
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea39d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea39d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fl9nK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2lD5F"));

});
parcelRegister("2lD5F", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1b5bdd7a69f0dbc1$export$ffb0004e005737fa, (v) => $1b5bdd7a69f0dbc1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1b5bdd7a69f0dbc1$export$34b9dba7ce09269b, (v) => $1b5bdd7a69f0dbc1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1b5bdd7a69f0dbc1$export$25062201e9e25d76, (v) => $1b5bdd7a69f0dbc1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1b5bdd7a69f0dbc1$export$ffb0004e005737fa;
var $1b5bdd7a69f0dbc1$export$34b9dba7ce09269b;
var $1b5bdd7a69f0dbc1$export$25062201e9e25d76;
'use strict';

var $bxRTa = parcelRequire("bxRTa");
var $1b5bdd7a69f0dbc1$var$k = Symbol.for("react.element"), $1b5bdd7a69f0dbc1$var$l = Symbol.for("react.fragment"), $1b5bdd7a69f0dbc1$var$m = Object.prototype.hasOwnProperty, $1b5bdd7a69f0dbc1$var$n = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1b5bdd7a69f0dbc1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1b5bdd7a69f0dbc1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1b5bdd7a69f0dbc1$var$m.call(a, b) && !$1b5bdd7a69f0dbc1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1b5bdd7a69f0dbc1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1b5bdd7a69f0dbc1$var$n.current
    };
}
$1b5bdd7a69f0dbc1$export$ffb0004e005737fa = $1b5bdd7a69f0dbc1$var$l;
$1b5bdd7a69f0dbc1$export$34b9dba7ce09269b = $1b5bdd7a69f0dbc1$var$q;
$1b5bdd7a69f0dbc1$export$25062201e9e25d76 = $1b5bdd7a69f0dbc1$var$q;

});
parcelRegister("bxRTa", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2O5Ek"));

});
parcelRegister("2O5Ek", function(module, exports) {

$parcel$export(module.exports, "Children", () => $20b4a222995d258f$export$dca3b0875bd9a954, (v) => $20b4a222995d258f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $20b4a222995d258f$export$16fa2f45be04daa8, (v) => $20b4a222995d258f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $20b4a222995d258f$export$ffb0004e005737fa, (v) => $20b4a222995d258f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $20b4a222995d258f$export$e2c29f18771995cb, (v) => $20b4a222995d258f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $20b4a222995d258f$export$221d75b3f55bb0bd, (v) => $20b4a222995d258f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $20b4a222995d258f$export$5f8d39834fd61797, (v) => $20b4a222995d258f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $20b4a222995d258f$export$74bf444e3cd11ea5, (v) => $20b4a222995d258f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $20b4a222995d258f$export$ae55be85d98224ed, (v) => $20b4a222995d258f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $20b4a222995d258f$export$3ba232387fd5d6dd, (v) => $20b4a222995d258f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $20b4a222995d258f$export$e530037191fcd5d7, (v) => $20b4a222995d258f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $20b4a222995d258f$export$fd42f52fd3ae1109, (v) => $20b4a222995d258f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $20b4a222995d258f$export$c8a8987d4410bf2d, (v) => $20b4a222995d258f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $20b4a222995d258f$export$d38cd72104c1f0e9, (v) => $20b4a222995d258f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $20b4a222995d258f$export$7d1e3a5e95ceca43, (v) => $20b4a222995d258f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $20b4a222995d258f$export$257a8862b851cb5b, (v) => $20b4a222995d258f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $20b4a222995d258f$export$a8257692ac88316c, (v) => $20b4a222995d258f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $20b4a222995d258f$export$488013bae63b21da, (v) => $20b4a222995d258f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $20b4a222995d258f$export$7c73462e0d25e514, (v) => $20b4a222995d258f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $20b4a222995d258f$export$7568632d0d33d16d, (v) => $20b4a222995d258f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $20b4a222995d258f$export$88948ce120ea2619, (v) => $20b4a222995d258f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $20b4a222995d258f$export$35808ee640e87ca7, (v) => $20b4a222995d258f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $20b4a222995d258f$export$fae74005e78b1a27, (v) => $20b4a222995d258f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $20b4a222995d258f$export$dc8fbce3eb94dc1e, (v) => $20b4a222995d258f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $20b4a222995d258f$export$6a7bc4e911dc01cf, (v) => $20b4a222995d258f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $20b4a222995d258f$export$6d9c69b0de29b591, (v) => $20b4a222995d258f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $20b4a222995d258f$export$f680877a34711e37, (v) => $20b4a222995d258f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $20b4a222995d258f$export$d5a552a76deda3c2, (v) => $20b4a222995d258f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $20b4a222995d258f$export$aaabe4eda9ed9969, (v) => $20b4a222995d258f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $20b4a222995d258f$export$e5c5a5f917a5871c, (v) => $20b4a222995d258f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $20b4a222995d258f$export$1538c33de8887b59, (v) => $20b4a222995d258f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $20b4a222995d258f$export$13e3392192263954, (v) => $20b4a222995d258f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $20b4a222995d258f$export$b8f5890fc79d6aca, (v) => $20b4a222995d258f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $20b4a222995d258f$export$60241385465d0a34, (v) => $20b4a222995d258f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $20b4a222995d258f$export$306c0aa65ff9ec16, (v) => $20b4a222995d258f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $20b4a222995d258f$export$7b286972b8d8ccbf, (v) => $20b4a222995d258f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $20b4a222995d258f$export$83d89fbfd8236492, (v) => $20b4a222995d258f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $20b4a222995d258f$export$dca3b0875bd9a954;
var $20b4a222995d258f$export$16fa2f45be04daa8;
var $20b4a222995d258f$export$ffb0004e005737fa;
var $20b4a222995d258f$export$e2c29f18771995cb;
var $20b4a222995d258f$export$221d75b3f55bb0bd;
var $20b4a222995d258f$export$5f8d39834fd61797;
var $20b4a222995d258f$export$74bf444e3cd11ea5;
var $20b4a222995d258f$export$ae55be85d98224ed;
var $20b4a222995d258f$export$3ba232387fd5d6dd;
var $20b4a222995d258f$export$e530037191fcd5d7;
var $20b4a222995d258f$export$fd42f52fd3ae1109;
var $20b4a222995d258f$export$c8a8987d4410bf2d;
var $20b4a222995d258f$export$d38cd72104c1f0e9;
var $20b4a222995d258f$export$7d1e3a5e95ceca43;
var $20b4a222995d258f$export$257a8862b851cb5b;
var $20b4a222995d258f$export$a8257692ac88316c;
var $20b4a222995d258f$export$488013bae63b21da;
var $20b4a222995d258f$export$7c73462e0d25e514;
var $20b4a222995d258f$export$7568632d0d33d16d;
var $20b4a222995d258f$export$88948ce120ea2619;
var $20b4a222995d258f$export$35808ee640e87ca7;
var $20b4a222995d258f$export$fae74005e78b1a27;
var $20b4a222995d258f$export$dc8fbce3eb94dc1e;
var $20b4a222995d258f$export$6a7bc4e911dc01cf;
var $20b4a222995d258f$export$6d9c69b0de29b591;
var $20b4a222995d258f$export$f680877a34711e37;
var $20b4a222995d258f$export$d5a552a76deda3c2;
var $20b4a222995d258f$export$aaabe4eda9ed9969;
var $20b4a222995d258f$export$e5c5a5f917a5871c;
var $20b4a222995d258f$export$1538c33de8887b59;
var $20b4a222995d258f$export$13e3392192263954;
var $20b4a222995d258f$export$b8f5890fc79d6aca;
var $20b4a222995d258f$export$60241385465d0a34;
var $20b4a222995d258f$export$306c0aa65ff9ec16;
var $20b4a222995d258f$export$7b286972b8d8ccbf;
var $20b4a222995d258f$export$83d89fbfd8236492;
'use strict';
var $20b4a222995d258f$var$l = Symbol.for("react.element"), $20b4a222995d258f$var$n = Symbol.for("react.portal"), $20b4a222995d258f$var$p = Symbol.for("react.fragment"), $20b4a222995d258f$var$q = Symbol.for("react.strict_mode"), $20b4a222995d258f$var$r = Symbol.for("react.profiler"), $20b4a222995d258f$var$t = Symbol.for("react.provider"), $20b4a222995d258f$var$u = Symbol.for("react.context"), $20b4a222995d258f$var$v = Symbol.for("react.forward_ref"), $20b4a222995d258f$var$w = Symbol.for("react.suspense"), $20b4a222995d258f$var$x = Symbol.for("react.memo"), $20b4a222995d258f$var$y = Symbol.for("react.lazy"), $20b4a222995d258f$var$z = Symbol.iterator;
function $20b4a222995d258f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $20b4a222995d258f$var$z && a[$20b4a222995d258f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $20b4a222995d258f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $20b4a222995d258f$var$C = Object.assign, $20b4a222995d258f$var$D = {};
function $20b4a222995d258f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $20b4a222995d258f$var$D;
    this.updater = e || $20b4a222995d258f$var$B;
}
$20b4a222995d258f$var$E.prototype.isReactComponent = {};
$20b4a222995d258f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$20b4a222995d258f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $20b4a222995d258f$var$F() {}
$20b4a222995d258f$var$F.prototype = $20b4a222995d258f$var$E.prototype;
function $20b4a222995d258f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $20b4a222995d258f$var$D;
    this.updater = e || $20b4a222995d258f$var$B;
}
var $20b4a222995d258f$var$H = $20b4a222995d258f$var$G.prototype = new $20b4a222995d258f$var$F;
$20b4a222995d258f$var$H.constructor = $20b4a222995d258f$var$G;
$20b4a222995d258f$var$C($20b4a222995d258f$var$H, $20b4a222995d258f$var$E.prototype);
$20b4a222995d258f$var$H.isPureReactComponent = !0;
var $20b4a222995d258f$var$I = Array.isArray, $20b4a222995d258f$var$J = Object.prototype.hasOwnProperty, $20b4a222995d258f$var$K = {
    current: null
}, $20b4a222995d258f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $20b4a222995d258f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$20b4a222995d258f$var$J.call(b, d) && !$20b4a222995d258f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $20b4a222995d258f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $20b4a222995d258f$var$K.current
    };
}
function $20b4a222995d258f$var$N(a, b) {
    return {
        $$typeof: $20b4a222995d258f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $20b4a222995d258f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $20b4a222995d258f$var$l;
}
function $20b4a222995d258f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $20b4a222995d258f$var$P = /\/+/g;
function $20b4a222995d258f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $20b4a222995d258f$var$escape("" + a.key) : b.toString(36);
}
function $20b4a222995d258f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $20b4a222995d258f$var$l:
                case $20b4a222995d258f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $20b4a222995d258f$var$Q(h, 0) : d, $20b4a222995d258f$var$I(c) ? (e = "", null != a && (e = a.replace($20b4a222995d258f$var$P, "$&/") + "/"), $20b4a222995d258f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($20b4a222995d258f$var$O(c) && (c = $20b4a222995d258f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($20b4a222995d258f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($20b4a222995d258f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $20b4a222995d258f$var$Q(k, g);
        h += $20b4a222995d258f$var$R(k, b, e, f, c);
    }
    else if (f = $20b4a222995d258f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $20b4a222995d258f$var$Q(k, g++), h += $20b4a222995d258f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $20b4a222995d258f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $20b4a222995d258f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $20b4a222995d258f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $20b4a222995d258f$var$U = {
    current: null
}, $20b4a222995d258f$var$V = {
    transition: null
}, $20b4a222995d258f$var$W = {
    ReactCurrentDispatcher: $20b4a222995d258f$var$U,
    ReactCurrentBatchConfig: $20b4a222995d258f$var$V,
    ReactCurrentOwner: $20b4a222995d258f$var$K
};
function $20b4a222995d258f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$20b4a222995d258f$export$dca3b0875bd9a954 = {
    map: $20b4a222995d258f$var$S,
    forEach: function(a, b, e) {
        $20b4a222995d258f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $20b4a222995d258f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $20b4a222995d258f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$20b4a222995d258f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$20b4a222995d258f$export$16fa2f45be04daa8 = $20b4a222995d258f$var$E;
$20b4a222995d258f$export$ffb0004e005737fa = $20b4a222995d258f$var$p;
$20b4a222995d258f$export$e2c29f18771995cb = $20b4a222995d258f$var$r;
$20b4a222995d258f$export$221d75b3f55bb0bd = $20b4a222995d258f$var$G;
$20b4a222995d258f$export$5f8d39834fd61797 = $20b4a222995d258f$var$q;
$20b4a222995d258f$export$74bf444e3cd11ea5 = $20b4a222995d258f$var$w;
$20b4a222995d258f$export$ae55be85d98224ed = $20b4a222995d258f$var$W;
$20b4a222995d258f$export$3ba232387fd5d6dd = $20b4a222995d258f$var$X;
$20b4a222995d258f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $20b4a222995d258f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $20b4a222995d258f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$20b4a222995d258f$var$J.call(b, f) && !$20b4a222995d258f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $20b4a222995d258f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$20b4a222995d258f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $20b4a222995d258f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $20b4a222995d258f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$20b4a222995d258f$export$c8a8987d4410bf2d = $20b4a222995d258f$var$M;
$20b4a222995d258f$export$d38cd72104c1f0e9 = function(a) {
    var b = $20b4a222995d258f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$20b4a222995d258f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$20b4a222995d258f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $20b4a222995d258f$var$v,
        render: a
    };
};
$20b4a222995d258f$export$a8257692ac88316c = $20b4a222995d258f$var$O;
$20b4a222995d258f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $20b4a222995d258f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $20b4a222995d258f$var$T
    };
};
$20b4a222995d258f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $20b4a222995d258f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$20b4a222995d258f$export$7568632d0d33d16d = function(a) {
    var b = $20b4a222995d258f$var$V.transition;
    $20b4a222995d258f$var$V.transition = {};
    try {
        a();
    } finally{
        $20b4a222995d258f$var$V.transition = b;
    }
};
$20b4a222995d258f$export$88948ce120ea2619 = $20b4a222995d258f$var$X;
$20b4a222995d258f$export$35808ee640e87ca7 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useCallback(a, b);
};
$20b4a222995d258f$export$fae74005e78b1a27 = function(a) {
    return $20b4a222995d258f$var$U.current.useContext(a);
};
$20b4a222995d258f$export$dc8fbce3eb94dc1e = function() {};
$20b4a222995d258f$export$6a7bc4e911dc01cf = function(a) {
    return $20b4a222995d258f$var$U.current.useDeferredValue(a);
};
$20b4a222995d258f$export$6d9c69b0de29b591 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useEffect(a, b);
};
$20b4a222995d258f$export$f680877a34711e37 = function() {
    return $20b4a222995d258f$var$U.current.useId();
};
$20b4a222995d258f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $20b4a222995d258f$var$U.current.useImperativeHandle(a, b, e);
};
$20b4a222995d258f$export$aaabe4eda9ed9969 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useInsertionEffect(a, b);
};
$20b4a222995d258f$export$e5c5a5f917a5871c = function(a, b) {
    return $20b4a222995d258f$var$U.current.useLayoutEffect(a, b);
};
$20b4a222995d258f$export$1538c33de8887b59 = function(a, b) {
    return $20b4a222995d258f$var$U.current.useMemo(a, b);
};
$20b4a222995d258f$export$13e3392192263954 = function(a, b, e) {
    return $20b4a222995d258f$var$U.current.useReducer(a, b, e);
};
$20b4a222995d258f$export$b8f5890fc79d6aca = function(a) {
    return $20b4a222995d258f$var$U.current.useRef(a);
};
$20b4a222995d258f$export$60241385465d0a34 = function(a) {
    return $20b4a222995d258f$var$U.current.useState(a);
};
$20b4a222995d258f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $20b4a222995d258f$var$U.current.useSyncExternalStore(a, b, e);
};
$20b4a222995d258f$export$7b286972b8d8ccbf = function() {
    return $20b4a222995d258f$var$U.current.useTransition();
};
$20b4a222995d258f$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("aRBoq", function(module, exports) {
'use strict';
function $7e8bdc0fcebcbe5b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e8bdc0fcebcbe5b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e8bdc0fcebcbe5b$var$checkDCE();

module.exports = (parcelRequire("RwUN7"));

});
parcelRegister("RwUN7", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0a0e7b9537100374$export$ae55be85d98224ed, (v) => $0a0e7b9537100374$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0a0e7b9537100374$export$d39a5bbd09211389, (v) => $0a0e7b9537100374$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0a0e7b9537100374$export$882461b6382ed46c, (v) => $0a0e7b9537100374$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0a0e7b9537100374$export$466bfc07425424d5, (v) => $0a0e7b9537100374$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0a0e7b9537100374$export$cd75ccfd720a3cd4, (v) => $0a0e7b9537100374$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0a0e7b9537100374$export$fa8d919ba61d84db, (v) => $0a0e7b9537100374$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0a0e7b9537100374$export$757ceba2d55c277e, (v) => $0a0e7b9537100374$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0a0e7b9537100374$export$b3890eb0ae9dca99, (v) => $0a0e7b9537100374$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0a0e7b9537100374$export$502457920280e6be, (v) => $0a0e7b9537100374$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0a0e7b9537100374$export$c78a37762a8d58e1, (v) => $0a0e7b9537100374$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0a0e7b9537100374$export$dc54d992c10e8a18, (v) => $0a0e7b9537100374$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0a0e7b9537100374$export$83d89fbfd8236492, (v) => $0a0e7b9537100374$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0a0e7b9537100374$export$ae55be85d98224ed;
var $0a0e7b9537100374$export$d39a5bbd09211389;
var $0a0e7b9537100374$export$882461b6382ed46c;
var $0a0e7b9537100374$export$466bfc07425424d5;
var $0a0e7b9537100374$export$cd75ccfd720a3cd4;
var $0a0e7b9537100374$export$fa8d919ba61d84db;
var $0a0e7b9537100374$export$757ceba2d55c277e;
var $0a0e7b9537100374$export$b3890eb0ae9dca99;
var $0a0e7b9537100374$export$502457920280e6be;
var $0a0e7b9537100374$export$c78a37762a8d58e1;
var $0a0e7b9537100374$export$dc54d992c10e8a18;
var $0a0e7b9537100374$export$83d89fbfd8236492;
'use strict';

var $bxRTa = parcelRequire("bxRTa");

var $9rFeI = parcelRequire("9rFeI");
function $0a0e7b9537100374$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0a0e7b9537100374$var$da = new Set, $0a0e7b9537100374$var$ea = {};
function $0a0e7b9537100374$var$fa(a, b) {
    $0a0e7b9537100374$var$ha(a, b);
    $0a0e7b9537100374$var$ha(a + "Capture", b);
}
function $0a0e7b9537100374$var$ha(a, b) {
    $0a0e7b9537100374$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0a0e7b9537100374$var$da.add(b[a]);
}
var $0a0e7b9537100374$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0a0e7b9537100374$var$ja = Object.prototype.hasOwnProperty, $0a0e7b9537100374$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0a0e7b9537100374$var$la = {}, $0a0e7b9537100374$var$ma = {};
function $0a0e7b9537100374$var$oa(a) {
    if ($0a0e7b9537100374$var$ja.call($0a0e7b9537100374$var$ma, a)) return !0;
    if ($0a0e7b9537100374$var$ja.call($0a0e7b9537100374$var$la, a)) return !1;
    if ($0a0e7b9537100374$var$ka.test(a)) return $0a0e7b9537100374$var$ma[a] = !0;
    $0a0e7b9537100374$var$la[a] = !0;
    return !1;
}
function $0a0e7b9537100374$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0a0e7b9537100374$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0a0e7b9537100374$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0a0e7b9537100374$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0a0e7b9537100374$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0a0e7b9537100374$var$ra = /[\-:]([a-z])/g;
function $0a0e7b9537100374$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0a0e7b9537100374$var$ra, $0a0e7b9537100374$var$sa);
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0a0e7b9537100374$var$ra, $0a0e7b9537100374$var$sa);
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0a0e7b9537100374$var$ra, $0a0e7b9537100374$var$sa);
    $0a0e7b9537100374$var$z[b] = new $0a0e7b9537100374$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0a0e7b9537100374$var$z.xlinkHref = new $0a0e7b9537100374$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0a0e7b9537100374$var$z[a] = new $0a0e7b9537100374$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0a0e7b9537100374$var$ta(a, b, c, d) {
    var e = $0a0e7b9537100374$var$z.hasOwnProperty(b) ? $0a0e7b9537100374$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0a0e7b9537100374$var$qa(b, c, e, d) && (c = null), d || null === e ? $0a0e7b9537100374$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0a0e7b9537100374$var$ua = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0a0e7b9537100374$var$va = Symbol.for("react.element"), $0a0e7b9537100374$var$wa = Symbol.for("react.portal"), $0a0e7b9537100374$var$ya = Symbol.for("react.fragment"), $0a0e7b9537100374$var$za = Symbol.for("react.strict_mode"), $0a0e7b9537100374$var$Aa = Symbol.for("react.profiler"), $0a0e7b9537100374$var$Ba = Symbol.for("react.provider"), $0a0e7b9537100374$var$Ca = Symbol.for("react.context"), $0a0e7b9537100374$var$Da = Symbol.for("react.forward_ref"), $0a0e7b9537100374$var$Ea = Symbol.for("react.suspense"), $0a0e7b9537100374$var$Fa = Symbol.for("react.suspense_list"), $0a0e7b9537100374$var$Ga = Symbol.for("react.memo"), $0a0e7b9537100374$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0a0e7b9537100374$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0a0e7b9537100374$var$Ja = Symbol.iterator;
function $0a0e7b9537100374$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0a0e7b9537100374$var$Ja && a[$0a0e7b9537100374$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0a0e7b9537100374$var$A = Object.assign, $0a0e7b9537100374$var$La;
function $0a0e7b9537100374$var$Ma(a) {
    if (void 0 === $0a0e7b9537100374$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0a0e7b9537100374$var$La = b && b[1] || "";
    }
    return "\n" + $0a0e7b9537100374$var$La + a;
}
var $0a0e7b9537100374$var$Na = !1;
function $0a0e7b9537100374$var$Oa(a, b) {
    if (!a || $0a0e7b9537100374$var$Na) return "";
    $0a0e7b9537100374$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0a0e7b9537100374$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0a0e7b9537100374$var$Ma(a) : "";
}
function $0a0e7b9537100374$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0a0e7b9537100374$var$Ma(a.type);
        case 16:
            return $0a0e7b9537100374$var$Ma("Lazy");
        case 13:
            return $0a0e7b9537100374$var$Ma("Suspense");
        case 19:
            return $0a0e7b9537100374$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0a0e7b9537100374$var$Oa(a.type, !1), a;
        case 11:
            return a = $0a0e7b9537100374$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0a0e7b9537100374$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0a0e7b9537100374$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0a0e7b9537100374$var$ya:
            return "Fragment";
        case $0a0e7b9537100374$var$wa:
            return "Portal";
        case $0a0e7b9537100374$var$Aa:
            return "Profiler";
        case $0a0e7b9537100374$var$za:
            return "StrictMode";
        case $0a0e7b9537100374$var$Ea:
            return "Suspense";
        case $0a0e7b9537100374$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0a0e7b9537100374$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0a0e7b9537100374$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0a0e7b9537100374$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0a0e7b9537100374$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0a0e7b9537100374$var$Qa(a.type) || "Memo";
        case $0a0e7b9537100374$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0a0e7b9537100374$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0a0e7b9537100374$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0a0e7b9537100374$var$Qa(b);
        case 8:
            return b === $0a0e7b9537100374$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0a0e7b9537100374$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0a0e7b9537100374$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0a0e7b9537100374$var$Ua(a) {
    var b = $0a0e7b9537100374$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0a0e7b9537100374$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0a0e7b9537100374$var$Ua(a));
}
function $0a0e7b9537100374$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0a0e7b9537100374$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0a0e7b9537100374$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0a0e7b9537100374$var$Ya(a, b) {
    var c = b.checked;
    return $0a0e7b9537100374$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0a0e7b9537100374$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0a0e7b9537100374$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0a0e7b9537100374$var$ab(a, b) {
    b = b.checked;
    null != b && $0a0e7b9537100374$var$ta(a, "checked", b, !1);
}
function $0a0e7b9537100374$var$bb(a, b) {
    $0a0e7b9537100374$var$ab(a, b);
    var c = $0a0e7b9537100374$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0a0e7b9537100374$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0a0e7b9537100374$var$cb(a, b.type, $0a0e7b9537100374$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0a0e7b9537100374$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0a0e7b9537100374$var$cb(a, b, c) {
    if ("number" !== b || $0a0e7b9537100374$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0a0e7b9537100374$var$eb = Array.isArray;
function $0a0e7b9537100374$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0a0e7b9537100374$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0a0e7b9537100374$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0a0e7b9537100374$var$p(91));
    return $0a0e7b9537100374$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0a0e7b9537100374$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0a0e7b9537100374$var$p(92));
            if ($0a0e7b9537100374$var$eb(c)) {
                if (1 < c.length) throw Error($0a0e7b9537100374$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0a0e7b9537100374$var$Sa(c)
    };
}
function $0a0e7b9537100374$var$ib(a, b) {
    var c = $0a0e7b9537100374$var$Sa(b.value), d = $0a0e7b9537100374$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0a0e7b9537100374$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0a0e7b9537100374$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0a0e7b9537100374$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0a0e7b9537100374$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0a0e7b9537100374$var$mb, $0a0e7b9537100374$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0a0e7b9537100374$var$mb = $0a0e7b9537100374$var$mb || document.createElement("div");
        $0a0e7b9537100374$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0a0e7b9537100374$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0a0e7b9537100374$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0a0e7b9537100374$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0a0e7b9537100374$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0a0e7b9537100374$var$pb).forEach(function(a) {
    $0a0e7b9537100374$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0a0e7b9537100374$var$pb[b] = $0a0e7b9537100374$var$pb[a];
    });
});
function $0a0e7b9537100374$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0a0e7b9537100374$var$pb.hasOwnProperty(a) && $0a0e7b9537100374$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0a0e7b9537100374$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0a0e7b9537100374$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0a0e7b9537100374$var$tb = $0a0e7b9537100374$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0a0e7b9537100374$var$ub(a, b) {
    if (b) {
        if ($0a0e7b9537100374$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0a0e7b9537100374$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0a0e7b9537100374$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0a0e7b9537100374$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0a0e7b9537100374$var$p(62));
    }
}
function $0a0e7b9537100374$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0a0e7b9537100374$var$wb = null;
function $0a0e7b9537100374$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0a0e7b9537100374$var$yb = null, $0a0e7b9537100374$var$zb = null, $0a0e7b9537100374$var$Ab = null;
function $0a0e7b9537100374$var$Bb(a) {
    if (a = $0a0e7b9537100374$var$Cb(a)) {
        if ("function" !== typeof $0a0e7b9537100374$var$yb) throw Error($0a0e7b9537100374$var$p(280));
        var b = a.stateNode;
        b && (b = $0a0e7b9537100374$var$Db(b), $0a0e7b9537100374$var$yb(a.stateNode, a.type, b));
    }
}
function $0a0e7b9537100374$var$Eb(a) {
    $0a0e7b9537100374$var$zb ? $0a0e7b9537100374$var$Ab ? $0a0e7b9537100374$var$Ab.push(a) : $0a0e7b9537100374$var$Ab = [
        a
    ] : $0a0e7b9537100374$var$zb = a;
}
function $0a0e7b9537100374$var$Fb() {
    if ($0a0e7b9537100374$var$zb) {
        var a = $0a0e7b9537100374$var$zb, b = $0a0e7b9537100374$var$Ab;
        $0a0e7b9537100374$var$Ab = $0a0e7b9537100374$var$zb = null;
        $0a0e7b9537100374$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0a0e7b9537100374$var$Bb(b[a]);
    }
}
function $0a0e7b9537100374$var$Gb(a, b) {
    return a(b);
}
function $0a0e7b9537100374$var$Hb() {}
var $0a0e7b9537100374$var$Ib = !1;
function $0a0e7b9537100374$var$Jb(a, b, c) {
    if ($0a0e7b9537100374$var$Ib) return a(b, c);
    $0a0e7b9537100374$var$Ib = !0;
    try {
        return $0a0e7b9537100374$var$Gb(a, b, c);
    } finally{
        if ($0a0e7b9537100374$var$Ib = !1, null !== $0a0e7b9537100374$var$zb || null !== $0a0e7b9537100374$var$Ab) $0a0e7b9537100374$var$Hb(), $0a0e7b9537100374$var$Fb();
    }
}
function $0a0e7b9537100374$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0a0e7b9537100374$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0a0e7b9537100374$var$p(231, b, typeof c));
    return c;
}
var $0a0e7b9537100374$var$Lb = !1;
if ($0a0e7b9537100374$var$ia) try {
    var $0a0e7b9537100374$var$Mb = {};
    Object.defineProperty($0a0e7b9537100374$var$Mb, "passive", {
        get: function() {
            $0a0e7b9537100374$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0a0e7b9537100374$var$Mb, $0a0e7b9537100374$var$Mb);
    window.removeEventListener("test", $0a0e7b9537100374$var$Mb, $0a0e7b9537100374$var$Mb);
} catch (a) {
    $0a0e7b9537100374$var$Lb = !1;
}
function $0a0e7b9537100374$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0a0e7b9537100374$var$Ob = !1, $0a0e7b9537100374$var$Pb = null, $0a0e7b9537100374$var$Qb = !1, $0a0e7b9537100374$var$Rb = null, $0a0e7b9537100374$var$Sb = {
    onError: function(a) {
        $0a0e7b9537100374$var$Ob = !0;
        $0a0e7b9537100374$var$Pb = a;
    }
};
function $0a0e7b9537100374$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0a0e7b9537100374$var$Ob = !1;
    $0a0e7b9537100374$var$Pb = null;
    $0a0e7b9537100374$var$Nb.apply($0a0e7b9537100374$var$Sb, arguments);
}
function $0a0e7b9537100374$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0a0e7b9537100374$var$Tb.apply(this, arguments);
    if ($0a0e7b9537100374$var$Ob) {
        if ($0a0e7b9537100374$var$Ob) {
            var l = $0a0e7b9537100374$var$Pb;
            $0a0e7b9537100374$var$Ob = !1;
            $0a0e7b9537100374$var$Pb = null;
        } else throw Error($0a0e7b9537100374$var$p(198));
        $0a0e7b9537100374$var$Qb || ($0a0e7b9537100374$var$Qb = !0, $0a0e7b9537100374$var$Rb = l);
    }
}
function $0a0e7b9537100374$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0a0e7b9537100374$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0a0e7b9537100374$var$Xb(a) {
    if ($0a0e7b9537100374$var$Vb(a) !== a) throw Error($0a0e7b9537100374$var$p(188));
}
function $0a0e7b9537100374$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0a0e7b9537100374$var$Vb(a);
        if (null === b) throw Error($0a0e7b9537100374$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0a0e7b9537100374$var$Xb(e), a;
                if (f === d) return $0a0e7b9537100374$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0a0e7b9537100374$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0a0e7b9537100374$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0a0e7b9537100374$var$p(190));
    }
    if (3 !== c.tag) throw Error($0a0e7b9537100374$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0a0e7b9537100374$var$Zb(a) {
    a = $0a0e7b9537100374$var$Yb(a);
    return null !== a ? $0a0e7b9537100374$var$$b(a) : null;
}
function $0a0e7b9537100374$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0a0e7b9537100374$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0a0e7b9537100374$var$ac = $9rFeI.unstable_scheduleCallback, $0a0e7b9537100374$var$bc = $9rFeI.unstable_cancelCallback, $0a0e7b9537100374$var$cc = $9rFeI.unstable_shouldYield, $0a0e7b9537100374$var$dc = $9rFeI.unstable_requestPaint, $0a0e7b9537100374$var$B = $9rFeI.unstable_now, $0a0e7b9537100374$var$ec = $9rFeI.unstable_getCurrentPriorityLevel, $0a0e7b9537100374$var$fc = $9rFeI.unstable_ImmediatePriority, $0a0e7b9537100374$var$gc = $9rFeI.unstable_UserBlockingPriority, $0a0e7b9537100374$var$hc = $9rFeI.unstable_NormalPriority, $0a0e7b9537100374$var$ic = $9rFeI.unstable_LowPriority, $0a0e7b9537100374$var$jc = $9rFeI.unstable_IdlePriority, $0a0e7b9537100374$var$kc = null, $0a0e7b9537100374$var$lc = null;
function $0a0e7b9537100374$var$mc(a) {
    if ($0a0e7b9537100374$var$lc && "function" === typeof $0a0e7b9537100374$var$lc.onCommitFiberRoot) try {
        $0a0e7b9537100374$var$lc.onCommitFiberRoot($0a0e7b9537100374$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0a0e7b9537100374$var$oc = Math.clz32 ? Math.clz32 : $0a0e7b9537100374$var$nc, $0a0e7b9537100374$var$pc = Math.log, $0a0e7b9537100374$var$qc = Math.LN2;
function $0a0e7b9537100374$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0a0e7b9537100374$var$pc(a) / $0a0e7b9537100374$var$qc | 0) | 0;
}
var $0a0e7b9537100374$var$rc = 64, $0a0e7b9537100374$var$sc = 4194304;
function $0a0e7b9537100374$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0a0e7b9537100374$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0a0e7b9537100374$var$tc(h) : (f &= g, 0 !== f && (d = $0a0e7b9537100374$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0a0e7b9537100374$var$tc(g) : 0 !== f && (d = $0a0e7b9537100374$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0a0e7b9537100374$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0a0e7b9537100374$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0a0e7b9537100374$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0a0e7b9537100374$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0a0e7b9537100374$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0a0e7b9537100374$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0a0e7b9537100374$var$yc() {
    var a = $0a0e7b9537100374$var$rc;
    $0a0e7b9537100374$var$rc <<= 1;
    0 === ($0a0e7b9537100374$var$rc & 4194240) && ($0a0e7b9537100374$var$rc = 64);
    return a;
}
function $0a0e7b9537100374$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0a0e7b9537100374$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0a0e7b9537100374$var$oc(b);
    a[b] = c;
}
function $0a0e7b9537100374$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0a0e7b9537100374$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0a0e7b9537100374$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0a0e7b9537100374$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0a0e7b9537100374$var$C = 0;
function $0a0e7b9537100374$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0a0e7b9537100374$var$Ec, $0a0e7b9537100374$var$Fc, $0a0e7b9537100374$var$Gc, $0a0e7b9537100374$var$Hc, $0a0e7b9537100374$var$Ic, $0a0e7b9537100374$var$Jc = !1, $0a0e7b9537100374$var$Kc = [], $0a0e7b9537100374$var$Lc = null, $0a0e7b9537100374$var$Mc = null, $0a0e7b9537100374$var$Nc = null, $0a0e7b9537100374$var$Oc = new Map, $0a0e7b9537100374$var$Pc = new Map, $0a0e7b9537100374$var$Qc = [], $0a0e7b9537100374$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0a0e7b9537100374$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0a0e7b9537100374$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0a0e7b9537100374$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0a0e7b9537100374$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0a0e7b9537100374$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0a0e7b9537100374$var$Pc.delete(b.pointerId);
    }
}
function $0a0e7b9537100374$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0a0e7b9537100374$var$Cb(b), null !== b && $0a0e7b9537100374$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0a0e7b9537100374$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0a0e7b9537100374$var$Lc = $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0a0e7b9537100374$var$Mc = $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0a0e7b9537100374$var$Nc = $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0a0e7b9537100374$var$Oc.set(f, $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0a0e7b9537100374$var$Pc.set(f, $0a0e7b9537100374$var$Tc($0a0e7b9537100374$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0a0e7b9537100374$var$Vc(a) {
    var b = $0a0e7b9537100374$var$Wc(a.target);
    if (null !== b) {
        var c = $0a0e7b9537100374$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0a0e7b9537100374$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0a0e7b9537100374$var$Ic(a.priority, function() {
                        $0a0e7b9537100374$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0a0e7b9537100374$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0a0e7b9537100374$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0a0e7b9537100374$var$wb = d;
            c.target.dispatchEvent(d);
            $0a0e7b9537100374$var$wb = null;
        } else return b = $0a0e7b9537100374$var$Cb(c), null !== b && $0a0e7b9537100374$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0a0e7b9537100374$var$Zc(a, b, c) {
    $0a0e7b9537100374$var$Xc(a) && c.delete(b);
}
function $0a0e7b9537100374$var$$c() {
    $0a0e7b9537100374$var$Jc = !1;
    null !== $0a0e7b9537100374$var$Lc && $0a0e7b9537100374$var$Xc($0a0e7b9537100374$var$Lc) && ($0a0e7b9537100374$var$Lc = null);
    null !== $0a0e7b9537100374$var$Mc && $0a0e7b9537100374$var$Xc($0a0e7b9537100374$var$Mc) && ($0a0e7b9537100374$var$Mc = null);
    null !== $0a0e7b9537100374$var$Nc && $0a0e7b9537100374$var$Xc($0a0e7b9537100374$var$Nc) && ($0a0e7b9537100374$var$Nc = null);
    $0a0e7b9537100374$var$Oc.forEach($0a0e7b9537100374$var$Zc);
    $0a0e7b9537100374$var$Pc.forEach($0a0e7b9537100374$var$Zc);
}
function $0a0e7b9537100374$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0a0e7b9537100374$var$Jc || ($0a0e7b9537100374$var$Jc = !0, $9rFeI.unstable_scheduleCallback($9rFeI.unstable_NormalPriority, $0a0e7b9537100374$var$$c)));
}
function $0a0e7b9537100374$var$bd(a) {
    function b(b) {
        return $0a0e7b9537100374$var$ad(b, a);
    }
    if (0 < $0a0e7b9537100374$var$Kc.length) {
        $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Kc[0], a);
        for(var c = 1; c < $0a0e7b9537100374$var$Kc.length; c++){
            var d = $0a0e7b9537100374$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0a0e7b9537100374$var$Lc && $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Lc, a);
    null !== $0a0e7b9537100374$var$Mc && $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Mc, a);
    null !== $0a0e7b9537100374$var$Nc && $0a0e7b9537100374$var$ad($0a0e7b9537100374$var$Nc, a);
    $0a0e7b9537100374$var$Oc.forEach(b);
    $0a0e7b9537100374$var$Pc.forEach(b);
    for(c = 0; c < $0a0e7b9537100374$var$Qc.length; c++)d = $0a0e7b9537100374$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0a0e7b9537100374$var$Qc.length && (c = $0a0e7b9537100374$var$Qc[0], null === c.blockedOn);)$0a0e7b9537100374$var$Vc(c), null === c.blockedOn && $0a0e7b9537100374$var$Qc.shift();
}
var $0a0e7b9537100374$var$cd = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig, $0a0e7b9537100374$var$dd = !0;
function $0a0e7b9537100374$var$ed(a, b, c, d) {
    var e = $0a0e7b9537100374$var$C, f = $0a0e7b9537100374$var$cd.transition;
    $0a0e7b9537100374$var$cd.transition = null;
    try {
        $0a0e7b9537100374$var$C = 1, $0a0e7b9537100374$var$fd(a, b, c, d);
    } finally{
        $0a0e7b9537100374$var$C = e, $0a0e7b9537100374$var$cd.transition = f;
    }
}
function $0a0e7b9537100374$var$gd(a, b, c, d) {
    var e = $0a0e7b9537100374$var$C, f = $0a0e7b9537100374$var$cd.transition;
    $0a0e7b9537100374$var$cd.transition = null;
    try {
        $0a0e7b9537100374$var$C = 4, $0a0e7b9537100374$var$fd(a, b, c, d);
    } finally{
        $0a0e7b9537100374$var$C = e, $0a0e7b9537100374$var$cd.transition = f;
    }
}
function $0a0e7b9537100374$var$fd(a, b, c, d) {
    if ($0a0e7b9537100374$var$dd) {
        var e = $0a0e7b9537100374$var$Yc(a, b, c, d);
        if (null === e) $0a0e7b9537100374$var$hd(a, b, d, $0a0e7b9537100374$var$id, c), $0a0e7b9537100374$var$Sc(a, d);
        else if ($0a0e7b9537100374$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0a0e7b9537100374$var$Sc(a, d), b & 4 && -1 < $0a0e7b9537100374$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0a0e7b9537100374$var$Cb(e);
                null !== f && $0a0e7b9537100374$var$Ec(f);
                f = $0a0e7b9537100374$var$Yc(a, b, c, d);
                null === f && $0a0e7b9537100374$var$hd(a, b, d, $0a0e7b9537100374$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0a0e7b9537100374$var$hd(a, b, d, null, c);
    }
}
var $0a0e7b9537100374$var$id = null;
function $0a0e7b9537100374$var$Yc(a, b, c, d) {
    $0a0e7b9537100374$var$id = null;
    a = $0a0e7b9537100374$var$xb(d);
    a = $0a0e7b9537100374$var$Wc(a);
    if (null !== a) {
        if (b = $0a0e7b9537100374$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0a0e7b9537100374$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0a0e7b9537100374$var$id = a;
    return null;
}
function $0a0e7b9537100374$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0a0e7b9537100374$var$ec()){
                case $0a0e7b9537100374$var$fc:
                    return 1;
                case $0a0e7b9537100374$var$gc:
                    return 4;
                case $0a0e7b9537100374$var$hc:
                case $0a0e7b9537100374$var$ic:
                    return 16;
                case $0a0e7b9537100374$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0a0e7b9537100374$var$kd = null, $0a0e7b9537100374$var$ld = null, $0a0e7b9537100374$var$md = null;
function $0a0e7b9537100374$var$nd() {
    if ($0a0e7b9537100374$var$md) return $0a0e7b9537100374$var$md;
    var a, b = $0a0e7b9537100374$var$ld, c = b.length, d, e = "value" in $0a0e7b9537100374$var$kd ? $0a0e7b9537100374$var$kd.value : $0a0e7b9537100374$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0a0e7b9537100374$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0a0e7b9537100374$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0a0e7b9537100374$var$pd() {
    return !0;
}
function $0a0e7b9537100374$var$qd() {
    return !1;
}
function $0a0e7b9537100374$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0a0e7b9537100374$var$pd : $0a0e7b9537100374$var$qd;
        this.isPropagationStopped = $0a0e7b9537100374$var$qd;
        return this;
    }
    $0a0e7b9537100374$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0a0e7b9537100374$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0a0e7b9537100374$var$pd);
        },
        persist: function() {},
        isPersistent: $0a0e7b9537100374$var$pd
    });
    return b;
}
var $0a0e7b9537100374$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0a0e7b9537100374$var$td = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$sd), $0a0e7b9537100374$var$ud = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    view: 0,
    detail: 0
}), $0a0e7b9537100374$var$vd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$ud), $0a0e7b9537100374$var$wd, $0a0e7b9537100374$var$xd, $0a0e7b9537100374$var$yd, $0a0e7b9537100374$var$Ad = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0a0e7b9537100374$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0a0e7b9537100374$var$yd && ($0a0e7b9537100374$var$yd && "mousemove" === a.type ? ($0a0e7b9537100374$var$wd = a.screenX - $0a0e7b9537100374$var$yd.screenX, $0a0e7b9537100374$var$xd = a.screenY - $0a0e7b9537100374$var$yd.screenY) : $0a0e7b9537100374$var$xd = $0a0e7b9537100374$var$wd = 0, $0a0e7b9537100374$var$yd = a);
        return $0a0e7b9537100374$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0a0e7b9537100374$var$xd;
    }
}), $0a0e7b9537100374$var$Bd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Ad), $0a0e7b9537100374$var$Cd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$Ad, {
    dataTransfer: 0
}), $0a0e7b9537100374$var$Dd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Cd), $0a0e7b9537100374$var$Ed = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    relatedTarget: 0
}), $0a0e7b9537100374$var$Fd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Ed), $0a0e7b9537100374$var$Gd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0a0e7b9537100374$var$Hd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Gd), $0a0e7b9537100374$var$Id = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0a0e7b9537100374$var$Jd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Id), $0a0e7b9537100374$var$Kd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    data: 0
}), $0a0e7b9537100374$var$Ld = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Kd), $0a0e7b9537100374$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0a0e7b9537100374$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0a0e7b9537100374$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0a0e7b9537100374$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0a0e7b9537100374$var$Od[a]) ? !!b[a] : !1;
}
function $0a0e7b9537100374$var$zd() {
    return $0a0e7b9537100374$var$Pd;
}
var $0a0e7b9537100374$var$Qd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0a0e7b9537100374$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0a0e7b9537100374$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0a0e7b9537100374$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0a0e7b9537100374$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0a0e7b9537100374$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0a0e7b9537100374$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0a0e7b9537100374$var$Rd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Qd), $0a0e7b9537100374$var$Sd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0a0e7b9537100374$var$Td = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Sd), $0a0e7b9537100374$var$Ud = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0a0e7b9537100374$var$zd
}), $0a0e7b9537100374$var$Vd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Ud), $0a0e7b9537100374$var$Wd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0a0e7b9537100374$var$Xd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Wd), $0a0e7b9537100374$var$Yd = $0a0e7b9537100374$var$A({}, $0a0e7b9537100374$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0a0e7b9537100374$var$Zd = $0a0e7b9537100374$var$rd($0a0e7b9537100374$var$Yd), $0a0e7b9537100374$var$$d = [
    9,
    13,
    27,
    32
], $0a0e7b9537100374$var$ae = $0a0e7b9537100374$var$ia && "CompositionEvent" in window, $0a0e7b9537100374$var$be = null;
$0a0e7b9537100374$var$ia && "documentMode" in document && ($0a0e7b9537100374$var$be = document.documentMode);
var $0a0e7b9537100374$var$ce = $0a0e7b9537100374$var$ia && "TextEvent" in window && !$0a0e7b9537100374$var$be, $0a0e7b9537100374$var$de = $0a0e7b9537100374$var$ia && (!$0a0e7b9537100374$var$ae || $0a0e7b9537100374$var$be && 8 < $0a0e7b9537100374$var$be && 11 >= $0a0e7b9537100374$var$be), $0a0e7b9537100374$var$ee = String.fromCharCode(32), $0a0e7b9537100374$var$fe = !1;
function $0a0e7b9537100374$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0a0e7b9537100374$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0a0e7b9537100374$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0a0e7b9537100374$var$ie = !1;
function $0a0e7b9537100374$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0a0e7b9537100374$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0a0e7b9537100374$var$fe = !0;
            return $0a0e7b9537100374$var$ee;
        case "textInput":
            return a = b.data, a === $0a0e7b9537100374$var$ee && $0a0e7b9537100374$var$fe ? null : a;
        default:
            return null;
    }
}
function $0a0e7b9537100374$var$ke(a, b) {
    if ($0a0e7b9537100374$var$ie) return "compositionend" === a || !$0a0e7b9537100374$var$ae && $0a0e7b9537100374$var$ge(a, b) ? (a = $0a0e7b9537100374$var$nd(), $0a0e7b9537100374$var$md = $0a0e7b9537100374$var$ld = $0a0e7b9537100374$var$kd = null, $0a0e7b9537100374$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0a0e7b9537100374$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0a0e7b9537100374$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0a0e7b9537100374$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0a0e7b9537100374$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0a0e7b9537100374$var$ne(a, b, c, d) {
    $0a0e7b9537100374$var$Eb(d);
    b = $0a0e7b9537100374$var$oe(b, "onChange");
    0 < b.length && (c = new $0a0e7b9537100374$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0a0e7b9537100374$var$pe = null, $0a0e7b9537100374$var$qe = null;
function $0a0e7b9537100374$var$re(a) {
    $0a0e7b9537100374$var$se(a, 0);
}
function $0a0e7b9537100374$var$te(a) {
    var b = $0a0e7b9537100374$var$ue(a);
    if ($0a0e7b9537100374$var$Wa(b)) return a;
}
function $0a0e7b9537100374$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0a0e7b9537100374$var$we = !1;
if ($0a0e7b9537100374$var$ia) {
    var $0a0e7b9537100374$var$xe;
    if ($0a0e7b9537100374$var$ia) {
        var $0a0e7b9537100374$var$ye = "oninput" in document;
        if (!$0a0e7b9537100374$var$ye) {
            var $0a0e7b9537100374$var$ze = document.createElement("div");
            $0a0e7b9537100374$var$ze.setAttribute("oninput", "return;");
            $0a0e7b9537100374$var$ye = "function" === typeof $0a0e7b9537100374$var$ze.oninput;
        }
        $0a0e7b9537100374$var$xe = $0a0e7b9537100374$var$ye;
    } else $0a0e7b9537100374$var$xe = !1;
    $0a0e7b9537100374$var$we = $0a0e7b9537100374$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0a0e7b9537100374$var$Ae() {
    $0a0e7b9537100374$var$pe && ($0a0e7b9537100374$var$pe.detachEvent("onpropertychange", $0a0e7b9537100374$var$Be), $0a0e7b9537100374$var$qe = $0a0e7b9537100374$var$pe = null);
}
function $0a0e7b9537100374$var$Be(a) {
    if ("value" === a.propertyName && $0a0e7b9537100374$var$te($0a0e7b9537100374$var$qe)) {
        var b = [];
        $0a0e7b9537100374$var$ne(b, $0a0e7b9537100374$var$qe, a, $0a0e7b9537100374$var$xb(a));
        $0a0e7b9537100374$var$Jb($0a0e7b9537100374$var$re, b);
    }
}
function $0a0e7b9537100374$var$Ce(a, b, c) {
    "focusin" === a ? ($0a0e7b9537100374$var$Ae(), $0a0e7b9537100374$var$pe = b, $0a0e7b9537100374$var$qe = c, $0a0e7b9537100374$var$pe.attachEvent("onpropertychange", $0a0e7b9537100374$var$Be)) : "focusout" === a && $0a0e7b9537100374$var$Ae();
}
function $0a0e7b9537100374$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0a0e7b9537100374$var$te($0a0e7b9537100374$var$qe);
}
function $0a0e7b9537100374$var$Ee(a, b) {
    if ("click" === a) return $0a0e7b9537100374$var$te(b);
}
function $0a0e7b9537100374$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0a0e7b9537100374$var$te(b);
}
function $0a0e7b9537100374$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0a0e7b9537100374$var$He = "function" === typeof Object.is ? Object.is : $0a0e7b9537100374$var$Ge;
function $0a0e7b9537100374$var$Ie(a, b) {
    if ($0a0e7b9537100374$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0a0e7b9537100374$var$ja.call(b, e) || !$0a0e7b9537100374$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0a0e7b9537100374$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0a0e7b9537100374$var$Ke(a, b) {
    var c = $0a0e7b9537100374$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0a0e7b9537100374$var$Je(c);
    }
}
function $0a0e7b9537100374$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0a0e7b9537100374$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0a0e7b9537100374$var$Me() {
    for(var a = window, b = $0a0e7b9537100374$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0a0e7b9537100374$var$Xa(a.document);
    }
    return b;
}
function $0a0e7b9537100374$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0a0e7b9537100374$var$Oe(a) {
    var b = $0a0e7b9537100374$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0a0e7b9537100374$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0a0e7b9537100374$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0a0e7b9537100374$var$Ke(c, f);
                var g = $0a0e7b9537100374$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0a0e7b9537100374$var$Pe = $0a0e7b9537100374$var$ia && "documentMode" in document && 11 >= document.documentMode, $0a0e7b9537100374$var$Qe = null, $0a0e7b9537100374$var$Re = null, $0a0e7b9537100374$var$Se = null, $0a0e7b9537100374$var$Te = !1;
function $0a0e7b9537100374$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0a0e7b9537100374$var$Te || null == $0a0e7b9537100374$var$Qe || $0a0e7b9537100374$var$Qe !== $0a0e7b9537100374$var$Xa(d) || (d = $0a0e7b9537100374$var$Qe, "selectionStart" in d && $0a0e7b9537100374$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0a0e7b9537100374$var$Se && $0a0e7b9537100374$var$Ie($0a0e7b9537100374$var$Se, d) || ($0a0e7b9537100374$var$Se = d, d = $0a0e7b9537100374$var$oe($0a0e7b9537100374$var$Re, "onSelect"), 0 < d.length && (b = new $0a0e7b9537100374$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0a0e7b9537100374$var$Qe)));
}
function $0a0e7b9537100374$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0a0e7b9537100374$var$We = {
    animationend: $0a0e7b9537100374$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0a0e7b9537100374$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0a0e7b9537100374$var$Ve("Animation", "AnimationStart"),
    transitionend: $0a0e7b9537100374$var$Ve("Transition", "TransitionEnd")
}, $0a0e7b9537100374$var$Xe = {}, $0a0e7b9537100374$var$Ye = {};
$0a0e7b9537100374$var$ia && ($0a0e7b9537100374$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0a0e7b9537100374$var$We.animationend.animation, delete $0a0e7b9537100374$var$We.animationiteration.animation, delete $0a0e7b9537100374$var$We.animationstart.animation), "TransitionEvent" in window || delete $0a0e7b9537100374$var$We.transitionend.transition);
function $0a0e7b9537100374$var$Ze(a) {
    if ($0a0e7b9537100374$var$Xe[a]) return $0a0e7b9537100374$var$Xe[a];
    if (!$0a0e7b9537100374$var$We[a]) return a;
    var b = $0a0e7b9537100374$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0a0e7b9537100374$var$Ye) return $0a0e7b9537100374$var$Xe[a] = b[c];
    return a;
}
var $0a0e7b9537100374$var$$e = $0a0e7b9537100374$var$Ze("animationend"), $0a0e7b9537100374$var$af = $0a0e7b9537100374$var$Ze("animationiteration"), $0a0e7b9537100374$var$bf = $0a0e7b9537100374$var$Ze("animationstart"), $0a0e7b9537100374$var$cf = $0a0e7b9537100374$var$Ze("transitionend"), $0a0e7b9537100374$var$df = new Map, $0a0e7b9537100374$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0a0e7b9537100374$var$ff(a, b) {
    $0a0e7b9537100374$var$df.set(a, b);
    $0a0e7b9537100374$var$fa(b, [
        a
    ]);
}
for(var $0a0e7b9537100374$var$gf = 0; $0a0e7b9537100374$var$gf < $0a0e7b9537100374$var$ef.length; $0a0e7b9537100374$var$gf++){
    var $0a0e7b9537100374$var$hf = $0a0e7b9537100374$var$ef[$0a0e7b9537100374$var$gf], $0a0e7b9537100374$var$jf = $0a0e7b9537100374$var$hf.toLowerCase(), $0a0e7b9537100374$var$kf = $0a0e7b9537100374$var$hf[0].toUpperCase() + $0a0e7b9537100374$var$hf.slice(1);
    $0a0e7b9537100374$var$ff($0a0e7b9537100374$var$jf, "on" + $0a0e7b9537100374$var$kf);
}
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$$e, "onAnimationEnd");
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$af, "onAnimationIteration");
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$bf, "onAnimationStart");
$0a0e7b9537100374$var$ff("dblclick", "onDoubleClick");
$0a0e7b9537100374$var$ff("focusin", "onFocus");
$0a0e7b9537100374$var$ff("focusout", "onBlur");
$0a0e7b9537100374$var$ff($0a0e7b9537100374$var$cf, "onTransitionEnd");
$0a0e7b9537100374$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0a0e7b9537100374$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0a0e7b9537100374$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0a0e7b9537100374$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0a0e7b9537100374$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0a0e7b9537100374$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0a0e7b9537100374$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0a0e7b9537100374$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0a0e7b9537100374$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0a0e7b9537100374$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0a0e7b9537100374$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0a0e7b9537100374$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0a0e7b9537100374$var$lf));
function $0a0e7b9537100374$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0a0e7b9537100374$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0a0e7b9537100374$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0a0e7b9537100374$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0a0e7b9537100374$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0a0e7b9537100374$var$Qb) throw a = $0a0e7b9537100374$var$Rb, $0a0e7b9537100374$var$Qb = !1, $0a0e7b9537100374$var$Rb = null, a;
}
function $0a0e7b9537100374$var$D(a, b) {
    var c = b[$0a0e7b9537100374$var$of];
    void 0 === c && (c = b[$0a0e7b9537100374$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0a0e7b9537100374$var$pf(b, a, 2, !1), c.add(d));
}
function $0a0e7b9537100374$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0a0e7b9537100374$var$pf(c, a, d, b);
}
var $0a0e7b9537100374$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0a0e7b9537100374$var$sf(a) {
    if (!a[$0a0e7b9537100374$var$rf]) {
        a[$0a0e7b9537100374$var$rf] = !0;
        $0a0e7b9537100374$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0a0e7b9537100374$var$mf.has(b) || $0a0e7b9537100374$var$qf(b, !1, a), $0a0e7b9537100374$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0a0e7b9537100374$var$rf] || (b[$0a0e7b9537100374$var$rf] = !0, $0a0e7b9537100374$var$qf("selectionchange", !1, b));
    }
}
function $0a0e7b9537100374$var$pf(a, b, c, d) {
    switch($0a0e7b9537100374$var$jd(b)){
        case 1:
            var e = $0a0e7b9537100374$var$ed;
            break;
        case 4:
            e = $0a0e7b9537100374$var$gd;
            break;
        default:
            e = $0a0e7b9537100374$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0a0e7b9537100374$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0a0e7b9537100374$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0a0e7b9537100374$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0a0e7b9537100374$var$Jb(function() {
        var d = f, e = $0a0e7b9537100374$var$xb(c), g = [];
        a: {
            var h = $0a0e7b9537100374$var$df.get(a);
            if (void 0 !== h) {
                var k = $0a0e7b9537100374$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0a0e7b9537100374$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0a0e7b9537100374$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0a0e7b9537100374$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0a0e7b9537100374$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0a0e7b9537100374$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0a0e7b9537100374$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0a0e7b9537100374$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0a0e7b9537100374$var$Vd;
                        break;
                    case $0a0e7b9537100374$var$$e:
                    case $0a0e7b9537100374$var$af:
                    case $0a0e7b9537100374$var$bf:
                        k = $0a0e7b9537100374$var$Hd;
                        break;
                    case $0a0e7b9537100374$var$cf:
                        k = $0a0e7b9537100374$var$Xd;
                        break;
                    case "scroll":
                        k = $0a0e7b9537100374$var$vd;
                        break;
                    case "wheel":
                        k = $0a0e7b9537100374$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0a0e7b9537100374$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0a0e7b9537100374$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0a0e7b9537100374$var$Kb(w, x), null != F && t.push($0a0e7b9537100374$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0a0e7b9537100374$var$wb && (n = c.relatedTarget || c.fromElement) && ($0a0e7b9537100374$var$Wc(n) || n[$0a0e7b9537100374$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0a0e7b9537100374$var$Wc(n) : null, null !== n && (J = $0a0e7b9537100374$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0a0e7b9537100374$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0a0e7b9537100374$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0a0e7b9537100374$var$ue(k);
                        u = null == n ? h : $0a0e7b9537100374$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0a0e7b9537100374$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0a0e7b9537100374$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0a0e7b9537100374$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0a0e7b9537100374$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0a0e7b9537100374$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0a0e7b9537100374$var$vf(t);
                                x = $0a0e7b9537100374$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0a0e7b9537100374$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0a0e7b9537100374$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0a0e7b9537100374$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0a0e7b9537100374$var$ve;
                else if ($0a0e7b9537100374$var$me(h)) {
                    if ($0a0e7b9537100374$var$we) na = $0a0e7b9537100374$var$Fe;
                    else {
                        na = $0a0e7b9537100374$var$De;
                        var xa = $0a0e7b9537100374$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0a0e7b9537100374$var$Ee);
                if (na && (na = na(a, d))) {
                    $0a0e7b9537100374$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0a0e7b9537100374$var$cb(h, "number", h.value);
            }
            xa = d ? $0a0e7b9537100374$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0a0e7b9537100374$var$me(xa) || "true" === xa.contentEditable) $0a0e7b9537100374$var$Qe = xa, $0a0e7b9537100374$var$Re = d, $0a0e7b9537100374$var$Se = null;
                    break;
                case "focusout":
                    $0a0e7b9537100374$var$Se = $0a0e7b9537100374$var$Re = $0a0e7b9537100374$var$Qe = null;
                    break;
                case "mousedown":
                    $0a0e7b9537100374$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0a0e7b9537100374$var$Te = !1;
                    $0a0e7b9537100374$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0a0e7b9537100374$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0a0e7b9537100374$var$Ue(g, c, e);
            }
            var $a;
            if ($0a0e7b9537100374$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0a0e7b9537100374$var$ie ? $0a0e7b9537100374$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0a0e7b9537100374$var$de && "ko" !== c.locale && ($0a0e7b9537100374$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0a0e7b9537100374$var$ie && ($a = $0a0e7b9537100374$var$nd()) : ($0a0e7b9537100374$var$kd = e, $0a0e7b9537100374$var$ld = "value" in $0a0e7b9537100374$var$kd ? $0a0e7b9537100374$var$kd.value : $0a0e7b9537100374$var$kd.textContent, $0a0e7b9537100374$var$ie = !0)), xa = $0a0e7b9537100374$var$oe(d, ba), 0 < xa.length && (ba = new $0a0e7b9537100374$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0a0e7b9537100374$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0a0e7b9537100374$var$ce ? $0a0e7b9537100374$var$je(a, c) : $0a0e7b9537100374$var$ke(a, c)) d = $0a0e7b9537100374$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0a0e7b9537100374$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0a0e7b9537100374$var$se(g, b);
    });
}
function $0a0e7b9537100374$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0a0e7b9537100374$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0a0e7b9537100374$var$Kb(a, c), null != f && d.unshift($0a0e7b9537100374$var$tf(a, f, e)), f = $0a0e7b9537100374$var$Kb(a, b), null != f && d.push($0a0e7b9537100374$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0a0e7b9537100374$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0a0e7b9537100374$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0a0e7b9537100374$var$Kb(c, f), null != k && g.unshift($0a0e7b9537100374$var$tf(c, k, h))) : e || (k = $0a0e7b9537100374$var$Kb(c, f), null != k && g.push($0a0e7b9537100374$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0a0e7b9537100374$var$xf = /\r\n?/g, $0a0e7b9537100374$var$yf = /\u0000|\uFFFD/g;
function $0a0e7b9537100374$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0a0e7b9537100374$var$xf, "\n").replace($0a0e7b9537100374$var$yf, "");
}
function $0a0e7b9537100374$var$Af(a, b, c) {
    b = $0a0e7b9537100374$var$zf(b);
    if ($0a0e7b9537100374$var$zf(a) !== b && c) throw Error($0a0e7b9537100374$var$p(425));
}
function $0a0e7b9537100374$var$Bf() {}
var $0a0e7b9537100374$var$Cf = null, $0a0e7b9537100374$var$Df = null;
function $0a0e7b9537100374$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0a0e7b9537100374$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0a0e7b9537100374$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0a0e7b9537100374$var$Hf = "function" === typeof Promise ? Promise : void 0, $0a0e7b9537100374$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0a0e7b9537100374$var$Hf ? function(a) {
    return $0a0e7b9537100374$var$Hf.resolve(null).then(a).catch($0a0e7b9537100374$var$If);
} : $0a0e7b9537100374$var$Ff;
function $0a0e7b9537100374$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0a0e7b9537100374$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0a0e7b9537100374$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0a0e7b9537100374$var$bd(b);
}
function $0a0e7b9537100374$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0a0e7b9537100374$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0a0e7b9537100374$var$Nf = Math.random().toString(36).slice(2), $0a0e7b9537100374$var$Of = "__reactFiber$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$Pf = "__reactProps$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$uf = "__reactContainer$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$of = "__reactEvents$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$Qf = "__reactListeners$" + $0a0e7b9537100374$var$Nf, $0a0e7b9537100374$var$Rf = "__reactHandles$" + $0a0e7b9537100374$var$Nf;
function $0a0e7b9537100374$var$Wc(a) {
    var b = a[$0a0e7b9537100374$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0a0e7b9537100374$var$uf] || c[$0a0e7b9537100374$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0a0e7b9537100374$var$Mf(a); null !== a;){
                if (c = a[$0a0e7b9537100374$var$Of]) return c;
                a = $0a0e7b9537100374$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0a0e7b9537100374$var$Cb(a) {
    a = a[$0a0e7b9537100374$var$Of] || a[$0a0e7b9537100374$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0a0e7b9537100374$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0a0e7b9537100374$var$p(33));
}
function $0a0e7b9537100374$var$Db(a) {
    return a[$0a0e7b9537100374$var$Pf] || null;
}
var $0a0e7b9537100374$var$Sf = [], $0a0e7b9537100374$var$Tf = -1;
function $0a0e7b9537100374$var$Uf(a) {
    return {
        current: a
    };
}
function $0a0e7b9537100374$var$E(a) {
    0 > $0a0e7b9537100374$var$Tf || (a.current = $0a0e7b9537100374$var$Sf[$0a0e7b9537100374$var$Tf], $0a0e7b9537100374$var$Sf[$0a0e7b9537100374$var$Tf] = null, $0a0e7b9537100374$var$Tf--);
}
function $0a0e7b9537100374$var$G(a, b) {
    $0a0e7b9537100374$var$Tf++;
    $0a0e7b9537100374$var$Sf[$0a0e7b9537100374$var$Tf] = a.current;
    a.current = b;
}
var $0a0e7b9537100374$var$Vf = {}, $0a0e7b9537100374$var$H = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$Vf), $0a0e7b9537100374$var$Wf = $0a0e7b9537100374$var$Uf(!1), $0a0e7b9537100374$var$Xf = $0a0e7b9537100374$var$Vf;
function $0a0e7b9537100374$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0a0e7b9537100374$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0a0e7b9537100374$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0a0e7b9537100374$var$$f() {
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H);
}
function $0a0e7b9537100374$var$ag(a, b, c) {
    if ($0a0e7b9537100374$var$H.current !== $0a0e7b9537100374$var$Vf) throw Error($0a0e7b9537100374$var$p(168));
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$H, b);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wf, c);
}
function $0a0e7b9537100374$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0a0e7b9537100374$var$p(108, $0a0e7b9537100374$var$Ra(a) || "Unknown", e));
    return $0a0e7b9537100374$var$A({}, c, d);
}
function $0a0e7b9537100374$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0a0e7b9537100374$var$Vf;
    $0a0e7b9537100374$var$Xf = $0a0e7b9537100374$var$H.current;
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$H, a);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wf, $0a0e7b9537100374$var$Wf.current);
    return !0;
}
function $0a0e7b9537100374$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0a0e7b9537100374$var$p(169));
    c ? (a = $0a0e7b9537100374$var$bg(a, b, $0a0e7b9537100374$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H), $0a0e7b9537100374$var$G($0a0e7b9537100374$var$H, a)) : $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wf, c);
}
var $0a0e7b9537100374$var$eg = null, $0a0e7b9537100374$var$fg = !1, $0a0e7b9537100374$var$gg = !1;
function $0a0e7b9537100374$var$hg(a) {
    null === $0a0e7b9537100374$var$eg ? $0a0e7b9537100374$var$eg = [
        a
    ] : $0a0e7b9537100374$var$eg.push(a);
}
function $0a0e7b9537100374$var$ig(a) {
    $0a0e7b9537100374$var$fg = !0;
    $0a0e7b9537100374$var$hg(a);
}
function $0a0e7b9537100374$var$jg() {
    if (!$0a0e7b9537100374$var$gg && null !== $0a0e7b9537100374$var$eg) {
        $0a0e7b9537100374$var$gg = !0;
        var a = 0, b = $0a0e7b9537100374$var$C;
        try {
            var c = $0a0e7b9537100374$var$eg;
            for($0a0e7b9537100374$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0a0e7b9537100374$var$eg = null;
            $0a0e7b9537100374$var$fg = !1;
        } catch (e) {
            throw null !== $0a0e7b9537100374$var$eg && ($0a0e7b9537100374$var$eg = $0a0e7b9537100374$var$eg.slice(a + 1)), $0a0e7b9537100374$var$ac($0a0e7b9537100374$var$fc, $0a0e7b9537100374$var$jg), e;
        } finally{
            $0a0e7b9537100374$var$C = b, $0a0e7b9537100374$var$gg = !1;
        }
    }
    return null;
}
var $0a0e7b9537100374$var$kg = [], $0a0e7b9537100374$var$lg = 0, $0a0e7b9537100374$var$mg = null, $0a0e7b9537100374$var$ng = 0, $0a0e7b9537100374$var$og = [], $0a0e7b9537100374$var$pg = 0, $0a0e7b9537100374$var$qg = null, $0a0e7b9537100374$var$rg = 1, $0a0e7b9537100374$var$sg = "";
function $0a0e7b9537100374$var$tg(a, b) {
    $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg++] = $0a0e7b9537100374$var$ng;
    $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg++] = $0a0e7b9537100374$var$mg;
    $0a0e7b9537100374$var$mg = a;
    $0a0e7b9537100374$var$ng = b;
}
function $0a0e7b9537100374$var$ug(a, b, c) {
    $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$rg;
    $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$sg;
    $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$qg;
    $0a0e7b9537100374$var$qg = a;
    var d = $0a0e7b9537100374$var$rg;
    a = $0a0e7b9537100374$var$sg;
    var e = 32 - $0a0e7b9537100374$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0a0e7b9537100374$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0a0e7b9537100374$var$rg = 1 << 32 - $0a0e7b9537100374$var$oc(b) + e | c << e | d;
        $0a0e7b9537100374$var$sg = f + a;
    } else $0a0e7b9537100374$var$rg = 1 << f | c << e | d, $0a0e7b9537100374$var$sg = a;
}
function $0a0e7b9537100374$var$vg(a) {
    null !== a.return && ($0a0e7b9537100374$var$tg(a, 1), $0a0e7b9537100374$var$ug(a, 1, 0));
}
function $0a0e7b9537100374$var$wg(a) {
    for(; a === $0a0e7b9537100374$var$mg;)$0a0e7b9537100374$var$mg = $0a0e7b9537100374$var$kg[--$0a0e7b9537100374$var$lg], $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg] = null, $0a0e7b9537100374$var$ng = $0a0e7b9537100374$var$kg[--$0a0e7b9537100374$var$lg], $0a0e7b9537100374$var$kg[$0a0e7b9537100374$var$lg] = null;
    for(; a === $0a0e7b9537100374$var$qg;)$0a0e7b9537100374$var$qg = $0a0e7b9537100374$var$og[--$0a0e7b9537100374$var$pg], $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg] = null, $0a0e7b9537100374$var$sg = $0a0e7b9537100374$var$og[--$0a0e7b9537100374$var$pg], $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg] = null, $0a0e7b9537100374$var$rg = $0a0e7b9537100374$var$og[--$0a0e7b9537100374$var$pg], $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg] = null;
}
var $0a0e7b9537100374$var$xg = null, $0a0e7b9537100374$var$yg = null, $0a0e7b9537100374$var$I = !1, $0a0e7b9537100374$var$zg = null;
function $0a0e7b9537100374$var$Ag(a, b) {
    var c = $0a0e7b9537100374$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0a0e7b9537100374$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0a0e7b9537100374$var$xg = a, $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0a0e7b9537100374$var$xg = a, $0a0e7b9537100374$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0a0e7b9537100374$var$qg ? {
                id: $0a0e7b9537100374$var$rg,
                overflow: $0a0e7b9537100374$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0a0e7b9537100374$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0a0e7b9537100374$var$xg = a, $0a0e7b9537100374$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0a0e7b9537100374$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0a0e7b9537100374$var$Eg(a) {
    if ($0a0e7b9537100374$var$I) {
        var b = $0a0e7b9537100374$var$yg;
        if (b) {
            var c = b;
            if (!$0a0e7b9537100374$var$Cg(a, b)) {
                if ($0a0e7b9537100374$var$Dg(a)) throw Error($0a0e7b9537100374$var$p(418));
                b = $0a0e7b9537100374$var$Lf(c.nextSibling);
                var d = $0a0e7b9537100374$var$xg;
                b && $0a0e7b9537100374$var$Cg(a, b) ? $0a0e7b9537100374$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0a0e7b9537100374$var$I = !1, $0a0e7b9537100374$var$xg = a);
            }
        } else {
            if ($0a0e7b9537100374$var$Dg(a)) throw Error($0a0e7b9537100374$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0a0e7b9537100374$var$I = !1;
            $0a0e7b9537100374$var$xg = a;
        }
    }
}
function $0a0e7b9537100374$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0a0e7b9537100374$var$xg = a;
}
function $0a0e7b9537100374$var$Gg(a) {
    if (a !== $0a0e7b9537100374$var$xg) return !1;
    if (!$0a0e7b9537100374$var$I) return $0a0e7b9537100374$var$Fg(a), $0a0e7b9537100374$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0a0e7b9537100374$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0a0e7b9537100374$var$yg)) {
        if ($0a0e7b9537100374$var$Dg(a)) throw $0a0e7b9537100374$var$Hg(), Error($0a0e7b9537100374$var$p(418));
        for(; b;)$0a0e7b9537100374$var$Ag(a, b), b = $0a0e7b9537100374$var$Lf(b.nextSibling);
    }
    $0a0e7b9537100374$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0a0e7b9537100374$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0a0e7b9537100374$var$yg = null;
        }
    } else $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$xg ? $0a0e7b9537100374$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0a0e7b9537100374$var$Hg() {
    for(var a = $0a0e7b9537100374$var$yg; a;)a = $0a0e7b9537100374$var$Lf(a.nextSibling);
}
function $0a0e7b9537100374$var$Ig() {
    $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$xg = null;
    $0a0e7b9537100374$var$I = !1;
}
function $0a0e7b9537100374$var$Jg(a) {
    null === $0a0e7b9537100374$var$zg ? $0a0e7b9537100374$var$zg = [
        a
    ] : $0a0e7b9537100374$var$zg.push(a);
}
var $0a0e7b9537100374$var$Kg = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig;
function $0a0e7b9537100374$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0a0e7b9537100374$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0a0e7b9537100374$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0a0e7b9537100374$var$p(284));
        if (!c._owner) throw Error($0a0e7b9537100374$var$p(290, a));
    }
    return a;
}
function $0a0e7b9537100374$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0a0e7b9537100374$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0a0e7b9537100374$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0a0e7b9537100374$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0a0e7b9537100374$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0a0e7b9537100374$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0a0e7b9537100374$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0a0e7b9537100374$var$Ha && $0a0e7b9537100374$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0a0e7b9537100374$var$Lg(a, b, c), d.return = a, d;
        d = $0a0e7b9537100374$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0a0e7b9537100374$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0a0e7b9537100374$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0a0e7b9537100374$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0a0e7b9537100374$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0a0e7b9537100374$var$va:
                    return c = $0a0e7b9537100374$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0a0e7b9537100374$var$Lg(a, null, b), c.return = a, c;
                case $0a0e7b9537100374$var$wa:
                    return b = $0a0e7b9537100374$var$Sg(b, a.mode, c), b.return = a, b;
                case $0a0e7b9537100374$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0a0e7b9537100374$var$eb(b) || $0a0e7b9537100374$var$Ka(b)) return b = $0a0e7b9537100374$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0a0e7b9537100374$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0a0e7b9537100374$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0a0e7b9537100374$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0a0e7b9537100374$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0a0e7b9537100374$var$eb(c) || $0a0e7b9537100374$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0a0e7b9537100374$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0a0e7b9537100374$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0a0e7b9537100374$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0a0e7b9537100374$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0a0e7b9537100374$var$eb(d) || $0a0e7b9537100374$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0a0e7b9537100374$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0a0e7b9537100374$var$Ka(h);
        if ("function" !== typeof l) throw Error($0a0e7b9537100374$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0a0e7b9537100374$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0a0e7b9537100374$var$I && $0a0e7b9537100374$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0a0e7b9537100374$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0a0e7b9537100374$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0a0e7b9537100374$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0a0e7b9537100374$var$Ha && $0a0e7b9537100374$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0a0e7b9537100374$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0a0e7b9537100374$var$ya ? (d = $0a0e7b9537100374$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0a0e7b9537100374$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0a0e7b9537100374$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0a0e7b9537100374$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0a0e7b9537100374$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0a0e7b9537100374$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0a0e7b9537100374$var$eb(f)) return n(a, d, f, h);
            if ($0a0e7b9537100374$var$Ka(f)) return t(a, d, f, h);
            $0a0e7b9537100374$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0a0e7b9537100374$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0a0e7b9537100374$var$Ug = $0a0e7b9537100374$var$Og(!0), $0a0e7b9537100374$var$Vg = $0a0e7b9537100374$var$Og(!1), $0a0e7b9537100374$var$Wg = $0a0e7b9537100374$var$Uf(null), $0a0e7b9537100374$var$Xg = null, $0a0e7b9537100374$var$Yg = null, $0a0e7b9537100374$var$Zg = null;
function $0a0e7b9537100374$var$$g() {
    $0a0e7b9537100374$var$Zg = $0a0e7b9537100374$var$Yg = $0a0e7b9537100374$var$Xg = null;
}
function $0a0e7b9537100374$var$ah(a) {
    var b = $0a0e7b9537100374$var$Wg.current;
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wg);
    a._currentValue = b;
}
function $0a0e7b9537100374$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0a0e7b9537100374$var$ch(a, b) {
    $0a0e7b9537100374$var$Xg = a;
    $0a0e7b9537100374$var$Zg = $0a0e7b9537100374$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0a0e7b9537100374$var$dh = !0), a.firstContext = null);
}
function $0a0e7b9537100374$var$eh(a) {
    var b = a._currentValue;
    if ($0a0e7b9537100374$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0a0e7b9537100374$var$Yg) {
            if (null === $0a0e7b9537100374$var$Xg) throw Error($0a0e7b9537100374$var$p(308));
            $0a0e7b9537100374$var$Yg = a;
            $0a0e7b9537100374$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0a0e7b9537100374$var$Yg = $0a0e7b9537100374$var$Yg.next = a;
    }
    return b;
}
var $0a0e7b9537100374$var$fh = null;
function $0a0e7b9537100374$var$gh(a) {
    null === $0a0e7b9537100374$var$fh ? $0a0e7b9537100374$var$fh = [
        a
    ] : $0a0e7b9537100374$var$fh.push(a);
}
function $0a0e7b9537100374$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0a0e7b9537100374$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0a0e7b9537100374$var$ih(a, d);
}
function $0a0e7b9537100374$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0a0e7b9537100374$var$jh = !1;
function $0a0e7b9537100374$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0a0e7b9537100374$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0a0e7b9537100374$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0a0e7b9537100374$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0a0e7b9537100374$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0a0e7b9537100374$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0a0e7b9537100374$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0a0e7b9537100374$var$ih(a, c);
}
function $0a0e7b9537100374$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0a0e7b9537100374$var$Cc(a, c);
    }
}
function $0a0e7b9537100374$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0a0e7b9537100374$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0a0e7b9537100374$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0a0e7b9537100374$var$A({}, q, r);
                            break a;
                        case 2:
                            $0a0e7b9537100374$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0a0e7b9537100374$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0a0e7b9537100374$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0a0e7b9537100374$var$p(191, e));
            e.call(d);
        }
    }
}
var $0a0e7b9537100374$var$th = {}, $0a0e7b9537100374$var$uh = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$th), $0a0e7b9537100374$var$vh = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$th), $0a0e7b9537100374$var$wh = $0a0e7b9537100374$var$Uf($0a0e7b9537100374$var$th);
function $0a0e7b9537100374$var$xh(a) {
    if (a === $0a0e7b9537100374$var$th) throw Error($0a0e7b9537100374$var$p(174));
    return a;
}
function $0a0e7b9537100374$var$yh(a, b) {
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$wh, b);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$vh, a);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$uh, $0a0e7b9537100374$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0a0e7b9537100374$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0a0e7b9537100374$var$lb(b, a);
    }
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$uh);
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$uh, b);
}
function $0a0e7b9537100374$var$zh() {
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$uh);
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$vh);
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$wh);
}
function $0a0e7b9537100374$var$Ah(a) {
    $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$wh.current);
    var b = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
    var c = $0a0e7b9537100374$var$lb(b, a.type);
    b !== c && ($0a0e7b9537100374$var$G($0a0e7b9537100374$var$vh, a), $0a0e7b9537100374$var$G($0a0e7b9537100374$var$uh, c));
}
function $0a0e7b9537100374$var$Bh(a) {
    $0a0e7b9537100374$var$vh.current === a && ($0a0e7b9537100374$var$E($0a0e7b9537100374$var$uh), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$vh));
}
var $0a0e7b9537100374$var$L = $0a0e7b9537100374$var$Uf(0);
function $0a0e7b9537100374$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0a0e7b9537100374$var$Dh = [];
function $0a0e7b9537100374$var$Eh() {
    for(var a = 0; a < $0a0e7b9537100374$var$Dh.length; a++)$0a0e7b9537100374$var$Dh[a]._workInProgressVersionPrimary = null;
    $0a0e7b9537100374$var$Dh.length = 0;
}
var $0a0e7b9537100374$var$Fh = $0a0e7b9537100374$var$ua.ReactCurrentDispatcher, $0a0e7b9537100374$var$Gh = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig, $0a0e7b9537100374$var$Hh = 0, $0a0e7b9537100374$var$M = null, $0a0e7b9537100374$var$N = null, $0a0e7b9537100374$var$O = null, $0a0e7b9537100374$var$Ih = !1, $0a0e7b9537100374$var$Jh = !1, $0a0e7b9537100374$var$Kh = 0, $0a0e7b9537100374$var$Lh = 0;
function $0a0e7b9537100374$var$P() {
    throw Error($0a0e7b9537100374$var$p(321));
}
function $0a0e7b9537100374$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0a0e7b9537100374$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0a0e7b9537100374$var$Nh(a, b, c, d, e, f) {
    $0a0e7b9537100374$var$Hh = f;
    $0a0e7b9537100374$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0a0e7b9537100374$var$Fh.current = null === a || null === a.memoizedState ? $0a0e7b9537100374$var$Oh : $0a0e7b9537100374$var$Ph;
    a = c(d, e);
    if ($0a0e7b9537100374$var$Jh) {
        f = 0;
        do {
            $0a0e7b9537100374$var$Jh = !1;
            $0a0e7b9537100374$var$Kh = 0;
            if (25 <= f) throw Error($0a0e7b9537100374$var$p(301));
            f += 1;
            $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$N = null;
            b.updateQueue = null;
            $0a0e7b9537100374$var$Fh.current = $0a0e7b9537100374$var$Qh;
            a = c(d, e);
        }while ($0a0e7b9537100374$var$Jh);
    }
    $0a0e7b9537100374$var$Fh.current = $0a0e7b9537100374$var$Rh;
    b = null !== $0a0e7b9537100374$var$N && null !== $0a0e7b9537100374$var$N.next;
    $0a0e7b9537100374$var$Hh = 0;
    $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$N = $0a0e7b9537100374$var$M = null;
    $0a0e7b9537100374$var$Ih = !1;
    if (b) throw Error($0a0e7b9537100374$var$p(300));
    return a;
}
function $0a0e7b9537100374$var$Sh() {
    var a = 0 !== $0a0e7b9537100374$var$Kh;
    $0a0e7b9537100374$var$Kh = 0;
    return a;
}
function $0a0e7b9537100374$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0a0e7b9537100374$var$O ? $0a0e7b9537100374$var$M.memoizedState = $0a0e7b9537100374$var$O = a : $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$O.next = a;
    return $0a0e7b9537100374$var$O;
}
function $0a0e7b9537100374$var$Uh() {
    if (null === $0a0e7b9537100374$var$N) {
        var a = $0a0e7b9537100374$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0a0e7b9537100374$var$N.next;
    var b = null === $0a0e7b9537100374$var$O ? $0a0e7b9537100374$var$M.memoizedState : $0a0e7b9537100374$var$O.next;
    if (null !== b) $0a0e7b9537100374$var$O = b, $0a0e7b9537100374$var$N = a;
    else {
        if (null === a) throw Error($0a0e7b9537100374$var$p(310));
        $0a0e7b9537100374$var$N = a;
        a = {
            memoizedState: $0a0e7b9537100374$var$N.memoizedState,
            baseState: $0a0e7b9537100374$var$N.baseState,
            baseQueue: $0a0e7b9537100374$var$N.baseQueue,
            queue: $0a0e7b9537100374$var$N.queue,
            next: null
        };
        null === $0a0e7b9537100374$var$O ? $0a0e7b9537100374$var$M.memoizedState = $0a0e7b9537100374$var$O = a : $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$O.next = a;
    }
    return $0a0e7b9537100374$var$O;
}
function $0a0e7b9537100374$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0a0e7b9537100374$var$Wh(a) {
    var b = $0a0e7b9537100374$var$Uh(), c = b.queue;
    if (null === c) throw Error($0a0e7b9537100374$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0a0e7b9537100374$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0a0e7b9537100374$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0a0e7b9537100374$var$M.lanes |= m;
                $0a0e7b9537100374$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0a0e7b9537100374$var$He(d, b.memoizedState) || ($0a0e7b9537100374$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0a0e7b9537100374$var$M.lanes |= f, $0a0e7b9537100374$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0a0e7b9537100374$var$Xh(a) {
    var b = $0a0e7b9537100374$var$Uh(), c = b.queue;
    if (null === c) throw Error($0a0e7b9537100374$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0a0e7b9537100374$var$He(f, b.memoizedState) || ($0a0e7b9537100374$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0a0e7b9537100374$var$Yh() {}
function $0a0e7b9537100374$var$Zh(a, b) {
    var c = $0a0e7b9537100374$var$M, d = $0a0e7b9537100374$var$Uh(), e = b(), f = !$0a0e7b9537100374$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0a0e7b9537100374$var$dh = !0);
    d = d.queue;
    $0a0e7b9537100374$var$$h($0a0e7b9537100374$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0a0e7b9537100374$var$O && $0a0e7b9537100374$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0a0e7b9537100374$var$bi(9, $0a0e7b9537100374$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0a0e7b9537100374$var$Q) throw Error($0a0e7b9537100374$var$p(349));
        0 !== ($0a0e7b9537100374$var$Hh & 30) || $0a0e7b9537100374$var$di(c, b, e);
    }
    return e;
}
function $0a0e7b9537100374$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0a0e7b9537100374$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0a0e7b9537100374$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0a0e7b9537100374$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0a0e7b9537100374$var$ei(b) && $0a0e7b9537100374$var$fi(a);
}
function $0a0e7b9537100374$var$ai(a, b, c) {
    return c(function() {
        $0a0e7b9537100374$var$ei(b) && $0a0e7b9537100374$var$fi(a);
    });
}
function $0a0e7b9537100374$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0a0e7b9537100374$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0a0e7b9537100374$var$fi(a) {
    var b = $0a0e7b9537100374$var$ih(a, 1);
    null !== b && $0a0e7b9537100374$var$gi(b, a, 1, -1);
}
function $0a0e7b9537100374$var$hi(a) {
    var b = $0a0e7b9537100374$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0a0e7b9537100374$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0a0e7b9537100374$var$ii.bind(null, $0a0e7b9537100374$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0a0e7b9537100374$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0a0e7b9537100374$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0a0e7b9537100374$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0a0e7b9537100374$var$ji() {
    return $0a0e7b9537100374$var$Uh().memoizedState;
}
function $0a0e7b9537100374$var$ki(a, b, c, d) {
    var e = $0a0e7b9537100374$var$Th();
    $0a0e7b9537100374$var$M.flags |= a;
    e.memoizedState = $0a0e7b9537100374$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0a0e7b9537100374$var$li(a, b, c, d) {
    var e = $0a0e7b9537100374$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0a0e7b9537100374$var$N) {
        var g = $0a0e7b9537100374$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0a0e7b9537100374$var$Mh(d, g.deps)) {
            e.memoizedState = $0a0e7b9537100374$var$bi(b, c, f, d);
            return;
        }
    }
    $0a0e7b9537100374$var$M.flags |= a;
    e.memoizedState = $0a0e7b9537100374$var$bi(1 | b, c, f, d);
}
function $0a0e7b9537100374$var$mi(a, b) {
    return $0a0e7b9537100374$var$ki(8390656, 8, a, b);
}
function $0a0e7b9537100374$var$$h(a, b) {
    return $0a0e7b9537100374$var$li(2048, 8, a, b);
}
function $0a0e7b9537100374$var$ni(a, b) {
    return $0a0e7b9537100374$var$li(4, 2, a, b);
}
function $0a0e7b9537100374$var$oi(a, b) {
    return $0a0e7b9537100374$var$li(4, 4, a, b);
}
function $0a0e7b9537100374$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0a0e7b9537100374$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0a0e7b9537100374$var$li(4, 4, $0a0e7b9537100374$var$pi.bind(null, b, a), c);
}
function $0a0e7b9537100374$var$ri() {}
function $0a0e7b9537100374$var$si(a, b) {
    var c = $0a0e7b9537100374$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0a0e7b9537100374$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0a0e7b9537100374$var$ti(a, b) {
    var c = $0a0e7b9537100374$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0a0e7b9537100374$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0a0e7b9537100374$var$ui(a, b, c) {
    if (0 === ($0a0e7b9537100374$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0a0e7b9537100374$var$dh = !0), a.memoizedState = c;
    $0a0e7b9537100374$var$He(c, b) || (c = $0a0e7b9537100374$var$yc(), $0a0e7b9537100374$var$M.lanes |= c, $0a0e7b9537100374$var$rh |= c, a.baseState = !0);
    return b;
}
function $0a0e7b9537100374$var$vi(a, b) {
    var c = $0a0e7b9537100374$var$C;
    $0a0e7b9537100374$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0a0e7b9537100374$var$Gh.transition;
    $0a0e7b9537100374$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0a0e7b9537100374$var$C = c, $0a0e7b9537100374$var$Gh.transition = d;
    }
}
function $0a0e7b9537100374$var$wi() {
    return $0a0e7b9537100374$var$Uh().memoizedState;
}
function $0a0e7b9537100374$var$xi(a, b, c) {
    var d = $0a0e7b9537100374$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0a0e7b9537100374$var$zi(a)) $0a0e7b9537100374$var$Ai(b, c);
    else if (c = $0a0e7b9537100374$var$hh(a, b, c, d), null !== c) {
        var e = $0a0e7b9537100374$var$R();
        $0a0e7b9537100374$var$gi(c, a, d, e);
        $0a0e7b9537100374$var$Bi(c, b, d);
    }
}
function $0a0e7b9537100374$var$ii(a, b, c) {
    var d = $0a0e7b9537100374$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0a0e7b9537100374$var$zi(a)) $0a0e7b9537100374$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0a0e7b9537100374$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0a0e7b9537100374$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0a0e7b9537100374$var$hh(a, b, e, d);
        null !== c && (e = $0a0e7b9537100374$var$R(), $0a0e7b9537100374$var$gi(c, a, d, e), $0a0e7b9537100374$var$Bi(c, b, d));
    }
}
function $0a0e7b9537100374$var$zi(a) {
    var b = a.alternate;
    return a === $0a0e7b9537100374$var$M || null !== b && b === $0a0e7b9537100374$var$M;
}
function $0a0e7b9537100374$var$Ai(a, b) {
    $0a0e7b9537100374$var$Jh = $0a0e7b9537100374$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0a0e7b9537100374$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0a0e7b9537100374$var$Cc(a, c);
    }
}
var $0a0e7b9537100374$var$Rh = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: $0a0e7b9537100374$var$P,
    useContext: $0a0e7b9537100374$var$P,
    useEffect: $0a0e7b9537100374$var$P,
    useImperativeHandle: $0a0e7b9537100374$var$P,
    useInsertionEffect: $0a0e7b9537100374$var$P,
    useLayoutEffect: $0a0e7b9537100374$var$P,
    useMemo: $0a0e7b9537100374$var$P,
    useReducer: $0a0e7b9537100374$var$P,
    useRef: $0a0e7b9537100374$var$P,
    useState: $0a0e7b9537100374$var$P,
    useDebugValue: $0a0e7b9537100374$var$P,
    useDeferredValue: $0a0e7b9537100374$var$P,
    useTransition: $0a0e7b9537100374$var$P,
    useMutableSource: $0a0e7b9537100374$var$P,
    useSyncExternalStore: $0a0e7b9537100374$var$P,
    useId: $0a0e7b9537100374$var$P,
    unstable_isNewReconciler: !1
}, $0a0e7b9537100374$var$Oh = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: function(a, b) {
        $0a0e7b9537100374$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0a0e7b9537100374$var$eh,
    useEffect: $0a0e7b9537100374$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0a0e7b9537100374$var$ki(4194308, 4, $0a0e7b9537100374$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0a0e7b9537100374$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0a0e7b9537100374$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0a0e7b9537100374$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0a0e7b9537100374$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0a0e7b9537100374$var$xi.bind(null, $0a0e7b9537100374$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0a0e7b9537100374$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0a0e7b9537100374$var$hi,
    useDebugValue: $0a0e7b9537100374$var$ri,
    useDeferredValue: function(a) {
        return $0a0e7b9537100374$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0a0e7b9537100374$var$hi(!1), b = a[0];
        a = $0a0e7b9537100374$var$vi.bind(null, a[1]);
        $0a0e7b9537100374$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0a0e7b9537100374$var$M, e = $0a0e7b9537100374$var$Th();
        if ($0a0e7b9537100374$var$I) {
            if (void 0 === c) throw Error($0a0e7b9537100374$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0a0e7b9537100374$var$Q) throw Error($0a0e7b9537100374$var$p(349));
            0 !== ($0a0e7b9537100374$var$Hh & 30) || $0a0e7b9537100374$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0a0e7b9537100374$var$mi($0a0e7b9537100374$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0a0e7b9537100374$var$bi(9, $0a0e7b9537100374$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0a0e7b9537100374$var$Th(), b = $0a0e7b9537100374$var$Q.identifierPrefix;
        if ($0a0e7b9537100374$var$I) {
            var c = $0a0e7b9537100374$var$sg;
            var d = $0a0e7b9537100374$var$rg;
            c = (d & ~(1 << 32 - $0a0e7b9537100374$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0a0e7b9537100374$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0a0e7b9537100374$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0a0e7b9537100374$var$Ph = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: $0a0e7b9537100374$var$si,
    useContext: $0a0e7b9537100374$var$eh,
    useEffect: $0a0e7b9537100374$var$$h,
    useImperativeHandle: $0a0e7b9537100374$var$qi,
    useInsertionEffect: $0a0e7b9537100374$var$ni,
    useLayoutEffect: $0a0e7b9537100374$var$oi,
    useMemo: $0a0e7b9537100374$var$ti,
    useReducer: $0a0e7b9537100374$var$Wh,
    useRef: $0a0e7b9537100374$var$ji,
    useState: function() {
        return $0a0e7b9537100374$var$Wh($0a0e7b9537100374$var$Vh);
    },
    useDebugValue: $0a0e7b9537100374$var$ri,
    useDeferredValue: function(a) {
        var b = $0a0e7b9537100374$var$Uh();
        return $0a0e7b9537100374$var$ui(b, $0a0e7b9537100374$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0a0e7b9537100374$var$Wh($0a0e7b9537100374$var$Vh)[0], b = $0a0e7b9537100374$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0a0e7b9537100374$var$Yh,
    useSyncExternalStore: $0a0e7b9537100374$var$Zh,
    useId: $0a0e7b9537100374$var$wi,
    unstable_isNewReconciler: !1
}, $0a0e7b9537100374$var$Qh = {
    readContext: $0a0e7b9537100374$var$eh,
    useCallback: $0a0e7b9537100374$var$si,
    useContext: $0a0e7b9537100374$var$eh,
    useEffect: $0a0e7b9537100374$var$$h,
    useImperativeHandle: $0a0e7b9537100374$var$qi,
    useInsertionEffect: $0a0e7b9537100374$var$ni,
    useLayoutEffect: $0a0e7b9537100374$var$oi,
    useMemo: $0a0e7b9537100374$var$ti,
    useReducer: $0a0e7b9537100374$var$Xh,
    useRef: $0a0e7b9537100374$var$ji,
    useState: function() {
        return $0a0e7b9537100374$var$Xh($0a0e7b9537100374$var$Vh);
    },
    useDebugValue: $0a0e7b9537100374$var$ri,
    useDeferredValue: function(a) {
        var b = $0a0e7b9537100374$var$Uh();
        return null === $0a0e7b9537100374$var$N ? b.memoizedState = a : $0a0e7b9537100374$var$ui(b, $0a0e7b9537100374$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0a0e7b9537100374$var$Xh($0a0e7b9537100374$var$Vh)[0], b = $0a0e7b9537100374$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0a0e7b9537100374$var$Yh,
    useSyncExternalStore: $0a0e7b9537100374$var$Zh,
    useId: $0a0e7b9537100374$var$wi,
    unstable_isNewReconciler: !1
};
function $0a0e7b9537100374$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0a0e7b9537100374$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0a0e7b9537100374$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0a0e7b9537100374$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0a0e7b9537100374$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0a0e7b9537100374$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0a0e7b9537100374$var$R(), e = $0a0e7b9537100374$var$yi(a), f = $0a0e7b9537100374$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0a0e7b9537100374$var$nh(a, f, e);
        null !== b && ($0a0e7b9537100374$var$gi(b, a, e, d), $0a0e7b9537100374$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0a0e7b9537100374$var$R(), e = $0a0e7b9537100374$var$yi(a), f = $0a0e7b9537100374$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0a0e7b9537100374$var$nh(a, f, e);
        null !== b && ($0a0e7b9537100374$var$gi(b, a, e, d), $0a0e7b9537100374$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0a0e7b9537100374$var$R(), d = $0a0e7b9537100374$var$yi(a), e = $0a0e7b9537100374$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0a0e7b9537100374$var$nh(a, e, d);
        null !== b && ($0a0e7b9537100374$var$gi(b, a, d, c), $0a0e7b9537100374$var$oh(b, a, d));
    }
};
function $0a0e7b9537100374$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0a0e7b9537100374$var$Ie(c, d) || !$0a0e7b9537100374$var$Ie(e, f) : !0;
}
function $0a0e7b9537100374$var$Gi(a, b, c) {
    var d = !1, e = $0a0e7b9537100374$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0a0e7b9537100374$var$eh(f) : (e = $0a0e7b9537100374$var$Zf(b) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0a0e7b9537100374$var$Yf(a, e) : $0a0e7b9537100374$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0a0e7b9537100374$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0a0e7b9537100374$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0a0e7b9537100374$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0a0e7b9537100374$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0a0e7b9537100374$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0a0e7b9537100374$var$eh(f) : (f = $0a0e7b9537100374$var$Zf(b) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, e.context = $0a0e7b9537100374$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0a0e7b9537100374$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0a0e7b9537100374$var$Ei.enqueueReplaceState(e, e.state, null), $0a0e7b9537100374$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0a0e7b9537100374$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0a0e7b9537100374$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0a0e7b9537100374$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0a0e7b9537100374$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0a0e7b9537100374$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0a0e7b9537100374$var$Ni(a, b, c) {
    c = $0a0e7b9537100374$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0a0e7b9537100374$var$Oi || ($0a0e7b9537100374$var$Oi = !0, $0a0e7b9537100374$var$Pi = d);
        $0a0e7b9537100374$var$Li(a, b);
    };
    return c;
}
function $0a0e7b9537100374$var$Qi(a, b, c) {
    c = $0a0e7b9537100374$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0a0e7b9537100374$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0a0e7b9537100374$var$Li(a, b);
        "function" !== typeof d && (null === $0a0e7b9537100374$var$Ri ? $0a0e7b9537100374$var$Ri = new Set([
            this
        ]) : $0a0e7b9537100374$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0a0e7b9537100374$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0a0e7b9537100374$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0a0e7b9537100374$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0a0e7b9537100374$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0a0e7b9537100374$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0a0e7b9537100374$var$mh(-1, 1), b.tag = 2, $0a0e7b9537100374$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0a0e7b9537100374$var$Wi = $0a0e7b9537100374$var$ua.ReactCurrentOwner, $0a0e7b9537100374$var$dh = !1;
function $0a0e7b9537100374$var$Xi(a, b, c, d) {
    b.child = null === a ? $0a0e7b9537100374$var$Vg(b, null, c, d) : $0a0e7b9537100374$var$Ug(b, a.child, c, d);
}
function $0a0e7b9537100374$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0a0e7b9537100374$var$ch(b, e);
    d = $0a0e7b9537100374$var$Nh(a, b, c, d, f, e);
    c = $0a0e7b9537100374$var$Sh();
    if (null !== a && !$0a0e7b9537100374$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0a0e7b9537100374$var$Zi(a, b, e);
    $0a0e7b9537100374$var$I && c && $0a0e7b9537100374$var$vg(b);
    b.flags |= 1;
    $0a0e7b9537100374$var$Xi(a, b, d, e);
    return b.child;
}
function $0a0e7b9537100374$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0a0e7b9537100374$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0a0e7b9537100374$var$bj(a, b, f, d, e);
        a = $0a0e7b9537100374$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0a0e7b9537100374$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0a0e7b9537100374$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0a0e7b9537100374$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0a0e7b9537100374$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0a0e7b9537100374$var$Ie(f, d) && a.ref === b.ref) {
            if ($0a0e7b9537100374$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0a0e7b9537100374$var$dh = !0);
            else return b.lanes = a.lanes, $0a0e7b9537100374$var$Zi(a, b, e);
        }
    }
    return $0a0e7b9537100374$var$cj(a, b, c, d, e);
}
function $0a0e7b9537100374$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj), $0a0e7b9537100374$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj), $0a0e7b9537100374$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj);
            $0a0e7b9537100374$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$ej, $0a0e7b9537100374$var$fj), $0a0e7b9537100374$var$fj |= d;
    $0a0e7b9537100374$var$Xi(a, b, e, c);
    return b.child;
}
function $0a0e7b9537100374$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0a0e7b9537100374$var$cj(a, b, c, d, e) {
    var f = $0a0e7b9537100374$var$Zf(c) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current;
    f = $0a0e7b9537100374$var$Yf(b, f);
    $0a0e7b9537100374$var$ch(b, e);
    c = $0a0e7b9537100374$var$Nh(a, b, c, d, f, e);
    d = $0a0e7b9537100374$var$Sh();
    if (null !== a && !$0a0e7b9537100374$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0a0e7b9537100374$var$Zi(a, b, e);
    $0a0e7b9537100374$var$I && d && $0a0e7b9537100374$var$vg(b);
    b.flags |= 1;
    $0a0e7b9537100374$var$Xi(a, b, c, e);
    return b.child;
}
function $0a0e7b9537100374$var$hj(a, b, c, d, e) {
    if ($0a0e7b9537100374$var$Zf(c)) {
        var f = !0;
        $0a0e7b9537100374$var$cg(b);
    } else f = !1;
    $0a0e7b9537100374$var$ch(b, e);
    if (null === b.stateNode) $0a0e7b9537100374$var$ij(a, b), $0a0e7b9537100374$var$Gi(b, c, d), $0a0e7b9537100374$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0a0e7b9537100374$var$eh(l) : (l = $0a0e7b9537100374$var$Zf(c) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, l = $0a0e7b9537100374$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0a0e7b9537100374$var$Hi(b, g, d, l);
        $0a0e7b9537100374$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0a0e7b9537100374$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0a0e7b9537100374$var$Wf.current || $0a0e7b9537100374$var$jh ? ("function" === typeof m && ($0a0e7b9537100374$var$Di(b, c, m, d), k = b.memoizedState), (h = $0a0e7b9537100374$var$jh || $0a0e7b9537100374$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0a0e7b9537100374$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0a0e7b9537100374$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0a0e7b9537100374$var$eh(k) : (k = $0a0e7b9537100374$var$Zf(c) ? $0a0e7b9537100374$var$Xf : $0a0e7b9537100374$var$H.current, k = $0a0e7b9537100374$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0a0e7b9537100374$var$Hi(b, g, d, k);
        $0a0e7b9537100374$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0a0e7b9537100374$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0a0e7b9537100374$var$Wf.current || $0a0e7b9537100374$var$jh ? ("function" === typeof y && ($0a0e7b9537100374$var$Di(b, c, y, d), n = b.memoizedState), (l = $0a0e7b9537100374$var$jh || $0a0e7b9537100374$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0a0e7b9537100374$var$jj(a, b, c, d, f, e);
}
function $0a0e7b9537100374$var$jj(a, b, c, d, e, f) {
    $0a0e7b9537100374$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0a0e7b9537100374$var$dg(b, c, !1), $0a0e7b9537100374$var$Zi(a, b, f);
    d = b.stateNode;
    $0a0e7b9537100374$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0a0e7b9537100374$var$Ug(b, a.child, null, f), b.child = $0a0e7b9537100374$var$Ug(b, null, h, f)) : $0a0e7b9537100374$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0a0e7b9537100374$var$dg(b, c, !0);
    return b.child;
}
function $0a0e7b9537100374$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0a0e7b9537100374$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0a0e7b9537100374$var$ag(a, b.context, !1);
    $0a0e7b9537100374$var$yh(a, b.containerInfo);
}
function $0a0e7b9537100374$var$lj(a, b, c, d, e) {
    $0a0e7b9537100374$var$Ig();
    $0a0e7b9537100374$var$Jg(e);
    b.flags |= 256;
    $0a0e7b9537100374$var$Xi(a, b, c, d);
    return b.child;
}
var $0a0e7b9537100374$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0a0e7b9537100374$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0a0e7b9537100374$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0a0e7b9537100374$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, e & 1);
    if (null === a) {
        $0a0e7b9537100374$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0a0e7b9537100374$var$pj(g, d, 0, null), a = $0a0e7b9537100374$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0a0e7b9537100374$var$nj(c), b.memoizedState = $0a0e7b9537100374$var$mj, a) : $0a0e7b9537100374$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0a0e7b9537100374$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0a0e7b9537100374$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0a0e7b9537100374$var$Pg(h, f) : (f = $0a0e7b9537100374$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0a0e7b9537100374$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0a0e7b9537100374$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0a0e7b9537100374$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0a0e7b9537100374$var$qj(a, b) {
    b = $0a0e7b9537100374$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0a0e7b9537100374$var$sj(a, b, c, d) {
    null !== d && $0a0e7b9537100374$var$Jg(d);
    $0a0e7b9537100374$var$Ug(b, a.child, null, c);
    a = $0a0e7b9537100374$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0a0e7b9537100374$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0a0e7b9537100374$var$Ki(Error($0a0e7b9537100374$var$p(422))), $0a0e7b9537100374$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0a0e7b9537100374$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0a0e7b9537100374$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0a0e7b9537100374$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0a0e7b9537100374$var$nj(g);
        b.memoizedState = $0a0e7b9537100374$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0a0e7b9537100374$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0a0e7b9537100374$var$p(419));
        d = $0a0e7b9537100374$var$Ki(f, d, void 0);
        return $0a0e7b9537100374$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0a0e7b9537100374$var$dh || h) {
        d = $0a0e7b9537100374$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0a0e7b9537100374$var$ih(a, e), $0a0e7b9537100374$var$gi(d, a, e, -1));
        }
        $0a0e7b9537100374$var$tj();
        d = $0a0e7b9537100374$var$Ki(Error($0a0e7b9537100374$var$p(421)));
        return $0a0e7b9537100374$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0a0e7b9537100374$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(e.nextSibling);
    $0a0e7b9537100374$var$xg = b;
    $0a0e7b9537100374$var$I = !0;
    $0a0e7b9537100374$var$zg = null;
    null !== a && ($0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$rg, $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$sg, $0a0e7b9537100374$var$og[$0a0e7b9537100374$var$pg++] = $0a0e7b9537100374$var$qg, $0a0e7b9537100374$var$rg = a.id, $0a0e7b9537100374$var$sg = a.overflow, $0a0e7b9537100374$var$qg = b);
    b = $0a0e7b9537100374$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0a0e7b9537100374$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0a0e7b9537100374$var$bh(a.return, b, c);
}
function $0a0e7b9537100374$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0a0e7b9537100374$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0a0e7b9537100374$var$Xi(a, b, d.children, c);
    d = $0a0e7b9537100374$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0a0e7b9537100374$var$vj(a, c, b);
            else if (19 === a.tag) $0a0e7b9537100374$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0a0e7b9537100374$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0a0e7b9537100374$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0a0e7b9537100374$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0a0e7b9537100374$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0a0e7b9537100374$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0a0e7b9537100374$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0a0e7b9537100374$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0a0e7b9537100374$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0a0e7b9537100374$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0a0e7b9537100374$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0a0e7b9537100374$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0a0e7b9537100374$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0a0e7b9537100374$var$kj(b);
            $0a0e7b9537100374$var$Ig();
            break;
        case 5:
            $0a0e7b9537100374$var$Ah(b);
            break;
        case 1:
            $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$cg(b);
            break;
        case 4:
            $0a0e7b9537100374$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0a0e7b9537100374$var$oj(a, b, c);
                $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1);
                a = $0a0e7b9537100374$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0a0e7b9537100374$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0a0e7b9537100374$var$dj(a, b, c);
    }
    return $0a0e7b9537100374$var$Zi(a, b, c);
}
var $0a0e7b9537100374$var$zj, $0a0e7b9537100374$var$Aj, $0a0e7b9537100374$var$Bj, $0a0e7b9537100374$var$Cj;
$0a0e7b9537100374$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0a0e7b9537100374$var$Aj = function() {};
$0a0e7b9537100374$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0a0e7b9537100374$var$Ya(a, e);
                d = $0a0e7b9537100374$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0a0e7b9537100374$var$A({}, e, {
                    value: void 0
                });
                d = $0a0e7b9537100374$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0a0e7b9537100374$var$gb(a, e);
                d = $0a0e7b9537100374$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0a0e7b9537100374$var$Bf);
        }
        $0a0e7b9537100374$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0a0e7b9537100374$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0a0e7b9537100374$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0a0e7b9537100374$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0a0e7b9537100374$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0a0e7b9537100374$var$Dj(a, b) {
    if (!$0a0e7b9537100374$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0a0e7b9537100374$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0a0e7b9537100374$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0a0e7b9537100374$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0a0e7b9537100374$var$S(b), null;
        case 1:
            return $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$$f(), $0a0e7b9537100374$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0a0e7b9537100374$var$zh();
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H);
            $0a0e7b9537100374$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0a0e7b9537100374$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0a0e7b9537100374$var$zg && ($0a0e7b9537100374$var$Fj($0a0e7b9537100374$var$zg), $0a0e7b9537100374$var$zg = null));
            $0a0e7b9537100374$var$Aj(a, b);
            $0a0e7b9537100374$var$S(b);
            return null;
        case 5:
            $0a0e7b9537100374$var$Bh(b);
            var e = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0a0e7b9537100374$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0a0e7b9537100374$var$p(166));
                    $0a0e7b9537100374$var$S(b);
                    return null;
                }
                a = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
                if ($0a0e7b9537100374$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0a0e7b9537100374$var$Of] = b;
                    d[$0a0e7b9537100374$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0a0e7b9537100374$var$D("cancel", d);
                            $0a0e7b9537100374$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0a0e7b9537100374$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0a0e7b9537100374$var$lf.length; e++)$0a0e7b9537100374$var$D($0a0e7b9537100374$var$lf[e], d);
                            break;
                        case "source":
                            $0a0e7b9537100374$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0a0e7b9537100374$var$D("error", d);
                            $0a0e7b9537100374$var$D("load", d);
                            break;
                        case "details":
                            $0a0e7b9537100374$var$D("toggle", d);
                            break;
                        case "input":
                            $0a0e7b9537100374$var$Za(d, f);
                            $0a0e7b9537100374$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0a0e7b9537100374$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0a0e7b9537100374$var$hb(d, f), $0a0e7b9537100374$var$D("invalid", d);
                    }
                    $0a0e7b9537100374$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0a0e7b9537100374$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0a0e7b9537100374$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0a0e7b9537100374$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0a0e7b9537100374$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0a0e7b9537100374$var$Va(d);
                            $0a0e7b9537100374$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0a0e7b9537100374$var$Va(d);
                            $0a0e7b9537100374$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0a0e7b9537100374$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0a0e7b9537100374$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0a0e7b9537100374$var$Of] = b;
                    a[$0a0e7b9537100374$var$Pf] = d;
                    $0a0e7b9537100374$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0a0e7b9537100374$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0a0e7b9537100374$var$D("cancel", a);
                                $0a0e7b9537100374$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0a0e7b9537100374$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0a0e7b9537100374$var$lf.length; e++)$0a0e7b9537100374$var$D($0a0e7b9537100374$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0a0e7b9537100374$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0a0e7b9537100374$var$D("error", a);
                                $0a0e7b9537100374$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0a0e7b9537100374$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0a0e7b9537100374$var$Za(a, d);
                                e = $0a0e7b9537100374$var$Ya(a, d);
                                $0a0e7b9537100374$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0a0e7b9537100374$var$A({}, d, {
                                    value: void 0
                                });
                                $0a0e7b9537100374$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0a0e7b9537100374$var$hb(a, d);
                                e = $0a0e7b9537100374$var$gb(a, d);
                                $0a0e7b9537100374$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0a0e7b9537100374$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0a0e7b9537100374$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0a0e7b9537100374$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0a0e7b9537100374$var$ob(a, k) : "number" === typeof k && $0a0e7b9537100374$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0a0e7b9537100374$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0a0e7b9537100374$var$D("scroll", a) : null != k && $0a0e7b9537100374$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0a0e7b9537100374$var$Va(a);
                                $0a0e7b9537100374$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0a0e7b9537100374$var$Va(a);
                                $0a0e7b9537100374$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0a0e7b9537100374$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0a0e7b9537100374$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0a0e7b9537100374$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0a0e7b9537100374$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0a0e7b9537100374$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0a0e7b9537100374$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0a0e7b9537100374$var$p(166));
                c = $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$wh.current);
                $0a0e7b9537100374$var$xh($0a0e7b9537100374$var$uh.current);
                if ($0a0e7b9537100374$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0a0e7b9537100374$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0a0e7b9537100374$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0a0e7b9537100374$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0a0e7b9537100374$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0a0e7b9537100374$var$Of] = b, b.stateNode = d;
            }
            $0a0e7b9537100374$var$S(b);
            return null;
        case 13:
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0a0e7b9537100374$var$I && null !== $0a0e7b9537100374$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0a0e7b9537100374$var$Hg(), $0a0e7b9537100374$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0a0e7b9537100374$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0a0e7b9537100374$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0a0e7b9537100374$var$p(317));
                        f[$0a0e7b9537100374$var$Of] = b;
                    } else $0a0e7b9537100374$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0a0e7b9537100374$var$S(b);
                    f = !1;
                } else null !== $0a0e7b9537100374$var$zg && ($0a0e7b9537100374$var$Fj($0a0e7b9537100374$var$zg), $0a0e7b9537100374$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0a0e7b9537100374$var$L.current & 1) ? 0 === $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$T = 3) : $0a0e7b9537100374$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0a0e7b9537100374$var$S(b);
            return null;
        case 4:
            return $0a0e7b9537100374$var$zh(), $0a0e7b9537100374$var$Aj(a, b), null === a && $0a0e7b9537100374$var$sf(b.stateNode.containerInfo), $0a0e7b9537100374$var$S(b), null;
        case 10:
            return $0a0e7b9537100374$var$ah(b.type._context), $0a0e7b9537100374$var$S(b), null;
        case 17:
            return $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$$f(), $0a0e7b9537100374$var$S(b), null;
        case 19:
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
            f = b.memoizedState;
            if (null === f) return $0a0e7b9537100374$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0a0e7b9537100374$var$Dj(f, !1);
                else {
                    if (0 !== $0a0e7b9537100374$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0a0e7b9537100374$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0a0e7b9537100374$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, $0a0e7b9537100374$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0a0e7b9537100374$var$B() > $0a0e7b9537100374$var$Gj && (b.flags |= 128, d = !0, $0a0e7b9537100374$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0a0e7b9537100374$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0a0e7b9537100374$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0a0e7b9537100374$var$I) return $0a0e7b9537100374$var$S(b), null;
                    } else 2 * $0a0e7b9537100374$var$B() - f.renderingStartTime > $0a0e7b9537100374$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0a0e7b9537100374$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0a0e7b9537100374$var$B(), b.sibling = null, c = $0a0e7b9537100374$var$L.current, $0a0e7b9537100374$var$G($0a0e7b9537100374$var$L, d ? c & 1 | 2 : c & 1), b;
            $0a0e7b9537100374$var$S(b);
            return null;
        case 22:
        case 23:
            return $0a0e7b9537100374$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0a0e7b9537100374$var$fj & 1073741824) && ($0a0e7b9537100374$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0a0e7b9537100374$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0a0e7b9537100374$var$p(156, b.tag));
}
function $0a0e7b9537100374$var$Ij(a, b) {
    $0a0e7b9537100374$var$wg(b);
    switch(b.tag){
        case 1:
            return $0a0e7b9537100374$var$Zf(b.type) && $0a0e7b9537100374$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0a0e7b9537100374$var$zh(), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf), $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H), $0a0e7b9537100374$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0a0e7b9537100374$var$Bh(b), null;
        case 13:
            $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0a0e7b9537100374$var$p(340));
                $0a0e7b9537100374$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L), null;
        case 4:
            return $0a0e7b9537100374$var$zh(), null;
        case 10:
            return $0a0e7b9537100374$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0a0e7b9537100374$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0a0e7b9537100374$var$Jj = !1, $0a0e7b9537100374$var$U = !1, $0a0e7b9537100374$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0a0e7b9537100374$var$V = null;
function $0a0e7b9537100374$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0a0e7b9537100374$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0a0e7b9537100374$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0a0e7b9537100374$var$W(a, b, d);
    }
}
var $0a0e7b9537100374$var$Nj = !1;
function $0a0e7b9537100374$var$Oj(a, b) {
    $0a0e7b9537100374$var$Cf = $0a0e7b9537100374$var$dd;
    a = $0a0e7b9537100374$var$Me();
    if ($0a0e7b9537100374$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0a0e7b9537100374$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0a0e7b9537100374$var$dd = !1;
    for($0a0e7b9537100374$var$V = b; null !== $0a0e7b9537100374$var$V;)if (b = $0a0e7b9537100374$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0a0e7b9537100374$var$V = a;
    else for(; null !== $0a0e7b9537100374$var$V;){
        b = $0a0e7b9537100374$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0a0e7b9537100374$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0a0e7b9537100374$var$p(163));
            }
        } catch (F) {
            $0a0e7b9537100374$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0a0e7b9537100374$var$V = a;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
    n = $0a0e7b9537100374$var$Nj;
    $0a0e7b9537100374$var$Nj = !1;
    return n;
}
function $0a0e7b9537100374$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0a0e7b9537100374$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0a0e7b9537100374$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0a0e7b9537100374$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0a0e7b9537100374$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0a0e7b9537100374$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0a0e7b9537100374$var$Of], delete b[$0a0e7b9537100374$var$Pf], delete b[$0a0e7b9537100374$var$of], delete b[$0a0e7b9537100374$var$Qf], delete b[$0a0e7b9537100374$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0a0e7b9537100374$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0a0e7b9537100374$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0a0e7b9537100374$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0a0e7b9537100374$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0a0e7b9537100374$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0a0e7b9537100374$var$Vj(a, b, c), a = a.sibling; null !== a;)$0a0e7b9537100374$var$Vj(a, b, c), a = a.sibling;
}
function $0a0e7b9537100374$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0a0e7b9537100374$var$Wj(a, b, c), a = a.sibling; null !== a;)$0a0e7b9537100374$var$Wj(a, b, c), a = a.sibling;
}
var $0a0e7b9537100374$var$X = null, $0a0e7b9537100374$var$Xj = !1;
function $0a0e7b9537100374$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0a0e7b9537100374$var$Zj(a, b, c), c = c.sibling;
}
function $0a0e7b9537100374$var$Zj(a, b, c) {
    if ($0a0e7b9537100374$var$lc && "function" === typeof $0a0e7b9537100374$var$lc.onCommitFiberUnmount) try {
        $0a0e7b9537100374$var$lc.onCommitFiberUnmount($0a0e7b9537100374$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0a0e7b9537100374$var$U || $0a0e7b9537100374$var$Lj(c, b);
        case 6:
            var d = $0a0e7b9537100374$var$X, e = $0a0e7b9537100374$var$Xj;
            $0a0e7b9537100374$var$X = null;
            $0a0e7b9537100374$var$Yj(a, b, c);
            $0a0e7b9537100374$var$X = d;
            $0a0e7b9537100374$var$Xj = e;
            null !== $0a0e7b9537100374$var$X && ($0a0e7b9537100374$var$Xj ? (a = $0a0e7b9537100374$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0a0e7b9537100374$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0a0e7b9537100374$var$X && ($0a0e7b9537100374$var$Xj ? (a = $0a0e7b9537100374$var$X, c = c.stateNode, 8 === a.nodeType ? $0a0e7b9537100374$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0a0e7b9537100374$var$Kf(a, c), $0a0e7b9537100374$var$bd(a)) : $0a0e7b9537100374$var$Kf($0a0e7b9537100374$var$X, c.stateNode));
            break;
        case 4:
            d = $0a0e7b9537100374$var$X;
            e = $0a0e7b9537100374$var$Xj;
            $0a0e7b9537100374$var$X = c.stateNode.containerInfo;
            $0a0e7b9537100374$var$Xj = !0;
            $0a0e7b9537100374$var$Yj(a, b, c);
            $0a0e7b9537100374$var$X = d;
            $0a0e7b9537100374$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0a0e7b9537100374$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0a0e7b9537100374$var$Mj(c, b, g) : 0 !== (f & 4) && $0a0e7b9537100374$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0a0e7b9537100374$var$U && ($0a0e7b9537100374$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0a0e7b9537100374$var$W(c, b, h);
            }
            $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        case 21:
            $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0a0e7b9537100374$var$U = (d = $0a0e7b9537100374$var$U) || null !== c.memoizedState, $0a0e7b9537100374$var$Yj(a, b, c), $0a0e7b9537100374$var$U = d) : $0a0e7b9537100374$var$Yj(a, b, c);
            break;
        default:
            $0a0e7b9537100374$var$Yj(a, b, c);
    }
}
function $0a0e7b9537100374$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0a0e7b9537100374$var$Kj);
        b.forEach(function(b) {
            var d = $0a0e7b9537100374$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0a0e7b9537100374$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0a0e7b9537100374$var$X = h.stateNode;
                        $0a0e7b9537100374$var$Xj = !1;
                        break a;
                    case 3:
                        $0a0e7b9537100374$var$X = h.stateNode.containerInfo;
                        $0a0e7b9537100374$var$Xj = !0;
                        break a;
                    case 4:
                        $0a0e7b9537100374$var$X = h.stateNode.containerInfo;
                        $0a0e7b9537100374$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0a0e7b9537100374$var$X) throw Error($0a0e7b9537100374$var$p(160));
            $0a0e7b9537100374$var$Zj(f, g, e);
            $0a0e7b9537100374$var$X = null;
            $0a0e7b9537100374$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0a0e7b9537100374$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0a0e7b9537100374$var$dk(b, a), b = b.sibling;
}
function $0a0e7b9537100374$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 4) {
                try {
                    $0a0e7b9537100374$var$Pj(3, a, a.return), $0a0e7b9537100374$var$Qj(3, a);
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
                try {
                    $0a0e7b9537100374$var$Pj(5, a, a.return);
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            d & 512 && null !== c && $0a0e7b9537100374$var$Lj(c, c.return);
            break;
        case 5:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            d & 512 && null !== c && $0a0e7b9537100374$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0a0e7b9537100374$var$ob(e, "");
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0a0e7b9537100374$var$ab(e, f);
                    $0a0e7b9537100374$var$vb(h, g);
                    var l = $0a0e7b9537100374$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0a0e7b9537100374$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0a0e7b9537100374$var$nb(e, q) : "children" === m ? $0a0e7b9537100374$var$ob(e, q) : $0a0e7b9537100374$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0a0e7b9537100374$var$bb(e, f);
                            break;
                        case "textarea":
                            $0a0e7b9537100374$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0a0e7b9537100374$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0a0e7b9537100374$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0a0e7b9537100374$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0a0e7b9537100374$var$Pf] = f;
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0a0e7b9537100374$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0a0e7b9537100374$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0a0e7b9537100374$var$bd(b.containerInfo);
            } catch (t) {
                $0a0e7b9537100374$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            break;
        case 13:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0a0e7b9537100374$var$fk = $0a0e7b9537100374$var$B()));
            d & 4 && $0a0e7b9537100374$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0a0e7b9537100374$var$U = (l = $0a0e7b9537100374$var$U) || m, $0a0e7b9537100374$var$ck(b, a), $0a0e7b9537100374$var$U = l) : $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0a0e7b9537100374$var$V = a, m = a.child; null !== m;){
                    for(q = $0a0e7b9537100374$var$V = m; null !== $0a0e7b9537100374$var$V;){
                        r = $0a0e7b9537100374$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0a0e7b9537100374$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0a0e7b9537100374$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0a0e7b9537100374$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0a0e7b9537100374$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0a0e7b9537100374$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0a0e7b9537100374$var$V = y) : $0a0e7b9537100374$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0a0e7b9537100374$var$rb("display", g));
                            } catch (t) {
                                $0a0e7b9537100374$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0a0e7b9537100374$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0a0e7b9537100374$var$ck(b, a);
            $0a0e7b9537100374$var$ek(a);
            d & 4 && $0a0e7b9537100374$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0a0e7b9537100374$var$ck(b, a), $0a0e7b9537100374$var$ek(a);
    }
}
function $0a0e7b9537100374$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0a0e7b9537100374$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0a0e7b9537100374$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0a0e7b9537100374$var$ob(e, ""), d.flags &= -33);
                    var f = $0a0e7b9537100374$var$Uj(a);
                    $0a0e7b9537100374$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0a0e7b9537100374$var$Uj(a);
                    $0a0e7b9537100374$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0a0e7b9537100374$var$p(161));
            }
        } catch (k) {
            $0a0e7b9537100374$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0a0e7b9537100374$var$hk(a, b, c) {
    $0a0e7b9537100374$var$V = a;
    $0a0e7b9537100374$var$ik(a, b, c);
}
function $0a0e7b9537100374$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0a0e7b9537100374$var$V;){
        var e = $0a0e7b9537100374$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0a0e7b9537100374$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0a0e7b9537100374$var$U;
                h = $0a0e7b9537100374$var$Jj;
                var l = $0a0e7b9537100374$var$U;
                $0a0e7b9537100374$var$Jj = g;
                if (($0a0e7b9537100374$var$U = k) && !l) for($0a0e7b9537100374$var$V = e; null !== $0a0e7b9537100374$var$V;)g = $0a0e7b9537100374$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0a0e7b9537100374$var$jk(e) : null !== k ? (k.return = g, $0a0e7b9537100374$var$V = k) : $0a0e7b9537100374$var$jk(e);
                for(; null !== f;)$0a0e7b9537100374$var$V = f, $0a0e7b9537100374$var$ik(f, b, c), f = f.sibling;
                $0a0e7b9537100374$var$V = e;
                $0a0e7b9537100374$var$Jj = h;
                $0a0e7b9537100374$var$U = l;
            }
            $0a0e7b9537100374$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0a0e7b9537100374$var$V = f) : $0a0e7b9537100374$var$kk(a, b, c);
    }
}
function $0a0e7b9537100374$var$kk(a) {
    for(; null !== $0a0e7b9537100374$var$V;){
        var b = $0a0e7b9537100374$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0a0e7b9537100374$var$U || $0a0e7b9537100374$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0a0e7b9537100374$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0a0e7b9537100374$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0a0e7b9537100374$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0a0e7b9537100374$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0a0e7b9537100374$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0a0e7b9537100374$var$p(163));
                }
                $0a0e7b9537100374$var$U || b.flags & 512 && $0a0e7b9537100374$var$Rj(b);
            } catch (r) {
                $0a0e7b9537100374$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0a0e7b9537100374$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0a0e7b9537100374$var$V = c;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
}
function $0a0e7b9537100374$var$gk(a) {
    for(; null !== $0a0e7b9537100374$var$V;){
        var b = $0a0e7b9537100374$var$V;
        if (b === a) {
            $0a0e7b9537100374$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0a0e7b9537100374$var$V = c;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
}
function $0a0e7b9537100374$var$jk(a) {
    for(; null !== $0a0e7b9537100374$var$V;){
        var b = $0a0e7b9537100374$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0a0e7b9537100374$var$Qj(4, b);
                    } catch (k) {
                        $0a0e7b9537100374$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0a0e7b9537100374$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0a0e7b9537100374$var$Rj(b);
                    } catch (k) {
                        $0a0e7b9537100374$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0a0e7b9537100374$var$Rj(b);
                    } catch (k) {
                        $0a0e7b9537100374$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0a0e7b9537100374$var$W(b, b.return, k);
        }
        if (b === a) {
            $0a0e7b9537100374$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0a0e7b9537100374$var$V = h;
            break;
        }
        $0a0e7b9537100374$var$V = b.return;
    }
}
var $0a0e7b9537100374$var$lk = Math.ceil, $0a0e7b9537100374$var$mk = $0a0e7b9537100374$var$ua.ReactCurrentDispatcher, $0a0e7b9537100374$var$nk = $0a0e7b9537100374$var$ua.ReactCurrentOwner, $0a0e7b9537100374$var$ok = $0a0e7b9537100374$var$ua.ReactCurrentBatchConfig, $0a0e7b9537100374$var$K = 0, $0a0e7b9537100374$var$Q = null, $0a0e7b9537100374$var$Y = null, $0a0e7b9537100374$var$Z = 0, $0a0e7b9537100374$var$fj = 0, $0a0e7b9537100374$var$ej = $0a0e7b9537100374$var$Uf(0), $0a0e7b9537100374$var$T = 0, $0a0e7b9537100374$var$pk = null, $0a0e7b9537100374$var$rh = 0, $0a0e7b9537100374$var$qk = 0, $0a0e7b9537100374$var$rk = 0, $0a0e7b9537100374$var$sk = null, $0a0e7b9537100374$var$tk = null, $0a0e7b9537100374$var$fk = 0, $0a0e7b9537100374$var$Gj = Infinity, $0a0e7b9537100374$var$uk = null, $0a0e7b9537100374$var$Oi = !1, $0a0e7b9537100374$var$Pi = null, $0a0e7b9537100374$var$Ri = null, $0a0e7b9537100374$var$vk = !1, $0a0e7b9537100374$var$wk = null, $0a0e7b9537100374$var$xk = 0, $0a0e7b9537100374$var$yk = 0, $0a0e7b9537100374$var$zk = null, $0a0e7b9537100374$var$Ak = -1, $0a0e7b9537100374$var$Bk = 0;
function $0a0e7b9537100374$var$R() {
    return 0 !== ($0a0e7b9537100374$var$K & 6) ? $0a0e7b9537100374$var$B() : -1 !== $0a0e7b9537100374$var$Ak ? $0a0e7b9537100374$var$Ak : $0a0e7b9537100374$var$Ak = $0a0e7b9537100374$var$B();
}
function $0a0e7b9537100374$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0a0e7b9537100374$var$K & 2) && 0 !== $0a0e7b9537100374$var$Z) return $0a0e7b9537100374$var$Z & -$0a0e7b9537100374$var$Z;
    if (null !== $0a0e7b9537100374$var$Kg.transition) return 0 === $0a0e7b9537100374$var$Bk && ($0a0e7b9537100374$var$Bk = $0a0e7b9537100374$var$yc()), $0a0e7b9537100374$var$Bk;
    a = $0a0e7b9537100374$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0a0e7b9537100374$var$jd(a.type);
    return a;
}
function $0a0e7b9537100374$var$gi(a, b, c, d) {
    if (50 < $0a0e7b9537100374$var$yk) throw $0a0e7b9537100374$var$yk = 0, $0a0e7b9537100374$var$zk = null, Error($0a0e7b9537100374$var$p(185));
    $0a0e7b9537100374$var$Ac(a, c, d);
    if (0 === ($0a0e7b9537100374$var$K & 2) || a !== $0a0e7b9537100374$var$Q) a === $0a0e7b9537100374$var$Q && (0 === ($0a0e7b9537100374$var$K & 2) && ($0a0e7b9537100374$var$qk |= c), 4 === $0a0e7b9537100374$var$T && $0a0e7b9537100374$var$Ck(a, $0a0e7b9537100374$var$Z)), $0a0e7b9537100374$var$Dk(a, d), 1 === c && 0 === $0a0e7b9537100374$var$K && 0 === (b.mode & 1) && ($0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$fg && $0a0e7b9537100374$var$jg());
}
function $0a0e7b9537100374$var$Dk(a, b) {
    var c = a.callbackNode;
    $0a0e7b9537100374$var$wc(a, b);
    var d = $0a0e7b9537100374$var$uc(a, a === $0a0e7b9537100374$var$Q ? $0a0e7b9537100374$var$Z : 0);
    if (0 === d) null !== c && $0a0e7b9537100374$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0a0e7b9537100374$var$bc(c);
        if (1 === b) 0 === a.tag ? $0a0e7b9537100374$var$ig($0a0e7b9537100374$var$Ek.bind(null, a)) : $0a0e7b9537100374$var$hg($0a0e7b9537100374$var$Ek.bind(null, a)), $0a0e7b9537100374$var$Jf(function() {
            0 === ($0a0e7b9537100374$var$K & 6) && $0a0e7b9537100374$var$jg();
        }), c = null;
        else {
            switch($0a0e7b9537100374$var$Dc(d)){
                case 1:
                    c = $0a0e7b9537100374$var$fc;
                    break;
                case 4:
                    c = $0a0e7b9537100374$var$gc;
                    break;
                case 16:
                    c = $0a0e7b9537100374$var$hc;
                    break;
                case 536870912:
                    c = $0a0e7b9537100374$var$jc;
                    break;
                default:
                    c = $0a0e7b9537100374$var$hc;
            }
            c = $0a0e7b9537100374$var$Fk(c, $0a0e7b9537100374$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0a0e7b9537100374$var$Gk(a, b) {
    $0a0e7b9537100374$var$Ak = -1;
    $0a0e7b9537100374$var$Bk = 0;
    if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(327));
    var c = a.callbackNode;
    if ($0a0e7b9537100374$var$Hk() && a.callbackNode !== c) return null;
    var d = $0a0e7b9537100374$var$uc(a, a === $0a0e7b9537100374$var$Q ? $0a0e7b9537100374$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0a0e7b9537100374$var$Ik(a, d);
    else {
        b = d;
        var e = $0a0e7b9537100374$var$K;
        $0a0e7b9537100374$var$K |= 2;
        var f = $0a0e7b9537100374$var$Jk();
        if ($0a0e7b9537100374$var$Q !== a || $0a0e7b9537100374$var$Z !== b) $0a0e7b9537100374$var$uk = null, $0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$Kk(a, b);
        for(;;)try {
            $0a0e7b9537100374$var$Lk();
            break;
        } catch (h) {
            $0a0e7b9537100374$var$Mk(a, h);
        }
        $0a0e7b9537100374$var$$g();
        $0a0e7b9537100374$var$mk.current = f;
        $0a0e7b9537100374$var$K = e;
        null !== $0a0e7b9537100374$var$Y ? b = 0 : ($0a0e7b9537100374$var$Q = null, $0a0e7b9537100374$var$Z = 0, b = $0a0e7b9537100374$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0a0e7b9537100374$var$xc(a), 0 !== e && (d = e, b = $0a0e7b9537100374$var$Nk(a, e)));
        if (1 === b) throw c = $0a0e7b9537100374$var$pk, $0a0e7b9537100374$var$Kk(a, 0), $0a0e7b9537100374$var$Ck(a, d), $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), c;
        if (6 === b) $0a0e7b9537100374$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0a0e7b9537100374$var$Ok(e) && (b = $0a0e7b9537100374$var$Ik(a, d), 2 === b && (f = $0a0e7b9537100374$var$xc(a), 0 !== f && (d = f, b = $0a0e7b9537100374$var$Nk(a, f))), 1 === b)) throw c = $0a0e7b9537100374$var$pk, $0a0e7b9537100374$var$Kk(a, 0), $0a0e7b9537100374$var$Ck(a, d), $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0a0e7b9537100374$var$p(345));
                case 2:
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                case 3:
                    $0a0e7b9537100374$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0a0e7b9537100374$var$fk + 500 - $0a0e7b9537100374$var$B(), 10 < b)) {
                        if (0 !== $0a0e7b9537100374$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0a0e7b9537100374$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0a0e7b9537100374$var$Ff($0a0e7b9537100374$var$Pk.bind(null, a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk), b);
                        break;
                    }
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                case 4:
                    $0a0e7b9537100374$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0a0e7b9537100374$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0a0e7b9537100374$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0a0e7b9537100374$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0a0e7b9537100374$var$Ff($0a0e7b9537100374$var$Pk.bind(null, a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk), d);
                        break;
                    }
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                case 5:
                    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
                    break;
                default:
                    throw Error($0a0e7b9537100374$var$p(329));
            }
        }
    }
    $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B());
    return a.callbackNode === c ? $0a0e7b9537100374$var$Gk.bind(null, a) : null;
}
function $0a0e7b9537100374$var$Nk(a, b) {
    var c = $0a0e7b9537100374$var$sk;
    a.current.memoizedState.isDehydrated && ($0a0e7b9537100374$var$Kk(a, b).flags |= 256);
    a = $0a0e7b9537100374$var$Ik(a, b);
    2 !== a && (b = $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$tk = c, null !== b && $0a0e7b9537100374$var$Fj(b));
    return a;
}
function $0a0e7b9537100374$var$Fj(a) {
    null === $0a0e7b9537100374$var$tk ? $0a0e7b9537100374$var$tk = a : $0a0e7b9537100374$var$tk.push.apply($0a0e7b9537100374$var$tk, a);
}
function $0a0e7b9537100374$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0a0e7b9537100374$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0a0e7b9537100374$var$Ck(a, b) {
    b &= ~$0a0e7b9537100374$var$rk;
    b &= ~$0a0e7b9537100374$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0a0e7b9537100374$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0a0e7b9537100374$var$Ek(a) {
    if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(327));
    $0a0e7b9537100374$var$Hk();
    var b = $0a0e7b9537100374$var$uc(a, 0);
    if (0 === (b & 1)) return $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), null;
    var c = $0a0e7b9537100374$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0a0e7b9537100374$var$xc(a);
        0 !== d && (b = d, c = $0a0e7b9537100374$var$Nk(a, d));
    }
    if (1 === c) throw c = $0a0e7b9537100374$var$pk, $0a0e7b9537100374$var$Kk(a, 0), $0a0e7b9537100374$var$Ck(a, b), $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B()), c;
    if (6 === c) throw Error($0a0e7b9537100374$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0a0e7b9537100374$var$Pk(a, $0a0e7b9537100374$var$tk, $0a0e7b9537100374$var$uk);
    $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B());
    return null;
}
function $0a0e7b9537100374$var$Qk(a, b) {
    var c = $0a0e7b9537100374$var$K;
    $0a0e7b9537100374$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0a0e7b9537100374$var$K = c, 0 === $0a0e7b9537100374$var$K && ($0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$fg && $0a0e7b9537100374$var$jg());
    }
}
function $0a0e7b9537100374$var$Rk(a) {
    null !== $0a0e7b9537100374$var$wk && 0 === $0a0e7b9537100374$var$wk.tag && 0 === ($0a0e7b9537100374$var$K & 6) && $0a0e7b9537100374$var$Hk();
    var b = $0a0e7b9537100374$var$K;
    $0a0e7b9537100374$var$K |= 1;
    var c = $0a0e7b9537100374$var$ok.transition, d = $0a0e7b9537100374$var$C;
    try {
        if ($0a0e7b9537100374$var$ok.transition = null, $0a0e7b9537100374$var$C = 1, a) return a();
    } finally{
        $0a0e7b9537100374$var$C = d, $0a0e7b9537100374$var$ok.transition = c, $0a0e7b9537100374$var$K = b, 0 === ($0a0e7b9537100374$var$K & 6) && $0a0e7b9537100374$var$jg();
    }
}
function $0a0e7b9537100374$var$Hj() {
    $0a0e7b9537100374$var$fj = $0a0e7b9537100374$var$ej.current;
    $0a0e7b9537100374$var$E($0a0e7b9537100374$var$ej);
}
function $0a0e7b9537100374$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0a0e7b9537100374$var$Gf(c));
    if (null !== $0a0e7b9537100374$var$Y) for(c = $0a0e7b9537100374$var$Y.return; null !== c;){
        var d = c;
        $0a0e7b9537100374$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0a0e7b9537100374$var$$f();
                break;
            case 3:
                $0a0e7b9537100374$var$zh();
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$Wf);
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$H);
                $0a0e7b9537100374$var$Eh();
                break;
            case 5:
                $0a0e7b9537100374$var$Bh(d);
                break;
            case 4:
                $0a0e7b9537100374$var$zh();
                break;
            case 13:
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
                break;
            case 19:
                $0a0e7b9537100374$var$E($0a0e7b9537100374$var$L);
                break;
            case 10:
                $0a0e7b9537100374$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0a0e7b9537100374$var$Hj();
        }
        c = c.return;
    }
    $0a0e7b9537100374$var$Q = a;
    $0a0e7b9537100374$var$Y = a = $0a0e7b9537100374$var$Pg(a.current, null);
    $0a0e7b9537100374$var$Z = $0a0e7b9537100374$var$fj = b;
    $0a0e7b9537100374$var$T = 0;
    $0a0e7b9537100374$var$pk = null;
    $0a0e7b9537100374$var$rk = $0a0e7b9537100374$var$qk = $0a0e7b9537100374$var$rh = 0;
    $0a0e7b9537100374$var$tk = $0a0e7b9537100374$var$sk = null;
    if (null !== $0a0e7b9537100374$var$fh) {
        for(b = 0; b < $0a0e7b9537100374$var$fh.length; b++)if (c = $0a0e7b9537100374$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0a0e7b9537100374$var$fh = null;
    }
    return a;
}
function $0a0e7b9537100374$var$Mk(a, b) {
    do {
        var c = $0a0e7b9537100374$var$Y;
        try {
            $0a0e7b9537100374$var$$g();
            $0a0e7b9537100374$var$Fh.current = $0a0e7b9537100374$var$Rh;
            if ($0a0e7b9537100374$var$Ih) {
                for(var d = $0a0e7b9537100374$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0a0e7b9537100374$var$Ih = !1;
            }
            $0a0e7b9537100374$var$Hh = 0;
            $0a0e7b9537100374$var$O = $0a0e7b9537100374$var$N = $0a0e7b9537100374$var$M = null;
            $0a0e7b9537100374$var$Jh = !1;
            $0a0e7b9537100374$var$Kh = 0;
            $0a0e7b9537100374$var$nk.current = null;
            if (null === c || null === c.return) {
                $0a0e7b9537100374$var$T = 1;
                $0a0e7b9537100374$var$pk = b;
                $0a0e7b9537100374$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0a0e7b9537100374$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0a0e7b9537100374$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0a0e7b9537100374$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0a0e7b9537100374$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0a0e7b9537100374$var$Si(f, l, b);
                            $0a0e7b9537100374$var$tj();
                            break a;
                        }
                        k = Error($0a0e7b9537100374$var$p(426));
                    }
                } else if ($0a0e7b9537100374$var$I && h.mode & 1) {
                    var J = $0a0e7b9537100374$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0a0e7b9537100374$var$Vi(J, g, h, f, b);
                        $0a0e7b9537100374$var$Jg($0a0e7b9537100374$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0a0e7b9537100374$var$Ji(k, h);
                4 !== $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$T = 2);
                null === $0a0e7b9537100374$var$sk ? $0a0e7b9537100374$var$sk = [
                    f
                ] : $0a0e7b9537100374$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0a0e7b9537100374$var$Ni(f, k, b);
                            $0a0e7b9537100374$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0a0e7b9537100374$var$Ri || !$0a0e7b9537100374$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0a0e7b9537100374$var$Qi(f, h, b);
                                $0a0e7b9537100374$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0a0e7b9537100374$var$Sk(c);
        } catch (na) {
            b = na;
            $0a0e7b9537100374$var$Y === c && null !== c && ($0a0e7b9537100374$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0a0e7b9537100374$var$Jk() {
    var a = $0a0e7b9537100374$var$mk.current;
    $0a0e7b9537100374$var$mk.current = $0a0e7b9537100374$var$Rh;
    return null === a ? $0a0e7b9537100374$var$Rh : a;
}
function $0a0e7b9537100374$var$tj() {
    if (0 === $0a0e7b9537100374$var$T || 3 === $0a0e7b9537100374$var$T || 2 === $0a0e7b9537100374$var$T) $0a0e7b9537100374$var$T = 4;
    null === $0a0e7b9537100374$var$Q || 0 === ($0a0e7b9537100374$var$rh & 268435455) && 0 === ($0a0e7b9537100374$var$qk & 268435455) || $0a0e7b9537100374$var$Ck($0a0e7b9537100374$var$Q, $0a0e7b9537100374$var$Z);
}
function $0a0e7b9537100374$var$Ik(a, b) {
    var c = $0a0e7b9537100374$var$K;
    $0a0e7b9537100374$var$K |= 2;
    var d = $0a0e7b9537100374$var$Jk();
    if ($0a0e7b9537100374$var$Q !== a || $0a0e7b9537100374$var$Z !== b) $0a0e7b9537100374$var$uk = null, $0a0e7b9537100374$var$Kk(a, b);
    for(;;)try {
        $0a0e7b9537100374$var$Tk();
        break;
    } catch (e) {
        $0a0e7b9537100374$var$Mk(a, e);
    }
    $0a0e7b9537100374$var$$g();
    $0a0e7b9537100374$var$K = c;
    $0a0e7b9537100374$var$mk.current = d;
    if (null !== $0a0e7b9537100374$var$Y) throw Error($0a0e7b9537100374$var$p(261));
    $0a0e7b9537100374$var$Q = null;
    $0a0e7b9537100374$var$Z = 0;
    return $0a0e7b9537100374$var$T;
}
function $0a0e7b9537100374$var$Tk() {
    for(; null !== $0a0e7b9537100374$var$Y;)$0a0e7b9537100374$var$Uk($0a0e7b9537100374$var$Y);
}
function $0a0e7b9537100374$var$Lk() {
    for(; null !== $0a0e7b9537100374$var$Y && !$0a0e7b9537100374$var$cc();)$0a0e7b9537100374$var$Uk($0a0e7b9537100374$var$Y);
}
function $0a0e7b9537100374$var$Uk(a) {
    var b = $0a0e7b9537100374$var$Vk(a.alternate, a, $0a0e7b9537100374$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0a0e7b9537100374$var$Sk(a) : $0a0e7b9537100374$var$Y = b;
    $0a0e7b9537100374$var$nk.current = null;
}
function $0a0e7b9537100374$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0a0e7b9537100374$var$Ej(c, b, $0a0e7b9537100374$var$fj), null !== c) {
                $0a0e7b9537100374$var$Y = c;
                return;
            }
        } else {
            c = $0a0e7b9537100374$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0a0e7b9537100374$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0a0e7b9537100374$var$T = 6;
                $0a0e7b9537100374$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0a0e7b9537100374$var$Y = b;
            return;
        }
        $0a0e7b9537100374$var$Y = b = a;
    }while (null !== b);
    0 === $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$T = 5);
}
function $0a0e7b9537100374$var$Pk(a, b, c) {
    var d = $0a0e7b9537100374$var$C, e = $0a0e7b9537100374$var$ok.transition;
    try {
        $0a0e7b9537100374$var$ok.transition = null, $0a0e7b9537100374$var$C = 1, $0a0e7b9537100374$var$Wk(a, b, c, d);
    } finally{
        $0a0e7b9537100374$var$ok.transition = e, $0a0e7b9537100374$var$C = d;
    }
    return null;
}
function $0a0e7b9537100374$var$Wk(a, b, c, d) {
    do $0a0e7b9537100374$var$Hk();
    while (null !== $0a0e7b9537100374$var$wk);
    if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0a0e7b9537100374$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0a0e7b9537100374$var$Bc(a, f);
    a === $0a0e7b9537100374$var$Q && ($0a0e7b9537100374$var$Y = $0a0e7b9537100374$var$Q = null, $0a0e7b9537100374$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0a0e7b9537100374$var$vk || ($0a0e7b9537100374$var$vk = !0, $0a0e7b9537100374$var$Fk($0a0e7b9537100374$var$hc, function() {
        $0a0e7b9537100374$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0a0e7b9537100374$var$ok.transition;
        $0a0e7b9537100374$var$ok.transition = null;
        var g = $0a0e7b9537100374$var$C;
        $0a0e7b9537100374$var$C = 1;
        var h = $0a0e7b9537100374$var$K;
        $0a0e7b9537100374$var$K |= 4;
        $0a0e7b9537100374$var$nk.current = null;
        $0a0e7b9537100374$var$Oj(a, c);
        $0a0e7b9537100374$var$dk(c, a);
        $0a0e7b9537100374$var$Oe($0a0e7b9537100374$var$Df);
        $0a0e7b9537100374$var$dd = !!$0a0e7b9537100374$var$Cf;
        $0a0e7b9537100374$var$Df = $0a0e7b9537100374$var$Cf = null;
        a.current = c;
        $0a0e7b9537100374$var$hk(c, a, e);
        $0a0e7b9537100374$var$dc();
        $0a0e7b9537100374$var$K = h;
        $0a0e7b9537100374$var$C = g;
        $0a0e7b9537100374$var$ok.transition = f;
    } else a.current = c;
    $0a0e7b9537100374$var$vk && ($0a0e7b9537100374$var$vk = !1, $0a0e7b9537100374$var$wk = a, $0a0e7b9537100374$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0a0e7b9537100374$var$Ri = null);
    $0a0e7b9537100374$var$mc(c.stateNode, d);
    $0a0e7b9537100374$var$Dk(a, $0a0e7b9537100374$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0a0e7b9537100374$var$Oi) throw $0a0e7b9537100374$var$Oi = !1, a = $0a0e7b9537100374$var$Pi, $0a0e7b9537100374$var$Pi = null, a;
    0 !== ($0a0e7b9537100374$var$xk & 1) && 0 !== a.tag && $0a0e7b9537100374$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0a0e7b9537100374$var$zk ? $0a0e7b9537100374$var$yk++ : ($0a0e7b9537100374$var$yk = 0, $0a0e7b9537100374$var$zk = a) : $0a0e7b9537100374$var$yk = 0;
    $0a0e7b9537100374$var$jg();
    return null;
}
function $0a0e7b9537100374$var$Hk() {
    if (null !== $0a0e7b9537100374$var$wk) {
        var a = $0a0e7b9537100374$var$Dc($0a0e7b9537100374$var$xk), b = $0a0e7b9537100374$var$ok.transition, c = $0a0e7b9537100374$var$C;
        try {
            $0a0e7b9537100374$var$ok.transition = null;
            $0a0e7b9537100374$var$C = 16 > a ? 16 : a;
            if (null === $0a0e7b9537100374$var$wk) var d = !1;
            else {
                a = $0a0e7b9537100374$var$wk;
                $0a0e7b9537100374$var$wk = null;
                $0a0e7b9537100374$var$xk = 0;
                if (0 !== ($0a0e7b9537100374$var$K & 6)) throw Error($0a0e7b9537100374$var$p(331));
                var e = $0a0e7b9537100374$var$K;
                $0a0e7b9537100374$var$K |= 4;
                for($0a0e7b9537100374$var$V = a.current; null !== $0a0e7b9537100374$var$V;){
                    var f = $0a0e7b9537100374$var$V, g = f.child;
                    if (0 !== ($0a0e7b9537100374$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0a0e7b9537100374$var$V = l; null !== $0a0e7b9537100374$var$V;){
                                    var m = $0a0e7b9537100374$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0a0e7b9537100374$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0a0e7b9537100374$var$V = q;
                                    else for(; null !== $0a0e7b9537100374$var$V;){
                                        m = $0a0e7b9537100374$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0a0e7b9537100374$var$Sj(m);
                                        if (m === l) {
                                            $0a0e7b9537100374$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0a0e7b9537100374$var$V = r;
                                            break;
                                        }
                                        $0a0e7b9537100374$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0a0e7b9537100374$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0a0e7b9537100374$var$V = g;
                    else b: for(; null !== $0a0e7b9537100374$var$V;){
                        f = $0a0e7b9537100374$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0a0e7b9537100374$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0a0e7b9537100374$var$V = x;
                            break b;
                        }
                        $0a0e7b9537100374$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0a0e7b9537100374$var$V = w; null !== $0a0e7b9537100374$var$V;){
                    g = $0a0e7b9537100374$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0a0e7b9537100374$var$V = u;
                    else b: for(g = w; null !== $0a0e7b9537100374$var$V;){
                        h = $0a0e7b9537100374$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0a0e7b9537100374$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0a0e7b9537100374$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0a0e7b9537100374$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0a0e7b9537100374$var$V = F;
                            break b;
                        }
                        $0a0e7b9537100374$var$V = h.return;
                    }
                }
                $0a0e7b9537100374$var$K = e;
                $0a0e7b9537100374$var$jg();
                if ($0a0e7b9537100374$var$lc && "function" === typeof $0a0e7b9537100374$var$lc.onPostCommitFiberRoot) try {
                    $0a0e7b9537100374$var$lc.onPostCommitFiberRoot($0a0e7b9537100374$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0a0e7b9537100374$var$C = c, $0a0e7b9537100374$var$ok.transition = b;
        }
    }
    return !1;
}
function $0a0e7b9537100374$var$Xk(a, b, c) {
    b = $0a0e7b9537100374$var$Ji(c, b);
    b = $0a0e7b9537100374$var$Ni(a, b, 1);
    a = $0a0e7b9537100374$var$nh(a, b, 1);
    b = $0a0e7b9537100374$var$R();
    null !== a && ($0a0e7b9537100374$var$Ac(a, 1, b), $0a0e7b9537100374$var$Dk(a, b));
}
function $0a0e7b9537100374$var$W(a, b, c) {
    if (3 === a.tag) $0a0e7b9537100374$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0a0e7b9537100374$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0a0e7b9537100374$var$Ri || !$0a0e7b9537100374$var$Ri.has(d))) {
                a = $0a0e7b9537100374$var$Ji(c, a);
                a = $0a0e7b9537100374$var$Qi(b, a, 1);
                b = $0a0e7b9537100374$var$nh(b, a, 1);
                a = $0a0e7b9537100374$var$R();
                null !== b && ($0a0e7b9537100374$var$Ac(b, 1, a), $0a0e7b9537100374$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0a0e7b9537100374$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0a0e7b9537100374$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0a0e7b9537100374$var$Q === a && ($0a0e7b9537100374$var$Z & c) === c && (4 === $0a0e7b9537100374$var$T || 3 === $0a0e7b9537100374$var$T && ($0a0e7b9537100374$var$Z & 130023424) === $0a0e7b9537100374$var$Z && 500 > $0a0e7b9537100374$var$B() - $0a0e7b9537100374$var$fk ? $0a0e7b9537100374$var$Kk(a, 0) : $0a0e7b9537100374$var$rk |= c);
    $0a0e7b9537100374$var$Dk(a, b);
}
function $0a0e7b9537100374$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0a0e7b9537100374$var$sc, $0a0e7b9537100374$var$sc <<= 1, 0 === ($0a0e7b9537100374$var$sc & 130023424) && ($0a0e7b9537100374$var$sc = 4194304)));
    var c = $0a0e7b9537100374$var$R();
    a = $0a0e7b9537100374$var$ih(a, b);
    null !== a && ($0a0e7b9537100374$var$Ac(a, b, c), $0a0e7b9537100374$var$Dk(a, c));
}
function $0a0e7b9537100374$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0a0e7b9537100374$var$Yk(a, c);
}
function $0a0e7b9537100374$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0a0e7b9537100374$var$p(314));
    }
    null !== d && d.delete(b);
    $0a0e7b9537100374$var$Yk(a, c);
}
var $0a0e7b9537100374$var$Vk;
$0a0e7b9537100374$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0a0e7b9537100374$var$Wf.current) $0a0e7b9537100374$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0a0e7b9537100374$var$dh = !1, $0a0e7b9537100374$var$yj(a, b, c);
            $0a0e7b9537100374$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0a0e7b9537100374$var$dh = !1, $0a0e7b9537100374$var$I && 0 !== (b.flags & 1048576) && $0a0e7b9537100374$var$ug(b, $0a0e7b9537100374$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0a0e7b9537100374$var$ij(a, b);
            a = b.pendingProps;
            var e = $0a0e7b9537100374$var$Yf(b, $0a0e7b9537100374$var$H.current);
            $0a0e7b9537100374$var$ch(b, c);
            e = $0a0e7b9537100374$var$Nh(null, b, d, a, e, c);
            var f = $0a0e7b9537100374$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0a0e7b9537100374$var$Zf(d) ? (f = !0, $0a0e7b9537100374$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0a0e7b9537100374$var$kh(b), e.updater = $0a0e7b9537100374$var$Ei, b.stateNode = e, e._reactInternals = b, $0a0e7b9537100374$var$Ii(b, d, a, c), b = $0a0e7b9537100374$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0a0e7b9537100374$var$I && f && $0a0e7b9537100374$var$vg(b), $0a0e7b9537100374$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0a0e7b9537100374$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0a0e7b9537100374$var$Zk(d);
                a = $0a0e7b9537100374$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0a0e7b9537100374$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0a0e7b9537100374$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0a0e7b9537100374$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0a0e7b9537100374$var$$i(null, b, d, $0a0e7b9537100374$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0a0e7b9537100374$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0a0e7b9537100374$var$kj(b);
                if (null === a) throw Error($0a0e7b9537100374$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0a0e7b9537100374$var$lh(a, b);
                $0a0e7b9537100374$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0a0e7b9537100374$var$Ji(Error($0a0e7b9537100374$var$p(423)), b);
                        b = $0a0e7b9537100374$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0a0e7b9537100374$var$Ji(Error($0a0e7b9537100374$var$p(424)), b);
                        b = $0a0e7b9537100374$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0a0e7b9537100374$var$yg = $0a0e7b9537100374$var$Lf(b.stateNode.containerInfo.firstChild), $0a0e7b9537100374$var$xg = b, $0a0e7b9537100374$var$I = !0, $0a0e7b9537100374$var$zg = null, c = $0a0e7b9537100374$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0a0e7b9537100374$var$Ig();
                    if (d === e) {
                        b = $0a0e7b9537100374$var$Zi(a, b, c);
                        break a;
                    }
                    $0a0e7b9537100374$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0a0e7b9537100374$var$Ah(b), null === a && $0a0e7b9537100374$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0a0e7b9537100374$var$Ef(d, e) ? g = null : null !== f && $0a0e7b9537100374$var$Ef(d, f) && (b.flags |= 32), $0a0e7b9537100374$var$gj(a, b), $0a0e7b9537100374$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0a0e7b9537100374$var$Eg(b), null;
        case 13:
            return $0a0e7b9537100374$var$oj(a, b, c);
        case 4:
            return $0a0e7b9537100374$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0a0e7b9537100374$var$Ug(b, null, d, c) : $0a0e7b9537100374$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$Yi(a, b, d, e, c);
        case 7:
            return $0a0e7b9537100374$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0a0e7b9537100374$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0a0e7b9537100374$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0a0e7b9537100374$var$G($0a0e7b9537100374$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0a0e7b9537100374$var$He(f.value, g)) {
                        if (f.children === e.children && !$0a0e7b9537100374$var$Wf.current) {
                            b = $0a0e7b9537100374$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0a0e7b9537100374$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0a0e7b9537100374$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0a0e7b9537100374$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0a0e7b9537100374$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0a0e7b9537100374$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0a0e7b9537100374$var$ch(b, c), e = $0a0e7b9537100374$var$eh(e), d = d(e), b.flags |= 1, $0a0e7b9537100374$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0a0e7b9537100374$var$Ci(d, b.pendingProps), e = $0a0e7b9537100374$var$Ci(d.type, e), $0a0e7b9537100374$var$$i(a, b, d, e, c);
        case 15:
            return $0a0e7b9537100374$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0a0e7b9537100374$var$Ci(d, e), $0a0e7b9537100374$var$ij(a, b), b.tag = 1, $0a0e7b9537100374$var$Zf(d) ? (a = !0, $0a0e7b9537100374$var$cg(b)) : a = !1, $0a0e7b9537100374$var$ch(b, c), $0a0e7b9537100374$var$Gi(b, d, e), $0a0e7b9537100374$var$Ii(b, d, e, c), $0a0e7b9537100374$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0a0e7b9537100374$var$xj(a, b, c);
        case 22:
            return $0a0e7b9537100374$var$dj(a, b, c);
    }
    throw Error($0a0e7b9537100374$var$p(156, b.tag));
};
function $0a0e7b9537100374$var$Fk(a, b) {
    return $0a0e7b9537100374$var$ac(a, b);
}
function $0a0e7b9537100374$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0a0e7b9537100374$var$Bg(a, b, c, d) {
    return new $0a0e7b9537100374$var$$k(a, b, c, d);
}
function $0a0e7b9537100374$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0a0e7b9537100374$var$Zk(a) {
    if ("function" === typeof a) return $0a0e7b9537100374$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0a0e7b9537100374$var$Da) return 11;
        if (a === $0a0e7b9537100374$var$Ga) return 14;
    }
    return 2;
}
function $0a0e7b9537100374$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0a0e7b9537100374$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0a0e7b9537100374$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0a0e7b9537100374$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0a0e7b9537100374$var$ya:
            return $0a0e7b9537100374$var$Tg(c.children, e, f, b);
        case $0a0e7b9537100374$var$za:
            g = 8;
            e |= 8;
            break;
        case $0a0e7b9537100374$var$Aa:
            return a = $0a0e7b9537100374$var$Bg(12, c, b, e | 2), a.elementType = $0a0e7b9537100374$var$Aa, a.lanes = f, a;
        case $0a0e7b9537100374$var$Ea:
            return a = $0a0e7b9537100374$var$Bg(13, c, b, e), a.elementType = $0a0e7b9537100374$var$Ea, a.lanes = f, a;
        case $0a0e7b9537100374$var$Fa:
            return a = $0a0e7b9537100374$var$Bg(19, c, b, e), a.elementType = $0a0e7b9537100374$var$Fa, a.lanes = f, a;
        case $0a0e7b9537100374$var$Ia:
            return $0a0e7b9537100374$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0a0e7b9537100374$var$Ba:
                    g = 10;
                    break a;
                case $0a0e7b9537100374$var$Ca:
                    g = 9;
                    break a;
                case $0a0e7b9537100374$var$Da:
                    g = 11;
                    break a;
                case $0a0e7b9537100374$var$Ga:
                    g = 14;
                    break a;
                case $0a0e7b9537100374$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0a0e7b9537100374$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0a0e7b9537100374$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0a0e7b9537100374$var$Tg(a, b, c, d) {
    a = $0a0e7b9537100374$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0a0e7b9537100374$var$pj(a, b, c, d) {
    a = $0a0e7b9537100374$var$Bg(22, a, d, b);
    a.elementType = $0a0e7b9537100374$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0a0e7b9537100374$var$Qg(a, b, c) {
    a = $0a0e7b9537100374$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0a0e7b9537100374$var$Sg(a, b, c) {
    b = $0a0e7b9537100374$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0a0e7b9537100374$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0a0e7b9537100374$var$zc(0);
    this.expirationTimes = $0a0e7b9537100374$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0a0e7b9537100374$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0a0e7b9537100374$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0a0e7b9537100374$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0a0e7b9537100374$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0a0e7b9537100374$var$kh(f);
    return a;
}
function $0a0e7b9537100374$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0a0e7b9537100374$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0a0e7b9537100374$var$dl(a) {
    if (!a) return $0a0e7b9537100374$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0a0e7b9537100374$var$Vb(a) !== a || 1 !== a.tag) throw Error($0a0e7b9537100374$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0a0e7b9537100374$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0a0e7b9537100374$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0a0e7b9537100374$var$Zf(c)) return $0a0e7b9537100374$var$bg(a, c, b);
    }
    return b;
}
function $0a0e7b9537100374$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0a0e7b9537100374$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0a0e7b9537100374$var$dl(null);
    c = a.current;
    d = $0a0e7b9537100374$var$R();
    e = $0a0e7b9537100374$var$yi(c);
    f = $0a0e7b9537100374$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0a0e7b9537100374$var$nh(c, f, e);
    a.current.lanes = e;
    $0a0e7b9537100374$var$Ac(a, e, d);
    $0a0e7b9537100374$var$Dk(a, d);
    return a;
}
function $0a0e7b9537100374$var$fl(a, b, c, d) {
    var e = b.current, f = $0a0e7b9537100374$var$R(), g = $0a0e7b9537100374$var$yi(e);
    c = $0a0e7b9537100374$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0a0e7b9537100374$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0a0e7b9537100374$var$nh(e, b, g);
    null !== a && ($0a0e7b9537100374$var$gi(a, e, g, f), $0a0e7b9537100374$var$oh(a, e, g));
    return g;
}
function $0a0e7b9537100374$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0a0e7b9537100374$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0a0e7b9537100374$var$il(a, b) {
    $0a0e7b9537100374$var$hl(a, b);
    (a = a.alternate) && $0a0e7b9537100374$var$hl(a, b);
}
function $0a0e7b9537100374$var$jl() {
    return null;
}
var $0a0e7b9537100374$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0a0e7b9537100374$var$ll(a) {
    this._internalRoot = a;
}
$0a0e7b9537100374$var$ml.prototype.render = $0a0e7b9537100374$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0a0e7b9537100374$var$p(409));
    $0a0e7b9537100374$var$fl(a, b, null, null);
};
$0a0e7b9537100374$var$ml.prototype.unmount = $0a0e7b9537100374$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0a0e7b9537100374$var$Rk(function() {
            $0a0e7b9537100374$var$fl(null, a, null, null);
        });
        b[$0a0e7b9537100374$var$uf] = null;
    }
};
function $0a0e7b9537100374$var$ml(a) {
    this._internalRoot = a;
}
$0a0e7b9537100374$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0a0e7b9537100374$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0a0e7b9537100374$var$Qc.length && 0 !== b && b < $0a0e7b9537100374$var$Qc[c].priority; c++);
        $0a0e7b9537100374$var$Qc.splice(c, 0, a);
        0 === c && $0a0e7b9537100374$var$Vc(a);
    }
};
function $0a0e7b9537100374$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0a0e7b9537100374$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0a0e7b9537100374$var$pl() {}
function $0a0e7b9537100374$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0a0e7b9537100374$var$gl(g);
                f.call(a);
            };
        }
        var g = $0a0e7b9537100374$var$el(b, d, a, 0, null, !1, !1, "", $0a0e7b9537100374$var$pl);
        a._reactRootContainer = g;
        a[$0a0e7b9537100374$var$uf] = g.current;
        $0a0e7b9537100374$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0a0e7b9537100374$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0a0e7b9537100374$var$gl(k);
            h.call(a);
        };
    }
    var k = $0a0e7b9537100374$var$bl(a, 0, !1, null, null, !1, !1, "", $0a0e7b9537100374$var$pl);
    a._reactRootContainer = k;
    a[$0a0e7b9537100374$var$uf] = k.current;
    $0a0e7b9537100374$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0a0e7b9537100374$var$Rk(function() {
        $0a0e7b9537100374$var$fl(b, k, c, d);
    });
    return k;
}
function $0a0e7b9537100374$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0a0e7b9537100374$var$gl(g);
                h.call(a);
            };
        }
        $0a0e7b9537100374$var$fl(b, g, a, e);
    } else g = $0a0e7b9537100374$var$ql(c, b, a, e, d);
    return $0a0e7b9537100374$var$gl(g);
}
$0a0e7b9537100374$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0a0e7b9537100374$var$tc(b.pendingLanes);
                0 !== c && ($0a0e7b9537100374$var$Cc(b, c | 1), $0a0e7b9537100374$var$Dk(b, $0a0e7b9537100374$var$B()), 0 === ($0a0e7b9537100374$var$K & 6) && ($0a0e7b9537100374$var$Gj = $0a0e7b9537100374$var$B() + 500, $0a0e7b9537100374$var$jg()));
            }
            break;
        case 13:
            $0a0e7b9537100374$var$Rk(function() {
                var b = $0a0e7b9537100374$var$ih(a, 1);
                if (null !== b) {
                    var c = $0a0e7b9537100374$var$R();
                    $0a0e7b9537100374$var$gi(b, a, 1, c);
                }
            }), $0a0e7b9537100374$var$il(a, 1);
    }
};
$0a0e7b9537100374$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0a0e7b9537100374$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0a0e7b9537100374$var$R();
            $0a0e7b9537100374$var$gi(b, a, 134217728, c);
        }
        $0a0e7b9537100374$var$il(a, 134217728);
    }
};
$0a0e7b9537100374$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0a0e7b9537100374$var$yi(a), c = $0a0e7b9537100374$var$ih(a, b);
        if (null !== c) {
            var d = $0a0e7b9537100374$var$R();
            $0a0e7b9537100374$var$gi(c, a, b, d);
        }
        $0a0e7b9537100374$var$il(a, b);
    }
};
$0a0e7b9537100374$var$Hc = function() {
    return $0a0e7b9537100374$var$C;
};
$0a0e7b9537100374$var$Ic = function(a, b) {
    var c = $0a0e7b9537100374$var$C;
    try {
        return $0a0e7b9537100374$var$C = a, b();
    } finally{
        $0a0e7b9537100374$var$C = c;
    }
};
$0a0e7b9537100374$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0a0e7b9537100374$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0a0e7b9537100374$var$Db(d);
                        if (!e) throw Error($0a0e7b9537100374$var$p(90));
                        $0a0e7b9537100374$var$Wa(d);
                        $0a0e7b9537100374$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0a0e7b9537100374$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0a0e7b9537100374$var$fb(a, !!c.multiple, b, !1);
    }
};
$0a0e7b9537100374$var$Gb = $0a0e7b9537100374$var$Qk;
$0a0e7b9537100374$var$Hb = $0a0e7b9537100374$var$Rk;
var $0a0e7b9537100374$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0a0e7b9537100374$var$Cb,
        $0a0e7b9537100374$var$ue,
        $0a0e7b9537100374$var$Db,
        $0a0e7b9537100374$var$Eb,
        $0a0e7b9537100374$var$Fb,
        $0a0e7b9537100374$var$Qk
    ]
}, $0a0e7b9537100374$var$tl = {
    findFiberByHostInstance: $0a0e7b9537100374$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0a0e7b9537100374$var$ul = {
    bundleType: $0a0e7b9537100374$var$tl.bundleType,
    version: $0a0e7b9537100374$var$tl.version,
    rendererPackageName: $0a0e7b9537100374$var$tl.rendererPackageName,
    rendererConfig: $0a0e7b9537100374$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0a0e7b9537100374$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0a0e7b9537100374$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0a0e7b9537100374$var$tl.findFiberByHostInstance || $0a0e7b9537100374$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0a0e7b9537100374$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0a0e7b9537100374$var$vl.isDisabled && $0a0e7b9537100374$var$vl.supportsFiber) try {
        $0a0e7b9537100374$var$kc = $0a0e7b9537100374$var$vl.inject($0a0e7b9537100374$var$ul), $0a0e7b9537100374$var$lc = $0a0e7b9537100374$var$vl;
    } catch (a) {}
}
$0a0e7b9537100374$export$ae55be85d98224ed = $0a0e7b9537100374$var$sl;
$0a0e7b9537100374$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0a0e7b9537100374$var$nl(b)) throw Error($0a0e7b9537100374$var$p(200));
    return $0a0e7b9537100374$var$cl(a, b, null, c);
};
$0a0e7b9537100374$export$882461b6382ed46c = function(a, b) {
    if (!$0a0e7b9537100374$var$nl(a)) throw Error($0a0e7b9537100374$var$p(299));
    var c = !1, d = "", e = $0a0e7b9537100374$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0a0e7b9537100374$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0a0e7b9537100374$var$uf] = b.current;
    $0a0e7b9537100374$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0a0e7b9537100374$var$ll(b);
};
$0a0e7b9537100374$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0a0e7b9537100374$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0a0e7b9537100374$var$p(268, a));
    }
    a = $0a0e7b9537100374$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0a0e7b9537100374$export$cd75ccfd720a3cd4 = function(a) {
    return $0a0e7b9537100374$var$Rk(a);
};
$0a0e7b9537100374$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0a0e7b9537100374$var$ol(b)) throw Error($0a0e7b9537100374$var$p(200));
    return $0a0e7b9537100374$var$rl(null, a, b, !0, c);
};
$0a0e7b9537100374$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0a0e7b9537100374$var$nl(a)) throw Error($0a0e7b9537100374$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0a0e7b9537100374$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0a0e7b9537100374$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0a0e7b9537100374$var$uf] = b.current;
    $0a0e7b9537100374$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0a0e7b9537100374$var$ml(b);
};
$0a0e7b9537100374$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0a0e7b9537100374$var$ol(b)) throw Error($0a0e7b9537100374$var$p(200));
    return $0a0e7b9537100374$var$rl(null, a, b, !1, c);
};
$0a0e7b9537100374$export$502457920280e6be = function(a) {
    if (!$0a0e7b9537100374$var$ol(a)) throw Error($0a0e7b9537100374$var$p(40));
    return a._reactRootContainer ? ($0a0e7b9537100374$var$Rk(function() {
        $0a0e7b9537100374$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0a0e7b9537100374$var$uf] = null;
        });
    }), !0) : !1;
};
$0a0e7b9537100374$export$c78a37762a8d58e1 = $0a0e7b9537100374$var$Qk;
$0a0e7b9537100374$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0a0e7b9537100374$var$ol(c)) throw Error($0a0e7b9537100374$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0a0e7b9537100374$var$p(38));
    return $0a0e7b9537100374$var$rl(a, b, c, !1, d);
};
$0a0e7b9537100374$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9rFeI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4zHOU"));

});
parcelRegister("4zHOU", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $354c6c187ec2d025$export$c4744153514ff05d, (v) => $354c6c187ec2d025$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $354c6c187ec2d025$export$3e506c1ccc9cc1a7, (v) => $354c6c187ec2d025$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $354c6c187ec2d025$export$e26fe2ed2fa76875, (v) => $354c6c187ec2d025$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $354c6c187ec2d025$export$502329bbf4b505b1, (v) => $354c6c187ec2d025$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $354c6c187ec2d025$export$6e3807111c4874c4, (v) => $354c6c187ec2d025$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $354c6c187ec2d025$export$c27134553091fb3a, (v) => $354c6c187ec2d025$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $354c6c187ec2d025$export$33ee1acdc04fd2a2, (v) => $354c6c187ec2d025$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $354c6c187ec2d025$export$b00a404bbd5edef2, (v) => $354c6c187ec2d025$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $354c6c187ec2d025$export$8352ce38b91d0c62, (v) => $354c6c187ec2d025$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $354c6c187ec2d025$export$d66a1c1c77bd778b, (v) => $354c6c187ec2d025$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $354c6c187ec2d025$export$d3dfb8e4810cb555, (v) => $354c6c187ec2d025$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $354c6c187ec2d025$export$839f9183b0465a69, (v) => $354c6c187ec2d025$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $354c6c187ec2d025$export$72fdf0e06517287b, (v) => $354c6c187ec2d025$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $354c6c187ec2d025$export$4b844e58a3e414b4, (v) => $354c6c187ec2d025$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $354c6c187ec2d025$export$816d2913ae6b83b1, (v) => $354c6c187ec2d025$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $354c6c187ec2d025$export$61bcfe829111a1d0, (v) => $354c6c187ec2d025$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $354c6c187ec2d025$export$7ee8c9beb337bc3f, (v) => $354c6c187ec2d025$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $354c6c187ec2d025$export$b5836b71941fa3ed, (v) => $354c6c187ec2d025$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $354c6c187ec2d025$export$cf845f2c119da08a, (v) => $354c6c187ec2d025$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $354c6c187ec2d025$export$c4744153514ff05d;
var $354c6c187ec2d025$export$3e506c1ccc9cc1a7;
var $354c6c187ec2d025$export$e26fe2ed2fa76875;
var $354c6c187ec2d025$export$502329bbf4b505b1;
var $354c6c187ec2d025$export$6e3807111c4874c4;
var $354c6c187ec2d025$export$c27134553091fb3a;
var $354c6c187ec2d025$export$33ee1acdc04fd2a2;
var $354c6c187ec2d025$export$b00a404bbd5edef2;
var $354c6c187ec2d025$export$8352ce38b91d0c62;
var $354c6c187ec2d025$export$d66a1c1c77bd778b;
var $354c6c187ec2d025$export$d3dfb8e4810cb555;
var $354c6c187ec2d025$export$839f9183b0465a69;
var $354c6c187ec2d025$export$72fdf0e06517287b;
var $354c6c187ec2d025$export$4b844e58a3e414b4;
var $354c6c187ec2d025$export$816d2913ae6b83b1;
var $354c6c187ec2d025$export$61bcfe829111a1d0;
var $354c6c187ec2d025$export$7ee8c9beb337bc3f;
var $354c6c187ec2d025$export$b5836b71941fa3ed;
var $354c6c187ec2d025$export$cf845f2c119da08a;
'use strict';
function $354c6c187ec2d025$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $354c6c187ec2d025$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $354c6c187ec2d025$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $354c6c187ec2d025$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $354c6c187ec2d025$var$g(C, c)) n < e && 0 > $354c6c187ec2d025$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $354c6c187ec2d025$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $354c6c187ec2d025$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $354c6c187ec2d025$var$l = performance;
    $354c6c187ec2d025$export$c4744153514ff05d = function() {
        return $354c6c187ec2d025$var$l.now();
    };
} else {
    var $354c6c187ec2d025$var$p = Date, $354c6c187ec2d025$var$q = $354c6c187ec2d025$var$p.now();
    $354c6c187ec2d025$export$c4744153514ff05d = function() {
        return $354c6c187ec2d025$var$p.now() - $354c6c187ec2d025$var$q;
    };
}
var $354c6c187ec2d025$var$r = [], $354c6c187ec2d025$var$t = [], $354c6c187ec2d025$var$u = 1, $354c6c187ec2d025$var$v = null, $354c6c187ec2d025$var$y = 3, $354c6c187ec2d025$var$z = !1, $354c6c187ec2d025$var$A = !1, $354c6c187ec2d025$var$B = !1, $354c6c187ec2d025$var$D = "function" === typeof setTimeout ? setTimeout : null, $354c6c187ec2d025$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $354c6c187ec2d025$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $354c6c187ec2d025$var$G(a) {
    for(var b = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t); null !== b;){
        if (null === b.callback) $354c6c187ec2d025$var$k($354c6c187ec2d025$var$t);
        else if (b.startTime <= a) $354c6c187ec2d025$var$k($354c6c187ec2d025$var$t), b.sortIndex = b.expirationTime, $354c6c187ec2d025$var$f($354c6c187ec2d025$var$r, b);
        else break;
        b = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t);
    }
}
function $354c6c187ec2d025$var$H(a) {
    $354c6c187ec2d025$var$B = !1;
    $354c6c187ec2d025$var$G(a);
    if (!$354c6c187ec2d025$var$A) {
        if (null !== $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r)) $354c6c187ec2d025$var$A = !0, $354c6c187ec2d025$var$I($354c6c187ec2d025$var$J);
        else {
            var b = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t);
            null !== b && $354c6c187ec2d025$var$K($354c6c187ec2d025$var$H, b.startTime - a);
        }
    }
}
function $354c6c187ec2d025$var$J(a, b) {
    $354c6c187ec2d025$var$A = !1;
    $354c6c187ec2d025$var$B && ($354c6c187ec2d025$var$B = !1, $354c6c187ec2d025$var$E($354c6c187ec2d025$var$L), $354c6c187ec2d025$var$L = -1);
    $354c6c187ec2d025$var$z = !0;
    var c = $354c6c187ec2d025$var$y;
    try {
        $354c6c187ec2d025$var$G(b);
        for($354c6c187ec2d025$var$v = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r); null !== $354c6c187ec2d025$var$v && (!($354c6c187ec2d025$var$v.expirationTime > b) || a && !$354c6c187ec2d025$var$M());){
            var d = $354c6c187ec2d025$var$v.callback;
            if ("function" === typeof d) {
                $354c6c187ec2d025$var$v.callback = null;
                $354c6c187ec2d025$var$y = $354c6c187ec2d025$var$v.priorityLevel;
                var e = d($354c6c187ec2d025$var$v.expirationTime <= b);
                b = $354c6c187ec2d025$export$c4744153514ff05d();
                "function" === typeof e ? $354c6c187ec2d025$var$v.callback = e : $354c6c187ec2d025$var$v === $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r) && $354c6c187ec2d025$var$k($354c6c187ec2d025$var$r);
                $354c6c187ec2d025$var$G(b);
            } else $354c6c187ec2d025$var$k($354c6c187ec2d025$var$r);
            $354c6c187ec2d025$var$v = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r);
        }
        if (null !== $354c6c187ec2d025$var$v) var w = !0;
        else {
            var m = $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t);
            null !== m && $354c6c187ec2d025$var$K($354c6c187ec2d025$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $354c6c187ec2d025$var$v = null, $354c6c187ec2d025$var$y = c, $354c6c187ec2d025$var$z = !1;
    }
}
var $354c6c187ec2d025$var$N = !1, $354c6c187ec2d025$var$O = null, $354c6c187ec2d025$var$L = -1, $354c6c187ec2d025$var$P = 5, $354c6c187ec2d025$var$Q = -1;
function $354c6c187ec2d025$var$M() {
    return $354c6c187ec2d025$export$c4744153514ff05d() - $354c6c187ec2d025$var$Q < $354c6c187ec2d025$var$P ? !1 : !0;
}
function $354c6c187ec2d025$var$R() {
    if (null !== $354c6c187ec2d025$var$O) {
        var a = $354c6c187ec2d025$export$c4744153514ff05d();
        $354c6c187ec2d025$var$Q = a;
        var b = !0;
        try {
            b = $354c6c187ec2d025$var$O(!0, a);
        } finally{
            b ? $354c6c187ec2d025$var$S() : ($354c6c187ec2d025$var$N = !1, $354c6c187ec2d025$var$O = null);
        }
    } else $354c6c187ec2d025$var$N = !1;
}
var $354c6c187ec2d025$var$S;
if ("function" === typeof $354c6c187ec2d025$var$F) $354c6c187ec2d025$var$S = function() {
    $354c6c187ec2d025$var$F($354c6c187ec2d025$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $354c6c187ec2d025$var$T = new MessageChannel, $354c6c187ec2d025$var$U = $354c6c187ec2d025$var$T.port2;
    $354c6c187ec2d025$var$T.port1.onmessage = $354c6c187ec2d025$var$R;
    $354c6c187ec2d025$var$S = function() {
        $354c6c187ec2d025$var$U.postMessage(null);
    };
} else $354c6c187ec2d025$var$S = function() {
    $354c6c187ec2d025$var$D($354c6c187ec2d025$var$R, 0);
};
function $354c6c187ec2d025$var$I(a) {
    $354c6c187ec2d025$var$O = a;
    $354c6c187ec2d025$var$N || ($354c6c187ec2d025$var$N = !0, $354c6c187ec2d025$var$S());
}
function $354c6c187ec2d025$var$K(a, b) {
    $354c6c187ec2d025$var$L = $354c6c187ec2d025$var$D(function() {
        a($354c6c187ec2d025$export$c4744153514ff05d());
    }, b);
}
$354c6c187ec2d025$export$3e506c1ccc9cc1a7 = 5;
$354c6c187ec2d025$export$e26fe2ed2fa76875 = 1;
$354c6c187ec2d025$export$502329bbf4b505b1 = 4;
$354c6c187ec2d025$export$6e3807111c4874c4 = 3;
$354c6c187ec2d025$export$c27134553091fb3a = null;
$354c6c187ec2d025$export$33ee1acdc04fd2a2 = 2;
$354c6c187ec2d025$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$354c6c187ec2d025$export$8352ce38b91d0c62 = function() {
    $354c6c187ec2d025$var$A || $354c6c187ec2d025$var$z || ($354c6c187ec2d025$var$A = !0, $354c6c187ec2d025$var$I($354c6c187ec2d025$var$J));
};
$354c6c187ec2d025$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $354c6c187ec2d025$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$354c6c187ec2d025$export$d3dfb8e4810cb555 = function() {
    return $354c6c187ec2d025$var$y;
};
$354c6c187ec2d025$export$839f9183b0465a69 = function() {
    return $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r);
};
$354c6c187ec2d025$export$72fdf0e06517287b = function(a) {
    switch($354c6c187ec2d025$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $354c6c187ec2d025$var$y;
    }
    var c = $354c6c187ec2d025$var$y;
    $354c6c187ec2d025$var$y = b;
    try {
        return a();
    } finally{
        $354c6c187ec2d025$var$y = c;
    }
};
$354c6c187ec2d025$export$4b844e58a3e414b4 = function() {};
$354c6c187ec2d025$export$816d2913ae6b83b1 = function() {};
$354c6c187ec2d025$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $354c6c187ec2d025$var$y;
    $354c6c187ec2d025$var$y = a;
    try {
        return b();
    } finally{
        $354c6c187ec2d025$var$y = c;
    }
};
$354c6c187ec2d025$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $354c6c187ec2d025$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $354c6c187ec2d025$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $354c6c187ec2d025$var$f($354c6c187ec2d025$var$t, a), null === $354c6c187ec2d025$var$h($354c6c187ec2d025$var$r) && a === $354c6c187ec2d025$var$h($354c6c187ec2d025$var$t) && ($354c6c187ec2d025$var$B ? ($354c6c187ec2d025$var$E($354c6c187ec2d025$var$L), $354c6c187ec2d025$var$L = -1) : $354c6c187ec2d025$var$B = !0, $354c6c187ec2d025$var$K($354c6c187ec2d025$var$H, c - d))) : (a.sortIndex = e, $354c6c187ec2d025$var$f($354c6c187ec2d025$var$r, a), $354c6c187ec2d025$var$A || $354c6c187ec2d025$var$z || ($354c6c187ec2d025$var$A = !0, $354c6c187ec2d025$var$I($354c6c187ec2d025$var$J)));
    return a;
};
$354c6c187ec2d025$export$b5836b71941fa3ed = $354c6c187ec2d025$var$M;
$354c6c187ec2d025$export$cf845f2c119da08a = function(a) {
    var b = $354c6c187ec2d025$var$y;
    return function() {
        var c = $354c6c187ec2d025$var$y;
        $354c6c187ec2d025$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $354c6c187ec2d025$var$y = c;
        }
    };
};

});




parcelRegister("4xGiN", function(module, exports) {

$parcel$export(module.exports, "useUtilsStore", () => $0a8a6ad4aa04366f$export$77e4cc5334565f28);
$parcel$export(module.exports, "default", () => $0a8a6ad4aa04366f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $2rYkD = parcelRequire("2rYkD");
let $0a8a6ad4aa04366f$var$timer = null;
const $0a8a6ad4aa04366f$var$initialState = {
    fullScreenImage: undefined,
    lastListActivity: undefined,
    listStatus: (0, $2rYkD.ListStatus).available,
    currentSubView: (0, $2rYkD.CurrentSubView).none,
    currentCustomView: undefined,
    retorikEvent: undefined,
    displayAgent: true,
    activityToSend: undefined,
    retorikNewsEnded: false,
    userIsTyping: false,
    userIsSwiping: false,
    askedForKioskParametersOpening: 0,
    detailedAttachmentTriggers: [
        {
            type: 'event',
            name: 'hospitality.ShowPointOfInterest',
            linkedComponent: null
        },
        {
            type: 'event',
            name: 'hospitality.ShowContentItem',
            linkedComponent: null
        }
    ],
    modalFullscreenContent: null,
    modalFullscreenContentNoDisplayId: undefined,
    printingCallback: null,
    GDPRDisplay: true,
    GDPRWindowData: undefined,
    GDPRUserConsent: false,
    unlockClickedButton: false,
    dashboardOpened: false,
    clickedOnUI: (0, $2rYkD.UIPart).none,
    closeDetailedPOI: false,
    closeList: 0
};
const $0a8a6ad4aa04366f$var$createUtilsStore = ()=>(0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$0a8a6ad4aa04366f$var$initialState,
            actions: {
                setFullScreenImage: (value)=>{
                    set({
                        fullScreenImage: value
                    });
                },
                setLastListActivity: (value)=>{
                    set({
                        lastListActivity: value
                    });
                },
                setListStatus: (value)=>{
                    set({
                        listStatus: value
                    });
                },
                getListStatus: ()=>{
                    return get().listStatus;
                },
                setCloseList: (value)=>{
                    set({
                        closeList: value
                    });
                },
                setCurrentSubView: (value)=>{
                    set({
                        currentSubView: value
                    });
                },
                setCurrentCustomView: (value)=>{
                    set({
                        currentCustomView: value
                    });
                },
                setRetorikEvent: (value)=>{
                    set({
                        retorikEvent: value
                    });
                },
                showAgent: ()=>{
                    set({
                        displayAgent: true
                    });
                },
                hideAgent: ()=>{
                    set({
                        displayAgent: false
                    });
                },
                sendActivity: (value)=>{
                    set({
                        activityToSend: value
                    });
                },
                setRetorikNewsEnded: (value)=>{
                    set({
                        retorikNewsEnded: value
                    });
                },
                setUserTyping: (value)=>{
                    set({
                        userIsTyping: value
                    });
                },
                setUserSwiping: ()=>{
                    $0a8a6ad4aa04366f$var$timer && clearTimeout($0a8a6ad4aa04366f$var$timer);
                    set({
                        userIsSwiping: true
                    });
                    $0a8a6ad4aa04366f$var$timer = setTimeout(()=>{
                        set({
                            userIsSwiping: false
                        });
                    }, 2500);
                },
                askForKioskParametersOpening: ()=>{
                    set((state)=>({
                            askedForKioskParametersOpening: state.askedForKioskParametersOpening + 1
                        }));
                },
                addDetailedAttachmentTrigger: (value)=>{
                    set((state)=>({
                            detailedAttachmentTriggers: [
                                ...state.detailedAttachmentTriggers,
                                value
                            ]
                        }));
                },
                setModalFullscreenContent: (value, fromActivity)=>{
                    set((state)=>{
                        if (!fromActivity) return {
                            modalFullscreenContent: value
                        };
                        else if (fromActivity !== state.modalFullscreenContentNoDisplayId) // Set fromActivity data to check next time if we have to prevent unwanted re-rendering
                        return {
                            modalFullscreenContent: value,
                            modalFullscreenContentNoDisplayId: fromActivity
                        };
                        return state;
                    });
                },
                setPrintingCallback: (value)=>{
                    set({
                        printingCallback: value
                    });
                },
                setGDPRDisplay: (value)=>{
                    set({
                        GDPRDisplay: value
                    });
                },
                setGDPRWindowData: (value)=>{
                    set(()=>({
                            GDPRWindowData: value
                        }));
                },
                setGDPRUserConsent: (value)=>{
                    set({
                        GDPRUserConsent: value
                    });
                },
                lockClickedButton: ()=>{
                    set({
                        unlockClickedButton: false
                    });
                },
                unlockClickedButton: ()=>{
                    set({
                        unlockClickedButton: true
                    });
                },
                setDashboardOpened: (value)=>{
                    set({
                        dashboardOpened: value
                    });
                },
                toggleDashboard: (doNotCloseViews)=>{
                    if (doNotCloseViews) set((state)=>({
                            dashboardOpened: !state.dashboardOpened
                        }));
                    else set((state)=>({
                            currentSubView: (0, $2rYkD.CurrentSubView).none,
                            dashboardOpened: !state.dashboardOpened
                        }));
                },
                setClickedOnUI: (value)=>{
                    set({
                        clickedOnUI: value
                    });
                    setTimeout(()=>{
                        set({
                            clickedOnUI: (0, $2rYkD.UIPart).none
                        });
                    }, 50);
                },
                setCloseDetailedPOI: (value)=>{
                    set({
                        closeDetailedPOI: value
                    });
                },
                resetUtilsStore: ()=>{
                    set({
                        ...$0a8a6ad4aa04366f$var$initialState
                    });
                }
            }
        };
    });
const $0a8a6ad4aa04366f$var$UtilsContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $0a8a6ad4aa04366f$export$77e4cc5334565f28 = (selector)=>{
    const store = (0, $bxRTa.useContext)($0a8a6ad4aa04366f$var$UtilsContext);
    if (!store) throw new Error('Retorik Framework > useUtilsStore must be used within UtilsProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $0a8a6ad4aa04366f$var$UtilsProvider = ({ children: children })=>{
    const [store] = (0, $bxRTa.useState)(()=>$0a8a6ad4aa04366f$var$createUtilsStore());
    return /*#__PURE__*/ (0, $fl9nK.jsx)($0a8a6ad4aa04366f$var$UtilsContext.Provider, {
        value: store,
        children: children
    });
};
var $0a8a6ad4aa04366f$export$2e2bcd8739ae039 = $0a8a6ad4aa04366f$var$UtilsProvider;

});
parcelRegister("jH1Jg", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $589838ddead54417$export$f51a9068ac82ea43);
const $589838ddead54417$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $589838ddead54417$export$f51a9068ac82ea43 = (createState)=>createState ? $589838ddead54417$var$createStoreImpl(createState) : $589838ddead54417$var$createStoreImpl;

});

parcelRegister("bndFL", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $d2e9e52d20dcb768$export$6ccbb43953eebf8);

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
const $d2e9e52d20dcb768$var$identity = (arg)=>arg;
function $d2e9e52d20dcb768$export$6ccbb43953eebf8(api, selector = $d2e9e52d20dcb768$var$identity) {
    const slice = (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useSyncExternalStore(api.subscribe, (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useDebugValue(slice);
    return slice;
}
const $d2e9e52d20dcb768$var$createImpl = (createState)=>{
    const api = (0, $jH1Jg.createStore)(createState);
    const useBoundStore = (selector)=>$d2e9e52d20dcb768$export$6ccbb43953eebf8(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $d2e9e52d20dcb768$export$185802fd694ee1f5 = (createState)=>createState ? $d2e9e52d20dcb768$var$createImpl(createState) : $d2e9e52d20dcb768$var$createImpl;

});

parcelRegister("2rYkD", function(module, exports) {

$parcel$export(module.exports, "ActionType", () => $2f88b96f1155ba4b$export$e4a712fff93fb00f);
$parcel$export(module.exports, "AnimationSize", () => $2f88b96f1155ba4b$export$a2a634340dd7e3e3);
$parcel$export(module.exports, "AvailableViews", () => $2f88b96f1155ba4b$export$3b4d92ba873f009a);
$parcel$export(module.exports, "AvailableSubViews", () => $2f88b96f1155ba4b$export$c5a4c3ea2d78493c);
$parcel$export(module.exports, "CategoryId", () => $2f88b96f1155ba4b$export$22b261e08140d6b2);
$parcel$export(module.exports, "CloseButtonCause", () => $2f88b96f1155ba4b$export$ddddf2c97763af65);
$parcel$export(module.exports, "ContainerParent", () => $2f88b96f1155ba4b$export$a31c5a03aaeee5f);
$parcel$export(module.exports, "CurrentSubView", () => $2f88b96f1155ba4b$export$f05d0fed0593ead7);
$parcel$export(module.exports, "Depth", () => $2f88b96f1155ba4b$export$950556173b6cbecb);
$parcel$export(module.exports, "DeviceType", () => $2f88b96f1155ba4b$export$ec1e04e4e5ef8233);
$parcel$export(module.exports, "DisplayDataTypes", () => $2f88b96f1155ba4b$export$382c3885a1d469b4);
$parcel$export(module.exports, "Displays", () => $2f88b96f1155ba4b$export$972614fc43112105);
$parcel$export(module.exports, "InputHintBehaviour", () => $2f88b96f1155ba4b$export$d5c9907f7475220b);
$parcel$export(module.exports, "ListStatus", () => $2f88b96f1155ba4b$export$2ba8159153a76219);
$parcel$export(module.exports, "Mode", () => $2f88b96f1155ba4b$export$9484bbecc3c49a2e);
$parcel$export(module.exports, "PermissionStatus", () => $2f88b96f1155ba4b$export$24ebbf8ea19b9f23);
$parcel$export(module.exports, "RetorikEvent", () => $2f88b96f1155ba4b$export$4f7cd669585dc69f);
$parcel$export(module.exports, "RecognitionState", () => $2f88b96f1155ba4b$export$3f0071308968cd80);
$parcel$export(module.exports, "RemoteButtonType", () => $2f88b96f1155ba4b$export$4112462e5af80a05);
$parcel$export(module.exports, "Routes", () => $2f88b96f1155ba4b$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "Source3DEngine", () => $2f88b96f1155ba4b$export$beb88f8efcd110a3);
$parcel$export(module.exports, "UIPart", () => $2f88b96f1155ba4b$export$63fc5f52b5b4da1e);
$parcel$export(module.exports, "TextFrom", () => $2f88b96f1155ba4b$export$b685c7d489184507);
$parcel$export(module.exports, "Theme", () => $2f88b96f1155ba4b$export$14faa19a0f3bbeb2);
$parcel$export(module.exports, "TraceType", () => $2f88b96f1155ba4b$export$d4b4ca0ba30ae29c);
var $2f88b96f1155ba4b$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["message"] = "message";
    ActionType["event"] = "event";
    ActionType["url"] = "url";
    ActionType["internal"] = "internal";
    return ActionType;
}($2f88b96f1155ba4b$export$e4a712fff93fb00f || {});
var $2f88b96f1155ba4b$export$a2a634340dd7e3e3 = /*#__PURE__*/ function(AnimationSize) {
    AnimationSize[AnimationSize["small"] = 0] = "small";
    AnimationSize[AnimationSize["medium"] = 1] = "medium";
    AnimationSize[AnimationSize["large"] = 2] = "large";
    return AnimationSize;
}($2f88b96f1155ba4b$export$a2a634340dd7e3e3 || {});
/**
 * @deprecated AvailableViews is deprecated without replacement since version 2.2.0 and the new menu system
 */ var $2f88b96f1155ba4b$export$3b4d92ba873f009a = /*#__PURE__*/ function(AvailableViews) {
    AvailableViews[AvailableViews["home"] = 1] = "home";
    AvailableViews[AvailableViews["news"] = 2] = "news";
    AvailableViews[AvailableViews["weather"] = 3] = "weather";
    AvailableViews[AvailableViews["emergency"] = 4] = "emergency";
    return AvailableViews;
}($2f88b96f1155ba4b$export$3b4d92ba873f009a || {});
/**
 * @deprecated AvailableSubViews is deprecated without replacement since version 2.2.0 and the new menu system
 */ var $2f88b96f1155ba4b$export$c5a4c3ea2d78493c = /*#__PURE__*/ function(AvailableSubViews) {
    AvailableSubViews[AvailableSubViews["history"] = 1000] = "history";
    AvailableSubViews[AvailableSubViews["tutorial"] = 1001] = "tutorial";
    return AvailableSubViews;
}($2f88b96f1155ba4b$export$c5a4c3ea2d78493c || {});
var $2f88b96f1155ba4b$export$22b261e08140d6b2 = /*#__PURE__*/ function(CategoryId) {
    CategoryId["eat"] = "where to eat";
    CategoryId["sleep"] = "where to sleep";
    CategoryId["see"] = "what to see";
    CategoryId["do"] = "what to do";
    CategoryId["localproducts"] = "local products";
    CategoryId["services"] = "services";
    CategoryId["agenda"] = "events";
    CategoryId["occupant"] = "occupant";
    return CategoryId;
}($2f88b96f1155ba4b$export$22b261e08140d6b2 || {});
var $2f88b96f1155ba4b$export$ddddf2c97763af65 = /*#__PURE__*/ function(CloseButtonCause) {
    CloseButtonCause["none"] = "None";
    CloseButtonCause["detailedpoi"] = "Detailed";
    CloseButtonCause["list"] = "List";
    CloseButtonCause["history"] = "History";
    CloseButtonCause["languages"] = "Languages";
    CloseButtonCause["weather"] = "Weather";
    CloseButtonCause["emergency"] = "Emergency";
    CloseButtonCause["map"] = "Map";
    CloseButtonCause["dashboard"] = "Dashboard";
    CloseButtonCause["fullscreenimage"] = "FullscreenImage";
    CloseButtonCause["news"] = "News";
    return CloseButtonCause;
}($2f88b96f1155ba4b$export$ddddf2c97763af65 || {});
var $2f88b96f1155ba4b$export$a31c5a03aaeee5f = /*#__PURE__*/ function(ContainerParent) {
    ContainerParent[ContainerParent["agent"] = 1] = "agent";
    ContainerParent[ContainerParent["widget"] = 2] = "widget";
    ContainerParent[ContainerParent["news"] = 3] = "news";
    return ContainerParent;
}($2f88b96f1155ba4b$export$a31c5a03aaeee5f || {});
var $2f88b96f1155ba4b$export$f05d0fed0593ead7 = /*#__PURE__*/ function(CurrentSubView) {
    CurrentSubView[CurrentSubView["none"] = 1] = "none";
    CurrentSubView[CurrentSubView["history"] = 2] = "history";
    CurrentSubView[CurrentSubView["languages"] = 3] = "languages";
    CurrentSubView[CurrentSubView["weather"] = 4] = "weather";
    CurrentSubView[CurrentSubView["emergency"] = 5] = "emergency";
    CurrentSubView[CurrentSubView["custom"] = 6] = "custom";
    return CurrentSubView;
}($2f88b96f1155ba4b$export$f05d0fed0593ead7 || {});
var $2f88b96f1155ba4b$export$950556173b6cbecb = /*#__PURE__*/ function(Depth) {
    Depth[Depth["background"] = 1] = "background";
    Depth[Depth["util"] = 2] = "util";
    Depth[Depth["chatbot"] = 3] = "chatbot";
    Depth[Depth["ui"] = 4] = "ui";
    Depth[Depth["dropdown"] = 5] = "dropdown";
    Depth[Depth["overlay"] = 6] = "overlay";
    Depth[Depth["menu"] = 7] = "menu";
    Depth[Depth["modal"] = 8] = "modal";
    Depth[Depth["exitwidget"] = 9] = "exitwidget";
    return Depth;
}($2f88b96f1155ba4b$export$950556173b6cbecb || {});
var $2f88b96f1155ba4b$export$ec1e04e4e5ef8233 = /*#__PURE__*/ function(DeviceType) {
    DeviceType[DeviceType["mobile"] = 1] = "mobile";
    DeviceType[DeviceType["borne"] = 2] = "borne";
    DeviceType[DeviceType["landscape"] = 3] = "landscape";
    DeviceType[DeviceType["widget"] = 4] = "widget";
    DeviceType[DeviceType["widgetLandscape"] = 5] = "widgetLandscape";
    DeviceType[DeviceType["widgetBorne"] = 6] = "widgetBorne";
    return DeviceType;
}($2f88b96f1155ba4b$export$ec1e04e4e5ef8233 || {});
var $2f88b96f1155ba4b$export$382c3885a1d469b4 = /*#__PURE__*/ function(DisplayDataTypes) {
    DisplayDataTypes[DisplayDataTypes["text"] = 0] = "text";
    DisplayDataTypes[DisplayDataTypes["attachment"] = 1] = "attachment";
    return DisplayDataTypes;
}($2f88b96f1155ba4b$export$382c3885a1d469b4 || {});
var $2f88b96f1155ba4b$export$972614fc43112105 = /*#__PURE__*/ function(Displays) {
    Displays[Displays["none"] = 0] = "none";
    Displays[Displays["normal"] = 1] = "normal";
    Displays[Displays["carousel"] = 2] = "carousel";
    Displays[Displays["grid"] = 3] = "grid";
    Displays[Displays["carouselgrid"] = 4] = "carouselgrid";
    Displays[Displays["list"] = 5] = "list";
    return Displays;
}($2f88b96f1155ba4b$export$972614fc43112105 || {});
var $2f88b96f1155ba4b$export$f0cfc93288d9ec06 = /*#__PURE__*/ function(Emotions) {
    Emotions["Regret"] = "regret";
    Emotions["Dislike"] = "dislike";
    Emotions["Distress"] = "distress";
    Emotions["Fear"] = "fear";
    Emotions["Sadness"] = "sadness";
    Emotions["Shame"] = "shame";
    Emotions["Contempt"] = "contempt";
    Emotions["Disgust"] = "disgust";
    Emotions["Guilt"] = "guilt";
    Emotions["Anger"] = "anger";
    Emotions["Frustration"] = "frustration";
    Emotions["Pride"] = "pride";
    Emotions["Love"] = "love";
    Emotions["Relief"] = "relief";
    Emotions["Joy"] = "joy";
    Emotions["Hope"] = "hope";
    return Emotions;
}($2f88b96f1155ba4b$export$f0cfc93288d9ec06 || {});
var $2f88b96f1155ba4b$export$d5c9907f7475220b = /*#__PURE__*/ function(InputHintBehaviour) {
    InputHintBehaviour["auto"] = "auto";
    InputHintBehaviour["always"] = "always";
    InputHintBehaviour["never"] = "never";
    InputHintBehaviour["ignore"] = "ignore";
    return InputHintBehaviour;
}($2f88b96f1155ba4b$export$d5c9907f7475220b || {});
var $2f88b96f1155ba4b$export$2ba8159153a76219 = /*#__PURE__*/ function(ListStatus) {
    ListStatus[ListStatus["available"] = 1] = "available";
    ListStatus[ListStatus["opened"] = 2] = "opened";
    ListStatus[ListStatus["closing"] = 3] = "closing";
    ListStatus[ListStatus["closed"] = 4] = "closed";
    return ListStatus;
}($2f88b96f1155ba4b$export$2ba8159153a76219 || {});
var $2f88b96f1155ba4b$export$bd7313a2f8345cae = /*#__PURE__*/ function(LoaderSteps) {
    LoaderSteps[LoaderSteps["loader"] = 1] = "loader";
    LoaderSteps[LoaderSteps["locale"] = 2] = "locale";
    LoaderSteps[LoaderSteps["supported"] = 3] = "supported";
    LoaderSteps[LoaderSteps["store"] = 4] = "store";
    LoaderSteps[LoaderSteps["directline"] = 5] = "directline";
    LoaderSteps[LoaderSteps["ponyfill"] = 6] = "ponyfill";
    LoaderSteps[LoaderSteps["agentdata"] = 7] = "agentdata";
    return LoaderSteps;
}($2f88b96f1155ba4b$export$bd7313a2f8345cae || {});
var $2f88b96f1155ba4b$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["vocal"] = 1] = "vocal";
    Mode[Mode["text"] = 2] = "text";
    Mode[Mode["dashboard"] = 3] = "dashboard";
    return Mode;
}($2f88b96f1155ba4b$export$9484bbecc3c49a2e || {});
var $2f88b96f1155ba4b$export$24ebbf8ea19b9f23 = /*#__PURE__*/ function(PermissionStatus) {
    PermissionStatus[PermissionStatus["waiting"] = 1] = "waiting";
    PermissionStatus[PermissionStatus["allowed"] = 2] = "allowed";
    PermissionStatus[PermissionStatus["refused"] = 3] = "refused";
    PermissionStatus[PermissionStatus["error"] = 4] = "error";
    return PermissionStatus;
}($2f88b96f1155ba4b$export$24ebbf8ea19b9f23 || {});
var $2f88b96f1155ba4b$export$13807d9ee5a34a42 = /*#__PURE__*/ function(Position) {
    Position[Position["top"] = 1] = "top";
    Position[Position["right"] = 2] = "right";
    Position[Position["bottom"] = 3] = "bottom";
    Position[Position["left"] = 4] = "left";
    return Position;
}($2f88b96f1155ba4b$export$13807d9ee5a34a42 || {});
var $2f88b96f1155ba4b$export$4f7cd669585dc69f = /*#__PURE__*/ function(RetorikEvent) {
    RetorikEvent[RetorikEvent["DetailViewOpen"] = 1] = "DetailViewOpen";
    RetorikEvent[RetorikEvent["DetailViewClose"] = 2] = "DetailViewClose";
    RetorikEvent[RetorikEvent["SpeechStarted"] = 3] = "SpeechStarted";
    RetorikEvent[RetorikEvent["SpeechEnded"] = 4] = "SpeechEnded";
    return RetorikEvent;
}($2f88b96f1155ba4b$export$4f7cd669585dc69f || {});
var $2f88b96f1155ba4b$export$3f0071308968cd80 = /*#__PURE__*/ function(RecognitionState) {
    RecognitionState[RecognitionState["Initializing"] = 1] = "Initializing";
    RecognitionState[RecognitionState["Listening"] = 2] = "Listening";
    RecognitionState[RecognitionState["Closing"] = 3] = "Closing";
    RecognitionState[RecognitionState["ForceClosing"] = 4] = "ForceClosing";
    RecognitionState[RecognitionState["Closed"] = 5] = "Closed";
    return RecognitionState;
}($2f88b96f1155ba4b$export$3f0071308968cd80 || {});
var $2f88b96f1155ba4b$export$4112462e5af80a05 = /*#__PURE__*/ function(RemoteButtonType) {
    RemoteButtonType[RemoteButtonType["home"] = 1] = "home";
    RemoteButtonType[RemoteButtonType["menu"] = 2] = "menu";
    RemoteButtonType[RemoteButtonType["language"] = 3] = "language";
    RemoteButtonType[RemoteButtonType["subtitles"] = 4] = "subtitles";
    RemoteButtonType[RemoteButtonType["sound"] = 5] = "sound";
    RemoteButtonType[RemoteButtonType["history"] = 6] = "history";
    RemoteButtonType[RemoteButtonType["text"] = 7] = "text";
    RemoteButtonType[RemoteButtonType["close"] = 8] = "close";
    return RemoteButtonType;
}($2f88b96f1155ba4b$export$4112462e5af80a05 || {});
var $2f88b96f1155ba4b$export$3565eb3d00ca5a74 = /*#__PURE__*/ function(Routes) {
    Routes[Routes["Home"] = 1] = "Home";
    Routes[Routes["News"] = 2] = "News";
    return Routes;
}($2f88b96f1155ba4b$export$3565eb3d00ca5a74 || {});
var $2f88b96f1155ba4b$export$beb88f8efcd110a3 = /*#__PURE__*/ function(Source3DEngine) {
    Source3DEngine["avatarsdk"] = "avatarsdk";
    Source3DEngine["avatarsdkbis"] = "avatar-sdk";
    Source3DEngine["avaturn"] = "avaturn";
    Source3DEngine["cc3"] = "cc3";
    Source3DEngine["cc4"] = "cc4";
    Source3DEngine["rpm"] = "rpm";
    Source3DEngine["readyplayerme"] = "readyplayerme";
    return Source3DEngine;
}($2f88b96f1155ba4b$export$beb88f8efcd110a3 || {});
var $2f88b96f1155ba4b$export$63fc5f52b5b4da1e = /*#__PURE__*/ function(UIPart) {
    UIPart[UIPart["none"] = 1] = "none";
    UIPart[UIPart["agent"] = 2] = "agent";
    UIPart[UIPart["background"] = 3] = "background";
    UIPart[UIPart["remote"] = 4] = "remote";
    UIPart[UIPart["languages"] = 5] = "languages";
    UIPart[UIPart["card"] = 6] = "card";
    UIPart[UIPart["qroverlay"] = 7] = "qroverlay";
    return UIPart;
}($2f88b96f1155ba4b$export$63fc5f52b5b4da1e || {});
var $2f88b96f1155ba4b$export$b685c7d489184507 = /*#__PURE__*/ function(TextFrom) {
    TextFrom["user"] = "user";
    TextFrom["bot"] = "bot";
    return TextFrom;
}($2f88b96f1155ba4b$export$b685c7d489184507 || {});
var $2f88b96f1155ba4b$export$14faa19a0f3bbeb2 = /*#__PURE__*/ function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
    Theme["auto"] = "auto";
    return Theme;
}($2f88b96f1155ba4b$export$14faa19a0f3bbeb2 || {});
var $2f88b96f1155ba4b$export$d4b4ca0ba30ae29c = /*#__PURE__*/ function(TraceType) {
    TraceType["message"] = "directlineMessage";
    TraceType["utteranceStart"] = "utteranceStart";
    TraceType["utteranceEnd"] = "utteranceEnd";
    return TraceType;
}($2f88b96f1155ba4b$export$d4b4ca0ba30ae29c || {});

});


parcelRegister("2eBYD", function(module, exports) {

$parcel$export(module.exports, "useLocaleStore", () => $c58d069d808fd0bd$export$6650dace022cfacc);
$parcel$export(module.exports, "default", () => $c58d069d808fd0bd$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $D3wt5 = parcelRequire("D3wt5");

var $kucVP = parcelRequire("kucVP");

var $2hYPB = parcelRequire("2hYPB");

var $8h6ET = parcelRequire("8h6ET");

var $kdMEA = parcelRequire("kdMEA");
const $c58d069d808fd0bd$var$initialState = {
    locale: '',
    defaultLocale: 'fr-FR',
    supported: [],
    dumpedLanguagesFallback: {},
    replacementLocales: {},
    defaultTranslations: structuredClone($2hYPB.fr_FR),
    currentTranslations: structuredClone($2hYPB.fr_FR),
    isRTL: false,
    localeForRetorikStudioContent: ''
};
const $c58d069d808fd0bd$var$createLocaleStore = ()=>(0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$c58d069d808fd0bd$var$initialState,
            actions: {
                setLocale: (value)=>{
                    set((state)=>{
                        const splitLocale = value.split('-')[0];
                        const changeLocaleEvent = new CustomEvent('retorikChangeLocale', {
                            detail: {
                                locale: value
                            }
                        });
                        document.dispatchEvent(changeLocaleEvent);
                        const tempTranslation = structuredClone($2hYPB[value.replace('-', '_')]);
                        let mergedTranslations = state.defaultTranslations;
                        if (tempTranslation) mergedTranslations = (0, $8h6ET.deepMerge)(tempTranslation, state.defaultTranslations);
                        else {
                            // Try to find a fallback translation language of the same locale but different culture
                            const fallbackLocale = (0, $kucVP.currentTranslatedLocales).find((l)=>l.split('-')[0] === splitLocale);
                            if (fallbackLocale) mergedTranslations = (0, $8h6ET.deepMerge)(structuredClone($2hYPB[fallbackLocale.replace('-', '_')]), state.defaultTranslations);
                        }
                        return {
                            locale: value,
                            isRTL: (0, $kdMEA.rtlLanguages).includes(splitLocale),
                            localeForRetorikStudioContent: state.dumpedLanguagesFallback[value] || value,
                            currentTranslations: {
                                ...mergedTranslations
                            }
                        };
                    });
                },
                fetchSupportedLanguages: async (baseAddress)=>{
                    (0, $D3wt5.default)(baseAddress).then((languages)=>{
                        set({
                            defaultLocale: languages.default,
                            supported: languages.all
                        });
                    });
                },
                setLanguageData: (defaultLocale, supported)=>{
                    set({
                        defaultLocale: defaultLocale,
                        supported: supported
                    });
                },
                addDumpedLanguageFallback: (key, value)=>{
                    set((state)=>({
                            dumpedLanguagesFallback: {
                                ...state.dumpedLanguagesFallback,
                                [key]: value
                            }
                        }));
                },
                addReplacementLocale: (key, value)=>{
                    set((state)=>({
                            replacementLocales: {
                                ...state.replacementLocales,
                                [key]: value
                            }
                        }));
                },
                checkDumpedLocaleFallback: ()=>{
                    if (Object.keys(get().dumpedLanguagesFallback).length) return get().dumpedLanguagesFallback[get().locale] || get().locale;
                    return get().locale;
                },
                checkReplacementLocale: (locale)=>{
                    if (Object.keys(get().replacementLocales).length) return get().replacementLocales[locale] || locale;
                    return locale;
                },
                resetLocaleStore: ()=>{
                    set({
                        ...$c58d069d808fd0bd$var$initialState
                    });
                }
            }
        };
    });
const $c58d069d808fd0bd$var$LocaleContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $c58d069d808fd0bd$export$6650dace022cfacc = (selector)=>{
    const store = (0, $bxRTa.useContext)($c58d069d808fd0bd$var$LocaleContext);
    if (!store) throw new Error('Retorik Framework > useLocaleStore must be used within LocaleProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $c58d069d808fd0bd$var$LocaleProvider = ({ children: children })=>{
    const [store] = (0, $bxRTa.useState)(()=>$c58d069d808fd0bd$var$createLocaleStore());
    return /*#__PURE__*/ (0, $fl9nK.jsx)($c58d069d808fd0bd$var$LocaleContext.Provider, {
        value: store,
        children: children
    });
};
var $c58d069d808fd0bd$export$2e2bcd8739ae039 = $c58d069d808fd0bd$var$LocaleProvider;

});
parcelRegister("D3wt5", function(module, exports) {

$parcel$export(module.exports, "processLanguageData", () => $de28171980b2041e$export$92cb25ec092104e6);
$parcel$export(module.exports, "default", () => $de28171980b2041e$export$2e2bcd8739ae039);

var $9P0Ec = parcelRequire("9P0Ec");

var $kdMEA = parcelRequire("kdMEA");

var $kucVP = parcelRequire("kucVP");
const $de28171980b2041e$var$fetchAvailableLanguages = async (baseAddress, needVisemes)=>{
    const fullAddress = `${baseAddress}api/graphql?query={siteCultures{culture,default}}`;
    const languages = await fetch(fullAddress).then((res)=>res.json()).then((json)=>{
        if (!json.data?.siteCultures?.length) return 0, $kdMEA.DEFAULT_LANGUAGE_DATA;
        const { processedDefaultLanguage: processedDefaultLanguage, processedSupported: processedSupported } = $de28171980b2041e$export$92cb25ec092104e6(json.data.siteCultures.find((siteCulture)=>siteCulture.default)?.culture || json.data.siteCultures[0].culture, json.data.siteCultures.map((siteCulture)=>siteCulture.culture), needVisemes);
        return {
            all: processedSupported,
            default: processedDefaultLanguage
        };
    }).catch((error)=>{
        console.log(error);
        return 0, $kdMEA.DEFAULT_LANGUAGE_DATA;
    });
    return languages;
};
const $de28171980b2041e$export$92cb25ec092104e6 = (defaultLanguage, supported, needVisemes)=>{
    const allowedLocales = needVisemes ? (0, $kucVP.allowedLocalesForMicrosoftWithVisemes) : (0, $kucVP.allowedLocalesForMicrosoftWithoutVisemes);
    let processedDefaultLanguage = allowedLocales.includes(defaultLanguage) ? defaultLanguage : 'fr-FR';
    const processedSupported = [];
    supported.forEach((culture)=>{
        // Fallback mechanism if the language code is not supported by Microsoft cognitive services
        if (!allowedLocales.includes(culture)) {
            const l = culture.split('-')[0];
            const otherLocalesFromSameLanguage = supported.filter((localeCode)=>localeCode.startsWith(`${l}-`)).find((locale)=>allowedLocales.includes(locale));
            // If we do find another locale code that contains the same language and is available for speech services, we dump the one that we are testing
            // Otherwise, we add the first available in the list of allowed ones if there is one of the same language.
            if (otherLocalesFromSameLanguage) {
                // If the dumped language is the default one, change it with the fallback one
                culture === defaultLanguage && (processedDefaultLanguage = otherLocalesFromSameLanguage);
                (0, $9P0Ec.addReplacementLocale)(culture, otherLocalesFromSameLanguage);
                console.log(`Retorik Framework > invalid locale "${culture}" was dumped because an existing locale for this language was found ("${otherLocalesFromSameLanguage}").`);
            } else {
                const fallback = allowedLocales.find((locale)=>locale.startsWith(`${l}-`));
                if (fallback) {
                    processedSupported.push(fallback);
                    // If the dumped language is the default one, change it with the fallback one
                    culture === defaultLanguage && (processedDefaultLanguage = fallback);
                    // We keep a relation between the dumped one and the replacement one in "dumpedLanguageFallback" to re-inject the dumped one in the activities so that Retorik Studio
                    // gets the same one as the one we fetched and not the replacement one
                    (0, $9P0Ec.addDumpedLanguageFallback)(fallback, culture);
                    (0, $9P0Ec.addReplacementLocale)(culture, fallback);
                    console.log(`Retorik Framework > invalid locale "${culture}" was replaced by "${fallback}".`);
                } else console.log(`Retorik Framework > invalid locale "${culture}" was dumped and no replacement was found for this language.`);
            }
        } else processedSupported.push(culture);
    });
    return {
        processedDefaultLanguage: processedDefaultLanguage,
        processedSupported: processedSupported
    };
};
var $de28171980b2041e$export$2e2bcd8739ae039 = $de28171980b2041e$var$fetchAvailableLanguages;

});
parcelRegister("9P0Ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b2cab4dfcfe505d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "openWidget", () => $7b2cab4dfcfe505d$export$a1c83309c736819f);
$parcel$export(module.exports, "closeWidget", () => $7b2cab4dfcfe505d$export$d27f1b0993b666c);
$parcel$export(module.exports, "toggleWidget", () => $7b2cab4dfcfe505d$export$77c0ba4d0d97cee5);
$parcel$export(module.exports, "toggleDisplay", () => $7b2cab4dfcfe505d$export$f0e9d14ede4c01bd);
$parcel$export(module.exports, "showAgent", () => $7b2cab4dfcfe505d$export$ae67eb518a2aae74);
$parcel$export(module.exports, "hideAgent", () => $7b2cab4dfcfe505d$export$e73dbd7ba351e3e);
$parcel$export(module.exports, "resetUtilsStore", () => $7b2cab4dfcfe505d$export$93b55f822ac81934);
$parcel$export(module.exports, "lockClickedButton", () => $7b2cab4dfcfe505d$export$5d55805fc8a86c05);
$parcel$export(module.exports, "sendActivity", () => $7b2cab4dfcfe505d$export$d4c8c6daac289378);
$parcel$export(module.exports, "addDetailedAttachmentTrigger", () => $7b2cab4dfcfe505d$export$d1f60bb847ecc604);
$parcel$export(module.exports, "setModalFullscreenContent", () => $7b2cab4dfcfe505d$export$4317154639841e84);
$parcel$export(module.exports, "setLocale", () => $7b2cab4dfcfe505d$export$c8aadf3621e41efb);
$parcel$export(module.exports, "resetLocaleStore", () => $7b2cab4dfcfe505d$export$3118ae18000e2700);
$parcel$export(module.exports, "addDumpedLanguageFallback", () => $7b2cab4dfcfe505d$export$5f8965892c631504);
$parcel$export(module.exports, "addReplacementLocale", () => $7b2cab4dfcfe505d$export$8de7f8944486b1fb);
$parcel$export(module.exports, "setValue", () => $7b2cab4dfcfe505d$export$80746c6bc6142fc8);
$parcel$export(module.exports, "setCurrentId", () => $7b2cab4dfcfe505d$export$a619c8fe018044c1);
$parcel$export(module.exports, "setToggleValue", () => $7b2cab4dfcfe505d$export$7fc8a028c7b38ace);
$parcel$export(module.exports, "addCurrentToggleId", () => $7b2cab4dfcfe505d$export$ff456dc518e4aa26);
$parcel$export(module.exports, "resetAdaptiveCardStore", () => $7b2cab4dfcfe505d$export$64bb98402f29970);
$parcel$export(module.exports, "setVisibility", () => $7b2cab4dfcfe505d$export$2c64211ecf98e50d);
$parcel$export(module.exports, "toggleVisibility", () => $7b2cab4dfcfe505d$export$7396a2167c7f755e);
$parcel$export(module.exports, "cancelCurrentUtterance", () => $7b2cab4dfcfe505d$export$f3aaae0c8197c567);
$parcel$export(module.exports, "toggleMicrophone", () => $7b2cab4dfcfe505d$export$39fcdeae376856e7);
$parcel$export(module.exports, "setMuted", () => $7b2cab4dfcfe505d$export$a1680ba91cc9be33);
$parcel$export(module.exports, "playExternalSynthesis", () => $7b2cab4dfcfe505d$export$99dcb7840cd85481);
$parcel$export(module.exports, "resetSpeechStore", () => $7b2cab4dfcfe505d$export$b6d2196a3ce412d8);
$parcel$export(module.exports, "setDisplaySubtitles", () => $7b2cab4dfcfe505d$export$708f3eb1d5828832);
$parcel$export(module.exports, "toggleSubtitles", () => $7b2cab4dfcfe505d$export$3fa7f3a227fc16cb);
$parcel$export(module.exports, "setAgentData", () => $7b2cab4dfcfe505d$export$a72b80ff363563a1);
$parcel$export(module.exports, "resetRetorikStore", () => $7b2cab4dfcfe505d$export$cd85ac4858c7290c);
$parcel$export(module.exports, "resetActivityStore", () => $7b2cab4dfcfe505d$export$b7b23f8e09258fa6);
$parcel$export(module.exports, "sendMessage", () => $7b2cab4dfcfe505d$export$465cb47180de50f0);
$parcel$export(module.exports, "sendEvent", () => $7b2cab4dfcfe505d$export$7329bcdc3edcd90e);
$parcel$export(module.exports, "pauseConversation", () => $7b2cab4dfcfe505d$export$7431bc5a5c7c9317);
$parcel$export(module.exports, "resumeConversation", () => $7b2cab4dfcfe505d$export$cceb853b29df842);
$parcel$export(module.exports, "sendMessageToChatbot", () => $7b2cab4dfcfe505d$export$255ebd0ca6bfba88);
$parcel$export(module.exports, "addExternalActivityHandler", () => $7b2cab4dfcfe505d$export$28afdcc603412603);
$parcel$export(module.exports, "setExternalActivityHandlers", () => $7b2cab4dfcfe505d$export$2c7ae0f34657d605);
$parcel$export(module.exports, "resetDirectlineStore", () => $7b2cab4dfcfe505d$export$8f3b2f6aa8e2c248);

var $bxRTa = parcelRequire("bxRTa");

var $9qyYE = parcelRequire("9qyYE");

var $4xGiN = parcelRequire("4xGiN");

var $2eBYD = parcelRequire("2eBYD");

var $6HxxJ = parcelRequire("6HxxJ");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $bWQ72 = parcelRequire("bWQ72");

var $hdMz2 = parcelRequire("hdMz2");
const $7b2cab4dfcfe505d$var$InputOutputHandler = ({ instanceId: instanceId })=>{
    const { closeWidget: closeWidget, openWidget: openWidget, toggleDisplay: toggleDisplay, toggleWidget: toggleWidget } = (0, $9qyYE.useWidgetStore)((state)=>state.actions);
    const { addDetailedAttachmentTrigger: addDetailedAttachmentTrigger, hideAgent: hideAgent, lockClickedButton: lockClickedButton, resetUtilsStore: resetUtilsStore, sendActivity: sendActivity, setCurrentCustomView: setCurrentCustomView, setCurrentSubView: setCurrentSubView, setDashboardOpened: setDashboardOpened, setModalFullscreenContent: setModalFullscreenContent, setPrintingCallback: setPrintingCallback, showAgent: showAgent } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const { setLocale: setLocale, resetLocaleStore: resetLocaleStore, addDumpedLanguageFallback: addDumpedLanguageFallback, addReplacementLocale: addReplacementLocale } = (0, $2eBYD.useLocaleStore)((state)=>state.actions);
    const { setValue: setValue, setCurrentId: setCurrentId, setToggleValue: setToggleValue, addCurrentToggleId: addCurrentToggleId, resetAdaptiveCardStore: resetAdaptiveCardStore } = (0, $6HxxJ.useAdaptiveCardStore)((state)=>state.actions);
    const { setVisibility: setVisibility, toggleVisibility: toggleVisibility } = (0, $9JLpC.useViewStore)((state)=>state.actions);
    const { setActiveRecognitionState: setActiveRecognitionState, cancelCurrentUtterance: cancelCurrentUtterance, setMuted: setMuted, setMode: setMode, playExternalSynthesis: playExternalSynthesis, resetSpeechStore: resetSpeechStore, toggleMicrophone: toggleMicrophone, askPermission: askPermission } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const isMicrophoneAllowed = (0, $giKuE.useSpeechStore)((state)=>state.isMicrophoneAllowed);
    const isMicrophoneAllowedRef = (0, $bxRTa.useRef)(isMicrophoneAllowed);
    const { setDisplaySubtitles: setDisplaySubtitles, toggleSubtitles: toggleSubtitles, setAgentData: setAgentData, setLoaderClosed: setLoaderClosed, resetRetorikStore: resetRetorikStore } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const resetActivityStore = (0, $bWQ72.useActivityStore)((state)=>state.actions.resetActivityStore);
    const { sendMessage: sendMessage, sendEvent: sendEvent, pauseConversation: pauseConversation, resumeConversation: resumeConversation, sendMessageToChatbot: sendMessageToChatbot, addExternalActivityHandler: addExternalActivityHandler, setExternalActivityHandlers: setExternalActivityHandlers, resetDirectlineStore: resetDirectlineStore } = (0, $hdMz2.useDirectlineStore)((state)=>state.actions);
    const handleCustomEvent = (event, method)=>{
        // Check if an instance id is given to use this method in a single instance of Retorik Framework when there are several
        const checkInstanceId = event.detail?.instanceId ? instanceId ? event.detail.instanceId === instanceId : false : true;
        if (checkInstanceId) // Add the parameters to the function depending on their number (up to 3)
        try {
            switch(event.detail?.values?.length){
                case 0:
                case undefined:
                    method();
                    break;
                case 1:
                    method(event.detail.values[0]);
                    break;
                case 2:
                    method(event.detail.values[0], event.detail.values[1]);
                    break;
                case 3:
                    method(event.detail.values[0], event.detail.values[1], event.detail.values[2]);
                    break;
            }
        } catch (e) {
            console.error(`Retorik Framework > failed to use ${method}`);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        isMicrophoneAllowedRef.current = isMicrophoneAllowed;
    }, [
        isMicrophoneAllowed
    ]);
    // Use refs to get updated states in native javascript events
    const handleToggleMicrophone = ()=>{
        isMicrophoneAllowedRef.current ? toggleMicrophone() : askPermission();
    };
    (0, $bxRTa.useEffect)(()=>{
        // Widget store events
        document.addEventListener('retorik_openWidget', (e)=>handleCustomEvent(e, openWidget));
        document.addEventListener('retorik_closeWidget', (e)=>handleCustomEvent(e, closeWidget));
        document.addEventListener('retorik_toggleWidget', (e)=>handleCustomEvent(e, toggleWidget));
        document.addEventListener('retorik_toggleDisplay', (e)=>handleCustomEvent(e, toggleDisplay));
        // Utils store events
        document.addEventListener('retorik_showAgent', (e)=>handleCustomEvent(e, showAgent));
        document.addEventListener('retorik_hideAgent', (e)=>handleCustomEvent(e, hideAgent));
        document.addEventListener('retorik_resetUtilsStore', (e)=>handleCustomEvent(e, resetUtilsStore));
        document.addEventListener('retorik_lockClickedButton', (e)=>handleCustomEvent(e, lockClickedButton));
        document.addEventListener('retorik_setCurrentCustomView', (e)=>handleCustomEvent(e, setCurrentCustomView));
        document.addEventListener('retorik_setCurrentSubView', (e)=>handleCustomEvent(e, setCurrentSubView));
        document.addEventListener('retorik_sendActivity', (e)=>handleCustomEvent(e, sendActivity));
        document.addEventListener('retorik_setModalFullscreenContent', (e)=>handleCustomEvent(e, setModalFullscreenContent));
        document.addEventListener('retorik_addDetailedAttachmentTrigger', (e)=>handleCustomEvent(e, addDetailedAttachmentTrigger));
        document.addEventListener('retorik_setPrintingCallback', (e)=>handleCustomEvent(e, setPrintingCallback));
        document.addEventListener('retorik_setDashboardOpened', (e)=>handleCustomEvent(e, setDashboardOpened));
        // Locale store events
        document.addEventListener('retorik_setLocale', (e)=>handleCustomEvent(e, setLocale));
        document.addEventListener('retorik_resetLocaleStore', (e)=>handleCustomEvent(e, resetLocaleStore));
        document.addEventListener('retorik_addDumpedLanguageFallback', (e)=>handleCustomEvent(e, addDumpedLanguageFallback));
        document.addEventListener('retorik_addReplacementLocale', (e)=>handleCustomEvent(e, addReplacementLocale));
        // Adaptive cards store events
        document.addEventListener('retorik_setValue', (e)=>handleCustomEvent(e, setValue));
        document.addEventListener('retorik_setCurrentId', (e)=>handleCustomEvent(e, setCurrentId));
        document.addEventListener('retorik_setToggleValue', (e)=>handleCustomEvent(e, setToggleValue));
        document.addEventListener('retorik_addCurrentToggleId', (e)=>handleCustomEvent(e, addCurrentToggleId));
        document.addEventListener('retorik_resetAdaptiveCardStore', (e)=>handleCustomEvent(e, resetAdaptiveCardStore));
        // View store utils
        document.addEventListener('retorik_setVisibility', (e)=>handleCustomEvent(e, setVisibility));
        document.addEventListener('retorik_toggleVisibility', (e)=>handleCustomEvent(e, toggleVisibility));
        // Speech store utils
        document.addEventListener('retorik_setActiveRecognitionState', (e)=>handleCustomEvent(e, setActiveRecognitionState));
        document.addEventListener('retorik_cancelCurrentUtterance', (e)=>handleCustomEvent(e, cancelCurrentUtterance));
        document.addEventListener('retorik_toggleMicrophone', handleToggleMicrophone);
        document.addEventListener('retorik_setMuted', (e)=>handleCustomEvent(e, setMuted));
        document.addEventListener('retorik_playExternalSynthesis', (e)=>handleCustomEvent(e, playExternalSynthesis));
        document.addEventListener('retorik_resetSpeechStore', (e)=>handleCustomEvent(e, resetSpeechStore));
        // Retorik store utils
        document.addEventListener('retorik_setDisplaySubtitles', (e)=>handleCustomEvent(e, setDisplaySubtitles));
        document.addEventListener('retorik_toggleSubtitles', (e)=>handleCustomEvent(e, toggleSubtitles));
        document.addEventListener('retorik_setAgentData', (e)=>handleCustomEvent(e, setAgentData));
        document.addEventListener('retorik_setMode', (e)=>handleCustomEvent(e, setMode));
        document.addEventListener('retorik_setLoaderClosed', (e)=>handleCustomEvent(e, setLoaderClosed));
        document.addEventListener('retorik_resetRetorikStore', (e)=>handleCustomEvent(e, resetRetorikStore));
        // Activity store utils
        document.addEventListener('retorik_resetActivityStore', (e)=>handleCustomEvent(e, resetActivityStore));
        // Directline store utils
        document.addEventListener('retorik_sendMessage', (e)=>handleCustomEvent(e, sendMessage));
        document.addEventListener('retorik_sendEvent', (e)=>handleCustomEvent(e, sendEvent));
        document.addEventListener('retorik_pauseConversation', (e)=>handleCustomEvent(e, pauseConversation));
        document.addEventListener('retorik_resumeConversation', (e)=>handleCustomEvent(e, resumeConversation));
        document.addEventListener('retorik_sendMessageToChatbot', (e)=>handleCustomEvent(e, sendMessageToChatbot));
        document.addEventListener('retorik_addExternalActivityHandler', (e)=>handleCustomEvent(e, addExternalActivityHandler));
        document.addEventListener('retorik_setExternalActivityHandlers', (e)=>handleCustomEvent(e, setExternalActivityHandlers));
        document.addEventListener('retorik_resetDirectlineStore', (e)=>handleCustomEvent(e, resetDirectlineStore));
        return ()=>{
            document.removeEventListener('retorik_openWidget', (e)=>handleCustomEvent(e, openWidget));
            document.removeEventListener('retorik_closeWidget', (e)=>handleCustomEvent(e, closeWidget));
            document.removeEventListener('retorik_toggleWidget', (e)=>handleCustomEvent(e, toggleWidget));
            document.removeEventListener('retorik_toggleDisplay', (e)=>handleCustomEvent(e, toggleDisplay));
            document.removeEventListener('retorik_showAgent', (e)=>handleCustomEvent(e, showAgent));
            document.removeEventListener('retorik_hideAgent', (e)=>handleCustomEvent(e, hideAgent));
            document.removeEventListener('retorik_resetUtilsStore', (e)=>handleCustomEvent(e, resetUtilsStore));
            document.removeEventListener('retorik_lockClickedButton', (e)=>handleCustomEvent(e, lockClickedButton));
            document.removeEventListener('retorik_setCurrentCustomView', (e)=>handleCustomEvent(e, setCurrentCustomView));
            document.removeEventListener('retorik_setCurrentSubView', (e)=>handleCustomEvent(e, setCurrentSubView));
            document.removeEventListener('retorik_sendActivity', (e)=>handleCustomEvent(e, sendActivity));
            document.removeEventListener('retorik_setModalFullscreenContent', (e)=>handleCustomEvent(e, setModalFullscreenContent));
            document.removeEventListener('retorik_addDetailedAttachmentTrigger', (e)=>handleCustomEvent(e, addDetailedAttachmentTrigger));
            document.removeEventListener('retorik_setPrintingCallback', (e)=>handleCustomEvent(e, setPrintingCallback));
            document.removeEventListener('retorik_setDashboardOpened', (e)=>handleCustomEvent(e, setDashboardOpened));
            document.removeEventListener('retorik_setLocale', (e)=>handleCustomEvent(e, setLocale));
            document.removeEventListener('retorik_resetLocaleStore', (e)=>handleCustomEvent(e, resetLocaleStore));
            document.removeEventListener('retorik_addDumpedLanguageFallback', (e)=>handleCustomEvent(e, addDumpedLanguageFallback));
            document.removeEventListener('retorik_addReplacementLocale', (e)=>handleCustomEvent(e, addReplacementLocale));
            document.removeEventListener('retorik_setValue', (e)=>handleCustomEvent(e, setValue));
            document.removeEventListener('retorik_setCurrentId', (e)=>handleCustomEvent(e, setCurrentId));
            document.removeEventListener('retorik_setToggleValue', (e)=>handleCustomEvent(e, setToggleValue));
            document.removeEventListener('retorik_addCurrentToggleId', (e)=>handleCustomEvent(e, addCurrentToggleId));
            document.removeEventListener('retorik_resetAdaptiveCardStore', (e)=>handleCustomEvent(e, resetAdaptiveCardStore));
            document.removeEventListener('retorik_setVisibility', (e)=>handleCustomEvent(e, setVisibility));
            document.removeEventListener('retorik_toggleVisibility', (e)=>handleCustomEvent(e, toggleVisibility));
            document.removeEventListener('retorik_setActiveRecognitionState', (e)=>handleCustomEvent(e, setActiveRecognitionState));
            document.removeEventListener('retorik_cancelCurrentUtterance', (e)=>handleCustomEvent(e, cancelCurrentUtterance));
            document.removeEventListener('retorik_toggleMicrophone', handleToggleMicrophone);
            document.removeEventListener('retorik_setMuted', (e)=>handleCustomEvent(e, setMuted));
            document.removeEventListener('retorik_playExternalSynthesis', (e)=>handleCustomEvent(e, playExternalSynthesis));
            document.removeEventListener('retorik_resetSpeechStore', (e)=>handleCustomEvent(e, resetSpeechStore));
            document.removeEventListener('retorik_setDisplaySubtitles', (e)=>handleCustomEvent(e, setDisplaySubtitles));
            document.removeEventListener('retorik_toggleSubtitles', (e)=>handleCustomEvent(e, toggleSubtitles));
            document.removeEventListener('retorik_setAgentData', (e)=>handleCustomEvent(e, setAgentData));
            document.removeEventListener('retorik_setMode', (e)=>handleCustomEvent(e, setMode));
            document.removeEventListener('retorik_setLoaderClosed', (e)=>handleCustomEvent(e, setLoaderClosed));
            document.removeEventListener('retorik_resetRetorikStore', (e)=>handleCustomEvent(e, resetRetorikStore));
            document.removeEventListener('retorik_resetActivityStore', (e)=>handleCustomEvent(e, resetActivityStore));
            document.removeEventListener('retorik_sendMessage', (e)=>handleCustomEvent(e, sendMessage));
            document.removeEventListener('retorik_sendEvent', (e)=>handleCustomEvent(e, sendEvent));
            document.removeEventListener('retorik_pauseConversation', (e)=>handleCustomEvent(e, pauseConversation));
            document.removeEventListener('retorik_resumeConversation', (e)=>handleCustomEvent(e, resumeConversation));
            document.removeEventListener('retorik_sendMessageToChatbot', (e)=>handleCustomEvent(e, sendMessageToChatbot));
            document.removeEventListener('retorik_addExternalActivityHandler', (e)=>handleCustomEvent(e, addExternalActivityHandler));
            document.removeEventListener('retorik_setExternalActivityHandlers', (e)=>handleCustomEvent(e, setExternalActivityHandlers));
            document.removeEventListener('retorik_resetDirectlineStore', (e)=>handleCustomEvent(e, resetDirectlineStore));
        };
    }, []);
    return null;
};
var $7b2cab4dfcfe505d$export$2e2bcd8739ae039 = $7b2cab4dfcfe505d$var$InputOutputHandler;
const $7b2cab4dfcfe505d$var$eventDispatch = (name, values, instanceId)=>{
    document.dispatchEvent(new CustomEvent(name, {
        detail: {
            instanceId: instanceId,
            values: values
        }
    }));
};
// Widget utils
const $7b2cab4dfcfe505d$export$a1c83309c736819f = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_openWidget', [], instanceId);
const $7b2cab4dfcfe505d$export$d27f1b0993b666c = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_closeWidget', [], instanceId);
const $7b2cab4dfcfe505d$export$77c0ba4d0d97cee5 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleWidget', [], instanceId);
const $7b2cab4dfcfe505d$export$f0e9d14ede4c01bd = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleDisplay', [], instanceId);
// Utils utils
const $7b2cab4dfcfe505d$export$ae67eb518a2aae74 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_showAgent', [], instanceId);
const $7b2cab4dfcfe505d$export$e73dbd7ba351e3e = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_hideAgent', [], instanceId);
const $7b2cab4dfcfe505d$export$93b55f822ac81934 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetUtilsStore', [], instanceId);
const $7b2cab4dfcfe505d$export$5d55805fc8a86c05 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_lockClickedButton', [], instanceId);
const $7b2cab4dfcfe505d$export$5a678fd51bd89633 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setCurrentCustomView', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$f0c096b4ecd7115d = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setCurrentSubView', [
        value
    ], instanceId);
/**
 * deprecated since v3.2.6
 */ const $7b2cab4dfcfe505d$export$d4c8c6daac289378 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendActivity', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$d1f60bb847ecc604 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addDetailedAttachmentTrigger', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$4317154639841e84 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setModalFullscreenContent', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$7f09d7ad7dbdcd2c = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setPrintingCallback', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$bbd7c92fc378d660 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setDashboardOpened', [
        value
    ], instanceId);
// Locale utils
const $7b2cab4dfcfe505d$export$c8aadf3621e41efb = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setLocale', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$3118ae18000e2700 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetLocaleStore', [], instanceId);
const $7b2cab4dfcfe505d$export$5f8965892c631504 = (key, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addDumpedLanguageFallback', [
        key,
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$8de7f8944486b1fb = (key, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addReplacementLocale', [
        key,
        value
    ], instanceId);
// Adaptive cards utils
const $7b2cab4dfcfe505d$export$80746c6bc6142fc8 = (id, value)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setValue', [
        id,
        value
    ], undefined);
const $7b2cab4dfcfe505d$export$a619c8fe018044c1 = (value)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setCurrentId', [
        value
    ], undefined);
const $7b2cab4dfcfe505d$export$7fc8a028c7b38ace = (id, value)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setToggleValue', [
        id,
        value
    ], undefined);
const $7b2cab4dfcfe505d$export$ff456dc518e4aa26 = (id, defaultValue)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addCurrentToggleId', [
        id,
        defaultValue
    ], undefined);
const $7b2cab4dfcfe505d$export$64bb98402f29970 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetAdaptiveCardStore', [], instanceId);
// View utils
const $7b2cab4dfcfe505d$export$2c64211ecf98e50d = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setVisibility', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$7396a2167c7f755e = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleVisibility', [], instanceId);
// Speech utils
const $7b2cab4dfcfe505d$export$45913366c4ba414f = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setActiveRecognitionState', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$f3aaae0c8197c567 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_cancelCurrentUtterance', [], instanceId);
const $7b2cab4dfcfe505d$export$39fcdeae376856e7 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleMicrophone', [], instanceId);
const $7b2cab4dfcfe505d$export$a1680ba91cc9be33 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setMuted', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$99dcb7840cd85481 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_playExternalSynthesis', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$b6d2196a3ce412d8 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetSpeechStore', [], instanceId);
// Retorik utils
const $7b2cab4dfcfe505d$export$708f3eb1d5828832 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setDisplaySubtitles', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$3fa7f3a227fc16cb = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_toggleSubtitles', [], instanceId);
const $7b2cab4dfcfe505d$export$a72b80ff363563a1 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setAgentData', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$d4f039427a1beff1 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setMode', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$982d69b78a955aaf = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setLoaderClosed', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$cd85ac4858c7290c = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetRetorikStore', [], instanceId);
// Activity utils
const $7b2cab4dfcfe505d$export$b7b23f8e09258fa6 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetActivityStore', [], instanceId);
// Directline utils
const $7b2cab4dfcfe505d$export$465cb47180de50f0 = (text, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendMessage', [
        text,
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$7329bcdc3edcd90e = (name, value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendEvent', [
        name,
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$7431bc5a5c7c9317 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_pauseConversation', [], instanceId);
const $7b2cab4dfcfe505d$export$cceb853b29df842 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resumeConversation', [], instanceId);
const $7b2cab4dfcfe505d$export$255ebd0ca6bfba88 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_sendMessageToChatbot', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$28afdcc603412603 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_addExternalActivityHandler', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$2c7ae0f34657d605 = (value, instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_setExternalActivityHandlers', [
        value
    ], instanceId);
const $7b2cab4dfcfe505d$export$8f3b2f6aa8e2c248 = (instanceId)=>$7b2cab4dfcfe505d$var$eventDispatch('retorik_resetDirectlineStore', [], instanceId);

});
parcelRegister("9qyYE", function(module, exports) {

$parcel$export(module.exports, "useWidgetStore", () => $4d8cb10e2b1433b7$export$d95eb9b67812311f);
$parcel$export(module.exports, "default", () => $4d8cb10e2b1433b7$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");
const $4d8cb10e2b1433b7$var$createWidgetStore = ()=>(0, $jH1Jg.createStore)((set)=>{
        return {
            widgetDisplayType: 'large',
            open: false,
            loaded: false,
            actions: {
                openWidget: ()=>{
                    set({
                        open: true,
                        loaded: true
                    });
                },
                closeWidget: ()=>{
                    set({
                        open: false,
                        loaded: true
                    });
                },
                toggleWidget: ()=>{
                    set((state)=>({
                            open: !state.open,
                            loaded: true
                        }));
                },
                toggleDisplay: ()=>{
                    set((state)=>({
                            widgetDisplayType: state.widgetDisplayType === 'large' ? 'thumbnail' : 'large'
                        }));
                }
            }
        };
    });
const $4d8cb10e2b1433b7$var$WidgetContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $4d8cb10e2b1433b7$export$d95eb9b67812311f = (selector)=>{
    const store = (0, $bxRTa.useContext)($4d8cb10e2b1433b7$var$WidgetContext);
    if (!store) throw new Error('Retorik Framework > useWidgetStore must be used within WidgetProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $4d8cb10e2b1433b7$var$WidgetProvider = ({ children: children })=>{
    const [store] = (0, $bxRTa.useState)(()=>$4d8cb10e2b1433b7$var$createWidgetStore());
    return /*#__PURE__*/ (0, $fl9nK.jsx)($4d8cb10e2b1433b7$var$WidgetContext.Provider, {
        value: store,
        children: children
    });
};
var $4d8cb10e2b1433b7$export$2e2bcd8739ae039 = $4d8cb10e2b1433b7$var$WidgetProvider;

});

parcelRegister("6HxxJ", function(module, exports) {

$parcel$export(module.exports, "useAdaptiveCardStore", () => $e522b0a402af6b07$export$a8a6e22a57e6f7d2);
$parcel$export(module.exports, "default", () => $e522b0a402af6b07$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $drUL7 = parcelRequire("drUL7");

var $f74jF = parcelRequire("f74jF");
const $e522b0a402af6b07$var$initialState = {
    adaptiveCardHostConfig: {},
    restoreInputsState: false,
    values: new Map(),
    currentId: undefined,
    currentToggleIds: [],
    currentValue: undefined
};
const $e522b0a402af6b07$var$createLocaleStore = ()=>(0, $jH1Jg.createStore)((set)=>{
        return {
            ...$e522b0a402af6b07$var$initialState,
            actions: {
                setAdaptiveCardHostConfig: (primary, background)=>{
                    const customAdaptiveCardHostConfig = (0, $f74jF.default)(primary, background);
                    set({
                        adaptiveCardHostConfig: new (0, $drUL7.HostConfig)(customAdaptiveCardHostConfig)
                    });
                },
                setValue: (id, value)=>{
                    set((state)=>{
                        if (id === state.currentId) {
                            const currentValues = state.values;
                            state.restoreInputsState && currentValues.set(id, value);
                            return {
                                values: currentValues,
                                currentValue: {
                                    [id]: value
                                }
                            };
                        }
                        return state;
                    });
                },
                setToggleValue: (id, value)=>{
                    set((state)=>{
                        if (state.currentToggleIds.includes(id)) {
                            const currentValues = state.values;
                            state.restoreInputsState && currentValues.set(id, value);
                            const tempCurrentValue = state.currentValue || {};
                            state.currentToggleIds.forEach((identifier)=>{
                                if (identifier === id) tempCurrentValue[identifier] = value;
                                else {
                                    const tempValueUntyped = state.currentValue?.[identifier] || false;
                                    tempCurrentValue[identifier] = Array.isArray(tempValueUntyped) ? false : tempValueUntyped;
                                }
                            });
                            return {
                                values: currentValues,
                                currentValue: tempCurrentValue
                            };
                        }
                        return state;
                    });
                },
                setCurrentId: (value)=>{
                    set({
                        currentId: value,
                        currentValue: undefined,
                        currentToggleIds: []
                    });
                },
                addCurrentToggleId: (id, defaultValue)=>{
                    set((state)=>{
                        const currentValues = state.values;
                        const currentToggleIds = state.currentToggleIds;
                        currentValues.set(id, defaultValue);
                        return {
                            values: currentValues,
                            currentToggleIds: [
                                ...currentToggleIds,
                                id
                            ]
                        };
                    });
                },
                setRestoreInputsState: (value)=>{
                    set({
                        restoreInputsState: value
                    });
                },
                resetAdaptiveCardStore: ()=>{
                    set({
                        ...$e522b0a402af6b07$var$initialState
                    });
                }
            }
        };
    });
const $e522b0a402af6b07$var$AdaptiveCardContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $e522b0a402af6b07$export$a8a6e22a57e6f7d2 = (selector)=>{
    const store = (0, $bxRTa.useContext)($e522b0a402af6b07$var$AdaptiveCardContext);
    if (!store) throw new Error('Retorik Framework > useAdaptiveCardStore must be used within AdaptiveCardProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $e522b0a402af6b07$var$AdaptiveCardProvider = ({ children: children })=>{
    const [store] = (0, $bxRTa.useState)(()=>$e522b0a402af6b07$var$createLocaleStore());
    return /*#__PURE__*/ (0, $fl9nK.jsx)($e522b0a402af6b07$var$AdaptiveCardContext.Provider, {
        value: store,
        children: children
    });
};
var $e522b0a402af6b07$export$2e2bcd8739ae039 = $e522b0a402af6b07$var$AdaptiveCardProvider;

});
parcelRegister("drUL7", function(module, exports) {
"use strict";
var $9ca9d31e6ae36725$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9ca9d31e6ae36725$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9ca9d31e6ae36725$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$9ca9d31e6ae36725$var$__exportStar((parcelRequire("24F6S")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("gIXBn")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("6BHj7")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("F6YrP")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("5Ougt")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("7Lc5Q")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("8kDQQ")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("2Zn2I")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("dUjDB")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("6XfIC")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("99lCx")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("bPIqH")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("krFBf")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("kBxrI")), module.exports);

$9ca9d31e6ae36725$var$__exportStar((parcelRequire("5PICj")), module.exports);

});
parcelRegister("24F6S", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Strings = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $182bd8154b9f9aad$var$Strings = /** @class */ function() {
    function Strings() {}
    Strings.errors = {
        unknownElementType: function(typeName) {
            return "Unknown element type \"".concat(typeName, "\". Fallback will be used if present.");
        },
        unknownActionType: function(typeName) {
            return "Unknown action type \"".concat(typeName, "\". Fallback will be used if present.");
        },
        elementTypeNotAllowed: function(typeName) {
            return "Element type \"".concat(typeName, "\" is not allowed in this context.");
        },
        actionTypeNotAllowed: function(typeName) {
            return "Action type \"".concat(typeName, "\" is not allowed in this context.");
        },
        invalidPropertyValue: function(value, propertyName) {
            return "Invalid value \"".concat(value, "\" for property \"").concat(propertyName, "\".");
        },
        showCardMustHaveCard: function() {
            return "\"An Action.ShowCard must have its \"card\" property set to a valid AdaptiveCard object.";
        },
        invalidColumnWidth: function(invalidWidth) {
            return "Invalid column width \"".concat(invalidWidth, "\" - defaulting to \"auto\".");
        },
        invalidCardVersion: function(defaultingToVersion) {
            return "Invalid card version. Defaulting to \"".concat(defaultingToVersion, "\".");
        },
        invalidVersionString: function(versionString) {
            return "Invalid version string \"".concat(versionString, "\".");
        },
        propertyValueNotSupported: function(value, propertyName, supportedInVersion, versionUsed) {
            return "Value \"".concat(value, "\" for property \"").concat(propertyName, "\" is supported in version ").concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        propertyNotSupported: function(propertyName, supportedInVersion, versionUsed) {
            return "Property \"".concat(propertyName, "\" is supported in version ").concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        indexOutOfRange: function(index) {
            return "Index out of range (".concat(index, ").");
        },
        elementCannotBeUsedAsInline: function() {
            return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
        },
        inlineAlreadyParented: function() {
            return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
        },
        interactivityNotAllowed: function() {
            return "Interactivity is not allowed.";
        },
        inputsMustHaveUniqueId: function() {
            return "All inputs must have a unique Id.";
        },
        choiceSetMustHaveAtLeastOneChoice: function() {
            return "An Input.ChoiceSet must have at least one choice defined.";
        },
        choiceSetChoicesMustHaveTitleAndValue: function() {
            return "All choices in an Input.ChoiceSet must have their title and value properties set.";
        },
        propertyMustBeSet: function(propertyName) {
            return "Property \"".concat(propertyName, "\" must be set.");
        },
        actionHttpHeadersMustHaveNameAndValue: function() {
            return "All headers of an Action.Http must have their name and value properties set.";
        },
        tooManyActions: function(maximumActions) {
            return "Maximum number of actions exceeded (".concat(maximumActions, ").");
        },
        tooLittleTimeDelay: function(minAutoplayDelay) {
            return "Autoplay Delay is too short (".concat(minAutoplayDelay, ").");
        },
        tooManyCarouselPages: function(maxCarouselPages) {
            return "Maximum number of Carousel pages exceeded (".concat(maxCarouselPages, ").");
        },
        invalidInitialPageIndex: function(initialPageIndex) {
            return "InitialPage for carousel is invalid (".concat(initialPageIndex, ").");
        },
        columnAlreadyBelongsToAnotherSet: function() {
            return "This column already belongs to another ColumnSet.";
        },
        invalidCardType: function() {
            return "Invalid or missing card type. Make sure the card's type property is set to \"AdaptiveCard\".";
        },
        unsupportedCardVersion: function(version, maxSupportedVersion) {
            return "The specified card version (".concat(version, ") is not supported or still in preview. The latest released card version is ").concat(maxSupportedVersion, ".");
        },
        duplicateId: function(id) {
            return "Duplicate Id \"".concat(id, "\".");
        },
        markdownProcessingNotEnabled: function() {
            return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
        },
        processMarkdownEventRemoved: function() {
            return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
        },
        elementAlreadyParented: function() {
            return "The element already belongs to another container.";
        },
        actionAlreadyParented: function() {
            return "The action already belongs to another element.";
        },
        elementTypeNotStandalone: function(typeName) {
            return "Elements of type ".concat(typeName, " cannot be used as standalone elements.");
        },
        invalidInputLabelWidth: function() {
            return "Invalid input label width. Defaulting to label width from host config.";
        }
    };
    Strings.magicCodeInputCard = {
        tryAgain: function() {
            return "That didn't work... let's try again.";
        },
        pleaseLogin: function() {
            return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
        },
        enterMagicCode: function() {
            return "Enter magic code";
        },
        pleaseEnterMagicCodeYouReceived: function() {
            return "Please enter the magic code you received.";
        },
        submit: function() {
            return "Submit";
        },
        cancel: function() {
            return "Cancel";
        },
        somethingWentWrong: function() {
            return "Something went wrong. This action can't be handled.";
        },
        authenticationFailed: function() {
            return "Authentication failed.";
        }
    };
    Strings.runtime = {
        automaticRefreshPaused: function() {
            return "Automatic refresh paused.";
        },
        clckToRestartAutomaticRefresh: function() {
            return "Click to restart.";
        },
        refreshThisCard: function() {
            return "Refresh this card";
        }
    };
    Strings.hints = {
        dontUseWeightedAndStrecthedColumnsInSameSet: function() {
            return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
        }
    };
    Strings.defaults = {
        inlineActionTitle: function() {
            return "Inline Action";
        },
        overflowButtonText: function() {
            return "...";
        },
        overflowButtonTooltip: function() {
            return "More options";
        },
        emptyElementText: function(elementType) {
            return "Empty ".concat(elementType);
        },
        mediaPlayerAriaLabel: function() {
            return "Media content";
        },
        mediaPlayerPlayMedia: function() {
            return "Play media";
        },
        youTubeVideoPlayer: function() {
            return "YouTube video player";
        },
        vimeoVideoPlayer: function() {
            return "Vimeo video player";
        },
        dailymotionVideoPlayer: function() {
            return "Dailymotion video player";
        },
        carouselNavigationPreviousTooltip: function() {
            return "Previous carousel page";
        },
        carouselNavigationNextTooltip: function() {
            return "Next carousel page";
        }
    };
    return Strings;
}();
module.exports.Strings = $182bd8154b9f9aad$var$Strings;

});

parcelRegister("gIXBn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionRole = module.exports.CarouselInteractionEvent = module.exports.LogLevel = module.exports.RefreshMode = module.exports.TypeErrorType = module.exports.ContainerFitStatus = module.exports.ValidationEvent = module.exports.ValidationPhase = module.exports.InputLabelPosition = module.exports.InputTextStyle = module.exports.ActionIconPlacement = module.exports.FillMode = module.exports.Orientation = module.exports.ShowCardActionMode = module.exports.ImageStyle = module.exports.ActionAlignment = module.exports.VerticalAlignment = module.exports.HorizontalAlignment = module.exports.TextColor = module.exports.Spacing = module.exports.FontType = module.exports.TextWeight = module.exports.InputStyle = module.exports.TextSize = module.exports.SizeUnit = module.exports.ImageSetPresentationStyle = module.exports.ImageSize = module.exports.Size = module.exports.ActionMode = module.exports.ActionStyle = module.exports.ContainerStyle = void 0;
/*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.

    Also note the "weird" way these readonly fields are declared is to work around
    a breaking change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    and adopt this syntax for all other static readonly fields.
*/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $c2cefd104394690b$var$ContainerStyle = /** @class */ function() {
    function ContainerStyle() {}
    ContainerStyle.Default = "default";
    ContainerStyle.Emphasis = "emphasis";
    ContainerStyle.Accent = "accent";
    ContainerStyle.Good = "good";
    ContainerStyle.Attention = "attention";
    ContainerStyle.Warning = "warning";
    return ContainerStyle;
}();
module.exports.ContainerStyle = $c2cefd104394690b$var$ContainerStyle;
var $c2cefd104394690b$var$ActionStyle = /** @class */ function() {
    function ActionStyle() {}
    ActionStyle.Default = "default";
    ActionStyle.Positive = "positive";
    ActionStyle.Destructive = "destructive";
    return ActionStyle;
}();
module.exports.ActionStyle = $c2cefd104394690b$var$ActionStyle;
var $c2cefd104394690b$var$ActionMode = /** @class */ function() {
    function ActionMode() {}
    ActionMode.Primary = "primary";
    ActionMode.Secondary = "secondary";
    return ActionMode;
}();
module.exports.ActionMode = $c2cefd104394690b$var$ActionMode;
/* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $c2cefd104394690b$var$Size;
(function(Size) {
    Size[Size["Auto"] = 0] = "Auto";
    Size[Size["Stretch"] = 1] = "Stretch";
    Size[Size["Small"] = 2] = "Small";
    Size[Size["Medium"] = 3] = "Medium";
    Size[Size["Large"] = 4] = "Large";
})($c2cefd104394690b$var$Size = module.exports.Size || (module.exports.Size = {}));
var $c2cefd104394690b$var$ImageSize;
(function(ImageSize) {
    ImageSize[ImageSize["Small"] = 0] = "Small";
    ImageSize[ImageSize["Medium"] = 1] = "Medium";
    ImageSize[ImageSize["Large"] = 2] = "Large";
})($c2cefd104394690b$var$ImageSize = module.exports.ImageSize || (module.exports.ImageSize = {}));
var $c2cefd104394690b$var$ImageSetPresentationStyle;
(function(ImageSetPresentationStyle) {
    ImageSetPresentationStyle[ImageSetPresentationStyle["Default"] = 0] = "Default";
    ImageSetPresentationStyle[ImageSetPresentationStyle["Stacked"] = 1] = "Stacked";
})($c2cefd104394690b$var$ImageSetPresentationStyle = module.exports.ImageSetPresentationStyle || (module.exports.ImageSetPresentationStyle = {}));
var $c2cefd104394690b$var$SizeUnit;
(function(SizeUnit) {
    SizeUnit[SizeUnit["Weight"] = 0] = "Weight";
    SizeUnit[SizeUnit["Pixel"] = 1] = "Pixel";
})($c2cefd104394690b$var$SizeUnit = module.exports.SizeUnit || (module.exports.SizeUnit = {}));
var $c2cefd104394690b$var$TextSize;
(function(TextSize) {
    TextSize[TextSize["Small"] = 0] = "Small";
    TextSize[TextSize["Default"] = 1] = "Default";
    TextSize[TextSize["Medium"] = 2] = "Medium";
    TextSize[TextSize["Large"] = 3] = "Large";
    TextSize[TextSize["ExtraLarge"] = 4] = "ExtraLarge";
})($c2cefd104394690b$var$TextSize = module.exports.TextSize || (module.exports.TextSize = {}));
var $c2cefd104394690b$var$InputStyle;
(function(InputStyle) {
    InputStyle[InputStyle["RevealOnHover"] = 0] = "RevealOnHover";
    InputStyle[InputStyle["Default"] = 1] = "Default";
})($c2cefd104394690b$var$InputStyle = module.exports.InputStyle || (module.exports.InputStyle = {}));
var $c2cefd104394690b$var$TextWeight;
(function(TextWeight) {
    TextWeight[TextWeight["Lighter"] = 0] = "Lighter";
    TextWeight[TextWeight["Default"] = 1] = "Default";
    TextWeight[TextWeight["Bolder"] = 2] = "Bolder";
})($c2cefd104394690b$var$TextWeight = module.exports.TextWeight || (module.exports.TextWeight = {}));
var $c2cefd104394690b$var$FontType;
(function(FontType) {
    FontType[FontType["Default"] = 0] = "Default";
    FontType[FontType["Monospace"] = 1] = "Monospace";
})($c2cefd104394690b$var$FontType = module.exports.FontType || (module.exports.FontType = {}));
var $c2cefd104394690b$var$Spacing;
(function(Spacing) {
    Spacing[Spacing["None"] = 0] = "None";
    Spacing[Spacing["Small"] = 1] = "Small";
    Spacing[Spacing["Default"] = 2] = "Default";
    Spacing[Spacing["Medium"] = 3] = "Medium";
    Spacing[Spacing["Large"] = 4] = "Large";
    Spacing[Spacing["ExtraLarge"] = 5] = "ExtraLarge";
    Spacing[Spacing["Padding"] = 6] = "Padding";
})($c2cefd104394690b$var$Spacing = module.exports.Spacing || (module.exports.Spacing = {}));
var $c2cefd104394690b$var$TextColor;
(function(TextColor) {
    TextColor[TextColor["Default"] = 0] = "Default";
    TextColor[TextColor["Dark"] = 1] = "Dark";
    TextColor[TextColor["Light"] = 2] = "Light";
    TextColor[TextColor["Accent"] = 3] = "Accent";
    TextColor[TextColor["Good"] = 4] = "Good";
    TextColor[TextColor["Warning"] = 5] = "Warning";
    TextColor[TextColor["Attention"] = 6] = "Attention";
})($c2cefd104394690b$var$TextColor = module.exports.TextColor || (module.exports.TextColor = {}));
var $c2cefd104394690b$var$HorizontalAlignment;
(function(HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})($c2cefd104394690b$var$HorizontalAlignment = module.exports.HorizontalAlignment || (module.exports.HorizontalAlignment = {}));
var $c2cefd104394690b$var$VerticalAlignment;
(function(VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
    VerticalAlignment[VerticalAlignment["Center"] = 1] = "Center";
    VerticalAlignment[VerticalAlignment["Bottom"] = 2] = "Bottom";
})($c2cefd104394690b$var$VerticalAlignment = module.exports.VerticalAlignment || (module.exports.VerticalAlignment = {}));
var $c2cefd104394690b$var$ActionAlignment;
(function(ActionAlignment) {
    ActionAlignment[ActionAlignment["Left"] = 0] = "Left";
    ActionAlignment[ActionAlignment["Center"] = 1] = "Center";
    ActionAlignment[ActionAlignment["Right"] = 2] = "Right";
    ActionAlignment[ActionAlignment["Stretch"] = 3] = "Stretch";
})($c2cefd104394690b$var$ActionAlignment = module.exports.ActionAlignment || (module.exports.ActionAlignment = {}));
var $c2cefd104394690b$var$ImageStyle;
(function(ImageStyle) {
    ImageStyle[ImageStyle["Default"] = 0] = "Default";
    ImageStyle[ImageStyle["Person"] = 1] = "Person";
})($c2cefd104394690b$var$ImageStyle = module.exports.ImageStyle || (module.exports.ImageStyle = {}));
var $c2cefd104394690b$var$ShowCardActionMode;
(function(ShowCardActionMode) {
    ShowCardActionMode[ShowCardActionMode["Inline"] = 0] = "Inline";
    ShowCardActionMode[ShowCardActionMode["Popup"] = 1] = "Popup";
})($c2cefd104394690b$var$ShowCardActionMode = module.exports.ShowCardActionMode || (module.exports.ShowCardActionMode = {}));
var $c2cefd104394690b$var$Orientation;
(function(Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})($c2cefd104394690b$var$Orientation = module.exports.Orientation || (module.exports.Orientation = {}));
var $c2cefd104394690b$var$FillMode;
(function(FillMode) {
    FillMode[FillMode["Cover"] = 0] = "Cover";
    FillMode[FillMode["RepeatHorizontally"] = 1] = "RepeatHorizontally";
    FillMode[FillMode["RepeatVertically"] = 2] = "RepeatVertically";
    FillMode[FillMode["Repeat"] = 3] = "Repeat";
})($c2cefd104394690b$var$FillMode = module.exports.FillMode || (module.exports.FillMode = {}));
var $c2cefd104394690b$var$ActionIconPlacement;
(function(ActionIconPlacement) {
    ActionIconPlacement[ActionIconPlacement["LeftOfTitle"] = 0] = "LeftOfTitle";
    ActionIconPlacement[ActionIconPlacement["AboveTitle"] = 1] = "AboveTitle";
})($c2cefd104394690b$var$ActionIconPlacement = module.exports.ActionIconPlacement || (module.exports.ActionIconPlacement = {}));
var $c2cefd104394690b$var$InputTextStyle;
(function(InputTextStyle) {
    InputTextStyle[InputTextStyle["Text"] = 0] = "Text";
    InputTextStyle[InputTextStyle["Tel"] = 1] = "Tel";
    InputTextStyle[InputTextStyle["Url"] = 2] = "Url";
    InputTextStyle[InputTextStyle["Email"] = 3] = "Email";
    InputTextStyle[InputTextStyle["Password"] = 4] = "Password";
})($c2cefd104394690b$var$InputTextStyle = module.exports.InputTextStyle || (module.exports.InputTextStyle = {}));
var $c2cefd104394690b$var$InputLabelPosition;
(function(InputLabelPosition) {
    InputLabelPosition[InputLabelPosition["Inline"] = 0] = "Inline";
    InputLabelPosition[InputLabelPosition["Above"] = 1] = "Above";
})($c2cefd104394690b$var$InputLabelPosition = module.exports.InputLabelPosition || (module.exports.InputLabelPosition = {}));
var $c2cefd104394690b$var$ValidationPhase;
(function(ValidationPhase) {
    ValidationPhase[ValidationPhase["Parse"] = 0] = "Parse";
    ValidationPhase[ValidationPhase["ToJSON"] = 1] = "ToJSON";
    ValidationPhase[ValidationPhase["Validation"] = 2] = "Validation";
})($c2cefd104394690b$var$ValidationPhase = module.exports.ValidationPhase || (module.exports.ValidationPhase = {}));
var $c2cefd104394690b$var$ValidationEvent;
(function(ValidationEvent) {
    ValidationEvent[ValidationEvent["Hint"] = 0] = "Hint";
    ValidationEvent[ValidationEvent["ActionTypeNotAllowed"] = 1] = "ActionTypeNotAllowed";
    ValidationEvent[ValidationEvent["CollectionCantBeEmpty"] = 2] = "CollectionCantBeEmpty";
    ValidationEvent[ValidationEvent["Deprecated"] = 3] = "Deprecated";
    ValidationEvent[ValidationEvent["ElementTypeNotAllowed"] = 4] = "ElementTypeNotAllowed";
    ValidationEvent[ValidationEvent["InteractivityNotAllowed"] = 5] = "InteractivityNotAllowed";
    ValidationEvent[ValidationEvent["InvalidPropertyValue"] = 6] = "InvalidPropertyValue";
    ValidationEvent[ValidationEvent["MissingCardType"] = 7] = "MissingCardType";
    ValidationEvent[ValidationEvent["PropertyCantBeNull"] = 8] = "PropertyCantBeNull";
    ValidationEvent[ValidationEvent["TooManyActions"] = 9] = "TooManyActions";
    ValidationEvent[ValidationEvent["UnknownActionType"] = 10] = "UnknownActionType";
    ValidationEvent[ValidationEvent["UnknownElementType"] = 11] = "UnknownElementType";
    ValidationEvent[ValidationEvent["UnsupportedCardVersion"] = 12] = "UnsupportedCardVersion";
    ValidationEvent[ValidationEvent["DuplicateId"] = 13] = "DuplicateId";
    ValidationEvent[ValidationEvent["UnsupportedProperty"] = 14] = "UnsupportedProperty";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveLabel"] = 15] = "RequiredInputsShouldHaveLabel";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveErrorMessage"] = 16] = "RequiredInputsShouldHaveErrorMessage";
    ValidationEvent[ValidationEvent["Other"] = 17] = "Other";
})($c2cefd104394690b$var$ValidationEvent = module.exports.ValidationEvent || (module.exports.ValidationEvent = {}));
var $c2cefd104394690b$var$ContainerFitStatus;
(function(ContainerFitStatus) {
    ContainerFitStatus[ContainerFitStatus["FullyInContainer"] = 0] = "FullyInContainer";
    ContainerFitStatus[ContainerFitStatus["Overflowing"] = 1] = "Overflowing";
    ContainerFitStatus[ContainerFitStatus["FullyOutOfContainer"] = 2] = "FullyOutOfContainer";
})($c2cefd104394690b$var$ContainerFitStatus = module.exports.ContainerFitStatus || (module.exports.ContainerFitStatus = {}));
var $c2cefd104394690b$var$TypeErrorType;
(function(TypeErrorType) {
    TypeErrorType[TypeErrorType["UnknownType"] = 0] = "UnknownType";
    TypeErrorType[TypeErrorType["ForbiddenType"] = 1] = "ForbiddenType";
})($c2cefd104394690b$var$TypeErrorType = module.exports.TypeErrorType || (module.exports.TypeErrorType = {}));
var $c2cefd104394690b$var$RefreshMode;
(function(RefreshMode) {
    RefreshMode[RefreshMode["Disabled"] = 0] = "Disabled";
    RefreshMode[RefreshMode["Manual"] = 1] = "Manual";
    RefreshMode[RefreshMode["Automatic"] = 2] = "Automatic";
})($c2cefd104394690b$var$RefreshMode = module.exports.RefreshMode || (module.exports.RefreshMode = {}));
var $c2cefd104394690b$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Info"] = 0] = "Info";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Error"] = 2] = "Error";
})($c2cefd104394690b$var$LogLevel = module.exports.LogLevel || (module.exports.LogLevel = {}));
var $c2cefd104394690b$var$CarouselInteractionEvent;
(function(CarouselInteractionEvent) {
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationNext"] = 0] = "NavigationNext";
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationPrevious"] = 1] = "NavigationPrevious";
    CarouselInteractionEvent[CarouselInteractionEvent["Pagination"] = 2] = "Pagination";
    CarouselInteractionEvent[CarouselInteractionEvent["Autoplay"] = 3] = "Autoplay";
})($c2cefd104394690b$var$CarouselInteractionEvent = module.exports.CarouselInteractionEvent || (module.exports.CarouselInteractionEvent = {}));
var $c2cefd104394690b$var$ActionRole;
(function(ActionRole) {
    ActionRole[ActionRole["Button"] = 0] = "Button";
    ActionRole[ActionRole["Link"] = 1] = "Link";
    ActionRole[ActionRole["Tab"] = 2] = "Tab";
    ActionRole[ActionRole["Menu"] = 3] = "Menu";
    ActionRole[ActionRole["MenuItem"] = 4] = "MenuItem";
})($c2cefd104394690b$var$ActionRole = module.exports.ActionRole || (module.exports.ActionRole = {}));

});

parcelRegister("6BHj7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = module.exports.SizeAndUnit = module.exports.PaddingDefinition = module.exports.SpacingDefinition = module.exports.StringWithSubstitutions = module.exports.ContentTypes = module.exports.GlobalSettings = void 0;

var $gIXBn = parcelRequire("gIXBn");
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $4cf7cab40de2f538$var$GlobalSettings = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.useAdvancedTextBlockTruncation = true;
    GlobalSettings.useAdvancedCardBottomTruncation = false;
    GlobalSettings.useMarkdownInRadioButtonAndCheckbox = true;
    GlobalSettings.allowMarkForTextHighlighting = false;
    GlobalSettings.alwaysBleedSeparators = false;
    GlobalSettings.enableFullJsonRoundTrip = false;
    GlobalSettings.displayInputValidationErrors = true;
    GlobalSettings.allowPreProcessingPropertyValues = false;
    GlobalSettings.setTabIndexAtCardRoot = true;
    GlobalSettings.enableFallback = true;
    GlobalSettings.useWebkitLineClamp = true;
    GlobalSettings.allowMoreThanMaxActionsInOverflowMenu = false;
    GlobalSettings.removePaddingFromContainersWithBackgroundImage = false;
    GlobalSettings.resetInputsDirtyStateAfterActionExecution = true;
    GlobalSettings.applets = {
        logEnabled: true,
        logLevel: $gIXBn.LogLevel.Error,
        maximumRetryAttempts: 3,
        defaultTimeBetweenRetryAttempts: 3000,
        authPromptWidth: 400,
        authPromptHeight: 600,
        refresh: {
            mode: $gIXBn.RefreshMode.Manual,
            timeBetweenAutomaticRefreshes: 3000,
            maximumConsecutiveAutomaticRefreshes: 3,
            allowManualRefreshesAfterAutomaticRefreshes: true
        }
    };
    return GlobalSettings;
}();
module.exports.GlobalSettings = $4cf7cab40de2f538$var$GlobalSettings;
module.exports.ContentTypes = {
    applicationJson: "application/json",
    applicationXWwwFormUrlencoded: "application/x-www-form-urlencoded"
};
var $4cf7cab40de2f538$var$StringWithSubstitutions = /** @class */ function() {
    function StringWithSubstitutions() {
        this._isProcessed = false;
    }
    StringWithSubstitutions.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        if (!referencedInputs) throw new Error("The referencedInputs parameter cannot be null.");
        if (this._original) for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
            var input = inputs_1[_i];
            var matches = new RegExp("\\{{2}(" + input.id + ").value\\}{2}", "gi").exec(this._original);
            if (matches != null && input.id) referencedInputs[input.id] = input;
        }
    };
    StringWithSubstitutions.prototype.substituteInputValues = function(inputs, contentType) {
        this._processed = this._original;
        if (this._original) {
            var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
            var matches = void 0;
            while((matches = regEx.exec(this._original)) !== null && this._processed)for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
                var key = _a[_i];
                if (key.toLowerCase() === matches[1].toLowerCase()) {
                    var matchedInput = inputs[key];
                    var valueForReplace = "";
                    if (matchedInput.value) valueForReplace = matchedInput.value;
                    if (contentType === module.exports.ContentTypes.applicationJson) {
                        valueForReplace = JSON.stringify(valueForReplace);
                        valueForReplace = valueForReplace.slice(1, -1);
                    } else if (contentType === module.exports.ContentTypes.applicationXWwwFormUrlencoded) valueForReplace = encodeURIComponent(valueForReplace);
                    this._processed = this._processed.replace(matches[0], valueForReplace);
                    break;
                }
            }
        }
        this._isProcessed = true;
    };
    StringWithSubstitutions.prototype.getOriginal = function() {
        return this._original;
    };
    StringWithSubstitutions.prototype.get = function() {
        if (!this._isProcessed) return this._original;
        else return this._processed;
    };
    StringWithSubstitutions.prototype.set = function(value) {
        this._original = value;
        this._isProcessed = false;
    };
    return StringWithSubstitutions;
}();
module.exports.StringWithSubstitutions = $4cf7cab40de2f538$var$StringWithSubstitutions;
var $4cf7cab40de2f538$var$SpacingDefinition = /** @class */ function() {
    function SpacingDefinition(top, right, bottom, left) {
        if (top === void 0) top = 0;
        if (right === void 0) right = 0;
        if (bottom === void 0) bottom = 0;
        if (left === void 0) left = 0;
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return SpacingDefinition;
}();
module.exports.SpacingDefinition = $4cf7cab40de2f538$var$SpacingDefinition;
var $4cf7cab40de2f538$var$PaddingDefinition = /** @class */ function() {
    function PaddingDefinition(top, right, bottom, left) {
        if (top === void 0) top = $gIXBn.Spacing.None;
        if (right === void 0) right = $gIXBn.Spacing.None;
        if (bottom === void 0) bottom = $gIXBn.Spacing.None;
        if (left === void 0) left = $gIXBn.Spacing.None;
        this.top = $gIXBn.Spacing.None;
        this.right = $gIXBn.Spacing.None;
        this.bottom = $gIXBn.Spacing.None;
        this.left = $gIXBn.Spacing.None;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return PaddingDefinition;
}();
module.exports.PaddingDefinition = $4cf7cab40de2f538$var$PaddingDefinition;
var $4cf7cab40de2f538$var$SizeAndUnit = /** @class */ function() {
    function SizeAndUnit(physicalSize, unit) {
        this.physicalSize = physicalSize;
        this.unit = unit;
    }
    SizeAndUnit.parse = function(input, requireUnitSpecifier) {
        if (requireUnitSpecifier === void 0) requireUnitSpecifier = false;
        var result = new SizeAndUnit(0, $gIXBn.SizeUnit.Weight);
        if (typeof input === "number") {
            result.physicalSize = input;
            return result;
        } else if (typeof input === "string") {
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            var expectedMatchCount = requireUnitSpecifier ? 3 : 2;
            if (matches && matches.length >= expectedMatchCount) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length === 3) {
                    if (matches[2] === "px") result.unit = $gIXBn.SizeUnit.Pixel;
                }
                return result;
            }
        }
        throw new Error("Invalid size: " + input);
    };
    return SizeAndUnit;
}();
module.exports.SizeAndUnit = $4cf7cab40de2f538$var$SizeAndUnit;
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ var $4cf7cab40de2f538$var$UUID = /** @class */ function() {
    function UUID() {}
    UUID.generate = function() {
        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;
        return UUID.lut[d0 & 0xff] + UUID.lut[d0 >> 8 & 0xff] + UUID.lut[d0 >> 16 & 0xff] + UUID.lut[d0 >> 24 & 0xff] + "-" + UUID.lut[d1 & 0xff] + UUID.lut[d1 >> 8 & 0xff] + "-" + UUID.lut[d1 >> 16 & 0x0f | 0x40] + UUID.lut[d1 >> 24 & 0xff] + "-" + UUID.lut[d2 & 0x3f | 0x80] + UUID.lut[d2 >> 8 & 0xff] + "-" + UUID.lut[d2 >> 16 & 0xff] + UUID.lut[d2 >> 24 & 0xff] + UUID.lut[d3 & 0xff] + UUID.lut[d3 >> 8 & 0xff] + UUID.lut[d3 >> 16 & 0xff] + UUID.lut[d3 >> 24 & 0xff];
    };
    UUID.initialize = function() {
        for(var i = 0; i < 256; i++)UUID.lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    };
    UUID.lut = [];
    return UUID;
}();
module.exports.UUID = $4cf7cab40de2f538$var$UUID;
$4cf7cab40de2f538$var$UUID.initialize(); /* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ 

});

parcelRegister("F6YrP", function(module, exports) {
"use strict";
var $07b93d55839f4030$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debounce = module.exports.addCancelSelectActionEventHandler = module.exports.clearElementChildren = module.exports.getScrollY = module.exports.getScrollX = module.exports.getFitStatus = module.exports.truncate = module.exports.truncateText = module.exports.stringToCssColor = module.exports.parseEnum = module.exports.getEnumValueByName = module.exports.parseBool = module.exports.parseNumber = module.exports.parseString = module.exports.appendChild = module.exports.generateUniqueId = module.exports.isMobileOS = module.exports.isInternetExplorer = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $6BHj7 = parcelRequire("6BHj7");
function $07b93d55839f4030$var$isInternetExplorer() {
    // The documentMode property only exists in IE
    return window.document.documentMode !== undefined;
}
module.exports.isInternetExplorer = $07b93d55839f4030$var$isInternetExplorer;
function $07b93d55839f4030$var$isMobileOS() {
    var userAgent = window.navigator.userAgent;
    return !!userAgent.match(/Android/i) || !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
}
module.exports.isMobileOS = $07b93d55839f4030$var$isMobileOS;
/**
 * Generate a UUID prepended with "__ac-"
 */ function $07b93d55839f4030$var$generateUniqueId() {
    return "__ac-" + $6BHj7.UUID.generate();
}
module.exports.generateUniqueId = $07b93d55839f4030$var$generateUniqueId;
function $07b93d55839f4030$var$appendChild(node, child) {
    if (child) node.appendChild(child);
}
module.exports.appendChild = $07b93d55839f4030$var$appendChild;
function $07b93d55839f4030$var$parseString(obj, defaultValue) {
    return typeof obj === "string" ? obj : defaultValue;
}
module.exports.parseString = $07b93d55839f4030$var$parseString;
function $07b93d55839f4030$var$parseNumber(obj, defaultValue) {
    return typeof obj === "number" ? obj : defaultValue;
}
module.exports.parseNumber = $07b93d55839f4030$var$parseNumber;
function $07b93d55839f4030$var$parseBool(value, defaultValue) {
    if (typeof value === "boolean") return value;
    else if (typeof value === "string") switch(value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        default:
            return defaultValue;
    }
    return defaultValue;
}
module.exports.parseBool = $07b93d55839f4030$var$parseBool;
function $07b93d55839f4030$var$getEnumValueByName(enumType, name) {
    // eslint-disable-next-line guard-for-in
    for(var key in enumType){
        var keyAsNumber = parseInt(key, 10);
        if (keyAsNumber >= 0) {
            var value = enumType[key];
            if (value && typeof value === "string" && value.toLowerCase() === name.toLowerCase()) return keyAsNumber;
        }
    }
    return undefined;
}
module.exports.getEnumValueByName = $07b93d55839f4030$var$getEnumValueByName;
function $07b93d55839f4030$var$parseEnum(enumType, name, defaultValue) {
    if (!name) return defaultValue;
    var enumValue = $07b93d55839f4030$var$getEnumValueByName(enumType, name);
    return enumValue !== undefined ? enumValue : defaultValue;
}
module.exports.parseEnum = $07b93d55839f4030$var$parseEnum;
function $07b93d55839f4030$var$stringToCssColor(color) {
    if (color) {
        var regEx = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi;
        var matches = regEx.exec(color);
        if (matches && matches[4]) {
            var a = parseInt(matches[1], 16) / 255;
            var r = parseInt(matches[2], 16);
            var g = parseInt(matches[3], 16);
            var b = parseInt(matches[4], 16);
            return "rgba(" + r + "," + g + "," + b + "," + a + ")";
        }
    }
    return color;
}
module.exports.stringToCssColor = $07b93d55839f4030$var$stringToCssColor;
function $07b93d55839f4030$var$truncateWorker(element, maxHeight, fullText, truncateAt, lineHeight) {
    var fits = function() {
        // Allow a one pixel overflow to account for rounding differences
        // between browsers
        return maxHeight - element.scrollHeight >= -1;
    };
    if (fits()) return;
    var breakableIndices = $07b93d55839f4030$var$findBreakableIndices(fullText);
    var lo = 0;
    var hi = breakableIndices.length;
    var bestBreakIdx = 0;
    // Do a binary search for the longest string that fits
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        truncateAt(fullText, breakableIndices[mid]);
        if (fits()) {
            bestBreakIdx = breakableIndices[mid];
            lo = mid + 1;
        } else hi = mid;
    }
    truncateAt(fullText, bestBreakIdx);
    // If we have extra room, try to expand the string letter by letter
    // (covers the case where we have to break in the middle of a long word)
    if (lineHeight && maxHeight - element.scrollHeight >= lineHeight - 1.0) {
        var idx = $07b93d55839f4030$var$findNextCharacter(fullText, bestBreakIdx);
        while(idx < fullText.length){
            truncateAt(fullText, idx);
            if (fits()) {
                bestBreakIdx = idx;
                idx = $07b93d55839f4030$var$findNextCharacter(fullText, idx);
            } else break;
        }
        truncateAt(fullText, bestBreakIdx);
    }
}
function $07b93d55839f4030$var$truncateText(element, maxHeight, lineHeight) {
    $07b93d55839f4030$var$truncateWorker(element, maxHeight, element.innerText, function(text, idx) {
        element.innerText = text.substring(0, idx) + "...";
    }, lineHeight);
}
module.exports.truncateText = $07b93d55839f4030$var$truncateText;
/**
 * {@link truncate} has been deprecated and is no longer in use internally. This policy passes
 * content through as it always has, which is _supposed_ to be dealing with text only (see {@link
 * TextBlock.truncateIfSupported}), but had a bug where it might actually pass through an element
 * for which innerHTML yielded actual HTML (since fixed).
 */ var $07b93d55839f4030$var$ttDeprecatedPolicy = typeof window === 'undefined' ? undefined : ($07b93d55839f4030$var$_a = window.trustedTypes) === null || $07b93d55839f4030$var$_a === void 0 ? void 0 : $07b93d55839f4030$var$_a.createPolicy("adaptivecards#deprecatedExportedFunctionPolicy", {
    createHTML: function(value) {
        return value;
    }
});
/** @deprecated Use {@link truncateText} instead. */ function $07b93d55839f4030$var$truncate(element, maxHeight, lineHeight) {
    $07b93d55839f4030$var$truncateWorker(element, maxHeight, element.innerHTML, function(text, idx) {
        var _a;
        var truncatedString = text.substring(0, idx) + "...";
        var truncatedHTML = (_a = $07b93d55839f4030$var$ttDeprecatedPolicy === null || $07b93d55839f4030$var$ttDeprecatedPolicy === void 0 ? void 0 : $07b93d55839f4030$var$ttDeprecatedPolicy.createHTML(truncatedString)) !== null && _a !== void 0 ? _a : truncatedString;
        element.innerHTML = truncatedHTML;
    }, lineHeight);
}
module.exports.truncate = $07b93d55839f4030$var$truncate;
function $07b93d55839f4030$var$findBreakableIndices(html) {
    var results = [];
    var idx = $07b93d55839f4030$var$findNextCharacter(html, -1);
    while(idx < html.length){
        if (html[idx] === " ") results.push(idx);
        idx = $07b93d55839f4030$var$findNextCharacter(html, idx);
    }
    return results;
}
function $07b93d55839f4030$var$findNextCharacter(html, currIdx) {
    currIdx += 1;
    // If we found the start of an HTML tag, keep advancing until we get
    // past it, so we don't end up truncating in the middle of the tag
    while(currIdx < html.length && html[currIdx] === "<"){
        while(currIdx < html.length && html[currIdx++] !== ">")continue;
    }
    return currIdx;
}
function $07b93d55839f4030$var$getFitStatus(element, containerEnd) {
    var start = element.offsetTop;
    var end = start + element.clientHeight;
    if (end <= containerEnd) return $gIXBn.ContainerFitStatus.FullyInContainer;
    else if (start < containerEnd) return $gIXBn.ContainerFitStatus.Overflowing;
    else return $gIXBn.ContainerFitStatus.FullyOutOfContainer;
}
module.exports.getFitStatus = $07b93d55839f4030$var$getFitStatus;
function $07b93d55839f4030$var$getScrollX() {
    return window.pageXOffset;
}
module.exports.getScrollX = $07b93d55839f4030$var$getScrollX;
function $07b93d55839f4030$var$getScrollY() {
    return window.pageYOffset;
}
module.exports.getScrollY = $07b93d55839f4030$var$getScrollY;
function $07b93d55839f4030$var$clearElementChildren(element) {
    while(element.firstChild)element.removeChild(element.firstChild);
}
module.exports.clearElementChildren = $07b93d55839f4030$var$clearElementChildren;
function $07b93d55839f4030$var$addCancelSelectActionEventHandler(element) {
    element.onclick = function(e) {
        e.preventDefault();
        e.cancelBubble = true;
    };
}
module.exports.addCancelSelectActionEventHandler = $07b93d55839f4030$var$addCancelSelectActionEventHandler;
function $07b93d55839f4030$var$debounce(fn, delay) {
    var timer;
    function debouncedFn() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(void 0, args);
        }, delay);
    }
    return debouncedFn;
}
module.exports.debounce = $07b93d55839f4030$var$debounce;

});

parcelRegister("5Ougt", function(module, exports) {
"use strict";
var $43b9193123441548$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SerializableObject = module.exports.property = module.exports.SerializableObjectSchema = module.exports.CustomProperty = module.exports.SerializableObjectCollectionProperty = module.exports.SerializableObjectProperty = module.exports.EnumProperty = module.exports.ValueSetProperty = module.exports.StringArrayProperty = module.exports.PixelSizeProperty = module.exports.NumProperty = module.exports.BoolProperty = module.exports.StringProperty = module.exports.PropertyDefinition = module.exports.BaseSerializationContext = module.exports.isVersionLessOrEqual = module.exports.Versions = module.exports.Version = void 0;

var $6BHj7 = parcelRequire("6BHj7");

var $F6YrP = parcelRequire("F6YrP");

var $gIXBn = parcelRequire("gIXBn");

var $24F6S = parcelRequire("24F6S");
var $43b9193123441548$var$Version = /** @class */ function() {
    function Version(major, minor, label) {
        if (major === void 0) major = 1;
        if (minor === void 0) minor = 1;
        this._isValid = true;
        this._major = major;
        this._minor = minor;
        this._label = label;
    }
    Version.parse = function(versionString, context) {
        if (!versionString) return undefined;
        var result = new Version();
        result._versionString = versionString;
        var regEx = /(\d+).(\d+)/gi;
        var matches = regEx.exec(versionString);
        if (matches != null && matches.length === 3) {
            result._major = parseInt(matches[1]);
            result._minor = parseInt(matches[2]);
        } else result._isValid = false;
        if (!result._isValid) context.logParseEvent(undefined, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidVersionString(result._versionString));
        return result;
    };
    Version.prototype.toString = function() {
        return !this._isValid ? this._versionString : this._major + "." + this._minor;
    };
    Version.prototype.toJSON = function() {
        return this.toString();
    };
    Version.prototype.compareTo = function(otherVersion) {
        if (!this.isValid || !otherVersion.isValid) throw new Error("Cannot compare invalid version.");
        if (this.major > otherVersion.major) return 1;
        else if (this.major < otherVersion.major) return -1;
        else if (this.minor > otherVersion.minor) return 1;
        else if (this.minor < otherVersion.minor) return -1;
        return 0;
    };
    Object.defineProperty(Version.prototype, "label", {
        get: function() {
            return this._label ? this._label : this.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "major", {
        get: function() {
            return this._major;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "minor", {
        get: function() {
            return this._minor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "isValid", {
        get: function() {
            return this._isValid;
        },
        enumerable: false,
        configurable: true
    });
    return Version;
}();
module.exports.Version = $43b9193123441548$var$Version;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $43b9193123441548$var$Versions = /** @class */ function() {
    function Versions() {}
    // If preview tag is added/removed from any version,
    // don't forget to update .ac-schema-version-1-?::after too in adaptivecards-site\themes\adaptivecards\source\css\style.css
    /* eslint-enable @typescript-eslint/naming-convention */ Versions.getAllDeclaredVersions = function() {
        var ctor = Versions;
        var properties = [];
        for(var propertyName in ctor){
            if (propertyName.match(/^v[0-9_]*$/)) // filter latest
            try {
                var propertyValue = ctor[propertyName];
                if (propertyValue instanceof $43b9193123441548$var$Version) properties.push(propertyValue);
            } catch (_a) {
            // If a property happens to have a getter function and
            // it throws an exception, we need to catch it here
            }
        }
        return properties.sort(function(v1, v2) {
            return v1.compareTo(v2);
        });
    };
    /* eslint-disable @typescript-eslint/naming-convention */ Versions.v1_0 = new $43b9193123441548$var$Version(1, 0);
    Versions.v1_1 = new $43b9193123441548$var$Version(1, 1);
    Versions.v1_2 = new $43b9193123441548$var$Version(1, 2);
    Versions.v1_3 = new $43b9193123441548$var$Version(1, 3);
    Versions.v1_4 = new $43b9193123441548$var$Version(1, 4);
    Versions.v1_5 = new $43b9193123441548$var$Version(1, 5);
    Versions.v1_6 = new $43b9193123441548$var$Version(1, 6);
    Versions.latest = Versions.v1_6;
    return Versions;
}();
module.exports.Versions = $43b9193123441548$var$Versions;
function $43b9193123441548$var$isVersionLessOrEqual(version, targetVersion) {
    if (version instanceof $43b9193123441548$var$Version) {
        if (targetVersion instanceof $43b9193123441548$var$Version) return targetVersion.compareTo(version) >= 0;
        else // Target version is *
        return true;
    } else // Version is *
    return true;
}
module.exports.isVersionLessOrEqual = $43b9193123441548$var$isVersionLessOrEqual;
var $43b9193123441548$var$BaseSerializationContext = /** @class */ function() {
    function BaseSerializationContext(targetVersion) {
        if (targetVersion === void 0) targetVersion = $43b9193123441548$var$Versions.latest;
        this._validationEvents = [];
        this.targetVersion = targetVersion;
    }
    BaseSerializationContext.prototype.isTemplateString = function(value) {
        if (typeof value === "string") return value.startsWith("${");
        else return false;
    };
    BaseSerializationContext.prototype.tryDeleteValue = function(target, propertyName) {
        if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
    };
    BaseSerializationContext.prototype.tryDeleteDefaultValue = function(target, propertyName) {
        if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip || !this.isTemplateString(target[propertyName])) delete target[propertyName];
    };
    BaseSerializationContext.prototype.serializeValue = function(target, propertyName, propertyValue, defaultValue, forceDeleteIfNullOrDefault) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (forceDeleteIfNullOrDefault === void 0) forceDeleteIfNullOrDefault = false;
        if (propertyValue === null || propertyValue === undefined) {
            if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault) delete target[propertyName];
        } else if (propertyValue === defaultValue) {
            if (!$6BHj7.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault || !this.isTemplateString(target[propertyName])) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeString = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeBool = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeNumber = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || isNaN(propertyValue)) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeEnum = function(enumType, target, propertyName, propertyValue, defaultValue) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = enumType[propertyValue];
    };
    BaseSerializationContext.prototype.serializeArray = function(target, propertyName, propertyValue) {
        var items = [];
        if (propertyValue) for(var _i = 0, propertyValue_1 = propertyValue; _i < propertyValue_1.length; _i++){
            var item = propertyValue_1[_i];
            var serializedItem = undefined;
            if (item instanceof $43b9193123441548$var$SerializableObject) serializedItem = item.toJSON(this);
            else if (item.toJSON) serializedItem = item.toJSON();
            else serializedItem = item;
            if (serializedItem !== undefined) items.push(serializedItem);
        }
        if (items.length === 0) {
            if (target.hasOwnProperty(propertyName) && Array.isArray(target[propertyName])) delete target[propertyName];
        } else this.serializeValue(target, propertyName, items);
    };
    BaseSerializationContext.prototype.clearEvents = function() {
        this._validationEvents = [];
    };
    BaseSerializationContext.prototype.logEvent = function(source, phase, event, message) {
        this._validationEvents.push({
            source: source,
            phase: phase,
            event: event,
            message: message
        });
    };
    BaseSerializationContext.prototype.logParseEvent = function(source, event, message) {
        this.logEvent(source, $gIXBn.ValidationPhase.Parse, event, message);
    };
    BaseSerializationContext.prototype.getEventAt = function(index) {
        return this._validationEvents[index];
    };
    Object.defineProperty(BaseSerializationContext.prototype, "eventCount", {
        get: function() {
            return this._validationEvents.length;
        },
        enumerable: false,
        configurable: true
    });
    return BaseSerializationContext;
}();
module.exports.BaseSerializationContext = $43b9193123441548$var$BaseSerializationContext;
var $43b9193123441548$var$SimpleSerializationContext = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(SimpleSerializationContext, _super);
    function SimpleSerializationContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SimpleSerializationContext;
}($43b9193123441548$var$BaseSerializationContext);
var $43b9193123441548$var$PropertyDefinition = /** @class */ function() {
    function PropertyDefinition(targetVersion, name, defaultValue, onGetInitialValue) {
        this.targetVersion = targetVersion;
        this.name = name;
        this.defaultValue = defaultValue;
        this.onGetInitialValue = onGetInitialValue;
        this.isSerializationEnabled = true;
        this.sequentialNumber = PropertyDefinition._sequentialNumber;
        PropertyDefinition._sequentialNumber++;
    }
    PropertyDefinition.prototype.getInternalName = function() {
        return this.name;
    };
    PropertyDefinition.prototype.parse = function(sender, source, context) {
        return source[this.name];
    };
    PropertyDefinition.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value, this.defaultValue);
    };
    PropertyDefinition._sequentialNumber = 0;
    return PropertyDefinition;
}();
module.exports.PropertyDefinition = $43b9193123441548$var$PropertyDefinition;
var $43b9193123441548$var$StringProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(StringProperty, _super);
    function StringProperty(targetVersion, name, treatEmptyAsUndefined, regEx, defaultValue, onGetInitialValue) {
        if (treatEmptyAsUndefined === void 0) treatEmptyAsUndefined = true;
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.treatEmptyAsUndefined = treatEmptyAsUndefined;
        _this.regEx = regEx;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringProperty.prototype.parse = function(sender, source, context) {
        var parsedValue = $F6YrP.parseString(source[this.name], this.defaultValue);
        var isUndefined = parsedValue === undefined || parsedValue === "" && this.treatEmptyAsUndefined;
        if (!isUndefined && this.regEx !== undefined) {
            var matches = this.regEx.exec(parsedValue);
            if (!matches) {
                context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(parsedValue, this.name));
                return undefined;
            }
        }
        return parsedValue;
    };
    StringProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeString(target, this.name, value === "" && this.treatEmptyAsUndefined ? undefined : value, this.defaultValue);
    };
    return StringProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.StringProperty = $43b9193123441548$var$StringProperty;
var $43b9193123441548$var$BoolProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(BoolProperty, _super);
    function BoolProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    BoolProperty.prototype.parse = function(sender, source, context) {
        return $F6YrP.parseBool(source[this.name], this.defaultValue);
    };
    BoolProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeBool(target, this.name, value, this.defaultValue);
    };
    return BoolProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.BoolProperty = $43b9193123441548$var$BoolProperty;
var $43b9193123441548$var$NumProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(NumProperty, _super);
    function NumProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    NumProperty.prototype.parse = function(sender, source, context) {
        return $F6YrP.parseNumber(source[this.name], this.defaultValue);
    };
    NumProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeNumber(target, this.name, value, this.defaultValue);
    };
    return NumProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.NumProperty = $43b9193123441548$var$NumProperty;
var $43b9193123441548$var$PixelSizeProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(PixelSizeProperty, _super);
    function PixelSizeProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PixelSizeProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var value = source[this.name];
        if (typeof value === "string") {
            var isValid = false;
            try {
                var size = $6BHj7.SizeAndUnit.parse(value, true);
                if (size.unit === $gIXBn.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Do nothing. A parse error is emitted below
            }
            if (!isValid) context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(source[this.name], this.name));
        }
        return result;
    };
    PixelSizeProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return PixelSizeProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.PixelSizeProperty = $43b9193123441548$var$PixelSizeProperty;
var $43b9193123441548$var$StringArrayProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(StringArrayProperty, _super);
    function StringArrayProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringArrayProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined || !Array.isArray(sourceValue)) return this.defaultValue;
        var result = [];
        for(var _i = 0, sourceValue_1 = sourceValue; _i < sourceValue_1.length; _i++){
            var value = sourceValue_1[_i];
            if (typeof value === "string") result.push(value);
            else context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, "Invalid array value \"".concat(JSON.stringify(value), "\" of type \"").concat(typeof value, "\" ignored for \"").concat(this.name, "\"."));
        }
        return result;
    };
    StringArrayProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return StringArrayProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.StringArrayProperty = $43b9193123441548$var$StringArrayProperty;
var $43b9193123441548$var$ValueSetProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(ValueSetProperty, _super);
    function ValueSetProperty(targetVersion, name, values, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.values = values;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    ValueSetProperty.prototype.isValidValue = function(value, context) {
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (value.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                return targetVersion.compareTo(context.targetVersion) <= 0;
            }
        }
        return false;
    };
    ValueSetProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        if (typeof sourceValue === "string") for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (sourceValue.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return versionedValue.value;
                else {
                    context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    ValueSetProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $gIXBn.ValidationPhase.ToJSON, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.propertyValueNotSupported(value, this.name, targetVersion.toString(), context.targetVersion.toString()));
                }
            }
        }
        if (!invalidValue) context.serializeValue(target, this.name, value, this.defaultValue, true);
    };
    return ValueSetProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.ValueSetProperty = $43b9193123441548$var$ValueSetProperty;
var $43b9193123441548$var$EnumProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(EnumProperty, _super);
    function EnumProperty(targetVersion, name, enumType, defaultValue, values, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.enumType = enumType;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        _this._values = [];
        if (!values) // eslint-disable-next-line guard-for-in
        for(var key in enumType){
            var keyAsNumber = parseInt(key, 10);
            if (keyAsNumber >= 0) _this._values.push({
                value: keyAsNumber
            });
        }
        else _this._values = values;
        return _this;
    }
    EnumProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (typeof sourceValue !== "string") return this.defaultValue;
        var enumValue = $F6YrP.getEnumValueByName(this.enumType, sourceValue);
        if (enumValue !== undefined) for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (versionedValue.value === enumValue) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return enumValue;
                else {
                    context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    EnumProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $gIXBn.ValidationPhase.ToJSON, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(value, this.name));
                }
            }
        }
        if (!invalidValue) context.serializeEnum(this.enumType, target, this.name, value, this.defaultValue);
    };
    Object.defineProperty(EnumProperty.prototype, "values", {
        get: function() {
            return this._values;
        },
        enumerable: false,
        configurable: true
    });
    return EnumProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.EnumProperty = $43b9193123441548$var$EnumProperty;
var $43b9193123441548$var$SerializableObjectProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(SerializableObjectProperty, _super);
    function SerializableObjectProperty(targetVersion, name, objectType, nullable, defaultValue) {
        if (nullable === void 0) nullable = false;
        var _this = _super.call(this, targetVersion, name, defaultValue, function(sender) {
            return _this.nullable ? undefined : new _this.objectType();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.nullable = nullable;
        return _this;
    }
    SerializableObjectProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.onGetInitialValue ? this.onGetInitialValue(sender) : this.defaultValue;
        var result = new this.objectType();
        result.parse(sourceValue, context);
        return result;
    };
    SerializableObjectProperty.prototype.toJSON = function(sender, target, value, context) {
        var serializedValue = undefined;
        if (value !== undefined && !value.hasAllDefaultValues()) serializedValue = value.toJSON(context);
        if (typeof serializedValue === "object" && Object.keys(serializedValue).length === 0) serializedValue = undefined;
        context.serializeValue(target, this.name, serializedValue, this.defaultValue, true);
    };
    return SerializableObjectProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.SerializableObjectProperty = $43b9193123441548$var$SerializableObjectProperty;
var $43b9193123441548$var$SerializableObjectCollectionProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(SerializableObjectCollectionProperty, _super);
    function SerializableObjectCollectionProperty(targetVersion, name, objectType, onItemAdded) {
        var _this = _super.call(this, targetVersion, name, undefined, function(sender) {
            return [];
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.onItemAdded = onItemAdded;
        return _this;
    }
    SerializableObjectCollectionProperty.prototype.parse = function(sender, source, context) {
        var result = [];
        var sourceCollection = source[this.name];
        if (Array.isArray(sourceCollection)) for(var _i = 0, sourceCollection_1 = sourceCollection; _i < sourceCollection_1.length; _i++){
            var sourceItem = sourceCollection_1[_i];
            var item = new this.objectType();
            item.parse(sourceItem, context);
            result.push(item);
            if (this.onItemAdded) this.onItemAdded(sender, item);
        }
        return result.length > 0 ? result : this.onGetInitialValue ? this.onGetInitialValue(sender) : undefined;
    };
    SerializableObjectCollectionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return SerializableObjectCollectionProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.SerializableObjectCollectionProperty = $43b9193123441548$var$SerializableObjectCollectionProperty;
var $43b9193123441548$var$CustomProperty = /** @class */ function(_super) {
    $43b9193123441548$var$__extends(CustomProperty, _super);
    function CustomProperty(targetVersion, name, onParse, onToJSON, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.onParse = onParse;
        _this.onToJSON = onToJSON;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        if (!_this.onParse) throw new Error("CustomPropertyDefinition instances must have an onParse handler.");
        if (!_this.onToJSON) throw new Error("CustomPropertyDefinition instances must have an onToJSON handler.");
        return _this;
    }
    CustomProperty.prototype.parse = function(sender, source, context) {
        return this.onParse(sender, this, source, context);
    };
    CustomProperty.prototype.toJSON = function(sender, target, value, context) {
        this.onToJSON(sender, this, target, value, context);
    };
    return CustomProperty;
}($43b9193123441548$var$PropertyDefinition);
module.exports.CustomProperty = $43b9193123441548$var$CustomProperty;
var $43b9193123441548$var$SerializableObjectSchema = /** @class */ function() {
    function SerializableObjectSchema() {
        this._properties = [];
    }
    SerializableObjectSchema.prototype.indexOf = function(prop) {
        for(var i = 0; i < this._properties.length; i++){
            if (this._properties[i] === prop) return i;
        }
        return -1;
    };
    SerializableObjectSchema.prototype.add = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_1 = properties; _a < properties_1.length; _a++){
            var prop = properties_1[_a];
            if (this.indexOf(prop) === -1) this._properties.push(prop);
        }
    };
    SerializableObjectSchema.prototype.remove = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_2 = properties; _a < properties_2.length; _a++){
            var prop = properties_2[_a];
            while(true){
                var index = this.indexOf(prop);
                if (index >= 0) this._properties.splice(index, 1);
                else break;
            }
        }
    };
    SerializableObjectSchema.prototype.getItemAt = function(index) {
        return this._properties[index];
    };
    SerializableObjectSchema.prototype.getCount = function() {
        return this._properties.length;
    };
    return SerializableObjectSchema;
}();
module.exports.SerializableObjectSchema = $43b9193123441548$var$SerializableObjectSchema;
// This is a decorator function, used to map SerializableObject descendant class members to
// schema properties
function $43b9193123441548$var$property(prop) {
    return function(target, propertyKey) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};
        if (!descriptor.get && !descriptor.set) {
            descriptor.get = function() {
                return this.getValue(prop);
            };
            descriptor.set = function(value) {
                this.setValue(prop, value);
            };
            Object.defineProperty(target, propertyKey, descriptor);
        }
    };
}
module.exports.property = $43b9193123441548$var$property;
var $43b9193123441548$var$SerializableObject = /** @class */ function() {
    function SerializableObject() {
        this._propertyBag = {};
        this._rawProperties = {};
        this.maxVersion = SerializableObject.defaultMaxVersion;
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (prop.onGetInitialValue) this.setValue(prop, prop.onGetInitialValue(this));
        }
    }
    SerializableObject.prototype.getDefaultSerializationContext = function() {
        return new $43b9193123441548$var$SimpleSerializationContext();
    };
    SerializableObject.prototype.populateSchema = function(schema) {
        var ctor = this.constructor;
        var properties = [];
        // eslint-disable-next-line guard-for-in
        for(var propertyName in ctor)try {
            var propertyValue = ctor[propertyName];
            if (propertyValue instanceof $43b9193123441548$var$PropertyDefinition) properties.push(propertyValue);
        } catch (_a) {
        // If a property happens to have a getter function and
        // it throws an exception, we need to catch it here
        }
        if (properties.length > 0) {
            var sortedProperties = properties.sort(function(p1, p2) {
                if (p1.sequentialNumber > p2.sequentialNumber) return 1;
                else if (p1.sequentialNumber < p2.sequentialNumber) return -1;
                return 0;
            });
            schema.add.apply(schema, sortedProperties);
        }
        if (SerializableObject.onRegisterCustomProperties) SerializableObject.onRegisterCustomProperties(this, schema);
    };
    SerializableObject.prototype.getValue = function(prop) {
        return this._propertyBag.hasOwnProperty(prop.getInternalName()) ? this._propertyBag[prop.getInternalName()] : prop.defaultValue;
    };
    SerializableObject.prototype.setValue = function(prop, value) {
        if (value === undefined || value === null) delete this._propertyBag[prop.getInternalName()];
        else this._propertyBag[prop.getInternalName()] = value;
    };
    SerializableObject.prototype.internalParse = function(source, context) {
        this._propertyBag = {};
        this._rawProperties = $6BHj7.GlobalSettings.enableFullJsonRoundTrip ? source ? source : {} : {};
        if (source) {
            var s = this.getSchema();
            for(var i = 0; i < s.getCount(); i++){
                var prop = s.getItemAt(i);
                if (prop.isSerializationEnabled) {
                    var propertyValue = prop.onGetInitialValue ? prop.onGetInitialValue(this) : undefined;
                    if (source.hasOwnProperty(prop.name)) {
                        if (prop.targetVersion.compareTo(context.targetVersion) <= 0) propertyValue = prop.parse(this, source, context);
                        else context.logParseEvent(this, $gIXBn.ValidationEvent.UnsupportedProperty, $24F6S.Strings.errors.propertyNotSupported(prop.name, prop.targetVersion.toString(), context.targetVersion.toString()));
                    }
                    this.setValue(prop, propertyValue);
                }
            }
        } else this.resetDefaultValues();
    };
    SerializableObject.prototype.internalToJSON = function(target, context) {
        var s = this.getSchema();
        var serializedProperties = [];
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            // Avoid serializing the same property multiple times. This is necessary
            // because some property definitions map to the same underlying schema
            // property
            if (prop.isSerializationEnabled && prop.targetVersion.compareTo(context.targetVersion) <= 0 && serializedProperties.indexOf(prop.name) === -1) {
                prop.toJSON(this, target, this.getValue(prop), context);
                serializedProperties.push(prop.name);
            }
        }
    };
    SerializableObject.prototype.shouldSerialize = function(_context) {
        return true;
    };
    SerializableObject.prototype.parse = function(source, context) {
        this.internalParse(source, context ? context : new $43b9193123441548$var$SimpleSerializationContext());
    };
    SerializableObject.prototype.toJSON = function(context) {
        var effectiveContext;
        if (context && context instanceof $43b9193123441548$var$BaseSerializationContext) effectiveContext = context;
        else {
            effectiveContext = this.getDefaultSerializationContext();
            effectiveContext.toJSONOriginalParam = context;
        }
        if (this.shouldSerialize(effectiveContext)) {
            var result = void 0;
            if ($6BHj7.GlobalSettings.enableFullJsonRoundTrip && this._rawProperties && typeof this._rawProperties === "object") result = this._rawProperties;
            else result = {};
            this.internalToJSON(result, effectiveContext);
            return result;
        } else return undefined;
    };
    SerializableObject.prototype.hasDefaultValue = function(prop) {
        return this.getValue(prop) === prop.defaultValue;
    };
    SerializableObject.prototype.hasAllDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (!this.hasDefaultValue(prop)) return false;
        }
        return true;
    };
    SerializableObject.prototype.resetDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            this.setValue(prop, prop.defaultValue);
        }
    };
    SerializableObject.prototype.setCustomProperty = function(name, value) {
        var shouldDeleteProperty = typeof value === "string" && !value || value === undefined || value === null;
        if (shouldDeleteProperty) delete this._rawProperties[name];
        else this._rawProperties[name] = value;
    };
    SerializableObject.prototype.getCustomProperty = function(name) {
        return this._rawProperties[name];
    };
    SerializableObject.prototype.getSchema = function() {
        var schema = SerializableObject._schemaCache[this.getSchemaKey()];
        if (!schema) {
            schema = new $43b9193123441548$var$SerializableObjectSchema();
            this.populateSchema(schema);
            SerializableObject._schemaCache[this.getSchemaKey()] = schema;
        }
        return schema;
    };
    SerializableObject.defaultMaxVersion = $43b9193123441548$var$Versions.latest;
    SerializableObject._schemaCache = {};
    return SerializableObject;
}();
module.exports.SerializableObject = $43b9193123441548$var$SerializableObject;

});

parcelRegister("7Lc5Q", function(module, exports) {
"use strict";
var $5a664dafacbee1f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostCapabilities = void 0;

var $5Ougt = parcelRequire("5Ougt");
var $5a664dafacbee1f9$var$HostCapabilities = /** @class */ function(_super) {
    $5a664dafacbee1f9$var$__extends(HostCapabilities, _super);
    function HostCapabilities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._capabilities = {};
        return _this;
    }
    HostCapabilities.prototype.getSchemaKey = function() {
        return "HostCapabilities";
    };
    HostCapabilities.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        if (source) // eslint-disable-next-line guard-for-in
        for(var name_1 in source){
            var jsonVersion = source[name_1];
            if (typeof jsonVersion === "string") {
                if (jsonVersion === "*") this.addCapability(name_1, "*");
                else {
                    var version = $5Ougt.Version.parse(jsonVersion, context);
                    if (version === null || version === void 0 ? void 0 : version.isValid) this.addCapability(name_1, version);
                }
            }
        }
    };
    HostCapabilities.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        // eslint-disable-next-line guard-for-in
        for(var key in this._capabilities)target[key] = this._capabilities[key];
    };
    HostCapabilities.prototype.addCapability = function(name, version) {
        this._capabilities[name] = version;
    };
    HostCapabilities.prototype.removeCapability = function(name) {
        delete this._capabilities[name];
    };
    HostCapabilities.prototype.clear = function() {
        this._capabilities = {};
    };
    HostCapabilities.prototype.hasCapability = function(name, version) {
        if (this._capabilities.hasOwnProperty(name)) {
            if (version === "*" || this._capabilities[name] === "*") return true;
            return version.compareTo(this._capabilities[name]) <= 0;
        }
        return false;
    };
    HostCapabilities.prototype.areAllMet = function(hostCapabilities) {
        for(var capabilityName in this._capabilities){
            if (!hostCapabilities.hasCapability(capabilityName, this._capabilities[capabilityName])) return false;
        }
        return true;
    };
    return HostCapabilities;
}($5Ougt.SerializableObject);
module.exports.HostCapabilities = $5a664dafacbee1f9$var$HostCapabilities;

});

parcelRegister("8kDQQ", function(module, exports) {
"use strict";
var $610f1a9c13915db5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultHostConfig = module.exports.HostConfig = module.exports.CarouselConfig = module.exports.FontTypeSet = module.exports.FontTypeDefinition = module.exports.ContainerStyleSet = module.exports.ContainerStyleDefinition = module.exports.ColorSetDefinition = module.exports.ActionsConfig = module.exports.ShowCardActionConfig = module.exports.FactSetConfig = module.exports.FactTitleDefinition = module.exports.FactTextDefinition = module.exports.InputConfig = module.exports.InputLabelConfig = module.exports.RequiredInputLabelTextDefinition = module.exports.TextBlockConfig = module.exports.TextStyleSet = module.exports.TextStyleDefinition = module.exports.BaseTextDefinition = module.exports.TableConfig = module.exports.MediaConfig = module.exports.ImageSetConfig = module.exports.AdaptiveCardConfig = module.exports.TextColorDefinition = module.exports.ColorDefinition = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $F6YrP = parcelRequire("F6YrP");

var $6BHj7 = parcelRequire("6BHj7");

var $7Lc5Q = parcelRequire("7Lc5Q");
function $610f1a9c13915db5$var$parseHostConfigEnum(targetEnum, value, defaultValue) {
    if (typeof value === "string") {
        var parsedValue = $F6YrP.parseEnum(targetEnum, value, defaultValue);
        return parsedValue !== undefined ? parsedValue : defaultValue;
    } else if (typeof value === "number") return value;
    else return defaultValue;
}
var $610f1a9c13915db5$var$ColorDefinition = /** @class */ function() {
    function ColorDefinition(defaultColor, subtleColor) {
        this.default = "#000000";
        this.subtle = "#666666";
        if (defaultColor) this.default = defaultColor;
        if (subtleColor) this.subtle = subtleColor;
    }
    ColorDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.default = obj["default"] || this.default;
            this.subtle = obj["subtle"] || this.subtle;
        }
    };
    return ColorDefinition;
}();
module.exports.ColorDefinition = $610f1a9c13915db5$var$ColorDefinition;
var $610f1a9c13915db5$var$TextColorDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(TextColorDefinition, _super);
    function TextColorDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highlightColors = new $610f1a9c13915db5$var$ColorDefinition("#22000000", "#11000000");
        return _this;
    }
    TextColorDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.highlightColors.parse(obj["highlightColors"]);
    };
    return TextColorDefinition;
}($610f1a9c13915db5$var$ColorDefinition);
module.exports.TextColorDefinition = $610f1a9c13915db5$var$TextColorDefinition;
var $610f1a9c13915db5$var$AdaptiveCardConfig = /** @class */ function() {
    function AdaptiveCardConfig(obj) {
        this.allowCustomStyle = false;
        if (obj) this.allowCustomStyle = obj["allowCustomStyle"] || this.allowCustomStyle;
    }
    return AdaptiveCardConfig;
}();
module.exports.AdaptiveCardConfig = $610f1a9c13915db5$var$AdaptiveCardConfig;
var $610f1a9c13915db5$var$ImageSetConfig = /** @class */ function() {
    function ImageSetConfig(obj) {
        this.imageSize = $gIXBn.Size.Medium;
        this.maxImageHeight = 100;
        if (obj) {
            this.imageSize = obj["imageSize"] != null ? obj["imageSize"] : this.imageSize;
            this.maxImageHeight = $F6YrP.parseNumber(obj["maxImageHeight"], 100);
        }
    }
    ImageSetConfig.prototype.toJSON = function() {
        return {
            imageSize: $gIXBn.Size[this.imageSize],
            maxImageHeight: this.maxImageHeight
        };
    };
    return ImageSetConfig;
}();
module.exports.ImageSetConfig = $610f1a9c13915db5$var$ImageSetConfig;
var $610f1a9c13915db5$var$MediaConfig = /** @class */ function() {
    function MediaConfig(obj) {
        this.allowInlinePlayback = true;
        if (obj) {
            this.defaultPoster = obj["defaultPoster"];
            this.allowInlinePlayback = obj["allowInlinePlayback"] || this.allowInlinePlayback;
        }
    }
    MediaConfig.prototype.toJSON = function() {
        return {
            defaultPoster: this.defaultPoster,
            allowInlinePlayback: this.allowInlinePlayback
        };
    };
    return MediaConfig;
}();
module.exports.MediaConfig = $610f1a9c13915db5$var$MediaConfig;
var $610f1a9c13915db5$var$TableConfig = /** @class */ function() {
    function TableConfig(obj) {
        this.cellSpacing = 8;
        if (obj) this.cellSpacing = obj.cellSpacing && typeof obj.cellSpacing === "number" ? obj.cellSpacing : this.cellSpacing;
    }
    TableConfig.prototype.toJSON = function() {
        return {
            cellSpacing: this.cellSpacing
        };
    };
    return TableConfig;
}();
module.exports.TableConfig = $610f1a9c13915db5$var$TableConfig;
var $610f1a9c13915db5$var$BaseTextDefinition = /** @class */ function() {
    function BaseTextDefinition(obj) {
        this.size = $gIXBn.TextSize.Default;
        this.color = $gIXBn.TextColor.Default;
        this.isSubtle = false;
        this.weight = $gIXBn.TextWeight.Default;
        this.parse(obj);
    }
    BaseTextDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.size = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextSize, obj["size"], this.size);
            this.color = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextColor, obj["color"], this.color);
            this.isSubtle = obj.isSubtle !== undefined && typeof obj.isSubtle === "boolean" ? obj.isSubtle : this.isSubtle;
            this.weight = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextWeight, obj["weight"], this.getDefaultWeight());
        }
    };
    BaseTextDefinition.prototype.getDefaultWeight = function() {
        return $gIXBn.TextWeight.Default;
    };
    BaseTextDefinition.prototype.toJSON = function() {
        return {
            size: $gIXBn.TextSize[this.size],
            color: $gIXBn.TextColor[this.color],
            isSubtle: this.isSubtle,
            weight: $gIXBn.TextWeight[this.weight]
        };
    };
    return BaseTextDefinition;
}();
module.exports.BaseTextDefinition = $610f1a9c13915db5$var$BaseTextDefinition;
var $610f1a9c13915db5$var$TextStyleDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(TextStyleDefinition, _super);
    function TextStyleDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fontType = $gIXBn.FontType.Default;
        return _this;
    }
    TextStyleDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.fontType = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.FontType, obj.fontType, this.fontType);
    };
    return TextStyleDefinition;
}($610f1a9c13915db5$var$BaseTextDefinition);
module.exports.TextStyleDefinition = $610f1a9c13915db5$var$TextStyleDefinition;
var $610f1a9c13915db5$var$TextStyleSet = /** @class */ function() {
    function TextStyleSet(obj) {
        this.default = new $610f1a9c13915db5$var$TextStyleDefinition();
        this.heading = new $610f1a9c13915db5$var$TextStyleDefinition({
            size: "Large",
            weight: "Bolder"
        });
        this.columnHeader = new $610f1a9c13915db5$var$TextStyleDefinition({
            weight: "Bolder"
        });
        if (obj) {
            this.heading.parse(obj.heading);
            this.columnHeader.parse(obj.columnHeader);
        }
    }
    TextStyleSet.prototype.getStyleByName = function(name) {
        switch(name.toLowerCase()){
            case "heading":
                return this.heading;
            case "columnHeader":
                return this.columnHeader;
            default:
                return this.default;
        }
    };
    return TextStyleSet;
}();
module.exports.TextStyleSet = $610f1a9c13915db5$var$TextStyleSet;
var $610f1a9c13915db5$var$TextBlockConfig = /** @class */ function() {
    function TextBlockConfig(obj) {
        if (obj) this.headingLevel = $F6YrP.parseNumber(obj.headingLevel);
    }
    return TextBlockConfig;
}();
module.exports.TextBlockConfig = $610f1a9c13915db5$var$TextBlockConfig;
var $610f1a9c13915db5$var$RequiredInputLabelTextDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(RequiredInputLabelTextDefinition, _super);
    function RequiredInputLabelTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suffix = " *";
        _this.suffixColor = $gIXBn.TextColor.Attention;
        return _this;
    }
    RequiredInputLabelTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) {
            this.suffix = obj["suffix"] || this.suffix;
            this.suffixColor = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextColor, obj["suffixColor"], this.suffixColor);
        }
    };
    RequiredInputLabelTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["suffix"] = this.suffix;
        result["suffixColor"] = $gIXBn.TextColor[this.suffixColor];
        return result;
    };
    return RequiredInputLabelTextDefinition;
}($610f1a9c13915db5$var$BaseTextDefinition);
module.exports.RequiredInputLabelTextDefinition = $610f1a9c13915db5$var$RequiredInputLabelTextDefinition;
var $610f1a9c13915db5$var$InputLabelConfig = /** @class */ function() {
    function InputLabelConfig(obj) {
        this.inputSpacing = $gIXBn.Spacing.Small;
        this.width = 30;
        this.requiredInputs = new $610f1a9c13915db5$var$RequiredInputLabelTextDefinition();
        this.optionalInputs = new $610f1a9c13915db5$var$BaseTextDefinition();
        if (obj) {
            this.inputSpacing = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.Spacing, obj["inputSpacing"], this.inputSpacing);
            this.requiredInputs = new $610f1a9c13915db5$var$RequiredInputLabelTextDefinition(obj["requiredInputs"]);
            this.optionalInputs = new $610f1a9c13915db5$var$BaseTextDefinition(obj["optionalInputs"]);
            this.width = obj["width"] != null ? obj["width"] : this.width;
        }
    }
    return InputLabelConfig;
}();
module.exports.InputLabelConfig = $610f1a9c13915db5$var$InputLabelConfig;
var $610f1a9c13915db5$var$InputConfig = /** @class */ function() {
    function InputConfig(obj) {
        this.label = new $610f1a9c13915db5$var$InputLabelConfig();
        this.errorMessage = new $610f1a9c13915db5$var$BaseTextDefinition({
            color: $gIXBn.TextColor.Attention
        });
        this.debounceTimeInMilliSeconds = 0;
        this.allowDynamicallyFilteredChoiceSet = true;
        this.allowRevealOnHoverStyle = false;
        if (obj) {
            this.label = new $610f1a9c13915db5$var$InputLabelConfig(obj["label"]);
            this.errorMessage = new $610f1a9c13915db5$var$BaseTextDefinition(obj["errorMessage"]);
            this.allowRevealOnHoverStyle = obj["allowRevealOnHoverStyle"] || this.allowRevealOnHoverStyle;
            this.allowDynamicallyFilteredChoiceSet = obj["allowDynamicallyFilteredChoiceSet"] || this.allowDynamicallyFilteredChoiceSet;
            this.debounceTimeInMilliSeconds = obj["debounceTimeInMilliSeconds"] || this.debounceTimeInMilliSeconds;
        }
    }
    return InputConfig;
}();
module.exports.InputConfig = $610f1a9c13915db5$var$InputConfig;
var $610f1a9c13915db5$var$FactTextDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(FactTextDefinition, _super);
    function FactTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = true;
        return _this;
    }
    FactTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.wrap = obj["wrap"] != null ? obj["wrap"] : this.wrap;
    };
    FactTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["wrap"] = this.wrap;
        return result;
    };
    return FactTextDefinition;
}($610f1a9c13915db5$var$BaseTextDefinition);
module.exports.FactTextDefinition = $610f1a9c13915db5$var$FactTextDefinition;
var $610f1a9c13915db5$var$FactTitleDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(FactTitleDefinition, _super);
    function FactTitleDefinition(obj) {
        var _this = _super.call(this, obj) || this;
        _this.maxWidth = 150;
        _this.weight = $gIXBn.TextWeight.Bolder;
        if (obj) {
            _this.maxWidth = obj["maxWidth"] != null ? obj["maxWidth"] : _this.maxWidth;
            _this.weight = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.TextWeight, obj["weight"], $gIXBn.TextWeight.Bolder);
        }
        return _this;
    }
    FactTitleDefinition.prototype.getDefaultWeight = function() {
        return $gIXBn.TextWeight.Bolder;
    };
    return FactTitleDefinition;
}($610f1a9c13915db5$var$FactTextDefinition);
module.exports.FactTitleDefinition = $610f1a9c13915db5$var$FactTitleDefinition;
var $610f1a9c13915db5$var$FactSetConfig = /** @class */ function() {
    function FactSetConfig(obj) {
        this.title = new $610f1a9c13915db5$var$FactTitleDefinition();
        this.value = new $610f1a9c13915db5$var$FactTextDefinition();
        this.spacing = 10;
        if (obj) {
            this.title = new $610f1a9c13915db5$var$FactTitleDefinition(obj["title"]);
            this.value = new $610f1a9c13915db5$var$FactTextDefinition(obj["value"]);
            this.spacing = obj.spacing && obj.spacing != null ? obj.spacing && obj.spacing : this.spacing;
        }
    }
    return FactSetConfig;
}();
module.exports.FactSetConfig = $610f1a9c13915db5$var$FactSetConfig;
var $610f1a9c13915db5$var$ShowCardActionConfig = /** @class */ function() {
    function ShowCardActionConfig(obj) {
        this.actionMode = $gIXBn.ShowCardActionMode.Inline;
        this.inlineTopMargin = 16;
        this.style = $gIXBn.ContainerStyle.Emphasis;
        if (obj) {
            this.actionMode = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.ShowCardActionMode, obj["actionMode"], $gIXBn.ShowCardActionMode.Inline);
            this.inlineTopMargin = obj["inlineTopMargin"] != null ? obj["inlineTopMargin"] : this.inlineTopMargin;
            this.style = obj["style"] && typeof obj["style"] === "string" ? obj["style"] : $gIXBn.ContainerStyle.Emphasis;
        }
    }
    ShowCardActionConfig.prototype.toJSON = function() {
        return {
            actionMode: $gIXBn.ShowCardActionMode[this.actionMode],
            inlineTopMargin: this.inlineTopMargin,
            style: this.style
        };
    };
    return ShowCardActionConfig;
}();
module.exports.ShowCardActionConfig = $610f1a9c13915db5$var$ShowCardActionConfig;
var $610f1a9c13915db5$var$ActionsConfig = /** @class */ function() {
    function ActionsConfig(obj) {
        this.maxActions = 5;
        this.spacing = $gIXBn.Spacing.Default;
        this.buttonSpacing = 20;
        this.showCard = new $610f1a9c13915db5$var$ShowCardActionConfig();
        this.preExpandSingleShowCardAction = false;
        this.actionsOrientation = $gIXBn.Orientation.Horizontal;
        this.actionAlignment = $gIXBn.ActionAlignment.Left;
        this.iconPlacement = $gIXBn.ActionIconPlacement.LeftOfTitle;
        this.allowTitleToWrap = false;
        this.iconSize = 16;
        if (obj) {
            this.maxActions = obj["maxActions"] != null ? obj["maxActions"] : this.maxActions;
            this.spacing = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.Spacing, obj.spacing && obj.spacing, $gIXBn.Spacing.Default);
            this.buttonSpacing = obj["buttonSpacing"] != null ? obj["buttonSpacing"] : this.buttonSpacing;
            this.showCard = new $610f1a9c13915db5$var$ShowCardActionConfig(obj["showCard"]);
            this.preExpandSingleShowCardAction = $F6YrP.parseBool(obj["preExpandSingleShowCardAction"], false);
            this.actionsOrientation = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.Orientation, obj["actionsOrientation"], $gIXBn.Orientation.Horizontal);
            this.actionAlignment = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.ActionAlignment, obj["actionAlignment"], $gIXBn.ActionAlignment.Left);
            this.iconPlacement = $610f1a9c13915db5$var$parseHostConfigEnum($gIXBn.ActionIconPlacement, obj["iconPlacement"], $gIXBn.ActionIconPlacement.LeftOfTitle);
            this.allowTitleToWrap = obj["allowTitleToWrap"] != null ? obj["allowTitleToWrap"] : this.allowTitleToWrap;
            try {
                var sizeAndUnit = $6BHj7.SizeAndUnit.parse(obj["iconSize"]);
                if (sizeAndUnit.unit === $gIXBn.SizeUnit.Pixel) this.iconSize = sizeAndUnit.physicalSize;
            } catch (e) {
            // Swallow this, keep default icon size
            }
        }
    }
    ActionsConfig.prototype.toJSON = function() {
        return {
            maxActions: this.maxActions,
            spacing: $gIXBn.Spacing[this.spacing],
            buttonSpacing: this.buttonSpacing,
            showCard: this.showCard,
            preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
            actionsOrientation: $gIXBn.Orientation[this.actionsOrientation],
            actionAlignment: $gIXBn.ActionAlignment[this.actionAlignment]
        };
    };
    return ActionsConfig;
}();
module.exports.ActionsConfig = $610f1a9c13915db5$var$ActionsConfig;
var $610f1a9c13915db5$var$ColorSetDefinition = /** @class */ function() {
    function ColorSetDefinition(obj) {
        this.default = new $610f1a9c13915db5$var$TextColorDefinition();
        this.dark = new $610f1a9c13915db5$var$TextColorDefinition();
        this.light = new $610f1a9c13915db5$var$TextColorDefinition();
        this.accent = new $610f1a9c13915db5$var$TextColorDefinition();
        this.good = new $610f1a9c13915db5$var$TextColorDefinition();
        this.warning = new $610f1a9c13915db5$var$TextColorDefinition();
        this.attention = new $610f1a9c13915db5$var$TextColorDefinition();
        this.parse(obj);
    }
    ColorSetDefinition.prototype.parseSingleColor = function(obj, propertyName) {
        if (obj) this[propertyName].parse(obj[propertyName]);
    };
    ColorSetDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.parseSingleColor(obj, "default");
            this.parseSingleColor(obj, "dark");
            this.parseSingleColor(obj, "light");
            this.parseSingleColor(obj, "accent");
            this.parseSingleColor(obj, "good");
            this.parseSingleColor(obj, "warning");
            this.parseSingleColor(obj, "attention");
        }
    };
    return ColorSetDefinition;
}();
module.exports.ColorSetDefinition = $610f1a9c13915db5$var$ColorSetDefinition;
var $610f1a9c13915db5$var$ContainerStyleDefinition = /** @class */ function() {
    function ContainerStyleDefinition(obj) {
        this.foregroundColors = new $610f1a9c13915db5$var$ColorSetDefinition({
            "default": {
                default: "#333333",
                subtle: "#EE333333"
            },
            "dark": {
                default: "#000000",
                subtle: "#66000000"
            },
            "light": {
                default: "#FFFFFF",
                subtle: "#33000000"
            },
            "accent": {
                default: "#2E89FC",
                subtle: "#882E89FC"
            },
            "good": {
                default: "#028A02",
                subtle: "#DD027502"
            },
            "warning": {
                default: "#E69500",
                subtle: "#DDE69500"
            },
            "attention": {
                default: "#CC3300",
                subtle: "#DDCC3300"
            }
        });
        this.parse(obj);
    }
    ContainerStyleDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.backgroundColor = obj["backgroundColor"];
            this.foregroundColors.parse(obj["foregroundColors"]);
            this.highlightBackgroundColor = obj["highlightBackgroundColor"];
            this.highlightForegroundColor = obj["highlightForegroundColor"];
            this.borderColor = obj["borderColor"];
        }
    };
    Object.defineProperty(ContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleDefinition;
}();
module.exports.ContainerStyleDefinition = $610f1a9c13915db5$var$ContainerStyleDefinition;
var $610f1a9c13915db5$var$BuiltInContainerStyleDefinition = /** @class */ function(_super) {
    $610f1a9c13915db5$var$__extends(BuiltInContainerStyleDefinition, _super);
    function BuiltInContainerStyleDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BuiltInContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return BuiltInContainerStyleDefinition;
}($610f1a9c13915db5$var$ContainerStyleDefinition);
var $610f1a9c13915db5$var$ContainerStyleSet = /** @class */ function() {
    function ContainerStyleSet(obj) {
        this._allStyles = {};
        this._allStyles[$gIXBn.ContainerStyle.Default] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Emphasis] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Accent] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Good] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Attention] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        this._allStyles[$gIXBn.ContainerStyle.Warning] = new $610f1a9c13915db5$var$BuiltInContainerStyleDefinition();
        if (obj) {
            this._allStyles[$gIXBn.ContainerStyle.Default].parse(obj[$gIXBn.ContainerStyle.Default]);
            this._allStyles[$gIXBn.ContainerStyle.Emphasis].parse(obj[$gIXBn.ContainerStyle.Emphasis]);
            this._allStyles[$gIXBn.ContainerStyle.Accent].parse(obj[$gIXBn.ContainerStyle.Accent]);
            this._allStyles[$gIXBn.ContainerStyle.Good].parse(obj[$gIXBn.ContainerStyle.Good]);
            this._allStyles[$gIXBn.ContainerStyle.Attention].parse(obj[$gIXBn.ContainerStyle.Attention]);
            this._allStyles[$gIXBn.ContainerStyle.Warning].parse(obj[$gIXBn.ContainerStyle.Warning]);
            var customStyleArray = obj["customStyles"];
            if (customStyleArray && Array.isArray(customStyleArray)) for(var _i = 0, customStyleArray_1 = customStyleArray; _i < customStyleArray_1.length; _i++){
                var customStyle = customStyleArray_1[_i];
                if (customStyle) {
                    var styleName = customStyle["name"];
                    if (styleName && typeof styleName === "string") {
                        if (this._allStyles.hasOwnProperty(styleName)) this._allStyles[styleName].parse(customStyle["style"]);
                        else this._allStyles[styleName] = new $610f1a9c13915db5$var$ContainerStyleDefinition(customStyle["style"]);
                    }
                }
            }
        }
    }
    ContainerStyleSet.prototype.toJSON = function() {
        var _this = this;
        var customStyleArray = [];
        Object.keys(this._allStyles).forEach(function(key) {
            if (!_this._allStyles[key].isBuiltIn) customStyleArray.push({
                name: key,
                style: _this._allStyles[key]
            });
        });
        var result = {
            default: this.default,
            emphasis: this.emphasis
        };
        if (customStyleArray.length > 0) result.customStyles = customStyleArray;
        return result;
    };
    ContainerStyleSet.prototype.getStyleByName = function(name, defaultValue) {
        if (name && this._allStyles.hasOwnProperty(name)) return this._allStyles[name];
        else return defaultValue ? defaultValue : this._allStyles[$gIXBn.ContainerStyle.Default];
    };
    Object.defineProperty(ContainerStyleSet.prototype, "default", {
        get: function() {
            return this._allStyles[$gIXBn.ContainerStyle.Default];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerStyleSet.prototype, "emphasis", {
        get: function() {
            return this._allStyles[$gIXBn.ContainerStyle.Emphasis];
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleSet;
}();
module.exports.ContainerStyleSet = $610f1a9c13915db5$var$ContainerStyleSet;
var $610f1a9c13915db5$var$FontTypeDefinition = /** @class */ function() {
    function FontTypeDefinition(fontFamily) {
        this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif";
        this.fontSizes = {
            small: 12,
            default: 14,
            medium: 17,
            large: 21,
            extraLarge: 26
        };
        this.fontWeights = {
            lighter: 200,
            default: 400,
            bolder: 600
        };
        if (fontFamily) this.fontFamily = fontFamily;
    }
    FontTypeDefinition.prototype.parse = function(obj) {
        this.fontFamily = obj["fontFamily"] || this.fontFamily;
        this.fontSizes = {
            small: obj.fontSizes && obj.fontSizes["small"] || this.fontSizes.small,
            default: obj.fontSizes && obj.fontSizes["default"] || this.fontSizes.default,
            medium: obj.fontSizes && obj.fontSizes["medium"] || this.fontSizes.medium,
            large: obj.fontSizes && obj.fontSizes["large"] || this.fontSizes.large,
            extraLarge: obj.fontSizes && obj.fontSizes["extraLarge"] || this.fontSizes.extraLarge
        };
        this.fontWeights = {
            lighter: obj.fontWeights && obj.fontWeights["lighter"] || this.fontWeights.lighter,
            default: obj.fontWeights && obj.fontWeights["default"] || this.fontWeights.default,
            bolder: obj.fontWeights && obj.fontWeights["bolder"] || this.fontWeights.bolder
        };
    };
    FontTypeDefinition.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
    return FontTypeDefinition;
}();
module.exports.FontTypeDefinition = $610f1a9c13915db5$var$FontTypeDefinition;
var $610f1a9c13915db5$var$FontTypeSet = /** @class */ function() {
    function FontTypeSet(obj) {
        this.default = new $610f1a9c13915db5$var$FontTypeDefinition();
        this.monospace = new $610f1a9c13915db5$var$FontTypeDefinition("'Courier New', Courier, monospace");
        if (obj) {
            this.default.parse(obj["default"]);
            this.monospace.parse(obj["monospace"]);
        }
    }
    FontTypeSet.prototype.getStyleDefinition = function(style) {
        switch(style){
            case $gIXBn.FontType.Monospace:
                return this.monospace;
            case $gIXBn.FontType.Default:
            default:
                return this.default;
        }
    };
    return FontTypeSet;
}();
module.exports.FontTypeSet = $610f1a9c13915db5$var$FontTypeSet;
var $610f1a9c13915db5$var$CarouselConfig = /** @class */ function() {
    function CarouselConfig(obj) {
        this.maxCarouselPages = 10;
        this.minAutoplayDelay = 5000.0;
        if (obj) {
            this.maxCarouselPages = obj["maxCarouselPages"] != null ? obj["maxCarouselPages"] : this.maxCarouselPages;
            this.minAutoplayDelay = obj["minAutoplayDelay"] != null ? obj["minAutoplayDelay"] : this.minAutoplayDelay;
        }
    }
    CarouselConfig.prototype.toJSON = function() {
        return {
            maxCarouselPages: this.maxCarouselPages,
            minAutoplayDelay: this.minAutoplayDelay
        };
    };
    return CarouselConfig;
}();
module.exports.CarouselConfig = $610f1a9c13915db5$var$CarouselConfig;
var $610f1a9c13915db5$var$HostConfig = /** @class */ function() {
    function HostConfig(obj) {
        this.hostCapabilities = new $7Lc5Q.HostCapabilities();
        this.choiceSetInputValueSeparator = ",";
        this.supportsInteractivity = true;
        this.spacing = {
            small: 3,
            default: 8,
            medium: 20,
            large: 30,
            extraLarge: 40,
            padding: 15
        };
        this.separator = {
            lineThickness: 1,
            lineColor: "#EEEEEE"
        };
        this.imageSizes = {
            small: 40,
            medium: 80,
            large: 160
        };
        this.containerStyles = new $610f1a9c13915db5$var$ContainerStyleSet();
        this.inputs = new $610f1a9c13915db5$var$InputConfig();
        this.actions = new $610f1a9c13915db5$var$ActionsConfig();
        this.adaptiveCard = new $610f1a9c13915db5$var$AdaptiveCardConfig();
        this.imageSet = new $610f1a9c13915db5$var$ImageSetConfig();
        this.media = new $610f1a9c13915db5$var$MediaConfig();
        this.factSet = new $610f1a9c13915db5$var$FactSetConfig();
        this.table = new $610f1a9c13915db5$var$TableConfig();
        this.textStyles = new $610f1a9c13915db5$var$TextStyleSet();
        this.textBlock = new $610f1a9c13915db5$var$TextBlockConfig();
        this.carousel = new $610f1a9c13915db5$var$CarouselConfig();
        this.alwaysAllowBleed = false;
        if (obj) {
            if (typeof obj === "string" || obj instanceof String) obj = JSON.parse(obj);
            this.choiceSetInputValueSeparator = obj && typeof obj["choiceSetInputValueSeparator"] === "string" ? obj["choiceSetInputValueSeparator"] : this.choiceSetInputValueSeparator;
            this.supportsInteractivity = obj && typeof obj["supportsInteractivity"] === "boolean" ? obj["supportsInteractivity"] : this.supportsInteractivity;
            this._legacyFontType = new $610f1a9c13915db5$var$FontTypeDefinition();
            this._legacyFontType.parse(obj);
            if (obj.fontTypes) this.fontTypes = new $610f1a9c13915db5$var$FontTypeSet(obj.fontTypes);
            if (obj.lineHeights) this.lineHeights = {
                small: obj.lineHeights["small"],
                default: obj.lineHeights["default"],
                medium: obj.lineHeights["medium"],
                large: obj.lineHeights["large"],
                extraLarge: obj.lineHeights["extraLarge"]
            };
            this.imageSizes = {
                small: obj.imageSizes && obj.imageSizes["small"] || this.imageSizes.small,
                medium: obj.imageSizes && obj.imageSizes["medium"] || this.imageSizes.medium,
                large: obj.imageSizes && obj.imageSizes["large"] || this.imageSizes.large
            };
            this.containerStyles = new $610f1a9c13915db5$var$ContainerStyleSet(obj["containerStyles"]);
            this.spacing = {
                small: obj.spacing && obj.spacing["small"] || this.spacing.small,
                default: obj.spacing && obj.spacing["default"] || this.spacing.default,
                medium: obj.spacing && obj.spacing["medium"] || this.spacing.medium,
                large: obj.spacing && obj.spacing["large"] || this.spacing.large,
                extraLarge: obj.spacing && obj.spacing["extraLarge"] || this.spacing.extraLarge,
                padding: obj.spacing && obj.spacing["padding"] || this.spacing.padding
            };
            this.separator = {
                lineThickness: obj.separator && obj.separator["lineThickness"] || this.separator.lineThickness,
                lineColor: obj.separator && obj.separator["lineColor"] || this.separator.lineColor
            };
            this.inputs = new $610f1a9c13915db5$var$InputConfig(obj.inputs || this.inputs);
            this.actions = new $610f1a9c13915db5$var$ActionsConfig(obj.actions || this.actions);
            this.adaptiveCard = new $610f1a9c13915db5$var$AdaptiveCardConfig(obj.adaptiveCard || this.adaptiveCard);
            this.imageSet = new $610f1a9c13915db5$var$ImageSetConfig(obj["imageSet"]);
            this.factSet = new $610f1a9c13915db5$var$FactSetConfig(obj["factSet"]);
            this.textStyles = new $610f1a9c13915db5$var$TextStyleSet(obj["textStyles"]);
            this.textBlock = new $610f1a9c13915db5$var$TextBlockConfig(obj["textBlock"]);
            this.carousel = new $610f1a9c13915db5$var$CarouselConfig(obj["carousel"]);
        }
    }
    HostConfig.prototype.getFontTypeDefinition = function(style) {
        if (this.fontTypes) return this.fontTypes.getStyleDefinition(style);
        else return style === $gIXBn.FontType.Monospace ? $610f1a9c13915db5$var$FontTypeDefinition.monospace : this._legacyFontType;
    };
    HostConfig.prototype.getEffectiveSpacing = function(spacing) {
        switch(spacing){
            case $gIXBn.Spacing.Small:
                return this.spacing.small;
            case $gIXBn.Spacing.Default:
                return this.spacing.default;
            case $gIXBn.Spacing.Medium:
                return this.spacing.medium;
            case $gIXBn.Spacing.Large:
                return this.spacing.large;
            case $gIXBn.Spacing.ExtraLarge:
                return this.spacing.extraLarge;
            case $gIXBn.Spacing.Padding:
                return this.spacing.padding;
            default:
                return 0;
        }
    };
    HostConfig.prototype.paddingDefinitionToSpacingDefinition = function(paddingDefinition) {
        return new $6BHj7.SpacingDefinition(this.getEffectiveSpacing(paddingDefinition.top), this.getEffectiveSpacing(paddingDefinition.right), this.getEffectiveSpacing(paddingDefinition.bottom), this.getEffectiveSpacing(paddingDefinition.left));
    };
    HostConfig.prototype.makeCssClassNames = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = [];
        for(var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++){
            var className = classNames_1[_a];
            result.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + className);
        }
        return result;
    };
    HostConfig.prototype.makeCssClassName = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = this.makeCssClassNames.apply(this, classNames).join(" ");
        return result ? result : "";
    };
    Object.defineProperty(HostConfig.prototype, "fontFamily", {
        get: function() {
            return this._legacyFontType.fontFamily;
        },
        set: function(value) {
            this._legacyFontType.fontFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontSizes", {
        get: function() {
            return this._legacyFontType.fontSizes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontWeights", {
        get: function() {
            return this._legacyFontType.fontWeights;
        },
        enumerable: false,
        configurable: true
    });
    return HostConfig;
}();
module.exports.HostConfig = $610f1a9c13915db5$var$HostConfig;
// eslint-disable-next-line @typescript-eslint/naming-convention
module.exports.defaultHostConfig = new $610f1a9c13915db5$var$HostConfig({
    supportsInteractivity: true,
    spacing: {
        small: 10,
        default: 20,
        medium: 30,
        large: 40,
        extraLarge: 50,
        padding: 20
    },
    separator: {
        lineThickness: 1,
        lineColor: "#EEEEEE"
    },
    fontTypes: {
        default: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        },
        monospace: {
            fontFamily: "'Courier New', Courier, monospace",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        }
    },
    imageSizes: {
        small: 40,
        medium: 80,
        large: 160
    },
    containerStyles: {
        default: {
            backgroundColor: "#FFFFFF",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        emphasis: {
            backgroundColor: "#08000000",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        accent: {
            backgroundColor: "#C7DEF9",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        good: {
            backgroundColor: "#CCFFCC",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        attention: {
            backgroundColor: "#FFC5B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        warning: {
            backgroundColor: "#FFE2B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        }
    },
    inputs: {
        label: {
            requiredInputs: {
                weight: $gIXBn.TextWeight.Bolder,
                suffix: " *",
                suffixColor: $gIXBn.TextColor.Attention
            },
            optionalInputs: {
                weight: $gIXBn.TextWeight.Bolder
            }
        },
        errorMessage: {
            color: $gIXBn.TextColor.Attention,
            weight: $gIXBn.TextWeight.Bolder
        },
        debounceTimeInMilliSeconds: 250
    },
    actions: {
        maxActions: 5,
        spacing: $gIXBn.Spacing.Default,
        buttonSpacing: 10,
        showCard: {
            actionMode: $gIXBn.ShowCardActionMode.Inline,
            inlineTopMargin: 16
        },
        actionsOrientation: $gIXBn.Orientation.Horizontal,
        actionAlignment: $gIXBn.ActionAlignment.Left
    },
    adaptiveCard: {
        allowCustomStyle: false
    },
    imageSet: {
        imageSize: $gIXBn.Size.Medium,
        maxImageHeight: 100
    },
    factSet: {
        title: {
            color: $gIXBn.TextColor.Default,
            size: $gIXBn.TextSize.Default,
            isSubtle: false,
            weight: $gIXBn.TextWeight.Bolder,
            wrap: true,
            maxWidth: 150
        },
        value: {
            color: $gIXBn.TextColor.Default,
            size: $gIXBn.TextSize.Default,
            isSubtle: false,
            weight: $gIXBn.TextWeight.Default,
            wrap: true
        },
        spacing: 10
    },
    carousel: {
        maxCarouselPages: 10,
        minAutoplayDuration: 5000
    },
    textBlock: {
        headingLevel: 2
    }
});

});

parcelRegister("2Zn2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalRegistry = module.exports.CardObjectRegistry = void 0;

var $5Ougt = parcelRequire("5Ougt");
var $22d3271605b452a3$var$CardObjectRegistry = /** @class */ function() {
    function CardObjectRegistry() {
        this._items = {};
    }
    CardObjectRegistry.prototype.findByName = function(typeName) {
        return this._items.hasOwnProperty(typeName) ? this._items[typeName] : undefined;
    };
    CardObjectRegistry.prototype.clear = function() {
        this._items = {};
    };
    CardObjectRegistry.prototype.copyTo = function(target) {
        var keys = Object.keys(this._items);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            var typeRegistration = this._items[key];
            target.register(typeRegistration.typeName, typeRegistration.objectType, typeRegistration.schemaVersion);
        }
    };
    CardObjectRegistry.prototype.register = function(typeName, objectType, schemaVersion) {
        if (schemaVersion === void 0) schemaVersion = $5Ougt.Versions.v1_0;
        var registrationInfo = this.findByName(typeName);
        if (registrationInfo !== undefined) registrationInfo.objectType = objectType;
        else registrationInfo = {
            typeName: typeName,
            objectType: objectType,
            schemaVersion: schemaVersion
        };
        this._items[typeName] = registrationInfo;
    };
    CardObjectRegistry.prototype.unregister = function(typeName) {
        delete this._items[typeName];
    };
    CardObjectRegistry.prototype.createInstance = function(typeName, targetVersion) {
        var registrationInfo = this.findByName(typeName);
        return registrationInfo && registrationInfo.schemaVersion.compareTo(targetVersion) <= 0 ? new registrationInfo.objectType() : undefined;
    };
    CardObjectRegistry.prototype.getItemCount = function() {
        return Object.keys(this._items).length;
    };
    CardObjectRegistry.prototype.getItemAt = function(index) {
        var _this = this;
        return Object.keys(this._items).map(function(e) {
            return _this._items[e];
        })[index];
    };
    return CardObjectRegistry;
}();
module.exports.CardObjectRegistry = $22d3271605b452a3$var$CardObjectRegistry;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $22d3271605b452a3$var$GlobalRegistry = /** @class */ function() {
    function GlobalRegistry() {}
    GlobalRegistry.populateWithDefaultElements = function(registry) {
        registry.clear();
        GlobalRegistry.defaultElements.copyTo(registry);
    };
    GlobalRegistry.populateWithDefaultActions = function(registry) {
        registry.clear();
        GlobalRegistry.defaultActions.copyTo(registry);
    };
    Object.defineProperty(GlobalRegistry, "elements", {
        get: function() {
            if (!GlobalRegistry._elements) {
                GlobalRegistry._elements = new $22d3271605b452a3$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultElements(GlobalRegistry._elements);
            }
            return GlobalRegistry._elements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalRegistry, "actions", {
        get: function() {
            if (!GlobalRegistry._actions) {
                GlobalRegistry._actions = new $22d3271605b452a3$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultActions(GlobalRegistry._actions);
            }
            return GlobalRegistry._actions;
        },
        enumerable: false,
        configurable: true
    });
    GlobalRegistry.reset = function() {
        GlobalRegistry._elements = undefined;
        GlobalRegistry._actions = undefined;
    };
    GlobalRegistry.defaultElements = new $22d3271605b452a3$var$CardObjectRegistry();
    GlobalRegistry.defaultActions = new $22d3271605b452a3$var$CardObjectRegistry();
    return GlobalRegistry;
}();
module.exports.GlobalRegistry = $22d3271605b452a3$var$GlobalRegistry;

});

parcelRegister("dUjDB", function(module, exports) {
"use strict";
var $a1ffbcf9ace7d47a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a1ffbcf9ace7d47a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardObject = module.exports.ValidationResults = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $24F6S = parcelRequire("24F6S");

var $6BHj7 = parcelRequire("6BHj7");

var $7Lc5Q = parcelRequire("7Lc5Q");

var $5Ougt = parcelRequire("5Ougt");
var $a1ffbcf9ace7d47a$var$ValidationResults = /** @class */ function() {
    function ValidationResults() {
        this.allIds = {};
        this.validationEvents = [];
    }
    ValidationResults.prototype.addFailure = function(cardObject, event, message) {
        this.validationEvents.push({
            phase: $gIXBn.ValidationPhase.Validation,
            source: cardObject,
            event: event,
            message: message
        });
    };
    return ValidationResults;
}();
module.exports.ValidationResults = $a1ffbcf9ace7d47a$var$ValidationResults;
var $a1ffbcf9ace7d47a$var$CardObject = /** @class */ function(_super) {
    $a1ffbcf9ace7d47a$var$__extends(CardObject, _super);
    function CardObject() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._shouldFallback = false;
        return _this;
    }
    CardObject.prototype.getSchemaKey = function() {
        return this.getJsonTypeName();
    };
    Object.defineProperty(CardObject.prototype, "requires", {
        get: function() {
            return this.getValue(CardObject.requiresProperty);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if this CardObject contains the given DOM Node.
     * @param node The DOM Node to look for.
     * @returns `true` if the DOM Node was found, `false` otherwise.
     */ CardObject.prototype.contains = function(node) {
        if (this._renderedElement) return this._renderedElement.contains(node);
        return false;
    };
    CardObject.prototype.preProcessPropertyValue = function(prop, propertyValue) {
        var value = propertyValue === undefined ? this.getValue(prop) : propertyValue;
        if ($6BHj7.GlobalSettings.allowPreProcessingPropertyValues) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var currentObject = this;
            while(currentObject && !currentObject.onPreProcessPropertyValue)currentObject = currentObject.parent;
            if (currentObject && currentObject.onPreProcessPropertyValue) return currentObject.onPreProcessPropertyValue(this, prop, value);
        }
        return value;
    };
    CardObject.prototype.setParent = function(value) {
        this._parent = value;
    };
    CardObject.prototype.setShouldFallback = function(value) {
        this._shouldFallback = value;
    };
    CardObject.prototype.shouldFallback = function() {
        return this._shouldFallback || !this.requires.areAllMet(this.hostConfig.hostCapabilities);
    };
    CardObject.prototype.getRootObject = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var currentObject = this;
        while(currentObject.parent)currentObject = currentObject.parent;
        return currentObject;
    };
    CardObject.prototype.internalValidateProperties = function(context) {
        if (this.id) {
            if (context.allIds.hasOwnProperty(this.id)) {
                if (context.allIds[this.id] === 1) context.addFailure(this, $gIXBn.ValidationEvent.DuplicateId, $24F6S.Strings.errors.duplicateId(this.id));
                context.allIds[this.id] += 1;
            } else context.allIds[this.id] = 1;
        }
    };
    CardObject.prototype.validateProperties = function() {
        var result = new $a1ffbcf9ace7d47a$var$ValidationResults();
        this.internalValidateProperties(result);
        return result;
    };
    /**
     * Recursively searches this CardObject and any children to find the
     * innermost CardObject that owns the given DOM Node.
     *
     * @param node The DOM Node to look for.
     *
     * @returns The owner of the given DOM Node, or `undefined` if no owner was found.
     */ CardObject.prototype.findDOMNodeOwner = function(node) {
        // default implementation for CardObjects with no associated children
        return this.contains(node) ? this : undefined;
    };
    CardObject.prototype.releaseDOMResources = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(CardObject.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardObject.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    CardObject.typeNameProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "type", undefined, undefined, undefined, function(sender) {
        return sender.getJsonTypeName();
    });
    CardObject.idProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "id");
    CardObject.requiresProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_2, "requires", $7Lc5Q.HostCapabilities, false, new $7Lc5Q.HostCapabilities());
    $a1ffbcf9ace7d47a$var$__decorate([
        (0, $5Ougt.property)(CardObject.idProperty)
    ], CardObject.prototype, "id", void 0);
    $a1ffbcf9ace7d47a$var$__decorate([
        (0, $5Ougt.property)(CardObject.requiresProperty)
    ], CardObject.prototype, "requires", null);
    return CardObject;
}($5Ougt.SerializableObject);
module.exports.CardObject = $a1ffbcf9ace7d47a$var$CardObject;

});

parcelRegister("6XfIC", function(module, exports) {
"use strict";
var $5104722604b983cb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5104722604b983cb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5104722604b983cb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5104722604b983cb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5104722604b983cb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundImage = module.exports.ContainerBase = module.exports.StylableCardElementContainer = module.exports.ContainerStyleProperty = module.exports.ActionSet = module.exports.ShowCardAction = module.exports.HttpAction = module.exports.HttpHeader = module.exports.ToggleVisibilityAction = module.exports.OpenUrlAction = module.exports.DataQuery = module.exports.ExecuteAction = module.exports.UniversalAction = module.exports.SubmitAction = module.exports.SubmitActionBase = module.exports.Action = module.exports.TimeInput = module.exports.TimeProperty = module.exports.DateInput = module.exports.NumberInput = module.exports.FilteredChoiceSet = module.exports.ChoiceSetInput = module.exports.ChoiceSetInputDataQuery = module.exports.Choice = module.exports.ToggleInput = module.exports.TextInput = module.exports.Input = module.exports.Media = module.exports.YouTubePlayer = module.exports.DailymotionPlayer = module.exports.VimeoPlayer = module.exports.IFrameMediaMediaPlayer = module.exports.CustomMediaPlayer = module.exports.HTML5MediaPlayer = module.exports.MediaPlayer = module.exports.MediaSource = module.exports.CaptionSource = module.exports.ContentSource = module.exports.ImageSet = module.exports.CardElementContainer = module.exports.Image = module.exports.FactSet = module.exports.Fact = module.exports.RichTextBlock = module.exports.TextRun = module.exports.TextBlock = module.exports.BaseTextBlock = module.exports.ActionProperty = module.exports.CardElement = module.exports.renderSeparation = void 0;
module.exports.SerializationContext = module.exports.AdaptiveCard = module.exports.Authentication = module.exports.TokenExchangeResource = module.exports.AuthCardButton = module.exports.RefreshDefinition = module.exports.RefreshActionProperty = module.exports.ContainerWithActions = module.exports.ColumnSet = module.exports.Column = module.exports.Container = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $6BHj7 = parcelRequire("6BHj7");

var $F6YrP = parcelRequire("F6YrP");

var $8kDQQ = parcelRequire("8kDQQ");

var $fuLKQ = parcelRequire("fuLKQ");

var $dUjDB = parcelRequire("dUjDB");

var $5Ougt = parcelRequire("5Ougt");

var $2Zn2I = parcelRequire("2Zn2I");

var $24F6S = parcelRequire("24F6S");

var $iX2Kh = parcelRequire("iX2Kh");
function $5104722604b983cb$var$clearElement(element) {
    var _a, _b;
    var trustedHtml = typeof window === 'undefined' ? "" : (_b = (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.emptyHTML) !== null && _b !== void 0 ? _b : "";
    element.innerHTML = trustedHtml;
}
function $5104722604b983cb$var$renderSeparation(hostConfig, separationDefinition, orientation) {
    if (separationDefinition.spacing > 0 || separationDefinition.lineThickness && separationDefinition.lineThickness > 0) {
        var separator = document.createElement("div");
        separator.className = hostConfig.makeCssClassName("ac-" + (orientation === $gIXBn.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator");
        separator.setAttribute("aria-hidden", "true");
        var color = separationDefinition.lineColor ? $F6YrP.stringToCssColor(separationDefinition.lineColor) : "";
        if (orientation === $gIXBn.Orientation.Horizontal) {
            if (separationDefinition.lineThickness) {
                separator.style.paddingTop = separationDefinition.spacing / 2 + "px";
                separator.style.marginBottom = separationDefinition.spacing / 2 + "px";
                separator.style.borderBottom = separationDefinition.lineThickness + "px solid " + color;
            } else separator.style.height = separationDefinition.spacing + "px";
        } else if (separationDefinition.lineThickness) {
            separator.style.paddingLeft = separationDefinition.spacing / 2 + "px";
            separator.style.marginRight = separationDefinition.spacing / 2 + "px";
            separator.style.borderRight = separationDefinition.lineThickness + "px solid " + color;
        } else separator.style.width = separationDefinition.spacing + "px";
        separator.style.overflow = "hidden";
        separator.style.flex = "0 0 auto";
        return separator;
    } else return undefined;
}
module.exports.renderSeparation = $5104722604b983cb$var$renderSeparation;
var $5104722604b983cb$var$CardElement = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CardElement, _super);
    function CardElement() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._truncatedDueToOverflow = false;
        return _this;
    }
    Object.defineProperty(CardElement.prototype, "lang", {
        get: function() {
            var lang = this.getValue(CardElement.langProperty);
            if (lang) return lang;
            else {
                if (this.parent) return this.parent.lang;
                else return undefined;
            }
        },
        set: function(value) {
            this.setValue(CardElement.langProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isVisible", {
        get: function() {
            return this.getValue(CardElement.isVisibleProperty);
        },
        set: function(value) {
            // If the element is going to be hidden, reset any changes that were due
            // to overflow truncation (this ensures that if the element is later
            // un-hidden it has the right content)
            if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation && !value) this.undoOverflowTruncation();
            if (this.isVisible !== value) {
                this.setValue(CardElement.isVisibleProperty, value);
                this.updateRenderedElementVisibility();
                if (this._renderedElement) $5104722604b983cb$var$raiseElementVisibilityChangedEvent(this);
            }
            if (this._renderedElement) this._renderedElement.setAttribute("aria-expanded", value.toString());
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.internalRenderSeparator = function() {
        var renderedSeparator = $5104722604b983cb$var$renderSeparation(this.hostConfig, {
            spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
            lineThickness: this.separator ? this.hostConfig.separator.lineThickness : undefined,
            lineColor: this.separator ? this.hostConfig.separator.lineColor : undefined
        }, this.separatorOrientation);
        if ($6BHj7.GlobalSettings.alwaysBleedSeparators && renderedSeparator && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
            // Adjust separator's margins if the option to always bleed separators is turned on
            var parentContainer = this.getParentContainer();
            if (parentContainer && parentContainer.getEffectivePadding()) {
                var parentPhysicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(parentContainer.getEffectivePadding());
                renderedSeparator.style.marginLeft = "-" + parentPhysicalPadding.left + "px";
                renderedSeparator.style.marginRight = "-" + parentPhysicalPadding.right + "px";
            }
        }
        return renderedSeparator;
    };
    CardElement.prototype.updateRenderedElementVisibility = function() {
        var displayMode = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
        if (this._renderedElement) {
            if (displayMode) this._renderedElement.style.display = displayMode;
            else this._renderedElement.style.removeProperty("display");
        }
        if (this._separatorElement) {
            if (this.parent && this.parent.isFirstElement(this)) this._separatorElement.style.display = "none";
            else if (displayMode) this._separatorElement.style.display = displayMode;
            else this._separatorElement.style.removeProperty("display");
        }
    };
    CardElement.prototype.hideElementDueToOverflow = function() {
        if (this._renderedElement && this.isVisible) {
            this._renderedElement.style.visibility = "hidden";
            this.isVisible = false;
            $5104722604b983cb$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    CardElement.prototype.showElementHiddenDueToOverflow = function() {
        if (this._renderedElement && !this.isVisible) {
            this._renderedElement.style.removeProperty("visibility");
            this.isVisible = true;
            $5104722604b983cb$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.handleOverflow = function(maxHeight) {
        if (this.isVisible || this.isHiddenDueToOverflow()) {
            var handled = this.truncateOverflow(maxHeight);
            // Even if we were unable to truncate the element to fit this time,
            // it still could have been previously truncated
            this._truncatedDueToOverflow = handled || this._truncatedDueToOverflow;
            if (!handled) this.hideElementDueToOverflow();
            else if (handled && !this.isVisible) this.showElementHiddenDueToOverflow();
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.resetOverflow = function() {
        var sizeChanged = false;
        if (this._truncatedDueToOverflow) {
            this.undoOverflowTruncation();
            this._truncatedDueToOverflow = false;
            sizeChanged = true;
        }
        if (this.isHiddenDueToOverflow()) this.showElementHiddenDueToOverflow();
        return sizeChanged;
    };
    CardElement.prototype.getDefaultSerializationContext = function() {
        return new $5104722604b983cb$var$SerializationContext();
    };
    CardElement.prototype.createPlaceholderElement = function() {
        var styleDefinition = this.getEffectiveStyleDefinition();
        var foregroundCssColor = $F6YrP.stringToCssColor(styleDefinition.foregroundColors.default.subtle);
        var element = document.createElement("div");
        element.style.border = "1px dashed " + foregroundCssColor;
        element.style.padding = "4px";
        element.style.minHeight = "32px";
        element.style.fontSize = "10px";
        if (foregroundCssColor) element.style.color = foregroundCssColor;
        element.innerText = $24F6S.Strings.defaults.emptyElementText(this.getJsonTypeName());
        return element;
    };
    CardElement.prototype.adjustRenderedElementSize = function(renderedElement) {
        if (this.height === "auto") renderedElement.style.flex = "0 0 auto";
        else renderedElement.style.flex = "1 1 auto";
    };
    /*
     * Called when mouse enters or leaves the card.
     * Inputs elements need to update their visual state in such events like showing or hiding borders etc.
     * It calls Input.updateVisualState(eventType) for all inputs.
     * This method on input (updateVisualState) is supposed to be called from card level on mouse events.
     */ CardElement.prototype.updateInputsVisualState = function(hover) {
        var allInputs = this.getAllInputs();
        var inputEventType = !!hover ? $5104722604b983cb$var$InputEventType.MouseEnterOnCard : $5104722604b983cb$var$InputEventType.MouseLeaveOnCard;
        allInputs.forEach(function(input) {
            return input.updateVisualState(inputEventType);
        });
    };
    CardElement.prototype.isDisplayed = function() {
        return this._renderedElement !== undefined && this.isVisible && this._renderedElement.offsetHeight > 0;
    };
    CardElement.prototype.overrideInternalRender = function() {
        return this.internalRender();
    };
    CardElement.prototype.applyPadding = function() {
        if (this.separatorElement && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
            if ($6BHj7.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
                var padding = new $6BHj7.PaddingDefinition();
                this.getImmediateSurroundingPadding(padding);
                var physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
                this.separatorElement.style.marginLeft = "-" + physicalPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + physicalPadding.right + "px";
            } else {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    /*
     * Called when this element overflows the bottom of the card.
     * maxHeight will be the amount of space still available on the card (0 if
     * the element is fully off the card).
     */ CardElement.prototype.truncateOverflow = function(_maxHeight) {
        // Child implementations should return true if the element handled
        // the truncation request such that its content fits within maxHeight,
        // false if the element should fall back to being hidden
        return false;
    };
    /*
     * This should reverse any changes performed in truncateOverflow().
     */ CardElement.prototype.undoOverflowTruncation = function() {
        return;
    };
    CardElement.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition();
    };
    CardElement.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return false;
    };
    CardElement.prototype.getHasBorder = function() {
        return false;
    };
    CardElement.prototype.getPadding = function() {
        return this._padding;
    };
    CardElement.prototype.setPadding = function(value) {
        this._padding = value;
    };
    CardElement.prototype.shouldSerialize = function(context) {
        return context.elementRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Object.defineProperty(CardElement.prototype, "useDefaultSizing", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorOrientation", {
        get: function() {
            return $gIXBn.Orientation.Horizontal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "defaultStyle", {
        get: function() {
            return $gIXBn.ContainerStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.parse = function(source, context) {
        _super.prototype.parse.call(this, source, context ? context : new $5104722604b983cb$var$SerializationContext());
    };
    CardElement.prototype.asString = function() {
        return "";
    };
    CardElement.prototype.isBleeding = function() {
        return false;
    };
    CardElement.prototype.getEffectiveStyle = function() {
        if (this.parent) return this.parent.getEffectiveStyle();
        return this.defaultStyle;
    };
    CardElement.prototype.getEffectiveStyleDefinition = function() {
        return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
    };
    CardElement.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.parent) return this.parent.getEffectiveTextStyleDefinition();
        return this.hostConfig.textStyles.default;
    };
    CardElement.prototype.getForbiddenActionTypes = function() {
        return [];
    };
    CardElement.prototype.getImmediateSurroundingPadding = function(result, processTop, processRight, processBottom, processLeft) {
        if (processTop === void 0) processTop = true;
        if (processRight === void 0) processRight = true;
        if (processBottom === void 0) processBottom = true;
        if (processLeft === void 0) processLeft = true;
        if (this.parent) {
            var doProcessTop = processTop && this.parent.isTopElement(this);
            var doProcessRight = processRight && this.parent.isRightMostElement(this);
            var doProcessBottom = processBottom && this.parent.isBottomElement(this);
            var doProcessLeft = processLeft && this.parent.isLeftMostElement(this);
            var effectivePadding = this.parent.getEffectivePadding();
            if (effectivePadding) {
                if (doProcessTop && effectivePadding.top !== $gIXBn.Spacing.None) {
                    result.top = effectivePadding.top;
                    doProcessTop = false;
                }
                if (doProcessRight && effectivePadding.right !== $gIXBn.Spacing.None) {
                    result.right = effectivePadding.right;
                    doProcessRight = false;
                }
                if (doProcessBottom && effectivePadding.bottom !== $gIXBn.Spacing.None) {
                    result.bottom = effectivePadding.bottom;
                    doProcessBottom = false;
                }
                if (doProcessLeft && effectivePadding.left !== $gIXBn.Spacing.None) {
                    result.left = effectivePadding.left;
                    doProcessLeft = false;
                }
            }
            if (doProcessTop || doProcessRight || doProcessBottom || doProcessLeft) this.parent.getImmediateSurroundingPadding(result, doProcessTop, doProcessRight, doProcessBottom, doProcessLeft);
        }
    };
    CardElement.prototype.getActionCount = function() {
        return 0;
    };
    CardElement.prototype.getActionAt = function(index) {
        throw new Error($24F6S.Strings.errors.indexOutOfRange(index));
    };
    CardElement.prototype.indexOfAction = function(action) {
        for(var i = 0; i < this.getActionCount(); i++){
            if (this.getActionAt(i) === action) return i;
        }
        return -1;
    };
    CardElement.prototype.remove = function() {
        if (this.parent && this.parent instanceof $5104722604b983cb$var$CardElementContainer) return this.parent.removeItem(this);
        return false;
    };
    CardElement.prototype.render = function() {
        this._renderedElement = this.overrideInternalRender();
        this._separatorElement = this.internalRenderSeparator();
        if (this._renderedElement) {
            if (this.id) this._renderedElement.id = this.id;
            if (this.customCssSelector) this._renderedElement.classList.add(this.customCssSelector);
            this._renderedElement.style.boxSizing = "border-box";
            this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : undefined;
            this.adjustRenderedElementSize(this._renderedElement);
            this.updateLayout(false);
        } else if (this.isDesignMode()) this._renderedElement = this.createPlaceholderElement();
        return this._renderedElement;
    };
    CardElement.prototype.updateLayout = function(_processChildren) {
        if (_processChildren === void 0) _processChildren = true;
        this.updateRenderedElementVisibility();
        this.applyPadding();
    };
    CardElement.prototype.updateActionsEnabledState = function() {
        var allActions = this.getRootElement().getAllActions();
        for(var _i = 0, allActions_1 = allActions; _i < allActions_1.length; _i++){
            var action = allActions_1[_i];
            action.updateEnabledState();
        }
    };
    CardElement.prototype.indexOf = function(_cardElement) {
        return -1;
    };
    CardElement.prototype.isDesignMode = function() {
        var rootElement = this.getRootElement();
        return rootElement instanceof $5104722604b983cb$var$AdaptiveCard && rootElement.designMode;
    };
    CardElement.prototype.isFirstElement = function(_element) {
        return true;
    };
    CardElement.prototype.isLastElement = function(_element) {
        return true;
    };
    CardElement.prototype.isAtTheVeryLeft = function() {
        return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : true;
    };
    CardElement.prototype.isAtTheVeryRight = function() {
        return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : true;
    };
    CardElement.prototype.isAtTheVeryTop = function() {
        return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : true;
    };
    CardElement.prototype.isAtTheVeryBottom = function() {
        return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : true;
    };
    CardElement.prototype.isBleedingAtTop = function() {
        return false;
    };
    CardElement.prototype.isBleedingAtBottom = function() {
        return false;
    };
    CardElement.prototype.isLeftMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isRightMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isTopElement = function(element) {
        return this.isFirstElement(element);
    };
    CardElement.prototype.isBottomElement = function(element) {
        return this.isLastElement(element);
    };
    CardElement.prototype.isHiddenDueToOverflow = function() {
        return this._renderedElement !== undefined && this._renderedElement.style.visibility === "hidden";
    };
    CardElement.prototype.getRootElement = function() {
        return this.getRootObject();
    };
    CardElement.prototype.getParentContainer = function() {
        var currentElement = this.parent;
        while(currentElement){
            if (currentElement instanceof $5104722604b983cb$var$Container) return currentElement;
            currentElement = currentElement.parent;
        }
        return undefined;
    };
    CardElement.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    CardElement.prototype.getAllActions = function() {
        var result = [];
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    CardElement.prototype.getResourceInformation = function() {
        return [];
    };
    CardElement.prototype.getElementById = function(id) {
        return this.id === id ? this : undefined;
    };
    CardElement.prototype.getActionById = function(_id) {
        return undefined;
    };
    CardElement.prototype.getElementByIdFromAction = function(id) {
        var result = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action instanceof $5104722604b983cb$var$ShowCardAction) {
                result = action.card.getElementById(id);
                if (result) break;
            }
        }
        return result;
    };
    CardElement.prototype.getEffectivePadding = function() {
        var padding = this.getPadding();
        return padding ? padding : this.getDefaultPadding();
    };
    CardElement.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parent) return this.parent.getEffectiveHorizontalAlignment();
        return $gIXBn.HorizontalAlignment.Left;
    };
    Object.defineProperty(CardElement.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $8kDQQ.defaultHostConfig;
            }
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "index", {
        get: function() {
            if (this.parent) return this.parent.indexOf(this);
            else return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInteractive", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isStandalone", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInline", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.separatorElement) return !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode());
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorElement", {
        get: function() {
            return this._separatorElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.langProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "lang", true, /^[a-z]{2,3}$/gi);
    CardElement.isVisibleProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "isVisible", true);
    CardElement.separatorProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "separator", false);
    CardElement.heightProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_1, "height", [
        {
            value: "auto"
        },
        {
            value: "stretch"
        }
    ], "auto");
    CardElement.horizontalAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "horizontalAlignment", $gIXBn.HorizontalAlignment);
    CardElement.spacingProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "spacing", $gIXBn.Spacing, $gIXBn.Spacing.Default);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.horizontalAlignmentProperty)
    ], CardElement.prototype, "horizontalAlignment", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.spacingProperty)
    ], CardElement.prototype, "spacing", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.separatorProperty)
    ], CardElement.prototype, "separator", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.heightProperty)
    ], CardElement.prototype, "height", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.langProperty)
    ], CardElement.prototype, "lang", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElement.isVisibleProperty)
    ], CardElement.prototype, "isVisible", null);
    return CardElement;
}($dUjDB.CardObject);
module.exports.CardElement = $5104722604b983cb$var$CardElement;
var $5104722604b983cb$var$ActionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ActionProperty, _super);
    function ActionProperty(targetVersion, name, forbiddenActionTypes) {
        if (forbiddenActionTypes === void 0) forbiddenActionTypes = [];
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.forbiddenActionTypes = forbiddenActionTypes;
        return _this;
    }
    ActionProperty.prototype.parse = function(sender, source, context) {
        var parent = sender;
        return context.parseAction(parent, source[this.name], this.forbiddenActionTypes, parent.isDesignMode());
    };
    ActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return ActionProperty;
}($5Ougt.PropertyDefinition);
module.exports.ActionProperty = $5104722604b983cb$var$ActionProperty;
var $5104722604b983cb$var$BaseTextBlock = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(BaseTextBlock, _super);
    function BaseTextBlock(text) {
        var _this = _super.call(this) || this;
        _this.ariaHidden = false;
        if (text) _this.text = text;
        return _this;
    }
    BaseTextBlock.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // selectAction is declared on BaseTextBlock but is only exposed on TextRun,
        // so the property is removed from the BaseTextBlock schema.
        schema.remove(BaseTextBlock.selectActionProperty);
    };
    Object.defineProperty(BaseTextBlock.prototype, "text", {
        get: function() {
            return this.getValue(BaseTextBlock.textProperty);
        },
        set: function(value) {
            this.setText(value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    BaseTextBlock.prototype.getFontSize = function(fontType) {
        switch(this.effectiveSize){
            case $gIXBn.TextSize.Small:
                return fontType.fontSizes.small;
            case $gIXBn.TextSize.Medium:
                return fontType.fontSizes.medium;
            case $gIXBn.TextSize.Large:
                return fontType.fontSizes.large;
            case $gIXBn.TextSize.ExtraLarge:
                return fontType.fontSizes.extraLarge;
            default:
                return fontType.fontSizes.default;
        }
    };
    BaseTextBlock.prototype.getColorDefinition = function(colorSet, color) {
        switch(color){
            case $gIXBn.TextColor.Accent:
                return colorSet.accent;
            case $gIXBn.TextColor.Dark:
                return colorSet.dark;
            case $gIXBn.TextColor.Light:
                return colorSet.light;
            case $gIXBn.TextColor.Good:
                return colorSet.good;
            case $gIXBn.TextColor.Warning:
                return colorSet.warning;
            case $gIXBn.TextColor.Attention:
                return colorSet.attention;
            default:
                return colorSet.default;
        }
    };
    BaseTextBlock.prototype.setText = function(value) {
        this.setValue(BaseTextBlock.textProperty, value);
    };
    BaseTextBlock.prototype.init = function(textDefinition) {
        this.size = textDefinition.size;
        this.weight = textDefinition.weight;
        this.color = textDefinition.color;
        this.isSubtle = textDefinition.isSubtle;
    };
    BaseTextBlock.prototype.asString = function() {
        return this.text;
    };
    BaseTextBlock.prototype.applyStylesTo = function(targetElement) {
        var fontType = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
        if (fontType.fontFamily) targetElement.style.fontFamily = fontType.fontFamily;
        var fontSize;
        switch(this.effectiveSize){
            case $gIXBn.TextSize.Small:
                fontSize = fontType.fontSizes.small;
                break;
            case $gIXBn.TextSize.Medium:
                fontSize = fontType.fontSizes.medium;
                break;
            case $gIXBn.TextSize.Large:
                fontSize = fontType.fontSizes.large;
                break;
            case $gIXBn.TextSize.ExtraLarge:
                fontSize = fontType.fontSizes.extraLarge;
                break;
            default:
                fontSize = fontType.fontSizes.default;
                break;
        }
        targetElement.style.fontSize = fontSize + "px";
        var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
        var targetColor = $F6YrP.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.subtle : colorDefinition.default);
        if (targetColor) targetElement.style.color = targetColor;
        var fontWeight;
        switch(this.effectiveWeight){
            case $gIXBn.TextWeight.Lighter:
                fontWeight = fontType.fontWeights.lighter;
                break;
            case $gIXBn.TextWeight.Bolder:
                fontWeight = fontType.fontWeights.bolder;
                break;
            default:
                fontWeight = fontType.fontWeights.default;
                break;
        }
        targetElement.style.fontWeight = fontWeight.toString();
        if (this.ariaHidden) targetElement.setAttribute("aria-hidden", "true");
    };
    BaseTextBlock.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Object.defineProperty(BaseTextBlock.prototype, "effectiveColor", {
        get: function() {
            return this.color !== undefined ? this.color : this.getEffectiveTextStyleDefinition().color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveFontType", {
        get: function() {
            return this.fontType !== undefined ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveIsSubtle", {
        get: function() {
            return this.isSubtle !== undefined ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveSize", {
        get: function() {
            return this.size !== undefined ? this.size : this.getEffectiveTextStyleDefinition().size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveWeight", {
        get: function() {
            return this.weight !== undefined ? this.weight : this.getEffectiveTextStyleDefinition().weight;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    BaseTextBlock.textProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "text", true);
    BaseTextBlock.sizeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "size", $gIXBn.TextSize);
    BaseTextBlock.weightProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "weight", $gIXBn.TextWeight);
    BaseTextBlock.colorProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "color", $gIXBn.TextColor);
    BaseTextBlock.isSubtleProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "isSubtle");
    BaseTextBlock.fontTypeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "fontType", $gIXBn.FontType);
    BaseTextBlock.selectActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.sizeProperty)
    ], BaseTextBlock.prototype, "size", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.weightProperty)
    ], BaseTextBlock.prototype, "weight", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.colorProperty)
    ], BaseTextBlock.prototype, "color", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.fontTypeProperty)
    ], BaseTextBlock.prototype, "fontType", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.isSubtleProperty)
    ], BaseTextBlock.prototype, "isSubtle", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.textProperty)
    ], BaseTextBlock.prototype, "text", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BaseTextBlock.selectActionProperty)
    ], BaseTextBlock.prototype, "selectAction", void 0);
    return BaseTextBlock;
}($5104722604b983cb$var$CardElement);
module.exports.BaseTextBlock = $5104722604b983cb$var$BaseTextBlock;
var $5104722604b983cb$var$TextBlock = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TextBlock, _super);
    function TextBlock() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = false;
        _this._treatAsPlainText = true;
        _this.useMarkdown = true;
        return _this;
    }
    TextBlock.prototype.restoreOriginalContent = function() {
        var _a, _b;
        if (this.renderedElement !== undefined) {
            if (this.maxLines && this.maxLines > 0) this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
            var originalHtml = (_b = (_a = TextBlock._ttRoundtripPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._originalInnerHtml)) !== null && _b !== void 0 ? _b : this._originalInnerHtml;
            this.renderedElement.innerHTML = originalHtml;
        }
    };
    TextBlock.prototype.truncateIfSupported = function(maxHeight) {
        if (this.renderedElement !== undefined) {
            // For now, only truncate TextBlocks that contain just a single
            // paragraph -- since the maxLines calculation doesn't take into
            // account Markdown lists
            var children = this.renderedElement.children;
            var isTextOnly = !children.length;
            var truncationSupported = isTextOnly || children.length === 1 && children[0].tagName.toLowerCase() === "p" && !children[0].children.length;
            if (truncationSupported) {
                var element = isTextOnly ? this.renderedElement : children[0];
                $F6YrP.truncateText(element, maxHeight, this._computedLineHeight);
                return true;
            }
        }
        return false;
    };
    TextBlock.prototype.setText = function(value) {
        _super.prototype.setText.call(this, value);
        this._processedText = undefined;
    };
    TextBlock.prototype.internalRender = function() {
        var _this = this;
        var _a, _b;
        this._processedText = undefined;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($5104722604b983cb$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.classList.add(hostConfig.makeCssClassName("ac-textBlock"));
            element.style.overflow = "hidden";
            this.applyStylesTo(element);
            if (this.style === "heading") {
                element.setAttribute("role", "heading");
                var headingLevel = this.hostConfig.textBlock.headingLevel;
                if (headingLevel !== undefined && headingLevel > 0) element.setAttribute("aria-level", headingLevel.toString());
            }
            if (this.selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(element);
                if (this.selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            if (!this._processedText) {
                this._treatAsPlainText = true;
                var formattedText = $fuLKQ.formatText(this.lang, preProcessedText);
                if (this.useMarkdown && formattedText) {
                    if ($6BHj7.GlobalSettings.allowMarkForTextHighlighting) formattedText = formattedText.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/");
                    var markdownProcessingResult = $5104722604b983cb$var$AdaptiveCard.applyMarkdown(formattedText);
                    if (markdownProcessingResult.didProcess && markdownProcessingResult.outputHtml) {
                        this._processedText = markdownProcessingResult.outputHtml;
                        this._treatAsPlainText = false;
                        // Only process <mark> tag if markdown processing was applied because
                        // markdown processing is also responsible for sanitizing the input string
                        if ($6BHj7.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
                            var markStyle = "";
                            var effectiveStyle = this.getEffectiveStyleDefinition();
                            if (effectiveStyle.highlightBackgroundColor) markStyle += "background-color: " + effectiveStyle.highlightBackgroundColor + ";";
                            if (effectiveStyle.highlightForegroundColor) markStyle += "color: " + effectiveStyle.highlightForegroundColor + ";";
                            if (markStyle) markStyle = 'style="' + markStyle + '"';
                            this._processedText = this._processedText.replace(/===/g, "<mark " + markStyle + ">").replace(/\/==\//g, "</mark>");
                        }
                    } else {
                        this._processedText = formattedText;
                        this._treatAsPlainText = true;
                    }
                } else {
                    this._processedText = formattedText;
                    this._treatAsPlainText = true;
                }
            }
            if (!this._processedText) this._processedText = "";
            if (this._treatAsPlainText) element.innerText = this._processedText;
            else {
                var processedHtml = (_b = (_a = TextBlock._ttMarkdownPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._processedText)) !== null && _b !== void 0 ? _b : this._processedText;
                element.innerHTML = processedHtml;
            }
            if (element.firstElementChild instanceof HTMLElement) {
                var firstElementChild = element.firstElementChild;
                firstElementChild.style.marginTop = "0px";
                firstElementChild.style.width = "100%";
                if (!this.wrap) {
                    firstElementChild.style.overflow = "hidden";
                    firstElementChild.style.textOverflow = "ellipsis";
                }
            }
            if (element.lastElementChild instanceof HTMLElement) element.lastElementChild.style.marginBottom = "0px";
            var anchors = element.getElementsByTagName("a");
            var _loop_1 = function(anchor) {
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if ($5104722604b983cb$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                    }
                };
                anchor.oncontextmenu = function(e) {
                    if ($5104722604b983cb$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        return false;
                    }
                    return true;
                };
            };
            for(var _i = 0, _c = Array.from(anchors); _i < _c.length; _i++){
                var anchor = _c[_i];
                _loop_1(anchor);
            }
            if (this.wrap) {
                element.style.wordWrap = "break-word";
                if (this.maxLines && this.maxLines > 0) {
                    element.style.overflow = "hidden";
                    if ($F6YrP.isInternetExplorer() || !$6BHj7.GlobalSettings.useWebkitLineClamp) element.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
                    else {
                        // While non standard, --webkit-line-clamp works in every browser (except IE)
                        // and is a great solution to support the maxLines feature with ellipsis
                        // truncation. With --webkit-line-clamp there is need to use explicit line heights
                        element.style.removeProperty("line-height");
                        element.style.display = "-webkit-box";
                        element.style.webkitBoxOrient = "vertical";
                        element.style.webkitLineClamp = this.maxLines.toString();
                    }
                }
            } else {
                element.style.whiteSpace = "nowrap";
                element.style.textOverflow = "ellipsis";
            }
            if ($6BHj7.GlobalSettings.useAdvancedTextBlockTruncation || $6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) this._originalInnerHtml = element.innerHTML;
            return element;
        } else return undefined;
    };
    TextBlock.prototype.truncateOverflow = function(maxHeight) {
        if (maxHeight >= this._computedLineHeight) return this.truncateIfSupported(maxHeight);
        return false;
    };
    TextBlock.prototype.undoOverflowTruncation = function() {
        this.restoreOriginalContent();
        if ($6BHj7.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
            var maxHeight = this._computedLineHeight * this.maxLines;
            this.truncateIfSupported(maxHeight);
        }
    };
    TextBlock.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        switch(this.getEffectiveHorizontalAlignment()){
            case $gIXBn.HorizontalAlignment.Center:
                targetElement.style.textAlign = "center";
                break;
            case $gIXBn.HorizontalAlignment.Right:
                targetElement.style.textAlign = "end";
                break;
            default:
                targetElement.style.textAlign = "start";
                break;
        }
        var lineHeights = this.hostConfig.lineHeights;
        if (lineHeights) switch(this.effectiveSize){
            case $gIXBn.TextSize.Small:
                this._computedLineHeight = lineHeights.small;
                break;
            case $gIXBn.TextSize.Medium:
                this._computedLineHeight = lineHeights.medium;
                break;
            case $gIXBn.TextSize.Large:
                this._computedLineHeight = lineHeights.large;
                break;
            case $gIXBn.TextSize.ExtraLarge:
                this._computedLineHeight = lineHeights.extraLarge;
                break;
            default:
                this._computedLineHeight = lineHeights.default;
                break;
        }
        else // Looks like 1.33 is the magic number to compute line-height
        // from font size.
        this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
        targetElement.style.lineHeight = this._computedLineHeight + "px";
    };
    TextBlock.prototype.getJsonTypeName = function() {
        return "TextBlock";
    };
    TextBlock.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.style) return this.hostConfig.textStyles.getStyleByName(this.style);
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TextBlock.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = false;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($6BHj7.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed()) {
            // Reset the element's innerHTML in case the available room for
            // content has increased
            this.restoreOriginalContent();
            this.truncateIfSupported(this._computedLineHeight * this.maxLines);
        }
    };
    var _a, _b;
    TextBlock.wrapProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "wrap", false);
    TextBlock.maxLinesProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "maxLines");
    TextBlock.styleProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_5, "style", [
        {
            value: "default"
        },
        {
            value: "columnHeader"
        },
        {
            value: "heading"
        }
    ]);
    // Markdown processing is handled outside of Adaptive Cards. It's up to the host to ensure that markdown is safely
    // processed.
    TextBlock._ttMarkdownPolicy = typeof window === 'undefined' ? undefined : (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy("adaptivecards#markdownPassthroughPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    // When "advanced" truncation is enabled (see GlobalSettings.useAdvancedCardBottomTruncation and
    // GlobalSettings.useAdvancedTextBlockTruncation), we store the original pre-truncation content in
    // _originalInnerHtml so that we can restore/recalculate truncation later if space availability has changed (see
    // TextBlock.restoreOriginalContent())
    TextBlock._ttRoundtripPolicy = typeof window === 'undefined' ? undefined : (_b = window.trustedTypes) === null || _b === void 0 ? void 0 : _b.createPolicy("adaptivecards#restoreContentsPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextBlock.wrapProperty)
    ], TextBlock.prototype, "wrap", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextBlock.maxLinesProperty)
    ], TextBlock.prototype, "maxLines", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextBlock.styleProperty)
    ], TextBlock.prototype, "style", void 0);
    return TextBlock;
}($5104722604b983cb$var$BaseTextBlock);
module.exports.TextBlock = $5104722604b983cb$var$TextBlock;
var $5104722604b983cb$var$TextRun = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TextRun, _super);
    function TextRun() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.italic = false;
        _this.strikethrough = false;
        _this.highlight = false;
        _this.underline = false;
        return _this;
    }
    TextRun.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.add($5104722604b983cb$var$BaseTextBlock.selectActionProperty);
    };
    //#endregion
    TextRun.prototype.internalRender = function() {
        var _this = this;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($5104722604b983cb$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var formattedText = $fuLKQ.formatText(this.lang, preProcessedText);
            if (!formattedText) formattedText = "";
            var element = document.createElement("span");
            element.classList.add(hostConfig.makeCssClassName("ac-textRun"));
            this.applyStylesTo(element);
            if (this.selectAction && hostConfig.supportsInteractivity) {
                var anchor = document.createElement("a");
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                var href = this.selectAction.getHref();
                anchor.href = href ? href : "";
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(anchor);
                anchor.innerText = formattedText;
                element.appendChild(anchor);
            } else element.innerText = formattedText;
            return element;
        } else return undefined;
    };
    TextRun.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        if (this.italic) targetElement.style.fontStyle = "italic";
        if (this.strikethrough) targetElement.style.textDecoration = "line-through";
        if (this.highlight) {
            var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
            var backgroundColor = $F6YrP.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.highlightColors.subtle : colorDefinition.highlightColors.default);
            if (backgroundColor) targetElement.style.backgroundColor = backgroundColor;
        }
        if (this.underline) targetElement.style.textDecoration = "underline";
    };
    TextRun.prototype.getJsonTypeName = function() {
        return "TextRun";
    };
    Object.defineProperty(TextRun.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "isInline", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TextRun.italicProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "italic", false);
    TextRun.strikethroughProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "strikethrough", false);
    TextRun.highlightProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "highlight", false);
    TextRun.underlineProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_3, "underline", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.italicProperty)
    ], TextRun.prototype, "italic", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.strikethroughProperty)
    ], TextRun.prototype, "strikethrough", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.highlightProperty)
    ], TextRun.prototype, "highlight", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextRun.underlineProperty)
    ], TextRun.prototype, "underline", void 0);
    return TextRun;
}($5104722604b983cb$var$BaseTextBlock);
module.exports.TextRun = $5104722604b983cb$var$TextRun;
var $5104722604b983cb$var$RichTextBlock = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(RichTextBlock, _super);
    function RichTextBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inlines = [];
        return _this;
    }
    RichTextBlock.prototype.internalAddInline = function(inline, forceAdd) {
        if (forceAdd === void 0) forceAdd = false;
        if (!inline.isInline) throw new Error($24F6S.Strings.errors.elementCannotBeUsedAsInline());
        var doAdd = inline.parent === undefined || forceAdd;
        if (!doAdd && inline.parent !== this) throw new Error($24F6S.Strings.errors.inlineAlreadyParented());
        else {
            inline.setParent(this);
            this._inlines.push(inline);
        }
    };
    RichTextBlock.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._inlines = [];
        if (Array.isArray(source["inlines"])) for(var _i = 0, _a = source["inlines"]; _i < _a.length; _i++){
            var jsonInline = _a[_i];
            var inline = void 0;
            if (typeof jsonInline === "string") {
                var textRun = new $5104722604b983cb$var$TextRun();
                textRun.text = jsonInline;
                inline = textRun;
            } else // No fallback for inlines in 1.2
            inline = context.parseElement(this, jsonInline, [], false);
            if (inline) this.internalAddInline(inline, true);
        }
    };
    RichTextBlock.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this._inlines.length > 0) {
            var jsonInlines = [];
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                jsonInlines.push(inline.toJSON(context));
            }
            context.serializeValue(target, "inlines", jsonInlines);
        }
    };
    RichTextBlock.prototype.internalRender = function() {
        if (this._inlines.length > 0) {
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.className = this.hostConfig.makeCssClassName("ac-richTextBlock");
            switch(this.getEffectiveHorizontalAlignment()){
                case $gIXBn.HorizontalAlignment.Center:
                    element.style.textAlign = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.style.textAlign = "end";
                    break;
                default:
                    element.style.textAlign = "start";
                    break;
            }
            var renderedInlines = 0;
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                var renderedInline = inline.render();
                if (renderedInline) {
                    element.appendChild(renderedInline);
                    renderedInlines++;
                }
            }
            if (renderedInlines > 0) return element;
        }
        return undefined;
    };
    RichTextBlock.prototype.asString = function() {
        var result = "";
        for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
            var inline = _a[_i];
            result += inline.asString();
        }
        return result;
    };
    RichTextBlock.prototype.getJsonTypeName = function() {
        return "RichTextBlock";
    };
    RichTextBlock.prototype.getInlineCount = function() {
        return this._inlines.length;
    };
    RichTextBlock.prototype.getInlineAt = function(index) {
        if (index >= 0 && index < this._inlines.length) return this._inlines[index];
        else throw new Error($24F6S.Strings.errors.indexOutOfRange(index));
    };
    RichTextBlock.prototype.addInline = function(inline) {
        if (typeof inline === "string") this.internalAddInline(new $5104722604b983cb$var$TextRun(inline));
        else this.internalAddInline(inline);
    };
    RichTextBlock.prototype.removeInline = function(inline) {
        var index = this._inlines.indexOf(inline);
        if (index >= 0) {
            this._inlines[index].setParent(undefined);
            this._inlines.splice(index, 1);
            return true;
        }
        return false;
    };
    return RichTextBlock;
}($5104722604b983cb$var$CardElement);
module.exports.RichTextBlock = $5104722604b983cb$var$RichTextBlock;
var $5104722604b983cb$var$Fact = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Fact, _super);
    function Fact(name, value) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    //#endregion
    Fact.prototype.getSchemaKey = function() {
        return "Fact";
    };
    //#region Schema
    Fact.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    Fact.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Fact.titleProperty)
    ], Fact.prototype, "name", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Fact.valueProperty)
    ], Fact.prototype, "value", void 0);
    return Fact;
}($5Ougt.SerializableObject);
module.exports.Fact = $5104722604b983cb$var$Fact;
var $5104722604b983cb$var$FactSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(FactSet, _super);
    function FactSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FactSet.prototype, "useDefaultSizing", {
        //#endregion
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FactSet.prototype.internalRender = function() {
        var element = undefined;
        var hostConfig = this.hostConfig;
        if (this.facts.length > 0) {
            element = document.createElement("table");
            element.style.borderWidth = "0px";
            element.style.borderSpacing = "0px";
            element.style.borderStyle = "none";
            element.style.borderCollapse = "collapse";
            element.style.display = "block";
            element.style.overflow = "hidden";
            element.classList.add(hostConfig.makeCssClassName("ac-factset"));
            element.setAttribute("role", "presentation");
            for(var i = 0; i < this.facts.length; i++){
                var trElement = document.createElement("tr");
                if (i > 0) trElement.style.marginTop = hostConfig.factSet.spacing + "px";
                // Title column
                var tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-title"));
                if (hostConfig.factSet.title.maxWidth) tdElement.style.maxWidth = hostConfig.factSet.title.maxWidth + "px";
                tdElement.style.verticalAlign = "top";
                var textBlock = new $5104722604b983cb$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name;
                textBlock.size = hostConfig.factSet.title.size;
                textBlock.color = hostConfig.factSet.title.color;
                textBlock.isSubtle = hostConfig.factSet.title.isSubtle;
                textBlock.weight = hostConfig.factSet.title.weight;
                textBlock.wrap = hostConfig.factSet.title.wrap;
                textBlock.spacing = $gIXBn.Spacing.None;
                $F6YrP.appendChild(tdElement, textBlock.render());
                $F6YrP.appendChild(trElement, tdElement);
                // Spacer column
                tdElement = document.createElement("td");
                tdElement.style.width = "10px";
                $F6YrP.appendChild(trElement, tdElement);
                // Value column
                tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.style.verticalAlign = "top";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-value"));
                textBlock = new $5104722604b983cb$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = this.facts[i].value;
                textBlock.size = hostConfig.factSet.value.size;
                textBlock.color = hostConfig.factSet.value.color;
                textBlock.isSubtle = hostConfig.factSet.value.isSubtle;
                textBlock.weight = hostConfig.factSet.value.weight;
                textBlock.wrap = hostConfig.factSet.value.wrap;
                textBlock.spacing = $gIXBn.Spacing.None;
                $F6YrP.appendChild(tdElement, textBlock.render());
                $F6YrP.appendChild(trElement, tdElement);
                $F6YrP.appendChild(element, trElement);
            }
        }
        return element;
    };
    FactSet.prototype.getJsonTypeName = function() {
        return "FactSet";
    };
    //#region Schema
    FactSet.factsProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "facts", $5104722604b983cb$var$Fact);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(FactSet.factsProperty)
    ], FactSet.prototype, "facts", void 0);
    return FactSet;
}($5104722604b983cb$var$CardElement);
module.exports.FactSet = $5104722604b983cb$var$FactSet;
var $5104722604b983cb$var$ImageDimensionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ImageDimensionProperty, _super);
    function ImageDimensionProperty(targetVersion, name, internalName, fallbackProperty) {
        var _this = _super.call(this, targetVersion, name) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.internalName = internalName;
        _this.fallbackProperty = fallbackProperty;
        return _this;
    }
    ImageDimensionProperty.prototype.getInternalName = function() {
        return this.internalName;
    };
    ImageDimensionProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        var isValid = false;
        if (typeof sourceValue === "string") {
            try {
                var size = $6BHj7.SizeAndUnit.parse(sourceValue, true);
                if (size.unit === $gIXBn.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Swallow the exception
            }
            // If the source value isn't valid per this property definition,
            // check its validity per the fallback property, if specified
            if (!isValid && this.fallbackProperty) isValid = this.fallbackProperty.isValidValue(sourceValue, context);
        }
        if (!isValid) context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return result;
    };
    ImageDimensionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return ImageDimensionProperty;
}($5Ougt.PropertyDefinition);
var $5104722604b983cb$var$Image = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Image, _super);
    function Image() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = $gIXBn.Size.Auto;
        _this.style = $gIXBn.ImageStyle.Default;
        return _this;
    }
    Image.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($5104722604b983cb$var$CardElement.heightProperty);
    };
    //#endregion
    Image.prototype.applySize = function(element) {
        if (this.pixelWidth || this.pixelHeight) {
            if (this.pixelWidth) element.style.width = this.pixelWidth + "px";
            if (this.pixelHeight) element.style.height = this.pixelHeight + "px";
        } else if (this.maxHeight) {
            // If the image is constrained in height, we set its height property and
            // auto and stretch are ignored (default to medium). THis is necessary for
            // ImageSet which uses a maximum image height as opposed to the cards width
            // as a constraining dimension
            switch(this.size){
                case $gIXBn.Size.Small:
                    element.style.height = this.hostConfig.imageSizes.small + "px";
                    break;
                case $gIXBn.Size.Large:
                    element.style.height = this.hostConfig.imageSizes.large + "px";
                    break;
                default:
                    element.style.height = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = this.maxHeight + "px";
        } else {
            switch(this.size){
                case $gIXBn.Size.Stretch:
                    element.style.width = "100%";
                    break;
                case $gIXBn.Size.Auto:
                    element.style.maxWidth = "100%";
                    break;
                case $gIXBn.Size.Small:
                    element.style.width = this.hostConfig.imageSizes.small + "px";
                    break;
                case $gIXBn.Size.Large:
                    element.style.width = this.hostConfig.imageSizes.large + "px";
                    break;
                case $gIXBn.Size.Medium:
                    element.style.width = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = "100%";
        }
    };
    Object.defineProperty(Image.prototype, "useDefaultSizing", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.internalRender = function() {
        var _this = this;
        var element = undefined;
        if (this.url) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.alignItems = "flex-start";
            // Cache hostConfig to avoid walking the parent hierarchy multiple times
            var hostConfig = this.hostConfig;
            switch(this.getEffectiveHorizontalAlignment()){
                case $gIXBn.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var imageElement = document.createElement("img");
            this.renderedImageElement = imageElement;
            imageElement.onload = function(_e) {
                $5104722604b983cb$var$raiseImageLoadedEvent(_this);
            };
            imageElement.onerror = function(_e) {
                if (_this.renderedElement) {
                    var card = _this.getRootElement();
                    $5104722604b983cb$var$clearElement(_this.renderedElement);
                    if (card && card.designMode) {
                        var errorElement = document.createElement("div");
                        errorElement.style.display = "flex";
                        errorElement.style.alignItems = "center";
                        errorElement.style.justifyContent = "center";
                        errorElement.style.backgroundColor = "#EEEEEE";
                        errorElement.style.color = "black";
                        errorElement.innerText = ":-(";
                        errorElement.style.padding = "10px";
                        _this.applySize(errorElement);
                        _this.renderedElement.appendChild(errorElement);
                    }
                }
                $5104722604b983cb$var$raiseImageLoadedEvent(_this);
            };
            imageElement.style.minWidth = "0";
            imageElement.classList.add(hostConfig.makeCssClassName("ac-image"));
            if (this.selectAction && hostConfig.supportsInteractivity) {
                imageElement.onkeypress = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                imageElement.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(imageElement);
                if (this.selectAction.isEffectivelyEnabled()) imageElement.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            this.applySize(imageElement);
            if (this.style === $gIXBn.ImageStyle.Person) {
                imageElement.style.borderRadius = "50%";
                imageElement.style.backgroundPosition = "50% 50%";
                imageElement.style.backgroundRepeat = "no-repeat";
            }
            var backgroundColor = $F6YrP.stringToCssColor(this.backgroundColor);
            if (backgroundColor) imageElement.style.backgroundColor = backgroundColor;
            this.setImageSource(imageElement);
            var altTextProperty = this.preProcessPropertyValue(Image.altTextProperty);
            if (altTextProperty) imageElement.alt = altTextProperty;
            element.appendChild(imageElement);
        }
        return element;
    };
    Image.prototype.getJsonTypeName = function() {
        return "Image";
    };
    Image.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Image.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.selectAction) result = this.selectAction.getActionById(id);
        return result;
    };
    Image.prototype.getResourceInformation = function() {
        return this.url ? [
            {
                url: this.url,
                mimeType: "image"
            }
        ] : [];
    };
    Image.prototype.setImageSource = function(imageElement) {
        var imageForceLoader = new $5104722604b983cb$var$ImageForceLoader(this.forceLoad, this.url);
        imageForceLoader.configureImage(this);
        imageElement.src = this.preProcessPropertyValue(Image.urlProperty);
        imageForceLoader.resetImage(this);
    };
    Image.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "url");
    Image.altTextProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "altText");
    Image.backgroundColorProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "backgroundColor");
    Image.styleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "style", $gIXBn.ImageStyle, $gIXBn.ImageStyle.Default);
    Image.sizeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "size", $gIXBn.Size, $gIXBn.Size.Auto);
    Image.pixelWidthProperty = new $5104722604b983cb$var$ImageDimensionProperty($5Ougt.Versions.v1_1, "width", "pixelWidth");
    Image.pixelHeightProperty = new $5104722604b983cb$var$ImageDimensionProperty($5Ougt.Versions.v1_1, "height", "pixelHeight", $5104722604b983cb$var$CardElement.heightProperty);
    Image.selectActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    Image.shouldForceLoadProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_6, "forceLoad", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.urlProperty)
    ], Image.prototype, "url", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.altTextProperty)
    ], Image.prototype, "altText", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.backgroundColorProperty)
    ], Image.prototype, "backgroundColor", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.sizeProperty)
    ], Image.prototype, "size", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.styleProperty)
    ], Image.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.pixelWidthProperty)
    ], Image.prototype, "pixelWidth", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.pixelHeightProperty)
    ], Image.prototype, "pixelHeight", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.selectActionProperty)
    ], Image.prototype, "selectAction", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Image.shouldForceLoadProperty)
    ], Image.prototype, "forceLoad", void 0);
    return Image;
}($5104722604b983cb$var$CardElement);
module.exports.Image = $5104722604b983cb$var$Image;
// configures Image element to fetch a new image data from url source instead of relying on cache
// currently rudimentary refreshing scheme is used
// by attaching unique query string to url, we bypass the cache usage
var $5104722604b983cb$var$ImageForceLoader = /** @class */ function() {
    function ImageForceLoader(doForceLoad, url) {
        this.doForceLoad = doForceLoad;
        this.url = url;
        if (url && url.length && doForceLoad) {
            // we can do better by appending unique key such as uuid instead of epoch
            // however the current usage is for front-end ui and networking,  
            // since ui is running in single main thread, this is sufficient mechanism
            // without needing to depend on external library for our small use cases.
            this.uniqueHash = '?' + Date.now();
            this.urlWithForceLoadOption = url + this.uniqueHash;
        }
    }
    ImageForceLoader.prototype.configureImage = function(image) {
        if (this.urlWithForceLoadOption && this.urlWithForceLoadOption.length) image.url = this.urlWithForceLoadOption;
    };
    ImageForceLoader.prototype.resetImage = function(image) {
        image.url = this.url;
    };
    return ImageForceLoader;
}();
var $5104722604b983cb$var$CardElementContainer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CardElementContainer, _super);
    function CardElementContainer() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowVerticalOverflow = false;
        return _this;
    }
    CardElementContainer.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        if (!this.isSelectable) schema.remove(CardElementContainer.selectActionProperty);
    };
    //#endregion
    CardElementContainer.prototype.isElementAllowed = function(element) {
        return this.hostConfig.supportsInteractivity || !element.isInteractive;
    };
    CardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $6BHj7.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        this.renderedElement.style.marginRight = "0";
        this.renderedElement.style.marginLeft = "0";
    };
    Object.defineProperty(CardElementContainer.prototype, "isSelectable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CardElementContainer.prototype.forbiddenChildElements = function() {
        return [];
    };
    CardElementContainer.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).releaseDOMResources();
    };
    CardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        for(var i = 0; i < this.getItemCount(); i++){
            var item = this.getItemAt(i);
            if (!this.hostConfig.supportsInteractivity && item.isInteractive) context.addFailure(this, $gIXBn.ValidationEvent.InteractivityNotAllowed, $24F6S.Strings.errors.interactivityNotAllowed());
            if (!this.isElementAllowed(item)) context.addFailure(this, $gIXBn.ValidationEvent.InteractivityNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
        if (this._selectAction) this._selectAction.internalValidateProperties(context);
    };
    CardElementContainer.prototype.render = function() {
        var _this = this;
        var element = _super.prototype.render.call(this);
        if (element) {
            var hostConfig = this.hostConfig;
            if (this.allowVerticalOverflow) {
                element.style.overflowX = "hidden";
                element.style.overflowY = "auto";
            }
            if (element && this.isSelectable && this._selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                element.onkeypress = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // Enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                this._selectAction.setupElementForAccessibility(element);
                if (this._selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
        }
        return element;
    };
    CardElementContainer.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if (processChildren) for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).updateLayout();
    };
    CardElementContainer.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllInputs(processActions));
        return result;
    };
    CardElementContainer.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllActions());
        if (this._selectAction) result.push(this._selectAction);
        return result;
    };
    CardElementContainer.prototype.getResourceInformation = function() {
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getResourceInformation());
        return result;
    };
    CardElementContainer.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) for(var i = 0; i < this.getItemCount(); i++){
            result = this.getItemAt(i).getElementById(id);
            if (result) break;
        }
        return result;
    };
    /**
     * @inheritdoc
     */ CardElementContainer.prototype.findDOMNodeOwner = function(node) {
        var _a;
        var target = undefined;
        for(var i = 0; i < this.getItemCount(); i++){
            // recur through child elements
            target = this.getItemAt(i).findDOMNodeOwner(node);
            if (target) return target;
        }
        // If not found in children, check the actions
        for(var i = 0; i < this.getActionCount(); i++){
            target = (_a = this.getActionAt(i)) === null || _a === void 0 ? void 0 : _a.findDOMNodeOwner(node);
            if (target) return target;
        }
        // if not found in children or actions, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    CardElementContainer.selectActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CardElementContainer.selectActionProperty)
    ], CardElementContainer.prototype, "_selectAction", void 0);
    return CardElementContainer;
}($5104722604b983cb$var$CardElement);
module.exports.CardElementContainer = $5104722604b983cb$var$CardElementContainer;
var $5104722604b983cb$var$ImageSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ImageSet, _super);
    function ImageSet() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._images = [];
        _this.imageSize = $gIXBn.ImageSize.Medium;
        _this.presentationStyle = $gIXBn.ImageSetPresentationStyle.Default;
        _this.pixelOffset = 0;
        return _this;
    }
    //#endregion
    ImageSet.prototype.internalRender = function() {
        var element = undefined;
        if (this._images.length > 0) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.flexWrap = "wrap";
            for(var _i = 0, _a = this._images; _i < _a.length; _i++){
                var image = _a[_i];
                switch(this.imageSize){
                    case $gIXBn.ImageSize.Small:
                        image.size = $gIXBn.Size.Small;
                        break;
                    case $gIXBn.ImageSize.Large:
                        image.size = $gIXBn.Size.Large;
                        break;
                    default:
                        image.size = $gIXBn.Size.Medium;
                        break;
                }
                image.maxHeight = this.hostConfig.imageSet.maxImageHeight;
                var renderedImage = image.render();
                if (renderedImage) {
                    renderedImage.style.display = "inline-flex";
                    renderedImage.style.margin = "0px";
                    if (this.presentationStyle == $gIXBn.ImageSetPresentationStyle.Default) renderedImage.style.marginRight = "10px";
                    $F6YrP.appendChild(element, renderedImage);
                }
            }
            if (this.presentationStyle == $gIXBn.ImageSetPresentationStyle.Stacked) this.applyStackedPresentationStyle();
        }
        return element;
    };
    ImageSet.prototype.applyStackedPresentationStyle = function() {
        if (this._images[0].renderedImageElement) {
            var dimension = $5104722604b983cb$var$StackedImageConfigurator.parseNumericPixelDimension(this._images[0].renderedImageElement.style.height);
            var bgColor = this.getEffectiveBackgroundColor();
            if (dimension) {
                var stackedImageConfigurator = new $5104722604b983cb$var$StackedImageConfigurator(this.pixelOffset, dimension, bgColor);
                stackedImageConfigurator.configureImagesArrayAsStackedLayout(this._images);
            }
        }
    };
    ImageSet.prototype.getEffectiveBackgroundColor = function() {
        var parentContainer = this.getParentContainer();
        var style = parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.getEffectiveStyle();
        var styleDefinition = this.hostConfig.containerStyles.getStyleByName(style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
        return $F6YrP.stringToCssColor(styleDefinition.backgroundColor);
    };
    ImageSet.prototype.getItemCount = function() {
        return this._images.length;
    };
    ImageSet.prototype.getItemAt = function(index) {
        return this._images[index];
    };
    ImageSet.prototype.getFirstVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[0] : undefined;
    };
    ImageSet.prototype.getLastVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : undefined;
    };
    ImageSet.prototype.removeItem = function(item) {
        if (item instanceof $5104722604b983cb$var$Image) {
            var itemIndex = this._images.indexOf(item);
            if (itemIndex >= 0) {
                this._images.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ImageSet.prototype.getJsonTypeName = function() {
        return "ImageSet";
    };
    ImageSet.prototype.addImage = function(image) {
        if (!image.parent) {
            this._images.push(image);
            image.setParent(this);
        } else throw new Error("This image already belongs to another ImageSet");
    };
    ImageSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $5104722604b983cb$var$Image ? this._images.indexOf(cardElement) : -1;
    };
    ImageSet.imagesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "images", $5104722604b983cb$var$Image, function(sender, item) {
        item.setParent(sender);
    });
    ImageSet.imageSizeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "imageSize", $gIXBn.ImageSize, $gIXBn.ImageSize.Medium);
    ImageSet.imagePresentationStyle = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "style", $gIXBn.ImageSetPresentationStyle, $gIXBn.ImageSetPresentationStyle.Default);
    ImageSet.pixelOffset = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "offset", 0, undefined);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.imagesProperty)
    ], ImageSet.prototype, "_images", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.imageSizeProperty)
    ], ImageSet.prototype, "imageSize", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.imagePresentationStyle)
    ], ImageSet.prototype, "presentationStyle", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ImageSet.pixelOffset)
    ], ImageSet.prototype, "pixelOffset", void 0);
    return ImageSet;
}($5104722604b983cb$var$CardElementContainer);
module.exports.ImageSet = $5104722604b983cb$var$ImageSet;
var $5104722604b983cb$var$StackedImageConfigurator = /** @class */ function() {
    function StackedImageConfigurator(offset, dimension, style) {
        this.sign45 = 0.7071;
        this.maxImageCounts = 2;
        this.offset = 0;
        this.normalizationConstant = 0;
        this.border = 5;
        this.dimension = 0;
        this.dimension = dimension;
        this.normalizationConstant = (dimension * this.sign45 - 0.5 * dimension) * 2;
        // offset determines how far images are placed from each other
        // at zero, images are separated only by the border
        // there is no restriction on how far they are apart in positive values, their actual
        // positioning is limited by maximum size imposed by Image renderer
        // a negative value can decrease upto the diameter of the image since a value less than the diameter
        // put the images past each other, and the use of such value is not reasonable request
        // users should change image positions in such case.
        this.offset = this.sign45 * (Math.max(offset, -dimension) - this.normalizationConstant);
        this.style = style ? style : "";
    }
    StackedImageConfigurator.prototype.moveImageRight = function(element) {
        element.style.marginLeft = this.offset + "px";
    };
    StackedImageConfigurator.prototype.moveImageUp = function(element) {
        element.style.marginBottom = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.moveImageDown = function(element) {
        element.style.marginTop = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.makeImageRound = function(element) {
        element.style.borderRadius = "50%";
        element.style.backgroundPosition = "50% 50%";
        element.style.backgroundRepeat = "no-repeat";
    };
    StackedImageConfigurator.prototype.applyBorder = function(element) {
        element.style.height = this.dimension + this.border * 2 + "px";
        element.style.border = this.border + "px" + " solid " + this.style;
    };
    StackedImageConfigurator.prototype.configureImageForBottomLeft = function(element) {
        this.moveImageDown(element);
        this.makeImageRound(element);
        this.applyBorder(element);
        element.style.zIndex = "2";
    };
    StackedImageConfigurator.prototype.configureImageForTopRight = function(element) {
        this.moveImageUp(element);
        this.moveImageRight(element);
        this.makeImageRound(element);
        element.style.zIndex = "1";
    };
    // stacked layout is applied when there are two images in ImageSet,
    // first image in the ImageSet is put bottom left of ImageSet,
    // second image is placed top right diagonally to the first image at 45 angle
    // first image is placed over the second image should the overlap to occur.
    StackedImageConfigurator.prototype.configureImagesArrayAsStackedLayout = function(elements) {
        if (elements.length == 1) {
            if (elements[0].renderedImageElement) this.makeImageRound(elements[0].renderedImageElement);
        } else if (elements.length <= this.maxImageCounts) {
            if (elements[0].renderedImageElement && elements[1].renderedImageElement) {
                this.configureImageForBottomLeft(elements[0].renderedImageElement);
                this.configureImageForTopRight(elements[1].renderedImageElement);
            }
        }
    };
    StackedImageConfigurator.parseNumericPixelDimension = function(dimension) {
        if ((dimension === null || dimension === void 0 ? void 0 : dimension.substring(dimension.length - 2)) == 'px') return parseInt(dimension.substring(0, dimension.length - 2));
        return undefined;
    };
    return StackedImageConfigurator;
}();
var $5104722604b983cb$var$ContentSource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContentSource, _super);
    //#endregion
    function ContentSource(url, mimeType) {
        var _this = _super.call(this) || this;
        _this.url = url;
        _this.mimeType = mimeType;
        return _this;
    }
    ContentSource.prototype.isValid = function() {
        return this.mimeType && this.url ? true : false;
    };
    //#region Schema
    ContentSource.mimeTypeProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "mimeType");
    ContentSource.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "url");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContentSource.mimeTypeProperty)
    ], ContentSource.prototype, "mimeType", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContentSource.urlProperty)
    ], ContentSource.prototype, "url", void 0);
    return ContentSource;
}($5Ougt.SerializableObject);
module.exports.ContentSource = $5104722604b983cb$var$ContentSource;
var $5104722604b983cb$var$CaptionSource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CaptionSource, _super);
    //#endregion
    function CaptionSource(url, mimeType, label) {
        var _this = _super.call(this, url, mimeType) || this;
        _this.label = label;
        return _this;
    }
    CaptionSource.prototype.getSchemaKey = function() {
        return "CaptionSource";
    };
    CaptionSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("track");
            result.src = this.url;
            result.kind = "captions";
            result.label = this.label;
        }
        return result;
    };
    //#region Schema
    CaptionSource.labelProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "label");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(CaptionSource.labelProperty)
    ], CaptionSource.prototype, "label", void 0);
    return CaptionSource;
}($5104722604b983cb$var$ContentSource);
module.exports.CaptionSource = $5104722604b983cb$var$CaptionSource;
var $5104722604b983cb$var$MediaSource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(MediaSource, _super);
    function MediaSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaSource.prototype.getSchemaKey = function() {
        return "MediaSource";
    };
    MediaSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("source");
            result.src = this.url;
            result.type = this.mimeType;
        }
        return result;
    };
    return MediaSource;
}($5104722604b983cb$var$ContentSource);
module.exports.MediaSource = $5104722604b983cb$var$MediaSource;
var $5104722604b983cb$var$MediaPlayer = /** @class */ function() {
    function MediaPlayer() {}
    MediaPlayer.prototype.play = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(MediaPlayer.prototype, "posterUrl", {
        get: function() {
            return this._posterUrl;
        },
        set: function(value) {
            this._posterUrl = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    return MediaPlayer;
}();
module.exports.MediaPlayer = $5104722604b983cb$var$MediaPlayer;
var $5104722604b983cb$var$HTML5MediaPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(HTML5MediaPlayer, _super);
    function HTML5MediaPlayer(owner) {
        var _this = _super.call(this) || this;
        _this.owner = owner;
        _this._selectedSources = [];
        _this._captionSources = [];
        _this.processSources();
        return _this;
    }
    HTML5MediaPlayer.prototype.processSources = function() {
        var _a;
        this._selectedSources = [];
        this._captionSources = [];
        this._selectedMediaType = undefined;
        for(var _i = 0, _b = this.owner.sources; _i < _b.length; _i++){
            var source = _b[_i];
            var mimeComponents = source.mimeType ? source.mimeType.split("/") : [];
            if (mimeComponents.length === 2) {
                if (!this._selectedMediaType) {
                    var index = HTML5MediaPlayer.supportedMediaTypes.indexOf(mimeComponents[0]);
                    if (index >= 0) this._selectedMediaType = HTML5MediaPlayer.supportedMediaTypes[index];
                }
                if (mimeComponents[0] === this._selectedMediaType) this._selectedSources.push(source);
            }
        }
        (_a = this._captionSources).push.apply(_a, this.owner.captionSources);
    };
    HTML5MediaPlayer.prototype.canPlay = function() {
        return this._selectedSources.length > 0;
    };
    HTML5MediaPlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            return $5104722604b983cb$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    HTML5MediaPlayer.prototype.render = function() {
        if (this._selectedMediaType === "video") this._mediaElement = document.createElement("video");
        else this._mediaElement = document.createElement("audio");
        this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : $24F6S.Strings.defaults.mediaPlayerAriaLabel());
        this._mediaElement.setAttribute("webkit-playsinline", "");
        this._mediaElement.setAttribute("playsinline", "");
        // We enable crossorigin for cases where the caption file has a different domain than
        // the video file. If the caption file lives in a different domain than the video file
        // and crossorigin is not set, then the caption file will fail to load.
        this._mediaElement.setAttribute("crossorigin", "");
        this._mediaElement.autoplay = true;
        this._mediaElement.controls = true;
        if ($F6YrP.isMobileOS()) this._mediaElement.muted = true;
        this._mediaElement.preload = "none";
        this._mediaElement.style.width = "100%";
        for(var _i = 0, _a = this.owner.sources; _i < _a.length; _i++){
            var source = _a[_i];
            var renderedSource = source.render();
            $F6YrP.appendChild(this._mediaElement, renderedSource);
        }
        for(var _b = 0, _c = this.owner.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.mimeType == "vtt") {
                var renderedCaptionSource = captionSource.render();
                $F6YrP.appendChild(this._mediaElement, renderedCaptionSource);
            }
        }
        return this._mediaElement;
    };
    HTML5MediaPlayer.prototype.play = function() {
        if (this._mediaElement) this._mediaElement.play();
    };
    Object.defineProperty(HTML5MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return this._selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    HTML5MediaPlayer.supportedMediaTypes = [
        "audio",
        "video"
    ];
    return HTML5MediaPlayer;
}($5104722604b983cb$var$MediaPlayer);
module.exports.HTML5MediaPlayer = $5104722604b983cb$var$HTML5MediaPlayer;
var $5104722604b983cb$var$CustomMediaPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(CustomMediaPlayer, _super);
    function CustomMediaPlayer(matches) {
        return _super.call(this) || this;
    }
    return CustomMediaPlayer;
}($5104722604b983cb$var$MediaPlayer);
module.exports.CustomMediaPlayer = $5104722604b983cb$var$CustomMediaPlayer;
var $5104722604b983cb$var$IFrameMediaMediaPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(IFrameMediaMediaPlayer, _super);
    function IFrameMediaMediaPlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 2) _this._videoId = matches[1];
        return _this;
    }
    IFrameMediaMediaPlayer.prototype.canPlay = function() {
        return this._videoId !== undefined;
    };
    IFrameMediaMediaPlayer.prototype.render = function() {
        var container = document.createElement("div");
        container.style.position = "relative";
        container.style.width = "100%";
        container.style.height = "0";
        container.style.paddingBottom = "56.25%";
        var iFrame = document.createElement("iframe");
        iFrame.style.position = "absolute";
        iFrame.style.top = "0";
        iFrame.style.left = "0";
        iFrame.style.width = "100%";
        iFrame.style.height = "100%";
        iFrame.src = this.getEmbedVideoUrl();
        iFrame.frameBorder = "0";
        if (this.iFrameTitle) iFrame.title = this.iFrameTitle;
        iFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iFrame.allowFullscreen = true;
        container.appendChild(iFrame);
        return container;
    };
    Object.defineProperty(IFrameMediaMediaPlayer.prototype, "videoId", {
        get: function() {
            return this._videoId;
        },
        enumerable: false,
        configurable: true
    });
    return IFrameMediaMediaPlayer;
}($5104722604b983cb$var$CustomMediaPlayer);
module.exports.IFrameMediaMediaPlayer = $5104722604b983cb$var$IFrameMediaMediaPlayer;
var $5104722604b983cb$var$VimeoPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(VimeoPlayer, _super);
    function VimeoPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VimeoPlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            var oEmbedUrl, response, json;
            return $5104722604b983cb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        oEmbedUrl = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl());
                        return [
                            4 /*yield*/ ,
                            fetch(oEmbedUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VimeoPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
    };
    return VimeoPlayer;
}($5104722604b983cb$var$IFrameMediaMediaPlayer);
module.exports.VimeoPlayer = $5104722604b983cb$var$VimeoPlayer;
var $5104722604b983cb$var$DailymotionPlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(DailymotionPlayer, _super);
    function DailymotionPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailymotionPlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            var apiUrl, response, json;
            return $5104722604b983cb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        apiUrl = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url");
                        return [
                            4 /*yield*/ ,
                            fetch(apiUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_720_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DailymotionPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
    };
    return DailymotionPlayer;
}($5104722604b983cb$var$IFrameMediaMediaPlayer);
module.exports.DailymotionPlayer = $5104722604b983cb$var$DailymotionPlayer;
var $5104722604b983cb$var$YouTubePlayer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(YouTubePlayer, _super);
    function YouTubePlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches, iFrameTitle) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 3 && matches[2] !== undefined) _this._startTimeIndex = parseInt(matches[2]);
        return _this;
    }
    YouTubePlayer.prototype.fetchVideoDetails = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            return $5104722604b983cb$var$__generator(this, function(_a) {
                this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : undefined;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    YouTubePlayer.prototype.getEmbedVideoUrl = function() {
        var url = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
        if (this._startTimeIndex !== undefined) url += "&start=".concat(this._startTimeIndex);
        return url;
    };
    return YouTubePlayer;
}($5104722604b983cb$var$IFrameMediaMediaPlayer);
module.exports.YouTubePlayer = $5104722604b983cb$var$YouTubePlayer;
var $5104722604b983cb$var$Media = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Media, _super);
    function Media() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sources = [];
        _this.captionSources = [];
        return _this;
    }
    Media.prototype.createMediaPlayer = function() {
        for(var _i = 0, _a = Media.customMediaPlayers; _i < _a.length; _i++){
            var provider = _a[_i];
            for(var _b = 0, _c = this.sources; _b < _c.length; _b++){
                var source = _c[_b];
                if (source.url) for(var _d = 0, _f = provider.urlPatterns; _d < _f.length; _d++){
                    var pattern = _f[_d];
                    var matches = pattern.exec(source.url);
                    if (matches !== null) return provider.createMediaPlayer(matches);
                }
            }
        }
        return new $5104722604b983cb$var$HTML5MediaPlayer(this);
    };
    Media.prototype.handlePlayButtonInvoke = function(event) {
        if (this.hostConfig.media.allowInlinePlayback) {
            event.preventDefault();
            event.cancelBubble = true;
            if (this.renderedElement) {
                var mediaPlayerElement = this._mediaPlayer.render();
                $5104722604b983cb$var$clearElement(this.renderedElement);
                this.renderedElement.appendChild(mediaPlayerElement);
                this._mediaPlayer.play();
                mediaPlayerElement.focus();
            }
        } else if (Media.onPlay) {
            event.preventDefault();
            event.cancelBubble = true;
            Media.onPlay(this);
        }
    };
    Media.prototype.displayPoster = function() {
        return $5104722604b983cb$var$__awaiter(this, void 0, void 0, function() {
            var playButtonArrowWidth, playButtonArrowHeight, posterRootElement_1, posterUrl, posterImageElement_1, playButtonOuterElement, playButtonInnerElement, playButtonContainer;
            var _this = this;
            return $5104722604b983cb$var$__generator(this, function(_a) {
                if (this.renderedElement) {
                    playButtonArrowWidth = 12;
                    playButtonArrowHeight = 15;
                    posterRootElement_1 = document.createElement("div");
                    posterRootElement_1.className = this.hostConfig.makeCssClassName("ac-media-poster");
                    posterRootElement_1.setAttribute("role", "contentinfo");
                    posterRootElement_1.setAttribute("aria-label", this.altText ? this.altText : $24F6S.Strings.defaults.mediaPlayerAriaLabel());
                    posterRootElement_1.style.position = "relative";
                    posterRootElement_1.style.display = "flex";
                    posterUrl = this.poster ? this.poster : this._mediaPlayer.posterUrl;
                    if (!posterUrl) posterUrl = this.hostConfig.media.defaultPoster;
                    if (posterUrl) {
                        posterImageElement_1 = document.createElement("img");
                        posterImageElement_1.style.width = "100%";
                        posterImageElement_1.style.height = "100%";
                        posterImageElement_1.setAttribute("role", "presentation");
                        posterImageElement_1.onerror = function(_e) {
                            if (posterImageElement_1.parentNode) posterImageElement_1.parentNode.removeChild(posterImageElement_1);
                            posterRootElement_1.classList.add("empty");
                            posterRootElement_1.style.minHeight = "150px";
                        };
                        posterImageElement_1.src = posterUrl;
                        posterRootElement_1.appendChild(posterImageElement_1);
                    } else {
                        posterRootElement_1.classList.add("empty");
                        posterRootElement_1.style.minHeight = "150px";
                    }
                    if (this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay()) {
                        playButtonOuterElement = document.createElement("div");
                        playButtonOuterElement.tabIndex = 0;
                        playButtonOuterElement.setAttribute("role", "button");
                        playButtonOuterElement.setAttribute("aria-label", $24F6S.Strings.defaults.mediaPlayerPlayMedia());
                        playButtonOuterElement.className = this.hostConfig.makeCssClassName("ac-media-playButton");
                        playButtonOuterElement.style.display = "flex";
                        playButtonOuterElement.style.alignItems = "center";
                        playButtonOuterElement.style.justifyContent = "center";
                        playButtonOuterElement.onclick = function(e) {
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonOuterElement.onkeypress = function(e) {
                            if (e.code === "Enter" || e.code === "Space") // space or enter
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonInnerElement = document.createElement("div");
                        playButtonInnerElement.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow");
                        playButtonInnerElement.style.width = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.height = playButtonArrowHeight + "px";
                        playButtonInnerElement.style.borderTopWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderBottomWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderLeftWidth = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.borderRightWidth = "0";
                        playButtonInnerElement.style.borderStyle = "solid";
                        playButtonInnerElement.style.borderTopColor = "transparent";
                        playButtonInnerElement.style.borderRightColor = "transparent";
                        playButtonInnerElement.style.borderBottomColor = "transparent";
                        playButtonInnerElement.style.transform = "translate(" + playButtonArrowWidth / 10 + "px,0px)";
                        playButtonOuterElement.appendChild(playButtonInnerElement);
                        playButtonContainer = document.createElement("div");
                        playButtonContainer.style.position = "absolute";
                        playButtonContainer.style.left = "0";
                        playButtonContainer.style.top = "0";
                        playButtonContainer.style.width = "100%";
                        playButtonContainer.style.height = "100%";
                        playButtonContainer.style.display = "flex";
                        playButtonContainer.style.justifyContent = "center";
                        playButtonContainer.style.alignItems = "center";
                        playButtonContainer.appendChild(playButtonOuterElement);
                        posterRootElement_1.appendChild(playButtonContainer);
                    }
                    $5104722604b983cb$var$clearElement(this.renderedElement);
                    this.renderedElement.appendChild(posterRootElement_1);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    Media.prototype.internalRender = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-media");
        return element;
    };
    Media.prototype.render = function() {
        var _this = this;
        var result = _super.prototype.render.call(this);
        if (result) {
            this._mediaPlayer = this.createMediaPlayer();
            this._mediaPlayer.fetchVideoDetails().then(function() {
                return _this.displayPoster();
            });
        }
        return result;
    };
    Media.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.displayPoster();
    };
    Media.prototype.getJsonTypeName = function() {
        return "Media";
    };
    Media.prototype.getResourceInformation = function() {
        var result = [];
        if (this._mediaPlayer) {
            var posterUrl = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
            if (posterUrl) result.push({
                url: posterUrl,
                mimeType: "image"
            });
        }
        for(var _i = 0, _a = this.sources; _i < _a.length; _i++){
            var mediaSource = _a[_i];
            if (mediaSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: mediaSource.url,
                mimeType: mediaSource.mimeType
            });
        }
        for(var _b = 0, _c = this.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: captionSource.url,
                mimeType: captionSource.mimeType
            });
        }
        return result;
    };
    Object.defineProperty(Media.prototype, "selectedMediaType", {
        get: function() {
            return this._mediaPlayer.selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    Media.customMediaPlayers = [
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi,
                /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi
            ],
            createMediaPlayer: function(matches) {
                return new $5104722604b983cb$var$YouTubePlayer(matches, $24F6S.Strings.defaults.youTubeVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $5104722604b983cb$var$VimeoPlayer(matches, $24F6S.Strings.defaults.vimeoVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $5104722604b983cb$var$DailymotionPlayer(matches, $24F6S.Strings.defaults.dailymotionVideoPlayer());
            }
        }
    ];
    //#region Schema
    Media.sourcesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_1, "sources", $5104722604b983cb$var$MediaSource);
    Media.captionSourcesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_6, "captionSources", $5104722604b983cb$var$CaptionSource);
    Media.posterProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "poster");
    Media.altTextProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "altText");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.sourcesProperty)
    ], Media.prototype, "sources", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.captionSourcesProperty)
    ], Media.prototype, "captionSources", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.posterProperty)
    ], Media.prototype, "poster", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Media.altTextProperty)
    ], Media.prototype, "altText", void 0);
    return Media;
}($5104722604b983cb$var$CardElement);
module.exports.Media = $5104722604b983cb$var$Media;
var $5104722604b983cb$var$InputEventType;
(function(InputEventType) {
    InputEventType[InputEventType["InitialRender"] = 0] = "InitialRender";
    InputEventType[InputEventType["MouseEnterOnCard"] = 1] = "MouseEnterOnCard";
    InputEventType[InputEventType["MouseLeaveOnCard"] = 2] = "MouseLeaveOnCard";
    InputEventType[InputEventType["FocusLeave"] = 3] = "FocusLeave";
})($5104722604b983cb$var$InputEventType || ($5104722604b983cb$var$InputEventType = {}));
var $5104722604b983cb$var$Input = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputStyle = $gIXBn.InputStyle.Default;
        return _this;
    }
    Input.prototype.getAllLabelIds = function() {
        var labelIds = [];
        if (this.labelledBy) labelIds.push(this.labelledBy);
        if (this._renderedLabelElement) labelIds.push(this._renderedLabelElement.id);
        if (this._renderedErrorMessageElement) labelIds.push(this._renderedErrorMessageElement.id);
        return labelIds;
    };
    Input.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._renderedInputControlElement) {
            var labelIds = this.getAllLabelIds();
            if (labelIds.length > 0) this._renderedInputControlElement.setAttribute("aria-labelledby", labelIds.join(" "));
            else this._renderedInputControlElement.removeAttribute("aria-labelledby");
        }
    };
    Object.defineProperty(Input.prototype, "isNullable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "renderedInputControlElement", {
        get: function() {
            return this._renderedInputControlElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "inputControlContainerElement", {
        get: function() {
            return this._inputControlContainerElement;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.overrideInternalRender = function() {
        var _this = this;
        var hostConfig = this.hostConfig;
        this._outerContainerElement = document.createElement("div");
        this._outerContainerElement.style.display = "flex";
        if (this.labelPosition === $gIXBn.InputLabelPosition.Inline) this._outerContainerElement.style.flexDirection = "row";
        else this._outerContainerElement.style.flexDirection = "column";
        var renderedInputControlId = $F6YrP.generateUniqueId();
        if (this.label) {
            var labelRichTextBlock = new $5104722604b983cb$var$RichTextBlock();
            labelRichTextBlock.setParent(this);
            labelRichTextBlock.forElementId = renderedInputControlId;
            var labelInline = new $5104722604b983cb$var$TextRun(this.label);
            labelRichTextBlock.addInline(labelInline);
            if (this.isRequired) {
                labelInline.init(hostConfig.inputs.label.requiredInputs);
                var isRequiredCueInline = new $5104722604b983cb$var$TextRun(hostConfig.inputs.label.requiredInputs.suffix);
                isRequiredCueInline.color = hostConfig.inputs.label.requiredInputs.suffixColor;
                isRequiredCueInline.ariaHidden = true;
                labelRichTextBlock.addInline(isRequiredCueInline);
            } else labelInline.init(hostConfig.inputs.label.optionalInputs);
            this._renderedLabelElement = labelRichTextBlock.render();
            if (this._renderedLabelElement) {
                this._renderedLabelElement.id = $F6YrP.generateUniqueId();
                if (this.labelPosition === $gIXBn.InputLabelPosition.Inline) // For inline label position: label should be in center of the div and no extra spacing needed
                this._renderedLabelElement.style.alignSelf = "center";
                else this._renderedLabelElement.style.marginBottom = hostConfig.getEffectiveSpacing(hostConfig.inputs.label.inputSpacing) + "px";
                this._outerContainerElement.appendChild(this._renderedLabelElement);
            }
        }
        this._inputControlContainerElement = document.createElement("div");
        this._inputControlContainerElement.className = hostConfig.makeCssClassName("ac-input-container");
        this._inputControlContainerElement.style.display = "flex";
        if (this.height === "stretch") {
            this._inputControlContainerElement.style.alignItems = "stretch";
            this._inputControlContainerElement.style.flex = "1 1 auto";
        }
        this._renderedInputControlElement = this.internalRender();
        if (this._renderedInputControlElement) {
            this._renderedInputControlElement.id = renderedInputControlId;
            this._renderedInputControlElement.style.minWidth = "0px";
            if (this.isNullable && this.isRequired) {
                this._renderedInputControlElement.setAttribute("aria-required", "true");
                this._renderedInputControlElement.classList.add(hostConfig.makeCssClassName("ac-input-required"));
            }
            this._inputControlContainerElement.appendChild(this._renderedInputControlElement);
            this._outerContainerElement.appendChild(this._inputControlContainerElement);
            if (this._renderedLabelElement && this.labelPosition === $gIXBn.InputLabelPosition.Inline) {
                if (!this.labelWidth) {
                    var defaultLabelWidth = hostConfig.inputs.label.width;
                    this._renderedLabelElement.style.width = defaultLabelWidth.toString() + "%";
                    this._inputControlContainerElement.style.width = 100 - defaultLabelWidth + "%";
                } else if (this.labelWidth.unit == $gIXBn.SizeUnit.Weight) {
                    var labelWidthInPercent = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPercent.toString() + "%";
                    this._inputControlContainerElement.style.width = (100 - labelWidthInPercent).toString() + "%";
                } else if (this.labelWidth.unit == $gIXBn.SizeUnit.Pixel) {
                    var labelWidthInPixel = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPixel.toString() + "px";
                }
            }
            this.updateVisualState($5104722604b983cb$var$InputEventType.InitialRender);
            if (this._renderedInputControlElement) this._renderedInputControlElement.onblur = function(ev) {
                _this.updateVisualState($5104722604b983cb$var$InputEventType.FocusLeave);
            };
            this.updateInputControlAriaLabelledBy();
            return this._outerContainerElement;
        }
        this.resetDirtyState();
        return undefined;
    };
    Input.prototype.valueChanged = function() {
        this.getRootElement().updateActionsEnabledState();
        if (this.isValid()) this.resetValidationFailureCue();
        if (this.onValueChanged) this.onValueChanged(this);
        $5104722604b983cb$var$raiseInputValueChangedEvent(this);
    };
    Input.prototype.resetValidationFailureCue = function() {
        if (this.renderedInputControlElement) {
            if (this instanceof $5104722604b983cb$var$ChoiceSetInput && this.isDynamicTypeahead()) this.removeValidationFailureCue();
            else this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.updateInputControlAriaLabelledBy();
            if (this._renderedErrorMessageElement) {
                this._outerContainerElement.removeChild(this._renderedErrorMessageElement);
                this._renderedErrorMessageElement = undefined;
            }
        }
    };
    Input.prototype.showValidationErrorMessage = function() {
        if (this.renderedElement && this.errorMessage && $6BHj7.GlobalSettings.displayInputValidationErrors) {
            var errorMessageTextBlock = new $5104722604b983cb$var$TextBlock();
            errorMessageTextBlock.setParent(this);
            errorMessageTextBlock.text = this.errorMessage;
            errorMessageTextBlock.wrap = true;
            errorMessageTextBlock.init(this.hostConfig.inputs.errorMessage);
            this._renderedErrorMessageElement = errorMessageTextBlock.render();
            if (this._renderedErrorMessageElement) {
                this._renderedErrorMessageElement.id = $F6YrP.generateUniqueId();
                this._outerContainerElement.appendChild(this._renderedErrorMessageElement);
                this.updateInputControlAriaLabelledBy();
            }
        }
    };
    Object.defineProperty(Input.prototype, "allowRevealOnHoverStyle", {
        get: function() {
            return this.hostConfig.inputs && this.hostConfig.inputs.allowRevealOnHoverStyle;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.shouldHideInputAdornersForRevealOnHover = function(input, eventType) {
        // show/hide input adorners (date picker, time picker, select dropdown picker) with inputStyle RevealOnHover
        // 1. intial render of card: hide input adorners
        // 2. mouse hover on the card: show input adorners
        // 3. mouse hover outside the card: hide input adorners unless input is still in focus state
        // 4. input loses focus: hide the input adorners unless mouse is still hovering on the card
        // check if input still has the focus
        var isInputInFocus = input === document.activeElement;
        // check if mouse is still on the card
        var inputHoverClassName = this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover");
        var isMouseOverCard = input.classList.contains(inputHoverClassName);
        var hideInputAdorners = eventType === $5104722604b983cb$var$InputEventType.InitialRender || eventType === $5104722604b983cb$var$InputEventType.FocusLeave && !isMouseOverCard || eventType === $5104722604b983cb$var$InputEventType.MouseLeaveOnCard && !isInputInFocus;
        return hideInputAdorners;
    };
    Input.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle || !this._renderedInputControlElement || this.inputStyle !== $gIXBn.InputStyle.RevealOnHover) return;
        if (eventType === $5104722604b983cb$var$InputEventType.InitialRender) // on initial render, we will show input fields as read only view
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onrender"));
        else if (eventType === $5104722604b983cb$var$InputEventType.MouseEnterOnCard) // on hover on the card, we will reveal the inputs by showing borders etc
        // ac-inputStyle-revealOnHover-onhover class is also used to identify if mouse is hovering on the card
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
        else if (eventType === $5104722604b983cb$var$InputEventType.MouseLeaveOnCard) this._renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
    };
    Input.prototype.focus = function() {
        if (this._renderedInputControlElement) this._renderedInputControlElement.focus();
    };
    Input.prototype.isValid = function() {
        return true;
    };
    Input.prototype.isDirty = function() {
        return this.value !== this._oldValue;
    };
    Input.prototype.resetDirtyState = function() {
        this._oldValue = this.value;
    };
    Input.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.id) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.inputsMustHaveUniqueId());
        if (this.isRequired) {
            if (!this.label) context.addFailure(this, $gIXBn.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label");
            if (!this.errorMessage) context.addFailure(this, $gIXBn.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message");
        }
    };
    Input.prototype.validateValue = function() {
        this.resetValidationFailureCue();
        var result = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
        if (!result && this.renderedInputControlElement) {
            if (this instanceof $5104722604b983cb$var$ChoiceSetInput && this.isDynamicTypeahead()) this.showValidationFailureCue();
            else this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.showValidationErrorMessage();
        }
        return result;
    };
    Input.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [
            this
        ];
    };
    Input.prototype.render = function() {
        var result = _super.prototype.render.call(this);
        this.resetDirtyState();
        return result;
    };
    Object.defineProperty(Input.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Input.labelProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_3, "label", true);
    Input.isRequiredProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_3, "isRequired", false);
    Input.errorMessageProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_3, "errorMessage", true);
    Input.inputStyleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "inputStyle", $gIXBn.InputStyle, $gIXBn.InputStyle.Default, [
        {
            value: $gIXBn.InputStyle.RevealOnHover
        },
        {
            value: $gIXBn.InputStyle.Default
        }
    ]);
    Input.labelWidthProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_6, "labelWidth", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidLabelWidth = false;
        if (typeof value === "number" && !isNaN(value)) {
            result = new $6BHj7.SizeAndUnit(value, $gIXBn.SizeUnit.Weight);
            if (result.physicalSize < 0 || result.physicalSize > 100) invalidLabelWidth = true;
        } else if (typeof value === "string") try {
            result = $6BHj7.SizeAndUnit.parse(value);
        } catch (e) {
            invalidLabelWidth = true;
        }
        else invalidLabelWidth = true;
        if (invalidLabelWidth) {
            context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidInputLabelWidth());
            result = undefined;
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $6BHj7.SizeAndUnit) {
            if (value.unit === $gIXBn.SizeUnit.Pixel) context.serializeValue(target, "labelWidth", value.physicalSize + "px");
            else context.serializeNumber(target, "labelWidth", value.physicalSize);
        }
    }, undefined);
    Input.labelPositionProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "labelPosition", $gIXBn.InputLabelPosition, $gIXBn.InputLabelPosition.Above, [
        {
            value: $gIXBn.InputLabelPosition.Inline
        },
        {
            value: $gIXBn.InputLabelPosition.Above
        }
    ]);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.labelProperty)
    ], Input.prototype, "label", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.isRequiredProperty)
    ], Input.prototype, "isRequired", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.errorMessageProperty)
    ], Input.prototype, "errorMessage", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.inputStyleProperty)
    ], Input.prototype, "inputStyle", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.labelWidthProperty)
    ], Input.prototype, "labelWidth", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Input.labelPositionProperty)
    ], Input.prototype, "labelPosition", void 0);
    return Input;
}($5104722604b983cb$var$CardElement);
module.exports.Input = $5104722604b983cb$var$Input;
var $5104722604b983cb$var$TextInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TextInput, _super);
    function TextInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiline = false;
        _this.style = $gIXBn.InputTextStyle.Text;
        return _this;
    }
    //#endregion
    TextInput.prototype.setupInput = function(input) {
        var _this = this;
        input.style.flex = "1 1 auto";
        input.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.placeholder) {
            input.placeholder = this.placeholder;
            input.setAttribute("aria-label", this.placeholder);
        }
        if (this.defaultValue) input.value = this.defaultValue;
        if (this.maxLength && this.maxLength > 0) input.maxLength = this.maxLength;
        input.oninput = function() {
            _this.valueChanged();
        };
        input.onkeypress = function(e) {
            // Ctrl+Enter pressed
            if (e.ctrlKey && e.code === "Enter" && _this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) _this.inlineAction.execute();
        };
    };
    TextInput.prototype.internalRender = function() {
        var result;
        if (this.isMultiline && this.style !== $gIXBn.InputTextStyle.Password) {
            result = document.createElement("textarea");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline");
            if (this.height === "stretch") result.style.height = "initial";
        } else {
            result = document.createElement("input");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput");
            result.type = $gIXBn.InputTextStyle[this.style].toLowerCase();
        }
        this.setupInput(result);
        return result;
    };
    TextInput.prototype.overrideInternalRender = function() {
        var _this = this;
        var renderedInputControl = _super.prototype.overrideInternalRender.call(this);
        if (this.inlineAction) {
            var button_1 = document.createElement("button");
            button_1.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled");
            button_1.onclick = function(e) {
                if (_this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
                    e.preventDefault();
                    e.cancelBubble = true;
                    _this.inlineAction.execute();
                }
            };
            if (this.inlineAction.iconUrl) {
                button_1.classList.add("iconOnly");
                var icon_1 = document.createElement("img");
                icon_1.style.height = "100%";
                icon_1.setAttribute("role", "presentation");
                // The below trick is necessary as a workaround in Chrome where the icon is initially displayed
                // at its native size then resized to 100% of the button's height. This cfreates an unpleasant
                // flicker. On top of that, Chrome's flex implementation fails to prperly re-layout the button
                // after the image has loaded and been gicven its final size. The below trick also fixes that.
                icon_1.style.display = "none";
                icon_1.onload = function() {
                    icon_1.style.removeProperty("display");
                };
                icon_1.onerror = function() {
                    button_1.removeChild(icon_1);
                    button_1.classList.remove("iconOnly");
                    button_1.classList.add("textOnly");
                    button_1.textContent = _this.inlineAction && _this.inlineAction.title ? _this.inlineAction.title : $24F6S.Strings.defaults.inlineActionTitle();
                };
                icon_1.src = this.inlineAction.iconUrl;
                button_1.appendChild(icon_1);
                button_1.title = this.inlineAction.title ? this.inlineAction.title : $24F6S.Strings.defaults.inlineActionTitle();
            } else {
                button_1.classList.add("textOnly");
                button_1.textContent = this.inlineAction.title ? this.inlineAction.title : $24F6S.Strings.defaults.inlineActionTitle();
            }
            this.inlineAction.setupElementForAccessibility(button_1, true);
            button_1.style.marginLeft = "8px";
            this.inputControlContainerElement.appendChild(button_1);
        }
        return renderedInputControl;
    };
    TextInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!(this.inlineAction || this.isMultiline)) _super.prototype.updateVisualState.call(this, eventType);
    };
    TextInput.prototype.getJsonTypeName = function() {
        return "Input.Text";
    };
    TextInput.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.inlineAction) result.push(this.inlineAction);
        return result;
    };
    TextInput.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.inlineAction) result = this.inlineAction.getActionById(id);
        return result;
    };
    TextInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TextInput.prototype.isValid = function() {
        if (!this.value) return true;
        if (this.regex) return new RegExp(this.regex, "g").test(this.value);
        return true;
    };
    Object.defineProperty(TextInput.prototype, "value", {
        get: function() {
            if (this.renderedInputControlElement) {
                if (this.isMultiline) return this.renderedInputControlElement.value;
                else return this.renderedInputControlElement.value;
            } else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    TextInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    TextInput.maxLengthProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "maxLength");
    TextInput.isMultilineProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "isMultiline", false);
    TextInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    TextInput.styleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_0, "style", $gIXBn.InputTextStyle, $gIXBn.InputTextStyle.Text, [
        {
            value: $gIXBn.InputTextStyle.Text
        },
        {
            value: $gIXBn.InputTextStyle.Tel
        },
        {
            value: $gIXBn.InputTextStyle.Url
        },
        {
            value: $gIXBn.InputTextStyle.Email
        },
        {
            value: $gIXBn.InputTextStyle.Password,
            targetVersion: $5Ougt.Versions.v1_5
        }
    ]);
    TextInput.inlineActionProperty = new $5104722604b983cb$var$ActionProperty($5Ougt.Versions.v1_0, "inlineAction", [
        "Action.ShowCard"
    ]);
    TextInput.regexProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_3, "regex", true);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.valueProperty)
    ], TextInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.maxLengthProperty)
    ], TextInput.prototype, "maxLength", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.isMultilineProperty)
    ], TextInput.prototype, "isMultiline", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.placeholderProperty)
    ], TextInput.prototype, "placeholder", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.styleProperty)
    ], TextInput.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.inlineActionProperty)
    ], TextInput.prototype, "inlineAction", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TextInput.regexProperty)
    ], TextInput.prototype, "regex", void 0);
    return TextInput;
}($5104722604b983cb$var$Input);
module.exports.TextInput = $5104722604b983cb$var$TextInput;
var $5104722604b983cb$var$ToggleInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ToggleInput, _super);
    function ToggleInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueOn = "true";
        _this.valueOff = "false";
        _this.wrap = false;
        return _this;
    }
    ToggleInput.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._checkboxInputElement) {
            var joinedLabelIds = this.getAllLabelIds().join(" ");
            if (this._checkboxInputLabelElement && this._checkboxInputLabelElement.id) joinedLabelIds += " " + this._checkboxInputLabelElement.id;
            if (joinedLabelIds) this._checkboxInputElement.setAttribute("aria-labelledby", joinedLabelIds);
            else this._checkboxInputElement.removeAttribute("aria-labelledby");
        }
    };
    ToggleInput.prototype.internalRender = function() {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput");
        element.style.width = "100%";
        element.style.display = "flex";
        element.style.alignItems = "center";
        this._checkboxInputElement = document.createElement("input");
        this._checkboxInputElement.id = $F6YrP.generateUniqueId();
        this._checkboxInputElement.type = "checkbox";
        this._checkboxInputElement.style.display = "inline-block";
        this._checkboxInputElement.style.verticalAlign = "middle";
        this._checkboxInputElement.style.margin = "0";
        this._checkboxInputElement.style.flex = "0 0 auto";
        if (this.title) this._checkboxInputElement.setAttribute("aria-label", this.title);
        if (this.isRequired) this._checkboxInputElement.setAttribute("aria-required", "true");
        this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue === this.valueOn) this._checkboxInputElement.checked = true;
        this._oldCheckboxValue = this._checkboxInputElement.checked;
        this._checkboxInputElement.onchange = function() {
            _this.valueChanged();
        };
        $F6YrP.appendChild(element, this._checkboxInputElement);
        if (this.title || this.isDesignMode()) {
            var label = new $5104722604b983cb$var$TextBlock();
            label.setParent(this);
            label.forElementId = this._checkboxInputElement.id;
            label.hostConfig = this.hostConfig;
            label.text = !this.title ? this.getJsonTypeName() : this.title;
            label.useMarkdown = $6BHj7.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            this._checkboxInputLabelElement = label.render();
            if (this._checkboxInputLabelElement) {
                this._checkboxInputLabelElement.id = $F6YrP.generateUniqueId();
                this._checkboxInputLabelElement.style.display = "inline-block";
                this._checkboxInputLabelElement.style.flex = "1 1 auto";
                this._checkboxInputLabelElement.style.marginLeft = "6px";
                this._checkboxInputLabelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $F6YrP.appendChild(element, spacerElement);
                $F6YrP.appendChild(element, this._checkboxInputLabelElement);
            }
        }
        return element;
    };
    Object.defineProperty(ToggleInput.prototype, "isNullable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.prototype.updateVisualState = function(eventType) {};
    ToggleInput.prototype.getJsonTypeName = function() {
        return "Input.Toggle";
    };
    ToggleInput.prototype.focus = function() {
        if (this._checkboxInputElement) this._checkboxInputElement.focus();
    };
    ToggleInput.prototype.isSet = function() {
        if (this.isRequired) return this.value === this.valueOn;
        return this.value ? true : false;
    };
    ToggleInput.prototype.isDirty = function() {
        return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : false;
    };
    Object.defineProperty(ToggleInput.prototype, "value", {
        get: function() {
            if (this._checkboxInputElement) return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
            else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    ToggleInput.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    ToggleInput.valueOnProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "valueOn", true, undefined, "true", function(sender) {
        return "true";
    });
    ToggleInput.valueOffProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "valueOff", true, undefined, "false", function(sender) {
        return "false";
    });
    ToggleInput.wrapProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "wrap", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.valueProperty)
    ], ToggleInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.titleProperty)
    ], ToggleInput.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.valueOnProperty)
    ], ToggleInput.prototype, "valueOn", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.valueOffProperty)
    ], ToggleInput.prototype, "valueOff", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleInput.wrapProperty)
    ], ToggleInput.prototype, "wrap", void 0);
    return ToggleInput;
}($5104722604b983cb$var$Input);
module.exports.ToggleInput = $5104722604b983cb$var$ToggleInput;
var $5104722604b983cb$var$Choice = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Choice, _super);
    function Choice(title, value) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.value = value;
        return _this;
    }
    //#endregion
    Choice.prototype.getSchemaKey = function() {
        return "Choice";
    };
    //#region Schema
    Choice.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    Choice.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Choice.titleProperty)
    ], Choice.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Choice.valueProperty)
    ], Choice.prototype, "value", void 0);
    return Choice;
}($5Ougt.SerializableObject);
module.exports.Choice = $5104722604b983cb$var$Choice;
/**
 * DataQuery class is declared later in the file and derives from subsequent base classes
 * Hence, it cannot be used in ChoiceSetInput.
 * Refactor is needed to separate elements and actions in separate files.
 */ var $5104722604b983cb$var$ChoiceSetInputDataQuery = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ChoiceSetInputDataQuery, _super);
    function ChoiceSetInputDataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ChoiceSetInputDataQuery.prototype.getSchemaKey = function() {
        return "choices.data";
    };
    //#region Schema
    ChoiceSetInputDataQuery.typeProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "type", true, new RegExp("^Data.Query$"));
    ChoiceSetInputDataQuery.datasetProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "dataset");
    ChoiceSetInputDataQuery.countProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "count");
    ChoiceSetInputDataQuery.skipProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "skip");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.typeProperty)
    ], ChoiceSetInputDataQuery.prototype, "type", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.datasetProperty)
    ], ChoiceSetInputDataQuery.prototype, "dataset", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.countProperty)
    ], ChoiceSetInputDataQuery.prototype, "count", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInputDataQuery.skipProperty)
    ], ChoiceSetInputDataQuery.prototype, "skip", void 0);
    return ChoiceSetInputDataQuery;
}($5Ougt.SerializableObject);
module.exports.ChoiceSetInputDataQuery = $5104722604b983cb$var$ChoiceSetInputDataQuery;
var $5104722604b983cb$var$ChoiceSetInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ChoiceSetInput, _super);
    function ChoiceSetInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelect = false;
        _this.wrap = false;
        _this.choices = [];
        return _this;
    }
    Object.defineProperty(ChoiceSetInput.prototype, "isCompact", {
        get: function() {
            return !this.style || this.style === "compact";
        },
        set: function(value) {
            this.style = value ? undefined : "expanded";
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.getUniqueCategoryName = function() {
        var uniqueCategoryName = "__ac-category" + ChoiceSetInput._uniqueCategoryCounter;
        ChoiceSetInput._uniqueCategoryCounter++;
        return uniqueCategoryName;
    };
    ChoiceSetInput.prototype.isDynamicTypeahead = function() {
        return this.hostConfig.inputs.allowDynamicallyFilteredChoiceSet && !!this.choicesData && !!this.choicesData.dataset && this.choicesData.type === "Data.Query";
    };
    ChoiceSetInput.prototype.getFilterForDynamicSearch = function() {
        var _a;
        return (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value;
    };
    ChoiceSetInput.prototype.getDropdownElement = function() {
        var _a;
        return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dropdown;
    };
    ChoiceSetInput.prototype.renderChoices = function(filter, fetchedChoices) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.processResponse(filter, fetchedChoices);
    };
    ChoiceSetInput.prototype.showLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showLoadingIndicator();
    };
    ChoiceSetInput.prototype.removeLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.removeLoadingIndicator();
    };
    ChoiceSetInput.prototype.showErrorIndicator = function(filter, error) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showErrorIndicator(filter, error);
    };
    ChoiceSetInput.prototype.showValidationFailureCue = function() {
        var _a;
        (_a = this._textInput) === null || _a === void 0 || _a.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    };
    ChoiceSetInput.prototype.removeValidationFailureCue = function() {
        var _a;
        (_a = this._textInput) === null || _a === void 0 || _a.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    };
    ChoiceSetInput.prototype.createPlaceholderOptionWhenValueDoesNotExist = function() {
        if (!this.value) {
            var placeholderOption = document.createElement("option");
            placeholderOption.selected = true;
            placeholderOption.disabled = true;
            placeholderOption.hidden = true;
            placeholderOption.value = "";
            if (this.placeholder) placeholderOption.text = this.placeholder;
            return placeholderOption;
        }
        return undefined;
    };
    // Make sure `aria-current` is applied to the currently-selected item
    ChoiceSetInput.prototype.internalApplyAriaCurrent = function() {
        if (this._selectElement) {
            var options = this._selectElement.options;
            if (options) for(var _i = 0, _a = Array.from(options); _i < _a.length; _i++){
                var option = _a[_i];
                if (option.selected) option.setAttribute("aria-current", "true");
                else option.removeAttribute("aria-current");
            }
        }
    };
    ChoiceSetInput.prototype.renderCompoundInput = function(cssClassName, type, defaultValues) {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", cssClassName);
        element.style.width = "100%";
        element.tabIndex = this.isDesignMode() ? -1 : 0;
        this._toggleInputs = [];
        this._labels = [];
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            var input = document.createElement("input");
            input.id = $F6YrP.generateUniqueId();
            input.type = type;
            input.style.margin = "0";
            input.style.display = "inline-block";
            input.style.verticalAlign = "middle";
            input.style.flex = "0 0 auto";
            input.name = this.id ? this.id : this._uniqueCategoryName;
            if (this.isRequired) input.setAttribute("aria-required", "true");
            input.tabIndex = this.isDesignMode() ? -1 : 0;
            if (choice.value) input.value = choice.value;
            if (choice.title) input.setAttribute("aria-label", choice.title);
            if (defaultValues && choice.value) {
                if (defaultValues.indexOf(choice.value) >= 0) input.checked = true;
            }
            input.onchange = function() {
                _this.valueChanged();
            };
            this._toggleInputs.push(input);
            var compoundInput = document.createElement("div");
            compoundInput.style.display = "flex";
            compoundInput.style.alignItems = "center";
            $F6YrP.appendChild(compoundInput, input);
            var label = new $5104722604b983cb$var$TextBlock();
            label.setParent(this);
            label.forElementId = input.id;
            label.hostConfig = this.hostConfig;
            label.text = choice.title ? choice.title : "Choice " + this._toggleInputs.length;
            label.useMarkdown = $6BHj7.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            var labelElement = label.render();
            this._labels.push(labelElement);
            if (labelElement) {
                labelElement.id = $F6YrP.generateUniqueId();
                labelElement.style.display = "inline-block";
                labelElement.style.flex = "1 1 auto";
                labelElement.style.marginLeft = "6px";
                labelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $F6YrP.appendChild(compoundInput, spacerElement);
                $F6YrP.appendChild(compoundInput, labelElement);
            }
            $F6YrP.appendChild(element, compoundInput);
        }
        return element;
    };
    ChoiceSetInput.prototype.updateInputControlAriaLabelledBy = function() {
        if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels) {
            var labelIds = this.getAllLabelIds();
            for(var i = 0; i < this._toggleInputs.length; i++){
                var joinedLabelIds = labelIds.join(" ");
                var label = this._labels[i];
                if (label && label.id) joinedLabelIds += " " + label.id;
                if (joinedLabelIds) this._toggleInputs[i].setAttribute("aria-labelledby", joinedLabelIds);
                else this._toggleInputs[i].removeAttribute("aria-labelledby");
            }
        } else _super.prototype.updateInputControlAriaLabelledBy.call(this);
    };
    ChoiceSetInput.prototype.internalRender = function() {
        var _this = this;
        this._uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
        if (this.isDynamicTypeahead()) {
            var filteredChoiceSet_1 = new $5104722604b983cb$var$FilteredChoiceSet(ChoiceSetInput._uniqueCategoryCounter, this.choices, this.hostConfig);
            filteredChoiceSet_1.render();
            if (filteredChoiceSet_1.textInput) {
                this._textInput = filteredChoiceSet_1.textInput;
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var onInputChangeEventHandler = $F6YrP.debounce(function() {
                    filteredChoiceSet_1.processChoices();
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                }, this.hostConfig.inputs.debounceTimeInMilliSeconds);
                this._textInput.onclick = onInputChangeEventHandler;
                this._textInput.oninput = onInputChangeEventHandler;
            }
            filteredChoiceSet_1.parent = this;
            this._filteredChoiceSet = filteredChoiceSet_1;
            return filteredChoiceSet_1.renderedElement;
        } else if (this.isMultiSelect) // Render as a list of toggle inputs
        return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : undefined);
        else {
            if (this.style === "expanded") // Render as a series of radio buttons
            return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [
                this.defaultValue
            ] : undefined);
            else if (this.style === "filtered") {
                // Render as a text input coupled with a datalist
                var inputContainer = document.createElement("div");
                inputContainer.style.width = "100%";
                this._textInput = document.createElement("input");
                this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
                this._textInput.type = "text";
                this._textInput.style.width = "100%";
                this._textInput.oninput = function() {
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                };
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var dataList = document.createElement("datalist");
                dataList.id = $F6YrP.generateUniqueId();
                for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                    var choice = _a[_i];
                    var option = document.createElement("option");
                    // To fix https://stackoverflow.com/questions/29882361/show-datalist-labels-but-submit-the-actual-value
                    // value is mapped to choice.title other than choice.value
                    if (choice.title) {
                        option.value = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    dataList.appendChild(option);
                }
                this._textInput.setAttribute("list", dataList.id);
                inputContainer.append(this._textInput, dataList);
                return inputContainer;
            } else {
                // Render as a combo box
                this._selectElement = document.createElement("select");
                this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact");
                this._selectElement.style.width = "100%";
                this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
                var placeholderOption = this.createPlaceholderOptionWhenValueDoesNotExist();
                $F6YrP.appendChild(this._selectElement, placeholderOption);
                for(var _b = 0, _c = this.choices; _b < _c.length; _b++){
                    var choice = _c[_b];
                    var option = document.createElement("option");
                    option.value = choice.value;
                    if (choice.title) {
                        option.text = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    if (choice.value === this.defaultValue) option.selected = true;
                    $F6YrP.appendChild(this._selectElement, option);
                }
                this._selectElement.onchange = function() {
                    _this.internalApplyAriaCurrent();
                    _this.valueChanged();
                };
                this.internalApplyAriaCurrent();
                return this._selectElement;
            }
        }
    };
    ChoiceSetInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!this.isMultiSelect && this.isCompact) {
            _super.prototype.updateVisualState.call(this, eventType);
            if (this._selectElement && this.inputStyle === $gIXBn.InputStyle.RevealOnHover) {
                var hideDropDownPicker = this.shouldHideInputAdornersForRevealOnHover(this._selectElement, eventType);
                if (hideDropDownPicker) {
                    this._selectElement.style.appearance = "none";
                    this._selectElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                } else {
                    this._selectElement.style.appearance = "auto";
                    this._selectElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                }
            }
        }
    };
    ChoiceSetInput.prototype.getJsonTypeName = function() {
        return "Input.ChoiceSet";
    };
    ChoiceSetInput.prototype.focus = function() {
        if (this._toggleInputs && (this.isMultiSelect || this.style === "expanded")) {
            if (this._toggleInputs.length > 0) this._toggleInputs[0].focus();
        } else if (this._textInput) this._textInput.focus();
        else _super.prototype.focus.call(this);
    };
    ChoiceSetInput.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.choices.length === 0) context.addFailure(this, $gIXBn.ValidationEvent.CollectionCantBeEmpty, $24F6S.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            if (!choice.title || !choice.value) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
        }
    };
    ChoiceSetInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    ChoiceSetInput.prototype.isValid = function() {
        if (this._textInput) {
            if (this.value === "" || this.value === this.placeholder) return true;
            for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                var choice = _a[_i];
                if (this.value === choice.value) return true;
            }
            if (this.dynamicChoices) for(var _b = 0, _c = this.dynamicChoices; _b < _c.length; _b++){
                var choice = _c[_b];
                if (this.value === choice) return true;
            }
            return false;
        }
        return _super.prototype.isValid.call(this);
    };
    Object.defineProperty(ChoiceSetInput.prototype, "value", {
        get: function() {
            if (!this.isMultiSelect) {
                if (this._selectElement) return this._selectElement.selectedIndex > 0 ? this._selectElement.value : undefined;
                else if (this._textInput) {
                    for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                        var choice = _a[_i];
                        if (choice.title && this._textInput.value === choice.title) return choice.value;
                    }
                    return this._textInput.value;
                } else if (this._toggleInputs && this._toggleInputs.length > 0) for(var _b = 0, _c = this._toggleInputs; _b < _c.length; _b++){
                    var toggleInput = _c[_b];
                    if (toggleInput.checked) return toggleInput.value;
                }
                return undefined;
            } else {
                if (!this._toggleInputs || this._toggleInputs.length === 0) return undefined;
                var result = "";
                for(var _d = 0, _f = this._toggleInputs; _d < _f.length; _d++){
                    var toggleInput = _f[_d];
                    if (toggleInput.checked) {
                        if (result !== "") result += this.hostConfig.choiceSetInputValueSeparator;
                        result += toggleInput.value;
                    }
                }
                return result ? result : undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChoiceSetInput.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dynamicChoices;
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    ChoiceSetInput.choicesProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "choices", $5104722604b983cb$var$Choice);
    ChoiceSetInput.choicesDataProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_6, "choices.data", $5104722604b983cb$var$ChoiceSetInputDataQuery);
    ChoiceSetInput.styleProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_0, "style", [
        {
            value: "compact"
        },
        {
            value: "expanded"
        },
        {
            value: "filtered",
            targetVersion: $5Ougt.Versions.v1_5
        }
    ], "compact");
    ChoiceSetInput.isMultiSelectProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "isMultiSelect", false);
    ChoiceSetInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    ChoiceSetInput.wrapProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "wrap", false);
    //#endregion
    ChoiceSetInput._uniqueCategoryCounter = 0;
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.valueProperty)
    ], ChoiceSetInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.styleProperty)
    ], ChoiceSetInput.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.isMultiSelectProperty)
    ], ChoiceSetInput.prototype, "isMultiSelect", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.placeholderProperty)
    ], ChoiceSetInput.prototype, "placeholder", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.wrapProperty)
    ], ChoiceSetInput.prototype, "wrap", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.choicesProperty)
    ], ChoiceSetInput.prototype, "choices", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ChoiceSetInput.choicesDataProperty)
    ], ChoiceSetInput.prototype, "choicesData", void 0);
    return ChoiceSetInput;
}($5104722604b983cb$var$Input);
module.exports.ChoiceSetInput = $5104722604b983cb$var$ChoiceSetInput;
var $5104722604b983cb$var$FilteredChoiceSet = /** @class */ function() {
    function FilteredChoiceSet(choiceSetId, choices, hostConfig) {
        this._choiceSetId = choiceSetId;
        this._choices = choices;
        this._dynamicChoices = [];
        this._visibleChoiceCount = 0;
        this._highlightedChoiceId = -1;
        this._hostConfig = hostConfig;
    }
    FilteredChoiceSet.prototype.render = function() {
        var _this = this;
        var choiceSetContainer = document.createElement("div");
        choiceSetContainer.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-container");
        this._textInput = document.createElement("input");
        this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-textbox");
        this._textInput.type = "text";
        this._textInput.onkeydown = function(event) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                _this.highlightChoice(_this._highlightedChoiceId + 1);
            } else if (event.key === "ArrowUp") {
                event.preventDefault();
                _this.highlightChoice(_this._highlightedChoiceId - 1);
            } else if (event.key === "Enter") {
                var choice = document.getElementById("ac-choiceSetInput-".concat(_this._choiceSetId, "-choice-").concat(_this._highlightedChoiceId));
                choice === null || choice === void 0 || choice.click();
            }
        };
        this._dropdown = document.createElement("div");
        this._dropdown.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-dropdown");
        choiceSetContainer.append(this._textInput, this._dropdown);
        this._renderedElement = choiceSetContainer;
    };
    FilteredChoiceSet.prototype.createChoice = function(value, filter, id) {
        var _this = this;
        var choice = document.createElement("span");
        choice.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-choice");
        choice.id = "ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id);
        choice.innerHTML = value.replace(filter, "<b>".concat(filter, "</b>"));
        choice.tabIndex = -1;
        choice.onclick = function() {
            choice.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
            _this._highlightedChoiceId = -1;
            if (_this._textInput) {
                _this._textInput.value = choice.innerText;
                _this._textInput.focus();
            }
            if (_this._dropdown) _this._dropdown.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
        };
        choice.onmousemove = function() {
            if (_this._highlightedChoiceId !== id) _this.highlightChoice(id, false);
        };
        return choice;
    };
    FilteredChoiceSet.prototype.highlightChoice = function(id, scrollIntoView) {
        if (scrollIntoView === void 0) scrollIntoView = true;
        if (this._visibleChoiceCount > 0) {
            var currentHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(this._highlightedChoiceId));
            var nextHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id));
            if (nextHighlightedChoice) {
                currentHighlightedChoice === null || currentHighlightedChoice === void 0 || currentHighlightedChoice.classList.remove(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
                nextHighlightedChoice.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
                if (scrollIntoView) nextHighlightedChoice.scrollIntoView();
                this._highlightedChoiceId = id;
            } else if (currentHighlightedChoice && this._highlightedChoiceId !== 0) this.highlightChoice(0);
            else this.highlightChoice(this._visibleChoiceCount - 1);
        }
    };
    FilteredChoiceSet.prototype.filterChoices = function() {
        var _a, _b;
        var filter = ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase().trim()) || "";
        var choices = $5104722604b983cb$var$__spreadArray($5104722604b983cb$var$__spreadArray([], this._choices, true), this._dynamicChoices, true);
        for(var _i = 0, choices_1 = choices; _i < choices_1.length; _i++){
            var choice = choices_1[_i];
            if (choice.title) {
                var matchIndex = choice.title.toLowerCase().indexOf(filter);
                if (matchIndex !== -1) {
                    var matchedText = choice.title.substring(matchIndex, matchIndex + filter.length);
                    var choiceContainer = this.createChoice(choice.title, matchedText, this._visibleChoiceCount++);
                    (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(choiceContainer);
                }
            }
        }
    };
    FilteredChoiceSet.prototype.getStatusIndicator = function(error) {
        if (error) {
            if (!this._errorIndicator) {
                var errorIndicator = document.createElement("div");
                errorIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator", "ac-choiceSetInput-errorIndicator");
                this._errorIndicator = errorIndicator;
            }
            this._errorIndicator.innerText = error;
            return this._errorIndicator;
        } else {
            if (!this._loadingIndicator) {
                var loadingIndicator = document.createElement("div");
                loadingIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator");
                this._loadingIndicator = loadingIndicator;
            }
            this._loadingIndicator.innerText = this._visibleChoiceCount === 0 ? "Loading..." : "Loading more...";
            return this._loadingIndicator;
        }
    };
    FilteredChoiceSet.prototype.resetDropdown = function() {
        if (this._dropdown) {
            $F6YrP.clearElementChildren(this._dropdown);
            this._visibleChoiceCount = 0;
            this._highlightedChoiceId = -1;
        }
    };
    FilteredChoiceSet.prototype.showDropdown = function() {
        var _a;
        if ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.hasChildNodes()) this._dropdown.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
    };
    FilteredChoiceSet.prototype.processChoices = function() {
        this.resetDropdown();
        this.filterChoices();
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.processResponse = function(filter, fetchedChoices) {
        var _a;
        if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
            this.resetDropdown();
            this._dynamicChoices = fetchedChoices;
            this.filterChoices();
            if (this._visibleChoiceCount === 0) this.showErrorIndicator(filter, "No results found");
        }
    };
    FilteredChoiceSet.prototype.showLoadingIndicator = function() {
        var _a;
        var loadingIndicator = this.getStatusIndicator();
        (_a = this._dropdown) === null || _a === void 0 || _a.appendChild(loadingIndicator);
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.removeLoadingIndicator = function() {
        var _a, _b;
        if (this._loadingIndicator && ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.contains(this._loadingIndicator))) (_b = this._dropdown) === null || _b === void 0 || _b.removeChild(this._loadingIndicator);
    };
    FilteredChoiceSet.prototype.showErrorIndicator = function(filter, error) {
        var _a, _b;
        if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
            this.processChoices();
            var errorIndicator = this.getStatusIndicator(error);
            (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(errorIndicator);
            errorIndicator.scrollIntoView();
        }
    };
    Object.defineProperty(FilteredChoiceSet.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._dynamicChoices) === null || _a === void 0 ? void 0 : _a.map(function(choice) {
                return choice.title;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $8kDQQ.defaultHostConfig;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        set: function(value) {
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "textInput", {
        get: function() {
            return this._textInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "dropdown", {
        get: function() {
            return this._dropdown;
        },
        enumerable: false,
        configurable: true
    });
    return FilteredChoiceSet;
}();
module.exports.FilteredChoiceSet = $5104722604b983cb$var$FilteredChoiceSet;
var $5104722604b983cb$var$NumberInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(NumberInput, _super);
    function NumberInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberInput.prototype.internalRender = function() {
        var _this = this;
        this._numberInputElement = document.createElement("input");
        this._numberInputElement.setAttribute("type", "number");
        if (this.min !== undefined) this._numberInputElement.setAttribute("min", this.min.toString());
        if (this.max !== undefined) this._numberInputElement.setAttribute("max", this.max.toString());
        this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput");
        this._numberInputElement.style.width = "100%";
        this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue !== undefined) this._numberInputElement.valueAsNumber = this.defaultValue;
        if (this.placeholder) {
            this._numberInputElement.placeholder = this.placeholder;
            this._numberInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._numberInputElement.oninput = function() {
            _this.valueChanged();
        };
        return this._numberInputElement;
    };
    NumberInput.prototype.getJsonTypeName = function() {
        return "Input.Number";
    };
    NumberInput.prototype.isSet = function() {
        return this.value !== undefined && !isNaN(this.value);
    };
    NumberInput.prototype.isValid = function() {
        if (this.value === undefined) return !this.isRequired;
        var result = true;
        if (this.min !== undefined) result = result && this.value >= this.min;
        if (this.max !== undefined) result = result && this.value <= this.max;
        return result;
    };
    Object.defineProperty(NumberInput.prototype, "value", {
        get: function() {
            return this._numberInputElement ? this._numberInputElement.valueAsNumber : undefined;
        },
        set: function(value) {
            if (value && this._numberInputElement) this._numberInputElement.value = value.toString();
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    NumberInput.valueProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "value");
    NumberInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    NumberInput.minProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "min");
    NumberInput.maxProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_0, "max");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.valueProperty)
    ], NumberInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.minProperty)
    ], NumberInput.prototype, "min", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.maxProperty)
    ], NumberInput.prototype, "max", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(NumberInput.placeholderProperty)
    ], NumberInput.prototype, "placeholder", void 0);
    return NumberInput;
}($5104722604b983cb$var$Input);
module.exports.NumberInput = $5104722604b983cb$var$NumberInput;
var $5104722604b983cb$var$DateInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(DateInput, _super);
    function DateInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateInput.prototype.internalRender = function() {
        var _this = this;
        this._dateInputElement = document.createElement("input");
        this._dateInputElement.setAttribute("type", "date");
        if (this.min) this._dateInputElement.setAttribute("min", this.min);
        if (this.max) this._dateInputElement.setAttribute("max", this.max);
        if (this.placeholder) {
            this._dateInputElement.placeholder = this.placeholder;
            this._dateInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput");
        this._dateInputElement.style.width = "100%";
        this._dateInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.defaultValue) this._dateInputElement.value = this.defaultValue;
        return this._dateInputElement;
    };
    DateInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._dateInputElement && this.inputStyle === $gIXBn.InputStyle.RevealOnHover) {
            var hideDatePicker = this.shouldHideInputAdornersForRevealOnHover(this._dateInputElement, eventType);
            if (hideDatePicker) this._dateInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._dateInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $5104722604b983cb$var$updateInputAdornersVisibility(this._dateInputElement, hideDatePicker /*hide*/ );
        }
    };
    DateInput.prototype.getJsonTypeName = function() {
        return "Input.Date";
    };
    DateInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    DateInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = new Date(this.value);
        var result = true;
        if (this.min) {
            var minDate = new Date(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = new Date(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(DateInput.prototype, "value", {
        get: function() {
            return this._dateInputElement ? this._dateInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    DateInput.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "value");
    DateInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    DateInput.minProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "min");
    DateInput.maxProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "max");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.valueProperty)
    ], DateInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.minProperty)
    ], DateInput.prototype, "min", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.maxProperty)
    ], DateInput.prototype, "max", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DateInput.placeholderProperty)
    ], DateInput.prototype, "placeholder", void 0);
    return DateInput;
}($5104722604b983cb$var$Input);
module.exports.DateInput = $5104722604b983cb$var$DateInput;
var $5104722604b983cb$var$TimeProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TimeProperty, _super);
    function TimeProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, function(sender, prop, source, context) {
            var value = source[prop.name];
            if (typeof value === "string" && value && /^[0-9]{2}:[0-9]{2}$/.test(value)) return value;
            return undefined;
        }, function(sender, prop, target, value, context) {
            context.serializeValue(target, prop.name, value);
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    return TimeProperty;
}($5Ougt.CustomProperty);
module.exports.TimeProperty = $5104722604b983cb$var$TimeProperty;
var $5104722604b983cb$var$TimeInput = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TimeInput, _super);
    function TimeInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeInput.convertTimeStringToDate = function(timeString) {
        return new Date("1973-09-04T" + timeString + ":00Z");
    };
    TimeInput.prototype.internalRender = function() {
        var _this = this;
        this._timeInputElement = document.createElement("input");
        this._timeInputElement.setAttribute("type", "time");
        if (this.min) this._timeInputElement.setAttribute("min", this.min);
        if (this.max) this._timeInputElement.setAttribute("max", this.max);
        this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput");
        this._timeInputElement.style.width = "100%";
        this._timeInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.placeholder) {
            this._timeInputElement.placeholder = this.placeholder;
            this._timeInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue) this._timeInputElement.value = this.defaultValue;
        return this._timeInputElement;
    };
    TimeInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._timeInputElement && this.inputStyle === $gIXBn.InputStyle.RevealOnHover) {
            var hideTimePicker = this.shouldHideInputAdornersForRevealOnHover(this._timeInputElement, eventType);
            if (hideTimePicker) this._timeInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._timeInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $5104722604b983cb$var$updateInputAdornersVisibility(this._timeInputElement, hideTimePicker /*hide*/ );
        }
    };
    TimeInput.prototype.getJsonTypeName = function() {
        return "Input.Time";
    };
    TimeInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TimeInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = TimeInput.convertTimeStringToDate(this.value);
        var result = true;
        if (this.min) {
            var minDate = TimeInput.convertTimeStringToDate(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = TimeInput.convertTimeStringToDate(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(TimeInput.prototype, "value", {
        get: function() {
            return this._timeInputElement ? this._timeInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TimeInput.valueProperty = new $5104722604b983cb$var$TimeProperty($5Ougt.Versions.v1_0, "value");
    TimeInput.placeholderProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "placeholder");
    TimeInput.minProperty = new $5104722604b983cb$var$TimeProperty($5Ougt.Versions.v1_0, "min");
    TimeInput.maxProperty = new $5104722604b983cb$var$TimeProperty($5Ougt.Versions.v1_0, "max");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.valueProperty)
    ], TimeInput.prototype, "defaultValue", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.minProperty)
    ], TimeInput.prototype, "min", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.maxProperty)
    ], TimeInput.prototype, "max", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TimeInput.placeholderProperty)
    ], TimeInput.prototype, "placeholder", void 0);
    return TimeInput;
}($5104722604b983cb$var$Input);
module.exports.TimeInput = $5104722604b983cb$var$TimeInput;
var $5104722604b983cb$var$Action = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Action, _super);
    function Action() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = $gIXBn.ActionStyle.Default;
        _this.mode = $gIXBn.ActionMode.Primary;
        _this._state = 0 /* Normal */ ;
        _this._isFocusable = true;
        return _this;
    }
    //#endregion
    Action.prototype.renderButtonContent = function() {
        if (this.renderedElement) {
            // Cache hostConfig for perf
            var hostConfig = this.hostConfig;
            var titleElement = document.createElement("div");
            titleElement.style.overflow = "hidden";
            titleElement.style.textOverflow = "ellipsis";
            if (!(hostConfig.actions.iconPlacement === $gIXBn.ActionIconPlacement.AboveTitle || hostConfig.actions.allowTitleToWrap)) titleElement.style.whiteSpace = "nowrap";
            if (this.title) titleElement.innerText = this.title;
            if (!this.iconUrl) {
                this.renderedElement.classList.add("noIcon");
                this.renderedElement.appendChild(titleElement);
            } else {
                var iconElement = document.createElement("img");
                iconElement.src = this.iconUrl;
                iconElement.style.width = hostConfig.actions.iconSize + "px";
                iconElement.style.height = hostConfig.actions.iconSize + "px";
                iconElement.style.flex = "0 0 auto";
                if (hostConfig.actions.iconPlacement === $gIXBn.ActionIconPlacement.AboveTitle) {
                    this.renderedElement.classList.add("iconAbove");
                    this.renderedElement.style.flexDirection = "column";
                    if (this.title) iconElement.style.marginBottom = "6px";
                } else {
                    this.renderedElement.classList.add("iconLeft");
                    iconElement.style.maxHeight = "100%";
                    if (this.title) iconElement.style.marginRight = "6px";
                }
                this.renderedElement.appendChild(iconElement);
                this.renderedElement.appendChild(titleElement);
            }
        }
    };
    Action.prototype.getParentContainer = function() {
        if (this.parent instanceof $5104722604b983cb$var$Container) return this.parent;
        return this.parent ? this.parent.getParentContainer() : undefined;
    };
    Action.prototype.isDesignMode = function() {
        var rootElement = this.getRootObject();
        return rootElement instanceof $5104722604b983cb$var$CardElement && rootElement.isDesignMode();
    };
    Action.prototype.updateCssClasses = function() {
        var _a, _b;
        if (this.parent && this.renderedElement) {
            var hostConfig = this.parent.hostConfig;
            this.renderedElement.className = hostConfig.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
            var parentContainer = this.getParentContainer();
            if (parentContainer) {
                var parentContainerStyle = parentContainer.getEffectiveStyle();
                if (parentContainerStyle) this.renderedElement.classList.add("style-" + parentContainerStyle);
            }
            this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1;
            switch(this._state){
                case 0 /* Normal */ :
                    break;
                case 1 /* Expanded */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("expanded"));
                    break;
                case 2 /* Subdued */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("subdued"));
                    break;
            }
            if (this.style && this.isEffectivelyEnabled()) {
                if (this.style === $gIXBn.ActionStyle.Positive) (_a = this.renderedElement.classList).add.apply(_a, hostConfig.makeCssClassNames("primary", "style-positive"));
                else (_b = this.renderedElement.classList).add.apply(_b, hostConfig.makeCssClassNames("style-" + this.style.toLowerCase()));
            }
        }
    };
    Action.prototype.getDefaultSerializationContext = function() {
        return new $5104722604b983cb$var$SerializationContext();
    };
    Action.prototype.internalGetReferencedInputs = function() {
        return {};
    };
    Action.prototype.internalPrepareForExecution = function(_inputs) {
    // Do nothing in base implementation
    };
    Action.prototype.internalValidateInputs = function(referencedInputs) {
        var result = [];
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (!input.validateValue()) result.push(input);
        }
        return result;
    };
    Action.prototype.shouldSerialize = function(context) {
        return context.actionRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Action.prototype.raiseExecuteActionEvent = function() {
        if (this.onExecute) this.onExecute(this);
        $5104722604b983cb$var$raiseExecuteActionEvent(this);
    };
    Action.prototype.internalAfterExecute = function() {
        var rootObject = this.getRootObject();
        if (rootObject instanceof $5104722604b983cb$var$CardElement) rootObject.updateActionsEnabledState();
    };
    Action.prototype.getHref = function() {
        return "";
    };
    Action.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "button";
    };
    Action.prototype.getAriaRoleFromEnum = function() {
        switch(this.role){
            case $gIXBn.ActionRole.Button:
                return "button";
            case $gIXBn.ActionRole.Link:
                return "link";
            case $gIXBn.ActionRole.Menu:
                return "menu";
            case $gIXBn.ActionRole.MenuItem:
                return "menuitem";
            case $gIXBn.ActionRole.Tab:
                return "tab";
            default:
                return undefined;
        }
    };
    Action.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        element.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1;
        element.setAttribute("role", this.getAriaRole());
        if (element instanceof HTMLButtonElement) element.disabled = !this.isEffectivelyEnabled();
        if (!this.isEffectivelyEnabled()) element.setAttribute("aria-disabled", "true");
        else {
            element.removeAttribute("aria-disabled");
            element.classList.add(this.hostConfig.makeCssClassName("ac-selectable"));
        }
        if (this.title) {
            element.setAttribute("aria-label", this.title);
            element.title = this.title;
        } else {
            element.removeAttribute("aria-label");
            element.removeAttribute("title");
        }
        if (this.tooltip) {
            if (promoteTooltipToLabel && !this.title) element.setAttribute("aria-label", this.tooltip);
            element.title = this.tooltip;
        }
    };
    Action.prototype.parse = function(source, context) {
        return _super.prototype.parse.call(this, source, context ? context : new $5104722604b983cb$var$SerializationContext());
    };
    Action.prototype.render = function() {
        var _this = this;
        var buttonElement = document.createElement("button");
        buttonElement.type = "button";
        buttonElement.style.display = "flex";
        buttonElement.style.alignItems = "center";
        buttonElement.style.justifyContent = "center";
        buttonElement.onclick = function(e) {
            if (_this.isEffectivelyEnabled()) {
                e.preventDefault();
                e.cancelBubble = true;
                _this.execute();
            }
        };
        this._renderedElement = buttonElement;
        this.renderButtonContent();
        this.updateCssClasses();
        this.setupElementForAccessibility(buttonElement);
    };
    Action.prototype.execute = function() {
        if (this._actionCollection) this._actionCollection.actionExecuted(this);
        this.raiseExecuteActionEvent();
        this.internalAfterExecute();
    };
    Action.prototype.prepareForExecution = function() {
        var referencedInputs = this.getReferencedInputs();
        var invalidInputs = this.internalValidateInputs(referencedInputs);
        if (invalidInputs.length > 0) {
            invalidInputs[0].focus();
            return false;
        }
        this.internalPrepareForExecution(referencedInputs);
        return true;
    };
    Action.prototype.remove = function() {
        if (this._actionCollection) return this._actionCollection.removeAction(this);
        return false;
    };
    Action.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    Action.prototype.getAllActions = function() {
        return [
            this
        ];
    };
    Action.prototype.getResourceInformation = function() {
        return this.iconUrl ? [
            {
                url: this.iconUrl,
                mimeType: "image"
            }
        ] : [];
    };
    Action.prototype.getActionById = function(id) {
        return this.id === id ? this : undefined;
    };
    Action.prototype.getReferencedInputs = function() {
        return this.internalGetReferencedInputs();
    };
    /**
     * Validates the inputs associated with this action.
     *
     * @returns A list of inputs that failed validation, or an empty array if no input failed validation.
     */ Action.prototype.validateInputs = function() {
        return this.internalValidateInputs(this.getReferencedInputs());
    };
    Action.prototype.updateEnabledState = function() {
    // Do nothing in base implementation
    };
    Action.prototype.isEffectivelyEnabled = function() {
        return this.isEnabled;
    };
    Object.defineProperty(Action.prototype, "isPrimary", {
        get: function() {
            return this.style === $gIXBn.ActionStyle.Positive;
        },
        set: function(value) {
            if (value) this.style = $gIXBn.ActionStyle.Positive;
            else if (this.style === $gIXBn.ActionStyle.Positive) this.style = $gIXBn.ActionStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "hostConfig", {
        get: function() {
            return this.parent ? this.parent.hostConfig : $8kDQQ.defaultHostConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(value) {
            if (this._state !== value) {
                this._state = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "isFocusable", {
        get: function() {
            return this._isFocusable;
        },
        set: function(value) {
            if (this._isFocusable !== value) {
                this._isFocusable = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Action.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "title");
    Action.iconUrlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_1, "iconUrl");
    Action.styleProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_2, "style", [
        {
            value: $gIXBn.ActionStyle.Default
        },
        {
            value: $gIXBn.ActionStyle.Positive
        },
        {
            value: $gIXBn.ActionStyle.Destructive
        }
    ], $gIXBn.ActionStyle.Default);
    Action.modeProperty = new $5Ougt.ValueSetProperty($5Ougt.Versions.v1_5, "mode", [
        {
            value: $gIXBn.ActionMode.Primary
        },
        {
            value: $gIXBn.ActionMode.Secondary
        }
    ], $gIXBn.ActionMode.Primary);
    Action.tooltipProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_5, "tooltip");
    Action.isEnabledProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_5, "isEnabled", true);
    Action.roleProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "role", $gIXBn.ActionRole);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.titleProperty)
    ], Action.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.iconUrlProperty)
    ], Action.prototype, "iconUrl", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.styleProperty)
    ], Action.prototype, "style", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.modeProperty)
    ], Action.prototype, "mode", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.tooltipProperty)
    ], Action.prototype, "tooltip", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.isEnabledProperty)
    ], Action.prototype, "isEnabled", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Action.roleProperty)
    ], Action.prototype, "role", void 0);
    return Action;
}($dUjDB.CardObject);
module.exports.Action = $5104722604b983cb$var$Action;
var $5104722604b983cb$var$SubmitActionBase = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(SubmitActionBase, _super);
    function SubmitActionBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledUnlessAssociatedInputsChange = false;
        //#endregion
        _this._isPrepared = false;
        _this._areReferencedInputsDirty = false;
        return _this;
    }
    SubmitActionBase.prototype.internalGetReferencedInputs = function() {
        var result = {};
        if (this.associatedInputs !== "none") {
            var current = this.parent;
            var inputs = [];
            while(current){
                inputs.push.apply(inputs, current.getAllInputs(false));
                current = current.parent;
            }
            for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
                var input = inputs_1[_i];
                if (input.id) result[input.id] = input;
            }
        }
        return result;
    };
    SubmitActionBase.prototype.internalPrepareForExecution = function(inputs) {
        if (this._originalData) this._processedData = JSON.parse(JSON.stringify(this._originalData));
        else this._processedData = {};
        if (this._processedData && inputs) for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = inputs[key];
            if (input.id && input.isSet()) this._processedData[input.id] = typeof input.value === "string" ? input.value : input.value.toString();
        }
        this._isPrepared = true;
    };
    SubmitActionBase.prototype.internalAfterExecute = function() {
        if ($6BHj7.GlobalSettings.resetInputsDirtyStateAfterActionExecution) this.resetReferencedInputsDirtyState();
    };
    SubmitActionBase.prototype.resetReferencedInputsDirtyState = function() {
        var referencedInputs = this.getReferencedInputs();
        this._areReferencedInputsDirty = false;
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            input.resetDirtyState();
        }
    };
    SubmitActionBase.prototype.updateEnabledState = function() {
        this._areReferencedInputsDirty = false;
        var referencedInputs = this.getReferencedInputs();
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (input.isDirty()) {
                this._areReferencedInputsDirty = true;
                break;
            }
        }
        this.updateCssClasses();
        if (this._renderedElement) this.setupElementForAccessibility(this._renderedElement);
    };
    SubmitActionBase.prototype.isEffectivelyEnabled = function() {
        var result = _super.prototype.isEffectivelyEnabled.call(this);
        return this.disabledUnlessAssociatedInputsChange ? result && this._areReferencedInputsDirty : result;
    };
    Object.defineProperty(SubmitActionBase.prototype, "data", {
        get: function() {
            return this._isPrepared ? this._processedData : this._originalData;
        },
        set: function(value) {
            this._originalData = value;
            this._isPrepared = false;
        },
        enumerable: false,
        configurable: true
    });
    SubmitActionBase.dataProperty = new $5Ougt.PropertyDefinition($5Ougt.Versions.v1_0, "data");
    SubmitActionBase.associatedInputsProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_3, "associatedInputs", function(sender, prop, source, context) {
        var value = source[prop.name];
        if (value !== undefined && typeof value === "string") return value.toLowerCase() === "none" ? "none" : "auto";
        return undefined;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, value);
    });
    SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_6, "disabledUnlessAssociatedInputsChange", false);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(SubmitActionBase.dataProperty)
    ], SubmitActionBase.prototype, "_originalData", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(SubmitActionBase.associatedInputsProperty)
    ], SubmitActionBase.prototype, "associatedInputs", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty)
    ], SubmitActionBase.prototype, "disabledUnlessAssociatedInputsChange", void 0);
    return SubmitActionBase;
}($5104722604b983cb$var$Action);
module.exports.SubmitActionBase = $5104722604b983cb$var$SubmitActionBase;
var $5104722604b983cb$var$SubmitAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(SubmitAction, _super);
    function SubmitAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubmitAction.prototype.getJsonTypeName = function() {
        return SubmitAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    SubmitAction.JsonTypeName = "Action.Submit";
    return SubmitAction;
}($5104722604b983cb$var$SubmitActionBase);
module.exports.SubmitAction = $5104722604b983cb$var$SubmitAction;
var $5104722604b983cb$var$UniversalAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(UniversalAction, _super);
    function UniversalAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UniversalAction;
}($5104722604b983cb$var$SubmitActionBase);
module.exports.UniversalAction = $5104722604b983cb$var$UniversalAction;
var $5104722604b983cb$var$ExecuteAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ExecuteAction, _super);
    function ExecuteAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ExecuteAction.prototype.getJsonTypeName = function() {
        return ExecuteAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ExecuteAction.JsonTypeName = "Action.Execute";
    //#region Schema
    ExecuteAction.verbProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "verb");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ExecuteAction.verbProperty)
    ], ExecuteAction.prototype, "verb", void 0);
    return ExecuteAction;
}($5104722604b983cb$var$UniversalAction);
module.exports.ExecuteAction = $5104722604b983cb$var$ExecuteAction;
var $5104722604b983cb$var$DataQuery = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(DataQuery, _super);
    function DataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    DataQuery.prototype.getJsonTypeName = function() {
        return DataQuery.JsonTypeName;
    };
    Object.defineProperty(DataQuery.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    DataQuery.JsonTypeName = "Data.Query";
    //#region Schema
    DataQuery.datasetProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "dataset");
    DataQuery.filterProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_6, "filter");
    DataQuery.countProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "count");
    DataQuery.skipProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "skip");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.datasetProperty)
    ], DataQuery.prototype, "dataset", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.filterProperty)
    ], DataQuery.prototype, "filter", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.countProperty)
    ], DataQuery.prototype, "count", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(DataQuery.skipProperty)
    ], DataQuery.prototype, "skip", void 0);
    return DataQuery;
}($5104722604b983cb$var$UniversalAction);
module.exports.DataQuery = $5104722604b983cb$var$DataQuery;
var $5104722604b983cb$var$OpenUrlAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(OpenUrlAction, _super);
    function OpenUrlAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenUrlAction.prototype.getJsonTypeName = function() {
        return OpenUrlAction.JsonTypeName;
    };
    OpenUrlAction.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "link";
    };
    OpenUrlAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("url"));
    };
    OpenUrlAction.prototype.getHref = function() {
        return this.url;
    };
    //#region Schema
    OpenUrlAction.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "url");
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    OpenUrlAction.JsonTypeName = "Action.OpenUrl";
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(OpenUrlAction.urlProperty)
    ], OpenUrlAction.prototype, "url", void 0);
    return OpenUrlAction;
}($5104722604b983cb$var$Action);
module.exports.OpenUrlAction = $5104722604b983cb$var$OpenUrlAction;
var $5104722604b983cb$var$ToggleVisibilityAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ToggleVisibilityAction, _super);
    function ToggleVisibilityAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElements = {};
        return _this;
    }
    ToggleVisibilityAction.prototype.updateAriaControlsAttribute = function() {
        // apply aria labels to make it clear which elements this action will toggle
        if (this.targetElements) {
            var elementIds = Object.keys(this.targetElements);
            if (this._renderedElement) {
                if (elementIds.length > 0) this._renderedElement.setAttribute("aria-controls", elementIds.join(" "));
                else this._renderedElement.removeAttribute("aria-controls");
            }
        }
    };
    ToggleVisibilityAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.targetElements) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("targetElements"));
    };
    ToggleVisibilityAction.prototype.getJsonTypeName = function() {
        return ToggleVisibilityAction.JsonTypeName;
    };
    ToggleVisibilityAction.prototype.render = function() {
        _super.prototype.render.call(this);
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.execute = function() {
        _super.prototype.execute.call(this);
        if (this.parent) for(var _i = 0, _a = Object.keys(this.targetElements); _i < _a.length; _i++){
            var elementId = _a[_i];
            var targetElement = this.parent.getRootElement().getElementById(elementId);
            if (targetElement) {
                if (typeof this.targetElements[elementId] === "boolean") targetElement.isVisible = this.targetElements[elementId];
                else targetElement.isVisible = !targetElement.isVisible;
            }
        }
    };
    ToggleVisibilityAction.prototype.addTargetElement = function(elementId, isVisible) {
        if (isVisible === void 0) isVisible = undefined;
        this.targetElements[elementId] = isVisible;
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.removeTargetElement = function(elementId) {
        delete this.targetElements[elementId];
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.targetElementsProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_2, "targetElements", function(sender, prop, source, context) {
        var result = {};
        if (Array.isArray(source[prop.name])) for(var _i = 0, _a = source[prop.name]; _i < _a.length; _i++){
            var item = _a[_i];
            if (typeof item === "string") result[item] = undefined;
            else if (typeof item === "object") {
                var elementId = item["elementId"];
                if (typeof elementId === "string") result[elementId] = $F6YrP.parseBool(item["isVisible"]);
            }
        }
        return result;
    }, function(sender, prop, target, value, context) {
        var targetElements = [];
        for(var _i = 0, _a = Object.keys(value); _i < _a.length; _i++){
            var id = _a[_i];
            if (typeof value[id] === "boolean") targetElements.push({
                elementId: id,
                isVisible: value[id]
            });
            else targetElements.push(id);
        }
        context.serializeArray(target, prop.name, targetElements);
    }, {}, function(sender) {
        return {};
    });
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ToggleVisibilityAction.JsonTypeName = "Action.ToggleVisibility";
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ToggleVisibilityAction.targetElementsProperty)
    ], ToggleVisibilityAction.prototype, "targetElements", void 0);
    return ToggleVisibilityAction;
}($5104722604b983cb$var$Action);
module.exports.ToggleVisibilityAction = $5104722604b983cb$var$ToggleVisibilityAction;
var $5104722604b983cb$var$StringWithSubstitutionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(StringWithSubstitutionProperty, _super);
    function StringWithSubstitutionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined, function() {
            return new $6BHj7.StringWithSubstitutions();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    StringWithSubstitutionProperty.prototype.parse = function(sender, source, context) {
        var result = new $6BHj7.StringWithSubstitutions();
        result.set($F6YrP.parseString(source[this.name]));
        return result;
    };
    StringWithSubstitutionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value.getOriginal());
    };
    return StringWithSubstitutionProperty;
}($5Ougt.PropertyDefinition);
var $5104722604b983cb$var$HttpHeader = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(HttpHeader, _super);
    //#endregion
    function HttpHeader(name, value) {
        if (name === void 0) name = "";
        if (value === void 0) value = "";
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    HttpHeader.prototype.getSchemaKey = function() {
        return "HttpHeader";
    };
    HttpHeader.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        this._value.getReferencedInputs(inputs, referencedInputs);
    };
    HttpHeader.prototype.prepareForExecution = function(inputs) {
        this._value.substituteInputValues(inputs, $6BHj7.ContentTypes.applicationXWwwFormUrlencoded);
    };
    Object.defineProperty(HttpHeader.prototype, "value", {
        get: function() {
            return this._value.get();
        },
        set: function(newValue) {
            this._value.set(newValue);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    HttpHeader.nameProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "name");
    HttpHeader.valueProperty = new $5104722604b983cb$var$StringWithSubstitutionProperty($5Ougt.Versions.v1_0, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpHeader.nameProperty)
    ], HttpHeader.prototype, "name", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpHeader.valueProperty)
    ], HttpHeader.prototype, "_value", void 0);
    return HttpHeader;
}($5Ougt.SerializableObject);
module.exports.HttpHeader = $5104722604b983cb$var$HttpHeader;
var $5104722604b983cb$var$HttpAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(HttpAction, _super);
    function HttpAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ignoreInputValidation = false;
        return _this;
    }
    HttpAction.prototype.internalGetReferencedInputs = function() {
        var allInputs = this.parent ? this.parent.getRootElement().getAllInputs() : [];
        var result = {};
        this._url.getReferencedInputs(allInputs, result);
        for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            header.getReferencedInputs(allInputs, result);
        }
        this._body.getReferencedInputs(allInputs, result);
        return result;
    };
    HttpAction.prototype.internalPrepareForExecution = function(inputs) {
        if (inputs) {
            this._url.substituteInputValues(inputs, $6BHj7.ContentTypes.applicationXWwwFormUrlencoded);
            var contentType = $6BHj7.ContentTypes.applicationJson;
            for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
                var header = _a[_i];
                header.prepareForExecution(inputs);
                if (header.name && header.name.toLowerCase() === "content-type") contentType = header.value;
            }
            this._body.substituteInputValues(inputs, contentType);
        }
    };
    HttpAction.prototype.getJsonTypeName = function() {
        return HttpAction.JsonTypeName;
    };
    HttpAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("url"));
        if (this.headers.length > 0) for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            if (!header.name) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
    };
    Object.defineProperty(HttpAction.prototype, "ignoreInputValidation", {
        get: function() {
            return this._ignoreInputValidation;
        },
        set: function(value) {
            this._ignoreInputValidation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "url", {
        get: function() {
            return this._url.get();
        },
        set: function(value) {
            this._url.set(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "body", {
        get: function() {
            return this._body.get();
        },
        set: function(value) {
            this._body.set(value);
        },
        enumerable: false,
        configurable: true
    });
    HttpAction.urlProperty = new $5104722604b983cb$var$StringWithSubstitutionProperty($5Ougt.Versions.v1_0, "url");
    HttpAction.bodyProperty = new $5104722604b983cb$var$StringWithSubstitutionProperty($5Ougt.Versions.v1_0, "body");
    HttpAction.methodProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "method");
    HttpAction.headersProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_0, "headers", $5104722604b983cb$var$HttpHeader);
    HttpAction.ignoreInputValidationProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_3, "ignoreInputValidation", false);
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    HttpAction.JsonTypeName = "Action.Http";
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.urlProperty)
    ], HttpAction.prototype, "_url", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.bodyProperty)
    ], HttpAction.prototype, "_body", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.methodProperty)
    ], HttpAction.prototype, "method", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.headersProperty)
    ], HttpAction.prototype, "headers", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(HttpAction.ignoreInputValidationProperty)
    ], HttpAction.prototype, "_ignoreInputValidation", void 0);
    return HttpAction;
}($5104722604b983cb$var$Action);
module.exports.HttpAction = $5104722604b983cb$var$HttpAction;
var $5104722604b983cb$var$ShowCardAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ShowCardAction, _super);
    function ShowCardAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.card = new $5104722604b983cb$var$InlineAdaptiveCard();
        return _this;
    }
    ShowCardAction.prototype.updateCssClasses = function() {
        _super.prototype.updateCssClasses.call(this);
        if (this.renderedElement) {
            var effectiveHostConfig = this.parent ? this.parent.hostConfig : $8kDQQ.defaultHostConfig;
            this.renderedElement.classList.add(effectiveHostConfig.makeCssClassName("expandable"));
            this.renderedElement.setAttribute("aria-expanded", (this.state === 1 /* Expanded */ ).toString());
        }
    };
    ShowCardAction.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        var jsonCard = source["card"];
        if (jsonCard) this.card.parse(jsonCard, context);
        else context.logParseEvent(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.showCardMustHaveCard());
    };
    ShowCardAction.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this.card) context.serializeValue(target, "card", this.card.toJSON(context));
    };
    ShowCardAction.prototype.raiseExecuteActionEvent = function() {
        if (this.hostConfig.actions.showCard.actionMode === $gIXBn.ShowCardActionMode.Popup) // Only raise the event in Popup mode.
        _super.prototype.raiseExecuteActionEvent.call(this);
    };
    ShowCardAction.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.card.releaseDOMResources();
    };
    ShowCardAction.prototype.getJsonTypeName = function() {
        return ShowCardAction.JsonTypeName;
    };
    ShowCardAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this.card.internalValidateProperties(context);
    };
    ShowCardAction.prototype.setParent = function(value) {
        _super.prototype.setParent.call(this, value);
        this.card.setParent(value);
    };
    ShowCardAction.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return this.card.getAllInputs(processActions);
    };
    ShowCardAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this.card.getAllActions());
        return result;
    };
    ShowCardAction.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this.card.getResourceInformation());
        return result;
    };
    ShowCardAction.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) result = this.card.getActionById(id);
        return result;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ShowCardAction.JsonTypeName = "Action.ShowCard";
    return ShowCardAction;
}($5104722604b983cb$var$Action);
module.exports.ShowCardAction = $5104722604b983cb$var$ShowCardAction;
var $5104722604b983cb$var$OverflowAction = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(OverflowAction, _super);
    function OverflowAction(actions) {
        var _this = _super.call(this) || this;
        _this._actions = actions;
        _this.title = $24F6S.Strings.defaults.overflowButtonText();
        _this.tooltip = $24F6S.Strings.defaults.overflowButtonTooltip();
        return _this;
    }
    OverflowAction.prototype.getActions = function() {
        return this._actions;
    };
    OverflowAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this._actions);
        return result;
    };
    OverflowAction.prototype.getJsonTypeName = function() {
        return $5104722604b983cb$var$ShowCardAction.JsonTypeName;
    };
    OverflowAction.prototype.execute = function() {
        var _this = this;
        var _a;
        var shouldDisplayPopupMenu = !$5104722604b983cb$var$raiseDisplayOverflowActionMenuEvent(this, this.renderedElement);
        if (shouldDisplayPopupMenu && this.renderedElement) {
            var contextMenu_1 = new $iX2Kh.PopupMenu();
            contextMenu_1.hostConfig = this.hostConfig;
            var _loop_2 = function(i) {
                var menuItem = new $iX2Kh.MenuItem(i.toString(), (_a = this_1._actions[i].title) !== null && _a !== void 0 ? _a : "");
                menuItem.isEnabled = this_1._actions[i].isEnabled;
                menuItem.onClick = function() {
                    var actionToExecute = _this._actions[i];
                    contextMenu_1.closePopup(false);
                    if (actionToExecute.isEnabled) actionToExecute.execute();
                };
                contextMenu_1.items.add(menuItem);
            };
            var this_1 = this;
            for(var i = 0; i < this._actions.length; i++)_loop_2(i);
            contextMenu_1.onClose = function() {
                var _a;
                (_a = _this.renderedElement) === null || _a === void 0 || _a.setAttribute("aria-expanded", "false");
            };
            this.renderedElement.setAttribute("aria-expanded", "true");
            contextMenu_1.popup(this.renderedElement);
        }
    };
    OverflowAction.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        _super.prototype.setupElementForAccessibility.call(this, element, promoteTooltipToLabel);
        element.setAttribute("aria-label", $24F6S.Strings.defaults.overflowButtonTooltip());
        element.setAttribute("aria-expanded", "false");
    };
    OverflowAction.JsonTypeName = "Action.Overflow";
    return OverflowAction;
}($5104722604b983cb$var$Action);
var $5104722604b983cb$var$ActionCollection = /** @class */ function() {
    function ActionCollection(owner) {
        this._items = [];
        this._renderedActions = [];
        this._owner = owner;
    }
    ActionCollection.prototype.isActionAllowed = function(action) {
        var forbiddenTypes = this._owner.getForbiddenActionTypes();
        if (forbiddenTypes) for(var _i = 0, forbiddenTypes_1 = forbiddenTypes; _i < forbiddenTypes_1.length; _i++){
            var forbiddenType = forbiddenTypes_1[_i];
            if (action.constructor === forbiddenType) return false;
        }
        return true;
    };
    ActionCollection.prototype.refreshContainer = function() {
        $5104722604b983cb$var$clearElement(this._actionCardContainer);
        if (!this._actionCard) {
            this._actionCardContainer.style.marginTop = "0px";
            return;
        }
        this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
        var padding = this._owner.getEffectivePadding();
        this._owner.getImmediateSurroundingPadding(padding);
        var physicalPadding = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(padding);
        if (this._actionCard) {
            this._actionCard.style.paddingLeft = physicalPadding.left + "px";
            this._actionCard.style.paddingRight = physicalPadding.right + "px";
            this._actionCard.style.marginLeft = "-" + physicalPadding.left + "px";
            this._actionCard.style.marginRight = "-" + physicalPadding.right + "px";
            if (physicalPadding.bottom !== 0 && !this._owner.isDesignMode()) {
                this._actionCard.style.paddingBottom = physicalPadding.bottom + "px";
                this._actionCard.style.marginBottom = "-" + physicalPadding.bottom + "px";
            }
            $F6YrP.appendChild(this._actionCardContainer, this._actionCard);
        }
    };
    ActionCollection.prototype.layoutChanged = function() {
        this._owner.getRootElement().updateLayout();
    };
    ActionCollection.prototype.showActionCard = function(action, suppressStyle, raiseEvent) {
        if (suppressStyle === void 0) suppressStyle = false;
        if (raiseEvent === void 0) raiseEvent = true;
        action.card.suppressStyle = suppressStyle;
        // Always re-render a ShowCard action in design mode; reuse already rendered ShowCard (if available) otherwise
        var renderedCard = action.card.renderedElement && !this._owner.isDesignMode() ? action.card.renderedElement : action.card.render();
        this._actionCard = renderedCard;
        this._expandedAction = action;
        this.refreshContainer();
        if (raiseEvent) {
            this.layoutChanged();
            $5104722604b983cb$var$raiseInlineCardExpandedEvent(action, true);
        }
    };
    ActionCollection.prototype.collapseExpandedAction = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.state = 0 /* Normal */ ;
        }
        var previouslyExpandedAction = this._expandedAction;
        this._expandedAction = undefined;
        this._actionCard = undefined;
        this.refreshContainer();
        if (previouslyExpandedAction) {
            this.layoutChanged();
            $5104722604b983cb$var$raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
        }
    };
    ActionCollection.prototype.expandShowCardAction = function(action, raiseEvent) {
        var _this = this;
        var afterSelectedAction = false;
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            // Remove actions after selected action from tabOrder if the actions are oriented horizontally, to skip focus directly to expanded card
            if (this._owner.hostConfig.actions.actionsOrientation == $gIXBn.Orientation.Horizontal && afterSelectedAction) renderedAction.isFocusable = false;
            if (renderedAction !== action) renderedAction.state = 2 /* Subdued */ ;
            else {
                renderedAction.state = 1 /* Expanded */ ;
                afterSelectedAction = true;
                if (renderedAction.renderedElement) renderedAction.renderedElement.onblur = function(_e) {
                    for(var _i = 0, _a = _this._renderedActions; _i < _a.length; _i++){
                        var ra = _a[_i];
                        ra.isFocusable = true;
                    }
                };
            }
        }
        this.showActionCard(action, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), raiseEvent);
    };
    ActionCollection.prototype.releaseDOMResources = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.releaseDOMResources();
        }
    };
    ActionCollection.prototype.actionExecuted = function(action) {
        if (!(action instanceof $5104722604b983cb$var$ShowCardAction)) this.collapseExpandedAction();
        else {
            if (action === this._expandedAction) this.collapseExpandedAction();
            else if (this._owner.hostConfig.actions.showCard.actionMode === $gIXBn.ShowCardActionMode.Inline) this.expandShowCardAction(action, true);
        }
    };
    ActionCollection.prototype.parse = function(source, context) {
        this.clear();
        if (Array.isArray(source)) for(var _i = 0, source_1 = source; _i < source_1.length; _i++){
            var jsonAction = source_1[_i];
            var forbiddenActions = [];
            // If the action owner is a ContainerWithActions, we should check for forbidden actions
            if (this._owner instanceof $5104722604b983cb$var$ContainerWithActions) forbiddenActions = this._owner.getForbiddenActionNames();
            var action = context.parseAction(this._owner, jsonAction, forbiddenActions, !this._owner.isDesignMode());
            if (action) this.addAction(action);
        }
    };
    ActionCollection.prototype.toJSON = function(target, propertyName, context) {
        context.serializeArray(target, propertyName, this._items);
    };
    ActionCollection.prototype.getActionAt = function(id) {
        return this._items[id];
    };
    ActionCollection.prototype.getActionCount = function() {
        return this._items.length;
    };
    ActionCollection.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            result = item.getActionById(id);
            if (result) break;
        }
        return result;
    };
    ActionCollection.prototype.validateProperties = function(context) {
        if (this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions) context.addFailure(this._owner, $gIXBn.ValidationEvent.TooManyActions, $24F6S.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions));
        if (this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity) context.addFailure(this._owner, $gIXBn.ValidationEvent.InteractivityNotAllowed, $24F6S.Strings.errors.interactivityNotAllowed());
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (!this.isActionAllowed(item)) context.addFailure(this._owner, $gIXBn.ValidationEvent.ActionTypeNotAllowed, $24F6S.Strings.errors.actionTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
    };
    ActionCollection.prototype.render = function(orientation) {
        // Cache hostConfig for better perf
        var hostConfig = this._owner.hostConfig;
        if (!hostConfig.supportsInteractivity) return undefined;
        var element = document.createElement("div");
        var maxActions = hostConfig.actions.maxActions ? Math.min(hostConfig.actions.maxActions, this._items.length) : this._items.length;
        this._actionCardContainer = document.createElement("div");
        this._renderedActions = [];
        if (hostConfig.actions.preExpandSingleShowCardAction && maxActions === 1 && this._items[0] instanceof $5104722604b983cb$var$ShowCardAction && this.isActionAllowed(this._items[0])) {
            this.showActionCard(this._items[0], true);
            this._renderedActions.push(this._items[0]);
        } else {
            var buttonStrip = document.createElement("div");
            buttonStrip.className = hostConfig.makeCssClassName("ac-actionSet");
            buttonStrip.style.display = "flex";
            if (orientation === $gIXBn.Orientation.Horizontal) {
                buttonStrip.style.flexDirection = "row";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $gIXBn.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $gIXBn.HorizontalAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $gIXBn.HorizontalAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $gIXBn.ActionAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $gIXBn.ActionAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
            } else {
                buttonStrip.style.flexDirection = "column";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $gIXBn.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $gIXBn.HorizontalAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $gIXBn.HorizontalAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $gIXBn.ActionAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $gIXBn.ActionAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    case $gIXBn.ActionAlignment.Stretch:
                        buttonStrip.style.alignItems = "stretch";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
            }
            var allowedActions = this._items.filter(this.isActionAllowed.bind(this));
            var primaryActions_1 = [];
            var secondaryActions_1 = [];
            if (!this._owner.isDesignMode()) {
                allowedActions.forEach(function(action) {
                    return action.mode === $gIXBn.ActionMode.Secondary ? secondaryActions_1.push(action) : primaryActions_1.push(action);
                });
                // If primaryActions.length > maxActions, extra actions are moved to overflow
                var overflowPrimaryActions = primaryActions_1.splice(hostConfig.actions.maxActions);
                if ($6BHj7.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu) secondaryActions_1.push.apply(secondaryActions_1, overflowPrimaryActions);
                var shouldRenderOverflowActionButton = true;
                if (secondaryActions_1.length > 0) {
                    if (!this._overflowAction) {
                        this._overflowAction = new $5104722604b983cb$var$OverflowAction(secondaryActions_1);
                        this._overflowAction.setParent(this._owner);
                        this._overflowAction["_actionCollection"] = this;
                    }
                    var isRootAction = this._owner instanceof $5104722604b983cb$var$AdaptiveCard && !this._owner.parent;
                    shouldRenderOverflowActionButton = !$5104722604b983cb$var$raiseRenderOverflowActionsEvent(this._overflowAction, isRootAction);
                }
                if (this._overflowAction && shouldRenderOverflowActionButton) primaryActions_1.push(this._overflowAction);
            } else primaryActions_1 = allowedActions;
            for(var i = 0; i < primaryActions_1.length; i++){
                var action = primaryActions_1[i];
                action.render();
                if (action.renderedElement) {
                    if (hostConfig.actions.actionsOrientation === $gIXBn.Orientation.Horizontal && hostConfig.actions.actionAlignment === $gIXBn.ActionAlignment.Stretch) action.renderedElement.style.flex = "0 1 100%";
                    else action.renderedElement.style.flex = "0 1 auto";
                    buttonStrip.appendChild(action.renderedElement);
                    this._renderedActions.push(action);
                    if (i < primaryActions_1.length - 1 && hostConfig.actions.buttonSpacing > 0) {
                        var spacer = document.createElement("div");
                        if (orientation === $gIXBn.Orientation.Horizontal) {
                            spacer.style.flex = "0 0 auto";
                            spacer.style.width = hostConfig.actions.buttonSpacing + "px";
                        } else spacer.style.height = hostConfig.actions.buttonSpacing + "px";
                        $F6YrP.appendChild(buttonStrip, spacer);
                    }
                }
            }
            var buttonStripContainer = document.createElement("div");
            buttonStripContainer.style.overflow = "hidden";
            buttonStripContainer.appendChild(buttonStrip);
            $F6YrP.appendChild(element, buttonStripContainer);
        }
        $F6YrP.appendChild(element, this._actionCardContainer);
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            if (renderedAction.state === 1 /* Expanded */ ) {
                this.expandShowCardAction(renderedAction, false);
                break;
            }
        }
        return this._renderedActions.length > 0 ? element : undefined;
    };
    ActionCollection.prototype.addAction = function(action) {
        if (!action) throw new Error("The action parameter cannot be null.");
        if ((!action.parent || action.parent === this._owner) && this._items.indexOf(action) < 0) {
            this._items.push(action);
            if (!action.parent) action.setParent(this._owner);
            action["_actionCollection"] = this;
        } else throw new Error($24F6S.Strings.errors.actionAlreadyParented());
    };
    ActionCollection.prototype.removeAction = function(action) {
        if (this.expandedAction && this._expandedAction === action) this.collapseExpandedAction();
        var actionIndex = this._items.indexOf(action);
        if (actionIndex >= 0) {
            this._items.splice(actionIndex, 1);
            action.setParent(undefined);
            action["_actionCollection"] = undefined;
            for(var i = 0; i < this._renderedActions.length; i++)if (this._renderedActions[i] === action) {
                this._renderedActions.splice(i, 1);
                break;
            }
            return true;
        }
        return false;
    };
    ActionCollection.prototype.clear = function() {
        this._items = [];
        this._renderedActions = [];
        this._expandedAction = undefined;
    };
    ActionCollection.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        if (processActions) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getAllInputs());
        }
        return result;
    };
    ActionCollection.prototype.getResourceInformation = function() {
        var result = [];
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getResourceInformation());
        }
        return result;
    };
    Object.defineProperty(ActionCollection.prototype, "renderedActionCount", {
        get: function() {
            return this._renderedActions.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionCollection.prototype, "expandedAction", {
        get: function() {
            return this._expandedAction;
        },
        enumerable: false,
        configurable: true
    });
    return ActionCollection;
}();
var $5104722604b983cb$var$ActionSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ActionSet, _super);
    function ActionSet() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $5104722604b983cb$var$ActionCollection(_this);
        return _this;
    }
    ActionSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._actionCollection.parse(source["actions"], context);
    };
    ActionSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ActionSet.prototype.internalRender = function() {
        return this._actionCollection.render(this.orientation !== undefined ? this.orientation : this.hostConfig.actions.actionsOrientation);
    };
    ActionSet.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ActionSet.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ActionSet.prototype.getJsonTypeName = function() {
        return "ActionSet";
    };
    ActionSet.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ActionSet.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ActionSet.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ActionSet.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    ActionSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this._actionCollection.validateProperties(context);
    };
    ActionSet.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ActionSet.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return processActions ? this._actionCollection.getAllInputs() : [];
    };
    ActionSet.prototype.getResourceInformation = function() {
        return this._actionCollection.getResourceInformation();
    };
    /**
     * @inheritdoc
     */ ActionSet.prototype.findDOMNodeOwner = function(node) {
        var target = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) {
                // recur through each Action
                target = action.findDOMNodeOwner(node);
                if (target) return target;
            }
        }
        // if not found in any Action, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    ActionSet.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ActionSet.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    ActionSet.orientationProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_1, "orientation", $gIXBn.Orientation);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ActionSet.orientationProperty)
    ], ActionSet.prototype, "orientation", void 0);
    return ActionSet;
}($5104722604b983cb$var$CardElement);
module.exports.ActionSet = $5104722604b983cb$var$ActionSet;
var $5104722604b983cb$var$ContainerStyleProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContainerStyleProperty, _super);
    function ContainerStyleProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, [
            {
                value: $gIXBn.ContainerStyle.Default
            },
            {
                value: $gIXBn.ContainerStyle.Emphasis
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Accent
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Good
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Attention
            },
            {
                targetVersion: $5Ougt.Versions.v1_2,
                value: $gIXBn.ContainerStyle.Warning
            }
        ], defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    return ContainerStyleProperty;
}($5Ougt.ValueSetProperty);
module.exports.ContainerStyleProperty = $5104722604b983cb$var$ContainerStyleProperty;
var $5104722604b983cb$var$StylableCardElementContainer = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(StylableCardElementContainer, _super);
    function StylableCardElementContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StylableCardElementContainer.prototype, "style", {
        get: function() {
            if (this.allowCustomStyle) {
                var style = this.getValue(StylableCardElementContainer.styleProperty);
                if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            }
            return undefined;
        },
        set: function(value) {
            this.setValue(StylableCardElementContainer.styleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "allowCustomStyle", {
        //#endregion
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "hasExplicitStyle", {
        get: function() {
            return this.getValue(StylableCardElementContainer.styleProperty) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    StylableCardElementContainer.prototype.applyBorder = function() {
    // No border in base implementation
    };
    StylableCardElementContainer.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = $F6YrP.stringToCssColor(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    StylableCardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $6BHj7.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        if (this.isBleeding()) {
            // Bleed into the first parent that does have padding
            var padding = new $6BHj7.PaddingDefinition();
            this.getImmediateSurroundingPadding(padding);
            var surroundingPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
            this.renderedElement.style.marginRight = "-" + surroundingPadding.right + "px";
            this.renderedElement.style.marginLeft = "-" + surroundingPadding.left + "px";
            if (!this.isDesignMode()) {
                this.renderedElement.style.marginTop = "-" + surroundingPadding.top + "px";
                this.renderedElement.style.marginBottom = "-" + surroundingPadding.bottom + "px";
            }
            if (this.separatorElement && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
                this.separatorElement.style.marginLeft = "-" + surroundingPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + surroundingPadding.right + "px";
            }
        } else {
            this.renderedElement.style.marginRight = "0";
            this.renderedElement.style.marginLeft = "0";
            this.renderedElement.style.marginTop = "0";
            this.renderedElement.style.marginBottom = "0";
            if (this.separatorElement && this.separatorOrientation === $gIXBn.Orientation.Horizontal) {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    StylableCardElementContainer.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var currentElement = this.parent;
        while(currentElement){
            var currentElementHasBackgroundImage = false;
            if (ignoreBackgroundImages) currentElementHasBackgroundImage = false;
            else currentElementHasBackgroundImage = currentElement instanceof $5104722604b983cb$var$Container ? currentElement.backgroundImage.isValid() : false;
            if (currentElement instanceof StylableCardElementContainer) {
                if (this.hasExplicitStyle && (currentElement.getEffectiveStyle() !== this.getEffectiveStyle() || currentElementHasBackgroundImage)) return true;
            }
            currentElement = currentElement.parent;
        }
        return false;
    };
    StylableCardElementContainer.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $6BHj7.PaddingDefinition($gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding) : _super.prototype.getDefaultPadding.call(this);
    };
    StylableCardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var explicitStyle = this.getValue(StylableCardElementContainer.styleProperty);
        if (explicitStyle !== undefined) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(explicitStyle);
            if (!styleDefinition) context.addFailure(this, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidPropertyValue(explicitStyle, "style"));
        }
    };
    StylableCardElementContainer.prototype.render = function() {
        var renderedElement = _super.prototype.render.call(this);
        if (renderedElement && this.getHasBackground()) this.applyBackground();
        this.applyBorder();
        return renderedElement;
    };
    StylableCardElementContainer.prototype.getEffectiveStyle = function() {
        var effectiveStyle = this.style;
        return effectiveStyle ? effectiveStyle : _super.prototype.getEffectiveStyle.call(this);
    };
    //#region Schema
    StylableCardElementContainer.styleProperty = new $5104722604b983cb$var$ContainerStyleProperty($5Ougt.Versions.v1_0, "style");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(StylableCardElementContainer.styleProperty)
    ], StylableCardElementContainer.prototype, "style", null);
    return StylableCardElementContainer;
}($5104722604b983cb$var$CardElementContainer);
module.exports.StylableCardElementContainer = $5104722604b983cb$var$StylableCardElementContainer;
var $5104722604b983cb$var$ContainerBase = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContainerBase, _super);
    function ContainerBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._bleed = false;
        return _this;
    }
    //#endregion
    ContainerBase.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
    };
    ContainerBase.prototype.getHasExpandedAction = function() {
        return false;
    };
    ContainerBase.prototype.getBleed = function() {
        return this._bleed;
    };
    ContainerBase.prototype.setBleed = function(value) {
        this._bleed = value;
    };
    Object.defineProperty(ContainerBase.prototype, "renderedActionCount", {
        get: function() {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    ContainerBase.prototype.isBleeding = function() {
        return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
    };
    ContainerBase.bleedProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_2, "bleed", false);
    ContainerBase.minHeightProperty = new $5Ougt.PixelSizeProperty($5Ougt.Versions.v1_2, "minHeight");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContainerBase.bleedProperty)
    ], ContainerBase.prototype, "_bleed", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(ContainerBase.minHeightProperty)
    ], ContainerBase.prototype, "minPixelHeight", void 0);
    return ContainerBase;
}($5104722604b983cb$var$StylableCardElementContainer);
module.exports.ContainerBase = $5104722604b983cb$var$ContainerBase;
var $5104722604b983cb$var$BackgroundImage = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(BackgroundImage, _super);
    function BackgroundImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    BackgroundImage.prototype.getSchemaKey = function() {
        return "BackgroundImage";
    };
    BackgroundImage.prototype.internalParse = function(source, context) {
        if (typeof source === "string") {
            this.resetDefaultValues();
            this.url = source;
        } else return _super.prototype.internalParse.call(this, source, context);
    };
    BackgroundImage.prototype.apply = function(element) {
        if (this.url && element.renderedElement) {
            element.renderedElement.style.backgroundImage = "url('" + element.preProcessPropertyValue(BackgroundImage.urlProperty, this.url) + "')";
            switch(this.fillMode){
                case $gIXBn.FillMode.Repeat:
                    element.renderedElement.style.backgroundRepeat = "repeat";
                    break;
                case $gIXBn.FillMode.RepeatHorizontally:
                    element.renderedElement.style.backgroundRepeat = "repeat-x";
                    break;
                case $gIXBn.FillMode.RepeatVertically:
                    element.renderedElement.style.backgroundRepeat = "repeat-y";
                    break;
                case $gIXBn.FillMode.Cover:
                default:
                    element.renderedElement.style.backgroundRepeat = "no-repeat";
                    element.renderedElement.style.backgroundSize = "cover";
                    break;
            }
            switch(this.horizontalAlignment){
                case $gIXBn.HorizontalAlignment.Left:
                    break;
                case $gIXBn.HorizontalAlignment.Center:
                    element.renderedElement.style.backgroundPositionX = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.renderedElement.style.backgroundPositionX = "right";
                    break;
            }
            switch(this.verticalAlignment){
                case $gIXBn.VerticalAlignment.Top:
                    break;
                case $gIXBn.VerticalAlignment.Center:
                    element.renderedElement.style.backgroundPositionY = "center";
                    break;
                case $gIXBn.VerticalAlignment.Bottom:
                    element.renderedElement.style.backgroundPositionY = "bottom";
                    break;
            }
        }
    };
    BackgroundImage.prototype.isValid = function() {
        return this.url ? true : false;
    };
    //#region Schema
    BackgroundImage.urlProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "url");
    BackgroundImage.fillModeProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "fillMode", $gIXBn.FillMode, $gIXBn.FillMode.Cover);
    BackgroundImage.horizontalAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "horizontalAlignment", $gIXBn.HorizontalAlignment, $gIXBn.HorizontalAlignment.Left);
    BackgroundImage.verticalAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_2, "verticalAlignment", $gIXBn.VerticalAlignment, $gIXBn.VerticalAlignment.Top);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.urlProperty)
    ], BackgroundImage.prototype, "url", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.fillModeProperty)
    ], BackgroundImage.prototype, "fillMode", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.horizontalAlignmentProperty)
    ], BackgroundImage.prototype, "horizontalAlignment", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(BackgroundImage.verticalAlignmentProperty)
    ], BackgroundImage.prototype, "verticalAlignment", void 0);
    return BackgroundImage;
}($5Ougt.SerializableObject);
module.exports.BackgroundImage = $5104722604b983cb$var$BackgroundImage;
var $5104722604b983cb$var$Container = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._items = [];
        _this._renderedItems = [];
        return _this;
    }
    Object.defineProperty(Container.prototype, "backgroundImage", {
        get: function() {
            return this.getValue(Container.backgroundImageProperty);
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.insertItemAt = function(item, index, forceInsert) {
        if (!item.parent || forceInsert) {
            if (item.isStandalone) {
                if (index < 0 || index >= this._items.length) this._items.push(item);
                else this._items.splice(index, 0, item);
                item.setParent(this);
            } else throw new Error($24F6S.Strings.errors.elementTypeNotStandalone(item.getJsonTypeName()));
        } else throw new Error($24F6S.Strings.errors.elementAlreadyParented());
    };
    Container.prototype.getItemsCollectionPropertyName = function() {
        return "items";
    };
    Container.prototype.applyBackground = function() {
        if (this.backgroundImage.isValid() && this.renderedElement) this.backgroundImage.apply(this);
        _super.prototype.applyBackground.call(this);
    };
    Container.prototype.applyRTL = function(element) {
        if (this.rtl !== undefined) element.dir = this.rtl ? "rtl" : "ltr";
    };
    Container.prototype.internalRender = function() {
        this._renderedItems = [];
        // Cache hostConfig to avoid walking the parent hierarchy several times
        var hostConfig = this.hostConfig;
        var element = document.createElement("div");
        this.applyRTL(element);
        element.classList.add(hostConfig.makeCssClassName("ac-container"));
        element.style.display = "flex";
        element.style.flexDirection = "column";
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        element.style.minHeight = "-webkit-min-content";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $gIXBn.VerticalAlignment.Center:
                element.style.justifyContent = "center";
                break;
            case $gIXBn.VerticalAlignment.Bottom:
                element.style.justifyContent = "flex-end";
                break;
            default:
                element.style.justifyContent = "flex-start";
                break;
        }
        if (this._items.length > 0) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            var renderedItem = this.isElementAllowed(item) ? item.render() : undefined;
            if (renderedItem) {
                if (this._renderedItems.length > 0 && item.separatorElement) {
                    item.separatorElement.style.flex = "0 0 auto";
                    $F6YrP.appendChild(element, item.separatorElement);
                }
                $F6YrP.appendChild(element, renderedItem);
                this._renderedItems.push(item);
            }
        }
        else if (this.isDesignMode()) {
            var placeholderElement = this.createPlaceholderElement();
            placeholderElement.style.width = "100%";
            placeholderElement.style.height = "100%";
            element.appendChild(placeholderElement);
        }
        return element;
    };
    Container.prototype.truncateOverflow = function(maxHeight) {
        if (this.renderedElement) {
            // Add 1 to account for rounding differences between browsers
            var boundary_1 = this.renderedElement.offsetTop + maxHeight + 1;
            var handleElement_1 = function(cardElement) {
                var elt = cardElement.renderedElement;
                if (elt) switch($F6YrP.getFitStatus(elt, boundary_1)){
                    case $gIXBn.ContainerFitStatus.FullyInContainer:
                        var sizeChanged = cardElement["resetOverflow"]();
                        // If the element's size changed after resetting content,
                        // we have to check if it still fits fully in the card
                        if (sizeChanged) handleElement_1(cardElement);
                        break;
                    case $gIXBn.ContainerFitStatus.Overflowing:
                        var containerMaxHeight = boundary_1 - elt.offsetTop;
                        cardElement["handleOverflow"](containerMaxHeight);
                        break;
                    case $gIXBn.ContainerFitStatus.FullyOutOfContainer:
                        cardElement["handleOverflow"](0);
                        break;
                }
            };
            for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                handleElement_1(item);
            }
            return true;
        }
        return false;
    };
    Container.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            item["resetOverflow"]();
        }
    };
    Container.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var result = ignoreBackgroundImages ? false : this.backgroundImage.isValid();
        return result || _super.prototype.getHasBackground.call(this, ignoreBackgroundImages);
    };
    Container.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.clear();
        this.setShouldFallback(false);
        var jsonItems = source[this.getItemsCollectionPropertyName()];
        if (Array.isArray(jsonItems)) for(var _i = 0, jsonItems_1 = jsonItems; _i < jsonItems_1.length; _i++){
            var item = jsonItems_1[_i];
            var element = context.parseElement(this, item, this.forbiddenChildElements(), !this.isDesignMode());
            if (element) this.insertItemAt(element, -1, true);
        }
    };
    Container.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        var collectionPropertyName = this.getItemsCollectionPropertyName();
        context.serializeArray(target, collectionPropertyName, this._items);
    };
    Object.defineProperty(Container.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.getEffectivePadding = function() {
        if ($6BHj7.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(true)) return new $6BHj7.PaddingDefinition();
        return _super.prototype.getEffectivePadding.call(this);
    };
    Container.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        var parentContainer = this.getParentContainer();
        return parentContainer ? parentContainer.getEffectiveVerticalContentAlignment() : $gIXBn.VerticalAlignment.Top;
    };
    Container.prototype.getItemCount = function() {
        return this._items.length;
    };
    Container.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    Container.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var _i = 0, _a = this._renderedItems; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible) return item;
        }
        return undefined;
    };
    Container.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var i = this._renderedItems.length - 1; i >= 0; i--){
            if (this._renderedItems[i].isVisible) return this._renderedItems[i];
        }
        return undefined;
    };
    Container.prototype.getJsonTypeName = function() {
        return "Container";
    };
    Container.prototype.isFirstElement = function(element) {
        var designMode = this.isDesignMode();
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible || designMode) return item === element;
        }
        return false;
    };
    Container.prototype.isLastElement = function(element) {
        var designMode = this.isDesignMode();
        for(var i = this._items.length - 1; i >= 0; i--){
            if (this._items[i].isVisible || designMode) return this._items[i] === element;
        }
        return false;
    };
    Container.prototype.isRtl = function() {
        if (this.rtl !== undefined) return this.rtl;
        else {
            var parentContainer = this.getParentContainer();
            return parentContainer ? parentContainer.isRtl() : false;
        }
    };
    Container.prototype.isBleedingAtTop = function() {
        var firstRenderedItem = this.getFirstVisibleRenderedItem();
        return this.isBleeding() || (firstRenderedItem ? firstRenderedItem.isBleedingAtTop() : false);
    };
    Container.prototype.isBleedingAtBottom = function() {
        var lastRenderedItem = this.getLastVisibleRenderedItem();
        return this.isBleeding() || (lastRenderedItem ? lastRenderedItem.isBleedingAtBottom() && lastRenderedItem.getEffectiveStyle() === this.getEffectiveStyle() : false);
    };
    Container.prototype.indexOf = function(cardElement) {
        return this._items.indexOf(cardElement);
    };
    Container.prototype.addItem = function(item) {
        this.insertItemAt(item, -1, false);
    };
    Container.prototype.insertItemBefore = function(item, insertBefore) {
        this.insertItemAt(item, this._items.indexOf(insertBefore), false);
    };
    Container.prototype.insertItemAfter = function(item, insertAfter) {
        this.insertItemAt(item, this._items.indexOf(insertAfter) + 1, false);
    };
    Container.prototype.removeItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    Container.prototype.clear = function() {
        this._items = [];
        this._renderedItems = [];
    };
    Container.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        if (this.backgroundImage.isValid()) result.push({
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
            url: this.backgroundImage.url,
            mimeType: "image"
        });
        return result;
    };
    Container.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) {
            if (this.selectAction) result = this.selectAction.getActionById(id);
            if (!result) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                result = item.getActionById(id);
                if (result) break;
            }
        }
        return result;
    };
    Object.defineProperty(Container.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Container.backgroundImageProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_0, "backgroundImage", $5104722604b983cb$var$BackgroundImage);
    Container.verticalContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_1, "verticalContentAlignment", $gIXBn.VerticalAlignment);
    Container.rtlProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_0, "rtl");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Container.backgroundImageProperty)
    ], Container.prototype, "backgroundImage", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Container.verticalContentAlignmentProperty)
    ], Container.prototype, "verticalContentAlignment", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Container.rtlProperty)
    ], Container.prototype, "rtl", void 0);
    return Container;
}($5104722604b983cb$var$ContainerBase);
module.exports.Container = $5104722604b983cb$var$Container;
var $5104722604b983cb$var$Column = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Column, _super);
    function Column(width) {
        if (width === void 0) width = "stretch";
        var _this = _super.call(this) || this;
        _this.width = "stretch";
        //#endregion
        _this._computedWeight = 0;
        _this.width = width;
        return _this;
    }
    Column.prototype.adjustRenderedElementSize = function(renderedElement) {
        var minDesignTimeColumnHeight = 20;
        if (this.isDesignMode()) {
            renderedElement.style.minWidth = "20px";
            renderedElement.style.minHeight = (!this.minPixelHeight ? minDesignTimeColumnHeight : Math.max(this.minPixelHeight, minDesignTimeColumnHeight)) + "px";
        } else {
            renderedElement.style.minWidth = "0";
            if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
        }
        if (this.width === "auto") renderedElement.style.flex = "0 1 auto";
        else if (this.width === "stretch") renderedElement.style.flex = "1 1 50px";
        else if (this.width instanceof $6BHj7.SizeAndUnit) {
            if (this.width.unit === $gIXBn.SizeUnit.Pixel) {
                renderedElement.style.flex = "0 0 auto";
                renderedElement.style.width = this.width.physicalSize + "px";
            } else renderedElement.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%";
        }
    };
    Column.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(Column.prototype, "separatorOrientation", {
        get: function() {
            return $gIXBn.Orientation.Vertical;
        },
        enumerable: false,
        configurable: true
    });
    Column.prototype.getJsonTypeName = function() {
        return "Column";
    };
    Object.defineProperty(Column.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.parent instanceof $5104722604b983cb$var$ColumnSet) return this.separatorElement !== undefined && !this.parent.isLeftMostElement(this);
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Column.widthProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_0, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $6BHj7.SizeAndUnit(value, $gIXBn.SizeUnit.Weight);
        else if (value === "auto" || value === "stretch") result = value;
        else if (typeof value === "string") try {
            result = $6BHj7.SizeAndUnit.parse(value);
            if (result.unit === $gIXBn.SizeUnit.Pixel && prop.targetVersion.compareTo(context.targetVersion) > 0) invalidWidth = true;
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) {
            context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidColumnWidth(value));
            result = "auto";
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $6BHj7.SizeAndUnit) {
            if (value.unit === $gIXBn.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
            else context.serializeNumber(target, "width", value.physicalSize);
        } else context.serializeValue(target, "width", value);
    }, "stretch");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Column.widthProperty)
    ], Column.prototype, "width", void 0);
    return Column;
}($5104722604b983cb$var$Container);
module.exports.Column = $5104722604b983cb$var$Column;
var $5104722604b983cb$var$ColumnSet = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ColumnSet, _super);
    function ColumnSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        return _this;
    }
    ColumnSet.prototype.createColumnInstance = function(source, context) {
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "Column" ? new $5104722604b983cb$var$Column() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    ColumnSet.prototype.internalRender = function() {
        this._renderedColumns = [];
        if (this._columns.length > 0) {
            // Cache hostConfig to avoid walking the parent hierarchy several times
            var hostConfig = this.hostConfig;
            var element = document.createElement("div");
            element.className = hostConfig.makeCssClassName("ac-columnSet");
            element.style.display = "flex";
            if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) // See comment in Container.internalRender()
            element.style.minHeight = "-webkit-min-content";
            switch(this.getEffectiveHorizontalAlignment()){
                case $gIXBn.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $gIXBn.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var totalWeight = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width instanceof $6BHj7.SizeAndUnit && column.width.unit === $gIXBn.SizeUnit.Weight) totalWeight += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width instanceof $6BHj7.SizeAndUnit && column.width.unit === $gIXBn.SizeUnit.Weight && totalWeight > 0) {
                    var computedWeight = 100 / totalWeight * column.width.physicalSize;
                    // Best way to emulate "internal" access I know of
                    column["_computedWeight"] = computedWeight;
                }
                var renderedColumn = column.render();
                if (renderedColumn) {
                    if (this._renderedColumns.length > 0 && column.separatorElement) {
                        column.separatorElement.style.flex = "0 0 auto";
                        $F6YrP.appendChild(element, column.separatorElement);
                    }
                    $F6YrP.appendChild(element, renderedColumn);
                    this._renderedColumns.push(column);
                }
            }
            return this._renderedColumns.length > 0 ? element : undefined;
        } else return undefined;
    };
    ColumnSet.prototype.truncateOverflow = function(maxHeight) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["handleOverflow"](maxHeight);
        }
        return true;
    };
    ColumnSet.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["resetOverflow"]();
        }
    };
    Object.defineProperty(ColumnSet.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ColumnSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._columns = [];
        this._renderedColumns = [];
        var jsonColumns = source["columns"];
        if (Array.isArray(jsonColumns)) for(var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++){
            var item = jsonColumns_1[_i];
            var column = this.createColumnInstance(item, context);
            if (column) this._columns.push(column);
        }
    };
    ColumnSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "columns", this._columns);
    };
    ColumnSet.prototype.isFirstElement = function(element) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isVisible) return column === element;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtTop = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtTop()) return true;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtBottom = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtBottom()) return true;
        }
        return false;
    };
    ColumnSet.prototype.getItemCount = function() {
        return this._columns.length;
    };
    ColumnSet.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[0];
        else return undefined;
    };
    ColumnSet.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[this._renderedColumns.length - 1];
        else return undefined;
    };
    ColumnSet.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    ColumnSet.prototype.getItemAt = function(index) {
        return this.getColumnAt(index);
    };
    ColumnSet.prototype.getJsonTypeName = function() {
        return "ColumnSet";
    };
    ColumnSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var weightedColumns = 0;
        var stretchedColumns = 0;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (typeof column.width === "number") weightedColumns++;
            else if (column.width === "stretch") stretchedColumns++;
        }
        if (weightedColumns > 0 && stretchedColumns > 0) context.addFailure(this, $gIXBn.ValidationEvent.Hint, $24F6S.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    };
    ColumnSet.prototype.addColumn = function(column) {
        if (!column.parent) {
            this._columns.push(column);
            column.setParent(this);
        } else throw new Error($24F6S.Strings.errors.columnAlreadyBelongsToAnotherSet());
    };
    ColumnSet.prototype.removeItem = function(item) {
        if (item instanceof $5104722604b983cb$var$Column) {
            var itemIndex = this._columns.indexOf(item);
            if (itemIndex >= 0) {
                this._columns.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ColumnSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $5104722604b983cb$var$Column ? this._columns.indexOf(cardElement) : -1;
    };
    ColumnSet.prototype.isLeftMostElement = function(element) {
        return this._columns.indexOf(element) === 0;
    };
    ColumnSet.prototype.isRightMostElement = function(element) {
        return this._columns.indexOf(element) === this._columns.length - 1;
    };
    ColumnSet.prototype.isTopElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.isBottomElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            result = column.getActionById(id);
            if (result) break;
        }
        return result;
    };
    Object.defineProperty(ColumnSet.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColumnSet;
}($5104722604b983cb$var$ContainerBase);
module.exports.ColumnSet = $5104722604b983cb$var$ColumnSet;
function $5104722604b983cb$var$raiseImageLoadedEvent(image) {
    var card = image.getRootElement();
    var onImageLoadedHandler = card && card.onImageLoaded ? card.onImageLoaded : $5104722604b983cb$var$AdaptiveCard.onImageLoaded;
    if (onImageLoadedHandler) onImageLoadedHandler(image);
}
function $5104722604b983cb$var$raiseAnchorClickedEvent(element, anchor, ev) {
    var card = element.getRootElement();
    var onAnchorClickedHandler = card && card.onAnchorClicked ? card.onAnchorClicked : $5104722604b983cb$var$AdaptiveCard.onAnchorClicked;
    return onAnchorClickedHandler !== undefined ? onAnchorClickedHandler(element, anchor, ev) : false;
}
function $5104722604b983cb$var$raiseExecuteActionEvent(action) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onExecuteActionHandler = card && card.onExecuteAction ? card.onExecuteAction : $5104722604b983cb$var$AdaptiveCard.onExecuteAction;
    if (action.prepareForExecution() && onExecuteActionHandler) onExecuteActionHandler(action);
}
function $5104722604b983cb$var$raiseInlineCardExpandedEvent(action, isExpanded) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onInlineCardExpandedHandler = card && card.onInlineCardExpanded ? card.onInlineCardExpanded : $5104722604b983cb$var$AdaptiveCard.onInlineCardExpanded;
    if (onInlineCardExpandedHandler) onInlineCardExpandedHandler(action, isExpanded);
}
function $5104722604b983cb$var$raiseInputValueChangedEvent(input) {
    var card = input.getRootElement();
    var onInputValueChangedHandler = card && card.onInputValueChanged ? card.onInputValueChanged : $5104722604b983cb$var$AdaptiveCard.onInputValueChanged;
    if (onInputValueChangedHandler) onInputValueChangedHandler(input);
}
function $5104722604b983cb$var$raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
    if (shouldUpdateLayout === void 0) shouldUpdateLayout = true;
    var rootElement = element.getRootElement();
    if (shouldUpdateLayout) rootElement.updateLayout();
    var card = rootElement;
    var onElementVisibilityChangedHandler = card && card.onElementVisibilityChanged ? card.onElementVisibilityChanged : $5104722604b983cb$var$AdaptiveCard.onElementVisibilityChanged;
    if (onElementVisibilityChangedHandler !== undefined) onElementVisibilityChangedHandler(element);
}
function $5104722604b983cb$var$updateInputAdornersVisibility(input, hide) {
    if (!!hide) {
        // hides the time/date picker icon
        input.readOnly = true;
        // hides the cross button icon
        input.required = true;
    } else {
        // shows the time/date picker icon
        input.readOnly = false;
        // shows the cross button icon
        input.required = false;
    }
}
/**
 * @returns return false to continue with default context menu; return true to skip SDK default context menu
 */ function $5104722604b983cb$var$raiseDisplayOverflowActionMenuEvent(action, target) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onDisplayOverflowActionMenuHandler = card && card.onDisplayOverflowActionMenu ? card.onDisplayOverflowActionMenu : $5104722604b983cb$var$AdaptiveCard.onDisplayOverflowActionMenu;
    return onDisplayOverflowActionMenuHandler !== undefined ? onDisplayOverflowActionMenuHandler(action.getActions(), target) : false;
}
/**
 * @returns return false to continue with default action button; return true to skip SDK default action button
 */ function $5104722604b983cb$var$raiseRenderOverflowActionsEvent(action, isAtRootLevelActions) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onRenderOverflowActionsHandler = card && card.onRenderOverflowActions ? card.onRenderOverflowActions : $5104722604b983cb$var$AdaptiveCard.onRenderOverflowActions;
    return onRenderOverflowActionsHandler !== undefined ? onRenderOverflowActionsHandler(action.getActions(), isAtRootLevelActions) : false;
}
var $5104722604b983cb$var$ContainerWithActions = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(ContainerWithActions, _super);
    function ContainerWithActions() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $5104722604b983cb$var$ActionCollection(_this);
        return _this;
    }
    ContainerWithActions.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.parseActions(source, context);
    };
    ContainerWithActions.prototype.parseActions = function(source, context) {
        this._actionCollection.parse(source["actions"], context);
    };
    ContainerWithActions.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ContainerWithActions.prototype.internalRender = function() {
        var element = _super.prototype.internalRender.call(this);
        if (element) {
            var renderedActions = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
            if (renderedActions) {
                $F6YrP.appendChild(element, $5104722604b983cb$var$renderSeparation(this.hostConfig, {
                    spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
                }, $gIXBn.Orientation.Horizontal));
                $F6YrP.appendChild(element, renderedActions);
            }
            if (this.renderIfEmpty) return element;
            else return element.children.length > 0 ? element : undefined;
        } else return undefined;
    };
    ContainerWithActions.prototype.getHasExpandedAction = function() {
        if (this.renderedActionCount === 0) return false;
        else if (this.renderedActionCount === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
        else return this._actionCollection.expandedAction !== undefined;
    };
    Object.defineProperty(ContainerWithActions.prototype, "renderedActionCount", {
        get: function() {
            return this._actionCollection.renderedActionCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerWithActions.prototype, "renderIfEmpty", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ContainerWithActions.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ContainerWithActions.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ContainerWithActions.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ContainerWithActions.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ContainerWithActions.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this._actionCollection) this._actionCollection.validateProperties(context);
    };
    ContainerWithActions.prototype.isLastElement = function(element) {
        return _super.prototype.isLastElement.call(this, element) && this._actionCollection.getActionCount() === 0;
    };
    ContainerWithActions.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ContainerWithActions.prototype.clear = function() {
        _super.prototype.clear.call(this);
        this._actionCollection.clear();
    };
    ContainerWithActions.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = _super.prototype.getAllInputs.call(this, processActions);
        if (processActions) result.push.apply(result, this._actionCollection.getAllInputs(processActions));
        return result;
    };
    ContainerWithActions.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this._actionCollection.getResourceInformation());
        return result;
    };
    ContainerWithActions.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ContainerWithActions.prototype.getForbiddenActionNames = function() {
        return [];
    };
    ContainerWithActions.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ContainerWithActions.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerWithActions;
}($5104722604b983cb$var$Container);
module.exports.ContainerWithActions = $5104722604b983cb$var$ContainerWithActions;
var $5104722604b983cb$var$RefreshActionProperty = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(RefreshActionProperty, _super);
    function RefreshActionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    RefreshActionProperty.prototype.parse = function(sender, source, context) {
        var action = context.parseAction(sender.parent, source[this.name], [], false);
        if (action !== undefined) {
            if (action instanceof $5104722604b983cb$var$ExecuteAction) return action;
            context.logParseEvent(sender, $gIXBn.ValidationEvent.ActionTypeNotAllowed, $24F6S.Strings.errors.actionTypeNotAllowed(action.getJsonTypeName()));
        }
        context.logParseEvent(sender, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("action"));
        return undefined;
    };
    RefreshActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return RefreshActionProperty;
}($5Ougt.PropertyDefinition);
module.exports.RefreshActionProperty = $5104722604b983cb$var$RefreshActionProperty;
var $5104722604b983cb$var$RefreshDefinition = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(RefreshDefinition, _super);
    function RefreshDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RefreshDefinition.prototype, "action", {
        get: function() {
            return this.getValue(RefreshDefinition.actionProperty);
        },
        set: function(value) {
            this.setValue(RefreshDefinition.actionProperty, value);
            if (value) value.setParent(this.parent);
        },
        enumerable: false,
        configurable: true
    });
    RefreshDefinition.prototype.getSchemaKey = function() {
        return "RefreshDefinition";
    };
    //#region Schema
    RefreshDefinition.actionProperty = new $5104722604b983cb$var$RefreshActionProperty($5Ougt.Versions.v1_4, "action");
    RefreshDefinition.userIdsProperty = new $5Ougt.StringArrayProperty($5Ougt.Versions.v1_4, "userIds");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(RefreshDefinition.actionProperty)
    ], RefreshDefinition.prototype, "action", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(RefreshDefinition.userIdsProperty)
    ], RefreshDefinition.prototype, "userIds", void 0);
    return RefreshDefinition;
}($5Ougt.SerializableObject);
module.exports.RefreshDefinition = $5104722604b983cb$var$RefreshDefinition;
var $5104722604b983cb$var$AuthCardButton = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(AuthCardButton, _super);
    function AuthCardButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthCardButton.prototype.getSchemaKey = function() {
        return "AuthCardButton";
    };
    //#region Schema
    AuthCardButton.typeProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "type");
    AuthCardButton.titleProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "title");
    AuthCardButton.imageProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "image");
    AuthCardButton.valueProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "value");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.typeProperty)
    ], AuthCardButton.prototype, "type", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.titleProperty)
    ], AuthCardButton.prototype, "title", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.imageProperty)
    ], AuthCardButton.prototype, "image", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AuthCardButton.valueProperty)
    ], AuthCardButton.prototype, "value", void 0);
    return AuthCardButton;
}($5Ougt.SerializableObject);
module.exports.AuthCardButton = $5104722604b983cb$var$AuthCardButton;
var $5104722604b983cb$var$TokenExchangeResource = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(TokenExchangeResource, _super);
    function TokenExchangeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenExchangeResource.prototype.getSchemaKey = function() {
        return "TokenExchangeResource";
    };
    //#region Schema
    TokenExchangeResource.idProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "id");
    TokenExchangeResource.uriProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "uri");
    TokenExchangeResource.providerIdProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "providerId");
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TokenExchangeResource.idProperty)
    ], TokenExchangeResource.prototype, "id", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TokenExchangeResource.uriProperty)
    ], TokenExchangeResource.prototype, "uri", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(TokenExchangeResource.providerIdProperty)
    ], TokenExchangeResource.prototype, "providerId", void 0);
    return TokenExchangeResource;
}($5Ougt.SerializableObject);
module.exports.TokenExchangeResource = $5104722604b983cb$var$TokenExchangeResource;
var $5104722604b983cb$var$Authentication = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(Authentication, _super);
    function Authentication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authentication.prototype.getSchemaKey = function() {
        return "Authentication";
    };
    //#region Schema
    Authentication.textProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "text");
    Authentication.connectionNameProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_4, "connectionName");
    Authentication.buttonsProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_4, "buttons", $5104722604b983cb$var$AuthCardButton);
    Authentication.tokenExchangeResourceProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_4, "tokenExchangeResource", $5104722604b983cb$var$TokenExchangeResource, true);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.textProperty)
    ], Authentication.prototype, "text", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.connectionNameProperty)
    ], Authentication.prototype, "connectionName", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.buttonsProperty)
    ], Authentication.prototype, "buttons", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(Authentication.tokenExchangeResourceProperty)
    ], Authentication.prototype, "tokenExchangeResource", void 0);
    return Authentication;
}($5Ougt.SerializableObject);
module.exports.Authentication = $5104722604b983cb$var$Authentication;
// @dynamic
var $5104722604b983cb$var$AdaptiveCard = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(AdaptiveCard, _super);
    function AdaptiveCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.designMode = false;
        return _this;
    }
    Object.defineProperty(AdaptiveCard.prototype, "refresh", {
        get: function() {
            return this.getValue(AdaptiveCard.refreshProperty);
        },
        set: function(value) {
            this.setValue(AdaptiveCard.refreshProperty, value);
            if (value) value.parent = this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard, "processMarkdown", {
        get: function() {
            throw new Error($24F6S.Strings.errors.processMarkdownEventRemoved());
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        set: function(_value) {
            throw new Error($24F6S.Strings.errors.processMarkdownEventRemoved());
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.applyMarkdown = function(text) {
        var result = {
            didProcess: false
        };
        if (AdaptiveCard.onProcessMarkdown) AdaptiveCard.onProcessMarkdown(text, result);
        else if (window.markdownit) {
            // Check for markdownit
            var markdownIt = window.markdownit;
            result.outputHtml = markdownIt().render(text);
            result.didProcess = true;
        } else if (!AdaptiveCard._haveWarnedAboutNoMarkdownProcessing) {
            // eslint-disable-next-line no-console
            console.warn($24F6S.Strings.errors.markdownProcessingNotEnabled);
            AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = true;
        }
        return result;
    };
    AdaptiveCard.prototype.isVersionSupported = function() {
        if (this.bypassVersionCheck) return true;
        else {
            var unsupportedVersion = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
            return !unsupportedVersion;
        }
    };
    AdaptiveCard.prototype.getDefaultSerializationContext = function() {
        return new $5104722604b983cb$var$SerializationContext(this.version);
    };
    AdaptiveCard.prototype.getItemsCollectionPropertyName = function() {
        return "body";
    };
    AdaptiveCard.prototype.internalParse = function(source, context) {
        this._fallbackCard = undefined;
        var fallbackElement = context.parseElement(undefined, source["fallback"], this.forbiddenChildElements(), !this.isDesignMode());
        if (fallbackElement) {
            this._fallbackCard = new AdaptiveCard();
            this._fallbackCard.addItem(fallbackElement);
        }
        _super.prototype.internalParse.call(this, source, context);
    };
    AdaptiveCard.prototype.internalToJSON = function(target, context) {
        this.setValue(AdaptiveCard.versionProperty, context.targetVersion);
        _super.prototype.internalToJSON.call(this, target, context);
    };
    AdaptiveCard.prototype.internalRender = function() {
        var renderedElement = _super.prototype.internalRender.call(this);
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation && renderedElement) // Unlike containers, the root card element should be allowed to
        // be shorter than its content (otherwise the overflow truncation
        // logic would never get triggered)
        renderedElement.style.removeProperty("minHeight");
        return renderedElement;
    };
    AdaptiveCard.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return true;
    };
    AdaptiveCard.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition($gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding);
    };
    AdaptiveCard.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(AdaptiveCard.prototype, "renderIfEmpty", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "allowCustomStyle", {
        get: function() {
            return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "hasBackground", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.prototype.getJsonTypeName = function() {
        return "AdaptiveCard";
    };
    AdaptiveCard.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.getValue($5104722604b983cb$var$CardElement.typeNameProperty) !== "AdaptiveCard") context.addFailure(this, $gIXBn.ValidationEvent.MissingCardType, $24F6S.Strings.errors.invalidCardType());
        if (!this.bypassVersionCheck && !this.version) context.addFailure(this, $gIXBn.ValidationEvent.PropertyCantBeNull, $24F6S.Strings.errors.propertyMustBeSet("version"));
        else if (!this.isVersionSupported()) context.addFailure(this, $gIXBn.ValidationEvent.UnsupportedCardVersion, $24F6S.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    };
    AdaptiveCard.prototype.render = function(target) {
        var _this = this;
        var renderedCard;
        if (this.shouldFallback() && this._fallbackCard) {
            this._fallbackCard.hostConfig = this.hostConfig;
            renderedCard = this._fallbackCard.render();
        } else {
            renderedCard = _super.prototype.render.call(this);
            if (renderedCard) {
                renderedCard.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard"));
                // Having a tabIndex on the root container for a card can mess up accessibility in some scenarios.
                // However, we've shipped this behavior before, and so can't just turn it off in a point release. For
                // now, to unblock accessibility scenarios for our customers, we've got an option to turn it off. In a
                // future release, we should strongly consider flipping the default such that we *don't* emit a tabIndex
                // by default.
                if ($6BHj7.GlobalSettings.setTabIndexAtCardRoot) renderedCard.tabIndex = 0;
                if (this.speak) renderedCard.setAttribute("aria-label", this.speak);
                renderedCard.onmouseenter = function(ev) {
                    _this.updateInputsVisualState(true);
                };
                renderedCard.onmouseleave = function(ev) {
                    _this.updateInputsVisualState(false);
                };
                this.getRootElement().updateActionsEnabledState();
            }
        }
        if (target) {
            $F6YrP.appendChild(target, renderedCard);
            this.updateLayout();
        }
        var inputElements = this.getAllInputs();
        document.onclick = function(event) {
            inputElements.forEach(function(input) {
                var _a, _b;
                if (input instanceof $5104722604b983cb$var$ChoiceSetInput && !((_a = input.renderedElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))) (_b = input.getDropdownElement()) === null || _b === void 0 || _b.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
            });
        };
        return renderedCard;
    };
    AdaptiveCard.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
            var padding = this.hostConfig.getEffectiveSpacing($gIXBn.Spacing.Default);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            this["handleOverflow"](this.renderedElement.offsetHeight - padding);
        }
    };
    AdaptiveCard.prototype.shouldFallback = function() {
        return _super.prototype.shouldFallback.call(this) || !this.isVersionSupported();
    };
    Object.defineProperty(AdaptiveCard.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json";
    //#region Schema
    // eslint-disable-next-line @typescript-eslint/naming-convention
    AdaptiveCard.$schemaProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_0, "$schema", function(sender, property, source, context) {
        return AdaptiveCard.schemaUrl;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, AdaptiveCard.schemaUrl);
    });
    AdaptiveCard.versionProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_0, "version", function(sender, prop, source, context) {
        var version = $5Ougt.Version.parse(source[prop.name], context);
        if (version === undefined) {
            version = $5Ougt.Versions.latest;
            context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidCardVersion(version.toString()));
        }
        return version;
    }, function(sender, prop, target, value, context) {
        if (value !== undefined) context.serializeValue(target, prop.name, value.toString());
    }, $5Ougt.Versions.v1_0);
    AdaptiveCard.fallbackTextProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "fallbackText");
    AdaptiveCard.speakProperty = new $5Ougt.StringProperty($5Ougt.Versions.v1_0, "speak");
    AdaptiveCard.refreshProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_4, "refresh", $5104722604b983cb$var$RefreshDefinition, true);
    AdaptiveCard.authenticationProperty = new $5Ougt.SerializableObjectProperty($5Ougt.Versions.v1_4, "authentication", $5104722604b983cb$var$Authentication, true);
    //#endregion
    AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = false;
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.versionProperty)
    ], AdaptiveCard.prototype, "version", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.fallbackTextProperty)
    ], AdaptiveCard.prototype, "fallbackText", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.speakProperty)
    ], AdaptiveCard.prototype, "speak", void 0);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.refreshProperty)
    ], AdaptiveCard.prototype, "refresh", null);
    $5104722604b983cb$var$__decorate([
        (0, $5Ougt.property)(AdaptiveCard.authenticationProperty)
    ], AdaptiveCard.prototype, "authentication", void 0);
    return AdaptiveCard;
}($5104722604b983cb$var$ContainerWithActions);
module.exports.AdaptiveCard = $5104722604b983cb$var$AdaptiveCard;
var $5104722604b983cb$var$InlineAdaptiveCard = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(InlineAdaptiveCard, _super);
    function InlineAdaptiveCard() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suppressStyle = false;
        return _this;
    }
    InlineAdaptiveCard.prototype.getSchemaKey = function() {
        return "InlineAdaptiveCard";
    };
    InlineAdaptiveCard.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($5104722604b983cb$var$AdaptiveCard.$schemaProperty, $5104722604b983cb$var$AdaptiveCard.versionProperty);
    };
    //#endregion
    InlineAdaptiveCard.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition(this.suppressStyle ? $gIXBn.Spacing.None : $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding, this.suppressStyle ? $gIXBn.Spacing.None : $gIXBn.Spacing.Padding, $gIXBn.Spacing.Padding);
    };
    Object.defineProperty(InlineAdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineAdaptiveCard.prototype, "defaultStyle", {
        get: function() {
            if (this.suppressStyle) return $gIXBn.ContainerStyle.Default;
            else return this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : $gIXBn.ContainerStyle.Emphasis;
        },
        enumerable: false,
        configurable: true
    });
    InlineAdaptiveCard.prototype.render = function(target) {
        var renderedCard = _super.prototype.render.call(this, target);
        if (renderedCard) {
            renderedCard.setAttribute("aria-live", "polite");
            renderedCard.removeAttribute("tabindex");
        }
        return renderedCard;
    };
    return InlineAdaptiveCard;
}($5104722604b983cb$var$AdaptiveCard);
var $5104722604b983cb$var$SerializationContext = /** @class */ function(_super) {
    $5104722604b983cb$var$__extends(SerializationContext, _super);
    function SerializationContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._forbiddenTypes = new Set();
        return _this;
    }
    SerializationContext.prototype.internalParseCardObject = function(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent) {
        var _this = this;
        var result = undefined;
        if (source && typeof source === "object") {
            var oldForbiddenTypes_1 = new Set();
            this._forbiddenTypes.forEach(function(type) {
                oldForbiddenTypes_1.add(type);
            });
            forbiddenTypes.forEach(function(type) {
                _this._forbiddenTypes.add(type);
            });
            var typeName = $F6YrP.parseString(source["type"]);
            if (typeName && this._forbiddenTypes.has(typeName)) logParseEvent(typeName, $gIXBn.TypeErrorType.ForbiddenType);
            else {
                var tryToFallback = false;
                result = createInstanceCallback(typeName);
                if (!result) {
                    tryToFallback = $6BHj7.GlobalSettings.enableFallback && allowFallback;
                    logParseEvent(typeName, $gIXBn.TypeErrorType.UnknownType);
                } else {
                    result.setParent(parent);
                    result.parse(source, this);
                    tryToFallback = $6BHj7.GlobalSettings.enableFallback && allowFallback && result.shouldFallback();
                }
                if (tryToFallback) {
                    var fallback = source["fallback"];
                    if (!fallback && parent) parent.setShouldFallback(true);
                    if (typeof fallback === "string" && fallback.toLowerCase() === "drop") result = undefined;
                    else if (typeof fallback === "object") result = this.internalParseCardObject(parent, fallback, forbiddenTypes, true, createInstanceCallback, logParseEvent);
                }
            }
            this._forbiddenTypes = oldForbiddenTypes_1;
        }
        return result;
    };
    SerializationContext.prototype.cardObjectParsed = function(o, source) {
        if (o instanceof $5104722604b983cb$var$Action && this.onParseAction) this.onParseAction(o, source, this);
        else if (o instanceof $5104722604b983cb$var$CardElement && this.onParseElement) this.onParseElement(o, source, this);
    };
    SerializationContext.prototype.shouldSerialize = function(o) {
        if (o instanceof $5104722604b983cb$var$Action) return this.actionRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else if (o instanceof $5104722604b983cb$var$CardElement) return this.elementRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else return true;
    };
    SerializationContext.prototype.parseCardObject = function(parent, source, forbiddenTypeNames, allowFallback, createInstanceCallback, logParseEvent) {
        var forbiddenTypes = new Set(forbiddenTypeNames);
        var result = this.internalParseCardObject(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent);
        if (result !== undefined) this.cardObjectParsed(result, source);
        return result;
    };
    SerializationContext.prototype.parseElement = function(parent, source, forbiddenTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenTypes, allowFallback, function(typeName) {
            return _this.elementRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $gIXBn.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $gIXBn.ValidationEvent.UnknownElementType, $24F6S.Strings.errors.unknownElementType(typeName));
            else _this.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    SerializationContext.prototype.parseAction = function(parent, source, forbiddenActionTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenActionTypes, allowFallback, function(typeName) {
            return _this.actionRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $gIXBn.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $gIXBn.ValidationEvent.UnknownActionType, $24F6S.Strings.errors.unknownActionType(typeName));
            else _this.logParseEvent(undefined, $gIXBn.ValidationEvent.ActionTypeNotAllowed, $24F6S.Strings.errors.actionTypeNotAllowed(typeName));
        });
    };
    Object.defineProperty(SerializationContext.prototype, "elementRegistry", {
        get: function() {
            var _a;
            return (_a = this._elementRegistry) !== null && _a !== void 0 ? _a : $2Zn2I.GlobalRegistry.elements;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setElementRegistry = function(value) {
        this._elementRegistry = value;
    };
    Object.defineProperty(SerializationContext.prototype, "actionRegistry", {
        get: function() {
            var _a;
            return (_a = this._actionRegistry) !== null && _a !== void 0 ? _a : $2Zn2I.GlobalRegistry.actions;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setActionRegistry = function(value) {
        this._actionRegistry = value;
    };
    return SerializationContext;
}($5Ougt.BaseSerializationContext);
module.exports.SerializationContext = $5104722604b983cb$var$SerializationContext;
$2Zn2I.GlobalRegistry.defaultElements.register("Container", $5104722604b983cb$var$Container);
$2Zn2I.GlobalRegistry.defaultElements.register("TextBlock", $5104722604b983cb$var$TextBlock);
$2Zn2I.GlobalRegistry.defaultElements.register("RichTextBlock", $5104722604b983cb$var$RichTextBlock, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultElements.register("TextRun", $5104722604b983cb$var$TextRun, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultElements.register("Image", $5104722604b983cb$var$Image);
$2Zn2I.GlobalRegistry.defaultElements.register("ImageSet", $5104722604b983cb$var$ImageSet);
$2Zn2I.GlobalRegistry.defaultElements.register("Media", $5104722604b983cb$var$Media, $5Ougt.Versions.v1_1);
$2Zn2I.GlobalRegistry.defaultElements.register("FactSet", $5104722604b983cb$var$FactSet);
$2Zn2I.GlobalRegistry.defaultElements.register("ColumnSet", $5104722604b983cb$var$ColumnSet);
$2Zn2I.GlobalRegistry.defaultElements.register("ActionSet", $5104722604b983cb$var$ActionSet, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Text", $5104722604b983cb$var$TextInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Date", $5104722604b983cb$var$DateInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Time", $5104722604b983cb$var$TimeInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Number", $5104722604b983cb$var$NumberInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.ChoiceSet", $5104722604b983cb$var$ChoiceSetInput);
$2Zn2I.GlobalRegistry.defaultElements.register("Input.Toggle", $5104722604b983cb$var$ToggleInput);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$OpenUrlAction.JsonTypeName, $5104722604b983cb$var$OpenUrlAction);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$SubmitAction.JsonTypeName, $5104722604b983cb$var$SubmitAction);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$ShowCardAction.JsonTypeName, $5104722604b983cb$var$ShowCardAction);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$ToggleVisibilityAction.JsonTypeName, $5104722604b983cb$var$ToggleVisibilityAction, $5Ougt.Versions.v1_2);
$2Zn2I.GlobalRegistry.defaultActions.register($5104722604b983cb$var$ExecuteAction.JsonTypeName, $5104722604b983cb$var$ExecuteAction, $5Ougt.Versions.v1_4);

});
parcelRegister("fuLKQ", function(module, exports) {
"use strict";
var $b47eb36aa0a8babf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatText = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $b47eb36aa0a8babf$var$AbstractTextFormatter = /** @class */ function() {
    function AbstractTextFormatter(regularExpression) {
        this._regularExpression = regularExpression;
    }
    AbstractTextFormatter.prototype.format = function(lang, input) {
        var matches;
        if (input) {
            var result = input;
            while((matches = this._regularExpression.exec(input)) != null)result = result.replace(matches[0], this.internalFormat(lang, matches));
            return result;
        } else return input;
    };
    return AbstractTextFormatter;
}();
var $b47eb36aa0a8babf$var$DateFormatter = /** @class */ function(_super) {
    $b47eb36aa0a8babf$var$__extends(DateFormatter, _super);
    function DateFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        var format = matches[2] !== undefined ? matches[2].toLowerCase() : "compact";
        if (format !== "compact") return date.toLocaleDateString(lang, {
            day: "numeric",
            weekday: format,
            month: format,
            year: "numeric"
        });
        else return date.toLocaleDateString();
    };
    return DateFormatter;
}($b47eb36aa0a8babf$var$AbstractTextFormatter);
var $b47eb36aa0a8babf$var$TimeFormatter = /** @class */ function(_super) {
    $b47eb36aa0a8babf$var$__extends(TimeFormatter, _super);
    function TimeFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        return date.toLocaleTimeString(lang, {
            hour: "numeric",
            minute: "2-digit"
        });
    };
    return TimeFormatter;
}($b47eb36aa0a8babf$var$AbstractTextFormatter);
function $b47eb36aa0a8babf$var$formatText(lang, text) {
    var formatters = [
        new $b47eb36aa0a8babf$var$DateFormatter(/\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g),
        new $b47eb36aa0a8babf$var$TimeFormatter(/\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g)
    ];
    var result = text;
    for(var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++){
        var formatter = formatters_1[_i];
        result = formatter.format(lang, result);
    }
    return result;
}
module.exports.formatText = $b47eb36aa0a8babf$var$formatText;

});

parcelRegister("iX2Kh", function(module, exports) {
"use strict";
var $dcbfddda8c2cbff8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dcbfddda8c2cbff8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dcbfddda8c2cbff8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (C) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$dcbfddda8c2cbff8$var$__exportStar((parcelRequire("eFbX8")), module.exports);

$dcbfddda8c2cbff8$var$__exportStar((parcelRequire("cCKyr")), module.exports);

});
parcelRegister("eFbX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MenuItem = void 0;

var $8kDQQ = parcelRequire("8kDQQ");

var $birwC = parcelRequire("birwC");
var $aace2a9f550c2003$var$MenuItem = /** @class */ function() {
    function MenuItem(key, value) {
        this._isEnabled = true;
        this.key = key;
        this._value = value;
    }
    MenuItem.prototype.click = function() {
        if (this.isEnabled && this.onClick) this.onClick(this);
    };
    MenuItem.prototype.updateCssClasses = function() {
        if (this._element) {
            var effectiveHostConfig = this._hostConfig ? this._hostConfig : $8kDQQ.defaultHostConfig;
            this._element.className = effectiveHostConfig.makeCssClassName("ac-ctrl");
            this._element.classList.add(effectiveHostConfig.makeCssClassName(this.isEnabled ? "ac-ctrl-dropdown-item" : "ac-ctrl-dropdown-item-disabled"));
            if (!this.isEnabled) this._element.classList.add(effectiveHostConfig.makeCssClassName("ac-disabled"));
        }
    };
    MenuItem.prototype.toString = function() {
        return this.value;
    };
    MenuItem.prototype.render = function(hostConfig) {
        var _this = this;
        this._hostConfig = hostConfig;
        if (!this._element) {
            this._element = document.createElement("span");
            this._element.innerText = this.value;
            this._element.setAttribute("role", "menuitem");
            if (!this.isEnabled) this._element.setAttribute("aria-disabled", "true");
            this._element.setAttribute("aria-current", "false");
            this._element.onmouseup = function(_e) {
                _this.click();
            };
            this._element.onkeydown = function(e) {
                if (e.key === $birwC.Constants.keys.enter) {
                    e.cancelBubble = true;
                    _this.click();
                }
            };
            this.updateCssClasses();
        }
        return this._element;
    };
    Object.defineProperty(MenuItem.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(newValue) {
            this._value = newValue;
            if (this._element) this._element.innerText = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItem.prototype, "isEnabled", {
        get: function() {
            return this._isEnabled;
        },
        set: function(value) {
            if (this._isEnabled !== value) {
                this._isEnabled = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    return MenuItem;
}();
module.exports.MenuItem = $aace2a9f550c2003$var$MenuItem;

});
parcelRegister("birwC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $8396ba0fcb145065$var$Constants = /** @class */ function() {
    function Constants() {}
    Constants.keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete"
    };
    return Constants;
}();
module.exports.Constants = $8396ba0fcb145065$var$Constants;

});


parcelRegister("cCKyr", function(module, exports) {
"use strict";
var $930d256c60becd73$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = void 0;

var $birwC = parcelRequire("birwC");

var $927hd = parcelRequire("927hd");

var $dcULZ = parcelRequire("dcULZ");
var $930d256c60becd73$var$PopupMenu = /** @class */ function(_super) {
    $930d256c60becd73$var$__extends(PopupMenu, _super);
    function PopupMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = new $927hd.Collection();
        _this._renderedItems = [];
        _this._selectedIndex = -1;
        return _this;
    }
    PopupMenu.prototype.renderContent = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup");
        element.setAttribute("role", "listbox");
        for(var i = 0; i < this._items.length; i++){
            var renderedItem = this._items.get(i).render(this.hostConfig);
            renderedItem.tabIndex = 0;
            element.appendChild(renderedItem);
            if (i === this.selectedIndex) renderedItem.focus();
            this._renderedItems.push(renderedItem);
        }
        return element;
    };
    PopupMenu.prototype.keyDown = function(e) {
        _super.prototype.keyDown.call(this, e);
        var selectedItemIndex = this._selectedIndex;
        switch(e.key){
            case $birwC.Constants.keys.tab:
                this.closePopup(true);
                break;
            /*
            case Constants.keys.enter:
                if (this.selectedIndex >= 0) {
                    this.selectedIndex = this.selectedIndex;

                    this.close();
                }

                break;
            */ case $birwC.Constants.keys.up:
                if (selectedItemIndex <= 0) selectedItemIndex = this._renderedItems.length - 1;
                else {
                    selectedItemIndex--;
                    if (selectedItemIndex < 0) selectedItemIndex = this._renderedItems.length - 1;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
            case $birwC.Constants.keys.down:
                if (selectedItemIndex < 0) selectedItemIndex = 0;
                else {
                    selectedItemIndex++;
                    if (selectedItemIndex >= this._renderedItems.length) selectedItemIndex = 0;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
        }
    };
    Object.defineProperty(PopupMenu.prototype, "items", {
        get: function() {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupMenu.prototype, "selectedIndex", {
        get: function() {
            return this._selectedIndex;
        },
        set: function(index) {
            if (index >= 0 && index < this._renderedItems.length) {
                this._renderedItems[index].focus();
                this._selectedIndex = index;
            }
        },
        enumerable: false,
        configurable: true
    });
    return PopupMenu;
}($dcULZ.PopupControl);
module.exports.PopupMenu = $930d256c60becd73$var$PopupMenu;

});
parcelRegister("927hd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $6939f1f1a0878d0d$var$Collection = /** @class */ function() {
    function Collection() {
        this._items = [];
    }
    Collection.prototype.get = function(index) {
        return this._items[index];
    };
    Collection.prototype.add = function(item) {
        this._items.push(item);
        if (this.onItemAdded) this.onItemAdded(item);
    };
    Collection.prototype.remove = function(item) {
        var i = this._items.indexOf(item);
        if (i >= 0) {
            this._items = this._items.splice(i, 1);
            if (this.onItemRemoved) this.onItemRemoved(item);
        }
    };
    Collection.prototype.indexOf = function(item) {
        return this._items.indexOf(item);
    };
    Object.defineProperty(Collection.prototype, "length", {
        get: function() {
            return this._items.length;
        },
        enumerable: false,
        configurable: true
    });
    return Collection;
}();
module.exports.Collection = $6939f1f1a0878d0d$var$Collection;

});

parcelRegister("dcULZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupControl = void 0;

var $birwC = parcelRequire("birwC");

var $F6YrP = parcelRequire("F6YrP");

var $8kDQQ = parcelRequire("8kDQQ");
var $99d86f4d549db4ad$var$PopupControl = /** @class */ function() {
    function PopupControl() {
        this._isOpen = false;
    }
    PopupControl.prototype.keyDown = function(e) {
        switch(e.key){
            case $birwC.Constants.keys.escape:
                this.closePopup(true);
                break;
        }
    };
    PopupControl.prototype.render = function(_rootElementBounds) {
        var _this = this;
        var element = document.createElement("div");
        element.tabIndex = 0;
        element.className = this.hostConfig.makeCssClassName("ac-ctrl", "ac-ctrl-popup-container");
        element.setAttribute("role", "dialog");
        element.setAttribute("aria-modal", "true");
        element.onkeydown = function(e) {
            _this.keyDown(e);
            return !e.cancelBubble;
        };
        element.appendChild(this.renderContent());
        return element;
    };
    PopupControl.prototype.focus = function() {
        if (this._popupElement) this._popupElement.firstElementChild.focus();
    };
    PopupControl.prototype.popup = function(rootElement) {
        var _a, _b, _c, _d, _f;
        var _this = this;
        if (!this._isOpen) {
            this._overlayElement = document.createElement("div");
            this._overlayElement.className = this.hostConfig.makeCssClassName("ac-ctrl-overlay");
            this._overlayElement.tabIndex = 0;
            this._overlayElement.style.width = document.documentElement.scrollWidth + "px";
            this._overlayElement.style.height = document.documentElement.scrollHeight + "px";
            this._overlayElement.onfocus = function(_e) {
                _this.closePopup(true);
            };
            document.body.appendChild(this._overlayElement);
            var rootElementBounds = rootElement.getBoundingClientRect();
            this._popupElement = this.render(rootElementBounds);
            (_a = this._popupElement.classList).remove.apply(_a, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight", "ac-ctrl-slideRightToLeft", "ac-ctrl-slideTopToBottom", "ac-ctrl-slideRightToLeft"));
            window.addEventListener("resize", function(_e) {
                _this.closePopup(true);
            });
            var rootElementLabel = rootElement.getAttribute("aria-label");
            if (rootElementLabel) this._popupElement.setAttribute("aria-label", rootElementLabel);
            this._overlayElement.appendChild(this._popupElement);
            var popupElementBounds = this._popupElement.getBoundingClientRect();
            var availableSpaceBelow = window.innerHeight - rootElementBounds.bottom;
            var availableSpaceAbove = rootElementBounds.top;
            var availableSpaceRight = window.innerWidth - rootElementBounds.right;
            var availableSpaceLeft = rootElementBounds.left;
            var left = rootElementBounds.left + $F6YrP.getScrollX();
            var top_1;
            if (availableSpaceAbove < popupElementBounds.height && availableSpaceBelow < popupElementBounds.height) {
                // Not enough space above or below root element
                var actualPopupHeight = Math.min(popupElementBounds.height, window.innerHeight);
                this._popupElement.style.maxHeight = actualPopupHeight + "px";
                if (actualPopupHeight < popupElementBounds.height) top_1 = $F6YrP.getScrollY();
                else top_1 = $F6YrP.getScrollY() + rootElementBounds.top + (rootElementBounds.height - actualPopupHeight) / 2;
                if (availableSpaceLeft < popupElementBounds.width && availableSpaceRight < popupElementBounds.width) {
                    // Not enough space left or right of root element
                    var actualPopupWidth = Math.min(popupElementBounds.width, window.innerWidth);
                    this._popupElement.style.maxWidth = actualPopupWidth + "px";
                    if (actualPopupWidth < popupElementBounds.width) left = $F6YrP.getScrollX();
                    else left = $F6YrP.getScrollX() + rootElementBounds.left + (rootElementBounds.width - actualPopupWidth) / 2;
                } else // Enough space on the left or right of the root element
                if (availableSpaceRight >= popupElementBounds.width) {
                    left = $F6YrP.getScrollX() + rootElementBounds.right;
                    (_b = this._popupElement.classList).add.apply(_b, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight"));
                } else {
                    left = $F6YrP.getScrollX() + rootElementBounds.left - popupElementBounds.width;
                    (_c = this._popupElement.classList).add.apply(_c, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideRightToLeft"));
                }
            } else {
                // Enough space above or below root element
                if (availableSpaceBelow >= popupElementBounds.height) {
                    top_1 = $F6YrP.getScrollY() + rootElementBounds.bottom;
                    (_d = this._popupElement.classList).add.apply(_d, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideTopToBottom"));
                } else {
                    top_1 = $F6YrP.getScrollY() + rootElementBounds.top - popupElementBounds.height;
                    (_f = this._popupElement.classList).add.apply(_f, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideBottomToTop"));
                }
                if (availableSpaceRight < popupElementBounds.width) left = $F6YrP.getScrollX() + rootElementBounds.right - popupElementBounds.width;
            }
            this._popupElement.style.left = left + "px";
            this._popupElement.style.top = top_1 + "px";
            this._popupElement.focus();
            this._isOpen = true;
        }
    };
    PopupControl.prototype.closePopup = function(wasCancelled) {
        if (this._isOpen) {
            document.body.removeChild(this._overlayElement);
            this._isOpen = false;
            if (this.onClose) this.onClose(this, wasCancelled);
        }
    };
    Object.defineProperty(PopupControl.prototype, "hostConfig", {
        get: function() {
            return this._hostConfig ? this._hostConfig : $8kDQQ.defaultHostConfig;
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupControl.prototype, "isOpen", {
        get: function() {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    return PopupControl;
}();
module.exports.PopupControl = $99d86f4d549db4ad$var$PopupControl;

});




parcelRegister("99lCx", function(module, exports) {
"use strict";
var $6a95b9bcd8d58230$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6a95b9bcd8d58230$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a95b9bcd8d58230$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselEvent = module.exports.Carousel = module.exports.CarouselPage = void 0;

var $6XfIC = parcelRequire("6XfIC");

var $gIXBn = parcelRequire("gIXBn");

var $5Ougt = parcelRequire("5Ougt");

var $2Zn2I = parcelRequire("2Zn2I");

var $gIXBn = parcelRequire("gIXBn");

var $24F6S = parcelRequire("24F6S");
parcelRequire("b6mvZ");
var $jITlg = parcelRequire("jITlg");
var $j1U9P = parcelRequire("j1U9P");
var $PP3xB = parcelRequire("PP3xB");
var $8Q03I = parcelRequire("8Q03I");
var $awlOA = parcelRequire("awlOA");
var $deIcY = parcelRequire("deIcY");
var $4648Z = parcelRequire("4648Z");
var $dQfLu = parcelRequire("dQfLu");

var $F6YrP = parcelRequire("F6YrP");

var $6BHj7 = parcelRequire("6BHj7");
// Note: to function correctly, consumers need to have CSS from swiper/css, swiper/css/pagination, and
// swiper/css/navigation
var $6a95b9bcd8d58230$var$CarouselPage = /** @class */ function(_super) {
    $6a95b9bcd8d58230$var$__extends(CarouselPage, _super);
    function CarouselPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#region Schema
    CarouselPage.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in CarouselPage
        schema.remove($6XfIC.Container.styleProperty);
        schema.remove($6XfIC.Container.bleedProperty);
        schema.remove($6XfIC.Container.isVisibleProperty);
    };
    //#endregion
    CarouselPage.prototype.internalRender = function() {
        var carouselSlide = document.createElement("div");
        carouselSlide.className = this.hostConfig.makeCssClassName("swiper-slide");
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        var renderedElement = _super.prototype.internalRender.call(this);
        $F6YrP.appendChild(carouselSlide, renderedElement);
        return carouselSlide;
    };
    CarouselPage.prototype.getForbiddenActionTypes = function() {
        return [
            $6XfIC.ShowCardAction,
            $6XfIC.ToggleVisibilityAction
        ];
    };
    CarouselPage.prototype.getForbiddenChildElements = function() {
        return this.forbiddenChildElements();
    };
    CarouselPage.prototype.forbiddenChildElements = function() {
        return $6a95b9bcd8d58230$var$__spreadArray([
            $6XfIC.ToggleVisibilityAction.JsonTypeName,
            $6XfIC.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle",
            "Carousel"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    CarouselPage.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.setShouldFallback(false);
    };
    CarouselPage.prototype.shouldSerialize = function(_context) {
        return true;
    };
    CarouselPage.prototype.getJsonTypeName = function() {
        return "CarouselPage";
    };
    Object.defineProperty(CarouselPage.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarouselPage.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return CarouselPage;
}($6XfIC.Container);
module.exports.CarouselPage = $6a95b9bcd8d58230$var$CarouselPage;
var $6a95b9bcd8d58230$var$Carousel = /** @class */ function(_super) {
    $6a95b9bcd8d58230$var$__extends(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.carouselLoop = true;
        _this.carouselOrientation = $gIXBn.Orientation.Horizontal;
        _this._pages = [];
        _this._currentIndex = 0;
        _this._previousEventType = $gIXBn.CarouselInteractionEvent.Pagination;
        return _this;
    }
    //#region Schema
    Carousel.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in Carousel
        schema.remove($6XfIC.Container.styleProperty);
        schema.remove($6XfIC.Container.bleedProperty);
        schema.remove($6XfIC.Container.isVisibleProperty);
    };
    Object.defineProperty(Carousel.prototype, "timer", {
        get: function() {
            var timer = this.getValue(Carousel.timerProperty);
            if (timer && timer < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($24F6S.Strings.errors.tooLittleTimeDelay);
                timer = this.hostConfig.carousel.minAutoplayDelay;
            }
            return timer;
        },
        set: function(value) {
            if (value && value < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($24F6S.Strings.errors.tooLittleTimeDelay);
                this.setValue(Carousel.timerProperty, this.hostConfig.carousel.minAutoplayDelay);
            } else this.setValue(Carousel.timerProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "initialPageIndex", {
        get: function() {
            return this.getValue(Carousel.initialPageProperty);
        },
        set: function(value) {
            if (this.isValidParsedPageIndex(value)) this.setValue(Carousel.initialPageProperty, value);
            else {
                console.warn($24F6S.Strings.errors.invalidInitialPageIndex(value));
                this.setValue(Carousel.initialPageProperty, 0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.isValidParsedPageIndex = function(index) {
        return this._pages ? this.isValidPageIndex(index, this._pages.length) : false;
    };
    Carousel.prototype.isValidRenderedPageIndex = function(index) {
        return this._renderedPages ? this.isValidPageIndex(index, this._renderedPages.length) : false;
    };
    Carousel.prototype.isValidPageIndex = function(index, collectionSize) {
        return collectionSize > 0 && 0 <= index && index < collectionSize;
    };
    Object.defineProperty(Carousel.prototype, "previousEventType", {
        //#endregion
        get: function() {
            return this._previousEventType;
        },
        set: function(eventType) {
            this._previousEventType = eventType;
        },
        enumerable: false,
        configurable: true
    });
    // Question: Why do we place this on the Carousel instead of the CarouselPage?
    Carousel.prototype.forbiddenChildElements = function() {
        return $6a95b9bcd8d58230$var$__spreadArray([
            $6XfIC.ToggleVisibilityAction.JsonTypeName,
            $6XfIC.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    Carousel.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.height == "stretch" && this._containerForAdorners !== undefined) this._containerForAdorners.style.height = "100%";
        // Assign the explicit height to carouselPageContainer if given
        if (this.carouselHeight) this._carouselPageContainer.style.height = this.carouselHeight + "px";
    };
    Carousel.prototype.getJsonTypeName = function() {
        return "Carousel";
    };
    Carousel.prototype.getItemCount = function() {
        return this._pages.length;
    };
    Carousel.prototype.getItemAt = function(index) {
        return this._pages[index];
    };
    Carousel.prototype.addPage = function(page) {
        this._pages.push(page);
        page.setParent(this);
    };
    Carousel.prototype.removeItem = function(item) {
        if (item instanceof $6a95b9bcd8d58230$var$CarouselPage) {
            var itemIndex = this._pages.indexOf(item);
            if (itemIndex >= 0) {
                this._pages.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    Carousel.prototype.getFirstVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[0];
        else return undefined;
    };
    Carousel.prototype.getLastVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[this._renderedPages.length - 1];
        else return undefined;
    };
    Object.defineProperty(Carousel.prototype, "currentPageId", {
        get: function() {
            var _a, _b;
            if ((_b = (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.slides) === null || _b === void 0 ? void 0 : _b.length) {
                var activeSlide = this._carousel.slides[this._carousel.activeIndex];
                return activeSlide.id;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentPageIndex", {
        get: function() {
            var _a;
            return (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.realIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._pages = [];
        var jsonPages = source["pages"];
        if (Array.isArray(jsonPages)) for(var _i = 0, jsonPages_1 = jsonPages; _i < jsonPages_1.length; _i++){
            var item = jsonPages_1[_i];
            var page = this.createCarouselPageInstance(item, context);
            if (page) this._pages.push(page);
        }
        // everything is parsed do validate on initial page index
        this.validateParsing(context);
    };
    Carousel.prototype.validateParsing = function(context) {
        if (!this.isValidParsedPageIndex(this.initialPageIndex)) context.logParseEvent(this, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
    };
    Carousel.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "pages", this._pages);
    };
    Carousel.prototype.internalRender = function() {
        var _a;
        this._renderedPages = [];
        if (this._pages.length <= 0) return undefined;
        this.validateOrientationProperties();
        var cardLevelContainer = document.createElement("div");
        cardLevelContainer.className = this.hostConfig.makeCssClassName("ac-carousel-card-level-container");
        var carouselContainer = document.createElement("div");
        carouselContainer.className = this.hostConfig.makeCssClassName("swiper", "ac-carousel");
        this._carouselPageContainer = carouselContainer;
        var containerForAdorners = document.createElement("div");
        containerForAdorners.className = this.hostConfig.makeCssClassName("ac-carousel-container");
        this._containerForAdorners = containerForAdorners;
        cardLevelContainer.appendChild(containerForAdorners);
        var navigationContainer = document.createElement("div");
        navigationContainer.className = this.hostConfig.makeCssClassName("ac-carousel-navigation");
        containerForAdorners.appendChild(navigationContainer);
        var carouselWrapper = document.createElement("div");
        carouselWrapper.className = this.hostConfig.makeCssClassName("swiper-wrapper", "ac-carousel-card-container");
        carouselWrapper.style.display = "flex";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $gIXBn.VerticalAlignment.Top:
                carouselWrapper.style.alignItems = "flex-start";
                break;
            case $gIXBn.VerticalAlignment.Bottom:
                carouselWrapper.style.alignItems = "flex-end";
                break;
            default:
                carouselWrapper.style.alignItems = "center";
                break;
        }
        if ($6BHj7.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        carouselWrapper.style.minHeight = "-webkit-min-content";
        var prevElementDiv = document.createElement("div");
        prevElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-prev");
        var nextElementDiv = document.createElement("div");
        nextElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-next");
        if (this.carouselOrientation === $gIXBn.Orientation.Horizontal) this.updateCssForHorizontalCarousel(prevElementDiv, nextElementDiv);
        else this.updateCssForVerticalCarousel(navigationContainer, prevElementDiv, nextElementDiv);
        var pagination = document.createElement("div");
        pagination.className = this.hostConfig.makeCssClassName("swiper-pagination", "ac-carousel-pagination");
        navigationContainer.appendChild(prevElementDiv);
        $F6YrP.addCancelSelectActionEventHandler(prevElementDiv);
        navigationContainer.appendChild(pagination);
        $F6YrP.addCancelSelectActionEventHandler(pagination);
        navigationContainer.appendChild(nextElementDiv);
        $F6YrP.addCancelSelectActionEventHandler(nextElementDiv);
        if (this.isDesignMode()) {
            // If we are in design mode, we need to ensure these elements are in front of the peers
            prevElementDiv.style.zIndex = "20";
            nextElementDiv.style.zIndex = "20";
            pagination.style.zIndex = "20";
        }
        var requestedNumberOfPages = Math.min(this._pages.length, this.hostConfig.carousel.maxCarouselPages);
        if (this._pages.length > this.hostConfig.carousel.maxCarouselPages) console.warn($24F6S.Strings.errors.tooManyCarouselPages);
        if (this._pages.length > 0) for(var i = 0; i < requestedNumberOfPages; i++){
            var page = this._pages[i];
            var renderedItem = this.isElementAllowed(page) ? page.render() : undefined;
            renderedItem === null || renderedItem === void 0 || renderedItem.classList.add("ac-carousel-page");
            (_a = renderedItem === null || renderedItem === void 0 ? void 0 : renderedItem.children[0]) === null || _a === void 0 || _a.classList.add("ac-carousel-page-container");
            if (renderedItem) {
                $F6YrP.appendChild(carouselWrapper, renderedItem);
                this._renderedPages.push(page);
            }
        }
        carouselContainer.appendChild(carouselWrapper);
        carouselContainer.tabIndex = this.isDesignMode() ? -1 : 0;
        containerForAdorners.appendChild(carouselContainer);
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        this.applyRTL(pagination);
        if (!this.isDesignMode()) {
            if (this.isValidRenderedPageIndex(this.initialPageIndex)) this._currentIndex = this.initialPageIndex;
            else {
                console.warn($24F6S.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
                this._currentIndex = 0;
            }
        }
        this.initializeCarouselControl(carouselContainer, nextElementDiv, prevElementDiv, pagination, this.rtl);
        return this._renderedPages.length > 0 ? cardLevelContainer : undefined;
    };
    Carousel.prototype.applyRTL = function(pagination) {
        _super.prototype.applyRTL.call(this, this._carouselPageContainer);
        if (this.rtl) pagination.classList.add(this.hostConfig.makeCssClassName("ac-carousel-pagination-rtl"));
    };
    Carousel.prototype.validateOrientationProperties = function() {
        if (!this.carouselHeight) this.carouselOrientation = $gIXBn.Orientation.Horizontal;
    };
    Carousel.prototype.updateCssForHorizontalCarousel = function(prevElementDiv, nextElementDiv) {
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-left"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-right"));
    };
    Carousel.prototype.updateCssForVerticalCarousel = function(navigationContainer, prevElementDiv, nextElementDiv) {
        this._containerForAdorners.classList.add(this.hostConfig.makeCssClassName("ac-carousel-container-vertical"));
        navigationContainer.classList.add(this.hostConfig.makeCssClassName("ac-carousel-navigation-vertical"));
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-up"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-down"));
    };
    Carousel.prototype.initializeCarouselControl = function(carouselContainer, nextElement, prevElement, paginationElement, rtl) {
        var _this = this;
        var _a, _b, _c;
        var nextElementAdjustedForRtl = rtl === undefined || !rtl ? nextElement : prevElement;
        var prevElementAdjustedForRtl = rtl === undefined || !rtl ? prevElement : nextElement;
        var prevElementAdjustedForOrientation = $gIXBn.Orientation.Horizontal === this.carouselOrientation ? prevElementAdjustedForRtl : prevElement;
        var nextElementAdjustedForOrientation = $gIXBn.Orientation.Horizontal === this.carouselOrientation ? nextElementAdjustedForRtl : nextElement;
        var swiperOptions = {
            loop: !this.isDesignMode() && this.carouselLoop,
            modules: [
                $awlOA.default,
                $deIcY.default,
                $4648Z.default,
                $jITlg.default,
                $PP3xB.default,
                $8Q03I.default
            ],
            pagination: {
                el: paginationElement,
                clickable: true
            },
            navigation: {
                prevEl: prevElementAdjustedForOrientation,
                nextEl: nextElementAdjustedForOrientation
            },
            a11y: {
                enabled: true
            },
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },
            direction: this.carouselOrientation === $gIXBn.Orientation.Horizontal ? "horizontal" : "vertical",
            resizeObserver: false,
            initialSlide: this._currentIndex
        };
        if (this.timer && !this.isDesignMode()) {
            (_a = swiperOptions.modules) === null || _a === void 0 || _a.push($j1U9P.default);
            swiperOptions.autoplay = {
                delay: this.timer,
                pauseOnMouseEnter: true
            };
        }
        var carousel = new $dQfLu.default(carouselContainer, swiperOptions);
        // While the 'pauseOnMouseEnter' option should resume autoplay on
        // mouse exit it doesn't do it, so adding custom events to handle it
        carouselContainer.addEventListener("mouseenter", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.stop();
        });
        carouselContainer.addEventListener("mouseleave", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.start();
        });
        carousel.on('navigationNext', function(swiper) {
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.NavigationNext);
        });
        carousel.on('navigationPrev', function(swiper) {
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.NavigationPrevious);
        });
        carousel.on('slideChangeTransitionEnd', function(swiper) {
            _this.currentIndex = swiper.realIndex;
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.Pagination);
        });
        carousel.on('autoplay', function() {
            _this.raiseCarouselEvent($gIXBn.CarouselInteractionEvent.Autoplay);
        });
        carousel.on('paginationRender', function(swiper, paginationEl) {
            swiper.pagination.bullets.forEach(function(bullet, index) {
                bullet.addEventListener("keypress", function(event) {
                    if (event.key == "Enter") {
                        event.preventDefault();
                        swiper.slideTo(index + 1);
                    }
                });
            });
        });
        carousel.on('destroy', function() {
            _this.destroyResizeObserver();
        });
        prevElement.title = (_b = prevElement.ariaLabel) !== null && _b !== void 0 ? _b : $24F6S.Strings.defaults.carouselNavigationPreviousTooltip();
        nextElement.title = (_c = nextElement.ariaLabel) !== null && _c !== void 0 ? _c : $24F6S.Strings.defaults.carouselNavigationNextTooltip();
        this._carousel = carousel;
        this.createResizeObserver();
    };
    Carousel.prototype.createCarouselPageInstance = function(source, context) {
        return context.parseCardObject(this, source, this.forbiddenChildElements(), !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "CarouselPage" ? new $6a95b9bcd8d58230$var$CarouselPage() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    Carousel.prototype.slideTo = function(index) {
        var _a;
        (_a = this._carousel) === null || _a === void 0 || _a.slideTo(index);
    };
    Object.defineProperty(Carousel.prototype, "carouselPageContainer", {
        get: function() {
            return this._carouselPageContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentIndex", {
        get: function() {
            return this._currentIndex;
        },
        set: function(currentIndex) {
            this._currentIndex = currentIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.createCarouselEvent = function(type) {
        var currentPageId;
        if (this.currentPageIndex != undefined) currentPageId = this.getItemAt(this.currentPageIndex).id;
        return new $6a95b9bcd8d58230$var$CarouselEvent(type, this.id, currentPageId, this.currentPageIndex);
    };
    Carousel.prototype.raiseCarouselEvent = function(eventType) {
        var card = this.parent ? this.parent.getRootElement() : undefined;
        var onCarouselEventHandler = card && card.onCarouselEvent ? card.onCarouselEvent : $6XfIC.AdaptiveCard.onCarouselEvent;
        // pagination event is triggered on slide transition end event 
        if (onCarouselEventHandler && eventType == $gIXBn.CarouselInteractionEvent.Pagination) // returns the event type that causes slide transition
        onCarouselEventHandler(this.createCarouselEvent(this.previousEventType));
        this.previousEventType = eventType;
    };
    /// Swiper version 8 added requestAnimationFrame() call in its resize observer code
    /// The new call causes flickering issue,
    /// We've copied resize observer code from Swiper version 7 with some modifications
    Carousel.prototype.createResizeObserver = function() {
        var _this = this;
        var _a;
        if (!this.checkIfCarouselInValidStateForResizeEvent()) return;
        this._observer = new ResizeObserver(function(entries) {
            var _a, _b, _c, _d;
            var width = (_a = _this._carousel) === null || _a === void 0 ? void 0 : _a.width;
            var height = (_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function(_a) {
                var _b;
                var contentBoxSize = _a.contentBoxSize, contentRect = _a.contentRect, target = _a.target;
                if (target && target !== ((_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.el)) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
                if (_this.checkIfCarouselInValidStateForResizeEvent()) {
                    (_c = _this._carousel) === null || _c === void 0 || _c.emit('beforeResize');
                    (_d = _this._carousel) === null || _d === void 0 || _d.emit('resize');
                }
            }
        });
        this._observer.observe((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el);
    };
    Carousel.prototype.destroyResizeObserver = function() {
        var _a;
        if (this._observer && this._observer.unobserve && ((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el)) {
            this._observer.unobserve(this._carousel.el);
            this._observer = null;
        }
    };
    Carousel.prototype.checkIfCarouselInValidStateForResizeEvent = function() {
        return this._carousel && !this._carousel.destroyed;
    };
    Carousel.timerProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "timer", undefined);
    Carousel.initialPageProperty = new $5Ougt.NumProperty($5Ougt.Versions.v1_6, "initialPage", 0);
    Carousel.loopProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_6, "loop", true);
    Carousel.orientationProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_6, "orientation", $gIXBn.Orientation, $gIXBn.Orientation.Horizontal);
    Carousel.carouselHeightProperty = new $5Ougt.PixelSizeProperty($5Ougt.Versions.v1_6, "heightInPixels");
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.timerProperty)
    ], Carousel.prototype, "timer", null);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.initialPageProperty)
    ], Carousel.prototype, "initialPageIndex", null);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.loopProperty)
    ], Carousel.prototype, "carouselLoop", void 0);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.orientationProperty)
    ], Carousel.prototype, "carouselOrientation", void 0);
    $6a95b9bcd8d58230$var$__decorate([
        (0, $5Ougt.property)(Carousel.carouselHeightProperty)
    ], Carousel.prototype, "carouselHeight", void 0);
    return Carousel;
}($6XfIC.Container);
module.exports.Carousel = $6a95b9bcd8d58230$var$Carousel;
var $6a95b9bcd8d58230$var$CarouselEvent = /** @class */ function() {
    function CarouselEvent(type, carouselId, activeCarouselPageId, activeCarouselPageIndex) {
        this.type = type;
        this.carouselId = carouselId;
        this.activeCarouselPageId = activeCarouselPageId;
        this.activeCarouselPageIndex = activeCarouselPageIndex;
    }
    return CarouselEvent;
}();
module.exports.CarouselEvent = $6a95b9bcd8d58230$var$CarouselEvent;
$2Zn2I.GlobalRegistry.defaultElements.register("Carousel", $6a95b9bcd8d58230$var$Carousel, $5Ougt.Versions.v1_6);

});
parcelRegister("b6mvZ", function(module, exports) {

$parcel$export(module.exports, "Swiper", () => (parcelRequire("dQfLu")).default);
$parcel$export(module.exports, "Keyboard", () => (parcelRequire("8Q03I")).default);
$parcel$export(module.exports, "Navigation", () => (parcelRequire("awlOA")).default);
$parcel$export(module.exports, "Pagination", () => (parcelRequire("deIcY")).default);
$parcel$export(module.exports, "Scrollbar", () => (parcelRequire("4648Z")).default);
$parcel$export(module.exports, "A11y", () => (parcelRequire("jITlg")).default);
$parcel$export(module.exports, "History", () => (parcelRequire("PP3xB")).default);
$parcel$export(module.exports, "Autoplay", () => (parcelRequire("j1U9P")).default);
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ 
var $dQfLu = parcelRequire("dQfLu");

var $4qE3U = parcelRequire("4qE3U");

var $8Q03I = parcelRequire("8Q03I");

var $5nU4l = parcelRequire("5nU4l");

var $awlOA = parcelRequire("awlOA");

var $deIcY = parcelRequire("deIcY");

var $4648Z = parcelRequire("4648Z");

var $em541 = parcelRequire("em541");

var $chcb1 = parcelRequire("chcb1");

var $cmf7N = parcelRequire("cmf7N");

var $6P4A4 = parcelRequire("6P4A4");

var $jITlg = parcelRequire("jITlg");

var $PP3xB = parcelRequire("PP3xB");

var $8MXvy = parcelRequire("8MXvy");

var $j1U9P = parcelRequire("j1U9P");

var $1zOwu = parcelRequire("1zOwu");

var $i1zC2 = parcelRequire("i1zC2");

var $5RFYN = parcelRequire("5RFYN");

var $8okVo = parcelRequire("8okVo");

var $6SK5Z = parcelRequire("6SK5Z");

var $4ORyx = parcelRequire("4ORyx");

var $4lZfa = parcelRequire("4lZfa");

var $4abV7 = parcelRequire("4abV7");

var $cNzyd = parcelRequire("cNzyd");

var $gdzc7 = parcelRequire("gdzc7");

});
parcelRegister("dQfLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a13c5c430bd4eedc$export$2e2bcd8739ae039);
/* eslint no-param-reassign: "off" */ 
var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");

var $1mfhi = parcelRequire("1mfhi");

var $a4AaA = parcelRequire("a4AaA");

var $c7sep = parcelRequire("c7sep");

var $9ds5j = parcelRequire("9ds5j");

var $cLreg = parcelRequire("cLreg");

var $fRG22 = parcelRequire("fRG22");

var $htB5L = parcelRequire("htB5L");

var $btAdb = parcelRequire("btAdb");

var $lOBx6 = parcelRequire("lOBx6");

var $2mxRy = parcelRequire("2mxRy");

var $lRvCK = parcelRequire("lRvCK");

var $l71cV = parcelRequire("l71cV");

var $i0518 = parcelRequire("i0518");

var $54oKQ = parcelRequire("54oKQ");

var $6ZMCi = parcelRequire("6ZMCi");

var $3JPaV = parcelRequire("3JPaV");

var $avmYP = parcelRequire("avmYP");

var $jnHEu = parcelRequire("jnHEu");

var $604MY = parcelRequire("604MY");
const $a13c5c430bd4eedc$var$prototypes = {
    eventsEmitter: $fRG22.default,
    update: $htB5L.default,
    translate: $btAdb.default,
    transition: $lOBx6.default,
    slide: $2mxRy.default,
    loop: $lRvCK.default,
    grabCursor: $l71cV.default,
    events: $i0518.default,
    breakpoints: $54oKQ.default,
    checkOverflow: $avmYP.default,
    classes: $6ZMCi.default,
    images: $3JPaV.default
};
const $a13c5c430bd4eedc$var$extendedDefaults = {};
class $a13c5c430bd4eedc$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $7XrMI.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $diCnN.default)(params.el).length > 1) {
            const swipers = [];
            (0, $diCnN.default)(params.el).each((containerEl)=>{
                const newParams = (0, $7XrMI.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new $a13c5c430bd4eedc$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $1mfhi.getSupport)();
        swiper.device = (0, $a4AaA.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $c7sep.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $604MY.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $7XrMI.extend)({}, (0, $jnHEu.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $7XrMI.extend)({}, swiperParams, $a13c5c430bd4eedc$var$extendedDefaults, params);
        swiper.originalParams = (0, $7XrMI.extend)({}, swiper.params);
        swiper.passedParams = (0, $7XrMI.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $diCnN.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $diCnN.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $7XrMI.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $diCnN.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $diCnN.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $diCnN.default)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $d1zq2.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $diCnN.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $7XrMI.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $7XrMI.extend)($a13c5c430bd4eedc$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $a13c5c430bd4eedc$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $jnHEu.default;
    }
    static installModule(mod) {
        if (!$a13c5c430bd4eedc$var$Swiper.prototype.__modules__) $a13c5c430bd4eedc$var$Swiper.prototype.__modules__ = [];
        const modules = $a13c5c430bd4eedc$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$a13c5c430bd4eedc$var$Swiper.installModule(m));
            return $a13c5c430bd4eedc$var$Swiper;
        }
        $a13c5c430bd4eedc$var$Swiper.installModule(module);
        return $a13c5c430bd4eedc$var$Swiper;
    }
}
Object.keys($a13c5c430bd4eedc$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($a13c5c430bd4eedc$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $a13c5c430bd4eedc$var$Swiper.prototype[protoMethod] = $a13c5c430bd4eedc$var$prototypes[prototypeGroup][protoMethod];
    });
});
$a13c5c430bd4eedc$var$Swiper.use([
    (0, $9ds5j.default),
    (0, $cLreg.default)
]);
var $a13c5c430bd4eedc$export$2e2bcd8739ae039 = $a13c5c430bd4eedc$var$Swiper;

});
parcelRegister("d1zq2", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $97b6d7d0165eea06$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $97b6d7d0165eea06$export$38b2d434cce3ea22);
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $97b6d7d0165eea06$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $97b6d7d0165eea06$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($97b6d7d0165eea06$var$isObject(src[key]) && $97b6d7d0165eea06$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $97b6d7d0165eea06$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $97b6d7d0165eea06$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $97b6d7d0165eea06$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $97b6d7d0165eea06$export$8b58be045bf06082(doc, $97b6d7d0165eea06$export$3fdcb9b4d81368d8);
    return doc;
}
const $97b6d7d0165eea06$export$8582633f185c62bb = {
    document: $97b6d7d0165eea06$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $97b6d7d0165eea06$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $97b6d7d0165eea06$export$8b58be045bf06082(win, $97b6d7d0165eea06$export$8582633f185c62bb);
    return win;
}

});

parcelRegister("diCnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aeabad7b7a7973d$export$2e2bcd8739ae039);

var $juGff = parcelRequire("juGff");
const $9aeabad7b7a7973d$var$Methods = {
    addClass: $juGff.addClass,
    removeClass: $juGff.removeClass,
    hasClass: $juGff.hasClass,
    toggleClass: $juGff.toggleClass,
    attr: $juGff.attr,
    removeAttr: $juGff.removeAttr,
    transform: $juGff.transform,
    transition: $juGff.transition,
    on: $juGff.on,
    off: $juGff.off,
    trigger: $juGff.trigger,
    transitionEnd: $juGff.transitionEnd,
    outerWidth: $juGff.outerWidth,
    outerHeight: $juGff.outerHeight,
    styles: $juGff.styles,
    offset: $juGff.offset,
    css: $juGff.css,
    each: $juGff.each,
    html: $juGff.html,
    text: $juGff.text,
    is: $juGff.is,
    index: $juGff.index,
    eq: $juGff.eq,
    append: $juGff.append,
    prepend: $juGff.prepend,
    next: $juGff.next,
    nextAll: $juGff.nextAll,
    prev: $juGff.prev,
    prevAll: $juGff.prevAll,
    parent: $juGff.parent,
    parents: $juGff.parents,
    closest: $juGff.closest,
    find: $juGff.find,
    children: $juGff.children,
    filter: $juGff.filter,
    remove: $juGff.remove
};
Object.keys($9aeabad7b7a7973d$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $juGff.$).fn, methodName, {
        value: $9aeabad7b7a7973d$var$Methods[methodName],
        writable: true
    });
});
var $9aeabad7b7a7973d$export$2e2bcd8739ae039 = (0, $juGff.$);

});
parcelRegister("juGff", function(module, exports) {

$parcel$export(module.exports, "$", () => $);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "transform", () => transform);
$parcel$export(module.exports, "transition", () => transition);
$parcel$export(module.exports, "on", () => on);
$parcel$export(module.exports, "off", () => off);
$parcel$export(module.exports, "trigger", () => trigger);
$parcel$export(module.exports, "transitionEnd", () => transitionEnd);
$parcel$export(module.exports, "outerWidth", () => outerWidth);
$parcel$export(module.exports, "outerHeight", () => outerHeight);
$parcel$export(module.exports, "offset", () => offset);
$parcel$export(module.exports, "styles", () => styles);
$parcel$export(module.exports, "css", () => css);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "remove", () => remove);
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $d1zq2 = parcelRequire("d1zq2");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $d1zq2.getWindow)();
    const document = (0, $d1zq2.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $d1zq2.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $d1zq2.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $d1zq2.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $d1zq2.getWindow)();
        const document = (0, $d1zq2.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $d1zq2.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $d1zq2.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $d1zq2.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $d1zq2.getWindow)();
    const document = (0, $d1zq2.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $d1zq2.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $d1zq2.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $d1zq2.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $d1zq2.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $e31196a498af4f21$export$2e2bcd8739ae039 = $;

});


parcelRegister("7XrMI", function(module, exports) {

$parcel$export(module.exports, "deleteProps", () => $5cb3988f52077c60$export$8694e5c03a4df8e6);
$parcel$export(module.exports, "nextTick", () => $5cb3988f52077c60$export$bdd553fddd433dcb);
$parcel$export(module.exports, "now", () => $5cb3988f52077c60$export$461939dd4422153);
$parcel$export(module.exports, "getTranslate", () => $5cb3988f52077c60$export$5ec402b7fcf74398);
$parcel$export(module.exports, "isObject", () => $5cb3988f52077c60$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "extend", () => $5cb3988f52077c60$export$8b58be045bf06082);
$parcel$export(module.exports, "setCSSProperty", () => $5cb3988f52077c60$export$a607267f322101fd);
$parcel$export(module.exports, "animateCSSModeScroll", () => $5cb3988f52077c60$export$a5dd2b4b1a116d6d);

var $d1zq2 = parcelRequire("d1zq2");
function $5cb3988f52077c60$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $5cb3988f52077c60$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $5cb3988f52077c60$export$461939dd4422153() {
    return Date.now();
}
function $5cb3988f52077c60$export$3735103072e4a80(el) {
    const window1 = (0, $d1zq2.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $5cb3988f52077c60$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $d1zq2.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $5cb3988f52077c60$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $5cb3988f52077c60$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $5cb3988f52077c60$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $5cb3988f52077c60$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$5cb3988f52077c60$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($5cb3988f52077c60$export$a6cdc56e425d0d0a(to[nextKey]) && $5cb3988f52077c60$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $5cb3988f52077c60$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$5cb3988f52077c60$export$a6cdc56e425d0d0a(to[nextKey]) && $5cb3988f52077c60$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $5cb3988f52077c60$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $5cb3988f52077c60$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $5cb3988f52077c60$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $d1zq2.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

});

parcelRegister("1mfhi", function(module, exports) {

$parcel$export(module.exports, "getSupport", () => $0fd3b2685b7b465b$export$d61c7b85ff180578);

var $d1zq2 = parcelRequire("d1zq2");
let $0fd3b2685b7b465b$var$support;
function $0fd3b2685b7b465b$var$calcSupport() {
    const window = (0, $d1zq2.getWindow)();
    const document = (0, $d1zq2.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $0fd3b2685b7b465b$export$d61c7b85ff180578() {
    if (!$0fd3b2685b7b465b$var$support) $0fd3b2685b7b465b$var$support = $0fd3b2685b7b465b$var$calcSupport();
    return $0fd3b2685b7b465b$var$support;
}

});

parcelRegister("a4AaA", function(module, exports) {

$parcel$export(module.exports, "getDevice", () => $755655a3649a303b$export$30c823bc834d6ab4);

var $d1zq2 = parcelRequire("d1zq2");

var $1mfhi = parcelRequire("1mfhi");
let $755655a3649a303b$var$deviceCached;
function $755655a3649a303b$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $1mfhi.getSupport)();
    const window = (0, $d1zq2.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $755655a3649a303b$export$30c823bc834d6ab4(overrides = {}) {
    if (!$755655a3649a303b$var$deviceCached) $755655a3649a303b$var$deviceCached = $755655a3649a303b$var$calcDevice(overrides);
    return $755655a3649a303b$var$deviceCached;
}

});

parcelRegister("c7sep", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $8d2c09a154c94fb0$export$89e15fc796a4a429);

var $d1zq2 = parcelRequire("d1zq2");
let $8d2c09a154c94fb0$var$browser;
function $8d2c09a154c94fb0$var$calcBrowser() {
    const window = (0, $d1zq2.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $8d2c09a154c94fb0$export$89e15fc796a4a429() {
    if (!$8d2c09a154c94fb0$var$browser) $8d2c09a154c94fb0$var$browser = $8d2c09a154c94fb0$var$calcBrowser();
    return $8d2c09a154c94fb0$var$browser;
}

});

parcelRegister("9ds5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5b1cf83f516a8f$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $6b5b1cf83f516a8f$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $d1zq2.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}

});

parcelRegister("cLreg", function(module, exports) {

$parcel$export(module.exports, "default", () => $94aefef3f61bdaa4$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $94aefef3f61bdaa4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $d1zq2.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}

});

parcelRegister("fRG22", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8cc68e19e08afc2$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ var $b8cc68e19e08afc2$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

});

parcelRegister("htB5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb91eaca9de20e96$export$2e2bcd8739ae039);

var $eTgqb = parcelRequire("eTgqb");

var $1TFQ7 = parcelRequire("1TFQ7");

var $cJm1s = parcelRequire("cJm1s");

var $1ymZz = parcelRequire("1ymZz");

var $7w1gy = parcelRequire("7w1gy");

var $7aUF8 = parcelRequire("7aUF8");

var $eCbgU = parcelRequire("eCbgU");

var $ifTqA = parcelRequire("ifTqA");

var $39WX8 = parcelRequire("39WX8");
var $cb91eaca9de20e96$export$2e2bcd8739ae039 = {
    updateSize: $eTgqb.default,
    updateSlides: $1TFQ7.default,
    updateAutoHeight: $cJm1s.default,
    updateSlidesOffset: $1ymZz.default,
    updateSlidesProgress: $7w1gy.default,
    updateProgress: $7aUF8.default,
    updateSlidesClasses: $eCbgU.default,
    updateActiveIndex: $ifTqA.default,
    updateClickedSlide: $39WX8.default
};

});
parcelRegister("eTgqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad72f0b20284c27d$export$2e2bcd8739ae039);
function $ad72f0b20284c27d$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}

});

parcelRegister("1TFQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $161b61f4b9a58a65$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $161b61f4b9a58a65$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}

});

parcelRegister("cJm1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $944ac532c60ecaf3$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $944ac532c60ecaf3$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $diCnN.default)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}

});

parcelRegister("1ymZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $121acd2f593ea6c6$export$2e2bcd8739ae039);
function $121acd2f593ea6c6$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

});

parcelRegister("7w1gy", function(module, exports) {

$parcel$export(module.exports, "default", () => $578c80f3d9963634$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $578c80f3d9963634$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $diCnN.default)(swiper.visibleSlides);
}

});

parcelRegister("7aUF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $53956b89e3712b61$export$2e2bcd8739ae039);
function $53956b89e3712b61$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}

});

parcelRegister("eCbgU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa3d5b9c9656698b$export$2e2bcd8739ae039);
function $aa3d5b9c9656698b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

});

parcelRegister("ifTqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a49f82b66da990$export$2e2bcd8739ae039);
function $d4a49f82b66da990$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}

});

parcelRegister("39WX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $24cff12a3882e474$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $24cff12a3882e474$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $diCnN.default)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $diCnN.default)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

});


parcelRegister("btAdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ae7e05440bb5df$export$2e2bcd8739ae039);

var $smOwM = parcelRequire("smOwM");

var $8lZy6 = parcelRequire("8lZy6");

var $boKRy = parcelRequire("boKRy");

var $9Dun6 = parcelRequire("9Dun6");

var $bXnJp = parcelRequire("bXnJp");
var $85ae7e05440bb5df$export$2e2bcd8739ae039 = {
    getTranslate: $smOwM.default,
    setTranslate: $8lZy6.default,
    minTranslate: $boKRy.default,
    maxTranslate: $9Dun6.default,
    translateTo: $bXnJp.default
};

});
parcelRegister("smOwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $055450046e4698cd$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $055450046e4698cd$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $7XrMI.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

});

parcelRegister("8lZy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $61500742c901f0f5$export$2e2bcd8739ae039);
function $61500742c901f0f5$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}

});

parcelRegister("boKRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c64996406e568d$export$2e2bcd8739ae039);
function $84c64996406e568d$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}

});

parcelRegister("9Dun6", function(module, exports) {

$parcel$export(module.exports, "default", () => $703f50c31e565a1d$export$2e2bcd8739ae039);
function $703f50c31e565a1d$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

});

parcelRegister("bXnJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b479cf4bda6936d$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $8b479cf4bda6936d$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $7XrMI.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

});


parcelRegister("lOBx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1b61c321437e48$export$2e2bcd8739ae039);

var $59zek = parcelRequire("59zek");

var $hpASV = parcelRequire("hpASV");

var $chuxE = parcelRequire("chuxE");
var $fe1b61c321437e48$export$2e2bcd8739ae039 = {
    setTransition: $59zek.default,
    transitionStart: $hpASV.default,
    transitionEnd: $chuxE.default
};

});
parcelRegister("59zek", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c091efdadc3c71a$export$2e2bcd8739ae039);
function $3c091efdadc3c71a$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}

});

parcelRegister("hpASV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad16206409b0957$export$2e2bcd8739ae039);

var $86f2w = parcelRequire("86f2w");
function $cad16206409b0957$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $86f2w.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}

});
parcelRegister("86f2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5a8cd309859a6c$export$2e2bcd8739ae039);
function $5e5a8cd309859a6c$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}

});


parcelRegister("chuxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f0ec38906b8c141$export$2e2bcd8739ae039);

var $86f2w = parcelRequire("86f2w");
function $8f0ec38906b8c141$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $86f2w.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}

});


parcelRegister("2mxRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b87e743e7ead7c6$export$2e2bcd8739ae039);

var $k3KuU = parcelRequire("k3KuU");

var $fXSr2 = parcelRequire("fXSr2");

var $ehhOe = parcelRequire("ehhOe");

var $ej3AS = parcelRequire("ej3AS");

var $9FqR6 = parcelRequire("9FqR6");

var $3VIFz = parcelRequire("3VIFz");

var $3SsfN = parcelRequire("3SsfN");
var $1b87e743e7ead7c6$export$2e2bcd8739ae039 = {
    slideTo: $k3KuU.default,
    slideToLoop: $fXSr2.default,
    slideNext: $ehhOe.default,
    slidePrev: $ej3AS.default,
    slideReset: $9FqR6.default,
    slideToClosest: $3VIFz.default,
    slideToClickedSlide: $3SsfN.default
};

});
parcelRegister("k3KuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9a827ec34e0dc2e$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $e9a827ec34e0dc2e$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $7XrMI.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

});

parcelRegister("fXSr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f697654e552d5d$export$2e2bcd8739ae039);
function $b9f697654e552d5d$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

});

parcelRegister("ehhOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65077c2d527a347$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $a65077c2d527a347$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

});

parcelRegister("ej3AS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6a5a0b5eba97a1e$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $a6a5a0b5eba97a1e$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

});

parcelRegister("9FqR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $709cc64ef9602464$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $709cc64ef9602464$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

});

parcelRegister("3VIFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc9586134ba9a0f$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $2dc9586134ba9a0f$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

});

parcelRegister("3SsfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2c54e0696c1809$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $2d2c54e0696c1809$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $diCnN.default)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $7XrMI.nextTick)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $7XrMI.nextTick)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

});


parcelRegister("lRvCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea7140ca1a6dd40$export$2e2bcd8739ae039);

var $lAzGI = parcelRequire("lAzGI");

var $1rqvj = parcelRequire("1rqvj");

var $5nNGT = parcelRequire("5nNGT");
var $fea7140ca1a6dd40$export$2e2bcd8739ae039 = {
    loopCreate: $lAzGI.default,
    loopFix: $1rqvj.default,
    loopDestroy: $5nNGT.default
};

});
parcelRegister("lAzGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb78a4a7feba37e5$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $fb78a4a7feba37e5$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $d1zq2.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $diCnN.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $diCnN.default)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $diCnN.default)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $diCnN.default)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $diCnN.default)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}

});

parcelRegister("1rqvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ccdf3837023031$export$2e2bcd8739ae039);
function $10ccdf3837023031$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}

});

parcelRegister("5nNGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb5a5494b15f128$export$2e2bcd8739ae039);
function $3eb5a5494b15f128$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}

});


parcelRegister("l71cV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5eb303010685450$export$2e2bcd8739ae039);

var $jfK8n = parcelRequire("jfK8n");

var $8LU4Y = parcelRequire("8LU4Y");
var $f5eb303010685450$export$2e2bcd8739ae039 = {
    setGrabCursor: $jfK8n.default,
    unsetGrabCursor: $8LU4Y.default
};

});
parcelRegister("jfK8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0433455a3d4258c$export$2e2bcd8739ae039);
function $e0433455a3d4258c$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}

});

parcelRegister("8LU4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $662e36ae4c9fe3ff$export$2e2bcd8739ae039);
function $662e36ae4c9fe3ff$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

});


parcelRegister("i0518", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1ac1e69f48928d0$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $3z83Q = parcelRequire("3z83Q");

var $kBLP4 = parcelRequire("kBLP4");

var $gNYUo = parcelRequire("gNYUo");

var $h4iS9 = parcelRequire("h4iS9");

var $lUNYV = parcelRequire("lUNYV");

var $1gmp9 = parcelRequire("1gmp9");
let $d1ac1e69f48928d0$var$dummyEventAttached = false;
function $d1ac1e69f48928d0$var$dummyEventListener() {}
const $d1ac1e69f48928d0$var$events = (swiper, method)=>{
    const document = (0, $d1zq2.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $h4iS9.default), true);
    else swiper[swiperMethod]('observerUpdate', (0, $h4iS9.default), true);
};
function $d1ac1e69f48928d0$var$attachEvents() {
    const swiper = this;
    const document = (0, $d1zq2.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $3z83Q.default).bind(swiper);
    swiper.onTouchMove = (0, $kBLP4.default).bind(swiper);
    swiper.onTouchEnd = (0, $gNYUo.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $1gmp9.default).bind(swiper);
    swiper.onClick = (0, $lUNYV.default).bind(swiper);
    if (support.touch && !$d1ac1e69f48928d0$var$dummyEventAttached) {
        document.addEventListener('touchstart', $d1ac1e69f48928d0$var$dummyEventListener);
        $d1ac1e69f48928d0$var$dummyEventAttached = true;
    }
    $d1ac1e69f48928d0$var$events(swiper, 'on');
}
function $d1ac1e69f48928d0$var$detachEvents() {
    const swiper = this;
    $d1ac1e69f48928d0$var$events(swiper, 'off');
}
var $d1ac1e69f48928d0$export$2e2bcd8739ae039 = {
    attachEvents: $d1ac1e69f48928d0$var$attachEvents,
    detachEvents: $d1ac1e69f48928d0$var$detachEvents
};

});
parcelRegister("3z83Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $298ae4b6816188f8$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $298ae4b6816188f8$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $d1zq2.getDocument)() || el === (0, $d1zq2.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $298ae4b6816188f8$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $d1zq2.getDocument)();
    const window = (0, $d1zq2.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $diCnN.default)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $diCnN.default)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $298ae4b6816188f8$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $7XrMI.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $diCnN.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}

});

parcelRegister("kBLP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00c5bedfedc8a94$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $f00c5bedfedc8a94$export$2e2bcd8739ae039(event) {
    const document = (0, $d1zq2.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $diCnN.default)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $7XrMI.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $diCnN.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

});

parcelRegister("gNYUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c07819907689a9$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $c3c07819907689a9$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $7XrMI.now)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $7XrMI.now)();
    (0, $7XrMI.nextTick)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

});

parcelRegister("h4iS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d173118330172b$export$2e2bcd8739ae039);
function $c6d173118330172b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

});

parcelRegister("lUNYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff45993fdc966e91$export$2e2bcd8739ae039);
function $ff45993fdc966e91$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

});

parcelRegister("1gmp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb8aa2c0f224c8d$export$2e2bcd8739ae039);
function $0eb8aa2c0f224c8d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}

});


parcelRegister("54oKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b10873badb9fe7a$export$2e2bcd8739ae039);

var $8HGoa = parcelRequire("8HGoa");

var $gWhU5 = parcelRequire("gWhU5");
var $3b10873badb9fe7a$export$2e2bcd8739ae039 = {
    setBreakpoint: $8HGoa.default,
    getBreakpoint: $gWhU5.default
};

});
parcelRegister("8HGoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $65633865cc209c59$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
const $65633865cc209c59$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $65633865cc209c59$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $65633865cc209c59$var$isGridEnabled(swiper, params);
    const isMultiRow = $65633865cc209c59$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $7XrMI.extend)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}

});

parcelRegister("gWhU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54ff367fda7fe4c$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $c54ff367fda7fe4c$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $d1zq2.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}

});


parcelRegister("6ZMCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $517e26dd5ba0a5eb$export$2e2bcd8739ae039);

var $fEGg7 = parcelRequire("fEGg7");

var $crzJO = parcelRequire("crzJO");
var $517e26dd5ba0a5eb$export$2e2bcd8739ae039 = {
    addClasses: $fEGg7.default,
    removeClasses: $crzJO.default
};

});
parcelRegister("fEGg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65b5f367e9b61a6$export$2e2bcd8739ae039);
function $b65b5f367e9b61a6$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $b65b5f367e9b61a6$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $b65b5f367e9b61a6$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}

});

parcelRegister("crzJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f3ba735cc74ac7$export$2e2bcd8739ae039);
function $90f3ba735cc74ac7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}

});


parcelRegister("3JPaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8d45647d2e7329$export$2e2bcd8739ae039);

var $cwoSt = parcelRequire("cwoSt");

var $fqMST = parcelRequire("fqMST");
var $2b8d45647d2e7329$export$2e2bcd8739ae039 = {
    loadImage: $cwoSt.default,
    preloadImages: $fqMST.default
};

});
parcelRegister("cwoSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $91dbc56336164767$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $91dbc56336164767$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $d1zq2.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $diCnN.default)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

});

parcelRegister("fqMST", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3bf3428b3616c22$export$2e2bcd8739ae039);
function $b3bf3428b3616c22$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}

});


parcelRegister("avmYP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5e9fffa3772a51$export$2e2bcd8739ae039);
function $7a5e9fffa3772a51$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $7a5e9fffa3772a51$export$2e2bcd8739ae039 = {
    checkOverflow: $7a5e9fffa3772a51$var$checkOverflow
};

});

parcelRegister("jnHEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c206ae04cf20e6$export$2e2bcd8739ae039);
var $e1c206ae04cf20e6$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

});

parcelRegister("604MY", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e6751f444d0888$export$2e2bcd8739ae039);

var $7XrMI = parcelRequire("7XrMI");
function $45e6751f444d0888$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $7XrMI.extend)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $7XrMI.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $7XrMI.extend)(allModulesParams, obj);
    };
}

});


parcelRegister("4qE3U", function(module, exports) {

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $3398aa9a88cda661$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $diCnN.default)(params.renderSlide.call(swiper, slide, index)) : (0, $diCnN.default)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $7XrMI.setCSSProperty)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});

parcelRegister("8Q03I", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f339c047af0ca3$export$2e2bcd8739ae039);
/* eslint-disable consistent-return */ 
var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $66f339c047af0ca3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $d1zq2.getDocument)();
    const window = (0, $d1zq2.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $diCnN.default)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $diCnN.default)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("5nU4l", function(module, exports) {
/* eslint-disable consistent-return */ 
var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $3eba97dc8ce69d05$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $d1zq2.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $7XrMI.now)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $7XrMI.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $7XrMI.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $diCnN.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $7XrMI.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $7XrMI.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $7XrMI.nextTick)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $7XrMI.nextTick)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $diCnN.default)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("awlOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8dd08c709bfac3$export$2e2bcd8739ae039);

var $dvPmG = parcelRequire("dvPmG");

var $diCnN = parcelRequire("diCnN");
function $7a8dd08c709bfac3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $diCnN.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $dvPmG.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $diCnN.default)(targetEl).is($prevEl) && !(0, $diCnN.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("dvPmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d660396a7030d20$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $9d660396a7030d20$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $d1zq2.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRegister("deIcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a2ee00583712409$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");

var $5lps1 = parcelRequire("5lps1");

var $dvPmG = parcelRequire("dvPmG");
function $9a2ee00583712409$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $diCnN.default)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $5lps1.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $5lps1.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $5lps1.default)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $5lps1.default)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $dvPmG.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $diCnN.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $diCnN.default)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $5lps1.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $diCnN.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $5lps1.default)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $diCnN.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("5lps1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e42a7f54a829de6$export$2e2bcd8739ae039);
function $3e42a7f54a829de6$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}

});


parcelRegister("4648Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbaefe040bb0fa0$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");

var $dvPmG = parcelRequire("dvPmG");
function $2fbaefe040bb0fa0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $d1zq2.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $7XrMI.nextTick)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $dvPmG.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $diCnN.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $diCnN.default)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRegister("em541", function(module, exports) {

var $diCnN = parcelRequire("diCnN");
function $a7370c5a9c9596a1$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $diCnN.default)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $diCnN.default)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $diCnN.default)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRegister("chcb1", function(module, exports) {

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");

var $7XrMI = parcelRequire("7XrMI");
function $8f0084a45e083870$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $d1zq2.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $diCnN.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $7XrMI.getTranslate)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $7XrMI.getTranslate)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $diCnN.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRegister("cmf7N", function(module, exports) {

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $8ff3459092631854$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $diCnN.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $diCnN.default)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $diCnN.default)(slideEl).attr('data-swiper-slide-index');
            return (0, $diCnN.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $diCnN.default)(slideEl).attr('data-swiper-slide-index') : (0, $diCnN.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $d1zq2.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $diCnN.default)(swiper.params.lazy.scrollingElement) : (0, $diCnN.default)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}

});

parcelRegister("6P4A4", function(module, exports) {
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
var $7XrMI = parcelRequire("7XrMI");
function $4f7b0f1f7788628e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $7XrMI.nextTick)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRegister("jITlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b49900aaad77d8$export$2e2bcd8739ae039);

var $5lps1 = parcelRequire("5lps1");

var $diCnN = parcelRequire("diCnN");
function $03b49900aaad77d8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $diCnN.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $5lps1.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $diCnN.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $diCnN.default)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $diCnN.default)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $diCnN.default)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $5lps1.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $5lps1.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $diCnN.default)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRegister("PP3xB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09bc5e372596a3ae$export$2e2bcd8739ae039);

var $d1zq2 = parcelRequire("d1zq2");
function $09bc5e372596a3ae$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $d1zq2.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $d1zq2.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $d1zq2.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $d1zq2.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRegister("8MXvy", function(module, exports) {

var $d1zq2 = parcelRequire("d1zq2");

var $diCnN = parcelRequire("diCnN");
function $6660f77297e2649d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $d1zq2.getDocument)();
    const window = (0, $d1zq2.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $diCnN.default)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $diCnN.default)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRegister("j1U9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda9ac0e7bbec1b6$export$2e2bcd8739ae039);
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $d1zq2 = parcelRequire("d1zq2");

var $7XrMI = parcelRequire("7XrMI");
function $dda9ac0e7bbec1b6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $7XrMI.nextTick)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $d1zq2.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $d1zq2.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $d1zq2.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}

});

parcelRegister("1zOwu", function(module, exports) {

var $7XrMI = parcelRequire("7XrMI");

var $diCnN = parcelRequire("diCnN");
function $1260402135f6c3cd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $diCnN.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $diCnN.default)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $7XrMI.isObject)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRegister("i1zC2", function(module, exports) {

var $7XrMI = parcelRequire("7XrMI");
function $d1f3f1e65b27884e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $7XrMI.now)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $7XrMI.now)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $7XrMI.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRegister("5RFYN", function(module, exports) {
function $4452773fb1998b29$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRegister("8okVo", function(module, exports) {

var $khY8L = parcelRequire("khY8L");

var $6F8iQ = parcelRequire("6F8iQ");

var $f7QgY = parcelRequire("f7QgY");

var $583Xd = parcelRequire("583Xd");

var $j9SDI = parcelRequire("j9SDI");
function $61c0cbd63045e691$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $khY8L.default).bind(swiper),
        prependSlide: (0, $6F8iQ.default).bind(swiper),
        addSlide: (0, $f7QgY.default).bind(swiper),
        removeSlide: (0, $583Xd.default).bind(swiper),
        removeAllSlides: (0, $j9SDI.default).bind(swiper)
    });
}

});
parcelRegister("khY8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec540bcaaac9d4ac$export$2e2bcd8739ae039);
function $ec540bcaaac9d4ac$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}

});

parcelRegister("6F8iQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9d0333ba430acb$export$2e2bcd8739ae039);
function $4d9d0333ba430acb$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("f7QgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0300eb8aafe18da$export$2e2bcd8739ae039);
function $b0300eb8aafe18da$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("583Xd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc0c44b612a6f9f$export$2e2bcd8739ae039);
function $3bc0c44b612a6f9f$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("j9SDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $df293dddd08596e8$export$2e2bcd8739ae039);
function $df293dddd08596e8$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

});


parcelRegister("6SK5Z", function(module, exports) {

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $502b8adb6cb4a4dc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $7NMrF.default)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("7NMrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae2b03c299fbe65$export$2e2bcd8739ae039);
function $5ae2b03c299fbe65$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRegister("lm88n", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8c1f65604c48eed$export$2e2bcd8739ae039);
function $f8c1f65604c48eed$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}

});

parcelRegister("MAw0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $0920cef94b5a2000$export$2e2bcd8739ae039);
function $0920cef94b5a2000$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}

});


parcelRegister("4ORyx", function(module, exports) {

var $diCnN = parcelRequire("diCnN");

var $7NMrF = parcelRequire("7NMrF");
function $3825600eca4a6a65$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $diCnN.default)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $diCnN.default)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $diCnN.default)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $diCnN.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $diCnN.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $7NMrF.default)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRegister("4lZfa", function(module, exports) {

var $diCnN = parcelRequire("diCnN");

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $32b8a14866ddc825$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $h5Soo.default)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $h5Soo.default)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $diCnN.default)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $7NMrF.default)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("h5Soo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71d1880b27f3920$export$2e2bcd8739ae039);

var $diCnN = parcelRequire("diCnN");
function $c71d1880b27f3920$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $diCnN.default)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}

});


parcelRegister("4abV7", function(module, exports) {

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");
function $308157bca6d3ac93$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $h5Soo.default)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $h5Soo.default)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $7NMrF.default)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRegister("cNzyd", function(module, exports) {

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $9515a35076d2b369$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $h5Soo.default)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $7NMrF.default)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRegister("gdzc7", function(module, exports) {

var $h5Soo = parcelRequire("h5Soo");

var $7NMrF = parcelRequire("7NMrF");

var $lm88n = parcelRequire("lm88n");

var $MAw0s = parcelRequire("MAw0s");
function $bce9292623373c10$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $h5Soo.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $lm88n.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $MAw0s.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $7NMrF.default)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});



parcelRegister("bPIqH", function(module, exports) {
"use strict";
var $89d6ebee591fa135$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89d6ebee591fa135$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = module.exports.TableRow = module.exports.TableCell = module.exports.StylableContainer = module.exports.TableColumnDefinition = void 0;

var $6XfIC = parcelRequire("6XfIC");

var $gIXBn = parcelRequire("gIXBn");

var $2Zn2I = parcelRequire("2Zn2I");

var $5Ougt = parcelRequire("5Ougt");

var $6BHj7 = parcelRequire("6BHj7");

var $24F6S = parcelRequire("24F6S");

var $F6YrP = parcelRequire("F6YrP");
var $89d6ebee591fa135$var$TableColumnDefinition = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(TableColumnDefinition, _super);
    function TableColumnDefinition() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = new $6BHj7.SizeAndUnit(1, $gIXBn.SizeUnit.Weight);
        return _this;
    }
    TableColumnDefinition.prototype.getSchemaKey = function() {
        return "ColumnDefinition";
    };
    TableColumnDefinition.horizontalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "horizontalCellContentAlignment", $gIXBn.HorizontalAlignment);
    TableColumnDefinition.verticalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "verticalCellContentAlignment", $gIXBn.VerticalAlignment);
    TableColumnDefinition.widthProperty = new $5Ougt.CustomProperty($5Ougt.Versions.v1_5, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $6BHj7.SizeAndUnit(value, $gIXBn.SizeUnit.Weight);
        else if (typeof value === "string") try {
            result = $6BHj7.SizeAndUnit.parse(value);
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) context.logParseEvent(sender, $gIXBn.ValidationEvent.InvalidPropertyValue, $24F6S.Strings.errors.invalidColumnWidth(value));
        return result;
    }, function(sender, property, target, value, context) {
        if (value.unit === $gIXBn.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
        else context.serializeNumber(target, "width", value.physicalSize);
    }, new $6BHj7.SizeAndUnit(1, $gIXBn.SizeUnit.Weight));
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableColumnDefinition.horizontalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "horizontalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableColumnDefinition.verticalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "verticalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableColumnDefinition.widthProperty)
    ], TableColumnDefinition.prototype, "width", void 0);
    return TableColumnDefinition;
}($5Ougt.SerializableObject);
module.exports.TableColumnDefinition = $89d6ebee591fa135$var$TableColumnDefinition;
var $89d6ebee591fa135$var$StylableContainer = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(StylableContainer, _super);
    function StylableContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = [];
        return _this;
    }
    StylableContainer.prototype.parseItem = function(source, context) {
        var _this = this;
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return _this.createItemInstance(typeName);
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $gIXBn.ValidationEvent.ElementTypeNotAllowed, $24F6S.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    StylableContainer.prototype.internalAddItem = function(item) {
        if (!item.parent) {
            this._items.push(item);
            item.setParent(this);
        } else throw new Error($24F6S.Strings.errors.elementAlreadyParented());
    };
    StylableContainer.prototype.internalRemoveItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    StylableContainer.prototype.internalIndexOf = function(item) {
        return this._items.indexOf(item);
    };
    StylableContainer.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._items = [];
        var items = source[this.getCollectionPropertyName()];
        if (Array.isArray(items)) for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var instance = this.parseItem(item, context);
            if (instance) this._items.push(instance);
        }
    };
    StylableContainer.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, this.getCollectionPropertyName(), this._items);
    };
    StylableContainer.prototype.removeItem = function(item) {
        return this.internalRemoveItem(item);
    };
    StylableContainer.prototype.getItemCount = function() {
        return this._items.length;
    };
    StylableContainer.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    StylableContainer.prototype.getFirstVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(0) : undefined;
    };
    StylableContainer.prototype.getLastVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(this.getItemCount() - 1) : undefined;
    };
    return StylableContainer;
}($6XfIC.StylableCardElementContainer);
module.exports.StylableContainer = $89d6ebee591fa135$var$StylableContainer;
var $89d6ebee591fa135$var$TableCell = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columnIndex = -1;
        _this._cellType = "data";
        return _this;
    }
    TableCell.prototype.getHasBorder = function() {
        return this.parentRow.parentTable.showGridLines;
    };
    TableCell.prototype.applyBorder = function() {
        if (this.renderedElement && this.getHasBorder()) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.parentRow.parentTable.gridStyle);
            if (styleDefinition.borderColor) {
                var borderColor = (0, $F6YrP.stringToCssColor)(styleDefinition.borderColor);
                if (borderColor) {
                    this.renderedElement.style.borderRight = "1px solid " + borderColor;
                    this.renderedElement.style.borderBottom = "1px solid " + borderColor;
                }
            }
        }
    };
    TableCell.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $6BHj7.PaddingDefinition($gIXBn.Spacing.Small, $gIXBn.Spacing.Small, $gIXBn.Spacing.Small, $gIXBn.Spacing.Small) : _super.prototype.getDefaultPadding.call(this);
    };
    TableCell.prototype.internalRender = function() {
        var cellElement = _super.prototype.internalRender.call(this);
        if (cellElement) {
            cellElement.setAttribute("role", this.cellType === "data" ? "cell" : "columnheader");
            cellElement.style.minWidth = "0";
            if (this.cellType === "header") cellElement.setAttribute("scope", "col");
        }
        return cellElement;
    };
    TableCell.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableCell.prototype.getJsonTypeName = function() {
        return "TableCell";
    };
    TableCell.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.cellType === "header") return this.hostConfig.textStyles.columnHeader;
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TableCell.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parentRow.horizontalCellContentAlignment !== undefined) return this.parentRow.horizontalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var horizontalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).horizontalCellContentAlignment;
            if (horizontalAlignment !== undefined) return horizontalAlignment;
        }
        if (this.parentRow.parentTable.horizontalCellContentAlignment !== undefined) return this.parentRow.parentTable.horizontalCellContentAlignment;
        return _super.prototype.getEffectiveHorizontalAlignment.call(this);
    };
    TableCell.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        if (this.parentRow.verticalCellContentAlignment !== undefined) return this.parentRow.verticalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var verticalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).verticalCellContentAlignment;
            if (verticalAlignment !== undefined) return verticalAlignment;
        }
        if (this.parentRow.parentTable.verticalCellContentAlignment !== undefined) return this.parentRow.parentTable.verticalCellContentAlignment;
        return _super.prototype.getEffectiveVerticalContentAlignment.call(this);
    };
    Object.defineProperty(TableCell.prototype, "columnIndex", {
        get: function() {
            return this._columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "cellType", {
        get: function() {
            return this._cellType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "parentRow", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return TableCell;
}($6XfIC.Container);
module.exports.TableCell = $89d6ebee591fa135$var$TableCell;
var $89d6ebee591fa135$var$TableRow = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    TableRow.prototype.getDefaultPadding = function() {
        return new $6BHj7.PaddingDefinition($gIXBn.Spacing.None, $gIXBn.Spacing.None, $gIXBn.Spacing.None, $gIXBn.Spacing.None);
    };
    TableRow.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = (0, $F6YrP.stringToCssColor)(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    TableRow.prototype.getCollectionPropertyName = function() {
        return "cells";
    };
    TableRow.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableCell" ? new $89d6ebee591fa135$var$TableCell() : undefined;
    };
    TableRow.prototype.internalRender = function() {
        var isFirstRow = this.getIsFirstRow();
        var cellSpacing = this.hostConfig.table.cellSpacing;
        var rowElement = document.createElement("div");
        rowElement.setAttribute("role", "row");
        rowElement.style.display = "flex";
        rowElement.style.flexDirection = "row";
        for(var i = 0; i < Math.min(this.getItemCount(), this.parentTable.getColumnCount()); i++){
            var cell = this.getItemAt(i);
            // Cheating a bit in order to keep cellType read-only
            cell["_columnIndex"] = i;
            cell["_cellType"] = this.parentTable.firstRowAsHeaders && isFirstRow ? "header" : "data";
            var renderedCell = cell.render();
            if (renderedCell) {
                var column = this.parentTable.getColumnAt(i);
                if (column.computedWidth.unit === $gIXBn.SizeUnit.Pixel) renderedCell.style.flex = "0 0 " + column.computedWidth.physicalSize + "px";
                else renderedCell.style.flex = "1 1 " + column.computedWidth.physicalSize + "%";
                if (i > 0 && !this.parentTable.showGridLines && cellSpacing > 0) renderedCell.style.marginLeft = cellSpacing + "px";
                rowElement.appendChild(renderedCell);
            }
        }
        return rowElement.children.length > 0 ? rowElement : undefined;
    };
    TableRow.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableRow.prototype.addCell = function(cell) {
        this.internalAddItem(cell);
    };
    TableRow.prototype.removeCellAt = function(columnIndex) {
        if (columnIndex >= 0 && columnIndex < this.getItemCount()) return this.removeItem(this.getItemAt(columnIndex));
        return false;
    };
    TableRow.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $89d6ebee591fa135$var$TableCell ? this.internalIndexOf(cardElement) : -1;
    };
    TableRow.prototype.ensureHasEnoughCells = function(cellCount) {
        while(this.getItemCount() < cellCount)this.addCell(new $89d6ebee591fa135$var$TableCell());
    };
    TableRow.prototype.getJsonTypeName = function() {
        return "TableRow";
    };
    TableRow.prototype.getIsFirstRow = function() {
        return this.parentTable.getItemAt(0) === this;
    };
    Object.defineProperty(TableRow.prototype, "parentTable", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRow.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TableRow.styleProperty = new $6XfIC.ContainerStyleProperty($5Ougt.Versions.v1_5, "style");
    TableRow.horizontalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "horizontalCellContentAlignment", $gIXBn.HorizontalAlignment);
    TableRow.verticalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "verticalCellContentAlignment", $gIXBn.VerticalAlignment);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableRow.horizontalCellContentAlignmentProperty)
    ], TableRow.prototype, "horizontalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(TableRow.verticalCellContentAlignmentProperty)
    ], TableRow.prototype, "verticalCellContentAlignment", void 0);
    return TableRow;
}($89d6ebee591fa135$var$StylableContainer);
module.exports.TableRow = $89d6ebee591fa135$var$TableRow;
var $89d6ebee591fa135$var$Table = /** @class */ function(_super) {
    $89d6ebee591fa135$var$__extends(Table, _super);
    function Table() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        _this.firstRowAsHeaders = true;
        _this.showGridLines = true;
        return _this;
    }
    Object.defineProperty(Table.prototype, "gridStyle", {
        get: function() {
            var style = this.getValue(Table.gridStyleProperty);
            if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            return undefined;
        },
        set: function(value) {
            this.setValue(Table.gridStyleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    Table.prototype.ensureRowsHaveEnoughCells = function() {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.removeCellsFromColumn = function(columnIndex) {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).removeCellAt(columnIndex);
    };
    Table.prototype.getCollectionPropertyName = function() {
        return "rows";
    };
    Table.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableRow" ? new $89d6ebee591fa135$var$TableRow() : undefined;
    };
    Table.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.internalRender = function() {
        if (this.getItemCount() > 0) {
            var totalWeights = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width.unit === $gIXBn.SizeUnit.Weight) totalWeights += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width.unit === $gIXBn.SizeUnit.Pixel) column.computedWidth = new $6BHj7.SizeAndUnit(column.width.physicalSize, $gIXBn.SizeUnit.Pixel);
                else column.computedWidth = new $6BHj7.SizeAndUnit(100 / totalWeights * column.width.physicalSize, $gIXBn.SizeUnit.Weight);
            }
            var tableElement = document.createElement("div");
            tableElement.setAttribute("role", "table");
            tableElement.style.display = "flex";
            tableElement.style.flexDirection = "column";
            if (this.showGridLines) {
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.gridStyle);
                if (styleDefinition.borderColor) {
                    var borderColor = (0, $F6YrP.stringToCssColor)(styleDefinition.borderColor);
                    if (borderColor) {
                        tableElement.style.borderTop = "1px solid " + borderColor;
                        tableElement.style.borderLeft = "1px solid " + borderColor;
                    }
                }
            }
            var cellSpacing = this.hostConfig.table.cellSpacing;
            for(var i = 0; i < this.getItemCount(); i++){
                var renderedRow = this.getItemAt(i).render();
                if (renderedRow) {
                    if (i > 0 && !this.showGridLines && cellSpacing > 0) {
                        var separatorRow = document.createElement("div");
                        separatorRow.setAttribute("aria-hidden", "true");
                        separatorRow.style.height = cellSpacing + "px";
                        tableElement.appendChild(separatorRow);
                    }
                    tableElement.appendChild(renderedRow);
                }
            }
            return tableElement;
        }
        return undefined;
    };
    Table.prototype.addColumn = function(column) {
        this._columns.push(column);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.removeColumn = function(column) {
        var index = this._columns.indexOf(column);
        if (index >= 0) {
            this.removeCellsFromColumn(index);
            this._columns.splice(index, 1);
        }
    };
    Table.prototype.getColumnCount = function() {
        return this._columns.length;
    };
    Table.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    Table.prototype.addRow = function(row) {
        this.internalAddItem(row);
        row.ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $89d6ebee591fa135$var$TableRow ? this.internalIndexOf(cardElement) : -1;
    };
    Table.prototype.getJsonTypeName = function() {
        return "Table";
    };
    Table._columnsProperty = new $5Ougt.SerializableObjectCollectionProperty($5Ougt.Versions.v1_5, "columns", $89d6ebee591fa135$var$TableColumnDefinition);
    Table.firstRowAsHeadersProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_5, "firstRowAsHeaders", true);
    Table.showGridLinesProperty = new $5Ougt.BoolProperty($5Ougt.Versions.v1_5, "showGridLines", true);
    Table.gridStyleProperty = new $6XfIC.ContainerStyleProperty($5Ougt.Versions.v1_5, "gridStyle");
    Table.horizontalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "horizontalCellContentAlignment", $gIXBn.HorizontalAlignment);
    Table.verticalCellContentAlignmentProperty = new $5Ougt.EnumProperty($5Ougt.Versions.v1_5, "verticalCellContentAlignment", $gIXBn.VerticalAlignment);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table._columnsProperty)
    ], Table.prototype, "_columns", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.firstRowAsHeadersProperty)
    ], Table.prototype, "firstRowAsHeaders", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.showGridLinesProperty)
    ], Table.prototype, "showGridLines", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.gridStyleProperty)
    ], Table.prototype, "gridStyle", null);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.horizontalCellContentAlignmentProperty)
    ], Table.prototype, "horizontalCellContentAlignment", void 0);
    $89d6ebee591fa135$var$__decorate([
        (0, $5Ougt.property)(Table.verticalCellContentAlignmentProperty)
    ], Table.prototype, "verticalCellContentAlignment", void 0);
    return Table;
}($89d6ebee591fa135$var$StylableContainer);
module.exports.Table = $89d6ebee591fa135$var$Table;
$2Zn2I.GlobalRegistry.defaultElements.register("Table", $89d6ebee591fa135$var$Table, $5Ougt.Versions.v1_5);

});

parcelRegister("krFBf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAdapter = void 0;
var $ee2699185d93bab8$var$ChannelAdapter = /** @class */ function() {
    function ChannelAdapter() {}
    return ChannelAdapter;
}();
module.exports.ChannelAdapter = $ee2699185d93bab8$var$ChannelAdapter;

});

parcelRegister("kBxrI", function(module, exports) {
"use strict";
var $f001350ddb668616$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginRequestResponse = module.exports.ErrorResponse = module.exports.SuccessResponse = module.exports.ActivityResponse = module.exports.ActivityRequestError = module.exports.ActivityRequestTrigger = void 0;
var $f001350ddb668616$var$ActivityRequestTrigger;
(function(ActivityRequestTrigger) {
    ActivityRequestTrigger["Automatic"] = "automatic";
    ActivityRequestTrigger["Manual"] = "manual";
})($f001350ddb668616$var$ActivityRequestTrigger = module.exports.ActivityRequestTrigger || (module.exports.ActivityRequestTrigger = {}));
var $f001350ddb668616$var$ActivityRequestError = /** @class */ function() {
    function ActivityRequestError(code, message) {
        this.code = code;
        this.message = message;
    }
    return ActivityRequestError;
}();
module.exports.ActivityRequestError = $f001350ddb668616$var$ActivityRequestError;
var $f001350ddb668616$var$ActivityResponse = /** @class */ function() {
    function ActivityResponse(request) {
        this.request = request;
    }
    return ActivityResponse;
}();
module.exports.ActivityResponse = $f001350ddb668616$var$ActivityResponse;
var $f001350ddb668616$var$SuccessResponse = /** @class */ function(_super) {
    $f001350ddb668616$var$__extends(SuccessResponse, _super);
    function SuccessResponse(request, rawContent) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.rawContent = rawContent;
        return _this;
    }
    return SuccessResponse;
}($f001350ddb668616$var$ActivityResponse);
module.exports.SuccessResponse = $f001350ddb668616$var$SuccessResponse;
var $f001350ddb668616$var$ErrorResponse = /** @class */ function(_super) {
    $f001350ddb668616$var$__extends(ErrorResponse, _super);
    function ErrorResponse(request, error) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.error = error;
        return _this;
    }
    return ErrorResponse;
}($f001350ddb668616$var$ActivityResponse);
module.exports.ErrorResponse = $f001350ddb668616$var$ErrorResponse;
var $f001350ddb668616$var$LoginRequestResponse = /** @class */ function(_super) {
    $f001350ddb668616$var$__extends(LoginRequestResponse, _super);
    function LoginRequestResponse(request, auth) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this._auth = auth;
        for(var _i = 0, _a = _this._auth.buttons; _i < _a.length; _i++){
            var button = _a[_i];
            if (button.type === "signin" && button.value !== undefined) try {
                new URL(button.value);
                _this.signinButton = button;
                break;
            } catch (e) {
            // Ignore parsing error
            }
        }
        return _this;
    }
    Object.defineProperty(LoginRequestResponse.prototype, "tokenExchangeResource", {
        get: function() {
            return this._auth.tokenExchangeResource;
        },
        enumerable: false,
        configurable: true
    });
    return LoginRequestResponse;
}($f001350ddb668616$var$ActivityResponse);
module.exports.LoginRequestResponse = $f001350ddb668616$var$LoginRequestResponse;

});

parcelRegister("5PICj", function(module, exports) {
"use strict";
var $43f4532456519116$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $43f4532456519116$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdaptiveApplet = void 0;

var $gIXBn = parcelRequire("gIXBn");

var $F6YrP = parcelRequire("F6YrP");

var $6BHj7 = parcelRequire("6BHj7");

var $kBxrI = parcelRequire("kBxrI");

var $24F6S = parcelRequire("24F6S");

var $6XfIC = parcelRequire("6XfIC");

var $5Ougt = parcelRequire("5Ougt");
function $43f4532456519116$var$logEvent(level, message) {
    var optionalParams = [];
    for(var _i = 2; _i < arguments.length; _i++)optionalParams[_i - 2] = arguments[_i];
    if ($6BHj7.GlobalSettings.applets.logEnabled) {
        if ($6BHj7.GlobalSettings.applets.onLogEvent) $6BHj7.GlobalSettings.applets.onLogEvent(level, message, optionalParams);
        else /* eslint-disable no-console */ switch(level){
            case $gIXBn.LogLevel.Warning:
                console.warn(message, optionalParams);
                break;
            case $gIXBn.LogLevel.Error:
                console.error(message, optionalParams);
                break;
            default:
                console.log(message, optionalParams);
                break;
        }
    }
}
var $43f4532456519116$var$ActivityRequest = /** @class */ function() {
    function ActivityRequest(action, trigger, consecutiveActions) {
        this.action = action;
        this.trigger = trigger;
        this.consecutiveActions = consecutiveActions;
        this.attemptNumber = 0;
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    ActivityRequest.prototype.retryAsync = function() {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            return $43f4532456519116$var$__generator(this, function(_a) {
                if (this.onSend) this.onSend(this);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ActivityRequest;
}();
var $43f4532456519116$var$AdaptiveApplet = /** @class */ function() {
    function AdaptiveApplet() {
        this._allowAutomaticCardUpdate = false;
        this.renderedElement = document.createElement("div");
        this.renderedElement.className = "aaf-cardHost";
        this.renderedElement.style.position = "relative";
        this.renderedElement.style.display = "flex";
        this.renderedElement.style.flexDirection = "column";
        this._cardHostElement = document.createElement("div");
        this._refreshButtonHostElement = document.createElement("div");
        this._refreshButtonHostElement.className = "aaf-refreshButtonHost";
        this._refreshButtonHostElement.style.display = "none";
        this.renderedElement.appendChild(this._cardHostElement);
        this.renderedElement.appendChild(this._refreshButtonHostElement);
    }
    AdaptiveApplet.prototype.displayCard = function(card) {
        if (card.renderedElement) {
            $F6YrP.clearElementChildren(this._cardHostElement);
            this._refreshButtonHostElement.style.display = "none";
            this._cardHostElement.appendChild(card.renderedElement);
        } else throw new Error("displayCard: undefined card.");
    };
    AdaptiveApplet.prototype.showManualRefreshButton = function(refreshAction) {
        var _this = this;
        var displayBuiltInManualRefreshButton = this.onShowManualRefreshButton ? this.onShowManualRefreshButton(this) : true;
        if (displayBuiltInManualRefreshButton) {
            this._refreshButtonHostElement.style.display = "none";
            var renderedRefreshButton = undefined;
            if (this.onRenderManualRefreshButton) renderedRefreshButton = this.onRenderManualRefreshButton(this);
            else {
                var message = $24F6S.Strings.runtime.refreshThisCard();
                if ($6BHj7.GlobalSettings.applets.refresh.mode === $gIXBn.RefreshMode.Automatic) {
                    var autoRefreshPausedMessage = $24F6S.Strings.runtime.automaticRefreshPaused();
                    if (autoRefreshPausedMessage[autoRefreshPausedMessage.length - 1] !== " ") autoRefreshPausedMessage += " ";
                    message = $24F6S.Strings.runtime.clckToRestartAutomaticRefresh();
                }
                var cardPayload = {
                    type: "AdaptiveCard",
                    version: "1.2",
                    body: [
                        {
                            type: "RichTextBlock",
                            horizontalAlignment: "right",
                            inlines: [
                                {
                                    type: "TextRun",
                                    text: message,
                                    selectAction: {
                                        type: "Action.Submit",
                                        id: "refreshCard"
                                    }
                                }
                            ]
                        }
                    ]
                };
                var card = new $6XfIC.AdaptiveCard();
                card.parse(cardPayload, new $6XfIC.SerializationContext($5Ougt.Versions.v1_2));
                card.onExecuteAction = function(action) {
                    if (action.id === "refreshCard") {
                        $F6YrP.clearElementChildren(_this._refreshButtonHostElement);
                        _this.internalExecuteAction(refreshAction, $kBxrI.ActivityRequestTrigger.Automatic, 0);
                    }
                };
                renderedRefreshButton = card.render();
            }
            if (renderedRefreshButton) {
                $F6YrP.clearElementChildren(this._refreshButtonHostElement);
                this._refreshButtonHostElement.appendChild(renderedRefreshButton);
                this._refreshButtonHostElement.style.removeProperty("display");
            }
        }
    };
    AdaptiveApplet.prototype.createActivityRequest = function(action, trigger, consecutiveActions) {
        var _this = this;
        if (this.card) {
            var request_1 = new $43f4532456519116$var$ActivityRequest(action, trigger, consecutiveActions);
            request_1.onSend = function(sender) {
                sender.attemptNumber++;
                _this.internalSendActivityRequestAsync(request_1);
            };
            var cancel = this.onPrepareActivityRequest ? !this.onPrepareActivityRequest(this, request_1, action) : false;
            return cancel ? undefined : request_1;
        } else throw new Error("createActivityRequest: no card has been set.");
    };
    AdaptiveApplet.prototype.createMagicCodeInputCard = function(attemptNumber) {
        var payload = {
            type: "AdaptiveCard",
            version: "1.0",
            body: [
                {
                    type: "TextBlock",
                    color: "attention",
                    text: attemptNumber === 1 ? undefined : "That didn't work... let's try again.",
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "TextBlock",
                    text: 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"',
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "Input.Text",
                    id: "magicCode",
                    placeholder: "Enter magic code"
                },
                {
                    type: "ActionSet",
                    horizontalAlignment: "center",
                    actions: [
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._submitMagicCodeActionId,
                            title: "Submit"
                        },
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._cancelMagicCodeAuthActionId,
                            title: "Cancel"
                        }
                    ]
                }
            ]
        };
        var card = new $6XfIC.AdaptiveCard();
        card.parse(payload);
        return card;
    };
    AdaptiveApplet.prototype.cancelAutomaticRefresh = function() {
        if (this._allowAutomaticCardUpdate) $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Automatic card refresh has been cancelled as a result of the user interacting with the card.");
        this._allowAutomaticCardUpdate = false;
    };
    AdaptiveApplet.prototype.createSerializationContext = function() {
        return this.onCreateSerializationContext ? this.onCreateSerializationContext(this) : new $6XfIC.SerializationContext();
    };
    AdaptiveApplet.prototype.internalSetCard = function(payload, consecutiveActions) {
        var _this = this;
        if (typeof payload === "object" && payload["type"] === "AdaptiveCard") this._cardPayload = payload;
        if (this._cardPayload) try {
            var card = new $6XfIC.AdaptiveCard();
            if (this.hostConfig) card.hostConfig = this.hostConfig;
            var serializationContext = this.createSerializationContext();
            card.parse(this._cardPayload, serializationContext);
            var doChangeCard = this.onCardChanging ? this.onCardChanging(this, this._cardPayload) : true;
            if (doChangeCard) {
                this._card = card;
                if (this._card.authentication && this._card.authentication.tokenExchangeResource && this.onPrefetchSSOToken) this.onPrefetchSSOToken(this, this._card.authentication.tokenExchangeResource);
                this._card.onExecuteAction = function(action) {
                    // If the user takes an action, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    _this.internalExecuteAction(action, $kBxrI.ActivityRequestTrigger.Manual, 0);
                };
                this._card.onInputValueChanged = function(input) {
                    var _a, _b, _c;
                    // If the user modifies an input, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    if (input instanceof $6XfIC.ChoiceSetInput && input.isDynamicTypeahead()) {
                        var filter = input.getFilterForDynamicSearch();
                        if (filter) {
                            var dataQueryAction = new $6XfIC.DataQuery();
                            dataQueryAction.filter = filter;
                            dataQueryAction.dataset = ((_a = input.choicesData) === null || _a === void 0 ? void 0 : _a.dataset) || "";
                            dataQueryAction.count = (_b = input.choicesData) === null || _b === void 0 ? void 0 : _b.count;
                            dataQueryAction.skip = (_c = input.choicesData) === null || _c === void 0 ? void 0 : _c.skip;
                            _this._choiceSet = input;
                            _this.internalExecuteAction(dataQueryAction, $kBxrI.ActivityRequestTrigger.Manual, 0 // consecutiveActions
                            );
                        }
                    }
                };
                this._card.render();
                if (this._card.renderedElement) {
                    this.displayCard(this._card);
                    if (this.onCardChanged) this.onCardChanged(this);
                    if (this._card.refresh) {
                        if ($6BHj7.GlobalSettings.applets.refresh.mode === $gIXBn.RefreshMode.Automatic && consecutiveActions < $6BHj7.GlobalSettings.applets.refresh.maximumConsecutiveAutomaticRefreshes) {
                            if ($6BHj7.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes <= 0) {
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Triggering automatic card refresh number " + (consecutiveActions + 1));
                                this.internalExecuteAction(this._card.refresh.action, $kBxrI.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                            } else {
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Scheduling automatic card refresh number " + (consecutiveActions + 1) + " in " + $6BHj7.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes + "ms");
                                var action_1 = this._card.refresh.action;
                                this._allowAutomaticCardUpdate = true;
                                window.setTimeout(function() {
                                    if (_this._allowAutomaticCardUpdate) _this.internalExecuteAction(action_1, $kBxrI.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                                }, $6BHj7.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes);
                            }
                        } else if ($6BHj7.GlobalSettings.applets.refresh.mode !== $gIXBn.RefreshMode.Disabled) {
                            if (consecutiveActions > 0) $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Stopping automatic refreshes after " + consecutiveActions + " consecutive refreshes.");
                            else $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "The card has a refresh section, but automatic refreshes are disabled.");
                            if ($6BHj7.GlobalSettings.applets.refresh.allowManualRefreshesAfterAutomaticRefreshes || $6BHj7.GlobalSettings.applets.refresh.mode === $gIXBn.RefreshMode.Manual) {
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Showing manual refresh button.");
                                this.showManualRefreshButton(this._card.refresh.action);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            // Ignore all errors
            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "setCard: " + error);
        }
    };
    AdaptiveApplet.prototype.internalExecuteAction = function(action, trigger, consecutiveActions) {
        if (action instanceof $6XfIC.UniversalAction) {
            if (this.channelAdapter) {
                var request = this.createActivityRequest(action, trigger, consecutiveActions);
                if (request) request.retryAsync();
            } else throw new Error("internalExecuteAction: No channel adapter set.");
        }
        if (this.onAction) this.onAction(this, action);
    };
    AdaptiveApplet.prototype.createProgressOverlay = function(request) {
        if (!this._progressOverlay) {
            if (this.onCreateProgressOverlay) this._progressOverlay = this.onCreateProgressOverlay(this, request);
            else {
                this._progressOverlay = document.createElement("div");
                this._progressOverlay.className = "aaf-progress-overlay";
                var spinner = document.createElement("div");
                spinner.className = "aaf-spinner";
                spinner.style.width = "28px";
                spinner.style.height = "28px";
                this._progressOverlay.appendChild(spinner);
            }
        }
        return this._progressOverlay;
    };
    AdaptiveApplet.prototype.removeProgressOverlay = function(request) {
        if (this.onRemoveProgressOverlay) this.onRemoveProgressOverlay(this, request);
        if (this._progressOverlay !== undefined) {
            this.renderedElement.removeChild(this._progressOverlay);
            this._progressOverlay = undefined;
        }
    };
    AdaptiveApplet.prototype.activityRequestSucceeded = function(response, parsedContent) {
        if (this.onActivityRequestSucceeded) this.onActivityRequestSucceeded(this, response, parsedContent);
    };
    AdaptiveApplet.prototype.activityRequestFailed = function(response) {
        return this.onActivityRequestFailed ? this.onActivityRequestFailed(this, response) : $6BHj7.GlobalSettings.applets.defaultTimeBetweenRetryAttempts;
    };
    AdaptiveApplet.prototype.showAuthCodeInputDialog = function(request) {
        var _this = this;
        var showBuiltInAuthCodeInputCard = this.onShowAuthCodeInputDialog ? this.onShowAuthCodeInputDialog(this, request) : true;
        if (showBuiltInAuthCodeInputCard) {
            var authCodeInputCard = this.createMagicCodeInputCard(request.attemptNumber);
            authCodeInputCard.render();
            authCodeInputCard.onExecuteAction = function(submitMagicCodeAction) {
                if (_this.card && submitMagicCodeAction instanceof $6XfIC.SubmitAction) switch(submitMagicCodeAction.id){
                    case AdaptiveApplet._submitMagicCodeActionId:
                        var authCode = undefined;
                        if (submitMagicCodeAction.data && typeof submitMagicCodeAction.data["magicCode"] === "string") authCode = submitMagicCodeAction.data["magicCode"];
                        if (authCode) {
                            _this.displayCard(_this.card);
                            request.authCode = authCode;
                            request.retryAsync();
                        } else alert("Please enter the magic code you received.");
                        break;
                    case AdaptiveApplet._cancelMagicCodeAuthActionId:
                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Authentication cancelled by user.");
                        _this.displayCard(_this.card);
                        break;
                    default:
                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Unexpected action taken from magic code input card (id = " + submitMagicCodeAction.id + ")");
                        alert($24F6S.Strings.magicCodeInputCard.somethingWentWrong());
                        break;
                }
            };
            this.displayCard(authCodeInputCard);
        }
    };
    AdaptiveApplet.prototype.internalSendActivityRequestAsync = function(request) {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            var action;
            return $43f4532456519116$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendActivityRequestAsync: channelAdapter is not set.");
                        action = request.action;
                        if (!(action instanceof $6XfIC.ExecuteAction)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendExecuteRequestAsync(request)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(action instanceof $6XfIC.DataQuery)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendDataQueryRequestAsync(request)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        throw new Error("internalSendActivityRequestAsync: Unhandled Action Type");
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendExecuteRequestAsync = function(request) {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            var overlay, done, _loop_1, this_1, state_1;
            return $43f4532456519116$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendExecuteRequestAsync: channelAdapter is not set.");
                        overlay = this.createProgressOverlay(request);
                        if (overlay !== undefined) this.renderedElement.appendChild(overlay);
                        done = false;
                        _loop_1 = function() {
                            var response, error_1, parsedContent, retryIn_1, attemptOAuth, left, top_1;
                            return $43f4532456519116$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        response = undefined;
                                        if (request.attemptNumber === 1) $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        else $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Re-sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this_1.channelAdapter.sendRequestAsync(request)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 3:
                                        error_1 = _b.sent();
                                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: " + error_1);
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 4:
                                        if (!response) return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                        if (!(response instanceof $kBxrI.SuccessResponse)) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        this_1.removeProgressOverlay(request);
                                        if (response.rawContent === undefined) throw new Error("internalSendExecuteRequestAsync: Action.Execute result is undefined");
                                        parsedContent = response.rawContent;
                                        try {
                                            parsedContent = JSON.parse(response.rawContent);
                                        } catch (_c) {
                                        // Leave parseContent as is
                                        }
                                        if (typeof parsedContent === "string") {
                                            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "The activity request returned a string after " + request.attemptNumber + " attempt(s).");
                                            this_1.activityRequestSucceeded(response, parsedContent);
                                        } else if (typeof parsedContent === "object" && parsedContent["type"] === "AdaptiveCard") {
                                            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "The activity request returned an Adaptive Card after " + request.attemptNumber + " attempt(s).");
                                            this_1.internalSetCard(parsedContent, request.consecutiveActions);
                                            this_1.activityRequestSucceeded(response, this_1.card);
                                        } else throw new Error("internalSendExecuteRequestAsync: Action.Execute result is of unsupported type (" + typeof response.rawContent + ")");
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 5:
                                        if (!(response instanceof $kBxrI.ErrorResponse)) return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                        retryIn_1 = this_1.activityRequestFailed(response);
                                        if (!(retryIn_1 >= 0 && request.attemptNumber < $6BHj7.GlobalSettings.applets.maximumRetryAttempts)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Warning, "Activity request failed: ".concat(response.error.message, ". Retrying in ").concat(retryIn_1, "ms"));
                                        request.attemptNumber++;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve, _reject) {
                                                window.setTimeout(function() {
                                                    resolve();
                                                }, retryIn_1);
                                            })
                                        ];
                                    case 6:
                                        _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                    case 7:
                                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: ".concat(response.error.message, ". Giving up after ").concat(request.attemptNumber, " attempt(s)"));
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        _b.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        if (response instanceof $kBxrI.LoginRequestResponse) {
                                            $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "The activity request returned a LoginRequestResponse after " + request.attemptNumber + " attempt(s).");
                                            if (request.attemptNumber <= $6BHj7.GlobalSettings.applets.maximumRetryAttempts) {
                                                attemptOAuth = true;
                                                if (response.tokenExchangeResource && this_1.onSSOTokenNeeded) // Attempt to use SSO. The host will return true if it can handle SSO, in which case
                                                // we bypass OAuth
                                                attemptOAuth = !this_1.onSSOTokenNeeded(this_1, request, response.tokenExchangeResource);
                                                if (attemptOAuth) {
                                                    // Attempt to use OAuth
                                                    this_1.removeProgressOverlay(request);
                                                    if (response.signinButton === undefined) throw new Error("internalSendExecuteRequestAsync: the login request doesn't contain a valid signin URL.");
                                                    $43f4532456519116$var$logEvent($gIXBn.LogLevel.Info, "Login required at " + response.signinButton.value);
                                                    if (this_1.onShowSigninPrompt) // Bypass the built-in auth prompt if the host app handles it
                                                    this_1.onShowSigninPrompt(this_1, request, response.signinButton);
                                                    else {
                                                        this_1.showAuthCodeInputDialog(request);
                                                        left = window.screenX + (window.outerWidth - $6BHj7.GlobalSettings.applets.authPromptWidth) / 2;
                                                        top_1 = window.screenY + (window.outerHeight - $6BHj7.GlobalSettings.applets.authPromptHeight) / 2;
                                                        window.open(response.signinButton.value, response.signinButton.title ? response.signinButton.title : "Sign in", "width=".concat($6BHj7.GlobalSettings.applets.authPromptWidth, ",height=").concat($6BHj7.GlobalSettings.applets.authPromptHeight, ",left=").concat(left, ",top=").concat(top_1));
                                                    }
                                                }
                                            } else {
                                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Authentication failed. Giving up after " + request.attemptNumber + " attempt(s)");
                                                alert($24F6S.Strings.magicCodeInputCard.authenticationFailed());
                                            }
                                            return [
                                                2 /*return*/ ,
                                                "break"
                                            ];
                                        } else throw new Error("Unhandled response type: " + JSON.stringify(response));
                                        _b.label = 10;
                                    case 10:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 2:
                        state_1 = _a.sent();
                        if (state_1 === "break") return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendDataQueryRequestAsync = function(request) {
        return $43f4532456519116$var$__awaiter(this, void 0, void 0, function() {
            var filter, response, error_2, rawResponse, parsedResponse;
            return $43f4532456519116$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendDataQueryRequestAsync: channel adapter not set");
                        filter = request.action.filter;
                        if (!this._choiceSet) return [
                            3 /*break*/ ,
                            5
                        ];
                        this._choiceSet.showLoadingIndicator();
                        response = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.channelAdapter.sendRequestAsync(request)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        this._choiceSet.showErrorIndicator(filter, "Unable to load");
                        $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: " + error_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (response) {
                            if (response instanceof $kBxrI.SuccessResponse) {
                                rawResponse = response.rawContent;
                                if (rawResponse) {
                                    parsedResponse = void 0;
                                    try {
                                        parsedResponse = JSON.parse(rawResponse);
                                    } catch (error) {
                                        this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                        throw new Error("internalSendDataQueryRequestAsync: Cannot parse response object: " + rawResponse);
                                    }
                                    if (typeof parsedResponse === "object") {
                                        this._choiceSet.renderChoices(filter, parsedResponse);
                                        this.activityRequestSucceeded(response, rawResponse);
                                    } else {
                                        this._choiceSet.showErrorIndicator(filter, "Error loading results");
                                        throw new Error("internalSendDataQueryRequestAsync: Data.Query result is of unsupported type (" + typeof rawResponse + ")");
                                    }
                                } else {
                                    this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                    throw new Error("internalSendDataQueryRequestAsync: Data.Query result is undefined");
                                }
                            } else if (response instanceof $kBxrI.ErrorResponse) {
                                this._choiceSet.showErrorIndicator(filter, response.error.message || "Error loading results");
                                $43f4532456519116$var$logEvent($gIXBn.LogLevel.Error, "Activity request failed: ".concat(response.error.message, "."));
                                this.activityRequestFailed(response);
                            } else {
                                this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                throw new Error("Unhandled response type: " + JSON.stringify(response));
                            }
                        } else this._choiceSet.removeLoadingIndicator();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.refreshCard = function() {
        if (this._card && this._card.refresh) this.internalExecuteAction(this._card.refresh.action, $kBxrI.ActivityRequestTrigger.Manual, 0);
    };
    AdaptiveApplet.prototype.setCard = function(payload) {
        this.internalSetCard(payload, 0);
    };
    Object.defineProperty(AdaptiveApplet.prototype, "card", {
        get: function() {
            return this._card;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveApplet._submitMagicCodeActionId = "submitMagicCode";
    AdaptiveApplet._cancelMagicCodeAuthActionId = "cancelMagicCodeAuth";
    return AdaptiveApplet;
}();
module.exports.AdaptiveApplet = $43f4532456519116$var$AdaptiveApplet;

});


parcelRegister("f74jF", function(module, exports) {

$parcel$export(module.exports, "default", () => $63e5c2a6b6784a3d$export$2e2bcd8739ae039);

var $aZ7dK = parcelRequire("aZ7dK");
const $63e5c2a6b6784a3d$var$createAdaptiveCardHostConfig = (primary, cardBackground)=>{
    const template = (0, $aZ7dK.adaptiveCardHostConfig);
    template.containerStyles.default.foregroundColors.default.default = primary;
    template.containerStyles.default.backgroundColor = cardBackground;
    return template;
};
var $63e5c2a6b6784a3d$export$2e2bcd8739ae039 = $63e5c2a6b6784a3d$var$createAdaptiveCardHostConfig;

});
parcelRegister("aZ7dK", function(module, exports) {

$parcel$export(module.exports, "adaptiveCardHostConfig", () => $b147a5a488fa3db3$export$d30af3ec38729f1);
const $b147a5a488fa3db3$var$color = '#00D7FF';
const $b147a5a488fa3db3$var$white = '#F7F3F6';
const $b147a5a488fa3db3$export$d30af3ec38729f1 = {
    hostCapabilities: {
        capabilities: null
    },
    choiceSetInputValueSeparator: ',',
    supportsInteractivity: true,
    fontTypes: {
        default: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        },
        monospace: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        }
    },
    spacing: {
        small: 8,
        default: 16,
        medium: 20,
        large: 30,
        extraLarge: 40,
        padding: 25
    },
    separator: {
        lineThickness: 1,
        lineColor: 'transparent'
    },
    imageSizes: {
        small: 40,
        medium: 100,
        large: 160
    },
    containerStyles: {
        default: {
            foregroundColors: {
                default: {
                    default: `${$b147a5a488fa3db3$var$white}`,
                    subtle: `${$b147a5a488fa3db3$var$color}`,
                    highlightColors: {
                        default: `${$b147a5a488fa3db3$var$color}`,
                        subtle: '#11000000'
                    }
                },
                dark: {
                    default: '#000000',
                    subtle: '#66000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                light: {
                    default: '#FFFFFF',
                    subtle: '#33000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                accent: {
                    default: '#0063B1',
                    subtle: '#0063B1',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                good: {
                    default: '#54a254',
                    subtle: '#DD54a254',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                warning: {
                    default: '#c3ab23',
                    subtle: '#DDc3ab23',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                attention: {
                    default: '#FF0000',
                    subtle: '#DDFF0000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                }
            },
            backgroundColor: 'transparent'
        },
        emphasis: {
            foregroundColors: {
                default: {
                    default: '#000000',
                    subtle: '#767676',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                dark: {
                    default: '#000000',
                    subtle: '#66000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                light: {
                    default: '#FFFFFF',
                    subtle: '#33000000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                accent: {
                    default: '#2E89FC',
                    subtle: '#882E89FC',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                good: {
                    default: '#54a254',
                    subtle: '#DD54a254',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                warning: {
                    default: '#c3ab23',
                    subtle: '#DDc3ab23',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                },
                attention: {
                    default: '#FF0000',
                    subtle: '#DDFF0000',
                    highlightColors: {
                        default: '#22000000',
                        subtle: '#11000000'
                    }
                }
            },
            backgroundColor: '#F0F0F0'
        }
    },
    actions: {
        maxActions: 100,
        spacing: 'Default',
        buttonSpacing: 0,
        showCard: {
            actionMode: 'Inline',
            inlineTopMargin: 8,
            style: 'emphasis'
        },
        preExpandSingleShowCardAction: false,
        actionsOrientation: 'vertical',
        actionAlignment: 'left',
        wrap: true
    },
    adaptiveCard: {
        allowCustomStyle: true
    },
    imageSet: {
        maxImageHeight: 100
    },
    media: {
        allowInlinePlayback: true
    },
    factSet: {
        title: {
            size: 'Default',
            color: `${$b147a5a488fa3db3$var$color}`,
            isSubtle: false,
            weight: 'Bolder',
            wrap: true
        },
        value: {
            size: 'Default',
            color: `${$b147a5a488fa3db3$var$color}`,
            isSubtle: false,
            weight: 'Default',
            wrap: true
        },
        spacing: 1000
    },
    cssClassNamePrefix: null,
    _legacyFontType: {
        fontFamily: 'Helvetica Neue,sans-serif',
        fontSizes: {
            small: 12,
            default: 16,
            medium: 20,
            large: 26,
            extraLarge: 33
        },
        fontWeights: {
            lighter: 200,
            default: 400,
            bolder: 600
        }
    }
};

});



parcelRegister("9JLpC", function(module, exports) {

$parcel$export(module.exports, "useViewStore", () => $0abfe7d9889c88c4$export$d13b2577cb75f2ad);
$parcel$export(module.exports, "default", () => $0abfe7d9889c88c4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $6HxxJ = parcelRequire("6HxxJ");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");

var $kdMEA = parcelRequire("kdMEA");

var $7j7nS = parcelRequire("7j7nS");
const $0abfe7d9889c88c4$var$defaultConfiguration = {
    homeRoute: 'home',
    views: {
        home: {
            background: {
                image: '',
                style: 'image'
            }
        }
    }
};
const $0abfe7d9889c88c4$var$initialState = {
    visibility: 'visible',
    currentDeviceType: (0, $2rYkD.DeviceType).mobile,
    isMobile: false,
    isWidget: false,
    isLandscape: true,
    isBorne: false,
    themeColors: (0, $7j7nS.defaultThemeDark),
    theme: (0, $2rYkD.Theme).light,
    configurations: $0abfe7d9889c88c4$var$defaultConfiguration,
    route: (0, $2rYkD.Routes).Home,
    currentHeight: 1080,
    currentWidth: 1920,
    isTactile: window.matchMedia('(any-pointer: coarse)').matches,
    isMobileLandscape: false,
    displayControls: true,
    mediumLandscape: false,
    characterLoaded: false
};
const $0abfe7d9889c88c4$var$createViewStore = (enabledFeaturesRef, setAdaptiveCardHostConfig)=>{
    return (0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$0abfe7d9889c88c4$var$initialState,
            actions: {
                setVisibility: (value)=>{
                    set({
                        visibility: value
                    });
                },
                toggleVisibility: ()=>{
                    set((state)=>({
                            visibility: state.visibility === 'visible' ? 'hidden' : 'visible'
                        }));
                },
                checkMobileLandscape: ()=>{
                    set((state)=>({
                            isMobileLandscape: state.currentDeviceType === (0, $2rYkD.DeviceType).mobile && state.currentHeight < state.currentWidth
                        }));
                },
                setCurrentDeviceType: (value)=>{
                    set({
                        currentDeviceType: value,
                        isMobile: (0, $kdMEA.mobileDisplays).includes(value),
                        isWidget: (0, $kdMEA.widgetDisplays).includes(value),
                        isLandscape: (0, $kdMEA.landscapeDisplays).includes(value),
                        isBorne: (0, $kdMEA.borneDisplays).includes(value)
                    });
                    get().actions.checkMobileLandscape();
                },
                setThemeColors: (value)=>{
                    setAdaptiveCardHostConfig(value.primary, value.card.frame.background);
                    set({
                        themeColors: value
                    });
                },
                setTheme: (value)=>{
                    set({
                        theme: value
                    });
                },
                setRoute: (value)=>{
                    if (value === (0, $2rYkD.Routes).News) enabledFeaturesRef.current?.includes('news') ? set({
                        route: value
                    }) : console.log('Retorik Framework > tried to switch to the news while the feature is not activated in Retorik Studio');
                    else set({
                        route: value
                    });
                },
                setViewsConfiguration: (value)=>{
                    set({
                        configurations: value
                    });
                },
                setCurrentHeight: (value)=>{
                    set({
                        currentHeight: value
                    });
                    get().actions.checkMobileLandscape();
                },
                setCurrentWidth: (value)=>{
                    set({
                        currentWidth: value,
                        mediumLandscape: value < (0, $kdMEA.mediumBreakpoint)
                    });
                    get().actions.checkMobileLandscape();
                },
                setDisplayControls: (value)=>{
                    set({
                        displayControls: value
                    });
                },
                setCharacterLoaded: (value)=>{
                    set({
                        characterLoaded: value
                    });
                }
            }
        };
    });
};
const $0abfe7d9889c88c4$var$ViewContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $0abfe7d9889c88c4$export$d13b2577cb75f2ad = (selector)=>{
    const store = (0, $bxRTa.useContext)($0abfe7d9889c88c4$var$ViewContext);
    if (!store) throw new Error('Retorik Framework > useViewStore must be used within ViewProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $0abfe7d9889c88c4$var$ViewProvider = ({ children: children })=>{
    const enabledFeatures = (0, $7SHCs.useRetorikStore)((state)=>state.enabledFeatures);
    const enabledFeaturesRef = (0, $bxRTa.useRef)(enabledFeatures);
    const setAdaptiveCardHostConfig = (0, $6HxxJ.useAdaptiveCardStore)((state)=>state.actions.setAdaptiveCardHostConfig);
    const [store] = (0, $bxRTa.useState)(()=>$0abfe7d9889c88c4$var$createViewStore(enabledFeaturesRef, setAdaptiveCardHostConfig));
    (0, $bxRTa.useEffect)(()=>{
        enabledFeaturesRef.current = enabledFeatures;
    }, [
        enabledFeatures
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)($0abfe7d9889c88c4$var$ViewContext.Provider, {
        value: store,
        children: children
    });
};
var $0abfe7d9889c88c4$export$2e2bcd8739ae039 = $0abfe7d9889c88c4$var$ViewProvider;

});
parcelRegister("7SHCs", function(module, exports) {

$parcel$export(module.exports, "useRetorikStore", () => $1b79424c133c0b78$export$bd22554f31e5f96f);
$parcel$export(module.exports, "default", () => $1b79424c133c0b78$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $6KzM1 = parcelRequire("6KzM1");

var $2rYkD = parcelRequire("2rYkD");

var $7okOs = parcelRequire("7okOs");

var $hMwCA = parcelRequire("hMwCA");
const $1b79424c133c0b78$var$defaultConfiguration = {
    subtitles: false
};
const $1b79424c133c0b78$var$initialState = {
    configuration: $1b79424c133c0b78$var$defaultConfiguration,
    addressData: {},
    canFocusSendBox: false,
    sendBoxRef: null,
    sendBoxPlaceHolder: undefined,
    fromTextToVocal: false,
    baseAddress: '',
    subtitlesInConfiguration: false,
    displaySubtitles: false,
    agentData: undefined,
    gpuData: undefined,
    loaderClosed: false,
    appAvailable: false,
    currentLayout: (0, $2rYkD.ContainerParent).agent,
    userAlreadySet: false,
    isWaitingForResponse: false,
    instantIsWaitingForResponse: false,
    skipLoader: false,
    displayAgentInNews: true,
    submitDelayBeforeSendingMessage: undefined,
    disableHistory: false,
    environmentPreset: "apartment",
    customScripts: [],
    customCSS: [],
    enabledFeatures: []
};
let $1b79424c133c0b78$var$timer = null;
$1b79424c133c0b78$var$timer = setTimeout(()=>{
    return true;
}, 1000);
const $1b79424c133c0b78$var$createRetorikStore = ()=>{
    return (0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$1b79424c133c0b78$var$initialState,
            actions: {
                setConfiguration: (value)=>{
                    set({
                        configuration: value
                    });
                },
                setAddressData: (value)=>{
                    set({
                        addressData: value
                    });
                },
                setSendBoxRef: (value)=>{
                    set({
                        sendBoxRef: value
                    });
                },
                focusSendBox: ()=>{
                    const sendBox = get().sendBoxRef;
                    sendBox && document.activeElement !== sendBox && sendBox.focus();
                },
                setCanFocusSendBox: (value)=>{
                    set({
                        canFocusSendBox: value
                    });
                },
                setSendBoxPlaceHolder: (value)=>{
                    set({
                        sendBoxPlaceHolder: value
                    });
                },
                setLayout: (value)=>{
                    set({
                        currentLayout: value
                    });
                },
                setUserAlreadySet: (value)=>{
                    set({
                        userAlreadySet: value
                    });
                },
                setEnvironmentPreset: (value)=>{
                    set({
                        environmentPreset: value
                    });
                },
                setFromTextToVocal: (value)=>{
                    set({
                        fromTextToVocal: value
                    });
                },
                setBaseAddress: (value)=>{
                    set({
                        baseAddress: value
                    });
                },
                setLoaderClosed: (value)=>{
                    set({
                        loaderClosed: value
                    });
                },
                setAppAvailable: (value)=>{
                    set({
                        appAvailable: value
                    });
                },
                setSubtitlesInConfiguration: (value)=>{
                    set({
                        subtitlesInConfiguration: value,
                        displaySubtitles: value
                    });
                },
                setDisplaySubtitles: (value)=>{
                    set({
                        displaySubtitles: value
                    });
                },
                toggleSubtitles: ()=>{
                    set((state)=>({
                            displaySubtitles: !state.displaySubtitles
                        }));
                },
                setAgentData: async (value)=>{
                    // Test GPU to use bodyengine or fall back to spiritengine. Tier at least 1 for mobile, 2 for desktop
                    const gpuTier = await (0, $6KzM1.getGPUTier)();
                    let gpuTestSupportsBodyengine = false;
                    if (gpuTier.tier > 0) {
                        if (gpuTier.type === 'FALLBACK') gpuTestSupportsBodyengine = true;
                        else gpuTestSupportsBodyengine = gpuTier.tier > 1;
                    }
                    const url = typeof value === 'string' ? value : value.url;
                    let data = await (0, $hMwCA.default)(url);
                    if (data?.useBodyEngineThree && !gpuTestSupportsBodyengine) {
                        console.log('Retorik Framework > graphic capacity too low to use bodyengine, the application will switch to spiritengine');
                        data = await (0, $hMwCA.default)(data?.gender === 'female' ? (0, $7okOs.characters).zahra : (0, $7okOs.characters).rowan);
                    }
                    if (data && typeof value !== 'string') {
                        value.name && (data.name = value.name);
                        value.animationsUrl && (data.animationsUrl = value.animationsUrl);
                    }
                    set({
                        gpuData: gpuTier,
                        agentData: data
                    });
                },
                setTimerForWaiting: ()=>{
                    $1b79424c133c0b78$var$timer = setTimeout(()=>{
                        set({
                            isWaitingForResponse: true
                        });
                        $1b79424c133c0b78$var$timer = null;
                    }, 1000);
                },
                setIsWaitingForResponse: (value)=>{
                    if (value) {
                        set({
                            instantIsWaitingForResponse: true
                        });
                        !$1b79424c133c0b78$var$timer && get().actions.setTimerForWaiting();
                    } else {
                        $1b79424c133c0b78$var$timer && clearTimeout($1b79424c133c0b78$var$timer);
                        $1b79424c133c0b78$var$timer = null;
                        set({
                            instantIsWaitingForResponse: false,
                            isWaitingForResponse: false
                        });
                    }
                },
                setSkipLoader: (value)=>{
                    set({
                        skipLoader: value
                    });
                },
                setDisplayAgentInNews: (value)=>{
                    set({
                        displayAgentInNews: value
                    });
                },
                setSubmitDelayBeforeSendingMessage: (value)=>{
                    set({
                        submitDelayBeforeSendingMessage: value
                    });
                },
                setDisableHistory: (value)=>{
                    set({
                        disableHistory: value
                    });
                },
                setCustomScripts: (value)=>{
                    set({
                        customScripts: value
                    });
                },
                setCustomCSS: (value)=>{
                    set({
                        customCSS: value
                    });
                },
                setEnabledFeatures: (value)=>{
                    set({
                        enabledFeatures: value
                    });
                },
                resetRetorikStore: ()=>{
                    set({
                        ...$1b79424c133c0b78$var$initialState
                    });
                }
            }
        };
    });
};
const $1b79424c133c0b78$var$RetorikContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $1b79424c133c0b78$export$bd22554f31e5f96f = (selector)=>{
    const store = (0, $bxRTa.useContext)($1b79424c133c0b78$var$RetorikContext);
    if (!store) throw new Error('Retorik Framework > useRetorikStore must be used within RetorikProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $1b79424c133c0b78$var$RetorikProvider = ({ children: children })=>{
    const [store] = (0, $bxRTa.useState)(()=>$1b79424c133c0b78$var$createRetorikStore());
    return /*#__PURE__*/ (0, $fl9nK.jsx)($1b79424c133c0b78$var$RetorikContext.Provider, {
        value: store,
        children: children
    });
};
var $1b79424c133c0b78$export$2e2bcd8739ae039 = $1b79424c133c0b78$var$RetorikProvider;

});
parcelRegister("6KzM1", function(module, exports) {

$parcel$export(module.exports, "getGPUTier", () => $4ea2c9d5d847799f$export$3c749a0234c63713);
function $4ea2c9d5d847799f$var$e(e, t, r, n) {
    return new (r || (r = Promise))(function(o, a) {
        function i(e) {
            try {
                d(n.next(e));
            } catch (e) {
                a(e);
            }
        }
        function c(e) {
            try {
                d(n.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function d(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, c);
        }
        d((n = n.apply(e, t || [])).next());
    });
}
"function" == typeof SuppressedError && SuppressedError;
const $4ea2c9d5d847799f$var$t = [
    "geforce 320m",
    "geforce 8600",
    "geforce 8600m gt",
    "geforce 8800 gs",
    "geforce 8800 gt",
    "geforce 9400",
    "geforce 9400m g",
    "geforce 9400m",
    "geforce 9600m gt",
    "geforce 9600m",
    "geforce fx go5200",
    "geforce gt 120",
    "geforce gt 130",
    "geforce gt 330m",
    "geforce gtx 285",
    "google swiftshader",
    "intel g41",
    "intel g45",
    "intel gma 4500mhd",
    "intel gma x3100",
    "intel hd 3000",
    "intel q45",
    "legacy",
    "mali-2",
    "mali-3",
    "mali-4",
    "quadro fx 1500",
    "quadro fx 4",
    "quadro fx 5",
    "radeon hd 2400",
    "radeon hd 2600",
    "radeon hd 4670",
    "radeon hd 4850",
    "radeon hd 4870",
    "radeon hd 5670",
    "radeon hd 5750",
    "radeon hd 6290",
    "radeon hd 6300",
    "radeon hd 6310",
    "radeon hd 6320",
    "radeon hd 6490m",
    "radeon hd 6630m",
    "radeon hd 6750m",
    "radeon hd 6770m",
    "radeon hd 6970m",
    "sgx 543",
    "sgx543"
];
function $4ea2c9d5d847799f$var$r(e) {
    return e = e.toLowerCase().replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
const $4ea2c9d5d847799f$var$n = "undefined" == typeof window, $4ea2c9d5d847799f$var$o = (()=>{
    if ($4ea2c9d5d847799f$var$n) return;
    const { userAgent: e, platform: t, maxTouchPoints: r } = window.navigator, o = /(iphone|ipod|ipad)/i.test(e), a = "iPad" === t || "MacIntel" === t && r > 0 && !window.MSStream;
    return {
        isIpad: a,
        isMobile: /android/i.test(e) || o || a,
        isSafari12: /Version\/12.+Safari/.test(e),
        isFirefox: /Firefox/.test(e)
    };
})();
function $4ea2c9d5d847799f$var$a(e, t, r) {
    if (!r) return [
        t
    ];
    const n = function(e) {
        const t = "\n    precision highp float;\n    attribute vec3 aPosition;\n    varying float vvv;\n    void main() {\n      vvv = 0.31622776601683794;\n      gl_Position = vec4(aPosition, 1.0);\n    }\n  ", r = "\n    precision highp float;\n    varying float vvv;\n    void main() {\n      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\n      enc = fract(enc);\n      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\n      gl_FragColor = enc;\n    }\n  ", n = e.createShader(35633), o = e.createShader(35632), a = e.createProgram();
        if (!(o && n && a)) return;
        e.shaderSource(n, t), e.shaderSource(o, r), e.compileShader(n), e.compileShader(o), e.attachShader(a, n), e.attachShader(a, o), e.linkProgram(a), e.detachShader(a, n), e.detachShader(a, o), e.deleteShader(n), e.deleteShader(o), e.useProgram(a);
        const i = e.createBuffer();
        e.bindBuffer(34962, i), e.bufferData(34962, new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), 35044);
        const c = e.getAttribLocation(a, "aPosition");
        e.vertexAttribPointer(c, 3, 5126, !1, 0, 0), e.enableVertexAttribArray(c), e.clearColor(1, 1, 1, 1), e.clear(16384), e.viewport(0, 0, 1, 1), e.drawArrays(4, 0, 3);
        const d = new Uint8Array(4);
        return e.readPixels(0, 0, 1, 1, 6408, 5121, d), e.deleteProgram(a), e.deleteBuffer(i), d.join("");
    }(e), a = "801621810", i = "8016218135", c = "80162181161", d = (null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isIpad) ? [
        [
            "a7",
            c,
            12
        ],
        [
            "a8",
            i,
            15
        ],
        [
            "a8x",
            i,
            15
        ],
        [
            "a9",
            i,
            15
        ],
        [
            "a9x",
            i,
            15
        ],
        [
            "a10",
            i,
            15
        ],
        [
            "a10x",
            i,
            15
        ],
        [
            "a12",
            a,
            15
        ],
        [
            "a12x",
            a,
            15
        ],
        [
            "a12z",
            a,
            15
        ],
        [
            "a14",
            a,
            15
        ],
        [
            "a15",
            a,
            15
        ],
        [
            "m1",
            a,
            15
        ],
        [
            "m2",
            a,
            15
        ]
    ] : [
        [
            "a7",
            c,
            12
        ],
        [
            "a8",
            i,
            12
        ],
        [
            "a9",
            i,
            15
        ],
        [
            "a10",
            i,
            15
        ],
        [
            "a11",
            a,
            15
        ],
        [
            "a12",
            a,
            15
        ],
        [
            "a13",
            a,
            15
        ],
        [
            "a14",
            a,
            15
        ],
        [
            "a15",
            a,
            15
        ],
        [
            "a16",
            a,
            15
        ],
        [
            "a17",
            a,
            15
        ]
    ];
    let l;
    "80162181255" === n ? l = d.filter(([, , e])=>e >= 14) : (l = d.filter(([, e])=>e === n), l.length || (l = d));
    return l.map(([e])=>`apple ${e} gpu`);
}
class $4ea2c9d5d847799f$var$i extends Error {
    constructor(e){
        super(e), Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $4ea2c9d5d847799f$var$c = [], $4ea2c9d5d847799f$var$d = [];
function $4ea2c9d5d847799f$var$l(e, t) {
    if (e === t) return 0;
    const r = e;
    e.length > t.length && (e = t, t = r);
    let n = e.length, o = t.length;
    for(; n > 0 && e.charCodeAt(~-n) === t.charCodeAt(~-o);)n--, o--;
    let a, i = 0;
    for(; i < n && e.charCodeAt(i) === t.charCodeAt(i);)i++;
    if (n -= i, o -= i, 0 === n) return o;
    let l, s, f = 0, u = 0, g = 0;
    for(; u < n;)$4ea2c9d5d847799f$var$d[u] = e.charCodeAt(i + u), $4ea2c9d5d847799f$var$c[u] = ++u;
    for(; g < o;)for(a = t.charCodeAt(i + g), l = g++, f = g, u = 0; u < n; u++)s = a === $4ea2c9d5d847799f$var$d[u] ? l : l + 1, l = $4ea2c9d5d847799f$var$c[u], f = $4ea2c9d5d847799f$var$c[u] = l > f ? s > f ? f + 1 : s : s > l ? l + 1 : s;
    return f;
}
function $4ea2c9d5d847799f$var$s(e) {
    return null != e;
}
const $4ea2c9d5d847799f$export$3c749a0234c63713 = ({ mobileTiers: c = [
    0,
    15,
    30,
    60
], desktopTiers: d = [
    0,
    15,
    30,
    60
], override: f = {}, glContext: u, failIfMajorPerformanceCaveat: g = !1, benchmarksURL: h = "https://unpkg.com/detect-gpu@5.0.70/dist/benchmarks" } = {})=>$4ea2c9d5d847799f$var$e(void 0, void 0, void 0, function*() {
        const p = {};
        if ($4ea2c9d5d847799f$var$n) return {
            tier: 0,
            type: "SSR"
        };
        const { isIpad: m = !!(null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isIpad), isMobile: v = !!(null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isMobile), screenSize: w = window.screen, loadBenchmarks: x = (t)=>$4ea2c9d5d847799f$var$e(void 0, void 0, void 0, function*() {
                const e = yield fetch(`${h}/${t}`).then((e)=>e.json());
                if (parseInt(e.shift().split(".")[0], 10) < 4) throw new $4ea2c9d5d847799f$var$i("Detect GPU benchmark data is out of date. Please update to version 4x");
                return e;
            }) } = f;
        let { renderer: A } = f;
        const P = (e, t, r, n, o)=>({
                device: o,
                fps: n,
                gpu: r,
                isMobile: v,
                tier: e,
                type: t
            });
        let S, b = "";
        if (A) A = $4ea2c9d5d847799f$var$r(A), S = [
            A
        ];
        else {
            const e = u || function(e, t = !1) {
                const r = {
                    alpha: !1,
                    antialias: !1,
                    depth: !1,
                    failIfMajorPerformanceCaveat: t,
                    powerPreference: "high-performance",
                    stencil: !1
                };
                e && delete r.powerPreference;
                const n = window.document.createElement("canvas"), o = n.getContext("webgl", r) || n.getContext("experimental-webgl", r);
                return null != o ? o : void 0;
            }(null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isSafari12, g);
            if (!e) return P(0, "WEBGL_UNSUPPORTED");
            const t = (null == $4ea2c9d5d847799f$var$o ? void 0 : $4ea2c9d5d847799f$var$o.isFirefox) ? null : e.getExtension("WEBGL_debug_renderer_info");
            if (A = t ? e.getParameter(t.UNMASKED_RENDERER_WEBGL) : e.getParameter(e.RENDERER), !A) return P(1, "FALLBACK");
            b = A, A = $4ea2c9d5d847799f$var$r(A), S = function(e, t, r) {
                return "apple gpu" === t ? $4ea2c9d5d847799f$var$a(e, t, r) : [
                    t
                ];
            }(e, A, v);
        }
        const E = (yield Promise.all(S.map(function(t) {
            var r;
            return $4ea2c9d5d847799f$var$e(this, void 0, void 0, function*() {
                const e = ((e)=>{
                    const t = v ? [
                        "adreno",
                        "apple",
                        "mali-t",
                        "mali",
                        "nvidia",
                        "powervr",
                        "samsung"
                    ] : [
                        "intel",
                        "apple",
                        "amd",
                        "radeon",
                        "nvidia",
                        "geforce",
                        "adreno"
                    ];
                    for (const r of t)if (e.includes(r)) return r;
                })(t);
                if (!e) return;
                const n = `${v ? "m" : "d"}-${e}${m ? "-ipad" : ""}.json`, o = p[n] = null !== (r = p[n]) && void 0 !== r ? r : x(n);
                let a;
                try {
                    a = yield o;
                } catch (e) {
                    if (e instanceof $4ea2c9d5d847799f$var$i) throw e;
                    return;
                }
                const c = function(e) {
                    var t;
                    const r = (e = e.replace(/\([^)]+\)/, "")).match(/\d+/) || e.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                    return null !== (t = null == r ? void 0 : r.join("").replace(/\W|amd/g, "")) && void 0 !== t ? t : "";
                }(t);
                let d = a.filter(([, e])=>e === c);
                d.length || (d = a.filter(([e])=>e.includes(t)));
                const s = d.length;
                if (0 === s) return;
                const f = t.split(/[.,()\[\]/\s]/g).sort().filter((e, t, r)=>0 === t || e !== r[t - 1]).join(" ");
                let u, [g, , , , h] = s > 1 ? d.map((e)=>[
                        e,
                        $4ea2c9d5d847799f$var$l(f, e[2])
                    ]).sort(([, e], [, t])=>e - t)[0][0] : d[0], A = Number.MAX_VALUE;
                const { devicePixelRatio: P } = window, S = w.width * P * w.height * P;
                for (const e of h){
                    const [t, r] = e, n = t * r, o = Math.abs(S - n);
                    o < A && (A = o, u = e);
                }
                if (!u) return;
                const [, , b, E] = u;
                return [
                    A,
                    b,
                    g,
                    E
                ];
            });
        }))).filter($4ea2c9d5d847799f$var$s).sort(([e = Number.MAX_VALUE, t], [r = Number.MAX_VALUE, n])=>e === r ? t - n : e - r);
        if (!E.length) {
            const e = $4ea2c9d5d847799f$var$t.find((e)=>A.includes(e));
            return e ? P(0, "BLOCKLISTED", e) : P(1, "FALLBACK", `${A} (${b})`);
        }
        const [, y, C, L] = E[0];
        if (-1 === y) return P(0, "BLOCKLISTED", C, y, L);
        const M = v ? c : d;
        let $ = 0;
        for(let e = 0; e < M.length; e++)y >= M[e] && ($ = e);
        return P($, "BENCHMARK", C, y, L);
    });

});

parcelRegister("7okOs", function(module, exports) {

$parcel$export(module.exports, "characters", () => $3841cbe997ee41da$export$30a86d91af8ff6e6);

var $kdMEA = parcelRequire("kdMEA");
const $3841cbe997ee41da$export$30a86d91af8ff6e6 = {
    alice: `${(0, $kdMEA.CDNCharactersAddress)}/long-shot/alice`,
    greg: `${(0, $kdMEA.CDNCharactersAddress)}/long-shot/greg`,
    jeanmarc: `${(0, $kdMEA.CDNCharactersAddress)}/jean-marc`,
    jessica: `${(0, $kdMEA.CDNCharactersAddress)}/long-shot/jessica`,
    jessica_short: `${(0, $kdMEA.CDNCharactersAddress)}/medium-shot/jessica`,
    ikaa: `${(0, $kdMEA.CDNCharactersAddress)}/long-shot/ikaa`,
    karine: `${(0, $kdMEA.CDNCharactersAddress)}/karine`,
    lea: `${(0, $kdMEA.CDNCharactersAddress)}/lea`,
    prosper: `${(0, $kdMEA.CDNCharactersAddress)}/prosper`,
    raphael: `${(0, $kdMEA.CDNCharactersAddress)}/raphael`,
    rowan: `${(0, $kdMEA.CDNCharactersAddress)}/long-shot/rowan`,
    rowan_short: `${(0, $kdMEA.CDNCharactersAddress)}/medium-shot/rowan`,
    zahra: `${(0, $kdMEA.CDNCharactersAddress)}/long-shot/zahra`
};

});
parcelRegister("kdMEA", function(module, exports) {

$parcel$export(module.exports, "mobileBreakpoint", () => $983afd5d6596f47e$export$2e65b7c7134e01f0);
$parcel$export(module.exports, "mediumBreakpoint", () => $983afd5d6596f47e$export$91e4bf93df95a062);
$parcel$export(module.exports, "CDNCharactersAddress", () => $983afd5d6596f47e$export$2475544086fd222b);
$parcel$export(module.exports, "CDNImagesAddress", () => $983afd5d6596f47e$export$f718170a6537817b);
$parcel$export(module.exports, "CDNAudioAddress", () => $983afd5d6596f47e$export$eefca12493f9e9b9);
$parcel$export(module.exports, "studioRetorik", () => $983afd5d6596f47e$export$c398bfda6cfa19ff);
$parcel$export(module.exports, "studioRetorikDev", () => $983afd5d6596f47e$export$9adff68f093278ec);
$parcel$export(module.exports, "studioRetorikStaging", () => $983afd5d6596f47e$export$409889737849a04f);
$parcel$export(module.exports, "studioRetorikExperimental", () => $983afd5d6596f47e$export$a4481ccc388fce2a);
$parcel$export(module.exports, "docsRetorik", () => $983afd5d6596f47e$export$1f4373411c991e56);
$parcel$export(module.exports, "openRoute", () => $983afd5d6596f47e$export$d6542303192de6db);
$parcel$export(module.exports, "openRouteAPIKey", () => $983afd5d6596f47e$export$6f60da16472d34a7);
$parcel$export(module.exports, "webchatTokenRetrievalAddress", () => $983afd5d6596f47e$export$d9e38c0112bbdae6);
$parcel$export(module.exports, "defaultDirectLineAddress", () => $983afd5d6596f47e$export$342c646308e8fa62);
$parcel$export(module.exports, "hospitalityApiAddress", () => $983afd5d6596f47e$export$1ca3e229e23d7f42);
$parcel$export(module.exports, "telemetryAddress", () => $983afd5d6596f47e$export$1e8c600abff9ea62);
$parcel$export(module.exports, "googleMapsAddress", () => $983afd5d6596f47e$export$f3c31933b33f3693);
$parcel$export(module.exports, "DEFAULT_LANGUAGE_DATA", () => $983afd5d6596f47e$export$8828fbbb6034a09b);
$parcel$export(module.exports, "DEFAULT_VIEWS", () => $983afd5d6596f47e$export$9bbca248acc786d3);
$parcel$export(module.exports, "DEFAULT_SUB_VIEWS", () => $983afd5d6596f47e$export$890576ebf405f6b7);
$parcel$export(module.exports, "mobileDisplays", () => $983afd5d6596f47e$export$78f16669b353a880);
$parcel$export(module.exports, "widgetDisplays", () => $983afd5d6596f47e$export$909f4c209eb70365);
$parcel$export(module.exports, "landscapeDisplays", () => $983afd5d6596f47e$export$baf53ca377ebf861);
$parcel$export(module.exports, "borneDisplays", () => $983afd5d6596f47e$export$a8576d98c9c928de);
$parcel$export(module.exports, "commonColors", () => $983afd5d6596f47e$export$c0da64553318f2cb);
$parcel$export(module.exports, "nonResponseInducingEvents", () => $983afd5d6596f47e$export$6a32bf5257e620e1);
$parcel$export(module.exports, "rtlLanguages", () => $983afd5d6596f47e$export$882049267ad78ff6);

var $2rYkD = parcelRequire("2rYkD");
const $983afd5d6596f47e$export$2e65b7c7134e01f0 = 600;
const $983afd5d6596f47e$export$91e4bf93df95a062 = 1300;
const $983afd5d6596f47e$export$66b40c15080ce99b = 'https://cdn.retorik.ai';
const $983afd5d6596f47e$export$2475544086fd222b = `${$983afd5d6596f47e$export$66b40c15080ce99b}/spiritenginehtml5/characters`;
const $983afd5d6596f47e$export$f718170a6537817b = `${$983afd5d6596f47e$export$66b40c15080ce99b}/retorik-framework/imagefiles`;
const $983afd5d6596f47e$export$eefca12493f9e9b9 = `${$983afd5d6596f47e$export$66b40c15080ce99b}/retorik-framework/audiofiles`;
const $983afd5d6596f47e$export$c398bfda6cfa19ff = 'https://studio.retorik.ai';
const $983afd5d6596f47e$export$9adff68f093278ec = 'https://dev.studio.retorik.ai';
const $983afd5d6596f47e$export$409889737849a04f = 'https://preview.studio.retorik.ai';
const $983afd5d6596f47e$export$a4481ccc388fce2a = 'https://experimental.studio.retorik.ai';
const $983afd5d6596f47e$export$1f4373411c991e56 = 'https://docs.retorik.ai';
const $983afd5d6596f47e$export$d6542303192de6db = 'https://api.openrouteservice.org/v2/directions';
const $983afd5d6596f47e$export$6f60da16472d34a7 = '5b3ce3597851110001cf62483cfd6bd46f934b7d96f108a35e0f08b8';
const $983afd5d6596f47e$export$dc91bcad81fffb1f = 'https://api.open-meteo.com/v1/forecast?';
const $983afd5d6596f47e$export$68b4ac416ba801c6 = '&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=auto&current_weather=true';
const $983afd5d6596f47e$export$d9e38c0112bbdae6 = 'K2.ContentFields.WebChat/api/GetWebchatToken';
const $983afd5d6596f47e$export$342c646308e8fa62 = 'https://directline.botframework.com/v3/directline';
const $983afd5d6596f47e$export$1ca3e229e23d7f42 = 'api/hospitality/Emergency';
const $983afd5d6596f47e$export$1e8c600abff9ea62 = 'https://telemetry.retorik.ai/otlp-http/v1/traces';
const $983afd5d6596f47e$export$f3c31933b33f3693 = 'https://www.google.com/maps/dir/?api=1&';
const $983afd5d6596f47e$export$8828fbbb6034a09b = {
    default: 'fr-FR',
    all: [
        'fr-FR'
    ]
};
const $983afd5d6596f47e$export$9bbca248acc786d3 = [
    {
        view: (0, $2rYkD.AvailableViews).home,
        indice: 1
    },
    {
        view: (0, $2rYkD.AvailableViews).emergency,
        indice: 2
    }
];
const $983afd5d6596f47e$export$890576ebf405f6b7 = [
    {
        view: (0, $2rYkD.AvailableSubViews).history,
        indice: 1
    },
    {
        view: (0, $2rYkD.AvailableSubViews).tutorial,
        indice: 2
    }
];
const $983afd5d6596f47e$export$78f16669b353a880 = [
    (0, $2rYkD.DeviceType).mobile,
    (0, $2rYkD.DeviceType).widget
];
const $983afd5d6596f47e$export$909f4c209eb70365 = [
    (0, $2rYkD.DeviceType).widget,
    (0, $2rYkD.DeviceType).widgetBorne,
    (0, $2rYkD.DeviceType).widgetLandscape
];
const $983afd5d6596f47e$export$baf53ca377ebf861 = [
    (0, $2rYkD.DeviceType).landscape,
    (0, $2rYkD.DeviceType).widgetLandscape
];
const $983afd5d6596f47e$export$a8576d98c9c928de = [
    (0, $2rYkD.DeviceType).borne,
    (0, $2rYkD.DeviceType).widgetBorne
];
const $983afd5d6596f47e$export$c0da64553318f2cb = {
    primary: '#00D7FF',
    secondary: '#1999B1',
    black: '#101219',
    whereToEatColor: '#FC952E',
    whereToSleepColor: '#9F007D',
    tobeSeenColor: '#76AB2A',
    tobeDoneColor: '#E23C2A',
    localProductsColor: '#AFB942',
    servicesColor: '#00C8BC',
    agendaColor: '#865DA2',
    occupantColor: '#6DEDBC'
};
const $983afd5d6596f47e$export$6a32bf5257e620e1 = [
    'davi.closewindow',
    'setuser',
    'davi.gdprconsent'
];
const $983afd5d6596f47e$export$882049267ad78ff6 = [
    'ar',
    'fa',
    'he',
    'ps',
    'ur'
];

});


parcelRegister("hMwCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2760655a634677$export$2e2bcd8739ae039);
var // Get data from the json file located at the root of the folder at the address agentUrl
$cc2760655a634677$export$2e2bcd8739ae039 = async (agentUrl)=>{
    const responseData = await fetch(`${agentUrl}/manifest.json`).then((data)=>{
        return data.json();
    }).then((json)=>{
        return json;
    }).catch((error)=>{
        console.log(error);
        return null;
    });
    // Set urls to retrieve the animations and a portrait of the agent
    if (responseData !== null) {
        responseData.url = responseData.character ? `${agentUrl}/${responseData.character}` : agentUrl;
        responseData.portrait = agentUrl + '/' + responseData.portrait;
        responseData.useBodyEngineThree = !!responseData.character;
    }
    return responseData;
};

});


parcelRegister("7j7nS", function(module, exports) {

$parcel$export(module.exports, "widgetDefault", () => $410cf9d598c613db$export$4aebf65ed07cf17b);
$parcel$export(module.exports, "defaultThemeDark", () => $410cf9d598c613db$export$d80fe84b82195dbd);
$parcel$export(module.exports, "defaultThemeLight", () => $410cf9d598c613db$export$1196b7bf97f3d16c);

var $kdMEA = parcelRequire("kdMEA");
const $410cf9d598c613db$export$4aebf65ed07cf17b = {
    rgb: 'rgb(112, 112, 112)'
};
const $410cf9d598c613db$export$d80fe84b82195dbd = {
    ...(0, $kdMEA.commonColors),
    companyName: '#000',
    loader: {
        animation: (0, $kdMEA.commonColors).primary,
        background: 'rgba(18,18,18,0.7)',
        text: '#FFF',
        toggle: {
            text: '#000',
            background: (0, $kdMEA.commonColors).primary
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        }
    },
    card: {
        frame: {
            background: '#2B2B2B',
            border: 'transparent',
            text: '#F7F3F6'
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        },
        discoverButton: {
            background: {
                default: '#eaebf0',
                hover: 'transparent'
            },
            border: {
                default: 'transparent',
                hover: '#FFF'
            },
            text: {
                default: '#575F6B',
                hover: '#FFF'
            }
        }
    },
    textMode: {
        panel: {
            background: 'rgba(255, 255, 255, 0.9)',
            border: 'transparent',
            conversationUser: '#FFF',
            conversationBot: '#2C2C2C',
            backgroundUser: (0, $kdMEA.commonColors).secondary,
            backgroundBot: '#F0F0F0'
        }
    },
    vocalMode: {
        subtitles: {
            text: '#FFF',
            background: '#000'
        }
    },
    formInput: {
        text: {
            default: (0, $kdMEA.commonColors).secondary,
            hover: '#FFF'
        },
        inputRadioCheckbox: {
            unchecked: {
                background: '#434141',
                border: '#818181'
            },
            checked: {
                background: (0, $kdMEA.commonColors).primary,
                border: (0, $kdMEA.commonColors).primary,
                item: '#000'
            }
        },
        inputButton: {
            background: {
                default: (0, $kdMEA.commonColors).black,
                hover: (0, $kdMEA.commonColors).primary
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: '#FFF',
                hover: '#FFF'
            }
        },
        likert: {
            default: 'transparent',
            hover: '#E8B712'
        }
    }
};
const $410cf9d598c613db$export$1196b7bf97f3d16c = {
    ...(0, $kdMEA.commonColors),
    companyName: '#000',
    loader: {
        animation: (0, $kdMEA.commonColors).primary,
        background: 'rgba(18,18,18,0.7)',
        text: '#FFF',
        toggle: {
            text: '#000',
            background: (0, $kdMEA.commonColors).primary
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        }
    },
    card: {
        frame: {
            background: '#2B2B2B',
            border: 'transparent',
            text: '#F7F3F6'
        },
        button: {
            background: {
                default: 'transparent',
                hover: 'transparent'
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            }
        },
        discoverButton: {
            background: {
                default: '#eaebf0',
                hover: 'transparent'
            },
            border: {
                default: 'transparent',
                hover: '#FFF'
            },
            text: {
                default: '#575F6B',
                hover: '#FFF'
            }
        }
    },
    textMode: {
        panel: {
            background: 'rgba(255, 255, 255, 0.9)',
            border: 'transparent',
            conversationUser: '#FFF',
            conversationBot: '#2C2C2C',
            backgroundUser: (0, $kdMEA.commonColors).secondary,
            backgroundBot: '#F0F0F0'
        }
    },
    vocalMode: {
        subtitles: {
            text: '#FFF',
            background: '#000'
        }
    },
    formInput: {
        text: {
            default: (0, $kdMEA.commonColors).secondary,
            hover: '#FFF'
        },
        inputRadioCheckbox: {
            unchecked: {
                background: '#434141',
                border: '#818181'
            },
            checked: {
                background: (0, $kdMEA.commonColors).primary,
                border: (0, $kdMEA.commonColors).primary,
                item: '#000'
            }
        },
        inputButton: {
            background: {
                default: (0, $kdMEA.commonColors).black,
                hover: (0, $kdMEA.commonColors).primary
            },
            border: {
                default: (0, $kdMEA.commonColors).primary,
                hover: '#FFF'
            },
            text: {
                default: '#FFF',
                hover: '#FFF'
            }
        },
        likert: {
            default: 'transparent',
            hover: '#E8B712'
        }
    }
};

});


parcelRegister("giKuE", function(module, exports) {

$parcel$export(module.exports, "useSpeechStore", () => $51387529b7472822$export$f299240efcda25a2);
$parcel$export(module.exports, "default", () => $51387529b7472822$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $eh4BG = parcelRequire("eh4BG");
const $51387529b7472822$var$initialState = {
    ponyfillCredentials: undefined,
    useContinuousRecognition: false,
    customVoice: undefined,
    voice: null,
    mode: (0, $2rYkD.Mode).text,
    disableSound: false,
    speaking: false,
    muted: false,
    cancel: false,
    boundaryData: [],
    visemeData: [],
    singleVisemeAdded: null,
    multiVisemesAdded: [],
    currentOrLastPlayedActivity: undefined,
    isMicrophoneAllowed: false,
    showMicrophoneModal: false,
    permissionStatus: (0, $2rYkD.PermissionStatus).waiting,
    activeRecognitionState: (0, $2rYkD.RecognitionState).Closed,
    lastRecognitionInterim: '',
    streamingReplyToId: null,
    streamingQueue: [],
    streamingReplyToIdToIgnore: null,
    speechRecognitionDynamicGrammars: [],
    externalTextToSpeech: undefined
};
const $51387529b7472822$var$createSpeechStore = (setRetorikEvent, getListStatus, setListStatus, setLastListActivity, setUserTyping)=>{
    return (0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$51387529b7472822$var$initialState,
            actions: {
                setPonyfillFactoryCredentials: (value)=>{
                    set({
                        ponyfillCredentials: value
                    });
                },
                setUseContinuousRecognition: (deviceType, options)=>{
                    if (options?.enableContinuousRecognitionOnAllDevices) set({
                        useContinuousRecognition: true
                    });
                    else if (options?.enableContinuousRecognitionOn) switch(deviceType){
                        case (0, $2rYkD.DeviceType).mobile:
                            set({
                                useContinuousRecognition: !!options.enableContinuousRecognitionOn.mobile
                            });
                            break;
                        case (0, $2rYkD.DeviceType).widget:
                        case (0, $2rYkD.DeviceType).widgetLandscape:
                        case (0, $2rYkD.DeviceType).widgetBorne:
                            set({
                                useContinuousRecognition: !!options.enableContinuousRecognitionOn.widget
                            });
                            break;
                        case (0, $2rYkD.DeviceType).landscape:
                            set({
                                useContinuousRecognition: !!options.enableContinuousRecognitionOn.desktop
                            });
                            break;
                        case (0, $2rYkD.DeviceType).borne:
                            set({
                                useContinuousRecognition: !!options.enableContinuousRecognitionOn.borne
                            });
                            break;
                        default:
                            set({
                                useContinuousRecognition: false
                            });
                            break;
                    }
                    else set({
                        useContinuousRecognition: false
                    });
                },
                setCustomVoice: (value)=>{
                    set({
                        customVoice: value
                    });
                },
                setVoice: (value)=>{
                    set({
                        voice: value
                    });
                },
                setMode: (value)=>{
                    set({
                        mode: value
                    });
                    setLastListActivity(undefined);
                    value !== (0, $2rYkD.Mode).text && setUserTyping(false);
                    !get().disableSound && get().actions.setMuted(value === (0, $2rYkD.Mode).text);
                },
                setDisableSound: (value)=>{
                    set({
                        disableSound: value
                    });
                },
                setSpeaking: (value)=>{
                    set(()=>{
                        return value === false ? {
                            speaking: value,
                            visemeData: [],
                            singleVisemeAdded: null,
                            multiVisemesAdded: []
                        } : {
                            speaking: value
                        };
                    });
                    setRetorikEvent(value ? (0, $2rYkD.RetorikEvent).SpeechStarted : (0, $2rYkD.RetorikEvent).SpeechEnded);
                },
                setMuted: (value)=>{
                    set({
                        muted: value
                    });
                },
                toggleMuted: ()=>{
                    set((state)=>({
                            muted: !state.muted
                        }));
                },
                cancelCurrentUtterance: ()=>{
                    set({
                        cancel: true
                    });
                },
                resetCancelCurrentUtterance: ()=>{
                    set({
                        cancel: false
                    });
                },
                setBoundaryData: (value)=>{
                    set({
                        boundaryData: value
                    });
                },
                setVisemeData: (value)=>{
                    set({
                        visemeData: value,
                        multiVisemesAdded: value
                    });
                },
                addViseme: (value)=>{
                    set((state)=>({
                            visemeData: [
                                ...state.visemeData,
                                value
                            ],
                            singleVisemeAdded: value
                        }));
                },
                setCurrentOrLastPlayedActivity: (value)=>{
                    set({
                        currentOrLastPlayedActivity: value
                    });
                    if (value?.attachmentLayout?.toLowerCase() === 'davilist') {
                        if (getListStatus() !== (0, $2rYkD.ListStatus).opened) setListStatus((0, $2rYkD.ListStatus).available);
                    }
                },
                setIsMicrophoneAllowed: (value)=>{
                    set({
                        isMicrophoneAllowed: value
                    });
                },
                setShowMicrophoneModal: (value)=>{
                    set({
                        showMicrophoneModal: value
                    });
                },
                toggleMicrophone: (fromExpectedInput)=>{
                    if (get().mode === (0, $2rYkD.Mode).text) get().actions.setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
                    else switch(get().activeRecognitionState){
                        // Do nothing if we are in a transition state
                        case (0, $2rYkD.RecognitionState).Initializing:
                        case (0, $2rYkD.RecognitionState).Closing:
                            return;
                        case (0, $2rYkD.RecognitionState).Listening:
                            get().actions.setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
                            get().actions.cancelCurrentUtterance();
                            break;
                        case (0, $2rYkD.RecognitionState).Closed:
                            get().actions.setActiveRecognitionState((0, $2rYkD.RecognitionState).Initializing);
                            !fromExpectedInput && get().actions.cancelCurrentUtterance();
                            break;
                    }
                },
                askPermission: async ()=>{
                    set({
                        showMicrophoneModal: true
                    });
                    (0, $eh4BG.default)().then((permission)=>{
                        // Hide modal window and open microphone if this one is allowed
                        if (permission === (0, $2rYkD.PermissionStatus).allowed) {
                            set({
                                permissionStatus: permission,
                                isMicrophoneAllowed: true,
                                showMicrophoneModal: false
                            });
                            get().actions.toggleMicrophone();
                        } else set({
                            permissionStatus: permission,
                            isMicrophoneAllowed: false
                        });
                    });
                },
                setActiveRecognitionState: (value)=>{
                    set({
                        activeRecognitionState: value
                    });
                },
                setLastRecognitionInterim: (value)=>{
                    set({
                        lastRecognitionInterim: value
                    });
                },
                setStreamingReplyToId: (value)=>{
                    set({
                        streamingReplyToId: value
                    });
                },
                addToStreamingQueue: (value)=>{
                    if (value.replyToId) {
                        if (value.replyToId !== get().streamingReplyToIdToIgnore) {
                            // Set replyToId and new queue if replyToId is different from the current one
                            if (get().streamingReplyToId !== value.replyToId) set({
                                streamingReplyToId: value.replyToId,
                                streamingQueue: [
                                    value
                                ]
                            });
                            else set({
                                streamingQueue: [
                                    ...get().streamingQueue,
                                    value
                                ]
                            });
                        }
                    } else set({
                        streamingQueue: [
                            ...get().streamingQueue,
                            value
                        ]
                    });
                },
                // If "twice" parameter is true, let's remove 2 elements instead of one (used with the message at the end of a streaming that should not be spoken)
                removeFirstFromStreamingQueue: (twice)=>{
                    set((state)=>({
                            streamingQueue: state.streamingQueue.slice(twice ? 2 : 1)
                        }));
                },
                killCurrentStreaming: ()=>{
                    set({
                        streamingReplyToIdToIgnore: get().streamingReplyToId,
                        streamingQueue: []
                    });
                },
                checkActivityReplyToId: (replyToId)=>{
                    get().streamingReplyToId !== replyToId && get().actions.killCurrentStreaming();
                },
                addSpeechRecognitionDynamicGrammar: (value)=>{
                    const currentGrammars = get().speechRecognitionDynamicGrammars;
                    // For each value, verifiy if it doesn't exist in the array yet
                    if (Array.isArray(value)) {
                        const valuesToAdd = [];
                        value.forEach((val)=>{
                            !currentGrammars.includes(val) && valuesToAdd.push(val);
                        });
                        valuesToAdd.length && set({
                            speechRecognitionDynamicGrammars: [
                                ...currentGrammars,
                                ...valuesToAdd
                            ]
                        });
                    } else !currentGrammars.includes(value) && set({
                        speechRecognitionDynamicGrammars: [
                            ...currentGrammars,
                            value
                        ]
                    });
                },
                playExternalSynthesis: (value)=>{
                    set({
                        externalTextToSpeech: value
                    });
                },
                resetSpeechStore: ()=>{
                    set({
                        ...$51387529b7472822$var$initialState
                    });
                }
            }
        };
    });
};
const $51387529b7472822$var$SpeechContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $51387529b7472822$export$f299240efcda25a2 = (selector)=>{
    const store = (0, $bxRTa.useContext)($51387529b7472822$var$SpeechContext);
    if (!store) throw new Error('Retorik Framework > useSpeechStore must be used within SpeechProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $51387529b7472822$var$SpeechProvider = ({ children: children })=>{
    const { setRetorikEvent: setRetorikEvent, getListStatus: getListStatus, setListStatus: setListStatus, setLastListActivity: setLastListActivity, setUserTyping: setUserTyping } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const [store] = (0, $bxRTa.useState)(()=>$51387529b7472822$var$createSpeechStore(setRetorikEvent, getListStatus, setListStatus, setLastListActivity, setUserTyping));
    return /*#__PURE__*/ (0, $fl9nK.jsx)($51387529b7472822$var$SpeechContext.Provider, {
        value: store,
        children: children
    });
};
var $51387529b7472822$export$2e2bcd8739ae039 = $51387529b7472822$var$SpeechProvider;

});
parcelRegister("eh4BG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a4bbcc726cceb44$export$2e2bcd8739ae039);

var $2rYkD = parcelRequire("2rYkD");
const $5a4bbcc726cceb44$var$getMicrophonePermission = async ()=>{
    try {
        return navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            return stream ? (0, $2rYkD.PermissionStatus).allowed : (0, $2rYkD.PermissionStatus).refused;
        }, (reason)=>{
            console.log('Retorik Framework > microphone permission refused : ', reason);
            return (0, $2rYkD.PermissionStatus).refused;
        }).catch((error)=>{
            console.log('Retorik Framework > microphone permission refused : ', error);
            return (0, $2rYkD.PermissionStatus).error;
        });
    } catch (error) {
        console.log('Retorik Framework > microphone permission refused : ', error);
        return (0, $2rYkD.PermissionStatus).error;
    }
};
var $5a4bbcc726cceb44$export$2e2bcd8739ae039 = $5a4bbcc726cceb44$var$getMicrophonePermission;

});


parcelRegister("bWQ72", function(module, exports) {

$parcel$export(module.exports, "useActivityStore", () => $1a9364e4fc82f8ea$export$b56465394e2b1287);
$parcel$export(module.exports, "default", () => $1a9364e4fc82f8ea$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $4xGiN = parcelRequire("4xGiN");

var $6HxxJ = parcelRequire("6HxxJ");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $dHUeX = parcelRequire("dHUeX");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $aC3vq = parcelRequire("aC3vq");

var $aO9lO = parcelRequire("aO9lO");

var $8K60s = parcelRequire("8K60s");

var $7z3DI = parcelRequire("7z3DI");

var $29xBE = parcelRequire("29xBE");
const $1a9364e4fc82f8ea$var$initialState = {
    activities: [],
    endedActivities: [],
    lastActivity: undefined,
    lastBotActivity: undefined,
    messageActivities: [],
    lastMessageActivity: undefined,
    eventActivities: [],
    lastEventActivity: undefined,
    botMessageActivities: [],
    lastBotMessageActivity: undefined,
    botEventActivities: [],
    lastBotEventActivity: undefined,
    botStreamingActivities: new Map(),
    userMessageActivities: [],
    lastUserMessageActivity: undefined,
    conversationId: null,
    watermark: 0,
    retrievingConversation: false,
    addRetorikNewsConversationIdInLocalStorage: undefined,
    cookies: [],
    queue: [],
    queueLock: false
};
const $1a9364e4fc82f8ea$var$regexDataCommand = /(\{data-command=")[\p{L}\p{N}\p{Po}\p{Pd}\p{Pc}\s\u0027\u2019]+("\})(<br\s\/>)?/gu;
const $1a9364e4fc82f8ea$var$createActivityStore = (localeRef, isUsedOnBorneRef, inputHintBehaviourRef, setCurrentId, setRestoreInputsState, addToStreamingQueue, setMode, unlockClickedButton, setSubmitDelayBeforeSendingMessage, setIsWaitingForResponse, setSendBoxPlaceHolder)=>{
    return (0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$1a9364e4fc82f8ea$var$initialState,
            actions: {
                addCookie: (value)=>{
                    value && set({
                        cookies: [
                            ...get().cookies,
                            value
                        ]
                    });
                },
                setCookiesInBrowser: ()=>{
                    const cookies = get().cookies;
                    if (cookies.length) {
                        cookies.forEach((cookie)=>{
                            if (cookie.indexOf('<conversationId>') > -1) {
                                const conversationId = get().conversationId;
                                if (conversationId) {
                                    const processedCookie = cookie.replace('<conversationId>', conversationId);
                                    document.cookie = processedCookie;
                                }
                            } else document.cookie = cookie;
                        });
                        set({
                            cookies: []
                        });
                    }
                },
                checkCurrentConversationId: (value)=>{
                    const currentConversationId = get().conversationId;
                    return !!(currentConversationId && value?.includes(currentConversationId));
                },
                checkConversationId: (value)=>{
                    // Add current conversation id with tenant name in local storage if we are in a RetorikNews component.
                    // This prevents creating a new conversation each time RetorikNews is launched (used in Retorik Kiosk).
                    if (get().addRetorikNewsConversationIdInLocalStorage) {
                        const dataToPutInlocalStorage = {
                            conversationId: value,
                            startedAt: Date.now()
                        };
                        localStorage.setItem(`Retorik.News.Conversation.${get().addRetorikNewsConversationIdInLocalStorage}`, JSON.stringify(dataToPutInlocalStorage));
                        set({
                            addRetorikNewsConversationIdInLocalStorage: undefined
                        });
                    }
                    // Check directline id to know if we have to reset the activities
                    if (value && value !== get().conversationId) {
                        get().conversationId === null ? set({
                            conversationId: value
                        }) : set({
                            ...$1a9364e4fc82f8ea$var$initialState,
                            conversationId: value
                        });
                        // Set desired cookies once the conversation id is set / changed
                        get().actions.setCookiesInBrowser();
                    }
                },
                processQueue: async ()=>{
                    if (get().queue.length) {
                        const currentActivity = get().queue[0];
                        currentActivity.type === 'message' ? await get().actions.processAddBotMessage(currentActivity) : await get().actions.processAddBotEvent(currentActivity);
                        // Remove the first element from the queue (the one that got processed above) and process the queue once again
                        set({
                            queue: get().queue.slice(1)
                        });
                        get().actions.processQueue();
                    } else set({
                        queueLock: false
                    });
                },
                processAddBotMessage: async (value)=>{
                    setCurrentId(undefined);
                    const processedActivity = await get().actions.processBotMessageActivity(value);
                    const tempActivity = get().retrievingConversation ? undefined : processedActivity;
                    // Add this activity to the streaming queue if we are not in conversation retrieval process
                    !get().retrievingConversation && addToStreamingQueue(processedActivity);
                    set({
                        activities: [
                            ...get().activities,
                            processedActivity
                        ],
                        lastActivity: tempActivity,
                        lastBotActivity: tempActivity,
                        messageActivities: [
                            ...get().messageActivities,
                            processedActivity
                        ],
                        botMessageActivities: [
                            ...get().botMessageActivities,
                            processedActivity
                        ],
                        lastMessageActivity: tempActivity,
                        lastBotMessageActivity: tempActivity,
                        watermark: get().watermark + 1
                    });
                    Promise.resolve();
                },
                addBotMessage: async (value)=>{
                    if (get().actions.checkCurrentConversationId(value.id)) {
                        if (get().queueLock) set({
                            queue: [
                                ...get().queue,
                                value
                            ]
                        });
                        else {
                            set({
                                queueLock: true
                            });
                            await get().actions.processAddBotMessage(value);
                            unlockClickedButton();
                            setIsWaitingForResponse(false);
                            get().actions.processQueue();
                        }
                    }
                },
                processAddBotEvent: async (value)=>{
                    const streamingMap = new Map(get().botStreamingActivities);
                    // Deal with streaming activities
                    if (value.name?.toLowerCase() === 'davi.streammessageactivity') // Add this activity to the streaming queue if we are not in conversation retrieval process
                    {
                        if (value.text?.trim().length && !get().retrievingConversation) {
                            // Create speak field from the text one
                            const processedText = (0, $aC3vq.processMarkdownAndSpeechMarkdown)(value.text, true);
                            value.speak = processedText.text;
                            value.htmlText = processedText.htmlText;
                            addToStreamingQueue(value);
                            // Set data in the Map for text display
                            if (value.replyToId) {
                                const currentStreamingData = streamingMap.get(value.replyToId);
                                currentStreamingData ? streamingMap.set(value.replyToId, [
                                    ...currentStreamingData,
                                    value
                                ]) : streamingMap.set(value.replyToId, [
                                    value
                                ]);
                            }
                        }
                    }
                    set({
                        activities: [
                            ...get().activities,
                            value
                        ],
                        lastActivity: get().retrievingConversation ? undefined : value,
                        lastBotActivity: get().retrievingConversation ? undefined : value,
                        eventActivities: [
                            ...get().eventActivities,
                            value
                        ],
                        botEventActivities: [
                            ...get().botEventActivities,
                            value
                        ],
                        lastBotEventActivity: value,
                        lastEventActivity: value,
                        botStreamingActivities: streamingMap,
                        watermark: get().watermark + 1
                    });
                    Promise.resolve();
                },
                addBotEvent: async (value)=>{
                    if (get().actions.checkCurrentConversationId(value.id)) {
                        //
                        if (value.name?.toLowerCase() === 'switchtotextmode') {
                            setMode((0, $2rYkD.Mode).text);
                            set({
                                watermark: get().watermark + 1
                            });
                        } else if (get().queueLock) set({
                            queue: [
                                ...get().queue,
                                value
                            ]
                        });
                        else {
                            set({
                                queueLock: true
                            });
                            await get().actions.processAddBotEvent(value);
                            unlockClickedButton();
                            setIsWaitingForResponse(false);
                            get().actions.processQueue();
                        }
                    }
                },
                addUserMessage: async (value)=>{
                    if (get().actions.checkCurrentConversationId(value.id)) {
                        setIsWaitingForResponse(true);
                        set({
                            activities: [
                                ...get().activities,
                                value
                            ],
                            lastActivity: value,
                            messageActivities: [
                                ...get().messageActivities,
                                value
                            ],
                            userMessageActivities: [
                                ...get().userMessageActivities,
                                value
                            ],
                            lastMessageActivity: value,
                            lastUserMessageActivity: value,
                            watermark: get().watermark + 1
                        });
                    }
                },
                addUserEvent: (value)=>{
                    if (get().actions.checkCurrentConversationId(value.id)) {
                        // Only wait for response if the event is one that need it
                        !(0, $kdMEA.nonResponseInducingEvents).find((eventName)=>value.name?.toLowerCase().includes(eventName)) && setIsWaitingForResponse(true);
                        set({
                            activities: [
                                ...get().activities,
                                value
                            ],
                            lastActivity: value,
                            lastEventActivity: value,
                            eventActivities: [
                                ...get().eventActivities,
                                value
                            ],
                            watermark: get().watermark + 1
                        });
                    }
                },
                addEndedActivity: (value)=>{
                    if (!get().endedActivities.includes(value)) set({
                        endedActivities: [
                            ...get().endedActivities,
                            value
                        ]
                    });
                },
                setRetrievingConversation: (value)=>{
                    set({
                        retrievingConversation: value
                    });
                },
                setAddRetorikNewsConversationIdInLocalStorage: (value)=>{
                    set({
                        addRetorikNewsConversationIdInLocalStorage: value
                    });
                },
                resetActivityStore: ()=>{
                    set({
                        ...$1a9364e4fc82f8ea$var$initialState
                    });
                },
                processBotMessageActivity: async (activity)=>{
                    setRestoreInputsState(!!activity?.channelData?.restoreInputsState);
                    setSendBoxPlaceHolder(activity.value?.retorik?.placeHolder || undefined);
                    setSubmitDelayBeforeSendingMessage(activity.value?.retorik?.submitDelay);
                    if (activity.attachmentLayout?.toLowerCase() === 'namedlist' && activity.attachments?.length) {
                        const content = activity.attachments[0].content?.value;
                        if (Array.isArray(content) && content.length > 12) {
                            const title = activity.attachments[0].content?.title;
                            const lastContent = content.pop();
                            const nbAttachments = Math.ceil(content.length / 11);
                            const attachments = [];
                            const locale = localeRef.current || 'fr-FR';
                            // Set 'group' data (initial of the lastname) for each item
                            content.forEach((item)=>{
                                if (item.text) {
                                    const splitName = item.text.split(' ');
                                    if (splitName.length > 1) item.group = splitName[1].charAt(0).toLocaleUpperCase(locale);
                                    else item.group = splitName[0].charAt(0).toLocaleUpperCase(locale);
                                }
                            });
                            for(let i = 0; i < nbAttachments; i++)attachments.push({
                                contentType: (0, $dHUeX.CONTENT_TYPE_NAMED_LIST),
                                content: {
                                    title: title,
                                    value: [
                                        ...content.slice(i * 11, i * 11 + 11),
                                        lastContent
                                    ]
                                }
                            });
                            activity.attachments = attachments;
                        }
                    }
                    // If the application is used on a borne and there are attachments, check if a received attachment is a multi-link one.
                    // If there is some, we need to split it in several attachments, one for each link.
                    if (isUsedOnBorneRef.current && activity.attachments?.length) {
                        let count = 0;
                        const tempAttachments = [];
                        for (const attachment of activity.attachments)if (attachment.contentType === (0, $dHUeX.CONTENT_TYPE_LINK) && Array.isArray(attachment.content?.urlData)) {
                            count++;
                            const splitAttachments = await (0, $8K60s.createAttachmentsFromMultiLink)(attachment.content.urlData);
                            tempAttachments.push(...splitAttachments);
                        } else tempAttachments.push(attachment);
                        // If some attachments have been split, we replace the attachments in the activity
                        count && (activity.attachments = tempAttachments);
                        // Carousel display if there is more than 1 card
                        count && activity.attachments.length > 1 && (activity.attachmentLayout = 'carousel');
                    }
                    const processedData = (0, $29xBE.default)(activity);
                    // Set processed speak, text and attachments if there are some
                    processedData.speak && (activity.speak = processedData.speak);
                    processedData.text && (activity.text = processedData.text);
                    processedData.htmlText && (activity.htmlText = processedData.htmlText);
                    // Check if there are cards to create from images
                    if (processedData.images.length) {
                        // If there is no attachment field, create an empty one
                        activity.attachments === undefined && (activity.attachments = []);
                        // Create content from image data and add it to the attachments
                        for (const image of processedData.images){
                            const imageAttachment = await (0, $7z3DI.default)(image);
                            activity.attachments.push(imageAttachment);
                        }
                        activity.attachments.length > 1 && (activity.attachmentLayout = 'carousel');
                    }
                    // Check if there are cards to create from links
                    if (processedData.urls.length) {
                        // If there is no attachment field, create an empty one
                        activity.attachments === undefined && (activity.attachments = []);
                        // Create content asynchonously from url data and add it to the attachments
                        for (const url of processedData.urls){
                            const fetchedAttachment = await (0, $8K60s.default)(url);
                            activity.attachments.push(fetchedAttachment);
                        }
                        activity.attachments.length > 1 && (activity.attachmentLayout = 'carousel');
                    }
                    // Transform herocards in adaptivecards
                    const heroToAdaptiveAttachments = (0, $aO9lO.processAttachments)(activity.attachments);
                    heroToAdaptiveAttachments && (activity.attachments = [
                        ...heroToAdaptiveAttachments
                    ]);
                    // Transform suggested actions into cards if the display isn't daviList
                    if (activity.suggestedActions?.actions && activity.attachmentLayout?.toLowerCase() !== 'davilist') {
                        let actionsArray = [];
                        activity.suggestedActions.actions.forEach((suggestedAction)=>{
                            const action = {
                                title: suggestedAction.title,
                                action: suggestedAction.value
                            };
                            actionsArray = [
                                ...actionsArray,
                                action
                            ];
                        });
                        const suggestedActionAttachment = {
                            contentType: (0, $dHUeX.CONTENT_TYPE_SUGGESTEDACTION),
                            content: {
                                title: activity.text || '',
                                actions: actionsArray
                            }
                        };
                        // Create field attachments with the newly created one if no attachment yet, or add to existing ones
                        activity.attachments === undefined ? activity.attachments = [
                            suggestedActionAttachment
                        ] : activity.attachments.push(suggestedActionAttachment);
                    }
                    // Deal with text containing [data command] data to make them usable in text mode
                    if (activity?.text && activity.text.includes('{data-command=')) {
                        const splitText = activity.text.split('{data-command=');
                        const dataForAttachment = [];
                        for(let i = 1; i < splitText.length; i++){
                            const text = splitText[i - 1].substring(splitText[i - 1].lastIndexOf('\n') ? splitText[i - 1].lastIndexOf('\n') + 1 : 0).trim();
                            const replacement = splitText[i].substring(0, splitText[i].indexOf('}')).replaceAll('"', '');
                            dataForAttachment.push({
                                text: text,
                                differentTextToSend: replacement
                            });
                            // Remove text part from speak / text / htmlText
                            activity.speak && (activity.speak = activity.speak.replace(text, ''));
                            activity.text = activity.text.replace(text, '');
                            activity.htmlText = activity.htmlText?.replace(text, '');
                        }
                        if (dataForAttachment.length > 0) {
                            const suggestionAttachment = {
                                contentType: (0, $dHUeX.CONTENT_TYPE_SUGGESTION),
                                content: {
                                    suggestions: dataForAttachment,
                                    showTutorial: false
                                }
                            };
                            // Create field attachment swith the newly created one if no attachment yet, or add to existing ones
                            activity.attachments === undefined ? activity.attachments = [
                                suggestionAttachment
                            ] : activity.attachments.push(suggestionAttachment);
                        }
                        // Remove all [data command] from speak / text / htmlText
                        activity.speak && (activity.speak = activity.speak.replaceAll($1a9364e4fc82f8ea$var$regexDataCommand, ''));
                        activity.text = activity.text.replaceAll($1a9364e4fc82f8ea$var$regexDataCommand, '');
                        activity.htmlText = activity.htmlText?.replaceAll($1a9364e4fc82f8ea$var$regexDataCommand, '');
                    }
                    if ((activity.value?.retorik?.placeHolder || activity.value?.retorik?.submitDelay) && !activity.attachments?.length) activity.attachments = [
                        {
                            contentType: (0, $dHUeX.CONTENT_TYPE_INTERNAL_COUNTER)
                        }
                    ];
                    // Process activity inputHint parameter if necessary
                    if (inputHintBehaviourRef.current) switch(inputHintBehaviourRef.current.toLowerCase()){
                        case (0, $2rYkD.InputHintBehaviour).always:
                            // Force value to 'expectingInput' to trigger microphone opening in vocal mode
                            activity.inputHint = 'expectingInput';
                            break;
                        case (0, $2rYkD.InputHintBehaviour).ignore:
                        case (0, $2rYkD.InputHintBehaviour).never:
                            // Force value to 'ignoreInput' to prevent microphone opening in vocal mode
                            activity.inputHint = 'ignoreInput';
                            break;
                        case (0, $2rYkD.InputHintBehaviour).auto:
                        default:
                            break;
                    }
                    return activity;
                }
            }
        };
    });
};
const $1a9364e4fc82f8ea$var$ActivityContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $1a9364e4fc82f8ea$export$b56465394e2b1287 = (selector)=>{
    const store = (0, $bxRTa.useContext)($1a9364e4fc82f8ea$var$ActivityContext);
    if (!store) throw new Error('Retorik Framework > useActivityStore must be used within ActivityProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $1a9364e4fc82f8ea$var$ActivityProvider = ({ children: children })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const localeRef = (0, $bxRTa.useRef)('fr-FR');
    const isUsedOnBorneRef = (0, $bxRTa.useRef)(false);
    const inputHintBehaviourRef = (0, $bxRTa.useRef)(undefined);
    const { setCurrentId: setCurrentId, setRestoreInputsState: setRestoreInputsState } = (0, $6HxxJ.useAdaptiveCardStore)((state)=>state.actions);
    const { addToStreamingQueue: addToStreamingQueue, setMode: setMode } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const unlockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.actions.unlockClickedButton);
    const { setSubmitDelayBeforeSendingMessage: setSubmitDelayBeforeSendingMessage, setIsWaitingForResponse: setIsWaitingForResponse, setSendBoxPlaceHolder: setSendBoxPlaceHolder } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const [store] = (0, $bxRTa.useState)(()=>$1a9364e4fc82f8ea$var$createActivityStore(localeRef, isUsedOnBorneRef, inputHintBehaviourRef, setCurrentId, setRestoreInputsState, addToStreamingQueue, setMode, unlockClickedButton, setSubmitDelayBeforeSendingMessage, setIsWaitingForResponse, setSendBoxPlaceHolder));
    (0, $bxRTa.useEffect)(()=>{
        localeRef.current = locale;
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isUsedOnBorneRef.current = configuration.isUsedOnBorne;
    }, [
        configuration.isUsedOnBorne
    ]);
    (0, $bxRTa.useEffect)(()=>{
        inputHintBehaviourRef.current = configuration.speechRecognitionOptions?.inputHintBehaviour;
    }, [
        configuration.speechRecognitionOptions?.inputHintBehaviour
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)($1a9364e4fc82f8ea$var$ActivityContext.Provider, {
        value: store,
        children: children
    });
};
var $1a9364e4fc82f8ea$export$2e2bcd8739ae039 = $1a9364e4fc82f8ea$var$ActivityProvider;

});
parcelRegister("dHUeX", function(module, exports) {

$parcel$export(module.exports, "CONTENT_TYPE_ADAPTIVE_CARD", () => $61cb18f0f95eed1f$export$bbfd0bb0baceb2f8);
$parcel$export(module.exports, "CONTENT_TYPE_HERO_CARD", () => $61cb18f0f95eed1f$export$264354e75632a3ba);
$parcel$export(module.exports, "CONTENT_TYPE_NEWS", () => $61cb18f0f95eed1f$export$7ff82c027074e396);
$parcel$export(module.exports, "CONTENT_TYPE_POI", () => $61cb18f0f95eed1f$export$8c612ad42a82284);
$parcel$export(module.exports, "CONTENT_TYPE_EMPTY", () => $61cb18f0f95eed1f$export$9399f66a54c38cac);
$parcel$export(module.exports, "CONTENT_TYPE_IMAGE", () => $61cb18f0f95eed1f$export$c50891df8986f6d9);
$parcel$export(module.exports, "CONTENT_TYPE_LINK", () => $61cb18f0f95eed1f$export$cce25171fe980112);
$parcel$export(module.exports, "CONTENT_TYPE_DISCOVER", () => $61cb18f0f95eed1f$export$8ebd8d161896e63a);
$parcel$export(module.exports, "CONTENT_TYPE_SUGGESTION", () => $61cb18f0f95eed1f$export$a4f2f23a67537f78);
$parcel$export(module.exports, "CONTENT_TYPE_SUGGESTEDACTION", () => $61cb18f0f95eed1f$export$2730c89e9ebd0948);
$parcel$export(module.exports, "CONTENT_TYPE_GRID", () => $61cb18f0f95eed1f$export$25f48dcc671a4afe);
$parcel$export(module.exports, "CONTENT_TYPE_TILE", () => $61cb18f0f95eed1f$export$98515f55cf51a42d);
$parcel$export(module.exports, "CONTENT_TYPE_INTERNAL_COUNTER", () => $61cb18f0f95eed1f$export$148e350383f31950);
$parcel$export(module.exports, "CONTENT_TYPE_NAMED_LIST", () => $61cb18f0f95eed1f$export$aae5ca847b436674);
$parcel$export(module.exports, "CONTENT_TYPE_GRID_TITLE", () => $61cb18f0f95eed1f$export$8180494a68c87622);
$parcel$export(module.exports, "CONTENT_TYPE_MODAL_EXTERNALURI", () => $61cb18f0f95eed1f$export$a831f0b167e16113);
const $61cb18f0f95eed1f$export$bbfd0bb0baceb2f8 = 'application/vnd.microsoft.card.adaptive';
const $61cb18f0f95eed1f$export$264354e75632a3ba = 'application/vnd.microsoft.card.hero';
const $61cb18f0f95eed1f$export$7ff82c027074e396 = 'application/vnd.davi.retorik.card.news';
const $61cb18f0f95eed1f$export$8c612ad42a82284 = 'application/vnd.davi.retorik.card.poi';
const $61cb18f0f95eed1f$export$9399f66a54c38cac = 'application/vnd.davi.retorik.card.empty';
const $61cb18f0f95eed1f$export$c50891df8986f6d9 = 'application/vnd.davi.retorik.card.image';
const $61cb18f0f95eed1f$export$cce25171fe980112 = 'application/vnd.davi.retorik.card.link';
const $61cb18f0f95eed1f$export$8ebd8d161896e63a = 'application/vnd.davi.retorik.card.discover';
const $61cb18f0f95eed1f$export$a4f2f23a67537f78 = 'application/vnd.davi.retorik.card.suggestion';
const $61cb18f0f95eed1f$export$2730c89e9ebd0948 = 'application/vnd.davi.retorik.card.suggestedaction';
const $61cb18f0f95eed1f$export$25f48dcc671a4afe = 'application/vnd.davi.retorik.card.grid';
const $61cb18f0f95eed1f$export$98515f55cf51a42d = 'application/vnd.davi.retorik.card.tile';
const $61cb18f0f95eed1f$export$148e350383f31950 = 'application/vnd.davi.retorik.card.counter';
const $61cb18f0f95eed1f$export$aae5ca847b436674 = 'application/vnd.davi.retorik.card.namedlistitem';
const $61cb18f0f95eed1f$export$8180494a68c87622 = 'application/vnd.davi.retorik.grid.title';
const $61cb18f0f95eed1f$export$a831f0b167e16113 = 'application/vnd.davi.retorik.modal.externaluri';

});

parcelRegister("aC3vq", function(module, exports) {

$parcel$export(module.exports, "processMarkdownAndSpeechMarkdown", () => $4f72a156fc74e407$export$1b8fbc30fb87d9aa);
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $3Gcj3 = parcelRequire("3Gcj3");
const $4f72a156fc74e407$var$regexLink = /<\/?a([^>])+>/g;
const $4f72a156fc74e407$var$regexImg = /<\/?img([^>])+>/g;
const $4f72a156fc74e407$export$1b8fbc30fb87d9aa = (text, skipAttachments)=>{
    const md = new (0, $28u6w.default)({
        breaks: true,
        html: true,
        xhtmlOut: true,
        typographer: true,
        quotes: `""''`
    });
    let attachmentsToCreate = {
        images: [],
        urls: []
    };
    // text = `[backgroundaudio:"https://daviretorikcdnstorage.blob.core.windows.net/retorik-framework/audiofiles/audiotest.mp3 0.5 2000 1500"][silence:"Leading 1s"] ((Bonjour, comment  allez-vous)[sentence] ? (Bien, merci, et vous-même ?)[sentence;voice:"Fr-fR-jerOMeNeuRal"])[paragraph] (Je suis de (tomato)[ipa:"təˈmeɪtoʊ"] (sapi)[sapi:"iy eh n y uw eh s"] (ups)[ups:"JH AU"] retour (après avoir été remplacée)[emphasis:"strong"] par Brigitte.[silence:"Sentenceboundary 3s"] Au revoir)[voice:"fr-FR-DeniseNeural";emotion:"calm SeniorMale"] ![image](images/bertranges.jpg)`
    // text = `((Bonjour, comment allez-vous ?)[sentence] [1s] (Bien, et toi Jérôme, ça va ?)[sentence])[paragraph] (Bien, merci, et vous-même ?)[voice:"Fr-fR-jerOMeNeuRal"]. Tout-va-pour-le-mieux. (Hallo Denise, wie geht es dir heute ?)[rate:"slow";vol:"x-loud";lang:"de-DE"] (Bonjour, je suis de retour (ASAP)[characters] après avoir été remplacée par Brigitte.Merci)[voice:"fr-FR-DeniseNeural";vol:"loud"] ![image](images/bertranges.jpg)`
    // text = `(Como estas ?)[lang:"es-ES"][1s] Parti - pour le test - (greenage)[lang:"en-US"]. Mettons une image ![image](images/bertranges.jpg).[500ms] En anglais, (parce-que en Français ce n'est pas ça...) greenage se dit (greenage)[lang:"en-US"]. Fin de message (aufwiedersehen)[lang:"de-DE"]`
    // text = `(Le petit chien va dans sa niche car bien escalader archiduchesse long fiente)[ipa:"lə pəti ʃjɛ̃ va dɑ̃ sa niʃ kaʁ bjɛ̃ ɛskalade ar̥ʃidyʃɛːs lɔ̃ fjɑ̃t"]`
    const speechMarkdownReplacedData = (0, $3Gcj3.replaceSpeechMarkdownTags)(text);
    if (!skipAttachments) {
        const parsed = md.parseInline(speechMarkdownReplacedData.text);
        parsed.length && (attachmentsToCreate = $4f72a156fc74e407$var$createNewAttachments(parsed[0].children));
    }
    const textWithHtmlTags = md.render(text);
    // Strip html tags from rendered text
    const newText = $4f72a156fc74e407$var$stripHtml(textWithHtmlTags);
    const speechMarkdownTagsPosition = [];
    speechMarkdownReplacedData.replacements.forEach((replacement)=>{
        const index = text.indexOf(replacement.speechMarkdown);
        speechMarkdownTagsPosition.push([
            index,
            index + replacement.speechMarkdown.length
        ]);
    });
    return {
        ...attachmentsToCreate,
        text: newText,
        htmlText: $4f72a156fc74e407$var$stripHtmlLinkTags(textWithHtmlTags, speechMarkdownTagsPosition)
    };
};
/**
 * Removes speechmarkdown, <a href ...></a> and <img ... /> tags from the text and keeps the others
 * @param text : string
 * @returns string
 */ const $4f72a156fc74e407$var$stripHtmlLinkTags = (text, speechMarkdownTagsPosition)=>{
    // Replace all characters replaced by mardkdown-it renderer (quotes, <, >)
    let newText = text.replaceAll('&quot;', '"');
    newText = newText.replaceAll('&lt;', '<');
    newText = newText.replaceAll('&gt;', '>');
    // Remove speechMarkdown tags, and link/images html tags
    newText = (0, $3Gcj3.getTextWithoutSpeechMarkdown)(newText, speechMarkdownTagsPosition).replaceAll($4f72a156fc74e407$var$regexLink, '');
    newText = newText.replaceAll($4f72a156fc74e407$var$regexImg, '');
    return newText;
};
/**
 * Removes all html tags from the text
 * @param text : string
 * @returns string
 */ const $4f72a156fc74e407$var$stripHtml = (text)=>{
    const temp = document.createElement('div');
    temp.innerHTML = text;
    return temp.textContent && temp.textContent !== '' ? temp.textContent : '';
};
const $4f72a156fc74e407$var$getDataFromToken = (attributes, type)=>{
    // Check if there are attributes, then if one of these attributes contains data with the desired key, and finally if there is a value attached to this key
    const allData = attributes?.find((data)=>data.length > 1 && data[0] === type && data[1] !== '');
    if (allData && allData.length > 1) return allData[1];
    return type === 'href' ? undefined : '';
};
const $4f72a156fc74e407$var$createNewAttachments = (tokens)=>{
    const images = [];
    const urls = [];
    if (tokens?.length) for(let i = 0; i < tokens.length; i++){
        const attributes = tokens[i].attrs;
        switch(tokens[i].type){
            case 'link_open':
                {
                    // Try to retrieve an URl from the href token
                    const url = $4f72a156fc74e407$var$getDataFromToken(attributes, 'href');
                    // If there is an URL, try to retrieve the text contained in the next token 'content' field
                    if (url && !urls.find((v)=>v.url === url)) {
                        const title = $4f72a156fc74e407$var$getDataFromToken(attributes, 'title') || tokens[i + 1]?.content;
                        urls.push({
                            url: url,
                            title: title
                        });
                    }
                    break;
                }
            case 'image':
                {
                    const url = $4f72a156fc74e407$var$getDataFromToken(attributes, 'src');
                    if (url && !images.find((v)=>v.url === url)) images.push({
                        url: url,
                        title: $4f72a156fc74e407$var$getDataFromToken(attributes, 'title'),
                        alt: $4f72a156fc74e407$var$getDataFromToken(attributes, 'alt')
                    });
                    break;
                }
            default:
                break;
        }
    }
    return {
        images: images,
        urls: urls
    };
};

});
parcelRegister("6hiCI", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("28u6w")).default);

var $28u6w = parcelRequire("28u6w");

});
parcelRegister("28u6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f7f8a9103718fb$export$2e2bcd8739ae039);
// Main parser class

var $9Wt9S = parcelRequire("9Wt9S");

var $lOMx4 = parcelRequire("lOMx4");

var $8Dgzl = parcelRequire("8Dgzl");

var $0O45r = parcelRequire("0O45r");

var $cqhCq = parcelRequire("cqhCq");

var $2vOE9 = parcelRequire("2vOE9");

var $eGX2O = parcelRequire("eGX2O");
parcelRequire("kpV4t");
var $2SsKF = parcelRequire("2SsKF");
var $1SHpU = parcelRequire("1SHpU");
var $5CQ13 = parcelRequire("5CQ13");
var $6b7BW = parcelRequire("6b7BW");

var $ib0wl = parcelRequire("ib0wl");

var $5ZRUt = parcelRequire("5ZRUt");

var $gVArB = parcelRequire("gVArB");

var $r2Oyp = parcelRequire("r2Oyp");
const $93f7f8a9103718fb$var$config = {
    default: (0, $5ZRUt.default),
    zero: (0, $gVArB.default),
    commonmark: (0, $r2Oyp.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $93f7f8a9103718fb$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $93f7f8a9103718fb$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $93f7f8a9103718fb$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $93f7f8a9103718fb$var$BAD_PROTO_RE.test(str) ? $93f7f8a9103718fb$var$GOOD_DATA_RE.test(str) : true;
}
const $93f7f8a9103718fb$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $93f7f8a9103718fb$var$normalizeLink(url) {
    const parsed = $6b7BW.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $93f7f8a9103718fb$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $ib0wl.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $1SHpU.default($5CQ13.default(parsed));
}
function $93f7f8a9103718fb$var$normalizeLinkText(url) {
    const parsed = $6b7BW.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $93f7f8a9103718fb$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $ib0wl.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $2SsKF.default($5CQ13.default(parsed), $2SsKF.default.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $93f7f8a9103718fb$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $93f7f8a9103718fb$var$MarkdownIt)) return new $93f7f8a9103718fb$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$9Wt9S.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $2vOE9.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $cqhCq.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $0O45r.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $8Dgzl.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $eGX2O.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $93f7f8a9103718fb$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $93f7f8a9103718fb$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $93f7f8a9103718fb$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $9Wt9S;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $9Wt9S.assign({}, $lOMx4);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.set = function(options) {
    $9Wt9S.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($9Wt9S.isString(presets)) {
        const presetName = presets;
        presets = $93f7f8a9103718fb$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $93f7f8a9103718fb$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $93f7f8a9103718fb$export$2e2bcd8739ae039 = $93f7f8a9103718fb$var$MarkdownIt;

});
parcelRegister("9Wt9S", function(module, exports) {

$parcel$export(module.exports, "isString", () => $0c2ec6ccb12eeab2$export$844ec244b1367d54);
$parcel$export(module.exports, "has", () => $0c2ec6ccb12eeab2$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "assign", () => $0c2ec6ccb12eeab2$export$e6e34fd1f2686227);
$parcel$export(module.exports, "arrayReplaceAt", () => $0c2ec6ccb12eeab2$export$f78478f71955b6bc);
$parcel$export(module.exports, "isValidEntityCode", () => $0c2ec6ccb12eeab2$export$644a8f5b13b2a36d);
$parcel$export(module.exports, "fromCodePoint", () => $0c2ec6ccb12eeab2$export$73bfc63873071f74);
$parcel$export(module.exports, "unescapeMd", () => $0c2ec6ccb12eeab2$export$5ccde1ea0c14bb03);
$parcel$export(module.exports, "unescapeAll", () => $0c2ec6ccb12eeab2$export$db8a17c6655f7e2c);
$parcel$export(module.exports, "escapeHtml", () => $0c2ec6ccb12eeab2$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "escapeRE", () => $0c2ec6ccb12eeab2$export$bc616c8f7dc20d5d);
$parcel$export(module.exports, "isSpace", () => $0c2ec6ccb12eeab2$export$1d5ccafae59b4926);
$parcel$export(module.exports, "isWhiteSpace", () => $0c2ec6ccb12eeab2$export$3c52dd84024ae72c);
$parcel$export(module.exports, "isPunctChar", () => $0c2ec6ccb12eeab2$export$4888a643af800fc1);
$parcel$export(module.exports, "isMdAsciiPunct", () => $0c2ec6ccb12eeab2$export$829a0d33ae4e744);
$parcel$export(module.exports, "normalizeReference", () => $0c2ec6ccb12eeab2$export$20ef46802c8744b);
$parcel$export(module.exports, "lib", () => $0c2ec6ccb12eeab2$export$16c08b91f883959a);
// Utilities
//

var $kpV4t = parcelRequire("kpV4t");
parcelRequire("ih6Pl");
var $6qXSM = parcelRequire("6qXSM");
var $7pSxY = parcelRequire("7pSxY");
var $ih6Pl = parcelRequire("ih6Pl");
parcelRequire("4MNLB");
var $8qSbS = parcelRequire("8qSbS");
function $0c2ec6ccb12eeab2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $0c2ec6ccb12eeab2$export$844ec244b1367d54(obj) {
    return $0c2ec6ccb12eeab2$var$_class(obj) === '[object String]';
}
const $0c2ec6ccb12eeab2$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $0c2ec6ccb12eeab2$export$a4f4bb6b1453fff5(object, key) {
    return $0c2ec6ccb12eeab2$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $0c2ec6ccb12eeab2$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $0c2ec6ccb12eeab2$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $0c2ec6ccb12eeab2$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $0c2ec6ccb12eeab2$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $0c2ec6ccb12eeab2$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $0c2ec6ccb12eeab2$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $0c2ec6ccb12eeab2$var$UNESCAPE_ALL_RE = new RegExp($0c2ec6ccb12eeab2$var$UNESCAPE_MD_RE.source + '|' + $0c2ec6ccb12eeab2$var$ENTITY_RE.source, 'gi');
const $0c2ec6ccb12eeab2$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $0c2ec6ccb12eeab2$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $0c2ec6ccb12eeab2$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($0c2ec6ccb12eeab2$export$644a8f5b13b2a36d(code)) return $0c2ec6ccb12eeab2$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $8qSbS.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $0c2ec6ccb12eeab2$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($0c2ec6ccb12eeab2$var$UNESCAPE_MD_RE, '$1');
}
function $0c2ec6ccb12eeab2$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($0c2ec6ccb12eeab2$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $0c2ec6ccb12eeab2$var$replaceEntityPattern(match, entity);
    });
}
const $0c2ec6ccb12eeab2$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $0c2ec6ccb12eeab2$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $0c2ec6ccb12eeab2$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $0c2ec6ccb12eeab2$var$replaceUnsafeChar(ch) {
    return $0c2ec6ccb12eeab2$var$HTML_REPLACEMENTS[ch];
}
function $0c2ec6ccb12eeab2$export$4cf11838cdc2a8a8(str) {
    if ($0c2ec6ccb12eeab2$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($0c2ec6ccb12eeab2$var$HTML_ESCAPE_REPLACE_RE, $0c2ec6ccb12eeab2$var$replaceUnsafeChar);
    return str;
}
const $0c2ec6ccb12eeab2$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $0c2ec6ccb12eeab2$export$bc616c8f7dc20d5d(str) {
    return str.replace($0c2ec6ccb12eeab2$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $0c2ec6ccb12eeab2$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $0c2ec6ccb12eeab2$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $0c2ec6ccb12eeab2$export$4888a643af800fc1(ch) {
    return $6qXSM.default.test(ch) || $7pSxY.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $0c2ec6ccb12eeab2$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $0c2ec6ccb12eeab2$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $0c2ec6ccb12eeab2$export$16c08b91f883959a = {
    mdurl: $kpV4t,
    ucmicro: $ih6Pl
};

});
parcelRegister("kpV4t", function(module, exports) {

$parcel$export(module.exports, "decode", () => (parcelRequire("2SsKF")).default);
$parcel$export(module.exports, "encode", () => (parcelRequire("1SHpU")).default);
$parcel$export(module.exports, "format", () => (parcelRequire("5CQ13")).default);
$parcel$export(module.exports, "parse", () => (parcelRequire("6b7BW")).default);

var $2SsKF = parcelRequire("2SsKF");

var $1SHpU = parcelRequire("1SHpU");

var $5CQ13 = parcelRequire("5CQ13");

var $6b7BW = parcelRequire("6b7BW");

});
parcelRegister("2SsKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9646d4e0a8dbef12$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise */ const $9646d4e0a8dbef12$var$decodeCache = {};
function $9646d4e0a8dbef12$var$getDecodeCache(exclude) {
    let cache = $9646d4e0a8dbef12$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $9646d4e0a8dbef12$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $9646d4e0a8dbef12$var$decode(string, exclude) {
    if (typeof exclude !== 'string') exclude = $9646d4e0a8dbef12$var$decode.defaultChars;
    const cache = $9646d4e0a8dbef12$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = '';
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$9646d4e0a8dbef12$var$decode.defaultChars = ';/?:@&=+$,#';
$9646d4e0a8dbef12$var$decode.componentChars = '';
var $9646d4e0a8dbef12$export$2e2bcd8739ae039 = $9646d4e0a8dbef12$var$decode;

});

parcelRegister("1SHpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb4b816fd68806d6$export$2e2bcd8739ae039);
const $cb4b816fd68806d6$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $cb4b816fd68806d6$var$getEncodeCache(exclude) {
    let cache = $cb4b816fd68806d6$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $cb4b816fd68806d6$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $cb4b816fd68806d6$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $cb4b816fd68806d6$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    const cache = $cb4b816fd68806d6$var$getEncodeCache(exclude);
    let result = '';
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$cb4b816fd68806d6$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$cb4b816fd68806d6$var$encode.componentChars = "-_.!~*'()";
var $cb4b816fd68806d6$export$2e2bcd8739ae039 = $cb4b816fd68806d6$var$encode;

});

parcelRegister("5CQ13", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc987d1a18604e3c$export$2e2bcd8739ae039);
function $fc987d1a18604e3c$export$2e2bcd8739ae039(url) {
    let result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
}

});

parcelRegister("6b7BW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d4e42cd7834d6f9$export$2e2bcd8739ae039);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $0d4e42cd7834d6f9$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $0d4e42cd7834d6f9$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $0d4e42cd7834d6f9$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $0d4e42cd7834d6f9$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $0d4e42cd7834d6f9$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
];
// RFC 2396: characters not allowed for various reasons.
const $0d4e42cd7834d6f9$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($0d4e42cd7834d6f9$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $0d4e42cd7834d6f9$var$autoEscape = [
    '\''
].concat($0d4e42cd7834d6f9$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $0d4e42cd7834d6f9$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($0d4e42cd7834d6f9$var$autoEscape);
const $0d4e42cd7834d6f9$var$hostEndingChars = [
    '/',
    '?',
    '#'
];
const $0d4e42cd7834d6f9$var$hostnameMaxLen = 255;
const $0d4e42cd7834d6f9$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $0d4e42cd7834d6f9$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $0d4e42cd7834d6f9$var$hostlessProtocol = {
    javascript: true,
    'javascript:': true
};
// protocols that always contain a // bit.
const $0d4e42cd7834d6f9$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
function $0d4e42cd7834d6f9$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $0d4e42cd7834d6f9$var$Url) return url;
    const u = new $0d4e42cd7834d6f9$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$0d4e42cd7834d6f9$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        const simplePath = $0d4e42cd7834d6f9$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $0d4e42cd7834d6f9$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $0d4e42cd7834d6f9$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$0d4e42cd7834d6f9$var$hostlessProtocol[proto] && (slashes || proto && !$0d4e42cd7834d6f9$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $0d4e42cd7834d6f9$var$hostEndingChars.length; i++){
            hec = rest.indexOf($0d4e42cd7834d6f9$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $0d4e42cd7834d6f9$var$nonHostChars.length; i++){
            hec = rest.indexOf($0d4e42cd7834d6f9$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($0d4e42cd7834d6f9$var$hostnamePartPattern)) {
                    let newpart = '';
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($0d4e42cd7834d6f9$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($0d4e42cd7834d6f9$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $0d4e42cd7834d6f9$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($0d4e42cd7834d6f9$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$0d4e42cd7834d6f9$var$Url.prototype.parseHost = function(host) {
    let port = $0d4e42cd7834d6f9$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $0d4e42cd7834d6f9$export$2e2bcd8739ae039 = $0d4e42cd7834d6f9$var$urlParse;

});


parcelRegister("ih6Pl", function(module, exports) {

$parcel$export(module.exports, "Any", () => (parcelRequire("6JWQo")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("bzTP8")).default);
$parcel$export(module.exports, "Cf", () => (parcelRequire("8dK82")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("6qXSM")).default);
$parcel$export(module.exports, "S", () => (parcelRequire("7pSxY")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("cINVi")).default);

var $6JWQo = parcelRequire("6JWQo");

var $bzTP8 = parcelRequire("bzTP8");

var $8dK82 = parcelRequire("8dK82");

var $6qXSM = parcelRequire("6qXSM");

var $7pSxY = parcelRequire("7pSxY");

var $cINVi = parcelRequire("cINVi");

});
parcelRegister("6JWQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $450f3f30b58a9426$export$2e2bcd8739ae039);
var $450f3f30b58a9426$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("bzTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77a0050499e3542$export$2e2bcd8739ae039);
var $b77a0050499e3542$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8dK82", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6aa885bdc05f64e$export$2e2bcd8739ae039);
var $f6aa885bdc05f64e$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("6qXSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d86f17c959fe4fb8$export$2e2bcd8739ae039);
var $d86f17c959fe4fb8$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("7pSxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee37b9c1f125617d$export$2e2bcd8739ae039);
var $ee37b9c1f125617d$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("cINVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b068cce94db5a90f$export$2e2bcd8739ae039);
var $b068cce94db5a90f$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});


parcelRegister("4MNLB", function(module, exports) {

$parcel$export(module.exports, "decodeHTML", () => (parcelRequire("8qSbS")).decodeHTML);

var $8qSbS = parcelRequire("8qSbS");

var $hAVKH = parcelRequire("hAVKH");

var $jJd9f = parcelRequire("jJd9f");
var $37c23fc1c6faf5f4$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($37c23fc1c6faf5f4$export$b8c86583d9718b50 || ($37c23fc1c6faf5f4$export$b8c86583d9718b50 = {}));
var $37c23fc1c6faf5f4$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($37c23fc1c6faf5f4$export$1851b20d614eb756 || ($37c23fc1c6faf5f4$export$1851b20d614eb756 = {}));
function $37c23fc1c6faf5f4$export$2f872c0f2117be69(data, options = $37c23fc1c6faf5f4$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $37c23fc1c6faf5f4$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $8qSbS.decodeHTML)(data, mode);
    }
    return (0, $8qSbS.decodeXML)(data);
}
function $37c23fc1c6faf5f4$export$c94669f4c7d36be4(data, options = $37c23fc1c6faf5f4$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $8qSbS.DecodingMode).Strict;
    return $37c23fc1c6faf5f4$export$2f872c0f2117be69(data, opts);
}
function $37c23fc1c6faf5f4$export$c564cdbbe6da493(data, options = $37c23fc1c6faf5f4$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.UTF8) return (0, $jJd9f.escapeUTF8)(data);
    if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.Attribute) return (0, $jJd9f.escapeAttribute)(data);
    if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.Text) return (0, $jJd9f.escapeText)(data);
    if (opts.level === $37c23fc1c6faf5f4$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $37c23fc1c6faf5f4$export$1851b20d614eb756.ASCII) return (0, $hAVKH.encodeNonAsciiHTML)(data);
        return (0, $hAVKH.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $jJd9f.encodeXML)(data);
}

});
parcelRegister("8qSbS", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $623ac987b90f204a$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $623ac987b90f204a$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $623ac987b90f204a$export$88e3b9643a8bd06e);

var $gHlnI = parcelRequire("gHlnI");

var $13OtZ = parcelRequire("13OtZ");

var $lI69q = parcelRequire("lI69q");
var $623ac987b90f204a$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($623ac987b90f204a$var$CharCodes || ($623ac987b90f204a$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $623ac987b90f204a$var$TO_LOWER_BIT = 32;
var $623ac987b90f204a$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($623ac987b90f204a$export$6a4325c613e0faec || ($623ac987b90f204a$export$6a4325c613e0faec = {}));
function $623ac987b90f204a$var$isNumber(code) {
    return code >= $623ac987b90f204a$var$CharCodes.ZERO && code <= $623ac987b90f204a$var$CharCodes.NINE;
}
function $623ac987b90f204a$var$isHexadecimalCharacter(code) {
    return code >= $623ac987b90f204a$var$CharCodes.UPPER_A && code <= $623ac987b90f204a$var$CharCodes.UPPER_F || code >= $623ac987b90f204a$var$CharCodes.LOWER_A && code <= $623ac987b90f204a$var$CharCodes.LOWER_F;
}
function $623ac987b90f204a$var$isAsciiAlphaNumeric(code) {
    return code >= $623ac987b90f204a$var$CharCodes.UPPER_A && code <= $623ac987b90f204a$var$CharCodes.UPPER_Z || code >= $623ac987b90f204a$var$CharCodes.LOWER_A && code <= $623ac987b90f204a$var$CharCodes.LOWER_Z || $623ac987b90f204a$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $623ac987b90f204a$var$isEntityInAttributeInvalidEnd(code) {
    return code === $623ac987b90f204a$var$CharCodes.EQUALS || $623ac987b90f204a$var$isAsciiAlphaNumeric(code);
}
var $623ac987b90f204a$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($623ac987b90f204a$var$EntityDecoderState || ($623ac987b90f204a$var$EntityDecoderState = {}));
var $623ac987b90f204a$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($623ac987b90f204a$export$8c8f129ce60f53c || ($623ac987b90f204a$export$8c8f129ce60f53c = {}));
class $623ac987b90f204a$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $623ac987b90f204a$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $623ac987b90f204a$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $623ac987b90f204a$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $623ac987b90f204a$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $623ac987b90f204a$var$CharCodes.NUM) {
                    this.state = $623ac987b90f204a$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $623ac987b90f204a$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $623ac987b90f204a$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $623ac987b90f204a$var$TO_LOWER_BIT) === $623ac987b90f204a$var$CharCodes.LOWER_X) {
            this.state = $623ac987b90f204a$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $623ac987b90f204a$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($623ac987b90f204a$var$isNumber(char) || $623ac987b90f204a$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($623ac987b90f204a$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $623ac987b90f204a$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $623ac987b90f204a$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $lI69q.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $623ac987b90f204a$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $623ac987b90f204a$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $623ac987b90f204a$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $623ac987b90f204a$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $623ac987b90f204a$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $623ac987b90f204a$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$623ac987b90f204a$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $623ac987b90f204a$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $623ac987b90f204a$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $623ac987b90f204a$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $623ac987b90f204a$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $623ac987b90f204a$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $623ac987b90f204a$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $623ac987b90f204a$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $623ac987b90f204a$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $lI69q.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $623ac987b90f204a$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $623ac987b90f204a$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $623ac987b90f204a$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $623ac987b90f204a$var$htmlDecoder = $623ac987b90f204a$var$getDecoder((0, $gHlnI.default));
const $623ac987b90f204a$var$xmlDecoder = $623ac987b90f204a$var$getDecoder((0, $13OtZ.default));
function $623ac987b90f204a$export$f045cb747ce77a19(str, mode = $623ac987b90f204a$export$8c8f129ce60f53c.Legacy) {
    return $623ac987b90f204a$var$htmlDecoder(str, mode);
}
function $623ac987b90f204a$export$49f5e8089adb006a(str) {
    return $623ac987b90f204a$var$htmlDecoder(str, $623ac987b90f204a$export$8c8f129ce60f53c.Attribute);
}
function $623ac987b90f204a$export$da52f4371b3f37de(str) {
    return $623ac987b90f204a$var$htmlDecoder(str, $623ac987b90f204a$export$8c8f129ce60f53c.Strict);
}
function $623ac987b90f204a$export$88e3b9643a8bd06e(str) {
    return $623ac987b90f204a$var$xmlDecoder(str, $623ac987b90f204a$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("gHlnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2813f70f6891dc7$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $c2813f70f6891dc7$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("13OtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5d3b13ad8a5e4d$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $0c5d3b13ad8a5e4d$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("lI69q", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $fce27a7ff8e67907$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $fce27a7ff8e67907$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $fce27a7ff8e67907$var$_a;
const $fce27a7ff8e67907$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $fce27a7ff8e67907$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($fce27a7ff8e67907$var$_a = String.fromCodePoint) !== null && $fce27a7ff8e67907$var$_a !== void 0 ? $fce27a7ff8e67907$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $fce27a7ff8e67907$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $fce27a7ff8e67907$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $fce27a7ff8e67907$export$2e2bcd8739ae039(codePoint) {
    return $fce27a7ff8e67907$export$73bfc63873071f74($fce27a7ff8e67907$export$b978ab756102108a(codePoint));
}

});


parcelRegister("hAVKH", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $ccf298d8b2959b47$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $ccf298d8b2959b47$export$e6e86c76506f1190);

var $yiozl = parcelRequire("yiozl");

var $jJd9f = parcelRequire("jJd9f");
const $ccf298d8b2959b47$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $ccf298d8b2959b47$export$f9d6449b9af28dc1(data) {
    return $ccf298d8b2959b47$var$encodeHTMLTrieRe($ccf298d8b2959b47$var$htmlReplacer, data);
}
function $ccf298d8b2959b47$export$e6e86c76506f1190(data) {
    return $ccf298d8b2959b47$var$encodeHTMLTrieRe((0, $jJd9f.xmlReplacer), data);
}
function $ccf298d8b2959b47$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $yiozl.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $jJd9f.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("yiozl", function(module, exports) {

$parcel$export(module.exports, "default", () => $067172025a93bfdd$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $067172025a93bfdd$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$067172025a93bfdd$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $067172025a93bfdd$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("jJd9f", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $e5cc6b37386efc7e$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $e5cc6b37386efc7e$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $e5cc6b37386efc7e$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $e5cc6b37386efc7e$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $e5cc6b37386efc7e$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $e5cc6b37386efc7e$export$96e6fc3a139b2555);
const $e5cc6b37386efc7e$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $e5cc6b37386efc7e$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $e5cc6b37386efc7e$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $e5cc6b37386efc7e$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $e5cc6b37386efc7e$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $e5cc6b37386efc7e$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$e5cc6b37386efc7e$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $e5cc6b37386efc7e$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $e5cc6b37386efc7e$export$4e7f196112fea3c5 = $e5cc6b37386efc7e$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $e5cc6b37386efc7e$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $e5cc6b37386efc7e$export$9e081872deefdcb0 = $e5cc6b37386efc7e$var$getEscaper(/[&<>'"]/g, $e5cc6b37386efc7e$var$xmlCodeMap);
const $e5cc6b37386efc7e$export$30330f3d5eb70e11 = $e5cc6b37386efc7e$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $e5cc6b37386efc7e$export$96e6fc3a139b2555 = $e5cc6b37386efc7e$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});




parcelRegister("lOMx4", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => (parcelRequire("gP720")).default);
$parcel$export(module.exports, "parseLinkDestination", () => (parcelRequire("hEouy")).default);
$parcel$export(module.exports, "parseLinkTitle", () => (parcelRequire("2syDh")).default);
// Just a shortcut for bulk export

var $gP720 = parcelRequire("gP720");

var $hEouy = parcelRequire("hEouy");

var $2syDh = parcelRequire("2syDh");

});
parcelRegister("gP720", function(module, exports) {

$parcel$export(module.exports, "default", () => $256ef2605acee19f$export$2e2bcd8739ae039);
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $256ef2605acee19f$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("hEouy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4ac6dc8f61484e$export$2e2bcd8739ae039);
// Parse link destination
//

var $9Wt9S = parcelRequire("9Wt9S");
function $6a4ac6dc8f61484e$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $9Wt9S.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $9Wt9S.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("2syDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb29b0c2a2d02d5a$export$2e2bcd8739ae039);
// Parse link title
//

var $9Wt9S = parcelRequire("9Wt9S");
function $cb29b0c2a2d02d5a$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $9Wt9S.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $9Wt9S.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("8Dgzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5ffcdf5357f963$export$2e2bcd8739ae039);
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $9Wt9S = parcelRequire("9Wt9S");
const $2f5ffcdf5357f963$var$default_rules = {};
$2f5ffcdf5357f963$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $9Wt9S.escapeHtml)(token.content) + '</code>';
};
$2f5ffcdf5357f963$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $9Wt9S.escapeHtml)(tokens[idx].content) + '</code></pre>\n';
};
$2f5ffcdf5357f963$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $9Wt9S.unescapeAll)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $9Wt9S.escapeHtml)(token.content);
    else highlighted = (0, $9Wt9S.escapeHtml)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$2f5ffcdf5357f963$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$2f5ffcdf5357f963$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$2f5ffcdf5357f963$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$2f5ffcdf5357f963$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $9Wt9S.escapeHtml)(tokens[idx].content);
};
$2f5ffcdf5357f963$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$2f5ffcdf5357f963$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $2f5ffcdf5357f963$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $9Wt9S.assign)({}, $2f5ffcdf5357f963$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $9Wt9S.escapeHtml)(token.attrs[i][0]) + '="' + (0, $9Wt9S.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $2f5ffcdf5357f963$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $2f5ffcdf5357f963$export$2e2bcd8739ae039 = $2f5ffcdf5357f963$var$Renderer;

});

parcelRegister("0O45r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ee4ea6fa4999a7$export$2e2bcd8739ae039);
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $at4l3 = parcelRequire("at4l3");

var $lFIix = parcelRequire("lFIix");

var $4wWHG = parcelRequire("4wWHG");

var $zKGz5 = parcelRequire("zKGz5");

var $gdzCr = parcelRequire("gdzCr");

var $hc3M5 = parcelRequire("hc3M5");

var $kVHcM = parcelRequire("kVHcM");

var $lwHgQ = parcelRequire("lwHgQ");

var $g8xuk = parcelRequire("g8xuk");
const $e8ee4ea6fa4999a7$var$_rules = [
    [
        'normalize',
        (0, $4wWHG.default)
    ],
    [
        'block',
        (0, $zKGz5.default)
    ],
    [
        'inline',
        (0, $gdzCr.default)
    ],
    [
        'linkify',
        (0, $hc3M5.default)
    ],
    [
        'replacements',
        (0, $kVHcM.default)
    ],
    [
        'smartquotes',
        (0, $lwHgQ.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $g8xuk.default)
    ]
];
/**
 * new Core()
 **/ function $e8ee4ea6fa4999a7$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $at4l3.default)();
    for(let i = 0; i < $e8ee4ea6fa4999a7$var$_rules.length; i++)this.ruler.push($e8ee4ea6fa4999a7$var$_rules[i][0], $e8ee4ea6fa4999a7$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $e8ee4ea6fa4999a7$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$e8ee4ea6fa4999a7$var$Core.prototype.State = (0, $lFIix.default);
var $e8ee4ea6fa4999a7$export$2e2bcd8739ae039 = $e8ee4ea6fa4999a7$var$Core;

});
parcelRegister("at4l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $856d3eaa12c7d7ab$export$2e2bcd8739ae039);
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $856d3eaa12c7d7ab$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$856d3eaa12c7d7ab$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$856d3eaa12c7d7ab$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $856d3eaa12c7d7ab$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $856d3eaa12c7d7ab$export$2e2bcd8739ae039 = $856d3eaa12c7d7ab$var$Ruler;

});

parcelRegister("lFIix", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff43ee2b0d9b681$export$2e2bcd8739ae039);
// Core state object
//

var $6P50I = parcelRequire("6P50I");
function $5ff43ee2b0d9b681$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$5ff43ee2b0d9b681$var$StateCore.prototype.Token = (0, $6P50I.default);
var $5ff43ee2b0d9b681$export$2e2bcd8739ae039 = $5ff43ee2b0d9b681$var$StateCore;

});
parcelRegister("6P50I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21340cc7b36c75d$export$2e2bcd8739ae039);
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $d21340cc7b36c75d$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $d21340cc7b36c75d$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $d21340cc7b36c75d$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $d21340cc7b36c75d$export$2e2bcd8739ae039 = $d21340cc7b36c75d$var$Token;

});


parcelRegister("4wWHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a74af09f2ba37fd$export$2e2bcd8739ae039);
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $4a74af09f2ba37fd$var$NEWLINES_RE = /\r\n?|\n/g;
const $4a74af09f2ba37fd$var$NULL_RE = /\0/g;
function $4a74af09f2ba37fd$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($4a74af09f2ba37fd$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($4a74af09f2ba37fd$var$NULL_RE, '\uFFFD');
    state.src = str;
}

});

parcelRegister("zKGz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdc461a40ef0996c$export$2e2bcd8739ae039);
function $fdc461a40ef0996c$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("gdzCr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7bda804fe2c36e6$export$2e2bcd8739ae039);
function $d7bda804fe2c36e6$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("hc3M5", function(module, exports) {

$parcel$export(module.exports, "default", () => $500adbf0c8e76436$export$2e2bcd8739ae039);
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $9Wt9S = parcelRequire("9Wt9S");
function $500adbf0c8e76436$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $500adbf0c8e76436$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $500adbf0c8e76436$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($500adbf0c8e76436$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($500adbf0c8e76436$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $9Wt9S.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("kVHcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4c38bbdc5f5f79$export$2e2bcd8739ae039);
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $6f4c38bbdc5f5f79$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $6f4c38bbdc5f5f79$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $6f4c38bbdc5f5f79$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $6f4c38bbdc5f5f79$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $6f4c38bbdc5f5f79$var$replaceFn(match, name) {
    return $6f4c38bbdc5f5f79$var$SCOPED_ABBR[name.toLowerCase()];
}
function $6f4c38bbdc5f5f79$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($6f4c38bbdc5f5f79$var$SCOPED_ABBR_RE, $6f4c38bbdc5f5f79$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6f4c38bbdc5f5f79$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($6f4c38bbdc5f5f79$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6f4c38bbdc5f5f79$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($6f4c38bbdc5f5f79$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $6f4c38bbdc5f5f79$var$replace_scoped(state.tokens[blkIdx].children);
        if ($6f4c38bbdc5f5f79$var$RARE_RE.test(state.tokens[blkIdx].content)) $6f4c38bbdc5f5f79$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("lwHgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ac4b11b288ec2d$export$2e2bcd8739ae039);
// Convert straight quotation marks to typographic ones
//

var $9Wt9S = parcelRequire("9Wt9S");
const $70ac4b11b288ec2d$var$QUOTE_TEST_RE = /['"]/;
const $70ac4b11b288ec2d$var$QUOTE_RE = /['"]/g;
const $70ac4b11b288ec2d$var$APOSTROPHE = '\u2019' /* ’ */ ;
function $70ac4b11b288ec2d$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $70ac4b11b288ec2d$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $70ac4b11b288ec2d$var$QUOTE_RE.lastIndex = pos;
            const t = $70ac4b11b288ec2d$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $9Wt9S.isMdAsciiPunct)(lastChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $9Wt9S.isMdAsciiPunct)(nextChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $9Wt9S.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $9Wt9S.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $70ac4b11b288ec2d$var$replaceAt(token.content, t.index, $70ac4b11b288ec2d$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $70ac4b11b288ec2d$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $70ac4b11b288ec2d$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $70ac4b11b288ec2d$var$replaceAt(token.content, t.index, $70ac4b11b288ec2d$var$APOSTROPHE);
        }
    }
}
function $70ac4b11b288ec2d$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$70ac4b11b288ec2d$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $70ac4b11b288ec2d$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("g8xuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $60323e9fe3e5750e$export$2e2bcd8739ae039);
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $60323e9fe3e5750e$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("cqhCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b24bf10baac51cd$export$2e2bcd8739ae039);
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $at4l3 = parcelRequire("at4l3");

var $g5XEx = parcelRequire("g5XEx");

var $7jA0X = parcelRequire("7jA0X");

var $aif0n = parcelRequire("aif0n");

var $3cVzU = parcelRequire("3cVzU");

var $6IVUy = parcelRequire("6IVUy");

var $aV7jx = parcelRequire("aV7jx");

var $1CL28 = parcelRequire("1CL28");

var $aMRwF = parcelRequire("aMRwF");

var $jKRoe = parcelRequire("jKRoe");

var $boNmx = parcelRequire("boNmx");

var $b9PIF = parcelRequire("b9PIF");

var $5Lg31 = parcelRequire("5Lg31");
const $1b24bf10baac51cd$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $7jA0X.default),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $aif0n.default)
    ],
    [
        'fence',
        (0, $3cVzU.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $6IVUy.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $aV7jx.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $1CL28.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $aMRwF.default)
    ],
    [
        'html_block',
        (0, $jKRoe.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $boNmx.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $b9PIF.default)
    ],
    [
        'paragraph',
        (0, $5Lg31.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $1b24bf10baac51cd$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $at4l3.default)();
    for(let i = 0; i < $1b24bf10baac51cd$var$_rules.length; i++)this.ruler.push($1b24bf10baac51cd$var$_rules[i][0], $1b24bf10baac51cd$var$_rules[i][1], {
        alt: ($1b24bf10baac51cd$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$1b24bf10baac51cd$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $1b24bf10baac51cd$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$1b24bf10baac51cd$var$ParserBlock.prototype.State = (0, $g5XEx.default);
var $1b24bf10baac51cd$export$2e2bcd8739ae039 = $1b24bf10baac51cd$var$ParserBlock;

});
parcelRegister("g5XEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $791edc64da2f2aa4$export$2e2bcd8739ae039);
// Parser state class

var $6P50I = parcelRequire("6P50I");

var $9Wt9S = parcelRequire("9Wt9S");
function $791edc64da2f2aa4$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $9Wt9S.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$791edc64da2f2aa4$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $6P50I.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$791edc64da2f2aa4$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$791edc64da2f2aa4$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$791edc64da2f2aa4$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$791edc64da2f2aa4$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $9Wt9S.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$791edc64da2f2aa4$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$791edc64da2f2aa4$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$791edc64da2f2aa4$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $9Wt9S.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$791edc64da2f2aa4$var$StateBlock.prototype.Token = (0, $6P50I.default);
var $791edc64da2f2aa4$export$2e2bcd8739ae039 = $791edc64da2f2aa4$var$StateBlock;

});

parcelRegister("7jA0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee53d7d0bd34043$export$2e2bcd8739ae039);
// GFM table, https://github.github.com/gfm/#tables-extension-

var $9Wt9S = parcelRequire("9Wt9S");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $0ee53d7d0bd34043$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $0ee53d7d0bd34043$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $0ee53d7d0bd34043$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $0ee53d7d0bd34043$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $9Wt9S.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $9Wt9S.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $9Wt9S.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $0ee53d7d0bd34043$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $0ee53d7d0bd34043$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $0ee53d7d0bd34043$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $0ee53d7d0bd34043$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $0ee53d7d0bd34043$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $0ee53d7d0bd34043$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("aif0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb785362ac575ef5$export$2e2bcd8739ae039);
// Code block (4 spaces padded)
function $cb785362ac575ef5$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("3cVzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e00964fb4e951b60$export$2e2bcd8739ae039);
// fences (``` lang, ~~~ lang)
function $e00964fb4e951b60$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("6IVUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $eba237e7f41c2eed$export$2e2bcd8739ae039);
// Block quotes

var $9Wt9S = parcelRequire("9Wt9S");
function $eba237e7f41c2eed$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $9Wt9S.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("aV7jx", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f5e8f4e87d6064$export$2e2bcd8739ae039);
// Horizontal rule

var $9Wt9S = parcelRequire("9Wt9S");
function $62f5e8f4e87d6064$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $9Wt9S.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("1CL28", function(module, exports) {

$parcel$export(module.exports, "default", () => $a629c46eb78ec931$export$2e2bcd8739ae039);
// Lists

var $9Wt9S = parcelRequire("9Wt9S");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $a629c46eb78ec931$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $a629c46eb78ec931$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $a629c46eb78ec931$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $a629c46eb78ec931$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $a629c46eb78ec931$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $a629c46eb78ec931$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $a629c46eb78ec931$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $a629c46eb78ec931$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $a629c46eb78ec931$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("aMRwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8852253d996ce648$export$2e2bcd8739ae039);

var $9Wt9S = parcelRequire("9Wt9S");
function $8852253d996ce648$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $9Wt9S.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $9Wt9S.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $9Wt9S.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $9Wt9S.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $9Wt9S.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("jKRoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $77dd0bad82781cb3$export$2e2bcd8739ae039);
// HTML block

var $cYu8C = parcelRequire("cYu8C");

var $kAxEC = parcelRequire("kAxEC");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $77dd0bad82781cb3$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $cYu8C.default).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $kAxEC.HTML_OPEN_CLOSE_TAG_RE).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $77dd0bad82781cb3$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $77dd0bad82781cb3$var$HTML_SEQUENCES.length; i++){
        if ($77dd0bad82781cb3$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $77dd0bad82781cb3$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $77dd0bad82781cb3$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$77dd0bad82781cb3$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($77dd0bad82781cb3$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("cYu8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7482819406fa2c$export$2e2bcd8739ae039);
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8e7482819406fa2c$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("kAxEC", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $d81d76d23616b3fd$export$6db61d2c3a16e419);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $d81d76d23616b3fd$export$cd48660d06f74639);
// Regexps to match html elements
const $d81d76d23616b3fd$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $d81d76d23616b3fd$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $d81d76d23616b3fd$var$single_quoted = "'[^']*'";
const $d81d76d23616b3fd$var$double_quoted = '"[^"]*"';
const $d81d76d23616b3fd$var$attr_value = '(?:' + $d81d76d23616b3fd$var$unquoted + '|' + $d81d76d23616b3fd$var$single_quoted + '|' + $d81d76d23616b3fd$var$double_quoted + ')';
const $d81d76d23616b3fd$var$attribute = '(?:\\s+' + $d81d76d23616b3fd$var$attr_name + '(?:\\s*=\\s*' + $d81d76d23616b3fd$var$attr_value + ')?)';
const $d81d76d23616b3fd$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $d81d76d23616b3fd$var$attribute + '*\\s*\\/?>';
const $d81d76d23616b3fd$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $d81d76d23616b3fd$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $d81d76d23616b3fd$var$processing = '<[?][\\s\\S]*?[?]>';
const $d81d76d23616b3fd$var$declaration = '<![A-Za-z][^>]*>';
const $d81d76d23616b3fd$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $d81d76d23616b3fd$export$6db61d2c3a16e419 = new RegExp('^(?:' + $d81d76d23616b3fd$var$open_tag + '|' + $d81d76d23616b3fd$var$close_tag + '|' + $d81d76d23616b3fd$var$comment + '|' + $d81d76d23616b3fd$var$processing + '|' + $d81d76d23616b3fd$var$declaration + '|' + $d81d76d23616b3fd$var$cdata + ')');
const $d81d76d23616b3fd$export$cd48660d06f74639 = new RegExp('^(?:' + $d81d76d23616b3fd$var$open_tag + '|' + $d81d76d23616b3fd$var$close_tag + ')');

});


parcelRegister("boNmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $386a7bf10f825645$export$2e2bcd8739ae039);
// heading (#, ##, ...)

var $9Wt9S = parcelRequire("9Wt9S");
function $386a7bf10f825645$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $9Wt9S.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $9Wt9S.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}

});

parcelRegister("b9PIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c68d720d14e3fcd$export$2e2bcd8739ae039);
// lheading (---, ===)
function $6c68d720d14e3fcd$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph' // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("5Lg31", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd7e7cbe73cebc09$export$2e2bcd8739ae039);
// Paragraph
function $dd7e7cbe73cebc09$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("2vOE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3178ab1d2766dc10$export$2e2bcd8739ae039);
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $at4l3 = parcelRequire("at4l3");

var $h5Y0q = parcelRequire("h5Y0q");

var $9EsZP = parcelRequire("9EsZP");

var $7DwY4 = parcelRequire("7DwY4");

var $gH7Rn = parcelRequire("gH7Rn");

var $gzJoP = parcelRequire("gzJoP");

var $fOW9o = parcelRequire("fOW9o");

var $gUBjg = parcelRequire("gUBjg");

var $jsV0C = parcelRequire("jsV0C");

var $l96IW = parcelRequire("l96IW");

var $hUu3r = parcelRequire("hUu3r");

var $2cC3v = parcelRequire("2cC3v");

var $lssRK = parcelRequire("lssRK");

var $hGHP1 = parcelRequire("hGHP1");

var $9oRtg = parcelRequire("9oRtg");

var $kVKhK = parcelRequire("kVKhK");
// Parser rules
const $3178ab1d2766dc10$var$_rules = [
    [
        'text',
        (0, $9EsZP.default)
    ],
    [
        'linkify',
        (0, $7DwY4.default)
    ],
    [
        'newline',
        (0, $gH7Rn.default)
    ],
    [
        'escape',
        (0, $gzJoP.default)
    ],
    [
        'backticks',
        (0, $fOW9o.default)
    ],
    [
        'strikethrough',
        (0, $gUBjg.default).tokenize
    ],
    [
        'emphasis',
        (0, $jsV0C.default).tokenize
    ],
    [
        'link',
        (0, $l96IW.default)
    ],
    [
        'image',
        (0, $hUu3r.default)
    ],
    [
        'autolink',
        (0, $2cC3v.default)
    ],
    [
        'html_inline',
        (0, $lssRK.default)
    ],
    [
        'entity',
        (0, $hGHP1.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $3178ab1d2766dc10$var$_rules2 = [
    [
        'balance_pairs',
        (0, $9oRtg.default)
    ],
    [
        'strikethrough',
        (0, $gUBjg.default).postProcess
    ],
    [
        'emphasis',
        (0, $jsV0C.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $kVKhK.default)
    ]
];
/**
 * new ParserInline()
 **/ function $3178ab1d2766dc10$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $at4l3.default)();
    for(let i = 0; i < $3178ab1d2766dc10$var$_rules.length; i++)this.ruler.push($3178ab1d2766dc10$var$_rules[i][0], $3178ab1d2766dc10$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $at4l3.default)();
    for(let i = 0; i < $3178ab1d2766dc10$var$_rules2.length; i++)this.ruler2.push($3178ab1d2766dc10$var$_rules2[i][0], $3178ab1d2766dc10$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3178ab1d2766dc10$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3178ab1d2766dc10$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3178ab1d2766dc10$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$3178ab1d2766dc10$var$ParserInline.prototype.State = (0, $h5Y0q.default);
var $3178ab1d2766dc10$export$2e2bcd8739ae039 = $3178ab1d2766dc10$var$ParserInline;

});
parcelRegister("h5Y0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2592a02f3d954285$export$2e2bcd8739ae039);
// Inline parser state

var $6P50I = parcelRequire("6P50I");

var $9Wt9S = parcelRequire("9Wt9S");
function $2592a02f3d954285$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$2592a02f3d954285$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $6P50I.default)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$2592a02f3d954285$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $6P50I.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$2592a02f3d954285$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $9Wt9S.isMdAsciiPunct)(lastChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $9Wt9S.isMdAsciiPunct)(nextChar) || (0, $9Wt9S.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $9Wt9S.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $9Wt9S.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$2592a02f3d954285$var$StateInline.prototype.Token = (0, $6P50I.default);
var $2592a02f3d954285$export$2e2bcd8739ae039 = $2592a02f3d954285$var$StateInline;

});

parcelRegister("9EsZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $db24db0eb5111e79$export$2e2bcd8739ae039);
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $db24db0eb5111e79$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $db24db0eb5111e79$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$db24db0eb5111e79$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("7DwY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f78c4fb26d79f4$export$2e2bcd8739ae039);
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $37f78c4fb26d79f4$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $37f78c4fb26d79f4$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($37f78c4fb26d79f4$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("gH7Rn", function(module, exports) {

$parcel$export(module.exports, "default", () => $465f123239c78f9c$export$2e2bcd8739ae039);
// Proceess '\n'

var $9Wt9S = parcelRequire("9Wt9S");
function $465f123239c78f9c$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $9Wt9S.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("gzJoP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb9b12de4931b87$export$2e2bcd8739ae039);
// Process escaped chars and hardbreaks

var $9Wt9S = parcelRequire("9Wt9S");
const $ebb9b12de4931b87$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$ebb9b12de4931b87$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $ebb9b12de4931b87$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $ebb9b12de4931b87$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $ebb9b12de4931b87$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("fOW9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19b7cb70ab1c423$export$2e2bcd8739ae039);
// Parse backticks
function $d19b7cb70ab1c423$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("gUBjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da0667f6ea239a2$export$2e2bcd8739ae039);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $7da0667f6ea239a2$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $7da0667f6ea239a2$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $7da0667f6ea239a2$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $7da0667f6ea239a2$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $7da0667f6ea239a2$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $7da0667f6ea239a2$export$2e2bcd8739ae039 = {
    tokenize: $7da0667f6ea239a2$var$strikethrough_tokenize,
    postProcess: $7da0667f6ea239a2$var$strikethrough_postProcess
};

});

parcelRegister("jsV0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d2eee1aeb284400$export$2e2bcd8739ae039);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $3d2eee1aeb284400$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $3d2eee1aeb284400$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $3d2eee1aeb284400$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $3d2eee1aeb284400$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $3d2eee1aeb284400$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $3d2eee1aeb284400$export$2e2bcd8739ae039 = {
    tokenize: $3d2eee1aeb284400$var$emphasis_tokenize,
    postProcess: $3d2eee1aeb284400$var$emphasis_post_process
};

});

parcelRegister("l96IW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d44413bc65f086b$export$2e2bcd8739ae039);
// Process [link](<to> "stuff")

var $9Wt9S = parcelRequire("9Wt9S");
function $0d44413bc65f086b$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $9Wt9S.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("hUu3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $6004b904447d9404$export$2e2bcd8739ae039);
// Process ![image](<src> "title")

var $9Wt9S = parcelRequire("9Wt9S");
function $6004b904447d9404$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $9Wt9S.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $9Wt9S.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("2cC3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e57dbd84036aa5$export$2e2bcd8739ae039);
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $49e57dbd84036aa5$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $49e57dbd84036aa5$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $49e57dbd84036aa5$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($49e57dbd84036aa5$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($49e57dbd84036aa5$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("lssRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb34f601fe68ff08$export$2e2bcd8739ae039);
// Process html tags

var $kAxEC = parcelRequire("kAxEC");
function $bb34f601fe68ff08$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $bb34f601fe68ff08$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $bb34f601fe68ff08$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $bb34f601fe68ff08$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$bb34f601fe68ff08$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $kAxEC.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($bb34f601fe68ff08$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($bb34f601fe68ff08$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("hGHP1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f4fa5c84eaf65f$export$2e2bcd8739ae039);
// Process html entity - &#123;, &#xAF;, &quot;, ...
parcelRequire("4MNLB");
var $8qSbS = parcelRequire("8qSbS");

var $9Wt9S = parcelRequire("9Wt9S");
const $d5f4fa5c84eaf65f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $d5f4fa5c84eaf65f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $d5f4fa5c84eaf65f$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($d5f4fa5c84eaf65f$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $9Wt9S.isValidEntityCode)(code) ? (0, $9Wt9S.fromCodePoint)(code) : (0, $9Wt9S.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($d5f4fa5c84eaf65f$var$NAMED_RE);
        if (match) {
            const decoded = (0, $8qSbS.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("9oRtg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6bea41754e8d9e$export$2e2bcd8739ae039);
// For each opening emphasis-like marker find a matching closing one
//
function $bc6bea41754e8d9e$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $bc6bea41754e8d9e$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $bc6bea41754e8d9e$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $bc6bea41754e8d9e$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("kVKhK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c939aeb62d3c954c$export$2e2bcd8739ae039);
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $c939aeb62d3c954c$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("eGX2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd1206f3765b534$export$2e2bcd8739ae039);

var $jmddV = parcelRequire("jmddV");
//
// Helpers
//
// Merge objects
//
function $bdd1206f3765b534$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $bdd1206f3765b534$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $bdd1206f3765b534$var$isString(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object String]';
}
function $bdd1206f3765b534$var$isObject(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object Object]';
}
function $bdd1206f3765b534$var$isRegExp(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object RegExp]';
}
function $bdd1206f3765b534$var$isFunction(obj) {
    return $bdd1206f3765b534$var$_class(obj) === '[object Function]';
}
function $bdd1206f3765b534$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $bdd1206f3765b534$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $bdd1206f3765b534$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $bdd1206f3765b534$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $bdd1206f3765b534$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $bdd1206f3765b534$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $bdd1206f3765b534$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $bdd1206f3765b534$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $bdd1206f3765b534$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $bdd1206f3765b534$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $bdd1206f3765b534$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $jmddV.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($bdd1206f3765b534$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($bdd1206f3765b534$var$isObject(val)) {
            if ($bdd1206f3765b534$var$isRegExp(val.validate)) compiled.validate = $bdd1206f3765b534$var$createValidator(val.validate);
            else if ($bdd1206f3765b534$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($bdd1206f3765b534$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $bdd1206f3765b534$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($bdd1206f3765b534$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $bdd1206f3765b534$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($bdd1206f3765b534$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $bdd1206f3765b534$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $bdd1206f3765b534$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $bdd1206f3765b534$var$createMatch(self, shift) {
    const match = new $bdd1206f3765b534$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $bdd1206f3765b534$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $bdd1206f3765b534$var$LinkifyIt)) return new $bdd1206f3765b534$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($bdd1206f3765b534$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $bdd1206f3765b534$var$assign({}, $bdd1206f3765b534$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $bdd1206f3765b534$var$assign({}, $bdd1206f3765b534$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $bdd1206f3765b534$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $bdd1206f3765b534$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $bdd1206f3765b534$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $bdd1206f3765b534$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($bdd1206f3765b534$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($bdd1206f3765b534$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $bdd1206f3765b534$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $bdd1206f3765b534$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $bdd1206f3765b534$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $bdd1206f3765b534$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $bdd1206f3765b534$export$2e2bcd8739ae039 = $bdd1206f3765b534$var$LinkifyIt;

});
parcelRegister("jmddV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7763c029038efc47$export$2e2bcd8739ae039);
parcelRequire("ih6Pl");
var $6JWQo = parcelRequire("6JWQo");
var $bzTP8 = parcelRequire("bzTP8");
var $6qXSM = parcelRequire("6qXSM");
var $cINVi = parcelRequire("cINVi");
function $7763c029038efc47$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $6JWQo.default).source;
    re.src_Cc = (0, $bzTP8.default).source;
    re.src_Z = (0, $cINVi.default).source;
    re.src_P = (0, $6qXSM.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    ',(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    ';(?!' + re.src_ZCc + '|$)|' + // allow `!!!` in paths, but not at the end
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /* _root */  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
}

});


parcelRegister("ib0wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b9a8767eb6cd3f$export$2e2bcd8739ae039);
'use strict';
/** Highest positive signed 32-bit float value */ const $d3b9a8767eb6cd3f$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $d3b9a8767eb6cd3f$var$base = 36;
const $d3b9a8767eb6cd3f$var$tMin = 1;
const $d3b9a8767eb6cd3f$var$tMax = 26;
const $d3b9a8767eb6cd3f$var$skew = 38;
const $d3b9a8767eb6cd3f$var$damp = 700;
const $d3b9a8767eb6cd3f$var$initialBias = 72;
const $d3b9a8767eb6cd3f$var$initialN = 128; // 0x80
const $d3b9a8767eb6cd3f$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $d3b9a8767eb6cd3f$var$regexPunycode = /^xn--/;
const $d3b9a8767eb6cd3f$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $d3b9a8767eb6cd3f$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $d3b9a8767eb6cd3f$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $d3b9a8767eb6cd3f$var$baseMinusTMin = $d3b9a8767eb6cd3f$var$base - $d3b9a8767eb6cd3f$var$tMin;
const $d3b9a8767eb6cd3f$var$floor = Math.floor;
const $d3b9a8767eb6cd3f$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $d3b9a8767eb6cd3f$var$error(type) {
    throw new RangeError($d3b9a8767eb6cd3f$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $d3b9a8767eb6cd3f$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $d3b9a8767eb6cd3f$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($d3b9a8767eb6cd3f$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $d3b9a8767eb6cd3f$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $d3b9a8767eb6cd3f$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $d3b9a8767eb6cd3f$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $d3b9a8767eb6cd3f$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $d3b9a8767eb6cd3f$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $d3b9a8767eb6cd3f$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $d3b9a8767eb6cd3f$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $d3b9a8767eb6cd3f$var$floor(delta / $d3b9a8767eb6cd3f$var$damp) : delta >> 1;
    delta += $d3b9a8767eb6cd3f$var$floor(delta / numPoints);
    for(; delta > $d3b9a8767eb6cd3f$var$baseMinusTMin * $d3b9a8767eb6cd3f$var$tMax >> 1; k += $d3b9a8767eb6cd3f$var$base)delta = $d3b9a8767eb6cd3f$var$floor(delta / $d3b9a8767eb6cd3f$var$baseMinusTMin);
    return $d3b9a8767eb6cd3f$var$floor(k + ($d3b9a8767eb6cd3f$var$baseMinusTMin + 1) * delta / (delta + $d3b9a8767eb6cd3f$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $d3b9a8767eb6cd3f$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $d3b9a8767eb6cd3f$var$initialN;
    let bias = $d3b9a8767eb6cd3f$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($d3b9a8767eb6cd3f$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $d3b9a8767eb6cd3f$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $d3b9a8767eb6cd3f$var$base;; k += $d3b9a8767eb6cd3f$var$base){
            if (index >= inputLength) $d3b9a8767eb6cd3f$var$error('invalid-input');
            const digit = $d3b9a8767eb6cd3f$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $d3b9a8767eb6cd3f$var$base) $d3b9a8767eb6cd3f$var$error('invalid-input');
            if (digit > $d3b9a8767eb6cd3f$var$floor(($d3b9a8767eb6cd3f$var$maxInt - i) / w)) $d3b9a8767eb6cd3f$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $d3b9a8767eb6cd3f$var$tMin : k >= bias + $d3b9a8767eb6cd3f$var$tMax ? $d3b9a8767eb6cd3f$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $d3b9a8767eb6cd3f$var$base - t;
            if (w > $d3b9a8767eb6cd3f$var$floor($d3b9a8767eb6cd3f$var$maxInt / baseMinusT)) $d3b9a8767eb6cd3f$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $d3b9a8767eb6cd3f$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($d3b9a8767eb6cd3f$var$floor(i / out) > $d3b9a8767eb6cd3f$var$maxInt - n) $d3b9a8767eb6cd3f$var$error('overflow');
        n += $d3b9a8767eb6cd3f$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $d3b9a8767eb6cd3f$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $d3b9a8767eb6cd3f$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $d3b9a8767eb6cd3f$var$initialN;
    let delta = 0;
    let bias = $d3b9a8767eb6cd3f$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($d3b9a8767eb6cd3f$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($d3b9a8767eb6cd3f$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $d3b9a8767eb6cd3f$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $d3b9a8767eb6cd3f$var$floor(($d3b9a8767eb6cd3f$var$maxInt - delta) / handledCPCountPlusOne)) $d3b9a8767eb6cd3f$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $d3b9a8767eb6cd3f$var$maxInt) $d3b9a8767eb6cd3f$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $d3b9a8767eb6cd3f$var$base;; k += $d3b9a8767eb6cd3f$var$base){
                    const t = k <= bias ? $d3b9a8767eb6cd3f$var$tMin : k >= bias + $d3b9a8767eb6cd3f$var$tMax ? $d3b9a8767eb6cd3f$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $d3b9a8767eb6cd3f$var$base - t;
                    output.push($d3b9a8767eb6cd3f$var$stringFromCharCode($d3b9a8767eb6cd3f$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $d3b9a8767eb6cd3f$var$floor(qMinusT / baseMinusT);
                }
                output.push($d3b9a8767eb6cd3f$var$stringFromCharCode($d3b9a8767eb6cd3f$var$digitToBasic(q, 0)));
                bias = $d3b9a8767eb6cd3f$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $d3b9a8767eb6cd3f$export$110c810e8727e62b = function(input) {
    return $d3b9a8767eb6cd3f$var$mapDomain(input, function(string) {
        return $d3b9a8767eb6cd3f$var$regexPunycode.test(string) ? $d3b9a8767eb6cd3f$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $d3b9a8767eb6cd3f$export$69111c4ea6e0c4a0 = function(input) {
    return $d3b9a8767eb6cd3f$var$mapDomain(input, function(string) {
        return $d3b9a8767eb6cd3f$var$regexNonASCII.test(string) ? 'xn--' + $d3b9a8767eb6cd3f$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $d3b9a8767eb6cd3f$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $d3b9a8767eb6cd3f$export$c1700176c90f250f,
        'encode': $d3b9a8767eb6cd3f$export$f999239d9b149395
    },
    'decode': $d3b9a8767eb6cd3f$export$2f872c0f2117be69,
    'encode': $d3b9a8767eb6cd3f$export$c564cdbbe6da493,
    'toASCII': $d3b9a8767eb6cd3f$export$69111c4ea6e0c4a0,
    'toUnicode': $d3b9a8767eb6cd3f$export$110c810e8727e62b
};
var $d3b9a8767eb6cd3f$export$2e2bcd8739ae039 = $d3b9a8767eb6cd3f$var$punycode;

});

parcelRegister("5ZRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a5bde204b42db2$export$2e2bcd8739ae039);
// markdown-it default options
var $69a5bde204b42db2$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("gVArB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78f92af3d2d267b$export$2e2bcd8739ae039);
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $e78f92af3d2d267b$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("r2Oyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d3b87413be1462$export$2e2bcd8739ae039);
// Commonmark default options
var $51d3b87413be1462$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("3Gcj3", function(module, exports) {

$parcel$export(module.exports, "getTextWithoutSpeechMarkdown", () => $d36b698e2bfea73e$export$d6c6ec86eedacfd9);
$parcel$export(module.exports, "replaceSpeechMarkdownTags", () => $d36b698e2bfea73e$export$f355fac925ad880f);

var $fb1tF = parcelRequire("fb1tF");
const $d36b698e2bfea73e$var$speechMarkdownParser = new (0, $fb1tF.SpeechMarkdown)();
const $d36b698e2bfea73e$export$d6c6ec86eedacfd9 = (text, speechMarkdownTagsPosition = [])=>{
    let res = '';
    // Myna parser used in speechmarkdown parsing can't deal with dashes which aren't in speechmarkdown tags properly.
    // Let's change them and put them back after treatment
    if (text.indexOf('-') !== -1) {
        const dashesOutsideSpeechmarkdown = [];
        for(let i = 0; i < text.length; i++)if (text[i] === '-') {
            let test = true;
            speechMarkdownTagsPosition.forEach((position)=>{
                if (i === position[0] || i === position[1] || i > position[0] && i < position[1]) test = false;
            });
            test && dashesOutsideSpeechmarkdown.push(i);
        }
        let textWithoutDashes = '';
        if (dashesOutsideSpeechmarkdown.length > 0) {
            for(let i = 0; i < dashesOutsideSpeechmarkdown.length; i++){
                textWithoutDashes += i === 0 ? text.substring(0, dashesOutsideSpeechmarkdown[i]) : text.substring(dashesOutsideSpeechmarkdown[i - 1] + 1, dashesOutsideSpeechmarkdown[i]);
                textWithoutDashes += '1xx1';
            }
            // Add the rest of the text (after the last dash)
            textWithoutDashes += text.substring(dashesOutsideSpeechmarkdown[dashesOutsideSpeechmarkdown.length - 1] + 1);
        }
        res = $d36b698e2bfea73e$var$speechMarkdownParser.toText(textWithoutDashes);
        res = res.replaceAll('1xx1', '-');
    } else res = $d36b698e2bfea73e$var$speechMarkdownParser.toText(text);
    // Remove phoneme tag
    res = res.replaceAll(/<\/?phoneme?[^>]+>|$/g, '');
    return res;
};
const $d36b698e2bfea73e$export$f355fac925ad880f = (text)=>{
    const replacements = [];
    let textWithReplacements = text;
    // Get the indexes of all the occurences of ')['
    let indexes = [];
    let position = text.indexOf(')[');
    while(position !== -1){
        indexes.push(position);
        position = text.indexOf(')[', position + 1);
    }
    // If at least one occurence has been found escape all characters related
    if (indexes.length > 0) // Loop on indexes to get all indexes
    for(let i = 0; i < indexes.length; i++){
        // Get the opening parenthesis related to the closing one from the expression
        const openingParenthesisIndex = $d36b698e2bfea73e$var$getOpeningParenthesis(text, indexes[i]);
        // Get the closing bracket related to the opening one from the expression
        const closingBracketIndex = text.substring(indexes[i]).indexOf(']') + indexes[i];
        const replacement = {
            // Use string for replacement as : 'replacement1x1'
            replacementString: `replacement${i}x${i}`,
            speechMarkdown: text.substring(openingParenthesisIndex, closingBracketIndex + 1)
        };
        replacements.push(replacement);
        textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
    }
    // In markdown links can be found as [...](...) so we need to find data between brackets without parentheses related to the closing bracket. Example : 'Hello. [1s] How are you ?'
    // Reset indexes array and set basic text to textWithReplacements to prevent searching again for brackets that have already been removed
    indexes = [];
    const tempText = textWithReplacements;
    position = tempText.indexOf(']');
    while(position !== -1){
        indexes.push(position);
        position = tempText.indexOf(']', position + 1);
    }
    if (indexes.length > 0) {
        for(let i = 0; i < indexes.length; i++)// If the index is the last character of the string, or if the next character isn't an opening parenthesis, it's ok
        if (indexes[i] === tempText.length - 1 || tempText.charAt(indexes[i] + 1) !== '(') {
            // Find the position of the previous opening bracket
            const openingBracketIndex = tempText.substring(0, indexes[i]).lastIndexOf('[');
            const replacement = {
                // Use string for replacement as : 'pause1x1'
                replacementString: `pause${i}x${i}`,
                speechMarkdown: tempText.substring(openingBracketIndex, indexes[i] + 1)
            };
            replacements.push(replacement);
            textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
        }
    }
    return {
        text: textWithReplacements,
        replacements: replacements
    };
};
const $d36b698e2bfea73e$var$getOpeningParenthesis = (text, index)=>{
    let nbOpeningParenthesis = 0;
    let nbClosingParenthesis = 0;
    // Search from the end of the string for an equivalence between opening and ending parenthesis, to prevent error if the text to be
    // spoken contains parenthesis.
    for(let i = index; i > 0; i--){
        if (text.charAt(i) === ')') nbClosingParenthesis++;
        else if (text.charAt(i) === '(') {
            nbOpeningParenthesis++;
            if (nbClosingParenthesis === nbOpeningParenthesis) return i;
        }
    }
    return 0;
};

});
parcelRegister("fb1tF", function(module, exports) {

$parcel$export(module.exports, "SpeechMarkdown", () => $b0c9077b7a60729e$export$fdd03b388331c324);
class $b0c9077b7a60729e$var$je {
    constructor(e){
        this.options = e, this.options = e;
    }
    // Adds each element of the array as markdown
    addArray(e, t) {
        for (const i of e)this.formatFromAst(i, t);
        return t;
    }
    processAst(e, t) {
        e instanceof Array ? this.addArray(e, t) : this.formatFromAst(e, t);
    }
}
class $b0c9077b7a60729e$var$Ne extends $b0c9077b7a60729e$var$je {
    constructor(e){
        super(e), this.options = e;
    }
    format(e) {
        let i = this.formatFromAst(e, []).join("").trim();
        return i = i.replace(/  +/g, " "), i;
    }
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.processAst(e.children, t), t;
            case "paragraph":
                return this.processAst(e.children, t), t;
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$S {
    constructor(e){
        this.base = e, this.tags = {}, this.text = "";
    }
    tag(e, t, i = !1, r = this.base.ssmlTagSortOrder) {
        const s = r.indexOf(e);
        this.tags[e] || (this.tags[e] = {
            sortId: s,
            attrs: null
        }), i ? this.tags[e].attrs = {
            ...this.tags[e].attrs,
            ...t
        } : this.tags[e].attrs = t;
    }
    voiceTagNamed(e, t) {
        let i = e && e[t];
        return i ? (typeof i != "object" && (i = {
            voice: {
                name: t
            }
        }), Object.keys(i).forEach((r)=>{
            const s = i[r];
            this.tag(r, s);
        }), !0) : !1;
    }
    voiceTag(e, t) {
        const i = this.base.sentenceCase(t || "device");
        this.voiceTagNamed(this.base.options && this.base.options.voices, i) || this.voiceTagNamed(this.base.validVoices, i);
    }
}
const $b0c9077b7a60729e$var$w = class w extends $b0c9077b7a60729e$var$je {
    constructor(e){
        super(e), this.options = e, this.sectionTags = [], this.modifierKeyMappings = {
            chars: "characters",
            cardinal: "number",
            digits: "characters",
            bleep: "expletive",
            phone: "telephone",
            vol: "volume"
        }, this.ssmlTagSortOrder = [
            "emphasis",
            "say-as",
            "prosody",
            "amazon:domain",
            "amazon:effect",
            "amazon:emotion",
            "voice",
            "lang",
            "sub",
            "phoneme"
        ], this.modifierKeyToSsmlTagMappings = {
            emphasis: "emphasis",
            address: "say-as",
            number: "say-as",
            characters: "say-as",
            expletive: "say-as",
            fraction: "say-as",
            interjection: "say-as",
            ordinal: "say-as",
            telephone: "say-as",
            unit: "say-as",
            time: "say-as",
            date: "say-as",
            whisper: null,
            sub: "sub",
            ipa: "phoneme",
            rate: "prosody",
            pitch: "prosody",
            volume: "prosody",
            drc: null,
            timbre: null,
            lang: null,
            voice: null,
            dj: null,
            defaults: null,
            newscaster: null,
            excited: null,
            disappointed: null
        };
    }
    format(e) {
        return this.formatFromAst(e, []).join("");
    }
    addSectionStartTag(e, t, i) {
        this.sectionTags = [
            ...e
        ].reverse();
        for(let r = 0; r < e.length; r++){
            const s = e[r], o = t.tags[s].attrs;
            i.push(`
`), i.push(this.startTag(s, o, !1));
        }
    }
    addSectionEndTag(e) {
        if (this.sectionTags.length > 0) for(let t = 0; t < this.sectionTags.length; t++){
            const i = this.sectionTags[t];
            e.push(this.endTag(i, !1)), e.push(`
`);
        }
    }
    // Adds tagged content
    addTag(e, t, i, r, s, o) {
        return o.push(this.startTag(e, s, i)), this.processAst(t, o), o.push(this.endTag(e, i)), r && o.push(`
`), o;
    }
    addSpeakTag(e, t, i, r, s) {
        return s.push(this.startTag("speak", r, t)), this.processAst(e, s), this.addSectionEndTag(s), s.push(this.endTag("speak", t)), i && s.push(`
`), s;
    }
    addComment(e, t) {
        return t.push(`<!-- ${e} -->
`), t;
    }
    // Returns the SSML for a start tag
    startTag(e, t, i = !1) {
        let r = "";
        return t && (r = " " + Object.keys(t).map((s)=>s + '="' + t[s] + '"').join(" ")), "<" + e + r + ">" + (i ? `
` : "");
    }
    // Returns the SSML for an end tag
    endTag(e, t = !1) {
        return (t ? `
` : "") + "</" + e + ">";
    }
    voidTag(e, t) {
        let i = "";
        return t && (i = " " + Object.keys(t).map((r)=>r + '="' + t[r] + '"').join(" ")), "<" + e + i + "/>";
    }
    addTagWithAttrs(e, t, i, r, s = !1) {
        return t || s ? (e.push(this.startTag(i, r)), t && e.push(t), e.push(this.endTag(i, !1))) : e.push(this.voidTag(i, r)), e;
    }
    getTagWithAttrs(e, t, i) {
        let r = [];
        return e ? (r.push(this.startTag(t, i)), r.push(e), r.push(this.endTag(t, !1))) : r.push(this.voidTag(t, i)), r.join("");
    }
    sentenceCase(e) {
        return e.replace(/[a-z]/i, (t)=>t.toUpperCase()).trim();
    }
    escapeXmlCharacters(e) {
        let t = `${Object.keys(w.XML_UNESCAPE_MAPPING).join("|")}]`, i = e.replace(new RegExp(t, "g"), (o)=>w.XML_UNESCAPE_MAPPING[o]), r = `[${Object.keys(w.XML_ESCAPE_MAPPING).join("")}]`;
        return i.replace(new RegExp(r, "g"), (o)=>w.XML_ESCAPE_MAPPING[o]);
    }
};
$b0c9077b7a60729e$var$w.XML_ESCAPE_MAPPING = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    '"': "&quot;",
    "'": "&apos;"
}, $b0c9077b7a60729e$var$w.XML_UNESCAPE_MAPPING = function(t) {
    return Object.keys(t).reduce((i, r)=>(i[t[r]] = r, i), {});
}($b0c9077b7a60729e$var$w.XML_ESCAPE_MAPPING);
let $b0c9077b7a60729e$var$L = $b0c9077b7a60729e$var$w;
class $b0c9077b7a60729e$var$He extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.validVoices = {
            Ivy: "en-US",
            Joanna: "en-US",
            Joey: "en-US",
            Justin: "en-US",
            Kendra: "en-US",
            Kimberly: "en-US",
            Matthew: "en-US",
            Salli: "en-US",
            Nicole: "en-AU",
            Russell: "en-AU",
            Amy: "en-GB",
            Brian: "en-GB",
            Emma: "en-GB",
            Aditi: "en-IN",
            Raveena: "en-IN",
            Hans: "de-DE",
            Marlene: "de-DE",
            Vicki: "de-DE",
            Conchita: "es-ES",
            Enrique: "es-ES",
            Carla: "it-IT",
            Giorgio: "it-IT",
            Mizuki: "ja-JP",
            Takumi: "ja-JP",
            Celine: "fr-FR",
            Lea: "fr-FR",
            Mathieu: "fr-FR"
        }, this.validEmotionIntensity = [
            "low",
            "medium",
            "high"
        ], this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.dj = "amazon:domain", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyToSsmlTagMappings.excited = "amazon:emotion", this.modifierKeyToSsmlTagMappings.disappointed = "amazon:emotion";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "emphasis":
                                t.tag(l, {
                                    level: o || "moderate"
                                });
                                break;
                            case "address":
                            case "characters":
                            case "expletive":
                            case "fraction":
                            case "interjection":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "whisper":
                                t.tag(l, {
                                    name: "whispered"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "voice":
                                t.voiceTag(s, o);
                                break;
                            case "excited":
                            case "disappointed":
                                {
                                    const d = (o || "medium").toLowerCase();
                                    if (this.validEmotionIntensity.includes(d)) {
                                        t.tag(l, {
                                            name: s,
                                            intensity: d
                                        });
                                        break;
                                    }
                                    break;
                                }
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                    case "voice":
                        t.voiceTag(s, o);
                        break;
                    case "dj":
                        t.tag(l, {
                            name: "music"
                        });
                        break;
                    case "newscaster":
                        t.tag(l, {
                            name: "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "excited":
                    case "disappointed":
                        {
                            const d = (o || "medium").toLowerCase();
                            if (this.validEmotionIntensity.includes(d)) {
                                t.tag(l, {
                                    name: s,
                                    intensity: d
                                });
                                break;
                            }
                            break;
                        }
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "shortEmphasisModerate":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    });
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
                {
                    let i = this.options.escapeXmlSymbols ? this.escapeXmlCharacters(e.allText) : e.allText;
                    return t.push(i), t;
                }
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$Ze extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.timbre = "amazon:effect", this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "emphasis":
                                t.tag(l, {
                                    level: o || "moderate"
                                });
                                break;
                            case "address":
                            case "cardinal":
                            case "characters":
                            case "digits":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "whisper":
                                t.tag(l, {
                                    name: "whispered"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "timbre":
                                t.tag(l, {
                                    "vocal-tract-length": o
                                });
                                break;
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "drc":
                                t.tag(l, {
                                    name: s
                                });
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "markTag":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "mark", {
                        name: i
                    });
                }
            case "shortEmphasisModerate":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$Ye extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "address":
                            case "cardinal":
                            case "characters":
                            case "digits":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "drc":
                                t.tag(l, {
                                    name: s
                                });
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                    case "newscaster":
                        t.tag(l, {
                            name: "news"
                        });
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Polly", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "markTag":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "mark", {
                        name: i
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                return t.push(e.allText.replace(/\+/g, "")), t;
            case "plainText":
            case "plainTextSpecialChars":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$_e extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.validVoices = {
            Ivy: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-US"
                }
            },
            Joanna: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-US"
                }
            },
            Joey: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-US"
                }
            },
            Justin: {
                voice: {
                    gender: "male",
                    variant: 2,
                    language: "en-US"
                }
            },
            Kendra: {
                voice: {
                    gender: "female",
                    variant: 3,
                    language: "en-US"
                }
            },
            Kimberly: {
                voice: {
                    gender: "female",
                    variant: 4,
                    language: "en-US"
                }
            },
            Matthew: {
                voice: {
                    gender: "male",
                    variant: 3,
                    language: "en-US"
                }
            },
            Salli: {
                voice: {
                    gender: "male",
                    variant: 4,
                    language: "en-US"
                }
            },
            Nicole: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-AU"
                }
            },
            Russell: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-AU"
                }
            },
            Amy: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-GB"
                }
            },
            Brian: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-GB"
                }
            },
            Emma: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-GB"
                }
            },
            Aditi: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-IN"
                }
            },
            Raveena: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-IN"
                }
            },
            Hans: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "de-DE"
                }
            },
            Marlene: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "de-DE"
                }
            },
            Vicki: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "de-DE"
                }
            },
            Conchita: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "es-ES"
                }
            },
            Enrique: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "es-ES"
                }
            },
            Carla: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "it-IT"
                }
            },
            Giorgio: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "it-IT"
                }
            },
            Mizuki: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            Takumi: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            Celine: {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "fr-FR"
                }
            },
            Lea: {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "fr-FR"
                }
            },
            Mathieu: {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "fr-FR"
                }
            }
        }, this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.lang = "lang";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "emphasis":
                                t.tag(l, {
                                    level: o || "moderate"
                                });
                                break;
                            case "address":
                            case "characters":
                            case "expletive":
                            case "fraction":
                            case "number":
                            case "ordinal":
                            case "telephone":
                            case "unit":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                });
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                });
                                break;
                            case "whisper":
                                t.tag(l, {
                                    volume: "x-soft",
                                    rate: "slow"
                                });
                                break;
                            case "ipa":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                });
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                });
                                break;
                            case "voice":
                                t.voiceTag(s, o);
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "lang":
                        t.tag(l, {
                            "xml:lang": o
                        });
                        break;
                    case "voice":
                        t.voiceTag(s, o);
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Google Assistant", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "markTag":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "mark", {
                        name: i
                    });
                }
            case "shortEmphasisModerate":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "moderate"
                    });
                }
            case "shortEmphasisStrong":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "strong"
                    });
                }
            case "shortEmphasisNone":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "none"
                    });
                }
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, i, "emphasis", {
                        level: "reduced"
                    });
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e);
                    if (i.textOnly) return t.push(i.text), t;
                    const r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    });
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$et extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.emphasis = null, this.modifierKeyToSsmlTagMappings.address = null, this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = null, this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = null, this.modifierKeyToSsmlTagMappings.date = null, this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.ipa = null, this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody";
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            // case 'emphasis': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { level: value || 'moderate' };
                            //   break;
                            // }
                            // case 'address':
                            // case 'expletive':
                            // case 'telephone':
                            // case 'unit':
                            case "fraction":
                            case "ordinal":
                                t.tag(l, {
                                    "interpret-as": s
                                });
                                break;
                            case "number":
                                t.tag(l, {
                                    "interpret-as": "cardinal"
                                });
                                break;
                            case "characters":
                                {
                                    let d = "digits";
                                    isNaN(t.text) && (d = "spell-out"), t.tag(l, {
                                        "interpret-as": d
                                    });
                                    break;
                                }
                            // case 'date': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'ymd' };
                            //   break;
                            // }
                            // case 'time': {
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'hms12' };
                            //   break;
                            // }
                            case "whisper":
                                t.tag(l, {
                                    volume: "x-soft",
                                    rate: "slow"
                                });
                                break;
                            // case 'ipa': {
                            //   // Google Assistant does not support <phoneme> tag
                            //   if (!textModifierObject.tags[ssmlTag]) {
                            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                            //   }
                            //   textModifierObject['textOnly'] = true;
                            //   break;
                            // }
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                });
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0);
                                    break;
                                }
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Samsung Bixby", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return i && t.push(i), t;
                }
            // case 'shortEmphasisStrong': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'strong' });
            // }
            // case 'shortEmphasisNone': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'none' });
            // }
            // case 'shortEmphasisReduced': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'reduced' });
            // }
            // case 'textModifier': {
            //   const tmo = this.getTextModifierObject(ast);
            //   if (tmo.textOnly) {
            //     // Quick return if tag is not supported
            //     lines.push(tmo.text)
            //     return lines
            //   }
            //   const tagsSortedDesc = Object.keys(tmo.tags).sort((a: any, b: any) => { return tmo.tags[b].sortId - tmo.tags[a].sortId });
            //   let inner = tmo.text;
            //   for (let index = 0; index < tagsSortedDesc.length; index++) {
            //     const tag = tagsSortedDesc[index];
            //     const attrs = tmo.tags[tag].attrs;
            //     inner = this.getTagWithAttrs(inner, tag, attrs);
            //   }
            //   lines.push(inner);
            //   return lines;
            // }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e);
                    if (i.textOnly) return t.push(i.text), t;
                    const r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    }, !0);
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return t.push(e.allText), t;
            default:
                return this.processAst(e.children, t), t;
        }
    }
}
class $b0c9077b7a60729e$var$tt extends $b0c9077b7a60729e$var$L {
    constructor(e){
        super(e), this.options = e, this.modifierKeyToSsmlTagMappings.emphasis = "emphasis", this.modifierKeyToSsmlTagMappings.address = "say-as", this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = "say-as", this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = "say-as", this.modifierKeyToSsmlTagMappings.date = "say-as", this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.paragraph = "p", this.modifierKeyToSsmlTagMappings.sentence = "s", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.ipa = "phoneme", this.modifierKeyToSsmlTagMappings.sapi = "phoneme", this.modifierKeyToSsmlTagMappings.ups = "phoneme", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.contour = "prosody", this.modifierKeyToSsmlTagMappings.range = "prosody", this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.emotion = "mstts:express-as", this.ssmlTagSortOrder = [
            "voice",
            "lang",
            "p",
            "s",
            "emphasis",
            "say-as",
            "mstts:express-as",
            "prosody",
            "sub",
            "phoneme"
        ];
    }
    // tslint:disable-next-line: max-func-body-length
    getTextModifierObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            switch(r.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    t.text = r.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    {
                        let s = r.children[0].allText;
                        s = this.modifierKeyMappings[s] || s;
                        const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                        switch(s){
                            case "address":
                            case "fraction":
                            case "ordinal":
                            case "telephone":
                                t.tag(l, {
                                    "interpret-as": s
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "number":
                                t.tag(l, {
                                    "interpret-as": "cardinal"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "characters":
                                {
                                    let d = "digits";
                                    isNaN(t.text) && (d = "characters"), t.tag(l, {
                                        "interpret-as": d
                                    }, !1, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "date":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "ymd"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "time":
                                t.tag(l, {
                                    "interpret-as": s,
                                    format: o || "hms12"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "whisper":
                                t.tag(l, {
                                    volume: "x-soft",
                                    rate: "slow"
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "ipa":
                            case "sapi":
                            case "ups":
                                t.tag(l, {
                                    alphabet: s,
                                    ph: o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "sub":
                                t.tag(l, {
                                    alias: o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "volume":
                            case "rate":
                            case "pitch":
                                {
                                    const d = {};
                                    d[s] = o || "medium", t.tag(l, d, !0, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "lang":
                                t.tag(l, {
                                    "xml:lang": o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "voice":
                                {
                                    const d = this.sentenceCase(o || "device");
                                    d != "Device" && t.tag(l, {
                                        name: d
                                    }, !1, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "emotion":
                                {
                                    const d = o.split(" "), f = {};
                                    switch(d.length){
                                        case 2:
                                            const k = parseInt(d[1]);
                                            isNaN(k) ? f.role = d[1] : f.styledegree = d[1];
                                        case 1:
                                            f.style = d[0];
                                            break;
                                    }
                                    t.tag(l, f, !0, this.ssmlTagSortOrder);
                                    break;
                                }
                            case "emphasis":
                                t.tag(l, {
                                    level: o
                                }, !1, this.ssmlTagSortOrder);
                                break;
                            case "paragraph":
                                t.tag(l, null, !1, this.ssmlTagSortOrder);
                                break;
                            case "sentence":
                                t.tag(l, null, !1, this.ssmlTagSortOrder);
                                break;
                        }
                        break;
                    }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    getSectionObject(e) {
        let t = new $b0c9077b7a60729e$var$S(this);
        for(let i = 0; i < e.children.length; i++){
            const r = e.children[i];
            if (r.name === "sectionModifierKeyOptionalValue") {
                let s = r.children[0].allText;
                const o = r.children.length === 2 ? r.children[1].allText : "", l = this.modifierKeyToSsmlTagMappings[s];
                switch(s){
                    case "voice":
                        {
                            const d = this.sentenceCase(o || "device");
                            d != "Device" && t.tag(l, {
                                name: d
                            }, !1, this.ssmlTagSortOrder);
                            break;
                        }
                    case "defaults":
                        break;
                    case "emotion":
                        t.tag(l, {
                            style: o
                        }, !1, this.ssmlTagSortOrder);
                        break;
                }
            }
        }
        return t;
    }
    // tslint:disable-next-line: max-func-body-length
    formatFromAst(e, t = []) {
        switch(e.name){
            case "document":
                return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Microsoft Azure", t), this.options.includeSpeakTag ? this.addSpeakTag(e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "paragraph":
                return this.options.includeParagraphTag ? this.addTag("p", e.children, !0, !1, null, t) : (this.processAst(e.children, t), t);
            case "shortBreak":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "break", {
                        time: i
                    });
                }
            case "break":
                {
                    const i = e.children[0].allText;
                    let r = {};
                    switch(e.children[0].children[0].name){
                        case "breakStrengthValue":
                            r = {
                                strength: i
                            };
                            break;
                        case "time":
                            r = {
                                time: i
                            };
                            break;
                    }
                    return this.addTagWithAttrs(t, null, "break", r);
                }
            case "silence":
                {
                    const i = e.children[0].allText.split(" "), r = {
                        type: i[0],
                        value: i[1]
                    };
                    return this.addTagWithAttrs(t, null, "mstts:silence", r);
                }
            case "backgroundAudio":
                {
                    const i = e.children[0].allText.split(" ");
                    let r = {};
                    const s = [
                        "src",
                        "volume",
                        "fadein",
                        "fadeout"
                    ];
                    for(let o = 0; o < i.length; o++)r[s[o]] = i[o];
                    return this.addTagWithAttrs(t, null, "mstts:backgroundaudio", r);
                }
            case "lexicon":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "lexicon", {
                        uri: i
                    });
                }
            case "bookmark":
                {
                    const i = e.children[0].allText;
                    return this.addTagWithAttrs(t, null, "bookmark", {
                        mark: i
                    });
                }
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                {
                    const i = e.children[0].allText;
                    return i && t.push(i), t;
                }
            case "textModifier":
                {
                    const i = this.getTextModifierObject(e), r = Object.keys(i.tags).sort((o, l)=>i.tags[l].sortId - i.tags[o].sortId);
                    let s = i.text;
                    for(let o = 0; o < r.length; o++){
                        const l = r[o], d = i.tags[l].attrs;
                        if (l === "voice" || l === "lang") {
                            const f = o < r.length - 1 ? r[o + 1] : "";
                            s = this.getVoiceOrLangTagWithAttrs(s, l, d, f);
                        } else s = this.getTagWithAttrs(s, l, d);
                    }
                    return t.push(s), t;
                }
            case "audio":
                {
                    const i = e.children[0].allText.replace(/&/g, "&amp;");
                    return this.addTagWithAttrs(t, null, "audio", {
                        src: i
                    }, !1);
                }
            case "simpleLine":
                return this.processAst(e.children, t), t;
            case "lineEnd":
                return t.push(e.allText), t;
            case "emptyLine":
                return this.options.preserveEmptyLines && t.push(e.allText), t;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                return t.push(e.allText), t;
            case "section":
                {
                    const i = this.getSectionObject(e), r = Object.keys(i.tags).sort((s, o)=>i.tags[s].sortId - i.tags[o].sortId);
                    return this.addSectionEndTag(t), this.addSectionStartTag(r, i, t), t;
                }
            default:
                return this.processAst(e.children, t), t;
        }
    }
    getVoiceOrLangTagWithAttrs(e, t, i, r) {
        let s = [];
        return e ? (s.push(this.startVoiceOrLangTag(t, i, r)), s.push(e), s.push(this.endVoiceOrLangTag(t, !1, r))) : s.push(this.voidTag(t, i)), s.join("");
    }
    // Returns the SSML for a start tag
    startVoiceOrLangTag(e, t, i, r = !1) {
        let s = "", o = "";
        switch(e){
            case "voice":
                this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (o = "</voice>", this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (o = "</lang>" + o));
                break;
            case "lang":
                i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (o = "</lang>");
                break;
        }
        return t && (s = " " + Object.keys(t).map((l)=>l + '="' + t[l] + '"').join(" ")), o + "<" + e + s + ">" + (r ? `
` : "");
    }
    // Returns the SSML for an end tag
    endVoiceOrLangTag(e, t = !1, i) {
        let r = "";
        switch(e){
            case "voice":
                this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (r = `<voice name="${this.options.globalVoiceAndLang.voice}">`, this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (r += `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`));
                break;
            case "lang":
                i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && e === "lang" && (r = `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`);
                break;
        }
        return (t ? `
` : "") + "</" + e + ">" + r;
    }
}
function $b0c9077b7a60729e$var$rt(m) {
    switch(m.platform){
        case "amazon-alexa":
            return new $b0c9077b7a60729e$var$He(m);
        case "amazon-polly":
            return new $b0c9077b7a60729e$var$Ze(m);
        case "amazon-polly-neural":
            return new $b0c9077b7a60729e$var$Ye(m);
        case "google-assistant":
            return new $b0c9077b7a60729e$var$_e(m);
        case "samsung-bixby":
            return new $b0c9077b7a60729e$var$et(m);
        case "microsoft-azure":
            return new $b0c9077b7a60729e$var$tt(m);
        default:
            return new $b0c9077b7a60729e$var$Ne(m);
    }
}
function $b0c9077b7a60729e$var$it(m) {
    return new $b0c9077b7a60729e$var$Ne(m);
}
var $b0c9077b7a60729e$var$Q = {
    exports: {}
}, $b0c9077b7a60729e$var$we = $b0c9077b7a60729e$var$Q.exports, $b0c9077b7a60729e$var$Ce;
function $b0c9077b7a60729e$var$at() {
    return $b0c9077b7a60729e$var$Ce || ($b0c9077b7a60729e$var$Ce = 1, function(m, e) {
        var t = $b0c9077b7a60729e$var$we && $b0c9077b7a60729e$var$we.__extends || function(r, s) {
            for(var o in s)s.hasOwnProperty(o) && (r[o] = s[o]);
            function l() {
                this.constructor = r;
            }
            r.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
        }, i;
        (function(r) {
            var s = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, c), this.type = "ParserError";
                }
                return n;
            }(Error);
            r.ParserError = s, r.grammars = {}, r.allRules = {}, r.parsers = {};
            var o = function() {
                function a(n, c) {
                    this.input = n, this.index = c, this.lineNum = 0, this.colNum = 0, this.lineStart = 0, this.lineEnd = 0;
                    for(var u = 0, h = 1, p = 0; p < this.index; ++p)this.input.charCodeAt(p) == 13 && (this.lineStart = p, u++), this.input.charCodeAt(p) == 10 && (this.lineStart = p, h++);
                    for(this.lineEnd = this.index; this.lineEnd < this.input.length && !(this.input.charCodeAt(this.lineEnd) == 13 || this.input.charCodeAt(this.lineEnd) == 10); ++this.lineEnd);
                    this.lineNum = u > h ? u : h, this.colNum = this.index - this.lineStart, this.lineText = this.input.substring(this.lineStart, this.lineEnd), this.pointerText = Array(this.colNum).join(" ") + "^";
                }
                return a.prototype.toString = function() {
                    return "Index " + this.index + ", Line " + this.lineNum + ", Column " + this.colNum + `
` + this.lineText + `
` + this.pointerText;
                }, a;
            }();
            r.ParseLocation = o;
            var l = function() {
                function a(n, c, u) {
                    this.input = n, this.index = c, this.nodes = u, this.length = 0, this.rules = [], this.length = this.input.length;
                }
                return Object.defineProperty(a.prototype, "location", {
                    // Returns an object that representation of the location. 
                    get: function() {
                        return new o(this.input, this.index);
                    },
                    enumerable: !0,
                    configurable: !0
                }), a;
            }();
            r.ParseState = l;
            var d = function() {
                function a(n, c, u, h) {
                    u === void 0 && (u = 0), h === void 0 && (h = -1), this.rule = n, this.input = c, this.start = u, this.end = h, this.children = null;
                }
                return Object.defineProperty(a.prototype, "name", {
                    // Returns the name of the rule associated with this node
                    get: function() {
                        return this.rule != null ? this.rule.name : "unnamed";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "fullName", {
                    // Returns the name of the rule, preceded by the grammar name, associated with this node
                    get: function() {
                        return this.rule != null ? this.rule.fullName : "unnamed";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "allText", {
                    // Returns the parsed text associated with this node's start and end locations  
                    get: function() {
                        return this.input.slice(this.start, this.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "isLeaf", {
                    // Returns true if this node has no children
                    get: function() {
                        return this.children == null || this.children.length == 0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.child = function(n) {
                    if (this.children) for(var c = 0, u = this.children; c < u.length; c++){
                        var h = u[c];
                        if (h.name == n) return h;
                    }
                    return null;
                }, Object.defineProperty(a.prototype, "_firstChildStart", {
                    // The position of the first child, or the end position for the entire node if no children 
                    get: function() {
                        return this.isLeaf ? this.end : this.children[0].start;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "_lastChildEnd", {
                    // The end position of the last child, or the end position for the entire node if no children 
                    get: function() {
                        return this.isLeaf ? this.end : this.children[0].end;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "beforeChildrenText", {
                    // Returns the text before the children, or if no children returns the entire text. 
                    get: function() {
                        return this.input.slice(this.start, this._firstChildStart);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "afterChildrenText", {
                    // Returns the text after the children, or if no children returns the empty string.
                    get: function() {
                        return this.input.slice(this._lastChildEnd, this.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "allChildrenText", {
                    // Returns the text from the beginning of the first child to the end of the last child.
                    get: function() {
                        return this.input.slice(this._firstChildStart, this._lastChildEnd);
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.toString = function() {
                    var n = this.isLeaf ? this.allText : this.children.map(function(c) {
                        return c.toString();
                    }).join(" ");
                    return "(" + this.rule.name + ": " + n + ")";
                }, a;
            }();
            r.AstNode = d;
            var f = function() {
                function a(n) {
                    this.rules = n, this.name = "", this.grammarName = "", this.type = "", this.className = "Rule", this._createAstNode = !1, this.parser = null, this.lexer = null;
                }
                return a.prototype.node = function(n) {
                    n === void 0 && (n = "");
                    for(var c = [], u = 1; u < arguments.length; u++)c[u - 1] = arguments[u];
                    var h = new d(this, n, 0, n.length);
                    return h.children = c, h;
                }, a.prototype.parse = function(n) {
                    return r.parse(this, n);
                }, a.prototype.setName = function(n, c) {
                    return this.grammarName = n, this.name = c, this;
                }, Object.defineProperty(a.prototype, "definition", {
                    // Returns a default definition of the rule
                    get: function() {
                        return this.className + "(" + this.rules.map(function(n) {
                            return n.toString();
                        }).join(", ") + ")";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "fullName", {
                    // Returns the name of the rule preceded by the grammar name and a "."
                    get: function() {
                        return this.grammarName + "." + this.name;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "nameOrDefinition", {
                    // Returns either the name of the rule, or it's definition
                    get: function() {
                        return this.name ? this.fullName : this.definition;
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.toString = function() {
                    return this.nameOrDefinition;
                }, Object.defineProperty(a.prototype, "firstChild", {
                    // Returns the first child rule
                    get: function() {
                        return this.rules[0];
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.setType = function(n) {
                    return this.type = n, this;
                }, a.prototype.cloneImplementation = function() {
                    throw new Error("Missing override for cloneImplementation");
                }, Object.defineProperty(a.prototype, "copy", {
                    // Returns a copy of this rule with all fields copied.  
                    get: function() {
                        var n = this.cloneImplementation();
                        if (typeof n != typeof this) throw new Error("Error in implementation of cloneImplementation: not returning object of correct type");
                        return n.name = this.name, n.grammarName = this.grammarName, n._createAstNode = this._createAstNode, n;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "hasAstChildRule", {
                    // Returns true if any of the child rules are "ast rules" meaning they create nodes in the parse tree.
                    get: function() {
                        return this.rules.filter(function(n) {
                            return n.createsAstNode;
                        }).length > 0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "createsAstNode", {
                    // Returns true if this rule when parsed successfully will create a node in the parse tree. 
                    // Some rules will override this function. 
                    get: function() {
                        return this._createAstNode;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "nonAdvancing", {
                    // Returns true if this rule doesn't advance the input
                    get: function() {
                        return !1;
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.astRuleDefn = function(n, c) {
                    n === void 0 && (n = !1), c === void 0 && (c = !1);
                    var u = this.rules.filter(function(g) {
                        return g.createsAstNode;
                    });
                    if (!u.length) return this.name;
                    if (u.length == 1) {
                        var h = u[0].astRuleNameOrDefn(n, c);
                        return this instanceof I && (h += "[" + this.min + "," + this.max + "]"), h;
                    }
                    if (this instanceof v) {
                        var p = u.map(function(g) {
                            return g.astRuleNameOrDefn(!0, !1);
                        }).join(",");
                        return n ? p : "seq(" + p + ")";
                    }
                    if (this instanceof C) {
                        var p = u.map(function(T) {
                            return T.astRuleNameOrDefn(!1, !0);
                        }).join(",");
                        return c ? p : "choice(" + p + ")";
                    }
                    throw new Error("Internal error: not a valid AST rule");
                }, a.prototype.astRuleNameOrDefn = function(n, c) {
                    return n === void 0 && (n = !1), c === void 0 && (c = !1), this._createAstNode ? this.name : this.astRuleDefn(n, c);
                }, Object.defineProperty(a.prototype, "opt", {
                    //======================================================
                    // Extensions to support method/property chaining. 
                    // This is also known as a fluent API syntax
                    get: function() {
                        return ee(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "zeroOrMore", {
                    get: function() {
                        return ce(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "oneOrMore", {
                    get: function() {
                        return le(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "at", {
                    get: function() {
                        return _(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "not", {
                    get: function() {
                        return N(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "advance", {
                    get: function() {
                        return this.then(r.advance);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "ws", {
                    get: function() {
                        return this.then(r.ws);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "all", {
                    get: function() {
                        return this.then(r.all);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "end", {
                    get: function() {
                        return this.then(r.end);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "assert", {
                    get: function() {
                        return F(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(a.prototype, "ast", {
                    get: function() {
                        return new k(this);
                    },
                    enumerable: !0,
                    configurable: !0
                }), a.prototype.then = function(n) {
                    return y(this, n);
                }, a.prototype.thenAt = function(n) {
                    return this.then(_(n));
                }, a.prototype.thenNot = function(n) {
                    return this.then(N(n));
                }, a.prototype.or = function(n) {
                    return b(this, n);
                }, a.prototype.until = function(n) {
                    return q(this, n);
                }, a.prototype.untilPast = function(n) {
                    return Z(this, n);
                }, a.prototype.repeat = function(n) {
                    return he(this, n);
                }, a.prototype.quantified = function(n, c) {
                    return W(this, n, c);
                }, a.prototype.delimited = function(n) {
                    return ge(this, n);
                }, a.prototype.unless = function(n) {
                    return re(this, n);
                }, a;
            }();
            r.Rule = f;
            var k = function(a) {
                t(n, a);
                function n(c) {
                    var u = this;
                    a.call(this, [
                        c
                    ]), this.r = c, this.type = "ast", this.className = "AstRule", this._createAstNode = !0, this.parser = function(h) {
                        var p = h.index, g = h.nodes;
                        if (h.nodes = [], h.rules.push(u), c.parser(h)) {
                            h.rules.pop();
                            var T = new d(u, h.input, p, h.index);
                            return T.children = h.nodes, h.nodes = g, h.nodes.push(T), !0;
                        } else return h.rules.pop(), h.nodes = g, h.index = p, !1;
                    }, this.lexer = c.lexer;
                }
                return n;
            }(f);
            r.AstRule = k;
            var v = function(a) {
                t(n, a);
                function n(c, u) {
                    a.call(this, [
                        c,
                        u
                    ]), this.rule1 = c, this.rule2 = u, this.type = "seq", this.className = "Sequence", this.parser = function(h) {
                        var p = h.nodes.length, g = h.index;
                        return c.parser(h) === !1 ? !1 : u.parser(h) === !1 ? (h.nodes.length !== p && h.nodes.splice(-1, h.nodes.length - p), h.index = g, !1) : !0;
                    }, this.lexer = function(h) {
                        var p = h.index;
                        return c.lexer(h) === !1 ? !1 : u.lexer(h) === !1 ? (h.index = p, !1) : !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        var c = this.rules.map(function(u) {
                            return u.toString();
                        }).join(" ");
                        return this.rules.length > 1 && (c = "(" + c + ")"), c;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "nonAdvancing", {
                    get: function() {
                        return this.rules.every(function(c) {
                            return c.nonAdvancing;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.rule1, this.rule2);
                }, n;
            }(f);
            r.Sequence = v;
            var C = function(a) {
                t(n, a);
                function n(c, u) {
                    a.call(this, [
                        c,
                        u
                    ]), this.rule1 = c, this.rule2 = u, this.type = "choice", this.className = "Choice", this.parser = function(h) {
                        return c.parser(h) || u.parser(h);
                    }, this.lexer = function(h) {
                        return c.lexer(h) || u.lexer(h);
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        var c = this.rules.map(function(u) {
                            return u.toString();
                        }).join(" / ");
                        return this.rules.length > 1 && (c = "(" + c + ")"), c;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "nonAdvancing", {
                    get: function() {
                        return this.rules.every(function(c) {
                            return c.nonAdvancing;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.rule1, this.rule2);
                }, n;
            }(f);
            r.Choice = C;
            var I = function(a) {
                t(n, a);
                function n(c, u, h) {
                    var p = this;
                    if (u === void 0 && (u = 0), h === void 0 && (h = 1 / 0), a.call(this, [
                        c
                    ]), this.min = u, this.max = h, this.type = "quantified", this.className = "Quantified", h === 1 / 0 && c.nonAdvancing) throw new Error("Rule would create an infinite loop");
                    this.parser = function(g) {
                        for(var T = g.nodes.length, x = g.index, O = 0; O < h; ++O){
                            if (c.parser(g) === !1) return O >= u ? !0 : (g.nodes.length !== T && g.nodes.splice(-1, g.nodes.length - T), g.index = x, !1);
                            ne(h !== 1 / 0 || g.index !== x, p);
                        }
                        return !0;
                    }, this.lexer = function(g) {
                        for(var T = g.index, x = 0; x < h; ++x){
                            if (c.lexer(g) === !1) return x >= u ? !0 : (g.index = T, !1);
                            ne(h !== 1 / 0 || g.index !== T, p, "Infinite loop");
                        }
                        return !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    // Used for creating a human readable definition of the grammar.
                    get: function() {
                        return this.min == 0 && this.max == 1 ? this.firstChild.toString() + "?" : this.min == 0 && this.max == 1 / 0 ? this.firstChild.toString() + "*" : this.min == 1 && this.max == 1 / 0 ? this.firstChild.toString() + "+" : this.firstChild.toString() + "{" + this.min + "," + this.max + "}";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    get: function() {
                        return this._createAstNode || this.hasAstChildRule;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild, this.min, this.max);
                }, n;
            }(f);
            r.Quantified = I;
            var G = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, c, 0, 1), this.type = "optional", this.className = "Optional", this.parser = function(u) {
                        return c.parser(u), !0;
                    }, this.lexer = function(u) {
                        return c.lexer(u), !0;
                    }, this.createsAstNode || (this.parser = this.lexer);
                }
                return Object.defineProperty(n.prototype, "definition", {
                    // Used for creating a human readable definition of the grammar.
                    get: function() {
                        return this.firstChild.toString() + "?";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, n;
            }(I);
            r.Optional = G;
            var z = function(a) {
                t(n, a);
                function n() {
                    a.call(this, []), this.type = "advance", this.className = "Advance", this.lexer = function(c) {
                        return c.index < c.length ? ++c.index >= 0 : !1;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "<advance>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n();
                }, n;
            }(f);
            r.Advance = z;
            var K = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, [
                        c
                    ]), this.type = "advanceIf", this.className = "AdvanceIf", this.lexer = function(u) {
                        return c.lexer(u) && u.index < u.length ? ++u.index !== 0 : !1;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "advanceIf(" + this.firstChild.toString() + ")";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, n;
            }(f);
            r.AdvanceIf = K;
            var B = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.text = c, this.type = "text", this.className = "Text";
                    for(var u = c.length, h = [], p = 0; p < u; ++p)h.push(c.charCodeAt(p));
                    this.lexer = function(g) {
                        var T = g.index;
                        if (T + h.length > g.input.length) return !1;
                        for(var x = 0, O = h; x < O.length; x++){
                            var se = O[x];
                            if (g.input.charCodeAt(T++) !== se) return !1;
                        }
                        return g.index = T, !0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return '"' + Y(this.text) + '"';
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.text);
                }, n;
            }(f);
            r.Text = B;
            var X = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.text = c, this.type = "anyCaseText", this.className = "AnyCaseText", c = c.toLowerCase(), this.text = c;
                    for(var u = c.length, h = [], p = 0; p < u; ++p)h.push(c[p]);
                    this.lexer = function(g) {
                        var T = g.index;
                        if (T + h.length > g.input.length) return !1;
                        for(var x = 0, O = h; x < O.length; x++){
                            var se = O[x];
                            if (g.input[T++].toLowerCase() !== se) return !1;
                        }
                        return g.index = T, !0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return 'AnyCase("' + Y(this.text) + '")';
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.text);
                }, n;
            }(f);
            r.AnyCaseText = X;
            var J = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.fn = c, this.type = "delay", this.className = "Delay";
                    var u = null;
                    this.parser = function(p) {
                        return (u || (u = c().parser))(p);
                    };
                    var h = null;
                    this.lexer = function(p) {
                        return (h || (h = c().lexer))(p);
                    };
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.fn);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "<delay>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(n.prototype, "createsAstNode", {
                    // It is assumed that a delay function creates an AST node,
                    get: function() {
                        return !0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(f);
            r.Delay = J;
            var j = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, c), this.type = "charSet";
                }
                return Object.defineProperty(n.prototype, "nonAdvancing", {
                    get: function() {
                        return !0;
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(f);
            r.NonAdvancingRule = j;
            var D = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.chars = c, this.type = "charSet", this.className = "CharSet";
                    for(var u = [], h = c.length, p = 0; p < h; ++p)u[p] = c.charCodeAt(p);
                    this.lexer = function(g) {
                        return u.indexOf(g.input.charCodeAt(g.index)) >= 0;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "[" + Y(this.chars) + "]";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.chars);
                }, n;
            }(j);
            r.CharSet = D;
            var U = function(a) {
                t(n, a);
                function n(c, u) {
                    a.call(this, []), this.min = c, this.max = u, this.type = "charRange", this.className = "CharRange";
                    var h = c.charCodeAt(0), p = u.charCodeAt(0);
                    this.lexer = function(g) {
                        var T = g.input.charCodeAt(g.index);
                        return T >= h && T <= p;
                    }, this.parser = this.lexer;
                }
                return Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "[" + this.min + ".." + this.max + "]";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n.prototype.cloneImplementation = function() {
                    return new n(this.min, this.max);
                }, n;
            }(j);
            r.CharRange = U;
            var $ = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, [
                        c
                    ]), this.type = "not", this.className = "Not";
                    var u = c.lexer;
                    this.lexer = function(h) {
                        if (h.index >= h.length) return !0;
                        var p = h.index;
                        return u(h) === !1 ? !0 : (h.index = p, !1);
                    }, this.parser = this.lexer;
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "!" + this.firstChild.toString();
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(j);
            r.Not = $;
            var H = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, [
                        c
                    ]), this.type = "at", this.className = "At";
                    var u = c.lexer;
                    this.lexer = function(h) {
                        var p = h.index;
                        return u(h) === !1 ? !1 : (h.index = p, !0);
                    }, this.parser = this.lexer;
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.firstChild);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "&" + this.firstChild.toString();
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(j);
            r.At = H;
            var V = function(a) {
                t(n, a);
                function n(c) {
                    a.call(this, []), this.fn = c, this.type = "predicate", this.className = "Predicate", this.lexer = c, this.parser = this.lexer;
                }
                return n.prototype.cloneImplementation = function() {
                    return new n(this.fn);
                }, Object.defineProperty(n.prototype, "definition", {
                    get: function() {
                        return "<predicate>";
                    },
                    enumerable: !0,
                    configurable: !0
                }), n;
            }(j);
            r.Predicate = V;
            function R(a) {
                return new B(a);
            }
            r.text = R;
            function oe(a) {
                return new X(a);
            }
            r.textAnyCase = oe;
            function y() {
                for(var a = [], n = 0; n < arguments.length; n++)a[n - 0] = arguments[n];
                var c = a.map(E);
                if (c.length == 0) throw new Error("At least one rule is expected when calling `seq`");
                if (c.length == 1) return c[0];
                var u = c[0], h = y.apply(void 0, c.slice(1));
                return u.nonAdvancing && h instanceof z ? new K(u) : new v(u, h);
            }
            r.seq = y;
            function b() {
                for(var a = [], n = 0; n < arguments.length; n++)a[n - 0] = arguments[n];
                var c = a.map(E);
                if (c.length == 0) throw new Error("At least one rule is expected when calling `choice`");
                if (c.length == 1) return c[0];
                var u = c[0], h = b.apply(void 0, c.slice(1));
                return u instanceof K && h instanceof K ? new K(b(u.firstChild, h.firstChild)) : new C(u, h);
            }
            r.choice = b;
            function Pe(a) {
                return new J(a);
            }
            r.delay = Pe;
            function N(a) {
                return new $(E(a));
            }
            r.not = N;
            function _(a) {
                return new H(E(a));
            }
            r.at = _;
            function W(a, n, c) {
                return n === void 0 && (n = 0), c === void 0 && (c = 1 / 0), n === 0 && c === 1 ? new G(E(a)) : new I(E(a), n, c);
            }
            r.quantified = W;
            function ce(a) {
                return W(a).setType("zeroOrMore");
            }
            r.zeroOrMore = ce;
            function le(a) {
                return W(a, 1).setType("oneOrMore");
            }
            r.oneOrMore = le;
            function ee(a) {
                return W(a, 0, 1).setType("optional");
            }
            r.opt = ee;
            function he(a, n) {
                return W(a, n, n).setType("repeat");
            }
            r.repeat = he;
            function P(a) {
                return new D(a);
            }
            r.atChar = P;
            function ue(a) {
                return P(a).not;
            }
            r.notAtChar = ue;
            function de(a) {
                return P(a).advance;
            }
            r.char = de;
            function te(a) {
                return ue(a).advance;
            }
            r.notChar = te;
            function A(a, n) {
                return new U(a, n);
            }
            r.atRange = A;
            function pe(a, n) {
                return A(a, n).advance;
            }
            r.range = pe;
            function Ee(a, n) {
                return pe(a, n).not;
            }
            r.notRange = Ee;
            function ge(a, n) {
                return ee(y(a, y(n, a).zeroOrMore)).setType("delimitedList");
            }
            r.delimited = ge;
            function re(a, n) {
                return y(N(n), a).setType("unless");
            }
            r.unless = re;
            function q(a, n) {
                return re(a, n).zeroOrMore.setType("repeatWhileNot");
            }
            r.repeatWhileNot = q;
            function fe(a, n) {
                return N(n).then(a).then(q(a, n)).setType("repeatOneOrMoreWhileNot");
            }
            r.repeatOneOrMoreWhileNot = fe;
            function Z(a, n) {
                return q(a, n).then(n).setType("repeatUntilPast");
            }
            r.repeatUntilPast = Z;
            function me(a, n) {
                return N(n).then(a).then(Z(a, n)).setType("repeatOneOrMoreUntilPast");
            }
            r.repeatOneOrMoreUntilPast = me;
            function Le(a) {
                return q(r.advance, a).setType("advanceWhileNot");
            }
            r.advanceWhileNot = Le;
            function Ke(a) {
                return fe(r.advance, a).setType("advanceOneOrMoreWhileNot");
            }
            r.advanceOneOrMoreWhileNot = Ke;
            function Me(a) {
                return Z(r.advance, a).setType("advanceUntilPast");
            }
            r.advanceUntilPast = Me;
            function Ie(a) {
                return me(r.advance, a).setType("advanceOneOrMoreUntilPast");
            }
            r.advanceOneOrMoreUntilPast = Ie;
            function Ve(a) {
                return r.advance.unless(a).setType("advanceUnless");
            }
            r.advanceUnless = Ve;
            function Te(a) {
                return new V(a);
            }
            r.predicate = Te;
            function ie(a) {
                return Te(function(n) {
                    return a(n), !0;
                }).setType("action");
            }
            r.action = ie;
            function Re(a) {
                return a === void 0 && (a = ""), ie(function(n) {
                    console.log(a);
                }).setType("log");
            }
            r.log = Re;
            function be(a) {
                return ie(function(n) {
                    var c = new s(a + `
` + n.location.toString());
                    throw c;
                }).setType("err");
            }
            r.err = be;
            function F(a) {
                return b(a, be("Expected: " + E(a)));
            }
            r.assert = F;
            function M(a) {
                for(var n = [], c = 1; c < arguments.length; c++)n[c - 1] = arguments[c];
                return y(a, y.apply(void 0, n.map(function(u) {
                    return F(u);
                }))).setType("guardedSeq");
            }
            r.guardedSeq = M;
            function xe(a) {
                return M('"', a, F('"')).setType("doubleQuoted");
            }
            r.doubleQuoted = xe;
            function We(a) {
                return xe(b(a, te('"').zeroOrMore)).setType("doubleQuotedString");
            }
            r.doubleQuotedString = We;
            function ve(a) {
                return M("'", a, F("'")).setType("singleQuoted");
            }
            r.singleQuoted = ve;
            function ze(a) {
                return ve(b(a, te("'").zeroOrMore)).setType("singleQuotedString");
            }
            r.singleQuotedString = ze;
            function De(a) {
                return M("(", r.ws, a, r.ws, ")").setType("parenthesized");
            }
            r.parenthesized = De;
            function Ue(a) {
                return M("{", r.ws, a, r.ws, "}").setType("braced");
            }
            r.braced = Ue;
            function qe(a) {
                return M("[", r.ws, a, r.ws, "]").setType("bracketed");
            }
            r.bracketed = qe;
            function Fe(a) {
                return M("<", r.ws, a, r.ws, ">").setType("tagged");
            }
            r.tagged = Fe;
            function ye(a) {
                return y(a, N(r.identifierNext)).setType("keyword");
            }
            r.keyword = ye;
            function Qe(a) {
                return y(oe(a), N(r.identifierNext)).setType("keywordAnyCase");
            }
            r.keywordAnyCase = Qe;
            function Ge() {
                for(var a = [], n = 0; n < arguments.length; n++)a[n - 0] = arguments[n];
                return b.apply(void 0, a.map(ye));
            }
            r.keywords = Ge, r.truePredicate = new V(function(a) {
                return !0;
            }), r.falsePredicate = new V(function(a) {
                return !1;
            }), r.end = new V(function(a) {
                return a.index >= a.length;
            }), r.notEnd = new V(function(a) {
                return a.index < a.length;
            }), r.advance = new z(), r.all = r.advance.zeroOrMore, r.atLetterLower = A("a", "z"), r.atLetterUpper = A("A", "Z"), r.atLetter = b(r.atLetterLower, r.atLetterUpper), r.atDigit = A("0", "9"), r.atDigitNonZero = A("1", "9"), r.atHexDigit = b(r.atDigit, A("a", "f"), A("A", "F")), r.atBinaryDigit = P("01"), r.atOctalDigit = A("0", "7"), r.atAlphaNumeric = b(r.atLetter, r.atDigit), r.atUnderscore = P("_"), r.atSpace = P(" "), r.atTab = P("	"), r.atWs = P(` 	\r
\xa0\uFEFF`), r.atIdentifierNext = b(r.atAlphaNumeric, r.atUnderscore), r.letterLower = r.atLetterLower.advance, r.letterUpper = r.atLetterUpper.advance, r.letter = r.atLetter.advance, r.letters = r.letter.oneOrMore, r.digit = r.atDigit.advance, r.digitNonZero = r.atDigitNonZero.advance, r.digits = r.digit.oneOrMore, r.integer = de("0").or(r.digits), r.hexDigit = r.atHexDigit.advance, r.binaryDigit = r.atBinaryDigit.advance, r.octalDigit = r.atOctalDigit.advance, r.alphaNumeric = r.atAlphaNumeric.advance, r.underscore = r.atUnderscore.advance, r.identifierFirst = b(r.atLetter, r.atUnderscore).advance, r.identifierNext = b(r.atAlphaNumeric, r.atUnderscore).advance, r.identifier = y(r.identifierFirst, r.identifierNext.zeroOrMore), r.hyphen = R("-"), r.crlf = R(`\r
`), r.newLine = b(r.crlf, `
`), r.space = R(" "), r.tab = R("	"), r.ws = r.atWs.advance.zeroOrMore;
            function Be(a, n) {
                var c = this.parse(a.ast.zeroOrMore, n);
                return c ? c.children : [];
            }
            r.tokenize = Be;
            function Se(a, n) {
                var c = new l(n, 0, []);
                return a instanceof k || (a = a.ast), a.parser(c) && c && c.nodes ? c.nodes[0] : null;
            }
            r.parse = Se;
            function ke(a) {
                return ae(a).filter(function(n) {
                    return n._createAstNode;
                });
            }
            r.grammarAstRules = ke;
            function ae(a) {
                return Ae().filter(function(n) {
                    return n.grammarName == a;
                });
            }
            r.grammarRules = ae;
            function Ae() {
                return Object.keys(r.allRules).sort().map(function(a) {
                    return r.allRules[a];
                });
            }
            r.allGrammarRules = Ae;
            function Xe() {
                return Object.keys(r.grammars).sort();
            }
            r.grammarNames = Xe;
            function Je(a) {
                return ae(a).map(function(n) {
                    return n.fullName + " <- " + n.definition;
                }).join(`
`);
            }
            r.grammarToString = Je;
            function $e(a) {
                return ke(a).map(function(n) {
                    return n.name + " <- " + n.astRuleDefn();
                }).join(`
`);
            }
            r.astSchemaToString = $e;
            function Oe(a, n, c) {
                for(var u in n)if (n[u] instanceof f) {
                    var h = n[u];
                    h.setName(a, u), r.allRules[h.fullName] = h;
                }
                return r.grammars[a] = n, c && (r.parsers[a] = function(p) {
                    return Se(c, p);
                }), n;
            }
            r.registerGrammar = Oe;
            function Y(a) {
                var n = JSON.stringify(a);
                return n.slice(1, n.length - 1);
            }
            r.escapeChars = Y;
            function E(a) {
                if (a instanceof f) return a;
                if (typeof a == "string") return R(a);
                if (typeof a == "boolean") return a ? r.truePredicate : r.falsePredicate;
                throw new Error("Invalid rule type: " + a);
            }
            r.RuleTypeToRule = E;
            function ne(a, n, c) {
                if (!a) throw new Error("Error occured while parsing rule: " + n.fullName + " " + (c || ""));
            }
            r.debugAssert = ne, Oe("core", r, null);
        })(i = e.Myna || (e.Myna = {})), m.exports && (m.exports = i, m.exports.Myna = i);
    }($b0c9077b7a60729e$var$Q, $b0c9077b7a60729e$var$Q.exports)), $b0c9077b7a60729e$var$Q.exports;
}
var $b0c9077b7a60729e$var$nt = $b0c9077b7a60729e$var$at();
function $b0c9077b7a60729e$var$st(m) {
    const e = m;
    e.parenthesized = (i)=>e.seq("(", e.ws, i, e.ws, ")").setType("parenthesized");
    const t = new function() {
        const i = "[]()", r = "[]()*~`@#\\_!+-", s = e.char(" 	").oneOrMore;
        s.opt, s.or(e.newLine);
        const o = e.notChar(r).unless(e.newLine), l = e.notChar(i).unless(e.newLine);
        e.notChar('"'), this.xsdToken = e.choice(e.digits, e.letters, e.char(r)).oneOrMore.ast, this.plainText = e.choice(e.digits, e.letters, s, o).oneOrMore.ast, this.plainTextEmphasis = e.choice(e.digits, e.letters, s, o).oneOrMore.ast;
        const d = e.choice(e.digits, e.letters, s, l);
        this.plainTextModifier = d.oneOrMore.ast, this.plainTextPhone = e.seq(e.parenthesized(e.digits), d.oneOrMore).ast, this.plainTextSpecialChars = e.choice(e.seq("(", d, ") "), e.seq("[", d, "] "), e.choice(...r.split("")).oneOrMore).oneOrMore.ast, this.urlSpecialChar = e.char(":/.-_~?#[]@!+,;%=()&"), this.url = e.choice(e.digit, e.letter, this.urlSpecialChar).oneOrMore.ast, this.audio = e.seq("![", e.choice(e.singleQuoted(this.url), e.doubleQuoted(this.url)), "]").ast, this.timeUnit = e.choice("s", "ms").ast, this.fraction = e.seq(".", e.digit.zeroOrMore), this.number = e.seq(e.integer, this.fraction.opt).ast, this.time = e.seq(this.number, this.timeUnit).ast, this.shortBreak = e.seq("[", this.time, "]").ast, this.silenceTypeValue = e.choice("Leading", "Tailing", "Sentenceboundary").ast, this.silenceData = e.seq(this.silenceTypeValue, " ", this.time).ast, this.silence = e.seq("[", "silence", ":", e.choice(e.singleQuoted(this.silenceData), e.doubleQuoted(this.silenceData)), "]").ast, this.backgroundData = e.seq(" ", this.url), this.backgroundAudio = e.seq("[", "backgroundaudio", ":", e.choice(e.singleQuoted(e.seq(this.url, this.backgroundData.zeroOrMore).ast), e.doubleQuoted(e.seq(this.url, this.backgroundData.zeroOrMore).ast)), "]").ast, this.lexicon = e.seq("[", "lexicon", ":", e.choice(e.singleQuoted(this.url), e.doubleQuoted(this.url)), "]").ast, this.bookmarkChar = e.char(".-_"), this.bookmarkString = e.choice(e.digit, e.letter, this.bookmarkChar).oneOrMore.ast, this.bookmark = e.seq("[", "bookmark", ":", e.choice(e.singleQuoted(this.bookmarkString), e.doubleQuoted(this.bookmarkString)), "]").ast;
        const f = e.not(e.letters);
        this.shortEmphasisModerate = e.seq(f, "+", this.plainTextEmphasis, "+", f).ast, this.shortEmphasisStrong = e.seq(f, "++", this.plainTextEmphasis, "++", f).ast, this.shortEmphasisNone = e.seq(f, "~", this.plainTextEmphasis, "~", f).ast, this.shortEmphasisReduced = e.seq(f, "-", this.plainTextEmphasis, "-", f).ast, this.emphasis = e.choice(this.shortEmphasisModerate, this.shortEmphasisStrong, this.shortEmphasisNone, this.shortEmphasisReduced);
        const k = e.char(":").ws, v = e.char(";").ws;
        this.textModifierKey = e.keywords("emphasis", "address", "number", "cardinal", "characters", "chars", "digits", "drc", "expletive", "bleep", "fraction", "interjection", "ordinal", "telephone", "phone", "unit", "time", "date", "whisper", "ipa", "sapi", "ups", "sub", "vol", "volume", "rate", "pitch", "contour", "range", "timbre", "lang", "voice", "excited", "disappointed", "emotion", "paragraph", "sentence").ast;
        const C = [
            // Plosive
            "p",
            "b",
            "t",
            "d",
            "\u0288",
            "\u0256",
            "c",
            "\u025F",
            "k",
            "\u0261",
            "g",
            "q",
            "\u0262",
            "\u0294",
            // Nasal
            "m",
            "\u0271",
            "n",
            "\u0273",
            "\u0272",
            "\u014B",
            "\u0274",
            // Trill
            "\u0299",
            "r",
            "\u0280",
            // Tap or Flap
            "\u2C71",
            "\u027E",
            "\u027D",
            // Fricative
            "\u0278",
            "\u03B2",
            "f",
            "v",
            "\u03B8",
            "\xf0",
            "s",
            "z",
            "\u0283",
            "\u0292",
            "\u0282",
            "\u0290",
            "\xe7",
            "\u029D",
            "x",
            "\u0263",
            "\u03C7",
            "\u0281",
            "\u0127",
            "\u0295",
            "h",
            "\u0266",
            // Lateral fricative
            "\u026C",
            "\u026E",
            // Approximant
            "\u028B",
            "\u0279",
            "\u027B",
            "j",
            "\u0270",
            // Lateral approximant
            "l",
            "\u026D",
            "\u028E",
            "\u029F"
        ], I = [
            // Clicks
            "\u0298",
            "\u01C0",
            "\u01C3",
            "\u01C2",
            "\u01C1",
            // Voiced implosive
            "\u0253",
            "\u0257",
            "\u0284",
            "\u0260",
            "\u029B",
            // Ejectives (already existing chars + unicode char \u02BC)
            "\u02BC"
        ], G = [
            // Close
            "i",
            "y",
            "\u0268",
            "\u0289",
            "\u026F",
            "u",
            "\u026A",
            "\u028F",
            "\u028A",
            // Close-mid
            "e",
            "\xf8",
            "\u0258",
            "\u025A",
            "\u0275",
            "\u0264",
            "o",
            "\u0259",
            // Open-mid
            "\u025B",
            "\u0153",
            "\u025C",
            "\u025D",
            "\u025E",
            "\u028C",
            "\u0254",
            "\xe6",
            "\u0250",
            // Open
            "a",
            "\u0276",
            "\u0251",
            "\u0252"
        ], z = [
            "\u028D",
            "w",
            "\u0265",
            "\u029C",
            "\u02A2",
            "\u02A1",
            "\u0255",
            "\u0291",
            "\u027A",
            "\u0267",
            "\u0361",
            // char ͡
            "\u035C"
        ], K = [
            "\u0325",
            // char ̥
            "\u030A",
            // char ̊
            "\u032C",
            // char ̬
            "\u02B0",
            "\u0339",
            // char ̹
            "\u031C",
            // char ̜
            "\u031F",
            // char ̟
            "\u0320",
            // char ̠
            "\u0308",
            // char ̈
            "\u033D",
            // char ̽
            "\u0329",
            // char ̩
            "\u032F",
            // char ̯
            "\u02DE",
            // char ˞
            "\u0324",
            // char ̤
            "\u0330",
            // char ̰
            "\u033C",
            // char ̼
            "\u02B7",
            "\u02B2",
            "\u02E0",
            "\u02E4",
            "\u0334",
            // char ̴
            "\u031D",
            // char ̝
            "\u031E",
            // char ̞
            "\u0318",
            // char ̘
            "\u0319",
            // char ̙
            "\u032A",
            // char ̪
            "\u033A",
            // char ̺
            "\u033B",
            // char ̻
            "\u0303",
            //char ̃
            "\u207F",
            "\u02E1",
            "\u031A"
        ], B = [
            "\u02C8",
            "\u02CC",
            "\u02D0",
            "\u02D1",
            "\u0306",
            // char ̆
            "|",
            "\u2016",
            ".",
            "\u203F"
        ], X = [
            "\u030B",
            "\u0301",
            "\u0304",
            "\u0300",
            "\u030F",
            "\u2193",
            "\u2191",
            "\u2197",
            "\u2198",
            "\u030C",
            "\u0302"
        ], J = [
            "\xe0",
            "\xe8",
            "\xec",
            "\xf2",
            "\xf9",
            "\xc0",
            "\xc8",
            "\xcc",
            "\xd2",
            "\xd9",
            "\xe1",
            "\xe9",
            "\xed",
            "\xf3",
            "\xfa",
            "\xfd",
            "\xc1",
            "\xc9",
            "\xcd",
            "\xd3",
            "\xda",
            "\xdd",
            "\xe2",
            "\xea",
            "\xee",
            "\xf4",
            "\xfb",
            "\xc2",
            "\xca",
            "\xce",
            "\xd4",
            "\xdb",
            "\xe4",
            "\xeb",
            "\xef",
            "\xf6",
            "\xfc",
            "\xff",
            "\xc4",
            "\xcb",
            "\xcf",
            "\xd6",
            "\xdc",
            "\u0178",
            "\xe3",
            "\xf1",
            "\xf5",
            "\xc3",
            "\xd1",
            "\xd5",
            "\xe5",
            "\xc5"
        ], j = [
            "\u0269",
            "\u026B",
            "\u0277",
            "\u027C",
            "\u027F",
            "\u0285",
            "\u0286",
            "\u0287",
            "\u0293",
            "\u0296",
            "\u0297",
            "\u029A",
            "\u029E",
            "\u02A0",
            "\u02A3",
            "\u02A4",
            "\u02A5",
            "\u02A6",
            "\u02A7",
            "\u02A8",
            "\u02A9",
            "\u02AA",
            "\u02AB",
            "\u02AC",
            "\u02AD",
            "\u02AE",
            "\u02AF"
        ], D = [
            ...C,
            ...I,
            ...G,
            ...z,
            ...K,
            ...B,
            ...X,
            ...J,
            ...j
        ], U = [
            "+",
            e.hyphen,
            e.digit,
            "%"
        ];
        this.textModifierText = e.choice(e.digit, e.letter, e.hyphen, e.space, ...D, ...U).oneOrMore.ast, this.textModifierTextDoubleQuote = e.choice(e.digit, e.letter, e.hyphen, e.space, ...D, ...U, "'").oneOrMore.ast, this.textModifierValue = e.seq(k, e.choice(e.singleQuoted(this.textModifierText), e.doubleQuoted(this.textModifierTextDoubleQuote))), this.textModifierKeyOptionalValue = e.seq(this.textModifierKey, this.textModifierValue.opt).ast, this.modifier = e.bracketed(e.delimited(this.textModifierKeyOptionalValue.ws, v));
        const $ = e.parenthesized(this.plainTextModifier), H = e.parenthesized(this.plainTextPhone);
        this.textModifier = e.seq(e.choice($, H), this.modifier).ast, this.sectionModifierKey = e.keywords("lang", "voice", "defaults", "dj", "newscaster", "excited", "disappointed").ast, this.sectionModifierText = e.choice(e.digit, e.letter, e.hyphen).oneOrMore.ast, this.sectionModifierValue = e.seq(k, e.choice(e.singleQuoted(this.sectionModifierText), e.doubleQuoted(this.sectionModifierText))), this.sectionModifierKeyOptionalValue = e.seq(this.sectionModifierKey, this.sectionModifierValue.opt).ast, this.sectionModifier = e.bracketed(e.delimited(this.sectionModifierKeyOptionalValue.ws, v)), this.section = e.seq("#", this.sectionModifier).ast, this.valueNone = "none", this.valueXWeak = "x-weak", this.valueWeak = "weak", this.valueMedium = "medium", this.valueStrong = "strong", this.valueXStrong = "x-strong", this.breakStrengthValue = e.keywords(this.valueNone, this.valueXWeak, this.valueWeak, this.valueMedium, this.valueStrong, this.valueXStrong).ast, this.breakValue = e.choice(this.breakStrengthValue, this.time).ast, this.break = e.seq("[", "break", ":", e.choice(e.singleQuoted(this.breakValue), e.doubleQuoted(this.breakValue)), "]").ast, this.markTag = e.seq("[", "mark", ":", e.choice(e.singleQuoted(this.xsdToken), e.doubleQuoted(this.xsdToken)), "]").ast, this.any = e.advance, this.inline = e.choice(this.backgroundAudio, this.lexicon, this.bookmark, this.textModifier, this.emphasis, this.shortBreak, this.silence, this.break, this.audio, this.markTag, this.plainTextSpecialChars, this.plainText, this.any).unless(e.newLine), this.lineEnd = e.newLine.or(e.assert(e.end)).ast, this.emptyLine = e.char(" 	").zeroOrMore.then(e.newLine).ast, this.restOfLine = e.seq(this.inline.zeroOrMore).then(this.lineEnd), this.simpleLine = e.seq(this.emptyLine.not, e.notEnd, this.restOfLine).ast, this.paragraph = this.simpleLine.oneOrMore.ast, this.content = e.choice(this.section, this.paragraph, this.emptyLine), this.document = this.content.zeroOrMore.ast;
    }();
    return e.registerGrammar("speechmarkdown", t, t.document);
}
class $b0c9077b7a60729e$var$ot {
    constructor(){
        this.myna = $b0c9077b7a60729e$var$nt.Myna, $b0c9077b7a60729e$var$st(this.myna), this.parser = this.myna.parsers.speechmarkdown;
    }
    parse(e) {
        return this.parser(e);
    }
}
class $b0c9077b7a60729e$export$fdd03b388331c324 {
    constructor(e){
        this.options = e, this.defaults = {
            includeFormatterComment: !1,
            includeParagraphTag: !1,
            includeSpeakTag: !0,
            platform: "",
            // default - text formatter
            preserveEmptyLines: !0
        }, this.options = {
            ...this.defaults,
            ...e
        };
    }
    get Parser() {
        return this.parser || (this.parser = new $b0c9077b7a60729e$var$ot()), this.parser;
    }
    toText(e, t) {
        const i = {
            ...this.options,
            ...t
        }, r = this.Parser.parse(e);
        return $b0c9077b7a60729e$var$it(i).format(r);
    }
    toSSML(e, t) {
        const i = {
            ...this.options,
            ...t
        };
        let r = e;
        try {
            do {
                const v = this.Parser.parse(r);
                r = $b0c9077b7a60729e$var$rt(i).format(v);
            }while (r.includes(")["));
            let s = "";
            if (r.includes("<mstts:backgroundaudio")) {
                const v = r.indexOf("<mstts:backgroundaudio"), C = r.substring(v).indexOf("/>") + 2;
                s = r.substring(v, C), r = r.replace(s, "");
            }
            let o = "", l = "";
            i.globalVoiceAndLang && i.globalVoiceAndLang.voice && (o = `<voice name="${i.globalVoiceAndLang.voice}">`, l = "</voice>");
            let d = "", f = "";
            return i.globalVoiceAndLang && i.globalVoiceAndLang.lang && (d = `<lang xml:lang="${i.globalVoiceAndLang.lang}">`, f = "</lang>"), `${s + o + d + r + f + l}`;
        } catch (s) {
            return console.log("Error : ", s), r;
        }
    }
    toAST(e) {
        return this.Parser.parse(e);
    }
    toASTString(e) {
        return this.Parser.parse(e).toString();
    }
}

});



parcelRegister("aO9lO", function(module, exports) {

$parcel$export(module.exports, "processAttachments", () => $b28b755f574eb674$export$4a92a69e5bfa5f9a);

var $bAYAG = parcelRequire("bAYAG");

var $dHUeX = parcelRequire("dHUeX");
const $b28b755f574eb674$export$4a92a69e5bfa5f9a = (attachments)=>{
    if (attachments && attachments.length > 0) {
        let tempAttachments = [];
        attachments.forEach((attachment)=>{
            if (attachment.contentType === (0, $dHUeX.CONTENT_TYPE_HERO_CARD)) {
                const heroToAdaptive = (0, $bAYAG.buildCard)({
                    ...attachment.content
                });
                tempAttachments = [
                    ...tempAttachments,
                    {
                        ...heroToAdaptive
                    }
                ];
            } else tempAttachments = [
                ...tempAttachments,
                {
                    ...attachment
                }
            ];
        });
        return tempAttachments;
    }
    return undefined;
};

});
parcelRegister("bAYAG", function(module, exports) {

$parcel$export(module.exports, "buildCard", () => $69baea6726a319e4$export$52053c22b954067e);

var $dHUeX = parcelRequire("dHUeX");

var $3Gcj3 = parcelRequire("3Gcj3");
const $69baea6726a319e4$var$addTextBlock = (text, type)=>{
    const textBlock = {
        type: 'TextBlock',
        text: text,
        size: undefined,
        horizontalAlignment: undefined,
        wrap: true,
        maxLines: undefined
    };
    switch(type){
        case 'title':
            textBlock.size = 'large';
            break;
        case 'subtitle':
            textBlock.size = 'medium';
            break;
        case 'text':
        default:
            break;
    }
    return textBlock;
};
const $69baea6726a319e4$var$addImage = (data)=>{
    const image = {
        type: 'Image',
        url: '',
        size: 'Large',
        altText: undefined,
        selectAction: undefined,
        horizontalAlignment: 'Center'
    };
    image.url = data.url;
    image.altText = data.alt || 'image';
    image.selectAction = data.tap && $69baea6726a319e4$var$addAction(data.tap);
    return {
        ...image
    };
};
const $69baea6726a319e4$var$addAction = (cardAction, includesOAuthButtons)=>{
    const action = {
        type: 'Action.Submit',
        title: undefined,
        url: undefined,
        data: undefined,
        fullWidth: undefined,
        position: undefined,
        display: undefined
    };
    for(const val in cardAction)if (cardAction[val] && typeof cardAction[val] === 'string') cardAction[val] = (0, $3Gcj3.getTextWithoutSpeechMarkdown)(cardAction[val]);
    if (cardAction.type === 'imBack' || cardAction.type === 'messageBack' || cardAction.type === 'postBack' || cardAction.type === 'signin' && includesOAuthButtons) {
        action.type = 'Action.Submit';
        action.data = cardAction.value || cardAction.title || null;
        action.title = cardAction.title || '';
    } else {
        action.type = 'Action.OpenUrl';
        action.title = cardAction.title || '';
        action.url = cardAction.type === 'call' ? `tel:${cardAction.value}` : cardAction.value;
    }
    const channelData = cardAction.channelData;
    if (channelData) {
        action.fullWidth = channelData.fullWidth;
        action.position = channelData.position;
        action.display = channelData.display;
    }
    return {
        ...action
    };
};
const $69baea6726a319e4$export$52053c22b954067e = (content)=>{
    const adaptiveCard = {
        contentType: (0, $dHUeX.CONTENT_TYPE_ADAPTIVE_CARD),
        content: {
            type: 'AdaptiveCard',
            $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
            version: '1.5',
            body: [],
            text: undefined,
            speak: undefined,
            selectAction: undefined
        }
    };
    // Add texts first in order : title - subtitle - text
    let cardTexts = [];
    if (content.title) {
        const ti = $69baea6726a319e4$var$addTextBlock(content.title, 'title');
        cardTexts = [
            ...cardTexts,
            {
                ...ti
            }
        ];
    }
    if (content.subtitle) {
        const st = $69baea6726a319e4$var$addTextBlock(content.subtitle, 'subtitle');
        cardTexts = [
            ...cardTexts,
            {
                ...st
            }
        ];
    }
    if (content.text) {
        const txt = $69baea6726a319e4$var$addTextBlock(content.text, 'text');
        cardTexts = [
            ...cardTexts,
            {
                ...txt
            }
        ];
        adaptiveCard.content.text = content.text;
    }
    // Set speak data so that the card is taken in account in the renderer
    if (content.speak || content.text) adaptiveCard.content.speak = content.speak || content.text;
    // Set body as Container with empty items
    adaptiveCard.content.body = [
        {
            type: 'Container',
            items: []
        }
    ];
    // Add texts to items is there are some
    cardTexts.length > 0 && (adaptiveCard.content.body[0].items = [
        ...cardTexts
    ]);
    // Add Images if there are some
    let images = [];
    content.images && content.images.forEach((heroImage)=>{
        const image = $69baea6726a319e4$var$addImage(heroImage);
        images = [
            ...images,
            {
                ...image
            }
        ];
    });
    images.length > 0 && (adaptiveCard.content.body[0].items = [
        ...adaptiveCard.content.body[0].items,
        ...images
    ]);
    // Add actions if there are some
    let actions = [];
    content.buttons && content.buttons.forEach((button)=>{
        const action = $69baea6726a319e4$var$addAction(button);
        actions = [
            ...actions,
            {
                ...action
            }
        ];
    });
    if (actions.length > 0) {
        const actionSet = {
            type: 'ActionSet',
            actions: [
                ...actions
            ]
        };
        adaptiveCard.content.body[0].items = [
            ...adaptiveCard.content.body[0].items,
            {
                ...actionSet
            }
        ];
    }
    // Tap action
    if (content.tap) {
        const tapAction = $69baea6726a319e4$var$addAction(content.tap);
        adaptiveCard.content.selectAction = {
            ...tapAction
        };
    }
    return {
        ...adaptiveCard
    };
};

});


parcelRegister("8K60s", function(module, exports) {

$parcel$export(module.exports, "createAttachmentsFromMultiLink", () => $838f1182792ad509$export$bd1cb79b05472e01);
$parcel$export(module.exports, "default", () => $838f1182792ad509$export$2e2bcd8739ae039);

var $7QU6k = parcelRequire("7QU6k");

var $dHUeX = parcelRequire("dHUeX");
const $838f1182792ad509$var$createLinkAttachmentCard = async ({ url: url, title: title, download: download })=>{
    const qrcode = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
    const hasTitle = title && !title.includes('pause0x0') && !title.includes('pause1x1') && !title.includes('pause2x2');
    return {
        contentType: (0, $dHUeX.CONTENT_TYPE_LINK),
        content: {
            urlData: {
                url: url,
                title: hasTitle ? title : undefined,
                download: download
            },
            qrCode: qrcode
        }
    };
};
const $838f1182792ad509$export$bd1cb79b05472e01 = async (urlDataArray)=>{
    const splitAttachments = [];
    for (const data of urlDataArray){
        const qrcode = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(data.url);
        const newLinkAttachment = {
            contentType: (0, $dHUeX.CONTENT_TYPE_LINK),
            content: {
                urlData: {
                    url: data.url,
                    title: data.title,
                    download: data.download
                },
                qrCode: qrcode
            }
        };
        splitAttachments.push(newLinkAttachment);
    }
    return splitAttachments;
};
var $838f1182792ad509$export$2e2bcd8739ae039 = $838f1182792ad509$var$createLinkAttachmentCard;

});
parcelRegister("7QU6k", function(module, exports) {

$parcel$export(module.exports, "create", () => $5b78e83ec8a66d05$export$185802fd694ee1f5, (v) => $5b78e83ec8a66d05$export$185802fd694ee1f5 = v);
$parcel$export(module.exports, "toCanvas", () => $5b78e83ec8a66d05$export$f87f6982d1fd4f81, (v) => $5b78e83ec8a66d05$export$f87f6982d1fd4f81 = v);
$parcel$export(module.exports, "toDataURL", () => $5b78e83ec8a66d05$export$723e4939e5a27c8, (v) => $5b78e83ec8a66d05$export$723e4939e5a27c8 = v);
$parcel$export(module.exports, "toString", () => $5b78e83ec8a66d05$export$f84e8e69fd4488a5, (v) => $5b78e83ec8a66d05$export$f84e8e69fd4488a5 = v);
var $5b78e83ec8a66d05$export$185802fd694ee1f5;
var $5b78e83ec8a66d05$export$f87f6982d1fd4f81;
var $5b78e83ec8a66d05$export$723e4939e5a27c8;
// only svg for now.
var $5b78e83ec8a66d05$export$f84e8e69fd4488a5;

var $cy5px = parcelRequire("cy5px");

var $gzdAP = parcelRequire("gzdAP");

var $dsm43 = parcelRequire("dsm43");

var $dM4JI = parcelRequire("dM4JI");
function $5b78e83ec8a66d05$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$cy5px()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $gzdAP.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $gzdAP.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$5b78e83ec8a66d05$export$185802fd694ee1f5 = $gzdAP.create;
$5b78e83ec8a66d05$export$f87f6982d1fd4f81 = $5b78e83ec8a66d05$var$renderCanvas.bind(null, $dsm43.render);
$5b78e83ec8a66d05$export$723e4939e5a27c8 = $5b78e83ec8a66d05$var$renderCanvas.bind(null, $dsm43.renderToDataURL);
$5b78e83ec8a66d05$export$f84e8e69fd4488a5 = $5b78e83ec8a66d05$var$renderCanvas.bind(null, function(data, _, opts) {
    return $dM4JI.render(data, opts);
});

});
parcelRegister("cy5px", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("gzdAP", function(module, exports) {

$parcel$export(module.exports, "create", () => $c0fa75802c08bb02$export$185802fd694ee1f5, (v) => $c0fa75802c08bb02$export$185802fd694ee1f5 = v);
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $c0fa75802c08bb02$export$185802fd694ee1f5;

var $j98yQ = parcelRequire("j98yQ");

var $k1tT4 = parcelRequire("k1tT4");

var $kRYYq = parcelRequire("kRYYq");

var $2LyZX = parcelRequire("2LyZX");

var $2TF8R = parcelRequire("2TF8R");

var $fapHe = parcelRequire("fapHe");

var $6dakX = parcelRequire("6dakX");

var $eN0fb = parcelRequire("eN0fb");

var $cQAO5 = parcelRequire("cQAO5");

var $gI0LP = parcelRequire("gI0LP");

var $kuXp2 = parcelRequire("kuXp2");

var $1jc42 = parcelRequire("1jc42");

var $ldDeC = parcelRequire("ldDeC");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c0fa75802c08bb02$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $fapHe.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $c0fa75802c08bb02$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c0fa75802c08bb02$var$setupAlignmentPattern(matrix, version) {
    const pos = $2TF8R.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c0fa75802c08bb02$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $gI0LP.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $c0fa75802c08bb02$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $kuXp2.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $c0fa75802c08bb02$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $c0fa75802c08bb02$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $kRYYq();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $1jc42.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $j98yQ.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $eN0fb.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $c0fa75802c08bb02$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $c0fa75802c08bb02$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $j98yQ.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $eN0fb.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $eN0fb.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $cQAO5(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $c0fa75802c08bb02$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $ldDeC.fromArray(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $ldDeC.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $gI0LP.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $ldDeC.fromString(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $gI0LP.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $c0fa75802c08bb02$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $j98yQ.getSymbolSize(version);
    const modules = new $2LyZX(moduleCount);
    // Add function modules
    $c0fa75802c08bb02$var$setupFinderPattern(modules, version);
    $c0fa75802c08bb02$var$setupTimingPattern(modules);
    $c0fa75802c08bb02$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $c0fa75802c08bb02$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $c0fa75802c08bb02$var$setupVersionInfo(modules, version);
    // Add data codewords
    $c0fa75802c08bb02$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $6dakX.getBestMask(modules, $c0fa75802c08bb02$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $6dakX.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $c0fa75802c08bb02$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$c0fa75802c08bb02$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $k1tT4.M;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $k1tT4.from(options.errorCorrectionLevel, $k1tT4.M);
        version = $gI0LP.from(options.version);
        mask = $6dakX.from(options.maskPattern);
        if (options.toSJISFunc) $j98yQ.setToSJISFunction(options.toSJISFunc);
    }
    return $c0fa75802c08bb02$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("j98yQ", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", () => $0398dce59eda23b6$export$8d4a06d3facd414b, (v) => $0398dce59eda23b6$export$8d4a06d3facd414b = v);
$parcel$export(module.exports, "getSymbolTotalCodewords", () => $0398dce59eda23b6$export$b05dac13c7a35c32, (v) => $0398dce59eda23b6$export$b05dac13c7a35c32 = v);
$parcel$export(module.exports, "getBCHDigit", () => $0398dce59eda23b6$export$ed1d66da50968976, (v) => $0398dce59eda23b6$export$ed1d66da50968976 = v);
$parcel$export(module.exports, "setToSJISFunction", () => $0398dce59eda23b6$export$6733b14783f975c2, (v) => $0398dce59eda23b6$export$6733b14783f975c2 = v);
$parcel$export(module.exports, "isKanjiModeEnabled", () => $0398dce59eda23b6$export$ce5b1274f8597fa0, (v) => $0398dce59eda23b6$export$ce5b1274f8597fa0 = v);
$parcel$export(module.exports, "toSJIS", () => $0398dce59eda23b6$export$43dd553ecded716d, (v) => $0398dce59eda23b6$export$43dd553ecded716d = v);
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $0398dce59eda23b6$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $0398dce59eda23b6$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $0398dce59eda23b6$export$ed1d66da50968976;
var $0398dce59eda23b6$export$6733b14783f975c2;
var $0398dce59eda23b6$export$ce5b1274f8597fa0;
var $0398dce59eda23b6$export$43dd553ecded716d;
let $0398dce59eda23b6$var$toSJISFunction;
const $0398dce59eda23b6$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$0398dce59eda23b6$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$0398dce59eda23b6$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $0398dce59eda23b6$var$CODEWORDS_COUNT[version];
};
$0398dce59eda23b6$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$0398dce59eda23b6$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $0398dce59eda23b6$var$toSJISFunction = f;
};
$0398dce59eda23b6$export$ce5b1274f8597fa0 = function() {
    return typeof $0398dce59eda23b6$var$toSJISFunction !== 'undefined';
};
$0398dce59eda23b6$export$43dd553ecded716d = function toSJIS(kanji) {
    return $0398dce59eda23b6$var$toSJISFunction(kanji);
};

});

parcelRegister("k1tT4", function(module, exports) {

$parcel$export(module.exports, "L", () => $e93b159af167de6a$export$61196ced6d74a310, (v) => $e93b159af167de6a$export$61196ced6d74a310 = v);
$parcel$export(module.exports, "M", () => $e93b159af167de6a$export$3a1a48c8f6ef640e, (v) => $e93b159af167de6a$export$3a1a48c8f6ef640e = v);
$parcel$export(module.exports, "Q", () => $e93b159af167de6a$export$3722cfe417b6ed86, (v) => $e93b159af167de6a$export$3722cfe417b6ed86 = v);
$parcel$export(module.exports, "H", () => $e93b159af167de6a$export$7f8ddf7c7c20b3cd, (v) => $e93b159af167de6a$export$7f8ddf7c7c20b3cd = v);
$parcel$export(module.exports, "isValid", () => $e93b159af167de6a$export$1ea939691cdc45b8, (v) => $e93b159af167de6a$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $e93b159af167de6a$export$6788812c4e6611e6, (v) => $e93b159af167de6a$export$6788812c4e6611e6 = v);
var $e93b159af167de6a$export$61196ced6d74a310;
var $e93b159af167de6a$export$3a1a48c8f6ef640e;
var $e93b159af167de6a$export$3722cfe417b6ed86;
var $e93b159af167de6a$export$7f8ddf7c7c20b3cd;
var $e93b159af167de6a$export$1ea939691cdc45b8;
var $e93b159af167de6a$export$6788812c4e6611e6;
$e93b159af167de6a$export$61196ced6d74a310 = {
    bit: 1
};
$e93b159af167de6a$export$3a1a48c8f6ef640e = {
    bit: 0
};
$e93b159af167de6a$export$3722cfe417b6ed86 = {
    bit: 3
};
$e93b159af167de6a$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $e93b159af167de6a$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $e93b159af167de6a$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $e93b159af167de6a$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $e93b159af167de6a$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $e93b159af167de6a$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$e93b159af167de6a$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$e93b159af167de6a$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($e93b159af167de6a$export$1ea939691cdc45b8(value)) return value;
    try {
        return $e93b159af167de6a$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("kRYYq", function(module, exports) {
function $f3180df86c0ceabb$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$f3180df86c0ceabb$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $f3180df86c0ceabb$var$BitBuffer;

});

parcelRegister("2LyZX", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $203b1e7b4160f407$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $203b1e7b4160f407$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $203b1e7b4160f407$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $203b1e7b4160f407$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $203b1e7b4160f407$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $203b1e7b4160f407$var$BitMatrix;

});

parcelRegister("2TF8R", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", () => $21c0a1ba40f38d49$export$cb05537eb8e57a83, (v) => $21c0a1ba40f38d49$export$cb05537eb8e57a83 = v);
$parcel$export(module.exports, "getPositions", () => $21c0a1ba40f38d49$export$c39457c570f2b189, (v) => $21c0a1ba40f38d49$export$c39457c570f2b189 = v);
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $21c0a1ba40f38d49$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $21c0a1ba40f38d49$export$c39457c570f2b189;

var $j98yQ = parcelRequire("j98yQ");
var $21c0a1ba40f38d49$require$getSymbolSize = $j98yQ.getSymbolSize;
$21c0a1ba40f38d49$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $21c0a1ba40f38d49$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$21c0a1ba40f38d49$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $21c0a1ba40f38d49$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("fapHe", function(module, exports) {

$parcel$export(module.exports, "getPositions", () => $b0abb8eaf11da0d6$export$c39457c570f2b189, (v) => $b0abb8eaf11da0d6$export$c39457c570f2b189 = v);
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b0abb8eaf11da0d6$export$c39457c570f2b189;

var $j98yQ = parcelRequire("j98yQ");
var $b0abb8eaf11da0d6$require$getSymbolSize = $j98yQ.getSymbolSize;
const $b0abb8eaf11da0d6$var$FINDER_PATTERN_SIZE = 7;
$b0abb8eaf11da0d6$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b0abb8eaf11da0d6$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b0abb8eaf11da0d6$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b0abb8eaf11da0d6$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("6dakX", function(module, exports) {

$parcel$export(module.exports, "Patterns", () => $485bf9b125816a96$export$7ed115685df827af, (v) => $485bf9b125816a96$export$7ed115685df827af = v);
$parcel$export(module.exports, "isValid", () => $485bf9b125816a96$export$1ea939691cdc45b8, (v) => $485bf9b125816a96$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $485bf9b125816a96$export$6788812c4e6611e6, (v) => $485bf9b125816a96$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getPenaltyN1", () => $485bf9b125816a96$export$a5fd3a02c14d0b3e, (v) => $485bf9b125816a96$export$a5fd3a02c14d0b3e = v);
$parcel$export(module.exports, "getPenaltyN2", () => $485bf9b125816a96$export$9a9385107a518e46, (v) => $485bf9b125816a96$export$9a9385107a518e46 = v);
$parcel$export(module.exports, "getPenaltyN3", () => $485bf9b125816a96$export$ade754353f0dc75e, (v) => $485bf9b125816a96$export$ade754353f0dc75e = v);
$parcel$export(module.exports, "getPenaltyN4", () => $485bf9b125816a96$export$3ff6f04d40d9962b, (v) => $485bf9b125816a96$export$3ff6f04d40d9962b = v);
$parcel$export(module.exports, "applyMask", () => $485bf9b125816a96$export$a1c9aa9c0e8ba394, (v) => $485bf9b125816a96$export$a1c9aa9c0e8ba394 = v);
$parcel$export(module.exports, "getBestMask", () => $485bf9b125816a96$export$fe9625aaceb0e563, (v) => $485bf9b125816a96$export$fe9625aaceb0e563 = v);
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $485bf9b125816a96$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $485bf9b125816a96$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $485bf9b125816a96$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $485bf9b125816a96$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $485bf9b125816a96$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $485bf9b125816a96$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $485bf9b125816a96$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $485bf9b125816a96$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $485bf9b125816a96$export$fe9625aaceb0e563;
$485bf9b125816a96$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $485bf9b125816a96$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$485bf9b125816a96$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$485bf9b125816a96$export$6788812c4e6611e6 = function from(value) {
    return $485bf9b125816a96$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$485bf9b125816a96$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $485bf9b125816a96$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$485bf9b125816a96$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $485bf9b125816a96$var$PenaltyScores.N2;
};
$485bf9b125816a96$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $485bf9b125816a96$var$PenaltyScores.N3;
};
$485bf9b125816a96$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $485bf9b125816a96$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $485bf9b125816a96$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $485bf9b125816a96$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$485bf9b125816a96$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $485bf9b125816a96$var$getMaskAt(pattern, row, col));
    }
};
$485bf9b125816a96$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($485bf9b125816a96$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $485bf9b125816a96$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $485bf9b125816a96$export$a5fd3a02c14d0b3e(data) + $485bf9b125816a96$export$9a9385107a518e46(data) + $485bf9b125816a96$export$ade754353f0dc75e(data) + $485bf9b125816a96$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $485bf9b125816a96$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("eN0fb", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", () => $ac45d4b63c43eb6c$export$41a1fc627aca72b9, (v) => $ac45d4b63c43eb6c$export$41a1fc627aca72b9 = v);
$parcel$export(module.exports, "getTotalCodewordsCount", () => $ac45d4b63c43eb6c$export$683d1b3e8a1a8438, (v) => $ac45d4b63c43eb6c$export$683d1b3e8a1a8438 = v);
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $ac45d4b63c43eb6c$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $ac45d4b63c43eb6c$export$683d1b3e8a1a8438;

var $k1tT4 = parcelRequire("k1tT4");
const $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$ac45d4b63c43eb6c$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $k1tT4.L:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $k1tT4.M:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $k1tT4.Q:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $k1tT4.H:
            return $ac45d4b63c43eb6c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$ac45d4b63c43eb6c$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $k1tT4.L:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $k1tT4.M:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $k1tT4.Q:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $k1tT4.H:
            return $ac45d4b63c43eb6c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("cQAO5", function(module, exports) {

var $fVqx4 = parcelRequire("fVqx4");
function $95a6e47109151cdc$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $95a6e47109151cdc$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $fVqx4.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $95a6e47109151cdc$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $fVqx4.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $95a6e47109151cdc$var$ReedSolomonEncoder;

});
parcelRegister("fVqx4", function(module, exports) {

$parcel$export(module.exports, "mul", () => $b980c2a582814d02$export$6e3a27864ab166fe, (v) => $b980c2a582814d02$export$6e3a27864ab166fe = v);
$parcel$export(module.exports, "mod", () => $b980c2a582814d02$export$842a2cf37af977e1, (v) => $b980c2a582814d02$export$842a2cf37af977e1 = v);
$parcel$export(module.exports, "generateECPolynomial", () => $b980c2a582814d02$export$7b8be06a973a9d05, (v) => $b980c2a582814d02$export$7b8be06a973a9d05 = v);
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $b980c2a582814d02$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $b980c2a582814d02$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $b980c2a582814d02$export$7b8be06a973a9d05;

var $9cX2v = parcelRequire("9cX2v");
$b980c2a582814d02$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $9cX2v.mul(p1[i], p2[j]);
    return coeff;
};
$b980c2a582814d02$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $9cX2v.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$b980c2a582814d02$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $b980c2a582814d02$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $9cX2v.exp(i)
    ]));
    return poly;
};

});
parcelRegister("9cX2v", function(module, exports) {

$parcel$export(module.exports, "exp", () => $6b43080ac02a0ec4$export$b310ec824aaee37f, (v) => $6b43080ac02a0ec4$export$b310ec824aaee37f = v);
$parcel$export(module.exports, "mul", () => $6b43080ac02a0ec4$export$6e3a27864ab166fe, (v) => $6b43080ac02a0ec4$export$6e3a27864ab166fe = v);
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $6b43080ac02a0ec4$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $6b43080ac02a0ec4$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $6b43080ac02a0ec4$export$6e3a27864ab166fe;
const $6b43080ac02a0ec4$var$EXP_TABLE = new Uint8Array(512);
const $6b43080ac02a0ec4$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $6b43080ac02a0ec4$var$EXP_TABLE[i] = x;
        $6b43080ac02a0ec4$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$6b43080ac02a0ec4$var$EXP_TABLE[i] = $6b43080ac02a0ec4$var$EXP_TABLE[i - 255];
})();
$6b43080ac02a0ec4$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $6b43080ac02a0ec4$var$LOG_TABLE[n];
};
$6b43080ac02a0ec4$export$b310ec824aaee37f = function exp(n) {
    return $6b43080ac02a0ec4$var$EXP_TABLE[n];
};
$6b43080ac02a0ec4$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $6b43080ac02a0ec4$var$EXP_TABLE[$6b43080ac02a0ec4$var$LOG_TABLE[x] + $6b43080ac02a0ec4$var$LOG_TABLE[y]];
};

});



parcelRegister("gI0LP", function(module, exports) {

$parcel$export(module.exports, "getCapacity", () => $c2a15a5f7cdacb92$export$55b283886ec2d3fb, (v) => $c2a15a5f7cdacb92$export$55b283886ec2d3fb = v);
$parcel$export(module.exports, "from", () => $c2a15a5f7cdacb92$export$6788812c4e6611e6, (v) => $c2a15a5f7cdacb92$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getBestVersionForData", () => $c2a15a5f7cdacb92$export$264e969aa7a8ff7e, (v) => $c2a15a5f7cdacb92$export$264e969aa7a8ff7e = v);
$parcel$export(module.exports, "getEncodedBits", () => $c2a15a5f7cdacb92$export$eee5438974ef6f0e, (v) => $c2a15a5f7cdacb92$export$eee5438974ef6f0e = v);
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $c2a15a5f7cdacb92$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $c2a15a5f7cdacb92$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $c2a15a5f7cdacb92$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $c2a15a5f7cdacb92$export$eee5438974ef6f0e;

var $j98yQ = parcelRequire("j98yQ");

var $eN0fb = parcelRequire("eN0fb");

var $k1tT4 = parcelRequire("k1tT4");

var $1jc42 = parcelRequire("1jc42");

var $11n8D = parcelRequire("11n8D");
// Generator polynomial used to encode version information
const $c2a15a5f7cdacb92$var$G18 = 7973;
const $c2a15a5f7cdacb92$var$G18_BCH = $j98yQ.getBCHDigit($c2a15a5f7cdacb92$var$G18);
function $c2a15a5f7cdacb92$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $c2a15a5f7cdacb92$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $c2a15a5f7cdacb92$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $1jc42.getCharCountIndicator(mode, version) + 4;
}
function $c2a15a5f7cdacb92$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $c2a15a5f7cdacb92$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $c2a15a5f7cdacb92$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $c2a15a5f7cdacb92$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $c2a15a5f7cdacb92$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $1jc42.MIXED)) return currentVersion;
    }
    return undefined;
}
$c2a15a5f7cdacb92$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($11n8D.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$c2a15a5f7cdacb92$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$11n8D.isValid(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $1jc42.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $j98yQ.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $eN0fb.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $1jc42.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $c2a15a5f7cdacb92$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $1jc42.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $1jc42.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $1jc42.KANJI:
            return Math.floor(usableBits / 13);
        case $1jc42.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$c2a15a5f7cdacb92$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $k1tT4.from(errorCorrectionLevel, $k1tT4.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $c2a15a5f7cdacb92$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $c2a15a5f7cdacb92$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$c2a15a5f7cdacb92$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$11n8D.isValid(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($j98yQ.getBCHDigit(d) - $c2a15a5f7cdacb92$var$G18_BCH >= 0)d ^= $c2a15a5f7cdacb92$var$G18 << $j98yQ.getBCHDigit(d) - $c2a15a5f7cdacb92$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("1jc42", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", () => $0f40ec75b63781e9$export$4d318981b5a83836, (v) => $0f40ec75b63781e9$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $0f40ec75b63781e9$export$376a9ed239d6c1c8, (v) => $0f40ec75b63781e9$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "BYTE", () => $0f40ec75b63781e9$export$8f4bf8f7eb581284, (v) => $0f40ec75b63781e9$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "KANJI", () => $0f40ec75b63781e9$export$a4d452c2363c8e12, (v) => $0f40ec75b63781e9$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "MIXED", () => $0f40ec75b63781e9$export$bb410559a65d3418, (v) => $0f40ec75b63781e9$export$bb410559a65d3418 = v);
$parcel$export(module.exports, "getCharCountIndicator", () => $0f40ec75b63781e9$export$e79764af6ffaeb8d, (v) => $0f40ec75b63781e9$export$e79764af6ffaeb8d = v);
$parcel$export(module.exports, "getBestModeForData", () => $0f40ec75b63781e9$export$1bd4c93ffb42e55e, (v) => $0f40ec75b63781e9$export$1bd4c93ffb42e55e = v);
$parcel$export(module.exports, "toString", () => $0f40ec75b63781e9$export$f84e8e69fd4488a5, (v) => $0f40ec75b63781e9$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isValid", () => $0f40ec75b63781e9$export$1ea939691cdc45b8, (v) => $0f40ec75b63781e9$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $0f40ec75b63781e9$export$6788812c4e6611e6, (v) => $0f40ec75b63781e9$export$6788812c4e6611e6 = v);
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $0f40ec75b63781e9$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $0f40ec75b63781e9$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $0f40ec75b63781e9$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $0f40ec75b63781e9$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $0f40ec75b63781e9$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $0f40ec75b63781e9$export$6788812c4e6611e6;

var $11n8D = parcelRequire("11n8D");

var $8gKF5 = parcelRequire("8gKF5");
$0f40ec75b63781e9$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$0f40ec75b63781e9$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$0f40ec75b63781e9$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$0f40ec75b63781e9$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$0f40ec75b63781e9$export$bb410559a65d3418 = {
    bit: -1
};
$0f40ec75b63781e9$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$11n8D.isValid(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$0f40ec75b63781e9$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($8gKF5.testNumeric(dataStr)) return $0f40ec75b63781e9$export$4d318981b5a83836;
    else if ($8gKF5.testAlphanumeric(dataStr)) return $0f40ec75b63781e9$export$376a9ed239d6c1c8;
    else if ($8gKF5.testKanji(dataStr)) return $0f40ec75b63781e9$export$a4d452c2363c8e12;
    else return $0f40ec75b63781e9$export$8f4bf8f7eb581284;
};
$0f40ec75b63781e9$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$0f40ec75b63781e9$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $0f40ec75b63781e9$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $0f40ec75b63781e9$export$4d318981b5a83836;
        case 'alphanumeric':
            return $0f40ec75b63781e9$export$376a9ed239d6c1c8;
        case 'kanji':
            return $0f40ec75b63781e9$export$a4d452c2363c8e12;
        case 'byte':
            return $0f40ec75b63781e9$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$0f40ec75b63781e9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0f40ec75b63781e9$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0f40ec75b63781e9$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("11n8D", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $0be7d5325bc34cbb$export$1ea939691cdc45b8, (v) => $0be7d5325bc34cbb$export$1ea939691cdc45b8 = v);
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $0be7d5325bc34cbb$export$1ea939691cdc45b8;
$0be7d5325bc34cbb$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("8gKF5", function(module, exports) {

$parcel$export(module.exports, "KANJI", () => $605403682d036054$export$a4d452c2363c8e12, (v) => $605403682d036054$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "BYTE_KANJI", () => $605403682d036054$export$9df7c29d562bab83, (v) => $605403682d036054$export$9df7c29d562bab83 = v);
$parcel$export(module.exports, "BYTE", () => $605403682d036054$export$8f4bf8f7eb581284, (v) => $605403682d036054$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "NUMERIC", () => $605403682d036054$export$4d318981b5a83836, (v) => $605403682d036054$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $605403682d036054$export$376a9ed239d6c1c8, (v) => $605403682d036054$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "testKanji", () => $605403682d036054$export$175f16aef75a4569, (v) => $605403682d036054$export$175f16aef75a4569 = v);
$parcel$export(module.exports, "testNumeric", () => $605403682d036054$export$50b7f9bf92c74274, (v) => $605403682d036054$export$50b7f9bf92c74274 = v);
$parcel$export(module.exports, "testAlphanumeric", () => $605403682d036054$export$4ba5f52893b4ac97, (v) => $605403682d036054$export$4ba5f52893b4ac97 = v);
var $605403682d036054$export$a4d452c2363c8e12;
var $605403682d036054$export$9df7c29d562bab83;
var $605403682d036054$export$8f4bf8f7eb581284;
var $605403682d036054$export$4d318981b5a83836;
var $605403682d036054$export$376a9ed239d6c1c8;
var $605403682d036054$export$175f16aef75a4569;
var $605403682d036054$export$50b7f9bf92c74274;
var $605403682d036054$export$4ba5f52893b4ac97;
const $605403682d036054$var$numeric = '[0-9]+';
const $605403682d036054$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $605403682d036054$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$605403682d036054$var$kanji = $605403682d036054$var$kanji.replace(/u/g, '\\u');
const $605403682d036054$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $605403682d036054$var$kanji + ')(?:.|[\r\n]))+';
$605403682d036054$export$a4d452c2363c8e12 = new RegExp($605403682d036054$var$kanji, 'g');
$605403682d036054$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$605403682d036054$export$8f4bf8f7eb581284 = new RegExp($605403682d036054$var$byte, 'g');
$605403682d036054$export$4d318981b5a83836 = new RegExp($605403682d036054$var$numeric, 'g');
$605403682d036054$export$376a9ed239d6c1c8 = new RegExp($605403682d036054$var$alphanumeric, 'g');
const $605403682d036054$var$TEST_KANJI = new RegExp('^' + $605403682d036054$var$kanji + '$');
const $605403682d036054$var$TEST_NUMERIC = new RegExp('^' + $605403682d036054$var$numeric + '$');
const $605403682d036054$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$605403682d036054$export$175f16aef75a4569 = function testKanji(str) {
    return $605403682d036054$var$TEST_KANJI.test(str);
};
$605403682d036054$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $605403682d036054$var$TEST_NUMERIC.test(str);
};
$605403682d036054$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $605403682d036054$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("kuXp2", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", () => $eec4b025674c15ee$export$eee5438974ef6f0e, (v) => $eec4b025674c15ee$export$eee5438974ef6f0e = v);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $eec4b025674c15ee$export$eee5438974ef6f0e;

var $j98yQ = parcelRequire("j98yQ");
const $eec4b025674c15ee$var$G15 = 1335;
const $eec4b025674c15ee$var$G15_MASK = 21522;
const $eec4b025674c15ee$var$G15_BCH = $j98yQ.getBCHDigit($eec4b025674c15ee$var$G15);
$eec4b025674c15ee$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($j98yQ.getBCHDigit(d) - $eec4b025674c15ee$var$G15_BCH >= 0)d ^= $eec4b025674c15ee$var$G15 << $j98yQ.getBCHDigit(d) - $eec4b025674c15ee$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $eec4b025674c15ee$var$G15_MASK;
};

});

parcelRegister("ldDeC", function(module, exports) {

$parcel$export(module.exports, "fromArray", () => $f7293f1a856f5fa9$export$571d59b505e6bb4e, (v) => $f7293f1a856f5fa9$export$571d59b505e6bb4e = v);
$parcel$export(module.exports, "fromString", () => $f7293f1a856f5fa9$export$3004f64547af360e, (v) => $f7293f1a856f5fa9$export$3004f64547af360e = v);
$parcel$export(module.exports, "rawSplit", () => $f7293f1a856f5fa9$export$89ab1afb9839589b, (v) => $f7293f1a856f5fa9$export$89ab1afb9839589b = v);
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $f7293f1a856f5fa9$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $f7293f1a856f5fa9$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $f7293f1a856f5fa9$export$89ab1afb9839589b;

var $1jc42 = parcelRequire("1jc42");

var $gEPuf = parcelRequire("gEPuf");

var $cGIMD = parcelRequire("cGIMD");

var $5pKEd = parcelRequire("5pKEd");

var $ayZEe = parcelRequire("ayZEe");

var $8gKF5 = parcelRequire("8gKF5");

var $j98yQ = parcelRequire("j98yQ");

var $2xicJ = parcelRequire("2xicJ");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $f7293f1a856f5fa9$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $f7293f1a856f5fa9$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $f7293f1a856f5fa9$var$getSegmentsFromString(dataStr) {
    const numSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.NUMERIC, $1jc42.NUMERIC, dataStr);
    const alphaNumSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.ALPHANUMERIC, $1jc42.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($j98yQ.isKanjiModeEnabled()) {
        byteSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.BYTE, $1jc42.BYTE, dataStr);
        kanjiSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.KANJI, $1jc42.KANJI, dataStr);
    } else {
        byteSegs = $f7293f1a856f5fa9$var$getSegments($8gKF5.BYTE_KANJI, $1jc42.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $f7293f1a856f5fa9$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $1jc42.NUMERIC:
            return $gEPuf.getBitsLength(length);
        case $1jc42.ALPHANUMERIC:
            return $cGIMD.getBitsLength(length);
        case $1jc42.KANJI:
            return $ayZEe.getBitsLength(length);
        case $1jc42.BYTE:
            return $5pKEd.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $f7293f1a856f5fa9$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $f7293f1a856f5fa9$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $1jc42.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $1jc42.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $1jc42.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $1jc42.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: $f7293f1a856f5fa9$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $1jc42.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $1jc42.BYTE,
                        length: $f7293f1a856f5fa9$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $f7293f1a856f5fa9$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $f7293f1a856f5fa9$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $f7293f1a856f5fa9$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $f7293f1a856f5fa9$var$getSegmentBitsLength(node.length, node.mode) + 4 + $1jc42.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $f7293f1a856f5fa9$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $1jc42.getBestModeForData(data);
    mode = $1jc42.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $1jc42.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $1jc42.toString(mode) + '.\n Suggested mode is: ' + $1jc42.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $1jc42.KANJI && !$j98yQ.isKanjiModeEnabled()) mode = $1jc42.BYTE;
    switch(mode){
        case $1jc42.NUMERIC:
            return new $gEPuf(data);
        case $1jc42.ALPHANUMERIC:
            return new $cGIMD(data);
        case $1jc42.KANJI:
            return new $ayZEe(data);
        case $1jc42.BYTE:
            return new $5pKEd(data);
    }
}
$f7293f1a856f5fa9$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($f7293f1a856f5fa9$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($f7293f1a856f5fa9$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$f7293f1a856f5fa9$export$3004f64547af360e = function fromString(data, version) {
    const segs = $f7293f1a856f5fa9$var$getSegmentsFromString(data, $j98yQ.isKanjiModeEnabled());
    const nodes = $f7293f1a856f5fa9$var$buildNodes(segs);
    const graph = $f7293f1a856f5fa9$var$buildGraph(nodes, version);
    const path = $2xicJ.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $f7293f1a856f5fa9$export$571d59b505e6bb4e($f7293f1a856f5fa9$var$mergeSegments(optimizedSegs));
};
$f7293f1a856f5fa9$export$89ab1afb9839589b = function rawSplit(data) {
    return $f7293f1a856f5fa9$export$571d59b505e6bb4e($f7293f1a856f5fa9$var$getSegmentsFromString(data, $j98yQ.isKanjiModeEnabled()));
};

});
parcelRegister("gEPuf", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");
function $c20851f99b1b9cf4$var$NumericData(data) {
    this.mode = $1jc42.NUMERIC;
    this.data = data.toString();
}
$c20851f99b1b9cf4$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$c20851f99b1b9cf4$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$c20851f99b1b9cf4$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $c20851f99b1b9cf4$var$NumericData.getBitsLength(this.data.length);
};
$c20851f99b1b9cf4$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $c20851f99b1b9cf4$var$NumericData;

});

parcelRegister("cGIMD", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $93cc2552c8ebb01c$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $93cc2552c8ebb01c$var$AlphanumericData(data) {
    this.mode = $1jc42.ALPHANUMERIC;
    this.data = data;
}
$93cc2552c8ebb01c$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$93cc2552c8ebb01c$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$93cc2552c8ebb01c$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $93cc2552c8ebb01c$var$AlphanumericData.getBitsLength(this.data.length);
};
$93cc2552c8ebb01c$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $93cc2552c8ebb01c$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $93cc2552c8ebb01c$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($93cc2552c8ebb01c$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $93cc2552c8ebb01c$var$AlphanumericData;

});

parcelRegister("5pKEd", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");
function $3f1378cabd048ecd$var$ByteData(data) {
    this.mode = $1jc42.BYTE;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$3f1378cabd048ecd$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$3f1378cabd048ecd$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$3f1378cabd048ecd$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $3f1378cabd048ecd$var$ByteData.getBitsLength(this.data.length);
};
$3f1378cabd048ecd$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $3f1378cabd048ecd$var$ByteData;

});

parcelRegister("ayZEe", function(module, exports) {

var $1jc42 = parcelRequire("1jc42");

var $j98yQ = parcelRequire("j98yQ");
function $7b0ce656f6dbf71c$var$KanjiData(data) {
    this.mode = $1jc42.KANJI;
    this.data = data;
}
$7b0ce656f6dbf71c$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$7b0ce656f6dbf71c$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7b0ce656f6dbf71c$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $7b0ce656f6dbf71c$var$KanjiData.getBitsLength(this.data.length);
};
$7b0ce656f6dbf71c$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $j98yQ.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $7b0ce656f6dbf71c$var$KanjiData;

});

parcelRegister("2xicJ", function(module, exports) {
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $1d8cc8d2fa58fb5b$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $1d8cc8d2fa58fb5b$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $1d8cc8d2fa58fb5b$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $1d8cc8d2fa58fb5b$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $1d8cc8d2fa58fb5b$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $1d8cc8d2fa58fb5b$var$dijkstra;

});



parcelRegister("dsm43", function(module, exports) {

$parcel$export(module.exports, "render", () => $9cbf01708baf91b3$export$b3890eb0ae9dca99, (v) => $9cbf01708baf91b3$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "renderToDataURL", () => $9cbf01708baf91b3$export$c3e5526bbaf70a25, (v) => $9cbf01708baf91b3$export$c3e5526bbaf70a25 = v);
var $9cbf01708baf91b3$export$b3890eb0ae9dca99;
var $9cbf01708baf91b3$export$c3e5526bbaf70a25;

var $4Qdpq = parcelRequire("4Qdpq");
function $9cbf01708baf91b3$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $9cbf01708baf91b3$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$9cbf01708baf91b3$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $9cbf01708baf91b3$var$getCanvasElement();
    opts = $4Qdpq.getOptions(opts);
    const size = $4Qdpq.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $4Qdpq.qrToImageData(image.data, qrData, opts);
    $9cbf01708baf91b3$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$9cbf01708baf91b3$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $9cbf01708baf91b3$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("4Qdpq", function(module, exports) {

$parcel$export(module.exports, "getOptions", () => $38666b850b8546b7$export$d2312e68e1f5ad00, (v) => $38666b850b8546b7$export$d2312e68e1f5ad00 = v);
$parcel$export(module.exports, "getScale", () => $38666b850b8546b7$export$5cdac61cf538712e, (v) => $38666b850b8546b7$export$5cdac61cf538712e = v);
$parcel$export(module.exports, "getImageWidth", () => $38666b850b8546b7$export$c3a1a1f268a8142b, (v) => $38666b850b8546b7$export$c3a1a1f268a8142b = v);
$parcel$export(module.exports, "qrToImageData", () => $38666b850b8546b7$export$83136f57c739c5f3, (v) => $38666b850b8546b7$export$83136f57c739c5f3 = v);
var $38666b850b8546b7$export$d2312e68e1f5ad00;
var $38666b850b8546b7$export$5cdac61cf538712e;
var $38666b850b8546b7$export$c3a1a1f268a8142b;
var $38666b850b8546b7$export$83136f57c739c5f3;
function $38666b850b8546b7$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$38666b850b8546b7$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $38666b850b8546b7$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $38666b850b8546b7$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$38666b850b8546b7$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$38666b850b8546b7$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $38666b850b8546b7$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$38666b850b8546b7$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $38666b850b8546b7$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("dM4JI", function(module, exports) {

$parcel$export(module.exports, "render", () => $a0736e989f732944$export$b3890eb0ae9dca99, (v) => $a0736e989f732944$export$b3890eb0ae9dca99 = v);
var $a0736e989f732944$export$b3890eb0ae9dca99;

var $4Qdpq = parcelRequire("4Qdpq");
function $a0736e989f732944$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $a0736e989f732944$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $a0736e989f732944$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $a0736e989f732944$var$svgCmd('M', col + margin, 0.5 + row + margin) : $a0736e989f732944$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $a0736e989f732944$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$a0736e989f732944$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $4Qdpq.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $a0736e989f732944$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $a0736e989f732944$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $a0736e989f732944$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("7z3DI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f22f47703db44e$export$2e2bcd8739ae039);

var $dHUeX = parcelRequire("dHUeX");

var $717Zc = parcelRequire("717Zc");
const $a1f22f47703db44e$var$createImageAttachmentCard = async (imageData)=>{
    const naturalSize = await $a1f22f47703db44e$var$getNaturalSize(imageData.url);
    let miniaturedDisplay = false;
    // If an error occured, we retrieve width = 0 and height = 0
    if (naturalSize.width === 0 && naturalSize.height === 0) imageData = {
        url: `${(0, $717Zc.imageFiles).noimage}`,
        alt: 'Image no found'
    };
    else miniaturedDisplay = naturalSize.width < 400 && naturalSize.height < 300;
    return {
        contentType: (0, $dHUeX.CONTENT_TYPE_IMAGE),
        content: {
            ...imageData,
            isMiniature: miniaturedDisplay
        }
    };
};
const $a1f22f47703db44e$var$getNaturalSize = async (url)=>{
    return new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        img.onerror = ()=>{
            resolve({
                width: 0,
                height: 0
            });
        };
        img.src = url;
    });
};
var $a1f22f47703db44e$export$2e2bcd8739ae039 = $a1f22f47703db44e$var$createImageAttachmentCard;

});
parcelRegister("717Zc", function(module, exports) {

$parcel$export(module.exports, "imageFiles", () => $1294548a0e615367$export$e56d88b19b5c9fbf);

var $kdMEA = parcelRequire("kdMEA");
const $1294548a0e615367$export$e56d88b19b5c9fbf = {
    noimage: `${(0, $kdMEA.CDNImagesAddress)}/no-image.png`,
    logoRetorikBlack: `${(0, $kdMEA.CDNImagesAddress)}/logo_RETORIK_black.png`,
    logoRetorikWhite: `${(0, $kdMEA.CDNImagesAddress)}/logo_RETORIK_white.png`,
    mapDeparture: `${(0, $kdMEA.CDNImagesAddress)}/Leaflet/map_departure.png`,
    mapArrival: `${(0, $kdMEA.CDNImagesAddress)}/Leaflet/map_arrival.png`,
    leaMini: `${(0, $kdMEA.CDNImagesAddress)}/lea_mini.png`
};

});


parcelRegister("29xBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $799342c4224a4cba$export$2e2bcd8739ae039);

var $aC3vq = parcelRequire("aC3vq");
const $799342c4224a4cba$var$processDirectLineIncomingActivity = (activity)=>{
    const dataToReturn = {
        speak: undefined,
        text: undefined,
        htmlText: undefined,
        images: [],
        urls: []
    };
    const usedImageURLs = [];
    const usedLinkURLs = [];
    // Deal with 'speak' field if present
    if (activity?.speak) {
        // Make all the treatments needed for markdown and speechmarkdown
        const data = (0, $aC3vq.processMarkdownAndSpeechMarkdown)(activity.speak);
        dataToReturn.speak = data.text;
        dataToReturn.images = data.images;
        dataToReturn.urls = data.urls;
        // Add the used image URLs and link URLs to prevent doubles
        data.images.forEach((data)=>{
            usedImageURLs.push(data.url);
        });
        data.urls.forEach((data)=>{
            usedLinkURLs.push(data.url);
        });
    }
    // Deal with 'text' field if present
    if (activity?.text) {
        // Make all the treatments needed for markdown and speechmarkdown
        const data = (0, $aC3vq.processMarkdownAndSpeechMarkdown)(activity.text);
        dataToReturn.text = data.text;
        dataToReturn.htmlText = data.htmlText;
        // Don't add images if they are already in the array (already extracted from the 'speak' field)
        data.images.forEach((image)=>{
            !usedImageURLs.includes(image.url) && dataToReturn.images.push(image);
        });
        // Don't add urls if they are already in the array (already extracted from the 'speak' field)
        data.urls.forEach((url)=>{
            !usedLinkURLs.includes(url.url) && dataToReturn.urls.push(url);
        });
    }
    return dataToReturn;
};
var $799342c4224a4cba$export$2e2bcd8739ae039 = $799342c4224a4cba$var$processDirectLineIncomingActivity;

});


parcelRegister("hdMz2", function(module, exports) {

$parcel$export(module.exports, "useDirectlineStore", () => $1e6129bb27d43f24$export$adc771f45cf9b273);
$parcel$export(module.exports, "default", () => $1e6129bb27d43f24$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $jH1Jg = parcelRequire("jH1Jg");
var $bndFL = parcelRequire("bndFL");

var $eo2R4 = parcelRequire("eo2R4");

var $4xGiN = parcelRequire("4xGiN");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $bWQ72 = parcelRequire("bWQ72");

var $9JLpC = parcelRequire("9JLpC");

var $gDyAX = parcelRequire("gDyAX");

var $6SpST = parcelRequire("6SpST");

var $2rYkD = parcelRequire("2rYkD");

var $3RB0m = parcelRequire("3RB0m");
const $1e6129bb27d43f24$var$initialState = {
    directLine: null,
    directLineStatus: (0, $eo2R4.ConnectionStatus).Uninitialized,
    connectionStatusSubscription: null,
    activitySubscription: null,
    userId: '',
    externalActivityHandlers: [],
    paginationToSend: 10,
    positionToSend: undefined,
    activityWatermark: 0,
    conversationPaused: false
};
const $1e6129bb27d43f24$var$postActivityTypes = [
    (0, $gDyAX.LegacyDirectLineActivityType).SEND_MESSAGE,
    (0, $gDyAX.LegacyDirectLineActivityType).SEND_EVENT
];
const $1e6129bb27d43f24$var$eventsWithoutCancel = [
    'setuser',
    'davi.gdprconsent'
];
const $1e6129bb27d43f24$var$pad = (num)=>{
    return (num < 10 ? '0' : '') + num;
};
const $1e6129bb27d43f24$var$getFormattedTimestamp = (date = new Date())=>{
    const tzo = -date.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    return date.getFullYear() + '-' + $1e6129bb27d43f24$var$pad(date.getMonth() + 1) + '-' + $1e6129bb27d43f24$var$pad(date.getDate()) + 'T' + $1e6129bb27d43f24$var$pad(date.getHours()) + ':' + $1e6129bb27d43f24$var$pad(date.getMinutes()) + ':' + $1e6129bb27d43f24$var$pad(date.getSeconds()) + dif + $1e6129bb27d43f24$var$pad(Math.floor(Math.abs(tzo) / 60)) + ':' + $1e6129bb27d43f24$var$pad(Math.abs(tzo) % 60);
};
const $1e6129bb27d43f24$var$createDirectlineStore = (modeRef, recognitionStateRef, retrievingConversationRef, conversationIdRef, isTactileRef, localeRef, sendBoxRefRef, channelDataRef, setIsWaitingForResponse, unlockClickedButton, addBotEvent, addBotMessage, addUserEvent, addUserMessage, checkConversationId, setRetrievingConversation, checkDumpedLocaleFallback, cancelCurrentUtterance, checkActivityReplyToId, addSpeechRecognitionDynamicGrammar, toggleMicrophone)=>{
    return (0, $jH1Jg.createStore)((set, get)=>{
        return {
            ...$1e6129bb27d43f24$var$initialState,
            actions: {
                patchActivityFromPart: (activity)=>{
                    const tempActivity = activity;
                    if (!activity.from) tempActivity.from = {
                        ...tempActivity.from,
                        role: 'channel'
                    };
                    else if (!activity.from.role) {
                        if (activity.from.id === get().userId) tempActivity.from = {
                            ...tempActivity.from,
                            role: 'user'
                        };
                        else if (activity.from.id) tempActivity.from = {
                            ...tempActivity.from,
                            role: 'bot'
                        };
                        else tempActivity.from = {
                            ...tempActivity.from,
                            role: 'channel'
                        };
                    }
                    return tempActivity;
                },
                checkIfHandlerAbortsActivity: (type, activity)=>{
                    const handlers = get().externalActivityHandlers;
                    if (handlers.length) {
                        const action = {
                            type: type,
                            payload: {
                                activity: activity
                            }
                        };
                        for(let i = 0; i < handlers.length; i++){
                            const f = handlers[i];
                            if (f(action)) {
                                setIsWaitingForResponse(false);
                                unlockClickedButton();
                                console.log('Retorik Framework > aborted activity');
                                return true;
                            }
                        }
                    }
                    return false;
                },
                dispatchStatus: (status)=>{
                    set({
                        directLineStatus: status
                    });
                    get().externalActivityHandlers.forEach((handler)=>{
                        handler({
                            type: (0, $gDyAX.LegacyDirectLineStatus)[status]
                        });
                        status === (0, $eo2R4.ConnectionStatus).Online && handler({
                            type: (0, $gDyAX.LegacyDirectLineActivityType).SET_LANGUAGE
                        });
                    });
                },
                dispatchActivity: (activity)=>{
                    if (get().conversationPaused) return;
                    if (retrievingConversationRef.current) {
                        // @ts-ignore
                        const finalWatermark = get().directLine?.watermark;
                        if (!isNaN(parseInt(finalWatermark))) {
                            const currentWatermark = get().activityWatermark + 1;
                            if (currentWatermark === parseInt(finalWatermark)) setRetrievingConversation(false);
                            else set({
                                activityWatermark: currentWatermark
                            });
                        }
                    }
                    activity.conversation && checkConversationId(activity.conversation.id);
                    // Patch 'from' part of the activity to distinct between 'bot', 'user and 'channel'
                    const retorikActivity = (0, $6SpST.default)(get().actions.patchActivityFromPart(activity));
                    let legacyType = (0, $gDyAX.LegacyDirectLineActivityType).UNKNOWN;
                    switch(retorikActivity.type){
                        case 'message':
                            legacyType = retorikActivity.from.role === 'user' ? (0, $gDyAX.LegacyDirectLineActivityType).SEND_MESSAGE : (0, $gDyAX.LegacyDirectLineActivityType).INCOMING_ACTIVITY;
                            break;
                        case 'event':
                            legacyType = retorikActivity.from.role === 'user' ? (0, $gDyAX.LegacyDirectLineActivityType).SEND_EVENT : (0, $gDyAX.LegacyDirectLineActivityType).INCOMING_ACTIVITY;
                            break;
                        case 'typing':
                            legacyType = (0, $gDyAX.LegacyDirectLineActivityType).TYPING;
                            break;
                    }
                    // Let speechStore check if this activity has an impact on a curent streaming
                    checkActivityReplyToId(retorikActivity.replyToId);
                    switch(legacyType){
                        case (0, $gDyAX.LegacyDirectLineActivityType).SEND_EVENT:
                            addUserEvent(retorikActivity);
                            break;
                        case (0, $gDyAX.LegacyDirectLineActivityType).SEND_MESSAGE:
                            addUserMessage(retorikActivity);
                            break;
                        case (0, $gDyAX.LegacyDirectLineActivityType).INCOMING_ACTIVITY:
                            if (!get().actions.checkIfHandlerAbortsActivity(legacyType, activity)) {
                                // Add data for better speech recognition if therer are some
                                if (retorikActivity.channelData?.speechRecognitionGrammars) addSpeechRecognitionDynamicGrammar(retorikActivity.channelData?.speechRecognitionGrammars);
                                if (retorikActivity.type === 'event') addBotEvent(retorikActivity);
                                else if (retorikActivity.type === 'message') addBotMessage(retorikActivity);
                                // Hide virtual keyboard if it is displayed (not working on safari and firefox)
                                navigator.virtualKeyboard?.hide();
                                if (isTactileRef.current) sendBoxRefRef.current?.blur();
                            }
                            break;
                    }
                    // Send POST_ACTIVITY_FULFILLED if the legacy type is SEND_MESSAGE or SEND_EVENT
                    if ($1e6129bb27d43f24$var$postActivityTypes.includes(legacyType)) get().actions.checkIfHandlerAbortsActivity((0, $gDyAX.LegacyDirectLineActivityType).POST_ACTIVITY_FULFILLED, activity);
                },
                subscribe: (value)=>{
                    // Subscribe to connection status and activities if a value is provided
                    const CSsubscription = value ? value.connectionStatus$.subscribe((newStatus)=>{
                        get().actions.dispatchStatus(newStatus);
                    }) : null;
                    const Asubscription = value ? value.activity$.subscribe((activity)=>{
                        activity.type !== 'typing' && get().actions.dispatchActivity(activity);
                    }) : null;
                    set({
                        directLine: value,
                        connectionStatusSubscription: CSsubscription,
                        activitySubscription: Asubscription
                    });
                },
                unsubscribe: ()=>{
                    // Unsubscribe existing subscriptions to connection status and activities
                    get().connectionStatusSubscription?.unsubscribe();
                    get().activitySubscription?.unsubscribe();
                },
                end: ()=>{
                    get().directLine?.end();
                },
                createDirectLine: (data)=>{
                    // Check if there are handlers already set or in the data
                    const currentHandlers = get().externalActivityHandlers;
                    const handlers = currentHandlers.length ? currentHandlers : data.externalActivityHandler ? [
                        data.externalActivityHandler
                    ] : [];
                    // Send DIRECT_LINE/CONNECT before creating directline because if everything goes well it only sends DIRECT_LINE/CONNECT_FULFILLED
                    handlers.forEach((handler)=>{
                        handler({
                            type: (0, $gDyAX.LegacyDirectLineStatus)[0]
                        });
                    });
                    const directLine = new (0, $eo2R4.DirectLine)({
                        webSocket: true,
                        ...data
                    });
                    get().actions.unsubscribe();
                    get().actions.subscribe(directLine);
                    set({
                        userId: data.userId || 'userId',
                        externalActivityHandlers: handlers
                    });
                },
                addDataInChannelData: ()=>{
                    const dataAddedToChannelData = {
                        pageSize: get().paginationToSend || 10,
                        version: (0, $3RB0m.version)
                    };
                    const position = get().positionToSend;
                    if (position?.latitude && position.longitude) {
                        dataAddedToChannelData.location = {
                            latitude: position.latitude,
                            longitude: position.longitude
                        };
                        dataAddedToChannelData.position = {
                            latitude: position.latitude,
                            longitude: position.longitude
                        };
                    }
                    return channelDataRef.current ? {
                        ...dataAddedToChannelData,
                        ...channelDataRef.current
                    } : dataAddedToChannelData;
                },
                checkMicrophoneAndCancel: ()=>{
                    if (modeRef.current === (0, $2rYkD.Mode).vocal && recognitionStateRef.current === (0, $2rYkD.RecognitionState).Listening) toggleMicrophone();
                    else cancelCurrentUtterance();
                },
                sendMessage: (text, value)=>{
                    if (get().conversationPaused) return;
                    // Check if we should cancel an utterance being played
                    get().actions.checkMicrophoneAndCancel();
                    const locale = checkDumpedLocaleFallback();
                    const tempActivity = {
                        from: {
                            id: get().userId
                        },
                        type: 'message',
                        channelData: get().actions.addDataInChannelData(),
                        localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        localTimestamp: $1e6129bb27d43f24$var$getFormattedTimestamp(),
                        locale: locale
                    };
                    text && (tempActivity.text = text);
                    value && (tempActivity.value = value);
                    // Check if the activity should be stopped in the external activity handler if there is one
                    if (get().actions.checkIfHandlerAbortsActivity((0, $gDyAX.LegacyDirectLineActivityType).POST_ACTIVITY, tempActivity)) return;
                    if (get().actions.checkIfHandlerAbortsActivity((0, $gDyAX.LegacyDirectLineActivityType).SEND_MESSAGE, tempActivity)) return;
                    get().directLine?.postActivity(tempActivity).subscribe();
                },
                sendEvent: (name, value, callback)=>{
                    if (get().conversationPaused) return;
                    !name.toLowerCase().includes('davi.closewindow') && !$1e6129bb27d43f24$var$eventsWithoutCancel.includes(name.toLowerCase()) && get().actions.checkMicrophoneAndCancel();
                    const locale = checkDumpedLocaleFallback();
                    const tempEvent = {
                        from: {
                            id: get().userId
                        },
                        type: 'event',
                        channelData: get().actions.addDataInChannelData(),
                        locale: locale,
                        localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        localTimestamp: $1e6129bb27d43f24$var$getFormattedTimestamp(),
                        name: name,
                        value: value
                    };
                    // Check if the event should be stopped in the external activity handler if there is one
                    if (get().actions.checkIfHandlerAbortsActivity((0, $gDyAX.LegacyDirectLineActivityType).POST_ACTIVITY, tempEvent)) return;
                    if (get().actions.checkIfHandlerAbortsActivity((0, $gDyAX.LegacyDirectLineActivityType).SEND_EVENT, tempEvent)) return;
                    get().directLine?.postActivity(tempEvent).subscribe({
                        error: (error)=>console.log('Retorik Framework > error while sending event : ', error),
                        complete: ()=>callback?.()
                    });
                },
                sendTyping: ()=>{
                    if (get().conversationPaused) return;
                    get().directLine?.postActivity({
                        from: {
                            id: get().userId
                        },
                        type: 'typing'
                    }).subscribe();
                },
                setPaginationToSend: (value)=>{
                    set({
                        paginationToSend: value
                    });
                },
                addExternalActivityHandler: (value)=>{
                    set((state)=>({
                            externalActivityHandlers: [
                                ...state.externalActivityHandlers,
                                value
                            ]
                        }));
                },
                setExternalActivityHandlers: (value)=>{
                    set({
                        externalActivityHandlers: value
                    });
                },
                setPositionToSend: (value)=>{
                    set({
                        positionToSend: value
                    });
                },
                dispatchMarkActivity: (id, speaking)=>{
                    const action = {
                        type: (0, $gDyAX.LegacyDirectLineActivityType).MARK,
                        payload: {
                            activityID: id,
                            name: 'speak',
                            value: speaking
                        }
                    };
                    get().externalActivityHandlers.forEach((handler)=>{
                        handler(action);
                    });
                },
                pauseConversation: ()=>{
                    set({
                        conversationPaused: true
                    });
                },
                resumeConversation: ()=>{
                    set({
                        conversationPaused: false
                    });
                },
                sendMessageToChatbot: (value)=>{
                    if (value && conversationIdRef.current && localeRef.current) {
                        const tempActivity = {
                            type: 'message',
                            conversation: {
                                id: conversationIdRef.current
                            },
                            id: `fake-bot-${conversationIdRef.current}`,
                            from: {
                                id: 'fake-bot-id'
                            },
                            locale: localeRef.current,
                            text: value,
                            speak: value
                        };
                        get().actions.dispatchActivity(tempActivity);
                    }
                },
                resetDirectlineStore: ()=>{
                    get().actions.unsubscribe();
                    get().actions.end();
                    set({
                        ...$1e6129bb27d43f24$var$initialState
                    });
                }
            }
        };
    });
};
const $1e6129bb27d43f24$var$DirectlineContext = /*#__PURE__*/ (0, $bxRTa.createContext)(null);
const $1e6129bb27d43f24$export$adc771f45cf9b273 = (selector)=>{
    const store = (0, $bxRTa.useContext)($1e6129bb27d43f24$var$DirectlineContext);
    if (!store) throw new Error('Retorik Framework > useDirectlineStore must be used within DirectlineProvider');
    return (0, $bndFL.useStore)(store, selector);
};
const $1e6129bb27d43f24$var$DirectlineProvider = ({ children: children })=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const recognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const retrievingConversation = (0, $bWQ72.useActivityStore)((state)=>state.retrievingConversation);
    const conversationId = (0, $bWQ72.useActivityStore)((state)=>state.conversationId);
    const isTactile = (0, $9JLpC.useViewStore)((state)=>state.isTactile);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const sendBoxRef = (0, $7SHCs.useRetorikStore)((state)=>state.sendBoxRef);
    const channelData = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.channelData);
    const modeRef = (0, $bxRTa.useRef)((0, $2rYkD.Mode).text);
    const recognitionStateRef = (0, $bxRTa.useRef)((0, $2rYkD.RecognitionState).Closed);
    const retrievingConversationRef = (0, $bxRTa.useRef)(false);
    const conversationIdRef = (0, $bxRTa.useRef)(null);
    const isTactileRef = (0, $bxRTa.useRef)(false);
    const localeRef = (0, $bxRTa.useRef)('fr-FR');
    const sendBoxRefRef = (0, $bxRTa.useRef)(null);
    const channelDataRef = (0, $bxRTa.useRef)(undefined);
    const setIsWaitingForResponse = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setIsWaitingForResponse);
    const unlockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.actions.unlockClickedButton);
    const { addBotEvent: addBotEvent, addBotMessage: addBotMessage, addUserEvent: addUserEvent, addUserMessage: addUserMessage, checkConversationId: checkConversationId, setRetrievingConversation: setRetrievingConversation } = (0, $bWQ72.useActivityStore)((state)=>state.actions);
    const checkDumpedLocaleFallback = (0, $2eBYD.useLocaleStore)((state)=>state.actions.checkDumpedLocaleFallback);
    const { cancelCurrentUtterance: cancelCurrentUtterance, checkActivityReplyToId: checkActivityReplyToId, addSpeechRecognitionDynamicGrammar: addSpeechRecognitionDynamicGrammar, toggleMicrophone: toggleMicrophone } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const [store] = (0, $bxRTa.useState)(()=>$1e6129bb27d43f24$var$createDirectlineStore(modeRef, recognitionStateRef, retrievingConversationRef, conversationIdRef, isTactileRef, localeRef, sendBoxRefRef, channelDataRef, setIsWaitingForResponse, unlockClickedButton, addBotEvent, addBotMessage, addUserEvent, addUserMessage, checkConversationId, setRetrievingConversation, checkDumpedLocaleFallback, cancelCurrentUtterance, checkActivityReplyToId, addSpeechRecognitionDynamicGrammar, toggleMicrophone));
    (0, $bxRTa.useEffect)(()=>{
        modeRef.current = mode;
    }, [
        mode
    ]);
    (0, $bxRTa.useEffect)(()=>{
        recognitionStateRef.current = recognitionState;
    }, [
        recognitionState
    ]);
    (0, $bxRTa.useEffect)(()=>{
        retrievingConversationRef.current = retrievingConversation;
    }, [
        retrievingConversation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        conversationIdRef.current = conversationId;
    }, [
        conversationId
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isTactileRef.current = isTactile;
    }, [
        isTactile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        localeRef.current = locale;
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        sendBoxRefRef.current = sendBoxRef;
    }, [
        sendBoxRef
    ]);
    (0, $bxRTa.useEffect)(()=>{
        channelDataRef.current = channelData;
    }, [
        channelData
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)($1e6129bb27d43f24$var$DirectlineContext.Provider, {
        value: store,
        children: children
    });
};
var $1e6129bb27d43f24$export$2e2bcd8739ae039 = $1e6129bb27d43f24$var$DirectlineProvider;

});
parcelRegister("eo2R4", function(module, exports) {
"use strict";

var $uqBZi = parcelRequire("uqBZi");

var $kl7l1 = parcelRequire("kl7l1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DirectLineStreaming", {
    enumerable: true,
    get: function get() {
        return $5yJeH.DirectLineStreaming;
    }
});
module.exports.DirectLine = module.exports.ConnectionStatus = void 0;

var $a795858394a7d4b6$var$_objectWithoutProperties2 = $uqBZi((parcelRequire("kULI0")));

var $a795858394a7d4b6$var$_classCallCheck2 = $uqBZi((parcelRequire("EwRGi")));

var $a795858394a7d4b6$var$_createClass2 = $uqBZi((parcelRequire("4Yhbl")));

var $a795858394a7d4b6$var$_defineProperty2 = $uqBZi((parcelRequire("fYOFJ")));
parcelRequire("5CTNf");
parcelRequire("72ISo");

var $1YsVE = parcelRequire("1YsVE");

var $iR1uX = parcelRequire("iR1uX");

var $2Y5Ku = parcelRequire("2Y5Ku");

var $a795858394a7d4b6$var$_jwtDecode = $a795858394a7d4b6$var$_interopRequireWildcard((parcelRequire("lFm6Z")));
parcelRequire("8vvfY");
parcelRequire("gRWGT");
parcelRequire("3Q9Rs");
parcelRequire("lksCl");
parcelRequire("26bWo");
parcelRequire("jutCu");
parcelRequire("dTyba");
parcelRequire("01LJJ");
parcelRequire("LJe1p");
parcelRequire("7FASC");
parcelRequire("hGx2X");
parcelRequire("gZoFY");
parcelRequire("5gros");
parcelRequire("izS6F");
parcelRequire("7HLwq");
parcelRequire("1eNvz");
parcelRequire("6PvQO");
parcelRequire("lxzQd");

var $a795858394a7d4b6$var$_dedupeFilenames = $uqBZi((parcelRequire("lt2oK")));

var $5yJeH = parcelRequire("5yJeH");
var $a795858394a7d4b6$var$_excluded = [
    "contentUrl"
];
function $a795858394a7d4b6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a795858394a7d4b6$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a795858394a7d4b6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $kl7l1(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $a795858394a7d4b6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a795858394a7d4b6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a795858394a7d4b6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a795858394a7d4b6$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $a795858394a7d4b6$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a795858394a7d4b6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
} // In order to keep file size down, only import the parts of rxjs that we use
var $a795858394a7d4b6$var$DIRECT_LINE_VERSION = 'DirectLine/3.0';
// Direct Line 3.0 types
// Deprecated format for Skype channels. For testing legacy bots in Emulator only.
// These types are specific to this client library, not to Direct Line 3.0
var $a795858394a7d4b6$var$ConnectionStatus;
module.exports.ConnectionStatus = $a795858394a7d4b6$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Uninitialized"] = 0] = "Uninitialized";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Online"] = 2] = "Online";
    ConnectionStatus[ConnectionStatus["ExpiredToken"] = 3] = "ExpiredToken";
    ConnectionStatus[ConnectionStatus["FailedToConnect"] = 4] = "FailedToConnect";
    ConnectionStatus[ConnectionStatus["Ended"] = 5] = "Ended";
})($a795858394a7d4b6$var$ConnectionStatus || (module.exports.ConnectionStatus = $a795858394a7d4b6$var$ConnectionStatus = {}));
var $a795858394a7d4b6$var$wrapAjaxWithRetry = function wrapAjaxWithRetry(source, scheduler) {
    var notImplemented = function notImplemented() {
        throw new Error('not implemented');
    };
    var inner = function inner(response$) {
        return response$["catch"](function(err) {
            if (err.status === 429) {
                var retryAfterValue = err.xhr.getResponseHeader('Retry-After');
                var retryAfter = Number(retryAfterValue);
                if (!isNaN(retryAfter)) return $iR1uX.Observable.timer(retryAfter, scheduler).flatMap(function(_) {
                    return $iR1uX.Observable["throw"](err, scheduler);
                });
            }
            return $iR1uX.Observable["throw"](err, scheduler);
        });
    };
    var outer = function outer(urlOrRequest) {
        return inner(source(urlOrRequest));
    };
    return Object.assign(outer, {
        get: function get(url, headers) {
            return notImplemented();
        },
        post: function post(url, body, headers) {
            return notImplemented();
        },
        put: function put(url, body, headers) {
            return notImplemented();
        },
        patch: function patch(url, body, headers) {
            return notImplemented();
        },
        "delete": function _delete(url, headers) {
            return notImplemented();
        },
        getJSON: function getJSON(url, headers) {
            return notImplemented();
        }
    });
};
var $a795858394a7d4b6$var$makeServices = function makeServices(services) {
    var scheduler = services.scheduler || $2Y5Ku.async;
    return {
        scheduler: scheduler,
        ajax: $a795858394a7d4b6$var$wrapAjaxWithRetry(services.ajax || $iR1uX.Observable.ajax, scheduler),
        WebSocket: services.WebSocket || WebSocket,
        random: services.random || Math.random
    };
};
var $a795858394a7d4b6$var$lifetimeRefreshToken = 1800000;
var $a795858394a7d4b6$var$intervalRefreshToken = $a795858394a7d4b6$var$lifetimeRefreshToken / 2;
var $a795858394a7d4b6$var$POLLING_INTERVAL_LOWER_BOUND = 200; //ms
var $a795858394a7d4b6$var$errorExpiredToken = new Error("expired token");
var $a795858394a7d4b6$var$errorConversationEnded = new Error("conversation ended");
var $a795858394a7d4b6$var$errorFailedToConnect = new Error("failed to connect");
var $a795858394a7d4b6$var$konsole = {
    log: function log(message) {
        var _console;
        for(var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)optionalParams[_key - 1] = arguments[_key];
        if (typeof window !== 'undefined' && window["botchatDebug"] && message) (_console = console).log.apply(_console, [
            message
        ].concat(optionalParams));
    }
};
var $a795858394a7d4b6$var$DirectLine = /*#__PURE__*/ function() {
    //ms
    function DirectLine(options) {
        (0, $a795858394a7d4b6$var$_classCallCheck2["default"])(this, DirectLine);
        (0, $a795858394a7d4b6$var$_defineProperty2["default"])(this, "connectionStatus$", new $1YsVE.BehaviorSubject($a795858394a7d4b6$var$ConnectionStatus.Uninitialized));
        (0, $a795858394a7d4b6$var$_defineProperty2["default"])(this, "domain", "https://directline.botframework.com/v3/directline");
        (0, $a795858394a7d4b6$var$_defineProperty2["default"])(this, "watermark", '');
        (0, $a795858394a7d4b6$var$_defineProperty2["default"])(this, "_botAgent", '');
        (0, $a795858394a7d4b6$var$_defineProperty2["default"])(this, "timeout", 20000);
        (0, $a795858394a7d4b6$var$_defineProperty2["default"])(this, "pollingInterval", 1000);
        this.secret = options.secret;
        this.token = options.secret || options.token;
        this.webSocket = (options.webSocket === undefined ? true : options.webSocket) && typeof WebSocket !== 'undefined' && WebSocket !== undefined;
        if (options.conversationStartProperties && options.conversationStartProperties.locale) {
            if (Object.prototype.toString.call(options.conversationStartProperties.locale) === '[object String]') this.localeOnStartConversation = options.conversationStartProperties.locale;
            else console.warn('DirectLineJS: conversationStartProperties.locale was ignored: the locale name may be a BCP 47 language tag');
        }
        if (options.domain) this.domain = options.domain;
        if (options.conversationId) this.conversationId = options.conversationId;
        if (options.watermark) this.watermark = options.watermark;
        if (options.streamUrl) {
            if (options.token && options.conversationId) this.streamUrl = options.streamUrl;
            else console.warn('DirectLineJS: streamUrl was ignored: you need to provide a token and a conversationid');
        }
        if (options.timeout !== undefined) this.timeout = options.timeout;
        this.retries = ($a795858394a7d4b6$var$lifetimeRefreshToken - $a795858394a7d4b6$var$intervalRefreshToken) / this.timeout;
        this._botAgent = this.getBotAgent(options.botAgent);
        this.services = $a795858394a7d4b6$var$makeServices(options);
        var parsedPollingInterval = ~~options.pollingInterval;
        if (parsedPollingInterval < $a795858394a7d4b6$var$POLLING_INTERVAL_LOWER_BOUND) {
            if (typeof options.pollingInterval !== 'undefined') console.warn("DirectLineJS: provided pollingInterval (".concat(options.pollingInterval, ") is under lower bound (200ms), using default of 1000ms"));
        } else this.pollingInterval = parsedPollingInterval;
        this.expiredTokenExhaustion = this.setConnectionStatusFallback($a795858394a7d4b6$var$ConnectionStatus.ExpiredToken, $a795858394a7d4b6$var$ConnectionStatus.FailedToConnect, 5);
        this.activity$ = (this.webSocket ? this.webSocketActivity$() : this.pollingGetActivity$()).share();
    }
    // Every time we're about to make a Direct Line REST call, we call this first to see check the current connection status.
    // Either throws an error (indicating an error state) or emits a null, indicating a (presumably) healthy connection
    (0, $a795858394a7d4b6$var$_createClass2["default"])(DirectLine, [
        {
            key: "checkConnection",
            value: function checkConnection() {
                var _this = this;
                var once = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                var obs = this.connectionStatus$.flatMap(function(connectionStatus) {
                    if (connectionStatus === $a795858394a7d4b6$var$ConnectionStatus.Uninitialized) {
                        _this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.Connecting);
                        //if token and streamUrl are defined it means reconnect has already been done. Skipping it.
                        if (_this.token && _this.streamUrl) {
                            _this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.Online);
                            return $iR1uX.Observable.of(connectionStatus, _this.services.scheduler);
                        } else return _this.startConversation()["do"](function(conversation) {
                            _this.conversationId = conversation.conversationId;
                            _this.token = _this.secret || conversation.token;
                            _this.streamUrl = conversation.streamUrl;
                            _this.referenceGrammarId = conversation.referenceGrammarId;
                            if (!_this.secret) _this.refreshTokenLoop();
                            _this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.Online);
                        }, function(error) {
                            _this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.FailedToConnect);
                        }).map(function(_) {
                            return connectionStatus;
                        });
                    } else return $iR1uX.Observable.of(connectionStatus, _this.services.scheduler);
                }).filter(function(connectionStatus) {
                    return connectionStatus != $a795858394a7d4b6$var$ConnectionStatus.Uninitialized && connectionStatus != $a795858394a7d4b6$var$ConnectionStatus.Connecting;
                }).flatMap(function(connectionStatus) {
                    switch(connectionStatus){
                        case $a795858394a7d4b6$var$ConnectionStatus.Ended:
                            return $iR1uX.Observable["throw"]($a795858394a7d4b6$var$errorConversationEnded, _this.services.scheduler);
                        case $a795858394a7d4b6$var$ConnectionStatus.FailedToConnect:
                            return $iR1uX.Observable["throw"]($a795858394a7d4b6$var$errorFailedToConnect, _this.services.scheduler);
                        case $a795858394a7d4b6$var$ConnectionStatus.ExpiredToken:
                            return $iR1uX.Observable.of(connectionStatus, _this.services.scheduler);
                        default:
                            return $iR1uX.Observable.of(connectionStatus, _this.services.scheduler);
                    }
                });
                return once ? obs.take(1) : obs;
            }
        },
        {
            key: "setConnectionStatusFallback",
            value: function setConnectionStatusFallback(connectionStatusFrom, connectionStatusTo) {
                var maxAttempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
                maxAttempts--;
                var attempts = 0;
                var currStatus = null;
                return function(status) {
                    if (status === connectionStatusFrom && currStatus === status && attempts >= maxAttempts) {
                        attempts = 0;
                        return connectionStatusTo;
                    }
                    attempts++;
                    currStatus = status;
                    return status;
                };
            }
        },
        {
            key: "expiredToken",
            value: function expiredToken() {
                var connectionStatus = this.connectionStatus$.getValue();
                if (connectionStatus != $a795858394a7d4b6$var$ConnectionStatus.Ended && connectionStatus != $a795858394a7d4b6$var$ConnectionStatus.FailedToConnect) this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.ExpiredToken);
                var protectedConnectionStatus = this.expiredTokenExhaustion(this.connectionStatus$.getValue());
                this.connectionStatus$.next(protectedConnectionStatus);
            }
        },
        {
            key: "startConversation",
            value: function startConversation() {
                var _this2 = this;
                //if conversationid is set here, it means we need to call the reconnect api, else it is a new conversation
                var url = this.conversationId ? "".concat(this.domain, "/conversations/").concat(this.conversationId, "?watermark=").concat(this.watermark) : "".concat(this.domain, "/conversations");
                var method = this.conversationId ? "GET" : "POST";
                var body = this.conversationId ? undefined : {
                    user: {
                        id: this.userIdOnStartConversation
                    },
                    locale: this.localeOnStartConversation
                };
                return this.services.ajax({
                    method: method,
                    url: url,
                    body: body,
                    timeout: this.timeout,
                    headers: $a795858394a7d4b6$var$_objectSpread({
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }, this.commonHeaders())
                })//      .do(ajaxResponse => konsole.log("conversation ajaxResponse", ajaxResponse.response))
                .map(function(ajaxResponse) {
                    return ajaxResponse.response;
                }).retryWhen(function(error$) {
                    return(// for now we deem 4xx and 5xx errors as unrecoverable
                    // for everything else (timeouts), retry for a while
                    error$.mergeMap(function(error) {
                        return error.status >= 400 && error.status < 600 ? $iR1uX.Observable["throw"](error, _this2.services.scheduler) : $iR1uX.Observable.of(error, _this2.services.scheduler);
                    }).delay(_this2.timeout, _this2.services.scheduler).take(_this2.retries));
                });
            }
        },
        {
            key: "refreshTokenLoop",
            value: function refreshTokenLoop() {
                var _this3 = this;
                this.tokenRefreshSubscription = $iR1uX.Observable.interval($a795858394a7d4b6$var$intervalRefreshToken, this.services.scheduler).flatMap(function(_) {
                    return _this3.refreshToken();
                }).subscribe(function(token) {
                    $a795858394a7d4b6$var$konsole.log("refreshing token", token, "at", new Date());
                    _this3.token = token;
                });
            }
        },
        {
            key: "refreshToken",
            value: function refreshToken() {
                var _this4 = this;
                return this.checkConnection(true).flatMap(function(_) {
                    return _this4.services.ajax({
                        method: "POST",
                        url: "".concat(_this4.domain, "/tokens/refresh"),
                        timeout: _this4.timeout,
                        headers: $a795858394a7d4b6$var$_objectSpread({}, _this4.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.token;
                    }).retryWhen(function(error$) {
                        return error$.mergeMap(function(error) {
                            if (error.status === 403) {
                                // if the token is expired there's no reason to keep trying
                                _this4.expiredToken();
                                return $iR1uX.Observable["throw"](error, _this4.services.scheduler);
                            } else if (error.status === 404) // If the bot is gone, we should stop retrying
                            return $iR1uX.Observable["throw"](error, _this4.services.scheduler);
                            return $iR1uX.Observable.of(error, _this4.services.scheduler);
                        }).delay(_this4.timeout, _this4.services.scheduler).take(_this4.retries);
                    });
                });
            }
        },
        {
            key: "reconnect",
            value: function reconnect(conversation) {
                this.token = conversation.token;
                this.streamUrl = conversation.streamUrl;
                if (this.connectionStatus$.getValue() === $a795858394a7d4b6$var$ConnectionStatus.ExpiredToken) this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.Online);
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.tokenRefreshSubscription) this.tokenRefreshSubscription.unsubscribe();
                try {
                    this.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.Ended);
                } catch (e) {
                    if (e === $a795858394a7d4b6$var$errorConversationEnded) return;
                    throw e;
                }
            }
        },
        {
            key: "getSessionId",
            value: function getSessionId() {
                var _this5 = this;
                // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                $a795858394a7d4b6$var$konsole.log("getSessionId");
                return this.checkConnection(true).flatMap(function(_) {
                    return _this5.services.ajax({
                        method: "GET",
                        url: "".concat(_this5.domain, "/session/getsessionid"),
                        withCredentials: true,
                        timeout: _this5.timeout,
                        headers: $a795858394a7d4b6$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, _this5.commonHeaders())
                    }).map(function(ajaxResponse) {
                        if (ajaxResponse && ajaxResponse.response && ajaxResponse.response.sessionId) {
                            $a795858394a7d4b6$var$konsole.log("getSessionId response: " + ajaxResponse.response.sessionId);
                            return ajaxResponse.response.sessionId;
                        }
                        return '';
                    })["catch"](function(error) {
                        $a795858394a7d4b6$var$konsole.log("getSessionId error: " + error.status);
                        return $iR1uX.Observable.of('', _this5.services.scheduler);
                    });
                })["catch"](function(error) {
                    return _this5.catchExpiredToken(error);
                });
            }
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                var _this6 = this;
                // If user id is set, check if it match activity.from.id and always override it in activity
                if (this.userIdOnStartConversation && activity.from && activity.from.id !== this.userIdOnStartConversation) {
                    console.warn('DirectLineJS: Activity.from.id does not match with user id, ignoring activity.from.id');
                    activity.from.id = this.userIdOnStartConversation;
                }
                // Use postMessageWithAttachments for messages with attachments that are local files (e.g. an image to upload)
                // Technically we could use it for *all* activities, but postActivity is much lighter weight
                // So, since WebChat is partially a reference implementation of Direct Line, we implement both.
                if (activity.type === "message" && activity.attachments && activity.attachments.length > 0) return this.postMessageWithAttachments(activity);
                // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                $a795858394a7d4b6$var$konsole.log("postActivity", activity);
                return this.checkConnection(true).flatMap(function(_) {
                    return _this6.services.ajax({
                        method: "POST",
                        url: "".concat(_this6.domain, "/conversations/").concat(_this6.conversationId, "/activities"),
                        body: activity,
                        timeout: _this6.timeout,
                        headers: $a795858394a7d4b6$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, _this6.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.id;
                    })["catch"](function(error) {
                        return _this6.catchPostError(error);
                    });
                })["catch"](function(error) {
                    return _this6.catchExpiredToken(error);
                });
            }
        },
        {
            key: "postMessageWithAttachments",
            value: function postMessageWithAttachments(message) {
                var _this7 = this;
                var attachments = message.attachments;
                // We clean the attachments but making sure every attachment has unique name.
                // If the file do not have a name, Chrome will assign "blob" when it is appended to FormData.
                var attachmentNames = (0, $a795858394a7d4b6$var$_dedupeFilenames["default"])(attachments.map(function(media) {
                    return media.name || 'blob';
                }));
                var cleansedAttachments = attachments.map(function(attachment, index) {
                    return $a795858394a7d4b6$var$_objectSpread($a795858394a7d4b6$var$_objectSpread({}, attachment), {}, {
                        name: attachmentNames[index]
                    });
                });
                var formData;
                // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                return this.checkConnection(true).flatMap(function(_) {
                    // To send this message to DirectLine we need to deconstruct it into a "template" activity
                    // and one blob for each attachment.
                    formData = new FormData();
                    formData.append('activity', new Blob([
                        JSON.stringify($a795858394a7d4b6$var$_objectSpread($a795858394a7d4b6$var$_objectSpread({}, message), {}, {
                            // Removing contentUrl from attachment, we will send it via multipart
                            attachments: cleansedAttachments.map(function(_ref) {
                                var string = _ref.contentUrl, others = (0, $a795858394a7d4b6$var$_objectWithoutProperties2["default"])(_ref, $a795858394a7d4b6$var$_excluded);
                                return $a795858394a7d4b6$var$_objectSpread({}, others);
                            })
                        }))
                    ], {
                        type: 'application/vnd.microsoft.activity'
                    }));
                    return $iR1uX.Observable.from(cleansedAttachments, _this7.services.scheduler).flatMap(function(media) {
                        return _this7.services.ajax({
                            method: "GET",
                            url: media.contentUrl,
                            responseType: 'arraybuffer'
                        })["do"](function(ajaxResponse) {
                            return formData.append('file', new Blob([
                                ajaxResponse.response
                            ], {
                                type: media.contentType
                            }), media.name);
                        });
                    }).count();
                }).flatMap(function(_) {
                    return _this7.services.ajax({
                        method: "POST",
                        url: "".concat(_this7.domain, "/conversations/").concat(_this7.conversationId, "/upload?userId=").concat(message.from.id),
                        body: formData,
                        timeout: _this7.timeout,
                        headers: $a795858394a7d4b6$var$_objectSpread({}, _this7.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.id;
                    })["catch"](function(error) {
                        return _this7.catchPostError(error);
                    });
                })["catch"](function(error) {
                    return _this7.catchPostError(error);
                });
            }
        },
        {
            key: "catchPostError",
            value: function catchPostError(error) {
                if (error.status === 403) // token has expired (will fall through to return "retry")
                this.expiredToken();
                else if (error.status >= 400 && error.status < 500) // more unrecoverable errors
                return $iR1uX.Observable["throw"](error, this.services.scheduler);
                return $iR1uX.Observable.of("retry", this.services.scheduler);
            }
        },
        {
            key: "catchExpiredToken",
            value: function catchExpiredToken(error) {
                return error === $a795858394a7d4b6$var$errorExpiredToken ? $iR1uX.Observable.of("retry", this.services.scheduler) : $iR1uX.Observable["throw"](error, this.services.scheduler);
            }
        },
        {
            key: "pollingGetActivity$",
            value: function pollingGetActivity$() {
                var _this8 = this;
                var poller$ = $iR1uX.Observable.create(function(subscriber) {
                    // A BehaviorSubject to trigger polling. Since it is a BehaviorSubject
                    // the first event is produced immediately.
                    var trigger$ = new $1YsVE.BehaviorSubject({});
                    // TODO: remove Date.now, use reactive interval to space out every request
                    trigger$.subscribe(function() {
                        if (_this8.connectionStatus$.getValue() === $a795858394a7d4b6$var$ConnectionStatus.Online) {
                            var startTimestamp = Date.now();
                            _this8.services.ajax({
                                headers: $a795858394a7d4b6$var$_objectSpread({
                                    Accept: 'application/json'
                                }, _this8.commonHeaders()),
                                method: 'GET',
                                url: "".concat(_this8.domain, "/conversations/").concat(_this8.conversationId, "/activities?watermark=").concat(_this8.watermark),
                                timeout: _this8.timeout
                            }).subscribe(function(result) {
                                subscriber.next(result);
                                setTimeout(function() {
                                    return trigger$.next(null);
                                }, Math.max(0, _this8.pollingInterval - Date.now() + startTimestamp));
                            }, function(error) {
                                switch(error.status){
                                    case 403:
                                        _this8.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.ExpiredToken);
                                        setTimeout(function() {
                                            return trigger$.next(null);
                                        }, _this8.pollingInterval);
                                        break;
                                    case 404:
                                        _this8.connectionStatus$.next($a795858394a7d4b6$var$ConnectionStatus.Ended);
                                        break;
                                    default:
                                        // propagate the error
                                        subscriber.error(error);
                                        break;
                                }
                            });
                        }
                    });
                });
                return this.checkConnection().flatMap(function(_) {
                    return poller$["catch"](function() {
                        return $iR1uX.Observable.empty();
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response;
                    }).flatMap(function(activityGroup) {
                        return _this8.observableFromActivityGroup(activityGroup);
                    });
                });
            }
        },
        {
            key: "observableFromActivityGroup",
            value: function observableFromActivityGroup(activityGroup) {
                if (activityGroup.watermark) this.watermark = activityGroup.watermark;
                return $iR1uX.Observable.from(activityGroup.activities, this.services.scheduler);
            }
        },
        {
            key: "webSocketActivity$",
            value: function webSocketActivity$() {
                var _this9 = this;
                return this.checkConnection().flatMap(function(_) {
                    return _this9.observableWebSocket()// WebSockets can be closed by the server or the browser. In the former case we need to
                    // retrieve a new streamUrl. In the latter case we could first retry with the current streamUrl,
                    // but it's simpler just to always fetch a new one.
                    .retryWhen(function(error$) {
                        return error$.delay(_this9.getRetryDelay(), _this9.services.scheduler).mergeMap(function(error) {
                            return _this9.reconnectToConversation();
                        });
                    });
                }).flatMap(function(activityGroup) {
                    return _this9.observableFromActivityGroup(activityGroup);
                });
            }
        },
        {
            key: "getRetryDelay",
            value: function getRetryDelay() {
                return Math.floor(3000 + this.services.random() * 12000);
            }
        },
        {
            key: "observableWebSocket",
            value: function observableWebSocket() {
                var _this10 = this;
                return $iR1uX.Observable.create(function(subscriber) {
                    $a795858394a7d4b6$var$konsole.log("creating WebSocket", _this10.streamUrl);
                    var ws = new _this10.services.WebSocket(_this10.streamUrl);
                    var sub;
                    var closed;
                    ws.onopen = function(open) {
                        $a795858394a7d4b6$var$konsole.log("WebSocket open", open);
                        // Chrome is pretty bad at noticing when a WebSocket connection is broken.
                        // If we periodically ping the server with empty messages, it helps Chrome
                        // realize when connection breaks, and close the socket. We then throw an
                        // error, and that give us the opportunity to attempt to reconnect.
                        sub = $iR1uX.Observable.interval(_this10.timeout, _this10.services.scheduler).subscribe(function(_) {
                            try {
                                ws.send("");
                            } catch (e) {
                                $a795858394a7d4b6$var$konsole.log("Ping error", e);
                            }
                        });
                    };
                    ws.onclose = function(close) {
                        $a795858394a7d4b6$var$konsole.log("WebSocket close", close);
                        if (sub) sub.unsubscribe();
                        // RxJS.retryWhen has a bug that would cause "error" signal to be sent after the observable is completed/errored.
                        // We need to guard against extraneous "error" signal to workaround the bug.
                        closed || subscriber.error(close);
                        closed = true;
                    };
                    ws.onerror = function(error) {
                        $a795858394a7d4b6$var$konsole.log("WebSocket error", error);
                        if (sub) sub.unsubscribe();
                        // RxJS.retryWhen has a bug that would cause "error" signal to be sent after the observable is completed/errored.
                        // We need to guard against extraneous "error" signal to workaround the bug.
                        closed || subscriber.error(error);
                        closed = true;
                    };
                    ws.onmessage = function(message) {
                        return message.data && subscriber.next(JSON.parse(message.data));
                    };
                    // This is the 'unsubscribe' method, which is called when this observable is disposed.
                    // When the WebSocket closes itself, we throw an error, and this function is eventually called.
                    // When the observable is closed first (e.g. when tearing down a WebChat instance) then
                    // we need to manually close the WebSocket.
                    return function() {
                        if (ws.readyState === 0 || ws.readyState === 1) ws.close();
                    };
                });
            }
        },
        {
            key: "reconnectToConversation",
            value: function reconnectToConversation() {
                var _this11 = this;
                return this.checkConnection(true).flatMap(function(_) {
                    return _this11.services.ajax({
                        method: "GET",
                        url: "".concat(_this11.domain, "/conversations/").concat(_this11.conversationId, "?watermark=").concat(_this11.watermark),
                        timeout: _this11.timeout,
                        headers: $a795858394a7d4b6$var$_objectSpread({
                            "Accept": "application/json"
                        }, _this11.commonHeaders())
                    })["do"](function(result) {
                        if (!_this11.secret) _this11.token = result.response.token;
                        _this11.streamUrl = result.response.streamUrl;
                    }).map(function(_) {
                        return null;
                    }).retryWhen(function(error$) {
                        return error$.mergeMap(function(error) {
                            if (error.status === 403) // token has expired. We can't recover from this here, but the embedding
                            // website might eventually call reconnect() with a new token and streamUrl.
                            _this11.expiredToken();
                            else if (error.status === 404) return $iR1uX.Observable["throw"]($a795858394a7d4b6$var$errorConversationEnded, _this11.services.scheduler);
                            return $iR1uX.Observable.of(error, _this11.services.scheduler);
                        }).delay(_this11.timeout, _this11.services.scheduler).take(_this11.retries);
                    });
                });
            }
        },
        {
            key: "commonHeaders",
            value: function commonHeaders() {
                return {
                    "Authorization": "Bearer ".concat(this.token),
                    "x-ms-bot-agent": this._botAgent
                };
            }
        },
        {
            key: "getBotAgent",
            value: function getBotAgent() {
                var customAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var clientAgent = 'directlinejs';
                if (customAgent) clientAgent += "; ".concat(customAgent);
                return "".concat($a795858394a7d4b6$var$DIRECT_LINE_VERSION, " (").concat(clientAgent, " ").concat("0.15.6", ")");
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                if (this.connectionStatus$.getValue() === $a795858394a7d4b6$var$ConnectionStatus.Online) throw new Error('DirectLineJS: It is connected, we cannot set user id.');
                var userIdFromToken = this.parseToken(this.token);
                if (userIdFromToken) return console.warn('DirectLineJS: user id is already set in token, will ignore this user id.');
                if (/^dl_/.test(userId)) return console.warn('DirectLineJS: user id prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
                this.userIdOnStartConversation = userId;
            }
        },
        {
            key: "parseToken",
            value: function parseToken(token) {
                try {
                    var _ref2 = (0, $a795858394a7d4b6$var$_jwtDecode["default"])(token), user = _ref2.user;
                    return user;
                } catch (e) {
                    if (e instanceof $a795858394a7d4b6$var$_jwtDecode.InvalidTokenError) return undefined;
                }
            }
        }
    ]);
    return DirectLine;
}();
module.exports.DirectLine = $a795858394a7d4b6$var$DirectLine;

});
parcelRegister("uqBZi", function(module, exports) {
function $05b771fc96275539$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $05b771fc96275539$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kl7l1", function(module, exports) {
function $eceb7600903d6492$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $eceb7600903d6492$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $eceb7600903d6492$var$_typeof(o);
}
module.exports = $eceb7600903d6492$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kULI0", function(module, exports) {

var $424C5 = parcelRequire("424C5");
function $f39e0b92cdd67d32$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $424C5(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $f39e0b92cdd67d32$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("424C5", function(module, exports) {
function $2efaed6cc2097c3e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $2efaed6cc2097c3e$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("EwRGi", function(module, exports) {
function $079d3acfb4dc7f8e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $079d3acfb4dc7f8e$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Yhbl", function(module, exports) {

var $8YE8n = parcelRequire("8YE8n");
function $39ea17fbe16b1987$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $8YE8n(o.key), o);
    }
}
function $39ea17fbe16b1987$var$_createClass(e, r, t) {
    return r && $39ea17fbe16b1987$var$_defineProperties(e.prototype, r), t && $39ea17fbe16b1987$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $39ea17fbe16b1987$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8YE8n", function(module, exports) {

var $kl7l1 = parcelRequire("kl7l1");
var $68930f20f78888ca$var$_typeof = $kl7l1.default;

var $41dRl = parcelRequire("41dRl");
function $68930f20f78888ca$var$toPropertyKey(t) {
    var i = $41dRl(t, "string");
    return "symbol" == $68930f20f78888ca$var$_typeof(i) ? i : i + "";
}
module.exports = $68930f20f78888ca$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41dRl", function(module, exports) {

var $kl7l1 = parcelRequire("kl7l1");
var $2ed2019d34f67562$var$_typeof = $kl7l1.default;
function $2ed2019d34f67562$var$toPrimitive(t, r) {
    if ("object" != $2ed2019d34f67562$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2ed2019d34f67562$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $2ed2019d34f67562$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fYOFJ", function(module, exports) {

var $8YE8n = parcelRequire("8YE8n");
function $ba23c40a1107f2b3$var$_defineProperty(e, r, t) {
    return (r = $8YE8n(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $ba23c40a1107f2b3$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5CTNf", function(module, exports) {

var $2yyC8 = parcelRequire("2yyC8");
parcelRequire("6hk9K");
parcelRequire("4Z6an");
parcelRequire("bHQd7");
parcelRequire("8Re0G");
module.exports = $2yyC8;

});
parcelRegister("2yyC8", function(module, exports) {
parcelRequire("5WsKq");
parcelRequire("aA9Uu");
parcelRequire("aALcr");
parcelRequire("8QlWM");
parcelRequire("46rC3");
parcelRequire("57xiE");
parcelRequire("e14Rk");
parcelRequire("5jw61");

var $31NCA = parcelRequire("31NCA");
module.exports = $31NCA.Promise;

});
parcelRegister("5WsKq", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $7IbUy = parcelRequire("7IbUy");

var $gZHt7 = parcelRequire("gZHt7");

var $griNg = parcelRequire("griNg");

var $9R4Rw = parcelRequire("9R4Rw");

var $7McbS = parcelRequire("7McbS");

var $23xda = parcelRequire("23xda");
var $4538ab42e3d19fc4$var$$AggregateError = function AggregateError(errors, message) {
    var that = this;
    if (!(that instanceof $4538ab42e3d19fc4$var$$AggregateError)) return new $4538ab42e3d19fc4$var$$AggregateError(errors, message);
    if ($gZHt7) // eslint-disable-next-line unicorn/error-message -- expected
    that = $gZHt7(new Error(undefined), $7IbUy(that));
    if (message !== undefined) $9R4Rw(that, 'message', String(message));
    var errorsArray = [];
    $23xda(errors, errorsArray.push, {
        that: errorsArray
    });
    $9R4Rw(that, 'errors', errorsArray);
    return that;
};
$4538ab42e3d19fc4$var$$AggregateError.prototype = $griNg(Error.prototype, {
    constructor: $7McbS(5, $4538ab42e3d19fc4$var$$AggregateError),
    message: $7McbS(5, ''),
    name: $7McbS(5, 'AggregateError')
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$BCiHc({
    global: true
}, {
    AggregateError: $4538ab42e3d19fc4$var$$AggregateError
});

});
parcelRegister("BCiHc", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $kl2ZX = parcelRequire("kl2ZX");
var $07112a81bbc17e8f$require$getOwnPropertyDescriptor = $kl2ZX.f;

var $9R4Rw = parcelRequire("9R4Rw");

var $cmECB = parcelRequire("cmECB");

var $fASUy = parcelRequire("fASUy");

var $7SeGZ = parcelRequire("7SeGZ");

var $2YVX3 = parcelRequire("2YVX3");
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $jPgvX;
    else if (STATIC) target = $jPgvX[TARGET] || $fASUy(TARGET, {});
    else target = ($jPgvX[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $07112a81bbc17e8f$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $2YVX3(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $7SeGZ(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $9R4Rw(sourceProperty, 'sham', true);
        // extend global
        $cmECB(target, key, sourceProperty, options);
    }
};

});
parcelRegister("jPgvX", function(module, exports) {
var $e6ef9726df4755b0$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$e6ef9726df4755b0$var$check(typeof globalThis == 'object' && globalThis) || $e6ef9726df4755b0$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$e6ef9726df4755b0$var$check(typeof self == 'object' && self) || $e6ef9726df4755b0$var$check(typeof $parcel$global == 'object' && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});

parcelRegister("kl2ZX", function(module, exports) {

$parcel$export(module.exports, "f", () => $ece818315b27f5c6$export$2d1720544b23b823, (v) => $ece818315b27f5c6$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $ece818315b27f5c6$export$2d1720544b23b823;

var $44FPw = parcelRequire("44FPw");

var $TvMwv = parcelRequire("TvMwv");

var $7McbS = parcelRequire("7McbS");

var $eAYLm = parcelRequire("eAYLm");

var $c6ha5 = parcelRequire("c6ha5");

var $sIjo5 = parcelRequire("sIjo5");

var $4jSi8 = parcelRequire("4jSi8");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ece818315b27f5c6$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$ece818315b27f5c6$export$2d1720544b23b823 = $44FPw ? $ece818315b27f5c6$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $eAYLm(O);
    P = $c6ha5(P, true);
    if ($4jSi8) try {
        return $ece818315b27f5c6$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($sIjo5(O, P)) return $7McbS(!$TvMwv.f.call(O, P), O[P]);
};

});
parcelRegister("44FPw", function(module, exports) {

var $h9Yhi = parcelRequire("h9Yhi");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$h9Yhi(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});
parcelRegister("h9Yhi", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRegister("TvMwv", function(module, exports) {

$parcel$export(module.exports, "f", () => $0a6dca56db093e9a$export$2d1720544b23b823, (v) => $0a6dca56db093e9a$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $0a6dca56db093e9a$export$2d1720544b23b823;
'use strict';
var $0a6dca56db093e9a$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $0a6dca56db093e9a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $0a6dca56db093e9a$var$NASHORN_BUG = $0a6dca56db093e9a$var$getOwnPropertyDescriptor && !$0a6dca56db093e9a$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$0a6dca56db093e9a$export$2d1720544b23b823 = $0a6dca56db093e9a$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $0a6dca56db093e9a$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $0a6dca56db093e9a$var$$propertyIsEnumerable;

});

parcelRegister("7McbS", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("eAYLm", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $5PrrV = parcelRequire("5PrrV");

var $4D8X3 = parcelRequire("4D8X3");
module.exports = function(it) {
    return $5PrrV($4D8X3(it));
};

});
parcelRegister("5PrrV", function(module, exports) {

var $h9Yhi = parcelRequire("h9Yhi");

var $V8QTg = parcelRequire("V8QTg");
var $43e702079f226a79$var$split = ''.split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $h9Yhi(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $V8QTg(it) == 'String' ? $43e702079f226a79$var$split.call(it, '') : Object(it);
} : Object;

});
parcelRegister("V8QTg", function(module, exports) {
var $0abc30d28715cfe3$var$toString = {}.toString;
module.exports = function(it) {
    return $0abc30d28715cfe3$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("4D8X3", function(module, exports) {
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};

});


parcelRegister("c6ha5", function(module, exports) {

var $dCTRi = parcelRequire("dCTRi");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(input, PREFERRED_STRING) {
    if (!$dCTRi(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !$dCTRi(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == 'function' && !$dCTRi(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !$dCTRi(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});
parcelRegister("dCTRi", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("sIjo5", function(module, exports) {

var $72sRo = parcelRequire("72sRo");
var $0564fd053ee6eb93$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $0564fd053ee6eb93$var$hasOwnProperty.call($72sRo(it), key);
};

});
parcelRegister("72sRo", function(module, exports) {

var $4D8X3 = parcelRequire("4D8X3");
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return Object($4D8X3(argument));
};

});


parcelRegister("4jSi8", function(module, exports) {

var $44FPw = parcelRequire("44FPw");

var $h9Yhi = parcelRequire("h9Yhi");

var $dZoIY = parcelRequire("dZoIY");
// Thank's IE8 for his funny defineProperty
module.exports = !$44FPw && !$h9Yhi(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($dZoIY('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("dZoIY", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $dCTRi = parcelRequire("dCTRi");
var $a2f426a0721a2db4$var$document = $jPgvX.document;
// typeof document.createElement is 'object' in old IE
var $a2f426a0721a2db4$var$EXISTS = $dCTRi($a2f426a0721a2db4$var$document) && $dCTRi($a2f426a0721a2db4$var$document.createElement);
module.exports = function(it) {
    return $a2f426a0721a2db4$var$EXISTS ? $a2f426a0721a2db4$var$document.createElement(it) : {};
};

});



parcelRegister("9R4Rw", function(module, exports) {

var $44FPw = parcelRequire("44FPw");

var $jFkUb = parcelRequire("jFkUb");

var $7McbS = parcelRequire("7McbS");
module.exports = $44FPw ? function(object, key, value) {
    return $jFkUb.f(object, key, $7McbS(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("jFkUb", function(module, exports) {

$parcel$export(module.exports, "f", () => $e5120ff85a8224af$export$2d1720544b23b823, (v) => $e5120ff85a8224af$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $e5120ff85a8224af$export$2d1720544b23b823;

var $44FPw = parcelRequire("44FPw");

var $4jSi8 = parcelRequire("4jSi8");

var $58iVU = parcelRequire("58iVU");

var $c6ha5 = parcelRequire("c6ha5");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e5120ff85a8224af$var$$defineProperty = Object.defineProperty;
$e5120ff85a8224af$export$2d1720544b23b823 = $44FPw ? $e5120ff85a8224af$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $58iVU(O);
    P = $c6ha5(P, true);
    $58iVU(Attributes);
    if ($4jSi8) try {
        return $e5120ff85a8224af$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("58iVU", function(module, exports) {

var $dCTRi = parcelRequire("dCTRi");
module.exports = function(it) {
    if (!$dCTRi(it)) throw TypeError(String(it) + ' is not an object');
    return it;
};

});



parcelRegister("cmECB", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $9R4Rw = parcelRequire("9R4Rw");

var $sIjo5 = parcelRequire("sIjo5");

var $fASUy = parcelRequire("fASUy");

var $3y5Jt = parcelRequire("3y5Jt");

var $1tUn8 = parcelRequire("1tUn8");
var $90070cb6bc1db73c$var$getInternalState = $1tUn8.get;
var $90070cb6bc1db73c$var$enforceInternalState = $1tUn8.enforce;
var $90070cb6bc1db73c$var$TEMPLATE = String(String).split('String');
(module.exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;
    if (typeof value == 'function') {
        if (typeof key == 'string' && !$sIjo5(value, 'name')) $9R4Rw(value, 'name', key);
        state = $90070cb6bc1db73c$var$enforceInternalState(value);
        if (!state.source) state.source = $90070cb6bc1db73c$var$TEMPLATE.join(typeof key == 'string' ? key : '');
    }
    if (O === $jPgvX) {
        if (simple) O[key] = value;
        else $fASUy(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $9R4Rw(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && $90070cb6bc1db73c$var$getInternalState(this).source || $3y5Jt(this);
});

});
parcelRegister("fASUy", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $9R4Rw = parcelRequire("9R4Rw");
module.exports = function(key, value) {
    try {
        $9R4Rw($jPgvX, key, value);
    } catch (error) {
        $jPgvX[key] = value;
    }
    return value;
};

});

parcelRegister("3y5Jt", function(module, exports) {

var $e7Mi4 = parcelRequire("e7Mi4");
var $2958fe6cbd666db0$var$functionToString = Function.toString;
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $e7Mi4.inspectSource != 'function') $e7Mi4.inspectSource = function(it) {
    return $2958fe6cbd666db0$var$functionToString.call(it);
};
module.exports = $e7Mi4.inspectSource;

});
parcelRegister("e7Mi4", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $fASUy = parcelRequire("fASUy");
var $a4872d9d94c1a397$var$SHARED = '__core-js_shared__';
var $a4872d9d94c1a397$var$store = $jPgvX[$a4872d9d94c1a397$var$SHARED] || $fASUy($a4872d9d94c1a397$var$SHARED, {});
module.exports = $a4872d9d94c1a397$var$store;

});


parcelRegister("1tUn8", function(module, exports) {

var $i0xcC = parcelRequire("i0xcC");

var $jPgvX = parcelRequire("jPgvX");

var $dCTRi = parcelRequire("dCTRi");

var $9R4Rw = parcelRequire("9R4Rw");

var $sIjo5 = parcelRequire("sIjo5");

var $e7Mi4 = parcelRequire("e7Mi4");

var $4ndYv = parcelRequire("4ndYv");

var $6z2Qb = parcelRequire("6z2Qb");
var $11443a3078637d82$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $11443a3078637d82$var$WeakMap = $jPgvX.WeakMap;
var $11443a3078637d82$var$set, $11443a3078637d82$var$get, $11443a3078637d82$var$has;
var $11443a3078637d82$var$enforce = function(it) {
    return $11443a3078637d82$var$has(it) ? $11443a3078637d82$var$get(it) : $11443a3078637d82$var$set(it, {});
};
var $11443a3078637d82$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$dCTRi(it) || (state = $11443a3078637d82$var$get(it)).type !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($i0xcC || $e7Mi4.state) {
    var $11443a3078637d82$var$store = $e7Mi4.state || ($e7Mi4.state = new $11443a3078637d82$var$WeakMap());
    var $11443a3078637d82$var$wmget = $11443a3078637d82$var$store.get;
    var $11443a3078637d82$var$wmhas = $11443a3078637d82$var$store.has;
    var $11443a3078637d82$var$wmset = $11443a3078637d82$var$store.set;
    $11443a3078637d82$var$set = function(it, metadata) {
        if ($11443a3078637d82$var$wmhas.call($11443a3078637d82$var$store, it)) throw new TypeError($11443a3078637d82$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $11443a3078637d82$var$wmset.call($11443a3078637d82$var$store, it, metadata);
        return metadata;
    };
    $11443a3078637d82$var$get = function(it) {
        return $11443a3078637d82$var$wmget.call($11443a3078637d82$var$store, it) || {};
    };
    $11443a3078637d82$var$has = function(it) {
        return $11443a3078637d82$var$wmhas.call($11443a3078637d82$var$store, it);
    };
} else {
    var $11443a3078637d82$var$STATE = $4ndYv('state');
    $6z2Qb[$11443a3078637d82$var$STATE] = true;
    $11443a3078637d82$var$set = function(it, metadata) {
        if ($sIjo5(it, $11443a3078637d82$var$STATE)) throw new TypeError($11443a3078637d82$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $9R4Rw(it, $11443a3078637d82$var$STATE, metadata);
        return metadata;
    };
    $11443a3078637d82$var$get = function(it) {
        return $sIjo5(it, $11443a3078637d82$var$STATE) ? it[$11443a3078637d82$var$STATE] : {};
    };
    $11443a3078637d82$var$has = function(it) {
        return $sIjo5(it, $11443a3078637d82$var$STATE);
    };
}
module.exports = {
    set: $11443a3078637d82$var$set,
    get: $11443a3078637d82$var$get,
    has: $11443a3078637d82$var$has,
    enforce: $11443a3078637d82$var$enforce,
    getterFor: $11443a3078637d82$var$getterFor
};

});
parcelRegister("i0xcC", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $3y5Jt = parcelRequire("3y5Jt");
var $d1c1fb67bd3a97a1$var$WeakMap = $jPgvX.WeakMap;
module.exports = typeof $d1c1fb67bd3a97a1$var$WeakMap === 'function' && /native code/.test($3y5Jt($d1c1fb67bd3a97a1$var$WeakMap));

});

parcelRegister("4ndYv", function(module, exports) {

var $gr2ES = parcelRequire("gr2ES");

var $fqZUk = parcelRequire("fqZUk");
var $32f42681b0ddb4f2$var$keys = $gr2ES('keys');
module.exports = function(key) {
    return $32f42681b0ddb4f2$var$keys[key] || ($32f42681b0ddb4f2$var$keys[key] = $fqZUk(key));
};

});
parcelRegister("gr2ES", function(module, exports) {

var $k7ZB0 = parcelRequire("k7ZB0");

var $e7Mi4 = parcelRequire("e7Mi4");
(module.exports = function(key, value) {
    return $e7Mi4[key] || ($e7Mi4[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.15.2',
    mode: $k7ZB0 ? 'pure' : 'global',
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("k7ZB0", function(module, exports) {
module.exports = false;

});


parcelRegister("fqZUk", function(module, exports) {
var $b3c94e469c6d55a6$var$id = 0;
var $b3c94e469c6d55a6$var$postfix = Math.random();
module.exports = function(key) {
    return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++$b3c94e469c6d55a6$var$id + $b3c94e469c6d55a6$var$postfix).toString(36);
};

});


parcelRegister("6z2Qb", function(module, exports) {
module.exports = {};

});



parcelRegister("7SeGZ", function(module, exports) {

var $sIjo5 = parcelRequire("sIjo5");

var $aiz0H = parcelRequire("aiz0H");

var $kl2ZX = parcelRequire("kl2ZX");

var $jFkUb = parcelRequire("jFkUb");
module.exports = function(target, source) {
    var keys = $aiz0H(source);
    var defineProperty = $jFkUb.f;
    var getOwnPropertyDescriptor = $kl2ZX.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$sIjo5(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("aiz0H", function(module, exports) {

var $diVwD = parcelRequire("diVwD");

var $dAYBR = parcelRequire("dAYBR");

var $5SmLA = parcelRequire("5SmLA");

var $58iVU = parcelRequire("58iVU");
// all object keys, includes non-enumerable and symbols
module.exports = $diVwD('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $dAYBR.f($58iVU(it));
    var getOwnPropertySymbols = $5SmLA.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("diVwD", function(module, exports) {

var $31NCA = parcelRequire("31NCA");

var $jPgvX = parcelRequire("jPgvX");
var $9af9942261c966f0$var$aFunction = function(variable) {
    return typeof variable == 'function' ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $9af9942261c966f0$var$aFunction($31NCA[namespace]) || $9af9942261c966f0$var$aFunction($jPgvX[namespace]) : $31NCA[namespace] && $31NCA[namespace][method] || $jPgvX[namespace] && $jPgvX[namespace][method];
};

});
parcelRegister("31NCA", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");
module.exports = $jPgvX;

});


parcelRegister("dAYBR", function(module, exports) {

$parcel$export(module.exports, "f", () => $9e5da6ff0b28ea5a$export$2d1720544b23b823, (v) => $9e5da6ff0b28ea5a$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $9e5da6ff0b28ea5a$export$2d1720544b23b823;

var $4UKs5 = parcelRequire("4UKs5");

var $lDrkF = parcelRequire("lDrkF");
var $9e5da6ff0b28ea5a$var$hiddenKeys = $lDrkF.concat('length', 'prototype');
$9e5da6ff0b28ea5a$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $4UKs5(O, $9e5da6ff0b28ea5a$var$hiddenKeys);
};

});
parcelRegister("4UKs5", function(module, exports) {

var $sIjo5 = parcelRequire("sIjo5");

var $eAYLm = parcelRequire("eAYLm");

var $fDMzW = parcelRequire("fDMzW");
var $39406cc682fd9da6$require$indexOf = $fDMzW.indexOf;

var $6z2Qb = parcelRequire("6z2Qb");
module.exports = function(object, names) {
    var O = $eAYLm(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$sIjo5($6z2Qb, key) && $sIjo5(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($sIjo5(O, key = names[i++])) ~$39406cc682fd9da6$require$indexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("fDMzW", function(module, exports) {

var $eAYLm = parcelRequire("eAYLm");

var $904Qh = parcelRequire("904Qh");

var $9HXKO = parcelRequire("9HXKO");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $b6302e4014e6e7ae$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $eAYLm($this);
        var length = $904Qh(O.length);
        var index = $9HXKO(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $b6302e4014e6e7ae$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $b6302e4014e6e7ae$var$createMethod(false)
};

});
parcelRegister("904Qh", function(module, exports) {

var $eH29a = parcelRequire("eH29a");
var $68d7deb01827ba73$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $68d7deb01827ba73$var$min($eH29a(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});
parcelRegister("eH29a", function(module, exports) {
var $ab26bf2475824593$var$ceil = Math.ceil;
var $ab26bf2475824593$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $ab26bf2475824593$var$floor : $ab26bf2475824593$var$ceil)(argument);
};

});


parcelRegister("9HXKO", function(module, exports) {

var $eH29a = parcelRequire("eH29a");
var $71167b19b1bee310$var$max = Math.max;
var $71167b19b1bee310$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $eH29a(index);
    return integer < 0 ? $71167b19b1bee310$var$max(integer + length, 0) : $71167b19b1bee310$var$min(integer, length);
};

});



parcelRegister("lDrkF", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});


parcelRegister("5SmLA", function(module, exports) {

$parcel$export(module.exports, "f", () => $4473a7e008fd1593$export$2d1720544b23b823, (v) => $4473a7e008fd1593$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $4473a7e008fd1593$export$2d1720544b23b823;
$4473a7e008fd1593$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("2YVX3", function(module, exports) {

var $h9Yhi = parcelRequire("h9Yhi");
var $22be235685fab5f3$var$replacement = /#|\.prototype\./;
var $22be235685fab5f3$var$isForced = function(feature, detection) {
    var value = $22be235685fab5f3$var$data[$22be235685fab5f3$var$normalize(feature)];
    return value == $22be235685fab5f3$var$POLYFILL ? true : value == $22be235685fab5f3$var$NATIVE ? false : typeof detection == 'function' ? $h9Yhi(detection) : !!detection;
};
var $22be235685fab5f3$var$normalize = $22be235685fab5f3$var$isForced.normalize = function(string) {
    return String(string).replace($22be235685fab5f3$var$replacement, '.').toLowerCase();
};
var $22be235685fab5f3$var$data = $22be235685fab5f3$var$isForced.data = {};
var $22be235685fab5f3$var$NATIVE = $22be235685fab5f3$var$isForced.NATIVE = 'N';
var $22be235685fab5f3$var$POLYFILL = $22be235685fab5f3$var$isForced.POLYFILL = 'P';
module.exports = $22be235685fab5f3$var$isForced;

});


parcelRegister("7IbUy", function(module, exports) {

var $sIjo5 = parcelRequire("sIjo5");

var $72sRo = parcelRequire("72sRo");

var $4ndYv = parcelRequire("4ndYv");

var $aCXGL = parcelRequire("aCXGL");
var $59d5e1ca451885c2$var$IE_PROTO = $4ndYv('IE_PROTO');
var $59d5e1ca451885c2$var$ObjectPrototype = Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $aCXGL ? Object.getPrototypeOf : function(O) {
    O = $72sRo(O);
    if ($sIjo5(O, $59d5e1ca451885c2$var$IE_PROTO)) return O[$59d5e1ca451885c2$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $59d5e1ca451885c2$var$ObjectPrototype : null;
};

});
parcelRegister("aCXGL", function(module, exports) {

var $h9Yhi = parcelRequire("h9Yhi");
module.exports = !$h9Yhi(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRegister("gZHt7", function(module, exports) {
/* eslint-disable no-proto -- safe */ 
var $58iVU = parcelRequire("58iVU");

var $fzvyY = parcelRequire("fzvyY");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
        setter.call(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $58iVU(O);
        $fzvyY(proto);
        if (CORRECT_SETTER) setter.call(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("fzvyY", function(module, exports) {

var $dCTRi = parcelRequire("dCTRi");
module.exports = function(it) {
    if (!$dCTRi(it) && it !== null) throw TypeError("Can't set " + String(it) + ' as a prototype');
    return it;
};

});


parcelRegister("griNg", function(module, exports) {

var $58iVU = parcelRequire("58iVU");

var $2Tvxm = parcelRequire("2Tvxm");

var $lDrkF = parcelRequire("lDrkF");

var $6z2Qb = parcelRequire("6z2Qb");

var $eVgUC = parcelRequire("eVgUC");

var $dZoIY = parcelRequire("dZoIY");

var $4ndYv = parcelRequire("4ndYv");
var $bf7dbefb9638a533$var$GT = '>';
var $bf7dbefb9638a533$var$LT = '<';
var $bf7dbefb9638a533$var$PROTOTYPE = 'prototype';
var $bf7dbefb9638a533$var$SCRIPT = 'script';
var $bf7dbefb9638a533$var$IE_PROTO = $4ndYv('IE_PROTO');
var $bf7dbefb9638a533$var$EmptyConstructor = function() {};
var $bf7dbefb9638a533$var$scriptTag = function(content) {
    return $bf7dbefb9638a533$var$LT + $bf7dbefb9638a533$var$SCRIPT + $bf7dbefb9638a533$var$GT + content + $bf7dbefb9638a533$var$LT + '/' + $bf7dbefb9638a533$var$SCRIPT + $bf7dbefb9638a533$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $bf7dbefb9638a533$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($bf7dbefb9638a533$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $bf7dbefb9638a533$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $dZoIY('iframe');
    var JS = 'java' + $bf7dbefb9638a533$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $eVgUC.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($bf7dbefb9638a533$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $bf7dbefb9638a533$var$activeXDocument;
var $bf7dbefb9638a533$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject -- old IE */ $bf7dbefb9638a533$var$activeXDocument = document.domain && new ActiveXObject('htmlfile');
    } catch (error) {}
    $bf7dbefb9638a533$var$NullProtoObject = $bf7dbefb9638a533$var$activeXDocument ? $bf7dbefb9638a533$var$NullProtoObjectViaActiveX($bf7dbefb9638a533$var$activeXDocument) : $bf7dbefb9638a533$var$NullProtoObjectViaIFrame();
    var length = $lDrkF.length;
    while(length--)delete $bf7dbefb9638a533$var$NullProtoObject[$bf7dbefb9638a533$var$PROTOTYPE][$lDrkF[length]];
    return $bf7dbefb9638a533$var$NullProtoObject();
};
$6z2Qb[$bf7dbefb9638a533$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $bf7dbefb9638a533$var$EmptyConstructor[$bf7dbefb9638a533$var$PROTOTYPE] = $58iVU(O);
        result = new $bf7dbefb9638a533$var$EmptyConstructor();
        $bf7dbefb9638a533$var$EmptyConstructor[$bf7dbefb9638a533$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$bf7dbefb9638a533$var$IE_PROTO] = O;
    } else result = $bf7dbefb9638a533$var$NullProtoObject();
    return Properties === undefined ? result : $2Tvxm(result, Properties);
};

});
parcelRegister("2Tvxm", function(module, exports) {

var $44FPw = parcelRequire("44FPw");

var $jFkUb = parcelRequire("jFkUb");

var $58iVU = parcelRequire("58iVU");

var $eLkjn = parcelRequire("eLkjn");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = $44FPw ? Object.defineProperties : function defineProperties(O, Properties) {
    $58iVU(O);
    var keys = $eLkjn(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$jFkUb.f(O, key = keys[index++], Properties[key]);
    return O;
};

});
parcelRegister("eLkjn", function(module, exports) {

var $4UKs5 = parcelRequire("4UKs5");

var $lDrkF = parcelRequire("lDrkF");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $4UKs5(O, $lDrkF);
};

});


parcelRegister("eVgUC", function(module, exports) {

var $diVwD = parcelRequire("diVwD");
module.exports = $diVwD('document', 'documentElement');

});


parcelRegister("23xda", function(module, exports) {

var $58iVU = parcelRequire("58iVU");

var $dkhaV = parcelRequire("dkhaV");

var $904Qh = parcelRequire("904Qh");

var $dGjDL = parcelRequire("dGjDL");

var $a5qGM = parcelRequire("a5qGM");

var $4yVQH = parcelRequire("4yVQH");
var $17f59fb08542f06d$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $dGjDL(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $4yVQH(iterator);
        return new $17f59fb08542f06d$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $58iVU(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $a5qGM(iterable);
        if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
        // optimisation for array iterators
        if ($dkhaV(iterFn)) {
            for(index = 0, length = $904Qh(iterable.length); length > index; index++){
                result = callFn(iterable[index]);
                if (result && result instanceof $17f59fb08542f06d$var$Result) return result;
            }
            return new $17f59fb08542f06d$var$Result(false);
        }
        iterator = iterFn.call(iterable);
    }
    next = iterator.next;
    while(!(step = next.call(iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $4yVQH(iterator);
            throw error;
        }
        if (typeof result == 'object' && result && result instanceof $17f59fb08542f06d$var$Result) return result;
    }
    return new $17f59fb08542f06d$var$Result(false);
};

});
parcelRegister("dkhaV", function(module, exports) {

var $cBGa7 = parcelRequire("cBGa7");

var $5KqUG = parcelRequire("5KqUG");
var $9b3a774331b6b3cd$var$ITERATOR = $cBGa7('iterator');
var $9b3a774331b6b3cd$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($5KqUG.Array === it || $9b3a774331b6b3cd$var$ArrayPrototype[$9b3a774331b6b3cd$var$ITERATOR] === it);
};

});
parcelRegister("cBGa7", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $gr2ES = parcelRequire("gr2ES");

var $sIjo5 = parcelRequire("sIjo5");

var $fqZUk = parcelRequire("fqZUk");

var $khUWI = parcelRequire("khUWI");

var $9VJ8C = parcelRequire("9VJ8C");
var $92d9a547bb838c78$var$WellKnownSymbolsStore = $gr2ES('wks');
var $92d9a547bb838c78$var$Symbol = $jPgvX.Symbol;
var $92d9a547bb838c78$var$createWellKnownSymbol = $9VJ8C ? $92d9a547bb838c78$var$Symbol : $92d9a547bb838c78$var$Symbol && $92d9a547bb838c78$var$Symbol.withoutSetter || $fqZUk;
module.exports = function(name) {
    if (!$sIjo5($92d9a547bb838c78$var$WellKnownSymbolsStore, name) || !($khUWI || typeof $92d9a547bb838c78$var$WellKnownSymbolsStore[name] == 'string')) {
        if ($khUWI && $sIjo5($92d9a547bb838c78$var$Symbol, name)) $92d9a547bb838c78$var$WellKnownSymbolsStore[name] = $92d9a547bb838c78$var$Symbol[name];
        else $92d9a547bb838c78$var$WellKnownSymbolsStore[name] = $92d9a547bb838c78$var$createWellKnownSymbol('Symbol.' + name);
    }
    return $92d9a547bb838c78$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("khUWI", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $c94Fb = parcelRequire("c94Fb");

var $h9Yhi = parcelRequire("h9Yhi");
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$h9Yhi(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $c94Fb && $c94Fb < 41;
});

});
parcelRegister("c94Fb", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $j52t7 = parcelRequire("j52t7");
var $8d79f157dfa6fee1$var$process = $jPgvX.process;
var $8d79f157dfa6fee1$var$versions = $8d79f157dfa6fee1$var$process && $8d79f157dfa6fee1$var$process.versions;
var $8d79f157dfa6fee1$var$v8 = $8d79f157dfa6fee1$var$versions && $8d79f157dfa6fee1$var$versions.v8;
var $8d79f157dfa6fee1$var$match, $8d79f157dfa6fee1$var$version;
if ($8d79f157dfa6fee1$var$v8) {
    $8d79f157dfa6fee1$var$match = $8d79f157dfa6fee1$var$v8.split('.');
    $8d79f157dfa6fee1$var$version = $8d79f157dfa6fee1$var$match[0] < 4 ? 1 : $8d79f157dfa6fee1$var$match[0] + $8d79f157dfa6fee1$var$match[1];
} else if ($j52t7) {
    $8d79f157dfa6fee1$var$match = $j52t7.match(/Edge\/(\d+)/);
    if (!$8d79f157dfa6fee1$var$match || $8d79f157dfa6fee1$var$match[1] >= 74) {
        $8d79f157dfa6fee1$var$match = $j52t7.match(/Chrome\/(\d+)/);
        if ($8d79f157dfa6fee1$var$match) $8d79f157dfa6fee1$var$version = $8d79f157dfa6fee1$var$match[1];
    }
}
module.exports = $8d79f157dfa6fee1$var$version && +$8d79f157dfa6fee1$var$version;

});
parcelRegister("j52t7", function(module, exports) {

var $diVwD = parcelRequire("diVwD");
module.exports = $diVwD('navigator', 'userAgent') || '';

});



parcelRegister("9VJ8C", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $khUWI = parcelRequire("khUWI");
module.exports = $khUWI && !Symbol.sham && typeof Symbol.iterator == 'symbol';

});


parcelRegister("5KqUG", function(module, exports) {
module.exports = {};

});


parcelRegister("dGjDL", function(module, exports) {

var $4JLys = parcelRequire("4JLys");
// optional / simple context binding
module.exports = function(fn, that, length) {
    $4JLys(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("4JLys", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(String(it) + ' is not a function');
    return it;
};

});


parcelRegister("a5qGM", function(module, exports) {

var $1IURi = parcelRequire("1IURi");

var $5KqUG = parcelRequire("5KqUG");

var $cBGa7 = parcelRequire("cBGa7");
var $757f12e5445a17d0$var$ITERATOR = $cBGa7('iterator');
module.exports = function(it) {
    if (it != undefined) return it[$757f12e5445a17d0$var$ITERATOR] || it['@@iterator'] || $5KqUG[$1IURi(it)];
};

});
parcelRegister("1IURi", function(module, exports) {

var $2HJ4J = parcelRequire("2HJ4J");

var $V8QTg = parcelRequire("V8QTg");

var $cBGa7 = parcelRequire("cBGa7");
var $1416017760e74051$var$TO_STRING_TAG = $cBGa7('toStringTag');
// ES3 wrong here
var $1416017760e74051$var$CORRECT_ARGUMENTS = $V8QTg(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $1416017760e74051$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $2HJ4J ? $V8QTg : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $1416017760e74051$var$tryGet(O = Object(it), $1416017760e74051$var$TO_STRING_TAG)) == 'string' ? tag : $1416017760e74051$var$CORRECT_ARGUMENTS ? $V8QTg(O) : (result = $V8QTg(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

});
parcelRegister("2HJ4J", function(module, exports) {

var $cBGa7 = parcelRequire("cBGa7");
var $1f828ff27b4c2e22$var$TO_STRING_TAG = $cBGa7('toStringTag');
var $1f828ff27b4c2e22$var$test = {};
$1f828ff27b4c2e22$var$test[$1f828ff27b4c2e22$var$TO_STRING_TAG] = 'z';
module.exports = String($1f828ff27b4c2e22$var$test) === '[object z]';

});



parcelRegister("4yVQH", function(module, exports) {

var $58iVU = parcelRequire("58iVU");
module.exports = function(iterator) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) return $58iVU(returnMethod.call(iterator)).value;
};

});



parcelRegister("aA9Uu", function(module, exports) {

var $2HJ4J = parcelRequire("2HJ4J");

var $cmECB = parcelRequire("cmECB");

var $e3PMZ = parcelRequire("e3PMZ");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$2HJ4J) $cmECB(Object.prototype, 'toString', $e3PMZ, {
    unsafe: true
});

});
parcelRegister("e3PMZ", function(module, exports) {
'use strict';

var $2HJ4J = parcelRequire("2HJ4J");

var $1IURi = parcelRequire("1IURi");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $2HJ4J ? ({}).toString : function toString() {
    return '[object ' + $1IURi(this) + ']';
};

});


parcelRegister("aALcr", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $k7ZB0 = parcelRequire("k7ZB0");

var $jPgvX = parcelRequire("jPgvX");

var $diVwD = parcelRequire("diVwD");

var $ey04o = parcelRequire("ey04o");

var $cmECB = parcelRequire("cmECB");

var $KMSw5 = parcelRequire("KMSw5");

var $gZHt7 = parcelRequire("gZHt7");

var $d1bnI = parcelRequire("d1bnI");

var $34HCN = parcelRequire("34HCN");

var $dCTRi = parcelRequire("dCTRi");

var $4JLys = parcelRequire("4JLys");

var $g2cWt = parcelRequire("g2cWt");

var $3y5Jt = parcelRequire("3y5Jt");

var $23xda = parcelRequire("23xda");

var $dQqtV = parcelRequire("dQqtV");

var $fcTJz = parcelRequire("fcTJz");

var $4Roh9 = parcelRequire("4Roh9");
var $7b61e1083ad49759$require$task = $4Roh9.set;

var $cquxo = parcelRequire("cquxo");

var $dG551 = parcelRequire("dG551");

var $hMmwQ = parcelRequire("hMmwQ");

var $5Ca01 = parcelRequire("5Ca01");

var $h1VnZ = parcelRequire("h1VnZ");

var $1tUn8 = parcelRequire("1tUn8");

var $2YVX3 = parcelRequire("2YVX3");

var $cBGa7 = parcelRequire("cBGa7");

var $haMJo = parcelRequire("haMJo");

var $kOkFf = parcelRequire("kOkFf");

var $c94Fb = parcelRequire("c94Fb");
var $7b61e1083ad49759$var$SPECIES = $cBGa7('species');
var $7b61e1083ad49759$var$PROMISE = 'Promise';
var $7b61e1083ad49759$var$getInternalState = $1tUn8.get;
var $7b61e1083ad49759$var$setInternalState = $1tUn8.set;
var $7b61e1083ad49759$var$getInternalPromiseState = $1tUn8.getterFor($7b61e1083ad49759$var$PROMISE);
var $7b61e1083ad49759$var$NativePromisePrototype = $ey04o && $ey04o.prototype;
var $7b61e1083ad49759$var$PromiseConstructor = $ey04o;
var $7b61e1083ad49759$var$PromiseConstructorPrototype = $7b61e1083ad49759$var$NativePromisePrototype;
var $7b61e1083ad49759$var$TypeError = $jPgvX.TypeError;
var $7b61e1083ad49759$var$document = $jPgvX.document;
var $7b61e1083ad49759$var$process = $jPgvX.process;
var $7b61e1083ad49759$var$newPromiseCapability = $5Ca01.f;
var $7b61e1083ad49759$var$newGenericPromiseCapability = $7b61e1083ad49759$var$newPromiseCapability;
var $7b61e1083ad49759$var$DISPATCH_EVENT = !!($7b61e1083ad49759$var$document && $7b61e1083ad49759$var$document.createEvent && $jPgvX.dispatchEvent);
var $7b61e1083ad49759$var$NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var $7b61e1083ad49759$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $7b61e1083ad49759$var$REJECTION_HANDLED = 'rejectionhandled';
var $7b61e1083ad49759$var$PENDING = 0;
var $7b61e1083ad49759$var$FULFILLED = 1;
var $7b61e1083ad49759$var$REJECTED = 2;
var $7b61e1083ad49759$var$HANDLED = 1;
var $7b61e1083ad49759$var$UNHANDLED = 2;
var $7b61e1083ad49759$var$SUBCLASSING = false;
var $7b61e1083ad49759$var$Internal, $7b61e1083ad49759$var$OwnPromiseCapability, $7b61e1083ad49759$var$PromiseWrapper, $7b61e1083ad49759$var$nativeThen;
var $7b61e1083ad49759$var$FORCED = $2YVX3($7b61e1083ad49759$var$PROMISE, function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $3y5Jt($7b61e1083ad49759$var$PromiseConstructor);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($7b61e1083ad49759$var$PromiseConstructor);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $c94Fb === 66) return true;
    // We need Promise#finally in the pure version for preventing prototype pollution
    if ($k7ZB0 && !$7b61e1083ad49759$var$PromiseConstructorPrototype['finally']) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($c94Fb >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $7b61e1083ad49759$var$PromiseConstructor(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$7b61e1083ad49759$var$SPECIES] = FakePromise;
    $7b61e1083ad49759$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$7b61e1083ad49759$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $haMJo && !$7b61e1083ad49759$var$NATIVE_REJECTION_EVENT;
});
var $7b61e1083ad49759$var$INCORRECT_ITERATION = $7b61e1083ad49759$var$FORCED || !$dQqtV(function(iterable) {
    $7b61e1083ad49759$var$PromiseConstructor.all(iterable)['catch'](function() {});
});
// helpers
var $7b61e1083ad49759$var$isThenable = function(it) {
    var then;
    return $dCTRi(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $7b61e1083ad49759$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    var chain = state.reactions;
    $cquxo(function() {
        var value = state.value;
        var ok = state.state == $7b61e1083ad49759$var$FULFILLED;
        var index = 0;
        // variable length - can't use forEach
        while(chain.length > index){
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (state.rejection === $7b61e1083ad49759$var$UNHANDLED) $7b61e1083ad49759$var$onHandleUnhandled(state);
                        state.rejection = $7b61e1083ad49759$var$HANDLED;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // can throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($7b61e1083ad49759$var$TypeError('Promise-chain cycle'));
                    else if (then = $7b61e1083ad49759$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (error) {
                if (domain && !exited) domain.exit();
                reject(error);
            }
        }
        state.reactions = [];
        state.notified = false;
        if (isReject && !state.rejection) $7b61e1083ad49759$var$onUnhandled(state);
    });
};
var $7b61e1083ad49759$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($7b61e1083ad49759$var$DISPATCH_EVENT) {
        event = $7b61e1083ad49759$var$document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $jPgvX.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$7b61e1083ad49759$var$NATIVE_REJECTION_EVENT && (handler = $jPgvX['on' + name])) handler(event);
    else if (name === $7b61e1083ad49759$var$UNHANDLED_REJECTION) $hMmwQ('Unhandled promise rejection', reason);
};
var $7b61e1083ad49759$var$onUnhandled = function(state) {
    $7b61e1083ad49759$require$task.call($jPgvX, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $7b61e1083ad49759$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $h1VnZ(function() {
                if ($kOkFf) $7b61e1083ad49759$var$process.emit('unhandledRejection', value, promise);
                else $7b61e1083ad49759$var$dispatchEvent($7b61e1083ad49759$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $kOkFf || $7b61e1083ad49759$var$isUnhandled(state) ? $7b61e1083ad49759$var$UNHANDLED : $7b61e1083ad49759$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $7b61e1083ad49759$var$isUnhandled = function(state) {
    return state.rejection !== $7b61e1083ad49759$var$HANDLED && !state.parent;
};
var $7b61e1083ad49759$var$onHandleUnhandled = function(state) {
    $7b61e1083ad49759$require$task.call($jPgvX, function() {
        var promise = state.facade;
        if ($kOkFf) $7b61e1083ad49759$var$process.emit('rejectionHandled', promise);
        else $7b61e1083ad49759$var$dispatchEvent($7b61e1083ad49759$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $7b61e1083ad49759$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $7b61e1083ad49759$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $7b61e1083ad49759$var$REJECTED;
    $7b61e1083ad49759$var$notify(state, true);
};
var $7b61e1083ad49759$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $7b61e1083ad49759$var$TypeError("Promise can't be resolved itself");
        var then = $7b61e1083ad49759$var$isThenable(value);
        if (then) $cquxo(function() {
            var wrapper = {
                done: false
            };
            try {
                then.call(value, $7b61e1083ad49759$var$bind($7b61e1083ad49759$var$internalResolve, wrapper, state), $7b61e1083ad49759$var$bind($7b61e1083ad49759$var$internalReject, wrapper, state));
            } catch (error) {
                $7b61e1083ad49759$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $7b61e1083ad49759$var$FULFILLED;
            $7b61e1083ad49759$var$notify(state, false);
        }
    } catch (error) {
        $7b61e1083ad49759$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($7b61e1083ad49759$var$FORCED) {
    // 25.4.3.1 Promise(executor)
    $7b61e1083ad49759$var$PromiseConstructor = function Promise(executor) {
        $g2cWt(this, $7b61e1083ad49759$var$PromiseConstructor, $7b61e1083ad49759$var$PROMISE);
        $4JLys(executor);
        $7b61e1083ad49759$var$Internal.call(this);
        var state = $7b61e1083ad49759$var$getInternalState(this);
        try {
            executor($7b61e1083ad49759$var$bind($7b61e1083ad49759$var$internalResolve, state), $7b61e1083ad49759$var$bind($7b61e1083ad49759$var$internalReject, state));
        } catch (error) {
            $7b61e1083ad49759$var$internalReject(state, error);
        }
    };
    $7b61e1083ad49759$var$PromiseConstructorPrototype = $7b61e1083ad49759$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $7b61e1083ad49759$var$Internal = function Promise(executor) {
        $7b61e1083ad49759$var$setInternalState(this, {
            type: $7b61e1083ad49759$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: $7b61e1083ad49759$var$PENDING,
            value: undefined
        });
    };
    $7b61e1083ad49759$var$Internal.prototype = $KMSw5($7b61e1083ad49759$var$PromiseConstructorPrototype, {
        // `Promise.prototype.then` method
        // https://tc39.es/ecma262/#sec-promise.prototype.then
        then: function then(onFulfilled, onRejected) {
            var state = $7b61e1083ad49759$var$getInternalPromiseState(this);
            var reaction = $7b61e1083ad49759$var$newPromiseCapability($fcTJz(this, $7b61e1083ad49759$var$PromiseConstructor));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $kOkFf ? $7b61e1083ad49759$var$process.domain : undefined;
            state.parent = true;
            state.reactions.push(reaction);
            if (state.state != $7b61e1083ad49759$var$PENDING) $7b61e1083ad49759$var$notify(state, false);
            return reaction.promise;
        },
        // `Promise.prototype.catch` method
        // https://tc39.es/ecma262/#sec-promise.prototype.catch
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $7b61e1083ad49759$var$OwnPromiseCapability = function() {
        var promise = new $7b61e1083ad49759$var$Internal();
        var state = $7b61e1083ad49759$var$getInternalState(promise);
        this.promise = promise;
        this.resolve = $7b61e1083ad49759$var$bind($7b61e1083ad49759$var$internalResolve, state);
        this.reject = $7b61e1083ad49759$var$bind($7b61e1083ad49759$var$internalReject, state);
    };
    $5Ca01.f = $7b61e1083ad49759$var$newPromiseCapability = function(C) {
        return C === $7b61e1083ad49759$var$PromiseConstructor || C === $7b61e1083ad49759$var$PromiseWrapper ? new $7b61e1083ad49759$var$OwnPromiseCapability(C) : $7b61e1083ad49759$var$newGenericPromiseCapability(C);
    };
    if (!$k7ZB0 && typeof $ey04o == 'function' && $7b61e1083ad49759$var$NativePromisePrototype !== Object.prototype) {
        $7b61e1083ad49759$var$nativeThen = $7b61e1083ad49759$var$NativePromisePrototype.then;
        if (!$7b61e1083ad49759$var$SUBCLASSING) {
            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
            $cmECB($7b61e1083ad49759$var$NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                var that = this;
                return new $7b61e1083ad49759$var$PromiseConstructor(function(resolve, reject) {
                    $7b61e1083ad49759$var$nativeThen.call(that, resolve, reject);
                }).then(onFulfilled, onRejected);
            // https://github.com/zloirock/core-js/issues/640
            }, {
                unsafe: true
            });
            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
            $cmECB($7b61e1083ad49759$var$NativePromisePrototype, 'catch', $7b61e1083ad49759$var$PromiseConstructorPrototype['catch'], {
                unsafe: true
            });
        }
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $7b61e1083ad49759$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($gZHt7) $gZHt7($7b61e1083ad49759$var$NativePromisePrototype, $7b61e1083ad49759$var$PromiseConstructorPrototype);
    }
}
$BCiHc({
    global: true,
    wrap: true,
    forced: $7b61e1083ad49759$var$FORCED
}, {
    Promise: $7b61e1083ad49759$var$PromiseConstructor
});
$d1bnI($7b61e1083ad49759$var$PromiseConstructor, $7b61e1083ad49759$var$PROMISE, false, true);
$34HCN($7b61e1083ad49759$var$PROMISE);
$7b61e1083ad49759$var$PromiseWrapper = $diVwD($7b61e1083ad49759$var$PROMISE);
// statics
$BCiHc({
    target: $7b61e1083ad49759$var$PROMISE,
    stat: true,
    forced: $7b61e1083ad49759$var$FORCED
}, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function reject(r) {
        var capability = $7b61e1083ad49759$var$newPromiseCapability(this);
        capability.reject.call(undefined, r);
        return capability.promise;
    }
});
$BCiHc({
    target: $7b61e1083ad49759$var$PROMISE,
    stat: true,
    forced: $k7ZB0 || $7b61e1083ad49759$var$FORCED
}, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
        return $dG551($k7ZB0 && this === $7b61e1083ad49759$var$PromiseWrapper ? $7b61e1083ad49759$var$PromiseConstructor : this, x);
    }
});
$BCiHc({
    target: $7b61e1083ad49759$var$PROMISE,
    stat: true,
    forced: $7b61e1083ad49759$var$INCORRECT_ITERATION
}, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function all(iterable) {
        var C = this;
        var capability = $7b61e1083ad49759$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $h1VnZ(function() {
            var $promiseResolve = $4JLys(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $23xda(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                $promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function race(iterable) {
        var C = this;
        var capability = $7b61e1083ad49759$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $h1VnZ(function() {
            var $promiseResolve = $4JLys(C.resolve);
            $23xda(iterable, function(promise) {
                $promiseResolve.call(C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRegister("ey04o", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");
module.exports = $jPgvX.Promise;

});

parcelRegister("KMSw5", function(module, exports) {

var $cmECB = parcelRequire("cmECB");
module.exports = function(target, src, options) {
    for(var key in src)$cmECB(target, key, src[key], options);
    return target;
};

});

parcelRegister("d1bnI", function(module, exports) {

var $jFkUb = parcelRequire("jFkUb");
var $97a4327a048835c7$require$defineProperty = $jFkUb.f;

var $sIjo5 = parcelRequire("sIjo5");

var $cBGa7 = parcelRequire("cBGa7");
var $97a4327a048835c7$var$TO_STRING_TAG = $cBGa7('toStringTag');
module.exports = function(it, TAG, STATIC) {
    if (it && !$sIjo5(it = STATIC ? it : it.prototype, $97a4327a048835c7$var$TO_STRING_TAG)) $97a4327a048835c7$require$defineProperty(it, $97a4327a048835c7$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

});

parcelRegister("34HCN", function(module, exports) {
'use strict';

var $diVwD = parcelRequire("diVwD");

var $jFkUb = parcelRequire("jFkUb");

var $cBGa7 = parcelRequire("cBGa7");

var $44FPw = parcelRequire("44FPw");
var $23d395cc1524d77b$var$SPECIES = $cBGa7('species');
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $diVwD(CONSTRUCTOR_NAME);
    var defineProperty = $jFkUb.f;
    if ($44FPw && Constructor && !Constructor[$23d395cc1524d77b$var$SPECIES]) defineProperty(Constructor, $23d395cc1524d77b$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("g2cWt", function(module, exports) {
module.exports = function(it, Constructor, name) {
    if (!(it instanceof Constructor)) throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
    return it;
};

});

parcelRegister("dQqtV", function(module, exports) {

var $cBGa7 = parcelRequire("cBGa7");
var $a144ac60c150f490$var$ITERATOR = $cBGa7('iterator');
var $a144ac60c150f490$var$SAFE_CLOSING = false;
try {
    var $a144ac60c150f490$var$called = 0;
    var $a144ac60c150f490$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$a144ac60c150f490$var$called++
            };
        },
        'return': function() {
            $a144ac60c150f490$var$SAFE_CLOSING = true;
        }
    };
    $a144ac60c150f490$var$iteratorWithReturn[$a144ac60c150f490$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($a144ac60c150f490$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$a144ac60c150f490$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$a144ac60c150f490$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});

parcelRegister("fcTJz", function(module, exports) {

var $58iVU = parcelRequire("58iVU");

var $4JLys = parcelRequire("4JLys");

var $cBGa7 = parcelRequire("cBGa7");
var $b123359d44a83a06$var$SPECIES = $cBGa7('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $58iVU(O).constructor;
    var S;
    return C === undefined || (S = $58iVU(C)[$b123359d44a83a06$var$SPECIES]) == undefined ? defaultConstructor : $4JLys(S);
};

});

parcelRegister("4Roh9", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $h9Yhi = parcelRequire("h9Yhi");

var $dGjDL = parcelRequire("dGjDL");

var $eVgUC = parcelRequire("eVgUC");

var $dZoIY = parcelRequire("dZoIY");

var $5KAGT = parcelRequire("5KAGT");

var $kOkFf = parcelRequire("kOkFf");
var $389ef1474adbb266$var$location = $jPgvX.location;
var $389ef1474adbb266$var$set = $jPgvX.setImmediate;
var $389ef1474adbb266$var$clear = $jPgvX.clearImmediate;
var $389ef1474adbb266$var$process = $jPgvX.process;
var $389ef1474adbb266$var$MessageChannel = $jPgvX.MessageChannel;
var $389ef1474adbb266$var$Dispatch = $jPgvX.Dispatch;
var $389ef1474adbb266$var$counter = 0;
var $389ef1474adbb266$var$queue = {};
var $389ef1474adbb266$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $389ef1474adbb266$var$defer, $389ef1474adbb266$var$channel, $389ef1474adbb266$var$port;
var $389ef1474adbb266$var$run = function(id) {
    // eslint-disable-next-line no-prototype-builtins -- safe
    if ($389ef1474adbb266$var$queue.hasOwnProperty(id)) {
        var fn = $389ef1474adbb266$var$queue[id];
        delete $389ef1474adbb266$var$queue[id];
        fn();
    }
};
var $389ef1474adbb266$var$runner = function(id) {
    return function() {
        $389ef1474adbb266$var$run(id);
    };
};
var $389ef1474adbb266$var$listener = function(event) {
    $389ef1474adbb266$var$run(event.data);
};
var $389ef1474adbb266$var$post = function(id) {
    // old engines have not location.origin
    $jPgvX.postMessage(id + '', $389ef1474adbb266$var$location.protocol + '//' + $389ef1474adbb266$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$389ef1474adbb266$var$set || !$389ef1474adbb266$var$clear) {
    $389ef1474adbb266$var$set = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $389ef1474adbb266$var$queue[++$389ef1474adbb266$var$counter] = function() {
            // eslint-disable-next-line no-new-func -- spec requirement
            (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
        };
        $389ef1474adbb266$var$defer($389ef1474adbb266$var$counter);
        return $389ef1474adbb266$var$counter;
    };
    $389ef1474adbb266$var$clear = function clearImmediate(id) {
        delete $389ef1474adbb266$var$queue[id];
    };
    // Node.js 0.8-
    if ($kOkFf) $389ef1474adbb266$var$defer = function(id) {
        $389ef1474adbb266$var$process.nextTick($389ef1474adbb266$var$runner(id));
    };
    else if ($389ef1474adbb266$var$Dispatch && $389ef1474adbb266$var$Dispatch.now) $389ef1474adbb266$var$defer = function(id) {
        $389ef1474adbb266$var$Dispatch.now($389ef1474adbb266$var$runner(id));
    };
    else if ($389ef1474adbb266$var$MessageChannel && !$5KAGT) {
        $389ef1474adbb266$var$channel = new $389ef1474adbb266$var$MessageChannel();
        $389ef1474adbb266$var$port = $389ef1474adbb266$var$channel.port2;
        $389ef1474adbb266$var$channel.port1.onmessage = $389ef1474adbb266$var$listener;
        $389ef1474adbb266$var$defer = $dGjDL($389ef1474adbb266$var$port.postMessage, $389ef1474adbb266$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($jPgvX.addEventListener && typeof postMessage == 'function' && !$jPgvX.importScripts && $389ef1474adbb266$var$location && $389ef1474adbb266$var$location.protocol !== 'file:' && !$h9Yhi($389ef1474adbb266$var$post)) {
        $389ef1474adbb266$var$defer = $389ef1474adbb266$var$post;
        $jPgvX.addEventListener('message', $389ef1474adbb266$var$listener, false);
    // IE8-
    } else if ($389ef1474adbb266$var$ONREADYSTATECHANGE in $dZoIY('script')) $389ef1474adbb266$var$defer = function(id) {
        $eVgUC.appendChild($dZoIY('script'))[$389ef1474adbb266$var$ONREADYSTATECHANGE] = function() {
            $eVgUC.removeChild(this);
            $389ef1474adbb266$var$run(id);
        };
    };
    else $389ef1474adbb266$var$defer = function(id) {
        setTimeout($389ef1474adbb266$var$runner(id), 0);
    };
}
module.exports = {
    set: $389ef1474adbb266$var$set,
    clear: $389ef1474adbb266$var$clear
};

});
parcelRegister("5KAGT", function(module, exports) {

var $j52t7 = parcelRequire("j52t7");
module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test($j52t7);

});

parcelRegister("kOkFf", function(module, exports) {

var $V8QTg = parcelRequire("V8QTg");

var $jPgvX = parcelRequire("jPgvX");
module.exports = $V8QTg($jPgvX.process) == 'process';

});


parcelRegister("cquxo", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $kl2ZX = parcelRequire("kl2ZX");
var $90bf99d96228274b$require$getOwnPropertyDescriptor = $kl2ZX.f;

var $4Roh9 = parcelRequire("4Roh9");
var $90bf99d96228274b$require$macrotask = $4Roh9.set;

var $5KAGT = parcelRequire("5KAGT");

var $jyohc = parcelRequire("jyohc");

var $kOkFf = parcelRequire("kOkFf");
var $90bf99d96228274b$var$MutationObserver = $jPgvX.MutationObserver || $jPgvX.WebKitMutationObserver;
var $90bf99d96228274b$var$document = $jPgvX.document;
var $90bf99d96228274b$var$process = $jPgvX.process;
var $90bf99d96228274b$var$Promise = $jPgvX.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $90bf99d96228274b$var$queueMicrotaskDescriptor = $90bf99d96228274b$require$getOwnPropertyDescriptor($jPgvX, 'queueMicrotask');
var $90bf99d96228274b$var$queueMicrotask = $90bf99d96228274b$var$queueMicrotaskDescriptor && $90bf99d96228274b$var$queueMicrotaskDescriptor.value;
var $90bf99d96228274b$var$flush, $90bf99d96228274b$var$head, $90bf99d96228274b$var$last, $90bf99d96228274b$var$notify, $90bf99d96228274b$var$toggle, $90bf99d96228274b$var$node, $90bf99d96228274b$var$promise, $90bf99d96228274b$var$then;
// modern engines have queueMicrotask method
if (!$90bf99d96228274b$var$queueMicrotask) {
    $90bf99d96228274b$var$flush = function() {
        var parent, fn;
        if ($kOkFf && (parent = $90bf99d96228274b$var$process.domain)) parent.exit();
        while($90bf99d96228274b$var$head){
            fn = $90bf99d96228274b$var$head.fn;
            $90bf99d96228274b$var$head = $90bf99d96228274b$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($90bf99d96228274b$var$head) $90bf99d96228274b$var$notify();
                else $90bf99d96228274b$var$last = undefined;
                throw error;
            }
        }
        $90bf99d96228274b$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$5KAGT && !$kOkFf && !$jyohc && $90bf99d96228274b$var$MutationObserver && $90bf99d96228274b$var$document) {
        $90bf99d96228274b$var$toggle = true;
        $90bf99d96228274b$var$node = $90bf99d96228274b$var$document.createTextNode('');
        new $90bf99d96228274b$var$MutationObserver($90bf99d96228274b$var$flush).observe($90bf99d96228274b$var$node, {
            characterData: true
        });
        $90bf99d96228274b$var$notify = function() {
            $90bf99d96228274b$var$node.data = $90bf99d96228274b$var$toggle = !$90bf99d96228274b$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($90bf99d96228274b$var$Promise && $90bf99d96228274b$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $90bf99d96228274b$var$promise = $90bf99d96228274b$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $90bf99d96228274b$var$promise.constructor = $90bf99d96228274b$var$Promise;
        $90bf99d96228274b$var$then = $90bf99d96228274b$var$promise.then;
        $90bf99d96228274b$var$notify = function() {
            $90bf99d96228274b$var$then.call($90bf99d96228274b$var$promise, $90bf99d96228274b$var$flush);
        };
    // Node.js without promises
    } else if ($kOkFf) $90bf99d96228274b$var$notify = function() {
        $90bf99d96228274b$var$process.nextTick($90bf99d96228274b$var$flush);
    };
    else $90bf99d96228274b$var$notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $90bf99d96228274b$require$macrotask.call($jPgvX, $90bf99d96228274b$var$flush);
    };
}
module.exports = $90bf99d96228274b$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($90bf99d96228274b$var$last) $90bf99d96228274b$var$last.next = task;
    if (!$90bf99d96228274b$var$head) {
        $90bf99d96228274b$var$head = task;
        $90bf99d96228274b$var$notify();
    }
    $90bf99d96228274b$var$last = task;
};

});
parcelRegister("jyohc", function(module, exports) {

var $j52t7 = parcelRequire("j52t7");
module.exports = /web0s(?!.*chrome)/i.test($j52t7);

});


parcelRegister("dG551", function(module, exports) {

var $58iVU = parcelRequire("58iVU");

var $dCTRi = parcelRequire("dCTRi");

var $5Ca01 = parcelRequire("5Ca01");
module.exports = function(C, x) {
    $58iVU(C);
    if ($dCTRi(x) && x.constructor === C) return x;
    var promiseCapability = $5Ca01.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});
parcelRegister("5Ca01", function(module, exports) {

$parcel$export(module.exports, "f", () => $416842023b6223eb$export$2d1720544b23b823, (v) => $416842023b6223eb$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $416842023b6223eb$export$2d1720544b23b823;
'use strict';

var $4JLys = parcelRequire("4JLys");
var $416842023b6223eb$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $4JLys(resolve);
    this.reject = $4JLys(reject);
};
$416842023b6223eb$export$2d1720544b23b823 = function(C) {
    return new $416842023b6223eb$var$PromiseCapability(C);
};

});


parcelRegister("hMmwQ", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");
module.exports = function(a, b) {
    var console = $jPgvX.console;
    if (console && console.error) arguments.length === 1 ? console.error(a) : console.error(a, b);
};

});

parcelRegister("h1VnZ", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRegister("haMJo", function(module, exports) {
module.exports = typeof window == 'object';

});


parcelRegister("8QlWM", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $4JLys = parcelRequire("4JLys");

var $5Ca01 = parcelRequire("5Ca01");

var $h1VnZ = parcelRequire("h1VnZ");

var $23xda = parcelRequire("23xda");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$BCiHc({
    target: 'Promise',
    stat: true
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $5Ca01.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $h1VnZ(function() {
            var promiseResolve = $4JLys(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $23xda(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("46rC3", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $4JLys = parcelRequire("4JLys");

var $diVwD = parcelRequire("diVwD");

var $5Ca01 = parcelRequire("5Ca01");

var $h1VnZ = parcelRequire("h1VnZ");

var $23xda = parcelRequire("23xda");
var $2fcd244e43c3a6cb$var$PROMISE_ANY_ERROR = 'No one promise resolved';
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$BCiHc({
    target: 'Promise',
    stat: true
}, {
    any: function any(iterable) {
        var C = this;
        var capability = $5Ca01.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $h1VnZ(function() {
            var promiseResolve = $4JLys(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $23xda(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                errors.push(undefined);
                remaining++;
                promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new ($diVwD('AggregateError'))(errors, $2fcd244e43c3a6cb$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new ($diVwD('AggregateError'))(errors, $2fcd244e43c3a6cb$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("57xiE", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $k7ZB0 = parcelRequire("k7ZB0");

var $ey04o = parcelRequire("ey04o");

var $h9Yhi = parcelRequire("h9Yhi");

var $diVwD = parcelRequire("diVwD");

var $fcTJz = parcelRequire("fcTJz");

var $dG551 = parcelRequire("dG551");

var $cmECB = parcelRequire("cmECB");
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $3ba76fdbd2d832ee$var$NON_GENERIC = !!$ey04o && $h9Yhi(function() {
    $ey04o.prototype['finally'].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$BCiHc({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $3ba76fdbd2d832ee$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $fcTJz(this, $diVwD('Promise'));
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $dG551(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $dG551(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$k7ZB0 && typeof $ey04o == 'function') {
    var $3ba76fdbd2d832ee$var$method = $diVwD('Promise').prototype['finally'];
    if ($ey04o.prototype['finally'] !== $3ba76fdbd2d832ee$var$method) $cmECB($ey04o.prototype, 'finally', $3ba76fdbd2d832ee$var$method, {
        unsafe: true
    });
}

});

parcelRegister("e14Rk", function(module, exports) {
'use strict';

var $kJ8AO = parcelRequire("kJ8AO");
var $a344ed9aa5fbf7e6$require$charAt = $kJ8AO.charAt;

var $1tUn8 = parcelRequire("1tUn8");

var $41lLp = parcelRequire("41lLp");
var $a344ed9aa5fbf7e6$var$STRING_ITERATOR = 'String Iterator';
var $a344ed9aa5fbf7e6$var$setInternalState = $1tUn8.set;
var $a344ed9aa5fbf7e6$var$getInternalState = $1tUn8.getterFor($a344ed9aa5fbf7e6$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$41lLp(String, 'String', function(iterated) {
    $a344ed9aa5fbf7e6$var$setInternalState(this, {
        type: $a344ed9aa5fbf7e6$var$STRING_ITERATOR,
        string: String(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $a344ed9aa5fbf7e6$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = $a344ed9aa5fbf7e6$require$charAt(string, index);
    state.index += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("kJ8AO", function(module, exports) {

var $eH29a = parcelRequire("eH29a");

var $4D8X3 = parcelRequire("4D8X3");
// `String.prototype.{ codePointAt, at }` methods implementation
var $f16eacf83aa990d6$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = String($4D8X3($this));
        var position = $eH29a(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $f16eacf83aa990d6$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $f16eacf83aa990d6$var$createMethod(true)
};

});

parcelRegister("41lLp", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $ig5W2 = parcelRequire("ig5W2");

var $7IbUy = parcelRequire("7IbUy");

var $gZHt7 = parcelRequire("gZHt7");

var $d1bnI = parcelRequire("d1bnI");

var $9R4Rw = parcelRequire("9R4Rw");

var $cmECB = parcelRequire("cmECB");

var $cBGa7 = parcelRequire("cBGa7");

var $k7ZB0 = parcelRequire("k7ZB0");

var $5KqUG = parcelRequire("5KqUG");

var $exayM = parcelRequire("exayM");
var $2ed8233a54bf5fbd$var$IteratorPrototype = $exayM.IteratorPrototype;
var $2ed8233a54bf5fbd$var$BUGGY_SAFARI_ITERATORS = $exayM.BUGGY_SAFARI_ITERATORS;
var $2ed8233a54bf5fbd$var$ITERATOR = $cBGa7('iterator');
var $2ed8233a54bf5fbd$var$KEYS = 'keys';
var $2ed8233a54bf5fbd$var$VALUES = 'values';
var $2ed8233a54bf5fbd$var$ENTRIES = 'entries';
var $2ed8233a54bf5fbd$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $ig5W2(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$2ed8233a54bf5fbd$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $2ed8233a54bf5fbd$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $2ed8233a54bf5fbd$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $2ed8233a54bf5fbd$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$2ed8233a54bf5fbd$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$2ed8233a54bf5fbd$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $7IbUy(anyNativeIterator.call(new Iterable()));
        if ($2ed8233a54bf5fbd$var$IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$k7ZB0 && $7IbUy(CurrentIteratorPrototype) !== $2ed8233a54bf5fbd$var$IteratorPrototype) {
                if ($gZHt7) $gZHt7(CurrentIteratorPrototype, $2ed8233a54bf5fbd$var$IteratorPrototype);
                else if (typeof CurrentIteratorPrototype[$2ed8233a54bf5fbd$var$ITERATOR] != 'function') $9R4Rw(CurrentIteratorPrototype, $2ed8233a54bf5fbd$var$ITERATOR, $2ed8233a54bf5fbd$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $d1bnI(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($k7ZB0) $5KqUG[TO_STRING_TAG] = $2ed8233a54bf5fbd$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (DEFAULT == $2ed8233a54bf5fbd$var$VALUES && nativeIterator && nativeIterator.name !== $2ed8233a54bf5fbd$var$VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return nativeIterator.call(this);
        };
    }
    // define iterator
    if ((!$k7ZB0 || FORCED) && IterablePrototype[$2ed8233a54bf5fbd$var$ITERATOR] !== defaultIterator) $9R4Rw(IterablePrototype, $2ed8233a54bf5fbd$var$ITERATOR, defaultIterator);
    $5KqUG[NAME] = defaultIterator;
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($2ed8233a54bf5fbd$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($2ed8233a54bf5fbd$var$KEYS),
            entries: getIterationMethod($2ed8233a54bf5fbd$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($2ed8233a54bf5fbd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $cmECB(IterablePrototype, KEY, methods[KEY]);
        } else $BCiHc({
            target: NAME,
            proto: true,
            forced: $2ed8233a54bf5fbd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    return methods;
};

});
parcelRegister("ig5W2", function(module, exports) {
'use strict';

var $exayM = parcelRequire("exayM");
var $d4ae5331ffc1a776$require$IteratorPrototype = $exayM.IteratorPrototype;

var $griNg = parcelRequire("griNg");

var $7McbS = parcelRequire("7McbS");

var $d1bnI = parcelRequire("d1bnI");

var $5KqUG = parcelRequire("5KqUG");
var $d4ae5331ffc1a776$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $griNg($d4ae5331ffc1a776$require$IteratorPrototype, {
        next: $7McbS(1, next)
    });
    $d1bnI(IteratorConstructor, TO_STRING_TAG, false, true);
    $5KqUG[TO_STRING_TAG] = $d4ae5331ffc1a776$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("exayM", function(module, exports) {
'use strict';

var $h9Yhi = parcelRequire("h9Yhi");

var $7IbUy = parcelRequire("7IbUy");

var $9R4Rw = parcelRequire("9R4Rw");

var $sIjo5 = parcelRequire("sIjo5");

var $cBGa7 = parcelRequire("cBGa7");

var $k7ZB0 = parcelRequire("k7ZB0");
var $a94c56ba5e363809$var$ITERATOR = $cBGa7('iterator');
var $a94c56ba5e363809$var$BUGGY_SAFARI_ITERATORS = false;
var $a94c56ba5e363809$var$returnThis = function() {
    return this;
};
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $a94c56ba5e363809$var$IteratorPrototype, $a94c56ba5e363809$var$PrototypeOfArrayIteratorPrototype, $a94c56ba5e363809$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $a94c56ba5e363809$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $a94c56ba5e363809$var$arrayIterator)) $a94c56ba5e363809$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $a94c56ba5e363809$var$PrototypeOfArrayIteratorPrototype = $7IbUy($7IbUy($a94c56ba5e363809$var$arrayIterator));
        if ($a94c56ba5e363809$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $a94c56ba5e363809$var$IteratorPrototype = $a94c56ba5e363809$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $a94c56ba5e363809$var$NEW_ITERATOR_PROTOTYPE = $a94c56ba5e363809$var$IteratorPrototype == undefined || $h9Yhi(function() {
    var test = {};
    // FF44- legacy iterators case
    return $a94c56ba5e363809$var$IteratorPrototype[$a94c56ba5e363809$var$ITERATOR].call(test) !== test;
});
if ($a94c56ba5e363809$var$NEW_ITERATOR_PROTOTYPE) $a94c56ba5e363809$var$IteratorPrototype = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!$k7ZB0 || $a94c56ba5e363809$var$NEW_ITERATOR_PROTOTYPE) && !$sIjo5($a94c56ba5e363809$var$IteratorPrototype, $a94c56ba5e363809$var$ITERATOR)) $9R4Rw($a94c56ba5e363809$var$IteratorPrototype, $a94c56ba5e363809$var$ITERATOR, $a94c56ba5e363809$var$returnThis);
module.exports = {
    IteratorPrototype: $a94c56ba5e363809$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $a94c56ba5e363809$var$BUGGY_SAFARI_ITERATORS
};

});




parcelRegister("5jw61", function(module, exports) {

var $jPgvX = parcelRequire("jPgvX");

var $9pCVV = parcelRequire("9pCVV");

var $2TYwx = parcelRequire("2TYwx");

var $9R4Rw = parcelRequire("9R4Rw");

var $cBGa7 = parcelRequire("cBGa7");
var $3de79fb61ac245ad$var$ITERATOR = $cBGa7('iterator');
var $3de79fb61ac245ad$var$TO_STRING_TAG = $cBGa7('toStringTag');
var $3de79fb61ac245ad$var$ArrayValues = $2TYwx.values;
for(var $3de79fb61ac245ad$var$COLLECTION_NAME in $9pCVV){
    var $3de79fb61ac245ad$var$Collection = $jPgvX[$3de79fb61ac245ad$var$COLLECTION_NAME];
    var $3de79fb61ac245ad$var$CollectionPrototype = $3de79fb61ac245ad$var$Collection && $3de79fb61ac245ad$var$Collection.prototype;
    if ($3de79fb61ac245ad$var$CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if ($3de79fb61ac245ad$var$CollectionPrototype[$3de79fb61ac245ad$var$ITERATOR] !== $3de79fb61ac245ad$var$ArrayValues) try {
            $9R4Rw($3de79fb61ac245ad$var$CollectionPrototype, $3de79fb61ac245ad$var$ITERATOR, $3de79fb61ac245ad$var$ArrayValues);
        } catch (error) {
            $3de79fb61ac245ad$var$CollectionPrototype[$3de79fb61ac245ad$var$ITERATOR] = $3de79fb61ac245ad$var$ArrayValues;
        }
        if (!$3de79fb61ac245ad$var$CollectionPrototype[$3de79fb61ac245ad$var$TO_STRING_TAG]) $9R4Rw($3de79fb61ac245ad$var$CollectionPrototype, $3de79fb61ac245ad$var$TO_STRING_TAG, $3de79fb61ac245ad$var$COLLECTION_NAME);
        if ($9pCVV[$3de79fb61ac245ad$var$COLLECTION_NAME]) for(var $3de79fb61ac245ad$var$METHOD_NAME in $2TYwx){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if ($3de79fb61ac245ad$var$CollectionPrototype[$3de79fb61ac245ad$var$METHOD_NAME] !== $2TYwx[$3de79fb61ac245ad$var$METHOD_NAME]) try {
                $9R4Rw($3de79fb61ac245ad$var$CollectionPrototype, $3de79fb61ac245ad$var$METHOD_NAME, $2TYwx[$3de79fb61ac245ad$var$METHOD_NAME]);
            } catch (error) {
                $3de79fb61ac245ad$var$CollectionPrototype[$3de79fb61ac245ad$var$METHOD_NAME] = $2TYwx[$3de79fb61ac245ad$var$METHOD_NAME];
            }
        }
    }
}

});
parcelRegister("9pCVV", function(module, exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});

parcelRegister("2TYwx", function(module, exports) {
'use strict';

var $eAYLm = parcelRequire("eAYLm");

var $goXTx = parcelRequire("goXTx");

var $5KqUG = parcelRequire("5KqUG");

var $1tUn8 = parcelRequire("1tUn8");

var $41lLp = parcelRequire("41lLp");
var $21cfaa9b88f266e0$var$ARRAY_ITERATOR = 'Array Iterator';
var $21cfaa9b88f266e0$var$setInternalState = $1tUn8.set;
var $21cfaa9b88f266e0$var$getInternalState = $1tUn8.getterFor($21cfaa9b88f266e0$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $41lLp(Array, 'Array', function(iterated, kind) {
    $21cfaa9b88f266e0$var$setInternalState(this, {
        type: $21cfaa9b88f266e0$var$ARRAY_ITERATOR,
        target: $eAYLm(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $21cfaa9b88f266e0$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == 'keys') return {
        value: index,
        done: false
    };
    if (kind == 'values') return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
$5KqUG.Arguments = $5KqUG.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$goXTx('keys');
$goXTx('values');
$goXTx('entries');

});
parcelRegister("goXTx", function(module, exports) {

var $cBGa7 = parcelRequire("cBGa7");

var $griNg = parcelRequire("griNg");

var $jFkUb = parcelRequire("jFkUb");
var $bf0d59179ba5b65b$var$UNSCOPABLES = $cBGa7('unscopables');
var $bf0d59179ba5b65b$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($bf0d59179ba5b65b$var$ArrayPrototype[$bf0d59179ba5b65b$var$UNSCOPABLES] == undefined) $jFkUb.f($bf0d59179ba5b65b$var$ArrayPrototype, $bf0d59179ba5b65b$var$UNSCOPABLES, {
    configurable: true,
    value: $griNg(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    $bf0d59179ba5b65b$var$ArrayPrototype[$bf0d59179ba5b65b$var$UNSCOPABLES][key] = true;
};

});




parcelRegister("6hk9K", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("5WsKq");

});

parcelRegister("4Z6an", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("8QlWM");

});

parcelRegister("bHQd7", function(module, exports) {
'use strict';

var $BCiHc = parcelRequire("BCiHc");

var $5Ca01 = parcelRequire("5Ca01");

var $h1VnZ = parcelRequire("h1VnZ");
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$BCiHc({
    target: 'Promise',
    stat: true
}, {
    'try': function(callbackfn) {
        var promiseCapability = $5Ca01.f(this);
        var result = $h1VnZ(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRegister("8Re0G", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("46rC3");

});


parcelRegister("72ISo", function(module, exports) {
/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */ (function(self) {
    'use strict';
    var nativeURLSearchParams = function() {
        // #41 Fix issue in RN
        try {
            if (self.URLSearchParams && new self.URLSearchParams('foo=bar').get('foo') === 'bar') return self.URLSearchParams;
        } catch (e) {}
        return null;
    }(), isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({
        a: 1
    }).toString() === 'a=1', // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams('s=%2B').get('s') === '+', __URLSearchParams__ = "__URLSearchParams__", // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? function() {
        var ampersandTest = new nativeURLSearchParams();
        ampersandTest.append('s', ' &');
        return ampersandTest.toString() === 's=+%26';
    }() : true, prototype = URLSearchParamsPolyfill.prototype, iterable = !!(self.Symbol && self.Symbol.iterator);
    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) return;
    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */ function URLSearchParamsPolyfill(search) {
        search = search || "";
        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) search = search.toString();
        this[__URLSearchParams__] = parseToDict(search);
    }
    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.append = function(name, value) {
        appendTo(this[__URLSearchParams__], name, value);
    };
    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */ prototype['delete'] = function(name) {
        delete this[__URLSearchParams__][name];
    };
    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */ prototype.get = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };
    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */ prototype.getAll = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name].slice(0) : [];
    };
    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */ prototype.has = function(name) {
        return hasOwnProperty(this[__URLSearchParams__], name);
    };
    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.set = function set(name, value) {
        this[__URLSearchParams__][name] = [
            '' + value
        ];
    };
    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */ prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for(key in dict){
            name = encode(key);
            for(i = 0, value = dict[key]; i < value.length; i++)query.push(name + '=' + encode(value[i]));
        }
        return query.join('&');
    };
    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = !forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy;
    var propValue;
    if (useProxy) {
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        propValue = new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target(new URLSearchParamsPolyfill(args[0]).toString());
            }
        });
        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
    } else propValue = URLSearchParamsPolyfill;
    /*
     * Apply polifill to global object and append other prototype into it
     */ Object.defineProperty(self, 'URLSearchParams', {
        value: propValue
    });
    var USPProto = self.URLSearchParams.prototype;
    USPProto.polyfill = true;
    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */ USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };
    /**
     * Sort all name-value pairs
     */ USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for(k in dict)keys.push(k);
        keys.sort();
        for(i = 0; i < keys.length; i++)this['delete'](keys[i]);
        for(i = 0; i < keys.length; i++){
            var key = keys[i], values = dict[key];
            for(j = 0; j < values.length; j++)this.append(key, values[j]);
        }
    };
    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([
                name,
                item
            ]);
        });
        return makeIterator(items);
    };
    if (iterable) USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }
    function decode(str) {
        return str.replace(/[ +]/g, '%20').replace(/(%[a-f0-9]{2})+/ig, function(match) {
            return decodeURIComponent(match);
        });
    }
    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if (iterable) iterator[self.Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function parseToDict(search) {
        var dict = {};
        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) for(var i = 0; i < search.length; i++){
                var item = search[i];
                if (isArray(item) && item.length === 2) appendTo(dict, item[0], item[1]);
                else throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
            }
            else {
                for(var key in search)if (search.hasOwnProperty(key)) appendTo(dict, key, search[key]);
            }
        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) search = search.slice(1);
            var pairs = search.split("&");
            for(var j = 0; j < pairs.length; j++){
                var value = pairs[j], index = value.indexOf('=');
                if (-1 < index) appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                else if (value) appendTo(dict, decode(value), '');
            }
        }
        return dict;
    }
    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value);
        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) dict[name].push(val);
        else dict[name] = [
            val
        ];
    }
    function isArray(val) {
        return !!val && '[object Array]' === Object.prototype.toString.call(val);
    }
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
})(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : module.exports);

});

parcelRegister("1YsVE", function(module, exports) {
"use strict";
var $1701d5b486f0990f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $h8cNM = parcelRequire("h8cNM");

var $aQCMu = parcelRequire("aQCMu");
/**
 * @class BehaviorSubject<T>
 */ var $1701d5b486f0990f$var$BehaviorSubject = function(_super) {
    $1701d5b486f0990f$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $aQCMu.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($h8cNM.Subject);
module.exports.BehaviorSubject = $1701d5b486f0990f$var$BehaviorSubject;

});
parcelRegister("h8cNM", function(module, exports) {
"use strict";
var $c78d1d33fd68c25e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iR1uX = parcelRequire("iR1uX");

var $dhIYH = parcelRequire("dhIYH");

var $7CWyX = parcelRequire("7CWyX");

var $aQCMu = parcelRequire("aQCMu");

var $l67F2 = parcelRequire("l67F2");

var $150Ju = parcelRequire("150Ju");
/**
 * @class SubjectSubscriber<T>
 */ var $c78d1d33fd68c25e$var$SubjectSubscriber = function(_super) {
    $c78d1d33fd68c25e$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($dhIYH.Subscriber);
module.exports.SubjectSubscriber = $c78d1d33fd68c25e$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $c78d1d33fd68c25e$var$Subject = function(_super) {
    $c78d1d33fd68c25e$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$150Ju.rxSubscriber] = function() {
        return new $c78d1d33fd68c25e$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $c78d1d33fd68c25e$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $aQCMu.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $aQCMu.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $aQCMu.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $aQCMu.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $aQCMu.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $7CWyX.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $7CWyX.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $l67F2.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $iR1uX.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $c78d1d33fd68c25e$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($iR1uX.Observable);
module.exports.Subject = $c78d1d33fd68c25e$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $c78d1d33fd68c25e$var$AnonymousSubject = function(_super) {
    $c78d1d33fd68c25e$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $7CWyX.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($c78d1d33fd68c25e$var$Subject);
module.exports.AnonymousSubject = $c78d1d33fd68c25e$var$AnonymousSubject;

});
parcelRegister("iR1uX", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $db9e56c4ae013226$export$77cea355fa80b5f4, (v) => $db9e56c4ae013226$export$77cea355fa80b5f4 = v);
var $db9e56c4ae013226$export$77cea355fa80b5f4;
"use strict";

var $1D1YG = parcelRequire("1D1YG");

var $ewfz4 = parcelRequire("ewfz4");

var $blbdM = parcelRequire("blbdM");

var $ncg8z = parcelRequire("ncg8z");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $db9e56c4ae013226$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $ewfz4.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($1D1YG.root.Rx && $1D1YG.root.Rx.config && $1D1YG.root.Rx.config.Promise) PromiseCtor = $1D1YG.root.Rx.config.Promise;
            else if ($1D1YG.root.Promise) PromiseCtor = $1D1YG.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$blbdM.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $ncg8z.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($1D1YG.root.Rx && $1D1YG.root.Rx.config && $1D1YG.root.Rx.config.Promise) PromiseCtor = $1D1YG.root.Rx.config.Promise;
            else if ($1D1YG.root.Promise) PromiseCtor = $1D1YG.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$db9e56c4ae013226$export$77cea355fa80b5f4 = $db9e56c4ae013226$var$Observable;

});
parcelRegister("1D1YG", function(module, exports) {

$parcel$export(module.exports, "root", () => $12faf7b833d6648c$export$e8e78c978b129247, (v) => $12faf7b833d6648c$export$e8e78c978b129247 = v);
var $12faf7b833d6648c$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $12faf7b833d6648c$var$__window = typeof window !== 'undefined' && window;
var $12faf7b833d6648c$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $12faf7b833d6648c$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $12faf7b833d6648c$var$_root = $12faf7b833d6648c$var$__window || $12faf7b833d6648c$var$__global || $12faf7b833d6648c$var$__self;
$12faf7b833d6648c$export$e8e78c978b129247 = $12faf7b833d6648c$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$12faf7b833d6648c$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});

parcelRegister("ewfz4", function(module, exports) {

$parcel$export(module.exports, "toSubscriber", () => $a92020a37feb333b$export$2a12c2cebbfd1087, (v) => $a92020a37feb333b$export$2a12c2cebbfd1087 = v);
var $a92020a37feb333b$export$2a12c2cebbfd1087;
"use strict";

var $dhIYH = parcelRequire("dhIYH");

var $150Ju = parcelRequire("150Ju");

var $ghlrh = parcelRequire("ghlrh");
function $a92020a37feb333b$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $dhIYH.Subscriber) return nextOrObserver;
        if (nextOrObserver[$150Ju.rxSubscriber]) return nextOrObserver[$150Ju.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $dhIYH.Subscriber($ghlrh.empty);
    return new $dhIYH.Subscriber(nextOrObserver, error, complete);
}
$a92020a37feb333b$export$2a12c2cebbfd1087 = $a92020a37feb333b$var$toSubscriber;

});
parcelRegister("dhIYH", function(module, exports) {
"use strict";
var $9abfc09b999efa4b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aRtSa = parcelRequire("aRtSa");

var $7CWyX = parcelRequire("7CWyX");

var $ghlrh = parcelRequire("ghlrh");

var $150Ju = parcelRequire("150Ju");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $9abfc09b999efa4b$var$Subscriber = function(_super) {
    $9abfc09b999efa4b$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $ghlrh.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $ghlrh.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($9abfc09b999efa4b$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$150Ju.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $9abfc09b999efa4b$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $9abfc09b999efa4b$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$150Ju.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($7CWyX.Subscription);
module.exports.Subscriber = $9abfc09b999efa4b$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9abfc09b999efa4b$var$SafeSubscriber = function(_super) {
    $9abfc09b999efa4b$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($aRtSa.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $ghlrh.empty) {
                context = Object.create(observerOrNext);
                if ($aRtSa.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($9abfc09b999efa4b$var$Subscriber);
function $9abfc09b999efa4b$var$isTrustedSubscriber(obj) {
    return obj instanceof $9abfc09b999efa4b$var$Subscriber || 'syncErrorThrowable' in obj && obj[$150Ju.rxSubscriber];
}

});
parcelRegister("aRtSa", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $7e8606b781e4f270$export$f6e2535fb5126e54, (v) => $7e8606b781e4f270$export$f6e2535fb5126e54 = v);
var $7e8606b781e4f270$export$f6e2535fb5126e54;
"use strict";
function $7e8606b781e4f270$var$isFunction(x) {
    return typeof x === 'function';
}
$7e8606b781e4f270$export$f6e2535fb5126e54 = $7e8606b781e4f270$var$isFunction;

});

parcelRegister("7CWyX", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $58d982592d63b19f$export$f55210826850c514, (v) => $58d982592d63b19f$export$f55210826850c514 = v);
var $58d982592d63b19f$export$f55210826850c514;
"use strict";

var $fFqNP = parcelRequire("fFqNP");

var $qhO9n = parcelRequire("qhO9n");

var $aRtSa = parcelRequire("aRtSa");

var $jZrjF = parcelRequire("jZrjF");

var $8kOgI = parcelRequire("8kOgI");

var $lTkKR = parcelRequire("lTkKR");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $58d982592d63b19f$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($aRtSa.isFunction(_unsubscribe)) {
            var trial = $jZrjF.tryCatch(_unsubscribe).call(this);
            if (trial === $8kOgI.errorObject) {
                hasErrors = true;
                errors = errors || ($8kOgI.errorObject.e instanceof $lTkKR.UnsubscriptionError ? $58d982592d63b19f$var$flattenUnsubscriptionErrors($8kOgI.errorObject.e.errors) : [
                    $8kOgI.errorObject.e
                ]);
            }
        }
        if ($fFqNP.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($qhO9n.isObject(sub)) {
                    var trial = $jZrjF.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $8kOgI.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $8kOgI.errorObject.e;
                        if (err instanceof $lTkKR.UnsubscriptionError) errors = errors.concat($58d982592d63b19f$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $lTkKR.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$58d982592d63b19f$export$f55210826850c514 = $58d982592d63b19f$var$Subscription;
function $58d982592d63b19f$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $lTkKR.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("fFqNP", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $b67f79cd8f5f6485$export$43bee75e5e14138e, (v) => $b67f79cd8f5f6485$export$43bee75e5e14138e = v);
var $b67f79cd8f5f6485$export$43bee75e5e14138e;
"use strict";
$b67f79cd8f5f6485$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("qhO9n", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $04f03e188ac56cc5$export$a6cdc56e425d0d0a, (v) => $04f03e188ac56cc5$export$a6cdc56e425d0d0a = v);
var $04f03e188ac56cc5$export$a6cdc56e425d0d0a;
"use strict";
function $04f03e188ac56cc5$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$04f03e188ac56cc5$export$a6cdc56e425d0d0a = $04f03e188ac56cc5$var$isObject;

});

parcelRegister("jZrjF", function(module, exports) {

$parcel$export(module.exports, "tryCatch", () => $e8d8e73de6edbed1$export$d234c058d1d4e435, (v) => $e8d8e73de6edbed1$export$d234c058d1d4e435 = v);
var $e8d8e73de6edbed1$export$d234c058d1d4e435;
"use strict";

var $8kOgI = parcelRequire("8kOgI");
var $e8d8e73de6edbed1$var$tryCatchTarget;
function $e8d8e73de6edbed1$var$tryCatcher() {
    try {
        return $e8d8e73de6edbed1$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $8kOgI.errorObject.e = e;
        return $8kOgI.errorObject;
    }
}
function $e8d8e73de6edbed1$var$tryCatch(fn) {
    $e8d8e73de6edbed1$var$tryCatchTarget = fn;
    return $e8d8e73de6edbed1$var$tryCatcher;
}
$e8d8e73de6edbed1$export$d234c058d1d4e435 = $e8d8e73de6edbed1$var$tryCatch;

});
parcelRegister("8kOgI", function(module, exports) {

$parcel$export(module.exports, "errorObject", () => $61172f4d5133559a$export$fc504b39d7c1176, (v) => $61172f4d5133559a$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $61172f4d5133559a$export$fc504b39d7c1176;
"use strict";
$61172f4d5133559a$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("lTkKR", function(module, exports) {
"use strict";
var $fefed58018720720$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $fefed58018720720$var$UnsubscriptionError = function(_super) {
    $fefed58018720720$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $fefed58018720720$var$UnsubscriptionError;

});


parcelRegister("ghlrh", function(module, exports) {

$parcel$export(module.exports, "empty", () => $bd9edd35862320a5$export$6e22c362a0406a2c, (v) => $bd9edd35862320a5$export$6e22c362a0406a2c = v);
var $bd9edd35862320a5$export$6e22c362a0406a2c;
"use strict";
$bd9edd35862320a5$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("150Ju", function(module, exports) {

$parcel$export(module.exports, "rxSubscriber", () => $0c96d3919db4f7db$export$77f77496d7cade10, (v) => $0c96d3919db4f7db$export$77f77496d7cade10 = v);
var $0c96d3919db4f7db$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $0c96d3919db4f7db$export$4a2e07ff24d010f0;
"use strict";

var $1D1YG = parcelRequire("1D1YG");
var $0c96d3919db4f7db$var$Symbol = $1D1YG.root.Symbol;
$0c96d3919db4f7db$export$77f77496d7cade10 = typeof $0c96d3919db4f7db$var$Symbol === 'function' && typeof $0c96d3919db4f7db$var$Symbol.for === 'function' ? $0c96d3919db4f7db$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$0c96d3919db4f7db$export$4a2e07ff24d010f0 = $0c96d3919db4f7db$export$77f77496d7cade10;

});



parcelRegister("blbdM", function(module, exports) {

$parcel$export(module.exports, "observable", () => $841a5c2e9a127591$export$5ab46cbf6120b33a, (v) => $841a5c2e9a127591$export$5ab46cbf6120b33a = v);
var $841a5c2e9a127591$export$7e68bb2e8ecea8fe;
var $841a5c2e9a127591$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $841a5c2e9a127591$export$a7c40509ff863847;
"use strict";

var $1D1YG = parcelRequire("1D1YG");
function $841a5c2e9a127591$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$841a5c2e9a127591$export$7e68bb2e8ecea8fe = $841a5c2e9a127591$var$getSymbolObservable;
$841a5c2e9a127591$export$5ab46cbf6120b33a = $841a5c2e9a127591$var$getSymbolObservable($1D1YG.root);
$841a5c2e9a127591$export$a7c40509ff863847 = $841a5c2e9a127591$export$5ab46cbf6120b33a;

});

parcelRegister("ncg8z", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $045ba888cbf6f87a$export$71f88a61afaa14d7, (v) => $045ba888cbf6f87a$export$71f88a61afaa14d7 = v);
var $045ba888cbf6f87a$export$a4627e546088548d;
var $045ba888cbf6f87a$export$71f88a61afaa14d7;
"use strict";

var $aJyDz = parcelRequire("aJyDz");
/* tslint:enable:max-line-length */ function $045ba888cbf6f87a$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $045ba888cbf6f87a$var$pipeFromArray(fns);
}
$045ba888cbf6f87a$export$a4627e546088548d = $045ba888cbf6f87a$var$pipe;
/* @internal */ function $045ba888cbf6f87a$var$pipeFromArray(fns) {
    if (!fns) return $aJyDz.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$045ba888cbf6f87a$export$71f88a61afaa14d7 = $045ba888cbf6f87a$var$pipeFromArray;

});
parcelRegister("aJyDz", function(module, exports) {

$parcel$export(module.exports, "noop", () => $7d08f993b1297eb6$export$8793edee2d425525, (v) => $7d08f993b1297eb6$export$8793edee2d425525 = v);
var $7d08f993b1297eb6$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $7d08f993b1297eb6$var$noop() {}
$7d08f993b1297eb6$export$8793edee2d425525 = $7d08f993b1297eb6$var$noop;

});



parcelRegister("aQCMu", function(module, exports) {
"use strict";
var $7e5cd7d12420a8d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $7e5cd7d12420a8d4$var$ObjectUnsubscribedError = function(_super) {
    $7e5cd7d12420a8d4$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $7e5cd7d12420a8d4$var$ObjectUnsubscribedError;

});

parcelRegister("l67F2", function(module, exports) {
"use strict";
var $f5c019d0d1118cf6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7CWyX = parcelRequire("7CWyX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f5c019d0d1118cf6$var$SubjectSubscription = function(_super) {
    $f5c019d0d1118cf6$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($7CWyX.Subscription);
module.exports.SubjectSubscription = $f5c019d0d1118cf6$var$SubjectSubscription;

});



parcelRegister("2Y5Ku", function(module, exports) {

$parcel$export(module.exports, "async", () => $2295a4f1289ed91e$export$12af436354f1a4f7, (v) => $2295a4f1289ed91e$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $2295a4f1289ed91e$export$12af436354f1a4f7;
"use strict";

var $ixbO5 = parcelRequire("ixbO5");

var $lruEX = parcelRequire("lruEX");
$2295a4f1289ed91e$export$12af436354f1a4f7 = new $lruEX.AsyncScheduler($ixbO5.AsyncAction);

});
parcelRegister("ixbO5", function(module, exports) {
"use strict";
var $d7e477a55cb31026$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1D1YG = parcelRequire("1D1YG");

var $5RwVP = parcelRequire("5RwVP");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d7e477a55cb31026$var$AsyncAction = function(_super) {
    $d7e477a55cb31026$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $1D1YG.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $1D1YG.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($5RwVP.Action);
module.exports.AsyncAction = $d7e477a55cb31026$var$AsyncAction;

});
parcelRegister("5RwVP", function(module, exports) {
"use strict";
var $444b728ab664147b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7CWyX = parcelRequire("7CWyX");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $444b728ab664147b$var$Action = function(_super) {
    $444b728ab664147b$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($7CWyX.Subscription);
module.exports.Action = $444b728ab664147b$var$Action;

});


parcelRegister("lruEX", function(module, exports) {
"use strict";
var $f9c3e6f3ec6ac80c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6oHlV = parcelRequire("6oHlV");
var $f9c3e6f3ec6ac80c$var$AsyncScheduler = function(_super) {
    $f9c3e6f3ec6ac80c$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($6oHlV.Scheduler);
module.exports.AsyncScheduler = $f9c3e6f3ec6ac80c$var$AsyncScheduler;

});
parcelRegister("6oHlV", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $4a869ce5db30584b$export$d3e54bb8584cda7c, (v) => $4a869ce5db30584b$export$d3e54bb8584cda7c = v);
var $4a869ce5db30584b$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $4a869ce5db30584b$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$4a869ce5db30584b$export$d3e54bb8584cda7c = $4a869ce5db30584b$var$Scheduler;

});



parcelRegister("lFm6Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InvalidTokenError", () => $fc5e943fbd2450fe$export$b9721ef022f71a68);
$parcel$export(module.exports, "default", () => $fc5e943fbd2450fe$export$2e2bcd8739ae039);
function $fc5e943fbd2450fe$var$e(e) {
    this.message = e;
}
$fc5e943fbd2450fe$var$e.prototype = new Error, $fc5e943fbd2450fe$var$e.prototype.name = "InvalidCharacterError";
var $fc5e943fbd2450fe$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $fc5e943fbd2450fe$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $fc5e943fbd2450fe$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($fc5e943fbd2450fe$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $fc5e943fbd2450fe$var$r(t);
    }
}
function $fc5e943fbd2450fe$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $fc5e943fbd2450fe$var$o(e, r) {
    if ("string" != typeof e) throw new $fc5e943fbd2450fe$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($fc5e943fbd2450fe$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $fc5e943fbd2450fe$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$fc5e943fbd2450fe$export$b9721ef022f71a68.prototype = new Error, $fc5e943fbd2450fe$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $fc5e943fbd2450fe$export$2e2bcd8739ae039 = $fc5e943fbd2450fe$var$o;

});

parcelRegister("8vvfY", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $eCth9 = parcelRequire("eCth9");
$iR1uX.Observable.prototype.catch = $eCth9._catch;
$iR1uX.Observable.prototype._catch = $eCth9._catch;

});
parcelRegister("eCth9", function(module, exports) {

$parcel$export(module.exports, "_catch", () => $aa4b52d421b8f9d2$export$7f43fa37c3d8a0b3, (v) => $aa4b52d421b8f9d2$export$7f43fa37c3d8a0b3 = v);
var $aa4b52d421b8f9d2$export$7f43fa37c3d8a0b3;
"use strict";

var $cwyd4 = parcelRequire("cwyd4");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $aa4b52d421b8f9d2$var$_catch(selector) {
    return $cwyd4.catchError(selector)(this);
}
$aa4b52d421b8f9d2$export$7f43fa37c3d8a0b3 = $aa4b52d421b8f9d2$var$_catch;

});
parcelRegister("cwyd4", function(module, exports) {
"use strict";
var $91e3028aa78fc2bc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $eGHb9 = parcelRequire("eGHb9");

var $dCggx = parcelRequire("dCggx");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $91e3028aa78fc2bc$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $91e3028aa78fc2bc$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $91e3028aa78fc2bc$var$catchError;
var $91e3028aa78fc2bc$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $91e3028aa78fc2bc$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $91e3028aa78fc2bc$var$CatchSubscriber = function(_super) {
    $91e3028aa78fc2bc$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dCggx.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($eGHb9.OuterSubscriber);

});
parcelRegister("eGHb9", function(module, exports) {
"use strict";
var $ab167b584d58f5bb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ab167b584d58f5bb$var$OuterSubscriber = function(_super) {
    $ab167b584d58f5bb$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($dhIYH.Subscriber);
module.exports.OuterSubscriber = $ab167b584d58f5bb$var$OuterSubscriber;

});

parcelRegister("dCggx", function(module, exports) {

$parcel$export(module.exports, "subscribeToResult", () => $9e9b71063ef80944$export$d0604af3321cfb1b, (v) => $9e9b71063ef80944$export$d0604af3321cfb1b = v);
var $9e9b71063ef80944$export$d0604af3321cfb1b;
"use strict";

var $1D1YG = parcelRequire("1D1YG");

var $3Q12k = parcelRequire("3Q12k");

var $4envA = parcelRequire("4envA");

var $qhO9n = parcelRequire("qhO9n");

var $iR1uX = parcelRequire("iR1uX");

var $9A1xs = parcelRequire("9A1xs");

var $7PqbB = parcelRequire("7PqbB");

var $blbdM = parcelRequire("blbdM");
function $9e9b71063ef80944$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $7PqbB.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $iR1uX.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($3Q12k.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($4envA.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $1D1YG.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$9A1xs.iterator] === 'function') {
        var iterator = result[$9A1xs.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$blbdM.observable] === 'function') {
        var obs = result[$blbdM.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $7PqbB.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $qhO9n.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$9e9b71063ef80944$export$d0604af3321cfb1b = $9e9b71063ef80944$var$subscribeToResult;

});
parcelRegister("3Q12k", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $2cb7083f37b63807$export$1e2f57719e155213, (v) => $2cb7083f37b63807$export$1e2f57719e155213 = v);
var $2cb7083f37b63807$export$1e2f57719e155213;
"use strict";
$2cb7083f37b63807$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("4envA", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $314ab48478ff5597$export$4369c812aac99591, (v) => $314ab48478ff5597$export$4369c812aac99591 = v);
var $314ab48478ff5597$export$4369c812aac99591;
"use strict";
function $314ab48478ff5597$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$314ab48478ff5597$export$4369c812aac99591 = $314ab48478ff5597$var$isPromise;

});

parcelRegister("9A1xs", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $6f98ab5ec1b0f0a8$export$6f58e2338da23f4d, (v) => $6f98ab5ec1b0f0a8$export$6f58e2338da23f4d = v);
var $6f98ab5ec1b0f0a8$export$77b88d321d1c84c6;
var $6f98ab5ec1b0f0a8$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $6f98ab5ec1b0f0a8$export$9785f547d3164dac;
"use strict";

var $1D1YG = parcelRequire("1D1YG");
function $6f98ab5ec1b0f0a8$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$6f98ab5ec1b0f0a8$export$77b88d321d1c84c6 = $6f98ab5ec1b0f0a8$var$symbolIteratorPonyfill;
$6f98ab5ec1b0f0a8$export$6f58e2338da23f4d = $6f98ab5ec1b0f0a8$var$symbolIteratorPonyfill($1D1YG.root);
$6f98ab5ec1b0f0a8$export$9785f547d3164dac = $6f98ab5ec1b0f0a8$export$6f58e2338da23f4d;

});

parcelRegister("7PqbB", function(module, exports) {
"use strict";
var $5b319bd450795496$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5b319bd450795496$var$InnerSubscriber = function(_super) {
    $5b319bd450795496$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($dhIYH.Subscriber);
module.exports.InnerSubscriber = $5b319bd450795496$var$InnerSubscriber;

});





parcelRegister("gRWGT", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $5voK2 = parcelRequire("5voK2");
$iR1uX.Observable.prototype.combineLatest = $5voK2.combineLatest;

});
parcelRegister("5voK2", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $40230a256c7cce87$export$77fa7d86f5204e8a, (v) => $40230a256c7cce87$export$77fa7d86f5204e8a = v);
var $40230a256c7cce87$export$77fa7d86f5204e8a;
"use strict";

var $eV1D7 = parcelRequire("eV1D7");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $40230a256c7cce87$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $eV1D7.combineLatest.apply(void 0, observables)(this);
}
$40230a256c7cce87$export$77fa7d86f5204e8a = $40230a256c7cce87$var$combineLatest;

});
parcelRegister("eV1D7", function(module, exports) {
"use strict";
var $adc7a73e96f1494c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3ocmU = parcelRequire("3ocmU");

var $fFqNP = parcelRequire("fFqNP");

var $eGHb9 = parcelRequire("eGHb9");

var $dCggx = parcelRequire("dCggx");
var $adc7a73e96f1494c$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $adc7a73e96f1494c$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $fFqNP.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $3ocmU.ArrayObservable([
            source
        ].concat(observables)), new $adc7a73e96f1494c$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $adc7a73e96f1494c$var$combineLatest;
var $adc7a73e96f1494c$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adc7a73e96f1494c$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $adc7a73e96f1494c$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adc7a73e96f1494c$var$CombineLatestSubscriber = function(_super) {
    $adc7a73e96f1494c$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($adc7a73e96f1494c$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($dCggx.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $adc7a73e96f1494c$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($eGHb9.OuterSubscriber);
module.exports.CombineLatestSubscriber = $adc7a73e96f1494c$var$CombineLatestSubscriber;

});
parcelRegister("3ocmU", function(module, exports) {
"use strict";
var $277d351ffb8b57a3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iR1uX = parcelRequire("iR1uX");

var $1AvOM = parcelRequire("1AvOM");

var $3t0e5 = parcelRequire("3t0e5");

var $04Zqi = parcelRequire("04Zqi");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $277d351ffb8b57a3$var$ArrayObservable = function(_super) {
    $277d351ffb8b57a3$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($04Zqi.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $1AvOM.ScalarObservable(array[0], scheduler);
        else return new $3t0e5.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($iR1uX.Observable);
module.exports.ArrayObservable = $277d351ffb8b57a3$var$ArrayObservable;

});
parcelRegister("1AvOM", function(module, exports) {
"use strict";
var $1281d59ef968b789$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iR1uX = parcelRequire("iR1uX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $1281d59ef968b789$var$ScalarObservable = function(_super) {
    $1281d59ef968b789$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($iR1uX.Observable);
module.exports.ScalarObservable = $1281d59ef968b789$var$ScalarObservable;

});

parcelRegister("3t0e5", function(module, exports) {
"use strict";
var $2864417256a9794a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iR1uX = parcelRequire("iR1uX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2864417256a9794a$var$EmptyObservable = function(_super) {
    $2864417256a9794a$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($iR1uX.Observable);
module.exports.EmptyObservable = $2864417256a9794a$var$EmptyObservable;

});

parcelRegister("04Zqi", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $00f0052c6cd66584$export$187e35932e88c15c, (v) => $00f0052c6cd66584$export$187e35932e88c15c = v);
var $00f0052c6cd66584$export$187e35932e88c15c;
"use strict";
function $00f0052c6cd66584$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$00f0052c6cd66584$export$187e35932e88c15c = $00f0052c6cd66584$var$isScheduler;

});





parcelRegister("3Q9Rs", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $ipQ3A = parcelRequire("ipQ3A");
$iR1uX.Observable.prototype.count = $ipQ3A.count;

});
parcelRegister("ipQ3A", function(module, exports) {

$parcel$export(module.exports, "count", () => $d682f133a68ad46b$export$85b9a36db797e02b, (v) => $d682f133a68ad46b$export$85b9a36db797e02b = v);
var $d682f133a68ad46b$export$85b9a36db797e02b;
"use strict";

var $4wSPj = parcelRequire("4wSPj");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $d682f133a68ad46b$var$count(predicate) {
    return $4wSPj.count(predicate)(this);
}
$d682f133a68ad46b$export$85b9a36db797e02b = $d682f133a68ad46b$var$count;

});
parcelRegister("4wSPj", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($dhIYH.Subscriber);

});



parcelRegister("lksCl", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $kIiG2 = parcelRequire("kIiG2");
$iR1uX.Observable.prototype.delay = $kIiG2.delay;

});
parcelRegister("kIiG2", function(module, exports) {

$parcel$export(module.exports, "delay", () => $f146679094b59d5c$export$1391212d75b2ee65, (v) => $f146679094b59d5c$export$1391212d75b2ee65 = v);
var $f146679094b59d5c$export$1391212d75b2ee65;
"use strict";

var $2Y5Ku = parcelRequire("2Y5Ku");

var $hLMBE = parcelRequire("hLMBE");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $f146679094b59d5c$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $2Y5Ku.async;
    return $hLMBE.delay(delay, scheduler)(this);
}
$f146679094b59d5c$export$1391212d75b2ee65 = $f146679094b59d5c$var$delay;

});
parcelRegister("hLMBE", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Y5Ku = parcelRequire("2Y5Ku");

var $abVJx = parcelRequire("abVJx");

var $dhIYH = parcelRequire("dhIYH");

var $kffBf = parcelRequire("kffBf");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $2Y5Ku.async;
    var absoluteDelay = $abVJx.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($kffBf.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($kffBf.Notification.createComplete());
    };
    return DelaySubscriber;
}($dhIYH.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});
parcelRegister("abVJx", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $76b7b7258d779837$export$871608497c498473, (v) => $76b7b7258d779837$export$871608497c498473 = v);
var $76b7b7258d779837$export$871608497c498473;
"use strict";
function $76b7b7258d779837$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$76b7b7258d779837$export$871608497c498473 = $76b7b7258d779837$var$isDate;

});

parcelRegister("kffBf", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $ebd14f2a52eb7388$export$14834abbfce3b8cd, (v) => $ebd14f2a52eb7388$export$14834abbfce3b8cd = v);
var $ebd14f2a52eb7388$export$14834abbfce3b8cd;
"use strict";

var $iR1uX = parcelRequire("iR1uX");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $ebd14f2a52eb7388$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $iR1uX.Observable.of(this.value);
            case 'E':
                return $iR1uX.Observable.throw(this.error);
            case 'C':
                return $iR1uX.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$ebd14f2a52eb7388$export$14834abbfce3b8cd = $ebd14f2a52eb7388$var$Notification;

});




parcelRegister("26bWo", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $5C1go = parcelRequire("5C1go");
$iR1uX.Observable.prototype.do = $5C1go._do;
$iR1uX.Observable.prototype._do = $5C1go._do;

});
parcelRegister("5C1go", function(module, exports) {

$parcel$export(module.exports, "_do", () => $41617b40e181f081$export$6e1c2ce23f3c9991, (v) => $41617b40e181f081$export$6e1c2ce23f3c9991 = v);
var $41617b40e181f081$export$6e1c2ce23f3c9991;
"use strict";

var $hdzRB = parcelRequire("hdzRB");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $41617b40e181f081$var$_do(nextOrObserver, error, complete) {
    return $hdzRB.tap(nextOrObserver, error, complete)(this);
}
$41617b40e181f081$export$6e1c2ce23f3c9991 = $41617b40e181f081$var$_do;

});
parcelRegister("hdzRB", function(module, exports) {
"use strict";
var $c88f784f6c43dc54$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $c88f784f6c43dc54$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $c88f784f6c43dc54$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $c88f784f6c43dc54$var$tap;
var $c88f784f6c43dc54$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c88f784f6c43dc54$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c88f784f6c43dc54$var$DoSubscriber = function(_super) {
    $c88f784f6c43dc54$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $dhIYH.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($dhIYH.Subscriber);

});



parcelRegister("jutCu", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $cM5lQ = parcelRequire("cM5lQ");
$iR1uX.Observable.prototype.filter = $cM5lQ.filter;

});
parcelRegister("cM5lQ", function(module, exports) {

$parcel$export(module.exports, "filter", () => $94ce1e6b446d4b03$export$3dea766d36a8935f, (v) => $94ce1e6b446d4b03$export$3dea766d36a8935f = v);
var $94ce1e6b446d4b03$export$3dea766d36a8935f;
"use strict";

var $9Vyy1 = parcelRequire("9Vyy1");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $94ce1e6b446d4b03$var$filter(predicate, thisArg) {
    return $9Vyy1.filter(predicate, thisArg)(this);
}
$94ce1e6b446d4b03$export$3dea766d36a8935f = $94ce1e6b446d4b03$var$filter;

});
parcelRegister("9Vyy1", function(module, exports) {
"use strict";
var $73a43c6214c90f86$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $73a43c6214c90f86$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $73a43c6214c90f86$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $73a43c6214c90f86$var$filter;
var $73a43c6214c90f86$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $73a43c6214c90f86$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $73a43c6214c90f86$var$FilterSubscriber = function(_super) {
    $73a43c6214c90f86$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($dhIYH.Subscriber);

});



parcelRegister("dTyba", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $6KsbF = parcelRequire("6KsbF");
$iR1uX.Observable.prototype.map = $6KsbF.map;

});
parcelRegister("6KsbF", function(module, exports) {

$parcel$export(module.exports, "map", () => $4e9ce757d6236ca2$export$871de8747c9eaa88, (v) => $4e9ce757d6236ca2$export$871de8747c9eaa88 = v);
var $4e9ce757d6236ca2$export$871de8747c9eaa88;
"use strict";

var $hlLxr = parcelRequire("hlLxr");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $4e9ce757d6236ca2$var$map(project, thisArg) {
    return $hlLxr.map(project, thisArg)(this);
}
$4e9ce757d6236ca2$export$871de8747c9eaa88 = $4e9ce757d6236ca2$var$map;

});
parcelRegister("hlLxr", function(module, exports) {
"use strict";
var $034278dee0e035dc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $034278dee0e035dc$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $034278dee0e035dc$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $034278dee0e035dc$var$map;
var $034278dee0e035dc$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $034278dee0e035dc$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $034278dee0e035dc$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $034278dee0e035dc$var$MapSubscriber = function(_super) {
    $034278dee0e035dc$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($dhIYH.Subscriber);

});



parcelRegister("01LJJ", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $d69cD = parcelRequire("d69cD");
$iR1uX.Observable.prototype.mergeMap = $d69cD.mergeMap;
$iR1uX.Observable.prototype.flatMap = $d69cD.mergeMap;

});
parcelRegister("d69cD", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $9892f95c4469e09f$export$6b9f6c0d32c093f9, (v) => $9892f95c4469e09f$export$6b9f6c0d32c093f9 = v);
var $9892f95c4469e09f$export$6b9f6c0d32c093f9;
"use strict";

var $8ScE4 = parcelRequire("8ScE4");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $9892f95c4469e09f$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $8ScE4.mergeMap(project, resultSelector, concurrent)(this);
}
$9892f95c4469e09f$export$6b9f6c0d32c093f9 = $9892f95c4469e09f$var$mergeMap;

});
parcelRegister("8ScE4", function(module, exports) {
"use strict";
var $675d2cfa5ef4cf57$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dCggx = parcelRequire("dCggx");

var $eGHb9 = parcelRequire("eGHb9");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $675d2cfa5ef4cf57$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $675d2cfa5ef4cf57$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $675d2cfa5ef4cf57$var$mergeMap;
var $675d2cfa5ef4cf57$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $675d2cfa5ef4cf57$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $675d2cfa5ef4cf57$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $675d2cfa5ef4cf57$var$MergeMapSubscriber = function(_super) {
    $675d2cfa5ef4cf57$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($dCggx.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($eGHb9.OuterSubscriber);
module.exports.MergeMapSubscriber = $675d2cfa5ef4cf57$var$MergeMapSubscriber;

});



parcelRegister("LJe1p", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $eG743 = parcelRequire("eG743");
$iR1uX.Observable.prototype.concatMap = $eG743.concatMap;

});
parcelRegister("eG743", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $aafa77cbcd67ee4a$export$c28c8388be0ab31a, (v) => $aafa77cbcd67ee4a$export$c28c8388be0ab31a = v);
var $aafa77cbcd67ee4a$export$c28c8388be0ab31a;
"use strict";

var $9RJfp = parcelRequire("9RJfp");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $aafa77cbcd67ee4a$var$concatMap(project, resultSelector) {
    return $9RJfp.concatMap(project, resultSelector)(this);
}
$aafa77cbcd67ee4a$export$c28c8388be0ab31a = $aafa77cbcd67ee4a$var$concatMap;

});
parcelRegister("9RJfp", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $01da84cc63235510$export$c28c8388be0ab31a, (v) => $01da84cc63235510$export$c28c8388be0ab31a = v);
var $01da84cc63235510$export$c28c8388be0ab31a;
"use strict";

var $8ScE4 = parcelRequire("8ScE4");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $01da84cc63235510$var$concatMap(project, resultSelector) {
    return $8ScE4.mergeMap(project, resultSelector, 1);
}
$01da84cc63235510$export$c28c8388be0ab31a = $01da84cc63235510$var$concatMap;

});



parcelRegister("7FASC", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $lWcuD = parcelRequire("lWcuD");
$iR1uX.Observable.prototype.retryWhen = $lWcuD.retryWhen;

});
parcelRegister("lWcuD", function(module, exports) {

$parcel$export(module.exports, "retryWhen", () => $ff88b4a0c26798f7$export$1281551253cfee02, (v) => $ff88b4a0c26798f7$export$1281551253cfee02 = v);
var $ff88b4a0c26798f7$export$1281551253cfee02;
"use strict";

var $5US5p = parcelRequire("5US5p");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $ff88b4a0c26798f7$var$retryWhen(notifier) {
    return $5US5p.retryWhen(notifier)(this);
}
$ff88b4a0c26798f7$export$1281551253cfee02 = $ff88b4a0c26798f7$var$retryWhen;

});
parcelRegister("5US5p", function(module, exports) {
"use strict";
var $44ec231a7e90802a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $h8cNM = parcelRequire("h8cNM");

var $jZrjF = parcelRequire("jZrjF");

var $8kOgI = parcelRequire("8kOgI");

var $eGHb9 = parcelRequire("eGHb9");

var $dCggx = parcelRequire("dCggx");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $44ec231a7e90802a$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $44ec231a7e90802a$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $44ec231a7e90802a$var$retryWhen;
var $44ec231a7e90802a$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $44ec231a7e90802a$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $44ec231a7e90802a$var$RetryWhenSubscriber = function(_super) {
    $44ec231a7e90802a$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $h8cNM.Subject();
                retries = $jZrjF.tryCatch(this.notifier)(errors);
                if (retries === $8kOgI.errorObject) return _super.prototype.error.call(this, $8kOgI.errorObject.e);
                retriesSubscription = $dCggx.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($eGHb9.OuterSubscriber);

});



parcelRegister("hGx2X", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $dCLpM = parcelRequire("dCLpM");
$iR1uX.Observable.prototype.share = $dCLpM.share;

});
parcelRegister("dCLpM", function(module, exports) {

$parcel$export(module.exports, "share", () => $028f48afb2151a90$export$ed80d9de1d9df928, (v) => $028f48afb2151a90$export$ed80d9de1d9df928 = v);
var $028f48afb2151a90$export$ed80d9de1d9df928;
"use strict";

var $3VLN6 = parcelRequire("3VLN6");
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $028f48afb2151a90$var$share() {
    return $3VLN6.share()(this);
}
$028f48afb2151a90$export$ed80d9de1d9df928 = $028f48afb2151a90$var$share;

});
parcelRegister("3VLN6", function(module, exports) {

$parcel$export(module.exports, "share", () => $2dcbc4409a7eeaf0$export$ed80d9de1d9df928, (v) => $2dcbc4409a7eeaf0$export$ed80d9de1d9df928 = v);
var $2dcbc4409a7eeaf0$export$ed80d9de1d9df928;
"use strict";

var $62LP5 = parcelRequire("62LP5");

var $88OWy = parcelRequire("88OWy");

var $h8cNM = parcelRequire("h8cNM");
function $2dcbc4409a7eeaf0$var$shareSubjectFactory() {
    return new $h8cNM.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $2dcbc4409a7eeaf0$var$share() {
    return function(source) {
        return $88OWy.refCount()($62LP5.multicast($2dcbc4409a7eeaf0$var$shareSubjectFactory)(source));
    };
}
$2dcbc4409a7eeaf0$export$ed80d9de1d9df928 = $2dcbc4409a7eeaf0$var$share;

});
parcelRegister("62LP5", function(module, exports) {

$parcel$export(module.exports, "multicast", () => $466806a16f03c10a$export$1364843af8d5a963, (v) => $466806a16f03c10a$export$1364843af8d5a963 = v);
var $466806a16f03c10a$export$1364843af8d5a963;
var $466806a16f03c10a$export$150d52413393bf2c;
"use strict";

var $f9CR7 = parcelRequire("f9CR7");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $466806a16f03c10a$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $466806a16f03c10a$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $f9CR7.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$466806a16f03c10a$export$1364843af8d5a963 = $466806a16f03c10a$var$multicast;
var $466806a16f03c10a$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$466806a16f03c10a$export$150d52413393bf2c = $466806a16f03c10a$var$MulticastOperator;

});
parcelRegister("f9CR7", function(module, exports) {
"use strict";
var $b085d636dde13bc0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $h8cNM = parcelRequire("h8cNM");

var $iR1uX = parcelRequire("iR1uX");

var $dhIYH = parcelRequire("dhIYH");

var $7CWyX = parcelRequire("7CWyX");

var $88OWy = parcelRequire("88OWy");
/**
 * @class ConnectableObservable<T>
 */ var $b085d636dde13bc0$var$ConnectableObservable = function(_super) {
    $b085d636dde13bc0$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $7CWyX.Subscription();
            connection.add(this.source.subscribe(new $b085d636dde13bc0$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $7CWyX.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $88OWy.refCount()(this);
    };
    return ConnectableObservable;
}($iR1uX.Observable);
module.exports.ConnectableObservable = $b085d636dde13bc0$var$ConnectableObservable;
var $b085d636dde13bc0$var$connectableProto = $b085d636dde13bc0$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $b085d636dde13bc0$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $b085d636dde13bc0$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $b085d636dde13bc0$var$connectableProto.getSubject
    },
    connect: {
        value: $b085d636dde13bc0$var$connectableProto.connect
    },
    refCount: {
        value: $b085d636dde13bc0$var$connectableProto.refCount
    }
};
var $b085d636dde13bc0$var$ConnectableSubscriber = function(_super) {
    $b085d636dde13bc0$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($h8cNM.SubjectSubscriber);
var $b085d636dde13bc0$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $b085d636dde13bc0$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $b085d636dde13bc0$var$RefCountSubscriber = function(_super) {
    $b085d636dde13bc0$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($dhIYH.Subscriber);

});
parcelRegister("88OWy", function(module, exports) {
"use strict";
var $5ed696604805d3f3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");
function $5ed696604805d3f3$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $5ed696604805d3f3$var$RefCountOperator(source));
    };
}
module.exports.refCount = $5ed696604805d3f3$var$refCount;
var $5ed696604805d3f3$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $5ed696604805d3f3$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $5ed696604805d3f3$var$RefCountSubscriber = function(_super) {
    $5ed696604805d3f3$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($dhIYH.Subscriber);

});






parcelRegister("gZoFY", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $ggDr0 = parcelRequire("ggDr0");
$iR1uX.Observable.prototype.take = $ggDr0.take;

});
parcelRegister("ggDr0", function(module, exports) {

$parcel$export(module.exports, "take", () => $bd7cbad45753b762$export$b7df5d561049483a, (v) => $bd7cbad45753b762$export$b7df5d561049483a = v);
var $bd7cbad45753b762$export$b7df5d561049483a;
"use strict";

var $4GeU7 = parcelRequire("4GeU7");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $bd7cbad45753b762$var$take(count) {
    return $4GeU7.take(count)(this);
}
$bd7cbad45753b762$export$b7df5d561049483a = $bd7cbad45753b762$var$take;

});
parcelRegister("4GeU7", function(module, exports) {
"use strict";
var $3686a553c669059d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");

var $jnu5r = parcelRequire("jnu5r");

var $3t0e5 = parcelRequire("3t0e5");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $3686a553c669059d$var$take(count) {
    return function(source) {
        if (count === 0) return new $3t0e5.EmptyObservable();
        else return source.lift(new $3686a553c669059d$var$TakeOperator(count));
    };
}
module.exports.take = $3686a553c669059d$var$take;
var $3686a553c669059d$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $jnu5r.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3686a553c669059d$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3686a553c669059d$var$TakeSubscriber = function(_super) {
    $3686a553c669059d$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($dhIYH.Subscriber);

});
parcelRegister("jnu5r", function(module, exports) {
"use strict";
var $e1b780e7ca89a7ea$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $e1b780e7ca89a7ea$var$ArgumentOutOfRangeError = function(_super) {
    $e1b780e7ca89a7ea$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $e1b780e7ca89a7ea$var$ArgumentOutOfRangeError;

});




parcelRegister("5gros", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $cxegI = parcelRequire("cxegI");
$iR1uX.Observable.ajax = $cxegI.ajax;

});
parcelRegister("cxegI", function(module, exports) {

$parcel$export(module.exports, "ajax", () => $9203a29140760f33$export$e68fce4c5f453854, (v) => $9203a29140760f33$export$e68fce4c5f453854 = v);
var $9203a29140760f33$export$e68fce4c5f453854;
"use strict";

var $dueNN = parcelRequire("dueNN");
$9203a29140760f33$export$e68fce4c5f453854 = $dueNN.AjaxObservable.create;

});
parcelRegister("dueNN", function(module, exports) {
"use strict";
var $9d198f1bcd1f7308$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1D1YG = parcelRequire("1D1YG");

var $jZrjF = parcelRequire("jZrjF");

var $8kOgI = parcelRequire("8kOgI");

var $iR1uX = parcelRequire("iR1uX");

var $dhIYH = parcelRequire("dhIYH");

var $hlLxr = parcelRequire("hlLxr");
function $9d198f1bcd1f7308$var$getCORSRequest() {
    if ($1D1YG.root.XMLHttpRequest) return new $1D1YG.root.XMLHttpRequest();
    else if (!!$1D1YG.root.XDomainRequest) return new $1D1YG.root.XDomainRequest();
    else throw new Error('CORS is not supported by your browser');
}
function $9d198f1bcd1f7308$var$getXMLHttpRequest() {
    if ($1D1YG.root.XMLHttpRequest) return new $1D1YG.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                'Msxml2.XMLHTTP',
                'Microsoft.XMLHTTP',
                'Msxml2.XMLHTTP.4.0'
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $1D1YG.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $1D1YG.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function $9d198f1bcd1f7308$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $9d198f1bcd1f7308$var$AjaxObservable({
        method: 'GET',
        url: url,
        headers: headers
    });
}
module.exports.ajaxGet = $9d198f1bcd1f7308$var$ajaxGet;
function $9d198f1bcd1f7308$var$ajaxPost(url, body, headers) {
    return new $9d198f1bcd1f7308$var$AjaxObservable({
        method: 'POST',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPost = $9d198f1bcd1f7308$var$ajaxPost;
function $9d198f1bcd1f7308$var$ajaxDelete(url, headers) {
    return new $9d198f1bcd1f7308$var$AjaxObservable({
        method: 'DELETE',
        url: url,
        headers: headers
    });
}
module.exports.ajaxDelete = $9d198f1bcd1f7308$var$ajaxDelete;
function $9d198f1bcd1f7308$var$ajaxPut(url, body, headers) {
    return new $9d198f1bcd1f7308$var$AjaxObservable({
        method: 'PUT',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPut = $9d198f1bcd1f7308$var$ajaxPut;
function $9d198f1bcd1f7308$var$ajaxPatch(url, body, headers) {
    return new $9d198f1bcd1f7308$var$AjaxObservable({
        method: 'PATCH',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPatch = $9d198f1bcd1f7308$var$ajaxPatch;
var $9d198f1bcd1f7308$var$mapResponse = $hlLxr.map(function(x, index) {
    return x.response;
});
function $9d198f1bcd1f7308$var$ajaxGetJSON(url, headers) {
    return $9d198f1bcd1f7308$var$mapResponse(new $9d198f1bcd1f7308$var$AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
module.exports.ajaxGetJSON = $9d198f1bcd1f7308$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $9d198f1bcd1f7308$var$AjaxObservable = function(_super) {
    $9d198f1bcd1f7308$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $9d198f1bcd1f7308$var$getCORSRequest.call(this) : $9d198f1bcd1f7308$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $9d198f1bcd1f7308$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $9d198f1bcd1f7308$var$ajaxGet;
        create.post = $9d198f1bcd1f7308$var$ajaxPost;
        create.delete = $9d198f1bcd1f7308$var$ajaxDelete;
        create.put = $9d198f1bcd1f7308$var$ajaxPut;
        create.patch = $9d198f1bcd1f7308$var$ajaxPatch;
        create.getJSON = $9d198f1bcd1f7308$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($iR1uX.Observable);
module.exports.AjaxObservable = $9d198f1bcd1f7308$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9d198f1bcd1f7308$var$AjaxSubscriber = function(_super) {
    $9d198f1bcd1f7308$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) headers['X-Requested-With'] = 'XMLHttpRequest';
        // ensure content type is set
        if (!('Content-Type' in headers) && !($1D1YG.root.FormData && request.body instanceof $1D1YG.root.FormData) && typeof request.body !== 'undefined') headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $9d198f1bcd1f7308$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $jZrjF.tryCatch(createXHR).call(request);
        if (xhr === $8kOgI.errorObject) this.error($8kOgI.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $jZrjF.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $jZrjF.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $8kOgI.errorObject) {
                this.error($8kOgI.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $jZrjF.tryCatch(xhr.send).call(xhr, body) : $jZrjF.tryCatch(xhr.send).call(xhr);
            if (result === $8kOgI.errorObject) {
                this.error($8kOgI.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === 'string') return body;
        else if ($1D1YG.root.FormData && body instanceof $1D1YG.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $9d198f1bcd1f7308$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($1D1YG.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $9d198f1bcd1f7308$var$AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === 'text' ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $9d198f1bcd1f7308$var$AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($dhIYH.Subscriber);
module.exports.AjaxSubscriber = $9d198f1bcd1f7308$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $9d198f1bcd1f7308$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $9d198f1bcd1f7308$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
module.exports.AjaxResponse = $9d198f1bcd1f7308$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $9d198f1bcd1f7308$var$AjaxError = function(_super) {
    $9d198f1bcd1f7308$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $9d198f1bcd1f7308$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
module.exports.AjaxError = $9d198f1bcd1f7308$var$AjaxError;
function $9d198f1bcd1f7308$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case 'json':
            if ('response' in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || 'null');
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return 'response' in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $9d198f1bcd1f7308$var$AjaxTimeoutError = function(_super) {
    $9d198f1bcd1f7308$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}($9d198f1bcd1f7308$var$AjaxError);
module.exports.AjaxTimeoutError = $9d198f1bcd1f7308$var$AjaxTimeoutError;

});



parcelRegister("izS6F", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $dqYij = parcelRequire("dqYij");
$iR1uX.Observable.empty = $dqYij.empty;

});
parcelRegister("dqYij", function(module, exports) {

$parcel$export(module.exports, "empty", () => $9c7c7949057135dd$export$6e22c362a0406a2c, (v) => $9c7c7949057135dd$export$6e22c362a0406a2c = v);
var $9c7c7949057135dd$export$6e22c362a0406a2c;
"use strict";

var $3t0e5 = parcelRequire("3t0e5");
$9c7c7949057135dd$export$6e22c362a0406a2c = $3t0e5.EmptyObservable.create;

});


parcelRegister("7HLwq", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $ddu5y = parcelRequire("ddu5y");
$iR1uX.Observable.from = $ddu5y.from;

});
parcelRegister("ddu5y", function(module, exports) {

$parcel$export(module.exports, "from", () => $99f3d4363bb1eea6$export$6788812c4e6611e6, (v) => $99f3d4363bb1eea6$export$6788812c4e6611e6 = v);
var $99f3d4363bb1eea6$export$6788812c4e6611e6;
"use strict";

var $l01p2 = parcelRequire("l01p2");
$99f3d4363bb1eea6$export$6788812c4e6611e6 = $l01p2.FromObservable.create;

});
parcelRegister("l01p2", function(module, exports) {
"use strict";
var $f49aaf9fe141de79$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fFqNP = parcelRequire("fFqNP");

var $3Q12k = parcelRequire("3Q12k");

var $4envA = parcelRequire("4envA");

var $cxRYj = parcelRequire("cxRYj");

var $BM7ar = parcelRequire("BM7ar");

var $3ocmU = parcelRequire("3ocmU");

var $2aDzo = parcelRequire("2aDzo");

var $9A1xs = parcelRequire("9A1xs");

var $iR1uX = parcelRequire("iR1uX");

var $5Cx2v = parcelRequire("5Cx2v");

var $blbdM = parcelRequire("blbdM");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f49aaf9fe141de79$var$FromObservable = function(_super) {
    $f49aaf9fe141de79$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$blbdM.observable] === 'function') {
                if (ish instanceof $iR1uX.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($fFqNP.isArray(ish)) return new $3ocmU.ArrayObservable(ish, scheduler);
            else if ($4envA.isPromise(ish)) return new $cxRYj.PromiseObservable(ish, scheduler);
            else if (typeof ish[$9A1xs.iterator] === 'function' || typeof ish === 'string') return new $BM7ar.IteratorObservable(ish, scheduler);
            else if ($3Q12k.isArrayLike(ish)) return new $2aDzo.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$blbdM.observable]().subscribe(subscriber);
        else return ish[$blbdM.observable]().subscribe(new $5Cx2v.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($iR1uX.Observable);
module.exports.FromObservable = $f49aaf9fe141de79$var$FromObservable;

});
parcelRegister("cxRYj", function(module, exports) {
"use strict";
var $92226ec7a486736e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1D1YG = parcelRequire("1D1YG");

var $iR1uX = parcelRequire("iR1uX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $92226ec7a486736e$var$PromiseObservable = function(_super) {
    $92226ec7a486736e$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $1D1YG.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($92226ec7a486736e$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($92226ec7a486736e$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($92226ec7a486736e$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $1D1YG.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($iR1uX.Observable);
module.exports.PromiseObservable = $92226ec7a486736e$var$PromiseObservable;
function $92226ec7a486736e$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $92226ec7a486736e$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});

parcelRegister("BM7ar", function(module, exports) {
"use strict";
var $0718c75fa815f198$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1D1YG = parcelRequire("1D1YG");

var $iR1uX = parcelRequire("iR1uX");

var $9A1xs = parcelRequire("9A1xs");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $0718c75fa815f198$var$IteratorObservable = function(_super) {
    $0718c75fa815f198$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $0718c75fa815f198$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($iR1uX.Observable);
module.exports.IteratorObservable = $0718c75fa815f198$var$IteratorObservable;
var $0718c75fa815f198$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$9A1xs.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $0718c75fa815f198$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $0718c75fa815f198$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$9A1xs.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $0718c75fa815f198$var$getIterator(obj) {
    var i = obj[$9A1xs.iterator];
    if (!i && typeof obj === 'string') return new $0718c75fa815f198$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $0718c75fa815f198$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$9A1xs.iterator]();
}
var $0718c75fa815f198$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $0718c75fa815f198$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$0718c75fa815f198$var$numberIsFinite(len)) return len;
    len = $0718c75fa815f198$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $0718c75fa815f198$var$maxSafeInteger) return $0718c75fa815f198$var$maxSafeInteger;
    return len;
}
function $0718c75fa815f198$var$numberIsFinite(value) {
    return typeof value === 'number' && $1D1YG.root.isFinite(value);
}
function $0718c75fa815f198$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});

parcelRegister("2aDzo", function(module, exports) {
"use strict";
var $194b35b31536e2af$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iR1uX = parcelRequire("iR1uX");

var $1AvOM = parcelRequire("1AvOM");

var $3t0e5 = parcelRequire("3t0e5");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $194b35b31536e2af$var$ArrayLikeObservable = function(_super) {
    $194b35b31536e2af$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $3t0e5.EmptyObservable();
        else if (length === 1) return new $1AvOM.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($iR1uX.Observable);
module.exports.ArrayLikeObservable = $194b35b31536e2af$var$ArrayLikeObservable;

});

parcelRegister("5Cx2v", function(module, exports) {
"use strict";
var $417a2150eb8405ab$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dhIYH = parcelRequire("dhIYH");

var $kffBf = parcelRequire("kffBf");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $417a2150eb8405ab$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $417a2150eb8405ab$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $417a2150eb8405ab$var$observeOn;
var $417a2150eb8405ab$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $417a2150eb8405ab$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $417a2150eb8405ab$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $417a2150eb8405ab$var$ObserveOnSubscriber = function(_super) {
    $417a2150eb8405ab$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $417a2150eb8405ab$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($kffBf.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($kffBf.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($kffBf.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($dhIYH.Subscriber);
module.exports.ObserveOnSubscriber = $417a2150eb8405ab$var$ObserveOnSubscriber;
var $417a2150eb8405ab$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $417a2150eb8405ab$var$ObserveOnMessage;

});




parcelRegister("1eNvz", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $2314j = parcelRequire("2314j");
$iR1uX.Observable.interval = $2314j.interval;

});
parcelRegister("2314j", function(module, exports) {

$parcel$export(module.exports, "interval", () => $17dcb0cd25465f4d$export$3174cdbf0a0cbc84, (v) => $17dcb0cd25465f4d$export$3174cdbf0a0cbc84 = v);
var $17dcb0cd25465f4d$export$3174cdbf0a0cbc84;
"use strict";

var $e7aVH = parcelRequire("e7aVH");
$17dcb0cd25465f4d$export$3174cdbf0a0cbc84 = $e7aVH.IntervalObservable.create;

});
parcelRegister("e7aVH", function(module, exports) {
"use strict";
var $a46a3286794d26d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7uTJY = parcelRequire("7uTJY");

var $iR1uX = parcelRequire("iR1uX");

var $2Y5Ku = parcelRequire("2Y5Ku");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a46a3286794d26d7$var$IntervalObservable = function(_super) {
    $a46a3286794d26d7$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $2Y5Ku.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$7uTJY.isNumeric(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $2Y5Ku.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $2Y5Ku.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($iR1uX.Observable);
module.exports.IntervalObservable = $a46a3286794d26d7$var$IntervalObservable;

});
parcelRegister("7uTJY", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $575692a0e3b9c399$export$e90fb89750dba83f, (v) => $575692a0e3b9c399$export$e90fb89750dba83f = v);
var $575692a0e3b9c399$export$e90fb89750dba83f;
"use strict";

var $fFqNP = parcelRequire("fFqNP");
function $575692a0e3b9c399$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$fFqNP.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$575692a0e3b9c399$export$e90fb89750dba83f = $575692a0e3b9c399$var$isNumeric;

});




parcelRegister("6PvQO", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $a8z89 = parcelRequire("a8z89");
$iR1uX.Observable.of = $a8z89.of;

});
parcelRegister("a8z89", function(module, exports) {

$parcel$export(module.exports, "of", () => $7615e6f100874e48$export$ba255e9e49e00608, (v) => $7615e6f100874e48$export$ba255e9e49e00608 = v);
var $7615e6f100874e48$export$ba255e9e49e00608;
"use strict";

var $3ocmU = parcelRequire("3ocmU");
$7615e6f100874e48$export$ba255e9e49e00608 = $3ocmU.ArrayObservable.of;

});


parcelRegister("lxzQd", function(module, exports) {
"use strict";

var $iR1uX = parcelRequire("iR1uX");

var $7McU2 = parcelRequire("7McU2");
$iR1uX.Observable.throw = $7McU2._throw;

});
parcelRegister("7McU2", function(module, exports) {

$parcel$export(module.exports, "_throw", () => $5a97064f9c732fa5$export$82a8af9b11518516, (v) => $5a97064f9c732fa5$export$82a8af9b11518516 = v);
var $5a97064f9c732fa5$export$82a8af9b11518516;
"use strict";

var $fUFy1 = parcelRequire("fUFy1");
$5a97064f9c732fa5$export$82a8af9b11518516 = $fUFy1.ErrorObservable.create;

});
parcelRegister("fUFy1", function(module, exports) {
"use strict";
var $b95c507eeaea0b40$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iR1uX = parcelRequire("iR1uX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $b95c507eeaea0b40$var$ErrorObservable = function(_super) {
    $b95c507eeaea0b40$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($iR1uX.Observable);
module.exports.ErrorObservable = $b95c507eeaea0b40$var$ErrorObservable;

});



parcelRegister("lt2oK", function(module, exports) {
"use strict";

var $uqBZi = parcelRequire("uqBZi");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $fa0e2aa279abaec1$var$dedupeFilenames;

var $fa0e2aa279abaec1$var$_parseFilename2 = $uqBZi((parcelRequire("YFu4r")));
function $fa0e2aa279abaec1$var$dedupeFilenames(array) {
    var nextArray = [];
    array.forEach(function(value) {
        var _parseFilename = (0, $fa0e2aa279abaec1$var$_parseFilename2["default"])(value), extname = _parseFilename.extname, name = _parseFilename.name;
        var count = 0;
        var nextValue = value;
        while(nextArray.includes(nextValue))nextValue = [
            name,
            "(".concat(++count, ")")
        ].filter(function(segment) {
            return segment;
        }).join(' ') + extname;
        nextArray.push(nextValue);
    });
    return nextArray;
}

});
parcelRegister("YFu4r", function(module, exports) {
"use strict";

var $uqBZi = parcelRequire("uqBZi");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0b65c8925a8447b2$var$parseFilename;

var $0b65c8925a8447b2$var$_toArray2 = $uqBZi((parcelRequire("cMqgQ")));
function $0b65c8925a8447b2$var$parseFilename(filename) {
    if (!filename) return {
        extname: '',
        name: ''
    };
    else if (~filename.indexOf('.')) {
        var _filename$split$rever = filename.split('.').reverse(), _filename$split$rever2 = (0, $0b65c8925a8447b2$var$_toArray2["default"])(_filename$split$rever), extensionWithoutDot = _filename$split$rever2[0], nameSegments = _filename$split$rever2.slice(1);
        return {
            extname: '.' + extensionWithoutDot,
            name: nameSegments.reverse().join('.')
        };
    } else return {
        extname: '',
        name: filename
    };
}

});
parcelRegister("cMqgQ", function(module, exports) {

var $5gVSf = parcelRequire("5gVSf");

var $73mGO = parcelRequire("73mGO");

var $hfguC = parcelRequire("hfguC");

var $9UQZx = parcelRequire("9UQZx");
function $94de588b1abb9c27$var$_toArray(r) {
    return $5gVSf(r) || $73mGO(r) || $hfguC(r) || $9UQZx();
}
module.exports = $94de588b1abb9c27$var$_toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5gVSf", function(module, exports) {
function $3d6b56eaca6f0c73$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $3d6b56eaca6f0c73$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("73mGO", function(module, exports) {
function $522a69e209583077$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $522a69e209583077$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hfguC", function(module, exports) {

var $Ly5tW = parcelRequire("Ly5tW");
function $c8e0a18044a4457a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $Ly5tW(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $Ly5tW(r, a) : void 0;
    }
}
module.exports = $c8e0a18044a4457a$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("Ly5tW", function(module, exports) {
function $08eed4f3c89eb6fe$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $08eed4f3c89eb6fe$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9UQZx", function(module, exports) {
function $7382730d79d24546$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7382730d79d24546$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("5yJeH", function(module, exports) {
"use strict";

var $uqBZi = parcelRequire("uqBZi");

var $kl7l1 = parcelRequire("kl7l1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectLineStreaming = void 0;

var $40c337ac67d09027$var$_objectWithoutProperties2 = $uqBZi((parcelRequire("kULI0")));

var $40c337ac67d09027$var$_regenerator = $uqBZi((parcelRequire("bugGq")));

var $40c337ac67d09027$var$_classPrivateFieldGet2 = $uqBZi((parcelRequire("kaIZq")));

var $40c337ac67d09027$var$_classPrivateFieldSet2 = $uqBZi((parcelRequire("jRlgX")));

var $40c337ac67d09027$var$_toConsumableArray2 = $uqBZi((parcelRequire("9S6VG")));

var $40c337ac67d09027$var$_asyncToGenerator2 = $uqBZi((parcelRequire("9aT6L")));

var $40c337ac67d09027$var$_classCallCheck2 = $uqBZi((parcelRequire("EwRGi")));

var $40c337ac67d09027$var$_createClass2 = $uqBZi((parcelRequire("4Yhbl")));

var $40c337ac67d09027$var$_defineProperty2 = $uqBZi((parcelRequire("fYOFJ")));

var $1YsVE = parcelRequire("1YsVE");

var $18pce = parcelRequire("18pce");

var $iR1uX = parcelRequire("iR1uX");

var $40c337ac67d09027$var$BFSE = $40c337ac67d09027$var$_interopRequireWildcard((parcelRequire("h1R35")));

var $40c337ac67d09027$var$_createDeferred = $uqBZi((parcelRequire("jtMJy")));

var $40c337ac67d09027$var$_crossFetch = $uqBZi((parcelRequire("bjYIg")));

var $eo2R4 = parcelRequire("eo2R4");

var $40c337ac67d09027$var$_WebSocketClientWithNetworkInformation = $uqBZi((parcelRequire("hAQWJ")));
var $40c337ac67d09027$var$_excluded = [
    "attachments"
]; // In order to keep file size down, only import the parts of rxjs that we use
function $40c337ac67d09027$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($40c337ac67d09027$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $40c337ac67d09027$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $kl7l1(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $40c337ac67d09027$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $40c337ac67d09027$var$DIRECT_LINE_VERSION = 'DirectLine/3.0';
var $40c337ac67d09027$var$MAX_RETRY_COUNT = 3;
var $40c337ac67d09027$var$refreshTokenLifetime = 1800000;
//const refreshTokenLifetime = 5000;
// const timeout = 20 * 1000;
var $40c337ac67d09027$var$refreshTokenInterval = $40c337ac67d09027$var$refreshTokenLifetime / 2;
var $40c337ac67d09027$var$StreamHandler = /*#__PURE__*/ function() {
    function StreamHandler(s, c$, sq) {
        (0, $40c337ac67d09027$var$_classCallCheck2["default"])(this, StreamHandler);
        (0, $40c337ac67d09027$var$_defineProperty2["default"])(this, "activityQueue", []);
        this.subscriber = s;
        this.connectionStatus$ = c$;
        this.shouldQueue = sq;
    }
    (0, $40c337ac67d09027$var$_createClass2["default"])(StreamHandler, [
        {
            key: "setSubscriber",
            value: function setSubscriber(s) {
                this.subscriber = s;
            }
        },
        {
            key: "processRequest",
            value: function() {
                var _processRequest = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee(request, logger) {
                    var streams, stream0, activitySetJson, activitySet, activity, attachments, stream, attachment, dataUri;
                    return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                streams = (0, $40c337ac67d09027$var$_toConsumableArray2["default"])(request.streams);
                                stream0 = streams.shift();
                                _context.next = 4;
                                return stream0.readAsString();
                            case 4:
                                activitySetJson = _context.sent;
                                activitySet = JSON.parse(activitySetJson);
                                if (!(activitySet.activities.length !== 1)) {
                                    _context.next = 9;
                                    break;
                                }
                                // Only one activity is expected in a set in streaming
                                this.subscriber.error(new Error('there should be exactly one activity'));
                                return _context.abrupt("return", $40c337ac67d09027$var$BFSE.StreamingResponse.create(500));
                            case 9:
                                activity = activitySet.activities[0];
                                if (!(streams.length > 0)) {
                                    _context.next = 21;
                                    break;
                                }
                                attachments = (0, $40c337ac67d09027$var$_toConsumableArray2["default"])(activity.attachments);
                            case 12:
                                if (!(stream = streams.shift())) {
                                    _context.next = 20;
                                    break;
                                }
                                _context.next = 15;
                                return stream.readAsString();
                            case 15:
                                attachment = _context.sent;
                                dataUri = 'data:text/plain;base64,' + attachment;
                                attachments.push({
                                    contentType: stream.contentType,
                                    contentUrl: dataUri
                                });
                                _context.next = 12;
                                break;
                            case 20:
                                activity.attachments = attachments;
                            case 21:
                                if (this.shouldQueue()) this.activityQueue.push(activity);
                                else this.subscriber.next(activity);
                                return _context.abrupt("return", $40c337ac67d09027$var$BFSE.StreamingResponse.create(200));
                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function processRequest(_x, _x2) {
                    return _processRequest.apply(this, arguments);
                }
                return processRequest;
            }()
        },
        {
            key: "flush",
            value: function flush() {
                var _this = this;
                this.connectionStatus$.subscribe(function() {});
                this.activityQueue.forEach(function(a) {
                    return _this.subscriber.next(a);
                });
                this.activityQueue = [];
            }
        },
        {
            key: "end",
            value: function end() {
                this.subscriber.complete();
            }
        }
    ]);
    return StreamHandler;
}();
var $40c337ac67d09027$var$_networkInformation = /*#__PURE__*/ new WeakMap();
var $40c337ac67d09027$var$DirectLineStreaming = /*#__PURE__*/ function() {
    function DirectLineStreaming(options) {
        var _this2 = this;
        (0, $40c337ac67d09027$var$_classCallCheck2["default"])(this, DirectLineStreaming);
        (0, $40c337ac67d09027$var$_defineProperty2["default"])(this, "connectionStatus$", new $1YsVE.BehaviorSubject($eo2R4.ConnectionStatus.Uninitialized));
        (0, $40c337ac67d09027$var$_defineProperty2["default"])(this, "_botAgent", '');
        $40c337ac67d09027$var$_networkInformation.set(this, {
            writable: true,
            value: void 0
        });
        // Rectifies `options.networkInformation`.
        var networkInformation = options === null || options === void 0 ? void 0 : options.networkInformation;
        if (typeof networkInformation === 'undefined' || typeof networkInformation.addEventListener === 'function' && typeof networkInformation.removeEventListener === 'function' && typeof networkInformation.type === 'string') (0, $40c337ac67d09027$var$_classPrivateFieldSet2["default"])(this, $40c337ac67d09027$var$_networkInformation, networkInformation);
        else console.warn('botframework-directlinejs: "networkInformation" option specified must be a `NetworkInformation`-like instance extending `EventTarget` interface with a `type` property returning a string.');
        this.token = options.token;
        this.refreshToken()["catch"](function() {
            _this2.connectionStatus$.next($eo2R4.ConnectionStatus.ExpiredToken);
        });
        this.domain = options.domain;
        if (options.conversationId) this.conversationId = options.conversationId;
        this._botAgent = this.getBotAgent(options.botAgent);
        this.queueActivities = true;
        this.activity$ = $iR1uX.Observable.create(/*#__PURE__*/ function() {
            var _ref = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee2(subscriber) {
                return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _this2.activitySubscriber = subscriber;
                            _this2.theStreamHandler = new $40c337ac67d09027$var$StreamHandler(subscriber, _this2.connectionStatus$, function() {
                                return _this2.queueActivities;
                            });
                            // Resolving connectDeferred will kick-off the connection.
                            _this2.connectDeferred.resolve();
                        case 3:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x3) {
                return _ref.apply(this, arguments);
            };
        }()).share();
        // connectWithRetryAsync() will create the connectDeferred object required in activity$.
        this.connectWithRetryAsync();
    }
    (0, $40c337ac67d09027$var$_createClass2["default"])(DirectLineStreaming, [
        {
            key: "reconnect",
            value: function reconnect(_ref2) {
                var conversationId = _ref2.conversationId, token = _ref2.token;
                if (this.connectionStatus$.getValue() === $eo2R4.ConnectionStatus.Ended) throw new Error('Connection has ended.');
                this.conversationId = conversationId;
                this.token = token;
                this.connectDeferred.resolve();
            }
        },
        {
            key: "end",
            value: function end() {
                // Once end() is called, no reconnection can be made.
                this.activitySubscriber.complete();
                this.connectionStatus$.next($eo2R4.ConnectionStatus.Ended);
                this.connectionStatus$.complete();
                this.streamConnection.disconnect();
            }
        },
        {
            key: "commonHeaders",
            value: function commonHeaders() {
                return {
                    Authorization: "Bearer ".concat(this.token),
                    'x-ms-bot-agent': this._botAgent
                };
            }
        },
        {
            key: "getBotAgent",
            value: function getBotAgent() {
                var customAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var clientAgent = 'directlineStreaming';
                if (customAgent) clientAgent += "; ".concat(customAgent);
                return "".concat($40c337ac67d09027$var$DIRECT_LINE_VERSION, " (").concat(clientAgent, ")");
            }
        },
        {
            key: "refreshToken",
            value: function() {
                var _refreshToken = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee3() {
                    var firstCall, retryCount, numberOfAttempts, res, _yield$res$json, token, _args3 = arguments;
                    return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                firstCall = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : true;
                                retryCount = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 0;
                                _context3.next = 4;
                                return this.waitUntilOnline();
                            case 4:
                                numberOfAttempts = 0;
                            case 5:
                                if (!(numberOfAttempts < $40c337ac67d09027$var$MAX_RETRY_COUNT)) {
                                    _context3.next = 30;
                                    break;
                                }
                                numberOfAttempts++;
                                _context3.next = 9;
                                return new Promise(function(r) {
                                    return setTimeout(r, $40c337ac67d09027$var$refreshTokenInterval);
                                });
                            case 9:
                                _context3.prev = 9;
                                _context3.next = 12;
                                return (0, $40c337ac67d09027$var$_crossFetch["default"])("".concat(this.domain, "/tokens/refresh"), {
                                    method: 'POST',
                                    headers: this.commonHeaders()
                                });
                            case 12:
                                res = _context3.sent;
                                if (!res.ok) {
                                    _context3.next = 22;
                                    break;
                                }
                                numberOfAttempts = 0;
                                _context3.next = 17;
                                return res.json();
                            case 17:
                                _yield$res$json = _context3.sent;
                                token = _yield$res$json.token;
                                this.token = token;
                                _context3.next = 23;
                                break;
                            case 22:
                                if (res.status === 403 || res.status === 403) {
                                    console.error("Fatal error while refreshing the token: ".concat(res.status, " ").concat(res.statusText));
                                    this.streamConnection.disconnect();
                                } else console.warn("Refresh attempt #".concat(numberOfAttempts, " failed: ").concat(res.status, " ").concat(res.statusText));
                            case 23:
                                _context3.next = 28;
                                break;
                            case 25:
                                _context3.prev = 25;
                                _context3.t0 = _context3["catch"](9);
                                console.warn("Refresh attempt #".concat(numberOfAttempts, " threw an exception: ").concat(_context3.t0));
                            case 28:
                                _context3.next = 5;
                                break;
                            case 30:
                                console.error('Retries exhausted');
                                this.streamConnection.disconnect();
                            case 32:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            9,
                            25
                        ]
                    ]);
                }));
                function refreshToken() {
                    return _refreshToken.apply(this, arguments);
                }
                return refreshToken;
            }()
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                var _this3 = this;
                if (this.connectionStatus$.value === $eo2R4.ConnectionStatus.Ended || this.connectionStatus$.value === $eo2R4.ConnectionStatus.FailedToConnect) return $iR1uX.Observable["throw"](new Error('Connection is closed'));
                if (activity.type === 'message' && activity.attachments && activity.attachments.length > 0) return this.postMessageWithAttachments(activity);
                var resp$ = $iR1uX.Observable.create(/*#__PURE__*/ function() {
                    var _ref3 = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee4(subscriber) {
                        var request, resp, numberOfStreams, idString, _JSON$parse, id;
                        return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    request = $40c337ac67d09027$var$BFSE.StreamingRequest.create('POST', '/v3/directline/conversations/' + _this3.conversationId + '/activities');
                                    request.setBody(JSON.stringify(activity));
                                    _context4.prev = 2;
                                    _context4.next = 5;
                                    return _this3.streamConnection.send(request);
                                case 5:
                                    resp = _context4.sent;
                                    if (!(resp.statusCode !== 200)) {
                                        _context4.next = 8;
                                        break;
                                    }
                                    throw new Error('PostActivity returned ' + resp.statusCode);
                                case 8:
                                    numberOfStreams = resp.streams.length;
                                    if (!(numberOfStreams !== 1)) {
                                        _context4.next = 11;
                                        break;
                                    }
                                    throw new Error('Expected one stream but got ' + numberOfStreams);
                                case 11:
                                    _context4.next = 13;
                                    return resp.streams[0].readAsString();
                                case 13:
                                    idString = _context4.sent;
                                    _JSON$parse = JSON.parse(idString), id = _JSON$parse.Id;
                                    subscriber.next(id);
                                    return _context4.abrupt("return", subscriber.complete());
                                case 19:
                                    _context4.prev = 19;
                                    _context4.t0 = _context4["catch"](2);
                                    // If there is a network issue then its handled by
                                    // the disconnectionHandler. Everything else can
                                    // be retried
                                    console.warn(_context4.t0);
                                    _this3.streamConnection.disconnect();
                                    return _context4.abrupt("return", subscriber.error(_context4.t0));
                                case 24:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4, null, [
                            [
                                2,
                                19
                            ]
                        ]);
                    }));
                    return function(_x4) {
                        return _ref3.apply(this, arguments);
                    };
                }());
                return resp$;
            }
        },
        {
            key: "postMessageWithAttachments",
            value: function postMessageWithAttachments(message) {
                var _this4 = this;
                var attachments = message.attachments, messageWithoutAttachments = (0, $40c337ac67d09027$var$_objectWithoutProperties2["default"])(message, $40c337ac67d09027$var$_excluded);
                return $iR1uX.Observable.create(function(subscriber) {
                    var httpContentList = [];
                    (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee6() {
                        var arrayBuffers, url, request, activityStream, resp, _yield$resp$streams$, id;
                        return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.prev = 0;
                                    _context6.next = 3;
                                    return Promise.all(attachments.map(/*#__PURE__*/ function() {
                                        var _ref5 = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee5(attachment) {
                                            var media, res;
                                            return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                                                while(true)switch(_context5.prev = _context5.next){
                                                    case 0:
                                                        media = attachment;
                                                        _context5.next = 3;
                                                        return (0, $40c337ac67d09027$var$_crossFetch["default"])(media.contentUrl);
                                                    case 3:
                                                        res = _context5.sent;
                                                        if (!res.ok) {
                                                            _context5.next = 12;
                                                            break;
                                                        }
                                                        _context5.next = 7;
                                                        return res.arrayBuffer();
                                                    case 7:
                                                        _context5.t0 = _context5.sent;
                                                        _context5.t1 = media;
                                                        return _context5.abrupt("return", {
                                                            arrayBuffer: _context5.t0,
                                                            media: _context5.t1
                                                        });
                                                    case 12:
                                                        throw new Error('...');
                                                    case 13:
                                                    case "end":
                                                        return _context5.stop();
                                                }
                                            }, _callee5);
                                        }));
                                        return function(_x5) {
                                            return _ref5.apply(this, arguments);
                                        };
                                    }()));
                                case 3:
                                    arrayBuffers = _context6.sent;
                                    arrayBuffers.forEach(function(_ref6) {
                                        var arrayBuffer = _ref6.arrayBuffer, media = _ref6.media;
                                        var buffer = $18pce.Buffer.from(arrayBuffer);
                                        var stream = new $40c337ac67d09027$var$BFSE.SubscribableStream();
                                        stream.write(buffer);
                                        var httpContent = new $40c337ac67d09027$var$BFSE.HttpContent({
                                            type: media.contentType,
                                            contentLength: buffer.length
                                        }, stream);
                                        httpContentList.push(httpContent);
                                    });
                                    url = "/v3/directline/conversations/".concat(_this4.conversationId, "/users/").concat(messageWithoutAttachments.from.id, "/upload");
                                    request = $40c337ac67d09027$var$BFSE.StreamingRequest.create('PUT', url);
                                    activityStream = new $40c337ac67d09027$var$BFSE.SubscribableStream();
                                    activityStream.write(JSON.stringify(messageWithoutAttachments), 'utf-8');
                                    request.addStream(new $40c337ac67d09027$var$BFSE.HttpContent({
                                        type: 'application/vnd.microsoft.activity',
                                        contentLength: activityStream.length
                                    }, activityStream));
                                    httpContentList.forEach(function(e) {
                                        return request.addStream(e);
                                    });
                                    _context6.next = 13;
                                    return _this4.streamConnection.send(request);
                                case 13:
                                    resp = _context6.sent;
                                    if (!(resp.streams && resp.streams.length !== 1)) {
                                        _context6.next = 18;
                                        break;
                                    }
                                    subscriber.error(new Error("Invalid stream count ".concat(resp.streams.length)));
                                    _context6.next = 24;
                                    break;
                                case 18:
                                    _context6.next = 20;
                                    return resp.streams[0].readAsJson();
                                case 20:
                                    _yield$resp$streams$ = _context6.sent;
                                    id = _yield$resp$streams$.Id;
                                    subscriber.next(id);
                                    subscriber.complete();
                                case 24:
                                    _context6.next = 29;
                                    break;
                                case 26:
                                    _context6.prev = 26;
                                    _context6.t0 = _context6["catch"](0);
                                    subscriber.error(_context6.t0);
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6, null, [
                            [
                                0,
                                26
                            ]
                        ]);
                    }))();
                });
            }
        },
        {
            key: "waitUntilOnline",
            value: function() {
                var _waitUntilOnline = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee7() {
                    var _this5 = this;
                    return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                return _context7.abrupt("return", new Promise(function(resolve, reject) {
                                    _this5.connectionStatus$.subscribe(function(cs) {
                                        if (cs === $eo2R4.ConnectionStatus.Online) return resolve();
                                    }, function(e) {
                                        return reject(e);
                                    });
                                }));
                            case 1:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7);
                }));
                function waitUntilOnline() {
                    return _waitUntilOnline.apply(this, arguments);
                }
                return waitUntilOnline;
            }()
        },
        {
            key: "connectAsync",
            value: function() {
                var _connectAsync = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee9() {
                    var _this6 = this;
                    var re, params, abortController, urlSearchParams, wsUrl;
                    return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                re = new RegExp('^http(s?)');
                                if (re.test(this.domain)) {
                                    _context9.next = 3;
                                    break;
                                }
                                throw 'Domain must begin with http or https';
                            case 3:
                                params = {
                                    token: this.token
                                };
                                if (this.conversationId) params['conversationId'] = this.conversationId;
                                abortController = new AbortController();
                                urlSearchParams = new URLSearchParams(params).toString();
                                wsUrl = "".concat(this.domain.replace(re, 'ws$1'), "/conversations/connect?").concat(urlSearchParams); // This promise will resolve when it is disconnected.
                                return _context9.abrupt("return", new Promise(/*#__PURE__*/ function() {
                                    var _ref7 = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee8(resolve, reject) {
                                        var request, response, responseString, conversation;
                                        return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                                            while(true)switch(_context8.prev = _context8.next){
                                                case 0:
                                                    _context8.prev = 0;
                                                    _this6.streamConnection = new $40c337ac67d09027$var$_WebSocketClientWithNetworkInformation["default"]({
                                                        disconnectionHandler: resolve,
                                                        networkInformation: (0, $40c337ac67d09027$var$_classPrivateFieldGet2["default"])(_this6, $40c337ac67d09027$var$_networkInformation),
                                                        requestHandler: {
                                                            processRequest: function processRequest(streamingRequest) {
                                                                // If `streamConnection` is still current, allow call to `processRequest()`, otherwise, ignore calls to `processRequest()`.
                                                                // This prevents zombie connections from sending us requests.
                                                                if (abortController.signal.aborted) throw new Error('Cannot process streaming request, `streamingConnection` should be disconnected.');
                                                                return _this6.theStreamHandler.processRequest(streamingRequest);
                                                            }
                                                        },
                                                        url: wsUrl
                                                    });
                                                    _this6.queueActivities = true;
                                                    _context8.next = 5;
                                                    return _this6.streamConnection.connect();
                                                case 5:
                                                    request = $40c337ac67d09027$var$BFSE.StreamingRequest.create('POST', '/v3/directline/conversations');
                                                    _context8.next = 8;
                                                    return _this6.streamConnection.send(request);
                                                case 8:
                                                    response = _context8.sent;
                                                    if (!(response.statusCode !== 200)) {
                                                        _context8.next = 11;
                                                        break;
                                                    }
                                                    throw new Error('Connection response code ' + response.statusCode);
                                                case 11:
                                                    if (!(response.streams.length !== 1)) {
                                                        _context8.next = 13;
                                                        break;
                                                    }
                                                    throw new Error('Expected 1 stream but got ' + response.streams.length);
                                                case 13:
                                                    _context8.next = 15;
                                                    return response.streams[0].readAsString();
                                                case 15:
                                                    responseString = _context8.sent;
                                                    conversation = JSON.parse(responseString);
                                                    _this6.conversationId = conversation.conversationId;
                                                    _this6.connectionStatus$.next($eo2R4.ConnectionStatus.Online);
                                                    // Wait until DL consumers have had a chance to be notified
                                                    // of the connection status change.
                                                    // This is specific to RxJS implementation of observable, which calling subscribe() after next() will still get the value.
                                                    _context8.next = 21;
                                                    return _this6.waitUntilOnline();
                                                case 21:
                                                    _this6.theStreamHandler.flush();
                                                    _this6.queueActivities = false;
                                                    _context8.next = 28;
                                                    break;
                                                case 25:
                                                    _context8.prev = 25;
                                                    _context8.t0 = _context8["catch"](0);
                                                    reject(_context8.t0);
                                                case 28:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }, _callee8, null, [
                                            [
                                                0,
                                                25
                                            ]
                                        ]);
                                    }));
                                    return function(_x6, _x7) {
                                        return _ref7.apply(this, arguments);
                                    };
                                }())["finally"](function() {
                                    return abortController.abort();
                                }));
                            case 9:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function connectAsync() {
                    return _connectAsync.apply(this, arguments);
                }
                return connectAsync;
            }()
        },
        {
            key: "connectWithRetryAsync",
            value: function() {
                var _connectWithRetryAsync = (0, $40c337ac67d09027$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $40c337ac67d09027$var$_regenerator["default"].mark(function _callee10() {
                    var _this7 = this;
                    var numRetries, start;
                    return $40c337ac67d09027$var$_regenerator["default"].wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return (this.connectDeferred = (0, $40c337ac67d09027$var$_createDeferred["default"])()).promise;
                            case 2:
                                numRetries = $40c337ac67d09027$var$MAX_RETRY_COUNT;
                                this.connectionStatus$.next($eo2R4.ConnectionStatus.Connecting);
                            case 4:
                                if (!(numRetries > 0)) {
                                    _context10.next = 27;
                                    break;
                                }
                                numRetries--;
                                start = Date.now();
                                _context10.prev = 7;
                                _context10.next = 10;
                                return this.connectAsync();
                            case 10:
                                _context10.next = 15;
                                break;
                            case 12:
                                _context10.prev = 12;
                                _context10.t0 = _context10["catch"](7);
                                console.error(_context10.t0);
                            case 15:
                                if (!(this.connectionStatus$.getValue() === $eo2R4.ConnectionStatus.Ended)) {
                                    _context10.next = 17;
                                    break;
                                }
                                return _context10.abrupt("return");
                            case 17:
                                // Make sure we don't signal ConnectionStatus.Connecting twice or more without an actual connection.
                                // Subsequent retries should be transparent.
                                if (this.connectionStatus$.getValue() !== $eo2R4.ConnectionStatus.Connecting) this.connectionStatus$.next($eo2R4.ConnectionStatus.Connecting);
                                // If the current connection lasted for more than a minute, the previous connection is good, which means:
                                // - we should reset the retry counter, and;
                                // - we should reconnect immediately.
                                if (!(60000 < Date.now() - start)) {
                                    _context10.next = 22;
                                    break;
                                }
                                numRetries = $40c337ac67d09027$var$MAX_RETRY_COUNT;
                                _context10.next = 25;
                                break;
                            case 22:
                                if (!(numRetries > 0)) {
                                    _context10.next = 25;
                                    break;
                                }
                                _context10.next = 25;
                                return new Promise(function(r) {
                                    return setTimeout(r, _this7.getRetryDelay());
                                });
                            case 25:
                                _context10.next = 4;
                                break;
                            case 27:
                                // TODO: [TEST] Make sure FailedToConnect is reported immediately after last disconnection, should be no getRetryDelay().
                                // Failed to reconnect after multiple retries.
                                this.connectionStatus$.next($eo2R4.ConnectionStatus.FailedToConnect);
                            case 28:
                                _context10.next = 0;
                                break;
                            case 30:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            7,
                            12
                        ]
                    ]);
                }));
                function connectWithRetryAsync() {
                    return _connectWithRetryAsync.apply(this, arguments);
                }
                return connectWithRetryAsync;
            }() // Returns the delay duration in milliseconds
        },
        {
            key: "getRetryDelay",
            value: function getRetryDelay() {
                return Math.floor(3000 + Math.random() * 12000);
            }
        }
    ]);
    return DirectLineStreaming;
}();
module.exports.DirectLineStreaming = $40c337ac67d09027$var$DirectLineStreaming;

});
parcelRegister("bugGq", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $85cf70012a3c5760$var$runtime = (parcelRequire("aWaHW"))();
module.exports = $85cf70012a3c5760$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $85cf70012a3c5760$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $85cf70012a3c5760$var$runtime;
    else Function("r", "regeneratorRuntime = r")($85cf70012a3c5760$var$runtime);
}

});
parcelRegister("aWaHW", function(module, exports) {

var $kl7l1 = parcelRequire("kl7l1");
var $7f67a07c315cafba$var$_typeof = $kl7l1.default;
function $7f67a07c315cafba$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $7f67a07c315cafba$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $7f67a07c315cafba$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($7f67a07c315cafba$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $7f67a07c315cafba$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kaIZq", function(module, exports) {

var $kSWva = parcelRequire("kSWva");

var $byqTG = parcelRequire("byqTG");
function $eaf7a3d97f40f1c2$var$_classPrivateFieldGet(e, t) {
    var r = $byqTG(t, e);
    return $kSWva(e, r);
}
module.exports = $eaf7a3d97f40f1c2$var$_classPrivateFieldGet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kSWva", function(module, exports) {
function $f3463afd2908d60f$var$_classApplyDescriptorGet(e, t) {
    return t.get ? t.get.call(e) : t.value;
}
module.exports = $f3463afd2908d60f$var$_classApplyDescriptorGet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("byqTG", function(module, exports) {

var $k3xJM = parcelRequire("k3xJM");
function $8697bbe54aa7f9d0$var$_classPrivateFieldGet2(s, a) {
    return s.get($k3xJM(s, a));
}
module.exports = $8697bbe54aa7f9d0$var$_classPrivateFieldGet2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k3xJM", function(module, exports) {
function $e99e4204f668b6e4$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
module.exports = $e99e4204f668b6e4$var$_assertClassBrand, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("jRlgX", function(module, exports) {

var $6wd4E = parcelRequire("6wd4E");

var $byqTG = parcelRequire("byqTG");
function $e75377d0c73fd453$var$_classPrivateFieldSet(e, t, r) {
    var s = $byqTG(t, e);
    return $6wd4E(e, s, r), r;
}
module.exports = $e75377d0c73fd453$var$_classPrivateFieldSet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6wd4E", function(module, exports) {
function $4befdf7c5f53a9d6$var$_classApplyDescriptorSet(e, t, l) {
    if (t.set) t.set.call(e, l);
    else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = l;
    }
}
module.exports = $4befdf7c5f53a9d6$var$_classApplyDescriptorSet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9S6VG", function(module, exports) {

var $39NwG = parcelRequire("39NwG");

var $73mGO = parcelRequire("73mGO");

var $hfguC = parcelRequire("hfguC");

var $31F2J = parcelRequire("31F2J");
function $72fe8835e713e28c$var$_toConsumableArray(r) {
    return $39NwG(r) || $73mGO(r) || $hfguC(r) || $31F2J();
}
module.exports = $72fe8835e713e28c$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("39NwG", function(module, exports) {

var $Ly5tW = parcelRequire("Ly5tW");
function $24c8a13c09dfaf21$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $Ly5tW(r);
}
module.exports = $24c8a13c09dfaf21$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("31F2J", function(module, exports) {
function $23414d62f289405b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $23414d62f289405b$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9aT6L", function(module, exports) {
function $6adfcb90a0f8920d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $6adfcb90a0f8920d$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $6adfcb90a0f8920d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $6adfcb90a0f8920d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $6adfcb90a0f8920d$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("18pce", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0d3a15479fa550dc$export$a143d493d941bafc, (v) => $0d3a15479fa550dc$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0d3a15479fa550dc$export$f99ded8fe4b79145, (v) => $0d3a15479fa550dc$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0d3a15479fa550dc$export$a143d493d941bafc;
var $0d3a15479fa550dc$export$e4cf37d7f6fb9e0a;
var $0d3a15479fa550dc$export$f99ded8fe4b79145;
var $0d3a15479fa550dc$export$599f31c3813fae4d;
'use strict';

var $jPqBZ = parcelRequire("jPqBZ");

var $oaTF8 = parcelRequire("oaTF8");
const $0d3a15479fa550dc$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0d3a15479fa550dc$export$a143d493d941bafc = $0d3a15479fa550dc$var$Buffer;
$0d3a15479fa550dc$export$e4cf37d7f6fb9e0a = $0d3a15479fa550dc$var$SlowBuffer;
$0d3a15479fa550dc$export$f99ded8fe4b79145 = 50;
const $0d3a15479fa550dc$var$K_MAX_LENGTH = 0x7fffffff;
$0d3a15479fa550dc$export$599f31c3813fae4d = $0d3a15479fa550dc$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0d3a15479fa550dc$var$Buffer.TYPED_ARRAY_SUPPORT = $0d3a15479fa550dc$var$typedArraySupport();
if (!$0d3a15479fa550dc$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0d3a15479fa550dc$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0d3a15479fa550dc$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0d3a15479fa550dc$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0d3a15479fa550dc$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0d3a15479fa550dc$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0d3a15479fa550dc$var$createBuffer(length) {
    if (length > $0d3a15479fa550dc$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0d3a15479fa550dc$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0d3a15479fa550dc$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0d3a15479fa550dc$var$allocUnsafe(arg);
    }
    return $0d3a15479fa550dc$var$from(arg, encodingOrOffset, length);
}
$0d3a15479fa550dc$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0d3a15479fa550dc$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0d3a15479fa550dc$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0d3a15479fa550dc$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0d3a15479fa550dc$var$isInstance(value, ArrayBuffer) || value && $0d3a15479fa550dc$var$isInstance(value.buffer, ArrayBuffer)) return $0d3a15479fa550dc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0d3a15479fa550dc$var$isInstance(value, SharedArrayBuffer) || value && $0d3a15479fa550dc$var$isInstance(value.buffer, SharedArrayBuffer))) return $0d3a15479fa550dc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0d3a15479fa550dc$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0d3a15479fa550dc$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0d3a15479fa550dc$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0d3a15479fa550dc$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0d3a15479fa550dc$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0d3a15479fa550dc$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0d3a15479fa550dc$var$Buffer, Uint8Array);
function $0d3a15479fa550dc$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0d3a15479fa550dc$var$alloc(size, fill, encoding) {
    $0d3a15479fa550dc$var$assertSize(size);
    if (size <= 0) return $0d3a15479fa550dc$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0d3a15479fa550dc$var$createBuffer(size).fill(fill, encoding) : $0d3a15479fa550dc$var$createBuffer(size).fill(fill);
    return $0d3a15479fa550dc$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0d3a15479fa550dc$var$Buffer.alloc = function(size, fill, encoding) {
    return $0d3a15479fa550dc$var$alloc(size, fill, encoding);
};
function $0d3a15479fa550dc$var$allocUnsafe(size) {
    $0d3a15479fa550dc$var$assertSize(size);
    return $0d3a15479fa550dc$var$createBuffer(size < 0 ? 0 : $0d3a15479fa550dc$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0d3a15479fa550dc$var$Buffer.allocUnsafe = function(size) {
    return $0d3a15479fa550dc$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0d3a15479fa550dc$var$Buffer.allocUnsafeSlow = function(size) {
    return $0d3a15479fa550dc$var$allocUnsafe(size);
};
function $0d3a15479fa550dc$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0d3a15479fa550dc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0d3a15479fa550dc$var$byteLength(string, encoding) | 0;
    let buf = $0d3a15479fa550dc$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0d3a15479fa550dc$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0d3a15479fa550dc$var$checked(array.length) | 0;
    const buf = $0d3a15479fa550dc$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0d3a15479fa550dc$var$fromArrayView(arrayView) {
    if ($0d3a15479fa550dc$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0d3a15479fa550dc$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0d3a15479fa550dc$var$fromArrayLike(arrayView);
}
function $0d3a15479fa550dc$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0d3a15479fa550dc$var$Buffer.prototype);
    return buf;
}
function $0d3a15479fa550dc$var$fromObject(obj) {
    if ($0d3a15479fa550dc$var$Buffer.isBuffer(obj)) {
        const len = $0d3a15479fa550dc$var$checked(obj.length) | 0;
        const buf = $0d3a15479fa550dc$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0d3a15479fa550dc$var$numberIsNaN(obj.length)) return $0d3a15479fa550dc$var$createBuffer(0);
        return $0d3a15479fa550dc$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0d3a15479fa550dc$var$fromArrayLike(obj.data);
}
function $0d3a15479fa550dc$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0d3a15479fa550dc$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0d3a15479fa550dc$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0d3a15479fa550dc$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0d3a15479fa550dc$var$Buffer.alloc(+length);
}
$0d3a15479fa550dc$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0d3a15479fa550dc$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0d3a15479fa550dc$var$Buffer.compare = function compare(a, b) {
    if ($0d3a15479fa550dc$var$isInstance(a, Uint8Array)) a = $0d3a15479fa550dc$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0d3a15479fa550dc$var$isInstance(b, Uint8Array)) b = $0d3a15479fa550dc$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0d3a15479fa550dc$var$Buffer.isBuffer(a) || !$0d3a15479fa550dc$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0d3a15479fa550dc$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0d3a15479fa550dc$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0d3a15479fa550dc$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0d3a15479fa550dc$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0d3a15479fa550dc$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0d3a15479fa550dc$var$Buffer.isBuffer(buf)) buf = $0d3a15479fa550dc$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0d3a15479fa550dc$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0d3a15479fa550dc$var$byteLength(string, encoding) {
    if ($0d3a15479fa550dc$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0d3a15479fa550dc$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0d3a15479fa550dc$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0d3a15479fa550dc$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0d3a15479fa550dc$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0d3a15479fa550dc$var$Buffer.byteLength = $0d3a15479fa550dc$var$byteLength;
function $0d3a15479fa550dc$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0d3a15479fa550dc$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0d3a15479fa550dc$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0d3a15479fa550dc$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0d3a15479fa550dc$var$latin1Slice(this, start, end);
        case 'base64':
            return $0d3a15479fa550dc$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0d3a15479fa550dc$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0d3a15479fa550dc$var$Buffer.prototype._isBuffer = true;
function $0d3a15479fa550dc$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0d3a15479fa550dc$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0d3a15479fa550dc$var$swap(this, i, i + 1);
    return this;
};
$0d3a15479fa550dc$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0d3a15479fa550dc$var$swap(this, i, i + 3);
        $0d3a15479fa550dc$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0d3a15479fa550dc$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0d3a15479fa550dc$var$swap(this, i, i + 7);
        $0d3a15479fa550dc$var$swap(this, i + 1, i + 6);
        $0d3a15479fa550dc$var$swap(this, i + 2, i + 5);
        $0d3a15479fa550dc$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0d3a15479fa550dc$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0d3a15479fa550dc$var$utf8Slice(this, 0, length);
    return $0d3a15479fa550dc$var$slowToString.apply(this, arguments);
};
$0d3a15479fa550dc$var$Buffer.prototype.toLocaleString = $0d3a15479fa550dc$var$Buffer.prototype.toString;
$0d3a15479fa550dc$var$Buffer.prototype.equals = function equals(b) {
    if (!$0d3a15479fa550dc$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0d3a15479fa550dc$var$Buffer.compare(this, b) === 0;
};
$0d3a15479fa550dc$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0d3a15479fa550dc$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0d3a15479fa550dc$var$customInspectSymbol) $0d3a15479fa550dc$var$Buffer.prototype[$0d3a15479fa550dc$var$customInspectSymbol] = $0d3a15479fa550dc$var$Buffer.prototype.inspect;
$0d3a15479fa550dc$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0d3a15479fa550dc$var$isInstance(target, Uint8Array)) target = $0d3a15479fa550dc$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0d3a15479fa550dc$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0d3a15479fa550dc$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0d3a15479fa550dc$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0d3a15479fa550dc$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0d3a15479fa550dc$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0d3a15479fa550dc$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0d3a15479fa550dc$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0d3a15479fa550dc$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0d3a15479fa550dc$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0d3a15479fa550dc$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0d3a15479fa550dc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0d3a15479fa550dc$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0d3a15479fa550dc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0d3a15479fa550dc$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0d3a15479fa550dc$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0d3a15479fa550dc$var$utf8Write(buf, string, offset, length) {
    return $0d3a15479fa550dc$var$blitBuffer($0d3a15479fa550dc$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0d3a15479fa550dc$var$asciiWrite(buf, string, offset, length) {
    return $0d3a15479fa550dc$var$blitBuffer($0d3a15479fa550dc$var$asciiToBytes(string), buf, offset, length);
}
function $0d3a15479fa550dc$var$base64Write(buf, string, offset, length) {
    return $0d3a15479fa550dc$var$blitBuffer($0d3a15479fa550dc$var$base64ToBytes(string), buf, offset, length);
}
function $0d3a15479fa550dc$var$ucs2Write(buf, string, offset, length) {
    return $0d3a15479fa550dc$var$blitBuffer($0d3a15479fa550dc$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0d3a15479fa550dc$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0d3a15479fa550dc$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0d3a15479fa550dc$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0d3a15479fa550dc$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0d3a15479fa550dc$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0d3a15479fa550dc$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0d3a15479fa550dc$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0d3a15479fa550dc$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jPqBZ.fromByteArray(buf);
    else return $jPqBZ.fromByteArray(buf.slice(start, end));
}
function $0d3a15479fa550dc$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0d3a15479fa550dc$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0d3a15479fa550dc$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0d3a15479fa550dc$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0d3a15479fa550dc$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0d3a15479fa550dc$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0d3a15479fa550dc$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0d3a15479fa550dc$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0d3a15479fa550dc$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0d3a15479fa550dc$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0d3a15479fa550dc$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0d3a15479fa550dc$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0d3a15479fa550dc$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0d3a15479fa550dc$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0d3a15479fa550dc$var$Buffer.prototype.readUintLE = $0d3a15479fa550dc$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0d3a15479fa550dc$var$Buffer.prototype.readUintBE = $0d3a15479fa550dc$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0d3a15479fa550dc$var$Buffer.prototype.readUint8 = $0d3a15479fa550dc$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0d3a15479fa550dc$var$Buffer.prototype.readUint16LE = $0d3a15479fa550dc$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0d3a15479fa550dc$var$Buffer.prototype.readUint16BE = $0d3a15479fa550dc$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0d3a15479fa550dc$var$Buffer.prototype.readUint32LE = $0d3a15479fa550dc$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0d3a15479fa550dc$var$Buffer.prototype.readUint32BE = $0d3a15479fa550dc$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0d3a15479fa550dc$var$Buffer.prototype.readBigUInt64LE = $0d3a15479fa550dc$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0d3a15479fa550dc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0d3a15479fa550dc$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0d3a15479fa550dc$var$Buffer.prototype.readBigUInt64BE = $0d3a15479fa550dc$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0d3a15479fa550dc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0d3a15479fa550dc$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0d3a15479fa550dc$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0d3a15479fa550dc$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0d3a15479fa550dc$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0d3a15479fa550dc$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0d3a15479fa550dc$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0d3a15479fa550dc$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0d3a15479fa550dc$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0d3a15479fa550dc$var$Buffer.prototype.readBigInt64LE = $0d3a15479fa550dc$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0d3a15479fa550dc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0d3a15479fa550dc$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0d3a15479fa550dc$var$Buffer.prototype.readBigInt64BE = $0d3a15479fa550dc$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0d3a15479fa550dc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0d3a15479fa550dc$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0d3a15479fa550dc$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 4, this.length);
    return $oaTF8.read(this, offset, true, 23, 4);
};
$0d3a15479fa550dc$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 4, this.length);
    return $oaTF8.read(this, offset, false, 23, 4);
};
$0d3a15479fa550dc$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 8, this.length);
    return $oaTF8.read(this, offset, true, 52, 8);
};
$0d3a15479fa550dc$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkOffset(offset, 8, this.length);
    return $oaTF8.read(this, offset, false, 52, 8);
};
function $0d3a15479fa550dc$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0d3a15479fa550dc$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0d3a15479fa550dc$var$Buffer.prototype.writeUintLE = $0d3a15479fa550dc$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0d3a15479fa550dc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeUintBE = $0d3a15479fa550dc$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0d3a15479fa550dc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeUint8 = $0d3a15479fa550dc$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeUint16LE = $0d3a15479fa550dc$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeUint16BE = $0d3a15479fa550dc$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeUint32LE = $0d3a15479fa550dc$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeUint32BE = $0d3a15479fa550dc$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0d3a15479fa550dc$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0d3a15479fa550dc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0d3a15479fa550dc$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0d3a15479fa550dc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0d3a15479fa550dc$var$Buffer.prototype.writeBigUInt64LE = $0d3a15479fa550dc$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0d3a15479fa550dc$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0d3a15479fa550dc$var$Buffer.prototype.writeBigUInt64BE = $0d3a15479fa550dc$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0d3a15479fa550dc$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0d3a15479fa550dc$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0d3a15479fa550dc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0d3a15479fa550dc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0d3a15479fa550dc$var$Buffer.prototype.writeBigInt64LE = $0d3a15479fa550dc$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0d3a15479fa550dc$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0d3a15479fa550dc$var$Buffer.prototype.writeBigInt64BE = $0d3a15479fa550dc$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0d3a15479fa550dc$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0d3a15479fa550dc$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0d3a15479fa550dc$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $oaTF8.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0d3a15479fa550dc$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0d3a15479fa550dc$var$writeFloat(this, value, offset, true, noAssert);
};
$0d3a15479fa550dc$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0d3a15479fa550dc$var$writeFloat(this, value, offset, false, noAssert);
};
function $0d3a15479fa550dc$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0d3a15479fa550dc$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $oaTF8.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0d3a15479fa550dc$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0d3a15479fa550dc$var$writeDouble(this, value, offset, true, noAssert);
};
$0d3a15479fa550dc$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0d3a15479fa550dc$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0d3a15479fa550dc$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0d3a15479fa550dc$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0d3a15479fa550dc$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0d3a15479fa550dc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0d3a15479fa550dc$var$Buffer.isBuffer(val) ? val : $0d3a15479fa550dc$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0d3a15479fa550dc$var$errors = {};
function $0d3a15479fa550dc$var$E(sym, getMessage, Base) {
    $0d3a15479fa550dc$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0d3a15479fa550dc$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0d3a15479fa550dc$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0d3a15479fa550dc$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0d3a15479fa550dc$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0d3a15479fa550dc$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0d3a15479fa550dc$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0d3a15479fa550dc$var$checkBounds(buf, offset, byteLength) {
    $0d3a15479fa550dc$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0d3a15479fa550dc$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0d3a15479fa550dc$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0d3a15479fa550dc$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0d3a15479fa550dc$var$checkBounds(buf, offset, byteLength);
}
function $0d3a15479fa550dc$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0d3a15479fa550dc$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0d3a15479fa550dc$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0d3a15479fa550dc$var$validateNumber(value, type);
        throw new $0d3a15479fa550dc$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0d3a15479fa550dc$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0d3a15479fa550dc$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0d3a15479fa550dc$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0d3a15479fa550dc$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0d3a15479fa550dc$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0d3a15479fa550dc$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0d3a15479fa550dc$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0d3a15479fa550dc$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0d3a15479fa550dc$var$base64ToBytes(str) {
    return $jPqBZ.toByteArray($0d3a15479fa550dc$var$base64clean(str));
}
function $0d3a15479fa550dc$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0d3a15479fa550dc$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0d3a15479fa550dc$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0d3a15479fa550dc$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0d3a15479fa550dc$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0d3a15479fa550dc$var$BufferBigIntNotDefined : fn;
}
function $0d3a15479fa550dc$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("jPqBZ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $e6f76c44bab27d1f$export$d622b2ad8d90c771, (v) => $e6f76c44bab27d1f$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e6f76c44bab27d1f$export$6100ba28696e12de, (v) => $e6f76c44bab27d1f$export$6100ba28696e12de = v);
var $e6f76c44bab27d1f$export$a48f0734ac7c2329;
var $e6f76c44bab27d1f$export$d622b2ad8d90c771;
var $e6f76c44bab27d1f$export$6100ba28696e12de;
'use strict';
$e6f76c44bab27d1f$export$a48f0734ac7c2329 = $e6f76c44bab27d1f$var$byteLength;
$e6f76c44bab27d1f$export$d622b2ad8d90c771 = $e6f76c44bab27d1f$var$toByteArray;
$e6f76c44bab27d1f$export$6100ba28696e12de = $e6f76c44bab27d1f$var$fromByteArray;
var $e6f76c44bab27d1f$var$lookup = [];
var $e6f76c44bab27d1f$var$revLookup = [];
var $e6f76c44bab27d1f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e6f76c44bab27d1f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e6f76c44bab27d1f$var$i = 0, $e6f76c44bab27d1f$var$len = $e6f76c44bab27d1f$var$code.length; $e6f76c44bab27d1f$var$i < $e6f76c44bab27d1f$var$len; ++$e6f76c44bab27d1f$var$i){
    $e6f76c44bab27d1f$var$lookup[$e6f76c44bab27d1f$var$i] = $e6f76c44bab27d1f$var$code[$e6f76c44bab27d1f$var$i];
    $e6f76c44bab27d1f$var$revLookup[$e6f76c44bab27d1f$var$code.charCodeAt($e6f76c44bab27d1f$var$i)] = $e6f76c44bab27d1f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e6f76c44bab27d1f$var$revLookup['-'.charCodeAt(0)] = 62;
$e6f76c44bab27d1f$var$revLookup['_'.charCodeAt(0)] = 63;
function $e6f76c44bab27d1f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e6f76c44bab27d1f$var$byteLength(b64) {
    var lens = $e6f76c44bab27d1f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6f76c44bab27d1f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6f76c44bab27d1f$var$toByteArray(b64) {
    var tmp;
    var lens = $e6f76c44bab27d1f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e6f76c44bab27d1f$var$Arr($e6f76c44bab27d1f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i)] << 18 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i)] << 2 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i)] << 10 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e6f76c44bab27d1f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e6f76c44bab27d1f$var$tripletToBase64(num) {
    return $e6f76c44bab27d1f$var$lookup[num >> 18 & 0x3F] + $e6f76c44bab27d1f$var$lookup[num >> 12 & 0x3F] + $e6f76c44bab27d1f$var$lookup[num >> 6 & 0x3F] + $e6f76c44bab27d1f$var$lookup[num & 0x3F];
}
function $e6f76c44bab27d1f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e6f76c44bab27d1f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e6f76c44bab27d1f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e6f76c44bab27d1f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e6f76c44bab27d1f$var$lookup[tmp >> 2] + $e6f76c44bab27d1f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e6f76c44bab27d1f$var$lookup[tmp >> 10] + $e6f76c44bab27d1f$var$lookup[tmp >> 4 & 0x3F] + $e6f76c44bab27d1f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("oaTF8", function(module, exports) {

$parcel$export(module.exports, "read", () => $048ab1e1373f922a$export$aafa59e2e03f2942, (v) => $048ab1e1373f922a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $048ab1e1373f922a$export$68d8715fc104d294, (v) => $048ab1e1373f922a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $048ab1e1373f922a$export$aafa59e2e03f2942;
var $048ab1e1373f922a$export$68d8715fc104d294;
$048ab1e1373f922a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$048ab1e1373f922a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("h1R35", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadAssembler = void 0;
                var subscribableStream_1 = require1("../subscribableStream");
                var payloads_1 = require1("../payloads");
                var contentStream_1 = require1("../contentStream");
                /**
 * Assembles payloads for streaming library.
 *
 * @internal
 */ var PayloadAssembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) class.
     *
     * @param streamManager The [StreamManager](xref:botframework-streaming.StreamManager) managing the stream being assembled.
     * @param params Parameters for a streaming assembler.
     */ function PayloadAssembler(streamManager, params) {
                        this.streamManager = streamManager;
                        this._byteOrderMark = 0xfeff;
                        this._utf = 'utf8';
                        if (params.header) {
                            this.id = params.header.id;
                            this.payloadType = params.header.payloadType;
                            this.contentLength = params.header.payloadLength;
                            this.end = params.header.end;
                        } else this.id = params.id;
                        if (!this.id) throw Error('An ID must be supplied when creating an assembler.');
                        this._onCompleted = params.onCompleted;
                    }
                    /**
     * Retrieves the assembler's payload as a stream.
     *
     * @returns A [SubscribableStream](xref:botframework-streaming.SubscribableStream) of the assembler's payload.
     */ PayloadAssembler.prototype.getPayloadStream = function() {
                        if (!this.stream) this.stream = this.createPayloadStream();
                        return this.stream;
                    };
                    /**
     * The action the assembler executes when new bytes are received on the incoming stream.
     *
     * @param header The stream's Header.
     * @param stream The incoming stream being assembled.
     * @param _contentLength The length of the stream, if finite.
     */ PayloadAssembler.prototype.onReceive = function(header, stream, _contentLength) {
                        this.end = header.end;
                        if (header.payloadType === payloads_1.PayloadTypes.response || header.payloadType === payloads_1.PayloadTypes.request) this.process(stream).then().catch();
                        else if (header.end) stream.end();
                    };
                    /**
     * Closes the assembler.
     */ PayloadAssembler.prototype.close = function() {
                        this.streamManager.closeStream(this.id);
                    };
                    /**
     * Creates a new [SubscribableStream](xref:botframework-streaming.SubscribableStream) instance.
     *
     * @returns The new stream ready for consumption.
     */ PayloadAssembler.prototype.createPayloadStream = function() {
                        return new subscribableStream_1.SubscribableStream();
                    };
                    PayloadAssembler.prototype.payloadFromJson = function(json) {
                        return JSON.parse(json.charCodeAt(0) === this._byteOrderMark ? json.slice(1) : json);
                    };
                    PayloadAssembler.prototype.stripBOM = function(input) {
                        return input.charCodeAt(0) === this._byteOrderMark ? input.slice(1) : input;
                    };
                    PayloadAssembler.prototype.process = function(stream) {
                        return __awaiter(this, void 0, void 0, function() {
                            var streamData, streamDataAsString;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        streamData = stream.read(stream.length);
                                        if (!streamData) return [
                                            2 /*return*/ 
                                        ];
                                        streamDataAsString = streamData.toString(this._utf);
                                        if (!(this.payloadType === payloads_1.PayloadTypes.request)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.processRequest(streamDataAsString)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 2:
                                        if (!(this.payloadType === payloads_1.PayloadTypes.response)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.processResponse(streamDataAsString)
                                        ];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processResponse = function(streamDataAsString) {
                        return __awaiter(this, void 0, void 0, function() {
                            var responsePayload, receiveResponse;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        responsePayload = this.payloadFromJson(this.stripBOM(streamDataAsString));
                                        receiveResponse = {
                                            streams: [],
                                            statusCode: responsePayload.statusCode
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.processStreams(responsePayload, receiveResponse)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processRequest = function(streamDataAsString) {
                        return __awaiter(this, void 0, void 0, function() {
                            var requestPayload, receiveRequest;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        requestPayload = this.payloadFromJson(streamDataAsString);
                                        receiveRequest = {
                                            streams: [],
                                            path: requestPayload.path,
                                            verb: requestPayload.verb
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.processStreams(requestPayload, receiveRequest)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processStreams = function(responsePayload, receiveResponse) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var _this = this;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        (_a = responsePayload.streams) === null || _a === void 0 || _a.forEach(function(responseStream) {
                                            var _a;
                                            // There was a bug in how streams were handled. In .NET, the StreamDescription definiton mapped the
                                            // "type" JSON property to `contentType`, but in Typescript there was no mapping. This is a workaround
                                            // to resolve this inconsistency.
                                            //
                                            // .NET code:
                                            // https://github.com/microsoft/botbuilder-dotnet/blob/a79036ddf6625ec3fd68a6f7295886eb7831bc1c/libraries/Microsoft.Bot.Streaming/Payloads/Models/StreamDescription.cs#L28-L29
                                            var contentType = (_a = responseStream.type) !== null && _a !== void 0 ? _a : responseStream.contentType;
                                            var contentAssembler = _this.streamManager.getPayloadAssembler(responseStream.id);
                                            contentAssembler.payloadType = contentType;
                                            contentAssembler.contentLength = responseStream.length;
                                            receiveResponse.streams.push(new contentStream_1.ContentStream(responseStream.id, contentAssembler));
                                        });
                                        return [
                                            4 /*yield*/ ,
                                            this._onCompleted(this.id, receiveResponse)
                                        ];
                                    case 1:
                                        _b.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return PayloadAssembler;
                }();
                exports.PayloadAssembler = PayloadAssembler;
            },
            {
                "../contentStream": 2,
                "../payloads": 16,
                "../subscribableStream": 27
            }
        ],
        2: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ContentStream = void 0;
                /**
 * A stream of fixed or infinite length containing content to be decoded.
 */ var ContentStream = /** @class */ function() {
                    /**
     * Initializes a new instance of the [ContentStream](xref:botframework-streaming.ContentStream) class.
     *
     * @param id The ID assigned to this instance.
     * @param assembler The [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) assigned to this instance.
     */ function ContentStream(id, assembler) {
                        if (!assembler) throw Error('Null Argument Exception');
                        this.id = id;
                        this.assembler = assembler;
                    }
                    Object.defineProperty(ContentStream.prototype, "contentType", {
                        /**
         * Gets the name of the type of the object contained within this [ContentStream](xref:botframework-streaming.ContentStream).
         *
         * @returns The [PayloadType](xref:botframework-streaming.PayloadType) of this [ContentStream](xref:botframework-streaming.ContentStream).
         */ get: function() {
                            return this.assembler.payloadType;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ContentStream.prototype, "length", {
                        /**
         * Gets the length of this [ContentStream](xref:botframework-streaming.ContentStream).
         *
         * @returns A number representing the length of this [ContentStream](xref:botframework-streaming.ContentStream).
         */ get: function() {
                            return this.assembler.contentLength;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Gets the data contained within this [ContentStream](xref:botframework-streaming.ContentStream).
     *
     * @returns This [ContentStream's](xref:botframework-streaming.ContentStream) [SubscribableStream](xref:botframework-streaming.SubscribableStream).
     */ ContentStream.prototype.getStream = function() {
                        if (!this.stream) this.stream = this.assembler.getPayloadStream();
                        return this.stream;
                    };
                    /**
     * Closes the assembler.
     */ ContentStream.prototype.cancel = function() {
                        this.assembler.close();
                    };
                    /**
     * Gets the [SubscribableStream](xref:botframework-streaming.SubscribableStream) content as a string.
     *
     * @returns A string Promise with [SubscribableStream](xref:botframework-streaming.SubscribableStream) content.
     */ ContentStream.prototype.readAsString = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var bufferArray;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.readAll()
                                        ];
                                    case 1:
                                        bufferArray = _a.sent().bufferArray;
                                        return [
                                            2 /*return*/ ,
                                            (bufferArray || []).map(function(result) {
                                                return result.toString('utf8');
                                            }).join('')
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets the [SubscribableStream](xref:botframework-streaming.SubscribableStream) content as a typed JSON object.
     *
     * @returns A typed object Promise with `SubscribableStream` content.
     */ ContentStream.prototype.readAsJson = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var stringToParse;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.readAsString()
                                        ];
                                    case 1:
                                        stringToParse = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            JSON.parse(stringToParse)
                                        ];
                                }
                            });
                        });
                    };
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ContentStream.prototype.readAll = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var allData, count, stream, chunk, readToEnd;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        allData = [];
                                        count = 0;
                                        stream = this.getStream();
                                        // populate the array with any existing buffers
                                        while(count < stream.length){
                                            chunk = stream.read(stream.length);
                                            allData.push(chunk);
                                            count += chunk.length;
                                        }
                                        if (!(count < this.length)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        readToEnd = new Promise(function(resolve) {
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            var callback = function(cs) {
                                                return function(chunk) {
                                                    allData.push(chunk);
                                                    count += chunk.length;
                                                    if (count === cs.length) resolve(true);
                                                };
                                            };
                                            stream.subscribe(callback(_this));
                                        });
                                        return [
                                            4 /*yield*/ ,
                                            readToEnd
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            {
                                                bufferArray: allData,
                                                size: count
                                            }
                                        ];
                                }
                            });
                        });
                    };
                    return ContentStream;
                }();
                exports.ContentStream = ContentStream;
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CancelDisassembler = void 0;
                /**
 * Streaming cancel disassembler.
 */ var CancelDisassembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [CancelDisassembler](xref:botframework-streaming.CancelDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) that this Cancel request will be sent by.
     * @param id The ID of the Stream to cancel.
     * @param payloadType The type of the Stream that is being cancelled.
     */ function CancelDisassembler(sender, id, payloadType) {
                        this.sender = sender;
                        this.id = id;
                        this.payloadType = payloadType;
                    }
                    /**
     * Initiates the process of disassembling the request and signals the [PayloadSender](xref:botframework-streaming.PayloadSender) to begin sending.
     */ CancelDisassembler.prototype.disassemble = function() {
                        var header = {
                            payloadType: this.payloadType,
                            payloadLength: 0,
                            id: this.id,
                            end: true
                        };
                        this.sender.sendPayload(header);
                    };
                    return CancelDisassembler;
                }();
                exports.CancelDisassembler = CancelDisassembler;
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HttpContentStreamDisassembler = void 0;
                var payloadDisassembler_1 = require1("./payloadDisassembler");
                var payloads_1 = require1("../payloads");
                /**
 * Disassembler for Http content stream
 */ var HttpContentStreamDisassembler = /** @class */ function(_super) {
                    __extends(HttpContentStreamDisassembler, _super);
                    /**
     * Initializes a new instance of the [HttpContentStreamDisassembler](xref:botframework-streaming.HttpContentStreamDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param contentStream The [HttpContentStream](xref:botframework-streaming.HttpContentStream) to be disassembled.
     */ function HttpContentStreamDisassembler(sender, contentStream) {
                        var _this = _super.call(this, sender, contentStream.id) || this;
                        _this.payloadType = payloads_1.PayloadTypes.stream;
                        _this.contentStream = contentStream;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Strea.
     */ HttpContentStreamDisassembler.prototype.getStream = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var stream;
                            return __generator(this, function(_a) {
                                stream = this.contentStream.content.getStream();
                                return [
                                    2 /*return*/ ,
                                    {
                                        stream: stream,
                                        streamLength: stream.length
                                    }
                                ];
                            });
                        });
                    };
                    return HttpContentStreamDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.HttpContentStreamDisassembler = HttpContentStreamDisassembler;
            },
            {
                "../payloads": 16,
                "./payloadDisassembler": 5
            }
        ],
        5: [
            function(require1, module1, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadDisassembler = void 0;
                var subscribableStream_1 = require1("../subscribableStream");
                /**
 * Base class streaming payload disassembling.
 */ var PayloadDisassembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadDisassembler](xref:botframework-streaming.PayloadDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) used to send the disassembled payload chunks.
     * @param id The ID of this disassembler.
     */ function PayloadDisassembler(sender, id) {
                        this.sender = sender;
                        this.id = id;
                    }
                    /**
     * Serializes the item into the [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) that exposes the stream and length of the result.
     *
     * @param item The item to be serialized.
     * @returns The stream containing the serialized item and the length of the stream.
     */ PayloadDisassembler.serialize = function(item) {
                        var stream = new subscribableStream_1.SubscribableStream();
                        stream.write(JSON.stringify(item));
                        stream.end();
                        return {
                            stream: stream,
                            streamLength: stream.length
                        };
                    };
                    /**
     * Begins the process of disassembling a payload and sending the resulting chunks to the [PayloadSender](xref:botframework-streaming.PayloadSender) to dispatch over the transport.
     *
     * @returns A completed Promise after the disassembled payload has been sent.
     */ PayloadDisassembler.prototype.disassemble = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var _a, stream, streamLength;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.getStream()
                                        ];
                                    case 1:
                                        _a = _b.sent(), stream = _a.stream, streamLength = _a.streamLength;
                                        this.stream = stream;
                                        this.streamLength = streamLength;
                                        return [
                                            2 /*return*/ ,
                                            this.send()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Begins the process of disassembling a payload and signals the [PayloadSender](xref:botframework-streaming.PayloadSender).
     */ PayloadDisassembler.prototype.send = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var header;
                            return __generator(this, function(_a) {
                                header = {
                                    payloadType: this.payloadType,
                                    payloadLength: this.streamLength,
                                    id: this.id,
                                    end: true
                                };
                                this.sender.sendPayload(header, this.stream);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    return PayloadDisassembler;
                }();
                exports.PayloadDisassembler = PayloadDisassembler;
            },
            {
                "../subscribableStream": 27
            }
        ],
        6: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestDisassembler = void 0;
                var payloadTypes_1 = require1("../payloads/payloadTypes");
                var payloadDisassembler_1 = require1("./payloadDisassembler");
                /**
 * Streaming request disassembler.
 */ var RequestDisassembler = /** @class */ function(_super) {
                    __extends(RequestDisassembler, _super);
                    /**
     * Initializes a new instance of the [RequestDisassembler](xref:botframework-streaming.RequestDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param id The ID of this disassembler.
     * @param request The request to be disassembled.
     */ function RequestDisassembler(sender, id, request) {
                        var _this = _super.call(this, sender, id) || this;
                        _this.request = request;
                        _this.payloadType = payloadTypes_1.PayloadTypes.request;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Stream.
     */ RequestDisassembler.prototype.getStream = function() {
                        var _a, _b, _c, _d;
                        return __awaiter(this, void 0, void 0, function() {
                            var payload;
                            return __generator(this, function(_e) {
                                payload = {
                                    verb: (_a = this.request) === null || _a === void 0 ? void 0 : _a.verb,
                                    path: (_b = this.request) === null || _b === void 0 ? void 0 : _b.path,
                                    streams: []
                                };
                                (_d = (_c = this.request) === null || _c === void 0 ? void 0 : _c.streams) === null || _d === void 0 || _d.forEach(function(stream) {
                                    payload.streams.push(stream.description);
                                });
                                return [
                                    2 /*return*/ ,
                                    payloadDisassembler_1.PayloadDisassembler.serialize(payload)
                                ];
                            });
                        });
                    };
                    return RequestDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.RequestDisassembler = RequestDisassembler;
            },
            {
                "../payloads/payloadTypes": 19,
                "./payloadDisassembler": 5
            }
        ],
        7: [
            function(require1, module1, exports) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ResponseDisassembler = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var payloadTypes_1 = require1("../payloads/payloadTypes");
                var payloadDisassembler_1 = require1("./payloadDisassembler");
                /**
 * Streaming response disassembler.
 */ var ResponseDisassembler = /** @class */ function(_super) {
                    __extends(ResponseDisassembler, _super);
                    /**
     * Initializes a new instance of the [ResponseDisassembler](xref:botframework-streaming.ResponseDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param id The ID of this disassembler.
     * @param response The response to be disassembled.
     */ function ResponseDisassembler(sender, id, response) {
                        var _this = _super.call(this, sender, id) || this;
                        _this.payloadType = payloadTypes_1.PayloadTypes.response;
                        _this.response = response;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Stream.
     */ ResponseDisassembler.prototype.getStream = function() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var payload;
                            return __generator(this, function(_b) {
                                payload = {
                                    statusCode: this.response.statusCode,
                                    streams: []
                                };
                                (_a = this.response.streams) === null || _a === void 0 || _a.forEach(function(_a) {
                                    var description = _a.description;
                                    payload.streams.push({
                                        id: description.id,
                                        contentType: description.type,
                                        length: description.length
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    payloadDisassembler_1.PayloadDisassembler.serialize(payload)
                                ];
                            });
                        });
                    };
                    return ResponseDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.ResponseDisassembler = ResponseDisassembler;
            },
            {
                "../payloads/payloadTypes": 19,
                "./payloadDisassembler": 5
            }
        ],
        8: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HttpContent = exports.HttpContentStream = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var protocol_base_1 = require1("./utilities/protocol-base");
                /**
 * An attachment contained within a StreamingRequest's stream collection, which itself contains any form of media item.
 */ var HttpContentStream = /** @class */ function() {
                    /**
     * Initializes a new instance of the [HttpContentStream](xref:botframework-streaming.HttpContentStream) class.
     *
     * @param content The [HttpContent](xref:botframework-streaming.HttpContent) to assign to the [HttpContentStream](xref:botframework-streaming.HttpContentStream).
     */ function HttpContentStream(content) {
                        var _a, _b, _c, _d, _e, _f;
                        this.content = content;
                        this.id = (0, protocol_base_1.generateGuid)();
                        this.description = {
                            id: this.id,
                            type: (_c = (_b = (_a = this.content) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : 'unknown',
                            length: (_f = (_e = (_d = this.content) === null || _d === void 0 ? void 0 : _d.headers) === null || _e === void 0 ? void 0 : _e.contentLength) !== null && _f !== void 0 ? _f : 0
                        };
                    }
                    return HttpContentStream;
                }();
                exports.HttpContentStream = HttpContentStream;
                /**
 * The HttpContent class that contains a [SubscribableStream](xref:botframework-streaming.SubscribableStream).
 */ var HttpContent = /** @class */ function() {
                    /**
     * Initializes a new instance of the [HttpContent](xref:botframework-streaming.HttpContent) class.
     *
     * @param headers The Streaming Http content header definition.
     * @param stream The stream of buffered data.
     */ function HttpContent(headers, stream) {
                        this.headers = headers;
                        this.stream = stream;
                    }
                    /**
     * Gets the data contained within this [HttpContent](xref:botframework-streaming.HttpContent).
     *
     * @returns This [HttpContent's](xref:botframework-streaming.HttpContent) [SubscribableStream](xref:botframework-streaming.SubscribableStream) member.
     */ HttpContent.prototype.getStream = function() {
                        return this.stream;
                    };
                    return HttpContent;
                }();
                exports.HttpContent = HttpContent;
            },
            {
                "./utilities/protocol-base": 28
            }
        ],
        9: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketClient = exports.BrowserWebSocket = exports.SubscribableStream = exports.StreamingResponse = exports.StreamingRequest = exports.RequestHandler = exports.HttpContent = exports.ContentStream = void 0;
                var contentStream_1 = require1("./contentStream");
                Object.defineProperty(exports, "ContentStream", {
                    enumerable: true,
                    get: function() {
                        return contentStream_1.ContentStream;
                    }
                });
                var httpContentStream_1 = require1("./httpContentStream");
                Object.defineProperty(exports, "HttpContent", {
                    enumerable: true,
                    get: function() {
                        return httpContentStream_1.HttpContent;
                    }
                });
                var requestHandler_1 = require1("./requestHandler");
                Object.defineProperty(exports, "RequestHandler", {
                    enumerable: true,
                    get: function() {
                        return requestHandler_1.RequestHandler;
                    }
                });
                var streamingRequest_1 = require1("./streamingRequest");
                Object.defineProperty(exports, "StreamingRequest", {
                    enumerable: true,
                    get: function() {
                        return streamingRequest_1.StreamingRequest;
                    }
                });
                var streamingResponse_1 = require1("./streamingResponse");
                Object.defineProperty(exports, "StreamingResponse", {
                    enumerable: true,
                    get: function() {
                        return streamingResponse_1.StreamingResponse;
                    }
                });
                var subscribableStream_1 = require1("./subscribableStream");
                Object.defineProperty(exports, "SubscribableStream", {
                    enumerable: true,
                    get: function() {
                        return subscribableStream_1.SubscribableStream;
                    }
                });
                var index_browser_1 = require1("./webSocket/index-browser");
                Object.defineProperty(exports, "BrowserWebSocket", {
                    enumerable: true,
                    get: function() {
                        return index_browser_1.BrowserWebSocket;
                    }
                });
                Object.defineProperty(exports, "WebSocketClient", {
                    enumerable: true,
                    get: function() {
                        return index_browser_1.WebSocketClient;
                    }
                });
            },
            {
                "./contentStream": 2,
                "./httpContentStream": 8,
                "./requestHandler": 24,
                "./streamingRequest": 25,
                "./streamingResponse": 26,
                "./subscribableStream": 27,
                "./webSocket/index-browser": 31
            }
        ],
        10: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(require1("./payloadReceiver"), exports);
                __exportStar(require1("./payloadSender"), exports);
                __exportStar(require1("./transportDisconnectedEvent"), exports);
                __exportStar(require1("./transportDisconnectedEventHandler"), exports);
            },
            {
                "./payloadReceiver": 11,
                "./payloadSender": 12,
                "./transportDisconnectedEvent": 13,
                "./transportDisconnectedEventHandler": 14
            }
        ],
        11: [
            function(require1, module1, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadReceiver = void 0;
                var payloadTypes_1 = require1("../payloads/payloadTypes");
                var headerSerializer_1 = require1("../payloads/headerSerializer");
                var payloadConstants_1 = require1("../payloads/payloadConstants");
                var transportDisconnectedEvent_1 = require1("./transportDisconnectedEvent");
                /**
 * Payload receiver for streaming.
 */ var PayloadReceiver = /** @class */ function() {
                    function PayloadReceiver() {}
                    Object.defineProperty(PayloadReceiver.prototype, "isConnected", {
                        /**
         * Get current connected state
         *
         * @returns true if connected to a transport sender.
         */ get: function() {
                            return this._receiver != null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Connects to a transport receiver
     *
     * @param receiver The [ITransportReceiver](xref:botframework-streaming.ITransportReceiver) object to pull incoming data from.
     * @returns a promise that resolves when the receiver is complete
     */ PayloadReceiver.prototype.connect = function(receiver) {
                        this._receiver = receiver;
                        return this.receivePackets();
                    };
                    /**
     * Allows subscribing to this receiver in order to be notified when new data comes in.
     *
     * @param getStream Callback when a new stream has been received.
     * @param receiveAction Callback when a new message has been received.
     */ PayloadReceiver.prototype.subscribe = function(getStream, receiveAction) {
                        this._getStream = getStream;
                        this._receiveAction = receiveAction;
                    };
                    /**
     * Force this receiver to disconnect.
     *
     * @param event Event arguments to include when broadcasting disconnection event.
     */ PayloadReceiver.prototype.disconnect = function(event) {
                        var _a, _b;
                        if (event === void 0) event = transportDisconnectedEvent_1.TransportDisconnectedEvent.Empty;
                        if (!this.isConnected) return;
                        try {
                            this._receiver.close();
                            (_a = this.disconnected) === null || _a === void 0 || _a.call(this, this, event);
                        } catch (err) {
                            (_b = this.disconnected) === null || _b === void 0 || _b.call(this, this, new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                        } finally{
                            this._receiver = null;
                        }
                    };
                    PayloadReceiver.prototype.receivePackets = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var readSoFar, _a, header, isStream, bytesActuallyRead, contentStream, count, _b, err_1;
                            return __generator(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        if (!this.isConnected) return [
                                            3 /*break*/ ,
                                            11
                                        ];
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([
                                            1,
                                            9,
                                            ,
                                            10
                                        ]);
                                        readSoFar = 0;
                                        _c.label = 2;
                                    case 2:
                                        if (!(readSoFar < payloadConstants_1.PayloadConstants.MaxHeaderLength)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        _a = this;
                                        return [
                                            4 /*yield*/ ,
                                            this._receiver.receive(payloadConstants_1.PayloadConstants.MaxHeaderLength - readSoFar)
                                        ];
                                    case 3:
                                        _a._receiveHeaderBuffer = _c.sent();
                                        if (this._receiveHeaderBuffer) readSoFar += this._receiveHeaderBuffer.length;
                                        return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                    case 4:
                                        header = headerSerializer_1.HeaderSerializer.deserialize(this._receiveHeaderBuffer);
                                        isStream = header.payloadType === payloadTypes_1.PayloadTypes.stream;
                                        if (!(header.payloadLength > 0)) return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                        bytesActuallyRead = 0;
                                        contentStream = this._getStream(header);
                                        _c.label = 5;
                                    case 5:
                                        if (!(bytesActuallyRead < header.payloadLength && bytesActuallyRead < payloadConstants_1.PayloadConstants.MaxPayloadLength)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        count = Math.min(header.payloadLength - bytesActuallyRead, payloadConstants_1.PayloadConstants.MaxPayloadLength);
                                        _b = this;
                                        return [
                                            4 /*yield*/ ,
                                            this._receiver.receive(count)
                                        ];
                                    case 6:
                                        _b._receivePayloadBuffer = _c.sent();
                                        bytesActuallyRead += this._receivePayloadBuffer.byteLength;
                                        contentStream.write(this._receivePayloadBuffer);
                                        // If this is a stream we want to keep handing it up as it comes in
                                        if (isStream) this._receiveAction(header, contentStream, bytesActuallyRead);
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 7:
                                        if (!isStream) this._receiveAction(header, contentStream, bytesActuallyRead);
                                        _c.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        err_1 = _c.sent();
                                        this.disconnect(new transportDisconnectedEvent_1.TransportDisconnectedEvent(err_1.message));
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 10:
                                        return [
                                            3 /*break*/ ,
                                            0
                                        ];
                                    case 11:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return PayloadReceiver;
                }();
                exports.PayloadReceiver = PayloadReceiver;
            },
            {
                "../payloads/headerSerializer": 15,
                "../payloads/payloadConstants": 18,
                "../payloads/payloadTypes": 19,
                "./transportDisconnectedEvent": 13
            }
        ],
        12: [
            function(require1, module1, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.PayloadSender = void 0;
                        var headerSerializer_1 = require1("../payloads/headerSerializer");
                        var payloadConstants_1 = require1("../payloads/payloadConstants");
                        var transportDisconnectedEvent_1 = require1("./transportDisconnectedEvent");
                        /**
 * Streaming payload sender.
 */ var PayloadSender = /** @class */ function() {
                            function PayloadSender() {}
                            Object.defineProperty(PayloadSender.prototype, "isConnected", {
                                /**
         * Get current connected state
         *
         * @returns true if connected to a transport sender.
         */ get: function() {
                                    return this._sender != null;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            /**
     * Connects to the given transport sender.
     *
     * @param sender The transport sender to connect this payload sender to.
     */ PayloadSender.prototype.connect = function(sender) {
                                this._sender = sender;
                            };
                            /**
     * Sends a payload out over the connected transport sender.
     *
     * @param header The header to attach to the outgoing payload.
     * @param payload The stream of buffered data to send.
     * @param sentCallback The function to execute when the send has completed.
     */ PayloadSender.prototype.sendPayload = function(header, payload, sentCallback) {
                                var packet = {
                                    header: header,
                                    payload: payload,
                                    sentCallback: sentCallback
                                };
                                this.writePacket(packet);
                            };
                            /**
     * Disconnects this payload sender.
     *
     * @param event The disconnected event arguments to include in the disconnected event broadcast.
     */ PayloadSender.prototype.disconnect = function(event) {
                                var _a, _b;
                                if (event === void 0) event = transportDisconnectedEvent_1.TransportDisconnectedEvent.Empty;
                                if (!this.isConnected) return;
                                try {
                                    this._sender.close();
                                    (_a = this.disconnected) === null || _a === void 0 || _a.call(this, this, event);
                                } catch (err) {
                                    (_b = this.disconnected) === null || _b === void 0 || _b.call(this, this, new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                                } finally{
                                    this._sender = null;
                                }
                            };
                            PayloadSender.prototype.writePacket = function(packet) {
                                try {
                                    if (packet.header.payloadLength > 0 && packet.payload) {
                                        var leftOver = packet.header.payloadLength;
                                        while(leftOver > 0){
                                            var count = leftOver <= payloadConstants_1.PayloadConstants.MaxPayloadLength ? leftOver : payloadConstants_1.PayloadConstants.MaxPayloadLength;
                                            var chunk = packet.payload.read(count);
                                            var header = packet.header;
                                            header.payloadLength = count;
                                            header.end = leftOver <= payloadConstants_1.PayloadConstants.MaxPayloadLength;
                                            var sendHeaderBuffer = Buffer.alloc(payloadConstants_1.PayloadConstants.MaxHeaderLength);
                                            headerSerializer_1.HeaderSerializer.serialize(header, sendHeaderBuffer);
                                            this._sender.send(sendHeaderBuffer);
                                            this._sender.send(chunk);
                                            leftOver -= chunk.length;
                                        }
                                        if (packet.sentCallback) packet.sentCallback();
                                    }
                                } catch (err) {
                                    this.disconnect(new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                                }
                            };
                            return PayloadSender;
                        }();
                        exports.PayloadSender = PayloadSender;
                    }).call(this);
                }).call(this, require1("buffer").Buffer);
            },
            {
                "../payloads/headerSerializer": 15,
                "../payloads/payloadConstants": 18,
                "./transportDisconnectedEvent": 13,
                "buffer": 35
            }
        ],
        13: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TransportDisconnectedEvent = void 0;
                /**
 * Event to be included when disconnection events are fired.
 */ var TransportDisconnectedEvent = /** @class */ function() {
                    /**
     * Indicates a transport disconnected with the reason provided via the constructor.
     *
     * @remarks
     * This class is used for communicating disconnection events between the
     * PayloadReceiver and PayloadSender.
     * @param reason The reason the disconnection event fired, in plain text.
     */ function TransportDisconnectedEvent(reason) {
                        this.reason = reason;
                    }
                    /**
     * A new and empty TransportDisconnectedEvent.
     */ TransportDisconnectedEvent.Empty = new TransportDisconnectedEvent();
                    return TransportDisconnectedEvent;
                }();
                exports.TransportDisconnectedEvent = TransportDisconnectedEvent;
            },
            {}
        ],
        14: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            },
            {}
        ],
        15: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HeaderSerializer = void 0;
                var payloadConstants_1 = require1("./payloadConstants");
                /**
 * Streaming header serializer
 */ var HeaderSerializer = /** @class */ function() {
                    function HeaderSerializer() {}
                    /**
     * Serializes the header into a buffer
     *
     * @param header The header to serialize.
     * @param buffer The buffer into which to serialize the header.
     */ HeaderSerializer.serialize = function(header, buffer) {
                        buffer.write(header.payloadType, this.TypeOffset, 1, this.Encoding);
                        buffer.write(this.Delimiter, this.TypeDelimiterOffset, 1, this.Encoding);
                        buffer.write(this.headerLengthPadder(header.payloadLength, this.LengthLength, '0'), this.LengthOffset, this.LengthLength, this.Encoding);
                        buffer.write(this.Delimiter, this.LengthDelimeterOffset, 1, this.Encoding);
                        buffer.write(header.id, this.IdOffset);
                        buffer.write(this.Delimiter, this.IdDelimeterOffset, 1, this.Encoding);
                        buffer.write(header.end ? this.End : this.NotEnd, this.EndOffset);
                        buffer.write(this.Terminator, this.TerminatorOffset);
                    };
                    /**
     * Deserializes a buffer containing header information.
     *
     * @param buffer The buffer from which to obtain the data to deserialize.
     * @returns The deserialized header from the buffer.
     */ HeaderSerializer.deserialize = function(buffer) {
                        var jsonBuffer = buffer.toString(this.Encoding);
                        var headerArray = jsonBuffer.split(this.Delimiter);
                        if (headerArray.length !== 4) throw Error("Cannot parse header, header is malformed. Header: ".concat(jsonBuffer));
                        var payloadType = headerArray[0], length = headerArray[1], id = headerArray[2], headerEnd = headerArray[3];
                        var end = headerEnd === '1\n';
                        var payloadLength = Number(length);
                        var header = {
                            end: end,
                            payloadLength: payloadLength,
                            payloadType: payloadType,
                            id: id
                        };
                        if (!(header.payloadLength <= payloadConstants_1.PayloadConstants.MaxPayloadLength && header.payloadLength >= payloadConstants_1.PayloadConstants.MinLength)) throw Error("Header length of ".concat(header.payloadLength, " is missing or malformed"));
                        if (header.payloadType.length !== this.TypeDelimiterOffset) throw Error("Header type '".concat(header.payloadType.length, "' is missing or malformed."));
                        if (!header.id || !header.id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) || header.id.length !== this.IdLength) throw Error("Header ID '".concat(header.id, "' is missing or malformed."));
                        if (!(headerEnd === '0\n' || headerEnd === '1\n')) throw Error("Header End is missing or not a valid value. Header end: '".concat(headerEnd, "'"));
                        return header;
                    };
                    /**
     * Creates a padded string based on a length and character to be padded to.
     *
     * @param lengthValue The value to be assingned on the result.
     * @param totalLength The length of the padded string result.
     * @param padChar The character value to use as filling.
     * @returns The padded string.
     */ HeaderSerializer.headerLengthPadder = function(lengthValue, totalLength, padChar) {
                        var result = Array(totalLength + 1).join(padChar);
                        var lengthString = lengthValue.toString();
                        return (result + lengthString).slice(lengthString.length);
                    };
                    HeaderSerializer.Delimiter = '.';
                    HeaderSerializer.Terminator = '\n';
                    HeaderSerializer.End = '1';
                    HeaderSerializer.NotEnd = '0';
                    HeaderSerializer.TypeOffset = 0;
                    HeaderSerializer.TypeDelimiterOffset = 1;
                    HeaderSerializer.LengthOffset = 2;
                    HeaderSerializer.LengthLength = 6;
                    HeaderSerializer.LengthDelimeterOffset = 8;
                    HeaderSerializer.IdOffset = 9;
                    HeaderSerializer.IdLength = 36;
                    HeaderSerializer.IdDelimeterOffset = 45;
                    HeaderSerializer.EndOffset = 46;
                    HeaderSerializer.TerminatorOffset = 47;
                    HeaderSerializer.Encoding = 'utf8';
                    return HeaderSerializer;
                }();
                exports.HeaderSerializer = HeaderSerializer;
            },
            {
                "./payloadConstants": 18
            }
        ],
        16: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(require1("./headerSerializer"), exports);
                __exportStar(require1("./streamManager"), exports);
                __exportStar(require1("./payloadAssemblerManager"), exports);
                __exportStar(require1("./payloadTypes"), exports);
                __exportStar(require1("./requestManager"), exports);
                __exportStar(require1("./sendOperations"), exports);
                __exportStar(require1("./streamManager"), exports);
            },
            {
                "./headerSerializer": 15,
                "./payloadAssemblerManager": 17,
                "./payloadTypes": 19,
                "./requestManager": 20,
                "./sendOperations": 21,
                "./streamManager": 22
            }
        ],
        17: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadAssemblerManager = void 0;
                var payloadAssembler_1 = require1("../assemblers/payloadAssembler");
                var payloadTypes_1 = require1("./payloadTypes");
                /**
 * Orchestrates assembly of payloads.
 */ var PayloadAssemblerManager = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadAssemblerManager](xref:botframework-streaming.PayloadAssemblerManager) class.
     *
     * @param streamManager The [StreamManager](xref:botframework-streaming.StreamManager) managing the stream being assembled.
     * @param onReceiveResponse Function that executes when new bytes are received on a `response` stream.
     * @param onReceiveRequest Function that executes when new bytes are received on a `request` stream.
     */ function PayloadAssemblerManager(streamManager, onReceiveResponse, onReceiveRequest) {
                        this.streamManager = streamManager;
                        this.onReceiveResponse = onReceiveResponse;
                        this.onReceiveRequest = onReceiveRequest;
                        this.activeAssemblers = {};
                    }
                    /**
     * Retrieves the assembler's payload as a stream.
     *
     * @param header The Header of the Stream to retrieve.
     * @returns A [SubscribableStream](xref:botframework-streaming.SubscribableStream) of the assembler's payload.
     */ PayloadAssemblerManager.prototype.getPayloadStream = function(header) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) return this.streamManager.getPayloadStream(header);
                        else if (!this.activeAssemblers[header.id]) {
                            var assembler = this.createPayloadAssembler(header);
                            if (assembler) {
                                this.activeAssemblers[header.id] = assembler;
                                return assembler.getPayloadStream();
                            }
                        }
                    };
                    /**
     * The action the assembler executes when new bytes are received on the incoming stream.
     *
     * @param header The stream's Header.
     * @param contentStream The incoming stream being assembled.
     * @param contentLength The length of the stream, if finite.
     */ PayloadAssemblerManager.prototype.onReceive = function(header, contentStream, contentLength) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) this.streamManager.onReceive(header, contentStream, contentLength);
                        else {
                            if (this.activeAssemblers && this.activeAssemblers[header.id]) {
                                var assembler = this.activeAssemblers[header.id];
                                assembler.onReceive(header, contentStream, contentLength);
                            }
                            if (header.end) delete this.activeAssemblers[header.id];
                        }
                    };
                    PayloadAssemblerManager.prototype.createPayloadAssembler = function(header) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.request) return new payloadAssembler_1.PayloadAssembler(this.streamManager, {
                            header: header,
                            onCompleted: this.onReceiveRequest
                        });
                        else if (header.payloadType === payloadTypes_1.PayloadTypes.response) return new payloadAssembler_1.PayloadAssembler(this.streamManager, {
                            header: header,
                            onCompleted: this.onReceiveResponse
                        });
                    };
                    return PayloadAssemblerManager;
                }();
                exports.PayloadAssemblerManager = PayloadAssemblerManager;
            },
            {
                "../assemblers/payloadAssembler": 1,
                "./payloadTypes": 19
            }
        ],
        18: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadConstants = void 0;
                /**
 * Constants for streaming payloads.
 */ var PayloadConstants;
                (function(PayloadConstants) {
                    PayloadConstants[PayloadConstants["MaxPayloadLength"] = 4096] = "MaxPayloadLength";
                    PayloadConstants[PayloadConstants["MaxHeaderLength"] = 48] = "MaxHeaderLength";
                    PayloadConstants[PayloadConstants["MaxLength"] = 999999] = "MaxLength";
                    PayloadConstants[PayloadConstants["MinLength"] = 0] = "MinLength";
                })(PayloadConstants = exports.PayloadConstants || (exports.PayloadConstants = {}));
            },
            {}
        ],
        19: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadTypes = void 0;
                /**
 * Typess of payloads supported in the streaming library.
 */ var PayloadTypes;
                (function(PayloadTypes) {
                    PayloadTypes["request"] = "A";
                    PayloadTypes["response"] = "B";
                    PayloadTypes["stream"] = "S";
                    PayloadTypes["cancelAll"] = "X";
                    PayloadTypes["cancelStream"] = "C";
                })(PayloadTypes = exports.PayloadTypes || (exports.PayloadTypes = {}));
            },
            {}
        ],
        20: [
            function(require1, module1, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestManager = void 0;
                /**
 * A streaming pending request.
 */ var PendingRequest = /** @class */ function() {
                    function PendingRequest() {}
                    return PendingRequest;
                }();
                /**
 * Orchestrates and manages pending streaming requests.
 */ var RequestManager = /** @class */ function() {
                    function RequestManager() {
                        this._pendingRequests = {};
                    }
                    /**
     * Gets the count of the pending requests.
     *
     * @returns Number with the pending requests count.
     */ RequestManager.prototype.pendingRequestCount = function() {
                        return Object.keys(this._pendingRequests).length;
                    };
                    /**
     * Signal fired when all response tasks have completed.
     *
     * @param requestId The ID of the StreamingRequest.
     * @param response The [IReceiveResponse](xref:botframework-streaming.IReceiveResponse) in response to the request.
     * @returns A Promise that when completed returns `true` if the `requestId`'s pending response task was completed, otherwise `false`.
     */ RequestManager.prototype.signalResponse = function(requestId, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pendingRequest;
                            return __generator(this, function(_a) {
                                pendingRequest = this._pendingRequests[requestId];
                                if (pendingRequest) {
                                    pendingRequest.resolve(response);
                                    delete this._pendingRequests[requestId];
                                    return [
                                        2 /*return*/ ,
                                        true
                                    ];
                                }
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                            });
                        });
                    };
                    /**
     * Constructs and returns a response for this request.
     *
     * @param requestId The ID of the StreamingRequest being responded to.
     * @returns The response to the specified request.
     */ RequestManager.prototype.getResponse = function(requestId) {
                        var pendingRequest = this._pendingRequests[requestId];
                        if (pendingRequest) return Promise.reject("requestId '".concat(requestId, "' already exists in RequestManager"));
                        pendingRequest = new PendingRequest();
                        pendingRequest.requestId = requestId;
                        var promise = new Promise(function(resolve, reject) {
                            pendingRequest.resolve = resolve;
                            pendingRequest.reject = reject;
                        });
                        this._pendingRequests[requestId] = pendingRequest;
                        return promise;
                    };
                    /**
     * Rejects all requests pending a response.
     *
     * @param reason The reason for rejection.
     */ RequestManager.prototype.rejectAllResponses = function(reason) {
                        var _this = this;
                        Object.entries(this._pendingRequests).forEach(function(_a) {
                            var requestId = _a[0], reject = _a[1].reject;
                            reject(reason);
                            delete _this._pendingRequests[requestId];
                        });
                    };
                    return RequestManager;
                }();
                exports.RequestManager = RequestManager;
            },
            {}
        ],
        21: [
            function(require1, module1, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SendOperations = void 0;
                var cancelDisassembler_1 = require1("../disassemblers/cancelDisassembler");
                var httpContentStreamDisassembler_1 = require1("../disassemblers/httpContentStreamDisassembler");
                var requestDisassembler_1 = require1("../disassemblers/requestDisassembler");
                var responseDisassembler_1 = require1("../disassemblers/responseDisassembler");
                var payloadTypes_1 = require1("./payloadTypes");
                /**
 * Send operations for streaming payloads.
 */ var SendOperations = /** @class */ function() {
                    /**
     * Initializes a new instance of the [SendOperations](xref:botframework-streaming.SendOperations) class.
     *
     * @param payloadSender The [PayloadSender](xref:botframework-streaming.PayloadSender) that will send the disassembled data from all of this instance's send operations.
     */ function SendOperations(payloadSender) {
                        this.payloadSender = payloadSender;
                    }
                    /**
     * The send operation used to send a [StreamingRequest](xref:botframework-streaming.StreamingRequest).
     *
     * @param id The ID to assign to the [RequestDisassembler](xref:botframework-streaming.RequestDisassembler) used by this operation.
     * @param request The request to send.
     */ SendOperations.prototype.sendRequest = function(id, request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        disassembler = new requestDisassembler_1.RequestDisassembler(this.payloadSender, id, request);
                                        return [
                                            4 /*yield*/ ,
                                            disassembler.disassemble()
                                        ];
                                    case 1:
                                        _a.sent();
                                        if (request.streams) request.streams.forEach(function(contentStream) {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    switch(_a.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                new httpContentStreamDisassembler_1.HttpContentStreamDisassembler(this.payloadSender, contentStream).disassemble()
                                                            ];
                                                        case 1:
                                                            _a.sent();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * The send operation used to send a [PayloadTypes.response](xref:botframework-streaming.PayloadTypes.response).
     *
     * @param id The ID to assign to the [ResponseDisassembler](xref:botframework-streaming.ResponseDisassembler) used by this operation.
     * @param response The response to send.
     */ SendOperations.prototype.sendResponse = function(id, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        disassembler = new responseDisassembler_1.ResponseDisassembler(this.payloadSender, id, response);
                                        return [
                                            4 /*yield*/ ,
                                            disassembler.disassemble()
                                        ];
                                    case 1:
                                        _a.sent();
                                        if (response.streams) response.streams.forEach(function(contentStream) {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    switch(_a.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                new httpContentStreamDisassembler_1.HttpContentStreamDisassembler(this.payloadSender, contentStream).disassemble()
                                                            ];
                                                        case 1:
                                                            _a.sent();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * The send operation used to send a [PayloadTypes.cancelStream](xref:botframework-streaming.PayloadTypes.cancelStream).
     *
     * @param id The ID to assign to the [CancelDisassembler](xref:botframework-streaming.CancelDisassembler) used by this operation.
     */ SendOperations.prototype.sendCancelStream = function(id) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            return __generator(this, function(_a) {
                                disassembler = new cancelDisassembler_1.CancelDisassembler(this.payloadSender, id, payloadTypes_1.PayloadTypes.cancelStream);
                                disassembler.disassemble();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    return SendOperations;
                }();
                exports.SendOperations = SendOperations;
            },
            {
                "../disassemblers/cancelDisassembler": 3,
                "../disassemblers/httpContentStreamDisassembler": 4,
                "../disassemblers/requestDisassembler": 6,
                "../disassemblers/responseDisassembler": 7,
                "./payloadTypes": 19
            }
        ],
        22: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamManager = void 0;
                var payloadAssembler_1 = require1("../assemblers/payloadAssembler");
                /**
 * Orchestrates and manages streams.
 */ var StreamManager = /** @class */ function() {
                    /**
     * Initializes a new instance of the [StreamManager](xref:botframework-streaming.StreamManager) class.
     *
     * @param onCancelStream Function to trigger if the managed stream is cancelled.
     */ function StreamManager(onCancelStream) {
                        this.onCancelStream = onCancelStream;
                        this.activeAssemblers = [];
                    }
                    /**
     * Retrieves a [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) with the given ID if one exists, otherwise a new instance is created and assigned the given ID.
     *
     * @param id The ID of the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) to retrieve or create.
     * @returns The [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) with the given ID.
     */ StreamManager.prototype.getPayloadAssembler = function(id) {
                        if (!this.activeAssemblers[id]) {
                            // A new id has come in, kick off the process of tracking it.
                            var assembler = new payloadAssembler_1.PayloadAssembler(this, {
                                id: id
                            });
                            this.activeAssemblers[id] = assembler;
                            return assembler;
                        } else return this.activeAssemblers[id];
                    };
                    /**
     * Retrieves the [SubscribableStream](xref:botframework-streaming.SubscribableStream) from the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) this manager manages.
     *
     * @param header The Header of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) to retrieve.
     * @returns The [SubscribableStream](xref:botframework-streaming.SubscribableStream) with the given header.
     */ StreamManager.prototype.getPayloadStream = function(header) {
                        var assembler = this.getPayloadAssembler(header.id);
                        return assembler.getPayloadStream();
                    };
                    /**
     * Used to set the behavior of the managed [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) when data is received.
     *
     * @param header The Header of the stream.
     * @param contentStream The [SubscribableStream](xref:botframework-streaming.SubscribableStream) to write incoming data to.
     * @param contentLength The amount of data to write to the contentStream.
     */ StreamManager.prototype.onReceive = function(header, contentStream, contentLength) {
                        if (!this.activeAssemblers[header.id]) return;
                        this.activeAssemblers[header.id].onReceive(header, contentStream, contentLength);
                    };
                    /**
     * Closes the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) assigned to the [SubscribableStream](xref:botframework-streaming.SubscribableStream) with the given ID.
     *
     * @param id The ID of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) to close.
     */ StreamManager.prototype.closeStream = function(id) {
                        if (!this.activeAssemblers[id]) return;
                        else {
                            var assembler = this.activeAssemblers[id];
                            this.activeAssemblers.splice(this.activeAssemblers.indexOf(id), 1);
                            var targetStream = assembler.getPayloadStream();
                            if (assembler.contentLength && targetStream.length < assembler.contentLength || !assembler.end) this.onCancelStream(assembler);
                        }
                    };
                    return StreamManager;
                }();
                exports.StreamManager = StreamManager;
            },
            {
                "../assemblers/payloadAssembler": 1
            }
        ],
        23: [
            function(require1, module1, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ProtocolAdapter = void 0;
                var payloadAssemblerManager_1 = require1("./payloads/payloadAssemblerManager");
                var sendOperations_1 = require1("./payloads/sendOperations");
                var streamManager_1 = require1("./payloads/streamManager");
                var protocol_base_1 = require1("./utilities/protocol-base");
                /**
 * Creates a protocol adapter for Streaming.
 */ var ProtocolAdapter = /** @class */ function() {
                    /**
     * Creates a new instance of the protocol adapter class.
     *
     * @param requestHandler The [RequestHandler](xref:botframework-streaming.RequestHandler) that will process incoming requests.
     * @param requestManager The [RequestManager](xref:botframework-streaming.RequestManager) that will process outgoing requests.
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) for use with outgoing requests.
     * @param receiver The [PayloadReceiver](xref:botframework-streaming.PayloadReceiver) for use with incoming requests.
     */ function ProtocolAdapter(requestHandler, requestManager, sender, receiver) {
                        var _this = this;
                        this.requestHandler = requestHandler;
                        this.requestManager = requestManager;
                        this.payloadSender = sender;
                        this.payloadReceiver = receiver;
                        this.sendOperations = new sendOperations_1.SendOperations(this.payloadSender);
                        this.streamManager = new streamManager_1.StreamManager(this.onCancelStream);
                        this.assemblerManager = new payloadAssemblerManager_1.PayloadAssemblerManager(this.streamManager, function(id, response) {
                            return _this.onReceiveResponse(id, response);
                        }, function(id, request) {
                            return _this.onReceiveRequest(id, request);
                        });
                        this.payloadReceiver.subscribe(function(header) {
                            return _this.assemblerManager.getPayloadStream(header);
                        }, function(header, contentStream, contentLength) {
                            return _this.assemblerManager.onReceive(header, contentStream, contentLength);
                        });
                    }
                    /**
     * Sends a request over the attached request manager.
     *
     * @param request The outgoing request to send.
     * @returns The response to the specified request.
     */ ProtocolAdapter.prototype.sendRequest = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var requestId, getResponsePromise;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        requestId = (0, protocol_base_1.generateGuid)();
                                        getResponsePromise = this.requestManager.getResponse(requestId);
                                        return [
                                            4 /*yield*/ ,
                                            this.sendOperations.sendRequest(requestId, request)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            getResponsePromise
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a request comes in.
     *
     * @param id The id the resources created for the response will be assigned.
     * @param request The incoming request to process.
     */ ProtocolAdapter.prototype.onReceiveRequest = function(id, request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.requestHandler) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.requestHandler.processRequest(request)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        if (!response) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.sendOperations.sendResponse(id, response)
                                        ];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a response comes in.
     *
     * @param id The id the resources created for the response will be assigned.
     * @param response The incoming response to process.
     */ ProtocolAdapter.prototype.onReceiveResponse = function(id, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.requestManager.signalResponse(id, response)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a cancellation comes in.
     *
     * @param contentStreamAssembler The payload assembler processing the incoming data that this cancellation request targets.
     */ ProtocolAdapter.prototype.onCancelStream = function(contentStreamAssembler) {
                        this.sendOperations.sendCancelStream(contentStreamAssembler.id).catch();
                    };
                    return ProtocolAdapter;
                }();
                exports.ProtocolAdapter = ProtocolAdapter;
            },
            {
                "./payloads/payloadAssemblerManager": 17,
                "./payloads/sendOperations": 21,
                "./payloads/streamManager": 22,
                "./utilities/protocol-base": 28
            }
        ],
        24: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestHandler = void 0;
                /**
 * Implemented by classes used to process incoming streaming requests sent over an [IStreamingTransport](xref:botframework-streaming.IStreamingTransport).
 */ var RequestHandler = /** @class */ function() {
                    function RequestHandler() {}
                    return RequestHandler;
                }();
                exports.RequestHandler = RequestHandler;
            },
            {}
        ],
        25: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamingRequest = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var httpContentStream_1 = require1("./httpContentStream");
                var subscribableStream_1 = require1("./subscribableStream");
                /**
 * The basic request type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP request messages.
 */ var StreamingRequest = /** @class */ function() {
                    function StreamingRequest() {
                        /**
         * List of associated streams.
         */ this.streams = [];
                    }
                    /**
     * Creates a streaming request with the passed in method, path, and body.
     *
     * @param method The HTTP verb to use for this request.
     * @param path Optional path where the resource can be found on the remote server.
     * @param body Optional body to send to the remote server.
     * @returns On success returns a streaming request with appropriate status code and body.
     */ StreamingRequest.create = function(method, path, body) {
                        var request = new StreamingRequest();
                        request.verb = method;
                        request.path = path;
                        if (body) request.setBody(body);
                        return request;
                    };
                    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */ StreamingRequest.prototype.addStream = function(content) {
                        if (!content) throw new Error('Argument Undefined Exception: content undefined.');
                        this.streams.push(new httpContentStream_1.HttpContentStream(content));
                    };
                    /**
     * Sets the contents of the body of this streamingRequest.
     *
     * @param body The JSON text to write to the body of the streamingRequest.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                    StreamingRequest.prototype.setBody = function(body) {
                        if (typeof body === 'string') {
                            var stream = new subscribableStream_1.SubscribableStream();
                            stream.write(body, 'utf8');
                            this.addStream(new httpContentStream_1.HttpContent({
                                type: 'application/json; charset=utf-8',
                                contentLength: stream.length
                            }, stream));
                        } else if (typeof body === 'object') this.addStream(body);
                    };
                    return StreamingRequest;
                }();
                exports.StreamingRequest = StreamingRequest;
            },
            {
                "./httpContentStream": 8,
                "./subscribableStream": 27
            }
        ],
        26: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamingResponse = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var httpContentStream_1 = require1("./httpContentStream");
                var subscribableStream_1 = require1("./subscribableStream");
                /**
 * The basic response type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP response messages.
 */ var StreamingResponse = /** @class */ function() {
                    function StreamingResponse() {
                        this.streams = [];
                    }
                    /**
     * Creates a streaming response with the passed in method, path, and body.
     *
     * @param statusCode The HTTP verb to use for this request.
     * @param body Optional body containing additional information.
     * @returns A streaming response with the appropriate statuscode and passed in body.
     */ StreamingResponse.create = function(statusCode, body) {
                        var response = new StreamingResponse();
                        response.statusCode = statusCode;
                        if (body) response.addStream(body);
                        return response;
                    };
                    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */ StreamingResponse.prototype.addStream = function(content) {
                        this.streams.push(new httpContentStream_1.HttpContentStream(content));
                    };
                    /**
     * Sets the contents of the body of this streaming response.
     *
     * @param body The JSON text to write to the body of the streaming response.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                    StreamingResponse.prototype.setBody = function(body) {
                        var stream = new subscribableStream_1.SubscribableStream();
                        stream.write(JSON.stringify(body), 'utf8');
                        this.addStream(new httpContentStream_1.HttpContent({
                            type: 'application/json; charset=utf-8',
                            contentLength: stream.length
                        }, stream));
                    };
                    return StreamingResponse;
                }();
                exports.StreamingResponse = StreamingResponse;
            },
            {
                "./httpContentStream": 8,
                "./subscribableStream": 27
            }
        ],
        27: [
            function(require1, module1, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        var __extends = this && this.__extends || function() {
                            var extendStatics = function(d, b) {
                                extendStatics = Object.setPrototypeOf || ({
                                    __proto__: []
                                }) instanceof Array && function(d, b) {
                                    d.__proto__ = b;
                                } || function(d, b) {
                                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                };
                                return extendStatics(d, b);
                            };
                            return function(d, b) {
                                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                extendStatics(d, b);
                                function __() {
                                    this.constructor = d;
                                }
                                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                            };
                        }();
                        Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.SubscribableStream = void 0;
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var stream_1 = require1("stream");
                        /**
 * An extension of `Duplex` that operates in conjunction with a `PayloadAssembler` to convert raw bytes into a consumable form.
 */ var SubscribableStream = /** @class */ function(_super) {
                            __extends(SubscribableStream, _super);
                            /**
     * Initializes a new instance of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) class.
     *
     * @param options The `DuplexOptions` to use when constructing this stream.
     */ function SubscribableStream(options) {
                                var _this = _super.call(this, options) || this;
                                _this.length = 0;
                                _this.bufferList = [];
                                return _this;
                            }
                            /**
     * Writes data to the buffered list.
     * All calls to writable.write() that occur between the time writable._write() is called and the callback is called will cause the written data to be buffered.
     *
     * @param chunk The Buffer to be written.
     * @param _encoding The encoding. Unused in the implementation of Duplex.
     * @param callback Callback for when this chunk of data is flushed.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                            SubscribableStream.prototype._write = function(chunk, _encoding, callback) {
                                var buffer = Buffer.from(chunk);
                                this.bufferList.push(buffer);
                                this.length += chunk.length;
                                if (this._onData) this._onData(buffer);
                                callback();
                            };
                            /**
     * Reads the buffered list.
     * Once the readable._read() method has been called, it will not be called again until more data is pushed through the readable.push() method.
     * Empty data such as empty buffers and strings will not cause readable._read() to be called.
     *
     * @param size Number of bytes to read.
     */ SubscribableStream.prototype._read = function(size) {
                                if (this.bufferList.length === 0) // null signals end of stream
                                this.push(null);
                                else {
                                    var total = 0;
                                    while(total < size && this.bufferList.length > 0){
                                        var buffer = this.bufferList[0];
                                        this.push(buffer);
                                        this.bufferList.splice(0, 1);
                                        total += buffer.length;
                                    }
                                }
                            };
                            /**
     * Subscribes to the stream when receives data.
     *
     * @param onData Callback to be called when onData is executed.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                            SubscribableStream.prototype.subscribe = function(onData) {
                                this._onData = onData;
                            };
                            return SubscribableStream;
                        }(stream_1.Duplex);
                        exports.SubscribableStream = SubscribableStream;
                    }).call(this);
                }).call(this, require1("buffer").Buffer);
            },
            {
                "buffer": 35,
                "stream": 41
            }
        ],
        28: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.generateGuid = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var uuid_1 = require1("uuid");
                /**
 * Generates an uuid v4 string.
 *
 * @returns An uuidv4 string.
 */ function generateGuid() {
                    return (0, uuid_1.v4)();
                }
                exports.generateGuid = generateGuid;
            },
            {
                "uuid": 58
            }
        ],
        29: [
            function(require1, module1, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BrowserWebSocket = void 0;
                /**
 * Represents a WebSocket that implements [ISocket](xref:botframework-streaming.ISocket).
 */ var BrowserWebSocket = /** @class */ function() {
                    /**
     * Creates a new instance of the [BrowserWebSocket](xref:botframework-streaming.BrowserWebSocket) class.
     *
     * @param socket The socket object to build this connection on.
     */ function BrowserWebSocket(socket) {
                        if (socket) this.webSocket = socket;
                    }
                    /**
     * Connects to the supporting socket using WebSocket protocol.
     *
     * @param serverAddress The address the server is listening on.
     * @returns A Promise that resolves the websocket is open and rejects if an error is encountered.
     */ BrowserWebSocket.prototype.connect = function(serverAddress) {
                        return __awaiter(this, void 0, void 0, function() {
                            var resolver, rejector;
                            return __generator(this, function(_a) {
                                if (!this.webSocket) this.webSocket = new WebSocket(serverAddress);
                                this.webSocket.onerror = function(e) {
                                    rejector(e);
                                };
                                this.webSocket.onopen = function(e) {
                                    resolver(e);
                                };
                                return [
                                    2 /*return*/ ,
                                    new Promise(function(resolve, reject) {
                                        resolver = resolve;
                                        rejector = reject;
                                    })
                                ];
                            });
                        });
                    };
                    Object.defineProperty(BrowserWebSocket.prototype, "isConnected", {
                        /**
         * Indicates if the [BrowserWebSocket's](xref:botframework-streaming.BrowserWebSocket) underlying websocket is currently connected.
         *
         * @returns `true` if the underlying websocket is ready and availble to send messages, otherwise `false`.
         */ get: function() {
                            return this.webSocket.readyState === 1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Writes a buffer to the socket and sends it.
     *
     * @param buffer The buffer of data to send across the connection.
     */ BrowserWebSocket.prototype.write = function(buffer) {
                        this.webSocket.send(buffer);
                    };
                    /**
     * Close the socket.
     */ BrowserWebSocket.prototype.close = function() {
                        this.webSocket.close();
                    };
                    /**
     * Set the handler for text and binary messages received on the socket.
     *
     * @param handler The callback to handle the "message" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnMessageHandler = function(handler) {
                        var bufferKey = 'buffer';
                        var packets = [];
                        this.webSocket.onmessage = function(evt) {
                            var fileReader = new FileReader();
                            var queueEntry = {
                                buffer: null
                            };
                            packets.push(queueEntry);
                            fileReader.onload = function(e) {
                                var t = e.target;
                                queueEntry[bufferKey] = t.result;
                                if (packets[0] === queueEntry) while(0 < packets.length && packets[0][bufferKey]){
                                    handler(packets[0][bufferKey]);
                                    packets.splice(0, 1);
                                }
                            };
                            fileReader.readAsArrayBuffer(evt.data);
                        };
                    };
                    /**
     * Set the callback to call when encountering errors.
     *
     * @param handler The callback to handle the "error" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnErrorHandler = function(handler) {
                        this.webSocket.onerror = function(error) {
                            if (error) handler(error);
                        };
                    };
                    /**
     * Set the callback to call when encountering socket closures.
     *
     * @param handler The callback to handle the "close" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnCloseHandler = function(handler) {
                        this.webSocket.onclose = handler;
                    };
                    return BrowserWebSocket;
                }();
                exports.BrowserWebSocket = BrowserWebSocket;
            },
            {}
        ],
        30: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketClient = void 0;
                var browserWebSocket_1 = require1("./browserWebSocket");
                var payloadTransport_1 = require1("../payloadTransport");
                var protocolAdapter_1 = require1("../protocolAdapter");
                var payloads_1 = require1("../payloads");
                var webSocketTransport_1 = require1("./webSocketTransport");
                /**
 * Web socket based client to be used as streaming transport.
 */ var WebSocketClient = /** @class */ function() {
                    /**
     * Creates a new instance of the [WebSocketClient](xref:botframework-streaming.WebSocketClient) class.
     *
     * @param config For configuring a [WebSocketClient](xref:botframework-streaming.WebSocketClient) instance to communicate with a WebSocket server.
     * @param config.url The URL of the remote server to connect to.
     * @param config.requestHandler The [RequestHandler](xref:botframework-streaming.RequestHandler) used to process incoming messages received by this client.
     * @param config.disconnectionHandler Optional function to handle the disconnection message.
     */ function WebSocketClient(_a) {
                        var url = _a.url, requestHandler = _a.requestHandler, _b = _a.disconnectionHandler, disconnectionHandler = _b === void 0 ? null : _b;
                        this._url = url;
                        this._requestHandler = requestHandler;
                        this._disconnectionHandler = disconnectionHandler;
                        this._requestManager = new payloads_1.RequestManager();
                        this._sender = new payloadTransport_1.PayloadSender();
                        this._sender.disconnected = this.onConnectionDisconnected.bind(this);
                        this._receiver = new payloadTransport_1.PayloadReceiver();
                        this._receiver.disconnected = this.onConnectionDisconnected.bind(this);
                        this._protocolAdapter = new protocolAdapter_1.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
                    }
                    /**
     * Establish a connection with no custom headers.
     *
     * @returns A promise that will not resolve until the client stops listening for incoming messages.
     */ WebSocketClient.prototype.connect = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var ws, transport;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        ws = new browserWebSocket_1.BrowserWebSocket();
                                        return [
                                            4 /*yield*/ ,
                                            ws.connect(this._url)
                                        ];
                                    case 1:
                                        _a.sent();
                                        transport = new webSocketTransport_1.WebSocketTransport(ws);
                                        this._sender.connect(transport);
                                        this._receiver.connect(transport);
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Stop this client from listening.
     */ WebSocketClient.prototype.disconnect = function() {
                        this._sender.disconnect(new payloadTransport_1.TransportDisconnectedEvent('Disconnect was called.'));
                        this._receiver.disconnect(new payloadTransport_1.TransportDisconnectedEvent('Disconnect was called.'));
                    };
                    /**
     * Task used to send data over this client connection.
     *
     * @param request The streaming request to send.
     * @returns A promise that will produce an instance of receive response on completion of the send operation.
     */ WebSocketClient.prototype.send = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._protocolAdapter.sendRequest(request)
                                ];
                            });
                        });
                    };
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    WebSocketClient.prototype.onConnectionDisconnected = function(sender, args) {
                        // Rejects all pending requests on disconnect.
                        this._requestManager.rejectAllResponses(new Error('Disconnect was called.'));
                        if (this._disconnectionHandler != null) {
                            this._disconnectionHandler('Disconnected');
                            return;
                        }
                        throw new Error("Unable to re-connect client to transport for url ".concat(this._url, ". Sender: '").concat(JSON.stringify(sender), "'. Args:' ").concat(JSON.stringify(args)));
                    };
                    return WebSocketClient;
                }();
                exports.WebSocketClient = WebSocketClient;
            },
            {
                "../payloadTransport": 10,
                "../payloads": 16,
                "../protocolAdapter": 23,
                "./browserWebSocket": 29,
                "./webSocketTransport": 32
            }
        ],
        31: [
            function(require1, module1, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketTransport = exports.WebSocketClient = exports.BrowserWebSocket = void 0;
                var browserWebSocket_1 = require1("./browserWebSocket");
                Object.defineProperty(exports, "BrowserWebSocket", {
                    enumerable: true,
                    get: function() {
                        return browserWebSocket_1.BrowserWebSocket;
                    }
                });
                var browserWebSocketClient_1 = require1("./browserWebSocketClient");
                Object.defineProperty(exports, "WebSocketClient", {
                    enumerable: true,
                    get: function() {
                        return browserWebSocketClient_1.WebSocketClient;
                    }
                });
                /** @internal */ var webSocketTransport_1 = require1("./webSocketTransport");
                Object.defineProperty(exports, "WebSocketTransport", {
                    enumerable: true,
                    get: function() {
                        return webSocketTransport_1.WebSocketTransport;
                    }
                });
            },
            {
                "./browserWebSocket": 29,
                "./browserWebSocketClient": 30,
                "./webSocketTransport": 32
            }
        ],
        32: [
            function(require1, module1, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                            function adopt(value) {
                                return value instanceof P ? value : new P(function(resolve) {
                                    resolve(value);
                                });
                            }
                            return new (P || (P = Promise))(function(resolve, reject) {
                                function fulfilled(value) {
                                    try {
                                        step(generator.next(value));
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                                function rejected(value) {
                                    try {
                                        step(generator["throw"](value));
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                                function step(result) {
                                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                                }
                                step((generator = generator.apply(thisArg, _arguments || [])).next());
                            });
                        };
                        var __generator = this && this.__generator || function(thisArg, body) {
                            var _ = {
                                label: 0,
                                sent: function() {
                                    if (t[0] & 1) throw t[1];
                                    return t[1];
                                },
                                trys: [],
                                ops: []
                            }, f, y, t, g;
                            return g = {
                                next: verb(0),
                                "throw": verb(1),
                                "return": verb(2)
                            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                                return this;
                            }), g;
                            function verb(n) {
                                return function(v) {
                                    return step([
                                        n,
                                        v
                                    ]);
                                };
                            }
                            function step(op) {
                                if (f) throw new TypeError("Generator is already executing.");
                                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                                    if (y = 0, t) op = [
                                        op[0] & 2,
                                        t.value
                                    ];
                                    switch(op[0]){
                                        case 0:
                                        case 1:
                                            t = op;
                                            break;
                                        case 4:
                                            _.label++;
                                            return {
                                                value: op[1],
                                                done: false
                                            };
                                        case 5:
                                            _.label++;
                                            y = op[1];
                                            op = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            op = _.ops.pop();
                                            _.trys.pop();
                                            continue;
                                        default:
                                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                                _ = 0;
                                                continue;
                                            }
                                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                                _.label = op[1];
                                                break;
                                            }
                                            if (op[0] === 6 && _.label < t[1]) {
                                                _.label = t[1];
                                                t = op;
                                                break;
                                            }
                                            if (t && _.label < t[2]) {
                                                _.label = t[2];
                                                _.ops.push(op);
                                                break;
                                            }
                                            if (t[2]) _.ops.pop();
                                            _.trys.pop();
                                            continue;
                                    }
                                    op = body.call(thisArg, _);
                                } catch (e) {
                                    op = [
                                        6,
                                        e
                                    ];
                                    y = 0;
                                } finally{
                                    f = t = 0;
                                }
                                if (op[0] & 5) throw op[1];
                                return {
                                    value: op[0] ? op[1] : void 0,
                                    done: true
                                };
                            }
                        };
                        Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.WebSocketTransport = void 0;
                        /**
 * Web socket based transport.
 */ var WebSocketTransport = /** @class */ function() {
                            /**
     * Creates a new instance of the [WebSocketTransport](xref:botframework-streaming.WebSocketTransport) class.
     *
     * @param ws The ISocket to build this transport on top of.
     */ function WebSocketTransport(ws) {
                                var _this = this;
                                this.ws = ws;
                                this._queue = [];
                                this._activeOffset = 0;
                                this._activeReceiveCount = 0;
                                this.ws.setOnMessageHandler(function(data) {
                                    _this.onReceive(data);
                                });
                                this.ws.setOnErrorHandler(function(err) {
                                    _this.onError(err);
                                });
                                this.ws.setOnCloseHandler(function() {
                                    _this.onClose();
                                });
                            }
                            /**
     * Sends the given buffer out over the socket's connection.
     *
     * @param buffer The buffered data to send out over the connection.
     * @returns A number indicating the length of the sent data if the data was successfully sent, otherwise 0.
     */ WebSocketTransport.prototype.send = function(buffer) {
                                var _a;
                                if ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected) {
                                    this.ws.write(buffer);
                                    return buffer.length;
                                }
                                return 0;
                            };
                            Object.defineProperty(WebSocketTransport.prototype, "isConnected", {
                                /**
         * Returns true if the transport is connected to a socket.
         *
         * @returns `true` if the the transport is connected and ready to send data, `false` otherwise.
         */ get: function() {
                                    var _a;
                                    return !!((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected);
                                },
                                enumerable: false,
                                configurable: true
                            });
                            /**
     * Close the socket this transport is connected to.
     */ WebSocketTransport.prototype.close = function() {
                                var _a;
                                if ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected) this.ws.close();
                            };
                            /**
     * Attempt to receive incoming data from the connected socket.
     *
     * @param count The number of bytes to attempt to receive.
     * @returns A buffer populated with the received data.
     */ WebSocketTransport.prototype.receive = function(count) {
                                return __awaiter(this, void 0, void 0, function() {
                                    var promise;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        if (this._activeReceiveResolve) throw new Error('Cannot call receive more than once before it has returned.');
                                        this._activeReceiveCount = count;
                                        promise = new Promise(function(resolve, reject) {
                                            _this._activeReceiveResolve = resolve;
                                            _this._activeReceiveReject = reject;
                                        });
                                        this.trySignalData();
                                        return [
                                            2 /*return*/ ,
                                            promise
                                        ];
                                    });
                                });
                            };
                            /**
     * Sets the transport to attempt to receive incoming data that has not yet arrived.
     *
     * @param data A buffer to store incoming data in.
     */ WebSocketTransport.prototype.onReceive = function(data) {
                                if (this._queue && data && data.byteLength > 0) {
                                    this._queue.push(Buffer.from(data));
                                    this.trySignalData();
                                }
                            };
                            WebSocketTransport.prototype.onClose = function() {
                                if (this._activeReceiveReject) this._activeReceiveReject(new Error('Socket was closed.'));
                                this._active = null;
                                this._activeOffset = 0;
                                this._activeReceiveResolve = null;
                                this._activeReceiveReject = null;
                                this._activeReceiveCount = 0;
                                this.ws = null;
                            };
                            WebSocketTransport.prototype.onError = function(err) {
                                if (this._activeReceiveReject) this._activeReceiveReject(err);
                                this.onClose();
                            };
                            WebSocketTransport.prototype.trySignalData = function() {
                                if (this._activeReceiveResolve) {
                                    if (!this._active && this._queue.length > 0) {
                                        this._active = this._queue.shift();
                                        this._activeOffset = 0;
                                    }
                                    if (this._active) {
                                        if (this._activeOffset === 0 && this._active.length === this._activeReceiveCount) {
                                            // can send the entire _active buffer
                                            var buffer = this._active;
                                            this._active = null;
                                            this._activeReceiveResolve(buffer);
                                        } else {
                                            // create a Buffer.from and copy some of the contents into it
                                            var available = Math.min(this._activeReceiveCount, this._active.length - this._activeOffset);
                                            var buffer = Buffer.alloc(available);
                                            this._active.copy(buffer, 0, this._activeOffset, this._activeOffset + available);
                                            this._activeOffset += available;
                                            // if we used all of active, set it to undefined
                                            if (this._activeOffset >= this._active.length) {
                                                this._active = null;
                                                this._activeOffset = 0;
                                            }
                                            this._activeReceiveResolve(buffer);
                                        }
                                        this._activeReceiveCount = 0;
                                        this._activeReceiveReject = null;
                                        this._activeReceiveResolve = null;
                                    }
                                }
                            };
                            return WebSocketTransport;
                        }();
                        exports.WebSocketTransport = WebSocketTransport;
                    }).call(this);
                }).call(this, require1("buffer").Buffer);
            },
            {
                "buffer": 35
            }
        ],
        33: [
            function(require1, module1, exports) {},
            {}
        ],
        34: [
            function(require1, module1, exports) {
                'use strict';
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
                var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup['-'.charCodeAt(0)] = 62;
                revLookup['_'.charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf('=');
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join('');
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
                    }
                    return parts.join('');
                }
            },
            {}
        ],
        35: [
            function(require1, module1, exports) {
                (function(Buffer) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
                        var base64 = require1('base64-js');
                        var ieee754 = require1('ieee754');
                        exports.Buffer = Buffer;
                        exports.SlowBuffer = SlowBuffer;
                        exports.INSPECT_MAX_BYTES = 50;
                        var K_MAX_LENGTH = 0x7fffffff;
                        exports.kMaxLength = K_MAX_LENGTH;
                        /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                        if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                        function typedArraySupport() {
                            // Can typed array instances can be augmented?
                            try {
                                var arr = new Uint8Array(1);
                                arr.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                };
                                return arr.foo() === 42;
                            } catch (e) {
                                return false;
                            }
                        }
                        Object.defineProperty(Buffer.prototype, 'parent', {
                            enumerable: true,
                            get: function() {
                                if (!Buffer.isBuffer(this)) return undefined;
                                return this.buffer;
                            }
                        });
                        Object.defineProperty(Buffer.prototype, 'offset', {
                            enumerable: true,
                            get: function() {
                                if (!Buffer.isBuffer(this)) return undefined;
                                return this.byteOffset;
                            }
                        });
                        function createBuffer(length) {
                            if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                            // Return an augmented `Uint8Array` instance
                            var buf = new Uint8Array(length);
                            buf.__proto__ = Buffer.prototype;
                            return buf;
                        }
                        /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                            // Common case.
                            if (typeof arg === 'number') {
                                if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
                                return allocUnsafe(arg);
                            }
                            return from(arg, encodingOrOffset, length);
                        }
                        // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
                        if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) Object.defineProperty(Buffer, Symbol.species, {
                            value: null,
                            configurable: true,
                            enumerable: false,
                            writable: false
                        });
                        Buffer.poolSize = 8192 // not used by this implementation
                        ;
                        function from(value, encodingOrOffset, length) {
                            if (typeof value === 'string') return fromString(value, encodingOrOffset);
                            if (ArrayBuffer.isView(value)) return fromArrayLike(value);
                            if (value == null) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                            if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                            if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var valueOf = value.valueOf && value.valueOf();
                            if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                            var b = fromObject(value);
                            if (b) return b;
                            if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                        }
                        /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                            return from(value, encodingOrOffset, length);
                        };
                        // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                        // https://github.com/feross/buffer/pull/148
                        Buffer.prototype.__proto__ = Uint8Array.prototype;
                        Buffer.__proto__ = Uint8Array;
                        function assertSize(size) {
                            if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
                            else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                        }
                        function alloc(size, fill, encoding) {
                            assertSize(size);
                            if (size <= 0) return createBuffer(size);
                            if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                            // prevents accidentally sending in a number that would
                            // be interpretted as a start offset.
                            return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                            return createBuffer(size);
                        }
                        /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                            return alloc(size, fill, encoding);
                        };
                        function allocUnsafe(size) {
                            assertSize(size);
                            return createBuffer(size < 0 ? 0 : checked(size) | 0);
                        }
                        /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                            return allocUnsafe(size);
                        };
                        /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                            return allocUnsafe(size);
                        };
                        function fromString(string, encoding) {
                            if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
                            if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                            var length = byteLength(string, encoding) | 0;
                            var buf = createBuffer(length);
                            var actual = buf.write(string, encoding);
                            if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                            // cause everything after the first invalid character to be ignored. (e.g.
                            // 'abxxcd' will be treated as 'ab')
                            buf = buf.slice(0, actual);
                            return buf;
                        }
                        function fromArrayLike(array) {
                            var length = array.length < 0 ? 0 : checked(array.length) | 0;
                            var buf = createBuffer(length);
                            for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                            return buf;
                        }
                        function fromArrayBuffer(array, byteOffset, length) {
                            if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                            if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                            var buf;
                            if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                            else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                            else buf = new Uint8Array(array, byteOffset, length);
                            // Return an augmented `Uint8Array` instance
                            buf.__proto__ = Buffer.prototype;
                            return buf;
                        }
                        function fromObject(obj) {
                            if (Buffer.isBuffer(obj)) {
                                var len = checked(obj.length) | 0;
                                var buf = createBuffer(len);
                                if (buf.length === 0) return buf;
                                obj.copy(buf, 0, 0, len);
                                return buf;
                            }
                            if (obj.length !== undefined) {
                                if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
                                return fromArrayLike(obj);
                            }
                            if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                        }
                        function checked(length) {
                            // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                            // length is NaN (which is otherwise coerced to zero.)
                            if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
                            return length | 0;
                        }
                        function SlowBuffer(length) {
                            if (+length != length) length = 0;
                            return Buffer.alloc(+length);
                        }
                        Buffer.isBuffer = function isBuffer(b) {
                            return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
                            ;
                        };
                        Buffer.compare = function compare(a, b) {
                            if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                            if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (a === b) return 0;
                            var x = a.length;
                            var y = b.length;
                            for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                                x = a[i];
                                y = b[i];
                                break;
                            }
                            if (x < y) return -1;
                            if (y < x) return 1;
                            return 0;
                        };
                        Buffer.isEncoding = function isEncoding(encoding) {
                            switch(String(encoding).toLowerCase()){
                                case 'hex':
                                case 'utf8':
                                case 'utf-8':
                                case 'ascii':
                                case 'latin1':
                                case 'binary':
                                case 'base64':
                                case 'ucs2':
                                case 'ucs-2':
                                case 'utf16le':
                                case 'utf-16le':
                                    return true;
                                default:
                                    return false;
                            }
                        };
                        Buffer.concat = function concat(list, length) {
                            if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (list.length === 0) return Buffer.alloc(0);
                            var i;
                            if (length === undefined) {
                                length = 0;
                                for(i = 0; i < list.length; ++i)length += list[i].length;
                            }
                            var buffer = Buffer.allocUnsafe(length);
                            var pos = 0;
                            for(i = 0; i < list.length; ++i){
                                var buf = list[i];
                                if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
                                if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                                buf.copy(buffer, pos);
                                pos += buf.length;
                            }
                            return buffer;
                        };
                        function byteLength(string, encoding) {
                            if (Buffer.isBuffer(string)) return string.length;
                            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                            if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                            var len = string.length;
                            var mustMatch = arguments.length > 2 && arguments[2] === true;
                            if (!mustMatch && len === 0) return 0;
                            // Use a for loop to avoid recursion
                            var loweredCase = false;
                            for(;;)switch(encoding){
                                case 'ascii':
                                case 'latin1':
                                case 'binary':
                                    return len;
                                case 'utf8':
                                case 'utf-8':
                                    return utf8ToBytes(string).length;
                                case 'ucs2':
                                case 'ucs-2':
                                case 'utf16le':
                                case 'utf-16le':
                                    return len * 2;
                                case 'hex':
                                    return len >>> 1;
                                case 'base64':
                                    return base64ToBytes(string).length;
                                default:
                                    if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                                    ;
                                    encoding = ('' + encoding).toLowerCase();
                                    loweredCase = true;
                            }
                        }
                        Buffer.byteLength = byteLength;
                        function slowToString(encoding, start, end) {
                            var loweredCase = false;
                            // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                            // property of a typed array.
                            // This behaves neither like String nor Uint8Array in that we set start/end
                            // to their upper/lower bounds if the value passed is out of range.
                            // undefined is handled specially as per ECMA-262 6th Edition,
                            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                            if (start === undefined || start < 0) start = 0;
                            // Return early if start > this.length. Done here to prevent potential uint32
                            // coercion fail below.
                            if (start > this.length) return '';
                            if (end === undefined || end > this.length) end = this.length;
                            if (end <= 0) return '';
                            // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                            end >>>= 0;
                            start >>>= 0;
                            if (end <= start) return '';
                            if (!encoding) encoding = 'utf8';
                            while(true)switch(encoding){
                                case 'hex':
                                    return hexSlice(this, start, end);
                                case 'utf8':
                                case 'utf-8':
                                    return utf8Slice(this, start, end);
                                case 'ascii':
                                    return asciiSlice(this, start, end);
                                case 'latin1':
                                case 'binary':
                                    return latin1Slice(this, start, end);
                                case 'base64':
                                    return base64Slice(this, start, end);
                                case 'ucs2':
                                case 'ucs-2':
                                case 'utf16le':
                                case 'utf-16le':
                                    return utf16leSlice(this, start, end);
                                default:
                                    if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                                    encoding = (encoding + '').toLowerCase();
                                    loweredCase = true;
                            }
                        }
                        // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                        // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                        // reliably in a browserify context because there could be multiple different
                        // copies of the 'buffer' package in use. This method works even for Buffer
                        // instances that were created from another copy of the `buffer` package.
                        // See: https://github.com/feross/buffer/issues/154
                        Buffer.prototype._isBuffer = true;
                        function swap(b, n, m) {
                            var i = b[n];
                            b[n] = b[m];
                            b[m] = i;
                        }
                        Buffer.prototype.swap16 = function swap16() {
                            var len = this.length;
                            if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
                            for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                            return this;
                        };
                        Buffer.prototype.swap32 = function swap32() {
                            var len = this.length;
                            if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
                            for(var i = 0; i < len; i += 4){
                                swap(this, i, i + 3);
                                swap(this, i + 1, i + 2);
                            }
                            return this;
                        };
                        Buffer.prototype.swap64 = function swap64() {
                            var len = this.length;
                            if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
                            for(var i = 0; i < len; i += 8){
                                swap(this, i, i + 7);
                                swap(this, i + 1, i + 6);
                                swap(this, i + 2, i + 5);
                                swap(this, i + 3, i + 4);
                            }
                            return this;
                        };
                        Buffer.prototype.toString = function toString() {
                            var length = this.length;
                            if (length === 0) return '';
                            if (arguments.length === 0) return utf8Slice(this, 0, length);
                            return slowToString.apply(this, arguments);
                        };
                        Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                        Buffer.prototype.equals = function equals(b) {
                            if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
                            if (this === b) return true;
                            return Buffer.compare(this, b) === 0;
                        };
                        Buffer.prototype.inspect = function inspect() {
                            var str = '';
                            var max = exports.INSPECT_MAX_BYTES;
                            str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
                            if (this.length > max) str += ' ... ';
                            return '<Buffer ' + str + '>';
                        };
                        Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                            if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                            if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                            if (start === undefined) start = 0;
                            if (end === undefined) end = target ? target.length : 0;
                            if (thisStart === undefined) thisStart = 0;
                            if (thisEnd === undefined) thisEnd = this.length;
                            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
                            if (thisStart >= thisEnd && start >= end) return 0;
                            if (thisStart >= thisEnd) return -1;
                            if (start >= end) return 1;
                            start >>>= 0;
                            end >>>= 0;
                            thisStart >>>= 0;
                            thisEnd >>>= 0;
                            if (this === target) return 0;
                            var x = thisEnd - thisStart;
                            var y = end - start;
                            var len = Math.min(x, y);
                            var thisCopy = this.slice(thisStart, thisEnd);
                            var targetCopy = target.slice(start, end);
                            for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                                x = thisCopy[i];
                                y = targetCopy[i];
                                break;
                            }
                            if (x < y) return -1;
                            if (y < x) return 1;
                            return 0;
                        };
                        // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                        // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                        //
                        // Arguments:
                        // - buffer - a Buffer to search
                        // - val - a string, Buffer, or number
                        // - byteOffset - an index into `buffer`; will be clamped to an int32
                        // - encoding - an optional encoding, relevant is val is a string
                        // - dir - true for indexOf, false for lastIndexOf
                        function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                            // Empty buffer means no match
                            if (buffer.length === 0) return -1;
                            // Normalize byteOffset
                            if (typeof byteOffset === 'string') {
                                encoding = byteOffset;
                                byteOffset = 0;
                            } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                            else if (byteOffset < -2147483648) byteOffset = -2147483648;
                            byteOffset = +byteOffset // Coerce to Number.
                            ;
                            if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                            byteOffset = dir ? 0 : buffer.length - 1;
                            // Normalize byteOffset: negative offsets start from the end of the buffer
                            if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                            if (byteOffset >= buffer.length) {
                                if (dir) return -1;
                                else byteOffset = buffer.length - 1;
                            } else if (byteOffset < 0) {
                                if (dir) byteOffset = 0;
                                else return -1;
                            }
                            // Normalize val
                            if (typeof val === 'string') val = Buffer.from(val, encoding);
                            // Finally, search either indexOf (if dir is true) or lastIndexOf
                            if (Buffer.isBuffer(val)) {
                                // Special case: looking for empty string/buffer always fails
                                if (val.length === 0) return -1;
                                return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                            } else if (typeof val === 'number') {
                                val = val & 0xFF // Search for a byte value [0-255]
                                ;
                                if (typeof Uint8Array.prototype.indexOf === 'function') {
                                    if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                                    else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                                }
                                return arrayIndexOf(buffer, [
                                    val
                                ], byteOffset, encoding, dir);
                            }
                            throw new TypeError('val must be string, number or Buffer');
                        }
                        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                            var indexSize = 1;
                            var arrLength = arr.length;
                            var valLength = val.length;
                            if (encoding !== undefined) {
                                encoding = String(encoding).toLowerCase();
                                if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                                    if (arr.length < 2 || val.length < 2) return -1;
                                    indexSize = 2;
                                    arrLength /= 2;
                                    valLength /= 2;
                                    byteOffset /= 2;
                                }
                            }
                            function read(buf, i) {
                                if (indexSize === 1) return buf[i];
                                else return buf.readUInt16BE(i * indexSize);
                            }
                            var i;
                            if (dir) {
                                var foundIndex = -1;
                                for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                                    if (foundIndex === -1) foundIndex = i;
                                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                                } else {
                                    if (foundIndex !== -1) i -= i - foundIndex;
                                    foundIndex = -1;
                                }
                            } else {
                                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                                for(i = byteOffset; i >= 0; i--){
                                    var found = true;
                                    for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                        found = false;
                                        break;
                                    }
                                    if (found) return i;
                                }
                            }
                            return -1;
                        }
                        Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                            return this.indexOf(val, byteOffset, encoding) !== -1;
                        };
                        Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                        };
                        Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                        };
                        function hexWrite(buf, string, offset, length) {
                            offset = Number(offset) || 0;
                            var remaining = buf.length - offset;
                            if (!length) length = remaining;
                            else {
                                length = Number(length);
                                if (length > remaining) length = remaining;
                            }
                            var strLen = string.length;
                            if (length > strLen / 2) length = strLen / 2;
                            for(var i = 0; i < length; ++i){
                                var parsed = parseInt(string.substr(i * 2, 2), 16);
                                if (numberIsNaN(parsed)) return i;
                                buf[offset + i] = parsed;
                            }
                            return i;
                        }
                        function utf8Write(buf, string, offset, length) {
                            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                        }
                        function asciiWrite(buf, string, offset, length) {
                            return blitBuffer(asciiToBytes(string), buf, offset, length);
                        }
                        function latin1Write(buf, string, offset, length) {
                            return asciiWrite(buf, string, offset, length);
                        }
                        function base64Write(buf, string, offset, length) {
                            return blitBuffer(base64ToBytes(string), buf, offset, length);
                        }
                        function ucs2Write(buf, string, offset, length) {
                            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                        }
                        Buffer.prototype.write = function write(string, offset, length, encoding) {
                            // Buffer#write(string)
                            if (offset === undefined) {
                                encoding = 'utf8';
                                length = this.length;
                                offset = 0;
                            // Buffer#write(string, encoding)
                            } else if (length === undefined && typeof offset === 'string') {
                                encoding = offset;
                                length = this.length;
                                offset = 0;
                            // Buffer#write(string, offset[, length][, encoding])
                            } else if (isFinite(offset)) {
                                offset = offset >>> 0;
                                if (isFinite(length)) {
                                    length = length >>> 0;
                                    if (encoding === undefined) encoding = 'utf8';
                                } else {
                                    encoding = length;
                                    length = undefined;
                                }
                            } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
                            var remaining = this.length - offset;
                            if (length === undefined || length > remaining) length = remaining;
                            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
                            if (!encoding) encoding = 'utf8';
                            var loweredCase = false;
                            for(;;)switch(encoding){
                                case 'hex':
                                    return hexWrite(this, string, offset, length);
                                case 'utf8':
                                case 'utf-8':
                                    return utf8Write(this, string, offset, length);
                                case 'ascii':
                                    return asciiWrite(this, string, offset, length);
                                case 'latin1':
                                case 'binary':
                                    return latin1Write(this, string, offset, length);
                                case 'base64':
                                    // Warning: maxLength not taken into account in base64Write
                                    return base64Write(this, string, offset, length);
                                case 'ucs2':
                                case 'ucs-2':
                                case 'utf16le':
                                case 'utf-16le':
                                    return ucs2Write(this, string, offset, length);
                                default:
                                    if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                                    encoding = ('' + encoding).toLowerCase();
                                    loweredCase = true;
                            }
                        };
                        Buffer.prototype.toJSON = function toJSON() {
                            return {
                                type: 'Buffer',
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function base64Slice(buf, start, end) {
                            if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                            else return base64.fromByteArray(buf.slice(start, end));
                        }
                        function utf8Slice(buf, start, end) {
                            end = Math.min(buf.length, end);
                            var res = [];
                            var i = start;
                            while(i < end){
                                var firstByte = buf[i];
                                var codePoint = null;
                                var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                                if (i + bytesPerSequence <= end) {
                                    var secondByte, thirdByte, fourthByte, tempCodePoint;
                                    switch(bytesPerSequence){
                                        case 1:
                                            if (firstByte < 0x80) codePoint = firstByte;
                                            break;
                                        case 2:
                                            secondByte = buf[i + 1];
                                            if ((secondByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                                if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                            }
                                            break;
                                        case 3:
                                            secondByte = buf[i + 1];
                                            thirdByte = buf[i + 2];
                                            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                            }
                                            break;
                                        case 4:
                                            secondByte = buf[i + 1];
                                            thirdByte = buf[i + 2];
                                            fourthByte = buf[i + 3];
                                            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                            }
                                    }
                                }
                                if (codePoint === null) {
                                    // we did not generate a valid codePoint so insert a
                                    // replacement char (U+FFFD) and advance only 1 byte
                                    codePoint = 0xFFFD;
                                    bytesPerSequence = 1;
                                } else if (codePoint > 0xFFFF) {
                                    // encode to utf16 (surrogate pair dance)
                                    codePoint -= 0x10000;
                                    res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                                    codePoint = 0xDC00 | codePoint & 0x3FF;
                                }
                                res.push(codePoint);
                                i += bytesPerSequence;
                            }
                            return decodeCodePointsArray(res);
                        }
                        // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                        // the lowest limit is Chrome, with 0x10000 args.
                        // We go 1 magnitude less, for safety
                        var MAX_ARGUMENTS_LENGTH = 0x1000;
                        function decodeCodePointsArray(codePoints) {
                            var len = codePoints.length;
                            if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                            ;
                            // Decode in chunks to avoid "call stack size exceeded".
                            var res = '';
                            var i = 0;
                            while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                            return res;
                        }
                        function asciiSlice(buf, start, end) {
                            var ret = '';
                            end = Math.min(buf.length, end);
                            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                            return ret;
                        }
                        function latin1Slice(buf, start, end) {
                            var ret = '';
                            end = Math.min(buf.length, end);
                            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                            return ret;
                        }
                        function hexSlice(buf, start, end) {
                            var len = buf.length;
                            if (!start || start < 0) start = 0;
                            if (!end || end < 0 || end > len) end = len;
                            var out = '';
                            for(var i = start; i < end; ++i)out += toHex(buf[i]);
                            return out;
                        }
                        function utf16leSlice(buf, start, end) {
                            var bytes = buf.slice(start, end);
                            var res = '';
                            for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                            return res;
                        }
                        Buffer.prototype.slice = function slice(start, end) {
                            var len = this.length;
                            start = ~~start;
                            end = end === undefined ? len : ~~end;
                            if (start < 0) {
                                start += len;
                                if (start < 0) start = 0;
                            } else if (start > len) start = len;
                            if (end < 0) {
                                end += len;
                                if (end < 0) end = 0;
                            } else if (end > len) end = len;
                            if (end < start) end = start;
                            var newBuf = this.subarray(start, end);
                            // Return an augmented `Uint8Array` instance
                            newBuf.__proto__ = Buffer.prototype;
                            return newBuf;
                        };
                        /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                            if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
                            if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
                        }
                        Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset];
                            var mul = 1;
                            var i = 0;
                            while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                            return val;
                        };
                        Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset + --byteLength];
                            var mul = 1;
                            while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                            return val;
                        };
                        Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 1, this.length);
                            return this[offset];
                        };
                        Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            return this[offset] | this[offset + 1] << 8;
                        };
                        Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            return this[offset] << 8 | this[offset + 1];
                        };
                        Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                        };
                        Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                        };
                        Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset];
                            var mul = 1;
                            var i = 0;
                            while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                            mul *= 0x80;
                            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                            return val;
                        };
                        Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var i = byteLength;
                            var mul = 1;
                            var val = this[offset + --i];
                            while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                            mul *= 0x80;
                            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                            return val;
                        };
                        Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 1, this.length);
                            if (!(this[offset] & 0x80)) return this[offset];
                            return (0xff - this[offset] + 1) * -1;
                        };
                        Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            var val = this[offset] | this[offset + 1] << 8;
                            return val & 0x8000 ? val | 0xFFFF0000 : val;
                        };
                        Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            var val = this[offset + 1] | this[offset] << 8;
                            return val & 0x8000 ? val | 0xFFFF0000 : val;
                        };
                        Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                        };
                        Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                        };
                        Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return ieee754.read(this, offset, true, 23, 4);
                        };
                        Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return ieee754.read(this, offset, false, 23, 4);
                        };
                        Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 8, this.length);
                            return ieee754.read(this, offset, true, 52, 8);
                        };
                        Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 8, this.length);
                            return ieee754.read(this, offset, false, 52, 8);
                        };
                        function checkInt(buf, value, offset, ext, max, min) {
                            if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                            if (offset + ext > buf.length) throw new RangeError('Index out of range');
                        }
                        Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) {
                                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                                checkInt(this, value, offset, byteLength, maxBytes, 0);
                            }
                            var mul = 1;
                            var i = 0;
                            this[offset] = value & 0xFF;
                            while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) {
                                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                                checkInt(this, value, offset, byteLength, maxBytes, 0);
                            }
                            var i = byteLength - 1;
                            var mul = 1;
                            this[offset + i] = value & 0xFF;
                            while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                            this[offset] = value & 0xff;
                            return offset + 1;
                        };
                        Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            return offset + 2;
                        };
                        Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                            this[offset] = value >>> 8;
                            this[offset + 1] = value & 0xff;
                            return offset + 2;
                        };
                        Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                            this[offset + 3] = value >>> 24;
                            this[offset + 2] = value >>> 16;
                            this[offset + 1] = value >>> 8;
                            this[offset] = value & 0xff;
                            return offset + 4;
                        };
                        Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                            this[offset] = value >>> 24;
                            this[offset + 1] = value >>> 16;
                            this[offset + 2] = value >>> 8;
                            this[offset + 3] = value & 0xff;
                            return offset + 4;
                        };
                        Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) {
                                var limit = Math.pow(2, 8 * byteLength - 1);
                                checkInt(this, value, offset, byteLength, limit - 1, -limit);
                            }
                            var i = 0;
                            var mul = 1;
                            var sub = 0;
                            this[offset] = value & 0xFF;
                            while(++i < byteLength && (mul *= 0x100)){
                                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                                this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                            }
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) {
                                var limit = Math.pow(2, 8 * byteLength - 1);
                                checkInt(this, value, offset, byteLength, limit - 1, -limit);
                            }
                            var i = byteLength - 1;
                            var mul = 1;
                            var sub = 0;
                            this[offset + i] = value & 0xFF;
                            while(--i >= 0 && (mul *= 0x100)){
                                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                                this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                            }
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                            if (value < 0) value = 0xff + value + 1;
                            this[offset] = value & 0xff;
                            return offset + 1;
                        };
                        Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            return offset + 2;
                        };
                        Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                            this[offset] = value >>> 8;
                            this[offset + 1] = value & 0xff;
                            return offset + 2;
                        };
                        Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            this[offset + 2] = value >>> 16;
                            this[offset + 3] = value >>> 24;
                            return offset + 4;
                        };
                        Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                            if (value < 0) value = 0xffffffff + value + 1;
                            this[offset] = value >>> 24;
                            this[offset + 1] = value >>> 16;
                            this[offset + 2] = value >>> 8;
                            this[offset + 3] = value & 0xff;
                            return offset + 4;
                        };
                        function checkIEEE754(buf, value, offset, ext, max, min) {
                            if (offset + ext > buf.length) throw new RangeError('Index out of range');
                            if (offset < 0) throw new RangeError('Index out of range');
                        }
                        function writeFloat(buf, value, offset, littleEndian, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                            ieee754.write(buf, value, offset, littleEndian, 23, 4);
                            return offset + 4;
                        }
                        Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                            return writeFloat(this, value, offset, true, noAssert);
                        };
                        Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                            return writeFloat(this, value, offset, false, noAssert);
                        };
                        function writeDouble(buf, value, offset, littleEndian, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                            ieee754.write(buf, value, offset, littleEndian, 52, 8);
                            return offset + 8;
                        }
                        Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                            return writeDouble(this, value, offset, true, noAssert);
                        };
                        Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                            return writeDouble(this, value, offset, false, noAssert);
                        };
                        // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                        Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                            if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
                            if (!start) start = 0;
                            if (!end && end !== 0) end = this.length;
                            if (targetStart >= target.length) targetStart = target.length;
                            if (!targetStart) targetStart = 0;
                            if (end > 0 && end < start) end = start;
                            // Copy 0 bytes; we're done
                            if (end === start) return 0;
                            if (target.length === 0 || this.length === 0) return 0;
                            // Fatal error conditions
                            if (targetStart < 0) throw new RangeError('targetStart out of bounds');
                            if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
                            if (end < 0) throw new RangeError('sourceEnd out of bounds');
                            // Are we oob?
                            if (end > this.length) end = this.length;
                            if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                            var len = end - start;
                            if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
                            this.copyWithin(targetStart, start, end);
                            else if (this === target && start < targetStart && targetStart < end) // descending copy from end
                            for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                            else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                            return len;
                        };
                        // Usage:
                        //    buffer.fill(number[, offset[, end]])
                        //    buffer.fill(buffer[, offset[, end]])
                        //    buffer.fill(string[, offset[, end]][, encoding])
                        Buffer.prototype.fill = function fill(val, start, end, encoding) {
                            // Handle string cases:
                            if (typeof val === 'string') {
                                if (typeof start === 'string') {
                                    encoding = start;
                                    start = 0;
                                    end = this.length;
                                } else if (typeof end === 'string') {
                                    encoding = end;
                                    end = this.length;
                                }
                                if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
                                if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                                if (val.length === 1) {
                                    var code = val.charCodeAt(0);
                                    if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                                    val = code;
                                }
                            } else if (typeof val === 'number') val = val & 255;
                            // Invalid ranges are not set to a default, so can range check early.
                            if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
                            if (end <= start) return this;
                            start = start >>> 0;
                            end = end === undefined ? this.length : end >>> 0;
                            if (!val) val = 0;
                            var i;
                            if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
                            else {
                                var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                                var len = bytes.length;
                                if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                                for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                            }
                            return this;
                        };
                        // HELPER FUNCTIONS
                        // ================
                        var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                        function base64clean(str) {
                            // Node takes equal signs as end of the Base64 encoding
                            str = str.split('=')[0];
                            // Node strips out invalid characters like \n and \t from the string, base64-js does not
                            str = str.trim().replace(INVALID_BASE64_RE, '');
                            // Node converts strings with length < 2 to ''
                            if (str.length < 2) return '';
                            // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                            while(str.length % 4 !== 0)str = str + '=';
                            return str;
                        }
                        function toHex(n) {
                            if (n < 16) return '0' + n.toString(16);
                            return n.toString(16);
                        }
                        function utf8ToBytes(string, units) {
                            units = units || Infinity;
                            var codePoint;
                            var length = string.length;
                            var leadSurrogate = null;
                            var bytes = [];
                            for(var i = 0; i < length; ++i){
                                codePoint = string.charCodeAt(i);
                                // is surrogate component
                                if (codePoint > 0xD7FF && codePoint < 0xE000) {
                                    // last char was a lead
                                    if (!leadSurrogate) {
                                        // no lead yet
                                        if (codePoint > 0xDBFF) {
                                            // unexpected trail
                                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                            continue;
                                        } else if (i + 1 === length) {
                                            // unpaired lead
                                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                            continue;
                                        }
                                        // valid lead
                                        leadSurrogate = codePoint;
                                        continue;
                                    }
                                    // 2 leads in a row
                                    if (codePoint < 0xDC00) {
                                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                        leadSurrogate = codePoint;
                                        continue;
                                    }
                                    // valid surrogate pair
                                    codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                                } else if (leadSurrogate) // valid bmp char, but last char was a lead
                                {
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                }
                                leadSurrogate = null;
                                // encode utf8
                                if (codePoint < 0x80) {
                                    if ((units -= 1) < 0) break;
                                    bytes.push(codePoint);
                                } else if (codePoint < 0x800) {
                                    if ((units -= 2) < 0) break;
                                    bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                                } else if (codePoint < 0x10000) {
                                    if ((units -= 3) < 0) break;
                                    bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                                } else if (codePoint < 0x110000) {
                                    if ((units -= 4) < 0) break;
                                    bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                                } else throw new Error('Invalid code point');
                            }
                            return bytes;
                        }
                        function asciiToBytes(str) {
                            var byteArray = [];
                            for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                            byteArray.push(str.charCodeAt(i) & 0xFF);
                            return byteArray;
                        }
                        function utf16leToBytes(str, units) {
                            var c, hi, lo;
                            var byteArray = [];
                            for(var i = 0; i < str.length; ++i){
                                if ((units -= 2) < 0) break;
                                c = str.charCodeAt(i);
                                hi = c >> 8;
                                lo = c % 256;
                                byteArray.push(lo);
                                byteArray.push(hi);
                            }
                            return byteArray;
                        }
                        function base64ToBytes(str) {
                            return base64.toByteArray(base64clean(str));
                        }
                        function blitBuffer(src, dst, offset, length) {
                            for(var i = 0; i < length; ++i){
                                if (i + offset >= dst.length || i >= src.length) break;
                                dst[i + offset] = src[i];
                            }
                            return i;
                        }
                        // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                        // the `instanceof` check but they should be treated as of that type.
                        // See: https://github.com/feross/buffer/issues/166
                        function isInstance(obj, type) {
                            return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                        }
                        function numberIsNaN(obj) {
                            // For IE11 support
                            return obj !== obj // eslint-disable-line no-self-compare
                            ;
                        }
                    }).call(this);
                }).call(this, require1("buffer").Buffer);
            },
            {
                "base64-js": 34,
                "buffer": 35,
                "ieee754": 37
            }
        ],
        36: [
            function(require1, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                'use strict';
                var R = typeof Reflect === 'object' ? Reflect : null;
                var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
                    return Function.prototype.apply.call(target, receiver, args);
                };
                var ReflectOwnKeys;
                if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
                else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
                };
                else ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target);
                };
                function ProcessEmitWarning(warning) {
                    if (console && console.warn) console.warn(warning);
                }
                var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
                    return value !== value;
                };
                function EventEmitter() {
                    EventEmitter.init.call(this);
                }
                module1.exports = EventEmitter;
                module1.exports.once = once;
                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._eventsCount = 0;
                EventEmitter.prototype._maxListeners = undefined;
                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                var defaultMaxListeners = 10;
                function checkListener(listener) {
                    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
                }
                Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
                    enumerable: true,
                    get: function() {
                        return defaultMaxListeners;
                    },
                    set: function(arg) {
                        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
                        defaultMaxListeners = arg;
                    }
                });
                EventEmitter.init = function() {
                    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                    }
                    this._maxListeners = this._maxListeners || undefined;
                };
                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
                    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
                    this._maxListeners = n;
                    return this;
                };
                function _getMaxListeners(that) {
                    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
                    return that._maxListeners;
                }
                EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
                    return _getMaxListeners(this);
                };
                EventEmitter.prototype.emit = function emit(type) {
                    var args = [];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var doError = type === 'error';
                    var events = this._events;
                    if (events !== undefined) doError = doError && events.error === undefined;
                    else if (!doError) return false;
                    // If there is no 'error' event listener then throw.
                    if (doError) {
                        var er;
                        if (args.length > 0) er = args[0];
                        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
                        // up in Node's output if this results in an unhandled exception.
                        throw er; // Unhandled 'error' event
                        // At least give some kind of context to the user
                        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
                        err.context = er;
                        throw err; // Unhandled 'error' event
                    }
                    var handler = events[type];
                    if (handler === undefined) return false;
                    if (typeof handler === 'function') ReflectApply(handler, this, args);
                    else {
                        var len = handler.length;
                        var listeners = arrayClone(handler, len);
                        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
                    }
                    return true;
                };
                function _addListener(target, type, listener, prepend) {
                    var m;
                    var events;
                    var existing;
                    checkListener(listener);
                    events = target._events;
                    if (events === undefined) {
                        events = target._events = Object.create(null);
                        target._eventsCount = 0;
                    } else {
                        // To avoid recursion in the case that type === "newListener"! Before
                        // adding it to the listeners, first emit "newListener".
                        if (events.newListener !== undefined) {
                            target.emit('newListener', type, listener.listener ? listener.listener : listener);
                            // Re-assign `events` because a newListener handler could have caused the
                            // this._events to be assigned to a new object
                            events = target._events;
                        }
                        existing = events[type];
                    }
                    if (existing === undefined) {
                        // Optimize the case of one listener. Don't need the extra array object.
                        existing = events[type] = listener;
                        ++target._eventsCount;
                    } else {
                        if (typeof existing === 'function') // Adding the second element, need to change to array.
                        existing = events[type] = prepend ? [
                            listener,
                            existing
                        ] : [
                            existing,
                            listener
                        ];
                        else if (prepend) existing.unshift(listener);
                        else existing.push(listener);
                        // Check for listener leak
                        m = _getMaxListeners(target);
                        if (m > 0 && existing.length > m && !existing.warned) {
                            existing.warned = true;
                            // No error code for this since it is a Warning
                            // eslint-disable-next-line no-restricted-syntax
                            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                            w.name = 'MaxListenersExceededWarning';
                            w.emitter = target;
                            w.type = type;
                            w.count = existing.length;
                            ProcessEmitWarning(w);
                        }
                    }
                    return target;
                }
                EventEmitter.prototype.addListener = function addListener(type, listener) {
                    return _addListener(this, type, listener, false);
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.prependListener = function prependListener(type, listener) {
                    return _addListener(this, type, listener, true);
                };
                function onceWrapper() {
                    if (!this.fired) {
                        this.target.removeListener(this.type, this.wrapFn);
                        this.fired = true;
                        if (arguments.length === 0) return this.listener.call(this.target);
                        return this.listener.apply(this.target, arguments);
                    }
                }
                function _onceWrap(target, type, listener) {
                    var state = {
                        fired: false,
                        wrapFn: undefined,
                        target: target,
                        type: type,
                        listener: listener
                    };
                    var wrapped = onceWrapper.bind(state);
                    wrapped.listener = listener;
                    state.wrapFn = wrapped;
                    return wrapped;
                }
                EventEmitter.prototype.once = function once(type, listener) {
                    checkListener(listener);
                    this.on(type, _onceWrap(this, type, listener));
                    return this;
                };
                EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
                    checkListener(listener);
                    this.prependListener(type, _onceWrap(this, type, listener));
                    return this;
                };
                // Emits a 'removeListener' event if and only if the listener was removed.
                EventEmitter.prototype.removeListener = function removeListener(type, listener) {
                    var list, events, position, i, originalListener;
                    checkListener(listener);
                    events = this._events;
                    if (events === undefined) return this;
                    list = events[type];
                    if (list === undefined) return this;
                    if (list === listener || list.listener === listener) {
                        if (--this._eventsCount === 0) this._events = Object.create(null);
                        else {
                            delete events[type];
                            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
                        }
                    } else if (typeof list !== 'function') {
                        position = -1;
                        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                            originalListener = list[i].listener;
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (position === 0) list.shift();
                        else spliceOne(list, position);
                        if (list.length === 1) events[type] = list[0];
                        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
                    }
                    return this;
                };
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
                    var listeners, events, i;
                    events = this._events;
                    if (events === undefined) return this;
                    // not listening for removeListener, no need to emit
                    if (events.removeListener === undefined) {
                        if (arguments.length === 0) {
                            this._events = Object.create(null);
                            this._eventsCount = 0;
                        } else if (events[type] !== undefined) {
                            if (--this._eventsCount === 0) this._events = Object.create(null);
                            else delete events[type];
                        }
                        return this;
                    }
                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        var keys = Object.keys(events);
                        var key;
                        for(i = 0; i < keys.length; ++i){
                            key = keys[i];
                            if (key === 'removeListener') continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners('removeListener');
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                        return this;
                    }
                    listeners = events[type];
                    if (typeof listeners === 'function') this.removeListener(type, listeners);
                    else if (listeners !== undefined) // LIFO order
                    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
                    return this;
                };
                function _listeners(target, type, unwrap) {
                    var events = target._events;
                    if (events === undefined) return [];
                    var evlistener = events[type];
                    if (evlistener === undefined) return [];
                    if (typeof evlistener === 'function') return unwrap ? [
                        evlistener.listener || evlistener
                    ] : [
                        evlistener
                    ];
                    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
                }
                EventEmitter.prototype.listeners = function listeners(type) {
                    return _listeners(this, type, true);
                };
                EventEmitter.prototype.rawListeners = function rawListeners(type) {
                    return _listeners(this, type, false);
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
                    else return listenerCount.call(emitter, type);
                };
                EventEmitter.prototype.listenerCount = listenerCount;
                function listenerCount(type) {
                    var events = this._events;
                    if (events !== undefined) {
                        var evlistener = events[type];
                        if (typeof evlistener === 'function') return 1;
                        else if (evlistener !== undefined) return evlistener.length;
                    }
                    return 0;
                }
                EventEmitter.prototype.eventNames = function eventNames() {
                    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
                };
                function arrayClone(arr, n) {
                    var copy = new Array(n);
                    for(var i = 0; i < n; ++i)copy[i] = arr[i];
                    return copy;
                }
                function spliceOne(list, index) {
                    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
                    list.pop();
                }
                function unwrapListeners(arr) {
                    var ret = new Array(arr.length);
                    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
                    return ret;
                }
                function once(emitter, name) {
                    return new Promise(function(resolve, reject) {
                        function eventListener() {
                            if (errorListener !== undefined) emitter.removeListener('error', errorListener);
                            resolve([].slice.call(arguments));
                        }
                        var errorListener;
                        // Adding an error listener is not optional because
                        // if an error is thrown on an event emitter we cannot
                        // guarantee that the actual event we are waiting will
                        // be fired. The result could be a silent way to create
                        // memory or file descriptor leaks, which is something
                        // we should avoid.
                        if (name !== 'error') {
                            errorListener = function errorListener(err) {
                                emitter.removeListener(name, eventListener);
                                reject(err);
                            };
                            emitter.once('error', errorListener);
                        }
                        emitter.once(name, eventListener);
                    });
                }
            },
            {}
        ],
        37: [
            function(require1, module1, exports) {
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            },
            {}
        ],
        38: [
            function(require1, module1, exports) {
                if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
                module1.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                    }
                };
                else // old school shim for old browsers
                module1.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                };
            },
            {}
        ],
        39: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error('setTimeout has not been defined');
                }
                function defaultClearTimeout() {
                    throw new Error('clearTimeout has not been defined');
                }
                (function() {
                    try {
                        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = 'browser';
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ''; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error('process.binding is not supported');
                };
                process.cwd = function() {
                    return '/';
                };
                process.chdir = function(dir) {
                    throw new Error('process.chdir is not supported');
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        40: [
            function(require1, module1, exports) {
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require1('buffer');
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module1.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                SafeBuffer.prototype = Object.create(Buffer.prototype);
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === 'string') buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                    return buffer.SlowBuffer(size);
                };
            },
            {
                "buffer": 35
            }
        ],
        41: [
            function(require1, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module1.exports = Stream;
                var EE = require1('events').EventEmitter;
                var inherits = require1('inherits');
                inherits(Stream, EE);
                Stream.Readable = require1('readable-stream/lib/_stream_readable.js');
                Stream.Writable = require1('readable-stream/lib/_stream_writable.js');
                Stream.Duplex = require1('readable-stream/lib/_stream_duplex.js');
                Stream.Transform = require1('readable-stream/lib/_stream_transform.js');
                Stream.PassThrough = require1('readable-stream/lib/_stream_passthrough.js');
                Stream.finished = require1('readable-stream/lib/internal/streams/end-of-stream.js');
                Stream.pipeline = require1('readable-stream/lib/internal/streams/pipeline.js');
                // Backwards-compat with node 0.4.x
                Stream.Stream = Stream;
                // old-style streams.  Note that the pipe method (the only relevant
                // part of this class) is overridden in the Readable class.
                function Stream() {
                    EE.call(this);
                }
                Stream.prototype.pipe = function(dest, options) {
                    var source = this;
                    function ondata(chunk) {
                        if (dest.writable) {
                            if (false === dest.write(chunk) && source.pause) source.pause();
                        }
                    }
                    source.on('data', ondata);
                    function ondrain() {
                        if (source.readable && source.resume) source.resume();
                    }
                    dest.on('drain', ondrain);
                    // If the 'end' option is not supplied, dest.end() will be called when
                    // source gets the 'end' or 'close' events.  Only dest.end() once.
                    if (!dest._isStdio && (!options || options.end !== false)) {
                        source.on('end', onend);
                        source.on('close', onclose);
                    }
                    var didOnEnd = false;
                    function onend() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        dest.end();
                    }
                    function onclose() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        if (typeof dest.destroy === 'function') dest.destroy();
                    }
                    // don't leave dangling pipes when there are errors.
                    function onerror(er) {
                        cleanup();
                        if (EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
                    }
                    source.on('error', onerror);
                    dest.on('error', onerror);
                    // remove all the event listeners that were added.
                    function cleanup() {
                        source.removeListener('data', ondata);
                        dest.removeListener('drain', ondrain);
                        source.removeListener('end', onend);
                        source.removeListener('close', onclose);
                        source.removeListener('error', onerror);
                        dest.removeListener('error', onerror);
                        source.removeListener('end', cleanup);
                        source.removeListener('close', cleanup);
                        dest.removeListener('close', cleanup);
                    }
                    source.on('end', cleanup);
                    source.on('close', cleanup);
                    dest.on('close', cleanup);
                    dest.emit('pipe', source);
                    // Allow for unix-like usage: A.pipe(B).pipe(C)
                    return dest;
                };
            },
            {
                "events": 36,
                "inherits": 38,
                "readable-stream/lib/_stream_duplex.js": 43,
                "readable-stream/lib/_stream_passthrough.js": 44,
                "readable-stream/lib/_stream_readable.js": 45,
                "readable-stream/lib/_stream_transform.js": 46,
                "readable-stream/lib/_stream_writable.js": 47,
                "readable-stream/lib/internal/streams/end-of-stream.js": 51,
                "readable-stream/lib/internal/streams/pipeline.js": 53
            }
        ],
        42: [
            function(require1, module1, exports) {
                'use strict';
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    subClass.__proto__ = superClass;
                }
                var codes = {};
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === 'string') return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inheritsLoose(NodeError, _Base);
                        function NodeError(arg1, arg2, arg3) {
                            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
                        }
                        return NodeError;
                    }(Base);
                    NodeError.prototype.name = Base.name;
                    NodeError.prototype.code = code;
                    codes[code] = NodeError;
                } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== 'number') start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
                    return 'The value "' + value + '" is invalid for option "' + name + '"';
                }, TypeError);
                createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
                        determiner = 'must not be';
                        expected = expected.replace(/^not /, '');
                    } else determiner = 'must be';
                    var msg;
                    if (endsWith(name, ' argument')) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
                    else {
                        var type = includes(name, '.') ? 'property' : 'argument';
                        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
                    }
                    msg += ". Received type ".concat(typeof actual);
                    return msg;
                }, TypeError);
                createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
                createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
                    return 'The ' + name + ' method is not implemented';
                });
                createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
                createErrorType('ERR_STREAM_DESTROYED', function(name) {
                    return 'Cannot call ' + name + ' after a stream was destroyed';
                });
                createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
                createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
                createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
                createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
                createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
                    return 'Unknown encoding: ' + arg;
                }, TypeError);
                createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
                module1.exports.codes = codes;
            },
            {}
        ],
        43: [
            function(require1, module1, exports) {
                (function(process) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        // a duplex stream is just a stream that is both readable and writable.
                        // Since JS doesn't have multiple prototypal inheritance, this class
                        // prototypally inherits from Readable, and then parasitically from
                        // Writable.
                        'use strict';
                        /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
                            var keys = [];
                            for(var key in obj)keys.push(key);
                            return keys;
                        };
                        /*</replacement>*/ module1.exports = Duplex;
                        var Readable = require1('./_stream_readable');
                        var Writable = require1('./_stream_writable');
                        require1('inherits')(Duplex, Readable);
                        // Allow the keys array to be GC'ed.
                        var keys = objectKeys(Writable.prototype);
                        for(var v = 0; v < keys.length; v++){
                            var method = keys[v];
                            if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
                        }
                        function Duplex(options) {
                            if (!(this instanceof Duplex)) return new Duplex(options);
                            Readable.call(this, options);
                            Writable.call(this, options);
                            this.allowHalfOpen = true;
                            if (options) {
                                if (options.readable === false) this.readable = false;
                                if (options.writable === false) this.writable = false;
                                if (options.allowHalfOpen === false) {
                                    this.allowHalfOpen = false;
                                    this.once('end', onend);
                                }
                            }
                        }
                        Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.highWaterMark;
                            }
                        });
                        Object.defineProperty(Duplex.prototype, 'writableBuffer', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        });
                        Object.defineProperty(Duplex.prototype, 'writableLength', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.length;
                            }
                        }); // the no-half-open enforcer
                        function onend() {
                            // If the writable side ended, then we're ok.
                            if (this._writableState.ended) return; // no more data can be written.
                            // But allow more writes to happen in this tick.
                            process.nextTick(onEndNT, this);
                        }
                        function onEndNT(self1) {
                            self1.end();
                        }
                        Object.defineProperty(Duplex.prototype, 'destroyed', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._readableState === undefined || this._writableState === undefined) return false;
                                return this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (this._readableState === undefined || this._writableState === undefined) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._readableState.destroyed = value;
                                this._writableState.destroyed = value;
                            }
                        });
                    }).call(this);
                }).call(this, require1('_process'));
            },
            {
                "./_stream_readable": 45,
                "./_stream_writable": 47,
                "_process": 39,
                "inherits": 38
            }
        ],
        44: [
            function(require1, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a passthrough stream.
                // basically just the most minimal sort of Transform stream.
                // Every written chunk gets output as-is.
                'use strict';
                module1.exports = PassThrough;
                var Transform = require1('./_stream_transform');
                require1('inherits')(PassThrough, Transform);
                function PassThrough(options) {
                    if (!(this instanceof PassThrough)) return new PassThrough(options);
                    Transform.call(this, options);
                }
                PassThrough.prototype._transform = function(chunk, encoding, cb) {
                    cb(null, chunk);
                };
            },
            {
                "./_stream_transform": 46,
                "inherits": 38
            }
        ],
        45: [
            function(require1, module1, exports) {
                (function(process, global1) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        'use strict';
                        module1.exports = Readable;
                        /*<replacement>*/ var Duplex;
                        /*</replacement>*/ Readable.ReadableState = ReadableState;
                        /*<replacement>*/ var EE = require1('events').EventEmitter;
                        var EElistenerCount = function EElistenerCount(emitter, type) {
                            return emitter.listeners(type).length;
                        };
                        /*</replacement>*/ /*<replacement>*/ var Stream = require1('./internal/streams/stream');
                        /*</replacement>*/ var Buffer = require1('buffer').Buffer;
                        var OurUint8Array = global1.Uint8Array || function() {};
                        function _uint8ArrayToBuffer(chunk) {
                            return Buffer.from(chunk);
                        }
                        function _isUint8Array(obj) {
                            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                        }
                        /*<replacement>*/ var debugUtil = require1('util');
                        var debug;
                        if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
                        else debug = function debug() {};
                        /*</replacement>*/ var BufferList = require1('./internal/streams/buffer_list');
                        var destroyImpl = require1('./internal/streams/destroy');
                        var _require = require1('./internal/streams/state'), getHighWaterMark = _require.getHighWaterMark;
                        var _require$codes = require1('../errors').codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
                        var StringDecoder;
                        var createReadableStreamAsyncIterator;
                        var from;
                        require1('inherits')(Readable, Stream);
                        var errorOrDestroy = destroyImpl.errorOrDestroy;
                        var kProxyEvents = [
                            'error',
                            'close',
                            'destroy',
                            'pause',
                            'resume'
                        ];
                        function prependListener(emitter, event, fn) {
                            // Sadly this is not cacheable as some libraries bundle their own
                            // event emitter implementation with them.
                            if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
                            // userland ones.  NEVER DO THIS. This is here only because this code needs
                            // to continue to work with older versions of Node.js that do not include
                            // the prependListener() method. The goal is to eventually remove this hack.
                            if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
                            else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
                            else emitter._events[event] = [
                                fn,
                                emitter._events[event]
                            ];
                        }
                        function ReadableState(options, stream, isDuplex) {
                            Duplex = Duplex || require1('./_stream_duplex');
                            options = options || {}; // Duplex streams are both readable and writable, but share
                            // the same options object.
                            // However, some cases require setting options to different
                            // values for the readable and the writable sides of the duplex stream.
                            // These options can be provided separately as readableXXX and writableXXX.
                            if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
                            // make all the buffer merging and length checks go away
                            this.objectMode = !!options.objectMode;
                            if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
                            // Note: 0 is a valid value, means "don't call _read preemptively ever"
                            this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
                            // linked list can remove elements from the beginning faster than
                            // array.shift()
                            this.buffer = new BufferList();
                            this.length = 0;
                            this.pipes = null;
                            this.pipesCount = 0;
                            this.flowing = null;
                            this.ended = false;
                            this.endEmitted = false;
                            this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
                            // immediately, or on a later tick.  We set this to true at first, because
                            // any actions that shouldn't happen until "later" should generally also
                            // not happen before the first read call.
                            this.sync = true; // whenever we return null, then we set a flag to say
                            // that we're awaiting a 'readable' event emission.
                            this.needReadable = false;
                            this.emittedReadable = false;
                            this.readableListening = false;
                            this.resumeScheduled = false;
                            this.paused = true; // Should close be emitted on destroy. Defaults to true.
                            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
                            this.autoDestroy = !!options.autoDestroy; // has it been destroyed
                            this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
                            // encoding is 'binary' so we have to make this configurable.
                            // Everything else in the universe uses 'utf8', though.
                            this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s
                            this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
                            this.readingMore = false;
                            this.decoder = null;
                            this.encoding = null;
                            if (options.encoding) {
                                if (!StringDecoder) StringDecoder = require1('string_decoder/').StringDecoder;
                                this.decoder = new StringDecoder(options.encoding);
                                this.encoding = options.encoding;
                            }
                        }
                        function Readable(options) {
                            Duplex = Duplex || require1('./_stream_duplex');
                            if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
                            // the ReadableState constructor, at least with V8 6.5
                            var isDuplex = this instanceof Duplex;
                            this._readableState = new ReadableState(options, this, isDuplex); // legacy
                            this.readable = true;
                            if (options) {
                                if (typeof options.read === 'function') this._read = options.read;
                                if (typeof options.destroy === 'function') this._destroy = options.destroy;
                            }
                            Stream.call(this);
                        }
                        Object.defineProperty(Readable.prototype, 'destroyed', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._readableState === undefined) return false;
                                return this._readableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (!this._readableState) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._readableState.destroyed = value;
                            }
                        });
                        Readable.prototype.destroy = destroyImpl.destroy;
                        Readable.prototype._undestroy = destroyImpl.undestroy;
                        Readable.prototype._destroy = function(err, cb) {
                            cb(err);
                        }; // Manually shove something into the read() buffer.
                        // This returns true if the highWaterMark has not been hit yet,
                        // similar to how Writable.write() returns true if you should
                        // write() some more.
                        Readable.prototype.push = function(chunk, encoding) {
                            var state = this._readableState;
                            var skipChunkCheck;
                            if (!state.objectMode) {
                                if (typeof chunk === 'string') {
                                    encoding = encoding || state.defaultEncoding;
                                    if (encoding !== state.encoding) {
                                        chunk = Buffer.from(chunk, encoding);
                                        encoding = '';
                                    }
                                    skipChunkCheck = true;
                                }
                            } else skipChunkCheck = true;
                            return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
                        }; // Unshift should *always* be something directly out of read()
                        Readable.prototype.unshift = function(chunk) {
                            return readableAddChunk(this, chunk, null, true, false);
                        };
                        function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
                            debug('readableAddChunk', chunk);
                            var state = stream._readableState;
                            if (chunk === null) {
                                state.reading = false;
                                onEofChunk(stream, state);
                            } else {
                                var er;
                                if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                                if (er) errorOrDestroy(stream, er);
                                else if (state.objectMode || chunk && chunk.length > 0) {
                                    if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
                                    if (addToFront) {
                                        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                                        else addChunk(stream, state, chunk, true);
                                    } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                                    else if (state.destroyed) return false;
                                    else {
                                        state.reading = false;
                                        if (state.decoder && !encoding) {
                                            chunk = state.decoder.write(chunk);
                                            if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                                            else maybeReadMore(stream, state);
                                        } else addChunk(stream, state, chunk, false);
                                    }
                                } else if (!addToFront) {
                                    state.reading = false;
                                    maybeReadMore(stream, state);
                                }
                            } // We can push more data if we are below the highWaterMark.
                            // Also, if we have no data yet, we can stand some more bytes.
                            // This is to work around cases where hwm=0, such as the repl.
                            return !state.ended && (state.length < state.highWaterMark || state.length === 0);
                        }
                        function addChunk(stream, state, chunk, addToFront) {
                            if (state.flowing && state.length === 0 && !state.sync) {
                                state.awaitDrain = 0;
                                stream.emit('data', chunk);
                            } else {
                                // update the buffer info.
                                state.length += state.objectMode ? 1 : chunk.length;
                                if (addToFront) state.buffer.unshift(chunk);
                                else state.buffer.push(chunk);
                                if (state.needReadable) emitReadable(stream);
                            }
                            maybeReadMore(stream, state);
                        }
                        function chunkInvalid(state, chunk) {
                            var er;
                            if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
                                'string',
                                'Buffer',
                                'Uint8Array'
                            ], chunk);
                            return er;
                        }
                        Readable.prototype.isPaused = function() {
                            return this._readableState.flowing === false;
                        }; // backwards compatibility.
                        Readable.prototype.setEncoding = function(enc) {
                            if (!StringDecoder) StringDecoder = require1('string_decoder/').StringDecoder;
                            var decoder = new StringDecoder(enc);
                            this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
                            this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
                            var p = this._readableState.buffer.head;
                            var content = '';
                            while(p !== null){
                                content += decoder.write(p.data);
                                p = p.next;
                            }
                            this._readableState.buffer.clear();
                            if (content !== '') this._readableState.buffer.push(content);
                            this._readableState.length = content.length;
                            return this;
                        }; // Don't raise the hwm > 1GB
                        var MAX_HWM = 0x40000000;
                        function computeNewHighWaterMark(n) {
                            if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
                            n = MAX_HWM;
                            else {
                                // Get the next highest power of 2 to prevent increasing hwm excessively in
                                // tiny amounts
                                n--;
                                n |= n >>> 1;
                                n |= n >>> 2;
                                n |= n >>> 4;
                                n |= n >>> 8;
                                n |= n >>> 16;
                                n++;
                            }
                            return n;
                        } // This function is designed to be inlinable, so please take care when making
                        // changes to the function body.
                        function howMuchToRead(n, state) {
                            if (n <= 0 || state.length === 0 && state.ended) return 0;
                            if (state.objectMode) return 1;
                            if (n !== n) {
                                // Only flow one buffer at a time
                                if (state.flowing && state.length) return state.buffer.head.data.length;
                                else return state.length;
                            } // If we're asking for more than the current hwm, then raise the hwm.
                            if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
                            if (n <= state.length) return n; // Don't have enough
                            if (!state.ended) {
                                state.needReadable = true;
                                return 0;
                            }
                            return state.length;
                        } // you can override either this method, or the async _read(n) below.
                        Readable.prototype.read = function(n) {
                            debug('read', n);
                            n = parseInt(n, 10);
                            var state = this._readableState;
                            var nOrig = n;
                            if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
                            // already have a bunch of data in the buffer, then just trigger
                            // the 'readable' event and move on.
                            if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
                                debug('read: emitReadable', state.length, state.ended);
                                if (state.length === 0 && state.ended) endReadable(this);
                                else emitReadable(this);
                                return null;
                            }
                            n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
                            if (n === 0 && state.ended) {
                                if (state.length === 0) endReadable(this);
                                return null;
                            } // All the actual chunk generation logic needs to be
                            // *below* the call to _read.  The reason is that in certain
                            // synthetic stream cases, such as passthrough streams, _read
                            // may be a completely synchronous operation which may change
                            // the state of the read buffer, providing enough data when
                            // before there was *not* enough.
                            //
                            // So, the steps are:
                            // 1. Figure out what the state of things will be after we do
                            // a read from the buffer.
                            //
                            // 2. If that resulting state will trigger a _read, then call _read.
                            // Note that this may be asynchronous, or synchronous.  Yes, it is
                            // deeply ugly to write APIs this way, but that still doesn't mean
                            // that the Readable class should behave improperly, as streams are
                            // designed to be sync/async agnostic.
                            // Take note if the _read call is sync or async (ie, if the read call
                            // has returned yet), so that we know whether or not it's safe to emit
                            // 'readable' etc.
                            //
                            // 3. Actually pull the requested chunks out of the buffer and return.
                            // if we need a readable event, then we need to do some reading.
                            var doRead = state.needReadable;
                            debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some
                            if (state.length === 0 || state.length - n < state.highWaterMark) {
                                doRead = true;
                                debug('length less than watermark', doRead);
                            } // however, if we've ended, then there's no point, and if we're already
                            // reading, then it's unnecessary.
                            if (state.ended || state.reading) {
                                doRead = false;
                                debug('reading or ended', doRead);
                            } else if (doRead) {
                                debug('do read');
                                state.reading = true;
                                state.sync = true; // if the length is currently zero, then we *need* a readable event.
                                if (state.length === 0) state.needReadable = true; // call internal read method
                                this._read(state.highWaterMark);
                                state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
                                // and we need to re-evaluate how much data we can return to the user.
                                if (!state.reading) n = howMuchToRead(nOrig, state);
                            }
                            var ret;
                            if (n > 0) ret = fromList(n, state);
                            else ret = null;
                            if (ret === null) {
                                state.needReadable = state.length <= state.highWaterMark;
                                n = 0;
                            } else {
                                state.length -= n;
                                state.awaitDrain = 0;
                            }
                            if (state.length === 0) {
                                // If we have nothing in the buffer, then we want to know
                                // as soon as we *do* get something into the buffer.
                                if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
                                if (nOrig !== n && state.ended) endReadable(this);
                            }
                            if (ret !== null) this.emit('data', ret);
                            return ret;
                        };
                        function onEofChunk(stream, state) {
                            debug('onEofChunk');
                            if (state.ended) return;
                            if (state.decoder) {
                                var chunk = state.decoder.end();
                                if (chunk && chunk.length) {
                                    state.buffer.push(chunk);
                                    state.length += state.objectMode ? 1 : chunk.length;
                                }
                            }
                            state.ended = true;
                            if (state.sync) // if we are sync, wait until next tick to emit the data.
                            // Otherwise we risk emitting data in the flow()
                            // the readable code triggers during a read() call
                            emitReadable(stream);
                            else {
                                // emit 'readable' now to make sure it gets picked up.
                                state.needReadable = false;
                                if (!state.emittedReadable) {
                                    state.emittedReadable = true;
                                    emitReadable_(stream);
                                }
                            }
                        } // Don't emit readable right away in sync mode, because this can trigger
                        // another read() call => stack overflow.  This way, it might trigger
                        // a nextTick recursion warning, but that's not so bad.
                        function emitReadable(stream) {
                            var state = stream._readableState;
                            debug('emitReadable', state.needReadable, state.emittedReadable);
                            state.needReadable = false;
                            if (!state.emittedReadable) {
                                debug('emitReadable', state.flowing);
                                state.emittedReadable = true;
                                process.nextTick(emitReadable_, stream);
                            }
                        }
                        function emitReadable_(stream) {
                            var state = stream._readableState;
                            debug('emitReadable_', state.destroyed, state.length, state.ended);
                            if (!state.destroyed && (state.length || state.ended)) {
                                stream.emit('readable');
                                state.emittedReadable = false;
                            } // The stream needs another readable event if
                            // 1. It is not flowing, as the flow mechanism will take
                            //    care of it.
                            // 2. It is not ended.
                            // 3. It is below the highWaterMark, so we can schedule
                            //    another readable later.
                            state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
                            flow(stream);
                        } // at this point, the user has presumably seen the 'readable' event,
                        // and called read() to consume some data.  that may have triggered
                        // in turn another _read(n) call, in which case reading = true if
                        // it's in progress.
                        // However, if we're not ended, or reading, and the length < hwm,
                        // then go ahead and try to read some more preemptively.
                        function maybeReadMore(stream, state) {
                            if (!state.readingMore) {
                                state.readingMore = true;
                                process.nextTick(maybeReadMore_, stream, state);
                            }
                        }
                        function maybeReadMore_(stream, state) {
                            // Attempt to read more data if we should.
                            //
                            // The conditions for reading more data are (one of):
                            // - Not enough data buffered (state.length < state.highWaterMark). The loop
                            //   is responsible for filling the buffer with enough data if such data
                            //   is available. If highWaterMark is 0 and we are not in the flowing mode
                            //   we should _not_ attempt to buffer any extra data. We'll get more data
                            //   when the stream consumer calls read() instead.
                            // - No data in the buffer, and the stream is in flowing mode. In this mode
                            //   the loop below is responsible for ensuring read() is called. Failing to
                            //   call read here would abort the flow and there's no other mechanism for
                            //   continuing the flow if the stream consumer has just subscribed to the
                            //   'data' event.
                            //
                            // In addition to the above conditions to keep reading data, the following
                            // conditions prevent the data from being read:
                            // - The stream has ended (state.ended).
                            // - There is already a pending 'read' operation (state.reading). This is a
                            //   case where the the stream has called the implementation defined _read()
                            //   method, but they are processing the call asynchronously and have _not_
                            //   called push() with new data. In this case we skip performing more
                            //   read()s. The execution ends in this method again after the _read() ends
                            //   up calling push() with more data.
                            while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
                                var len = state.length;
                                debug('maybeReadMore read 0');
                                stream.read(0);
                                if (len === state.length) break;
                            }
                            state.readingMore = false;
                        } // abstract method.  to be overridden in specific implementation classes.
                        // call cb(er, data) where data is <= n in length.
                        // for virtual (non-string, non-buffer) streams, "length" is somewhat
                        // arbitrary, and perhaps not very meaningful.
                        Readable.prototype._read = function(n) {
                            errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
                        };
                        Readable.prototype.pipe = function(dest, pipeOpts) {
                            var src = this;
                            var state = this._readableState;
                            switch(state.pipesCount){
                                case 0:
                                    state.pipes = dest;
                                    break;
                                case 1:
                                    state.pipes = [
                                        state.pipes,
                                        dest
                                    ];
                                    break;
                                default:
                                    state.pipes.push(dest);
                                    break;
                            }
                            state.pipesCount += 1;
                            debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
                            var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
                            var endFn = doEnd ? onend : unpipe;
                            if (state.endEmitted) process.nextTick(endFn);
                            else src.once('end', endFn);
                            dest.on('unpipe', onunpipe);
                            function onunpipe(readable, unpipeInfo) {
                                debug('onunpipe');
                                if (readable === src) {
                                    if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                                        unpipeInfo.hasUnpiped = true;
                                        cleanup();
                                    }
                                }
                            }
                            function onend() {
                                debug('onend');
                                dest.end();
                            } // when the dest drains, it reduces the awaitDrain counter
                            // on the source.  This would be more elegant with a .once()
                            // handler in flow(), but adding and removing repeatedly is
                            // too slow.
                            var ondrain = pipeOnDrain(src);
                            dest.on('drain', ondrain);
                            var cleanedUp = false;
                            function cleanup() {
                                debug('cleanup'); // cleanup event handlers once the pipe is broken
                                dest.removeListener('close', onclose);
                                dest.removeListener('finish', onfinish);
                                dest.removeListener('drain', ondrain);
                                dest.removeListener('error', onerror);
                                dest.removeListener('unpipe', onunpipe);
                                src.removeListener('end', onend);
                                src.removeListener('end', unpipe);
                                src.removeListener('data', ondata);
                                cleanedUp = true; // if the reader is waiting for a drain event from this
                                // specific writer, then it would cause it to never start
                                // flowing again.
                                // So, if this is awaiting a drain, then we just call it now.
                                // If we don't know, then assume that we are waiting for one.
                                if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
                            }
                            src.on('data', ondata);
                            function ondata(chunk) {
                                debug('ondata');
                                var ret = dest.write(chunk);
                                debug('dest.write', ret);
                                if (ret === false) {
                                    // If the user unpiped during `dest.write()`, it is possible
                                    // to get stuck in a permanently paused state if that write
                                    // also returned false.
                                    // => Check whether `dest` is still a piping destination.
                                    if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                                        debug('false write response, pause', state.awaitDrain);
                                        state.awaitDrain++;
                                    }
                                    src.pause();
                                }
                            } // if the dest has an error, then stop piping into it.
                            // however, don't suppress the throwing behavior for this.
                            function onerror(er) {
                                debug('onerror', er);
                                unpipe();
                                dest.removeListener('error', onerror);
                                if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
                            } // Make sure our error handler is attached before userland ones.
                            prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.
                            function onclose() {
                                dest.removeListener('finish', onfinish);
                                unpipe();
                            }
                            dest.once('close', onclose);
                            function onfinish() {
                                debug('onfinish');
                                dest.removeListener('close', onclose);
                                unpipe();
                            }
                            dest.once('finish', onfinish);
                            function unpipe() {
                                debug('unpipe');
                                src.unpipe(dest);
                            } // tell the dest that it's being piped to
                            dest.emit('pipe', src); // start the flow if it hasn't been started already.
                            if (!state.flowing) {
                                debug('pipe resume');
                                src.resume();
                            }
                            return dest;
                        };
                        function pipeOnDrain(src) {
                            return function pipeOnDrainFunctionResult() {
                                var state = src._readableState;
                                debug('pipeOnDrain', state.awaitDrain);
                                if (state.awaitDrain) state.awaitDrain--;
                                if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
                                    state.flowing = true;
                                    flow(src);
                                }
                            };
                        }
                        Readable.prototype.unpipe = function(dest) {
                            var state = this._readableState;
                            var unpipeInfo = {
                                hasUnpiped: false
                            }; // if we're not piping anywhere, then do nothing.
                            if (state.pipesCount === 0) return this; // just one destination.  most common case.
                            if (state.pipesCount === 1) {
                                // passed in one, but it's not the right one.
                                if (dest && dest !== state.pipes) return this;
                                if (!dest) dest = state.pipes; // got a match.
                                state.pipes = null;
                                state.pipesCount = 0;
                                state.flowing = false;
                                if (dest) dest.emit('unpipe', this, unpipeInfo);
                                return this;
                            } // slow case. multiple pipe destinations.
                            if (!dest) {
                                // remove all.
                                var dests = state.pipes;
                                var len = state.pipesCount;
                                state.pipes = null;
                                state.pipesCount = 0;
                                state.flowing = false;
                                for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
                                    hasUnpiped: false
                                });
                                return this;
                            } // try to find the right one.
                            var index = indexOf(state.pipes, dest);
                            if (index === -1) return this;
                            state.pipes.splice(index, 1);
                            state.pipesCount -= 1;
                            if (state.pipesCount === 1) state.pipes = state.pipes[0];
                            dest.emit('unpipe', this, unpipeInfo);
                            return this;
                        }; // set up data events if they are asked for
                        // Ensure readable listeners eventually get something
                        Readable.prototype.on = function(ev, fn) {
                            var res = Stream.prototype.on.call(this, ev, fn);
                            var state = this._readableState;
                            if (ev === 'data') {
                                // update readableListening so that resume() may be a no-op
                                // a few lines down. This is needed to support once('readable').
                                state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused
                                if (state.flowing !== false) this.resume();
                            } else if (ev === 'readable') {
                                if (!state.endEmitted && !state.readableListening) {
                                    state.readableListening = state.needReadable = true;
                                    state.flowing = false;
                                    state.emittedReadable = false;
                                    debug('on readable', state.length, state.reading);
                                    if (state.length) emitReadable(this);
                                    else if (!state.reading) process.nextTick(nReadingNextTick, this);
                                }
                            }
                            return res;
                        };
                        Readable.prototype.addListener = Readable.prototype.on;
                        Readable.prototype.removeListener = function(ev, fn) {
                            var res = Stream.prototype.removeListener.call(this, ev, fn);
                            if (ev === 'readable') // We need to check if there is someone still listening to
                            // readable and reset the state. However this needs to happen
                            // after readable has been emitted but before I/O (nextTick) to
                            // support once('readable', fn) cycles. This means that calling
                            // resume within the same tick will have no
                            // effect.
                            process.nextTick(updateReadableListening, this);
                            return res;
                        };
                        Readable.prototype.removeAllListeners = function(ev) {
                            var res = Stream.prototype.removeAllListeners.apply(this, arguments);
                            if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
                            // readable and reset the state. However this needs to happen
                            // after readable has been emitted but before I/O (nextTick) to
                            // support once('readable', fn) cycles. This means that calling
                            // resume within the same tick will have no
                            // effect.
                            process.nextTick(updateReadableListening, this);
                            return res;
                        };
                        function updateReadableListening(self1) {
                            var state = self1._readableState;
                            state.readableListening = self1.listenerCount('readable') > 0;
                            if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
                            // the upcoming resume will not flow.
                            state.flowing = true; // crude way to check if we should resume
                            else if (self1.listenerCount('data') > 0) self1.resume();
                        }
                        function nReadingNextTick(self1) {
                            debug('readable nexttick read 0');
                            self1.read(0);
                        } // pause() and resume() are remnants of the legacy readable stream API
                        // If the user uses them, then switch into old mode.
                        Readable.prototype.resume = function() {
                            var state = this._readableState;
                            if (!state.flowing) {
                                debug('resume'); // we flow only if there is no one listening
                                // for readable, but we still have to call
                                // resume()
                                state.flowing = !state.readableListening;
                                resume(this, state);
                            }
                            state.paused = false;
                            return this;
                        };
                        function resume(stream, state) {
                            if (!state.resumeScheduled) {
                                state.resumeScheduled = true;
                                process.nextTick(resume_, stream, state);
                            }
                        }
                        function resume_(stream, state) {
                            debug('resume', state.reading);
                            if (!state.reading) stream.read(0);
                            state.resumeScheduled = false;
                            stream.emit('resume');
                            flow(stream);
                            if (state.flowing && !state.reading) stream.read(0);
                        }
                        Readable.prototype.pause = function() {
                            debug('call pause flowing=%j', this._readableState.flowing);
                            if (this._readableState.flowing !== false) {
                                debug('pause');
                                this._readableState.flowing = false;
                                this.emit('pause');
                            }
                            this._readableState.paused = true;
                            return this;
                        };
                        function flow(stream) {
                            var state = stream._readableState;
                            debug('flow', state.flowing);
                            while(state.flowing && stream.read() !== null);
                        } // wrap an old-style stream as the async data source.
                        // This is *not* part of the readable stream interface.
                        // It is an ugly unfortunate mess of history.
                        Readable.prototype.wrap = function(stream) {
                            var _this = this;
                            var state = this._readableState;
                            var paused = false;
                            stream.on('end', function() {
                                debug('wrapped end');
                                if (state.decoder && !state.ended) {
                                    var chunk = state.decoder.end();
                                    if (chunk && chunk.length) _this.push(chunk);
                                }
                                _this.push(null);
                            });
                            stream.on('data', function(chunk) {
                                debug('wrapped data');
                                if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
                                if (state.objectMode && (chunk === null || chunk === undefined)) return;
                                else if (!state.objectMode && (!chunk || !chunk.length)) return;
                                var ret = _this.push(chunk);
                                if (!ret) {
                                    paused = true;
                                    stream.pause();
                                }
                            }); // proxy all the other methods.
                            // important when wrapping filters and duplexes.
                            for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
                                return function methodWrapReturnFunction() {
                                    return stream[method].apply(stream, arguments);
                                };
                            }(i);
                             // proxy certain important events.
                            for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
                             // when we try to consume some more bytes, simply unpause the
                            // underlying stream.
                            this._read = function(n) {
                                debug('wrapped _read', n);
                                if (paused) {
                                    paused = false;
                                    stream.resume();
                                }
                            };
                            return this;
                        };
                        if (typeof Symbol === 'function') Readable.prototype[Symbol.asyncIterator] = function() {
                            if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require1('./internal/streams/async_iterator');
                            return createReadableStreamAsyncIterator(this);
                        };
                        Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.highWaterMark;
                            }
                        });
                        Object.defineProperty(Readable.prototype, 'readableBuffer', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState && this._readableState.buffer;
                            }
                        });
                        Object.defineProperty(Readable.prototype, 'readableFlowing', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.flowing;
                            },
                            set: function set(state) {
                                if (this._readableState) this._readableState.flowing = state;
                            }
                        }); // exposed for testing purposes only.
                        Readable._fromList = fromList;
                        Object.defineProperty(Readable.prototype, 'readableLength', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.length;
                            }
                        }); // Pluck off n bytes from an array of buffers.
                        // Length is the combined lengths of all the buffers in the list.
                        // This function is designed to be inlinable, so please take care when making
                        // changes to the function body.
                        function fromList(n, state) {
                            // nothing buffered
                            if (state.length === 0) return null;
                            var ret;
                            if (state.objectMode) ret = state.buffer.shift();
                            else if (!n || n >= state.length) {
                                // read it all, truncate the list
                                if (state.decoder) ret = state.buffer.join('');
                                else if (state.buffer.length === 1) ret = state.buffer.first();
                                else ret = state.buffer.concat(state.length);
                                state.buffer.clear();
                            } else // read part of list
                            ret = state.buffer.consume(n, state.decoder);
                            return ret;
                        }
                        function endReadable(stream) {
                            var state = stream._readableState;
                            debug('endReadable', state.endEmitted);
                            if (!state.endEmitted) {
                                state.ended = true;
                                process.nextTick(endReadableNT, state, stream);
                            }
                        }
                        function endReadableNT(state, stream) {
                            debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.
                            if (!state.endEmitted && state.length === 0) {
                                state.endEmitted = true;
                                stream.readable = false;
                                stream.emit('end');
                                if (state.autoDestroy) {
                                    // In case of duplex streams we need a way to detect
                                    // if the writable side is ready for autoDestroy as well
                                    var wState = stream._writableState;
                                    if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
                                }
                            }
                        }
                        if (typeof Symbol === 'function') Readable.from = function(iterable, opts) {
                            if (from === undefined) from = require1('./internal/streams/from');
                            return from(Readable, iterable, opts);
                        };
                        function indexOf(xs, x) {
                            for(var i = 0, l = xs.length; i < l; i++){
                                if (xs[i] === x) return i;
                            }
                            return -1;
                        }
                    }).call(this);
                }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "./internal/streams/async_iterator": 48,
                "./internal/streams/buffer_list": 49,
                "./internal/streams/destroy": 50,
                "./internal/streams/from": 52,
                "./internal/streams/state": 54,
                "./internal/streams/stream": 55,
                "_process": 39,
                "buffer": 35,
                "events": 36,
                "inherits": 38,
                "string_decoder/": 56,
                "util": 33
            }
        ],
        46: [
            function(require1, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a transform stream is a readable/writable stream where you do
                // something with the data.  Sometimes it's called a "filter",
                // but that's not a great name for it, since that implies a thing where
                // some bits pass through, and others are simply ignored.  (That would
                // be a valid example of a transform, of course.)
                //
                // While the output is causally related to the input, it's not a
                // necessarily symmetric or synchronous transformation.  For example,
                // a zlib stream might take multiple plain-text writes(), and then
                // emit a single compressed chunk some time in the future.
                //
                // Here's how this works:
                //
                // The Transform stream has all the aspects of the readable and writable
                // stream classes.  When you write(chunk), that calls _write(chunk,cb)
                // internally, and returns false if there's a lot of pending writes
                // buffered up.  When you call read(), that calls _read(n) until
                // there's enough pending readable data buffered up.
                //
                // In a transform stream, the written data is placed in a buffer.  When
                // _read(n) is called, it transforms the queued up data, calling the
                // buffered _write cb's as it consumes chunks.  If consuming a single
                // written chunk would result in multiple output chunks, then the first
                // outputted bit calls the readcb, and subsequent chunks just go into
                // the read buffer, and will cause it to emit 'readable' if necessary.
                //
                // This way, back-pressure is actually determined by the reading side,
                // since _read has to be called to start processing a new chunk.  However,
                // a pathological inflate type of transform can cause excessive buffering
                // here.  For example, imagine a stream where every byte of input is
                // interpreted as an integer from 0-255, and then results in that many
                // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
                // 1kb of data being output.  In this case, you could write a very small
                // amount of input, and end up with a very large amount of output.  In
                // such a pathological inflating mechanism, there'd be no way to tell
                // the system to stop doing the transform.  A single 4MB write could
                // cause the system to run out of memory.
                //
                // However, even in such a pathological case, only a single written chunk
                // would be consumed, and then the rest would wait (un-transformed) until
                // the results of the previous transformed chunk were consumed.
                'use strict';
                module1.exports = Transform;
                var _require$codes = require1('../errors').codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
                var Duplex = require1('./_stream_duplex');
                require1('inherits')(Transform, Duplex);
                function afterTransform(er, data) {
                    var ts = this._transformState;
                    ts.transforming = false;
                    var cb = ts.writecb;
                    if (cb === null) return this.emit('error', new ERR_MULTIPLE_CALLBACK());
                    ts.writechunk = null;
                    ts.writecb = null;
                    if (data != null) this.push(data);
                    cb(er);
                    var rs = this._readableState;
                    rs.reading = false;
                    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                }
                function Transform(options) {
                    if (!(this instanceof Transform)) return new Transform(options);
                    Duplex.call(this, options);
                    this._transformState = {
                        afterTransform: afterTransform.bind(this),
                        needTransform: false,
                        transforming: false,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }; // start out asking for a readable event once data is transformed.
                    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
                    // that Readable wants before the first _read call, so unset the
                    // sync guard flag.
                    this._readableState.sync = false;
                    if (options) {
                        if (typeof options.transform === 'function') this._transform = options.transform;
                        if (typeof options.flush === 'function') this._flush = options.flush;
                    } // When the writable side finishes, then flush out anything remaining.
                    this.on('prefinish', prefinish);
                }
                function prefinish() {
                    var _this = this;
                    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
                        done(_this, er, data);
                    });
                    else done(this, null, null);
                }
                Transform.prototype.push = function(chunk, encoding) {
                    this._transformState.needTransform = false;
                    return Duplex.prototype.push.call(this, chunk, encoding);
                }; // This is the part where you do stuff!
                // override this function in implementation classes.
                // 'chunk' is an input chunk.
                //
                // Call `push(newChunk)` to pass along transformed output
                // to the readable side.  You may call 'push' zero or more times.
                //
                // Call `cb(err)` when you are done with this chunk.  If you pass
                // an error, then that'll put the hurt on the whole operation.  If you
                // never call cb(), then you'll never get another chunk.
                Transform.prototype._transform = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
                };
                Transform.prototype._write = function(chunk, encoding, cb) {
                    var ts = this._transformState;
                    ts.writecb = cb;
                    ts.writechunk = chunk;
                    ts.writeencoding = encoding;
                    if (!ts.transforming) {
                        var rs = this._readableState;
                        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                    }
                }; // Doesn't matter what the args are here.
                // _transform does all the work.
                // That we got here means that the readable side wants more data.
                Transform.prototype._read = function(n) {
                    var ts = this._transformState;
                    if (ts.writechunk !== null && !ts.transforming) {
                        ts.transforming = true;
                        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
                    } else // mark that we need a transform, so that any data that comes in
                    // will get processed, now that we've asked for it.
                    ts.needTransform = true;
                };
                Transform.prototype._destroy = function(err, cb) {
                    Duplex.prototype._destroy.call(this, err, function(err2) {
                        cb(err2);
                    });
                };
                function done(stream, er, data) {
                    if (er) return stream.emit('error', er);
                    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
                    // if there's nothing in the write buffer, then that means
                    // that nothing more will ever be provided
                    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
                    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
                    return stream.push(null);
                }
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "inherits": 38
            }
        ],
        47: [
            function(require1, module1, exports) {
                (function(process, global1) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        // A bit simpler than readable streams.
                        // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                        // the drain event emission and buffering.
                        'use strict';
                        module1.exports = Writable;
                        /* <replacement> */ function WriteReq(chunk, encoding, cb) {
                            this.chunk = chunk;
                            this.encoding = encoding;
                            this.callback = cb;
                            this.next = null;
                        } // It seems a linked list but it is not
                        // there will be only 2 of these for each stream
                        function CorkedRequest(state) {
                            var _this = this;
                            this.next = null;
                            this.entry = null;
                            this.finish = function() {
                                onCorkedFinish(_this, state);
                            };
                        }
                        /* </replacement> */ /*<replacement>*/ var Duplex;
                        /*</replacement>*/ Writable.WritableState = WritableState;
                        /*<replacement>*/ var internalUtil = {
                            deprecate: require1('util-deprecate')
                        };
                        /*</replacement>*/ /*<replacement>*/ var Stream = require1('./internal/streams/stream');
                        /*</replacement>*/ var Buffer = require1('buffer').Buffer;
                        var OurUint8Array = global1.Uint8Array || function() {};
                        function _uint8ArrayToBuffer(chunk) {
                            return Buffer.from(chunk);
                        }
                        function _isUint8Array(obj) {
                            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                        }
                        var destroyImpl = require1('./internal/streams/destroy');
                        var _require = require1('./internal/streams/state'), getHighWaterMark = _require.getHighWaterMark;
                        var _require$codes = require1('../errors').codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
                        var errorOrDestroy = destroyImpl.errorOrDestroy;
                        require1('inherits')(Writable, Stream);
                        function nop() {}
                        function WritableState(options, stream, isDuplex) {
                            Duplex = Duplex || require1('./_stream_duplex');
                            options = options || {}; // Duplex streams are both readable and writable, but share
                            // the same options object.
                            // However, some cases require setting options to different
                            // values for the readable and the writable sides of the duplex stream,
                            // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
                            if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
                            // contains buffers or objects.
                            this.objectMode = !!options.objectMode;
                            if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
                            // Note: 0 is a valid value, means that we always return false if
                            // the entire buffer is not flushed immediately on write()
                            this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called
                            this.finalCalled = false; // drain event flag.
                            this.needDrain = false; // at the start of calling end()
                            this.ending = false; // when end() has been called, and returned
                            this.ended = false; // when 'finish' is emitted
                            this.finished = false; // has it been destroyed
                            this.destroyed = false; // should we decode strings into buffers before passing to _write?
                            // this is here so that some node-core streams can optimize string
                            // handling at a lower level.
                            var noDecode = options.decodeStrings === false;
                            this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
                            // encoding is 'binary' so we have to make this configurable.
                            // Everything else in the universe uses 'utf8', though.
                            this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
                            // of how much we're waiting to get pushed to some underlying
                            // socket or file.
                            this.length = 0; // a flag to see when we're in the middle of a write.
                            this.writing = false; // when true all writes will be buffered until .uncork() call
                            this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
                            // or on a later tick.  We set this to true at first, because any
                            // actions that shouldn't happen until "later" should generally also
                            // not happen before the first write call.
                            this.sync = true; // a flag to know if we're processing previously buffered items, which
                            // may call the _write() callback in the same tick, so that we don't
                            // end up in an overlapped onwrite situation.
                            this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
                            this.onwrite = function(er) {
                                onwrite(stream, er);
                            }; // the callback that the user supplies to write(chunk,encoding,cb)
                            this.writecb = null; // the amount that is being written when _write is called.
                            this.writelen = 0;
                            this.bufferedRequest = null;
                            this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
                            // this must be 0 before 'finish' can be emitted
                            this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
                            // This is relevant for synchronous Transform streams
                            this.prefinished = false; // True if the error was already emitted and should not be thrown again
                            this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
                            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
                            this.autoDestroy = !!options.autoDestroy; // count buffered requests
                            this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
                            // one allocated and free to use, and we maintain at most two
                            this.corkedRequestsFree = new CorkedRequest(this);
                        }
                        WritableState.prototype.getBuffer = function getBuffer() {
                            var current = this.bufferedRequest;
                            var out = [];
                            while(current){
                                out.push(current);
                                current = current.next;
                            }
                            return out;
                        };
                        (function() {
                            try {
                                Object.defineProperty(WritableState.prototype, 'buffer', {
                                    get: internalUtil.deprecate(function writableStateBufferGetter() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
                                });
                            } catch (_) {}
                        })(); // Test _writableState for inheritance to account for Duplex streams,
                        // whose prototype chain only points to Readable.
                        var realHasInstance;
                        if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
                            realHasInstance = Function.prototype[Symbol.hasInstance];
                            Object.defineProperty(Writable, Symbol.hasInstance, {
                                value: function value(object) {
                                    if (realHasInstance.call(this, object)) return true;
                                    if (this !== Writable) return false;
                                    return object && object._writableState instanceof WritableState;
                                }
                            });
                        } else realHasInstance = function realHasInstance(object) {
                            return object instanceof this;
                        };
                        function Writable(options) {
                            Duplex = Duplex || require1('./_stream_duplex'); // Writable ctor is applied to Duplexes, too.
                            // `realHasInstance` is necessary because using plain `instanceof`
                            // would return false, as no `_writableState` property is attached.
                            // Trying to use the custom `instanceof` for Writable here will also break the
                            // Node.js LazyTransform implementation, which has a non-trivial getter for
                            // `_writableState` that would lead to infinite recursion.
                            // Checking for a Stream.Duplex instance is faster here instead of inside
                            // the WritableState constructor, at least with V8 6.5
                            var isDuplex = this instanceof Duplex;
                            if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
                            this._writableState = new WritableState(options, this, isDuplex); // legacy.
                            this.writable = true;
                            if (options) {
                                if (typeof options.write === 'function') this._write = options.write;
                                if (typeof options.writev === 'function') this._writev = options.writev;
                                if (typeof options.destroy === 'function') this._destroy = options.destroy;
                                if (typeof options.final === 'function') this._final = options.final;
                            }
                            Stream.call(this);
                        } // Otherwise people can pipe Writable streams, which is just wrong.
                        Writable.prototype.pipe = function() {
                            errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
                        };
                        function writeAfterEnd(stream, cb) {
                            var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
                            errorOrDestroy(stream, er);
                            process.nextTick(cb, er);
                        } // Checks that a user-supplied chunk is valid, especially for the particular
                        // mode the stream is in. Currently this means that `null` is never accepted
                        // and undefined/non-string values are only allowed in object mode.
                        function validChunk(stream, state, chunk, cb) {
                            var er;
                            if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
                            else if (typeof chunk !== 'string' && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
                                'string',
                                'Buffer'
                            ], chunk);
                            if (er) {
                                errorOrDestroy(stream, er);
                                process.nextTick(cb, er);
                                return false;
                            }
                            return true;
                        }
                        Writable.prototype.write = function(chunk, encoding, cb) {
                            var state = this._writableState;
                            var ret = false;
                            var isBuf = !state.objectMode && _isUint8Array(chunk);
                            if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
                            if (typeof encoding === 'function') {
                                cb = encoding;
                                encoding = null;
                            }
                            if (isBuf) encoding = 'buffer';
                            else if (!encoding) encoding = state.defaultEncoding;
                            if (typeof cb !== 'function') cb = nop;
                            if (state.ending) writeAfterEnd(this, cb);
                            else if (isBuf || validChunk(this, state, chunk, cb)) {
                                state.pendingcb++;
                                ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                            }
                            return ret;
                        };
                        Writable.prototype.cork = function() {
                            this._writableState.corked++;
                        };
                        Writable.prototype.uncork = function() {
                            var state = this._writableState;
                            if (state.corked) {
                                state.corked--;
                                if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
                            }
                        };
                        Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
                            // node::ParseEncoding() requires lower case.
                            if (typeof encoding === 'string') encoding = encoding.toLowerCase();
                            if (!([
                                'hex',
                                'utf8',
                                'utf-8',
                                'ascii',
                                'binary',
                                'base64',
                                'ucs2',
                                'ucs-2',
                                'utf16le',
                                'utf-16le',
                                'raw'
                            ].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
                            this._writableState.defaultEncoding = encoding;
                            return this;
                        };
                        Object.defineProperty(Writable.prototype, 'writableBuffer', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        });
                        function decodeChunk(state, chunk, encoding) {
                            if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
                            return chunk;
                        }
                        Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.highWaterMark;
                            }
                        }); // if we're already writing something, then just put this
                        // in the queue, and wait our turn.  Otherwise, call _write
                        // If we return false, then we need a drain event, so set that flag.
                        function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
                            if (!isBuf) {
                                var newChunk = decodeChunk(state, chunk, encoding);
                                if (chunk !== newChunk) {
                                    isBuf = true;
                                    encoding = 'buffer';
                                    chunk = newChunk;
                                }
                            }
                            var len = state.objectMode ? 1 : chunk.length;
                            state.length += len;
                            var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
                            if (!ret) state.needDrain = true;
                            if (state.writing || state.corked) {
                                var last = state.lastBufferedRequest;
                                state.lastBufferedRequest = {
                                    chunk: chunk,
                                    encoding: encoding,
                                    isBuf: isBuf,
                                    callback: cb,
                                    next: null
                                };
                                if (last) last.next = state.lastBufferedRequest;
                                else state.bufferedRequest = state.lastBufferedRequest;
                                state.bufferedRequestCount += 1;
                            } else doWrite(stream, state, false, len, chunk, encoding, cb);
                            return ret;
                        }
                        function doWrite(stream, state, writev, len, chunk, encoding, cb) {
                            state.writelen = len;
                            state.writecb = cb;
                            state.writing = true;
                            state.sync = true;
                            if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));
                            else if (writev) stream._writev(chunk, state.onwrite);
                            else stream._write(chunk, encoding, state.onwrite);
                            state.sync = false;
                        }
                        function onwriteError(stream, state, sync, er, cb) {
                            --state.pendingcb;
                            if (sync) {
                                // defer the callback if we are being called synchronously
                                // to avoid piling up things on the stack
                                process.nextTick(cb, er); // this can emit finish, and it will always happen
                                // after error
                                process.nextTick(finishMaybe, stream, state);
                                stream._writableState.errorEmitted = true;
                                errorOrDestroy(stream, er);
                            } else {
                                // the caller expect this to happen before if
                                // it is async
                                cb(er);
                                stream._writableState.errorEmitted = true;
                                errorOrDestroy(stream, er); // this can emit finish, but finish must
                                // always follow error
                                finishMaybe(stream, state);
                            }
                        }
                        function onwriteStateUpdate(state) {
                            state.writing = false;
                            state.writecb = null;
                            state.length -= state.writelen;
                            state.writelen = 0;
                        }
                        function onwrite(stream, er) {
                            var state = stream._writableState;
                            var sync = state.sync;
                            var cb = state.writecb;
                            if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
                            onwriteStateUpdate(state);
                            if (er) onwriteError(stream, state, sync, er, cb);
                            else {
                                // Check if we're actually ready to finish, but don't emit yet
                                var finished = needFinish(state) || stream.destroyed;
                                if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
                                if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
                                else afterWrite(stream, state, finished, cb);
                            }
                        }
                        function afterWrite(stream, state, finished, cb) {
                            if (!finished) onwriteDrain(stream, state);
                            state.pendingcb--;
                            cb();
                            finishMaybe(stream, state);
                        } // Must force callback to be called on nextTick, so that we don't
                        // emit 'drain' before the write() consumer gets the 'false' return
                        // value, and has a chance to attach a 'drain' listener.
                        function onwriteDrain(stream, state) {
                            if (state.length === 0 && state.needDrain) {
                                state.needDrain = false;
                                stream.emit('drain');
                            }
                        } // if there's something in the buffer waiting, then process it
                        function clearBuffer(stream, state) {
                            state.bufferProcessing = true;
                            var entry = state.bufferedRequest;
                            if (stream._writev && entry && entry.next) {
                                // Fast case, write everything using _writev()
                                var l = state.bufferedRequestCount;
                                var buffer = new Array(l);
                                var holder = state.corkedRequestsFree;
                                holder.entry = entry;
                                var count = 0;
                                var allBuffers = true;
                                while(entry){
                                    buffer[count] = entry;
                                    if (!entry.isBuf) allBuffers = false;
                                    entry = entry.next;
                                    count += 1;
                                }
                                buffer.allBuffers = allBuffers;
                                doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
                                // as the hot path ends with doWrite
                                state.pendingcb++;
                                state.lastBufferedRequest = null;
                                if (holder.next) {
                                    state.corkedRequestsFree = holder.next;
                                    holder.next = null;
                                } else state.corkedRequestsFree = new CorkedRequest(state);
                                state.bufferedRequestCount = 0;
                            } else {
                                // Slow case, write chunks one-by-one
                                while(entry){
                                    var chunk = entry.chunk;
                                    var encoding = entry.encoding;
                                    var cb = entry.callback;
                                    var len = state.objectMode ? 1 : chunk.length;
                                    doWrite(stream, state, false, len, chunk, encoding, cb);
                                    entry = entry.next;
                                    state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
                                    // it means that we need to wait until it does.
                                    // also, that means that the chunk and cb are currently
                                    // being processed, so move the buffer counter past them.
                                    if (state.writing) break;
                                }
                                if (entry === null) state.lastBufferedRequest = null;
                            }
                            state.bufferedRequest = entry;
                            state.bufferProcessing = false;
                        }
                        Writable.prototype._write = function(chunk, encoding, cb) {
                            cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
                        };
                        Writable.prototype._writev = null;
                        Writable.prototype.end = function(chunk, encoding, cb) {
                            var state = this._writableState;
                            if (typeof chunk === 'function') {
                                cb = chunk;
                                chunk = null;
                                encoding = null;
                            } else if (typeof encoding === 'function') {
                                cb = encoding;
                                encoding = null;
                            }
                            if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
                            if (state.corked) {
                                state.corked = 1;
                                this.uncork();
                            } // ignore unnecessary end() calls.
                            if (!state.ending) endWritable(this, state, cb);
                            return this;
                        };
                        Object.defineProperty(Writable.prototype, 'writableLength', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.length;
                            }
                        });
                        function needFinish(state) {
                            return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
                        }
                        function callFinal(stream, state) {
                            stream._final(function(err) {
                                state.pendingcb--;
                                if (err) errorOrDestroy(stream, err);
                                state.prefinished = true;
                                stream.emit('prefinish');
                                finishMaybe(stream, state);
                            });
                        }
                        function prefinish(stream, state) {
                            if (!state.prefinished && !state.finalCalled) {
                                if (typeof stream._final === 'function' && !state.destroyed) {
                                    state.pendingcb++;
                                    state.finalCalled = true;
                                    process.nextTick(callFinal, stream, state);
                                } else {
                                    state.prefinished = true;
                                    stream.emit('prefinish');
                                }
                            }
                        }
                        function finishMaybe(stream, state) {
                            var need = needFinish(state);
                            if (need) {
                                prefinish(stream, state);
                                if (state.pendingcb === 0) {
                                    state.finished = true;
                                    stream.emit('finish');
                                    if (state.autoDestroy) {
                                        // In case of duplex streams we need a way to detect
                                        // if the readable side is ready for autoDestroy as well
                                        var rState = stream._readableState;
                                        if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                                    }
                                }
                            }
                            return need;
                        }
                        function endWritable(stream, state, cb) {
                            state.ending = true;
                            finishMaybe(stream, state);
                            if (cb) {
                                if (state.finished) process.nextTick(cb);
                                else stream.once('finish', cb);
                            }
                            state.ended = true;
                            stream.writable = false;
                        }
                        function onCorkedFinish(corkReq, state, err) {
                            var entry = corkReq.entry;
                            corkReq.entry = null;
                            while(entry){
                                var cb = entry.callback;
                                state.pendingcb--;
                                cb(err);
                                entry = entry.next;
                            } // reuse the free corkReq.
                            state.corkedRequestsFree.next = corkReq;
                        }
                        Object.defineProperty(Writable.prototype, 'destroyed', {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._writableState === undefined) return false;
                                return this._writableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (!this._writableState) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._writableState.destroyed = value;
                            }
                        });
                        Writable.prototype.destroy = destroyImpl.destroy;
                        Writable.prototype._undestroy = destroyImpl.undestroy;
                        Writable.prototype._destroy = function(err, cb) {
                            cb(err);
                        };
                    }).call(this);
                }).call(this, require1('_process'), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "./internal/streams/destroy": 50,
                "./internal/streams/state": 54,
                "./internal/streams/stream": 55,
                "_process": 39,
                "buffer": 35,
                "inherits": 38,
                "util-deprecate": 57
            }
        ],
        48: [
            function(require1, module1, exports) {
                (function(process) {
                    (function() {
                        'use strict';
                        var _Object$setPrototypeO;
                        function _defineProperty(obj, key, value) {
                            if (key in obj) Object.defineProperty(obj, key, {
                                value: value,
                                enumerable: true,
                                configurable: true,
                                writable: true
                            });
                            else obj[key] = value;
                            return obj;
                        }
                        var finished = require1('./end-of-stream');
                        var kLastResolve = Symbol('lastResolve');
                        var kLastReject = Symbol('lastReject');
                        var kError = Symbol('error');
                        var kEnded = Symbol('ended');
                        var kLastPromise = Symbol('lastPromise');
                        var kHandlePromise = Symbol('handlePromise');
                        var kStream = Symbol('stream');
                        function createIterResult(value, done) {
                            return {
                                value: value,
                                done: done
                            };
                        }
                        function readAndResolve(iter) {
                            var resolve = iter[kLastResolve];
                            if (resolve !== null) {
                                var data = iter[kStream].read(); // we defer if data is null
                                // we can be expecting either 'end' or
                                // 'error'
                                if (data !== null) {
                                    iter[kLastPromise] = null;
                                    iter[kLastResolve] = null;
                                    iter[kLastReject] = null;
                                    resolve(createIterResult(data, false));
                                }
                            }
                        }
                        function onReadable(iter) {
                            // we wait for the next tick, because it might
                            // emit an error with process.nextTick
                            process.nextTick(readAndResolve, iter);
                        }
                        function wrapForNext(lastPromise, iter) {
                            return function(resolve, reject) {
                                lastPromise.then(function() {
                                    if (iter[kEnded]) {
                                        resolve(createIterResult(undefined, true));
                                        return;
                                    }
                                    iter[kHandlePromise](resolve, reject);
                                }, reject);
                            };
                        }
                        var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
                        var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
                            get stream () {
                                return this[kStream];
                            },
                            next: function next() {
                                var _this = this;
                                // if we have detected an error in the meanwhile
                                // reject straight away
                                var error = this[kError];
                                if (error !== null) return Promise.reject(error);
                                if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
                                if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
                                // called, the error will be emitted via nextTick, and
                                // we cannot guarantee that there is no error lingering around
                                // waiting to be emitted.
                                return new Promise(function(resolve, reject) {
                                    process.nextTick(function() {
                                        if (_this[kError]) reject(_this[kError]);
                                        else resolve(createIterResult(undefined, true));
                                    });
                                });
                                 // if we have multiple next() calls
                                // we will wait for the previous Promise to finish
                                // this logic is optimized to support for await loops,
                                // where next() is only called once at a time
                                var lastPromise = this[kLastPromise];
                                var promise;
                                if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
                                else {
                                    // fast path needed to support multiple this.push()
                                    // without triggering the next() queue
                                    var data = this[kStream].read();
                                    if (data !== null) return Promise.resolve(createIterResult(data, false));
                                    promise = new Promise(this[kHandlePromise]);
                                }
                                this[kLastPromise] = promise;
                                return promise;
                            }
                        }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
                            return this;
                        }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
                            var _this2 = this;
                            // destroy(err, cb) is a private API
                            // we can guarantee we have that here, because we control the
                            // Readable class this is attached to
                            return new Promise(function(resolve, reject) {
                                _this2[kStream].destroy(null, function(err) {
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    resolve(createIterResult(undefined, true));
                                });
                            });
                        }), _Object$setPrototypeO), AsyncIteratorPrototype);
                        var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
                            var _Object$create;
                            var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
                                value: stream,
                                writable: true
                            }), _defineProperty(_Object$create, kLastResolve, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kLastReject, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kError, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kEnded, {
                                value: stream._readableState.endEmitted,
                                writable: true
                            }), _defineProperty(_Object$create, kHandlePromise, {
                                value: function value(resolve, reject) {
                                    var data = iterator[kStream].read();
                                    if (data) {
                                        iterator[kLastPromise] = null;
                                        iterator[kLastResolve] = null;
                                        iterator[kLastReject] = null;
                                        resolve(createIterResult(data, false));
                                    } else {
                                        iterator[kLastResolve] = resolve;
                                        iterator[kLastReject] = reject;
                                    }
                                },
                                writable: true
                            }), _Object$create));
                            iterator[kLastPromise] = null;
                            finished(stream, function(err) {
                                if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
                                    var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                                    // returned by next() and store the error
                                    if (reject !== null) {
                                        iterator[kLastPromise] = null;
                                        iterator[kLastResolve] = null;
                                        iterator[kLastReject] = null;
                                        reject(err);
                                    }
                                    iterator[kError] = err;
                                    return;
                                }
                                var resolve = iterator[kLastResolve];
                                if (resolve !== null) {
                                    iterator[kLastPromise] = null;
                                    iterator[kLastResolve] = null;
                                    iterator[kLastReject] = null;
                                    resolve(createIterResult(undefined, true));
                                }
                                iterator[kEnded] = true;
                            });
                            stream.on('readable', onReadable.bind(null, iterator));
                            return iterator;
                        };
                        module1.exports = createReadableStreamAsyncIterator;
                    }).call(this);
                }).call(this, require1('_process'));
            },
            {
                "./end-of-stream": 51,
                "_process": 39
            }
        ],
        49: [
            function(require1, module1, exports) {
                'use strict';
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var _require = require1('buffer'), Buffer = _require.Buffer;
                var _require2 = require1('util'), inspect = _require2.inspect;
                var custom = inspect && inspect.custom || 'inspect';
                function copyBuffer(src, target, offset) {
                    Buffer.prototype.copy.call(src, target, offset);
                }
                module1.exports = /*#__PURE__*/ function() {
                    function BufferList() {
                        _classCallCheck(this, BufferList);
                        this.head = null;
                        this.tail = null;
                        this.length = 0;
                    }
                    _createClass(BufferList, [
                        {
                            key: "push",
                            value: function push(v) {
                                var entry = {
                                    data: v,
                                    next: null
                                };
                                if (this.length > 0) this.tail.next = entry;
                                else this.head = entry;
                                this.tail = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function unshift(v) {
                                var entry = {
                                    data: v,
                                    next: this.head
                                };
                                if (this.length === 0) this.tail = entry;
                                this.head = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function shift() {
                                if (this.length === 0) return;
                                var ret = this.head.data;
                                if (this.length === 1) this.head = this.tail = null;
                                else this.head = this.head.next;
                                --this.length;
                                return ret;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.head = this.tail = null;
                                this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function join(s) {
                                if (this.length === 0) return '';
                                var p = this.head;
                                var ret = '' + p.data;
                                while(p = p.next)ret += s + p.data;
                                return ret;
                            }
                        },
                        {
                            key: "concat",
                            value: function concat(n) {
                                if (this.length === 0) return Buffer.alloc(0);
                                var ret = Buffer.allocUnsafe(n >>> 0);
                                var p = this.head;
                                var i = 0;
                                while(p){
                                    copyBuffer(p.data, ret, i);
                                    i += p.data.length;
                                    p = p.next;
                                }
                                return ret;
                            } // Consumes a specified amount of bytes or characters from the buffered data.
                        },
                        {
                            key: "consume",
                            value: function consume(n, hasStrings) {
                                var ret;
                                if (n < this.head.data.length) {
                                    // `slice` is the same for buffers and strings.
                                    ret = this.head.data.slice(0, n);
                                    this.head.data = this.head.data.slice(n);
                                } else if (n === this.head.data.length) // First chunk is a perfect match.
                                ret = this.shift();
                                else // Result spans more than one buffer.
                                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                                return ret;
                            }
                        },
                        {
                            key: "first",
                            value: function first() {
                                return this.head.data;
                            } // Consumes a specified amount of characters from the buffered data.
                        },
                        {
                            key: "_getString",
                            value: function _getString(n) {
                                var p = this.head;
                                var c = 1;
                                var ret = p.data;
                                n -= ret.length;
                                while(p = p.next){
                                    var str = p.data;
                                    var nb = n > str.length ? str.length : n;
                                    if (nb === str.length) ret += str;
                                    else ret += str.slice(0, n);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === str.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = str.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            } // Consumes a specified amount of bytes from the buffered data.
                        },
                        {
                            key: "_getBuffer",
                            value: function _getBuffer(n) {
                                var ret = Buffer.allocUnsafe(n);
                                var p = this.head;
                                var c = 1;
                                p.data.copy(ret);
                                n -= p.data.length;
                                while(p = p.next){
                                    var buf = p.data;
                                    var nb = n > buf.length ? buf.length : n;
                                    buf.copy(ret, ret.length - n, 0, nb);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === buf.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = buf.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            } // Make sure the linked list only shows the minimal necessary information.
                        },
                        {
                            key: custom,
                            value: function value(_, options) {
                                return inspect(this, _objectSpread({}, options, {
                                    // Only inspect one level.
                                    depth: 0,
                                    // It should not recurse.
                                    customInspect: false
                                }));
                            }
                        }
                    ]);
                    return BufferList;
                }();
            },
            {
                "buffer": 35,
                "util": 33
            }
        ],
        50: [
            function(require1, module1, exports) {
                (function(process) {
                    (function() {
                        'use strict'; // undocumented cb() API, needed for core, not for public API
                        function destroy(err, cb) {
                            var _this = this;
                            var readableDestroyed = this._readableState && this._readableState.destroyed;
                            var writableDestroyed = this._writableState && this._writableState.destroyed;
                            if (readableDestroyed || writableDestroyed) {
                                if (cb) cb(err);
                                else if (err) {
                                    if (!this._writableState) process.nextTick(emitErrorNT, this, err);
                                    else if (!this._writableState.errorEmitted) {
                                        this._writableState.errorEmitted = true;
                                        process.nextTick(emitErrorNT, this, err);
                                    }
                                }
                                return this;
                            } // we set destroyed to true before firing error callbacks in order
                            // to make it re-entrance safe in case destroy() is called within callbacks
                            if (this._readableState) this._readableState.destroyed = true;
                             // if this is a duplex stream mark the writable part as destroyed as well
                            if (this._writableState) this._writableState.destroyed = true;
                            this._destroy(err || null, function(err) {
                                if (!cb && err) {
                                    if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
                                    else if (!_this._writableState.errorEmitted) {
                                        _this._writableState.errorEmitted = true;
                                        process.nextTick(emitErrorAndCloseNT, _this, err);
                                    } else process.nextTick(emitCloseNT, _this);
                                } else if (cb) {
                                    process.nextTick(emitCloseNT, _this);
                                    cb(err);
                                } else process.nextTick(emitCloseNT, _this);
                            });
                            return this;
                        }
                        function emitErrorAndCloseNT(self1, err) {
                            emitErrorNT(self1, err);
                            emitCloseNT(self1);
                        }
                        function emitCloseNT(self1) {
                            if (self1._writableState && !self1._writableState.emitClose) return;
                            if (self1._readableState && !self1._readableState.emitClose) return;
                            self1.emit('close');
                        }
                        function undestroy() {
                            if (this._readableState) {
                                this._readableState.destroyed = false;
                                this._readableState.reading = false;
                                this._readableState.ended = false;
                                this._readableState.endEmitted = false;
                            }
                            if (this._writableState) {
                                this._writableState.destroyed = false;
                                this._writableState.ended = false;
                                this._writableState.ending = false;
                                this._writableState.finalCalled = false;
                                this._writableState.prefinished = false;
                                this._writableState.finished = false;
                                this._writableState.errorEmitted = false;
                            }
                        }
                        function emitErrorNT(self1, err) {
                            self1.emit('error', err);
                        }
                        function errorOrDestroy(stream, err) {
                            // We have tests that rely on errors being emitted
                            // in the same tick, so changing this is semver major.
                            // For now when you opt-in to autoDestroy we allow
                            // the error to be emitted nextTick. In a future
                            // semver major update we should change the default to this.
                            var rState = stream._readableState;
                            var wState = stream._writableState;
                            if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
                            else stream.emit('error', err);
                        }
                        module1.exports = {
                            destroy: destroy,
                            undestroy: undestroy,
                            errorOrDestroy: errorOrDestroy
                        };
                    }).call(this);
                }).call(this, require1('_process'));
            },
            {
                "_process": 39
            }
        ],
        51: [
            function(require1, module1, exports) {
                // Ported from https://github.com/mafintosh/end-of-stream with
                // permission from the author, Mathias Buus (@mafintosh).
                'use strict';
                var ERR_STREAM_PREMATURE_CLOSE = require1('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback.apply(this, args);
                    };
                }
                function noop() {}
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === 'function';
                }
                function eos(stream, opts, callback) {
                    if (typeof opts === 'function') return eos(stream, null, opts);
                    if (!opts) opts = {};
                    callback = once(callback || noop);
                    var readable = opts.readable || opts.readable !== false && stream.readable;
                    var writable = opts.writable || opts.writable !== false && stream.writable;
                    var onlegacyfinish = function onlegacyfinish() {
                        if (!stream.writable) onfinish();
                    };
                    var writableEnded = stream._writableState && stream._writableState.finished;
                    var onfinish = function onfinish() {
                        writable = false;
                        writableEnded = true;
                        if (!readable) callback.call(stream);
                    };
                    var readableEnded = stream._readableState && stream._readableState.endEmitted;
                    var onend = function onend() {
                        readable = false;
                        readableEnded = true;
                        if (!writable) callback.call(stream);
                    };
                    var onerror = function onerror(err) {
                        callback.call(stream, err);
                    };
                    var onclose = function onclose() {
                        var err;
                        if (readable && !readableEnded) {
                            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                        if (writable && !writableEnded) {
                            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                    };
                    var onrequest = function onrequest() {
                        stream.req.on('finish', onfinish);
                    };
                    if (isRequest(stream)) {
                        stream.on('complete', onfinish);
                        stream.on('abort', onclose);
                        if (stream.req) onrequest();
                        else stream.on('request', onrequest);
                    } else if (writable && !stream._writableState) {
                        // legacy streams
                        stream.on('end', onlegacyfinish);
                        stream.on('close', onlegacyfinish);
                    }
                    stream.on('end', onend);
                    stream.on('finish', onfinish);
                    if (opts.error !== false) stream.on('error', onerror);
                    stream.on('close', onclose);
                    return function() {
                        stream.removeListener('complete', onfinish);
                        stream.removeListener('abort', onclose);
                        stream.removeListener('request', onrequest);
                        if (stream.req) stream.req.removeListener('finish', onfinish);
                        stream.removeListener('end', onlegacyfinish);
                        stream.removeListener('close', onlegacyfinish);
                        stream.removeListener('finish', onfinish);
                        stream.removeListener('end', onend);
                        stream.removeListener('error', onerror);
                        stream.removeListener('close', onclose);
                    };
                }
                module1.exports = eos;
            },
            {
                "../../../errors": 42
            }
        ],
        52: [
            function(require1, module1, exports) {
                module1.exports = function() {
                    throw new Error('Readable.from is not available in the browser');
                };
            },
            {}
        ],
        53: [
            function(require1, module1, exports) {
                // Ported from https://github.com/mafintosh/pump with
                // permission from the author, Mathias Buus (@mafintosh).
                'use strict';
                var eos;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        callback.apply(void 0, arguments);
                    };
                }
                var _require$codes = require1('../../../errors').codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
                function noop(err) {
                    // Rethrow the error if it exists to avoid swallowing it
                    if (err) throw err;
                }
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === 'function';
                }
                function destroyer(stream, reading, writing, callback) {
                    callback = once(callback);
                    var closed = false;
                    stream.on('close', function() {
                        closed = true;
                    });
                    if (eos === undefined) eos = require1('./end-of-stream');
                    eos(stream, {
                        readable: reading,
                        writable: writing
                    }, function(err) {
                        if (err) return callback(err);
                        closed = true;
                        callback();
                    });
                    var destroyed = false;
                    return function(err) {
                        if (closed) return;
                        if (destroyed) return;
                        destroyed = true; // request.destroy just do .end - .abort is what we want
                        if (isRequest(stream)) return stream.abort();
                        if (typeof stream.destroy === 'function') return stream.destroy();
                        callback(err || new ERR_STREAM_DESTROYED('pipe'));
                    };
                }
                function call(fn) {
                    fn();
                }
                function pipe(from, to) {
                    return from.pipe(to);
                }
                function popCallback(streams) {
                    if (!streams.length) return noop;
                    if (typeof streams[streams.length - 1] !== 'function') return noop;
                    return streams.pop();
                }
                function pipeline() {
                    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
                    var callback = popCallback(streams);
                    if (Array.isArray(streams[0])) streams = streams[0];
                    if (streams.length < 2) throw new ERR_MISSING_ARGS('streams');
                    var error;
                    var destroys = streams.map(function(stream, i) {
                        var reading = i < streams.length - 1;
                        var writing = i > 0;
                        return destroyer(stream, reading, writing, function(err) {
                            if (!error) error = err;
                            if (err) destroys.forEach(call);
                            if (reading) return;
                            destroys.forEach(call);
                            callback(error);
                        });
                    });
                    return streams.reduce(pipe);
                }
                module1.exports = pipeline;
            },
            {
                "../../../errors": 42,
                "./end-of-stream": 51
            }
        ],
        54: [
            function(require1, module1, exports) {
                'use strict';
                var ERR_INVALID_OPT_VALUE = require1('../../../errors').codes.ERR_INVALID_OPT_VALUE;
                function highWaterMarkFrom(options, isDuplex, duplexKey) {
                    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
                }
                function getHighWaterMark(state, options, duplexKey, isDuplex) {
                    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
                    if (hwm != null) {
                        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                            var name = isDuplex ? duplexKey : 'highWaterMark';
                            throw new ERR_INVALID_OPT_VALUE(name, hwm);
                        }
                        return Math.floor(hwm);
                    } // Default value
                    return state.objectMode ? 16 : 16384;
                }
                module1.exports = {
                    getHighWaterMark: getHighWaterMark
                };
            },
            {
                "../../../errors": 42
            }
        ],
        55: [
            function(require1, module1, exports) {
                module1.exports = require1('events').EventEmitter;
            },
            {
                "events": 36
            }
        ],
        56: [
            function(require1, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                'use strict';
                /*<replacement>*/ var Buffer = require1('safe-buffer').Buffer;
                /*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
                    encoding = '' + encoding;
                    switch(encoding && encoding.toLowerCase()){
                        case 'hex':
                        case 'utf8':
                        case 'utf-8':
                        case 'ascii':
                        case 'binary':
                        case 'base64':
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                        case 'raw':
                            return true;
                        default:
                            return false;
                    }
                };
                function _normalizeEncoding(enc) {
                    if (!enc) return 'utf8';
                    var retried;
                    while(true)switch(enc){
                        case 'utf8':
                        case 'utf-8':
                            return 'utf8';
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                            return 'utf16le';
                        case 'latin1':
                        case 'binary':
                            return 'latin1';
                        case 'base64':
                        case 'ascii':
                        case 'hex':
                            return enc;
                        default:
                            if (retried) return; // undefined
                            enc = ('' + enc).toLowerCase();
                            retried = true;
                    }
                }
                // Do not cache `Buffer.isEncoding` when checking encoding names as some
                // modules monkey-patch it to support additional encodings
                function normalizeEncoding(enc) {
                    var nenc = _normalizeEncoding(enc);
                    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
                    return nenc || enc;
                }
                // StringDecoder provides an interface for efficiently splitting a series of
                // buffers into a series of JS strings without breaking apart multi-byte
                // characters.
                exports.StringDecoder = StringDecoder;
                function StringDecoder(encoding) {
                    this.encoding = normalizeEncoding(encoding);
                    var nb;
                    switch(this.encoding){
                        case 'utf16le':
                            this.text = utf16Text;
                            this.end = utf16End;
                            nb = 4;
                            break;
                        case 'utf8':
                            this.fillLast = utf8FillLast;
                            nb = 4;
                            break;
                        case 'base64':
                            this.text = base64Text;
                            this.end = base64End;
                            nb = 3;
                            break;
                        default:
                            this.write = simpleWrite;
                            this.end = simpleEnd;
                            return;
                    }
                    this.lastNeed = 0;
                    this.lastTotal = 0;
                    this.lastChar = Buffer.allocUnsafe(nb);
                }
                StringDecoder.prototype.write = function(buf) {
                    if (buf.length === 0) return '';
                    var r;
                    var i;
                    if (this.lastNeed) {
                        r = this.fillLast(buf);
                        if (r === undefined) return '';
                        i = this.lastNeed;
                        this.lastNeed = 0;
                    } else i = 0;
                    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
                    return r || '';
                };
                StringDecoder.prototype.end = utf8End;
                // Returns only complete characters in a Buffer
                StringDecoder.prototype.text = utf8Text;
                // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
                StringDecoder.prototype.fillLast = function(buf) {
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
                    this.lastNeed -= buf.length;
                };
                // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
                // continuation byte. If an invalid byte is detected, -2 is returned.
                function utf8CheckByte(byte) {
                    if (byte <= 0x7F) return 0;
                    else if (byte >> 5 === 0x06) return 2;
                    else if (byte >> 4 === 0x0E) return 3;
                    else if (byte >> 3 === 0x1E) return 4;
                    return byte >> 6 === 0x02 ? -1 : -2;
                }
                // Checks at most 3 bytes at the end of a Buffer in order to detect an
                // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
                // needed to complete the UTF-8 character (if applicable) are returned.
                function utf8CheckIncomplete(self1, buf, i) {
                    var j = buf.length - 1;
                    if (j < i) return 0;
                    var nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 1;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 2;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) {
                            if (nb === 2) nb = 0;
                            else self1.lastNeed = nb - 3;
                        }
                        return nb;
                    }
                    return 0;
                }
                // Validates as many continuation bytes for a multi-byte UTF-8 character as
                // needed or are available. If we see a non-continuation byte where we expect
                // one, we "replace" the validated continuation bytes we've seen so far with
                // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
                // behavior. The continuation byte check is included three times in the case
                // where all of the continuation bytes for a character exist in the same buffer.
                // It is also done this way as a slight performance increase instead of using a
                // loop.
                function utf8CheckExtraBytes(self1, buf, p) {
                    if ((buf[0] & 0xC0) !== 0x80) {
                        self1.lastNeed = 0;
                        return '\ufffd';
                    }
                    if (self1.lastNeed > 1 && buf.length > 1) {
                        if ((buf[1] & 0xC0) !== 0x80) {
                            self1.lastNeed = 1;
                            return '\ufffd';
                        }
                        if (self1.lastNeed > 2 && buf.length > 2) {
                            if ((buf[2] & 0xC0) !== 0x80) {
                                self1.lastNeed = 2;
                                return '\ufffd';
                            }
                        }
                    }
                }
                // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
                function utf8FillLast(buf) {
                    var p = this.lastTotal - this.lastNeed;
                    var r = utf8CheckExtraBytes(this, buf, p);
                    if (r !== undefined) return r;
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, p, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, p, 0, buf.length);
                    this.lastNeed -= buf.length;
                }
                // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
                // partial character, the character's bytes are buffered until the required
                // number of bytes are available.
                function utf8Text(buf, i) {
                    var total = utf8CheckIncomplete(this, buf, i);
                    if (!this.lastNeed) return buf.toString('utf8', i);
                    this.lastTotal = total;
                    var end = buf.length - (total - this.lastNeed);
                    buf.copy(this.lastChar, 0, end);
                    return buf.toString('utf8', i, end);
                }
                // For UTF-8, a replacement character is added when ending on a partial
                // character.
                function utf8End(buf) {
                    var r = buf && buf.length ? this.write(buf) : '';
                    if (this.lastNeed) return r + '\ufffd';
                    return r;
                }
                // UTF-16LE typically needs two bytes per character, but even if we have an even
                // number of bytes available, we need to check if we end on a leading/high
                // surrogate. In that case, we need to wait for the next two bytes in order to
                // decode the last character properly.
                function utf16Text(buf, i) {
                    if ((buf.length - i) % 2 === 0) {
                        var r = buf.toString('utf16le', i);
                        if (r) {
                            var c = r.charCodeAt(r.length - 1);
                            if (c >= 0xD800 && c <= 0xDBFF) {
                                this.lastNeed = 2;
                                this.lastTotal = 4;
                                this.lastChar[0] = buf[buf.length - 2];
                                this.lastChar[1] = buf[buf.length - 1];
                                return r.slice(0, -1);
                            }
                        }
                        return r;
                    }
                    this.lastNeed = 1;
                    this.lastTotal = 2;
                    this.lastChar[0] = buf[buf.length - 1];
                    return buf.toString('utf16le', i, buf.length - 1);
                }
                // For UTF-16LE we do not explicitly append special replacement characters if we
                // end on a partial character, we simply let v8 handle that.
                function utf16End(buf) {
                    var r = buf && buf.length ? this.write(buf) : '';
                    if (this.lastNeed) {
                        var end = this.lastTotal - this.lastNeed;
                        return r + this.lastChar.toString('utf16le', 0, end);
                    }
                    return r;
                }
                function base64Text(buf, i) {
                    var n = (buf.length - i) % 3;
                    if (n === 0) return buf.toString('base64', i);
                    this.lastNeed = 3 - n;
                    this.lastTotal = 3;
                    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
                    else {
                        this.lastChar[0] = buf[buf.length - 2];
                        this.lastChar[1] = buf[buf.length - 1];
                    }
                    return buf.toString('base64', i, buf.length - n);
                }
                function base64End(buf) {
                    var r = buf && buf.length ? this.write(buf) : '';
                    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
                    return r;
                }
                // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
                function simpleWrite(buf) {
                    return buf.toString(this.encoding);
                }
                function simpleEnd(buf) {
                    return buf && buf.length ? this.write(buf) : '';
                }
            },
            {
                "safe-buffer": 40
            }
        ],
        57: [
            function(require1, module1, exports) {
                (function(global1) {
                    (function() {
                        /**
 * Module exports.
 */ module1.exports = deprecate;
                        /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
                            if (config('noDeprecation')) return fn;
                            var warned = false;
                            function deprecated() {
                                if (!warned) {
                                    if (config('throwDeprecation')) throw new Error(msg);
                                    else if (config('traceDeprecation')) console.trace(msg);
                                    else console.warn(msg);
                                    warned = true;
                                }
                                return fn.apply(this, arguments);
                            }
                            return deprecated;
                        }
                        /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
                            // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                            try {
                                if (!global1.localStorage) return false;
                            } catch (_) {
                                return false;
                            }
                            var val = global1.localStorage[name];
                            if (null == val) return false;
                            return String(val).toLowerCase() === 'true';
                        }
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        58: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "v1", {
                    enumerable: true,
                    get: function() {
                        return _v.default;
                    }
                });
                Object.defineProperty(exports, "v3", {
                    enumerable: true,
                    get: function() {
                        return _v2.default;
                    }
                });
                Object.defineProperty(exports, "v4", {
                    enumerable: true,
                    get: function() {
                        return _v3.default;
                    }
                });
                Object.defineProperty(exports, "v5", {
                    enumerable: true,
                    get: function() {
                        return _v4.default;
                    }
                });
                Object.defineProperty(exports, "NIL", {
                    enumerable: true,
                    get: function() {
                        return _nil.default;
                    }
                });
                Object.defineProperty(exports, "version", {
                    enumerable: true,
                    get: function() {
                        return _version.default;
                    }
                });
                Object.defineProperty(exports, "validate", {
                    enumerable: true,
                    get: function() {
                        return _validate.default;
                    }
                });
                Object.defineProperty(exports, "stringify", {
                    enumerable: true,
                    get: function() {
                        return _stringify.default;
                    }
                });
                Object.defineProperty(exports, "parse", {
                    enumerable: true,
                    get: function() {
                        return _parse.default;
                    }
                });
                var _v = _interopRequireDefault(require1("./v1.js"));
                var _v2 = _interopRequireDefault(require1("./v3.js"));
                var _v3 = _interopRequireDefault(require1("./v4.js"));
                var _v4 = _interopRequireDefault(require1("./v5.js"));
                var _nil = _interopRequireDefault(require1("./nil.js"));
                var _version = _interopRequireDefault(require1("./version.js"));
                var _validate = _interopRequireDefault(require1("./validate.js"));
                var _stringify = _interopRequireDefault(require1("./stringify.js"));
                var _parse = _interopRequireDefault(require1("./parse.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
            },
            {
                "./nil.js": 60,
                "./parse.js": 61,
                "./stringify.js": 65,
                "./v1.js": 66,
                "./v3.js": 67,
                "./v4.js": 69,
                "./v5.js": 70,
                "./validate.js": 71,
                "./version.js": 72
            }
        ],
        59: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                /*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ function md5(bytes) {
                    if (typeof bytes === 'string') {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = new Uint8Array(msg.length);
                        for(let i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
                    }
                    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
                }
                /*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
                    const output = [];
                    const length32 = input.length * 32;
                    const hexTab = '0123456789abcdef';
                    for(let i = 0; i < length32; i += 8){
                        const x = input[i >> 5] >>> i % 32 & 0xff;
                        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
                        output.push(hex);
                    }
                    return output;
                }
                /**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
                    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
                }
                /*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
                    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
                    x[getOutputLength(len) - 1] = len;
                    let a = 1732584193;
                    let b = -271733879;
                    let c = -1732584194;
                    let d = 271733878;
                    for(let i = 0; i < x.length; i += 16){
                        const olda = a;
                        const oldb = b;
                        const oldc = c;
                        const oldd = d;
                        a = md5ff(a, b, c, d, x[i], 7, -680876936);
                        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
                        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
                        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
                        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
                        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
                        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
                        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
                        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
                        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
                        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
                        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
                        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
                        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
                        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
                        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
                        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
                        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
                        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
                        b = md5gg(b, c, d, a, x[i], 20, -373897302);
                        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
                        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
                        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
                        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
                        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
                        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
                        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
                        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
                        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
                        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
                        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
                        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
                        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
                        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
                        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
                        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
                        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
                        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
                        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
                        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
                        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
                        d = md5hh(d, a, b, c, x[i], 11, -358537222);
                        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
                        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
                        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
                        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
                        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
                        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
                        a = md5ii(a, b, c, d, x[i], 6, -198630844);
                        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
                        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
                        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
                        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
                        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
                        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
                        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
                        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
                        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
                        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
                        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
                        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
                        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
                        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
                        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
                        a = safeAdd(a, olda);
                        b = safeAdd(b, oldb);
                        c = safeAdd(c, oldc);
                        d = safeAdd(d, oldd);
                    }
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                }
                /*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
                    if (input.length === 0) return [];
                    const length8 = input.length * 8;
                    const output = new Uint32Array(getOutputLength(length8));
                    for(let i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
                    return output;
                }
                /*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
                    const lsw = (x & 0xffff) + (y & 0xffff);
                    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
                    return msw << 16 | lsw & 0xffff;
                }
                /*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
                    return num << cnt | num >>> 32 - cnt;
                }
                /*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
                    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
                }
                function md5ff(a, b, c, d, x, s, t) {
                    return md5cmn(b & c | ~b & d, a, b, x, s, t);
                }
                function md5gg(a, b, c, d, x, s, t) {
                    return md5cmn(b & d | c & ~d, a, b, x, s, t);
                }
                function md5hh(a, b, c, d, x, s, t) {
                    return md5cmn(b ^ c ^ d, a, b, x, s, t);
                }
                function md5ii(a, b, c, d, x, s, t) {
                    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
                }
                var _default = md5;
                exports.default = _default;
            },
            {}
        ],
        60: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _default = '00000000-0000-0000-0000-000000000000';
                exports.default = _default;
            },
            {}
        ],
        61: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require1("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function parse(uuid) {
                    if (!(0, _validate.default)(uuid)) throw TypeError('Invalid UUID');
                    let v;
                    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
                    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
                    arr[1] = v >>> 16 & 0xff;
                    arr[2] = v >>> 8 & 0xff;
                    arr[3] = v & 0xff; // Parse ........-####-....-....-............
                    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
                    arr[5] = v & 0xff; // Parse ........-....-####-....-............
                    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
                    arr[7] = v & 0xff; // Parse ........-....-....-####-............
                    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
                    arr[9] = v & 0xff; // Parse ........-....-....-....-############
                    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
                    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
                    arr[11] = v / 0x100000000 & 0xff;
                    arr[12] = v >>> 24 & 0xff;
                    arr[13] = v >>> 16 & 0xff;
                    arr[14] = v >>> 8 & 0xff;
                    arr[15] = v & 0xff;
                    return arr;
                }
                var _default = parse;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ],
        62: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                exports.default = _default;
            },
            {}
        ],
        63: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = rng;
                // Unique ID creation requires a high quality random # generator. In the browser we therefore
                // require the crypto API and do not support built-in fallback to lower quality random number
                // generators (like Math.random()).
                let getRandomValues;
                const rnds8 = new Uint8Array(16);
                function rng() {
                    // lazy load so that environments that need to polyfill have a chance to do so
                    if (!getRandomValues) {
                        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
                        // find the complete implementation of crypto (msCrypto) on IE11.
                        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
                        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
                    }
                    return getRandomValues(rnds8);
                }
            },
            {}
        ],
        64: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                // Adapted from Chris Veness' SHA1 code at
                // http://www.movable-type.co.uk/scripts/sha1.html
                function f(s, x, y, z) {
                    switch(s){
                        case 0:
                            return x & y ^ ~x & z;
                        case 1:
                            return x ^ y ^ z;
                        case 2:
                            return x & y ^ x & z ^ y & z;
                        case 3:
                            return x ^ y ^ z;
                    }
                }
                function ROTL(x, n) {
                    return x << n | x >>> 32 - n;
                }
                function sha1(bytes) {
                    const K = [
                        0x5a827999,
                        0x6ed9eba1,
                        0x8f1bbcdc,
                        0xca62c1d6
                    ];
                    const H = [
                        0x67452301,
                        0xefcdab89,
                        0x98badcfe,
                        0x10325476,
                        0xc3d2e1f0
                    ];
                    if (typeof bytes === 'string') {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = [];
                        for(let i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
                    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
                    bytes = Array.prototype.slice.call(bytes);
                    bytes.push(0x80);
                    const l = bytes.length / 4 + 2;
                    const N = Math.ceil(l / 16);
                    const M = new Array(N);
                    for(let i = 0; i < N; ++i){
                        const arr = new Uint32Array(16);
                        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
                        M[i] = arr;
                    }
                    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
                    M[N - 1][14] = Math.floor(M[N - 1][14]);
                    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
                    for(let i = 0; i < N; ++i){
                        const W = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
                        for(let t = 16; t < 80; ++t)W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
                        let a = H[0];
                        let b = H[1];
                        let c = H[2];
                        let d = H[3];
                        let e = H[4];
                        for(let t = 0; t < 80; ++t){
                            const s = Math.floor(t / 20);
                            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
                            e = d;
                            d = c;
                            c = ROTL(b, 30) >>> 0;
                            b = a;
                            a = T;
                        }
                        H[0] = H[0] + a >>> 0;
                        H[1] = H[1] + b >>> 0;
                        H[2] = H[2] + c >>> 0;
                        H[3] = H[3] + d >>> 0;
                        H[4] = H[4] + e >>> 0;
                    }
                    return [
                        H[0] >> 24 & 0xff,
                        H[0] >> 16 & 0xff,
                        H[0] >> 8 & 0xff,
                        H[0] & 0xff,
                        H[1] >> 24 & 0xff,
                        H[1] >> 16 & 0xff,
                        H[1] >> 8 & 0xff,
                        H[1] & 0xff,
                        H[2] >> 24 & 0xff,
                        H[2] >> 16 & 0xff,
                        H[2] >> 8 & 0xff,
                        H[2] & 0xff,
                        H[3] >> 24 & 0xff,
                        H[3] >> 16 & 0xff,
                        H[3] >> 8 & 0xff,
                        H[3] & 0xff,
                        H[4] >> 24 & 0xff,
                        H[4] >> 16 & 0xff,
                        H[4] >> 8 & 0xff,
                        H[4] & 0xff
                    ];
                }
                var _default = sha1;
                exports.default = _default;
            },
            {}
        ],
        65: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require1("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
                for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
                function stringify(arr, offset = 0) {
                    // Note: Be careful editing this code!  It's been tuned for performance
                    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
                    const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
                    // of the following:
                    // - One or more input array values don't map to a hex octet (leading to
                    // "undefined" in the uuid)
                    // - Invalid input values for the RFC `version` or `variant` fields
                    if (!(0, _validate.default)(uuid)) throw TypeError('Stringified UUID is invalid');
                    return uuid;
                }
                var _default = stringify;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ],
        66: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _rng = _interopRequireDefault(require1("./rng.js"));
                var _stringify = _interopRequireDefault(require1("./stringify.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                // **`v1()` - Generate time-based UUID**
                //
                // Inspired by https://github.com/LiosK/UUID.js
                // and http://docs.python.org/library/uuid.html
                let _nodeId;
                let _clockseq; // Previous uuid creation time
                let _lastMSecs = 0;
                let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
                function v1(options, buf, offset) {
                    let i = buf && offset || 0;
                    const b = buf || new Array(16);
                    options = options || {};
                    let node = options.node || _nodeId;
                    let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
                    // specified.  We do this lazily to minimize issues related to insufficient
                    // system entropy.  See #189
                    if (node == null || clockseq == null) {
                        const seedBytes = options.random || (options.rng || _rng.default)();
                        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
                        node = _nodeId = [
                            seedBytes[0] | 0x01,
                            seedBytes[1],
                            seedBytes[2],
                            seedBytes[3],
                            seedBytes[4],
                            seedBytes[5]
                        ];
                        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
                        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
                    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
                    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
                    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
                    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
                    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
                    // cycle to simulate higher resolution clock
                    let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
                    const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
                    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
                     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
                    // time interval
                    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
                     // Per 4.2.1.2 Throw error if too many uuids are requested
                    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    _lastMSecs = msecs;
                    _lastNSecs = nsecs;
                    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
                    msecs += 12219292800000; // `time_low`
                    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
                    b[i++] = tl >>> 24 & 0xff;
                    b[i++] = tl >>> 16 & 0xff;
                    b[i++] = tl >>> 8 & 0xff;
                    b[i++] = tl & 0xff; // `time_mid`
                    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
                    b[i++] = tmh >>> 8 & 0xff;
                    b[i++] = tmh & 0xff; // `time_high_and_version`
                    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
                    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
                    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
                    b[i++] = clockseq & 0xff; // `node`
                    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
                    return buf || (0, _stringify.default)(b);
                }
                var _default = v1;
                exports.default = _default;
            },
            {
                "./rng.js": 63,
                "./stringify.js": 65
            }
        ],
        67: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _v = _interopRequireDefault(require1("./v35.js"));
                var _md = _interopRequireDefault(require1("./md5.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v3 = (0, _v.default)('v3', 0x30, _md.default);
                var _default = v3;
                exports.default = _default;
            },
            {
                "./md5.js": 59,
                "./v35.js": 68
            }
        ],
        68: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = _default;
                exports.URL = exports.DNS = void 0;
                var _stringify = _interopRequireDefault(require1("./stringify.js"));
                var _parse = _interopRequireDefault(require1("./parse.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function stringToBytes(str) {
                    str = unescape(encodeURIComponent(str)); // UTF8 escape
                    const bytes = [];
                    for(let i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
                    return bytes;
                }
                const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
                exports.DNS = DNS;
                const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
                exports.URL = URL;
                function _default(name, version, hashfunc) {
                    function generateUUID(value, namespace, buf, offset) {
                        if (typeof value === 'string') value = stringToBytes(value);
                        if (typeof namespace === 'string') namespace = (0, _parse.default)(namespace);
                        if (namespace.length !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
                         // Compute hash of namespace and value, Per 4.3
                        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
                        // hashfunc([...namespace, ... value])`
                        let bytes = new Uint8Array(16 + value.length);
                        bytes.set(namespace);
                        bytes.set(value, namespace.length);
                        bytes = hashfunc(bytes);
                        bytes[6] = bytes[6] & 0x0f | version;
                        bytes[8] = bytes[8] & 0x3f | 0x80;
                        if (buf) {
                            offset = offset || 0;
                            for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
                            return buf;
                        }
                        return (0, _stringify.default)(bytes);
                    } // Function#name is not settable on some platforms (#270)
                    try {
                        generateUUID.name = name; // eslint-disable-next-line no-empty
                    } catch (err) {} // For CommonJS default export support
                    generateUUID.DNS = DNS;
                    generateUUID.URL = URL;
                    return generateUUID;
                }
            },
            {
                "./parse.js": 61,
                "./stringify.js": 65
            }
        ],
        69: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _rng = _interopRequireDefault(require1("./rng.js"));
                var _stringify = _interopRequireDefault(require1("./stringify.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function v4(options, buf, offset) {
                    options = options || {};
                    const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
                    rnds[6] = rnds[6] & 0x0f | 0x40;
                    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
                    if (buf) {
                        offset = offset || 0;
                        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
                        return buf;
                    }
                    return (0, _stringify.default)(rnds);
                }
                var _default = v4;
                exports.default = _default;
            },
            {
                "./rng.js": 63,
                "./stringify.js": 65
            }
        ],
        70: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _v = _interopRequireDefault(require1("./v35.js"));
                var _sha = _interopRequireDefault(require1("./sha1.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v5 = (0, _v.default)('v5', 0x50, _sha.default);
                var _default = v5;
                exports.default = _default;
            },
            {
                "./sha1.js": 64,
                "./v35.js": 68
            }
        ],
        71: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _regex = _interopRequireDefault(require1("./regex.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function validate(uuid) {
                    return typeof uuid === 'string' && _regex.default.test(uuid);
                }
                var _default = validate;
                exports.default = _default;
            },
            {
                "./regex.js": 62
            }
        ],
        72: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require1("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function version(uuid) {
                    if (!(0, _validate.default)(uuid)) throw TypeError('Invalid UUID');
                    return parseInt(uuid.substr(14, 1), 16);
                }
                var _default = version;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ]
    }, {}, [
        9
    ])(9);
});

});

parcelRegister("jtMJy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $03a8e12644f2dcab$var$createDeferred() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.reject = reject;
        deferred.resolve = resolve;
    });
    return deferred;
}
var $03a8e12644f2dcab$var$_default = $03a8e12644f2dcab$var$createDeferred;
module.exports["default"] = $03a8e12644f2dcab$var$_default;

});

parcelRegister("bjYIg", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("hAQWJ", function(module, exports) {
"use strict";

var $uqBZi = parcelRequire("uqBZi");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $cceede80e219310d$var$_classCallCheck2 = $uqBZi((parcelRequire("EwRGi")));

var $cceede80e219310d$var$_createClass2 = $uqBZi((parcelRequire("4Yhbl")));

var $cceede80e219310d$var$_assertThisInitialized2 = $uqBZi((parcelRequire("4TXYE")));

var $cceede80e219310d$var$_get2 = $uqBZi((parcelRequire("7qWbB")));

var $cceede80e219310d$var$_inherits2 = $uqBZi((parcelRequire("hzsSd")));

var $cceede80e219310d$var$_possibleConstructorReturn2 = $uqBZi((parcelRequire("ktPRR")));

var $cceede80e219310d$var$_getPrototypeOf2 = $uqBZi((parcelRequire("lCnis")));

var $cceede80e219310d$var$_classPrivateFieldGet4 = $uqBZi((parcelRequire("kaIZq")));

var $cceede80e219310d$var$_classPrivateFieldSet2 = $uqBZi((parcelRequire("jRlgX")));

var $h1R35 = parcelRequire("h1R35");
function $cceede80e219310d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cceede80e219310d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $cceede80e219310d$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $cceede80e219310d$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cceede80e219310d$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $cceede80e219310d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $cceede80e219310d$var$_connectCalled = /*#__PURE__*/ new WeakMap();
var $cceede80e219310d$var$_handleNetworkInformationChange = /*#__PURE__*/ new WeakMap();
var $cceede80e219310d$var$_initialNetworkInformationType = /*#__PURE__*/ new WeakMap();
var $cceede80e219310d$var$_networkInformation = /*#__PURE__*/ new WeakMap();
var $cceede80e219310d$var$WebSocketClientWithNetworkInformation = /*#__PURE__*/ function(_WebSocketClient) {
    (0, $cceede80e219310d$var$_inherits2["default"])(WebSocketClientWithNetworkInformation, _WebSocketClient);
    var _super = $cceede80e219310d$var$_createSuper(WebSocketClientWithNetworkInformation);
    function WebSocketClientWithNetworkInformation(_ref) {
        var _this;
        var disconnectionHandler = _ref.disconnectionHandler, networkInformation = _ref.networkInformation, requestHandler = _ref.requestHandler, url = _ref.url;
        (0, $cceede80e219310d$var$_classCallCheck2["default"])(this, WebSocketClientWithNetworkInformation);
        _this = _super.call(this, {
            disconnectionHandler: disconnectionHandler,
            requestHandler: requestHandler,
            url: url
        });
        $cceede80e219310d$var$_connectCalled.set((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: false
        });
        $cceede80e219310d$var$_handleNetworkInformationChange.set((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: function value() {
                return (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), $cceede80e219310d$var$_initialNetworkInformationType) === (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), $cceede80e219310d$var$_networkInformation).type || _this.disconnect();
            }
        });
        $cceede80e219310d$var$_initialNetworkInformationType.set((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: void 0
        });
        $cceede80e219310d$var$_networkInformation.set((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: void 0
        });
        (0, $cceede80e219310d$var$_classPrivateFieldSet2["default"])((0, $cceede80e219310d$var$_assertThisInitialized2["default"])(_this), $cceede80e219310d$var$_networkInformation, networkInformation);
        return _this;
    }
    // According to W3C Network Information API, https://wicg.github.io/netinfo/#handling-changes-to-the-underlying-connection.
    // NetworkInformation.onChange event will be fired on any changes to: `downlinkMax`, `type`, `downlink`, or `rtt`.
    (0, $cceede80e219310d$var$_createClass2["default"])(WebSocketClientWithNetworkInformation, [
        {
            key: "connect",
            value: // TODO: Better, the `NetworkInformation` instance should be passed to `BrowserWebSocketClient` -> `BrowserWebSocket`.
            //       `BrowserWebSocket` is where it creates `WebSocket` object.
            //       The `NetworkInformation` instance should accompany `WebSocket` and forcibly close it on abort.
            //       Maybe `botframework-streaming` should accept ponyfills.
            function connect() {
                if ((0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_connectCalled)) {
                    console.warn('botframework-directlinejs: connect() can only be called once.');
                    return Promise.resolve();
                }
                (0, $cceede80e219310d$var$_classPrivateFieldSet2["default"])(this, $cceede80e219310d$var$_connectCalled, true);
                if ((0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_networkInformation)) {
                    var _classPrivateFieldGet2 = (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_networkInformation), initialType = _classPrivateFieldGet2.type;
                    (0, $cceede80e219310d$var$_classPrivateFieldSet2["default"])(this, $cceede80e219310d$var$_initialNetworkInformationType, initialType);
                    if (initialType === 'none') {
                        console.warn('botframework-directlinejs: Failed to connect while offline.');
                        return Promise.reject(new Error('botframework-directlinejs: Failed to connect while offline.'));
                    }
                    (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_networkInformation).addEventListener('change', (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_handleNetworkInformationChange));
                }
                return (0, $cceede80e219310d$var$_get2["default"])((0, $cceede80e219310d$var$_getPrototypeOf2["default"])(WebSocketClientWithNetworkInformation.prototype), "connect", this).call(this);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _classPrivateFieldGet3;
                (_classPrivateFieldGet3 = (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_networkInformation)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.removeEventListener('change', (0, $cceede80e219310d$var$_classPrivateFieldGet4["default"])(this, $cceede80e219310d$var$_handleNetworkInformationChange));
                (0, $cceede80e219310d$var$_get2["default"])((0, $cceede80e219310d$var$_getPrototypeOf2["default"])(WebSocketClientWithNetworkInformation.prototype), "disconnect", this).call(this);
            }
        }
    ]);
    return WebSocketClientWithNetworkInformation;
}($h1R35.WebSocketClient);
module.exports["default"] = $cceede80e219310d$var$WebSocketClientWithNetworkInformation;

});
parcelRegister("4TXYE", function(module, exports) {
function $391ad2aff5bf3dfa$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $391ad2aff5bf3dfa$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7qWbB", function(module, exports) {

var $7vz4e = parcelRequire("7vz4e");
function $569818aada0d2d0e$var$_get() {
    return module.exports = $569818aada0d2d0e$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $7vz4e(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $569818aada0d2d0e$var$_get.apply(null, arguments);
}
module.exports = $569818aada0d2d0e$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7vz4e", function(module, exports) {

var $lCnis = parcelRequire("lCnis");
function $5776a147afe85eb0$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $lCnis(t)););
    return t;
}
module.exports = $5776a147afe85eb0$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lCnis", function(module, exports) {
function $fbcf37ccc36f024a$var$_getPrototypeOf(t) {
    return module.exports = $fbcf37ccc36f024a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fbcf37ccc36f024a$var$_getPrototypeOf(t);
}
module.exports = $fbcf37ccc36f024a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hzsSd", function(module, exports) {

var $2lzEH = parcelRequire("2lzEH");
function $ccac1a3751cb02d2$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $2lzEH(t, e);
}
module.exports = $ccac1a3751cb02d2$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2lzEH", function(module, exports) {
function $1b593360aea6747b$var$_setPrototypeOf(t, e) {
    return module.exports = $1b593360aea6747b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1b593360aea6747b$var$_setPrototypeOf(t, e);
}
module.exports = $1b593360aea6747b$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ktPRR", function(module, exports) {

var $kl7l1 = parcelRequire("kl7l1");
var $ee8ebff0a4dad4a8$var$_typeof = $kl7l1.default;

var $4TXYE = parcelRequire("4TXYE");
function $ee8ebff0a4dad4a8$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ee8ebff0a4dad4a8$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4TXYE(t);
}
module.exports = $ee8ebff0a4dad4a8$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("gDyAX", function(module, exports) {

$parcel$export(module.exports, "LegacyDirectLineActivityType", () => $054a5858f11f4e53$export$bbd16b9b30e132b3);
$parcel$export(module.exports, "LegacyDirectLineStatus", () => $054a5858f11f4e53$export$741b3b19a0ba7556);
var $054a5858f11f4e53$export$bbd16b9b30e132b3 = /*#__PURE__*/ function(LegacyDirectLineActivityType) {
    LegacyDirectLineActivityType["UNKNOWN"] = "DIRECT_LINE/UNKNOWN";
    LegacyDirectLineActivityType["INCOMING_ACTIVITY"] = "DIRECT_LINE/INCOMING_ACTIVITY";
    LegacyDirectLineActivityType["POST_ACTIVITY"] = "DIRECT_LINE/POST_ACTIVITY";
    LegacyDirectLineActivityType["POST_ACTIVITY_FULFILLED"] = "DIRECT_LINE/POST_ACTIVITY_FULFILLED";
    LegacyDirectLineActivityType["SEND_MESSAGE"] = "WEB_CHAT/SEND_MESSAGE";
    LegacyDirectLineActivityType["SEND_EVENT"] = "WEB_CHAT/SEND_EVENT";
    LegacyDirectLineActivityType["TYPING"] = "WEB_CHAT/EMIT_TYPING_INDICATOR";
    LegacyDirectLineActivityType["MARK"] = "WEB_CHAT/MARK_ACTIVITY";
    LegacyDirectLineActivityType["SET_LANGUAGE"] = "WEB_CHAT/SET_LANGUAGE";
    return LegacyDirectLineActivityType;
}($054a5858f11f4e53$export$bbd16b9b30e132b3 || {});
const $054a5858f11f4e53$export$741b3b19a0ba7556 = {
    0: 'DIRECT_LINE/CONNECT',
    1: 'DIRECT_LINE/CONNECT_PENDING',
    2: 'DIRECT_LINE/CONNECT_FULFILLED',
    3: 'DIRECT_LINE/EXPIRED_TOKEN',
    4: 'DIRECT_LINE/CONNECT_FAILED',
    5: 'DIRECT_LINE/CONNECT_ENDED'
};

});

parcelRegister("6SpST", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24ee22498b11cc0$export$2e2bcd8739ae039);
const $e24ee22498b11cc0$var$activityMiddleware = (activity)=>{
    if (activity?.type === 'message' && activity.attachments?.length && activity.attachments[0].contentType === 'application/vnd.davi.retorik.card.suggestedaction' && activity.attachments[0].content?.title?.indexOf(activity.text) > -1) {
        // Hack for Suggested Action : Only show text in card, not in message
        activity.text = '';
        activity.htmlText = '';
    }
    return activity;
};
var $e24ee22498b11cc0$export$2e2bcd8739ae039 = $e24ee22498b11cc0$var$activityMiddleware;

});

parcelRegister("3RB0m", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@davi-ai/retorik-framework\",\"version\":\"3.2.6\",\"description\":\"Retorik Framework package\",\"author\":\"DAVI\",\"license\":\"MIT\",\"repository\":\"none\",\"main\":\"dist/index.js\",\"module\":\"dist/index.modern.js\",\"types\":\"dist/index.d.ts\",\"source\":\"src/index.tsx\",\"standalone\":\"standalone/index.js\",\"targets\":{\"standalone\":{\"context\":\"browser\",\"outputFormat\":\"esmodule\",\"distDir\":\"standalone\"},\"module\":{\"context\":\"browser\",\"outputFormat\":\"esmodule\",\"distDir\":\"dist\"}},\"engines\":{\"node\":\">=10\"},\"scripts\":{\"build\":\"parcel build\",\"start\":\"parcel watch\",\"test\":\"jest --env=jsdom --reporters=jest-junit\",\"test-console\":\"jest --env=jsdom\",\"test-update-snapshots\":\"jest --env=jsdom --updateSnapshot\",\"test-coverage-console\":\"jest --env=jsdom --reporters=jest-junit --coverage\",\"test-coverage\":\"jest --env=jsdom --reporters=jest-junit --coverage --coverageReporters=cobertura\",\"report\":\"npx parcel build src/index.tsx --reporter @parcel/reporter-bundle-analyzer\",\"credentials\":\"vsts-npm-auth -config .npmrc\"},\"peerDependencies\":{\"react\":\"18.3.1\",\"react-dom\":\"18.3.1\"},\"devDependencies\":{\"@babel/core\":\"^7.19.1\",\"@babel/plugin-proposal-decorators\":\"^7.24.7\",\"@babel/plugin-proposal-private-property-in-object\":\"^7.21.11\",\"@babel/preset-env\":\"^7.25.4\",\"@babel/preset-react\":\"^7.24.7\",\"@babel/preset-typescript\":\"^7.24.7\",\"@babel/runtime\":\"^7.23.8\",\"@parcel/packager-ts\":\"^2.13.2\",\"@parcel/reporter-bundle-analyzer\":\"^2.13.2\",\"@parcel/reporter-sourcemap-visualiser\":\"^2.13.2\",\"@parcel/transformer-inline-string\":\"^2.13.2\",\"@parcel/transformer-typescript-types\":\"^2.13.2\",\"@parcel/validator-eslint\":\"^2.13.2\",\"@parcel/validator-typescript\":\"^2.13.2\",\"@testing-library/dom\":\"^10.4.0\",\"@testing-library/jest-dom\":\"6.5.0\",\"@testing-library/react\":\"16.0.1\",\"@testing-library/react-hooks\":\"8.0.1\",\"@testing-library/user-event\":\"14.5.2\",\"@types/jest\":\"^27.5.1\",\"@types/leaflet\":\"^1.8.0\",\"@types/node\":\"^12.12.38\",\"@types/react\":\"18.3.12\",\"@types/react-dom\":\"18.3.1\",\"@types/testing-library__jest-dom\":\"^5.14.5\",\"@types/testing-library__react\":\"latest\",\"@typescript-eslint/eslint-plugin\":\"^8.19.0\",\"@typescript-eslint/parser\":\"^8.19.0\",\"autoprefixer\":\"^10.4.7\",\"babel-eslint\":\"^10.0.3\",\"babel-jest\":\"^29.7.0\",\"babel-loader\":\"^8.2.5\",\"buffer\":\"^5.7.1\",\"canvas\":\"^2.9.0\",\"cross-env\":\"^7.0.2\",\"crypto-browserify\":\"^3.12.0\",\"eslint\":\"^9.16.0\",\"eslint-config-prettier\":\"^9.1.0\",\"eslint-config-standard\":\"^17.1.0\",\"eslint-config-standard-react\":\"^13.0.0\",\"eslint-plugin-import\":\"^2.31.0\",\"eslint-plugin-node\":\"^11.1.0\",\"eslint-plugin-prettier\":\"^5.2.1\",\"eslint-plugin-promise\":\"^7.2.1\",\"eslint-plugin-react\":\"^7.37.2\",\"https-browserify\":\"^1.0.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"jest-junit\":\"16.0.0\",\"npm-run-all\":\"^4.1.5\",\"parcel\":\"^2.13.2\",\"postcss\":\"^8.4.14\",\"postcss-url\":\"^10.1.3\",\"prettier\":\"^2.0.4\",\"process\":\"^0.11.10\",\"punycode\":\"^1.4.1\",\"querystring-es3\":\"^0.2.1\",\"react\":\"^18\",\"react-docgen-typescript-plugin\":\"^1.0.5\",\"react-dom\":\"18.3.1\",\"react-test-renderer\":\"^18.3.1\",\"resize-observer-polyfill\":\"^1.5.1\",\"stream-browserify\":\"^3.0.0\",\"stream-http\":\"^3.2.0\",\"string_decoder\":\"^1.3.0\",\"tailwindcss\":\"^3.1.0\",\"typescript\":\"5.3.2\",\"url\":\"^0.11.0\",\"util\":\"^0.12.4\"},\"files\":[\"dist\"],\"dependencies\":{\"@davi-ai/body-engine-sprite\":\"3.0.0\",\"@davi-ai/react-bodyengine-three\":\"^1.0.8\",\"@davi-ai/retorik-weather\":\"2.0.0\",\"@davi-ai/speechmarkdown-davi-js\":\"2.0.1\",\"@davi-ai/web-speech-cognitive-services-davi\":\"2.1.0\",\"@lottiefiles/react-lottie-player\":\"^3.4.1\",\"@opentelemetry/api\":\"^1.9.0\",\"@opentelemetry/exporter-trace-otlp-http\":\"^0.200.0\",\"@opentelemetry/instrumentation\":\"^0.200.0\",\"@opentelemetry/instrumentation-document-load\":\"^0.45.0\",\"@opentelemetry/instrumentation-fetch\":\"^0.200.0\",\"@opentelemetry/resources\":\"^2.0.0\",\"@opentelemetry/sdk-trace-web\":\"^2.0.0\",\"@opentelemetry/semantic-conventions\":\"^1.32.0\",\"@react-spring/types\":\"^9.7.3\",\"@react-spring/web\":\"^9.7.3\",\"@swc/helpers\":\"^0.5.0\",\"@types/geojson\":\"^7946.0.10\",\"@types/jsdom\":\"^16.2.14\",\"@use-gesture/react\":\"^10.2.15\",\"adaptivecards\":\"3.0.1\",\"botframework-directlinejs\":\"^0.15.5\",\"classnames\":\"^2.3.1\",\"detect-gpu\":\"^5.0.70\",\"leaflet\":\"^1.9.2\",\"markdown-it\":\"14.1.0\",\"pdfjs-dist\":\"3.11.174\",\"postcss-copy\":\"^7.1.0\",\"qrcode\":\"^1.5.1\",\"react-device-detect\":\"^2.2.3\",\"react-error-boundary\":\"^4.0.10\",\"react-leaflet\":\"^4.1.0\",\"react-pdf\":\"7.7.1\",\"react-shadow\":\"^20.5.0\",\"swiper\":\"^8.4.5\",\"zustand\":\"^5.0.3\"},\"overrides\":{\"@davi-ai/web-speech-cognitive-services-davi\":\"$@davi-ai/web-speech-cognitive-services-davi\",\"zustand\":\"$zustand\"},\"@parcel/resolver-default\":{\"packageExports\":true}}");

});



parcelRegister("kucVP", function(module, exports) {

$parcel$export(module.exports, "allowedLocalesForMicrosoftWithVisemes", () => $03d227dac7928361$export$c8eb837c49d83ee5);
$parcel$export(module.exports, "allowedLocalesForMicrosoftWithoutVisemes", () => $03d227dac7928361$export$9a6594216df9de73);
$parcel$export(module.exports, "currentTranslatedLocales", () => $03d227dac7928361$export$5faa65939df15b6b);
const $03d227dac7928361$export$c8eb837c49d83ee5 = [
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE',
    'bg-BG',
    'ca-ES',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'de-AT',
    'de-CH',
    'el-GR',
    'en-US',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-KE',
    'en-NG',
    'en-NZ',
    'en-PH',
    'en-SG',
    'en-TZ',
    'en-ZA',
    'es-ES',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-CU',
    'es-DO',
    'es-EC',
    'es-GQ',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-PY',
    'es-SV',
    'es-US',
    'es-UY',
    'es-VE',
    'fi-FI',
    'fr-FR',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'gu-IN',
    'he-IL',
    'hi-IN',
    'hr-HR',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'mr-IN',
    'ms-MY',
    'nb-NO',
    'nl-NL',
    'nl-BE',
    'pl-PL',
    'pt-PT',
    'pt-BR',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sl-SI',
    'sv-SE',
    'sw-TZ',
    'ta-IN',
    'ta-LK',
    'ta-MY',
    'ta-SG',
    'te-IN',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'ur-PK',
    'ur-IN',
    'vi-VN',
    'zh-CN',
    'zh-HK',
    'zh-TW'
];
const $03d227dac7928361$export$9a6594216df9de73 = [
    'af-ZA',
    'am-ET',
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE',
    'as-IN',
    'az-AZ',
    'bg-BG',
    'bn-BD',
    'bn-IN',
    'bs-BA',
    'ca-ES',
    'cs-CZ',
    'cy-GB',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'el-GR',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-KE',
    'en-NG',
    'en-NZ',
    'en-PH',
    'en-SG',
    'en-TZ',
    'en-US',
    'en-ZA',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-CU',
    'es-DO',
    'es-EC',
    'es-ES',
    'es-GQ',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-PY',
    'es-SV',
    'es-US',
    'es-UY',
    'es-VE',
    'et-EE',
    'eu-ES',
    'fa-IR',
    'fi-FI',
    'fil-PH',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'ga-IE',
    'gl-ES',
    'gu-IN',
    'he-IL',
    'hi-IN',
    'hr-HR',
    'hu-HU',
    'hy-AM',
    'id-ID',
    'is-IS',
    'it-IT',
    'iu-CANS-CA',
    'iu-LATN-CA',
    'ja-JP',
    'jv-ID',
    'ka-GE',
    'kk-KZ',
    'km-KH',
    'kn-IN',
    'ko-KR',
    'lo-LA',
    'lt-LT',
    'lv-LV',
    'mk-MK',
    'ml-IN',
    'mn-MN',
    'mr-IN',
    'ms-MY',
    'mt-MT',
    'my-MM',
    'nb-NO',
    'ne-NP',
    'nl-BE',
    'nl-NL',
    'or-IN',
    'pa-IN',
    'pl-PL',
    'ps-AF',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'si-LK',
    'sk-SK',
    'sl-SI',
    'so-SO',
    'sq-AL',
    'sr-LATN-RS',
    'sr-RS',
    'su-ID',
    'sv-SE',
    'sw-KE',
    'sw-TZ',
    'ta-IN',
    'ta-LK',
    'ta-MY',
    'ta-SG',
    'te-IN',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'ur-IN',
    'ur-PK',
    'uz-UZ',
    'vi-VN',
    'wuu-CN',
    'yue-CN',
    'zh-CN',
    'zh-CN-GUANGXI',
    'zh-CN-henan',
    'zh-CN-liaoning',
    'zh-CN-shaanxi',
    'zh-CN-shandong',
    'zh-CN-sichuan',
    'zh-HK',
    'zh-TW',
    'zu-ZA'
];
const $03d227dac7928361$export$5faa65939df15b6b = [
    'ar-AE',
    'ar-EG',
    'ar-SA',
    'ca-ES',
    'cs-CZ',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-US',
    'es-ES',
    'es-MX',
    'fi-FI',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'hi-IN',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NO',
    'nl-BE',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ru-RU',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'zh-CN',
    'zh-HK',
    'zh-TW'
];

});


parcelRegister("2hYPB", function(module, exports) {

$parcel$export(module.exports, "ar_AE", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("egi2Q")))));
$parcel$export(module.exports, "ar_EG", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("rnsVA")))));
$parcel$export(module.exports, "ar_SA", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("hFld1")))));
$parcel$export(module.exports, "ca_ES", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("l1HSk")))));
$parcel$export(module.exports, "cs_CZ", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cMKRm")))));
$parcel$export(module.exports, "da_DK", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("54G60")))));
$parcel$export(module.exports, "de_AT", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cHckr")))));
$parcel$export(module.exports, "de_CH", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("4pbjv")))));
$parcel$export(module.exports, "de_DE", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("86Qd9")))));
$parcel$export(module.exports, "en_CA", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gnGGd")))));
$parcel$export(module.exports, "en_GB", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fOTQw")))));
$parcel$export(module.exports, "en_HK", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6wSBz")))));
$parcel$export(module.exports, "en_IE", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kRuZt")))));
$parcel$export(module.exports, "en_IN", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9tktv")))));
$parcel$export(module.exports, "en_US", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gEZZY")))));
$parcel$export(module.exports, "es_ES", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cs0Qr")))));
$parcel$export(module.exports, "es_MX", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("ecRvl")))));
$parcel$export(module.exports, "fi_FI", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gw5Pl")))));
$parcel$export(module.exports, "fr_BE", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1ZXrl")))));
$parcel$export(module.exports, "fr_CA", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("476o5")))));
$parcel$export(module.exports, "fr_CH", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8mOEg")))));
$parcel$export(module.exports, "fr_FR", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("72eSH")))));
$parcel$export(module.exports, "hi_IN", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("90eWJ")))));
$parcel$export(module.exports, "hu_HU", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gUwFA")))));
$parcel$export(module.exports, "id_ID", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("4oHlA")))));
$parcel$export(module.exports, "it_IT", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("lHWsA")))));
$parcel$export(module.exports, "ja_JP", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("j2Gzi")))));
$parcel$export(module.exports, "ko_KR", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("by8FM")))));
$parcel$export(module.exports, "nb_NO", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9xRuv")))));
$parcel$export(module.exports, "nl_BE", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cv59j")))));
$parcel$export(module.exports, "nl_NL", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8eBLN")))));
$parcel$export(module.exports, "pl_PL", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cXPQk")))));
$parcel$export(module.exports, "pt_BR", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("f6Gk7")))));
$parcel$export(module.exports, "pt_PT", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fVqcA")))));
$parcel$export(module.exports, "ru_RU", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("csgXy")))));
$parcel$export(module.exports, "sv_SE", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("baqvr")))));
$parcel$export(module.exports, "th_TH", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("4V31a")))));
$parcel$export(module.exports, "tr_TR", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aIGYp")))));
$parcel$export(module.exports, "zh_CN", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5ufOy")))));
$parcel$export(module.exports, "zh_HK", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jsptP")))));
$parcel$export(module.exports, "zh_TW", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1yVKr")))));

var $egi2Q = parcelRequire("egi2Q");

var $rnsVA = parcelRequire("rnsVA");

var $hFld1 = parcelRequire("hFld1");

var $l1HSk = parcelRequire("l1HSk");

var $cMKRm = parcelRequire("cMKRm");

var $54G60 = parcelRequire("54G60");

var $cHckr = parcelRequire("cHckr");

var $4pbjv = parcelRequire("4pbjv");

var $86Qd9 = parcelRequire("86Qd9");

var $gnGGd = parcelRequire("gnGGd");

var $fOTQw = parcelRequire("fOTQw");

var $6wSBz = parcelRequire("6wSBz");

var $kRuZt = parcelRequire("kRuZt");

var $9tktv = parcelRequire("9tktv");

var $gEZZY = parcelRequire("gEZZY");

var $cs0Qr = parcelRequire("cs0Qr");

var $ecRvl = parcelRequire("ecRvl");

var $gw5Pl = parcelRequire("gw5Pl");

var $1ZXrl = parcelRequire("1ZXrl");

var $476o5 = parcelRequire("476o5");

var $8mOEg = parcelRequire("8mOEg");

var $72eSH = parcelRequire("72eSH");

var $90eWJ = parcelRequire("90eWJ");

var $gUwFA = parcelRequire("gUwFA");

var $4oHlA = parcelRequire("4oHlA");

var $lHWsA = parcelRequire("lHWsA");

var $j2Gzi = parcelRequire("j2Gzi");

var $by8FM = parcelRequire("by8FM");

var $9xRuv = parcelRequire("9xRuv");

var $cv59j = parcelRequire("cv59j");

var $8eBLN = parcelRequire("8eBLN");

var $cXPQk = parcelRequire("cXPQk");

var $f6Gk7 = parcelRequire("f6Gk7");

var $fVqcA = parcelRequire("fVqcA");

var $csgXy = parcelRequire("csgXy");

var $baqvr = parcelRequire("baqvr");

var $4V31a = parcelRequire("4V31a");

var $aIGYp = parcelRequire("aIGYp");

var $5ufOy = parcelRequire("5ufOy");

var $jsptP = parcelRequire("jsptP");

var $1yVKr = parcelRequire("1yVKr");

});
parcelRegister("egi2Q", function(module, exports) {
module.exports = JSON.parse('{"1":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","2":"\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629","3":"\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633","4":"\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626","1000":"\u062A\u0627\u0631\u064A\u062E\u064A","1001":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","common":{"all":"\u0627\u0644\u062C\u0645\u064A\u0639","back":"\u062E\u0644\u0641","close":"\u0627\u063A\u0644\u0627\u0642","continue":"\u064A\u0643\u0645\u0644","download":"\u062A\u062D\u0645\u064A\u0644","downloadsheet":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","downloadsheetmobile":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","filter":"\u0645\u0646\u0642\u064A","history":"\u062A\u0627\u0631\u064A\u062E\u064A","knowmore":"\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F","lang":"\u0627\u0644\u0644\u063A\u0627\u062A","menu":"\u0627\u0644\u0642\u0627\u0626\u0645\u0629","mode":"\u0645\u0648\u0636\u0629","needhelp":"\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F","parameters":"\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A","print":"\u0645\u0637\u0628\u0639\u0629","printsheet":"\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","result":"\u0646\u062A\u064A\u062C\u0629","results":"\u0646\u062A\u0627\u0626\u062C","singleLang":"\u0644\u063A\u0629","sound":"\u0647\u0627","submit":"\u064A\u064F\u0642\u062F\u0651\u0650\u0645","subtitle":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A","tutorial":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","validate":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"},"emergency":{"samu":".S.A.M.U","police":"\u0634\u0631\u0637\u0629","firefighter":"\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621","general":"\u0639\u0627\u0645","citypolice":"\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629","hospital":"\u0645\u0633\u062A\u0634\u0641\u0649","homeless":"\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)","poison":"\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645","emergency":"\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"},"error":{"title":"\u062D\u062F\u062B \u062E\u0637\u0623","button":"\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"},"history":{"title":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"},"inputs":{"choose":"\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629"},"language":{"change":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629","select":"\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"},"link":{"buttontext":"\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629","goto":"\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","click":"\u0627\u0646\u0642\u0631 \u0647\u0646\u0627","scanQR":"\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629","scanQRTile":"\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"},"loader":{"loader":{"optimal":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","classic":"\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C","vocal":"\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.","text":"\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."},"modes":{"vocal":"\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A","text":"\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"},"loaderValidation":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","locale":"\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629","supported":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629","addressdata":"\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"},"menu":{"message":"\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643","backconversation":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","answer":" \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"},"mobileLandscapePreventer":{"firstline":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","secondline":"\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"},"news":{"warningtext":"\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643","live":"\u0645\u0628\u0627\u0634\u0631","continuous":"\u0644\u0646\u0643\u0645\u0644"},"poi":{"comment":"\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644","route":"\u0637\u0631\u064A\u0642","nodata":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643","openinghours":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","prices":"\u0627\u0644\u0623\u0633\u0639\u0627\u0631","paymentmethods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","numberofplaces":"\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646","openroutemobile":"\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","FoodEstablishment":"\u0623\u064A\u0646 \u062A\u0623\u0643\u0644","LodgingBusiness":"\u0623\u064A\u0646 \u062A\u0646\u0627\u0645","TouristDestination":"\u0645\u0627\u0630\u0627 \u062A\u0631\u0649","TouristAttraction":"\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647","Product":"\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629","Service":"\u062E\u062F\u0645\u0627\u062A","Event":"\u0627\u0644\u0623\u062D\u062F\u0627\u062B","City":"\u0645\u062F\u0646","Wine":"\u0627\u0644\u0646\u0628\u064A\u0630"},"suggestion":{"consult":"\u0627\u0644\u062F\u0641\u0639","thetutorial":"\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"},"template":{"reset":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639","showresults":"\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C","suggestiontitle":"\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B","reminder":"\u0644\u0627 \u062A\u0646\u0633\u0649 \\n \u0623\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643."},"anghello":{"listening":"\u0623\u0646\u062A \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631\u0643\u060C \u0623\u0646\u0627 \u0623\u0633\u062A\u0645\u0639...","correct":"\u062A\u0635\u062D\u064A\u062D","dontknow":"\u0644\u0627 \u0623\u0639\u0631\u0641"},"microphone":{"allow":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631.","rejected":"\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.","instructions":"\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.","listening":"\u0623\u0646\u0627 \u0623\u0633\u0645\u0639\u0643","trigger":"\u0627\u0636\u063A\u0637 \u0623\u0648 \u0642\u0644","triggerwithoutname":"\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u062D\u062F\u062B"}}');

});

parcelRegister("rnsVA", function(module, exports) {
module.exports = JSON.parse('{"1":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","2":"\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629","3":"\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633","4":"\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626","1000":"\u062A\u0627\u0631\u064A\u062E\u064A","1001":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","common":{"all":"\u0627\u0644\u062C\u0645\u064A\u0639","back":"\u062E\u0644\u0641","close":"\u0627\u063A\u0644\u0627\u0642","continue":"\u064A\u0643\u0645\u0644","download":"\u062A\u062D\u0645\u064A\u0644","downloadsheet":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","downloadsheetmobile":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","filter":"\u0645\u0646\u0642\u064A","history":"\u062A\u0627\u0631\u064A\u062E\u064A","knowmore":"\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F","lang":"\u0627\u0644\u0644\u063A\u0627\u062A","menu":"\u0627\u0644\u0642\u0627\u0626\u0645\u0629","mode":"\u0645\u0648\u0636\u0629","needhelp":"\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F","parameters":"\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A","print":"\u0645\u0637\u0628\u0639\u0629","printsheet":"\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","result":"\u0646\u062A\u064A\u062C\u0629","results":"\u0646\u062A\u0627\u0626\u062C","singleLang":"\u0644\u063A\u0629","sound":"\u0647\u0627","submit":"\u064A\u064F\u0642\u062F\u0651\u0650\u0645","subtitle":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A","tutorial":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","validate":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"},"emergency":{"samu":".S.A.M.U","police":"\u0634\u0631\u0637\u0629","firefighter":"\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621","general":"\u0639\u0627\u0645","citypolice":"\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629","hospital":"\u0645\u0633\u062A\u0634\u0641\u0649","homeless":"\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)","poison":"\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645","emergency":"\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"},"error":{"title":"\u062D\u062F\u062B \u062E\u0637\u0623","button":"\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"},"history":{"title":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"},"inputs":{"choose":"\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629"},"language":{"change":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629","select":"\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"},"link":{"buttontext":"\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629","goto":"\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","click":"\u0627\u0646\u0642\u0631 \u0647\u0646\u0627","scanQR":"\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629","scanQRTile":"\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"},"loader":{"loader":{"optimal":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","classic":"\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C","vocal":"\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.","text":"\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."},"modes":{"vocal":"\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A","text":"\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"},"loaderValidation":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","locale":"\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629","supported":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629","addressdata":"\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"},"menu":{"message":"\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643","backconversation":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","answer":" \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"},"mobileLandscapePreventer":{"firstline":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","secondline":"\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"},"news":{"warningtext":"\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643","live":"\u0645\u0628\u0627\u0634\u0631","continuous":"\u0644\u0646\u0643\u0645\u0644"},"poi":{"comment":"\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644","route":"\u0637\u0631\u064A\u0642","nodata":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643","openinghours":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","prices":"\u0627\u0644\u0623\u0633\u0639\u0627\u0631","paymentmethods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","numberofplaces":"\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646","openroutemobile":"\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","FoodEstablishment":"\u0623\u064A\u0646 \u062A\u0623\u0643\u0644","LodgingBusiness":"\u0623\u064A\u0646 \u062A\u0646\u0627\u0645","TouristDestination":"\u0645\u0627\u0630\u0627 \u062A\u0631\u0649","TouristAttraction":"\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647","Product":"\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629","Service":"\u062E\u062F\u0645\u0627\u062A","Event":"\u0627\u0644\u0623\u062D\u062F\u0627\u062B","City":"\u0645\u062F\u0646","Wine":"\u0627\u0644\u0646\u0628\u064A\u0630"},"suggestion":{"consult":"\u0627\u0644\u062F\u0641\u0639","thetutorial":"\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"},"template":{"reset":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639","showresults":"\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C","suggestiontitle":"\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B","reminder":"\u0644\u0627 \u062A\u0646\u0633\u0649 \\n \u0623\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643."},"anghello":{"listening":"\u0623\u0646\u062A \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631\u0643\u060C \u0623\u0646\u0627 \u0623\u0633\u062A\u0645\u0639...","correct":"\u062A\u0635\u062D\u064A\u062D","dontknow":"\u0644\u0627 \u0623\u0639\u0631\u0641"},"microphone":{"allow":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631.","rejected":"\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.","instructions":"\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.","listening":"\u0623\u0646\u0627 \u0623\u0633\u0645\u0639\u0643","trigger":"\u0627\u0636\u063A\u0637 \u0623\u0648 \u0642\u0644","triggerwithoutname":"\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u062D\u062F\u062B"}}');

});

parcelRegister("hFld1", function(module, exports) {
module.exports = JSON.parse('{"1":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","2":"\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629","3":"\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633","4":"\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626","1000":"\u062A\u0627\u0631\u064A\u062E\u064A","1001":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","common":{"all":"\u0627\u0644\u062C\u0645\u064A\u0639","back":"\u062E\u0644\u0641","close":"\u0627\u063A\u0644\u0627\u0642","continue":"\u064A\u0643\u0645\u0644","download":"\u062A\u062D\u0645\u064A\u0644","downloadsheet":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","downloadsheetmobile":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","filter":"\u0645\u0646\u0642\u064A","history":"\u062A\u0627\u0631\u064A\u062E\u064A","knowmore":"\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F","lang":"\u0627\u0644\u0644\u063A\u0627\u062A","menu":"\u0627\u0644\u0642\u0627\u0626\u0645\u0629","mode":"\u0645\u0648\u0636\u0629","needhelp":"\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F","parameters":"\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A","print":"\u0645\u0637\u0628\u0639\u0629","printsheet":"\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","result":"\u0646\u062A\u064A\u062C\u0629","results":"\u0646\u062A\u0627\u0626\u062C","singleLang":"\u0644\u063A\u0629","sound":"\u0647\u0627","submit":"\u064A\u064F\u0642\u062F\u0651\u0650\u0645","subtitle":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A","tutorial":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","validate":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"},"emergency":{"samu":".S.A.M.U","police":"\u0634\u0631\u0637\u0629","firefighter":"\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621","general":"\u0639\u0627\u0645","citypolice":"\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629","hospital":"\u0645\u0633\u062A\u0634\u0641\u0649","homeless":"\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)","poison":"\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645","emergency":"\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"},"error":{"title":"\u062D\u062F\u062B \u062E\u0637\u0623","button":"\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"},"history":{"title":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"},"inputs":{"choose":"\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629"},"language":{"change":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629","select":"\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"},"link":{"buttontext":"\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629","goto":"\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","click":"\u0627\u0646\u0642\u0631 \u0647\u0646\u0627","scanQR":"\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629","scanQRTile":"\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"},"loader":{"loader":{"optimal":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","classic":"\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C","vocal":"\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.","text":"\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."},"modes":{"vocal":"\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A","text":"\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"},"loaderValidation":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","locale":"\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629","supported":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629","addressdata":"\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"},"menu":{"message":"\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643","backconversation":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","answer":" \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"},"mobileLandscapePreventer":{"firstline":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","secondline":"\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"},"news":{"warningtext":"\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643","live":"\u0645\u0628\u0627\u0634\u0631","continuous":"\u0644\u0646\u0643\u0645\u0644"},"poi":{"comment":"\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644","route":"\u0637\u0631\u064A\u0642","nodata":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643","openinghours":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","prices":"\u0627\u0644\u0623\u0633\u0639\u0627\u0631","paymentmethods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","numberofplaces":"\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646","openroutemobile":"\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","FoodEstablishment":"\u0623\u064A\u0646 \u062A\u0623\u0643\u0644","LodgingBusiness":"\u0623\u064A\u0646 \u062A\u0646\u0627\u0645","TouristDestination":"\u0645\u0627\u0630\u0627 \u062A\u0631\u0649","TouristAttraction":"\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647","Product":"\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629","Service":"\u062E\u062F\u0645\u0627\u062A","Event":"\u0627\u0644\u0623\u062D\u062F\u0627\u062B","City":"\u0645\u062F\u0646","Wine":"\u0627\u0644\u0646\u0628\u064A\u0630"},"suggestion":{"consult":"\u0627\u0644\u062F\u0641\u0639","thetutorial":"\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"},"template":{"reset":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639","showresults":"\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C","suggestiontitle":"\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B","reminder":"\u0644\u0627 \u062A\u0646\u0633\u0649 \\n \u0623\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643."},"anghello":{"listening":"\u0623\u0646\u062A \u0623\u0645\u0627\u0645\u064A\u060C \u0623\u0646\u0627 \u0623\u0633\u062A\u0645\u0639...","correct":"\u062A\u0635\u062D\u064A\u062D","dontknow":"\u0644\u0627 \u0623\u0639\u0631\u0641"},"microphone":{"allow":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631.","rejected":"\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.","instructions":"\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u062A\u0635\u0641\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.","listening":"\u0623\u0646\u0627 \u0623\u0633\u0645\u0639\u0643","trigger":"\u0627\u0636\u063A\u0637 \u0623\u0648 \u0642\u0644","triggerwithoutname":"\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u062D\u062F\u062B"}}');

});

parcelRegister("l1HSk", function(module, exports) {
module.exports = JSON.parse('{"1":"p\xe0gina d\'inici","2":"canal de not\xedcies en directe","3":"informe del temps","4":"N\xfameros d\'emerg\xe8ncia","1000":"hist\xf2ric","1001":"tutorial","common":{"all":"tots","back":"esquena","close":"tanca","continue":"continua","download":"descarregar","downloadsheet":"descarregar aquest full","downloadsheetmobile":"descarregueu aquest full al tel\xe8fon intel\xb7ligent","filter":"filtre","history":"hist\xf2ric","knowmore":"M\xe9s informaci\xf3","lang":"idiomes","menu":"men\xfa","mode":"moda","needhelp":"necessitar ajuda?","parameters":"configuracions","print":"imprimir","printsheet":"imprimeix aquest full","result":"resultat","results":"resultats","singleLang":"llenguatge","sound":"ella","subtitle":"subt\xedtol","submit":"presentar","tutorial":"tutorial","validate":"validar"},"emergency":{"samu":"S.A.M.U.","police":"policia","firefighter":"bombers","general":"general","citypolice":"Policia local","hospital":"Hospital","homeless":"Sense llar (trucada gratu\xefta)","poison":"Centre de control de ver\xed","emergency":"emerg\xe8ncies europees"},"error":{"title":"S\'ha produ\xeft un error","button":"Reinicieu l\'aplicaci\xf3"},"history":{"title":"historial de converses"},"inputs":{"choose":"Tria una resposta"},"language":{"change":"canviar l\'idioma","select":"seleccioneu l\'idioma que voleu utilitzar"},"link":{"buttontext":"Visualitza el document","goto":"V\xe9s a l\'adre\xe7a","click":"Clica aqu\xed","scanQR":"escanejant el QrCode","scanQRTile":"Escaneja el codi QR per descobrir"},"loader":{"loader":{"optimal":"Per a una experi\xe8ncia \xf2ptima,","classic":"Per a una experi\xe8ncia m\xe9s cl\xe0ssica,","vocal":"Parlo cara a cara amb l\'agent.","text":"Em comunico per escrit amb l\'agent."},"modes":{"vocal":"manera vocal","text":"mode text"},"loaderValidation":"Inicia la conversa","locale":"comprovant el llenguatge","supported":"comprovant els idiomes compatibles","addressdata":"recuperant dades"},"menu":{"message":"Introdu\xefu el vostre missatge","backconversation":"tornar a la conversa","answer":" respon les teves preguntes"},"mobileLandscapePreventer":{"firstline":"Per a una experi\xe8ncia \xf2ptima,","secondline":"gira la pantalla"},"news":{"warningtext":"Accedeix al canal de not\xedcies, s\'activar\xe0 el so del teu dispositiu","live":"viu","continuous":"cont\xednuament"},"poi":{"comment":"revisi\xf3 del client","route":"carretera","nodata":"Cap contingut coincideix amb la teva cerca","openinghours":"Horari d\'obertura","prices":"Preus","paymentmethods":"M\xe8todes de Pagament","numberofplaces":"nombre de places","openroutemobile":"obre la ruta de Google Maps al tel\xe8fon intel\xb7ligent","FoodEstablishment":"On menjar","LodgingBusiness":"On dormir","TouristDestination":"Qu\xe8 veure","TouristAttraction":"Qu\xe8 fer","Product":"Productes locals","Service":"Serveis","Event":"Esdeveniments","City":"Ciutats","Wine":"Vins"},"suggestion":{"consult":"Fes una ullada","thetutorial":"el tutorial"},"template":{"reset":"restablir tot","showresults":"Mostra els resultats","suggestiontitle":"Cerca suggeriments","reminder":"No oblidis, \\n puc respondre les teves preguntes."},"anghello":{"listening":"\xc9s el teu torn, t\'escolto...","correct":"Corregir","dontknow":"No ho s\xe9"},"microphone":{"allow":"Si us plau, autoritzeu que el vostre navegador accedeixi al micr\xf2fon per continuar.","rejected":"Heu refusat l\'acc\xe9s al micr\xf2fon.","instructions":"Per utilitzar el mode de veu, si us plau, autoritzeu que el vostre navegador accedeixi al micr\xf2fon.","listening":"Et estant","trigger":"Toca o diu","triggerwithoutname":"Toca per parlar"}}');

});

parcelRegister("cMKRm", function(module, exports) {
module.exports = JSON.parse('{"1":"domovsk\xe1 str\xe1nka","2":"\u017Eiv\xfd zpravodajsk\xfd kan\xe1l","3":"zpr\xe1va o po\u010Das\xed","4":"T\xeds\u0148ov\xe1 \u010D\xedsla","1000":"historick\xfd","1001":"tutorial","common":{"all":"v\u0161echno","back":"zadn\xed","close":"zav\u0159\xedt","continue":"pokra\u010Dovat","download":"sta\u017Een\xed","downloadsheet":"st\xe1hn\u011Bte si tento list","downloadsheetmobile":"st\xe1hn\u011Bte si tento list na smartphone","filter":"filtr","history":"historick\xfd","knowmore":"Zjistit v\xedce","lang":"jazyky","menu":"j\xeddeln\xed l\xedstek","mode":"m\xf3da","needhelp":"pot\u0159ebovat pomoc?","parameters":"nastaven\xed","print":"tisk","printsheet":"tytiskn\u011Bte tento list","result":"v\xfdsledek","results":"v\xfdsledek","singleLang":"jazyk","sound":"jej\xed","submit":"p\u0159edlo\u017Eit","subtitle":"podtitulek","tutorial":"tutorial","validate":"ov\u011B\u0159it"},"emergency":{"samu":"S.A.M.U.","police":"POLICIE","firefighter":"hasi\u010Di","general":"v\u0161eobecn\xfd","citypolice":"M\xedstn\xed policie","hospital":"Nemocnice","homeless":"Bezdomovci (vol\xe1n\xed zdarma)","poison":"Poison Control Center","emergency":"evropsk\xe9 mimo\u0159\xe1dn\xe9 ud\xe1losti"},"error":{"title":"Do\u0161lo k chyb\u011B","button":"Znovu spus\u0165te aplikaci"},"history":{"title":"historie konverzace"},"inputs":{"choose":"Vyberte odpov\u011B\u010F"},"language":{"change":"zm\u011Bnit jazyk","select":"vyberte jazyk, kter\xfd chcete pou\u017E\xedvat"},"link":{"buttontext":"Zobrazit dokument","goto":"P\u0159ejd\u011Bte na adresu","click":"Klikn\u011Bte zde","scanQR":"skenov\xe1n\xedm QrCode","scanQRTile":"Naskenujte QR k\xf3d a objevte"},"loader":{"loader":{"optimal":"Pro optim\xe1ln\xed z\xe1\u017Eitek,","classic":"Pro klasi\u010Dt\u011Bj\u0161\xed z\xe1\u017Eitek,","vocal":"Mluv\xedm tv\xe1\u0159\xed v tv\xe1\u0159 s agentem.","text":"S jednatelem komunikuji p\xedsemn\u011B."},"modes":{"vocal":"hlasov\xfd re\u017Eim","text":"textov\xfd re\u017Eim"},"loaderValidation":"Zahajte konverzaci","locale":"kontrola jazyka","supported":"kontrola podporovan\xfdch jazyk\u016F","addressdata":"na\u010D\xedt\xe1n\xed dat"},"menu":{"message":"Zadejte svou zpr\xe1vu","backconversation":"zp\u011Bt k rozhovoru","answer":" odpov\xedd\xe1 na va\u0161e ot\xe1zky"},"mobileLandscapePreventer":{"firstline":"Pro optim\xe1ln\xed z\xe1\u017Eitek,","secondline":"oto\u010Dte obrazovku"},"news":{"warningtext":"Vstoup\xedte do zpravodajsk\xe9ho kan\xe1lu, zvuk na va\u0161em za\u0159\xedzen\xed bude aktivov\xe1n","live":"\u017E\xedt","continuous":"nep\u0159etr\u017Eit\u011B"},"poi":{"comment":"z\xe1kaznick\xe1 recenze","route":"silnice","nodata":"Va\u0161emu vyhled\xe1v\xe1n\xed neodpov\xedd\xe1 \u017E\xe1dn\xfd obsah","openinghours":"Otev\xedrac\xed doba","prices":"Ceny","paymentmethods":"Platebn\xed metody","numberofplaces":"po\u010Det m\xedst","openroutemobile":"otev\u0159ete trasu Google Maps na smartphonu","FoodEstablishment":"Kde j\xedst","LodgingBusiness":"Kde sp\xe1t","TouristDestination":"Co vid\u011Bt","TouristAttraction":"Co d\u011Blat","Product":"M\xedstn\xed produkty","Service":"Slu\u017Eby","Event":"Ud\xe1losti","City":"M\u011Bsta","Wine":"V\xedna"},"suggestion":{"consult":"P\u0159ekontrolovat","thetutorial":"tutori\xe1l"},"template":{"reset":"resetovat v\u0161e","showresults":"Uka\u017E v\xfdsledky","suggestiontitle":"N\xe1vrhy vyhled\xe1v\xe1n\xed","reminder":"Nezapome\u0148te, \\n mohu odpov\u011Bd\u011Bt na va\u0161e ot\xe1zky."},"anghello":{"listening":"Je to na v\xe1s, poslouch\xe1m...","correct":"Opravit","dontknow":"Nev\xedm"},"microphone":{"allow":"Povolte pros\xedm prohl\xed\u017Ee\u010Di p\u0159\xedstup k mikrofonu pro pokra\u010Dov\xe1n\xed.","rejected":"Odm\xedtli jste p\u0159\xedstup k mikrofonu.","instructions":"Pro pou\u017Eit\xed hlasov\xe9ho re\u017Eimu pros\xedm povolte prohl\xed\u017Ee\u010Di p\u0159\xedstup k mikrofonu.","listening":"Sly\u0161\xedm","trigger":"Stiskn\u011Bte nebo \u0159ekn\u011Bte","triggerwithoutname":"Klepnut\xedm mluv\xedte"}}');

});

parcelRegister("54G60", function(module, exports) {
module.exports = JSON.parse('{"1":"hjemmeside","2":"live nyhedskanal","3":"vejrudsigt","4":"N\xf8dnumre","1000":"historisk","1001":"tutorial","common":{"all":"alle","back":"tilbage","close":"t\xe6t","continue":"Blive ved","download":"Hent","downloadsheet":"download dette ark","downloadsheetmobile":"download dette ark p\xe5 smartphone","filter":"Filter","history":"historisk","knowmore":"L\xe6s mere","lang":"SPROG","menu":"menu","mode":"mode","needhelp":"Brug for hj\xe6lp?","parameters":"indstillinger","print":"Print","printsheet":"Udskriv dette ark","result":"resultat","results":"resultater","singleLang":"Sprog","sound":"hende","submit":"indsend","subtitle":"undertekst","tutorial":"tutorial","validate":"validere"},"emergency":{"samu":"S.A.M.U.","police":"politi","firefighter":"brandm\xe6nd","general":"generel","citypolice":"Lokalt politi","hospital":"Hospital","homeless":"Hjeml\xf8s (gratis opkald)","poison":"Giftkontrolcenter","emergency":"europ\xe6iske n\xf8dsituationer"},"error":{"title":"Der opstod en fejl","button":"Genstart applikationen"},"history":{"title":"samtale historie"},"inputs":{"choose":"V\xe6lg et svar"},"language":{"change":"\xe6ndre sproget","select":"v\xe6lg det sprog, du vil bruge"},"link":{"buttontext":"Se dokumentet","goto":"G\xe5 til adressen","click":"Klik her","scanQR":"ved at scanne QRCoden","scanQRTile":"Scan QR-koden for at opdage"},"loader":{"loader":{"optimal":"For en optimal oplevelse,","classic":"For en mere klassisk oplevelse,","vocal":"Jeg taler ansigt til ansigt med agenten.","text":"Jeg kommunikerer skriftligt med agenten."},"modes":{"vocal":"vokal tilstand","text":"teksttilstand"},"loaderValidation":"Start samtale","locale":"kontrol af sprog","supported":"kontrol af underst\xf8ttede sprog","addressdata":"hente data"},"menu":{"message":"Indtast din besked","backconversation":"tilbage til samtalen","answer":" svarer p\xe5 dine sp\xf8rgsm\xe5l"},"mobileLandscapePreventer":{"firstline":"For en optimal oplevelse,","secondline":"vend din sk\xe6rm"},"news":{"warningtext":"Du f\xe5r adgang til nyhedskanalen, lyden p\xe5 din enhed aktiveres","live":"Direkte","continuous":"l\xf8bende"},"poi":{"comment":"kundeanmeldelse","route":"vej","nodata":"Intet indhold matcher din s\xf8gning","openinghours":"\xc5bningstider","prices":"Priser","paymentmethods":"Betalingsmetoder","numberofplaces":"antal pladser","openroutemobile":"\xe5ben Google Map-rute p\xe5 smartphone","FoodEstablishment":"Hvor skal man spise","LodgingBusiness":"Hvor skal man sove","TouristDestination":"Hvad at se","TouristAttraction":"Hvad skal man g\xf8re","Product":"Lokale produkter","Service":"Tjenester","Event":"Begivenheder","City":"Byer","Wine":"Vine"},"suggestion":{"consult":"Tjek ud","thetutorial":"tutorialen"},"template":{"reset":"genstart alt","showresults":"Vis resultaterne","suggestiontitle":"S\xf8geforslag","reminder":"Glem ikke, \\n jeg kan svare p\xe5 dine sp\xf8rgsm\xe5l."},"anghello":{"listening":"Det er op til dig, jeg lytter...","correct":"Korrigere","dontknow":"Jeg ved det ikke"},"microphone":{"allow":"Venligst giv din browser tilladelse til at f\xe5 adgang til mikrofonen for at forts\xe6tte.","rejected":"Du har n\xe6gtet adgangen til mikrofonen.","instructions":"For at bruge stemmetilstand, venligst giv din browser tilladelse til at f\xe5 adgang til mikrofonen.","listening":"Jeg lytter","trigger":"Tryk eller siger","triggerwithoutname":"Tryk for at tale"}}');

});

parcelRegister("cHckr", function(module, exports) {
module.exports = JSON.parse('{"1":"Startseite","2":"Live-Infokanal","3":"Wetter","4":"Notrufnummern","1000":"Geschichte","1001":"anleitung","common":{"all":"alle","back":"zur\xfcck","close":"schlie\xdfen","continue":"Weiter","download":"herunterladen","downloadsheet":"Dieses Blatt herunterladen","downloadsheetmobile":"Laden Sie dieses Blatt auf Ihr Smartphone herunter","filter":"filter","history":"Verlauf","knowmore":"Mehr erfahren","lang":"Sprachen","menu":"Men\xfc","mode":"Modus","needhelp":"Brauche Hilfe ?","parameters":"Parameter","print":"Ausdrucken","printsheet":"Blat ausdrucken","result":"Ergebnis","results":"Ergebnisse","singleLang":"Sprache","sound":"Ton","subtitle":"Untertitel","submit":"einreichen","tutorial":"Lernprogramm","validate":"validieren"},"emergency":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein","citypolice":"Lokale Polizeibeh\xf6rde","hospital":"Krankenhaus","homeless":"Obdachlos (kostenloser Anruf)","poison":"Giftkontrollzentrum","emergency":"Europ\xe4ische Notf\xe4lle"},"error":{"title":"Es ist ein Fehler aufgetreten","button":"Starten Sie die Anwendung erneut"},"history":{"title":"Chat-Verlauf"},"inputs":{"choose":"W\xe4hlen Sie eine Antwort"},"language":{"change":"die Sprache \xe4ndern","select":"W\xe4hlen Sie die gew\xfcnschte Sprache"},"link":{"buttontext":"Sehen Sie sich das Dokument an","goto":"Zur Adresse gehen","click":"klicken Sie hier","scanQR":"durch Scannen des QrCodes","scanQRTile":"Scannen Sie den QR-Code, um zu entdecken"},"loader":{"loader":{"optimal":"F\xfcr ein optimales Erlebnis,","classic":"F\xfcr ein eher klassisches Erlebnis,","vocal":"Ich kommuniziere durch Sprechen mit dem Agenten.","text":"Ich kommuniziere per Text mit dem Agenten."},"modes":{"vocal":"Vokal-Modus","text":"Textmodus"},"loaderValidation":"Gespr\xe4ch beginnen","locale":"Gebietsschema pr\xfcfen","supported":"Pr\xfcfung der unterst\xfctzten Gebietsschemata","store":"Speicher erstellen","directline":"Direktleitung verbinden","ponyfill":"ponyfilling","addressdata":"Abrufen von Daten"},"menu":{"message":"Geben Sie Ihre Nachricht ein","backconversation":"zur\xfcck zum Gespr\xe4ch","answer":" beantwortet Ihre Fragen"},"mobileLandscapePreventer":{"firstline":"F\xfcr ein optimales Erlebnis,","secondline":"drehen Sie Ihren Bildschirm um"},"news":{"warningtext":"Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert","live":"live","continuous":"fortlaufend"},"poi":{"comment":"Kundenbewertung","route":"Route","nodata":"Kein Inhalt entspricht Ihrer Suche","openinghours":"\xd6ffnungszeiten","prices":"Preise","paymentmethods":"Zahlungsarten","numberofplaces":"Anzahl der Pl\xe4tze","openroutemobile":"\xd6ffnen Sie die Google Map-Route auf dem Smartphone","FoodEstablishment":"Wo sollen wir essen","LodgingBusiness":"Wo schlafen","TouristDestination":"Was zu sehen","TouristAttraction":"Was zu tun","Product":"Lokale Produkte","Service":"Dienstleistungen","Event":"Veranstaltungen","City":"St\xe4dte","Wine":"Weine"},"suggestion":{"consult":"Schauen Sie sich","thetutorial":"das Tutorial an"},"template":{"reset":"Filter zur\xfccksetzen","showresults":"Ergebnisse anzeigen","suggestiontitle":"Forschungsvorschl\xe4ge","reminder":"Vergessen Sie nicht :\\n Ich kann Ihre Fragen beantworten."},"anghello":{"listening":"Es liegt an dir, ich h\xf6re...","correct":"Korrigieren","dontknow":"Ich wei\xdf es nicht"},"microphone":{"allow":"Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.","rejected":"Sie haben den Zugriff auf das Mikrofon abgelehnt.","instructions":"Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.","listening":"Ich h\xf6re","trigger":"Dr\xfccken Sie oder sagen Sie","triggerwithoutname":"Zum Sprechen tippen"}}');

});

parcelRegister("4pbjv", function(module, exports) {
module.exports = JSON.parse('{"1":"Startseite","2":"Live-Infokanal","3":"Wetter","4":"Notrufnummern","1000":"Geschichte","1001":"anleitung","common":{"all":"alle","back":"zur\xfcck","close":"schlie\xdfen","continue":"Weiter","download":"herunterladen","downloadsheet":"Dieses Blatt herunterladen","downloadsheetmobile":"Laden Sie dieses Blatt auf Ihr Smartphone herunter","filter":"filter","history":"Verlauf","knowmore":"Mehr erfahren","lang":"Sprachen","menu":"Men\xfc","mode":"Modus","needhelp":"Brauche Hilfe ?","parameters":"Parameter","print":"Ausdrucken","printsheet":"Blat ausdrucken","result":"Ergebnis","results":"Ergebnisse","singleLang":"Sprache","sound":"Ton","subtitle":"Untertitel","submit":"einreichen","tutorial":"Lernprogramm","validate":"validieren"},"emergency":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein","citypolice":"Lokale Polizeibeh\xf6rde","hospital":"Krankenhaus","homeless":"Obdachlos (kostenloser Anruf)","poison":"Giftkontrollzentrum","emergency":"Europ\xe4ische Notf\xe4lle"},"error":{"title":"Es ist ein Fehler aufgetreten","button":"Starten Sie die Anwendung erneut"},"history":{"title":"Chat-Verlauf"},"inputs":{"choose":"W\xe4hlen Sie eine Antwort"},"language":{"change":"die Sprache \xe4ndern","select":"W\xe4hlen Sie die gew\xfcnschte Sprache"},"link":{"buttontext":"Sehen Sie sich das Dokument an","goto":"Zur Adresse gehen","click":"klicken Sie hier","scanQR":"durch Scannen des QrCodes","scanQRTile":"Scannen Sie den QR-Code, um zu entdecken"},"loader":{"loader":{"optimal":"F\xfcr ein optimales Erlebnis,","classic":"F\xfcr ein eher klassisches Erlebnis,","vocal":"Ich kommuniziere durch Sprechen mit dem Agenten.","text":"Ich kommuniziere per Text mit dem Agenten."},"modes":{"vocal":"Vokal-Modus","text":"Textmodus"},"loaderValidation":"Gespr\xe4ch beginnen","locale":"Gebietsschema pr\xfcfen","supported":"Pr\xfcfung der unterst\xfctzten Gebietsschemata","store":"Speicher erstellen","directline":"Direktleitung verbinden","ponyfill":"ponyfilling","addressdata":"Abrufen von Daten"},"menu":{"message":"Geben Sie Ihre Nachricht ein","backconversation":"zur\xfcck zum Gespr\xe4ch","answer":" beantwortet Ihre Fragen"},"mobileLandscapePreventer":{"firstline":"F\xfcr ein optimales Erlebnis,","secondline":"drehen Sie Ihren Bildschirm um"},"news":{"warningtext":"Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert","live":"live","continuous":"fortlaufend"},"poi":{"comment":"Kundenbewertung","route":"Route","nodata":"Kein Inhalt entspricht Ihrer Suche","openinghours":"\xd6ffnungszeiten","prices":"Preise","paymentmethods":"Zahlungsarten","numberofplaces":"Anzahl der Pl\xe4tze","openroutemobile":"\xd6ffnen Sie die Google Map-Route auf dem Smartphone","FoodEstablishment":"Wo sollen wir essen","LodgingBusiness":"Wo schlafen","TouristDestination":"Was zu sehen","TouristAttraction":"Was zu tun","Product":"Lokale Produkte","Service":"Dienstleistungen","Event":"Veranstaltungen","City":"St\xe4dte","Wine":"Weine"},"suggestion":{"consult":"Schauen Sie sich","thetutorial":"das Tutorial an"},"template":{"reset":"Filter zur\xfccksetzen","showresults":"Ergebnisse anzeigen","suggestiontitle":"Forschungsvorschl\xe4ge","reminder":"Vergessen Sie nicht :\\n Ich kann Ihre Fragen beantworten."},"anghello":{"listening":"Es liegt an dir, ich h\xf6re...","correct":"Korrigieren","dontknow":"Ich wei\xdf es nicht"},"microphone":{"allow":"Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.","rejected":"Sie haben den Zugriff auf das Mikrofon abgelehnt.","instructions":"Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.","listening":"Ich h\xf6re","trigger":"Dr\xfccken Sie oder sagen Sie","triggerwithoutname":"Zum Sprechen tippen"}}');

});

parcelRegister("86Qd9", function(module, exports) {
module.exports = JSON.parse('{"1":"Startseite","2":"Live-Infokanal","3":"Wetter","4":"Notrufnummern","1000":"Geschichte","1001":"anleitung","common":{"all":"alle","back":"zur\xfcck","close":"schlie\xdfen","continue":"Weiter","download":"herunterladen","downloadsheet":"Dieses Blatt herunterladen","downloadsheetmobile":"Laden Sie dieses Blatt auf Ihr Smartphone herunter","filter":"filter","history":"Verlauf","knowmore":"Mehr erfahren","lang":"Sprachen","menu":"Men\xfc","mode":"Modus","needhelp":"Brauche Hilfe ?","parameters":"Parameter","print":"Ausdrucken","printsheet":"Blat ausdrucken","result":"Ergebnis","results":"Ergebnisse","singleLang":"Sprache","sound":"Ton","subtitle":"Untertitel","submit":"einreichen","tutorial":"Lernprogramm","validate":"validieren"},"emergency":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein","citypolice":"Lokale Polizeibeh\xf6rde","hospital":"Krankenhaus","homeless":"Obdachlos (kostenloser Anruf)","poison":"Giftkontrollzentrum","emergency":"Europ\xe4ische Notf\xe4lle"},"error":{"title":"Es ist ein Fehler aufgetreten","button":"Starten Sie die Anwendung erneut"},"history":{"title":"Chat-Verlauf"},"inputs":{"choose":"W\xe4hlen Sie eine Antwort"},"language":{"change":"die Sprache \xe4ndern","select":"W\xe4hlen Sie die gew\xfcnschte Sprache"},"link":{"buttontext":"Sehen Sie sich das Dokument an","goto":"Zur Adresse gehen","click":"klicken Sie hier","scanQR":"durch Scannen des QrCodes","scanQRTile":"Scannen Sie den QR-Code, um zu entdecken"},"loader":{"loader":{"optimal":"F\xfcr ein optimales Erlebnis,","classic":"F\xfcr ein eher klassisches Erlebnis,","vocal":"Ich kommuniziere durch Sprechen mit dem Agenten.","text":"Ich kommuniziere per Text mit dem Agenten."},"modes":{"vocal":"Vokal-Modus","text":"Textmodus"},"loaderValidation":"Gespr\xe4ch beginnen","locale":"Gebietsschema pr\xfcfen","supported":"Pr\xfcfung der unterst\xfctzten Gebietsschemata","store":"Speicher erstellen","directline":"Direktleitung verbinden","ponyfill":"ponyfilling","addressdata":"Abrufen von Daten"},"menu":{"message":"Geben Sie Ihre Nachricht ein","backconversation":"zur\xfcck zum Gespr\xe4ch","answer":" beantwortet Ihre Fragen"},"mobileLandscapePreventer":{"firstline":"F\xfcr ein optimales Erlebnis,","secondline":"drehen Sie Ihren Bildschirm um"},"news":{"warningtext":"Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert","live":"live","continuous":"fortlaufend"},"poi":{"comment":"Kundenbewertung","route":"Route","nodata":"Kein Inhalt entspricht Ihrer Suche","openinghours":"\xd6ffnungszeiten","prices":"Preise","paymentmethods":"Zahlungsarten","numberofplaces":"Anzahl der Pl\xe4tze","openroutemobile":"\xd6ffnen Sie die Google Map-Route auf dem Smartphone","FoodEstablishment":"Wo sollen wir essen","LodgingBusiness":"Wo schlafen","TouristDestination":"Was zu sehen","TouristAttraction":"Was zu tun","Product":"Lokale Produkte","Service":"Dienstleistungen","Event":"Veranstaltungen","City":"St\xe4dte","Wine":"Weine"},"suggestion":{"consult":"Schauen Sie sich","thetutorial":"das Tutorial an"},"template":{"reset":"Filter zur\xfccksetzen","showresults":"Ergebnisse anzeigen","suggestiontitle":"Forschungsvorschl\xe4ge","reminder":"Vergessen Sie nicht :\\n Ich kann Ihre Fragen beantworten."},"anghello":{"listening":"Es liegt an dir, ich h\xf6re...","correct":"Korrigieren","dontknow":"Ich wei\xdf es nicht"},"microphone":{"allow":"Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.","rejected":"Sie haben den Zugriff auf das Mikrofon abgelehnt.","instructions":"Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.","listening":"Ich h\xf6re","trigger":"Dr\xfccken Sie oder sagen Sie","triggerwithoutname":"Zum Sprechen tippen"}}');

});

parcelRegister("gnGGd", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"home\",\"2\":\"live info channel\",\"3\":\"weather\",\"4\":\"emergency numbers\",\"1000\":\"history\",\"1001\":\"tutorial\",\"common\":{\"abort\":\"abort\",\"all\":\"all\",\"back\":\"back\",\"close\":\"close\",\"continue\":\"continue\",\"download\":\"download\",\"downloadsheet\":\"download this sheet\",\"downloadsheetmobile\":\"download this sheet on smartphone\",\"filter\":\"filter\",\"history\":\"history\",\"knowmore\":\"Learn more\",\"lang\":\"languages\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Need help ?\",\"parameters\":\"parameters\",\"print\":\"print\",\"printsheet\":\"print this sheet\",\"result\":\"result\",\"results\":\"results\",\"singleLang\":\"language\",\"sound\":\"sound\",\"submit\":\"submit\",\"subtitle\":\"subtitle\",\"tutorial\":\"tutorial\",\"validate\":\"validate\"},\"emergency\":{\"samu\":\"maeu\",\"police\":\"police\",\"firefighter\":\"firefighters\",\"general\":\"general\",\"citypolice\":\"Local police\",\"hospital\":\"Hospital\",\"homeless\":\"Homeless (free call)\",\"poison\":\"Poison Control Center\",\"emergency\":\"European emergencies\"},\"error\":{\"title\":\"An error occurred\",\"button\":\"Launch the application again\"},\"history\":{\"title\":\"chat history\"},\"inputs\":{\"choose\":\"Choose an answer\"},\"language\":{\"change\":\"change the language\",\"select\":\"select the language you want to use\"},\"link\":{\"buttontext\":\"View the document\",\"goto\":\"Go to address\",\"click\":\"Click here\",\"scanQR\":\"by scanning the QrCode\",\"scanQRTile\":\"Scan the QR Code to discover\"},\"loader\":{\"loader\":{\"optimal\":\"For an optimal experience,\",\"classic\":\"For a more classical experience,\",\"vocal\":\"I communicate by speaking with the agent.\",\"text\":\"I communicate by text with the agent.\"},\"modes\":{\"vocal\":\"vocal mode\",\"text\":\"text mode\"},\"loaderValidation\":\"Start conversation\",\"locale\":\"checking language\",\"supported\":\"checking supported languages\",\"addressdata\":\"retrieving data\",\"store\":\"store\",\"directline\":\"directline\",\"ponyfill\":\"ponyfill\"},\"menu\":{\"message\":\"Enter your message\",\"backconversation\":\"back to the conversation\",\"answer\":\" answers your questions\"},\"mobileLandscapePreventer\":{\"firstline\":\"For an optimal experience,\",\"secondline\":\"flip your screen\"},\"news\":{\"warningtext\":\"You are about to access the information channel, the sound of your device will be activated\",\"live\":\"live\",\"continuous\":\"continuous\"},\"poi\":{\"comment\":\"customer review\",\"route\":\"route\",\"nodata\":\"No content corresponds to your search\",\"openinghours\":\"Opening hours\",\"prices\":\"Prices\",\"paymentmethods\":\"Payment methods\",\"numberofplaces\":\"number of places\",\"openroutemobile\":\"open Google Maps route on smartphone\",\"FoodEstablishment\":\"Where to eat\",\"LodgingBusiness\":\"Where to sleep\",\"TouristDestination\":\"What to see\",\"TouristAttraction\":\"What to do\",\"Product\":\"Local products\",\"Service\":\"Services\",\"Event\":\"Events\",\"City\":\"Cities\",\"Wine\":\"Wines\"},\"suggestion\":{\"consult\":\"Check out\",\"thetutorial\":\"the tutorial\"},\"template\":{\"reset\":\"reset filters\",\"showresults\":\"Show results\",\"suggestiontitle\":\"Research suggestions\",\"reminder\":\"Don't forget,\\n I can answer your questions.\"},\"GDPR\":{\"title\":\"processing personal data transmitted to the bot\",\"message\":\"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.\",\"link\":\"open confidency policy\",\"buttonAccept\":\"I understand and I accept\",\"buttonRefuse\":\"I refuse\",\"messageAccepted\":\"your acceptation has been saved\",\"messageRefused\":\"your refusal has been saved\"},\"anghello\":{\"listening\":\"It's up to you, I'm listening...\",\"correct\":\"Correct\",\"dontknow\":\"I don't know\"},\"microphone\":{\"allow\":\"Please allow your browser to access the microphone to continue.\",\"rejected\":\"You have denied access to the microphone.\",\"instructions\":\"To use voice mode, please allow your browser to access the microphone.\",\"listening\":\"I'm listening\",\"trigger\":\"Press or say\",\"triggerwithoutname\":\"Tap to talk\"}}");

});

parcelRegister("fOTQw", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"home\",\"2\":\"live info channel\",\"3\":\"weather\",\"4\":\"emergency numbers\",\"1000\":\"history\",\"1001\":\"tutorial\",\"common\":{\"abort\":\"abort\",\"all\":\"all\",\"back\":\"back\",\"close\":\"close\",\"continue\":\"continue\",\"download\":\"download\",\"downloadsheet\":\"download this sheet\",\"downloadsheetmobile\":\"download this sheet on smartphone\",\"filter\":\"filter\",\"history\":\"history\",\"knowmore\":\"Learn more\",\"lang\":\"languages\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Need help ?\",\"parameters\":\"parameters\",\"print\":\"print\",\"printsheet\":\"print this sheet\",\"result\":\"result\",\"results\":\"results\",\"singleLang\":\"language\",\"sound\":\"sound\",\"submit\":\"submit\",\"subtitle\":\"subtitle\",\"tutorial\":\"tutorial\",\"validate\":\"validate\"},\"emergency\":{\"samu\":\"maeu\",\"police\":\"police\",\"firefighter\":\"firefighters\",\"general\":\"general\",\"citypolice\":\"Local police\",\"hospital\":\"Hospital\",\"homeless\":\"Homeless (free call)\",\"poison\":\"Poison Control Center\",\"emergency\":\"European emergencies\"},\"error\":{\"title\":\"An error occurred\",\"button\":\"Launch the application again\"},\"history\":{\"title\":\"chat history\"},\"inputs\":{\"choose\":\"Choose an answer\"},\"language\":{\"change\":\"change the language\",\"select\":\"select the language you want to use\"},\"link\":{\"buttontext\":\"View the document\",\"goto\":\"Go to address\",\"click\":\"Click here\",\"scanQR\":\"by scanning the QrCode\",\"scanQRTile\":\"Scan the QR Code to discover\"},\"loader\":{\"loader\":{\"optimal\":\"For an optimal experience,\",\"classic\":\"For a more classical experience,\",\"vocal\":\"I communicate by speaking with the agent.\",\"text\":\"I communicate by text with the agent.\"},\"modes\":{\"vocal\":\"vocal mode\",\"text\":\"text mode\"},\"loaderValidation\":\"Start conversation\",\"locale\":\"checking language\",\"supported\":\"checking supported languages\",\"addressdata\":\"retrieving data\",\"store\":\"store\",\"directline\":\"directline\",\"ponyfill\":\"ponyfill\"},\"menu\":{\"message\":\"Enter your message\",\"backconversation\":\"back to the conversation\",\"answer\":\" answers your questions\"},\"mobileLandscapePreventer\":{\"firstline\":\"For an optimal experience,\",\"secondline\":\"flip your screen\"},\"news\":{\"warningtext\":\"You are about to access the information channel, the sound of your device will be activated\",\"live\":\"live\",\"continuous\":\"continuous\"},\"poi\":{\"comment\":\"customer review\",\"route\":\"route\",\"nodata\":\"No content corresponds to your search\",\"openinghours\":\"Opening hours\",\"prices\":\"Prices\",\"paymentmethods\":\"Payment methods\",\"numberofplaces\":\"number of places\",\"openroutemobile\":\"open Google Maps route on smartphone\",\"FoodEstablishment\":\"Where to eat\",\"LodgingBusiness\":\"Where to sleep\",\"TouristDestination\":\"What to see\",\"TouristAttraction\":\"What to do\",\"Product\":\"Local products\",\"Service\":\"Services\",\"Event\":\"Events\",\"City\":\"Cities\",\"Wine\":\"Wines\"},\"suggestion\":{\"consult\":\"Check out\",\"thetutorial\":\"the tutorial\"},\"template\":{\"reset\":\"reset filters\",\"showresults\":\"Show results\",\"suggestiontitle\":\"Research suggestions\",\"reminder\":\"Don't forget,\\n I can answer your questions.\"},\"GDPR\":{\"title\":\"processing personal data transmitted to the bot\",\"message\":\"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.\",\"link\":\"open confidency policy\",\"buttonAccept\":\"I understand and I accept\",\"buttonRefuse\":\"I refuse\",\"messageAccepted\":\"your acceptation has been saved\",\"messageRefused\":\"your refusal has been saved\"},\"anghello\":{\"listening\":\"It's up to you, I'm listening...\",\"correct\":\"Correct\",\"dontknow\":\"I don't know\"},\"microphone\":{\"allow\":\"Please allow your browser to access the microphone to continue.\",\"rejected\":\"You have denied access to the microphone.\",\"instructions\":\"To use voice mode, please allow your browser to access the microphone.\",\"listening\":\"I'm listening\",\"trigger\":\"Press or say\",\"triggerwithoutname\":\"Tap to talk\"}}");

});

parcelRegister("6wSBz", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"home\",\"2\":\"live info channel\",\"3\":\"weather\",\"4\":\"emergency numbers\",\"1000\":\"history\",\"1001\":\"tutorial\",\"common\":{\"abort\":\"abort\",\"all\":\"all\",\"back\":\"back\",\"close\":\"close\",\"continue\":\"continue\",\"download\":\"download\",\"downloadsheet\":\"download this sheet\",\"downloadsheetmobile\":\"download this sheet on smartphone\",\"filter\":\"filter\",\"history\":\"history\",\"knowmore\":\"Learn more\",\"lang\":\"languages\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Need help ?\",\"parameters\":\"parameters\",\"print\":\"print\",\"printsheet\":\"print this sheet\",\"result\":\"result\",\"results\":\"results\",\"singleLang\":\"language\",\"sound\":\"sound\",\"submit\":\"submit\",\"subtitle\":\"subtitle\",\"tutorial\":\"tutorial\",\"validate\":\"validate\"},\"emergency\":{\"samu\":\"maeu\",\"police\":\"police\",\"firefighter\":\"firefighters\",\"general\":\"general\",\"citypolice\":\"Local police\",\"hospital\":\"Hospital\",\"homeless\":\"Homeless (free call)\",\"poison\":\"Poison Control Center\",\"emergency\":\"European emergencies\"},\"error\":{\"title\":\"An error occurred\",\"button\":\"Launch the application again\"},\"history\":{\"title\":\"chat history\"},\"inputs\":{\"choose\":\"Choose an answer\"},\"language\":{\"change\":\"change the language\",\"select\":\"select the language you want to use\"},\"link\":{\"buttontext\":\"View the document\",\"goto\":\"Go to address\",\"click\":\"Click here\",\"scanQR\":\"by scanning the QrCode\",\"scanQRTile\":\"Scan the QR Code to discover\"},\"loader\":{\"loader\":{\"optimal\":\"For an optimal experience,\",\"classic\":\"For a more classical experience,\",\"vocal\":\"I communicate by speaking with the agent.\",\"text\":\"I communicate by text with the agent.\"},\"modes\":{\"vocal\":\"vocal mode\",\"text\":\"text mode\"},\"loaderValidation\":\"Start conversation\",\"locale\":\"checking language\",\"supported\":\"checking supported languages\",\"addressdata\":\"retrieving data\",\"store\":\"store\",\"directline\":\"directline\",\"ponyfill\":\"ponyfill\"},\"menu\":{\"message\":\"Enter your message\",\"backconversation\":\"back to the conversation\",\"answer\":\" answers your questions\"},\"mobileLandscapePreventer\":{\"firstline\":\"For an optimal experience,\",\"secondline\":\"flip your screen\"},\"news\":{\"warningtext\":\"You are about to access the information channel, the sound of your device will be activated\",\"live\":\"live\",\"continuous\":\"continuous\"},\"poi\":{\"comment\":\"customer review\",\"route\":\"route\",\"nodata\":\"No content corresponds to your search\",\"openinghours\":\"Opening hours\",\"prices\":\"Prices\",\"paymentmethods\":\"Payment methods\",\"numberofplaces\":\"number of places\",\"openroutemobile\":\"open Google Maps route on smartphone\",\"FoodEstablishment\":\"Where to eat\",\"LodgingBusiness\":\"Where to sleep\",\"TouristDestination\":\"What to see\",\"TouristAttraction\":\"What to do\",\"Product\":\"Local products\",\"Service\":\"Services\",\"Event\":\"Events\",\"City\":\"Cities\",\"Wine\":\"Wines\"},\"suggestion\":{\"consult\":\"Check out\",\"thetutorial\":\"the tutorial\"},\"template\":{\"reset\":\"reset filters\",\"showresults\":\"Show results\",\"suggestiontitle\":\"Research suggestions\",\"reminder\":\"Don't forget,\\n I can answer your questions.\"},\"GDPR\":{\"title\":\"processing personal data transmitted to the bot\",\"message\":\"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.\",\"link\":\"open confidency policy\",\"buttonAccept\":\"I understand and I accept\",\"buttonRefuse\":\"I refuse\",\"messageAccepted\":\"your acceptation has been saved\",\"messageRefused\":\"your refusal has been saved\"},\"anghello\":{\"listening\":\"It's up to you, I'm listening...\",\"correct\":\"Correct\",\"dontknow\":\"I don't know\"},\"microphone\":{\"allow\":\"Please allow your browser to access the microphone to continue.\",\"rejected\":\"You have denied access to the microphone.\",\"instructions\":\"To use voice mode, please allow your browser to access the microphone.\",\"listening\":\"I'm listening\",\"trigger\":\"Press or say\",\"triggerwithoutname\":\"Tap to talk\"}}");

});

parcelRegister("kRuZt", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"home\",\"2\":\"live info channel\",\"3\":\"weather\",\"4\":\"emergency numbers\",\"1000\":\"history\",\"1001\":\"tutorial\",\"common\":{\"abort\":\"abort\",\"all\":\"all\",\"back\":\"back\",\"close\":\"close\",\"continue\":\"continue\",\"download\":\"download\",\"downloadsheet\":\"download this sheet\",\"downloadsheetmobile\":\"download this sheet on smartphone\",\"filter\":\"filter\",\"history\":\"history\",\"knowmore\":\"Learn more\",\"lang\":\"languages\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Need help ?\",\"parameters\":\"parameters\",\"print\":\"print\",\"printsheet\":\"print this sheet\",\"result\":\"result\",\"results\":\"results\",\"singleLang\":\"language\",\"sound\":\"sound\",\"submit\":\"submit\",\"subtitle\":\"subtitle\",\"tutorial\":\"tutorial\",\"validate\":\"validate\"},\"emergency\":{\"samu\":\"maeu\",\"police\":\"police\",\"firefighter\":\"firefighters\",\"general\":\"general\",\"citypolice\":\"Local police\",\"hospital\":\"Hospital\",\"homeless\":\"Homeless (free call)\",\"poison\":\"Poison Control Center\",\"emergency\":\"European emergencies\"},\"error\":{\"title\":\"An error occurred\",\"button\":\"Launch the application again\"},\"history\":{\"title\":\"chat history\"},\"inputs\":{\"choose\":\"Choose an answer\"},\"language\":{\"change\":\"change the language\",\"select\":\"select the language you want to use\"},\"link\":{\"buttontext\":\"View the document\",\"goto\":\"Go to address\",\"click\":\"Click here\",\"scanQR\":\"by scanning the QrCode\",\"scanQRTile\":\"Scan the QR Code to discover\"},\"loader\":{\"loader\":{\"optimal\":\"For an optimal experience,\",\"classic\":\"For a more classical experience,\",\"vocal\":\"I communicate by speaking with the agent.\",\"text\":\"I communicate by text with the agent.\"},\"modes\":{\"vocal\":\"vocal mode\",\"text\":\"text mode\"},\"loaderValidation\":\"Start conversation\",\"locale\":\"checking language\",\"supported\":\"checking supported languages\",\"addressdata\":\"retrieving data\",\"store\":\"store\",\"directline\":\"directline\",\"ponyfill\":\"ponyfill\"},\"menu\":{\"message\":\"Enter your message\",\"backconversation\":\"back to the conversation\",\"answer\":\" answers your questions\"},\"mobileLandscapePreventer\":{\"firstline\":\"For an optimal experience,\",\"secondline\":\"flip your screen\"},\"news\":{\"warningtext\":\"You are about to access the information channel, the sound of your device will be activated\",\"live\":\"live\",\"continuous\":\"continuous\"},\"poi\":{\"comment\":\"customer review\",\"route\":\"route\",\"nodata\":\"No content corresponds to your search\",\"openinghours\":\"Opening hours\",\"prices\":\"Prices\",\"paymentmethods\":\"Payment methods\",\"numberofplaces\":\"number of places\",\"openroutemobile\":\"open Google Maps route on smartphone\",\"FoodEstablishment\":\"Where to eat\",\"LodgingBusiness\":\"Where to sleep\",\"TouristDestination\":\"What to see\",\"TouristAttraction\":\"What to do\",\"Product\":\"Local products\",\"Service\":\"Services\",\"Event\":\"Events\",\"City\":\"Cities\",\"Wine\":\"Wines\"},\"suggestion\":{\"consult\":\"Check out\",\"thetutorial\":\"the tutorial\"},\"template\":{\"reset\":\"reset filters\",\"showresults\":\"Show results\",\"suggestiontitle\":\"Research suggestions\",\"reminder\":\"Don't forget,\\n I can answer your questions.\"},\"GDPR\":{\"title\":\"processing personal data transmitted to the bot\",\"message\":\"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.\",\"link\":\"open confidency policy\",\"buttonAccept\":\"I understand and I accept\",\"buttonRefuse\":\"I refuse\",\"messageAccepted\":\"your acceptation has been saved\",\"messageRefused\":\"your refusal has been saved\"},\"anghello\":{\"listening\":\"It's up to you, I'm listening...\",\"correct\":\"Correct\",\"dontknow\":\"I don't know\"},\"microphone\":{\"allow\":\"Please allow your browser to access the microphone to continue.\",\"rejected\":\"You have denied access to the microphone.\",\"instructions\":\"To use voice mode, please allow your browser to access the microphone.\",\"listening\":\"I'm listening\",\"trigger\":\"Press or say\",\"triggerwithoutname\":\"Tap to talk\"}}");

});

parcelRegister("9tktv", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"home\",\"2\":\"live info channel\",\"3\":\"weather\",\"4\":\"emergency numbers\",\"1000\":\"history\",\"1001\":\"tutorial\",\"common\":{\"abort\":\"abort\",\"all\":\"all\",\"back\":\"back\",\"close\":\"close\",\"continue\":\"continue\",\"download\":\"download\",\"downloadsheet\":\"download this sheet\",\"downloadsheetmobile\":\"download this sheet on smartphone\",\"filter\":\"filter\",\"history\":\"history\",\"knowmore\":\"Learn more\",\"lang\":\"languages\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Need help ?\",\"parameters\":\"parameters\",\"print\":\"print\",\"printsheet\":\"print this sheet\",\"result\":\"result\",\"results\":\"results\",\"singleLang\":\"language\",\"sound\":\"sound\",\"submit\":\"submit\",\"subtitle\":\"subtitle\",\"tutorial\":\"tutorial\",\"validate\":\"validate\"},\"emergency\":{\"samu\":\"maeu\",\"police\":\"police\",\"firefighter\":\"firefighters\",\"general\":\"general\",\"citypolice\":\"Local police\",\"hospital\":\"Hospital\",\"homeless\":\"Homeless (free call)\",\"poison\":\"Poison Control Center\",\"emergency\":\"European emergencies\"},\"error\":{\"title\":\"An error occurred\",\"button\":\"Launch the application again\"},\"history\":{\"title\":\"chat history\"},\"inputs\":{\"choose\":\"Choose an answer\"},\"language\":{\"change\":\"change the language\",\"select\":\"select the language you want to use\"},\"link\":{\"buttontext\":\"View the document\",\"goto\":\"Go to address\",\"click\":\"Click here\",\"scanQR\":\"by scanning the QrCode\",\"scanQRTile\":\"Scan the QR Code to discover\"},\"loader\":{\"loader\":{\"optimal\":\"For an optimal experience,\",\"classic\":\"For a more classical experience,\",\"vocal\":\"I communicate by speaking with the agent.\",\"text\":\"I communicate by text with the agent.\"},\"modes\":{\"vocal\":\"vocal mode\",\"text\":\"text mode\"},\"loaderValidation\":\"Start conversation\",\"locale\":\"checking language\",\"supported\":\"checking supported languages\",\"addressdata\":\"retrieving data\",\"store\":\"store\",\"directline\":\"directline\",\"ponyfill\":\"ponyfill\"},\"menu\":{\"message\":\"Enter your message\",\"backconversation\":\"back to the conversation\",\"answer\":\" answers your questions\"},\"mobileLandscapePreventer\":{\"firstline\":\"For an optimal experience,\",\"secondline\":\"flip your screen\"},\"news\":{\"warningtext\":\"You are about to access the information channel, the sound of your device will be activated\",\"live\":\"live\",\"continuous\":\"continuous\"},\"poi\":{\"comment\":\"customer review\",\"route\":\"route\",\"nodata\":\"No content corresponds to your search\",\"openinghours\":\"Opening hours\",\"prices\":\"Prices\",\"paymentmethods\":\"Payment methods\",\"numberofplaces\":\"number of places\",\"openroutemobile\":\"open Google Maps route on smartphone\",\"FoodEstablishment\":\"Where to eat\",\"LodgingBusiness\":\"Where to sleep\",\"TouristDestination\":\"What to see\",\"TouristAttraction\":\"What to do\",\"Product\":\"Local products\",\"Service\":\"Services\",\"Event\":\"Events\",\"City\":\"Cities\",\"Wine\":\"Wines\"},\"suggestion\":{\"consult\":\"Check out\",\"thetutorial\":\"the tutorial\"},\"template\":{\"reset\":\"reset filters\",\"showresults\":\"Show results\",\"suggestiontitle\":\"Research suggestions\",\"reminder\":\"Don't forget,\\n I can answer your questions.\"},\"GDPR\":{\"title\":\"processing personal data transmitted to the bot\",\"message\":\"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.\",\"link\":\"open confidency policy\",\"buttonAccept\":\"I understand and I accept\",\"buttonRefuse\":\"I refuse\",\"messageAccepted\":\"your acceptation has been saved\",\"messageRefused\":\"your refusal has been saved\"},\"anghello\":{\"listening\":\"It's up to you, I'm listening...\",\"correct\":\"Correct\",\"dontknow\":\"I don't know\"},\"microphone\":{\"allow\":\"Please allow your browser to access the microphone to continue.\",\"rejected\":\"You have denied access to the microphone.\",\"instructions\":\"To use voice mode, please allow your browser to access the microphone.\",\"listening\":\"I'm listening\",\"trigger\":\"Press or say\",\"triggerwithoutname\":\"Tap to talk\"}}");

});

parcelRegister("gEZZY", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"home\",\"2\":\"live info channel\",\"3\":\"weather\",\"4\":\"emergency numbers\",\"1000\":\"history\",\"1001\":\"tutorial\",\"common\":{\"abort\":\"abort\",\"all\":\"all\",\"back\":\"back\",\"close\":\"close\",\"continue\":\"continue\",\"download\":\"download\",\"downloadsheet\":\"download this sheet\",\"downloadsheetmobile\":\"download this sheet on smartphone\",\"filter\":\"filter\",\"history\":\"history\",\"knowmore\":\"Learn more\",\"lang\":\"languages\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Need help ?\",\"parameters\":\"parameters\",\"print\":\"print\",\"printsheet\":\"print this sheet\",\"result\":\"result\",\"results\":\"results\",\"singleLang\":\"language\",\"sound\":\"sound\",\"submit\":\"submit\",\"subtitle\":\"subtitle\",\"tutorial\":\"tutorial\",\"validate\":\"validate\"},\"emergency\":{\"samu\":\"maeu\",\"police\":\"police\",\"firefighter\":\"firefighters\",\"general\":\"general\",\"citypolice\":\"Local police\",\"hospital\":\"Hospital\",\"homeless\":\"Homeless (free call)\",\"poison\":\"Poison Control Center\",\"emergency\":\"European emergencies\"},\"error\":{\"title\":\"An error occurred\",\"button\":\"Launch the application again\"},\"history\":{\"title\":\"chat history\"},\"inputs\":{\"choose\":\"Choose an answer\",\"noaction\":\"Awaiting action\"},\"language\":{\"change\":\"change the language\",\"select\":\"select the language you want to use\"},\"link\":{\"buttontext\":\"View the document\",\"goto\":\"Go to address\",\"click\":\"Click here\",\"scanQR\":\"by scanning the QrCode\",\"scanQRTile\":\"Scan the QR Code to discover\"},\"loader\":{\"loader\":{\"optimal\":\"For an optimal experience,\",\"classic\":\"For a more classical experience,\",\"vocal\":\"I communicate by speaking with the agent.\",\"text\":\"I communicate by text with the agent.\"},\"modes\":{\"vocal\":\"vocal mode\",\"text\":\"text mode\"},\"loaderValidation\":\"Start conversation\",\"locale\":\"checking language\",\"supported\":\"checking supported languages\",\"addressdata\":\"retrieving data\",\"store\":\"store\",\"directline\":\"directline\",\"ponyfill\":\"ponyfill\"},\"menu\":{\"message\":\"Enter your message\",\"backconversation\":\"back to the conversation\",\"answer\":\" answers your questions\"},\"mobileLandscapePreventer\":{\"firstline\":\"For an optimal experience,\",\"secondline\":\"flip your screen\"},\"news\":{\"warningtext\":\"You are about to access the information channel, the sound of your device will be activated\",\"live\":\"live\",\"continuous\":\"continuous\"},\"poi\":{\"comment\":\"customer review\",\"route\":\"route\",\"nodata\":\"No content corresponds to your search\",\"openinghours\":\"Opening hours\",\"prices\":\"Prices\",\"paymentmethods\":\"Payment methods\",\"numberofplaces\":\"number of places\",\"openroutemobile\":\"open Google Maps route on smartphone\",\"FoodEstablishment\":\"Where to eat\",\"LodgingBusiness\":\"Where to sleep\",\"TouristDestination\":\"What to see\",\"TouristAttraction\":\"What to do\",\"Product\":\"Local products\",\"Service\":\"Services\",\"Event\":\"Events\",\"City\":\"Cities\",\"Wine\":\"Wines\"},\"suggestion\":{\"consult\":\"Check out\",\"thetutorial\":\"the tutorial\"},\"template\":{\"reset\":\"reset filters\",\"showresults\":\"Show results\",\"suggestiontitle\":\"Research suggestions\",\"reminder\":\"Don't forget,\\n I can answer your questions.\"},\"GDPR\":{\"title\":\"processing personal data transmitted to the bot\",\"message\":\"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.\",\"link\":\"open confidency policy\",\"buttonAccept\":\"I understand and I accept\",\"buttonRefuse\":\"I refuse\",\"messageAccepted\":\"your acceptation has been saved\",\"messageRefused\":\"your refusal has been saved\"},\"anghello\":{\"listening\":\"It's up to you, I'm listening...\",\"correct\":\"Correct\",\"dontknow\":\"I don't know\"},\"microphone\":{\"allow\":\"Please allow your browser to access the microphone to continue.\",\"rejected\":\"You have denied access to the microphone.\",\"instructions\":\"To use voice mode, please allow your browser to access the microphone.\",\"listening\":\"I'm listening\",\"trigger\":\"Press or say\",\"triggerwithoutname\":\"Tap to talk\"}}");

});

parcelRegister("cs0Qr", function(module, exports) {
module.exports = JSON.parse('{"1":"inicio","2":"canal de informaci\xf3n en directo","3":"tiempo","4":"n\xfameros de emergencia","1000":"historia","1001":"tutorial","common":{"all":"todos","back":"volver","close":"cerrar","continue":"continuar","download":"descargar","downloadsheet":"descargar esta hoja","downloadsheetmobile":"descargar esta hoja en el tel\xe9fono inteligente","filter":"filtrar","history":"historia","knowmore":"Saber m\xe1s","lang":"idiomas","menu":"men\xfa","mode":"modo","needhelp":"necesitar ayuda ?","parameters":"par\xe1metros","print":"imprime","printsheet":"imprime esta hoja","result":"resultado","results":"resultados","singleLang":"idioma","sound":"sonido","submit":"enviar","subtitle":"subt\xedtulos","tutorial":"tutorial","validate":"valide"},"emergency":{"samu":"samu","police":"polic\xeda","firefighter":"bomberos","general":"general","citypolice":"Polic\xeda Local","hospital":"Hospital","homeless":"Personas sin hogar (llamada gratuita)","poison":"Centro de control de venenos","emergency":"Emergencias europeas"},"error":{"title":"Se ha producido un error","button":"Vuelva a iniciar la aplicaci\xf3n"},"history":{"title":"historial de chat"},"inputs":{"choose":"Elija una respuesta"},"language":{"change":"cambiar el idioma","select":"seleccione la lengua que desea utilizar"},"link":{"buttontext":"Ver el documento","goto":"Ir a la direcci\xf3n","click":"Haga clic aqu\xed","scanQR":"escaneando el QrCode","scanQRTile":"Escanea el c\xf3digo QR para descubrir"},"loader":{"loader":{"optimal":"Para una experiencia \xf3ptima,","classic":"Para una experiencia m\xe1s cl\xe1sica,","vocal":"Me comunico hablando con el agente.","text":"Me comunico por SMS con el agente."},"modes":{"vocal":"modo vocal","text":"modo texto"},"loaderValidation":"Iniciar conversaci\xf3n","locale":"comprobar configuraci\xf3n regional","supported":"comprobaci\xf3n de las configuraciones regionales admitidas","store":"crear tienda","directline":"conexi\xf3n directline","ponyfill":"creaci\xf3n del ponyfill","addressdata":"recuperar datos"},"menu":{"message":"Escriba su mensaje","backconversation":"volver a la conversaci\xf3n","answer":" responde a tus preguntas"},"mobileLandscapePreventer":{"firstline":"Para una experiencia \xf3ptima","secondline":"voltea la pantalla"},"news":{"warningtext":"Est\xe1 a punto de acceder al canal de informaci\xf3n, el sonido de su dispositivo se activar\xe1","live":"en directo","continuous":"continuo"},"poi":{"comment":"revisi\xf3n del cliente","route":"ruta","nodata":"Ning\xfan contenido corresponde a su b\xfasqueda","openinghours":"Horario de apertura","prices":"Precios","paymentmethods":"M\xe9todos de pago","numberofplaces":"numero de lugares","openroutemobile":"abrir la ruta de Google Maps en el tel\xe9fono inteligente","FoodEstablishment":"D\xf3nde comer","LodgingBusiness":"D\xf3nde dormir","TouristDestination":"Qu\xe9 ver","TouristAttraction":"Qu\xe9 hacer","Product":"Productos locales","Service":"Servicios","Event":"Eventos","City":"Ciudades","Wine":"Vinos"},"suggestion":{"consult":"Mira","thetutorial":"el tutorial"},"template":{"reset":"restablecer filtros","showresults":"Mostrar resultados","suggestiontitle":"Sugerencias de investigaci\xf3n","reminder":"No olvide :\\n puedo responder a sus preguntas."},"anghello":{"listening":"Te toca a ti, te escucho...","correct":"Corregir","dontknow":"No lo s\xe9"},"microphone":{"allow":"Por favor, autorice a su navegador para acceder al micr\xf3fono para continuar.","rejected":"Ha denegado el acceso al micr\xf3fono.","instructions":"Para usar el modo de voz, por favor, autorice a su navegador para acceder al micr\xf3fono.","listening":"Estoy escuchando","trigger":"Pulsa o di","triggerwithoutname":"Toca para hablar"}}');

});

parcelRegister("ecRvl", function(module, exports) {
module.exports = JSON.parse('{"1":"inicio","2":"canal de informaci\xf3n en directo","3":"tiempo","4":"n\xfameros de emergencia","1000":"historia","1001":"tutorial","common":{"all":"todos","back":"volver","close":"cerrar","continue":"continuar","download":"descargar","downloadsheet":"descargar esta hoja","downloadsheetmobile":"descargar esta hoja en el tel\xe9fono inteligente","filter":"filtrar","history":"historia","knowmore":"Saber m\xe1s","lang":"idiomas","menu":"men\xfa","mode":"modo","needhelp":"necesitar ayuda ?","parameters":"par\xe1metros","print":"imprime","printsheet":"imprime esta hoja","result":"resultado","results":"resultados","singleLang":"idioma","sound":"sonido","submit":"enviar","subtitle":"subt\xedtulos","tutorial":"tutorial","validate":"valide"},"emergency":{"samu":"samu","police":"polic\xeda","firefighter":"bomberos","general":"general","citypolice":"Polic\xeda Local","hospital":"Hospital","homeless":"Personas sin hogar (llamada gratuita)","poison":"Centro de control de venenos","emergency":"Emergencias europeas"},"error":{"title":"Se ha producido un error","button":"Vuelva a iniciar la aplicaci\xf3n"},"history":{"title":"historial de chat"},"inputs":{"choose":"Elija una respuesta"},"language":{"change":"cambiar el idioma","select":"seleccione la lengua que desea utilizar"},"link":{"buttontext":"Ver el documento","goto":"Ir a la direcci\xf3n","click":"Haga clic aqu\xed","scanQR":"escaneando el QrCode","scanQRTile":"Escanea el c\xf3digo QR para descubrir"},"loader":{"loader":{"optimal":"Para una experiencia \xf3ptima,","classic":"Para una experiencia m\xe1s cl\xe1sica,","vocal":"Me comunico hablando con el agente.","text":"Me comunico por SMS con el agente."},"modes":{"vocal":"modo vocal","text":"modo texto"},"loaderValidation":"Iniciar conversaci\xf3n","locale":"comprobar configuraci\xf3n regional","supported":"comprobaci\xf3n de las configuraciones regionales admitidas","store":"crear tienda","directline":"conexi\xf3n directline","ponyfill":"creaci\xf3n del ponyfill","addressdata":"recuperar datos"},"menu":{"message":"Escriba su mensaje","backconversation":"volver a la conversaci\xf3n","answer":" responde a tus preguntas"},"mobileLandscapePreventer":{"firstline":"Para una experiencia \xf3ptima","secondline":"voltea la pantalla"},"news":{"warningtext":"Est\xe1 a punto de acceder al canal de informaci\xf3n, el sonido de su dispositivo se activar\xe1","live":"en directo","continuous":"continuo"},"poi":{"comment":"revisi\xf3n del cliente","route":"ruta","nodata":"Ning\xfan contenido corresponde a su b\xfasqueda","openinghours":"Horario de apertura","prices":"Precios","paymentmethods":"M\xe9todos de pago","numberofplaces":"numero de lugares","openroutemobile":"abrir la ruta de Google Maps en el tel\xe9fono inteligente","FoodEstablishment":"D\xf3nde comer","LodgingBusiness":"D\xf3nde dormir","TouristDestination":"Qu\xe9 ver","TouristAttraction":"Qu\xe9 hacer","Product":"Productos locales","Service":"Servicios","Event":"Eventos","City":"Ciudades","Wine":"Vinos"},"suggestion":{"consult":"Mira","thetutorial":"el tutorial"},"template":{"reset":"restablecer filtros","showresults":"Mostrar resultados","suggestiontitle":"Sugerencias de investigaci\xf3n","reminder":"No olvide :\\n puedo responder a sus preguntas."},"anghello":{"listening":"Te toca a ti, te escucho...","correct":"Corregir","dontknow":"No lo s\xe9"},"microphone":{"allow":"Por favor, autorice a su navegador para acceder al micr\xf3fono para continuar.","rejected":"Ha denegado el acceso al micr\xf3fono.","instructions":"Para usar el modo de voz, por favor, autorice a su navegador para acceder al micr\xf3fono.","listening":"Estoy escuchando","trigger":"Pulsa o di","triggerwithoutname":"Toca para hablar"}}');

});

parcelRegister("gw5Pl", function(module, exports) {
module.exports = JSON.parse('{"1":"kotisivu","2":"live-uutiskanava","3":"S\xe4\xe4tiedotus","4":"H\xe4t\xe4numerot","1000":"historiallinen","1001":"opetusohjelma","common":{"all":"kaikki","back":"takaisin","close":"kiinni","continue":"Jatkaa","download":"ladata","downloadsheet":"lataa t\xe4m\xe4 taulukko","downloadsheetmobile":"lataa t\xe4m\xe4 taulukko \xe4lypuhelimeen","filter":"Suodattaa","history":"historiallinen","knowmore":"Lue lis\xe4\xe4","lang":"KIELET","menu":"valikosta","mode":"muoti","needhelp":"Tarvitsetko apua?","parameters":"asetukset","print":"Tulosta","printsheet":"Tulosta t\xe4m\xe4 arkki","result":"tulos","results":"tuloksia","singleLang":"Kieli","sound":"h\xe4nen","submit":"L\xe4het\xe4","subtitle":"alaotsikko","tutorial":"opetusohjelma","validate":"vahvistaa"},"emergency":{"samu":"S.A.M.U.","police":"Poliisi","firefighter":"palomiehi\xe4","general":"yleist\xe4","citypolice":"Paikallinen poliisi","hospital":"Sairaala","homeless":"Asunnoton (ilmainen puhelu)","poison":"Poison Control Center","emergency":"Euroopan h\xe4t\xe4tilanteita"},"error":{"title":"Tapahtui virhe","button":"K\xe4ynnist\xe4 sovellus uudelleen"},"history":{"title":"keskusteluhistoria"},"inputs":{"choose":"Valitse vastaus"},"language":{"change":"vaihtaa kielt\xe4","select":"valitse kieli, jota haluat k\xe4ytt\xe4\xe4"},"link":{"buttontext":"N\xe4yt\xe4 asiakirja","goto":"Mene osoitteeseen","click":"Klikkaa t\xe4st\xe4","scanQR":"skannaamalla QR-koodin","scanQRTile":"Skannaa QR-koodi saadaksesi selville"},"loader":{"loader":{"optimal":"Optimaalisen kokemuksen saamiseksi","classic":"Klassisemman kokemuksen saamiseksi","vocal":"Puhun kasvotusten agentin kanssa.","text":"Olen yhteydess\xe4 v\xe4litt\xe4j\xe4\xe4n kirjallisesti."},"modes":{"vocal":"laulutila","text":"tekstitila"},"loaderValidation":"Aloita keskustelu","locale":"kielen tarkistaminen","supported":"tuettujen kielten tarkistaminen","addressdata":"tietojen hakeminen"},"menu":{"message":"Kirjoita viestisi","backconversation":"takaisin keskusteluun","answer":" vastaa kysymyksiisi"},"mobileLandscapePreventer":{"firstline":"Optimaalisen kokemuksen saamiseksi","secondline":"k\xe4\xe4nn\xe4 n\xe4ytt\xf6\xe4si"},"news":{"warningtext":"P\xe4\xe4set uutiskanavalle, laitteesi \xe4\xe4ni aktivoituu","live":"el\xe4\xe4","continuous":"jatkuvasti"},"poi":{"comment":"Asiakaspalaute","route":"tie","nodata":"Mik\xe4\xe4n sis\xe4lt\xf6 ei vastaa hakuasi","openinghours":"Aukioloajat","prices":"hinnat","paymentmethods":"Maksutavat","numberofplaces":"paikkojen m\xe4\xe4r\xe4","openroutemobile":"avaa Google Maps -reitti \xe4lypuhelimella","FoodEstablishment":"Miss\xe4 sy\xf6d\xe4","LodgingBusiness":"Miss\xe4 nukkua","TouristDestination":"Mit\xe4 n\xe4hd\xe4","TouristAttraction":"Mit\xe4 tehd\xe4","Product":"Paikalliset tuotteet","Service":"Palvelut","Event":"Tapahtumat","City":"kaupungit","Wine":"Viinit"},"suggestion":{"consult":"Tarkista","thetutorial":"opetusohjelma"},"template":{"reset":"nollaa kaikki","showresults":"N\xe4yt\xe4 tulokset","suggestiontitle":"Hakuehdotukset","reminder":"\xc4l\xe4 unohda, \\n voin vastata kysymyksiisi."},"anghello":{"listening":"Se on sinusta kiinni, kuuntelen...","correct":"Korjata","dontknow":"En tied\xe4"},"microphone":{"allow":"Salli selaimesi k\xe4ytt\xe4\xe4 mikrofonia jatkaaksesi.","rejected":"Olet kielt\xe4nyt p\xe4\xe4syn mikrofonille.","instructions":"\xc4\xe4nitilassa k\xe4ytt\xe4mist\xe4 varten salli selaimesi k\xe4ytt\xe4\xe4 mikrofonia.","listening":"Min\xe4 kuuntelen","trigger":"Napsauta tai sano","triggerwithoutname":"Napauta puhuaksesi"}}');

});

parcelRegister("1ZXrl", function(module, exports) {
module.exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","knowmore":"En savoir +","lang":"langues","menu":"menu","mode":"mode","needhelp":"Besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttontext":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"},"anghello":{"listening":"C\'est \xe0 vous, je vous \xe9coute...","correct":"Corriger","dontknow":"Je ne sais pas"},"microphone":{"allow":"Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.","rejected":"Vous avez refus\xe9 l\'acc\xe8s au micro.","instructions":"Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.","listening":"Je vous \xe9coute","trigger":"Appuyez ou dites","triggerwithoutname":"Appuyez pour parler"}}');

});

parcelRegister("476o5", function(module, exports) {
module.exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","knowmore":"En savoir +","lang":"langues","menu":"menu","mode":"mode","needhelp":"Besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttontext":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"},"anghello":{"listening":"C\'est \xe0 vous, je vous \xe9coute...","correct":"Corriger","dontknow":"Je ne sais pas"},"microphone":{"allow":"Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.","rejected":"Vous avez refus\xe9 l\'acc\xe8s au micro.","instructions":"Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.","listening":"Je vous \xe9coute","trigger":"Appuyez ou dites","triggerwithoutname":"Appuyez pour parler"}}');

});

parcelRegister("8mOEg", function(module, exports) {
module.exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","knowmore":"En savoir +","lang":"langues","menu":"menu","mode":"mode","needhelp":"Besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttontext":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"},"anghello":{"listening":"C\'est \xe0 vous, je vous \xe9coute...","correct":"Corriger","dontknow":"Je ne sais pas"},"microphone":{"allow":"Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.","rejected":"Vous avez refus\xe9 l\'acc\xe8s au micro.","instructions":"Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.","listening":"Je vous \xe9coute","trigger":"Appuyez ou dites","triggerwithoutname":"Appuyez pour parler"}}');

});

parcelRegister("72eSH", function(module, exports) {
module.exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","knowmore":"En savoir +","lang":"langues","menu":"menu","mode":"mode","needhelp":"Besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse","noaction":"Une action est attendue"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttontext":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"},"anghello":{"listening":"C\'est \xe0 vous, je vous \xe9coute...","correct":"Corriger","dontknow":"Je ne sais pas"},"microphone":{"allow":"Veuillez autoriser votre navigateur \xe0 acc\xe9der au micro pour continuer.","rejected":"Vous avez refus\xe9 l\'acc\xe8s au micro.","instructions":"Pour utiliser le mode vocal, veuillez autoriser votre navigateur \xe0 acc\xe9der au micro.","listening":"Je vous \xe9coute","trigger":"Appuyez ou dites","triggerwithoutname":"Appuyez pour parler"}}');

});

parcelRegister("90eWJ", function(module, exports) {
module.exports = JSON.parse('{"1":"\u0939\u094B\u092E \u092A\u0947\u091C","2":"\u0932\u093E\u0907\u0935 \u0928\u094D\u092F\u0942\u091C\u093C \u091A\u0948\u0928\u0932","3":"\u092E\u094C\u0938\u092E \u0915\u0940 \u0930\u093F\u092A\u094B\u0930\u094D\u091F","4":"\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0928\u0902\u092C\u0930","1000":"\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915","1001":"\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932","common":{"all":"\u0938\u092D\u0940","back":"\u092A\u0940\u091B\u0947","close":"\u092C\u0902\u0926 \u0915\u0930\u0928\u093E","continue":"\u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u093E","download":"\u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0928\u093E","downloadsheet":"\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902","downloadsheetmobile":"\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u092A\u0930 \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902","filter":"\u092B\u093C\u093F\u0932\u094D\u091F\u0930","history":"\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915","knowmore":"\u0905\u0927\u093F\u0915 \u091C\u093E\u0928\u0947\u0902","lang":"\u092C\u094B\u0932\u0940","menu":"\u092E\u0947\u0928\u094D\u092F\u0942","mode":"\u092A\u0939\u0928\u093E\u0935\u093E","needhelp":"\u092E\u0926\u0926 \u0915\u0940 \u091C\u093C\u0930\u0942\u0930\u0924 \u0939\u0948?","parameters":"\u0938\u092E\u093E\u092F\u094B\u091C\u0928","print":"\u091B\u093E\u092A","printsheet":"\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u092A\u094D\u0930\u093F\u0902\u091F \u0915\u0930\u0947\u0902","result":"\u092A\u0930\u093F\u0923\u093E\u092E","results":"\u092A\u0930\u093F\u0923\u093E\u092E","singleLang":"\u092D\u093E\u0937\u093E","sound":"\u0909\u0938\u0915\u0940","submit":"\u091C\u092E\u093E \u0915\u0930\u0928\u093E","subtitle":"\u0909\u092A\u0936\u0940\u0930\u094D\u0937\u0915","tutorial":"\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932","validate":"\u092E\u093E\u0928\u094D\u092F"},"emergency":{"samu":"\u090F\u0938.\u090F.\u090F\u092E.\u092F\u0942.","police":"\u092A\u0941\u0932\u093F\u0938","firefighter":"\u0905\u0917\u094D\u0928\u093F\u0936\u092E\u0928 \u0915\u0930\u094D\u092E\u0940","general":"\u091C\u0928\u0930\u0932","citypolice":"\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u092A\u0941\u0932\u093F\u0938","hospital":"\u0905\u0938\u094D\u092A\u0924\u093E\u0932","homeless":"\u092C\u0947\u0918\u0930 (\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0915\u0949\u0932)","poison":"\u091C\u093C\u0939\u0930 \u0928\u093F\u092F\u0902\u0924\u094D\u0930\u0923 \u0915\u0947\u0902\u0926\u094D\u0930","emergency":"\u092F\u0942\u0930\u094B\u092A\u0940\u092F \u0906\u092A\u093E\u0924\u0915\u093E\u0932"},"error":{"title":"\u090F\u0915 \u0917\u0932\u0924\u0940 \u0939\u0941\u0908 \u0939\u0948","button":"\u090F\u092A\u094D\u0932\u093F\u0915\u0947\u0936\u0928 \u0915\u094B \u092A\u0941\u0928\u0903 \u0932\u0949\u0928\u094D\u091A \u0915\u0930\u0947\u0902"},"history":{"title":"\u092C\u093E\u0924\u091A\u0940\u0924 \u0915\u093E \u0907\u0924\u093F\u0939\u093E\u0938"},"inputs":{"choose":"\u090F\u0915 \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902"},"language":{"change":"\u092D\u093E\u0937\u093E \u092C\u0926\u0932\u094B","select":"\u0935\u0939 \u092D\u093E\u0937\u093E \u091A\u0941\u0928\u0947\u0902 \u091C\u093F\u0938\u0915\u093E \u0906\u092A \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902"},"link":{"buttontext":"\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0926\u0947\u0916\u0947\u0902","goto":"\u092A\u0924\u0947 \u092A\u0930 \u091C\u093E\u090F\u0902","click":"\u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902","scanQR":"QrCode \u0915\u094B \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0915\u0947","scanQRTile":"\u0915\u094D\u092F\u0942\u0906\u0930 \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u091C\u093E\u0928\u0947\u0902"},"loader":{"loader":{"optimal":"\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","classic":"\u0905\u0927\u093F\u0915 \u0915\u094D\u0932\u093E\u0938\u093F\u0915 \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","vocal":"\u092E\u0948\u0902 \u090F\u091C\u0947\u0902\u091F \u0938\u0947 \u0906\u092E\u0928\u0947-\u0938\u093E\u092E\u0928\u0947 \u092C\u093E\u0924 \u0915\u0930\u0924\u093E \u0939\u0942\u0902\u0964","text":"\u092E\u0948\u0902 \u090F\u091C\u0947\u0902\u091F \u0915\u0947 \u0938\u093E\u0925 \u0932\u093F\u0916\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u0902\u0935\u093E\u0926 \u0915\u0930\u0924\u093E \u0939\u0942\u0902\u0964"},"modes":{"vocal":"\u0938\u094D\u0935\u0930 \u0935\u093F\u0927\u093E","text":"\u092A\u093E\u0920 \u092E\u094B\u0921"},"loaderValidation":"\u092C\u093E\u0924\u091A\u0940\u0924 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902","locale":"\u092D\u093E\u0937\u093E \u0915\u0940 \u091C\u093E\u0901\u091A \u0915\u0930\u0928\u093E","supported":"\u0938\u092E\u0930\u094D\u0925\u093F\u0924 \u092D\u093E\u0937\u093E\u0913\u0902 \u0915\u0940 \u091C\u093E\u0901\u091A \u0915\u0930\u0928\u093E","addressdata":"\u092A\u0941\u0928: \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0921\u0947\u091F\u093E"},"menu":{"message":"\u0905\u092A\u0928\u093E \u0938\u0902\u0926\u0947\u0936 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902","backconversation":"\u092C\u093E\u0924\u091A\u0940\u0924 \u092A\u0930 \u0935\u093E\u092A\u0938","answer":" \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902 \u0915\u093E \u0909\u0924\u094D\u0924\u0930 \u0926\u0947\u0924\u093E \u0939\u0948"},"mobileLandscapePreventer":{"firstline":"\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","secondline":"\u0905\u092A\u0928\u0940 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0932\u091F\u0947\u0902"},"news":{"warningtext":"\u0906\u092A \u0938\u092E\u093E\u091A\u093E\u0930 \u091A\u0948\u0928\u0932 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u092A\u093E\u090F\u0902\u0917\u0947, \u0906\u092A\u0915\u0947 \u0921\u093F\u0935\u093E\u0907\u0938 \u092A\u0930 \u0927\u094D\u0935\u0928\u093F \u0938\u0915\u094D\u0930\u093F\u092F \u0939\u094B \u091C\u093E\u090F\u0917\u0940","live":"\u0930\u0939\u0928\u093E","continuous":"\u0932\u0917\u093E\u0924\u093E\u0930"},"poi":{"comment":"\u0917\u094D\u0930\u093E\u0939\u0915 \u0938\u092E\u0940\u0915\u094D\u0937\u093E","route":"\u0938\u0921\u093C\u0915","nodata":"\u0915\u094B\u0908 \u092D\u0940 \u0938\u093E\u092E\u0917\u094D\u0930\u0940 \u0906\u092A\u0915\u0940 \u0916\u094B\u091C \u0938\u0947 \u092E\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093E\u0924\u0940","openinghours":"\u0916\u0941\u0932\u0928\u0947 \u0915\u093E \u0938\u092E\u092F","prices":"\u0915\u0940\u092E\u0924\u094B\u0902","paymentmethods":"\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0940 \u0935\u093F\u0927\u093F","numberofplaces":"\u0938\u094D\u0925\u093E\u0928\u094B\u0902 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E","openroutemobile":"\u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u092A\u0930 \u0917\u0942\u0917\u0932 \u092E\u0948\u092A \u0930\u0942\u091F \u0916\u094B\u0932\u0947\u0902","FoodEstablishment":"\u0915\u0939\u093E\u0901 \u0916\u093E\u0928\u093E \u0939\u0948","LodgingBusiness":"\u0915\u0939\u093E\u0901 \u0938\u094B\u0928\u093E \u0939\u0948","TouristDestination":"\u0915\u094D\u092F\u093E \u0926\u0947\u0916\u0947\u0902","TouristAttraction":"\u0915\u094D\u092F\u093E \u0915\u0930\u0947\u0902","Product":"\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u0909\u0924\u094D\u092A\u093E\u0926","Service":"\u0938\u0947\u0935\u093E\u090F\u0902","Event":"\u0906\u092F\u094B\u091C\u0928","City":"\u0936\u0939\u0930\u094B\u0902","Wine":"\u0935\u093E\u0907\u0928"},"suggestion":{"consult":"\u091A\u0947\u0915 \u0906\u0909\u091F","thetutorial":"\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932"},"template":{"reset":"\u0938\u092D\u0940 \u0915\u094B \u092A\u0941\u0928\u0903 \u0924\u0948\u092F\u093E\u0930 \u0915\u0930\u0928\u093E","showresults":"\u092A\u0930\u093F\u0923\u093E\u092E \u0926\u093F\u0916\u093E\u090F\u0901","suggestiontitle":"\u0938\u0941\u091D\u093E\u0935 \u0916\u094B\u091C\u0947\u0902","reminder":"\u092E\u0924 \u092D\u0942\u0932\u093F\u090F, \\n \u092E\u0948\u0902 \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902 \u0915\u093E \u0909\u0924\u094D\u0924\u0930 \u0926\u0947 \u0938\u0915\u0924\u093E \u0939\u0942\u0901\u0964"},"anghello":{"listening":"\u092F\u0939 \u0906\u092A \u092A\u0930 \u0939\u0948, \u092E\u0948\u0902 \u0938\u0941\u0928 \u0930\u0939\u093E \u0939\u0942\u0902...","correct":"\u0938\u0941\u0927\u093E\u0930\u0947\u0902","dontknow":"\u092E\u0941\u091D\u0947 \u0928\u0939\u0940\u0902 \u092A\u0924\u093E"},"microphone":{"allow":"\u0915\u0943\u092A\u092F\u093E \u0906\u0917\u0947 \u092C\u0922\u093C\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u094B\u0928 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0926\u0947\u0902\u0964","rejected":"\u0906\u092A\u0928\u0947 \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u094B\u0928 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u0915\u094B \u0905\u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930 \u0926\u093F\u092F\u093E \u0939\u0948\u0964","instructions":"\u0935\u0949\u092F\u0938 \u092E\u094B\u0921 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u094B\u0928 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0926\u0947\u0902\u0964","listening":"\u092E\u0948\u0902 \u0938\u0941\u0928 \u0930\u0939\u093E \u0939\u0942\u0901","trigger":"\u092A\u094D\u0930\u0947\u0938 \u092F\u093E \u092C\u094B\u0932\u0947","triggerwithoutname":"\u092C\u093E\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u091F\u0948\u092A \u0915\u0930\u0947\u0902"}}');

});

parcelRegister("gUwFA", function(module, exports) {
module.exports = JSON.parse('{"1":"kezd\u0151lap","2":"\xe9l\u0151 h\xedrcsatorna","3":"id\u0151j\xe1r\xe1s jelent\xe9s","4":"Seg\xe9lyh\xedv\xf3 sz\xe1mok","1000":"t\xf6rt\xe9nelmi","1001":"oktat\xf3anyag","common":{"all":"minden","continue":"Folytatni","download":"Let\xf6lt\xe9s","downloadsheet":"T\xf6ltse le ezt a lapot","downloadsheetmobile":"t\xf6ltse le ezt a lapot okostelefonra","filter":"Sz\u0171r\u0151","history":"t\xf6rt\xe9nelmi","knowmore":"Tudj meg t\xf6bbet","lang":"NYELVEK","menu":"men\xfc","mode":"divat","needhelp":"Kell seg\xedts\xe9g?","parameters":"be\xe1ll\xedt\xe1sok","print":"Nyomtat\xe1s","printsheet":"Nyomtassa ki ezt a lapot","result":"eredm\xe9ny","results":"eredm\xe9nyek","singleLang":"nyelv","sound":"neki","submit":"Bek\xfcld\xe9s","subtitle":"felirat","tutorial":"oktat\xf3anyag","validate":"\xe9rv\xe9nyes\xedt"},"emergency":{"samu":"S.A.M.U.","police":"rend\u0151rs\xe9g","firefighter":"t\u0171zolt\xf3k","general":"t\xe1bornoki","citypolice":"Helyi rend\u0151rs\xe9g","hospital":"K\xf3rh\xe1z","homeless":"Hajl\xe9ktalanok (ingyenes h\xedv\xe1s)","poison":"M\xe9regellen\u0151rz\u0151 K\xf6zpont","emergency":"eur\xf3pai v\xe9szhelyzetek"},"error":{"title":"Hiba t\xf6rt\xe9nt","button":"Ind\xedtsa \xfajra az alkalmaz\xe1st"},"history":{"title":"besz\xe9lget\xe9s el\u0151zm\xe9nyei"},"inputs":{"choose":"V\xe1lasszon egy v\xe1laszt"},"language":{"change":"v\xe1ltoztassa meg a nyelvet","select":"v\xe1lassza ki a haszn\xe1lni k\xedv\xe1nt nyelvet"},"link":{"buttontext":"Tekintse meg a dokumentumot","goto":"Menjen a c\xedmre","click":"Kattints ide","scanQR":"a QR-k\xf3d beolvas\xe1s\xe1val","scanQRTile":"Olvassa be a QR-k\xf3dot a felfedez\xe9shez"},"loader":{"loader":{"optimal":"Az optim\xe1lis \xe9lm\xe9ny \xe9rdek\xe9ben","classic":"A klasszikusabb \xe9lm\xe9ny \xe9rdek\xe9ben","vocal":"N\xe9gyszemk\xf6zt besz\xe9lek az \xfcgyn\xf6kkel.","text":"\xcdr\xe1sban kommunik\xe1lok az \xfcgyn\xf6kkel."},"modes":{"vocal":"vok\xe1lis m\xf3d","text":"sz\xf6veges m\xf3d"},"loaderValidation":"Ind\xedtsa el a besz\xe9lget\xe9st","locale":"nyelv ellen\u0151rz\xe9se","supported":"t\xe1mogatott nyelvek ellen\u0151rz\xe9se","addressdata":"adatok lek\xe9r\xe9se"},"menu":{"message":"\xcdrja be \xfczenet\xe9t","back":"vissza","backconversation":"vissza a besz\xe9lget\xe9shez","close":"Bez\xe1r\xe1s","answer":" v\xe1laszol a k\xe9rd\xe9seidre"},"mobileLandscapePreventer":{"firstline":"\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","secondline":"\u0905\u092A\u0928\u0940 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0932\u091F\u0947\u0902"},"news":{"warningtext":"Hozz\xe1f\xe9r a h\xedrcsatorn\xe1hoz, \xe9s a k\xe9sz\xfcl\xe9k hangja aktiv\xe1l\xf3dik","live":"\xe9l\u0151","continuous":"folyamatosan"},"poi":{"comment":"felhaszn\xe1l\xf3i \xe9rt\xe9kel\xe9s","route":"\xfat","nodata":"Egyetlen tartalom sem felel meg a keres\xe9snek","openinghours":"Nyitvatart\xe1si id\u0151","prices":"\xc1rak","paymentmethods":"Fizet\xe9si m\xf3dok","numberofplaces":"helyek sz\xe1ma","openroutemobile":"nyissa meg a Google Maps \xfatvonalat az okostelefonon","FoodEstablishment":"Hol tudok enni","LodgingBusiness":"Hol kell aludni","TouristDestination":"Mit kell l\xe1tni","TouristAttraction":"Mit kell tenni","Product":"Helyi term\xe9kek","Service":"Szolg\xe1ltat\xe1sok","Event":"Esem\xe9nyek","City":"V\xe1rosok","Wine":"Borok"},"suggestion":{"consult":"N\xe9zze meg","thetutorial":"az oktat\xf3anyag"},"template":{"reset":"minden vissza\xe1ll\xedt\xe1sa","showresults":"Mutasd meg az eredm\xe9nyeket","suggestiontitle":"Keres\xe9si javaslatok","reminder":"Ne felejtsd el, \\n tudok v\xe1laszolni a k\xe9rd\xe9seidre."},"anghello":{"listening":"\xd6n\xf6n m\xfalik, hallgatok...","correct":"Korrig\xe1lni","dontknow":"Nem tudom"},"microphone":{"allow":"K\xe9rj\xfck, enged\xe9lyezze a b\xf6ng\xe9sz\u0151 sz\xe1m\xe1ra a mikrofonhoz val\xf3 hozz\xe1f\xe9r\xe9st a folytat\xe1shoz.","rejected":"Elutas\xedtotta a mikrofonhoz val\xf3 hozz\xe1f\xe9r\xe9st.","instructions":"A hang m\xf3d haszn\xe1lat\xe1hoz k\xe9rj\xfck, enged\xe9lyezze a b\xf6ng\xe9sz\u0151 sz\xe1m\xe1ra a mikrofonhoz val\xf3 hozz\xe1f\xe9r\xe9st.","listening":"Hallgatlak","trigger":"Nyomja vagy mondja","triggerwithoutname":"\xc9rintse meg a besz\xe9ldhez"}}');

});

parcelRegister("4oHlA", function(module, exports) {
module.exports = JSON.parse("{\"1\":\"halaman rumah\",\"2\":\"saluran berita langsung\",\"3\":\"laporan cuaca\",\"4\":\"Nomor darurat\",\"1000\":\"historis\",\"1001\":\"tutorial\",\"common\":{\"all\":\"semua\",\"continue\":\"Melanjutkan\",\"download\":\"unduh\",\"downloadsheet\":\"unduh lembar ini\",\"downloadsheetmobile\":\"unduh lembar ini di ponsel pintar\",\"filter\":\"Saring\",\"history\":\"historis\",\"knowmore\":\"Ketahui lebih lanjut\",\"lang\":\"BAHASA\",\"menu\":\"menu\",\"mode\":\"mode\",\"needhelp\":\"Butuh bantuan?\",\"parameters\":\"pengaturan\",\"print\":\"Mencetak\",\"printsheet\":\"Cetak lembar ini\",\"result\":\"hasil\",\"results\":\"hasil\",\"singleLang\":\"bahasa\",\"sound\":\"dia\",\"submit\":\"kirim\",\"subtitle\":\"subjudul\",\"tutorial\":\"tutorial\",\"validate\":\"mengesahkan\"},\"emergency\":{\"samu\":\"S.A.M.U.\",\"police\":\"POLISI\",\"firefighter\":\"petugas pemadam kebakaran\",\"general\":\"umum\",\"citypolice\":\"Polisi setempat\",\"hospital\":\"RSUD\",\"homeless\":\"Tunawisma (panggilan gratis)\",\"poison\":\"Pusat Pengendalian Racun\",\"emergency\":\"keadaan darurat Eropa\"},\"error\":{\"title\":\"Sebuah kesalahan telah terjadi\",\"button\":\"Luncurkan kembali aplikasi\"},\"history\":{\"title\":\"riwayat percakapan\"},\"inputs\":{\"choose\":\"Pilih jawaban\"},\"language\":{\"change\":\"mengubah bahasa\",\"select\":\"pilih bahasa yang ingin Anda gunakan\"},\"link\":{\"buttontext\":\"Lihat dokumennya\",\"goto\":\"Pergi ke alamat\",\"click\":\"klik disini\",\"scanQR\":\"dengan memindai QrCode\",\"scanQRTile\":\"Pindai Kode QR untuk menemukan\"},\"loader\":{\"loader\":{\"optimal\":\"Untuk pengalaman optimal,\",\"classic\":\"Untuk pengalaman yang lebih klasik,\",\"vocal\":\"Saya berbicara tatap muka dengan agen.\",\"text\":\"Saya berkomunikasi secara tertulis dengan agen.\"},\"modes\":{\"vocal\":\"modus vokal\",\"text\":\"modus teks\"},\"loaderValidation\":\"Mulai percakapan\",\"locale\":\"memeriksa bahasa\",\"supported\":\"memeriksa bahasa yang didukung\",\"addressdata\":\"mengambil data\"},\"menu\":{\"message\":\"Masukkan pesan Anda\",\"back\":\"kembali\",\"backconversation\":\"kembali ke percakapan\",\"close\":\"menutup\",\"answer\":\" menjawab pertanyaan Anda\"},\"mobileLandscapePreventer\":{\"firstline\":\"Untuk pengalaman optimal,\",\"secondline\":\"balik layar Anda\"},\"news\":{\"warningtext\":\"Anda akan mengakses saluran berita, suara di perangkat Anda akan diaktifkan\",\"live\":\"hidup\",\"continuous\":\"terus menerus\"},\"poi\":{\"comment\":\"ulasan pelanggan\",\"route\":\"jalan\",\"nodata\":\"Tidak ada konten yang cocok dengan pencarian Anda\",\"openinghours\":\"Jam buka\",\"prices\":\"Harga\",\"paymentmethods\":\"Cara Pembayaran\",\"numberofplaces\":\"sejumlah tempat\",\"openroutemobile\":\"buka rute Google Maps di smartphone\",\"FoodEstablishment\":\"Tempat makan\",\"LodgingBusiness\":\"Tempat tidur\",\"TouristDestination\":\"Apa yang dilihat\",\"TouristAttraction\":\"Apa yang harus dilakukan\",\"Product\":\"Produk lokal\",\"Service\":\"Jasa\",\"Event\":\"Acara\",\"City\":\"kota\",\"Wine\":\"Anggur\"},\"suggestion\":{\"consult\":\"Periksa\",\"thetutorial\":\"tutorialnya\"},\"template\":{\"reset\":\"atur ulang semua\",\"showresults\":\"Tunjukkan hasilnya\",\"suggestiontitle\":\"Saran pencarian\",\"reminder\":\"Jangan lupa, \\n saya bisa menjawab pertanyaan Anda.\"},\"anghello\":{\"listening\":\"Terserah Anda, saya mendengarkan...\",\"correct\":\"Perbaiki\",\"dontknow\":\"Saya tidak tahu\"},\"microphone\":{\"allow\":\"Silakan izinkan browser Anda mengakses mikrofon untuk melanjutkan.\",\"rejected\":\"Anda telah menolak akses ke mikrofon.\",\"instructions\":\"Untuk menggunakan mode suara, silakan izinkan browser Anda mengakses mikrofon.\",\"listening\":\"Saya mendengar\",\"trigger\":\"Tekan atau katakan\",\"triggerwithoutname\":\"Ketuk untuk berbicara\"}}");

});

parcelRegister("lHWsA", function(module, exports) {
module.exports = JSON.parse('{"1":"pagina iniziale","2":"canale di notizie in diretta","3":"bollettino meteorologico","4":"Numeri di emergenza","1000":"storico","1001":"tutorial","common":{"all":"tutti","back":"Indietro","close":"chiudere","continue":"continuare","download":"scaricamento","downloadsheet":"scarica questa scheda","downloadsheetmobile":"scarica questa scheda sullo smartphone","filter":"Filtro","history":"storico","knowmore":"Scopri di pi\xf9","lang":"lingua","menu":"men\xf9","mode":"moda","needhelp":"Ho bisogno di aiuto?","parameters":"impostazioni","print":"Stampa","printsheet":"Stampa questo foglio","result":"risultato","results":"risultati","singleLang":"Lingua","sound":"suo","submit":"invia","subtitle":"sottotitolo","tutorial":"tutorial","validate":"convalidare"},"emergency":{"samu":"S.A.M.U.","police":"Polizia Stradale","firefighter":"vigili del fuoco","general":"generale","citypolice":"Polizia locale","hospital":"Ospedale","homeless":"Senzatetto (chiamata gratuita)","poison":"Centro antiveleni","emergency":"Emergenze europee"},"error":{"title":"C\'\xe8 stato un errore","button":"Riavviare l\'applicazione"},"history":{"title":"cronologia delle conversazioni"},"inputs":{"choose":"Scegli una risposta"},"language":{"change":"cambiare la lingua","select":"seleziona la lingua che desideri utilizzare"},"link":{"buttontext":"Visualizza il documento","goto":"Vai all\'indirizzo","click":"clicca qui","scanQR":"scansionando il QrCode","scanQRTile":"Scansiona il QR Code per scoprire"},"loader":{"loader":{"optimal":"Per un\'esperienza ottimale,","classic":"Per un\'esperienza pi\xf9 classica,","vocal":"Parlo faccia a faccia con l\'agente.","text":"Comunico per iscritto con l\'agente."},"modes":{"vocal":"modalit\xe0 vocale","text":"modalit\xe0 testo"},"loaderValidation":"Inizia la conversazione","locale":"controllo della lingua","supported":"verifica delle lingue supportate","addressdata":"recupero dati"},"menu":{"message":"Inserisci il tuo messaggio","backconversation":"torniamo alla conversazione","answer":" risponde alle tue domande"},"mobileLandscapePreventer":{"firstline":"Per un\'esperienza ottimale,","secondline":"capovolgi lo schermo"},"news":{"warningtext":"Accederai al canale delle notizie, l\'audio sul tuo dispositivo verr\xe0 attivato","live":"vivere","continuous":"continuamente"},"poi":{"comment":"recensione del cliente","route":"strada","nodata":"Nessun contenuto corrisponde alla tua ricerca","openinghours":"Orari di apertura","prices":"Prezzi","paymentmethods":"Modalit\xe0 di pagamento","numberofplaces":"numero di posti","openroutemobile":"apri il percorso di Google Maps sullo smartphone","FoodEstablishment":"Dove mangiare","LodgingBusiness":"Dove dormire","TouristDestination":"Cosa guardare","TouristAttraction":"Cosa fare","Product":"Prodotti locali","Service":"Servizi","Event":"Eventi","City":"Citt\xe0","Wine":"Vini"},"suggestion":{"consult":"Guardare","thetutorial":"il tutorial"},"template":{"reset":"resetta tutto","showresults":"Mostra i risultati","suggestiontitle":"Suggerimenti per la ricerca","reminder":"Non dimenticare, \\n posso rispondere alle tue domande."},"anghello":{"listening":"Dipende da te, ti ascolto...","correct":"Correggere","dontknow":"Non lo so"},"microphone":{"allow":"Si prega di consentire al browser di accedere al microfono per continuare.","rejected":"Hai rifiutato l\'accesso al microfono.","instructions":"Per utilizzare la modalit\xe0 vocale, si prega di consentire al browser di accedere al microfono.","listening":"Sto ascoltando","trigger":"Premi o dica","triggerwithoutname":"Tocca per parlare"}}');

});

parcelRegister("j2Gzi", function(module, exports) {
module.exports = JSON.parse('{"1":"\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8","2":"\u30E9\u30A4\u30D6\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB","3":"\u5929\u6C17\u4E88\u5831","4":"\u7DCA\u6025\u96FB\u8A71\u756A\u53F7","1000":"\u6B74\u53F2\u7684\u306A","1001":"\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB","common":{"all":"\u5168\u3066","back":"\u623B\u308B","close":"\u8FD1\u3044","continue":"\u7D9A\u304F","download":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","downloadsheet":"\u3053\u306E\u30B7\u30FC\u30C8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","downloadsheetmobile":"\u3053\u306E\u30B7\u30FC\u30C8\u3092\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","history":"\u6B74\u53F2\u7684\u306A","knowmore":"\u3082\u3063\u3068\u77E5\u308B","lang":"\u8A00\u8A9E","menu":"\u30E1\u30CB\u30E5\u30FC","mode":"\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","needhelp":"\u52A9\u3051\u304C\u5FC5\u8981\uFF1F","parameters":"\u8A2D\u5B9A","print":"\u5370\u5237\u3059\u308B","printsheet":"\u3053\u306E\u30B7\u30FC\u30C8\u3092\u5370\u5237\u3059\u308B","result":"\u7D50\u679C","results":"\u7D50\u679C","singleLang":"\u8A00\u8A9E","sound":"\u5F7C\u5973","submit":"\u63D0\u51FA\u3059\u308B","subtitle":"\u5B57\u5E55","tutorial":"\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB","validate":"\u691C\u8A3C"},"emergency":{"samu":"S.A.M.U","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u58EB","general":"\u4E00\u822C\u7684\u306A","citypolice":"\u5730\u5143\u8B66\u5BDF","hospital":"\u75C5\u9662","homeless":"\u30DB\u30FC\u30E0\u30EC\u30B9\uFF08\u7121\u6599\u901A\u8A71\uFF09","poison":"\u6BD2\u7269\u7BA1\u7406\u30BB\u30F3\u30BF\u30FC","emergency":"\u30E8\u30FC\u30ED\u30C3\u30D1\u306E\u7DCA\u6025\u4E8B\u614B"},"error":{"title":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","button":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u518D\u8D77\u52D5\u3059\u308B"},"history":{"title":"\u4F1A\u8A71\u5C65\u6B74"},"inputs":{"choose":"\u7B54\u3048\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"},"language":{"change":"\u8A00\u8A9E\u3092\u5909\u3048\u308B","select":"\u4F7F\u7528\u3057\u305F\u3044\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"},"link":{"buttontext":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u898B\u308B","goto":"\u4F4F\u6240\u306B\u79FB\u52D5","click":"\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF","scanQR":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u3053\u3068\u3067","scanQRTile":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u767A\u898B\u3059\u308B"},"loader":{"loader":{"optimal":"\u6700\u9069\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001","classic":"\u3088\u308A\u30AF\u30E9\u30B7\u30C3\u30AF\u306A\u4F53\u9A13\u3092\u3059\u308B\u306B\u306F\u3001","vocal":"\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3068\u5BFE\u9762\u3067\u8A71\u3057\u307E\u3059\u3002","text":"\u79C1\u306F\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3068\u66F8\u9762\u3067\u3084\u308A\u53D6\u308A\u3057\u307E\u3059\u3002"},"modes":{"vocal":"\u30DC\u30FC\u30AB\u30EB\u30E2\u30FC\u30C9","text":"\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9"},"loaderValidation":"\u4F1A\u8A71\u3092\u958B\u59CB\u3059\u308B","locale":"\u8A00\u8A9E\u3092\u30C1\u30A7\u30C3\u30AF\u3059\u308B","supported":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u8A00\u8A9E\u3092\u78BA\u8A8D\u3059\u308B","addressdata":"\u30C7\u30FC\u30BF\u306E\u53D6\u5F97"},"menu":{"message":"\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","backconversation":"\u4F1A\u8A71\u306B\u623B\u308A\u307E\u3059","answer":" \u3042\u306A\u305F\u306E\u8CEA\u554F\u306B\u7B54\u3048\u307E\u3059"},"mobileLandscapePreventer":{"firstline":"\u6700\u9069\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001","secondline":"\u753B\u9762\u3092\u53CD\u8EE2\u3057\u3066\u304F\u3060\u3055\u3044"},"news":{"warningtext":"\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30B5\u30A6\u30F3\u30C9\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u308A\u307E\u3059","live":"\u30E9\u30A4\u30D6","continuous":"\u7D99\u7D9A\u7684\u306B"},"poi":{"comment":"\u30AB\u30B9\u30BF\u30DE\u30FC\u30EC\u30D3\u30E5\u30FC","route":"\u9053","nodata":"\u691C\u7D22\u306B\u4E00\u81F4\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3042\u308A\u307E\u305B\u3093","openinghours":"\u55B6\u696D\u6642\u9593","prices":"\u4FA1\u683C","paymentmethods":"\u304A\u652F\u6255\u3044\u65B9\u6CD5","numberofplaces":"\u5834\u6240\u306E\u6570","openroutemobile":"\u30B9\u30DE\u30DB\u3067Google\u30DE\u30C3\u30D7\u306E\u30EB\u30FC\u30C8\u3092\u958B\u304F","FoodEstablishment":"\u3069\u3053\u3067\u98DF\u3079\u307E\u3059","LodgingBusiness":"\u3069\u3053\u3067\u5BDD\u308B\u304B","TouristDestination":"\u898B\u308B\u3079\u304D\u3082\u306E","TouristAttraction":"\u4F55\u3092\u3059\u308B\u304B","Product":"\u5730\u5143\u306E\u7279\u7523\u54C1","Service":"\u30B5\u30FC\u30D3\u30B9","Event":"\u30A4\u30D9\u30F3\u30C8","City":"\u90FD\u5E02","Wine":"\u30EF\u30A4\u30F3"},"suggestion":{"consult":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","thetutorial":"\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB"},"template":{"reset":"\u3059\u3079\u3066\u30EA\u30BB\u30C3\u30C8","showresults":"\u7D50\u679C\u3092\u8868\u793A\u3059\u308B","suggestiontitle":"\u691C\u7D22\u5019\u88DC","reminder":"\u5FD8\u308C\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3001\\n \u3042\u306A\u305F\u306E\u8CEA\u554F\u306B\u7B54\u3048\u307E\u3059\u3002"},"anghello":{"listening":"\u3042\u306A\u305F\u6B21\u7B2C\u3067\u3059\u3001\u79C1\u306F\u805E\u3044\u3066\u3044\u307E\u3059...","correct":"\u4FEE\u6B63\u3059\u308B","dontknow":"\u308F\u304B\u308A\u307E\u305B\u3093"},"microphone":{"allow":"\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u306B\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","rejected":"\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u307E\u3057\u305F\u3002","instructions":"\u97F3\u58F0\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u306B\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","listening":"\u805E\u3044\u3066\u307E\u3059\u3088","trigger":"\u62BC\u3059\u304B\u8A00\u3063\u3066\u304F\u3060\u3055\u3044","triggerwithoutname":"\u8A71\u3059\u306B\u306F\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044"}}');

});

parcelRegister("by8FM", function(module, exports) {
module.exports = JSON.parse('{"1":"\uD648\uD398\uC774\uC9C0","2":"\uB77C\uC774\uBE0C \uB274\uC2A4 \uCC44\uB110","3":"\uC77C\uAE30 \uC608\uBCF4","4":"\uAE34\uAE09 \uC804\uD654\uBC88\uD638","1000":"\uC5ED\uC0AC\uC801\uC778","1001":"\uC9C0\uB3C4 \uC2DC\uAC04","common":{"all":"\uBAA8\uB450","back":"\uB4A4\uCABD\uC5D0","close":"\uB2EB\uB2E4","continue":"\uACC4\uC18D\uD558\uB2E4","download":"\uB2E4\uC6B4\uB85C\uB4DC","downloadsheet":"\uC774 \uC2DC\uD2B8 \uB2E4\uC6B4\uB85C\uB4DC","downloadsheetmobile":"\uC774 \uC2DC\uD2B8\uB97C \uC2A4\uB9C8\uD2B8\uD3F0\uC5D0 \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC138\uC694","filter":"\uD544\uD130","history":"\uC5ED\uC0AC\uC801\uC778","knowmore":"\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30","lang":"\uC5B8\uC5B4","menu":"\uBA54\uB274","mode":"\uD328\uC158","needhelp":"\uB3C4\uC6C0\uC774 \uD544\uC694\uD558\uB2E4?","parameters":"\uC124\uC815","print":"\uC778\uC1C4","printsheet":"\uC774 \uC2DC\uD2B8\uB97C \uC778\uC1C4\uD558\uC138\uC694","result":"\uACB0\uACFC","results":"\uACB0\uACFC","singleLang":"\uC5B8\uC5B4","sound":"\uADF8\uB140\uC758","submit":"\uC81C\uCD9C\uD558\uB2E4","subtitle":"\uBD80\uC81C","tutorial":"\uC9C0\uB3C4 \uC2DC\uAC04","validate":"\uD655\uC778"},"emergency":{"samu":"S.A.M.U.","police":"\uACBD\uCC30","firefighter":"\uC18C\uBC29\uAD00","general":"\uC77C\uBC18\uC801\uC778","hospital":"\uBCD1\uC6D0","homeless":"\uB178\uC219\uC790","poison":"\uB3C5\uADF9\uBB3C \uAD00\uB9AC \uC13C\uD130","emergency":"\uAE34\uAE09 \uC0C1\uD669"},"error":{"title":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","button":"\uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC744 \uB2E4\uC2DC \uC2DC\uC791\uD558\uC138\uC694."},"history":{"title":"\uB300\uD654 \uAE30\uB85D"},"inputs":{"choose":"\uB2F5\uBCC0\uC744 \uC120\uD0DD\uD558\uC138\uC694"},"language":{"change":"\uC5B8\uC5B4\uB97C \uBC14\uAFD4\uB77C","select":"\uC0AC\uC6A9\uD558\uACE0 \uC2F6\uC740 \uC5B8\uC5B4\uB97C \uC120\uD0DD\uD558\uC138\uC694"},"link":{"buttontext":"\uBB38\uC11C \uBCF4\uAE30","goto":"\uC8FC\uC18C\uB85C \uC774\uB3D9","click":"\uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC138\uC694","scanQR":"QrCode\uB97C \uC2A4\uCE94\uD558\uC5EC","scanQRTile":"QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uBC1C\uACAC\uD558\uB2E4"},"loader":{"loader":{"optimal":"\uCD5C\uC801\uC758 \uACBD\uD5D8\uC744 \uC704\uD574,","classic":"\uC880 \uB354 \uD074\uB798\uC2DD\uD55C \uACBD\uD5D8\uC744 \uC6D0\uD558\uC2E0\uB2E4\uBA74,","vocal":"\uC800\uB294 \uC0C1\uB2F4\uC6D0\uACFC \uC9C1\uC811 \uB300\uBA74\uD558\uC5EC \uC774\uC57C\uAE30\uD569\uB2C8\uB2E4.","text":"\uB098\uB294 \uB300\uB9AC\uC778\uACFC \uC11C\uBA74\uC73C\uB85C \uC758\uC0AC\uC18C\uD1B5\uD569\uB2C8\uB2E4."},"modes":{"vocal":"\uBCF4\uCEEC \uBAA8\uB4DC","text":"\uD14D\uC2A4\uD2B8 \uBAA8\uB4DC"},"loaderValidation":"\uB300\uD654 \uC2DC\uC791","locale":"\uC5B8\uC5B4 \uD655\uC778","supported":"\uC9C0\uC6D0\uB418\uB294 \uC5B8\uC5B4 \uD655\uC778","addressdata":"\uB370\uC774\uD130 \uAC80\uC0C9"},"menu":{"message":"\uBA54\uC2DC\uC9C0\uB97C \uC785\uB825\uD558\uC138\uC694","backconversation":"\uB300\uD654\uB85C \uB3CC\uC544\uAC00\uC11C","answer":" \uADC0\uD558\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uBCC0"},"mobileLandscapePreventer":{"firstline":"\uCD5C\uC801\uC758 \uACBD\uD5D8\uC744 \uC704\uD574,","secondline":"\uD654\uBA74\uC744 \uB4A4\uC9D1\uC5B4"},"news":{"warningtext":"\uB274\uC2A4 \uCC44\uB110\uC5D0 \uC811\uC18D\uD558\uAC8C \uB418\uBA70 \uAE30\uAE30\uC758 \uC18C\uB9AC\uAC00 \uD65C\uC131\uD654\uB429\uB2C8\uB2E4.","live":"\uC0B4\uB2E4","continuous":"\uACC4\uC18D\uD574\uC11C"},"poi":{"comment":"\uACE0\uAC1D \uB9AC\uBDF0","route":"\uB3C4\uB85C","nodata":"\uAC80\uC0C9\uC5B4\uC640 \uC77C\uCE58\uD558\uB294 \uCF58\uD150\uCE20\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","openinghours":"\uAC1C\uAD00 \uC2DC\uAC04","prices":"\uBB3C\uAC00","paymentmethods":"\uACB0\uC81C \uBC29\uBC95","numberofplaces":"\uC7A5\uC18C\uC758 \uC218","openroutemobile":"\uC2A4\uB9C8\uD2B8\uD3F0\uC5D0\uC11C Google \uC9C0\uB3C4 \uACBD\uB85C \uC5F4\uAE30","FoodEstablishment":"\uBA39\uC744 \uACF3","LodgingBusiness":"\uC7A0\uC744 \uC798 \uACF3","TouristDestination":"\uBB34\uC5C7\uC744 \uBCFC \uAC83\uC778\uAC00","TouristAttraction":"\uD574\uC57C \uD560 \uC77C","Product":"\uC9C0\uC5ED\uC0C1\uD488","Service":"\uC11C\uBE44\uC2A4","Event":"\uC774\uBCA4\uD2B8","City":"\uB3C4\uC2DC","Wine":"\uC640\uC778"},"suggestion":{"consult":"\uD655\uC778\uD574 \uBCF4\uC138\uC694","thetutorial":"\uD29C\uD1A0\uB9AC\uC5BC"},"template":{"reset":"\uBAA8\uB450 \uCD08\uAE30\uD654","showresults":"\uACB0\uACFC \uD45C\uC2DC","suggestiontitle":"\uAC80\uC0C9 \uC81C\uC548","reminder":"\uC78A\uC9C0 \uB9C8\uC138\uC694. \\n \uC81C\uAC00 \uADC0\uD558\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uBCC0\uD574\uB4DC\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."},"anghello":{"listening":"\uB2F9\uC2E0 \uCC28\uB840\uC785\uB2C8\uB2E4, \uC800\uB294 \uB4E3\uACE0 \uC788\uC2B5\uB2C8\uB2E4...","correct":"\uC218\uC815","dontknow":"\uBAA8\uB974\uACA0\uC2B5\uB2C8\uB2E4"},"microphone":{"allow":"\uACC4\uC18D\uD558\uB824\uBA74 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uB9C8\uC774\uD06C\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD574\uC8FC\uC138\uC694.","rejected":"\uB9C8\uC774\uD06C \uC811\uADFC\uC744 \uAC70\uBD80\uD588\uC2B5\uB2C8\uB2E4.","instructions":"\uC74C\uC131 \uBAA8\uB4DC\uB97C \uC0AC\uC6A9\uD558\uB824\uBA74 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uB9C8\uC774\uD06C\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD574\uC8FC\uC138\uC694.","listening":"\uB098\uB294 \uB2F9\uC2E0\uC758 \uB9D0\uC744 \uB4E3\uACE0 \uC788\uC5B4\uC694","trigger":"\uB204\uB974\uAC70\uB098 \uB9D0\uD558\uC138\uC694","triggerwithoutname":"\uB9D0\uD558\uB824\uBA74 \uD0ED\uD558\uC138\uC694"}}');

});

parcelRegister("9xRuv", function(module, exports) {
module.exports = JSON.parse('{"1":"hjemmeside","2":"direktesendt nyhetskanal","3":"V\xe6rmelding","4":"N\xf8dnumre","1000":"historisk","1001":"oppl\xe6ringen","common":{"all":"alle","back":"tilbake","close":"Lukk","continue":"Fortsette","download":"nedlasting","downloadsheet":"last ned dette arket","downloadsheetmobile":"last ned dette arket p\xe5 smarttelefonen","filter":"Filter","history":"historisk","knowmore":"Les mer","lang":"spr\xe5kene","menu":"Meny","mode":"mote","needhelp":"Trenger hjelp?","parameters":"innstillinger","print":"Skrive ut","printsheet":"Skriv ut dette arket","result":"resultat","results":"resultater","singleLang":"spr\xe5k","sound":"henne","submit":"sende inn","subtitle":"undertekst","tutorial":"oppl\xe6ringen","validate":"\xe5 validere"},"emergency":{"samu":"S.A.M.U.","police":"politiet","firefighter":"brannmenn","general":"generell","hospital":"Sykehus","homeless":"Hjeml\xf8s","poison":"Giftkontrollsenter","emergency":"N\xf8dhjelp"},"error":{"title":"Det har oppst\xe5tt en feil","button":"Start applikasjonen p\xe5 nytt"},"history":{"title":"samtalehistorikk"},"inputs":{"choose":"Velg et svar"},"language":{"change":"endre spr\xe5ket","select":"velg spr\xe5ket du \xf8nsker"},"link":{"buttontext":"Se dokumentet","goto":"G\xe5 til adressen","click":"Klikk her","scanQR":"ved \xe5 skanne QRCode","scanQRTile":"Skann QR-koden for \xe5 oppdage"},"loader":{"loader":{"optimal":"For en optimal opplevelse,","classic":"For en mer klassisk opplevelse,","vocal":"Jeg snakker ansikt til ansikt med agenten.","text":"Jeg kommuniserer skriftlig med agenten."},"modes":{"vocal":"vokalmodus","text":"tekstmodus"},"loaderValidation":"Start samtale","locale":"sjekke spr\xe5k","supported":"sjekke st\xf8ttede spr\xe5k","addressdata":"henter data"},"menu":{"message":"Skriv inn meldingen din","backconversation":"tilbake til samtalen","answer":" svarer p\xe5 sp\xf8rsm\xe5lene dine"},"mobileLandscapePreventer":{"firstline":"For en optimal opplevelse,","secondline":"snu skjermen"},"news":{"warningtext":"Du f\xe5r tilgang til nyhetskanalen, lyden p\xe5 enheten din aktiveres","live":"bo","continuous":"kontinuerlig"},"poi":{"comment":"kundeanmeldelse","route":"vei","nodata":"Ingen innhold samsvarer med s\xf8ket ditt","openinghours":"\xc5pningstider","prices":"Priser","paymentmethods":"Betalingsmetoder","numberofplaces":"antall plasser","openroutemobile":"\xe5pne Google Maps-ruten p\xe5 smarttelefonen","FoodEstablishment":"Hvor skal vi spise","LodgingBusiness":"Hvor skal man sove","TouristDestination":"Hva er det \xe5 se","TouristAttraction":"Hva \xe5 gj\xf8re","Product":"Lokale produkter","Service":"Tjenester","Event":"arrangementer","City":"Byer","Wine":"Viner"},"suggestion":{"consult":"Sjekk ut","thetutorial":"oppl\xe6ringen"},"template":{"reset":"Tilbakestill alt","showresults":"Vis resultatene","suggestiontitle":"S\xf8keforslag","reminder":"Ikke glem, \\n jeg kan svare p\xe5 sp\xf8rsm\xe5lene dine."},"anghello":{"listening":"Det er opp til deg, jeg lytter...","correct":"Korrigere","dontknow":"Jeg vet ikke"},"microphone":{"allow":"Vennligst tillat nettleseren din \xe5 f\xe5 tilgang til mikrofonen for \xe5 fortsette.","rejected":"Du har nektet tilgang til mikrofonen.","instructions":"For \xe5 bruke talemodus, vennligst tillat nettleseren din \xe5 f\xe5 tilgang til mikrofonen.","listening":"Jeg lytter","trigger":"Trykk eller si","triggerwithoutname":"Trykk for \xe5 snakke"}}');

});

parcelRegister("cv59j", function(module, exports) {
module.exports = JSON.parse('{"1":"hjemmeside","2":"direktesendt nyhetskanal","3":"V\xe6rmelding","4":"N\xf8dnumre","1000":"historisk","1001":"tutorial","common":{"all":"alle","back":"rug","close":"sluiten","continue":"doorgaan","download":"downloaden","downloadsheet":"download dit blad","downloadsheetmobile":"download dit blad op uw smartphone","filter":"Filter","history":"historisch","knowmore":"Lees meer","lang":"TALEN","menu":"menu","mode":"mode","needhelp":"Hulp nodig?","parameters":"instellingen","print":"Afdrukken","printsheet":"Druk dit blad af","result":"resultaat","results":"resultaten","singleLang":"taal","sound":"zijn","submit":"indienen","subtitle":"ondertitel","tutorial":"zelfstudie","validate":"bevestigen"},"emergency":{"samu":"S.A.M.U.","police":"politie","firefighter":"brandweerlieden","general":"algemeen","hospital":"Ziekenhuis","homeless":"Dakloos","poison":"Vergifcontrolecentrum","emergency":"Hulpdiensten"},"error":{"title":"er is een fout opgetreden","button":"Start de applicatie opnieuw"},"history":{"title":"gespreksgeschiedenis"},"inputs":{"choose":"Kies een antwoord"},"language":{"change":"verander de taal","select":"selecteer de taal van uw keuze"},"link":{"buttontext":"Bekijk het document","goto":"Ga naar adres","click":"Klik hier","scanQR":"door de QRCode te scannen","scanQRTile":"Scan de QR-code om te ontdekken"},"loader":{"loader":{"optimal":"Voor een optimale ervaring,","classic":"Voor een meer klassieke ervaring,","vocal":"Ik spreek oog in oog met de agent.","text":"Ik communiceer schriftelijk met de makelaar."},"modes":{"vocal":"vocale modus","text":"tekstmodus"},"loaderValidation":"Begin een gesprek","locale":"taal controleren","supported":"ondersteunde talen controleren","addressdata":"het ophalen van gegevens"},"menu":{"message":"Voer uw bericht in","backconversation":"terug naar het gesprek","answer":" beantwoordt uw vragen"},"mobileLandscapePreventer":{"firstline":"Voor een optimale ervaring,","secondline":"draai je scherm om"},"news":{"warningtext":"U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd","live":"live","continuous":"doorlopend"},"poi":{"comment":"klant beoordeling","route":"weg","nodata":"Er is geen inhoud die overeenkomt met uw zoekopdracht","openinghours":"Openingstijden","prices":"Prijzen","paymentmethods":"Betaalmethoden","numberofplaces":"aantal plaatsen","openroutemobile":"open Google Maps-route op smartphone","FoodEstablishment":"Waar te eten","LodgingBusiness":"Waar te slapen","TouristDestination":"Wat te zien","TouristAttraction":"Wat moeten we doen","Product":"Regionale producten","Service":"Diensten","Event":"Evenementen","City":"Steden","Wine":"Wijnen"},"suggestion":{"consult":"Uitchecken","thetutorial":"de tutorial"},"template":{"reset":"alles resetten","showresults":"Laat de resultaten zien","suggestiontitle":"Zoeksuggesties","reminder":"Vergeet niet dat ik je vragen kan beantwoorden."},"anghello":{"listening":"Het is aan jou, ik luister...","correct":"Corrigeren","dontknow":"Ik weet het niet"},"microphone":{"allow":"Sta uw browser toe om toegang te krijgen tot de microfoon om door te gaan.","rejected":"U hebt toegang tot de microfoon geweigerd.","instructions":"Om de spraakmodus te gebruiken, staat u uw browser toe toegang te krijgen tot de microfoon.","listening":"Ik luister","trigger":"Druk of zeg","triggerwithoutname":"Tik om te praten"}}');

});

parcelRegister("8eBLN", function(module, exports) {
module.exports = JSON.parse('{"1":"hjemmeside","2":"direktesendt nyhetskanal","3":"V\xe6rmelding","4":"N\xf8dnumre","1000":"historisk","1001":"tutorial","common":{"all":"alle","back":"rug","close":"sluiten","continue":"doorgaan","download":"downloaden","downloadsheet":"download dit blad","downloadsheetmobile":"download dit blad op uw smartphone","filter":"Filter","history":"historisch","knowmore":"Lees meer","lang":"TALEN","menu":"menu","mode":"mode","needhelp":"Hulp nodig?","parameters":"instellingen","print":"Afdrukken","printsheet":"Druk dit blad af","result":"resultaat","results":"resultaten","singleLang":"taal","sound":"zijn","submit":"indienen","subtitle":"ondertitel","tutorial":"zelfstudie","validate":"bevestigen"},"emergency":{"samu":"S.A.M.U.","police":"politie","firefighter":"brandweerlieden","general":"algemeen","hospital":"Ziekenhuis","homeless":"Dakloos","poison":"Vergifcontrolecentrum","emergency":"Hulpdiensten"},"error":{"title":"er is een fout opgetreden","button":"Start de applicatie opnieuw"},"history":{"title":"gespreksgeschiedenis"},"inputs":{"choose":"Kies een antwoord"},"language":{"change":"verander de taal","select":"selecteer de taal van uw keuze"},"link":{"buttontext":"Bekijk het document","goto":"Ga naar adres","click":"Klik hier","scanQR":"door de QRCode te scannen","scanQRTile":"Scan de QR-code om te ontdekken"},"loader":{"loader":{"optimal":"Voor een optimale ervaring,","classic":"Voor een meer klassieke ervaring,","vocal":"Ik spreek oog in oog met de agent.","text":"Ik communiceer schriftelijk met de makelaar."},"modes":{"vocal":"vocale modus","text":"tekstmodus"},"loaderValidation":"Begin een gesprek","locale":"taal controleren","supported":"ondersteunde talen controleren","addressdata":"het ophalen van gegevens"},"menu":{"message":"Voer uw bericht in","backconversation":"terug naar het gesprek","answer":" beantwoordt uw vragen"},"mobileLandscapePreventer":{"firstline":"Voor een optimale ervaring,","secondline":"draai je scherm om"},"news":{"warningtext":"U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd","live":"live","continuous":"doorlopend"},"poi":{"comment":"klant beoordeling","route":"weg","nodata":"Er is geen inhoud die overeenkomt met uw zoekopdracht","openinghours":"Openingstijden","prices":"Prijzen","paymentmethods":"Betaalmethoden","numberofplaces":"aantal plaatsen","openroutemobile":"open Google Maps-route op smartphone","FoodEstablishment":"Waar te eten","LodgingBusiness":"Waar te slapen","TouristDestination":"Wat te zien","TouristAttraction":"Wat moeten we doen","Product":"Regionale producten","Service":"Diensten","Event":"Evenementen","City":"Steden","Wine":"Wijnen"},"suggestion":{"consult":"Uitchecken","thetutorial":"de tutorial"},"template":{"reset":"alles resetten","showresults":"Laat de resultaten zien","suggestiontitle":"Zoeksuggesties","reminder":"Vergeet niet dat ik je vragen kan beantwoorden."},"anghello":{"listening":"Het is aan jou, ik luister...","correct":"Corrigeren","dontknow":"Ik weet het niet"},"microphone":{"allow":"Sta uw browser toe om toegang te krijgen tot de microfoon om door te gaan.","rejected":"U hebt toegang tot de microfoon geweigerd.","instructions":"Om de spraakmodus te gebruiken, staat u uw browser toe toegang te krijgen tot de microfoon.","listening":"Ik luister","trigger":"Druk of zeg","triggerwithoutname":"Tik om te praten"}}');

});

parcelRegister("cXPQk", function(module, exports) {
module.exports = JSON.parse('{"1":"strona g\u0142\xf3wna","2":"kana\u0142 informacyjny na \u017Cywo","3":"pogoda","4":"numery alarmowe","1000":"historia","1001":"instrukta\u017C","common":{"all":"Wszystko","back":"z powrotem","close":"zamkn\u0105\u0107","continue":"Kontynuowa\u0107","download":"pobiera\u0107","downloadsheet":"pobierz ten arkusz","downloadsheetmobile":"pobierz ten arkusz na smartfonie","filter":"Filtr","history":"historyczny","knowmore":"Dowiedz si\u0119 wi\u0119cej","lang":"J\u0119zyki","menu":"menu","mode":"moda","needhelp":"Potrzebuj\u0119 pomocy?","parameters":"ustawienia","print":"Wydrukowa\u0107","printsheet":"Wydrukuj ten arkusz","result":"wynik","results":"wyniki","singleLang":"j\u0119zyk","sound":"jej","submit":"sk\u0142ada\u0107","subtitle":"podtytu\u0142","tutorial":"instrukta\u017C","validate":"potwierdzi\u0107"},"emergency":{"samu":"S.A.M.U.","police":"Policja","firefighter":"stra\u017Cacy","general":"og\xf3lny","hospital":"Szpital","homeless":"Bezdomny","poison":"Centrum Kontroli Trucizn","emergency":"S\u0142u\u017Cby ratunkowe"},"error":{"title":"Wyst\u0105pi\u0142 b\u0142\u0105d","button":"Uruchom ponownie aplikacj\u0119"},"history":{"title":"Historia konwersacji"},"inputs":{"choose":"Wybierz odpowied\u017A"},"language":{"change":"zmieni\u0107 j\u0119zyk","select":"wybierz wybrany j\u0119zyk"},"link":{"buttontext":"Obejrzyj dokument","goto":"Przejd\u017A do adresu","click":"Kliknij tutaj","scanQR":"poprzez zeskanowanie kodu QR","scanQRTile":"Zeskanuj kod QR, aby odkry\u0107"},"loader":{"loader":{"optimal":"Aby uzyska\u0107 optymalne wra\u017Cenia,","classic":"Aby uzyska\u0107 bardziej klasyczne wra\u017Cenia,","vocal":"Rozmawiam twarz\u0105 w twarz z agentem.","text":"Komunikuj\u0119 si\u0119 pisemnie z agentem."},"modes":{"vocal":"tryb wokalny","text":"tryb tekstowy"},"loaderValidation":"Rozpocznij rozmow\u0119","locale":"sprawdzanie j\u0119zyka","supported":"sprawdzanie obs\u0142ugiwanych j\u0119zyk\xf3w","addressdata":"pobieranie danych"},"menu":{"message":"Wpisz swoj\u0105 wiadomo\u015B\u0107","backconversation":"wr\xf3\u0107 do rozmowy","answer":" odpowiada na Twoje pytania"},"mobileLandscapePreventer":{"firstline":"Aby uzyska\u0107 optymalne wra\u017Cenia,","secondline":"obr\xf3\u0107 ekran"},"news":{"warningtext":"Uzyskasz dost\u0119p do kana\u0142u informacyjnego, d\u017Awi\u0119k na Twoim urz\u0105dzeniu zostanie aktywowany","live":"na \u017Cywo","continuous":"bez przerwy"},"poi":{"comment":"Recenzja klienta","route":"droga","nodata":"\u017Badna tre\u015B\u0107 nie pasuje do Twojego wyszukiwania","openinghours":"Godziny otwarcia","prices":"Ceny","paymentmethods":"Metody P\u0142atno\u015Bci","numberofplaces":"liczba miejsc","openroutemobile":"otw\xf3rz tras\u0119 Map Google na smartfonie","FoodEstablishment":"Gdzie zje\u015B\u0107","LodgingBusiness":"Gdzie spa\u0107","TouristDestination":"Co zobaczy\u0107","TouristAttraction":"Co robi\u0107","Product":"Lokalne produkty","Service":"Us\u0142ugi","Event":"Wydarzenia","City":"Miasta","Wine":"Wina"},"suggestion":{"consult":"Wymeldowa\u0107 si\u0119","thetutorial":"samouczek"},"template":{"reset":"Zresetowa\u0107 wszystko","showresults":"Poka\u017C wyniki","suggestiontitle":"Wyszukaj sugestie","reminder":"Nie zapomnij, \\n, \u017Ce mog\u0119 odpowiedzie\u0107 na Twoje pytania."},"anghello":{"listening":"To zale\u017Cy od ciebie, s\u0142ucham...","correct":"Poprawi\u0107","dontknow":"Nie wiem"},"microphone":{"allow":"Prosz\u0119 pozwoli\u0107 swojej przegl\u0105darce na dost\u0119p do mikrofonu, aby kontynuowa\u0107.","rejected":"Odm\xf3wi\u0142e\u015B dost\u0119pu do mikrofonu.","instructions":"Aby u\u017Cywa\u0107 trybu g\u0142osowego, prosz\u0119 pozwoli\u0107 swojej przegl\u0105darce na dost\u0119p do mikrofonu.","listening":"S\u0142ucham","trigger":"Naci\u015Bnij lub powiedz","triggerwithoutname":"Dotknij, aby m\xf3wi\u0107"}}');

});

parcelRegister("f6Gk7", function(module, exports) {
module.exports = JSON.parse('{"1":"pagina inicial","2":"canal de informa\xe7\xf5es ao vivo","3":"clima","4":"N\xfameros de emerg\xeancia","1000":"hist\xf3ria","1001":"tutorial","common":{"all":"todos","back":"voltar","close":"fechar","continue":"continuar","download":"download","downloadsheet":"baixe esta planilha","downloadsheetmobile":"baixe esta planilha no smartphone","filter":"filtro","history":"hist\xf3rico","knowmore":"Saiba mais","lang":"l\xednguas","menu":"card\xe1pio","mode":"moda","needhelp":"Preciso de ajuda?","parameters":"configura\xe7\xf5es","print":"Imprimir","printsheet":"Imprima esta folha","result":"resultado","results":"resultados","singleLang":"linguagem","sound":"dela","submit":"enviar","subtitle":"legenda","tutorial":"tutorial","validate":"validar"},"emergency":{"samu":"S.A.M.U.","police":"pol\xedcia","firefighter":"bombeiros","general":"general","hospital":"Hospital","homeless":"Morador de rua","poison":"Centro de Controle de Venenos","emergency":"Servi\xe7os de emerg\xeancia"},"error":{"title":"ocorreu um erro","button":"Reinicie o aplicativo"},"history":{"title":"hist\xf3rico de conversas"},"inputs":{"choose":"Escolha uma resposta"},"language":{"change":"alterar o idioma","select":"selecione o idioma de sua prefer\xeancia"},"link":{"buttontext":"Veja o documento","goto":"Ir para o endere\xe7o","click":"Clique aqui","scanQR":"digitalizando o QrCode","scanQRTile":"Escaneie o c\xf3digo QR para descobrir"},"loader":{"loader":{"optimal":"Para uma experi\xeancia ideal,","classic":"Para uma experi\xeancia mais cl\xe1ssica,","vocal":"Falo cara a cara com o agente.","text":"Eu me comunico por escrito com o agente."},"modes":{"vocal":"modo vocal","text":"modo de texto"},"loaderValidation":"Iniciar conversa","locale":"verificando o idioma","supported":"verificando idiomas suportados","addressdata":"recuperando dados"},"menu":{"message":"Digite sua mensagem","backconversation":"de volta \xe0 conversa","answer":" responde \xe0s suas perguntas"},"mobileLandscapePreventer":{"firstline":"Para uma experi\xeancia ideal,","secondline":"vire sua tela"},"news":{"warningtext":"Voc\xea acessar\xe1 o canal de not\xedcias, o som do seu aparelho ser\xe1 ativado","live":"ao vivo","continuous":"continuamente"},"poi":{"comment":"avalia\xe7\xe3o do cliente","route":"estrada","nodata":"Nenhum conte\xfado corresponde \xe0 sua pesquisa","openinghours":"Hor\xe1rio de funcionamento","prices":"Pre\xe7os","paymentmethods":"M\xe9todos de Pagamento","numberofplaces":"n\xfamero de lugares","openroutemobile":"abra a rota do Google Maps no smartphone","FoodEstablishment":"Onde comer","LodgingBusiness":"Onde dormir","TouristDestination":"O que ver","TouristAttraction":"O que fazer","Product":"Produtos locais","Service":"Servi\xe7os","Event":"Eventos","City":"Cidades","Wine":"Vinhos"},"suggestion":{"consult":"Confira","thetutorial":"o tutorial"},"template":{"reset":"reiniciar tudo","showresults":"Mostrar os resultados","suggestiontitle":"Sugest\xf5es de pesquisa","reminder":"N\xe3o se esque\xe7a, \\n, posso responder \xe0s suas perguntas."},"anghello":{"listening":"Est\xe1 com voc\xea, estou ouvindo...","correct":"Corrigir","dontknow":"Eu n\xe3o sei"},"microphone":{"allow":"Por favor, permita que seu navegador acesse o microfone para continuar.","rejected":"Voc\xea negou o acesso ao microfone.","instructions":"Para usar o modo de voz, por favor, permita que seu navegador acesse o microfone.","listening":"Estou ouvindo","trigger":"Clique ou diga","triggerwithoutname":"Toque para falar"}}');

});

parcelRegister("fVqcA", function(module, exports) {
module.exports = JSON.parse('{"1":"pagina inicial","2":"canal de informa\xe7\xf5es ao vivo","3":"clima","4":"N\xfameros de emerg\xeancia","1000":"hist\xf3ria","1001":"tutorial","common":{"all":"todos","back":"voltar","close":"fechar","continue":"continuar","download":"download","downloadsheet":"baixe esta planilha","downloadsheetmobile":"baixe esta planilha no smartphone","filter":"filtro","history":"hist\xf3rico","knowmore":"Saiba mais","lang":"l\xednguas","menu":"card\xe1pio","mode":"moda","needhelp":"Preciso de ajuda?","parameters":"configura\xe7\xf5es","print":"Imprimir","printsheet":"Imprima esta folha","result":"resultado","results":"resultados","singleLang":"linguagem","sound":"dela","submit":"enviar","subtitle":"legenda","tutorial":"tutorial","validate":"validar"},"emergency":{"samu":"S.A.M.U.","police":"pol\xedcia","firefighter":"bombeiros","general":"general","hospital":"Hospital","homeless":"Morador de rua","poison":"Centro de Controle de Venenos","emergency":"Servi\xe7os de emerg\xeancia"},"error":{"title":"ocorreu um erro","button":"Reinicie o aplicativo"},"history":{"title":"hist\xf3rico de conversas"},"inputs":{"choose":"Escolha uma resposta"},"language":{"change":"alterar o idioma","select":"selecione o idioma de sua prefer\xeancia"},"link":{"buttontext":"Veja o documento","goto":"Ir para o endere\xe7o","click":"Clique aqui","scanQR":"digitalizando o QrCode","scanQRTile":"Escaneie o c\xf3digo QR para descobrir"},"loader":{"loader":{"optimal":"Para uma experi\xeancia ideal,","classic":"Para uma experi\xeancia mais cl\xe1ssica,","vocal":"Falo cara a cara com o agente.","text":"Eu me comunico por escrito com o agente."},"modes":{"vocal":"modo vocal","text":"modo de texto"},"loaderValidation":"Iniciar conversa","locale":"verificando o idioma","supported":"verificando idiomas suportados","addressdata":"recuperando dados"},"menu":{"message":"Digite sua mensagem","backconversation":"de volta \xe0 conversa","answer":" responde \xe0s suas perguntas"},"mobileLandscapePreventer":{"firstline":"Para uma experi\xeancia ideal,","secondline":"vire sua tela"},"news":{"warningtext":"Voc\xea acessar\xe1 o canal de not\xedcias, o som do seu aparelho ser\xe1 ativado","live":"ao vivo","continuous":"continuamente"},"poi":{"comment":"avalia\xe7\xe3o do cliente","route":"estrada","nodata":"Nenhum conte\xfado corresponde \xe0 sua pesquisa","openinghours":"Hor\xe1rio de funcionamento","prices":"Pre\xe7os","paymentmethods":"M\xe9todos de Pagamento","numberofplaces":"n\xfamero de lugares","openroutemobile":"abra a rota do Google Maps no smartphone","FoodEstablishment":"Onde comer","LodgingBusiness":"Onde dormir","TouristDestination":"O que ver","TouristAttraction":"O que fazer","Product":"Produtos locais","Service":"Servi\xe7os","Event":"Eventos","City":"Cidades","Wine":"Vinhos"},"suggestion":{"consult":"Confira","thetutorial":"o tutorial"},"template":{"reset":"reiniciar tudo","showresults":"Mostrar os resultados","suggestiontitle":"Sugest\xf5es de pesquisa","reminder":"N\xe3o se esque\xe7a, \\n, posso responder \xe0s suas perguntas."},"anghello":{"listening":"Est\xe1 com voc\xea, estou ouvindo...","correct":"Corrigir","dontknow":"Eu n\xe3o sei"},"microphone":{"allow":"Por favor, permita que o seu navegador aceda ao microfone para continuar.","rejected":"Negou o acesso ao microfone.","instructions":"Para usar o modo de voz, por favor, permita que o seu navegador aceda ao microfone.","listening":"Estou ouvindo","trigger":"Clique ou diga","triggerwithoutname":"Toque para falar"}}');

});

parcelRegister("csgXy", function(module, exports) {
module.exports = JSON.parse('{"1":"\u0434\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","2":"\u043F\u0440\u044F\u043C\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B","3":"\u043F\u043E\u0433\u043E\u0434\u0430","4":"\u043D\u043E\u043C\u0435\u0440\u0430 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043B\u0443\u0436\u0431","1000":"\u0438\u0441\u0442\u043E\u0440\u0438\u044F","1001":"\u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E","common":{"all":"\u0432\u0441\u0435","back":"\u043D\u0430\u0437\u0430\u0434","close":"\u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0442\u044C","continue":"\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0442\u044C","download":"\u0421\u043A\u0430\u0447\u0430\u0442\u044C","downloadsheet":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442","downloadsheetmobile":"\u0441\u043A\u0430\u0447\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442 \u043D\u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D","filter":"\u0424\u0438\u043B\u044C\u0442\u0440","history":"\u0438\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439","knowmore":"\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435","lang":"\u042F\u0417\u042B\u041A\u0418","menu":"\u043C\u0435\u043D\u044E","mode":"\u043C\u043E\u0434\u0430","needhelp":"\u041D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C?","parameters":"\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","print":"\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C","printsheet":"\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442","result":"\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442","results":"\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B","singleLang":"\u044F\u0437\u044B\u043A","sound":"\u0437\u0432\u0443\u043A","submit":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C","subtitle":"\u0441\u0443\u0431\u0442\u0438\u0442\u0440\u044B","tutorial":"\u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E","validate":"\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"},"emergency":{"samu":"\u0421.\u0410.\u041C.\u0423.","police":"\u043F\u043E\u043B\u0438\u0446\u0438\u044F","firefighter":"\u043F\u043E\u0436\u0430\u0440\u043D\u044B\u0435","general":"\u043E\u0431\u0449\u0438\u0439","hospital":"\u0411\u043E\u043B\u044C\u043D\u0438\u0446\u0430","homeless":"\u0411\u0435\u0437\u0434\u043E\u043C\u043D\u044B\u0439","poison":"\u0422\u043E\u043A\u0441\u0438\u043A\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0446\u0435\u043D\u0442\u0440","emergency":"\u0410\u0432\u0430\u0440\u0438\u0439\u043D\u044B\u0435 \u0441\u043B\u0443\u0436\u0431\u044B"},"error":{"title":"\u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","button":"\u041F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"},"history":{"title":"\u0438\u0441\u0442\u043E\u0440\u0438\u044F \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u043E\u0432"},"inputs":{"choose":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442"},"language":{"change":"\u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u044F\u0437\u044B\u043A","select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044F\u0437\u044B\u043A \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u044B\u0431\u043E\u0440\u0443"},"link":{"buttontext":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442","goto":"\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443","click":"\u043A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0441\u044E\u0434\u0430","scanQR":"\u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0432 QrCode","scanQRTile":"\u0421\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C"},"loader":{"loader":{"optimal":"\u0414\u043B\u044F \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,","classic":"\u0414\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u043A\u043B\u0430\u0441\u0441\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,","vocal":"\u042F \u043E\u0431\u0449\u0430\u044E\u0441\u044C, \u0440\u0430\u0437\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u044F \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C.","text":"\u042F \u043E\u0431\u0449\u0430\u044E\u0441\u044C \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C."},"modes":{"vocal":"\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0440\u0435\u0436\u0438\u043C","text":"\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439 \u0440\u0435\u0436\u0438\u043C"},"loaderValidation":"\u041D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440","locale":"\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u044F\u0437\u044B\u043A\u0430","supported":"\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0445 \u044F\u0437\u044B\u043A\u043E\u0432","addressdata":"\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445"},"menu":{"message":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435","backconversation":"\u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0443","answer":" \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u043D\u0430 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"},"mobileLandscapePreventer":{"firstline":"\u0414\u043B\u044F \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,","secondline":"\u043F\u0435\u0440\u0435\u0432\u0435\u0440\u043D\u0438\u0442\u0435 \u044D\u043A\u0440\u0430\u043D"},"news":{"warningtext":"\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043D\u043E\u0432\u043E\u0441\u0442\u043D\u043E\u043C\u0443 \u043A\u0430\u043D\u0430\u043B\u0443, \u0437\u0432\u0443\u043A \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u0431\u0443\u0434\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D.","live":"\u0436\u0438\u0442\u044C","continuous":"\u043D\u0435\u043F\u0440\u0435\u0440\u044B\u0432\u043D\u043E"},"poi":{"comment":"\u043E\u0442\u0437\u044B\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u0430","route":"\u0434\u043E\u0440\u043E\u0433\u0430","nodata":"\u041D\u0435\u0442 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443","openinghours":"\u0427\u0430\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B","prices":"\u0426\u0435\u043D\u044B","paymentmethods":"\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B","numberofplaces":"\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043C\u0435\u0441\u0442","openroutemobile":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442 Google Maps \u043D\u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D\u0435","FoodEstablishment":"\u0413\u0434\u0435 \u043F\u043E\u0435\u0441\u0442\u044C","LodgingBusiness":"\u0413\u0434\u0435 \u0441\u043F\u0430\u0442\u044C","TouristDestination":"\u0427\u0442\u043E \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C","TouristAttraction":"\u0427\u0442\u043E \u0434\u0435\u043B\u0430\u0442\u044C","Product":"\u041C\u0435\u0441\u0442\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B","Service":"\u0423\u0441\u043B\u0443\u0433\u0438","Event":"\u0421\u043E\u0431\u044B\u0442\u0438\u044F","City":"\u0413\u043E\u0440\u043E\u0434\u0430","Wine":"\u0412\u0438\u043D\u0430"},"suggestion":{"consult":"\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C","thetutorial":"\u0443\u0447\u0435\u0431\u043D\u0438\u043A"},"template":{"reset":"\u0441\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0435","showresults":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B","suggestiontitle":"\u041F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F","reminder":"\u041D\u0435 \u0437\u0430\u0431\u044B\u0432\u0430\u0439, \\n \u042F \u043C\u043E\u0433\u0443 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u0442\u0432\u043E\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B."},"anghello":{"listening":"\u042D\u0442\u043E \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0432\u0430\u0441, \u044F \u0441\u043B\u0443\u0448\u0430\u044E...","correct":"\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C","dontknow":"\u042F \u043D\u0435 \u0437\u043D\u0430\u044E"},"microphone":{"allow":"\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F.","rejected":"\u0412\u044B \u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0438 \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443.","instructions":"\u0427\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0440\u0435\u0436\u0438\u043C, \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443.","listening":"\u042F \u0441\u043B\u0443\u0448\u0430\u044E","trigger":"\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438\u043B\u0438 \u0441\u043A\u0430\u0437\u0430\u0439\u0442\u0435","triggerwithoutname":"\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C"}}');

});

parcelRegister("baqvr", function(module, exports) {
module.exports = JSON.parse('{"1":"doma\u010Da stran","2":"info kanal v \u017Eivo","3":"vreme","4":"\u0161tevilke za klic v sili","1000":"zgodovina","1001":"vadnica","common":{"all":"vse","close":"blizu","back":"nazaj","continue":"Nadaljuj","download":"prenesi","downloadsheet":"prenesite ta list","downloadsheetmobile":"prenesite ta list na pametni telefon","filter":"Filter","history":"zgodovinski","knowmore":"L\xe4s mer","lang":"jezikov","menu":"meni","mode":"moda","needhelp":"Rabim pomo\u010D?","parameters":"nastavitve","print":"Tiskanje","printsheet":"Natisnite ta list","result":"rezultat","results":"rezultate","singleLang":"jezik","sound":"njo","submit":"Skicka in","subtitle":"podnaslov","tutorial":"vadnica","validate":"potrditi"},"emergency":{"samu":"S.A.M.U.","police":"polis","firefighter":"brandm\xe4n","general":"allm\xe4n","hospital":"Sjukhus","homeless":"Heml\xf6s","poison":"Giftkontrollcenter","emergency":"Akuttj\xe4nster"},"error":{"title":"Ett fel har uppst\xe5tt","button":"Starta om programmet"},"history":{"title":"zgodovino pogovorov"},"inputs":{"choose":"V\xe4lj ett svar"},"language":{"change":"spremenite jezik","select":"izberite jezik po va\u0161i izbiri"},"link":{"buttontext":"Oglejte si dokument","goto":"Pojdi na naslov","click":"Klikni tukaj","scanQR":"s skeniranjem QrCode","scanQRTile":"Skanna QR-koden f\xf6r att uppt\xe4cka"},"loader":{"loader":{"optimal":"Za optimalno izku\u0161njo,","classic":"Za bolj klasi\u010Dno izku\u0161njo,","vocal":"Z agentom se pogovarjam iz o\u010Di v o\u010Di.","text":"Pisno komuniciram z agentom."},"modes":{"vocal":"vokalni na\u010Din","text":"besedilni na\u010Din"},"loaderValidation":"Za\u010Dni pogovor","locale":"preverjanje jezika","supported":"preverjanje podprtih jezikov","addressdata":"pridobivanje podatkov"},"menu":{"message":"Vnesite svoje sporo\u010Dilo","backconversation":"nazaj k pogovoru","answer":" odgovarja na va\u0161a vpra\u0161anja"},"mobileLandscapePreventer":{"firstline":"Za optimalno izku\u0161njo,","secondline":"obrnite zaslon"},"news":{"warningtext":"Dostopili boste do kanala z novicami, zvok na va\u0161i napravi bo aktiviran","live":"v \u017Eivo","continuous":"neprekinjeno"},"poi":{"comment":"pregled strank","route":"cesta","nodata":"Nobena vsebina se ne ujema z va\u0161im iskanjem","openinghours":"Odpiralni \u010Das","prices":"Cene","paymentmethods":"Na\u010Dini pla\u010Dila","numberofplaces":"\u0161tevilo mest","openroutemobile":"odprite Google Maps route na pametnem telefonu","FoodEstablishment":"Kje jesti","LodgingBusiness":"Kje spati","TouristDestination":"Kaj videti","TouristAttraction":"Kaj storiti","Product":"Lokalni izdelki","Service":"Storitve","Event":"Dogodki","City":"Mesta","Wine":"Vina"},"suggestion":{"consult":"Preveri","thetutorial":"vadnica"},"template":{"reset":"ponastavi vse","showresults":"Poka\u017Ei rezultate","suggestiontitle":"Predlogi za iskanje","reminder":"Ne pozabite, \\n lahko odgovorim na va\u0161a vpra\u0161anja."},"anghello":{"listening":"Det \xe4r upp till dig, jag lyssnar...","correct":"Korrigera","dontknow":"Jag vet inte"},"microphone":{"allow":"V\xe4nligen till\xe5t din webbl\xe4sare att f\xe5 \xe5tkomst till mikrofonen f\xf6r att forts\xe4tta.","rejected":"Du har nekad \xe5tkomst till mikrofonen.","instructions":"F\xf6r att anv\xe4nda r\xf6stl\xe4ge, v\xe4nligen till\xe5t din webbl\xe4sare att f\xe5 \xe5tkomst till mikrofonen.","listening":"Jag lyssnar","trigger":"Tryck eller s\xe4g","triggerwithoutname":"Tryck f\xf6r att prata"}}');

});

parcelRegister("4V31a", function(module, exports) {
module.exports = JSON.parse('{"1":"\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01","2":"\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E14","3":"\u0E2A\u0E20\u0E32\u0E1E\u0E2D\u0E32\u0E01\u0E32\u0E28","4":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19","1000":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C","1001":"\u0E01\u0E27\u0E14\u0E27\u0E34\u0E0A\u0E32","common":{"all":"\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","back":"\u0E01\u0E25\u0E31\u0E1A","close":"\u0E1B\u0E34\u0E14","continue":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","download":"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14","downloadsheet":"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E19\u0E35\u0E49","downloadsheetmobile":"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E19\u0E35\u0E49\u0E1A\u0E19\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E42\u0E1F\u0E19","filter":"\u0E01\u0E23\u0E2D\u0E07","history":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C","knowmore":"\u0E2D\u0E48\u0E32\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","lang":"\u0E20\u0E32\u0E29\u0E32","menu":"\u0E40\u0E21\u0E19\u0E39","mode":"\u0E41\u0E1F\u0E0A\u0E31\u0E48\u0E19","needhelp":"\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D?","parameters":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32","print":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C","printsheet":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E41\u0E1C\u0E48\u0E19\u0E19\u0E35\u0E49","result":"\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C","results":"\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C","singleLang":"\u0E20\u0E32\u0E29\u0E32","sound":"\u0E02\u0E2D\u0E07\u0E40\u0E18\u0E2D","submit":"\u0E2A\u0E48\u0E07","subtitle":"\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22","tutorial":"\u0E01\u0E27\u0E14\u0E27\u0E34\u0E0A\u0E32","validate":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A"},"emergency":{"samu":"S.A.M.U.","police":"\u0E15\u0E33\u0E23\u0E27\u0E08","firefighter":"\u0E19\u0E31\u0E01\u0E14\u0E31\u0E1A\u0E40\u0E1E\u0E25\u0E34\u0E07","general":"\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B","hospital":"\u0E42\u0E23\u0E07\u0E1E\u0E22\u0E32\u0E1A\u0E32\u0E25","homeless":"\u0E04\u0E19\u0E44\u0E23\u0E49\u0E1A\u0E49\u0E32\u0E19","poison":"\u0E28\u0E39\u0E19\u0E22\u0E4C\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E1E\u0E34\u0E29","emergency":"\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19"},"error":{"title":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","button":"\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07"},"history":{"title":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32"},"inputs":{"choose":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E33\u0E15\u0E2D\u0E1A"},"language":{"change":"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E29\u0E32","select":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23"},"link":{"buttontext":"\u0E14\u0E39\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23","goto":"\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","click":"\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48","scanQR":"\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E41\u0E01\u0E19 QrCode","scanQRTile":"\u0E2A\u0E41\u0E01\u0E19\u0E23\u0E2B\u0E31\u0E2A QR \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E49\u0E19\u0E1E\u0E1A"},"loader":{"loader":{"optimal":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14","classic":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E04\u0E25\u0E32\u0E2A\u0E2A\u0E34\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19","vocal":"\u0E09\u0E31\u0E19\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E39\u0E14\u0E04\u0E38\u0E22\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19","text":"\u0E09\u0E31\u0E19\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19"},"modes":{"vocal":"\u0E42\u0E2B\u0E21\u0E14\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E1E\u0E39\u0E14","text":"\u0E42\u0E2B\u0E21\u0E14\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21"},"loaderValidation":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32","locale":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E20\u0E32\u0E29\u0E32","supported":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A","addressdata":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25"},"menu":{"message":"\u0E1B\u0E49\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","backconversation":"\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32","answer":" \u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"},"mobileLandscapePreventer":{"firstline":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14","secondline":"\u0E1E\u0E25\u0E34\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"},"news":{"warningtext":"\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E02\u0E48\u0E32\u0E27\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19","live":"\u0E2A\u0E14","continuous":"\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07"},"poi":{"comment":"\u0E23\u0E35\u0E27\u0E34\u0E27\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","route":"\u0E16\u0E19\u0E19","nodata":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","openinghours":"\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23","prices":"\u0E23\u0E32\u0E04\u0E32","paymentmethods":"\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19","numberofplaces":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48","openroutemobile":"\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07 Google Maps \u0E1A\u0E19\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E42\u0E1F\u0E19","FoodEstablishment":"\u0E01\u0E34\u0E19\u0E17\u0E35\u0E48\u0E44\u0E2B\u0E19\u0E14\u0E35","LodgingBusiness":"\u0E19\u0E2D\u0E19\u0E44\u0E2B\u0E19.","TouristDestination":"\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E43\u0E2B\u0E49\u0E14\u0E39\u0E1A\u0E49\u0E32\u0E07","TouristAttraction":"\u0E08\u0E30\u0E17\u0E33\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23","Product":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07","Service":"\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23","Event":"\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21","City":"\u0E40\u0E21\u0E37\u0E2D\u0E07","Wine":"\u0E44\u0E27\u0E19\u0E4C"},"suggestion":{"consult":"\u0E40\u0E0A\u0E47\u0E04\u0E40\u0E2D\u0E32\u0E17\u0E4C","thetutorial":"\u0E1A\u0E17\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E2D\u0E19"},"template":{"reset":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","showresults":"\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25","suggestiontitle":"\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32","reminder":"\u0E2D\u0E22\u0E48\u0E32\u0E25\u0E37\u0E21 \\n \u0E09\u0E31\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49"},"anghello":{"listening":"\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13, \u0E09\u0E31\u0E19\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1F\u0E31\u0E07...","correct":"\u0E41\u0E01\u0E49\u0E44\u0E02","dontknow":"\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E23\u0E39\u0E49"},"microphone":{"allow":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","rejected":"\u0E04\u0E38\u0E13\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19","instructions":"\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E42\u0E2B\u0E21\u0E14\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19","listening":"\u0E09\u0E31\u0E19\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1F\u0E31\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48","trigger":"\u0E01\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E1E\u0E39\u0E14","triggerwithoutname":"\u0E41\u0E15\u0E30\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1E\u0E39\u0E14"}}');

});

parcelRegister("aIGYp", function(module, exports) {
module.exports = JSON.parse('{"1":"ana sayfa","2":"canl\u0131 bilgi kanal\u0131","3":"hava durumu","4":"Acil durum numaralar\u0131","1000":"tarih","1001":"\xf6\u011Fretici","common":{"all":"T\xfcm\xfc","back":"geri","close":"kapal\u0131","continue":"Devam etmek","download":"\u0130ndirmek","downloadsheet":"bu sayfay\u0131 indir","downloadsheetmobile":"bu sayfay\u0131 ak\u0131ll\u0131 telefonunuza indirin","filter":"Filtre","history":"tarihi","knowmore":"Daha fazla bilgi","lang":"Diller","menu":"Men\xfc","mode":"moda","needhelp":"Yard\u0131ma m\u0131 ihtiyac\u0131n\u0131z var?","parameters":"ayarlar","print":"Yazd\u0131r","printsheet":"Bu sayfay\u0131 yazd\u0131r","result":"sonu\xe7","results":"sonu\xe7lar","singleLang":"dil","sound":"ses","submit":"g\xf6ndermek","subtitle":"alt yaz\u0131","tutorial":"\xf6\u011Fretici","validate":"Do\u011Frulamak"},"emergency":{"samu":"S.A.M.U.","police":"polis","firefighter":"itfaiyeciler","general":"genel","hospital":"Hastane","homeless":"Evsiz","poison":"Zehir kontrol Merkezi","emergency":"Acil servisler"},"error":{"title":"bir hata olu\u015Ftu","button":"Uygulamay\u0131 yeniden ba\u015Flat\u0131n"},"history":{"title":"konu\u015Fma ge\xe7mi\u015Fi"},"inputs":{"choose":"Bir cevap se\xe7in"},"language":{"change":"dili de\u011Fi\u015Ftir","select":"istedi\u011Finiz dili se\xe7in"},"link":{"buttontext":"Belgeyi g\xf6r\xfcnt\xfcle","goto":"Adrese git","click":"buraya t\u0131klay\u0131n","scanQR":"QrCode\'u tarayarak","scanQRTile":"Ke\u015Ffetmek i\xe7in QR Kodu\u2019nu tara"},"loader":{"loader":{"optimal":"Optimum bir deneyim i\xe7in,","classic":"Daha klasik bir deneyim i\xe7in,","vocal":"Temsilciyle konu\u015Farak ileti\u015Fim kuruyorum.","text":"Temsilciyle mesaj yoluyla ileti\u015Fim kuruyorum."},"modes":{"vocal":"vokal modu","text":"metin modu"},"loaderValidation":"Konu\u015Fmay\u0131 ba\u015Flat","locale":"dili kontrol etme","supported":"desteklenen dilleri kontrol etme","addressdata":"veri alma"},"menu":{"message":"Mesaj\u0131n\u0131z\u0131 girin","backconversation":"konu\u015Fmaya geri d\xf6n","answer":" sorular\u0131n\u0131z\u0131 yan\u0131tl\u0131yor"},"mobileLandscapePreventer":{"firstline":"Optimum bir deneyim i\xe7in,","secondline":"ekran\u0131n\u0131 \xe7evir"},"news":{"warningtext":"Haber kanal\u0131na ula\u015Facaks\u0131n\u0131z, cihaz\u0131n\u0131zdaki ses aktif hale gelecektir","live":"canl\u0131","continuous":"devaml\u0131 olarak"},"poi":{"comment":"m\xfc\u015Fteri yorumu","route":"yol","nodata":"Araman\u0131zla e\u015Fle\u015Fen i\xe7erik yok","openinghours":"A\xe7\u0131l\u0131\u015F saatleri","prices":"Fiyat:% s","paymentmethods":"\xd6deme metodlar\u0131","numberofplaces":"yer say\u0131s\u0131","openroutemobile":"ak\u0131ll\u0131 telefonda Google Haritalar rotas\u0131n\u0131 a\xe7","FoodEstablishment":"Nerede yenir","LodgingBusiness":"Nerede uyumal\u0131","TouristDestination":"Ne g\xf6rmeli","TouristAttraction":"Ne yapal\u0131m","Product":"Yerel \xfcr\xfcnler","Service":"Hizmetler","Event":"Olaylar","City":"\u015Eehirler","Wine":"\u015Earaplar"},"suggestion":{"consult":"\xc7\u0131k\u0131\u015F yapmak","thetutorial":"\xf6\u011Fretici"},"template":{"reset":"hepsini s\u0131f\u0131rla","showresults":"Sonu\xe7lar\u0131 g\xf6ster","suggestiontitle":"\xd6nerileri ara","reminder":"Unutmay\u0131n, \\n sorular\u0131n\u0131z\u0131 cevaplayabilirim."},"anghello":{"listening":"S\u0131ra sizde, dinliyorum...","correct":"D\xfczelt","dontknow":"Bilmiyorum"},"microphone":{"allow":"Devam etmek i\xe7in l\xfctfen taray\u0131c\u0131n\u0131z\u0131n mikrofonunuza eri\u015Fmesine izin verin.","rejected":"Mikrofon eri\u015Fimini reddettiniz.","instructions":"Ses modunu kullanmak i\xe7in l\xfctfen taray\u0131c\u0131n\u0131z\u0131n mikrofonunuza eri\u015Fmesine izin verin.","listening":"S\xf6yl\xfcyorum","trigger":"Basma veya s\xf6yle","triggerwithoutname":"Konu\u015Fmak i\xe7in dokunun"}}');

});

parcelRegister("5ufOy", function(module, exports) {
module.exports = JSON.parse('{"1":"\u4E3B\u9875","2":"\u5B9E\u65F6\u4FE1\u606F\u9891\u9053","3":"\u5929\u6C14","4":"\u7D27\u6025\u7535\u8BDD\u53F7\u7801","1000":"\u5386\u53F2","1001":"\u6559\u7A0B","common":{"all":"\u5168\u90E8","back":"\u540E\u9000","close":"\u5173\u95ED","continue":"\u7EE7\u7EED","download":"\u4E0B\u8F7D","downloadsheet":"\u4E0B\u8F7D\u6B64\u8868","downloadsheetmobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868","filter":"\u7B5B\u9009","history":"\u5386\u53F2\u7684","knowmore":"\u4E86\u89E3\u66F4\u591A","lang":"\u8BED\u8A00","menu":"\u83DC\u5355","mode":"\u65F6\u5C1A","needhelp":"\u9700\u8981\u5E2E\u5FD9\uFF1F","parameters":"\u8BBE\u7F6E","print":"\u6253\u5370","printsheet":"\u6253\u5370\u6B64\u8868","result":"\u7ED3\u679C","results":"\u7ED3\u679C","singleLang":"\u8BED\u8A00","sound":"\u5979","submit":"\u63D0\u4EA4","subtitle":"\u5B57\u5E55","tutorial":"\u6559\u7A0B","validate":"\u8BC1\u5B9E"},"emergency":{"samu":"S.A.M.U.","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u5458","general":"\u5C06\u519B","hospital":"\u533B\u9662","homeless":"\u65E0\u5BB6\u53EF\u5F52","poison":"\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3","emergency":"\u7D27\u6025\u670D\u52A1"},"error":{"title":"\u53D1\u751F\u4E86\u9519\u8BEF","button":"\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"},"history":{"title":"\u5BF9\u8BDD\u5386\u53F2"},"inputs":{"choose":"\u9009\u62E9\u4E00\u4E2A\u7B54\u6848"},"language":{"change":"\u66F4\u6539\u8BED\u8A00","select":"\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"},"link":{"buttontext":"\u67E5\u770B\u6587\u6863","goto":"\u524D\u5F80\u5730\u5740","click":"\u70B9\u51FB\u8FD9\u91CC","scanQR":"\u626B\u63CF\u4E8C\u7EF4\u7801","scanQRTile":"\u626B\u63CF\u4E8C\u7EF4\u7801\u4EE5\u53D1\u73B0"},"loader":{"loader":{"optimal":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","classic":"\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C","vocal":"\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002","text":"\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"},"modes":{"vocal":"\u58F0\u97F3\u6A21\u5F0F","text":"\u6587\u672C\u6A21\u5F0F"},"loaderValidation":"\u5F00\u59CB\u5BF9\u8BDD","locale":"\u68C0\u67E5\u8BED\u8A00","supported":"\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00","addressdata":"\u68C0\u7D22\u6570\u636E"},"menu":{"message":"\u8F93\u5165\u60A8\u7684\u7559\u8A00","backconversation":"\u56DE\u5230\u5BF9\u8BDD","answer":" \u56DE\u7B54\u4F60\u7684\u95EE\u9898"},"mobileLandscapePreventer":{"firstline":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","secondline":"\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"},"news":{"warningtext":"\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B","live":"\u5C45\u4F4F","continuous":"\u4E0D\u65AD\u5730"},"poi":{"comment":"\u5BA2\u6237\u8BC4\u8BBA","route":"\u8DEF","nodata":"\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22","openinghours":"\u8425\u4E1A\u65F6\u95F4","prices":"\u4EF7\u683C","paymentmethods":"\u652F\u4ED8\u65B9\u5F0F","numberofplaces":"\u540D\u989D","openroutemobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF","FoodEstablishment":"\u53BB\u54EA\u91CC\u5403\u996D","LodgingBusiness":"\u7761\u89C9\u7684\u5730\u65B9","TouristDestination":"\u8BE5\u770B\u4EC0\u4E48","TouristAttraction":"\u8BE5\u600E\u4E48\u529E","Product":"\u571F\u7279\u4EA7","Service":"\u670D\u52A1","Event":"\u6D3B\u52A8","City":"\u57CE\u5E02","Wine":"\u8461\u8404\u9152"},"suggestion":{"consult":"\u67E5\u770B","thetutorial":"\u6559\u7A0B"},"template":{"reset":"\u91CD\u7F6E\u5168\u90E8","showresults":"\u663E\u793A\u7ED3\u679C","suggestiontitle":"\u641C\u7D22\u5EFA\u8BAE","reminder":"\u522B\u5FD8\u4E86\uFF0C\\n\u6211\u53EF\u4EE5\u56DE\u7B54\u4F60\u7684\u95EE\u9898\u3002"},"anghello":{"listening":"\u7531\u4F60\u51B3\u5B9A\uFF0C\u6211\u5728\u542C...","correct":"\u7EA0\u6B63","dontknow":"\u6211\u4E0D\u77E5\u9053"},"microphone":{"allow":"\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u9EA6\u514B\u98CE\u4EE5\u7EE7\u7EED\u3002","rejected":"\u60A8\u5DF2\u62D2\u7EDD\u9EA6\u514B\u98CE\u8BBF\u95EE\u3002","instructions":"\u8981\u4F7F\u7528\u8BED\u97F3\u6A21\u5F0F\uFF0C\u8BF7\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u8BBF\u95EE\u9EA6\u514B\u98CE\u3002","listening":"\u6211\u5728\u542C\u4F60\u8BF4\u8BDD","trigger":"\u6309\u6216\u8BF4","triggerwithoutname":"\u70B9\u51FB\u8BF4\u8BDD"}}');

});

parcelRegister("jsptP", function(module, exports) {
module.exports = JSON.parse('{"1":"\u4E3B\u9875","2":"\u5B9E\u65F6\u4FE1\u606F\u9891\u9053","3":"\u5929\u6C14","4":"\u7D27\u6025\u7535\u8BDD\u53F7\u7801","1000":"\u5386\u53F2","1001":"\u6559\u7A0B","common":{"all":"\u5168\u90E8","back":"\u540E\u9000","close":"\u5173\u95ED","continue":"\u7EE7\u7EED","download":"\u4E0B\u8F7D","downloadsheet":"\u4E0B\u8F7D\u6B64\u8868","downloadsheetmobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868","filter":"\u7B5B\u9009","history":"\u5386\u53F2\u7684","knowmore":"\u4E86\u89E3\u66F4\u591A","lang":"\u8BED\u8A00","menu":"\u83DC\u5355","mode":"\u65F6\u5C1A","needhelp":"\u9700\u8981\u5E2E\u5FD9\uFF1F","parameters":"\u8BBE\u7F6E","print":"\u6253\u5370","printsheet":"\u6253\u5370\u6B64\u8868","result":"\u7ED3\u679C","results":"\u7ED3\u679C","singleLang":"\u8BED\u8A00","sound":"\u5979","submit":"\u63D0\u4EA4","subtitle":"\u5B57\u5E55","tutorial":"\u6559\u7A0B","validate":"\u8BC1\u5B9E"},"emergency":{"samu":"S.A.M.U.","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u5458","general":"\u5C06\u519B","hospital":"\u533B\u9662","homeless":"\u65E0\u5BB6\u53EF\u5F52","poison":"\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3","emergency":"\u7D27\u6025\u670D\u52A1"},"error":{"title":"\u53D1\u751F\u4E86\u9519\u8BEF","button":"\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"},"history":{"title":"\u5BF9\u8BDD\u5386\u53F2"},"inputs":{"choose":"\u9009\u62E9\u4E00\u4E2A\u7B54\u6848"},"language":{"change":"\u66F4\u6539\u8BED\u8A00","select":"\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"},"link":{"buttontext":"\u67E5\u770B\u6587\u6863","goto":"\u524D\u5F80\u5730\u5740","click":"\u70B9\u51FB\u8FD9\u91CC","scanQR":"\u626B\u63CF\u4E8C\u7EF4\u7801","scanQRTile":"\u6383\u63CF QR \u78BC\u4EE5\u767C\u73FE"},"loader":{"loader":{"optimal":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","classic":"\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C","vocal":"\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002","text":"\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"},"modes":{"vocal":"\u58F0\u97F3\u6A21\u5F0F","text":"\u6587\u672C\u6A21\u5F0F"},"loaderValidation":"\u5F00\u59CB\u5BF9\u8BDD","locale":"\u68C0\u67E5\u8BED\u8A00","supported":"\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00","addressdata":"\u68C0\u7D22\u6570\u636E"},"menu":{"message":"\u8F93\u5165\u60A8\u7684\u7559\u8A00","backconversation":"\u56DE\u5230\u5BF9\u8BDD","answer":" \u56DE\u7B54\u4F60\u7684\u95EE\u9898"},"mobileLandscapePreventer":{"firstline":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","secondline":"\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"},"news":{"warningtext":"\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B","live":"\u5C45\u4F4F","continuous":"\u4E0D\u65AD\u5730"},"poi":{"comment":"\u5BA2\u6237\u8BC4\u8BBA","route":"\u8DEF","nodata":"\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22","openinghours":"\u8425\u4E1A\u65F6\u95F4","prices":"\u4EF7\u683C","paymentmethods":"\u652F\u4ED8\u65B9\u5F0F","numberofplaces":"\u540D\u989D","openroutemobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF","FoodEstablishment":"\u53BB\u54EA\u91CC\u5403\u996D","LodgingBusiness":"\u7761\u89C9\u7684\u5730\u65B9","TouristDestination":"\u8BE5\u770B\u4EC0\u4E48","TouristAttraction":"\u8BE5\u600E\u4E48\u529E","Product":"\u571F\u7279\u4EA7","Service":"\u670D\u52A1","Event":"\u6D3B\u52A8","City":"\u57CE\u5E02","Wine":"\u8461\u8404\u9152"},"suggestion":{"consult":"\u67E5\u770B","thetutorial":"\u6559\u7A0B"},"template":{"reset":"\u91CD\u7F6E\u5168\u90E8","showresults":"\u663E\u793A\u7ED3\u679C","suggestiontitle":"\u641C\u7D22\u5EFA\u8BAE","reminder":"\u522B\u5FD8\u4E86\uFF0C\\n\u6211\u53EF\u4EE5\u56DE\u7B54\u4F60\u7684\u95EE\u9898\u3002"},"anghello":{"listening":"\u7531\u4F60\u6C7A\u5B9A\uFF0C\u6211\u5728\u807D...","correct":"\u66F4\u6B63","dontknow":"\u6211\u4E0D\u77E5\u9053"},"microphone":{"allow":"\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u4EE5\u7E7C\u7E8C\u3002","rejected":"\u60A8\u5DF2\u62D2\u7D55\u9EA5\u514B\u98A8\u8A2A\u554F\u3002","instructions":"\u8981\u4F7F\u7528\u8A9E\u97F3\u6A21\u5F0F\uFF0C\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u3002","listening":"\u6211\u5728\u542C\u4F60\u8BF4\u8BDD","trigger":"\u6309\u6216\u8BF4","triggerwithoutname":"\u9EDE\u64CA\u4EE5\u8AAA\u8A71"}}');

});

parcelRegister("1yVKr", function(module, exports) {
module.exports = JSON.parse('{"1":"\u4E3B\u9875","2":"\u5B9E\u65F6\u4FE1\u606F\u9891\u9053","3":"\u5929\u6C14","4":"\u7D27\u6025\u7535\u8BDD\u53F7\u7801","1000":"\u5386\u53F2","1001":"\u6559\u7A0B","common":{"all":"\u5168\u90E8","back":"\u540E\u9000","close":"\u5173\u95ED","continue":"\u7EE7\u7EED","download":"\u4E0B\u8F7D","downloadsheet":"\u4E0B\u8F7D\u6B64\u8868","downloadsheetmobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868","filter":"\u7B5B\u9009","history":"\u5386\u53F2\u7684","knowmore":"\u4E86\u89E3\u66F4\u591A","lang":"\u8BED\u8A00","menu":"\u83DC\u5355","mode":"\u65F6\u5C1A","needhelp":"\u9700\u8981\u5E2E\u5FD9\uFF1F","parameters":"\u8BBE\u7F6E","print":"\u6253\u5370","printsheet":"\u6253\u5370\u6B64\u8868","result":"\u7ED3\u679C","results":"\u7ED3\u679C","singleLang":"\u8BED\u8A00","sound":"\u5979","submit":"\u63D0\u4EA4","subtitle":"\u5B57\u5E55","tutorial":"\u6559\u7A0B","validate":"\u8BC1\u5B9E"},"emergency":{"samu":"S.A.M.U.","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u5458","general":"\u5C06\u519B","hospital":"\u533B\u9662","homeless":"\u65E0\u5BB6\u53EF\u5F52","poison":"\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3","emergency":"\u7D27\u6025\u670D\u52A1"},"error":{"title":"\u53D1\u751F\u4E86\u9519\u8BEF","button":"\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"},"history":{"title":"\u5BF9\u8BDD\u5386\u53F2"},"inputs":{"choose":"\u9009\u62E9\u4E00\u4E2A\u7B54\u6848"},"language":{"change":"\u66F4\u6539\u8BED\u8A00","select":"\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"},"link":{"buttontext":"\u67E5\u770B\u6587\u6863","goto":"\u524D\u5F80\u5730\u5740","click":"\u70B9\u51FB\u8FD9\u91CC","scanQR":"\u626B\u63CF\u4E8C\u7EF4\u7801","scanQRTile":"\u6383\u63CF QR \u78BC\u4EE5\u767C\u73FE"},"loader":{"loader":{"optimal":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","classic":"\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C","vocal":"\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002","text":"\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"},"modes":{"vocal":"\u58F0\u97F3\u6A21\u5F0F","text":"\u6587\u672C\u6A21\u5F0F"},"loaderValidation":"\u5F00\u59CB\u5BF9\u8BDD","locale":"\u68C0\u67E5\u8BED\u8A00","supported":"\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00","addressdata":"\u68C0\u7D22\u6570\u636E"},"menu":{"message":"\u8F93\u5165\u60A8\u7684\u7559\u8A00","backconversation":"\u56DE\u5230\u5BF9\u8BDD","answer":" \u56DE\u7B54\u4F60\u7684\u95EE\u9898"},"mobileLandscapePreventer":{"firstline":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","secondline":"\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"},"news":{"warningtext":"\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B","live":"\u5C45\u4F4F","continuous":"\u4E0D\u65AD\u5730"},"poi":{"comment":"\u5BA2\u6237\u8BC4\u8BBA","route":"\u8DEF","nodata":"\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22","openinghours":"\u8425\u4E1A\u65F6\u95F4","prices":"\u4EF7\u683C","paymentmethods":"\u652F\u4ED8\u65B9\u5F0F","numberofplaces":"\u540D\u989D","openroutemobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF","FoodEstablishment":"\u53BB\u54EA\u91CC\u5403\u996D","LodgingBusiness":"\u7761\u89C9\u7684\u5730\u65B9","TouristDestination":"\u8BE5\u770B\u4EC0\u4E48","TouristAttraction":"\u8BE5\u600E\u4E48\u529E","Product":"\u571F\u7279\u4EA7","Service":"\u670D\u52A1","Event":"\u6D3B\u52A8","City":"\u57CE\u5E02","Wine":"\u8461\u8404\u9152"},"suggestion":{"consult":"\u67E5\u770B","thetutorial":"\u6559\u7A0B"},"template":{"reset":"\u91CD\u7F6E\u5168\u90E8","showresults":"\u663E\u793A\u7ED3\u679C","suggestiontitle":"\u641C\u7D22\u5EFA\u8BAE","reminder":"\u522B\u5FD8\u4E86\uFF0C\\n\u6211\u53EF\u4EE5\u56DE\u7B54\u4F60\u7684\u95EE\u9898\u3002"},"anghello":{"listening":"\u7531\u4F60\u6C7A\u5B9A\uFF0C\u6211\u5728\u807D...","correct":"\u66F4\u6B63","dontknow":"\u6211\u4E0D\u77E5\u9053"},"microphone":{"allow":"\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u4EE5\u7E7C\u7E8C\u3002","rejected":"\u60A8\u5DF2\u62D2\u7D55\u9EA5\u514B\u98A8\u8A2A\u554F\u3002","instructions":"\u8981\u4F7F\u7528\u8A9E\u97F3\u6A21\u5F0F\uFF0C\u8ACB\u5141\u8A31\u60A8\u7684\u700F\u89BD\u5668\u8A2A\u554F\u9EA5\u514B\u98A8\u3002","listening":"\u6211\u5728\u542C\u4F60\u8BF4\u8BDD","trigger":"\u6309\u6216\u8BF4","triggerwithoutname":"\u9EDE\u64CA\u4EE5\u8AAA\u8A71"}}');

});


parcelRegister("8h6ET", function(module, exports) {

$parcel$export(module.exports, "deepMerge", () => $4fe2e42aa167de9f$export$6969335ea1e4e77c);
$parcel$export(module.exports, "default", () => $4fe2e42aa167de9f$export$2e2bcd8739ae039);

var $7j7nS = parcelRequire("7j7nS");
const $4fe2e42aa167de9f$export$6969335ea1e4e77c = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === 'object';
    if (!isObject(target) || !isObject(source)) return source;
    Object.keys(source).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (targetValue || targetValue === false) {
            if (Array.isArray(targetValue) && Array.isArray(sourceValue)) source[key] = [
                ...new Set([
                    ...targetValue,
                    ...sourceValue
                ])
            ];
            else if (isObject(targetValue) && isObject(sourceValue)) source[key] = $4fe2e42aa167de9f$export$6969335ea1e4e77c(targetValue, sourceValue);
            else source[key] = targetValue;
        }
    });
    return source;
};
const $4fe2e42aa167de9f$var$getThemeColors = (colors)=>{
    let defaultColors = colors?.theme === 'light' ? (0, $7j7nS.defaultThemeLight) : (0, $7j7nS.defaultThemeDark);
    defaultColors = $4fe2e42aa167de9f$export$6969335ea1e4e77c(colors, defaultColors);
    return defaultColors;
};
var $4fe2e42aa167de9f$export$2e2bcd8739ae039 = $4fe2e42aa167de9f$var$getThemeColors;

});


parcelRegister("i2BIy", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $d225abd390b33787$export$307591e98609eddd, (v) => $d225abd390b33787$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $d225abd390b33787$export$eb3a06aef9e6ee51, (v) => $d225abd390b33787$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $d225abd390b33787$export$b23711c915539651, (v) => $d225abd390b33787$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $d225abd390b33787$export$80e7718417253a51, (v) => $d225abd390b33787$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $d225abd390b33787$export$83d89fbfd8236492, (v) => $d225abd390b33787$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d225abd390b33787$export$307591e98609eddd;
var $d225abd390b33787$export$eb3a06aef9e6ee51;
var $d225abd390b33787$export$b23711c915539651;
var $d225abd390b33787$export$80e7718417253a51;
var $d225abd390b33787$export$83d89fbfd8236492;
'use strict';

var $bxRTa = parcelRequire("bxRTa");
function $d225abd390b33787$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d225abd390b33787$var$p = Object.prototype.hasOwnProperty, $d225abd390b33787$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d225abd390b33787$var$ha = {}, $d225abd390b33787$var$ia = {};
function $d225abd390b33787$var$ja(a) {
    if ($d225abd390b33787$var$p.call($d225abd390b33787$var$ia, a)) return !0;
    if ($d225abd390b33787$var$p.call($d225abd390b33787$var$ha, a)) return !1;
    if ($d225abd390b33787$var$fa.test(a)) return $d225abd390b33787$var$ia[a] = !0;
    $d225abd390b33787$var$ha[a] = !0;
    return !1;
}
function $d225abd390b33787$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $d225abd390b33787$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d225abd390b33787$var$ka = /[\-:]([a-z])/g;
function $d225abd390b33787$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d225abd390b33787$var$ka, $d225abd390b33787$var$la);
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d225abd390b33787$var$ka, $d225abd390b33787$var$la);
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d225abd390b33787$var$ka, $d225abd390b33787$var$la);
    $d225abd390b33787$var$t[b] = new $d225abd390b33787$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d225abd390b33787$var$t.xlinkHref = new $d225abd390b33787$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d225abd390b33787$var$t[a] = new $d225abd390b33787$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $d225abd390b33787$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d225abd390b33787$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d225abd390b33787$var$u).forEach(function(a) {
    $d225abd390b33787$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d225abd390b33787$var$u[b] = $d225abd390b33787$var$u[a];
    });
});
var $d225abd390b33787$var$na = /["'&<>]/;
function $d225abd390b33787$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $d225abd390b33787$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $d225abd390b33787$var$oa = /([A-Z])/g, $d225abd390b33787$var$pa = /^ms-/, $d225abd390b33787$var$qa = Array.isArray;
function $d225abd390b33787$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $d225abd390b33787$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $d225abd390b33787$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $d225abd390b33787$var$w(2, null);
        case "math":
            return $d225abd390b33787$var$w(3, null);
        case "foreignObject":
            return $d225abd390b33787$var$w(1, null);
        case "table":
            return $d225abd390b33787$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $d225abd390b33787$var$w(5, null);
        case "colgroup":
            return $d225abd390b33787$var$w(7, null);
        case "tr":
            return $d225abd390b33787$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $d225abd390b33787$var$w(1, null) : a;
}
var $d225abd390b33787$var$sa = new Map;
function $d225abd390b33787$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($d225abd390b33787$var$l(62));
    b = !0;
    for(var d in c)if ($d225abd390b33787$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $d225abd390b33787$var$v(d);
                f = $d225abd390b33787$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $d225abd390b33787$var$sa.get(e);
                void 0 !== g ? e = g : (g = $d225abd390b33787$var$v(e.replace($d225abd390b33787$var$oa, "-$1").toLowerCase().replace($d225abd390b33787$var$pa, "-ms-")), $d225abd390b33787$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $d225abd390b33787$var$p.call($d225abd390b33787$var$u, d) ? "" + f : f + "px" : $d225abd390b33787$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $d225abd390b33787$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $d225abd390b33787$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $d225abd390b33787$var$t.hasOwnProperty(c) ? $d225abd390b33787$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
            }
        } else if ($d225abd390b33787$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $d225abd390b33787$var$v(d), '"');
        }
    }
}
function $d225abd390b33787$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($d225abd390b33787$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($d225abd390b33787$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $d225abd390b33787$var$ua(a) {
    var b = "";
    $bxRTa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $d225abd390b33787$var$va(a, b, c, d) {
    a.push($d225abd390b33787$var$A(c));
    var f = c = null, e;
    for(e in b)if ($d225abd390b33787$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $d225abd390b33787$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $d225abd390b33787$var$y(a, f, c);
    return "string" === typeof c ? (a.push($d225abd390b33787$var$v(c)), null) : c;
}
var $d225abd390b33787$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $d225abd390b33787$var$xa = new Map;
function $d225abd390b33787$var$A(a) {
    var b = $d225abd390b33787$var$xa.get(a);
    if (void 0 === b) {
        if (!$d225abd390b33787$var$wa.test(a)) throw Error($d225abd390b33787$var$l(65, a));
        b = "<" + a;
        $d225abd390b33787$var$xa.set(a, b);
    }
    return b;
}
function $d225abd390b33787$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($d225abd390b33787$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($d225abd390b33787$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $d225abd390b33787$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $d225abd390b33787$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($d225abd390b33787$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($d225abd390b33787$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $d225abd390b33787$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $d225abd390b33787$var$ua(h), $d225abd390b33787$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $d225abd390b33787$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($d225abd390b33787$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($d225abd390b33787$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(91));
                default:
                    $d225abd390b33787$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($d225abd390b33787$var$l(92));
                if ($d225abd390b33787$var$qa(n) && 1 < n.length) throw Error($d225abd390b33787$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($d225abd390b33787$var$v("" + e));
            return null;
        case "input":
            a.push($d225abd390b33787$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($d225abd390b33787$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $d225abd390b33787$var$x(a, d, g, m);
            }
            null !== n ? $d225abd390b33787$var$x(a, d, "checked", n) : null !== k && $d225abd390b33787$var$x(a, d, "checked", k);
            null !== e ? $d225abd390b33787$var$x(a, d, "value", e) : null !== h && $d225abd390b33787$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($d225abd390b33787$var$A("menuitem"));
            for(var C in c)if ($d225abd390b33787$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(400));
                default:
                    $d225abd390b33787$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($d225abd390b33787$var$A("title"));
            e = null;
            for(q in c)if ($d225abd390b33787$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(434));
                default:
                    $d225abd390b33787$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($d225abd390b33787$var$A(b));
            g = e = null;
            for(k in c)if ($d225abd390b33787$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $d225abd390b33787$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($d225abd390b33787$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($d225abd390b33787$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($d225abd390b33787$var$A(b));
            for(var D in c)if ($d225abd390b33787$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d225abd390b33787$var$l(399, b));
                default:
                    $d225abd390b33787$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $d225abd390b33787$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $d225abd390b33787$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $d225abd390b33787$var$va(a, c, b, d);
            a.push($d225abd390b33787$var$A(b));
            g = e = null;
            for(m in c)if ($d225abd390b33787$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $d225abd390b33787$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $d225abd390b33787$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $d225abd390b33787$var$v(h), '"');
            }
            a.push(">");
            $d225abd390b33787$var$y(a, g, e);
            return e;
    }
}
function $d225abd390b33787$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($d225abd390b33787$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $d225abd390b33787$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($d225abd390b33787$var$l(397));
    }
}
function $d225abd390b33787$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($d225abd390b33787$var$l(397));
    }
}
var $d225abd390b33787$var$Ca = /[<\u2028\u2029]/g;
function $d225abd390b33787$var$Da(a) {
    return JSON.stringify(a).replace($d225abd390b33787$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $d225abd390b33787$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $d225abd390b33787$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($d225abd390b33787$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($d225abd390b33787$var$v(b)), a = !0);
    return a;
}
var $d225abd390b33787$var$B = Object.assign, $d225abd390b33787$var$Ga = Symbol.for("react.element"), $d225abd390b33787$var$Ha = Symbol.for("react.portal"), $d225abd390b33787$var$Ia = Symbol.for("react.fragment"), $d225abd390b33787$var$Ja = Symbol.for("react.strict_mode"), $d225abd390b33787$var$Ka = Symbol.for("react.profiler"), $d225abd390b33787$var$La = Symbol.for("react.provider"), $d225abd390b33787$var$Ma = Symbol.for("react.context"), $d225abd390b33787$var$Na = Symbol.for("react.forward_ref"), $d225abd390b33787$var$Oa = Symbol.for("react.suspense"), $d225abd390b33787$var$Pa = Symbol.for("react.suspense_list"), $d225abd390b33787$var$Qa = Symbol.for("react.memo"), $d225abd390b33787$var$Ra = Symbol.for("react.lazy"), $d225abd390b33787$var$Sa = Symbol.for("react.scope"), $d225abd390b33787$var$Ta = Symbol.for("react.debug_trace_mode"), $d225abd390b33787$var$Ua = Symbol.for("react.legacy_hidden"), $d225abd390b33787$var$Va = Symbol.for("react.default_value"), $d225abd390b33787$var$Wa = Symbol.iterator;
function $d225abd390b33787$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d225abd390b33787$var$Ia:
            return "Fragment";
        case $d225abd390b33787$var$Ha:
            return "Portal";
        case $d225abd390b33787$var$Ka:
            return "Profiler";
        case $d225abd390b33787$var$Ja:
            return "StrictMode";
        case $d225abd390b33787$var$Oa:
            return "Suspense";
        case $d225abd390b33787$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d225abd390b33787$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $d225abd390b33787$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $d225abd390b33787$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $d225abd390b33787$var$Qa:
            return b = a.displayName || null, null !== b ? b : $d225abd390b33787$var$Xa(a.type) || "Memo";
        case $d225abd390b33787$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $d225abd390b33787$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $d225abd390b33787$var$Ya = {};
function $d225abd390b33787$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $d225abd390b33787$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $d225abd390b33787$var$E = null;
function $d225abd390b33787$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($d225abd390b33787$var$l(401));
        } else {
            if (null === c) throw Error($d225abd390b33787$var$l(401));
            $d225abd390b33787$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $d225abd390b33787$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $d225abd390b33787$var$$a(a);
}
function $d225abd390b33787$var$ab(a) {
    var b = a.parent;
    null !== b && $d225abd390b33787$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $d225abd390b33787$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($d225abd390b33787$var$l(402));
    a.depth === b.depth ? $d225abd390b33787$var$F(a, b) : $d225abd390b33787$var$bb(a, b);
}
function $d225abd390b33787$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($d225abd390b33787$var$l(402));
    a.depth === c.depth ? $d225abd390b33787$var$F(a, c) : $d225abd390b33787$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $d225abd390b33787$var$G(a) {
    var b = $d225abd390b33787$var$E;
    b !== a && (null === b ? $d225abd390b33787$var$ab(a) : null === a ? $d225abd390b33787$var$$a(b) : b.depth === a.depth ? $d225abd390b33787$var$F(b, a) : b.depth > a.depth ? $d225abd390b33787$var$bb(b, a) : $d225abd390b33787$var$cb(b, a), $d225abd390b33787$var$E = a);
}
var $d225abd390b33787$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $d225abd390b33787$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $d225abd390b33787$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $d225abd390b33787$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $d225abd390b33787$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $d225abd390b33787$var$B({}, e, h)) : $d225abd390b33787$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $d225abd390b33787$var$fb = {
    id: 1,
    overflow: ""
};
function $d225abd390b33787$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $d225abd390b33787$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $d225abd390b33787$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $d225abd390b33787$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $d225abd390b33787$var$H = Math.clz32 ? Math.clz32 : $d225abd390b33787$var$hb, $d225abd390b33787$var$ib = Math.log, $d225abd390b33787$var$jb = Math.LN2;
function $d225abd390b33787$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($d225abd390b33787$var$ib(a) / $d225abd390b33787$var$jb | 0) | 0;
}
function $d225abd390b33787$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d225abd390b33787$var$lb = "function" === typeof Object.is ? Object.is : $d225abd390b33787$var$kb, $d225abd390b33787$var$I = null, $d225abd390b33787$var$ob = null, $d225abd390b33787$var$J = null, $d225abd390b33787$var$K = null, $d225abd390b33787$var$L = !1, $d225abd390b33787$var$M = !1, $d225abd390b33787$var$N = 0, $d225abd390b33787$var$O = null, $d225abd390b33787$var$P = 0;
function $d225abd390b33787$var$Q() {
    if (null === $d225abd390b33787$var$I) throw Error($d225abd390b33787$var$l(321));
    return $d225abd390b33787$var$I;
}
function $d225abd390b33787$var$pb() {
    if (0 < $d225abd390b33787$var$P) throw Error($d225abd390b33787$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $d225abd390b33787$var$qb() {
    null === $d225abd390b33787$var$K ? null === $d225abd390b33787$var$J ? ($d225abd390b33787$var$L = !1, $d225abd390b33787$var$J = $d225abd390b33787$var$K = $d225abd390b33787$var$pb()) : ($d225abd390b33787$var$L = !0, $d225abd390b33787$var$K = $d225abd390b33787$var$J) : null === $d225abd390b33787$var$K.next ? ($d225abd390b33787$var$L = !1, $d225abd390b33787$var$K = $d225abd390b33787$var$K.next = $d225abd390b33787$var$pb()) : ($d225abd390b33787$var$L = !0, $d225abd390b33787$var$K = $d225abd390b33787$var$K.next);
    return $d225abd390b33787$var$K;
}
function $d225abd390b33787$var$rb() {
    $d225abd390b33787$var$ob = $d225abd390b33787$var$I = null;
    $d225abd390b33787$var$M = !1;
    $d225abd390b33787$var$J = null;
    $d225abd390b33787$var$P = 0;
    $d225abd390b33787$var$K = $d225abd390b33787$var$O = null;
}
function $d225abd390b33787$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d225abd390b33787$var$tb(a, b, c) {
    $d225abd390b33787$var$I = $d225abd390b33787$var$Q();
    $d225abd390b33787$var$K = $d225abd390b33787$var$qb();
    if ($d225abd390b33787$var$L) {
        var d = $d225abd390b33787$var$K.queue;
        b = d.dispatch;
        if (null !== $d225abd390b33787$var$O && (c = $d225abd390b33787$var$O.get(d), void 0 !== c)) {
            $d225abd390b33787$var$O.delete(d);
            d = $d225abd390b33787$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $d225abd390b33787$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $d225abd390b33787$var$K.memoizedState,
            b
        ];
    }
    a = a === $d225abd390b33787$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $d225abd390b33787$var$K.memoizedState = a;
    a = $d225abd390b33787$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $d225abd390b33787$var$ub.bind(null, $d225abd390b33787$var$I, a);
    return [
        $d225abd390b33787$var$K.memoizedState,
        a
    ];
}
function $d225abd390b33787$var$vb(a, b) {
    $d225abd390b33787$var$I = $d225abd390b33787$var$Q();
    $d225abd390b33787$var$K = $d225abd390b33787$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $d225abd390b33787$var$K) {
        var c = $d225abd390b33787$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$d225abd390b33787$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $d225abd390b33787$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d225abd390b33787$var$ub(a, b, c) {
    if (25 <= $d225abd390b33787$var$P) throw Error($d225abd390b33787$var$l(301));
    if (a === $d225abd390b33787$var$I) {
        if ($d225abd390b33787$var$M = !0, a = {
            action: c,
            next: null
        }, null === $d225abd390b33787$var$O && ($d225abd390b33787$var$O = new Map), c = $d225abd390b33787$var$O.get(b), void 0 === c) $d225abd390b33787$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $d225abd390b33787$var$wb() {
    throw Error($d225abd390b33787$var$l(394));
}
function $d225abd390b33787$var$R() {}
var $d225abd390b33787$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $d225abd390b33787$var$Q();
        return a._currentValue2;
    },
    useMemo: $d225abd390b33787$var$vb,
    useReducer: $d225abd390b33787$var$tb,
    useRef: function(a) {
        $d225abd390b33787$var$I = $d225abd390b33787$var$Q();
        $d225abd390b33787$var$K = $d225abd390b33787$var$qb();
        var b = $d225abd390b33787$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $d225abd390b33787$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $d225abd390b33787$var$tb($d225abd390b33787$var$sb, a);
    },
    useInsertionEffect: $d225abd390b33787$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $d225abd390b33787$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $d225abd390b33787$var$R,
    useEffect: $d225abd390b33787$var$R,
    useDebugValue: $d225abd390b33787$var$R,
    useDeferredValue: function(a) {
        $d225abd390b33787$var$Q();
        return a;
    },
    useTransition: function() {
        $d225abd390b33787$var$Q();
        return [
            !1,
            $d225abd390b33787$var$wb
        ];
    },
    useId: function() {
        var a = $d225abd390b33787$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $d225abd390b33787$var$H(a) - 1)).toString(32) + b;
        var c = $d225abd390b33787$var$S;
        if (null === c) throw Error($d225abd390b33787$var$l(404));
        b = $d225abd390b33787$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $d225abd390b33787$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($d225abd390b33787$var$l(407));
        return c();
    }
}, $d225abd390b33787$var$S = null, $d225abd390b33787$var$yb = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $d225abd390b33787$var$zb(a) {
    console.error(a);
    return null;
}
function $d225abd390b33787$var$T() {}
function $d225abd390b33787$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $d225abd390b33787$var$zb : f,
        onAllReady: void 0 === e ? $d225abd390b33787$var$T : e,
        onShellReady: void 0 === g ? $d225abd390b33787$var$T : g,
        onShellError: void 0 === h ? $d225abd390b33787$var$T : h,
        onFatalError: void 0 === k ? $d225abd390b33787$var$T : k
    };
    c = $d225abd390b33787$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $d225abd390b33787$var$Bb(b, a, null, c, n, $d225abd390b33787$var$Ya, null, $d225abd390b33787$var$fb);
    m.push(a);
    return b;
}
function $d225abd390b33787$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $d225abd390b33787$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $d225abd390b33787$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $d225abd390b33787$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $d225abd390b33787$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $d225abd390b33787$var$Db(a, b, c, d, f) {
    $d225abd390b33787$var$I = {};
    $d225abd390b33787$var$ob = b;
    $d225abd390b33787$var$N = 0;
    for(a = c(d, f); $d225abd390b33787$var$M;)$d225abd390b33787$var$M = !1, $d225abd390b33787$var$N = 0, $d225abd390b33787$var$P += 1, $d225abd390b33787$var$K = null, a = c(d, f);
    $d225abd390b33787$var$rb();
    return a;
}
function $d225abd390b33787$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($d225abd390b33787$var$l(108, $d225abd390b33787$var$Xa(d) || "Unknown", h));
            d = $d225abd390b33787$var$B({}, g, c);
        }
        b.legacyContext = d;
        $d225abd390b33787$var$X(a, b, f);
        b.legacyContext = g;
    } else $d225abd390b33787$var$X(a, b, f);
}
function $d225abd390b33787$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $d225abd390b33787$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $d225abd390b33787$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $d225abd390b33787$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $d225abd390b33787$var$eb(e, c, d, f);
            $d225abd390b33787$var$Eb(a, b, e, c);
        } else {
            e = $d225abd390b33787$var$Za(c, b.legacyContext);
            f = $d225abd390b33787$var$Db(a, b, c, d, e);
            var g = 0 !== $d225abd390b33787$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $d225abd390b33787$var$eb(f, c, d, e), $d225abd390b33787$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $d225abd390b33787$var$gb(d, 1, 0);
                try {
                    $d225abd390b33787$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $d225abd390b33787$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $d225abd390b33787$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $d225abd390b33787$var$ra(g, c, d);
        $d225abd390b33787$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $d225abd390b33787$var$Ua:
            case $d225abd390b33787$var$Ta:
            case $d225abd390b33787$var$Ja:
            case $d225abd390b33787$var$Ka:
            case $d225abd390b33787$var$Ia:
                $d225abd390b33787$var$X(a, b, d.children);
                return;
            case $d225abd390b33787$var$Pa:
                $d225abd390b33787$var$X(a, b, d.children);
                return;
            case $d225abd390b33787$var$Sa:
                throw Error($d225abd390b33787$var$l(343));
            case $d225abd390b33787$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $d225abd390b33787$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $d225abd390b33787$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($d225abd390b33787$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $d225abd390b33787$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $d225abd390b33787$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $d225abd390b33787$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $d225abd390b33787$var$Na:
                d = $d225abd390b33787$var$Db(a, b, c.render, d, f);
                if (0 !== $d225abd390b33787$var$N) {
                    c = b.treeContext;
                    b.treeContext = $d225abd390b33787$var$gb(c, 1, 0);
                    try {
                        $d225abd390b33787$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $d225abd390b33787$var$X(a, b, d);
                return;
            case $d225abd390b33787$var$Qa:
                c = c.type;
                d = $d225abd390b33787$var$Fb(c, d);
                $d225abd390b33787$var$Gb(a, b, c, d, f);
                return;
            case $d225abd390b33787$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $d225abd390b33787$var$E;
                $d225abd390b33787$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $d225abd390b33787$var$X(a, b, f);
                a = $d225abd390b33787$var$E;
                if (null === a) throw Error($d225abd390b33787$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $d225abd390b33787$var$Va ? a.context._defaultValue : d;
                a = $d225abd390b33787$var$E = a.parent;
                b.context = a;
                return;
            case $d225abd390b33787$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $d225abd390b33787$var$X(a, b, d);
                return;
            case $d225abd390b33787$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $d225abd390b33787$var$Fb(c, d);
                $d225abd390b33787$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($d225abd390b33787$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $d225abd390b33787$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $d225abd390b33787$var$Ga:
                $d225abd390b33787$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $d225abd390b33787$var$Ha:
                throw Error($d225abd390b33787$var$l(257));
            case $d225abd390b33787$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $d225abd390b33787$var$X(a, b, c);
                return;
        }
        if ($d225abd390b33787$var$qa(c)) {
            $d225abd390b33787$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $d225abd390b33787$var$Wa && c[$d225abd390b33787$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $d225abd390b33787$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($d225abd390b33787$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $d225abd390b33787$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $d225abd390b33787$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $d225abd390b33787$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $d225abd390b33787$var$gb(e, d, f);
        try {
            $d225abd390b33787$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $d225abd390b33787$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $d225abd390b33787$var$X(a, b, c);
    } catch (k) {
        if ($d225abd390b33787$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $d225abd390b33787$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $d225abd390b33787$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $d225abd390b33787$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $d225abd390b33787$var$G(e), k;
    }
}
function $d225abd390b33787$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $d225abd390b33787$var$Kb(this, b, a);
}
function $d225abd390b33787$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($d225abd390b33787$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $d225abd390b33787$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $d225abd390b33787$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $d225abd390b33787$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $d225abd390b33787$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($d225abd390b33787$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $d225abd390b33787$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $d225abd390b33787$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($d225abd390b33787$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($d225abd390b33787$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $d225abd390b33787$var$Cb(a) {
    if (2 !== a.status) {
        var b = $d225abd390b33787$var$E, c = $d225abd390b33787$var$yb.current;
        $d225abd390b33787$var$yb.current = $d225abd390b33787$var$xb;
        var d = $d225abd390b33787$var$S;
        $d225abd390b33787$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $d225abd390b33787$var$G(g.context);
                    try {
                        $d225abd390b33787$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $d225abd390b33787$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($d225abd390b33787$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $d225abd390b33787$var$V(h, q);
                            null === n ? $d225abd390b33787$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $d225abd390b33787$var$Mb(a, a.destination);
        } catch (z) {
            $d225abd390b33787$var$V(a, z), $d225abd390b33787$var$W(a, z);
        } finally{
            $d225abd390b33787$var$S = d, $d225abd390b33787$var$yb.current = c, c === $d225abd390b33787$var$xb && $d225abd390b33787$var$G(b);
        }
    }
}
function $d225abd390b33787$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $d225abd390b33787$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($d225abd390b33787$var$l(390));
    }
}
function $d225abd390b33787$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $d225abd390b33787$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $d225abd390b33787$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $d225abd390b33787$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $d225abd390b33787$var$za(b, a.responseState, d);
        $d225abd390b33787$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $d225abd390b33787$var$za(b, a.responseState, d.id), $d225abd390b33787$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($d225abd390b33787$var$l(391));
    $d225abd390b33787$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $d225abd390b33787$var$Ob(a, b, c) {
    $d225abd390b33787$var$Aa(b, a.responseState, c.formatContext, c.id);
    $d225abd390b33787$var$Nb(a, b, c);
    return $d225abd390b33787$var$Ba(b, c.formatContext);
}
function $d225abd390b33787$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$d225abd390b33787$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($d225abd390b33787$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $d225abd390b33787$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($d225abd390b33787$var$l(392));
        return $d225abd390b33787$var$Ob(a, b, d);
    }
    $d225abd390b33787$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $d225abd390b33787$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $d225abd390b33787$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($d225abd390b33787$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $d225abd390b33787$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $d225abd390b33787$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $d225abd390b33787$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$d225abd390b33787$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$d225abd390b33787$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$d225abd390b33787$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $d225abd390b33787$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $d225abd390b33787$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $d225abd390b33787$var$Mb(a, a.destination);
    } catch (d) {
        $d225abd390b33787$var$V(a, d), $d225abd390b33787$var$W(a, d);
    }
}
function $d225abd390b33787$var$Sb() {}
function $d225abd390b33787$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $d225abd390b33787$var$Ab(a, $d225abd390b33787$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $d225abd390b33787$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $d225abd390b33787$var$Cb(a);
    $d225abd390b33787$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $d225abd390b33787$var$Mb(a, h);
        } catch (m) {
            $d225abd390b33787$var$V(a, m), $d225abd390b33787$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($d225abd390b33787$var$l(426));
    return g;
}
$d225abd390b33787$export$307591e98609eddd = function() {
    throw Error($d225abd390b33787$var$l(207));
};
$d225abd390b33787$export$eb3a06aef9e6ee51 = function(a, b) {
    return $d225abd390b33787$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$d225abd390b33787$export$b23711c915539651 = function() {
    throw Error($d225abd390b33787$var$l(208));
};
$d225abd390b33787$export$80e7718417253a51 = function(a, b) {
    return $d225abd390b33787$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$d225abd390b33787$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("3TORS", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $2d6df7737cf21851$export$7020a3240b287705, (v) => $2d6df7737cf21851$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $2d6df7737cf21851$export$83d89fbfd8236492, (v) => $2d6df7737cf21851$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2d6df7737cf21851$export$7020a3240b287705;
var $2d6df7737cf21851$export$83d89fbfd8236492;
'use strict';

var $bxRTa = parcelRequire("bxRTa");
function $2d6df7737cf21851$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2d6df7737cf21851$var$l = null, $2d6df7737cf21851$var$n = 0;
function $2d6df7737cf21851$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $2d6df7737cf21851$var$n && (a.enqueue(new Uint8Array($2d6df7737cf21851$var$l.buffer, 0, $2d6df7737cf21851$var$n)), $2d6df7737cf21851$var$l = new Uint8Array(512), $2d6df7737cf21851$var$n = 0), a.enqueue(b);
        else {
            var c = $2d6df7737cf21851$var$l.length - $2d6df7737cf21851$var$n;
            c < b.length && (0 === c ? a.enqueue($2d6df7737cf21851$var$l) : ($2d6df7737cf21851$var$l.set(b.subarray(0, c), $2d6df7737cf21851$var$n), a.enqueue($2d6df7737cf21851$var$l), b = b.subarray(c)), $2d6df7737cf21851$var$l = new Uint8Array(512), $2d6df7737cf21851$var$n = 0);
            $2d6df7737cf21851$var$l.set(b, $2d6df7737cf21851$var$n);
            $2d6df7737cf21851$var$n += b.length;
        }
    }
}
function $2d6df7737cf21851$var$t(a, b) {
    $2d6df7737cf21851$var$p(a, b);
    return !0;
}
function $2d6df7737cf21851$var$ba(a) {
    $2d6df7737cf21851$var$l && 0 < $2d6df7737cf21851$var$n && (a.enqueue(new Uint8Array($2d6df7737cf21851$var$l.buffer, 0, $2d6df7737cf21851$var$n)), $2d6df7737cf21851$var$l = null, $2d6df7737cf21851$var$n = 0);
}
var $2d6df7737cf21851$var$ca = new TextEncoder;
function $2d6df7737cf21851$var$u(a) {
    return $2d6df7737cf21851$var$ca.encode(a);
}
function $2d6df7737cf21851$var$w(a) {
    return $2d6df7737cf21851$var$ca.encode(a);
}
function $2d6df7737cf21851$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $2d6df7737cf21851$var$x = Object.prototype.hasOwnProperty, $2d6df7737cf21851$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2d6df7737cf21851$var$fa = {}, $2d6df7737cf21851$var$ha = {};
function $2d6df7737cf21851$var$ia(a) {
    if ($2d6df7737cf21851$var$x.call($2d6df7737cf21851$var$ha, a)) return !0;
    if ($2d6df7737cf21851$var$x.call($2d6df7737cf21851$var$fa, a)) return !1;
    if ($2d6df7737cf21851$var$ea.test(a)) return $2d6df7737cf21851$var$ha[a] = !0;
    $2d6df7737cf21851$var$fa[a] = !0;
    return !1;
}
function $2d6df7737cf21851$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $2d6df7737cf21851$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2d6df7737cf21851$var$ja = /[\-:]([a-z])/g;
function $2d6df7737cf21851$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2d6df7737cf21851$var$ja, $2d6df7737cf21851$var$ka);
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2d6df7737cf21851$var$ja, $2d6df7737cf21851$var$ka);
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2d6df7737cf21851$var$ja, $2d6df7737cf21851$var$ka);
    $2d6df7737cf21851$var$z[b] = new $2d6df7737cf21851$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2d6df7737cf21851$var$z.xlinkHref = new $2d6df7737cf21851$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2d6df7737cf21851$var$z[a] = new $2d6df7737cf21851$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $2d6df7737cf21851$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2d6df7737cf21851$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2d6df7737cf21851$var$B).forEach(function(a) {
    $2d6df7737cf21851$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2d6df7737cf21851$var$B[b] = $2d6df7737cf21851$var$B[a];
    });
});
var $2d6df7737cf21851$var$oa = /["'&<>]/;
function $2d6df7737cf21851$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $2d6df7737cf21851$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $2d6df7737cf21851$var$pa = /([A-Z])/g, $2d6df7737cf21851$var$qa = /^ms-/, $2d6df7737cf21851$var$ra = Array.isArray, $2d6df7737cf21851$var$sa = $2d6df7737cf21851$var$w("<script>"), $2d6df7737cf21851$var$ta = $2d6df7737cf21851$var$w("\x3c/script>"), $2d6df7737cf21851$var$ua = $2d6df7737cf21851$var$w('<script src="'), $2d6df7737cf21851$var$va = $2d6df7737cf21851$var$w('<script type="module" src="'), $2d6df7737cf21851$var$wa = $2d6df7737cf21851$var$w('" async="">\x3c/script>'), $2d6df7737cf21851$var$xa = /(<\/|<)(s)(cript)/gi;
function $2d6df7737cf21851$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $2d6df7737cf21851$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $2d6df7737cf21851$var$sa : $2d6df7737cf21851$var$w('<script nonce="' + $2d6df7737cf21851$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $2d6df7737cf21851$var$u(("" + c).replace($2d6df7737cf21851$var$xa, $2d6df7737cf21851$var$ya)), $2d6df7737cf21851$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($2d6df7737cf21851$var$ua, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d[c])), $2d6df7737cf21851$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($2d6df7737cf21851$var$va, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(f[d])), $2d6df7737cf21851$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $2d6df7737cf21851$var$w(a + "P:"),
        segmentPrefix: $2d6df7737cf21851$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $2d6df7737cf21851$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $2d6df7737cf21851$var$Aa(a) {
    return $2d6df7737cf21851$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $2d6df7737cf21851$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $2d6df7737cf21851$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $2d6df7737cf21851$var$D(2, null);
        case "math":
            return $2d6df7737cf21851$var$D(3, null);
        case "foreignObject":
            return $2d6df7737cf21851$var$D(1, null);
        case "table":
            return $2d6df7737cf21851$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $2d6df7737cf21851$var$D(5, null);
        case "colgroup":
            return $2d6df7737cf21851$var$D(7, null);
        case "tr":
            return $2d6df7737cf21851$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $2d6df7737cf21851$var$D(1, null) : a;
}
var $2d6df7737cf21851$var$Ca = $2d6df7737cf21851$var$w("\x3c!-- --\x3e");
function $2d6df7737cf21851$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($2d6df7737cf21851$var$Ca);
    a.push($2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(b)));
    return !0;
}
var $2d6df7737cf21851$var$Ea = new Map, $2d6df7737cf21851$var$Fa = $2d6df7737cf21851$var$w(' style="'), $2d6df7737cf21851$var$Ga = $2d6df7737cf21851$var$w(":"), $2d6df7737cf21851$var$Ha = $2d6df7737cf21851$var$w(";");
function $2d6df7737cf21851$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($2d6df7737cf21851$var$k(62));
    b = !0;
    for(var d in c)if ($2d6df7737cf21851$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d));
                f = $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $2d6df7737cf21851$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $2d6df7737cf21851$var$w($2d6df7737cf21851$var$C(e.replace($2d6df7737cf21851$var$pa, "-$1").toLowerCase().replace($2d6df7737cf21851$var$qa, "-ms-"))), $2d6df7737cf21851$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $2d6df7737cf21851$var$x.call($2d6df7737cf21851$var$B, d) ? $2d6df7737cf21851$var$u("" + f) : $2d6df7737cf21851$var$u(f + "px") : $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($2d6df7737cf21851$var$Fa, e, $2d6df7737cf21851$var$Ga, f)) : a.push($2d6df7737cf21851$var$Ha, e, $2d6df7737cf21851$var$Ga, f);
        }
    }
    b || a.push($2d6df7737cf21851$var$E);
}
var $2d6df7737cf21851$var$H = $2d6df7737cf21851$var$w(" "), $2d6df7737cf21851$var$I = $2d6df7737cf21851$var$w('="'), $2d6df7737cf21851$var$E = $2d6df7737cf21851$var$w('"'), $2d6df7737cf21851$var$Ja = $2d6df7737cf21851$var$w('=""');
function $2d6df7737cf21851$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $2d6df7737cf21851$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $2d6df7737cf21851$var$z.hasOwnProperty(c) ? $2d6df7737cf21851$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $2d6df7737cf21851$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$Ja) : !1 !== d && a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($2d6df7737cf21851$var$H, c, $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
            }
        } else if ($2d6df7737cf21851$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($2d6df7737cf21851$var$H, $2d6df7737cf21851$var$u(c), $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d)), $2d6df7737cf21851$var$E);
        }
    }
}
var $2d6df7737cf21851$var$K = $2d6df7737cf21851$var$w(">"), $2d6df7737cf21851$var$Ka = $2d6df7737cf21851$var$w("/>");
function $2d6df7737cf21851$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($2d6df7737cf21851$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($2d6df7737cf21851$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($2d6df7737cf21851$var$u("" + b));
    }
}
function $2d6df7737cf21851$var$La(a) {
    var b = "";
    $bxRTa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $2d6df7737cf21851$var$Ma = $2d6df7737cf21851$var$w(' selected=""');
function $2d6df7737cf21851$var$Na(a, b, c, d) {
    a.push($2d6df7737cf21851$var$M(c));
    var f = c = null, e;
    for(e in b)if ($2d6df7737cf21851$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $2d6df7737cf21851$var$J(a, d, e, g);
        }
    }
    a.push($2d6df7737cf21851$var$K);
    $2d6df7737cf21851$var$L(a, f, c);
    return "string" === typeof c ? (a.push($2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(c))), null) : c;
}
var $2d6df7737cf21851$var$Oa = $2d6df7737cf21851$var$w("\n"), $2d6df7737cf21851$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $2d6df7737cf21851$var$Qa = new Map;
function $2d6df7737cf21851$var$M(a) {
    var b = $2d6df7737cf21851$var$Qa.get(a);
    if (void 0 === b) {
        if (!$2d6df7737cf21851$var$Pa.test(a)) throw Error($2d6df7737cf21851$var$k(65, a));
        b = $2d6df7737cf21851$var$w("<" + a);
        $2d6df7737cf21851$var$Qa.set(a, b);
    }
    return b;
}
var $2d6df7737cf21851$var$Ra = $2d6df7737cf21851$var$w("<!DOCTYPE html>");
function $2d6df7737cf21851$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($2d6df7737cf21851$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($2d6df7737cf21851$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $2d6df7737cf21851$var$J(a, d, r, h);
                }
            }
            a.push($2d6df7737cf21851$var$K);
            $2d6df7737cf21851$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($2d6df7737cf21851$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($2d6df7737cf21851$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $2d6df7737cf21851$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $2d6df7737cf21851$var$La(h), $2d6df7737cf21851$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($2d6df7737cf21851$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($2d6df7737cf21851$var$Ma);
            } else q && a.push($2d6df7737cf21851$var$Ma);
            a.push($2d6df7737cf21851$var$K);
            $2d6df7737cf21851$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($2d6df7737cf21851$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($2d6df7737cf21851$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(91));
                default:
                    $2d6df7737cf21851$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($2d6df7737cf21851$var$K);
            if (null != r) {
                if (null != e) throw Error($2d6df7737cf21851$var$k(92));
                if ($2d6df7737cf21851$var$ra(r) && 1 < r.length) throw Error($2d6df7737cf21851$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($2d6df7737cf21851$var$Oa);
            null !== e && a.push($2d6df7737cf21851$var$u($2d6df7737cf21851$var$C("" + e)));
            return null;
        case "input":
            a.push($2d6df7737cf21851$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($2d6df7737cf21851$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $2d6df7737cf21851$var$J(a, d, g, q);
            }
            null !== r ? $2d6df7737cf21851$var$J(a, d, "checked", r) : null !== m && $2d6df7737cf21851$var$J(a, d, "checked", m);
            null !== e ? $2d6df7737cf21851$var$J(a, d, "value", e) : null !== h && $2d6df7737cf21851$var$J(a, d, "value", h);
            a.push($2d6df7737cf21851$var$Ka);
            return null;
        case "menuitem":
            a.push($2d6df7737cf21851$var$M("menuitem"));
            for(var A in c)if ($2d6df7737cf21851$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(400));
                default:
                    $2d6df7737cf21851$var$J(a, d, A, e);
            }
            a.push($2d6df7737cf21851$var$K);
            return null;
        case "title":
            a.push($2d6df7737cf21851$var$M("title"));
            e = null;
            for(v in c)if ($2d6df7737cf21851$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(434));
                default:
                    $2d6df7737cf21851$var$J(a, d, v, g);
            }
            a.push($2d6df7737cf21851$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($2d6df7737cf21851$var$M(b));
            g = e = null;
            for(m in c)if ($2d6df7737cf21851$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $2d6df7737cf21851$var$J(a, d, m, h);
            }
            a.push($2d6df7737cf21851$var$K);
            if (null != g) {
                if (null != e) throw Error($2d6df7737cf21851$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($2d6df7737cf21851$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($2d6df7737cf21851$var$Oa, $2d6df7737cf21851$var$u(c)) : a.push($2d6df7737cf21851$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($2d6df7737cf21851$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($2d6df7737cf21851$var$M(b));
            for(var F in c)if ($2d6df7737cf21851$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2d6df7737cf21851$var$k(399, b));
                default:
                    $2d6df7737cf21851$var$J(a, d, F, e);
            }
            a.push($2d6df7737cf21851$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $2d6df7737cf21851$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($2d6df7737cf21851$var$Ra), $2d6df7737cf21851$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $2d6df7737cf21851$var$Na(a, c, b, d);
            a.push($2d6df7737cf21851$var$M(b));
            g = e = null;
            for(q in c)if ($2d6df7737cf21851$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $2d6df7737cf21851$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $2d6df7737cf21851$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($2d6df7737cf21851$var$H, $2d6df7737cf21851$var$u(q), $2d6df7737cf21851$var$I, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(h)), $2d6df7737cf21851$var$E);
            }
            a.push($2d6df7737cf21851$var$K);
            $2d6df7737cf21851$var$L(a, g, e);
            return e;
    }
}
var $2d6df7737cf21851$var$Ta = $2d6df7737cf21851$var$w("</"), $2d6df7737cf21851$var$Ua = $2d6df7737cf21851$var$w(">"), $2d6df7737cf21851$var$Va = $2d6df7737cf21851$var$w('<template id="'), $2d6df7737cf21851$var$Wa = $2d6df7737cf21851$var$w('"></template>'), $2d6df7737cf21851$var$Xa = $2d6df7737cf21851$var$w("\x3c!--$--\x3e"), $2d6df7737cf21851$var$Ya = $2d6df7737cf21851$var$w('\x3c!--$?--\x3e<template id="'), $2d6df7737cf21851$var$Za = $2d6df7737cf21851$var$w('"></template>'), $2d6df7737cf21851$var$$a = $2d6df7737cf21851$var$w("\x3c!--$!--\x3e"), $2d6df7737cf21851$var$ab = $2d6df7737cf21851$var$w("\x3c!--/$--\x3e"), $2d6df7737cf21851$var$bb = $2d6df7737cf21851$var$w("<template"), $2d6df7737cf21851$var$cb = $2d6df7737cf21851$var$w('"'), $2d6df7737cf21851$var$db = $2d6df7737cf21851$var$w(' data-dgst="');
$2d6df7737cf21851$var$w(' data-msg="');
$2d6df7737cf21851$var$w(' data-stck="');
var $2d6df7737cf21851$var$eb = $2d6df7737cf21851$var$w("></template>");
function $2d6df7737cf21851$var$fb(a, b, c) {
    $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$Ya);
    if (null === c) throw Error($2d6df7737cf21851$var$k(395));
    $2d6df7737cf21851$var$p(a, c);
    return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$Za);
}
var $2d6df7737cf21851$var$gb = $2d6df7737cf21851$var$w('<div hidden id="'), $2d6df7737cf21851$var$hb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$ib = $2d6df7737cf21851$var$w("</div>"), $2d6df7737cf21851$var$jb = $2d6df7737cf21851$var$w('<svg aria-hidden="true" style="display:none" id="'), $2d6df7737cf21851$var$kb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$lb = $2d6df7737cf21851$var$w("</svg>"), $2d6df7737cf21851$var$mb = $2d6df7737cf21851$var$w('<math aria-hidden="true" style="display:none" id="'), $2d6df7737cf21851$var$nb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$ob = $2d6df7737cf21851$var$w("</math>"), $2d6df7737cf21851$var$pb = $2d6df7737cf21851$var$w('<table hidden id="'), $2d6df7737cf21851$var$qb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$rb = $2d6df7737cf21851$var$w("</table>"), $2d6df7737cf21851$var$sb = $2d6df7737cf21851$var$w('<table hidden><tbody id="'), $2d6df7737cf21851$var$tb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$ub = $2d6df7737cf21851$var$w("</tbody></table>"), $2d6df7737cf21851$var$vb = $2d6df7737cf21851$var$w('<table hidden><tr id="'), $2d6df7737cf21851$var$wb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$xb = $2d6df7737cf21851$var$w("</tr></table>"), $2d6df7737cf21851$var$yb = $2d6df7737cf21851$var$w('<table hidden><colgroup id="'), $2d6df7737cf21851$var$zb = $2d6df7737cf21851$var$w('">'), $2d6df7737cf21851$var$Ab = $2d6df7737cf21851$var$w("</colgroup></table>");
function $2d6df7737cf21851$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$gb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$hb);
        case 2:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$jb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$kb);
        case 3:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$mb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$nb);
        case 4:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$pb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$qb);
        case 5:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$sb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$tb);
        case 6:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$vb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$wb);
        case 7:
            return $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$yb), $2d6df7737cf21851$var$p(a, b.segmentPrefix), $2d6df7737cf21851$var$p(a, $2d6df7737cf21851$var$u(d.toString(16))), $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$zb);
        default:
            throw Error($2d6df7737cf21851$var$k(397));
    }
}
function $2d6df7737cf21851$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$ib);
        case 2:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$lb);
        case 3:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$ob);
        case 4:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$rb);
        case 5:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$ub);
        case 6:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$xb);
        case 7:
            return $2d6df7737cf21851$var$t(a, $2d6df7737cf21851$var$Ab);
        default:
            throw Error($2d6df7737cf21851$var$k(397));
    }
}
var $2d6df7737cf21851$var$Db = $2d6df7737cf21851$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $2d6df7737cf21851$var$Eb = $2d6df7737cf21851$var$w('$RS("'), $2d6df7737cf21851$var$Gb = $2d6df7737cf21851$var$w('","'), $2d6df7737cf21851$var$Hb = $2d6df7737cf21851$var$w('")\x3c/script>'), $2d6df7737cf21851$var$Ib = $2d6df7737cf21851$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $2d6df7737cf21851$var$Jb = $2d6df7737cf21851$var$w('$RC("'), $2d6df7737cf21851$var$Kb = $2d6df7737cf21851$var$w('","'), $2d6df7737cf21851$var$Lb = $2d6df7737cf21851$var$w('")\x3c/script>'), $2d6df7737cf21851$var$Mb = $2d6df7737cf21851$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $2d6df7737cf21851$var$Nb = $2d6df7737cf21851$var$w('$RX("'), $2d6df7737cf21851$var$Ob = $2d6df7737cf21851$var$w('"'), $2d6df7737cf21851$var$Pb = $2d6df7737cf21851$var$w(")\x3c/script>"), $2d6df7737cf21851$var$Qb = $2d6df7737cf21851$var$w(","), $2d6df7737cf21851$var$Rb = /[<\u2028\u2029]/g;
function $2d6df7737cf21851$var$Sb(a) {
    return JSON.stringify(a).replace($2d6df7737cf21851$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $2d6df7737cf21851$var$N = Object.assign, $2d6df7737cf21851$var$Tb = Symbol.for("react.element"), $2d6df7737cf21851$var$Ub = Symbol.for("react.portal"), $2d6df7737cf21851$var$Vb = Symbol.for("react.fragment"), $2d6df7737cf21851$var$Wb = Symbol.for("react.strict_mode"), $2d6df7737cf21851$var$Xb = Symbol.for("react.profiler"), $2d6df7737cf21851$var$Yb = Symbol.for("react.provider"), $2d6df7737cf21851$var$Zb = Symbol.for("react.context"), $2d6df7737cf21851$var$$b = Symbol.for("react.forward_ref"), $2d6df7737cf21851$var$ac = Symbol.for("react.suspense"), $2d6df7737cf21851$var$bc = Symbol.for("react.suspense_list"), $2d6df7737cf21851$var$cc = Symbol.for("react.memo"), $2d6df7737cf21851$var$dc = Symbol.for("react.lazy"), $2d6df7737cf21851$var$ec = Symbol.for("react.scope"), $2d6df7737cf21851$var$fc = Symbol.for("react.debug_trace_mode"), $2d6df7737cf21851$var$gc = Symbol.for("react.legacy_hidden"), $2d6df7737cf21851$var$hc = Symbol.for("react.default_value"), $2d6df7737cf21851$var$ic = Symbol.iterator;
function $2d6df7737cf21851$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2d6df7737cf21851$var$Vb:
            return "Fragment";
        case $2d6df7737cf21851$var$Ub:
            return "Portal";
        case $2d6df7737cf21851$var$Xb:
            return "Profiler";
        case $2d6df7737cf21851$var$Wb:
            return "StrictMode";
        case $2d6df7737cf21851$var$ac:
            return "Suspense";
        case $2d6df7737cf21851$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2d6df7737cf21851$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $2d6df7737cf21851$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $2d6df7737cf21851$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2d6df7737cf21851$var$cc:
            return b = a.displayName || null, null !== b ? b : $2d6df7737cf21851$var$jc(a.type) || "Memo";
        case $2d6df7737cf21851$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $2d6df7737cf21851$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $2d6df7737cf21851$var$kc = {};
function $2d6df7737cf21851$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $2d6df7737cf21851$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $2d6df7737cf21851$var$O = null;
function $2d6df7737cf21851$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($2d6df7737cf21851$var$k(401));
        } else {
            if (null === c) throw Error($2d6df7737cf21851$var$k(401));
            $2d6df7737cf21851$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $2d6df7737cf21851$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $2d6df7737cf21851$var$mc(a);
}
function $2d6df7737cf21851$var$nc(a) {
    var b = a.parent;
    null !== b && $2d6df7737cf21851$var$nc(b);
    a.context._currentValue = a.value;
}
function $2d6df7737cf21851$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($2d6df7737cf21851$var$k(402));
    a.depth === b.depth ? $2d6df7737cf21851$var$P(a, b) : $2d6df7737cf21851$var$oc(a, b);
}
function $2d6df7737cf21851$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($2d6df7737cf21851$var$k(402));
    a.depth === c.depth ? $2d6df7737cf21851$var$P(a, c) : $2d6df7737cf21851$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $2d6df7737cf21851$var$Q(a) {
    var b = $2d6df7737cf21851$var$O;
    b !== a && (null === b ? $2d6df7737cf21851$var$nc(a) : null === a ? $2d6df7737cf21851$var$mc(b) : b.depth === a.depth ? $2d6df7737cf21851$var$P(b, a) : b.depth > a.depth ? $2d6df7737cf21851$var$oc(b, a) : $2d6df7737cf21851$var$pc(b, a), $2d6df7737cf21851$var$O = a);
}
var $2d6df7737cf21851$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $2d6df7737cf21851$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $2d6df7737cf21851$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $2d6df7737cf21851$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $2d6df7737cf21851$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $2d6df7737cf21851$var$N({}, e, h)) : $2d6df7737cf21851$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $2d6df7737cf21851$var$sc = {
    id: 1,
    overflow: ""
};
function $2d6df7737cf21851$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $2d6df7737cf21851$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $2d6df7737cf21851$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $2d6df7737cf21851$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $2d6df7737cf21851$var$uc = Math.clz32 ? Math.clz32 : $2d6df7737cf21851$var$vc, $2d6df7737cf21851$var$wc = Math.log, $2d6df7737cf21851$var$xc = Math.LN2;
function $2d6df7737cf21851$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2d6df7737cf21851$var$wc(a) / $2d6df7737cf21851$var$xc | 0) | 0;
}
function $2d6df7737cf21851$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2d6df7737cf21851$var$zc = "function" === typeof Object.is ? Object.is : $2d6df7737cf21851$var$yc, $2d6df7737cf21851$var$R = null, $2d6df7737cf21851$var$Ac = null, $2d6df7737cf21851$var$Bc = null, $2d6df7737cf21851$var$S = null, $2d6df7737cf21851$var$T = !1, $2d6df7737cf21851$var$Cc = !1, $2d6df7737cf21851$var$U = 0, $2d6df7737cf21851$var$V = null, $2d6df7737cf21851$var$Dc = 0;
function $2d6df7737cf21851$var$W() {
    if (null === $2d6df7737cf21851$var$R) throw Error($2d6df7737cf21851$var$k(321));
    return $2d6df7737cf21851$var$R;
}
function $2d6df7737cf21851$var$Ec() {
    if (0 < $2d6df7737cf21851$var$Dc) throw Error($2d6df7737cf21851$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $2d6df7737cf21851$var$Fc() {
    null === $2d6df7737cf21851$var$S ? null === $2d6df7737cf21851$var$Bc ? ($2d6df7737cf21851$var$T = !1, $2d6df7737cf21851$var$Bc = $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Ec()) : ($2d6df7737cf21851$var$T = !0, $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Bc) : null === $2d6df7737cf21851$var$S.next ? ($2d6df7737cf21851$var$T = !1, $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$S.next = $2d6df7737cf21851$var$Ec()) : ($2d6df7737cf21851$var$T = !0, $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$S.next);
    return $2d6df7737cf21851$var$S;
}
function $2d6df7737cf21851$var$Gc() {
    $2d6df7737cf21851$var$Ac = $2d6df7737cf21851$var$R = null;
    $2d6df7737cf21851$var$Cc = !1;
    $2d6df7737cf21851$var$Bc = null;
    $2d6df7737cf21851$var$Dc = 0;
    $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$V = null;
}
function $2d6df7737cf21851$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2d6df7737cf21851$var$Ic(a, b, c) {
    $2d6df7737cf21851$var$R = $2d6df7737cf21851$var$W();
    $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Fc();
    if ($2d6df7737cf21851$var$T) {
        var d = $2d6df7737cf21851$var$S.queue;
        b = d.dispatch;
        if (null !== $2d6df7737cf21851$var$V && (c = $2d6df7737cf21851$var$V.get(d), void 0 !== c)) {
            $2d6df7737cf21851$var$V.delete(d);
            d = $2d6df7737cf21851$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $2d6df7737cf21851$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $2d6df7737cf21851$var$S.memoizedState,
            b
        ];
    }
    a = a === $2d6df7737cf21851$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $2d6df7737cf21851$var$S.memoizedState = a;
    a = $2d6df7737cf21851$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $2d6df7737cf21851$var$Jc.bind(null, $2d6df7737cf21851$var$R, a);
    return [
        $2d6df7737cf21851$var$S.memoizedState,
        a
    ];
}
function $2d6df7737cf21851$var$Kc(a, b) {
    $2d6df7737cf21851$var$R = $2d6df7737cf21851$var$W();
    $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $2d6df7737cf21851$var$S) {
        var c = $2d6df7737cf21851$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$2d6df7737cf21851$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $2d6df7737cf21851$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2d6df7737cf21851$var$Jc(a, b, c) {
    if (25 <= $2d6df7737cf21851$var$Dc) throw Error($2d6df7737cf21851$var$k(301));
    if (a === $2d6df7737cf21851$var$R) {
        if ($2d6df7737cf21851$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $2d6df7737cf21851$var$V && ($2d6df7737cf21851$var$V = new Map), c = $2d6df7737cf21851$var$V.get(b), void 0 === c) $2d6df7737cf21851$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $2d6df7737cf21851$var$Lc() {
    throw Error($2d6df7737cf21851$var$k(394));
}
function $2d6df7737cf21851$var$Mc() {}
var $2d6df7737cf21851$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $2d6df7737cf21851$var$W();
        return a._currentValue;
    },
    useMemo: $2d6df7737cf21851$var$Kc,
    useReducer: $2d6df7737cf21851$var$Ic,
    useRef: function(a) {
        $2d6df7737cf21851$var$R = $2d6df7737cf21851$var$W();
        $2d6df7737cf21851$var$S = $2d6df7737cf21851$var$Fc();
        var b = $2d6df7737cf21851$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $2d6df7737cf21851$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $2d6df7737cf21851$var$Ic($2d6df7737cf21851$var$Hc, a);
    },
    useInsertionEffect: $2d6df7737cf21851$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $2d6df7737cf21851$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $2d6df7737cf21851$var$Mc,
    useEffect: $2d6df7737cf21851$var$Mc,
    useDebugValue: $2d6df7737cf21851$var$Mc,
    useDeferredValue: function(a) {
        $2d6df7737cf21851$var$W();
        return a;
    },
    useTransition: function() {
        $2d6df7737cf21851$var$W();
        return [
            !1,
            $2d6df7737cf21851$var$Lc
        ];
    },
    useId: function() {
        var a = $2d6df7737cf21851$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $2d6df7737cf21851$var$uc(a) - 1)).toString(32) + b;
        var c = $2d6df7737cf21851$var$Nc;
        if (null === c) throw Error($2d6df7737cf21851$var$k(404));
        b = $2d6df7737cf21851$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $2d6df7737cf21851$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($2d6df7737cf21851$var$k(407));
        return c();
    }
}, $2d6df7737cf21851$var$Nc = null, $2d6df7737cf21851$var$Pc = $bxRTa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $2d6df7737cf21851$var$Qc(a) {
    console.error(a);
    return null;
}
function $2d6df7737cf21851$var$X() {}
function $2d6df7737cf21851$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $2d6df7737cf21851$var$Qc : f,
        onAllReady: void 0 === e ? $2d6df7737cf21851$var$X : e,
        onShellReady: void 0 === g ? $2d6df7737cf21851$var$X : g,
        onShellError: void 0 === h ? $2d6df7737cf21851$var$X : h,
        onFatalError: void 0 === m ? $2d6df7737cf21851$var$X : m
    };
    c = $2d6df7737cf21851$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $2d6df7737cf21851$var$Tc(b, a, null, c, r, $2d6df7737cf21851$var$kc, null, $2d6df7737cf21851$var$sc);
    q.push(a);
    return b;
}
function $2d6df7737cf21851$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $2d6df7737cf21851$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $2d6df7737cf21851$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $2d6df7737cf21851$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $2d6df7737cf21851$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $2d6df7737cf21851$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $2d6df7737cf21851$var$Wc(a, b, c, d, f) {
    $2d6df7737cf21851$var$R = {};
    $2d6df7737cf21851$var$Ac = b;
    $2d6df7737cf21851$var$U = 0;
    for(a = c(d, f); $2d6df7737cf21851$var$Cc;)$2d6df7737cf21851$var$Cc = !1, $2d6df7737cf21851$var$U = 0, $2d6df7737cf21851$var$Dc += 1, $2d6df7737cf21851$var$S = null, a = c(d, f);
    $2d6df7737cf21851$var$Gc();
    return a;
}
function $2d6df7737cf21851$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($2d6df7737cf21851$var$k(108, $2d6df7737cf21851$var$jc(d) || "Unknown", h));
            d = $2d6df7737cf21851$var$N({}, g, c);
        }
        b.legacyContext = d;
        $2d6df7737cf21851$var$Z(a, b, f);
        b.legacyContext = g;
    } else $2d6df7737cf21851$var$Z(a, b, f);
}
function $2d6df7737cf21851$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $2d6df7737cf21851$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $2d6df7737cf21851$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $2d6df7737cf21851$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $2d6df7737cf21851$var$rc(e, c, d, f);
            $2d6df7737cf21851$var$Xc(a, b, e, c);
        } else {
            e = $2d6df7737cf21851$var$lc(c, b.legacyContext);
            f = $2d6df7737cf21851$var$Wc(a, b, c, d, e);
            var g = 0 !== $2d6df7737cf21851$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $2d6df7737cf21851$var$rc(f, c, d, e), $2d6df7737cf21851$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $2d6df7737cf21851$var$tc(d, 1, 0);
                try {
                    $2d6df7737cf21851$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $2d6df7737cf21851$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $2d6df7737cf21851$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $2d6df7737cf21851$var$Ba(g, c, d);
        $2d6df7737cf21851$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($2d6df7737cf21851$var$Ta, $2d6df7737cf21851$var$u(c), $2d6df7737cf21851$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $2d6df7737cf21851$var$gc:
            case $2d6df7737cf21851$var$fc:
            case $2d6df7737cf21851$var$Wb:
            case $2d6df7737cf21851$var$Xb:
            case $2d6df7737cf21851$var$Vb:
                $2d6df7737cf21851$var$Z(a, b, d.children);
                return;
            case $2d6df7737cf21851$var$bc:
                $2d6df7737cf21851$var$Z(a, b, d.children);
                return;
            case $2d6df7737cf21851$var$ec:
                throw Error($2d6df7737cf21851$var$k(343));
            case $2d6df7737cf21851$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $2d6df7737cf21851$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $2d6df7737cf21851$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($2d6df7737cf21851$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($2d6df7737cf21851$var$Ca), q.status = 1, $2d6df7737cf21851$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $2d6df7737cf21851$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $2d6df7737cf21851$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $2d6df7737cf21851$var$$b:
                d = $2d6df7737cf21851$var$Wc(a, b, c.render, d, f);
                if (0 !== $2d6df7737cf21851$var$U) {
                    c = b.treeContext;
                    b.treeContext = $2d6df7737cf21851$var$tc(c, 1, 0);
                    try {
                        $2d6df7737cf21851$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $2d6df7737cf21851$var$Z(a, b, d);
                return;
            case $2d6df7737cf21851$var$cc:
                c = c.type;
                d = $2d6df7737cf21851$var$Yc(c, d);
                $2d6df7737cf21851$var$Zc(a, b, c, d, f);
                return;
            case $2d6df7737cf21851$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $2d6df7737cf21851$var$O;
                $2d6df7737cf21851$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $2d6df7737cf21851$var$Z(a, b, f);
                a = $2d6df7737cf21851$var$O;
                if (null === a) throw Error($2d6df7737cf21851$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $2d6df7737cf21851$var$hc ? a.context._defaultValue : d;
                a = $2d6df7737cf21851$var$O = a.parent;
                b.context = a;
                return;
            case $2d6df7737cf21851$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $2d6df7737cf21851$var$Z(a, b, d);
                return;
            case $2d6df7737cf21851$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $2d6df7737cf21851$var$Yc(c, d);
                $2d6df7737cf21851$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($2d6df7737cf21851$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $2d6df7737cf21851$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $2d6df7737cf21851$var$Tb:
                $2d6df7737cf21851$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $2d6df7737cf21851$var$Ub:
                throw Error($2d6df7737cf21851$var$k(257));
            case $2d6df7737cf21851$var$dc:
                var d = c._init;
                c = d(c._payload);
                $2d6df7737cf21851$var$Z(a, b, c);
                return;
        }
        if ($2d6df7737cf21851$var$ra(c)) {
            $2d6df7737cf21851$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $2d6df7737cf21851$var$ic && c[$2d6df7737cf21851$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $2d6df7737cf21851$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($2d6df7737cf21851$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $2d6df7737cf21851$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $2d6df7737cf21851$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $2d6df7737cf21851$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $2d6df7737cf21851$var$tc(e, d, f);
        try {
            $2d6df7737cf21851$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $2d6df7737cf21851$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $2d6df7737cf21851$var$Z(a, b, c);
    } catch (m) {
        if ($2d6df7737cf21851$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $2d6df7737cf21851$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $2d6df7737cf21851$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $2d6df7737cf21851$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $2d6df7737cf21851$var$Q(e), m;
    }
}
function $2d6df7737cf21851$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $2d6df7737cf21851$var$dd(this, b, a);
}
function $2d6df7737cf21851$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($2d6df7737cf21851$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $2d6df7737cf21851$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $2d6df7737cf21851$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $2d6df7737cf21851$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $2d6df7737cf21851$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($2d6df7737cf21851$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $2d6df7737cf21851$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $2d6df7737cf21851$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($2d6df7737cf21851$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($2d6df7737cf21851$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $2d6df7737cf21851$var$Uc(a) {
    if (2 !== a.status) {
        var b = $2d6df7737cf21851$var$O, c = $2d6df7737cf21851$var$Pc.current;
        $2d6df7737cf21851$var$Pc.current = $2d6df7737cf21851$var$Oc;
        var d = $2d6df7737cf21851$var$Nc;
        $2d6df7737cf21851$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $2d6df7737cf21851$var$Q(g.context);
                    try {
                        $2d6df7737cf21851$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($2d6df7737cf21851$var$Ca), g.abortSet.delete(g), m.status = 1, $2d6df7737cf21851$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($2d6df7737cf21851$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $2d6df7737cf21851$var$Y(h, v);
                            null === r ? $2d6df7737cf21851$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $2d6df7737cf21851$var$fd(a, a.destination);
        } catch (G) {
            $2d6df7737cf21851$var$Y(a, G), $2d6df7737cf21851$var$Vc(a, G);
        } finally{
            $2d6df7737cf21851$var$Nc = d, $2d6df7737cf21851$var$Pc.current = c, c === $2d6df7737cf21851$var$Oc && $2d6df7737cf21851$var$Q(b);
        }
    }
}
function $2d6df7737cf21851$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Va);
            $2d6df7737cf21851$var$p(b, a.placeholderPrefix);
            a = $2d6df7737cf21851$var$u(d.toString(16));
            $2d6df7737cf21851$var$p(b, a);
            return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$2d6df7737cf21851$var$p(b, d[e]);
                f = $2d6df7737cf21851$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$2d6df7737cf21851$var$p(b, d[e]);
            e < d.length && (f = $2d6df7737cf21851$var$t(b, d[e]));
            return f;
        default:
            throw Error($2d6df7737cf21851$var$k(390));
    }
}
function $2d6df7737cf21851$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $2d6df7737cf21851$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$$a), $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$bb), d && ($2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$db), $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$C(d))), $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$cb)), $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$eb), $2d6df7737cf21851$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $2d6df7737cf21851$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $2d6df7737cf21851$var$fb(b, a.responseState, d);
        $2d6df7737cf21851$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $2d6df7737cf21851$var$fb(b, a.responseState, d.id), $2d6df7737cf21851$var$gd(a, b, c);
    else {
        $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($2d6df7737cf21851$var$k(391));
        $2d6df7737cf21851$var$hd(a, b, c[0]);
    }
    return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$ab);
}
function $2d6df7737cf21851$var$id(a, b, c) {
    $2d6df7737cf21851$var$Bb(b, a.responseState, c.formatContext, c.id);
    $2d6df7737cf21851$var$hd(a, b, c);
    return $2d6df7737cf21851$var$Cb(b, c.formatContext);
}
function $2d6df7737cf21851$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$2d6df7737cf21851$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $2d6df7737cf21851$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Ib));
    if (null === d) throw Error($2d6df7737cf21851$var$k(395));
    c = $2d6df7737cf21851$var$u(c.toString(16));
    $2d6df7737cf21851$var$p(b, d);
    $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Kb);
    $2d6df7737cf21851$var$p(b, a.segmentPrefix);
    $2d6df7737cf21851$var$p(b, c);
    return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Lb);
}
function $2d6df7737cf21851$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($2d6df7737cf21851$var$k(392));
        return $2d6df7737cf21851$var$id(a, b, d);
    }
    $2d6df7737cf21851$var$id(a, b, d);
    a = a.responseState;
    $2d6df7737cf21851$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Eb) : (a.sentCompleteSegmentFunction = !0, $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Db));
    $2d6df7737cf21851$var$p(b, a.segmentPrefix);
    f = $2d6df7737cf21851$var$u(f.toString(16));
    $2d6df7737cf21851$var$p(b, f);
    $2d6df7737cf21851$var$p(b, $2d6df7737cf21851$var$Gb);
    $2d6df7737cf21851$var$p(b, a.placeholderPrefix);
    $2d6df7737cf21851$var$p(b, f);
    return $2d6df7737cf21851$var$t(b, $2d6df7737cf21851$var$Hb);
}
function $2d6df7737cf21851$var$fd(a, b) {
    $2d6df7737cf21851$var$l = new Uint8Array(512);
    $2d6df7737cf21851$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $2d6df7737cf21851$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$2d6df7737cf21851$var$p(b, d[c]);
            c < d.length && $2d6df7737cf21851$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $2d6df7737cf21851$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Nb) : (h.sentClientRenderFunction = !0, $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Mb));
            if (null === m) throw Error($2d6df7737cf21851$var$k(395));
            $2d6df7737cf21851$var$p(d, m);
            $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Ob);
            if (q || r || v) $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Qb), $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$Sb(q || "")));
            if (r || v) $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Qb), $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$Sb(r || "")));
            v && ($2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$Qb), $2d6df7737cf21851$var$p(d, $2d6df7737cf21851$var$u($2d6df7737cf21851$var$Sb(v))));
            if (!$2d6df7737cf21851$var$t(d, $2d6df7737cf21851$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$2d6df7737cf21851$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $2d6df7737cf21851$var$ba(b);
        $2d6df7737cf21851$var$l = new Uint8Array(512);
        $2d6df7737cf21851$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$2d6df7737cf21851$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$2d6df7737cf21851$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $2d6df7737cf21851$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $2d6df7737cf21851$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $2d6df7737cf21851$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $2d6df7737cf21851$var$fd(a, a.destination);
    } catch (d) {
        $2d6df7737cf21851$var$Y(a, d), $2d6df7737cf21851$var$Vc(a, d);
    }
}
$2d6df7737cf21851$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $2d6df7737cf21851$var$Rc(a, $2d6df7737cf21851$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $2d6df7737cf21851$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $2d6df7737cf21851$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $2d6df7737cf21851$var$fd(h, a);
                        } catch (A) {
                            $2d6df7737cf21851$var$Y(h, A), $2d6df7737cf21851$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $2d6df7737cf21851$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $2d6df7737cf21851$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $2d6df7737cf21851$var$Uc(h);
    });
};
$2d6df7737cf21851$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("7vU9M", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $03NNS = parcelRequire("03NNS");
function $5786fd365fe07671$var$emptyFunction() {}
function $5786fd365fe07671$var$emptyFunctionWithReset() {}
$5786fd365fe07671$var$emptyFunctionWithReset.resetWarningCache = $5786fd365fe07671$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $03NNS) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $5786fd365fe07671$var$emptyFunctionWithReset,
        resetWarningCache: $5786fd365fe07671$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("03NNS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $00b6e9dcd1ec46b4$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $00b6e9dcd1ec46b4$var$ReactPropTypesSecret;

});


parcelRegister("2jBaP", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("eyNRs", function(module, exports) {

$parcel$export(module.exports, "rotatingPhoneFromVerticalToHorizontalPosition", () => $7d5b83b0df58ea28$export$ad7b40b81d5409c);
$parcel$export(module.exports, "markerShadow", () => $7d5b83b0df58ea28$export$1524746c49eeef2b);
const $7d5b83b0df58ea28$export$ad7b40b81d5409c = 'data:image/png;base64,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';
const $7d5b83b0df58ea28$export$1524746c49eeef2b = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC';

});

parcelRegister("hd0ee", function(module, exports) {

var $f2Nvv = parcelRequire("f2Nvv");
var $c873d3ee29cd35e1$require$Buffer = $f2Nvv.Buffer;

var $aOKBQ = parcelRequire("aOKBQ");










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = false;
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xEF") {
                        let encoding;
                        if (str[0] === "\xFE" && str[1] === "\xFF") encoding = "utf-16be";
                        else if (str[0] === "\xFF" && str[1] === "\xFE") encoding = "utf-16le";
                        else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task = new PDFDocumentLoadingTask();
                    const { docId } = task;
                    const url = src.url ? getUrlProp(src.url) : null;
                    const data = src.data ? getDataProp(src.data) : null;
                    const httpHeaders = src.httpHeaders || null;
                    const withCredentials = src.withCredentials === true;
                    const password = src.password ?? null;
                    const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker = src.worker instanceof PDFWorker ? src.worker : null;
                    const verbosity = src.verbosity;
                    const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    const cMapPacked = src.cMapPacked !== false;
                    const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors = src.stopAtErrors !== true;
                    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    const isEvalSupported = src.isEvalSupported !== false;
                    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties = src.fontExtraProperties === true;
                    const enableXfa = src.enableXfa === true;
                    const ownerDocument = src.ownerDocument || globalThis.document;
                    const disableRange = src.disableRange === true;
                    const disableStream = src.disableStream === true;
                    const disableAutoFetch = src.disableAutoFetch === true;
                    const pdfBug = src.pdfBug === true;
                    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
                    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    const filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    const styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    const transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        const workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    const fetchDocParams = {
                        docId: docId,
                        apiVersion: '3.11.174',
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    const transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        const networkStreamPromise = new Promise(function(resolve) {
                            let networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                const createPDFNetworkStream = (params)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function([workerId, networkStream]) {
                            if (task.destroyed) throw new Error("Loading aborted");
                            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                async function _fetchDocument(worker, source) {
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    const workerId = await worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                        source.data.buffer
                    ] : null);
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    return workerId;
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch  {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $c873d3ee29cd35e1$require$Buffer !== "undefined" && val instanceof $c873d3ee29cd35e1$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    static #docId = 0;
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    async destroy() {
                        this.destroyed = true;
                        try {
                            if (this._worker?.port) this._worker._pendingDestroy = true;
                            await this._transport?.destroy();
                        } catch (ex) {
                            if (this._worker?.port) delete this._worker._pendingDestroy;
                            throw ex;
                        }
                        this._transport = null;
                        if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                        }
                    }
                }
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    addRangeListener(listener) {
                        this._rangeListeners.push(listener);
                    }
                    addProgressListener(listener) {
                        this._progressListeners.push(listener);
                    }
                    addProgressiveReadListener(listener) {
                        this._progressiveReadListeners.push(listener);
                    }
                    addProgressiveDoneListener(listener) {
                        this._progressiveDoneListeners.push(listener);
                    }
                    onDataRange(begin, chunk) {
                        for (const listener of this._rangeListeners)listener(begin, chunk);
                    }
                    onDataProgress(loaded, total) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressListeners)listener(loaded, total);
                        });
                    }
                    onDataProgressiveRead(chunk) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveReadListeners)listener(chunk);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveDoneListeners)listener();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin, end) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo, transport){
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js)=>{
                                    if (!js) return js;
                                    const jsArr = [];
                                    for(const name in js)jsArr.push(...js[name]);
                                    return jsArr;
                                });
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber) {
                        return this._transport.getPage(pageNumber);
                    }
                    getPageIndex(ref) {
                        return this._transport.getPageIndex(ref);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id) {
                        return this._transport.getDestination(id);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts = false) {
                        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    #delayedCleanupTimeout = null;
                    #pendingCleanup = false;
                    constructor(pageIndex, pageInfo, transport, pdfBug = false){
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale, rotation = this.rotate, offsetX = 0, offsetY = 0, dontFlip = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    getAnnotations({ intent = "display" } = {}) {
                        const intentArgs = this._transport.getRenderingIntent(intent);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext, viewport, intent = "display", annotationMode = _util.AnnotationMode.ENABLE, transform = null, background = null, optionalContentConfigPromise = null, annotationCanvasMap = null, pageColors = null, printAnnotationStorage = null }) {
                        this._stats?.time("Overall");
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState.displayReadyCapability) {
                            intentState.displayReadyCapability = new _util.PromiseCapability();
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        const complete = (error)=>{
                            intentState.renderTasks.delete(internalRenderTask);
                            if (this._maybeCleanupAfterRender || intentPrint) this.#pendingCleanup = true;
                            this.#tryCleanup(!intentPrint);
                            if (error) {
                                internalRenderTask.capability.reject(error);
                                this._abortOperatorList({
                                    intentState: intentState,
                                    reason: error instanceof Error ? error : new Error(error)
                                });
                            } else internalRenderTask.capability.resolve();
                            this._stats?.timeEnd("Rendering");
                            this._stats?.timeEnd("Overall");
                        };
                        const internalRenderTask = new InternalRenderTask({
                            callback: complete,
                            params: {
                                canvasContext: canvasContext,
                                viewport: viewport,
                                transform: transform,
                                background: background
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap,
                            operatorList: intentState.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors
                        });
                        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
                        const renderTask = internalRenderTask.task;
                        Promise.all([
                            intentState.displayReadyCapability.promise,
                            optionalContentConfigPromise
                        ]).then(([transparency, optionalContentConfig])=>{
                            if (this.destroyed) {
                                complete();
                                return;
                            }
                            this._stats?.time("Rendering");
                            internalRenderTask.initializeGraphics({
                                transparency: transparency,
                                optionalContentConfig: optionalContentConfig
                            });
                            internalRenderTask.operatorListChanged();
                        }).catch(complete);
                        return renderTask;
                    }
                    getOperatorList({ intent = "display", annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null } = {}) {
                        function operatorListChanged() {
                            if (intentState.operatorList.lastChunk) {
                                intentState.opListReadCapability.resolve(intentState.operatorList);
                                intentState.renderTasks.delete(opListTask);
                            }
                        }
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        let opListTask;
                        if (!intentState.opListReadCapability) {
                            opListTask = Object.create(null);
                            opListTask.operatorListChanged = operatorListChanged;
                            intentState.opListReadCapability = new _util.PromiseCapability();
                            (intentState.renderTasks ||= new Set()).add(opListTask);
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        return intentState.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent = false, disableNormalization = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent === true,
                            disableNormalization: disableNormalization === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                            size (textContent) {
                                return textContent.items.length;
                            }
                        });
                    }
                    getTextContent(params = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>{
                            return _xfa_text.XfaText.textContent(xfa);
                        });
                        const readableStream = this.streamTextContent(params);
                        return new Promise(function(resolve, reject) {
                            function pump() {
                                reader.read().then(function({ value, done }) {
                                    if (done) {
                                        resolve(textContent);
                                        return;
                                    }
                                    Object.assign(textContent.styles, value.styles);
                                    textContent.items.push(...value.items);
                                    pump();
                                }, reject);
                            }
                            const reader = readableStream.getReader();
                            const textContent = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn = [];
                        for (const intentState of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState.opListReadCapability) continue;
                            for (const internalRenderTask of intentState.renderTasks){
                                waitOn.push(internalRenderTask.completed);
                                internalRenderTask.cancel();
                            }
                        }
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        return Promise.all(waitOn);
                    }
                    cleanup(resetStats = false) {
                        this.#pendingCleanup = true;
                        const success = this.#tryCleanup(false);
                        if (resetStats && success) this._stats &&= new _display_utils.StatTimer();
                        return success;
                    }
                    #tryCleanup(delayed = false) {
                        this.#abortDelayedCleanup();
                        if (!this.#pendingCleanup || this.destroyed) return false;
                        if (delayed) {
                            this.#delayedCleanupTimeout = setTimeout(()=>{
                                this.#delayedCleanupTimeout = null;
                                this.#tryCleanup(false);
                            }, DELAYED_CLEANUP_TIMEOUT);
                            return false;
                        }
                        for (const { renderTasks, operatorList } of this._intentStates.values()){
                            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        return true;
                    }
                    #abortDelayedCleanup() {
                        if (this.#delayedCleanupTimeout) {
                            clearTimeout(this.#delayedCleanupTimeout);
                            this.#delayedCleanupTimeout = null;
                        }
                    }
                    _startRenderPage(transparency, cacheKey) {
                        const intentState = this._intentStates.get(cacheKey);
                        if (!intentState) return;
                        this._stats?.timeEnd("Page Request");
                        intentState.displayReadyCapability?.resolve(transparency);
                    }
                    _renderPageChunk(operatorListChunk, intentState) {
                        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
                            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                        }
                        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                        if (operatorListChunk.lastChunk) this.#tryCleanup(true);
                    }
                    _pumpOperatorList({ renderingIntent, cacheKey, annotationStorageSerializable }) {
                        const { map, transfers } = annotationStorageSerializable;
                        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent,
                            cacheKey: cacheKey,
                            annotationStorage: map
                        }, transfers);
                        const reader = readableStream.getReader();
                        const intentState = this._intentStates.get(cacheKey);
                        intentState.streamReader = reader;
                        const pump = ()=>{
                            reader.read().then(({ value, done })=>{
                                if (done) {
                                    intentState.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value, intentState);
                                pump();
                            }, (reason)=>{
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState.operatorList) {
                                    intentState.operatorList.lastChunk = true;
                                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                                    this.#tryCleanup(true);
                                }
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                else throw reason;
                            });
                        };
                        pump();
                    }
                    _abortOperatorList({ intentState, reason, force = false }) {
                        if (!intentState.streamReader) return;
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        if (!force) {
                            if (intentState.renderTasks.size > 0) return;
                            if (reason instanceof _display_utils.RenderingCancelledException) {
                                let delay = RENDERING_CANCELLED_TIMEOUT;
                                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState,
                                        reason: reason,
                                        force: true
                                    });
                                }, delay);
                                return;
                            }
                        }
                        intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(()=>{});
                        intentState.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
                            this._intentStates.delete(curCacheKey);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    #listeners = new Set();
                    #deferred = Promise.resolve();
                    postMessage(obj, transfer) {
                        const event = {
                            data: structuredClone(obj, transfer ? {
                                transfer: transfer
                            } : null)
                        };
                        this.#deferred.then(()=>{
                            for (const listener of this.#listeners)listener.call(this, event);
                        });
                    }
                    addEventListener(name, listener) {
                        this.#listeners.add(listener);
                    }
                    removeEventListener(name, listener) {
                        this.#listeners.delete(listener);
                    }
                    terminate() {
                        this.#listeners.clear();
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    const pdfjsFilePath = document?.currentScript?.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch  {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    const wrapper = `importScripts("${url}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                class PDFWorker {
                    static #workerPorts;
                    constructor({ name = null, port = null, verbosity = (0, _util.getVerbosityLevel)() } = {}){
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            if (PDFWorker.#workerPorts?.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port) {
                        this._port = port;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                const worker = new Worker(workerSrc);
                                const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                const terminateEarly = ()=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    messageHandler.destroy();
                                    worker.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError = ()=>{
                                    if (!this._webWorker) terminateEarly();
                                };
                                worker.addEventListener("error", onWorkerError);
                                messageHandler.on("test", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    if (data) {
                                        this._messageHandler = messageHandler;
                                        this._port = worker;
                                        this._webWorker = worker;
                                        this._readyCapability.resolve();
                                        messageHandler.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler.destroy();
                                        worker.terminate();
                                    }
                                });
                                messageHandler.on("ready", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    try {
                                        sendTest();
                                    } catch  {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest = ()=>{
                                    const testObj = new Uint8Array();
                                    messageHandler.send("test", testObj, [
                                        testObj.buffer
                                    ]);
                                };
                                sendTest();
                                return;
                            } catch  {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port = new LoopbackPort();
                            this._port = port;
                            const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                            WorkerMessageHandler.setup(workerHandler, port);
                            const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                            this._messageHandler = messageHandler;
                            this._readyCapability.resolve();
                            messageHandler.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                        });
                    }
                    destroy() {
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        PDFWorker.#workerPorts?.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params) {
                        if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort = this.#workerPorts?.get(params.port);
                        if (cachedPort) {
                            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort;
                        }
                        return new PDFWorker(params);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                        } catch  {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = async ()=>{
                            const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_util.isNodeJS && true) {
                                const worker = eval("require")(this.workerSrc);
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(this.workerSrc);
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                }
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    #methodPromises = new Map();
                    #pageCache = new Map();
                    #pagePromises = new Map();
                    #passwordCapability = null;
                    constructor(messageHandler, loadingTask, networkStream, params, factory){
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    #cacheSimpleMethod(name, data = null) {
                        const cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, data);
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                        let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                        switch(intent){
                            case "any":
                                renderingIntent = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                        }
                        switch(annotationMode){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                annotationStorageSerializable = annotationStorage.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                        }
                        if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent,
                            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable
                        };
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn = [];
                        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
                        this.#pageCache.clear();
                        this.#pagePromises.clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn.push(terminated);
                        Promise.all(waitOn).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this.#methodPromises.clear();
                            this.filterFactory.destroy();
                            this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler, loadingTask } = this;
                        messageHandler.on("GetReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt)=>{
                                this._lastProgress = {
                                    loaded: evt.loaded,
                                    total: evt.total
                                };
                            };
                            sink.onPull = ()=>{
                                this._fullReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                this._fullReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("ReaderHeadersReady", (data)=>{
                            const headersCapability = new _util.PromiseCapability();
                            const fullReader = this._fullReader;
                            fullReader.headersReady.then(()=>{
                                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                    if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                                    fullReader.onProgress = (evt)=>{
                                        loadingTask.onProgress?.({
                                            loaded: evt.loaded,
                                            total: evt.total
                                        });
                                    };
                                }
                                headersCapability.resolve({
                                    isStreamingSupported: fullReader.isStreamingSupported,
                                    isRangeSupported: fullReader.isRangeSupported,
                                    contentLength: fullReader.contentLength
                                });
                            }, headersCapability.reject);
                            return headersCapability.promise;
                        });
                        messageHandler.on("GetRangeReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
                            if (!rangeReader) {
                                sink.close();
                                return;
                            }
                            sink.onPull = ()=>{
                                rangeReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                rangeReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("GetDoc", ({ pdfInfo })=>{
                            this._numPages = pdfInfo.numPages;
                            this._htmlForXfa = pdfInfo.htmlForXfa;
                            delete pdfInfo.htmlForXfa;
                            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                        });
                        messageHandler.on("DocException", function(ex) {
                            let reason;
                            switch(ex.name){
                                case "PasswordException":
                                    reason = new _util.PasswordException(ex.message, ex.code);
                                    break;
                                case "InvalidPDFException":
                                    reason = new _util.InvalidPDFException(ex.message);
                                    break;
                                case "MissingPDFException":
                                    reason = new _util.MissingPDFException(ex.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                    break;
                                case "UnknownErrorException":
                                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask._capability.reject(reason);
                        });
                        messageHandler.on("PasswordRequest", (exception)=>{
                            this.#passwordCapability = new _util.PromiseCapability();
                            if (loadingTask.onPassword) {
                                const updatePassword = (password)=>{
                                    if (password instanceof Error) this.#passwordCapability.reject(password);
                                    else this.#passwordCapability.resolve({
                                        password: password
                                    });
                                };
                                try {
                                    loadingTask.onPassword(updatePassword, exception.code);
                                } catch (ex) {
                                    this.#passwordCapability.reject(ex);
                                }
                            } else this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                            return this.#passwordCapability.promise;
                        });
                        messageHandler.on("DataLoaded", (data)=>{
                            loadingTask.onProgress?.({
                                loaded: data.length,
                                total: data.length
                            });
                            this.downloadInfoCapability.resolve(data);
                        });
                        messageHandler.on("StartRenderPage", (data)=>{
                            if (this.destroyed) return;
                            const page = this.#pageCache.get(data.pageIndex);
                            page._startRenderPage(data.transparency, data.cacheKey);
                        });
                        messageHandler.on("commonobj", ([id, type, exportedData])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id)) return;
                            switch(type){
                                case "Font":
                                    const params = this._params;
                                    if ("error" in exportedData) {
                                        const exportedError = exportedData.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                                        this.commonObjs.resolve(id, exportedError);
                                        break;
                                    }
                                    const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                                    const font = new _font_loader.FontFaceObject(exportedData, {
                                        isEvalSupported: params.isEvalSupported,
                                        disableFontFace: params.disableFontFace,
                                        ignoreErrors: params.ignoreErrors,
                                        inspectFont: inspectFont
                                    });
                                    this.fontLoader.bind(font).catch((reason)=>{
                                        return messageHandler.sendWithPromise("FontFallback", {
                                            id: id
                                        });
                                    }).finally(()=>{
                                        if (!params.fontExtraProperties && font.data) font.data = null;
                                        this.commonObjs.resolve(id, font);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id, exportedData);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type}`);
                            }
                        });
                        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
                            if (this.destroyed) return;
                            const pageProxy = this.#pageCache.get(pageIndex);
                            if (pageProxy.objs.has(id)) return;
                            switch(type){
                                case "Image":
                                    pageProxy.objs.resolve(id, imageData);
                                    if (imageData) {
                                        let length;
                                        if (imageData.bitmap) {
                                            const { width, height } = imageData;
                                            length = width * height * 4;
                                        } else length = imageData.data?.length || 0;
                                        if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy.objs.resolve(id, imageData);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type}`);
                            }
                        });
                        messageHandler.on("DocProgress", (data)=>{
                            if (this.destroyed) return;
                            loadingTask.onProgress?.({
                                loaded: data.loaded,
                                total: data.total
                            });
                        });
                        messageHandler.on("FetchBuiltInCMap", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data);
                        });
                        messageHandler.on("FetchStandardFontData", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map, transfers } = this.annotationStorage.serializable;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map,
                            filename: this._fullReader?.filename ?? null
                        }, transfers).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber) {
                        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex
                        }).then((pageInfo)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                            this.#pageCache.set(pageIndex, page);
                            return page;
                        });
                        this.#pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    getPageIndex(ref) {
                        if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref.num,
                            gen: ref.gen
                        });
                    }
                    getAnnotations(pageIndex, intent) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex,
                            intent: intent
                        });
                    }
                    getFieldObjects() {
                        return this.#cacheSimpleMethod("GetFieldObjects");
                    }
                    hasJSActions() {
                        return this.#cacheSimpleMethod("HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id) {
                        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return this.#cacheSimpleMethod("GetDocJSActions");
                    }
                    getPageJSActions(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex
                        });
                    }
                    getStructTree(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results)=>{
                            return new _optional_content_config.OptionalContentConfig(results);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>{
                            return {
                                info: results[0],
                                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    async startCleanup(keepLoadedFonts = false) {
                        if (this.destroyed) return;
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        for (const page of this.#pageCache.values()){
                            const cleanupSuccessful = page.cleanup();
                            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts) this.fontLoader.clear();
                        this.#methodPromises.clear();
                        this.filterFactory.destroy(true);
                    }
                    get loadingParams() {
                        const { disableAutoFetch, enableXfa } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch,
                            enableXfa: enableXfa
                        });
                    }
                }
                class PDFObjects {
                    #objs = Object.create(null);
                    #ensureObj(objId) {
                        return this.#objs[objId] ||= {
                            capability: new _util.PromiseCapability(),
                            data: null
                        };
                    }
                    get(objId, callback = null) {
                        if (callback) {
                            const obj = this.#ensureObj(objId);
                            obj.capability.promise.then(()=>callback(obj.data));
                            return null;
                        }
                        const obj = this.#objs[objId];
                        if (!obj?.capability.settled) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                        return obj.data;
                    }
                    has(objId) {
                        const obj = this.#objs[objId];
                        return obj?.capability.settled || false;
                    }
                    resolve(objId, data = null) {
                        const obj = this.#ensureObj(objId);
                        obj.data = data;
                        obj.capability.resolve();
                    }
                    clear() {
                        for(const objId in this.#objs){
                            const { data } = this.#objs[objId];
                            data?.bitmap?.close();
                        }
                        this.#objs = Object.create(null);
                    }
                }
                class RenderTask {
                    #internalRenderTask = null;
                    constructor(internalRenderTask){
                        this.#internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this.#internalRenderTask.capability.promise;
                    }
                    cancel(extraDelay = 0) {
                        this.#internalRenderTask.cancel(null, extraDelay);
                    }
                    get separateAnnots() {
                        const { separateAnnots } = this.#internalRenderTask.operatorList;
                        if (!separateAnnots) return false;
                        const { annotationCanvasMap } = this.#internalRenderTask;
                        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    static #canvasInUse = new WeakSet();
                    constructor({ callback, params, objs, commonObjs, annotationCanvasMap, operatorList, pageIndex, canvasFactory, filterFactory, useRequestAnimationFrame = false, pdfBug = false, pageColors = null }){
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency = false, optionalContentConfig }) {
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if (InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            InternalRenderTask.#canvasInUse.add(this._canvas);
                        }
                        if (this._pdfBug && globalThis.StepperManager?.enabled) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext, viewport, transform, background } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform,
                            viewport: viewport,
                            transparency: transparency,
                            background: background
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        this.graphicsReadyCallback?.();
                    }
                    cancel(error = null, extraDelay = 0) {
                        this.running = false;
                        this.cancelled = true;
                        this.gfx?.endDrawing();
                        InternalRenderTask.#canvasInUse.delete(this._canvas);
                        this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                    }
                    operatorListChanged() {
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback ||= this._continueBound;
                            return;
                        }
                        this.stepper?.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    async _next() {
                        if (this.cancelled) return;
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                                this.gfx.endDrawing();
                                InternalRenderTask.#canvasInUse.delete(this._canvas);
                                this.callback();
                            }
                        }
                    }
                }
                const version = '3.11.174';
                exports.version = version;
                const build = 'ce8716743';
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                const SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                class AnnotationStorage {
                    #modified = false;
                    #storage = new Map();
                    constructor(){
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    getValue(key, defaultValue) {
                        const value = this.#storage.get(key);
                        if (value === undefined) return defaultValue;
                        return Object.assign(defaultValue, value);
                    }
                    getRawValue(key) {
                        return this.#storage.get(key);
                    }
                    remove(key) {
                        this.#storage.delete(key);
                        if (this.#storage.size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value of this.#storage.values()){
                                if (value instanceof _editor.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key, value) {
                        const obj = this.#storage.get(key);
                        let modified = false;
                        if (obj !== undefined) {
                            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                                modified = true;
                                obj[entry] = val;
                            }
                        } else {
                            modified = true;
                            this.#storage.set(key, value);
                        }
                        if (modified) this.#setModified();
                        if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                    }
                    has(key) {
                        return this.#storage.has(key);
                    }
                    getAll() {
                        return this.#storage.size > 0 ? (0, _util.objectFromMap)(this.#storage) : null;
                    }
                    setAll(obj) {
                        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
                    }
                    get size() {
                        return this.#storage.size;
                    }
                    #setModified() {
                        if (!this.#modified) {
                            this.#modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this.#modified) {
                            this.#modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage(this);
                    }
                    get serializable() {
                        if (this.#storage.size === 0) return SerializableEmpty;
                        const map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                        const context = Object.create(null);
                        let hasBitmap = false;
                        for (const [key, val] of this.#storage){
                            const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                            if (serialized) {
                                map.set(key, serialized);
                                hash.update(`${key}:${JSON.stringify(serialized)}`);
                                hasBitmap ||= !!serialized.bitmap;
                            }
                        }
                        if (hasBitmap) {
                            for (const value of map.values())if (value.bitmap) transfers.push(value.bitmap);
                        }
                        return map.size > 0 ? {
                            map: map,
                            hash: hash.hexdigest(),
                            transfers: transfers
                        } : SerializableEmpty;
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                class PrintAnnotationStorage extends AnnotationStorage {
                    #serializable;
                    constructor(parent){
                        super();
                        const { map, hash, transfers } = parent.serializable;
                        const clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        this.#serializable = {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        };
                    }
                    get print() {
                        (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return this.#serializable;
                    }
                }
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class AnnotationEditor {
                    #altText = "";
                    #altTextDecorative = false;
                    #altTextButton = null;
                    #altTextTooltip = null;
                    #altTextTooltipTimeout = null;
                    #keepAspectRatio = false;
                    #resizersDiv = null;
                    #boundFocusin = this.focusin.bind(this);
                    #boundFocusout = this.focusout.bind(this);
                    #hasBeenClicked = false;
                    #isEditing = false;
                    #isInEditMode = false;
                    _initialOptions = Object.create(null);
                    _uiManager = null;
                    _focusEventsAllowed = true;
                    _l10nPromise = null;
                    #isDraggable = false;
                    #zIndex = AnnotationEditor._zIndex++;
                    static _borderLineWidth = -1;
                    static _colorManager = new _tools.ColorManager();
                    static _zIndex = 1;
                    static SMALL_EDITOR_SIZE = 0;
                    constructor(parameters){
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        const [width, height] = this.parentDimensions;
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor) {
                        const fakeEditor = new FakeEditor({
                            id: editor.parent.getNextId(),
                            parent: editor.parent,
                            uiManager: editor._uiManager
                        });
                        fakeEditor.annotationElementId = editor.annotationElementId;
                        fakeEditor.deleted = true;
                        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                    }
                    static initialize(l10n, options = null) {
                        AnnotationEditor._l10nPromise ||= new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str)=>[
                                str,
                                l10n.get(str)
                            ]));
                        if (options?.strings) for (const str of options.strings)AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                        if (AnnotationEditor._borderLineWidth !== -1) return;
                        const style = getComputedStyle(document.documentElement);
                        AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type, _value) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime) {
                        return false;
                    }
                    static paste(item, parent) {
                        (0, _util.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return this.#isDraggable;
                    }
                    set _isDraggable(value) {
                        this.#isDraggable = value;
                        this.div?.classList.toggle("draggable", value);
                    }
                    center() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight / (pageWidth * 2);
                                this.y += this.width * pageWidth / (pageHeight * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight / (pageWidth * 2);
                                this.y -= this.width * pageWidth / (pageHeight * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params) {
                        this._uiManager.addCommands(params);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = this.#zIndex;
                    }
                    setParent(parent) {
                        if (parent !== null) {
                            this.pageIndex = parent.pageIndex;
                            this.pageDimensions = parent.pageDimensions;
                        }
                        this.parent = parent;
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.#hasBeenClicked) this.parent.setSelected(this);
                        else this.#hasBeenClicked = false;
                    }
                    focusout(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target = event.relatedTarget;
                        if (target?.closest(`#${this.id}`)) return;
                        event.preventDefault();
                        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x, y, tx, ty) {
                        const [width, height] = this.parentDimensions;
                        [tx, ty] = this.screenToPageTranslation(tx, ty);
                        this.x = (x + tx) / width;
                        this.y = (y + ty) / height;
                        this.fixAndSetPosition();
                    }
                    #translate([width, height], x, y) {
                        [x, y] = this.screenToPageTranslation(x, y);
                        this.x += x / width;
                        this.y += y / height;
                        this.fixAndSetPosition();
                    }
                    translate(x, y) {
                        this.#translate(this.parentDimensions, x, y);
                    }
                    translateInPage(x, y) {
                        this.#translate(this.pageDimensions, x, y);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx, ty) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.x += tx / parentWidth;
                        this.y += ty / parentHeight;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x, y } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x, y)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x, y } = this;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        this.div.style.left = `${(100 * x).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    #getBaseTranslation() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const { _borderLineWidth } = AnnotationEditor;
                        const x = _borderLineWidth / parentWidth;
                        const y = _borderLineWidth / parentHeight;
                        switch(this.rotation){
                            case 90:
                                return [
                                    -x,
                                    y
                                ];
                            case 180:
                                return [
                                    x,
                                    y
                                ];
                            case 270:
                                return [
                                    x,
                                    -y
                                ];
                            default:
                                return [
                                    -x,
                                    -y
                                ];
                        }
                    }
                    fixAndSetPosition() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        let { x, y, width, height } = this;
                        width *= pageWidth;
                        height *= pageHeight;
                        x *= pageWidth;
                        y *= pageHeight;
                        switch(this.rotation){
                            case 0:
                                x = Math.max(0, Math.min(pageWidth - width, x));
                                y = Math.max(0, Math.min(pageHeight - height, y));
                                break;
                            case 90:
                                x = Math.max(0, Math.min(pageWidth - height, x));
                                y = Math.min(pageHeight, Math.max(width, y));
                                break;
                            case 180:
                                x = Math.min(pageWidth, Math.max(width, x));
                                y = Math.min(pageHeight, Math.max(height, y));
                                break;
                            case 270:
                                x = Math.min(pageWidth, Math.max(height, x));
                                y = Math.max(0, Math.min(pageHeight - width, y));
                                break;
                        }
                        this.x = x /= pageWidth;
                        this.y = y /= pageHeight;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        const { style } = this.div;
                        style.left = `${(100 * x).toFixed(2)}%`;
                        style.top = `${(100 * y).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    static #rotatePoint(x, y, angle) {
                        switch(angle){
                            case 90:
                                return [
                                    y,
                                    -x
                                ];
                            case 180:
                                return [
                                    -x,
                                    -y
                                ];
                            case 270:
                                return [
                                    -y,
                                    x
                                ];
                            default:
                                return [
                                    x,
                                    y
                                ];
                        }
                    }
                    screenToPageTranslation(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
                    }
                    pageTranslationToScreen(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
                    }
                    #getRotationMatrix(rotation) {
                        switch(rotation){
                            case 90:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        -pageWidth / pageHeight,
                                        pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            case 180:
                                return [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                            case 270:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        pageWidth / pageHeight,
                                        -pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            default:
                                return [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                        }
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
                        const scaledWidth = pageWidth * parentScale;
                        const scaledHeight = pageHeight * parentScale;
                        return _util.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth),
                            Math.round(scaledHeight)
                        ] : [
                            scaledWidth,
                            scaledHeight
                        ];
                    }
                    setDims(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                        this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style } = this.div;
                        const { height, width } = style;
                        const widthPercent = width.endsWith("%");
                        const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
                        if (widthPercent && heightPercent) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    #createResizers() {
                        if (this.#resizersDiv) return;
                        this.#resizersDiv = document.createElement("div");
                        this.#resizersDiv.classList.add("resizers");
                        const classes = [
                            "topLeft",
                            "topRight",
                            "bottomRight",
                            "bottomLeft"
                        ];
                        if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                        for (const name of classes){
                            const div = document.createElement("div");
                            this.#resizersDiv.append(div);
                            div.classList.add("resizer", name);
                            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
                            div.addEventListener("contextmenu", _display_utils.noContextMenu);
                        }
                        this.div.prepend(this.#resizersDiv);
                    }
                    #resizerPointerdown(name, event) {
                        event.preventDefault();
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
                        const savedDraggable = this._isDraggable;
                        this._isDraggable = false;
                        const pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const savedParentCursor = this.parent.div.style.cursor;
                        const savedCursor = this.div.style.cursor;
                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                        const pointerUpCallback = ()=>{
                            this._isDraggable = savedDraggable;
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                            this.parent.div.style.cursor = savedParentCursor;
                            this.div.style.cursor = savedCursor;
                            const newX = this.x;
                            const newY = this.y;
                            const newWidth = this.width;
                            const newHeight = this.height;
                            if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                            this.addCommands({
                                cmd: ()=>{
                                    this.width = newWidth;
                                    this.height = newHeight;
                                    this.x = newX;
                                    this.y = newY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                    this.fixAndSetPosition();
                                },
                                undo: ()=>{
                                    this.width = savedWidth;
                                    this.height = savedHeight;
                                    this.x = savedX;
                                    this.y = savedY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                    this.fixAndSetPosition();
                                },
                                mustExec: true
                            });
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    #resizerPointermove(name, event) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                        const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                        const round = (x)=>Math.round(x * 10000) / 10000;
                        const rotationMatrix = this.#getRotationMatrix(this.rotation);
                        const transf = (x, y)=>[
                                rotationMatrix[0] * x + rotationMatrix[2] * y,
                                rotationMatrix[1] * x + rotationMatrix[3] * y
                            ];
                        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
                        const invTransf = (x, y)=>[
                                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                                invRotationMatrix[1] * x + invRotationMatrix[3] * y
                            ];
                        let getPoint;
                        let getOpposite;
                        let isDiagonal = false;
                        let isHorizontal = false;
                        switch(name){
                            case "topLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h
                                    ];
                                break;
                            case "topMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                break;
                            case "topRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h
                                    ];
                                break;
                            case "middleRight":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                break;
                            case "bottomRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        0
                                    ];
                                break;
                            case "bottomMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                break;
                            case "bottomLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        0
                                    ];
                                break;
                            case "middleLeft":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                break;
                        }
                        const point = getPoint(savedWidth, savedHeight);
                        const oppositePoint = getOpposite(savedWidth, savedHeight);
                        let transfOppositePoint = transf(...oppositePoint);
                        const oppositeX = round(savedX + transfOppositePoint[0]);
                        const oppositeY = round(savedY + transfOppositePoint[1]);
                        let ratioX = 1;
                        let ratioY = 1;
                        let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                        if (isDiagonal) {
                            const oldDiag = Math.hypot(savedWidth, savedHeight);
                            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                        } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                        else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                        const newWidth = round(savedWidth * ratioX);
                        const newHeight = round(savedHeight * ratioY);
                        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                        const newX = oppositeX - transfOppositePoint[0];
                        const newY = oppositeY - transfOppositePoint[1];
                        this.width = newWidth;
                        this.height = newHeight;
                        this.x = newX;
                        this.y = newY;
                        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                        this.fixAndSetPosition();
                    }
                    async addAltTextButton() {
                        if (this.#altTextButton) return;
                        const altText = this.#altTextButton = document.createElement("button");
                        altText.className = "altText";
                        const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                        altText.textContent = msg;
                        altText.setAttribute("aria-label", msg);
                        altText.tabIndex = "0";
                        altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                        altText.addEventListener("pointerdown", (event)=>event.stopPropagation());
                        altText.addEventListener("click", (event)=>{
                            event.preventDefault();
                            this._uiManager.editAltText(this);
                        }, {
                            capture: true
                        });
                        altText.addEventListener("keydown", (event)=>{
                            if (event.target === altText && event.key === "Enter") {
                                event.preventDefault();
                                this._uiManager.editAltText(this);
                            }
                        });
                        this.#setAltTextButtonState();
                        this.div.append(altText);
                        if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                            const PERCENT = 40;
                            AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                        }
                    }
                    async #setAltTextButtonState() {
                        const button = this.#altTextButton;
                        if (!button) return;
                        if (!this.#altText && !this.#altTextDecorative) {
                            button.classList.remove("done");
                            this.#altTextTooltip?.remove();
                            return;
                        }
                        AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg)=>{
                            button.setAttribute("aria-label", msg);
                        });
                        let tooltip = this.#altTextTooltip;
                        if (!tooltip) {
                            this.#altTextTooltip = tooltip = document.createElement("span");
                            tooltip.className = "tooltip";
                            tooltip.setAttribute("role", "tooltip");
                            const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                            button.setAttribute("aria-describedby", id);
                            const DELAY_TO_SHOW_TOOLTIP = 100;
                            button.addEventListener("mouseenter", ()=>{
                                this.#altTextTooltipTimeout = setTimeout(()=>{
                                    this.#altTextTooltipTimeout = null;
                                    this.#altTextTooltip.classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP);
                            });
                            button.addEventListener("mouseleave", ()=>{
                                clearTimeout(this.#altTextTooltipTimeout);
                                this.#altTextTooltipTimeout = null;
                                this.#altTextTooltip?.classList.remove("show");
                            });
                        }
                        button.classList.add("done");
                        tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                        if (!tooltip.parentNode) button.append(tooltip);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: this.#altText,
                            decorative: this.#altTextDecorative
                        };
                    }
                    set altTextData({ altText, decorative }) {
                        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
                        this.#altText = altText;
                        this.#altTextDecorative = decorative;
                        this.#setAltTextButtonState();
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", this.#boundFocusin);
                        this.div.addEventListener("focusout", this.#boundFocusout);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                        }
                        const [tx, ty] = this.getInitialTranslation();
                        this.translate(tx, ty);
                        (0, _tools.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) {
                            event.preventDefault();
                            return;
                        }
                        this.#hasBeenClicked = true;
                        this.#setUpDragSession(event);
                    }
                    #setUpDragSession(event) {
                        if (!this._isDraggable) return;
                        const isSelected = this._uiManager.isSelected(this);
                        this._uiManager.setUpDragSession();
                        let pointerMoveOptions, pointerMoveCallback;
                        if (isSelected) {
                            pointerMoveOptions = {
                                passive: true,
                                capture: true
                            };
                            pointerMoveCallback = (e)=>{
                                const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
                                this._uiManager.dragSelectedEditors(tx, ty);
                            };
                            window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        }
                        const pointerUpCallback = ()=>{
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                            this.#hasBeenClicked = false;
                            if (!this._uiManager.endDragSession()) {
                                const { isMac } = _util.FeatureTest.platform;
                                if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
                                else this.parent.setSelected(this);
                            }
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    moveInDOM() {
                        this.parent?.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent, x, y) {
                        parent.changeParent(this);
                        this.x = x;
                        this.y = y;
                        this.fixAndSetPosition();
                    }
                    getRect(tx, ty) {
                        const scale = this.parentScale;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const [pageX, pageY] = this.pageTranslation;
                        const shiftX = tx / scale;
                        const shiftY = ty / scale;
                        const x = this.x * pageWidth;
                        const y = this.y * pageHeight;
                        const width = this.width * pageWidth;
                        const height = this.height * pageHeight;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x + shiftX + pageX,
                                    pageHeight - y - shiftY - height + pageY,
                                    x + shiftX + width + pageX,
                                    pageHeight - y - shiftY + pageY
                                ];
                            case 90:
                                return [
                                    x + shiftY + pageX,
                                    pageHeight - y + shiftX + pageY,
                                    x + shiftY + height + pageX,
                                    pageHeight - y + shiftX + width + pageY
                                ];
                            case 180:
                                return [
                                    x - shiftX - width + pageX,
                                    pageHeight - y + shiftY + pageY,
                                    x - shiftX + pageX,
                                    pageHeight - y + shiftY + height + pageY
                                ];
                            case 270:
                                return [
                                    x - shiftY - height + pageX,
                                    pageHeight - y - shiftX - width + pageY,
                                    x - shiftY + pageX,
                                    pageHeight - y - shiftX + pageY
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect, pageHeight) {
                        const [x1, y1, x2, y2] = rect;
                        const width = x2 - x1;
                        const height = y2 - y1;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x1,
                                    pageHeight - y2,
                                    width,
                                    height
                                ];
                            case 90:
                                return [
                                    x1,
                                    pageHeight - y1,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    x2,
                                    pageHeight - y1,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    x2,
                                    pageHeight - y2,
                                    height,
                                    width
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        this.#isInEditMode = true;
                    }
                    disableEditMode() {
                        this.#isInEditMode = false;
                    }
                    isInEditMode() {
                        return this.#isInEditMode;
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        this.div?.addEventListener("focusin", this.#boundFocusin);
                        this.div?.addEventListener("focusout", this.#boundFocusout);
                    }
                    serialize(isForCopying = false, context = null) {
                        (0, _util.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data, parent, uiManager) {
                        const editor = new this.prototype.constructor({
                            parent: parent,
                            id: parent.getNextId(),
                            uiManager: uiManager
                        });
                        editor.rotation = data.rotation;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
                        editor.x = x / pageWidth;
                        editor.y = y / pageHeight;
                        editor.width = width / pageWidth;
                        editor.height = height / pageHeight;
                        return editor;
                    }
                    remove() {
                        this.div.removeEventListener("focusin", this.#boundFocusin);
                        this.div.removeEventListener("focusout", this.#boundFocusout);
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        this.#altTextButton?.remove();
                        this.#altTextButton = null;
                        this.#altTextTooltip = null;
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            this.#createResizers();
                            this.#resizersDiv.classList.remove("hidden");
                        }
                    }
                    select() {
                        this.makeResizable();
                        this.div?.classList.add("selectedEditor");
                    }
                    unselect() {
                        this.#resizersDiv?.classList.add("hidden");
                        this.div?.classList.remove("selectedEditor");
                        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type, value) {}
                    disableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = true;
                    }
                    enableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return this.#isEditing;
                    }
                    set isEditing(value) {
                        this.#isEditing = value;
                        if (!this.parent) return;
                        if (value) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width, height) {
                        this.#keepAspectRatio = true;
                        const aspectRatio = width / height;
                        const { style } = this.div;
                        style.aspectRatio = aspectRatio;
                        style.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                }
                exports.AnnotationEditor = AnnotationEditor;
                class FakeEditor extends AnnotationEditor {
                    constructor(params){
                        super(params);
                        this.annotationElementId = params.annotationElementId;
                        this.deleted = true;
                    }
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                class IdManager {
                    #id = 0;
                    getId() {
                        return `${_util.AnnotationEditorPrefix}${this.#id++}`;
                    }
                }
                class ImageManager {
                    #baseId = (0, _util.getUuid)();
                    #id = 0;
                    #cache = null;
                    static get _isSVGFittingCanvas() {
                        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas = new OffscreenCanvas(1, 3);
                        const ctx = canvas.getContext("2d");
                        const image = new Image();
                        image.src = svg;
                        const promise = image.decode().then(()=>{
                            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                    }
                    async #get(key, rawData) {
                        this.#cache ||= new Map();
                        let data = this.#cache.get(key);
                        if (data === null) return null;
                        if (data?.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        try {
                            data ||= {
                                bitmap: null,
                                id: `image_${this.#baseId}_${this.#id++}`,
                                refCounter: 0,
                                isSvg: false
                            };
                            let image;
                            if (typeof rawData === "string") {
                                data.url = rawData;
                                const response = await fetch(rawData);
                                if (!response.ok) throw new Error(response.statusText);
                                image = await response.blob();
                            } else image = data.file = rawData;
                            if (image.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                const fileReader = new FileReader();
                                const imageElement = new Image();
                                const imagePromise = new Promise((resolve, reject)=>{
                                    imageElement.onload = ()=>{
                                        data.bitmap = imageElement;
                                        data.isSvg = true;
                                        resolve();
                                    };
                                    fileReader.onload = async ()=>{
                                        const url = data.svgUrl = fileReader.result;
                                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                                    };
                                    imageElement.onerror = fileReader.onerror = reject;
                                });
                                fileReader.readAsDataURL(image);
                                await imagePromise;
                            } else data.bitmap = await createImageBitmap(image);
                            data.refCounter = 1;
                        } catch (e) {
                            console.error(e);
                            data = null;
                        }
                        this.#cache.set(key, data);
                        if (data) this.#cache.set(data.id, data);
                        return data;
                    }
                    async getFromFile(file) {
                        const { lastModified, name, size, type } = file;
                        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
                    }
                    async getFromUrl(url) {
                        return this.#get(url, url);
                    }
                    async getFromId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return null;
                        if (data.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        if (data.file) return this.getFromFile(data.file);
                        return this.getFromUrl(data.url);
                    }
                    getSvgUrl(id) {
                        const data = this.#cache.get(id);
                        if (!data?.isSvg) return null;
                        return data.svgUrl;
                    }
                    deleteId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return;
                        data.refCounter -= 1;
                        if (data.refCounter !== 0) return;
                        data.bitmap = null;
                    }
                    isValidId(id) {
                        return id.startsWith(`image_${this.#baseId}_`);
                    }
                }
                class CommandManager {
                    #commands = [];
                    #locked = false;
                    #maxSize;
                    #position = -1;
                    constructor(maxSize = 128){
                        this.#maxSize = maxSize;
                    }
                    add({ cmd, undo, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
                        if (mustExec) cmd();
                        if (this.#locked) return;
                        const save = {
                            cmd: cmd,
                            undo: undo,
                            type: type
                        };
                        if (this.#position === -1) {
                            if (this.#commands.length > 0) this.#commands.length = 0;
                            this.#position = 0;
                            this.#commands.push(save);
                            return;
                        }
                        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
                            if (keepUndo) save.undo = this.#commands[this.#position].undo;
                            this.#commands[this.#position] = save;
                            return;
                        }
                        const next = this.#position + 1;
                        if (next === this.#maxSize) this.#commands.splice(0, 1);
                        else {
                            this.#position = next;
                            if (next < this.#commands.length) this.#commands.splice(next);
                        }
                        this.#commands.push(save);
                    }
                    undo() {
                        if (this.#position === -1) return;
                        this.#locked = true;
                        this.#commands[this.#position].undo();
                        this.#locked = false;
                        this.#position -= 1;
                    }
                    redo() {
                        if (this.#position < this.#commands.length - 1) {
                            this.#position += 1;
                            this.#locked = true;
                            this.#commands[this.#position].cmd();
                            this.#locked = false;
                        }
                    }
                    hasSomethingToUndo() {
                        return this.#position !== -1;
                    }
                    hasSomethingToRedo() {
                        return this.#position < this.#commands.length - 1;
                    }
                    destroy() {
                        this.#commands = null;
                    }
                }
                exports.CommandManager = CommandManager;
                class KeyboardManager {
                    constructor(callbacks){
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac } = _util.FeatureTest.platform;
                        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
                            const isMacKey = key.startsWith("mac+");
                            if (isMac && isMacKey) {
                                this.callbacks.set(key.slice(4), {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            } else if (!isMac && !isMacKey) {
                                this.callbacks.set(key, {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            }
                        }
                    }
                    #serialize(event) {
                        if (event.altKey) this.buffer.push("alt");
                        if (event.ctrlKey) this.buffer.push("ctrl");
                        if (event.metaKey) this.buffer.push("meta");
                        if (event.shiftKey) this.buffer.push("shift");
                        this.buffer.push(event.key);
                        const str = this.buffer.join("+");
                        this.buffer.length = 0;
                        return str;
                    }
                    exec(self, event) {
                        if (!this.allKeys.has(event.key)) return;
                        const info = this.callbacks.get(this.#serialize(event));
                        if (!info) return;
                        const { callback, options: { bubbles = false, args = [], checker = null } } = info;
                        if (checker && !checker(self, event)) return;
                        callback.bind(self, ...args)();
                        if (!bubbles) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                }
                exports.KeyboardManager = KeyboardManager;
                class ColorManager {
                    static _colorsMapping = new Map([
                        [
                            "CanvasText",
                            [
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            "Canvas",
                            [
                                255,
                                255,
                                255
                            ]
                        ]
                    ]);
                    get _colors() {
                        const colors = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils.getColorValues)(colors);
                        return (0, _util.shadow)(this, "_colors", colors);
                    }
                    convert(color) {
                        const rgb = (0, _display_utils.getRGB)(color);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                        for (const [name, RGB] of this._colors){
                            if (RGB.every((x, i)=>x === rgb[i])) return ColorManager._colorsMapping.get(name);
                        }
                        return rgb;
                    }
                    getHexCode(name) {
                        const rgb = this._colors.get(name);
                        if (!rgb) return name;
                        return _util.Util.makeHexColor(...rgb);
                    }
                }
                exports.ColorManager = ColorManager;
                class AnnotationEditorUIManager {
                    #activeEditor = null;
                    #allEditors = new Map();
                    #allLayers = new Map();
                    #altTextManager = null;
                    #annotationStorage = null;
                    #commandManager = new CommandManager();
                    #currentPageIndex = 0;
                    #deletedAnnotationsElementIds = new Set();
                    #draggingEditors = null;
                    #editorTypes = null;
                    #editorsToRescale = new Set();
                    #filterFactory = null;
                    #idManager = new IdManager();
                    #isEnabled = false;
                    #isWaiting = false;
                    #lastActiveElement = null;
                    #mode = _util.AnnotationEditorType.NONE;
                    #selectedEditors = new Set();
                    #pageColors = null;
                    #boundBlur = this.blur.bind(this);
                    #boundFocus = this.focus.bind(this);
                    #boundCopy = this.copy.bind(this);
                    #boundCut = this.cut.bind(this);
                    #boundPaste = this.paste.bind(this);
                    #boundKeydown = this.keydown.bind(this);
                    #boundOnEditingAction = this.onEditingAction.bind(this);
                    #boundOnPageChanging = this.onPageChanging.bind(this);
                    #boundOnScaleChanging = this.onScaleChanging.bind(this);
                    #boundOnRotationChanging = this.onRotationChanging.bind(this);
                    #previousStates = {
                        isEditing: false,
                        isEmpty: true,
                        hasSomethingToUndo: false,
                        hasSomethingToRedo: false,
                        hasSelectedEditor: false
                    };
                    #translation = [
                        0,
                        0
                    ];
                    #translationTimeoutId = null;
                    #container = null;
                    #viewer = null;
                    static TRANSLATE_SMALL = 1;
                    static TRANSLATE_BIG = 10;
                    static get _keyboardManager() {
                        const proto = AnnotationEditorUIManager.prototype;
                        const arrowChecker = (self)=>{
                            const { activeElement } = document;
                            return activeElement && self.#container.contains(activeElement) && self.hasSomethingToControl();
                        };
                        const small = this.TRANSLATE_SMALL;
                        const big = this.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors){
                        this.#container = container;
                        this.#viewer = viewer;
                        this.#altTextManager = altTextManager;
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", this.#boundOnEditingAction);
                        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                        this.#annotationStorage = pdfDocument.annotationStorage;
                        this.#filterFactory = pdfDocument.filterFactory;
                        this.#pageColors = pageColors;
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    destroy() {
                        this.#removeKeyboardManager();
                        this.#removeFocusManager();
                        this._eventBus._off("editingaction", this.#boundOnEditingAction);
                        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                        for (const layer of this.#allLayers.values())layer.destroy();
                        this.#allLayers.clear();
                        this.#allEditors.clear();
                        this.#editorsToRescale.clear();
                        this.#activeEditor = null;
                        this.#selectedEditors.clear();
                        this.#commandManager.destroy();
                        this.#altTextManager.destroy();
                    }
                    get hcmFilter() {
                        return (0, _util.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                    }
                    get direction() {
                        return (0, _util.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                    }
                    editAltText(editor) {
                        this.#altTextManager?.editAltText(this, editor);
                    }
                    onPageChanging({ pageNumber }) {
                        this.#currentPageIndex = pageNumber - 1;
                    }
                    focusMainContainer() {
                        this.#container.focus();
                    }
                    findParent(x, y) {
                        for (const layer of this.#allLayers.values()){
                            const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
                            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                        }
                        return null;
                    }
                    disableUserSelect(value = false) {
                        this.#viewer.classList.toggle("noUserSelect", value);
                    }
                    addShouldRescale(editor) {
                        this.#editorsToRescale.add(editor);
                    }
                    removeShouldRescale(editor) {
                        this.#editorsToRescale.delete(editor);
                    }
                    onScaleChanging({ scale }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation;
                    }
                    addToAnnotationStorage(editor) {
                        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
                    }
                    #addFocusManager() {
                        window.addEventListener("focus", this.#boundFocus);
                        window.addEventListener("blur", this.#boundBlur);
                    }
                    #removeFocusManager() {
                        window.removeEventListener("focus", this.#boundFocus);
                        window.removeEventListener("blur", this.#boundBlur);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement } = document;
                        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
                            this.#lastActiveElement = [
                                editor,
                                activeElement
                            ];
                            editor._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!this.#lastActiveElement) return;
                        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
                        this.#lastActiveElement = null;
                        lastActiveElement.addEventListener("focusin", ()=>{
                            lastEditor._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement.focus();
                    }
                    #addKeyboardManager() {
                        window.addEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #removeKeyboardManager() {
                        window.removeEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #addCopyPasteListeners() {
                        document.addEventListener("copy", this.#boundCopy);
                        document.addEventListener("cut", this.#boundCut);
                        document.addEventListener("paste", this.#boundPaste);
                    }
                    #removeCopyPasteListeners() {
                        document.removeEventListener("copy", this.#boundCopy);
                        document.removeEventListener("cut", this.#boundCut);
                        document.removeEventListener("paste", this.#boundPaste);
                    }
                    addEditListeners() {
                        this.#addKeyboardManager();
                        this.#addCopyPasteListeners();
                    }
                    removeEditListeners() {
                        this.#removeKeyboardManager();
                        this.#removeCopyPasteListeners();
                    }
                    copy(event) {
                        event.preventDefault();
                        this.#activeEditor?.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [];
                        for (const editor of this.#selectedEditors){
                            const serialized = editor.serialize(true);
                            if (serialized) editors.push(serialized);
                        }
                        if (editors.length === 0) return;
                        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                    }
                    cut(event) {
                        this.copy(event);
                        this.delete();
                    }
                    paste(event) {
                        event.preventDefault();
                        const { clipboardData } = event;
                        for (const item of clipboardData.items){
                            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                                editorType.paste(item, this.currentLayer);
                                return;
                            }
                        }
                        let data = clipboardData.getData("application/pdfjs");
                        if (!data) return;
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                            return;
                        }
                        if (!Array.isArray(data)) return;
                        this.unselectAll();
                        const layer = this.currentLayer;
                        try {
                            const newEditors = [];
                            for (const editor of data){
                                const deserializedEditor = layer.deserialize(editor);
                                if (!deserializedEditor) return;
                                newEditors.push(deserializedEditor);
                            }
                            const cmd = ()=>{
                                for (const editor of newEditors)this.#addEditorToLayer(editor);
                                this.#selectEditors(newEditors);
                            };
                            const undo = ()=>{
                                for (const editor of newEditors)editor.remove();
                            };
                            this.addCommands({
                                cmd: cmd,
                                undo: undo,
                                mustExec: true
                            });
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                        }
                    }
                    keydown(event) {
                        if (!this.getActive()?.shouldGetKeyboardEvents()) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                    }
                    onEditingAction(details) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details.name)) this[details.name]();
                    }
                    #dispatchUpdateStates(details) {
                        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
                        if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                            source: this,
                            details: Object.assign(this.#previousStates, details)
                        });
                    }
                    #dispatchUpdateUI(details) {
                        this._eventBus.dispatch("annotationeditorparamschanged", {
                            source: this,
                            details: details
                        });
                    }
                    setEditingState(isEditing) {
                        if (isEditing) {
                            this.#addFocusManager();
                            this.#addKeyboardManager();
                            this.#addCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: this.#mode !== _util.AnnotationEditorType.NONE,
                                isEmpty: this.#isEmpty(),
                                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            this.#removeFocusManager();
                            this.#removeKeyboardManager();
                            this.#removeCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types) {
                        if (this.#editorTypes) return;
                        this.#editorTypes = types;
                        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return this.#idManager.getId();
                    }
                    get currentLayer() {
                        return this.#allLayers.get(this.#currentPageIndex);
                    }
                    getLayer(pageIndex) {
                        return this.#allLayers.get(pageIndex);
                    }
                    get currentPageIndex() {
                        return this.#currentPageIndex;
                    }
                    addLayer(layer) {
                        this.#allLayers.set(layer.pageIndex, layer);
                        if (this.#isEnabled) layer.enable();
                        else layer.disable();
                    }
                    removeLayer(layer) {
                        this.#allLayers.delete(layer.pageIndex);
                    }
                    updateMode(mode, editId = null) {
                        if (this.#mode === mode) return;
                        this.#mode = mode;
                        if (mode === _util.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            this.#disableAll();
                            return;
                        }
                        this.setEditingState(true);
                        this.#enableAll();
                        this.unselectAll();
                        for (const layer of this.#allLayers.values())layer.updateMode(mode);
                        if (!editId) return;
                        for (const editor of this.#allEditors.values())if (editor.annotationElementId === editId) {
                            this.setSelected(editor);
                            editor.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode) {
                        if (mode === this.#mode) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode
                        });
                    }
                    updateParams(type, value) {
                        if (!this.#editorTypes) return;
                        if (type === _util.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type);
                            return;
                        }
                        for (const editor of this.#selectedEditors)editor.updateParams(type, value);
                        for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
                    }
                    enableWaiting(mustWait = false) {
                        if (this.#isWaiting === mustWait) return;
                        this.#isWaiting = mustWait;
                        for (const layer of this.#allLayers.values()){
                            if (mustWait) layer.disableClick();
                            else layer.enableClick();
                            layer.div.classList.toggle("waiting", mustWait);
                        }
                    }
                    #enableAll() {
                        if (!this.#isEnabled) {
                            this.#isEnabled = true;
                            for (const layer of this.#allLayers.values())layer.enable();
                        }
                    }
                    #disableAll() {
                        this.unselectAll();
                        if (this.#isEnabled) {
                            this.#isEnabled = false;
                            for (const layer of this.#allLayers.values())layer.disable();
                        }
                    }
                    getEditors(pageIndex) {
                        const editors = [];
                        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) editors.push(editor);
                        return editors;
                    }
                    getEditor(id) {
                        return this.#allEditors.get(id);
                    }
                    addEditor(editor) {
                        this.#allEditors.set(editor.id, editor);
                    }
                    removeEditor(editor) {
                        this.#allEditors.delete(editor.id);
                        this.unselect(editor);
                        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
                    }
                    addDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
                        editor.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId) {
                        return this.#deletedAnnotationsElementIds.has(annotationElementId);
                    }
                    removeDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
                        editor.deleted = false;
                    }
                    #addEditorToLayer(editor) {
                        const layer = this.#allLayers.get(editor.pageIndex);
                        if (layer) layer.addOrRebuild(editor);
                        else this.addEditor(editor);
                    }
                    setActiveEditor(editor) {
                        if (this.#activeEditor === editor) return;
                        this.#activeEditor = editor;
                        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
                    }
                    toggleSelected(editor) {
                        if (this.#selectedEditors.has(editor)) {
                            this.#selectedEditors.delete(editor);
                            editor.unselect();
                            this.#dispatchUpdateStates({
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor) {
                        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
                        this.#selectedEditors.clear();
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor) {
                        return this.#selectedEditors.has(editor);
                    }
                    unselect(editor) {
                        editor.unselect();
                        this.#selectedEditors.delete(editor);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return this.#selectedEditors.size !== 0;
                    }
                    undo() {
                        this.#commandManager.undo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    redo() {
                        this.#commandManager.redo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                            isEmpty: this.#isEmpty()
                        });
                    }
                    addCommands(params) {
                        this.#commandManager.add(params);
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    #isEmpty() {
                        if (this.#allEditors.size === 0) return true;
                        if (this.#allEditors.size === 1) {
                            for (const editor of this.#allEditors.values())return editor.isEmpty();
                        }
                        return false;
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const cmd = ()=>{
                            for (const editor of editors)editor.remove();
                        };
                        const undo = ()=>{
                            for (const editor of editors)this.#addEditorToLayer(editor);
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        this.#activeEditor?.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return this.#activeEditor || this.hasSelection;
                    }
                    #selectEditors(editors) {
                        this.#selectedEditors.clear();
                        for (const editor of editors){
                            if (editor.isEmpty()) continue;
                            this.#selectedEditors.add(editor);
                            editor.select();
                        }
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    selectAll() {
                        for (const editor of this.#selectedEditors)editor.commit();
                        this.#selectEditors(this.#allEditors.values());
                    }
                    unselectAll() {
                        if (this.#activeEditor) {
                            this.#activeEditor.commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor of this.#selectedEditors)editor.unselect();
                        this.#selectedEditors.clear();
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x, y, noCommit = false) {
                        if (!noCommit) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        this.#translation[0] += x;
                        this.#translation[1] += y;
                        const [totalX, totalY] = this.#translation;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const TIME_TO_WAIT = 1000;
                        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
                        this.#translationTimeoutId = setTimeout(()=>{
                            this.#translationTimeoutId = null;
                            this.#translation[0] = this.#translation[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(totalX, totalY);
                                },
                                undo: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT);
                        for (const editor of editors)editor.translateInPage(x, y);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        this.#draggingEditors = new Map();
                        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
                            savedX: editor.x,
                            savedY: editor.y,
                            savedPageIndex: editor.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!this.#draggingEditors) return false;
                        this.disableUserSelect(false);
                        const map = this.#draggingEditors;
                        this.#draggingEditors = null;
                        let mustBeAddedInUndoStack = false;
                        for (const [{ x, y, pageIndex }, value] of map){
                            value.newX = x;
                            value.newY = y;
                            value.newPageIndex = pageIndex;
                            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
                        }
                        if (!mustBeAddedInUndoStack) return false;
                        const move = (editor, x, y, pageIndex)=>{
                            if (this.#allEditors.has(editor.id)) {
                                const parent = this.#allLayers.get(pageIndex);
                                if (parent) editor._setParentAndPosition(parent, x, y);
                                else {
                                    editor.pageIndex = pageIndex;
                                    editor.x = x;
                                    editor.y = y;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor, { newX, newY, newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
                            },
                            undo: ()=>{
                                for (const [editor, { savedX, savedY, savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx, ty) {
                        if (!this.#draggingEditors) return;
                        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
                    }
                    rebuild(editor) {
                        if (editor.parent === null) {
                            const parent = this.getLayer(editor.pageIndex);
                            if (parent) {
                                parent.changeParent(editor);
                                parent.addOrRebuild(editor);
                            } else {
                                this.addEditor(editor);
                                this.addToAnnotationStorage(editor);
                                editor.rebuild();
                            }
                        } else editor.parent.addOrRebuild(editor);
                    }
                    isActive(editor) {
                        return this.#activeEditor === editor;
                    }
                    getActive() {
                        return this.#activeEditor;
                    }
                    getMode() {
                        return this.#mode;
                    }
                    get imageManager() {
                        return (0, _util.shadow)(this, "imageManager", new ImageManager());
                    }
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const SVG_NS = "http://www.w3.org/2000/svg";
                class PixelsPerInch {
                    static CSS = 96.0;
                    static PDF = 72.0;
                    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
                }
                exports.PixelsPerInch = PixelsPerInch;
                class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                    #_cache;
                    #_defs;
                    #docId;
                    #document;
                    #hcmFilter;
                    #hcmKey;
                    #hcmUrl;
                    #hcmHighlightFilter;
                    #hcmHighlightKey;
                    #hcmHighlightUrl;
                    #id = 0;
                    constructor({ docId, ownerDocument = globalThis.document } = {}){
                        super();
                        this.#docId = docId;
                        this.#document = ownerDocument;
                    }
                    get #cache() {
                        return this.#_cache ||= new Map();
                    }
                    get #defs() {
                        if (!this.#_defs) {
                            const div = this.#document.createElement("div");
                            const { style } = div;
                            style.visibility = "hidden";
                            style.contain = "strict";
                            style.width = style.height = 0;
                            style.position = "absolute";
                            style.top = style.left = 0;
                            style.zIndex = -1;
                            const svg = this.#document.createElementNS(SVG_NS, "svg");
                            svg.setAttribute("width", 0);
                            svg.setAttribute("height", 0);
                            this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
                            div.append(svg);
                            svg.append(this.#_defs);
                            this.#document.body.append(div);
                        }
                        return this.#_defs;
                    }
                    addFilter(maps) {
                        if (!maps) return "none";
                        let value = this.#cache.get(maps);
                        if (value) return value;
                        let tableR, tableG, tableB, key;
                        if (maps.length === 1) {
                            const mapR = maps[0];
                            const buffer = new Array(256);
                            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                            key = tableR = tableG = tableB = buffer.join(",");
                        } else {
                            const [mapR, mapG, mapB] = maps;
                            const bufferR = new Array(256);
                            const bufferG = new Array(256);
                            const bufferB = new Array(256);
                            for(let i = 0; i < 256; i++){
                                bufferR[i] = mapR[i] / 255;
                                bufferG[i] = mapG[i] / 255;
                                bufferB[i] = mapB[i] / 255;
                            }
                            tableR = bufferR.join(",");
                            tableG = bufferG.join(",");
                            tableB = bufferB.join(",");
                            key = `${tableR}${tableG}${tableB}`;
                        }
                        value = this.#cache.get(key);
                        if (value) {
                            this.#cache.set(maps, value);
                            return value;
                        }
                        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
                        const url = `url(#${id})`;
                        this.#cache.set(maps, url);
                        this.#cache.set(key, url);
                        const filter = this.#createFilter(id);
                        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
                        return url;
                    }
                    addHCMFilter(fgColor, bgColor) {
                        const key = `${fgColor}-${bgColor}`;
                        if (this.#hcmKey === key) return this.#hcmUrl;
                        this.#hcmKey = key;
                        this.#hcmUrl = "none";
                        this.#hcmFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmUrl;
                        const fgRGB = this.#getRGB(fgColor);
                        fgColor = _util.Util.makeHexColor(...fgRGB);
                        const bgRGB = this.#getRGB(bgColor);
                        bgColor = _util.Util.makeHexColor(...bgRGB);
                        this.#defs.style.color = "";
                        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return this.#hcmUrl;
                        const map = new Array(256);
                        for(let i = 0; i <= 255; i++){
                            const x = i / 255;
                            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
                        }
                        const table = map.join(",");
                        const id = `g_${this.#docId}_hcm_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addTransferMapConversion(table, table, table, filter);
                        this.#addGrayConversion(filter);
                        const getSteps = (c, n)=>{
                            const start = fgRGB[c] / 255;
                            const end = bgRGB[c] / 255;
                            const arr = new Array(n + 1);
                            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                            return arr.join(",");
                        };
                        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                        this.#hcmUrl = `url(#${id})`;
                        return this.#hcmUrl;
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                        if (this.#hcmHighlightKey === key) return this.#hcmHighlightUrl;
                        this.#hcmHighlightKey = key;
                        this.#hcmHighlightUrl = "none";
                        this.#hcmHighlightFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmHighlightUrl;
                        const [fgRGB, bgRGB] = [
                            fgColor,
                            bgColor
                        ].map(this.#getRGB.bind(this));
                        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                        let [newFgRGB, newBgRGB] = [
                            newFgColor,
                            newBgColor
                        ].map(this.#getRGB.bind(this));
                        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
                            bgGray,
                            fgGray,
                            newBgRGB,
                            newFgRGB
                        ];
                        this.#defs.style.color = "";
                        const getSteps = (fg, bg, n)=>{
                            const arr = new Array(256);
                            const step = (bgGray - fgGray) / n;
                            const newStart = fg / 255;
                            const newStep = (bg - fg) / (255 * n);
                            let prev = 0;
                            for(let i = 0; i <= n; i++){
                                const k = Math.round(fgGray + i * step);
                                const value = newStart + i * newStep;
                                for(let j = prev; j <= k; j++)arr[j] = value;
                                prev = k + 1;
                            }
                            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
                            return arr.join(",");
                        };
                        const id = `g_${this.#docId}_hcm_highlight_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addGrayConversion(filter);
                        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                        this.#hcmHighlightUrl = `url(#${id})`;
                        return this.#hcmHighlightUrl;
                    }
                    destroy(keepHCM = false) {
                        if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) return;
                        if (this.#_defs) {
                            this.#_defs.parentNode.parentNode.remove();
                            this.#_defs = null;
                        }
                        if (this.#_cache) {
                            this.#_cache.clear();
                            this.#_cache = null;
                        }
                        this.#id = 0;
                    }
                    #addGrayConversion(filter) {
                        const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
                        feColorMatrix.setAttribute("type", "matrix");
                        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                        filter.append(feColorMatrix);
                    }
                    #createFilter(id) {
                        const filter = this.#document.createElementNS(SVG_NS, "filter");
                        filter.setAttribute("color-interpolation-filters", "sRGB");
                        filter.setAttribute("id", id);
                        this.#defs.append(filter);
                        return filter;
                    }
                    #appendFeFunc(feComponentTransfer, func, table) {
                        const feFunc = this.#document.createElementNS(SVG_NS, func);
                        feFunc.setAttribute("type", "discrete");
                        feFunc.setAttribute("tableValues", table);
                        feComponentTransfer.append(feFunc);
                    }
                    #addTransferMapConversion(rTable, gTable, bTable, filter) {
                        const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
                        filter.append(feComponentTransfer);
                        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
                    }
                    #getRGB(color) {
                        this.#defs.style.color = color;
                        return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
                    }
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                    constructor({ ownerDocument = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument;
                    }
                    _createCanvas(width, height) {
                        const canvas = this._document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        return canvas;
                    }
                }
                exports.DOMCanvasFactory = DOMCanvasFactory;
                async function fetchData(url, asTypedArray = false) {
                    if (isValidFetchUrl(url, document.baseURI)) {
                        const response = await fetch(url);
                        if (!response.ok) throw new Error(response.statusText);
                        return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util.stringToBytes)(await response.text());
                    }
                    return new Promise((resolve, reject)=>{
                        const request = new XMLHttpRequest();
                        request.open("GET", url, true);
                        if (asTypedArray) request.responseType = "arraybuffer";
                        request.onreadystatechange = ()=>{
                            if (request.readyState !== XMLHttpRequest.DONE) return;
                            if (request.status === 200 || request.status === 0) {
                                let data;
                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                if (data) {
                                    resolve(data);
                                    return;
                                }
                            }
                            reject(new Error(request.statusText));
                        };
                        request.send(null);
                    });
                }
                class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url, this.isCompressed).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url, true);
                    }
                }
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                    _createSVG(type) {
                        return document.createElementNS(SVG_NS, type);
                    }
                }
                exports.DOMSVGFactory = DOMSVGFactory;
                class PageViewport {
                    constructor({ viewBox, scale, rotation, offsetX = 0, offsetY = 0, dontFlip = false }){
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        const centerX = (viewBox[2] + viewBox[0]) / 2;
                        const centerY = (viewBox[3] + viewBox[1]) / 2;
                        let rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        let offsetCanvasX, offsetCanvasY;
                        let width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    get rawDims() {
                        const { viewBox } = this;
                        return (0, _util.shadow)(this, "rawDims", {
                            pageWidth: viewBox[2] - viewBox[0],
                            pageHeight: viewBox[3] - viewBox[1],
                            pageX: viewBox[0],
                            pageY: viewBox[1]
                        });
                    }
                    clone({ scale = this.scale, rotation = this.rotation, offsetX = this.offsetX, offsetY = this.offsetY, dontFlip = false } = {}) {
                        return new PageViewport({
                            viewBox: this.viewBox.slice(),
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    convertToViewportPoint(x, y) {
                        return _util.Util.applyTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect) {
                        const topLeft = _util.Util.applyTransform([
                            rect[0],
                            rect[1]
                        ], this.transform);
                        const bottomRight = _util.Util.applyTransform([
                            rect[2],
                            rect[3]
                        ], this.transform);
                        return [
                            topLeft[0],
                            topLeft[1],
                            bottomRight[0],
                            bottomRight[1]
                        ];
                    }
                    convertToPdfPoint(x, y) {
                        return _util.Util.applyInverseTransform([
                            x,
                            y
                        ], this.transform);
                    }
                }
                exports.PageViewport = PageViewport;
                class RenderingCancelledException extends _util.BaseException {
                    constructor(msg, extraDelay = 0){
                        super(msg, "RenderingCancelledException");
                        this.extraDelay = extraDelay;
                    }
                }
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    const ii = url.length;
                    let i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url, onlyStripPath = false) {
                    if (!onlyStripPath) [url] = url.split(/[#?]/, 1);
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI = reURI.exec(url);
                    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch  {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                class StatTimer {
                    started = Object.create(null);
                    times = [];
                    time(name) {
                        if (name in this.started) (0, _util.warn)(`Timer is already running for ${name}`);
                        this.started[name] = Date.now();
                    }
                    timeEnd(name) {
                        if (!(name in this.started)) (0, _util.warn)(`Timer has not been started for ${name}`);
                        this.times.push({
                            name: name,
                            start: this.started[name],
                            end: Date.now()
                        });
                        delete this.started[name];
                    }
                    toString() {
                        const outBuf = [];
                        let longest = 0;
                        for (const { name } of this.times)longest = Math.max(name.length, longest);
                        for (const { name, start, end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
                        return outBuf.join("");
                    }
                }
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        return protocol === "http:" || protocol === "https:";
                    } catch  {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src, removeScriptElement = false) {
                    return new Promise((resolve, reject)=>{
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error(`Cannot load script at: ${script.src}`));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                let pdfDateStringRegex;
                class PDFDateString {
                    static toDateObject(input) {
                        if (!input || typeof input !== "string") return null;
                        pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches = pdfDateStringRegex.exec(input);
                        if (!matches) return null;
                        const year = parseInt(matches[1], 10);
                        let month = parseInt(matches[2], 10);
                        month = month >= 1 && month <= 12 ? month - 1 : 0;
                        let day = parseInt(matches[3], 10);
                        day = day >= 1 && day <= 31 ? day : 1;
                        let hour = parseInt(matches[4], 10);
                        hour = hour >= 0 && hour <= 23 ? hour : 0;
                        let minute = parseInt(matches[5], 10);
                        minute = minute >= 0 && minute <= 59 ? minute : 0;
                        let second = parseInt(matches[6], 10);
                        second = second >= 0 && second <= 59 ? second : 0;
                        const universalTimeRelation = matches[7] || "Z";
                        let offsetHour = parseInt(matches[8], 10);
                        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                        let offsetMinute = parseInt(matches[9], 10) || 0;
                        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                        if (universalTimeRelation === "-") {
                            hour += offsetHour;
                            minute += offsetMinute;
                        } else if (universalTimeRelation === "+") {
                            hour -= offsetHour;
                            minute -= offsetMinute;
                        }
                        return new Date(Date.UTC(year, month, day, hour, minute, second));
                    }
                }
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
                    const { width, height } = xfaPage.attributes.style;
                    const viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB(color) {
                    if (color.startsWith("#")) {
                        const colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
                    (0, _util.warn)(`Not a valid color format: "${color}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    const span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    for (const name of colors.keys()){
                        span.style.color = name;
                        const computedColor = window.getComputedStyle(span).color;
                        colors.set(name, getRGB(computedColor));
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                    if (viewport instanceof PageViewport) {
                        const { pageWidth, pageHeight } = viewport.rawDims;
                        const { style } = div;
                        const useRound = _util.FeatureTest.isCSSRoundSupported;
                        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
                        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                class BaseFilterFactory {
                    constructor(){
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    addFilter(maps) {
                        return "none";
                    }
                    addHCMFilter(fgColor, bgColor) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        return "none";
                    }
                    destroy(keepHCM = false) {}
                }
                exports.BaseFilterFactory = BaseFilterFactory;
                class BaseCanvasFactory {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width, height) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        const canvas = this._createCanvas(width, height);
                        return {
                            canvas: canvas,
                            context: canvas.getContext("2d")
                        };
                    }
                    reset(canvasAndContext, width, height) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext.canvas.width = width;
                        canvasAndContext.canvas.height = height;
                    }
                    destroy(canvasAndContext) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext.canvas.width = 0;
                        canvasAndContext.canvas.height = 0;
                        canvasAndContext.canvas = null;
                        canvasAndContext.context = null;
                    }
                    _createCanvas(width, height) {
                        (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports.BaseCanvasFactory = BaseCanvasFactory;
                class BaseCMapReaderFactory {
                    constructor({ baseUrl = null, isCompressed = true }){
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    async fetch({ name }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name) throw new Error("CMap name must be specified.");
                        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                        const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                        return this._fetchData(url, compressionType).catch((reason)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
                        });
                    }
                    _fetchData(url, compressionType) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                class BaseStandardFontDataFactory {
                    constructor({ baseUrl = null }){
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    async fetch({ filename }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename) throw new Error("Font filename must be specified.");
                        const url = `${this.baseUrl}${filename}`;
                        return this._fetchData(url).catch((reason)=>{
                            throw new Error(`Unable to load font data at: ${url}`);
                        });
                    }
                    _fetchData(url) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                class BaseSVGFactory {
                    constructor(){
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width, height, skipDimensions = false) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                        const svg = this._createSVG("svg:svg");
                        svg.setAttribute("version", "1.1");
                        if (!skipDimensions) {
                            svg.setAttribute("width", `${width}px`);
                            svg.setAttribute("height", `${height}px`);
                        }
                        svg.setAttribute("preserveAspectRatio", "none");
                        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                        return svg;
                    }
                    createElement(type) {
                        if (typeof type !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type);
                    }
                    _createSVG(type) {
                        (0, _util.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                class FontLoader {
                    #systemFonts = new Set();
                    constructor({ ownerDocument = globalThis.document, styleElement = null }){
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    addNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.add(nativeFontFace);
                        this._document.fonts.add(nativeFontFace);
                    }
                    removeNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.delete(nativeFontFace);
                        this._document.fonts.delete(nativeFontFace);
                    }
                    insertRule(rule) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet = this.styleElement.sheet;
                        styleSheet.insertRule(rule, styleSheet.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
                        this.nativeFontFaces.clear();
                        this.#systemFonts.clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async loadSystemFont(info) {
                        if (!info || this.#systemFonts.has(info.loadedName)) return;
                        (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (this.isFontLoadingAPISupported) {
                            const { loadedName, src, style } = info;
                            const fontFace = new FontFace(loadedName, src, style);
                            this.addNativeFontFace(fontFace);
                            try {
                                await fontFace.load();
                                this.#systemFonts.add(loadedName);
                            } catch  {
                                (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                                this.removeNativeFontFace(fontFace);
                            }
                            return;
                        }
                        (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                    }
                    async bind(font) {
                        if (font.attached || font.missingFile && !font.systemFontInfo) return;
                        font.attached = true;
                        if (font.systemFontInfo) {
                            await this.loadSystemFont(font.systemFontInfo);
                            return;
                        }
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace = font.createNativeFontFace();
                            if (nativeFontFace) {
                                this.addNativeFontFace(nativeFontFace);
                                try {
                                    await nativeFontFace.loaded;
                                } catch (ex) {
                                    (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                                    font.disableFontFace = true;
                                    throw ex;
                                }
                            }
                            return;
                        }
                        const rule = font.createFontFaceRule();
                        if (rule) {
                            this.insertRule(rule);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve)=>{
                                const request = this._queueLoadingCallback(resolve);
                                this._prepareFontLoadEvent(font, request);
                            });
                        }
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts = !!this._document?.fonts;
                        return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported = false;
                        if (_util.isNodeJS) supported = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                    }
                    _queueLoadingCallback(callback) {
                        function completeRequest() {
                            (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                            request.done = true;
                            while(loadingRequests.length > 0 && loadingRequests[0].done){
                                const otherRequest = loadingRequests.shift();
                                setTimeout(otherRequest.callback, 0);
                            }
                        }
                        const { loadingRequests } = this;
                        const request = {
                            done: false,
                            complete: completeRequest,
                            callback: callback
                        };
                        loadingRequests.push(request);
                        return request;
                    }
                    get _loadTestFont() {
                        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util.shadow)(this, "_loadTestFont", testFont);
                    }
                    _prepareFontLoadEvent(font, request) {
                        function int32(data, offset) {
                            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                        }
                        function spliceString(s, offset, remove, insert) {
                            const chunk1 = s.substring(0, offset);
                            const chunk2 = s.substring(offset + remove);
                            return chunk1 + insert + chunk2;
                        }
                        let i, ii;
                        const canvas = this._document.createElement("canvas");
                        canvas.width = 1;
                        canvas.height = 1;
                        const ctx = canvas.getContext("2d");
                        let called = 0;
                        function isFontReady(name, callback) {
                            if (++called > 30) {
                                (0, _util.warn)("Load test font never loaded.");
                                callback();
                                return;
                            }
                            ctx.font = "30px " + name;
                            ctx.fillText(".", 0, 20);
                            const imageData = ctx.getImageData(0, 0, 1, 1);
                            if (imageData.data[3] > 0) {
                                callback();
                                return;
                            }
                            setTimeout(isFontReady.bind(null, name, callback));
                        }
                        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data = this._loadTestFont;
                        const COMMENT_OFFSET = 976;
                        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                        const CFF_CHECKSUM_OFFSET = 16;
                        const XXXX_VALUE = 0x58585858;
                        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
                        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                        const url = `url(data:font/opentype;base64,${btoa(data)});`;
                        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                        this.insertRule(rule);
                        const div = this._document.createElement("div");
                        div.style.visibility = "hidden";
                        div.style.width = div.style.height = "10px";
                        div.style.position = "absolute";
                        div.style.top = div.style.left = "0px";
                        for (const name of [
                            font.loadedName,
                            loadTestFontId
                        ]){
                            const span = this._document.createElement("span");
                            span.textContent = "Hi";
                            span.style.fontFamily = name;
                            div.append(span);
                        }
                        this._document.body.append(div);
                        isFontReady(loadTestFontId, ()=>{
                            div.remove();
                            request.complete();
                        });
                    }
                }
                exports.FontLoader = FontLoader;
                class FontFaceObject {
                    constructor(translatedData, { isEvalSupported = true, disableFontFace = false, ignoreErrors = false, inspectFont = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace;
                        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                        }
                        this._inspectFont?.(this);
                        return nativeFontFace;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data = (0, _util.bytesToString)(this.data);
                        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
                        let rule;
                        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
                        else {
                            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
                        }
                        this._inspectFont?.(this, url);
                        return rule;
                    }
                    getPathGenerator(objs, character) {
                        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                        let cmds;
                        try {
                            cmds = objs.get(this.loadedName + "_path_" + character);
                        } catch (ex) {
                            if (!this.ignoreErrors) throw ex;
                            (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                            return this.compiledGlyphs[character] = function(c, size) {};
                        }
                        if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const jsBuf = [];
                            for (const current of cmds){
                                const args = current.args !== undefined ? current.args.join(",") : "";
                                jsBuf.push("c.", current.cmd, "(", args, ");\n");
                            }
                            return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                        }
                        return this.compiledGlyphs[character] = function(c, size) {
                            for (const current of cmds){
                                if (current.cmd === "scale") current.args = [
                                    size,
                                    -size
                                ];
                                c[current.cmd].apply(c, current.args);
                            }
                        };
                    }
                }
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const fetchData = function(url) {
                    return new Promise((resolve, reject)=>{
                        const fs = (parcelRequire("9zn7p"));
                        fs.readFile(url, (error, data)=>{
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                class NodeFilterFactory extends _base_factory.BaseFilterFactory {
                }
                exports.NodeFilterFactory = NodeFilterFactory;
                class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const Canvas = (parcelRequire("9zn7p"));
                        return Canvas.createCanvas(width, height);
                    }
                }
                exports.NodeCanvasFactory = NodeCanvasFactory;
                class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url);
                    }
                }
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                const MIN_FONT_SIZE = 16;
                const MAX_FONT_SIZE = 100;
                const MAX_GROUP_SIZE = 4096;
                const EXECUTION_TIME = 15;
                const EXECUTION_STEPS = 10;
                const MAX_SIZE_TO_COMPILE = 1000;
                const FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = ()=>{
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases {
                    constructor(canvasFactory){
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id, width, height) {
                        let canvasEntry;
                        if (this.cache[id] !== undefined) {
                            canvasEntry = this.cache[id];
                            this.canvasFactory.reset(canvasEntry, width, height);
                        } else {
                            canvasEntry = this.canvasFactory.create(width, height);
                            this.cache[id] = canvasEntry;
                        }
                        return canvasEntry;
                    }
                    delete(id) {
                        delete this.cache[id];
                    }
                    clear() {
                        for(const id in this.cache){
                            const canvasEntry = this.cache[id];
                            this.canvasFactory.destroy(canvasEntry);
                            delete this.cache[id];
                        }
                    }
                }
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
                    if (b === 0 && c === 0) {
                        const tlX = destX * a + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destY * d + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destX + destW) * a + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destY + destH) * d + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        const tlX = destY * c + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destX * b + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destY + destH) * c + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destX + destW) * b + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight,
                            rWidth
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    const scaleX = Math.hypot(a, b);
                    const scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    const { width, height } = imgData;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    const POINT_TO_PROCESS_LIMIT = 1000;
                    const POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width1 = width + 1;
                    let points = new Uint8Array(width1 * (height + 1));
                    let i, j, j0;
                    const lineSize = width + 7 & -8;
                    let data = new Uint8Array(lineSize * height), pos = 0;
                    for (const elem of imgData.data){
                        let mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    let count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    const steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        let p = i * width1;
                        const end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        const p0 = p;
                        let type = points[p];
                        do {
                            const step = steps[type];
                            do p += step;
                            while (!points[p]);
                            const pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    const drawOutline = function(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                class CanvasExtraState {
                    constructor(width, height){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.clipBox = this.clipBox.slice();
                        return clone;
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    updatePathMinMax(transform, x, y) {
                        [x, y] = _util.Util.applyTransform([
                            x,
                            y
                        ], transform);
                        this.minX = Math.min(this.minX, x);
                        this.minY = Math.min(this.minY, y);
                        this.maxX = Math.max(this.maxX, x);
                        this.maxY = Math.max(this.maxY, y);
                    }
                    updateRectMinMax(transform, rect) {
                        const p1 = _util.Util.applyTransform(rect, transform);
                        const p2 = _util.Util.applyTransform(rect.slice(2), transform);
                        this.minX = Math.min(this.minX, p1[0], p2[0]);
                        this.minY = Math.min(this.minY, p1[1], p2[1]);
                        this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                        this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                    }
                    updateScalingPathMinMax(transform, minMax) {
                        _util.Util.scaleMinMax(transform, minMax);
                        this.minX = Math.min(this.minX, minMax[0]);
                        this.maxX = Math.max(this.maxX, minMax[1]);
                        this.minY = Math.min(this.minY, minMax[2]);
                        this.maxY = Math.max(this.maxY, minMax[3]);
                    }
                    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                        const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                        if (minMax) {
                            minMax[0] = Math.min(minMax[0], box[0], box[2]);
                            minMax[1] = Math.max(minMax[1], box[0], box[2]);
                            minMax[2] = Math.min(minMax[2], box[1], box[3]);
                            minMax[3] = Math.max(minMax[3], box[1], box[3]);
                            return;
                        }
                        this.updateRectMinMax(transform, box);
                    }
                    getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        const box = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType === _pattern_helper.PathType.STROKE) {
                            if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                            const scale = _util.Util.singularValueDecompose2dScale(transform);
                            const xStrokePad = scale[0] * this.lineWidth / 2;
                            const yStrokePad = scale[1] * this.lineWidth / 2;
                            box[0] -= xStrokePad;
                            box[1] -= yStrokePad;
                            box[2] += xStrokePad;
                            box[3] += yStrokePad;
                        }
                        return box;
                    }
                    updateClipFromPath() {
                        const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box) {
                        this.clipBox = box;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                    }
                }
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0, destPos;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    let i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength = src.byteLength;
                        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        const dest32DataLength = dest32.length;
                        const fullSrcDiff = width + 7 >> 3;
                        const white = 0xffffffff;
                        const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                const srcDiff = srcLength - srcPos;
                                let k = 0;
                                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                const kEndUnrolled = kEnd & -8;
                                let mask = 0;
                                let srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error(`bad image kind: ${imgData.kind}`);
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    for(let i = 0; i < totalChunks; i++){
                        const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        ({ srcPos } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }));
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    const properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        const { filter } = ctx;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    const length = bytes.length;
                    for(let i = 3; i < length; i += 4){
                        const alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            const alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    const scale = 1 / 255;
                    for(let i = 3; i < length; i += 4){
                        const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    for(let i = 3; i < length; i += 4){
                        const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    const hasBackdrop = !!backdrop;
                    const r0 = hasBackdrop ? backdrop[0] : 0;
                    const g0 = hasBackdrop ? backdrop[1] : 0;
                    const b0 = hasBackdrop ? backdrop[2] : 0;
                    const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    const PIXELS_TO_PROCESS = 1048576;
                    const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(let row = 0; row < height; row += chunkSize){
                        const chunkHeight = Math.min(chunkSize, height - row);
                        const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    const layerOffsetX = layerBox[0];
                    const layerOffsetY = layerBox[1];
                    const layerWidth = layerBox[2] - layerOffsetX;
                    const layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    const scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP = {};
                const EO_CLIP = {};
                class CanvasGraphics {
                    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig, markedContentStack = null }, annotationCanvasMap, pageColors){
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    beginDrawing({ transform, viewport, transparency = false, background = null }) {
                        const width = this.ctx.canvas.width;
                        const height = this.ctx.canvas.height;
                        const savedFillStyle = this.ctx.fillStyle;
                        this.ctx.fillStyle = background || "#ffffff";
                        this.ctx.fillRect(0, 0, width, height);
                        this.ctx.fillStyle = savedFillStyle;
                        if (transparency) {
                            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas.canvas;
                            this.ctx = transparentCanvas.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault(this.ctx);
                        if (transform) {
                            this.ctx.transform(...transform);
                            this.outputScaleX = transform[0];
                            this.outputScaleY = transform[0];
                        }
                        this.ctx.transform(...viewport.transform);
                        this.viewportScale = viewport.scale;
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        let i = executionStartIdx || 0;
                        const argsArrayLen = argsArray.length;
                        if (argsArrayLen === i) return i;
                        const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                        const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                        let steps = 0;
                        const commonObjs = this.commonObjs;
                        const objs = this.objs;
                        let fnId;
                        while(true){
                            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                stepper.breakIt(i, continueCallback);
                                return i;
                            }
                            fnId = fnArray[i];
                            if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                            else for (const depObjId of argsArray[i]){
                                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                if (!objsPool.has(depObjId)) {
                                    objsPool.get(depObjId, continueCallback);
                                    return i;
                                }
                            }
                            i++;
                            if (i === argsArrayLen) return i;
                            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                if (Date.now() > endTime) {
                                    continueCallback();
                                    return i;
                                }
                                steps = 0;
                            }
                        }
                    }
                    #restoreInitialState() {
                        while(this.stateStack.length || this.inSMaskMode)this.restore();
                        this.ctx.restore();
                        if (this.transparentCanvas) {
                            this.ctx = this.compositeCtx;
                            this.ctx.save();
                            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                            this.ctx.drawImage(this.transparentCanvas, 0, 0);
                            this.ctx.restore();
                            this.transparentCanvas = null;
                        }
                    }
                    endDrawing() {
                        this.#restoreInitialState();
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache of this._cachedBitmapsMap.values()){
                            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                            cache.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        this.#drawFilter();
                    }
                    #drawFilter() {
                        if (this.pageColors) {
                            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                            if (hcmFilterId !== "none") {
                                const savedFilter = this.ctx.filter;
                                this.ctx.filter = hcmFilterId;
                                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                this.ctx.filter = savedFilter;
                            }
                        }
                    }
                    _scaleImage(img, inverseTransform) {
                        const width = img.width;
                        const height = img.height;
                        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                        let paintWidth = width, paintHeight = height;
                        let tmpCanvasId = "prescale1";
                        let tmpCanvas, tmpCtx;
                        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                            let newWidth = paintWidth, newHeight = paintHeight;
                            if (widthScale > 2 && paintWidth > 1) {
                                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                widthScale /= paintWidth / newWidth;
                            }
                            if (heightScale > 2 && paintHeight > 1) {
                                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                heightScale /= paintHeight / newHeight;
                            }
                            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                            tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, newWidth, newHeight);
                            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                            img = tmpCanvas.canvas;
                            paintWidth = newWidth;
                            paintHeight = newHeight;
                            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img,
                            paintWidth: paintWidth,
                            paintHeight: paintHeight
                        };
                    }
                    _createMaskCanvas(img) {
                        const ctx = this.ctx;
                        const { width, height } = img;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        let cache, cacheKey, scaled, maskCanvas;
                        if ((img.bitmap || img.data) && img.count > 1) {
                            const mainKey = img.bitmap || img.data.buffer;
                            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                currentTransform.slice(0, 4),
                                fillColor
                            ]);
                            cache = this._cachedBitmapsMap.get(mainKey);
                            if (!cache) {
                                cache = new Map();
                                this._cachedBitmapsMap.set(mainKey, cache);
                            }
                            const cachedImage = cache.get(cacheKey);
                            if (cachedImage && !isPatternFill) {
                                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                return {
                                    canvas: cachedImage,
                                    offsetX: offsetX,
                                    offsetY: offsetY
                                };
                            }
                            scaled = cachedImage;
                        }
                        if (!scaled) {
                            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            putBinaryImageMask(maskCanvas.context, img);
                        }
                        let maskToCanvas = _util.Util.transform(currentTransform, [
                            1 / width,
                            0,
                            0,
                            -1 / height,
                            0,
                            0
                        ]);
                        maskToCanvas = _util.Util.transform(maskToCanvas, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height
                        ]);
                        const cord1 = _util.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas);
                        const cord2 = _util.Util.applyTransform([
                            width,
                            height
                        ], maskToCanvas);
                        const rect = _util.Util.normalizeRect([
                            cord1[0],
                            cord1[1],
                            cord2[0],
                            cord2[1]
                        ]);
                        const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                        const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                        const fillCtx = fillCanvas.context;
                        const offsetX = Math.min(cord1[0], cord2[0]);
                        const offsetY = Math.min(cord1[1], cord2[1]);
                        fillCtx.translate(-offsetX, -offsetY);
                        fillCtx.transform(...maskToCanvas);
                        if (!scaled) {
                            scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                            scaled = scaled.img;
                            if (cache && isPatternFill) cache.set(cacheKey, scaled);
                        }
                        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                        fillCtx.globalCompositeOperation = "source-in";
                        const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX,
                            -offsetY
                        ]);
                        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                        fillCtx.fillRect(0, 0, width, height);
                        if (cache && !isPatternFill) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache.set(cacheKey, fillCanvas.canvas);
                        }
                        return {
                            canvas: fillCanvas.canvas,
                            offsetX: Math.round(offsetX),
                            offsetY: Math.round(offsetY)
                        };
                    }
                    setLineWidth(width) {
                        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width;
                        this.ctx.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.ctx.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.ctx.miterLimit = limit;
                    }
                    setDash(dashArray, dashPhase) {
                        const ctx = this.ctx;
                        if (ctx.setLineDash !== undefined) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashPhase;
                        }
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value[0], value[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value;
                                break;
                            case "ca":
                                this.current.fillAlpha = value;
                                this.ctx.globalAlpha = value;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value;
                                break;
                            case "SMask":
                                this.current.activeSMask = value ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth = this.ctx.canvas.width;
                        const drawnHeight = this.ctx.canvas.height;
                        const cacheId = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas.context;
                        const ctx = this.ctx;
                        ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState(this.suspendedCtx, ctx);
                        mirrorContextOperations(ctx, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox) dirtyBox = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox[0] = Math.floor(dirtyBox[0]);
                            dirtyBox[1] = Math.floor(dirtyBox[1]);
                            dirtyBox[2] = Math.ceil(dirtyBox[2]);
                            dirtyBox[3] = Math.ceil(dirtyBox[3]);
                        }
                        const smask = this.current.activeSMask;
                        const suspendedCtx = this.suspendedCtx;
                        composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old = this.current;
                        this.stateStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a, b, c, d, e, f) {
                        this.ctx.transform(a, b, c, d, e, f);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops, args, minMax) {
                        const ctx = this.ctx;
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let startX, startY;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                ctx.moveTo(x, y);
                                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                else {
                                    ctx.lineTo(xw, y);
                                    ctx.lineTo(xw, yh);
                                    ctx.lineTo(x, yh);
                                }
                                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                    x,
                                    y,
                                    xw,
                                    yh
                                ]);
                                ctx.closePath();
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.moveTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.lineTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.curveTo:
                                startX = x;
                                startY = y;
                                x = args[j + 4];
                                y = args[j + 5];
                                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                startX = x;
                                startY = y;
                                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                startX = x;
                                startY = y;
                                x = args[j + 2];
                                y = args[j + 3];
                                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                ctx.closePath();
                                break;
                        }
                        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                        current.setCurrentPoint(x, y);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath = true) {
                        const ctx = this.ctx;
                        const strokeColor = this.current.strokeColor;
                        ctx.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                                ctx.save();
                                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath = true) {
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        let needRestore = false;
                        if (isPatternFill) {
                            ctx.save();
                            ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            needRestore = true;
                        }
                        const intersect = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect !== null) {
                            if (this.pendingEOFill) {
                                ctx.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx.fill();
                        }
                        if (needRestore) ctx.restore();
                        if (consumePath) this.consumePath(intersect);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP;
                    }
                    beginText() {
                        this.current.textMatrix = _util.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths = this.pendingTextPaths;
                        const ctx = this.ctx;
                        if (paths === undefined) {
                            ctx.beginPath();
                            return;
                        }
                        ctx.save();
                        ctx.beginPath();
                        for (const path of paths){
                            ctx.setTransform(...path.transform);
                            ctx.translate(path.x, path.y);
                            path.addToPath(ctx, path.fontSize);
                        }
                        ctx.restore();
                        ctx.clip();
                        ctx.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing) {
                        this.current.charSpacing = spacing;
                    }
                    setWordSpacing(spacing) {
                        this.current.wordSpacing = spacing;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setFont(fontRefName, size) {
                        const fontObj = this.commonObjs.get(fontRefName);
                        const current = this.current;
                        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        this.current.font = fontObj;
                        this.current.fontSize = size;
                        if (fontObj.isType3Font) return;
                        const name = fontObj.loadedName || "sans-serif";
                        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        let browserFontSize = size;
                        if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                        else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                        this.current.fontSizeScale = size / browserFontSize;
                        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                    }
                    setTextRenderingMode(mode) {
                        this.current.textRenderingMode = mode;
                    }
                    setTextRise(rise) {
                        this.current.textRise = rise;
                    }
                    moveText(x, y) {
                        this.current.x = this.current.lineX += x;
                        this.current.y = this.current.lineY += y;
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        this.current.textMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.current.textMatrixScale = Math.hypot(a, b);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character, x, y, patternTransform) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const textRenderingMode = current.textRenderingMode;
                        const fontSize = current.fontSize / current.fontSizeScale;
                        const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill = current.patternFill && !font.missingFile;
                        let addToPath;
                        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                        if (font.disableFontFace || patternFill) {
                            ctx.save();
                            ctx.translate(x, y);
                            ctx.beginPath();
                            addToPath(ctx, fontSize);
                            if (patternTransform) ctx.setTransform(...patternTransform);
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                            ctx.restore();
                        } else {
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                        }
                        if (isAddToPathSet) {
                            const paths = this.pendingTextPaths ||= [];
                            paths.push({
                                transform: (0, _display_utils.getCurrentTransform)(ctx),
                                x: x,
                                y: y,
                                fontSize: fontSize,
                                addToPath: addToPath
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx.scale(1.5, 1);
                        ctx.fillText("I", 0, 10);
                        const data = ctx.getImageData(0, 0, 10, 10).data;
                        let enabled = false;
                        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                            enabled = true;
                            break;
                        }
                        return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        if (font.isType3Font) return this.showType3Text(glyphs);
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return undefined;
                        const ctx = this.ctx;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const glyphsLength = glyphs.length;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y + current.textRise);
                        if (fontDirection > 0) ctx.scale(textHScale, -1);
                        else ctx.scale(textHScale, 1);
                        let patternTransform;
                        if (current.patternFill) {
                            ctx.save();
                            const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                            ctx.restore();
                            ctx.fillStyle = pattern;
                        }
                        let lineWidth = current.lineWidth;
                        const scale = current.textMatrixScale;
                        if (scale === 0 || lineWidth === 0) {
                            const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                        } else lineWidth /= scale;
                        if (fontSizeScale !== 1.0) {
                            ctx.scale(fontSizeScale, fontSizeScale);
                            lineWidth /= fontSizeScale;
                        }
                        ctx.lineWidth = lineWidth;
                        if (font.isInvalidPDFjsFont) {
                            const chars = [];
                            let width = 0;
                            for (const glyph of glyphs){
                                chars.push(glyph.unicode);
                                width += glyph.width;
                            }
                            ctx.fillText(chars.join(""), 0, 0);
                            current.x += width * widthAdvanceScale * textHScale;
                            ctx.restore();
                            this.compose();
                            return undefined;
                        }
                        let x = 0, i;
                        for(i = 0; i < glyphsLength; ++i){
                            const glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            let restoreNeeded = false;
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            const accent = glyph.accent;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (font.remeasure && width > 0) {
                                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX = width / measuredWidth;
                                    restoreNeeded = true;
                                    ctx.save();
                                    ctx.scale(characterScaleX, 1);
                                    scaledX /= characterScaleX;
                                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                            }
                            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                else {
                                    this.paintChar(character, scaledX, scaledY, patternTransform);
                                    if (accent) {
                                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                    }
                                }
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                            if (restoreNeeded) ctx.restore();
                        }
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        ctx.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        const fontDirection = current.fontDirection;
                        const spacingDir = font.vertical ? 1 : -1;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const textHScale = current.textHScale * fontDirection;
                        const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        const glyphsLength = glyphs.length;
                        const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                        let i, glyph, width, spacingLength;
                        if (isTextInvisible || fontSize === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y);
                        ctx.scale(textHScale, fontDirection);
                        for(i = 0; i < glyphsLength; ++i){
                            glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                spacingLength = spacingDir * glyph * fontSize / 1000;
                                this.ctx.translate(spacingLength, 0);
                                current.x += spacingLength * textHScale;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const operatorList = font.charProcOperatorList[glyph.operatorListId];
                            if (!operatorList) {
                                (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph;
                                this.save();
                                ctx.scale(fontSize, fontSize);
                                ctx.transform(...fontMatrix);
                                this.executeOperatorList(operatorList);
                                this.restore();
                            }
                            const transformed = _util.Util.applyTransform([
                                glyph.width,
                                0
                            ], fontMatrix);
                            width = transformed[0] * fontSize + spacing;
                            ctx.translate(width, 0);
                            current.x += width * textHScale;
                        }
                        ctx.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth, yWidth) {}
                    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                        this.ctx.rect(llx, lly, urx - llx, ury - lly);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR) {
                        let pattern;
                        if (IR[0] === "TilingPattern") {
                            const color = IR[1];
                            const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory = {
                                createCanvasGraphics: (ctx)=>{
                                    return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                        } else pattern = this._getPattern(IR[1], IR[2]);
                        return pattern;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.strokeStyle = color;
                        this.current.strokeColor = color;
                    }
                    setFillRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.fillStyle = color;
                        this.current.fillColor = color;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId, matrix = null) {
                        let pattern;
                        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                        else {
                            pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                            this.cachedPatterns.set(objId, pattern);
                        }
                        if (matrix) pattern.matrix = matrix;
                        return pattern;
                    }
                    shadingFill(objId) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        this.save();
                        const pattern = this._getPattern(objId);
                        ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                        const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                        if (inv) {
                            const { width, height } = ctx.canvas;
                            const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width,
                                height
                            ], inv);
                            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(...matrix);
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            this.ctx.rect(bbox[0], bbox[1], width, height);
                            this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx = this.ctx;
                        if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                        if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                        const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                        if (group.matrix) currentCtx.transform(...group.matrix);
                        if (!group.bbox) throw new Error("Bounding box is required.");
                        let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                        const canvasBounds = [
                            0,
                            0,
                            currentCtx.canvas.width,
                            currentCtx.canvas.height
                        ];
                        bounds = _util.Util.intersect(bounds, canvasBounds) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX = Math.floor(bounds[0]);
                        const offsetY = Math.floor(bounds[1]);
                        let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                        let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                        let scaleX = 1, scaleY = 1;
                        if (drawnWidth > MAX_GROUP_SIZE) {
                            scaleX = drawnWidth / MAX_GROUP_SIZE;
                            drawnWidth = MAX_GROUP_SIZE;
                        }
                        if (drawnHeight > MAX_GROUP_SIZE) {
                            scaleY = drawnHeight / MAX_GROUP_SIZE;
                            drawnHeight = MAX_GROUP_SIZE;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth,
                            drawnHeight
                        ]);
                        let cacheId = "groupAt" + this.groupLevel;
                        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        const groupCtx = scratchCanvas.context;
                        groupCtx.scale(1 / scaleX, 1 / scaleY);
                        groupCtx.translate(-offsetX, -offsetY);
                        groupCtx.transform(...currentTransform);
                        if (group.smask) this.smaskStack.push({
                            canvas: scratchCanvas.canvas,
                            context: groupCtx,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            scaleX: scaleX,
                            scaleY: scaleY,
                            subtype: group.smask.subtype,
                            backdrop: group.smask.backdrop,
                            transferMap: group.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx.translate(offsetX, offsetY);
                            currentCtx.scale(scaleX, scaleY);
                            currentCtx.save();
                        }
                        copyCtxState(currentCtx, groupCtx);
                        this.ctx = groupCtx;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx);
                        this.groupLevel++;
                    }
                    endGroup(group) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx = this.ctx;
                        const ctx = this.groupStack.pop();
                        this.ctx = ctx;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx);
                            const dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx.canvas.width,
                                groupCtx.canvas.height
                            ], currentMtx);
                            this.ctx.drawImage(groupCtx.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox);
                        }
                    }
                    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                        this.#restoreInitialState();
                        resetCtxToDefault(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect) && rect.length === 4) {
                            const width = rect[2] - rect[0];
                            const height = rect[3] - rect[1];
                            if (hasOwnCanvas && this.annotationCanvasMap) {
                                transform = transform.slice();
                                transform[4] -= rect[0];
                                transform[5] -= rect[1];
                                rect = rect.slice();
                                rect[0] = rect[1] = 0;
                                rect[2] = width;
                                rect[3] = height;
                                const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
                                const { viewportScale } = this;
                                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                const { canvas, context } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id, canvas);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                resetCtxToDefault(this.ctx);
                            } else {
                                resetCtxToDefault(this.ctx);
                                this.ctx.rect(rect[0], rect[1], width, height);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform);
                        this.transform(...matrix);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            this.#drawFilter();
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img) {
                        if (!this.contentVisible) return;
                        const count = img.count;
                        img = this.getObject(img.data, img);
                        img.count = count;
                        const ctx = this.ctx;
                        const glyph = this.processingType3;
                        if (glyph) {
                            if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                            if (glyph.compiled) {
                                glyph.compiled(ctx);
                                return;
                            }
                        }
                        const mask = this._createMaskCanvas(img);
                        const maskCanvas = mask.canvas;
                        ctx.save();
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                        if (!this.contentVisible) return;
                        img = this.getObject(img.data, img);
                        const ctx = this.ctx;
                        ctx.save();
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                        const mask = this._createMaskCanvas(img);
                        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                        for(let i = 0, ii = positions.length; i < ii; i += 2){
                            const trans = _util.Util.transform(currentTransform, [
                                scaleX,
                                skewX,
                                skewY,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ]);
                            const [x, y] = _util.Util.applyTransform([
                                0,
                                0
                            ], trans);
                            ctx.drawImage(mask.canvas, x, y);
                        }
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        for (const image of images){
                            const { data, width, height, transform } = image;
                            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            const maskCtx = maskCanvas.context;
                            maskCtx.save();
                            const img = this.getObject(data, image);
                            putBinaryImageMask(maskCtx, img);
                            maskCtx.globalCompositeOperation = "source-in";
                            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                            maskCtx.fillRect(0, 0, width, height);
                            maskCtx.restore();
                            ctx.save();
                            ctx.transform(...transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width = imgData.width;
                        const height = imgData.height;
                        const map = [];
                        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
                            transform: [
                                scaleX,
                                0,
                                0,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width,
                            h: height
                        });
                        this.paintInlineImageXObjectGroup(imgData, map);
                    }
                    applyTransferMapsToCanvas(ctx) {
                        if (this.current.transferMaps !== "none") {
                            ctx.filter = this.current.transferMaps;
                            ctx.drawImage(ctx.canvas, 0, 0);
                            ctx.filter = "none";
                        }
                        return ctx.canvas;
                    }
                    applyTransferMapsToBitmap(imgData) {
                        if (this.current.transferMaps === "none") return imgData.bitmap;
                        const { bitmap, width, height } = imgData;
                        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                        const tmpCtx = tmpCanvas.context;
                        tmpCtx.filter = this.current.transferMaps;
                        tmpCtx.drawImage(bitmap, 0, 0);
                        tmpCtx.filter = "none";
                        return tmpCanvas.canvas;
                    }
                    paintInlineImageXObject(imgData) {
                        if (!this.contentVisible) return;
                        const width = imgData.width;
                        const height = imgData.height;
                        const ctx = this.ctx;
                        this.save();
                        if (!_util.isNodeJS) {
                            const { filter } = ctx;
                            if (filter !== "none" && filter !== "") ctx.filter = "none";
                        }
                        ctx.scale(1 / width, -1 / height);
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                        else {
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                        ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData, map) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = imgData.bitmap;
                        else {
                            const w = imgData.width;
                            const h = imgData.height;
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        for (const entry of map){
                            ctx.save();
                            ctx.transform(...entry.transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag) {}
                    markPointProps(tag, properties) {}
                    beginMarkedContent(tag) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag, properties) {
                        if (tag === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox) {
                        const isEmpty = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox);
                        const ctx = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty) {
                                if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                else ctx.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m = (0, _display_utils.getCurrentTransform)(this.ctx);
                            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                            else {
                                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                const normX = Math.hypot(m[0], m[2]);
                                const normY = Math.hypot(m[1], m[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth } = this.current;
                            const { a, b, c, d } = this.ctx.getTransform();
                            let scaleX, scaleY;
                            if (b === 0 && c === 0) {
                                const normX = Math.abs(a);
                                const normY = Math.abs(d);
                                if (normX === normY) {
                                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                    else {
                                        const scaledLineWidth = normX * lineWidth;
                                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                    }
                                } else if (lineWidth === 0) {
                                    scaleX = 1 / normX;
                                    scaleY = 1 / normY;
                                } else {
                                    const scaledXLineWidth = normX * lineWidth;
                                    const scaledYLineWidth = normY * lineWidth;
                                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                }
                            } else {
                                const absDet = Math.abs(a * d - b * c);
                                const normX = Math.hypot(a, b);
                                const normY = Math.hypot(c, d);
                                if (lineWidth === 0) {
                                    scaleX = normY / absDet;
                                    scaleY = normX / absDet;
                                } else {
                                    const baseArea = lineWidth * absDet;
                                    scaleX = normY > baseArea ? normY / baseArea : 1;
                                    scaleY = normX > baseArea ? normX / baseArea : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX;
                            this._cachedScaleForStroking[1] = scaleY;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore) {
                        const { ctx } = this;
                        const { lineWidth } = this.current;
                        const [scaleX, scaleY] = this.getScaleForStroking();
                        ctx.lineWidth = lineWidth || 1;
                        if (scaleX === 1 && scaleY === 1) {
                            ctx.stroke();
                            return;
                        }
                        const dashes = ctx.getLineDash();
                        if (saveRestore) ctx.save();
                        ctx.scale(scaleX, scaleY);
                        if (dashes.length > 0) {
                            const scale = Math.max(scaleX, scaleY);
                            ctx.setLineDash(dashes.map((x)=>x / scale));
                            ctx.lineDashOffset /= scale;
                        }
                        ctx.stroke();
                        if (saveRestore) ctx.restore();
                    }
                    isContentVisible() {
                        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
                            if (!this.markedContentStack[i].visible) return false;
                        }
                        return true;
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(const op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                class BaseShadingPattern {
                    constructor(){
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._type = IR[1];
                        this._bbox = IR[2];
                        this._colorStops = IR[3];
                        this._p0 = IR[4];
                        this._p1 = IR[5];
                        this._r0 = IR[6];
                        this._r1 = IR[7];
                        this.matrix = null;
                    }
                    _createGradient(ctx) {
                        let grad;
                        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
                        return grad;
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let pattern;
                        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                            const tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.beginPath();
                            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                            inverse = _util.Util.transform(inverse, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox[0],
                                ownerBBox[1]
                            ]);
                            tmpCtx.transform(...owner.baseTransform);
                            if (this.matrix) tmpCtx.transform(...this.matrix);
                            applyBoundingBox(tmpCtx, this._bbox);
                            tmpCtx.fillStyle = this._createGradient(tmpCtx);
                            tmpCtx.fill();
                            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                            const domMatrix = new DOMMatrix(inverse);
                            pattern.setTransform(domMatrix);
                        } else {
                            applyBoundingBox(ctx, this._bbox);
                            pattern = this._createGradient(ctx);
                        }
                        return pattern;
                    }
                }
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    const coords = context.coords, colors = context.colors;
                    const bytes = data.data, rowSize = data.width * 4;
                    let tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    const minY = Math.round(y1), maxY = Math.round(y3);
                    let xa, car, cag, cab;
                    let xb, cbr, cbg, cbb;
                    for(let y = minY; y <= maxY; y++){
                        if (y < y2) {
                            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            let k;
                            if (y > y3) k = 1;
                            else if (y2 === y3) k = 0;
                            else k = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k;
                            car = c2r - (c2r - c3r) * k;
                            cag = c2g - (c2g - c3g) * k;
                            cab = c2b - (c2b - c3b) * k;
                        }
                        let k;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        const x1_ = Math.round(Math.min(xa, xb));
                        const x2_ = Math.round(Math.max(xa, xb));
                        let j = rowSize * y + x1_ * 4;
                        for(let x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    const ps = figure.coords;
                    const cs = figure.colors;
                    let i, ii;
                    switch(figure.type){
                        case "lattice":
                            const verticesPerRow = figure.verticesPerRow;
                            const rows = Math.floor(ps.length / verticesPerRow) - 1;
                            const cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                let q = i * verticesPerRow;
                                for(let j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._coords = IR[2];
                        this._colors = IR[3];
                        this._figures = IR[4];
                        this._bounds = IR[5];
                        this._bbox = IR[7];
                        this._background = IR[8];
                        this.matrix = null;
                    }
                    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                        const EXPECTED_SCALE = 1.1;
                        const MAX_PATTERN_SIZE = 3000;
                        const BORDER_SIZE = 2;
                        const offsetX = Math.floor(this._bounds[0]);
                        const offsetY = Math.floor(this._bounds[1]);
                        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const scaleX = boundsWidth / width;
                        const scaleY = boundsHeight / height;
                        const context = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX,
                            offsetY: -offsetY,
                            scaleX: 1 / scaleX,
                            scaleY: 1 / scaleY
                        };
                        const paddedWidth = width + BORDER_SIZE * 2;
                        const paddedHeight = height + BORDER_SIZE * 2;
                        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                        const tmpCtx = tmpCanvas.context;
                        const data = tmpCtx.createImageData(width, height);
                        if (backgroundColor) {
                            const bytes = data.data;
                            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                                bytes[i] = backgroundColor[0];
                                bytes[i + 1] = backgroundColor[1];
                                bytes[i + 2] = backgroundColor[2];
                                bytes[i + 3] = 255;
                            }
                        }
                        for (const figure of this._figures)drawFigure(data, figure, context);
                        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                        const canvas = tmpCanvas.canvas;
                        return {
                            canvas: canvas,
                            offsetX: offsetX - BORDER_SIZE * scaleX,
                            offsetY: offsetY - BORDER_SIZE * scaleY,
                            scaleX: scaleX,
                            scaleY: scaleY
                        };
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        applyBoundingBox(ctx, this._bbox);
                        let scale;
                        if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                        else {
                            scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                            if (this.matrix) {
                                const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                scale = [
                                    scale[0] * matrixScale[0],
                                    scale[1] * matrixScale[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                        if (pathType !== PathType.SHADING) {
                            ctx.setTransform(...owner.baseTransform);
                            if (this.matrix) ctx.transform(...this.matrix);
                        }
                        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern extends BaseShadingPattern {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error(`Unknown IR type: ${IR[0]}`);
                }
                const PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern {
                    static MAX_PATTERN_SIZE = 3000;
                    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    createPatternCanvas(owner) {
                        const operatorList = this.operatorList;
                        const bbox = this.bbox;
                        const xstep = this.xstep;
                        const ystep = this.ystep;
                        const paintType = this.paintType;
                        const tilingType = this.tilingType;
                        const color = this.color;
                        const canvasGraphicsFactory = this.canvasGraphicsFactory;
                        (0, _util.info)("TilingType: " + tilingType);
                        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale = [
                            matrixScale[0] * curMatrixScale[0],
                            matrixScale[1] * curMatrixScale[1]
                        ];
                        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                        const tmpCtx = tmpCanvas.context;
                        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                        graphics.groupLevel = owner.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                        let adjustedX0 = x0;
                        let adjustedY0 = y0;
                        let adjustedX1 = x1;
                        let adjustedY1 = y1;
                        if (x0 < 0) {
                            adjustedX0 = 0;
                            adjustedX1 += Math.abs(x0);
                        }
                        if (y0 < 0) {
                            adjustedY0 = 0;
                            adjustedY1 += Math.abs(y0);
                        }
                        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                        tmpCtx.save();
                        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                        graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                        graphics.executeOperatorList(operatorList);
                        graphics.endDrawing();
                        return {
                            canvas: tmpCanvas.canvas,
                            scaleX: dimx.scale,
                            scaleY: dimy.scale,
                            offsetX: adjustedX0,
                            offsetY: adjustedY0
                        };
                    }
                    getSizeAndScale(step, realOutputSize, scale) {
                        step = Math.abs(step);
                        const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                        let size = Math.ceil(step * scale);
                        if (size >= maxSize) size = maxSize;
                        else scale = size / step;
                        return {
                            scale: scale,
                            size: size
                        };
                    }
                    clipBbox(graphics, x0, y0, x1, y1) {
                        const bboxWidth = x1 - x0;
                        const bboxHeight = y1 - y0;
                        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                        graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                            x0,
                            y0,
                            x1,
                            y1
                        ]);
                        graphics.clip();
                        graphics.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics, paintType, color) {
                        const context = graphics.ctx, current = graphics.current;
                        switch(paintType){
                            case PaintType.COLORED:
                                const ctx = this.ctx;
                                context.fillStyle = ctx.fillStyle;
                                context.strokeStyle = ctx.strokeStyle;
                                current.fillColor = ctx.fillStyle;
                                current.strokeColor = ctx.strokeStyle;
                                break;
                            case PaintType.UNCOLORED:
                                const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                context.fillStyle = cssColor;
                                context.strokeStyle = cssColor;
                                current.fillColor = cssColor;
                                current.strokeColor = cssColor;
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
                        }
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let matrix = inverse;
                        if (pathType !== PathType.SHADING) {
                            matrix = _util.Util.transform(matrix, owner.baseTransform);
                            if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                        }
                        const temporaryPatternCanvas = this.createPatternCanvas(owner);
                        let domMatrix = new DOMMatrix(matrix);
                        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                        pattern.setTransform(domMatrix);
                        return pattern;
                    }
                }
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src, srcPos = 0, dest, width, height, nonBlackColor = 0xffffffff, inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src, srcPos = 0, dest, destPos = 0, width, height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                class Metadata {
                    #metadataMap;
                    #data;
                    constructor({ parsedData, rawData }){
                        this.#metadataMap = parsedData;
                        this.#data = rawData;
                    }
                    getRaw() {
                        return this.#data;
                    }
                    get(name) {
                        return this.#metadataMap.get(name) ?? null;
                    }
                    getAll() {
                        return (0, _util.objectFromMap)(this.#metadataMap);
                    }
                    has(name) {
                        return this.#metadataMap.has(name);
                    }
                }
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                const INTERNAL = Symbol("INTERNAL");
                class OptionalContentGroup {
                    #visible = true;
                    constructor(name, intent){
                        this.name = name;
                        this.intent = intent;
                    }
                    get visible() {
                        return this.#visible;
                    }
                    _setVisible(internal, visible) {
                        if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                        this.#visible = visible;
                    }
                }
                class OptionalContentConfig {
                    #cachedGetHash = null;
                    #groups = new Map();
                    #initialHash = null;
                    #order = null;
                    constructor(data){
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this.#order = data.order;
                        for (const group of data.groups)this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
                        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible(INTERNAL, false);
                        for (const on of data.on)this.#groups.get(on)._setVisible(INTERNAL, true);
                        for (const off of data.off)this.#groups.get(off)._setVisible(INTERNAL, false);
                        this.#initialHash = this.getHash();
                    }
                    #evaluateVisibilityExpression(array) {
                        const length = array.length;
                        if (length < 2) return true;
                        const operator = array[0];
                        for(let i = 1; i < length; i++){
                            const element = array[i];
                            let state;
                            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
                            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
                            else {
                                (0, _util.warn)(`Optional content group not found: ${element}`);
                                return true;
                            }
                            switch(operator){
                                case "And":
                                    if (!state) return false;
                                    break;
                                case "Or":
                                    if (state) return true;
                                    break;
                                case "Not":
                                    return !state;
                                default:
                                    return true;
                            }
                        }
                        return operator === "And";
                    }
                    isVisible(group) {
                        if (this.#groups.size === 0) return true;
                        if (!group) {
                            (0, _util.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group.type === "OCG") {
                            if (!this.#groups.has(group.id)) {
                                (0, _util.warn)(`Optional content group not found: ${group.id}`);
                                return true;
                            }
                            return this.#groups.get(group.id).visible;
                        } else if (group.type === "OCMD") {
                            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
                            if (!group.policy || group.policy === "AnyOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return false;
                                }
                                return true;
                            } else if (group.policy === "AnyOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return false;
                                }
                                return true;
                            }
                            (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
                            return true;
                        }
                        (0, _util.warn)(`Unknown group type ${group.type}.`);
                        return true;
                    }
                    setVisibility(id, visible = true) {
                        if (!this.#groups.has(id)) {
                            (0, _util.warn)(`Optional content group not found: ${id}`);
                            return;
                        }
                        this.#groups.get(id)._setVisible(INTERNAL, !!visible);
                        this.#cachedGetHash = null;
                    }
                    get hasInitialVisibility() {
                        return this.#initialHash === null || this.getHash() === this.#initialHash;
                    }
                    getOrder() {
                        if (!this.#groups.size) return null;
                        if (this.#order) return this.#order.slice();
                        return [
                            ...this.#groups.keys()
                        ];
                    }
                    getGroups() {
                        return this.#groups.size > 0 ? (0, _util.objectFromMap)(this.#groups) : null;
                    }
                    getGroup(id) {
                        return this.#groups.get(id) || null;
                    }
                    getHash() {
                        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
                        const hash = new _murmurhash.MurmurHash3_64();
                        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
                        return this.#cachedGetHash = hash.hexdigest();
                    }
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class PDFDataTransportStream {
                    constructor({ length, initialData, progressiveDone = false, contentDispositionFilename = null, disableRange = false, disableStream = false }, pdfDataRangeTransport){
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if (initialData?.length > 0) {
                            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
                            this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded, total)=>{
                            this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
                            this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData({ begin, chunk }) {
                        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                        if (begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                            else this._queuedChunks.push(buffer);
                        } else {
                            const found = this._rangeReaders.some(function(rangeReader) {
                                if (rangeReader._begin !== begin) return false;
                                rangeReader._enqueue(buffer);
                                return true;
                            });
                            (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt) {
                        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
                            loaded: evt.loaded
                        });
                        else this._fullRequestReader?.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    }
                    _onProgressiveDone() {
                        this._fullRequestReader?.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader) {
                        const i = this._rangeReaders.indexOf(reader);
                        if (i >= 0) this._rangeReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                        this._pdfDataRangeTransport.requestDataRange(begin, end);
                        this._rangeReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports.PDFDataTransportStream = PDFDataTransportStream;
                class PDFDataTransportStreamReader {
                    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk);
                        this._loaded += chunk.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk = this._queuedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk;
                        else {
                            const requestsCapability = this._requests.shift();
                            requestsCapability.resolve({
                                value: chunk,
                                done: false
                            });
                            for (const requestCapability of this._requests)requestCapability.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    const headers = new Headers();
                    for(const property in httpHeaders){
                        const value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                    return new Uint8Array(val).buffer;
                }
                class PDFFetchStream {
                    constructor(source){
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFFetchStreamRangeReader(this, begin, end);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFFetchStream = PDFFetchStream;
                class PDFFetchStreamReader {
                    constructor(stream){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._reader = response.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader = (name)=>{
                                return response.headers.get(name);
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._readCapability.resolve();
                            this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities({ getResponseHeader, isHttp, rangeChunkSize, disableRange }) {
                    const returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    const contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch  {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    let needsEncodingFixup = true;
                    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        const filename = rfc2047decode(tmp);
                        return fixupEncoding(filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                const decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                const buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch  {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        const matches = [];
                        let match;
                        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            let [, n, quot, part] = match;
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        const parts = [];
                        for(let n = 0; n < matches.length; ++n){
                            if (!(n in matches)) break;
                            let [quot, part] = matches[n];
                            part = rfc2616unquote(part);
                            if (quot) {
                                part = unescape(part);
                                if (n === 0) part = rfc5987decode(part);
                            }
                            parts.push(part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            const parts = value.slice(1).split('\\"');
                            for(let i = 0; i < parts.length; ++i){
                                const quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        const encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        const encoding = extvalue.slice(0, encodingend);
                        const langvalue = extvalue.slice(encodingend + 1);
                        const value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch  {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const OK_RESPONSE = 200;
                const PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    const data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                class NetworkManager {
                    constructor(url, args = {}){
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin, end, listeners) {
                        const args = {
                            begin: begin,
                            end: end
                        };
                        for(const prop in listeners)args[prop] = listeners[prop];
                        return this.request(args);
                    }
                    requestFull(listeners) {
                        return this.request(listeners);
                    }
                    request(args) {
                        const xhr = new XMLHttpRequest();
                        const xhrId = this.currXhrId++;
                        const pendingRequest = this.pendingRequests[xhrId] = {
                            xhr: xhr
                        };
                        xhr.open("GET", this.url);
                        xhr.withCredentials = this.withCredentials;
                        for(const property in this.httpHeaders){
                            const value = this.httpHeaders[property];
                            if (value === undefined) continue;
                            xhr.setRequestHeader(property, value);
                        }
                        if (this.isHttp && "begin" in args && "end" in args) {
                            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                        } else pendingRequest.expectedStatus = OK_RESPONSE;
                        xhr.responseType = "arraybuffer";
                        if (args.onError) xhr.onerror = function(evt) {
                            args.onError(xhr.status);
                        };
                        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                        xhr.onprogress = this.onProgress.bind(this, xhrId);
                        pendingRequest.onHeadersReceived = args.onHeadersReceived;
                        pendingRequest.onDone = args.onDone;
                        pendingRequest.onError = args.onError;
                        pendingRequest.onProgress = args.onProgress;
                        xhr.send(null);
                        return xhrId;
                    }
                    onProgress(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        pendingRequest.onProgress?.(evt);
                    }
                    onStateChange(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        const xhr = pendingRequest.xhr;
                        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                            pendingRequest.onHeadersReceived();
                            delete pendingRequest.onHeadersReceived;
                        }
                        if (xhr.readyState !== 4) return;
                        if (!(xhrId in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId];
                        if (xhr.status === 0 && this.isHttp) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const xhrStatus = xhr.status || OK_RESPONSE;
                        const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const chunk = getArrayBuffer(xhr);
                        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                            const rangeHeader = xhr.getResponseHeader("Content-Range");
                            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                            pendingRequest.onDone({
                                begin: parseInt(matches[1], 10),
                                chunk: chunk
                            });
                        } else if (chunk) pendingRequest.onDone({
                            begin: 0,
                            chunk: chunk
                        });
                        else pendingRequest.onError?.(xhr.status);
                    }
                    getRequestXhr(xhrId) {
                        return this.pendingRequests[xhrId].xhr;
                    }
                    isPendingRequest(xhrId) {
                        return xhrId in this.pendingRequests;
                    }
                    abortRequest(xhrId) {
                        const xhr = this.pendingRequests[xhrId].xhr;
                        delete this.pendingRequests[xhrId];
                        xhr.abort();
                    }
                }
                class PDFNetworkStream {
                    constructor(source){
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader) {
                        const i = this._rangeRequestReaders.indexOf(reader);
                        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNetworkStream = PDFNetworkStream;
                class PDFNetworkStreamFullRequestReader {
                    constructor(manager, source){
                        this._manager = manager;
                        const args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId = this._fullRequestId;
                        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                        const getResponseHeader = (name)=>{
                            return fullRequestXhr.getResponseHeader(name);
                        };
                        const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests) this._isRangeSupported = true;
                        this._contentLength = suggestedLength || this._contentLength;
                        this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data) {
                        if (data) {
                            if (this._requests.length > 0) {
                                const requestCapability = this._requests.shift();
                                requestCapability.resolve({
                                    value: data.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt) {
                        this.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.lengthComputable ? evt.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk = this._cachedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason);
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader {
                    constructor(manager, begin, end){
                        this._manager = manager;
                        const args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        this.onClosed?.(this);
                    }
                    _onDone(data) {
                        const chunk = data.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunk = chunk;
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt) {
                        if (!this.isStreamingSupported) this.onProgress?.({
                            loaded: evt.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._queuedChunk !== null) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    const url = (parcelRequire("9zn7p"));
                    const parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                class PDFNodeStream {
                    constructor(source){
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                        this._rangeRequestReaders.push(rangeReader);
                        return rangeReader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNodeStream = PDFNodeStream;
                class BaseFullReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        const source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                class PDFNodeStreamFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response);
                            const getResponseHeader = (name)=>{
                                return this._readableStream.headers[name.toLowerCase()];
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("9zn7p"));
                            this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("9zn7p"));
                            this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                            this._headersCapability.reject(reason);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        this._httpHeaders = {};
                        for(const property in stream.httpHeaders){
                            const value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            this._httpHeaders[property] = value;
                        }
                        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                return;
                            }
                            this._setReadableStream(response);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("9zn7p"));
                            this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("9zn7p"));
                            this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("9zn7p"));
                        fs.lstat(path, (error, stat)=>{
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException(`Missing PDF "${path}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._contentLength = stat.size;
                            this._setReadableStream(fs.createReadStream(path));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("9zn7p"));
                        this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                const SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL = function(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                const convertImgDataToPng = function() {
                    const PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE = 12;
                    const crcTable = new Int32Array(256);
                    for(let i = 0; i < 256; i++){
                        let c = i;
                        for(let h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        let crc = -1;
                        for(let i = start; i < end; i++){
                            const a = (crc ^ data[i]) & 0xff;
                            const b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        let p = offset;
                        const len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        const crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        let a = 1;
                        let b = 0;
                        for(let i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            const input = parseInt($aOKBQ.versions.node) >= 8 ? literals : $c873d3ee29cd35e1$require$Buffer.from(literals);
                            const output = (parcelRequire("9zn7p")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        let len = literals.length;
                        const maxBlockLength = 0xffff;
                        const deflateBlocks = Math.ceil(len / maxBlockLength);
                        const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        let pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        let pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        const adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        let bitDepth, colorType, lineSize;
                        const bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals = new Uint8Array((1 + lineSize) * height);
                        let offsetLiterals = 0, offsetBytes = 0;
                        for(let y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(let y = 0; y < height; y++){
                                offsetLiterals++;
                                for(let i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        const ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat = deflateSync(literals);
                        const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        const data = new Uint8Array(pngLength);
                        let offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                class SVGExtraState {
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                }
                function opListToTree(opList) {
                    let opTree = [];
                    const tmp = [];
                    for (const opListElement of opList){
                        if (opListElement.fn === "save") {
                            opTree.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp.push(opTree);
                            opTree = opTree.at(-1).items;
                            continue;
                        }
                        if (opListElement.fn === "restore") opTree = tmp.pop();
                        else opTree.push(opListElement);
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const s = value.toFixed(10);
                    let i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return `scale(${pf(m[0])} ${pf(m[3])})`;
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            const a = Math.acos(m[0]) * 180 / Math.PI;
                            return `rotate(${pf(a)})`;
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return `translate(${pf(m[4])} ${pf(m[5])})`;
                    return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
                }
                let clipCount = 0;
                let maskCount = 0;
                let shadingCount = 0;
                class SVGGraphics {
                    constructor(commonObjs, objs, forceDataSchema = false){
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(const op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old = this.current;
                        this.extraStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items) {
                        this.save();
                        this.executeOpTree(items);
                        this.restore();
                    }
                    loadDependencies(operatorList) {
                        const fnArray = operatorList.fnArray;
                        const argsArray = operatorList.argsArray;
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            if (fnArray[i] !== _util.OPS.dependency) continue;
                            for (const obj of argsArray[i]){
                                const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise = new Promise((resolve)=>{
                                    objsPool.get(obj, resolve);
                                });
                                this.current.dependencies.push(promise);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a, b, c, d, e, f) {
                        const transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                        this.tgrp = null;
                    }
                    getSVG(operatorList, viewport) {
                        this.viewport = viewport;
                        const svgElement = this._initialize(viewport);
                        return this.loadDependencies(operatorList).then(()=>{
                            this.transformMatrix = _util.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList));
                            return svgElement;
                        });
                    }
                    convertOpList(operatorList) {
                        const operatorIdMapping = this._operatorIdMapping;
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        const opList = [];
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            const fnId = fnArray[i];
                            opList.push({
                                fnId: fnId,
                                fn: operatorIdMapping[fnId],
                                args: argsArray[i]
                            });
                        }
                        return opListToTree(opList);
                    }
                    executeOpTree(opTree) {
                        for (const opTreeElement of opTree){
                            const fn = opTreeElement.fn;
                            const fnId = opTreeElement.fnId;
                            const args = opTreeElement.args;
                            switch(fnId | 0){
                                case _util.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util.OPS.dependency:
                                    break;
                                case _util.OPS.setLeading:
                                    this.setLeading(args);
                                    break;
                                case _util.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setFont:
                                    this.setFont(args);
                                    break;
                                case _util.OPS.showText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.showSpacedText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.endText:
                                    this.endText();
                                    break;
                                case _util.OPS.moveText:
                                    this.moveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setCharSpacing:
                                    this.setCharSpacing(args[0]);
                                    break;
                                case _util.OPS.setWordSpacing:
                                    this.setWordSpacing(args[0]);
                                    break;
                                case _util.OPS.setHScale:
                                    this.setHScale(args[0]);
                                    break;
                                case _util.OPS.setTextMatrix:
                                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.setTextRise:
                                    this.setTextRise(args[0]);
                                    break;
                                case _util.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args[0]);
                                    break;
                                case _util.OPS.setLineWidth:
                                    this.setLineWidth(args[0]);
                                    break;
                                case _util.OPS.setLineJoin:
                                    this.setLineJoin(args[0]);
                                    break;
                                case _util.OPS.setLineCap:
                                    this.setLineCap(args[0]);
                                    break;
                                case _util.OPS.setMiterLimit:
                                    this.setMiterLimit(args[0]);
                                    break;
                                case _util.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args);
                                    break;
                                case _util.OPS.setFillColorN:
                                    this.setFillColorN(args);
                                    break;
                                case _util.OPS.shadingFill:
                                    this.shadingFill(args[0]);
                                    break;
                                case _util.OPS.setDash:
                                    this.setDash(args[0], args[1]);
                                    break;
                                case _util.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args[0]);
                                    break;
                                case _util.OPS.setFlatness:
                                    this.setFlatness(args[0]);
                                    break;
                                case _util.OPS.setGState:
                                    this.setGState(args[0]);
                                    break;
                                case _util.OPS.fill:
                                    this.fill();
                                    break;
                                case _util.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util.OPS.paintImageXObject:
                                    this.paintImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args[0]);
                                    break;
                                case _util.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args[0], args[1]);
                                    break;
                                case _util.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util.OPS.transform:
                                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.constructPath:
                                    this.constructPath(args[0], args[1]);
                                    break;
                                case _util.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement.items);
                                    break;
                                default:
                                    (0, _util.warn)(`Unimplemented operator ${fn}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing) {
                        this.current.wordSpacing = wordSpacing;
                    }
                    setCharSpacing(charSpacing) {
                        this.current.charSpacing = charSpacing;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const current = this.current;
                        current.textMatrix = current.lineMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        current.textMatrixScale = Math.hypot(a, b);
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtElement.append(current.tspan);
                    }
                    beginText() {
                        const current = this.current;
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.textMatrix = _util.IDENTITY_MATRIX;
                        current.lineMatrix = _util.IDENTITY_MATRIX;
                        current.textMatrixScale = 1;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtgrp = this.svgFactory.createElement("svg:g");
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    moveText(x, y) {
                        const current = this.current;
                        current.x = current.lineX += x;
                        current.y = current.lineY += y;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        let x = 0;
                        for (const glyph of glyphs){
                            if (glyph === null) {
                                x += fontDirection * wordSpacing;
                                continue;
                            } else if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                let vx;
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                vx = -vx * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (glyph.isInFont || font.missingFile) {
                                current.xcoords.push(current.x + scaledX);
                                if (vertical) current.ycoords.push(-current.y + scaledY);
                                current.tspan.textContent += character;
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                        }
                        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                        if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                        else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                        const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                            if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                        else current.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale = 1 / (current.textMatrixScale || 1);
                            this._setStrokeAttributes(current.tspan, lineWidthScale);
                        }
                        let textMatrix = current.textMatrix;
                        if (current.textRise !== 0) {
                            textMatrix = textMatrix.slice();
                            textMatrix[5] += current.textRise;
                        }
                        current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                        current.txtElement.append(current.tspan);
                        current.txtgrp.append(current.txtElement);
                        this._ensureTransformGroup().append(current.txtElement);
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    addFontStyle(fontObj) {
                        if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
                    }
                    setFont(details) {
                        const current = this.current;
                        const fontObj = this.commonObjs.get(details[0]);
                        let size = details[1];
                        current.font = fontObj;
                        if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                            this.addFontStyle(fontObj);
                            this.embeddedFonts[fontObj.loadedName] = fontObj;
                        }
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        current.fontSize = size;
                        current.fontFamily = fontObj.loadedName;
                        current.fontWeight = bold;
                        current.fontStyle = italic;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    endText() {
                        const current = this.current;
                        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement?.hasChildNodes()) {
                            current.element = current.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width) {
                        if (width > 0) this.current.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.current.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.current.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.current.miterLimit = limit;
                    }
                    setStrokeAlpha(strokeAlpha) {
                        this.current.strokeAlpha = strokeAlpha;
                    }
                    setStrokeRGBColor(r, g, b) {
                        this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                    }
                    setFillAlpha(fillAlpha) {
                        this.current.fillAlpha = fillAlpha;
                    }
                    setFillRGBColor(r, g, b) {
                        this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args) {
                        this.current.strokeColor = this._makeColorN_Pattern(args);
                    }
                    setFillColorN(args) {
                        this.current.fillColor = this._makeColorN_Pattern(args);
                    }
                    shadingFill(args) {
                        const { width, height } = this.viewport;
                        const inv = _util.Util.inverseTransform(this.transformMatrix);
                        const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width,
                            height
                        ], inv);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", x0);
                        rect.setAttributeNS(null, "y", y0);
                        rect.setAttributeNS(null, "width", x1 - x0);
                        rect.setAttributeNS(null, "height", y1 - y0);
                        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                        if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect);
                    }
                    _makeColorN_Pattern(args) {
                        if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                        return this._makeShadingPattern(args);
                    }
                    _makeTilingPattern(args) {
                        const color = args[1];
                        const operatorList = args[2];
                        const matrix = args[3] || _util.IDENTITY_MATRIX;
                        const [x0, y0, x1, y1] = args[4];
                        const xstep = args[5];
                        const ystep = args[6];
                        const paintType = args[7];
                        const tilingId = `shading${shadingCount++}`;
                        const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([
                            ..._util.Util.applyTransform([
                                x0,
                                y0
                            ], matrix),
                            ..._util.Util.applyTransform([
                                x1,
                                y1
                            ], matrix)
                        ]);
                        const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
                        const txstep = xstep * xscale;
                        const tystep = ystep * yscale;
                        const tiling = this.svgFactory.createElement("svg:pattern");
                        tiling.setAttributeNS(null, "id", tilingId);
                        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling.setAttributeNS(null, "width", txstep);
                        tiling.setAttributeNS(null, "height", tystep);
                        tiling.setAttributeNS(null, "x", `${tx0}`);
                        tiling.setAttributeNS(null, "y", `${ty0}`);
                        const svg = this.svg;
                        const transformMatrix = this.transformMatrix;
                        const fillColor = this.current.fillColor;
                        const strokeColor = this.current.strokeColor;
                        const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                        this.svg = bbox;
                        this.transformMatrix = matrix;
                        if (paintType === 2) {
                            const cssColor = _util.Util.makeHexColor(...color);
                            this.current.fillColor = cssColor;
                            this.current.strokeColor = cssColor;
                        }
                        this.executeOpTree(this.convertOpList(operatorList));
                        this.svg = svg;
                        this.transformMatrix = transformMatrix;
                        this.current.fillColor = fillColor;
                        this.current.strokeColor = strokeColor;
                        tiling.append(bbox.childNodes[0]);
                        this.defs.append(tiling);
                        return `url(#${tilingId})`;
                    }
                    _makeShadingPattern(args) {
                        if (typeof args === "string") args = this.objs.get(args);
                        switch(args[0]){
                            case "RadialAxial":
                                const shadingId = `shading${shadingCount++}`;
                                const colorStops = args[3];
                                let gradient;
                                switch(args[1]){
                                    case "axial":
                                        const point0 = args[4];
                                        const point1 = args[5];
                                        gradient = this.svgFactory.createElement("svg:linearGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "x1", point0[0]);
                                        gradient.setAttributeNS(null, "y1", point0[1]);
                                        gradient.setAttributeNS(null, "x2", point1[0]);
                                        gradient.setAttributeNS(null, "y2", point1[1]);
                                        break;
                                    case "radial":
                                        const focalPoint = args[4];
                                        const circlePoint = args[5];
                                        const focalRadius = args[6];
                                        const circleRadius = args[7];
                                        gradient = this.svgFactory.createElement("svg:radialGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                        gradient.setAttributeNS(null, "r", circleRadius);
                                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                        gradient.setAttributeNS(null, "fr", focalRadius);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                                }
                                for (const colorStop of colorStops){
                                    const stop = this.svgFactory.createElement("svg:stop");
                                    stop.setAttributeNS(null, "offset", colorStop[0]);
                                    stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                    gradient.append(stop);
                                }
                                this.defs.append(gradient);
                                return `url(#${shadingId})`;
                            case "Mesh":
                                (0, _util.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args[0]}`);
                        }
                    }
                    setDash(dashArray, dashPhase) {
                        this.current.dashArray = dashArray;
                        this.current.dashPhase = dashPhase;
                    }
                    constructPath(ops, args) {
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let d = [];
                        let j = 0;
                        for (const op of ops)switch(op | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("M", pf(x), pf(y));
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("L", pf(x), pf(y));
                                break;
                            case _util.OPS.curveTo:
                                x = args[j + 4];
                                y = args[j + 5];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                x = args[j + 2];
                                y = args[j + 3];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                d.push("Z");
                                break;
                        }
                        d = d.join(" ");
                        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                        else {
                            current.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current.path);
                        }
                        current.path.setAttributeNS(null, "d", d);
                        current.path.setAttributeNS(null, "fill", "none");
                        current.element = current.path;
                        current.setCurrentPoint(x, y);
                    }
                    endPath() {
                        const current = this.current;
                        current.path = null;
                        if (!this.pendingClip) return;
                        if (!current.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId = `clippath${clipCount++}`;
                        const clipPath = this.svgFactory.createElement("svg:clipPath");
                        clipPath.setAttributeNS(null, "id", clipId);
                        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                        const clipElement = current.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath.append(clipElement);
                        this.defs.append(clipPath);
                        if (current.activeClipUrl) {
                            current.clipGroup = null;
                            for (const prev of this.extraStack)prev.clipGroup = null;
                            clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                        }
                        current.activeClipUrl = `url(#${clipId})`;
                        this.tgrp = null;
                    }
                    clip(type) {
                        this.pendingClip = type;
                    }
                    closePath() {
                        const current = this.current;
                        if (current.path) {
                            const d = `${current.path.getAttributeNS(null, "d")}Z`;
                            current.path.setAttributeNS(null, "d", d);
                        }
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setTextRise(textRise) {
                        this.current.textRise = textRise;
                    }
                    setTextRenderingMode(textRenderingMode) {
                        this.current.textRenderingMode = textRenderingMode;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value);
                                break;
                            case "ca":
                                this.setFillAlpha(value);
                                break;
                            default:
                                (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
                                break;
                        }
                    }
                    fill() {
                        const current = this.current;
                        if (current.element) {
                            current.element.setAttributeNS(null, "fill", current.fillColor);
                            current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current = this.current;
                        if (current.element) {
                            this._setStrokeAttributes(current.element);
                            current.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element, lineWidthScale = 1) {
                        const current = this.current;
                        let dashArray = current.dashArray;
                        if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                            return lineWidthScale * value;
                        });
                        element.setAttributeNS(null, "stroke", current.strokeColor);
                        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                    }
                    eoFill() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", "1px");
                        rect.setAttributeNS(null, "height", "1px");
                        rect.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect);
                    }
                    paintImageXObject(objId) {
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintInlineImageXObject(imgData, mask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                        const cliprect = this.svgFactory.createElement("svg:rect");
                        cliprect.setAttributeNS(null, "x", "0");
                        cliprect.setAttributeNS(null, "y", "0");
                        cliprect.setAttributeNS(null, "width", pf(width));
                        cliprect.setAttributeNS(null, "height", pf(height));
                        this.current.element = cliprect;
                        this.clip("nonzero");
                        const imgEl = this.svgFactory.createElement("svg:image");
                        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                        imgEl.setAttributeNS(null, "x", "0");
                        imgEl.setAttributeNS(null, "y", pf(-height));
                        imgEl.setAttributeNS(null, "width", pf(width) + "px");
                        imgEl.setAttributeNS(null, "height", pf(height) + "px");
                        imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                        if (mask) mask.append(imgEl);
                        else this._ensureTransformGroup().append(imgEl);
                    }
                    paintImageMaskXObject(img) {
                        const imgData = this.getObject(img.data, img);
                        if (imgData.bitmap) {
                            (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current = this.current;
                        const width = imgData.width;
                        const height = imgData.height;
                        const fillColor = current.fillColor;
                        current.maskId = `mask${maskCount++}`;
                        const mask = this.svgFactory.createElement("svg:mask");
                        mask.setAttributeNS(null, "id", current.maskId);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", pf(width));
                        rect.setAttributeNS(null, "height", pf(height));
                        rect.setAttributeNS(null, "fill", fillColor);
                        rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                        this.defs.append(mask);
                        this._ensureTransformGroup().append(rect);
                        this.paintInlineImageXObject(imgData, mask);
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            const cliprect = this.svgFactory.createElement("svg:rect");
                            cliprect.setAttributeNS(null, "x", bbox[0]);
                            cliprect.setAttributeNS(null, "y", bbox[1]);
                            cliprect.setAttributeNS(null, "width", pf(width));
                            cliprect.setAttributeNS(null, "height", pf(height));
                            this.current.element = cliprect;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport) {
                        const svg = this.svgFactory.create(viewport.width, viewport.height);
                        const definitions = this.svgFactory.createElement("svg:defs");
                        svg.append(definitions);
                        this.defs = definitions;
                        const rootGroup = this.svgFactory.createElement("svg:g");
                        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                        svg.append(rootGroup);
                        this.svg = rootGroup;
                        return svg;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup = this.svgFactory.createElement("svg:g");
                            clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup);
                            this.current.clipGroup = clipGroup;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                }
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                class XfaText {
                    static textContent(xfa) {
                        const items = [];
                        const output = {
                            items: items,
                            styles: Object.create(null)
                        };
                        function walk(node) {
                            if (!node) return;
                            let str = null;
                            const name = node.name;
                            if (name === "#text") str = node.value;
                            else if (!XfaText.shouldBuildText(name)) return;
                            else if (node?.attributes?.textContent) str = node.attributes.textContent;
                            else if (node.value) str = node.value;
                            if (str !== null) items.push({
                                str: str
                            });
                            if (!node.children) return;
                            for (const child of node.children)walk(child);
                        }
                        walk(xfa);
                        return output;
                    }
                    static shouldBuildText(name) {
                        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                    }
                }
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const MAX_TEXT_DIVS_TO_RENDER = 100000;
                const DEFAULT_FONT_SIZE = 30;
                const DEFAULT_FONT_ASCENT = 0.8;
                const ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    let ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    const cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
                    const metrics = ctx.measureText("");
                    let ascent = metrics.fontBoundingBoxAscent;
                    let descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    const textDiv = document.createElement("span");
                    const textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    const tx = _util.Util.transform(task._transform, geom.transform);
                    let angle = Math.atan2(tx[1], tx[0]);
                    const style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    const fontHeight = Math.hypot(tx[2], tx[3]);
                    const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    let left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    const scaleFactorStr = "calc(var(--scale-factor)*";
                    const divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                        divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                        divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                    }
                    divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    let shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    const { div, scale, properties, ctx, prevFontSize, prevFontFamily } = params;
                    const { style } = div;
                    let transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        const { fontFamily } = style;
                        const { canvasWidth, fontSize } = properties;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = `${fontSize * scale}px ${fontFamily}`;
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        const { width } = ctx.measureText(div.textContent);
                        if (width > 0) transform = `scaleX(${canvasWidth * scale / width})`;
                    }
                    if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    const textDivs = task._textDivs;
                    const capability = task._capability;
                    const textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    if (!task._isReadableStream) for (const textDiv of textDivs)task._layoutText(textDiv);
                    capability.resolve();
                }
                class TextLayerRenderTask {
                    constructor({ textContentSource, container, viewport, textDivs, textDivProperties, textContentItemsStr, isOffscreenCanvasSupported }){
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items, styleCache) {
                        for (const item of items){
                            if (item.str === undefined) {
                                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                    const parent = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item.id !== null) this._container.setAttribute("id", `${item.id}`);
                                    parent.append(this._container);
                                } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item.str);
                            appendText(this, item, styleCache);
                        }
                    }
                    _layoutText(textDiv) {
                        const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                        this._layoutTextParams.div = textDiv;
                        layout(this._layoutTextParams);
                        if (textDivProperties.hasText) this._container.append(textDiv);
                        if (textDivProperties.hasEOL) {
                            const br = document.createElement("br");
                            br.setAttribute("role", "presentation");
                            this._container.append(br);
                        }
                    }
                    _render() {
                        const capability = new _util.PromiseCapability();
                        let styleCache = Object.create(null);
                        if (this._isReadableStream) {
                            const pump = ()=>{
                                this._reader.read().then(({ value, done })=>{
                                    if (done) {
                                        capability.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache, value.styles);
                                    this._processItems(value.items, styleCache);
                                    pump();
                                }, capability.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump();
                        } else if (this._textContentSource) {
                            const { items, styles } = this._textContentSource;
                            this._processItems(items, styles);
                            capability.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability.promise.then(()=>{
                            styleCache = null;
                            render(this);
                        }, this._capability.reject);
                    }
                }
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    const { container, viewport } = params;
                    const style = getComputedStyle(container);
                    const visibility = style.getPropertyValue("visibility");
                    const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer({ container, viewport, textDivs, textDivProperties, isOffscreenCanvasSupported, mustRotate = true, mustRescale = true }) {
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        const ctx = getCtx(0, isOffscreenCanvasSupported);
                        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        const params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        for (const div of textDivs){
                            params.properties = textDivProperties.get(div);
                            params.div = div;
                            layout(params);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                class AnnotationEditorLayer {
                    #accessibilityManager;
                    #allowClick = false;
                    #annotationLayer = null;
                    #boundPointerup = this.pointerup.bind(this);
                    #boundPointerdown = this.pointerdown.bind(this);
                    #editors = new Map();
                    #hadPointerDown = false;
                    #isCleaningUp = false;
                    #isDisabling = false;
                    #uiManager;
                    static _initialized = false;
                    constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, viewport, l10n }){
                        const editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            for (const editorType of editorTypes)editorType.initialize(l10n);
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        this.#uiManager = uiManager;
                        this.pageIndex = pageIndex;
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationLayer = annotationLayer;
                        this.viewport = viewport;
                        this.#uiManager.addLayer(this);
                    }
                    get isEmpty() {
                        return this.#editors.size === 0;
                    }
                    updateToolbar(mode) {
                        this.#uiManager.updateToolbar(mode);
                    }
                    updateMode(mode = this.#uiManager.getMode()) {
                        this.#cleanup();
                        if (mode === _util.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode !== _util.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting) {
                        if (!isCommitting && this.#uiManager.getMode() !== _util.AnnotationEditorType.INK) return;
                        if (!isCommitting) {
                            for (const editor of this.#editors.values())if (editor.isEmpty()) {
                                editor.setInBackground();
                                return;
                            }
                        }
                        const editor = this.#createAndAddNewEditor({
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor.setInBackground();
                    }
                    setEditingState(isEditing) {
                        this.#uiManager.setEditingState(isEditing);
                    }
                    addCommands(params) {
                        this.#uiManager.addCommands(params);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.enableEditing();
                            if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                        }
                        if (!this.#annotationLayer) return;
                        const editables = this.#annotationLayer.getEditableAnnotations();
                        for (const editable of editables){
                            editable.hide();
                            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
                            if (annotationElementIds.has(editable.data.id)) continue;
                            const editor = this.deserialize(editable);
                            if (!editor) continue;
                            this.addOrRebuild(editor);
                            editor.enableEditing();
                        }
                    }
                    disable() {
                        this.#isDisabling = true;
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.disableEditing();
                            if (!editor.annotationElementId || editor.serialize() !== null) {
                                hiddenAnnotationIds.add(editor.annotationElementId);
                                continue;
                            }
                            this.getEditableAnnotation(editor.annotationElementId)?.show();
                            editor.remove();
                        }
                        if (this.#annotationLayer) {
                            const editables = this.#annotationLayer.getEditableAnnotations();
                            for (const editable of editables){
                                const { id } = editable.data;
                                if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) continue;
                                editable.show();
                            }
                        }
                        this.#cleanup();
                        if (this.isEmpty) this.div.hidden = true;
                        this.#isDisabling = false;
                    }
                    getEditableAnnotation(id) {
                        return this.#annotationLayer?.getEditableAnnotation(id) || null;
                    }
                    setActiveEditor(editor) {
                        const currentActive = this.#uiManager.getActive();
                        if (currentActive === editor) return;
                        this.#uiManager.setActiveEditor(editor);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", this.#boundPointerdown);
                        this.div.addEventListener("pointerup", this.#boundPointerup);
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                        this.div.removeEventListener("pointerup", this.#boundPointerup);
                    }
                    attach(editor) {
                        this.#editors.set(editor.id, editor);
                        const { annotationElementId } = editor;
                        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
                    }
                    detach(editor) {
                        this.#editors.delete(editor.id);
                        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
                    }
                    remove(editor) {
                        this.detach(editor);
                        this.#uiManager.removeEditor(editor);
                        if (editor.div.contains(document.activeElement)) setTimeout(()=>{
                            this.#uiManager.focusMainContainer();
                        }, 0);
                        editor.div.remove();
                        editor.isAttachedToDOM = false;
                        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor) {
                        if (editor.parent === this) return;
                        if (editor.annotationElementId) {
                            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
                            _editor.AnnotationEditor.deleteAnnotationElement(editor);
                            editor.annotationElementId = null;
                        }
                        this.attach(editor);
                        editor.parent?.detach(editor);
                        editor.setParent(this);
                        if (editor.div && editor.isAttachedToDOM) {
                            editor.div.remove();
                            this.div.append(editor.div);
                        }
                    }
                    add(editor) {
                        this.changeParent(editor);
                        this.#uiManager.addEditor(editor);
                        this.attach(editor);
                        if (!editor.isAttachedToDOM) {
                            const div = editor.render();
                            this.div.append(div);
                            editor.isAttachedToDOM = true;
                        }
                        editor.fixAndSetPosition();
                        editor.onceAdded();
                        this.#uiManager.addToAnnotationStorage(editor);
                    }
                    moveEditorInDOM(editor) {
                        if (!editor.isAttachedToDOM) return;
                        const { activeElement } = document;
                        if (editor.div.contains(activeElement)) {
                            editor._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor.div.contains(document.activeElement)) {
                                    editor.div.addEventListener("focusin", ()=>{
                                        editor._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement.focus();
                                } else editor._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                    }
                    addOrRebuild(editor) {
                        if (editor.needsToBeRebuilt()) editor.rebuild();
                        else this.add(editor);
                    }
                    addUndoableEditor(editor) {
                        const cmd = ()=>editor._uiManager.rebuild(editor);
                        const undo = ()=>{
                            editor.remove();
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return this.#uiManager.getId();
                    }
                    #createNewEditor(params) {
                        switch(this.#uiManager.getMode()){
                            case _util.AnnotationEditorType.FREETEXT:
                                return new _freetext.FreeTextEditor(params);
                            case _util.AnnotationEditorType.INK:
                                return new _ink.InkEditor(params);
                            case _util.AnnotationEditorType.STAMP:
                                return new _stamp.StampEditor(params);
                        }
                        return null;
                    }
                    pasteEditor(mode, params) {
                        this.#uiManager.updateToolbar(mode);
                        this.#uiManager.updateMode(mode);
                        const { offsetX, offsetY } = this.#getCenterPoint();
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: offsetX,
                            y: offsetY,
                            uiManager: this.#uiManager,
                            isCentered: true,
                            ...params
                        });
                        if (editor) this.add(editor);
                    }
                    deserialize(data) {
                        switch(data.annotationType ?? data.annotationEditorType){
                            case _util.AnnotationEditorType.FREETEXT:
                                return _freetext.FreeTextEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.INK:
                                return _ink.InkEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.STAMP:
                                return _stamp.StampEditor.deserialize(data, this, this.#uiManager);
                        }
                        return null;
                    }
                    #createAndAddNewEditor(event, isCentered) {
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: event.offsetX,
                            y: event.offsetY,
                            uiManager: this.#uiManager,
                            isCentered: isCentered
                        });
                        if (editor) this.add(editor);
                        return editor;
                    }
                    #getCenterPoint() {
                        const { x, y, width, height } = this.div.getBoundingClientRect();
                        const tlX = Math.max(0, x);
                        const tlY = Math.max(0, y);
                        const brX = Math.min(window.innerWidth, x + width);
                        const brY = Math.min(window.innerHeight, y + height);
                        const centerX = (tlX + brX) / 2 - x;
                        const centerY = (tlY + brY) / 2 - y;
                        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
                            centerX,
                            centerY
                        ] : [
                            centerY,
                            centerX
                        ];
                        return {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                    }
                    addNewEditor() {
                        this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                    }
                    setSelected(editor) {
                        this.#uiManager.setSelected(editor);
                    }
                    toggleSelected(editor) {
                        this.#uiManager.toggleSelected(editor);
                    }
                    isSelected(editor) {
                        return this.#uiManager.isSelected(editor);
                    }
                    unselect(editor) {
                        this.#uiManager.unselect(editor);
                    }
                    pointerup(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        if (!this.#hadPointerDown) return;
                        this.#hadPointerDown = false;
                        if (!this.#allowClick) {
                            this.#allowClick = true;
                            return;
                        }
                        if (this.#uiManager.getMode() === _util.AnnotationEditorType.STAMP) {
                            this.#uiManager.unselectAll();
                            return;
                        }
                        this.#createAndAddNewEditor(event, false);
                    }
                    pointerdown(event) {
                        if (this.#hadPointerDown) {
                            this.#hadPointerDown = false;
                            return;
                        }
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        this.#hadPointerDown = true;
                        const editor = this.#uiManager.getActive();
                        this.#allowClick = !editor || editor.isEmpty();
                    }
                    findNewParent(editor, x, y) {
                        const layer = this.#uiManager.findParent(x, y);
                        if (layer === null || layer === this) return false;
                        layer.changeParent(editor);
                        return true;
                    }
                    destroy() {
                        if (this.#uiManager.getActive()?.parent === this) {
                            this.#uiManager.commitOrRemove();
                            this.#uiManager.setActiveEditor(null);
                        }
                        for (const editor of this.#editors.values()){
                            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                            editor.setParent(null);
                            editor.isAttachedToDOM = false;
                            editor.div.remove();
                        }
                        this.div = null;
                        this.#editors.clear();
                        this.#uiManager.removeLayer(this);
                    }
                    #cleanup() {
                        this.#isCleaningUp = true;
                        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
                        this.#isCleaningUp = false;
                    }
                    render({ viewport }) {
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, viewport);
                        for (const editor of this.#uiManager.getEditors(this.pageIndex))this.add(editor);
                        this.updateMode();
                    }
                    update({ viewport }) {
                        this.#uiManager.commitOrRemove();
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, {
                            rotation: viewport.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth, pageHeight } = this.viewport.rawDims;
                        return [
                            pageWidth,
                            pageHeight
                        ];
                    }
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                class FreeTextEditor extends _editor.AnnotationEditor {
                    #boundEditorDivBlur = this.editorDivBlur.bind(this);
                    #boundEditorDivFocus = this.editorDivFocus.bind(this);
                    #boundEditorDivInput = this.editorDivInput.bind(this);
                    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                    #color;
                    #content = "";
                    #editorDivId = `${this.id}-editor`;
                    #fontSize;
                    #initialData = null;
                    static _freeTextDefaultContent = "";
                    static _internalPadding = 0;
                    static _defaultColor = null;
                    static _defaultFontSize = 10;
                    static get _keyboardManager() {
                        const proto = FreeTextEditor.prototype;
                        const arrowChecker = (self)=>self.isEmpty();
                        const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    static _type = "freetext";
                    constructor(params){
                        super({
                            ...params,
                            name: "freeTextEditor"
                        });
                        this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                        this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor._defaultFontSize = value;
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor._defaultColor = value;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                this.#updateFontSize(value);
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                this.#updateColor(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor._defaultFontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                this.#fontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                this.#color
                            ]
                        ];
                    }
                    #updateFontSize(fontSize) {
                        const setFontsize = (size)=>{
                            this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                            this.translate(0, -(size - this.#fontSize) * this.parentScale);
                            this.#fontSize = size;
                            this.#setEditorDimensions();
                        };
                        const savedFontsize = this.#fontSize;
                        this.addCommands({
                            cmd: ()=>{
                                setFontsize(fontSize);
                            },
                            undo: ()=>{
                                setFontsize(savedFontsize);
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.#color;
                        this.addCommands({
                            cmd: ()=>{
                                this.#color = this.editorDiv.style.color = color;
                            },
                            undo: ()=>{
                                this.#color = this.editorDiv.style.color = savedColor;
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    _translateEmpty(x, y) {
                        this._uiManager.translateSelectedEditors(x, y, true);
                    }
                    getInitialTranslation() {
                        const scale = this.parentScale;
                        return [
                            -FreeTextEditor._internalPadding * scale,
                            -(FreeTextEditor._internalPadding + this.#fontSize) * scale
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        if (event.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        if (this.width) {
                            this.#cheatInitialRect();
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if (this._initialOptions?.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    #extractText() {
                        const divs = this.editorDiv.getElementsByTagName("div");
                        if (divs.length === 0) return this.editorDiv.innerText;
                        const buffer = [];
                        for (const div of divs)buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                        return buffer.join("\n");
                    }
                    #setEditorDimensions() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        let rect;
                        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                        else {
                            const { currentLayer, div } = this;
                            const savedDisplay = div.style.display;
                            div.style.display = "hidden";
                            currentLayer.div.append(this.div);
                            rect = div.getBoundingClientRect();
                            div.remove();
                            div.style.display = savedDisplay;
                        }
                        if (this.rotation % 180 === this.parentRotation % 180) {
                            this.width = rect.width / parentWidth;
                            this.height = rect.height / parentHeight;
                        } else {
                            this.width = rect.height / parentWidth;
                            this.height = rect.width / parentHeight;
                        }
                        this.fixAndSetPosition();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText = this.#content;
                        const newText = this.#content = this.#extractText().trimEnd();
                        if (savedText === newText) return;
                        const setText = (text)=>{
                            this.#content = text;
                            if (!text) {
                                this.remove();
                                return;
                            }
                            this.#setContent();
                            this._uiManager.rebuild(this);
                            this.#setEditorDimensions();
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText(newText);
                            },
                            undo: ()=>{
                                setText(savedText);
                            },
                            mustExec: false
                        });
                        this.#setEditorDimensions();
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event) {
                        this.enterInEditMode();
                    }
                    keydown(event) {
                        if (event.target === this.div && event.key === "Enter") {
                            this.enterInEditMode();
                            event.preventDefault();
                        }
                    }
                    editorDivKeydown(event) {
                        FreeTextEditor._keyboardManager.exec(this, event);
                    }
                    editorDivFocus(event) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event) {
                        this.isEditing = false;
                    }
                    editorDivInput(event) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", this.#editorDivId);
                        this.enableEditing();
                        _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg)=>this.editorDiv?.setAttribute("aria-label", msg));
                        _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg)=>this.editorDiv?.setAttribute("default-content", msg));
                        this.editorDiv.contentEditable = true;
                        const { style } = this.editorDiv;
                        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                        style.color = this.#color;
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position } = this.#initialData;
                                let [tx, ty] = this.getInitialTranslation();
                                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                const [pageX, pageY] = this.pageTranslation;
                                let posX, posY;
                                switch(this.rotation){
                                    case 0:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                        break;
                                    case 90:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            ty,
                                            -tx
                                        ];
                                        break;
                                    case 180:
                                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            -tx,
                                            -ty
                                        ];
                                        break;
                                    case 270:
                                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                        [tx, ty] = [
                                            -ty,
                                            tx
                                        ];
                                        break;
                                }
                                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#setContent();
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    #setContent() {
                        this.editorDiv.replaceChildren();
                        if (!this.#content) return;
                        for (const line of this.#content.split("\n")){
                            const div = document.createElement("div");
                            div.append(line ? document.createTextNode(line) : document.createElement("br"));
                            this.editorDiv.append(div);
                        }
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data, parent, uiManager) {
                        let initialData = null;
                        if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
                            if (!textContent || textContent.length === 0) return null;
                            initialData = data = {
                                annotationType: _util.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect,
                                rotation: rotation,
                                id: id,
                                deleted: false
                            };
                        }
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.#fontSize = data.fontSize;
                        editor.#color = _util.Util.makeHexColor(...data.color);
                        editor.#content = data.value;
                        editor.annotationElementId = data.id || null;
                        editor.#initialData = initialData;
                        return editor;
                    }
                    serialize(isForCopying = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        const rect = this.getRect(padding, padding);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.FREETEXT,
                            color: color,
                            fontSize: this.#fontSize,
                            value: this.#content,
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) return serialized;
                        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
                        serialized.id = this.annotationElementId;
                        return serialized;
                    }
                    #hasElementChanged(serialized) {
                        const { value, fontSize, color, rect, pageIndex } = this.#initialData;
                        return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i)=>Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
                    }
                    #cheatInitialRect(delayed = false) {
                        if (!this.annotationElementId) return;
                        this.#setEditorDimensions();
                        if (!delayed && (this.width === 0 || this.height === 0)) {
                            setTimeout(()=>this.#cheatInitialRect(true), 0);
                            return;
                        }
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        this.#initialData.rect = this.getRect(padding, padding);
                    }
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                const DEFAULT_TAB_INDEX = 1000;
                const DEFAULT_FONT_SIZE = 9;
                const GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                class AnnotationElementFactory {
                    static create(parameters) {
                        const subtype = parameters.data.annotationType;
                        switch(subtype){
                            case _util.AnnotationType.LINK:
                                return new LinkAnnotationElement(parameters);
                            case _util.AnnotationType.TEXT:
                                return new TextAnnotationElement(parameters);
                            case _util.AnnotationType.WIDGET:
                                const fieldType = parameters.data.fieldType;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement(parameters);
                                    case "Btn":
                                        if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                        else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                        return new PushButtonWidgetAnnotationElement(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement(parameters);
                                }
                                return new WidgetAnnotationElement(parameters);
                            case _util.AnnotationType.POPUP:
                                return new PopupAnnotationElement(parameters);
                            case _util.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement(parameters);
                            case _util.AnnotationType.LINE:
                                return new LineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUARE:
                                return new SquareAnnotationElement(parameters);
                            case _util.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement(parameters);
                            case _util.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement(parameters);
                            case _util.AnnotationType.CARET:
                                return new CaretAnnotationElement(parameters);
                            case _util.AnnotationType.INK:
                                return new InkAnnotationElement(parameters);
                            case _util.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement(parameters);
                            case _util.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement(parameters);
                            case _util.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement(parameters);
                            case _util.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement(parameters);
                            case _util.AnnotationType.STAMP:
                                return new StampAnnotationElement(parameters);
                            case _util.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement(parameters);
                            default:
                                return new AnnotationElement(parameters);
                        }
                    }
                }
                class AnnotationElement {
                    #hasBorder = false;
                    constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}){
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                    static _hasPopupData({ titleObj, contentsObj, richText }) {
                        return !!(titleObj?.str || contentsObj?.str || richText?.str);
                    }
                    get hasPopupData() {
                        return AnnotationElement._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder) {
                        const { data, parent: { page, viewport } } = this;
                        const container = document.createElement("section");
                        container.setAttribute("data-annotation-id", data.id);
                        if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                        container.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                        if (data.noRotate) container.classList.add("norotate");
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        if (!data.rect || this instanceof PopupAnnotationElement) {
                            const { rotation } = data;
                            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                            return container;
                        }
                        const { width, height } = getRectDims(data.rect);
                        const rect = _util.Util.normalizeRect([
                            data.rect[0],
                            page.view[3] - data.rect[1] + page.view[1],
                            data.rect[2],
                            page.view[3] - data.rect[3] + page.view[1]
                        ]);
                        if (!ignoreBorder && data.borderStyle.width > 0) {
                            container.style.borderWidth = `${data.borderStyle.width}px`;
                            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
                            const verticalRadius = data.borderStyle.verticalCornerRadius;
                            if (horizontalRadius > 0 || verticalRadius > 0) {
                                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            }
                            switch(data.borderStyle.style){
                                case _util.AnnotationBorderStyleType.SOLID:
                                    container.style.borderStyle = "solid";
                                    break;
                                case _util.AnnotationBorderStyleType.DASHED:
                                    container.style.borderStyle = "dashed";
                                    break;
                                case _util.AnnotationBorderStyleType.BEVELED:
                                    (0, _util.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util.AnnotationBorderStyleType.INSET:
                                    (0, _util.warn)("Unimplemented border style: inset");
                                    break;
                                case _util.AnnotationBorderStyleType.UNDERLINE:
                                    container.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor = data.borderColor || null;
                            if (borderColor) {
                                this.#hasBorder = true;
                                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                            } else container.style.borderWidth = 0;
                        }
                        container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                        container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                        const { rotation } = data;
                        if (data.hasOwnCanvas || rotation === 0) {
                            container.style.width = `${100 * width / pageWidth}%`;
                            container.style.height = `${100 * height / pageHeight}%`;
                        } else this.setRotation(rotation, container);
                        return container;
                    }
                    setRotation(angle, container = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
                        const { width, height } = getRectDims(this.data.rect);
                        let elementWidth, elementHeight;
                        if (angle % 180 === 0) {
                            elementWidth = 100 * width / pageWidth;
                            elementHeight = 100 * height / pageHeight;
                        } else {
                            elementWidth = 100 * height / pageWidth;
                            elementHeight = 100 * width / pageHeight;
                        }
                        container.style.width = `${elementWidth}%`;
                        container.style.height = `${elementHeight}%`;
                        container.setAttribute("data-main-rotation", (360 - angle) % 360);
                    }
                    get _commonActions() {
                        const setColor = (jsName, styleName, event)=>{
                            const color = event.detail[jsName];
                            const colorType = color[0];
                            const colorArray = color.slice(1);
                            event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                            });
                        };
                        return (0, _util.shadow)(this, "_commonActions", {
                            display: (event)=>{
                                const { display } = event.detail;
                                const hidden = display % 2 === 1;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden,
                                    noPrint: display === 1 || display === 2
                                });
                            },
                            print: (event)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event.detail.print
                                });
                            },
                            hidden: (event)=>{
                                const { hidden } = event.detail;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden,
                                    noView: hidden
                                });
                            },
                            focus: (event)=>{
                                setTimeout(()=>event.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event)=>{
                                event.target.title = event.detail.userName;
                            },
                            readonly: (event)=>{
                                event.target.disabled = event.detail.readonly;
                            },
                            required: (event)=>{
                                this._setRequired(event.target, event.detail.required);
                            },
                            bgColor: (event)=>{
                                setColor("bgColor", "backgroundColor", event);
                            },
                            fillColor: (event)=>{
                                setColor("fillColor", "backgroundColor", event);
                            },
                            fgColor: (event)=>{
                                setColor("fgColor", "color", event);
                            },
                            textColor: (event)=>{
                                setColor("textColor", "color", event);
                            },
                            borderColor: (event)=>{
                                setColor("borderColor", "borderColor", event);
                            },
                            strokeColor: (event)=>{
                                setColor("strokeColor", "borderColor", event);
                            },
                            rotation: (event)=>{
                                const angle = event.detail.rotation;
                                this.setRotation(angle);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions, jsEvent) {
                        const commonActions = this._commonActions;
                        for (const name of Object.keys(jsEvent.detail)){
                            const action = actions[name] || commonActions[name];
                            action?.(jsEvent);
                        }
                    }
                    _setDefaultPropertiesFromJS(element) {
                        if (!this.enableScripting) return;
                        const storedData = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData) return;
                        const commonActions = this._commonActions;
                        for (const [actionName, detail] of Object.entries(storedData)){
                            const action = commonActions[actionName];
                            if (action) {
                                const eventProxy = {
                                    detail: {
                                        [actionName]: detail
                                    },
                                    target: element
                                };
                                action(eventProxy);
                                delete storedData[actionName];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints } = this.data;
                        if (!quadPoints) return;
                        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                        if (quadPoints.length === 1) {
                            const [, { x: trX, y: trY }, { x: blX, y: blY }] = quadPoints[0];
                            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                        }
                        const { style } = this.container;
                        let svgBuffer;
                        if (this.#hasBorder) {
                            const { borderColor, borderWidth } = style;
                            style.borderWidth = 0;
                            svgBuffer = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width = rectTrX - rectBlX;
                        const height = rectTrY - rectBlY;
                        const { svgFactory } = this;
                        const svg = svgFactory.createElement("svg");
                        svg.classList.add("quadrilateralsContainer");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        const defs = svgFactory.createElement("defs");
                        svg.append(defs);
                        const clipPath = svgFactory.createElement("clipPath");
                        const id = `clippath_${this.data.id}`;
                        clipPath.setAttribute("id", id);
                        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs.append(clipPath);
                        for (const [, { x: trX, y: trY }, { x: blX, y: blY }] of quadPoints){
                            const rect = svgFactory.createElement("rect");
                            const x = (blX - rectBlX) / width;
                            const y = (rectTrY - trY) / height;
                            const rectWidth = (trX - blX) / width;
                            const rectHeight = (trY - blY) / height;
                            rect.setAttribute("x", x);
                            rect.setAttribute("y", y);
                            rect.setAttribute("width", rectWidth);
                            rect.setAttribute("height", rectHeight);
                            clipPath.append(rect);
                            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                        }
                        if (this.#hasBorder) {
                            svgBuffer.push(`</g></svg>')`);
                            style.backgroundImage = svgBuffer.join("");
                        }
                        this.container.append(svg);
                        this.container.style.clipPath = `url(#${id})`;
                    }
                    _createPopup() {
                        const { container, data } = this;
                        container.setAttribute("aria-haspopup", "dialog");
                        const popup = new PopupAnnotationElement({
                            data: {
                                color: data.color,
                                titleObj: data.titleObj,
                                modificationDate: data.modificationDate,
                                contentsObj: data.contentsObj,
                                richText: data.richText,
                                parentRect: data.rect,
                                borderStyle: 0,
                                id: `popup_${data.id}`,
                                rotation: data.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup.render());
                    }
                    render() {
                        (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name, skipId = null) {
                        const fields = [];
                        if (this._fieldObjects) {
                            const fieldObj = this._fieldObjects[name];
                            if (fieldObj) for (const { page, id, exportValues } of fieldObj){
                                if (page === -1) continue;
                                if (id === skipId) continue;
                                const exportValue = typeof exportValues === "string" ? exportValues : null;
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
                                    continue;
                                }
                                fields.push({
                                    id: id,
                                    exportValue: exportValue,
                                    domElement: domElement
                                });
                            }
                            return fields;
                        }
                        for (const domElement of document.getElementsByName(name)){
                            const { exportValue } = domElement;
                            const id = domElement.getAttribute("data-element-id");
                            if (id === skipId) continue;
                            if (!GetElementsByNameSet.has(domElement)) continue;
                            fields.push({
                                id: id,
                                exportValue: exportValue,
                                domElement: domElement
                            });
                        }
                        return fields;
                    }
                    show() {
                        if (this.container) this.container.hidden = false;
                        this.popup?.maybeShow();
                    }
                    hide() {
                        if (this.container) this.container.hidden = true;
                        this.popup?.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
                        else triggers.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode, data: { id: editId } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode,
                                editId: editId
                            });
                        });
                    }
                }
                class LinkAnnotationElement extends AnnotationElement {
                    constructor(parameters, options = null){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: !!options?.ignoreBorder,
                            createQuadrilaterals: true
                        });
                        this.isTooltipOnly = parameters.data.isTooltipOnly;
                    }
                    render() {
                        const { data, linkService } = this;
                        const link = document.createElement("a");
                        link.setAttribute("data-element-id", data.id);
                        let isBound = false;
                        if (data.url) {
                            linkService.addLinkAttributes(link, data.url, data.newWindow);
                            isBound = true;
                        } else if (data.action) {
                            this._bindNamedAction(link, data.action);
                            isBound = true;
                        } else if (data.attachment) {
                            this._bindAttachment(link, data.attachment);
                            isBound = true;
                        } else if (data.setOCGState) {
                            this.#bindSetOCGState(link, data.setOCGState);
                            isBound = true;
                        } else if (data.dest) {
                            this._bindLink(link, data.dest);
                            isBound = true;
                        } else {
                            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link, data);
                                isBound = true;
                            }
                            if (data.resetForm) {
                                this._bindResetFormAction(link, data.resetForm);
                                isBound = true;
                            } else if (this.isTooltipOnly && !isBound) {
                                this._bindLink(link, "");
                                isBound = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound) this.container.append(link);
                        return this.container;
                    }
                    #setInternalLink() {
                        this.container.setAttribute("data-internal-link", "");
                    }
                    _bindLink(link, destination) {
                        link.href = this.linkService.getDestinationHash(destination);
                        link.onclick = ()=>{
                            if (destination) this.linkService.goToDestination(destination);
                            return false;
                        };
                        if (destination || destination === "") this.#setInternalLink();
                    }
                    _bindNamedAction(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeNamedAction(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindAttachment(link, attachment) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    #bindSetOCGState(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeSetOCGState(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindJSAction(link, data) {
                        link.href = this.linkService.getAnchorUrl("");
                        const map = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name of Object.keys(data.actions)){
                            const jsName = map.get(name);
                            if (!jsName) continue;
                            link[jsName] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data.id,
                                        name: name
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link.onclick) link.onclick = ()=>false;
                        this.#setInternalLink();
                    }
                    _bindResetFormAction(link, resetForm) {
                        const otherClickAction = link.onclick;
                        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                        this.#setInternalLink();
                        if (!this._fieldObjects) {
                            (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction) link.onclick = ()=>false;
                            return;
                        }
                        link.onclick = ()=>{
                            otherClickAction?.();
                            const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
                            const allFields = [];
                            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                const fieldIds = new Set(resetFormRefs);
                                for (const fieldName of resetFormFields){
                                    const fields = this._fieldObjects[fieldName] || [];
                                    for (const { id } of fields)fieldIds.add(id);
                                }
                                for (const fields of Object.values(this._fieldObjects)){
                                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                                }
                            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
                            const storage = this.annotationStorage;
                            const allIds = [];
                            for (const field of allFields){
                                const { id } = field;
                                allIds.push(id);
                                switch(field.type){
                                    case "text":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value = field.defaultValue === field.exportValues;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (!domElement) continue;
                                else if (!GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                                    continue;
                                }
                                domElement.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                }
                class TextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                    }
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image = document.createElement("img");
                        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image.alt = "[{{type}} Annotation]";
                        image.dataset.l10nId = "text_annotation_type";
                        image.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement extends AnnotationElement {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element) {
                        if (this.data.hasOwnCanvas) {
                            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
                            element.hidden = false;
                        }
                    }
                    _getKeyModifier(event) {
                        const { isWin, isMac } = _util.FeatureTest.platform;
                        return isWin && event.ctrlKey || isMac && event.metaKey;
                    }
                    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event),
                                    shift: event.shiftKey,
                                    modifier: this._getKeyModifier(event)
                                }
                            });
                        });
                        else element.addEventListener(baseName, (event)=>{
                            if (baseName === "blur") {
                                if (!elementData.focused || !event.relatedTarget) return;
                                elementData.focused = false;
                            } else if (baseName === "focus") {
                                if (elementData.focused) return;
                                elementData.focused = true;
                            }
                            if (!valueGetter) return;
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event)
                                }
                            });
                        });
                    }
                    _setEventListeners(element, elementData, names, getter) {
                        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
                            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                                focused: false
                            };
                            this._setEventListener(element, elementData, baseName, eventName, getter);
                            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
                            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element) {
                        const color = this.data.backgroundColor || null;
                        element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                    }
                    _setTextStyle(element) {
                        const TEXT_ALIGNMENT = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor } = this.data.defaultAppearanceData;
                        const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                        const style = element.style;
                        let computedFontSize;
                        const BORDER_SIZE = 2;
                        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
                        if (this.data.multiLine) {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                            const lineHeight = height / numberOfLines;
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                        } else {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
                        }
                        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                        style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                    }
                    _setRequired(element, isRequired) {
                        if (isRequired) element.setAttribute("required", true);
                        else element.removeAttribute("required");
                        element.setAttribute("aria-required", isRequired);
                    }
                }
                class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        super(parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    setPropertyOnSiblings(base, key, value, keyInStorage) {
                        const storage = this.annotationStorage;
                        for (const element of this._getElementsByName(base.name, base.id)){
                            if (element.domElement) element.domElement[key] = value;
                            storage.setValue(element.id, {
                                [keyInStorage]: value
                            });
                        }
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element = null;
                        if (this.renderForms) {
                            const storedData = storage.getValue(id, {
                                value: this.data.fieldValue
                            });
                            let textContent = storedData.value || "";
                            const maxLen = storage.getValue(id, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
                            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                            const elementData = {
                                userValue: textContent,
                                formattedValue: fieldFormattedValues,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element = document.createElement("textarea");
                                element.textContent = fieldFormattedValues ?? textContent;
                                if (this.data.doNotScroll) element.style.overflowY = "hidden";
                            } else {
                                element = document.createElement("input");
                                element.type = "text";
                                element.setAttribute("value", fieldFormattedValues ?? textContent);
                                if (this.data.doNotScroll) element.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element.hidden = true;
                            GetElementsByNameSet.add(element);
                            element.setAttribute("data-element-id", id);
                            element.disabled = this.data.readOnly;
                            element.name = this.data.fieldName;
                            element.tabIndex = DEFAULT_TAB_INDEX;
                            this._setRequired(element, this.data.required);
                            if (maxLen) element.maxLength = maxLen;
                            element.addEventListener("input", (event)=>{
                                storage.setValue(id, {
                                    value: event.target.value
                                });
                                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                elementData.formattedValue = null;
                            });
                            element.addEventListener("resetform", (event)=>{
                                const defaultValue = this.data.defaultFieldValue ?? "";
                                element.value = elementData.userValue = defaultValue;
                                elementData.formattedValue = null;
                            });
                            let blurListener = (event)=>{
                                const { formattedValue } = elementData;
                                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                event.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element.addEventListener("focus", (event)=>{
                                    if (elementData.focused) return;
                                    const { target } = event;
                                    if (elementData.userValue) target.value = elementData.userValue;
                                    elementData.lastCommittedValue = target.value;
                                    elementData.commitKey = 1;
                                    elementData.focused = true;
                                });
                                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                    this.showElementAndHideCanvas(jsEvent.target);
                                    const actions = {
                                        value (event) {
                                            elementData.userValue = event.detail.value ?? "";
                                            storage.setValue(id, {
                                                value: elementData.userValue.toString()
                                            });
                                            event.target.value = elementData.userValue;
                                        },
                                        formattedValue (event) {
                                            const { formattedValue } = event.detail;
                                            elementData.formattedValue = formattedValue;
                                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                            storage.setValue(id, {
                                                formattedValue: formattedValue
                                            });
                                        },
                                        selRange (event) {
                                            event.target.setSelectionRange(...event.detail.selRange);
                                        },
                                        charLimit: (event)=>{
                                            const { charLimit } = event.detail;
                                            const { target } = event;
                                            if (charLimit === 0) {
                                                target.removeAttribute("maxLength");
                                                return;
                                            }
                                            target.setAttribute("maxLength", charLimit);
                                            let value = elementData.userValue;
                                            if (!value || value.length <= charLimit) return;
                                            value = value.slice(0, charLimit);
                                            target.value = elementData.userValue = value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target.selectionStart,
                                                    selEnd: target.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions, jsEvent);
                                });
                                element.addEventListener("keydown", (event)=>{
                                    elementData.commitKey = 1;
                                    let commitKey = -1;
                                    if (event.key === "Escape") commitKey = 0;
                                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                                    else if (event.key === "Tab") elementData.commitKey = 3;
                                    if (commitKey === -1) return;
                                    const { value } = event.target;
                                    if (elementData.lastCommittedValue === value) return;
                                    elementData.lastCommittedValue = value;
                                    elementData.userValue = value;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener = blurListener;
                                blurListener = null;
                                element.addEventListener("blur", (event)=>{
                                    if (!elementData.focused || !event.relatedTarget) return;
                                    elementData.focused = false;
                                    const { value } = event.target;
                                    elementData.userValue = value;
                                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: elementData.commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                    _blurListener(event);
                                });
                                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                                    elementData.lastCommittedValue = null;
                                    const { data, target } = event;
                                    const { value, selectionStart, selectionEnd } = target;
                                    let selStart = selectionStart, selEnd = selectionEnd;
                                    switch(event.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                if (match) selStart -= match[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                if (match) selEnd += match[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart === selectionEnd) selStart -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart === selectionEnd) selEnd += 1;
                                            break;
                                    }
                                    event.preventDefault();
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            change: data || "",
                                            willCommit: false,
                                            selStart: selStart,
                                            selEnd: selEnd
                                        }
                                    });
                                });
                                this._setEventListeners(element, elementData, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event)=>event.target.value);
                            }
                            if (blurListener) element.addEventListener("blur", blurListener);
                            if (this.data.comb) {
                                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                                const combWidth = fieldWidth / maxLen;
                                element.classList.add("comb");
                                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element = document.createElement("div");
                            element.textContent = this.data.fieldValue;
                            element.style.verticalAlign = "middle";
                            element.style.display = "table-cell";
                        }
                        this._setTextStyle(element);
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.exportValue === data.fieldValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== "Off";
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "checkbox";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.setAttribute("exportValue", data.exportValue);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const checkbox of this._getElementsByName(name, id)){
                                const curChecked = checked && checkbox.exportValue === data.exportValue;
                                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                storage.setValue(checkbox.id, {
                                    value: curChecked
                                });
                            }
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue || "Off";
                            event.target.checked = defaultValue === data.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        event.target.checked = event.detail.value !== "Off";
                                        storage.setValue(id, {
                                            value: event.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.fieldValue === data.buttonValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== data.buttonValue;
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "radio";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                                value: false
                            });
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue;
                            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue = data.buttonValue;
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value: (event)=>{
                                        const checked = pdfButtonValue === event.detail.value;
                                        for (const radio of this._getElementsByName(event.target.name)){
                                            const curChecked = checked && radio.id === id;
                                            if (radio.domElement) radio.domElement.checked = curChecked;
                                            storage.setValue(radio.id, {
                                                value: curChecked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    render() {
                        const container = super.render();
                        container.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container.title = this.data.alternativeText;
                        const linkElement = container.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement) {
                            this._setDefaultPropertiesFromJS(linkElement);
                            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                this._dispatchEventFromSandbox({}, jsEvent);
                            });
                        }
                        return container;
                    }
                }
                class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        const storedData = storage.getValue(id, {
                            value: this.data.fieldValue
                        });
                        const selectElement = document.createElement("select");
                        GetElementsByNameSet.add(selectElement);
                        selectElement.setAttribute("data-element-id", id);
                        selectElement.disabled = this.data.readOnly;
                        this._setRequired(selectElement, this.data.required);
                        selectElement.name = this.data.fieldName;
                        selectElement.tabIndex = DEFAULT_TAB_INDEX;
                        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement.multiple = true;
                        }
                        selectElement.addEventListener("resetform", (event)=>{
                            const defaultValue = this.data.defaultFieldValue;
                            for (const option of selectElement.options)option.selected = option.value === defaultValue;
                        });
                        for (const option of this.data.options){
                            const optionElement = document.createElement("option");
                            optionElement.textContent = option.displayValue;
                            optionElement.value = option.exportValue;
                            if (storedData.value.includes(option.exportValue)) {
                                optionElement.setAttribute("selected", true);
                                addAnEmptyEntry = false;
                            }
                            selectElement.append(optionElement);
                        }
                        let removeEmptyEntry = null;
                        if (addAnEmptyEntry) {
                            const noneOptionElement = document.createElement("option");
                            noneOptionElement.value = " ";
                            noneOptionElement.setAttribute("hidden", true);
                            noneOptionElement.setAttribute("selected", true);
                            selectElement.prepend(noneOptionElement);
                            removeEmptyEntry = ()=>{
                                noneOptionElement.remove();
                                selectElement.removeEventListener("input", removeEmptyEntry);
                                removeEmptyEntry = null;
                            };
                            selectElement.addEventListener("input", removeEmptyEntry);
                        }
                        const getValue = (isExport)=>{
                            const name = isExport ? "value" : "textContent";
                            const { options, multiple } = selectElement;
                            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
                        };
                        let selectedValues = getValue(false);
                        const getItems = (event)=>{
                            const options = event.target.options;
                            return Array.prototype.map.call(options, (option)=>{
                                return {
                                    displayValue: option.textContent,
                                    exportValue: option.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        removeEmptyEntry?.();
                                        const value = event.detail.value;
                                        const values = new Set(Array.isArray(value) ? value : [
                                            value
                                        ]);
                                        for (const option of selectElement.options)option.selected = values.has(option.value);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    multipleSelection (event) {
                                        selectElement.multiple = true;
                                    },
                                    remove (event) {
                                        const options = selectElement.options;
                                        const index = event.detail.remove;
                                        options[index].selected = false;
                                        selectElement.remove(index);
                                        if (options.length > 0) {
                                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                                            if (i === -1) options[0].selected = true;
                                        }
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    clear (event) {
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        storage.setValue(id, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    insert (event) {
                                        const { index, displayValue, exportValue } = event.detail.insert;
                                        const selectChild = selectElement.children[index];
                                        const optionElement = document.createElement("option");
                                        optionElement.textContent = displayValue;
                                        optionElement.value = exportValue;
                                        if (selectChild) selectChild.before(optionElement);
                                        else selectElement.append(optionElement);
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    items (event) {
                                        const { items } = event.detail;
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        for (const item of items){
                                            const { displayValue, exportValue } = item;
                                            const optionElement = document.createElement("option");
                                            optionElement.textContent = displayValue;
                                            optionElement.value = exportValue;
                                            selectElement.append(optionElement);
                                        }
                                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    indices (event) {
                                        const indices = new Set(event.detail.indices);
                                        for (const option of event.target.options)option.selected = indices.has(option.index);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    editable (event) {
                                        event.target.disabled = !event.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            selectElement.addEventListener("input", (event)=>{
                                const exportValue = getValue(true);
                                storage.setValue(id, {
                                    value: exportValue
                                });
                                event.preventDefault();
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id,
                                        name: "Keystroke",
                                        value: selectedValues,
                                        changeEx: exportValue,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event)=>event.target.value);
                        } else selectElement.addEventListener("input", function(event) {
                            storage.setValue(id, {
                                value: getValue(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement);
                        this._setBackgroundColor(selectElement);
                        this._setDefaultPropertiesFromJS(selectElement);
                        this.container.append(selectElement);
                        return this.container;
                    }
                }
                class PopupAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        const { data, elements } = parameters;
                        super(parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        this.elements = elements;
                    }
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup = new PopupElement({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds = [];
                        for (const element of this.elements){
                            element.popup = popup;
                            elementIds.push(element.data.id);
                            element.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${_util.AnnotationPrefix}${id}`).join(","));
                        return this.container;
                    }
                }
                class PopupElement {
                    #dateTimePromise = null;
                    #boundKeyDown = this.#keyDown.bind(this);
                    #boundHide = this.#hide.bind(this);
                    #boundShow = this.#show.bind(this);
                    #boundToggle = this.#toggle.bind(this);
                    #color = null;
                    #container = null;
                    #contentsObj = null;
                    #elements = null;
                    #parent = null;
                    #parentRect = null;
                    #pinned = false;
                    #popup = null;
                    #rect = null;
                    #richText = null;
                    #titleObj = null;
                    #wasVisible = false;
                    constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }){
                        this.#container = container;
                        this.#titleObj = titleObj;
                        this.#contentsObj = contentsObj;
                        this.#richText = richText;
                        this.#parent = parent;
                        this.#color = color;
                        this.#rect = rect;
                        this.#parentRect = parentRect;
                        this.#elements = elements;
                        const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) this.#dateTimePromise = parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        });
                        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
                        for (const element of this.trigger){
                            element.addEventListener("click", this.#boundToggle);
                            element.addEventListener("mouseenter", this.#boundShow);
                            element.addEventListener("mouseleave", this.#boundHide);
                            element.classList.add("popupTriggerArea");
                        }
                        for (const element of elements)element.container?.addEventListener("keydown", this.#boundKeyDown);
                        this.#container.hidden = true;
                        if (open) this.#toggle();
                    }
                    render() {
                        if (this.#popup) return;
                        const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = this.#parent;
                        const popup = this.#popup = document.createElement("div");
                        popup.className = "popup";
                        if (this.#color) {
                            const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...this.#color);
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT = 0.7;
                                popup.style.backgroundColor = _util.Util.makeHexColor(...this.#color.map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                            }
                        }
                        const header = document.createElement("span");
                        header.className = "header";
                        const title = document.createElement("h1");
                        header.append(title);
                        ({ dir: title.dir, str: title.textContent } = this.#titleObj);
                        popup.append(header);
                        if (this.#dateTimePromise) {
                            const modificationDate = document.createElement("span");
                            modificationDate.classList.add("popupDate");
                            this.#dateTimePromise.then((localized)=>{
                                modificationDate.textContent = localized;
                            });
                            header.append(modificationDate);
                        }
                        const contentsObj = this.#contentsObj;
                        const richText = this.#richText;
                        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
                            _xfa_layer.XfaLayer.render({
                                xfaHtml: richText.html,
                                intent: "richText",
                                div: popup
                            });
                            popup.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents = this._formatContents(contentsObj);
                            popup.append(contents);
                        }
                        let useParentRect = !!this.#parentRect;
                        let rect = useParentRect ? this.#parentRect : this.#rect;
                        for (const element of this.#elements)if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                            rect = element.data.rect;
                            useParentRect = true;
                            break;
                        }
                        const normalizedRect = _util.Util.normalizeRect([
                            rect[0],
                            view[3] - rect[1] + view[1],
                            rect[2],
                            view[3] - rect[3] + view[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                        const popupLeft = normalizedRect[0] + parentWidth;
                        const popupTop = normalizedRect[1];
                        const { style } = this.#container;
                        style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                        style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                        this.#container.append(popup);
                    }
                    _formatContents({ str, dir }) {
                        const p = document.createElement("p");
                        p.classList.add("popupContent");
                        p.dir = dir;
                        const lines = str.split(/(?:\r\n?|\n)/);
                        for(let i = 0, ii = lines.length; i < ii; ++i){
                            const line = lines[i];
                            p.append(document.createTextNode(line));
                            if (i < ii - 1) p.append(document.createElement("br"));
                        }
                        return p;
                    }
                    #keyDown(event) {
                        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
                    }
                    #toggle() {
                        this.#pinned = !this.#pinned;
                        if (this.#pinned) {
                            this.#show();
                            this.#container.addEventListener("click", this.#boundToggle);
                            this.#container.addEventListener("keydown", this.#boundKeyDown);
                        } else {
                            this.#hide();
                            this.#container.removeEventListener("click", this.#boundToggle);
                            this.#container.removeEventListener("keydown", this.#boundKeyDown);
                        }
                    }
                    #show() {
                        if (!this.#popup) this.render();
                        if (!this.isVisible) {
                            this.#container.hidden = false;
                            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
                        } else if (this.#pinned) this.#container.classList.add("focused");
                    }
                    #hide() {
                        this.#container.classList.remove("focused");
                        if (this.#pinned || !this.isVisible) return;
                        this.#container.hidden = true;
                        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
                    }
                    forceHide() {
                        this.#wasVisible = this.isVisible;
                        if (!this.#wasVisible) return;
                        this.#container.hidden = true;
                    }
                    maybeShow() {
                        if (!this.#wasVisible) return;
                        this.#wasVisible = false;
                        this.#container.hidden = false;
                    }
                    get isVisible() {
                        return this.#container.hidden === false;
                    }
                }
                class FreeTextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters.data.textContent;
                        this.textPosition = parameters.data.textPosition;
                        this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                    }
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content = document.createElement("div");
                            content.classList.add("annotationTextContent");
                            content.setAttribute("role", "comment");
                            for (const line of this.textContent){
                                const lineSpan = document.createElement("span");
                                lineSpan.textContent = line;
                                content.append(lineSpan);
                            }
                            this.container.append(content);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                }
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                class LineAnnotationElement extends AnnotationElement {
                    #line = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const line = this.#line = this.svgFactory.createElement("svg:line");
                        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                        line.setAttribute("stroke-width", data.borderStyle.width || 1);
                        line.setAttribute("stroke", "transparent");
                        line.setAttribute("fill", "transparent");
                        svg.append(line);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#line;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class SquareAnnotationElement extends AnnotationElement {
                    #square = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const square = this.#square = this.svgFactory.createElement("svg:rect");
                        square.setAttribute("x", borderWidth / 2);
                        square.setAttribute("y", borderWidth / 2);
                        square.setAttribute("width", width - borderWidth);
                        square.setAttribute("height", height - borderWidth);
                        square.setAttribute("stroke-width", borderWidth || 1);
                        square.setAttribute("stroke", "transparent");
                        square.setAttribute("fill", "transparent");
                        svg.append(square);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#square;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class CircleAnnotationElement extends AnnotationElement {
                    #circle = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
                        circle.setAttribute("cx", width / 2);
                        circle.setAttribute("cy", height / 2);
                        circle.setAttribute("rx", width / 2 - borderWidth / 2);
                        circle.setAttribute("ry", height / 2 - borderWidth / 2);
                        circle.setAttribute("stroke-width", borderWidth || 1);
                        circle.setAttribute("stroke", "transparent");
                        circle.setAttribute("fill", "transparent");
                        svg.append(circle);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#circle;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolylineAnnotationElement extends AnnotationElement {
                    #polyline = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        let points = [];
                        for (const coordinate of data.vertices){
                            const x = coordinate.x - data.rect[0];
                            const y = data.rect[3] - coordinate.y;
                            points.push(x + "," + y);
                        }
                        points = points.join(" ");
                        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                        polyline.setAttribute("points", points);
                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                        polyline.setAttribute("stroke", "transparent");
                        polyline.setAttribute("fill", "transparent");
                        svg.append(polyline);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polyline;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolygonAnnotationElement extends PolylineAnnotationElement {
                    constructor(parameters){
                        super(parameters);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                class InkAnnotationElement extends AnnotationElement {
                    #polylines = [];
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util.AnnotationEditorType.INK;
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        for (const inkList of data.inkLists){
                            let points = [];
                            for (const coordinate of inkList){
                                const x = coordinate.x - data.rect[0];
                                const y = data.rect[3] - coordinate.y;
                                points.push(`${x},${y}`);
                            }
                            points = points.join(" ");
                            const polyline = this.svgFactory.createElement(this.svgElementName);
                            this.#polylines.push(polyline);
                            polyline.setAttribute("points", points);
                            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                            polyline.setAttribute("stroke", "transparent");
                            polyline.setAttribute("fill", "transparent");
                            if (!data.popupRef && this.hasPopupData) this._createPopup();
                            svg.append(polyline);
                        }
                        this.container.append(svg);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polylines;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                exports.InkAnnotationElement = InkAnnotationElement;
                class HighlightAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                }
                class StampAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                exports.StampAnnotationElement = StampAnnotationElement;
                class FileAttachmentAnnotationElement extends AnnotationElement {
                    #trigger = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                        const { filename, content } = this.data.file;
                        this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        this.content = content;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename,
                            content: content
                        });
                    }
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container, data } = this;
                        let trigger;
                        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                        else {
                            trigger = document.createElement("img");
                            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
                        }
                        trigger.addEventListener("dblclick", this.#download.bind(this));
                        this.#trigger = trigger;
                        const { isMac } = _util.FeatureTest.platform;
                        container.addEventListener("keydown", (evt)=>{
                            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
                        });
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        else trigger.classList.add("popupTriggerArea");
                        container.append(trigger);
                        return container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#trigger;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    #download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer {
                    #accessibilityManager = null;
                    #annotationCanvasMap = null;
                    #editableAnnotations = new Map();
                    constructor({ div, accessibilityManager, annotationCanvasMap, l10n, page, viewport }){
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationCanvasMap = annotationCanvasMap;
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n ||= _displayL10n_utils.NullL10n;
                    }
                    #appendElement(element, id) {
                        const contentElement = element.firstChild || element;
                        contentElement.id = `${_util.AnnotationPrefix}${id}`;
                        this.div.append(element);
                        this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
                    }
                    async render(params) {
                        const { annotations } = params;
                        const layer = this.div;
                        (0, _display_utils.setLayerDimensions)(layer, this.viewport);
                        const popupToElements = new Map();
                        const elementParams = {
                            data: null,
                            layer: layer,
                            linkService: params.linkService,
                            downloadManager: params.downloadManager,
                            imageResourcesPath: params.imageResourcesPath || "",
                            renderForms: params.renderForms !== false,
                            svgFactory: new _display_utils.DOMSVGFactory(),
                            annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                            enableScripting: params.enableScripting === true,
                            hasJSActions: params.hasJSActions,
                            fieldObjects: params.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        for (const data of annotations){
                            if (data.noHTML) continue;
                            const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                            if (!isPopupAnnotation) {
                                const { width, height } = getRectDims(data.rect);
                                if (width <= 0 || height <= 0) continue;
                            } else {
                                const elements = popupToElements.get(data.id);
                                if (!elements) continue;
                                elementParams.elements = elements;
                            }
                            elementParams.data = data;
                            const element = AnnotationElementFactory.create(elementParams);
                            if (!element.isRenderable) continue;
                            if (!isPopupAnnotation && data.popupRef) {
                                const elements = popupToElements.get(data.popupRef);
                                if (!elements) popupToElements.set(data.popupRef, [
                                    element
                                ]);
                                else elements.push(element);
                            }
                            if (element.annotationEditorType > 0) this.#editableAnnotations.set(element.data.id, element);
                            const rendered = element.render();
                            if (data.hidden) rendered.style.visibility = "hidden";
                            this.#appendElement(rendered, data.id);
                        }
                        this.#setAnnotationCanvasMap();
                        await this.l10n.translate(layer);
                    }
                    update({ viewport }) {
                        const layer = this.div;
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(layer, {
                            rotation: viewport.rotation
                        });
                        this.#setAnnotationCanvasMap();
                        layer.hidden = false;
                    }
                    #setAnnotationCanvasMap() {
                        if (!this.#annotationCanvasMap) return;
                        const layer = this.div;
                        for (const [id, canvas] of this.#annotationCanvasMap){
                            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                            if (!element) continue;
                            const { firstChild } = element;
                            if (!firstChild) element.append(canvas);
                            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                            else firstChild.before(canvas);
                        }
                        this.#annotationCanvasMap.clear();
                    }
                    getEditableAnnotations() {
                        return Array.from(this.#editableAnnotations.values());
                    }
                    getEditableAnnotation(id) {
                        return this.#editableAnnotations.get(id);
                    }
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                class ColorConverters {
                    static CMYK_G([c, y, m, k]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                        ];
                    }
                    static G_CMYK([g]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g
                        ];
                    }
                    static G_RGB([g]) {
                        return [
                            "RGB",
                            g,
                            g,
                            g
                        ];
                    }
                    static G_rgb([g]) {
                        g = scaleAndClamp(g);
                        return [
                            g,
                            g,
                            g
                        ];
                    }
                    static G_HTML([g]) {
                        const G = makeColorComp(g);
                        return `#${G}${G}${G}`;
                    }
                    static RGB_G([r, g, b]) {
                        return [
                            "G",
                            0.3 * r + 0.59 * g + 0.11 * b
                        ];
                    }
                    static RGB_rgb(color) {
                        return color.map(scaleAndClamp);
                    }
                    static RGB_HTML(color) {
                        return `#${color.map(makeColorComp).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c, y, m, k]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c + k),
                            1 - Math.min(1, m + k),
                            1 - Math.min(1, y + k)
                        ];
                    }
                    static CMYK_rgb([c, y, m, k]) {
                        return [
                            scaleAndClamp(1 - Math.min(1, c + k)),
                            scaleAndClamp(1 - Math.min(1, m + k)),
                            scaleAndClamp(1 - Math.min(1, y + k))
                        ];
                    }
                    static CMYK_HTML(components) {
                        const rgb = this.CMYK_RGB(components).slice(1);
                        return this.RGB_HTML(rgb);
                    }
                    static RGB_CMYK([r, g, b]) {
                        const c = 1 - r;
                        const m = 1 - g;
                        const y = 1 - b;
                        const k = Math.min(c, m, y);
                        return [
                            "CMYK",
                            c,
                            m,
                            y,
                            k
                        ];
                    }
                }
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                const DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name)=>{
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                const NullL10n = {
                    async getLanguage () {
                        return "en-us";
                    },
                    async getDirection () {
                        return "ltr";
                    },
                    async get (key, args = null, fallback = getL10nFallback(key, args)) {
                        return formatL10nValue(fallback, args);
                    },
                    async translate (element) {}
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                class XfaLayer {
                    static setupStorage(html, id, element, storage, intent) {
                        const storedData = storage.getValue(id, {
                            value: null
                        });
                        switch(element.name){
                            case "textarea":
                                if (storedData.value !== null) html.textContent = storedData.value;
                                if (intent === "print") break;
                                html.addEventListener("input", (event)=>{
                                    storage.setValue(id, {
                                        value: event.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                    if (intent === "print") break;
                                    html.addEventListener("change", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                    if (intent === "print") break;
                                    html.addEventListener("input", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData.value !== null) {
                                    html.setAttribute("value", storedData.value);
                                    for (const option of element.children){
                                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                    }
                                }
                                html.addEventListener("input", (event)=>{
                                    const options = event.target.options;
                                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html, element, storage = null, intent, linkService }) {
                        const { attributes } = element;
                        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
                        for (const [key, value] of Object.entries(attributes)){
                            if (value === null || value === undefined) continue;
                            switch(key){
                                case "class":
                                    if (value.length) html.setAttribute(key, value.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html.setAttribute("data-element-id", value);
                                    break;
                                case "style":
                                    Object.assign(html.style, value);
                                    break;
                                case "textContent":
                                    html.textContent = value;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                            }
                        }
                        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                    }
                    static render(parameters) {
                        const storage = parameters.annotationStorage;
                        const linkService = parameters.linkService;
                        const root = parameters.xfaHtml;
                        const intent = parameters.intent || "display";
                        const rootHtml = document.createElement(root.name);
                        if (root.attributes) this.setAttributes({
                            html: rootHtml,
                            element: root,
                            intent: intent,
                            linkService: linkService
                        });
                        const stack = [
                            [
                                root,
                                -1,
                                rootHtml
                            ]
                        ];
                        const rootDiv = parameters.div;
                        rootDiv.append(rootHtml);
                        if (parameters.viewport) {
                            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                            rootDiv.style.transform = transform;
                        }
                        if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs = [];
                        while(stack.length > 0){
                            const [parent, i, html] = stack.at(-1);
                            if (i + 1 === parent.children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = parent.children[++stack.at(-1)[1]];
                            if (child === null) continue;
                            const { name } = child;
                            if (name === "#text") {
                                const node = document.createTextNode(child.value);
                                textDivs.push(node);
                                html.append(node);
                                continue;
                            }
                            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                            html.append(childHtml);
                            if (child.attributes) this.setAttributes({
                                html: childHtml,
                                element: child,
                                storage: storage,
                                intent: intent,
                                linkService: linkService
                            });
                            if (child.children && child.children.length > 0) stack.push([
                                child,
                                -1,
                                childHtml
                            ]);
                            else if (child.value) {
                                const node = document.createTextNode(child.value);
                                if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node);
                                childHtml.append(node);
                            }
                        }
                        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs
                        };
                    }
                    static update(parameters) {
                        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                        parameters.div.style.transform = transform;
                        parameters.div.hidden = false;
                    }
                }
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                class InkEditor extends _editor.AnnotationEditor {
                    #baseHeight = 0;
                    #baseWidth = 0;
                    #boundCanvasPointermove = this.canvasPointermove.bind(this);
                    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                    #boundCanvasPointerup = this.canvasPointerup.bind(this);
                    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                    #currentPath2D = new Path2D();
                    #disableEditing = false;
                    #hasSomethingToDraw = false;
                    #isCanvasInitialized = false;
                    #observer = null;
                    #realWidth = 0;
                    #realHeight = 0;
                    #requestFrameCallback = null;
                    static _defaultColor = null;
                    static _defaultOpacity = 1;
                    static _defaultThickness = 1;
                    static _type = "ink";
                    constructor(params){
                        super({
                            ...params,
                            name: "inkEditor"
                        });
                        this.color = params.color || null;
                        this.thickness = params.thickness || null;
                        this.opacity = params.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor._defaultThickness = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor._defaultColor = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor._defaultOpacity = value / 100;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                this.#updateThickness(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                this.#updateColor(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                this.#updateOpacity(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))
                            ]
                        ];
                    }
                    #updateThickness(thickness) {
                        const savedThickness = this.thickness;
                        this.addCommands({
                            cmd: ()=>{
                                this.thickness = thickness;
                                this.#fitToContent();
                            },
                            undo: ()=>{
                                this.thickness = savedThickness;
                                this.#fitToContent();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.color;
                        this.addCommands({
                            cmd: ()=>{
                                this.color = color;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.color = savedColor;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateOpacity(opacity) {
                        opacity /= 100;
                        const savedOpacity = this.opacity;
                        this.addCommands({
                            cmd: ()=>{
                                this.opacity = opacity;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.opacity = savedOpacity;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_OPACITY,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            this.#createCanvas();
                            this.#createObserver();
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            this.#setCanvasDims();
                        }
                        this.#fitToContent();
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        this.#observer.disconnect();
                        this.#observer = null;
                        super.remove();
                    }
                    setParent(parent) {
                        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent);
                    }
                    onScaleChanging() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const width = this.width * parentWidth;
                        const height = this.height * parentHeight;
                        this.setDimensions(width, height);
                    }
                    enableEditMode() {
                        if (this.#disableEditing || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    #getInitialBBox() {
                        const { parentRotation, parentDimensions: [width, height] } = this;
                        switch(parentRotation){
                            case 90:
                                return [
                                    0,
                                    height,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    width,
                                    height,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    width,
                                    0,
                                    height,
                                    width
                                ];
                            default:
                                return [
                                    0,
                                    0,
                                    width,
                                    height
                                ];
                        }
                    }
                    #setStroke() {
                        const { ctx, color, opacity, thickness, parentScale, scaleFactor } = this;
                        ctx.lineWidth = thickness * parentScale / scaleFactor;
                        ctx.lineCap = "round";
                        ctx.lineJoin = "round";
                        ctx.miterLimit = 10;
                        ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                    }
                    #startDrawing(x, y) {
                        this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                        this.isEditing = true;
                        if (!this.#isCanvasInitialized) {
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.thickness ||= InkEditor._defaultThickness;
                            this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                            this.opacity ??= InkEditor._defaultOpacity;
                        }
                        this.currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = false;
                        this.#setStroke();
                        this.#requestFrameCallback = ()=>{
                            this.#drawPoints();
                            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
                        };
                        window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                    #draw(x, y) {
                        const [lastX, lastY] = this.currentPath.at(-1);
                        if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                        const currentPath = this.currentPath;
                        let path2D = this.#currentPath2D;
                        currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = true;
                        if (currentPath.length <= 2) {
                            path2D.moveTo(...currentPath[0]);
                            path2D.lineTo(x, y);
                            return;
                        }
                        if (currentPath.length === 3) {
                            this.#currentPath2D = path2D = new Path2D();
                            path2D.moveTo(...currentPath[0]);
                        }
                        this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                    }
                    #endPath() {
                        if (this.currentPath.length === 0) return;
                        const lastPoint = this.currentPath.at(-1);
                        this.#currentPath2D.lineTo(...lastPoint);
                    }
                    #stopDrawing(x, y) {
                        this.#requestFrameCallback = null;
                        x = Math.min(Math.max(x, 0), this.canvas.width);
                        y = Math.min(Math.max(y, 0), this.canvas.height);
                        this.#draw(x, y);
                        this.#endPath();
                        let bezier;
                        if (this.currentPath.length !== 1) bezier = this.#generateBezierPoints();
                        else {
                            const xy = [
                                x,
                                y
                            ];
                            bezier = [
                                [
                                    xy,
                                    xy.slice(),
                                    xy.slice(),
                                    xy
                                ]
                            ];
                        }
                        const path2D = this.#currentPath2D;
                        const currentPath = this.currentPath;
                        this.currentPath = [];
                        this.#currentPath2D = new Path2D();
                        const cmd = ()=>{
                            this.allRawPaths.push(currentPath);
                            this.paths.push(bezier);
                            this.bezierPath2D.push(path2D);
                            this.rebuild();
                        };
                        const undo = ()=>{
                            this.allRawPaths.pop();
                            this.paths.pop();
                            this.bezierPath2D.pop();
                            if (this.paths.length === 0) this.remove();
                            else {
                                if (!this.canvas) {
                                    this.#createCanvas();
                                    this.#createObserver();
                                }
                                this.#fitToContent();
                            }
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    #drawPoints() {
                        if (!this.#hasSomethingToDraw) return;
                        this.#hasSomethingToDraw = false;
                        const thickness = Math.ceil(this.thickness * this.parentScale);
                        const lastPoints = this.currentPath.slice(-3);
                        const x = lastPoints.map((xy)=>xy[0]);
                        const y = lastPoints.map((xy)=>xy[1]);
                        const xMin = Math.min(...x) - thickness;
                        const xMax = Math.max(...x) + thickness;
                        const yMin = Math.min(...y) - thickness;
                        const yMax = Math.max(...y) + thickness;
                        const { ctx } = this;
                        ctx.save();
                        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                        ctx.stroke(this.#currentPath2D);
                        ctx.restore();
                    }
                    #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                        const prevX = (x0 + x1) / 2;
                        const prevY = (y0 + y1) / 2;
                        const x3 = (x1 + x2) / 2;
                        const y3 = (y1 + y2) / 2;
                        path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                    }
                    #generateBezierPoints() {
                        const path = this.currentPath;
                        if (path.length <= 2) return [
                            [
                                path[0],
                                path[0],
                                path.at(-1),
                                path.at(-1)
                            ]
                        ];
                        const bezierPoints = [];
                        let i;
                        let [x0, y0] = path[0];
                        for(i = 1; i < path.length - 2; i++){
                            const [x1, y1] = path[i];
                            const [x2, y2] = path[i + 1];
                            const x3 = (x1 + x2) / 2;
                            const y3 = (y1 + y2) / 2;
                            const control1 = [
                                x0 + 2 * (x1 - x0) / 3,
                                y0 + 2 * (y1 - y0) / 3
                            ];
                            const control2 = [
                                x3 + 2 * (x1 - x3) / 3,
                                y3 + 2 * (y1 - y3) / 3
                            ];
                            bezierPoints.push([
                                [
                                    x0,
                                    y0
                                ],
                                control1,
                                control2,
                                [
                                    x3,
                                    y3
                                ]
                            ]);
                            [x0, y0] = [
                                x3,
                                y3
                            ];
                        }
                        const [x1, y1] = path[i];
                        const [x2, y2] = path[i + 1];
                        const control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        const control2 = [
                            x2 + 2 * (x1 - x2) / 3,
                            y2 + 2 * (y1 - y2) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x2,
                                y2
                            ]
                        ]);
                        return bezierPoints;
                    }
                    #redraw() {
                        if (this.isEmpty()) {
                            this.#updateTransform();
                            return;
                        }
                        this.#setStroke();
                        const { canvas, ctx } = this;
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        this.#updateTransform();
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                    }
                    commit() {
                        if (this.#disableEditing) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        this.#disableEditing = true;
                        this.div.classList.add("disabled");
                        this.#fitToContent(true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event) {
                        if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
                        this.setInForeground();
                        event.preventDefault();
                        if (event.type !== "mouse") this.div.focus();
                        this.#startDrawing(event.offsetX, event.offsetY);
                    }
                    canvasPointermove(event) {
                        event.preventDefault();
                        this.#draw(event.offsetX, event.offsetY);
                    }
                    canvasPointerup(event) {
                        event.preventDefault();
                        this.#endDrawing(event);
                    }
                    canvasPointerleave(event) {
                        this.#endDrawing(event);
                    }
                    #endDrawing(event) {
                        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                        setTimeout(()=>{
                            this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                        }, 10);
                        this.#stopDrawing(event.offsetX, event.offsetY);
                        this.addToAnnotationStorage();
                        this.setInBackground();
                    }
                    #createCanvas() {
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.className = "inkEditorCanvas";
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg)=>this.canvas?.setAttribute("aria-label", msg));
                        this.div.append(this.canvas);
                        this.ctx = this.canvas.getContext("2d");
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    get isResizable() {
                        return !this.isEmpty() && this.#disableEditing;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg)=>this.div?.setAttribute("aria-label", msg));
                        const [x, y, w, h] = this.#getInitialBBox();
                        this.setAt(x, y, 0, 0);
                        this.setDims(w, h);
                        this.#createCanvas();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.setDims(this.width * parentWidth, this.height * parentHeight);
                            this.#redraw();
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        this.#createObserver();
                        return this.div;
                    }
                    #setCanvasDims() {
                        if (!this.#isCanvasInitialized) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.canvas.width = Math.ceil(this.width * parentWidth);
                        this.canvas.height = Math.ceil(this.height * parentHeight);
                        this.#updateTransform();
                    }
                    setDimensions(width, height) {
                        const roundedWidth = Math.round(width);
                        const roundedHeight = Math.round(height);
                        if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) return;
                        this.#realWidth = roundedWidth;
                        this.#realHeight = roundedHeight;
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.fixAndSetPosition();
                        if (this.#disableEditing) this.#setScaleFactor(width, height);
                        this.#setCanvasDims();
                        this.#redraw();
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    #setScaleFactor(width, height) {
                        const padding = this.#getPadding();
                        const scaleFactorW = (width - padding) / this.#baseWidth;
                        const scaleFactorH = (height - padding) / this.#baseHeight;
                        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                    }
                    #updateTransform() {
                        const padding = this.#getPadding() / 2;
                        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                    }
                    static #buildPath2D(bezier) {
                        const path2D = new Path2D();
                        for(let i = 0, ii = bezier.length; i < ii; i++){
                            const [first, control1, control2, second] = bezier[i];
                            if (i === 0) path2D.moveTo(...first);
                            path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                        }
                        return path2D;
                    }
                    static #toPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] += blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] + blX;
                                    points[i + 1] = x + blY;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] += blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trX - points[i + 1];
                                    points[i + 1] = trY - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    static #fromPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] -= blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] - blY;
                                    points[i + 1] = x - blX;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] -= blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trY - points[i + 1];
                                    points[i + 1] = trX - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    #serializePaths(s, tx, ty, rect) {
                        const paths = [];
                        const padding = this.thickness / 2;
                        const shiftX = s * tx + padding;
                        const shiftY = s * ty + padding;
                        for (const bezier of this.paths){
                            const buffer = [];
                            const points = [];
                            for(let j = 0, jj = bezier.length; j < jj; j++){
                                const [first, control1, control2, second] = bezier[j];
                                const p10 = s * first[0] + shiftX;
                                const p11 = s * first[1] + shiftY;
                                const p20 = s * control1[0] + shiftX;
                                const p21 = s * control1[1] + shiftY;
                                const p30 = s * control2[0] + shiftX;
                                const p31 = s * control2[1] + shiftY;
                                const p40 = s * second[0] + shiftX;
                                const p41 = s * second[1] + shiftY;
                                if (j === 0) {
                                    buffer.push(p10, p11);
                                    points.push(p10, p11);
                                }
                                buffer.push(p20, p21, p30, p31, p40, p41);
                                points.push(p20, p21);
                                if (j === jj - 1) points.push(p40, p41);
                            }
                            paths.push({
                                bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                                points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
                            });
                        }
                        return paths;
                    }
                    #getBbox() {
                        let xMin = Infinity;
                        let xMax = -Infinity;
                        let yMin = Infinity;
                        let yMax = -Infinity;
                        for (const path of this.paths)for (const [first, control1, control2, second] of path){
                            const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                            xMin = Math.min(xMin, bbox[0]);
                            yMin = Math.min(yMin, bbox[1]);
                            xMax = Math.max(xMax, bbox[2]);
                            yMax = Math.max(yMax, bbox[3]);
                        }
                        return [
                            xMin,
                            yMin,
                            xMax,
                            yMax
                        ];
                    }
                    #getPadding() {
                        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                    }
                    #fitToContent(firstTime = false) {
                        if (this.isEmpty()) return;
                        if (!this.#disableEditing) {
                            this.#redraw();
                            return;
                        }
                        const bbox = this.#getBbox();
                        const padding = this.#getPadding();
                        this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
                        const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setAspectRatio(width, height);
                        const prevTranslationX = this.translationX;
                        const prevTranslationY = this.translationY;
                        this.translationX = -bbox[0];
                        this.translationY = -bbox[1];
                        this.#setCanvasDims();
                        this.#redraw();
                        this.#realWidth = width;
                        this.#realHeight = height;
                        this.setDims(width, height);
                        const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.thickness = data.thickness;
                        editor.color = _util.Util.makeHexColor(...data.color);
                        editor.opacity = data.opacity;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const width = editor.width * pageWidth;
                        const height = editor.height * pageHeight;
                        const scaleFactor = editor.parentScale;
                        const padding = data.thickness / 2;
                        editor.#disableEditing = true;
                        editor.#realWidth = Math.round(width);
                        editor.#realHeight = Math.round(height);
                        const { paths, rect, rotation } = data;
                        for (let { bezier } of paths){
                            bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
                            const path = [];
                            editor.paths.push(path);
                            let p0 = scaleFactor * (bezier[0] - padding);
                            let p1 = scaleFactor * (bezier[1] - padding);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const p10 = scaleFactor * (bezier[i] - padding);
                                const p11 = scaleFactor * (bezier[i + 1] - padding);
                                const p20 = scaleFactor * (bezier[i + 2] - padding);
                                const p21 = scaleFactor * (bezier[i + 3] - padding);
                                const p30 = scaleFactor * (bezier[i + 4] - padding);
                                const p31 = scaleFactor * (bezier[i + 5] - padding);
                                path.push([
                                    [
                                        p0,
                                        p1
                                    ],
                                    [
                                        p10,
                                        p11
                                    ],
                                    [
                                        p20,
                                        p21
                                    ],
                                    [
                                        p30,
                                        p31
                                    ]
                                ]);
                                p0 = p30;
                                p1 = p31;
                            }
                            const path2D = this.#buildPath2D(path);
                            editor.bezierPath2D.push(path2D);
                        }
                        const bbox = editor.#getBbox();
                        editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        editor.#setScaleFactor(width, height);
                        return editor;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect = this.getRect(0, 0);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util.AnnotationEditorType.INK,
                            color: color,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                class StampEditor extends _editor.AnnotationEditor {
                    #bitmap = null;
                    #bitmapId = null;
                    #bitmapPromise = null;
                    #bitmapUrl = null;
                    #bitmapFile = null;
                    #canvas = null;
                    #observer = null;
                    #resizeTimeoutId = null;
                    #isSvg = false;
                    #hasBeenAddedInUndoStack = false;
                    static _type = "stamp";
                    constructor(params){
                        super({
                            ...params,
                            name: "stampEditor"
                        });
                        this.#bitmapUrl = params.bitmapUrl;
                        this.#bitmapFile = params.bitmapFile;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n);
                    }
                    static get supportedTypes() {
                        const types = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util.shadow)(this, "supportedTypes", types.map((type)=>`image/${type}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime) {
                        return this.supportedTypes.includes(mime);
                    }
                    static paste(item, parent) {
                        parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                            bitmapFile: item.getAsFile()
                        });
                    }
                    #getBitmapFetched(data, fromId = false) {
                        if (!data) {
                            this.remove();
                            return;
                        }
                        this.#bitmap = data.bitmap;
                        if (!fromId) {
                            this.#bitmapId = data.id;
                            this.#isSvg = data.isSvg;
                        }
                        this.#createCanvas();
                    }
                    #getBitmapDone() {
                        this.#bitmapPromise = null;
                        this._uiManager.enableWaiting(false);
                        if (this.#canvas) this.div.focus();
                    }
                    #getBitmap() {
                        if (this.#bitmapId) {
                            this._uiManager.enableWaiting(true);
                            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapUrl) {
                            const url = this.#bitmapUrl;
                            this.#bitmapUrl = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapFile) {
                            const file = this.#bitmapFile;
                            this.#bitmapFile = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        const input = document.createElement("input");
                        input.type = "file";
                        input.accept = StampEditor.supportedTypesStr;
                        this.#bitmapPromise = new Promise((resolve)=>{
                            input.addEventListener("change", async ()=>{
                                if (!input.files || input.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                                    this.#getBitmapFetched(data);
                                }
                                resolve();
                            });
                            input.addEventListener("cancel", ()=>{
                                this.remove();
                                resolve();
                            });
                        }).finally(()=>this.#getBitmapDone());
                        input.click();
                    }
                    remove() {
                        if (this.#bitmapId) {
                            this.#bitmap = null;
                            this._uiManager.imageManager.deleteId(this.#bitmapId);
                            this.#canvas?.remove();
                            this.#canvas = null;
                            this.#observer?.disconnect();
                            this.#observer = null;
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if (this.#bitmapId) this.#getBitmap();
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if (this.#bitmapId) this.#getBitmap();
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if (this.#bitmap) this.#createCanvas();
                        else this.#getBitmap();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                        }
                        return this.div;
                    }
                    #createCanvas() {
                        const { div } = this;
                        let { width, height } = this.#bitmap;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const MAX_RATIO = 0.75;
                        if (this.width) {
                            width = this.width * pageWidth;
                            height = this.height * pageHeight;
                        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                            width *= factor;
                            height *= factor;
                        }
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                        this._uiManager.enableWaiting(false);
                        const canvas = this.#canvas = document.createElement("canvas");
                        div.append(canvas);
                        div.hidden = false;
                        this.#drawBitmap(width, height);
                        this.#createObserver();
                        if (!this.#hasBeenAddedInUndoStack) {
                            this.parent.addUndoableEditor(this);
                            this.#hasBeenAddedInUndoStack = true;
                        }
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                            source: this,
                            details: {
                                type: "editing",
                                subtype: this.editorType,
                                data: {
                                    action: "inserted_image"
                                }
                            }
                        });
                        this.addAltTextButton();
                    }
                    #setDimensions(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setDims(width, height);
                        if (this._initialOptions?.isCentered) this.center();
                        else this.fixAndSetPosition();
                        this._initialOptions = null;
                        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
                        const TIME_TO_WAIT = 200;
                        this.#resizeTimeoutId = setTimeout(()=>{
                            this.#resizeTimeoutId = null;
                            this.#drawBitmap(width, height);
                        }, TIME_TO_WAIT);
                    }
                    #scaleBitmap(width, height) {
                        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
                        let newWidth = bitmapWidth;
                        let newHeight = bitmapHeight;
                        let bitmap = this.#bitmap;
                        while(newWidth > 2 * width || newHeight > 2 * height){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                            const offscreen = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = offscreen.transferToImageBitmap();
                        }
                        return bitmap;
                    }
                    #drawBitmap(width, height) {
                        width = Math.ceil(width);
                        height = Math.ceil(height);
                        const canvas = this.#canvas;
                        if (!canvas || canvas.width === width && canvas.height === height) return;
                        canvas.width = width;
                        canvas.height = height;
                        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
                        const ctx = canvas.getContext("2d");
                        ctx.filter = this._uiManager.hcmFilter;
                        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                    }
                    #serializeBitmap(toUrl) {
                        if (toUrl) {
                            if (this.#isSvg) {
                                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                                if (url) return url;
                            }
                            const canvas = document.createElement("canvas");
                            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0);
                            return canvas.toDataURL();
                        }
                        if (this.#isSvg) {
                            const [pageWidth, pageHeight] = this.pageDimensions;
                            const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const offscreen = new OffscreenCanvas(width, height);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
                            return offscreen.transferToImageBitmap();
                        }
                        return structuredClone(this.#bitmap);
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.#setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        const { rect, bitmapUrl, bitmapId, isSvg, accessibilityData } = data;
                        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) editor.#bitmapId = bitmapId;
                        else editor.#bitmapUrl = bitmapUrl;
                        editor.#isSvg = isSvg;
                        const [parentWidth, parentHeight] = editor.pageDimensions;
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        if (accessibilityData) editor.altTextData = accessibilityData;
                        return editor;
                    }
                    serialize(isForCopying = false, context = null) {
                        if (this.isEmpty()) return null;
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.STAMP,
                            bitmapId: this.#bitmapId,
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: this.#isSvg,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) {
                            serialized.bitmapUrl = this.#serializeBitmap(true);
                            serialized.accessibilityData = this.altTextData;
                            return serialized;
                        }
                        const { decorative, altText } = this.altTextData;
                        if (!decorative && altText) serialized.accessibilityData = {
                            type: "Figure",
                            alt: altText
                        };
                        if (context === null) return serialized;
                        context.stamps ||= new Map();
                        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                        if (!context.stamps.has(this.#bitmapId)) {
                            context.stamps.set(this.#bitmapId, {
                                area: area,
                                serialized: serialized
                            });
                            serialized.bitmap = this.#serializeBitmap(false);
                        } else if (this.#isSvg) {
                            const prevData = context.stamps.get(this.#bitmapId);
                            if (area > prevData.area) {
                                prevData.area = area;
                                prevData.serialized.bitmap.close();
                                prevData.serialized.bitmap = this.#serializeBitmap(false);
                            }
                        }
                        return serialized;
                    }
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = '3.11.174';
            const pdfjsBuild = 'ce8716743';
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("f2Nvv", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $af3d72024532fa73$export$a143d493d941bafc, (v) => $af3d72024532fa73$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $af3d72024532fa73$export$f99ded8fe4b79145, (v) => $af3d72024532fa73$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $af3d72024532fa73$export$a143d493d941bafc;
var $af3d72024532fa73$export$e4cf37d7f6fb9e0a;
var $af3d72024532fa73$export$f99ded8fe4b79145;
var $af3d72024532fa73$export$599f31c3813fae4d;
'use strict';

var $jPqBZ = parcelRequire("jPqBZ");

var $oaTF8 = parcelRequire("oaTF8");
var $af3d72024532fa73$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$af3d72024532fa73$export$a143d493d941bafc = $af3d72024532fa73$var$Buffer;
$af3d72024532fa73$export$e4cf37d7f6fb9e0a = $af3d72024532fa73$var$SlowBuffer;
$af3d72024532fa73$export$f99ded8fe4b79145 = 50;
var $af3d72024532fa73$var$K_MAX_LENGTH = 0x7fffffff;
$af3d72024532fa73$export$599f31c3813fae4d = $af3d72024532fa73$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $af3d72024532fa73$var$Buffer.TYPED_ARRAY_SUPPORT = $af3d72024532fa73$var$typedArraySupport();
if (!$af3d72024532fa73$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $af3d72024532fa73$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($af3d72024532fa73$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$af3d72024532fa73$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($af3d72024532fa73$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$af3d72024532fa73$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $af3d72024532fa73$var$createBuffer(length) {
    if (length > $af3d72024532fa73$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $af3d72024532fa73$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $af3d72024532fa73$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $af3d72024532fa73$var$allocUnsafe(arg);
    }
    return $af3d72024532fa73$var$from(arg, encodingOrOffset, length);
}
$af3d72024532fa73$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $af3d72024532fa73$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $af3d72024532fa73$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $af3d72024532fa73$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($af3d72024532fa73$var$isInstance(value, ArrayBuffer) || value && $af3d72024532fa73$var$isInstance(value.buffer, ArrayBuffer)) return $af3d72024532fa73$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($af3d72024532fa73$var$isInstance(value, SharedArrayBuffer) || value && $af3d72024532fa73$var$isInstance(value.buffer, SharedArrayBuffer))) return $af3d72024532fa73$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $af3d72024532fa73$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $af3d72024532fa73$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $af3d72024532fa73$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $af3d72024532fa73$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $af3d72024532fa73$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($af3d72024532fa73$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($af3d72024532fa73$var$Buffer, Uint8Array);
function $af3d72024532fa73$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $af3d72024532fa73$var$alloc(size, fill, encoding) {
    $af3d72024532fa73$var$assertSize(size);
    if (size <= 0) return $af3d72024532fa73$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $af3d72024532fa73$var$createBuffer(size).fill(fill, encoding) : $af3d72024532fa73$var$createBuffer(size).fill(fill);
    return $af3d72024532fa73$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $af3d72024532fa73$var$Buffer.alloc = function(size, fill, encoding) {
    return $af3d72024532fa73$var$alloc(size, fill, encoding);
};
function $af3d72024532fa73$var$allocUnsafe(size) {
    $af3d72024532fa73$var$assertSize(size);
    return $af3d72024532fa73$var$createBuffer(size < 0 ? 0 : $af3d72024532fa73$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $af3d72024532fa73$var$Buffer.allocUnsafe = function(size) {
    return $af3d72024532fa73$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $af3d72024532fa73$var$Buffer.allocUnsafeSlow = function(size) {
    return $af3d72024532fa73$var$allocUnsafe(size);
};
function $af3d72024532fa73$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$af3d72024532fa73$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $af3d72024532fa73$var$byteLength(string, encoding) | 0;
    var buf = $af3d72024532fa73$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $af3d72024532fa73$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $af3d72024532fa73$var$checked(array.length) | 0;
    var buf = $af3d72024532fa73$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $af3d72024532fa73$var$fromArrayView(arrayView) {
    if ($af3d72024532fa73$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $af3d72024532fa73$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $af3d72024532fa73$var$fromArrayLike(arrayView);
}
function $af3d72024532fa73$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $af3d72024532fa73$var$Buffer.prototype);
    return buf;
}
function $af3d72024532fa73$var$fromObject(obj) {
    if ($af3d72024532fa73$var$Buffer.isBuffer(obj)) {
        var len = $af3d72024532fa73$var$checked(obj.length) | 0;
        var buf = $af3d72024532fa73$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $af3d72024532fa73$var$numberIsNaN(obj.length)) return $af3d72024532fa73$var$createBuffer(0);
        return $af3d72024532fa73$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $af3d72024532fa73$var$fromArrayLike(obj.data);
}
function $af3d72024532fa73$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $af3d72024532fa73$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $af3d72024532fa73$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $af3d72024532fa73$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $af3d72024532fa73$var$Buffer.alloc(+length);
}
$af3d72024532fa73$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $af3d72024532fa73$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$af3d72024532fa73$var$Buffer.compare = function compare(a, b) {
    if ($af3d72024532fa73$var$isInstance(a, Uint8Array)) a = $af3d72024532fa73$var$Buffer.from(a, a.offset, a.byteLength);
    if ($af3d72024532fa73$var$isInstance(b, Uint8Array)) b = $af3d72024532fa73$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$af3d72024532fa73$var$Buffer.isBuffer(a) || !$af3d72024532fa73$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$af3d72024532fa73$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$af3d72024532fa73$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $af3d72024532fa73$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $af3d72024532fa73$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($af3d72024532fa73$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $af3d72024532fa73$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$af3d72024532fa73$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $af3d72024532fa73$var$byteLength(string, encoding) {
    if ($af3d72024532fa73$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $af3d72024532fa73$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $af3d72024532fa73$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $af3d72024532fa73$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $af3d72024532fa73$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$af3d72024532fa73$var$Buffer.byteLength = $af3d72024532fa73$var$byteLength;
function $af3d72024532fa73$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $af3d72024532fa73$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $af3d72024532fa73$var$utf8Slice(this, start, end);
        case 'ascii':
            return $af3d72024532fa73$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $af3d72024532fa73$var$latin1Slice(this, start, end);
        case 'base64':
            return $af3d72024532fa73$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $af3d72024532fa73$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$af3d72024532fa73$var$Buffer.prototype._isBuffer = true;
function $af3d72024532fa73$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$af3d72024532fa73$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$af3d72024532fa73$var$swap(this, i, i + 1);
    return this;
};
$af3d72024532fa73$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $af3d72024532fa73$var$swap(this, i, i + 3);
        $af3d72024532fa73$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$af3d72024532fa73$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $af3d72024532fa73$var$swap(this, i, i + 7);
        $af3d72024532fa73$var$swap(this, i + 1, i + 6);
        $af3d72024532fa73$var$swap(this, i + 2, i + 5);
        $af3d72024532fa73$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$af3d72024532fa73$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $af3d72024532fa73$var$utf8Slice(this, 0, length);
    return $af3d72024532fa73$var$slowToString.apply(this, arguments);
};
$af3d72024532fa73$var$Buffer.prototype.toLocaleString = $af3d72024532fa73$var$Buffer.prototype.toString;
$af3d72024532fa73$var$Buffer.prototype.equals = function equals(b) {
    if (!$af3d72024532fa73$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $af3d72024532fa73$var$Buffer.compare(this, b) === 0;
};
$af3d72024532fa73$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $af3d72024532fa73$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($af3d72024532fa73$var$customInspectSymbol) $af3d72024532fa73$var$Buffer.prototype[$af3d72024532fa73$var$customInspectSymbol] = $af3d72024532fa73$var$Buffer.prototype.inspect;
$af3d72024532fa73$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($af3d72024532fa73$var$isInstance(target, Uint8Array)) target = $af3d72024532fa73$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$af3d72024532fa73$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $af3d72024532fa73$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($af3d72024532fa73$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $af3d72024532fa73$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($af3d72024532fa73$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $af3d72024532fa73$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $af3d72024532fa73$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $af3d72024532fa73$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$af3d72024532fa73$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$af3d72024532fa73$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $af3d72024532fa73$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$af3d72024532fa73$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $af3d72024532fa73$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $af3d72024532fa73$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($af3d72024532fa73$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $af3d72024532fa73$var$utf8Write(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $af3d72024532fa73$var$asciiWrite(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$asciiToBytes(string), buf, offset, length);
}
function $af3d72024532fa73$var$base64Write(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$base64ToBytes(string), buf, offset, length);
}
function $af3d72024532fa73$var$ucs2Write(buf, string, offset, length) {
    return $af3d72024532fa73$var$blitBuffer($af3d72024532fa73$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$af3d72024532fa73$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $af3d72024532fa73$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $af3d72024532fa73$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $af3d72024532fa73$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $af3d72024532fa73$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $af3d72024532fa73$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$af3d72024532fa73$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $af3d72024532fa73$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jPqBZ.fromByteArray(buf);
    else return $jPqBZ.fromByteArray(buf.slice(start, end));
}
function $af3d72024532fa73$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $af3d72024532fa73$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $af3d72024532fa73$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $af3d72024532fa73$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $af3d72024532fa73$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $af3d72024532fa73$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $af3d72024532fa73$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $af3d72024532fa73$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $af3d72024532fa73$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $af3d72024532fa73$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $af3d72024532fa73$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$af3d72024532fa73$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $af3d72024532fa73$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $af3d72024532fa73$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$af3d72024532fa73$var$Buffer.prototype.readUintLE = $af3d72024532fa73$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readUintBE = $af3d72024532fa73$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readUint8 = $af3d72024532fa73$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$af3d72024532fa73$var$Buffer.prototype.readUint16LE = $af3d72024532fa73$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$af3d72024532fa73$var$Buffer.prototype.readUint16BE = $af3d72024532fa73$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$af3d72024532fa73$var$Buffer.prototype.readUint32LE = $af3d72024532fa73$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$af3d72024532fa73$var$Buffer.prototype.readUint32BE = $af3d72024532fa73$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$af3d72024532fa73$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$af3d72024532fa73$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$af3d72024532fa73$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$af3d72024532fa73$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$af3d72024532fa73$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$af3d72024532fa73$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$af3d72024532fa73$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return $oaTF8.read(this, offset, true, 23, 4);
};
$af3d72024532fa73$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 4, this.length);
    return $oaTF8.read(this, offset, false, 23, 4);
};
$af3d72024532fa73$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 8, this.length);
    return $oaTF8.read(this, offset, true, 52, 8);
};
$af3d72024532fa73$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkOffset(offset, 8, this.length);
    return $oaTF8.read(this, offset, false, 52, 8);
};
function $af3d72024532fa73$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$af3d72024532fa73$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$af3d72024532fa73$var$Buffer.prototype.writeUintLE = $af3d72024532fa73$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeUintBE = $af3d72024532fa73$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint8 = $af3d72024532fa73$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint16LE = $af3d72024532fa73$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint16BE = $af3d72024532fa73$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint32LE = $af3d72024532fa73$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$af3d72024532fa73$var$Buffer.prototype.writeUint32BE = $af3d72024532fa73$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$af3d72024532fa73$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $af3d72024532fa73$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$af3d72024532fa73$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $af3d72024532fa73$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $af3d72024532fa73$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $oaTF8.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$af3d72024532fa73$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeFloat(this, value, offset, true, noAssert);
};
$af3d72024532fa73$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeFloat(this, value, offset, false, noAssert);
};
function $af3d72024532fa73$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $af3d72024532fa73$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $oaTF8.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$af3d72024532fa73$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeDouble(this, value, offset, true, noAssert);
};
$af3d72024532fa73$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $af3d72024532fa73$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$af3d72024532fa73$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$af3d72024532fa73$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$af3d72024532fa73$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$af3d72024532fa73$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $af3d72024532fa73$var$Buffer.isBuffer(val) ? val : $af3d72024532fa73$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $af3d72024532fa73$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $af3d72024532fa73$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($af3d72024532fa73$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $af3d72024532fa73$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $af3d72024532fa73$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $af3d72024532fa73$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $af3d72024532fa73$var$base64ToBytes(str) {
    return $jPqBZ.toByteArray($af3d72024532fa73$var$base64clean(str));
}
function $af3d72024532fa73$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $af3d72024532fa73$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $af3d72024532fa73$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $af3d72024532fa73$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});

parcelRegister("aOKBQ", function(module, exports) {
// shim for using process in browser
var $7e02ba8c6c2d8bfb$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7e02ba8c6c2d8bfb$var$cachedSetTimeout;
var $7e02ba8c6c2d8bfb$var$cachedClearTimeout;
function $7e02ba8c6c2d8bfb$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $7e02ba8c6c2d8bfb$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $7e02ba8c6c2d8bfb$var$cachedSetTimeout = setTimeout;
        else $7e02ba8c6c2d8bfb$var$cachedSetTimeout = $7e02ba8c6c2d8bfb$var$defaultSetTimout;
    } catch (e) {
        $7e02ba8c6c2d8bfb$var$cachedSetTimeout = $7e02ba8c6c2d8bfb$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $7e02ba8c6c2d8bfb$var$cachedClearTimeout = clearTimeout;
        else $7e02ba8c6c2d8bfb$var$cachedClearTimeout = $7e02ba8c6c2d8bfb$var$defaultClearTimeout;
    } catch (e) {
        $7e02ba8c6c2d8bfb$var$cachedClearTimeout = $7e02ba8c6c2d8bfb$var$defaultClearTimeout;
    }
})();
function $7e02ba8c6c2d8bfb$var$runTimeout(fun) {
    if ($7e02ba8c6c2d8bfb$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7e02ba8c6c2d8bfb$var$cachedSetTimeout === $7e02ba8c6c2d8bfb$var$defaultSetTimout || !$7e02ba8c6c2d8bfb$var$cachedSetTimeout) && setTimeout) {
        $7e02ba8c6c2d8bfb$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7e02ba8c6c2d8bfb$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7e02ba8c6c2d8bfb$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7e02ba8c6c2d8bfb$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7e02ba8c6c2d8bfb$var$runClearTimeout(marker) {
    if ($7e02ba8c6c2d8bfb$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7e02ba8c6c2d8bfb$var$cachedClearTimeout === $7e02ba8c6c2d8bfb$var$defaultClearTimeout || !$7e02ba8c6c2d8bfb$var$cachedClearTimeout) && clearTimeout) {
        $7e02ba8c6c2d8bfb$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7e02ba8c6c2d8bfb$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7e02ba8c6c2d8bfb$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7e02ba8c6c2d8bfb$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7e02ba8c6c2d8bfb$var$queue = [];
var $7e02ba8c6c2d8bfb$var$draining = false;
var $7e02ba8c6c2d8bfb$var$currentQueue;
var $7e02ba8c6c2d8bfb$var$queueIndex = -1;
function $7e02ba8c6c2d8bfb$var$cleanUpNextTick() {
    if (!$7e02ba8c6c2d8bfb$var$draining || !$7e02ba8c6c2d8bfb$var$currentQueue) return;
    $7e02ba8c6c2d8bfb$var$draining = false;
    if ($7e02ba8c6c2d8bfb$var$currentQueue.length) $7e02ba8c6c2d8bfb$var$queue = $7e02ba8c6c2d8bfb$var$currentQueue.concat($7e02ba8c6c2d8bfb$var$queue);
    else $7e02ba8c6c2d8bfb$var$queueIndex = -1;
    if ($7e02ba8c6c2d8bfb$var$queue.length) $7e02ba8c6c2d8bfb$var$drainQueue();
}
function $7e02ba8c6c2d8bfb$var$drainQueue() {
    if ($7e02ba8c6c2d8bfb$var$draining) return;
    var timeout = $7e02ba8c6c2d8bfb$var$runTimeout($7e02ba8c6c2d8bfb$var$cleanUpNextTick);
    $7e02ba8c6c2d8bfb$var$draining = true;
    var len = $7e02ba8c6c2d8bfb$var$queue.length;
    while(len){
        $7e02ba8c6c2d8bfb$var$currentQueue = $7e02ba8c6c2d8bfb$var$queue;
        $7e02ba8c6c2d8bfb$var$queue = [];
        while(++$7e02ba8c6c2d8bfb$var$queueIndex < len)if ($7e02ba8c6c2d8bfb$var$currentQueue) $7e02ba8c6c2d8bfb$var$currentQueue[$7e02ba8c6c2d8bfb$var$queueIndex].run();
        $7e02ba8c6c2d8bfb$var$queueIndex = -1;
        len = $7e02ba8c6c2d8bfb$var$queue.length;
    }
    $7e02ba8c6c2d8bfb$var$currentQueue = null;
    $7e02ba8c6c2d8bfb$var$draining = false;
    $7e02ba8c6c2d8bfb$var$runClearTimeout(timeout);
}
$7e02ba8c6c2d8bfb$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7e02ba8c6c2d8bfb$var$queue.push(new $7e02ba8c6c2d8bfb$var$Item(fun, args));
    if ($7e02ba8c6c2d8bfb$var$queue.length === 1 && !$7e02ba8c6c2d8bfb$var$draining) $7e02ba8c6c2d8bfb$var$runTimeout($7e02ba8c6c2d8bfb$var$drainQueue);
};
// v8 likes predictible objects
function $7e02ba8c6c2d8bfb$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7e02ba8c6c2d8bfb$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7e02ba8c6c2d8bfb$var$process.title = 'browser';
$7e02ba8c6c2d8bfb$var$process.browser = true;
$7e02ba8c6c2d8bfb$var$process.env = {};
$7e02ba8c6c2d8bfb$var$process.argv = [];
$7e02ba8c6c2d8bfb$var$process.version = ''; // empty string to avoid regexp issues
$7e02ba8c6c2d8bfb$var$process.versions = {};
function $7e02ba8c6c2d8bfb$var$noop() {}
$7e02ba8c6c2d8bfb$var$process.on = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.addListener = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.once = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.off = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.removeListener = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.removeAllListeners = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.emit = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.prependListener = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.prependOnceListener = $7e02ba8c6c2d8bfb$var$noop;
$7e02ba8c6c2d8bfb$var$process.listeners = function(name) {
    return [];
};
$7e02ba8c6c2d8bfb$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$7e02ba8c6c2d8bfb$var$process.cwd = function() {
    return '/';
};
$7e02ba8c6c2d8bfb$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$7e02ba8c6c2d8bfb$var$process.umask = function() {
    return 0;
};

});

parcelRegister("9zn7p", function(module, exports) {
"use strict";

});


parcelRegister("eO5xw", function(module, exports) {

$parcel$export(module.exports, "capitalizeFirstLetter", () => $6ab59bee0c56cc7a$export$d07f57595c356899);
const $6ab59bee0c56cc7a$export$d07f57595c356899 = (text, locale = 'fr-FR')=>{
    if (text && text.length > 0) {
        const first = text.charAt(0);
        const rest = text.slice(1);
        return first.toLocaleUpperCase(locale) + rest;
    }
    return '';
};

});

parcelRegister("l9TTE", function(module, exports) {

$parcel$export(module.exports, "Carousel", () => (parcelRequire("bQTDb")).default);
$parcel$export(module.exports, "Radio", () => (parcelRequire("k0gIL")).default);
$parcel$export(module.exports, "Swiper", () => (parcelRequire("o9qp2")).default);
$parcel$export(module.exports, "Toggle", () => (parcelRequire("66rUF")).default);
$parcel$export(module.exports, "Wheeler", () => (parcelRequire("fEfdX")).default);

var $bQTDb = parcelRequire("bQTDb");

var $k0gIL = parcelRequire("k0gIL");

var $7c6BL = parcelRequire("7c6BL");

var $o9qp2 = parcelRequire("o9qp2");

var $66rUF = parcelRequire("66rUF");

var $6aH4h = parcelRequire("6aH4h");

var $fEfdX = parcelRequire("fEfdX");

});
parcelRegister("bQTDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b92d705caaa237$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("7Jjoy");
var $3kuIS = parcelRequire("3kuIS");
var $iyJo4 = parcelRequire("iyJo4");
/**
 * Media types enum
 */ var $a3b92d705caaa237$var$MediaTypes = /*#__PURE__*/ function(MediaTypes) {
    MediaTypes[MediaTypes["image"] = 1] = "image";
    MediaTypes[MediaTypes["video"] = 2] = "video";
    return MediaTypes;
}($a3b92d705caaa237$var$MediaTypes || {});
const $a3b92d705caaa237$var$images = [
    'png',
    'gif',
    'jpg',
    'jpeg'
];
const $a3b92d705caaa237$var$videos = [
    'mp4',
    'webm',
    '3gp',
    'ogg'
];
const $a3b92d705caaa237$var$Carousel = ({ className: className, medias: medias, controls: controls, timer: timer, color: color, maxHeight: maxHeight })=>{
    const [currentIndex, setCurrentIndex] = (0, $bxRTa.useState)(0);
    const [currentMedia, setCurrentMedia] = (0, $bxRTa.useState)();
    const timerRef = (0, $bxRTa.useRef)(null);
    /**
   * On medias state change :
   *  - clear timerRef interval if set
   *  - call startNewMedia to reset medias
   *  - if there are more than 1 media, set a timeout and launch it
   * On component unmount :
   *  - clear timerRef interval if set
   */ (0, $bxRTa.useEffect)(()=>{
        // Clear interval
        timerRef.current && clearInterval(timerRef.current);
        // Call the reset function to set currentIndex and currentMedia states
        startNewMedias();
        // Launch timer only if there are more than 1 media
        if (medias.length > 1 && timer !== 0) timerRef.current = setTimeout(()=>{
            handleMore();
        }, timer || 3000);
        return ()=>timerRef.current && clearTimeout(timerRef.current);
    }, [
        medias
    ]);
    /**
   * On currentIndex state change :
   *  - check type of media in medias array at current index by calling checkType method
   *  - set currentMedia state
   */ (0, $bxRTa.useEffect)(()=>{
        if (currentIndex !== undefined) {
            const index = currentIndex % medias.length;
            const type = checkType(medias[index].url);
            if (type) {
                setCurrentMedia({
                    ...medias[index],
                    type: type
                });
                // Reset timer only if there are more than 1 media
                if (medias.length > 1 && timer !== 0) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = setTimeout(()=>{
                        handleMore();
                    }, timer || 3000);
                }
            }
        }
    }, [
        currentIndex
    ]);
    /**
   * On call :
   *  - check if the currentIndex state is 0
   *  - if so, if we just update this state to 0 it will remain the same and won't change the currentMedia state. We just leave currentIndex as is and set currentMedia state instead.
   *  - otherwise, set the currentIndex state to 0
   */ const startNewMedias = ()=>{
        if (currentIndex === 0) {
            const type = checkType(medias[0].url);
            if (type) setCurrentMedia({
                ...medias[0],
                type: type
            });
        } else setCurrentIndex(0);
    };
    /**
   * On call :
   *  - retrieve the extension of the media
   *  - return if it's either an image, or a video, or null
   * @param src : string
   * @returns number | null
   */ const checkType = (src)=>{
        const extension = src.split('.').slice(-1)[0];
        return $a3b92d705caaa237$var$images.includes(extension.toLowerCase()) ? 1 : $a3b92d705caaa237$var$videos.includes(extension.toLowerCase()) ? 2 : null;
    };
    const handleChoice = (choice)=>{
        setCurrentIndex(choice);
    };
    const handleLess = ()=>{
        currentIndex === 0 ? setCurrentIndex(medias.length - 1) : setCurrentIndex((currentIndex)=>currentIndex - 1);
    };
    const handleMore = ()=>{
        currentIndex === medias.length - 1 ? setCurrentIndex(0) : setCurrentIndex((currentIndex)=>currentIndex + 1);
    };
    return currentMedia && currentMedia.type ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            currentMedia.type === 1 ? /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                className: className,
                src: currentMedia.url,
                alt: currentMedia.alt || 'image',
                style: {
                    maxHeight: maxHeight
                }
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("video", {
                className: className,
                style: {
                    maxHeight: maxHeight
                },
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("source", {
                    src: currentMedia.url
                })
            }),
            controls && medias.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-bottom-4 rf-left-1/2 -rf-translate-x-1/2 rf-flex rf-flex-row rf-items-center rf-gap-2",
                        children: medias.map((media, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-3 rf-w-3 rf-rounded-half rf-border rf-border-truewhite rf-cursor-pointer",
                                onClick: ()=>handleChoice(key),
                                style: {
                                    backgroundColor: currentIndex === key ? color : 'transparent'
                                }
                            }, `${media.url}${key}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-left-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleLess,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3kuIS.default), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-right-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleMore,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $a3b92d705caaa237$export$2e2bcd8739ae039 = $a3b92d705caaa237$var$Carousel;

});
parcelRegister("7Jjoy", function(module, exports) {

$parcel$export(module.exports, "ChevronLeftIcon", () => (parcelRequire("3kuIS")).default);
$parcel$export(module.exports, "ChevronRightIcon", () => (parcelRequire("iyJo4")).default);

var $3kuIS = parcelRequire("3kuIS");

var $iyJo4 = parcelRequire("iyJo4");

var $fEqFQ = parcelRequire("fEqFQ");

});
parcelRegister("3kuIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $29977ff6d48b8474$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $29977ff6d48b8474$var$ChevronLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-4',
        viewBox: "0 0 7.414 12.828",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M1429.081,2861.407l5-5-5-5",
            transform: "translate(1435.081 2862.822) rotate(180)",
            fill: "none",
            stroke: color || '#fff',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
var $29977ff6d48b8474$export$2e2bcd8739ae039 = $29977ff6d48b8474$var$ChevronLeftIcon;

});

parcelRegister("iyJo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92eeef5002581ed$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f92eeef5002581ed$var$ChevronRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-4',
        viewBox: "0 0 10.131 17.719",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M8.863,7.077l6.7-6.705a1.261,1.261,0,0,1,1.788,0,1.277,1.277,0,0,1,0,1.794L9.76,9.762A1.264,1.264,0,0,1,8.014,9.8L.369,2.171A1.266,1.266,0,0,1,2.158.377Z",
            transform: "translate(0 17.719) rotate(-90)",
            fill: color || '#818181'
        })
    });
};
var $f92eeef5002581ed$export$2e2bcd8739ae039 = $f92eeef5002581ed$var$ChevronRightIcon;

});

parcelRegister("fEqFQ", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $3a23468e72ecffca$var$ChevronUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || 'currentColor',
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $3a23468e72ecffca$export$2e2bcd8739ae039 = $3a23468e72ecffca$var$ChevronUpIcon;

});



parcelRegister("k0gIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $96de6b7836aa192d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $96de6b7836aa192d$var$Radio = ({ className: className, title: title, handleChange: handleChange, checked: checked })=>{
    const [transition, setTransition] = (0, $bxRTa.useState)(checked ? 'rf-scale-1' : 'rf-scale-0');
    const handleToggle = ()=>{
        setTransition(checked ? 'rf-scale-0' : 'rf-scale-1');
        handleChange(title);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-row rf-items-center rf-justify-between hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-capitalize",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: `rf-relative rf-w-7 large:rf-w-8 large-vertical:rf-w-14 rf-min-w-7 large:rf-min-w-8 large-vertical:rf-min-w-14 rf-h-7 large:rf-h-8 large-vertical:rf-h-14 ${!checked && 'rf-border rf-border-[#9FA2AA]'} rf-rounded-half`,
                style: {
                    background: checked ? 'linear-gradient(to right, #1999B1, #0a4652)' : '#FFFFFF',
                    boxShadow: checked ? '-3px 3px 6px #00000029' : ''
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-absolute rf-top-2 large-vertical:rf-top-4 rf-left-2 large-vertical:rf-left-4 rf-w-3 large:rf-w-4 large-vertical:rf-w-6 rf-h-3 large:rf-h-4 large-vertical:rf-h-6 rf-rounded-half rf-bg-[#F8F8F8] rf-transition-all ${transition}`
                })
            })
        ]
    });
};
var $96de6b7836aa192d$export$2e2bcd8739ae039 = $96de6b7836aa192d$var$Radio;

});

parcelRegister("7c6BL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8c2248156e4a90$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $hdMz2 = parcelRequire("hdMz2");

var $giKuE = parcelRequire("giKuE");
var $7e8c2248156e4a90$var$EventsReceived = /*#__PURE__*/ function(EventsReceived) {
    EventsReceived[EventsReceived["retorikSendActivity"] = 1] = "retorikSendActivity";
    EventsReceived[EventsReceived["retorikSendEvent"] = 2] = "retorikSendEvent";
    EventsReceived[EventsReceived["retorikStartListening"] = 3] = "retorikStartListening";
    EventsReceived[EventsReceived["retorikDisplaySubtitles"] = 4] = "retorikDisplaySubtitles";
    EventsReceived[EventsReceived["retorikSetVisibility"] = 5] = "retorikSetVisibility";
    return EventsReceived;
}($7e8c2248156e4a90$var$EventsReceived || {});
const $7e8c2248156e4a90$var$SendActivityEventListener = ({ isRetorikNews: isRetorikNews, hasConversationCookie: hasConversationCookie, userData: userData })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const activityToSend = (0, $4xGiN.useUtilsStore)((state)=>state.activityToSend);
    const displayGDPR = (0, $4xGiN.useUtilsStore)((state)=>state.GDPRDisplay);
    const userConsent = (0, $4xGiN.useUtilsStore)((state)=>state.GDPRUserConsent);
    const sendUtilActivity = (0, $4xGiN.useUtilsStore)((state)=>state.actions.sendActivity);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const appAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.appAvailable);
    const skipWelcome = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.skipWelcome);
    const userAlreadySet = (0, $7SHCs.useRetorikStore)((state)=>state.userAlreadySet);
    const isMicrophoneAllowed = (0, $giKuE.useSpeechStore)((state)=>state.isMicrophoneAllowed);
    const characterLoaded = (0, $9JLpC.useViewStore)((state)=>state.characterLoaded);
    const setVisibility = (0, $9JLpC.useViewStore)((state)=>state.actions.setVisibility);
    const askPermission = (0, $giKuE.useSpeechStore)((state)=>state.actions.askPermission);
    const { setDisplaySubtitles: setDisplaySubtitles, setUserAlreadySet: setUserAlreadySet } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const toggleMicrophone = (0, $giKuE.useSpeechStore)((state)=>state.actions.toggleMicrophone);
    const { sendMessage: sendMessage, sendEvent: sendEvent } = (0, $hdMz2.useDirectlineStore)((state)=>state.actions);
    const [eventReceived, setEventReceived] = (0, $bxRTa.useState)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (eventReceived) try {
            switch(eventReceived.type){
                case 1:
                    eventReceived.detail && sendMessage(undefined, eventReceived.detail);
                    break;
                case 4:
                    setDisplaySubtitles(!!eventReceived.detail);
                    break;
                case 3:
                    isMicrophoneAllowed ? toggleMicrophone() : askPermission();
                    break;
                case 2:
                    eventReceived.detail && sendEvent(eventReceived.detail.name, eventReceived.detail.value);
                    break;
                case 5:
                    eventReceived.detail && setVisibility(eventReceived.detail);
                    break;
            }
        } catch (e) {
            console.warn('Retorik Framework > error on event reception');
        }
    }, [
        eventReceived
    ]);
    const handleEvents = (event)=>{
        setEventReceived({
            type: $7e8c2248156e4a90$var$EventsReceived[event.type],
            detail: event.detail
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorikSendActivity', handleEvents);
        document.addEventListener('retorikSendEvent', handleEvents);
        document.addEventListener('retorikStartListening', handleEvents);
        document.addEventListener('retorikDisplaySubtitles', handleEvents);
        document.addEventListener('retorikSetVisibility', handleEvents);
        return ()=>{
            document.removeEventListener('retorikSendActivity', handleEvents);
            document.removeEventListener('retorikStartListening', handleEvents);
            document.removeEventListener('retorikDisplaySubtitles', handleEvents);
            document.removeEventListener('retorikSetVisibility', handleEvents);
        };
    }, []);
    /**
   * Send mandatory events : setUser to start conversation, Davi.GDPRConsent for GDPR module
   */ const sendMandatoryEvents = async ()=>{
        sendEvent('Davi.GDPRConsent', {
            userConsent: userConsent
        }, ()=>sendEvent('setUser', {
                user: {
                    ...userData,
                    gdprConsent: true
                },
                skipWelcome: !!skipWelcome
            }));
    };
    (0, $bxRTa.useEffect)(()=>{
        if (isRetorikNews || hasConversationCookie) setUserAlreadySet(true);
        else if (!userAlreadySet && appAvailable && !displayGDPR && characterLoaded) {
            setUserAlreadySet(true);
            sendMandatoryEvents();
        }
    }, [
        appAvailable,
        loaderClosed,
        displayGDPR,
        characterLoaded
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (activityToSend) {
            if (activityToSend.type === 'message' && activityToSend.text && typeof activityToSend.text !== 'string') {
                const tempActivity = {
                    ...activityToSend
                };
                tempActivity.text = activityToSend.text[locale] || '';
                sendMessage(tempActivity.text);
            } else sendMessage(undefined, activityToSend.value || activityToSend);
            sendUtilActivity(undefined);
        }
    }, [
        activityToSend
    ]);
    return null;
};
var $7e8c2248156e4a90$export$2e2bcd8739ae039 = $7e8c2248156e4a90$var$SendActivityEventListener;

});

parcelRegister("o9qp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f717076b62aa1fd7$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
// The required distance between touchStart and touchEnd to be detected as a swipe
const $f717076b62aa1fd7$var$minSwipeDistance = 30;
const $f717076b62aa1fd7$var$Swiper = ({ direction: direction, onSwiping: onSwiping, onSwipeLeft: onSwipeLeft, onSwipeRight: onSwipeRight, onSwipeTop: onSwipeTop, onSwipeBottom: onSwipeBottom, className: className, children: children })=>{
    const [moveStart, setMoveStart] = (0, $bxRTa.useState)(null);
    const [moveEnd, setMoveEnd] = (0, $bxRTa.useState)(null);
    const [timeStart, setTimeStart] = (0, $bxRTa.useState)(0);
    /**
   * On moveEnd state change :
   *  - set swiping distance to moveStart - moveEnd
   */ (0, $bxRTa.useEffect)(()=>{
        if (moveStart && moveEnd) {
            const distance = moveStart - moveEnd;
            onSwiping(distance);
        }
    }, [
        moveEnd
    ]);
    /**
   * On PointerDown event fire :
   *  - set timeStart state to current timestamp
   *  - reset moveEnd state to null to prevent activation on single touch
   *  - set moveStart state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerDown = (e)=>{
        setTimeStart(Date.now());
        setMoveEnd(null);
        setMoveStart(direction === 'horizontal' ? e.clientX : e.clientY);
    };
    /**
   * On PointerMove event fire :
   *  - set moveEnd state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerMove = (e)=>{
        setMoveEnd(direction === 'horizontal' ? e.clientX : e.clientY);
    };
    /**
   * On PointerUp event fire :
   *  - calculate the distance between move start and end
   *  - prevent default behaviour and propagation of the event if the distance is large enough (prevent unwanted touch/click at the end of a slide)
   *  - call the parent method depending on the distance and the direction, or reset position if the distance is too small
   *  - reset moveStart state to null
   */ const onPointerUp = (e)=>{
        if (moveStart && moveEnd) {
            const elapsedTime = Date.now() - timeStart;
            const distance = moveStart - moveEnd;
            if (distance > $f717076b62aa1fd7$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === 'horizontal' ? onSwipeLeft(distance, elapsedTime) : onSwipeTop(distance, elapsedTime);
            } else if (distance < -$f717076b62aa1fd7$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === 'horizontal' ? onSwipeRight(distance, elapsedTime) : onSwipeBottom(distance, elapsedTime);
            } else onSwiping(0);
        }
        setMoveStart(null);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-relative rf-w-full rf-overflow-hidden ${className}`,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerUp,
        children: children
    });
};
var $f717076b62aa1fd7$export$2e2bcd8739ae039 = $f717076b62aa1fd7$var$Swiper;

});

parcelRegister("66rUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d941fb14a0f8c8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");
const $55d941fb14a0f8c8$var$Toggle = ({ className: className, title: title, handleChange: handleChange, defaultChecked: defaultChecked, lockInTextMode: lockInTextMode })=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const [on, setOn] = (0, $bxRTa.useState)(!!defaultChecked);
    const [transition, setTransition] = (0, $bxRTa.useState)(on ? 'rf-right-1' : 'rf-left-1');
    (0, $bxRTa.useEffect)(()=>{
        setOn(!!defaultChecked);
        setTransition(defaultChecked ? 'rf-right-1' : 'rf-left-1');
    }, [
        defaultChecked
    ]);
    const handleToggle = ()=>{
        if (!(lockInTextMode && mode === (0, $2rYkD.Mode).text)) {
            setTransition(on ? 'rf-translate-x-1' : 'rf-translate-x-5');
            handleChange(!on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-row large:rf-flex-col rf-items-center rf-justify-between large:rf-justify-start large:rf-gap-1 hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-capitalize large:rf-uppercase",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-relative rf-w-12 rf-min-w-12 rf-h-6 rf-rounded-6",
                style: {
                    background: 'linear-gradient(to left, #E5E6EC, #F2F3F6)',
                    boxShadow: 'inset 3px 3px 6px #00000029'
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-absolute rf-top-1 rf-w-4 rf-h-4 rf-rounded-half ${on ? 'rf-bg-secondary' : 'rf-bg-[#F8F8F8]'} rf-transition-all ${transition}`,
                    style: {
                        boxShadow: on ? '-3px -3px 3px #00000029' : '3px 3px 3px #00000029'
                    }
                })
            })
        ]
    });
};
var $55d941fb14a0f8c8$export$2e2bcd8739ae039 = $55d941fb14a0f8c8$var$Toggle;

});

parcelRegister("6aH4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $80e8a675a6b3dfd3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $80e8a675a6b3dfd3$var$ToggleWithTexts = ({ texts: texts, colors: colors, handleChange: handleChange, defaultChecked: defaultChecked, showLeft: showLeft, showRight: showRight })=>{
    const [left, setLeft] = (0, $bxRTa.useState)(!defaultChecked || defaultChecked === texts.leftId);
    /**
   * On call :
   *  - call parent method with either leftId or rightId depending on the leftSide parameter
   *  - set left state
   * @param leftSide : boolean
   */ const handleToggle = (leftSide)=>{
        handleChange(leftSide ? texts.leftId : texts.rightId);
        setLeft(leftSide);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-flex rf-flex-row rf-justify-between rf-text-size-auto rf-rounded-8 rf-cursor-pointer rf-select-none rf-shadow-[inset_0_12px_12px_-12px_#00000029,inset_0_-12px_12px_-12px_#00000029]",
        style: {
            background: 'linear-gradient(to left, #CBCBCB 0%, #9A9797 50%, #4E4C4C 100%)',
            color: colors.text
        },
        children: [
            showLeft && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${left && 'rf-shadow-[0_0_3px_6px_#00000029]'} `,
                style: {
                    background: left ? colors.background : 'transparent',
                    borderColor: left ? colors.background : 'transparent'
                },
                onClick: ()=>handleToggle(true),
                children: texts.left
            }),
            showRight && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${!left && 'rf-shadow-[0_0_3px_6px_#00000029]'}`,
                style: {
                    background: left ? 'transparent' : colors.background,
                    borderColor: left ? 'transparent' : colors.background
                },
                onClick: ()=>handleToggle(false),
                children: texts.right
            })
        ]
    });
};
var $80e8a675a6b3dfd3$export$2e2bcd8739ae039 = $80e8a675a6b3dfd3$var$ToggleWithTexts;

});

parcelRegister("fEfdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7227dfa768fc141b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $7227dfa768fc141b$var$Wheeler = ({ className: className, handleWheel: handleWheel, paramInHandle: paramInHandle, handleBoth: handleBoth, xAxisOnly: xAxisOnly, children: children })=>{
    const ref = (0, $bxRTa.useRef)(null);
    /**
   * On mouse wheel :
   *  - check if the event has to be taken in account
   *  - if  yes, retrieve the wanted data
   *  - prevent event default
   *  - stop event propagation
   *  - call parent function with delta value and paramInHandle from props if defined
   * @param e : WheelEvent
   */ const internalHandleWheel = (e)=>{
        if (xAxisOnly && e.deltaY) return;
        const delta = handleBoth ? {
            x: e.deltaX,
            y: e.deltaY
        } : xAxisOnly ? e.deltaX : e.deltaY;
        e.preventDefault();
        e.stopImmediatePropagation();
        paramInHandle ? handleWheel(delta, paramInHandle) : handleWheel(delta);
    };
    /**
   * On ref change :
   *  - add wheel event listener, with passive = false to allow preventDefault in processing
   * On component unmount :
   *  - unbind wheel event listener
   */ (0, $bxRTa.useEffect)(()=>{
        if (ref.current) ref.current.addEventListener('wheel', (e)=>internalHandleWheel(e), {
            passive: false
        });
        return ()=>{
            ref.current && ref.current.removeEventListener('wheel', (e)=>internalHandleWheel(e));
        };
    }, [
        ref.current
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: className,
        ref: ref,
        children: children
    });
};
var $7227dfa768fc141b$export$2e2bcd8739ae039 = $7227dfa768fc141b$var$Wheeler;

});


parcelRegister("kMAJU", function(module, exports) {

$parcel$export(module.exports, "CloseIcon", () => (parcelRequire("04Syy")).default);
$parcel$export(module.exports, "DownloadIcon", () => (parcelRequire("9oAhU")).default);
$parcel$export(module.exports, "FeatherCheckIcon", () => (parcelRequire("kA2rN")).default);
$parcel$export(module.exports, "FeatherFilterIcon", () => (parcelRequire("cxD1i")).default);
$parcel$export(module.exports, "InfoWithCircleIcon", () => (parcelRequire("d5ZYc")).default);
$parcel$export(module.exports, "MicrophoneAllowedIcon", () => (parcelRequire("f3SD2")).default);
$parcel$export(module.exports, "MicrophoneRefusedIcon", () => (parcelRequire("iNZRc")).default);
$parcel$export(module.exports, "SendMessageIcon", () => (parcelRequire("byrzf")).default);
$parcel$export(module.exports, "SendMessageIconReversed", () => (parcelRequire("lvWyY")).default);
$parcel$export(module.exports, "ZoomOutIcon", () => (parcelRequire("7bOgw")).default);
$parcel$export(module.exports, "RetorikLogoIcon", () => (parcelRequire("lHTuW")).default);
$parcel$export(module.exports, "FileIcon", () => (parcelRequire("av28T")).default);

var $04Syy = parcelRequire("04Syy");

var $9oAhU = parcelRequire("9oAhU");

var $kA2rN = parcelRequire("kA2rN");

var $cxD1i = parcelRequire("cxD1i");

var $d5ZYc = parcelRequire("d5ZYc");

var $f3SD2 = parcelRequire("f3SD2");

var $iNZRc = parcelRequire("iNZRc");

var $byrzf = parcelRequire("byrzf");

var $lvWyY = parcelRequire("lvWyY");

var $7bOgw = parcelRequire("7bOgw");

var $lHTuW = parcelRequire("lHTuW");

var $av28T = parcelRequire("av28T");

});
parcelRegister("04Syy", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ae80c2a7e55409$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $35ae80c2a7e55409$var$CloseIcon = ({ className: className, color: color, strokeWidth: strokeWidth })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || 'currentColor',
        strokeWidth: strokeWidth || 2,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18L18 6M6 6l12 12"
        })
    });
};
var $35ae80c2a7e55409$export$2e2bcd8739ae039 = $35ae80c2a7e55409$var$CloseIcon;

});

parcelRegister("9oAhU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b5aaac005f59ffb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $7b5aaac005f59ffb$var$DownloadIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        className: className || 'rf-h-6 rf-w-6',
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M20.75 14.38H16V.96c0-.53-.45-.96-1-.96s-1 .43-1 .96v13.42H9.25c-.19 0-.32.2-.22.36l5.75 9.52c.1.16.34.16.44 0l5.75-9.52c.09-.16-.03-.36-.22-.36z",
                fill: color || 'currentColor'
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M29 19.76V27c0 1.1-.86 2-1.93 2H2.93C1.86 29 1 28.1 1 27v-7.24",
                fill: "none",
                stroke: color || 'currentColor'
            })
        ]
    });
};
var $7b5aaac005f59ffb$export$2e2bcd8739ae039 = $7b5aaac005f59ffb$var$DownloadIcon;

});

parcelRegister("kA2rN", function(module, exports) {

$parcel$export(module.exports, "default", () => $21517659bdeb3e43$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $21517659bdeb3e43$var$FeatherCheckIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28.676",
        height: "20.419",
        viewBox: "0 0 28.676 20.419",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M30.434,9l-16.8,16.8L6,18.163",
            transform: "translate(-3.879 -6.879)",
            fill: "none",
            stroke: color || '#fff',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "3"
        })
    });
};
var $21517659bdeb3e43$export$2e2bcd8739ae039 = $21517659bdeb3e43$var$FeatherCheckIcon;

});

parcelRegister("cxD1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9847270020efa43$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $b9847270020efa43$var$FeatherFilterIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.333",
        height: "13",
        viewBox: "0 0 14.333 13",
        className: className || 'rf-w-6 rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M16.333,4.5H3l5.333,6.307v4.36L11,16.5V10.807Z",
            transform: "translate(-2.5 -4)",
            fill: "none",
            stroke: color || '#000',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1"
        })
    });
};
var $b9847270020efa43$export$2e2bcd8739ae039 = $b9847270020efa43$var$FeatherFilterIcon;

});

parcelRegister("d5ZYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $84cfe305a0ebc914$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $84cfe305a0ebc914$var$InfoWithCircleIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: className || 'rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 33 33",
            className: "rf-h-full",
            children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                transform: "translate(-1.5 -1.5)",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
                        fill: "none",
                        stroke: color || '#00d7ff',
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M18,24V18",
                        fill: "none",
                        stroke: color || '#00d7ff',
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M18,12h0",
                        fill: "none",
                        stroke: color || '#00d7ff',
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    })
                ]
            })
        })
    });
};
var $84cfe305a0ebc914$export$2e2bcd8739ae039 = $84cfe305a0ebc914$var$InfoWithCircleIcon;

});

parcelRegister("f3SD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60a2a87a4615b74$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c60a2a87a4615b74$var$MicrophoneAllowedIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 28.5 41.453",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-374.543 -230)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M401.748,280.386h-1.3a1.3,1.3,0,0,0-1.3,1.3v3.887a10.375,10.375,0,0,1-10.387,10.364q-.507,0-1.013-.051a10.679,10.679,0,0,1-9.328-10.775v-3.425a1.3,1.3,0,0,0-1.3-1.3h-1.3a1.3,1.3,0,0,0-1.3,1.3v3.252c0,7.258,5.176,13.728,12.307,14.711v2.765h-4.534a1.3,1.3,0,0,0-1.3,1.3V305a1.3,1.3,0,0,0,1.3,1.3H395.27a1.3,1.3,0,0,0,1.3-1.3v-1.3a1.3,1.3,0,0,0-1.3-1.3h-4.534v-2.735a14.264,14.264,0,0,0,12.307-14.107v-3.887A1.3,1.3,0,0,0,401.748,280.386Z",
                    transform: "translate(0 -34.842)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M406.719,248.348a2.769,2.769,0,0,1-1.969-.815l-5.251-5.25a2.786,2.786,0,0,1,0-3.938l1.145-1.148a2.786,2.786,0,0,1,3.941,0l2.138,2.139,3.98-3.981a7.773,7.773,0,0,0-15.16,2.416v12.955a7.773,7.773,0,0,0,15.546,0v-5.591l-2.393,2.393A2.767,2.767,0,0,1,406.719,248.348Z",
                    transform: "translate(-14.519)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M428.061,245.381l-1.142-1.145h0a.808.808,0,0,0-1.142,0l-3.211,3.212-4.365,4.366-3.537-3.539h0a.808.808,0,0,0-1.142,0l-1.142,1.146h0a.808.808,0,0,0,0,1.142l5.251,5.251h0a.808.808,0,0,0,1.142,0l3.794-3.794,5.5-5.5h0A.808.808,0,0,0,428.061,245.381Z",
                    transform: "translate(-25.999 -9.681)",
                    fill: color || '#FFF'
                })
            ]
        })
    });
};
var $c60a2a87a4615b74$export$2e2bcd8739ae039 = $c60a2a87a4615b74$var$MicrophoneAllowedIcon;

});

parcelRegister("iNZRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a39f0d26f73bbe1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $8a39f0d26f73bbe1$var$MicrophoneRefusedIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 28.99 42.159",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-527.589 -229.523)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M556.489,258.506h0a7.9,7.9,0,0,0,7.9-7.9v-8.817l-.07-.07-2.065,2.063a2.079,2.079,0,0,1-2.936,0l-1.557-1.557a2.084,2.084,0,0,1,0-2.936l2.06-2.06-2.063-2.063a2.084,2.084,0,0,1,0-2.936l1.557-1.557a2.073,2.073,0,0,1,.541-.387,7.906,7.906,0,0,0-11.283,7.147V250.6A7.9,7.9,0,0,0,556.489,258.506Z",
                    transform: "translate(-14.411 0)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M555.259,279.916h-1.322a1.318,1.318,0,0,0-1.318,1.318v3.952a10.551,10.551,0,0,1-10.564,10.539q-.515,0-1.028-.051a10.859,10.859,0,0,1-9.487-10.957v-3.483a1.318,1.318,0,0,0-1.318-1.318h-1.314a1.318,1.318,0,0,0-1.318,1.318v3.307A14.945,14.945,0,0,0,540.105,299.5v2.813h-4.621a1.318,1.318,0,0,0-1.318,1.318v1.318a1.318,1.318,0,0,0,1.318,1.318h13.173a1.318,1.318,0,0,0,1.318-1.318v-1.318a1.318,1.318,0,0,0-1.318-1.318h-4.593v-2.78a14.505,14.505,0,0,0,12.514-14.345v-3.954A1.318,1.318,0,0,0,555.259,279.916Z",
                    transform: "translate(0 -34.583)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M592.216,245.5h0l-3.29-3.29,3.29-3.29a.34.34,0,0,0,0-.479l-1.554-1.554a.34.34,0,0,0-.479,0l-3.288,3.29-.374-.374-2.918-2.916a.34.34,0,0,0-.479,0l-1.555,1.554a.34.34,0,0,0,0,.479l3.29,3.29-3.29,3.29a.34.34,0,0,0,0,.479l1.554,1.554a.34.34,0,0,0,.479,0l3.292-3.29.07.07,3.22,3.22a.339.339,0,0,0,.479,0l1.554-1.554A.339.339,0,0,0,592.216,245.5Z",
                    transform: "translate(-36.977 -4.985)",
                    fill: color || '#FFF'
                })
            ]
        })
    });
};
var $8a39f0d26f73bbe1$export$2e2bcd8739ae039 = $8a39f0d26f73bbe1$var$MicrophoneRefusedIcon;

});

parcelRegister("byrzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0cc0e1aabe9e77f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f0cc0e1aabe9e77f$var$SendMessageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-w-6',
        viewBox: "0 0 23.207 23.207",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.5 0.707)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28.6,3,16.5,15.1",
                    transform: "translate(-6.6 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M25,3,17.3,25l-4.4-9.9L3,10.7Z",
                    transform: "translate(-3 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $f0cc0e1aabe9e77f$export$2e2bcd8739ae039 = $f0cc0e1aabe9e77f$var$SendMessageIcon;

});

parcelRegister("lvWyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $95383ea446068ca2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $95383ea446068ca2$var$SendMessageIconReversed = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-w-6',
        viewBox: "0 0 23.207 23.207",
        style: {
            transform: 'scaleX(-1)',
            transformOrigin: '11.6px 11.6px'
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.5 0.707)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28.6,3,16.5,15.1",
                    transform: "translate(-6.6 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M25,3,17.3,25l-4.4-9.9L3,10.7Z",
                    transform: "translate(-3 -3)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $95383ea446068ca2$export$2e2bcd8739ae039 = $95383ea446068ca2$var$SendMessageIconReversed;

});

parcelRegister("7bOgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c80aa348110a43b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $1c80aa348110a43b$var$ZoomOutIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 37.91 37.91",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M29.773,4.5l4.844,4.844-6.087,6.044,2.991,2.991,6.044-6.087,4.844,4.844V4.5ZM4.5,17.137l4.844-4.844,6.044,6.087,2.991-2.991L12.293,9.344,17.137,4.5H4.5ZM17.137,42.41l-4.844-4.844,6.087-6.044-2.991-2.991L9.344,34.617,4.5,29.773V42.41ZM42.41,29.773l-4.844,4.844-6.044-6.087-2.991,2.991,6.087,6.044L29.773,42.41H42.41Z",
            transform: "translate(-4.5 -4.5)",
            fill: color || '#00d7ff'
        })
    });
};
var $1c80aa348110a43b$export$2e2bcd8739ae039 = $1c80aa348110a43b$var$ZoomOutIcon;

});

parcelRegister("lHTuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e6fbe4f0234d6e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $d5e6fbe4f0234d6e$var$RetorikLogoIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 325 135",
        className: className || 'rf-h-6 rf-w-6',
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("rect", {
                x: "0",
                y: "-6",
                width: "325",
                height: "143",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M93.6,70.9V50.8c0-14.2-11.5-25.7-25.7-25.7h0c-14.2,0-25.7,11.5-25.7,25.7v20.1c0,14.2,11.5,25.7,25.7,25.7v0   h25.7l-13.3-3.2C88.2,89,93.6,80.6,93.6,70.9z M67.9,89.8C57.5,89.8,49,81.3,49,70.9V50.8c0-10.4,8.5-18.9,18.9-18.9   c10.4,0,18.9,8.5,18.9,18.9v20.1C86.8,81.3,78.3,89.8,67.9,89.8z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M67.9,82.6c-2.3,0-4.5-0.9-6.1-2.5c-0.7-0.7-0.7-1.9,0-2.6c0.7-0.7,1.9-0.7,2.6,0c0.9,0.9,2.2,1.4,3.5,1.4    c1.3,0,2.6-0.5,3.5-1.4c0.7-0.7,1.9-0.7,2.6,0c0.7,0.7,0.7,1.9,0,2.6C72.4,81.7,70.2,82.6,67.9,82.6z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M117.1,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1H119v10.1H117.1z M119,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5H119   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M161.6,59.9v1.7h-17.8V34.9h17.5v1.7h-15.5v10.5h13.6v1.7h-13.6v11.1H161.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M187.8,36.6H178v25h-1.9v-25h-9.8v-1.7h21.5V36.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M203.7,61.8c-1.9,0-3.5-0.4-5.1-1.2c-1.5-0.8-2.8-1.8-4-3c-1.1-1.3-2-2.7-2.6-4.3c-0.6-1.6-0.9-3.3-0.9-5   c0-1.8,0.3-3.5,1-5.1c0.6-1.6,1.5-3.1,2.6-4.3c1.1-1.3,2.4-2.3,4-3c1.5-0.7,3.2-1.1,5-1.1c1.9,0,3.6,0.4,5.1,1.2   c1.5,0.8,2.9,1.8,4,3.1c1.1,1.3,1.9,2.7,2.5,4.3s0.9,3.3,0.9,4.9c0,1.8-0.3,3.5-1,5.2c-0.6,1.6-1.5,3.1-2.6,4.3   c-1.1,1.2-2.4,2.2-4,3C207.1,61.4,205.5,61.8,203.7,61.8z M193.1,48.2c0,1.5,0.3,3,0.8,4.4c0.5,1.4,1.2,2.7,2.2,3.8   c0.9,1.1,2.1,2,3.4,2.6c1.3,0.7,2.7,1,4.3,1c1.6,0,3.1-0.3,4.3-1c1.3-0.7,2.4-1.6,3.3-2.7c0.9-1.1,1.6-2.4,2.1-3.8   c0.5-1.4,0.8-2.8,0.8-4.3c0-1.5-0.3-3-0.8-4.4c-0.5-1.4-1.3-2.7-2.2-3.8c-0.9-1.1-2-2-3.3-2.6c-1.3-0.7-2.7-1-4.2-1   c-1.6,0-3.1,0.3-4.4,1S197,39,196,40.2c-0.9,1.1-1.6,2.4-2.1,3.8C193.4,45.4,193.1,46.8,193.1,48.2z",
                        id: "path19"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M223.7,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1h-8.7v10.1H223.7z M225.6,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5h-9.1   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M250.5,61.6V34.9h1.9v26.7H250.5z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        fill: color || '#FFF',
                        d: "M261.7,61.6V34.9h1.9v16.2l15.6-16.2h2.2l-11.1,11.7l11.7,15h-2.2l-10.7-13.8l-5.5,5.6v8.2H261.7z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                        fill: color || '#FFF',
                                        d: "M122.9,96.1c-1,0-1.9-0.3-2.7-0.8c-0.8-0.5-1.5-1.2-2-2v2.5h-1.1V78.4h1.2v7.7c0.6-0.9,1.3-1.6,2.1-2.1      c0.8-0.5,1.7-0.8,2.8-0.8c0.9,0,1.7,0.2,2.4,0.6c0.7,0.4,1.3,0.9,1.8,1.5c0.5,0.6,0.9,1.3,1.1,2.1c0.3,0.8,0.4,1.6,0.4,2.4      c0,0.9-0.2,1.7-0.5,2.4s-0.7,1.4-1.3,2c-0.5,0.6-1.2,1-1.9,1.4C124.5,95.9,123.7,96.1,122.9,96.1z M122.6,95      c0.7,0,1.4-0.2,2-0.5c0.6-0.3,1.1-0.7,1.6-1.2c0.4-0.5,0.8-1.1,1-1.7c0.2-0.6,0.4-1.3,0.4-2c0-0.7-0.1-1.4-0.3-2      c-0.2-0.6-0.6-1.2-1-1.7c-0.4-0.5-0.9-0.9-1.5-1.2c-0.6-0.3-1.2-0.5-1.9-0.5c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.4-1.3,0.7      c-0.4,0.3-0.7,0.7-1.1,1.1c-0.3,0.4-0.6,0.8-0.8,1.2v4.1c0,0.5,0.2,0.9,0.5,1.3c0.3,0.4,0.7,0.8,1.1,1.1      c0.4,0.3,0.9,0.5,1.4,0.7C121.7,95,122.2,95,122.6,95z"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                        fill: color || '#FFF',
                                        d: "M133.3,100.1c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2      c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.3,0.3-0.7,0.5-1.2c0.2-0.5,0.5-1.2,0.9-2.1L131,83.5h1.2l4.9,11.3l4.6-11.3h1.2l-6.8,16.3      c-0.2,0.4-0.5,0.8-0.8,1c-0.4,0.2-0.9,0.4-1.6,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0V100.1z"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M213.9,95.9l0.4-0.3c1.4-1.2,2.1-2.7,2.1-4.6l0-8h-2.5V95.9z"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("polygon", {
                            fill: color || '#FFF',
                            points: "202.9,93.3 196.9,83 193.9,83 201.4,95.9 201.4,95.9 204.4,95.9 204.4,95.9 212,83 208.9,83   "
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M174.1,87.5v3.9c0,2.5,2,4.5,4.5,4.5h8.9c0.7,0,1.4-0.2,2-0.5v0.4h2.5V83l-13.4,0    C176.1,83,174.1,85,174.1,87.5z M189.4,85.5v5.7c-0.1,1.2-1,2.1-2.2,2.1h-8.6c-1.2,0-2.2-1-2.2-2.3v-3.4c0-1.2,1-2.2,2.2-2.2    H189.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M171.3,75.2l-2.5-0.8v9.1c-0.6-0.3-1.3-0.5-2-0.5H158c-2.5,0-4.5,2-4.5,4.5v3.9c0,2.5,2,4.5,4.5,4.5l13.2,0    h1.4h0.3c-1-1.2-1.6-2.8-1.6-4.5L171.3,75.2z M168.8,93.4h-10.7c-1.2,0-2.2-1-2.2-2.2v-3.4c0-1.2,1-2.2,2.2-2.2h8.5    c1.1,0,2.1,0.9,2.1,2.1V93.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            fill: color || '#FFF',
                            d: "M215.1,80.6c0.3,0,0.6-0.1,0.9-0.4c0.3-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4    c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9C214.5,80.5,214.8,80.6,215.1,80.6z"
                        })
                    })
                ]
            })
        ]
    });
};
var $d5e6fbe4f0234d6e$export$2e2bcd8739ae039 = $d5e6fbe4f0234d6e$var$RetorikLogoIcon;

});

parcelRegister("av28T", function(module, exports) {

$parcel$export(module.exports, "default", () => $662532ad3923967c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $662532ad3923967c$var$FileIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19.908 23.226",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M21.6,7.129a3.016,3.016,0,0,1,.622.985,2.991,2.991,0,0,1,.259,1.141V24.185a1.239,1.239,0,0,1-1.244,1.244H3.815a1.239,1.239,0,0,1-1.244-1.244V3.448A1.239,1.239,0,0,1,3.815,2.2H15.428a2.992,2.992,0,0,1,1.141.259,3.016,3.016,0,0,1,.985.622ZM15.843,3.966V8.839h4.873a1.416,1.416,0,0,0-.285-.531L16.374,4.251a1.416,1.416,0,0,0-.531-.285Zm4.977,19.8V10.5H15.428a1.239,1.239,0,0,1-1.244-1.244V3.862H4.23V23.77H20.82Z",
            transform: "translate(-2.571 -2.203)",
            fill: color || '#00d7ff'
        })
    });
};
var $662532ad3923967c$export$2e2bcd8739ae039 = $662532ad3923967c$var$FileIcon;

});


parcelRegister("85RVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $218717c20dbad67e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $218717c20dbad67e$var$Animation2 = ({ color: color, loaderColor: loaderColor, backgroundColor: backgroundColor })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        "aria-hidden": "true",
        className: "rf-inline rf-w-8 rf-h-8 rf-mr-2 rf-animate-spin ",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor",
                style: {
                    fill: color
                }
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill",
                style: {
                    fill: loaderColor
                }
            })
        ]
    });
};
var $218717c20dbad67e$export$2e2bcd8739ae039 = $218717c20dbad67e$var$Animation2;

});

parcelRegister("8e5cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $299cb4e81f4790c2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $299cb4e81f4790c2$var$QRCodeComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).forwardRef(({ src: src, alt: alt, largeMaxHeight: largeMaxHeight }, ref)=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
        ref: ref,
        src: src,
        className: `rf-h-full ${largeMaxHeight ? 'rf-max-h-qrcodelarge' : 'rf-max-h-qrcode'}`,
        alt: alt || 'QR Code'
    });
});
var $299cb4e81f4790c2$export$2e2bcd8739ae039 = $299cb4e81f4790c2$var$QRCodeComponent;

});

parcelRegister("7fviB", function(module, exports) {

$parcel$export(module.exports, "default", () => $44989506a6c85bc5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("d72S7");
var $57bW7 = parcelRequire("57bW7");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");

var $aibZy = parcelRequire("aibZy");
var $Zrrxd = parcelRequire("Zrrxd");
parcelRequire("7Jjoy");
var $3kuIS = parcelRequire("3kuIS");
var $iyJo4 = parcelRequire("iyJo4");
const $44989506a6c85bc5$var$PrintingPreview = ({ url: url, printingAllowed: printingAllowed })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const printingCallback = (0, $4xGiN.useUtilsStore)((state)=>state.printingCallback);
    const setModalFullscreenContent = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setModalFullscreenContent);
    const [documentLoaded, setDocumentLoaded] = (0, $bxRTa.useState)(false);
    const [numberOfPages, setNumberOfPages] = (0, $bxRTa.useState)(0);
    const [pageNumber, setPageNumber] = (0, $bxRTa.useState)(1);
    const onDocumentLoadSuccess = ({ numPages: numPages })=>{
        setNumberOfPages(numPages);
        setDocumentLoaded(true);
    };
    const handleClick = ()=>{
        console.log('Call printing and close preview');
        printingCallback?.(url);
        handleClose();
    };
    const handleClose = ()=>{
        setModalFullscreenContent(null);
    };
    const changePage = (index)=>{
        setPageNumber((current)=>current + index);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-h-full large-vertical:rf-mt-[20vh] large-vertical:rf-h-1/2 rf-max-w-1/2 large-vertical:rf-max-w-[60%] rf-py-4 rf-flex rf-flex-col rf-gap-4",
        style: {
            visibility: documentLoaded ? 'visible' : 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-grid rf-grid-cols-printingPreview rf-min-h-12 rf-h-12",
                children: [
                    printingAllowed ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        className: "rf-px-4 rf-py-1 rf-h-full rf-justify-self-center rf-flex rf-flex-row rf-items-center rf-gap-2 rf-font-bold rf-text-sm rf-rounded-lg rf-bg-truewhite",
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $57bW7.default), {}),
                            translation.common.print
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: '\u2800'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-h-full rf-w-12 rf-justify-self-end rf-flex rf-justify-center rf-items-center rf-rounded-lg rf-bg-truewhite",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-relative rf-w-full rf-flex rf-flex-col rf-rounded-lg rf-overflow-y-scroll rf-scrollbar-thin",
                children: [
                    numberOfPages > 1 && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-px-4 rf-pt-3 rf-pb-2 rf-flex rf-flex-row rf-justify-between rf-items-center rf-bg-truewhite",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                className: `${pageNumber <= 1 ? 'rf-invisible' : 'rf-visible'}`,
                                onClick: ()=>changePage(-1),
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3kuIS.default), {
                                    className: "rf-h-4",
                                    color: "#000"
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("p", {
                                className: "rf-text-xl",
                                children: [
                                    pageNumber,
                                    " / ",
                                    numberOfPages
                                ]
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                className: `${pageNumber >= numberOfPages ? 'rf-invisible' : 'rf-visible'}`,
                                onClick: ()=>changePage(1),
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                                    className: "rf-h-4",
                                    color: "#000"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $aibZy.default), {
                        file: url,
                        onLoadSuccess: onDocumentLoadSuccess,
                        onLoadError: handleClose,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $Zrrxd.default), {
                            pageNumber: pageNumber,
                            renderAnnotationLayer: false,
                            renderTextLayer: false
                        })
                    })
                ]
            })
        ]
    });
};
var $44989506a6c85bc5$export$2e2bcd8739ae039 = $44989506a6c85bc5$var$PrintingPreview;

});
parcelRegister("d72S7", function(module, exports) {

$parcel$export(module.exports, "CommentsPennantIcon", () => (parcelRequire("a0inq")).default);
$parcel$export(module.exports, "FavoriteIcon", () => (parcelRequire("1olzu")).default);
$parcel$export(module.exports, "FavoriteLightIcon", () => (parcelRequire("79eFo")).default);
$parcel$export(module.exports, "PhoneIcon", () => (parcelRequire("41UZV")).default);
$parcel$export(module.exports, "PhotoCameraIcon", () => (parcelRequire("epsYO")).default);
$parcel$export(module.exports, "PrintIcon", () => (parcelRequire("57bW7")).default);
$parcel$export(module.exports, "RoundIcon", () => (parcelRequire("cUlNP")).default);

var $a0inq = parcelRequire("a0inq");

var $1olzu = parcelRequire("1olzu");

var $79eFo = parcelRequire("79eFo");

var $41UZV = parcelRequire("41UZV");

var $epsYO = parcelRequire("epsYO");

var $57bW7 = parcelRequire("57bW7");

var $cUlNP = parcelRequire("cUlNP");

});
parcelRegister("a0inq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cceacee5cdad80cb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $cceacee5cdad80cb$var$CommentsPennantIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72.258 45",
        className: className || 'w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-2203.071 -428.34)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2201.071 426.34)",
                    fill: "none",
                    stroke: color || '#ffffff',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2255.071 426.34)",
                    fill: "none",
                    stroke: color || '#ffffff',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28,11.225A5.775,5.775,0,1,1,22.225,17,5.774,5.774,0,0,1,28,11.225m0,24.75c8.167,0,16.775,4.015,16.775,5.775v3.025H11.225V41.75c0-1.76,8.608-5.775,16.775-5.775M28,6A11,11,0,1,0,39,17,11,11,0,0,0,28,6Zm0,24.75c-7.342,0-22,3.685-22,11V50H50V41.75C50,34.435,35.343,30.75,28,30.75Z",
                    transform: "translate(2211 423.34)",
                    fill: color || '#ffffff'
                })
            ]
        })
    });
};
var $cceacee5cdad80cb$export$2e2bcd8739ae039 = $cceacee5cdad80cb$var$CommentsPennantIcon;

});

parcelRegister("1olzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f8d34a582e0db4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $b2f8d34a582e0db4$var$FavoriteIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: className || '',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 72 72",
            className: "rf-h-full",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M413.444,281.927a24.4,24.4,0,1,0,24.4,24.4A24.4,24.4,0,0,0,413.444,281.927Zm12.233,30.989a51.118,51.118,0,0,1-9.936,9.6l-2.3,1.654-2.3-1.654a51.118,51.118,0,0,1-9.936-9.6,17.7,17.7,0,0,1-3.462-9.826,10.357,10.357,0,0,1,10.227-10.321h.095a10.267,10.267,0,0,1,5.373,1.514,10.271,10.271,0,0,1,5.373-1.514h.095a10.357,10.357,0,0,1,10.226,10.321A17.7,17.7,0,0,1,425.677,312.916Z",
                    transform: "translate(-380.234 -271.942)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M428.741,308.235h-.057a6.436,6.436,0,0,0-5.373,2.941,6.435,6.435,0,0,0-5.373-2.941h-.057a6.394,6.394,0,0,0-6.335,6.391,13.766,13.766,0,0,0,2.7,7.505,47.374,47.374,0,0,0,9.06,8.727,47.369,47.369,0,0,0,9.061-8.727,13.765,13.765,0,0,0,2.7-7.505A6.394,6.394,0,0,0,428.741,308.235Z",
                    transform: "translate(-390.101 -283.478)",
                    fill: "#cb0038"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M379.123,306.092l.984-.568a3.667,3.667,0,1,1-4.851-1.228l.554,1a2.435,2.435,0,0,0-1.228,1.529,2.533,2.533,0,0,0,4.873,1.339A2.519,2.519,0,0,0,379.123,306.092Z",
                            transform: "translate(-373.354 -281.75)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M383.877,292.134a3.579,3.579,0,1,1-4.955,1.283A3.524,3.524,0,0,1,383.877,292.134Zm-.614,1.07a2.35,2.35,0,1,0,1.007,3.281A2.36,2.36,0,0,0,383.263,293.2Z",
                            transform: "translate(-375.577 -276.186)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M388.494,279.91l.851-.864,3.212,3.162a2.729,2.729,0,0,1-3.83,3.889l-3.211-3.163.85-.864,3.1,3.056a1.525,1.525,0,1,0,2.127-2.161Z",
                            transform: "translate(-378.687 -270.679)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M396.125,274.77l2.02-1.306a2.265,2.265,0,1,1,2.457,3.8l-1,.647,1.382,2.138-1.018.658Zm4.181-.008a1.092,1.092,0,0,0-1.664-.248l-.874.564,1.206,1.867.874-.565A1.092,1.092,0,0,0,400.306,274.762Z",
                            transform: "translate(-383.338 -268.046)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M418.982,268.841a3.387,3.387,0,0,1-2.494,4.305l-2.211.575-1.782-6.847,2.211-.576A3.387,3.387,0,0,1,418.982,268.841Zm-1.194.311a2.247,2.247,0,0,0-2.772-1.743l-1.056.275,1.2,4.617,1.057-.275A2.254,2.254,0,0,0,417.788,269.151Z",
                            transform: "translate(-390.516 -265.032)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M427.818,267.132l2.828-.109.044,1.151-2.827.11.073,1.9,3.132-.122.044,1.151-4.343.17-.275-7.07,4.282-.167.045,1.151-3.07.12Z",
                            transform: "translate(-396.655 -264.145)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M446.9,272.151l.56.988a3.666,3.666,0,1,1,1.268-4.839l-1.006.544a2.431,2.431,0,0,0-1.518-1.239,2.532,2.532,0,0,0-1.38,4.86A2.519,2.519,0,0,0,446.9,272.151Z",
                            transform: "translate(-403.416 -265.121)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M460.445,277.009a3.579,3.579,0,1,1-1.242-4.964A3.523,3.523,0,0,1,460.445,277.009Zm-1.064-.622a2.35,2.35,0,1,0-3.289.98A2.361,2.361,0,0,0,459.381,276.386Z",
                            transform: "translate(-408.594 -267.384)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M467.155,281.565l2.048,1.953-.8.834L466.36,282.4l-1.311,1.375,2.268,2.162-.8.834-3.145-3,4.882-5.12,3.1,2.957-.8.834-2.224-2.12Z",
                            transform: "translate(-412.827 -270.506)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M478.916,290.648l.678,1.006-3.737,2.52a2.729,2.729,0,0,1-3.052-4.525l3.738-2.521.678,1.006-3.612,2.435a1.525,1.525,0,1,0,1.7,2.514Z",
                            transform: "translate(-416.422 -274.223)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M482.854,299.49l.848,2.165a2.168,2.168,0,0,1-1.2,2.987,2.045,2.045,0,0,1-2.552-.694l-1.915,2.649-.516-1.317,1.873-2.535-.2-.518-2.485.973-.442-1.129Zm-.8,4c.649-.254.8-.835.518-1.56l-.351-.894-1.957.766.35.894C480.9,303.425,481.406,303.748,482.055,303.494Z",
                            transform: "translate(-418.479 -279.643)",
                            fill: "#161615"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(4.89 51.981)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M384.888,365.352l-.9-1.038.58-.5a2.025,2.025,0,0,1-1.846-.74,3.084,3.084,0,0,1,4.657-4.019,2.09,2.09,0,0,1,.5,1.753l3.1-2.68.969,1.122Zm1.911-3.608a1.623,1.623,0,0,0-.294-1.589,1.695,1.695,0,0,0-2.562,2.211,1.621,1.621,0,0,0,1.529.524Z",
                            transform: "translate(-382.062 -357.324)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M397.773,372.316c-.066.09-.2.269-.337.442l-3.535-2.577a1.672,1.672,0,0,0,.629,1.927,2.359,2.359,0,0,0,1.648.467l-.057,1.335a3.75,3.75,0,0,1-2.392-.7,3.078,3.078,0,0,1-.733-4.342,2.949,2.949,0,1,1,4.777,3.452Zm-.893-1.293a1.481,1.481,0,0,0-2.346-1.71Z",
                            transform: "translate(-386.596 -361.465)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M412.418,369.575l1.391.51-3.215,8.768-1.391-.511Z",
                            transform: "translate(-393.963 -362.355)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M418.264,372.236l1.265.337-.784,2.936-1.265-.337Z",
                            transform: "translate(-397.592 -363.522)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M426.423,379.222c-.013.111-.039.331-.076.551l-4.344-.5a1.671,1.671,0,0,0,1.5,1.366,2.353,2.353,0,0,0,1.662-.407l.61,1.188a3.749,3.749,0,0,1-2.427.568,3.077,3.077,0,0,1-2.779-3.414,2.948,2.948,0,1,1,5.857.646Zm-1.414-.684a1.481,1.481,0,0,0-2.884-.33Zm.961-5.025-2.384,1.816-.842-1,2.343-1.895Z",
                            transform: "translate(-398.936 -363.608)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M438.911,378.258l.963,8.642-1.473.164-.382-3.425a2.092,2.092,0,0,1-1.561.933,3.084,3.084,0,0,1-.682-6.114,2.123,2.123,0,0,1,1.857.713l-.085-.761Zm-1.247,2.2a1.62,1.62,0,0,0-1.477-.655,1.694,1.694,0,0,0,.375,3.363,1.623,1.623,0,0,0,1.3-.965Z",
                            transform: "translate(-404.51 -366.163)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M447.021,379.887l-1.251-3.581,1.4-.489,1.117,3.2a1.053,1.053,0,0,0,1.5.783,1.442,1.442,0,0,0,.86-1.06l-1.288-3.686,1.4-.489,1.933,5.529-1.307.457-.281-.805a2.111,2.111,0,0,1-4.086.145Z",
                            transform: "translate(-409.996 -364.542)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M455.552,367.9a.976.976,0,1,1-.385,1.325A.97.97,0,0,1,455.552,367.9Zm.73,2.869,1.3-.714,2.819,5.132-1.3.714Z",
                            transform: "translate(-414.063 -361.567)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M463.272,367.506l.478.6a2.125,2.125,0,0,1,.809-1.818,3.086,3.086,0,0,1,3.842,4.807,2.089,2.089,0,0,1-1.764.445l2.152,2.694-1.159.926-5.43-6.8Zm2.462,2.9a1.625,1.625,0,0,0,1.6-.234,1.7,1.7,0,0,0-2.114-2.645,1.623,1.623,0,0,0-.582,1.509Z",
                            transform: "translate(-417.201 -360.651)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M478.073,357.422c.086.069.261.207.427.355l-2.719,3.423a1.67,1.67,0,0,0,1.95-.549,2.354,2.354,0,0,0,.535-1.626l1.332.111a3.751,3.751,0,0,1-.8,2.36,3.077,3.077,0,0,1-4.367.551,2.947,2.947,0,1,1,3.646-4.626Zm-1.327.837a1.481,1.481,0,0,0-1.806,2.273Z",
                            transform: "translate(-422.028 -356.717)",
                            fill: "#161615"
                        })
                    ]
                })
            ]
        })
    });
};
var $b2f8d34a582e0db4$export$2e2bcd8739ae039 = $b2f8d34a582e0db4$var$FavoriteIcon;

});

parcelRegister("79eFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcae149a5ba7fe08$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $dcae149a5ba7fe08$var$FavoriteLightIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 56 55",
        className: className || 'rf-h-full',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.465 -0.307)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("ellipse", {
                    cx: "28",
                    cy: "27.5",
                    rx: "28",
                    ry: "27.5",
                    transform: "translate(-0.465 0.307)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M449.065,485.074a24.475,24.475,0,1,0,24.476,24.476A24.475,24.475,0,0,0,449.065,485.074Zm12.272,31.086a51.307,51.307,0,0,1-9.969,9.625l-2.3,1.659-2.3-1.659a51.425,51.425,0,0,1-9.966-9.625,17.755,17.755,0,0,1-3.474-9.857,10.391,10.391,0,0,1,10.26-10.353h.1a10.28,10.28,0,0,1,5.387,1.52,10.291,10.291,0,0,1,5.39-1.52h.1A10.388,10.388,0,0,1,464.808,506.3,17.75,17.75,0,0,1,461.337,516.16Z",
                    transform: "translate(-421.48 -482.143)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M445.93,489.861h-.056a6.46,6.46,0,0,0-5.39,2.947,6.45,6.45,0,0,0-5.387-2.947h-.059a6.412,6.412,0,0,0-6.353,6.409A13.817,13.817,0,0,0,431.4,503.8a47.5,47.5,0,0,0,9.086,8.752,47.479,47.479,0,0,0,9.09-8.752,13.817,13.817,0,0,0,2.712-7.529A6.413,6.413,0,0,0,445.93,489.861Z",
                    transform: "translate(-412.899 -472.11)",
                    fill: "#cb0038"
                })
            ]
        })
    });
};
var $dcae149a5ba7fe08$export$2e2bcd8739ae039 = $dcae149a5ba7fe08$var$FavoriteLightIcon;

});

parcelRegister("41UZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a39ab1584f39e386$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $a39ab1584f39e386$var$PhoneIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 40",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            transform: "translate(-183.86 -57.462) rotate(-21)",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                d: "M162.1,156.952a2.852,2.852,0,0,0,2.91-2.915V127.8a2.851,2.851,0,0,0-2.91-2.915H151.91A2.851,2.851,0,0,0,149,127.8v26.233a2.852,2.852,0,0,0,2.91,2.915ZM157,155.738a1.455,1.455,0,1,1,1.455-1.455A1.456,1.456,0,0,1,157,155.738Zm-2.183-29.072c0-.18.086-.322.194-.322h3.978c.106,0,.194.144.194.322v.086c0,.18-.087.322-.194.322h-3.978c-.106,0-.194-.144-.194-.322Zm-4.365,1.861h13.1V151.81h-13.1Zm0,0"
            })
        })
    });
};
var $a39ab1584f39e386$export$2e2bcd8739ae039 = $a39ab1584f39e386$var$PhoneIcon;

});

parcelRegister("epsYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4c11de8d3c839$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $47d4c11de8d3c839$var$PhotoCameraIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 67.258 60.532",
        className: className || 'rf-w-6 rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(15.629 13.766)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M34.722,23.961A10.761,10.761,0,1,1,23.961,13.2,10.761,10.761,0,0,1,34.722,23.961Z",
                    transform: "translate(-5.961 -4.098)",
                    fill: color || '#f1f1f1'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M26.54,3,20.386,9.726H9.726A6.746,6.746,0,0,0,3,16.452V56.806a6.746,6.746,0,0,0,6.726,6.726H63.532a6.746,6.746,0,0,0,6.726-6.726V16.452a6.746,6.746,0,0,0-6.726-6.726H52.872L46.718,3ZM36.629,53.443A16.814,16.814,0,1,1,53.443,36.629,16.821,16.821,0,0,1,36.629,53.443Z",
                    transform: "translate(-18.629 -16.766)",
                    fill: color || '#f1f1f1'
                })
            ]
        })
    });
};
var $47d4c11de8d3c839$export$2e2bcd8739ae039 = $47d4c11de8d3c839$var$PhotoCameraIcon;

});

parcelRegister("57bW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $11cbe1500ba239e9$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $11cbe1500ba239e9$var$PrintIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.578 24.578",
        className: className || 'rf-h-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0.5 0.5)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M9,11.252V3H23.147v8.252",
                    transform: "translate(-4.284 -3)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M7.716,24.11H5.358A2.358,2.358,0,0,1,3,21.752V15.858A2.358,2.358,0,0,1,5.358,13.5H24.221a2.358,2.358,0,0,1,2.358,2.358v5.895a2.358,2.358,0,0,1-2.358,2.358H21.863",
                    transform: "translate(-3 -5.248)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M9,21H23.147v9.431H9Z",
                    transform: "translate(-4.284 -6.853)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $11cbe1500ba239e9$export$2e2bcd8739ae039 = $11cbe1500ba239e9$var$PrintIcon;

});

parcelRegister("cUlNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d540d7a8841cf7f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $3d540d7a8841cf7f$var$RoundIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20.306 20.306",
        className: className || 'rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-2 -2)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M21.306,12.153A9.153,9.153,0,1,1,12.153,3a9.153,9.153,0,0,1,9.153,9.153Z",
                    transform: "translate(0 0)",
                    fill: "none",
                    stroke: color || '#000',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M18,21.661V18",
                    transform: "translate(-5.847 -5.847)",
                    fill: "none",
                    stroke: color || '#000',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M18,12h0",
                    transform: "translate(-5.847 -3.508)",
                    fill: "none",
                    stroke: color || '#000',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $3d540d7a8841cf7f$export$2e2bcd8739ae039 = $3d540d7a8841cf7f$var$RoundIcon;

});


parcelRegister("aibZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $77e4e32557e626d1$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $2ARZ1 = parcelRequire("2ARZ1");

var $jxUH4 = parcelRequire("jxUH4");

var $dETBS = parcelRequire("dETBS");

var $6hsJH = parcelRequire("6hsJH");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $e0vOG = parcelRequire("e0vOG");

var $fP0xm = parcelRequire("fP0xm");

var $czL4i = parcelRequire("czL4i");

var $jEto0 = parcelRequire("jEto0");

var $avB5i = parcelRequire("avB5i");

var $kHqm7 = parcelRequire("kHqm7");

var $aF5fn = parcelRequire("aF5fn");

var $kBgJ7 = parcelRequire("kBgJ7");

var $5Iu0J = parcelRequire("5Iu0J");
'use client';
var $77e4e32557e626d1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $77e4e32557e626d1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { PDFDataRangeTransport: $77e4e32557e626d1$var$PDFDataRangeTransport } = (0, $fP0xm.default);
const $77e4e32557e626d1$var$defaultOnPassword = (callback, reason)=>{
    switch(reason){
        case (0, $kHqm7.default).NEED_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                const password = prompt('Enter the password to open this PDF file.');
                callback(password);
                break;
            }
        case (0, $kHqm7.default).INCORRECT_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                const password = prompt('Invalid password. Please try again.');
                callback(password);
                break;
            }
        default:
    }
};
function $77e4e32557e626d1$var$isParameterObject(file) {
    return typeof file === 'object' && file !== null && ('data' in file || 'range' in file || 'url' in file);
}
/**
 * Loads a document passed using `file` prop.
 */ const $77e4e32557e626d1$var$Document = (0, $bxRTa.forwardRef)(function Document(_a, ref) {
    var { children: children, className: className, error: error = 'Failed to load PDF file.', externalLinkRel: externalLinkRel, externalLinkTarget: externalLinkTarget, file: file, inputRef: inputRef, imageResourcesPath: imageResourcesPath, loading: loading = "Loading PDF\u2026", noData: noData = 'No PDF file specified.', onItemClick: onItemClick, onLoadError: onLoadErrorProps, onLoadProgress: onLoadProgress, onLoadSuccess: onLoadSuccessProps, onPassword: onPassword = $77e4e32557e626d1$var$defaultOnPassword, onSourceError: onSourceErrorProps, onSourceSuccess: onSourceSuccessProps, options: options, renderMode: renderMode, rotate: rotate } = _a, otherProps = $77e4e32557e626d1$var$__rest(_a, [
        "children",
        "className",
        "error",
        "externalLinkRel",
        "externalLinkTarget",
        "file",
        "inputRef",
        "imageResourcesPath",
        "loading",
        "noData",
        "onItemClick",
        "onLoadError",
        "onLoadProgress",
        "onLoadSuccess",
        "onPassword",
        "onSourceError",
        "onSourceSuccess",
        "options",
        "renderMode",
        "rotate"
    ]);
    const [sourceState, sourceDispatch] = (0, $kBgJ7.default)();
    const { value: source, error: sourceError } = sourceState;
    const [pdfState, pdfDispatch] = (0, $kBgJ7.default)();
    const { value: pdf, error: pdfError } = pdfState;
    const linkService = (0, $bxRTa.useRef)(new (0, $avB5i.default)());
    const pages = (0, $bxRTa.useRef)([]);
    const prevFile = (0, $bxRTa.useRef)();
    const prevOptions = (0, $bxRTa.useRef)();
    (0, $bxRTa.useEffect)(()=>{
        if (file && file !== prevFile.current && $77e4e32557e626d1$var$isParameterObject(file)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(!(0, $e0vOG.dequal)(file, prevFile.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`);
            prevFile.current = file;
        }
    }, [
        file
    ]);
    // Detect non-memoized changes in options prop
    (0, $bxRTa.useEffect)(()=>{
        if (options && options !== prevOptions.current) {
            (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(!(0, $e0vOG.dequal)(options, prevOptions.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`);
            prevOptions.current = options;
        }
    }, [
        options
    ]);
    const viewer = (0, $bxRTa.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: (args)=>{
            const { dest: dest, pageNumber: pageNumber, pageIndex: pageIndex = pageNumber - 1 } = args;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            const page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, `An internal link leading to page ${pageNumber} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
        }
    });
    (0, $bxRTa.useImperativeHandle)(ref, ()=>({
            linkService: linkService,
            pages: pages,
            viewer: viewer
        }), []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    const findDocumentSource = (0, $bxRTa.useCallback)(()=>$77e4e32557e626d1$var$__awaiter(this, void 0, void 0, function*() {
            if (!file) return null;
            // File is a string
            if (typeof file === 'string') {
                if ((0, $aF5fn.isDataURI)(file)) {
                    const fileByteString = (0, $aF5fn.dataURItoByteString)(file);
                    return {
                        data: fileByteString
                    };
                }
                (0, $aF5fn.displayCORSWarning)();
                return {
                    url: file
                };
            }
            // File is PDFDataRangeTransport
            if (file instanceof $77e4e32557e626d1$var$PDFDataRangeTransport) return {
                range: file
            };
            // File is an ArrayBuffer
            if ((0, $aF5fn.isArrayBuffer)(file)) return {
                data: file
            };
            /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $aF5fn.isBrowser) // File is a Blob
            {
                if ((0, $aF5fn.isBlob)(file)) {
                    const data = yield (0, $aF5fn.loadFromFile)(file);
                    return {
                        data: data
                    };
                }
            }
            // At this point, file must be an object
            (0, $ctQXl.default)(typeof file === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
            (0, $ctQXl.default)($77e4e32557e626d1$var$isParameterObject(file), 'Invalid parameter object: need either .data, .range or .url');
            // File .url is a string
            if ('url' in file && typeof file.url === 'string') {
                if ((0, $aF5fn.isDataURI)(file.url)) {
                    const { url: url } = file, otherParams = $77e4e32557e626d1$var$__rest(file, [
                        "url"
                    ]);
                    const fileByteString = (0, $aF5fn.dataURItoByteString)(url);
                    return Object.assign({
                        data: fileByteString
                    }, otherParams);
                }
                (0, $aF5fn.displayCORSWarning)();
            }
            return file;
        }), [
        file
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const cancellable = (0, $dETBS.default)(findDocumentSource());
        cancellable.promise.then((nextSource)=>{
            sourceDispatch({
                type: 'RESOLVE',
                value: nextSource
            });
        }).catch((error)=>{
            sourceDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $aF5fn.cancelRunningTask)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (typeof source === 'undefined') return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    function resetDocument() {
        pdfDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetDocument, [
        pdfDispatch,
        source
    ]);
    function loadDocument() {
        if (!source) return;
        const documentInitParams = options ? Object.assign(Object.assign({}, source), options) : source;
        const destroyable = (0, $fP0xm.default).getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        const loadingTask = destroyable;
        loadingTask.promise.then((nextPdf)=>{
            pdfDispatch({
                type: 'RESOLVE',
                value: nextPdf
            });
        }).catch((error)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            loadingTask.destroy();
        };
    }
    (0, $bxRTa.useEffect)(loadDocument, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        options,
        pdfDispatch,
        source
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (typeof pdf === 'undefined') return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pdf
    ]);
    function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }
    (0, $bxRTa.useEffect)(setupLinkService, [
        externalLinkRel,
        externalLinkTarget
    ]);
    function registerPage(pageIndex, ref) {
        pages.current[pageIndex] = ref;
    }
    function unregisterPage(pageIndex) {
        delete pages.current[pageIndex];
    }
    const childContext = (0, $bxRTa.useMemo)(()=>({
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            unregisterPage: unregisterPage
        }), [
        imageResourcesPath,
        onItemClick,
        pdf,
        renderMode,
        rotate
    ]);
    const eventProps = (0, $bxRTa.useMemo)(()=>(0, $jxUH4.default)(otherProps, ()=>pdf), [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $czL4i.default).Provider, {
            value: childContext
        }, children);
    }
    function renderContent() {
        if (!file) return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $jEto0.default), {
            type: "no-data"
        }, typeof noData === 'function' ? noData() : noData);
        if (pdf === undefined || pdf === null) return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $jEto0.default), {
            type: "loading"
        }, typeof loading === 'function' ? loading() : loading);
        if (pdf === false) return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $jEto0.default), {
            type: "error"
        }, typeof error === 'function' ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("div", Object.assign({
        className: (0, $6hsJH.default)('react-pdf__Document', className),
        ref: inputRef,
        style: {
            ['--scale-factor']: '1'
        }
    }, eventProps), renderContent());
});
const $77e4e32557e626d1$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
]);
$77e4e32557e626d1$var$Document.propTypes = Object.assign(Object.assign({}, (0, $5Iu0J.eventProps)), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node,
    className: (0, $5Iu0J.isClassName),
    error: $77e4e32557e626d1$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
        '_self',
        '_blank',
        '_parent',
        '_top'
    ]),
    file: (0, $5Iu0J.isFile),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
    inputRef: (0, $5Iu0J.isRef),
    loading: $77e4e32557e626d1$var$isFunctionOrNode,
    noData: $77e4e32557e626d1$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).shape({
        canvasFactory: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any,
        canvasMaxAreaInBytes: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
        cMapPacked: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        CMapReaderFactory: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any,
        cMapUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
        disableAutoFetch: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        disableFontFace: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        disableRange: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        disableStream: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        docBaseUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
        enableXfa: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        filterFactory: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any,
        fontExtraProperties: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).object,
        isEvalSupported: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        isOffscreenCanvasSupported: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        length: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
        maxImageSize: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
        ownerDocument: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any,
        password: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
        pdfBug: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        rangeChunkSize: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
        StandardFontDataFactory: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any,
        standardFontDataUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
        stopAtErrors: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        useSystemFonts: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        useWorkerFetch: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        verbosity: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        worker: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any
    }),
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number
});
var $77e4e32557e626d1$export$2e2bcd8739ae039 = $77e4e32557e626d1$var$Document;

});
parcelRegister("2ARZ1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1e38d185da9648c7$var$ReactIs, $1e38d185da9648c7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("7vU9M"))();

});

parcelRegister("jxUH4", function(module, exports) {

$parcel$export(module.exports, "allEvents", () => $e3ad1397f4ab3408$export$59ef7197c4d7b9dc);
$parcel$export(module.exports, "default", () => $e3ad1397f4ab3408$export$2e2bcd8739ae039);
var $e3ad1397f4ab3408$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e3ad1397f4ab3408$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
var $e3ad1397f4ab3408$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
var $e3ad1397f4ab3408$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
var $e3ad1397f4ab3408$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
var $e3ad1397f4ab3408$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
var $e3ad1397f4ab3408$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
var $e3ad1397f4ab3408$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
var $e3ad1397f4ab3408$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
var $e3ad1397f4ab3408$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
var $e3ad1397f4ab3408$export$d93346aa7735a637 = [
    'onSelect'
];
var $e3ad1397f4ab3408$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var $e3ad1397f4ab3408$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
var $e3ad1397f4ab3408$export$bac3087b5cb826f6 = [
    'onScroll'
];
var $e3ad1397f4ab3408$export$28298837799e00e8 = [
    'onWheel'
];
var $e3ad1397f4ab3408$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
var $e3ad1397f4ab3408$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
var $e3ad1397f4ab3408$export$477a88c5b93a108d = [
    'onToggle'
];
var $e3ad1397f4ab3408$export$7212b61f9f58bd1 = [
    'onChange'
];
var $e3ad1397f4ab3408$export$59ef7197c4d7b9dc = $e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray($e3ad1397f4ab3408$var$__spreadArray([], $e3ad1397f4ab3408$export$84fe03429ed1b6d6, true), $e3ad1397f4ab3408$export$dbc46161504615f7, true), $e3ad1397f4ab3408$export$fb6351c2666f0875, true), $e3ad1397f4ab3408$export$4e58c1a9761ed81a, true), $e3ad1397f4ab3408$export$3bf7402f2a4eb3af, true), $e3ad1397f4ab3408$export$409c4891d97f97cf, true), $e3ad1397f4ab3408$export$6be5aa2386088264, true), $e3ad1397f4ab3408$export$3a6e2b8954613992, true), $e3ad1397f4ab3408$export$6c96379d5b8a2df7, true), $e3ad1397f4ab3408$export$d93346aa7735a637, true), $e3ad1397f4ab3408$export$fa367689c659e65c, true), $e3ad1397f4ab3408$export$c731eab7619e00a0, true), $e3ad1397f4ab3408$export$bac3087b5cb826f6, true), $e3ad1397f4ab3408$export$28298837799e00e8, true), $e3ad1397f4ab3408$export$6ff45424014e7407, true), $e3ad1397f4ab3408$export$78878fc7bd50dc3e, true), $e3ad1397f4ab3408$export$7212b61f9f58bd1, true), $e3ad1397f4ab3408$export$477a88c5b93a108d, true);
function $e3ad1397f4ab3408$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $e3ad1397f4ab3408$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}

});

parcelRegister("dETBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1a25c040e46472$export$2e2bcd8739ae039);
function $9f1a25c040e46472$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}

});

parcelRegister("6hsJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aee94404b6d2bdcb$export$2e2bcd8739ae039);
function $aee94404b6d2bdcb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $aee94404b6d2bdcb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $aee94404b6d2bdcb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $aee94404b6d2bdcb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $aee94404b6d2bdcb$export$2e2bcd8739ae039 = $aee94404b6d2bdcb$export$4f5d2d50c9deca37;

});

parcelRegister("ctQXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $916145766421847b$export$2e2bcd8739ae039);
var $916145766421847b$var$isProduction = true;
var $916145766421847b$var$prefix = 'Invariant failed';
function $916145766421847b$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($916145766421847b$var$isProduction) throw new Error($916145766421847b$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($916145766421847b$var$prefix, ": ").concat(provided) : $916145766421847b$var$prefix;
    throw new Error(value);
}

});

parcelRegister("aKmSP", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $7d2ff36ac3c8809b$var$__DEV__ = false;
var $7d2ff36ac3c8809b$var$warning = function() {};
if ($7d2ff36ac3c8809b$var$__DEV__) {
    var $7d2ff36ac3c8809b$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $7d2ff36ac3c8809b$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $7d2ff36ac3c8809b$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $7d2ff36ac3c8809b$var$warning;

});

parcelRegister("e0vOG", function(module, exports) {

$parcel$export(module.exports, "dequal", () => $6c54642c3d3a767a$export$de8294bb3be0322f);
var $6c54642c3d3a767a$var$has = Object.prototype.hasOwnProperty;
function $6c54642c3d3a767a$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($6c54642c3d3a767a$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $6c54642c3d3a767a$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $6c54642c3d3a767a$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $6c54642c3d3a767a$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $6c54642c3d3a767a$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$6c54642c3d3a767a$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($6c54642c3d3a767a$var$has.call(foo, ctor) && ++len && !$6c54642c3d3a767a$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$6c54642c3d3a767a$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});

parcelRegister("fP0xm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b84c09165b133011$export$2e2bcd8739ae039);

var $hd0ee = parcelRequire("hd0ee");
const $b84c09165b133011$var$pdfjs = 'default' in $hd0ee ? $hd0ee['default'] : $hd0ee;
var $b84c09165b133011$export$2e2bcd8739ae039 = $b84c09165b133011$var$pdfjs;

});

parcelRegister("czL4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $927d43b5f4e29168$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
'use client';
var $927d43b5f4e29168$export$2e2bcd8739ae039 = (0, $bxRTa.createContext)(null);

});

parcelRegister("jEto0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e88c38b64def0f$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
function $e4e88c38b64def0f$export$2e2bcd8739ae039({ children: children, type: type }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("div", {
        className: `react-pdf__message react-pdf__message--${type}`
    }, children);
}

});

parcelRegister("avB5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6990d0b67ed4f4$export$2e2bcd8739ae039);
/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $ctQXl = parcelRequire("ctQXl");
const $7a6990d0b67ed4f4$var$DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
class $7a6990d0b67ed4f4$export$2e2bcd8739ae039 {
    constructor(){
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
    }
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    setExternalLinkRel(externalLinkRel) {
        this.externalLinkRel = externalLinkRel;
    }
    setExternalLinkTarget(externalLinkTarget) {
        this.externalLinkTarget = externalLinkTarget;
    }
    setHistory() {
    // Intentionally empty
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        (0, $ctQXl.default)(this.pdfViewer, 'PDF viewer is not initialized.');
        return this.pdfViewer.currentPageNumber || 0;
    }
    set page(value) {
        (0, $ctQXl.default)(this.pdfViewer, 'PDF viewer is not initialized.');
        this.pdfViewer.currentPageNumber = value;
    }
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get rotation() {
        return 0;
    }
    set rotation(value) {
    // Intentionally empty
    }
    goToDestination(dest) {
        return new Promise((resolve)=>{
            (0, $ctQXl.default)(this.pdfDocument, 'PDF document not loaded.');
            (0, $ctQXl.default)(dest, 'Destination is not specified.');
            if (typeof dest === 'string') this.pdfDocument.getDestination(dest).then(resolve);
            else if (Array.isArray(dest)) resolve(dest);
            else dest.then(resolve);
        }).then((explicitDest)=>{
            (0, $ctQXl.default)(Array.isArray(explicitDest), `"${explicitDest}" is not a valid destination array.`);
            const destRef = explicitDest[0];
            new Promise((resolve)=>{
                (0, $ctQXl.default)(this.pdfDocument, 'PDF document not loaded.');
                if (destRef instanceof Object) this.pdfDocument.getPageIndex(destRef).then((pageIndex)=>{
                    resolve(pageIndex);
                }).catch(()=>{
                    (0, $ctQXl.default)(false, `"${destRef}" is not a valid page reference.`);
                });
                else if (typeof destRef === 'number') resolve(destRef);
                else (0, $ctQXl.default)(false, `"${destRef}" is not a valid destination reference.`);
            }).then((pageIndex)=>{
                const pageNumber = pageIndex + 1;
                (0, $ctQXl.default)(this.pdfViewer, 'PDF viewer is not initialized.');
                (0, $ctQXl.default)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
                this.pdfViewer.scrollPageIntoView({
                    dest: explicitDest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
    }
    navigateTo(dest) {
        this.goToDestination(dest);
    }
    goToPage(pageNumber) {
        const pageIndex = pageNumber - 1;
        (0, $ctQXl.default)(this.pdfViewer, 'PDF viewer is not initialized.');
        (0, $ctQXl.default)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
        this.pdfViewer.scrollPageIntoView({
            pageIndex: pageIndex,
            pageNumber: pageNumber
        });
    }
    addLinkAttributes(link, url, newWindow) {
        link.href = url;
        link.rel = this.externalLinkRel || $7a6990d0b67ed4f4$var$DEFAULT_LINK_REL;
        link.target = newWindow ? '_blank' : this.externalLinkTarget || '';
    }
    getDestinationHash() {
        return '#';
    }
    getAnchorUrl() {
        return '#';
    }
    setHash() {
    // Intentionally empty
    }
    executeNamedAction() {
    // Intentionally empty
    }
    cachePageRef() {
    // Intentionally empty
    }
    isPageVisible() {
        return true;
    }
    isPageCached() {
        return true;
    }
    executeSetOCGState() {
    // Intentionally empty
    }
}

});

parcelRegister("kHqm7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11c44876790bd57$export$2e2bcd8739ae039);
// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
const $f11c44876790bd57$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $f11c44876790bd57$export$2e2bcd8739ae039 = $f11c44876790bd57$var$PasswordResponses;

});

parcelRegister("aF5fn", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $7c31cda59002fbe9$export$4e09c449d6c407f7);
$parcel$export(module.exports, "isDefined", () => $7c31cda59002fbe9$export$4e62c701997796c1);
$parcel$export(module.exports, "isProvided", () => $7c31cda59002fbe9$export$ef8866826b0b1f6d);
$parcel$export(module.exports, "isArrayBuffer", () => $7c31cda59002fbe9$export$9dd3754ae86f0017);
$parcel$export(module.exports, "isBlob", () => $7c31cda59002fbe9$export$5bcd6e94ed871c88);
$parcel$export(module.exports, "isDataURI", () => $7c31cda59002fbe9$export$4d82193ef6a8d75c);
$parcel$export(module.exports, "dataURItoByteString", () => $7c31cda59002fbe9$export$c1553384119518c3);
$parcel$export(module.exports, "getDevicePixelRatio", () => $7c31cda59002fbe9$export$cf4a949e5ad681d);
$parcel$export(module.exports, "displayCORSWarning", () => $7c31cda59002fbe9$export$84884c3182d1bdda);
$parcel$export(module.exports, "displayWorkerWarning", () => $7c31cda59002fbe9$export$e7ec4a9e2d586a77);
$parcel$export(module.exports, "cancelRunningTask", () => $7c31cda59002fbe9$export$b8c3f1dffc289352);
$parcel$export(module.exports, "makePageCallback", () => $7c31cda59002fbe9$export$8cc3f6b8d58bdda0);
$parcel$export(module.exports, "isCancelException", () => $7c31cda59002fbe9$export$99075c4d008e6ab1);
$parcel$export(module.exports, "loadFromFile", () => $7c31cda59002fbe9$export$21fedb3a7a137f3d);

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");
const $7c31cda59002fbe9$export$4e09c449d6c407f7 = typeof document !== 'undefined';
const $7c31cda59002fbe9$export$d528e4159a0e221e = $7c31cda59002fbe9$export$4e09c449d6c407f7 && window.location.protocol === 'file:';
function $7c31cda59002fbe9$export$4e62c701997796c1(variable) {
    return typeof variable !== 'undefined';
}
function $7c31cda59002fbe9$export$ef8866826b0b1f6d(variable) {
    return $7c31cda59002fbe9$export$4e62c701997796c1(variable) && variable !== null;
}
function $7c31cda59002fbe9$export$844ec244b1367d54(variable) {
    return typeof variable === 'string';
}
function $7c31cda59002fbe9$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $7c31cda59002fbe9$export$5bcd6e94ed871c88(variable) {
    (0, $ctQXl.default)($7c31cda59002fbe9$export$4e09c449d6c407f7, 'isBlob can only be used in a browser environment');
    return variable instanceof Blob;
}
function $7c31cda59002fbe9$export$4d82193ef6a8d75c(variable) {
    return $7c31cda59002fbe9$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $7c31cda59002fbe9$export$c1553384119518c3(dataURI) {
    (0, $ctQXl.default)($7c31cda59002fbe9$export$4d82193ef6a8d75c(dataURI), 'Invalid data URI.');
    const [headersString = '', dataString = ''] = dataURI.split(',');
    const headers = headersString.split(';');
    if (headers.indexOf('base64') !== -1) return atob(dataString);
    return unescape(dataString);
}
function $7c31cda59002fbe9$export$cf4a949e5ad681d() {
    return $7c31cda59002fbe9$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $7c31cda59002fbe9$var$allowFileAccessFromFilesTip = 'On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.';
function $7c31cda59002fbe9$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(!$7c31cda59002fbe9$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$7c31cda59002fbe9$var$allowFileAccessFromFilesTip}`);
}
function $7c31cda59002fbe9$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(!$7c31cda59002fbe9$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$7c31cda59002fbe9$var$allowFileAccessFromFilesTip}`);
}
function $7c31cda59002fbe9$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $7c31cda59002fbe9$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, 'width', {
        get () {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'height', {
        get () {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalWidth', {
        get () {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalHeight', {
        get () {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $7c31cda59002fbe9$export$99075c4d008e6ab1(error) {
    return error.name === 'RenderingCancelledException';
}
function $7c31cda59002fbe9$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error('Error while reading a file.'));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error('Error while reading a file.'));
            const { error: error } = event.target;
            if (!error) return reject(new Error('Error while reading a file.'));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error('Error while reading a file: File not found.'));
                case error.SECURITY_ERR:
                    return reject(new Error('Error while reading a file: Security error.'));
                case error.ABORT_ERR:
                    return reject(new Error('Error while reading a file: Aborted.'));
                default:
                    return reject(new Error('Error while reading a file.'));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}

});

parcelRegister("kBgJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $eff43ce9382cea09$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
function $eff43ce9382cea09$var$reducer(state, action) {
    switch(action.type){
        case 'RESOLVE':
            return {
                value: action.value,
                error: undefined
            };
        case 'REJECT':
            return {
                value: false,
                error: action.error
            };
        case 'RESET':
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $eff43ce9382cea09$export$2e2bcd8739ae039() {
    return (0, $bxRTa.useReducer)($eff43ce9382cea09$var$reducer, {
        value: undefined,
        error: undefined
    });
}

});

parcelRegister("5Iu0J", function(module, exports) {

$parcel$export(module.exports, "eventProps", () => $4298575618983426$export$1e08905474334888);
$parcel$export(module.exports, "isClassName", () => $4298575618983426$export$d53f3db2f43345df);
$parcel$export(module.exports, "isFile", () => $4298575618983426$export$be78b3111c50efdd);
$parcel$export(module.exports, "isPageIndex", () => $4298575618983426$export$7b4c8bd6e6871332);
$parcel$export(module.exports, "isPageNumber", () => $4298575618983426$export$973e710208ddd50f);
$parcel$export(module.exports, "isPdf", () => $4298575618983426$export$d22001c6ab8dd37);
$parcel$export(module.exports, "isRef", () => $4298575618983426$export$4f9f5282de18fc69);
$parcel$export(module.exports, "isRenderMode", () => $4298575618983426$export$70f0c3edbd58f82c);
$parcel$export(module.exports, "isRotate", () => $4298575618983426$export$10b2580337f7e7c1);

var $2ARZ1 = parcelRequire("2ARZ1");

var $jxUH4 = parcelRequire("jxUH4");

var $fP0xm = parcelRequire("fP0xm");

var $aF5fn = parcelRequire("aF5fn");

var $avB5i = parcelRequire("avB5i");
const { PDFDataRangeTransport: $4298575618983426$var$PDFDataRangeTransport } = (0, $fP0xm.default);
const $4298575618983426$export$1e08905474334888 = (()=>{
    const result = {};
    (0, $jxUH4.allEvents).forEach((eventName)=>{
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func;
    });
    return result;
})();
const $4298575618983426$var$isTypedArray = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Int8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Uint8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Uint8ClampedArray),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Int16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Uint16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Int32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Uint32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Float32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Float64Array)
]);
const $4298575618983426$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(ArrayBuffer),
            (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number.isRequired),
            $4298575618983426$var$isTypedArray
        ]).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).shape({
        range: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf($4298575618983426$var$PDFDataRangeTransport).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).shape({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string.isRequired
    })
];
if (typeof Blob !== 'undefined') $4298575618983426$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(Blob));
const $4298575618983426$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string)
]);
const $4298575618983426$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType($4298575618983426$var$fileTypes);
const $4298575618983426$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf((0, $avB5i.default));
const $4298575618983426$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
    '_self',
    '_blank',
    '_parent',
    '_top'
]);
const $4298575618983426$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).shape({
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).shape({}).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func.isRequired
});
const $4298575618983426$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    const { [propName]: pageIndex, pageNumber: pageNumber, pdf: pdf } = props;
    if (!(0, $aF5fn.isDefined)(pdf)) return null;
    if ((0, $aF5fn.isDefined)(pageIndex)) {
        if (typeof pageIndex !== 'number') return new Error(`\`${propName}\` of type \`${typeof pageIndex}\` supplied to \`${componentName}\`, expected \`number\`.`);
        if (pageIndex < 0) return new Error(`Expected \`${propName}\` to be greater or equal to 0.`);
        const { numPages: numPages } = pdf;
        if (pageIndex + 1 > numPages) return new Error(`Expected \`${propName}\` to be less or equal to ${numPages - 1}.`);
    } else if (!(0, $aF5fn.isDefined)(pageNumber)) return new Error(`\`${propName}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${componentName}\`.`);
    // Everything is fine
    return null;
};
const $4298575618983426$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    const { [propName]: pageNumber, pageIndex: pageIndex, pdf: pdf } = props;
    if (!(0, $aF5fn.isDefined)(pdf)) return null;
    if ((0, $aF5fn.isDefined)(pageNumber)) {
        if (typeof pageNumber !== 'number') return new Error(`\`${propName}\` of type \`${typeof pageNumber}\` supplied to \`${componentName}\`, expected \`number\`.`);
        if (pageNumber < 1) return new Error(`Expected \`${propName}\` to be greater or equal to 1.`);
        const { numPages: numPages } = pdf;
        if (pageNumber > numPages) return new Error(`Expected \`${propName}\` to be less or equal to ${numPages}.`);
    } else if (!(0, $aF5fn.isDefined)(pageIndex)) return new Error(`\`${propName}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${componentName}\`.`);
    // Everything is fine
    return null;
};
const $4298575618983426$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
    // Ideally, this would be `PropTypes.instanceOf(PDFDocumentProxy)`, but it can't be imported.
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any,
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
        false
    ])
]);
const $4298575618983426$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).exact({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).any
    })
]);
const $4298575618983426$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
    'canvas',
    'custom',
    'none',
    'svg'
]);
const $4298575618983426$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
    0,
    90,
    180,
    270
]);

});


parcelRegister("Zrrxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b8afc3fcf8b5ecf$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $2ARZ1 = parcelRequire("2ARZ1");

var $dETBS = parcelRequire("dETBS");

var $jxUH4 = parcelRequire("jxUH4");

var $6hsJH = parcelRequire("6hsJH");

var $gXRT3 = parcelRequire("gXRT3");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $G00Vw = parcelRequire("G00Vw");

var $jEto0 = parcelRequire("jEto0");

var $6nn85 = parcelRequire("6nn85");

var $gdYu3 = parcelRequire("gdYu3");

var $g5sZY = parcelRequire("g5sZY");

var $3Svrl = parcelRequire("3Svrl");

var $aF5fn = parcelRequire("aF5fn");

var $e4eH2 = parcelRequire("e4eH2");

var $kBgJ7 = parcelRequire("kBgJ7");

var $5Iu0J = parcelRequire("5Iu0J");
'use client';
var $0b8afc3fcf8b5ecf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0b8afc3fcf8b5ecf$var$defaultScale = 1;
/**
 * Displays a page.
 *
 * Should be placed inside `<Document />`. Alternatively, it can have `pdf` prop passed, which can be obtained from `<Document />`'s `onLoadSuccess` callback function, however some advanced functions like linking between pages inside a document may not be working correctly.
 */ const $0b8afc3fcf8b5ecf$var$Page = function Page(props) {
    const documentContext = (0, $e4eH2.default)();
    const mergedProps = Object.assign(Object.assign({}, documentContext), props);
    const { _className: _className = 'react-pdf__Page', _enableRegisterUnregisterPage: _enableRegisterUnregisterPage = true, canvasBackground: canvasBackground, canvasRef: canvasRef, children: children, className: className, customRenderer: CustomRenderer, customTextRenderer: customTextRenderer, devicePixelRatio: devicePixelRatio, error: error = 'Failed to load the page.', height: height, inputRef: inputRef, loading: loading = "Loading page\u2026", noData: noData = 'No page specified.', onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps, onGetTextError: onGetTextErrorProps, onGetTextSuccess: onGetTextSuccessProps, onLoadError: onLoadErrorProps, onLoadSuccess: onLoadSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, onRenderTextLayerError: onRenderTextLayerErrorProps, onRenderTextLayerSuccess: onRenderTextLayerSuccessProps, pageIndex: pageIndexProps, pageNumber: pageNumberProps, pdf: pdf, registerPage: registerPage, renderAnnotationLayer: renderAnnotationLayerProps = true, renderForms: renderForms = false, renderMode: renderMode = 'canvas', renderTextLayer: renderTextLayerProps = true, rotate: rotateProps, scale: scaleProps = $0b8afc3fcf8b5ecf$var$defaultScale, unregisterPage: unregisterPage, width: width } = mergedProps, otherProps = $0b8afc3fcf8b5ecf$var$__rest(mergedProps, [
        "_className",
        "_enableRegisterUnregisterPage",
        "canvasBackground",
        "canvasRef",
        "children",
        "className",
        "customRenderer",
        "customTextRenderer",
        "devicePixelRatio",
        "error",
        "height",
        "inputRef",
        "loading",
        "noData",
        "onGetAnnotationsError",
        "onGetAnnotationsSuccess",
        "onGetStructTreeError",
        "onGetStructTreeSuccess",
        "onGetTextError",
        "onGetTextSuccess",
        "onLoadError",
        "onLoadSuccess",
        "onRenderAnnotationLayerError",
        "onRenderAnnotationLayerSuccess",
        "onRenderError",
        "onRenderSuccess",
        "onRenderTextLayerError",
        "onRenderTextLayerSuccess",
        "pageIndex",
        "pageNumber",
        "pdf",
        "registerPage",
        "renderAnnotationLayer",
        "renderForms",
        "renderMode",
        "renderTextLayer",
        "rotate",
        "scale",
        "unregisterPage",
        "width"
    ]);
    const [pageState, pageDispatch] = (0, $kBgJ7.default)();
    const { value: page, error: pageError } = pageState;
    const pageElement = (0, $bxRTa.useRef)(null);
    (0, $ctQXl.default)(pdf, 'Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    const pageIndex = (0, $aF5fn.isProvided)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    const pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $aF5fn.isProvided)(pageIndexProps) ? pageIndexProps + 1 : null;
    const rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    const scale = (0, $bxRTa.useMemo)(()=>{
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        let pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        const scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $0b8afc3fcf8b5ecf$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            const viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    function hook() {
        return ()=>{
            if (!(0, $aF5fn.isProvided)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }
    (0, $bxRTa.useEffect)(hook, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $aF5fn.makePageCallback)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $aF5fn.isProvided)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    function resetPage() {
        pageDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetPage, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    function loadPage() {
        if (!pdf || !pageNumber) return;
        const cancellable = (0, $dETBS.default)(pdf.getPage(pageNumber));
        const runningTask = cancellable;
        cancellable.promise.then((nextPage)=>{
            pageDispatch({
                type: 'RESOLVE',
                value: nextPage
            });
        }).catch((error)=>{
            pageDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $aF5fn.cancelRunningTask)(runningTask);
    }
    (0, $bxRTa.useEffect)(loadPage, [
        pageDispatch,
        pdf,
        pageIndex,
        pageNumber,
        registerPage
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        page,
        scale
    ]);
    const childContext = (0, $bxRTa.useMemo)(()=>// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        page && (0, $aF5fn.isProvided)(pageIndex) && pageNumber && (0, $aF5fn.isProvided)(rotate) && (0, $aF5fn.isProvided)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    const eventProps = (0, $bxRTa.useMemo)(()=>(0, $jxUH4.default)(otherProps, ()=>page ? scale ? (0, $aF5fn.makePageCallback)(page, scale) : undefined : page), [
        otherProps,
        page,
        scale
    ]);
    const pageKey = `${pageIndex}@${scale}/${rotate}`;
    const pageKeyNoScale = `${pageIndex}/${rotate}`;
    function renderMainLayer() {
        switch(renderMode){
            case 'custom':
                (0, $ctQXl.default)(CustomRenderer, `renderMode was set to "custom", but no customRenderer was passed.`);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement(CustomRenderer, {
                    key: `${pageKey}_custom`
                });
            case 'none':
                return null;
            case 'svg':
                return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $gdYu3.default), {
                    key: `${pageKeyNoScale}_svg`
                });
            case 'canvas':
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $6nn85.default), {
                    key: `${pageKey}_canvas`,
                    canvasRef: canvasRef
                });
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $g5sZY.default), {
            key: `${pageKey}_text`
        });
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        /**
         * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
         * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
         */ return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $3Svrl.default), {
            key: `${pageKey}_annotations`
        });
    }
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $G00Vw.default).Provider, {
            value: childContext
        }, renderMainLayer(), renderTextLayer(), renderAnnotationLayer(), children);
    }
    function renderContent() {
        if (!pageNumber) return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $jEto0.default), {
            type: "no-data"
        }, typeof noData === 'function' ? noData() : noData);
        if (pdf === null || page === undefined || page === null) return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $jEto0.default), {
            type: "loading"
        }, typeof loading === 'function' ? loading() : loading);
        if (pdf === false || page === false) return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $jEto0.default), {
            type: "error"
        }, typeof error === 'function' ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("div", Object.assign({
        className: (0, $6hsJH.default)(_className, className),
        "data-page-number": pageNumber,
        ref: (0, $gXRT3.default)(inputRef, pageElement),
        style: {
            ['--scale-factor']: `${scale}`,
            backgroundColor: canvasBackground || 'white',
            position: 'relative',
            minWidth: 'min-content',
            minHeight: 'min-content'
        }
    }, eventProps), renderContent());
};
const $0b8afc3fcf8b5ecf$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
]);
$0b8afc3fcf8b5ecf$var$Page.propTypes = Object.assign(Object.assign({}, (0, $5Iu0J.eventProps)), {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
    canvasRef: (0, $5Iu0J.isRef),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node,
    className: (0, $5Iu0J.isClassName),
    customRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    devicePixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
    error: $0b8afc3fcf8b5ecf$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
    inputRef: (0, $5Iu0J.isRef),
    loading: $0b8afc3fcf8b5ecf$var$isFunctionOrNode,
    noData: $0b8afc3fcf8b5ecf$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onRenderTextLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    onRenderTextLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).func,
    pageIndex: (0, $5Iu0J.isPageIndex),
    pageNumber: (0, $5Iu0J.isPageNumber),
    pdf: (0, $5Iu0J.isPdf),
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
    renderMode: (0, $5Iu0J.isRenderMode),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
    rotate: (0, $5Iu0J.isRotate),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).number
});
var $0b8afc3fcf8b5ecf$export$2e2bcd8739ae039 = $0b8afc3fcf8b5ecf$var$Page;

});
parcelRegister("gXRT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59bf4d9adb3405f$export$2e2bcd8739ae039);
/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $c59bf4d9adb3405f$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === 'function') inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}

});

parcelRegister("G00Vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e3ef20df2f7391$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
'use client';
var $07e3ef20df2f7391$export$2e2bcd8739ae039 = (0, $bxRTa.createContext)(null);

});

parcelRegister("6nn85", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a46d5182debc814$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $gXRT3 = parcelRequire("gXRT3");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $fP0xm = parcelRequire("fP0xm");

var $bpCvI = parcelRequire("bpCvI");

var $2etJo = parcelRequire("2etJo");

var $aF5fn = parcelRequire("aF5fn");
'use client';
const $4a46d5182debc814$var$ANNOTATION_MODE = (0, $fP0xm.default).AnnotationMode;
function $4a46d5182debc814$export$2e2bcd8739ae039(props) {
    const pageContext = (0, $2etJo.default)();
    (0, $ctQXl.default)(pageContext, 'Unable to find Page context.');
    const mergedProps = Object.assign(Object.assign({}, pageContext), props);
    const { _className: _className, canvasBackground: canvasBackground, devicePixelRatio: devicePixelRatio = (0, $aF5fn.getDevicePixelRatio)(), onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, page: page, renderForms: renderForms, renderTextLayer: renderTextLayer, rotate: rotate, scale: scale } = mergedProps;
    const { canvasRef: canvasRef } = props;
    (0, $ctQXl.default)(page, 'Attempted to render page canvas, but no page was specified.');
    const canvasElement = (0, $bxRTa.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $aF5fn.makePageCallback)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $aF5fn.isCancelException)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    const renderViewport = (0, $bxRTa.useMemo)(()=>page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        }), [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    const viewport = (0, $bxRTa.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        const { current: canvas } = canvasElement;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvas.style.visibility = 'hidden';
        const renderContext = {
            annotationMode: renderForms ? $4a46d5182debc814$var$ANNOTATION_MODE.ENABLE_FORMS : $4a46d5182debc814$var$ANNOTATION_MODE.ENABLE,
            canvasContext: canvas.getContext('2d', {
                alpha: false
            }),
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        const cancellable = page.render(renderContext);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            canvas.style.visibility = '';
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $aF5fn.cancelRunningTask)(runningTask);
    }
    (0, $bxRTa.useEffect)(drawPageOnCanvas, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canvasBackground,
        canvasElement,
        devicePixelRatio,
        page,
        renderForms,
        renderViewport,
        viewport
    ]);
    const cleanup = (0, $bxRTa.useCallback)(()=>{
        const { current: canvas } = canvasElement;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, [
        canvasElement
    ]);
    (0, $bxRTa.useEffect)(()=>cleanup, [
        cleanup
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("canvas", {
        className: `${_className}__canvas`,
        dir: "ltr",
        ref: (0, $gXRT3.default)(canvasRef, canvasElement),
        style: {
            display: 'block',
            userSelect: 'none'
        }
    }, renderTextLayer ? (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $bpCvI.default), null) : null);
}

});
parcelRegister("bpCvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $84efe6e8c2ddc301$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $dETBS = parcelRequire("dETBS");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $35aFx = parcelRequire("35aFx");

var $2etJo = parcelRequire("2etJo");

var $kBgJ7 = parcelRequire("kBgJ7");

var $aF5fn = parcelRequire("aF5fn");
function $84efe6e8c2ddc301$export$2e2bcd8739ae039() {
    const pageContext = (0, $2etJo.default)();
    (0, $ctQXl.default)(pageContext, 'Unable to find Page context.');
    const { onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps } = pageContext;
    const [structTreeState, structTreeDispatch] = (0, $kBgJ7.default)();
    const { value: structTree, error: structTreeError } = structTreeState;
    const { customTextRenderer: customTextRenderer, page: page } = pageContext;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    function resetAnnotations() {
        structTreeDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetAnnotations, [
        structTreeDispatch,
        page
    ]);
    function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        const cancellable = (0, $dETBS.default)(page.getStructTree());
        const runningTask = cancellable;
        cancellable.promise.then((nextStructTree)=>{
            structTreeDispatch({
                type: 'RESOLVE',
                value: nextStructTree
            });
        }).catch((error)=>{
            structTreeDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $aF5fn.cancelRunningTask)(runningTask);
    }
    (0, $bxRTa.useEffect)(loadStructTree, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        structTree
    ]);
    if (!structTree) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $35aFx.default), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}

});
parcelRegister("35aFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $23ea1d5bd7ea75c6$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $44wew = parcelRequire("44wew");
function $23ea1d5bd7ea75c6$export$2e2bcd8739ae039({ className: className, node: node }) {
    const attributes = (0, $bxRTa.useMemo)(()=>(0, $44wew.getAttributes)(node), [
        node
    ]);
    const children = (0, $bxRTa.useMemo)(()=>{
        if (!(0, $44wew.isStructTreeNode)(node)) return null;
        if ((0, $44wew.isStructTreeNodeWithOnlyContentChild)(node)) return null;
        return node.children.map((child, index)=>{
            return(// eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($23ea1d5bd7ea75c6$export$2e2bcd8739ae039, {
                key: index,
                node: child
            }));
        });
    }, [
        node
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("span", Object.assign({
        className: className
    }, attributes), children);
}

});
parcelRegister("44wew", function(module, exports) {

$parcel$export(module.exports, "isStructTreeNode", () => $2f708a041f5c0a43$export$9eeaf208d22fae4f);
$parcel$export(module.exports, "isStructTreeNodeWithOnlyContentChild", () => $2f708a041f5c0a43$export$3b7840712ba182f3);
$parcel$export(module.exports, "getAttributes", () => $2f708a041f5c0a43$export$fe94072fee8a6976);

var $hyAaB = parcelRequire("hyAaB");
function $2f708a041f5c0a43$export$80a007e7cc9dad0d(role) {
    return role in (0, $hyAaB.PDF_ROLE_TO_HTML_ROLE);
}
function $2f708a041f5c0a43$export$9eeaf208d22fae4f(node) {
    return 'children' in node;
}
function $2f708a041f5c0a43$export$3b7840712ba182f3(node) {
    if (!$2f708a041f5c0a43$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && 'id' in node.children[0];
}
function $2f708a041f5c0a43$export$aa440a09c67191c2(node) {
    const attributes = {};
    if ($2f708a041f5c0a43$export$9eeaf208d22fae4f(node)) {
        const { role: role } = node;
        const matches = role.match((0, $hyAaB.HEADING_PATTERN));
        if (matches) {
            attributes.role = 'heading';
            attributes['aria-level'] = Number(matches[1]);
        } else if ($2f708a041f5c0a43$export$80a007e7cc9dad0d(role)) {
            const htmlRole = (0, $hyAaB.PDF_ROLE_TO_HTML_ROLE)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $2f708a041f5c0a43$export$e86e6c9c68c5154c(node) {
    const attributes = {};
    if ($2f708a041f5c0a43$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes['aria-label'] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($2f708a041f5c0a43$export$3b7840712ba182f3(node)) {
            const [child] = node.children;
            if (child) {
                const childAttributes = $2f708a041f5c0a43$export$e86e6c9c68c5154c(child);
                return Object.assign(Object.assign({}, attributes), childAttributes);
            }
        }
    } else if ('id' in node) attributes['aria-owns'] = node.id;
    return attributes;
}
function $2f708a041f5c0a43$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return Object.assign(Object.assign({}, $2f708a041f5c0a43$export$aa440a09c67191c2(node)), $2f708a041f5c0a43$export$e86e6c9c68c5154c(node));
}

});
parcelRegister("hyAaB", function(module, exports) {

$parcel$export(module.exports, "PDF_ROLE_TO_HTML_ROLE", () => $cc81ab43c9eca151$export$789cd800273ee71a);
$parcel$export(module.exports, "HEADING_PATTERN", () => $cc81ab43c9eca151$export$4921bbe0701579e4);
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
const $cc81ab43c9eca151$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: 'group',
    Sect: 'group',
    Div: 'group',
    Aside: 'note',
    NonStruct: 'none',
    // Block level structure types
    P: null,
    // H<n>,
    H: 'heading',
    Title: null,
    FENote: 'note',
    // Sub-block level structure type
    Sub: 'group',
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: 'link',
    Annot: 'note',
    Form: 'form',
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: 'list',
    LI: 'listitem',
    LBody: null,
    // Table standard structure types
    Table: 'table',
    TR: 'row',
    TH: 'columnheader',
    TD: 'cell',
    THead: 'columnheader',
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: 'figure',
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
const $cc81ab43c9eca151$export$4921bbe0701579e4 = /^H(\d+)$/;

});



parcelRegister("2etJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a03f3907794890b$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $G00Vw = parcelRequire("G00Vw");
function $1a03f3907794890b$export$2e2bcd8739ae039() {
    return (0, $bxRTa.useContext)((0, $G00Vw.default));
}

});



parcelRegister("gdYu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcfcc70a52e63370$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $dETBS = parcelRequire("dETBS");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $fP0xm = parcelRequire("fP0xm");

var $2etJo = parcelRequire("2etJo");

var $kBgJ7 = parcelRequire("kBgJ7");

var $aF5fn = parcelRequire("aF5fn");
function $bcfcc70a52e63370$export$2e2bcd8739ae039() {
    const pageContext = (0, $2etJo.default)();
    (0, $ctQXl.default)(pageContext, 'Unable to find Page context.');
    const { _className: _className, onRenderSuccess: onRenderSuccessProps, onRenderError: onRenderErrorProps, page: page, rotate: rotate, scale: scale } = pageContext;
    (0, $ctQXl.default)(page, 'Attempted to render page SVG, but no page was specified.');
    const [svgState, svgDispatch] = (0, $kBgJ7.default)();
    const { value: svg, error: svgError } = svgState;
    /**
     * Called when a page is rendered successfully
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $aF5fn.makePageCallback)(page, scale));
    }
    /**
     * Called when a page fails to render
     */ function onRenderError() {
        if (!svgError) // Impossible, but TypeScript doesn't know that
        return;
        if ((0, $aF5fn.isCancelException)(svgError)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, svgError.toString());
        if (onRenderErrorProps) onRenderErrorProps(svgError);
    }
    const viewport = (0, $bxRTa.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function resetSVG() {
        svgDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    function renderSVG() {
        if (!page) return;
        const cancellable = (0, $dETBS.default)(page.getOperatorList());
        cancellable.promise.then((operatorList)=>{
            const svgGfx = new (0, $fP0xm.default).SVGGraphics(page.commonObjs, page.objs);
            svgGfx.getSVG(operatorList, viewport).then((nextSvg)=>{
                // See https://github.com/mozilla/pdf.js/issues/16745
                if (!(nextSvg instanceof SVGElement)) throw new Error('getSVG returned unexpected result.');
                svgDispatch({
                    type: 'RESOLVE',
                    value: nextSvg
                });
            }).catch((error)=>{
                svgDispatch({
                    type: 'REJECT',
                    error: error
                });
            });
        }).catch((error)=>{
            svgDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $aF5fn.cancelRunningTask)(cancellable);
    }
    (0, $bxRTa.useEffect)(renderSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (svg === undefined) return;
        if (svg === false) {
            onRenderError();
            return;
        }
        onRenderSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        svg
    ]);
    function drawPageOnContainer(element) {
        if (!element || !svg) return;
        // Append SVG element to the main container, if this hasn't been done already
        if (!element.firstElementChild) element.appendChild(svg);
        const { width: width, height: height } = viewport;
        svg.setAttribute('width', `${width}`);
        svg.setAttribute('height', `${height}`);
    }
    const { width: width, height: height } = viewport;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("div", {
        className: `${_className}__svg`,
        // Note: This cannot be shortened, as we need this function to be called with each render.
        ref: (ref)=>drawPageOnContainer(ref),
        style: {
            display: 'block',
            backgroundColor: 'white',
            overflow: 'hidden',
            width: width,
            height: height,
            userSelect: 'none'
        }
    });
}

});

parcelRegister("g5sZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb639b7a339a5d03$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $dETBS = parcelRequire("dETBS");

var $6hsJH = parcelRequire("6hsJH");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $fP0xm = parcelRequire("fP0xm");

var $2etJo = parcelRequire("2etJo");

var $kBgJ7 = parcelRequire("kBgJ7");

var $aF5fn = parcelRequire("aF5fn");
'use client';
function $bb639b7a339a5d03$var$isTextItem(item) {
    return 'str' in item;
}
function $bb639b7a339a5d03$export$2e2bcd8739ae039() {
    const pageContext = (0, $2etJo.default)();
    (0, $ctQXl.default)(pageContext, 'Unable to find Page context.');
    const { customTextRenderer: customTextRenderer, onGetTextError: onGetTextError, onGetTextSuccess: onGetTextSuccess, onRenderTextLayerError: onRenderTextLayerError, onRenderTextLayerSuccess: onRenderTextLayerSuccess, page: page, pageIndex: pageIndex, pageNumber: pageNumber, rotate: rotate, scale: scale } = pageContext;
    (0, $ctQXl.default)(page, 'Attempted to load page text content, but no page was specified.');
    const [textContentState, textContentDispatch] = (0, $kBgJ7.default)();
    const { value: textContent, error: textContentError } = textContentState;
    const layerElement = (0, $bxRTa.useRef)(null);
    const endElement = (0, $bxRTa.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-text-layer'), 10) === 1, 'TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer');
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    function resetTextContent() {
        textContentDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetTextContent, [
        page,
        textContentDispatch
    ]);
    function loadTextContent() {
        if (!page) return;
        const cancellable = (0, $dETBS.default)(page.getTextContent());
        const runningTask = cancellable;
        cancellable.promise.then((nextTextContent)=>{
            textContentDispatch({
                type: 'RESOLVE',
                value: nextTextContent
            });
        }).catch((error)=>{
            textContentDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $aF5fn.cancelRunningTask)(runningTask);
    }
    (0, $bxRTa.useEffect)(loadTextContent, [
        page,
        textContentDispatch
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ const onRenderSuccess = (0, $bxRTa.useCallback)(()=>{
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ const onRenderError = (0, $bxRTa.useCallback)((error)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        const end = endElement.current;
        if (!end) return;
        end.classList.add('active');
    }
    function onMouseUp() {
        const end = endElement.current;
        if (!end) return;
        end.classList.remove('active');
    }
    const viewport = (0, $bxRTa.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function renderTextLayer() {
        if (!page || !textContent) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        layer.innerHTML = '';
        const textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        const parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        const cancellable = (0, $fP0xm.default).renderTextLayer(parameters);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            const end = document.createElement('div');
            end.className = 'endOfContent';
            layer.append(end);
            endElement.current = end;
            const layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                let index = 0;
                textContent.items.forEach((item, itemIndex)=>{
                    if (!$bb639b7a339a5d03$var$isTextItem(item)) return;
                    const child = layerChildren[index];
                    if (!child) return;
                    const content = customTextRenderer(Object.assign({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex
                    }, item));
                    child.innerHTML = content;
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $aF5fn.cancelRunningTask)(runningTask);
    }
    (0, $bxRTa.useLayoutEffect)(renderTextLayer, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("div", {
        className: (0, $6hsJH.default)('react-pdf__Page__textContent', 'textLayer'),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    }));
}

});

parcelRegister("3Svrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2ecd96280a2303$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $dETBS = parcelRequire("dETBS");

var $6hsJH = parcelRequire("6hsJH");

var $ctQXl = parcelRequire("ctQXl");

var $aKmSP = parcelRequire("aKmSP");

var $fP0xm = parcelRequire("fP0xm");

var $e4eH2 = parcelRequire("e4eH2");

var $2etJo = parcelRequire("2etJo");

var $kBgJ7 = parcelRequire("kBgJ7");

var $aF5fn = parcelRequire("aF5fn");
'use client';
function $2d2ecd96280a2303$export$2e2bcd8739ae039() {
    const documentContext = (0, $e4eH2.default)();
    const pageContext = (0, $2etJo.default)();
    (0, $ctQXl.default)(pageContext, 'Unable to find Page context.');
    const mergedProps = Object.assign(Object.assign({}, documentContext), pageContext);
    const { imageResourcesPath: imageResourcesPath, linkService: linkService, onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, page: page, pdf: pdf, renderForms: renderForms, rotate: rotate, scale: scale = 1 } = mergedProps;
    (0, $ctQXl.default)(pdf, 'Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    (0, $ctQXl.default)(page, 'Attempted to load page annotations, but no page was specified.');
    (0, $ctQXl.default)(linkService, 'Attempted to load page annotations, but no linkService was specified.');
    const [annotationsState, annotationsDispatch] = (0, $kBgJ7.default)();
    const { value: annotations, error: annotationsError } = annotationsState;
    const layerElement = (0, $bxRTa.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-annotation-layer'), 10) === 1, 'AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations');
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    function resetAnnotations() {
        annotationsDispatch({
            type: 'RESET'
        });
    }
    (0, $bxRTa.useEffect)(resetAnnotations, [
        annotationsDispatch,
        page
    ]);
    function loadAnnotations() {
        if (!page) return;
        const cancellable = (0, $dETBS.default)(page.getAnnotations());
        const runningTask = cancellable;
        cancellable.promise.then((nextAnnotations)=>{
            annotationsDispatch({
                type: 'RESOLVE',
                value: nextAnnotations
            });
        }).catch((error)=>{
            annotationsDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $aF5fn.cancelRunningTask)(runningTask);
        };
    }
    (0, $bxRTa.useEffect)(loadAnnotations, [
        annotationsDispatch,
        page,
        renderForms
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($aKmSP)))(false, `${error}`);
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    const viewport = (0, $bxRTa.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function renderAnnotationLayer() {
        if (!pdf || !page || !linkService || !annotations) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        const clonedViewport = viewport.clone({
            dontFlip: true
        });
        const annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            div: layer,
            l10n: null,
            page: page,
            viewport: clonedViewport
        };
        const renderParameters = {
            annotations: annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            // See https://github.com/mozilla/pdf.js/issues/17029
            downloadManager: null,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = '';
        try {
            new (0, $fP0xm.default).AnnotationLayer(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return ()=>{
        // TODO: Cancel running task?
        };
    }
    (0, $bxRTa.useEffect)(renderAnnotationLayer, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations,
        imageResourcesPath,
        linkService,
        page,
        renderForms,
        viewport
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("div", {
        className: (0, $6hsJH.default)('react-pdf__Page__annotations', 'annotationLayer'),
        ref: layerElement
    });
}

});
parcelRegister("e4eH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3dcd62587995f8f$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $czL4i = parcelRequire("czL4i");
function $a3dcd62587995f8f$export$2e2bcd8739ae039() {
    return (0, $bxRTa.useContext)((0, $czL4i.default));
}

});




parcelRegister("VZzOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $926afd8270ce2c83$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $lOuaH = parcelRequire("lOuaH");

var $5h4it = parcelRequire("5h4it");

var $gR5Co = parcelRequire("gR5Co");
const $926afd8270ce2c83$var$Background = ({ config: config, videoLoop: videoLoop, videoMuted: videoMuted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const webcamRotation = (0, $9JLpC.useViewStore)((state)=>state.configurations).webcamRotation;
    const imageRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(imageRef);
    const [videoDimensions, setVideoDimensions] = (0, $bxRTa.useState)(dimensions);
    const [webcamStyle, setWebcamStyle] = (0, $bxRTa.useState)({});
    (0, $bxRTa.useEffect)(()=>{
        if (config.style === 'webcam') {
            if (!webcamRotation || webcamRotation % 180 === 0) setVideoDimensions(dimensions);
            else setVideoDimensions({
                height: dimensions.width,
                width: dimensions.height
            });
        }
    }, [
        config.style,
        dimensions
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(webcamRotation){
            case 90:
                setWebcamStyle({
                    width: '100vh',
                    height: '100vw',
                    transform: 'rotate(90deg)'
                });
                break;
            case -90:
                setWebcamStyle({
                    width: '100vh',
                    height: '100vw',
                    transform: 'rotate(-90deg)'
                });
                break;
            case 180:
                setWebcamStyle({
                    transform: 'rotate(180deg)'
                });
                break;
            default:
                setWebcamStyle({});
                break;
        }
    }, [
        webcamRotation
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            config.style === 'image' && config.image && /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                ref: imageRef,
                src: config.image,
                alt: "background image",
                className: "rf-col-span-full rf-row-span-full rf-w-full rf-h-full rf-object-cover rf-filter rf-blur-background"
            }),
            config.style === 'video' && config.video && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5h4it.default), {
                source: config.video,
                loop: !!videoLoop,
                muted: !!videoMuted,
                onVideoEnded: onVideoEnded,
                onVideoCanPlay: onVideoCanPlay
            }),
            config.style === 'webcam' && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gR5Co.default), {
                config: config.webcam,
                size: videoDimensions,
                style: webcamStyle
            })
        ]
    });
};
var $926afd8270ce2c83$export$2e2bcd8739ae039 = $926afd8270ce2c83$var$Background;

});
parcelRegister("lOuaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1b66e17ac36733$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
/**
 * Use javascript ResizeOberver object to catch element's resize and return current size
 * @param {React.RefObject<HTMLElement>} ref element for which we want to get the size when resized
 * @returns {Dimensions} dimension data (width, height)
 */ const $dc1b66e17ac36733$var$useRefDimensions = (ref)=>{
    const [dimensions, setDimensions] = (0, $bxRTa.useState)({
        width: 1,
        height: 1
    });
    const [observer, setObserver] = (0, $bxRTa.useState)();
    const handleResizeObserverTick = (entries)=>{
        entries.length && entries[0].contentBoxSize.length && setDimensions({
            width: entries[0].contentBoxSize[0].inlineSize,
            height: entries[0].contentBoxSize[0].blockSize
        });
    };
    (0, $bxRTa.useLayoutEffect)(()=>{
        if (!observer) {
            const obs = new ResizeObserver(handleResizeObserverTick);
            if (ref?.current) {
                obs.observe(ref.current);
                setObserver(obs);
            }
        }
        return ()=>{
            observer?.disconnect();
        };
    }, []);
    return dimensions;
};
var $dc1b66e17ac36733$export$2e2bcd8739ae039 = $dc1b66e17ac36733$var$useRefDimensions;

});

parcelRegister("5h4it", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4cef58725b0107$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");
const $7c4cef58725b0107$var$BackgroundVideo = ({ source: source, style: style, loop: loop, muted: muted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const currentWidth = (0, $9JLpC.useViewStore)((state)=>state.currentWidth);
    const videoRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.load();
            videoRef.current.play().catch((e)=>console.warn(e));
        }
    }, [
        videoRef
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("video", {
        ref: videoRef,
        id: "retorik-background-video",
        className: "rf-relative rf-col-span-full rf-row-span-full rf-object-cover rf-overflow-hidden rf-filter rf-blur-background",
        onEnded: onVideoEnded,
        onError: onVideoEnded,
        onCanPlay: onVideoCanPlay,
        autoPlay: true,
        loop: loop,
        muted: muted,
        playsInline: true,
        style: {
            ...style,
            height: currentHeight,
            width: currentWidth
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("source", {
            src: source
        })
    });
};
var $7c4cef58725b0107$export$2e2bcd8739ae039 = $7c4cef58725b0107$var$BackgroundVideo;

});

parcelRegister("gR5Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f7f67914ca455d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $43f7f67914ca455d$var$BackgroundWebcam = ({ config: config, size: size, style: style })=>{
    const videoRef = (0, $bxRTa.useRef)(null);
    const setSource = (constraints)=>{
        navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
            if (videoRef.current) videoRef.current.srcObject = stream;
        }).catch((error)=>console.warn('Retorik Framework > an error occured when trying to use the webcam : ', error));
    };
    (0, $bxRTa.useEffect)(()=>{
        setSource({
            video: {
                facingMode: config === 'back' ? {
                    exact: 'environment'
                } : config === 'front' ? 'user' : undefined,
                deviceId: [
                    'back',
                    'front',
                    undefined
                ].includes(config) ? undefined : config,
                ...size
            }
        });
    }, [
        config,
        size
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("video", {
        ref: videoRef,
        id: "retorik-background-webcam",
        className: "rf-relative rf-col-span-full rf-row-span-full rf-overflow-hidden rf-max-w-none rf-w-screen rf-h-screen rf-filter rf-blur-background rf-border rf-self-center rf-justify-self-center rf-object-cover rf-origin-center",
        style: {
            ...style
        },
        autoPlay: true,
        muted: true,
        playsInline: true
    });
};
var $43f7f67914ca455d$export$2e2bcd8739ae039 = $43f7f67914ca455d$var$BackgroundWebcam;

});


parcelRegister("5bTjo", function(module, exports) {
$parcel$export(module.exports, "easings", () => (parcelRequire("2aMjv")).easings);
$parcel$export(module.exports, "Globals", () => (parcelRequire("2aMjv")).Globals);
$parcel$export(module.exports, "useSpring", () => (parcelRequire("hzlaD")).useSpring);

$parcel$export(module.exports, "animated", () => $5731f2f135da08c2$export$407448d2b89b1813);
// src/index.ts
parcelRequire("hzlaD");
var $2aMjv = parcelRequire("2aMjv");

var $aRBoq = parcelRequire("aRBoq");

var $2aMjv = parcelRequire("2aMjv");

var $b1Sgt = parcelRequire("b1Sgt");
// src/applyAnimatedValues.ts
var $5731f2f135da08c2$var$isCustomPropRE = /^--/;
function $5731f2f135da08c2$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$5731f2f135da08c2$var$isCustomPropRE.test(name) && !($5731f2f135da08c2$var$isUnitlessNumber.hasOwnProperty(name) && $5731f2f135da08c2$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $5731f2f135da08c2$var$attributeCache = {};
function $5731f2f135da08c2$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $5731f2f135da08c2$var$attributeCache[name] || ($5731f2f135da08c2$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $5731f2f135da08c2$var$dangerousStyleValue(name, style[name]);
        if ($5731f2f135da08c2$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $5731f2f135da08c2$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $5731f2f135da08c2$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $5731f2f135da08c2$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$5731f2f135da08c2$var$isUnitlessNumber = Object.keys($5731f2f135da08c2$var$isUnitlessNumber).reduce((acc, prop)=>{
    $5731f2f135da08c2$var$prefixes.forEach((prefix)=>acc[$5731f2f135da08c2$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $5731f2f135da08c2$var$isUnitlessNumber);
var $5731f2f135da08c2$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $5731f2f135da08c2$var$pxTransforms = /^(translate)/;
var $5731f2f135da08c2$var$degTransforms = /^(rotate|skew)/;
var $5731f2f135da08c2$var$addUnit = (value, unit)=>(0, $2aMjv.is).num(value) && value !== 0 ? value + unit : value;
var $5731f2f135da08c2$var$isValueIdentity = (value, id)=>(0, $2aMjv.is).arr(value) ? value.every((v)=>$5731f2f135da08c2$var$isValueIdentity(v, id)) : (0, $2aMjv.is).num(value) ? value === id : parseFloat(value) === id;
var $5731f2f135da08c2$var$AnimatedStyle = class extends (0, $b1Sgt.AnimatedObject) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$5731f2f135da08c2$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $5731f2f135da08c2$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $2aMjv.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($5731f2f135da08c2$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $2aMjv.is).und(value)) return;
                const unit = $5731f2f135da08c2$var$pxTransforms.test(key) ? "px" : $5731f2f135da08c2$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $2aMjv.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$5731f2f135da08c2$var$addUnit(deg, unit)})`,
                        $5731f2f135da08c2$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$5731f2f135da08c2$var$addUnit(v, unit)).join(",")})`,
                        $5731f2f135da08c2$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $5731f2f135da08c2$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $5731f2f135da08c2$var$FluidTransform = class extends (0, $2aMjv.FluidValue) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $2aMjv.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $2aMjv.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $2aMjv.is).arr(arg1) ? arg1 : input.map((0, $2aMjv.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $2aMjv.each)(this.inputs, (input)=>(0, $2aMjv.each)(input, (value)=>(0, $2aMjv.hasFluidValue)(value) && (0, $2aMjv.addFluidObserver)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $2aMjv.each)(this.inputs, (input)=>(0, $2aMjv.each)(input, (value)=>(0, $2aMjv.hasFluidValue)(value) && (0, $2aMjv.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $2aMjv.callFluidObservers)(this, event);
    }
};
// src/primitives.ts
var $5731f2f135da08c2$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $2aMjv.Globals).assign({
    batchedUpdates: (0, $aRBoq.unstable_batchedUpdates),
    createStringInterpolator: $2aMjv.createStringInterpolator,
    colors: $2aMjv.colors
});
var $5731f2f135da08c2$var$host = (0, $b1Sgt.createHost)($5731f2f135da08c2$var$primitives, {
    applyAnimatedValues: $5731f2f135da08c2$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $5731f2f135da08c2$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $5731f2f135da08c2$export$407448d2b89b1813 = $5731f2f135da08c2$var$host.animated;

});
parcelRegister("hzlaD", function(module, exports) {

$parcel$export(module.exports, "useSpring", () => $8197315a05dcadae$export$c4af9125706c4d30);
$parcel$export(module.exports, "Globals", () => (parcelRequire("2aMjv")).Globals);
$parcel$export(module.exports, "easings", () => (parcelRequire("2aMjv")).easings);
// src/hooks/useChain.ts

var $2aMjv = parcelRequire("2aMjv");
var $gtRA1 = parcelRequire("gtRA1");

var $bxRTa = parcelRequire("bxRTa");

var $b1Sgt = parcelRequire("b1Sgt");
parcelRequire("5od7d");
function $8197315a05dcadae$var$callProp(value, ...args) {
    return (0, $2aMjv.is).fun(value) ? value(...args) : value;
}
var $8197315a05dcadae$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $2aMjv.is).fun(value) ? value(key) : (0, $2aMjv.toArray)(value).includes(key)));
var $8197315a05dcadae$var$resolveProp = (prop, key)=>(0, $2aMjv.is).obj(prop) ? key && prop[key] : prop;
var $8197315a05dcadae$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $8197315a05dcadae$var$noopTransform = (value)=>value;
var $8197315a05dcadae$var$getDefaultProps = (props, transform = $8197315a05dcadae$var$noopTransform)=>{
    let keys = $8197315a05dcadae$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $2aMjv.is).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $8197315a05dcadae$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $8197315a05dcadae$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $8197315a05dcadae$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $2aMjv.eachProp)(props, (value, prop)=>{
        if (!$8197315a05dcadae$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $8197315a05dcadae$export$b971039a739bf227(props) {
    const to2 = $8197315a05dcadae$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $2aMjv.eachProp)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $8197315a05dcadae$var$computeGoal(value) {
    value = (0, $2aMjv.getFluidValue)(value);
    return (0, $2aMjv.is).arr(value) ? value.map($8197315a05dcadae$var$computeGoal) : (0, $2aMjv.isAnimatedString)(value) ? (0, $2aMjv.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $8197315a05dcadae$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $8197315a05dcadae$var$isAsyncTo(to2) {
    return (0, $2aMjv.is).fun(to2) || (0, $2aMjv.is).arr(to2) && (0, $2aMjv.is).obj(to2[0]);
}
function $8197315a05dcadae$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $8197315a05dcadae$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $8197315a05dcadae$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $2aMjv.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $2aMjv.each)(controllers, (ctrl)=>{
                        (0, $2aMjv.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $8197315a05dcadae$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $2aMjv.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $2aMjv.each)(controllers, (ctrl, i)=>(0, $2aMjv.each)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $8197315a05dcadae$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $8197315a05dcadae$var$defaults = {
    ...$8197315a05dcadae$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $2aMjv.easings).linear,
    clamp: false
};
var $8197315a05dcadae$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $8197315a05dcadae$var$defaults);
    }
};
function $8197315a05dcadae$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $8197315a05dcadae$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $8197315a05dcadae$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $8197315a05dcadae$var$defaults)if (config2[key] == null) config2[key] = $8197315a05dcadae$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $2aMjv.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $8197315a05dcadae$var$sanitizeConfig(config2, props) {
    if (!(0, $2aMjv.is).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $2aMjv.is).und(props.tension) || !(0, $2aMjv.is).und(props.friction);
        if (isTensionConfig || !(0, $2aMjv.is).und(props.frequency) || !(0, $2aMjv.is).und(props.damping) || !(0, $2aMjv.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $8197315a05dcadae$var$emptyArray = [];
var $8197315a05dcadae$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $8197315a05dcadae$var$emptyArray;
        this.toValues = null;
        this.fromValues = $8197315a05dcadae$var$emptyArray;
        this.config = new $8197315a05dcadae$var$AnimationConfig();
        this.immediate = false;
    }
};
function $8197315a05dcadae$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $8197315a05dcadae$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $2aMjv.is).und(props.pause)) state.paused = $8197315a05dcadae$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $8197315a05dcadae$var$matchProp(pause, key);
            delay = $8197315a05dcadae$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $gtRA1.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $2aMjv.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, $gtRA1.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $8197315a05dcadae$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $8197315a05dcadae$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $8197315a05dcadae$var$getNoopResult(target.get()) : $8197315a05dcadae$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $8197315a05dcadae$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $8197315a05dcadae$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $8197315a05dcadae$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $8197315a05dcadae$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $8197315a05dcadae$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $8197315a05dcadae$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $8197315a05dcadae$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $8197315a05dcadae$export$d362d093fa99dc7();
            const skipAnimationSignal = new $8197315a05dcadae$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $2aMjv.Globals).skipAnimation) {
                    $8197315a05dcadae$var$stopAsync(state);
                    skipAnimationSignal.result = $8197315a05dcadae$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $2aMjv.is).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $2aMjv.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $2aMjv.is).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $2aMjv.Globals).skipAnimation) {
            $8197315a05dcadae$var$stopAsync(state);
            return $8197315a05dcadae$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $2aMjv.is).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $8197315a05dcadae$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $8197315a05dcadae$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $8197315a05dcadae$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $2aMjv.is).fun(onRest)) (0, $gtRA1.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $8197315a05dcadae$var$stopAsync(state, cancelId) {
    (0, $2aMjv.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $8197315a05dcadae$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $8197315a05dcadae$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $8197315a05dcadae$var$isFrameValue = (value)=>value instanceof $8197315a05dcadae$export$8229896f80e2495e;
var $8197315a05dcadae$var$nextId = 1;
var $8197315a05dcadae$export$8229896f80e2495e = class extends (0, $2aMjv.FluidValue) {
    constructor(){
        super(...arguments);
        this.id = $8197315a05dcadae$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $b1Sgt.getAnimated)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $2aMjv.Globals).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $2aMjv.deprecateInterpolate)();
        return (0, $2aMjv.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $2aMjv.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $2aMjv.frameLoop).sort(this);
        (0, $2aMjv.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $8197315a05dcadae$var$$P = Symbol.for("SpringPhase");
var $8197315a05dcadae$var$HAS_ANIMATED = 1;
var $8197315a05dcadae$var$IS_ANIMATING = 2;
var $8197315a05dcadae$var$IS_PAUSED = 4;
var $8197315a05dcadae$var$hasAnimated = (target)=>(target[$8197315a05dcadae$var$$P] & $8197315a05dcadae$var$HAS_ANIMATED) > 0;
var $8197315a05dcadae$var$isAnimating = (target)=>(target[$8197315a05dcadae$var$$P] & $8197315a05dcadae$var$IS_ANIMATING) > 0;
var $8197315a05dcadae$var$isPaused = (target)=>(target[$8197315a05dcadae$var$$P] & $8197315a05dcadae$var$IS_PAUSED) > 0;
var $8197315a05dcadae$var$setActiveBit = (target, active)=>active ? target[$8197315a05dcadae$var$$P] |= $8197315a05dcadae$var$IS_ANIMATING | $8197315a05dcadae$var$HAS_ANIMATED : target[$8197315a05dcadae$var$$P] &= ~$8197315a05dcadae$var$IS_ANIMATING;
var $8197315a05dcadae$var$setPausedBit = (target, paused)=>paused ? target[$8197315a05dcadae$var$$P] |= $8197315a05dcadae$var$IS_PAUSED : target[$8197315a05dcadae$var$$P] &= ~$8197315a05dcadae$var$IS_PAUSED;
// src/SpringValue.ts
var $8197315a05dcadae$export$5854d13427d5a954 = class extends $8197315a05dcadae$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $8197315a05dcadae$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $2aMjv.is).und(arg1) || !(0, $2aMjv.is).und(arg2)) {
            const props = (0, $2aMjv.is).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $2aMjv.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($8197315a05dcadae$var$isAnimating(this) || this._state.asyncTo) || $8197315a05dcadae$var$isPaused(this);
    }
    get goal() {
        return (0, $2aMjv.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $b1Sgt.getAnimated)(this);
        return node instanceof (0, $b1Sgt.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $8197315a05dcadae$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $8197315a05dcadae$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $8197315a05dcadae$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $b1Sgt.getPayload)(anim.to);
        if (!payload && (0, $2aMjv.hasFluidValue)(anim.to)) toValues = (0, $2aMjv.toArray)((0, $2aMjv.getFluidValue)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $b1Sgt.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $2aMjv.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $2aMjv.is).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $2aMjv.is).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $b1Sgt.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $2aMjv.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $gtRA1.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($8197315a05dcadae$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $gtRA1.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $2aMjv.is).und(to2)) queue = [
            (0, $2aMjv.is).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$8197315a05dcadae$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $8197315a05dcadae$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $gtRA1.raf).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $2aMjv.is).obj(to2) ? to2[key] : to2;
        if (to2 == null || $8197315a05dcadae$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $2aMjv.is).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$8197315a05dcadae$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $2aMjv.getFluidValue)(from);
            if (!(0, $2aMjv.is).und(from)) this._set(from);
            else if (!(0, $b1Sgt.getAnimated)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $8197315a05dcadae$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $8197315a05dcadae$var$resolveProp(value, key) : value));
        $8197315a05dcadae$var$mergeActiveFn(this, props, "onProps");
        $8197315a05dcadae$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $8197315a05dcadae$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$8197315a05dcadae$var$isPaused(this)) {
                        $8197315a05dcadae$var$setPausedBit(this, true);
                        (0, $2aMjv.flushCalls)(state.pauseQueue);
                        $8197315a05dcadae$var$sendEvent(this, "onPause", $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($8197315a05dcadae$var$isPaused(this)) {
                        $8197315a05dcadae$var$setPausedBit(this, false);
                        if ($8197315a05dcadae$var$isAnimating(this)) this._resume();
                        (0, $2aMjv.flushCalls)(state.resumeQueue);
                        $8197315a05dcadae$var$sendEvent(this, "onResume", $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $8197315a05dcadae$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($8197315a05dcadae$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $2aMjv.is).und(range.to);
        const hasFromProp = !(0, $2aMjv.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($8197315a05dcadae$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $2aMjv.is).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $2aMjv.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $2aMjv.getFluidValue)(from);
        const hasToChanged = !(0, $2aMjv.isEqual)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $8197315a05dcadae$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $8197315a05dcadae$var$mergeConfig(config2, $8197315a05dcadae$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $8197315a05dcadae$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $b1Sgt.getAnimated)(this);
        if (!node || (0, $2aMjv.is).und(to2)) return resolve($8197315a05dcadae$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $2aMjv.is).und(props.reset) ? hasFromProp && !props.default : !(0, $2aMjv.is).und(from) && $8197315a05dcadae$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $8197315a05dcadae$var$computeGoal(to2);
        const isAnimatable = (0, $2aMjv.is).num(goal) || (0, $2aMjv.is).arr(goal) || (0, $2aMjv.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $8197315a05dcadae$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $b1Sgt.getAnimatedType)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $2aMjv.hasFluidValue)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$8197315a05dcadae$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $2aMjv.isEqual)($8197315a05dcadae$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $2aMjv.isEqual)(anim.immediate, immediate) && !immediate || !(0, $2aMjv.isEqual)(config2.decay, decay) || !(0, $2aMjv.isEqual)(config2.velocity, velocity)) started = true;
        }
        if (finished && $8197315a05dcadae$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $2aMjv.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $2aMjv.hasFluidValue)(to2) ? null : goalType == (0, $b1Sgt.AnimatedString) ? [
                    1
                ] : (0, $2aMjv.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $2aMjv.each)($8197315a05dcadae$var$ACTIVE_EVENTS, (type)=>$8197315a05dcadae$var$mergeActiveFn(this, props, type));
                const result = $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, prevTo));
                (0, $2aMjv.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $gtRA1.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $8197315a05dcadae$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($8197315a05dcadae$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($8197315a05dcadae$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($8197315a05dcadae$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $2aMjv.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $2aMjv.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $2aMjv.hasFluidValue)(to2)) {
            (0, $2aMjv.addFluidObserver)(to2, this);
            if ($8197315a05dcadae$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $2aMjv.hasFluidValue)(to2)) (0, $2aMjv.removeFluidObserver)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $2aMjv.getFluidValue)(arg);
        if (!(0, $2aMjv.is).und(value)) {
            const oldNode = (0, $b1Sgt.getAnimated)(this);
            if (!oldNode || !(0, $2aMjv.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $b1Sgt.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $b1Sgt.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $gtRA1.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $b1Sgt.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $8197315a05dcadae$var$sendEvent(this, "onStart", $8197315a05dcadae$var$getFinishedResult(this, $8197315a05dcadae$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $8197315a05dcadae$var$callProp(this.animation.onChange, value, this);
        }
        $8197315a05dcadae$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $b1Sgt.getAnimated)(this).reset((0, $2aMjv.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$8197315a05dcadae$var$isAnimating(this)) {
            $8197315a05dcadae$var$setActiveBit(this, true);
            if (!$8197315a05dcadae$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $2aMjv.Globals).skipAnimation) this.finish();
        else (0, $2aMjv.frameLoop).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($8197315a05dcadae$var$isAnimating(this)) {
            $8197315a05dcadae$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $2aMjv.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $2aMjv.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $8197315a05dcadae$var$getCancelledResult(this.get()) : $8197315a05dcadae$var$getFinishedResult(this.get(), $8197315a05dcadae$var$checkFinished(this, goal ?? anim.to));
            (0, $2aMjv.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $8197315a05dcadae$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $8197315a05dcadae$var$checkFinished(target, to2) {
    const goal = $8197315a05dcadae$var$computeGoal(to2);
    const value = $8197315a05dcadae$var$computeGoal(target.get());
    return (0, $2aMjv.isEqual)(value, goal);
}
function $8197315a05dcadae$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $8197315a05dcadae$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $8197315a05dcadae$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $8197315a05dcadae$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $8197315a05dcadae$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $8197315a05dcadae$var$createUpdate(props) {
    const { to: to2, from: from } = props = $8197315a05dcadae$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $2aMjv.is).obj(to2)) $8197315a05dcadae$var$findDefined(to2, keys);
    if ((0, $2aMjv.is).obj(from)) $8197315a05dcadae$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $8197315a05dcadae$var$declareUpdate(props) {
    const update2 = $8197315a05dcadae$var$createUpdate(props);
    if ((0, $2aMjv.is).und(update2.default)) update2.default = $8197315a05dcadae$var$getDefaultProps(update2);
    return update2;
}
function $8197315a05dcadae$var$findDefined(values, keys) {
    (0, $2aMjv.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
var $8197315a05dcadae$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $8197315a05dcadae$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $8197315a05dcadae$var$getDefaultProp(props, type) ? $8197315a05dcadae$var$resolveProp(props[type], target.key) : void 0;
}
function $8197315a05dcadae$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $8197315a05dcadae$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $8197315a05dcadae$var$nextId2 = 1;
var $8197315a05dcadae$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $8197315a05dcadae$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $2aMjv.is).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($8197315a05dcadae$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $2aMjv.toArray)(props).map($8197315a05dcadae$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $8197315a05dcadae$var$prepareKeys(this, queue);
        return $8197315a05dcadae$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $2aMjv.each)((0, $2aMjv.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $8197315a05dcadae$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $2aMjv.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $2aMjv.each)((0, $2aMjv.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $2aMjv.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $2aMjv.each)((0, $2aMjv.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $2aMjv.eachProp)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $2aMjv.flush)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $2aMjv.flush)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $2aMjv.flush)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $gtRA1.raf).onFrame(this._onFrame);
    }
};
function $8197315a05dcadae$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$8197315a05dcadae$var$flushUpdate(ctrl, props))).then((results)=>$8197315a05dcadae$var$getCombinedResult(ctrl, results));
}
async function $8197315a05dcadae$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $2aMjv.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $2aMjv.is).arr(to2) || (0, $2aMjv.is).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $2aMjv.each)($8197315a05dcadae$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $2aMjv.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $2aMjv.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $8197315a05dcadae$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($8197315a05dcadae$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $2aMjv.noop),
            resume: (0, $2aMjv.noop),
            start (props2, resolve) {
                if (cancel) {
                    $8197315a05dcadae$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($8197315a05dcadae$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($8197315a05dcadae$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $8197315a05dcadae$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $8197315a05dcadae$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $8197315a05dcadae$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $8197315a05dcadae$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $gtRA1.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $8197315a05dcadae$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $2aMjv.each)((0, $2aMjv.toArray)(props), (props2)=>{
        if ((0, $2aMjv.is).und(props2.keys)) props2 = $8197315a05dcadae$var$createUpdate(props2);
        if (!(0, $2aMjv.is).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $8197315a05dcadae$var$prepareSprings(springs, props2, (key)=>{
            return $8197315a05dcadae$var$createSpring(key);
        });
    });
    $8197315a05dcadae$var$setSprings(ctrl, springs);
    return springs;
}
function $8197315a05dcadae$var$setSprings(ctrl, springs) {
    (0, $2aMjv.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $2aMjv.addFluidObserver)(spring, ctrl);
        }
    });
}
function $8197315a05dcadae$var$createSpring(key, observer) {
    const spring = new $8197315a05dcadae$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $2aMjv.addFluidObserver)(spring, observer);
    return spring;
}
function $8197315a05dcadae$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $2aMjv.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $8197315a05dcadae$var$prepareKeys(ctrl, queue) {
    (0, $2aMjv.each)(queue, (props)=>{
        $8197315a05dcadae$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $8197315a05dcadae$var$createSpring(key, ctrl);
        });
    });
}
var $8197315a05dcadae$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $bxRTa.useContext)($8197315a05dcadae$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $2aMjv.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $8197315a05dcadae$var$ctx;
    return /* @__PURE__ */ $bxRTa.createElement(Provider, {
        value: props
    }, children);
};
var $8197315a05dcadae$var$ctx = $8197315a05dcadae$var$makeContext($8197315a05dcadae$export$f12a216ec50d2cf1, {});
$8197315a05dcadae$export$f12a216ec50d2cf1.Provider = $8197315a05dcadae$var$ctx.Provider;
$8197315a05dcadae$export$f12a216ec50d2cf1.Consumer = $8197315a05dcadae$var$ctx.Consumer;
function $8197315a05dcadae$var$makeContext(target, init) {
    Object.assign(target, $bxRTa.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $8197315a05dcadae$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $2aMjv.deprecateDirectCall)();
        const results = [];
        (0, $2aMjv.each)(current, (ctrl, i)=>{
            if ((0, $2aMjv.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $2aMjv.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $2aMjv.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $2aMjv.each)(current, (ctrl, i)=>{
            const update2 = (0, $2aMjv.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $2aMjv.each)(current, (ctrl, i)=>{
            if ((0, $2aMjv.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $2aMjv.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $2aMjv.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $2aMjv.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $8197315a05dcadae$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $2aMjv.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $bxRTa.useMemo)(()=>propsFn || arguments.length == 3 ? $8197315a05dcadae$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $bxRTa.useRef)(0);
    const forceUpdate = (0, $2aMjv.useForceUpdate)();
    const state = (0, $bxRTa.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $8197315a05dcadae$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $8197315a05dcadae$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $8197315a05dcadae$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($8197315a05dcadae$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $bxRTa.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $2aMjv.usePrev)(length) || 0;
    (0, $bxRTa.useMemo)(()=>{
        (0, $2aMjv.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $8197315a05dcadae$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $bxRTa.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $8197315a05dcadae$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $8197315a05dcadae$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$8197315a05dcadae$var$getSprings(ctrl, updates[i]));
    const context = (0, $bxRTa.useContext)($8197315a05dcadae$export$f12a216ec50d2cf1);
    const prevContext = (0, $2aMjv.usePrev)(context);
    const hasContext = context !== prevContext && $8197315a05dcadae$var$hasProps(context);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $2aMjv.each)(queue, (cb)=>cb());
        }
        (0, $2aMjv.each)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $8197315a05dcadae$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $2aMjv.useOnce)(()=>()=>{
            (0, $2aMjv.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $8197315a05dcadae$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $2aMjv.is).fun(props);
    const [[values], ref] = $8197315a05dcadae$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $8197315a05dcadae$var$initSpringRef = ()=>$8197315a05dcadae$export$2471ae76e2946684();
var $8197315a05dcadae$export$564bff9c23cad2ca = ()=>(0, $bxRTa.useState)($8197315a05dcadae$var$initSpringRef)[0];
var $8197315a05dcadae$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $2aMjv.useConstant)(()=>new $8197315a05dcadae$export$5854d13427d5a954(initial, props));
    (0, $2aMjv.useOnce)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $8197315a05dcadae$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $2aMjv.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $8197315a05dcadae$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        (0, $2aMjv.each)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $8197315a05dcadae$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $2aMjv.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $8197315a05dcadae$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $2aMjv.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $bxRTa.useMemo)(()=>propsFn || arguments.length == 3 ? $8197315a05dcadae$export$2471ae76e2946684() : void 0, []);
    const items = (0, $2aMjv.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $bxRTa.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $2aMjv.useOnce)(()=>{
        (0, $2aMjv.each)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $2aMjv.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $8197315a05dcadae$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $8197315a05dcadae$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>(0, $2aMjv.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $8197315a05dcadae$var$detachRefs(ctrl, ref);
            $8197315a05dcadae$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $2aMjv.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $2aMjv.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $8197315a05dcadae$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $2aMjv.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $2aMjv.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $2aMjv.useForceUpdate)();
    const defaultProps = $8197315a05dcadae$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $bxRTa.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $bxRTa.useRef)(false);
    (0, $2aMjv.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $8197315a05dcadae$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $8197315a05dcadae$var$callProp(to2, t.item, i);
        to2 = (0, $2aMjv.is).obj(to2) ? $8197315a05dcadae$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $8197315a05dcadae$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $2aMjv.is).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $2aMjv.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $8197315a05dcadae$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $8197315a05dcadae$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $8197315a05dcadae$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $8197315a05dcadae$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $bxRTa.useContext)($8197315a05dcadae$export$f12a216ec50d2cf1);
    const prevContext = (0, $2aMjv.usePrev)(context);
    const hasContext = context !== prevContext && $8197315a05dcadae$var$hasProps(context);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        if (hasContext) (0, $2aMjv.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $2aMjv.each)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        (0, $2aMjv.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $8197315a05dcadae$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $bxRTa.createElement($bxRTa.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $bxRTa.createElement(elem.type, {
                ...elem.props,
                key: (0, $2aMjv.is).str(t.key) || (0, $2aMjv.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $8197315a05dcadae$var$nextKey = 1;
function $8197315a05dcadae$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $8197315a05dcadae$var$nextKey++;
        });
    }
    return (0, $2aMjv.is).und(keys) ? items : (0, $2aMjv.is).fun(keys) ? items.map(keys) : (0, $2aMjv.toArray)(keys);
}
var $8197315a05dcadae$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $8197315a05dcadae$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $2aMjv.onScroll)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $2aMjv.each)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $8197315a05dcadae$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $8197315a05dcadae$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $2aMjv.onResize)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $2aMjv.each)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $8197315a05dcadae$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $8197315a05dcadae$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $bxRTa.useState)(false);
    const ref = (0, $bxRTa.useRef)();
    const propsFn = (0, $2aMjv.is).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $8197315a05dcadae$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $2aMjv.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $8197315a05dcadae$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $8197315a05dcadae$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($8197315a05dcadae$export$c4af9125706c4d30(props));
}
function $8197315a05dcadae$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $8197315a05dcadae$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $2aMjv.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $8197315a05dcadae$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $8197315a05dcadae$export$7b286972b8d8ccbf(items, props)(children);
}
var $8197315a05dcadae$export$b0cc4f9860136880 = class extends $8197315a05dcadae$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $2aMjv.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $b1Sgt.getAnimatedType)(value);
        (0, $b1Sgt.setAnimated)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $2aMjv.isEqual)(value, oldValue)) {
            (0, $b1Sgt.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $8197315a05dcadae$var$checkIdle(this._active)) $8197315a05dcadae$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $2aMjv.is).arr(this.source) ? this.source.map((0, $2aMjv.getFluidValue)) : (0, $2aMjv.toArray)((0, $2aMjv.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$8197315a05dcadae$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $2aMjv.each)((0, $b1Sgt.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $2aMjv.Globals).skipAnimation) {
                (0, $gtRA1.raf).batchedUpdates(()=>this.advance());
                $8197315a05dcadae$var$becomeIdle(this);
            } else (0, $2aMjv.frameLoop).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $2aMjv.each)((0, $2aMjv.toArray)(this.source), (source)=>{
            if ((0, $2aMjv.hasFluidValue)(source)) (0, $2aMjv.addFluidObserver)(source, this);
            if ($8197315a05dcadae$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $2aMjv.each)((0, $2aMjv.toArray)(this.source), (source)=>{
            if ((0, $2aMjv.hasFluidValue)(source)) (0, $2aMjv.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $8197315a05dcadae$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $2aMjv.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($8197315a05dcadae$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $8197315a05dcadae$var$isIdle(source) {
    return source.idle !== false;
}
function $8197315a05dcadae$var$checkIdle(active) {
    return !active.size || Array.from(active).every($8197315a05dcadae$var$isIdle);
}
function $8197315a05dcadae$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $2aMjv.each)((0, $b1Sgt.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $2aMjv.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $8197315a05dcadae$export$2c618a4308a30424 = (source, ...args)=>new $8197315a05dcadae$export$b0cc4f9860136880(source, args);
var $8197315a05dcadae$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $2aMjv.deprecateInterpolate)(), new $8197315a05dcadae$export$b0cc4f9860136880(source, args));
(0, $2aMjv.Globals).assign({
    createStringInterpolator: $2aMjv.createStringInterpolator,
    to: (source, args)=>new $8197315a05dcadae$export$b0cc4f9860136880(source, args)
});
var $8197315a05dcadae$export$722fbec263ad908a = (0, $2aMjv.frameLoop).advance;

});
parcelRegister("2aMjv", function(module, exports) {

$parcel$export(module.exports, "Globals", () => $05bd5b66d02a1a3f$export$cceeabf822b64fc0);
$parcel$export(module.exports, "noop", () => $05bd5b66d02a1a3f$export$8793edee2d425525);
$parcel$export(module.exports, "defineHidden", () => $05bd5b66d02a1a3f$export$5c74248ea0e35446);
$parcel$export(module.exports, "is", () => $05bd5b66d02a1a3f$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isEqual", () => $05bd5b66d02a1a3f$export$248d38f6296296c5);
$parcel$export(module.exports, "each", () => $05bd5b66d02a1a3f$export$79b2f7037acddd43);
$parcel$export(module.exports, "eachProp", () => $05bd5b66d02a1a3f$export$f4c6fe153f5a944e);
$parcel$export(module.exports, "toArray", () => $05bd5b66d02a1a3f$export$45b10814cc054894);
$parcel$export(module.exports, "flush", () => $05bd5b66d02a1a3f$export$4909b86c8034bf73);
$parcel$export(module.exports, "flushCalls", () => $05bd5b66d02a1a3f$export$7ba486852759e806);
$parcel$export(module.exports, "frameLoop", () => $05bd5b66d02a1a3f$export$a57f5080a3bcc90a);
$parcel$export(module.exports, "colors", () => $05bd5b66d02a1a3f$export$8f45430ccf837300);
$parcel$export(module.exports, "createInterpolator", () => $05bd5b66d02a1a3f$export$b12af43b97697ef5);
$parcel$export(module.exports, "easings", () => $05bd5b66d02a1a3f$export$15a0bf1b4bbacad8);
$parcel$export(module.exports, "hasFluidValue", () => $05bd5b66d02a1a3f$export$57ea7e3a7f6280c7);
$parcel$export(module.exports, "getFluidValue", () => $05bd5b66d02a1a3f$export$e37b7520edd66839);
$parcel$export(module.exports, "getFluidObservers", () => $05bd5b66d02a1a3f$export$133f54e9f7cf1796);
$parcel$export(module.exports, "callFluidObservers", () => $05bd5b66d02a1a3f$export$31752c40a5fab62a);
$parcel$export(module.exports, "FluidValue", () => $05bd5b66d02a1a3f$export$aff8e1ac1a016a2);
$parcel$export(module.exports, "addFluidObserver", () => $05bd5b66d02a1a3f$export$72d604e3f8d000a5);
$parcel$export(module.exports, "removeFluidObserver", () => $05bd5b66d02a1a3f$export$7a0eb830d336339b);
$parcel$export(module.exports, "createStringInterpolator", () => $05bd5b66d02a1a3f$export$4759a013d387347a);
$parcel$export(module.exports, "deprecateInterpolate", () => $05bd5b66d02a1a3f$export$2abfcde8ae218ba8);
$parcel$export(module.exports, "deprecateDirectCall", () => $05bd5b66d02a1a3f$export$d99d974913ad3b12);
$parcel$export(module.exports, "isAnimatedString", () => $05bd5b66d02a1a3f$export$75bed621f62abfa9);
$parcel$export(module.exports, "onResize", () => $05bd5b66d02a1a3f$export$45b39e67d4ce4921);
$parcel$export(module.exports, "onScroll", () => $05bd5b66d02a1a3f$export$d4d89fd61e5416ee);
$parcel$export(module.exports, "useConstant", () => $05bd5b66d02a1a3f$export$fe4300aa8eebea86);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $05bd5b66d02a1a3f$export$700979bc83e7db82);
$parcel$export(module.exports, "useForceUpdate", () => $05bd5b66d02a1a3f$export$91db9bc4f8ac944a);
$parcel$export(module.exports, "useMemoOne", () => $05bd5b66d02a1a3f$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useOnce", () => $05bd5b66d02a1a3f$export$392544347a18b6ea);
$parcel$export(module.exports, "usePrev", () => $05bd5b66d02a1a3f$export$ef7ad0c4e19d7fbf);
$parcel$export(module.exports, "raf", () => (parcelRequire("gtRA1")).raf);

var $gtRA1 = parcelRequire("gtRA1");

var $bxRTa = parcelRequire("bxRTa");
var $05bd5b66d02a1a3f$var$__defProp = Object.defineProperty;
var $05bd5b66d02a1a3f$var$__export = (target, all)=>{
    for(var name in all)$05bd5b66d02a1a3f$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $05bd5b66d02a1a3f$export$cceeabf822b64fc0 = {};
$05bd5b66d02a1a3f$var$__export($05bd5b66d02a1a3f$export$cceeabf822b64fc0, {
    assign: ()=>$05bd5b66d02a1a3f$var$assign,
    colors: ()=>$05bd5b66d02a1a3f$var$colors,
    createStringInterpolator: ()=>$05bd5b66d02a1a3f$var$createStringInterpolator,
    skipAnimation: ()=>$05bd5b66d02a1a3f$var$skipAnimation,
    to: ()=>$05bd5b66d02a1a3f$var$to,
    willAdvance: ()=>$05bd5b66d02a1a3f$var$willAdvance
});
// src/helpers.ts
function $05bd5b66d02a1a3f$export$8793edee2d425525() {}
var $05bd5b66d02a1a3f$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $05bd5b66d02a1a3f$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $05bd5b66d02a1a3f$export$248d38f6296296c5(a, b) {
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(a)) {
        if (!$05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $05bd5b66d02a1a3f$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $05bd5b66d02a1a3f$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $05bd5b66d02a1a3f$export$45b10814cc054894 = (a)=>$05bd5b66d02a1a3f$export$226b3eccf92c9ed9.und(a) ? [] : $05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $05bd5b66d02a1a3f$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $05bd5b66d02a1a3f$export$79b2f7037acddd43(items, iterator);
    }
}
var $05bd5b66d02a1a3f$export$7ba486852759e806 = (queue, ...args)=>$05bd5b66d02a1a3f$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $05bd5b66d02a1a3f$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $05bd5b66d02a1a3f$var$createStringInterpolator;
var $05bd5b66d02a1a3f$var$to;
var $05bd5b66d02a1a3f$var$colors = null;
var $05bd5b66d02a1a3f$var$skipAnimation = false;
var $05bd5b66d02a1a3f$var$willAdvance = $05bd5b66d02a1a3f$export$8793edee2d425525;
var $05bd5b66d02a1a3f$var$assign = (globals)=>{
    if (globals.to) $05bd5b66d02a1a3f$var$to = globals.to;
    if (globals.now) (0, $gtRA1.raf).now = globals.now;
    if (globals.colors !== void 0) $05bd5b66d02a1a3f$var$colors = globals.colors;
    if (globals.skipAnimation != null) $05bd5b66d02a1a3f$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $05bd5b66d02a1a3f$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $gtRA1.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $gtRA1.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $05bd5b66d02a1a3f$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $gtRA1.raf).frameLoop = globals.frameLoop;
};
var $05bd5b66d02a1a3f$var$startQueue = /* @__PURE__ */ new Set();
var $05bd5b66d02a1a3f$var$currentFrame = [];
var $05bd5b66d02a1a3f$var$prevFrame = [];
var $05bd5b66d02a1a3f$var$priority = 0;
var $05bd5b66d02a1a3f$export$a57f5080a3bcc90a = {
    get idle () {
        return !$05bd5b66d02a1a3f$var$startQueue.size && !$05bd5b66d02a1a3f$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($05bd5b66d02a1a3f$var$priority > animation.priority) {
            $05bd5b66d02a1a3f$var$startQueue.add(animation);
            (0, $gtRA1.raf).onStart($05bd5b66d02a1a3f$var$flushStartQueue);
        } else {
            $05bd5b66d02a1a3f$var$startSafely(animation);
            (0, $gtRA1.raf)($05bd5b66d02a1a3f$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $05bd5b66d02a1a3f$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($05bd5b66d02a1a3f$var$priority) (0, $gtRA1.raf).onFrame(()=>$05bd5b66d02a1a3f$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $05bd5b66d02a1a3f$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $05bd5b66d02a1a3f$var$currentFrame.splice(prevIndex, 1);
                $05bd5b66d02a1a3f$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $05bd5b66d02a1a3f$var$currentFrame = [];
        $05bd5b66d02a1a3f$var$startQueue.clear();
    }
};
function $05bd5b66d02a1a3f$var$flushStartQueue() {
    $05bd5b66d02a1a3f$var$startQueue.forEach($05bd5b66d02a1a3f$var$startSafely);
    $05bd5b66d02a1a3f$var$startQueue.clear();
    (0, $gtRA1.raf)($05bd5b66d02a1a3f$var$advance);
}
function $05bd5b66d02a1a3f$var$startSafely(animation) {
    if (!$05bd5b66d02a1a3f$var$currentFrame.includes(animation)) $05bd5b66d02a1a3f$var$startUnsafely(animation);
}
function $05bd5b66d02a1a3f$var$startUnsafely(animation) {
    $05bd5b66d02a1a3f$var$currentFrame.splice($05bd5b66d02a1a3f$var$findIndex($05bd5b66d02a1a3f$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $05bd5b66d02a1a3f$var$advance(dt) {
    const nextFrame = $05bd5b66d02a1a3f$var$prevFrame;
    for(let i = 0; i < $05bd5b66d02a1a3f$var$currentFrame.length; i++){
        const animation = $05bd5b66d02a1a3f$var$currentFrame[i];
        $05bd5b66d02a1a3f$var$priority = animation.priority;
        if (!animation.idle) {
            $05bd5b66d02a1a3f$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $05bd5b66d02a1a3f$var$priority = 0;
    $05bd5b66d02a1a3f$var$prevFrame = $05bd5b66d02a1a3f$var$currentFrame;
    $05bd5b66d02a1a3f$var$prevFrame.length = 0;
    $05bd5b66d02a1a3f$var$currentFrame = nextFrame;
    return $05bd5b66d02a1a3f$var$currentFrame.length > 0;
}
function $05bd5b66d02a1a3f$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $05bd5b66d02a1a3f$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $05bd5b66d02a1a3f$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $05bd5b66d02a1a3f$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $05bd5b66d02a1a3f$var$PERCENTAGE = $05bd5b66d02a1a3f$var$NUMBER + "%";
function $05bd5b66d02a1a3f$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $05bd5b66d02a1a3f$export$8972dc0e6ad9238f = new RegExp("rgb" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER));
var $05bd5b66d02a1a3f$export$4e46ac54fc82cf3b = new RegExp("rgba" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$NUMBER));
var $05bd5b66d02a1a3f$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$PERCENTAGE, $05bd5b66d02a1a3f$var$PERCENTAGE));
var $05bd5b66d02a1a3f$export$810b04175080204c = new RegExp("hsla" + $05bd5b66d02a1a3f$var$call($05bd5b66d02a1a3f$var$NUMBER, $05bd5b66d02a1a3f$var$PERCENTAGE, $05bd5b66d02a1a3f$var$PERCENTAGE, $05bd5b66d02a1a3f$var$NUMBER));
var $05bd5b66d02a1a3f$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $05bd5b66d02a1a3f$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $05bd5b66d02a1a3f$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $05bd5b66d02a1a3f$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $05bd5b66d02a1a3f$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $05bd5b66d02a1a3f$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($05bd5b66d02a1a3f$var$colors && $05bd5b66d02a1a3f$var$colors[color] !== void 0) return $05bd5b66d02a1a3f$var$colors[color];
    if (match = $05bd5b66d02a1a3f$export$8972dc0e6ad9238f.exec(color)) return ($05bd5b66d02a1a3f$var$parse255(match[1]) << 24 | // r
    $05bd5b66d02a1a3f$var$parse255(match[2]) << 16 | // g
    $05bd5b66d02a1a3f$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $05bd5b66d02a1a3f$export$4e46ac54fc82cf3b.exec(color)) return ($05bd5b66d02a1a3f$var$parse255(match[1]) << 24 | // r
    $05bd5b66d02a1a3f$var$parse255(match[2]) << 16 | // g
    $05bd5b66d02a1a3f$var$parse255(match[3]) << 8 | // b
    $05bd5b66d02a1a3f$var$parse1(match[4])) >>> // a
    0;
    if (match = $05bd5b66d02a1a3f$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $05bd5b66d02a1a3f$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $05bd5b66d02a1a3f$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $05bd5b66d02a1a3f$export$8f4a7c0bb78e6ea8.exec(color)) return ($05bd5b66d02a1a3f$var$hslToRgb($05bd5b66d02a1a3f$var$parse360(match[1]), // h
    $05bd5b66d02a1a3f$var$parsePercentage(match[2]), // s
    $05bd5b66d02a1a3f$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $05bd5b66d02a1a3f$export$810b04175080204c.exec(color)) return ($05bd5b66d02a1a3f$var$hslToRgb($05bd5b66d02a1a3f$var$parse360(match[1]), // h
    $05bd5b66d02a1a3f$var$parsePercentage(match[2]), // s
    $05bd5b66d02a1a3f$var$parsePercentage(match[3])) | $05bd5b66d02a1a3f$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $05bd5b66d02a1a3f$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $05bd5b66d02a1a3f$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $05bd5b66d02a1a3f$var$hue2rgb(p, q, h + 1 / 3);
    const g = $05bd5b66d02a1a3f$var$hue2rgb(p, q, h);
    const b = $05bd5b66d02a1a3f$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $05bd5b66d02a1a3f$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $05bd5b66d02a1a3f$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $05bd5b66d02a1a3f$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $05bd5b66d02a1a3f$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $05bd5b66d02a1a3f$export$61db176b839af1f(input) {
    let int32Color = $05bd5b66d02a1a3f$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $05bd5b66d02a1a3f$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.arr(range)) return $05bd5b66d02a1a3f$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($05bd5b66d02a1a3f$export$226b3eccf92c9ed9.str(range.output[0])) return $05bd5b66d02a1a3f$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $05bd5b66d02a1a3f$var$findRange(input, inputRange);
        return $05bd5b66d02a1a3f$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $05bd5b66d02a1a3f$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $05bd5b66d02a1a3f$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $05bd5b66d02a1a3f$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $05bd5b66d02a1a3f$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $05bd5b66d02a1a3f$var$c1 = 1.70158;
var $05bd5b66d02a1a3f$var$c2 = $05bd5b66d02a1a3f$var$c1 * 1.525;
var $05bd5b66d02a1a3f$var$c3 = $05bd5b66d02a1a3f$var$c1 + 1;
var $05bd5b66d02a1a3f$var$c4 = 2 * Math.PI / 3;
var $05bd5b66d02a1a3f$var$c5 = 2 * Math.PI / 4.5;
var $05bd5b66d02a1a3f$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $05bd5b66d02a1a3f$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$05bd5b66d02a1a3f$var$c3 * x * x * x - $05bd5b66d02a1a3f$var$c1 * x * x,
    easeOutBack: (x)=>1 + $05bd5b66d02a1a3f$var$c3 * Math.pow(x - 1, 3) + $05bd5b66d02a1a3f$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($05bd5b66d02a1a3f$var$c2 + 1) * 2 * x - $05bd5b66d02a1a3f$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($05bd5b66d02a1a3f$var$c2 + 1) * (x * 2 - 2) + $05bd5b66d02a1a3f$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $05bd5b66d02a1a3f$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $05bd5b66d02a1a3f$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $05bd5b66d02a1a3f$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $05bd5b66d02a1a3f$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $05bd5b66d02a1a3f$var$bounceOut(1 - x),
    easeOutBounce: $05bd5b66d02a1a3f$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $05bd5b66d02a1a3f$var$bounceOut(1 - 2 * x)) / 2 : (1 + $05bd5b66d02a1a3f$var$bounceOut(2 * x - 1)) / 2,
    steps: $05bd5b66d02a1a3f$var$steps
};
// src/fluids.ts
var $05bd5b66d02a1a3f$var$$get = Symbol.for("FluidValue.get");
var $05bd5b66d02a1a3f$var$$observers = Symbol.for("FluidValue.observers");
var $05bd5b66d02a1a3f$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$05bd5b66d02a1a3f$var$$get]);
var $05bd5b66d02a1a3f$export$e37b7520edd66839 = (arg)=>arg && arg[$05bd5b66d02a1a3f$var$$get] ? arg[$05bd5b66d02a1a3f$var$$get]() : arg;
var $05bd5b66d02a1a3f$export$133f54e9f7cf1796 = (target)=>target[$05bd5b66d02a1a3f$var$$observers] || null;
function $05bd5b66d02a1a3f$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $05bd5b66d02a1a3f$export$31752c40a5fab62a(target, event) {
    const observers = target[$05bd5b66d02a1a3f$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $05bd5b66d02a1a3f$export$8cbca1207adce0c0(observer2, event);
    });
}
var $05bd5b66d02a1a3f$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $05bd5b66d02a1a3f$export$a3b4618659637aa3(this, get);
    }
};
$05bd5b66d02a1a3f$var$$get, $05bd5b66d02a1a3f$var$$observers;
var $05bd5b66d02a1a3f$export$a3b4618659637aa3 = (target, get)=>$05bd5b66d02a1a3f$var$setHidden(target, $05bd5b66d02a1a3f$var$$get, get);
function $05bd5b66d02a1a3f$export$72d604e3f8d000a5(target, observer2) {
    if (target[$05bd5b66d02a1a3f$var$$get]) {
        let observers = target[$05bd5b66d02a1a3f$var$$observers];
        if (!observers) $05bd5b66d02a1a3f$var$setHidden(target, $05bd5b66d02a1a3f$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $05bd5b66d02a1a3f$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$05bd5b66d02a1a3f$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$05bd5b66d02a1a3f$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $05bd5b66d02a1a3f$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $05bd5b66d02a1a3f$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $05bd5b66d02a1a3f$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $05bd5b66d02a1a3f$var$unitRegex = new RegExp(`(${$05bd5b66d02a1a3f$var$numberRegex.source})(%|[a-z]+)`, "i");
var $05bd5b66d02a1a3f$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $05bd5b66d02a1a3f$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $05bd5b66d02a1a3f$var$variableToRgba = (input)=>{
    const [token, fallback] = $05bd5b66d02a1a3f$var$parseCSSVariable(input);
    if (!token || $05bd5b66d02a1a3f$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $05bd5b66d02a1a3f$var$cssVariableRegex.test(fallback)) return $05bd5b66d02a1a3f$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $05bd5b66d02a1a3f$var$parseCSSVariable = (current)=>{
    const match = $05bd5b66d02a1a3f$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $05bd5b66d02a1a3f$var$namedColorRegex;
var $05bd5b66d02a1a3f$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $05bd5b66d02a1a3f$export$4759a013d387347a = (config)=>{
    if (!$05bd5b66d02a1a3f$var$namedColorRegex) $05bd5b66d02a1a3f$var$namedColorRegex = $05bd5b66d02a1a3f$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($05bd5b66d02a1a3f$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $05bd5b66d02a1a3f$export$e37b7520edd66839(value).replace($05bd5b66d02a1a3f$var$cssVariableRegex, $05bd5b66d02a1a3f$var$variableToRgba).replace($05bd5b66d02a1a3f$var$colorRegex, $05bd5b66d02a1a3f$export$61db176b839af1f).replace($05bd5b66d02a1a3f$var$namedColorRegex, $05bd5b66d02a1a3f$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($05bd5b66d02a1a3f$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$05bd5b66d02a1a3f$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$05bd5b66d02a1a3f$var$unitRegex.test(output[0]) && output.find((value)=>$05bd5b66d02a1a3f$var$unitRegex.test(value))?.replace($05bd5b66d02a1a3f$var$numberRegex, "");
        let i = 0;
        return output[0].replace($05bd5b66d02a1a3f$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($05bd5b66d02a1a3f$var$rgbaRegex, $05bd5b66d02a1a3f$var$rgbaRound);
    };
};
// src/deprecations.ts
var $05bd5b66d02a1a3f$export$82e9f45cca5ba907 = "react-spring: ";
var $05bd5b66d02a1a3f$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$05bd5b66d02a1a3f$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $05bd5b66d02a1a3f$var$warnInterpolate = $05bd5b66d02a1a3f$export$d2de3aaeafa91619(console.warn);
function $05bd5b66d02a1a3f$export$2abfcde8ae218ba8() {
    $05bd5b66d02a1a3f$var$warnInterpolate(`${$05bd5b66d02a1a3f$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $05bd5b66d02a1a3f$var$warnDirectCall = $05bd5b66d02a1a3f$export$d2de3aaeafa91619(console.warn);
function $05bd5b66d02a1a3f$export$d99d974913ad3b12() {
    $05bd5b66d02a1a3f$var$warnDirectCall(`${$05bd5b66d02a1a3f$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $05bd5b66d02a1a3f$export$75bed621f62abfa9(value) {
    return $05bd5b66d02a1a3f$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$05bd5b66d02a1a3f$export$48d7c418edadb60c() && $05bd5b66d02a1a3f$var$cssVariableRegex.test(value) || value in ($05bd5b66d02a1a3f$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $05bd5b66d02a1a3f$var$observer;
var $05bd5b66d02a1a3f$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $05bd5b66d02a1a3f$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $05bd5b66d02a1a3f$var$resizeElement(handler, target) {
    if (!$05bd5b66d02a1a3f$var$observer) {
        if (typeof ResizeObserver !== "undefined") $05bd5b66d02a1a3f$var$observer = new ResizeObserver($05bd5b66d02a1a3f$var$handleObservation);
    }
    let elementHandlers = $05bd5b66d02a1a3f$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $05bd5b66d02a1a3f$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($05bd5b66d02a1a3f$var$observer) $05bd5b66d02a1a3f$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $05bd5b66d02a1a3f$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $05bd5b66d02a1a3f$var$observer) $05bd5b66d02a1a3f$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $05bd5b66d02a1a3f$var$listeners = /* @__PURE__ */ new Set();
var $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler;
var $05bd5b66d02a1a3f$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $05bd5b66d02a1a3f$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $05bd5b66d02a1a3f$var$resizeWindow = (callback)=>{
    $05bd5b66d02a1a3f$var$listeners.add(callback);
    if (!$05bd5b66d02a1a3f$var$cleanupWindowResizeHandler) $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler = $05bd5b66d02a1a3f$var$createResizeHandler();
    return ()=>{
        $05bd5b66d02a1a3f$var$listeners.delete(callback);
        if (!$05bd5b66d02a1a3f$var$listeners.size && $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler) {
            $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler();
            $05bd5b66d02a1a3f$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $05bd5b66d02a1a3f$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $05bd5b66d02a1a3f$var$resizeWindow(callback);
    else return $05bd5b66d02a1a3f$var$resizeElement(callback, container);
};
// src/progress.ts
var $05bd5b66d02a1a3f$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $05bd5b66d02a1a3f$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $05bd5b66d02a1a3f$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $05bd5b66d02a1a3f$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $05bd5b66d02a1a3f$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $05bd5b66d02a1a3f$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $05bd5b66d02a1a3f$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $05bd5b66d02a1a3f$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $05bd5b66d02a1a3f$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $05bd5b66d02a1a3f$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $05bd5b66d02a1a3f$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$05bd5b66d02a1a3f$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $05bd5b66d02a1a3f$var$scrollListeners.set(container, listener);
        const target = $05bd5b66d02a1a3f$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $05bd5b66d02a1a3f$var$resizeListeners.set(container, $05bd5b66d02a1a3f$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $05bd5b66d02a1a3f$var$scrollListeners.get(container);
    (0, $gtRA1.raf)(animateScroll);
    return ()=>{
        (0, $gtRA1.raf).cancel(animateScroll);
        const containerHandlers2 = $05bd5b66d02a1a3f$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $05bd5b66d02a1a3f$var$scrollListeners.get(container);
        $05bd5b66d02a1a3f$var$scrollListeners.delete(container);
        if (listener) {
            $05bd5b66d02a1a3f$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $05bd5b66d02a1a3f$var$resizeListeners.get(container)?.();
        }
    };
};
function $05bd5b66d02a1a3f$export$fe4300aa8eebea86(init) {
    const ref = (0, $bxRTa.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $05bd5b66d02a1a3f$export$700979bc83e7db82 = $05bd5b66d02a1a3f$export$48d7c418edadb60c() ? (0, $bxRTa.useEffect) : (0, $bxRTa.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $05bd5b66d02a1a3f$var$useIsMounted = ()=>{
    const isMounted = (0, $bxRTa.useRef)(false);
    $05bd5b66d02a1a3f$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $05bd5b66d02a1a3f$export$91db9bc4f8ac944a() {
    const update = (0, $bxRTa.useState)()[1];
    const isMounted = $05bd5b66d02a1a3f$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $05bd5b66d02a1a3f$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $bxRTa.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $bxRTa.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $05bd5b66d02a1a3f$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $bxRTa.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $05bd5b66d02a1a3f$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $05bd5b66d02a1a3f$export$392544347a18b6ea = (effect)=>(0, $bxRTa.useEffect)(effect, $05bd5b66d02a1a3f$var$emptyDeps);
var $05bd5b66d02a1a3f$var$emptyDeps = [];
function $05bd5b66d02a1a3f$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $bxRTa.useRef)();
    (0, $bxRTa.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $05bd5b66d02a1a3f$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $bxRTa.useState)(null);
    $05bd5b66d02a1a3f$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $05bd5b66d02a1a3f$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

});
parcelRegister("gtRA1", function(module, exports) {

$parcel$export(module.exports, "raf", () => $78610d1aca4f97bc$export$27f233d61a9e2fa4);
// src/index.ts
var $78610d1aca4f97bc$var$updateQueue = $78610d1aca4f97bc$var$makeQueue();
var $78610d1aca4f97bc$export$27f233d61a9e2fa4 = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$updateQueue);
var $78610d1aca4f97bc$var$writeQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.write = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$writeQueue);
var $78610d1aca4f97bc$var$onStartQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.onStart = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$onStartQueue);
var $78610d1aca4f97bc$var$onFrameQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.onFrame = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$onFrameQueue);
var $78610d1aca4f97bc$var$onFinishQueue = $78610d1aca4f97bc$var$makeQueue();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.onFinish = (fn)=>$78610d1aca4f97bc$var$schedule(fn, $78610d1aca4f97bc$var$onFinishQueue);
var $78610d1aca4f97bc$var$timeouts = [];
$78610d1aca4f97bc$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $78610d1aca4f97bc$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $78610d1aca4f97bc$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $78610d1aca4f97bc$var$timeouts.splice(i, 1);
        $78610d1aca4f97bc$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $78610d1aca4f97bc$var$timeouts.splice($78610d1aca4f97bc$var$findTimeout(time), 0, timeout);
    $78610d1aca4f97bc$var$pendingCount += 1;
    $78610d1aca4f97bc$var$start();
    return timeout;
};
var $78610d1aca4f97bc$var$findTimeout = (time)=>~(~$78610d1aca4f97bc$var$timeouts.findIndex((t)=>t.time > time) || ~$78610d1aca4f97bc$var$timeouts.length);
$78610d1aca4f97bc$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $78610d1aca4f97bc$var$onStartQueue.delete(fn);
    $78610d1aca4f97bc$var$onFrameQueue.delete(fn);
    $78610d1aca4f97bc$var$onFinishQueue.delete(fn);
    $78610d1aca4f97bc$var$updateQueue.delete(fn);
    $78610d1aca4f97bc$var$writeQueue.delete(fn);
};
$78610d1aca4f97bc$export$27f233d61a9e2fa4.sync = (fn)=>{
    $78610d1aca4f97bc$var$sync = true;
    $78610d1aca4f97bc$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $78610d1aca4f97bc$var$sync = false;
};
$78610d1aca4f97bc$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $78610d1aca4f97bc$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $78610d1aca4f97bc$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $78610d1aca4f97bc$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$78610d1aca4f97bc$export$27f233d61a9e2fa4.use = (impl)=>$78610d1aca4f97bc$var$nativeRaf = impl;
$78610d1aca4f97bc$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$78610d1aca4f97bc$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$78610d1aca4f97bc$export$27f233d61a9e2fa4.catch = console.error;
$78610d1aca4f97bc$export$27f233d61a9e2fa4.frameLoop = "always";
$78610d1aca4f97bc$export$27f233d61a9e2fa4.advance = ()=>{
    if ($78610d1aca4f97bc$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $78610d1aca4f97bc$var$update();
};
var $78610d1aca4f97bc$var$ts = -1;
var $78610d1aca4f97bc$var$pendingCount = 0;
var $78610d1aca4f97bc$var$sync = false;
function $78610d1aca4f97bc$var$schedule(fn, queue) {
    if ($78610d1aca4f97bc$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $78610d1aca4f97bc$var$start();
    }
}
function $78610d1aca4f97bc$var$start() {
    if ($78610d1aca4f97bc$var$ts < 0) {
        $78610d1aca4f97bc$var$ts = 0;
        if ($78610d1aca4f97bc$export$27f233d61a9e2fa4.frameLoop !== "demand") $78610d1aca4f97bc$var$nativeRaf($78610d1aca4f97bc$var$loop);
    }
}
function $78610d1aca4f97bc$var$stop() {
    $78610d1aca4f97bc$var$ts = -1;
}
function $78610d1aca4f97bc$var$loop() {
    if (~$78610d1aca4f97bc$var$ts) {
        $78610d1aca4f97bc$var$nativeRaf($78610d1aca4f97bc$var$loop);
        $78610d1aca4f97bc$export$27f233d61a9e2fa4.batchedUpdates($78610d1aca4f97bc$var$update);
    }
}
function $78610d1aca4f97bc$var$update() {
    const prevTs = $78610d1aca4f97bc$var$ts;
    $78610d1aca4f97bc$var$ts = $78610d1aca4f97bc$export$27f233d61a9e2fa4.now();
    const count = $78610d1aca4f97bc$var$findTimeout($78610d1aca4f97bc$var$ts);
    if (count) {
        $78610d1aca4f97bc$var$eachSafely($78610d1aca4f97bc$var$timeouts.splice(0, count), (t)=>t.handler());
        $78610d1aca4f97bc$var$pendingCount -= count;
    }
    if (!$78610d1aca4f97bc$var$pendingCount) {
        $78610d1aca4f97bc$var$stop();
        return;
    }
    $78610d1aca4f97bc$var$onStartQueue.flush();
    $78610d1aca4f97bc$var$updateQueue.flush(prevTs ? Math.min(64, $78610d1aca4f97bc$var$ts - prevTs) : 16.667);
    $78610d1aca4f97bc$var$onFrameQueue.flush();
    $78610d1aca4f97bc$var$writeQueue.flush();
    $78610d1aca4f97bc$var$onFinishQueue.flush();
}
function $78610d1aca4f97bc$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $78610d1aca4f97bc$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $78610d1aca4f97bc$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $78610d1aca4f97bc$var$pendingCount -= current.size;
                $78610d1aca4f97bc$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $78610d1aca4f97bc$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $78610d1aca4f97bc$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $78610d1aca4f97bc$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $78610d1aca4f97bc$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $78610d1aca4f97bc$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $78610d1aca4f97bc$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $78610d1aca4f97bc$var$ts = -1;
        $78610d1aca4f97bc$var$timeouts = [];
        $78610d1aca4f97bc$var$onStartQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$updateQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$onFrameQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$writeQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$onFinishQueue = $78610d1aca4f97bc$var$makeQueue();
        $78610d1aca4f97bc$var$pendingCount = 0;
    }
};

});


parcelRegister("b1Sgt", function(module, exports) {

$parcel$export(module.exports, "getAnimated", () => $f5c2412cc94227ab$export$6b63995194a3a9e4);
$parcel$export(module.exports, "setAnimated", () => $f5c2412cc94227ab$export$b553cb5b22b81b04);
$parcel$export(module.exports, "getPayload", () => $f5c2412cc94227ab$export$ccab2b64c5d440);
$parcel$export(module.exports, "AnimatedValue", () => $f5c2412cc94227ab$export$cb1e8f3c05d37ad5);
$parcel$export(module.exports, "AnimatedString", () => $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93);
$parcel$export(module.exports, "AnimatedObject", () => $f5c2412cc94227ab$export$f1b0b9e366a6e2d4);
$parcel$export(module.exports, "getAnimatedType", () => $f5c2412cc94227ab$export$e6b77ddbe47b132e);
$parcel$export(module.exports, "createHost", () => $f5c2412cc94227ab$export$4ee5c78f6dcbcef);
// src/Animated.ts

var $2aMjv = parcelRequire("2aMjv");
var $gtRA1 = parcelRequire("gtRA1");

var $bxRTa = parcelRequire("bxRTa");
var $f5c2412cc94227ab$var$$node = Symbol.for("Animated:node");
var $f5c2412cc94227ab$export$3df5e165e801a70f = (value)=>!!value && value[$f5c2412cc94227ab$var$$node] === value;
var $f5c2412cc94227ab$export$6b63995194a3a9e4 = (owner)=>owner && owner[$f5c2412cc94227ab$var$$node];
var $f5c2412cc94227ab$export$b553cb5b22b81b04 = (owner, node)=>(0, $2aMjv.defineHidden)(owner, $f5c2412cc94227ab$var$$node, node);
var $f5c2412cc94227ab$export$ccab2b64c5d440 = (owner)=>owner && owner[$f5c2412cc94227ab$var$$node] && owner[$f5c2412cc94227ab$var$$node].getPayload();
var $f5c2412cc94227ab$export$31627395a3b18e54 = class {
    constructor(){
        $f5c2412cc94227ab$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $f5c2412cc94227ab$export$cb1e8f3c05d37ad5 = class extends $f5c2412cc94227ab$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $2aMjv.is).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $f5c2412cc94227ab$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $2aMjv.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $2aMjv.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93 = class extends $f5c2412cc94227ab$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $2aMjv.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $2aMjv.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $2aMjv.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $f5c2412cc94227ab$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $f5c2412cc94227ab$export$f1b0b9e366a6e2d4 = class extends $f5c2412cc94227ab$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $2aMjv.eachProp)(this.source, (source, key)=>{
            if ($f5c2412cc94227ab$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $2aMjv.hasFluidValue)(source)) values[key] = (0, $2aMjv.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $2aMjv.each)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $2aMjv.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($f5c2412cc94227ab$var$TreeContext.dependencies && (0, $2aMjv.hasFluidValue)(source)) $f5c2412cc94227ab$var$TreeContext.dependencies.add(source);
        const payload = $f5c2412cc94227ab$export$ccab2b64c5d440(source);
        if (payload) (0, $2aMjv.each)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $f5c2412cc94227ab$export$ede394683406942d = class extends $f5c2412cc94227ab$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $f5c2412cc94227ab$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($f5c2412cc94227ab$var$makeAnimated));
        return true;
    }
};
function $f5c2412cc94227ab$var$makeAnimated(value) {
    const nodeType = (0, $2aMjv.isAnimatedString)(value) ? $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93 : $f5c2412cc94227ab$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $f5c2412cc94227ab$export$e6b77ddbe47b132e(value) {
    const parentNode = $f5c2412cc94227ab$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $2aMjv.is).arr(value) ? $f5c2412cc94227ab$export$ede394683406942d : (0, $2aMjv.isAnimatedString)(value) ? $f5c2412cc94227ab$export$f6c6c4cbd7fa5b93 : $f5c2412cc94227ab$export$cb1e8f3c05d37ad5;
}
var $f5c2412cc94227ab$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $2aMjv.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $bxRTa.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $bxRTa.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $bxRTa.useCallback)((value)=>{
            instanceRef.current = $f5c2412cc94227ab$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $f5c2412cc94227ab$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $2aMjv.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $f5c2412cc94227ab$var$PropsObserver(callback, deps);
        const observerRef = (0, $bxRTa.useRef)();
        (0, $2aMjv.useIsomorphicLayoutEffect)(()=>{
            observerRef.current = observer;
            (0, $2aMjv.each)(deps, (dep)=>(0, $2aMjv.addFluidObserver)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $2aMjv.each)(observerRef.current.deps, (dep)=>(0, $2aMjv.removeFluidObserver)(dep, observerRef.current));
                    (0, $gtRA1.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, $bxRTa.useEffect)(callback, []);
        (0, $2aMjv.useOnce)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $2aMjv.each)(observer2.deps, (dep)=>(0, $2aMjv.removeFluidObserver)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $bxRTa.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $f5c2412cc94227ab$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $gtRA1.raf).write(this.update);
    }
};
function $f5c2412cc94227ab$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $f5c2412cc94227ab$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $f5c2412cc94227ab$export$f1b0b9e366a6e2d4(props);
    $f5c2412cc94227ab$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $f5c2412cc94227ab$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $2aMjv.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $f5c2412cc94227ab$var$cacheKey = Symbol.for("AnimatedComponent");
var $f5c2412cc94227ab$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $f5c2412cc94227ab$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $f5c2412cc94227ab$var$getDisplayName(Component) || "Anonymous";
        if ((0, $2aMjv.is).str(Component)) Component = animated[Component] || (animated[Component] = $f5c2412cc94227ab$var$withAnimated(Component, hostConfig));
        else Component = Component[$f5c2412cc94227ab$var$cacheKey] || (Component[$f5c2412cc94227ab$var$cacheKey] = $f5c2412cc94227ab$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $2aMjv.eachProp)(components, (Component, key)=>{
        if ((0, $2aMjv.is).arr(components)) key = $f5c2412cc94227ab$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $f5c2412cc94227ab$var$getDisplayName = (arg)=>(0, $2aMjv.is).str(arg) ? arg : arg && (0, $2aMjv.is).str(arg.displayName) ? arg.displayName : (0, $2aMjv.is).fun(arg) && arg.name || null;

});

parcelRegister("5od7d", function(module, exports) {
// src/utils.ts
var $d14fc60eedae7441$export$b24b633b1364b94b = class {
};

});



parcelRegister("kaFO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6737f9caded417b5$export$2e2bcd8739ae039);

var $4xGiN = parcelRequire("4xGiN");

var $bWQ72 = parcelRequire("bWQ72");

var $bxRTa = parcelRequire("bxRTa");
const $6737f9caded417b5$var$useFullscreenImage = ()=>{
    const lastbotActivity = (0, $bWQ72.useActivityStore)((state)=>state.lastBotActivity);
    const fullScreenImage = (0, $4xGiN.useUtilsStore)((state)=>state.fullScreenImage);
    const [image, setImage] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        setImage(fullScreenImage);
    }, [
        fullScreenImage
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (lastbotActivity && lastbotActivity.type === 'event' && lastbotActivity.name === 'hospitality.ShowImage' && lastbotActivity.value) setImage(lastbotActivity.value);
        else setImage(undefined);
    }, [
        lastbotActivity
    ]);
    return image;
};
var $6737f9caded417b5$export$2e2bcd8739ae039 = $6737f9caded417b5$var$useFullscreenImage;

});

parcelRegister("9TTQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ca07486db72ee2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $36ca07486db72ee2$var$CloseButton = ({ onClick: onClick, label: label, className: className, showLabel: showLabel })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        "aria-label": label || translation.common.close,
        onClick: onClick,
        className: `${className} rf-absolute rf-flex rf-flex-col rf-items-center rf-right-0 rf-top-0 rf-p-2`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                className: "rf-h-6 rf-w-6"
            }),
            showLabel && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-[0.5rem] rf-uppercase",
                children: label || translation.common.close
            })
        ]
    });
};
var $36ca07486db72ee2$export$2e2bcd8739ae039 = $36ca07486db72ee2$var$CloseButton;

});

parcelRegister("2roA1", function(module, exports) {
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("9Alju", function(module, exports) {

$parcel$export(module.exports, "getColorFromCategoryId", () => $2bce87916a747938$export$7c3e7489ecac4759);

var $2rYkD = parcelRequire("2rYkD");
const $2bce87916a747938$export$7c3e7489ecac4759 = (id, themeColors)=>{
    let color = themeColors.secondary;
    if (id) switch(id.toLowerCase()){
        case (0, $2rYkD.CategoryId).eat:
            color = themeColors.whereToEatColor;
            break;
        case (0, $2rYkD.CategoryId).sleep:
            color = themeColors.whereToSleepColor;
            break;
        case (0, $2rYkD.CategoryId).see:
            color = themeColors.tobeSeenColor;
            break;
        case (0, $2rYkD.CategoryId).do:
            color = themeColors.tobeDoneColor;
            break;
        case (0, $2rYkD.CategoryId).localproducts:
            color = themeColors.localProductsColor;
            break;
        case (0, $2rYkD.CategoryId).services:
            color = themeColors.servicesColor;
            break;
        case (0, $2rYkD.CategoryId).agenda:
            color = themeColors.agendaColor;
            break;
        case (0, $2rYkD.CategoryId).occupant:
            color = themeColors.occupantColor;
            break;
        default:
            color = themeColors.secondary;
            break;
    }
    return color;
};

});

parcelRegister("lTDDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $834910afddbc9d20$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");
parcelRequire("hZeqH");
var $dvlC9 = parcelRequire("dvlC9");

var $9TTQJ = parcelRequire("9TTQJ");

var $75jcl = parcelRequire("75jcl");
parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");
const $834910afddbc9d20$var$FullScreenRemoteClosing = ({ className: className, background: background, closeButtonClassName: closeButtonClassName, remoteCloseButtonZIndex: remoteCloseButtonZIndex, mobileReturnTitle: mobileReturnTitle, handleClose: handleClose, onClick: onClick, animation: animation, children: children })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const isBorne = (0, $9JLpC.useViewStore)((state)=>state.isBorne);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $dvlC9.default), {
                className: className,
                background: background,
                onClick: onClick,
                animation: animation,
                children: [
                    isLandscape && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleClose,
                        className: closeButtonClassName,
                        showLabel: true
                    }),
                    isMobile && mobileReturnTitle && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                        title: mobileReturnTitle,
                        handleBack: handleClose,
                        className: "rf-p-4 rf-text-size-auto"
                    }),
                    children
                ]
            }),
            isBorne && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                zIndexClassname: remoteCloseButtonZIndex,
                onClick: handleClose
            })
        ]
    });
};
var $834910afddbc9d20$export$2e2bcd8739ae039 = $834910afddbc9d20$var$FullScreenRemoteClosing;

});
parcelRegister("hZeqH", function(module, exports) {

$parcel$export(module.exports, "Desktop", () => (parcelRequire("byZaD")).default);
$parcel$export(module.exports, "FullScreen", () => (parcelRequire("6Vbk7")).default);
$parcel$export(module.exports, "FullScreenMobile", () => (parcelRequire("AeEPl")).default);
$parcel$export(module.exports, "FullScreenRemote", () => (parcelRequire("dvlC9")).default);
$parcel$export(module.exports, "SubMenu", () => (parcelRequire("32gH3")).default);
$parcel$export(module.exports, "SubMenuClosing", () => (parcelRequire("7RuxE")).default);

var $byZaD = parcelRequire("byZaD");

var $6Vbk7 = parcelRequire("6Vbk7");

var $AeEPl = parcelRequire("AeEPl");

var $dvlC9 = parcelRequire("dvlC9");

var $lTDDB = parcelRequire("lTDDB");

var $a459f = parcelRequire("a459f");

var $jz5ru = parcelRequire("jz5ru");

var $32gH3 = parcelRequire("32gH3");

var $7RuxE = parcelRequire("7RuxE");

});
parcelRegister("byZaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $decf61189c37ce0b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $decf61189c37ce0b$var$Desktop = ({ background: background, children: children })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-z-menu rf-relative rf-col-start-5 rf-col-end-13 rf-row-start-1 rf-row-span-full rf-w-3/5 rf-justify-self-center tactile:rf-pt-1/5 rf-flex rf-flex-col rf-justify-start rf-items-center rf-bg-templateBackground rf-shadow-[3px_3px_6px_#00000029] rf-overflow-y-scroll rf-scrollbar-hidden",
        style: {
            background: background || ''
        },
        children: children
    });
};
var $decf61189c37ce0b$export$2e2bcd8739ae039 = $decf61189c37ce0b$var$Desktop;

});

parcelRegister("6Vbk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a7f3173879e30e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $9TTQJ = parcelRequire("9TTQJ");
const $59a7f3173879e30e$var$FullScreen = ({ className: className, depth: depth, background: background, onClick: onClick, children: children })=>{
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const [zindex, setzindex] = (0, $bxRTa.useState)('rf-z-ui');
    (0, $bxRTa.useEffect)(()=>{
        switch(depth){
            case (0, $2rYkD.Depth).background:
                setzindex('rf-z-background');
                break;
            case (0, $2rYkD.Depth).util:
                setzindex('rf-z-util');
                break;
            case (0, $2rYkD.Depth).chatbot:
                setzindex('rf-z-chatbot');
                break;
            case (0, $2rYkD.Depth).ui:
                setzindex('rf-z-ui');
                break;
            case (0, $2rYkD.Depth).dropdown:
                setzindex('rf-z-dropdown');
                break;
            case (0, $2rYkD.Depth).overlay:
                setzindex('rf-z-overlay');
                break;
            case (0, $2rYkD.Depth).modal:
                setzindex('rf-z-modal');
                break;
            case (0, $2rYkD.Depth).exitwidget:
                setzindex('rf-z-exitwidget');
                break;
            case (0, $2rYkD.Depth).menu:
                setzindex('rf-z-menu');
                break;
            default:
                setzindex('rf-z-dropdown');
                break;
        }
    }, [
        depth
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-relative ${zindex} rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-text-trueblack ${className}`,
        style: {
            background: background || 'linear-gradient(to right bottom, #F8F8FC , #E1E2E8)'
        },
        children: [
            isLandscape && !useOldRemote && route !== (0, $2rYkD.Routes).News && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                onClick: ()=>onClick?.(),
                className: "rf-z-[2]",
                showLabel: true
            }),
            children
        ]
    });
};
var $59a7f3173879e30e$export$2e2bcd8739ae039 = $59a7f3173879e30e$var$FullScreen;

});

parcelRegister("AeEPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae242a7bfb941bbd$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");
parcelRequire("hZeqH");
var $6Vbk7 = parcelRequire("6Vbk7");
const $ae242a7bfb941bbd$var$FullScreenMobile = ({ className: className, depth: depth, background: background, children: children })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const displayControls = (0, $9JLpC.useViewStore)((state)=>state.displayControls);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Vbk7.default), {
        className: `${isMobile && displayControls && 'rf-mb-12'} rf-p-4 rf-flex rf-flex-col ${className}`,
        depth: depth,
        background: background || '#FFFFFF',
        children: children
    });
};
var $ae242a7bfb941bbd$export$2e2bcd8739ae039 = $ae242a7bfb941bbd$var$FullScreenMobile;

});

parcelRegister("dvlC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a171f3efb9408721$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $5bTjo = parcelRequire("5bTjo");
const $a171f3efb9408721$var$FullScreenRemote = ({ className: className, background: background, onClick: onClick, animation: animation, children: children })=>{
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
        className: `${useOldRemote ? className?.includes('rf-z-') ? '' : 'rf-z-util' : 'rf-z-[15]'} rf-relative rf-overflow-y-scroll rf-scrollbar-hidden rf-text-black rf-text-size-auto rf-bg-templateBackground large:rf-mr-30 rf-col-span-full rf-row-span-full ${className}`,
        style: {
            background: background || '',
            outline: '1px solid transparent',
            ...animation
        },
        onClick: onClick ? ()=>onClick() : ()=>{},
        children: children
    });
};
var $a171f3efb9408721$export$2e2bcd8739ae039 = $a171f3efb9408721$var$FullScreenRemote;

});

parcelRegister("a459f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c93c49701e114459$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $c93c49701e114459$var$Grid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-grid rf-grid-cols-2 large:rf-grid-cols-5 large-vertical:rf-grid-cols-3 rf-gap-4 large:rf-gap-6",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.map(children, (child)=>{
            return child;
        })
    });
};
var $c93c49701e114459$export$2e2bcd8739ae039 = $c93c49701e114459$var$Grid;

});

parcelRegister("jz5ru", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e842ffab385346f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $lATAa = parcelRequire("lATAa");

var $b3Gke = parcelRequire("b3Gke");
const $5e842ffab385346f$var$List = ({ activity: activity, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lATAa.default), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b3Gke.default), {
            activity: activity,
            onClose: onClose
        })
    });
};
var $5e842ffab385346f$export$2e2bcd8739ae039 = $5e842ffab385346f$var$List;

});
parcelRegister("lATAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1659729a48fc4639$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");
const $1659729a48fc4639$var$ListContextProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4mkhB.ListProvider), {
        children: children
    });
};
var $1659729a48fc4639$export$2e2bcd8739ae039 = $1659729a48fc4639$var$ListContextProvider;

});
parcelRegister("4mkhB", function(module, exports) {

$parcel$export(module.exports, "useList", () => $138ade36c671bdf6$export$f9763ecd339e95eb);
$parcel$export(module.exports, "ListProvider", () => $138ade36c671bdf6$export$9b0a72e5d41d62ec);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $hdMz2 = parcelRequire("hdMz2");

var $9JLpC = parcelRequire("9JLpC");

var $9Alju = parcelRequire("9Alju");
const $138ade36c671bdf6$var$ListContextDefaultValues = {
    content: undefined,
    filters: [],
    selectedFilters: [],
    loadingData: false,
    color: '',
    setContent: ()=>{},
    setSelectedFilters: ()=>{},
    resetFilters: ()=>{},
    processFiltersOnChange: ()=>{},
    setSuggestedFilter: ()=>{},
    setLoadingData: ()=>{}
};
const $138ade36c671bdf6$export$52411773e0d6f15d = /*#__PURE__*/ (0, $bxRTa.createContext)($138ade36c671bdf6$var$ListContextDefaultValues);
function $138ade36c671bdf6$export$f9763ecd339e95eb() {
    return (0, $bxRTa.useContext)($138ade36c671bdf6$export$52411773e0d6f15d);
}
function $138ade36c671bdf6$export$9b0a72e5d41d62ec({ children: children }) {
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const timerForFilterSelectionListMode = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.timerForFilterSelectionListMode);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [content, setContent] = (0, $bxRTa.useState)();
    const [filters, setFilters] = (0, $bxRTa.useState)([]);
    const [selectedFilters, setSelectedFilters] = (0, $bxRTa.useState)([]);
    const [loadingData, setLoadingData] = (0, $bxRTa.useState)(false);
    const color = (0, $bxRTa.useMemo)(()=>{
        return (0, $9Alju.getColorFromCategoryId)(content?.channelData?.category?.id, themeColors);
    }, [
        content
    ]);
    const timerRef = (0, $bxRTa.useRef)();
    const setSuggestedFilter = (filter)=>{
        setSelectedFilters([
            filter
        ]);
    };
    /**
   * On call :
   *  - set selectedFilters state to empty array
   *  - send postBack message with empty filters
   */ const resetFilters = ()=>{
        setSelectedFilters([]);
        sendMessage(undefined, {
            filters: []
        });
    };
    /**
   * On call :
   *  - set selectedFilters and filters states to empty arrays
   */ const totalReset = ()=>{
        setSelectedFilters([]);
        setFilters([]);
    };
    const processFiltersOnChange = (data, full = false)=>{
        let tempFilters = [];
        timerRef?.current && clearTimeout(timerRef.current);
        if (selectedFilters.length > 0) {
            let remainingData = [
                ...data
            ];
            // Check on each selected filter to modify if necessary
            selectedFilters.forEach((selectedFilter)=>{
                let items = [
                    ...selectedFilter.filterItems
                ];
                data.forEach((filter)=>{
                    if (filter.id === selectedFilter.id) {
                        // Special treatment for calendar filter : only 1 value allowed
                        if (filter.id === 'Event.DateRange') {
                            if (items.length > 0 && filter.filterItems.length > 0 && items[0] === filter.filterItems[0]) items = [];
                            else items = [
                                ...filter.filterItems
                            ];
                        } else // If the chosen filter is a full one and has already at least one item chosen, let's choose all its items
                        if (full) items = selectedFilter.filterItems.length === filter.filterItems.length ? [] : [
                            ...filter.filterItems
                        ];
                        else items = [
                            ...selectedFilter.filterItems,
                            ...filter.filterItems
                        ].filter((item)=>!(selectedFilter.filterItems.find((filterItem)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined && filter.filterItems.find((filterItem)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined));
                        // Let's remove this filter from remainingData because it has been processed
                        remainingData = remainingData.filter((fil)=>fil.id !== filter.id);
                    }
                });
                items.length > 0 && (tempFilters = [
                    ...tempFilters,
                    {
                        id: selectedFilter.id,
                        title: selectedFilter.title,
                        filterItems: items
                    }
                ]);
            });
            // If some filters weren't in the selected filters, we add them to the selected filters
            remainingData.length > 0 && (tempFilters = [
                ...tempFilters,
                ...remainingData
            ]);
        } else data.length > 0 && (tempFilters = data);
        setSelectedFilters(tempFilters);
        timerRef.current = setTimeout(()=>{
            sendMessage(undefined, {
                filters: tempFilters
            });
            setLoadingData(true);
        }, timerForFilterSelectionListMode === undefined ? 1000 : timerForFilterSelectionListMode);
    };
    const value = (0, $bxRTa.useMemo)(()=>({
            content: content,
            filters: filters,
            selectedFilters: selectedFilters,
            loadingData: loadingData,
            color: color,
            setContent: setContent,
            setSelectedFilters: setSelectedFilters,
            resetFilters: resetFilters,
            processFiltersOnChange: processFiltersOnChange,
            setSuggestedFilter: setSuggestedFilter,
            setLoadingData: setLoadingData
        }), [
        content,
        filters,
        selectedFilters,
        loadingData,
        color,
        setContent,
        setSelectedFilters,
        resetFilters,
        processFiltersOnChange,
        setSuggestedFilter,
        setLoadingData
    ]);
    /**
   * On content state change :
   *  - if there is no content, reset all filters and selected filters
   *  - if there is some content, set filters state with the content received or an empty array, and selectedFilters state with received data if there are some
   */ (0, $bxRTa.useEffect)(()=>{
        if (content) {
            if (filters.length === 0 || content.channelData?.filters !== filters) setFilters(content.channelData?.filters || []);
            content.channelData?.selectedFilters && setSelectedFilters(content.channelData?.selectedFilters);
        } else totalReset();
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)($138ade36c671bdf6$export$52411773e0d6f15d.Provider, {
            value: value,
            children: children
        })
    });
}

});


parcelRegister("b3Gke", function(module, exports) {

$parcel$export(module.exports, "default", () => $858b6e1300531d73$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");

var $7SHCs = parcelRequire("7SHCs");

var $4mkhB = parcelRequire("4mkhB");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $lTDDB = parcelRequire("lTDDB");

var $c1Gdf = parcelRequire("c1Gdf");

var $eGQaF = parcelRequire("eGQaF");

var $64pvK = parcelRequire("64pvK");

var $fBNj2 = parcelRequire("fBNj2");

var $cdF3t = parcelRequire("cdF3t");

var $lKGM8 = parcelRequire("lKGM8");

var $k4qlo = parcelRequire("k4qlo");
const $858b6e1300531d73$var$springEnterDuration = 1500;
const $858b6e1300531d73$var$springLeaveDuration = 2500;
const $858b6e1300531d73$var$List = ({ activity: activity, onClose: onClose })=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const { content: content, filters: filters, selectedFilters: selectedFilters, setContent: setContent } = (0, $4mkhB.useList)();
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const lastListActivity = (0, $4xGiN.useUtilsStore)((state)=>state.lastListActivity);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const closeList = (0, $4xGiN.useUtilsStore)((state)=>state.closeList);
    const { setLastListActivity: setLastListActivity, setListStatus: setListStatus } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const [mobileFiltersOpened, setMobileFiltersOpened] = (0, $bxRTa.useState)(false);
    const [largeFilterOpenedKey, setLargeFilterOpenedKey] = (0, $bxRTa.useState)(undefined);
    const scrollRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)'
            }
        }));
    const timerRef = (0, $bxRTa.useRef)(null);
    const divRef = (0, $bxRTa.useRef)(null);
    const [abortController, setAbortController] = (0, $bxRTa.useState)(null);
    (0, $bxRTa.useEffect)(()=>{
        closeList && handleClose();
    }, [
        closeList
    ]);
    const handleOpen = ()=>{
        setListStatus((0, $2rYkD.ListStatus).opened);
        api.start({
            from: {
                transform: 'translateX(-100%)'
            },
            to: {
                transform: 'translateX(0%)'
            },
            config: {
                duration: $858b6e1300531d73$var$springEnterDuration,
                easing: (0, $2aMjv.easings).easeInBack
            }
        });
    };
    const handleClose = ()=>{
        setListStatus((0, $2rYkD.ListStatus).closing);
        api.start({
            from: {
                transform: 'translateX(0%)'
            },
            to: {
                transform: 'translateX(-100%)'
            },
            config: {
                duration: $858b6e1300531d73$var$springLeaveDuration,
                easing: (0, $2aMjv.easings).easeOutExpo
            }
        });
        if (timerRef) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                sendEvent('Davi.CloseWindow', null, ()=>sendEvent('Davi.CloseWindowList', null));
                onClose?.();
                setContent(undefined);
            }, $858b6e1300531d73$var$springLeaveDuration);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        if (activity?.id !== lastListActivity) {
            setContent(activity);
            if (listStatus !== (0, $2rYkD.ListStatus).opened && timerRef.current) {
                clearTimeout(timerRef.current);
                handleOpen();
            }
        }
        return ()=>{
            activity?.id && setLastListActivity(activity.id);
        };
    }, [
        activity
    ]);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        if (divRef?.current && isWidget) {
            if (currentDeviceType === (0, $2rYkD.DeviceType).widget) {
                const ab = new AbortController();
                setAbortController(ab);
                (0, $k4qlo.default)(null, divRef, ab.signal);
            } else {
                abortController?.abort();
                setAbortController(null);
            }
        }
    }, [
        divRef?.current,
        currentDeviceType
    ]);
    /**
   * On content change :
   *  - call scrollToRef method
   */ (0, $bxRTa.useEffect)(()=>{
        const timer = content && isMobile && content.label !== 'Davi.NextPageContent' ? setTimeout(()=>{
            scrollToRef();
        }, 100) : null;
        return ()=>{
            timer && clearTimeout(timer);
        };
    }, [
        content
    ]);
    (0, $bxRTa.useEffect)(()=>{
        handleOpen();
        return ()=>{
            setListStatus((0, $2rYkD.ListStatus).closed);
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, []);
    return content ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $lTDDB.default), {
        className: useOldRemote ? 'large:rf-px-16 rf-flex rf-flex-col large:rf-h-full' : 'rf-z-[20] large:rf-px-16 rf-flex rf-flex-col large:rf-h-full',
        handleClose: handleClose,
        onClick: isMobile ? ()=>{} : ()=>setLargeFilterOpenedKey(undefined),
        remoteCloseButtonZIndex: "rf-z-list",
        animation: spring,
        children: [
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $64pvK.default), {
                setFiltersOpened: setMobileFiltersOpened,
                handleClose: handleClose,
                hasFilters: !!filters.length
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: divRef,
                className: "rf-w-full rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: scrollRef
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: `${mobileFiltersOpened ? 'rf-hidden' : 'rf-flex'} rf-flex-col rf-items-start large:rf-pt-16 large:rf-h-full large-vertical:rf-pt-[20vh]`,
                        children: [
                            content.text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c1Gdf.default), {
                                className: "rf-ml-2 rf-mt-8 large:rf-ml-0 large:rf-mt-0",
                                title: (0, $eO5xw.capitalizeFirstLetter)(content.text, locale),
                                numberOfResults: content.channelData?.numberOfResults || 0
                            }),
                            !isMobile && filters.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $eGQaF.default), {
                                openedFilterKey: largeFilterOpenedKey,
                                setOpenedFilterKey: setLargeFilterOpenedKey
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
                            isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-flex rf-flex-row rf-mx-2 rf-gap-2 rf-mb-2 rf-flex-wrap",
                                children: selectedFilters?.map((chosenFilter, key1)=>{
                                    return chosenFilter.filterItems.map((item, key2)=>{
                                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fBNj2.default), {
                                            className: "rf-px-2",
                                            filterItem: item,
                                            parent: {
                                                id: chosenFilter.id,
                                                title: chosenFilter.title
                                            }
                                        }, `${key1}-${key2}`);
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cdF3t.default), {
                                hasFilterOrSuggestedAction: filters.length > 0 || content.suggestedActions?.actions?.length > 0,
                                numberOfResults: content.channelData?.numberOfResults || 0
                            }),
                            content.suggestedActions?.actions?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lKGM8.default), {
                                className: "rf-px-2 large:rf-px-0 large:rf-mb-4",
                                suggestions: content.suggestedActions.actions
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
                            isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: mode === (0, $2rYkD.Mode).text ? 'rf-mb-28' : 'rf-mb-16'
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {})
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $858b6e1300531d73$export$2e2bcd8739ae039 = $858b6e1300531d73$var$List;

});
parcelRegister("c1Gdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8042787564bbd0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");
const $8a8042787564bbd0$var$Title = ({ className: className, title: title, numberOfResults: numberOfResults })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-mb-4 rf-flex rf-flex-col rf-items-start rf-justify-center large:rf-flex-row large:rf-items-baseline large:rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold",
                children: title
            }),
            numberOfResults !== undefined && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-text-gray large:rf-ml-4",
                children: [
                    numberOfResults,
                    " ",
                    numberOfResults > 1 ? translation.common.results : translation.common.result
                ]
            })
        ]
    });
};
var $8a8042787564bbd0$export$2e2bcd8739ae039 = $8a8042787564bbd0$var$Title;

});

parcelRegister("eGQaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a588f5267b0b3c0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $fBNj2 = parcelRequire("fBNj2");

var $ZFnWC = parcelRequire("ZFnWC");
const $2a588f5267b0b3c0$var$FilterLarge = ({ className: className, openedFilterKey: openedFilterKey, setOpenedFilterKey: setOpenedFilterKey })=>{
    const { filters: filters, selectedFilters: selectedFilters } = (0, $4mkhB.useList)();
    const closeOpenedFilters = (key)=>{
        setOpenedFilterKey(key);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-relative rf-flex rf-flex-row rf-flex-wrap",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ZFnWC.default), {
                        identifier: key + 1,
                        opened: (openedFilterKey && key + 1 === openedFilterKey) === true,
                        filter: filter,
                        closeOpenedFilters: closeOpenedFilters
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-my-2 rf-flex-wrap",
                children: selectedFilters?.map((chosenFilter, key1)=>{
                    return chosenFilter.filterItems.map((item, key2)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fBNj2.default), {
                            className: "rf-px-4 rf-mr-2 rf-mb-1",
                            filterItem: item,
                            parent: {
                                id: chosenFilter.id,
                                title: chosenFilter.title
                            }
                        }, `${key1}-${key2}`);
                    });
                })
            })
        ]
    });
};
var $2a588f5267b0b3c0$export$2e2bcd8739ae039 = $2a588f5267b0b3c0$var$FilterLarge;

});
parcelRegister("fBNj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be35d345816489c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $2eBYD = parcelRequire("2eBYD");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $4be35d345816489c$var$ChosenItem = ({ className: className, filterItem: filterItem, parent: parent })=>{
    const { processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-py-1 rf-text-size-auto rf-text-white rf-bg-gray hover:rf-cursor-pointer rf-rounded-lg rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        onClick: ()=>processFiltersOnChange([
                {
                    ...parent,
                    filterItems: [
                        filterItem
                    ]
                }
            ]),
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-mr-2 large:rf-mr-3",
                children: parent.id === 'Event.DateRange' ? `${filterItem.name.substring(8, 10)}/${filterItem.name.substring(5, 7)}/${filterItem.name.substring(0, 4)}` : (0, $eO5xw.capitalizeFirstLetter)(filterItem.name, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                className: "rf-h-3 rf-w-3"
            })
        ]
    });
};
var $4be35d345816489c$export$2e2bcd8739ae039 = $4be35d345816489c$var$ChosenItem;

});

parcelRegister("ZFnWC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b4bb84dbb1ade4e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");
parcelRequire("hNqlv");
var $1NaGJ = parcelRequire("1NaGJ");
var $1dNUX = parcelRequire("1dNUX");

var $eO5xw = parcelRequire("eO5xw");

var $13Gjm = parcelRequire("13Gjm");

var $jN7Hy = parcelRequire("jN7Hy");

var $20yCl = parcelRequire("20yCl");
const $6b4bb84dbb1ade4e$var$FilterItem = ({ className: className, identifier: identifier, opened: opened, filter: filter, closeOpenedFilters: closeOpenedFilters })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        opened ? setStyle('rf-bg-truewhite rf-text-black rf-border-black') : setStyle('rf-bg-templateBackground rf-text-gray rf-border-gray');
    }, [
        opened
    ]);
    const handleOpen = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        closeOpenedFilters(opened ? undefined : identifier);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-mt-1",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-px-4 rf-py-3 rf-mr-4 large-vertical:rf-py-4 ${style} rf-border rf-rounded-lg hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
                onClick: (e)=>handleOpen(e),
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mr-3",
                        children: (0, $eO5xw.capitalizeFirstLetter)(filter.title, locale)
                    }),
                    opened ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1dNUX.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1NaGJ.default), {})
                ]
            }),
            opened && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-left-0 rf-top-110 rf-z-util rf-w-max rf-py-1 rf-px-4 rf-text-black rf-border rf-rounded-lg rf-border-black rf-bg-truewhite rf-flex rf-flex-col rf-items-center rf-justify-center",
                style: {
                    transform: filter.id === 'Event.DateRange' && !isMobile ? 'translate(-20%, -20%) scale(0.6, 0.6)' : ''
                },
                children: filter.id === 'Event.DateRange' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $20yCl.default), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jN7Hy.default), {
                            fullParent: filter
                        }),
                        filter.filterItems.map((item, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $13Gjm.default), {
                                filterItem: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $6b4bb84dbb1ade4e$export$2e2bcd8739ae039 = $6b4bb84dbb1ade4e$var$FilterItem;

});
parcelRegister("hNqlv", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => (parcelRequire("1NaGJ")).default);
$parcel$export(module.exports, "ArrowLeftIcon", () => (parcelRequire("4QFhT")).default);
$parcel$export(module.exports, "ArrowRightIcon", () => (parcelRequire("dH58k")).default);
$parcel$export(module.exports, "ArrowUpIcon", () => (parcelRequire("1dNUX")).default);

var $1NaGJ = parcelRequire("1NaGJ");

var $jSDhU = parcelRequire("jSDhU");

var $67LuN = parcelRequire("67LuN");

var $4QFhT = parcelRequire("4QFhT");

var $dH58k = parcelRequire("dH58k");

var $1dNUX = parcelRequire("1dNUX");

});
parcelRegister("1NaGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a314903fe03abb5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $3a314903fe03abb5$var$ArrowDownIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || 'currentColor',
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M14 11.18 24.6.58a2 2 0 0 1 2.82 0 2.02 2.02 0 0 1 0 2.84l-12 12a2 2 0 0 1-2.76.05L.58 3.44A2 2 0 0 1 3.41.6Z"
        })
    });
};
var $3a314903fe03abb5$export$2e2bcd8739ae039 = $3a314903fe03abb5$var$ArrowDownIcon;

});

parcelRegister("jSDhU", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c86177602ef72c59$var$ArrowIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.776 39.197",
        className: className || 'rf-h-6 rf-w-8',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(9.939 -0.321) rotate(17)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M28.156,0S31.392,28.156,0,28.156",
                    transform: "translate(5.721 0)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M0,0,8.8,8.8l8.8-8.8",
                    transform: "translate(8.688 18.779) rotate(81)",
                    fill: "none",
                    stroke: color || '#1999b1',
                    strokeLinecap: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $c86177602ef72c59$export$2e2bcd8739ae039 = $c86177602ef72c59$var$ArrowIcon;

});

parcelRegister("67LuN", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $bc72cd2d205d9489$var$ArrowIconReversed = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.776 39.197",
        className: className || 'rf-h-6 rf-w-8',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            transform: "translate(21.888, 0) scale(-1, 1) translate(-21.888, 0)",
            children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                transform: "translate(9.939 -0.321) rotate(17)",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M28.156,0S31.392,28.156,0,28.156",
                        transform: "translate(5.721 0)",
                        fill: "none",
                        stroke: color || '#1999b1',
                        strokeLinecap: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M0,0,8.8,8.8l8.8-8.8",
                        transform: "translate(8.688 18.779) rotate(81)",
                        fill: "none",
                        stroke: color || '#1999b1',
                        strokeLinecap: "round",
                        strokeWidth: "2"
                    })
                ]
            })
        })
    });
};
var $bc72cd2d205d9489$export$2e2bcd8739ae039 = $bc72cd2d205d9489$var$ArrowIconReversed;

});

parcelRegister("4QFhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1b69a12e8d41e5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6c1b69a12e8d41e5$var$ArrowLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || 'currentColor',
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 17l-5-5m0 0l5-5m-5 5h12"
        })
    });
};
var $6c1b69a12e8d41e5$export$2e2bcd8739ae039 = $6c1b69a12e8d41e5$var$ArrowLeftIcon;

});

parcelRegister("dH58k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6467fe3ae78e93be$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6467fe3ae78e93be$var$ArrowRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || 'currentColor',
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7l5 5m0 0l-5 5m5-5H6"
        })
    });
};
var $6467fe3ae78e93be$export$2e2bcd8739ae039 = $6467fe3ae78e93be$var$ArrowRightIcon;

});

parcelRegister("1dNUX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7c557cd0b218f8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $bf7c557cd0b218f8$var$ArrowUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || 'currentColor',
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $bf7c557cd0b218f8$export$2e2bcd8739ae039 = $bf7c557cd0b218f8$var$ArrowUpIcon;

});


parcelRegister("13Gjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7100240842796ad6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $2eBYD = parcelRequire("2eBYD");

var $eO5xw = parcelRequire("eO5xw");

var $bCTGs = parcelRequire("bCTGs");
const $7100240842796ad6$var$SubFilter = ({ className: className, filterItem: filterItem, parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const checked = (0, $bxRTa.useMemo)(()=>{
        if (selectedFilters.length) {
            const check = selectedFilters.filter((filter)=>filter.title === parent.title && filter.filterItems.find((item)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined);
            return !!check.length;
        }
        return false;
    }, [
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $eO5xw.capitalizeFirstLetter)(filterItem.name, locale),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bCTGs.default), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: checked,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...parent,
                            filterItems: [
                                filterItem
                            ]
                        }
                    ])
            })
        ]
    });
};
var $7100240842796ad6$export$2e2bcd8739ae039 = $7100240842796ad6$var$SubFilter;

});
parcelRegister("bCTGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22d6e24a3b46ad8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("kMAJU");
var $kA2rN = parcelRequire("kA2rN");
const $f22d6e24a3b46ad8$var$CheckBox = ({ className: className, iconClassName: iconClassName, checked: checked, onClick: onClick })=>{
    const [bgColor, setBgColor] = (0, $bxRTa.useState)(checked ? 'rf-bg-secondary' : 'rf-bg-truewhite');
    (0, $bxRTa.useEffect)(()=>{
        setBgColor(checked ? 'rf-bg-secondary' : 'rf-bg-truewhite');
    }, [
        checked
    ]);
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-6 rf-h-6 rf-min-w-6 rf-min-h-6 rf-flex rf-justify-center rf-items-center rf-border rf-border-templateCheckboxBorder hover:rf-cursor-pointer ${bgColor} ${className}`,
        onClick: (e)=>handleClick(e),
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
            className: iconClassName
        })
    });
};
var $f22d6e24a3b46ad8$export$2e2bcd8739ae039 = $f22d6e24a3b46ad8$var$CheckBox;

});


parcelRegister("jN7Hy", function(module, exports) {

$parcel$export(module.exports, "default", () => $75dfc0cde415847c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $2eBYD = parcelRequire("2eBYD");

var $eO5xw = parcelRequire("eO5xw");

var $bCTGs = parcelRequire("bCTGs");
const $75dfc0cde415847c$var$SubFilterAll = ({ className: className, fullParent: fullParent })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-py-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $eO5xw.capitalizeFirstLetter)(translation.common.all, locale),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bCTGs.default), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: selectedFilters.filter((filter)=>filter.title === fullParent.title && filter.filterItems.length === fullParent.filterItems.length).length === 1,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...fullParent
                        }
                    ], true)
            })
        ]
    });
};
var $75dfc0cde415847c$export$2e2bcd8739ae039 = $75dfc0cde415847c$var$SubFilterAll;

});

parcelRegister("20yCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7dca0dabbffe41$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $f9SqX = parcelRequire("f9SqX");
const $ec7dca0dabbffe41$var$SubFilterCalendar = ({ parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const handleCalendarChange = (newDate)=>{
        processFiltersOnChange([
            {
                ...parent,
                filterItems: [
                    {
                        name: newDate,
                        value: newDate
                    }
                ]
            }
        ]);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f9SqX.default), {
            id: "filterCalendar",
            handleChange: handleCalendarChange,
            defaultValue: selectedFilters.find((filter)=>filter.id === 'Event.DateRange' && filter.filterItems.length > 0)?.filterItems[0].name.substring(0, 11),
            isFilter: true
        })
    });
};
var $ec7dca0dabbffe41$export$2e2bcd8739ae039 = $ec7dca0dabbffe41$var$SubFilterCalendar;

});
parcelRegister("f9SqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $458e84cda88f0199$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $680es = parcelRequire("680es");
var $but28 = parcelRequire("but28");

var $kpSTr = parcelRequire("kpSTr");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("7Jjoy");
var $3kuIS = parcelRequire("3kuIS");
var $iyJo4 = parcelRequire("iyJo4");
/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $458e84cda88f0199$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $458e84cda88f0199$var$InputCalendar = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, handleChange: handleChange, isFilter: isFilter })=>{
    const locale = (0, $680es.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [year, setYear] = (0, $bxRTa.useState)(new Date().getFullYear());
    const [month, setMonth] = (0, $bxRTa.useState)(new Date().getMonth() + 1);
    const [day, setDay] = (0, $bxRTa.useState)(new Date().getDate());
    const [maxYear, setMaxYear] = (0, $bxRTa.useState)(0);
    const [minYear, setMinYear] = (0, $bxRTa.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $bxRTa.useState)(12);
    const [minMonth, setMinMonth] = (0, $bxRTa.useState)(1);
    const [maxDay, setMaxDay] = (0, $bxRTa.useState)(31);
    const [minDay, setMinDay] = (0, $bxRTa.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [date, setDate] = (0, $bxRTa.useState)(values.get(id) || `${year}-${month}-${day}`);
    /**
   * On month / year states change :
   *  - calculate and return the number of days of the current month
   */ const days = (0, $bxRTa.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $458e84cda88f0199$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    /**
   * On month / year states change :
   *  - check which day is the first day of the month
   *  - return the number of days of week before the first one of the month
   */ const emptyDays = (0, $bxRTa.useMemo)(()=>{
        const firstDay = new Date(year, month - 1, 1).toLocaleString('fr-FR', {
            weekday: 'long'
        });
        switch(firstDay.toLowerCase()){
            case 'lundi':
                return 0;
            case 'mardi':
                return 1;
            case 'mercredi':
                return 2;
            case 'jeudi':
                return 3;
            case 'vendredi':
                return 4;
            case 'samedi':
                return 5;
            case 'dimanche':
                return 6;
        }
        return 0;
    }, [
        month,
        year
    ]);
    const title = (0, $bxRTa.useMemo)(()=>{
        const newDate = new Date(year, month - 1, 1);
        return (0, $eO5xw.capitalizeFirstLetter)(new Date(newDate).toLocaleString(locale, {
            month: 'long',
            year: 'numeric'
        }));
    }, [
        month,
        year
    ]);
    /**
   * On locale change :
   *  - translate the days of week to display depending on the locale
   */ const daysOfWeek = (0, $bxRTa.useMemo)(()=>{
        let tempArray = [];
        for(let i = 1; i < 8; i++){
            // First day of May 2023 is monday, let's get each day one after another beginning by monday
            const newDate = new Date(2023, 4, i);
            tempArray = [
                ...tempArray,
                (0, $eO5xw.capitalizeFirstLetter)(newDate.toLocaleString(locale, {
                    weekday: 'short'
                }))
            ];
        }
        return tempArray;
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $bxRTa.useEffect)(()=>{
        const dateAsArray = (0, $kpSTr.getDateAsArray)(values.get(id) || defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        setDate(`${dateAsArray[0]}-${dateAsArray[1]}-${dateAsArray[2]}`);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if the date is in the boundaries of minDate / maxDate
   *  - set the value in localStorage
   */ (0, $bxRTa.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        // Explode date to extract each value and substract 1 to the month (begins at 0 in js Date object)
        const dateAsArray = date.split('-');
        const newDate = new Date(parseInt(dateAsArray[0]), parseInt(dateAsArray[1]) - 1, parseInt(dateAsArray[2]));
        if (minValue && minValueAsDate && newDate < minValueAsDate) {
            setDay(minDay);
            setMonth(minMonth);
            setYear(minYear);
            setDate(minValue);
        } else if (maxValue && maxValueAsDate && newDate > maxValueAsDate) {
            setDay(maxDay);
            setMonth(maxMonth);
            setYear(maxYear);
            setDate(maxValue);
        } else // Save date
        id !== 'filterCalendar' && (0, $9P0Ec.setValue)(id, date);
    }, [
        date
    ]);
    const handlePreviousMonth = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            if (year > minYear) {
                setMonth((month)=>month === 1 ? 12 : month - 1);
                month === 1 && setYear((year)=>year - 1);
            } else if (year === minYear && month > minMonth) month > 1 && setMonth((month)=>month - 1);
        }
    };
    const handleNextMonth = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            if (year < maxYear) {
                setMonth((month)=>month === 12 ? 1 : month + 1);
                month === 12 && setYear((year)=>year + 1);
            } else if (year === maxYear && month < maxMonth) month < 12 && setMonth((month)=>month + 1);
        }
    };
    const handleClick = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setDay(value);
            setDate(`${year}-${month}-${value}`);
            id === 'filterCalendar' && handleChange?.(`${year}-${month < 10 ? '0' : ''}${month}-${value < 10 ? '0' : ''}${value}`);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-px-2 rf-flex rf-flex-col rf-rounded-lg ${isFilter ? 'rf-text-trueblack' : 'rf-text-truewhite'} rf-subtitle-size-auto rf-unselectable`,
        style: {
            background: isFilter ? '#FFF' : 'rgba(0, 0, 0, 0.5)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-px-4 rf-py-6 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handlePreviousMonth();
                        },
                        children: (year > minYear || year === minYear && month > minMonth) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3kuIS.default), {
                            className: "rf-h-4",
                            color: isFilter ? '#000' : '#FFF'
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: `rf-width-fill-available rf-text-center rf-title-size-auto ${isFilter ? 'rf-text-secondary' : 'rf-text-primary'}`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleNextMonth();
                        },
                        children: (year < maxYear || year === maxYear && month < maxMonth) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                            className: "rf-h-4",
                            color: isFilter ? '#000' : '#FFF'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-py-6 rf-grid rf-grid-cols-7 rf-gap-4",
                children: [
                    daysOfWeek.map((weekDay, key)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-flex rf-justify-center rf-items-center rf-aspect-square",
                            children: weekDay
                        }, key);
                    }),
                    [
                        ...Array(emptyDays)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-aspect-square",
                            children: e || '\u2800'
                        }, (key + 1) * 10);
                    }),
                    [
                        ...Array(days)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: `rf-flex rf-justify-center rf-items-center rf-aspect-square ${key + 1 === day && parseInt(date.split('-')[1]) === month && parseInt(date.split('-')[0]) === year ? `rf-font-bold rf-text-trueblack ${isFilter ? 'rf-bg-secondary' : 'rf-bg-primary'} rf-rounded-half` : year === maxYear && month === maxMonth && key + 1 > maxDay ? 'rf-text-formInputRadioCheckboxUncheckedBackground' : 'rf-cursor-pointer'}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                handleClick(key + 1);
                            },
                            children: e || key + 1
                        }, (key + 1) * 100);
                    })
                ]
            })
        ]
    });
};
var $458e84cda88f0199$export$2e2bcd8739ae039 = $458e84cda88f0199$var$InputCalendar;

});
parcelRegister("f4klx", function(module, exports) {

$parcel$export(module.exports, "useCurrentSubView", () => (parcelRequire("f6Xnj")).default);
$parcel$export(module.exports, "useUnlockClickedButton", () => (parcelRequire("7xSOB")).default);
$parcel$export(module.exports, "useLocale", () => (parcelRequire("680es")).default);
$parcel$export(module.exports, "useIsRTL", () => (parcelRequire("h0xwd")).default);
$parcel$export(module.exports, "useTranslation", () => (parcelRequire("gxeI6")).default);
$parcel$export(module.exports, "useCurrentValue", () => (parcelRequire("4Zu5g")).default);
$parcel$export(module.exports, "useValues", () => (parcelRequire("but28")).default);
$parcel$export(module.exports, "useIsMobile", () => (parcelRequire("ftSpM")).default);
$parcel$export(module.exports, "useThemeColors", () => (parcelRequire("517WC")).default);
$parcel$export(module.exports, "useIsUsedOnBorne", () => (parcelRequire("5OuKI")).default);
$parcel$export(module.exports, "useEnableDocumentPrinting", () => (parcelRequire("6AR3O")).default);

var $f6Xnj = parcelRequire("f6Xnj");

var $fvifn = parcelRequire("fvifn");

var $hqQWd = parcelRequire("hqQWd");

var $7xSOB = parcelRequire("7xSOB");

var $680es = parcelRequire("680es");

var $h0xwd = parcelRequire("h0xwd");

var $gxeI6 = parcelRequire("gxeI6");

var $4Zu5g = parcelRequire("4Zu5g");

var $but28 = parcelRequire("but28");

var $ftSpM = parcelRequire("ftSpM");

var $cGvNv = parcelRequire("cGvNv");

var $lRhSi = parcelRequire("lRhSi");

var $517WC = parcelRequire("517WC");

var $7craI = parcelRequire("7craI");

var $3grkP = parcelRequire("3grkP");

var $1gjkL = parcelRequire("1gjkL");

var $dXqZ1 = parcelRequire("dXqZ1");

var $lbJSZ = parcelRequire("lbJSZ");

var $l2LtX = parcelRequire("l2LtX");

var $5OuKI = parcelRequire("5OuKI");

var $aECtX = parcelRequire("aECtX");

var $6AR3O = parcelRequire("6AR3O");

var $lQU3g = parcelRequire("lQU3g");

var $2E4sw = parcelRequire("2E4sw");

});
parcelRegister("f6Xnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $eccbad72ba0d7637$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $eccbad72ba0d7637$var$useCurrentSubView = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $2rYkD.CurrentSubView).none);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_currentSubView', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_currentSubView'));
        return ()=>{
            document.removeEventListener('retorik_currentSubView', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $eccbad72ba0d7637$export$2e2bcd8739ae039 = $eccbad72ba0d7637$var$useCurrentSubView;

});

parcelRegister("fvifn", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $15499adbaa6d13ef$var$useKioskParameterOpening = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(0);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_askedForKioskParametersOpening', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_askedForKioskParametersOpening'));
        return ()=>{
            document.removeEventListener('retorik_askedForKioskParametersOpening', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $15499adbaa6d13ef$export$2e2bcd8739ae039 = $15499adbaa6d13ef$var$useKioskParameterOpening;

});

parcelRegister("hqQWd", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $4a79f956c4b70684$var$useRetorikEvent = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(undefined);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_retorikEvent', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_retorikEvent'));
        return ()=>{
            document.removeEventListener('retorik_retorikEvent', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $4a79f956c4b70684$export$2e2bcd8739ae039 = $4a79f956c4b70684$var$useRetorikEvent;

});

parcelRegister("7xSOB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a109e2b0f2a399a$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $4a109e2b0f2a399a$var$useUnlockClickedButton = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(true);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_unlockClickedButton', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_unlockClickedButton'));
        return ()=>{
            document.removeEventListener('retorik_unlockClickedButton', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $4a109e2b0f2a399a$export$2e2bcd8739ae039 = $4a109e2b0f2a399a$var$useUnlockClickedButton;

});

parcelRegister("680es", function(module, exports) {

$parcel$export(module.exports, "default", () => $65aba44f1f006b87$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $65aba44f1f006b87$var$useLocale = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)('fr-FR');
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_locale', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_locale'));
        return ()=>{
            document.removeEventListener('retorik_locale', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $65aba44f1f006b87$export$2e2bcd8739ae039 = $65aba44f1f006b87$var$useLocale;

});

parcelRegister("h0xwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $25dce51cfe3b7644$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $25dce51cfe3b7644$var$useIsRTL = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isRTL', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isRTL'));
        return ()=>{
            document.removeEventListener('retorik_isRTL', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $25dce51cfe3b7644$export$2e2bcd8739ae039 = $25dce51cfe3b7644$var$useIsRTL;

});

parcelRegister("gxeI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f6e43a91b8b1d0$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("2hYPB");
var $72eSH = parcelRequire("72eSH");
const $76f6e43a91b8b1d0$var$useTranslation = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, (/*@__PURE__*/$parcel$interopDefault($72eSH))));
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_translation', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_translation'));
        return ()=>{
            document.removeEventListener('retorik_translation', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $76f6e43a91b8b1d0$export$2e2bcd8739ae039 = $76f6e43a91b8b1d0$var$useTranslation;

});

parcelRegister("4Zu5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fc42339098f4095$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $0fc42339098f4095$var$useCurrentValue = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(undefined);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_currentValue', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_currentValue'));
        return ()=>{
            document.removeEventListener('retorik_currentValue', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $0fc42339098f4095$export$2e2bcd8739ae039 = $0fc42339098f4095$var$useCurrentValue;

});

parcelRegister("but28", function(module, exports) {

$parcel$export(module.exports, "default", () => $2799a46b4bf8d2a8$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $2799a46b4bf8d2a8$var$useValues = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(new Map());
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_values', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_values'));
        return ()=>{
            document.removeEventListener('retorik_values', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $2799a46b4bf8d2a8$export$2e2bcd8739ae039 = $2799a46b4bf8d2a8$var$useValues;

});

parcelRegister("ftSpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $557bc5ab6089f8fa$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $557bc5ab6089f8fa$var$useIsMobile = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isMobile', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isMobile'));
        return ()=>{
            document.removeEventListener('retorik_isMobile', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $557bc5ab6089f8fa$export$2e2bcd8739ae039 = $557bc5ab6089f8fa$var$useIsMobile;

});

parcelRegister("cGvNv", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $d3530005f67af227$var$useIsWidget = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isWidget', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isWidget'));
        return ()=>{
            document.removeEventListener('retorik_isWidget', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $d3530005f67af227$export$2e2bcd8739ae039 = $d3530005f67af227$var$useIsWidget;

});

parcelRegister("lRhSi", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $3baf3ec5ddd2bbba$var$useIsTactile = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isTactile', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isTactile'));
        return ()=>{
            document.removeEventListener('retorik_isTactile', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $3baf3ec5ddd2bbba$export$2e2bcd8739ae039 = $3baf3ec5ddd2bbba$var$useIsTactile;

});

parcelRegister("517WC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe23951c4219024$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $7j7nS = parcelRequire("7j7nS");
const $7fe23951c4219024$var$useThemeColors = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $7j7nS.defaultThemeDark));
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_themeColors', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_themeColors'));
        return ()=>{
            document.removeEventListener('retorik_themeColors', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $7fe23951c4219024$export$2e2bcd8739ae039 = $7fe23951c4219024$var$useThemeColors;

});

parcelRegister("7craI", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $a51c1a855c7da240$var$useActiveRecognitionState = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $2rYkD.RecognitionState).Closed);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_activeRecognitionState', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_activeRecognitionState'));
        return ()=>{
            document.removeEventListener('retorik_activeRecognitionState', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $a51c1a855c7da240$export$2e2bcd8739ae039 = $a51c1a855c7da240$var$useActiveRecognitionState;

});

parcelRegister("3grkP", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $2745467ede20441e$var$useMode = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)((0, $2rYkD.Mode).text);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_mode', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_mode'));
        return ()=>{
            document.removeEventListener('retorik_mode', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $2745467ede20441e$export$2e2bcd8739ae039 = $2745467ede20441e$var$useMode;

});

parcelRegister("1gjkL", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $364f5050553dbd09$var$useMuted = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_muted', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_muted'));
        return ()=>{
            document.removeEventListener('retorik_muted', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $364f5050553dbd09$export$2e2bcd8739ae039 = $364f5050553dbd09$var$useMuted;

});

parcelRegister("dXqZ1", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $d5d524d74dc0db7d$var$useLoaderClosed = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_loaderClosed', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_loaderClosed'));
        return ()=>{
            document.removeEventListener('retorik_loaderClosed', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $d5d524d74dc0db7d$export$2e2bcd8739ae039 = $d5d524d74dc0db7d$var$useLoaderClosed;

});

parcelRegister("lbJSZ", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $97a5db449eb3f1a7$var$useConfiguration = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)({});
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_configuration', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_configuration'));
        return ()=>{
            document.removeEventListener('retorik_configuration', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $97a5db449eb3f1a7$export$2e2bcd8739ae039 = $97a5db449eb3f1a7$var$useConfiguration;

});

parcelRegister("l2LtX", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $43f7e3aac226ec2e$var$useSendBoxRef = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(null);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_sendBoxRef', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_sendBoxRef'));
        return ()=>{
            document.removeEventListener('retorik_sendBoxRef', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $43f7e3aac226ec2e$export$2e2bcd8739ae039 = $43f7e3aac226ec2e$var$useSendBoxRef;

});

parcelRegister("5OuKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $77444f6cb9655f3f$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $77444f6cb9655f3f$var$useIsUsedOnBorne = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_isUsedOnBorne', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_isUsedOnBorne'));
        return ()=>{
            document.removeEventListener('retorik_isUsedOnBorne', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $77444f6cb9655f3f$export$2e2bcd8739ae039 = $77444f6cb9655f3f$var$useIsUsedOnBorne;

});

parcelRegister("aECtX", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $3d6e1990faa9300b$var$useInputHintBehaviour = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(undefined);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_inputHintBehaviour', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_inputHintBehaviour'));
        return ()=>{
            document.removeEventListener('retorik_inputHintBehaviour', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $3d6e1990faa9300b$export$2e2bcd8739ae039 = $3d6e1990faa9300b$var$useInputHintBehaviour;

});

parcelRegister("6AR3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd246c35edfbfe1$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");
const $5fd246c35edfbfe1$var$useEnableDocumentPrinting = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_enableDocumentPrinting', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_enableDocumentPrinting'));
        return ()=>{
            document.removeEventListener('retorik_enableDocumentPrinting', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $5fd246c35edfbfe1$export$2e2bcd8739ae039 = $5fd246c35edfbfe1$var$useEnableDocumentPrinting;

});

parcelRegister("lQU3g", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $22882023547f3d80$var$useConversationId = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(null);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_conversationId', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_conversationId'));
        return ()=>{
            document.removeEventListener('retorik_conversationId', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $22882023547f3d80$export$2e2bcd8739ae039 = $22882023547f3d80$var$useConversationId;

});

parcelRegister("2E4sw", function(module, exports) {

var $bxRTa = parcelRequire("bxRTa");
const $07eaaabf5bd7b352$var$useRetrievingConversation = (instanceId)=>{
    const [current, setCurrent] = (0, $bxRTa.useState)(false);
    const handleChange = (e)=>{
        if (instanceId) e.detail.instanceId === instanceId && setCurrent(e.detail.value);
        else setCurrent(e.detail.value);
    };
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_retrievingConversation', (e)=>handleChange(e));
        // Dispatch event on mount to get the updated value in stead of the default one
        document.dispatchEvent(new Event('retorik_call_retrievingConversation'));
        return ()=>{
            document.removeEventListener('retorik_retrievingConversation', (e)=>handleChange(e));
        };
    }, []);
    return current;
};
var $07eaaabf5bd7b352$export$2e2bcd8739ae039 = $07eaaabf5bd7b352$var$useRetrievingConversation;

});


parcelRegister("kpSTr", function(module, exports) {

$parcel$export(module.exports, "getDateAsArray", () => $fc9b9a51d999125b$export$ffedad9fbd47bff0);
$parcel$export(module.exports, "getMonthAsString", () => $fc9b9a51d999125b$export$9e9b71dbaf488f87);
const $fc9b9a51d999125b$export$ffedad9fbd47bff0 = (dateAsString)=>{
    if (dateAsString) {
        const resultFromLocal = $fc9b9a51d999125b$var$processSplitDate(dateAsString.split('-'));
        if (resultFromLocal) return resultFromLocal;
    }
    const now = new Date();
    return [
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate()
    ];
};
const $fc9b9a51d999125b$var$processSplitDate = (splitDate)=>{
    if (splitDate.length === 3) {
        const year = parseInt(splitDate[0]);
        const month = parseInt(splitDate[1]);
        const day = parseInt(splitDate[2]);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) return [
            year,
            month,
            day
        ];
    }
    return undefined;
};
const $fc9b9a51d999125b$export$9e9b71dbaf488f87 = (month, locale)=>{
    const date = new Date(`2000-${month}-1`).toLocaleString(locale, {
        month: 'long'
    });
    return date;
};

});





parcelRegister("64pvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e05f8cc121c724$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $9JLpC = parcelRequire("9JLpC");
parcelRequire("kMAJU");
var $cxD1i = parcelRequire("cxD1i");

var $2eBYD = parcelRequire("2eBYD");

var $2mqSk = parcelRequire("2mqSk");

var $lGMuf = parcelRequire("lGMuf");

var $1RkzK = parcelRequire("1RkzK");
parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");

var $k4qlo = parcelRequire("k4qlo");
const $21e05f8cc121c724$var$FilterMobile = ({ className: className, setFiltersOpened: setFiltersOpened, handleClose: handleClose, hasFilters: hasFilters })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const { resetFilters: resetFilters } = (0, $4mkhB.useList)();
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const [open, setOpen] = (0, $bxRTa.useState)(false);
    const [currentOpened, setCurrentOpened] = (0, $bxRTa.useState)(undefined);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (divRef?.current) isWidget && (0, $k4qlo.default)(null, divRef);
    }, [
        divRef?.current
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setFiltersOpened(open);
    }, [
        open
    ]);
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleReturn = ()=>{
        setOpen(false);
    };
    const handleReset = ()=>{
        setOpen(false);
        resetFilters && resetFilters();
    };
    const closeCurrentSubFilters = ()=>{
        setCurrentOpened(undefined);
    };
    const handleDisplayResults = ()=>{
        setCurrentOpened(undefined);
        setOpen(false);
    };
    return !open ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `large:rf-hidden rf-w-full rf-py-4 rf-px-4 rf-flex rf-flex-row rf-justify-between rf-items-center rf-bg-truewhite rf-shadow-[0_0_15px_0_silver] ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                title: translation.menu.backconversation,
                handleBack: handleClose,
                className: "rf-relative rf-text-size-auto"
            }),
            hasFilters && /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-items-center rf-border rf-rounded-lg rf-border-black",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cxD1i.default), {
                        className: "rf-h-4 rf-w-4"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-ml-2",
                        children: translation.common.filter
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        ref: divRef,
        className: "rf-absolute rf-z-util large:rf-hidden rf-top-0 rf-left-0 rf-w-full rf-h-full rf-overflow-y-scroll rf-scrollbar-hidden rf-bg-truewhite rf-flex rf-flex-col rf-justify-between",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-col rf-justify-start rf-align-center",
                children: currentOpened ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lGMuf.default), {
                    filter: currentOpened,
                    close: closeCurrentSubFilters,
                    resetFilters: handleReset
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2mqSk.default), {
                    setCurrentOpened: setCurrentOpened,
                    close: handleReturn,
                    resetFilters: handleReset
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1RkzK.default), {
                onClick: handleDisplayResults
            })
        ]
    });
};
var $21e05f8cc121c724$export$2e2bcd8739ae039 = $21e05f8cc121c724$var$FilterMobile;

});
parcelRegister("2mqSk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dcc9d5929a055fc$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $2eBYD = parcelRequire("2eBYD");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("7Jjoy");
var $iyJo4 = parcelRequire("iyJo4");

var $c2Jg7 = parcelRequire("c2Jg7");
const $1dcc9d5929a055fc$var$MobileFilterPage = ({ close: close, resetFilters: resetFilters, setCurrentOpened: setCurrentOpened })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const { filters: filters, processFiltersOnChange: processFiltersOnChange } = (0, $4mkhB.useList)();
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const handleSelectAllAndOpen = (filter)=>{
        processFiltersOnChange([
            filter
        ], true);
        setCurrentOpened(filter);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c2Jg7.default), {
                title: translation.common.filter,
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: `rf-py-4 rf-text-xl rf-font-semibold rf-flex rf-justify-between rf-items-center rf-cursor-pointer ${key !== 0 && 'rf-border-t rf-border-t-[#CBC9C9]'}`,
                        onClick: ()=>setCurrentOpened(filter),
                        children: [
                            (0, $eO5xw.capitalizeFirstLetter)(filter.title, locale),
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: "rf-flex rf-items-center",
                                children: [
                                    filter.id !== 'Event.DateRange' && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-text-sm rf-text-gray rf-mr-5",
                                        onClick: ()=>handleSelectAllAndOpen(filter),
                                        children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.all, locale)
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                                        className: "rf-h-5",
                                        color: "#000"
                                    })
                                ]
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};
var $1dcc9d5929a055fc$export$2e2bcd8739ae039 = $1dcc9d5929a055fc$var$MobileFilterPage;

});
parcelRegister("c2Jg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3090dcade16d18f0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
const $3090dcade16d18f0$var$MobileUpperBand = ({ title: title, handleReset: handleReset, handleReturn: handleReturn })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-py-4 rf-px-4 rf-flex rf-justify-between rf-items-center rf-border-b rf-border-b-black",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: "rf-flex rf-flex-row rf-items-center rf-text-size-auto",
                onClick: handleReturn,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                        className: "rf-w-8"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-ml-1",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-uppercase rf-text-secondary rf-underline`,
                onClick: handleReset,
                children: translation.template.reset
            })
        ]
    });
};
var $3090dcade16d18f0$export$2e2bcd8739ae039 = $3090dcade16d18f0$var$MobileUpperBand;

});


parcelRegister("lGMuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21786dedb66e59e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $eO5xw = parcelRequire("eO5xw");

var $c2Jg7 = parcelRequire("c2Jg7");

var $13Gjm = parcelRequire("13Gjm");

var $jN7Hy = parcelRequire("jN7Hy");

var $20yCl = parcelRequire("20yCl");
const $d21786dedb66e59e$var$MobileSubFilterPage = ({ filter: filter, close: close, resetFilters: resetFilters })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c2Jg7.default), {
                title: (0, $eO5xw.capitalizeFirstLetter)(filter.title, locale),
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filter.id === 'Event.DateRange' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $20yCl.default), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jN7Hy.default), {
                            className: "rf-text-xl rf-border-b rf-border-b-silver",
                            fullParent: filter
                        }),
                        filter.filterItems.map((item, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $13Gjm.default), {
                                className: "rf-text-xl",
                                filterItem: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $d21786dedb66e59e$export$2e2bcd8739ae039 = $d21786dedb66e59e$var$MobileSubFilterPage;

});

parcelRegister("1RkzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf64b144e597cb6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");
const $aaf64b144e597cb6$var$MobileDisplayResult = ({ onClick: onClick })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-pt-8 ${mode === (0, $2rYkD.Mode).text ? 'rf-mb-30' : 'rf-mb-16'} rf-flex rf-justify-center rf-justify-self-end`,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
            className: "rf-py-4 rf-px-6 rf-font-bold rf-text-secondary rf-border-2 rf-rounded-lg rf-border-secondary",
            onClick: onClick,
            children: translation.template.showresults
        })
    });
};
var $aaf64b144e597cb6$export$2e2bcd8739ae039 = $aaf64b144e597cb6$var$MobileDisplayResult;

});

parcelRegister("9cEaH", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => (parcelRequire("4kqtJ")).default);
$parcel$export(module.exports, "Dashboard", () => (parcelRequire("9UTGN")).default);
$parcel$export(module.exports, "HistoryButton", () => (parcelRequire("CgDXB")).default);
$parcel$export(module.exports, "LanguageButton", () => (parcelRequire("3o2AQ")).default);
$parcel$export(module.exports, "MicrophoneButton", () => (parcelRequire("iqpLV")).default);
$parcel$export(module.exports, "Parameters", () => (parcelRequire("91jIt")).default);
$parcel$export(module.exports, "TutorialButton", () => (parcelRequire("2aOO4")).default);
$parcel$export(module.exports, "Version", () => (parcelRequire("lRvrG")).default);

var $4kqtJ = parcelRequire("4kqtJ");

var $9UTGN = parcelRequire("9UTGN");

var $CgDXB = parcelRequire("CgDXB");

var $3o2AQ = parcelRequire("3o2AQ");

var $iqpLV = parcelRequire("iqpLV");

var $91jIt = parcelRequire("91jIt");

var $dLhbi = parcelRequire("dLhbi");

var $2aOO4 = parcelRequire("2aOO4");

var $lRvrG = parcelRequire("lRvrG");

});
parcelRegister("4kqtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb04d93bb9fda115$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
const $cb04d93bb9fda115$var$BackButton = ({ title: title, className: className, handleBack: handleBack })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-flex rf-flex-row rf-items-center ${className}`,
        onClick: handleBack,
        "aria-label": title,
        "data-map": "fermer",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                className: "rf-w-8"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1",
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            })
        ]
    });
};
var $cb04d93bb9fda115$export$2e2bcd8739ae039 = $cb04d93bb9fda115$var$BackButton;

});

parcelRegister("9UTGN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b532675e9677f5b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");
parcelRequire("hZeqH");
var $6Vbk7 = parcelRequire("6Vbk7");

var $75jcl = parcelRequire("75jcl");

var $h0yA8 = parcelRequire("h0yA8");

var $g4PdG = parcelRequire("g4PdG");

var $f51Nf = parcelRequire("f51Nf");
parcelRequire("81HL8");
var $77wBI = parcelRequire("77wBI");

var $lRvrG = parcelRequire("lRvrG");
const $3b532675e9677f5b$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const askForKioskParametersOpening = (0, $4xGiN.useUtilsStore)((state)=>state.actions.askForKioskParametersOpening);
    const handleClick = ()=>{
        toggleDashboard?.();
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        askForKioskParametersOpening();
        toggleDashboard?.();
    };
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $g4PdG.default), {
            conditionalHandleClick: handleClick
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Vbk7.default), {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-h-full rf-max-w-7/10 rf-flex rf-flex-col rf-items-start rf-gap-8",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-min-h-2/5 rf-py-4 rf-mt-auto rf-flex rf-flex-col rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $g4PdG.default), {
                                    handleClick: toggleDashboard
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-3/10 rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f51Nf.default), {
                                    handleClick: toggleDashboard
                                })
                            })
                        ]
                    }),
                    isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $77wBI.default), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lRvrG.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: handleClick
            })
        ]
    });
};
var $3b532675e9677f5b$export$2e2bcd8739ae039 = $3b532675e9677f5b$var$Dashboard;

});
parcelRegister("75jcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88c67cf473fabee$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $d9kWL = parcelRequire("d9kWL");

var $ijq12 = parcelRequire("ijq12");
const $f88c67cf473fabee$var$AbsoluteLargeClosingButton = ({ dashboardVisible: dashboardVisible, zIndexClassname: zIndexClassname, customComponent: customComponent, onClick: onClick })=>{
    const hideMenu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.hideMenu);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    const top = (0, $d9kWL.default)();
    const [hidden, setHidden] = (0, $bxRTa.useState)(false);
    const handleHideAndClose = ()=>{
        dashboardVisible && !customComponent && setHidden(true);
        onClick();
    };
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-absolute ${hidden && 'rf-hidden'} rf-w-24 rf-flex rf-justify-center rf-right-0 ${zIndexClassname || 'rf-z-ui'}`,
        style: {
            top: hideMenu ? `calc(${top} - 6rem)` : top
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ijq12.default), {
            dashboardVisible: dashboardVisible,
            onClick: handleHideAndClose
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $f88c67cf473fabee$export$2e2bcd8739ae039 = $f88c67cf473fabee$var$AbsoluteLargeClosingButton;

});
parcelRegister("d9kWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $847d89e91d773caa$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");
const $847d89e91d773caa$var$useCloseButtonTop = ()=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const isTactile = (0, $9JLpC.useViewStore)((state)=>state.isTactile);
    const [top, setTop] = (0, $bxRTa.useState)(200);
    /**
   * On currentDeviceType change :
   *  - switch on currentDeviceType and check for tactile
   *  - set top state to the value in configuration if given, or a default one
   */ (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
                if (isTactile) setTop(configuration.remote?.desktopTactile || '9.75rem');
                else setTop(configuration.remote?.desktop || '9.75rem');
                break;
            case (0, $2rYkD.DeviceType).borne:
                setTop(configuration.remote?.verticalTactile || 'calc(50% - 11.25rem)');
                break;
            default:
                setTop(200);
                break;
        }
    }, [
        currentDeviceType
    ]);
    return top;
};
var $847d89e91d773caa$export$2e2bcd8739ae039 = $847d89e91d773caa$var$useCloseButtonTop;

});

parcelRegister("ijq12", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b80f4c7069c48f8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("dikAc");
var $6Nt3V = parcelRequire("6Nt3V");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");
const $9b80f4c7069c48f8$var$DashboardButton = ({ dashboardVisible: dashboardVisible, onClick: onClick })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        setLabel(dashboardVisible ? translation.common.close : translation.common.menu);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-18 rf-h-18 rf-mb-6 rf-flex rf-flex-col rf-justify-center rf-items-center rf-bg-truewhite ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-text-trueblack rf-border rf-border-menuBorder rf-rounded-half hover:rf-cursor-pointer rf-shadow-[0_3px_6px_#606267]`,
        "aria-label": label,
        // data-map used in interactive map to use this button externaly
        "data-map": dashboardVisible ? 'fermer' : 'dashboard',
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-uppercase",
                children: label
            }),
            dashboardVisible ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                className: "rf-h-6 rf-w-6"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Nt3V.default), {
                className: "rf-h-6 rf-w-6"
            })
        ]
    });
};
var $9b80f4c7069c48f8$export$2e2bcd8739ae039 = $9b80f4c7069c48f8$var$DashboardButton;

});
parcelRegister("dikAc", function(module, exports) {

$parcel$export(module.exports, "DashboardIcon", () => (parcelRequire("6Nt3V")).default);
$parcel$export(module.exports, "KeyboardIcon", () => (parcelRequire("9f9kU")).default);
$parcel$export(module.exports, "MicrophoneIcon", () => (parcelRequire("jWbjz")).default);
$parcel$export(module.exports, "MicrophoneIconOn", () => (parcelRequire("9HRSd")).default);

var $6Nt3V = parcelRequire("6Nt3V");

var $9f9kU = parcelRequire("9f9kU");

var $jWbjz = parcelRequire("jWbjz");

var $9HRSd = parcelRequire("9HRSd");

});
parcelRegister("6Nt3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d7b99368b57a3c6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6d7b99368b57a3c6$var$DashboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: color || 'currentColor',
        className: className || 'w-6',
        viewBox: "0 0 27.93 16.72",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M1.23 2.46a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 9.59a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 16.72a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23Z"
        })
    });
};
var $6d7b99368b57a3c6$export$2e2bcd8739ae039 = $6d7b99368b57a3c6$var$DashboardIcon;

});

parcelRegister("9f9kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d3cd23e7f10ba2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $06d3cd23e7f10ba2$var$KeyboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 22.5 15",
        className: className || 'w-6',
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_awesome-keyboard",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                        transform: "translate(0 -4.5)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-keyboard)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                            transform: "translate(0 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $06d3cd23e7f10ba2$export$2e2bcd8739ae039 = $06d3cd23e7f10ba2$var$KeyboardIcon;

});

parcelRegister("jWbjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f252c8393a08d666$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f252c8393a08d666$var$MicrophoneIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6',
        viewBox: "0 0 14.426 20.983",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_awesome-microphone",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-microphone)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $f252c8393a08d666$export$2e2bcd8739ae039 = $f252c8393a08d666$var$MicrophoneIcon;

});

parcelRegister("9HRSd", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdafa1307f3316ac$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $fdafa1307f3316ac$var$MicrophoneIconOn = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-8',
        viewBox: "0 0 21.055 18.479",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-44.181 -45.388)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(44.181 45.388)",
                    fill: color || '#ff6462'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(57.007 45.388)",
                    fill: color || '#ff6462'
                })
            ]
        })
    });
};
var $fdafa1307f3316ac$export$2e2bcd8739ae039 = $fdafa1307f3316ac$var$MicrophoneIconOn;

});




parcelRegister("h0yA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d1685fba6dad8d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");
const $72d1685fba6dad8d$var$Logo = ({ className: className })=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    return configuration.logo?.src ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-customer-logo",
        className: className || 'rf-absolute rf-m-4 large:rf-m-8 rf-top-0 rf-left-0',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
            src: configuration.logo.src,
            alt: "Logo",
            className: "rf-max-h-12 rf-max-w-16 large:rf-max-h-28 large:rf-max-w-[12rem] large-vertical:rf-max-h-36"
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $72d1685fba6dad8d$export$2e2bcd8739ae039 = $72d1685fba6dad8d$var$Logo;

});

parcelRegister("g4PdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a80b227c1ab5ab$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $kdMEA = parcelRequire("kdMEA");

var $7jXNO = parcelRequire("7jXNO");
const $c3a80b227c1ab5ab$var$DisplayViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const [finalMenu, setFinalMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $7jXNO.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined,
                    name: customCurrentMenu.name
                }));
            } else fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $7jXNO.default), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick,
                conditionalHandleClick: conditionalHandleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        const tempFinalMenu = [];
        // Basic menu
        tempFinalMenu.push(buildMenu(configuration && configuration.baseMenu ? [
            ...configuration.baseMenu
        ] : [
            ...(0, $kdMEA.DEFAULT_VIEWS)
        ]));
        // Custom menus
        if (configuration && configuration.customMenu && configuration.customMenu.length > 0) {
            if (Array.isArray(configuration.customMenu[0])) configuration.customMenu.forEach((menuArray)=>{
                tempFinalMenu.push(buildMenu(menuArray));
            });
            else tempFinalMenu.push(buildMenu(configuration.customMenu));
        }
        setFinalMenu(tempFinalMenu);
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: finalMenu.map((line, key)=>{
            return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${key === 0 && 'rf-pb-4'} rf-flex rf-flex-col rf-items-center`,
                children: [
                    key !== 0 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-6 -rf-mx-6 rf-width-fill-available rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                    }),
                    line.map((e, subkey)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                            children: e
                        }, subkey);
                    })
                ]
            }, key) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                children: line.map((e, subkey)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: e
                    }, subkey);
                })
            }, key);
        })
    });
};
var $c3a80b227c1ab5ab$export$2e2bcd8739ae039 = $c3a80b227c1ab5ab$var$DisplayViews;

});
parcelRegister("7jXNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f44689844fae488$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $1ABKz = parcelRequire("1ABKz");
function $1f44689844fae488$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $1f44689844fae488$var$DisplayGenerator = (props)=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const { setCurrentCustomView: setCurrentCustomView, setCurrentSubView: setCurrentSubView } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    const [colorButtonHandle, setColorButtonHandle] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($1f44689844fae488$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let colorButtonHandle = '';
        // Handle hospitality menu icon color
        if ($1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(props) && props.name) {
            if (props.name.toString().indexOf('whatToDo') > -1) colorButtonHandle = themeColors.tobeDoneColor;
            else if (props.name.toString().indexOf('localProducts') > -1) colorButtonHandle = themeColors.localProductsColor;
            else if (props.name.toString().indexOf('whereToEat') > -1) colorButtonHandle = themeColors.whereToEatColor;
            else if (props.name.toString().indexOf('whereToSleep') > -1) colorButtonHandle = themeColors.whereToSleepColor;
            else if (props.name.toString().indexOf('whatToSee') > -1) colorButtonHandle = themeColors.tobeSeenColor;
            else if (props.name.toString().indexOf('agenda') > -1) colorButtonHandle = themeColors.agendaColor;
            else if (props.name.toString().indexOf('services') > -1) colorButtonHandle = themeColors.servicesColor;
        }
        setColorButtonHandle(colorButtonHandle);
    }, [
        label
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($1f44689844fae488$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableViews).home:
                isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
                sendEvent('showHome');
                break;
            case (0, $2rYkD.AvailableViews).news:
                setRoute((0, $2rYkD.Routes).News);
                break;
            case (0, $2rYkD.AvailableViews).weather:
                setCurrentSubView((0, $2rYkD.CurrentSubView).weather);
                break;
            case (0, $2rYkD.AvailableViews).emergency:
                setCurrentSubView((0, $2rYkD.CurrentSubView).emergency);
                break;
        }
        else if ($1f44689844fae488$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            // Display custom component if present
            if (props.customDisplay) setCurrentCustomView({
                ...props
            });
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $1f44689844fae488$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                view: props.view
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                icon: props.icon,
                className: "rf-max-h-6 rf-max-w-6 rf-flex rf-items-center",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-4 rf-font-bold",
                children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
            })
        ]
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-36 rf-w-36 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $1f44689844fae488$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                view: props.view,
                className: "rf-h-16"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                icon: props.icon,
                className: "rf-h-16 rf-w-16 rf-flex",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'} large-vertical:rf-text-basecustomuppercase`,
                children: label
            })
        ]
    });
};
var $1f44689844fae488$export$2e2bcd8739ae039 = $1f44689844fae488$var$DisplayGenerator;

});
parcelRegister("1ABKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $759207c94e1c6964$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("2l6WH");
var $hCkUC = parcelRequire("hCkUC");
var $3sPnl = parcelRequire("3sPnl");
var $jGi9r = parcelRequire("jGi9r");
var $8LI0a = parcelRequire("8LI0a");
var $jzwsO = parcelRequire("jzwsO");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $3EchS = parcelRequire("3EchS");
const $759207c94e1c6964$var$DisplayIcon = ({ view: view, icon: icon, className: className, color: color = '' })=>{
    if (view) return view === (0, $2rYkD.AvailableViews).home ? /*#__PURE__*/ (0, $fl9nK.jsx)($3sPnl.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).news ? /*#__PURE__*/ (0, $fl9nK.jsx)($8LI0a.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).weather ? /*#__PURE__*/ (0, $fl9nK.jsx)($jzwsO.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).emergency ? /*#__PURE__*/ (0, $fl9nK.jsx)($hCkUC.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).history ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).tutorial ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
        className: className
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($jGi9r.default, {
        className: className
    });
    else if (icon) return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${className} ${color !== '' ? 'svgButtonMenu' : ''}`,
        style: color !== '' ? {
            '--fill': color
        } : {},
        children: icon
    });
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {});
};
var $759207c94e1c6964$export$2e2bcd8739ae039 = $759207c94e1c6964$var$DisplayIcon;

});
parcelRegister("2l6WH", function(module, exports) {

$parcel$export(module.exports, "EmergencyIcon", () => (parcelRequire("hCkUC")).default);
$parcel$export(module.exports, "HomeIcon", () => (parcelRequire("3sPnl")).default);
$parcel$export(module.exports, "InteractiveMapIcon", () => (parcelRequire("jGi9r")).default);
$parcel$export(module.exports, "NewsChannelIcon", () => (parcelRequire("8LI0a")).default);
$parcel$export(module.exports, "WeatherIcon", () => (parcelRequire("jzwsO")).default);

var $hCkUC = parcelRequire("hCkUC");

var $3sPnl = parcelRequire("3sPnl");

var $jGi9r = parcelRequire("jGi9r");

var $8LI0a = parcelRequire("8LI0a");

var $jzwsO = parcelRequire("jzwsO");

});
parcelRegister("hCkUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c0edcfeef079ee$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c5c0edcfeef079ee$var$EmergencyIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            fill: color || '#1999B1',
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M294.4,182.4h34.1v34.1c0,3.9,3.1,7,7,7h47c3.9,0,7-3.1,7-7v-34.1h34.1c3.9,0,7-3.1,7-7v-47c0-3.9-3.1-7-7-7h-34.1V87.3     c0-3.9-3.1-7-7-7h-47c-3.9,0-7,3.1-7,7v34.1h-34.1c-3.9,0-7,3.1-7,7v47C287.4,179.3,290.6,182.4,294.4,182.4z M301.4,135.4h34.1     c3.9,0,7-3.1,7-7V94.3h33v34.1c0,3.9,3.1,7,7,7h34.1v33h-34.1c-3.9,0-7,3.1-7,7v34.1h-33v-34.1c0-3.9-3.1-7-7-7h-34.1V135.4z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M218.1,285.1c0.1,3.8,3.2,6.8,6.9,6.8c0.9,0,95.2,1.1,133.1,1.1c78.5,0,142.5-63.9,142.5-142.5S436.7,8.2,358.1,8.2     c-78.5,0-142.5,63.9-142.5,142.5C215.7,186.8,218.1,284.2,218.1,285.1z M358.1,22.2c70.8,0,128.5,57.6,128.5,128.5     S429,279.1,358.1,279.1c-31.9,0-103.8-0.8-126.2-1c-0.5-22.8-2.3-97-2.3-127.4C229.7,79.8,287.3,22.2,358.1,22.2z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M191.5,94c1,0.5,2,0.7,3,0.7c2.6,0,5.1-1.5,6.3-4c0.2-0.4,21.5-45.1,51-70.9c2.9-2.5,3.2-7,0.7-9.9c-2.5-2.9-7-3.2-9.9-0.7     c-31.8,27.7-53.6,73.5-54.5,75.5C186.5,88.2,188,92.3,191.5,94z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M176.6,60.1c1.1,0.6,2.2,0.8,3.3,0.8c2.5,0,4.9-1.3,6.2-3.7c0.1-0.2,13.2-24.6,27.9-36.4c3-2.4,3.5-6.8,1.1-9.8     c-2.4-3-6.8-3.5-9.8-1.1c-16.9,13.6-30.9,39.6-31.5,40.7C171.9,54.1,173.2,58.3,176.6,60.1z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M490.2,255.8c-0.3,0.4-34.6,36.1-70.7,51.3c-3.6,1.5-5.2,5.6-3.7,9.2c1.1,2.7,3.7,4.3,6.5,4.3c0.9,0,1.8-0.2,2.7-0.5     c38.9-16.3,73.9-53,75.4-54.6c2.7-2.8,2.5-7.2-0.3-9.9S492.8,253,490.2,255.8z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M503.6,292.4c-2.7-2.8-7.1-2.9-9.9-0.2c-0.2,0.2-20.3,19.2-37.9,25.8c-3.6,1.4-5.5,5.4-4.1,9c1.1,2.8,3.7,4.5,6.6,4.5     c0.8,0,1.6-0.1,2.5-0.4c20.3-7.6,41.8-27.9,42.7-28.8C506.2,299.6,506.3,295.2,503.6,292.4z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M490.2,372.5c-1.6-0.5-40.7-13.2-71.4,4c-16,9-26.7,24.2-31.6,45.4c-12.9,55-48.2,58-85.6,52l17.2-10     c18.4-10.7,24.7-34.4,14-52.8L302.5,359c-10.7-18.4-34.4-24.7-52.8-14l-36.7,21.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-6.4,4-17.1,1.6     c-12.6-2.7-32.6-14.3-56.7-53.7c-22-39.9-22.4-62.9-18.8-75.2c3.1-10.5,9.4-14.3,10.1-14.7c0.2-0.1,0.2-0.1,0.4-0.2l36.7-21.3     c18.4-10.7,24.7-34.4,14-52.8L151,98.2c-10.7-18.4-34.4-24.7-52.8-14L60.8,106c-0.1,0-0.2,0.1-0.2,0.1c-1.5,1-38.1,24.6-48.6,67     C-4,237.2,63,350,65.9,354.7c0.3,0.6,0.8,1.1,1.2,1.5c0.1,0.6,0.4,1.2,0.7,1.8c2.7,4.8,67.5,118.9,131,136.8     c42.1,11.8,80.7-8.2,82.3-9c0.1,0,0.2-0.1,0.2-0.1l2.4-1.4c0.7,0.5,1.6,0.9,2.5,1c12.3,2.5,25.9,4.8,39.4,4.8     c8.5,0,17-0.9,25.2-3.4c25.4-7.6,42.2-28.3,50-61.7c4-17.1,12.3-29.3,24.8-36.3c25.3-14.2,59.9-3.1,60.2-3c3.7,1.2,7.6-0.8,8.8-4.4     C495.9,377.7,493.9,373.8,490.2,372.5z M256.8,357.2c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.5,5.5     c-39.1-34.5-52.5-80.7-55.8-94.2L256.8,357.2z M202.6,481.4C144.7,465.1,80.7,352.3,80,351.2c-0.4-0.6-0.8-1.2-1.3-1.7     c-0.2-0.7-0.4-1.4-0.8-2c-0.7-1.1-66.9-112.5-52.4-171c8.9-35.9,40.5-57.3,42.4-58.5l14.6-8.5c1.8,7,5.2,18,10.9,30.9     c1.6,3.5,5.7,5.1,9.2,3.6c0.2-0.1,0.5-0.2,0.7-0.4c3-1.8,4.3-5.6,2.9-8.9c-6.6-14.8-9.8-27-11.1-32.6l10.1-5.9     c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.6,5.6c-11.1-9.9-21-21.4-29.5-34.5c-2.1-3.2-6.4-4.1-9.7-2     c-3.2,2.1-4.1,6.5-2,9.7c8.3,12.7,17.9,24.2,28.6,34.2l-14.2,8.2c-2.2,1.1-12.1,7-16.9,22.3c-6.6,21-0.5,49.1,18,83.7     c0.2,0.5,0.4,1,0.6,1.4c0.4,0.7,0.8,1.3,1.2,2c0.4,0.7,0.7,1.3,1.1,2c0.3,0.5,0.6,0.9,0.9,1.3c20.9,33.2,42.3,52.4,63.8,57.1     c15.7,3.4,25.7-2.3,27.7-3.6l13.7-7.9c4.7,18.1,19,60.2,55.7,94.3l-15.1,8.8C272.4,474.6,238.4,491.5,202.6,481.4z"
                })
            ]
        })
    });
};
var $c5c0edcfeef079ee$export$2e2bcd8739ae039 = $c5c0edcfeef079ee$var$EmergencyIcon;

});

parcelRegister("3sPnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138c260f10ee542$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $2138c260f10ee542$var$HomeIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M39.908,31.05l-4.784-4.784V21.032a.312.312,0,0,0-.312-.312H31.887a.312.312,0,0,0-.312.312v1.685L27.72,18.861a.312.312,0,0,0-.441,0L15.091,31.05a.312.312,0,1,0,.441.441L17.925,29.1V42.483a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V35.97h4.252v6.514a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V29.1l2.393,2.393a.312.312,0,1,0,.441-.441ZM32.2,21.344h2.3v4.3l-2.3-2.3Zm4.252,20.827h-6.2V35.658a.312.312,0,0,0-.312-.312H25.062a.312.312,0,0,0-.312.312v6.514h-6.2v-13.7L27.5,19.523l4.167,4.167h0l2.925,2.925h0l1.859,1.859Z",
            transform: "translate(-15 -18.77)",
            fill: color || '#1999b1'
        })
    });
};
var $2138c260f10ee542$export$2e2bcd8739ae039 = $2138c260f10ee542$var$HomeIcon;

});

parcelRegister("jGi9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $470bea3d78e84fc8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $470bea3d78e84fc8$var$InteractiveMapIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                fill: color || '#1999B1',
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M256,93.297c-14.021,0-27.516,4.218-39.025,12.198c-3.402,2.359-4.262,7.05-1.921,10.478   c2.342,3.428,6.998,4.294,10.4,1.936c9.004-6.243,19.566-9.543,30.546-9.543c29.754,0,53.96,24.388,53.96,54.365   c0,29.977-24.206,54.366-53.96,54.366c-29.754,0-53.96-24.389-53.96-54.366c0-8.843,2.038-17.273,6.057-25.055   c1.906-3.692,0.482-8.241-3.182-10.161c-3.665-1.919-8.178-0.486-10.085,3.206c-5.067,9.812-7.746,20.881-7.746,32.01   C187.085,201.018,218,232.166,256,232.166s68.915-31.148,68.915-69.435C324.915,124.445,294,93.297,256,93.297z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                fill: color || '#1999B1',
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M511.426,501.571l-73.804-178.665c-1.16-2.809-3.883-4.639-6.903-4.639h-73.547   c14.305-19.498,26.212-38.919,35.511-57.988c16.48-33.794,24.835-66.613,24.835-97.547C417.517,73.001,345.061,0,256,0   S94.483,73.001,94.483,162.731c0,30.934,8.355,63.754,24.835,97.547c9.298,19.069,21.205,38.491,35.511,57.988H81.282   c-3.02,0-5.744,1.831-6.903,4.639L24.087,444.651c-1.587,3.842,0.217,8.252,4.03,9.85c0.94,0.394,1.912,0.581,2.87,0.581   c2.93,0,5.711-1.746,6.906-4.641l7.176-17.372h50.906l-26.38,63.862H18.69l7.647-18.513c1.587-3.842-0.217-8.252-4.03-9.85   c-3.815-1.601-8.191,0.219-9.777,4.06L0.575,501.571c-0.961,2.325-0.705,4.981,0.683,7.075c1.386,2.095,3.72,3.354,6.22,3.354   h497.044c2.499,0,4.834-1.259,6.221-3.354C512.13,506.552,512.387,503.896,511.426,501.571z M109.439,162.731   c0-81.422,65.747-147.663,146.561-147.663S402.561,81.31,402.561,162.731c0,34.143-11.775,88.703-66.245,158.231   c-0.055,0.065-0.104,0.134-0.156,0.201c-2.782,3.547-5.672,7.132-8.681,10.757c-29.932,36.062-60.222,62.395-71.48,71.751   c-11.225-9.324-41.372-35.525-71.283-71.518c-3.084-3.711-6.042-7.38-8.889-11.01c-0.046-0.058-0.089-0.118-0.137-0.175   C121.222,251.445,109.439,196.887,109.439,162.731z M86.269,333.335h50.907l-18.568,44.948H67.702L86.269,333.335z   M129.997,496.932l46.741-113.148l133.014,113.148H129.997z M332.935,496.932L332.935,496.932l-154.352-131.3   c-1.822-1.551-4.27-2.132-6.584-1.566c-2.316,0.565-4.228,2.21-5.143,4.427l-53.057,128.438H85.795l28.296-68.502   c0.961-2.325,0.705-4.98-0.683-7.075c-1.386-2.095-3.721-3.354-6.221-3.354H51.296l10.182-24.65h62.118   c3.02,0,5.744-1.831,6.903-4.639l22.876-55.377h12.978c2.253,2.83,4.543,5.661,6.894,8.491   c38.585,46.43,76.578,76.239,78.177,77.486c1.348,1.051,2.962,1.575,4.576,1.575s3.229-0.525,4.576-1.575   c0.879-0.685,12.757-10.009,29.673-25.96h84.681c4.13,0,7.478-3.373,7.478-7.534s-3.348-7.534-7.478-7.534h-69.269   c10.368-10.503,21.7-22.749,33.093-36.457c2.351-2.83,4.642-5.66,6.894-8.491h80.083l18.567,44.948h-39.457   c-4.13,0-7.478,3.373-7.478,7.534s3.347,7.534,7.478,7.534h45.681l10.182,24.65h-154.07c-3.121,0-5.913,1.952-7.006,4.898   c-1.091,2.946-0.253,6.265,2.104,8.326l75.133,65.707H332.935z M399.681,496.932l-73.024-63.862H466.93l26.381,63.862H399.681z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("g", {})
        ]
    });
};
var $470bea3d78e84fc8$export$2e2bcd8739ae039 = $470bea3d78e84fc8$var$InteractiveMapIcon;

});

parcelRegister("8LI0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $87efea18457e1d13$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $87efea18457e1d13$var$NewsChannelIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        className: className || 'rf-h-6 rf-w-6',
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            fill: color || '#1999B1',
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M500.9,13.5H325.3c-3.9,0-7,3.1-7,7v142.4c0,3.9,3.1,7,7,7h39.6v41.4c0,2.7,1.6,5.2,4,6.3c0.9,0.4,2,0.7,3,0.7     c1.6,0,3.2-0.6,4.5-1.6l55.5-46.8h68.9c3.9,0,7-3.1,7-7V20.5C507.9,16.6,504.8,13.5,500.9,13.5z M493.9,155.9h-64.5     c-1.6,0-3.2,0.6-4.5,1.6l-46,38.7v-33.4c0-3.9-3.1-7-7-7h-39.6V27.5h161.6V155.9z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M386.2,66h28.2c3.9,0,7-3.1,7-7s-3.1-7-7-7h-28.2c-3.9,0-7,3.1-7,7S382.3,66,386.2,66z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M436.7,66h32.6c3.9,0,7-3.1,7-7s-3.1-7-7-7h-32.6c-3.9,0-7,3.1-7,7S432.8,66,436.7,66z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M355.6,98.5h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,98.5,355.6,98.5z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M355.6,130.8h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,130.8,355.6,130.8z"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M335.4,277.7c-17-4.2-47.9-12.2-60.2-15.4c0.7-1.7,0.7-3.6-0.1-5.4c-0.9-2-2.6-3.5-4.7-4l-40.8-10.2v-12.9     c18.6-11.3,32.3-30.3,37-52.8h12.9c12.1,0,21.9-9.8,21.9-21.9s-9.8-21.9-21.9-21.9h-12c4.4-7.2,16.2-28.5,16.6-48.9     c0.4-26.5-29.5-49.5-37.6-53.3c-1.1-0.5-2.8-1.6-4.9-2.8c-10-5.9-28.6-16.9-50.6-16.9c-32.8,0.1-55.2,25-56.1,26.1     c-0.4,0.5-0.8,1-1,1.6C112,43.2,95.5,62.5,95.5,85.6c0,3.1,0.3,6.3,0.9,9.5c0.1,0.4,0.2,0.9,0.4,1.3l14.7,36.8h-9.8     c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9h12.9c4.7,22.5,18.4,41.5,36.9,52.8v12.9l-40.8,10.2c-2.1,0.5-3.9,2-4.7,4     c-0.8,1.8-0.8,3.8,0,5.5l-62.7,16.7c0,0-0.1,0-0.1,0c-1.1,0.3-26.8,8.1-26.8,42.2v140.6c0,0.3,0,0.6,0.1,0.8     c1.8,14.9,12.5,43,40.2,43h299.3c3.9,0,7-3.1,7-7l0-177.9C362.9,319.3,362.1,284.3,335.4,277.7z M258.1,264.3l-29.1,52l-25.1-27.9     c16.2-5.9,23.6-21.6,25.5-31.3L258.1,264.3z M287.4,155.1c0,4.4-3.5,7.9-7.9,7.9h-11.2c0-1,0.1-2.1,0.1-3.1c0-4.4-0.2-8.6-0.6-12.7     h11.7C283.9,147.2,287.4,150.7,287.4,155.1z M109.5,85.6c0-18.5,15.1-33.6,33.6-33.6c12.2,0,23.5,6.7,29.4,17.4     c1.9,3.4,6.1,4.6,9.5,2.7c3.4-1.9,4.6-6.1,2.7-9.5c-6.6-12-18-20.4-31.1-23.4c8-6.1,21.3-13.9,37.3-13.9c18.2,0,34,9.3,43.4,14.9     c2.5,1.5,4.4,2.6,6.1,3.4c5.1,2.4,29.8,21.3,29.6,40.4c-0.2,11.4-5.1,23.7-9.4,32.4c-2.6-6.8-5.8-13.6-9.8-20.7     c-1.1-2-3.1-3.3-5.4-3.5c-2.2-0.2-4.5,0.6-6,2.3c-0.2,0.2-20,22.1-49,22.2c-28.9-0.2-48.8-22-49-22.2c-1.5-1.7-3.7-2.6-6-2.3     c-2.3,0.2-4.3,1.5-5.4,3.5c-4.2,7.4-7.5,14.4-10.1,21.5l-10.1-25.4C109.7,89.8,109.5,87.6,109.5,85.6z M101.7,163     c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9h11.7c-0.4,4.1-0.6,8.3-0.6,12.7c0,1,0,2.1,0.1,3.1H101.7z M126.8,159.9     c0-17.8,3.5-33,11.5-49.3c9.5,7.9,27.7,19.9,51.7,20.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0     c24-0.3,42.3-12.3,51.7-20.2c8,16.3,11.5,31.5,11.5,49.3c0,36.8-28.6,66.8-63.8,67C155.4,226.7,126.8,196.7,126.8,159.9z     M189.5,240.9c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.7,0c8.3-0.2,16.3-1.7,23.9-4.4v17.8     c-0.8,3.5-5.8,22.1-25,22.3c-19.3-0.2-24.3-18.9-25.1-22.3v-17.9C173,239.2,181.1,240.7,189.5,240.9z M151.8,257.1     c1.9,9.7,9.3,25.4,25.5,31.3l-25.1,27.9l-29.1-52L151.8,257.1z M209.4,445.8c2.1,0.8,8.2,4.2,8.2,16.5v29.4h-53.8v-45.9H209.4z     M208.3,369.8h-34.6v-15.2c0-9.5,7.8-17.3,17.3-17.3s17.3,7.8,17.3,17.3V369.8z M219.9,383.8V403H159v-19.3H219.9z M199.9,417v14.8     h-18.8V417H199.9z M348.9,491.7h-56.1V381.6c0-3.9-3.1-7-7-7s-7,3.1-7,7v110.1h-47.2v-29.4c0-13-5.1-20.5-9.3-24.5     c-3.2-3-6.4-4.5-8.4-5.2V417h13c3.9,0,7-3.1,7-7v-33.3c0-3.9-3.1-7-7-7h-4.6v-15.2c0-17.3-14-31.3-31.3-31.3s-31.3,14-31.3,31.3     v15.2H152c-3.9,0-7,3.1-7,7V410c0,3.9,3.1,7,7,7h15.2v14.8h-65.8v-49.8c0-3.9-3.1-7-7-7s-7,3.1-7,7v56.8c0,3.9,3.1,7,7,7h55.5v45.9     H56.6c-21.1,0-25.7-26.6-26.3-30.3V321.3c0-23.1,15.7-28.4,16.6-28.7l66-17.5l31.7,56.6c1.1,2,3.1,3.3,5.3,3.5c0.3,0,0.5,0,0.8,0     c2,0,3.9-0.8,5.2-2.3l34.5-38.4l34.5,38.4c1.3,1.5,3.2,2.3,5.2,2.3c0.3,0,0.5,0,0.8,0c2.2-0.2,4.2-1.6,5.3-3.5l31.8-56.7     c8.6,2.2,44.9,11.7,63.9,16.4c15.9,3.9,16.8,28.5,16.8,29.6V491.7z"
                })
            ]
        })
    });
};
var $87efea18457e1d13$export$2e2bcd8739ae039 = $87efea18457e1d13$var$NewsChannelIcon;

});

parcelRegister("jzwsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9a4c7b4247af9c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $5c9a4c7b4247af9c$var$WeatherIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            fill: color || '#1999B1',
            children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M439.2,385.3c0.7-3.5,1-7,1-10.6c0-31.2-25.4-56.5-56.5-56.5c-6.5,0-13,1.1-19.1,3.3c-1.4-3.6-3-7.1-4.8-10.4      C392,287.3,411,249.8,411,209.6c0-69.5-56.5-126-126-126c-69.5,0-126,56.5-126,126c0,5.7,0.4,11.3,1.1,16.9      c-16.7,9.5-30,24.6-37.2,43c-5.5-1.9-11.4-2.9-17.3-2.9c-29.1,0-52.7,23.6-52.7,52.7c0,3.2,0.3,6.4,0.9,9.5      c-20.8,10.3-34.5,31.8-34.5,55.3c0,34,27.6,61.6,61.6,61.6c0.7,0.2,1.4,0.3,2.1,0.3h26.1c2.9,15.6,10.3,29.9,21.6,41.4      c14.2,14.4,33,22.8,53.2,23.7c0.8,0.3,1.6,0.4,2.5,0.4h221.5c0.8,0,1.5-0.1,2.2-0.3c0,0,0.1,0,0.1,0c36.5,0,66.2-29.7,66.2-66.2      C476.6,419.5,461.8,396.3,439.2,385.3z M173.1,209.6c0-61.7,50.2-112,112-112s112,50.2,112,112c0,35.4-16.7,68.5-44.8,89.6      c-17-22.6-44-36.7-73.4-36.7c-0.1,0-0.1,0-0.2,0c-14.3-28.8-43.8-47.2-76.2-47.2c-10,0-19.7,1.8-28.8,5.1      C173.3,216.7,173.1,213.2,173.1,209.6z M85.4,432c-0.8-0.3-1.7-0.4-2.5-0.4c-0.6,0-1.2,0-1.8,0c-26.3,0-47.6-21.4-47.6-47.6      c0-19.8,12.5-37.8,31.1-44.7c3.5-1.3,5.4-5.1,4.3-8.6c-1.1-3.7-1.7-7.6-1.7-11.5c0-21.3,17.4-38.7,38.7-38.7      c6.3,0,12.6,1.6,18.2,4.5c1.9,1,4.1,1.1,6,0.3c1.9-0.8,3.4-2.5,4-4.5c8.6-30.4,36.8-51.6,68.4-51.6c25.2,0,48.2,13.3,61,34.5      c-42.5,7.2-75.1,43.8-76.2,88c-43.7,0.3-79.2,35.9-79.2,79.7c0,0.2,0,0.4,0,0.6H85.4z M410.3,497.2c-0.7,0-1.3,0-2-0.1      c-0.9,0-1.8,0.1-2.6,0.4H188.9c-0.7-0.2-1.4-0.4-2.2-0.4c-17.4-0.3-33.6-7.2-45.8-19.6c-12.2-12.4-18.9-28.8-18.9-46.1      c0-36.2,29.5-65.7,65.7-65.7c1.9,0,3.9,0.1,6,0.3c2,0.2,4-0.5,5.5-1.9s2.2-3.4,2.1-5.4c-0.1-1.6-0.1-3.1-0.1-4.5      c0-42.8,34.8-77.7,77.7-77.7c34.6,0,65.3,23.2,74.7,56.4c0.6,2,2,3.7,4,4.5c1.9,0.8,4.2,0.7,6-0.3c6.1-3.3,13-5,20-5      c23.5,0,42.5,19.1,42.5,42.5c0,4.3-0.6,8.6-1.9,12.6c-1.1,3.6,0.8,7.3,4.3,8.6c20.4,7.6,34.1,27.2,34.1,49      C462.6,473.8,439.2,497.2,410.3,497.2z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M485.4,203.6H443c-3.9,0-7,3.1-7,7s3.1,7,7,7h42.4c3.9,0,7-3.1,7-7S489.3,203.6,485.4,203.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M84.6,217.6h42.4c3.9,0,7-3.1,7-7s-3.1-7-7-7H84.6c-3.9,0-7,3.1-7,7S80.7,217.6,84.6,217.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M284.7,58.9c3.9,0,7-3.1,7-7V9.5c0-3.9-3.1-7-7-7s-7,3.1-7,7v42.4C277.7,55.7,280.8,58.9,284.7,58.9z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M360,79.4c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5l21.2-36.7c1.9-3.3,0.8-7.6-2.6-9.6      s-7.6-0.8-9.6,2.6l-21.2,36.7C355.5,73.2,356.7,77.4,360,79.4z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M199.7,76.8c1.3,2.2,3.6,3.5,6.1,3.5c1.2,0,2.4-0.3,3.5-0.9c3.3-1.9,4.5-6.2,2.6-9.6l-21.2-36.7      c-1.9-3.3-6.2-4.5-9.6-2.6s-4.5,6.2-2.6,9.6L199.7,76.8z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M107.8,116.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2      c-3.3-1.9-7.6-0.8-9.6,2.6S104.5,114.7,107.8,116.6z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M422.3,138.7c1.2,0,2.4-0.3,3.5-0.9l36.7-21.2c3.3-1.9,4.5-6.2,2.6-9.6c-1.9-3.3-6.2-4.5-9.6-2.6l-36.7,21.2      c-3.3,1.9-4.5,6.2-2.6,9.6C417.5,137.5,419.9,138.7,422.3,138.7z"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M416.5,286.6c-1.9,3.3-0.8,7.6,2.6,9.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5      c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2C422.8,282.1,418.5,283.3,416.5,286.6z"
                    })
                ]
            })
        })
    });
};
var $5c9a4c7b4247af9c$export$2e2bcd8739ae039 = $5c9a4c7b4247af9c$var$WeatherIcon;

});


parcelRegister("81HL8", function(module, exports) {

$parcel$export(module.exports, "BorneParametersIcon", () => (parcelRequire("77wBI")).default);
$parcel$export(module.exports, "HistoryIcon", () => (parcelRequire("2ogpH")).default);
$parcel$export(module.exports, "LanguageIcon", () => (parcelRequire("k1ioo")).default);
$parcel$export(module.exports, "TutorialIcon", () => (parcelRequire("3EchS")).default);

var $77wBI = parcelRequire("77wBI");

var $2ogpH = parcelRequire("2ogpH");

var $k1ioo = parcelRequire("k1ioo");

var $ikTA6 = parcelRequire("ikTA6");

var $3EchS = parcelRequire("3EchS");

});
parcelRegister("77wBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $501757403cd6fe1d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $501757403cd6fe1d$var$BorneParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M218.9,43.9l-2.6,13.3l-9.7,48.5c-15.6,6.1-29.6,14.7-42.3,25l-47.4-16.3l-12.8-4.1l-6.6,11.7L64.9,178   l-6.6,11.7l9.7,8.7l36.7,32.1c-1.3,8.4-3.1,16.7-3.1,25.5c0,8.8,1.7,17.1,3.1,25.5l-36.7,32.1l-9.7,8.7l6.6,11.7l32.6,56.1l6.6,11.7   l12.8-4.1l47.4-16.3c12.8,10.3,26.8,18.9,42.3,25l9.7,48.5l2.6,13.3h91.8l2.6-13.3l9.7-48.5c15.6-6.1,29.6-14.7,42.3-25l47.4,16.3   l12.8,4.1l6.6-11.7l32.6-56.1l6.6-11.7l-9.7-8.7l-36.7-32.1c1.3-8.4,3.1-16.7,3.1-25.5c0-8.8-1.7-17.1-3.1-25.5l36.7-32.1l9.7-8.7   l-6.6-11.7l-32.6-56.1l-6.6-11.7l-12.8,4.1l-47.4,16.3c-12.8-10.3-26.8-18.9-42.3-25l-9.7-48.5l-2.6-13.3H218.9z M245.4,76.5h38.8   l8.2,42.3l2,9.7l9.2,3.1c18.6,5.8,35.4,15.6,49.5,28.6l7.1,6.6l9.2-3.1l41.3-14.3l19.4,33.2l-32.6,29.1l-7.7,6.1l2.6,9.7   c2.1,9.3,3.1,18.8,3.1,28.6c0,9.8-1,19.3-3.1,28.6l-2,9.7l7.1,6.1l32.6,29.1l-19.4,33.2l-41.3-14.3l-9.2-3.1l-7.1,6.6   c-14.1,12.9-30.9,22.8-49.5,28.6l-9.2,3.1l-2,9.7l-8.2,42.3h-38.8l-8.2-42.3l-2-9.7l-9.2-3.1c-18.6-5.8-35.4-15.6-49.5-28.6   l-7.1-6.6l-9.2,3.1l-41.3,14.3l-19.4-33.2l32.6-29.1l7.7-6.1l-2.6-9.7c-2.1-9.3-3.1-18.8-3.1-28.6c0-9.8,1-19.3,3.1-28.6l2.6-9.7   l-7.7-6.1l-32.6-29.1l19.4-33.2l41.3,14.3l9.2,3.1l7.1-6.6c14.1-12.9,30.9-22.8,49.5-28.6l9.2-3.1l2-9.7L245.4,76.5z M264.8,174.4   c-44.9,0-81.6,36.7-81.6,81.6s36.7,81.6,81.6,81.6s81.6-36.7,81.6-81.6S309.7,174.4,264.8,174.4z M264.8,207.1c27.2,0,49,21.7,49,49   s-21.7,49-49,49c-27.2,0-49-21.7-49-49S237.6,207.1,264.8,207.1z",
            fill: color || '#95989E'
        })
    });
};
var $501757403cd6fe1d$export$2e2bcd8739ae039 = $501757403cd6fe1d$var$BorneParametersIcon;

});

parcelRegister("2ogpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae2ca89bd3bc4a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $b9ae2ca89bd3bc4a$var$HistoryIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-w-6 rf-flex-1',
        viewBox: "0 0 14 14",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_awesome-history",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                        transform: "translate(-0.563 -0.563)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-history)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                            transform: "translate(-0.56 -0.56)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $b9ae2ca89bd3bc4a$export$2e2bcd8739ae039 = $b9ae2ca89bd3bc4a$var$HistoryIcon;

});

parcelRegister("k1ioo", function(module, exports) {

$parcel$export(module.exports, "default", () => $490a1fc41ac7f76d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $490a1fc41ac7f76d$var$LanguageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || 'w-6',
        viewBox: "0 0 21 21",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M13.49,3A10.5,10.5,0,1,0,24,13.5,10.495,10.495,0,0,0,13.49,3Zm7.277,6.3h-3.1A16.432,16.432,0,0,0,16.22,5.562,8.431,8.431,0,0,1,20.766,9.3ZM13.5,5.142A14.791,14.791,0,0,1,15.505,9.3H11.494A14.791,14.791,0,0,1,13.5,5.142ZM5.373,15.6a8.213,8.213,0,0,1,0-4.2H8.922a17.341,17.341,0,0,0-.147,2.1,17.341,17.341,0,0,0,.147,2.1Zm.861,2.1h3.1a16.432,16.432,0,0,0,1.449,3.738A8.386,8.386,0,0,1,6.234,17.7Zm3.1-8.4h-3.1A8.386,8.386,0,0,1,10.78,5.562,16.432,16.432,0,0,0,9.331,9.3ZM13.5,21.858A14.791,14.791,0,0,1,11.494,17.7h4.011A14.791,14.791,0,0,1,13.5,21.858ZM15.957,15.6H11.043a15.448,15.448,0,0,1-.168-2.1,15.314,15.314,0,0,1,.168-2.1h4.914a15.314,15.314,0,0,1,.168,2.1A15.448,15.448,0,0,1,15.957,15.6Zm.262,5.838A16.431,16.431,0,0,0,17.668,17.7h3.1a8.431,8.431,0,0,1-4.546,3.738ZM18.078,15.6a17.341,17.341,0,0,0,.147-2.1,17.341,17.341,0,0,0-.147-2.1h3.549a8.213,8.213,0,0,1,0,4.2Z",
            transform: "translate(-3 -3)",
            fill: color || '#90939a'
        })
    });
};
var $490a1fc41ac7f76d$export$2e2bcd8739ae039 = $490a1fc41ac7f76d$var$LanguageIcon;

});

parcelRegister("ikTA6", function(module, exports) {

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $81a46a941b9f337b$var$ParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 27.005 27.012",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_ionic-ios-settings",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                        transform: "translate(-4.5 -4.5)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-settings)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                            transform: "translate(-4.5 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $81a46a941b9f337b$export$2e2bcd8739ae039 = $81a46a941b9f337b$var$ParametersIcon;

});

parcelRegister("3EchS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f924f4e5dbe76f9$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $5f924f4e5dbe76f9$var$TutorialIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || 'rf-h-6 rf-w-6',
        viewBox: "0 0 21.039 21.039",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("filter", {
                    id: "Icon_ionic-ios-help-buoy",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                "data-type": "innerShadowGroup",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        id: "Icon_ionic-ios-help-buoy-2",
                        "data-name": "Icon ionic-ios-help-buoy",
                        d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                        transform: "translate(-3.375 -3.375)",
                        fill: color || '#a4a7af'
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-help-buoy)",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                            transform: "translate(-3.38 -3.38)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $5f924f4e5dbe76f9$export$2e2bcd8739ae039 = $5f924f4e5dbe76f9$var$TutorialIcon;

});





parcelRegister("f51Nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1687bb30467378aa$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $Q1lHs = parcelRequire("Q1lHs");
const $1687bb30467378aa$var$DisplaySubViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const disableHistory = (0, $7SHCs.useRetorikStore)((state)=>state.disableHistory);
    const [subMenu, setSubMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseSubMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $Q1lHs.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else {
                // In mobile mode, we only push custom items, base items (history / tutorial) have their own render
                if (!isMobile) // Don't add "history" item if it is disabled
                {
                    if (!(disableHistory && configuration.isUsedOnBorne) || currentMenu.view !== (0, $2rYkD.AvailableSubViews).history) fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $Q1lHs.default), {
                        type: "BaseMenu",
                        indice: currentMenu.indice,
                        view: currentMenu.view,
                        device: currentDeviceType,
                        handleClick: handleClick
                    }));
                }
            }
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        // Handle custom submenus
        if (configuration?.subMenu) setSubMenu(buildMenu(configuration.subMenu));
        else setSubMenu(buildMenu((0, $kdMEA.DEFAULT_SUB_VIEWS)));
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: subMenu.map((e, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: e
            }, key);
        })
    });
};
var $1687bb30467378aa$export$2e2bcd8739ae039 = $1687bb30467378aa$var$DisplaySubViews;

});
parcelRegister("Q1lHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f0441594b75de7$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $1ABKz = parcelRequire("1ABKz");
function $32f0441594b75de7$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $32f0441594b75de7$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $32f0441594b75de7$var$DisplaySubGenerator = (props)=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const { setCurrentCustomView: setCurrentCustomView, setCurrentSubView: setCurrentSubView } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($32f0441594b75de7$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($32f0441594b75de7$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($32f0441594b75de7$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableSubViews).history:
                setCurrentSubView((0, $2rYkD.CurrentSubView).history);
                break;
            case (0, $2rYkD.AvailableSubViews).tutorial:
                console.log('Tutorial');
                break;
        }
        else if ($32f0441594b75de7$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            if (props.customDisplay) setCurrentCustomView({
                ...props
            });
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines, without icons */ /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-24 rf-w-24 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $32f0441594b75de7$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                view: props.view,
                className: "rf-h-8"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1ABKz.default), {
                icon: props.icon,
                className: "rf-h-8 rf-w-8 rf-flex"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'}`,
                children: label
            })
        ]
    });
};
var $32f0441594b75de7$export$2e2bcd8739ae039 = $32f0441594b75de7$var$DisplaySubGenerator;

});


parcelRegister("lRvrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d678f470f68632$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $3RB0m = parcelRequire("3RB0m");
const $83d678f470f68632$var$Version = ({ isMobile: isMobile })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${isMobile ? 'rf-px-5 rf-pt-6 rf-text-xsm' : 'rf-absolute rf-left-8 rf-bottom-2 rf-text-sm'} rf-text-[#A4A7AF] rf-text-sm`,
        children: `v ${(0, $3RB0m.version)}`
    });
};
var $83d678f470f68632$export$2e2bcd8739ae039 = $83d678f470f68632$var$Version;

});


parcelRegister("CgDXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb354ba306826829$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $dLhbi = parcelRequire("dLhbi");
const $eb354ba306826829$var$HistoryButton = ({ handleBack: handleBack })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const setCurrentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setCurrentSubView);
    /**
   * On call :
   *  - call parent's handleBack method if defined
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        handleBack && handleBack();
        setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).history ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).history);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dLhbi.default), {
        title: translation.history.title,
        icon: "history",
        color: currentSubView === (0, $2rYkD.CurrentSubView).history ? themeColors.secondary : '#A4A7AF',
        onClick: handleClick
    });
};
var $eb354ba306826829$export$2e2bcd8739ae039 = $eb354ba306826829$var$HistoryButton;

});
parcelRegister("dLhbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7613824d9fccf2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $13Gq4 = parcelRequire("13Gq4");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $k1ioo = parcelRequire("k1ioo");
var $3EchS = parcelRequire("3EchS");
parcelRequire("7Jjoy");
var $iyJo4 = parcelRequire("iyJo4");
const $8e7613824d9fccf2$var$ParameterButton = ({ title: title, color: color, icon: icon, onClick: onClick })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row ${icon === 'lang' ? 'rf-justify-between' : 'rf-justify-start'} rf-items-center rf-border-t rf-border-t-menuBorder rf-capitalize`,
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            title,
            icon === 'lang' && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mr-3 rf-text-lightgray rf-normal-case",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($13Gq4)))[locale]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                        className: "rf-h-4"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-width-fill-available rf-mx-3 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg",
        style: {
            color: color || '#A4A7AF',
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)',
            boxShadow: '2px 2px 6px #00000029'
        },
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            icon === 'tutorial' ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'history' ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'lang' ? /*#__PURE__*/ (0, $fl9nK.jsx)($k1ioo.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1 rf-uppercase",
                children: title
            })
        ]
    });
};
var $8e7613824d9fccf2$export$2e2bcd8739ae039 = $8e7613824d9fccf2$var$ParameterButton;

});
parcelRegister("13Gq4", function(module, exports) {
module.exports = JSON.parse('{"aa":"Qafar","aa-DJ":"Qafar (Yabuuti)","aa-ER":"Qafar (Eretria)","aa-ET":"Qafar (Otobbia)","af":"Afrikaans","af-NA":"Afrikaans (Namibi\xeb)","af-ZA":"Afrikaans (Suid-Afrika)","agq":"Aghem","agq-CM":"Aghem (K\xe0m\xe0l\xfb\u014B)","ak":"Akan","ak-GH":"Akan (Gaana)","am":"\u12A0\u121B\u122D\u129B","am-ET":"\u12A0\u121B\u122D\u129B (\u12A2\u1275\u12EE\u1335\u12EB)","ar":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629","ar-001":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0639\u0627\u0644\u0645)","ar-AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629)","ar-BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0628\u062D\u0631\u064A\u0646)","ar-DJ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u064A\u0628\u0648\u062A\u064A)","ar-DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u062C\u0632\u0627\u0626\u0631)","ar-EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0645\u0635\u0631)","ar-ER":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0625\u0631\u064A\u062A\u0631\u064A\u0627)","ar-IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0625\u0633\u0631\u0627\u0626\u064A\u0644)","ar-IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0639\u0631\u0627\u0642)","ar-JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0623\u0631\u062F\u0646)","ar-KM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631)","ar-KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0643\u0648\u064A\u062A)","ar-LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0644\u0628\u0646\u0627\u0646)","ar-LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0644\u064A\u0628\u064A\u0627)","ar-MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629)","ar-MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627)","arn":"Mapudungun","arn-CL":"Mapudungun (Chile)","ar-OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0639\u0645\u0627\u0646)","ar-PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0644\u0637\u0629 \u0627\u0644\u0641\u0644\u0633\u0637\u064A\u0646\u064A\u0629)","ar-QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0642\u0637\u0631)","ar-SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","ar-SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0648\u062F\u0627\u0646)","ar-SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0635\u0648\u0645\u0627\u0644)","ar-SS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646)","ar-SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0633\u0648\u0631\u064A\u0627)","ar-TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062A\u0634\u0627\u062F)","ar-TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062A\u0648\u0646\u0633)","ar-YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u064A\u0645\u0646)","as":"\u0985\u09B8\u09AE\u09C0\u09DF\u09BE","asa":"Kipare","asa-TZ":"Kipare (Tadhania)","as-IN":"\u0985\u09B8\u09AE\u09C0\u09DF\u09BE (\u09AD\u09BE\u09F0\u09A4)","ast":"asturianu","ast-ES":"asturianu (Espa\xf1a)","az":"az\u0259rbaycan","az-Cyrl":"\u0410\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D \u0434\u0438\u043B\u0438","az-Cyrl-AZ":"\u0430\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D (\u0410\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D)","az-Latn":"az\u0259rbaycan","az-Latn-AZ":"az\u0259rbaycan (Az\u0259rbaycan)","ba":"\u0411\u0430\u0448\u04A1\u043E\u0440\u0442","ba-RU":"\u0411\u0430\u0448\u04A1\u043E\u0440\u0442 (\u0420\u04D9\u0441\u04D9\u0439)","bas":"\u0181\xe0s\xe0a","bas-CM":"\u0181\xe0s\xe0a (K\xe0m\u025B\u0300r\xfbn)","be":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","be-BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)","bem":"Ichibemba","bem-ZM":"Ichibemba (Zambia)","bez":"Hibena","bez-TZ":"Hibena (Hutanzania)","bg":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","bg-BG":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)","bin":"\u1EB8\u0300d\xf3","bin-NG":"\u1EB8\u0300d\xf3 (Nigeria)","bm":"bamanakan","bm-Latn":"bamanakan","bm-Latn-ML":"bamanakan (Mali)","bn":"\u09AC\u09BE\u0982\u09B2\u09BE","bn-BD":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","bn-IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bo":"\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42","bo-CN":"\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42 (\u0F40\u0FB2\u0F74\u0F44\u0F0B\u0F67\u0FAD\u0F0B\u0F58\u0F72\u0F0B\u0F51\u0F58\u0F44\u0F66\u0F0B\u0F66\u0FA4\u0FB1\u0F72\u0F0B\u0F58\u0F50\u0F74\u0F53\u0F0B\u0F62\u0F92\u0FB1\u0F63\u0F0B\u0F41\u0F56\u0F0D)","bo-IN":"\u0F56\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (\u0F62\u0F92\u0FB1\u0F0B\u0F42\u0F62\u0F0B)","br":"brezhoneg","br-FR":"brezhoneg (Fra\xf1s)","brx":"\u092C\u0921\u093C\u094B","brx-IN":"\u092C\u0921\u093C\u094B (\u092D\u093E\u0930\u0924)","bs":"bosanski","bs-Cyrl":"\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438","bs-Cyrl-BA":"\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438 (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)","bs-Latn":"bosanski","bs-Latn-BA":"bosanski (Bosna i Hercegovina)","byn":"\u1265\u120A\u1295","byn-ER":"\u1265\u120A\u1295 (\u12A4\u122D\u1275\u122B)","ca":"catal\xe0","ca-AD":"catal\xe0 (Andorra)","ca-ES":"catal\xe0 (catal\xe0)","ca-ES-valencia":"valenci\xe0 (Espanya)","ca-FR":"catal\xe0 (Fran\xe7a)","ca-IT":"catal\xe0 (It\xe0lia)","ce":"\u043D\u043E\u0445\u0447\u0438\u0439\u043D","ce-RU":"\u043D\u043E\u0445\u0447\u0438\u0439\u043D (\u0420\u043E\u0441\u0441\u0438)","cgg":"Rukiga","cgg-UG":"Rukiga (Uganda)","chr":"\u13E3\u13B3\u13A9","chr-Cher":"\u13E3\u13B3\u13A9","chr-Cher-US":"\u13E3\u13B3\u13A9 (\u13CC\u13CA \u13A2\u13F3\u13BE\u13B5\u13CD\u13D4\u13C5 \u13CD\u13A6\u13DA\u13A9)","co":"Corsu","co-FR":"Corsu (Francia)","cs":"\u010De\u0161tina","cs-CZ":"\u010De\u0161tina (\u010Cesko)","cu":"\u0446\u0435\u0440\u043A\u043E\u0432\u043D\u043E\u0441\u043B\u043E\u0432\u0435\u0301\u043D\u0441\u043A\u0457\u0439","cu-RU":"\u0446\u0435\u0440\u043A\u043E\u0432\u043D\u043E\u0441\u043B\u043E\u0432\u0435\u0301\u043D\u0441\u043A\u0457\u0439 (\u0440\u0461\u0441\u0441\u0456\u0301\u0430)","cy":"Cymraeg","cy-GB":"Cymraeg (Y Deyrnas Unedig)","da":"dansk","da-DK":"dansk (Danmark)","da-GL":"dansk (Gr\xf8nland)","dav":"Kitaita","dav-KE":"Kitaita (Kenya)","de":"Deutsch","de-AT":"Deutsch (\xd6sterreich)","de-BE":"Deutsch (Belgien)","de-CH":"Deutsch (Schweiz)","de-DE":"Deutsch (Deutschland)","de-IT":"Deutsch (Italien)","de-LI":"Deutsch (Liechtenstein)","de-LU":"Deutsch (Luxemburg)","dje":"Zarmaciine","dje-NE":"Zarmaciine (Ni\u017Eer)","dsb":"dolnoserb\u0161\u0107ina","dsb-DE":"dolnoserb\u0161\u0107ina (Nimska)","dua":"du\xe1l\xe1","dua-CM":"du\xe1l\xe1 (Cameroun)","dv":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0","dv-MV":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0 (\u078B\u07A8\u0788\u07AC\u0780\u07A8 \u0783\u07A7\u0787\u07B0\u0796\u07AC)","dyo":"joola","dyo-SN":"joola (Senegal)","dz":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41","dz-BT":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41 (\u0F60\u0F56\u0FB2\u0F74\u0F42)","ebu":"K\u0129embu","ebu-KE":"K\u0129embu (Kenya)","ee":"E\u028Begbe","ee-GH":"E\u028Begbe (Ghana nutome)","ee-TG":"E\u028Begbe (Togo nutome)","el":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el-CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)","el-GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)","en":"English","en-001":"English (World)","en-029":"English (Caribbean)","en-150":"English (Europe)","en-AG":"English (Antigua and Barbuda)","en-AI":"English (Anguilla)","en-AS":"English (American Samoa)","en-AT":"English (Austria)","en-AU":"English (Australia)","en-BB":"English (Barbados)","en-BE":"English (Belgium)","en-BI":"English (Burundi)","en-BM":"English (Bermuda)","en-BS":"English (Bahamas)","en-BW":"English (Botswana)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-CC":"English (Cocos (Keeling) Islands)","en-CH":"English (Switzerland)","en-CK":"English (Cook Islands)","en-CM":"English (Cameroon)","en-CX":"English (Christmas Island)","en-CY":"English (Cyprus)","en-DE":"English (Germany)","en-DK":"English (Denmark)","en-DM":"English (Dominica)","en-ER":"English (Eritrea)","en-FI":"English (Finland)","en-FJ":"English (Fiji)","en-FK":"English (Falkland Islands)","en-FM":"English (Micronesia)","en-GB":"English (United Kingdom)","en-GD":"English (Grenada)","en-GG":"English (Guernsey)","en-GH":"English (Ghana)","en-GI":"English (Gibraltar)","en-GM":"English (Gambia)","en-GU":"English (Guam)","en-GY":"English (Guyana)","en-HK":"English (Hong Kong SAR)","en-ID":"English (Indonesia)","en-IE":"English (Ireland)","en-IL":"English (Israel)","en-IM":"English (Isle of Man)","en-IN":"English (India)","en-IO":"English (British Indian Ocean Territory)","en-JE":"English (Jersey)","en-JM":"English (Jamaica)","en-KE":"English (Kenya)","en-KI":"English (Kiribati)","en-KN":"English (Saint Kitts and Nevis)","en-KY":"English (Cayman Islands)","en-LC":"English (Saint Lucia)","en-LR":"English (Liberia)","en-LS":"English (Lesotho)","en-MG":"English (Madagascar)","en-MH":"English (Marshall Islands)","en-MO":"English (Macao SAR)","en-MP":"English (Northern Mariana Islands)","en-MS":"English (Montserrat)","en-MT":"English (Malta)","en-MU":"English (Mauritius)","en-MW":"English (Malawi)","en-MY":"English (Malaysia)","en-NA":"English (Namibia)","en-NF":"English (Norfolk Island)","en-NG":"English (Nigeria)","en-NL":"English (Netherlands)","en-NR":"English (Nauru)","en-NU":"English (Niue)","en-NZ":"English (New Zealand)","en-PG":"English (Papua New Guinea)","en-PH":"English (Philippines)","en-PK":"English (Pakistan)","en-PN":"English (Pitcairn Islands)","en-PR":"English (Puerto Rico)","en-PW":"English (Palau)","en-RW":"English (Rwanda)","en-SB":"English (Solomon Islands)","en-SC":"English (Seychelles)","en-SD":"English (Sudan)","en-SE":"English (Sweden)","en-SG":"English (Singapore)","en-SH":"English (St Helena, Ascension, Tristan da Cunha)","en-SI":"English (Slovenia)","en-SL":"English (Sierra Leone)","en-SS":"English (South Sudan)","en-SX":"English (Sint Maarten)","en-SZ":"English (Swaziland)","en-TC":"English (Turks and Caicos Islands)","en-TK":"English (Tokelau)","en-TO":"English (Tonga)","en-TT":"English (Trinidad and Tobago)","en-TV":"English (Tuvalu)","en-TZ":"English (Tanzania)","en-UG":"English (Uganda)","en-UM":"English (U.S. Outlying Islands)","en-US":"English (United States)","en-VC":"English (Saint Vincent and the Grenadines)","en-VG":"English (British Virgin Islands)","en-VI":"English (U.S. Virgin Islands)","en-VU":"English (Vanuatu)","en-WS":"English (Samoa)","en-ZA":"English (South Africa)","en-ZM":"English (Zambia)","en-ZW":"English (Zimbabwe)","eo":"esperanto","eo-001":"esperanto (World)","es":"espa\xf1ol","es-419":"espa\xf1ol (Latinoam\xe9rica)","es-AR":"espa\xf1ol (Argentina)","es-BO":"espa\xf1ol (Bolivia)","es-BR":"espa\xf1ol (Brasil)","es-BZ":"espa\xf1ol (Belice)","es-CL":"espa\xf1ol (Chile)","es-CO":"espa\xf1ol (Colombia)","es-CR":"espa\xf1ol (Costa Rica)","es-CU":"espa\xf1ol (Cuba)","es-DO":"espa\xf1ol (Rep\xfablica Dominicana)","es-EC":"espa\xf1ol (Ecuador)","es-ES":"espa\xf1ol (Espa\xf1a, alfabetizaci\xf3n internacional)","es-GQ":"espa\xf1ol (Guinea Ecuatorial)","es-GT":"espa\xf1ol (Guatemala)","es-HN":"espa\xf1ol (Honduras)","es-MX":"espa\xf1ol (M\xe9xico)","es-NI":"espa\xf1ol (Nicaragua)","es-PA":"espa\xf1ol (Panam\xe1)","es-PE":"espa\xf1ol (Per\xfa)","es-PH":"espa\xf1ol (Filipinas)","es-PR":"espa\xf1ol (Puerto Rico)","es-PY":"espa\xf1ol (Paraguay)","es-SV":"espa\xf1ol (El Salvador)","es-US":"espa\xf1ol (Estados Unidos)","es-UY":"espa\xf1ol (Uruguay)","es-VE":"espa\xf1ol (Venezuela)","et":"eesti","et-EE":"eesti (Eesti)","eu":"euskara","eu-ES":"euskara (euskara)","ewo":"ewondo","ewo-CM":"ewondo (Kam\u0259r\xfan)","fa":"\u0641\u0627\u0631\u0633\u06CC","fa-IR":"\u0641\u0627\u0631\u0633\u06CC (\u0627\u06CC\u0631\u0627\u0646)","ff":"Fulah","ff-CM":"Pulaar (Kameruun)","ff-GN":"Pulaar (Gine)","ff-Latn":"Fulah","ff-Latn-SN":"Fulah (S\xe9n\xe9gal)","ff-MR":"Pulaar (Muritani)","ff-NG":"Pulaar (Nigeria)","fi":"suomi","fi-FI":"suomi (Suomi)","fil":"Filipino","fil-PH":"Filipino (Pilipinas)","fo":"f\xf8royskt","fo-DK":"f\xf8royskt (Danmark)","fo-FO":"f\xf8royskt (F\xf8royar)","fr":"fran\xe7ais","fr-029":"fran\xe7ais (cara\xefbes)","fr-BE":"fran\xe7ais (Belgique)","fr-BF":"fran\xe7ais (Burkina Faso)","fr-BI":"fran\xe7ais (Burundi)","fr-BJ":"fran\xe7ais (B\xe9nin)","fr-BL":"fran\xe7ais (Saint-Barth\xe9lemy)","fr-CA":"fran\xe7ais (Canada)","fr-CD":"fran\xe7ais (Congo, R\xe9publique d\xe9mocratique du)","fr-CF":"fran\xe7ais (R\xe9publique centrafricaine)","fr-CG":"fran\xe7ais (Congo)","fr-CH":"fran\xe7ais (Suisse)","fr-CI":"fran\xe7ais (C\xf4te d\u2019Ivoire)","fr-CM":"fran\xe7ais (Cameroun)","fr-DJ":"fran\xe7ais (Djibouti)","fr-DZ":"fran\xe7ais (Alg\xe9rie)","fr-FR":"fran\xe7ais (France)","fr-GA":"fran\xe7ais (Gabon)","fr-GF":"fran\xe7ais (Guyane fran\xe7aise)","fr-GN":"fran\xe7ais (Guin\xe9e)","fr-GP":"fran\xe7ais (Guadeloupe)","fr-GQ":"fran\xe7ais (Guin\xe9e \xe9quatoriale)","fr-HT":"fran\xe7ais (Ha\xefti)","fr-KM":"fran\xe7ais (Comores)","fr-LU":"fran\xe7ais (Luxembourg)","fr-MA":"fran\xe7ais (Maroc)","fr-MC":"fran\xe7ais (Monaco)","fr-MF":"fran\xe7ais (Saint-Martin)","fr-MG":"fran\xe7ais (Madagascar)","fr-ML":"fran\xe7ais (Mali)","fr-MQ":"fran\xe7ais (Martinique)","fr-MR":"fran\xe7ais (Mauritanie)","fr-MU":"fran\xe7ais (Maurice)","fr-NC":"fran\xe7ais (Nouvelle-Cal\xe9donie)","fr-NE":"fran\xe7ais (Niger)","fr-PF":"fran\xe7ais (Polyn\xe9sie fran\xe7aise)","fr-PM":"fran\xe7ais (Saint-Pierre-et-Miquelon)","fr-RE":"fran\xe7ais (La R\xe9union)","fr-RW":"fran\xe7ais (Rwanda)","fr-SC":"fran\xe7ais (Seychelles)","fr-SN":"fran\xe7ais (S\xe9n\xe9gal)","fr-SY":"fran\xe7ais (Syrie)","fr-TD":"fran\xe7ais (Tchad)","fr-TG":"fran\xe7ais (Togo)","fr-TN":"fran\xe7ais (Tunisie)","fr-VU":"fran\xe7ais (Vanuatu)","fr-WF":"fran\xe7ais (Wallis-et-Futuna)","fr-YT":"fran\xe7ais (Mayotte)","fur":"furlan","fur-IT":"furlan (Italie)","fy":"Frysk","fy-NL":"Frysk (Nederl\xe2n)","ga":"Gaeilge","ga-IE":"Gaeilge (\xc9ire)","gd":"G\xe0idhlig","gd-GB":"G\xe0idhlig (An R\xecoghachd Aonaichte)","gl":"galego","gl-ES":"galego (galego)","gn":"Ava\xf1e\u2019\u1EBD","gn-PY":"Ava\xf1e\u2019\u1EBD (Paragu\xe1i)","gsw":"Schwiizert\xfc\xfctsch","gsw-CH":"Schwiizert\xfc\xfctsch (Schwiiz)","gsw-FR":"Els\xe4ssisch (Fr\xe0nkrisch)","gsw-LI":"Schwiizert\xfc\xfctsch (Li\xe4chtescht\xe4i)","gu":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","gu-IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0 (\u0AAD\u0ABE\u0AB0\u0AA4)","guz":"Ekegusii","guz-KE":"Ekegusii (Kenya)","gv":"Gaelg","gv-IM":"Gaelg (Ellan Vannin)","ha":"Hausa","ha-Latn":"Hausa","ha-Latn-GH":"Hausa (Gana)","ha-Latn-NE":"Hausa (Nijar)","ha-Latn-NG":"Hausa (Najeriya)","haw":"\u02BB\u014Clelo Hawai\u02BBi","haw-US":"\u02BB\u014Clelo Hawai\u02BBi (\u02BBAmelika Hui P\u016B \u02BBIa)","he":"\u05E2\u05D1\u05E8\u05D9\u05EA","he-IL":"\u05E2\u05D1\u05E8\u05D9\u05EA (\u05D9\u05E9\u05E8\u05D0\u05DC)","hi":"\u0939\u093F\u0928\u094D\u0926\u0940","hi-IN":"\u0939\u093F\u0928\u094D\u0926\u0940 (\u092D\u093E\u0930\u0924)","hr":"hrvatski","hr-BA":"hrvatski (Bosna i Hercegovina)","hr-HR":"hrvatski (Hrvatska)","hsb":"hornjoserb\u0161\u0107ina","hsb-DE":"hornjoserb\u0161\u0107ina (N\u011Bmska)","hu":"magyar","hu-HU":"magyar (Magyarorsz\xe1g)","hy":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","hy-AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576 (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)","ia":"interlingua","ia-001":"interlingua (World)","ia-FR":"interlingua (Francia)","ibb":"Ibibio-Efik","ibb-NG":"Ibibio-Efik (Nigeria)","id":"Indonesia","id-ID":"Indonesia (Indonesia)","ig":"Igbo","ig-NG":"Igbo (Na\u1ECBj\u1ECBr\u1ECBa)","ii":"\uA188\uA320\uA071\uA0B7","ii-CN":"\uA188\uA320\uA071\uA0B7 (\uA34F\uA278\uA3D3\uA0B1\uA1ED\uA27C\uA1E9)","is":"\xedslenska","is-IS":"\xedslenska (\xcdsland)","it":"italiano","it-CH":"italiano (Svizzera)","it-IT":"italiano (Italia)","it-SM":"italiano (San Marino)","it-VA":"italiano (Citt\xe0 del Vaticano)","iu":"Inuktitut","iu-Cans":"\u1403\u14C4\u1483\u144E\u1450\u1466","iu-Cans-CA":"\u1403\u14C4\u1483\u144E\u1450\u1466 (\u1472\u14C7\u1455\u14A5)","iu-Latn":"Inuktitut","iu-Latn-CA":"Inuktitut (Kanatami)","ja":"\u65E5\u672C\u8A9E","ja-JP":"\u65E5\u672C\u8A9E (\u65E5\u672C)","jgo":"Nda\uA78Ca","jgo-CM":"Nda\uA78Ca (Kam\u025Bl\xfbn)","jmc":"Kimachame","jmc-TZ":"Kimachame (Tanzania)","jv":"Basa Jawa","jv-Java":"\uA9A7\uA9B1\uA997\uA9AE","jv-Java-ID":"\uA9A7\uA9B1\uA997\uA9AE (Indonesia)","jv-Latn":"Basa Jawa","jv-Latn-ID":"Basa Jawa (Indonesia)","ka":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","kab":"Taqbaylit","kab-DZ":"Taqbaylit (Lezzayer)","ka-GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)","kam":"Kikamba","kam-KE":"Kikamba (Kenya)","kde":"Chimakonde","kde-TZ":"Chimakonde (Tanzania)","kea":"kabuverdianu","kea-CV":"kabuverdianu (Kabu Verdi)","khq":"Koyra ciini","khq-ML":"Koyra ciini (Maali)","ki":"Gikuyu","ki-KE":"Gikuyu (Kenya)","kk":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456","kkj":"kak\u0254","kkj-CM":"kak\u0254 (Kam\u025Brun)","kk-KZ":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456 (\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D)","kl":"kalaallisut","kl-GL":"kalaallisut (Kalaallit Nunaat)","kln":"Kalenjin","kln-KE":"Kalenjin (Emetab Kenya)","km":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","km-KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)","kn":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1","kn-IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (\u0CAD\u0CBE\u0CB0\u0CA4)","ko":"\uD55C\uAD6D\uC5B4","kok":"\u0915\u094B\u0902\u0915\u0923\u0940","kok-IN":"\u0915\u094B\u0902\u0915\u0923\u0940 (\u092D\u093E\u0930\u0924)","ko-KP":"\uD55C\uAD6D\uC5B4 (\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D)","ko-KR":"\uD55C\uAD6D\uC5B4(\uB300\uD55C\uBBFC\uAD6D)","kr":"Kanuri","kr-NG":"Kanuri (Nigeria)","ks":"\u06A9\u0672\u0634\u064F\u0631","ks-Arab":"\u06A9\u0672\u0634\u064F\u0631","ks-Arab-IN":"\u06A9\u0672\u0634\u064F\u0631 (\u0627\u064E\u0631\u0628\u06CC)","ksb":"Kishambaa","ksb-TZ":"Kishambaa (Tanzania)","ks-Deva":"\u0915\u0949\u0936\u0941\u0930","ks-Deva-IN":"\u0915\u0949\u0936\u0941\u0930","ksf":"rikpa","ksf-CM":"rikpa (kam\u025Br\xfan)","ksh":"K\xf6lsch","ksh-DE":"K\xf6lsch (Do\xfctschland)","ku":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A","ku-Arab":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A","ku-Arab-IQ":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A (\u0639\u06CE\u0631\u0627\u0642)","ku-Arab-IR":"\u06A9\u0648\u0631\u062F\u06CC (\u0626\u06CE\u0631\u0627\u0646)","kw":"kernewek","kw-GB":"kernewek (Rywvaneth Unys)","ky":"\u041A\u044B\u0440\u0433\u044B\u0437","ky-KG":"\u041A\u044B\u0440\u0433\u044B\u0437 (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)","la":"lingua lat\u012Bna","la-001":"lingua lat\u012Bna (World)","lag":"K\u0268laangi","lag-TZ":"K\u0268laangi (Taansan\xeda)","lb":"L\xebtzebuergesch","lb-LU":"L\xebtzebuergesch (L\xebtzebuerg)","lg":"Luganda","lg-UG":"Luganda (Yuganda)","lkt":"Lak\u021F\xf3l\u02BCiyapi","lkt-US":"Lak\u021F\xf3l\u02BCiyapi (M\xedlaha\u014Bska T\u021Fam\xe1k\u021Fo\u010Dhe)","ln":"ling\xe1la","ln-AO":"ling\xe1la (Ang\xf3la)","ln-CD":"ling\xe1la (Republ\xedki ya Kong\xf3 Demokrat\xedki)","ln-CF":"ling\xe1la (Repibiki ya Afr\xedka ya K\xe1ti)","ln-CG":"ling\xe1la (Kongo)","lo":"\u0EA5\u0EB2\u0EA7","lo-LA":"\u0EA5\u0EB2\u0EA7 (\u0EA5\u0EB2\u0EA7)","lrc":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC","lrc-IQ":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC (Iraq)","lrc-IR":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC (Iran)","lt":"lietuvi\u0173","lt-LT":"lietuvi\u0173 (Lietuva)","lu":"Tshiluba","lu-CD":"Tshiluba (Ditunga wa Kongu)","luo":"Dholuo","luo-KE":"Dholuo (Kenya)","luy":"Luluhia","luy-KE":"Luluhia (Kenya)","lv":"latvie\u0161u","lv-LV":"latvie\u0161u (Latvija)","mas":"Maa","mas-KE":"Maa (Kenya)","mas-TZ":"Maa (Tansania)","mer":"K\u0129m\u0129r\u0169","mer-KE":"K\u0129m\u0129r\u0169 (Kenya)","mfe":"kreol morisien","mfe-MU":"kreol morisien (Moris)","mg":"Malagasy","mgh":"Makua","mgh-MZ":"Makua (Umozambiki)","mg-MG":"Malagasy (Madagasikara)","mgo":"meta\u02BC","mgo-CM":"meta\u02BC (Kamalun)","mi":"te reo M\u0101ori","mi-NZ":"te reo M\u0101ori (Aotearoa)","mk":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438","mk-MK":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)","ml":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","ml-IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02 (\u0D07\u0D28\u0D4D\u0D24\u0D4D\u0D2F)","mn":"\u043C\u043E\u043D\u0433\u043E\u043B","mn-Cyrl":"\u043C\u043E\u043D\u0433\u043E\u043B","mni":"\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD","mni-IN":"\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD (India)","mn-MN":"\u043C\u043E\u043D\u0433\u043E\u043B (\u041C\u043E\u043D\u0433\u043E\u043B)","mn-Mong":"\u182E\u1823\u1829\u182D\u1823\u1824\u182F \u182C\u1821\u182F\u1821","mn-Mong-CN":"\u182E\u1823\u1829\u182D\u1823\u1824\u182F \u182C\u1821\u182F\u1821 (\u182A\u1826\u182D\u1826\u1833\u1821 \u1828\u1820\u1822\u1837\u1820\u182E\u1833\u1820\u182C\u1824 \u1833\u1824\u182E\u1833\u1820\u1833\u1824 \u1820\u1837\u1820\u1833 \u1823\u182F\u1823\u1830)","mn-Mong-MN":"\u182E\u1823\u1829\u182D\u1823\u182F \u182C\u1821\u182F\u1821 (\u182E\u1823\u1829\u182D\u1823\u182F \u1823\u182F\u1823\u1830)","moh":"Kanien\u2019k\xe9ha","moh-CA":"Kanien\'k\xe9ha","mr":"\u092E\u0930\u093E\u0920\u0940","mr-IN":"\u092E\u0930\u093E\u0920\u0940 (\u092D\u093E\u0930\u0924)","ms":"Melayu","ms-BN":"Melayu (Brunei)","ms-MY":"Melayu (Malaysia)","ms-SG":"Melayu (Singapura)","mt":"Malti","mt-MT":"Malti (Malta)","mua":"MUNDA\u014A","mua-CM":"MUNDA\u014A (kameru\u014B)","my":"\u1017\u1019\u102C","my-MM":"\u1019\u103C\u1014\u103A\u1019\u102C (\u1019\u103C\u1014\u103A\u1019\u102C)","mzn":"\u0645\u0627\u0632\u0631\u0648\u0646\u06CC","mzn-IR":"\u0645\u0627\u0632\u0631\u0648\u0646\u06CC (\u0627\u06CC\u0631\u0627\u0646)","naq":"Khoekhoegowab","naq-NA":"Khoekhoegowab (Namibiab)","nb":"norsk bokm\xe5l","nb-NO":"norsk bokm\xe5l (Norge)","nb-SJ":"norsk bokm\xe5l (Svalbard og Jan Mayen)","nd":"isiNdebele","nds":"Neddersass\u2019sch","nds-DE":"Neddersass\u2019sch (D\xfc\xfctschland)","nds-NL":"Neddersass\u2019sch (Nedderlannen)","nd-ZW":"isiNdebele (Zimbabwe)","ne":"\u0928\u0947\u092A\u093E\u0932\u0940","ne-IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (\u092D\u093E\u0930\u0924)","ne-NP":"\u0928\u0947\u092A\u093E\u0932\u0940 (\u0928\u0947\u092A\u093E\u0932)","nl":"Nederlands","nl-AW":"Nederlands (Aruba)","nl-BE":"Nederlands (Belgi\xeb)","nl-BQ":"Nederlands (Bonaire, Sint Eustatius en Saba)","nl-CW":"Nederlands (Cura\xe7ao)","nl-NL":"Nederlands (Nederland)","nl-SR":"Nederlands (Suriname)","nl-SX":"Nederlands (Sint-Maarten)","nmg":"Kwasio","nmg-CM":"Kwasio (Kamerun)","nn":"nynorsk","nnh":"Shw\xf3\u014B\xf2 ngiemb\u0254\u0254n","nnh-CM":"Shw\xf3\u014B\xf2 ngiemb\u0254\u0254n (K\xe0mal\xfbm)","nn-NO":"nynorsk (Noreg)","no":"norsk","nqo":"\u07D2\u07DE\u07CF","nqo-GN":"\u07D2\u07DE\u07CF (\u07D6\u07CC\u07EC\u07E3\u07CD\u07EC \u07DE\u07CA\u07F2\u07D3\u07CD\u07F2)","nr":"isiNdebele","nr-ZA":"isiNdebele (South Africa)","nso":"Sesotho sa Leboa","nso-ZA":"Sesotho sa Leboa (Afrika Borwa)","nus":"Thok Nath","nus-SS":"Thok Nath (South Sudan)","nyn":"Runyankore","nyn-UG":"Runyankore (Uganda)","oc":"Occitan","oc-FR":"Occitan (Fran\xe7a)","om":"Oromoo","om-ET":"Oromoo (Itoophiyaa)","om-KE":"Oromoo (Keeniyaa)","or":"\u0B13\u0B5C\u0B3F\u0B06","or-IN":"\u0B13\u0B5C\u0B3F\u0B06 (\u0B2D\u0B3E\u0B30\u0B24)","os":"\u0438\u0440\u043E\u043D","os-GE":"\u0438\u0440\u043E\u043D (\u0413\u0443\u044B\u0440\u0434\u0437\u044B\u0441\u0442\u043E\u043D)","os-RU":"\u0438\u0440\u043E\u043D (\u0423\u04D5\u0440\u04D5\u0441\u0435)","pa":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40","pa-Arab":"\u067E\u0646\u062C\u0627\u0628\u06CC","pa-Arab-PK":"\u067E\u0646\u062C\u0627\u0628\u06CC (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","pa-Guru":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40","pa-IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24)","pap":"Papiamentu","pap-029":"Papiamentu (Caribbean)","pl":"polski","pl-PL":"polski (Polska)","prg":"pr\u016Bsiskan","prg-001":"pr\u016Bsiskan (sw\u012Btai)","prs":"\u062F\u0631\u0649","prs-AF":"\u062F\u0631\u0649 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","ps":"\u067E\u069A\u062A\u0648","ps-AF":"\u067E\u069A\u062A\u0648 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","pt":"portugu\xeas","pt-AO":"portugu\xeas (Angola)","pt-BR":"portugu\xeas (Brasil)","pt-CH":"portugu\xeas (Su\xed\xe7a)","pt-CV":"portugu\xeas (Cabo Verde)","pt-GQ":"portugu\xeas (Guin\xe9 Equatorial)","pt-GW":"portugu\xeas (Guin\xe9-Bissau)","pt-LU":"portugu\xeas (Luxemburgo)","pt-MO":"portugu\xeas (RAE de Macau)","pt-MZ":"portugu\xeas (Mo\xe7ambique)","pt-PT":"portugu\xeas (Portugal)","pt-ST":"portugu\xeas (S\xe3o Tom\xe9 e Pr\xedncipe)","pt-TL":"portugu\xeas (Timor-Leste)","quc":"K\'iche\'","quc-Latn":"K\'iche\'","quc-Latn-GT":"K\'iche\' (Guatemala)","quz":"Runasimi","quz-BO":"Runasimi (Bolivia)","quz-EC":"Runasimi (Ecuador)","quz-PE":"Runasimi (Per\xfa)","rm":"rumantsch","rm-CH":"rumantsch (Svizra)","rn":"Ikirundi","rn-BI":"Ikirundi (Uburundi)","ro":"rom\xe2n\u0103","rof":"Kihorombo","rof-TZ":"Kihorombo (Tanzania)","ro-MD":"rom\xe2n\u0103 (Republica Moldova)","ro-RO":"rom\xe2n\u0103 (Rom\xe2nia)","ru":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439","ru-BY":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)","ru-KG":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F)","ru-KZ":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)","ru-MD":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041C\u043E\u043B\u0434\u043E\u0432\u0430)","ru-RU":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0420\u043E\u0441\u0441\u0438\u044F)","ru-UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0423\u043A\u0440\u0430\u0438\u043D\u0430)","rw":"Kinyarwanda","rwk":"Kiruwa","rwk-TZ":"Kiruwa (Tanzania)","rw-RW":"Kinyarwanda (U Rwanda)","sa":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924","sah":"\u0421\u0430\u0445\u0430","sah-RU":"\u0421\u0430\u0445\u0430 (\u0420\u043E\u0441\u0441\u0438\u044F)","sa-IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924 (\u092D\u093E\u0930\u0924\u092E\u094D)","saq":"Kisampur","saq-KE":"Kisampur (Kenya)","sbp":"Ishisangu","sbp-TZ":"Ishisangu (Tansaniya)","sd":"\u0633\u0646\u068C\u064A","sd-Arab":"\u0633\u0646\u068C\u064A","sd-Arab-PK":"\u0633\u0646\u068C\u064A (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","sd-Deva":"\u0938\u093F\u0928\u094D\u0927\u0940","sd-Deva-IN":"\u0938\u093F\u0928\u094D\u0927\u0940 (India)","se":"davvis\xe1megiella","se-FI":"davvis\xe1megiella (Suopma)","seh":"sena","seh-MZ":"sena (Mo\xe7ambique)","se-NO":"davvis\xe1megiella (Norga)","ses":"Koyraboro senni","se-SE":"davvis\xe1megiella (Ruo\u0167\u0167a)","ses-ML":"Koyraboro senni (Maali)","sg":"S\xe4ng\xf6","sg-CF":"S\xe4ng\xf6 (K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka)","shi":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C","shi-Latn":"Tashel\u1E25iyt","shi-Latn-MA":"Tashel\u1E25iyt (lm\u0263rib)","shi-Tfng":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C","shi-Tfng-MA":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","si":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD","si-LK":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)","sk":"sloven\u010Dina","sk-SK":"sloven\u010Dina (Slovensko)","sl":"sloven\u0161\u010Dina","sl-SI":"sloven\u0161\u010Dina (Slovenija)","sma":"\xe5arjelsaemieng\xefele","sma-NO":"\xe5arjelsaemieng\xefele (N\xf6\xf6rje)","sma-SE":"\xe5arjelsaemieng\xefele (Sveerje)","smj":"julevus\xe1megiella","smj-NO":"julevus\xe1megiella (Vuodna)","smj-SE":"julevus\xe1megiella (Svierik)","smn":"anar\xe2\u0161kiel\xe2","smn-FI":"anar\xe2\u0161kiel\xe2 (Suom\xe2)","sms":"s\xe4\xe4\xb4m\u01E9i\xf5ll","sms-FI":"s\xe4\xe4\xb4m\u01E9i\xf5ll (L\xe4\xe4\xb4ddj\xe2nnam)","sn":"chiShona","sn-Latn":"chiShona (Latin)","sn-Latn-ZW":"chiShona (Zimbabwe)","so":"Soomaali","so-DJ":"Soomaali (Jabuuti)","so-ET":"Soomaali (Itoobiya)","so-KE":"Soomaali (Kiiniya)","so-SO":"Soomaali (Soomaaliya)","sq":"shqip","sq-AL":"shqip (Shqip\xebri)","sq-MK":"shqip (Republika e Maqedonis\xeb)","sq-XK":"shqip (Kosov\xeb)","sr":"srpski","sr-Cyrl":"\u0441\u0440\u043F\u0441\u043A\u0438","sr-Cyrl-BA":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)","sr-Cyrl-ME":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430)","sr-Cyrl-RS":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0421\u0440\u0431\u0438\u0458\u0430)","sr-Cyrl-XK":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u041A\u043E\u0441\u043E\u0432\u043E)","sr-Latn":"srpski","sr-Latn-BA":"srpski (Bosna i Hercegovina)","sr-Latn-ME":"srpski (Crna Gora)","sr-Latn-RS":"srpski (Srbija)","sr-Latn-XK":"srpski (Kosovo)","ss":"Siswati","ss-SZ":"siSwati (Swaziland)","ssy":"Saho","ssy-ER":"Saho (Eretria)","ss-ZA":"siSwati (South Africa)","st":"Sesotho","st-LS":"Sesotho (Lesotho)","st-ZA":"Sesotho (South Africa)","sv":"svenska","sv-AX":"svenska (\xc5land)","sv-FI":"svenska (Finland)","sv-SE":"svenska (Sverige)","sw":"Kiswahili","sw-CD":"Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)","sw-KE":"Kiswahili (Kenya)","sw-TZ":"Kiswahili (Tanzania)","sw-UG":"Kiswahili (Uganda)","syr":"\u0723\u0718\u072A\u071D\u071D\u0710","syr-SY":"\u0723\u0718\u072A\u071D\u071D\u0710 (\u0723\u0718\u072A\u071D\u0710)","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta-IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE)","ta-LK":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8)","ta-MY":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0BAE\u0BB2\u0BC7\u0B9A\u0BBF\u0BAF\u0BBE)","ta-SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD)","te":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","te-IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41 (\u0C2D\u0C3E\u0C30\u0C24 \u0C26\u0C47\u0C36\u0C02)","teo":"Kiteso","teo-KE":"Kiteso (Kenia)","teo-UG":"Kiteso (Uganda)","tg":"\u0422\u043E\u04B7\u0438\u043A\u04E3","tg-Cyrl":"\u0442\u043E\u04B7\u0438\u043A\u04E3","tg-Cyrl-TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3 (\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D)","th":"\u0E44\u0E17\u0E22","th-TH":"\u0E44\u0E17\u0E22 (\u0E44\u0E17\u0E22)","ti":"\u1275\u130D\u122D\u129B","ti-ER":"\u1275\u130D\u122D\u129B (\u12A4\u122D\u1275\u122B)","ti-ET":"\u1275\u130D\u122D\u129B (\u12A2\u1275\u12EE\u1335\u12EB)","tig":"\u1275\u130D\u1228","tig-ER":"\u1275\u130D\u1228 (\u12A4\u122D\u1275\u122B)","tk":"T\xfcrkmen dili","tk-TM":"T\xfcrkmen dili (T\xfcrkmenistan)","tn":"Setswana","tn-BW":"Setswana (Botswana)","tn-ZA":"Setswana (Aforika Borwa)","to":"lea fakatonga","to-TO":"lea fakatonga (Tonga)","tr":"T\xfcrk\xe7e","tr-CY":"T\xfcrk\xe7e (K\u0131br\u0131s)","tr-TR":"T\xfcrk\xe7e (T\xfcrkiye)","ts":"Xitsonga","ts-ZA":"Xitsonga (South Africa)","tt":"\u0422\u0430\u0442\u0430\u0440","tt-RU":"\u0422\u0430\u0442\u0430\u0440 (\u0420\u043E\u0441\u0441\u0438\u044F)","twq":"Tasawaq senni","twq-NE":"Tasawaq senni (Ni\u017Eer)","tzm":"Tamazi\u0263t n la\u1E6Dla\u1E63","tzm-Arab":"\u0623\u0637\u0644\u0633 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0627\u0644\u062A\u0627\u0645\u0627\u0632\u064A\u062A\u064A\u0629","tzm-Arab-MA":"\u0623\u0637\u0644\u0633 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0627\u0644\u062A\u0627\u0645\u0627\u0632\u064A\u062A\u064A\u0629 (Morocco)","tzm-Latn":"Tamazi\u0263t n la\u1E6Dla\u1E63","tzm-Latn-DZ":"Tamazi\u0263t n la\u1E6Dla\u1E63 (Djaza\xefr)","tzm-Latn-MA":"Tamazi\u0263t n la\u1E6Dla\u1E63 (Me\u1E5B\u1E5Buk)","tzm-Tfng":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","tzm-Tfng-MA":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","ug":"\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5","ug-CN":"\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5 (\u062C\u06C7\u06AD\u062E\u06C7\u0627 \u062E\u06D5\u0644\u0642 \u062C\u06C7\u0645\u06BE\u06C7\u0631\u0649\u064A\u0649\u062A\u0649)","uk":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","uk-UA":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)","ur":"\u0627\u064F\u0631\u062F\u0648","ur-IN":"\u0627\u0631\u062F\u0648 (\u0628\u06BE\u0627\u0631\u062A)","ur-PK":"\u0627\u064F\u0631\u062F\u0648 (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","uz":"o\u2018zbek","uz-Arab":"\u0627\u0648\u0632\u0628\u06CC\u06A9","uz-Arab-AF":"\u0627\u0648\u0632\u0628\u06CC\u06A9 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","uz-Cyrl":"\u045E\u0437\u0431\u0435\u043A\u0447\u0430","uz-Cyrl-UZ":"\u045E\u0437\u0431\u0435\u043A\u0447\u0430 (\u040E\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u043E\u043D)","uz-Latn":"o\u2018zbek","uz-Latn-UZ":"o\u2018zbek (O\u02BBzbekiston)","vai":"\uA559\uA524","vai-Latn":"Vai","vai-Latn-LR":"Vai (Laibhiya)","vai-Vaii":"\uA559\uA524","vai-Vaii-LR":"\uA559\uA524 (\uA55E\uA524\uA52B\uA569)","ve":"Tshiven\u1E13a","ve-ZA":"Tshiven\u1E13a (South Africa)","vi":"Ti\xea\u0301ng Vi\u1EC7t","vi-VN":"Ti\xea\u0301ng Vi\u1EC7t (Vi\u1EC7t Nam)","vo":"Volap\xfck","vo-001":"Volap\xfck (World)","vun":"Kyivunjo","vun-TZ":"Kyivunjo (Tanzania)","wae":"Walser","wae-CH":"Walser (Schwiz)","wal":"\u12C8\u120B\u12ED\u1273\u1271","wal-ET":"\u12C8\u120B\u12ED\u1273\u1271 (\u12A2\u1275\u12EE\u1335\u12EB)","wo":"Wolof","wo-SN":"Wolof (Senegaal)","xh":"isiXhosa","xh-ZA":"isiXhosa (eMzantsi Afrika)","xog":"Olusoga","xog-UG":"Olusoga (Yuganda)","yav":"nuasue","yav-CM":"nuasue (Kemel\xfan)","yi":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9","yi-001":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (\u05D5\u05D5\u05E2\u05DC\u05D8)","yo":"\xc8d\xe8 Yor\xf9b\xe1","yo-BJ":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedl\u025B\u0301\xe8de B\u025B\u0300n\u025B\u0300)","yo-NG":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedl\u1EB9\u0301\xe8de N\xe0\xecj\xedr\xed\xe0)","zgh":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","zgh-Tfng":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","zgh-Tfng-MA":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","zh":"\u4E2D\u6587","zh-CHS":"\u4E2D\u6587(\u7B80\u4F53) \u65E7\u7248","zh-CHT":"\u4E2D\u6587(\u7E41\u9AD4) \u820A\u7248","zh-CN":"\u4E2D\u6587(\u4E2D\u56FD)","zh-Hans":"\u4E2D\u6587(\u7B80\u4F53)","zh-Hans-HK":"\u4E2D\u6587 (\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A)","zh-Hans-MO":"\u4E2D\u6587 (\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A)","zh-Hant":"\u4E2D\u6587(\u7E41\u9AD4)","zh-HK":"\u4E2D\u6587(\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340)","zh-MO":"\u4E2D\u6587(\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340)","zh-SG":"\u4E2D\u6587(\u65B0\u52A0\u5761)","zh-TW":"\u4E2D\u6587(\u53F0\u7063)","zu":"isiZulu","zu-ZA":"isiZulu (iNingizimu Afrika)"}');

});



parcelRegister("3o2AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe32ccb3f8998c9d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");

var $13Gq4 = parcelRequire("13Gq4");

var $eO5xw = parcelRequire("eO5xw");

var $fzVhJ = parcelRequire("fzVhJ");

var $dLhbi = parcelRequire("dLhbi");
const $fe32ccb3f8998c9d$var$LanguageButton = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const supported = (0, $2eBYD.useLocaleStore)((state)=>state.supported);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const { setCurrentSubView: setCurrentSubView, setClickedOnUI: setClickedOnUI } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const isTactile = (0, $9JLpC.useViewStore)((state)=>state.isTactile);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const [mainLocale, setMainLocale] = (0, $bxRTa.useState)((0, $fzVhJ.getMainLocale)(locale).toUpperCase());
    const [bottom, setBottom] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        setMainLocale((0, $fzVhJ.getMainLocale)(locale).toUpperCase());
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration.languageChoiceBottom?.setUnderRemote) setBottom('-3rem');
        else switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
                if (isTactile) setBottom(configuration.languageChoiceBottom?.desktopTactile || '4rem');
                else setBottom(configuration.languageChoiceBottom?.desktop || '4rem');
                break;
            case (0, $2rYkD.DeviceType).borne:
                setBottom(configuration.languageChoiceBottom?.verticalTactile || '25vh');
                break;
        }
    }, [
        currentDeviceType
    ]);
    /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */ const handleClick = (e)=>{
        setClickedOnUI((0, $2rYkD.UIPart).languages);
        setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).languages ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).languages);
        e.stopPropagation();
        e.preventDefault();
    };
    return supported.length > 1 ? isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dLhbi.default), {
        title: translation.common.lang,
        icon: "lang",
        color: currentSubView === (0, $2rYkD.CurrentSubView).languages ? themeColors.secondary : '#A4A7AF',
        onClick: (e)=>handleClick(e)
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-absolute rf-z-ui rf-min-w-24 rf-right-0 rf-px-2 rf-flex rf-flex-row rf-items-center rf-rounded-l-lg",
        style: {
            bottom: bottom,
            background: 'linear-gradient(#F8F8FC, #EDEEF3)'
        },
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-8 rf-mr-2",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-full",
                    src: `https://flagsapi.com/${mainLocale}/flat/64.png`
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-flex rf-flex-col rf-items-start ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'}`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-text-trueblack",
                        children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.singleLang)
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-text-lightgray",
                        children: (0, $eO5xw.capitalizeFirstLetter)((0, (/*@__PURE__*/$parcel$interopDefault($13Gq4)))[locale.split('-')[0]])
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $fe32ccb3f8998c9d$export$2e2bcd8739ae039 = $fe32ccb3f8998c9d$var$LanguageButton;

});
parcelRegister("fzVhJ", function(module, exports) {

$parcel$export(module.exports, "checkLocale", () => $40aaf61b4fa53955$export$d64c0ac95bb7fd72);
$parcel$export(module.exports, "getMainLocale", () => $40aaf61b4fa53955$export$91fc93b93c368955);
const $40aaf61b4fa53955$var$checkResult = (lang, allLanguages)=>{
    let res;
    // Lang can be 2-chars
    if (lang.length === 2) res = allLanguages.find((language)=>{
        return language.split('-')[0]?.toLowerCase() === lang.toLowerCase();
    });
    else {
        res = allLanguages.find((language)=>{
            return language.toLowerCase() === lang.toLowerCase();
        });
        if (!res) res = allLanguages.find((language)=>{
            return language.startsWith(`${lang.split('-')[0].toLowerCase()}-`);
        });
    }
    return res;
};
// Check if the locale in the current browser is in the array of available locales
const $40aaf61b4fa53955$var$checkLocaleFromBrowser = (allLanguages)=>{
    const navLang = navigator?.language;
    if (navLang && allLanguages?.length) return $40aaf61b4fa53955$var$checkResult(navLang, allLanguages);
    return undefined;
};
const $40aaf61b4fa53955$export$d64c0ac95bb7fd72 = (languageData, localeConfig)=>{
    // Use browser locale if config doesn't prevent it
    if (localeConfig?.getDefaultFromBrowser !== false) {
        const browserLocale = $40aaf61b4fa53955$var$checkLocaleFromBrowser(languageData.all);
        if (browserLocale) return browserLocale;
    }
    // Else check the "lang" tag in the html element
    const htmlElements = document.getElementsByTagName('html');
    if (htmlElements.length && htmlElements[0].lang) {
        const htmlLocale = $40aaf61b4fa53955$var$checkResult(htmlElements[0].lang, languageData.all);
        if (htmlLocale) return htmlLocale;
    }
    // Else, use default from languageData
    return languageData.default;
};
const $40aaf61b4fa53955$export$91fc93b93c368955 = (locale)=>{
    const split = locale.split('-');
    return split.length ? split[1] : split[0];
};

});


parcelRegister("iqpLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f2d90ce2054bc3e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $lqIBI = parcelRequire("lqIBI");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");

var $hVO5T = parcelRequire("hVO5T");

var $6Iy5P = parcelRequire("6Iy5P");
parcelRequire("dikAc");
var $jWbjz = parcelRequire("jWbjz");
var $9HRSd = parcelRequire("9HRSd");

var $4ZEXS = parcelRequire("4ZEXS");

var $d7O2A = parcelRequire("d7O2A");

var $gpOhM = parcelRequire("gpOhM");
const $3f2d90ce2054bc3e$var$MicrophoneButton = ({ openMicrophone: openMicrophone })=>{
    const isMicrophoneAllowed = (0, $giKuE.useSpeechStore)((state)=>state.isMicrophoneAllowed);
    const showMicrophoneModal = (0, $giKuE.useSpeechStore)((state)=>state.showMicrophoneModal);
    const microphonePermissionStatus = (0, $giKuE.useSpeechStore)((state)=>state.permissionStatus);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const { setFullScreenImage: setFullScreenImage, setCurrentSubView: setCurrentSubView } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const { setIsMicrophoneAllowed: setIsMicrophoneAllowed, setShowMicrophoneModal: setShowMicrophoneModal, askPermission: askPermission, toggleMicrophone: toggleMicrophone } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const [playerRef, setPlayerRef] = (0, $bxRTa.useState)(null);
    const handleClick = ()=>{
        if (!isMicrophoneAllowed) askPermission();
        else toggleMicrophone();
    };
    (0, $bxRTa.useEffect)(()=>{
        console.log('openMicrophone : ', openMicrophone);
        openMicrophone && handleClick();
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        setIsMicrophoneAllowed(microphonePermissionStatus === (0, $2rYkD.PermissionStatus).allowed);
        switch(microphonePermissionStatus){
            case (0, $2rYkD.PermissionStatus).allowed:
                setShowMicrophoneModal(false);
                toggleMicrophone();
                break;
            case (0, $2rYkD.PermissionStatus).waiting:
            case (0, $2rYkD.PermissionStatus).refused:
            case (0, $2rYkD.PermissionStatus).error:
                break;
        }
    }, [
        microphonePermissionStatus
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (playerRef) activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? playerRef.lottie.play() : playerRef.lottie.stop();
        setCurrentSubView((0, $2rYkD.CurrentSubView).none);
        setFullScreenImage(undefined);
    }, [
        activeRecognitionState,
        playerRef
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: `rf-relative large:rf-w-full large:rf-h-auto rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border ${activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? isMobile ? 'rf-h-12 rf-border-[#00000029]' : 'rf-border-[#00000029]' : isMobile ? 'rf-h-8 rf-border-none' : 'rf-border-menuBorder'} rf-rounded-half rf-overflow-hidden`,
                onClick: handleClick,
                "aria-label": "microphone",
                style: {
                    boxShadow: activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? 'inset 0 0 6px 3px#00000029' : isMobile ? undefined : '0 0 20px 1px #A4A7AF80',
                    WebkitMaskImage: activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? '-webkit-radial-gradient(white, black)' : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-h-full rf-w-full rf-flex rf-justify-end",
                        children: activeRecognitionState === (0, $2rYkD.RecognitionState).Listening && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lqIBI.Player), {
                            lottieRef: (instance)=>{
                                setPlayerRef({
                                    lottie: instance
                                });
                            },
                            loop: true,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($hVO5T))),
                            className: "rf-w-full"
                        })
                    }),
                    activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? /*#__PURE__*/ (0, $fl9nK.jsx)($9HRSd.default, {
                        className: "rf-h-3 rf-w-3 large:rf-h-4 large:rf-w-4"
                    }) : activeRecognitionState === (0, $2rYkD.RecognitionState).Closed ? /*#__PURE__*/ (0, $fl9nK.jsx)($jWbjz.default, {
                        className: "rf-h-5 rf-w-5",
                        color: themeColors.secondary
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4ZEXS.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Iy5P.default), {
                isOpened: showMicrophoneModal,
                onClose: ()=>setShowMicrophoneModal(false),
                children: [
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).waiting && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d7O2A.default), {}),
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).refused && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gpOhM.default), {})
                ]
            })
        ]
    });
};
var $3f2d90ce2054bc3e$export$2e2bcd8739ae039 = $3f2d90ce2054bc3e$var$MicrophoneButton;

});
parcelRegister("lqIBI", function(module, exports) {

$parcel$export(module.exports, "Player", () => Player);

var $bxRTa = parcelRequire("bxRTa");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(t, e) {
    return (extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    })(t, e);
};
function __extends(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
var __assign = function() {
    return (__assign = Object.assign || function(t) {
        for(var e, r = 1, i = arguments.length; r < i; r++)for(var a in e = arguments[r])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }).apply(this, arguments);
};
function __rest(t, e) {
    var r = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(i = Object.getOwnPropertySymbols(t); a < i.length; a++)e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (r[i[a]] = t[i[a]]);
    }
    return r;
}
function __decorate(t, e, r, i) {
    var a, s = arguments.length, n = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, r) : i;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, r, i);
    else for(var o = t.length - 1; o >= 0; o--)(a = t[o]) && (n = (s < 3 ? a(n) : s > 3 ? a(e, r, n) : a(e, r)) || n);
    return s > 3 && n && Object.defineProperty(e, r, n), n;
}
function __param(t, e) {
    return function(r, i) {
        e(r, i, t);
    };
}
function __metadata(t, e) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
}
function __awaiter(t, e, r, i) {
    return new (r || (r = Promise))(function(a, s) {
        function n(t) {
            try {
                h(i.next(t));
            } catch (t) {
                s(t);
            }
        }
        function o(t) {
            try {
                h(i.throw(t));
            } catch (t) {
                s(t);
            }
        }
        function h(t) {
            var e;
            t.done ? a(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(n, o);
        }
        h((i = i.apply(t, e || [])).next());
    });
}
function __generator(t, e) {
    var r, i, a, s, n = {
        label: 0,
        sent: function() {
            if (1 & a[0]) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    };
    return s = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function() {
        return this;
    }), s;
    function o(s) {
        return function(o) {
            return function(s) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; n;)try {
                    if (r = 1, i && (a = 2 & s[0] ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
                    switch(i = 0, a && (s = [
                        2 & s[0],
                        a.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            a = s;
                            break;
                        case 4:
                            return n.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            n.label++, i = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = n.ops.pop(), n.trys.pop();
                            continue;
                        default:
                            if (!(a = n.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                n = 0;
                                continue;
                            }
                            if (3 === s[0] && (!a || s[1] > a[0] && s[1] < a[3])) {
                                n.label = s[1];
                                break;
                            }
                            if (6 === s[0] && n.label < a[1]) {
                                n.label = a[1], a = s;
                                break;
                            }
                            if (a && n.label < a[2]) {
                                n.label = a[2], n.ops.push(s);
                                break;
                            }
                            a[2] && n.ops.pop(), n.trys.pop();
                            continue;
                    }
                    s = e.call(t, n);
                } catch (t) {
                    s = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    r = a = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                o
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t, e, r, i) {
    void 0 === i && (i = r), Object.defineProperty(t, i, {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    });
} : function(t, e, r, i) {
    void 0 === i && (i = r), t[i] = e[r];
};
function __exportStar(t, e) {
    for(var r in t)"default" === r || Object.prototype.hasOwnProperty.call(e, r) || __createBinding(e, t, r);
}
function __values(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], i = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var i, a, s = r.call(t), n = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = s.next()).done;)n.push(i.value);
    } catch (t) {
        a = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (r = s.return) && r.call(s);
        } finally{
            if (a) throw a.error;
        }
    }
    return n;
}
function __spread() {
    for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(__read(arguments[e]));
    return t;
}
function __spreadArrays() {
    for(var t = 0, e = 0, r = arguments.length; e < r; e++)t += arguments[e].length;
    var i = Array(t), a = 0;
    for(e = 0; e < r; e++)for(var s = arguments[e], n = 0, o = s.length; n < o; n++, a++)i[a] = s[n];
    return i;
}
function __spreadArray(t, e, r) {
    if (r || 2 === arguments.length) for(var i, a = 0, s = e.length; a < s; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}
function __await(t) {
    return this instanceof __await ? (this.v = t, this) : new __await(t);
}
function __asyncGenerator(t, e, r) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i, a = r.apply(t, e || []), s = [];
    return i = {}, n("next"), n("throw"), n("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function n(t) {
        a[t] && (i[t] = function(e) {
            return new Promise(function(r, i) {
                s.push([
                    t,
                    e,
                    r,
                    i
                ]) > 1 || o(t, e);
            });
        });
    }
    function o(t, e) {
        try {
            (r = a[t](e)).value instanceof __await ? Promise.resolve(r.value.v).then(h, l) : p(s[0][2], r);
        } catch (t) {
            p(s[0][3], t);
        }
        var r;
    }
    function h(t) {
        o("next", t);
    }
    function l(t) {
        o("throw", t);
    }
    function p(t, e) {
        t(e), s.shift(), s.length && o(s[0][0], s[0][1]);
    }
}
function __asyncDelegator(t) {
    var e, r;
    return e = {}, i("next"), i("throw", function(t) {
        throw t;
    }), i("return"), e[Symbol.iterator] = function() {
        return this;
    }, e;
    function i(i, a) {
        e[i] = t[i] ? function(e) {
            return (r = !r) ? {
                value: __await(t[i](e)),
                done: "return" === i
            } : a ? a(e) : e;
        } : a;
    }
}
function __asyncValues(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e, r = t[Symbol.asyncIterator];
    return r ? r.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function i(r) {
        e[r] = t[r] && function(e) {
            return new Promise(function(i, a) {
                (function(t, e, r, i) {
                    Promise.resolve(i).then(function(e) {
                        t({
                            value: e,
                            done: r
                        });
                    }, e);
                })(i, a, (e = t[r](e)).done, e.value);
            });
        };
    }
}
function __makeTemplateObject(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
    }) : t.raw = e, t;
}
var __setModuleDefault = Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
};
function __importStar(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && __createBinding(e, t, r);
    return __setModuleDefault(e, t), e;
}
function __importDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function __classPrivateFieldGet(t, e, r, i) {
    if ("a" === r && !i) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? i : "a" === r ? i.call(t) : i ? i.value : e.get(t);
}
function __classPrivateFieldSet(t, e, r, i, a) {
    if ("m" === i) throw new TypeError("Private method is not writable");
    if ("a" === i && !a) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function unwrapExports(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function createCommonjsModule(t, e) {
    return t(e = {
        exports: {}
    }, e.exports), e.exports;
}
function getCjsExportFromNamespace(t) {
    return t && t.default || t;
}
function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var lottie = createCommonjsModule(function(module, exports) {
    "undefined" != typeof navigator && function(t, e) {
        module.exports = e();
    }(0, function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
            _useWebWorker = !!t;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t) {
            locationHref = t;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t) {
            return document.createElement(t);
        }
        function extendPrototype(t, e) {
            var r, i, a = t.length;
            for(r = 0; r < a; r += 1)for(var s in i = t[r].prototype)Object.prototype.hasOwnProperty.call(i, s) && (e.prototype[s] = i[s]);
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t, e;
        }
        var audioControllerFactory = function() {
            function t(t) {
                this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
            }
            return t.prototype = {
                addAudio: function(t) {
                    this.audios.push(t);
                },
                pause: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].pause();
                },
                resume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].resume();
                },
                setRate: function(t) {
                    var e, r = this.audios.length;
                    for(e = 0; e < r; e += 1)this.audios[e].setRate(t);
                },
                createAudio: function(t) {
                    return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                        src: [
                            t
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t) {
                    this.audioFactory = t;
                },
                setVolume: function(t) {
                    this._volume = t, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t;
            };
        }(), createTypedArray = function() {
            function t(t, e) {
                var r, i = 0, a = [];
                switch(t){
                    case "int16":
                    case "uint8c":
                        r = 1;
                        break;
                    default:
                        r = 1.1;
                }
                for(i = 0; i < e; i += 1)a.push(r);
                return a;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e, r) {
                return "float32" === e ? new Float32Array(r) : "int16" === e ? new Int16Array(r) : "uint8c" === e ? new Uint8ClampedArray(r) : t(e, r);
            } : t;
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            });
        }
        function _typeof$6(t) {
            return (_typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t, e = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r = e.length;
            for(t = 0; t < r; t += 1)BMMath[e[t]] = Math[e[t]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t) {
            if ("object" === _typeof$6(t) && t.length) {
                var e, r = createSizedArray(t.length), i = t.length;
                for(e = 0; e < i; e += 1)r[e] = Math.abs(t[e]);
                return r;
            }
            return Math.abs(t);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t) {
            _shouldRoundValues = !!t;
        }
        function bmRnd(t) {
            return _shouldRoundValues ? Math.round(t) : t;
        }
        function styleDiv(t) {
            t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t, e, r, i) {
            this.type = t, this.currentTime = e, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t, e) {
            this.type = t, this.direction = e < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t, e, r, i) {
            this.type = t, this.currentLoop = r, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t, e, r) {
            this.type = t, this.firstFrame = e, this.totalFrames = r;
        }
        function BMDestroyEvent(t, e) {
            this.type = t, this.target = e;
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError", this.nativeError = t;
        }
        function BMAnimationConfigErrorEvent(t, e) {
            this.type = t, this.nativeError = e;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t, e, r) {
            var i, a, s, n, o, h, l, p;
            switch(h = r * (1 - e), l = r * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = r * (1 - (1 - o) * e), n % 6){
                case 0:
                    i = r, a = p, s = h;
                    break;
                case 1:
                    i = l, a = r, s = h;
                    break;
                case 2:
                    i = h, a = r, s = p;
                    break;
                case 3:
                    i = h, a = l, s = r;
                    break;
                case 4:
                    i = p, a = h, s = r;
                    break;
                case 5:
                    i = r, a = h, s = l;
            }
            return [
                i,
                a,
                s
            ];
        }
        function RGBtoHSV(t, e, r) {
            var i, a = Math.max(t, e, r), s = Math.min(t, e, r), n = a - s, o = 0 === a ? 0 : n / a, h = a / 255;
            switch(a){
                case s:
                    i = 0;
                    break;
                case t:
                    i = e - r + n * (e < r ? 6 : 0), i /= 6 * n;
                    break;
                case e:
                    i = r - t + 2 * n, i /= 6 * n;
                    break;
                case r:
                    i = t - e + 4 * n, i /= 6 * n;
            }
            return [
                i,
                o,
                h
            ];
        }
        function addSaturationToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[1] += e, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addBrightnessToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[2] += e, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addHueToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[0] += e / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
        }
        var rgbToHex = function() {
            var t, e, r = [];
            for(t = 0; t < 256; t += 1)e = t.toString(16), r[t] = 1 === e.length ? "0" + e : e;
            return function(t, e, i) {
                return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r[t] + r[e] + r[i];
            };
        }(), setSubframeEnabled = function(t) {
            subframeEnabled = !!t;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t) {
            expressionsPlugin = t;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t) {
            expressionsInterfaces = t;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t) {
            defaultCurveSegments = t;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t) {
            idPrefix$1 = t;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t);
        }
        function _typeof$5(t) {
            return (_typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var dataManager = function() {
            var t, e, r = 1, i = [], a = {
                onmessage: function() {},
                postMessage: function(e) {
                    t({
                        data: e
                    });
                }
            }, s = {
                postMessage: function(t) {
                    a.onmessage({
                        data: t
                    });
                }
            };
            function n() {
                e || ((e = function(e) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e.toString()
                        ], {
                            type: "text/javascript"
                        }), i = URL.createObjectURL(r);
                        return new Worker(i);
                    }
                    return t = e, a;
                }(function(t) {
                    if (s.dataManager || (s.dataManager = function() {
                        function t(a, s) {
                            var n, o, h, l, p, c, m = a.length;
                            for(o = 0; o < m; o += 1)if ("ks" in (n = a[o]) && !n.completed) {
                                if (n.completed = !0, n.hasMask) {
                                    var d = n.masksProperties;
                                    for(l = d.length, h = 0; h < l; h += 1)if (d[h].pt.k.i) i(d[h].pt.k);
                                    else for(c = d[h].pt.k.length, p = 0; p < c; p += 1)d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]), d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                                }
                                0 === n.ty ? (n.layers = e(n.refId, s), t(n.layers, s)) : 4 === n.ty ? r(n.shapes) : 5 === n.ty && f(n);
                            }
                        }
                        function e(t, e) {
                            var r = function(t, e) {
                                for(var r = 0, i = e.length; r < i;){
                                    if (e[r].id === t) return e[r];
                                    r += 1;
                                }
                                return null;
                            }(t, e);
                            return r ? r.layers.__used ? JSON.parse(JSON.stringify(r.layers)) : (r.layers.__used = !0, r.layers) : null;
                        }
                        function r(t) {
                            var e, a, s;
                            for(e = t.length - 1; e >= 0; e -= 1)if ("sh" === t[e].ty) {
                                if (t[e].ks.k.i) i(t[e].ks.k);
                                else for(s = t[e].ks.k.length, a = 0; a < s; a += 1)t[e].ks.k[a].s && i(t[e].ks.k[a].s[0]), t[e].ks.k[a].e && i(t[e].ks.k[a].e[0]);
                            } else "gr" === t[e].ty && r(t[e].it);
                        }
                        function i(t) {
                            var e, r = t.i.length;
                            for(e = 0; e < r; e += 1)t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
                        }
                        function a(t, e) {
                            var r = e ? e.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t[0] > r[0] || !(r[0] > t[0]) && (t[1] > r[1] || !(r[1] > t[1]) && (t[2] > r[2] || !(r[2] > t[2]) && null));
                        }
                        var s, n = function() {
                            var t = [
                                4,
                                4,
                                14
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, i = r.t.d, r.t.d = {
                                    k: [
                                        {
                                            s: i,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), o = (s = [
                            4,
                            7,
                            99
                        ], function(t) {
                            if (t.chars && !a(s, t.v)) {
                                var e, i = t.chars.length;
                                for(e = 0; e < i; e += 1){
                                    var n = t.chars[e];
                                    n.data && n.data.shapes && (r(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t.chars[e].t || (n.data.shapes.push({
                                        ty: "no"
                                    }), n.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h = function() {
                            var t = [
                                5,
                                7,
                                15
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, "number" == typeof (i = r.t.p).a && (i.a = {
                                    a: 0,
                                    k: i.a
                                }), "number" == typeof i.p && (i.p = {
                                    a: 0,
                                    k: i.p
                                }), "number" == typeof i.r && (i.r = {
                                    a: 0,
                                    k: i.r
                                }));
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), l = function() {
                            var t = [
                                4,
                                1,
                                9
                            ];
                            function e(t) {
                                var r, i, a, s = t.length;
                                for(r = 0; r < s; r += 1)if ("gr" === t[r].ty) e(t[r].it);
                                else if ("fl" === t[r].ty || "st" === t[r].ty) {
                                    if (t[r].c.k && t[r].c.k[0].i) for(a = t[r].c.k.length, i = 0; i < a; i += 1)t[r].c.k[i].s && (t[r].c.k[i].s[0] /= 255, t[r].c.k[i].s[1] /= 255, t[r].c.k[i].s[2] /= 255, t[r].c.k[i].s[3] /= 255), t[r].c.k[i].e && (t[r].c.k[i].e[0] /= 255, t[r].c.k[i].e[1] /= 255, t[r].c.k[i].e[2] /= 255, t[r].c.k[i].e[3] /= 255);
                                    else t[r].c.k[0] /= 255, t[r].c.k[1] /= 255, t[r].c.k[2] /= 255, t[r].c.k[3] /= 255;
                                }
                            }
                            function r(t) {
                                var r, i = t.length;
                                for(r = 0; r < i; r += 1)4 === t[r].ty && e(t[r].shapes);
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }(), p = function() {
                            var t = [
                                4,
                                4,
                                18
                            ];
                            function e(t) {
                                var r, i, a;
                                for(r = t.length - 1; r >= 0; r -= 1)if ("sh" === t[r].ty) {
                                    if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                                    else for(a = t[r].ks.k.length, i = 0; i < a; i += 1)t[r].ks.k[i].s && (t[r].ks.k[i].s[0].c = t[r].closed), t[r].ks.k[i].e && (t[r].ks.k[i].e[0].c = t[r].closed);
                                } else "gr" === t[r].ty && e(t[r].it);
                            }
                            function r(t) {
                                var r, i, a, s, n, o, h = t.length;
                                for(i = 0; i < h; i += 1){
                                    if ((r = t[i]).hasMask) {
                                        var l = r.masksProperties;
                                        for(s = l.length, a = 0; a < s; a += 1)if (l[a].pt.k.i) l[a].pt.k.c = l[a].cl;
                                        else for(o = l[a].pt.k.length, n = 0; n < o; n += 1)l[a].pt.k[n].s && (l[a].pt.k[n].s[0].c = l[a].cl), l[a].pt.k[n].e && (l[a].pt.k[n].e[0].c = l[a].cl);
                                    }
                                    4 === r.ty && e(r.shapes);
                                }
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }();
                        function f(t) {
                            0 === t.t.a.length && t.t.p;
                        }
                        var c = {
                            completeData: function(r) {
                                r.__complete || (l(r), n(r), o(r), h(r), p(r), t(r.layers, r.assets), function(r, i) {
                                    if (r) {
                                        var a = 0, s = r.length;
                                        for(a = 0; a < s; a += 1)1 === r[a].t && (r[a].data.layers = e(r[a].data.refId, i), t(r[a].data.layers, i));
                                    }
                                }(r.chars, r.assets), r.__complete = !0);
                            }
                        };
                        return c.checkColors = l, c.checkChars = o, c.checkPathProperties = h, c.checkShapes = p, c.completeLayers = t, c;
                    }()), s.assetLoader || (s.assetLoader = function() {
                        function t(t) {
                            var e = t.getResponseHeader("content-type");
                            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === _typeof$5(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                        }
                        return {
                            load: function(e, r, i, a) {
                                var s, n = new XMLHttpRequest;
                                try {
                                    n.responseType = "json";
                                } catch (t) {}
                                n.onreadystatechange = function() {
                                    if (4 === n.readyState) {
                                        if (200 === n.status) s = t(n), i(s);
                                        else try {
                                            s = t(n), i(s);
                                        } catch (t) {
                                            a && a(t);
                                        }
                                    }
                                };
                                try {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e, !0);
                                } catch (t) {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r + "/" + e, !0);
                                }
                                n.send();
                            }
                        };
                    }()), "loadAnimation" === t.data.type) s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t.data.type) {
                        var e = t.data.animation;
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    } else "loadData" === t.data.type && s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                })).onmessage = function(t) {
                    var e = t.data, r = e.id, a = i[r];
                    i[r] = null, "success" === e.status ? a.onComplete(e.payload) : a.onError && a.onError();
                });
            }
            function o(t, e) {
                var a = "processId_" + (r += 1);
                return i[a] = {
                    onComplete: t,
                    onError: e
                }, a;
            }
            return {
                loadAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadAnimation",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                loadData: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadData",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                completeAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "complete",
                        animation: t,
                        id: a
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t = function() {
                var t = createTag("canvas");
                t.width = 1, t.height = 1;
                var e = t.getContext("2d");
                return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
            }();
            function e() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i(t, e, r) {
                var i = "";
                if (t.e) i = t.p;
                else if (e) {
                    var a = t.p;
                    -1 !== a.indexOf("images/") && (a = a.split("/")[1]), i = e + a;
                } else i = r, i += t.u ? t.u : "", i += t.p;
                return i;
            }
            function a(t) {
                var e = 0, r = setInterval((function() {
                    (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r)), e += 1;
                }).bind(this), 50);
            }
            function s(t) {
                var e = {
                    assetData: t
                }, r = i(t, this.assetsPath, this.path);
                return dataManager.loadData(r, (function(t) {
                    e.img = t, this._footageLoaded();
                }).bind(this), (function() {
                    e.img = {}, this._footageLoaded();
                }).bind(this)), e;
            }
            function n() {
                this._imageLoaded = e.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = s.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n.prototype = {
                loadAssets: function(t, e) {
                    var r;
                    this.imagesLoadedCb = e;
                    var i = t.length;
                    for(r = 0; r < i; r += 1)t[r].layers || (t[r].t && "seq" !== t[r].t ? 3 === t[r].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[r]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[r]))));
                },
                setAssetsPath: function(t) {
                    this.assetsPath = t || "";
                },
                setPath: function(t) {
                    this.path = t || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t) {
                    for(var e = 0, r = this.images.length; e < r;){
                        if (this.images[e].assetData === t) return this.images[e].img;
                        e += 1;
                    }
                    return null;
                },
                createImgData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createTag("img");
                    a.crossOrigin = "anonymous", a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.src = r;
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                createImageData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createNS("image");
                    isSafari ? this.testImageLoaded(a) : a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), this._elementHelper.append ? this._elementHelper.append(a) : this._elementHelper.appendChild(a);
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                imageLoaded: e,
                footageLoaded: r,
                setCacheType: function(t, e) {
                    "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t, e) {
                if (this._cbs[t]) for(var r = this._cbs[t], i = 0; i < r.length; i += 1)r[i](e);
            },
            addEventListener: function(t, e) {
                return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), (function() {
                    this.removeEventListener(t, e);
                }).bind(this);
            },
            removeEventListener: function(t, e) {
                if (e) {
                    if (this._cbs[t]) {
                        for(var r = 0, i = this._cbs[t].length; r < i;)this._cbs[t][r] === e && (this._cbs[t].splice(r, 1), r -= 1, i -= 1), r += 1;
                        this._cbs[t].length || (this._cbs[t] = null);
                    }
                } else this._cbs[t] = null;
            }
        };
        var markerParser = function() {
            function t(t) {
                for(var e, r = t.split("\r\n"), i = {}, a = 0, s = 0; s < r.length; s += 1)2 === (e = r[s].split(":")).length && (i[e[0]] = e[1].trim(), a += 1);
                if (0 === a) throw new Error;
                return i;
            }
            return function(e) {
                for(var r = [], i = 0; i < e.length; i += 1){
                    var a = e[i], s = {
                        time: a.tm,
                        duration: a.dr
                    };
                    try {
                        s.payload = JSON.parse(e[i].cm);
                    } catch (r) {
                        try {
                            s.payload = t(e[i].cm);
                        } catch (t) {
                            s.payload = {
                                name: e[i].cm
                            };
                        }
                    }
                    r.push(s);
                }
                return r;
            };
        }(), ProjectInterface = function() {
            function t(t) {
                this.compositions.push(t);
            }
            return function() {
                function e(t) {
                    for(var e = 0, r = this.compositions.length; e < r;){
                        if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                        e += 1;
                    }
                    return null;
                }
                return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
            };
        }(), renderers = {}, registerRenderer = function(t, e) {
            renderers[t] = e;
        };
        function getRenderer(t) {
            return renderers[t];
        }
        function getRegisteredRenderer() {
            if (renderers.canvas) return "canvas";
            for(var t in renderers)if (renderers[t]) return t;
            return "";
        }
        function _typeof$4(t) {
            return (_typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r = getRenderer(e);
            this.renderer = new r(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t, e) {
            e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
            var r = {
                wrapper: t,
                animationData: e
            }, i = t.attributes;
            r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
            var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
            "false" === a ? r.loop = !1 : "true" === a ? r.loop = !0 : "" !== a && (r.loop = parseInt(a, 10));
            var s = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
            r.autoplay = "false" !== s, r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "", "false" === (i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "") && (r.prerender = !1), r.path ? this.setParams(r) : this.trigger("destroy");
        }, AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e, r, i = this.animationData.layers, a = i.length, s = t.layers, n = s.length;
            for(r = 0; r < n; r += 1)for(e = 0; e < a;){
                if (i[e].id === s[r].id) {
                    i[e] = s[r];
                    break;
                }
                e += 1;
            }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for(a = t.assets.length, e = 0; e < a; e += 1)this.animationData.assets.push(t.assets[e]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer) try {
                this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t) {
                this.triggerConfigError(t);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t, e) {
            var r = "number" == typeof t ? t : void 0, i = "number" == typeof e ? e : void 0;
            this.renderer.updateContainerSize(r, i);
        }, AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t) {
                this.triggerRenderFrameError(t);
            }
        }, AnimationItem.prototype.play = function(t) {
            t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t) {
            for(var e, r = 0; r < this.markers.length; r += 1)if ((e = this.markers[r]).payload && e.payload.name === t) return e;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && this.goToAndStop(a.time, !0);
                } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && (a.duration ? this.playSegments([
                        a.time,
                        a.time + a.duration
                    ], !0) : this.goToAndStop(a.time, !0));
                } else this.goToAndStop(i, e, r);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e = this.currentRawFrame + t * this.frameModifier, r = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), r && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t, e) {
            var r = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r = t : this.currentRawFrame + this.firstFrame > e && (r = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== r && this.goToAndStop(r, !0);
        }, AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0), "object" === _typeof$4(t[0])) {
                var r, i = t.length;
                for(r = 0; r < i; r += 1)this.segments.push(t[r]);
            } else this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
        }, AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t) {
            this.loop = t;
        }, AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e) e = t.p;
            else if (this.assetsPath) {
                var r = t.p;
                -1 !== r.indexOf("images/") && (r = r.split("/")[1]), e = this.assetsPath + r;
            } else e = this.path, e += t.u ? t.u : "", e += t.p;
            return e;
        }, AnimationItem.prototype.getAssetData = function(t) {
            for(var e = 0, r = this.assets.length; e < r;){
                if (t === this.assets[e].id) return this.assets[e];
                e += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t, e, r) {
            try {
                this.renderer.getElementByPath(t).updateDocumentData(e, r);
            } catch (t) {}
        }, AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t]) switch(t){
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t, this));
                    break;
                default:
                    this.triggerEvent(t);
            }
            "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        }, AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        };
        var animationManager = function() {
            var t = {}, e = [], r = 0, i = 0, a = 0, s = !0, n = !1;
            function o(t) {
                for(var r = 0, a = t.target; r < i;)e[r].animation === a && (e.splice(r, 1), r -= 1, i -= 1, a.isPaused || p()), r += 1;
            }
            function h(t, r) {
                if (!t) return null;
                for(var a = 0; a < i;){
                    if (e[a].elem === t && null !== e[a].elem) return e[a].animation;
                    a += 1;
                }
                var s = new AnimationItem;
                return f(s, t), s.setData(t, r), s;
            }
            function l() {
                a += 1, d();
            }
            function p() {
                a -= 1;
            }
            function f(t, r) {
                t.addEventListener("destroy", o), t.addEventListener("_active", l), t.addEventListener("_idle", p), e.push({
                    elem: r,
                    animation: t
                }), i += 1;
            }
            function c(t) {
                var o, h = t - r;
                for(o = 0; o < i; o += 1)e[o].animation.advanceTime(h);
                r = t, a && !n ? window.requestAnimationFrame(c) : s = !0;
            }
            function m(t) {
                r = t, window.requestAnimationFrame(c);
            }
            function d() {
                !n && a && s && (window.requestAnimationFrame(m), s = !1);
            }
            return t.registerAnimation = h, t.loadAnimation = function(t) {
                var e = new AnimationItem;
                return f(e, null), e.setParams(t), e;
            }, t.setSpeed = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setSpeed(t, r);
            }, t.setDirection = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setDirection(t, r);
            }, t.play = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.play(t);
            }, t.pause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.pause(t);
            }, t.stop = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.stop(t);
            }, t.togglePause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.togglePause(t);
            }, t.searchAnimations = function(t, e, r) {
                var i, a = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), s = a.length;
                for(i = 0; i < s; i += 1)r && a[i].setAttribute("data-bm-type", r), h(a[i], t);
                if (e && 0 === s) {
                    r || (r = "svg");
                    var n = document.getElementsByTagName("body")[0];
                    n.innerText = "";
                    var o = createTag("div");
                    o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", r), n.appendChild(o), h(o, t);
                }
            }, t.resize = function() {
                var t;
                for(t = 0; t < i; t += 1)e[t].animation.resize();
            }, t.goToAndStop = function(t, r, a) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.goToAndStop(t, r, a);
            }, t.destroy = function(t) {
                var r;
                for(r = i - 1; r >= 0; r -= 1)e[r].animation.destroy(t);
            }, t.freeze = function() {
                n = !0;
            }, t.unfreeze = function() {
                n = !1, d();
            }, t.setVolume = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setVolume(t, r);
            }, t.mute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.mute(t);
            }, t.unmute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.unmute(t);
            }, t.getRegisteredAnimations = function() {
                var t, r = e.length, i = [];
                for(t = 0; t < r; t += 1)i.push(e[t].animation);
                return i;
            }, t;
        }(), BezierFactory = function() {
            var t = {
                getBezierEasing: function(t, r, i, a, s) {
                    var n = s || ("bez_" + t + "_" + r + "_" + i + "_" + a).replace(/\./g, "p");
                    if (e[n]) return e[n];
                    var o = new h([
                        t,
                        r,
                        i,
                        a
                    ]);
                    return e[n] = o, o;
                }
            }, e = {};
            var r = "function" == typeof Float32Array;
            function i(t, e) {
                return 1 - 3 * e + 3 * t;
            }
            function a(t, e) {
                return 3 * e - 6 * t;
            }
            function s(t) {
                return 3 * t;
            }
            function n(t, e, r) {
                return ((i(e, r) * t + a(e, r)) * t + s(e)) * t;
            }
            function o(t, e, r) {
                return 3 * i(e, r) * t * t + 2 * a(e, r) * t + s(e);
            }
            function h(t) {
                this._p = t, this._mSampleValues = r ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return h.prototype = {
                get: function(t) {
                    var e = this._p[0], r = this._p[1], i = this._p[2], a = this._p[3];
                    return this._precomputed || this._precompute(), e === r && i === a ? t : 0 === t ? 0 : 1 === t ? 1 : n(this._getTForX(t), r, a);
                },
                _precompute: function() {
                    var t = this._p[0], e = this._p[1], r = this._p[2], i = this._p[3];
                    this._precomputed = !0, t === e && r === i || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t = this._p[0], e = this._p[2], r = 0; r < 11; ++r)this._mSampleValues[r] = n(.1 * r, t, e);
                },
                _getTForX: function(t) {
                    for(var e = this._p[0], r = this._p[2], i = this._mSampleValues, a = 0, s = 1; 10 !== s && i[s] <= t; ++s)a += .1;
                    var h = a + .1 * ((t - i[--s]) / (i[s + 1] - i[s])), l = o(h, e, r);
                    return l >= .001 ? function(t, e, r, i) {
                        for(var a = 0; a < 4; ++a){
                            var s = o(e, r, i);
                            if (0 === s) return e;
                            e -= (n(e, r, i) - t) / s;
                        }
                        return e;
                    }(t, h, e, r) : 0 === l ? h : function(t, e, r, i, a) {
                        var s, o, h = 0;
                        do (s = n(o = e + (r - e) / 2, i, a) - t) > 0 ? r = o : e = o;
                        while (Math.abs(s) > 1e-7 && ++h < 10);
                        return o;
                    }(t, a, a + .1, e, r);
                }
            }, t;
        }(), pooling = {
            double: function(t) {
                return t.concat(createSizedArray(t.length));
            }
        }, poolFactory = function(t, e, r) {
            var i = 0, a = t, s = createSizedArray(a);
            return {
                newElement: function() {
                    return i ? s[i -= 1] : e();
                },
                release: function(t) {
                    i === a && (s = pooling.double(s), a *= 2), r && r(t), s[i] = t, i += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t) {
            var e, r = t.lengths.length;
            for(e = 0; e < r; e += 1)bezierLengthPool.release(t.lengths[e]);
            t.lengths.length = 0;
        });
        function bezFunction() {
            var t = Math;
            function e(t, e, r, i, a, s) {
                var n = t * i + e * a + r * s - a * i - s * t - r * e;
                return n > -0.001 && n < .001;
            }
            var r = function(t, e, r, i) {
                var a, s, n, o, h, l, p = getDefaultCurveSegments(), f = 0, c = [], m = [], d = bezierLengthPool.newElement();
                for(n = r.length, a = 0; a < p; a += 1){
                    for(h = a / (p - 1), l = 0, s = 0; s < n; s += 1)o = bmPow(1 - h, 3) * t[s] + 3 * bmPow(1 - h, 2) * h * r[s] + 3 * (1 - h) * bmPow(h, 2) * i[s] + bmPow(h, 3) * e[s], c[s] = o, null !== m[s] && (l += bmPow(c[s] - m[s], 2)), m[s] = c[s];
                    l && (f += l = bmSqrt(l)), d.percents[a] = h, d.lengths[a] = f;
                }
                return d.addedLength = f, d;
            };
            function i(t) {
                this.segmentLength = 0, this.points = new Array(t);
            }
            function a(t, e) {
                this.partialLength = t, this.point = e;
            }
            var s, n = (s = {}, function(t, r, n, o) {
                var h = (t[0] + "_" + t[1] + "_" + r[0] + "_" + r[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                if (!s[h]) {
                    var l, p, f, c, m, d, u, y = getDefaultCurveSegments(), g = 0, v = null;
                    2 === t.length && (t[0] !== r[0] || t[1] !== r[1]) && e(t[0], t[1], r[0], r[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) && (y = 2);
                    var b = new i(y);
                    for(f = n.length, l = 0; l < y; l += 1){
                        for(u = createSizedArray(f), m = l / (y - 1), d = 0, p = 0; p < f; p += 1)c = bmPow(1 - m, 3) * t[p] + 3 * bmPow(1 - m, 2) * m * (t[p] + n[p]) + 3 * (1 - m) * bmPow(m, 2) * (r[p] + o[p]) + bmPow(m, 3) * r[p], u[p] = c, null !== v && (d += bmPow(u[p] - v[p], 2));
                        g += d = bmSqrt(d), b.points[l] = new a(d, u), v = u;
                    }
                    b.segmentLength = g, s[h] = b;
                }
                return s[h];
            });
            function o(t, e) {
                var r = e.percents, i = e.lengths, a = r.length, s = bmFloor((a - 1) * t), n = t * e.addedLength, o = 0;
                if (s === a - 1 || 0 === s || n === i[s]) return r[s];
                for(var h = i[s] > n ? -1 : 1, l = !0; l;)if (i[s] <= n && i[s + 1] > n ? (o = (n - i[s]) / (i[s + 1] - i[s]), l = !1) : s += h, s < 0 || s >= a - 1) {
                    if (s === a - 1) return r[s];
                    l = !1;
                }
                return r[s] + (r[s + 1] - r[s]) * o;
            }
            var h = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t) {
                    var e, i = segmentsLengthPool.newElement(), a = t.c, s = t.v, n = t.o, o = t.i, h = t._length, l = i.lengths, p = 0;
                    for(e = 0; e < h - 1; e += 1)l[e] = r(s[e], s[e + 1], n[e], o[e + 1]), p += l[e].addedLength;
                    return a && h && (l[e] = r(s[e], s[0], n[e], o[0]), p += l[e].addedLength), i.totalLength = p, i;
                },
                getNewSegment: function(e, r, i, a, s, n, l) {
                    s < 0 ? s = 0 : s > 1 && (s = 1);
                    var p, f = o(s, l), c = o(n = n > 1 ? 1 : n, l), m = e.length, d = 1 - f, u = 1 - c, y = d * d * d, g = f * d * d * 3, v = f * f * d * 3, b = f * f * f, x = d * d * u, E = f * d * u + d * f * u + d * d * c, S = f * f * u + d * f * c + f * d * c, P = f * f * c, C = d * u * u, _ = f * u * u + d * c * u + d * u * c, k = f * c * u + d * c * c + f * u * c, A = f * c * c, T = u * u * u, M = c * u * u + u * c * u + u * u * c, w = c * c * u + u * c * c + c * u * c, D = c * c * c;
                    for(p = 0; p < m; p += 1)h[4 * p] = t.round(1e3 * (y * e[p] + g * i[p] + v * a[p] + b * r[p])) / 1e3, h[4 * p + 1] = t.round(1e3 * (x * e[p] + E * i[p] + S * a[p] + P * r[p])) / 1e3, h[4 * p + 2] = t.round(1e3 * (C * e[p] + _ * i[p] + k * a[p] + A * r[p])) / 1e3, h[4 * p + 3] = t.round(1e3 * (T * e[p] + M * i[p] + w * a[p] + D * r[p])) / 1e3;
                    return h;
                },
                getPointInSegment: function(e, r, i, a, s, n) {
                    var h = o(s, n), l = 1 - h;
                    return [
                        t.round(1e3 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * i[0] + (h * h * l + l * h * h + h * l * h) * a[0] + h * h * h * r[0])) / 1e3,
                        t.round(1e3 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * i[1] + (h * h * l + l * h * h + h * l * h) * a[1] + h * h * h * r[1])) / 1e3
                    ];
                },
                buildBezierData: n,
                pointOnLine2D: e,
                pointOnLine3D: function(r, i, a, s, n, o, h, l, p) {
                    if (0 === a && 0 === o && 0 === p) return e(r, i, s, n, h, l);
                    var f, c = t.sqrt(t.pow(s - r, 2) + t.pow(n - i, 2) + t.pow(o - a, 2)), m = t.sqrt(t.pow(h - r, 2) + t.pow(l - i, 2) + t.pow(p - a, 2)), d = t.sqrt(t.pow(h - s, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
                    return (f = c > m ? c > d ? c - m - d : d - m - c : d > m ? d - m - c : m - c - d) > -0.0001 && f < 1e-4;
                }
            };
        }
        var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
        function interpolateValue(t, e) {
            var r, i = this.offsetTime;
            "multidimensional" === this.propType && (r = createTypedArray("float32", this.pv.length));
            for(var a, s, n, o, h, l, p, f, c, m = e.lastIndex, d = m, u = this.keyframes.length - 1, y = !0; y;){
                if (a = this.keyframes[d], s = this.keyframes[d + 1], d === u - 1 && t >= s.t - i) {
                    a.h && (a = s), m = 0;
                    break;
                }
                if (s.t - i > t) {
                    m = d;
                    break;
                }
                d < u - 1 ? d += 1 : (m = 0, y = !1);
            }
            n = this.keyframesMetadata[d] || {};
            var g, v = s.t - i, b = a.t - i;
            if (a.to) {
                n.bezierData || (n.bezierData = bez.buildBezierData(a.s, s.s || a.e, a.to, a.ti));
                var x = n.bezierData;
                if (t >= v || t < b) {
                    var E = t >= v ? x.points.length - 1 : 0;
                    for(h = x.points[E].point.length, o = 0; o < h; o += 1)r[o] = x.points[E].point[o];
                } else {
                    n.__fnct ? c = n.__fnct : (c = BezierFactory.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get, n.__fnct = c), l = c((t - b) / (v - b));
                    var S, P = x.segmentLength * l, C = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastAddedLength : 0;
                    for(f = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastPoint : 0, y = !0, p = x.points.length; y;){
                        if (C += x.points[f].partialLength, 0 === P || 0 === l || f === x.points.length - 1) {
                            for(h = x.points[f].point.length, o = 0; o < h; o += 1)r[o] = x.points[f].point[o];
                            break;
                        }
                        if (P >= C && P < C + x.points[f + 1].partialLength) {
                            for(S = (P - C) / x.points[f + 1].partialLength, h = x.points[f].point.length, o = 0; o < h; o += 1)r[o] = x.points[f].point[o] + (x.points[f + 1].point[o] - x.points[f].point[o]) * S;
                            break;
                        }
                        f < p - 1 ? f += 1 : y = !1;
                    }
                    e._lastPoint = f, e._lastAddedLength = C - x.points[f].partialLength, e._lastKeyframeIndex = d;
                }
            } else {
                var _, k, A, T, M;
                if (u = a.s.length, g = s.s || a.e, this.sh && 1 !== a.h) {
                    if (t >= v) r[0] = g[0], r[1] = g[1], r[2] = g[2];
                    else if (t <= b) r[0] = a.s[0], r[1] = a.s[1], r[2] = a.s[2];
                    else quaternionToEuler(r, slerp(createQuaternion(a.s), createQuaternion(g), (t - b) / (v - b)));
                } else for(d = 0; d < u; d += 1)1 !== a.h && (t >= v ? l = 1 : t < b ? l = 0 : (a.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[d] ? c = n.__fnct[d] : (_ = void 0 === a.o.x[d] ? a.o.x[0] : a.o.x[d], k = void 0 === a.o.y[d] ? a.o.y[0] : a.o.y[d], A = void 0 === a.i.x[d] ? a.i.x[0] : a.i.x[d], T = void 0 === a.i.y[d] ? a.i.y[0] : a.i.y[d], c = BezierFactory.getBezierEasing(_, k, A, T).get, n.__fnct[d] = c)) : n.__fnct ? c = n.__fnct : (_ = a.o.x, k = a.o.y, A = a.i.x, T = a.i.y, c = BezierFactory.getBezierEasing(_, k, A, T).get, a.keyframeMetadata = c), l = c((t - b) / (v - b)))), g = s.s || a.e, M = 1 === a.h ? a.s[d] : a.s[d] + (g[d] - a.s[d]) * l, "multidimensional" === this.propType ? r[d] = M : r = M;
            }
            return e.lastIndex = m, r;
        }
        function slerp(t, e, r) {
            var i, a, s, n, o, h = [], l = t[0], p = t[1], f = t[2], c = t[3], m = e[0], d = e[1], u = e[2], y = e[3];
            return (a = l * m + p * d + f * u + c * y) < 0 && (a = -a, m = -m, d = -d, u = -u, y = -y), 1 - a > 1e-6 ? (i = Math.acos(a), s = Math.sin(i), n = Math.sin((1 - r) * i) / s, o = Math.sin(r * i) / s) : (n = 1 - r, o = r), h[0] = n * l + o * m, h[1] = n * p + o * d, h[2] = n * f + o * u, h[3] = n * c + o * y, h;
        }
        function quaternionToEuler(t, e) {
            var r = e[0], i = e[1], a = e[2], s = e[3], n = Math.atan2(2 * i * s - 2 * r * a, 1 - 2 * i * i - 2 * a * a), o = Math.asin(2 * r * i + 2 * a * s), h = Math.atan2(2 * r * s - 2 * i * a, 1 - 2 * r * r - 2 * a * a);
            t[0] = n / degToRads, t[1] = o / degToRads, t[2] = h / degToRads;
        }
        function createQuaternion(t) {
            var e = t[0] * degToRads, r = t[1] * degToRads, i = t[2] * degToRads, a = Math.cos(e / 2), s = Math.cos(r / 2), n = Math.cos(i / 2), o = Math.sin(e / 2), h = Math.sin(r / 2), l = Math.sin(i / 2);
            return [
                o * h * n + a * s * l,
                o * s * n + a * h * l,
                a * h * n - o * s * l,
                a * s * n - o * h * l
            ];
        }
        function getValueAtCurrentTime() {
            var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r && t >= r || this._caching.lastFrame < e && t < e))) {
                this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                var i = this.interpolateValue(t, this._caching);
                this.pv = i;
            }
            return this._caching.lastFrame = t, this.pv;
        }
        function setVValue(t) {
            var e;
            if ("unidimensional" === this.propType) e = t * this.mult, mathAbs(this.v - e) > 1e-5 && (this.v = e, this._mdf = !0);
            else for(var r = 0, i = this.v.length; r < i;)e = t[r] * this.mult, mathAbs(this.v[r] - e) > 1e-5 && (this.v[r] = e, this._mdf = !0), r += 1;
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                if (this.lock) this.setVValue(this.pv);
                else {
                    var t;
                    this.lock = !0, this._mdf = this._isFirstFrame;
                    var e = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
                    for(t = 0; t < e; t += 1)r = this.effectsSequence[t](r);
                    this.setVValue(r), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }
        function addEffect(t) {
            this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function ValueProperty(t, e, r, i) {
            this.propType = "unidimensional", this.mult = r || 1, this.data = e, this.v = r ? e.k * r : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function MultiDimensionalProperty(t, e, r, i) {
            var a;
            this.propType = "multidimensional", this.mult = r || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
            var s = e.k.length;
            for(this.v = createTypedArray("float32", s), this.pv = createTypedArray("float32", s), this.vel = createTypedArray("float32", s), a = 0; a < s; a += 1)this.v[a] = e.k[a] * this.mult, this.pv[a] = e.k[a];
            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function KeyframedValueProperty(t, e, r, i) {
            this.propType = "unidimensional", this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            }, this.k = !0, this.kf = !0, this.data = e, this.mult = r || 1, this.elem = t, this.container = i, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.addEffect = addEffect;
        }
        function KeyframedMultidimensionalProperty(t, e, r, i) {
            var a;
            this.propType = "multidimensional";
            var s, n, o, h, l = e.k.length;
            for(a = 0; a < l - 1; a += 1)e.k[a].to && e.k[a].s && e.k[a + 1] && e.k[a + 1].s && (s = e.k[a].s, n = e.k[a + 1].s, o = e.k[a].to, h = e.k[a].ti, (2 === s.length && (s[0] !== n[0] || s[1] !== n[1]) && bez.pointOnLine2D(s[0], s[1], n[0], n[1], s[0] + o[0], s[1] + o[1]) && bez.pointOnLine2D(s[0], s[1], n[0], n[1], n[0] + h[0], n[1] + h[1]) || 3 === s.length && (s[0] !== n[0] || s[1] !== n[1] || s[2] !== n[2]) && bez.pointOnLine3D(s[0], s[1], s[2], n[0], n[1], n[2], s[0] + o[0], s[1] + o[1], s[2] + o[2]) && bez.pointOnLine3D(s[0], s[1], s[2], n[0], n[1], n[2], n[0] + h[0], n[1] + h[1], n[2] + h[2])) && (e.k[a].to = null, e.k[a].ti = null), s[0] === n[0] && s[1] === n[1] && 0 === o[0] && 0 === o[1] && 0 === h[0] && 0 === h[1] && (2 === s.length || s[2] === n[2] && 0 === o[2] && 0 === h[2]) && (e.k[a].to = null, e.k[a].ti = null));
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.data = e, this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r || 1, this.elem = t, this.container = i, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
            var p = e.k[0].s.length;
            for(this.v = createTypedArray("float32", p), this.pv = createTypedArray("float32", p), a = 0; a < p; a += 1)this.v[a] = initFrame, this.pv[a] = initFrame;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray("float32", p)
            }, this.addEffect = addEffect;
        }
        var PropertyFactory = {
            getProp: function(t, e, r, i, a) {
                var s;
                if (e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length) {
                    if ("number" == typeof e.k[0]) s = new MultiDimensionalProperty(t, e, i, a);
                    else switch(r){
                        case 0:
                            s = new KeyframedValueProperty(t, e, i, a);
                            break;
                        case 1:
                            s = new KeyframedMultidimensionalProperty(t, e, i, a);
                    }
                } else s = new ValueProperty(t, e, i, a);
                return s.effectsSequence.length && a.addDynamicProperty(s), s;
            }
        };
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for(t = 0; t < e; t += 1)this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t) {
                this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t, this.setLength(e);
            for(var r = 0; r < e;)this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
        }, ShapePath.prototype.setLength = function(t) {
            for(; this._maxLength < t;)this.doubleArrayLength();
            this._length = t;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t, e, r, i, a) {
            var s;
            switch(this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r){
                case "v":
                    s = this.v;
                    break;
                case "i":
                    s = this.i;
                    break;
                case "o":
                    s = this.o;
                    break;
                default:
                    s = [];
            }
            (!s[i] || s[i] && !a) && (s[i] = pointPool.newElement()), s[i][0] = t, s[i][1] = e;
        }, ShapePath.prototype.setTripleAt = function(t, e, r, i, a, s, n, o) {
            this.setXYAt(t, e, "v", n, o), this.setXYAt(r, i, "o", n, o), this.setXYAt(a, s, "i", n, o);
        }, ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v, r = this.o, i = this.i, a = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), a = 1);
            var s, n = this._length - 1, o = this._length;
            for(s = a; s < o; s += 1)t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], r[n][0], r[n][1], s, !1), n -= 1;
            return t;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t) {
            var e, r = t._length;
            for(e = 0; e < r; e += 1)pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
            t._length = 0, t.c = !1;
        }), factory.clone = function(t) {
            var e, r = factory.newElement(), i = void 0 === t._length ? t.v.length : t._length;
            for(r.setLength(i), r.c = t.c, e = 0; e < i; e += 1)r.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
            return r;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for(t = 0; t < this._length; t += 1)shapePool.release(this.shapes[t]);
            this._length = 0;
        };
        var shapeCollectionPool = (ob = {
            newShapeCollection: function() {
                return _length ? pool[_length -= 1] : new ShapeCollection;
            },
            release: function(t) {
                var e, r = t._length;
                for(e = 0; e < r; e += 1)shapePool.release(t.shapes[e]);
                t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t, _length += 1;
            }
        }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
            function t(t, e, r) {
                var i, a, s, n, o, h, l, p, f, c = r.lastIndex, m = this.keyframes;
                if (t < m[0].t - this.offsetTime) i = m[0].s[0], s = !0, c = 0;
                else if (t >= m[m.length - 1].t - this.offsetTime) i = m[m.length - 1].s ? m[m.length - 1].s[0] : m[m.length - 2].e[0], s = !0;
                else {
                    for(var d, u, y, g = c, v = m.length - 1, b = !0; b && (d = m[g], !((u = m[g + 1]).t - this.offsetTime > t));)g < v - 1 ? g += 1 : b = !1;
                    if (y = this.keyframesMetadata[g] || {}, c = g, !(s = 1 === d.h)) {
                        if (t >= u.t - this.offsetTime) p = 1;
                        else if (t < d.t - this.offsetTime) p = 0;
                        else {
                            var x;
                            y.__fnct ? x = y.__fnct : (x = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get, y.__fnct = x), p = x((t - (d.t - this.offsetTime)) / (u.t - this.offsetTime - (d.t - this.offsetTime)));
                        }
                        a = u.s ? u.s[0] : d.e[0];
                    }
                    i = d.s[0];
                }
                for(h = e._length, l = i.i[0].length, r.lastIndex = c, n = 0; n < h; n += 1)for(o = 0; o < l; o += 1)f = s ? i.i[n][o] : i.i[n][o] + (a.i[n][o] - i.i[n][o]) * p, e.i[n][o] = f, f = s ? i.o[n][o] : i.o[n][o] + (a.o[n][o] - i.o[n][o]) * p, e.o[n][o] = f, f = s ? i.v[n][o] : i.v[n][o] + (a.v[n][o] - i.v[n][o]) * p, e.v[n][o] = f;
            }
            function e() {
                var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, i = this._caching.lastFrame;
                return -999999 !== i && (i < e && t < e || i > r && t > r) || (this._caching.lastIndex = i < t ? this._caching.lastIndex : 0, this.interpolateShape(t, this.pv, this._caching)), this._caching.lastFrame = t, this.pv;
            }
            function r() {
                this.paths = this.localShapeCollection;
            }
            function i(t) {
                (function(t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var r, i = t._length;
                    for(r = 0; r < i; r += 1)if (t.v[r][0] !== e.v[r][0] || t.v[r][1] !== e.v[r][1] || t.o[r][0] !== e.o[r][0] || t.o[r][1] !== e.o[r][1] || t.i[r][0] !== e.i[r][0] || t.i[r][1] !== e.i[r][1]) return !1;
                    return !0;
                })(this.v, t) || (this.v = shapePool.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t, e;
                            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r = this.effectsSequence.length;
                            for(e = 0; e < r; e += 1)t = this.effectsSequence[e](t);
                            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function s(t, e, i) {
                this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                var a = 3 === i ? e.pt.k : e.ks.k;
                this.v = shapePool.clone(a), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = [];
            }
            function n(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function o(t, i, a) {
                this.propType = "shape", this.comp = t.comp, this.elem = t, this.container = t, this.offsetTime = t.data.st, this.keyframes = 3 === a ? i.pt.k : i.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var s = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, s), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = r, this._caching = {
                    lastFrame: -999999,
                    lastIndex: 0
                }, this.effectsSequence = [
                    e.bind(this)
                ];
            }
            s.prototype.interpolateShape = t, s.prototype.getValue = a, s.prototype.setVValue = i, s.prototype.addEffect = n, o.prototype.getValue = a, o.prototype.interpolateShape = t, o.prototype.setVValue = i, o.prototype.addEffect = n;
            var h = function() {
                var t = roundCorner;
                function e(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e = this.p.v[0], r = this.p.v[1], i = this.s.v[0] / 2, a = this.s.v[1] / 2, s = 3 !== this.d, n = this.v;
                        n.v[0][0] = e, n.v[0][1] = r - a, n.v[1][0] = s ? e + i : e - i, n.v[1][1] = r, n.v[2][0] = e, n.v[2][1] = r + a, n.v[3][0] = s ? e - i : e + i, n.v[3][1] = r, n.i[0][0] = s ? e - i * t : e + i * t, n.i[0][1] = r - a, n.i[1][0] = s ? e + i : e - i, n.i[1][1] = r - a * t, n.i[2][0] = s ? e + i * t : e - i * t, n.i[2][1] = r + a, n.i[3][0] = s ? e - i : e + i, n.i[3][1] = r + a * t, n.o[0][0] = s ? e + i * t : e - i * t, n.o[0][1] = r - a, n.o[1][0] = s ? e + i : e - i, n.o[1][1] = r + a * t, n.o[2][0] = s ? e - i * t : e + i * t, n.o[2][1] = r + a, n.o[3][0] = s ? e - i : e + i, n.o[3][1] = r - a * t;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e), e;
            }(), l = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this), this.is = PropertyFactory.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t, e.or, 0, 0, this), this.os = PropertyFactory.getProp(t, e.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t, e, r, i, a = 2 * Math.floor(this.pt.v), s = 2 * Math.PI / a, n = !0, o = this.or.v, h = this.ir.v, l = this.os.v, p = this.is.v, f = 2 * Math.PI * o / (2 * a), c = 2 * Math.PI * h / (2 * a), m = -Math.PI / 2;
                        m += this.r.v;
                        var d = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t = 0; t < a; t += 1){
                            r = n ? l : p, i = n ? f : c;
                            var u = (e = n ? o : h) * Math.cos(m), y = e * Math.sin(m), g = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y), v = 0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                            u += +this.p.v[0], y += +this.p.v[1], this.v.setTripleAt(u, y, u - g * i * r * d, y - v * i * r * d, u + g * i * r * d, y + v * i * r * d, t, !0), n = !n, m += s * d;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t, e = Math.floor(this.pt.v), r = 2 * Math.PI / e, i = this.or.v, a = this.os.v, s = 2 * Math.PI * i / (4 * e), n = .5 * -Math.PI, o = 3 === this.data.d ? -1 : 1;
                        for(n += this.r.v, this.v._length = 0, t = 0; t < e; t += 1){
                            var h = i * Math.cos(n), l = i * Math.sin(n), p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l), f = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                            h += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(h, l, h - p * s * a * o, l - f * s * a * o, h + p * s * a * o, l + f * s * a * o, t, !0), n += r * o;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), p = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t.prototype = {
                    convertRectToPath: function() {
                        var t = this.p.v[0], e = this.p.v[1], r = this.s.v[0] / 2, i = this.s.v[1] / 2, a = bmMin(r, i, this.r.v), s = a * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + a, t + r, e - i + s, 0, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - s, t + r, e + i - a, 1, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e + i, t + r - a, e + i, t + r - s, e + i, 2, !0), this.v.setTripleAt(t - r + a, e + i, t - r + s, e + i, t - r + a, e + i, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - a, t - r, e + i - s, 4, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + s, t - r, e - i + a, 5, !0), this.v.setTripleAt(t - r + a, e - i, t - r + a, e - i, t - r + s, e - i, 6, !0), this.v.setTripleAt(t + r - a, e - i, t + r - s, e - i, t + r - a, e - i, 7, !0)) : (this.v.setTripleAt(t - r, e + i, t - r + s, e + i, t - r, e + i, 2), this.v.setTripleAt(t - r, e - i, t - r, e - i + s, t - r, e - i, 3))) : (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + s, t + r, e - i + a, 0, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e - i, t + r - a, e - i, t + r - s, e - i, 1, !0), this.v.setTripleAt(t - r + a, e - i, t - r + s, e - i, t - r + a, e - i, 2, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + a, t - r, e - i + s, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - s, t - r, e + i - a, 4, !0), this.v.setTripleAt(t - r + a, e + i, t - r + a, e + i, t - r + s, e + i, 5, !0), this.v.setTripleAt(t + r - a, e + i, t + r - s, e + i, t + r - a, e + i, 6, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - a, t + r, e + i - s, 7, !0)) : (this.v.setTripleAt(t - r, e - i, t - r + s, e - i, t - r, e - i, 1, !0), this.v.setTripleAt(t - r, e + i, t - r, e + i - s, t - r, e + i, 2, !0), this.v.setTripleAt(t + r, e + i, t + r - s, e + i, t + r, e + i, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: r
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }();
            var f = {
                getShapeProp: function(t, e, r) {
                    var i;
                    return 3 === r || 4 === r ? i = (3 === r ? e.pt : e.ks).k.length ? new o(t, e, r) : new s(t, e, r) : 5 === r ? i = new p(t, e) : 6 === r ? i = new h(t, e) : 7 === r && (i = new l(t, e)), i.k && t.addDynamicProperty(i), i;
                },
                getConstructorFunction: function() {
                    return s;
                },
                getKeyframedConstructorFunction: function() {
                    return o;
                }
            };
            return f;
        }(), Matrix = function() {
            var t = Math.cos, e = Math.sin, r = Math.tan, i = Math.round;
            function a() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function s(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(1, 0, 0, 0, 0, i, -a, 0, 0, a, i, 0, 0, 0, 0, 1);
            }
            function o(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, 0, a, 0, 0, 1, 0, 0, -a, 0, i, 0, 0, 0, 0, 1);
            }
            function h(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l(t, e) {
                return this._t(1, e, t, 1, 0, 0);
            }
            function p(t, e) {
                return this.shear(r(t), r(e));
            }
            function f(i, a) {
                var s = t(a), n = e(a);
                return this._t(s, n, 0, 0, -n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s, -n, 0, 0, n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function c(t, e, r) {
                return r || 0 === r || (r = 1), 1 === t && 1 === e && 1 === r ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1);
            }
            function m(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                return this.props[0] = t, this.props[1] = e, this.props[2] = r, this.props[3] = i, this.props[4] = a, this.props[5] = s, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = f, this.props[12] = c, this.props[13] = m, this.props[14] = d, this.props[15] = u, this;
            }
            function d(t, e, r) {
                return r = r || 0, 0 !== t || 0 !== e || 0 !== r ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1) : this;
            }
            function u(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                var y = this.props;
                if (1 === t && 0 === e && 0 === r && 0 === i && 0 === a && 1 === s && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === f) return y[12] = y[12] * t + y[15] * c, y[13] = y[13] * s + y[15] * m, y[14] = y[14] * p + y[15] * d, y[15] *= u, this._identityCalculated = !1, this;
                var g = y[0], v = y[1], b = y[2], x = y[3], E = y[4], S = y[5], P = y[6], C = y[7], _ = y[8], k = y[9], A = y[10], T = y[11], M = y[12], w = y[13], D = y[14], F = y[15];
                return y[0] = g * t + v * a + b * h + x * c, y[1] = g * e + v * s + b * l + x * m, y[2] = g * r + v * n + b * p + x * d, y[3] = g * i + v * o + b * f + x * u, y[4] = E * t + S * a + P * h + C * c, y[5] = E * e + S * s + P * l + C * m, y[6] = E * r + S * n + P * p + C * d, y[7] = E * i + S * o + P * f + C * u, y[8] = _ * t + k * a + A * h + T * c, y[9] = _ * e + k * s + A * l + T * m, y[10] = _ * r + k * n + A * p + T * d, y[11] = _ * i + k * o + A * f + T * u, y[12] = M * t + w * a + D * h + F * c, y[13] = M * e + w * s + D * l + F * m, y[14] = M * r + w * n + D * p + F * d, y[15] = M * i + w * o + D * f + F * u, this._identityCalculated = !1, this;
            }
            function y(t) {
                var e = t.props;
                return this.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
            }
            function g() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function v(t) {
                for(var e = 0; e < 16;){
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                }
                return !0;
            }
            function b(t) {
                var e;
                for(e = 0; e < 16; e += 1)t.props[e] = this.props[e];
                return t;
            }
            function x(t) {
                var e;
                for(e = 0; e < 16; e += 1)this.props[e] = t[e];
            }
            function E(t, e, r) {
                return {
                    x: t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                };
            }
            function S(t, e, r) {
                return t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12];
            }
            function P(t, e, r) {
                return t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13];
            }
            function C(t, e, r) {
                return t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14];
            }
            function _() {
                var t = this.props[0] * this.props[5] - this.props[1] * this.props[4], e = this.props[5] / t, r = -this.props[1] / t, i = -this.props[4] / t, a = this.props[0] / t, s = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t, n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t, o = new Matrix;
                return o.props[0] = e, o.props[1] = r, o.props[4] = i, o.props[5] = a, o.props[12] = s, o.props[13] = n, o;
            }
            function k(t) {
                return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
            }
            function A(t) {
                var e, r = t.length, i = [];
                for(e = 0; e < r; e += 1)i[e] = k(t[e]);
                return i;
            }
            function T(t, e, r) {
                var i = createTypedArray("float32", 6);
                if (this.isIdentity()) i[0] = t[0], i[1] = t[1], i[2] = e[0], i[3] = e[1], i[4] = r[0], i[5] = r[1];
                else {
                    var a = this.props[0], s = this.props[1], n = this.props[4], o = this.props[5], h = this.props[12], l = this.props[13];
                    i[0] = t[0] * a + t[1] * n + h, i[1] = t[0] * s + t[1] * o + l, i[2] = e[0] * a + e[1] * n + h, i[3] = e[0] * s + e[1] * o + l, i[4] = r[0] * a + r[1] * n + h, i[5] = r[0] * s + r[1] * o + l;
                }
                return i;
            }
            function M(t, e, r) {
                return this.isIdentity() ? [
                    t,
                    e,
                    r
                ] : [
                    t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                ];
            }
            function w(t, e) {
                if (this.isIdentity()) return t + "," + e;
                var r = this.props;
                return Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 + "," + Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100;
            }
            function D() {
                for(var t = 0, e = this.props, r = "matrix3d("; t < 16;)r += i(1e4 * e[t]) / 1e4, r += 15 === t ? ")" : ",", t += 1;
                return r;
            }
            function F(t) {
                return t < 1e-6 && t > 0 || t > -0.000001 && t < 0 ? i(1e4 * t) / 1e4 : t;
            }
            function I() {
                var t = this.props;
                return "matrix(" + F(t[0]) + "," + F(t[1]) + "," + F(t[4]) + "," + F(t[5]) + "," + F(t[12]) + "," + F(t[13]) + ")";
            }
            return function() {
                this.reset = a, this.rotate = s, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = p, this.skewFromAxis = f, this.shear = l, this.scale = c, this.setTransform = m, this.translate = d, this.transform = u, this.multiply = y, this.applyToPoint = E, this.applyToX = S, this.applyToY = P, this.applyToZ = C, this.applyToPointArray = M, this.applyToTriplePoints = T, this.applyToPointStringified = w, this.toCSS = D, this.to2dCSS = I, this.clone = b, this.cloneFromProps = x, this.equals = v, this.inversePoints = A, this.inversePoint = k, this.getInverseMatrix = _, this._t = this.transform, this.isIdentity = g, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t) {
            return (_typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t) {
            setLocationHref(t);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t);
        }
        function setPrefix(t) {
            setIdPrefix(t);
        }
        function loadAnimation(t) {
            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
        }
        function setQuality(t) {
            if ("string" == typeof t) switch(t){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t, e) {
            "expressions" === t && setExpressionsPlugin(e);
        }
        function getFactory(t) {
            switch(t){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t) {
            for(var e = queryString.split("&"), r = 0; r < e.length; r += 1){
                var i = e[r].split("=");
                if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}, e = {};
            return t.registerModifier = function(t, r) {
                e[t] || (e[t] = r);
            }, t.getModifier = function(t, r, i) {
                return new e[t](r, i);
            }, t;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this), this.e = PropertyFactory.getProp(t, e.e, 0, .01, this), this.o = PropertyFactory.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t, e, r, i, a) {
            var s = [];
            e <= 1 ? s.push({
                s: t,
                e: e
            }) : t >= 1 ? s.push({
                s: t - 1,
                e: e - 1
            }) : (s.push({
                s: t,
                e: 1
            }), s.push({
                s: 0,
                e: e - 1
            }));
            var n, o, h = [], l = s.length;
            for(n = 0; n < l; n += 1){
                var p, f;
                if (!((o = s[n]).e * a < i || o.s * a > i + r)) p = o.s * a <= i ? 0 : (o.s * a - i) / r, f = o.e * a >= i + r ? 1 : (o.e * a - i) / r, h.push([
                    p,
                    f
                ]);
            }
            return h.length || h.push([
                0,
                0
            ]), h;
        }, TrimModifier.prototype.releasePathsData = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)segmentsLengthPool.release(t[e]);
            return t.length = 0, t;
        }, TrimModifier.prototype.processShapes = function(t) {
            var e, r, i, a;
            if (this._mdf || t) {
                var s = this.o.v % 360 / 360;
                if (s < 0 && (s += 1), (e = this.s.v > 1 ? 1 + s : this.s.v < 0 ? 0 + s : this.s.v + s) > (r = this.e.v > 1 ? 1 + s : this.e.v < 0 ? 0 + s : this.e.v + s)) {
                    var n = e;
                    e = r, r = n;
                }
                e = 1e-4 * Math.round(1e4 * e), r = 1e-4 * Math.round(1e4 * r), this.sValue = e, this.eValue = r;
            } else e = this.sValue, r = this.eValue;
            var o, h, l, p, f, c = this.shapes.length, m = 0;
            if (r === e) for(a = 0; a < c; a += 1)this.shapes[a].localShapeCollection.releaseShapes(), this.shapes[a].shape._mdf = !0, this.shapes[a].shape.paths = this.shapes[a].localShapeCollection, this._mdf && (this.shapes[a].pathsData.length = 0);
            else if (1 === r && 0 === e || 0 === r && 1 === e) {
                if (this._mdf) for(a = 0; a < c; a += 1)this.shapes[a].pathsData.length = 0, this.shapes[a].shape._mdf = !0;
            } else {
                var d, u, y = [];
                for(a = 0; a < c; a += 1)if ((d = this.shapes[a]).shape._mdf || this._mdf || t || 2 === this.m) {
                    if (h = (i = d.shape.paths)._length, f = 0, !d.shape._mdf && d.pathsData.length) f = d.totalShapeLength;
                    else {
                        for(l = this.releasePathsData(d.pathsData), o = 0; o < h; o += 1)p = bez.getSegmentsLength(i.shapes[o]), l.push(p), f += p.totalLength;
                        d.totalShapeLength = f, d.pathsData = l;
                    }
                    m += f, d.shape._mdf = !0;
                } else d.shape.paths = d.localShapeCollection;
                var g, v = e, b = r, x = 0;
                for(a = c - 1; a >= 0; a -= 1)if ((d = this.shapes[a]).shape._mdf) {
                    for((u = d.localShapeCollection).releaseShapes(), 2 === this.m && c > 1 ? (g = this.calculateShapeEdges(e, r, d.totalShapeLength, x, m), x += d.totalShapeLength) : g = [
                        [
                            v,
                            b
                        ]
                    ], h = g.length, o = 0; o < h; o += 1){
                        v = g[o][0], b = g[o][1], y.length = 0, b <= 1 ? y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength * b
                        }) : v >= 1 ? y.push({
                            s: d.totalShapeLength * (v - 1),
                            e: d.totalShapeLength * (b - 1)
                        }) : (y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength
                        }), y.push({
                            s: 0,
                            e: d.totalShapeLength * (b - 1)
                        }));
                        var E = this.addShapes(d, y[0]);
                        if (y[0].s !== y[0].e) {
                            if (y.length > 1) {
                                if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                    var S = E.pop();
                                    this.addPaths(E, u), E = this.addShapes(d, y[1], S);
                                } else this.addPaths(E, u), E = this.addShapes(d, y[1]);
                            }
                            this.addPaths(E, u);
                        }
                    }
                    d.shape.paths = u;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e.addShape(t[r]);
        }, TrimModifier.prototype.addSegment = function(t, e, r, i, a, s, n) {
            a.setXYAt(e[0], e[1], "o", s), a.setXYAt(r[0], r[1], "i", s + 1), n && a.setXYAt(t[0], t[1], "v", s), a.setXYAt(i[0], i[1], "v", s + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t, e, r, i) {
            e.setXYAt(t[1], t[5], "o", r), e.setXYAt(t[2], t[6], "i", r + 1), i && e.setXYAt(t[0], t[4], "v", r), e.setXYAt(t[3], t[7], "v", r + 1);
        }, TrimModifier.prototype.addShapes = function(t, e, r) {
            var i, a, s, n, o, h, l, p, f = t.pathsData, c = t.shape.paths.shapes, m = t.shape.paths._length, d = 0, u = [], y = !0;
            for(r ? (o = r._length, p = r._length) : (r = shapePool.newElement(), o = 0, p = 0), u.push(r), i = 0; i < m; i += 1){
                for(h = f[i].lengths, r.c = c[i].c, s = c[i].c ? h.length : h.length + 1, a = 1; a < s; a += 1)if (d + (n = h[a - 1]).addedLength < e.s) d += n.addedLength, r.c = !1;
                else {
                    if (d > e.e) {
                        r.c = !1;
                        break;
                    }
                    e.s <= d && e.e >= d + n.addedLength ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[a], c[i].v[a], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[a], c[i].o[a - 1], c[i].i[a], (e.s - d) / n.addedLength, (e.e - d) / n.addedLength, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1), d += n.addedLength, o += 1;
                }
                if (c[i].c && h.length) {
                    if (n = h[a - 1], d <= e.e) {
                        var g = h[a - 1].addedLength;
                        e.s <= d && e.e >= d + g ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[0], c[i].v[0], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[0], c[i].o[a - 1], c[i].i[0], (e.s - d) / g, (e.e - d) / g, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1);
                    } else r.c = !1;
                    d += n.addedLength, o += 1;
                }
                if (r._length && (r.setXYAt(r.v[p][0], r.v[p][1], "i", p), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), d > e.e) break;
                i < m - 1 && (r = shapePool.newElement(), y = !0, u.push(r), o = 0);
            }
            return u;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r = e / 100, i = [
                0,
                0
            ], a = t._length, s = 0;
            for(s = 0; s < a; s += 1)i[0] += t.v[s][0], i[1] += t.v[s][1];
            i[0] /= a, i[1] /= a;
            var n, o, h, l, p, f, c = shapePool.newElement();
            for(c.c = t.c, s = 0; s < a; s += 1)n = t.v[s][0] + (i[0] - t.v[s][0]) * r, o = t.v[s][1] + (i[1] - t.v[s][1]) * r, h = t.o[s][0] + (i[0] - t.o[s][0]) * -r, l = t.o[s][1] + (i[1] - t.o[s][1]) * -r, p = t.i[s][0] + (i[0] - t.i[s][0]) * -r, f = t.i[s][1] + (i[1] - t.i[s][1]) * -r, c.setTripleAt(n, o, h, l, p, f, s);
            return c;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t = [
                0,
                0
            ];
            function e(t, e, r) {
                if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r || t), e.p && e.p.s ? (this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t, e.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e.rx) {
                    if (this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this), e.or.k[0].ti) {
                        var i, a = e.or.k.length;
                        for(i = 0; i < a; i += 1)e.or.k[i].to = null, e.or.k[i].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t, e.r || {
                    k: 0
                }, 0, degToRads, this);
                e.sk && (this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t, e.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e.o ? this.o = PropertyFactory.getProp(t, e.o, 0, .01, t) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e.prototype = {
                applyToMatrix: function(t) {
                    var e = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                            var r;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i, a;
                                if (r = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r, 0), a = this.p.getValueAtTime(this.p.keyframes[0].t / r, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r, 0), a = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r, 0)) : (i = this.p.pv, a = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i = [], a = [];
                                    var s = this.px, n = this.py;
                                    s._caching.lastFrame + s.offsetTime <= s.keyframes[0].t ? (i[0] = s.getValueAtTime((s.keyframes[0].t + .01) / r, 0), i[1] = n.getValueAtTime((n.keyframes[0].t + .01) / r, 0), a[0] = s.getValueAtTime(s.keyframes[0].t / r, 0), a[1] = n.getValueAtTime(n.keyframes[0].t / r, 0)) : s._caching.lastFrame + s.offsetTime >= s.keyframes[s.keyframes.length - 1].t ? (i[0] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / r, 0), i[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / r, 0), a[0] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - .01) / r, 0), a[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / r, 0)) : (i = [
                                        s.pv,
                                        n.pv
                                    ], a[0] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - .01) / r, s.offsetTime), a[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / r, n.offsetTime));
                                } else i = a = t;
                                this.v.rotate(-Math.atan2(i[1] - a[1], i[0] - a[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e), e.prototype.addDynamicProperty = function(t) {
                this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
            }, e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t, r, i) {
                    return new e(t, r, i);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t, e) {
            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5;
        }
        function lerp(t, e, r) {
            return t * (1 - r) + e * r;
        }
        function lerpPoint(t, e, r) {
            return [
                lerp(t[0], e[0], r),
                lerp(t[1], e[1], r)
            ];
        }
        function quadRoots(t, e, r) {
            if (0 === t) return [];
            var i = e * e - 4 * t * r;
            if (i < 0) return [];
            var a = -e / (2 * t);
            if (0 === i) return [
                a
            ];
            var s = Math.sqrt(i) / (2 * t);
            return [
                a - s,
                a + s
            ];
        }
        function polynomialCoefficients(t, e, r, i) {
            return [
                3 * e - t - 3 * r + i,
                3 * t - 6 * e + 3 * r,
                -3 * t + 3 * e,
                t
            ];
        }
        function singlePoint(t) {
            return new PolynomialBezier(t, t, t, t, !1);
        }
        function PolynomialBezier(t, e, r, i, a) {
            a && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), a && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
            var s = polynomialCoefficients(t[0], e[0], r[0], i[0]), n = polynomialCoefficients(t[1], e[1], r[1], i[1]);
            this.a = [
                s[0],
                n[0]
            ], this.b = [
                s[1],
                n[1]
            ], this.c = [
                s[2],
                n[2]
            ], this.d = [
                s[3],
                n[3]
            ], this.points = [
                t,
                e,
                r,
                i
            ];
        }
        function extrema(t, e) {
            var r = t.points[0][e], i = t.points[t.points.length - 1][e];
            if (r > i) {
                var a = i;
                i = r, r = a;
            }
            for(var s = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < s.length; n += 1)if (s[n] > 0 && s[n] < 1) {
                var o = t.point(s[n])[e];
                o < r ? r = o : o > i && (i = o);
            }
            return {
                min: r,
                max: i
            };
        }
        function intersectData(t, e, r) {
            var i = t.boundingBox();
            return {
                cx: i.cx,
                cy: i.cy,
                width: i.width,
                height: i.height,
                bez: t,
                t: (e + r) / 2,
                t1: e,
                t2: r
            };
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [
                intersectData(e[0], t.t1, t.t),
                intersectData(e[1], t.t, t.t2)
            ];
        }
        function boxIntersect(t, e) {
            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
        }
        function intersectsImpl(t, e, r, i, a, s) {
            if (boxIntersect(t, e)) {
                if (r >= s || t.width <= i && t.height <= i && e.width <= i && e.height <= i) a.push([
                    t.t,
                    e.t
                ]);
                else {
                    var n = splitData(t), o = splitData(e);
                    intersectsImpl(n[0], o[0], r + 1, i, a, s), intersectsImpl(n[0], o[1], r + 1, i, a, s), intersectsImpl(n[1], o[0], r + 1, i, a, s), intersectsImpl(n[1], o[1], r + 1, i, a, s);
                }
            }
        }
        function crossProduct(t, e) {
            return [
                t[1] * e[2] - t[2] * e[1],
                t[2] * e[0] - t[0] * e[2],
                t[0] * e[1] - t[1] * e[0]
            ];
        }
        function lineIntersection(t, e, r, i) {
            var a = [
                t[0],
                t[1],
                1
            ], s = [
                e[0],
                e[1],
                1
            ], n = [
                r[0],
                r[1],
                1
            ], o = [
                i[0],
                i[1],
                1
            ], h = crossProduct(crossProduct(a, s), crossProduct(n, o));
            return floatZero(h[2]) ? null : [
                h[0] / h[2],
                h[1] / h[2]
            ];
        }
        function polarOffset(t, e, r) {
            return [
                t[0] + Math.cos(e) * r,
                t[1] - Math.sin(e) * r
            ];
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1]);
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t, e, r, i, a, s, n) {
            var o = r - Math.PI / 2, h = r + Math.PI / 2, l = e[0] + Math.cos(r) * i * a, p = e[1] - Math.sin(r) * i * a;
            t.setTripleAt(l, p, l + Math.cos(o) * s, p - Math.sin(o) * s, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
        }
        function getPerpendicularVector(t, e) {
            var r = [
                e[0] - t[0],
                e[1] - t[1]
            ], i = .5 * -Math.PI;
            return [
                Math.cos(i) * r[0] - Math.sin(i) * r[1],
                Math.sin(i) * r[0] + Math.cos(i) * r[1]
            ];
        }
        function getProjectingAngle(t, e) {
            var r = 0 === e ? t.length() - 1 : e - 1, i = (e + 1) % t.length(), a = getPerpendicularVector(t.v[r], t.v[i]);
            return Math.atan2(0, 1) - Math.atan2(a[1], a[0]);
        }
        function zigZagCorner(t, e, r, i, a, s, n) {
            var o = getProjectingAngle(e, r), h = e.v[r % e._length], l = e.v[0 === r ? e._length - 1 : r - 1], p = e.v[(r + 1) % e._length], f = 2 === s ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0, c = 2 === s ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r % e._length], o, n, i, c / (2 * (a + 1)), f / (2 * (a + 1)), s);
        }
        function zigZagSegment(t, e, r, i, a, s) {
            for(var n = 0; n < i; n += 1){
                var o = (n + 1) / (i + 1), h = 2 === a ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0, l = e.normalAngle(o);
                setPoint(t, e.point(o), l, s, r, h / (2 * (i + 1)), h / (2 * (i + 1)), a), s = -s;
            }
            return s;
        }
        function linearOffset(t, e, r) {
            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [
                polarOffset(t, i, r),
                polarOffset(e, i, r)
            ];
        }
        function offsetSegment(t, e) {
            var r, i, a, s, n, o, h;
            r = (h = linearOffset(t.points[0], t.points[1], e))[0], i = h[1], a = (h = linearOffset(t.points[1], t.points[2], e))[0], s = h[1], n = (h = linearOffset(t.points[2], t.points[3], e))[0], o = h[1];
            var l = lineIntersection(r, i, a, s);
            null === l && (l = i);
            var p = lineIntersection(n, o, a, s);
            return null === p && (p = n), new PolynomialBezier(r, l, p, o);
        }
        function joinLines(t, e, r, i, a) {
            var s = e.points[3], n = r.points[0];
            if (3 === i) return s;
            if (pointEqual(s, n)) return s;
            if (2 === i) {
                var o = -e.tangentAngle(1), h = -r.tangentAngle(0) + Math.PI, l = lineIntersection(s, polarOffset(s, o + Math.PI / 2, 100), n, polarOffset(n, o + Math.PI / 2, 100)), p = l ? pointDistance(l, s) : pointDistance(s, n) / 2, f = polarOffset(s, o, 2 * p * roundCorner);
                return t.setXYAt(f[0], f[1], "o", t.length() - 1), f = polarOffset(n, h, 2 * p * roundCorner), t.setTripleAt(n[0], n[1], n[0], n[1], f[0], f[1], t.length()), n;
            }
            var c = lineIntersection(pointEqual(s, e.points[2]) ? e.points[0] : e.points[2], s, n, pointEqual(n, r.points[1]) ? r.points[3] : r.points[1]);
            return c && pointDistance(c, s) < a ? (t.setTripleAt(c[0], c[1], c[0], c[1], c[0], c[1], t.length()), c) : s;
        }
        function getIntersection(t, e) {
            var r = t.intersections(e);
            return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
        }
        function pruneSegmentIntersection(t, e) {
            var r = t.slice(), i = e.slice(), a = getIntersection(t[t.length - 1], e[0]);
            return a && (r[t.length - 1] = t[t.length - 1].split(a[0])[0], i[0] = e[0].split(a[1])[1]), t.length > 1 && e.length > 1 && (a = getIntersection(t[0], e[e.length - 1])) ? [
                [
                    t[0].split(a[0])[0]
                ],
                [
                    e[e.length - 1].split(a[1])[1]
                ]
            ] : [
                r,
                i
            ];
        }
        function pruneIntersections(t) {
            for(var e, r = 1; r < t.length; r += 1)e = pruneSegmentIntersection(t[r - 1], t[r]), t[r - 1] = e[0], t[r] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
        }
        function offsetSegmentSplit(t, e) {
            var r, i, a, s, n = t.inflectionPoints();
            if (0 === n.length) return [
                offsetSegment(t, e)
            ];
            if (1 === n.length || floatEqual(n[1], 1)) return r = (a = t.split(n[0]))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(i, e)
            ];
            r = (a = t.split(n[0]))[0];
            var o = (n[1] - n[0]) / (1 - n[0]);
            return s = (a = a[1].split(o))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(s, e),
                offsetSegment(i, e)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t) {
            for(var e = t.fStyle ? t.fStyle.split(" ") : [], r = "normal", i = "normal", a = e.length, s = 0; s < a; s += 1)switch(e[s].toLowerCase()){
                case "italic":
                    i = "italic";
                    break;
                case "bold":
                    r = "700";
                    break;
                case "black":
                    r = "900";
                    break;
                case "medium":
                    r = "500";
                    break;
                case "regular":
                case "normal":
                    r = "400";
                    break;
                case "light":
                case "thin":
                    r = "200";
            }
            return {
                style: i,
                weight: t.fWeight || r
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, e.c, 0, null, this), this.o = PropertyFactory.getProp(t, e.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this), this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t, e, r, i, a, s) {
            var n = s ? -1 : 1, o = i.s.v[0] + (1 - i.s.v[0]) * (1 - a), h = i.s.v[1] + (1 - i.s.v[1]) * (1 - a);
            t.translate(i.p.v[0] * n * a, i.p.v[1] * n * a, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * a), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(s ? 1 / o : o, s ? 1 / h : h), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t, e, r, i) {
            for(this.elem = t, this.arr = e, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[r]); r > 0;)r -= 1, this._elements.unshift(e[r]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
        }, RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e), e;
        }, RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r]._render = e, "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
        }, RepeaterModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n = !1;
            if (this._mdf || t) {
                var o, h = Math.ceil(this.c.v);
                if (this._groups.length < h) {
                    for(; this._groups.length < h;){
                        var l = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n = !0;
                }
                for(s = 0, i = 0; i <= this._groups.length - 1; i += 1){
                    if (o = s < h, this._groups[i]._render = o, this.changeGroupRender(this._groups[i].it, o), !o) {
                        var p = this.elemsData[i].it, f = p[p.length - 1];
                        0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
                    }
                    s += 1;
                }
                this._currentCopies = h;
                var c = this.o.v, m = c % 1, d = c > 0 ? Math.floor(c) : Math.ceil(c), u = this.pMatrix.props, y = this.rMatrix.props, g = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v, b, x = 0;
                if (c > 0) {
                    for(; x < d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), x += 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, m, !1), x += m);
                } else if (c < 0) {
                    for(; x > d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), x -= 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -m, !0), x -= m);
                }
                for(i = 1 === this.data.m ? 0 : this._currentCopies - 1, a = 1 === this.data.m ? 1 : -1, s = this._currentCopies; s;){
                    if (b = (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), 0 !== x) {
                        for((0 !== i && 1 === a || i !== this._currentCopies - 1 && -1 === a) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                    x += 1, s -= 1, i += a;
                }
            } else for(s = this._currentCopies, i = 0, a = 1; s;)r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, s -= 1, i += a;
            return n;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t, e) {
            var r, i = shapePool.newElement();
            i.c = t.c;
            var a, s, n, o, h, l, p, f, c, m, d, u, y = t._length, g = 0;
            for(r = 0; r < y; r += 1)a = t.v[r], n = t.o[r], s = t.i[r], a[0] === n[0] && a[1] === n[1] && a[0] === s[0] && a[1] === s[1] ? 0 !== r && r !== y - 1 || t.c ? (o = 0 === r ? t.v[y - 1] : t.v[r - 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = a[0] + (o[0] - a[0]) * l, f = u = a[1] - (a[1] - o[1]) * l, c = p - (p - a[0]) * roundCorner, m = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1, o = r === y - 1 ? t.v[0] : t.v[r + 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = c = a[0] + (o[0] - a[0]) * l, f = m = a[1] + (o[1] - a[1]) * l, d = p - (p - a[0]) * roundCorner, u = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1) : (i.setTripleAt(a[0], a[1], n[0], n[1], s[0], s[1], g), g += 1) : (i.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], g), g += 1);
            return i;
        }, RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.rd.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t) {
            return [
                ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t) {
            return [
                (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t)) return [];
            var e = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, r = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r < 0) return [];
            var i = Math.sqrt(r);
            return floatZero(i) ? i > 0 && i < 1 ? [
                e
            ] : [] : [
                e - i,
                e + i
            ].filter(function(t) {
                return t > 0 && t < 1;
            });
        }, PolynomialBezier.prototype.split = function(t) {
            if (t <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e = lerpPoint(this.points[0], this.points[1], t), r = lerpPoint(this.points[1], this.points[2], t), i = lerpPoint(this.points[2], this.points[3], t), a = lerpPoint(e, r, t), s = lerpPoint(r, i, t), n = lerpPoint(a, s, t);
            return [
                new PolynomialBezier(this.points[0], e, a, n, !0),
                new PolynomialBezier(n, s, i, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t, e, r) {
            void 0 === e && (e = 2), void 0 === r && (r = 7);
            var i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r), i;
        }, PolynomialBezier.shapeSegment = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t, e, r, i) {
            var a = t._length, s = shapePool.newElement();
            if (s.c = t.c, t.c || (a -= 1), 0 === a) return s;
            var n = -1, o = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(s, t, 0, e, r, i, n);
            for(var h = 0; h < a; h += 1)n = zigZagSegment(s, o, e, r, i, -n), o = h !== a - 1 || t.c ? PolynomialBezier.shapeSegment(t, (h + 1) % a) : null, zigZagCorner(s, t, h + 1, e, r, i, n);
            return s;
        }, ZigZagModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), p = this.pointsType.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, l, p));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this), this.lineJoin = e.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t, e, r, i) {
            var a = shapePool.newElement();
            a.c = t.c;
            var s, n, o, h = t.length();
            t.c || (h -= 1);
            var l = [];
            for(s = 0; s < h; s += 1)o = PolynomialBezier.shapeSegment(t, s), l.push(offsetSegmentSplit(o, e));
            if (!t.c) for(s = h - 1; s >= 0; s -= 1)o = PolynomialBezier.shapeSegmentInverted(t, s), l.push(offsetSegmentSplit(o, e));
            l = pruneIntersections(l);
            var p = null, f = null;
            for(s = 0; s < l.length; s += 1){
                var c = l[s];
                for(f && (p = joinLines(a, f, c[0], r, i)), f = c[c.length - 1], n = 0; n < c.length; n += 1)o = c[n], p && pointEqual(o.points[0], p) ? a.setXYAt(o.points[1][0], o.points[1][1], "o", a.length() - 1) : a.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], a.length()), a.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], a.length()), p = o.points[3];
            }
            return l.length && joinLines(a, f, l[0][0], r, i), a;
        }, OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v, l = this.miterLimit.v, p = this.lineJoin;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, p, l));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e = [];
            e = e.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ];
            function i(t, e) {
                var r = createTag("span");
                r.setAttribute("aria-hidden", !0), r.style.fontFamily = e;
                var i = createTag("span");
                i.innerText = "giItT1WQy@!-/#", r.style.position = "absolute", r.style.left = "-10000px", r.style.top = "-10000px", r.style.fontSize = "300px", r.style.fontVariant = "normal", r.style.fontStyle = "normal", r.style.fontWeight = "normal", r.style.letterSpacing = "0", r.appendChild(i), document.body.appendChild(r);
                var a = i.offsetWidth;
                return i.style.fontFamily = function(t) {
                    var e, r = t.split(","), i = r.length, a = [];
                    for(e = 0; e < i; e += 1)"sans-serif" !== r[e] && "monospace" !== r[e] && a.push(r[e]);
                    return a.join(",");
                }(t) + ", " + e, {
                    node: i,
                    w: a,
                    parent: r
                };
            }
            function a(t, e) {
                var r, i = document.body && e ? "svg" : "canvas", a = getFontProperties(t);
                if ("svg" === i) {
                    var s = createNS("text");
                    s.style.fontSize = "100px", s.setAttribute("font-family", t.fFamily), s.setAttribute("font-style", a.style), s.setAttribute("font-weight", a.weight), s.textContent = "1", t.fClass ? (s.style.fontFamily = "inherit", s.setAttribute("class", t.fClass)) : s.style.fontFamily = t.fFamily, e.appendChild(s), r = s;
                } else {
                    var n = new OffscreenCanvas(500, 500).getContext("2d");
                    n.font = a.style + " " + a.weight + " 100px " + t.fFamily, r = n;
                }
                return {
                    measureText: function(t) {
                        return "svg" === i ? (r.textContent = t, r.getComputedTextLength()) : r.measureText(t).width;
                    }
                };
            }
            function s(t) {
                var e = 0, r = t.charCodeAt(0);
                if (r >= 55296 && r <= 56319) {
                    var i = t.charCodeAt(1);
                    i >= 56320 && i <= 57343 && (e = 1024 * (r - 55296) + i - 56320 + 65536);
                }
                return e;
            }
            function n(t) {
                var e = s(t);
                return e >= 127462 && e <= 127487;
            }
            var o = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            return o.isModifier = function(t, e) {
                var i = t.toString(16) + e.toString(16);
                return -1 !== r.indexOf(i);
            }, o.isZeroWidthJoiner = function(t) {
                return 8205 === t;
            }, o.isFlagEmoji = function(t) {
                return n(t.substr(0, 2)) && n(t.substr(2, 2));
            }, o.isRegionalCode = n, o.isCombinedCharacter = function(t) {
                return -1 !== e.indexOf(t);
            }, o.isRegionalFlag = function(t, e) {
                var r = s(t.substr(e, 2));
                if (127988 !== r) return !1;
                var i = 0;
                for(e += 2; i < 5;){
                    if ((r = s(t.substr(e, 2))) < 917601 || r > 917626) return !1;
                    i += 1, e += 2;
                }
                return 917631 === s(t.substr(e, 2));
            }, o.isVariationSelector = function(t) {
                return 65039 === t;
            }, o.BLACK_FLAG_CODE_POINT = 127988, o.prototype = {
                addChars: function(t) {
                    if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var r, i, a = t.length, s = this.chars.length;
                        for(e = 0; e < a; e += 1){
                            for(r = 0, i = !1; r < s;)this.chars[r].style === t[e].style && this.chars[r].fFamily === t[e].fFamily && this.chars[r].ch === t[e].ch && (i = !0), r += 1;
                            i || (this.chars.push(t[e]), s += 1);
                        }
                    }
                },
                addFonts: function(t, e) {
                    if (t) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                        if (!document.body) return this.isLoaded = !0, t.list.forEach(function(t) {
                            t.helper = a(t), t.cache = {};
                        }), void (this.fonts = t.list);
                        var r, s = t.list, n = s.length, o = n;
                        for(r = 0; r < n; r += 1){
                            var h, l, p = !0;
                            if (s[r].loaded = !1, s[r].monoCase = i(s[r].fFamily, "monospace"), s[r].sansCase = i(s[r].fFamily, "sans-serif"), s[r].fPath) {
                                if ("p" === s[r].fOrigin || 3 === s[r].origin) {
                                    if ((h = document.querySelectorAll('style[f-forigin="p"][f-family="' + s[r].fFamily + '"], style[f-origin="3"][f-family="' + s[r].fFamily + '"]')).length > 0 && (p = !1), p) {
                                        var f = createTag("style");
                                        f.setAttribute("f-forigin", s[r].fOrigin), f.setAttribute("f-origin", s[r].origin), f.setAttribute("f-family", s[r].fFamily), f.type = "text/css", f.innerText = "@font-face {font-family: " + s[r].fFamily + "; font-style: normal; src: url('" + s[r].fPath + "');}", e.appendChild(f);
                                    }
                                } else if ("g" === s[r].fOrigin || 1 === s[r].origin) {
                                    for(h = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < h.length; l += 1)-1 !== h[l].href.indexOf(s[r].fPath) && (p = !1);
                                    if (p) {
                                        var c = createTag("link");
                                        c.setAttribute("f-forigin", s[r].fOrigin), c.setAttribute("f-origin", s[r].origin), c.type = "text/css", c.rel = "stylesheet", c.href = s[r].fPath, document.body.appendChild(c);
                                    }
                                } else if ("t" === s[r].fOrigin || 2 === s[r].origin) {
                                    for(h = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < h.length; l += 1)s[r].fPath === h[l].src && (p = !1);
                                    if (p) {
                                        var m = createTag("link");
                                        m.setAttribute("f-forigin", s[r].fOrigin), m.setAttribute("f-origin", s[r].origin), m.setAttribute("rel", "stylesheet"), m.setAttribute("href", s[r].fPath), e.appendChild(m);
                                    }
                                }
                            } else s[r].loaded = !0, o -= 1;
                            s[r].helper = a(s[r], e), s[r].cache = {}, this.fonts.push(s[r]);
                        }
                        0 === o ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e, r, i) {
                    for(var a = 0, s = this.chars.length; a < s;){
                        if (this.chars[a].ch === e && this.chars[a].style === r && this.chars[a].fFamily === i) return this.chars[a];
                        a += 1;
                    }
                    return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0), t;
                },
                getFontByName: function(t) {
                    for(var e = 0, r = this.fonts.length; e < r;){
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t, e, r) {
                    var i = this.getFontByName(e), a = t;
                    if (!i.cache[a]) {
                        var s = i.helper;
                        if (" " === t) {
                            var n = s.measureText("|" + t + "|"), o = s.measureText("||");
                            i.cache[a] = (n - o) / 100;
                        } else i.cache[a] = s.measureText(t) / 100;
                    }
                    return i.cache[a] * r;
                },
                checkLoadedFonts: function() {
                    var t, e, r, i = this.fonts.length, a = i;
                    for(t = 0; t < i; t += 1)this.fonts[t].loaded ? a -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, r = this.fonts[t].monoCase.w, e.offsetWidth !== r ? (a -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, r = this.fonts[t].sansCase.w, e.offsetWidth !== r && (a -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== a && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            }, o;
        }();
        function SlotManager(t) {
            this.animationData = t;
        }
        function slotFactory(t) {
            return new SlotManager(t);
        }
        function RenderableElement() {}
        SlotManager.prototype.getProp = function(t) {
            return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
        }, RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t) {
                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
            },
            removeRenderableComponent: function(t) {
                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
            },
            prepareRenderableFrame: function(t) {
                this.checkLayerLimits(t);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t) {
                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t, e = this.renderableComponents.length;
                for(t = 0; t < e; t += 1)this.renderableComponents[t].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t) {
            return blendModeEnums[t] || "";
        }), blendModeEnums;
        function SliderEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function AngleEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function ColorEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function PointEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function LayerIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function MaskIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function CheckboxEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t, e) {
            var r, i = t.ef || [];
            this.effectElements = [];
            var a, s = i.length;
            for(r = 0; r < s; r += 1)a = new GroupEffect(i[r], e), this.effectElements.push(a);
        }
        function GroupEffect(t, e) {
            this.init(t, e);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, r);
        }
        function AudioElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, r), this._isPlaying = !1, this._canPlay = !1;
            var i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, e) {
            var r;
            this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
            var i, a = this.data.ef.length, s = this.data.ef;
            for(r = 0; r < a; r += 1){
                switch(i = null, s[r].ty){
                    case 0:
                        i = new SliderEffect(s[r], e, this);
                        break;
                    case 1:
                        i = new AngleEffect(s[r], e, this);
                        break;
                    case 2:
                        i = new ColorEffect(s[r], e, this);
                        break;
                    case 3:
                        i = new PointEffect(s[r], e, this);
                        break;
                    case 4:
                    case 7:
                        i = new CheckboxEffect(s[r], e, this);
                        break;
                    case 10:
                        i = new LayerIndexEffect(s[r], e, this);
                        break;
                    case 11:
                        i = new MaskIndexEffect(s[r], e, this);
                        break;
                    case 5:
                        i = new EffectsManager(s[r], e, this);
                        break;
                    default:
                        i = new NoValueEffect(s[r], e, this);
                }
                i && this.effectElements.push(i);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t = 0, e = this.data.masksProperties.length; t < e;){
                    if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                    t += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t = getExpressionInterfaces();
                if (t) {
                    var e = t("layer"), r = t("effects"), i = t("shape"), a = t("text"), s = t("comp");
                    this.layerInterface = e(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n = r.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n), 0 === this.data.ty || this.data.xt ? this.compInterface = s(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
            },
            initBaseData: function(t, e, r) {
                this.globalData = e, this.comp = r, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t, e) {
                var r, i = this.dynamicProperties.length;
                for(r = 0; r < i; r += 1)(e || this._isParent && "transform" === this.dynamicProperties[r].propType) && (this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e;
            }
            this._volume = this.lv.v[0];
            var r = this._volume * this._volumeMultiplier;
            this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t);
        }, AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t) {
            var e, r, i = this.layers.length;
            for(this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)this.elements[e] || (r = this.layers[e]).ip - r.st <= t - this.layers[e].st && r.op - r.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t) {
            switch(t.ty){
                case 2:
                    return this.createImage(t);
                case 0:
                    return this.createComp(t);
                case 1:
                    return this.createSolid(t);
                case 3:
                    return this.createNull(t);
                case 4:
                    return this.createShape(t);
                case 5:
                    return this.createText(t);
                case 6:
                    return this.createAudio(t);
                case 13:
                    return this.createCamera(t);
                case 15:
                    return this.createFootage(t);
                default:
                    return this.createNull(t);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.buildItem(t);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t) {
            var e;
            this.completeLayers = !1;
            var r, i = t.length, a = this.layers.length;
            for(e = 0; e < i; e += 1)for(r = 0; r < a;){
                if (this.layers[r].id === t[e].id) {
                    this.layers[r] = t[e];
                    break;
                }
                r += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t, e, r) {
            for(var i = this.elements, a = this.layers, s = 0, n = a.length; s < n;)a[s].ind == e && (i[s] && !0 !== i[s] ? (r.push(i[s]), i[s].setAsParent(), void 0 !== a[s].parent ? this.buildElementParenting(t, a[s].parent, r) : t.setHierarchy(r)) : (this.buildItem(s), this.addPendingElement(t))), s += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var i = this.createComp(t[e]);
                i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
            }
        }, BaseRenderer.prototype.getElementById = function(t) {
            var e, r = this.elements.length;
            for(e = 0; e < r; e += 1)if (this.elements[e].data.ind === t) return this.elements[e];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t) {
            var e, r = t.shift();
            if ("number" == typeof r) e = this.elements[r];
            else {
                var i, a = this.elements.length;
                for(i = 0; i < a; i += 1)if (this.elements[i].data.nm === r) {
                    e = this.elements[i];
                    break;
                }
            }
            return 0 === t.length ? e : e.getElementByPath(t);
        }, BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager, this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                w: t.w,
                h: t.h
            };
        };
        var effectTypes = {
            TRANSFORM_EFFECT: "transformEFfect"
        };
        function TransformElement() {}
        function MaskElement(t, e, r) {
            this.data = t, this.element = e, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i, a, s = this.globalData.defs, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n), this.solidPath = "";
            var o, h, l, p, f, c, m = this.masksProperties, d = 0, u = [], y = createElementID(), g = "clipPath", v = "clip-path";
            for(i = 0; i < n; i += 1)if (("a" !== m[i].mode && "n" !== m[i].mode || m[i].inv || 100 !== m[i].o.k || m[i].o.x) && (g = "mask", v = "mask"), "s" !== m[i].mode && "i" !== m[i].mode || 0 !== d ? l = null : ((l = createNS("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), u.push(l)), a = createNS("path"), "n" === m[i].mode) this.viewData[i] = {
                op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                elem: a,
                lastPath: ""
            }, s.appendChild(a);
            else {
                var b;
                if (d += 1, a.setAttribute("fill", "s" === m[i].mode ? "#000000" : "#ffffff"), a.setAttribute("clip-rule", "nonzero"), 0 !== m[i].x.k ? (g = "mask", v = "mask", c = PropertyFactory.getProp(this.element, m[i].x, 0, null, this.element), b = createElementID(), (p = createNS("filter")).setAttribute("id", b), (f = createNS("feMorphology")).setAttribute("operator", "erode"), f.setAttribute("in", "SourceGraphic"), f.setAttribute("radius", "0"), p.appendChild(f), s.appendChild(p), a.setAttribute("stroke", "s" === m[i].mode ? "#000000" : "#ffffff")) : (f = null, c = null), this.storedData[i] = {
                    elem: a,
                    x: c,
                    expan: f,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b,
                    lastRadius: 0
                }, "i" === m[i].mode) {
                    h = u.length;
                    var x = createNS("g");
                    for(o = 0; o < h; o += 1)x.appendChild(u[o]);
                    var E = createNS("mask");
                    E.setAttribute("mask-type", "alpha"), E.setAttribute("id", y + "_" + d), E.appendChild(a), s.appendChild(E), x.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), u.length = 0, u.push(x);
                } else u.push(a);
                m[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
                    elem: a,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                    invRect: l
                }, this.viewData[i].prop.k || this.drawPath(m[i], this.viewData[i].prop.v, this.viewData[i]);
            }
            for(this.maskElement = createNS(g), n = u.length, i = 0; i < n; i += 1)this.maskElement.appendChild(u[i]);
            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(v, "url(" + getLocationHref() + "#" + y + ")"), s.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        TransformElement.prototype = {
            initTransform: function() {
                var t = new Matrix;
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _localMatMdf: !1,
                    _opMdf: !1,
                    mat: t,
                    localMat: t,
                    localOpacity: 1
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t, e = this.finalTransform.mat, r = 0, i = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r < i;){
                        if (this.hierarchy[r].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r += 1;
                    }
                    if (this.finalTransform._matMdf) for(t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0; r < i; r += 1)e.multiply(this.hierarchy[r].finalTransform.mProp.v);
                }
                this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
            },
            renderLocalTransform: function() {
                if (this.localTransforms) {
                    var t = 0, e = this.localTransforms.length;
                    if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for(; t < e;)this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
                    if (this.finalTransform._localMatMdf) {
                        var r = this.finalTransform.localMat;
                        for(this.localTransforms[0].matrix.clone(r), t = 1; t < e; t += 1){
                            var i = this.localTransforms[t].matrix;
                            r.multiply(i);
                        }
                        r.multiply(this.finalTransform.mat);
                    }
                    if (this.finalTransform._opMdf) {
                        var a = this.finalTransform.localOpacity;
                        for(t = 0; t < e; t += 1)a *= .01 * this.localTransforms[t].opacity;
                        this.finalTransform.localOpacity = a;
                    }
                }
            },
            searchEffectTransforms: function() {
                if (this.renderableEffectsManager) {
                    var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                    if (t.length) {
                        this.localTransforms = [], this.finalTransform.localMat = new Matrix;
                        var e = 0, r = t.length;
                        for(e = 0; e < r; e += 1)this.localTransforms.push(t[e]);
                    }
                }
            },
            globalToLocal: function(t) {
                var e = [];
                e.push(this.finalTransform);
                for(var r, i = !0, a = this.comp; i;)a.finalTransform ? (a.data.hasMask && e.splice(0, 0, a.finalTransform), a = a.comp) : i = !1;
                var s, n = e.length;
                for(r = 0; r < n; r += 1)s = e[r].mat.applyToPointArray(0, 0, 0), t = [
                    t[0] - s[0],
                    t[1] - s[1],
                    0
                ];
                return t;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop;
        }, MaskElement.prototype.renderFrame = function(t) {
            var e, r = this.element.finalTransform.mat, i = this.masksProperties.length;
            for(e = 0; e < i; e += 1)if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                var a = this.storedData[e].expan;
                this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")), a.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t, e, r) {
            var i, a, s = " M" + e.v[0][0] + "," + e.v[0][1];
            for(a = e._length, i = 1; i < a; i += 1)s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
            if (e.c && a > 1 && (s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r.lastPath !== s) {
                var n = "";
                r.elem && (e.c && (n = t.inv ? this.solidPath + s : s), r.elem.setAttribute("d", n)), r.lastPath = s;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t = {};
            return t.createFilter = function(t, e) {
                var r = createNS("filter");
                r.setAttribute("id", t), !0 !== e && (r.setAttribute("filterUnits", "objectBoundingBox"), r.setAttribute("x", "0%"), r.setAttribute("y", "0%"), r.setAttribute("width", "100%"), r.setAttribute("height", "100%"));
                return r;
            }, t.createAlphaToLuminanceFilter = function() {
                var t = createNS("feColorMatrix");
                return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
            }, t;
        }(), featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
        }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r, i = "SourceGraphic", a = t.data.ef ? t.data.ef.length : 0, s = createElementID(), n = filtersFactory.createFilter(s, !0), o = 0;
            for(this.filters = [], e = 0; e < a; e += 1){
                r = null;
                var h = t.data.ef[e].ty;
                if (registeredEffects$1[h]) r = new registeredEffects$1[h].effect(n, t.effectsManager.effectElements[e], t, idPrefix + o, i), i = idPrefix + o, registeredEffects$1[h].countsAsEffect && (o += 1);
                r && this.filters.push(r);
            }
            o && (t.globalData.defs.appendChild(n), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect$1(t, e, r) {
            registeredEffects$1[t] = {
                effect: e,
                countsAsEffect: r
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = e.slotManager.getProp(this.assetData)), this.initElement(t, e, r), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t, e) {
            this.elem = t, this.pos = e;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, SVGEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for(e = 0; e < r; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e = createNS("g");
                    e.setAttribute("id", this.layerId), e.appendChild(this.layerElement), t = e, this.globalData.defs.appendChild(e);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r = createNS("clipPath"), i = createNS("path");
                    i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var a = createElementID();
                    if (r.setAttribute("id", a), r.appendChild(i), this.globalData.defs.appendChild(r), this.checkMasks()) {
                        var s = createNS("g");
                        s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), s.appendChild(this.layerElement), this.transformedElement = s, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
            },
            getMatte: function(t) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
                    var e, r, i, a, s = this.layerId + "_" + t;
                    if (1 === t || 3 === t) {
                        var n = createNS("mask");
                        n.setAttribute("id", s), n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n.appendChild(i), this.globalData.defs.appendChild(n), featureSupport.maskType || 1 !== t || (n.setAttribute("mask-type", "luminance"), e = createElementID(), r = filtersFactory.createFilter(e), this.globalData.defs.appendChild(r), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (a = createNS("g")).appendChild(i), n.appendChild(a), a.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                    } else if (2 === t) {
                        var o = createNS("mask");
                        o.setAttribute("id", s), o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h), e = createElementID(), r = filtersFactory.createFilter(e);
                        var l = createNS("feComponentTransfer");
                        l.setAttribute("in", "SourceGraphic"), r.appendChild(l);
                        var p = createNS("feFuncA");
                        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), l.appendChild(p), this.globalData.defs.appendChild(r);
                        var f = createNS("rect");
                        f.setAttribute("width", this.comp.data.w), f.setAttribute("height", this.comp.data.h), f.setAttribute("x", "0"), f.setAttribute("y", "0"), f.setAttribute("fill", "#ffffff"), f.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"), h.appendChild(f), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(i), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), a = createNS("g"), h.appendChild(f), a.appendChild(this.layerElement), h.appendChild(a)), this.globalData.defs.appendChild(o);
                    }
                    this.matteMasks[t] = s;
                }
                return this.matteMasks[t];
            },
            setMatte: function(t) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t) {
                this.hierarchy = t;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t, e, r) {
                    this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t) {
                var e, r = this.shapeModifiers.length;
                for(e = 0; e < r; e += 1)this.shapeModifiers[e].addShape(t);
            },
            isShapeInAnimatedModifiers: function(t) {
                for(var e = this.shapeModifiers.length; 0 < e;)if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t, e = this.shapes.length;
                    for(t = 0; t < e; t += 1)this.shapes[t].sh.reset();
                    for(t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                }
            },
            searchProcessedElement: function(t) {
                for(var e = this.processedElements, r = 0, i = e.length; r < i;){
                    if (e[r].elem === t) return e[r].pos;
                    r += 1;
                }
                return 0;
            },
            addProcessedElement: function(t, e) {
                for(var r = this.processedElements, i = r.length; i;)if (r[i -= 1].elem === t) return void (r[i].pos = e);
                r.push(new ProcessedElement(t, e));
            },
            prepareFrame: function(t) {
                this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r) {
            this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = r, this.lvl = e, this._isAnimated = !!r.k;
            for(var i = 0, a = t.length; i < a;){
                if (t[i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i += 1;
            }
        }
        function SVGStyleData(t, e) {
            this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t, e, r, i) {
            var a;
            this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(e.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
            var s, n = e.length || 0;
            for(a = 0; a < n; a += 1)s = PropertyFactory.getProp(t, e[a].v, 0, 0, this), this.k = s.k || this.k, this.dataProps[a] = {
                n: e[a].n,
                p: s
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r;
        }
        function SVGNoStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = r;
        }
        function GradientProperty(t, e, r) {
            this.data = e, this.c = createTypedArray("uint8c", 4 * e.p);
            var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
            this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, r);
        }
        function SVGGradientStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.initGradientData(t, e, r), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t, e, r) {
            this.transform = {
                mProps: t,
                op: e,
                container: r
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t) {
            if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                var e = 0, r = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r; e += 1)"o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, e) {
            for(var r = 0, i = this.o.length / 2; r < i;){
                if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > .01) return !1;
                r += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t = 0, e = this.data.k.k.length; t < e;){
                if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                t += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                var e, r, i, a = 4 * this.data.p;
                for(e = 0; e < a; e += 1)r = e % 4 == 0 ? 100 : 255, i = Math.round(this.prop.v[e] * r), this.c[e] !== i && (this.c[e] = i, this._cmdf = !t);
                if (this.o.length) for(a = this.prop.v.length, e = 4 * this.data.p; e < a; e += 1)r = e % 2 == 0 ? 100 : 1, i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== i && (this.o[e - 4 * this.data.p] = i, this._omdf = !t);
                this._mdf = !t;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.s = PropertyFactory.getProp(t, e.s, 1, null, this), this.e = PropertyFactory.getProp(t, e.e, 1, null, this), this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t, e.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, e), this.setGradientOpacity(e, r), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r = createElementID(), i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
            i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
            var a, s, n, o = [];
            for(n = 4 * e.g.p, s = 0; s < n; s += 4)a = createNS("stop"), i.appendChild(a), o.push(a);
            t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = o;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r, i, a, s = createNS("mask"), n = createNS("path");
                s.appendChild(n);
                var o = createElementID(), h = createElementID();
                s.setAttribute("id", h);
                var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                l.setAttribute("id", o), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), a = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for(i = 4 * t.g.p; i < a; i += 2)(r = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(r), p.push(r);
                n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = s, this.ost = p, this.maskId = h, e.msElem = n;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t, e, r, i) {
            if (0 === e) return "";
            var a, s = t.o, n = t.i, o = t.v, h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
            for(a = 1; a < e; a += 1)h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[a][0], n[a][1]) + " " + i.applyToPointStringified(o[a][0], o[a][1]);
            return r && e && (h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
        }, SVGElementsRenderer = function() {
            var t = new Matrix, e = new Matrix;
            function r(t, e, r) {
                (r || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (r || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
            }
            function i() {}
            function a(r, i, a) {
                var s, n, o, h, l, p, f, c, m, d, u = i.styles.length, y = i.lvl;
                for(p = 0; p < u; p += 1){
                    if (h = i.sh._mdf || a, i.styles[p].lvl < y) {
                        for(c = e.reset(), m = y - i.styles[p].lvl, d = i.transformers.length - 1; !h && m > 0;)h = i.transformers[d].mProps._mdf || h, m -= 1, d -= 1;
                        if (h) for(m = y - i.styles[p].lvl, d = i.transformers.length - 1; m > 0;)c.multiply(i.transformers[d].mProps.v), m -= 1, d -= 1;
                    } else c = t;
                    if (n = (f = i.sh.paths)._length, h) {
                        for(o = "", s = 0; s < n; s += 1)(l = f.shapes[s]) && l._length && (o += buildShapeString(l, l._length, l.c, c));
                        i.caches[p] = o;
                    } else o = i.caches[p];
                    i.styles[p].d += !0 === r.hd ? "" : o, i.styles[p]._mdf = h || i.styles[p]._mdf;
                }
            }
            function s(t, e, r) {
                var i = e.style;
                (e.c._mdf || r) && i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
            }
            function n(t, e, r) {
                o(t, e, r), h(t, e, r);
            }
            function o(t, e, r) {
                var i, a, s, n, o, h = e.gf, l = e.g._hasOpacity, p = e.s.v, f = e.e.v;
                if (e.o._mdf || r) {
                    var c = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                    e.style.pElem.setAttribute(c, e.o.v);
                }
                if (e.s._mdf || r) {
                    var m = 1 === t.t ? "x1" : "cx", d = "x1" === m ? "y1" : "cy";
                    h.setAttribute(m, p[0]), h.setAttribute(d, p[1]), l && !e.g._collapsable && (e.of.setAttribute(m, p[0]), e.of.setAttribute(d, p[1]));
                }
                if (e.g._cmdf || r) {
                    i = e.cst;
                    var u = e.g.c;
                    for(s = i.length, a = 0; a < s; a += 1)(n = i[a]).setAttribute("offset", u[4 * a] + "%"), n.setAttribute("stop-color", "rgb(" + u[4 * a + 1] + "," + u[4 * a + 2] + "," + u[4 * a + 3] + ")");
                }
                if (l && (e.g._omdf || r)) {
                    var y = e.g.o;
                    for(s = (i = e.g._collapsable ? e.cst : e.ost).length, a = 0; a < s; a += 1)n = i[a], e.g._collapsable || n.setAttribute("offset", y[2 * a] + "%"), n.setAttribute("stop-opacity", y[2 * a + 1]);
                }
                if (1 === t.t) (e.e._mdf || r) && (h.setAttribute("x2", f[0]), h.setAttribute("y2", f[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));
                else if ((e.s._mdf || e.e._mdf || r) && (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || r) {
                    o || (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)));
                    var g = Math.atan2(f[1] - p[1], f[0] - p[0]), v = e.h.v;
                    v >= 1 ? v = .99 : v <= -1 && (v = -0.99);
                    var b = o * v, x = Math.cos(g + e.a.v) * b + p[0], E = Math.sin(g + e.a.v) * b + p[1];
                    h.setAttribute("fx", x), h.setAttribute("fy", E), l && !e.g._collapsable && (e.of.setAttribute("fx", x), e.of.setAttribute("fy", E));
                }
            }
            function h(t, e, r) {
                var i = e.style, a = e.d;
                a && (a._mdf || r) && a.dashStr && (i.pElem.setAttribute("stroke-dasharray", a.dashStr), i.pElem.setAttribute("stroke-dashoffset", a.dashoffset[0])), e.c && (e.c._mdf || r) && i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || r) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
            }
            return {
                createRenderFunction: function(t) {
                    switch(t.ty){
                        case "fl":
                            return s;
                        case "gf":
                            return o;
                        case "gs":
                            return n;
                        case "st":
                            return h;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return a;
                        case "tr":
                            return r;
                        case "no":
                            return i;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, r), this.prevViewData = [];
        }
        function LetterProps(t, e, r, i, a, s) {
            this.o = t, this.sw = e, this.sc = r, this.fc = i, this.m = a, this.p = s, this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r,
                fc: !!i,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)), this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e, r, i, a = this.shapes.length, s = this.stylesList.length, n = [], o = !1;
            for(r = 0; r < s; r += 1){
                for(i = this.stylesList[r], o = !1, n.length = 0, t = 0; t < a; t += 1)-1 !== (e = this.shapes[t]).styles.indexOf(i) && (n.push(e), o = e._isAnimated || o);
                n.length > 1 && o && this.setShapesAsAnimated(n);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r, i = new SVGStyleData(t, e), a = i.pElem;
            if ("st" === t.ty) r = new SVGStrokeStyleData(this, t, i);
            else if ("fl" === t.ty) r = new SVGFillStyleData(this, t, i);
            else if ("gf" === t.ty || "gs" === t.ty) r = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), a.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
            else "no" === t.ty && (r = new SVGNoStyleData(this, t, i));
            return "st" !== t.ty && "gs" !== t.ty || (a.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), a.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), a.setAttribute("fill-opacity", "0"), 1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && a.setAttribute("fill-rule", "evenodd"), t.ln && a.setAttribute("id", t.ln), t.cl && a.setAttribute("class", t.cl), t.bm && (a.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(i), this.addToAnimatedContents(t, r), r;
        }, SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
        }, SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r = TransformPropertyFactory.getTransformProperty(this, t, this), i = new SVGTransformData(r, r.o, e);
            return this.addToAnimatedContents(t, i), i;
        }, SVGShapeElement.prototype.createShapeElement = function(t, e, r) {
            var i = 4;
            "rc" === t.ty ? i = 5 : "el" === t.ty ? i = 6 : "sr" === t.ty && (i = 7);
            var a = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, i, this));
            return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(t, a), a;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for(var r = 0, i = this.animatedContents.length; r < i;){
                if (this.animatedContents[r].element === e) return;
                r += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t) {
            var e, r = t.styles, i = this.stylesList.length;
            for(e = 0; e < i; e += 1)this.stylesList[e].closed || r.push(this.stylesList[e]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t, e, r, i, a, s, n) {
            var o, h, l, p, f, c, m = [].concat(s), d = t.length - 1, u = [], y = [];
            for(o = d; o >= 0; o -= 1){
                if ((c = this.searchProcessedElement(t[o])) ? e[o] = r[c - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) c ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], a), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), u.push(e[o].style);
                else if ("gr" === t[o].ty) {
                    if (c) for(l = e[o].it.length, h = 0; h < l; h += 1)e[o].prevViewData[h] = e[o].it[h];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, a + 1, m, n), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                } else "tr" === t[o].ty ? (c || (e[o] = this.createTransformElement(t[o], i)), p = e[o].transform, m.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (c || (e[o] = this.createShapeElement(t[o], m, a)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (c ? (f = e[o]).closed = !1 : ((f = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), e[o] = f, this.shapeModifiers.push(f)), y.push(f)) : "rp" === t[o].ty && (c ? (f = e[o]).closed = !0 : (f = ShapeModifiers.getModifier(t[o].ty), e[o] = f, f.init(this, t, o, e), this.shapeModifiers.push(f), n = !1), y.push(f));
                this.addProcessedElement(t[o], o + 1);
            }
            for(d = u.length, o = 0; o < d; o += 1)u[o].closed = !0;
            for(d = y.length, o = 0; o < d; o += 1)y[o].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t;
            this.renderModifiers();
            var e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].reset();
            for(this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t, e, r = this.animatedContents.length;
            for(t = 0; t < r; t += 1)e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t, e, r, i, a, s) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n = !1;
            return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== a && (this.m = a, this._mdf.m = !0, n = !0), !s.length || this.p[0] === s[0] && this.p[1] === s[1] && this.p[4] === s[4] && this.p[5] === s[5] && this.p[12] === s[12] && this.p[13] === s[13] || (this.p = s, this._mdf.p = !0, n = !0), n;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t, e) {
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
        }, TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData, r = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i;
                    this.lock = !0, this._mdf = !1;
                    var a = this.effectsSequence.length, s = t || this.data.d.k[this.keysIndex].s;
                    for(i = 0; i < a; i += 1)s = r !== this.keysIndex ? this.effectsSequence[i](s, s.t) : this.effectsSequence[i](this.currentData, s.t);
                    e !== s && this.setCurrentData(s), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length; r <= i - 1 && !(r === i - 1 || t[r + 1].t > e);)r += 1;
            return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t) {
            for(var e, r, i = [], a = 0, s = t.length, n = !1, o = !1, h = ""; a < s;)n = o, o = !1, e = t.charCodeAt(a), h = t.charAt(a), FontManager.isCombinedCharacter(e) ? n = !0 : e >= 55296 && e <= 56319 ? FontManager.isRegionalFlag(t, a) ? h = t.substr(a, 14) : (r = t.charCodeAt(a + 1)) >= 56320 && r <= 57343 && (FontManager.isModifier(e, r) ? (h = t.substr(a, 2), n = !0) : h = FontManager.isFlagEmoji(t.substr(a, 4)) ? t.substr(a, 4) : t.substr(a, 2)) : e > 56319 ? (r = t.charCodeAt(a + 1), FontManager.isVariationSelector(e) && (n = !0)) : FontManager.isZeroWidthJoiner(e) && (n = !0, o = !0), n ? (i[i.length - 1] += h, n = !1) : i.push(h), a += h.length;
            return i;
        }, TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e, r, i, a, s, n, o, h = this.elem.globalData.fontManager, l = this.data, p = [], f = 0, c = l.m.g, m = 0, d = 0, u = 0, y = [], g = 0, v = 0, b = h.getFontByName(t.f), x = 0, E = getFontProperties(b);
            t.fWeight = E.weight, t.fStyle = E.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), r = t.finalText.length, t.finalLineHeight = t.lh;
            var S, P = t.tr / 1e3 * t.finalSize;
            if (t.sz) for(var C, _, k = !0, A = t.sz[0], T = t.sz[1]; k;){
                C = 0, g = 0, r = (_ = this.buildFinalText(t.t)).length, P = t.tr / 1e3 * t.finalSize;
                var M = -1;
                for(e = 0; e < r; e += 1)S = _[e].charCodeAt(0), i = !1, " " === _[e] ? M = e : 13 !== S && 3 !== S || (g = 0, i = !0, C += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(_[e], b.fStyle, b.fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(_[e], t.f, t.finalSize), g + x > A && " " !== _[e] ? (-1 === M ? r += 1 : e = M, C += t.finalLineHeight || 1.2 * t.finalSize, _.splice(e, M === e ? 1 : 0, "\r"), M = -1, g = 0) : (g += x, g += P);
                C += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && T < C ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = _, r = t.finalText.length, k = !1);
            }
            g = -P, x = 0;
            var w, D = 0;
            for(e = 0; e < r; e += 1)if (i = !1, 13 === (S = (w = t.finalText[e]).charCodeAt(0)) || 3 === S ? (D = 0, y.push(g), v = g > v ? g : v, g = -2 * P, a = "", i = !0, u += 1) : a = w, h.chars ? (o = h.getCharData(w, b.fStyle, h.getFontByName(t.f).fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(a, t.f, t.finalSize), " " === w ? D += x + P : (g += x + P + D, D = 0), p.push({
                l: x,
                an: x,
                add: m,
                n: i,
                anIndexes: [],
                val: a,
                line: u,
                animatorJustifyOffset: 0
            }), 2 == c) {
                if (m += x, "" === a || " " === a || e === r - 1) {
                    for("" !== a && " " !== a || (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    f += 1, m = 0;
                }
            } else if (3 == c) {
                if (m += x, "" === a || e === r - 1) {
                    for("" === a && (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    m = 0, f += 1;
                }
            } else p[f].ind = f, p[f].extra = 0, f += 1;
            if (t.l = p, v = g > v ? g : v, y.push(g), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
            else switch(t.boxWidth = v, t.j){
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0;
            }
            t.lineWidths = y;
            var F, I, R, V, B = l.a;
            n = B.length;
            var L = [];
            for(s = 0; s < n; s += 1){
                for((F = B[s]).a.sc && (t.strokeColorAnim = !0), F.a.sw && (t.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0), V = 0, R = F.s.b, e = 0; e < r; e += 1)(I = p[e]).anIndexes[s] = V, (1 == R && "" !== I.val || 2 == R && "" !== I.val && " " !== I.val || 3 == R && (I.n || " " == I.val || e == r - 1) || 4 == R && (I.n || e == r - 1)) && (1 === F.s.rn && L.push(V), V += 1);
                l.a[s].s.totalChars = V;
                var z, G = -1;
                if (1 === F.s.rn) for(e = 0; e < r; e += 1)G != (I = p[e]).anIndexes[s] && (G = I.anIndexes[s], z = L.splice(Math.floor(Math.random() * L.length), 1)[0]), I.anIndexes[s] = z;
            }
            t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t, e) {
            e = void 0 === e ? this.keysIndex : e;
            var r = this.copyData({}, this.data.d.k[e].s);
            r = this.copyData(r, t), this.data.d.k[e].s = r, this.recalculate(e), this.setCurrentData(r), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
        }, TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t = Math.max, e = Math.min, r = Math.floor;
            function i(t, e) {
                this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = PropertyFactory.getProp(t, e.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t, e.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t, e.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t, e.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t, e.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i.prototype = {
                getMult: function(i) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var a = 0, s = 0, n = 1, o = 1;
                    this.ne.v > 0 ? a = this.ne.v / 100 : s = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                    var h = BezierFactory.getBezierEasing(a, s, n, o).get, l = 0, p = this.finalS, f = this.finalE, c = this.data.sh;
                    if (2 === c) l = h(l = f === p ? i >= f ? 1 : 0 : t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (3 === c) l = h(l = f === p ? i >= f ? 0 : 1 : 1 - t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (4 === c) f === p ? l = 0 : (l = t(0, e(.5 / (f - p) + (i - p) / (f - p), 1))) < .5 ? l *= 2 : l = 1 - 2 * (l - .5), l = h(l);
                    else if (5 === c) {
                        if (f === p) l = 0;
                        else {
                            var m = f - p, d = -m / 2 + (i = e(t(0, i + .5 - p), f - p)), u = m / 2;
                            l = Math.sqrt(1 - d * d / (u * u));
                        }
                        l = h(l);
                    } else 6 === c ? (f === p ? l = 0 : (i = e(t(0, i + .5 - p), f - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * i / (f - p))) / 2), l = h(l)) : (i >= r(p) && (l = t(0, e(i - p < 0 ? e(f, 1) - (p - i) : f - i, 1))), l = h(l));
                    if (100 !== this.sm.v) {
                        var y = .01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = .5 - .5 * y;
                        l < g ? l = 0 : (l = (l - g) / y) > 1 && (l = 1);
                    }
                    return l * this.a.v;
                },
                getValue: function(t) {
                    this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r = this.o.v / e, i = this.s.v / e + r, a = this.e.v / e + r;
                    if (i > a) {
                        var s = i;
                        i = a, a = s;
                    }
                    this.finalS = i, this.finalE = a;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i), {
                getTextSelectorProp: function(t, e, r) {
                    return new i(t, e, r);
                }
            };
        }();
        function TextAnimatorDataProperty(t, e, r) {
            var i = {
                propType: !1
            }, a = PropertyFactory.getProp, s = e.a;
            this.a = {
                r: s.r ? a(t, s.r, 0, degToRads, r) : i,
                rx: s.rx ? a(t, s.rx, 0, degToRads, r) : i,
                ry: s.ry ? a(t, s.ry, 0, degToRads, r) : i,
                sk: s.sk ? a(t, s.sk, 0, degToRads, r) : i,
                sa: s.sa ? a(t, s.sa, 0, degToRads, r) : i,
                s: s.s ? a(t, s.s, 1, .01, r) : i,
                a: s.a ? a(t, s.a, 1, 0, r) : i,
                o: s.o ? a(t, s.o, 0, .01, r) : i,
                p: s.p ? a(t, s.p, 1, 0, r) : i,
                sw: s.sw ? a(t, s.sw, 0, 0, r) : i,
                sc: s.sc ? a(t, s.sc, 1, 0, r) : i,
                fc: s.fc ? a(t, s.fc, 1, 0, r) : i,
                fh: s.fh ? a(t, s.fh, 0, 0, r) : i,
                fs: s.fs ? a(t, s.fs, 0, .01, r) : i,
                fb: s.fb ? a(t, s.fb, 0, .01, r) : i,
                t: s.t ? a(t, s.t, 0, 0, r) : i
            }, this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r), this.s.t = e.s.t;
        }
        function TextAnimatorProperty(t, e, r) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e, r = this._textData.a.length, i = PropertyFactory.getProp;
            for(t = 0; t < r; t += 1)e = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i(this._elem, this._textData.p.a, 0, 0, this),
                f: i(this._elem, this._textData.p.f, 0, 0, this),
                l: i(this._elem, this._textData.p.l, 0, 0, this),
                r: i(this._elem, this._textData.p.r, 0, 0, this),
                p: i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r, i, a, s, n, o, h, l, p, f, c, m, d, u, y, g, v, b, x, E = this._moreOptions.alignment.v, S = this._animatorsData, P = this._textData, C = this.mHelper, _ = this._renderType, k = this.renderedLetters.length, A = t.l;
                if (this._hasMaskedPath) {
                    if (x = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var T, M = x.v;
                        for(this._pathData.r.v && (M = M.reverse()), n = {
                            tLength: 0,
                            segments: []
                        }, s = M._length - 1, g = 0, a = 0; a < s; a += 1)T = bez.buildBezierData(M.v[a], M.v[a + 1], [
                            M.o[a][0] - M.v[a][0],
                            M.o[a][1] - M.v[a][1]
                        ], [
                            M.i[a + 1][0] - M.v[a + 1][0],
                            M.i[a + 1][1] - M.v[a + 1][1]
                        ]), n.tLength += T.segmentLength, n.segments.push(T), g += T.segmentLength;
                        a = s, x.v.c && (T = bez.buildBezierData(M.v[a], M.v[0], [
                            M.o[a][0] - M.v[a][0],
                            M.o[a][1] - M.v[a][1]
                        ], [
                            M.i[0][0] - M.v[0][0],
                            M.i[0][1] - M.v[0][1]
                        ]), n.tLength += T.segmentLength, n.segments.push(T), g += T.segmentLength), this._pathData.pi = n;
                    }
                    if (n = this._pathData.pi, o = this._pathData.f.v, c = 0, f = 1, l = 0, p = !0, u = n.segments, o < 0 && x.v.c) for(n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), f = (d = u[c = u.length - 1].points).length - 1; o < 0;)o += d[f].partialLength, (f -= 1) < 0 && (f = (d = u[c -= 1].points).length - 1);
                    m = (d = u[c].points)[f - 1], y = (h = d[f]).partialLength;
                }
                s = A.length, r = 0, i = 0;
                var w, D, F, I, R, V = 1.2 * t.finalSize * .714, B = !0;
                F = S.length;
                var L, z, G, O, N, H, j, q, W, $, Y, J, X = -1, Z = o, K = c, U = f, Q = -1, tt = "", et = this.defaultPropsArray;
                if (2 === t.j || 1 === t.j) {
                    var rt = 0, it = 0, at = 2 === t.j ? -0.5 : -1, st = 0, nt = !0;
                    for(a = 0; a < s; a += 1)if (A[a].n) {
                        for(rt && (rt += it); st < a;)A[st].animatorJustifyOffset = rt, st += 1;
                        rt = 0, nt = !0;
                    } else {
                        for(D = 0; D < F; D += 1)(w = S[D].a).t.propType && (nt && 2 === t.j && (it += w.t.v * at), (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? rt += w.t.v * R[0] * at : rt += w.t.v * R * at);
                        nt = !1;
                    }
                    for(rt && (rt += it); st < a;)A[st].animatorJustifyOffset = rt, st += 1;
                }
                for(a = 0; a < s; a += 1){
                    if (C.reset(), O = 1, A[a].n) r = 0, i += t.yOffset, i += B ? 1 : 0, o = Z, B = !1, this._hasMaskedPath && (f = U, m = (d = u[c = K].points)[f - 1], y = (h = d[f]).partialLength, l = 0), tt = "", Y = "", W = "", J = "", et = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q !== A[a].line) {
                                switch(t.j){
                                    case 1:
                                        o += g - t.lineWidths[A[a].line];
                                        break;
                                    case 2:
                                        o += (g - t.lineWidths[A[a].line]) / 2;
                                }
                                Q = A[a].line;
                            }
                            X !== A[a].ind && (A[X] && (o += A[X].extra), o += A[a].an / 2, X = A[a].ind), o += E[0] * A[a].an * .005;
                            var ot = 0;
                            for(D = 0; D < F; D += 1)(w = S[D].a).p.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? ot += w.p.v[0] * R[0] : ot += w.p.v[0] * R), w.a.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? ot += w.a.v[0] * R[0] : ot += w.a.v[0] * R);
                            for(p = !0, this._pathData.a.v && (o = .5 * A[0].an + (g - this._pathData.f.v - .5 * A[0].an - .5 * A[A.length - 1].an) * X / (s - 1), o += this._pathData.f.v); p;)l + y >= o + ot || !d ? (v = (o + ot - l) / h.partialLength, z = m.point[0] + (h.point[0] - m.point[0]) * v, G = m.point[1] + (h.point[1] - m.point[1]) * v, C.translate(-E[0] * A[a].an * .005, -E[1] * V * .01), p = !1) : d && (l += h.partialLength, (f += 1) >= d.length && (f = 0, u[c += 1] ? d = u[c].points : x.v.c ? (f = 0, d = u[c = 0].points) : (l -= h.partialLength, d = null)), d && (m = h, y = (h = d[f]).partialLength));
                            L = A[a].an / 2 - A[a].add, C.translate(-L, 0, 0);
                        } else L = A[a].an / 2 - A[a].add, C.translate(-L, 0, 0), C.translate(-E[0] * A[a].an * .005, -E[1] * V * .01, 0);
                        for(D = 0; D < F; D += 1)(w = S[D].a).t.propType && (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), 0 === r && 0 === t.j || (this._hasMaskedPath ? R.length ? o += w.t.v * R[0] : o += w.t.v * R : R.length ? r += w.t.v * R[0] : r += w.t.v * R));
                        for(t.strokeWidthAnim && (H = t.sw || 0), t.strokeColorAnim && (N = t.sc ? [
                            t.sc[0],
                            t.sc[1],
                            t.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t.fillColorAnim && t.fc && (j = [
                            t.fc[0],
                            t.fc[1],
                            t.fc[2]
                        ]), D = 0; D < F; D += 1)(w = S[D].a).a.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? C.translate(-w.a.v[0] * R[0], -w.a.v[1] * R[1], w.a.v[2] * R[2]) : C.translate(-w.a.v[0] * R, -w.a.v[1] * R, w.a.v[2] * R));
                        for(D = 0; D < F; D += 1)(w = S[D].a).s.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? C.scale(1 + (w.s.v[0] - 1) * R[0], 1 + (w.s.v[1] - 1) * R[1], 1) : C.scale(1 + (w.s.v[0] - 1) * R, 1 + (w.s.v[1] - 1) * R, 1));
                        for(D = 0; D < F; D += 1){
                            if (w = S[D].a, R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), w.sk.propType && (R.length ? C.skewFromAxis(-w.sk.v * R[0], w.sa.v * R[1]) : C.skewFromAxis(-w.sk.v * R, w.sa.v * R)), w.r.propType && (R.length ? C.rotateZ(-w.r.v * R[2]) : C.rotateZ(-w.r.v * R)), w.ry.propType && (R.length ? C.rotateY(w.ry.v * R[1]) : C.rotateY(w.ry.v * R)), w.rx.propType && (R.length ? C.rotateX(w.rx.v * R[0]) : C.rotateX(w.rx.v * R)), w.o.propType && (R.length ? O += (w.o.v * R[0] - O) * R[0] : O += (w.o.v * R - O) * R), t.strokeWidthAnim && w.sw.propType && (R.length ? H += w.sw.v * R[0] : H += w.sw.v * R), t.strokeColorAnim && w.sc.propType) for(q = 0; q < 3; q += 1)R.length ? N[q] += (w.sc.v[q] - N[q]) * R[0] : N[q] += (w.sc.v[q] - N[q]) * R;
                            if (t.fillColorAnim && t.fc) {
                                if (w.fc.propType) for(q = 0; q < 3; q += 1)R.length ? j[q] += (w.fc.v[q] - j[q]) * R[0] : j[q] += (w.fc.v[q] - j[q]) * R;
                                w.fh.propType && (j = R.length ? addHueToRGB(j, w.fh.v * R[0]) : addHueToRGB(j, w.fh.v * R)), w.fs.propType && (j = R.length ? addSaturationToRGB(j, w.fs.v * R[0]) : addSaturationToRGB(j, w.fs.v * R)), w.fb.propType && (j = R.length ? addBrightnessToRGB(j, w.fb.v * R[0]) : addBrightnessToRGB(j, w.fb.v * R));
                            }
                        }
                        for(D = 0; D < F; D += 1)(w = S[D].a).p.propType && (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), this._hasMaskedPath ? R.length ? C.translate(0, w.p.v[1] * R[0], -w.p.v[2] * R[1]) : C.translate(0, w.p.v[1] * R, -w.p.v[2] * R) : R.length ? C.translate(w.p.v[0] * R[0], w.p.v[1] * R[1], -w.p.v[2] * R[2]) : C.translate(w.p.v[0] * R, w.p.v[1] * R, -w.p.v[2] * R));
                        if (t.strokeWidthAnim && (W = H < 0 ? 0 : H), t.strokeColorAnim && ($ = "rgb(" + Math.round(255 * N[0]) + "," + Math.round(255 * N[1]) + "," + Math.round(255 * N[2]) + ")"), t.fillColorAnim && t.fc && (Y = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"), this._hasMaskedPath) {
                            if (C.translate(0, -t.ls), C.translate(0, E[1] * V * .01 + i, 0), this._pathData.p.v) {
                                b = (h.point[1] - m.point[1]) / (h.point[0] - m.point[0]);
                                var ht = 180 * Math.atan(b) / Math.PI;
                                h.point[0] < m.point[0] && (ht += 180), C.rotate(-ht * Math.PI / 180);
                            }
                            C.translate(z, G, 0), o -= E[0] * A[a].an * .005, A[a + 1] && X !== A[a + 1].ind && (o += A[a].an / 2, o += .001 * t.tr * t.finalSize);
                        } else {
                            switch(C.translate(r, i, 0), t.ps && C.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j){
                                case 1:
                                    C.translate(A[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[A[a].line]), 0, 0);
                                    break;
                                case 2:
                                    C.translate(A[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[A[a].line]) / 2, 0, 0);
                            }
                            C.translate(0, -t.ls), C.translate(L, 0, 0), C.translate(E[0] * A[a].an * .005, E[1] * V * .01, 0), r += A[a].l + .001 * t.tr * t.finalSize;
                        }
                        "html" === _ ? tt = C.toCSS() : "svg" === _ ? tt = C.to2dCSS() : et = [
                            C.props[0],
                            C.props[1],
                            C.props[2],
                            C.props[3],
                            C.props[4],
                            C.props[5],
                            C.props[6],
                            C.props[7],
                            C.props[8],
                            C.props[9],
                            C.props[10],
                            C.props[11],
                            C.props[12],
                            C.props[13],
                            C.props[14],
                            C.props[15]
                        ], J = O;
                    }
                    k <= a ? (I = new LetterProps(J, W, $, Y, tt, et), this.renderedLetters.push(I), k += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[a], this.lettersChangedFlag = I.update(J, W, $, Y, tt, et) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, e, r) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, r), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
        }, ITextElement.prototype.createPathShape = function(t, e) {
            var r, i, a = e.length, s = "";
            for(r = 0; r < a; r += 1)"sh" === e[r].ty && (i = e[r].ks.k, s += buildShapeString(i, i.i.length, !0, t));
            return s;
        }, ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e);
        }, ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t);
        }, ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r, i, a) {
            switch(t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j){
                case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                    break;
                case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
            }
            e.translate(i, a, 0);
        }, ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {}, ITextElement.prototype.validateText = function() {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        };
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t, e, r);
        }
        function ISolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function NullElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initFrame(), this.initTransform(t, e, r), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r = "";
            if (e && e.title) {
                var i = createNS("title"), a = createElementID();
                i.setAttribute("id", a), i.textContent = e.title, this.svgElement.appendChild(i), r += a;
            }
            if (e && e.description) {
                var s = createNS("desc"), n = createElementID();
                s.setAttribute("id", n), s.textContent = e.description, this.svgElement.appendChild(s), r += " " + n;
            }
            r && this.svgElement.setAttribute("aria-labelledby", r);
            var o = createNS("defs");
            this.svgElement.appendChild(o);
            var h = createNS("g");
            this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for(var e = 0, r = t.length, i = [], a = ""; e < r;)t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(a), a = "") : a += t[e], e += 1;
            return i.push(a), i;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r = t.shapes[0];
                if (r.it) {
                    var i = r.it[r.it.length - 1];
                    i.s && (i.s.k[0] = e, i.s.k[1] = e);
                }
            }
            return t;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t, e;
            this.addDynamicProperty(this);
            var r = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
            var i = this.globalData.fontManager.getFontByName(r.f);
            if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
            else {
                this.layerElement.setAttribute("font-family", i.fFamily);
                var a = r.fWeight, s = r.fStyle;
                this.layerElement.setAttribute("font-style", s), this.layerElement.setAttribute("font-weight", a);
            }
            this.layerElement.setAttribute("aria-label", r.t);
            var n, o = r.l || [], h = !!this.globalData.fontManager.chars;
            e = o.length;
            var l = this.mHelper, p = this.data.singleShape, f = 0, c = 0, m = !0, d = .001 * r.tr * r.finalSize;
            if (!p || h || r.sz) {
                var u, y = this.textSpans.length;
                for(t = 0; t < e; t += 1){
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h || !p || 0 === t) {
                        if (n = y > t ? this.textSpans[t].span : createNS(h ? "g" : "text"), y <= t) {
                            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
                                var g = createNS("g");
                                n.appendChild(g), this.textSpans[t].childSpan = g;
                            }
                            this.textSpans[t].span = n, this.layerElement.appendChild(n);
                        }
                        n.style.display = "inherit";
                    }
                    if (l.reset(), p && (o[t].n && (f = -d, c += r.yOffset, c += m ? 1 : 0, m = !1), this.applyTextPropertiesToMatrix(r, l, o[t].line, f, c), f += o[t].l || 0, f += d), h) {
                        var v;
                        if (1 === (u = this.globalData.fontManager.getCharData(r.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily)).t) v = new SVGCompElement(u.data, this.globalData, this);
                        else {
                            var b = emptyShapeData;
                            u.data && u.data.shapes && (b = this.buildShapeData(u.data, r.finalSize)), v = new SVGShapeElement(b, this.globalData, this);
                        }
                        if (this.textSpans[t].glyph) {
                            var x = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(x.layerElement), x.destroy();
                        }
                        this.textSpans[t].glyph = v, v._debug = !0, v.prepareFrame(0), v.renderFrame(), this.textSpans[t].childSpan.appendChild(v.layerElement), 1 === u.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
                    } else p && n.setAttribute("transform", "translate(" + l.props[12] + "," + l.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p && n && n.setAttribute("d", "");
            } else {
                var E = this.textContainer, S = "start";
                switch(r.j){
                    case 1:
                        S = "end";
                        break;
                    case 2:
                        S = "middle";
                        break;
                    default:
                        S = "start";
                }
                E.setAttribute("text-anchor", S), E.setAttribute("letter-spacing", d);
                var P = this.buildTextContents(r.finalText);
                for(e = P.length, c = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)(n = this.textSpans[t].span || createNS("tspan")).textContent = P[t], n.setAttribute("x", 0), n.setAttribute("y", c), n.style.display = "inherit", E.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t].span = n, c += r.finalLineHeight;
                this.layerElement.appendChild(E);
            }
            for(; t < this.textSpans.length;)this.textSpans[t].span.style.display = "none", t += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t, e, r = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t, e;
                this._sizeChanged = !0;
                var r, i, a, s = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
                for(e = n.length, t = 0; t < e; t += 1)n[t].n || (r = s[t], i = this.textSpans[t].span, (a = this.textSpans[t].glyph) && a.renderFrame(), r._mdf.m && i.setAttribute("transform", r.m), r._mdf.o && i.setAttribute("opacity", r.o), r._mdf.sw && i.setAttribute("stroke-width", r.sw), r._mdf.sc && i.setAttribute("stroke", r.sc), r._mdf.fc && i.setAttribute("fill", r.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
        }, NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
            var r = createNS("clipPath"), i = createNS("rect");
            i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
            var a = createElementID();
            r.setAttribute("id", a), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), e.appendChild(r), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0, r = this.layers.length;
            for(e = 0; e < r; e += 1)if (this.layers[e].ind === t) return e;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                e[t] = !0;
                var r = this.createItem(this.layers[t]);
                if (e[t] = r, getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, t), this.layers[t].tt) {
                    var i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (-1 === i) return;
                    if (this.elements[i] && !0 !== this.elements[i]) {
                        var a = e[i].getMatte(this.layers[t].tt);
                        r.setMatte(a);
                    } else this.buildItem(i), this.addPendingElement(r);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t = this.pendingElements.pop();
                if (t.checkParenting(), t.data.tt) for(var e = 0, r = this.elements.length; e < r;){
                    if (this.elements[e] === t) {
                        var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1, a = this.elements[i].getMatte(this.layers[e].tt);
                        t.setMatte(a);
                        break;
                    }
                    e += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t) {
            if (this.renderedFrame !== t && !this.destroyed) {
                var e;
                null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                var r = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf) for(e = 0; e < r; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                for(var i, a = 0; a < e;)this.elements[a] && !0 !== this.elements[a] && this.elements[a].getBaseElement() && (i = this.elements[a].getBaseElement()), a += 1;
                i ? this.layerElement.insertBefore(r, i) : this.layerElement.appendChild(r);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
                }
                var r, i = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, ICompElement.prototype.setElements = function(t) {
            this.elements = t;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t) {
                var e, r = t.length, i = "_";
                for(e = 0; e < r; e += 1)i += t[e].transform.key + "_";
                var a = this.sequences[i];
                return a || (a = {
                    transforms: [].concat(t),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i] = a, this.sequenceList.push(a)), a;
            },
            processSequence: function(t, e) {
                for(var r = 0, i = t.transforms.length, a = e; r < i && !e;){
                    if (t.transforms[r].transform.mProps._mdf) {
                        a = !0;
                        break;
                    }
                    r += 1;
                }
                if (a) for(t.finalTransform.reset(), r = i - 1; r >= 0; r -= 1)t.finalTransform.multiply(t.transforms[r].transform.mProps.v);
                t._mdf = a;
            },
            processSequences: function(t) {
                var e, r = this.sequenceList.length;
                for(e = 0; e < r; e += 1)this.processSequence(this.sequenceList[e], t);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function() {
            var t = "__lottie_element_luma_buffer", e = null, r = null, i = null;
            function a() {
                var a, s, n;
                e || (a = createNS("svg"), s = createNS("filter"), n = createNS("feColorMatrix"), s.setAttribute("id", t), n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), s.appendChild(n), a.appendChild(s), a.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (a.style.display = "none"), i = a, document.body.appendChild(i), e = createTag("canvas"), (r = e.getContext("2d")).filter = "url(#" + t + ")", r.fillStyle = "rgba(0,0,0,0)", r.fillRect(0, 0, 1, 1));
            }
            return {
                load: a,
                get: function(i) {
                    return e || a(), e.width = i.width, e.height = i.height, r.filter = "url(#" + t + ")", e;
                }
            };
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
            var r = createTag("canvas");
            return r.width = t, r.height = e, r;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        }, registeredEffects = {};
        function CVEffects(t) {
            var e, r, i = t.data.ef ? t.data.ef.length : 0;
            for(this.filters = [], e = 0; e < i; e += 1){
                r = null;
                var a = t.data.ef[e].ty;
                if (registeredEffects[a]) r = new registeredEffects[a].effect(t.effectsManager.effectElements[e], t);
                r && this.filters.push(r);
            }
            this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect(t, e) {
            registeredEffects[t] = {
                effect: e
            };
        }
        function CVMaskElement(t, e) {
            var r;
            this.data = t, this.element = e, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i = this.masksProperties.length, a = !1;
            for(r = 0; r < i; r += 1)"n" !== this.masksProperties[r].mode && (a = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
            this.hasMasks = a, a && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, CVEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for(e = 0; e < r; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t, e, r, i, a = this.element.finalTransform.mat, s = this.element.canvasContext, n = this.masksProperties.length;
                for(s.beginPath(), t = 0; t < n; t += 1)if ("n" !== this.masksProperties[t].mode) {
                    var o;
                    this.masksProperties[t].inv && (s.moveTo(0, 0), s.lineTo(this.element.globalData.compSize.w, 0), s.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), s.lineTo(0, this.element.globalData.compSize.h), s.lineTo(0, 0)), i = this.viewData[t].v, e = a.applyToPointArray(i.v[0][0], i.v[0][1], 0), s.moveTo(e[0], e[1]);
                    var h = i._length;
                    for(o = 1; o < h; o += 1)r = a.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                    r = a.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                }
                this.element.globalData.renderer.save(!0), s.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t, e, r, i) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var a, s = 4;
            "rc" === e.ty ? s = 5 : "el" === e.ty ? s = 6 : "sr" === e.ty && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(t, e, s, t);
            var n, o = r.length;
            for(a = 0; a < o; a += 1)r[a].closed || (n = {
                transforms: i.addTransformSequence(r[a].transforms),
                trNodes: []
            }, this.styledShapes.push(n), r[a].elements.push(n));
        }
        function CVShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t, e, r);
        }
        function CVTextElement(t, e, r) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t, e, r);
        }
        function CVImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.img = e.imageLoader.getAsset(this.assetData), this.initElement(t, e, r);
        }
        function CVSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function CanvasRendererBase() {}
        function CanvasContext() {
            this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
        }
        function CVContextData() {
            var t;
            this.stack = [], this.cArrPos = 0, this.cTr = new Matrix;
            for(t = 0; t < 15; t += 1){
                var e = new CanvasContext;
                this.stack[t] = e;
            }
            this._length = 15, this.nativeContext = null, this.transformMat = new Matrix, this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
        }
        function CVCompElement(t, e, r) {
            this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
        }
        function HBaseElement() {}
        function HSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function HShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, e, r), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t, e, r) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, e, r);
        }
        function HCameraElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
            var i = PropertyFactory.getProp;
            if (this.pe = i(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = i(this, t.ks.p.x, 1, 0, this), this.py = i(this, t.ks.p.y, 1, 0, this), this.pz = i(this, t.ks.p.z, 1, 0, this)) : this.p = i(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
                var a, s = t.ks.or.k.length;
                for(a = 0; a < s; a += 1)t.ks.or.k[a].to = null, t.ks.or.k[a].ti = null;
            }
            this.or = i(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, t.ks.rx, 0, degToRads, this), this.ry = i(this, t.ks.ry, 0, degToRads, this), this.rz = i(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r);
        }
        function HybridRendererBase(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t = this.globalData.canvasContext, e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(e);
                    var r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(r), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
            },
            createContent: function() {},
            setBlendMode: function() {
                var t = this.globalData;
                if (t.blendMode !== this.data.bm) {
                    t.blendMode = this.data.bm;
                    var e = getBlendMode(this.data.bm);
                    t.canvasContext.globalCompositeOperation = e;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function(t) {
                t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[0].getContext("2d");
                    this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[1], e = t.getContext("2d");
                    if (this.clearCanvas(e), e.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function(t) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
                    this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
                    var e = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(e), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: !0 === t.hd
            }, i = {};
            if ("fl" === t.ty || "st" === t.ty ? (i.c = PropertyFactory.getProp(this, t.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : "gf" !== t.ty && "gs" !== t.ty || (i.s = PropertyFactory.getProp(this, t.s, 1, null, this), i.e = PropertyFactory.getProp(this, t.e, 1, null, this), i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this), i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this), i.g = new GradientProperty(this, t.g, this)), i.o = PropertyFactory.getProp(this, t.o, 0, .01, this), "st" === t.ty || "gs" === t.ty) {
                if (r.lc = lineCapEnum[t.lc || 2], r.lj = lineJoinEnum[t.lj || 2], 1 == t.lj && (r.ml = t.ml), i.w = PropertyFactory.getProp(this, t.w, 0, null, this), i.w.k || (r.wi = i.w.v), t.d) {
                    var a = new DashProperty(this, t.d, "canvas", this);
                    i.d = a, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
                }
            } else r.r = 2 === t.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r), i.style = r, i;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
            return this.shapes.push(e), this.addShapeToModifiers(e), e;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r = this.stylesList.length;
            for(e = 0; e < r; e += 1)this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].closed || this.stylesList[t].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t, e, r, i, a) {
            var s, n, o, h, l, p, f = t.length - 1, c = [], m = [], d = [].concat(a);
            for(s = f; s >= 0; s -= 1){
                if ((h = this.searchProcessedElement(t[s])) ? e[s] = r[h - 1] : t[s]._shouldRender = i, "fl" === t[s].ty || "st" === t[s].ty || "gf" === t[s].ty || "gs" === t[s].ty) h ? e[s].style.closed = !1 : e[s] = this.createStyleElement(t[s], d), c.push(e[s].style);
                else if ("gr" === t[s].ty) {
                    if (h) for(o = e[s].it.length, n = 0; n < o; n += 1)e[s].prevViewData[n] = e[s].it[n];
                    else e[s] = this.createGroupElement(t[s]);
                    this.searchShapes(t[s].it, e[s].it, e[s].prevViewData, i, d);
                } else "tr" === t[s].ty ? (h || (p = this.createTransformElement(t[s]), e[s] = p), d.push(e[s]), this.addTransformToStyleList(e[s])) : "sh" === t[s].ty || "rc" === t[s].ty || "el" === t[s].ty || "sr" === t[s].ty ? h || (e[s] = this.createShapeElement(t[s])) : "tm" === t[s].ty || "rd" === t[s].ty || "pb" === t[s].ty || "zz" === t[s].ty || "op" === t[s].ty ? (h ? (l = e[s]).closed = !1 : ((l = ShapeModifiers.getModifier(t[s].ty)).init(this, t[s]), e[s] = l, this.shapeModifiers.push(l)), m.push(l)) : "rp" === t[s].ty && (h ? (l = e[s]).closed = !0 : (l = ShapeModifiers.getModifier(t[s].ty), e[s] = l, l.init(this, t, s, e), this.shapeModifiers.push(l), i = !1), m.push(l));
                this.addProcessedElement(t[s], s + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(c), f = m.length, s = 0; s < f; s += 1)m[s].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity, e.opacity *= e.op.v, e._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t, e, r, i, a, s, n, o, h, l = this.stylesList.length, p = this.globalData.renderer, f = this.globalData.canvasContext;
            for(t = 0; t < l; t += 1)if (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o || 0 !== h.wi) && h.data._shouldRender && 0 !== h.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p.save(), s = h.elements, "st" === o || "gs" === o ? (p.ctxStrokeStyle("st" === o ? h.co : h.grd), p.ctxLineWidth(h.wi), p.ctxLineCap(h.lc), p.ctxLineJoin(h.lj), p.ctxMiterLimit(h.ml || 0)) : p.ctxFillStyle("fl" === o ? h.co : h.grd), p.ctxOpacity(h.coOp), "st" !== o && "gs" !== o && f.beginPath(), p.ctxTransform(h.preTransforms.finalTransform.props), r = s.length, e = 0; e < r; e += 1){
                    for("st" !== o && "gs" !== o || (f.beginPath(), h.da && (f.setLineDash(h.da), f.lineDashOffset = h.do)), a = (n = s[e].trNodes).length, i = 0; i < a; i += 1)"m" === n[i].t ? f.moveTo(n[i].p[0], n[i].p[1]) : "c" === n[i].t ? f.bezierCurveTo(n[i].pts[0], n[i].pts[1], n[i].pts[2], n[i].pts[3], n[i].pts[4], n[i].pts[5]) : f.closePath();
                    "st" !== o && "gs" !== o || (p.ctxStroke(), h.da && f.setLineDash(this.dashResetter));
                }
                "st" !== o && "gs" !== o && this.globalData.renderer.ctxFill(h.r), p.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t, e, r, i) {
            var a, s;
            for(s = t, a = e.length - 1; a >= 0; a -= 1)"tr" === e[a].ty ? (s = r[a].transform, this.renderShapeTransform(t, s)) : "sh" === e[a].ty || "el" === e[a].ty || "rc" === e[a].ty || "sr" === e[a].ty ? this.renderPath(e[a], r[a]) : "fl" === e[a].ty ? this.renderFill(e[a], r[a], s) : "st" === e[a].ty ? this.renderStroke(e[a], r[a], s) : "gf" === e[a].ty || "gs" === e[a].ty ? this.renderGradientFill(e[a], r[a], s) : "gr" === e[a].ty ? this.renderShape(s, e[a].it, r[a].it) : e[a].ty;
            i && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r, i, a, s = t.trNodes, n = e.paths, o = n._length;
                s.length = 0;
                var h = t.transforms.finalTransform;
                for(a = 0; a < o; a += 1){
                    var l = n.shapes[a];
                    if (l && l.v) {
                        for(i = l._length, r = 1; r < i; r += 1)1 === r && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[r], l.v[r])
                        });
                        1 === i && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), l.c && i && (s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[0], l.v[0])
                        }), s.push({
                            t: "z"
                        }));
                    }
                }
                t.trNodes = s;
            }
        }, CVShapeElement.prototype.renderPath = function(t, e) {
            if (!0 !== t.hd && t._shouldRender) {
                var r, i = e.styledShapes.length;
                for(r = 0; r < i; r += 1)this.renderStyledShape(e.styledShapes[r], e.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t, e, r) {
            var i = e.style;
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t, e, r) {
            var i, a = e.style;
            if (!a.grd || e.g._mdf || e.s._mdf || e.e._mdf || 1 !== t.t && (e.h._mdf || e.a._mdf)) {
                var s, n = this.globalData.canvasContext, o = e.s.v, h = e.e.v;
                if (1 === t.t) i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
                else {
                    var l = Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)), p = Math.atan2(h[1] - o[1], h[0] - o[0]), f = e.h.v;
                    f >= 1 ? f = .99 : f <= -1 && (f = -0.99);
                    var c = l * f, m = Math.cos(p + e.a.v) * c + o[0], d = Math.sin(p + e.a.v) * c + o[1];
                    i = n.createRadialGradient(m, d, 0, o[0], o[1], l);
                }
                var u = t.g.p, y = e.g.c, g = 1;
                for(s = 0; s < u; s += 1)e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * s + 1]), i.addColorStop(y[4 * s] / 100, "rgba(" + y[4 * s + 1] + "," + y[4 * s + 2] + "," + y[4 * s + 3] + "," + g + ")");
                a.grd = i;
            }
            a.coOp = e.o.v * r.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t, e, r) {
            var i = e.style, a = e.d;
            a && (a._mdf || this._isFirstFrame) && (i.da = a.dashArray, i.do = a.dashoffset[0]), (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity), (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
            var r = !1;
            t.sc && (r = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
            var i, a, s, n, o, h, l, p, f, c, m, d, u = this.globalData.fontManager.getFontByName(t.f), y = t.l, g = this.mHelper;
            this.stroke = r, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, a = t.finalText.length;
            var v = this.data.singleShape, b = .001 * t.tr * t.finalSize, x = 0, E = 0, S = !0, P = 0;
            for(i = 0; i < a; i += 1){
                n = (s = this.globalData.fontManager.getCharData(t.finalText[i], u.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && s.data || {}, g.reset(), v && y[i].n && (x = -b, E += t.yOffset, E += S ? 1 : 0, S = !1), f = (l = n.shapes ? n.shapes[0].it : []).length, g.scale(t.finalSize / 100, t.finalSize / 100), v && this.applyTextPropertiesToMatrix(t, g, y[i].line, x, E), m = createSizedArray(f - 1);
                var C = 0;
                for(p = 0; p < f; p += 1)if ("sh" === l[p].ty) {
                    for(h = l[p].ks.k.i.length, c = l[p].ks.k, d = [], o = 1; o < h; o += 1)1 === o && d.push(g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[o][0], c.i[o][1], 0), g.applyToY(c.i[o][0], c.i[o][1], 0), g.applyToX(c.v[o][0], c.v[o][1], 0), g.applyToY(c.v[o][0], c.v[o][1], 0));
                    d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[0][0], c.i[0][1], 0), g.applyToY(c.i[0][0], c.i[0][1], 0), g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), m[C] = d, C += 1;
                }
                v && (x += y[i].l, x += b), this.textSpans[P] ? this.textSpans[P].elem = m : this.textSpans[P] = {
                    elem: m
                }, P += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t, e, r, i, a, s;
            this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var n, o = this.textAnimator.renderedLetters, h = this.textProperty.currentData.l;
            e = h.length;
            var l, p, f = null, c = null, m = null, d = this.globalData.renderer;
            for(t = 0; t < e; t += 1)if (!h[t].n) {
                if ((n = o[t]) && (d.save(), d.ctxTransform(n.p), d.ctxOpacity(n.o)), this.fill) {
                    for(n && n.fc ? f !== n.fc && (d.ctxFillStyle(n.fc), f = n.fc) : f !== this.values.fill && (f = this.values.fill, d.ctxFillStyle(this.values.fill)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (p = l[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(p[a], p[a + 1], p[a + 2], p[a + 3], p[a + 4], p[a + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxFill();
                }
                if (this.stroke) {
                    for(n && n.sw ? m !== n.sw && (m = n.sw, d.ctxLineWidth(n.sw)) : m !== this.values.sWidth && (m = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), n && n.sc ? c !== n.sc && (c = n.sc, d.ctxStrokeStyle(n.sc)) : c !== this.values.stroke && (c = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (p = l[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(p[a], p[a + 1], p[a + 2], p[a + 3], p[a + 4], p[a + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxStroke();
                }
                n && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w, t.height = this.assetData.h;
                var e, r, i = t.getContext("2d"), a = this.img.width, s = this.img.height, n = a / s, o = this.assetData.w / this.assetData.h, h = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n > o && "xMidYMid slice" === h || n < o && "xMidYMid slice" !== h ? e = (r = s) * o : r = (e = a) / o, i.drawImage(this.img, (a - e) / 2, (s - r) / 2, e, r, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
            1 === t[0] && 0 === t[1] && 0 === t[4] && 1 === t[5] && 0 === t[12] && 0 === t[13] || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
        }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
            this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
        }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
            this.canvasContext.fillStyle = t;
        }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
            this.canvasContext.strokeStyle = t;
        }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
            this.canvasContext.lineWidth = t;
        }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
            this.canvasContext.lineCap = t;
        }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
            this.canvasContext.lineJoin = t;
        }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
            this.canvasContext.miterLimit = t;
        }, CanvasRendererBase.prototype.ctxFill = function(t) {
            this.canvasContext.fill(t);
        }, CanvasRendererBase.prototype.ctxFillRect = function(t, e, r, i) {
            this.canvasContext.fillRect(t, e, r, i);
        }, CanvasRendererBase.prototype.ctxStroke = function() {
            this.canvasContext.stroke();
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function() {
            this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t) {
            this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%", e.height = "100%";
                var r = "0px 0px 0px";
                e.transformOrigin = r, e.mozTransformOrigin = r, e.webkitTransformOrigin = r, e["-webkit-transform"] = r, e.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            var r, i, a, s;
            if (this.reset(), t ? (r = t, i = e, this.canvasContext.canvas.width = r, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n = this.renderConfig.preserveAspectRatio.split(" "), o = n[1] || "meet", h = n[0] || "xMidYMid", l = h.substr(0, 4), p = h.substr(4);
                a = r / i, (s = this.transformCanvas.w / this.transformCanvas.h) > a && "meet" === o || s < a && "slice" === o ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                var r;
                this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e, this.globalData.projectInterface.currentFrame = t;
                var i = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                var r = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r, r.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, CVContextData.prototype.duplicate = function() {
            var t = 2 * this._length, e = 0;
            for(e = this._length; e < t; e += 1)this.stack[e] = new CanvasContext;
            this._length = t;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
        }, CVContextData.prototype.restore = function(t) {
            this.cArrPos -= 1;
            var e, r = this.stack[this.cArrPos], i = r.transform, a = this.cTr.props;
            for(e = 0; e < 16; e += 1)a[e] = i[e];
            if (t) {
                this.nativeContext.restore();
                var s = this.stack[this.cArrPos + 1];
                this.appliedFillStyle = s.fillStyle, this.appliedStrokeStyle = s.strokeStyle, this.appliedLineWidth = s.lineWidth, this.appliedLineCap = s.lineCap, this.appliedLineJoin = s.lineJoin, this.appliedMiterLimit = s.miterLimit;
            }
            this.nativeContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]), (t || -1 !== r.opacity && this.currentOpacity !== r.opacity) && (this.nativeContext.globalAlpha = r.opacity, this.currentOpacity = r.opacity), this.currentFillStyle = r.fillStyle, this.currentStrokeStyle = r.strokeStyle, this.currentLineWidth = r.lineWidth, this.currentLineCap = r.lineCap, this.currentLineJoin = r.lineJoin, this.currentMiterLimit = r.miterLimit;
        }, CVContextData.prototype.save = function(t) {
            t && this.nativeContext.save();
            var e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r, i = this.stack[this.cArrPos];
            for(r = 0; r < 16; r += 1)i.transform[r] = e[r];
            this.cArrPos += 1;
            var a = this.stack[this.cArrPos];
            a.opacity = i.opacity, a.fillStyle = i.fillStyle, a.strokeStyle = i.strokeStyle, a.lineWidth = i.lineWidth, a.lineCap = i.lineCap, a.lineJoin = i.lineJoin, a.miterLimit = i.miterLimit;
        }, CVContextData.prototype.setOpacity = function(t) {
            this.stack[this.cArrPos].opacity = t;
        }, CVContextData.prototype.setContext = function(t) {
            this.nativeContext = t;
        }, CVContextData.prototype.fillStyle = function(t) {
            this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
        }, CVContextData.prototype.strokeStyle = function(t) {
            this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
        }, CVContextData.prototype.lineWidth = function(t) {
            this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
        }, CVContextData.prototype.lineCap = function(t) {
            this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
        }, CVContextData.prototype.lineJoin = function(t) {
            this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
        }, CVContextData.prototype.miterLimit = function(t) {
            this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
        }, CVContextData.prototype.transform = function(t) {
            this.transformMat.cloneFromProps(t);
            var e = this.cTr;
            this.transformMat.multiply(e), e.cloneFromProps(this.transformMat.props);
            var r = e.props;
            this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
        }, CVContextData.prototype.opacity = function(t) {
            var e = this.stack[this.cArrPos].opacity;
            e *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== e && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = e);
        }, CVContextData.prototype.fill = function(t) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
        }, CVContextData.prototype.fillRect = function(t, e, r, i) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, e, r, i);
        }, CVContextData.prototype.stroke = function() {
            this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t, e = this.canvasContext;
            for(e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t;
            for(t = this.layers.length - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e = this.finalTransform.mat.toCSS();
                    t.transform = e, t.webkitTransform = e;
                }
                this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
        }, HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r, i, a, s, n, o = t.sh.v, h = t.transformers, l = o._length;
            if (!(l <= 1)) {
                for(r = 0; r < l - 1; r += 1)i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[r + 1]), n = this.getTransformedPoint(h, o.v[r + 1]), this.checkBounds(i, a, s, n, e);
                o.c && (i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[0]), n = this.getTransformedPoint(h, o.v[0]), this.checkBounds(i, a, s, n, e));
            }
        }, HShapeElement.prototype.checkBounds = function(t, e, r, i, a) {
            this.getBoundsOfCurve(t, e, r, i);
            var s = this.shapeBoundingBox;
            a.x = bmMin(s.left, a.x), a.xMax = bmMax(s.right, a.xMax), a.y = bmMin(s.top, a.y), a.yMax = bmMax(s.bottom, a.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t, e, r, i) {
            for(var a, s, n, o, h, l, p, f = [
                [
                    t[0],
                    i[0]
                ],
                [
                    t[1],
                    i[1]
                ]
            ], c = 0; c < 2; ++c)s = 6 * t[c] - 12 * e[c] + 6 * r[c], a = -3 * t[c] + 9 * e[c] - 9 * r[c] + 3 * i[c], n = 3 * e[c] - 3 * t[c], s |= 0, n |= 0, 0 === (a |= 0) && 0 === s || (0 === a ? (o = -n / s) > 0 && o < 1 && f[c].push(this.calculateF(o, t, e, r, i, c)) : (h = s * s - 4 * n * a) >= 0 && ((l = (-s + bmSqrt(h)) / (2 * a)) > 0 && l < 1 && f[c].push(this.calculateF(l, t, e, r, i, c)), (p = (-s - bmSqrt(h)) / (2 * a)) > 0 && p < 1 && f[c].push(this.calculateF(p, t, e, r, i, c))));
            this.shapeBoundingBox.left = bmMin.apply(null, f[0]), this.shapeBoundingBox.top = bmMin.apply(null, f[1]), this.shapeBoundingBox.right = bmMax.apply(null, f[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, f[1]);
        }, HShapeElement.prototype.calculateF = function(t, e, r, i, a, s) {
            return bmPow(1 - t, 3) * e[s] + 3 * bmPow(1 - t, 2) * t * r[s] + 3 * (1 - t) * bmPow(t, 2) * i[s] + bmPow(t, 3) * a[s];
        }, HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r] && t[r].sh ? this.calculateShapeBoundingBox(t[r], e) : t[r] && t[r].it ? this.calculateBoundingBox(t[r].it, e) : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r = 0;
            if (t.keyframes) {
                for(var i = 0; i < t.keyframes.length; i += 1){
                    var a = t.keyframes[i].s;
                    a > r && (r = a);
                }
                r *= t.mult;
            } else r = t.v * t.mult;
            e.x -= r, e.xMax += r, e.y -= r, e.yMax += r;
        }, HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox, e = 999999;
                if (t.x = e, t.xMax = -e, t.y = e, t.yMax = -e, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
                var r = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), r = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), r = !0), r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i = this.shapeCont.style, a = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i.transform = a, i.webkitTransform = a;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t), this.innerElem = t;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style, r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r, e.color = r, t.sc && (e.stroke = this.buildColor(t.sc), e.strokeWidth = t.sw + "px");
            var i, a, s = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars) {
                if (e.fontSize = t.finalSize + "px", e.lineHeight = t.finalSize + "px", s.fClass) this.innerElem.className = s.fClass;
                else {
                    e.fontFamily = s.fFamily;
                    var n = t.fWeight, o = t.fStyle;
                    e.fontStyle = o, e.fontWeight = n;
                }
            }
            var h, l, p, f = t.l;
            a = f.length;
            var c, m = this.mHelper, d = "", u = 0;
            for(i = 0; i < a; i += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[u] ? h = this.textPaths[u] : ((h = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u] ? p = (l = this.textSpans[u]).children[0] : ((l = createTag("div")).style.lineHeight = 0, (p = createNS("svg")).appendChild(h), styleDiv(l)))) : this.isMasked ? h = this.textPaths[u] ? this.textPaths[u] : createNS("text") : this.textSpans[u] ? (l = this.textSpans[u], h = this.textPaths[u]) : (styleDiv(l = createTag("span")), styleDiv(h = createTag("span")), l.appendChild(h)), this.globalData.fontManager.chars) {
                    var y, g = this.globalData.fontManager.getCharData(t.finalText[i], s.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                    if (y = g ? g.data : null, m.reset(), y && y.shapes && y.shapes.length && (c = y.shapes[0].it, m.scale(t.finalSize / 100, t.finalSize / 100), d = this.createPathShape(m, c), h.setAttribute("d", d)), this.isMasked) this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(l), y && y.shapes) {
                            document.body.appendChild(p);
                            var v = p.getBBox();
                            p.setAttribute("width", v.width + 2), p.setAttribute("height", v.height + 2), p.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2));
                            var b = p.style, x = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                            b.transform = x, b.webkitTransform = x, f[i].yOffset = v.y - 1;
                        } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                        l.appendChild(p);
                    }
                } else if (h.textContent = f[i].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(l);
                    var E = h.style, S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    E.transform = S, E.webkitTransform = S;
                }
                this.isMasked ? this.textSpans[u] = h : this.textSpans[u] = l, this.textSpans[u].style.display = "block", this.textPaths[u] = h, u += 1;
            }
            for(; u < this.textSpans.length;)this.textSpans[u].style.display = "none", u += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t;
            if (this.validateText(), this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e, t.webkitTransform = e;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r, i, a, s, n, o = 0, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
                for(i = l.length, r = 0; r < i; r += 1)l[r].n ? o += 1 : (s = this.textSpans[r], n = this.textPaths[r], a = h[o], o += 1, a._mdf.m && (this.isMasked ? s.setAttribute("transform", a.m) : (s.style.webkitTransform = a.m, s.style.transform = a.m)), s.style.opacity = a.o, a.sw && a._mdf.sw && n.setAttribute("stroke-width", a.sw), a.sc && a._mdf.sc && n.setAttribute("stroke", a.sc), a.fc && a._mdf.fc && (n.setAttribute("fill", a.fc), n.style.color = a.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    this.currentBBox.w !== p.width && (this.currentBBox.w = p.width, this.svgElement.setAttribute("width", p.width)), this.currentBBox.h !== p.height && (this.currentBBox.h = p.height, this.svgElement.setAttribute("height", p.height));
                    if (this.currentBBox.w !== p.width + 2 || this.currentBBox.h !== p.height + 2 || this.currentBBox.x !== p.x - 1 || this.currentBBox.y !== p.y - 1) {
                        this.currentBBox.w = p.width + 2, this.currentBBox.h = p.height + 2, this.currentBBox.x = p.x - 1, this.currentBBox.y = p.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
                        var f = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = f, t.webkitTransform = f;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t, e, r, i, a = this.comp.threeDElements.length;
            for(t = 0; t < a; t += 1)if ("3d" === (e = this.comp.threeDElements[t]).type) {
                r = e.perspectiveElem.style, i = e.container.style;
                var s = this.pe.v + "px", n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r.perspective = s, r.webkitPerspective = s, i.transformOrigin = "0px 0px 0px", i.mozTransformOrigin = "0px 0px 0px", i.webkitTransformOrigin = "0px 0px 0px", r.transform = n, r.webkitTransform = n;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t, e, r = this._isFirstFrame;
            if (this.hierarchy) for(e = this.hierarchy.length, t = 0; t < e; t += 1)r = this.hierarchy[t].finalTransform.mProp._mdf || r;
            if (r || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t = e = this.hierarchy.length - 1; t >= 0; t -= 1){
                    var i = this.hierarchy[t].finalTransform.mProp;
                    this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var a;
                    a = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var s = Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2)), n = [
                        a[0] / s,
                        a[1] / s,
                        a[2] / s
                    ], o = Math.sqrt(n[2] * n[2] + n[0] * n[0]), h = Math.atan2(n[1], o), l = Math.atan2(n[0], -n[2]);
                    this.mat.rotateY(l).rotateX(-h);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    var f, c, m;
                    for(e = this.comp.threeDElements.length, t = 0; t < e; t += 1)if ("3d" === (f = this.comp.threeDElements[t]).type) {
                        if (p) {
                            var d = this.mat.toCSS();
                            (m = f.container.style).transform = d, m.webkitTransform = d;
                        }
                        this.pe._mdf && ((c = f.perspectiveElem.style).perspective = this.pe.v + "px", c.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData), e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e), e.crossOrigin = "anonymous", e.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                var i = this.layers[e];
                if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
                else if (this.threeDElements) this.addTo3dContainer(r, e);
                else {
                    for(var a, s, n = 0; n < e;)this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement && (s = this.elements[n], a = (this.layers[n].ddd ? this.getThreeDContainerByPos(n) : s.getBaseElement()) || a), n += 1;
                    a ? i.ddd && this.supports3d || this.layerElement.insertBefore(r, a) : i.ddd && this.supports3d || this.layerElement.appendChild(r);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for(var e = 0, r = this.threeDElements.length; e < r;){
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                e += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r, i, a = createTag("div");
            styleDiv(a);
            var s = createTag("div");
            if (styleDiv(s), "3d" === e) {
                (r = a.style).width = this.globalData.compSize.w + "px", r.height = this.globalData.compSize.h + "px";
                r.webkitTransformOrigin = "50% 50%", r.mozTransformOrigin = "50% 50%", r.transformOrigin = "50% 50%";
                var n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i = s.style).transform = n, i.webkitTransform = n;
            }
            a.appendChild(s);
            var o = {
                container: s,
                perspectiveElem: a,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(o), o;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t, e, r = this.layers.length, i = "";
            for(t = 0; t < r; t += 1)this.layers[t].ddd && 3 !== this.layers[t].ty ? ("3d" !== i && (i = "3d", e = this.createThreeDContainer(t, "3d")), e.endPos = Math.max(e.endPos, t)) : ("2d" !== i && (i = "2d", e = this.createThreeDContainer(t, "2d")), e.endPos = Math.max(e.endPos, t));
            for(t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for(var r = 0, i = this.threeDElements.length; r < i;){
                if (e <= this.threeDElements[r].endPos) {
                    for(var a, s = this.threeDElements[r].startPos; s < e;)this.elements[s] && this.elements[s].getBaseElement && (a = this.elements[s].getBaseElement()), s += 1;
                    a ? this.threeDElements[r].container.insertBefore(t, a) : this.threeDElements[r].container.appendChild(t);
                    break;
                }
                r += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div"), r = this.animationItem.wrapper, i = e.style;
            i.width = t.w + "px", i.height = t.h + "px", this.resizerElem = e, styleDiv(e), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && e.setAttribute("class", this.renderConfig.className), r.appendChild(e), i.overflow = "hidden";
            var a = createNS("svg");
            a.setAttribute("width", "1"), a.setAttribute("height", "1"), styleDiv(a), this.resizerElem.appendChild(a);
            var s = createNS("defs");
            a.appendChild(s), this.data = t, this.setupGlobalData(t, a), this.globalData.defs = s, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t, e, r, i, a = this.animationItem.wrapper.offsetWidth, s = this.animationItem.wrapper.offsetHeight, n = a / s;
            this.globalData.compSize.w / this.globalData.compSize.h > n ? (t = a / this.globalData.compSize.w, e = a / this.globalData.compSize.w, r = 0, i = (s - this.globalData.compSize.h * (a / this.globalData.compSize.w)) / 2) : (t = s / this.globalData.compSize.h, e = s / this.globalData.compSize.h, r = (a - this.globalData.compSize.w * (s / this.globalData.compSize.h)) / 2, i = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r + "," + i + ",0,1)", o.transform = o.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t, e = this.globalData.compSize.w, r = this.globalData.compSize.h, i = this.threeDElements.length;
                for(t = 0; t < i; t += 1){
                    var a = this.threeDElements[t].perspectiveElem.style;
                    a.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px", a.perspective = a.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length, i = createTag("div");
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var a = this.createComp(t[e], i, this.globalData.comp, null);
                a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t, e) {
            for(var r, i = 0; i < e;)this.elements[i] && this.elements[i].getBaseElement && (r = this.elements[i].getBaseElement()), i += 1;
            r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
        }, HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        };
        var CompExpressionInterface = function(t) {
            function e(e) {
                for(var r = 0, i = t.layers.length; r < i;){
                    if (t.layers[r].nm === e || t.layers[r].ind === e) return t.elements[r].layerInterface;
                    r += 1;
                }
                return null;
            }
            return Object.defineProperty(e, "_name", {
                value: t.data.nm
            }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
        };
        function _typeof$2(t) {
            return (_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        function seedRandom(t, e) {
            var r = this, i = e.pow(256, 6), a = e.pow(2, 52), s = 2 * a;
            function n(t) {
                var e, r = t.length, i = this, a = 0, s = i.i = i.j = 0, n = i.S = [];
                for(r || (t = [
                    r++
                ]); a < 256;)n[a] = a++;
                for(a = 0; a < 256; a++)n[a] = n[s = 255 & s + t[a % r] + (e = n[a])], n[s] = e;
                i.g = function(t) {
                    for(var e, r = 0, a = i.i, s = i.j, n = i.S; t--;)e = n[a = 255 & a + 1], r = 256 * r + n[255 & (n[a] = n[s = 255 & s + e]) + (n[s] = e)];
                    return i.i = a, i.j = s, r;
                };
            }
            function o(t, e) {
                return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
            }
            function h(t, e) {
                for(var r, i = t + "", a = 0; a < i.length;)e[255 & a] = 255 & (r ^= 19 * e[255 & a]) + i.charCodeAt(a++);
                return l(e);
            }
            function l(t) {
                return String.fromCharCode.apply(0, t);
            }
            e.seedrandom = function(p, f, c) {
                var m = [], d = h(function t(e, r) {
                    var i, a = [], s = _typeof$2(e);
                    if (r && "object" == s) for(i in e)try {
                        a.push(t(e[i], r - 1));
                    } catch (t) {}
                    return a.length ? a : "string" == s ? e : e + "\0";
                }((f = !0 === f ? {
                    entropy: !0
                } : f || {}).entropy ? [
                    p,
                    l(t)
                ] : null === p ? function() {
                    try {
                        var e = new Uint8Array(256);
                        return (r.crypto || r.msCrypto).getRandomValues(e), l(e);
                    } catch (e) {
                        var i = r.navigator, a = i && i.plugins;
                        return [
                            +new Date,
                            r,
                            a,
                            r.screen,
                            l(t)
                        ];
                    }
                }() : p, 3), m), u = new n(m), y = function() {
                    for(var t = u.g(6), e = i, r = 0; t < a;)t = 256 * (t + r), e *= 256, r = u.g(1);
                    for(; t >= s;)t /= 2, e /= 2, r >>>= 1;
                    return (t + r) / e;
                };
                return y.int32 = function() {
                    return 0 | u.g(4);
                }, y.quick = function() {
                    return u.g(4) / 4294967296;
                }, y.double = y, h(l(u.S), t), (f.pass || c || function(t, r, i, a) {
                    return a && (a.S && o(a, u), t.state = function() {
                        return o(u, {});
                    }), i ? (e.random = t, r) : t;
                })(y, d, "global" in f ? f.global : this == e, f.state);
            }, h(e.random(), t);
        }
        function initialize$2(t) {
            seedRandom([], t);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof$1(t) {
            return (_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var ExpressionManager = function() {
            var ob = {}, Math1 = BMMath, window1 = null, document1 = null, XMLHttpRequest1 = null, fetch1 = null, frames = null, _lottieGlobal = {};
            function resetFrame() {
                _lottieGlobal = {};
            }
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array;
            }
            function isNumerable(t, e) {
                return "number" === t || e instanceof Number || "boolean" === t || "string" === t;
            }
            function $bm_neg(t) {
                var e = _typeof$1(t);
                if ("number" === e || t instanceof Number || "boolean" === e) return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r, i = t.length, a = [];
                    for(r = 0; r < i; r += 1)a[r] = -t[r];
                    return a;
                }
                return t.propType ? t.v : -t;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e) || "string" === r || "string" === i) return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] += e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t + e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] + e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            var add = sum;
            function sub(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e)) return "string" === r && (t = parseInt(t, 10)), "string" === i && (e = parseInt(e, 10)), t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] -= e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t - e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] - e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            function mul(t, e) {
                var r, i, a, s = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t * e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] * e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t * e[i];
                    return r;
                }
                return 0;
            }
            function div(t, e) {
                var r, i, a, s = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t / e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] / e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t / e[i];
                    return r;
                }
                return 0;
            }
            function mod(t, e) {
                return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t, e, r) {
                if (e > r) {
                    var i = r;
                    r = e, e = i;
                }
                return Math1.min(Math1.max(t, e), r);
            }
            function radiansToDegrees(t) {
                return t / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t, e) {
                if ("number" == typeof t || t instanceof Number) return e = e || 0, Math1.abs(t - e);
                var r;
                e || (e = helperLengthArray);
                var i = Math1.min(t.length, e.length), a = 0;
                for(r = 0; r < i; r += 1)a += Math1.pow(e[r] - t[r], 2);
                return Math1.sqrt(a);
            }
            function normalize(t) {
                return div(t, length(t));
            }
            function rgbToHsl(t) {
                var e, r, i = t[0], a = t[1], s = t[2], n = Math1.max(i, a, s), o = Math1.min(i, a, s), h = (n + o) / 2;
                if (n === o) e = 0, r = 0;
                else {
                    var l = n - o;
                    switch(r = h > .5 ? l / (2 - n - o) : l / (n + o), n){
                        case i:
                            e = (a - s) / l + (a < s ? 6 : 0);
                            break;
                        case a:
                            e = (s - i) / l + 2;
                            break;
                        case s:
                            e = (i - a) / l + 4;
                    }
                    e /= 6;
                }
                return [
                    e,
                    r,
                    h,
                    t[3]
                ];
            }
            function hue2rgb(t, e, r) {
                return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
            }
            function hslToRgb(t) {
                var e, r, i, a = t[0], s = t[1], n = t[2];
                if (0 === s) e = n, i = n, r = n;
                else {
                    var o = n < .5 ? n * (1 + s) : n + s - n * s, h = 2 * n - o;
                    e = hue2rgb(h, o, a + 1 / 3), r = hue2rgb(h, o, a), i = hue2rgb(h, o, a - 1 / 3);
                }
                return [
                    e,
                    r,
                    i,
                    t[3]
                ];
            }
            function linear(t, e, r, i, a) {
                if (void 0 !== i && void 0 !== a || (i = e, a = r, e = 0, r = 1), r < e) {
                    var s = r;
                    r = e, e = s;
                }
                if (t <= e) return i;
                if (t >= r) return a;
                var n, o = r === e ? 0 : (t - e) / (r - e);
                if (!i.length) return i + (a - i) * o;
                var h = i.length, l = createTypedArray("float32", h);
                for(n = 0; n < h; n += 1)l[n] = i[n] + (a[n] - i[n]) * o;
                return l;
            }
            function random(t, e) {
                if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
                    var r, i = e.length;
                    t || (t = createTypedArray("float32", i));
                    var a = createTypedArray("float32", i), s = BMMath.random();
                    for(r = 0; r < i; r += 1)a[r] = t[r] + s * (e[r] - t[r]);
                    return a;
                }
                return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
            }
            function createPath(t, e, r, i) {
                var a, s = t.length, n = shapePool.newElement();
                n.setPathData(!!i, s);
                var o, h, l = [
                    0,
                    0
                ];
                for(a = 0; a < s; a += 1)o = e && e[a] ? e[a] : l, h = r && r[a] ? r[a] : l, n.setTripleAt(t[a][0], t[a][1], h[0] + t[a][0], h[1] + t[a][1], o[0] + t[a][0], o[1] + t[a][1], a, !0);
                return n;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t, e) {
                    var r, i, a = this.pv.length ? this.pv.length : 1, s = createTypedArray("float32", a);
                    var n = Math1.floor(5 * time);
                    for(r = 0, i = 0; r < n;){
                        for(i = 0; i < a; i += 1)s[i] += -e + 2 * e * BMMath.random();
                        r += 1;
                    }
                    var o = 5 * time, h = o - Math1.floor(o), l = createTypedArray("float32", a);
                    if (a > 1) {
                        for(i = 0; i < a; i += 1)l[i] = this.pv[i] + s[i] + (-e + 2 * e * BMMath.random()) * h;
                        return l;
                    }
                    return this.pv + s[0] + (-e + 2 * e * BMMath.random()) * h;
                }).bind(this);
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0);
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t, e) {
                    var r = [
                        e[0] - t[0],
                        e[1] - t[1],
                        e[2] - t[2]
                    ], i = Math1.atan2(r[0], Math1.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                    return [
                        -Math1.atan2(r[1], r[2]) / degToRads,
                        i,
                        0
                    ];
                }
                function easeOut(t, e, r, i, a) {
                    return applyEase(easeOutBez, t, e, r, i, a);
                }
                function easeIn(t, e, r, i, a) {
                    return applyEase(easeInBez, t, e, r, i, a);
                }
                function ease(t, e, r, i, a) {
                    return applyEase(easeInOutBez, t, e, r, i, a);
                }
                function applyEase(t, e, r, i, a, s) {
                    void 0 === a ? (a = r, s = i) : e = (e - r) / (i - r), e > 1 ? e = 1 : e < 0 && (e = 0);
                    var n = t(e);
                    if ($bm_isInstanceOfArray(a)) {
                        var o, h = a.length, l = createTypedArray("float32", h);
                        for(o = 0; o < h; o += 1)l[o] = (s[o] - a[o]) * n + a[o];
                        return l;
                    }
                    return (s - a) * n + a;
                }
                function nearestKey(t) {
                    var e, r, i, a = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) r = 1, i = data.k[0].t;
                        else {
                            for(e = 0; e < a - 1; e += 1){
                                if (t === data.k[e].t) {
                                    r = e + 1, i = data.k[e].t;
                                    break;
                                }
                                if (t > data.k[e].t && t < data.k[e + 1].t) {
                                    t - data.k[e].t > data.k[e + 1].t - t ? (r = e + 2, i = data.k[e + 1].t) : (r = e + 1, i = data.k[e].t);
                                    break;
                                }
                            }
                            -1 === r && (r = e + 1, i = data.k[e].t);
                        }
                    } else r = 0, i = 0;
                    var s = {};
                    return s.index = r, s.time = i / elem.comp.globalData.frameRate, s;
                }
                function key(t) {
                    var e, r, i;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                    t -= 1, e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var a = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for(i = a.length, r = 0; r < i; r += 1)e[r] = a[r], e.value[r] = a[r];
                    return e;
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate), t / e;
                }
                function timeToFrames(t, e) {
                    return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substring(t) : value.substring(t, e) : "";
                }
                function substr(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substr(t) : value.substr(t, e) : "";
                }
                function posterizeTime(t) {
                    time = 0 === t ? 0 : Math1.floor(time * t) / t, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math1.floor(1e6 * Math1.random()), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window1,
                document1,
                XMLHttpRequest1,
                fetch1,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath,
                _lottieGlobal
            ], ob.resetFrame = resetFrame, ob;
        }(), Expressions = function() {
            var t = {};
            return t.initExpressions = function(t) {
                var e = 0, r = [];
                t.renderer.compInterface = CompExpressionInterface(t.renderer), t.renderer.globalData.projectInterface.registerComposition(t.renderer), t.renderer.globalData.pushExpression = function() {
                    e += 1;
                }, t.renderer.globalData.popExpression = function() {
                    0 === (e -= 1) && function() {
                        var t, e = r.length;
                        for(t = 0; t < e; t += 1)r[t].release();
                        r.length = 0;
                    }();
                }, t.renderer.globalData.registerExpressionProperty = function(t) {
                    -1 === r.indexOf(t) && r.push(t);
                };
            }, t.resetFrame = ExpressionManager.resetFrame, t;
        }(), MaskManagerInterface = function() {
            function t(t, e) {
                this._mask = t, this._data = e;
            }
            Object.defineProperty(t.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            });
            return function(e) {
                var r, i = createSizedArray(e.viewData.length), a = e.viewData.length;
                for(r = 0; r < a; r += 1)i[r] = new t(e.viewData[r], e.masksProperties[r]);
                return function(t) {
                    for(r = 0; r < a;){
                        if (e.masksProperties[r].nm === t) return i[r];
                        r += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }, e = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r(t, e, r) {
                Object.defineProperty(t, "velocity", {
                    get: function() {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                    }
                }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function(i) {
                    if (!t.numKeys) return 0;
                    var a = "";
                    a = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                    var s = "unidimensional" === r ? new Number(a) : Object.assign({}, a);
                    return s.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate, s.value = "unidimensional" === r ? a[0] : a, s;
                }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
            }
            function i() {
                return t;
            }
            return function(a) {
                return a ? "unidimensional" === a.propType ? function(e) {
                    e && "pv" in e || (e = t);
                    var i = 1 / e.mult, a = e.pv * i, s = new Number(a);
                    return s.value = a, r(s, e, "unidimensional"), function() {
                        return e.k && e.getValue(), a = e.v * i, s.value !== a && ((s = new Number(a)).value = a, r(s, e, "unidimensional")), s;
                    };
                }(a) : function(t) {
                    t && "pv" in t || (t = e);
                    var i = 1 / t.mult, a = t.data && t.data.l || t.pv.length, s = createTypedArray("float32", a), n = createTypedArray("float32", a);
                    return s.value = n, r(s, t, "multidimensional"), function() {
                        t.k && t.getValue();
                        for(var e = 0; e < a; e += 1)n[e] = t.v[e] * i, s[e] = n[e];
                        return s;
                    };
                }(a) : i;
            };
        }(), TransformExpressionInterface = function(t) {
            function e(t) {
                switch(t){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null;
                }
            }
            var r, i, a, s;
            return Object.defineProperty(e, "rotation", {
                get: ExpressionPropertyInterface(t.r || t.rz)
            }), Object.defineProperty(e, "zRotation", {
                get: ExpressionPropertyInterface(t.rz || t.r)
            }), Object.defineProperty(e, "xRotation", {
                get: ExpressionPropertyInterface(t.rx)
            }), Object.defineProperty(e, "yRotation", {
                get: ExpressionPropertyInterface(t.ry)
            }), Object.defineProperty(e, "scale", {
                get: ExpressionPropertyInterface(t.s)
            }), t.p ? s = ExpressionPropertyInterface(t.p) : (r = ExpressionPropertyInterface(t.px), i = ExpressionPropertyInterface(t.py), t.pz && (a = ExpressionPropertyInterface(t.pz))), Object.defineProperty(e, "position", {
                get: function() {
                    return t.p ? s() : [
                        r(),
                        i(),
                        a ? a() : 0
                    ];
                }
            }), Object.defineProperty(e, "xPosition", {
                get: ExpressionPropertyInterface(t.px)
            }), Object.defineProperty(e, "yPosition", {
                get: ExpressionPropertyInterface(t.py)
            }), Object.defineProperty(e, "zPosition", {
                get: ExpressionPropertyInterface(t.pz)
            }), Object.defineProperty(e, "anchorPoint", {
                get: ExpressionPropertyInterface(t.a)
            }), Object.defineProperty(e, "opacity", {
                get: ExpressionPropertyInterface(t.o)
            }), Object.defineProperty(e, "skew", {
                get: ExpressionPropertyInterface(t.sk)
            }), Object.defineProperty(e, "skewAxis", {
                get: ExpressionPropertyInterface(t.sa)
            }), Object.defineProperty(e, "orientation", {
                get: ExpressionPropertyInterface(t.or)
            }), e;
        }, LayerExpressionInterface = function() {
            function t(t) {
                var e = new Matrix;
                void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e);
                return e;
            }
            function e(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.applyPoint(r, t);
            }
            function r(t, e) {
                var r = this.getMatrix(e);
                return this.applyPoint(r, t);
            }
            function i(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.invertPoint(r, t);
            }
            function a(t, e) {
                var r = this.getMatrix(e);
                return this.invertPoint(r, t);
            }
            function s(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.applyToPointArray(e[0], e[1], e[2] || 0);
            }
            function n(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.inversePoint(e);
            }
            function o(t) {
                var e = new Matrix;
                if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                    return e.inversePoint(t);
                }
                return e.inversePoint(t);
            }
            function h() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l) {
                var p;
                function f(t) {
                    switch(t){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return f.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return f.effect;
                        case "ADBE Text Properties":
                            return f.textInterface;
                        default:
                            return null;
                    }
                }
                f.getMatrix = t, f.invertPoint = n, f.applyPoint = s, f.toWorld = r, f.toWorldVec = e, f.fromWorld = a, f.fromWorldVec = i, f.toComp = r, f.fromComp = o, f.sampleImage = h, f.sourceRectAtTime = l.sourceRectAtTime.bind(l), f._elem = l;
                var c = getDescriptor(p = TransformExpressionInterface(l.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(f, {
                    hasParent: {
                        get: function() {
                            return l.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: c,
                    anchor_point: c,
                    transform: {
                        get: function() {
                            return p;
                        }
                    },
                    active: {
                        get: function() {
                            return l.isInRange;
                        }
                    }
                }), f.startTime = l.data.st, f.index = l.data.ind, f.source = l.data.refId, f.height = 0 === l.data.ty ? l.data.h : 100, f.width = 0 === l.data.ty ? l.data.w : 100, f.inPoint = l.data.ip / l.comp.globalData.frameRate, f.outPoint = l.data.op / l.comp.globalData.frameRate, f._name = l.data.nm, f.registerMaskInterface = function(t) {
                    f.mask = new MaskManagerInterface(t, l);
                }, f.registerEffectsInterface = function(t) {
                    f.effect = t;
                }, f;
            };
        }(), propertyGroupFactory = function(t, e) {
            return function(r) {
                return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
            };
        }, PropertyInterface = function(t, e) {
            var r = {
                _name: t
            };
            return function(t) {
                return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
            };
        }, EffectsExpressionInterface = function() {
            function t(r, i, a, s) {
                function n(t) {
                    for(var e = r.ef, i = 0, a = e.length; i < a;){
                        if (t === e[i].nm || t === e[i].mn || t === e[i].ix) return 5 === e[i].ty ? l[i] : l[i]();
                        i += 1;
                    }
                    throw new Error;
                }
                var o, h = propertyGroupFactory(n, a), l = [], p = r.ef.length;
                for(o = 0; o < p; o += 1)5 === r.ef[o].ty ? l.push(t(r.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, s)) : l.push(e(i.effectElements[o], r.ef[o].ty, s, h));
                return "ADBE Color Control" === r.mn && Object.defineProperty(n, "color", {
                    get: function() {
                        return l[0]();
                    }
                }), Object.defineProperties(n, {
                    numProperties: {
                        get: function() {
                            return r.np;
                        }
                    },
                    _name: {
                        value: r.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }), n.enabled = 0 !== r.en, n.active = n.enabled, n;
            }
            function e(t, e, r, i) {
                var a = ExpressionPropertyInterface(t.p);
                return t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)), function() {
                    return 10 === e ? r.comp.compInterface(t.p.v) : a();
                };
            }
            return {
                createEffectsInterface: function(e, r) {
                    if (e.effectsManager) {
                        var i, a = [], s = e.data.ef, n = e.effectsManager.effectElements.length;
                        for(i = 0; i < n; i += 1)a.push(t(s[i], e.effectsManager.effectElements[i], r, e));
                        var o = e.data.ef || [], h = function(t) {
                            for(i = 0, n = o.length; i < n;){
                                if (t === o[i].nm || t === o[i].mn || t === o[i].ix) return a[i];
                                i += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h, "numProperties", {
                            get: function() {
                                return o.length;
                            }
                        }), h;
                    }
                    return null;
                }
            };
        }(), ShapePathInterface = function(t, e, r) {
            var i = e.sh;
            function a(t) {
                return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? a.path : null;
            }
            var s = propertyGroupFactory(a, r);
            return i.setGroupProperty(PropertyInterface("Path", s)), Object.defineProperties(a, {
                path: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                shape: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                _name: {
                    value: t.nm
                },
                ix: {
                    value: t.ix
                },
                propertyIndex: {
                    value: t.ix
                },
                mn: {
                    value: t.mn
                },
                propertyGroup: {
                    value: r
                }
            }), a;
        }, ShapeExpressionInterface = function() {
            function t(t, o, m) {
                var d, u = [], y = t ? t.length : 0;
                for(d = 0; d < y; d += 1)"gr" === t[d].ty ? u.push(e(t[d], o[d], m)) : "fl" === t[d].ty ? u.push(r(t[d], o[d], m)) : "st" === t[d].ty ? u.push(s(t[d], o[d], m)) : "tm" === t[d].ty ? u.push(n(t[d], o[d], m)) : "tr" === t[d].ty || ("el" === t[d].ty ? u.push(h(t[d], o[d], m)) : "sr" === t[d].ty ? u.push(l(t[d], o[d], m)) : "sh" === t[d].ty ? u.push(ShapePathInterface(t[d], o[d], m)) : "rc" === t[d].ty ? u.push(p(t[d], o[d], m)) : "rd" === t[d].ty ? u.push(f(t[d], o[d], m)) : "rp" === t[d].ty ? u.push(c(t[d], o[d], m)) : "gf" === t[d].ty ? u.push(i(t[d], o[d], m)) : u.push(a(t[d], o[d])));
                return u;
            }
            function e(e, r, i) {
                var a = function(t) {
                    switch(t){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return a.content;
                        default:
                            return a.transform;
                    }
                };
                a.propertyGroup = propertyGroupFactory(a, i);
                var s = function(e, r, i) {
                    var a, s = function(t) {
                        for(var e = 0, r = a.length; e < r;){
                            if (a[e]._name === t || a[e].mn === t || a[e].propertyIndex === t || a[e].ix === t || a[e].ind === t) return a[e];
                            e += 1;
                        }
                        return "number" == typeof t ? a[t - 1] : null;
                    };
                    s.propertyGroup = propertyGroupFactory(s, i), a = t(e.it, r.it, s.propertyGroup), s.numProperties = a.length;
                    var n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], s.propertyGroup);
                    return s.transform = n, s.propertyIndex = e.cix, s._name = e.nm, s;
                }(e, r, a.propertyGroup), n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], a.propertyGroup);
                return a.content = s, a.transform = n, Object.defineProperty(a, "_name", {
                    get: function() {
                        return e.nm;
                    }
                }), a.numProperties = e.np, a.propertyIndex = e.ix, a.nm = e.nm, a.mn = e.mn, a;
            }
            function r(t, e, r) {
                function i(t) {
                    return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function i(t, e, r) {
                function i(t) {
                    return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.s.setGroupProperty(PropertyInterface("Start Point", r)), e.e.setGroupProperty(PropertyInterface("End Point", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function a() {
                return function() {
                    return null;
                };
            }
            function s(t, e, r) {
                var i, a = propertyGroupFactory(l, r), s = propertyGroupFactory(h, a);
                function n(r) {
                    Object.defineProperty(h, t.d[r].nm, {
                        get: ExpressionPropertyInterface(e.d.dataProps[r].p)
                    });
                }
                var o = t.d ? t.d.length : 0, h = {};
                for(i = 0; i < o; i += 1)n(i), e.d.dataProps[i].p.setGroupProperty(s);
                function l(t) {
                    return "Color" === t || "color" === t ? l.color : "Opacity" === t || "opacity" === t ? l.opacity : "Stroke Width" === t || "stroke width" === t ? l.strokeWidth : null;
                }
                return Object.defineProperties(l, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e.w)
                    },
                    dash: {
                        get: function() {
                            return h;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", a)), e.o.setGroupProperty(PropertyInterface("Opacity", a)), e.w.setGroupProperty(PropertyInterface("Stroke Width", a)), l;
            }
            function n(t, e, r) {
                function i(e) {
                    return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r);
                return i.propertyIndex = t.ix, e.s.setGroupProperty(PropertyInterface("Start", a)), e.e.setGroupProperty(PropertyInterface("End", a)), e.o.setGroupProperty(PropertyInterface("Offset", a)), i.propertyIndex = t.ix, i.propertyGroup = r, Object.defineProperties(i, {
                    start: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function o(t, e, r) {
                function i(e) {
                    return t.a.ix === e || "Anchor Point" === e ? i.anchorPoint : t.o.ix === e || "Opacity" === e ? i.opacity : t.p.ix === e || "Position" === e ? i.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? i.rotation : t.s.ix === e || "Scale" === e ? i.scale : t.sk && t.sk.ix === e || "Skew" === e ? i.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? i.skewAxis : null;
                }
                var a = propertyGroupFactory(i, r);
                return e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", a)), e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", a)), e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", a)), e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", a)), e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", a)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", a)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", a))), e.transform.op.setGroupProperty(PropertyInterface("Opacity", a)), Object.defineProperties(i, {
                    opacity: {
                        get: ExpressionPropertyInterface(e.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sa)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.ty = "tr", i.mn = t.mn, i.propertyGroup = r, i;
            }
            function h(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r);
                i.propertyIndex = t.ix;
                var s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return s.s.setGroupProperty(PropertyInterface("Size", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), Object.defineProperties(i, {
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function l(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.rotation : t.pt.ix === e ? i.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? i.outerRadius : t.os.ix === e ? i.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? i.innerRoundness : null : i.innerRadius;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.or.setGroupProperty(PropertyInterface("Outer Radius", a)), s.os.setGroupProperty(PropertyInterface("Outer Roundness", a)), s.pt.setGroupProperty(PropertyInterface("Points", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), t.ir && (s.ir.setGroupProperty(PropertyInterface("Inner Radius", a)), s.is.setGroupProperty(PropertyInterface("Inner Roundness", a))), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(s.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(s.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(s.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(s.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(s.is)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function p(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.p.setGroupProperty(PropertyInterface("Position", a)), s.s.setGroupProperty(PropertyInterface("Size", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function f(t, e, r) {
                function i(e) {
                    return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.rd.setGroupProperty(PropertyInterface("Radius", a)), Object.defineProperties(i, {
                    radius: {
                        get: ExpressionPropertyInterface(s.rd)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function c(t, e, r) {
                function i(e) {
                    return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.c.setGroupProperty(PropertyInterface("Copies", a)), s.o.setGroupProperty(PropertyInterface("Offset", a)), Object.defineProperties(i, {
                    copies: {
                        get: ExpressionPropertyInterface(s.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(s.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            return function(e, r, i) {
                var a;
                function s(t) {
                    if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : a[t - 1];
                    for(var e = 0, r = a.length; e < r;){
                        if (a[e]._name === t) return a[e];
                        e += 1;
                    }
                    return null;
                }
                return s.propertyGroup = propertyGroupFactory(s, function() {
                    return i;
                }), a = t(e, r, s.propertyGroup), s.numProperties = a.length, s._name = "Contents", s;
            };
        }(), TextExpressionInterface = function(t) {
            var e;
            function r(t) {
                switch(t){
                    case "ADBE Text Document":
                        return r.sourceText;
                    default:
                        return null;
                }
            }
            return Object.defineProperty(r, "sourceText", {
                get: function() {
                    t.textProperty.getValue();
                    var r = t.textProperty.currentData.t;
                    return e && r === e.value || ((e = new String(r)).value = r || new String(r), Object.defineProperty(e, "style", {
                        get: function() {
                            return {
                                fillColor: t.textProperty.currentData.fc
                            };
                        }
                    })), e;
                }
            }), r;
        };
        function _typeof(t) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var FootageInterface = (dataInterfaceFactory = function(t) {
            function e(t) {
                return "Outline" === t ? e.outlineInterface() : null;
            }
            return e._name = "Outline", e.outlineInterface = function(t) {
                var e = "", r = t.getFootageData();
                function i(t) {
                    if (r[t]) return e = t, "object" === _typeof(r = r[t]) ? i : r;
                    var a = t.indexOf(e);
                    if (-1 !== a) {
                        var s = parseInt(t.substr(a + e.length), 10);
                        return "object" === _typeof(r = r[s]) ? i : r;
                    }
                    return "";
                }
                return function() {
                    return e = "", r = t.getFootageData(), i;
                };
            }(t), e;
        }, function(t) {
            function e(t) {
                return "Data" === t ? e.dataInterface : null;
            }
            return e._name = "Data", e.dataInterface = dataInterfaceFactory(t), e;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null;
        }
        var expressionHelpers = {
            searchExpressions: function(t, e, r) {
                e.x && (r.k = !0, r.x = !0, r.initiateExpression = ExpressionManager.initiateExpression, r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
            },
            getSpeedAtTime: function(t) {
                var e = this.getValueAtTime(t), r = this.getValueAtTime(t + -0.01), i = 0;
                if (e.length) {
                    var a;
                    for(a = 0; a < e.length; a += 1)i += Math.pow(r[a] - e[a], 2);
                    i = 100 * Math.sqrt(i);
                } else i = 0;
                return i;
            },
            getVelocityAtTime: function(t) {
                if (void 0 !== this.vel) return this.vel;
                var e, r, i = this.getValueAtTime(t), a = this.getValueAtTime(t + -0.001);
                if (i.length) for(e = createTypedArray("float32", i.length), r = 0; r < i.length; r += 1)e[r] = (a[r] - i[r]) / -0.001;
                else e = (a - i) / -0.001;
                return e;
            },
            getValueAtTime: function(t) {
                return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t) {
                this.propertyGroup = t;
            }
        };
        function addPropertyDecorator() {
            function t(t, e, r) {
                if (!this.k || !this.keyframes) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[l.length - 1].t;
                if (h <= p) return this.pv;
                if (r ? a = p - (i = e ? Math.abs(p - this.elem.comp.globalData.frameRate * e) : Math.max(0, p - this.elem.data.ip)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = p - (a = l[l.length - 1 - e].t)), "pingpong" === t) {
                    if (Math.floor((h - a) / i) % 2 != 0) return this.getValueAtTime((i - (h - a) % i + a) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), m = this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0), d = Math.floor((h - a) / i);
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = (c[s] - f[s]) * d + m[s];
                            return o;
                        }
                        return (c - f) * d + m;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * ((h - p) / this.comp.globalData.frameRate) / 5e-4;
                            return o;
                        }
                        return u + (h - p) / .001 * (u - y);
                    }
                }
                return this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0);
            }
            function e(t, e, r) {
                if (!this.k) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[0].t;
                if (h >= p) return this.pv;
                if (r ? a = p + (i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - p)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = (a = l[e].t) - p), "pingpong" === t) {
                    if (Math.floor((p - h) / i) % 2 == 0) return this.getValueAtTime(((p - h) % i + p) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), m = this.getValueAtTime((i - (p - h) % i + p) / this.comp.globalData.frameRate, 0), d = Math.floor((p - h) / i) + 1;
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = m[s] - (c[s] - f[s]) * d;
                            return o;
                        }
                        return m - (c - f) * d;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * (p - h) / .001;
                            return o;
                        }
                        return u + (u - y) * (p - h) / .001;
                    }
                }
                return this.getValueAtTime((i - ((p - h) % i + p)) / this.comp.globalData.frameRate, 0);
            }
            function r(t, e) {
                if (!this.k) return this.pv;
                if (t = .5 * (t || .4), (e = Math.floor(e || 5)) <= 1) return this.pv;
                var r, i, a = this.comp.renderedFrame / this.comp.globalData.frameRate, s = a - t, n = e > 1 ? (a + t - s) / (e - 1) : 1, o = 0, h = 0;
                for(r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e;){
                    if (i = this.getValueAtTime(s + o * n), this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] += i[h];
                    else r += i;
                    o += 1;
                }
                if (this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] /= e;
                else r /= e;
                return r;
            }
            function i(t) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e = this._transformCachingAtTime.v;
                if (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r = this.a.getValueAtTime(t);
                    e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i = this.s.getValueAtTime(t);
                    e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var a = this.sk.getValueAtTime(t), s = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-a * this.sk.mult, s * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n = this.r.getValueAtTime(t);
                    e.rotate(-n * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o = this.rz.getValueAtTime(t), h = this.ry.getValueAtTime(t), l = this.rx.getValueAtTime(t), p = this.or.getValueAtTime(t);
                    e.rotateZ(-o * this.rz.mult).rotateY(h * this.ry.mult).rotateX(l * this.rx.mult).rotateZ(-p[2] * this.or.mult).rotateY(p[1] * this.or.mult).rotateX(p[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var f = this.px.getValueAtTime(t), c = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                        var m = this.pz.getValueAtTime(t);
                        e.translate(f * this.px.mult, c * this.py.mult, -m * this.pz.mult);
                    } else e.translate(f * this.px.mult, c * this.py.mult, 0);
                } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                }
                return e;
            }
            function a() {
                return this.v.clone(new Matrix);
            }
            var s = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t, e, r) {
                var n = s(t, e, r);
                return n.dynamicProperties.length ? n.getValueAtTime = i.bind(n) : n.getValueAtTime = a.bind(n), n.setGroupProperty = expressionHelpers.setGroupProperty, n;
            };
            var n = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i, a, s, o, h) {
                var l = n(i, a, s, o, h);
                l.kf ? l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l) : l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l), l.setGroupProperty = expressionHelpers.setGroupProperty, l.loopOut = t, l.loopIn = e, l.smooth = r, l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l), l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l), l.numKeys = 1 === a.a ? a.k.length : 0, l.propertyIndex = a.ix;
                var p = 0;
                return 0 !== s && (p = createTypedArray("float32", 1 === a.a ? a.k[0].s.length : a.k.length)), l._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p
                }, expressionHelpers.searchExpressions(i, a, l), l.k && h.addDynamicProperty(l), l;
            };
            var o = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l() {}
            l.prototype = {
                vertices: function(t, e) {
                    this.k && this.getValue();
                    var r, i = this.v;
                    void 0 !== e && (i = this.getValueAtTime(e, 0));
                    var a = i._length, s = i[t], n = i.v, o = createSizedArray(a);
                    for(r = 0; r < a; r += 1)o[r] = "i" === t || "o" === t ? [
                        s[r][0] - n[r][0],
                        s[r][1] - n[r][1]
                    ] : [
                        s[r][0],
                        s[r][1]
                    ];
                    return o;
                },
                points: function(t) {
                    return this.vertices("v", t);
                },
                inTangents: function(t) {
                    return this.vertices("i", t);
                },
                outTangents: function(t) {
                    return this.vertices("o", t);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t, e) {
                    var r = this.v;
                    void 0 !== e && (r = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                    for(var i, a = this._segmentsLength, s = a.lengths, n = a.totalLength * t, o = 0, h = s.length, l = 0; o < h;){
                        if (l + s[o].addedLength > n) {
                            var p = o, f = r.c && o === h - 1 ? 0 : o + 1, c = (n - l) / s[o].addedLength;
                            i = bez.getPointInSegment(r.v[p], r.v[f], r.o[p], r.i[f], c, s[o]);
                            break;
                        }
                        l += s[o].addedLength, o += 1;
                    }
                    return i || (i = r.c ? [
                        r.v[0][0],
                        r.v[0][1]
                    ] : [
                        r.v[r._length - 1][0],
                        r.v[r._length - 1][1]
                    ]), i;
                },
                vectorOnPath: function(t, e, r) {
                    1 == t ? t = this.v.c : 0 == t && (t = .999);
                    var i = this.pointOnPath(t, e), a = this.pointOnPath(t + .001, e), s = a[0] - i[0], n = a[1] - i[1], o = Math.sqrt(Math.pow(s, 2) + Math.pow(n, 2));
                    return 0 === o ? [
                        0,
                        0
                    ] : "tangent" === r ? [
                        s / o,
                        n / o
                    ] : [
                        -n / o,
                        s / o
                    ];
                },
                tangentOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "tangent");
                },
                normalOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l
            ], o), extendPrototype([
                l
            ], h), h.prototype.getValueAtTime = function(t) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t, this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t, e, r, i, a) {
                var s = p(t, e, r, i, a);
                return s.propertyIndex = e.ix, s.lock = !1, 3 === r ? expressionHelpers.searchExpressions(t, e.pt, s) : 4 === r && expressionHelpers.searchExpressions(t, e.ks, s), s.k && t.addDynamicProperty(s), s;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t, e) {
                var r = this.calculateExpression(e);
                if (t.t !== r) {
                    var i = {};
                    return this.copyData(i, t), i.t = r.toString(), i.__complete = !1, i;
                }
                return t;
            }, TextProperty.prototype.searchProperty = function() {
                var t = this.searchKeyframes(), e = this.searchExpressions();
                return this.kf = t || e, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function(t, e) {
                var r, i, a = createNS("feMerge");
                for(a.setAttribute("result", t), i = 0; i < e.length; i += 1)(r = createNS("feMergeNode")).setAttribute("in", e[i]), a.appendChild(r), a.appendChild(r);
                return a;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r, i, a) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = s, s.setAttribute("result", i + "_tint_1"), t.appendChild(s), (s = createNS("feColorMatrix")).setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i + "_tint_2"), t.appendChild(s), this.matrixFilter = s;
            var n = this.createMergeNode(i, [
                a,
                i + "_tint_1",
                i + "_tint_2"
            ]);
            t.appendChild(n);
        }
        function SVGFillFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i), t.appendChild(a), this.matrixFilter = a;
        }
        function SVGStrokeEffect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.elem = r, this.paths = [];
        }
        function SVGTritoneFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(a);
            var s = createNS("feComponentTransfer");
            s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), this.matrixFilter = s;
            var n = createNS("feFuncR");
            n.setAttribute("type", "table"), s.appendChild(n), this.feFuncR = n;
            var o = createNS("feFuncG");
            o.setAttribute("type", "table"), s.appendChild(o), this.feFuncG = o;
            var h = createNS("feFuncB");
            h.setAttribute("type", "table"), s.appendChild(h), this.feFuncB = h, t.appendChild(s);
        }
        function SVGProLevelsFilter(t, e, r, i) {
            this.filterManager = e;
            var a = this.filterManager.effectElements, s = createNS("feComponentTransfer");
            (a[10].p.k || 0 !== a[10].p.v || a[11].p.k || 1 !== a[11].p.v || a[12].p.k || 1 !== a[12].p.v || a[13].p.k || 0 !== a[13].p.v || a[14].p.k || 1 !== a[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", s)), (a[17].p.k || 0 !== a[17].p.v || a[18].p.k || 1 !== a[18].p.v || a[19].p.k || 1 !== a[19].p.v || a[20].p.k || 0 !== a[20].p.v || a[21].p.k || 1 !== a[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", s)), (a[24].p.k || 0 !== a[24].p.v || a[25].p.k || 1 !== a[25].p.v || a[26].p.k || 1 !== a[26].p.v || a[27].p.k || 0 !== a[27].p.v || a[28].p.k || 1 !== a[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", s)), (a[31].p.k || 0 !== a[31].p.v || a[32].p.k || 1 !== a[32].p.v || a[33].p.k || 1 !== a[33].p.v || a[34].p.k || 0 !== a[34].p.v || a[35].p.k || 1 !== a[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", s)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (s.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(s)), (a[3].p.k || 0 !== a[3].p.v || a[4].p.k || 1 !== a[4].p.v || a[5].p.k || 1 !== a[5].p.v || a[6].p.k || 0 !== a[6].p.v || a[7].p.k || 1 !== a[7].p.v) && ((s = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), t.appendChild(s), this.feFuncRComposed = this.createFeFunc("feFuncR", s), this.feFuncGComposed = this.createFeFunc("feFuncG", s), this.feFuncBComposed = this.createFeFunc("feFuncB", s));
        }
        function SVGDropShadowEffect(t, e, r, i, a) {
            var s = e.container.globalData.renderConfig.filterSize, n = e.data.fs || s;
            t.setAttribute("x", n.x || s.x), t.setAttribute("y", n.y || s.y), t.setAttribute("width", n.width || s.width), t.setAttribute("height", n.height || s.height), this.filterManager = e;
            var o = createNS("feGaussianBlur");
            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o, t.appendChild(o);
            var h = createNS("feOffset");
            h.setAttribute("dx", "25"), h.setAttribute("dy", "0"), h.setAttribute("in", i + "_drop_shadow_1"), h.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = h, t.appendChild(h);
            var l = createNS("feFlood");
            l.setAttribute("flood-color", "#00ff00"), l.setAttribute("flood-opacity", "1"), l.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = l, t.appendChild(l);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"), p.setAttribute("in2", i + "_drop_shadow_2"), p.setAttribute("operator", "in"), p.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(p);
            var f = this.createMergeNode(i, [
                i + "_drop_shadow_4",
                a
            ]);
            t.appendChild(f);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r[0] - e[0] + " 0 0 0 " + e[0] + " " + (r[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v, r = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t, e, r, i, a = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i = this.elem.maskManager.masksProperties.length, r = 0) : i = (r = this.filterManager.effectElements[0].p.v - 1) + 1, (e = createNS("g")).setAttribute("fill", "none"), e.setAttribute("stroke-linecap", "round"), e.setAttribute("stroke-dashoffset", 1); r < i; r += 1)t = createNS("path"), e.appendChild(t), this.paths.push({
                p: t,
                m: r
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var s = createNS("mask"), n = createElementID();
                s.setAttribute("id", n), s.setAttribute("mask-type", "alpha"), s.appendChild(e), this.elem.globalData.defs.appendChild(s);
                var o = createNS("g");
                for(o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); a[0];)o.appendChild(a[0]);
                this.elem.layerElement.appendChild(o), this.masker = s, e.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(a = this.elem.layerElement.children || this.elem.layerElement.childNodes; a.length;)this.elem.layerElement.removeChild(a[0]);
                this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e;
        }, SVGStrokeEffect.prototype.renderFrame = function(t) {
            var e;
            this.initialized || this.initialize();
            var r, i, a = this.paths.length;
            for(e = 0; e < a; e += 1)if (-1 !== this.paths[e].m && (r = this.elem.maskManager.viewData[this.paths[e].m], i = this.paths[e].p, (t || this.filterManager._mdf || r.prop._mdf) && i.setAttribute("d", r.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r.prop._mdf)) {
                var s;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h = i.getTotalLength();
                    s = "0 0 0 " + h * n + " ";
                    var l, p = h * (o - n), f = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, c = Math.floor(p / f);
                    for(l = 0; l < c; l += 1)s += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    s += "0 " + 10 * h + " 0 0";
                } else s = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i.setAttribute("stroke-dasharray", s);
            }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var m = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * m[0]) + "," + bmFloor(255 * m[1]) + "," + bmFloor(255 * m[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, a = i[0] + " " + r[0] + " " + e[0], s = i[1] + " " + r[1] + " " + e[1], n = i[2] + " " + r[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", a), this.feFuncG.setAttribute("tableValues", s), this.feFuncB.setAttribute("tableValues", n);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r = createNS(t);
            return r.setAttribute("type", "table"), e.appendChild(r), r;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t, e, r, i, a) {
            for(var s, n, o = 0, h = Math.min(t, e), l = Math.max(t, e), p = Array.call(null, {
                length: 256
            }), f = 0, c = a - i, m = e - t; o <= 256;)n = (s = o / 256) <= h ? m < 0 ? a : i : s >= l ? m < 0 ? i : a : i + c * Math.pow((s - t) / m, 1 / r), p[f] = n, f += 1, o += 256 / 255;
            return p.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e), this.feFuncGComposed.setAttribute("tableValues", e), this.feFuncBComposed.setAttribute("tableValues", e)), this.feFuncR && (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v), this.feFuncR.setAttribute("tableValues", e)), this.feFuncG && (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v), this.feFuncG.setAttribute("tableValues", e)), this.feFuncB && (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v), this.feFuncB.setAttribute("tableValues", e)), this.feFuncA && (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v), this.feFuncA.setAttribute("tableValues", e));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a = r * Math.cos(i), s = r * Math.sin(i);
                    this.feOffset.setAttribute("dx", a), this.feOffset.setAttribute("dy", s);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.filterElem = t, this.elem = r, r.matteElement = createNS("g"), r.matteElement.appendChild(r.layerElement), r.matteElement.appendChild(r.transformedElement), r.baseElement = r.matteElement;
        }
        function SVGGaussianBlurEffect(t, e, r, i) {
            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = e;
            var a = createNS("feGaussianBlur");
            a.setAttribute("result", i), t.appendChild(a), this.feGaussianBlur = a;
        }
        function TransformEffect() {}
        function SVGTransformEffect(t, e) {
            this.init(e);
        }
        function CVTransformEffect(t) {
            this.init(t);
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t) {
            for(var e = 0, r = _svgMatteSymbols.length; e < r;){
                if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                e += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r = t.layerElement.parentNode;
            if (r) {
                for(var i, a = r.children, s = 0, n = a.length; s < n && a[s] !== t.layerElement;)s += 1;
                s <= n - 2 && (i = a[s + 1]);
                var o = createNS("use");
                o.setAttribute("href", "#" + e), i ? r.insertBefore(o, i) : r.appendChild(o);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r = createElementID(), i = createNS("mask");
                i.setAttribute("id", e.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                var a = t.globalData.defs;
                a.appendChild(i);
                var s = createNS("symbol");
                s.setAttribute("id", r), this.replaceInParent(e, r), s.appendChild(e.layerElement), a.appendChild(s);
                var n = createNS("use");
                n.setAttribute("href", "#" + r), i.appendChild(n), e.data.hd = !1, e.show();
            }
            t.setMatte(e.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, i = e.length; r < i;)e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), r += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3 * this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = 3 == r ? 0 : e, a = 2 == r ? 0 : e;
                this.feGaussianBlur.setAttribute("stdDeviation", i + " " + a);
                var s = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", s);
            }
        }, TransformEffect.prototype.init = function(t) {
            this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix, this.opacity = -1, this._mdf = !1, this._opMdf = !1;
        }, TransformEffect.prototype.renderFrame = function(t) {
            if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
                var e = this.effectsManager.effectElements, r = e[0].p.v, i = e[1].p.v, a = 1 === e[2].p.v, s = e[3].p.v, n = a ? s : e[4].p.v, o = e[5].p.v, h = e[6].p.v, l = e[7].p.v;
                this.matrix.reset(), this.matrix.translate(-r[0], -r[1], r[2]), this.matrix.scale(.01 * n, .01 * s, 1), this.matrix.rotate(-l * degToRads), this.matrix.skewFromAxis(-o * degToRads, (h + 90) * degToRads), this.matrix.translate(i[0], i[1], 0), this._mdf = !0, this.opacity !== e[8].p.v && (this.opacity = e[8].p.v, this._opMdf = !0);
            }
        }, extendPrototype([
            TransformEffect
        ], SVGTransformEffect), extendPrototype([
            TransformEffect
        ], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
    });
}), REACT_LOTTIE_PLAYER_VERSION = "3.6.0", LOTTIE_WEB_VERSION = "^5.12.2", PlayerState, PlayerEvent;
function parseSrc(t) {
    if ("object" == typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (t) {}
    try {
        return new URL(t).toString();
    } catch (t) {}
    return t;
}
!function(t) {
    t.Loading = "loading", t.Playing = "playing", t.Paused = "paused", t.Stopped = "stopped", t.Frozen = "frozen", t.Error = "error";
}(PlayerState || (PlayerState = {})), function(t) {
    t.Load = "load", t.InstanceSaved = "instanceSaved", t.Error = "error", t.Ready = "ready", t.Play = "play", t.Pause = "pause", t.Stop = "stop", t.Freeze = "freeze", t.Loop = "loop", t.Complete = "complete", t.Frame = "frame";
}(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = {
    clearCanvas: !1,
    hideOnTransparent: !0,
    progressiveLoad: !0
}, Player = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.container = null, r.unmounted = !1, r.handleBgChange = function(t) {
            r.setState({
                background: t
            });
        }, r.triggerDownload = function(t, e) {
            var r = document.createElement("a");
            r.href = t, r.download = e, document.body.appendChild(r), r.click(), document.body.removeChild(r);
        }, r.snapshot = function(t) {
            var e;
            void 0 === t && (t = !0);
            var i = r.props.id ? r.props.id : "lottie", a = document.getElementById(i);
            if ("svg" === r.props.renderer) {
                if (a) {
                    var s = a.querySelector("svg");
                    if (s) {
                        var n = (new XMLSerializer).serializeToString(s);
                        e = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n);
                    }
                }
                t && r.triggerDownload(e, "snapshot.svg");
            } else if ("canvas" === r.props.renderer) {
                if (a) {
                    var o = a.querySelector("canvas");
                    o && (e = o.toDataURL("image/png"));
                }
                t && r.triggerDownload(e, "snapshot.png");
            }
            return e;
        }, "undefined" != typeof window && (window.lottie = lottie), r.state = {
            animationData: null,
            background: "transparent",
            containerRef: $bxRTa.createRef(),
            debug: !0,
            instance: null,
            playerState: PlayerState.Loading,
            seeker: 0
        }, r;
    }
    return __extends(e, t), e.getDerivedStateFromProps = function(t, e) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(r) {
                return t.background !== e.background ? [
                    2,
                    {
                        background: t.background
                    }
                ] : [
                    2,
                    null
                ];
            });
        });
    }, e.prototype.getVersions = function() {
        return {
            lottieWebVersion: LOTTIE_WEB_VERSION,
            lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION
        };
    }, e.prototype.componentDidMount = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.unmounted ? [
                            3,
                            2
                        ] : [
                            4,
                            this.createLottie()
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.componentWillUnmount = function() {
        this.unmounted = !0, this.state.instance && this.state.instance.destroy();
    }, e.prototype.componentDidUpdate = function(t) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.props.src === t.src ? [
                            3,
                            2
                        ] : (this.state.instance && this.state.instance.destroy(), [
                            4,
                            this.createLottie()
                        ]);
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.render = function() {
        var t = this, e = this.props, r = e.children, i = e.loop, a = e.style, s = e.onBackgroundChange, n = e.className, o = this.state, h = o.animationData, l = o.instance, p = o.playerState, f = o.seeker, c = o.debug, m = o.background;
        return $bxRTa.createElement("div", {
            className: "lf-player-container"
        }, this.state.playerState === PlayerState.Error ? $bxRTa.createElement("div", {
            className: "lf-error"
        }, $bxRTa.createElement("span", {
            "aria-label": "error-symbol",
            role: "img"
        }, "\u26A0\uFE0F")) : $bxRTa.createElement("div", {
            id: this.props.id ? this.props.id : "lottie",
            ref: function(e) {
                return t.container = e;
            },
            style: __assign({
                background: m,
                margin: "0 auto",
                outline: "none",
                overflow: "hidden"
            }, a),
            className: n
        }), $bxRTa.Children.map(r, function(e) {
            return $bxRTa.isValidElement(e) ? $bxRTa.cloneElement(e, {
                animationData: h,
                background: m,
                debug: c,
                instance: l,
                loop: i,
                pause: function() {
                    return t.pause();
                },
                play: function() {
                    return t.play();
                },
                playerState: p,
                seeker: f,
                setBackground: function(e) {
                    t.setState({
                        background: e
                    }), "function" == typeof s && s(e);
                },
                setSeeker: function(e, r) {
                    return t.setSeeker(e, r);
                },
                stop: function() {
                    return t.stop();
                },
                toggleDebug: function() {
                    return t.toggleDebug();
                },
                setLoop: function(e) {
                    return t.setLoop(e);
                },
                colorChangedEvent: function(e) {
                    t.handleBgChange(e);
                },
                snapshot: function() {
                    t.snapshot();
                }
            }) : null;
        }));
    }, e.prototype.toggleDebug = function() {
        this.setState({
            debug: !this.state.debug
        });
    }, e.prototype.createLottie = function() {
        return __awaiter(this, void 0, void 0, function() {
            var t, e, r, i, a, s, n, o, h, l, p, f, c, m, d = this;
            return __generator(this, function(u) {
                switch(u.label){
                    case 0:
                        if (t = this.props, e = t.autoplay, r = t.direction, i = t.loop, a = t.lottieRef, s = t.renderer, n = t.speed, o = t.src, h = t.background, l = t.rendererSettings, p = t.hover, f = this.state.instance, !o || !this.container) return [
                            2
                        ];
                        u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), "string" != typeof (c = parseSrc(o)) ? [
                            3,
                            4
                        ] : [
                            4,
                            fetch(c).catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 2:
                        return [
                            4,
                            u.sent().json().catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 3:
                        c = u.sent(), u.label = 4;
                    case 4:
                        return f && f.destroy(), m = lottie.loadAnimation({
                            rendererSettings: l || defaultOptions,
                            animationData: c,
                            autoplay: e || !1,
                            container: this.container,
                            loop: i || !1,
                            renderer: s
                        }), n && m.setSpeed(n), this.setState({
                            animationData: c
                        }), this.setState({
                            instance: m
                        }, function() {
                            d.triggerEvent(PlayerEvent.InstanceSaved), "function" == typeof a && a(m), e && d.play();
                        }), m.addEventListener("enterFrame", function() {
                            d.triggerEvent(PlayerEvent.Frame), d.setState({
                                seeker: Math.floor(m.currentFrame)
                            });
                        }), m.addEventListener("DOMLoaded", function() {
                            d.triggerEvent(PlayerEvent.Load);
                        }), m.addEventListener("data_ready", function() {
                            d.triggerEvent(PlayerEvent.Ready);
                        }), m.addEventListener("data_failed", function() {
                            d.setState({
                                playerState: PlayerState.Error
                            }), d.triggerEvent(PlayerEvent.Error);
                        }), m.addEventListener("loopComplete", function() {
                            d.triggerEvent(PlayerEvent.Loop);
                        }), m.addEventListener("complete", function() {
                            d.triggerEvent(PlayerEvent.Complete), d.setState({
                                playerState: PlayerState.Paused
                            }), d.props.keepLastFrame && !d.props.loop || d.setSeeker(0);
                        }), this.container && (this.container.addEventListener("mouseenter", function() {
                            p && d.state.playerState !== PlayerState.Playing && (d.props.keepLastFrame && d.stop(), d.play());
                        }), this.container.addEventListener("mouseleave", function() {
                            p && d.state.playerState === PlayerState.Playing && d.stop();
                        })), n && this.setPlayerSpeed(n), r && this.setPlayerDirection(r), h && this.setState({
                            background: h
                        }), [
                            3,
                            6
                        ];
                    case 5:
                        return u.sent(), this.setState({
                            playerState: PlayerState.Error
                        }), this.triggerEvent(PlayerEvent.Error), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.play = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Play), t.play(), this.setState({
            playerState: PlayerState.Playing
        }));
    }, e.prototype.pause = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Pause), t.pause(), this.setState({
            playerState: PlayerState.Paused
        }));
    }, e.prototype.stop = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Stop), t.stop(), this.setState({
            playerState: PlayerState.Stopped
        }));
    }, e.prototype.setPlayerSpeed = function(t) {
        var e = this.state.instance;
        e && e.setSpeed(t);
    }, e.prototype.setPlayerDirection = function(t) {
        var e = this.state.instance;
        e && e.setDirection(t);
    }, e.prototype.setSeeker = function(t, e) {
        void 0 === e && (e = !1);
        var r = this.state, i = r.instance, a = r.playerState;
        i && (e && a === PlayerState.Playing ? i.goToAndPlay(t, !0) : (i.goToAndStop(t, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({
            playerState: PlayerState.Paused
        })));
    }, e.prototype.setLoop = function(t) {
        var e = this.state.instance;
        e && (e.loop = t, this.setState({
            instance: e
        }));
    }, e.prototype.triggerEvent = function(t) {
        var e = this.props.onEvent;
        e && e(t);
    }, e.defaultProps = {
        loop: !1
    }, e;
}($bxRTa.Component);
function styleInject(t, e) {
    void 0 === e && (e = {});
    var r = e.insertAt;
    if (t && "undefined" != typeof document) {
        var i = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
        a.type = "text/css", "top" === r && i.firstChild ? i.insertBefore(a, i.firstChild) : i.appendChild(a), a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(document.createTextNode(t));
    }
}
var css_248z = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n", stylesheet = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n";
styleInject(css_248z);
var ColorPicker = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.state = {
            red: 0,
            green: 0,
            blue: 0,
            rgba: null,
            hex: "#000000",
            colorComponents: []
        }, e.handleChange = function(t, r) {
            if ("r" === t) {
                var i = "#" + (256 | r).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("g" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | r).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("b" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | r).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            }
        }, e.parseColor = function(t) {
            var r;
            if ("string" == typeof t) {
                if ("#" === t[0]) {
                    var i = 4 === t.length ? [
                        t.slice(1, 2),
                        t.slice(2, 3),
                        t.slice(3, 4)
                    ].map(function(t) {
                        return parseInt("" + t + t, 16);
                    }) : [
                        t.slice(1, 3),
                        t.slice(3, 5),
                        t.slice(5, 7)
                    ].map(function(t) {
                        return parseInt(t, 16);
                    });
                    e.setState({
                        colorComponents: i
                    });
                } else if (t.startsWith("rgb")) void 0 !== (i = null === (r = t.match(/\d+/g)) || void 0 === r ? void 0 : r.map(function(t) {
                    return parseInt(t);
                })) && e.setState({
                    colorComponents: i
                });
                e.state.colorComponents.length && (e.setState({
                    red: e.state.colorComponents[0]
                }), e.setState({
                    green: e.state.colorComponents[1]
                }), e.setState({
                    blue: e.state.colorComponents[2]
                }));
            }
        }, e;
    }
    return __extends(e, t), e.prototype.componentDidUpdate = function(t, e) {
        return this.props.colorChangedEvent && this.state.hex !== e.hex && this.props.colorChangedEvent(this.state.hex), !0;
    }, e.prototype.render = function() {
        var t = this;
        return $bxRTa.createElement("div", {
            className: "lf-color-picker"
        }, $bxRTa.createElement("div", {
            className: "lf-color-selectors"
        }, $bxRTa.createElement("div", {
            className: "lf-color-component"
        }, $bxRTa.createElement("strong", null, "Red"), $bxRTa.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        }), $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        })), $bxRTa.createElement("div", {
            className: "lf-color-component"
        }, $bxRTa.createElement("strong", null, "Green"), $bxRTa.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        }), $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        })), $bxRTa.createElement("div", {
            className: "lf-color-component"
        }, $bxRTa.createElement("strong", null, "Blue"), $bxRTa.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }), $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }))), $bxRTa.createElement("div", {
            className: "lf-color-preview"
        }, $bxRTa.createElement("div", {
            className: "lf-preview",
            style: {
                background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")"
            }
        }), $bxRTa.createElement("div", null, $bxRTa.createElement("input", {
            className: "lf-text-input",
            type: "text",
            value: this.state.hex,
            onChange: function(e) {
                t.setState({
                    hex: e.target.value
                }), t.parseColor(e.target.value);
            }
        }))));
    }, e;
}($bxRTa.Component), Popover = function(t) {
    var e = t.children, r = t.icon, i = (0, $bxRTa.useState)(null), a = i[0], s = i[1], n = (0, $bxRTa.useState)(null), o = n[0], h = n[1], l = (0, $bxRTa.useState)(null), p = l[0], f = l[1], c = (0, $bxRTa.useState)(!1), m = c[0], d = c[1];
    (0, $bxRTa.useEffect)(function() {
        if (a && o) {
            var t = a.getBoundingClientRect(), e = o.getBoundingClientRect(), r = t.left + e.width > window.innerWidth ? -1 : 0;
            f(r);
        }
    }, [
        p,
        o,
        a
    ]);
    return $bxRTa.createElement("div", {
        className: "lf-popover",
        onMouseOver: function() {
            d(!0);
        },
        onMouseLeave: function() {
            d(!1);
        },
        ref: function(t) {
            s(t);
        }
    }, $bxRTa.createElement("div", {
        className: " lf-player-btn"
    }, r), $bxRTa.createElement("div", {
        className: "lf-popover-content",
        ref: function(t) {
            h(t);
        },
        style: {
            bottom: "22px",
            right: "0px",
            zIndex: 2,
            visibility: m ? "visible" : "hidden"
        }
    }, e));
}, Seeker = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.inputRef = $bxRTa.createRef(), r.handleChange = function() {
            return function(t) {
                var e = t.target.value, i = Math.floor(e / 100 * r.props.max);
                r.props.onChange(i);
            };
        }, r.state = {
            value: 0
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this.props.value / this.props.max * 100, e = {
            backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + t + "%, rgba(15, 204, 206, 0.4)), color-stop(" + t + "%, #DAE1E7))"
        }, r = {
            position: "absolute",
            left: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        }, i = {
            position: "absolute",
            right: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        };
        return $bxRTa.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                marginRight: "5px",
                marginLeft: "5px",
                position: "relative"
            }
        }, $bxRTa.createElement("input", {
            ref: this.inputRef,
            id: "track",
            className: "lf-progress",
            name: "progress",
            "aria-label": "progress",
            type: "range",
            min: "0",
            max: "100",
            step: "0.1",
            value: t,
            onInput: this.handleChange(),
            onChange: this.handleChange(),
            style: e
        }), this.props.showLabels && $bxRTa.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $bxRTa.createElement("div", {
            style: r
        }, this.props.min), $bxRTa.createElement("div", {
            style: i
        }, this.props.max)));
    }, e;
}($bxRTa.Component), ControlButtonStyle = {
    display: "inline-flex",
    cursor: "pointer"
}, Controls = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.state = {
            activeFrame: 0,
            mouseDown: !1
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this, e = this.props, r = e.instance, i = e.playerState, a = e.seeker, s = e.setLoop, n = e.setSeeker, o = e.play, h = e.pause, l = e.stop, p = e.visible, f = e.buttons;
        if (!r) return null;
        if (!p) return null;
        var c = !f || f.includes("play"), m = !f || f.includes("stop"), d = !f || f.includes("repeat"), u = !f || f.includes("frame"), y = !f || f.includes("background"), g = !f || f.includes("snapshot"), v = {
            width: 14,
            height: 14,
            viewBox: "0 0 24 24"
        }, b = Math.round(r.currentFrame);
        return $bxRTa.createElement("div", {
            className: "lf-player-controls",
            style: {
                display: "flex",
                justifyContent: "space-between",
                height: "60px",
                alignItems: "center",
                backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff",
                paddingLeft: "10px",
                paddingRight: "10px"
            }
        }, c && $bxRTa.createElement("div", {
            role: "button",
            "aria-label": i === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play,
            tabIndex: 0,
            onClick: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            onKeyDown: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            className: "lf-player-btn",
            style: ControlButtonStyle
        }, i === PlayerState.Playing ? $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "14",
            y: ".5"
        }), $bxRTa.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "2",
            y: ".5"
        })) : $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
            d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z"
        }))), m && $bxRTa.createElement("div", {
            tabIndex: 0,
            role: "button",
            "aria-label": PlayerEvent.Stop,
            onClick: function() {
                return l && l();
            },
            onKeyDown: function() {
                return l && l();
            },
            className: i === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
            d: "M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333\n            22H3.667A1.67 1.67 0 0 1 2 20.333z"
        }))), $bxRTa.createElement(Seeker, {
            min: 0,
            step: 1,
            max: r ? r.totalFrames : 1,
            value: a || 0,
            onChange: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            onChangeEnd: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            showLabels: this.props.showLabels,
            darkTheme: this.props.darkTheme
        }), u && $bxRTa.createElement("div", {
            role: "button",
            className: "lf-player-btn-container"
        }, $bxRTa.createElement("input", {
            style: {
                outline: "none",
                border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid",
                borderRadius: "3px",
                width: "40px",
                textAlign: "center",
                backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff",
                color: this.props.darkTheme ? "#B9B9B9" : "#999",
                fontSize: "0.7rem",
                padding: "0",
                fontFamily: "inherit"
            },
            type: "text",
            value: b,
            readOnly: !0
        })), d && $bxRTa.createElement("div", {
            role: "button",
            "aria-label": PlayerEvent.Loop,
            tabIndex: 0,
            onClick: function() {
                r && s && s(!r.loop);
            },
            onKeyDown: function() {
                r && s && s(!r.loop);
            },
            className: r.loop ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
            d: "M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116\n            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0\n            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025\n            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0\n            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115\n            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }), $bxRTa.createElement("path", {
            d: "M11.1482\n            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898\n            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347\n            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014\n            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453\n            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368\n            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671\n            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442\n            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z",
            fill: "#8795A1",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }))), y && $bxRTa.createElement(Popover, {
            icon: $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
                d: "M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0\n            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1\n            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0\n            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6\n            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z"
            }))
        }, $bxRTa.createElement("div", {
            slot: "content",
            className: "lf-popover popover-background"
        }, $bxRTa.createElement(ColorPicker, {
            colorChangedEvent: this.props.colorChangedEvent
        }))), g && $bxRTa.createElement(Popover, {
            icon: $bxRTa.createElement("svg", __assign({}, v), $bxRTa.createElement("path", {
                clipRule: "evenodd",
                d: "M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983\n              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0\n              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z",
                fillRule: "evenodd"
            }), $bxRTa.createElement("path", {
                d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z"
            }), $bxRTa.createElement("circle", {
                cx: "7.444",
                cy: "6.513",
                r: "2.032"
            }), $bxRTa.createElement("path", {
                d: "M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0\n              01-.803.804H9.562a1.061 1.061 0 100 2.123z",
                stroke: "#8795a1",
                strokeWidth: ".215"
            }))
        }, $bxRTa.createElement("div", {
            slot: "content",
            className: "lf-popover lf-popover-snapshot",
            onWheel: function(t) {
                n && n(b + (t.deltaY > 0 ? -1 : 1), !1);
            }
        }, $bxRTa.createElement("h5", null, "Frame ", b), $bxRTa.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download SVG"), $bxRTa.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download PNG"), $bxRTa.createElement("i", {
            className: "lf-note"
        }, "Scroll with mousewheel to find exact frame"))));
    }, e;
}($bxRTa.Component);

});

parcelRegister("hVO5T", function(module, exports) {
module.exports = JSON.parse('{"v":"5.7.4","fr":29.9700012207031,"ip":0,"op":45.0000018328876,"w":256,"h":256,"nm":"vibe","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Calque de forme 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,31.25],[-49.5,103],[-92.5,81],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,18],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.247,87.636],[-49.5,62.5],[-92.5,8.144],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,10.5],[100.25,84.403],[54.75,36.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,51.758],[-49.5,103],[-92.5,48.989],[-129,-22],[-129.5,167.5],[128.75,171.75],[129.75,19.75],[100.25,93.847],[54.75,-2]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.498,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,-34.148],[-49.5,39.75],[-92.5,90.277],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,33.052],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,23.747],[-49.5,-21.5],[-92.5,115.754],[-129,62.5],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,90.836],[54.75,110]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Calque de forme 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,48.5],[-49.5,-11.5],[-92.5,44],[-129,116],[-129.5,167.5],[128.75,171.75],[129.75,125.5],[100.25,62.5],[54.749,95.5]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,27],[-49.502,94.547],[-92.5,55],[-129,-19.068],[-129.5,167.5],[128.75,171.75],[129.75,125],[100.25,110.5],[54.749,-63.236]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,70],[-49.501,1.079],[-92.5,120.5],[-129,57.802],[-129.5,167.5],[128.75,171.75],[129.75,-0.19],[100.25,65.5],[54.749,45.01]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,22.75],[-49.501,80.531],[-92.5,33],[-129,114.922],[-129.5,167.5],[128.75,171.75],[129.75,-17.129],[100.25,106.25],[54.747,69.109]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.501,68.115],[-92.5,106.017],[-129,129.414],[-129.5,167.5],[128.75,171.75],[129.75,63.44],[100.25,-1.2],[54.748,66.851]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0}],"markers":[]}');

});

parcelRegister("6Iy5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $28aa2270500a74e1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9TTQJ = parcelRequire("9TTQJ");

var $9JLpC = parcelRequire("9JLpC");
const $28aa2270500a74e1$var$Modal = ({ isOpened: isOpened, onClose: onClose, children: children })=>{
    const modalRef = (0, $bxRTa.useRef)(null);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const currentWidth = (0, $9JLpC.useViewStore)((state)=>state.currentWidth);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    (0, $bxRTa.useEffect)(()=>{
        if (isOpened) modalRef.current?.showModal();
        else modalRef.current?.close();
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("dialog", {
        ref: modalRef,
        className: "rf-absolute rf-m-0 rf-text-cardFrameText rf-bg-[#121212F2] rf-border rf-border-[#707070] rf-rounded-lg",
        style: {
            transform: isWidget ? `translate(calc(${window.innerWidth / 2}px - 50%), calc(${window.innerHeight / 2}px - 50%)` : `translate(calc(${currentWidth / 2}px - 50%), calc(${currentHeight / 2}px - 50%)`
        },
        onCancel: onClose,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            className: "rf-relative rf-flex rf-flex-col",
            onClick: (event)=>event?.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                    onClick: onClose
                }),
                children
            ]
        })
    });
};
var $28aa2270500a74e1$export$2e2bcd8739ae039 = $28aa2270500a74e1$var$Modal;

});

parcelRegister("4ZEXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $92319df216410cd8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $92319df216410cd8$var$MicrophoneLoader = ({ color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-h-full rf-bg-transparent",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: `rf-w-full rf-h-full rf-relative rf-rounded-max rf-mx-0 rf-my-auto ${color === 'primary' ? 'rf-loader-microphone-primary' : color === 'secondary' ? 'rf-loader-microphone-secondary' : 'rf-loader-microphone'}`,
            style: {
                borderTopColor: color || '#FFF'
            }
        })
    });
};
var $92319df216410cd8$export$2e2bcd8739ae039 = $92319df216410cd8$var$MicrophoneLoader;

});

parcelRegister("d7O2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $542b0f253e181af0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("kMAJU");
var $f3SD2 = parcelRequire("f3SD2");
const $542b0f253e181af0$var$MicrophoneModalWaiting = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-16 rf-py-16 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f3SD2.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-size-auto rf-text-center",
                children: translation.microphone.allow
            })
        ]
    });
};
var $542b0f253e181af0$export$2e2bcd8739ae039 = $542b0f253e181af0$var$MicrophoneModalWaiting;

});

parcelRegister("gpOhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c609267b6627dcdb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $clSD3 = parcelRequire("clSD3");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $kdMEA = parcelRequire("kdMEA");
parcelRequire("kMAJU");
var $iNZRc = parcelRequire("iNZRc");

var $8e5cw = parcelRequire("8e5cw");

var $9TTQJ = parcelRequire("9TTQJ");
parcelRequire("d72S7");
var $cUlNP = parcelRequire("cUlNP");
const $c609267b6627dcdb$var$springDuration = 500;
const $c609267b6627dcdb$var$MicrophoneModalRefused = ()=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const [redirectionUrl, setRedirectionUrl] = (0, $bxRTa.useState)();
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        let tempUrl = `${(0, $kdMEA.docsRetorik)}${locale.split('-')[0] === 'fr' ? '' : '/en'}/docs/depannage-autorisations-acces-micro/`;
        switch(0, $clSD3.browserName){
            case (0, $clSD3.BrowserTypes).Chrome:
            case (0, $clSD3.BrowserTypes).Chromium:
                tempUrl += '#chrome-';
                break;
            case (0, $clSD3.BrowserTypes).Edge:
            case (0, $clSD3.BrowserTypes).EdgeChromium:
                tempUrl += '#edge-';
                break;
            case (0, $clSD3.BrowserTypes).Firefox:
                tempUrl += '#firefox-';
                break;
            case (0, $clSD3.BrowserTypes).Safari:
            case (0, $clSD3.BrowserTypes).MobileSafari:
                tempUrl += '#safari-';
                break;
            case (0, $clSD3.BrowserTypes).Opera:
                tempUrl += '#opera-';
                break;
            case (0, $clSD3.BrowserTypes).SamsungBrowser:
                setRedirectionUrl(`${tempUrl}#samsung-sur-mobile`);
                return;
            case (0, $clSD3.BrowserTypes).Ie:
            case (0, $clSD3.BrowserTypes).InternetExplorer:
            default:
                break;
        }
        switch(0, $clSD3.osName){
            case (0, $clSD3.OsTypes).Windows:
            case (0, $clSD3.OsTypes).MAC_OS:
                tempUrl += 'sur-ordinateur-de-bureau';
                break;
            default:
                tempUrl += 'sur-mobile-ou-tablette';
        }
        setRedirectionUrl(tempUrl);
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $c609267b6627dcdb$var$springDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $c609267b6627dcdb$var$springDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $c609267b6627dcdb$var$springDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleRedirect = ()=>{
        if (redirectionUrl) isUsedOnBorne ? setQrCodeDataAsync(redirectionUrl) : window.open(redirectionUrl, '_blank', 'noopener noreferrer');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-8 rf-py-8 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-size-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iNZRc.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-font-light",
                children: translation.microphone.rejected
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-center",
                children: translation.microphone.instructions
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button",
                onClick: handleRedirect,
                children: translation.common.knowmore
            }),
            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: 'rgba(18,18,18,0.7)',
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-px-8 rf-flex rf-flex-row rf-items-start rf-gap-1 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cUlNP.default), {
                                color: "#FFF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-fit",
                                children: translation.link.scanQRTile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $c609267b6627dcdb$export$2e2bcd8739ae039 = $c609267b6627dcdb$var$MicrophoneModalRefused;

});
parcelRegister("clSD3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $8fe1d25903380419$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $bxRTa = parcelRequire("bxRTa");
var $8fe1d25903380419$var$React__default = $8fe1d25903380419$var$_interopDefault($bxRTa);

var $2roA1 = parcelRequire("2roA1");
var $8fe1d25903380419$var$ClientUAInstance = new $2roA1();
var $8fe1d25903380419$var$browser = $8fe1d25903380419$var$ClientUAInstance.getBrowser();
var $8fe1d25903380419$var$cpu = $8fe1d25903380419$var$ClientUAInstance.getCPU();
var $8fe1d25903380419$var$device = $8fe1d25903380419$var$ClientUAInstance.getDevice();
var $8fe1d25903380419$var$engine = $8fe1d25903380419$var$ClientUAInstance.getEngine();
var $8fe1d25903380419$var$os = $8fe1d25903380419$var$ClientUAInstance.getOS();
var $8fe1d25903380419$var$ua = $8fe1d25903380419$var$ClientUAInstance.getUA();
var $8fe1d25903380419$var$setUa = function setUa(userAgentString) {
    return $8fe1d25903380419$var$ClientUAInstance.setUA(userAgentString);
};
var $8fe1d25903380419$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $2roA1(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $8fe1d25903380419$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $8fe1d25903380419$var$ClientUAInstance,
    browser: $8fe1d25903380419$var$browser,
    cpu: $8fe1d25903380419$var$cpu,
    device: $8fe1d25903380419$var$device,
    engine: $8fe1d25903380419$var$engine,
    os: $8fe1d25903380419$var$os,
    ua: $8fe1d25903380419$var$ua,
    setUa: $8fe1d25903380419$var$setUa,
    parseUserAgent: $8fe1d25903380419$var$parseUserAgent
});
function $8fe1d25903380419$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8fe1d25903380419$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8fe1d25903380419$var$ownKeys(Object(source), true).forEach(function(key) {
            $8fe1d25903380419$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8fe1d25903380419$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8fe1d25903380419$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8fe1d25903380419$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $8fe1d25903380419$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8fe1d25903380419$var$_typeof(obj);
}
function $8fe1d25903380419$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8fe1d25903380419$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8fe1d25903380419$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8fe1d25903380419$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8fe1d25903380419$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8fe1d25903380419$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8fe1d25903380419$var$_extends() {
    $8fe1d25903380419$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8fe1d25903380419$var$_extends.apply(this, arguments);
}
function $8fe1d25903380419$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8fe1d25903380419$var$_setPrototypeOf(subClass, superClass);
}
function $8fe1d25903380419$var$_getPrototypeOf(o) {
    $8fe1d25903380419$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8fe1d25903380419$var$_getPrototypeOf(o);
}
function $8fe1d25903380419$var$_setPrototypeOf(o, p) {
    $8fe1d25903380419$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8fe1d25903380419$var$_setPrototypeOf(o, p);
}
function $8fe1d25903380419$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8fe1d25903380419$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8fe1d25903380419$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8fe1d25903380419$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8fe1d25903380419$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8fe1d25903380419$var$_assertThisInitialized(self);
}
function $8fe1d25903380419$var$_slicedToArray(arr, i) {
    return $8fe1d25903380419$var$_arrayWithHoles(arr) || $8fe1d25903380419$var$_iterableToArrayLimit(arr, i) || $8fe1d25903380419$var$_unsupportedIterableToArray(arr, i) || $8fe1d25903380419$var$_nonIterableRest();
}
function $8fe1d25903380419$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8fe1d25903380419$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8fe1d25903380419$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fe1d25903380419$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fe1d25903380419$var$_arrayLikeToArray(o, minLen);
}
function $8fe1d25903380419$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fe1d25903380419$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $8fe1d25903380419$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $8fe1d25903380419$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $8fe1d25903380419$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $8fe1d25903380419$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $8fe1d25903380419$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $8fe1d25903380419$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $8fe1d25903380419$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $8fe1d25903380419$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $8fe1d25903380419$var$InitialDeviceTypes;
    }
};
var $8fe1d25903380419$var$setUserAgent = function setUserAgent(userAgent) {
    return $8fe1d25903380419$var$setUa(userAgent);
};
var $8fe1d25903380419$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $8fe1d25903380419$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $8fe1d25903380419$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $8fe1d25903380419$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $8fe1d25903380419$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $8fe1d25903380419$var$setDefaults(browser.major),
        browserFullVersion: $8fe1d25903380419$var$setDefaults(browser.version),
        browserName: $8fe1d25903380419$var$setDefaults(browser.name),
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $8fe1d25903380419$var$_objectSpread2({}, type, {
        vendor: $8fe1d25903380419$var$setDefaults(device.vendor),
        model: $8fe1d25903380419$var$setDefaults(device.model),
        os: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        ua: $8fe1d25903380419$var$setDefaults(ua)
    });
};
var $8fe1d25903380419$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
var $8fe1d25903380419$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $8fe1d25903380419$var$setDefaults(device.vendor),
        model: $8fe1d25903380419$var$setDefaults(device.model),
        engineName: $8fe1d25903380419$var$setDefaults(engine.name),
        engineVersion: $8fe1d25903380419$var$setDefaults(engine.version),
        osName: $8fe1d25903380419$var$setDefaults(os.name),
        osVersion: $8fe1d25903380419$var$setDefaults(os.version),
        userAgent: $8fe1d25903380419$var$setDefaults(ua)
    };
};
function $8fe1d25903380419$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $8fe1d25903380419$var$parseUserAgent(userAgent) : $8fe1d25903380419$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $8fe1d25903380419$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $8fe1d25903380419$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $8fe1d25903380419$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $8fe1d25903380419$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $8fe1d25903380419$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $8fe1d25903380419$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $8fe1d25903380419$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $8fe1d25903380419$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $8fe1d25903380419$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Mobile;
};
var $8fe1d25903380419$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Tablet;
};
var $8fe1d25903380419$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Mobile || type === $8fe1d25903380419$var$DeviceTypes.Tablet;
};
var $8fe1d25903380419$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $8fe1d25903380419$var$DeviceTypes.SmartTv;
};
var $8fe1d25903380419$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Browser;
};
var $8fe1d25903380419$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Wearable;
};
var $8fe1d25903380419$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Console;
};
var $8fe1d25903380419$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $8fe1d25903380419$var$DeviceTypes.Embedded;
};
var $8fe1d25903380419$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $8fe1d25903380419$var$setDefaults(vendor);
};
var $8fe1d25903380419$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $8fe1d25903380419$var$setDefaults(model);
};
var $8fe1d25903380419$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $8fe1d25903380419$var$setDefaults(type, 'browser');
}; // os types
var $8fe1d25903380419$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $8fe1d25903380419$var$OsTypes.Android;
};
var $8fe1d25903380419$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $8fe1d25903380419$var$OsTypes.Windows;
};
var $8fe1d25903380419$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $8fe1d25903380419$var$OsTypes.MAC_OS;
};
var $8fe1d25903380419$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $8fe1d25903380419$var$OsTypes.WindowsPhone;
};
var $8fe1d25903380419$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $8fe1d25903380419$var$OsTypes.IOS;
};
var $8fe1d25903380419$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $8fe1d25903380419$var$setDefaults(version);
};
var $8fe1d25903380419$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $8fe1d25903380419$var$setDefaults(name);
}; // browser types
var $8fe1d25903380419$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Chrome;
};
var $8fe1d25903380419$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Firefox;
};
var $8fe1d25903380419$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Chromium;
};
var $8fe1d25903380419$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Edge;
};
var $8fe1d25903380419$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Yandex;
};
var $8fe1d25903380419$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Safari || name === $8fe1d25903380419$var$BrowserTypes.MobileSafari;
};
var $8fe1d25903380419$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $8fe1d25903380419$var$BrowserTypes.MobileSafari;
};
var $8fe1d25903380419$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $8fe1d25903380419$var$BrowserTypes.Opera;
};
var $8fe1d25903380419$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $8fe1d25903380419$var$BrowserTypes.InternetExplorer || name === $8fe1d25903380419$var$BrowserTypes.Ie;
};
var $8fe1d25903380419$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $8fe1d25903380419$var$BrowserTypes.MIUI;
};
var $8fe1d25903380419$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $8fe1d25903380419$var$BrowserTypes.SamsungBrowser;
};
var $8fe1d25903380419$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $8fe1d25903380419$var$setDefaults(version);
};
var $8fe1d25903380419$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $8fe1d25903380419$var$setDefaults(major);
};
var $8fe1d25903380419$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $8fe1d25903380419$var$setDefaults(name);
}; // engine types
var $8fe1d25903380419$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $8fe1d25903380419$var$setDefaults(name);
};
var $8fe1d25903380419$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $8fe1d25903380419$var$setDefaults(version);
};
var $8fe1d25903380419$var$isElectronType = function isElectronType() {
    var nav = $8fe1d25903380419$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $8fe1d25903380419$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $8fe1d25903380419$var$getIOS13 = function getIOS13() {
    var nav = $8fe1d25903380419$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $8fe1d25903380419$var$getIPad13 = function getIPad13() {
    return $8fe1d25903380419$var$isIOS13Check('iPad');
};
var $8fe1d25903380419$var$getIphone13 = function getIphone13() {
    return $8fe1d25903380419$var$isIOS13Check('iPhone');
};
var $8fe1d25903380419$var$getIPod13 = function getIPod13() {
    return $8fe1d25903380419$var$isIOS13Check('iPod');
};
var $8fe1d25903380419$var$getUseragent = function getUseragent(userAg) {
    return $8fe1d25903380419$var$setDefaults(userAg);
};
function $8fe1d25903380419$var$buildSelectorsObject(options) {
    var _ref = options ? options : $8fe1d25903380419$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $8fe1d25903380419$var$isSmartTVType(device),
        isConsole: $8fe1d25903380419$var$isConsoleType(device),
        isWearable: $8fe1d25903380419$var$isWearableType(device),
        isEmbedded: $8fe1d25903380419$var$isEmbeddedType(device),
        isMobileSafari: $8fe1d25903380419$var$isMobileSafariType(browser) || $8fe1d25903380419$var$getIPad13(),
        isChromium: $8fe1d25903380419$var$isChromiumType(browser),
        isMobile: $8fe1d25903380419$var$isMobileAndTabletType(device) || $8fe1d25903380419$var$getIPad13(),
        isMobileOnly: $8fe1d25903380419$var$isMobileType(device),
        isTablet: $8fe1d25903380419$var$isTabletType(device) || $8fe1d25903380419$var$getIPad13(),
        isBrowser: $8fe1d25903380419$var$isBrowserType(device),
        isDesktop: $8fe1d25903380419$var$isBrowserType(device),
        isAndroid: $8fe1d25903380419$var$isAndroidType(os),
        isWinPhone: $8fe1d25903380419$var$isWinPhoneType(os),
        isIOS: $8fe1d25903380419$var$isIOSType(os) || $8fe1d25903380419$var$getIPad13(),
        isChrome: $8fe1d25903380419$var$isChromeType(browser),
        isFirefox: $8fe1d25903380419$var$isFirefoxType(browser),
        isSafari: $8fe1d25903380419$var$isSafariType(browser),
        isOpera: $8fe1d25903380419$var$isOperaType(browser),
        isIE: $8fe1d25903380419$var$isIEType(browser),
        osVersion: $8fe1d25903380419$var$getOsVersion(os),
        osName: $8fe1d25903380419$var$getOsName(os),
        fullBrowserVersion: $8fe1d25903380419$var$getBrowserFullVersion(browser),
        browserVersion: $8fe1d25903380419$var$getBrowserVersion(browser),
        browserName: $8fe1d25903380419$var$getBrowserName(browser),
        mobileVendor: $8fe1d25903380419$var$getMobileVendor(device),
        mobileModel: $8fe1d25903380419$var$getMobileModel(device),
        engineName: $8fe1d25903380419$var$getEngineName(engine),
        engineVersion: $8fe1d25903380419$var$getEngineVersion(engine),
        getUA: $8fe1d25903380419$var$getUseragent(ua),
        isEdge: $8fe1d25903380419$var$isEdgeType(browser) || $8fe1d25903380419$var$isEdgeChromiumType(ua),
        isYandex: $8fe1d25903380419$var$isYandexType(browser),
        deviceType: $8fe1d25903380419$var$getDeviceType(device),
        isIOS13: $8fe1d25903380419$var$getIOS13(),
        isIPad13: $8fe1d25903380419$var$getIPad13(),
        isIPhone13: $8fe1d25903380419$var$getIphone13(),
        isIPod13: $8fe1d25903380419$var$getIPod13(),
        isElectron: $8fe1d25903380419$var$isElectronType(),
        isEdgeChromium: $8fe1d25903380419$var$isEdgeChromiumType(ua),
        isLegacyEdge: $8fe1d25903380419$var$isEdgeType(browser) && !$8fe1d25903380419$var$isEdgeChromiumType(ua),
        isWindows: $8fe1d25903380419$var$isWindowsType(os),
        isMacOs: $8fe1d25903380419$var$isMacOsType(os),
        isMIUI: $8fe1d25903380419$var$isMIUIType(browser),
        isSamsungBrowser: $8fe1d25903380419$var$isSamsungBrowserType(browser)
    };
}
var $8fe1d25903380419$var$isSmartTV = $8fe1d25903380419$var$isSmartTVType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isConsole = $8fe1d25903380419$var$isConsoleType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isWearable = $8fe1d25903380419$var$isWearableType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isEmbedded = $8fe1d25903380419$var$isEmbeddedType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isMobileSafari = $8fe1d25903380419$var$isMobileSafariType($8fe1d25903380419$var$browser) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isChromium = $8fe1d25903380419$var$isChromiumType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isMobile = $8fe1d25903380419$var$isMobileAndTabletType($8fe1d25903380419$var$device) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isMobileOnly = $8fe1d25903380419$var$isMobileType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isTablet = $8fe1d25903380419$var$isTabletType($8fe1d25903380419$var$device) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isBrowser = $8fe1d25903380419$var$isBrowserType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isDesktop = $8fe1d25903380419$var$isBrowserType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isAndroid = $8fe1d25903380419$var$isAndroidType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isWinPhone = $8fe1d25903380419$var$isWinPhoneType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isIOS = $8fe1d25903380419$var$isIOSType($8fe1d25903380419$var$os) || $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isChrome = $8fe1d25903380419$var$isChromeType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isFirefox = $8fe1d25903380419$var$isFirefoxType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isSafari = $8fe1d25903380419$var$isSafariType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isOpera = $8fe1d25903380419$var$isOperaType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isIE = $8fe1d25903380419$var$isIEType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$osVersion = $8fe1d25903380419$var$getOsVersion($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$osName = $8fe1d25903380419$var$getOsName($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$fullBrowserVersion = $8fe1d25903380419$var$getBrowserFullVersion($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$browserVersion = $8fe1d25903380419$var$getBrowserVersion($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$browserName = $8fe1d25903380419$var$getBrowserName($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$mobileVendor = $8fe1d25903380419$var$getMobileVendor($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$mobileModel = $8fe1d25903380419$var$getMobileModel($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$engineName = $8fe1d25903380419$var$getEngineName($8fe1d25903380419$var$engine);
var $8fe1d25903380419$var$engineVersion = $8fe1d25903380419$var$getEngineVersion($8fe1d25903380419$var$engine);
var $8fe1d25903380419$var$getUA = $8fe1d25903380419$var$getUseragent($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isEdge = $8fe1d25903380419$var$isEdgeType($8fe1d25903380419$var$browser) || $8fe1d25903380419$var$isEdgeChromiumType($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isYandex = $8fe1d25903380419$var$isYandexType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$deviceType = $8fe1d25903380419$var$getDeviceType($8fe1d25903380419$var$device);
var $8fe1d25903380419$var$isIOS13 = $8fe1d25903380419$var$getIOS13();
var $8fe1d25903380419$var$isIPad13 = $8fe1d25903380419$var$getIPad13();
var $8fe1d25903380419$var$isIPhone13 = $8fe1d25903380419$var$getIphone13();
var $8fe1d25903380419$var$isIPod13 = $8fe1d25903380419$var$getIPod13();
var $8fe1d25903380419$var$isElectron = $8fe1d25903380419$var$isElectronType();
var $8fe1d25903380419$var$isEdgeChromium = $8fe1d25903380419$var$isEdgeChromiumType($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isLegacyEdge = $8fe1d25903380419$var$isEdgeType($8fe1d25903380419$var$browser) && !$8fe1d25903380419$var$isEdgeChromiumType($8fe1d25903380419$var$ua);
var $8fe1d25903380419$var$isWindows = $8fe1d25903380419$var$isWindowsType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isMacOs = $8fe1d25903380419$var$isMacOsType($8fe1d25903380419$var$os);
var $8fe1d25903380419$var$isMIUI = $8fe1d25903380419$var$isMIUIType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$isSamsungBrowser = $8fe1d25903380419$var$isSamsungBrowserType($8fe1d25903380419$var$browser);
var $8fe1d25903380419$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $8fe1d25903380419$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $8fe1d25903380419$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $8fe1d25903380419$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isAndroid ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isBrowser ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isIE ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isIOS ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isMobile ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isTablet ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isWinPhone ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $8fe1d25903380419$var$isMobileOnly ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isSmartTV ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isConsole ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $8fe1d25903380419$var$isWearable ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
var $8fe1d25903380419$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $8fe1d25903380419$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $8fe1d25903380419$var$React__default.createElement($bxRTa.Fragment, null, children) : $8fe1d25903380419$var$React__default.createElement("div", props, children) : null;
};
function $8fe1d25903380419$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $8fe1d25903380419$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $8fe1d25903380419$var$_classCallCheck(this, _class);
            _this = $8fe1d25903380419$var$_possibleConstructorReturn(this, $8fe1d25903380419$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($8fe1d25903380419$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($8fe1d25903380419$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($8fe1d25903380419$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $8fe1d25903380419$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $8fe1d25903380419$var$_typeof(window)) !== undefined && $8fe1d25903380419$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $8fe1d25903380419$var$React__default.createElement(WrappedComponent, $8fe1d25903380419$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($8fe1d25903380419$var$React__default.Component);
}
function $8fe1d25903380419$var$useMobileOrientation() {
    var _useState = $bxRTa.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $8fe1d25903380419$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $bxRTa.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $bxRTa.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $8fe1d25903380419$var$_typeof(window)) !== undefined && $8fe1d25903380419$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $8fe1d25903380419$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $8fe1d25903380419$var$parseUserAgent(hookUserAgent);
}
function $8fe1d25903380419$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $8fe1d25903380419$var$useDeviceData(hookUserAgent);
    var selectors = $8fe1d25903380419$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
module.exports.AndroidView = $8fe1d25903380419$var$AndroidView;
module.exports.BrowserTypes = $8fe1d25903380419$var$BrowserTypes;
module.exports.BrowserView = $8fe1d25903380419$var$BrowserView;
module.exports.ConsoleView = $8fe1d25903380419$var$ConsoleView;
module.exports.CustomView = $8fe1d25903380419$var$CustomView;
module.exports.IEView = $8fe1d25903380419$var$IEView;
module.exports.IOSView = $8fe1d25903380419$var$IOSView;
module.exports.MobileOnlyView = $8fe1d25903380419$var$MobileOnlyView;
module.exports.MobileView = $8fe1d25903380419$var$MobileView;
module.exports.OsTypes = $8fe1d25903380419$var$OsTypes;
module.exports.SmartTVView = $8fe1d25903380419$var$SmartTVView;
module.exports.TabletView = $8fe1d25903380419$var$TabletView;
module.exports.WearableView = $8fe1d25903380419$var$WearableView;
module.exports.WinPhoneView = $8fe1d25903380419$var$WinPhoneView;
module.exports.browserName = $8fe1d25903380419$var$browserName;
module.exports.browserVersion = $8fe1d25903380419$var$browserVersion;
module.exports.deviceDetect = $8fe1d25903380419$var$deviceDetect;
module.exports.deviceType = $8fe1d25903380419$var$deviceType;
module.exports.engineName = $8fe1d25903380419$var$engineName;
module.exports.engineVersion = $8fe1d25903380419$var$engineVersion;
module.exports.fullBrowserVersion = $8fe1d25903380419$var$fullBrowserVersion;
module.exports.getSelectorsByUserAgent = $8fe1d25903380419$var$getSelectorsByUserAgent;
module.exports.getUA = $8fe1d25903380419$var$getUA;
module.exports.isAndroid = $8fe1d25903380419$var$isAndroid;
module.exports.isBrowser = $8fe1d25903380419$var$isBrowser;
module.exports.isChrome = $8fe1d25903380419$var$isChrome;
module.exports.isChromium = $8fe1d25903380419$var$isChromium;
module.exports.isConsole = $8fe1d25903380419$var$isConsole;
module.exports.isDesktop = $8fe1d25903380419$var$isDesktop;
module.exports.isEdge = $8fe1d25903380419$var$isEdge;
module.exports.isEdgeChromium = $8fe1d25903380419$var$isEdgeChromium;
module.exports.isElectron = $8fe1d25903380419$var$isElectron;
module.exports.isEmbedded = $8fe1d25903380419$var$isEmbedded;
module.exports.isFirefox = $8fe1d25903380419$var$isFirefox;
module.exports.isIE = $8fe1d25903380419$var$isIE;
module.exports.isIOS = $8fe1d25903380419$var$isIOS;
module.exports.isIOS13 = $8fe1d25903380419$var$isIOS13;
module.exports.isIPad13 = $8fe1d25903380419$var$isIPad13;
module.exports.isIPhone13 = $8fe1d25903380419$var$isIPhone13;
module.exports.isIPod13 = $8fe1d25903380419$var$isIPod13;
module.exports.isLegacyEdge = $8fe1d25903380419$var$isLegacyEdge;
module.exports.isMIUI = $8fe1d25903380419$var$isMIUI;
module.exports.isMacOs = $8fe1d25903380419$var$isMacOs;
module.exports.isMobile = $8fe1d25903380419$var$isMobile;
module.exports.isMobileOnly = $8fe1d25903380419$var$isMobileOnly;
module.exports.isMobileSafari = $8fe1d25903380419$var$isMobileSafari;
module.exports.isOpera = $8fe1d25903380419$var$isOpera;
module.exports.isSafari = $8fe1d25903380419$var$isSafari;
module.exports.isSamsungBrowser = $8fe1d25903380419$var$isSamsungBrowser;
module.exports.isSmartTV = $8fe1d25903380419$var$isSmartTV;
module.exports.isTablet = $8fe1d25903380419$var$isTablet;
module.exports.isWearable = $8fe1d25903380419$var$isWearable;
module.exports.isWinPhone = $8fe1d25903380419$var$isWinPhone;
module.exports.isWindows = $8fe1d25903380419$var$isWindows;
module.exports.isYandex = $8fe1d25903380419$var$isYandex;
module.exports.mobileModel = $8fe1d25903380419$var$mobileModel;
module.exports.mobileVendor = $8fe1d25903380419$var$mobileVendor;
module.exports.osName = $8fe1d25903380419$var$osName;
module.exports.osVersion = $8fe1d25903380419$var$osVersion;
module.exports.parseUserAgent = $8fe1d25903380419$var$parseUserAgent;
module.exports.setUserAgent = $8fe1d25903380419$var$setUserAgent;
module.exports.useDeviceData = $8fe1d25903380419$var$useDeviceData;
module.exports.useDeviceSelectors = $8fe1d25903380419$var$useDeviceSelectors;
module.exports.useMobileOrientation = $8fe1d25903380419$var$useMobileOrientation;
module.exports.withOrientationChange = $8fe1d25903380419$var$withOrientationChange;

});



parcelRegister("91jIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2625bdeb54ab2b5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("9cEaH");
var $CgDXB = parcelRequire("CgDXB");
var $3o2AQ = parcelRequire("3o2AQ");
var $2aOO4 = parcelRequire("2aOO4");
parcelRequire("l9TTE");
var $66rUF = parcelRequire("66rUF");

var $f51Nf = parcelRequire("f51Nf");
const $d2625bdeb54ab2b5$var$Parameters = ({ handleBack: handleBack })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const disableHistory = (0, $7SHCs.useRetorikStore)((state)=>state.disableHistory);
    const muted = (0, $giKuE.useSpeechStore)((state)=>state.muted);
    const disableSound = (0, $giKuE.useSpeechStore)((state)=>state.disableSound);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const setMuted = (0, $giKuE.useSpeechStore)((state)=>state.actions.setMuted);
    const setDisplaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setDisplaySubtitles);
    const handleSoundChange = (val)=>{
        setMuted(!val);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !disableSound && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.sound,
                handleChange: handleSoundChange,
                defaultChecked: !muted
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder"
            }),
            mode !== (0, $2rYkD.Mode).text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.subtitle,
                handleChange: setDisplaySubtitles,
                defaultChecked: displaySubtitles
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3o2AQ.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2aOO4.default), {
                        handleBack: handleBack
                    }),
                    !disableHistory && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $CgDXB.default), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f51Nf.default), {
                        handleClick: handleBack
                    })
                ]
            })
        ]
    });
};
var $d2625bdeb54ab2b5$export$2e2bcd8739ae039 = $d2625bdeb54ab2b5$var$Parameters;

});

parcelRegister("2aOO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $abec42842328198d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $dLhbi = parcelRequire("dLhbi");
const $abec42842328198d$var$TutorialButton = ({ handleBack: handleBack })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const handleClick = ()=>{
        handleBack && handleBack();
        console.log('Launch tutorial');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dLhbi.default), {
        title: translation.common.tutorial,
        icon: "tutorial",
        onClick: handleClick
    });
};
var $abec42842328198d$export$2e2bcd8739ae039 = $abec42842328198d$var$TutorialButton;

});


parcelRegister("k4qlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $45faa0a4bd982593$export$2e2bcd8739ae039);
// Check if we should let the event propagate. For example leaflet events should pass to allow map panning
const $45faa0a4bd982593$var$checkShouldPropagate = (e)=>{
    if (e.target) try {
        const className = e.target.className;
        return className && typeof className === 'string' ? className.includes('leaflet') : false;
    } catch  {
        return false;
    }
    else return false;
};
const $45faa0a4bd982593$var$handleStop = (e)=>{
    !$45faa0a4bd982593$var$checkShouldPropagate(e) && e.cancelable && e.preventDefault();
};
const $45faa0a4bd982593$var$handleRefStop = (e, ref, reversed)=>{
    if (!$45faa0a4bd982593$var$checkShouldPropagate(e) && e.cancelable && ref.current) {
        const scrollHeight = ref.current.scrollHeight;
        const scrollTop = ref.current.scrollTop;
        const clientHeight = ref.current.clientHeight;
        // If no overflow, prevent event default
        if (scrollHeight === clientHeight) e.preventDefault();
        else if (e.type === 'wheel') {
            if (reversed) scrollTop >= 0 ? e.deltaY > 0 && e.preventDefault() : -scrollTop + clientHeight >= scrollHeight - 5 && e.deltaY < 0 && e.preventDefault();
            else scrollTop === 0 ? e.deltaY < 0 && e.preventDefault() : scrollTop + clientHeight >= scrollHeight - 5 && e.deltaY > 0 && e.preventDefault();
        } else if (e.type === 'touchmove') {
            if (e.touches.length > 1) e.preventDefault();
            else {
                const positionInLocalStorage = localStorage.getItem('Retorik.Framework.TouchY');
                const origin = positionInLocalStorage ? parseInt(positionInLocalStorage) : null;
                if (origin && !isNaN(origin)) {
                    const currentY = e.touches.length > 0 ? e.touches[0].screenY : null;
                    if (currentY || currentY === 0) {
                        const deltaY = origin - currentY;
                        if (reversed) scrollTop >= 0 ? deltaY > 0 && e.preventDefault() : -scrollTop + clientHeight >= scrollHeight - 5 && deltaY < 0 && e.preventDefault();
                        else scrollTop === 0 ? deltaY < 0 && e.preventDefault() : scrollTop + clientHeight >= scrollHeight - 5 && deltaY > 0 && e.preventDefault();
                    } else e.preventDefault();
                } else e.preventDefault();
            }
        }
        e.stopImmediatePropagation();
    }
};
const $45faa0a4bd982593$var$handleTouch = (e)=>{
    localStorage.setItem('Retorik.Framework.TouchY', `${e.touches[0].screenY}`);
    e.touches.length > 1 && !$45faa0a4bd982593$var$checkShouldPropagate(e) && e.cancelable && e.preventDefault();
};
/**
 * Attach wheel | touch events on either a HTMLElement or a reference to a HTMLDivElement to prevent the propagation of this events to parent window.
 * @param {HTMLElement | null} element HTMLElement to which we will attach the events
 * @param {React.RefObject<HTMLDivElement>} ref reference to the HTMLDivElement to which we will attach the events
 * @param {AbortSignal} signal abort signal to remove events when needed
 */ const $45faa0a4bd982593$var$preventEvents = (element, ref, signal, reversed)=>{
    // Add abort signal to options if present
    const options = signal ? {
        passive: false,
        signal: signal
    } : {
        passive: false
    };
    if (ref?.current) {
        try {
            ref.current.removeEventListener('wheel', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed));
            ref.current.removeEventListener('touchstart', (e)=>$45faa0a4bd982593$var$handleTouch(e));
            ref.current.removeEventListener('touchmove', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed));
        } catch (err) {
            console.warn(err);
        }
        ref.current.addEventListener('wheel', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed), options);
        ref.current.addEventListener('touchstart', (e)=>$45faa0a4bd982593$var$handleTouch(e), options);
        ref.current.addEventListener('touchmove', (e)=>$45faa0a4bd982593$var$handleRefStop(e, ref, !!reversed), options);
    } else if (element) {
        element.addEventListener('wheel', (e)=>$45faa0a4bd982593$var$handleStop(e), options);
        element.addEventListener('touchstart', (e)=>$45faa0a4bd982593$var$handleTouch(e), options);
        element.addEventListener('touchmove', (e)=>$45faa0a4bd982593$var$handleStop(e), options);
    }
};
var $45faa0a4bd982593$export$2e2bcd8739ae039 = $45faa0a4bd982593$var$preventEvents;

});


parcelRegister("cdF3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $20498039af0e1269$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $hdMz2 = parcelRequire("hdMz2");

var $NMpBg = parcelRequire("NMpBg");

var $dHUeX = parcelRequire("dHUeX");

var $2rYkD = parcelRequire("2rYkD");

var $k4qlo = parcelRequire("k4qlo");

var $8HSQQ = parcelRequire("8HSQQ");

var $a459f = parcelRequire("a459f");

var $85RVQ = parcelRequire("85RVQ");

var $hC8yR = parcelRequire("hC8yR");
let $20498039af0e1269$var$timer = null;
const $20498039af0e1269$var$ListContainer = ({ hasFilterOrSuggestedAction: hasFilterOrSuggestedAction, numberOfResults: numberOfResults })=>{
    const { content: content, selectedFilters: selectedFilters, loadingData: loadingData, setLoadingData: setLoadingData } = (0, $4mkhB.useList)();
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const currentPagination = (0, $NMpBg.default)();
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [contentToDisplay, setContentToDisplay] = (0, $bxRTa.useState)([]);
    const [landscapeStyle, setLandscapeStyle] = (0, $bxRTa.useState)('large:rf-h-3/5');
    const [limitToFill, setLimitToFill] = (0, $bxRTa.useState)(0);
    const loadingRef = (0, $bxRTa.useRef)(false);
    const scrollRef = (0, $bxRTa.useRef)(null);
    const contentRef = (0, $bxRTa.useRef)(null);
    const numberOfDisplayed = (0, $bxRTa.useRef)();
    const [abortController, setAbortController] = (0, $bxRTa.useState)(null);
    (0, $bxRTa.useEffect)(()=>{
        setLandscapeStyle(hasFilterOrSuggestedAction ? 'large:rf-h-[60vh]' : '');
    }, [
        hasFilterOrSuggestedAction
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
                setLimitToFill(10);
                break;
            case (0, $2rYkD.DeviceType).borne:
                setLimitToFill(9);
                break;
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setLimitToFill(0);
                break;
        }
    }, [
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (content?.attachments && content.attachments.length > 0) {
            const filteredContent = content.attachments.filter((attachment)=>attachment.contentType === (0, $dHUeX.CONTENT_TYPE_POI));
            if (content?.label === 'Davi.NextPageContent') {
                // If we received new content to add to the current one, check for mobile and display all
                if (isMobile) {
                    // If the last attachment was added to get an even number, remove it before merging data
                    const oldAttachments = contentToDisplay[contentToDisplay.length - 1].contentType === (0, $dHUeX.CONTENT_TYPE_EMPTY) ? [
                        ...contentToDisplay
                    ].slice(0, -1) : contentToDisplay;
                    const tempAttachments = [
                        ...oldAttachments,
                        ...filteredContent
                    ];
                    if (tempAttachments.length % 2 !== 0) setContentToDisplay([
                        ...tempAttachments,
                        {
                            contentType: (0, $dHUeX.CONTENT_TYPE_EMPTY)
                        }
                    ]);
                    else setContentToDisplay(tempAttachments);
                } else setContentToDisplay([
                    ...contentToDisplay,
                    ...filteredContent
                ]);
            } else {
                // On a mobile device, if there is an odd number of attachments, we put a grey one at the end
                if (isMobile && filteredContent.length % 2 !== 0) setContentToDisplay([
                    ...filteredContent,
                    {
                        contentType: (0, $dHUeX.CONTENT_TYPE_EMPTY)
                    }
                ]);
                else if (filteredContent.length < limitToFill) {
                    const tempAttachments = [
                        ...filteredContent
                    ];
                    let i = filteredContent.length;
                    while(i < limitToFill){
                        tempAttachments.push({
                            contentType: (0, $dHUeX.CONTENT_TYPE_EMPTY)
                        });
                        i++;
                    }
                    setContentToDisplay(tempAttachments);
                } else setContentToDisplay(filteredContent);
            }
        } else setContentToDisplay([]);
    }, [
        content,
        limitToFill
    ]);
    (0, $bxRTa.useEffect)(()=>{
        loadingRef.current = loadingData;
    }, [
        loadingData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        numberOfDisplayed.current = contentToDisplay.filter((item)=>item.contentType === (0, $dHUeX.CONTENT_TYPE_POI)).length;
        content?.label !== 'Davi.NextPageContent' && !isMobile ? $20498039af0e1269$var$timer = setTimeout(()=>{
            scrollToRef();
        }, 100) : setLoadingData(false);
        return ()=>{
            $20498039af0e1269$var$timer && clearTimeout($20498039af0e1269$var$timer);
        };
    }, [
        contentToDisplay
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (contentRef?.current && isWidget) {
            if (currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape) {
                const ab = new AbortController();
                setAbortController(ab);
                (0, $k4qlo.default)(null, contentRef, ab.signal);
            } else {
                abortController?.abort();
                setAbortController(null);
            }
        }
    }, [
        contentRef?.current,
        currentDeviceType
    ]);
    /**
   * Click on 'see more' button in mobile mode or scroll to the end of the list in desktop / borne modes.
   * This will send a postback message with 'hospitality.pointOfInterest.nextPage' name to get new content
   */ const handleClick = ()=>{
        setLoadingData(true);
        numberOfDisplayed.current && sendMessage(undefined, {
            name: 'hospitality.pointOfInterest.nextPage',
            index: numberOfDisplayed.current < currentPagination ? 0 : numberOfDisplayed.current - (currentPagination - 2),
            filters: selectedFilters
        });
    };
    /**
   * Check if we need to call for next content
   */ const handleScroll = ()=>{
        if (contentRef?.current && contentRef.current.scrollTop + contentRef.current.clientHeight >= contentRef.current.scrollHeight - 5 && numberOfDisplayed?.current && numberOfDisplayed.current !== numberOfResults && !loadingRef.current) handleClick();
    };
    /**
   * Scroll to the scrollRef HTMLDivElement at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
        setLoadingData(false);
    };
    return content ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: contentRef,
                className: `rf-relative rf-w-full rf-mb-8 ${landscapeStyle} large-vertical:rf-h-[50vh] rf-overflow-y-visible large:rf-overflow-y-scroll rf-scrollbar-hidden ${!isMobile && 'rf-opacity-gradient-b-thin'} rf-px-2 large:rf-px-0 rf-pb-8 large:rf-pb-16 ${loadingData && 'rf-pointer-events-none'}`,
                onScroll: handleScroll,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: scrollRef
                    }),
                    loadingData && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-absolute rf-z-util rf-w-full rf-flex rf-items-end rf-justify-center rf-bg-white rf-bg-opacity-50 rf-pointer-events-none",
                        style: {
                            height: contentRef?.current?.scrollHeight ? `${contentRef.current.scrollHeight}px` : '100%',
                            paddingBottom: contentRef?.current?.clientHeight ? `calc(${contentRef.current.clientHeight / 2}px - 6rem)` : '6rem'
                        },
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-w-6 rf-h-6 rf-mb-16",
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $85RVQ.default), {
                                color: "gray",
                                loaderColor: "#1999b1",
                                backgroundColor: "transparent"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a459f.default), {
                        children: contentToDisplay.length === 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            children: translation.poi.nodata
                        }) : contentToDisplay.map((attachment, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: (0, $8HSQQ.default)({
                                    attachment: attachment
                                })
                            }, key);
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-justify-end rf-gap-8",
                        children: [
                            numberOfDisplayed.current !== numberOfResults && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                className: "rf-w-full rf-py-2 rf-bg-templateBackground rf-border rf-border-black rf-rounded rf-text-black",
                                onClick: handleClick,
                                children: "Voir plus"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                                direction: "top",
                                display: !!(numberOfDisplayed?.current && numberOfDisplayed.current > currentPagination),
                                scrollHandler: ()=>scrollToRef(),
                                className: "rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                            })
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                direction: "top",
                display: !!(numberOfDisplayed?.current && numberOfDisplayed.current > currentPagination),
                scrollHandler: ()=>scrollToRef(),
                className: "rf-absolute rf-bottom-1/4 rf-right-3 rf-z-ui rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $20498039af0e1269$export$2e2bcd8739ae039 = $20498039af0e1269$var$ListContainer;

});
parcelRegister("NMpBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c73313d6353629$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");
function $b6c73313d6353629$export$2e2bcd8739ae039() {
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const [currentPagination, setCurrentPagination] = (0, $bxRTa.useState)(10);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration && currentDeviceType) switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).borne:
                setCurrentPagination(configuration.pagination?.borne || 15);
                break;
            case (0, $2rYkD.DeviceType).landscape:
                setCurrentPagination(configuration.pagination?.landscape || 20);
                break;
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setCurrentPagination(configuration.pagination?.mobile || 12);
                break;
            default:
                break;
        }
        else setCurrentPagination(10);
    }, [
        configuration,
        currentDeviceType
    ]);
    return currentPagination;
}

});

parcelRegister("8HSQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1205cbb49dfe016$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $dHUeX = parcelRequire("dHUeX");

var $7aiQ6 = parcelRequire("7aiQ6");

var $hGmDs = parcelRequire("hGmDs");

var $8fRqq = parcelRequire("8fRqq");

var $icqMW = parcelRequire("icqMW");

var $9rMVA = parcelRequire("9rMVA");

var $ck3iG = parcelRequire("ck3iG");

var $k60RP = parcelRequire("k60RP");

var $cZz3G = parcelRequire("cZz3G");

var $3B8pL = parcelRequire("3B8pL");

var $030Xj = parcelRequire("030Xj");

var $hRTgS = parcelRequire("hRTgS");

var $xEIv0 = parcelRequire("xEIv0");

var $exvww = parcelRequire("exvww");

var $beoxv = parcelRequire("beoxv");
const $d1205cbb49dfe016$var$renderAttachment = ({ attachment: attachment, history: history, activityId: activityId, height: height, setQrCodeData: setQrCodeData, setModalFullscreenContent: setModalFullscreenContent })=>{
    switch(attachment.contentType){
        case 0, $dHUeX.CONTENT_TYPE_NEWS:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7aiQ6.default), {
                ...attachment.content,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_POI:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hGmDs.default), {
                ...attachment.content
            });
        case 0, $dHUeX.CONTENT_TYPE_EMPTY:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8fRqq.default), {});
        case 0, $dHUeX.CONTENT_TYPE_IMAGE:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $icqMW.default), {
                ...attachment.content,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_LINK:
            return Array.isArray(attachment.content.urlData) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ck3iG.default), {
                ...attachment.content,
                height: height
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9rMVA.default), {
                ...attachment.content,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_SUGGESTEDACTION:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $k60RP.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_DISCOVER:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cZz3G.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_SUGGESTION:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3B8pL.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $dHUeX.CONTENT_TYPE_GRID:
        case 0, $dHUeX.CONTENT_TYPE_TILE:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $030Xj.default), {
                ...attachment.content,
                history: history,
                setQrCodeDataOverlay: setQrCodeData
            });
        case 0, $dHUeX.CONTENT_TYPE_MODAL_EXTERNALURI:
            if (!history) {
                const customComponent = /*#__PURE__*/ (0, $fl9nK.jsx)((0, $beoxv.default), {
                    ...attachment.content
                });
                setTimeout(()=>{
                    setModalFullscreenContent?.(customComponent, activityId);
                }, 250);
            }
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        case 0, $dHUeX.CONTENT_TYPE_INTERNAL_COUNTER:
            return history ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $xEIv0.default), {});
        case 0, $dHUeX.CONTENT_TYPE_NAMED_LIST:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $exvww.default), {
                ...attachment.content,
                history: history,
                height: height
            });
        default:
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hRTgS.default), {
                content: attachment.content,
                height: height
            });
    }
};
var $d1205cbb49dfe016$export$2e2bcd8739ae039 = $d1205cbb49dfe016$var$renderAttachment;

});
parcelRegister("7aiQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e269216fbe0b81$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
parcelRequire("l9TTE");
var $bQTDb = parcelRequire("bQTDb");
const $87e269216fbe0b81$var$NewsAttachment = ({ title: title, subtitle: subtitle, text: text, media: media, height: height })=>{
    const medias = [];
    media && media.forEach((med)=>{
        medias.push({
            url: med.url,
            alt: med.profile || 'media'
        });
    });
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-gap-4 rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText",
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-fit rf-px-2 rf-py-1 large:rf-py-2 rf-small-size-auto rf-uppercase rf-border rf-border-black rf-bg-black rf-text-primary",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-title-size-auto",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-gap-3",
                children: [
                    medias.length > 0 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-[45%] rf-min-w-[45%] rf-max-w-[45%] rf-flex rf-justify-center rf-aspect-square large:rf-aspect-video",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bQTDb.default), {
                            className: "rf-max-h-full rf-max-w-full rf-h-fit rf-w-fit",
                            medias: medias
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-line-clamp-7",
                        children: text
                    })
                ]
            })
        ]
    });
};
var $87e269216fbe0b81$export$2e2bcd8739ae039 = $87e269216fbe0b81$var$NewsAttachment;

});

parcelRegister("hGmDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $881bf6ededcd0d75$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $hdMz2 = parcelRequire("hdMz2");
parcelRequire("d72S7");
var $79eFo = parcelRequire("79eFo");
var $epsYO = parcelRequire("epsYO");

var $cZ7bt = parcelRequire("cZ7bt");
const $881bf6ededcd0d75$var$ReviewsAndFavorite = ({ reviews: reviews, favorite: favorite })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            reviews && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cZ7bt.default), {
                customerReviews: reviews,
                className: "rf-absolute rf-top-0 rf-right-2"
            }),
            favorite && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $79eFo.default), {
                className: "rf-absolute rf-h-6 large:rf-h-8 rf-bottom-2 rf-right-2"
            })
        ]
    });
};
const $881bf6ededcd0d75$var$POIAttachment = ({ media: media, title: title, subtitle: subtitle, favorite: favorite, customerReviews: customerReviews, tap: tap, distance: distance })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const handleClick = ()=>{
        tap && sendMessage(undefined, tap);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-rounded hover:rf-cursor-pointer",
        onClick: handleClick,
        children: [
            media && media[0]?.url ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-relative rf-w-full rf-rounded rf-aspect-video",
                style: {
                    backgroundImage: `url(${media[0].url.replaceAll("'", '%27')})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                },
                children: /*#__PURE__*/ (0, $fl9nK.jsx)($881bf6ededcd0d75$var$ReviewsAndFavorite, {
                    reviews: customerReviews,
                    favorite: favorite
                })
            }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-relative rf-w-full rf-bg-silver rf-rounded rf-aspect-video",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $epsYO.default), {
                        className: "rf-absolute rf-h-1/3 rf-top-1/3 rf-left-1/2 rf-transform -rf-translate-x-1/2"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)($881bf6ededcd0d75$var$ReviewsAndFavorite, {
                        reviews: customerReviews,
                        favorite: favorite
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-line-clamp-2",
                style: {
                    color: themeColors.agendaColor
                },
                children: subtitle
            }),
            distance && /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-text-gray",
                children: `${(distance / 1000).toFixed(1)} km`
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-my-2 rf-font-bold rf-line-clamp-2",
                children: title || ''
            })
        ]
    });
};
var $881bf6ededcd0d75$export$2e2bcd8739ae039 = $881bf6ededcd0d75$var$POIAttachment;

});
parcelRegister("cZ7bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c32995d18448a1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");
parcelRequire("d72S7");
var $a0inq = parcelRequire("a0inq");
const $30c32995d18448a1$var$CommentsPennant = ({ className: className, customerReviews: customerReviews })=>{
    const { color: color } = (0, $4mkhB.useList)();
    const [widthInPx, setWidthInPx] = (0, $bxRTa.useState)(0);
    const pennantRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (pennantRef.current) setWidthInPx(Math.ceil(pennantRef.current.offsetWidth / 2));
    }, [
        pennantRef
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `${className} rf-flex rf-flex-col rf-justify-center rf-text-white`,
        ref: pennantRef,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-p-1",
                style: {
                    backgroundColor: color
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a0inq.default), {
                        className: "rf-w-6 large:rf-w-8 rf-py-2 vertical:rf-py-1"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-font-bold rf-small-size-auto rf-text-center",
                        children: [
                            customerReviews,
                            "/10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-0 rf-h-0 rf-border-t-0 rf-border-x-primary rf-border-b-transparent",
                style: {
                    borderLeftColor: color,
                    borderRightColor: color,
                    borderBottomWidth: widthInPx * 2 / 3,
                    borderLeftWidth: widthInPx,
                    borderRightWidth: widthInPx
                }
            })
        ]
    });
};
var $30c32995d18448a1$export$2e2bcd8739ae039 = $30c32995d18448a1$var$CommentsPennant;

});


parcelRegister("8fRqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe9a3203d97d9b4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $6fe9a3203d97d9b4$var$EmptyAttachment = ()=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-gap-2 rf-rounded",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-relative rf-w-full rf-bg-templateEmptyCard rf-rounded rf-aspect-video"
        })
    });
};
var $6fe9a3203d97d9b4$export$2e2bcd8739ae039 = $6fe9a3203d97d9b4$var$EmptyAttachment;

});

parcelRegister("icqMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $237d7ddb91c1b9e4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $1cxbd = parcelRequire("1cxbd");
const $237d7ddb91c1b9e4$var$ImageAttachment = ({ url: url, title: title, alt: alt, isMiniature: isMiniature, height: height })=>{
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const [maxHeight, setMaxHeight] = (0, $bxRTa.useState)(0);
    (0, $bxRTa.useEffect)(()=>{
        if (currentHeight && currentDeviceType) switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setMaxHeight(Math.floor(currentHeight * (displaySubtitles ? 0.34 : 0.5)));
                break;
            case (0, $2rYkD.DeviceType).landscape:
                // The container in BotResponse is 7 rows high on the main grid, with a total of 12 rows, so quite 59%.
                // We reduce a little 9% because 100% is whithout browser's interface. 
                setMaxHeight(Math.floor(currentHeight * 0.50));
                break;
            case (0, $2rYkD.DeviceType).borne:
                // Same as landscape, but 5 rows high instead of 7
                setMaxHeight(Math.floor(currentHeight * 0.34));
                break;
            default:
                break;
        }
    }, [
        currentHeight,
        currentDeviceType,
        displaySubtitles
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-row rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1cxbd.default), {
                url: url
            }),
            isMiniature ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-1/4"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: "rf-max-w-1/2",
                        src: url,
                        alt: alt || 'image',
                        style: {
                            maxHeight: `calc(${maxHeight}px - 3rem)`
                        }
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-1/4"
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                className: "rf-max-w-full",
                src: url,
                alt: alt || 'image',
                style: {
                    maxHeight: `calc(${maxHeight}px - 3rem)`
                }
            }),
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-bottom-0 rf-py-2 rf-text-center rf-text-sm large:rf-text-base rf-text-cardFrameText rf-bg-cardFrameBackground rf-bg-opacity-80 rf-rounded-b rf-w-full",
                children: title
            })
        ]
    });
};
var $237d7ddb91c1b9e4$export$2e2bcd8739ae039 = $237d7ddb91c1b9e4$var$ImageAttachment;

});
parcelRegister("1cxbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $188e3060064bd9c0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");
parcelRequire("kMAJU");
var $7bOgw = parcelRequire("7bOgw");
const $188e3060064bd9c0$var$DisplayFullScreenButton = ({ url: url })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const setFullScreenImage = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setFullScreenImage);
    const handleClick = ()=>{
        setFullScreenImage(url);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-absolute rf-right-2 rf-top-2 rf-p-2 rf-border rf-rounded-lg rf-bg-cardFrameBackground rf-bg-opacity-30 rf-border-cardButtonBorderDefault hover:rf-cursor-pointer",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7bOgw.default), {
            className: "rf-h-4 rf-w-4 large:rf-h-6 large:rf-w-6",
            color: themeColors.card.button.text.default
        })
    });
};
var $188e3060064bd9c0$export$2e2bcd8739ae039 = $188e3060064bd9c0$var$DisplayFullScreenButton;

});


parcelRegister("9rMVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $216a7cf8d000b214$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $7SHCs = parcelRequire("7SHCs");

var $clTWB = parcelRequire("clTWB");

var $eO5xw = parcelRequire("eO5xw");

var $cDMN1 = parcelRequire("cDMN1");

var $cjZIW = parcelRequire("cjZIW");

var $8s4pt = parcelRequire("8s4pt");
parcelRequire("kMAJU");
var $av28T = parcelRequire("av28T");
var $d5ZYc = parcelRequire("d5ZYc");

var $8e5cw = parcelRequire("8e5cw");

var $7fviB = parcelRequire("7fviB");
const $216a7cf8d000b214$var$LinkAttachment = ({ urlData: urlData, fileName: fileName, qrCode: qrCode, description: description, height: height })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const enableDocumentPrinting = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.enableDocumentPrinting);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const setModalFullscreenContent = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setModalFullscreenContent);
    !fileName && (fileName = (0, $cDMN1.checkFileNameInUrl)(urlData.url));
    const title = urlData.title || fileName;
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(qrCode);
    const [textToDisplay, setTextToDisplay] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        setTextToDisplay((0, $clTWB.getTextToDisplayOnLink)({
            translation: translation,
            isUsedOnBorne: isUsedOnBorne,
            data: urlData,
            fileName: fileName
        }));
    }, [
        isUsedOnBorne,
        locale,
        urlData
    ]);
    /**
   * On component creation :
   *  - call setQrCodeDataAsync only if used on a borne
   */ (0, $bxRTa.useEffect)(()=>{
        !qrCode && isUsedOnBorne && setQrCodeDataAsync();
    }, []);
    /**
   * On call :
   *  - generate a qrcode as dataURL
   *  - set qrCodeData state with the data
   */ const setQrCodeDataAsync = async ()=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(urlData.url);
        setQrCodeData(qrCodeString);
    };
    const handleClick = ()=>{
        setModalFullscreenContent(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $7fviB.default), {
            url: urlData.url,
            printingAllowed: !!enableDocumentPrinting
        }));
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-4 ${title || description ? 'rf-justify-between' : 'rf-justify-around'} rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin`,
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full ${description ? 'rf-text-left' : 'rf-text-center'} rf-title-size-auto ${isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            }),
            isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    urlData.url.length > 4 && urlData.url.substring(urlData.url.length - 4) === '.pdf' && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-full rf-pb-10 rf-flex rf-items-center rf-justify-center",
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                            className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-gap-2 rf-items-center rf-border-2 rf-text-primary rf-border-primary hover:rf-text-truewhite hover:rf-border-truewhite rf-rounded-lg rf-text-sm rf-font-bold",
                            onClick: handleClick,
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $av28T.default), {
                                    color: themeColors.primary
                                }),
                                translation.link.buttontext
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-center",
                        children: [
                            description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: description
                            }),
                            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                                src: qrCodeData
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d5ZYc.default), {
                                className: "rf-absolute rf-top-[0.125rem] -rf-left-6 rf-h-4"
                            }),
                            textToDisplay
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mb-4",
                        children: description
                    }),
                    urlData.download && urlData.title && textToDisplay.length >= 40 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8s4pt.default), {
                        url: urlData.url,
                        text: textToDisplay,
                        download: true
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cjZIW.default), {
                        url: urlData.url,
                        text: textToDisplay,
                        description: !!description,
                        download: !!urlData.download
                    })
                ]
            })
        ]
    });
};
var $216a7cf8d000b214$export$2e2bcd8739ae039 = $216a7cf8d000b214$var$LinkAttachment;

});
parcelRegister("clTWB", function(module, exports) {

$parcel$export(module.exports, "getTextToDisplayOnLink", () => $aa22e2043600c016$export$2eb1c1cc4b12d451);
const $aa22e2043600c016$export$2eb1c1cc4b12d451 = ({ translation: translation, isUsedOnBorne: isUsedOnBorne, data: data, fileName: fileName })=>{
    let textToDisplay = '';
    if (isUsedOnBorne) {
        if (data.download) {
            if (data.title) textToDisplay = `${translation.common.download} \u00ab ${fileName} \u00bb`;
            else textToDisplay = translation.common.download;
        } else textToDisplay = translation.link.goto;
        textToDisplay += ` ${translation.link.scanQR}`;
    } else if (data.download) {
        if (data.title) textToDisplay = `${translation.common.download} ${fileName}`;
        else textToDisplay = translation.common.download;
    } else textToDisplay = translation.link.click;
    return textToDisplay;
};

});

parcelRegister("cDMN1", function(module, exports) {

$parcel$export(module.exports, "checkFileNameInUrl", () => $a3f4d9145cbf9524$export$a6f11fce0a840e6c);
const $a3f4d9145cbf9524$export$a6f11fce0a840e6c = (url)=>{
    const [lastPart] = url.split('/').slice(-1);
    if (lastPart && lastPart.length > 4 && lastPart.includes('.')) return lastPart;
    return undefined;
};

});

parcelRegister("cjZIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0099778562612303$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
parcelRequire("kMAJU");
var $9oAhU = parcelRequire("9oAhU");

var $2eBYD = parcelRequire("2eBYD");
const $0099778562612303$var$ClassicButton = ({ url: url, text: text, description: description, download: download })=>{
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-flex ${description ? 'rf-justify-start' : 'rf-justify-center'}`,
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-card-button rf-flex rf-items-center",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-h-6 rf-w-6",
                    children: download ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9oAhU.default), {}) : isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {})
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isRTL ? 'rf-mr-2' : 'rf-ml-2'} rf-truncate`,
                    children: text || ''
                })
            ]
        })
    });
};
var $0099778562612303$export$2e2bcd8739ae039 = $0099778562612303$var$ClassicButton;

});

parcelRegister("8s4pt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe00e8f533f6539$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
parcelRequire("kMAJU");
var $9oAhU = parcelRequire("9oAhU");
const $bbe00e8f533f6539$var$BorderlessButton = ({ url: url, text: text, download: download })=>{
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>setHover(true),
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`,
                    children: download ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9oAhU.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`,
                    children: text || ''
                })
            ]
        })
    });
};
var $bbe00e8f533f6539$export$2e2bcd8739ae039 = $bbe00e8f533f6539$var$BorderlessButton;

});


parcelRegister("ck3iG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4733061cfa3e284c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $eO5xw = parcelRequire("eO5xw");

var $cDMN1 = parcelRequire("cDMN1");

var $8s4pt = parcelRequire("8s4pt");
const $4733061cfa3e284c$var$MultiLinkAttachment = ({ urlData: urlData, title: title, description: description, height: height })=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? 'rf-justify-between' : 'rf-justify-around'} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin`,
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full rf-mb-4 ${description ? 'rf-text-left' : 'rf-text-center'} rf-title-size-auto ${configuration.isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            }),
            description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-mb-4",
                children: description
            }),
            urlData.map((data, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8s4pt.default), {
                    url: data.url,
                    text: data.title || (0, $cDMN1.checkFileNameInUrl)(data.url) || data.url,
                    download: !!data.download
                }, key);
            })
        ]
    });
};
var $4733061cfa3e284c$export$2e2bcd8739ae039 = $4733061cfa3e284c$var$MultiLinkAttachment;

});

parcelRegister("k60RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4860cbee8d312bd0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $iEJNQ = parcelRequire("iEJNQ");
const $4860cbee8d312bd0$var$SuggestedActionAttachment = ({ title: title, actions: actions, history: history, height: height })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const unlockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.unlockClickedButton);
    const lockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.actions.lockClickedButton);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [clicked, setClicked] = (0, $bxRTa.useState)(null);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton && setClicked(null);
    }, [
        unlockClickedButton
    ]);
    const handleClick = (value, index)=>{
        lockClickedButton();
        setClicked(index);
        sendMessage(value);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-pb-4 rf-text-center rf-text-cardFrameText rf-subtitle-size-auto",
                children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-pt-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 rf-flex-wrap",
                children: actions.map((action, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: clicked === key ? 'rf-card-button-clicked' : 'rf-card-button',
                        onClick: history ? ()=>{} : ()=>handleClick(action.action, key),
                        children: clicked === key ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center",
                            style: {
                                ...animationColor
                            },
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-2 rf-h-2 large:rf-w-4 large:rf-h-4",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                                    size: isMobile ? (0, $2rYkD.AnimationSize).small : (0, $2rYkD.AnimationSize).medium
                                })
                            })
                        }) : action.title || '?'
                    }, key);
                })
            })
        ]
    });
};
var $4860cbee8d312bd0$export$2e2bcd8739ae039 = $4860cbee8d312bd0$var$SuggestedActionAttachment;

});
parcelRegister("iEJNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d00caebba42feb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
const $42d00caebba42feb$var$Animation = ({ size: size })=>{
    const customClassName = (0, $bxRTa.useMemo)(()=>{
        switch(size){
            case (0, $2rYkD.AnimationSize).small:
                return 'rf-loader-mini rf-animate-loaderMini rf-h-2 -rf-top-2';
            case (0, $2rYkD.AnimationSize).medium:
                return 'rf-loader-medium rf-animate-loaderMedium rf-h-4 -rf-top-4';
            case (0, $2rYkD.AnimationSize).large:
            default:
                return 'rf-loader rf-animate-loader rf-h-6 -rf-top-6';
        }
    }, [
        size
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-relative ${customClassName} rf-rounded-half`
    });
};
var $42d00caebba42feb$export$2e2bcd8739ae039 = $42d00caebba42feb$var$Animation;

});


parcelRegister("cZz3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68744aac590de15$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $5JKxf = parcelRequire("5JKxf");

var $iEJNQ = parcelRequire("iEJNQ");
const $c68744aac590de15$var$DiscoverAttachment = ({ title: title, mainButtons: mainButtons, recommandationButton: recommandationButton, history: history, height: height })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const unlockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.unlockClickedButton);
    const lockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.actions.lockClickedButton);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const displayLayout = (0, $bxRTa.useMemo)(()=>{
        if (mainButtons && mainButtons.length > 1) return `rf-w-full rf-grid rf-grid-cols-${mainButtons.length} rf-gap-2 large:rf-gap-4`;
        return 'rf-w-1/2 rf-justify-self-center';
    }, [
        mainButtons
    ]);
    const [clicked, setClicked] = (0, $bxRTa.useState)(false);
    const [discoverClicked, setDiscoverClicked] = (0, $bxRTa.useState)(null);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    const handleClick = (data, index)=>{
        if (discoverClicked === null || discoverClicked !== index) {
            lockClickedButton();
            let dataToSend = {};
            // @ts-ignore
            if (data.eventName) {
                const tempData = data;
                setClicked(true);
                dataToSend = {
                    type: 'event',
                    name: tempData.eventName,
                    recommendationId: tempData.recommendationId
                };
            } else if (index !== undefined) {
                setDiscoverClicked(index);
                const tempData = data;
                dataToSend = {
                    type: 'event',
                    name: tempData.EventName,
                    value: {
                        filterId: tempData.FilterId,
                        filterValue: tempData.FilterValue,
                        followingCardText: tempData.FollowingCardText,
                        identifier: tempData.Identifier
                    }
                };
            }
            sendMessage(undefined, dataToSend);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        if (unlockClickedButton) {
            setClicked(false);
            setDiscoverClicked(null);
        }
    }, [
        unlockClickedButton
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-bg-cardFrameBackground large:rf-p-[25px] rf-p-4 ${history && 'rf-pointer-events-none'} `,
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-title-size-auto rf-mb-3 rf-text-center",
                children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full ${displayLayout}`,
                children: mainButtons && mainButtons.length > 0 ? mainButtons.map((button, i)=>{
                    let colorButtonHandle = '';
                    if (button.EventName.indexOf('TouristAttractions') > -1) colorButtonHandle = themeColors.tobeDoneColor;
                    else if (button.EventName.indexOf('Products') > -1) colorButtonHandle = themeColors.localProductsColor;
                    else if (button.EventName.indexOf('FoodEstablishments') > -1) colorButtonHandle = themeColors.whereToEatColor;
                    else if (button.EventName.indexOf('LodgingBusinesses') > -1) colorButtonHandle = themeColors.whereToSleepColor;
                    else if (button.EventName.indexOf('TouristDestinations') > -1) colorButtonHandle = themeColors.tobeSeenColor;
                    else if (button.EventName.indexOf('Event') > -1) colorButtonHandle = themeColors.agendaColor;
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-relative rf-w-full rf-card-button-discover rf-rounded rf-flex rf-flex-col rf-gap-2 large:rf-gap-3 rf-items-center rf-justify-self-center",
                        onClick: ()=>handleClick(button, i),
                        style: {
                            boxShadow: '0px 0px 13px #0000009c'
                        },
                        children: discoverClicked === i ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center",
                            style: {
                                ...animationColor
                            },
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                                    size: isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large
                                })
                            })
                        }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                            children: [
                                button.MediaUrl.indexOf('svg') > -1 && colorButtonHandle !== '' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                                    svgUrl: button.MediaUrl,
                                    height: "50px",
                                    fillColor: colorButtonHandle
                                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                                    src: button.MediaUrl,
                                    alt: button.Text,
                                    style: {
                                        height: '50px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                    className: "rf-flex rf-items-center rf-text-center rf-uppercase rf-font-bold large:rf-text-basecustom rf-text-xsl rf-overflow-wrap",
                                    children: button.Text
                                })
                            ]
                        })
                    }, i);
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {})
            }),
            recommandationButton && mainButtons && mainButtons.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-mt-4 rf-font-bold ${clicked ? 'rf-card-button-clicked' : 'rf-card-button'} rf-text-center rf-capitalize-first`,
                onClick: ()=>handleClick(recommandationButton),
                children: clicked ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                            size: isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large
                        })
                    })
                }) : recommandationButton.text
            })
        ]
    });
};
var $c68744aac590de15$export$2e2bcd8739ae039 = $c68744aac590de15$var$DiscoverAttachment;

});
parcelRegister("5JKxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $298f7d80b3eebe3e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $aBDai = parcelRequire("aBDai");

var $lOuaH = parcelRequire("lOuaH");
const $298f7d80b3eebe3e$var$SvgColorChanger = ({ svgUrl: svgUrl, fillColor: fillColor, height: height })=>{
    const [filter, setFilter] = (0, $bxRTa.useState)();
    const [hex, setHex] = (0, $bxRTa.useState)();
    const [ratio, setRatio] = (0, $bxRTa.useState)(1);
    const divRef = (0, $bxRTa.useRef)(null);
    const svgRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(divRef);
    const rgbToCssFilter = (r, g, b)=>{
        const hex = `${(r & 0xff).toString(16).padStart(2, '0')}${(g & 0xff).toString(16).padStart(2, '0')}${(b & 0xff).toString(16).padStart(2, '0')}`;
        setHex(hex);
        return /*#__PURE__*/ (0, $fl9nK.jsx)("filter", {
            id: hex,
            colorInterpolationFilters: "sRGB",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("feColorMatrix", {
                type: "matrix",
                values: `0 0 0 0 ${r / 255.0} 0 0 0 0 ${g / 255.0} 0 0 0 0 ${b / 255.0} 0 0 0 1 0`
            })
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        if (fillColor) {
            const rgbColor = (0, $aBDai.hexToRgb)(fillColor);
            setFilter(rgbToCssFilter(rgbColor.r, rgbColor.g, rgbColor.b));
        }
    }, [
        fillColor
    ]);
    const handleLoaded = ()=>{
        if (svgRef.current) {
            const box = svgRef.current.getBBox();
            setRatio(box.width / box.height);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        ref: divRef,
        className: "rf-h-full",
        style: {
            width: dimensions.height * ratio
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("svg", {
            ref: svgRef,
            className: "rf-filter rf-w-full",
            height: height || '100%',
            children: [
                filter && /*#__PURE__*/ (0, $fl9nK.jsx)("defs", {
                    children: filter
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("image", {
                    filter: filter ? `url(#${hex})` : undefined,
                    onLoad: handleLoaded,
                    href: svgUrl,
                    x: "0",
                    y: "0",
                    height: height || dimensions.height
                })
            ]
        })
    });
};
var $298f7d80b3eebe3e$export$2e2bcd8739ae039 = $298f7d80b3eebe3e$var$SvgColorChanger;

});
parcelRegister("aBDai", function(module, exports) {

$parcel$export(module.exports, "getColorWithTransparency", () => $b6ebd48cdf39835a$export$730331b97844b22d);
$parcel$export(module.exports, "hexToRgb", () => $b6ebd48cdf39835a$export$5a544e13ad4e1fa5);
const $b6ebd48cdf39835a$export$730331b97844b22d = (color, transparency)=>{
    let tempColorObject = null;
    try {
        tempColorObject = color.includes('rgb') ? $b6ebd48cdf39835a$var$rgbToObject(color) : $b6ebd48cdf39835a$export$5a544e13ad4e1fa5(color);
    } catch (error) {
        console.log(error);
    }
    if (tempColorObject) return `rgba(${tempColorObject.r}, ${tempColorObject.g}, ${tempColorObject.b}, ${transparency})`;
    return color;
};
const $b6ebd48cdf39835a$export$186ed2fadd5d0f9d = (color)=>{
    let tempColorObject = null;
    try {
        tempColorObject = color.includes('rgb') ? $b6ebd48cdf39835a$var$rgbToObject(color) : $b6ebd48cdf39835a$export$5a544e13ad4e1fa5(color);
    } catch (error) {
        console.log(error);
    }
    if (tempColorObject) return `rgba(${tempColorObject.r / 2}, ${tempColorObject.g / 2}, ${tempColorObject.b / 2})`;
    return color;
};
const $b6ebd48cdf39835a$var$rgbToObject = (rgb)=>{
    // Replace unwanted characters
    rgb = rgb.replace('rgb(', '');
    rgb = rgb.replace(')', '');
    rgb = rgb.replace(' ', '');
    const stringArray = rgb.split(',');
    return {
        r: parseInt(stringArray[0], 16),
        g: parseInt(stringArray[1], 16),
        b: parseInt(stringArray[2], 16)
    };
};
const $b6ebd48cdf39835a$export$5a544e13ad4e1fa5 = (hex)=>{
    // Remove '#' char if present
    if (hex.charAt(0) === '#') hex = hex.slice(1);
    // Transform if shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4), 16)
    };
};

});



parcelRegister("3B8pL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbe0760b36a26aa$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $eO5xw = parcelRequire("eO5xw");

var $BwWrg = parcelRequire("BwWrg");
parcelRequire("kMAJU");
var $d5ZYc = parcelRequire("d5ZYc");
const $7bbe0760b36a26aa$var$SuggestionAttachment = ({ suggestions: suggestions, title: title, description: description, height: height, history: history, showTutorial: showTutorial })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const onTutorialClick = ()=>{
        // TODO
        console.log('show tutorial');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full large:rf-p-[25px] rf-p-4 rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? 'rf-justify-between' : 'rf-justify-around'} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin ${history && 'rf-pointer-events-none'} `,
        style: {
            height: height,
            touchAction: 'pan-y'
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full ${description ? '' : 'rf-text-center'} rf-title-size-auto ${configuration.isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            }),
            description && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full",
                children: description
            }),
            suggestions?.map((data, key)=>{
                const text = typeof data === 'string' ? data : data.text;
                const differentTextTosend = typeof data === 'string' ? undefined : data.differentTextToSend || data.text;
                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $BwWrg.default), {
                        text: text,
                        differentTextTosend: differentTextTosend
                    })
                }, key);
            }),
            showTutorial && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-flex rf-items-end rf-italic",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d5ZYc.default), {
                        className: `${isRTL ? 'rf-pl-2' : 'rf-pr-2'} rf-h-6`,
                        color: themeColors.card.button.text.default
                    }),
                    `${translation.common.needhelp} ${translation.suggestion.consult}`,
                    /*#__PURE__*/ (0, $fl9nK.jsx)("span", {
                        className: `${isRTL ? 'rf-pr-1' : 'rf-pl-1'} rf-underline rf-cursor-pointer`,
                        onClick: onTutorialClick,
                        children: translation.suggestion.thetutorial
                    })
                ]
            })
        ]
    });
};
var $7bbe0760b36a26aa$export$2e2bcd8739ae039 = $7bbe0760b36a26aa$var$SuggestionAttachment;

});
parcelRegister("BwWrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $15d670b578ce327d$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $2eBYD = parcelRequire("2eBYD");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");

var $iEJNQ = parcelRequire("iEJNQ");
const $15d670b578ce327d$var$BorderlessButtonMessage = ({ text: text, differentTextTosend: differentTextTosend })=>{
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const unlockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.unlockClickedButton);
    const lockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.actions.lockClickedButton);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const [clicked, setClicked] = (0, $bxRTa.useState)(false);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    const onClick = (text)=>{
        setClicked(true);
        lockClickedButton();
        sendMessage(text);
    };
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton && setClicked(false);
    }, [
        unlockClickedButton
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start rf-cursor-pointer",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>{
                setHover(true);
                onClick(differentTextTosend || text);
            },
            children: [
                clicked ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-2 rf-h-2",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                            size: (0, $2rYkD.AnimationSize).small
                        })
                    })
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`,
                    children: isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`,
                    children: text || ''
                })
            ]
        })
    });
};
var $15d670b578ce327d$export$2e2bcd8739ae039 = $15d670b578ce327d$var$BorderlessButtonMessage;

});


parcelRegister("030Xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a59d276d0c21c5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $hdMz2 = parcelRequire("hdMz2");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $lOuaH = parcelRequire("lOuaH");

var $2rYkD = parcelRequire("2rYkD");

var $5JKxf = parcelRequire("5JKxf");
const $c2a59d276d0c21c5$var$springEnterDuration = 1000;
const $c2a59d276d0c21c5$var$md = new (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $c2a59d276d0c21c5$var$GridAttachment = ({ index: index, text: text, textColor: textColor, backgroundColor: backgroundColor, image: image, action: action, history: history, setQrCodeDataOverlay: setQrCodeDataOverlay })=>{
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const { setClickedOnUI: setClickedOnUI, setCurrentSubView: setCurrentSubView, setDashboardOpened: setDashboardOpened, setFullScreenImage: setFullScreenImage } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const { sendMessage: sendMessage, sendEvent: sendEvent } = (0, $hdMz2.useDirectlineStore)((state)=>state.actions);
    const divRef = (0, $bxRTa.useRef)(null);
    const tileDimensions = (0, $lOuaH.default)(divRef);
    const height = (0, $bxRTa.useMemo)(()=>{
        return tileDimensions.width * 0.75;
    }, [
        tileDimensions.width
    ]);
    const showImage = (0, $bxRTa.useMemo)(()=>{
        return !!(image?.url && height > 80);
    }, [
        height,
        image
    ]);
    const nbLines = (0, $bxRTa.useMemo)(()=>{
        if (!showImage) {
            const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const lineHeightInPx = remToPx * (isMobile ? 1 : 1.1);
            return Math.floor(height / lineHeightInPx);
        }
        return 2;
    }, [
        showImage,
        height
    ]);
    const lineClamp = (0, $bxRTa.useMemo)(()=>{
        return showImage ? 'rf-h-2/5 rf-line-clamp-2' : `rf-line-clamp-${nbLines}`;
    }, [
        nbLines,
        showImage
    ]);
    const maxHeight = (0, $bxRTa.useMemo)(()=>{
        return showImage ? 'rf-max-h-8 large:rf-max-h-[2.3rem]' : `rf-max-h-[${nbLines}rem] large:rf-max-h-[${nbLines * 1.1 + 0.1}rem]`;
    }, [
        nbLines,
        showImage
    ]);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)',
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        setTimeout(()=>{
            api.start({
                from: {
                    transform: 'translateX(100%)',
                    opacity: 0
                },
                to: {
                    transform: 'translateX(0%)',
                    opacity: 1
                },
                config: {
                    duration: $c2a59d276d0c21c5$var$springEnterDuration,
                    easing: (0, $2aMjv.easings).easeInBack
                }
            });
        }, index * 200);
    }, []);
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case 'openmenu':
                setDashboardOpened(true);
                break;
            case 'openlanguage':
                setCurrentSubView((0, $2rYkD.CurrentSubView).languages);
                break;
            case 'openhistory':
                setCurrentSubView((0, $2rYkD.CurrentSubView).history);
                break;
            case 'opentutorial':
                console.log('Open tutorial');
                break;
            case 'fullscreenimage':
                value.url && setFullScreenImage(value.url);
                break;
        }
    };
    const handleClick = (e)=>{
        switch(action.type){
            case (0, $2rYkD.ActionType).message:
                action.value?.text && sendMessage(action.value.text);
                break;
            case (0, $2rYkD.ActionType).event:
                action.value?.name && sendEvent(action.value.name, action.value.value || null);
                break;
            case (0, $2rYkD.ActionType).url:
                if (action.value?.url) // Generate QR-code data on borne, open the URL otherwise
                !isMobile && isUsedOnBorne ? setQrCodeDataOverlay?.(action.value.url) : window.open(action.value.url, '_blank', 'noopener noreferrer');
                break;
            case (0, $2rYkD.ActionType).internal:
                handleInternalAction(action.value);
                break;
        }
        setClickedOnUI((0, $2rYkD.UIPart).card);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        ref: divRef,
        className: `rf-relative rf-w-full ${history ? 'rf-p-3 rf-pointer-events-none' : 'rf-p-4'} rf-flex rf-flex-col ${image?.url ? 'rf-justify-between' : 'rf-justify-end'} rf-items-start rf-gap-[10%] ${isMobile ? 'rf-border rf-border-[#F0F0F0]' : ''} hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[-3px_-3px_10px_#00000099] rf-overflow-hidden`,
        style: {
            height: `calc(${height}px + 1.5rem)`,
            color: textColor || '#575F6B',
            backgroundColor: backgroundColor || '#FFF',
            ...spring
        },
        onClick: (e)=>handleClick(e),
        children: [
            showImage && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-1/2",
                children: image?.url && image.url.indexOf('svg') > -1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                    svgUrl: image.url,
                    height: "100%",
                    fillColor: image.color
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-full",
                    src: image?.url
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-flex rf-min-h-8 large:rf-min-h-[2.3rem] ${lineClamp} rf-items-start rf-text-small-size-auto rf-overflow-y-hidden`,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                    className: `${maxHeight} rf-overflow-y-clip`,
                    dangerouslySetInnerHTML: {
                        __html: $c2a59d276d0c21c5$var$md.renderInline(text)
                    }
                })
            })
        ]
    });
};
var $c2a59d276d0c21c5$export$2e2bcd8739ae039 = $c2a59d276d0c21c5$var$GridAttachment;

});

parcelRegister("hRTgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d4969aabda7e97$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $drUL7 = parcelRequire("drUL7");

var $6HxxJ = parcelRequire("6HxxJ");
const $86d4969aabda7e97$var$adaptiveCard = new $drUL7.AdaptiveCard();
const $86d4969aabda7e97$var$AdaptiveCardAttachment = ({ content: content, height: height })=>{
    const adaptiveCardHostConfig = (0, $6HxxJ.useAdaptiveCardStore)((state)=>state.adaptiveCardHostConfig);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        $86d4969aabda7e97$var$adaptiveCard.hostConfig = adaptiveCardHostConfig;
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        content.minHeight = height ? `${height}px` : '0px';
        content.verticalContentAlignment = 'Center';
        $86d4969aabda7e97$var$adaptiveCard.parse(content);
        const htmlValue = $86d4969aabda7e97$var$adaptiveCard.render();
        if (divRef.current) {
            divRef.current.firstChild?.remove();
            htmlValue && divRef.current.appendChild(htmlValue);
        }
    }, [
        content,
        height
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        ref: divRef
    });
};
var $86d4969aabda7e97$export$2e2bcd8739ae039 = $86d4969aabda7e97$var$AdaptiveCardAttachment;

});

parcelRegister("xEIv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d11bb19506d161$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $2eBYD = parcelRequire("2eBYD");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

var $fUXG2 = parcelRequire("fUXG2");
const $70d11bb19506d161$var$CounterAttachment = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const placeHolder = (0, $7SHCs.useRetorikStore)((state)=>state.sendBoxPlaceHolder);
    const delay = (0, $7SHCs.useRetorikStore)((state)=>state.submitDelayBeforeSendingMessage);
    const speechInterims = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const recognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const { setActiveRecognitionState: setActiveRecognitionState, setMode: setMode } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [displayCounter, setDisplayCounter] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        setDisplayCounter(false);
    }, [
        placeHolder,
        delay
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (delay && recognitionState === (0, $2rYkD.RecognitionState).Closing && speechInterims) {
            setDisplayCounter(true);
            timerRef.current = setTimeout(()=>{
                sendMessage(speechInterims);
                setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
            }, delay * 1000);
        }
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        delay,
        speechInterims,
        recognitionState
    ]);
    const handleButtonClick = ()=>{
        timerRef.current && clearTimeout(timerRef.current);
        setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
        setMode((0, $2rYkD.Mode).text);
    };
    return mode === (0, $2rYkD.Mode).vocal && (recognitionState === (0, $2rYkD.RecognitionState).Closing || recognitionState === (0, $2rYkD.RecognitionState).Listening) ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded",
        children: [
            placeHolder && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold",
                children: placeHolder
            }),
            displayCounter ? /* Counter + button */ /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    delay && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fUXG2.default), {
                        delay: delay
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-card-button",
                        onClick: handleButtonClick,
                        children: translation.anghello.correct
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-text-medium-size-auto rf-text-center rf-text-cardButtonTextDefault",
                children: translation.anghello.listening
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $70d11bb19506d161$export$2e2bcd8739ae039 = $70d11bb19506d161$var$CounterAttachment;

});
parcelRegister("fUXG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $210a7fe3ec90b247$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $210a7fe3ec90b247$var$Counter = ({ delay: delay })=>{
    const [counter, setCounter] = (0, $bxRTa.useState)(delay);
    const intervalRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        intervalRef.current = setInterval(()=>{
            setCounter((value)=>{
                return value ? value - 1 : 0;
            });
        }, 1000);
        return ()=>{
            intervalRef.current && clearInterval(intervalRef.current);
        };
    }, []);
    return counter ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-relative rf-h-32 rf-w-32 rf-flex rf-items-center rf-justify-center rf-text-6xl rf-text-primary rf-loader-counter",
        style: {
            '--duration': `${delay}s`
        },
        children: counter
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $210a7fe3ec90b247$export$2e2bcd8739ae039 = $210a7fe3ec90b247$var$Counter;

});


parcelRegister("exvww", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e3e520daefcda3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $hdMz2 = parcelRequire("hdMz2");
const $e5e3e520daefcda3$var$NamedListAttachment = ({ value: value, title: title, history: history, height: height })=>{
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const handleClick = (valueToSend)=>{
        sendMessage(valueToSend);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded",
        style: {
            height: height
        },
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-justify-center rf-items-center rf-flex-wrap rf-gap-3 large:rf-gap-4",
                children: value.map((item, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: `${item.display === 'primary' ? 'rf-card-button-positive' : 'rf-card-button'}`,
                        onClick: history ? ()=>{} : ()=>handleClick(item.value),
                        children: item.text
                    }, key);
                })
            })
        ]
    });
};
var $e5e3e520daefcda3$export$2e2bcd8739ae039 = $e5e3e520daefcda3$var$NamedListAttachment;

});

parcelRegister("beoxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e551f8aff398c01a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $hdMz2 = parcelRequire("hdMz2");

var $lOuaH = parcelRequire("lOuaH");

var $4ZEXS = parcelRequire("4ZEXS");
const $e551f8aff398c01a$var$IFrame = ({ uri: uri, height: height, width: width, title: title, actions: actions })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const currentWidth = (0, $9JLpC.useViewStore)((state)=>state.currentWidth);
    const setModalFullscreenContent = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setModalFullscreenContent);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [documentLoaded, setDocumentLoaded] = (0, $bxRTa.useState)(false);
    const divRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(divRef);
    const processedHeight = (0, $bxRTa.useMemo)(()=>{
        if (currentHeight > currentWidth) return currentWidth > 960 ? '50%' : '100%';
        return '100%';
    }, [
        currentHeight,
        currentWidth
    ]);
    const processedWidth = (0, $bxRTa.useMemo)(()=>{
        return currentWidth > 960 ? 960 : '100%';
    }, [
        currentWidth
    ]);
    const handleClick = (value)=>{
        if (typeof value === 'string') sendMessage(value);
        else if (typeof value === 'object') sendMessage(undefined, value);
        setModalFullscreenContent(null);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        ref: divRef,
        className: `${isMobile ? '' : 'rf-py-8'} rf-flex rf-flex-col rf-justify-center`,
        style: {
            height: height || processedHeight,
            width: width || processedWidth
        },
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-py-4 rf-px-4 rf-flex rf-flex-row rf-justify-start rf-items-center rf-gap-4 rf-bg-truewhite rf-rounded-t-lg",
                children: title
            }),
            !documentLoaded && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-h-24 rf-w-24 rf-top-[calc(50%-3rem)] rf-left-[calc(50%-3rem)]",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4ZEXS.default), {
                    color: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("iframe", {
                src: uri,
                height: dimensions.height,
                width: dimensions.width,
                style: {
                    backgroundColor: '#FFF'
                },
                onLoad: ()=>setDocumentLoaded(true)
            }),
            actions?.length && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-py-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 rf-bg-truewhite rf-rounded-b-lg",
                children: actions.map((action, key)=>{
                    return key === 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-text-truewhite rf-border rf-border-[#1999B1] rf-bg-[#1999B1] hover:rf-text-[#1999B1] hover:rf-bg-transparent rf-rounded rf-py-1 large:rf-py-2 rf-px-2 large:rf-px-4 rf-text-size-auto",
                        onClick: ()=>handleClick(action.value),
                        children: action.title
                    }, key) : /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                        className: "rf-text-[#1999B1] rf-border rf-border-[#1999B1] rf-bg-transparent hover:rf-text-truewhite hover:rf-bg-[#1999B1] rf-rounded rf-py-1 large:rf-py-2 rf-px-2 large:rf-px-4 rf-text-size-auto",
                        onClick: ()=>handleClick(action.value),
                        children: action.title
                    }, key);
                })
            })
        ]
    });
};
var $e551f8aff398c01a$export$2e2bcd8739ae039 = $e551f8aff398c01a$var$IFrame;

});


parcelRegister("hC8yR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2df9ed76ce0fc2c$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $kaFO8 = parcelRequire("kaFO8");

var $k4qlo = parcelRequire("k4qlo");

var $dMIx4 = parcelRequire("dMIx4");
const $c2df9ed76ce0fc2c$var$ScrollButton = ({ direction: direction, display: display, scrollHandler: scrollHandler, className: className })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const fullScreenImage = (0, $kaFO8.default)();
    const divRef = (0, $bxRTa.useRef)(null);
    const handleClick = ()=>{
        scrollHandler(direction);
    };
    (0, $bxRTa.useLayoutEffect)(()=>{
        divRef?.current && (0, $k4qlo.default)(divRef.current);
    });
    return display && !fullScreenImage ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "ScrollButton",
        ref: divRef,
        className: className,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dMIx4.default), {
            className: `${direction === 'top' ? 'rf-rotate-0' : 'rf-rotate-180'}`,
            color: themeColors.primary
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {});
};
var $c2df9ed76ce0fc2c$export$2e2bcd8739ae039 = $c2df9ed76ce0fc2c$var$ScrollButton;

});
parcelRegister("dMIx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf7d1facde185da$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $ccf7d1facde185da$var$ScrollButtonIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        className: className,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            id: "Icon_ionic-ios-arrow-down",
            fill: color,
            className: "st0",
            d: "M 49.948 29.033 L 13.413 65.414 C 10.792 68.035 6.323 68.188 3.702 65.414 C 3.702 65.414 3.702 65.414 3.702 65.414 C 1.081 62.639 1.081 58.322 3.702 55.702 L 45.015 14.388 C 47.636 11.767 51.798 11.767 54.573 14.233 L 96.195 55.856 C 98.97 58.477 98.97 62.947 96.195 65.568 C 93.574 68.343 89.103 68.343 86.484 65.568 L 49.948 29.033 Z"
        })
    });
};
var $ccf7d1facde185da$export$2e2bcd8739ae039 = $ccf7d1facde185da$var$ScrollButtonIcon;

});



parcelRegister("lKGM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa5d0aa7ee1aa94$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4mkhB = parcelRequire("4mkhB");

var $2eBYD = parcelRequire("2eBYD");

var $hdMz2 = parcelRequire("hdMz2");

var $c5E0P = parcelRequire("c5E0P");
const $2fa5d0aa7ee1aa94$var$Suggestions = ({ className: className, suggestions: suggestions })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const { setSuggestedFilter: setSuggestedFilter } = (0, $4mkhB.useList)();
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const handleClick = (value)=>{
        setSuggestedFilter(value);
        sendMessage(undefined, {
            filters: [
                value
            ]
        });
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-items-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold rf-mb-5",
                children: translation.template.suggestiontitle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-flex-wrap",
                children: suggestions.map((suggestion, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c5E0P.default), {
                        title: suggestion.title,
                        value: suggestion.value.filter,
                        results: suggestion.value.results !== undefined ? suggestion.value.results : 'NC',
                        handleClick: handleClick
                    }, key);
                })
            })
        ]
    });
};
var $2fa5d0aa7ee1aa94$export$2e2bcd8739ae039 = $2fa5d0aa7ee1aa94$var$Suggestions;

});
parcelRegister("c5E0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f3a16356667cf2$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $eO5xw = parcelRequire("eO5xw");

var $2eBYD = parcelRequire("2eBYD");
const $f7f3a16356667cf2$var$SuggestionsItem = ({ className: className, title: title, value: value, results: results, handleClick: handleClick })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        onClick: ()=>handleClick(value),
        className: `rf-h-fit rf-px-4 rf-py-3 rf-mr-4 rf-mb-4 large-vertical:rf-py-4 rf-border rf-rounded-lg rf-bg-templateBackground rf-text-black rf-border-black hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        "aria-label": title,
        children: [
            (0, $eO5xw.capitalizeFirstLetter)(title, locale),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-6 rf-text-gray",
                children: results || 0
            })
        ]
    });
};
var $f7f3a16356667cf2$export$2e2bcd8739ae039 = $f7f3a16356667cf2$var$SuggestionsItem;

});




parcelRegister("32gH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $756ac6d40fac5b72$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hZeqH");
var $byZaD = parcelRequire("byZaD");
var $AeEPl = parcelRequire("AeEPl");
var $dvlC9 = parcelRequire("dvlC9");

var $h0yA8 = parcelRequire("h0yA8");

var $75jcl = parcelRequire("75jcl");
const $756ac6d40fac5b72$var$SubMenu = ({ background: background, onClick: onClick, children: children })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const isBorne = (0, $9JLpC.useViewStore)((state)=>state.isBorne);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !isMobile && onClick && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                zIndexClassname: "rf-z-overlay",
                onClick: onClick
            }),
            isBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $dvlC9.default), {
                className: "rf-z-menu rf-flex rf-flex-col rf-pt-[25vh] rf-pb-[15vh] rf-justify-start rf-items-center rf-shadow-[20px_3px_20px_#00000029] rf-overflow-y-scroll rf-scrollbar-hidden",
                background: background || '#FFFFFF',
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    children
                ]
            }) : isLandscape ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $byZaD.default), {
                background: background || '#FFFFFF',
                children: children
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $AeEPl.default), {
                depth: (0, $2rYkD.Depth).dropdown,
                children: children
            })
        ]
    });
};
var $756ac6d40fac5b72$export$2e2bcd8739ae039 = $756ac6d40fac5b72$var$SubMenu;

});

parcelRegister("7RuxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $63f754bc453bba15$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hZeqH");
var $32gH3 = parcelRequire("32gH3");
parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");
const $63f754bc453bba15$var$SubMenuClosing = ({ className: className, background: background, handleClose: handleClose, backIsConversation: backIsConversation, title: title, children: children })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $32gH3.default), {
        background: background,
        onClick: handleClose,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                title: backIsConversation ? translation.menu.backconversation : isMobile ? translation.common.back : translation.menu.backconversation,
                handleBack: handleClose,
                className: `rf-relative large:rf-absolute ${useOldRemote ? 'large-tactile:rf-hidden' : 'large-vertical:rf-hidden'} rf-pb-6 large:rf-left-4 large:rf-top-8 rf-text-size-auto`
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-w-full large:rf-w-fit large:rf-max-w-full large-vertical:rf-max-w-2/3 large:rf-px-6 rf-flex rf-flex-col large-vertical:rf-text-size-auto rf-overflow-y-scroll rf-scrollbar-hidden ${className}`,
                children: [
                    useOldRemote && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                        title: translation.menu.backconversation,
                        handleBack: handleClose,
                        className: "rf-hidden large-tactile:rf-flex rf-pt-4 rf-pb-6"
                    }),
                    title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "large:rf-mt-20 large-tactile:rf-mt-0 rf-mb-6 rf-title-bold-size-auto rf-font-bold",
                        children: (0, $eO5xw.capitalizeFirstLetter)(title, locale)
                    }),
                    children
                ]
            })
        ]
    });
};
var $63f754bc453bba15$export$2e2bcd8739ae039 = $63f754bc453bba15$var$SubMenuClosing;

});



parcelRegister("2nxul", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaab6ada7fdf6dbd$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $dHUeX = parcelRequire("dHUeX");

var $2rYkD = parcelRequire("2rYkD");

var $hITwk = parcelRequire("hITwk");

var $dd8py = parcelRequire("dd8py");

var $5tLSs = parcelRequire("5tLSs");
const $aaab6ada7fdf6dbd$var$Attachments = ({ activity: activity, display: display, history: history, triggerScroll: triggerScroll })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const attachments = (0, $bxRTa.useMemo)(()=>{
        return activity?.attachments?.filter((attachment)=>attachment.contentType !== (0, $dHUeX.CONTENT_TYPE_GRID_TITLE)) || [];
    }, [
        activity
    ]);
    const checkDisplay = (attachmentLayout)=>{
        if (!attachments?.length) return (0, $2rYkD.Displays).none;
        if (attachmentLayout) switch(attachmentLayout.toLowerCase()){
            case 'davilist':
                return (0, $2rYkD.Displays).none;
            case 'carousel':
            case 'namedlist':
                return attachments.length > 1 ? (0, $2rYkD.Displays).carousel : (0, $2rYkD.Displays).normal;
            case 'grid':
                // Grid display is not available in mobile mode
                return isMobile ? (0, $2rYkD.Displays).carouselgrid : (0, $2rYkD.Displays).grid;
        }
        // If we have no attachment layout but attachment(s), we use none display by default is there are several attachments
        return attachments.length > 1 ? (0, $2rYkD.Displays).none : (0, $2rYkD.Displays).normal;
    };
    const currentDisplay = (0, $bxRTa.useMemo)(()=>{
        return display || checkDisplay(activity.attachmentLayout);
    }, [
        attachments,
        display,
        isMobile
    ]);
    return currentDisplay === (0, $2rYkD.Displays).normal ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hITwk.default), {
        attachment: attachments[0],
        history: history,
        activityId: activity.id,
        triggerScroll: triggerScroll
    }) : currentDisplay === (0, $2rYkD.Displays).carousel || currentDisplay === (0, $2rYkD.Displays).carouselgrid ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dd8py.default), {
        title: activity.attachments?.find((attachment)=>attachment.contentType === (0, $dHUeX.CONTENT_TYPE_GRID_TITLE))?.content?.text,
        attachments: attachments,
        history: history,
        grid: currentDisplay === (0, $2rYkD.Displays).carouselgrid,
        showSearchBar: !!(activity.attachmentLayout?.toLowerCase() === 'namedlist' && attachments.length > 1),
        triggerScroll: triggerScroll
    }) : currentDisplay === (0, $2rYkD.Displays).grid ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5tLSs.default), {
        title: activity.attachments?.find((attachment)=>attachment.contentType === (0, $dHUeX.CONTENT_TYPE_GRID_TITLE))?.content?.text,
        attachments: attachments,
        history: history,
        triggerScroll: triggerScroll
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $aaab6ada7fdf6dbd$export$2e2bcd8739ae039 = $aaab6ada7fdf6dbd$var$Attachments;

});
parcelRegister("hITwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7269fe4cc92535$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $8HSQQ = parcelRequire("8HSQQ");

var $9GMhE = parcelRequire("9GMhE");

var $4xGiN = parcelRequire("4xGiN");
const $7f7269fe4cc92535$var$SingleCardContainer = ({ attachment: attachment, history: history, activityId: activityId, triggerScroll: triggerScroll })=>{
    const setModalFullscreenContent = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setModalFullscreenContent);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return attachment.contentType.includes('.card') ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
        className: history ? 'rf-w-full' : 'rf-w-full rf-min-w-full landscape-retorik:rf-w-[48%] landscape-retorik:rf-min-w-[48%] landscape-retorik:rf-ml-1/5 large-vertical:rf-w-3/5 large-vertical:rf-min-w-3/5 rf-max-h-full',
        children: (0, $8HSQQ.default)({
            attachment: attachment,
            history: history
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: (0, $8HSQQ.default)({
            attachment: attachment,
            history: history,
            activityId: activityId,
            setModalFullscreenContent: setModalFullscreenContent
        })
    });
};
var $7f7269fe4cc92535$export$2e2bcd8739ae039 = $7f7269fe4cc92535$var$SingleCardContainer;

});
parcelRegister("9GMhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $035a2f2fdfdba85b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $hC8yR = parcelRequire("hC8yR");
const $035a2f2fdfdba85b$var$Card = ({ children: children, className: className, shadow: shadow = false })=>{
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $bxRTa.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $bxRTa.useState)('bottom');
    const botEndRef = (0, $bxRTa.useRef)(null);
    const cardRef = (0, $bxRTa.useRef)(null);
    const scrollHandler = (to)=>{
        switch(to){
            case 'top':
                setScrollButtonDirection('bottom');
                cardRef.current?.children[1].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
            case 'bottom':
                setScrollButtonDirection('top');
                botEndRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
        }
        if (to === 'bottom') setScrollButtonDirection('top');
        else setScrollButtonDirection('bottom');
    };
    const handleScroll = ()=>{
        if (cardRef.current) {
            const parentHeight = cardRef.current.parentElement?.clientHeight;
            const scrollHeight = cardRef.current.scrollHeight;
            const scrollTop = cardRef.current.scrollTop;
            // const offsetHeight = (cardRef.current as HTMLDivElement).offsetHeight
            const clientHeight = cardRef.current.clientHeight;
            if (parentHeight && scrollHeight > parentHeight) {
                if (scrollHeight - scrollTop < clientHeight + 10) {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection('top');
                } else {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection('bottom');
                }
            } else setScrollButtonDisplay(false);
        }
    };
    /**
   * On DragStart event call :
   *  - prevent default behaviour and stop propagation of the event
   *  - this is to prevent image dragging while trying to swipe in a carousel
   * @param e : React.DragEvent
   */ const handleDragStart = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    // Check scroll at component first render
    (0, $bxRTa.useEffect)(()=>{
        const timer = setTimeout(()=>{
            handleScroll();
        }, 500);
        return ()=>timer && clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-relative rf-max-h-full rf-flex rf-flex-col rf-text-size-auto rf-unselectable ${className}`,
        draggable: true,
        onDragStart: handleDragStart,
        style: {
            pointerEvents: 'all'
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
            className: `rf-w-full rf-max-h-full rf-rounded rf-border rf-border-cardFrameBorder rf-flex rf-flex-col rf-content-around rf-justify-start ${!shadow && 'rf-overflow-y-auto rf-overflow-x-hidden'} rf-scrollbar-thin`,
            ref: cardRef,
            onScroll: ()=>handleScroll(),
            style: {
                touchAction: 'pan-y'
            },
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                    direction: scrollButtonDirection,
                    display: scrollButtonDisplay,
                    scrollHandler: scrollHandler,
                    className: "rf-absolute rf-z-ui rf-bottom-1 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                }),
                children,
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    ref: botEndRef
                })
            ]
        })
    });
};
var $035a2f2fdfdba85b$export$2e2bcd8739ae039 = $035a2f2fdfdba85b$var$Card;

});


parcelRegister("dd8py", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff93508f46094968$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $8HSQQ = parcelRequire("8HSQQ");

var $eQecn = parcelRequire("eQecn");

var $9GMhE = parcelRequire("9GMhE");

var $bFo6t = parcelRequire("bFo6t");
const $ff93508f46094968$var$CarouselContainer = ({ title: title, attachments: attachments, history: history, grid: grid, showSearchBar: showSearchBar, triggerScroll: triggerScroll })=>{
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const [height, setHeight] = (0, $bxRTa.useState)(0);
    const [elements, setElements] = (0, $bxRTa.useState)([]);
    const [forcedCurrentCardInCarousel, setForcedCurrentCardInCarousel] = (0, $bxRTa.useState)(0);
    const [carouselCardWidth, setCarouselCardWidth] = (0, $bxRTa.useState)(0);
    const timerRef = (0, $bxRTa.useRef)();
    const carouselRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useLayoutEffect)(()=>{
        setHeight(0);
        if (attachments.length) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                carouselRef.current && setHeight(carouselRef.current.clientHeight);
            }, 500);
        }
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        attachments,
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, [
        height
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const tempElements = [];
        if (showSearchBar) {
            attachments.forEach((attachment)=>{
                attachment.content?.value?.forEach((val)=>{
                    tempElements.push(val);
                });
            });
            setElements(tempElements);
        } else setElements([]);
    }, [
        attachments,
        showSearchBar
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $eQecn.default), {
                ref: carouselRef,
                history: history,
                draft: height === 0,
                grid: grid,
                gridTitle: title,
                forcedCurrentCard: forcedCurrentCardInCarousel,
                setForcedCurrentCardInCarousel: setForcedCurrentCardInCarousel,
                setCarouselCardWidth: setCarouselCardWidth,
                children: height === 0 ? attachments.map((attachment, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
                        className: "rf-w-full",
                        children: (0, $8HSQQ.default)({
                            attachment: attachment,
                            history: history
                        })
                    }, key + 100);
                }) : attachments.map((attachment, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
                        className: "rf-w-full",
                        children: (0, $8HSQQ.default)({
                            attachment: attachment,
                            history: history,
                            height: height
                        })
                    }, key);
                })
            }),
            showSearchBar && height !== 0 && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bFo6t.default), {
                elements: elements,
                elementsByCard: attachments[0].content?.value?.length,
                carouselCardWidth: carouselCardWidth,
                setCardToShow: setForcedCurrentCardInCarousel
            })
        ]
    });
};
var $ff93508f46094968$export$2e2bcd8739ae039 = $ff93508f46094968$var$CarouselContainer;

});
parcelRegister("eQecn", function(module, exports) {

$parcel$export(module.exports, "default", () => $122c41313e875e60$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $lOuaH = parcelRequire("lOuaH");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("l9TTE");
var $o9qp2 = parcelRequire("o9qp2");
var $fEfdX = parcelRequire("fEfdX");
const $122c41313e875e60$var$springEnterDuration = 1000;
// Cards' width coefficients depending on the mode and display type
const $122c41313e875e60$var$widthCoefficients = {
    mobile: 0.9,
    mobileGrid: 0.45,
    desktop: 0.48,
    borne: 0.6
};
const $122c41313e875e60$var$defaultTransitionDuration = '300ms';
const $122c41313e875e60$var$velocityBreakpoint = 0.5;
const $122c41313e875e60$var$Carousel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).forwardRef(({ direction: direction, history: history, draft: draft, grid: grid, gridTitle: gridTitle, forcedCurrentCard: forcedCurrentCard, setCarouselCardWidth: setCarouselCardWidth, setForcedCurrentCardInCarousel: setForcedCurrentCardInCarousel, children: children }, ref)=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const forceMobileView = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.forceMobileView);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentOrLastPlayedActivity = (0, $giKuE.useSpeechStore)((state)=>state.currentOrLastPlayedActivity);
    const setUserSwiping = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setUserSwiping);
    const nbCards = (0, $bxRTa.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.count(children);
    }, [
        children
    ]);
    const gap = (0, $bxRTa.useMemo)(()=>{
        return isMobile ? 0.3 : 1;
    }, [
        currentDeviceType
    ]);
    const coefficient = (0, $bxRTa.useMemo)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                return history ? $122c41313e875e60$var$widthCoefficients.mobile : $122c41313e875e60$var$widthCoefficients.desktop;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                return history ? $122c41313e875e60$var$widthCoefficients.desktop : $122c41313e875e60$var$widthCoefficients.borne;
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                return grid ? $122c41313e875e60$var$widthCoefficients.mobileGrid : $122c41313e875e60$var$widthCoefficients.mobile;
            default:
                return $122c41313e875e60$var$widthCoefficients.mobileGrid;
        }
    }, [
        mode,
        currentDeviceType,
        grid
    ]);
    const [cardWidth, setCardWidth] = (0, $bxRTa.useState)(currentDeviceType === (0, $2rYkD.DeviceType).widget || forceMobileView ? 400 * coefficient : window.innerWidth * coefficient);
    const [cardHeight, setCardHeight] = (0, $bxRTa.useState)();
    const [currentCard, setCurrentCard] = (0, $bxRTa.useState)(0);
    const [currentPadding, setCurrentPadding] = (0, $bxRTa.useState)();
    const [translation, setTranslation] = (0, $bxRTa.useState)('');
    const [transitionDuration, setTransitionDuration] = (0, $bxRTa.useState)('1ms');
    const [gridTemplateColumn, setGridTemplateColumn] = (0, $bxRTa.useState)(direction !== 'vertical' ? `repeat(${nbCards}, ${cardWidth}px)` : '');
    const [gridTemplateRow, setGridTemplateRow] = (0, $bxRTa.useState)(direction === 'vertical' ? `repeat(${nbCards}, ${cardWidth * 10 / 16}px)` : '');
    const [enableTranslation, setEnableTranslation] = (0, $bxRTa.useState)(true);
    const [wheeling, setWheeling] = (0, $bxRTa.useState)(0);
    const divRef = (0, $bxRTa.useRef)(null);
    const timerRef = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(divRef);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)'
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        !draft && api.start({
            from: {
                transform: 'translateX(100%)'
            },
            to: {
                transform: `translateX(${nbCards === 1 ? '25%' : '0%'})`
            },
            config: {
                duration: $122c41313e875e60$var$springEnterDuration,
                easing: (0, $2aMjv.easings).easeInBack
            }
        });
    }, [
        draft,
        nbCards
    ]);
    (0, $bxRTa.useEffect)(()=>{
        handleClick(forcedCurrentCard || 0);
    }, [
        forcedCurrentCard
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setForcedCurrentCardInCarousel?.(currentCard);
    }, [
        currentCard
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setCarouselCardWidth?.(cardWidth);
    }, [
        cardWidth
    ]);
    /**
     * On cards container reference, mode / currentDeviceType states change :
     *  - calculate the cards' width depending on the coefficient
     *  - calculate the cards' height depending on the width (use a 16/10 format). Only used in vertical disposition
     *  - set the currentPadding state to have centered cards in horizontal disposition
     *  - set cardWidth, cardHeight and gridTemplateRow / gridTemplateColumn (depending on direction) states
     * On component unmount :
     *  - clear timeout
     */ (0, $bxRTa.useEffect)(()=>{
        if (dimensions) {
            let newCardWidth = Math.floor(dimensions.width * coefficient);
            // Get the number of pixels contained in 1 rem multiplicated by the gap, used with grid elements
            const gapInPx = gap * parseFloat(getComputedStyle(document.documentElement).fontSize);
            if (forceMobileView && newCardWidth > 400) {
                newCardWidth = 400;
                setCurrentPadding(grid ? (dimensions.width - newCardWidth * 2 - gapInPx) / 2 : currentDeviceType === (0, $2rYkD.DeviceType).landscape || currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape ? dimensions.width / 5 : (dimensions.width - newCardWidth - 5 * (nbCards - 1)) / 2);
                if (nbCards * newCardWidth < dimensions.width) setEnableTranslation(false);
            } else setCurrentPadding(grid ? (dimensions.width - newCardWidth * 2 - gapInPx) / 2 : currentDeviceType === (0, $2rYkD.DeviceType).landscape || currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape ? dimensions.width / 5 : (1 - coefficient) * dimensions.width / 2);
            const newCardHeight = Math.ceil(newCardWidth * 10 / 16);
            // Space needed to center to cards
            // Cards' width (all dispositions) and height (only used in vertical disposition)
            setCardWidth(newCardWidth);
            setCardHeight(newCardHeight);
            direction === 'vertical' ? setGridTemplateRow(`repeat(${nbCards}, ${newCardHeight}px)`) : setGridTemplateColumn(`repeat(${nbCards}, ${newCardWidth}px)`);
            setCurrentCard(0);
        }
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        dimensions,
        coefficient,
        nbCards,
        currentDeviceType,
        currentOrLastPlayedActivity?.id
    ]);
    /**
     * On currentCard, cardWidth, cardHeight, currentPadding states change :
     *  - set translation state depending on the direction
     */ (0, $bxRTa.useEffect)(()=>{
        if (currentCard !== undefined && cardWidth !== undefined && cardHeight !== undefined && currentPadding !== undefined) direction === 'vertical' ? setTranslation(`translateY(calc(-${currentCard * cardHeight}px - ${currentCard * gap}rem))`) : setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    }, [
        currentCard,
        cardWidth,
        cardHeight,
        currentPadding
    ]);
    /**
     * On wheeling state change :
     *  - call either onSwipeRight or onSwipeLeft (with high values to enter the right part of the if condition), depending on the wheeling value (positive or negative)
     */ (0, $bxRTa.useEffect)(()=>{
        if (wheeling) wheeling > 0 ? onSwipeLeft(1000, 1000) : onSwipeRight(1000, 1000);
    }, [
        wheeling
    ]);
    /**
     * On call :
     *  - set translation to its initial state
     */ const resetPosition = ()=>{
        if (cardWidth !== undefined && currentPadding !== undefined) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    };
    /**
     * On call :
     *  - simulate a bounce effect by translating 1/10 of the width of a card in a sense, and then back
     * @param left : boolean
     */ const bounce = (left)=>{
        if (!cardWidth || currentPadding === undefined) return;
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        const direction = left ? '-' : '+';
        setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px ${direction} ${cardWidth / 10}px))`);
        if (timerRef && timerRef.current !== null) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
        }, 300);
    };
    /**
     * On call :
     *  - check if the current card is not already the last one
     *  - check the distance of the swipe, if it's higher than half a card's width, add 1 to currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, add 1 to currentCard state by 0.1 velocity over the limit, otherwise add 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeLeft = (distance, elapsedTime)=>{
        // Utils store util to show that the user is swiping
        setUserSwiping();
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        if (currentCard !== nbCards - 1 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card + 1);
            else {
                const velocityDifference = Math.round((velocity - $122c41313e875e60$var$velocityBreakpoint) * 10);
                const nextCard = currentCard + (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard < nbCards ? nextCard : nbCards - 1);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce(true) : resetPosition();
    };
    /**
     * On call :
     *  - check if the current card is not already the first one
     *  - check the distance of the swipe, if it's higher than half a card's width, substract 1 from currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, substract 1 to currentCard state by 0.1 velocity over the limit, otherwise substract 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeRight = (distance, elapsedTime)=>{
        // Utils store util to show that the user is swiping
        setUserSwiping();
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        if (currentCard !== 0 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card - 1);
            else {
                const velocityDifference = Math.round((velocity - $122c41313e875e60$var$velocityBreakpoint) * 10);
                const nextCard = currentCard - (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard >= 0 ? nextCard : 0);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce() : resetPosition();
    };
    /**
     * On call :
     *  - check if the translation is available (inside allowed bounds)
     *  - if available, set transitionDuration state to '0ms' and then update translation state to the default distance - received distance param
     * @param distance : number
     */ const onSwiping = (distance)=>{
        const available = currentCard === 0 || currentCard === nbCards - 1 ? checkSwipingAvailable(distance, gap) : true;
        if (cardWidth !== undefined) {
            setTransitionDuration('0ms');
            if (available) {
                if (currentCard !== undefined && cardHeight !== undefined && currentPadding !== undefined) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance}px))`);
            } else {
                const bounceLimit = cardWidth / 3;
                if (Math.abs(distance) <= bounceLimit / 2) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance * (1 - Math.abs(distance) / bounceLimit)}px))`);
            }
        }
    };
    /**
     * On call :
     *  - calculate the max length allowed
     *  - calculate the future length depending on the distance
     *  - check if the future length is inside the available bounds and return a boolean
     * @param distance : number
     * @param gap : number
     * @returns boolean
     */ const checkSwipingAvailable = (distance, gap)=>{
        if (currentCard !== undefined && cardWidth && currentPadding) {
            const maxLength = (nbCards - 1) * cardWidth + (nbCards - 1) * gap + currentPadding;
            const currentLength = currentCard * cardWidth + currentCard * gap * parseFloat(getComputedStyle(document.documentElement).fontSize) + currentPadding + distance;
            return !(currentLength < currentPadding || currentLength > maxLength);
        }
        return false;
    };
    /**
     * On call :
     *  - call onSwipeLeft method
     * @param distance : number
     */ const onSwipeTop = (distance, elapsedTime)=>{
        onSwipeLeft(distance, elapsedTime);
    };
    /**
     * On call :
     *  - call onSwipeRight method
     * @param distance : number
     */ const onSwipeBottom = (distance, elapsedTime)=>{
        onSwipeRight(distance, elapsedTime);
    };
    /**
     * On click event fire :
     *  - set transitionDuration state to default value
     *  - update currentCard state with the key parameter
     * @param key : number
     */ const handleClick = (key)=>{
        // Utils store util to show that the user is swiping
        setUserSwiping();
        setTransitionDuration($122c41313e875e60$var$defaultTransitionDuration);
        setCurrentCard(key);
    };
    /**
     * On wheel event fire :
     *  - check which axis has been triggered (x or y) to get its value
     *  - set wheeling state to a positive or negative unique value (here Date.now() is used as unique)
     * @param delta : number
     */ const handleWheel = (delta)=>{
        if (delta !== undefined) {
            // Utils store util to show that the user is swiping
            setUserSwiping();
            setWheeling(delta > 0 ? Date.now() : -Date.now());
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            gridTitle && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full rf-text-left rf-title-large-size-auto ${mode === (0, $2rYkD.Mode).vocal ? 'rf-text-truewhite rf-text-shadow-black' : 'rf-text-textModePanelConversationBot'}`,
                style: {
                    paddingLeft: currentPadding
                },
                children: gridTitle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                ref: divRef,
                className: "rf-w-full rf-flex rf-flex-col",
                style: {
                    visibility: draft ? 'hidden' : 'visible',
                    pointerEvents: 'all',
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fEfdX.default), {
                        className: "rf-w-full",
                        handleWheel: handleWheel,
                        xAxisOnly: true,
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $o9qp2.default), {
                            direction: direction || 'horizontal',
                            onSwiping: onSwiping,
                            onSwipeLeft: onSwipeLeft,
                            onSwipeRight: onSwipeRight,
                            onSwipeTop: onSwipeTop,
                            onSwipeBottom: onSwipeBottom,
                            className: direction === 'vertical' ? 'rf-flex rf-justify-center' : !isMobile ? history ? 'rf-opacity-gradient-l-thin' : 'rf-opacity-gradient-l' : '',
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                ref: ref,
                                className: `rf-relative ${direction === 'vertical' ? 'rf-h-max' : 'rf-w-max'} ${enableTranslation ? '' : 'rf-m-auto'} rf-transition-transform`,
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: direction === 'vertical' ? `${cardWidth}px` : gridTemplateColumn,
                                    gridTemplateRows: gridTemplateRow,
                                    gap: isMobile ? '0.3rem' : '1rem',
                                    transitionTimingFunction: 'linear',
                                    transitionDuration: transitionDuration,
                                    transform: enableTranslation ? translation : ''
                                },
                                children: children
                            })
                        })
                    }),
                    !draft && nbCards > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-full rf-py-3 rf-flex rf-flex-row rf-justify-center rf-gap-1",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.map(children, (_child, key)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                className: `rf-w-3 rf-h-3 rf-border rf-border-trueblack rf-rounded-half ${key === currentCard ? 'rf-bg-primary' : 'rf-bg-truewhite'}`,
                                onClick: ()=>handleClick(key)
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
});
var $122c41313e875e60$export$2e2bcd8739ae039 = $122c41313e875e60$var$Carousel;

});

parcelRegister("bFo6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4903addc9e983b3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
const $a4903addc9e983b3$var$remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
// Width of one item in the search bar plus the gap between items, smaller in mobile mode
const $a4903addc9e983b3$var$itemWidthForMobile = 2.5 * $a4903addc9e983b3$var$remToPx;
const $a4903addc9e983b3$var$itemWidthForLarge = 3.5 * $a4903addc9e983b3$var$remToPx;
const $a4903addc9e983b3$var$SearchBar = ({ elements: elements, elementsByCard: elementsByCard, carouselCardWidth: carouselCardWidth, setCardToShow: setCardToShow })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const [firstOfEachLetter, setFirstOfEachLetter] = (0, $bxRTa.useState)(new Map());
    const [initialsArray, setInitialsArray] = (0, $bxRTa.useState)([]);
    const [paginatedInitialsArray, setPaginatedInitialsArray] = (0, $bxRTa.useState)([]);
    const [paginationIndex, setPaginationIndex] = (0, $bxRTa.useState)(0);
    const [selectedInitial, setSelectedInitial] = (0, $bxRTa.useState)(undefined);
    const currentPaginatedInitialsArray = (0, $bxRTa.useMemo)(()=>{
        return paginatedInitialsArray[paginationIndex];
    }, [
        paginatedInitialsArray,
        paginationIndex
    ]);
    (0, $bxRTa.useEffect)(()=>{
        const tempFirstOfEachLetter = new Map();
        const tempInitialsArray = [];
        for(let i = 0; i < elements.length; i++){
            const initial = elements[i].group?.toLocaleUpperCase(locale);
            if (initial && tempFirstOfEachLetter.get(initial) === undefined) {
                tempFirstOfEachLetter.set(initial, Math.floor(i / elementsByCard));
                tempInitialsArray.push(initial);
            }
        }
        setFirstOfEachLetter(tempFirstOfEachLetter);
        setInitialsArray(tempInitialsArray);
    }, [
        elements
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (initialsArray.length && carouselCardWidth) {
            const nbMaxElements = carouselCardWidth / (isMobile ? $a4903addc9e983b3$var$itemWidthForMobile : $a4903addc9e983b3$var$itemWidthForLarge);
            if (nbMaxElements < initialsArray.length) {
                const tempArray = [];
                // Remove 2 from the length for previous / next items
                for(let i = 0; i < initialsArray.length; i += nbMaxElements - 2)tempArray.push(initialsArray.slice(i, Math.min(i + nbMaxElements - 2, initialsArray.length)));
                setPaginatedInitialsArray(tempArray);
            } else setPaginatedInitialsArray([
                initialsArray
            ]);
        }
    }, [
        initialsArray,
        carouselCardWidth,
        isMobile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setCardToShow(selectedInitial ? firstOfEachLetter.get(selectedInitial) || 0 : 0);
    }, [
        selectedInitial
    ]);
    const handleChangePagination = (getBack)=>{
        getBack ? setPaginationIndex((value)=>value - 1) : setPaginationIndex((value)=>value + 1);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-7 large:rf-h-10 rf-px-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-3",
        children: [
            paginatedInitialsArray.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-bg-cardFrameBackground rf-border rf-rounded ${paginationIndex === 0 ? 'rf-border-lightgray' : 'rf-border-cardButtonBorderDefault'}`,
                onClick: paginationIndex === 0 ? ()=>{} : ()=>handleChangePagination(true),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                    className: "rf-h-5 large:rf-h-6",
                    color: paginationIndex === 0 ? '#818181' : themeColors.card.button.text.default
                })
            }),
            currentPaginatedInitialsArray?.map((value, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                    className: `rf-h-full rf-aspect-square rf-flex rf-justify-center rf-items-center ${selectedInitial === value ? 'rf-card-button-mini-selected' : 'rf-card-button-mini'}`,
                    onClick: ()=>setSelectedInitial(selectedInitial === value ? undefined : value),
                    children: value
                }, key);
            }),
            paginatedInitialsArray.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-bg-cardFrameBackground rf-border rf-rounded ${paginationIndex === paginatedInitialsArray.length - 1 ? 'rf-border-lightgray' : 'rf-border-cardButtonBorderDefault'}`,
                onClick: paginationIndex === paginatedInitialsArray.length - 1 ? ()=>{} : ()=>handleChangePagination(false),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                    className: "rf-h-5 large:rf-h-6",
                    color: paginationIndex === paginatedInitialsArray.length - 1 ? '#818181' : themeColors.card.button.text.default
                })
            })
        ]
    });
};
var $a4903addc9e983b3$export$2e2bcd8739ae039 = $a4903addc9e983b3$var$SearchBar;

});


parcelRegister("5tLSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb4583898b96066$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $8HSQQ = parcelRequire("8HSQQ");

var $9GMhE = parcelRequire("9GMhE");

var $diOjE = parcelRequire("diOjE");
const $deb4583898b96066$var$GridContainer = ({ title: title, attachments: attachments, history: history, triggerScroll: triggerScroll })=>{
    const [qrCodeDataUrl, setQrCodeDataUrl] = (0, $bxRTa.useState)(undefined);
    const processedAttachments = (0, $bxRTa.useMemo)(()=>{
        let tempAttachments = [
            ...attachments
        ];
        tempAttachments = tempAttachments.sort((a, b)=>a.content.index - b.content.index);
        return tempAttachments;
    }, [
        attachments
    ]);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $diOjE.default), {
        title: title,
        history: history,
        qrCodeDataUrl: qrCodeDataUrl,
        setQrCodeDataUrl: setQrCodeDataUrl,
        children: processedAttachments.map((attachment, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9GMhE.default), {
                className: "rf-w-full",
                shadow: true,
                children: (0, $8HSQQ.default)({
                    attachment: attachment,
                    history: history,
                    setQrCodeData: setQrCodeDataUrl
                })
            }, key);
        })
    });
};
var $deb4583898b96066$export$2e2bcd8739ae039 = $deb4583898b96066$var$GridContainer;

});
parcelRegister("diOjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bccbcb4d04946491$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $7QU6k = parcelRequire("7QU6k");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $lOuaH = parcelRequire("lOuaH");

var $2rYkD = parcelRequire("2rYkD");

var $8e5cw = parcelRequire("8e5cw");

var $9TTQJ = parcelRequire("9TTQJ");
parcelRequire("d72S7");
var $cUlNP = parcelRequire("cUlNP");
const $bccbcb4d04946491$var$springQrCodeDuration = 500;
const $bccbcb4d04946491$var$Grid = ({ title: title, history: history, qrCodeDataUrl: qrCodeDataUrl, setQrCodeDataUrl: setQrCodeDataUrl, children: children })=>{
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const mainWidth = (0, $9JLpC.useViewStore)((state)=>state.currentWidth);
    const mainHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const clickedOnUI = (0, $4xGiN.useUtilsStore)((state)=>state.clickedOnUI);
    const setClickedOnUI = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setClickedOnUI);
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    const [classname, setClassname] = (0, $bxRTa.useState)('');
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const gridContainerRef = (0, $bxRTa.useRef)(null);
    const gridContainerDimensions = (0, $lOuaH.default)(gridContainerRef);
    const nbCards = (0, $bxRTa.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Children.count(children);
    }, [
        children
    ]);
    const rowGap = (0, $bxRTa.useMemo)(()=>{
        return gridContainerDimensions.width * 0.035;
    }, [
        gridContainerDimensions.width
    ]);
    const maxHeight = (0, $bxRTa.useMemo)(()=>{
        // 0.58 quite equals 7/12. This ratio prevents the container from overflowing vertically
        return mainHeight * 0.58;
    }, [
        mainHeight
    ]);
    const newMaxHeight = (0, $bxRTa.useMemo)(()=>{
        if (mode === (0, $2rYkD.Mode).vocal) {
            // Base positions of container on the grid are 3 -> 11 for landscape and 6 -> 11 for borne
            let start = isLandscape ? 3 : 6;
            let end = 11;
            if (typeof configuration.answerpanel === 'object') {
                start = isLandscape ? configuration.answerpanel.landscape?.containerRowStart || 3 : configuration.answerpanel.borne?.containerRowStart || 6;
                end = isLandscape ? configuration.answerpanel.landscape?.containerRowEnd || 11 : configuration.answerpanel.borne?.containerRowEnd || 11;
            }
            return 0.75 * mainHeight * (end - start) / 12;
        } else {
            // Base positions of container on the grid are 1 -> 11 for landscape and 6 -> 13 for borne
            let start = isLandscape ? 1 : 6;
            let end = isLandscape ? 11 : 13;
            if (typeof configuration.answerpanel === 'object') {
                start = isLandscape ? configuration.answerpanel.landscape?.containerRowStartText || 1 : configuration.answerpanel.borne?.containerRowStart || 6;
                end = isLandscape ? configuration.answerpanel.landscape?.containerRowEndText || 11 : configuration.answerpanel.borne?.containerRowEnd || 13;
            }
            return 0.75 * mainHeight * (end - start) / 12;
        }
    }, [
        mainHeight,
        isLandscape,
        mode,
        configuration.answerpanel
    ]);
    const [qrCodeSpring, qrCodeApi] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && qrCodeApi.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $bccbcb4d04946491$var$springQrCodeDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        qrCodeApi.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $bccbcb4d04946491$var$springQrCodeDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeDataUrl?.(undefined);
        }, $bccbcb4d04946491$var$springQrCodeDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    (0, $bxRTa.useEffect)(()=>{
        qrCodeDataUrl ? setQrCodeDataAsync(qrCodeDataUrl) : setQrCodeData(undefined);
    }, [
        qrCodeDataUrl
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // Close qrcode overlay if we click on another part of the UI
        if (clickedOnUI !== (0, $2rYkD.UIPart).none && clickedOnUI !== (0, $2rYkD.UIPart).card && clickedOnUI !== (0, $2rYkD.UIPart).qroverlay && qrCodeData) handleCloseQrCode();
    }, [
        clickedOnUI,
        qrCodeData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(nbCards){
            case 1:
            case 2:
                setClassname('rf-grid-cols-[repeat(2,30%)] rf-grid-rows-1');
                break;
            case 3:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-1' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-2');
                break;
            case 4:
                setClassname('rf-grid-cols-[repeat(2,30%)] rf-grid-rows-2');
                break;
            case 5:
            case 6:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-2' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-3');
                break;
            case 7:
            case 8:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-3' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-4');
                break;
            case 9:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? 'rf-grid-cols-[repeat(3,31%)] rf-grid-rows-3' : 'rf-grid-cols-[repeat(2,45%)] rf-grid-rows-5');
                break;
            default:
                break;
        }
    }, [
        nbCards,
        mainWidth,
        mainHeight
    ]);
    const handleClick = (e)=>{
        setClickedOnUI((0, $2rYkD.UIPart).qroverlay);
        e.stopPropagation();
        e.preventDefault();
    };
    return nbCards ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-grid",
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-w-full rf-flex rf-flex-col rf-gap-4 vertical:rf-w-9/10 ${history ? 'large-vertical:rf-w-full' : 'landscape-retorik:rf-pr-40 landscape-retorik:rf-pl-1/5 large-vertical:rf-w-3/5'} vertical:rf-items-center`,
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full ${isRTL ? 'rf-text-right' : 'rf-text-left'} rf-title-large-size-auto ${history ? 'rf-text-textModePanelConversationBot' : 'rf-text-truewhite rf-text-shadow-black'}`,
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: gridContainerRef,
                className: `rf-relative rf-w-full rf-grid rf-justify-center rf-gap-x-[3.5%] ${classname}`,
                style: {
                    maxHeight: history || mainHeight > mainWidth ? 'none' : useOldRemote ? maxHeight : newMaxHeight,
                    rowGap: rowGap
                },
                children: [
                    children,
                    qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                        className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                        style: {
                            background: 'rgba(18,18,18,0.7)',
                            ...qrCodeSpring
                        },
                        onClick: (e)=>handleClick(e),
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                                onClick: handleCloseQrCode,
                                showLabel: false
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: "rf-px-8 rf-pb-4 rf-flex rf-flex-row rf-items-center rf-gap-1 rf-italic",
                                children: [
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cUlNP.default), {
                                        color: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-w-fit rf-text-medium-size-auto",
                                        children: translation.link.scanQRTile
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                                src: qrCodeData,
                                largeMaxHeight: true
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $bccbcb4d04946491$export$2e2bcd8739ae039 = $bccbcb4d04946491$var$Grid;

});



parcelRegister("b5pvk", function(module, exports) {
module.exports = $parcel$import("6NCfb").then(()=>parcelRequire('cyTMj'));

});

parcelRegister("5vqr0", function(module, exports) {
module.exports = $parcel$import("9GKrX").then(()=>parcelRequire('bukVV'));

});

parcelRegister("f4HPR", function(module, exports) {
module.exports = $parcel$import("k0VAd").then(()=>parcelRequire('7V9hq'));

});

parcelRegister("iFNHz", function(module, exports) {
module.exports = $parcel$import("iTlMv").then(()=>parcelRequire('j1wAI'));

});

parcelRegister("VHvle", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hvc5r"),
    $parcel$import("aSHJY")
]).then(()=>parcelRequire('7JsuT'));

});

parcelRegister("6JZzf", function(module, exports) {
module.exports = $parcel$import("dqy4I").then(()=>parcelRequire('6C05u'));

});

parcelRegister("6BMly", function(module, exports) {
module.exports = $parcel$import("dDfpQ").then(()=>parcelRequire('hB7tv'));

});

parcelRegister("6hEoY", function(module, exports) {

$parcel$export(module.exports, "createNewQuestionForTimestamp", () => $ade47506c8567b6f$export$190bd3f548d0449);
const $ade47506c8567b6f$export$190bd3f548d0449 = (activity)=>{
    // Get answer's timestamp or create a new one if none present
    const timestamp = activity.localTimestamp || activity.timestamp || Date.now().toString();
    const newQuestion = {
        id: activity.replyToId || activity.id,
        type: 'message',
        text: '',
        channelData: {
            'webchat:sequence-id': 1
        },
        timestamp: timestamp,
        localTimestamp: timestamp,
        from: {
            id: 'user',
            role: 'user'
        }
    };
    return newQuestion;
};

});

parcelRegister("4Twm7", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hvc5r"),
    $parcel$import("fboBS")
]).then(()=>parcelRequire('jG5jU'));

});

parcelRegister("3i7uv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2018eeb453c43d9e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $9lyYS = parcelRequire("9lyYS");

var $1U3dy = parcelRequire("1U3dy");

var $iLzAK = parcelRequire("iLzAK");

var $37abB = parcelRequire("37abB");

var $hRvNU = parcelRequire("hRvNU");
const $2018eeb453c43d9e$var$MenuDisplayer = ({ hideMenu: hideMenu })=>{
    const menu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isBorne = (0, $9JLpC.useViewStore)((state)=>state.isBorne);
    const displayControls = (0, $9JLpC.useViewStore)((state)=>state.displayControls);
    const dashboardOpened = (0, $4xGiN.useUtilsStore)((state)=>state.dashboardOpened);
    const toggleDashboard = (0, $4xGiN.useUtilsStore)((state)=>state.actions.toggleDashboard);
    const [topOfRemote, setTopOfRemote] = (0, $bxRTa.useState)();
    return !displayControls ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1U3dy.default), {
        hideMenu: !!hideMenu
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            isBorne && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $37abB.default), {
                top: topOfRemote
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9lyYS.default), {
                hideMenu: !!hideMenu,
                setTopOfRemote: setTopOfRemote
            }),
            dashboardOpened && (menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iLzAK.default), {
                toggleDashboard: ()=>toggleDashboard(true)
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hRvNU.default), {
                toggleDashboard: ()=>toggleDashboard(true)
            }))
        ]
    });
};
var $2018eeb453c43d9e$export$2e2bcd8739ae039 = $2018eeb453c43d9e$var$MenuDisplayer;

});
parcelRegister("9lyYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $12031e58728d33c5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");

var $726gw = parcelRequire("726gw");
const $12031e58728d33c5$var$Remote = ({ hideMenu: hideMenu = false, setTopOfRemote: setTopOfRemote })=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const disableHistory = (0, $7SHCs.useRetorikStore)((state)=>state.disableHistory);
    const remoteData = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.remote);
    const menuData = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const baseMenuData = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.baseMenu);
    const customMenuData = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.customMenu);
    const containerData = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.answerpanel);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const isTactile = (0, $9JLpC.useViewStore)((state)=>state.isTactile);
    const theme = (0, $9JLpC.useViewStore)((state)=>state.theme);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const supported = (0, $2eBYD.useLocaleStore)((state)=>state.supported);
    const disableSound = (0, $giKuE.useSpeechStore)((state)=>state.disableSound);
    const setClickedOnUI = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setClickedOnUI);
    const [absoluteVerticalTop, setAbsoluteVerticalTop] = (0, $bxRTa.useState)(undefined);
    const [absoluteVerticalBottom, setAbsoluteVerticalBottom] = (0, $bxRTa.useState)(undefined);
    const [backgroundColor, setBackgroundColor] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
        switch(currentDeviceType){
            // In landscape mode, we set the default position from the bottom
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (isTactile) {
                    if (remoteData?.desktopTactile) {
                        setAbsoluteVerticalBottom(undefined);
                        setAbsoluteVerticalTop(remoteData.desktopTactile);
                    } else if (typeof containerData === 'object' && containerData.landscape?.containerRowStartText) {
                        setAbsoluteVerticalBottom(containerData.landscape.containerRowStartText * currentHeight / 12 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    } else {
                        setAbsoluteVerticalBottom(currentHeight / 6 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    }
                } else {
                    if (remoteData?.desktop) {
                        setAbsoluteVerticalBottom(undefined);
                        setAbsoluteVerticalTop(remoteData.desktop);
                    } else if (typeof containerData === 'object' && containerData.landscape?.containerRowStartText) {
                        setAbsoluteVerticalBottom(containerData.landscape.containerRowStartText * currentHeight / 12 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    } else {
                        setAbsoluteVerticalBottom(currentHeight / 6 - remToPx * 1.5);
                        setAbsoluteVerticalTop(undefined);
                    }
                }
                break;
            // In borne mode, we set the default position from the top
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                let verticalTop = 0;
                if (remoteData?.verticalTactile) verticalTop = remoteData.verticalTactile;
                else if (typeof containerData === 'object' && containerData.borne?.containerRowStart) verticalTop = containerData.borne.containerRowStart * currentHeight / 12;
                else verticalTop = 5 * currentHeight / 12;
                setAbsoluteVerticalBottom(undefined);
                setAbsoluteVerticalTop(verticalTop);
                setTopOfRemote?.(verticalTop);
                break;
        }
    }, [
        remoteData,
        containerData,
        currentHeight,
        currentDeviceType,
        isTactile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setBackgroundColor(theme === (0, $2rYkD.Theme).dark ? '#00000099' : '#FFFFFF99');
    }, [
        theme
    ]);
    const handleClick = (e)=>{
        setClickedOnUI((0, $2rYkD.UIPart).remote);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-framework-remote",
        className: "rf-absolute rf-z-[10] rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-right-6 large-vertical:rf-right-9",
        style: {
            top: absoluteVerticalTop,
            bottom: absoluteVerticalBottom
        },
        onClick: (e)=>handleClick(e),
        children: route === (0, $2rYkD.Routes).News ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).home,
                    backgroundColor: backgroundColor
                }),
                !hideMenu && (menuData?.categories?.length || customMenuData?.length || baseMenuData && baseMenuData.length > 1) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).menu,
                    backgroundColor: backgroundColor
                }),
                supported.length > 1 && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).language,
                    backgroundColor: backgroundColor
                }),
                mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).subtitles,
                    backgroundColor: backgroundColor
                }),
                !disableSound && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).sound,
                    backgroundColor: backgroundColor
                }),
                !disableHistory && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                    type: (0, $2rYkD.RemoteButtonType).history,
                    backgroundColor: backgroundColor
                })
            ]
        })
    });
};
var $12031e58728d33c5$export$2e2bcd8739ae039 = $12031e58728d33c5$var$Remote;

});
parcelRegister("726gw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d4c52f4e003340$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $4xGiN = parcelRequire("4xGiN");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("cMz42");
var $iJ1h5 = parcelRequire("iJ1h5");
var $hnSXC = parcelRequire("hnSXC");
var $gxLEu = parcelRequire("gxLEu");
var $6O1HN = parcelRequire("6O1HN");
var $l4nO8 = parcelRequire("l4nO8");
var $iqleb = parcelRequire("iqleb");
var $c5iXz = parcelRequire("c5iXz");
var $hpcDC = parcelRequire("hpcDC");
parcelRequire("dikAc");
var $9f9kU = parcelRequire("9f9kU");
parcelRequire("kMAJU");
var $04Syy = parcelRequire("04Syy");

var $2eBYD = parcelRequire("2eBYD");
const $d1d4c52f4e003340$var$RemoteButton = ({ type: type, backgroundColor: backgroundColor, cause: cause })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const theme = (0, $9JLpC.useViewStore)((state)=>state.theme);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const muted = (0, $giKuE.useSpeechStore)((state)=>state.muted);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const { setCurrentSubView: setCurrentSubView, toggleDashboard: toggleDashboard, setDashboardOpened: setDashboardOpened, setCloseDetailedPOI: setCloseDetailedPOI, setFullScreenImage: setFullScreenImage, setCloseList: setCloseList } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const { toggleMuted: toggleMuted, setActiveRecognitionState: setActiveRecognitionState, setMode: setMode } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const { toggleSubtitles: toggleSubtitles, setCanFocusSendBox: setCanFocusSendBox } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const currentSubViewRef = (0, $bxRTa.useRef)((0, $2rYkD.CurrentSubView).none);
    const [icon, setIcon] = (0, $bxRTa.useState)();
    const [label, setLabel] = (0, $bxRTa.useState)();
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const [backgroundColorHover, setBackgroundColorHover] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        currentSubViewRef.current = currentSubView;
    }, [
        currentSubView
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setBackgroundColorHover(backgroundColor?.replace('99', 'E6'));
    }, [
        backgroundColor
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(type){
            case (0, $2rYkD.RemoteButtonType).history:
                setLabel(translation.common.history);
                break;
            case (0, $2rYkD.RemoteButtonType).home:
                setLabel('home');
                break;
            case (0, $2rYkD.RemoteButtonType).language:
                setLabel(translation.common.lang);
                break;
            case (0, $2rYkD.RemoteButtonType).menu:
                setLabel(translation.common.menu);
                break;
            case (0, $2rYkD.RemoteButtonType).sound:
                setLabel(translation.common.sound);
                break;
            case (0, $2rYkD.RemoteButtonType).subtitles:
                setLabel(translation.common.subtitle);
                break;
            case (0, $2rYkD.RemoteButtonType).text:
                setLabel(translation.common.mode);
                break;
            case (0, $2rYkD.RemoteButtonType).close:
                setLabel(translation.common.close);
                break;
        }
    }, [
        type,
        translation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(type){
            case (0, $2rYkD.RemoteButtonType).history:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($iJ1h5.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).home:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($hnSXC.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).language:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($gxLEu.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).menu:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)($6O1HN.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).sound:
                setIcon(muted ? /*#__PURE__*/ (0, $fl9nK.jsx)($l4nO8.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)($iqleb.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).subtitles:
                setIcon(displaySubtitles ? /*#__PURE__*/ (0, $fl9nK.jsx)($hpcDC.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)($c5iXz.default, {
                    color: theme === (0, $2rYkD.Theme).dark ? '#FFF' : '#000'
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).text:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
                    className: "rf-w-5",
                    color: "#A4A7AF"
                }));
                break;
            case (0, $2rYkD.RemoteButtonType).close:
                setIcon(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                    className: "rf-h-8 rf-w-8",
                    color: "#000",
                    strokeWidth: 1
                }));
                break;
        }
    }, [
        type,
        theme,
        displaySubtitles,
        muted
    ]);
    const handleClick = ()=>{
        switch(type){
            case (0, $2rYkD.RemoteButtonType).history:
                if (currentSubViewRef.current === (0, $2rYkD.CurrentSubView).history) {
                    setCurrentSubView((0, $2rYkD.CurrentSubView).none);
                    sendEvent('Davi.CloseWindow', null, ()=>sendEvent('Davi.CloseWindowHistory', null));
                } else setCurrentSubView((0, $2rYkD.CurrentSubView).history);
                break;
            case (0, $2rYkD.RemoteButtonType).home:
                setCurrentSubView((0, $2rYkD.CurrentSubView).none);
                sendEvent('showHome');
                break;
            case (0, $2rYkD.RemoteButtonType).language:
                if (currentSubViewRef.current === (0, $2rYkD.CurrentSubView).languages) {
                    setCurrentSubView((0, $2rYkD.CurrentSubView).none);
                    sendEvent('Davi.CloseWindow', null, ()=>sendEvent('Davi.CloseWindowLanguages', null));
                } else setCurrentSubView((0, $2rYkD.CurrentSubView).languages);
                break;
            case (0, $2rYkD.RemoteButtonType).menu:
                toggleDashboard();
                break;
            case (0, $2rYkD.RemoteButtonType).sound:
                toggleMuted();
                break;
            case (0, $2rYkD.RemoteButtonType).subtitles:
                toggleSubtitles();
                break;
            case (0, $2rYkD.RemoteButtonType).text:
                setCanFocusSendBox(true);
                setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
                setMode((0, $2rYkD.Mode).text);
                break;
            case (0, $2rYkD.RemoteButtonType).close:
                switch(cause){
                    case (0, $2rYkD.CloseButtonCause).dashboard:
                        setDashboardOpened(false);
                        break;
                    case (0, $2rYkD.CloseButtonCause).detailedpoi:
                        setCloseDetailedPOI(true);
                        break;
                    case (0, $2rYkD.CloseButtonCause).fullscreenimage:
                        setFullScreenImage(undefined);
                        break;
                    case (0, $2rYkD.CloseButtonCause).list:
                        setCloseList(Date.now());
                        break;
                    case (0, $2rYkD.CloseButtonCause).emergency:
                    case (0, $2rYkD.CloseButtonCause).history:
                    case (0, $2rYkD.CloseButtonCause).languages:
                    case (0, $2rYkD.CloseButtonCause).weather:
                    case (0, $2rYkD.CloseButtonCause).map:
                        setCurrentSubView((0, $2rYkD.CurrentSubView).none);
                        sendEvent('Davi.CloseWindow', null, ()=>sendEvent(`Davi.CloseWindow${cause}`, null));
                        break;
                    case (0, $2rYkD.CloseButtonCause).news:
                        setRoute((0, $2rYkD.Routes).Home);
                        break;
                    case (0, $2rYkD.CloseButtonCause).none:
                    default:
                        break;
                }
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-10 rf-h-10 rf-rounded-half rf-flex rf-justify-center rf-items-center rf-cursor-pointer",
        style: {
            zIndex: type === (0, $2rYkD.RemoteButtonType).close ? 60 : 5,
            backgroundColor: hover ? backgroundColorHover : backgroundColor,
            boxShadow: type === (0, $2rYkD.RemoteButtonType).text || type === (0, $2rYkD.RemoteButtonType).close ? '0px 0px 6px #1A1A1A80' : undefined
        },
        "aria-label": label,
        // data-map used in interactive map to use this button externaly
        "data-map": type === (0, $2rYkD.RemoteButtonType).close ? 'fermer' : 'other',
        onClick: handleClick,
        onPointerEnter: ()=>setHover(true),
        onPointerLeave: ()=>setHover(false),
        children: icon
    });
};
var $d1d4c52f4e003340$export$2e2bcd8739ae039 = $d1d4c52f4e003340$var$RemoteButton;

});
parcelRegister("cMz42", function(module, exports) {

$parcel$export(module.exports, "HistoryIcon", () => (parcelRequire("iJ1h5")).default);
$parcel$export(module.exports, "HomeIcon", () => (parcelRequire("hnSXC")).default);
$parcel$export(module.exports, "LanguageIcon", () => (parcelRequire("gxLEu")).default);
$parcel$export(module.exports, "MenuIcon", () => (parcelRequire("6O1HN")).default);
$parcel$export(module.exports, "SoundOffIcon", () => (parcelRequire("l4nO8")).default);
$parcel$export(module.exports, "SoundOnIcon", () => (parcelRequire("iqleb")).default);
$parcel$export(module.exports, "SubtitlesOffIcon", () => (parcelRequire("c5iXz")).default);
$parcel$export(module.exports, "SubtitlesOnIcon", () => (parcelRequire("hpcDC")).default);

var $iJ1h5 = parcelRequire("iJ1h5");

var $hnSXC = parcelRequire("hnSXC");

var $gxLEu = parcelRequire("gxLEu");

var $6O1HN = parcelRequire("6O1HN");

var $l4nO8 = parcelRequire("l4nO8");

var $iqleb = parcelRequire("iqleb");

var $c5iXz = parcelRequire("c5iXz");

var $hpcDC = parcelRequire("hpcDC");

});
parcelRegister("iJ1h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $04141648ecd3fad1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $04141648ecd3fad1$var$HistoryIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19.4 19.401",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-77.528 -79.501)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M378.724,244.778a.614.614,0,0,0-1.227,0v3.891l2.453,2.453a.614.614,0,1,0,.868-.868l-2.093-2.093Z",
                    transform: "translate(-290.737 -159.395)",
                    fill: color || '#FFF'
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M94.055,82.374A9.73,9.73,0,0,0,87.189,79.5a9.544,9.544,0,0,0-6.848,2.8l-.127.127,0-.93a.677.677,0,0,0-.677-.673h0a.677.677,0,0,0-.673.68l.013,2.552a.679.679,0,0,0,.673.673l2.552.013a.677.677,0,0,0,.007-1.354l-.93,0,.128-.128a8.2,8.2,0,0,1,5.884-2.408,8.457,8.457,0,0,1,8.392,8.4,8.238,8.238,0,0,1-8.3,8.3,8.44,8.44,0,0,1-8.318-9.575.678.678,0,0,0-.579-.762.688.688,0,0,0-.093-.006.677.677,0,0,0-.669.585A9.806,9.806,0,0,0,87.27,98.9h.051a9.591,9.591,0,0,0,9.607-9.658A9.73,9.73,0,0,0,94.055,82.374Z",
                    fill: color || '#FFF'
                })
            ]
        })
    });
};
var $04141648ecd3fad1$export$2e2bcd8739ae039 = $04141648ecd3fad1$var$HistoryIcon;

});

parcelRegister("hnSXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e5d3ddaa1d3e5b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $f4e5d3ddaa1d3e5b$var$HomeIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.875 17.044",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M13.721,3.5V4.9l1.663,1.33V3.5Zm2.91,3.733V3.289A1.039,1.039,0,0,0,15.592,2.25H13.513a1.039,1.039,0,0,0-1.039,1.039V3.9l-.339-.271a3.118,3.118,0,0,0-3.9,0l-6.756,5.4a.624.624,0,0,0,.779.974l.65-.52v8.555H1.874a.624.624,0,0,0,0,1.247H18.5a.624.624,0,1,0,0-1.247H17.462V9.492l.65.52a.624.624,0,0,0,.779-.974Zm-.416,1.265L11.356,4.607a1.871,1.871,0,0,0-2.337,0L4.16,8.494v9.552H7.07V14.472a11.466,11.466,0,0,1,.051-1.41,1.7,1.7,0,0,1,1.615-1.615,11.468,11.468,0,0,1,1.41-.051h.082a11.469,11.469,0,0,1,1.41.051,1.7,1.7,0,0,1,1.615,1.615,11.451,11.451,0,0,1,.051,1.41v3.574h2.91Zm-4.157,9.552V14.513a10.966,10.966,0,0,0-.04-1.285c-.036-.27-.1-.355-.143-.4s-.132-.106-.4-.143a10.966,10.966,0,0,0-1.285-.04,10.964,10.964,0,0,0-1.285.04c-.27.036-.355.1-.4.143s-.106.132-.143.4a10.957,10.957,0,0,0-.04,1.285v3.533ZM10.187,7.238a1.039,1.039,0,1,0,1.039,1.039A1.039,1.039,0,0,0,10.187,7.238ZM7.9,8.278a2.286,2.286,0,1,1,2.286,2.286A2.286,2.286,0,0,1,7.9,8.278Z",
            transform: "translate(-1.25 -2.25)",
            fill: color || "#FFF",
            fillRule: "evenodd"
        })
    });
};
var $f4e5d3ddaa1d3e5b$export$2e2bcd8739ae039 = $f4e5d3ddaa1d3e5b$var$HomeIcon;

});

parcelRegister("gxLEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8361783ffd12eac$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $d8361783ffd12eac$var$LanguageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.578 17.581",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(0)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M16.861,8.789V2.572A2.072,2.072,0,0,0,14.789.5H8.572A2.072,2.072,0,0,0,6.5,2.572V8.789a2.072,2.072,0,0,0,2.072,2.072h6.217A2.072,2.072,0,0,0,16.861,8.789Z",
                    transform: "translate(0.217)",
                    fill: "none",
                    stroke: color || '#FFF',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M4.645,6.5H2.572A2.072,2.072,0,0,0,.5,8.576v6.216a2.072,2.072,0,0,0,2.072,2.072h0l6.217-.011a2.072,2.072,0,0,0,2.069-2.072V12.717",
                    transform: "translate(0 0.217)",
                    fill: "none",
                    stroke: color || '#FFF',
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(2.572 10.864)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M3.106,1H0",
                            transform: "translate(0.002 -1.003)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M4.625,2.5,3.589,3.536A11.99,11.99,0,0,1,1,5.09",
                            transform: "translate(0.038 -0.949)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M1,1A4.739,4.739,0,0,0,2.553,3.592a17.063,17.063,0,0,0,2.59,1.553",
                            transform: "translate(0.038 -1.003)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(8.789 2.572)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M3.108,0,0,6.217",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M3,0,6.108,6.217",
                            transform: "translate(0.108)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                            d: "M0,0V4.145",
                            transform: "translate(5.181 4.145) rotate(90)",
                            fill: "none",
                            stroke: color || '#FFF',
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            fillRule: "evenodd"
                        })
                    ]
                })
            ]
        })
    });
};
var $d8361783ffd12eac$export$2e2bcd8739ae039 = $d8361783ffd12eac$var$LanguageIcon;

});

parcelRegister("6O1HN", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d1b4923df236f5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $74d1b4923df236f5$var$MenuIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.2 11.2",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M4,17H20M4,12H20M4,7H20",
            transform: "translate(-3.4 -6.4)",
            fill: "none",
            stroke: color || '#FFF',
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2"
        })
    });
};
var $74d1b4923df236f5$export$2e2bcd8739ae039 = $74d1b4923df236f5$var$MenuIcon;

});

parcelRegister("l4nO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7fe1e46a348d70$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $bf7fe1e46a348d70$var$SoundOffIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 15.106",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M4.069,12.039l.3-.5-.138-.083H4.069Zm0-6.972v.581H4.23l.138-.083ZM9.883,1.581h.581a.581.581,0,0,0-.88-.5Zm0,13.943-.3.5a.581.581,0,0,0,.88-.5ZM13.3,6.5l-.411-.411-.822.822.411.411Zm2.466,4.108.411.411L17,10.2l-.411-.411Zm.822-3.286L17,6.91l-.822-.822-.411.411Zm-4.11,2.464-.411.411.822.822.411-.411ZM4.069,11.457H1.744V12.62H4.069Zm-2.325,0a.58.58,0,0,1-.581-.581H0A1.743,1.743,0,0,0,1.744,12.62Zm-.581-.581V6.229H0v4.648Zm0-4.648a.58.58,0,0,1,.581-.58V4.486A1.743,1.743,0,0,0,0,6.229Zm.581-.58H4.069V4.486H1.744Zm2.624-.083L10.182,2.08l-.6-1L3.77,4.569ZM9.3,1.581V15.525h1.163V1.581Zm.88,13.445L4.368,11.54l-.6,1,5.813,3.486Zm2.3-7.7,3.288,3.286.822-.822L13.3,6.5ZM15.767,6.5,12.479,9.785l.822.822,3.288-3.286Z",
            transform: "translate(0 -1)",
            fill: color || '#FFF'
        })
    });
};
var $bf7fe1e46a348d70$export$2e2bcd8739ae039 = $bf7fe1e46a348d70$var$SoundOffIcon;

});

parcelRegister("iqleb", function(module, exports) {

$parcel$export(module.exports, "default", () => $36869e013bd47b79$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $36869e013bd47b79$var$SoundOnIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 14.724",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
            d: "M3.967,11.76l.291-.486-.135-.081H3.967Zm0-6.8v.567h.157l.135-.081Zm5.667-3.4H10.2a.567.567,0,0,0-.858-.486Zm0,13.591-.291.486a.567.567,0,0,0,.858-.486ZM15.7,4.564l-.4-.4-.8.8.4.4Zm-.8,6.8-.4.4.8.8.4-.4ZM3.967,11.193H1.7v1.133H3.967Zm-2.267,0a.566.566,0,0,1-.567-.566H0a1.7,1.7,0,0,0,1.7,1.7Zm-.567-.566V6.1H0v4.53Zm0-4.53A.566.566,0,0,1,1.7,5.531V4.4A1.7,1.7,0,0,0,0,6.1ZM1.7,5.531H3.967V4.4H1.7ZM4.258,5.45l5.667-3.4-.583-.972-5.667,3.4ZM9.067,1.567V15.158H10.2V1.567Zm.858,13.105-5.667-3.4-.583.972,5.667,3.4ZM15.3,4.964l-.4.4h0l0,0,.023.025c.022.025.057.067.1.126a3.611,3.611,0,0,1,.336.55,5.086,5.086,0,0,1,.507,2.295H17a6.217,6.217,0,0,0-.627-2.8,4.757,4.757,0,0,0-.443-.724c-.062-.083-.115-.147-.155-.192l-.049-.054-.016-.017L15.7,4.568l0,0h0Zm.567,3.4a5.086,5.086,0,0,1-.507,2.295,3.609,3.609,0,0,1-.336.55c-.044.059-.079.1-.1.126l-.023.025,0,0h0l.4.4.4.4h0l0,0,.006-.006.016-.017.049-.054c.04-.045.093-.11.155-.192a4.764,4.764,0,0,0,.443-.724A6.216,6.216,0,0,0,17,8.362Z",
            transform: "translate(0 -1)",
            fill: color || '#FFF'
        })
    });
};
var $36869e013bd47b79$export$2e2bcd8739ae039 = $36869e013bd47b79$var$SoundOnIcon;

});

parcelRegister("c5iXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd031e8c6745d61a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $cd031e8c6745d61a$var$SubtitlesOffIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.088 17.088",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-41.7 -41.7)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M521.309,212.887v.016l.016-.016Z",
                    transform: "translate(-468.172 -167.105)",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M42.892,52.629V47.859c0-1.866.355-3.089,1.116-3.851s1.985-1.116,3.851-1.116h4.769a7.124,7.124,0,0,1,2.926.488l.886-.886a7.6,7.6,0,0,0-3.812-.795H47.859c-2.2,0-3.694.466-4.694,1.466S41.7,45.657,41.7,47.859v4.769a7.6,7.6,0,0,0,.794,3.812l.886-.886A7.129,7.129,0,0,1,42.892,52.629Z",
                    transform: "translate(0 0)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M157.118,147.4v4.769c0,1.865-.355,3.088-1.116,3.85s-1.986,1.117-3.851,1.117h-4.769a7.333,7.333,0,0,1-2.835-.448l-.893.893a7.745,7.745,0,0,0,3.728.747h4.769c2.2,0,3.694-.466,4.694-1.467s1.466-2.491,1.466-4.693V147.4a7.741,7.741,0,0,0-.747-3.728l-.893.893A7.328,7.328,0,0,1,157.118,147.4Z",
                    transform: "translate(-99.522 -99.537)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M498.667,572.3H497.2a.6.6,0,1,0,0,1.192h1.471a.6.6,0,0,0,0-1.192Z",
                    transform: "translate(-444.052 -517.947)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M252.716,573.492a.6.6,0,1,0,0-1.192h-3.195l-1.192,1.192Z",
                    transform: "translate(-201.702 -517.947)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M375.711,464.192h4.395a.6.6,0,0,0,0-1.192h-4.189l-.775.775A.6.6,0,0,0,375.711,464.192Z",
                    transform: "translate(-325.491 -411.254)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M192.3,463a.6.6,0,1,0,0,1.192h.123L193.612,463Z",
                    transform: "translate(-146.423 -411.254)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M201.268,170.421a1.643,1.643,0,0,0-.113-.636,1.6,1.6,0,0,0-.3-.469,1.926,1.926,0,0,0-.418-.342,4.719,4.719,0,0,0-.479-.256q-.244-.113-.479-.213a3.17,3.17,0,0,1-.42-.216,1.057,1.057,0,0,1-.3-.263.568.568,0,0,1-.11-.35.683.683,0,0,1,.049-.258.537.537,0,0,1,.15-.209.728.728,0,0,1,.251-.136,1.131,1.131,0,0,1,.352-.049,1.679,1.679,0,0,1,.474.063,2.633,2.633,0,0,1,.38.141q.164.077.277.143a.391.391,0,0,0,.164.066.116.116,0,0,0,.082-.028.185.185,0,0,0,.047-.089.858.858,0,0,0,.023-.155q.007-.094.007-.23t0-.2a.906.906,0,0,0-.016-.136.378.378,0,0,0-.028-.087.342.342,0,0,0-.063-.08.784.784,0,0,0-.192-.117,2.258,2.258,0,0,0-.333-.127,2.956,2.956,0,0,0-.4-.089,2.873,2.873,0,0,0-.432-.033,2.832,2.832,0,0,0-.791.108,1.858,1.858,0,0,0-.647.326,1.573,1.573,0,0,0-.436.549,1.725,1.725,0,0,0-.162.767,1.7,1.7,0,0,0,.113.652,1.612,1.612,0,0,0,.293.472,1.916,1.916,0,0,0,.411.342,4.315,4.315,0,0,0,.474.256q.244.113.474.213a3.055,3.055,0,0,1,.41.216,1.118,1.118,0,0,1,.293.263.567.567,0,0,1,.113.354.778.778,0,0,1-.066.324.647.647,0,0,1-.19.244.9.9,0,0,1-.3.152,1.392,1.392,0,0,1-.4.054,2.12,2.12,0,0,1-.6-.077,2.773,2.773,0,0,1-.448-.171,3.253,3.253,0,0,1-.307-.171.39.39,0,0,0-.185-.077.135.135,0,0,0-.082.026.175.175,0,0,0-.056.087.7.7,0,0,0-.031.16q-.009.1-.009.244a1.606,1.606,0,0,0,.026.331.351.351,0,0,0,.087.176.992.992,0,0,0,.2.141,2.076,2.076,0,0,0,.345.152,3.319,3.319,0,0,0,.476.124,3.112,3.112,0,0,0,.584.052,3.033,3.033,0,0,0,.873-.122c.054-.016.107-.034.158-.054l1.123-1.123A2.02,2.02,0,0,0,201.268,170.421Z",
                    transform: "translate(-151.893 -121.397)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M400.9,171.6h.016l1.009-1.009h-3.783a.125.125,0,0,0-.08.026.2.2,0,0,0-.056.084.633.633,0,0,0-.035.157,2.07,2.07,0,0,0-.012.239,1.958,1.958,0,0,0,.012.232.627.627,0,0,0,.035.155.219.219,0,0,0,.056.087.118.118,0,0,0,.08.028h1.52v1.254l1.239-1.239Z",
                    transform: "translate(-347.759 -125.815)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M469.37,350.961a.13.13,0,0,0,.03.085.214.214,0,0,0,.1.061.991.991,0,0,0,.19.038,3.161,3.161,0,0,0,.6,0,.991.991,0,0,0,.19-.038.214.214,0,0,0,.1-.061.13.13,0,0,0,.03-.085v-1.64l-1.239,1.239Z",
                    transform: "translate(-417.472 -300.285)",
                    fill: color || "#FFF"
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                    d: "M61.748,46.575a.6.6,0,0,0-.843,0l-.817.817-.855.855L57.983,49.5l-.873.873-.792.792L55.08,52.4l-3.934,3.934-1.192,1.192-3.114,3.114-.855.855-.851.851a.6.6,0,0,0,.843.843l.86-.86.859-.859,1.338-1.338,1.192-1.192,4.854-4.854,1.239-1.239L60.063,49.1l.859-.859.826-.826A.6.6,0,0,0,61.748,46.575Z",
                    transform: "translate(-3.181 -4.588)",
                    fill: color || "#FFF"
                })
            ]
        })
    });
};
var $cd031e8c6745d61a$export$2e2bcd8739ae039 = $cd031e8c6745d61a$var$SubtitlesOffIcon;

});

parcelRegister("hpcDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc63bf9d31d20a8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $fbc63bf9d31d20a8$var$SubtitlesOnIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 17",
        className: className || 'rf-w-4 rf-h-4',
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
            transform: "translate(-41.7 -41.7)",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(41.7 41.7)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M52.572,58.7H47.828c-2.191,0-3.675-.463-4.67-1.458S41.7,54.763,41.7,52.572V47.828c0-2.191.463-3.675,1.458-4.67s2.479-1.458,4.67-1.458h4.745c2.19,0,3.674.463,4.669,1.458s1.459,2.479,1.459,4.67v4.745c0,2.19-.463,3.674-1.458,4.669S54.763,58.7,52.572,58.7ZM47.828,42.886c-1.856,0-3.073.353-3.831,1.111s-1.111,1.975-1.111,3.831v4.745c0,1.856.353,3.073,1.111,3.831s1.975,1.111,3.831,1.111h4.745c1.856,0,3.073-.353,3.831-1.111s1.111-1.975,1.111-3.83V47.828c0-1.856-.353-3.073-1.111-3.831s-1.975-1.111-3.83-1.111Z",
                        transform: "translate(-41.7 -41.7)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(52.486 54.285)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M498.663,573.49h-1.468a.595.595,0,0,1,0-1.19h1.468a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-496.6 -572.3)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(45.252 54.285)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M197.425,573.49h-5.13a.595.595,0,1,1,0-1.19h5.13a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-191.7 -572.3)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(49.572 51.692)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M378.98,464.19h-4.385a.595.595,0,1,1,0-1.19h4.385a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-374 -463)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                    transform: "translate(45.256 51.692)",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                        d: "M194.491,464.19h-2.2a.595.595,0,1,1,0-1.19h2.2a.595.595,0,1,1,0,1.19Z",
                        transform: "translate(-191.7 -463)",
                        fill: color || '#FFF'
                    })
                }),
                /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    transform: "translate(45.373 44.636)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                            transform: "translate(0 0)",
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                d: "M201.06,170.057a1.863,1.863,0,0,1-.178.838,1.734,1.734,0,0,1-.483.6,2.072,2.072,0,0,1-.711.362,3.033,3.033,0,0,1-.871.121,2.983,2.983,0,0,1-.583-.052,3.353,3.353,0,0,1-.476-.124,2.089,2.089,0,0,1-.345-.152.958.958,0,0,1-.2-.14.35.35,0,0,1-.086-.176A1.631,1.631,0,0,1,197.1,171a2.307,2.307,0,0,1,.01-.243.725.725,0,0,1,.031-.159.169.169,0,0,1,.057-.086.137.137,0,0,1,.081-.026.411.411,0,0,1,.186.076,2.746,2.746,0,0,0,.307.171,2.851,2.851,0,0,0,.447.171,2.091,2.091,0,0,0,.6.076,1.393,1.393,0,0,0,.4-.055.88.88,0,0,0,.3-.152.675.675,0,0,0,.19-.243.8.8,0,0,0,.067-.324.578.578,0,0,0-.112-.355,1.085,1.085,0,0,0-.293-.262,3.438,3.438,0,0,0-.409-.217c-.152-.067-.312-.138-.474-.214a4.334,4.334,0,0,1-.474-.255,1.887,1.887,0,0,1-.409-.343,1.626,1.626,0,0,1-.293-.471,1.717,1.717,0,0,1-.112-.65,1.737,1.737,0,0,1,.162-.766,1.565,1.565,0,0,1,.435-.547,1.852,1.852,0,0,1,.645-.326,2.841,2.841,0,0,1,.79-.107,2.918,2.918,0,0,1,.431.033,3.135,3.135,0,0,1,.4.088,2.328,2.328,0,0,1,.333.126.8.8,0,0,1,.193.117.388.388,0,0,1,.064.079.3.3,0,0,1,.029.086.876.876,0,0,1,.017.136c0,.055,0,.121,0,.2s0,.167-.007.228a.787.787,0,0,1-.024.155.171.171,0,0,1-.048.088.116.116,0,0,1-.081.029.388.388,0,0,1-.164-.067c-.074-.043-.167-.09-.276-.143a2.642,2.642,0,0,0-.378-.14,1.651,1.651,0,0,0-.474-.064,1.123,1.123,0,0,0-.352.05.737.737,0,0,0-.25.136.53.53,0,0,0-.15.209.668.668,0,0,0-.05.257.572.572,0,0,0,.109.35,1.061,1.061,0,0,0,.3.262,3.117,3.117,0,0,0,.419.214c.157.067.314.138.478.214a4.631,4.631,0,0,1,.478.255,1.871,1.871,0,0,1,.416.343,1.619,1.619,0,0,1,.3.469A1.762,1.762,0,0,1,201.06,170.057Z",
                                transform: "translate(-197.1 -165.7)",
                                fill: color || '#FFF'
                            })
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                            transform: "translate(4.778 0.119)",
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)("path", {
                                d: "M402.535,171.2a2.054,2.054,0,0,1-.012.231.548.548,0,0,1-.036.155.2.2,0,0,1-.06.086.122.122,0,0,1-.076.029h-1.516v4.883a.121.121,0,0,1-.031.083.225.225,0,0,1-.1.062.918.918,0,0,1-.19.038,2.557,2.557,0,0,1-.3.014,2.588,2.588,0,0,1-.3-.014.917.917,0,0,1-.19-.038.2.2,0,0,1-.1-.062.121.121,0,0,1-.031-.083V171.7h-1.516a.114.114,0,0,1-.078-.029.244.244,0,0,1-.057-.086.648.648,0,0,1-.036-.155,2.1,2.1,0,0,1-.012-.231,2.211,2.211,0,0,1,.012-.238.569.569,0,0,1,.036-.157.19.19,0,0,1,.057-.083.125.125,0,0,1,.078-.026h4.269a.123.123,0,0,1,.076.026.193.193,0,0,1,.06.083.644.644,0,0,1,.036.157A1.683,1.683,0,0,1,402.535,171.2Z",
                                transform: "translate(-397.9 -170.7)",
                                fill: color || '#FFF'
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $fbc63bf9d31d20a8$export$2e2bcd8739ae039 = $fbc63bf9d31d20a8$var$SubtitlesOnIcon;

});




parcelRegister("1U3dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d10767699fc70d76$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hZeqH");
var $6Vbk7 = parcelRequire("6Vbk7");

var $fQnPZ = parcelRequire("fQnPZ");

var $kq8jt = parcelRequire("kq8jt");
const $d10767699fc70d76$var$MobileContainer = ({ hideMenu: hideMenu })=>{
    const dashboardOpened = (0, $4xGiN.useUtilsStore)((state)=>state.dashboardOpened);
    const { setCurrentSubView: setCurrentSubView, setDashboardOpened: setDashboardOpened } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const toggleParameters = ()=>{
        setCurrentSubView((0, $2rYkD.CurrentSubView).none);
        setDashboardOpened(!dashboardOpened);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Vbk7.default), {
        className: "large:rf-hidden rf-p-0 rf-m-0 rf-flex rf-flex-col-reverse rf-pointer-events-none vertical:rf-row-start-0 vertical:rf-row-end-13",
        depth: (0, $2rYkD.Depth).ui,
        background: "transparent",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fQnPZ.default), {
                parametersOpened: dashboardOpened,
                toggleParameters: toggleParameters
            }),
            dashboardOpened && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kq8jt.default), {
                handleBack: toggleParameters,
                hideMenu: hideMenu
            })
        ]
    });
};
var $d10767699fc70d76$export$2e2bcd8739ae039 = $d10767699fc70d76$var$MobileContainer;

});
parcelRegister("fQnPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae9aa21ccb925fe$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");

var $dq6kU = parcelRequire("dq6kU");

var $hvWkK = parcelRequire("hvWkK");

var $4BCpK = parcelRequire("4BCpK");

var $2QZab = parcelRequire("2QZab");
const $9ae9aa21ccb925fe$var$Mobile = ({ parametersOpened: parametersOpened, toggleParameters: toggleParameters })=>{
    const hideMenu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.hideMenu);
    const disabledSpeechMode = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.disableSpeechMode);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const appAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.appAvailable);
    const { setActiveRecognitionState: setActiveRecognitionState, setMode: setMode } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const { setFromTextToVocal: setFromTextToVocal, setCanFocusSendBox: setCanFocusSendBox } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const toggleMode = (newMode)=>{
        // If the parameters are opened, no action
        if (!parametersOpened) {
            if (newMode === (0, $2rYkD.Mode).text) {
                setCanFocusSendBox(true);
                setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
            } else setFromTextToVocal(true);
            setMode(newMode);
        }
    };
    const handleDashboardClick = ()=>{
        toggleParameters();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-menu",
        className: "rf-w-full rf-h-fit rf-max-h-80 rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto",
        style: {
            background: 'linear-gradient(to right, #F8F8FC, #EDEEF3)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-w-full rf-grid rf-flex-1 rf-h-full ${!disabledSpeechMode ? hideMenu ? 'rf-grid-cols-2' : 'rf-grid-cols-3' : hideMenu ? 'rf-grid-cols-1' : 'rf-grid-cols-2'} rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4BCpK.default), {
                        label: "text",
                        selected: parametersOpened ? false : mode === (0, $2rYkD.Mode).text,
                        onClick: toggleMode
                    }),
                    !disabledSpeechMode && (mode === (0, $2rYkD.Mode).vocal ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-py-2 rf-w-full rf-flex rf-justify-center",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2QZab.default), {})
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4BCpK.default), {
                        label: "vocal",
                        selected: false,
                        onClick: toggleMode
                    })),
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4BCpK.default), {
                        label: "dashboard",
                        selected: parametersOpened,
                        onClick: handleDashboardClick
                    })
                ]
            }),
            !parametersOpened && mode === (0, $2rYkD.Mode).text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {
                className: "rf-mx-4 rf-mt-2"
            }),
            appAvailable && !parametersOpened && mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hvWkK.default), {
                className: "rf-w-full rf-px-6 rf-py-2 rf-text-center"
            })
        ]
    });
};
var $9ae9aa21ccb925fe$export$2e2bcd8739ae039 = $9ae9aa21ccb925fe$var$Mobile;

});
parcelRegister("dq6kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f69347d44792da5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $4xGiN = parcelRequire("4xGiN");

var $giKuE = parcelRequire("giKuE");

var $hdMz2 = parcelRequire("hdMz2");
parcelRequire("kMAJU");
var $byrzf = parcelRequire("byrzf");
var $lvWyY = parcelRequire("lvWyY");
parcelRequire("dikAc");
var $jWbjz = parcelRequire("jWbjz");

var $2rYkD = parcelRequire("2rYkD");
const $0f69347d44792da5$var$SendTextBox = ({ className: className })=>{
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const disabledSpeechMode = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.disableSpeechMode);
    const canFocusSendBox = (0, $7SHCs.useRetorikStore)((state)=>state.canFocusSendBox);
    const preventVirtualKeyboard = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.preventVirtualKeyboard);
    const sendBoxPlaceHolder = (0, $7SHCs.useRetorikStore)((state)=>state.sendBoxPlaceHolder);
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const setUserTyping = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setUserTyping);
    const { setSendBoxRef: setSendBoxRef, setFromTextToVocal: setFromTextToVocal } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const setMode = (0, $giKuE.useSpeechStore)((state)=>state.actions.setMode);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [height, setHeight] = (0, $bxRTa.useState)();
    const [message, setMessage] = (0, $bxRTa.useState)('');
    const timerRef = (0, $bxRTa.useRef)(null);
    const textareaRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (canFocusSendBox && textareaRef.current && document.activeElement !== textareaRef.current) textareaRef.current.focus();
    }, [
        textareaRef,
        canFocusSendBox
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (textareaRef.current) {
            setSendBoxRef(textareaRef.current);
            // Add focusin event to open virtual keyboard if it isn't disabled
            !preventVirtualKeyboard && textareaRef.current.addEventListener('focusin', ()=>navigator.virtualKeyboard?.show());
            textareaRef.current.addEventListener('focusout', ()=>setUserTyping(false));
        }
        return ()=>{
            setUserTyping(false);
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, [
        preventVirtualKeyboard,
        textareaRef
    ]);
    const handleMessageChange = ()=>{
        timerRef?.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            setUserTyping(false);
        }, 1000);
    };
    const handleChange = (e)=>{
        setUserTyping(true);
        handleMessageChange();
        setMessage(e.currentTarget.value);
        textareaRef?.current && setHeight(`${textareaRef.current.scrollHeight}px`);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' || e.key === 'NumpadEnter') {
            e.preventDefault();
            e.stopPropagation();
            handleSend();
        }
    };
    const handleSend = ()=>{
        if (message?.length) {
            sendMessage(message);
            setMessage('');
            setHeight(undefined);
            timerRef?.current && clearTimeout(timerRef.current);
            setUserTyping(false);
        }
    };
    const handleClick = ()=>{
        setFromTextToVocal(true);
        setMode((0, $2rYkD.Mode).vocal);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-send-textbox",
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-relative rf-min-h-12 rf-px-4 rf-text-base rf-pt-3 rf-pb-3 rf-flex rf-items-center rf-border rf-border-textBoxBorder rf-rounded-8 rf-bg-truewhite rf-shadow-[inset_0_0_6px_#0000003B] ${className}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("textarea", {
                ref: textareaRef,
                // @ts-ignore
                virtualkeyboardpolicy: "manual",
                className: `rf-input-hidden rf-outline-none rf-max-h-full rf-overflow-y-clip rf-bg-truewhite rf-w-[calc(100%-4rem)] rf-resize-none rf-scrollbar-hidden ${isMobile && 'placeholder:rf-text-black placeholder:rf-opacity-100'}`,
                value: message,
                placeholder: sendBoxPlaceHolder || translation.menu.message,
                onKeyDown: (e)=>handleKeyDown(e),
                onChange: (e)=>handleChange(e),
                style: {
                    height: height || '1.5rem'
                }
            }),
            !isMobile && !disabledSpeechMode && !useOldRemote && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: `rf-absolute ${isRTL ? 'rf-left-12' : 'rf-right-12'} rf-h-full rf-w-8 rf-flex rf-justify-center rf-items-center`,
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
                    className: "rf-h-4 large-vertical:rf-h-5",
                    color: '#00000080'
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: `rf-absolute ${isRTL ? 'rf-left-2' : 'rf-right-2'} rf-h-8 rf-w-8 rf-pt-1 rf-pr-1 rf-flex rf-justify-center rf-items-center rf-border rf-border-secondary rf-bg-secondary rf-rounded-half`,
                onClick: handleSend,
                children: isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lvWyY.default), {
                    className: "rf-w-5",
                    color: "#FFF"
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $byrzf.default), {
                    className: "rf-w-5",
                    color: "#FFF"
                })
            })
        ]
    });
};
var $0f69347d44792da5$export$2e2bcd8739ae039 = $0f69347d44792da5$var$SendTextBox;

});

parcelRegister("hvWkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b82f579358ff4d3$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");

var $gQoxd = parcelRequire("gQoxd");

var $37abB = parcelRequire("37abB");
const $9b82f579358ff4d3$var$springDuration = 1050;
// Unicode Spaces found here : https://www.fileformat.info/info/unicode/category/Zs/list.htm
const $9b82f579358ff4d3$var$spacingCharacters = [
    '\u0020',
    '\u00A0',
    '\u1680',
    '\u2000',
    '\u2001',
    '\u2002',
    '\u2003',
    '\u2004',
    '\u2005',
    '\u2006',
    '\u2007',
    '\u2008',
    '\u2009',
    '\u200A',
    '\u202F',
    '\u205F',
    '\u3000'
];
const $9b82f579358ff4d3$var$VoiceInput = ({ className: className })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const lastRecognitionInterim = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const isWaitingForResponse = (0, $7SHCs.useRetorikStore)((state)=>state.isWaitingForResponse);
    const [remainingLastRecognitionInterim, setRemainingLastRecognitionInterim] = (0, $bxRTa.useState)(null);
    const animationTimerRef = (0, $bxRTa.useRef)();
    const divRef = (0, $bxRTa.useRef)(null);
    const lastSpaceRef = (0, $bxRTa.useRef)(0);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 1
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            lastSpaceRef.current = 0;
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (lastRecognitionInterim) {
            if (isLandscape && divRef?.current) {
                if (divRef.current.scrollHeight > divRef.current.clientHeight) {
                    let lastSpace = 0;
                    for(let i = lastRecognitionInterim.length - 1; i > 0; i--)if ($9b82f579358ff4d3$var$spacingCharacters.includes(lastRecognitionInterim[i])) {
                        switch(lastSpace){
                            case 0:
                                // First space found, let's wait for another one
                                lastSpace = 1;
                                break;
                            case 1:
                                // Second space found, the next one will be the good one
                                lastSpace = 2;
                                break;
                            case 2:
                                // Take this space as reference to display text
                                lastSpace = 3;
                                lastSpaceRef.current = i;
                                break;
                        }
                        if (lastSpace === 3) break;
                    }
                }
                setRemainingLastRecognitionInterim(`${lastSpaceRef.current ? '... ' : ''}${lastRecognitionInterim.substring(lastSpaceRef.current)}`);
            } else setRemainingLastRecognitionInterim(lastRecognitionInterim);
        } else if (remainingLastRecognitionInterim) {
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $9b82f579358ff4d3$var$springDuration
                }
            });
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            animationTimerRef.current = setTimeout(()=>{
                api.set({
                    opacity: 1
                });
                setRemainingLastRecognitionInterim(null);
                lastSpaceRef.current = 0;
            }, $9b82f579358ff4d3$var$springDuration);
        }
    }, [
        lastRecognitionInterim
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: isMobile ? isWaitingForResponse ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gQoxd.default), {
            classname: "rf-flex rf-justify-center rf-py-3 rf-items-center",
            subClassname: "rf-w-4 rf-h-4",
            size: (0, $2rYkD.AnimationSize).medium,
            useTextColor: true
        }) : remainingLastRecognitionInterim ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).p, {
            className: className,
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-justify-end landscape-retorik:rf-justify-start rf-gap-2",
            children: isLandscape ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $37abB.default), {}),
                    remainingLastRecognitionInterim && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
                        ref: divRef,
                        className: "rf-w-full rf-max-h-16 rf-pt-2 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-center rf-text-shadow-black rf-overflow-hidden",
                        style: {
                            ...spring
                        },
                        children: remainingLastRecognitionInterim
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: remainingLastRecognitionInterim && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
                    className: "rf-w-full rf-py-3 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-center rf-text-shadow-black",
                    style: {
                        ...spring
                    },
                    children: remainingLastRecognitionInterim
                })
            })
        })
    });
};
var $9b82f579358ff4d3$export$2e2bcd8739ae039 = $9b82f579358ff4d3$var$VoiceInput;

});
parcelRegister("gQoxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7804735915c02809$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $iEJNQ = parcelRequire("iEJNQ");
const $7804735915c02809$var$AnimationContainer = ({ classname: classname, subClassname: subClassname, size: size, useTextColor: useTextColor, triggerScroll: triggerScroll })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const processedClassName = (0, $bxRTa.useMemo)(()=>{
        return classname || 'rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center';
    }, [
        classname
    ]);
    const processedSubClassName = (0, $bxRTa.useMemo)(()=>{
        return subClassname || 'rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6';
    }, [
        subClassname
    ]);
    const processedAnimationColor = (0, $bxRTa.useMemo)(()=>{
        return {
            '--rf-color-loader-animation': useTextColor ? themeColors.secondary : themeColors.card.frame.text
        };
    }, [
        themeColors,
        useTextColor
    ]);
    (0, $bxRTa.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: processedClassName,
        style: {
            ...processedAnimationColor
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: processedSubClassName,
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                size: size || (isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large)
            })
        })
    });
};
var $7804735915c02809$export$2e2bcd8739ae039 = $7804735915c02809$var$AnimationContainer;

});

parcelRegister("37abB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10b399800c34b4a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $kaFO8 = parcelRequire("kaFO8");

var $2rYkD = parcelRequire("2rYkD");

var $2QZab = parcelRequire("2QZab");

var $726gw = parcelRequire("726gw");
const $e10b399800c34b4a$var$MicrophoneAndSwitch = ({ top: top })=>{
    const fullScreenImage = (0, $kaFO8.default)();
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const dashboardOpened = (0, $4xGiN.useUtilsStore)((state)=>state.dashboardOpened);
    const retorikEvent = (0, $4xGiN.useUtilsStore)((state)=>state.retorikEvent);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const [showCloseButton, setShowCloseButton] = (0, $bxRTa.useState)((0, $2rYkD.CloseButtonCause).none);
    const [bottomForBorne, setBottomForBorne] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        if (!isLandscape && (currentSubView !== (0, $2rYkD.CurrentSubView).none || dashboardOpened || retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen || listStatus === (0, $2rYkD.ListStatus).opened || route === (0, $2rYkD.Routes).News || fullScreenImage)) {
            if (retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen && currentSubView === (0, $2rYkD.CurrentSubView).none) setShowCloseButton((0, $2rYkD.CloseButtonCause).detailedpoi);
            else if (listStatus === (0, $2rYkD.ListStatus).opened) setShowCloseButton((0, $2rYkD.CloseButtonCause).list);
            else if (currentSubView !== (0, $2rYkD.CurrentSubView).none) switch(currentSubView){
                case (0, $2rYkD.CurrentSubView).emergency:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).emergency);
                    break;
                case (0, $2rYkD.CurrentSubView).history:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).history);
                    break;
                case (0, $2rYkD.CurrentSubView).languages:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).languages);
                    break;
                case (0, $2rYkD.CurrentSubView).weather:
                    setShowCloseButton((0, $2rYkD.CloseButtonCause).weather);
                    break;
            }
            else if (dashboardOpened) setShowCloseButton((0, $2rYkD.CloseButtonCause).dashboard);
            else if (route === (0, $2rYkD.Routes).News) setShowCloseButton((0, $2rYkD.CloseButtonCause).news);
            else if (fullScreenImage) setShowCloseButton((0, $2rYkD.CloseButtonCause).fullscreenimage);
        } else setShowCloseButton((0, $2rYkD.CloseButtonCause).none);
    }, [
        isLandscape,
        currentSubView,
        dashboardOpened,
        retorikEvent,
        listStatus,
        route,
        fullScreenImage
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (!top || isLandscape) setBottomForBorne(undefined);
        else setBottomForBorne(typeof top === 'number' ? `calc(100% - ${top}px + 0.5rem)` : `calc(100% - ${top} + 0.5rem)`);
    }, [
        isLandscape,
        top
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-microphone-container",
        className: `large-vertical:rf-absolute rf-w-fit ${showCloseButton !== (0, $2rYkD.CloseButtonCause).none ? 'rf-right-9' : 'rf-right-4'} landscape-retorik:-rf-mt-4 landscape-retorik:rf-pl-[calc(50%-2.5rem)] rf-flex rf-flex-row large-vertical:rf-flex-col rf-justify-center rf-items-center rf-gap-6 large-vertical:rf-gap-4`,
        style: {
            bottom: bottomForBorne
        },
        children: [
            mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2QZab.default), {
                hidden: showCloseButton !== (0, $2rYkD.CloseButtonCause).none
            }),
            (showCloseButton !== (0, $2rYkD.CloseButtonCause).none || mode === (0, $2rYkD.Mode).vocal) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $726gw.default), {
                type: showCloseButton !== (0, $2rYkD.CloseButtonCause).none ? (0, $2rYkD.RemoteButtonType).close : (0, $2rYkD.RemoteButtonType).text,
                backgroundColor: "#FFF",
                cause: showCloseButton
            })
        ]
    });
};
var $e10b399800c34b4a$export$2e2bcd8739ae039 = $e10b399800c34b4a$var$MicrophoneAndSwitch;

});
parcelRegister("2QZab", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ec64be329ff6f6$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");

var $aBDai = parcelRequire("aBDai");

var $6Iy5P = parcelRequire("6Iy5P");
parcelRequire("dikAc");
var $jWbjz = parcelRequire("jWbjz");

var $bNR9S = parcelRequire("bNR9S");

var $fEtid = parcelRequire("fEtid");

var $ePe83 = parcelRequire("ePe83");
const $89ec64be329ff6f6$var$MicrophoneButton = ({ hidden: hidden })=>{
    const isMicrophoneAllowed = (0, $giKuE.useSpeechStore)((state)=>state.isMicrophoneAllowed);
    const showMicrophoneModal = (0, $giKuE.useSpeechStore)((state)=>state.showMicrophoneModal);
    const microphonePermissionStatus = (0, $giKuE.useSpeechStore)((state)=>state.permissionStatus);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const instantIsWaitingForResponse = (0, $7SHCs.useRetorikStore)((state)=>state.instantIsWaitingForResponse);
    const fromTextToVocal = (0, $7SHCs.useRetorikStore)((state)=>state.fromTextToVocal);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const { setFullScreenImage: setFullScreenImage, setCurrentSubView: setCurrentSubView } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const { setShowMicrophoneModal: setShowMicrophoneModal, askPermission: askPermission, toggleMicrophone: toggleMicrophone } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const setFromTextToVocal = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setFromTextToVocal);
    const [colorWithTransparency] = (0, $bxRTa.useState)((0, $aBDai.getColorWithTransparency)(themeColors.secondary, 0.8));
    const [microphoneButtonClassname, setMicrophoneButtonClassname] = (0, $bxRTa.useState)();
    const [backgroundColor, setBackgroundColor] = (0, $bxRTa.useState)();
    const [showLoader, setShowLoader] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    const instantIsWaitingForResponseRef = (0, $bxRTa.useRef)(false);
    (0, $bxRTa.useEffect)(()=>{
        instantIsWaitingForResponseRef.current = instantIsWaitingForResponse;
    }, [
        instantIsWaitingForResponse
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let classname = 'rf-relative rf-z-[5] large:rf-h-20 rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border rf-rounded-half ';
        timerRef?.current && clearTimeout(timerRef.current);
        switch(activeRecognitionState){
            case (0, $2rYkD.RecognitionState).Listening:
                setShowLoader(false);
                setBackgroundColor(themeColors.secondary);
                classname += `${isMobile && 'rf-h-12 rf-my-2'} rf-border-none rf-loader-pulsation`;
                break;
            case (0, $2rYkD.RecognitionState).Initializing:
            case (0, $2rYkD.RecognitionState).Closing:
            case (0, $2rYkD.RecognitionState).ForceClosing:
                setShowLoader(true);
                if (isMobile) {
                    setBackgroundColor('transparent');
                    classname += 'rf-h-8 rf-border-none';
                } else {
                    setBackgroundColor(colorWithTransparency);
                    classname += 'rf-border-truewhite';
                }
                break;
            case (0, $2rYkD.RecognitionState).Closed:
                if (isMobile) {
                    setBackgroundColor('transparent');
                    classname += 'rf-h-8 rf-border-none';
                } else {
                    setBackgroundColor(colorWithTransparency);
                    classname += 'rf-border-truewhite';
                }
                // Timeout before setting showLoader to hide the delay between closing state and message sending
                timerRef.current = setTimeout(()=>{
                    setShowLoader(instantIsWaitingForResponseRef.current);
                }, 250);
                break;
        }
        setMicrophoneButtonClassname(classname);
    }, [
        isMobile,
        activeRecognitionState,
        colorWithTransparency,
        instantIsWaitingForResponse
    ]);
    const handleClick = ()=>{
        if (!isMicrophoneAllowed) askPermission();
        else toggleMicrophone();
    };
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (fromTextToVocal) {
            handleClick();
            setFromTextToVocal(false);
        }
    }, [
        fromTextToVocal
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setCurrentSubView((0, $2rYkD.CurrentSubView).none);
        setFullScreenImage(undefined);
    }, [
        activeRecognitionState
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-relative rf-h-full rf-flex rf-justify-center rf-items-center ${hidden && 'rf-hidden'}`,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: microphoneButtonClassname,
                onClick: handleClick,
                "aria-label": "microphone",
                style: {
                    backgroundColor: backgroundColor,
                    boxShadow: isMobile ? undefined : '0 0 6px #00000080'
                },
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-absolute rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                    children: showLoader && !isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-8 rf-loader-bouncing-white"
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($jWbjz.default, {
                        className: isMobile ? 'rf-h-5 rf-w-5' : 'rf-h-6 rf-w-6',
                        color: !isMobile || activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? '#FFF' : themeColors.secondary
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ePe83.default), {
                showLoader: showLoader
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Iy5P.default), {
                isOpened: showMicrophoneModal,
                onClose: ()=>setShowMicrophoneModal(false),
                children: [
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).waiting && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bNR9S.default), {}),
                    microphonePermissionStatus === (0, $2rYkD.PermissionStatus).refused && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fEtid.default), {})
                ]
            })
        ]
    });
};
var $89ec64be329ff6f6$export$2e2bcd8739ae039 = $89ec64be329ff6f6$var$MicrophoneButton;

});
parcelRegister("bNR9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c7bb8a07f85cf5$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");
parcelRequire("kMAJU");
var $f3SD2 = parcelRequire("f3SD2");
const $d1c7bb8a07f85cf5$var$MicrophoneModalWaiting = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-16 rf-py-16 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f3SD2.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-size-auto rf-text-center",
                children: translation.microphone.allow
            })
        ]
    });
};
var $d1c7bb8a07f85cf5$export$2e2bcd8739ae039 = $d1c7bb8a07f85cf5$var$MicrophoneModalWaiting;

});

parcelRegister("fEtid", function(module, exports) {

$parcel$export(module.exports, "default", () => $063d1e0c0a6e7c3e$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $clSD3 = parcelRequire("clSD3");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $kdMEA = parcelRequire("kdMEA");
parcelRequire("kMAJU");
var $iNZRc = parcelRequire("iNZRc");

var $8e5cw = parcelRequire("8e5cw");

var $9TTQJ = parcelRequire("9TTQJ");
parcelRequire("d72S7");
var $cUlNP = parcelRequire("cUlNP");
const $063d1e0c0a6e7c3e$var$springDuration = 500;
const $063d1e0c0a6e7c3e$var$MicrophoneModalRefused = ()=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const [redirectionUrl, setRedirectionUrl] = (0, $bxRTa.useState)();
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        let tempUrl = `${(0, $kdMEA.docsRetorik)}${locale.split('-')[0] === 'fr' ? '' : '/en'}/docs/depannage-autorisations-acces-micro/`;
        switch(0, $clSD3.browserName){
            case (0, $clSD3.BrowserTypes).Chrome:
            case (0, $clSD3.BrowserTypes).Chromium:
                tempUrl += '#chrome-';
                break;
            case (0, $clSD3.BrowserTypes).Edge:
            case (0, $clSD3.BrowserTypes).EdgeChromium:
                tempUrl += '#edge-';
                break;
            case (0, $clSD3.BrowserTypes).Firefox:
                tempUrl += '#firefox-';
                break;
            case (0, $clSD3.BrowserTypes).Safari:
            case (0, $clSD3.BrowserTypes).MobileSafari:
                tempUrl += '#safari-';
                break;
            case (0, $clSD3.BrowserTypes).Opera:
                tempUrl += '#opera-';
                break;
            case (0, $clSD3.BrowserTypes).SamsungBrowser:
                setRedirectionUrl(`${tempUrl}#samsung-sur-mobile`);
                return;
            case (0, $clSD3.BrowserTypes).Ie:
            case (0, $clSD3.BrowserTypes).InternetExplorer:
            default:
                break;
        }
        switch(0, $clSD3.osName){
            case (0, $clSD3.OsTypes).Windows:
            case (0, $clSD3.OsTypes).MAC_OS:
                tempUrl += 'sur-ordinateur-de-bureau';
                break;
            default:
                tempUrl += 'sur-mobile-ou-tablette';
        }
        setRedirectionUrl(tempUrl);
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $063d1e0c0a6e7c3e$var$springDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $063d1e0c0a6e7c3e$var$springDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $063d1e0c0a6e7c3e$var$springDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleRedirect = ()=>{
        if (redirectionUrl) isUsedOnBorne ? setQrCodeDataAsync(redirectionUrl) : window.open(redirectionUrl, '_blank', 'noopener noreferrer');
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-max-w-[500px] rf-px-8 rf-py-8 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-size-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iNZRc.default), {
                className: "rf-h-10"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-font-light",
                children: translation.microphone.rejected
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-text-center",
                children: translation.microphone.instructions
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button",
                onClick: handleRedirect,
                children: translation.common.knowmore
            }),
            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: 'rgba(18,18,18,0.7)',
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-px-8 rf-flex rf-flex-row rf-items-start rf-gap-1 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cUlNP.default), {
                                color: "#FFF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-w-fit",
                                children: translation.link.scanQRTile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $063d1e0c0a6e7c3e$export$2e2bcd8739ae039 = $063d1e0c0a6e7c3e$var$MicrophoneModalRefused;

});

parcelRegister("ePe83", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acbf3e094ad379$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $8PG7f = parcelRequire("8PG7f");

var $2rYkD = parcelRequire("2rYkD");
const $47acbf3e094ad379$var$MicrophoneTextBubble = ({ showLoader: showLoader })=>{
    const botAnswerEnded = (0, $8PG7f.default)();
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const lastRecognitionInterim = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const speaking = (0, $giKuE.useSpeechStore)((state)=>state.speaking);
    const useContinuousRecognition = (0, $giKuE.useSpeechStore)((state)=>state.useContinuousRecognition);
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const dashboardOpened = (0, $4xGiN.useUtilsStore)((state)=>state.dashboardOpened);
    const retorikEvent = (0, $4xGiN.useUtilsStore)((state)=>state.retorikEvent);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const [className, setClassName] = (0, $bxRTa.useState)();
    const [text, setText] = (0, $bxRTa.useState)();
    const [textUndefined, setTextUndefined] = (0, $bxRTa.useState)(false);
    const timerRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        setTextUndefined(speaking || showLoader || !botAnswerEnded || currentSubView !== (0, $2rYkD.CurrentSubView).none || dashboardOpened || retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen || listStatus === (0, $2rYkD.ListStatus).opened);
    }, [
        speaking,
        showLoader,
        botAnswerEnded,
        currentSubView,
        dashboardOpened,
        retorikEvent,
        listStatus
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let tempClassName = 'rf-absolute rf-w-max rf-py-2 rf-px-4 rf-flex rf-flex-col rf-justify-center rf-items-center rf-bg-[#000000B3] rf-border rf-rounded-lg rf-text-truewhite rf-text-center rf-border-[#8B8888] rf-shadow-[inset_0_0_6px_#0000003B] ';
        if (isMobile) tempClassName += 'rf-bottom-[calc(100%+2rem)]';
        else if (isLandscape) tempClassName += 'rf-top-[calc(100%+1rem)]';
        else tempClassName += isRTL ? 'rf-left-[calc(100%+1rem)]' : 'rf-right-[calc(100%+1rem)]';
        setClassName(tempClassName);
    }, [
        isMobile,
        isLandscape,
        isRTL
    ]);
    (0, $bxRTa.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        switch(activeRecognitionState){
            case (0, $2rYkD.RecognitionState).Listening:
                setText(isMobile || isLandscape && lastRecognitionInterim ? undefined : translation.microphone.listening);
                break;
            case (0, $2rYkD.RecognitionState).Closed:
                let text = undefined;
                if (!textUndefined) text = useContinuousRecognition ? `<p>${translation.microphone.trigger}${isMobile ? ' ' : '<br />'}<strong>\xab ${agentData?.name} \xbb</strong></p>` : `<p>${translation.microphone.triggerwithoutname}</p>`;
                // Show the button only 1.5s after, to prevents it from appearing à fraction of second between several texts
                timerRef.current = setTimeout(()=>{
                    setText(text);
                }, 1500);
                break;
            case (0, $2rYkD.RecognitionState).Initializing:
            case (0, $2rYkD.RecognitionState).Closing:
            case (0, $2rYkD.RecognitionState).ForceClosing:
            default:
                setText(undefined);
                break;
        }
    }, [
        isMobile,
        activeRecognitionState,
        agentData,
        lastRecognitionInterim,
        textUndefined,
        useContinuousRecognition
    ]);
    return text ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: className,
                style: {
                    clipPath: isMobile ? 'polygon(0% 0%, 0% 100%, calc(50% - 0.4rem) 100%, calc(50% - 0.4rem) calc(100% - 1px), calc(50% + 0.4rem) calc(100% - 1px), calc(50% + 0.4rem) 100%, 100% 100%, 100% 0%)' : isLandscape ? 'polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%, calc(50% + 0.4rem) 0%, calc(50% + 0.4rem) calc(0% + 1px), calc(50% - 0.4rem) calc(0% + 1px), calc(50% - 0.4rem) 0%)' : 'polygon(0% 0%, 0% 100%, 100% 100%, 100% calc(50% + 0.4rem), calc(100% - 1px) calc(50% + 0.4rem), calc(100% - 1px) calc(50% - 0.4rem), 100% calc(50% - 0.4rem), 100% 0%)'
                },
                dangerouslySetInnerHTML: {
                    __html: text
                }
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-absolute rf-w-3 rf-h-3 rf-bg-[#000000B3] rf-border-t rf-border-r rf-border-t-[#8B8888] rf-border-r-[#8B8888]",
                style: {
                    rotate: isMobile ? '135deg' : isLandscape ? '-45deg' : isRTL ? '-135deg' : '45deg',
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%)',
                    bottom: isMobile ? 'calc(100% + 1.7rem)' : undefined,
                    top: isLandscape ? 'calc(100% + 0.7rem)' : undefined,
                    right: isMobile || isLandscape || isRTL ? undefined : 'calc(100% + 0.7rem)',
                    left: isMobile || isLandscape || !isRTL ? undefined : 'calc(100% + 0.7rem)'
                }
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $47acbf3e094ad379$export$2e2bcd8739ae039 = $47acbf3e094ad379$var$MicrophoneTextBubble;

});
parcelRegister("8PG7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a763a6f055cf6f$export$2e2bcd8739ae039);

var $bxRTa = parcelRequire("bxRTa");

var $bWQ72 = parcelRequire("bWQ72");

var $kdMEA = parcelRequire("kdMEA");
/**
 * Check if the last activity received/sent is used in the flow of the conversation and if so, if it's ended or not.
 * Used for text/loader display in vocal mode for example.
 * @returns {boolean}
 */ const $f7a763a6f055cf6f$var$useBotAnswerEnded = ()=>{
    const lastActivity = (0, $bWQ72.useActivityStore)((state)=>state.lastActivity);
    const endedActivities = (0, $bWQ72.useActivityStore)((state)=>state.endedActivities);
    const [ended, setEnded] = (0, $bxRTa.useState)(false);
    (0, $bxRTa.useEffect)(()=>{
        if (lastActivity) {
            // If the activity has a replyToId or if it's a bring-up message, it's a bot response.
            if (lastActivity.replyToId || lastActivity.label?.toLowerCase() === 'davi.bringupmessage') {
                if (lastActivity.type === 'message' || lastActivity.value?.name?.toLowerCase() === 'davi.streammessageactivity') setEnded(endedActivities.includes(lastActivity.id));
                else setEnded(true);
            } else if (lastActivity.type === 'message' || lastActivity.value?.name && !(0, $kdMEA.nonResponseInducingEvents).find((eventName)=>lastActivity.value.name.toLowerCase().includes(eventName))) setEnded(false);
            else setEnded(true);
        } else setEnded(true);
    }, [
        lastActivity,
        endedActivities
    ]);
    return ended;
};
var $f7a763a6f055cf6f$export$2e2bcd8739ae039 = $f7a763a6f055cf6f$var$useBotAnswerEnded;

});





parcelRegister("4BCpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $058ed3f0f77eab9a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("dikAc");
var $6Nt3V = parcelRequire("6Nt3V");
var $9f9kU = parcelRequire("9f9kU");
var $jWbjz = parcelRequire("jWbjz");
const $058ed3f0f77eab9a$var$ModeButton = ({ label: label, selected: selected, onClick: onClick })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: "rf-grid rf-w-full rf-h-12 rf-pb-4 rf-justify-center rf-items-end",
        onClick: ()=>onClick((0, $2rYkD.Mode)[label]),
        "aria-label": label,
        children: label === 'vocal' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
            className: "rf-h-5",
            color: "#A4A7AF"
        }) : label === 'text' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
            className: "rf-h-4",
            color: selected ? themeColors.secondary : '#A4A7AF'
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Nt3V.default), {
            className: "rf-h-[0.875rem]",
            color: selected ? themeColors.secondary : '#A4A7AF'
        })
    });
};
var $058ed3f0f77eab9a$export$2e2bcd8739ae039 = $058ed3f0f77eab9a$var$ModeButton;

});


parcelRegister("kq8jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d590c2d5e524e8$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $eO5xw = parcelRequire("eO5xw");

var $k4qlo = parcelRequire("k4qlo");

var $iU6tk = parcelRequire("iU6tk");

var $hRvNU = parcelRequire("hRvNU");

var $cxKWX = parcelRequire("cxKWX");

var $iBT6g = parcelRequire("iBT6g");

var $3KYvq = parcelRequire("3KYvq");
const $81d590c2d5e524e8$var$ParametersAndDashboardContainer = ({ handleBack: handleBack, hideMenu: hideMenu = false })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const menu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        divRef?.current && isWidget && (0, $k4qlo.default)(null, divRef);
    }, [
        divRef.current
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-py-4 rf-bg-truewhite rf-overflow-y-hidden rf-pointer-events-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iU6tk.default), {
                title: translation.menu.backconversation,
                className: "rf-px-4 rf-text-sm",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: divRef,
                className: "rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: [
                            menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3KYvq.default), {
                                toggleDashboard: handleBack
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hRvNU.default), {
                                toggleDashboard: handleBack
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-4 rf-text-lightgray",
                                children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.parameters, locale)
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cxKWX.default), {
                                handleBack: handleBack
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iBT6g.default), {
                        isMobile: true
                    })
                ]
            })
        ]
    });
};
var $81d590c2d5e524e8$export$2e2bcd8739ae039 = $81d590c2d5e524e8$var$ParametersAndDashboardContainer;

});
parcelRegister("iU6tk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a67c1e41002f9f1$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
const $1a67c1e41002f9f1$var$BackButton = ({ title: title, className: className, handleBack: handleBack })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-flex rf-flex-row rf-items-center ${className}`,
        onClick: handleBack,
        "aria-label": title,
        "data-map": "fermer",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                className: "rf-w-8"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1",
                children: (0, $eO5xw.capitalizeFirstLetter)(title)
            })
        ]
    });
};
var $1a67c1e41002f9f1$export$2e2bcd8739ae039 = $1a67c1e41002f9f1$var$BackButton;

});

parcelRegister("hRvNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $517a47f1eedd6a3b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");
parcelRequire("hZeqH");
var $6Vbk7 = parcelRequire("6Vbk7");

var $75jcl = parcelRequire("75jcl");

var $h0yA8 = parcelRequire("h0yA8");

var $jVVrN = parcelRequire("jVVrN");

var $dncba = parcelRequire("dncba");
parcelRequire("81HL8");
var $77wBI = parcelRequire("77wBI");

var $iBT6g = parcelRequire("iBT6g");
const $517a47f1eedd6a3b$var$OldDashboard = ({ toggleDashboard: toggleDashboard })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const askForKioskParametersOpening = (0, $4xGiN.useUtilsStore)((state)=>state.actions.askForKioskParametersOpening);
    const handleClick = ()=>{
        toggleDashboard?.();
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        askForKioskParametersOpening();
        toggleDashboard?.();
    };
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jVVrN.default), {
            conditionalHandleClick: handleClick
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Vbk7.default), {
        onClick: toggleDashboard,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-h-full rf-max-w-7/10 rf-flex rf-flex-col rf-items-start rf-gap-8",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-min-h-2/5 rf-py-4 rf-mt-auto rf-flex rf-flex-col rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jVVrN.default), {
                                    handleClick: toggleDashboard
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-3/10 rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dncba.default), {
                                    handleClick: toggleDashboard
                                })
                            })
                        ]
                    }),
                    isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $77wBI.default), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iBT6g.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: handleClick
            })
        ]
    });
};
var $517a47f1eedd6a3b$export$2e2bcd8739ae039 = $517a47f1eedd6a3b$var$OldDashboard;

});
parcelRegister("jVVrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7441469c8ba1113$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $kdMEA = parcelRequire("kdMEA");

var $41KEu = parcelRequire("41KEu");
const $d7441469c8ba1113$var$DisplayViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const [finalMenu, setFinalMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $41KEu.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined,
                    name: customCurrentMenu.name
                }));
            } else fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $41KEu.default), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick,
                conditionalHandleClick: conditionalHandleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        const tempFinalMenu = [];
        // Basic menu
        tempFinalMenu.push(buildMenu(configuration && configuration.baseMenu ? [
            ...configuration.baseMenu
        ] : [
            ...(0, $kdMEA.DEFAULT_VIEWS)
        ]));
        // Custom menus
        if (configuration && configuration.customMenu && configuration.customMenu.length > 0) {
            if (Array.isArray(configuration.customMenu[0])) configuration.customMenu.forEach((menuArray)=>{
                tempFinalMenu.push(buildMenu(menuArray));
            });
            else tempFinalMenu.push(buildMenu(configuration.customMenu));
        }
        setFinalMenu(tempFinalMenu);
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: finalMenu.map((line, key)=>{
            return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${key === 0 && 'rf-pb-4'} rf-flex rf-flex-col rf-items-center`,
                children: [
                    key !== 0 && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-6 -rf-mx-6 rf-width-fill-available rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                    }),
                    line.map((e, subkey)=>{
                        return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                            children: e
                        }, subkey);
                    })
                ]
            }, key) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                children: line.map((e, subkey)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: e
                    }, subkey);
                })
            }, key);
        })
    });
};
var $d7441469c8ba1113$export$2e2bcd8739ae039 = $d7441469c8ba1113$var$DisplayViews;

});
parcelRegister("41KEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $de88e43f6a74bebb$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $3XSV8 = parcelRequire("3XSV8");
function $de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $de88e43f6a74bebb$var$DisplayGenerator = (props)=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const { setCurrentSubView: setCurrentSubView, setCurrentCustomView: setCurrentCustomView } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    const [colorButtonHandle, setColorButtonHandle] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        let colorButtonHandle = '';
        // Handle hospitality menu icon color
        if ($de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(props) && props.name) {
            if (props.name.toString().indexOf('whatToDo') > -1) colorButtonHandle = themeColors.tobeDoneColor;
            else if (props.name.toString().indexOf('localProducts') > -1) colorButtonHandle = themeColors.localProductsColor;
            else if (props.name.toString().indexOf('whereToEat') > -1) colorButtonHandle = themeColors.whereToEatColor;
            else if (props.name.toString().indexOf('whereToSleep') > -1) colorButtonHandle = themeColors.whereToSleepColor;
            else if (props.name.toString().indexOf('whatToSee') > -1) colorButtonHandle = themeColors.tobeSeenColor;
            else if (props.name.toString().indexOf('agenda') > -1) colorButtonHandle = themeColors.agendaColor;
            else if (props.name.toString().indexOf('services') > -1) colorButtonHandle = themeColors.servicesColor;
        }
        setColorButtonHandle(colorButtonHandle);
    }, [
        label
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableViews).home:
                isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
                sendEvent('showHome');
                break;
            case (0, $2rYkD.AvailableViews).news:
                setRoute((0, $2rYkD.Routes).News);
                break;
            case (0, $2rYkD.AvailableViews).weather:
                setCurrentSubView((0, $2rYkD.CurrentSubView).weather);
                break;
            case (0, $2rYkD.AvailableViews).emergency:
                setCurrentSubView((0, $2rYkD.CurrentSubView).emergency);
                break;
        }
        else if ($de88e43f6a74bebb$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            // Display custom component if present
            if (props.customDisplay) setCurrentCustomView({
                ...props
            });
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                view: props.view
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                icon: props.icon,
                className: "rf-max-h-6 rf-max-w-6 rf-flex rf-items-center",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-4 rf-font-bold",
                children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
            })
        ]
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-36 rf-w-36 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $de88e43f6a74bebb$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                view: props.view,
                className: "rf-h-16"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                icon: props.icon,
                className: "rf-h-16 rf-w-16 rf-flex",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'} large-vertical:rf-text-basecustomuppercase`,
                children: label
            })
        ]
    });
};
var $de88e43f6a74bebb$export$2e2bcd8739ae039 = $de88e43f6a74bebb$var$DisplayGenerator;

});
parcelRegister("3XSV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ed40ff53afd6e0$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("2l6WH");
var $hCkUC = parcelRequire("hCkUC");
var $3sPnl = parcelRequire("3sPnl");
var $jGi9r = parcelRequire("jGi9r");
var $8LI0a = parcelRequire("8LI0a");
var $jzwsO = parcelRequire("jzwsO");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $3EchS = parcelRequire("3EchS");
const $72ed40ff53afd6e0$var$DisplayIcon = ({ view: view, icon: icon, className: className, color: color = '' })=>{
    if (view) return view === (0, $2rYkD.AvailableViews).home ? /*#__PURE__*/ (0, $fl9nK.jsx)($3sPnl.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).news ? /*#__PURE__*/ (0, $fl9nK.jsx)($8LI0a.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).weather ? /*#__PURE__*/ (0, $fl9nK.jsx)($jzwsO.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableViews).emergency ? /*#__PURE__*/ (0, $fl9nK.jsx)($hCkUC.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).history ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
        className: className
    }) : view === (0, $2rYkD.AvailableSubViews).tutorial ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
        className: className
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($jGi9r.default, {
        className: className
    });
    else if (icon) return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${className} ${color !== '' ? 'svgButtonMenu' : ''}`,
        style: color !== '' ? {
            '--fill': color
        } : {},
        children: icon
    });
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {});
};
var $72ed40ff53afd6e0$export$2e2bcd8739ae039 = $72ed40ff53afd6e0$var$DisplayIcon;

});



parcelRegister("dncba", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f2ab8ee6f2ca889$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $3u9RE = parcelRequire("3u9RE");
const $8f2ab8ee6f2ca889$var$DisplaySubViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const disableHistory = (0, $7SHCs.useRetorikStore)((state)=>state.disableHistory);
    const [subMenu, setSubMenu] = (0, $bxRTa.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseSubMenu
            if (Object.keys(currentMenu).includes('icon')) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $3u9RE.default), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else {
                // In mobile mode, we only push custom items, base items (history / tutorial) have their own render
                if (!isMobile) // Don't add "history" item if it is disabled
                {
                    if (!(disableHistory && configuration.isUsedOnBorne) || currentMenu.view !== (0, $2rYkD.AvailableSubViews).history) fullMenu.push(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $3u9RE.default), {
                        type: "BaseMenu",
                        indice: currentMenu.indice,
                        view: currentMenu.view,
                        device: currentDeviceType,
                        handleClick: handleClick
                    }));
                }
            }
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $bxRTa.useEffect)(()=>{
        // Handle custom submenus
        if (configuration?.subMenu) setSubMenu(buildMenu(configuration.subMenu));
        else setSubMenu(buildMenu((0, $kdMEA.DEFAULT_SUB_VIEWS)));
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: subMenu.map((e, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: e
            }, key);
        })
    });
};
var $8f2ab8ee6f2ca889$export$2e2bcd8739ae039 = $8f2ab8ee6f2ca889$var$DisplaySubViews;

});
parcelRegister("3u9RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d878087efb3c35ce$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $eO5xw = parcelRequire("eO5xw");

var $kdMEA = parcelRequire("kdMEA");

var $3XSV8 = parcelRequire("3XSV8");
function $d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(object) {
    return 'view' in object && object.type === 'BaseMenu';
}
function $d878087efb3c35ce$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return 'icon' in object && object.type === 'CustomMenu';
}
const $d878087efb3c35ce$var$DisplaySubGenerator = (props)=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const { setCurrentSubView: setCurrentSubView, setCurrentCustomView: setCurrentCustomView } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const [label, setLabel] = (0, $bxRTa.useState)('');
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $bxRTa.useEffect)(()=>{
        if ($d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($d878087efb3c35ce$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === 'string') setLabel(props.label);
            else if (props.label && typeof props.label === 'object') setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $2rYkD.AvailableSubViews).history:
                setCurrentSubView((0, $2rYkD.CurrentSubView).history);
                break;
            case (0, $2rYkD.AvailableSubViews).tutorial:
                console.log('Tutorial');
                break;
        }
        else if ($d878087efb3c35ce$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            if (props.customDisplay) setCurrentCustomView({
                ...props
            });
        }
        props.handleClick && props.handleClick();
    };
    return (0, $kdMEA.mobileDisplays).includes(props.device) ? /* On mobile / widget : display available views as lines, without icons */ /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && 'rf-border-t rf-border-t-menuBorder'}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: (0, $eO5xw.capitalizeFirstLetter)(label, locale)
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-h-24 rf-w-24 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $d878087efb3c35ce$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                view: props.view,
                className: "rf-h-8"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3XSV8.default), {
                icon: props.icon,
                className: "rf-h-8 rf-w-8 rf-flex"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-uppercase rf-text-[#575F6B] ${isRTL ? 'rf-text-arabic' : 'rf-text-xs'}`,
                children: label
            })
        ]
    });
};
var $d878087efb3c35ce$export$2e2bcd8739ae039 = $d878087efb3c35ce$var$DisplaySubGenerator;

});


parcelRegister("iBT6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6845afb7ac8a9e4$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $3RB0m = parcelRequire("3RB0m");
const $a6845afb7ac8a9e4$var$Version = ({ isMobile: isMobile })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${isMobile ? 'rf-px-5 rf-pt-6 rf-text-xsm' : 'rf-absolute rf-left-8 rf-bottom-2 rf-text-sm'} rf-text-[#A4A7AF] rf-text-sm`,
        children: `v ${(0, $3RB0m.version)}`
    });
};
var $a6845afb7ac8a9e4$export$2e2bcd8739ae039 = $a6845afb7ac8a9e4$var$Version;

});


parcelRegister("cxKWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed59ffb9b8bdca9f$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("l9TTE");
var $66rUF = parcelRequire("66rUF");

var $bt5PB = parcelRequire("bt5PB");

var $1HwbH = parcelRequire("1HwbH");

var $bAJ6O = parcelRequire("bAJ6O");

var $dncba = parcelRequire("dncba");
const $ed59ffb9b8bdca9f$var$Parameters = ({ handleBack: handleBack })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const disableHistory = (0, $7SHCs.useRetorikStore)((state)=>state.disableHistory);
    const muted = (0, $giKuE.useSpeechStore)((state)=>state.muted);
    const disableSound = (0, $giKuE.useSpeechStore)((state)=>state.disableSound);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const setMuted = (0, $giKuE.useSpeechStore)((state)=>state.actions.setMuted);
    const setDisplaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setDisplaySubtitles);
    const handleSoundChange = (val)=>{
        setMuted(!val);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !disableSound && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.sound,
                handleChange: handleSoundChange,
                defaultChecked: !muted
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder"
            }),
            mode !== (0, $2rYkD.Mode).text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $66rUF.default), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.subtitle,
                handleChange: setDisplaySubtitles,
                defaultChecked: displaySubtitles
            }),
            isMobile && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bt5PB.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1HwbH.default), {
                        handleBack: handleBack
                    }),
                    !disableHistory && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bAJ6O.default), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dncba.default), {
                        handleClick: handleBack
                    })
                ]
            })
        ]
    });
};
var $ed59ffb9b8bdca9f$export$2e2bcd8739ae039 = $ed59ffb9b8bdca9f$var$Parameters;

});
parcelRegister("bt5PB", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c1aad1002c044b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $hzhG4 = parcelRequire("hzhG4");
const $43c1aad1002c044b$var$LanguageButton = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const supported = (0, $2eBYD.useLocaleStore)((state)=>state.supported);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const setCurrentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setCurrentSubView);
    /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).languages ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).languages);
    };
    return supported.length > 1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hzhG4.default), {
        title: translation.common.lang,
        icon: "lang",
        color: currentSubView === (0, $2rYkD.CurrentSubView).languages ? themeColors.secondary : '#A4A7AF',
        onClick: handleClick
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $43c1aad1002c044b$export$2e2bcd8739ae039 = $43c1aad1002c044b$var$LanguageButton;

});
parcelRegister("hzhG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bba48756c4a0595$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $13Gq4 = parcelRequire("13Gq4");
parcelRequire("81HL8");
var $2ogpH = parcelRequire("2ogpH");
var $k1ioo = parcelRequire("k1ioo");
var $3EchS = parcelRequire("3EchS");
parcelRequire("7Jjoy");
var $iyJo4 = parcelRequire("iyJo4");
const $6bba48756c4a0595$var$ParameterButton = ({ title: title, color: color, icon: icon, onClick: onClick })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    return isMobile ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row ${icon === 'lang' ? 'rf-justify-between' : 'rf-justify-start'} rf-items-center rf-border-t rf-border-t-menuBorder rf-capitalize`,
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            title,
            icon === 'lang' && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mr-3 rf-text-lightgray rf-normal-case",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($13Gq4)))[locale]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iyJo4.default), {
                        className: "rf-h-4"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
        className: "rf-width-fill-available rf-mx-3 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg",
        style: {
            color: color || '#A4A7AF',
            background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)',
            boxShadow: '2px 2px 6px #00000029'
        },
        onClick: (e)=>onClick(e),
        "aria-label": title,
        children: [
            icon === 'tutorial' ? /*#__PURE__*/ (0, $fl9nK.jsx)($3EchS.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'history' ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ogpH.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === 'lang' ? /*#__PURE__*/ (0, $fl9nK.jsx)($k1ioo.default, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-ml-1 rf-uppercase",
                children: title
            })
        ]
    });
};
var $6bba48756c4a0595$export$2e2bcd8739ae039 = $6bba48756c4a0595$var$ParameterButton;

});


parcelRegister("1HwbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $684aa20548960f8b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $hzhG4 = parcelRequire("hzhG4");
const $684aa20548960f8b$var$TutorialButton = ({ handleBack: handleBack })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const handleClick = ()=>{
        handleBack?.();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hzhG4.default), {
        title: translation.common.tutorial,
        icon: "tutorial",
        onClick: handleClick
    });
};
var $684aa20548960f8b$export$2e2bcd8739ae039 = $684aa20548960f8b$var$TutorialButton;

});

parcelRegister("bAJ6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb13c235c769d16$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $hzhG4 = parcelRequire("hzhG4");
const $7bb13c235c769d16$var$HistoryButton = ({ handleBack: handleBack })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const setCurrentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setCurrentSubView);
    const handleClick = ()=>{
        handleBack?.();
        setCurrentSubView(currentSubView === (0, $2rYkD.CurrentSubView).history ? (0, $2rYkD.CurrentSubView).none : (0, $2rYkD.CurrentSubView).history);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hzhG4.default), {
        title: translation.history.title,
        icon: "history",
        color: currentSubView === (0, $2rYkD.CurrentSubView).history ? themeColors.secondary : '#A4A7AF',
        onClick: handleClick
    });
};
var $7bb13c235c769d16$export$2e2bcd8739ae039 = $7bb13c235c769d16$var$HistoryButton;

});


parcelRegister("3KYvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $48212c6720f5588b$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $hdMz2 = parcelRequire("hdMz2");

var $eO5xw = parcelRequire("eO5xw");

var $hnSXC = parcelRequire("hnSXC");

var $b0ztB = parcelRequire("b0ztB");
const $48212c6720f5588b$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const menus = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const handleHome = ()=>{
        sendEvent('showHome');
        toggleDashboard();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-text-trueblack rf-overflow-hidden",
                onClick: handleHome,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hnSXC.default), {
                        className: "rf-h-6 rf-w-8",
                        color: "#1999B1"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: (0, $eO5xw.capitalizeFirstLetter)(translation['1'], locale)
                    })
                ]
            }),
            menus?.categories?.map((menu, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-h-6 -rf-mx-8 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b0ztB.default), {
                            ...menu,
                            onClick: toggleDashboard
                        })
                    ]
                }, key);
            })
        ]
    });
};
var $48212c6720f5588b$export$2e2bcd8739ae039 = $48212c6720f5588b$var$Dashboard;

});
parcelRegister("b0ztB", function(module, exports) {

$parcel$export(module.exports, "default", () => $80421e0bfdcb4c70$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $8Ibqy = parcelRequire("8Ibqy");
const $80421e0bfdcb4c70$var$DashboardColumn = ({ title: title, tiles: tiles, onClick: onClick })=>{
    const processedItems = (0, $bxRTa.useMemo)(()=>{
        return tiles.slice().sort((item1, item2)=>item1.index - item2.index);
    }, [
        tiles
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-pt-6 rf-pb-2 rf-flex rf-flex-col rf-justify-start",
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-text-lgcustom rf-font-bold rf-pb-2",
                children: title
            }),
            processedItems.map((item, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `rf-w-full ${key && 'rf-border-t rf-border-t-menuBorder'}`,
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8Ibqy.default), {
                        ...item,
                        textColor: undefined,
                        onClick: onClick
                    })
                }, key);
            })
        ]
    });
};
var $80421e0bfdcb4c70$export$2e2bcd8739ae039 = $80421e0bfdcb4c70$var$DashboardColumn;

});
parcelRegister("8Ibqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbbe61161f64952$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $hdMz2 = parcelRequire("hdMz2");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $5JKxf = parcelRequire("5JKxf");
const $0cbbe61161f64952$var$md = (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $0cbbe61161f64952$var$DashboardItem = ({ text: text, textColor: textColor, image: image, action: action, onClick: onClick })=>{
    const { sendMessage: sendMessage, sendEvent: sendEvent } = (0, $hdMz2.useDirectlineStore)((state)=>state.actions);
    const { setClickedOnUI: setClickedOnUI, setCurrentSubView: setCurrentSubView, setFullScreenImage: setFullScreenImage } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case 'openlanguage':
                setCurrentSubView((0, $2rYkD.CurrentSubView).languages);
                break;
            case 'openhistory':
                setCurrentSubView((0, $2rYkD.CurrentSubView).history);
                break;
            case 'opentutorial':
                console.log('Open tutorial');
                break;
            case 'opennews':
                setRoute((0, $2rYkD.Routes).News);
                break;
            case 'openweather':
                setCurrentSubView((0, $2rYkD.CurrentSubView).weather);
                break;
            case 'openemergency':
                setCurrentSubView((0, $2rYkD.CurrentSubView).emergency);
                break;
            case 'fullscreenimage':
                value.url && setFullScreenImage(value.url);
                break;
        }
    };
    const handleClick = (e)=>{
        switch(action.type){
            case (0, $2rYkD.ActionType).message:
                action.value?.text && sendMessage(action.value.text);
                break;
            case (0, $2rYkD.ActionType).event:
                action.value?.name && sendEvent(action.value.name, action.value.value || null);
                break;
            case (0, $2rYkD.ActionType).url:
                action.value?.url && window.open(action.value.url, '_blank', 'noopener noreferrer');
                break;
            case (0, $2rYkD.ActionType).internal:
                handleInternalAction(action.value);
                break;
        }
        onClick();
        setClickedOnUI((0, $2rYkD.UIPart).card);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-overflow-hidden",
        style: {
            color: textColor || '#000'
        },
        onClick: (e)=>handleClick(e),
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-6 rf-w-8",
                children: image?.url && /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: image.url.indexOf('svg') > -1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                        svgUrl: image.url,
                        height: "100%",
                        fillColor: image.color
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: "rf-h-full",
                        src: image.url
                    })
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: $0cbbe61161f64952$var$md.render(text)
                }
            })
        ]
    });
};
var $0cbbe61161f64952$export$2e2bcd8739ae039 = $0cbbe61161f64952$var$DashboardItem;

});





parcelRegister("iLzAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $be6cc8c3888f2e35$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $hdMz2 = parcelRequire("hdMz2");

var $2eBYD = parcelRequire("2eBYD");

var $4xGiN = parcelRequire("4xGiN");
parcelRequire("hZeqH");
var $6Vbk7 = parcelRequire("6Vbk7");

var $h0yA8 = parcelRequire("h0yA8");

var $iBT6g = parcelRequire("iBT6g");

var $75jcl = parcelRequire("75jcl");

var $hnSXC = parcelRequire("hnSXC");
parcelRequire("81HL8");
var $77wBI = parcelRequire("77wBI");

var $8XlTw = parcelRequire("8XlTw");

const $be6cc8c3888f2e35$var$LittleWeather = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("4Twm7")));
const $be6cc8c3888f2e35$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const menus = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const askForKioskParametersOpening = (0, $4xGiN.useUtilsStore)((state)=>state.actions.askForKioskParametersOpening);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const [justify, setJustify] = (0, $bxRTa.useState)();
    const [opacityStyle, setOpacityStyle] = (0, $bxRTa.useState)('');
    const divRef = (0, $bxRTa.useRef)(null);
    /**
   * Check if there is an overflow to adjust justify-content value on menu container
   */ (0, $bxRTa.useLayoutEffect)(()=>{
        setJustify(divRef?.current?.scrollHeight && divRef?.current?.scrollHeight > divRef?.current?.clientHeight ? 'flex-start' : 'center');
    }, [
        menus
    ]);
    const handleHome = ()=>{
        sendEvent('showHome');
        toggleDashboard();
    };
    const handleScroll = ()=>{
        if (divRef.current) {
            const maxScroll = divRef.current.scrollHeight - divRef.current.offsetHeight;
            const percentage = Math.ceil(divRef.current.scrollTop / maxScroll * 20);
            setOpacityStyle(`linear-gradient(to top, black ${100 - percentage}%, transparent 100%)`);
        }
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        askForKioskParametersOpening();
        toggleDashboard?.();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Vbk7.default), {
        onClick: toggleDashboard,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-pt-40 large-vertical:rf-pt-48 rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)($be6cc8c3888f2e35$var$LittleWeather, {})
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        ref: divRef,
                        className: "rf-h-full rf-pt-4 rf-pb-24 rf-px-48 tablet:rf-pl-12 tablet:rf-pr-24 borne:rf-pl-32 borne:rf-pr-56 rf-flex rf-flex-col rf-items-start rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                        style: {
                            justifyContent: justify,
                            WebkitMaskImage: opacityStyle
                        },
                        onScroll: handleScroll,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                                className: "rf-h-14 rf-min-h-14 borne:rf-h-20 borne:rf-min-h-20 rf-px-4 rf-py-3 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
                                style: {
                                    color: '#575F6B',
                                    background: 'linear-gradient(to left top, #F2F3F6, #E5E6EC)'
                                },
                                onClick: handleHome,
                                children: [
                                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hnSXC.default), {
                                        className: "rf-h-8 borne:rf-h-10",
                                        color: "#818181"
                                    }),
                                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                        className: "rf-uppercase",
                                        children: translation['1']
                                    })
                                ]
                            }),
                            menus?.categories?.map((menu, key)=>{
                                return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8XlTw.default), {
                                    ...menu,
                                    onClick: toggleDashboard
                                }, key);
                            })
                        ]
                    }),
                    isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $77wBI.default), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iBT6g.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $75jcl.default), {
                dashboardVisible: true,
                onClick: toggleDashboard
            })
        ]
    });
};
var $be6cc8c3888f2e35$export$2e2bcd8739ae039 = $be6cc8c3888f2e35$var$Dashboard;

});
parcelRegister("8XlTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $479db7a2cdc55e0a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $eP5yt = parcelRequire("eP5yt");
const $479db7a2cdc55e0a$var$DashboardLine = ({ title: title, tiles: tiles, onClick: onClick })=>{
    const processedItems = (0, $bxRTa.useMemo)(()=>{
        return tiles.slice().sort((item1, item2)=>item1.index - item2.index);
    }, [
        tiles
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-col rf-justify-start rf-gap-4",
        children: [
            title && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-title-bold-size-auto",
                children: title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-flex rf-flex-row rf-gap-6 rf-flex-wrap",
                children: processedItems.map((item, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $eP5yt.default), {
                        ...item,
                        onClick: onClick
                    }, key);
                })
            })
        ]
    });
};
var $479db7a2cdc55e0a$export$2e2bcd8739ae039 = $479db7a2cdc55e0a$var$DashboardLine;

});
parcelRegister("eP5yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e2746b4da1d09a$export$2e2bcd8739ae039);

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $2aMjv = parcelRequire("2aMjv");
var $hzlaD = parcelRequire("hzlaD");

var $7QU6k = parcelRequire("7QU6k");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $hdMz2 = parcelRequire("hdMz2");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $5JKxf = parcelRequire("5JKxf");

var $9TTQJ = parcelRequire("9TTQJ");

var $8e5cw = parcelRequire("8e5cw");
const $d0e2746b4da1d09a$var$md = (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $d0e2746b4da1d09a$var$springEnterDuration = 500;
const $d0e2746b4da1d09a$var$springQrcodeDuration = 500;
const $d0e2746b4da1d09a$var$DashboardItem = ({ index: index, text: text, textColor: textColor, backgroundColor: backgroundColor, image: image, action: action, onClick: onClick })=>{
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const { sendMessage: sendMessage, sendEvent: sendEvent } = (0, $hdMz2.useDirectlineStore)((state)=>state.actions);
    const { setClickedOnUI: setClickedOnUI, setCurrentSubView: setCurrentSubView, setFullScreenImage: setFullScreenImage } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)(undefined);
    const divRef = (0, $bxRTa.useRef)(null);
    const fadeInTimerRef = (0, $bxRTa.useRef)(null);
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                transform: 'translateX(0%)',
                opacity: 0
            }
        }));
    const [springQr, apiQr] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        setTimeout(()=>{
            api.start({
                from: {
                    transform: 'translateX(100%)',
                    opacity: 0
                },
                to: {
                    transform: 'translateX(0%)',
                    opacity: 1
                },
                config: {
                    duration: $d0e2746b4da1d09a$var$springEnterDuration,
                    easing: (0, $2aMjv.easings).easeInBack
                }
            });
        }, index * 150);
    }, []);
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case 'openlanguage':
                setCurrentSubView((0, $2rYkD.CurrentSubView).languages);
                break;
            case 'openhistory':
                setCurrentSubView((0, $2rYkD.CurrentSubView).history);
                break;
            case 'opentutorial':
                console.log('Open tutorial');
                break;
            case 'opennews':
                setRoute((0, $2rYkD.Routes).News);
                break;
            case 'openweather':
                setCurrentSubView((0, $2rYkD.CurrentSubView).weather);
                break;
            case 'openemergency':
                setCurrentSubView((0, $2rYkD.CurrentSubView).emergency);
                break;
            case 'fullscreenimage':
                value.url && setFullScreenImage(value.url);
                break;
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        qrCodeData && apiQr.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $d0e2746b4da1d09a$var$springQrcodeDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        apiQr.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $d0e2746b4da1d09a$var$springQrcodeDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $d0e2746b4da1d09a$var$springQrcodeDuration);
    };
    const setQrCodeDataOverlay = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleClick = (e)=>{
        switch(action.type){
            case (0, $2rYkD.ActionType).message:
                action.value?.text && sendMessage(action.value.text);
                onClick();
                break;
            case (0, $2rYkD.ActionType).event:
                action.value?.name && sendEvent(action.value.name, action.value.value || null);
                onClick();
                break;
            case (0, $2rYkD.ActionType).url:
                if (action.value?.url) // Generate QR-code data on borne, open the URL otherwise
                isUsedOnBorne ? setQrCodeDataOverlay?.(action.value.url) : window.open(action.value.url, '_blank', 'noopener noreferrer');
                break;
            case (0, $2rYkD.ActionType).internal:
                handleInternalAction(action.value);
                onClick();
                break;
        }
        setClickedOnUI((0, $2rYkD.UIPart).card);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        ref: divRef,
        className: "rf-relative rf-w-32 tablet:rf-w-28 borne:rf-w-40 rf-aspect-square rf-p-3 borne:rf-p-5 rf-flex rf-flex-col rf-justify-between rf-items-center hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[3px_3px_16px_#00000029] rf-overflow-hidden",
        style: {
            color: textColor || '#575F6B',
            background: backgroundColor || 'linear-gradient(to left top, #F2F3F6, #E5E6EC)',
            ...spring
        },
        onClick: (e)=>handleClick(e),
        children: [
            image?.url && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-[50%] rf-flex rf-justify-center rf-items-center",
                children: image.url.indexOf('svg') > -1 ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5JKxf.default), {
                    svgUrl: image.url,
                    height: "100%",
                    fillColor: image.color
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-full",
                    src: image.url
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-[35%] rf-w-full rf-flex rf-justify-center rf-items-center rf-text-center rf-text-extra-small-size-auto rf-overflow-y-hidden rf-scrollbar-thin",
                dangerouslySetInnerHTML: {
                    __html: $d0e2746b4da1d09a$var$md.render(text)
                }
            }),
            qrCodeData && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: 'rgba(18,18,18,0.7)',
                    ...springQr
                },
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9TTQJ.default), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $d0e2746b4da1d09a$export$2e2bcd8739ae039 = $d0e2746b4da1d09a$var$DashboardItem;

});




parcelRegister("b7yy4", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hvc5r"),
    $parcel$import("aSHJY"),
    $parcel$import("lBnLP")
]).then(()=>parcelRequire('8DLzn'));

});

parcelRegister("lo8xw", function(module, exports) {

var $85V5Z = parcelRequire("85V5Z");
var $jcTbW = parcelRequire("jcTbW");
var $jjpOc = parcelRequire("jjpOc");
var $fWPg2 = parcelRequire("fWPg2");
var $20d7X = parcelRequire("20d7X");
var $3RAj2 = parcelRequire("3RAj2");
var $fnMfN = parcelRequire("fnMfN");
var $2eIQR = parcelRequire("2eIQR");
var $khunP = parcelRequire("khunP");

var $kKnec = parcelRequire("kKnec");
function $f92276aae71962b2$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $f92276aae71962b2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $f92276aae71962b2$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$f92276aae71962b2$var$$parcel$defineInteropFlag(module.exports);
$f92276aae71962b2$var$$parcel$export(module.exports, "default", ()=>$f92276aae71962b2$var$$882b6d93070905b3$export$2e2bcd8739ae039);
$f92276aae71962b2$var$$parcel$export(module.exports, "createSpeechRecognitionPonyfill", ()=>$f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0);
$f92276aae71962b2$var$$parcel$export(module.exports, "createSpeechSynthesisPonyfill", ()=>$f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c);
$f92276aae71962b2$var$$parcel$export(module.exports, "fetchAuthorizationToken", ()=>$f92276aae71962b2$var$$3e54160c801e3614$export$2e2bcd8739ae039);
$f92276aae71962b2$var$$parcel$export(module.exports, "SpeechSynthesisUtterance", ()=>$f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039);
$f92276aae71962b2$var$$parcel$export(module.exports, "SpeechSynthesis", ()=>$f92276aae71962b2$var$$0adf7fcdea541e7b$export$1268b12b5ca510be);
$f92276aae71962b2$var$$parcel$export(module.exports, "SpeechGrammarList", ()=>$f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039);
/* eslint class-methods-use-this: "off" */ /* eslint complexity: ["error", 70] */ /* eslint no-await-in-loop: "off" */ /* eslint no-empty-function: "off" */ /* eslint no-magic-numbers: ["error", { "ignore": [0, 100, 150] }] */ function $f92276aae71962b2$var$$e3680afa520905a3$export$2e2bcd8739ae039(array, extras) {
    const map = {
        // @ts-ignore
        ...[].reduce.call(array, (map, value, index)=>{
            // @ts-ignore
            map[index] = value;
            return map;
        }, {}),
        ...extras,
        length: array.length,
        [Symbol.iterator]: ()=>[].slice.call(map)[Symbol.iterator]()
    };
    return map;
}
var $f92276aae71962b2$var$$409c56140c6d134e$export$2e2bcd8739ae039 = {
    AudioConfig: $85V5Z.AudioConfig,
    OutputFormat: $jcTbW.OutputFormat,
    ResultReason: $20d7X.ResultReason,
    SpeechConfig: $fnMfN.SpeechConfig,
    SpeechRecognizer: $2eIQR.SpeechRecognizer,
    SpeechSynthesizer: $khunP.SpeechSynthesizer
};
const { ResultReason: { RecognizingSpeech: $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizingSpeech, RecognizedSpeech: $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech } } = $f92276aae71962b2$var$$409c56140c6d134e$export$2e2bcd8739ae039;
function $f92276aae71962b2$var$$4e800713d8cfc243$export$2e2bcd8739ae039(result, { maxAlternatives: maxAlternatives = Infinity, textNormalization: textNormalization = 'display' } = {}) {
    if (result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizingSpeech || result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech && !result.json.NBest) {
        const resultList = [
            {
                confidence: 0.5,
                transcript: result.text
            }
        ];
        if (result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech) resultList.isFinal = true;
        return resultList;
    } else if (result.reason === $f92276aae71962b2$var$$4e800713d8cfc243$var$RecognizedSpeech) {
        const resultList = $f92276aae71962b2$var$$e3680afa520905a3$export$2e2bcd8739ae039((result.json.NBest || []).slice(0, maxAlternatives).map(({ Confidence: confidence, Display: display, ITN: itn, Lexical: lexical, MaskedITN: maskedITN })=>({
                confidence: confidence,
                transcript: textNormalization === 'itn' ? itn : textNormalization === 'lexical' ? lexical : textNormalization === 'maskeditn' ? maskedITN : display
            })), {
            isFinal: true
        });
        return resultList;
    }
    return [];
}
function $f92276aae71962b2$var$$521b485d0cd15790$export$2e2bcd8739ae039() {
    let shiftDeferred;
    const queue = [];
    const push = (value)=>{
        if (shiftDeferred) {
            const { resolve: resolve } = shiftDeferred;
            shiftDeferred = null;
            resolve(value);
        } else queue.push(value);
    };
    const shift = ()=>{
        if (queue.length) return Promise.resolve(queue.shift());
        return (shiftDeferred || (shiftDeferred = $f92276aae71962b2$var$$parcel$interopDefault($kKnec)())).promise;
    };
    return {
        push: push,
        shift: shift
    };
}
function $f92276aae71962b2$var$$e2af95d6aca72d87$export$2e2bcd8739ae039(fnOrValue) {
    return typeof fnOrValue === 'function' ? fnOrValue() : fnOrValue;
}
let $f92276aae71962b2$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey = true;
function $f92276aae71962b2$var$$cec424af042710dc$export$2e2bcd8739ae039({ credentials: credentials, looseEvents: looseEvents, ...otherOptions }) {
    if (!credentials) throw new Error('web-speech-cognitive-services: Credentials must be specified.');
    return {
        ...otherOptions,
        fetchCredentials: async ()=>{
            const { authorizationToken: authorizationToken, customVoiceHostname: customVoiceHostname, region: region, speechRecognitionHostname: speechRecognitionHostname, speechSynthesisHostname: speechSynthesisHostname, subscriptionKey: subscriptionKey } = await $f92276aae71962b2$var$$e2af95d6aca72d87$export$2e2bcd8739ae039(credentials);
            if (!authorizationToken && !subscriptionKey || authorizationToken && subscriptionKey) throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
            else if (!region && !(speechRecognitionHostname && speechSynthesisHostname)) throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
            else if (region && (customVoiceHostname || speechRecognitionHostname || speechSynthesisHostname)) throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
            else if (authorizationToken) {
                if (typeof authorizationToken !== 'string') throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
            } else if (typeof subscriptionKey !== 'string') throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
            if ($f92276aae71962b2$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey && subscriptionKey) {
                console.warn('web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead.');
                $f92276aae71962b2$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey = false;
            }
            const resolvedCredentials = {
                region: region,
                authorizationToken: authorizationToken,
                subscriptionKey: subscriptionKey,
                customVoiceHostname: customVoiceHostname,
                speechRecognitionHostname: speechRecognitionHostname,
                speechSynthesisHostname: speechSynthesisHostname
            };
            return resolvedCredentials;
        },
        looseEvents: looseEvents
    };
}
/* eslint class-methods-use-this: "off" */ class $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039 {
    addFromString() {
        throw new Error('JSGF is not supported');
    }
    get phrases() {
        return this._phrases;
    }
    set phrases(value) {
        if (Array.isArray(value)) this._phrases = value;
        else if (typeof value === 'string') this._phrases = [
            value
        ];
        else throw new Error(`The provided value is not an array or of type 'string'`);
    }
    constructor(){
        this._phrases = [];
    }
}
// https://docs.microsoft.com/en-us/javascript/api/microsoft-cognitiveservices-speech-sdk/speechconfig?view=azure-node-latest#outputformat
// {
//   "RecognitionStatus": "Success",
//   "Offset": 900000,
//   "Duration": 49000000,
//   "NBest": [
//     {
//       "Confidence": 0.738919,
//       "Lexical": "second",
//       "ITN": "second",
//       "MaskedITN": "second",
//       "Display": "Second."
//     }
//   ]
// }
// {
//   "RecognitionStatus": "InitialSilenceTimeout",
//   "Offset": 50000000,
//   "Duration": 0
// }
// const { AudioConfig, OutputFormat, ResultReason, SpeechConfig, SpeechRecognizer } = SDK;
function $f92276aae71962b2$var$$87729c1c3277125d$var$serializeRecognitionResult({ duration: duration, errorDetails: errorDetails, json: json, offset: offset, properties: properties, reason: reason, resultId: resultId, text: text }) {
    return {
        duration: duration,
        errorDetails: errorDetails,
        json: JSON.parse(json),
        offset: offset,
        properties: properties,
        reason: reason,
        resultId: resultId,
        text: text
    };
}
function $f92276aae71962b2$var$$87729c1c3277125d$var$averageAmplitude(arrayBuffer) {
    const array = new Int16Array(arrayBuffer);
    return array.reduce((averageAmplitude, amplitude)=>averageAmplitude + Math.abs(amplitude), 0) / array.length;
}
function $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(fn) {
    return (...args)=>new Promise((resolve, reject)=>fn(...args, resolve, reject));
}
function $f92276aae71962b2$var$$87729c1c3277125d$var$prepareAudioConfig(audioConfig) {
    const originalAttach = audioConfig.attach;
    const boundOriginalAttach = audioConfig.attach.bind(audioConfig);
    let firstChunk = false;
    let muted = false;
    // We modify "attach" function and detect when audible chunk is read.
    // We will only modify "attach" function once.
    audioConfig.attach = async ()=>{
        const reader = await boundOriginalAttach();
        return {
            ...reader,
            read: async ()=>{
                const chunk = await reader.read();
                // The magic number 150 is measured by:
                // 1. Set microphone volume to 0
                // 2. Observe the amplitude (100-110) for the first few chunks
                //    (There is a short static caught when turning on the microphone)
                // 3. Set the number a bit higher than the observation
                if (!firstChunk && $f92276aae71962b2$var$$87729c1c3277125d$var$averageAmplitude(chunk.buffer) > 150) {
                    audioConfig.events.onEvent({
                        name: 'FirstAudibleChunk'
                    });
                    firstChunk = true;
                }
                if (muted) return {
                    buffer: new ArrayBuffer(0),
                    isEnd: true,
                    timeReceived: Date.now()
                };
                return chunk;
            }
        };
    };
    return {
        audioConfig: audioConfig,
        pause: ()=>{
            muted = true;
        },
        unprepare: ()=>{
            audioConfig.attach = originalAttach;
        }
    };
}
class $f92276aae71962b2$var$$87729c1c3277125d$export$7a5e8c1807e6b8ee {
    constructor(options, data){
        this.audioConfig = null;
        this.speechConfig = null;
        this.recognizer = null;
        this.enableTelemetry = true;
        this.looseEvents = false;
        this.textNormalization = 'display';
        this.started = false;
        this._autoStart = false;
        this._passive = false;
        this._continuous = false;
        this._interimResults = true;
        this._grammars = new $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039();
        this._maxAlternatives = 1;
        this._debug = false;
        this.onstart = ()=>{};
        this.onend = ()=>{};
        this.onpassivestart = ()=>{};
        this.onpassiveend = ()=>{};
        this.onaudiostart = ()=>{};
        this.onaudioend = ()=>{};
        this.onsoundstart = ()=>{};
        this.onsoundend = ()=>{};
        this.onspeechstart = ()=>{};
        this.onspeechend = ()=>{};
        this.onerror = (value)=>{
            console.log('Error : ', value);
        };
        this.onabort = ()=>{
            this._debug && console.log('Recognition aborted');
        };
        this.onresult = (value)=>{
            this._debug && console.log('Result : ', value);
        };
        this.onpassiveresult = (value)=>{
            this._debug && console.log('Passive Result : ', value);
        };
        this.onwakeup = ()=>{
            this._debug && console.log('Wake up !');
        };
        this.start = ()=>{
            this._startOnce().catch((err)=>{
                new Error(`error : ${err.message}\ncallstack : ${err.stack}`);
            });
        };
        this.abort = undefined;
        this.stop = undefined;
        /**
   * Retrieval of credentials, initialization of speechConfig and start recognizing
   * @param fetchCredentials Function
   * @param speechRecognitionEndpointId string | undefined
   */ this.initRecognizer = async (fetchCredentials, speechRecognitionEndpointId, timerBeforeSpeechEnd)=>{
            const { authorizationToken: authorizationToken, region: region = 'westus', speechRecognitionHostname: speechRecognitionHostname, subscriptionKey: subscriptionKey } = await fetchCredentials();
            if (speechRecognitionHostname) {
                // Process host name to add 'wss' if no protocol is given
                const processedHostName = speechRecognitionHostname.startsWith('ws://') || speechRecognitionHostname.startsWith('wss://') ? speechRecognitionHostname : `wss://${speechRecognitionHostname}`;
                if (authorizationToken) {
                    this.speechConfig = $fnMfN.SpeechConfig.fromHost(new URL(processedHostName));
                    this.speechConfig.authorizationToken = authorizationToken;
                } else this.speechConfig = $fnMfN.SpeechConfig.fromHost(new URL(processedHostName), subscriptionKey);
            } else if (region && (authorizationToken || subscriptionKey)) this.speechConfig = authorizationToken ? $fnMfN.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : subscriptionKey ? $fnMfN.SpeechConfig.fromSubscription(subscriptionKey, region) : null;
            if (this.speechConfig) {
                if (speechRecognitionEndpointId && this.speechConfig) this.speechConfig.endpointId = speechRecognitionEndpointId;
                this.speechConfig.outputFormat = $jcTbW.OutputFormat.Detailed;
                this.speechConfig.speechRecognitionLanguage = this._lang || 'en-US';
                timerBeforeSpeechEnd && this.speechConfig.setProperty($fWPg2.PropertyId[$fWPg2.PropertyId.Speech_SegmentationSilenceTimeoutMs], `${timerBeforeSpeechEnd}`);
                this._autoStart && this.start();
            }
        };
        /**
   * Create a new Synthesizer from audioConfig / speechConfig / lang
   * @param lang string
   */ this.createRecognizer = async ()=>{
            if (this.audioConfig && this.speechConfig) {
                this.speechConfig.speechRecognitionLanguage = this._lang;
                this.recognizer = new $2eIQR.SpeechRecognizer(this.speechConfig, this.audioConfig);
                // Add grammars
                const { dynamicGrammar: dynamicGrammar } = this.recognizer.internalData;
                this.referenceGrammars && this.referenceGrammars.length && dynamicGrammar.addReferenceGrammar(this.referenceGrammars);
                // Add phrases
                const { phrases: phrases } = this._grammars;
                if (phrases && phrases.length) {
                    const phraseList = $jjpOc.PhraseListGrammar.fromRecognizer(this.recognizer);
                    phrases.forEach((phrase)=>{
                        phraseList.addPhrase(phrase);
                    });
                }
            } else this.recognizer = null;
        };
        /**
   * Stop current recognizer, change language and start a new recognition
   * @param lang string
   */ this.changeLanguage = async (lang)=>{
            if (this.recognizer && this.audioConfig && this.speechConfig && lang && lang !== this._lang) {
                // Stop current recognition and start a new one
                await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._lang = lang;
                this._continuous && this.start();
            } else this.recognizer = null;
        };
        /**
   * In continuous mode, toggle from passive to active mode by stopping current recognition and starting a new one to prevent
   * receiving results from a current passive speech recognition.
   * If you don't care about having existing results in active recognition, just set recognition's 'passive' variable to 'false' instead
   * of using this method.
   */ this.toggleContinuousPassiveToActive = async ()=>{
            if (this._continuous && this.recognizer && this.audioConfig && this.speechConfig) {
                // Stop current recognition and start a new one
                if (this.started) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._continuous = false;
                this._passive = false;
                this.start();
            }
        };
        /**
   * In continuous mode, toggle from passive to active mode by stopping current recognition and starting a new one to prevent
   * receiving results from a current passive speech recognition.
   * If you don't care about having existing results in active recognition, just set recognition's 'passive' variable to 'false' instead
   * of using this method.
   */ this.toggleContinuousActiveToPassive = async ()=>{
            if (!this._continuous && this.recognizer && this.audioConfig && this.speechConfig) {
                // Stop current recognition and start a new one
                if (this.started) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._continuous = true;
                this._passive = true;
                this.start();
            }
        };
        this.processSendEvent = (type, data)=>{
            this._debug && console.log('Speech Recognizer Event : type = ', type, '\n, data = ', data);
            switch(type){
                case 'start':
                    if (this._passive) this.onpassivestart && this.onpassivestart();
                    else this.onstart && this.onstart();
                    this.started = true;
                    break;
                case 'end':
                    if (this._passive) this.onpassiveend && this.onpassiveend();
                    else this.onend && this.onend();
                    this.started = false;
                    break;
                case 'audiostart':
                    this.onaudiostart && this.onaudiostart();
                    break;
                case 'audioend':
                    this.onaudioend && this.onaudioend();
                    break;
                case 'soundstart':
                    this.onsoundstart && this.onsoundstart();
                    break;
                case 'soundend':
                    this.onsoundend && this.onsoundend();
                    break;
                case 'speechstart':
                    this.onspeechstart && this.onspeechstart();
                    break;
                case 'speechend':
                    this.onspeechend && this.onspeechend();
                    break;
                case 'error':
                    this.onerror && this.onerror(data);
                    this.started = false;
                    break;
                case 'abort':
                    this.onabort && this.onabort();
                    this.started = false;
                    break;
                case 'result':
                    this.onresult && this.onresult(data.results);
                    break;
                case 'passiveresult':
                    this.onpassiveresult && this.onpassiveresult(data.results);
                    break;
                case 'wakeup':
                    this.onwakeup && this.onwakeup();
                    break;
            }
        };
        this._autoStart = !!data?.autoStart;
        this._passive = !!data?.passive;
        this._wakeWords = data?.wakeWords || [];
        this._continuous = !!data?.continuous;
        this._interimResults = !(data?.interimResults === false);
        this._lang = data?.lang ? data.lang : typeof window !== 'undefined' ? window.document.documentElement.getAttribute('lang') || window.navigator.language : 'en-US';
        data?.grammarsList && (this._grammars.phrases = data.grammarsList);
        this._debug = !!data?.debug || false;
        const { audioConfig: audioConfig = null, enableTelemetry: // https://github.com/Microsoft/cognitive-services-speech-sdk-js#data--telemetry
        enableTelemetry = true, fetchCredentials: fetchCredentials, looseEvents: looseEvents, referenceGrammars: referenceGrammars, speechRecognitionEndpointId: speechRecognitionEndpointId, textNormalization: textNormalization = 'display' } = $f92276aae71962b2$var$$cec424af042710dc$export$2e2bcd8739ae039(options);
        this.enableTelemetry = enableTelemetry;
        this.looseEvents = !!looseEvents;
        this.referenceGrammars = referenceGrammars;
        this.textNormalization = textNormalization;
        if (!audioConfig && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) console.warn('web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.');
        else try {
            this.audioConfig = audioConfig || $85V5Z.AudioConfig.fromDefaultMicrophoneInput();
            this.initRecognizer(fetchCredentials, speechRecognitionEndpointId, data?.timerBeforeSpeechEnd);
        } catch (e) {
            console.warn(e);
        }
    }
    get passive() {
        return this._passive;
    }
    set passive(value) {
        this._passive = value;
    }
    get wakeWords() {
        return this._wakeWords;
    }
    set wakeWords(value) {
        this._wakeWords = value;
    }
    get continuous() {
        return this._continuous;
    }
    set continuous(value) {
        this._continuous = value;
    }
    get grammars() {
        return this._grammars;
    }
    set grammars(value) {
        if (value instanceof $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039) this._grammars = value;
        else throw new Error(`The provided value is not of type 'SpeechGrammarList'`);
    }
    get interimResults() {
        return this._interimResults;
    }
    set interimResults(value) {
        this._interimResults = value;
    }
    get maxAlternatives() {
        return this._maxAlternatives;
    }
    set maxAlternatives(value) {
        this._maxAlternatives = value;
    }
    get lang() {
        return this._lang;
    }
    set lang(value) {
        this._lang = value;
    }
    async _startOnce() {
        if (this.audioConfig && !this.started) {
            const { pause: pause, unprepare: unprepare } = $f92276aae71962b2$var$$87729c1c3277125d$var$prepareAudioConfig(this.audioConfig);
            const queue = $f92276aae71962b2$var$$521b485d0cd15790$export$2e2bcd8739ae039();
            let soundStarted = false;
            let speechStarted = false;
            let stopping = '';
            const { detach: detachAudioConfigEvent } = this.audioConfig.events.attach((event)=>{
                const { name: name } = event;
                if (name === 'AudioSourceReadyEvent') queue.push({
                    audioSourceReady: {}
                });
                else if (name === 'AudioSourceOffEvent') queue.push({
                    audioSourceOff: {}
                });
                else if (name === 'FirstAudibleChunk') queue.push({
                    firstAudibleChunk: {}
                });
            });
            await this.createRecognizer();
            if (this.recognizer) try {
                this.recognizer.canceled = (_, { errorDetails: errorDetails, offset: offset, reason: reason, sessionId: sessionId })=>{
                    queue.push({
                        canceled: {
                            errorDetails: errorDetails,
                            offset: offset,
                            reason: reason,
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.recognized = (_, { offset: offset, result: result, sessionId: sessionId })=>{
                    queue.push({
                        recognized: {
                            offset: offset,
                            result: $f92276aae71962b2$var$$87729c1c3277125d$var$serializeRecognitionResult(result),
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.recognizing = (_, { offset: offset, result: result, sessionId: sessionId })=>{
                    queue.push({
                        recognizing: {
                            offset: offset,
                            result: $f92276aae71962b2$var$$87729c1c3277125d$var$serializeRecognitionResult(result),
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.sessionStarted = (_, { sessionId: sessionId })=>{
                    queue.push({
                        sessionStarted: {
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.sessionStopped = (_, { sessionId: sessionId })=>{
                    // "sessionStopped" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                    queue.push({
                        sessionStopped: {
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.speechStartDetected = (_, { offset: offset, sessionId: sessionId })=>{
                    queue.push({
                        speechStartDetected: {
                            offset: offset,
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.speechEndDetected = (_, { sessionId: sessionId })=>{
                    // "speechEndDetected" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                    // Update: "speechEndDetected" is fired for DLSpeech.listenOnceAsync()
                    queue.push({
                        speechEndDetected: {
                            sessionId: sessionId
                        }
                    });
                };
                await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.startContinuousRecognitionAsync.bind(this.recognizer))();
                this.abort = ()=>queue.push({
                        abort: {}
                    });
                this.stop = ()=>queue.push({
                        stop: {}
                    });
                let audioStarted = false;
                let finalEvent = null;
                let finalizedResults = [];
                for(let loop = 0; !stopping || audioStarted; loop++){
                    const event = await queue.shift();
                    const { abort: abort, audioSourceOff: audioSourceOff, audioSourceReady: audioSourceReady, canceled: canceled, firstAudibleChunk: firstAudibleChunk, recognized: recognized, recognizing: recognizing, stop: stop } = event;
                    const errorMessage = canceled && canceled.errorDetails;
                    if (/Permission\sdenied/u.test(errorMessage || '')) {
                        // If microphone is not allowed, we should not emit "start" event.
                        finalEvent = {
                            data: 'not-allowed',
                            type: 'error'
                        };
                        break;
                    }
                    if (!loop) this.processSendEvent('start');
                    if (errorMessage) {
                        if (/1006/u.test(errorMessage)) {
                            if (!audioStarted) {
                                this.processSendEvent('audiostart');
                                this.processSendEvent('audioend');
                            }
                            finalEvent = {
                                data: 'network',
                                type: 'error'
                            };
                        } else finalEvent = {
                            data: 'unknown',
                            type: 'error'
                        };
                        break;
                    } else if (abort || stop) {
                        if (abort) {
                            finalEvent = {
                                type: 'abort'
                            };
                            // If we are aborting, we will ignore lingering recognizing/recognized events. But if we are stopping, we need them.
                            stopping = 'abort';
                        } else {
                            // When we pause, we will send { isEnd: true }, Speech Services will send us "recognized" event.
                            pause();
                            stopping = 'stop';
                        }
                        // Abort should not be dispatched without support of "stopContinuousRecognitionAsync".
                        // But for defensive purpose, we make sure "stopContinuousRecognitionAsync" is available before we can call.
                        if (abort && this.recognizer.stopContinuousRecognitionAsync) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                    } else if (audioSourceReady) {
                        this.processSendEvent('audiostart');
                        audioStarted = true;
                    } else if (firstAudibleChunk) {
                        this.processSendEvent('soundstart');
                        soundStarted = true;
                    } else if (audioSourceOff) {
                        // Looks like we don't need this line and all the tests are still working.
                        // Guessing probably stopping is already truthy.
                        // stopping = true;
                        speechStarted && this.processSendEvent('speechend');
                        soundStarted && this.processSendEvent('soundend');
                        audioStarted && this.processSendEvent('audioend');
                        audioStarted = soundStarted = speechStarted = false;
                        break;
                    } else if (stopping !== 'abort') {
                        if (recognized && recognized.result && recognized.result.reason === $20d7X.ResultReason.NoMatch) finalEvent = {
                            data: 'no-speech',
                            type: 'error'
                        };
                        else if (recognized || recognizing) {
                            if (!audioStarted) {
                                // Unconfirmed prevention of quirks
                                this.processSendEvent('audiostart');
                                audioStarted = true;
                            }
                            if (!soundStarted) {
                                this.processSendEvent('soundstart');
                                soundStarted = true;
                            }
                            if (!speechStarted) {
                                this.processSendEvent('speechstart');
                                speechStarted = true;
                            }
                            if (recognized) {
                                const result = $f92276aae71962b2$var$$4e800713d8cfc243$export$2e2bcd8739ae039(recognized.result, {
                                    maxAlternatives: this.maxAlternatives,
                                    textNormalization: this.textNormalization
                                });
                                const recognizable = !!result[0].transcript;
                                if (recognizable) {
                                    finalizedResults = [
                                        ...finalizedResults,
                                        ...result
                                    ];
                                    if (this._interimResults) {
                                        this.processSendEvent('result', {
                                            results: finalizedResults
                                        });
                                        this._passive && this.processSendEvent('passiveresult', {
                                            results: result
                                        });
                                    }
                                }
                                // If it is continuous, we just sent the finalized results. So we don't need to send it again after "audioend" event.
                                if (this._continuous && recognizable) finalEvent = null;
                                else this._interimResults && (finalEvent = {
                                    data: {
                                        results: finalizedResults
                                    },
                                    type: 'result'
                                });
                                if (!this._continuous && this.recognizer.stopContinuousRecognitionAsync) await $f92276aae71962b2$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                                // If event order can be loosened, we can send the recognized event as soon as we receive it.
                                // 1. If it is not recognizable (no-speech), we should send an "error" event just before "end" event. We will not loosen "error" events.
                                if (this.looseEvents && finalEvent && recognizable) {
                                    this.processSendEvent(finalEvent.type, finalEvent.data);
                                    finalEvent = null;
                                }
                            } else if (recognizing) {
                                const result = $f92276aae71962b2$var$$4e800713d8cfc243$export$2e2bcd8739ae039(recognizing.result, {
                                    maxAlternatives: this.maxAlternatives,
                                    textNormalization: this.textNormalization
                                });
                                if (this._passive && this._wakeWords && this._wakeWords.length > 0) {
                                    // Test wake words if some are present
                                    if (result && Array.isArray(result) && result.length > 0 && result[0].transcript) {
                                        const { transcript: transcript } = {
                                            ...result[0]
                                        };
                                        this._wakeWords.forEach((wakeWord)=>{
                                            if (transcript.toLowerCase().includes(wakeWord.toLowerCase())) this.processSendEvent('wakeup');
                                        });
                                    }
                                    this._interimResults && this.processSendEvent('passiveresult', {
                                        results: result
                                    });
                                }
                                this._interimResults && this.processSendEvent('result', {
                                    results: [
                                        ...finalizedResults,
                                        ...result
                                    ]
                                });
                            }
                        }
                    }
                }
                speechStarted && this.processSendEvent('speechend');
                soundStarted && this.processSendEvent('soundend');
                audioStarted && this.processSendEvent('audioend');
                if (finalEvent) {
                    if (finalEvent.type === 'result' && (typeof finalEvent.data === 'string' || !finalEvent.data?.results || !finalEvent.data.results.length)) finalEvent = {
                        data: 'no-speech',
                        type: 'error'
                    };
                    this.processSendEvent(finalEvent.type, finalEvent.data);
                }
                // Even though there is no "start" event emitted, we will still emit "end" event
                // This is mainly for "microphone blocked" story.
                this.processSendEvent('end');
                detachAudioConfigEvent && detachAudioConfigEvent();
            } catch (err) {
                // Logging out the erorr because Speech SDK would fail silently.
                console.error(err);
                throw err;
            } finally{
                unprepare();
                this.recognizer.close();
            }
        }
    }
}
const $f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0 = (options, data)=>{
    return {
        speechRecognition: new $f92276aae71962b2$var$$87729c1c3277125d$export$7a5e8c1807e6b8ee(options, data),
        SpeechGrammarList: $f92276aae71962b2$var$$c213b3979e1323e8$export$2e2bcd8739ae039
    };
};
var $f92276aae71962b2$var$$87729c1c3277125d$export$2e2bcd8739ae039 = $f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0;
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */ class $f92276aae71962b2$var$$fd1e2557ea351c52$var$SpeechSynthesisUtterance extends EventTarget {
    constructor(text){
        super(), this._lang = undefined, this._pitch = 1, this._rate = 1, this._voice = undefined, this._volume = 1;
        this.text = text;
    }
    get lang() {
        return this._lang;
    }
    set lang(value) {
        this._lang = value;
    }
    get pitch() {
        return this._pitch;
    }
    set pitch(value) {
        this._pitch = value;
    }
    get rate() {
        return this._rate;
    }
    set rate(value) {
        this._rate = value;
    }
    get voice() {
        return this._voice;
    }
    set voice(value) {
        this._voice = value;
    }
    get volume() {
        return this._volume;
    }
    set volume(value) {
        this._volume = value;
    }
    onstart() {}
    onend() {}
    onerror(error) {
        console.log(error);
    }
    onsynthesisstart() {}
    onsynthesiscompleted() {}
    onboundary(data) {
        console.log(data);
    }
    onviseme(data) {
        console.log(data);
    }
    onmark(data) {
        console.log(data);
    }
}
var $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039 = $f92276aae71962b2$var$$fd1e2557ea351c52$var$SpeechSynthesisUtterance;
class $f92276aae71962b2$var$$fd058ea71144ee3c$export$2e2bcd8739ae039 {
    constructor({ gender: gender, lang: lang, voiceURI: voiceURI }){
        this._default = false;
        this._localService = false;
        this._gender = gender;
        this._lang = lang;
        this._name = voiceURI;
        this._voiceURI = voiceURI;
    }
    get default() {
        return this._default;
    }
    get gender() {
        return this._gender;
    }
    get lang() {
        return this._lang;
    }
    get localService() {
        return this._localService;
    }
    get name() {
        return this._name;
    }
    get voiceURI() {
        return this._voiceURI;
    }
}
class $f92276aae71962b2$var$$0adf7fcdea541e7b$export$1268b12b5ca510be {
    constructor(options){
        this.speaking = false;
        this.speakerAudioDestination = new $3RAj2.SpeakerAudioDestination();
        this.audioConfig = undefined;
        this.speechConfig = null;
        this.queue = [];
        this.canceled = false;
        this.synth = null;
        this.synthesizing = false;
        // Function that returns an empty array of available voices
        this.getVoices = ()=>{
            return [];
        };
        this.onvoiceschanged = ()=>{
            console.log('Voices changed');
        };
        // Extract parameters from options using the patchOptions function
        const { audioContext: audioContext, fetchCredentials: fetchCredentials, ponyfill: ponyfill = {
            // @ts-ignore
            AudioContext: window.AudioContext || window.webkitAudioContext
        }, speechSynthesisDeploymentId: speechSynthesisDeploymentId } = $f92276aae71962b2$var$$cec424af042710dc$export$2e2bcd8739ae039(options);
        // Check if the browser supports the Web Audio API, if not, return an empty object
        if (!audioContext && !ponyfill.AudioContext) console.warn('web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.');
        else {
            this.audioConfig = $85V5Z.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
            // Init synthesizer
            this.initSpeechSynthesizer(fetchCredentials, speechSynthesisDeploymentId);
        }
    }
    mute() {
        this.speakerAudioDestination && this.speakerAudioDestination.mute();
    }
    unmute() {
        this.speakerAudioDestination && this.speakerAudioDestination.unmute();
    }
    getVolume() {
        // eslint-disable-next-line no-magic-numbers
        return this.speakerAudioDestination ? this.speakerAudioDestination.volume : -1;
    }
    setVolume(value) {
        this.speakerAudioDestination && (this.speakerAudioDestination.volume = value);
    }
    // Asynchronous function that initializes the speech synthesizer class
    async initSpeechSynthesizer(fetchCredentials, speechSynthesisDeploymentId) {
        const { speechSynthesisHostname: speechSynthesisHostname, subscriptionKey: subscriptionKey, authorizationToken: authorizationToken, region: region } = await fetchCredentials();
        if (!authorizationToken && !subscriptionKey) throw new Error('no subscription data : authorizationToken or subscriptionKey needed');
        // Configure the synthesizer and audio
        if (speechSynthesisDeploymentId) {
            const hostname = speechSynthesisHostname || `${region}.customvoice.api.speech.microsoft.com`;
            const url = `https://${encodeURI(hostname)}/api/texttospeech/v2.0/endpoints/${encodeURIComponent(speechSynthesisDeploymentId)}`;
            this.speechConfig = $fnMfN.SpeechConfig.fromEndpoint(new URL(url), subscriptionKey);
        } else if (speechSynthesisHostname) this.speechConfig = $fnMfN.SpeechConfig.fromHost(speechSynthesisHostname, subscriptionKey);
        else this.speechConfig = authorizationToken ? $fnMfN.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : $fnMfN.SpeechConfig.fromSubscription(subscriptionKey, region);
        this.synth = new $khunP.SpeechSynthesizer(this.speechConfig, this.audioConfig);
        // Update available voices
        this.updateVoices();
    }
    // Function to recreate the synthesizer
    createSynthesizer(voice, stream) {
        if (stream) this.audioConfig = $85V5Z.AudioConfig.fromStreamOutput(stream);
        else {
            this.speakerAudioDestination = new $3RAj2.SpeakerAudioDestination();
            this.audioConfig = $85V5Z.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
        }
        if (this.speechConfig) {
            if (voice) {
                const tempSpeechConfig = this.speechConfig;
                tempSpeechConfig.speechSynthesisVoiceName = voice;
                this.synth = new $khunP.SpeechSynthesizer(tempSpeechConfig, this.audioConfig);
            } else this.synth = new $khunP.SpeechSynthesizer(this.speechConfig, this.audioConfig);
        }
    }
    // Cancel current synthesis
    cancel() {
        if (this.synthesizing) try {
            // @ts-ignore
            this.synth && !this.synth.privDisposed && this.synth.close();
            this.queue = [];
        } catch (e) {
            console.warn(e);
        }
        else if (this.speaking) try {
            this.speakerAudioDestination.pause();
            this.speakerAudioDestination.onAudioEnd(this.speakerAudioDestination);
            this.speakerAudioDestination.close();
        } catch (e) {
            console.warn(e);
        }
        this.queue = [];
        this.canceled = true;
    }
    // Pause current synthesis
    pause() {
        if (this.speakerAudioDestination) this.speakerAudioDestination.pause();
    }
    // Resume current synthesis
    resume() {
        if (this.speakerAudioDestination && !this.canceled) this.speakerAudioDestination.resume();
    }
    /**
   * Add events listeners to the events received by the synthesizer if callbakcs are given in the utterance
   * @param {SpeechSynthesisUtterance} utterance
   */ linkEventsCallbacks(utterance) {
        if (this.synth) {
            // Events callbacks
            this.synth.synthesisStarted = ()=>{
                utterance.onsynthesisstart && utterance.onsynthesisstart();
                this.synthesizing = true;
            };
            this.synth.synthesisCompleted = ()=>{
                utterance.onsynthesiscompleted && utterance.onsynthesiscompleted();
                this.synthesizing = false;
            };
            this.synth.wordBoundary = (synth, e)=>{
                !synth && console.warn('No synthesizer');
                const data = {
                    boundaryType: e.boundaryType,
                    name: e.text,
                    elapsedTime: e.audioOffset,
                    duration: e.duration
                };
                utterance.onboundary && utterance.onboundary(data);
            };
            this.synth.visemeReceived = (synth, e)=>{
                !synth && console.warn('No synthesizer');
                const data = {
                    boundaryType: 'Viseme',
                    name: `${e.visemeId}`,
                    elapsedTime: e.audioOffset,
                    duration: 0
                };
                utterance.onboundary && utterance.onboundary(data);
                utterance.onviseme && utterance.onviseme(data);
            };
            this.synth.bookmarkReached = (synth, e)=>{
                !synth && console.warn('No synthesizer');
                const data = {
                    boundaryType: 'Mark',
                    name: e.text,
                    elapsedTime: e.audioOffset,
                    duration: 0
                };
                utterance.onmark && utterance.onmark(data);
            };
        }
    }
    /**
   * Launch synthesis and play sound with the speech synthesizer
   * @param {SpeechSynthesisUtterance} utterance 
   */ speak(utterance, stream) {
        // Test utterance
        if (!(utterance instanceof $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039)) throw new Error('invalid utterance');
        // Add the utterance to the queue
        this.queue.push(utterance);
        // Function to process the queued utterances
        const processQueue = ()=>{
            if (this.queue.length && !this.speaking) {
                const currentUtterance = this.queue.shift(); // Get the next utterance from the queue
                if (currentUtterance) {
                    const isSSML = /<speak[\s\S]*?>/iu.test(currentUtterance.text);
                    if (currentUtterance.voice && (currentUtterance.voice.voiceURI || currentUtterance.voice._name)) this.createSynthesizer(currentUtterance.voice.voiceURI || currentUtterance.voice._name, stream);
                    else this.createSynthesizer(undefined, stream);
                    // Set volume / mute status if present in the utterance parameters
                    currentUtterance.volume && (this.speakerAudioDestination.volume = currentUtterance.volume);
                    // SpeakerAudioDestination events callbacks
                    this.speakerAudioDestination.onAudioStart = ()=>{
                        this.speaking = true;
                        currentUtterance.onstart && currentUtterance.onstart();
                    };
                    this.speakerAudioDestination.onAudioEnd = ()=>{
                        this.speaking = false;
                        currentUtterance.onend && currentUtterance.onend();
                        processQueue(); // Process the next queued utterance after the current one has finished
                    };
                    this.linkEventsCallbacks(currentUtterance);
                    return isSSML ? new Promise((reject)=>{
                        this.synth && this.synth.speakSsmlAsync(currentUtterance.text, (result)=>{
                            if (result) this.synth && this.synth.close();
                            else reject(new Error('No synthesis result.'));
                        }, (error)=>{
                            reject(new Error(`Synthesis failed : ${error}`));
                        });
                    }) : new Promise((reject)=>{
                        this.synth && this.synth.speakTextAsync(currentUtterance.text, (result)=>{
                            if (result) this.synth && this.synth.close();
                            else reject(new Error('No synthesis result.'));
                        }, (error)=>{
                            reject(new Error(`Synthesis failed : ${error}`));
                        });
                    });
                }
            }
        };
        processQueue(); // Start processing the queue
        this.canceled = false; // Reset canceled state after processing the queue
    }
    /**
   * Launch synthesis without sound being played and call callback function with an ArrayBuffer after synthesis finished, containing the sound data
   * @param {SpeechSynthesisUtterance} utterance 
   * @param {Function} callback 
   */ synthesizeAndGetArrayData(utterance, callback) {
        // Test utterance
        if (!(utterance instanceof $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039)) throw new Error('invalid utterance');
        const isSSML = /<speak[\s\S]*?>/iu.test(utterance.text);
        if (this.speechConfig) {
            if (utterance.voice && (utterance.voice.voiceURI || utterance.voice._name)) {
                const tempSpeechConfig = this.speechConfig;
                tempSpeechConfig.speechSynthesisVoiceName = utterance.voice.voiceURI || utterance.voice._name;
                // @ts-ignore
                this.synth = new $khunP.SpeechSynthesizer(tempSpeechConfig, null);
            } else this.synth = new $khunP.SpeechSynthesizer(this.speechConfig, null);
        }
        this.linkEventsCallbacks(utterance);
        try {
            isSSML ? this.synth && this.synth.speakSsmlAsync(utterance.text, (result)=>{
                if (result && result.audioData) {
                    callback(result.audioData);
                    this.synth && this.synth.close();
                } else callback(null);
            }, (error)=>{
                console.error(error);
                callback(null);
            }) : this.synth && this.synth.speakTextAsync(utterance.text, (result)=>{
                if (result && result.audioData) {
                    callback(result.audioData);
                    this.synth && this.synth.close();
                } else callback(null);
            }, (error)=>{
                console.error(error);
                callback(null);
            });
        } catch (error) {
            console.error(error);
        }
    }
    // Asynchronous function that updates available voices
    async updateVoices() {
        const voicesResult = this.synth ? await this.synth.getVoicesAsync() : null;
        const voices = voicesResult?.voices;
        if (Array.isArray(voices)) {
            const formattedVoices = voices.map((voice)=>new $f92276aae71962b2$var$$fd058ea71144ee3c$export$2e2bcd8739ae039({
                    // eslint-disable-next-line no-magic-numbers
                    gender: voice.gender === 1 ? 'Female' : voice.gender === 2 ? 'Male' : 'Undefined',
                    lang: voice.locale,
                    voiceURI: voice.name
                }));
            this.getVoices = ()=>formattedVoices;
        } else console.warn("Failed to retrieve voices. 'voices' is not an array.");
        // Call 'onvoiceschanged' callback to notify the voices update
        this.onvoiceschanged();
    }
}
const $f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c = (options)=>{
    return {
        speechSynthesis: new $f92276aae71962b2$var$$0adf7fcdea541e7b$export$1268b12b5ca510be(options),
        SpeechSynthesisUtterance: $f92276aae71962b2$var$$fd1e2557ea351c52$export$2e2bcd8739ae039
    };
};
var $f92276aae71962b2$var$$0adf7fcdea541e7b$export$2e2bcd8739ae039 = $f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c;
const $f92276aae71962b2$var$$3e54160c801e3614$var$TOKEN_URL_TEMPLATE = 'https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken';
async function $f92276aae71962b2$var$$3e54160c801e3614$export$2e2bcd8739ae039({ region: region, subscriptionKey: subscriptionKey }) {
    if (!region || !subscriptionKey) throw new Error('Region AND subscription must be provided');
    else {
        const res = await fetch($f92276aae71962b2$var$$3e54160c801e3614$var$TOKEN_URL_TEMPLATE.replace(/\{region\}/u, region), {
            headers: {
                'Ocp-Apim-Subscription-Key': subscriptionKey
            },
            method: 'POST'
        });
        if (!res.ok) throw new Error(`Failed to fetch authorization token, server returned ${res.status}`);
        return res.text();
    }
}
function $f92276aae71962b2$var$$882b6d93070905b3$export$2e2bcd8739ae039(options, recognitionData) {
    return {
        ...$f92276aae71962b2$var$$87729c1c3277125d$export$7c06391dbd8298b0(options, recognitionData),
        ...$f92276aae71962b2$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c(options)
    };
}

});
parcelRegister("85V5Z", function(module, exports) {

$parcel$export(module.exports, "AudioConfig", () => $5e4b14609c3bc285$export$3b730bf34c92a0f9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $7rsPH = parcelRequire("7rsPH");
var $7uZTa = parcelRequire("7uZTa");
var $38XBR = parcelRequire("38XBR");

var $3SMEZ = parcelRequire("3SMEZ");

var $35Ity = parcelRequire("35Ity");
var $7pMg9 = parcelRequire("7pMg9");
var $kzV1n = parcelRequire("kzV1n");
var $92Nur = parcelRequire("92Nur");
var $3RAj2 = parcelRequire("3RAj2");

var $5d2Dz = parcelRequire("5d2Dz");

var $35Ity = parcelRequire("35Ity");

var $kzV1n = parcelRequire("kzV1n");
class $5e4b14609c3bc285$export$3b730bf34c92a0f9 {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromDefaultMicrophoneInput() {
        const pcmRecorder = new (0, $38XBR.PcmRecorder)(true);
        return new $5e4b14609c3bc285$export$7da309f8663a918b(new (0, $7uZTa.MicAudioSource)(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromMicrophoneInput(deviceId) {
        const pcmRecorder = new (0, $38XBR.PcmRecorder)(true);
        return new $5e4b14609c3bc285$export$7da309f8663a918b(new (0, $7uZTa.MicAudioSource)(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromWavFileInput(file, name = "unnamedBuffer.wav") {
        return new $5e4b14609c3bc285$export$7da309f8663a918b(new (0, $7rsPH.FileAudioSource)(file, name));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromStreamInput(audioStream) {
        if (audioStream instanceof (0, $7pMg9.PullAudioInputStreamCallback)) return new $5e4b14609c3bc285$export$7da309f8663a918b(new (0, $35Ity.PullAudioInputStreamImpl)(audioStream));
        if (audioStream instanceof (0, $35Ity.AudioInputStream)) return new $5e4b14609c3bc285$export$7da309f8663a918b(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            const pcmRecorder = new (0, $38XBR.PcmRecorder)(false);
            return new $5e4b14609c3bc285$export$7da309f8663a918b(new (0, $7uZTa.MicAudioSource)(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromDefaultSpeakerOutput() {
        return new $5e4b14609c3bc285$export$6474c8308a86365e(new (0, $3RAj2.SpeakerAudioDestination)());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ static fromSpeakerOutput(player) {
        if (player === undefined) return $5e4b14609c3bc285$export$3b730bf34c92a0f9.fromDefaultSpeakerOutput();
        if (player instanceof (0, $3RAj2.SpeakerAudioDestination)) return new $5e4b14609c3bc285$export$6474c8308a86365e(player);
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromAudioFileOutput(filename) {
        return new $5e4b14609c3bc285$export$6474c8308a86365e(new (0, $5d2Dz.AudioFileWriter)(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromStreamOutput(audioStream) {
        if (audioStream instanceof (0, $92Nur.PushAudioOutputStreamCallback)) return new $5e4b14609c3bc285$export$6474c8308a86365e(new (0, $kzV1n.PushAudioOutputStreamImpl)(audioStream));
        if (audioStream instanceof (0, $kzV1n.PushAudioOutputStream)) return new $5e4b14609c3bc285$export$6474c8308a86365e(audioStream);
        if (audioStream instanceof (0, $kzV1n.PullAudioOutputStream)) return new $5e4b14609c3bc285$export$6474c8308a86365e(audioStream);
        throw new Error("Not Supported Type");
    }
}
class $5e4b14609c3bc285$export$7da309f8663a918b extends $5e4b14609c3bc285$export$3b730bf34c92a0f9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ constructor(source){
        super();
        this.privSource = source;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        this.privSource.turnOff().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ id() {
        return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ attach(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ detach(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */ get events() {
        return this.privSource.events;
    }
    setProperty(name, value) {
        (0, $3SMEZ.Contracts).throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
class $5e4b14609c3bc285$export$6474c8308a86365e extends $5e4b14609c3bc285$export$3b730bf34c92a0f9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ constructor(destination){
        super();
        this.privDestination = destination;
    }
    set format(format) {
        this.privDestination.format = format;
    }
    write(buffer) {
        this.privDestination.write(buffer);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}

});
parcelRegister("7rsPH", function(module, exports) {

$parcel$export(module.exports, "FileAudioSource", () => $56b16b9bd5156b0e$export$2457f6fad5859840);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6xqgT = parcelRequire("6xqgT");

var $1AwHR = parcelRequire("1AwHR");
var $ds9gc = parcelRequire("ds9gc");
var $8lWt4 = parcelRequire("8lWt4");
var $ciGbY = parcelRequire("ciGbY");
var $5vbCN = parcelRequire("5vbCN");
var $9SKhX = parcelRequire("9SKhX");

var $hzVTX = parcelRequire("hzVTX");
var $56b16b9bd5156b0e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $56b16b9bd5156b0e$export$2457f6fad5859840 {
    constructor(file, filename, audioSourceId){
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.privId = audioSourceId ? audioSourceId : (0, $8lWt4.createNoDashGuid)();
        this.privEvents = new (0, $9SKhX.EventSource)();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            this.onEvent(new (0, $1AwHR.AudioSourceErrorEvent)(errorMsg, ""));
            return Promise.reject(errorMsg);
        }
        this.onEvent(new (0, $1AwHR.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $1AwHR.AudioSourceReadyEvent)(this.privId));
        return;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        return $56b16b9bd5156b0e$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            const stream = yield this.upload(audioNodeId);
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return Promise.resolve({
                detach: ()=>$56b16b9bd5156b0e$var$__awaiter(this, void 0, void 0, function*() {
                        stream.readEnded();
                        delete this.privStreams[audioNodeId];
                        this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        yield this.turnOff();
                    }),
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            });
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
        }
    }
    turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream && !stream.isClosed) stream.close();
        }
        this.onEvent(new (0, $1AwHR.AudioSourceOffEvent)(this.privId)); // no stream now
        return Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((result)=>Promise.resolve({
                bitspersample: result.bitsPerSample,
                channelcount: result.channels,
                connectivity: (0, $6xqgT.connectivity).Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: result.samplesPerSec,
                type: (0, $6xqgT.type).File
            }));
    }
    readHeader() {
        // Read the wave header.
        const maxHeaderSize = 4296;
        const header = this.privSource.slice(0, maxHeaderSize);
        const headerResult = new (0, $ciGbY.Deferred)();
        const processHeader = (header)=>{
            const view = new DataView(header);
            const getWord = (index)=>String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const formatSize = view.getInt32(16, true);
            const channelCount = view.getUint16(22, true);
            const sampleRate = view.getUint32(24, true);
            const bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            let pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = pos + 8;
            headerResult.resolve((0, $hzVTX.AudioStreamFormat).getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event)=>{
                const header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            const h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    }
    upload(audioNodeId) {
        return $56b16b9bd5156b0e$var$__awaiter(this, void 0, void 0, function*() {
            const onerror = (error)=>{
                const errorMsg = `Error occurred while processing '${this.privFilename}'. ${error}`;
                this.onEvent(new (0, $1AwHR.AudioStreamNodeErrorEvent)(this.privId, audioNodeId, errorMsg));
                throw new Error(errorMsg);
            };
            try {
                yield this.turnOn();
                const format = yield this.privAudioFormatPromise;
                const stream = new (0, $ds9gc.ChunkedArrayBufferStream)(format.avgBytesPerSec / 10, audioNodeId);
                this.privStreams[audioNodeId] = stream;
                const chunk = this.privSource.slice(this.privHeaderEnd);
                const processFile = (buff)=>{
                    if (stream.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                    stream.writeStreamChunk({
                        buffer: buff,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                    stream.close();
                };
                if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                    const reader = new FileReader();
                    reader.onerror = (ev)=>onerror(ev.toString());
                    reader.onload = (event)=>{
                        const fileBuffer = event.target.result;
                        processFile(fileBuffer);
                    };
                    reader.readAsArrayBuffer(chunk);
                } else {
                    const c = chunk;
                    processFile(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
                }
                return stream;
            } catch (e) {
                onerror(e);
            }
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $5vbCN.Events).instance.onEvent(event);
    }
}

});
parcelRegister("6xqgT", function(module, exports) {

$parcel$export(module.exports, "SpeechServiceConfig", () => $4c2a341d1e549fbb$export$51f52f0a07e48303);
$parcel$export(module.exports, "Context", () => $4c2a341d1e549fbb$export$841858b892ce1f4c);
$parcel$export(module.exports, "OS", () => $4c2a341d1e549fbb$export$decc4a6e69bbf763);
$parcel$export(module.exports, "connectivity", () => $4c2a341d1e549fbb$export$bc2c1e1c80c298f2);
$parcel$export(module.exports, "type", () => $4c2a341d1e549fbb$export$bf9fb029d174d554);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ // The config is serialized and sent as the Speech.Config
class $4c2a341d1e549fbb$export$51f52f0a07e48303 {
    constructor(context){
        this.context = context;
    }
    serialize() {
        return JSON.stringify(this, (key, value)=>{
            if (value && typeof value === "object" && !Array.isArray(value)) {
                const replacement = {};
                for(const k in value)if (Object.hasOwnProperty.call(value, k)) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                return replacement;
            }
            return value;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(value) {
        this.recognition = value.toLowerCase();
    }
}
class $4c2a341d1e549fbb$export$841858b892ce1f4c {
    constructor(os){
        this.system = new $4c2a341d1e549fbb$export$e1dae5660003ffa7();
        this.os = os;
    }
}
class $4c2a341d1e549fbb$export$e1dae5660003ffa7 {
    constructor(){
        // Note: below will be patched for official builds.
        const SPEECHSDK_CLIENTSDK_VERSION = "1.33.1";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
}
class $4c2a341d1e549fbb$export$decc4a6e69bbf763 {
    constructor(platform, name, version){
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
}
class $4c2a341d1e549fbb$export$8215d14a63d9fb10 {
    constructor(manufacturer, model, version){
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
}
var $4c2a341d1e549fbb$export$bc2c1e1c80c298f2;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($4c2a341d1e549fbb$export$bc2c1e1c80c298f2 || ($4c2a341d1e549fbb$export$bc2c1e1c80c298f2 = {}));
var $4c2a341d1e549fbb$export$bf9fb029d174d554;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($4c2a341d1e549fbb$export$bf9fb029d174d554 || ($4c2a341d1e549fbb$export$bf9fb029d174d554 = {}));

});

parcelRegister("1AwHR", function(module, exports) {

$parcel$export(module.exports, "AudioSourceInitializingEvent", () => $12828613243373fc$export$3ea896e783b014bc);
$parcel$export(module.exports, "AudioSourceReadyEvent", () => $12828613243373fc$export$54b576ec7ac02ebe);
$parcel$export(module.exports, "AudioSourceOffEvent", () => $12828613243373fc$export$6b78daffb3d5512d);
$parcel$export(module.exports, "AudioSourceErrorEvent", () => $12828613243373fc$export$846353fbe6243328);
$parcel$export(module.exports, "AudioStreamNodeAttachingEvent", () => $12828613243373fc$export$4fd6277c5ad6f287);
$parcel$export(module.exports, "AudioStreamNodeAttachedEvent", () => $12828613243373fc$export$5080ccbedcd117ea);
$parcel$export(module.exports, "AudioStreamNodeDetachedEvent", () => $12828613243373fc$export$cc8a6ff2edb60616);
$parcel$export(module.exports, "AudioStreamNodeErrorEvent", () => $12828613243373fc$export$787ac83068e70a4c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $dVTTx = parcelRequire("dVTTx");
class $12828613243373fc$export$46570d6d6ccc791d extends (0, $dVTTx.PlatformEvent) {
    constructor(eventName, audioSourceId, eventType = (0, $dVTTx.EventType).Info){
        super(eventName, eventType);
        this.privAudioSourceId = audioSourceId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
class $12828613243373fc$export$3ea896e783b014bc extends $12828613243373fc$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceInitializingEvent", audioSourceId);
    }
}
class $12828613243373fc$export$54b576ec7ac02ebe extends $12828613243373fc$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceReadyEvent", audioSourceId);
    }
}
class $12828613243373fc$export$6b78daffb3d5512d extends $12828613243373fc$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceOffEvent", audioSourceId);
    }
}
class $12828613243373fc$export$846353fbe6243328 extends $12828613243373fc$export$46570d6d6ccc791d {
    constructor(audioSourceId, error){
        super("AudioSourceErrorEvent", audioSourceId, (0, $dVTTx.EventType).Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
class $12828613243373fc$export$bcf1319de53b0d5d extends $12828613243373fc$export$46570d6d6ccc791d {
    constructor(eventName, audioSourceId, audioNodeId){
        super(eventName, audioSourceId);
        this.privAudioNodeId = audioNodeId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $12828613243373fc$export$4fd6277c5ad6f287 extends $12828613243373fc$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
    }
}
class $12828613243373fc$export$5080ccbedcd117ea extends $12828613243373fc$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
    }
}
class $12828613243373fc$export$cc8a6ff2edb60616 extends $12828613243373fc$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
    }
}
class $12828613243373fc$export$787ac83068e70a4c extends $12828613243373fc$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId, error){
        super("AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}

});
parcelRegister("dVTTx", function(module, exports) {

$parcel$export(module.exports, "EventType", () => $a24bf4c6b6d00914$export$3d7865934588d77e);
$parcel$export(module.exports, "PlatformEvent", () => $a24bf4c6b6d00914$export$fd68248162ec482a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8lWt4 = parcelRequire("8lWt4");
var $a24bf4c6b6d00914$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
    EventType[EventType["None"] = 4] = "None";
})($a24bf4c6b6d00914$export$3d7865934588d77e || ($a24bf4c6b6d00914$export$3d7865934588d77e = {}));
class $a24bf4c6b6d00914$export$fd68248162ec482a {
    constructor(eventName, eventType){
        this.privName = eventName;
        this.privEventId = (0, $8lWt4.createNoDashGuid)();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}

});
parcelRegister("8lWt4", function(module, exports) {

$parcel$export(module.exports, "createNoDashGuid", () => $614da360328fa112$export$992f04952fbcb07f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $1PPLO = parcelRequire("1PPLO");
const $614da360328fa112$export$7571c350ed9fec74 = ()=>(0, $1PPLO.default)();
const $614da360328fa112$export$992f04952fbcb07f = ()=>$614da360328fa112$export$7571c350ed9fec74().replace(new RegExp("-", "g"), "").toUpperCase();

});
parcelRegister("1PPLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1562b65b58b4e4cd$export$2e2bcd8739ae039);

var $6wFKq = parcelRequire("6wFKq");

var $lioNd = parcelRequire("lioNd");

var $7YlLv = parcelRequire("7YlLv");
function $1562b65b58b4e4cd$var$v4(options, buf, offset) {
    if ((0, $6wFKq.default).randomUUID && !buf && !options) return (0, $6wFKq.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $lioNd.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7YlLv.unsafeStringify)(rnds);
}
var $1562b65b58b4e4cd$export$2e2bcd8739ae039 = $1562b65b58b4e4cd$var$v4;

});
parcelRegister("6wFKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c061d7bf09094cb$export$2e2bcd8739ae039);
const $4c061d7bf09094cb$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $4c061d7bf09094cb$export$2e2bcd8739ae039 = {
    randomUUID: $4c061d7bf09094cb$var$randomUUID
};

});

parcelRegister("lioNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80e82bfba227050$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $f80e82bfba227050$var$getRandomValues;
const $f80e82bfba227050$var$rnds8 = new Uint8Array(16);
function $f80e82bfba227050$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$f80e82bfba227050$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $f80e82bfba227050$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$f80e82bfba227050$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $f80e82bfba227050$var$getRandomValues($f80e82bfba227050$var$rnds8);
}

});

parcelRegister("7YlLv", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $5cdf051e3a7f0f40$export$8fb373d660548968);

var $dVF9D = parcelRequire("dVF9D");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $5cdf051e3a7f0f40$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5cdf051e3a7f0f40$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5cdf051e3a7f0f40$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 0]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 1]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 2]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 3]] + '-' + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 4]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 5]] + '-' + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 6]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 7]] + '-' + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 8]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 9]] + '-' + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 10]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 11]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 12]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 13]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 14]] + $5cdf051e3a7f0f40$var$byteToHex[arr[offset + 15]];
}
function $5cdf051e3a7f0f40$var$stringify(arr, offset = 0) {
    const uuid = $5cdf051e3a7f0f40$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $dVF9D.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $5cdf051e3a7f0f40$export$2e2bcd8739ae039 = $5cdf051e3a7f0f40$var$stringify;

});
parcelRegister("dVF9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24085a4b68ae1eb$export$2e2bcd8739ae039);

var $4CEC2 = parcelRequire("4CEC2");
function $a24085a4b68ae1eb$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4CEC2.default).test(uuid);
}
var $a24085a4b68ae1eb$export$2e2bcd8739ae039 = $a24085a4b68ae1eb$var$validate;

});
parcelRegister("4CEC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $35da36d89b7de5e2$export$2e2bcd8739ae039);
var $35da36d89b7de5e2$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});







parcelRegister("ds9gc", function(module, exports) {

$parcel$export(module.exports, "ChunkedArrayBufferStream", () => $9cb512c8c40b5f4c$export$8451797d25cb97b2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $brK4I = parcelRequire("brK4I");
class $9cb512c8c40b5f4c$export$8451797d25cb97b2 extends (0, $brK4I.Stream) {
    constructor(targetChunkSize, streamId){
        super(streamId);
        this.privTargetChunkSize = targetChunkSize;
        this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(chunk);
            return;
        }
        let bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            const bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            const targetView = new Uint8Array(this.privNextBufferToWrite);
            const sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                super.writeStreamChunk({
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    }
    close() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        super.close();
    }
}

});
parcelRegister("brK4I", function(module, exports) {

$parcel$export(module.exports, "Stream", () => $8555f4e074c0502f$export$6a4eb2e7fc9e8903);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");

var $63lFD = parcelRequire("63lFD");
var $8555f4e074c0502f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $8555f4e074c0502f$export$6a4eb2e7fc9e8903 {
    constructor(streamId){
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.privId = streamId ? streamId : (0, $8lWt4.createNoDashGuid)();
        this.privReaderQueue = new (0, $63lFD.Queue)();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    }
    writeStreamChunk(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    }
    read() {
        if (this.privIsReadEnded) throw new (0, $3NF6I.InvalidOperationError)("Stream read has already finished");
        return this.privReaderQueue.dequeue().then((streamChunk)=>$8555f4e074c0502f$var$__awaiter(this, void 0, void 0, function*() {
                if (streamChunk === undefined || streamChunk.isEnd) yield this.privReaderQueue.dispose("End of stream reached");
                return streamChunk;
            }));
    }
    readEnded() {
        if (!this.privIsReadEnded) {
            this.privIsReadEnded = true;
            this.privReaderQueue = new (0, $63lFD.Queue)();
        }
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new (0, $3NF6I.InvalidOperationError)("Stream closed");
    }
}

});
parcelRegister("3NF6I", function(module, exports) {

$parcel$export(module.exports, "ArgumentNullError", () => $2c45d5bfcd53d721$export$5ab68a1dbe1fe1a4);
$parcel$export(module.exports, "InvalidOperationError", () => $2c45d5bfcd53d721$export$59a732e9476f38b5);
$parcel$export(module.exports, "ObjectDisposedError", () => $2c45d5bfcd53d721$export$1697868c944415ee);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ /**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ class $2c45d5bfcd53d721$export$5ab68a1dbe1fe1a4 extends Error {
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ constructor(argumentName){
        super(argumentName);
        this.name = "ArgumentNull";
        this.message = argumentName;
    }
}
class $2c45d5bfcd53d721$export$59a732e9476f38b5 extends Error {
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ constructor(error){
        super(error);
        this.name = "InvalidOperation";
        this.message = error;
    }
}
class $2c45d5bfcd53d721$export$1697868c944415ee extends Error {
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ constructor(objectName, error){
        super(error);
        this.name = objectName + "ObjectDisposed";
        this.message = error;
    }
}

});

parcelRegister("63lFD", function(module, exports) {

$parcel$export(module.exports, "Queue", () => $4683d5306442318e$export$3dc07afe418952bc);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $jHUvS = parcelRequire("jHUvS");

var $ciGbY = parcelRequire("ciGbY");
var $4683d5306442318e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4683d5306442318e$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($4683d5306442318e$var$SubscriberType || ($4683d5306442318e$var$SubscriberType = {}));
class $4683d5306442318e$export$3dc07afe418952bc {
    constructor(list){
        this.privPromiseStore = new (0, $jHUvS.List)();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.privList = list ? list : new (0, $jHUvS.List)();
        this.privDetachables = [];
        this.privSubscribers = new (0, $jHUvS.List)();
        this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
    enqueue(item) {
        this.throwIfDispose();
        this.enqueueFromPromise(new Promise((resolve)=>resolve(item)));
    }
    enqueueFromPromise(promise) {
        this.throwIfDispose();
        promise.then((val)=>{
            this.privList.add(val);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const deferredSubscriber = new (0, $ciGbY.Deferred)();
        if (this.privSubscribers) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $4683d5306442318e$var$SubscriberType.Dequeue
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    peek() {
        this.throwIfDispose();
        const deferredSubscriber = new (0, $ciGbY.Deferred)();
        const subs = this.privSubscribers;
        if (subs) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $4683d5306442318e$var$SubscriberType.Peek
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    length() {
        this.throwIfDispose();
        return this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    drainAndDispose(pendingItemProcessor, reason) {
        return $4683d5306442318e$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isDisposed() && !this.privIsDisposing) {
                this.privDisposeReason = reason;
                this.privIsDisposing = true;
                const subs = this.privSubscribers;
                if (subs) {
                    while(subs.length() > 0){
                        const subscriber = subs.removeFirst();
                        // TODO: this needs work (Resolve(null) instead?).
                        subscriber.deferral.resolve(undefined);
                    // subscriber.deferral.reject("Disposed");
                    }
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (this.privSubscribers === subs) this.privSubscribers = subs;
                }
                for (const detachable of this.privDetachables)yield detachable.detach();
                if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                    const promiseArray = [];
                    this.privPromiseStore.toArray().forEach((wrapper)=>{
                        promiseArray.push(wrapper);
                    });
                    return Promise.all(promiseArray).finally(()=>{
                        this.privSubscribers = null;
                        this.privList.forEach((item)=>{
                            pendingItemProcessor(item);
                        });
                        this.privList = null;
                        return;
                    }).then();
                } else {
                    this.privSubscribers = null;
                    this.privList = null;
                }
            }
        });
    }
    dispose(reason) {
        return $4683d5306442318e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.drainAndDispose(null, reason);
        });
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = true;
            const subs = this.privSubscribers;
            const lists = this.privList;
            if (subs && lists) {
                while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                    const subscriber = subs.removeFirst();
                    if (subscriber.type === $4683d5306442318e$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                    else {
                        const dequeuedItem = lists.removeFirst();
                        subscriber.deferral.resolve(dequeuedItem);
                    }
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privList === lists) this.privList = lists;
            }
            this.privIsDrainInProgress = false;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) {
            if (this.privDisposeReason) throw new (0, $3NF6I.InvalidOperationError)(this.privDisposeReason);
            throw new (0, $3NF6I.ObjectDisposedError)("Queue");
        } else if (this.privIsDisposing) throw new (0, $3NF6I.InvalidOperationError)("Queue disposing");
    }
}

});
parcelRegister("jHUvS", function(module, exports) {

$parcel$export(module.exports, "List", () => $e58dded2f036002a$export$54c2e3dc7acea9f5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");
class $e58dded2f036002a$export$54c2e3dc7acea9f5 {
    constructor(list){
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for (const item of list)this.privList.push(item);
    }
    get(itemIndex) {
        this.throwIfDisposed();
        return this.privList[itemIndex];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(item) {
        this.throwIfDisposed();
        this.insertAt(this.privList.length, item);
    }
    insertAt(index, item) {
        this.throwIfDisposed();
        if (index === 0) this.privList.unshift(item);
        else if (index === this.privList.length) this.privList.push(item);
        else this.privList.splice(index, 0, item);
        this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        this.throwIfDisposed();
        return this.removeAt(0);
    }
    removeLast() {
        this.throwIfDisposed();
        return this.removeAt(this.length() - 1);
    }
    removeAt(index) {
        this.throwIfDisposed();
        return this.remove(index, 1)[0];
    }
    remove(index, count) {
        this.throwIfDisposed();
        const removedElements = this.privList.splice(index, count);
        this.triggerSubscriptions(this.privRemoveSubscriptions);
        return removedElements;
    }
    clear() {
        this.throwIfDisposed();
        this.remove(0, this.length());
    }
    length() {
        this.throwIfDisposed();
        return this.privList.length;
    }
    onAdded(addedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privAddSubscriptions[subscriptionId] = addedCallback;
        return {
            detach: ()=>{
                delete this.privAddSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onRemoved(removedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privRemoveSubscriptions[subscriptionId] = removedCallback;
        return {
            detach: ()=>{
                delete this.privRemoveSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onDisposed(disposedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
        return {
            detach: ()=>{
                delete this.privDisposedSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    join(seperator) {
        this.throwIfDisposed();
        return this.privList.join(seperator);
    }
    toArray() {
        const cloneCopy = Array();
        this.privList.forEach((val)=>{
            cloneCopy.push(val);
        });
        return cloneCopy;
    }
    any(callback) {
        this.throwIfDisposed();
        if (callback) return this.where(callback).length() > 0;
        else return this.length() > 0;
    }
    all(callback) {
        this.throwIfDisposed();
        return this.where(callback).length() === this.length();
    }
    forEach(callback) {
        this.throwIfDisposed();
        for(let i = 0; i < this.length(); i++)callback(this.privList[i], i);
    }
    select(callback) {
        this.throwIfDisposed();
        const selectList = [];
        for(let i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
        return new $e58dded2f036002a$export$54c2e3dc7acea9f5(selectList);
    }
    where(callback) {
        this.throwIfDisposed();
        const filteredList = new $e58dded2f036002a$export$54c2e3dc7acea9f5();
        for(let i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
        return filteredList;
    }
    orderBy(compareFn) {
        this.throwIfDisposed();
        const clonedArray = this.toArray();
        const orderedArray = clonedArray.sort(compareFn);
        return new $e58dded2f036002a$export$54c2e3dc7acea9f5(orderedArray);
    }
    orderByDesc(compareFn) {
        this.throwIfDisposed();
        return this.orderBy((a, b)=>compareFn(b, a));
    }
    clone() {
        this.throwIfDisposed();
        return new $e58dded2f036002a$export$54c2e3dc7acea9f5(this.toArray());
    }
    concat(list) {
        this.throwIfDisposed();
        return new $e58dded2f036002a$export$54c2e3dc7acea9f5(this.privList.concat(list.toArray()));
    }
    concatArray(array) {
        this.throwIfDisposed();
        return new $e58dded2f036002a$export$54c2e3dc7acea9f5(this.privList.concat(array));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(reason) {
        if (!this.isDisposed()) {
            this.privDisposeReason = reason;
            this.privList = null;
            this.privAddSubscriptions = null;
            this.privRemoveSubscriptions = null;
            this.triggerSubscriptions(this.privDisposedSubscriptions);
        }
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new (0, $3NF6I.ObjectDisposedError)("List", this.privDisposeReason);
    }
    triggerSubscriptions(subscriptions) {
        if (subscriptions) {
            for(const subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
        }
    }
}

});

parcelRegister("ciGbY", function(module, exports) {

$parcel$export(module.exports, "Deferred", () => $8f47e4f5f5fe996a$export$85f6557964517f1a);
$parcel$export(module.exports, "marshalPromiseToCallbacks", () => $8f47e4f5f5fe996a$export$509551f10457d7e0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file, @typescript-eslint/typedef */ var $8f47e4f5f5fe996a$export$7bc76142acab2181;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($8f47e4f5f5fe996a$export$7bc76142acab2181 || ($8f47e4f5f5fe996a$export$7bc76142acab2181 = {}));
class $8f47e4f5f5fe996a$export$66aad414e2a6f5ad {
    constructor(promiseResultEventSource){
        this.throwIfError = ()=>{
            if (this.isError) throw this.error;
        };
        promiseResultEventSource.on((result)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = false;
                this.privResult = result;
            }
        }, (error)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = true;
                this.privError = error;
            }
        });
    }
    get isCompleted() {
        return this.privIsCompleted;
    }
    get isError() {
        return this.privIsError;
    }
    get error() {
        return this.privError;
    }
    get result() {
        return this.privResult;
    }
}
class $8f47e4f5f5fe996a$export$30541693eb0f7895 {
    constructor(){
        this.setResult = (result)=>{
            this.privOnSetResult(result);
        };
        this.setError = (error)=>{
            this.privOnSetError(error);
        };
        this.on = (onSetResult, onSetError)=>{
            this.privOnSetResult = onSetResult;
            this.privOnSetError = onSetError;
        };
    }
}
class $8f47e4f5f5fe996a$export$85f6557964517f1a {
    constructor(){
        this.resolve = (result)=>{
            this.privResolve(result);
            return this;
        };
        this.reject = (error)=>{
            this.privReject(error);
            return this;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.privPromise = new Promise((resolve, reject)=>{
            this.privResolve = resolve;
            this.privReject = reject;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
class $8f47e4f5f5fe996a$export$e287445474a1d9bf {
    constructor(){
        this.privState = $8f47e4f5f5fe996a$export$7bc76142acab2181.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.privPromiseResultEvents = new $8f47e4f5f5fe996a$export$30541693eb0f7895();
        this.privPromiseResult = new $8f47e4f5f5fe996a$export$66aad414e2a6f5ad(this.privPromiseResultEvents);
    }
    get state() {
        return this.privState;
    }
    get result() {
        return this.privPromiseResult;
    }
    resolve(result) {
        if (this.privState !== $8f47e4f5f5fe996a$export$7bc76142acab2181.None) throw new Error("'Cannot resolve a completed promise'");
        this.privState = $8f47e4f5f5fe996a$export$7bc76142acab2181.Resolved;
        this.privPromiseResultEvents.setResult(result);
        for(let i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
        this.detachHandlers();
    }
    reject(error) {
        if (this.privState !== $8f47e4f5f5fe996a$export$7bc76142acab2181.None) throw new Error("'Cannot reject a completed promise'");
        this.privState = $8f47e4f5f5fe996a$export$7bc76142acab2181.Rejected;
        this.privPromiseResultEvents.setError(error);
        for (const errorHandler of this.privErrorHandlers)this.executeErrorCallback(error, errorHandler);
        this.detachHandlers();
    }
    on(successCallback, errorCallback) {
        if (successCallback == null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        successCallback = ()=>{};
        if (this.privState === $8f47e4f5f5fe996a$export$7bc76142acab2181.None) {
            this.privSuccessHandlers.push(successCallback);
            this.privErrorHandlers.push(errorCallback);
        } else {
            if (this.privState === $8f47e4f5f5fe996a$export$7bc76142acab2181.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
            else if (this.privState === $8f47e4f5f5fe996a$export$7bc76142acab2181.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
            this.detachHandlers();
        }
    }
    executeSuccessCallback(result, successCallback, errorCallback) {
        try {
            successCallback(result);
        } catch (e) {
            this.executeErrorCallback(`'Unhandled callback error: ${e}'`, errorCallback);
        }
    }
    executeErrorCallback(error, errorCallback) {
        if (errorCallback) try {
            errorCallback(error);
        } catch (e) {
            throw new Error(`'Unhandled callback error: ${e}. InnerError: ${error}'`);
        }
        else throw new Error(`'Unhandled error: ${error}'`);
    }
    detachHandlers() {
        this.privErrorHandlers = [];
        this.privSuccessHandlers = [];
    }
}
function $8f47e4f5f5fe996a$export$509551f10457d7e0(promise, cb, err) {
    promise.then((val)=>{
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, (error)=>{
        if (!!err) try {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        // eslint-disable-next-line no-empty
        } catch (error) {}
    });
}

});




parcelRegister("5vbCN", function(module, exports) {

$parcel$export(module.exports, "Events", () => $4018dd6fa9e4d561$export$ada873a34909da65);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $9SKhX = parcelRequire("9SKhX");
class $4018dd6fa9e4d561$export$ada873a34909da65 {
    static setEventSource(eventSource) {
        if (!eventSource) throw new (0, $3NF6I.ArgumentNullError)("eventSource");
        $4018dd6fa9e4d561$export$ada873a34909da65.privInstance = eventSource;
    }
    static get instance() {
        return $4018dd6fa9e4d561$export$ada873a34909da65.privInstance;
    }
}
$4018dd6fa9e4d561$export$ada873a34909da65.privInstance = new (0, $9SKhX.EventSource)();

});
parcelRegister("9SKhX", function(module, exports) {

$parcel$export(module.exports, "EventSource", () => $731d102e8bff58d9$export$31c54eb8781d4391);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");
class $731d102e8bff58d9$export$31c54eb8781d4391 {
    constructor(metadata){
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.privConsoleListener = undefined;
        this.privMetadata = metadata;
    }
    onEvent(event) {
        if (this.isDisposed()) throw new (0, $3NF6I.ObjectDisposedError)("EventSource");
        if (this.metadata) {
            for(const paramName in this.metadata)if (paramName) {
                if (event.metadata) {
                    if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                }
            }
        }
        for(const eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
    }
    attach(onEventCallback) {
        const id = (0, $8lWt4.createNoDashGuid)();
        this.privEventListeners[id] = onEventCallback;
        return {
            detach: ()=>{
                delete this.privEventListeners[id];
                return Promise.resolve();
            }
        };
    }
    attachListener(listener) {
        return this.attach((e)=>listener.onEvent(e));
    }
    attachConsoleListener(listener) {
        if (!!this.privConsoleListener) this.privConsoleListener.detach(); // Detach implementation for eventListeners is synchronous
        this.privConsoleListener = this.attach((e)=>listener.onEvent(e));
        return this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null;
        this.privIsDisposed = true;
    }
    get metadata() {
        return this.privMetadata;
    }
}

});


parcelRegister("hzVTX", function(module, exports) {

$parcel$export(module.exports, "AudioFormatTag", () => $ccc29e9c8d1f38e2$export$97592a59cf8dc84a);
$parcel$export(module.exports, "AudioStreamFormat", () => $ccc29e9c8d1f38e2$export$2d50fcba14d14cb0);
$parcel$export(module.exports, "AudioStreamFormatImpl", () => $ccc29e9c8d1f38e2$export$22b9ff0cbb278347);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// eslint-disable-next-line max-classes-per-file
var $ccc29e9c8d1f38e2$export$97592a59cf8dc84a;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
    AudioFormatTag[AudioFormatTag["FLAC"] = 9] = "FLAC";
    AudioFormatTag[AudioFormatTag["OPUS"] = 10] = "OPUS";
})($ccc29e9c8d1f38e2$export$97592a59cf8dc84a || ($ccc29e9c8d1f38e2$export$97592a59cf8dc84a = {}));
class $ccc29e9c8d1f38e2$export$2d50fcba14d14cb0 {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getDefaultInputFormat() {
        return $ccc29e9c8d1f38e2$export$22b9ff0cbb278347.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormat(samplesPerSecond, bitsPerSample, channels, format) {
        return new $ccc29e9c8d1f38e2$export$22b9ff0cbb278347(samplesPerSecond, bitsPerSample, channels, format);
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
        return new $ccc29e9c8d1f38e2$export$22b9ff0cbb278347(samplesPerSecond, bitsPerSample, channels);
    }
}
class $ccc29e9c8d1f38e2$export$22b9ff0cbb278347 extends $ccc29e9c8d1f38e2$export$2d50fcba14d14cb0 {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ constructor(samplesPerSec = 16000, bitsPerSample = 16, channels = 1, format = $ccc29e9c8d1f38e2$export$97592a59cf8dc84a.PCM){
        super();
        let isWavFormat = true;
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $ccc29e9c8d1f38e2$export$97592a59cf8dc84a.PCM:
                this.formatTag = 1;
                break;
            case $ccc29e9c8d1f38e2$export$97592a59cf8dc84a.ALaw:
                this.formatTag = 6;
                break;
            case $ccc29e9c8d1f38e2$export$97592a59cf8dc84a.MuLaw:
                this.formatTag = 7;
                break;
            default:
                isWavFormat = false;
        }
        this.bitsPerSample = bitsPerSample;
        this.samplesPerSec = samplesPerSec;
        this.channels = channels;
        this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8);
        this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8);
        if (isWavFormat) {
            this.privHeader = new ArrayBuffer(44);
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
            const view = new DataView(this.privHeader);
            /* RIFF identifier */ this.setString(view, 0, "RIFF");
            /* file length */ view.setUint32(4, 0, true);
            /* RIFF type & Format */ this.setString(view, 8, "WAVEfmt ");
            /* format chunk length */ view.setUint32(16, 16, true);
            /* audio format */ view.setUint16(20, this.formatTag, true);
            /* channel count */ view.setUint16(22, this.channels, true);
            /* sample rate */ view.setUint32(24, this.samplesPerSec, true);
            /* byte rate (sample rate * block align) */ view.setUint32(28, this.avgBytesPerSec, true);
            /* block align (channel count * bytes per sample) */ view.setUint16(32, this.channels * (this.bitsPerSample / 8), true);
            /* bits per sample */ view.setUint16(34, this.bitsPerSample, true);
            /* data chunk identifier */ this.setString(view, 36, "data");
            /* data chunk length */ view.setUint32(40, 0, true);
        }
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ static getDefaultInputFormat() {
        return new $ccc29e9c8d1f38e2$export$22b9ff0cbb278347();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ /* eslint-disable */ static getAudioContext(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        const AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    get header() {
        return this.privHeader;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
}

});


parcelRegister("7uZTa", function(module, exports) {

$parcel$export(module.exports, "MicAudioSource", () => $575b579640329ac7$export$401b719c640c9369);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6xqgT = parcelRequire("6xqgT");

var $1AwHR = parcelRequire("1AwHR");
var $ds9gc = parcelRequire("ds9gc");
var $8lWt4 = parcelRequire("8lWt4");
var $ciGbY = parcelRequire("ciGbY");
var $5vbCN = parcelRequire("5vbCN");
var $9SKhX = parcelRequire("9SKhX");

var $hzVTX = parcelRequire("hzVTX");
var $575b579640329ac7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $575b579640329ac7$export$a38f7a762545a7e0 = "MICROPHONE-WorkletSourceUrl";
class $575b579640329ac7$export$401b719c640c9369 {
    constructor(privRecorder, deviceId, audioSourceId, mediaStream){
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.privOutputChunkSize = $575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : (0, $8lWt4.createNoDashGuid)();
        this.privEvents = new (0, $9SKhX.EventSource)();
        this.privMediaStream = mediaStream || null;
        this.privIsClosing = false;
    }
    get format() {
        return Promise.resolve($575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new (0, $ciGbY.Deferred)();
        try {
            this.createAudioContext();
        } catch (error) {
            if (error instanceof Error) {
                const typedError = error;
                this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
            } else this.privInitializeDeferral.reject(error);
            return this.privInitializeDeferral.promise;
        }
        const nav = window.navigator;
        let getUserMedia = // eslint-disable-next-line
        nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (!!nav.mediaDevices) getUserMedia = (constraints, successCallback, errorCallback)=>{
            nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
        if (!getUserMedia) {
            const errorMsg = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(errorMsg);
            this.onEvent(new (0, $1AwHR.AudioSourceErrorEvent)(errorMsg, "")); // mic initialized error - no streamid at this point
        } else {
            const next = ()=>{
                this.onEvent(new (0, $1AwHR.AudioSourceInitializingEvent)(this.privId)); // no stream id
                if (this.privMediaStream && this.privMediaStream.active) {
                    this.onEvent(new (0, $1AwHR.AudioSourceReadyEvent)(this.privId));
                    this.privInitializeDeferral.resolve();
                } else getUserMedia({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : true,
                    video: false
                }, (mediaStream)=>{
                    this.privMediaStream = mediaStream;
                    this.onEvent(new (0, $1AwHR.AudioSourceReadyEvent)(this.privId));
                    this.privInitializeDeferral.resolve();
                }, (error)=>{
                    const errorMsg = `Error occurred during microphone initialization: ${error}`;
                    this.privInitializeDeferral.reject(errorMsg);
                    this.onEvent(new (0, $1AwHR.AudioSourceErrorEvent)(this.privId, errorMsg));
                });
            };
            if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
            // https://github.com/WebAudio/web-audio-api/issues/790
            this.privContext.resume().then(next).catch((reason)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${reason}`);
            });
            else next();
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
        return this.listen(audioNodeId).then((stream)=>{
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>$575b579640329ac7$var$__awaiter(this, void 0, void 0, function*() {
                        stream.readEnded();
                        delete this.privStreams[audioNodeId];
                        this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        return this.turnOff();
                    }),
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
        }
    }
    turnOff() {
        return $575b579640329ac7$var$__awaiter(this, void 0, void 0, function*() {
            for(const streamId in this.privStreams)if (streamId) {
                const stream = this.privStreams[streamId];
                if (stream) stream.close();
            }
            this.onEvent(new (0, $1AwHR.AudioSourceOffEvent)(this.privId)); // no stream now
            if (this.privInitializeDeferral) {
                // Correctly handle when browser forces mic off before turnOn() completes
                // eslint-disable-next-line @typescript-eslint/await-thenable
                yield this.privInitializeDeferral;
                this.privInitializeDeferral = null;
            }
            yield this.destroyAudioContext();
            return;
        });
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((label)=>({
                bitspersample: $575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT.bitsPerSample,
                channelcount: $575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT.channels,
                connectivity: (0, $6xqgT.connectivity).Unknown,
                manufacturer: "Speech SDK",
                model: label,
                samplerate: $575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT.samplesPerSec,
                type: (0, $6xqgT.type).Microphones
            }));
    }
    setProperty(name, value) {
        if (name === $575b579640329ac7$export$a38f7a762545a7e0) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        const microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        const deferred = new (0, $ciGbY.Deferred)();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            for (const device of devices)if (device.deviceId === microphoneDeviceId) {
                // Found the device
                this.privMicrophoneLabel = device.label;
                break;
            }
            deferred.resolve(this.privMicrophoneLabel);
        }, ()=>deferred.resolve(this.privMicrophoneLabel));
        return deferred.promise;
    }
    listen(audioNodeId) {
        return $575b579640329ac7$var$__awaiter(this, void 0, void 0, function*() {
            yield this.turnOn();
            const stream = new (0, $ds9gc.ChunkedArrayBufferStream)(this.privOutputChunkSize, audioNodeId);
            this.privStreams[audioNodeId] = stream;
            try {
                this.privRecorder.record(this.privContext, this.privMediaStream, stream);
            } catch (error) {
                this.onEvent(new (0, $1AwHR.AudioStreamNodeErrorEvent)(this.privId, audioNodeId, error));
                throw error;
            }
            const result = stream;
            return result;
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $5vbCN.Events).instance.onEvent(event);
    }
    createAudioContext() {
        if (!!this.privContext) return;
        this.privContext = (0, $hzVTX.AudioStreamFormatImpl).getAudioContext($575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT.samplesPerSec);
    }
    destroyAudioContext() {
        return $575b579640329ac7$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privContext) return;
            this.privRecorder.releaseMediaResources(this.privContext);
            // This pattern brought to you by a bug in the TypeScript compiler where it
            // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
            // https://github.com/Microsoft/TypeScript/issues/11498
            let hasClose = false;
            if ("close" in this.privContext) hasClose = true;
            if (hasClose) {
                if (!this.privIsClosing) {
                    // The audio context close may take enough time that the close is called twice
                    this.privIsClosing = true;
                    yield this.privContext.close();
                    this.privContext = null;
                    this.privIsClosing = false;
                }
            } else if (null !== this.privContext && this.privContext.state === "running") // Suspend actually takes a callback, but analogous to the
            // resume method, it'll be only fired if suspend is called
            // in a direct response to a user action. The later is not always
            // the case, as TurnOff is also called, when we receive an
            // end-of-speech message from the service. So, doing a best effort
            // fire-and-forget here.
            yield this.privContext.suspend();
        });
    }
}
$575b579640329ac7$export$401b719c640c9369.AUDIOFORMAT = (0, $hzVTX.AudioStreamFormat).getDefaultInputFormat();

});

parcelRegister("38XBR", function(module, exports) {

$parcel$export(module.exports, "PcmRecorder", () => $24a05bb4ec29c64d$export$b4d48a500005f7a2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $csECP = parcelRequire("csECP");

class $24a05bb4ec29c64d$export$b4d48a500005f7a2 {
    constructor(stopInputOnRelease){
        this.privStopInputOnRelease = stopInputOnRelease;
    }
    record(context, mediaStream, outputStream) {
        const desiredSampleRate = 16000;
        const waveStreamEncoder = new (0, $csECP.RiffPcmEncoder)(context.sampleRate, desiredSampleRate);
        const micInput = context.createMediaStreamSource(mediaStream);
        const attachScriptProcessor = ()=>{
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const scriptNode = (()=>{
                let bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    let audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            })();
            scriptNode.onaudioprocess = (event)=>{
                const inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(scriptNode);
            scriptNode.connect(context.destination);
            this.privMediaResources = {
                scriptProcessorNode: scriptNode,
                source: micInput,
                stream: mediaStream
            };
        };
        const connectWorkletToMicInput = (context)=>{
            const workletNode = new AudioWorkletNode(context, "speech-processor");
            workletNode.port.onmessage = (ev)=>{
                const inputFrame = ev.data;
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(workletNode);
            workletNode.connect(context.destination);
            this.privMediaResources = {
                scriptProcessorNode: workletNode,
                source: micInput,
                stream: mediaStream
            };
        };
        // https://webaudio.github.io/web-audio-api/#audioworklet
        // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
        const skipAudioWorklet = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
        if (!!context.audioWorklet && !skipAudioWorklet) {
            /* eslint-disable-next-line */ this.privSpeechProcessorScript = new URL((parcelRequire("7hg9t"))).toString();
            context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                connectWorkletToMicInput(context);
            }).catch(()=>{
                const workletScript = `class SP extends AudioWorkletProcessor {
                        constructor(options) {
                        super(options);
                        }
                        process(inputs, outputs) {
                        const input = inputs[0];
                        const output = [];
                        for (let channel = 0; channel < input.length; channel += 1) {
                            output[channel] = input[channel];
                        }
                        this.port.postMessage(output[0]);
                        return true;
                        }
                    }
                    registerProcessor('speech-processor', SP);`;
                const blob = new Blob([
                    workletScript
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                this.privSpeechProcessorScript = URL.createObjectURL(blob);
                context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                    connectWorkletToMicInput(context);
                }).catch(()=>{
                    attachScriptProcessor();
                });
            });
        } else try {
            attachScriptProcessor();
        } catch (err) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${err}`);
        }
    }
    releaseMediaResources(context) {
        if (this.privMediaResources) {
            if (this.privMediaResources.scriptProcessorNode) {
                this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                this.privMediaResources.scriptProcessorNode = null;
            }
            if (this.privMediaResources.source) {
                this.privMediaResources.source.disconnect();
                if (this.privStopInputOnRelease) this.privMediaResources.stream.getTracks().forEach((track)=>track.stop());
                this.privMediaResources.source = null;
            }
        }
    }
    setWorkletUrl(url) {
        this.privSpeechProcessorScript = url;
    }
}

});
parcelRegister("csECP", function(module, exports) {

$parcel$export(module.exports, "RiffPcmEncoder", () => $91279cdf251eb24d$export$f0c1cabbb64251f4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $91279cdf251eb24d$export$f0c1cabbb64251f4 {
    constructor(actualSampleRate, desiredSampleRate){
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
    encode(actualAudioFrame) {
        const audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!audioFrame) return null;
        const audioLength = audioFrame.length * 2;
        const buffer = new ArrayBuffer(audioLength);
        const view = new DataView(buffer);
        this.floatTo16BitPCM(view, 0, audioFrame);
        return buffer;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
    floatTo16BitPCM(view, offset, input) {
        for(let i = 0; i < input.length; i++, offset += 2){
            const s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    }
    downSampleAudioFrame(srcFrame, srcRate, dstRate) {
        if (!srcFrame) return null;
        if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
        const ratio = srcRate / dstRate;
        const dstLength = Math.round(srcFrame.length / ratio);
        const dstFrame = new Float32Array(dstLength);
        let srcOffset = 0;
        let dstOffset = 0;
        while(dstOffset < dstLength){
            const nextSrcOffset = Math.round((dstOffset + 1) * ratio);
            let accum = 0;
            let count = 0;
            while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                accum += srcFrame[srcOffset++];
                count++;
            }
            dstFrame[dstOffset++] = accum / count;
        }
        return dstFrame;
    }
}

});

parcelRegister("7hg9t", function(module, exports) {
module.exports = $parcel$resolve("1B7Z5");

});


parcelRegister("3SMEZ", function(module, exports) {

$parcel$export(module.exports, "Contracts", () => $2d3c291d0e7973d0$export$e93adfd13fa159ba);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * @class Contracts
 * @private
 */ class $2d3c291d0e7973d0$export$e93adfd13fa159ba {
    static throwIfNullOrUndefined(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    }
    static throwIfNull(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    }
    static throwIfNullOrWhitespace(param, name) {
        $2d3c291d0e7973d0$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    }
    static throwIfNullOrTooLong(param, name, maxLength) {
        $2d3c291d0e7973d0$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).length > maxLength) throw new Error("throwIfNullOrTooLong:" + name + " (more than " + maxLength.toString() + " characters)");
    }
    static throwIfNullOrTooShort(param, name, minLength) {
        $2d3c291d0e7973d0$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).length < minLength) throw new Error("throwIfNullOrTooShort:" + name + " (less than " + minLength.toString() + " characters)");
    }
    static throwIfDisposed(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(array, name) {
        $2d3c291d0e7973d0$export$e93adfd13fa159ba.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for (const item of array)$2d3c291d0e7973d0$export$e93adfd13fa159ba.throwIfNullOrWhitespace(item, name);
    }
    static throwIfFileDoesNotExist(param, name) {
        $2d3c291d0e7973d0$export$e93adfd13fa159ba.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    }
    static throwIfNotUndefined(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    }
}

});

parcelRegister("35Ity", function(module, exports) {

$parcel$export(module.exports, "AudioInputStream", () => $240456aa2db316f1$export$d2b41ea729bcd23a);
$parcel$export(module.exports, "PullAudioInputStreamImpl", () => $240456aa2db316f1$export$aa28c96dd85a430d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6xqgT = parcelRequire("6xqgT");

var $1AwHR = parcelRequire("1AwHR");
var $ds9gc = parcelRequire("ds9gc");
var $5vbCN = parcelRequire("5vbCN");
var $9SKhX = parcelRequire("9SKhX");

var $8lWt4 = parcelRequire("8lWt4");

var $hzVTX = parcelRequire("hzVTX");

var $hzVTX = parcelRequire("hzVTX");

var $f2Nvv = parcelRequire("f2Nvv");
var $240456aa2db316f1$require$Buffer = $f2Nvv.Buffer;
var $240456aa2db316f1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $240456aa2db316f1$export$d2b41ea729bcd23a {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ static createPushStream(format) {
        return $240456aa2db316f1$export$c65274612fceab73.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ static createPullStream(callback, format) {
        return $240456aa2db316f1$export$2b6293045b3dda4e.create(callback, format);
    // throw new Error("Oops");
    }
}
class $240456aa2db316f1$export$c65274612fceab73 extends $240456aa2db316f1$export$d2b41ea729bcd23a {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ static create(format) {
        return new $240456aa2db316f1$export$96d17a539b8936d6(format);
    }
}
class $240456aa2db316f1$export$96d17a539b8936d6 extends $240456aa2db316f1$export$c65274612fceab73 {
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ constructor(format){
        super();
        if (format === undefined) this.privFormat = (0, $hzVTX.AudioStreamFormatImpl).getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new (0, $9SKhX.EventSource)();
        this.privId = (0, $8lWt4.createNoDashGuid)();
        this.privStream = new (0, $ds9gc.ChunkedArrayBufferStream)(this.privFormat.avgBytesPerSec / 10);
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new (0, $1AwHR.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $1AwHR.AudioSourceReadyEvent)(this.privId));
        return;
    }
    attach(audioNodeId) {
        return $240456aa2db316f1$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            yield this.turnOn();
            const stream = this.privStream;
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>$240456aa2db316f1$var$__awaiter(this, void 0, void 0, function*() {
                        this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        return this.turnOff();
                    }),
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: (0, $6xqgT.connectivity).Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: (0, $6xqgT.type).Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $5vbCN.Events).instance.onEvent(event);
    }
    toBuffer(arrayBuffer) {
        const buf = $240456aa2db316f1$require$Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for(let i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    }
}
class $240456aa2db316f1$export$2b6293045b3dda4e extends $240456aa2db316f1$export$d2b41ea729bcd23a {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ static create(callback, format) {
        return new $240456aa2db316f1$export$aa28c96dd85a430d(callback, format);
    }
}
class $240456aa2db316f1$export$aa28c96dd85a430d extends $240456aa2db316f1$export$2b6293045b3dda4e {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ constructor(callback, format){
        super();
        if (undefined === format) this.privFormat = (0, $hzVTX.AudioStreamFormat).getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new (0, $9SKhX.EventSource)();
        this.privId = (0, $8lWt4.createNoDashGuid)();
        this.privCallback = callback;
        this.privIsClosed = false;
        this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privIsClosed = true;
        this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new (0, $1AwHR.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $1AwHR.AudioSourceReadyEvent)(this.privId));
        return;
    }
    attach(audioNodeId) {
        return $240456aa2db316f1$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            yield this.turnOn();
            this.onEvent(new (0, $1AwHR.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>{
                    this.privCallback.close();
                    this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                    return this.turnOff();
                },
                id: ()=>audioNodeId,
                read: ()=>{
                    let totalBytes = 0;
                    let transmitBuff;
                    // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                    while(totalBytes < this.privBufferSize){
                        // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                        // data back.
                        const readBuff = new ArrayBuffer(this.privBufferSize - totalBytes);
                        const pulledBytes = this.privCallback.read(readBuff);
                        // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                        // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                        // preferred size allocated.
                        if (undefined === transmitBuff) transmitBuff = readBuff;
                        else {
                            // Not the first bite at the apple, so fill the return buffer with the data we got back.
                            const intView = new Int8Array(transmitBuff);
                            intView.set(new Int8Array(readBuff), totalBytes);
                        }
                        // If there are no bytes to read, just break out and be done.
                        if (0 === pulledBytes) break;
                        totalBytes += pulledBytes;
                    }
                    return Promise.resolve({
                        buffer: transmitBuff.slice(0, totalBytes),
                        isEnd: this.privIsClosed || totalBytes === 0,
                        timeReceived: Date.now()
                    });
                }
            };
        });
    }
    detach(audioNodeId) {
        this.onEvent(new (0, $1AwHR.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: (0, $6xqgT.connectivity).Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: (0, $6xqgT.type).Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $5vbCN.Events).instance.onEvent(event);
    }
}

});

parcelRegister("7pMg9", function(module, exports) {

$parcel$export(module.exports, "PullAudioInputStreamCallback", () => $56604d866a7afa1d$export$2d63425b32f9d538);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ class $56604d866a7afa1d$export$2d63425b32f9d538 {
}

});

parcelRegister("kzV1n", function(module, exports) {

$parcel$export(module.exports, "PullAudioOutputStream", () => $efb34ec3a539ab8b$export$bdc5f48d2816203a);
$parcel$export(module.exports, "PullAudioOutputStreamImpl", () => $efb34ec3a539ab8b$export$ccb0817f052cc8c4);
$parcel$export(module.exports, "PushAudioOutputStream", () => $efb34ec3a539ab8b$export$cabdb2d97c90043d);
$parcel$export(module.exports, "PushAudioOutputStreamImpl", () => $efb34ec3a539ab8b$export$8469916a21360061);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8lWt4 = parcelRequire("8lWt4");
var $brK4I = parcelRequire("brK4I");

var $3SMEZ = parcelRequire("3SMEZ");

var $913NY = parcelRequire("913NY");
var $efb34ec3a539ab8b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $efb34ec3a539ab8b$export$e0b7acef3648253f {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ static createPullStream() {
        return $efb34ec3a539ab8b$export$bdc5f48d2816203a.create();
    }
}
class $efb34ec3a539ab8b$export$bdc5f48d2816203a extends $efb34ec3a539ab8b$export$e0b7acef3648253f {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ static create() {
        return new $efb34ec3a539ab8b$export$ccb0817f052cc8c4();
    }
}
class $efb34ec3a539ab8b$export$ccb0817f052cc8c4 extends $efb34ec3a539ab8b$export$bdc5f48d2816203a {
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ constructor(){
        super();
        this.privId = (0, $8lWt4.createNoDashGuid)();
        this.privStream = new (0, $brK4I.Stream)();
    }
    /**
     * Sets the format information to the stream. For internal use only.
     * @param {AudioStreamFormat} format - the format to be set.
     */ set format(format) {
        if (format === undefined || format === null) this.privFormat = (0, $913NY.AudioOutputFormatImpl).getDefaultOutputFormat();
        this.privFormat = format;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ id() {
        return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ read(dataBuffer) {
        return $efb34ec3a539ab8b$var$__awaiter(this, void 0, void 0, function*() {
            const intView = new Int8Array(dataBuffer);
            let totalBytes = 0;
            if (this.privLastChunkView !== undefined) {
                if (this.privLastChunkView.length > dataBuffer.byteLength) {
                    intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                    this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                    return Promise.resolve(dataBuffer.byteLength);
                }
                intView.set(this.privLastChunkView);
                totalBytes = this.privLastChunkView.length;
                this.privLastChunkView = undefined;
            }
            // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
            while(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded){
                const chunk = yield this.privStream.read();
                if (chunk !== undefined && !chunk.isEnd) {
                    let tmpBuffer;
                    if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                        tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                        this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                    } else tmpBuffer = chunk.buffer;
                    intView.set(new Int8Array(tmpBuffer), totalBytes);
                    totalBytes += tmpBuffer.byteLength;
                } else this.privStream.readEnded();
            }
            return totalBytes;
        });
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        (0, $3SMEZ.Contracts).throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
}
class $efb34ec3a539ab8b$export$cabdb2d97c90043d extends $efb34ec3a539ab8b$export$e0b7acef3648253f {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ static create(callback) {
        return new $efb34ec3a539ab8b$export$8469916a21360061(callback);
    }
}
class $efb34ec3a539ab8b$export$8469916a21360061 extends $efb34ec3a539ab8b$export$cabdb2d97c90043d {
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     */ constructor(callback){
        super();
        this.privId = (0, $8lWt4.createNoDashGuid)();
        this.privCallback = callback;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(format) {}
    write(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    }
    close() {
        if (!!this.privCallback.close) this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}

});
parcelRegister("913NY", function(module, exports) {

$parcel$export(module.exports, "AudioOutputFormatImpl", () => $690728ad26725fe0$export$53c5e8ad1050e453);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $38QGp = parcelRequire("38QGp");

var $hzVTX = parcelRequire("hzVTX");
class $690728ad26725fe0$export$53c5e8ad1050e453 extends (0, $hzVTX.AudioStreamFormatImpl) {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader){
        super(samplesPerSec, bitsPerSample, channels, formatTag);
        this.formatTag = formatTag;
        this.avgBytesPerSec = avgBytesPerSec;
        this.blockAlign = blockAlign;
        this.priAudioFormatString = audioFormatString;
        this.priRequestAudioFormatString = requestAudioFormatString;
        this.priHasHeader = hasHeader;
    }
    static fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return $690728ad26725fe0$export$53c5e8ad1050e453.getDefaultOutputFormat();
        return $690728ad26725fe0$export$53c5e8ad1050e453.fromSpeechSynthesisOutputFormatString($690728ad26725fe0$export$53c5e8ad1050e453.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
    static fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).WEBM_OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).WEBM_OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).WEBM_OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-mono-flac":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).FLAC, 1, 24000, 24000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-16bit-mono-flac":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).FLAC, 1, 48000, 30000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "raw-22050hz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-22050hz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, "raw-22050hz-16bit-mono-pcm", true);
            case "raw-44100hz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-44100hz-16bit-mono-pcm":
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, "raw-44100hz-16bit-mono-pcm", true);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $690728ad26725fe0$export$53c5e8ad1050e453((0, $hzVTX.AudioFormatTag).PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    }
    static getDefaultOutputFormat() {
        return $690728ad26725fe0$export$53c5e8ad1050e453.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */ get header() {
        if (this.hasHeader) return this.privHeader;
        return undefined;
    }
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ updateHeader(audioLength) {
        if (this.priHasHeader) {
            const view = new DataView(this.privHeader);
            view.setUint32(4, audioLength + this.privHeader.byteLength - 8, true);
            view.setUint32(40, audioLength, true);
        }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
    /**
     * Adds audio header
     * @param audio the raw audio without header
     * @returns the audio with header if applicable
     */ addHeader(audio) {
        if (!this.hasHeader) return audio;
        this.updateHeader(audio.byteLength);
        const tmp = new Uint8Array(audio.byteLength + this.header.byteLength);
        tmp.set(new Uint8Array(this.header), 0);
        tmp.set(new Uint8Array(audio), this.header.byteLength);
        return tmp.buffer;
    }
}
$690728ad26725fe0$export$53c5e8ad1050e453.SpeechSynthesisOutputFormatToString = {
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [(0, $38QGp.SpeechSynthesisOutputFormat).Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm"
};

});
parcelRegister("38QGp", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisOutputFormat", () => $249afc32f4439222$export$3671c0863ecfe8a6);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $249afc32f4439222$export$3671c0863ecfe8a6;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
    /**
     * webm-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec in a webm container, with bitrate of 24kbps, optimized for IoT scenario.
     * Added in version 1.19.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16Bit24KbpsMonoOpus"] = 29] = "Webm24Khz16Bit24KbpsMonoOpus";
    /**
     * audio-16khz-16bit-32kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 32kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16Bit32KbpsMonoOpus"] = 30] = "Audio16Khz16Bit32KbpsMonoOpus";
    /**
     * audio-24khz-16bit-48kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 48kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit48KbpsMonoOpus"] = 31] = "Audio24Khz16Bit48KbpsMonoOpus";
    /**
     * audio-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 24kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit24KbpsMonoOpus"] = 32] = "Audio24Khz16Bit24KbpsMonoOpus";
    /**
     * raw-22050hz-16bit-mono-pcm
     * Raw PCM audio at 22050Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw22050Hz16BitMonoPcm"] = 33] = "Raw22050Hz16BitMonoPcm";
    /**
     * riff-22050hz-16bit-mono-pcm
     * PCM audio at 22050Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff22050Hz16BitMonoPcm"] = 34] = "Riff22050Hz16BitMonoPcm";
    /**
     * raw-44100hz-16bit-mono-pcm
     * Raw PCM audio at 44100Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw44100Hz16BitMonoPcm"] = 35] = "Raw44100Hz16BitMonoPcm";
    /**
     * riff-44100hz-16bit-mono-pcm
     * PCM audio at 44100Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff44100Hz16BitMonoPcm"] = 36] = "Riff44100Hz16BitMonoPcm";
})($249afc32f4439222$export$3671c0863ecfe8a6 || ($249afc32f4439222$export$3671c0863ecfe8a6 = {}));

});



parcelRegister("92Nur", function(module, exports) {

$parcel$export(module.exports, "PushAudioOutputStreamCallback", () => $695ab09f88963d4f$export$af7283ebc568ec10);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ class $695ab09f88963d4f$export$af7283ebc568ec10 {
}

});

parcelRegister("3RAj2", function(module, exports) {

$parcel$export(module.exports, "SpeakerAudioDestination", () => $2d027bf4788f0616$export$c717373bdea3ec69);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lWqSg = parcelRequire("lWqSg");
var $8lWt4 = parcelRequire("8lWt4");
var $5vbCN = parcelRequire("5vbCN");

var $kzV1n = parcelRequire("kzV1n");

var $hzVTX = parcelRequire("hzVTX");
var $2d027bf4788f0616$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2d027bf4788f0616$var$MediaDurationPlaceholderSeconds = 1800;
const $2d027bf4788f0616$var$AudioFormatToMimeType = {
    [(0, $hzVTX.AudioFormatTag).PCM]: "audio/wav",
    [(0, $hzVTX.AudioFormatTag).MuLaw]: "audio/x-wav",
    [(0, $hzVTX.AudioFormatTag).MP3]: "audio/mpeg",
    [(0, $hzVTX.AudioFormatTag).OGG_OPUS]: "audio/ogg",
    [(0, $hzVTX.AudioFormatTag).WEBM_OPUS]: "audio/webm; codecs=opus",
    [(0, $hzVTX.AudioFormatTag).ALaw]: "audio/x-wav",
    [(0, $hzVTX.AudioFormatTag).FLAC]: "audio/flac"
};
class $2d027bf4788f0616$export$c717373bdea3ec69 {
    constructor(audioDestinationId){
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : (0, $8lWt4.createNoDashGuid)();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    id() {
        return this.privId;
    }
    write(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    }
    close(cb, err) {
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined && typeof window !== "undefined") {
            if ((this.privFormat.formatTag === (0, $hzVTX.AudioFormatTag).PCM || this.privFormat.formatTag === (0, $hzVTX.AudioFormatTag).MuLaw || this.privFormat.formatTag === (0, $hzVTX.AudioFormatTag).ALaw) && this.privFormat.hasHeader === false) {
                // eslint-disable-next-line no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                let receivedAudio = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio).then(()=>{
                    receivedAudio = this.privFormat.addHeader(receivedAudio);
                    const audioBlob = new Blob([
                        receivedAudio
                    ], {
                        type: $2d027bf4788f0616$var$AudioFormatToMimeType[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    this.notifyPlayback().then(()=>{
                        if (!!cb) cb();
                    }, (error)=>{
                        if (!!err) err(error);
                    });
                }, (error)=>{
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    }
    set format(format) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof AudioContext !== "undefined" || typeof window !== "undefined" && typeof window.webkitAudioContext !== "undefined") {
            this.privFormat = format;
            const mimeType = $2d027bf4788f0616$var$AudioFormatToMimeType[this.privFormat.formatTag];
            if (mimeType === undefined) // eslint-disable-next-line no-console
            console.warn(`Unknown mimeType for format ${(0, $hzVTX.AudioFormatTag)[this.privFormat.formatTag]}; playback is not supported.`);
            else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
                this.privAudio = new Audio();
                this.privAudioBuffer = [];
                this.privMediaSource = new MediaSource();
                this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                this.privAudio.load();
                this.privMediaSource.onsourceopen = ()=>{
                    this.privMediaSourceOpened = true;
                    this.privMediaSource.duration = $2d027bf4788f0616$var$MediaDurationPlaceholderSeconds;
                    this.privSourceBuffer = this.privMediaSource.addSourceBuffer(mimeType);
                    this.privSourceBuffer.onupdate = ()=>{
                        this.updateSourceBuffer().catch((reason)=>{
                            (0, $5vbCN.Events).instance.onEvent(new (0, $lWqSg.BackgroundEvent)(reason));
                        });
                    };
                    this.privSourceBuffer.onupdateend = ()=>{
                        this.handleSourceBufferUpdateEnd().catch((reason)=>{
                            (0, $5vbCN.Events).instance.onEvent(new (0, $lWqSg.BackgroundEvent)(reason));
                        });
                    };
                    this.privSourceBuffer.onupdatestart = ()=>{
                        this.privAppendingToBuffer = false;
                    };
                };
                this.updateSourceBuffer().catch((reason)=>{
                    (0, $5vbCN.Events).instance.onEvent(new (0, $lWqSg.BackgroundEvent)(reason));
                });
            } else {
                // eslint-disable-next-line no-console
                console.warn(`Format ${(0, $hzVTX.AudioFormatTag)[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`);
                this.privAudioOutputStream = new (0, $kzV1n.PullAudioOutputStreamImpl)();
                this.privAudioOutputStream.format = this.privFormat;
                this.privAudio = new Audio();
            }
        }
    }
    get volume() {
        var _a, _b;
        return (_b = (_a = this.privAudio) === null || _a === void 0 ? void 0 : _a.volume) !== null && _b !== void 0 ? _b : -1;
    }
    set volume(volume) {
        if (!!this.privAudio) this.privAudio.volume = volume;
    }
    mute() {
        if (!!this.privAudio) this.privAudio.muted = true;
    }
    unmute() {
        if (!!this.privAudio) this.privAudio.muted = false;
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        if (this.privAudio !== undefined) return this.privAudio.currentTime;
        return -1;
    }
    pause() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    }
    resume(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    }
    get internalAudio() {
        return this.privAudio;
    }
    updateSourceBuffer() {
        return $2d027bf4788f0616$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
                this.privAppendingToBuffer = true;
                const binary = this.privAudioBuffer.shift();
                try {
                    this.privSourceBuffer.appendBuffer(binary);
                } catch (error) {
                    this.privAudioBuffer.unshift(binary);
                    // eslint-disable-next-line no-console
                    console.log("buffer filled, pausing addition of binaries until space is made");
                    return;
                }
                yield this.notifyPlayback();
            } else if (this.canEndStream()) yield this.handleSourceBufferUpdateEnd();
        });
    }
    handleSourceBufferUpdateEnd() {
        return $2d027bf4788f0616$var$__awaiter(this, void 0, void 0, function*() {
            if (this.canEndStream() && this.sourceBufferAvailable()) {
                this.privMediaSource.endOfStream();
                yield this.notifyPlayback();
            }
        });
    }
    notifyPlayback() {
        return $2d027bf4788f0616$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privPlaybackStarted && this.privAudio !== undefined) {
                this.privPlaybackStarted = true;
                if (!!this.onAudioStart) this.onAudioStart(this);
                this.privAudio.onended = ()=>{
                    if (!!this.onAudioEnd) this.onAudioEnd(this);
                };
                if (!this.privIsPaused) yield this.privAudio.play();
            }
        });
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
}

});
parcelRegister("lWqSg", function(module, exports) {

$parcel$export(module.exports, "BackgroundEvent", () => $ff93dc6908a54656$export$3e33db5d08e1fac7);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $dVTTx = parcelRequire("dVTTx");
class $ff93dc6908a54656$export$3e33db5d08e1fac7 extends (0, $dVTTx.PlatformEvent) {
    constructor(error){
        super("BackgroundEvent", (0, $dVTTx.EventType).Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}

});


parcelRegister("5d2Dz", function(module, exports) {

$parcel$export(module.exports, "AudioFileWriter", () => $3cb0365e19847bc3$export$b18256b0fa0aa326);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $9zn7p = parcelRequire("9zn7p");

var $3SMEZ = parcelRequire("3SMEZ");
class $3cb0365e19847bc3$export$b18256b0fa0aa326 {
    constructor(filename){
        (0, $3SMEZ.Contracts).throwIfNullOrUndefined($9zn7p.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $9zn7p.openSync(filename, "w");
    }
    set format(format) {
        (0, $3SMEZ.Contracts).throwIfNotUndefined(this.privAudioFormat, "format is already set");
        this.privAudioFormat = format;
        let headerOffset = 0;
        if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
        if (this.privFd !== undefined) this.privWriteStream = $9zn7p.createWriteStream("", {
            fd: this.privFd,
            start: headerOffset,
            autoClose: false
        });
    }
    write(buffer) {
        (0, $3SMEZ.Contracts).throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    }
    close() {
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", ()=>{
                if (this.privAudioFormat.hasHeader) {
                    this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten);
                    $9zn7p.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0);
                }
                $9zn7p.closeSync(this.privFd);
                this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    }
    id() {
        return this.privId;
    }
}

});


parcelRegister("jcTbW", function(module, exports) {

$parcel$export(module.exports, "OutputFormat", () => $dfb9f335ea62f961$export$ed6df354c75a09e0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $dfb9f335ea62f961$export$ed6df354c75a09e0;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($dfb9f335ea62f961$export$ed6df354c75a09e0 || ($dfb9f335ea62f961$export$ed6df354c75a09e0 = {}));

});

parcelRegister("jjpOc", function(module, exports) {

$parcel$export(module.exports, "PhraseListGrammar", () => $e0f3cfb916fc7ae1$export$f794bc66b259065e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */ class $e0f3cfb916fc7ae1$export$f794bc66b259065e {
    constructor(recogBase){
        this.privGrammerBuilder = recogBase.dynamicGrammar;
    }
    /**
     * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
     * @param recognizer The recognizer to add phrase lists to.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        return new $e0f3cfb916fc7ae1$export$f794bc66b259065e(recoBase);
    }
    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */ addPhrase(phrase) {
        this.privGrammerBuilder.addPhrase(phrase);
    }
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */ addPhrases(phrases) {
        this.privGrammerBuilder.addPhrase(phrases);
    }
    /**
     * Clears all phrases added to the current recognizer.
     */ clear() {
        this.privGrammerBuilder.clearPhrases();
    }
}

});

parcelRegister("fWPg2", function(module, exports) {

$parcel$export(module.exports, "PropertyId", () => $b9c4087a93e84323$export$f7caa2a6f083d81);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $b9c4087a93e84323$export$f7caa2a6f083d81;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to
     * specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A duration of detected silence, measured in milliseconds, after which speech-to-text will determine a spoken
     * phrase has ended and generate a final Recognized result. Configuring this timeout may be helpful in situations
     * where spoken input is significantly faster or slower than usual and default segmentation behavior consistently
     * yields results that are too long or too short. Segmentation timeout values that are inappropriately high or low
     * can negatively affect speech-to-text accuracy; this property should be carefully configured and the resulting
     * behavior should be thoroughly validated as intended.
     *
     * For more information about timeout configuration that includes discussion of default behaviors, please visit
     * https://aka.ms/csspeech/timeouts.
     *
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["Speech_SegmentationSilenceTimeoutMs"] = 32] = "Speech_SegmentationSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Audio and content logs are stored either in Microsoft-owned storage, or in your own storage account linked
     * to your Cognitive Services subscription (Bring Your Own Storage (BYOS) enabled Speech resource).
     * The logs will be removed after 30 days.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 33] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The speech service connection language identifier mode.
     * Can be "AtStart" (the default), or "Continuous". See Language
     * Identification document https://aka.ms/speech/lid?pivots=programming-language-javascript
     * for more details.
     * Added in 1.25.0
     **/ PropertyId[PropertyId["SpeechServiceConnection_LanguageIdMode"] = 34] = "SpeechServiceConnection_LanguageIdMode";
    /**
     * A string value representing the desired endpoint version to target for Speech Recognition.
     * Added in version 1.21.0
     */ PropertyId[PropertyId["SpeechServiceConnection_RecognitionEndpointVersion"] = 35] = "SpeechServiceConnection_RecognitionEndpointVersion";
    /**
    /**
     * A string value the current speaker recognition scenario/mode (TextIndependentIdentification, etc.).
     * Added in version 1.23.0
     */ PropertyId[PropertyId["SpeechServiceConnection_SpeakerIdMode"] = 36] = "SpeechServiceConnection_SpeakerIdMode";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 37] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 38] = "SpeechServiceResponse_PostProcessingOption";
    /**
     * A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 40] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 41] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * A boolean value specifying whether to request WordBoundary events.
     * @member PropertyId.SpeechServiceResponse_RequestWordBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordBoundary"] = 43] = "SpeechServiceResponse_RequestWordBoundary";
    /**
     * A boolean value specifying whether to request punctuation boundary in WordBoundary Events. Default is true.
     * @member PropertyId.SpeechServiceResponse_RequestPunctuationBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestPunctuationBoundary"] = 44] = "SpeechServiceResponse_RequestPunctuationBoundary";
    /**
     * A boolean value specifying whether to request sentence boundary in WordBoundary Events. Default is false.
     * @member PropertyId.SpeechServiceResponse_RequestSentenceBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestSentenceBoundary"] = 45] = "SpeechServiceResponse_RequestSentenceBoundary";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 46] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 47] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 48] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 49] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 50] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 51] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 52] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 53] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 54] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 55] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 56] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 57] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 58] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 59] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 60] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 61] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 62] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 63] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 64] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 65] = "PronunciationAssessment_Params";
    /**
     * Version of Speaker Recognition API to use.
     * Added in version 1.18.0
     */ PropertyId[PropertyId["SpeakerRecognition_Api_Version"] = 66] = "SpeakerRecognition_Api_Version";
    /**
     * Specifies whether to allow load of data URL for web worker
     * Allowed values are "off" and "on". Default is "on".
     * Added in version 1.32.0
     */ PropertyId[PropertyId["WebWorkerLoadType"] = 67] = "WebWorkerLoadType";
    /**
     * Talking avatar service WebRTC session description protocol.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.33.0
     */ PropertyId[PropertyId["TalkingAvatarService_WebRTC_SDP"] = 68] = "TalkingAvatarService_WebRTC_SDP";
})($b9c4087a93e84323$export$f7caa2a6f083d81 || ($b9c4087a93e84323$export$f7caa2a6f083d81 = {}));

});

parcelRegister("20d7X", function(module, exports) {

$parcel$export(module.exports, "ResultReason", () => $1755c3b092484014$export$3527eaa7db1a45df);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $1755c3b092484014$export$3527eaa7db1a45df;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
    /**
     * Indicates synthesis voices list has been successfully retrieved.
     * @member ResultReason.VoicesListRetrieved
     */ ResultReason[ResultReason["VoicesListRetrieved"] = 18] = "VoicesListRetrieved";
    /**
     * Indicates the transcription result contains hypothesis text and its translation(s) for
     * other participants in the conversation.
     * @member ResultReason.TranslatingParticipantSpeech
     */ ResultReason[ResultReason["TranslatingParticipantSpeech"] = 19] = "TranslatingParticipantSpeech";
    /**
     * Indicates the transcription result contains final text and corresponding translation(s)
     * for other participants in the conversation. Speech Recognition and Translation are now
     * complete for this phrase.
     * @member ResultReason.TranslatedParticipantSpeech
     */ ResultReason[ResultReason["TranslatedParticipantSpeech"] = 20] = "TranslatedParticipantSpeech";
    /**
     * <summary>
     * Indicates the transcription result contains the instant message and corresponding
     * translation(s).
     * @member ResultReason.TranslatedInstantMessage
     */ ResultReason[ResultReason["TranslatedInstantMessage"] = 21] = "TranslatedInstantMessage";
    /**
     * Indicates the transcription result contains the instant message for other participants
     * in the conversation and corresponding translation(s).
     * @member ResultReason.TranslatedParticipantInstantMessage
     */ ResultReason[ResultReason["TranslatedParticipantInstantMessage"] = 22] = "TranslatedParticipantInstantMessage";
})($1755c3b092484014$export$3527eaa7db1a45df || ($1755c3b092484014$export$3527eaa7db1a45df = {}));

});

parcelRegister("fnMfN", function(module, exports) {

$parcel$export(module.exports, "SpeechConfig", () => $b32e6f34075fb810$export$de011cb7b5310b31);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $hgjD5 = parcelRequire("hgjD5");

var $3SMEZ = parcelRequire("3SMEZ");

var $jcTbW = parcelRequire("jcTbW");
var $biETf = parcelRequire("biETf");
var $isROj = parcelRequire("isROj");
var $fWPg2 = parcelRequire("fWPg2");
var $38QGp = parcelRequire("38QGp");
class $b32e6f34075fb810$export$de011cb7b5310b31 {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ static fromSubscription(subscriptionKey, region) {
        (0, $3SMEZ.Contracts).throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        (0, $3SMEZ.Contracts).throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $b32e6f34075fb810$export$974c5658476a7259();
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Region, region);
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     * and the effective language is "de-DE". Only the parameters that are not specified in the
     * endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        (0, $3SMEZ.Contracts).throwIfNull(endpoint, "endpoint");
        const speechImpl = new $b32e6f34075fb810$export$974c5658476a7259();
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        (0, $3SMEZ.Contracts).throwIfNull(hostName, "hostName");
        const speechImpl = new $b32e6f34075fb810$export$974c5658476a7259();
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromAuthorizationToken(authorizationToken, region) {
        (0, $3SMEZ.Contracts).throwIfNull(authorizationToken, "authorizationToken");
        (0, $3SMEZ.Contracts).throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $b32e6f34075fb810$export$974c5658476a7259();
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Region, region);
        speechImpl.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
}
class $b32e6f34075fb810$export$974c5658476a7259 extends $b32e6f34075fb810$export$de011cb7b5310b31 {
    constructor(){
        super();
        this.privProperties = new (0, $isROj.PropertyCollection)();
        this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        this.outputFormat = (0, $jcTbW.OutputFormat).Simple;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token);
    }
    set authorizationToken(value) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, value);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(value) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_RecoLanguage, value);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(value) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages, value);
    }
    get outputFormat() {
        return (0, $jcTbW.OutputFormat)[this.privProperties.getProperty((0, $hgjD5.OutputFormatPropertyName), undefined)];
    }
    set outputFormat(value) {
        this.privProperties.setProperty((0, $hgjD5.OutputFormatPropertyName), (0, $jcTbW.OutputFormat)[value]);
    }
    get endpointId() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_EndpointId);
    }
    set endpointId(value) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_EndpointId, value);
    }
    setProperty(name, value) {
        (0, $3SMEZ.Contracts).throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    }
    getProperty(name, def) {
        return this.privProperties.getProperty(name, def);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty((0, $fWPg2.PropertyId)[(0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty((0, $fWPg2.PropertyId)[(0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty((0, $fWPg2.PropertyId)[(0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty((0, $fWPg2.PropertyId)[(0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty((0, $hgjD5.ServicePropertiesPropertyName), "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty((0, $hgjD5.ServicePropertiesPropertyName), JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_ProfanityOption, (0, $biETf.ProfanityOption)[profanity]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty((0, $hgjD5.ForceDictationPropertyName), "true");
    }
    clone() {
        const ret = new $b32e6f34075fb810$export$974c5658476a7259();
        ret.privProperties = this.privProperties.clone();
        return ret;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        return (0, $38QGp.SpeechSynthesisOutputFormat)[this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privProperties.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthOutputFormat, (0, $38QGp.SpeechSynthesisOutputFormat)[format]);
    }
}

});
parcelRegister("hgjD5", function(module, exports) {
$parcel$export(module.exports, "CognitiveSubscriptionKeyAuthentication", () => (parcelRequire("6HIA2")).CognitiveSubscriptionKeyAuthentication);
$parcel$export(module.exports, "CognitiveTokenAuthentication", () => (parcelRequire("4t6tB")).CognitiveTokenAuthentication);
$parcel$export(module.exports, "ServiceRecognizerBase", () => (parcelRequire("lDTeU")).ServiceRecognizerBase);
$parcel$export(module.exports, "RecognitionMode", () => (parcelRequire("3ppF1")).RecognitionMode);
$parcel$export(module.exports, "RecognizerConfig", () => (parcelRequire("3ppF1")).RecognizerConfig);
$parcel$export(module.exports, "WebsocketMessageFormatter", () => (parcelRequire("iUPWQ")).WebsocketMessageFormatter);
$parcel$export(module.exports, "SpeechConnectionFactory", () => (parcelRequire("gXTdh")).SpeechConnectionFactory);
$parcel$export(module.exports, "SpeechSynthesisConnectionFactory", () => (parcelRequire("2Fj9D")).SpeechSynthesisConnectionFactory);
$parcel$export(module.exports, "EnumTranslation", () => (parcelRequire("3up4e")).EnumTranslation);
$parcel$export(module.exports, "RecognitionStatus", () => (parcelRequire("gNbeL")).RecognitionStatus);
$parcel$export(module.exports, "SpeechDetected", () => (parcelRequire("5Xm3f")).SpeechDetected);
$parcel$export(module.exports, "SpeechHypothesis", () => (parcelRequire("buBkw")).SpeechHypothesis);
$parcel$export(module.exports, "SpeechServiceRecognizer", () => (parcelRequire("7w59Q")).SpeechServiceRecognizer);
$parcel$export(module.exports, "DetailedSpeechPhrase", () => (parcelRequire("cg0MH")).DetailedSpeechPhrase);
$parcel$export(module.exports, "SimpleSpeechPhrase", () => (parcelRequire("jsqMv")).SimpleSpeechPhrase);
$parcel$export(module.exports, "RequestSession", () => (parcelRequire("lkId6")).RequestSession);
$parcel$export(module.exports, "SpeechContext", () => (parcelRequire("hRi9W")).SpeechContext);
$parcel$export(module.exports, "DynamicGrammarBuilder", () => (parcelRequire("f9t0q")).DynamicGrammarBuilder);
$parcel$export(module.exports, "AgentConfig", () => (parcelRequire("51cqC")).AgentConfig);
$parcel$export(module.exports, "MetadataType", () => (parcelRequire("6nl23")).MetadataType);
$parcel$export(module.exports, "SynthesisAudioMetadata", () => (parcelRequire("6nl23")).SynthesisAudioMetadata);
$parcel$export(module.exports, "SynthesisTurn", () => (parcelRequire("dsBs3")).SynthesisTurn);
$parcel$export(module.exports, "SynthesisAdapterBase", () => (parcelRequire("gd3Vj")).SynthesisAdapterBase);
$parcel$export(module.exports, "SynthesisRestAdapter", () => (parcelRequire("bOCy4")).SynthesisRestAdapter);
$parcel$export(module.exports, "SynthesizerConfig", () => (parcelRequire("gBlwq")).SynthesizerConfig);
$parcel$export(module.exports, "SynthesisContext", () => (parcelRequire("bgoz0")).SynthesisContext);
$parcel$export(module.exports, "connectivity", () => (parcelRequire("6xqgT")).connectivity);
$parcel$export(module.exports, "Context", () => (parcelRequire("6xqgT")).Context);
$parcel$export(module.exports, "OS", () => (parcelRequire("6xqgT")).OS);
$parcel$export(module.exports, "SpeechServiceConfig", () => (parcelRequire("6xqgT")).SpeechServiceConfig);
$parcel$export(module.exports, "type", () => (parcelRequire("6xqgT")).type);

$parcel$export(module.exports, "OutputFormatPropertyName", () => $c913284cd7b42aa7$export$ad4e0600dd11837f);
$parcel$export(module.exports, "CancellationErrorCodePropertyName", () => $c913284cd7b42aa7$export$cbbf1d2efc001695);
$parcel$export(module.exports, "ServicePropertiesPropertyName", () => $c913284cd7b42aa7$export$84df797b3b5f7f6c);
$parcel$export(module.exports, "ForceDictationPropertyName", () => $c913284cd7b42aa7$export$9fd1049e23088e5e);
$parcel$export(module.exports, "AutoDetectSourceLanguagesOpenRangeOptionName", () => $c913284cd7b42aa7$export$dfb31ff7bb3a5cb4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Make sure not to export internal modules.
//
parcelRequire("6HIA2");
parcelRequire("4t6tB");






parcelRequire("lDTeU");

parcelRequire("3ppF1");

parcelRequire("iUPWQ");
parcelRequire("gXTdh");



parcelRequire("2Fj9D");
parcelRequire("3up4e");
parcelRequire("gNbeL");




parcelRequire("5Xm3f");
parcelRequire("buBkw");

parcelRequire("7w59Q");


parcelRequire("cg0MH");
parcelRequire("jsqMv");




parcelRequire("lkId6");
parcelRequire("hRi9W");
parcelRequire("f9t0q");


parcelRequire("51cqC");

parcelRequire("6nl23");
parcelRequire("dsBs3");
parcelRequire("gd3Vj");


var $5ilMI = parcelRequire("5ilMI");
parcelRequire("bOCy4");
parcelRequire("gBlwq");
parcelRequire("bgoz0");



parcelRequire("6xqgT");
const $c913284cd7b42aa7$export$ad4e0600dd11837f = "OutputFormat";
const $c913284cd7b42aa7$export$cbbf1d2efc001695 = "CancellationErrorCode";
const $c913284cd7b42aa7$export$84df797b3b5f7f6c = "ServiceProperties";
const $c913284cd7b42aa7$export$9fd1049e23088e5e = "ForceDictation";
const $c913284cd7b42aa7$export$dfb31ff7bb3a5cb4 = "OpenRange";

});
parcelRegister("6HIA2", function(module, exports) {

$parcel$export(module.exports, "CognitiveSubscriptionKeyAuthentication", () => $01427924f138524d$export$953fe81aaa517010);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $40Pvg = parcelRequire("40Pvg");

var $8YUMa = parcelRequire("8YUMa");
class $01427924f138524d$export$953fe81aaa517010 {
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ constructor(subscriptionKey){
        if (!subscriptionKey) throw new (0, $3NF6I.ArgumentNullError)("subscriptionKey");
        this.privAuthInfo = new (0, $8YUMa.AuthInfo)((0, $40Pvg.HeaderNames).AuthKey, subscriptionKey);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchOnExpiry(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
}

});
parcelRegister("40Pvg", function(module, exports) {

$parcel$export(module.exports, "HeaderNames", () => $2ebf1d02cdce8ed7$export$28d77f87efed1d88);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $2ebf1d02cdce8ed7$export$28d77f87efed1d88 {
}
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.AuthKey = "Ocp-Apim-Subscription-Key";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.Authorization = "Authorization";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.SpIDAuthKey = "Apim-Subscription-Id";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.ConnectionId = "X-ConnectionId";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.ContentType = "Content-Type";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.CustomCommandsAppId = "X-CommandsAppId";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.Path = "Path";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.RequestId = "X-RequestId";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.RequestStreamId = "X-StreamId";
$2ebf1d02cdce8ed7$export$28d77f87efed1d88.RequestTimestamp = "X-Timestamp";

});

parcelRegister("8YUMa", function(module, exports) {

$parcel$export(module.exports, "AuthInfo", () => $689ff7daabb00893$export$12e76865728ad4c1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $689ff7daabb00893$export$12e76865728ad4c1 {
    constructor(headerName, token){
        this.privHeaderName = headerName;
        this.privToken = token;
    }
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
}

});


parcelRegister("4t6tB", function(module, exports) {

$parcel$export(module.exports, "CognitiveTokenAuthentication", () => $340ee4f178b929b7$export$d54ea9b3174205e1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $8YUMa = parcelRequire("8YUMa");

var $40Pvg = parcelRequire("40Pvg");
class $340ee4f178b929b7$export$d54ea9b3174205e1 {
    constructor(fetchCallback, fetchOnExpiryCallback){
        if (!fetchCallback) throw new (0, $3NF6I.ArgumentNullError)("fetchCallback");
        if (!fetchOnExpiryCallback) throw new (0, $3NF6I.ArgumentNullError)("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
    fetch(authFetchEventId) {
        return this.privFetchCallback(authFetchEventId).then((token)=>new (0, $8YUMa.AuthInfo)((0, $40Pvg.HeaderNames).Authorization, token === undefined ? undefined : $340ee4f178b929b7$export$d54ea9b3174205e1.privTokenPrefix + token));
    }
    fetchOnExpiry(authFetchEventId) {
        return this.privFetchOnExpiryCallback(authFetchEventId).then((token)=>new (0, $8YUMa.AuthInfo)((0, $40Pvg.HeaderNames).Authorization, token === undefined ? undefined : $340ee4f178b929b7$export$d54ea9b3174205e1.privTokenPrefix + token));
    }
}
$340ee4f178b929b7$export$d54ea9b3174205e1.privTokenPrefix = "Bearer ";

});

parcelRegister("lDTeU", function(module, exports) {

$parcel$export(module.exports, "ServiceRecognizerBase", () => $fc1816ed069b338f$export$984734d84ac7a9a1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $k2jz9 = parcelRequire("k2jz9");

var $3NF6I = parcelRequire("3NF6I");
var $9klG9 = parcelRequire("9klG9");
var $8lWt4 = parcelRequire("8lWt4");
var $9SKhX = parcelRequire("9SKhX");
var $k419T = parcelRequire("k419T");
var $ls19Y = parcelRequire("ls19Y");
var $8WCaJ = parcelRequire("8WCaJ");

var $5bdH7 = parcelRequire("5bdH7");
var $6Oi8a = parcelRequire("6Oi8a");
var $jcTbW = parcelRequire("jcTbW");
var $fWPg2 = parcelRequire("fWPg2");
var $jBghy = parcelRequire("jBghy");
var $83GF9 = parcelRequire("83GF9");

var $51cqC = parcelRequire("51cqC");
var $f9t0q = parcelRequire("f9t0q");
var $hgjD5 = parcelRequire("hgjD5");
var $3ppF1 = parcelRequire("3ppF1");
var $lkId6 = parcelRequire("lkId6");
var $hRi9W = parcelRequire("hRi9W");
var $5Xm3f = parcelRequire("5Xm3f");
var $6xqgT = parcelRequire("6xqgT");

var $ccM4b = parcelRequire("ccM4b");
var $fc1816ed069b338f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $fc1816ed069b338f$export$984734d84ac7a9a1 {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        // A promise for a connection, but one that has not had the speech context sent yet.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionPromise = undefined;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.privAverageBytesPerMs = 0;
        this.privEnableSpeakerId = false;
        this.recognizeOverride = undefined;
        this.recognizeSpeaker = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.handleSpeechPhraseMessage = undefined;
        this.handleSpeechHypothesisMessage = undefined;
        if (!authentication) throw new (0, $3NF6I.ArgumentNullError)("authentication");
        if (!connectionFactory) throw new (0, $3NF6I.ArgumentNullError)("connectionFactory");
        if (!audioSource) throw new (0, $3NF6I.ArgumentNullError)("audioSource");
        if (!recognizerConfig) throw new (0, $3NF6I.ArgumentNullError)("recognizerConfig");
        this.privEnableSpeakerId = recognizerConfig.isSpeakerDiarizationEnabled;
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new (0, $lkId6.RequestSession)(this.privAudioSource.id());
        this.privConnectionEvents = new (0, $9SKhX.EventSource)();
        this.privServiceEvents = new (0, $9SKhX.EventSource)();
        this.privDynamicGrammar = new (0, $f9t0q.DynamicGrammarBuilder)();
        this.privSpeechContext = new (0, $hRi9W.SpeechContext)(this.privDynamicGrammar);
        this.privAgentConfig = new (0, $51cqC.AgentConfig)();
        const webWorkerLoadType = this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = (0, $8WCaJ.Timeout).setTimeout;
        else if (typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privSetTimeout = window.setTimeout.bind(window);
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) this.cancelRecognitionLocal((0, $6Oi8a.CancellationReason).Error, connectionClosedEvent.statusCode === 1007 ? (0, $5bdH7.CancellationErrorCode).BadRequestParameters : (0, $5bdH7.CancellationErrorCode).ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
        if (this.privEnableSpeakerId) this.privDiarizationSessionId = (0, $8lWt4.createNoDashGuid)();
        this.setLanguageIdJson();
        this.setOutputDetailLevelJson();
    }
    setTranslationJson() {
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            const languages = targetLanguages.split(",");
            const translationVoice = this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_TranslationVoice, undefined);
            const action = translationVoice !== undefined ? "Synthesize" : "None";
            this.privSpeechContext.setSection("translation", {
                onSuccess: {
                    action: action
                },
                output: {
                    interimResults: {
                        mode: "Always"
                    }
                },
                targetLanguages: languages
            });
            if (translationVoice !== undefined) {
                const languageToVoiceMap = {};
                for (const lang of languages)languageToVoiceMap[lang] = translationVoice;
                this.privSpeechContext.setSection("synthesis", {
                    defaultVoices: languageToVoiceMap
                });
            }
        }
    }
    setSpeechSegmentationTimeoutJson() {
        const speechSegmentationTimeout = this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).Speech_SegmentationSilenceTimeoutMs, undefined);
        if (speechSegmentationTimeout !== undefined) {
            const mode = this.recognitionMode === (0, $3ppF1.RecognitionMode).Conversation ? "CONVERSATION" : this.recognitionMode === (0, $3ppF1.RecognitionMode).Dictation ? "DICTATION" : "INTERACTIVE";
            const segmentationSilenceTimeoutMs = parseInt(speechSegmentationTimeout, 10);
            const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = mode;
            phraseDetection[mode] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: segmentationSilenceTimeoutMs
                }
            };
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    }
    setLanguageIdJson() {
        const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== undefined) {
            const sourceLanguages = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
            let speechContextLidMode;
            if (this.privRecognizerConfig.languageIdMode === "Continuous") speechContextLidMode = "DetectContinuous";
            else speechContextLidMode = "DetectAtAudioStart";
            this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: sourceLanguages,
                mode: speechContextLidMode,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            const customModels = this.privRecognizerConfig.sourceLanguageModels;
            if (customModels !== undefined) {
                phraseDetection.customModels = customModels;
                phraseDetection.onInterim = {
                    action: "None"
                };
                phraseDetection.onSuccess = {
                    action: "None"
                };
            }
        }
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            phraseDetection.onInterim = {
                action: "Translate"
            };
            phraseDetection.onSuccess = {
                action: "Translate"
            };
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "None"
                },
                phraseResults: {
                    resultType: "None"
                }
            });
        }
        this.privSpeechContext.setSection("phraseDetection", phraseDetection);
    }
    setOutputDetailLevelJson() {
        if (this.privEnableSpeakerId) {
            const requestWordLevelTimestamps = this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase();
            if (requestWordLevelTimestamps === "true") this.privSpeechContext.setWordLevelTimings();
            else {
                const outputFormat = this.privRecognizerConfig.parameters.getProperty((0, $hgjD5.OutputFormatPropertyName), (0, $jcTbW.OutputFormat)[(0, $jcTbW.OutputFormat).Simple]).toLowerCase();
                if (outputFormat === (0, $jcTbW.OutputFormat)[(0, $jcTbW.OutputFormat).Detailed].toLocaleLowerCase()) this.privSpeechContext.setDetailedOutputFormat();
            }
        }
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(token) {
        this.privRecognizerConfig.parameters.setProperty((0, $fWPg2.PropertyId).ConversationTranslator_Token, token);
    }
    set voiceProfileType(type) {
        this.privRecognizerConfig.parameters.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SpeakerIdMode, type);
    }
    set authentication(auth) {
        this.privAuthentication = auth;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privConnectionConfigurationPromise !== undefined) try {
                const connection = yield this.privConnectionConfigurationPromise;
                yield connection.dispose(reason);
            } catch (error) {
                // The connection is in a bad state. But we're trying to kill it, so...
                return;
            }
        });
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    recognize(recoMode, successCallback, errorCallBack) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.recognizeOverride !== undefined) {
                yield this.recognizeOverride(recoMode, successCallback, errorCallBack);
                return;
            }
            // Clear the existing configuration promise to force a re-transmission of config and context.
            this.privConnectionConfigurationPromise = undefined;
            this.privRecognizerConfig.recognitionMode = recoMode;
            this.setSpeechSegmentationTimeoutJson();
            this.setTranslationJson();
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallBack;
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            let audioNode;
            try {
                const audioStreamNode = yield this.audioSource.attach(this.privRequestSession.audioNodeId);
                const format = yield this.audioSource.format;
                const deviceInfo = yield this.audioSource.deviceInfo;
                this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === (0, $6xqgT.type).Microphones;
                audioNode = new (0, $k2jz9.ReplayableAudioNode)(audioStreamNode, format.avgBytesPerSec);
                yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
                this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                    source: deviceInfo
                };
            } catch (error) {
                yield this.privRequestSession.onStopRecognizing();
                throw error;
            }
            try {
                yield conPromise;
            } catch (error) {
                yield this.cancelRecognitionLocal((0, $6Oi8a.CancellationReason).Error, (0, $5bdH7.CancellationErrorCode).ConnectionFailure, error);
                return;
            }
            const sessionStartEventArgs = new (0, $83GF9.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            this.receiveMessage();
            const audioSendPromise = this.sendAudio(audioNode);
            audioSendPromise.catch((error)=>$fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.cancelRecognitionLocal((0, $6Oi8a.CancellationReason).Error, (0, $5bdH7.CancellationErrorCode).RuntimeError, error);
                }));
            return;
        });
    }
    stopRecognizing() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) try {
                yield this.audioSource.turnOff();
                yield this.sendFinalAudio();
                yield this.privRequestSession.onStopRecognizing();
                yield this.privRequestSession.turnCompletionPromise;
            } finally{
                yield this.privRequestSession.dispose();
            }
            return;
        });
    }
    connect() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
            return Promise.resolve();
        });
    }
    connectAsync(cb, err) {
        this.connectImpl().then(()=>{
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, (reason)=>{
            try {
                if (!!err) err(reason);
            /* eslint-disable no-empty */ } catch (error) {}
        });
    }
    disconnect() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.cancelRecognitionLocal((0, $6Oi8a.CancellationReason).Error, (0, $5bdH7.CancellationErrorCode).NoError, "Disconnecting");
            if (this.disconnectOverride !== undefined) yield this.disconnectOverride();
            if (this.privConnectionPromise !== undefined) try {
                yield (yield this.privConnectionPromise).dispose();
            } catch (error) {}
            this.privConnectionPromise = undefined;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(message) {
        return;
    }
    sendNetworkMessage(path, payload) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            const type = typeof payload === "string" ? (0, $k419T.MessageType).Text : (0, $k419T.MessageType).Binary;
            const contentType = typeof payload === "string" ? "application/json" : "";
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $ccM4b.SpeechConnectionMessage)(type, path, this.privRequestSession.requestId, contentType, payload));
        });
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    sendTelemetryData() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            const telemetryData = this.privRequestSession.getTelemetry();
            if ($fc1816ed069b338f$export$984734d84ac7a9a1.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return;
            if (!!$fc1816ed069b338f$export$984734d84ac7a9a1.telemetryData) try {
                $fc1816ed069b338f$export$984734d84ac7a9a1.telemetryData(telemetryData);
            /* eslint-disable no-empty */ } catch (_a) {}
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData));
        });
    }
    // Cancels recognition.
    cancelRecognitionLocal(cancellationReason, errorCode, error) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privRequestSession.isRecognizing) {
                yield this.privRequestSession.onStopRecognizing();
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
            }
        });
    }
    receiveMessage() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (this.privIsDisposed) // We're done.
                return;
                let connection = yield this.fetchConnection();
                const message = yield connection.read();
                if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
                // indicates we are draining the queue and it came with no message;
                if (!message) return this.receiveMessage();
                this.privServiceHasSentMessage = true;
                const connectionMessage = (0, $ccM4b.SpeechConnectionMessage).fromConnectionMessage(message);
                if (connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        this.privMustReportEndOfStream = true;
                        this.privRequestSession.onServiceTurnStartResponse();
                        break;
                    case "speech.startdetected":
                        const speechStartDetected = (0, $5Xm3f.SpeechDetected).fromJSON(connectionMessage.textBody);
                        const speechStartEventArgs = new (0, $jBghy.RecognitionEventArgs)(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        break;
                    case "speech.enddetected":
                        let json;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        const speechStopDetected = (0, $5Xm3f.SpeechDetected).fromJSON(json);
                        const speechStopEventArgs = new (0, $jBghy.RecognitionEventArgs)(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        break;
                    case "turn.end":
                        yield this.sendTelemetryData();
                        if (this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream) {
                            this.privMustReportEndOfStream = false;
                            yield this.cancelRecognitionLocal((0, $6Oi8a.CancellationReason).EndOfStream, (0, $5bdH7.CancellationErrorCode).NoError, undefined);
                        }
                        const sessionStopEventArgs = new (0, $83GF9.SessionEventArgs)(this.privRequestSession.sessionId);
                        yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition);
                        if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                            if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                            return;
                        } else {
                            connection = yield this.fetchConnection();
                            yield this.sendPrePayloadJSON(connection);
                        }
                        break;
                    default:
                        if (!(yield this.processTypeSpecificMessages(connectionMessage))) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new (0, $ls19Y.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                }
                return this.receiveMessage();
            } catch (error) {
                return null;
            }
        });
    }
    updateSpeakerDiarizationAudioOffset() {
        const bytesSent = this.privRequestSession.recognitionBytesSent;
        const audioOffsetMs = bytesSent / this.privAverageBytesPerMs;
        this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(audioOffsetMs);
    }
    sendSpeechContext(connection, generateNewRequestId) {
        if (this.privEnableSpeakerId) this.updateSpeakerDiarizationAudioOffset();
        const speechContextJson = this.speechContext.toJSON();
        if (generateNewRequestId) this.privRequestSession.onSpeechContext();
        if (speechContextJson) return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
        return;
    }
    noOp() {
        // operation not supported
        return;
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendPrePayloadJSON(connection, generateNewRequestId = true) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.sendPrePayloadJSONOverride !== undefined) return this.sendPrePayloadJSONOverride(connection);
            yield this.sendSpeechContext(connection, generateNewRequestId);
            yield this.sendWaveHeader(connection);
            return;
        });
    }
    sendWaveHeader(connection) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            const format = yield this.audioSource.format;
            // this.writeBufferToConsole(format.header);
            return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header));
        });
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        if (this.privConnectionPromise !== undefined) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === (0, $9klG9.ConnectionState).Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, requestSession, SpeechServiceConfigJson) {
        requestSession.onSpeechContext();
        // filter out anything that is not required for the service to work.
        if ($fc1816ed069b338f$export$984734d84ac7a9a1.telemetryDataEnabled !== true) {
            const withTelemetry = JSON.parse(SpeechServiceConfigJson);
            const replacement = {
                context: {
                    system: withTelemetry.context.system
                }
            };
            SpeechServiceConfigJson = JSON.stringify(replacement);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const json = JSON.parse(SpeechServiceConfigJson);
            json.context.DisableReferenceChannel = "True";
            json.context.MicSpec = "1_0_0";
            SpeechServiceConfigJson = JSON.stringify(json);
        }
        if (SpeechServiceConfigJson) return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
        return;
    }
    fetchConnection() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
                if (connection.state() === (0, $9klG9.ConnectionState).Disconnected) {
                    this.privConnectionId = null;
                    this.privConnectionConfigurationPromise = undefined;
                    this.privServiceHasSentMessage = false;
                    return this.fetchConnection();
                }
                return this.privConnectionConfigurationPromise;
            }, ()=>{
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            });
            this.privConnectionConfigurationPromise = this.configureConnection();
            return yield this.privConnectionConfigurationPromise;
        });
    }
    sendAudio(audioStreamNode) {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            const audioFormat = yield this.audioSource.format;
            this.privAverageBytesPerMs = audioFormat.avgBytesPerSec / 1000;
            // The time we last sent data to the service.
            let nextSendTime = Date.now();
            // Max amount to send before we start to throttle
            const fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
            const maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
            const startRecogNumber = this.privRequestSession.recogNumber;
            const readAndUploadCycle = ()=>$fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
                    // If speech is done, stop sending audio.
                    if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                        const connection = yield this.fetchConnection();
                        const audioStreamChunk = yield audioStreamNode.read();
                        // we have a new audio chunk to upload.
                        if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                        return;
                        let payload;
                        let sendDelay;
                        if (!audioStreamChunk || audioStreamChunk.isEnd) {
                            payload = null;
                            sendDelay = 0;
                        } else {
                            payload = audioStreamChunk.buffer;
                            this.privRequestSession.onAudioSent(payload.byteLength);
                            if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                            else sendDelay = Math.max(0, nextSendTime - Date.now());
                        }
                        if (0 !== sendDelay) yield this.delay(sendDelay);
                        if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                        // Are we still alive?
                        if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                            connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(()=>{
                                // eslint-disable-next-line @typescript-eslint/no-empty-function
                                this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                            });
                            if (!(audioStreamChunk === null || audioStreamChunk === void 0 ? void 0 : audioStreamChunk.isEnd)) // this.writeBufferToConsole(payload);
                            // Regardless of success or failure, schedule the next upload.
                            // If the underlying connection was broken, the next cycle will
                            // get a new connection and re-transmit missing audio automatically.
                            return readAndUploadCycle();
                            else // the audio stream has been closed, no need to schedule next
                            // read-upload cycle.
                            if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                        }
                    }
                });
            return readAndUploadCycle();
        });
    }
    retryableConnect() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            let isUnAuthorized = false;
            this.privAuthFetchEventId = (0, $8lWt4.createNoDashGuid)();
            const sessionId = this.privRequestSession.sessionId;
            this.privConnectionId = sessionId !== undefined ? sessionId : (0, $8lWt4.createNoDashGuid)();
            this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
            let lastStatusCode = 0;
            let lastReason = "";
            while(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount){
                // Get the auth information for the connection. This is a bit of overkill for the current API surface, but leaving the plumbing in place to be able to raise a developer-customer
                // facing event when a connection fails to let them try and provide new auth information.
                const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                const auth = yield authPromise;
                yield this.privRequestSession.onAuthCompleted(false);
                // Create the connection
                const connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
                // Attach the telemetry handlers.
                this.privRequestSession.listenForServiceTelemetry(connection.events);
                // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                // it'll stop sending events.
                connection.events.attach((event)=>{
                    this.connectionEvents.onEvent(event);
                });
                const response = yield connection.open();
                // 200 == everything is fine.
                if (response.statusCode === 200) {
                    yield this.privRequestSession.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.resolve(connection);
                } else if (response.statusCode === 1006) isUnAuthorized = true;
                lastStatusCode = response.statusCode;
                lastReason = response.reason;
                this.privRequestSession.onRetryConnection();
            }
            yield this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason);
            return Promise.reject(`Unable to contact server. StatusCode: ${lastStatusCode}, ${this.privRecognizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint)} Reason: ${lastReason}`);
        });
    }
    delay(delayMs) {
        return new Promise((resolve)=>this.privSetTimeout(resolve, delayMs));
    }
    writeBufferToConsole(buffer) {
        let out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            const readView = new Uint8Array(buffer);
            out += `${buffer.byteLength}\r\n`;
            for(let i = 0; i < buffer.byteLength; i++){
                out += readView[i].toString(16).padStart(2, "0") + " ";
                if ((i + 1) % 16 === 0) {
                    // eslint-disable-next-line no-console
                    console.info(out);
                    out = "";
                }
            }
        }
        // eslint-disable-next-line no-console
        console.info(out);
    }
    sendFinalAudio() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Binary, "audio", this.privRequestSession.requestId, null, null));
            return;
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $fc1816ed069b338f$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.connectImpl();
            if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
            yield this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
            yield this.sendPrePayloadJSON(connection, false);
            return connection;
        });
    }
}
$fc1816ed069b338f$export$984734d84ac7a9a1.telemetryDataEnabled = true;

});
parcelRegister("k2jz9", function(module, exports) {

$parcel$export(module.exports, "ReplayableAudioNode", () => $e9632beacc52811d$export$3553271f667249af);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $e9632beacc52811d$export$3553271f667249af {
    constructor(audioSource, bytesPerSecond){
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            const offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            let i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((result)=>{
            if (result && result.buffer) {
                this.privBuffers.push(new $e9632beacc52811d$var$BufferEntry(result, this.privBufferSerial++, this.privBufferedBytes));
                this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    }
    detach() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    }
    replay() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        const offsetToSeek = offset - this.privBufferStartOffset;
        let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        let i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for (const value of this.privBuffers){
            const startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            const endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    }
}
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
class $e9632beacc52811d$var$BufferEntry {
    constructor(chunk, serial, byteOffset){
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
}

});

parcelRegister("9klG9", function(module, exports) {

$parcel$export(module.exports, "ConnectionState", () => $6ca6cc4a58644bfc$export$cd9c3c6bf535afc9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6ca6cc4a58644bfc$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($6ca6cc4a58644bfc$export$cd9c3c6bf535afc9 || ($6ca6cc4a58644bfc$export$cd9c3c6bf535afc9 = {}));

});

parcelRegister("k419T", function(module, exports) {

$parcel$export(module.exports, "MessageType", () => $e9b51472080e5f45$export$80edbf15fa61a4db);
$parcel$export(module.exports, "ConnectionMessage", () => $e9b51472080e5f45$export$fa43bbfea96f2015);
/* eslint-disable @typescript-eslint/no-unsafe-return */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");
var $e9b51472080e5f45$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($e9b51472080e5f45$export$80edbf15fa61a4db || ($e9b51472080e5f45$export$80edbf15fa61a4db = {}));
class $e9b51472080e5f45$export$fa43bbfea96f2015 {
    constructor(messageType, body, headers, id){
        this.privBody = null;
        if (messageType === $e9b51472080e5f45$export$80edbf15fa61a4db.Text && body && !(typeof body === "string")) throw new (0, $3NF6I.InvalidOperationError)("Payload must be a string");
        if (messageType === $e9b51472080e5f45$export$80edbf15fa61a4db.Binary && body && !(body instanceof ArrayBuffer)) throw new (0, $3NF6I.InvalidOperationError)("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : (0, $8lWt4.createNoDashGuid)();
        switch(this.messageType){
            case $e9b51472080e5f45$export$80edbf15fa61a4db.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $e9b51472080e5f45$export$80edbf15fa61a4db.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $e9b51472080e5f45$export$80edbf15fa61a4db.Binary) throw new (0, $3NF6I.InvalidOperationError)("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $e9b51472080e5f45$export$80edbf15fa61a4db.Text) throw new (0, $3NF6I.InvalidOperationError)("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
}

});

parcelRegister("ls19Y", function(module, exports) {

$parcel$export(module.exports, "ServiceEvent", () => $f9dd1cd947d65b53$export$4a3bd582097411);
$parcel$export(module.exports, "ConnectionStartEvent", () => $f9dd1cd947d65b53$export$b07a5b383e429393);
$parcel$export(module.exports, "ConnectionEstablishedEvent", () => $f9dd1cd947d65b53$export$89bbcdbfdd7f98d6);
$parcel$export(module.exports, "ConnectionClosedEvent", () => $f9dd1cd947d65b53$export$c0d6050433d51d03);
$parcel$export(module.exports, "ConnectionErrorEvent", () => $f9dd1cd947d65b53$export$3299e654b279c3f8);
$parcel$export(module.exports, "ConnectionEstablishErrorEvent", () => $f9dd1cd947d65b53$export$e916fc8e35135338);
$parcel$export(module.exports, "ConnectionMessageReceivedEvent", () => $f9dd1cd947d65b53$export$60c815f18d84ea31);
$parcel$export(module.exports, "ConnectionMessageSentEvent", () => $f9dd1cd947d65b53$export$41b2353b9658d253);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $dVTTx = parcelRequire("dVTTx");
class $f9dd1cd947d65b53$export$4a3bd582097411 extends (0, $dVTTx.PlatformEvent) {
    constructor(eventName, jsonstring, eventType = (0, $dVTTx.EventType).Info){
        super(eventName, eventType);
        this.privJsonResult = jsonstring;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
class $f9dd1cd947d65b53$export$a5d2cb21a485eb9 extends (0, $dVTTx.PlatformEvent) {
    constructor(eventName, connectionId, eventType = (0, $dVTTx.EventType).Info){
        super(eventName, eventType);
        this.privConnectionId = connectionId;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
class $f9dd1cd947d65b53$export$b07a5b383e429393 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId, uri, headers){
        super("ConnectionStartEvent", connectionId);
        this.privUri = uri;
        this.privHeaders = headers;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
class $f9dd1cd947d65b53$export$89bbcdbfdd7f98d6 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId){
        super("ConnectionEstablishedEvent", connectionId);
    }
}
class $f9dd1cd947d65b53$export$c0d6050433d51d03 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId, statusCode, reason){
        super("ConnectionClosedEvent", connectionId, (0, $dVTTx.EventType).Debug);
        this.privReason = reason;
        this.privStatusCode = statusCode;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $f9dd1cd947d65b53$export$3299e654b279c3f8 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId, message, type){
        super("ConnectionErrorEvent", connectionId, (0, $dVTTx.EventType).Debug);
        this.privMessage = message;
        this.privType = type;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
class $f9dd1cd947d65b53$export$e916fc8e35135338 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId, statuscode, reason){
        super("ConnectionEstablishErrorEvent", connectionId, (0, $dVTTx.EventType).Error);
        this.privStatusCode = statuscode;
        this.privReason = reason;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $f9dd1cd947d65b53$export$60c815f18d84ea31 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId, networkReceivedTimeISO, message){
        super("ConnectionMessageReceivedEvent", connectionId);
        this.privNetworkReceivedTime = networkReceivedTimeISO;
        this.privMessage = message;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $f9dd1cd947d65b53$export$41b2353b9658d253 extends $f9dd1cd947d65b53$export$a5d2cb21a485eb9 {
    constructor(connectionId, networkSentTimeISO, message){
        super("ConnectionMessageSentEvent", connectionId);
        this.privNetworkSentTime = networkSentTimeISO;
        this.privMessage = message;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}

});

parcelRegister("8WCaJ", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $683159ac6661ce6b$export$786b4da70f00938b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $683159ac6661ce6b$export$786b4da70f00938b {
    static load() {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        const scheduledTimeoutFunctions = new Map([
            [
                0,
                ()=>{}
            ]
        ]); // eslint-disable-line @typescript-eslint/no-empty-function
        const unhandledRequests = new Map();
        // eslint-disable-next-line
        const workerScript = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
        const workerUrl = "data:text/javascript;base64," + btoa(workerScript);
        const worker = new Worker(workerUrl);
        worker.addEventListener("message", ({ data: data })=>{
            if ($683159ac6661ce6b$export$786b4da70f00938b.isCallNotification(data)) {
                const { params: { timerId: timerId } } = data;
                const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if ($683159ac6661ce6b$export$786b4da70f00938b.isClearResponse(data)) {
                const { id: id } = data;
                const unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                const { error: { message: message } } = data;
                throw new Error(message);
            }
        });
        const clearTimeout = (timerId)=>{
            const id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        const setTimeout = (func, delay)=>{
            const timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    }
    static loadWorkerTimers() {
        return ()=>{
            if ($683159ac6661ce6b$export$786b4da70f00938b.workerTimers !== null) return $683159ac6661ce6b$export$786b4da70f00938b.workerTimers;
            $683159ac6661ce6b$export$786b4da70f00938b.workerTimers = $683159ac6661ce6b$export$786b4da70f00938b.load();
            return $683159ac6661ce6b$export$786b4da70f00938b.workerTimers;
        };
    }
    static isCallNotification(message) {
        return message.method !== undefined && message.method === "call";
    }
    static isClearResponse(message) {
        return message.error === null && typeof message.id === "number";
    }
}
$683159ac6661ce6b$export$786b4da70f00938b.workerTimers = null;
$683159ac6661ce6b$export$786b4da70f00938b.clearTimeout = (timerId)=>$683159ac6661ce6b$export$786b4da70f00938b.timers().clearTimeout(timerId);
$683159ac6661ce6b$export$786b4da70f00938b.setTimeout = (func, delay)=>$683159ac6661ce6b$export$786b4da70f00938b.timers().setTimeout(func, delay);
$683159ac6661ce6b$export$786b4da70f00938b.timers = $683159ac6661ce6b$export$786b4da70f00938b.loadWorkerTimers();

});

parcelRegister("5bdH7", function(module, exports) {

$parcel$export(module.exports, "CancellationErrorCode", () => $3c589a4675c4d8b2$export$b0e2ad361e796e97);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines error code in case that CancellationReason is Error.
 * Added in version 1.1.0.
 */ var $3c589a4675c4d8b2$export$b0e2ad361e796e97;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
    /**
     * Indicates an quota overrun on existing key.
     */ CancellationErrorCode[CancellationErrorCode["Forbidden"] = 8] = "Forbidden";
})($3c589a4675c4d8b2$export$b0e2ad361e796e97 || ($3c589a4675c4d8b2$export$b0e2ad361e796e97 = {}));

});

parcelRegister("6Oi8a", function(module, exports) {

$parcel$export(module.exports, "CancellationReason", () => $4f5579f86c0a3e77$export$cbce095b92028433);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $4f5579f86c0a3e77$export$cbce095b92028433;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($4f5579f86c0a3e77$export$cbce095b92028433 || ($4f5579f86c0a3e77$export$cbce095b92028433 = {}));

});

parcelRegister("jBghy", function(module, exports) {

$parcel$export(module.exports, "RecognitionEventArgs", () => $e44e1a53a80faaf6$export$12431311bd74173);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83GF9 = parcelRequire("83GF9");
class $e44e1a53a80faaf6$export$12431311bd74173 extends (0, $83GF9.SessionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(offset, sessionId){
        super(sessionId);
        this.privOffset = offset;
    }
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */ get offset() {
        return this.privOffset;
    }
}

});
parcelRegister("83GF9", function(module, exports) {

$parcel$export(module.exports, "SessionEventArgs", () => $5ddfb27eae42a463$export$ddbc7bb13aa93fd9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ class $5ddfb27eae42a463$export$ddbc7bb13aa93fd9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ constructor(sessionId){
        this.privSessionId = sessionId;
    }
    /**
     * Represents the session identifier.
     * @member SessionEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} Represents the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
}

});


parcelRegister("51cqC", function(module, exports) {

$parcel$export(module.exports, "AgentConfig", () => $3a76afc331a50408$export$561104de51a59cce);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ class $3a76afc331a50408$export$561104de51a59cce {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ set(value) {
        this.iPrivConfig = value;
    }
}

});

parcelRegister("f9t0q", function(module, exports) {

$parcel$export(module.exports, "DynamicGrammarBuilder", () => $b07e324304d66a0a$export$feefa659188a6539);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ class $b07e324304d66a0a$export$feefa659188a6539 {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = undefined;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = undefined;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        const retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            const retPhrases = [];
            this.privPhrases.forEach((value)=>{
                retPhrases.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases
                }
            ];
        }
        return retObj;
    }
}

});

parcelRegister("3ppF1", function(module, exports) {

$parcel$export(module.exports, "RecognitionMode", () => $27b79c9703ca383b$export$79403a05110b2cfc);
$parcel$export(module.exports, "RecognizerConfig", () => $27b79c9703ca383b$export$6036b6a06cf1bd7e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $fWPg2 = parcelRequire("fWPg2");

var $6xqgT = parcelRequire("6xqgT");
var $27b79c9703ca383b$export$79403a05110b2cfc;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($27b79c9703ca383b$export$79403a05110b2cfc || ($27b79c9703ca383b$export$79403a05110b2cfc = {}));
var $27b79c9703ca383b$export$e92bebf6311e8221;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($27b79c9703ca383b$export$e92bebf6311e8221 || ($27b79c9703ca383b$export$e92bebf6311e8221 = {}));
class $27b79c9703ca383b$export$6036b6a06cf1bd7e {
    constructor(speechServiceConfig, parameters){
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new (0, $6xqgT.SpeechServiceConfig)(new (0, $6xqgT.Context)(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        this.privLanguageIdMode = parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_LanguageIdMode, undefined);
        this.privEnableSpeakerId = false;
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(value) {
        this.privRecognitionMode = value;
        this.privRecognitionActivityTimeout = value === $27b79c9703ca383b$export$79403a05110b2cfc.Interactive ? 8000 : 25000;
        this.privSpeechServiceConfig.Recognition = $27b79c9703ca383b$export$79403a05110b2cfc[value];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $27b79c9703ca383b$export$79403a05110b2cfc.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_RecognitionEndpointVersion, undefined);
    }
    get sourceLanguageModels() {
        const models = [];
        let modelsExist = false;
        if (this.autoDetectSourceLanguages !== undefined) for (const language of this.autoDetectSourceLanguages.split(",")){
            const customProperty = language + (0, $fWPg2.PropertyId).SpeechServiceConnection_EndpointId.toString();
            const modelId = this.parameters.getProperty(customProperty, undefined);
            if (modelId !== undefined) {
                models.push({
                    language: language,
                    endpoint: modelId
                });
                modelsExist = true;
            } else models.push({
                language: language,
                endpoint: ""
            });
        }
        return modelsExist ? models : undefined;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    set isSpeakerDiarizationEnabled(value) {
        this.privEnableSpeakerId = value;
    }
}

});

parcelRegister("lkId6", function(module, exports) {

$parcel$export(module.exports, "RequestSession", () => $f87dc27befc29b7b$export$64a8db883c198597);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8lWt4 = parcelRequire("8lWt4");
var $ciGbY = parcelRequire("ciGbY");
var $5vbCN = parcelRequire("5vbCN");

var $5bgRq = parcelRequire("5bgRq");

var $izEx7 = parcelRequire("izEx7");
var $f87dc27befc29b7b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $f87dc27befc29b7b$export$64a8db883c198597 {
    constructor(audioSourceId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecognitionBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = (0, $8lWt4.createNoDashGuid)();
        this.privAudioNodeId = (0, $8lWt4.createNoDashGuid)();
        this.privTurnDeferral = new (0, $ciGbY.Deferred)();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    // The number of bytes sent for the current recognition.
    // Counter is reset to 0 each time recognition is started.
    get recognitionBytesSent() {
        return this.privRecognitionBytesSent;
    }
    listenForServiceTelemetry(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privRecognitionBytesSent = 0;
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new (0, $izEx7.ServiceTelemetryListener)(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new (0, $5bgRq.RecognitionTriggeredEvent)(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onAudioSourceAttachCompleted(audioNode, isError) {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            this.privAudioNode = audioNode;
            this.privIsAudioNodeDetached = false;
            if (isError) yield this.onComplete();
            else this.onEvent(new (0, $5bgRq.ListeningStartedEvent)(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
        });
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.privSessionId = connectionId;
        this.onEvent(new (0, $5bgRq.ConnectingToServiceEvent)(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    onAuthCompleted(isError) {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            if (isError) yield this.onComplete();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onConnectionEstablishCompleted(statusCode, reason) {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            if (statusCode === 200) {
                this.onEvent(new (0, $5bgRq.RecognitionStartedEvent)(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
                if (!!this.privAudioNode) this.privAudioNode.replay();
                this.privTurnStartAudioOffset = this.privLastRecoOffset;
                this.privBytesSent = 0;
                return;
            } else if (statusCode === 403) yield this.onComplete();
        });
    }
    onServiceTurnEndResponse(continuousRecognition) {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            this.privTurnDeferral.resolve();
            if (!continuousRecognition || this.isSpeechEnded) {
                yield this.onComplete();
                this.privInTurn = false;
            } else {
                // Start a new request set.
                this.privTurnStartAudioOffset = this.privLastRecoOffset;
                this.privAudioNode.replay();
            }
        });
    }
    onSpeechContext() {
        this.privRequestId = (0, $8lWt4.createNoDashGuid)();
    }
    onServiceTurnStartResponse() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new (0, $ciGbY.Deferred)();
    }
    onHypothesis(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    }
    onPhraseRecognized(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    }
    onServiceRecognized(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    }
    onAudioSent(bytesSent) {
        this.privBytesSent += bytesSent;
        this.privRecognitionBytesSent += bytesSent;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    dispose() {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                // we should have completed by now. If we did not its an unknown error.
                this.privIsDisposed = true;
                for (const detachable of this.privDetachables)yield detachable.detach();
                if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.dispose();
                this.privIsRecognizing = false;
            }
        });
    }
    getTelemetry() {
        if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
        else return null;
    }
    onStopRecognizing() {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.onComplete();
        });
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = true;
    }
    onEvent(event) {
        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
        (0, $5vbCN.Events).instance.onEvent(event);
    }
    onComplete() {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privIsRecognizing) {
                this.privIsRecognizing = false;
                yield this.detachAudioNode();
            }
        });
    }
    detachAudioNode() {
        return $f87dc27befc29b7b$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privIsAudioNodeDetached) {
                this.privIsAudioNodeDetached = true;
                if (this.privAudioNode) yield this.privAudioNode.detach();
            }
        });
    }
}

});
parcelRegister("5bgRq", function(module, exports) {

$parcel$export(module.exports, "RecognitionTriggeredEvent", () => $3c5b0efd67d2dee7$export$5a7a93aa45921175);
$parcel$export(module.exports, "ListeningStartedEvent", () => $3c5b0efd67d2dee7$export$4093ad2c899cda43);
$parcel$export(module.exports, "ConnectingToServiceEvent", () => $3c5b0efd67d2dee7$export$beef32cc459c1496);
$parcel$export(module.exports, "RecognitionStartedEvent", () => $3c5b0efd67d2dee7$export$32b70f34e60833d0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $dVTTx = parcelRequire("dVTTx");
class $3c5b0efd67d2dee7$export$2faa991ee52d1699 extends (0, $dVTTx.PlatformEvent) {
    constructor(eventName, requestId, sessionId, eventType = (0, $dVTTx.EventType).Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
        this.privSessionId = sessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $3c5b0efd67d2dee7$export$5a7a93aa45921175 extends $3c5b0efd67d2dee7$export$2faa991ee52d1699 {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("RecognitionTriggeredEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $3c5b0efd67d2dee7$export$4093ad2c899cda43 extends $3c5b0efd67d2dee7$export$2faa991ee52d1699 {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("ListeningStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $3c5b0efd67d2dee7$export$beef32cc459c1496 extends $3c5b0efd67d2dee7$export$2faa991ee52d1699 {
    constructor(requestId, authFetchEventid, sessionId){
        super("ConnectingToServiceEvent", requestId, sessionId);
        this.privAuthFetchEventid = authFetchEventid;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
class $3c5b0efd67d2dee7$export$32b70f34e60833d0 extends $3c5b0efd67d2dee7$export$2faa991ee52d1699 {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId){
        super("RecognitionStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $3c5b0efd67d2dee7$export$ed6cf71006422f40;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($3c5b0efd67d2dee7$export$ed6cf71006422f40 || ($3c5b0efd67d2dee7$export$ed6cf71006422f40 = {}));
class $3c5b0efd67d2dee7$export$8de1ba0528dc7861 extends $3c5b0efd67d2dee7$export$2faa991ee52d1699 {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error){
        super("RecognitionEndedEvent", requestId, sessionId, status === $3c5b0efd67d2dee7$export$ed6cf71006422f40.Success ? (0, $dVTTx.EventType).Info : (0, $dVTTx.EventType).Error);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
        this.privStatus = status;
        this.privError = error;
        this.privServiceTag = serviceTag;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    get serviceTag() {
        return this.privServiceTag;
    }
    get status() {
        return this.privStatus;
    }
    get error() {
        return this.privError;
    }
}

});

parcelRegister("izEx7", function(module, exports) {

$parcel$export(module.exports, "ServiceTelemetryListener", () => $d85aefe7af370369$export$12a36cb0f88ffb8d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $1AwHR = parcelRequire("1AwHR");
var $ls19Y = parcelRequire("ls19Y");

var $5bgRq = parcelRequire("5bgRq");
class $d85aefe7af370369$export$12a36cb0f88ffb8d {
    constructor(requestId, audioSourceId, audioNodeId){
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    phraseReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    }
    hypothesisReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    }
    onEvent(e) {
        if (this.privIsDisposed) return;
        if (e instanceof (0, $5bgRq.RecognitionTriggeredEvent) && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        };
        if (e instanceof (0, $1AwHR.AudioStreamNodeAttachingEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof (0, $1AwHR.AudioStreamNodeAttachedEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof (0, $1AwHR.AudioSourceErrorEvent) && e.audioSourceId === this.privAudioSourceId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof (0, $1AwHR.AudioStreamNodeErrorEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof (0, $1AwHR.AudioStreamNodeDetachedEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof (0, $5bgRq.ConnectingToServiceEvent) && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
        if (e instanceof (0, $ls19Y.ConnectionStartEvent) && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
        if (e instanceof (0, $ls19Y.ConnectionEstablishedEvent) && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof (0, $ls19Y.ConnectionEstablishErrorEvent) && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Error: this.getConnectionError(e.statusCode),
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof (0, $ls19Y.ConnectionMessageReceivedEvent) && e.connectionId === this.privConnectionId) {
            if (e.message && e.message.headers && e.message.headers.path) {
                if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                const maxMessagesToSend = 50;
                if (this.privReceivedMessages[e.message.headers.path].length < maxMessagesToSend) this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
            }
        }
    }
    getTelemetry() {
        const metrics = new Array();
        if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
        if (this.privMicMetric) metrics.push(this.privMicMetric);
        if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
        if (this.privPhraseLatencies.length > 0) metrics.push({
            PhraseLatencyMs: this.privPhraseLatencies
        });
        if (this.privHypothesisLatencies.length > 0) metrics.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const telemetry = {
            Metrics: metrics,
            ReceivedMessages: this.privReceivedMessages
        };
        const json = JSON.stringify(telemetry);
        // We dont want to send the same telemetry again. So clean those out.
        this.privReceivedMessages = {};
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
        return json;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = true;
    }
    getConnectionError(statusCode) {
        /*
        -- Websocket status codes --
        NormalClosure = 1000,
        EndpointUnavailable = 1001,
        ProtocolError = 1002,
        InvalidMessageType = 1003,
        Empty = 1005,
        InvalidPayloadData = 1007,
        PolicyViolation = 1008,
        MessageTooBig = 1009,
        MandatoryExtension = 1010,
        InternalServerError = 1011
        */ switch(statusCode){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + statusCode.toString();
        }
    }
}

});


parcelRegister("hRi9W", function(module, exports) {

$parcel$export(module.exports, "SpeechContext", () => $d00578fe1ead9939$export$11ed12a49459a250);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $d00578fe1ead9939$export$11ed12a49459a250 {
    constructor(dynamicGrammar){
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    /**
     * Gets a section of the speech.context object.
     * @param sectionName Name of the section to get.
     * @return string or Context JSON serializable object that represents the value.
     */ getSection(sectionName) {
        return this.privContext[sectionName] || {};
    }
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ setPronunciationAssessmentParams(params, contentAssessmentTopic, isSpeakerDiarizationEnabled = false) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        if (this.privContext.phraseDetection.enrichment === undefined) this.privContext.phraseDetection.enrichment = {
            pronunciationAssessment: {}
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        if (isSpeakerDiarizationEnabled) this.privContext.phraseDetection.mode = "Conversation";
        this.setWordLevelTimings();
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1) this.privContext.phraseOutput.detailed.options.push("SNR");
        if (!!contentAssessmentTopic) {
            this.privContext.phraseDetection.enrichment.contentAssessment = {
                topic: contentAssessmentTopic
            };
            this.privContext.phraseOutput.detailed.options.push("ContentAssessment");
        }
    }
    setDetailedOutputFormat() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
    }
    setWordLevelTimings() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    setSpeakerDiarizationAudioOffsetMs(audioOffsetMs) {
        this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = audioOffsetMs;
    }
    toJSON() {
        const dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        const ret = JSON.stringify(this.privContext);
        return ret;
    }
}

});

parcelRegister("5Xm3f", function(module, exports) {

$parcel$export(module.exports, "SpeechDetected", () => $45639161942a5125$export$fa943fcb498ea779);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $45639161942a5125$export$fa943fcb498ea779 {
    constructor(json){
        this.privSpeechStartDetected = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $45639161942a5125$export$fa943fcb498ea779(json);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}

});

parcelRegister("ccM4b", function(module, exports) {

$parcel$export(module.exports, "SpeechConnectionMessage", () => $8e2be402df271926$export$d7d1294d295e5b2a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");
var $k419T = parcelRequire("k419T");

var $40Pvg = parcelRequire("40Pvg");
class $8e2be402df271926$export$d7d1294d295e5b2a extends (0, $k419T.ConnectionMessage) {
    constructor(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id){
        if (!path) throw new (0, $3NF6I.ArgumentNullError)("path");
        if (!requestId) throw new (0, $3NF6I.ArgumentNullError)("requestId");
        const headers = {};
        headers[(0, $40Pvg.HeaderNames).Path] = path;
        headers[(0, $40Pvg.HeaderNames).RequestId] = requestId;
        headers[(0, $40Pvg.HeaderNames).RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[(0, $40Pvg.HeaderNames).ContentType] = contentType;
        if (streamId) headers[(0, $40Pvg.HeaderNames).RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(const headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) super(messageType, body, headers, id);
        else super(messageType, body, headers);
        this.privPath = path;
        this.privRequestId = requestId;
        this.privContentType = contentType;
        this.privStreamId = streamId;
        this.privAdditionalHeaders = additionalHeaders;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(message) {
        let path = null;
        let requestId = null;
        let contentType = null;
        // let requestTimestamp = null;
        let streamId = null;
        const additionalHeaders = {};
        if (message.headers) {
            for(const headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === (0, $40Pvg.HeaderNames).Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === (0, $40Pvg.HeaderNames).RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === (0, $40Pvg.HeaderNames).ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === (0, $40Pvg.HeaderNames).RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new $8e2be402df271926$export$d7d1294d295e5b2a(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    }
}

});


parcelRegister("iUPWQ", function(module, exports) {

$parcel$export(module.exports, "WebsocketMessageFormatter", () => $dc55c0c4cccf4a8e$export$668bf8a6f768f67a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $k419T = parcelRequire("k419T");
var $ciGbY = parcelRequire("ciGbY");
var $hkGW0 = parcelRequire("hkGW0");
const $dc55c0c4cccf4a8e$var$CRLF = "\r\n";
class $dc55c0c4cccf4a8e$export$668bf8a6f768f67a {
    toConnectionMessage(message) {
        const deferral = new (0, $ciGbY.Deferred)();
        try {
            if (message.messageType === (0, $k419T.MessageType).Text) {
                const textMessage = message.textContent;
                let headers = {};
                let body = null;
                if (textMessage) {
                    const headerBodySplit = textMessage.split("\r\n\r\n");
                    if (headerBodySplit && headerBodySplit.length > 0) {
                        headers = this.parseHeaders(headerBodySplit[0]);
                        if (headerBodySplit.length > 1) body = headerBodySplit[1];
                    }
                }
                deferral.resolve(new (0, $k419T.ConnectionMessage)(message.messageType, body, headers, message.id));
            } else if (message.messageType === (0, $k419T.MessageType).Binary) {
                const binaryMessage = message.binaryContent;
                let headers = {};
                let body = null;
                if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                const dataView = new DataView(binaryMessage);
                const headerLength = dataView.getInt16(0);
                if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                let headersString = "";
                for(let i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                headers = this.parseHeaders(headersString);
                if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                deferral.resolve(new (0, $k419T.ConnectionMessage)(message.messageType, body, headers, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    fromConnectionMessage(message) {
        const deferral = new (0, $ciGbY.Deferred)();
        try {
            if (message.messageType === (0, $k419T.MessageType).Text) {
                const payload = `${this.makeHeaders(message)}${$dc55c0c4cccf4a8e$var$CRLF}${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new (0, $hkGW0.RawWebsocketMessage)((0, $k419T.MessageType).Text, payload, message.id));
            } else if (message.messageType === (0, $k419T.MessageType).Binary) {
                const headersString = this.makeHeaders(message);
                const content = message.binaryBody;
                const headerBuffer = this.stringToArrayBuffer(headersString);
                const headerInt8Array = new Int8Array(headerBuffer);
                const headerLength = headerInt8Array.byteLength;
                const payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                payloadInt8Array[0] = headerLength >> 8 & 0xff;
                payloadInt8Array[1] = headerLength & 0xff;
                payloadInt8Array.set(headerInt8Array, 2);
                if (content) {
                    const bodyInt8Array = new Int8Array(content);
                    payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                }
                const payload = payloadInt8Array.buffer;
                deferral.resolve(new (0, $hkGW0.RawWebsocketMessage)((0, $k419T.MessageType).Binary, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
    makeHeaders(message) {
        let headersString = "";
        if (message.headers) {
            for(const header in message.headers)if (header) headersString += `${header}: ${message.headers[header]}${$dc55c0c4cccf4a8e$var$CRLF}`;
        }
        return headersString;
    }
    parseHeaders(headersString) {
        const headers = {};
        if (headersString) {
            const headerMatches = headersString.match(/[^\r\n]+/g);
            if (headers) {
                for (const header of headerMatches)if (header) {
                    const separatorIndex = header.indexOf(":");
                    const headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                    const headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                    headers[headerName] = headerValue;
                }
            }
        }
        return headers;
    }
    stringToArrayBuffer(str) {
        const buffer = new ArrayBuffer(str.length);
        const view = new DataView(buffer);
        for(let i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
        return buffer;
    }
}

});
parcelRegister("hkGW0", function(module, exports) {

$parcel$export(module.exports, "RawWebsocketMessage", () => $c9e59bd21b330f3f$export$4d4fca4599964cf2);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $k419T = parcelRequire("k419T");

var $3NF6I = parcelRequire("3NF6I");

var $8lWt4 = parcelRequire("8lWt4");
class $c9e59bd21b330f3f$export$4d4fca4599964cf2 {
    constructor(messageType, payload, id){
        this.privPayload = null;
        if (!payload) throw new (0, $3NF6I.ArgumentNullError)("payload");
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (messageType === (0, $k419T.MessageType).Binary && payload.__proto__.constructor.name !== "ArrayBuffer") throw new (0, $3NF6I.InvalidOperationError)("Payload must be ArrayBuffer");
        if (messageType === (0, $k419T.MessageType).Text && !(typeof payload === "string")) throw new (0, $3NF6I.InvalidOperationError)("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : (0, $8lWt4.createNoDashGuid)();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === (0, $k419T.MessageType).Binary) throw new (0, $3NF6I.InvalidOperationError)("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === (0, $k419T.MessageType).Text) throw new (0, $3NF6I.InvalidOperationError)("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}

});


parcelRegister("gXTdh", function(module, exports) {

$parcel$export(module.exports, "SpeechConnectionFactory", () => $c59cfc3ce2eedfdd$export$6edb081562b8a962);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $bRS6a = parcelRequire("bRS6a");
var $4MedZ = parcelRequire("4MedZ");

var $hgjD5 = parcelRequire("hgjD5");

var $jcTbW = parcelRequire("jcTbW");
var $fWPg2 = parcelRequire("fWPg2");

var $kBobk = parcelRequire("kBobk");

var $3ppF1 = parcelRequire("3ppF1");
var $iUPWQ = parcelRequire("iUPWQ");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");
class $c59cfc3ce2eedfdd$export$6edb081562b8a962 extends (0, $kBobk.ConnectionFactoryBase) {
    constructor(){
        super(...arguments);
        this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
        this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
        this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";
        this.universalUri = "/speech/universal/v";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Region, undefined);
        const hostSuffix = (0, $kBobk.ConnectionFactoryBase).getHostSuffix(region);
        const host = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search((0, $jE6M6.QueryParameterNames).CustomSpeechDeploymentId) === -1) queryParams[(0, $jE6M6.QueryParameterNames).CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search((0, $jE6M6.QueryParameterNames).Language) === -1) queryParams[(0, $jE6M6.QueryParameterNames).Language] = language;
        }
        if (!endpoint || endpoint.search((0, $jE6M6.QueryParameterNames).Format) === -1) queryParams[(0, $jE6M6.QueryParameterNames).Format] = config.parameters.getProperty((0, $hgjD5.OutputFormatPropertyName), (0, $jcTbW.OutputFormat)[(0, $jcTbW.OutputFormat).Simple]).toLowerCase();
        if (config.autoDetectSourceLanguages !== undefined) queryParams[(0, $jE6M6.QueryParameterNames).EnableLanguageId] = "true";
        this.setCommonUrlParams(config, queryParams, endpoint);
        if (!endpoint) switch(config.recognitionMode){
            case (0, $3ppF1.RecognitionMode).Conversation:
                if (config.parameters.getProperty((0, $hgjD5.ForceDictationPropertyName), "false") === "true") endpoint = host + this.dictationRelativeUri;
                else if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.conversationRelativeUri;
                break;
            case (0, $3ppF1.RecognitionMode).Dictation:
                endpoint = host + this.dictationRelativeUri;
                break;
            default:
                if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.interactiveRelativeUri; // default is interactive
                break;
        }
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[(0, $40Pvg.HeaderNames).ConnectionId] = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new (0, $4MedZ.WebsocketConnection)(endpoint, queryParams, headers, new (0, $iUPWQ.WebsocketMessageFormatter)(), (0, $bRS6a.ProxyInfo).fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
}

});
parcelRegister("bRS6a", function(module, exports) {

$parcel$export(module.exports, "ProxyInfo", () => $8a3e9bc939eeb4f6$export$3199a3edab3bbf8);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $fWPg2 = parcelRequire("fWPg2");
class $8a3e9bc939eeb4f6$export$3199a3edab3bbf8 {
    constructor(proxyHostName, proxyPort, proxyUserName, proxyPassword){
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
    static fromParameters(parameters) {
        return new $8a3e9bc939eeb4f6$export$3199a3edab3bbf8(parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyPort), 10), parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyUserName), parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(config) {
        return this.fromParameters(config.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
}

});

parcelRegister("4MedZ", function(module, exports) {

$parcel$export(module.exports, "WebsocketConnection", () => $37a6add96d63ba14$export$659cb444c1aa6c10);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");
var $8lWt4 = parcelRequire("8lWt4");

var $kvQYc = parcelRequire("kvQYc");
var $37a6add96d63ba14$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $37a6add96d63ba14$export$659cb444c1aa6c10 {
    constructor(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression = false, connectionId){
        this.privIsDisposed = false;
        if (!uri) throw new (0, $3NF6I.ArgumentNullError)("uri");
        if (!messageFormatter) throw new (0, $3NF6I.ArgumentNullError)("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        let queryParams = "";
        let i = 0;
        if (queryParameters) {
            for(const paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const key = encodeURIComponent(paramName);
                queryParams += key;
                let val = queryParameters[paramName];
                if (val) {
                    val = encodeURIComponent(val);
                    queryParams += `=${val}`;
                }
                i++;
            }
        }
        if (headers) {
            for(const headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(headers[headerName]);
                queryParams += `${headerName}=${val}`;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : (0, $8lWt4.createNoDashGuid)();
        this.privConnectionMessageAdapter = new (0, $kvQYc.WebsocketMessageAdapter)(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    dispose() {
        return $37a6add96d63ba14$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privConnectionMessageAdapter) yield this.privConnectionMessageAdapter.close();
        });
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(message) {
        return this.privConnectionMessageAdapter.send(message);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}

});
parcelRegister("kvQYc", function(module, exports) {

$parcel$export(module.exports, "WebsocketMessageAdapter", () => $eeefcaa3c5db8bfe$export$2b2f6d87ad7998b5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $9zn7p = parcelRequire("9zn7p");

var $9zn7p = parcelRequire("9zn7p");

var $9zn7p = parcelRequire("9zn7p");

var $9zn7p = parcelRequire("9zn7p");

var $9zn7p = parcelRequire("9zn7p");

var $40Pvg = parcelRequire("40Pvg");

var $3NF6I = parcelRequire("3NF6I");
var $lWqSg = parcelRequire("lWqSg");
var $ls19Y = parcelRequire("ls19Y");
var $jyCxe = parcelRequire("jyCxe");
var $9klG9 = parcelRequire("9klG9");
var $ciGbY = parcelRequire("ciGbY");
var $5vbCN = parcelRequire("5vbCN");
var $9SKhX = parcelRequire("9SKhX");
var $k419T = parcelRequire("k419T");
var $63lFD = parcelRequire("63lFD");
var $hkGW0 = parcelRequire("hkGW0");

var $f2Nvv = parcelRequire("f2Nvv");
var $eeefcaa3c5db8bfe$require$Buffer = $f2Nvv.Buffer;
var $eeefcaa3c5db8bfe$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $eeefcaa3c5db8bfe$export$2b2f6d87ad7998b5 {
    constructor(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression){
        if (!uri) throw new (0, $3NF6I.ArgumentNullError)("uri");
        if (!messageFormatter) throw new (0, $3NF6I.ArgumentNullError)("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new (0, $9SKhX.EventSource)();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = (0, $9klG9.ConnectionState).None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[(0, $40Pvg.HeaderNames).ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === (0, $9klG9.ConnectionState).Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new (0, $ciGbY.Deferred)();
        this.privCertificateValidatedDeferral = new (0, $ciGbY.Deferred)();
        this.privConnectionState = (0, $9klG9.ConnectionState).Connecting;
        try {
            if (typeof WebSocket !== "undefined" && !$eeefcaa3c5db8bfe$export$2b2f6d87ad7998b5.forceNpmWebSocket) {
                // Browser handles cert checks.
                this.privCertificateValidatedDeferral.resolve();
                this.privWebsocketClient = new WebSocket(this.privUri);
            } else {
                const options = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                // The ocsp library will handle validation for us and fail the connection if needed.
                this.privCertificateValidatedDeferral.resolve();
                options.agent = this.getAgent();
                // Workaround for https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/465
                // Which is root caused by https://github.com/TooTallNate/node-agent-base/issues/61
                const uri = new URL(this.privUri);
                let protocol = uri.protocol;
                if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "wss:") protocol = "https:";
                else if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "ws:") protocol = "http:";
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                options.agent.protocol = protocol;
                this.privWebsocketClient = new (0, (/*@__PURE__*/$parcel$interopDefault($9zn7p)))(this.privUri, options);
            }
            this.privWebsocketClient.binaryType = "arraybuffer";
            this.privReceivingMessageQueue = new (0, $63lFD.Queue)();
            this.privDisconnectDeferral = new (0, $ciGbY.Deferred)();
            this.privSendMessageQueue = new (0, $63lFD.Queue)();
            this.processSendQueue().catch((reason)=>{
                (0, $5vbCN.Events).instance.onEvent(new (0, $lWqSg.BackgroundEvent)(reason));
            });
        } catch (error) {
            this.privConnectionEstablishDeferral.resolve(new (0, $jyCxe.ConnectionOpenResponse)(500, error));
            return this.privConnectionEstablishDeferral.promise;
        }
        this.onEvent(new (0, $ls19Y.ConnectionStartEvent)(this.privConnectionId, this.privUri));
        this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = (0, $9klG9.ConnectionState).Connected;
                this.onEvent(new (0, $ls19Y.ConnectionEstablishedEvent)(this.privConnectionId));
                this.privConnectionEstablishDeferral.resolve(new (0, $jyCxe.ConnectionOpenResponse)(200, ""));
            }, (error)=>{
                this.privConnectionEstablishDeferral.reject(error);
            });
        };
        this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new (0, $ls19Y.ConnectionErrorEvent)(this.privConnectionId, e.message, e.type));
            this.privLastErrorReceived = e.message;
        };
        this.privWebsocketClient.onclose = (e)=>{
            if (this.privConnectionState === (0, $9klG9.ConnectionState).Connecting) {
                this.privConnectionState = (0, $9klG9.ConnectionState).Disconnected;
                // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                this.privConnectionEstablishDeferral.resolve(new (0, $jyCxe.ConnectionOpenResponse)(e.code, e.reason + " " + this.privLastErrorReceived));
            } else {
                this.privConnectionState = (0, $9klG9.ConnectionState).Disconnected;
                this.privWebsocketClient = null;
                this.onEvent(new (0, $ls19Y.ConnectionClosedEvent)(this.privConnectionId, e.code, e.reason));
            }
            this.onClose(e.code, e.reason).catch((reason)=>{
                (0, $5vbCN.Events).instance.onEvent(new (0, $lWqSg.BackgroundEvent)(reason));
            });
        };
        this.privWebsocketClient.onmessage = (e)=>{
            const networkReceivedTime = new Date().toISOString();
            if (this.privConnectionState === (0, $9klG9.ConnectionState).Connected) {
                const deferred = new (0, $ciGbY.Deferred)();
                // let id = ++this.idCounter;
                this.privReceivingMessageQueue.enqueueFromPromise(deferred.promise);
                if (e.data instanceof ArrayBuffer) {
                    const rawMessage = new (0, $hkGW0.RawWebsocketMessage)((0, $k419T.MessageType).Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new (0, $ls19Y.ConnectionMessageReceivedEvent)(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid binary message format. Error: ${error}`);
                    });
                } else {
                    const rawMessage = new (0, $hkGW0.RawWebsocketMessage)((0, $k419T.MessageType).Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new (0, $ls19Y.ConnectionMessageReceivedEvent)(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid text message format. Error: ${error}`);
                    });
                }
            }
        };
        return this.privConnectionEstablishDeferral.promise;
    }
    send(message) {
        if (this.privConnectionState !== (0, $9klG9.ConnectionState).Connected) return Promise.reject(`Cannot send on connection that is in ${(0, $9klG9.ConnectionState)[this.privConnectionState]} state`);
        const messageSendStatusDeferral = new (0, $ciGbY.Deferred)();
        const messageSendDeferral = new (0, $ciGbY.Deferred)();
        this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
        this.privMessageFormatter.fromConnectionMessage(message).then((rawMessage)=>{
            messageSendDeferral.resolve({
                Message: message,
                RawWebsocketMessage: rawMessage,
                sendStatusDeferral: messageSendStatusDeferral
            });
        }, (error)=>{
            messageSendDeferral.reject(`Error formatting the message. ${error}`);
        });
        return messageSendStatusDeferral.promise;
    }
    read() {
        if (this.privConnectionState !== (0, $9klG9.ConnectionState).Connected) return Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`);
        return this.privReceivingMessageQueue.dequeue();
    }
    close(reason) {
        if (this.privWebsocketClient) {
            if (this.privConnectionState !== (0, $9klG9.ConnectionState).Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
        } else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(sendItem) {
        try {
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return Promise.resolve();
            this.onEvent(new (0, $ls19Y.ConnectionMessageSentEvent)(this.privConnectionId, new Date().toISOString(), sendItem.Message));
            // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
            if (this.isWebsocketOpen) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(`websocket send error: ${e}`);
        }
    }
    onClose(code, reason) {
        return $eeefcaa3c5db8bfe$var$__awaiter(this, void 0, void 0, function*() {
            const closeReason = `Connection closed. ${code}: ${reason}`;
            this.privConnectionState = (0, $9klG9.ConnectionState).Disconnected;
            this.privDisconnectDeferral.resolve();
            yield this.privReceivingMessageQueue.drainAndDispose(()=>{
            // TODO: Events for these ?
            // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
            }, closeReason);
            yield this.privSendMessageQueue.drainAndDispose((pendingSendItem)=>{
                pendingSendItem.sendStatusDeferral.reject(closeReason);
            }, closeReason);
        });
    }
    processSendQueue() {
        return $eeefcaa3c5db8bfe$var$__awaiter(this, void 0, void 0, function*() {
            while(true){
                const itemToSend = this.privSendMessageQueue.dequeue();
                const sendItem = yield itemToSend;
                // indicates we are draining the queue and it came with no message;
                if (!sendItem) return;
                try {
                    yield this.sendRawMessage(sendItem);
                    sendItem.sendStatusDeferral.resolve();
                } catch (sendError) {
                    sendItem.sendStatusDeferral.reject(sendError);
                }
            }
        });
    }
    onEvent(event) {
        this.privConnectionEvents.onEvent(event);
        (0, $5vbCN.Events).instance.onEvent(event);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const agent = new (0, (/*@__PURE__*/$parcel$interopDefault($9zn7p))).Agent(this.createConnection);
        if (this.proxyInfo !== undefined && this.proxyInfo.HostName !== undefined && this.proxyInfo.Port > 0) agent.proxyInfo = this.proxyInfo;
        return agent;
    }
    static GetProxyAgent(proxyInfo) {
        const httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $eeefcaa3c5db8bfe$require$Buffer(`${proxyInfo.UserName}:${proxyInfo.Password === undefined ? "" : proxyInfo.Password}`).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        const httpProxyAgent = new (0, (/*@__PURE__*/$parcel$interopDefault($9zn7p)))(httpProxyOptions);
        return httpProxyAgent;
    }
    createConnection(request, options) {
        let socketPromise;
        options = Object.assign(Object.assign({}, options), {
            requestOCSP: true,
            servername: options.host
        });
        if (!!this.proxyInfo) {
            const httpProxyAgent = $eeefcaa3c5db8bfe$export$2b2f6d87ad7998b5.GetProxyAgent(this.proxyInfo);
            const baseAgent = httpProxyAgent;
            socketPromise = new Promise((resolve, reject)=>{
                baseAgent.callback(request, options, (error, socket)=>{
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($9zn7p.connect(options));
        else socketPromise = Promise.resolve($9zn7p.connect(options));
        return socketPromise;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
$eeefcaa3c5db8bfe$export$2b2f6d87ad7998b5.forceNpmWebSocket = false;

});
parcelRegister("jyCxe", function(module, exports) {

$parcel$export(module.exports, "ConnectionOpenResponse", () => $e3cf158e7aef369e$export$c90e9ce8e513a038);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $e3cf158e7aef369e$export$c90e9ce8e513a038 {
    constructor(statusCode, reason){
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}

});



parcelRegister("kBobk", function(module, exports) {

$parcel$export(module.exports, "ConnectionFactoryBase", () => $effa05594b805a41$export$7cee44a940f2294a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $hgjD5 = parcelRequire("hgjD5");

var $fWPg2 = parcelRequire("fWPg2");

var $jE6M6 = parcelRequire("jE6M6");
class $effa05594b805a41$export$7cee44a940f2294a {
    static getHostSuffix(region) {
        if (!!region) {
            if (region.toLowerCase().startsWith("china")) return ".azure.cn";
            if (region.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    }
    setCommonUrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                (0, $fWPg2.PropertyId).Speech_SegmentationSilenceTimeoutMs,
                (0, $jE6M6.QueryParameterNames).SegmentationSilenceTimeoutMs
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceConnection_EnableAudioLogging,
                (0, $jE6M6.QueryParameterNames).EnableAudioLogging
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceConnection_EndSilenceTimeoutMs,
                (0, $jE6M6.QueryParameterNames).EndSilenceTimeoutMs
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceConnection_InitialSilenceTimeoutMs,
                (0, $jE6M6.QueryParameterNames).InitialSilenceTimeoutMs
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceResponse_PostProcessingOption,
                (0, $jE6M6.QueryParameterNames).Postprocessing
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceResponse_ProfanityOption,
                (0, $jE6M6.QueryParameterNames).Profanity
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps,
                (0, $jE6M6.QueryParameterNames).EnableWordLevelTimestamps
            ],
            [
                (0, $fWPg2.PropertyId).SpeechServiceResponse_StablePartialResultThreshold,
                (0, $jE6M6.QueryParameterNames).StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty((0, $hgjD5.ServicePropertiesPropertyName), "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
    setUrlParameter(propId, parameterName, config, queryParams, endpoint) {
        const value = config.parameters.getProperty(propId, undefined);
        // FIXME: The .search() check will incorrectly match parameter name anywhere in the string
        //        including e.g. the path portion, or even as a substring of other query parameters
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    }
}

});
parcelRegister("jE6M6", function(module, exports) {

$parcel$export(module.exports, "QueryParameterNames", () => $e4d702137d0d199c$export$cb816fe21be94f3);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $e4d702137d0d199c$export$cb816fe21be94f3 {
}
$e4d702137d0d199c$export$cb816fe21be94f3.BotId = "botid";
$e4d702137d0d199c$export$cb816fe21be94f3.CustomSpeechDeploymentId = "cid";
$e4d702137d0d199c$export$cb816fe21be94f3.CustomVoiceDeploymentId = "deploymentId";
$e4d702137d0d199c$export$cb816fe21be94f3.EnableAudioLogging = "storeAudio";
$e4d702137d0d199c$export$cb816fe21be94f3.EnableLanguageId = "lidEnabled";
$e4d702137d0d199c$export$cb816fe21be94f3.EnableWordLevelTimestamps = "wordLevelTimestamps";
$e4d702137d0d199c$export$cb816fe21be94f3.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$e4d702137d0d199c$export$cb816fe21be94f3.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
$e4d702137d0d199c$export$cb816fe21be94f3.Format = "format";
$e4d702137d0d199c$export$cb816fe21be94f3.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$e4d702137d0d199c$export$cb816fe21be94f3.Language = "language";
$e4d702137d0d199c$export$cb816fe21be94f3.Profanity = "profanity";
$e4d702137d0d199c$export$cb816fe21be94f3.RequestBotStatusMessages = "enableBotMessageStatus";
$e4d702137d0d199c$export$cb816fe21be94f3.StableIntermediateThreshold = "stableIntermediateThreshold";
$e4d702137d0d199c$export$cb816fe21be94f3.StableTranslation = "stableTranslation";
$e4d702137d0d199c$export$cb816fe21be94f3.TestHooks = "testhooks";
$e4d702137d0d199c$export$cb816fe21be94f3.Postprocessing = "postprocessing";
$e4d702137d0d199c$export$cb816fe21be94f3.CtsMeetingId = "meetingId";
$e4d702137d0d199c$export$cb816fe21be94f3.CtsDeviceId = "deviceId";
$e4d702137d0d199c$export$cb816fe21be94f3.CtsIsParticipant = "isParticipant";
$e4d702137d0d199c$export$cb816fe21be94f3.EnableAvatar = "enableTalkingAvatar";

});



parcelRegister("2Fj9D", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisConnectionFactory", () => $1f0e44bfdad73924$export$4d1107899c99ced8);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $bRS6a = parcelRequire("bRS6a");
var $4MedZ = parcelRequire("4MedZ");

var $fWPg2 = parcelRequire("fWPg2");

var $kBobk = parcelRequire("kBobk");

var $iUPWQ = parcelRequire("iUPWQ");

var $40Pvg = parcelRequire("40Pvg");

var $jE6M6 = parcelRequire("jE6M6");
class $1f0e44bfdad73924$export$4d1107899c99ced8 {
    constructor(){
        this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Region, undefined);
        const hostSuffix = (0, $kBobk.ConnectionFactoryBase).getHostSuffix(region);
        const endpointId = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_EndpointId, undefined);
        const hostPrefix = endpointId === undefined ? "tts" : "voice";
        const host = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
        const queryParams = {};
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[(0, $40Pvg.HeaderNames).ConnectionId] = connectionId;
        if (endpointId !== undefined && endpointId !== "") {
            if (!endpoint || endpoint.search((0, $jE6M6.QueryParameterNames).CustomVoiceDeploymentId) === -1) queryParams[(0, $jE6M6.QueryParameterNames).CustomVoiceDeploymentId] = endpointId;
        }
        if (config.avatarEnabled) {
            if (!endpoint || endpoint.search((0, $jE6M6.QueryParameterNames).EnableAvatar) === -1) queryParams[(0, $jE6M6.QueryParameterNames).EnableAvatar] = "true";
        }
        if (!endpoint) endpoint = host + this.synthesisUri;
        config.parameters.setProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new (0, $4MedZ.WebsocketConnection)(endpoint, queryParams, headers, new (0, $iUPWQ.WebsocketMessageFormatter)(), (0, $bRS6a.ProxyInfo).fromParameters(config.parameters), enableCompression, connectionId);
    }
}

});

parcelRegister("3up4e", function(module, exports) {

$parcel$export(module.exports, "EnumTranslation", () => $28a79e45593b71ca$export$f8492c3e19247e15);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $5bdH7 = parcelRequire("5bdH7");
var $6Oi8a = parcelRequire("6Oi8a");
var $20d7X = parcelRequire("20d7X");

var $gNbeL = parcelRequire("gNbeL");
class $28a79e45593b71ca$export$f8492c3e19247e15 {
    static implTranslateRecognitionResult(recognitionStatus) {
        let reason = (0, $20d7X.ResultReason).Canceled;
        switch(recognitionStatus){
            case (0, $gNbeL.RecognitionStatus).Success:
                reason = (0, $20d7X.ResultReason).RecognizedSpeech;
                break;
            case (0, $gNbeL.RecognitionStatus).NoMatch:
            case (0, $gNbeL.RecognitionStatus).InitialSilenceTimeout:
            case (0, $gNbeL.RecognitionStatus).BabbleTimeout:
            case (0, $gNbeL.RecognitionStatus).EndOfDictation:
                reason = (0, $20d7X.ResultReason).NoMatch;
                break;
            case (0, $gNbeL.RecognitionStatus).Error:
            case (0, $gNbeL.RecognitionStatus).BadRequest:
            case (0, $gNbeL.RecognitionStatus).Forbidden:
            default:
                reason = (0, $20d7X.ResultReason).Canceled;
                break;
        }
        return reason;
    }
    static implTranslateCancelResult(recognitionStatus) {
        let reason = (0, $6Oi8a.CancellationReason).EndOfStream;
        switch(recognitionStatus){
            case (0, $gNbeL.RecognitionStatus).Success:
            case (0, $gNbeL.RecognitionStatus).EndOfDictation:
            case (0, $gNbeL.RecognitionStatus).NoMatch:
                reason = (0, $6Oi8a.CancellationReason).EndOfStream;
                break;
            case (0, $gNbeL.RecognitionStatus).InitialSilenceTimeout:
            case (0, $gNbeL.RecognitionStatus).BabbleTimeout:
            case (0, $gNbeL.RecognitionStatus).Error:
            case (0, $gNbeL.RecognitionStatus).BadRequest:
            case (0, $gNbeL.RecognitionStatus).Forbidden:
            default:
                reason = (0, $6Oi8a.CancellationReason).Error;
                break;
        }
        return reason;
    }
    static implTranslateCancelErrorCode(recognitionStatus) {
        let reason = (0, $5bdH7.CancellationErrorCode).NoError;
        switch(recognitionStatus){
            case (0, $gNbeL.RecognitionStatus).Error:
                reason = (0, $5bdH7.CancellationErrorCode).ServiceError;
                break;
            case (0, $gNbeL.RecognitionStatus).TooManyRequests:
                reason = (0, $5bdH7.CancellationErrorCode).TooManyRequests;
                break;
            case (0, $gNbeL.RecognitionStatus).BadRequest:
                reason = (0, $5bdH7.CancellationErrorCode).BadRequestParameters;
                break;
            case (0, $gNbeL.RecognitionStatus).Forbidden:
                reason = (0, $5bdH7.CancellationErrorCode).Forbidden;
                break;
            default:
                reason = (0, $5bdH7.CancellationErrorCode).NoError;
                break;
        }
        return reason;
    }
    static implTranslateErrorDetails(cancellationErrorCode) {
        let errorDetails = "The speech service encountered an internal error and could not continue.";
        switch(cancellationErrorCode){
            case (0, $5bdH7.CancellationErrorCode).Forbidden:
                errorDetails = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case (0, $5bdH7.CancellationErrorCode).BadRequestParameters:
                errorDetails = "Invalid parameter or unsupported audio format in the request.";
                break;
            case (0, $5bdH7.CancellationErrorCode).TooManyRequests:
                errorDetails = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
            default:
                break;
        }
        return errorDetails;
    }
}

});
parcelRegister("gNbeL", function(module, exports) {

$parcel$export(module.exports, "RecognitionStatus", () => $c399f068c86ad2e8$export$9eb5d8ff1b75c8c9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * @class SynthesisStatus
 * @private
 */ var $c399f068c86ad2e8$export$7be11a9ec645348f;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($c399f068c86ad2e8$export$7be11a9ec645348f || ($c399f068c86ad2e8$export$7be11a9ec645348f = {}));
var $c399f068c86ad2e8$export$9eb5d8ff1b75c8c9;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
    RecognitionStatus[RecognitionStatus["BadRequest"] = 7] = "BadRequest";
    RecognitionStatus[RecognitionStatus["Forbidden"] = 8] = "Forbidden";
})($c399f068c86ad2e8$export$9eb5d8ff1b75c8c9 || ($c399f068c86ad2e8$export$9eb5d8ff1b75c8c9 = {}));

});


parcelRegister("buBkw", function(module, exports) {

$parcel$export(module.exports, "SpeechHypothesis", () => $85df73fdb05916be$export$b698b2694660f661);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $85df73fdb05916be$export$b698b2694660f661 {
    constructor(json){
        this.privSpeechHypothesis = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $85df73fdb05916be$export$b698b2694660f661(json);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}

});

parcelRegister("7w59Q", function(module, exports) {

$parcel$export(module.exports, "SpeechServiceRecognizer", () => $578f85c59f575ac7$export$ed87a00dda91f8bd);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $5bdH7 = parcelRequire("5bdH7");
var $jcTbW = parcelRequire("jcTbW");
var $isROj = parcelRequire("isROj");
var $fWPg2 = parcelRequire("fWPg2");
var $20d7X = parcelRequire("20d7X");
var $iGIs8 = parcelRequire("iGIs8");
var $9naJi = parcelRequire("9naJi");
var $b5LoR = parcelRequire("b5LoR");

var $hgjD5 = parcelRequire("hgjD5");
var $cg0MH = parcelRequire("cg0MH");
var $3up4e = parcelRequire("3up4e");
var $gNbeL = parcelRequire("gNbeL");
var $lDTeU = parcelRequire("lDTeU");
var $jsqMv = parcelRequire("jsqMv");
var $buBkw = parcelRequire("buBkw");
var $578f85c59f575ac7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $578f85c59f575ac7$export$ed87a00dda91f8bd extends (0, $lDTeU.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer);
        this.privSpeechRecognizer = speechRecognizer;
    }
    processTypeSpecificMessages(connectionMessage) {
        return $578f85c59f575ac7$var$__awaiter(this, void 0, void 0, function*() {
            let result;
            const resultProps = new (0, $isROj.PropertyCollection)();
            resultProps.setProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            let processed = false;
            switch(connectionMessage.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const hypothesis = (0, $buBkw.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                    const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                    result = new (0, $b5LoR.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $20d7X.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                    this.privRequestSession.onHypothesis(offset);
                    const ev = new (0, $9naJi.SpeechRecognitionEventArgs)(result, hypothesis.Duration, this.privRequestSession.sessionId);
                    if (!!this.privSpeechRecognizer.recognizing) try {
                        this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "speech.phrase":
                    const simple = (0, $jsqMv.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                    const resultReason = (0, $3up4e.EnumTranslation).implTranslateRecognitionResult(simple.RecognitionStatus);
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                    if ((0, $20d7X.ResultReason).Canceled === resultReason) {
                        const cancelReason = (0, $3up4e.EnumTranslation).implTranslateCancelResult(simple.RecognitionStatus);
                        const cancellationErrorCode = (0, $3up4e.EnumTranslation).implTranslateCancelErrorCode(simple.RecognitionStatus);
                        yield this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, (0, $3up4e.EnumTranslation).implTranslateErrorDetails(cancellationErrorCode));
                    } else {
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === (0, $20d7X.ResultReason).NoMatch && simple.RecognitionStatus !== (0, $gNbeL.RecognitionStatus).InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty((0, $hgjD5.OutputFormatPropertyName)) === (0, $jcTbW.OutputFormat)[(0, $jcTbW.OutputFormat).Simple]) result = new (0, $b5LoR.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            else {
                                const detailed = (0, $cg0MH.DetailedSpeechPhrase).fromJSON(connectionMessage.textBody);
                                const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                                const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                                result = new (0, $b5LoR.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === (0, $gNbeL.RecognitionStatus).Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, offsetCorrectedJson, resultProps);
                            }
                            const event = new (0, $9naJi.SpeechRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $isROj.PropertyCollection)();
        properties.setProperty((0, $hgjD5.CancellationErrorCodePropertyName), (0, $5bdH7.CancellationErrorCode)[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            const cancelEvent = new (0, $iGIs8.SpeechRecognitionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $b5LoR.SpeechRecognitionResult)(requestId, (0, $20d7X.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch (_b) {}
        }
    }
}

});
parcelRegister("isROj", function(module, exports) {

$parcel$export(module.exports, "PropertyCollection", () => $d714952c6de1dabc$export$a9938bacf0fbb927);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $fWPg2 = parcelRequire("fWPg2");
class $d714952c6de1dabc$export$a9938bacf0fbb927 {
    constructor(){
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */ getProperty(key, def) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = (0, $fWPg2.PropertyId)[key];
        for(let n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        if (def === undefined) return undefined;
        return String(def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ setProperty(key, value) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = (0, $fWPg2.PropertyId)[key];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ clone() {
        const clonedMap = new $d714952c6de1dabc$export$a9938bacf0fbb927();
        for(let n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */ mergeTo(destinationCollection) {
        this.privKeys.forEach((key)=>{
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                const value = this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    }
    /**
     * Get the keys in Property Collection.
     * @member PropertyCollection.prototype.keys
     * @function
     * @public
     * @returns {string []} Keys in the collection.
     */ get keys() {
        return this.privKeys;
    }
}

});

parcelRegister("iGIs8", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionCanceledEventArgs", () => $d9aea1a2d292a401$export$15ff9e6d819b9207);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $g5epc = parcelRequire("g5epc");
class $d9aea1a2d292a401$export$15ff9e6d819b9207 extends (0, $g5epc.CancellationEventArgsBase) {
}

});
parcelRegister("g5epc", function(module, exports) {

$parcel$export(module.exports, "CancellationEventArgsBase", () => $bb58499c9c1fbac8$export$dd228f7536b5286b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jBghy = parcelRequire("jBghy");
class $bb58499c9c1fbac8$export$dd228f7536b5286b extends (0, $jBghy.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, offset, sessionId){
        super(offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}

});


parcelRegister("9naJi", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionEventArgs", () => $6d2e95b33c75001c$export$a9c37a51b7d8dc18);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $jBghy = parcelRequire("jBghy");
class $6d2e95b33c75001c$export$a9c37a51b7d8dc18 extends (0, $jBghy.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
class $6d2e95b33c75001c$export$bdeacab7c8f9ce49 extends (0, $jBghy.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranscriptionResult} result - The conversation transcription result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the transcription result.
     * @member ConversationTranscription1EventArgs.prototype.result
     * @function
     * @public
     * @returns {ConversationTranscriptionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
class $6d2e95b33c75001c$export$6a51a7d503693c0d extends $6d2e95b33c75001c$export$a9c37a51b7d8dc18 {
}

});

parcelRegister("b5LoR", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionResult", () => $8134ee01dca4e96e$export$e41fbbd40b4d7802);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $fzoDC = parcelRequire("fzoDC");
class $8134ee01dca4e96e$export$e41fbbd40b4d7802 extends (0, $fzoDC.RecognitionResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}

});
parcelRegister("fzoDC", function(module, exports) {

$parcel$export(module.exports, "RecognitionResult", () => $b55d3c7b1d7855c2$export$fbb9fad6e09cd236);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ class $b55d3c7b1d7855c2$export$fbb9fad6e09cd236 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member RecognitionResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member RecognitionResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Presents the recognized text in the result.
     * @member RecognitionResult.prototype.text
     * @function
     * @public
     * @returns {string} Presents the recognized text in the result.
     */ get text() {
        return this.privText;
    }
    /**
     * Duration of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.duration
     * @function
     * @public
     * @returns {number} Duration of recognized speech in 100 nano second increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Offset of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.offset
     * @function
     * @public
     * @returns {number} Offset of recognized speech in 100 nano second increments.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Primary Language detected.
     * @member RecognitionResult.prototype.language
     * @function
     * @public
     * @returns {string} language detected.
     */ get language() {
        return this.privLanguage;
    }
    /**
     * Primary Language detection confidence (Unknown, Low, Medium, High).
     * @member RecognitionResult.prototype.languageDetectionConfidence
     * @function
     * @public
     * @returns {string} detection confidence strength.
     */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member RecognitionResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * A string containing Json serialized recognition result as it was received from the service.
     * @member RecognitionResult.prototype.json
     * @function
     * @private
     * @returns {string} Json serialized representation of the result.
     */ get json() {
        return this.privJson;
    }
    /**
     * The set of properties exposed in the result.
     * @member RecognitionResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}

});


parcelRegister("cg0MH", function(module, exports) {

$parcel$export(module.exports, "DetailedSpeechPhrase", () => $8ec7966bc80cbded$export$a2619747d8979906);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gNbeL = parcelRequire("gNbeL");
class $8ec7966bc80cbded$export$a2619747d8979906 {
    constructor(json){
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = (0, $gNbeL.RecognitionStatus)[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $8ec7966bc80cbded$export$a2619747d8979906(json);
    }
    getJsonWithCorrectedOffsets(baseOffset) {
        if (!!this.privDetailedSpeechPhrase.NBest) {
            let firstWordOffset;
            for (const phrase of this.privDetailedSpeechPhrase.NBest)if (!!phrase.Words && !!phrase.Words[0]) {
                firstWordOffset = phrase.Words[0].Offset;
                break;
            }
            if (!!firstWordOffset && firstWordOffset < baseOffset) {
                const offset = baseOffset - firstWordOffset;
                for (const details of this.privDetailedSpeechPhrase.NBest){
                    if (!!details.Words) for (const word of details.Words)word.Offset += offset;
                    if (!!details.DisplayWords) for (const word of details.DisplayWords)word.Offset += offset;
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        if (!!this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0]) return this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText;
        return this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
}

});

parcelRegister("jsqMv", function(module, exports) {

$parcel$export(module.exports, "SimpleSpeechPhrase", () => $e2a5680a4142a753$export$20e2c3c1649e1f71);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gNbeL = parcelRequire("gNbeL");
class $e2a5680a4142a753$export$20e2c3c1649e1f71 {
    constructor(json){
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = (0, $gNbeL.RecognitionStatus)[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $e2a5680a4142a753$export$20e2c3c1649e1f71(json);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
}

});


parcelRegister("6nl23", function(module, exports) {

$parcel$export(module.exports, "MetadataType", () => $4a45349f0bd6d19b$export$aaf15ef60576e95);
$parcel$export(module.exports, "SynthesisAudioMetadata", () => $4a45349f0bd6d19b$export$82529c92128bfe6c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4a45349f0bd6d19b$export$aaf15ef60576e95;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
    MetadataType["SentenceBoundary"] = "SentenceBoundary";
    MetadataType["SessionEnd"] = "SessionEnd";
    MetadataType["AvatarSignal"] = "TalkingAvatarSignal";
})($4a45349f0bd6d19b$export$aaf15ef60576e95 || ($4a45349f0bd6d19b$export$aaf15ef60576e95 = {}));
class $4a45349f0bd6d19b$export$82529c92128bfe6c {
    constructor(json){
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $4a45349f0bd6d19b$export$82529c92128bfe6c(json);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}

});

parcelRegister("dsBs3", function(module, exports) {

$parcel$export(module.exports, "SynthesisTurn", () => $9ccaf0fa75ec9ef2$export$ffc1d5309a5caa5f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8lWt4 = parcelRequire("8lWt4");
var $ciGbY = parcelRequire("ciGbY");
var $5vbCN = parcelRequire("5vbCN");

var $kzV1n = parcelRequire("kzV1n");

var $isROj = parcelRequire("isROj");
var $fWPg2 = parcelRequire("fWPg2");
var $20d7X = parcelRequire("20d7X");
var $3GDrg = parcelRequire("3GDrg");

var $6nl23 = parcelRequire("6nl23");

var $geVE6 = parcelRequire("geVE6");
var $9ccaf0fa75ec9ef2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9ccaf0fa75ec9ef2$export$ffc1d5309a5caa5f {
    constructor(){
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privRequestId = (0, $8lWt4.createNoDashGuid)();
        this.privTurnDeferral = new (0, $ciGbY.Deferred)();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(value) {
        this.privStreamId = value;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    get extraProperties() {
        if (!!this.privWebRTCSDP) {
            const properties = new (0, $isROj.PropertyCollection)();
            properties.setProperty((0, $fWPg2.PropertyId).TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP);
            return properties;
        }
        return undefined;
    }
    getAllReceivedAudio() {
        return $9ccaf0fa75ec9ef2$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privReceivedAudio) return Promise.resolve(this.privReceivedAudio);
            if (!this.privIsSynthesisEnded) return null;
            yield this.readAllAudioFromStream();
            return Promise.resolve(this.privReceivedAudio);
        });
    }
    getAllReceivedAudioWithHeader() {
        return $9ccaf0fa75ec9ef2$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
            if (!this.privIsSynthesisEnded) return null;
            if (this.audioOutputFormat.hasHeader) {
                const audio = yield this.getAllReceivedAudio();
                this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(audio);
                return this.privReceivedAudioWithHeader;
            } else return this.getAllReceivedAudio();
        });
    }
    startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new (0, $kzV1n.PullAudioOutputStreamImpl)();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privPartialVisemeAnimation = "";
        this.privWebRTCSDP = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new (0, $geVE6.SynthesisTriggeredEvent)(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
    onPreConnectionStart(authFetchEventId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.onEvent(new (0, $geVE6.ConnectingToSynthesisServiceEvent)(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) {
            this.onEvent(new (0, $geVE6.SynthesisStartedEvent)(this.requestId, this.privAuthFetchEventId));
            this.privBytesReceived = 0;
            return;
        } else if (statusCode === 403) this.onComplete();
    }
    onServiceResponseMessage(responseJson) {
        const response = JSON.parse(responseJson);
        this.streamId = response.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = false;
        this.privTurnDeferral.resolve();
        this.onComplete();
    }
    onServiceTurnStartResponse(responseJson) {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new (0, $ciGbY.Deferred)();
        const response = JSON.parse(responseJson);
        if (!!response.webrtc) this.privWebRTCSDP = response.webrtc.connectionString;
    }
    onAudioChunkReceived(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    }
    onTextBoundaryEvent(metadata) {
        this.updateTextOffset(metadata.Data.text.Text, metadata.Type);
    }
    onVisemeMetadataReceived(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    }
    onSessionEnd(metadata) {
        this.privAudioDuration = metadata.Data.Offset;
    }
    constructSynthesisResult() {
        return $9ccaf0fa75ec9ef2$var$__awaiter(this, void 0, void 0, function*() {
            const audioBuffer = yield this.getAllReceivedAudioWithHeader();
            return new (0, $3GDrg.SpeechSynthesisResult)(this.requestId, (0, $20d7X.ResultReason).SynthesizingAudioCompleted, audioBuffer, undefined, this.extraProperties, this.audioDuration);
        });
    }
    dispose() {
        if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
        this.privIsDisposed = true;
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ getAndClearVisemeAnimation() {
        const animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    }
    onEvent(event) {
        (0, $5vbCN.Events).instance.onEvent(event);
    }
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */ static isXmlTag(text) {
        return text.length >= 2 && text[0] === "<" && text[text.length - 1] === ">";
    }
    updateTextOffset(text, type) {
        if (type === (0, $6nl23.MetadataType).WordBoundary) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) {
                this.privNextSearchTextIndex = this.privTextOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privTextOffset) && !$9ccaf0fa75ec9ef2$export$ffc1d5309a5caa5f.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        } else {
            this.privSentenceOffset = this.privRawText.indexOf(text, this.privNextSearchSentenceIndex);
            if (this.privSentenceOffset >= 0) {
                this.privNextSearchSentenceIndex = this.privSentenceOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privSentenceOffset) && !$9ccaf0fa75ec9ef2$export$ffc1d5309a5caa5f.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        }
    }
    onComplete() {
        if (this.privIsSynthesizing) {
            this.privIsSynthesizing = false;
            this.privIsSynthesisEnded = true;
            this.privAudioOutputStream.close();
            this.privInTurn = false;
            if (this.privTurnAudioDestination !== undefined) {
                this.privTurnAudioDestination.close();
                this.privTurnAudioDestination = undefined;
            }
        }
    }
    readAllAudioFromStream() {
        return $9ccaf0fa75ec9ef2$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privIsSynthesisEnded) {
                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                try {
                    yield this.privAudioOutputStream.read(this.privReceivedAudio);
                } catch (e) {
                    this.privReceivedAudio = new ArrayBuffer(0);
                }
            }
        });
    }
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */ withinXmlTag(idx) {
        return this.privRawText.indexOf("<", idx + 1) > this.privRawText.indexOf(">", idx + 1);
    }
}

});
parcelRegister("3GDrg", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisResult", () => $2af3e307ea2c312c$export$7483af638e01359e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jNWUv = parcelRequire("jNWUv");
class $2af3e307ea2c312c$export$7483af638e01359e extends (0, $jNWUv.SynthesisResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */ constructor(resultId, reason, audioData, errorDetails, properties, audioDuration){
        super(resultId, reason, errorDetails, properties);
        this.privAudioData = audioData;
        this.privAudioDuration = audioDuration;
    }
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */ get audioData() {
        return this.privAudioData;
    }
    /**
     * The time duration of synthesized audio, in ticks (100 nanoseconds).
     * @member SpeechSynthesisResult.prototype.audioDuration
     * @function
     * @public
     * @returns {number} The time duration of synthesized audio.
     */ get audioDuration() {
        return this.privAudioDuration;
    }
}

});
parcelRegister("jNWUv", function(module, exports) {

$parcel$export(module.exports, "SynthesisResult", () => $e6b04a4660ac0673$export$39f27198a7645486);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */ class $e6b04a4660ac0673$export$39f27198a7645486 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, errorDetails, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member SynthesisResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The set of properties exposed in the result.
     * @member SynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}

});


parcelRegister("geVE6", function(module, exports) {

$parcel$export(module.exports, "SynthesisTriggeredEvent", () => $bd2aab628a0b7022$export$4bdadafede730bd5);
$parcel$export(module.exports, "ConnectingToSynthesisServiceEvent", () => $bd2aab628a0b7022$export$2024970667be27b8);
$parcel$export(module.exports, "SynthesisStartedEvent", () => $bd2aab628a0b7022$export$4aa6db8ac8b32039);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $dVTTx = parcelRequire("dVTTx");
class $bd2aab628a0b7022$export$cd674f01be9bedfb extends (0, $dVTTx.PlatformEvent) {
    constructor(eventName, requestId, eventType = (0, $dVTTx.EventType).Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
    }
    get requestId() {
        return this.privRequestId;
    }
}
class $bd2aab628a0b7022$export$4bdadafede730bd5 extends $bd2aab628a0b7022$export$cd674f01be9bedfb {
    constructor(requestId, sessionAudioDestinationId, turnAudioDestinationId){
        super("SynthesisTriggeredEvent", requestId);
        this.privSessionAudioDestinationId = sessionAudioDestinationId;
        this.privTurnAudioDestinationId = turnAudioDestinationId;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
class $bd2aab628a0b7022$export$2024970667be27b8 extends $bd2aab628a0b7022$export$cd674f01be9bedfb {
    constructor(requestId, authFetchEventId){
        super("ConnectingToSynthesisServiceEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
class $bd2aab628a0b7022$export$4aa6db8ac8b32039 extends $bd2aab628a0b7022$export$cd674f01be9bedfb {
    constructor(requestId, authFetchEventId){
        super("SynthesisStartedEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}

});


parcelRegister("gd3Vj", function(module, exports) {

$parcel$export(module.exports, "SynthesisAdapterBase", () => $bcd0e75b488f1184$export$6a9ae5f91b217634);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3NF6I = parcelRequire("3NF6I");
var $9klG9 = parcelRequire("9klG9");
var $8lWt4 = parcelRequire("8lWt4");
var $9SKhX = parcelRequire("9SKhX");
var $k419T = parcelRequire("k419T");
var $ls19Y = parcelRequire("ls19Y");

var $5bdH7 = parcelRequire("5bdH7");
var $6Oi8a = parcelRequire("6Oi8a");
var $isROj = parcelRequire("isROj");
var $fWPg2 = parcelRequire("fWPg2");
var $20d7X = parcelRequire("20d7X");
var $ijhvW = parcelRequire("ijhvW");
var $3GDrg = parcelRequire("3GDrg");
var $7cBsb = parcelRequire("7cBsb");
var $8UuSQ = parcelRequire("8UuSQ");

var $51cqC = parcelRequire("51cqC");
var $hgjD5 = parcelRequire("hgjD5");
var $6nl23 = parcelRequire("6nl23");
var $bgoz0 = parcelRequire("bgoz0");
var $dsBs3 = parcelRequire("dsBs3");

var $ccM4b = parcelRequire("ccM4b");
var $bcd0e75b488f1184$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $bcd0e75b488f1184$export$6a9ae5f91b217634 {
    constructor(authentication, connectionFactory, synthesizerConfig, audioDestination){
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        if (!authentication) throw new (0, $3NF6I.ArgumentNullError)("authentication");
        if (!connectionFactory) throw new (0, $3NF6I.ArgumentNullError)("connectionFactory");
        if (!synthesizerConfig) throw new (0, $3NF6I.ArgumentNullError)("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new (0, $dsBs3.SynthesisTurn)();
        this.privConnectionEvents = new (0, $9SKhX.EventSource)();
        this.privServiceEvents = new (0, $9SKhX.EventSource)();
        this.privSynthesisContext = new (0, $bgoz0.SynthesisContext)();
        this.privAgentConfig = new (0, $51cqC.AgentConfig)();
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) this.cancelSynthesisLocal((0, $6Oi8a.CancellationReason).Error, connectionClosedEvent.statusCode === 1007 ? (0, $5bdH7.CancellationErrorCode).BadRequestParameters : (0, $5bdH7.CancellationErrorCode).ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
        this.privSynthesisTurn.audioOutputFormat = format;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
        if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason) {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
            if (this.privConnectionConfigurationPromise !== undefined) {
                const connection = yield this.privConnectionConfigurationPromise;
                yield connection.dispose(reason);
            }
        });
    }
    connect() {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
        });
    }
    sendNetworkMessage(path, payload) {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            const type = typeof payload === "string" ? (0, $k419T.MessageType).Text : (0, $k419T.MessageType).Binary;
            const contentType = typeof payload === "string" ? "application/json" : "";
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $ccM4b.SpeechConnectionMessage)(type, path, this.privSynthesisTurn.requestId, contentType, payload));
        });
    }
    Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            let ssml;
            if (isSSML) ssml = text;
            else ssml = this.privSynthesizer.buildSsml(text);
            if (this.speakOverride !== undefined) return this.speakOverride(ssml, requestId, successCallback, errorCallBack);
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallBack;
            this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
            try {
                yield this.connectImpl();
                const connection = yield this.fetchConnection();
                yield this.sendSynthesisContext(connection);
                yield this.sendSsmlMessage(connection, ssml, requestId);
                this.onSynthesisStarted(requestId);
                this.receiveMessage();
            } catch (e) {
                this.cancelSynthesisLocal((0, $6Oi8a.CancellationReason).Error, (0, $5bdH7.CancellationErrorCode).ConnectionFailure, e);
                return Promise.reject(e);
            }
        });
    }
    stopSpeaking() {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
                action: "stop"
            })));
        });
    }
    // Cancels synthesis.
    cancelSynthesis(requestId, _cancellationReason, errorCode, error) {
        const properties = new (0, $isROj.PropertyCollection)();
        properties.setProperty((0, $hgjD5.CancellationErrorCodePropertyName), (0, $5bdH7.CancellationErrorCode)[errorCode]);
        const result = new (0, $3GDrg.SpeechSynthesisResult)(requestId, (0, $20d7X.ResultReason).Canceled, undefined, error, properties);
        this.onSynthesisCancelled(result);
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* eslint-disable no-empty */ } catch (_a) {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(_connectionMessage) {
        return true;
    }
    receiveMessage() {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const connection = yield this.fetchConnection();
                const message = yield connection.read();
                if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
                if (this.privIsDisposed) // We're done.
                return;
                // indicates we are draining the queue and it came with no message;
                if (!message) {
                    if (!this.privSynthesisTurn.isSynthesizing) return;
                    else return this.receiveMessage();
                }
                const connectionMessage = (0, $ccM4b.SpeechConnectionMessage).fromConnectionMessage(message);
                if (connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        this.privSynthesisTurn.onServiceTurnStartResponse(connectionMessage.textBody);
                        break;
                    case "response":
                        this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                        break;
                    case "audio":
                        if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                            this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                            this.onSynthesizing(connectionMessage.binaryBody);
                            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                        }
                        break;
                    case "audio.metadata":
                        const metadataList = (0, $6nl23.SynthesisAudioMetadata).fromJSON(connectionMessage.textBody).Metadata;
                        for (const metadata of metadataList)switch(metadata.Type){
                            case (0, $6nl23.MetadataType).WordBoundary:
                            case (0, $6nl23.MetadataType).SentenceBoundary:
                                this.privSynthesisTurn.onTextBoundaryEvent(metadata);
                                const wordBoundaryEventArgs = new (0, $8UuSQ.SpeechSynthesisWordBoundaryEventArgs)(metadata.Data.Offset, metadata.Data.Duration, metadata.Data.text.Text, metadata.Data.text.Length, metadata.Type === (0, $6nl23.MetadataType).WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, metadata.Data.text.BoundaryType);
                                this.onWordBoundary(wordBoundaryEventArgs);
                                break;
                            case (0, $6nl23.MetadataType).Bookmark:
                                const bookmarkEventArgs = new (0, $ijhvW.SpeechSynthesisBookmarkEventArgs)(metadata.Data.Offset, metadata.Data.Bookmark);
                                this.onBookmarkReached(bookmarkEventArgs);
                                break;
                            case (0, $6nl23.MetadataType).Viseme:
                                this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                                if (metadata.Data.IsLastAnimation) {
                                    const visemeEventArgs = new (0, $7cBsb.SpeechSynthesisVisemeEventArgs)(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                    this.onVisemeReceived(visemeEventArgs);
                                }
                                break;
                            case (0, $6nl23.MetadataType).AvatarSignal:
                                this.onAvatarEvent(metadata);
                                break;
                            case (0, $6nl23.MetadataType).SessionEnd:
                                this.privSynthesisTurn.onSessionEnd(metadata);
                                break;
                        }
                        break;
                    case "turn.end":
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        let result;
                        try {
                            result = yield this.privSynthesisTurn.constructSynthesisResult();
                            if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                        } catch (error) {
                            if (!!this.privErrorCallback) this.privErrorCallback(error);
                        }
                        this.onSynthesisCompleted(result);
                        break;
                    default:
                        if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new (0, $ls19Y.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                }
                return this.receiveMessage();
            } catch (e) {
            // TODO: What goes here?
            }
        });
    }
    sendSynthesisContext(connection) {
        this.setSynthesisContextSynthesisSection();
        const synthesisContextJson = this.synthesisContext.toJSON();
        if (synthesisContextJson) return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
        return;
    }
    setSpeechConfigSynthesisSection() {
        return;
    }
    connectImpl(isUnAuthorized = false) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === (0, $9klG9.ConnectionState).Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            return this.connectImpl();
        });
        this.privAuthFetchEventId = (0, $8lWt4.createNoDashGuid)();
        this.privConnectionId = (0, $8lWt4.createNoDashGuid)();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then((result)=>$bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
                this.privSynthesisTurn.onAuthCompleted(false);
                const connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
                // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                // it'll stop sending events.
                connection.events.attach((event)=>{
                    this.connectionEvents.onEvent(event);
                });
                const response = yield connection.open();
                if (response.statusCode === 200) {
                    this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.resolve(connection);
                } else if (response.statusCode === 403 && !isUnAuthorized) return this.connectImpl(true);
                else {
                    this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.reject(`Unable to contact server. StatusCode: ${response.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint)} Reason: ${response.reason}`);
                }
            }), (error)=>{
            this.privSynthesisTurn.onAuthCompleted(true);
            throw new Error(error);
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, SpeechServiceConfigJson) {
        if (SpeechServiceConfigJson) return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
    }
    sendSsmlMessage(connection, ssml, requestId) {
        return connection.send(new (0, $ccM4b.SpeechConnectionMessage)((0, $k419T.MessageType).Text, "ssml", requestId, "application/ssml+xml", ssml));
    }
    fetchConnection() {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
                if (connection.state() === (0, $9klG9.ConnectionState).Disconnected) {
                    this.privConnectionId = null;
                    this.privConnectionConfigurationPromise = undefined;
                    return this.fetchConnection();
                }
                return this.privConnectionConfigurationPromise;
            }, ()=>{
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                return this.fetchConnection();
            });
            this.privConnectionConfigurationPromise = this.configureConnection();
            return yield this.privConnectionConfigurationPromise;
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $bcd0e75b488f1184$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.connectImpl();
            if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
            this.setSpeechConfigSynthesisSection();
            yield this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());
            return connection;
        });
    }
    onAvatarEvent(_metadata) {
        return;
    }
    onSynthesisStarted(_requestId) {
        return;
    }
    onSynthesizing(_audio) {
        return;
    }
    onSynthesisCancelled(_result) {
        return;
    }
    onSynthesisCompleted(_result) {
        return;
    }
    onWordBoundary(_wordBoundaryEventArgs) {
        return;
    }
    onVisemeReceived(_visemeEventArgs) {
        return;
    }
    onBookmarkReached(_bookmarkEventArgs) {
        return;
    }
}
$bcd0e75b488f1184$export$6a9ae5f91b217634.telemetryDataEnabled = true;

});
parcelRegister("ijhvW", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisBookmarkEventArgs", () => $d547964a41ea1a6d$export$8f9389ce6b5310bb);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ class $d547964a41ea1a6d$export$8f9389ce6b5310bb {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ constructor(audioOffset, text){
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the bookmark.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the bookmark text.
     */ get text() {
        return this.privText;
    }
}

});

parcelRegister("7cBsb", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisVisemeEventArgs", () => $53e6b4e82b368f7b$export$bed102a9cb8b5da);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ class $53e6b4e82b368f7b$export$bed102a9cb8b5da {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ constructor(audioOffset, visemeId, animation){
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the viseme ID.
     * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
     * @function
     * @public
     * @returns {number} the viseme ID.
     */ get visemeId() {
        return this.privVisemeId;
    }
    /**
     * Specifies the animation.
     * @member SpeechSynthesisVisemeEventArgs.prototype.animation
     * @function
     * @public
     * @returns {string} the animation, could be in svg or other format.
     */ get animation() {
        return this.privAnimation;
    }
}

});

parcelRegister("8UuSQ", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisWordBoundaryEventArgs", () => $67cb82814ef60933$export$5baece3a3f21e6ae);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ class $67cb82814ef60933$export$5baece3a3f21e6ae {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} duration - The audio duration.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
     */ constructor(audioOffset, duration, text, wordLength, textOffset, boundaryType){
        this.privAudioOffset = audioOffset;
        this.privDuration = duration;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
        this.privBoundaryType = boundaryType;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the duration, in ticks (100 nanoseconds).
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
     * @function
     * @public
     * @returns {number} Duration in 100 nanosecond increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Specifies the text of the word boundary event.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the text.
     */ get text() {
        return this.privText;
    }
    /**
     * Specifies the word length
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
     * @function
     * @public
     * @returns {number} the word length
     */ get wordLength() {
        return this.privWordLength;
    }
    /**
     * Specifies the text offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
     * @function
     * @public
     * @returns {number} the text offset.
     */ get textOffset() {
        return this.privTextOffset;
    }
    /**
     * Specifies the boundary type.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
     * @function
     * @public
     * @returns {SpeechSynthesisBoundaryType} the boundary type.
     */ get boundaryType() {
        return this.privBoundaryType;
    }
}

});

parcelRegister("bgoz0", function(module, exports) {

$parcel$export(module.exports, "SynthesisContext", () => $83343e232e8b3d33$export$a7af640f564c9d7a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $fWPg2 = parcelRequire("fWPg2");
class $83343e232e8b3d33$export$a7af640f564c9d7a {
    constructor(){
        this.privContext = {};
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */ set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    toJSON() {
        return JSON.stringify(this.privContext);
    }
    setSynthesisSection(speechSynthesizer) {
        const synthesisSection = this.buildSynthesisContext(speechSynthesizer);
        this.setSection("synthesis", synthesisSection);
    }
    buildSynthesisContext(speechSynthesizer) {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.bookmarkReached),
                    punctuationBoundaryEnabled: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_RequestPunctuationBoundary, !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.wordBoundary)),
                    sentenceBoundaryEnabled: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_RequestSentenceBoundary, false),
                    sessionEndEnabled: true,
                    visemeEnabled: !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.visemeReceived),
                    wordBoundaryEnabled: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceResponse_RequestWordBoundary, !!(speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.wordBoundary))
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: speechSynthesizer === null || speechSynthesizer === void 0 ? void 0 : speechSynthesizer.autoDetectSourceLanguage
            }
        };
    }
}

});


parcelRegister("5ilMI", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisAdapter", () => $3daf883026743774$export$3d8206067c615e0a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $20d7X = parcelRequire("20d7X");
var $jGC6z = parcelRequire("jGC6z");
var $3GDrg = parcelRequire("3GDrg");

var $gd3Vj = parcelRequire("gd3Vj");
class $3daf883026743774$export$3d8206067c615e0a extends (0, $gd3Vj.SynthesisAdapterBase) {
    constructor(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination){
        super(authentication, connectionFactory, synthesizerConfig, audioDestination);
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSynthesizer = speechSynthesizer;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(requestId) {
        const synthesisStartEventArgs = new (0, $jGC6z.SpeechSynthesisEventArgs)(new (0, $3GDrg.SpeechSynthesisResult)(requestId, (0, $20d7X.ResultReason).SynthesizingAudioStarted));
        if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
    }
    onSynthesizing(audio) {
        if (!!this.privSpeechSynthesizer.synthesizing) try {
            const audioWithHeader = this.privSynthesisTurn.audioOutputFormat.addHeader(audio);
            const ev = new (0, $jGC6z.SpeechSynthesisEventArgs)(new (0, $3GDrg.SpeechSynthesisResult)(this.privSynthesisTurn.requestId, (0, $20d7X.ResultReason).SynthesizingAudio, audioWithHeader));
            this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onSynthesisCancelled(result) {
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            const cancelEvent = new (0, $jGC6z.SpeechSynthesisEventArgs)(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
    }
    onSynthesisCompleted(result) {
        if (this.privSpeechSynthesizer.synthesisCompleted) try {
            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new (0, $jGC6z.SpeechSynthesisEventArgs)(result));
        } catch (e) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onWordBoundary(wordBoundaryEventArgs) {
        if (!!this.privSpeechSynthesizer.wordBoundary) try {
            this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onVisemeReceived(visemeEventArgs) {
        if (!!this.privSpeechSynthesizer.visemeReceived) try {
            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onBookmarkReached(bookmarkEventArgs) {
        if (!!this.privSpeechSynthesizer.bookmarkReached) try {
            this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}

});
parcelRegister("jGC6z", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisEventArgs", () => $e54f7f67c8a681af$export$771b44dbfb6bc7af);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ class $e54f7f67c8a681af$export$771b44dbfb6bc7af {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ constructor(result){
        this.privResult = result;
    }
    /**
     * Specifies the synthesis result.
     * @member SpeechSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechSynthesisResult} the synthesis result.
     */ get result() {
        return this.privResult;
    }
}

});


parcelRegister("bOCy4", function(module, exports) {

$parcel$export(module.exports, "SynthesisRestAdapter", () => $89a2442acde752ea$export$fbeb488a9a469b38);

var $cTQ6R = parcelRequire("cTQ6R");
var $lfoMA = parcelRequire("lfoMA");

var $fWPg2 = parcelRequire("fWPg2");

var $kBobk = parcelRequire("kBobk");

var $40Pvg = parcelRequire("40Pvg");
class $89a2442acde752ea$export$fbeb488a9a469b38 {
    constructor(config, authentication){
        let endpoint = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            const region = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Region, "westus");
            const hostSuffix = (0, $kBobk.ConnectionFactoryBase).getHostSuffix(region);
            endpoint = config.parameters.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Host, `https://${region}.tts.speech${hostSuffix}`);
        }
        this.privUri = `${endpoint}/cognitiveservices/voices/list`;
        const options = (0, $cTQ6R.RestConfigBase).requestOptions;
        this.privRestAdapter = new (0, $lfoMA.RestMessageAdapter)(options);
        this.privAuthentication = authentication;
    }
    /**
     * Sends list voices request to endpoint.
     * @function
     * @public
     * @param connectionId - guid for connectionId
     * @returns {Promise<IRestResponse>} rest response to status request
     */ getVoicesList(connectionId) {
        this.privRestAdapter.setHeaders((0, $40Pvg.HeaderNames).ConnectionId, connectionId);
        return this.privAuthentication.fetch(connectionId).then((authInfo)=>{
            this.privRestAdapter.setHeaders(authInfo.headerName, authInfo.token);
            return this.privRestAdapter.request((0, $lfoMA.RestRequestType).Get, this.privUri);
        });
    }
}

});
parcelRegister("cTQ6R", function(module, exports) {

$parcel$export(module.exports, "RestConfigBase", () => $96430af81b82bafd$export$8d374502f37c0343);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $96430af81b82bafd$export$8d374502f37c0343 {
    static get requestOptions() {
        return $96430af81b82bafd$export$8d374502f37c0343.privDefaultRequestOptions;
    }
    static get configParams() {
        return $96430af81b82bafd$export$8d374502f37c0343.privDefaultParams;
    }
    static get restErrors() {
        return $96430af81b82bafd$export$8d374502f37c0343.privRestErrors;
    }
}
$96430af81b82bafd$export$8d374502f37c0343.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: false,
    timeout: 10000
};
$96430af81b82bafd$export$8d374502f37c0343.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$96430af81b82bafd$export$8d374502f37c0343.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};

});

parcelRegister("lfoMA", function(module, exports) {

$parcel$export(module.exports, "RestRequestType", () => $f77e38fb60fb6fd5$export$7e4a254cc224227f);
$parcel$export(module.exports, "RestMessageAdapter", () => $f77e38fb60fb6fd5$export$9721ae21c2a3931a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $bLd4X = parcelRequire("bLd4X");

var $3NF6I = parcelRequire("3NF6I");
var $ciGbY = parcelRequire("ciGbY");
var $f77e38fb60fb6fd5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f77e38fb60fb6fd5$export$7e4a254cc224227f;
(function(RestRequestType) {
    RestRequestType["Get"] = "GET";
    RestRequestType["Post"] = "POST";
    RestRequestType["Delete"] = "DELETE";
    RestRequestType["File"] = "file";
})($f77e38fb60fb6fd5$export$7e4a254cc224227f || ($f77e38fb60fb6fd5$export$7e4a254cc224227f = {}));
class $f77e38fb60fb6fd5$export$9721ae21c2a3931a {
    constructor(configParams){
        if (!configParams) throw new (0, $3NF6I.ArgumentNullError)("configParams");
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    static extractHeaderValue(headerKey, headers) {
        let headerValue = "";
        try {
            const arr = headers.trim().split(/[\r\n]+/);
            const headerMap = {};
            arr.forEach((line)=>{
                const parts = line.split(": ");
                const header = parts.shift().toLowerCase();
                const value = parts.join(": ");
                headerMap[header] = value;
            });
            headerValue = headerMap[headerKey.toLowerCase()];
        } catch (e) {
        // ignore the error
        }
        return headerValue;
    }
    set options(configParams) {
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    setHeaders(key, value) {
        this.privHeaders[key] = value;
    }
    request(method, uri, queryParams = {}, body = null) {
        const responseReceivedDeferral = new (0, $ciGbY.Deferred)();
        const requestCommand = method === $f77e38fb60fb6fd5$export$7e4a254cc224227f.File ? "POST" : method;
        const handleRestResponse = (data, j = {})=>{
            const d = data;
            return {
                data: JSON.stringify(j),
                headers: JSON.stringify(data.headers),
                json: j,
                ok: data.statusCode >= 200 && data.statusCode < 300,
                status: data.statusCode,
                statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        };
        const send = (postData)=>{
            const sendRequest = (0, (/*@__PURE__*/$parcel$interopDefault($bLd4X)))(uri, requestCommand, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
            const params = this.queryParams(queryParams) === "" ? "" : `?${this.queryParams(queryParams)}`;
            sendRequest(params, postData).then((data)=>$f77e38fb60fb6fd5$var$__awaiter(this, void 0, void 0, function*() {
                    if (method === $f77e38fb60fb6fd5$export$7e4a254cc224227f.Delete || data.statusCode === 204) // No JSON from Delete and reset (204) operations
                    responseReceivedDeferral.resolve(handleRestResponse(data));
                    else try {
                        const j = yield data.json();
                        responseReceivedDeferral.resolve(handleRestResponse(data, j));
                    } catch (_a) {
                        responseReceivedDeferral.resolve(handleRestResponse(data));
                    }
                })).catch((error)=>{
                responseReceivedDeferral.reject(error);
            });
        };
        if (this.privIgnoreCache) this.privHeaders["Cache-Control"] = "no-cache";
        if (method === $f77e38fb60fb6fd5$export$7e4a254cc224227f.Post && body) {
            this.privHeaders["content-type"] = "application/json";
            this.privHeaders["Content-Type"] = "application/json";
        }
        send(body);
        return responseReceivedDeferral.promise;
    }
    queryParams(params = {}) {
        return Object.keys(params).map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
    }
}

});
parcelRegister("bLd4X", function(module, exports) {
'use strict';

var $4QMNu = parcelRequire("4QMNu");
class $88fe3aaee92acb81$var$StatusError extends Error {
    constructor(res, ...params){
        super(...params);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $88fe3aaee92acb81$var$StatusError);
        this.name = 'StatusError';
        this.message = res.statusMessage;
        this.statusCode = res.status;
        this.res = res;
        this.json = res.json.bind(res);
        this.text = res.text.bind(res);
        this.arrayBuffer = res.arrayBuffer.bind(res);
        let buffer;
        const get = ()=>{
            if (!buffer) buffer = this.arrayBuffer();
            return buffer;
        };
        Object.defineProperty(this, 'responseBody', {
            get: get
        });
        // match Node.js headers object
        this.headers = {};
        for (const [key, value] of res.headers.entries())this.headers[key.toLowerCase()] = value;
    }
}
const $88fe3aaee92acb81$var$mkrequest = (statusCodes, method, encoding, headers, baseurl)=>async (_url, body, _headers = {})=>{
        _url = baseurl + (_url || '');
        let parsed = new URL(_url);
        if (!headers) headers = {};
        if (parsed.username) {
            headers.Authorization = 'Basic ' + btoa(parsed.username + ':' + parsed.password);
            parsed = new URL(parsed.protocol + '//' + parsed.host + parsed.pathname + parsed.search);
        }
        if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') throw new Error(`Unknown protocol, ${parsed.protocol}`);
        if (body) {
            if (body instanceof ArrayBuffer || ArrayBuffer.isView(body) || typeof body === 'string') ;
            else if (typeof body === 'object') {
                body = JSON.stringify(body);
                headers['Content-Type'] = 'application/json';
            } else throw new Error('Unknown body type.');
        }
        _headers = new Headers({
            ...headers || {},
            ..._headers
        });
        const resp = await fetch(parsed, {
            method: method,
            headers: _headers,
            body: body
        });
        resp.statusCode = resp.status;
        if (!statusCodes.has(resp.status)) throw new $88fe3aaee92acb81$var$StatusError(resp);
        if (encoding === 'json') return resp.json();
        else if (encoding === 'buffer') return resp.arrayBuffer();
        else if (encoding === 'string') return resp.text();
        else return resp;
    };
module.exports = $4QMNu($88fe3aaee92acb81$var$mkrequest);

});
parcelRegister("4QMNu", function(module, exports) {
'use strict';
const $3881dedbff731964$var$encodings = new Set([
    'json',
    'buffer',
    'string'
]);
module.exports = (mkrequest)=>(...args)=>{
        const statusCodes = new Set();
        let method;
        let encoding;
        let headers;
        let baseurl = '';
        args.forEach((arg)=>{
            if (typeof arg === 'string') {
                if (arg.toUpperCase() === arg) {
                    if (method) {
                        const msg = `Can't set method to ${arg}, already set to ${method}.`;
                        throw new Error(msg);
                    } else method = arg;
                } else if (arg.startsWith('http:') || arg.startsWith('https:')) baseurl = arg;
                else {
                    if ($3881dedbff731964$var$encodings.has(arg)) encoding = arg;
                    else throw new Error(`Unknown encoding, ${arg}`);
                }
            } else if (typeof arg === 'number') statusCodes.add(arg);
            else if (typeof arg === 'object') {
                if (Array.isArray(arg) || arg instanceof Set) arg.forEach((code)=>statusCodes.add(code));
                else {
                    if (headers) throw new Error('Cannot set headers twice.');
                    headers = arg;
                }
            } else throw new Error(`Unknown type: ${typeof arg}`);
        });
        if (!method) method = 'GET';
        if (statusCodes.size === 0) statusCodes.add(200);
        return mkrequest(statusCodes, method, encoding, headers, baseurl);
    };

});




parcelRegister("gBlwq", function(module, exports) {

$parcel$export(module.exports, "SynthesizerConfig", () => $c160cbdc83f14ac0$export$dffdf95f0955f209);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6xqgT = parcelRequire("6xqgT");
var $c160cbdc83f14ac0$export$4671c5aa7c4b1a53;
(function(SynthesisServiceType) {
    SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
    SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})($c160cbdc83f14ac0$export$4671c5aa7c4b1a53 || ($c160cbdc83f14ac0$export$4671c5aa7c4b1a53 = {}));
class $c160cbdc83f14ac0$export$dffdf95f0955f209 {
    constructor(speechServiceConfig, parameters){
        this.privSynthesisServiceType = $c160cbdc83f14ac0$export$4671c5aa7c4b1a53.Standard;
        this.avatarEnabled = false;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new (0, $6xqgT.SpeechServiceConfig)(new (0, $6xqgT.Context)(null));
        this.privParameters = parameters;
    }
    get parameters() {
        return this.privParameters;
    }
    get synthesisServiceType() {
        return this.privSynthesisServiceType;
    }
    set synthesisServiceType(value) {
        this.privSynthesisServiceType = value;
    }
    set synthesisVideoSection(value) {
        this.privSpeechServiceConfig.Context.synthesis = {
            video: value
        };
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
}

});


parcelRegister("biETf", function(module, exports) {

$parcel$export(module.exports, "ProfanityOption", () => $83a11814171cbe8e$export$84f426873273f221);
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $83a11814171cbe8e$export$84f426873273f221;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($83a11814171cbe8e$export$84f426873273f221 || ($83a11814171cbe8e$export$84f426873273f221 = {}));

});


parcelRegister("2eIQR", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognizer", () => $1a0fae283b39512b$export$21540fca23cf2ecd);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $hgjD5 = parcelRequire("hgjD5");
var $3ppF1 = parcelRequire("3ppF1");
var $gXTdh = parcelRequire("gXTdh");
var $7w59Q = parcelRequire("7w59Q");

var $ciGbY = parcelRequire("ciGbY");

var $3SMEZ = parcelRequire("3SMEZ");

var $jcTbW = parcelRequire("jcTbW");
var $fWPg2 = parcelRequire("fWPg2");
var $fTUeo = parcelRequire("fTUeo");
var $1a0fae283b39512b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $1a0fae283b39512b$export$21540fca23cf2ecd extends (0, $fTUeo.Recognizer) {
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        (0, $3SMEZ.Contracts).throwIfNull(speechConfigImpl, "speechConfig");
        (0, $3SMEZ.Contracts).throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_RecoLanguage), (0, $fWPg2.PropertyId)[(0, $fWPg2.PropertyId).SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new (0, $gXTdh.SpeechConnectionFactory)());
        this.privDisposedRecognizer = false;
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $1a0fae283b39512b$export$21540fca23cf2ecd(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for speech recognition.
     * @member SpeechRecognizer.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        (0, $3SMEZ.Contracts).throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of recognition.
     * @member SpeechRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of recognition.
     * @member SpeechRecognizer.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of recognition.
     */ get outputFormat() {
        (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty((0, $hgjD5.OutputFormatPropertyName), (0, $jcTbW.OutputFormat)[(0, $jcTbW.OutputFormat).Simple]) === (0, $jcTbW.OutputFormat)[(0, $jcTbW.OutputFormat).Simple]) return (0, $jcTbW.OutputFormat).Simple;
        else return (0, $jcTbW.OutputFormat).Detailed;
    }
    /**
     * The collection of properties and their values defined for this SpeechRecognizer.
     * @member SpeechRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition
     * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        (0, $ciGbY.marshalPromiseToCallbacks)(this.recognizeOnceAsyncImpl((0, $3ppF1.RecognitionMode).Interactive), cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        (0, $ciGbY.marshalPromiseToCallbacks)(this.startContinuousRecognitionAsyncImpl((0, $3ppF1.RecognitionMode).Conversation), cb, err);
    }
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        (0, $ciGbY.marshalPromiseToCallbacks)(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     * specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startKeywordRecognitionAsync(model, cb, err) {
        (0, $3SMEZ.Contracts).throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopKeywordRecognitionAsync(cb) {
        if (!!cb) cb();
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposedRecognizer);
        (0, $ciGbY.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ dispose(disposing) {
        const _super = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $1a0fae283b39512b$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privDisposedRecognizer) return;
            if (disposing) {
                this.privDisposedRecognizer = true;
                yield this.implRecognizerStop();
            }
            yield _super.dispose.call(this, disposing);
        });
    }
    createRecognizerConfig(speechConfig) {
        return new (0, $3ppF1.RecognizerConfig)(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new (0, $7w59Q.SpeechServiceRecognizer)(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}

});
parcelRegister("fTUeo", function(module, exports) {

$parcel$export(module.exports, "Recognizer", () => $b9379c624d89d1aa$export$d051b53981c4a264);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6HIA2 = parcelRequire("6HIA2");
var $4t6tB = parcelRequire("4t6tB");
var $6xqgT = parcelRequire("6xqgT");
var $lDTeU = parcelRequire("lDTeU");

var $ciGbY = parcelRequire("ciGbY");

var $3SMEZ = parcelRequire("3SMEZ");

var $85V5Z = parcelRequire("85V5Z");
var $fWPg2 = parcelRequire("fWPg2");
var $b9379c624d89d1aa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $b9379c624d89d1aa$export$d051b53981c4a264 {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     * @param {PropertyCollection} properties - A set of properties to set on the recognizer
     * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
     */ constructor(audioConfig, properties, connectionFactory){
        this.audioConfig = audioConfig !== undefined ? audioConfig : (0, $85V5Z.AudioConfig).fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposed);
        (0, $ciGbY.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privReco;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ dispose(disposing) {
        return $b9379c624d89d1aa$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privDisposed) return;
            this.privDisposed = true;
            if (disposing) {
                if (this.privReco) {
                    yield this.privReco.audioSource.turnOff();
                    yield this.privReco.dispose();
                }
            }
        });
    }
    /**
     * This method returns the current state of the telemetry setting.
     * @member Recognizer.prototype.telemetryEnabled
     * @function
     * @public
     * @returns true if the telemetry is enabled, false otherwise.
     */ static get telemetryEnabled() {
        return (0, $lDTeU.ServiceRecognizerBase).telemetryDataEnabled;
    }
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ static enableTelemetry(enabled) {
        (0, $lDTeU.ServiceRecognizerBase).telemetryDataEnabled = enabled;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const recognizerConfig = this.createRecognizerConfig(new (0, $6xqgT.SpeechServiceConfig)(new (0, $6xqgT.Context)(new (0, $6xqgT.OS)(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer($b9379c624d89d1aa$export$d051b53981c4a264.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    }
    recognizeOnceAsyncImpl(recognitionMode) {
        return $b9379c624d89d1aa$var$__awaiter(this, void 0, void 0, function*() {
            (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposed);
            const ret = new (0, $ciGbY.Deferred)();
            yield this.implRecognizerStop();
            yield this.privReco.recognize(recognitionMode, ret.resolve, ret.reject);
            const result = yield ret.promise;
            yield this.implRecognizerStop();
            return result;
        });
    }
    startContinuousRecognitionAsyncImpl(recognitionMode) {
        return $b9379c624d89d1aa$var$__awaiter(this, void 0, void 0, function*() {
            (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposed);
            yield this.implRecognizerStop();
            yield this.privReco.recognize(recognitionMode, undefined, undefined);
        });
    }
    stopContinuousRecognitionAsyncImpl() {
        return $b9379c624d89d1aa$var$__awaiter(this, void 0, void 0, function*() {
            (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposed);
            yield this.implRecognizerStop();
        });
    }
    implRecognizerStop() {
        return $b9379c624d89d1aa$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privReco) yield this.privReco.stopRecognizing();
            return;
        });
    }
    static getAuthFromProperties(properties) {
        const subscriptionKey = properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new (0, $6HIA2.CognitiveSubscriptionKeyAuthentication)(subscriptionKey) : new (0, $4t6tB.CognitiveTokenAuthentication)(()=>{
            const authorizationToken = properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        return authentication;
    }
}

});


parcelRegister("khunP", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesizer", () => $ec3cf6ad6a7e6d74$export$56ebaa590b87d41);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $5ilMI = parcelRequire("5ilMI");
var $2Fj9D = parcelRequire("2Fj9D");
var $bOCy4 = parcelRequire("bOCy4");

var $8lWt4 = parcelRequire("8lWt4");
var $ciGbY = parcelRequire("ciGbY");

var $5d2Dz = parcelRequire("5d2Dz");

var $913NY = parcelRequire("913NY");

var $kzV1n = parcelRequire("kzV1n");

var $3SMEZ = parcelRequire("3SMEZ");

var $85V5Z = parcelRequire("85V5Z");
var $fWPg2 = parcelRequire("fWPg2");
var $kzV1n = parcelRequire("kzV1n");
var $92Nur = parcelRequire("92Nur");
var $38QGp = parcelRequire("38QGp");
var $8EK5K = parcelRequire("8EK5K");
var $ctHGQ = parcelRequire("ctHGQ");

var $ctHGQ = parcelRequire("ctHGQ");
var $ec3cf6ad6a7e6d74$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $ec3cf6ad6a7e6d74$export$56ebaa590b87d41 extends (0, $ctHGQ.Synthesizer) {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */ constructor(speechConfig, audioConfig){
        super(speechConfig);
        if (audioConfig !== null) {
            if (audioConfig === undefined) this.audioConfig = typeof window === "undefined" ? undefined : (0, $85V5Z.AudioConfig).fromDefaultSpeakerOutput();
            else this.audioConfig = audioConfig;
        }
        this.privConnectionFactory = new (0, $2Fj9D.SpeechSynthesisConnectionFactory)();
        this.implCommonSynthesizeSetup();
    }
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        return new $ec3cf6ad6a7e6d74$export$56ebaa590b87d41(speechConfig, audioConfig);
    }
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakTextAsync(text, cb, err, stream) {
        this.speakImpl(text, false, cb, err, stream);
    }
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakSsmlAsync(ssml, cb, err, stream) {
        this.speakImpl(ssml, true, cb, err, stream);
    }
    /**
     * Get list of synthesis voices available.
     * The task returns the synthesis voice result.
     * @member SpeechSynthesizer.prototype.getVoicesAsync
     * @function
     * @async
     * @public
     * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
     * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
     */ getVoicesAsync(locale = "") {
        return $ec3cf6ad6a7e6d74$var$__awaiter(this, void 0, void 0, function*() {
            return this.getVoices(locale);
        });
    }
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposed);
        (0, $ciGbY.marshalPromiseToCallbacks)(this.dispose(true), cb, err);
    }
    /**
     * @Internal
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new (0, $5ilMI.SpeechSynthesisAdapter)(authentication, connectionFactory, synthesizerConfig, this, this.audioConfig);
    }
    createRestSynthesisAdapter(authentication, synthesizerConfig) {
        return new (0, $bOCy4.SynthesisRestAdapter)(synthesizerConfig, authentication);
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        this.privAdapter.audioOutputFormat = (0, $913NY.AudioOutputFormatImpl).fromSpeechSynthesisOutputFormat((0, $38QGp.SpeechSynthesisOutputFormat)[this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)]);
    }
    speakImpl(text, IsSsml, cb, err, dataStream) {
        try {
            (0, $3SMEZ.Contracts).throwIfDisposed(this.privDisposed);
            const requestId = (0, $8lWt4.createNoDashGuid)();
            let audioDestination;
            if (dataStream instanceof (0, $92Nur.PushAudioOutputStreamCallback)) audioDestination = new (0, $kzV1n.PushAudioOutputStreamImpl)(dataStream);
            else if (dataStream instanceof (0, $kzV1n.PullAudioOutputStream)) audioDestination = dataStream;
            else if (dataStream !== undefined) audioDestination = new (0, $5d2Dz.AudioFileWriter)(dataStream);
            else audioDestination = undefined;
            this.synthesisRequestQueue.enqueue(new (0, $ctHGQ.SynthesisRequest)(requestId, text, IsSsml, (e)=>{
                this.privSynthesizing = false;
                if (!!cb) try {
                    cb(e);
                } catch (e) {
                    if (!!err) err(e);
                }
                cb = undefined;
                /* eslint-disable no-empty */ this.adapterSpeak().catch(()=>{});
            }, (e)=>{
                if (!!err) err(e);
            }, audioDestination));
            /* eslint-disable no-empty-function */ this.adapterSpeak().catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the synthesizer.
            /* eslint-disable no-empty */ this.dispose(true).catch(()=>{});
        }
    }
    getVoices(locale) {
        return $ec3cf6ad6a7e6d74$var$__awaiter(this, void 0, void 0, function*() {
            const requestId = (0, $8lWt4.createNoDashGuid)();
            const response = yield this.privRestAdapter.getVoicesList(requestId);
            if (response.ok && Array.isArray(response.json)) {
                let json = response.json;
                if (!!locale && locale.length > 0) json = json.filter((item)=>!!item.Locale && item.Locale.toLowerCase() === locale.toLowerCase());
                return new (0, $8EK5K.SynthesisVoicesResult)(requestId, json, undefined);
            } else return new (0, $8EK5K.SynthesisVoicesResult)(requestId, undefined, `Error: ${response.status}: ${response.statusText}`);
        });
    }
}

});
parcelRegister("8EK5K", function(module, exports) {

$parcel$export(module.exports, "SynthesisVoicesResult", () => $64d5d00689caf6bd$export$a785d558b3c9ce16);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $isROj = parcelRequire("isROj");
var $20d7X = parcelRequire("20d7X");
var $jNWUv = parcelRequire("jNWUv");
var $dDI25 = parcelRequire("dDI25");
class $64d5d00689caf6bd$export$a785d558b3c9ce16 extends (0, $jNWUv.SynthesisResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param requestId - result id for request.
     * @param json - json payload from endpoint.
     */ constructor(requestId, json, errorDetails){
        if (Array.isArray(json)) {
            super(requestId, (0, $20d7X.ResultReason).VoicesListRetrieved, undefined, new (0, $isROj.PropertyCollection)());
            this.privVoices = [];
            for (const item of json)this.privVoices.push(new (0, $dDI25.VoiceInfo)(item));
        } else super(requestId, (0, $20d7X.ResultReason).Canceled, errorDetails ? errorDetails : "Error information unavailable", new (0, $isROj.PropertyCollection)());
    }
    /**
     * The list of voices
     * @member SynthesisVoicesResult.prototype.voices
     * @function
     * @public
     * @returns {VoiceInfo[]} List of synthesized voices.
     */ get voices() {
        return this.privVoices;
    }
}

});
parcelRegister("dDI25", function(module, exports) {

$parcel$export(module.exports, "VoiceInfo", () => $9ee112d62df7e855$export$a109380dc4b9e543);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the gender of synthesis voices.
 * Added in version 1.20.0.
 */ var $9ee112d62df7e855$export$5113617c0ece90c2;
(function(SynthesisVoiceGender) {
    /** Gender unknown */ SynthesisVoiceGender[SynthesisVoiceGender["Unknown"] = 0] = "Unknown";
    /** Female voice */ SynthesisVoiceGender[SynthesisVoiceGender["Female"] = 1] = "Female";
    /** Male voice */ SynthesisVoiceGender[SynthesisVoiceGender["Male"] = 2] = "Male";
})($9ee112d62df7e855$export$5113617c0ece90c2 || ($9ee112d62df7e855$export$5113617c0ece90c2 = {}));
var $9ee112d62df7e855$export$398274292b2dfb80;
(function(SynthesisVoiceType) {
    SynthesisVoiceType[SynthesisVoiceType["OnlineNeural"] = 1] = "OnlineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OnlineStandard"] = 2] = "OnlineStandard";
    SynthesisVoiceType[SynthesisVoiceType["OfflineNeural"] = 3] = "OfflineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OfflineStandard"] = 4] = "OfflineStandard";
})($9ee112d62df7e855$export$398274292b2dfb80 || ($9ee112d62df7e855$export$398274292b2dfb80 = {}));
class $9ee112d62df7e855$export$a109380dc4b9e543 {
    constructor(json){
        this.privStyleList = [];
        this.privVoicePath = "";
        if (!!json) {
            this.privName = json.Name;
            this.privLocale = json.Locale;
            this.privShortName = json.ShortName;
            this.privLocaleName = json.LocaleName;
            this.privDisplayName = json.DisplayName;
            this.privLocalName = json.LocalName;
            this.privVoiceType = json.VoiceType.endsWith("Standard") ? $9ee112d62df7e855$export$398274292b2dfb80.OnlineStandard : $9ee112d62df7e855$export$398274292b2dfb80.OnlineNeural;
            this.privGender = json.Gender === "Male" ? $9ee112d62df7e855$export$5113617c0ece90c2.Male : json.Gender === "Female" ? $9ee112d62df7e855$export$5113617c0ece90c2.Female : $9ee112d62df7e855$export$5113617c0ece90c2.Unknown;
            if (!!json.StyleList && Array.isArray(json.StyleList)) for (const style of json.StyleList)this.privStyleList.push(style);
        }
    }
    get name() {
        return this.privName;
    }
    get locale() {
        return this.privLocale;
    }
    get shortName() {
        return this.privShortName;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get localName() {
        return this.privLocalName;
    }
    get localeName() {
        return this.privLocaleName;
    }
    get gender() {
        return this.privGender;
    }
    get voiceType() {
        return this.privVoiceType;
    }
    get styleList() {
        return this.privStyleList;
    }
    get voicePath() {
        return this.privVoicePath;
    }
}

});


parcelRegister("ctHGQ", function(module, exports) {

$parcel$export(module.exports, "Synthesizer", () => $915a1568f832bc18$export$30c5e19407545686);
$parcel$export(module.exports, "SynthesisRequest", () => $915a1568f832bc18$export$3795ef90d019847a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $hgjD5 = parcelRequire("hgjD5");
var $6HIA2 = parcelRequire("6HIA2");
var $4t6tB = parcelRequire("4t6tB");
var $6xqgT = parcelRequire("6xqgT");
var $gBlwq = parcelRequire("gBlwq");

var $63lFD = parcelRequire("63lFD");

var $3SMEZ = parcelRequire("3SMEZ");

var $fWPg2 = parcelRequire("fWPg2");
var $915a1568f832bc18$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $915a1568f832bc18$export$30c5e19407545686 {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
     */ constructor(speechConfig){
        const speechConfigImpl = speechConfig;
        (0, $3SMEZ.Contracts).throwIfNull(speechConfigImpl, "speechConfig");
        this.privProperties = speechConfigImpl.properties.clone();
        this.privDisposed = false;
        this.privSynthesizing = false;
        this.synthesisRequestQueue = new (0, $63lFD.Queue)();
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        (0, $3SMEZ.Contracts).throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this Synthesizer.
     * @member Synthesizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Indicates if auto detect source language is enabled
     * @member Synthesizer.prototype.autoDetectSourceLanguage
     * @function
     * @public
     * @returns {boolean} if auto detect source language is enabled
     */ get autoDetectSourceLanguage() {
        return this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages) === (0, $hgjD5.AutoDetectSourceLanguagesOpenRangeOptionName);
    }
    buildSsml(text) {
        const languageToDefaultVoice = {
            ["af-ZA"]: "af-ZA-AdriNeural",
            ["am-ET"]: "am-ET-AmehaNeural",
            ["ar-AE"]: "ar-AE-FatimaNeural",
            ["ar-BH"]: "ar-BH-AliNeural",
            ["ar-DZ"]: "ar-DZ-AminaNeural",
            ["ar-EG"]: "ar-EG-SalmaNeural",
            ["ar-IQ"]: "ar-IQ-BasselNeural",
            ["ar-JO"]: "ar-JO-SanaNeural",
            ["ar-KW"]: "ar-KW-FahedNeural",
            ["ar-LY"]: "ar-LY-ImanNeural",
            ["ar-MA"]: "ar-MA-JamalNeural",
            ["ar-QA"]: "ar-QA-AmalNeural",
            ["ar-SA"]: "ar-SA-HamedNeural",
            ["ar-SY"]: "ar-SY-AmanyNeural",
            ["ar-TN"]: "ar-TN-HediNeural",
            ["ar-YE"]: "ar-YE-MaryamNeural",
            ["bg-BG"]: "bg-BG-BorislavNeural",
            ["bn-BD"]: "bn-BD-NabanitaNeural",
            ["bn-IN"]: "bn-IN-BashkarNeural",
            ["ca-ES"]: "ca-ES-JoanaNeural",
            ["cs-CZ"]: "cs-CZ-AntoninNeural",
            ["cy-GB"]: "cy-GB-AledNeural",
            ["da-DK"]: "da-DK-ChristelNeural",
            ["de-AT"]: "de-AT-IngridNeural",
            ["de-CH"]: "de-CH-JanNeural",
            ["de-DE"]: "de-DE-KatjaNeural",
            ["el-GR"]: "el-GR-AthinaNeural",
            ["en-AU"]: "en-AU-NatashaNeural",
            ["en-CA"]: "en-CA-ClaraNeural",
            ["en-GB"]: "en-GB-LibbyNeural",
            ["en-HK"]: "en-HK-SamNeural",
            ["en-IE"]: "en-IE-ConnorNeural",
            ["en-IN"]: "en-IN-NeerjaNeural",
            ["en-KE"]: "en-KE-AsiliaNeural",
            ["en-NG"]: "en-NG-AbeoNeural",
            ["en-NZ"]: "en-NZ-MitchellNeural",
            ["en-PH"]: "en-PH-JamesNeural",
            ["en-SG"]: "en-SG-LunaNeural",
            ["en-TZ"]: "en-TZ-ElimuNeural",
            ["en-US"]: "en-US-JennyNeural",
            ["en-ZA"]: "en-ZA-LeahNeural",
            ["es-AR"]: "es-AR-ElenaNeural",
            ["es-BO"]: "es-BO-MarceloNeural",
            ["es-CL"]: "es-CL-CatalinaNeural",
            ["es-CO"]: "es-CO-GonzaloNeural",
            ["es-CR"]: "es-CR-JuanNeural",
            ["es-CU"]: "es-CU-BelkysNeural",
            ["es-DO"]: "es-DO-EmilioNeural",
            ["es-EC"]: "es-EC-AndreaNeural",
            ["es-ES"]: "es-ES-AlvaroNeural",
            ["es-GQ"]: "es-GQ-JavierNeural",
            ["es-GT"]: "es-GT-AndresNeural",
            ["es-HN"]: "es-HN-CarlosNeural",
            ["es-MX"]: "es-MX-DaliaNeural",
            ["es-NI"]: "es-NI-FedericoNeural",
            ["es-PA"]: "es-PA-MargaritaNeural",
            ["es-PE"]: "es-PE-AlexNeural",
            ["es-PR"]: "es-PR-KarinaNeural",
            ["es-PY"]: "es-PY-MarioNeural",
            ["es-SV"]: "es-SV-LorenaNeural",
            ["es-US"]: "es-US-AlonsoNeural",
            ["es-UY"]: "es-UY-MateoNeural",
            ["es-VE"]: "es-VE-PaolaNeural",
            ["et-EE"]: "et-EE-AnuNeural",
            ["fa-IR"]: "fa-IR-DilaraNeural",
            ["fi-FI"]: "fi-FI-SelmaNeural",
            ["fil-PH"]: "fil-PH-AngeloNeural",
            ["fr-BE"]: "fr-BE-CharlineNeural",
            ["fr-CA"]: "fr-CA-SylvieNeural",
            ["fr-CH"]: "fr-CH-ArianeNeural",
            ["fr-FR"]: "fr-FR-DeniseNeural",
            ["ga-IE"]: "ga-IE-ColmNeural",
            ["gl-ES"]: "gl-ES-RoiNeural",
            ["gu-IN"]: "gu-IN-DhwaniNeural",
            ["he-IL"]: "he-IL-AvriNeural",
            ["hi-IN"]: "hi-IN-MadhurNeural",
            ["hr-HR"]: "hr-HR-GabrijelaNeural",
            ["hu-HU"]: "hu-HU-NoemiNeural",
            ["id-ID"]: "id-ID-ArdiNeural",
            ["is-IS"]: "is-IS-GudrunNeural",
            ["it-IT"]: "it-IT-IsabellaNeural",
            ["ja-JP"]: "ja-JP-NanamiNeural",
            ["jv-ID"]: "jv-ID-DimasNeural",
            ["kk-KZ"]: "kk-KZ-AigulNeural",
            ["km-KH"]: "km-KH-PisethNeural",
            ["kn-IN"]: "kn-IN-GaganNeural",
            ["ko-KR"]: "ko-KR-SunHiNeural",
            ["lo-LA"]: "lo-LA-ChanthavongNeural",
            ["lt-LT"]: "lt-LT-LeonasNeural",
            ["lv-LV"]: "lv-LV-EveritaNeural",
            ["mk-MK"]: "mk-MK-AleksandarNeural",
            ["ml-IN"]: "ml-IN-MidhunNeural",
            ["mr-IN"]: "mr-IN-AarohiNeural",
            ["ms-MY"]: "ms-MY-OsmanNeural",
            ["mt-MT"]: "mt-MT-GraceNeural",
            ["my-MM"]: "my-MM-NilarNeural",
            ["nb-NO"]: "nb-NO-PernilleNeural",
            ["nl-BE"]: "nl-BE-ArnaudNeural",
            ["nl-NL"]: "nl-NL-ColetteNeural",
            ["pl-PL"]: "pl-PL-AgnieszkaNeural",
            ["ps-AF"]: "ps-AF-GulNawazNeural",
            ["pt-BR"]: "pt-BR-FranciscaNeural",
            ["pt-PT"]: "pt-PT-DuarteNeural",
            ["ro-RO"]: "ro-RO-AlinaNeural",
            ["ru-RU"]: "ru-RU-SvetlanaNeural",
            ["si-LK"]: "si-LK-SameeraNeural",
            ["sk-SK"]: "sk-SK-LukasNeural",
            ["sl-SI"]: "sl-SI-PetraNeural",
            ["so-SO"]: "so-SO-MuuseNeural",
            ["sr-RS"]: "sr-RS-NicholasNeural",
            ["su-ID"]: "su-ID-JajangNeural",
            ["sv-SE"]: "sv-SE-SofieNeural",
            ["sw-KE"]: "sw-KE-RafikiNeural",
            ["sw-TZ"]: "sw-TZ-DaudiNeural",
            ["ta-IN"]: "ta-IN-PallaviNeural",
            ["ta-LK"]: "ta-LK-KumarNeural",
            ["ta-SG"]: "ta-SG-AnbuNeural",
            ["te-IN"]: "te-IN-MohanNeural",
            ["th-TH"]: "th-TH-PremwadeeNeural",
            ["tr-TR"]: "tr-TR-AhmetNeural",
            ["uk-UA"]: "uk-UA-OstapNeural",
            ["ur-IN"]: "ur-IN-GulNeural",
            ["ur-PK"]: "ur-PK-AsadNeural",
            ["uz-UZ"]: "uz-UZ-MadinaNeural",
            ["vi-VN"]: "vi-VN-HoaiMyNeural",
            ["zh-CN"]: "zh-CN-XiaoxiaoNeural",
            ["zh-HK"]: "zh-HK-HiuMaanNeural",
            ["zh-TW"]: "zh-TW-HsiaoChenNeural",
            ["zu-ZA"]: "zu-ZA-ThandoNeural"
        };
        let language = this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthLanguage, "en-US");
        let voice = this.properties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_SynthVoice, "");
        let ssml = $915a1568f832bc18$export$30c5e19407545686.XMLEncode(text);
        if (this.autoDetectSourceLanguage) language = "en-US";
        else voice = voice || languageToDefaultVoice[language];
        if (voice) ssml = `<voice name='${voice}'>${ssml}</voice>`;
        ssml = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${language}'>${ssml}</speak>`;
        return ssml;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Synthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ dispose(disposing) {
        return $915a1568f832bc18$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privDisposed) return;
            if (disposing) {
                if (this.privAdapter) yield this.privAdapter.dispose();
            }
            this.privDisposed = true;
        });
    }
    adapterSpeak() {
        return $915a1568f832bc18$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privDisposed && !this.privSynthesizing) {
                this.privSynthesizing = true;
                const request = yield this.synthesisRequestQueue.dequeue();
                return this.privAdapter.Speak(request.text, request.isSSML, request.requestId, request.cb, request.err, request.dataStream);
            }
        });
    }
    createSynthesizerConfig(speechConfig) {
        return new (0, $gBlwq.SynthesizerConfig)(speechConfig, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const synthesizerConfig = this.createSynthesizerConfig(new (0, $6xqgT.SpeechServiceConfig)(new (0, $6xqgT.Context)(new (0, $6xqgT.OS)(osPlatform, osName, osVersion))));
        const subscriptionKey = this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new (0, $6HIA2.CognitiveSubscriptionKeyAuthentication)(subscriptionKey) : new (0, $4t6tB.CognitiveTokenAuthentication)(()=>{
            const authorizationToken = this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = this.privProperties.getProperty((0, $fWPg2.PropertyId).SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        this.privAdapter = this.createSynthesisAdapter(authentication, this.privConnectionFactory, synthesizerConfig);
        this.privRestAdapter = this.createRestSynthesisAdapter(authentication, synthesizerConfig);
    }
    static XMLEncode(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
}
class $915a1568f832bc18$export$3795ef90d019847a {
    constructor(requestId, text, isSSML, cb, err, dataStream){
        this.requestId = requestId;
        this.text = text;
        this.isSSML = isSSML;
        this.cb = cb;
        this.err = err;
        this.dataStream = dataStream;
    }
}

});


parcelRegister("kKnec", function(module, exports) {
"use strict";

var $i3HcB = parcelRequire("i3HcB");
var $f1aa1f21e09b6f79$var$_interopRequireDefault = $i3HcB.default;

var $f1aa1f21e09b6f79$var$_promise = $f1aa1f21e09b6f79$var$_interopRequireDefault((parcelRequire("k3Scp")));
// ../p-defer/index.js
function $f1aa1f21e09b6f79$var$pDefer() {
    var deferred = {};
    deferred.promise = new $f1aa1f21e09b6f79$var$_promise["default"](function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}
// src/index.js
module.exports = $f1aa1f21e09b6f79$var$pDefer;

});
parcelRegister("i3HcB", function(module, exports) {
function $d25a04e0ff6b5159$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $d25a04e0ff6b5159$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k3Scp", function(module, exports) {

module.exports = (parcelRequire("IJZrE"));

});
parcelRegister("IJZrE", function(module, exports) {
'use strict';

var $gRDsX = parcelRequire("gRDsX");
parcelRequire("jlLxD");
module.exports = $gRDsX;

});
parcelRegister("gRDsX", function(module, exports) {
'use strict';
parcelRequire("1pUxE");
parcelRequire("1sRs4");
parcelRequire("1o61r");
parcelRequire("bW6p0");
parcelRequire("3Fwpb");
parcelRequire("9hluD");
parcelRequire("djTyE");
parcelRequire("3Comk");
parcelRequire("hyQQI");
parcelRequire("hNffK");

var $fDEaU = parcelRequire("fDEaU");
module.exports = $fDEaU.Promise;

});
parcelRegister("1pUxE", function(module, exports) {
'use strict';
parcelRequire("2OyLJ");

});
parcelRegister("2OyLJ", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $3MFCD = parcelRequire("3MFCD");

var $fugbv = parcelRequire("fugbv");

var $1DwRe = parcelRequire("1DwRe");

var $6JHYn = parcelRequire("6JHYn");

var $18Ax7 = parcelRequire("18Ax7");

var $5QIuJ = parcelRequire("5QIuJ");

var $jw35K = parcelRequire("jw35K");

var $9IqsX = parcelRequire("9IqsX");

var $fRZA9 = parcelRequire("fRZA9");

var $7ICfs = parcelRequire("7ICfs");

var $bn7kC = parcelRequire("bn7kC");

var $1TMNu = parcelRequire("1TMNu");
var $20cb38adc7773e46$var$TO_STRING_TAG = $1TMNu('toStringTag');
var $20cb38adc7773e46$var$$Error = Error;
var $20cb38adc7773e46$var$push = [].push;
var $20cb38adc7773e46$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $3MFCD($20cb38adc7773e46$var$AggregateErrorPrototype, this);
    var that;
    if ($1DwRe) that = $1DwRe(new $20cb38adc7773e46$var$$Error(), isInstance ? $fugbv(this) : $20cb38adc7773e46$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $18Ax7($20cb38adc7773e46$var$AggregateErrorPrototype);
        $5QIuJ(that, $20cb38adc7773e46$var$TO_STRING_TAG, 'Error');
    }
    if (message !== undefined) $5QIuJ(that, 'message', $bn7kC(message));
    $fRZA9(that, $20cb38adc7773e46$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $9IqsX(that, arguments[2]);
    var errorsArray = [];
    $7ICfs(errors, $20cb38adc7773e46$var$push, {
        that: errorsArray
    });
    $5QIuJ(that, 'errors', errorsArray);
    return that;
};
if ($1DwRe) $1DwRe($20cb38adc7773e46$var$$AggregateError, $20cb38adc7773e46$var$$Error);
else $6JHYn($20cb38adc7773e46$var$$AggregateError, $20cb38adc7773e46$var$$Error, {
    name: true
});
var $20cb38adc7773e46$var$AggregateErrorPrototype = $20cb38adc7773e46$var$$AggregateError.prototype = $18Ax7($20cb38adc7773e46$var$$Error.prototype, {
    constructor: $jw35K(1, $20cb38adc7773e46$var$$AggregateError),
    message: $jw35K(1, ''),
    name: $jw35K(1, 'AggregateError')
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$k8IkA({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $20cb38adc7773e46$var$$AggregateError
});

});
parcelRegister("k8IkA", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $dgWbh = parcelRequire("dgWbh");

var $8yMwi = parcelRequire("8yMwi");

var $bCB23 = parcelRequire("bCB23");

var $Cu1XA = parcelRequire("Cu1XA");
var $ea96f13e007491fa$require$getOwnPropertyDescriptor = $Cu1XA.f;

var $7xCLo = parcelRequire("7xCLo");

var $fDEaU = parcelRequire("fDEaU");

var $iyHek = parcelRequire("iyHek");

var $5QIuJ = parcelRequire("5QIuJ");

var $8Gs5d = parcelRequire("8Gs5d");

var $ea96f13e007491fa$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $dgWbh(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $a974b : STATIC ? $a974b[TARGET] : $a974b[TARGET] && $a974b[TARGET].prototype;
    var target = GLOBAL ? $fDEaU : $fDEaU[TARGET] || $5QIuJ($fDEaU, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $7xCLo(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $8Gs5d(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $ea96f13e007491fa$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $iyHek(sourceProperty, $a974b);
        else if (options.wrap && USE_NATIVE) resultProperty = $ea96f13e007491fa$var$wrapConstructor(sourceProperty);
        else if (PROTO && $bCB23(sourceProperty)) resultProperty = $8yMwi(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $5QIuJ(resultProperty, 'sham', true);
        $5QIuJ(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!$8Gs5d($fDEaU, VIRTUAL_PROTOTYPE)) $5QIuJ($fDEaU, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $5QIuJ($fDEaU[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $5QIuJ(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRegister("a974b", function(module, exports) {
'use strict';
var $763039e6b2c42a44$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$763039e6b2c42a44$var$check(typeof globalThis == 'object' && globalThis) || $763039e6b2c42a44$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$763039e6b2c42a44$var$check(typeof self == 'object' && self) || $763039e6b2c42a44$var$check(typeof $parcel$global == 'object' && $parcel$global) || $763039e6b2c42a44$var$check(typeof module.exports == 'object' && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});

parcelRegister("dgWbh", function(module, exports) {
'use strict';

var $lfb3z = parcelRequire("lfb3z");
var $9a99e68842319011$var$FunctionPrototype = Function.prototype;
var $9a99e68842319011$var$apply = $9a99e68842319011$var$FunctionPrototype.apply;
var $9a99e68842319011$var$call = $9a99e68842319011$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || ($lfb3z ? $9a99e68842319011$var$call.bind($9a99e68842319011$var$apply) : function() {
    return $9a99e68842319011$var$call.apply($9a99e68842319011$var$apply, arguments);
});

});
parcelRegister("lfb3z", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");
module.exports = !$5TNal(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});
parcelRegister("5TNal", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRegister("8yMwi", function(module, exports) {
'use strict';

var $abkeB = parcelRequire("abkeB");

var $blzM2 = parcelRequire("blzM2");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($abkeB(fn) === 'Function') return $blzM2(fn);
};

});
parcelRegister("abkeB", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
var $769aa09d4596201c$var$toString = $blzM2({}.toString);
var $769aa09d4596201c$var$stringSlice = $blzM2(''.slice);
module.exports = function(it) {
    return $769aa09d4596201c$var$stringSlice($769aa09d4596201c$var$toString(it), 8, -1);
};

});
parcelRegister("blzM2", function(module, exports) {
'use strict';

var $lfb3z = parcelRequire("lfb3z");
var $842d67d3864b0d9b$var$FunctionPrototype = Function.prototype;
var $842d67d3864b0d9b$var$call = $842d67d3864b0d9b$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $842d67d3864b0d9b$var$uncurryThisWithBind = $lfb3z && $842d67d3864b0d9b$var$FunctionPrototype.bind.bind($842d67d3864b0d9b$var$call, $842d67d3864b0d9b$var$call);
module.exports = $lfb3z ? $842d67d3864b0d9b$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $842d67d3864b0d9b$var$call.apply(fn, arguments);
    };
};

});



parcelRegister("bCB23", function(module, exports) {
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $875ff82551747bfa$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $875ff82551747bfa$var$documentAll == 'undefined' && $875ff82551747bfa$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $875ff82551747bfa$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

});

parcelRegister("Cu1XA", function(module, exports) {

$parcel$export(module.exports, "f", () => $073ad82dcdc065d7$export$2d1720544b23b823, (v) => $073ad82dcdc065d7$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $073ad82dcdc065d7$export$2d1720544b23b823;
'use strict';

var $izyPX = parcelRequire("izyPX");

var $fztCk = parcelRequire("fztCk");

var $aXXjS = parcelRequire("aXXjS");

var $jw35K = parcelRequire("jw35K");

var $22RLh = parcelRequire("22RLh");

var $cDVev = parcelRequire("cDVev");

var $8Gs5d = parcelRequire("8Gs5d");

var $yje0b = parcelRequire("yje0b");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $073ad82dcdc065d7$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$073ad82dcdc065d7$export$2d1720544b23b823 = $izyPX ? $073ad82dcdc065d7$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $22RLh(O);
    P = $cDVev(P);
    if ($yje0b) try {
        return $073ad82dcdc065d7$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($8Gs5d(O, P)) return $jw35K(!$fztCk($aXXjS.f, O, P), O[P]);
};

});
parcelRegister("izyPX", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$5TNal(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});

parcelRegister("fztCk", function(module, exports) {
'use strict';

var $lfb3z = parcelRequire("lfb3z");
var $b561193d6d25af95$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = $lfb3z ? $b561193d6d25af95$var$call.bind($b561193d6d25af95$var$call) : function() {
    return $b561193d6d25af95$var$call.apply($b561193d6d25af95$var$call, arguments);
};

});

parcelRegister("aXXjS", function(module, exports) {

$parcel$export(module.exports, "f", () => $020f7140e1656b0a$export$2d1720544b23b823, (v) => $020f7140e1656b0a$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $020f7140e1656b0a$export$2d1720544b23b823;
'use strict';
var $020f7140e1656b0a$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $020f7140e1656b0a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $020f7140e1656b0a$var$NASHORN_BUG = $020f7140e1656b0a$var$getOwnPropertyDescriptor && !$020f7140e1656b0a$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$020f7140e1656b0a$export$2d1720544b23b823 = $020f7140e1656b0a$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $020f7140e1656b0a$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $020f7140e1656b0a$var$$propertyIsEnumerable;

});

parcelRegister("jw35K", function(module, exports) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("22RLh", function(module, exports) {
'use strict';

var $hZOGl = parcelRequire("hZOGl");

var $wWRWr = parcelRequire("wWRWr");
module.exports = function(it) {
    return $hZOGl($wWRWr(it));
};

});
parcelRegister("hZOGl", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $5TNal = parcelRequire("5TNal");

var $abkeB = parcelRequire("abkeB");
var $d19f7290ce8cfb4b$var$$Object = Object;
var $d19f7290ce8cfb4b$var$split = $blzM2(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $5TNal(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$d19f7290ce8cfb4b$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $abkeB(it) === 'String' ? $d19f7290ce8cfb4b$var$split(it, '') : $d19f7290ce8cfb4b$var$$Object(it);
} : $d19f7290ce8cfb4b$var$$Object;

});

parcelRegister("wWRWr", function(module, exports) {
'use strict';

var $giVYe = parcelRequire("giVYe");
var $0630a76faf6e2804$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($giVYe(it)) throw new $0630a76faf6e2804$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("giVYe", function(module, exports) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("cDVev", function(module, exports) {
'use strict';

var $aDxXM = parcelRequire("aDxXM");

var $1RGBa = parcelRequire("1RGBa");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $aDxXM(argument, 'string');
    return $1RGBa(key) ? key : key + '';
};

});
parcelRegister("aDxXM", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $81LAJ = parcelRequire("81LAJ");

var $1RGBa = parcelRequire("1RGBa");

var $dcbJP = parcelRequire("dcbJP");

var $jaUSS = parcelRequire("jaUSS");

var $1TMNu = parcelRequire("1TMNu");
var $7be7e4482ec15e95$var$$TypeError = TypeError;
var $7be7e4482ec15e95$var$TO_PRIMITIVE = $1TMNu('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$81LAJ(input) || $1RGBa(input)) return input;
    var exoticToPrim = $dcbJP(input, $7be7e4482ec15e95$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $fztCk(exoticToPrim, input, pref);
        if (!$81LAJ(result) || $1RGBa(result)) return result;
        throw new $7be7e4482ec15e95$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $jaUSS(input, pref);
};

});
parcelRegister("81LAJ", function(module, exports) {
'use strict';

var $bCB23 = parcelRequire("bCB23");
module.exports = function(it) {
    return typeof it == 'object' ? it !== null : $bCB23(it);
};

});

parcelRegister("1RGBa", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");

var $bCB23 = parcelRequire("bCB23");

var $3MFCD = parcelRequire("3MFCD");

var $6jrJb = parcelRequire("6jrJb");
var $15bbc8ddc173fd7d$var$$Object = Object;
module.exports = $6jrJb ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $a1ZFI('Symbol');
    return $bCB23($Symbol) && $3MFCD($Symbol.prototype, $15bbc8ddc173fd7d$var$$Object(it));
};

});
parcelRegister("a1ZFI", function(module, exports) {
'use strict';

var $fDEaU = parcelRequire("fDEaU");

var $a974b = parcelRequire("a974b");

var $bCB23 = parcelRequire("bCB23");
var $74d9d62512367c24$var$aFunction = function(variable) {
    return $bCB23(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $74d9d62512367c24$var$aFunction($fDEaU[namespace]) || $74d9d62512367c24$var$aFunction($a974b[namespace]) : $fDEaU[namespace] && $fDEaU[namespace][method] || $a974b[namespace] && $a974b[namespace][method];
};

});
parcelRegister("fDEaU", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("3MFCD", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
module.exports = $blzM2({}.isPrototypeOf);

});

parcelRegister("6jrJb", function(module, exports) {
'use strict';

var $c0AT5 = parcelRequire("c0AT5");
module.exports = $c0AT5 && !Symbol.sham && typeof Symbol.iterator == 'symbol';

});
parcelRegister("c0AT5", function(module, exports) {
'use strict';

var $gYjxe = parcelRequire("gYjxe");

var $5TNal = parcelRequire("5TNal");

var $a974b = parcelRequire("a974b");
var $8be2193c46f64bf8$var$$String = $a974b.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$5TNal(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$8be2193c46f64bf8$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $gYjxe && $gYjxe < 41;
});

});
parcelRegister("gYjxe", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $bd2Ce = parcelRequire("bd2Ce");
var $c5b1673215b05c7f$var$process = $a974b.process;
var $c5b1673215b05c7f$var$Deno = $a974b.Deno;
var $c5b1673215b05c7f$var$versions = $c5b1673215b05c7f$var$process && $c5b1673215b05c7f$var$process.versions || $c5b1673215b05c7f$var$Deno && $c5b1673215b05c7f$var$Deno.version;
var $c5b1673215b05c7f$var$v8 = $c5b1673215b05c7f$var$versions && $c5b1673215b05c7f$var$versions.v8;
var $c5b1673215b05c7f$var$match, $c5b1673215b05c7f$var$version;
if ($c5b1673215b05c7f$var$v8) {
    $c5b1673215b05c7f$var$match = $c5b1673215b05c7f$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $c5b1673215b05c7f$var$version = $c5b1673215b05c7f$var$match[0] > 0 && $c5b1673215b05c7f$var$match[0] < 4 ? 1 : +($c5b1673215b05c7f$var$match[0] + $c5b1673215b05c7f$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$c5b1673215b05c7f$var$version && $bd2Ce) {
    $c5b1673215b05c7f$var$match = $bd2Ce.match(/Edge\/(\d+)/);
    if (!$c5b1673215b05c7f$var$match || $c5b1673215b05c7f$var$match[1] >= 74) {
        $c5b1673215b05c7f$var$match = $bd2Ce.match(/Chrome\/(\d+)/);
        if ($c5b1673215b05c7f$var$match) $c5b1673215b05c7f$var$version = +$c5b1673215b05c7f$var$match[1];
    }
}
module.exports = $c5b1673215b05c7f$var$version;

});
parcelRegister("bd2Ce", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");
var $8292f007eba65e7a$var$navigator = $a974b.navigator;
var $8292f007eba65e7a$var$userAgent = $8292f007eba65e7a$var$navigator && $8292f007eba65e7a$var$navigator.userAgent;
module.exports = $8292f007eba65e7a$var$userAgent ? String($8292f007eba65e7a$var$userAgent) : '';

});





parcelRegister("dcbJP", function(module, exports) {
'use strict';

var $9I3bq = parcelRequire("9I3bq");

var $giVYe = parcelRequire("giVYe");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $giVYe(func) ? undefined : $9I3bq(func);
};

});
parcelRegister("9I3bq", function(module, exports) {
'use strict';

var $bCB23 = parcelRequire("bCB23");

var $gEcAW = parcelRequire("gEcAW");
var $711ab139f5037f6b$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($bCB23(argument)) return argument;
    throw new $711ab139f5037f6b$var$$TypeError($gEcAW(argument) + ' is not a function');
};

});
parcelRegister("gEcAW", function(module, exports) {
'use strict';
var $c1ea26d1966771ef$var$$String = String;
module.exports = function(argument) {
    try {
        return $c1ea26d1966771ef$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};

});



parcelRegister("jaUSS", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $bCB23 = parcelRequire("bCB23");

var $81LAJ = parcelRequire("81LAJ");
var $df5b137b8650f474$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $bCB23(fn = input.toString) && !$81LAJ(val = $fztCk(fn, input))) return val;
    if ($bCB23(fn = input.valueOf) && !$81LAJ(val = $fztCk(fn, input))) return val;
    if (pref !== 'string' && $bCB23(fn = input.toString) && !$81LAJ(val = $fztCk(fn, input))) return val;
    throw new $df5b137b8650f474$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("1TMNu", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $2DACA = parcelRequire("2DACA");

var $8Gs5d = parcelRequire("8Gs5d");

var $g713c = parcelRequire("g713c");

var $c0AT5 = parcelRequire("c0AT5");

var $6jrJb = parcelRequire("6jrJb");
var $1620c796c5c010ea$var$Symbol = $a974b.Symbol;
var $1620c796c5c010ea$var$WellKnownSymbolsStore = $2DACA('wks');
var $1620c796c5c010ea$var$createWellKnownSymbol = $6jrJb ? $1620c796c5c010ea$var$Symbol['for'] || $1620c796c5c010ea$var$Symbol : $1620c796c5c010ea$var$Symbol && $1620c796c5c010ea$var$Symbol.withoutSetter || $g713c;
module.exports = function(name) {
    if (!$8Gs5d($1620c796c5c010ea$var$WellKnownSymbolsStore, name)) $1620c796c5c010ea$var$WellKnownSymbolsStore[name] = $c0AT5 && $8Gs5d($1620c796c5c010ea$var$Symbol, name) ? $1620c796c5c010ea$var$Symbol[name] : $1620c796c5c010ea$var$createWellKnownSymbol('Symbol.' + name);
    return $1620c796c5c010ea$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("2DACA", function(module, exports) {
'use strict';

var $6D74Q = parcelRequire("6D74Q");
module.exports = function(key, value) {
    return $6D74Q[key] || ($6D74Q[key] = value || {});
};

});
parcelRegister("6D74Q", function(module, exports) {
'use strict';

var $1cBJJ = parcelRequire("1cBJJ");

var $a974b = parcelRequire("a974b");

var $7k1Pl = parcelRequire("7k1Pl");
var $4d3bdff4f7e0e859$var$SHARED = '__core-js_shared__';
var $4d3bdff4f7e0e859$var$store = module.exports = $a974b[$4d3bdff4f7e0e859$var$SHARED] || $7k1Pl($4d3bdff4f7e0e859$var$SHARED, {});
($4d3bdff4f7e0e859$var$store.versions || ($4d3bdff4f7e0e859$var$store.versions = [])).push({
    version: '3.47.0',
    mode: $1cBJJ ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

});
parcelRegister("1cBJJ", function(module, exports) {
'use strict';
module.exports = true;

});

parcelRegister("7k1Pl", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $554bd17c504e90b5$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $554bd17c504e90b5$var$defineProperty($a974b, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $a974b[key] = value;
    }
    return value;
};

});



parcelRegister("8Gs5d", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $67owA = parcelRequire("67owA");
var $652807b09d66bbe6$var$hasOwnProperty = $blzM2({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $652807b09d66bbe6$var$hasOwnProperty($67owA(it), key);
};

});
parcelRegister("67owA", function(module, exports) {
'use strict';

var $wWRWr = parcelRequire("wWRWr");
var $47466b95662ba698$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $47466b95662ba698$var$$Object($wWRWr(argument));
};

});


parcelRegister("g713c", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
var $bbae1d6ea63f48c8$var$id = 0;
var $bbae1d6ea63f48c8$var$postfix = Math.random();
var $bbae1d6ea63f48c8$var$toString = $blzM2(1.1.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $bbae1d6ea63f48c8$var$toString(++$bbae1d6ea63f48c8$var$id + $bbae1d6ea63f48c8$var$postfix, 36);
};

});




parcelRegister("yje0b", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $5TNal = parcelRequire("5TNal");

var $fUD4A = parcelRequire("fUD4A");
// Thanks to IE8 for its funny defineProperty
module.exports = !$izyPX && !$5TNal(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($fUD4A('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("fUD4A", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $81LAJ = parcelRequire("81LAJ");
var $b95a650ffef36724$var$document = $a974b.document;
// typeof document.createElement is 'object' in old IE
var $b95a650ffef36724$var$EXISTS = $81LAJ($b95a650ffef36724$var$document) && $81LAJ($b95a650ffef36724$var$document.createElement);
module.exports = function(it) {
    return $b95a650ffef36724$var$EXISTS ? $b95a650ffef36724$var$document.createElement(it) : {};
};

});



parcelRegister("7xCLo", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");

var $bCB23 = parcelRequire("bCB23");
var $57d9af10ce46e318$var$replacement = /#|\.prototype\./;
var $57d9af10ce46e318$var$isForced = function(feature, detection) {
    var value = $57d9af10ce46e318$var$data[$57d9af10ce46e318$var$normalize(feature)];
    return value === $57d9af10ce46e318$var$POLYFILL ? true : value === $57d9af10ce46e318$var$NATIVE ? false : $bCB23(detection) ? $5TNal(detection) : !!detection;
};
var $57d9af10ce46e318$var$normalize = $57d9af10ce46e318$var$isForced.normalize = function(string) {
    return String(string).replace($57d9af10ce46e318$var$replacement, '.').toLowerCase();
};
var $57d9af10ce46e318$var$data = $57d9af10ce46e318$var$isForced.data = {};
var $57d9af10ce46e318$var$NATIVE = $57d9af10ce46e318$var$isForced.NATIVE = 'N';
var $57d9af10ce46e318$var$POLYFILL = $57d9af10ce46e318$var$isForced.POLYFILL = 'P';
module.exports = $57d9af10ce46e318$var$isForced;

});

parcelRegister("iyHek", function(module, exports) {
'use strict';

var $8yMwi = parcelRequire("8yMwi");

var $9I3bq = parcelRequire("9I3bq");

var $lfb3z = parcelRequire("lfb3z");
var $d82cef8f26151ae1$var$bind = $8yMwi($8yMwi.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $9I3bq(fn);
    return that === undefined ? fn : $lfb3z ? $d82cef8f26151ae1$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRegister("5QIuJ", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $2llQo = parcelRequire("2llQo");

var $jw35K = parcelRequire("jw35K");
module.exports = $izyPX ? function(object, key, value) {
    return $2llQo.f(object, key, $jw35K(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("2llQo", function(module, exports) {

$parcel$export(module.exports, "f", () => $1b4e7cb4f30d4df5$export$2d1720544b23b823, (v) => $1b4e7cb4f30d4df5$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $1b4e7cb4f30d4df5$export$2d1720544b23b823;
'use strict';

var $izyPX = parcelRequire("izyPX");

var $yje0b = parcelRequire("yje0b");

var $cB6If = parcelRequire("cB6If");

var $amhk0 = parcelRequire("amhk0");

var $cDVev = parcelRequire("cDVev");
var $1b4e7cb4f30d4df5$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1b4e7cb4f30d4df5$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1b4e7cb4f30d4df5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1b4e7cb4f30d4df5$var$ENUMERABLE = 'enumerable';
var $1b4e7cb4f30d4df5$var$CONFIGURABLE = 'configurable';
var $1b4e7cb4f30d4df5$var$WRITABLE = 'writable';
$1b4e7cb4f30d4df5$export$2d1720544b23b823 = $izyPX ? $cB6If ? function defineProperty(O, P, Attributes) {
    $amhk0(O);
    P = $cDVev(P);
    $amhk0(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $1b4e7cb4f30d4df5$var$WRITABLE in Attributes && !Attributes[$1b4e7cb4f30d4df5$var$WRITABLE]) {
        var current = $1b4e7cb4f30d4df5$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$1b4e7cb4f30d4df5$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $1b4e7cb4f30d4df5$var$CONFIGURABLE in Attributes ? Attributes[$1b4e7cb4f30d4df5$var$CONFIGURABLE] : current[$1b4e7cb4f30d4df5$var$CONFIGURABLE],
                enumerable: $1b4e7cb4f30d4df5$var$ENUMERABLE in Attributes ? Attributes[$1b4e7cb4f30d4df5$var$ENUMERABLE] : current[$1b4e7cb4f30d4df5$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $1b4e7cb4f30d4df5$var$$defineProperty(O, P, Attributes);
} : $1b4e7cb4f30d4df5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $amhk0(O);
    P = $cDVev(P);
    $amhk0(Attributes);
    if ($yje0b) try {
        return $1b4e7cb4f30d4df5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $1b4e7cb4f30d4df5$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("cB6If", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $5TNal = parcelRequire("5TNal");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $izyPX && $5TNal(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("amhk0", function(module, exports) {
'use strict';

var $81LAJ = parcelRequire("81LAJ");
var $78a96530546817de$var$$String = String;
var $78a96530546817de$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($81LAJ(argument)) return argument;
    throw new $78a96530546817de$var$$TypeError($78a96530546817de$var$$String(argument) + ' is not an object');
};

});




parcelRegister("fugbv", function(module, exports) {
'use strict';

var $8Gs5d = parcelRequire("8Gs5d");

var $bCB23 = parcelRequire("bCB23");

var $67owA = parcelRequire("67owA");

var $eh6hB = parcelRequire("eh6hB");

var $j0P42 = parcelRequire("j0P42");
var $b466364683ae94ff$var$IE_PROTO = $eh6hB('IE_PROTO');
var $b466364683ae94ff$var$$Object = Object;
var $b466364683ae94ff$var$ObjectPrototype = $b466364683ae94ff$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $j0P42 ? $b466364683ae94ff$var$$Object.getPrototypeOf : function(O) {
    var object = $67owA(O);
    if ($8Gs5d(object, $b466364683ae94ff$var$IE_PROTO)) return object[$b466364683ae94ff$var$IE_PROTO];
    var constructor = object.constructor;
    if ($bCB23(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $b466364683ae94ff$var$$Object ? $b466364683ae94ff$var$ObjectPrototype : null;
};

});
parcelRegister("eh6hB", function(module, exports) {
'use strict';

var $2DACA = parcelRequire("2DACA");

var $g713c = parcelRequire("g713c");
var $a64786db7f59c34f$var$keys = $2DACA('keys');
module.exports = function(key) {
    return $a64786db7f59c34f$var$keys[key] || ($a64786db7f59c34f$var$keys[key] = $g713c(key));
};

});

parcelRegister("j0P42", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");
module.exports = !$5TNal(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRegister("1DwRe", function(module, exports) {
'use strict';

var $6Vebe = parcelRequire("6Vebe");

var $81LAJ = parcelRequire("81LAJ");

var $wWRWr = parcelRequire("wWRWr");

var $6SQtZ = parcelRequire("6SQtZ");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $6Vebe(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $wWRWr(O);
        $6SQtZ(proto);
        if (!$81LAJ(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("6Vebe", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $9I3bq = parcelRequire("9I3bq");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $blzM2($9I3bq(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("6SQtZ", function(module, exports) {
'use strict';

var $ldfVa = parcelRequire("ldfVa");
var $50307f382b048e70$var$$String = String;
var $50307f382b048e70$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($ldfVa(argument)) return argument;
    throw new $50307f382b048e70$var$$TypeError("Can't set " + $50307f382b048e70$var$$String(argument) + ' as a prototype');
};

});
parcelRegister("ldfVa", function(module, exports) {
'use strict';

var $81LAJ = parcelRequire("81LAJ");
module.exports = function(argument) {
    return $81LAJ(argument) || argument === null;
};

});



parcelRegister("6JHYn", function(module, exports) {
'use strict';

var $8Gs5d = parcelRequire("8Gs5d");

var $jffIL = parcelRequire("jffIL");

var $Cu1XA = parcelRequire("Cu1XA");

var $2llQo = parcelRequire("2llQo");
module.exports = function(target, source, exceptions) {
    var keys = $jffIL(source);
    var defineProperty = $2llQo.f;
    var getOwnPropertyDescriptor = $Cu1XA.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$8Gs5d(target, key) && !(exceptions && $8Gs5d(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("jffIL", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");

var $blzM2 = parcelRequire("blzM2");

var $fhlkb = parcelRequire("fhlkb");

var $hIQfK = parcelRequire("hIQfK");

var $amhk0 = parcelRequire("amhk0");
var $e02b9ce610bfe0cc$var$concat = $blzM2([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $a1ZFI('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $fhlkb.f($amhk0(it));
    var getOwnPropertySymbols = $hIQfK.f;
    return getOwnPropertySymbols ? $e02b9ce610bfe0cc$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("fhlkb", function(module, exports) {

$parcel$export(module.exports, "f", () => $b1f8fc28c23eb1b8$export$2d1720544b23b823, (v) => $b1f8fc28c23eb1b8$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $b1f8fc28c23eb1b8$export$2d1720544b23b823;
'use strict';

var $dMOyj = parcelRequire("dMOyj");

var $6AIDI = parcelRequire("6AIDI");
var $b1f8fc28c23eb1b8$var$hiddenKeys = $6AIDI.concat('length', 'prototype');
$b1f8fc28c23eb1b8$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dMOyj(O, $b1f8fc28c23eb1b8$var$hiddenKeys);
};

});
parcelRegister("dMOyj", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $8Gs5d = parcelRequire("8Gs5d");

var $22RLh = parcelRequire("22RLh");

var $icdlP = parcelRequire("icdlP");
var $a096f8b9dc6f76f3$require$indexOf = $icdlP.indexOf;

var $5NSM3 = parcelRequire("5NSM3");
var $a096f8b9dc6f76f3$var$push = $blzM2([].push);
module.exports = function(object, names) {
    var O = $22RLh(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$8Gs5d($5NSM3, key) && $8Gs5d(O, key) && $a096f8b9dc6f76f3$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8Gs5d(O, key = names[i++])) ~$a096f8b9dc6f76f3$require$indexOf(result, key) || $a096f8b9dc6f76f3$var$push(result, key);
    return result;
};

});
parcelRegister("icdlP", function(module, exports) {
'use strict';

var $22RLh = parcelRequire("22RLh");

var $4U47N = parcelRequire("4U47N");

var $1kfO2 = parcelRequire("1kfO2");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $d3f3b4379a96c0dd$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $22RLh($this);
        var length = $1kfO2(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $4U47N(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $d3f3b4379a96c0dd$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $d3f3b4379a96c0dd$var$createMethod(false)
};

});
parcelRegister("4U47N", function(module, exports) {
'use strict';

var $aiawW = parcelRequire("aiawW");
var $391f977d0103e8b4$var$max = Math.max;
var $391f977d0103e8b4$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $aiawW(index);
    return integer < 0 ? $391f977d0103e8b4$var$max(integer + length, 0) : $391f977d0103e8b4$var$min(integer, length);
};

});
parcelRegister("aiawW", function(module, exports) {
'use strict';

var $hSViC = parcelRequire("hSViC");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $hSViC(number);
};

});
parcelRegister("hSViC", function(module, exports) {
'use strict';
var $d053ed497945b18f$var$ceil = Math.ceil;
var $d053ed497945b18f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $d053ed497945b18f$var$floor : $d053ed497945b18f$var$ceil)(n);
};

});



parcelRegister("1kfO2", function(module, exports) {
'use strict';

var $1oKxw = parcelRequire("1oKxw");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $1oKxw(obj.length);
};

});
parcelRegister("1oKxw", function(module, exports) {
'use strict';

var $aiawW = parcelRequire("aiawW");
var $104c22294f0fd108$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $aiawW(argument);
    return len > 0 ? $104c22294f0fd108$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});



parcelRegister("5NSM3", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("6AIDI", function(module, exports) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});


parcelRegister("hIQfK", function(module, exports) {

$parcel$export(module.exports, "f", () => $ce6f1414a4f8cb9b$export$2d1720544b23b823, (v) => $ce6f1414a4f8cb9b$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $ce6f1414a4f8cb9b$export$2d1720544b23b823;
'use strict';
$ce6f1414a4f8cb9b$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("18Ax7", function(module, exports) {
'use strict';

var $amhk0 = parcelRequire("amhk0");

var $7a0ao = parcelRequire("7a0ao");

var $6AIDI = parcelRequire("6AIDI");

var $5NSM3 = parcelRequire("5NSM3");

var $lDC5s = parcelRequire("lDC5s");

var $fUD4A = parcelRequire("fUD4A");

var $eh6hB = parcelRequire("eh6hB");
var $0d42e0863dedd3c7$var$GT = '>';
var $0d42e0863dedd3c7$var$LT = '<';
var $0d42e0863dedd3c7$var$PROTOTYPE = 'prototype';
var $0d42e0863dedd3c7$var$SCRIPT = 'script';
var $0d42e0863dedd3c7$var$IE_PROTO = $eh6hB('IE_PROTO');
var $0d42e0863dedd3c7$var$EmptyConstructor = function() {};
var $0d42e0863dedd3c7$var$scriptTag = function(content) {
    return $0d42e0863dedd3c7$var$LT + $0d42e0863dedd3c7$var$SCRIPT + $0d42e0863dedd3c7$var$GT + content + $0d42e0863dedd3c7$var$LT + '/' + $0d42e0863dedd3c7$var$SCRIPT + $0d42e0863dedd3c7$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $0d42e0863dedd3c7$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($0d42e0863dedd3c7$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $0d42e0863dedd3c7$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $fUD4A('iframe');
    var JS = 'java' + $0d42e0863dedd3c7$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $lDC5s.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($0d42e0863dedd3c7$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $0d42e0863dedd3c7$var$activeXDocument;
var $0d42e0863dedd3c7$var$NullProtoObject = function() {
    try {
        $0d42e0863dedd3c7$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $0d42e0863dedd3c7$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $0d42e0863dedd3c7$var$activeXDocument ? $0d42e0863dedd3c7$var$NullProtoObjectViaActiveX($0d42e0863dedd3c7$var$activeXDocument) // old IE
     : $0d42e0863dedd3c7$var$NullProtoObjectViaIFrame() : $0d42e0863dedd3c7$var$NullProtoObjectViaActiveX($0d42e0863dedd3c7$var$activeXDocument); // WSH
    var length = $6AIDI.length;
    while(length--)delete $0d42e0863dedd3c7$var$NullProtoObject[$0d42e0863dedd3c7$var$PROTOTYPE][$6AIDI[length]];
    return $0d42e0863dedd3c7$var$NullProtoObject();
};
$5NSM3[$0d42e0863dedd3c7$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $0d42e0863dedd3c7$var$EmptyConstructor[$0d42e0863dedd3c7$var$PROTOTYPE] = $amhk0(O);
        result = new $0d42e0863dedd3c7$var$EmptyConstructor();
        $0d42e0863dedd3c7$var$EmptyConstructor[$0d42e0863dedd3c7$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$0d42e0863dedd3c7$var$IE_PROTO] = O;
    } else result = $0d42e0863dedd3c7$var$NullProtoObject();
    return Properties === undefined ? result : $7a0ao.f(result, Properties);
};

});
parcelRegister("7a0ao", function(module, exports) {

$parcel$export(module.exports, "f", () => $536998b0bdb04212$export$2d1720544b23b823, (v) => $536998b0bdb04212$export$2d1720544b23b823 = v);
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $536998b0bdb04212$export$2d1720544b23b823;
'use strict';

var $izyPX = parcelRequire("izyPX");

var $cB6If = parcelRequire("cB6If");

var $2llQo = parcelRequire("2llQo");

var $amhk0 = parcelRequire("amhk0");

var $22RLh = parcelRequire("22RLh");

var $4Ws1L = parcelRequire("4Ws1L");
$536998b0bdb04212$export$2d1720544b23b823 = $izyPX && !$cB6If ? Object.defineProperties : function defineProperties(O, Properties) {
    $amhk0(O);
    var props = $22RLh(Properties);
    var keys = $4Ws1L(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$2llQo.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("4Ws1L", function(module, exports) {
'use strict';

var $dMOyj = parcelRequire("dMOyj");

var $6AIDI = parcelRequire("6AIDI");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $dMOyj(O, $6AIDI);
};

});


parcelRegister("lDC5s", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");
module.exports = $a1ZFI('document', 'documentElement');

});


parcelRegister("9IqsX", function(module, exports) {
'use strict';

var $81LAJ = parcelRequire("81LAJ");

var $5QIuJ = parcelRequire("5QIuJ");
// `InstallErrorCause` abstract operation
// https://tc39.es/ecma262/#sec-installerrorcause
module.exports = function(O, options) {
    if ($81LAJ(options) && 'cause' in options) $5QIuJ(O, 'cause', options.cause);
};

});

parcelRegister("fRZA9", function(module, exports) {
'use strict';

var $5QIuJ = parcelRequire("5QIuJ");

var $cq7Tk = parcelRequire("cq7Tk");

var $jorX2 = parcelRequire("jorX2");
// non-standard V8
// eslint-disable-next-line es/no-nonstandard-error-properties -- safe
var $b8db9328d661e3e4$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($jorX2) {
        if ($b8db9328d661e3e4$var$captureStackTrace) $b8db9328d661e3e4$var$captureStackTrace(error, C);
        else $5QIuJ(error, 'stack', $cq7Tk(stack, dropEntries));
    }
};

});
parcelRegister("cq7Tk", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
var $90ae08cdf0fdebf2$var$$Error = Error;
var $90ae08cdf0fdebf2$var$replace = $blzM2(''.replace);
var $90ae08cdf0fdebf2$var$TEST = function(arg) {
    return String(new $90ae08cdf0fdebf2$var$$Error(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var $90ae08cdf0fdebf2$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $90ae08cdf0fdebf2$var$IS_V8_OR_CHAKRA_STACK = $90ae08cdf0fdebf2$var$V8_OR_CHAKRA_STACK_ENTRY.test($90ae08cdf0fdebf2$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($90ae08cdf0fdebf2$var$IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$90ae08cdf0fdebf2$var$$Error.prepareStackTrace) while(dropEntries--)stack = $90ae08cdf0fdebf2$var$replace(stack, $90ae08cdf0fdebf2$var$V8_OR_CHAKRA_STACK_ENTRY, '');
    return stack;
};

});

parcelRegister("jorX2", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");

var $jw35K = parcelRequire("jw35K");
module.exports = !$5TNal(function() {
    var error = new Error('a');
    if (!('stack' in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, 'stack', $jw35K(1, 7));
    return error.stack !== 7;
});

});


parcelRegister("7ICfs", function(module, exports) {
'use strict';

var $iyHek = parcelRequire("iyHek");

var $fztCk = parcelRequire("fztCk");

var $amhk0 = parcelRequire("amhk0");

var $gEcAW = parcelRequire("gEcAW");

var $iPzAE = parcelRequire("iPzAE");

var $1kfO2 = parcelRequire("1kfO2");

var $3MFCD = parcelRequire("3MFCD");

var $6ZzCi = parcelRequire("6ZzCi");

var $3rBCg = parcelRequire("3rBCg");

var $UXfhQ = parcelRequire("UXfhQ");
var $59ea4fc769c24c34$var$$TypeError = TypeError;
var $59ea4fc769c24c34$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $59ea4fc769c24c34$var$ResultPrototype = $59ea4fc769c24c34$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $iyHek(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $UXfhQ(iterator, 'normal');
        return new $59ea4fc769c24c34$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $amhk0(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $3rBCg(iterable);
        if (!iterFn) throw new $59ea4fc769c24c34$var$$TypeError($gEcAW(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($iPzAE(iterFn)) {
            for(index = 0, length = $1kfO2(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $3MFCD($59ea4fc769c24c34$var$ResultPrototype, result)) return result;
            }
            return new $59ea4fc769c24c34$var$Result(false);
        }
        iterator = $6ZzCi(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $fztCk(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $UXfhQ(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $3MFCD($59ea4fc769c24c34$var$ResultPrototype, result)) return result;
    }
    return new $59ea4fc769c24c34$var$Result(false);
};

});
parcelRegister("iPzAE", function(module, exports) {
'use strict';

var $1TMNu = parcelRequire("1TMNu");

var $bim2i = parcelRequire("bim2i");
var $db5898de4d4e0edd$var$ITERATOR = $1TMNu('iterator');
var $db5898de4d4e0edd$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($bim2i.Array === it || $db5898de4d4e0edd$var$ArrayPrototype[$db5898de4d4e0edd$var$ITERATOR] === it);
};

});
parcelRegister("bim2i", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("6ZzCi", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $amhk0 = parcelRequire("amhk0");

var $gEcAW = parcelRequire("gEcAW");

var $3rBCg = parcelRequire("3rBCg");
var $5174115574bb1362$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $3rBCg(argument) : usingIterator;
    if ($9I3bq(iteratorMethod)) return $amhk0($fztCk(iteratorMethod, argument));
    throw new $5174115574bb1362$var$$TypeError($gEcAW(argument) + ' is not iterable');
};

});
parcelRegister("3rBCg", function(module, exports) {
'use strict';

var $7IIKI = parcelRequire("7IIKI");

var $dcbJP = parcelRequire("dcbJP");

var $giVYe = parcelRequire("giVYe");

var $bim2i = parcelRequire("bim2i");

var $1TMNu = parcelRequire("1TMNu");
var $282112865371d58e$var$ITERATOR = $1TMNu('iterator');
module.exports = function(it) {
    if (!$giVYe(it)) return $dcbJP(it, $282112865371d58e$var$ITERATOR) || $dcbJP(it, '@@iterator') || $bim2i[$7IIKI(it)];
};

});
parcelRegister("7IIKI", function(module, exports) {
'use strict';

var $b6Nx2 = parcelRequire("b6Nx2");

var $bCB23 = parcelRequire("bCB23");

var $abkeB = parcelRequire("abkeB");

var $1TMNu = parcelRequire("1TMNu");
var $59ef5b633a277b83$var$TO_STRING_TAG = $1TMNu('toStringTag');
var $59ef5b633a277b83$var$$Object = Object;
// ES3 wrong here
var $59ef5b633a277b83$var$CORRECT_ARGUMENTS = $abkeB(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $59ef5b633a277b83$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $b6Nx2 ? $abkeB : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $59ef5b633a277b83$var$tryGet(O = $59ef5b633a277b83$var$$Object(it), $59ef5b633a277b83$var$TO_STRING_TAG)) == 'string' ? tag : $59ef5b633a277b83$var$CORRECT_ARGUMENTS ? $abkeB(O) : (result = $abkeB(O)) === 'Object' && $bCB23(O.callee) ? 'Arguments' : result;
};

});
parcelRegister("b6Nx2", function(module, exports) {
'use strict';

var $1TMNu = parcelRequire("1TMNu");
var $8166ad44b60844a3$var$TO_STRING_TAG = $1TMNu('toStringTag');
var $8166ad44b60844a3$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$8166ad44b60844a3$var$test[$8166ad44b60844a3$var$TO_STRING_TAG] = 'z';
module.exports = String($8166ad44b60844a3$var$test) === '[object z]';

});




parcelRegister("UXfhQ", function(module, exports) {
'use strict';

var $fztCk = parcelRequire("fztCk");

var $amhk0 = parcelRequire("amhk0");

var $dcbJP = parcelRequire("dcbJP");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $amhk0(iterator);
    try {
        innerResult = $dcbJP(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $fztCk(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $amhk0(innerResult);
    return value;
};

});


parcelRegister("bn7kC", function(module, exports) {
'use strict';

var $1ffsO = parcelRequire("1ffsO");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? '' : $default : $1ffsO(argument);
};

});
parcelRegister("1ffsO", function(module, exports) {
'use strict';

var $7IIKI = parcelRequire("7IIKI");
var $0e832ff382ed3d5a$var$$String = String;
module.exports = function(argument) {
    if ($7IIKI(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $0e832ff382ed3d5a$var$$String(argument);
};

});




parcelRegister("1sRs4", function(module, exports) {
'use strict';

var $22RLh = parcelRequire("22RLh");

var $eelBH = parcelRequire("eelBH");

var $bim2i = parcelRequire("bim2i");

var $iUh4p = parcelRequire("iUh4p");

var $2llQo = parcelRequire("2llQo");
var $1111de617187a88f$require$defineProperty = $2llQo.f;

var $03Wh9 = parcelRequire("03Wh9");

var $fJ7og = parcelRequire("fJ7og");

var $1cBJJ = parcelRequire("1cBJJ");

var $izyPX = parcelRequire("izyPX");
var $1111de617187a88f$var$ARRAY_ITERATOR = 'Array Iterator';
var $1111de617187a88f$var$setInternalState = $iUh4p.set;
var $1111de617187a88f$var$getInternalState = $iUh4p.getterFor($1111de617187a88f$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $03Wh9(Array, 'Array', function(iterated, kind) {
    $1111de617187a88f$var$setInternalState(this, {
        type: $1111de617187a88f$var$ARRAY_ITERATOR,
        target: $22RLh(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $1111de617187a88f$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $fJ7og(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $fJ7og(index, false);
        case 'values':
            return $fJ7og(target[index], false);
    }
    return $fJ7og([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $1111de617187a88f$var$values = $bim2i.Arguments = $bim2i.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$eelBH('keys');
$eelBH('values');
$eelBH('entries');
// V8 ~ Chrome 45- bug
if (!$1cBJJ && $izyPX && $1111de617187a88f$var$values.name !== 'values') try {
    $1111de617187a88f$require$defineProperty($1111de617187a88f$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}

});
parcelRegister("eelBH", function(module, exports) {
'use strict';
module.exports = function() {};

});

parcelRegister("iUh4p", function(module, exports) {
'use strict';

var $e8ACr = parcelRequire("e8ACr");

var $a974b = parcelRequire("a974b");

var $81LAJ = parcelRequire("81LAJ");

var $5QIuJ = parcelRequire("5QIuJ");

var $8Gs5d = parcelRequire("8Gs5d");

var $6D74Q = parcelRequire("6D74Q");

var $eh6hB = parcelRequire("eh6hB");

var $5NSM3 = parcelRequire("5NSM3");
var $dc3ab2b3bcd32b6b$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $dc3ab2b3bcd32b6b$var$TypeError = $a974b.TypeError;
var $dc3ab2b3bcd32b6b$var$WeakMap = $a974b.WeakMap;
var $dc3ab2b3bcd32b6b$var$set, $dc3ab2b3bcd32b6b$var$get, $dc3ab2b3bcd32b6b$var$has;
var $dc3ab2b3bcd32b6b$var$enforce = function(it) {
    return $dc3ab2b3bcd32b6b$var$has(it) ? $dc3ab2b3bcd32b6b$var$get(it) : $dc3ab2b3bcd32b6b$var$set(it, {});
};
var $dc3ab2b3bcd32b6b$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$81LAJ(it) || (state = $dc3ab2b3bcd32b6b$var$get(it)).type !== TYPE) throw new $dc3ab2b3bcd32b6b$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($e8ACr || $6D74Q.state) {
    var $dc3ab2b3bcd32b6b$var$store = $6D74Q.state || ($6D74Q.state = new $dc3ab2b3bcd32b6b$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $dc3ab2b3bcd32b6b$var$store.get = $dc3ab2b3bcd32b6b$var$store.get;
    $dc3ab2b3bcd32b6b$var$store.has = $dc3ab2b3bcd32b6b$var$store.has;
    $dc3ab2b3bcd32b6b$var$store.set = $dc3ab2b3bcd32b6b$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $dc3ab2b3bcd32b6b$var$set = function(it, metadata) {
        if ($dc3ab2b3bcd32b6b$var$store.has(it)) throw new $dc3ab2b3bcd32b6b$var$TypeError($dc3ab2b3bcd32b6b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc3ab2b3bcd32b6b$var$store.set(it, metadata);
        return metadata;
    };
    $dc3ab2b3bcd32b6b$var$get = function(it) {
        return $dc3ab2b3bcd32b6b$var$store.get(it) || {};
    };
    $dc3ab2b3bcd32b6b$var$has = function(it) {
        return $dc3ab2b3bcd32b6b$var$store.has(it);
    };
} else {
    var $dc3ab2b3bcd32b6b$var$STATE = $eh6hB('state');
    $5NSM3[$dc3ab2b3bcd32b6b$var$STATE] = true;
    $dc3ab2b3bcd32b6b$var$set = function(it, metadata) {
        if ($8Gs5d(it, $dc3ab2b3bcd32b6b$var$STATE)) throw new $dc3ab2b3bcd32b6b$var$TypeError($dc3ab2b3bcd32b6b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5QIuJ(it, $dc3ab2b3bcd32b6b$var$STATE, metadata);
        return metadata;
    };
    $dc3ab2b3bcd32b6b$var$get = function(it) {
        return $8Gs5d(it, $dc3ab2b3bcd32b6b$var$STATE) ? it[$dc3ab2b3bcd32b6b$var$STATE] : {};
    };
    $dc3ab2b3bcd32b6b$var$has = function(it) {
        return $8Gs5d(it, $dc3ab2b3bcd32b6b$var$STATE);
    };
}
module.exports = {
    set: $dc3ab2b3bcd32b6b$var$set,
    get: $dc3ab2b3bcd32b6b$var$get,
    has: $dc3ab2b3bcd32b6b$var$has,
    enforce: $dc3ab2b3bcd32b6b$var$enforce,
    getterFor: $dc3ab2b3bcd32b6b$var$getterFor
};

});
parcelRegister("e8ACr", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $bCB23 = parcelRequire("bCB23");
var $a4ae37d02805c089$var$WeakMap = $a974b.WeakMap;
module.exports = $bCB23($a4ae37d02805c089$var$WeakMap) && /native code/.test(String($a4ae37d02805c089$var$WeakMap));

});


parcelRegister("03Wh9", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $1cBJJ = parcelRequire("1cBJJ");

var $Pi9oo = parcelRequire("Pi9oo");

var $bCB23 = parcelRequire("bCB23");

var $eof8u = parcelRequire("eof8u");

var $fugbv = parcelRequire("fugbv");

var $1DwRe = parcelRequire("1DwRe");

var $3pVms = parcelRequire("3pVms");

var $5QIuJ = parcelRequire("5QIuJ");

var $9DIeg = parcelRequire("9DIeg");

var $1TMNu = parcelRequire("1TMNu");

var $bim2i = parcelRequire("bim2i");

var $fjUiZ = parcelRequire("fjUiZ");
var $00bd7c45dd2dc870$var$PROPER_FUNCTION_NAME = $Pi9oo.PROPER;
var $00bd7c45dd2dc870$var$CONFIGURABLE_FUNCTION_NAME = $Pi9oo.CONFIGURABLE;
var $00bd7c45dd2dc870$var$IteratorPrototype = $fjUiZ.IteratorPrototype;
var $00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS = $fjUiZ.BUGGY_SAFARI_ITERATORS;
var $00bd7c45dd2dc870$var$ITERATOR = $1TMNu('iterator');
var $00bd7c45dd2dc870$var$KEYS = 'keys';
var $00bd7c45dd2dc870$var$VALUES = 'values';
var $00bd7c45dd2dc870$var$ENTRIES = 'entries';
var $00bd7c45dd2dc870$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $eof8u(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $00bd7c45dd2dc870$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00bd7c45dd2dc870$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00bd7c45dd2dc870$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$00bd7c45dd2dc870$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $fugbv(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$1cBJJ && $fugbv(CurrentIteratorPrototype) !== $00bd7c45dd2dc870$var$IteratorPrototype) {
                if ($1DwRe) $1DwRe(CurrentIteratorPrototype, $00bd7c45dd2dc870$var$IteratorPrototype);
                else if (!$bCB23(CurrentIteratorPrototype[$00bd7c45dd2dc870$var$ITERATOR])) $9DIeg(CurrentIteratorPrototype, $00bd7c45dd2dc870$var$ITERATOR, $00bd7c45dd2dc870$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $3pVms(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($1cBJJ) $bim2i[TO_STRING_TAG] = $00bd7c45dd2dc870$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($00bd7c45dd2dc870$var$PROPER_FUNCTION_NAME && DEFAULT === $00bd7c45dd2dc870$var$VALUES && nativeIterator && nativeIterator.name !== $00bd7c45dd2dc870$var$VALUES) {
        if (!$1cBJJ && $00bd7c45dd2dc870$var$CONFIGURABLE_FUNCTION_NAME) $5QIuJ(IterablePrototype, 'name', $00bd7c45dd2dc870$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $fztCk(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($00bd7c45dd2dc870$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($00bd7c45dd2dc870$var$KEYS),
            entries: getIterationMethod($00bd7c45dd2dc870$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $9DIeg(IterablePrototype, KEY, methods[KEY]);
        } else $k8IkA({
            target: NAME,
            proto: true,
            forced: $00bd7c45dd2dc870$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$1cBJJ || FORCED) && IterablePrototype[$00bd7c45dd2dc870$var$ITERATOR] !== defaultIterator) $9DIeg(IterablePrototype, $00bd7c45dd2dc870$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $bim2i[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("Pi9oo", function(module, exports) {
'use strict';

var $izyPX = parcelRequire("izyPX");

var $8Gs5d = parcelRequire("8Gs5d");
var $09a2d7d827b77642$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $09a2d7d827b77642$var$getDescriptor = $izyPX && Object.getOwnPropertyDescriptor;
var $09a2d7d827b77642$var$EXISTS = $8Gs5d($09a2d7d827b77642$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $09a2d7d827b77642$var$PROPER = $09a2d7d827b77642$var$EXISTS && (function something() {}).name === 'something';
var $09a2d7d827b77642$var$CONFIGURABLE = $09a2d7d827b77642$var$EXISTS && (!$izyPX || $izyPX && $09a2d7d827b77642$var$getDescriptor($09a2d7d827b77642$var$FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: $09a2d7d827b77642$var$EXISTS,
    PROPER: $09a2d7d827b77642$var$PROPER,
    CONFIGURABLE: $09a2d7d827b77642$var$CONFIGURABLE
};

});

parcelRegister("eof8u", function(module, exports) {
'use strict';

var $fjUiZ = parcelRequire("fjUiZ");
var $a79f0c3d48f4d169$require$IteratorPrototype = $fjUiZ.IteratorPrototype;

var $18Ax7 = parcelRequire("18Ax7");

var $jw35K = parcelRequire("jw35K");

var $3pVms = parcelRequire("3pVms");

var $bim2i = parcelRequire("bim2i");
var $a79f0c3d48f4d169$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $18Ax7($a79f0c3d48f4d169$require$IteratorPrototype, {
        next: $jw35K(+!ENUMERABLE_NEXT, next)
    });
    $3pVms(IteratorConstructor, TO_STRING_TAG, false, true);
    $bim2i[TO_STRING_TAG] = $a79f0c3d48f4d169$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("fjUiZ", function(module, exports) {
'use strict';

var $5TNal = parcelRequire("5TNal");

var $bCB23 = parcelRequire("bCB23");

var $81LAJ = parcelRequire("81LAJ");

var $18Ax7 = parcelRequire("18Ax7");

var $fugbv = parcelRequire("fugbv");

var $9DIeg = parcelRequire("9DIeg");

var $1TMNu = parcelRequire("1TMNu");

var $1cBJJ = parcelRequire("1cBJJ");
var $b2744e674335f849$var$ITERATOR = $1TMNu('iterator');
var $b2744e674335f849$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $b2744e674335f849$var$IteratorPrototype, $b2744e674335f849$var$PrototypeOfArrayIteratorPrototype, $b2744e674335f849$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $b2744e674335f849$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $b2744e674335f849$var$arrayIterator)) $b2744e674335f849$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $b2744e674335f849$var$PrototypeOfArrayIteratorPrototype = $fugbv($fugbv($b2744e674335f849$var$arrayIterator));
        if ($b2744e674335f849$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $b2744e674335f849$var$IteratorPrototype = $b2744e674335f849$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $b2744e674335f849$var$NEW_ITERATOR_PROTOTYPE = !$81LAJ($b2744e674335f849$var$IteratorPrototype) || $5TNal(function() {
    var test = {};
    // FF44- legacy iterators case
    return $b2744e674335f849$var$IteratorPrototype[$b2744e674335f849$var$ITERATOR].call(test) !== test;
});
if ($b2744e674335f849$var$NEW_ITERATOR_PROTOTYPE) $b2744e674335f849$var$IteratorPrototype = {};
else if ($1cBJJ) $b2744e674335f849$var$IteratorPrototype = $18Ax7($b2744e674335f849$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$bCB23($b2744e674335f849$var$IteratorPrototype[$b2744e674335f849$var$ITERATOR])) $9DIeg($b2744e674335f849$var$IteratorPrototype, $b2744e674335f849$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $b2744e674335f849$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $b2744e674335f849$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("9DIeg", function(module, exports) {
'use strict';

var $5QIuJ = parcelRequire("5QIuJ");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $5QIuJ(target, key, value);
    return target;
};

});


parcelRegister("3pVms", function(module, exports) {
'use strict';

var $b6Nx2 = parcelRequire("b6Nx2");

var $2llQo = parcelRequire("2llQo");
var $27d033a943f5d823$require$defineProperty = $2llQo.f;

var $5QIuJ = parcelRequire("5QIuJ");

var $8Gs5d = parcelRequire("8Gs5d");

var $jyhCT = parcelRequire("jyhCT");

var $1TMNu = parcelRequire("1TMNu");
var $27d033a943f5d823$var$TO_STRING_TAG = $1TMNu('toStringTag');
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    var target = STATIC ? it : it && it.prototype;
    if (target) {
        if (!$8Gs5d(target, $27d033a943f5d823$var$TO_STRING_TAG)) $27d033a943f5d823$require$defineProperty(target, $27d033a943f5d823$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$b6Nx2) $5QIuJ(target, 'toString', $jyhCT);
    }
};

});
parcelRegister("jyhCT", function(module, exports) {
'use strict';

var $b6Nx2 = parcelRequire("b6Nx2");

var $7IIKI = parcelRequire("7IIKI");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $b6Nx2 ? ({}).toString : function toString() {
    return '[object ' + $7IIKI(this) + ']';
};

});




parcelRegister("fJ7og", function(module, exports) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRegister("1o61r", function(module, exports) {
// empty

});

parcelRegister("bW6p0", function(module, exports) {
'use strict';
parcelRequire("9hSKp");
parcelRequire("4MY5K");
parcelRequire("chvhL");
parcelRequire("1KFVU");
parcelRequire("6UgSe");
parcelRequire("euzrX");

});
parcelRegister("9hSKp", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $1cBJJ = parcelRequire("1cBJJ");

var $i7XiZ = parcelRequire("i7XiZ");

var $a974b = parcelRequire("a974b");

var $fDEaU = parcelRequire("fDEaU");

var $fztCk = parcelRequire("fztCk");

var $9DIeg = parcelRequire("9DIeg");

var $1DwRe = parcelRequire("1DwRe");

var $3pVms = parcelRequire("3pVms");

var $6Fx27 = parcelRequire("6Fx27");

var $9I3bq = parcelRequire("9I3bq");

var $bCB23 = parcelRequire("bCB23");

var $81LAJ = parcelRequire("81LAJ");

var $6ABtt = parcelRequire("6ABtt");

var $17lIF = parcelRequire("17lIF");

var $laoax = parcelRequire("laoax");
var $6c302b4c80c55ef8$require$task = $laoax.set;

var $kln2e = parcelRequire("kln2e");

var $ggKK7 = parcelRequire("ggKK7");

var $97RGR = parcelRequire("97RGR");

var $fOoey = parcelRequire("fOoey");

var $iUh4p = parcelRequire("iUh4p");

var $4BzCf = parcelRequire("4BzCf");

var $bpphM = parcelRequire("bpphM");

var $2hmlq = parcelRequire("2hmlq");
var $6c302b4c80c55ef8$var$PROMISE = 'Promise';
var $6c302b4c80c55ef8$var$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;
var $6c302b4c80c55ef8$var$NATIVE_PROMISE_REJECTION_EVENT = $bpphM.REJECTION_EVENT;
var $6c302b4c80c55ef8$var$NATIVE_PROMISE_SUBCLASSING = $bpphM.SUBCLASSING;
var $6c302b4c80c55ef8$var$getInternalPromiseState = $iUh4p.getterFor($6c302b4c80c55ef8$var$PROMISE);
var $6c302b4c80c55ef8$var$setInternalState = $iUh4p.set;
var $6c302b4c80c55ef8$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
var $6c302b4c80c55ef8$var$PromiseConstructor = $4BzCf;
var $6c302b4c80c55ef8$var$PromisePrototype = $6c302b4c80c55ef8$var$NativePromisePrototype;
var $6c302b4c80c55ef8$var$TypeError = $a974b.TypeError;
var $6c302b4c80c55ef8$var$document = $a974b.document;
var $6c302b4c80c55ef8$var$process = $a974b.process;
var $6c302b4c80c55ef8$var$newPromiseCapability = $2hmlq.f;
var $6c302b4c80c55ef8$var$newGenericPromiseCapability = $6c302b4c80c55ef8$var$newPromiseCapability;
var $6c302b4c80c55ef8$var$DISPATCH_EVENT = !!($6c302b4c80c55ef8$var$document && $6c302b4c80c55ef8$var$document.createEvent && $a974b.dispatchEvent);
var $6c302b4c80c55ef8$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $6c302b4c80c55ef8$var$REJECTION_HANDLED = 'rejectionhandled';
var $6c302b4c80c55ef8$var$PENDING = 0;
var $6c302b4c80c55ef8$var$FULFILLED = 1;
var $6c302b4c80c55ef8$var$REJECTED = 2;
var $6c302b4c80c55ef8$var$HANDLED = 1;
var $6c302b4c80c55ef8$var$UNHANDLED = 2;
var $6c302b4c80c55ef8$var$Internal, $6c302b4c80c55ef8$var$OwnPromiseCapability, $6c302b4c80c55ef8$var$PromiseWrapper, $6c302b4c80c55ef8$var$nativeThen;
// helpers
var $6c302b4c80c55ef8$var$isThenable = function(it) {
    var then;
    return $81LAJ(it) && $bCB23(then = it.then) ? then : false;
};
var $6c302b4c80c55ef8$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $6c302b4c80c55ef8$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $6c302b4c80c55ef8$var$UNHANDLED) $6c302b4c80c55ef8$var$onHandleUnhandled(state);
                state.rejection = $6c302b4c80c55ef8$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $6c302b4c80c55ef8$var$TypeError('Promise-chain cycle'));
            else if (then = $6c302b4c80c55ef8$var$isThenable(result)) $fztCk(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $6c302b4c80c55ef8$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $kln2e(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$6c302b4c80c55ef8$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $6c302b4c80c55ef8$var$onUnhandled(state);
    });
};
var $6c302b4c80c55ef8$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($6c302b4c80c55ef8$var$DISPATCH_EVENT) {
        event = $6c302b4c80c55ef8$var$document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $a974b.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$6c302b4c80c55ef8$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $a974b['on' + name])) handler(event);
    else if (name === $6c302b4c80c55ef8$var$UNHANDLED_REJECTION) $ggKK7('Unhandled promise rejection', reason);
};
var $6c302b4c80c55ef8$var$onUnhandled = function(state) {
    $fztCk($6c302b4c80c55ef8$require$task, $a974b, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $6c302b4c80c55ef8$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $97RGR(function() {
                if ($i7XiZ) $6c302b4c80c55ef8$var$process.emit('unhandledRejection', value, promise);
                else $6c302b4c80c55ef8$var$dispatchEvent($6c302b4c80c55ef8$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $i7XiZ || $6c302b4c80c55ef8$var$isUnhandled(state) ? $6c302b4c80c55ef8$var$UNHANDLED : $6c302b4c80c55ef8$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $6c302b4c80c55ef8$var$isUnhandled = function(state) {
    return state.rejection !== $6c302b4c80c55ef8$var$HANDLED && !state.parent;
};
var $6c302b4c80c55ef8$var$onHandleUnhandled = function(state) {
    $fztCk($6c302b4c80c55ef8$require$task, $a974b, function() {
        var promise = state.facade;
        if ($i7XiZ) $6c302b4c80c55ef8$var$process.emit('rejectionHandled', promise);
        else $6c302b4c80c55ef8$var$dispatchEvent($6c302b4c80c55ef8$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $6c302b4c80c55ef8$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $6c302b4c80c55ef8$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $6c302b4c80c55ef8$var$REJECTED;
    $6c302b4c80c55ef8$var$notify(state, true);
};
var $6c302b4c80c55ef8$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $6c302b4c80c55ef8$var$TypeError("Promise can't be resolved itself");
        var then = $6c302b4c80c55ef8$var$isThenable(value);
        if (then) $kln2e(function() {
            var wrapper = {
                done: false
            };
            try {
                $fztCk(then, value, $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalResolve, wrapper, state), $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalReject, wrapper, state));
            } catch (error) {
                $6c302b4c80c55ef8$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $6c302b4c80c55ef8$var$FULFILLED;
            $6c302b4c80c55ef8$var$notify(state, false);
        }
    } catch (error) {
        $6c302b4c80c55ef8$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($6c302b4c80c55ef8$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $6c302b4c80c55ef8$var$PromiseConstructor = function Promise(executor) {
        $6ABtt(this, $6c302b4c80c55ef8$var$PromisePrototype);
        $9I3bq(executor);
        $fztCk($6c302b4c80c55ef8$var$Internal, this);
        var state = $6c302b4c80c55ef8$var$getInternalPromiseState(this);
        try {
            executor($6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalResolve, state), $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalReject, state));
        } catch (error) {
            $6c302b4c80c55ef8$var$internalReject(state, error);
        }
    };
    $6c302b4c80c55ef8$var$PromisePrototype = $6c302b4c80c55ef8$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $6c302b4c80c55ef8$var$Internal = function Promise(executor) {
        $6c302b4c80c55ef8$var$setInternalState(this, {
            type: $6c302b4c80c55ef8$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $fOoey(),
            rejection: false,
            state: $6c302b4c80c55ef8$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $6c302b4c80c55ef8$var$Internal.prototype = $9DIeg($6c302b4c80c55ef8$var$PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = $6c302b4c80c55ef8$var$getInternalPromiseState(this);
        var reaction = $6c302b4c80c55ef8$var$newPromiseCapability($17lIF(this, $6c302b4c80c55ef8$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $bCB23(onFulfilled) ? onFulfilled : true;
        reaction.fail = $bCB23(onRejected) && onRejected;
        reaction.domain = $i7XiZ ? $6c302b4c80c55ef8$var$process.domain : undefined;
        if (state.state === $6c302b4c80c55ef8$var$PENDING) state.reactions.add(reaction);
        else $kln2e(function() {
            $6c302b4c80c55ef8$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $6c302b4c80c55ef8$var$OwnPromiseCapability = function() {
        var promise = new $6c302b4c80c55ef8$var$Internal();
        var state = $6c302b4c80c55ef8$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalResolve, state);
        this.reject = $6c302b4c80c55ef8$var$bind($6c302b4c80c55ef8$var$internalReject, state);
    };
    $2hmlq.f = $6c302b4c80c55ef8$var$newPromiseCapability = function(C) {
        return C === $6c302b4c80c55ef8$var$PromiseConstructor || C === $6c302b4c80c55ef8$var$PromiseWrapper ? new $6c302b4c80c55ef8$var$OwnPromiseCapability(C) : $6c302b4c80c55ef8$var$newGenericPromiseCapability(C);
    };
    if (!$1cBJJ && $bCB23($4BzCf) && $6c302b4c80c55ef8$var$NativePromisePrototype !== Object.prototype) {
        $6c302b4c80c55ef8$var$nativeThen = $6c302b4c80c55ef8$var$NativePromisePrototype.then;
        if (!$6c302b4c80c55ef8$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $9DIeg($6c302b4c80c55ef8$var$NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var that = this;
            return new $6c302b4c80c55ef8$var$PromiseConstructor(function(resolve, reject) {
                $fztCk($6c302b4c80c55ef8$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $6c302b4c80c55ef8$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($1DwRe) $1DwRe($6c302b4c80c55ef8$var$NativePromisePrototype, $6c302b4c80c55ef8$var$PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$k8IkA({
    global: true,
    constructor: true,
    wrap: true,
    forced: $6c302b4c80c55ef8$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $6c302b4c80c55ef8$var$PromiseConstructor
});
$6c302b4c80c55ef8$var$PromiseWrapper = $fDEaU.Promise;
$3pVms($6c302b4c80c55ef8$var$PromiseConstructor, $6c302b4c80c55ef8$var$PROMISE, false, true);
$6Fx27($6c302b4c80c55ef8$var$PROMISE);

});
parcelRegister("i7XiZ", function(module, exports) {
'use strict';

var $dlL5c = parcelRequire("dlL5c");
module.exports = $dlL5c === 'NODE';

});
parcelRegister("dlL5c", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $bd2Ce = parcelRequire("bd2Ce");

var $abkeB = parcelRequire("abkeB");
var $9b81c2357b0a5960$var$userAgentStartsWith = function(string) {
    return $bd2Ce.slice(0, string.length) === string;
};
module.exports = function() {
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($9b81c2357b0a5960$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($a974b.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($a974b.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($abkeB($a974b.process) === 'process') return 'NODE';
    if ($a974b.window && $a974b.document) return 'BROWSER';
    return 'REST';
}();

});


parcelRegister("6Fx27", function(module, exports) {
'use strict';

var $a1ZFI = parcelRequire("a1ZFI");

var $ca0NC = parcelRequire("ca0NC");

var $1TMNu = parcelRequire("1TMNu");

var $izyPX = parcelRequire("izyPX");
var $4db0322016396c49$var$SPECIES = $1TMNu('species');
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $a1ZFI(CONSTRUCTOR_NAME);
    if ($izyPX && Constructor && !Constructor[$4db0322016396c49$var$SPECIES]) $ca0NC(Constructor, $4db0322016396c49$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRegister("ca0NC", function(module, exports) {
'use strict';

var $2llQo = parcelRequire("2llQo");
module.exports = function(target, name, descriptor) {
    return $2llQo.f(target, name, descriptor);
};

});


parcelRegister("6ABtt", function(module, exports) {
'use strict';

var $3MFCD = parcelRequire("3MFCD");
var $4cc32c7eba8a551a$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($3MFCD(Prototype, it)) return it;
    throw new $4cc32c7eba8a551a$var$$TypeError('Incorrect invocation');
};

});

parcelRegister("17lIF", function(module, exports) {
'use strict';

var $amhk0 = parcelRequire("amhk0");

var $21d1Z = parcelRequire("21d1Z");

var $giVYe = parcelRequire("giVYe");

var $1TMNu = parcelRequire("1TMNu");
var $0d074aed54c19725$var$SPECIES = $1TMNu('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $amhk0(O).constructor;
    var S;
    return C === undefined || $giVYe(S = $amhk0(C)[$0d074aed54c19725$var$SPECIES]) ? defaultConstructor : $21d1Z(S);
};

});
parcelRegister("21d1Z", function(module, exports) {
'use strict';

var $6khJx = parcelRequire("6khJx");

var $gEcAW = parcelRequire("gEcAW");
var $1785c87ad2f83d9d$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($6khJx(argument)) return argument;
    throw new $1785c87ad2f83d9d$var$$TypeError($gEcAW(argument) + ' is not a constructor');
};

});
parcelRegister("6khJx", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $5TNal = parcelRequire("5TNal");

var $bCB23 = parcelRequire("bCB23");

var $7IIKI = parcelRequire("7IIKI");

var $a1ZFI = parcelRequire("a1ZFI");

var $hl3EW = parcelRequire("hl3EW");
var $49b25dd5c4f9389e$var$noop = function() {};
var $49b25dd5c4f9389e$var$construct = $a1ZFI('Reflect', 'construct');
var $49b25dd5c4f9389e$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $49b25dd5c4f9389e$var$exec = $blzM2($49b25dd5c4f9389e$var$constructorRegExp.exec);
var $49b25dd5c4f9389e$var$INCORRECT_TO_STRING = !$49b25dd5c4f9389e$var$constructorRegExp.test($49b25dd5c4f9389e$var$noop);
var $49b25dd5c4f9389e$var$isConstructorModern = function isConstructor(argument) {
    if (!$bCB23(argument)) return false;
    try {
        $49b25dd5c4f9389e$var$construct($49b25dd5c4f9389e$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $49b25dd5c4f9389e$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$bCB23(argument)) return false;
    switch($7IIKI(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $49b25dd5c4f9389e$var$INCORRECT_TO_STRING || !!$49b25dd5c4f9389e$var$exec($49b25dd5c4f9389e$var$constructorRegExp, $hl3EW(argument));
    } catch (error) {
        return true;
    }
};
$49b25dd5c4f9389e$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$49b25dd5c4f9389e$var$construct || $5TNal(function() {
    var called;
    return $49b25dd5c4f9389e$var$isConstructorModern($49b25dd5c4f9389e$var$isConstructorModern.call) || !$49b25dd5c4f9389e$var$isConstructorModern(Object) || !$49b25dd5c4f9389e$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $49b25dd5c4f9389e$var$isConstructorLegacy : $49b25dd5c4f9389e$var$isConstructorModern;

});
parcelRegister("hl3EW", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $bCB23 = parcelRequire("bCB23");

var $6D74Q = parcelRequire("6D74Q");
var $c9f73c7f7baa270d$var$functionToString = $blzM2(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$bCB23($6D74Q.inspectSource)) $6D74Q.inspectSource = function(it) {
    return $c9f73c7f7baa270d$var$functionToString(it);
};
module.exports = $6D74Q.inspectSource;

});




parcelRegister("laoax", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $dgWbh = parcelRequire("dgWbh");

var $iyHek = parcelRequire("iyHek");

var $bCB23 = parcelRequire("bCB23");

var $8Gs5d = parcelRequire("8Gs5d");

var $5TNal = parcelRequire("5TNal");

var $lDC5s = parcelRequire("lDC5s");

var $eXbub = parcelRequire("eXbub");

var $fUD4A = parcelRequire("fUD4A");

var $lcEhe = parcelRequire("lcEhe");

var $4LkyJ = parcelRequire("4LkyJ");

var $i7XiZ = parcelRequire("i7XiZ");
var $f68d4795da4bb704$var$set = $a974b.setImmediate;
var $f68d4795da4bb704$var$clear = $a974b.clearImmediate;
var $f68d4795da4bb704$var$process = $a974b.process;
var $f68d4795da4bb704$var$Dispatch = $a974b.Dispatch;
var $f68d4795da4bb704$var$Function = $a974b.Function;
var $f68d4795da4bb704$var$MessageChannel = $a974b.MessageChannel;
var $f68d4795da4bb704$var$String = $a974b.String;
var $f68d4795da4bb704$var$counter = 0;
var $f68d4795da4bb704$var$queue = {};
var $f68d4795da4bb704$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $f68d4795da4bb704$var$$location, $f68d4795da4bb704$var$defer, $f68d4795da4bb704$var$channel, $f68d4795da4bb704$var$port;
$5TNal(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $f68d4795da4bb704$var$$location = $a974b.location;
});
var $f68d4795da4bb704$var$run = function(id) {
    if ($8Gs5d($f68d4795da4bb704$var$queue, id)) {
        var fn = $f68d4795da4bb704$var$queue[id];
        delete $f68d4795da4bb704$var$queue[id];
        fn();
    }
};
var $f68d4795da4bb704$var$runner = function(id) {
    return function() {
        $f68d4795da4bb704$var$run(id);
    };
};
var $f68d4795da4bb704$var$eventListener = function(event) {
    $f68d4795da4bb704$var$run(event.data);
};
var $f68d4795da4bb704$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $a974b.postMessage($f68d4795da4bb704$var$String(id), $f68d4795da4bb704$var$$location.protocol + '//' + $f68d4795da4bb704$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$f68d4795da4bb704$var$set || !$f68d4795da4bb704$var$clear) {
    $f68d4795da4bb704$var$set = function setImmediate(handler) {
        $lcEhe(arguments.length, 1);
        var fn = $bCB23(handler) ? handler : $f68d4795da4bb704$var$Function(handler);
        var args = $eXbub(arguments, 1);
        $f68d4795da4bb704$var$queue[++$f68d4795da4bb704$var$counter] = function() {
            $dgWbh(fn, undefined, args);
        };
        $f68d4795da4bb704$var$defer($f68d4795da4bb704$var$counter);
        return $f68d4795da4bb704$var$counter;
    };
    $f68d4795da4bb704$var$clear = function clearImmediate(id) {
        delete $f68d4795da4bb704$var$queue[id];
    };
    // Node.js 0.8-
    if ($i7XiZ) $f68d4795da4bb704$var$defer = function(id) {
        $f68d4795da4bb704$var$process.nextTick($f68d4795da4bb704$var$runner(id));
    };
    else if ($f68d4795da4bb704$var$Dispatch && $f68d4795da4bb704$var$Dispatch.now) $f68d4795da4bb704$var$defer = function(id) {
        $f68d4795da4bb704$var$Dispatch.now($f68d4795da4bb704$var$runner(id));
    };
    else if ($f68d4795da4bb704$var$MessageChannel && !$4LkyJ) {
        $f68d4795da4bb704$var$channel = new $f68d4795da4bb704$var$MessageChannel();
        $f68d4795da4bb704$var$port = $f68d4795da4bb704$var$channel.port2;
        $f68d4795da4bb704$var$channel.port1.onmessage = $f68d4795da4bb704$var$eventListener;
        $f68d4795da4bb704$var$defer = $iyHek($f68d4795da4bb704$var$port.postMessage, $f68d4795da4bb704$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($a974b.addEventListener && $bCB23($a974b.postMessage) && !$a974b.importScripts && $f68d4795da4bb704$var$$location && $f68d4795da4bb704$var$$location.protocol !== 'file:' && !$5TNal($f68d4795da4bb704$var$globalPostMessageDefer)) {
        $f68d4795da4bb704$var$defer = $f68d4795da4bb704$var$globalPostMessageDefer;
        $a974b.addEventListener('message', $f68d4795da4bb704$var$eventListener, false);
    // IE8-
    } else if ($f68d4795da4bb704$var$ONREADYSTATECHANGE in $fUD4A('script')) $f68d4795da4bb704$var$defer = function(id) {
        $lDC5s.appendChild($fUD4A('script'))[$f68d4795da4bb704$var$ONREADYSTATECHANGE] = function() {
            $lDC5s.removeChild(this);
            $f68d4795da4bb704$var$run(id);
        };
    };
    else $f68d4795da4bb704$var$defer = function(id) {
        setTimeout($f68d4795da4bb704$var$runner(id), 0);
    };
}
module.exports = {
    set: $f68d4795da4bb704$var$set,
    clear: $f68d4795da4bb704$var$clear
};

});
parcelRegister("eXbub", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");
module.exports = $blzM2([].slice);

});

parcelRegister("lcEhe", function(module, exports) {
'use strict';
var $f6f9f6259be2e999$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $f6f9f6259be2e999$var$$TypeError('Not enough arguments');
    return passed;
};

});

parcelRegister("4LkyJ", function(module, exports) {
'use strict';

var $bd2Ce = parcelRequire("bd2Ce");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($bd2Ce);

});


parcelRegister("kln2e", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $2VzIO = parcelRequire("2VzIO");

var $iyHek = parcelRequire("iyHek");

var $laoax = parcelRequire("laoax");
var $ecf7a30f3d257c00$require$macrotask = $laoax.set;

var $fOoey = parcelRequire("fOoey");

var $4LkyJ = parcelRequire("4LkyJ");

var $3k2dW = parcelRequire("3k2dW");

var $4eHfF = parcelRequire("4eHfF");

var $i7XiZ = parcelRequire("i7XiZ");
var $ecf7a30f3d257c00$var$MutationObserver = $a974b.MutationObserver || $a974b.WebKitMutationObserver;
var $ecf7a30f3d257c00$var$document = $a974b.document;
var $ecf7a30f3d257c00$var$process = $a974b.process;
var $ecf7a30f3d257c00$var$Promise = $a974b.Promise;
var $ecf7a30f3d257c00$var$microtask = $2VzIO('queueMicrotask');
var $ecf7a30f3d257c00$var$notify, $ecf7a30f3d257c00$var$toggle, $ecf7a30f3d257c00$var$node, $ecf7a30f3d257c00$var$promise, $ecf7a30f3d257c00$var$then;
// modern engines have queueMicrotask method
if (!$ecf7a30f3d257c00$var$microtask) {
    var $ecf7a30f3d257c00$var$queue = new $fOoey();
    var $ecf7a30f3d257c00$var$flush = function() {
        var parent, fn;
        if ($i7XiZ && (parent = $ecf7a30f3d257c00$var$process.domain)) parent.exit();
        while(fn = $ecf7a30f3d257c00$var$queue.get())try {
            fn();
        } catch (error) {
            if ($ecf7a30f3d257c00$var$queue.head) $ecf7a30f3d257c00$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$4LkyJ && !$i7XiZ && !$4eHfF && $ecf7a30f3d257c00$var$MutationObserver && $ecf7a30f3d257c00$var$document) {
        $ecf7a30f3d257c00$var$toggle = true;
        $ecf7a30f3d257c00$var$node = $ecf7a30f3d257c00$var$document.createTextNode('');
        new $ecf7a30f3d257c00$var$MutationObserver($ecf7a30f3d257c00$var$flush).observe($ecf7a30f3d257c00$var$node, {
            characterData: true
        });
        $ecf7a30f3d257c00$var$notify = function() {
            $ecf7a30f3d257c00$var$node.data = $ecf7a30f3d257c00$var$toggle = !$ecf7a30f3d257c00$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$3k2dW && $ecf7a30f3d257c00$var$Promise && $ecf7a30f3d257c00$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $ecf7a30f3d257c00$var$promise = $ecf7a30f3d257c00$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $ecf7a30f3d257c00$var$promise.constructor = $ecf7a30f3d257c00$var$Promise;
        $ecf7a30f3d257c00$var$then = $iyHek($ecf7a30f3d257c00$var$promise.then, $ecf7a30f3d257c00$var$promise);
        $ecf7a30f3d257c00$var$notify = function() {
            $ecf7a30f3d257c00$var$then($ecf7a30f3d257c00$var$flush);
        };
    // Node.js without promises
    } else if ($i7XiZ) $ecf7a30f3d257c00$var$notify = function() {
        $ecf7a30f3d257c00$var$process.nextTick($ecf7a30f3d257c00$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $ecf7a30f3d257c00$require$macrotask = $iyHek($ecf7a30f3d257c00$require$macrotask, $a974b);
        $ecf7a30f3d257c00$var$notify = function() {
            $ecf7a30f3d257c00$require$macrotask($ecf7a30f3d257c00$var$flush);
        };
    }
    $ecf7a30f3d257c00$var$microtask = function(fn) {
        if (!$ecf7a30f3d257c00$var$queue.head) $ecf7a30f3d257c00$var$notify();
        $ecf7a30f3d257c00$var$queue.add(fn);
    };
}
module.exports = $ecf7a30f3d257c00$var$microtask;

});
parcelRegister("2VzIO", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $izyPX = parcelRequire("izyPX");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $221c9d439e8ee9bb$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!$izyPX) return $a974b[name];
    var descriptor = $221c9d439e8ee9bb$var$getOwnPropertyDescriptor($a974b, name);
    return descriptor && descriptor.value;
};

});

parcelRegister("fOoey", function(module, exports) {
'use strict';
var $b82e52d647d9fee7$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$b82e52d647d9fee7$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $b82e52d647d9fee7$var$Queue;

});

parcelRegister("3k2dW", function(module, exports) {
'use strict';

var $bd2Ce = parcelRequire("bd2Ce");
module.exports = /ipad|iphone|ipod/i.test($bd2Ce) && typeof Pebble != 'undefined';

});

parcelRegister("4eHfF", function(module, exports) {
'use strict';

var $bd2Ce = parcelRequire("bd2Ce");
module.exports = /web0s(?!.*chrome)/i.test($bd2Ce);

});


parcelRegister("ggKK7", function(module, exports) {
'use strict';
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRegister("97RGR", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRegister("4BzCf", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");
module.exports = $a974b.Promise;

});

parcelRegister("bpphM", function(module, exports) {
'use strict';

var $a974b = parcelRequire("a974b");

var $4BzCf = parcelRequire("4BzCf");

var $bCB23 = parcelRequire("bCB23");

var $7xCLo = parcelRequire("7xCLo");

var $hl3EW = parcelRequire("hl3EW");

var $1TMNu = parcelRequire("1TMNu");

var $dlL5c = parcelRequire("dlL5c");

var $1cBJJ = parcelRequire("1cBJJ");

var $gYjxe = parcelRequire("gYjxe");
var $84e5a4b698051148$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
var $84e5a4b698051148$var$SPECIES = $1TMNu('species');
var $84e5a4b698051148$var$SUBCLASSING = false;
var $84e5a4b698051148$var$NATIVE_PROMISE_REJECTION_EVENT = $bCB23($a974b.PromiseRejectionEvent);
var $84e5a4b698051148$var$FORCED_PROMISE_CONSTRUCTOR = $7xCLo('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $hl3EW($4BzCf);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($4BzCf);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $gYjxe === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($1cBJJ && !($84e5a4b698051148$var$NativePromisePrototype['catch'] && $84e5a4b698051148$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$gYjxe || $gYjxe < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $4BzCf(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$84e5a4b698051148$var$SPECIES] = FakePromise;
        $84e5a4b698051148$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$84e5a4b698051148$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($dlL5c === 'BROWSER' || $dlL5c === 'DENO') && !$84e5a4b698051148$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $84e5a4b698051148$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $84e5a4b698051148$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $84e5a4b698051148$var$SUBCLASSING
};

});

parcelRegister("2hmlq", function(module, exports) {

$parcel$export(module.exports, "f", () => $1a8e807b5a76d4aa$export$2d1720544b23b823, (v) => $1a8e807b5a76d4aa$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $1a8e807b5a76d4aa$export$2d1720544b23b823;
'use strict';

var $9I3bq = parcelRequire("9I3bq");
var $1a8e807b5a76d4aa$var$$TypeError = TypeError;
var $1a8e807b5a76d4aa$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $1a8e807b5a76d4aa$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $9I3bq(resolve);
    this.reject = $9I3bq(reject);
};
$1a8e807b5a76d4aa$export$2d1720544b23b823 = function(C) {
    return new $1a8e807b5a76d4aa$var$PromiseCapability(C);
};

});


parcelRegister("4MY5K", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $2hmlq.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $97RGR(function() {
            var $promiseResolve = $9I3bq(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $7ICfs(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $fztCk($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRegister("enhYZ", function(module, exports) {
'use strict';

var $4BzCf = parcelRequire("4BzCf");

var $fWetc = parcelRequire("fWetc");

var $bpphM = parcelRequire("bpphM");
var $a77129ab13e958db$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;
module.exports = $a77129ab13e958db$require$FORCED_PROMISE_CONSTRUCTOR || !$fWetc(function(iterable) {
    $4BzCf.all(iterable).then(undefined, function() {});
});

});
parcelRegister("fWetc", function(module, exports) {
'use strict';

var $1TMNu = parcelRequire("1TMNu");
var $b9a77f3661b0eae5$var$ITERATOR = $1TMNu('iterator');
var $b9a77f3661b0eae5$var$SAFE_CLOSING = false;
try {
    var $b9a77f3661b0eae5$var$called = 0;
    var $b9a77f3661b0eae5$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$b9a77f3661b0eae5$var$called++
            };
        },
        'return': function() {
            $b9a77f3661b0eae5$var$SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    $b9a77f3661b0eae5$var$iteratorWithReturn[$b9a77f3661b0eae5$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($b9a77f3661b0eae5$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$b9a77f3661b0eae5$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[$b9a77f3661b0eae5$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRegister("chvhL", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $1cBJJ = parcelRequire("1cBJJ");

var $bpphM = parcelRequire("bpphM");
var $8f0f573b6c790cb3$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;

var $4BzCf = parcelRequire("4BzCf");

var $a1ZFI = parcelRequire("a1ZFI");

var $bCB23 = parcelRequire("bCB23");

var $9DIeg = parcelRequire("9DIeg");
var $8f0f573b6c790cb3$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$k8IkA({
    target: 'Promise',
    proto: true,
    forced: $8f0f573b6c790cb3$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$1cBJJ && $bCB23($4BzCf)) {
    var $8f0f573b6c790cb3$var$method = $a1ZFI('Promise').prototype['catch'];
    if ($8f0f573b6c790cb3$var$NativePromisePrototype['catch'] !== $8f0f573b6c790cb3$var$method) $9DIeg($8f0f573b6c790cb3$var$NativePromisePrototype, 'catch', $8f0f573b6c790cb3$var$method, {
        unsafe: true
    });
}

});

parcelRegister("1KFVU", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $2hmlq.f(C);
        var reject = capability.reject;
        var result = $97RGR(function() {
            var $promiseResolve = $9I3bq(C.resolve);
            $7ICfs(iterable, function(promise) {
                $fztCk($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("6UgSe", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $2hmlq = parcelRequire("2hmlq");

var $bpphM = parcelRequire("bpphM");
var $50750fc96650feef$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $50750fc96650feef$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $2hmlq.f(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});

});

parcelRegister("euzrX", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $a1ZFI = parcelRequire("a1ZFI");

var $1cBJJ = parcelRequire("1cBJJ");

var $4BzCf = parcelRequire("4BzCf");

var $bpphM = parcelRequire("bpphM");
var $a8cf5da170f4bdf7$require$FORCED_PROMISE_CONSTRUCTOR = $bpphM.CONSTRUCTOR;

var $46QV9 = parcelRequire("46QV9");
var $a8cf5da170f4bdf7$var$PromiseConstructorWrapper = $a1ZFI('Promise');
var $a8cf5da170f4bdf7$var$CHECK_WRAPPER = $1cBJJ && !$a8cf5da170f4bdf7$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $1cBJJ || $a8cf5da170f4bdf7$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $46QV9($a8cf5da170f4bdf7$var$CHECK_WRAPPER && this === $a8cf5da170f4bdf7$var$PromiseConstructorWrapper ? $4BzCf : this, x);
    }
});

});
parcelRegister("46QV9", function(module, exports) {
'use strict';

var $amhk0 = parcelRequire("amhk0");

var $81LAJ = parcelRequire("81LAJ");

var $2hmlq = parcelRequire("2hmlq");
module.exports = function(C, x) {
    $amhk0(C);
    if ($81LAJ(x) && x.constructor === C) return x;
    var promiseCapability = $2hmlq.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRegister("3Fwpb", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $2hmlq.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $97RGR(function() {
            var promiseResolve = $9I3bq(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $7ICfs(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $fztCk(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("9hluD", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $fztCk = parcelRequire("fztCk");

var $9I3bq = parcelRequire("9I3bq");

var $a1ZFI = parcelRequire("a1ZFI");

var $2hmlq = parcelRequire("2hmlq");

var $97RGR = parcelRequire("97RGR");

var $7ICfs = parcelRequire("7ICfs");

var $enhYZ = parcelRequire("enhYZ");
var $6c165fb20d954d57$var$PROMISE_ANY_ERROR = 'No one promise resolved';
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $enhYZ
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $a1ZFI('AggregateError');
        var capability = $2hmlq.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $97RGR(function() {
            var promiseResolve = $9I3bq(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $7ICfs(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $fztCk(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $6c165fb20d954d57$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $6c165fb20d954d57$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("djTyE", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $a974b = parcelRequire("a974b");

var $dgWbh = parcelRequire("dgWbh");

var $eXbub = parcelRequire("eXbub");

var $2hmlq = parcelRequire("2hmlq");

var $9I3bq = parcelRequire("9I3bq");

var $97RGR = parcelRequire("97RGR");
var $9b282556ae670410$var$Promise = $a974b.Promise;
var $9b282556ae670410$var$ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var $9b282556ae670410$var$FORCED = !$9b282556ae670410$var$Promise || !$9b282556ae670410$var$Promise['try'] || $97RGR(function() {
    $9b282556ae670410$var$Promise['try'](function(argument) {
        $9b282556ae670410$var$ACCEPT_ARGUMENTS = argument === 8;
    }, 8);
}).error || !$9b282556ae670410$var$ACCEPT_ARGUMENTS;
// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$k8IkA({
    target: 'Promise',
    stat: true,
    forced: $9b282556ae670410$var$FORCED
}, {
    'try': function(callbackfn /* , ...args */ ) {
        var args = arguments.length > 1 ? $eXbub(arguments, 1) : [];
        var promiseCapability = $2hmlq.f(this);
        var result = $97RGR(function() {
            return $dgWbh($9I3bq(callbackfn), undefined, args);
        });
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRegister("3Comk", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $2hmlq = parcelRequire("2hmlq");
// `Promise.withResolvers` method
// https://tc39.es/ecma262/#sec-promise.withResolvers
$k8IkA({
    target: 'Promise',
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $2hmlq.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});

});

parcelRegister("hyQQI", function(module, exports) {
'use strict';

var $k8IkA = parcelRequire("k8IkA");

var $1cBJJ = parcelRequire("1cBJJ");

var $4BzCf = parcelRequire("4BzCf");

var $5TNal = parcelRequire("5TNal");

var $a1ZFI = parcelRequire("a1ZFI");

var $bCB23 = parcelRequire("bCB23");

var $17lIF = parcelRequire("17lIF");

var $46QV9 = parcelRequire("46QV9");

var $9DIeg = parcelRequire("9DIeg");
var $cc8e9b6d76347651$var$NativePromisePrototype = $4BzCf && $4BzCf.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $cc8e9b6d76347651$var$NON_GENERIC = !!$4BzCf && $5TNal(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $cc8e9b6d76347651$var$NativePromisePrototype['finally'].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$k8IkA({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $cc8e9b6d76347651$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $17lIF(this, $a1ZFI('Promise'));
        var isFunction = $bCB23(onFinally);
        return this.then(isFunction ? function(x) {
            return $46QV9(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $46QV9(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$1cBJJ && $bCB23($4BzCf)) {
    var $cc8e9b6d76347651$var$method = $a1ZFI('Promise').prototype['finally'];
    if ($cc8e9b6d76347651$var$NativePromisePrototype['finally'] !== $cc8e9b6d76347651$var$method) $9DIeg($cc8e9b6d76347651$var$NativePromisePrototype, 'finally', $cc8e9b6d76347651$var$method, {
        unsafe: true
    });
}

});

parcelRegister("hNffK", function(module, exports) {
'use strict';

var $eBbjp = parcelRequire("eBbjp");
var $cf42d8318689f7b3$require$charAt = $eBbjp.charAt;

var $1ffsO = parcelRequire("1ffsO");

var $iUh4p = parcelRequire("iUh4p");

var $03Wh9 = parcelRequire("03Wh9");

var $fJ7og = parcelRequire("fJ7og");
var $cf42d8318689f7b3$var$STRING_ITERATOR = 'String Iterator';
var $cf42d8318689f7b3$var$setInternalState = $iUh4p.set;
var $cf42d8318689f7b3$var$getInternalState = $iUh4p.getterFor($cf42d8318689f7b3$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$03Wh9(String, 'String', function(iterated) {
    $cf42d8318689f7b3$var$setInternalState(this, {
        type: $cf42d8318689f7b3$var$STRING_ITERATOR,
        string: $1ffsO(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $cf42d8318689f7b3$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $fJ7og(undefined, true);
    point = $cf42d8318689f7b3$require$charAt(string, index);
    state.index += point.length;
    return $fJ7og(point, false);
});

});
parcelRegister("eBbjp", function(module, exports) {
'use strict';

var $blzM2 = parcelRequire("blzM2");

var $aiawW = parcelRequire("aiawW");

var $1ffsO = parcelRequire("1ffsO");

var $wWRWr = parcelRequire("wWRWr");
var $aa0d4bb909cd6b22$var$charAt = $blzM2(''.charAt);
var $aa0d4bb909cd6b22$var$charCodeAt = $blzM2(''.charCodeAt);
var $aa0d4bb909cd6b22$var$stringSlice = $blzM2(''.slice);
var $aa0d4bb909cd6b22$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $1ffsO($wWRWr($this));
        var position = $aiawW(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $aa0d4bb909cd6b22$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $aa0d4bb909cd6b22$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $aa0d4bb909cd6b22$var$charAt(S, position) : first : CONVERT_TO_STRING ? $aa0d4bb909cd6b22$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $aa0d4bb909cd6b22$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $aa0d4bb909cd6b22$var$createMethod(true)
};

});



parcelRegister("jlLxD", function(module, exports) {
'use strict';
parcelRequire("1sRs4");

var $aoGv6 = parcelRequire("aoGv6");

var $a974b = parcelRequire("a974b");

var $3pVms = parcelRequire("3pVms");

var $bim2i = parcelRequire("bim2i");
for(var $e164db42d8f880ec$var$COLLECTION_NAME in $aoGv6){
    $3pVms($a974b[$e164db42d8f880ec$var$COLLECTION_NAME], $e164db42d8f880ec$var$COLLECTION_NAME);
    $bim2i[$e164db42d8f880ec$var$COLLECTION_NAME] = $bim2i.Array;
}

});
parcelRegister("aoGv6", function(module, exports) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});






parcelRegister("eWorU", function(module, exports) {
module.exports = $parcel$import("cby9Y").then(()=>parcelRequire('7wiNg'));

});

parcelRegister("hhGYP", function(module, exports) {
module.exports = $parcel$import("bVNjP").then(()=>parcelRequire('buL06'));

});

parcelRegister("itb2K", function(module, exports) {

$parcel$export(module.exports, "CharacterState", () => $d7238066c5de7f1c$export$f2e6b371e93925c7);
$parcel$export(module.exports, "CreationTool", () => $d7238066c5de7f1c$export$4a5f7b09ca822d8c);
$parcel$export(module.exports, "setCharacterState", () => $d7238066c5de7f1c$export$83a16ee147243363);
$parcel$export(module.exports, "presets", () => $d7238066c5de7f1c$export$7afd9c1079ecedf7);
$parcel$export(module.exports, "setVisemes", () => $d7238066c5de7f1c$export$53e124f45dac8729);
$parcel$export(module.exports, "addViseme", () => $d7238066c5de7f1c$export$a6f0d0f24e5dc19b);
$parcel$export(module.exports, "flushLipSyncData", () => $d7238066c5de7f1c$export$1a9c534915c6839e);
$parcel$export(module.exports, "Character", () => $d7238066c5de7f1c$export$cb68cc2163cd3f1);

var $bxRTa = parcelRequire("bxRTa");
parcelRequire("1W96c");
var $329ek = parcelRequire("329ek");
var $1W96c = parcelRequire("1W96c");

var $fl9nK = parcelRequire("fl9nK");

var $f2Nvv = parcelRequire("f2Nvv");
var $d7238066c5de7f1c$require$Buffer = $f2Nvv.Buffer;
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.8.2
*/ var $d7238066c5de7f1c$var$Qg = Uint8Array, $d7238066c5de7f1c$var$IA = Uint16Array, $d7238066c5de7f1c$var$Q7 = Int32Array, $d7238066c5de7f1c$var$Bk = new $d7238066c5de7f1c$var$Qg([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]), $d7238066c5de7f1c$var$fk = new $d7238066c5de7f1c$var$Qg([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]), $d7238066c5de7f1c$var$O7 = new $d7238066c5de7f1c$var$Qg([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $d7238066c5de7f1c$var$Gk = function(r, e) {
    for(var t = new $d7238066c5de7f1c$var$IA(31), i = 0; i < 31; ++i)t[i] = e += 1 << r[i - 1];
    for(var n = new $d7238066c5de7f1c$var$Q7(t[30]), i = 1; i < 30; ++i)for(var s = t[i]; s < t[i + 1]; ++s)n[s] = s - t[i] << 5 | i;
    return {
        b: t,
        r: n
    };
}, $d7238066c5de7f1c$var$vk = $d7238066c5de7f1c$var$Gk($d7238066c5de7f1c$var$Bk, 2), $d7238066c5de7f1c$var$Sk = $d7238066c5de7f1c$var$vk.b, $d7238066c5de7f1c$var$j7 = $d7238066c5de7f1c$var$vk.r;
$d7238066c5de7f1c$var$Sk[28] = 258, $d7238066c5de7f1c$var$j7[258] = 28;
var $d7238066c5de7f1c$var$q7 = $d7238066c5de7f1c$var$Gk($d7238066c5de7f1c$var$fk, 0), $d7238066c5de7f1c$var$$7 = $d7238066c5de7f1c$var$q7.b, $d7238066c5de7f1c$var$m2 = new $d7238066c5de7f1c$var$IA(32768);
for(var $d7238066c5de7f1c$var$ns = 0; $d7238066c5de7f1c$var$ns < 32768; ++$d7238066c5de7f1c$var$ns){
    var $d7238066c5de7f1c$var$Zd = ($d7238066c5de7f1c$var$ns & 43690) >> 1 | ($d7238066c5de7f1c$var$ns & 21845) << 1;
    $d7238066c5de7f1c$var$Zd = ($d7238066c5de7f1c$var$Zd & 52428) >> 2 | ($d7238066c5de7f1c$var$Zd & 13107) << 2, $d7238066c5de7f1c$var$Zd = ($d7238066c5de7f1c$var$Zd & 61680) >> 4 | ($d7238066c5de7f1c$var$Zd & 3855) << 4, $d7238066c5de7f1c$var$m2[$d7238066c5de7f1c$var$ns] = (($d7238066c5de7f1c$var$Zd & 65280) >> 8 | ($d7238066c5de7f1c$var$Zd & 255) << 8) >> 1;
}
var $d7238066c5de7f1c$var$Ly = function(r, e, t) {
    for(var i = r.length, n = 0, s = new $d7238066c5de7f1c$var$IA(e); n < i; ++n)r[n] && ++s[r[n] - 1];
    var a = new $d7238066c5de7f1c$var$IA(e);
    for(n = 1; n < e; ++n)a[n] = a[n - 1] + s[n - 1] << 1;
    var o;
    if (t) {
        o = new $d7238066c5de7f1c$var$IA(1 << e);
        var g = 15 - e;
        for(n = 0; n < i; ++n)if (r[n]) for(var l = n << 4 | r[n], c = e - r[n], d = a[r[n] - 1]++ << c, p = d | (1 << c) - 1; d <= p; ++d)o[$d7238066c5de7f1c$var$m2[d] >> g] = l;
    } else for(o = new $d7238066c5de7f1c$var$IA(i), n = 0; n < i; ++n)r[n] && (o[n] = $d7238066c5de7f1c$var$m2[a[r[n] - 1]++] >> 15 - r[n]);
    return o;
}, $d7238066c5de7f1c$var$TB = new $d7238066c5de7f1c$var$Qg(288);
for(var $d7238066c5de7f1c$var$ns = 0; $d7238066c5de7f1c$var$ns < 144; ++$d7238066c5de7f1c$var$ns)$d7238066c5de7f1c$var$TB[$d7238066c5de7f1c$var$ns] = 8;
for(var $d7238066c5de7f1c$var$ns = 144; $d7238066c5de7f1c$var$ns < 256; ++$d7238066c5de7f1c$var$ns)$d7238066c5de7f1c$var$TB[$d7238066c5de7f1c$var$ns] = 9;
for(var $d7238066c5de7f1c$var$ns = 256; $d7238066c5de7f1c$var$ns < 280; ++$d7238066c5de7f1c$var$ns)$d7238066c5de7f1c$var$TB[$d7238066c5de7f1c$var$ns] = 7;
for(var $d7238066c5de7f1c$var$ns = 280; $d7238066c5de7f1c$var$ns < 288; ++$d7238066c5de7f1c$var$ns)$d7238066c5de7f1c$var$TB[$d7238066c5de7f1c$var$ns] = 8;
var $d7238066c5de7f1c$var$Zk = new $d7238066c5de7f1c$var$Qg(32);
for(var $d7238066c5de7f1c$var$ns = 0; $d7238066c5de7f1c$var$ns < 32; ++$d7238066c5de7f1c$var$ns)$d7238066c5de7f1c$var$Zk[$d7238066c5de7f1c$var$ns] = 5;
var $d7238066c5de7f1c$var$e6 = /* @__PURE__ */ $d7238066c5de7f1c$var$Ly($d7238066c5de7f1c$var$TB, 9, 1), $d7238066c5de7f1c$var$t6 = /* @__PURE__ */ $d7238066c5de7f1c$var$Ly($d7238066c5de7f1c$var$Zk, 5, 1), $d7238066c5de7f1c$var$KW = function(r) {
    for(var e = r[0], t = 1; t < r.length; ++t)r[t] > e && (e = r[t]);
    return e;
}, $d7238066c5de7f1c$var$Yl = function(r, e, t) {
    var i = e / 8 | 0;
    return (r[i] | r[i + 1] << 8) >> (e & 7) & t;
}, $d7238066c5de7f1c$var$xW = function(r, e) {
    var t = e / 8 | 0;
    return (r[t] | r[t + 1] << 8 | r[t + 2] << 16) >> (e & 7);
}, $d7238066c5de7f1c$var$i6 = function(r) {
    return (r + 7) / 8 | 0;
}, $d7238066c5de7f1c$var$n6 = function(r, e, t) {
    return (t == null || t > r.length) && (t = r.length), new $d7238066c5de7f1c$var$Qg(r.subarray(e, t));
}, $d7238066c5de7f1c$var$s6 = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
], $d7238066c5de7f1c$var$Jl = function(r, e, t) {
    var i = new Error(e || $d7238066c5de7f1c$var$s6[r]);
    if (i.code = r, Error.captureStackTrace && Error.captureStackTrace(i, $d7238066c5de7f1c$var$Jl), !t) throw i;
    return i;
}, $d7238066c5de7f1c$var$r6 = function(r, e, t, i) {
    var n = r.length, s = 0;
    if (!n || e.f && !e.l) return t || new $d7238066c5de7f1c$var$Qg(0);
    var a = !t, o = a || e.i != 2, g = e.i;
    a && (t = new $d7238066c5de7f1c$var$Qg(n * 3));
    var l = function(mn) {
        var Qs = t.length;
        if (mn > Qs) {
            var Di = new $d7238066c5de7f1c$var$Qg(Math.max(Qs * 2, mn));
            Di.set(t), t = Di;
        }
    }, c = e.f || 0, d = e.p || 0, p = e.b || 0, A = e.l, y = e.d, G = e.m, Z = e.n, v = n * 8;
    do {
        if (!A) {
            c = $d7238066c5de7f1c$var$Yl(r, d, 1);
            var V = $d7238066c5de7f1c$var$Yl(r, d + 1, 3);
            if (d += 3, V) {
                if (V == 1) A = $d7238066c5de7f1c$var$e6, y = $d7238066c5de7f1c$var$t6, G = 9, Z = 5;
                else if (V == 2) {
                    var K = $d7238066c5de7f1c$var$Yl(r, d, 31) + 257, z = $d7238066c5de7f1c$var$Yl(r, d + 10, 15) + 4, M = K + $d7238066c5de7f1c$var$Yl(r, d + 5, 31) + 1;
                    d += 14;
                    for(var _ = new $d7238066c5de7f1c$var$Qg(M), O = new $d7238066c5de7f1c$var$Qg(19), ie = 0; ie < z; ++ie)O[$d7238066c5de7f1c$var$O7[ie]] = $d7238066c5de7f1c$var$Yl(r, d + ie * 3, 7);
                    d += z * 3;
                    for(var he = $d7238066c5de7f1c$var$KW(O), pe = (1 << he) - 1, ce = $d7238066c5de7f1c$var$Ly(O, he, 1), ie = 0; ie < M;){
                        var $ = ce[$d7238066c5de7f1c$var$Yl(r, d, pe)];
                        d += $ & 15;
                        var H = $ >> 4;
                        if (H < 16) _[ie++] = H;
                        else {
                            var te = 0, Ge = 0;
                            for(H == 16 ? (Ge = 3 + $d7238066c5de7f1c$var$Yl(r, d, 3), d += 2, te = _[ie - 1]) : H == 17 ? (Ge = 3 + $d7238066c5de7f1c$var$Yl(r, d, 7), d += 3) : H == 18 && (Ge = 11 + $d7238066c5de7f1c$var$Yl(r, d, 127), d += 7); Ge--;)_[ie++] = te;
                        }
                    }
                    var q = _.subarray(0, K), de = _.subarray(K);
                    G = $d7238066c5de7f1c$var$KW(q), Z = $d7238066c5de7f1c$var$KW(de), A = $d7238066c5de7f1c$var$Ly(q, G, 1), y = $d7238066c5de7f1c$var$Ly(de, Z, 1);
                } else $d7238066c5de7f1c$var$Jl(1);
            } else {
                var H = $d7238066c5de7f1c$var$i6(d) + 4, N = r[H - 4] | r[H - 3] << 8, Y = H + N;
                if (Y > n) {
                    g && $d7238066c5de7f1c$var$Jl(0);
                    break;
                }
                o && l(p + N), t.set(r.subarray(H, Y), p), e.b = p += N, e.p = d = Y * 8, e.f = c;
                continue;
            }
            if (d > v) {
                g && $d7238066c5de7f1c$var$Jl(0);
                break;
            }
        }
        o && l(p + 131072);
        for(var ge = (1 << G) - 1, Ye = (1 << Z) - 1, Fe = d;; Fe = d){
            var te = A[$d7238066c5de7f1c$var$xW(r, d) & ge], Xe = te >> 4;
            if (d += te & 15, d > v) {
                g && $d7238066c5de7f1c$var$Jl(0);
                break;
            }
            if (te || $d7238066c5de7f1c$var$Jl(2), Xe < 256) t[p++] = Xe;
            else if (Xe == 256) {
                Fe = d, A = null;
                break;
            } else {
                var Te = Xe - 254;
                if (Xe > 264) {
                    var ie = Xe - 257, ct = $d7238066c5de7f1c$var$Bk[ie];
                    Te = $d7238066c5de7f1c$var$Yl(r, d, (1 << ct) - 1) + $d7238066c5de7f1c$var$Sk[ie], d += ct;
                }
                var st = y[$d7238066c5de7f1c$var$xW(r, d) & Ye], Xt = st >> 4;
                st || $d7238066c5de7f1c$var$Jl(3), d += st & 15;
                var de = $d7238066c5de7f1c$var$$7[Xt];
                if (Xt > 3) {
                    var ct = $d7238066c5de7f1c$var$fk[Xt];
                    de += $d7238066c5de7f1c$var$xW(r, d) & (1 << ct) - 1, d += ct;
                }
                if (d > v) {
                    g && $d7238066c5de7f1c$var$Jl(0);
                    break;
                }
                o && l(p + 131072);
                var Mi = p + Te;
                if (p < de) {
                    var Jn = s - de, Un = Math.min(de, Mi);
                    for(Jn + p < 0 && $d7238066c5de7f1c$var$Jl(3); p < Un; ++p)t[p] = i[Jn + p];
                }
                for(; p < Mi; ++p)t[p] = t[p - de];
            }
        }
        e.l = A, e.p = Fe, e.b = p, e.f = c, A && (c = 1, e.m = G, e.d = y, e.n = Z);
    }while (!c);
    return p != t.length && a ? $d7238066c5de7f1c$var$n6(t, 0, p) : t.subarray(0, p);
}, $d7238066c5de7f1c$var$a6 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Qg(0), $d7238066c5de7f1c$var$o6 = function(r, e) {
    return ((r[0] & 15) != 8 || r[0] >> 4 > 7 || (r[0] << 8 | r[1]) % 31) && $d7238066c5de7f1c$var$Jl(6, "invalid zlib data"), (r[1] >> 5 & 1) == 1 && $d7238066c5de7f1c$var$Jl(6, "invalid zlib data: " + (r[1] & 32 ? "need" : "unexpected") + " dictionary"), (r[1] >> 3 & 4) + 2;
};
function $d7238066c5de7f1c$var$g6(r, e) {
    return $d7238066c5de7f1c$var$r6(r.subarray($d7238066c5de7f1c$var$o6(r), -4), {
        i: 2
    }, e, e);
}
var $d7238066c5de7f1c$var$l6 = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), $d7238066c5de7f1c$var$c6 = 0;
try {
    $d7238066c5de7f1c$var$l6.decode($d7238066c5de7f1c$var$a6, {
        stream: !0
    }), $d7238066c5de7f1c$var$c6 = 1;
} catch  {}
function $d7238066c5de7f1c$var$Rk(r, e, t) {
    const i = t.length - r - 1;
    if (e >= t[i]) return i - 1;
    if (e <= t[r]) return r;
    let n = r, s = i, a = Math.floor((n + s) / 2);
    for(; e < t[a] || e >= t[a + 1];)e < t[a] ? s = a : n = a, a = Math.floor((n + s) / 2);
    return a;
}
function $d7238066c5de7f1c$var$u6(r, e, t, i) {
    const n = [], s = [], a = [];
    n[0] = 1;
    for(let o = 1; o <= t; ++o){
        s[o] = e - i[r + 1 - o], a[o] = i[r + o] - e;
        let g = 0;
        for(let l = 0; l < o; ++l){
            const c = a[l + 1], d = s[o - l], p = n[l] / (c + d);
            n[l] = g + c * p, g = d * p;
        }
        n[o] = g;
    }
    return n;
}
function $d7238066c5de7f1c$var$I6(r, e, t, i) {
    const n = $d7238066c5de7f1c$var$Rk(r, i, e), s = $d7238066c5de7f1c$var$u6(n, i, r, e), a = new (0, $329ek.Vector4)(0, 0, 0, 0);
    for(let o = 0; o <= r; ++o){
        const g = t[n - r + o], l = s[o], c = g.w * l;
        a.x += g.x * c, a.y += g.y * c, a.z += g.z * c, a.w += g.w * l;
    }
    return a;
}
function $d7238066c5de7f1c$var$d6(r, e, t, i, n) {
    const s = [];
    for(let d = 0; d <= t; ++d)s[d] = 0;
    const a = [];
    for(let d = 0; d <= i; ++d)a[d] = s.slice(0);
    const o = [];
    for(let d = 0; d <= t; ++d)o[d] = s.slice(0);
    o[0][0] = 1;
    const g = s.slice(0), l = s.slice(0);
    for(let d = 1; d <= t; ++d){
        g[d] = e - n[r + 1 - d], l[d] = n[r + d] - e;
        let p = 0;
        for(let A = 0; A < d; ++A){
            const y = l[A + 1], G = g[d - A];
            o[d][A] = y + G;
            const Z = o[A][d - 1] / o[d][A];
            o[A][d] = p + y * Z, p = G * Z;
        }
        o[d][d] = p;
    }
    for(let d = 0; d <= t; ++d)a[0][d] = o[d][t];
    for(let d = 0; d <= t; ++d){
        let p = 0, A = 1;
        const y = [];
        for(let G = 0; G <= t; ++G)y[G] = s.slice(0);
        y[0][0] = 1;
        for(let G = 1; G <= i; ++G){
            let Z = 0;
            const v = d - G, V = t - G;
            d >= G && (y[A][0] = y[p][0] / o[V + 1][v], Z = y[A][0] * o[v][V]);
            const H = v >= -1 ? 1 : -v, N = d - 1 <= V ? G - 1 : t - d;
            for(let K = H; K <= N; ++K)y[A][K] = (y[p][K] - y[p][K - 1]) / o[V + 1][v + K], Z += y[A][K] * o[v + K][V];
            d <= V && (y[A][G] = -y[p][G - 1] / o[V + 1][d], Z += y[A][G] * o[d][V]), a[G][d] = Z;
            const Y = p;
            p = A, A = Y;
        }
    }
    let c = t;
    for(let d = 1; d <= i; ++d){
        for(let p = 0; p <= t; ++p)a[d][p] *= c;
        c *= t - d;
    }
    return a;
}
function $d7238066c5de7f1c$var$h6(r, e, t, i, n) {
    const s = n < r ? n : r, a = [], o = $d7238066c5de7f1c$var$Rk(r, i, e), g = $d7238066c5de7f1c$var$d6(o, i, r, s, e), l = [];
    for(let c = 0; c < t.length; ++c){
        const d = t[c].clone(), p = d.w;
        d.x *= p, d.y *= p, d.z *= p, l[c] = d;
    }
    for(let c = 0; c <= s; ++c){
        const d = l[o - r].clone().multiplyScalar(g[c][0]);
        for(let p = 1; p <= r; ++p)d.add(l[o - r + p].clone().multiplyScalar(g[c][p]));
        a[c] = d;
    }
    for(let c = s + 1; c <= n + 1; ++c)a[c] = new (0, $329ek.Vector4)(0, 0, 0);
    return a;
}
function $d7238066c5de7f1c$var$C6(r, e) {
    let t = 1;
    for(let n = 2; n <= r; ++n)t *= n;
    let i = 1;
    for(let n = 2; n <= e; ++n)i *= n;
    for(let n = 2; n <= r - e; ++n)i *= n;
    return t / i;
}
function $d7238066c5de7f1c$var$p6(r) {
    const e = r.length, t = [], i = [];
    for(let s = 0; s < e; ++s){
        const a = r[s];
        t[s] = new (0, $329ek.Vector3)(a.x, a.y, a.z), i[s] = a.w;
    }
    const n = [];
    for(let s = 0; s < e; ++s){
        const a = t[s].clone();
        for(let o = 1; o <= s; ++o)a.sub(n[s - o].clone().multiplyScalar($d7238066c5de7f1c$var$C6(s, o) * i[o]));
        n[s] = a.divideScalar(i[0]);
    }
    return n;
}
function $d7238066c5de7f1c$var$m6(r, e, t, i, n) {
    const s = $d7238066c5de7f1c$var$h6(r, e, t, i, n);
    return $d7238066c5de7f1c$var$p6(s);
}
class $d7238066c5de7f1c$var$A6 extends (0, $329ek.Curve) {
    /**
   * Constructs a new NURBS curve.
   *
   * @param {number} degree - The NURBS degree.
   * @param {Array<number>} knots - The knots as a flat array of numbers.
   * @param {Array<Vector2|Vector3|Vector4>} controlPoints - An array holding control points.
   * @param {number} [startKnot] - Index of the start knot into the `knots` array.
   * @param {number} [endKnot] - Index of the end knot into the `knots` array.
   */ constructor(e, t, i, n, s){
        super();
        const a = t ? t.length - 1 : 0, o = i ? i.length : 0;
        this.degree = e, this.knots = t, this.controlPoints = [], this.startKnot = n || 0, this.endKnot = s || a;
        for(let g = 0; g < o; ++g){
            const l = i[g];
            this.controlPoints[g] = new (0, $329ek.Vector4)(l.x, l.y, l.z, l.w);
        }
    }
    /**
   * This method returns a vector in 3D space for the given interpolation factor.
   *
   * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
   * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
   * @return {Vector3} The position on the curve.
   */ getPoint(e, t = new (0, $329ek.Vector3)()) {
        const i = t, n = this.knots[this.startKnot] + e * (this.knots[this.endKnot] - this.knots[this.startKnot]), s = $d7238066c5de7f1c$var$I6(this.degree, this.knots, this.controlPoints, n);
        return s.w !== 1 && s.divideScalar(s.w), i.set(s.x, s.y, s.z);
    }
    /**
   * Returns a unit vector tangent for the given interpolation factor.
   *
   * @param {number} t - The interpolation factor.
   * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
   * @return {Vector3} The tangent vector.
   */ getTangent(e, t = new (0, $329ek.Vector3)()) {
        const i = t, n = this.knots[0] + e * (this.knots[this.knots.length - 1] - this.knots[0]), s = $d7238066c5de7f1c$var$m6(this.degree, this.knots, this.controlPoints, n, 1);
        return i.copy(s[1]).normalize(), i;
    }
    toJSON() {
        const e = super.toJSON();
        return e.degree = this.degree, e.knots = [
            ...this.knots
        ], e.controlPoints = this.controlPoints.map((t)=>t.toArray()), e.startKnot = this.startKnot, e.endKnot = this.endKnot, e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.degree = e.degree, this.knots = [
            ...e.knots
        ], this.controlPoints = e.controlPoints.map((t)=>new (0, $329ek.Vector4)(t[0], t[1], t[2], t[3])), this.startKnot = e.startKnot, this.endKnot = e.endKnot, this;
    }
}
let $d7238066c5de7f1c$var$Ri, $d7238066c5de7f1c$var$Us, $d7238066c5de7f1c$var$$a;
class $d7238066c5de7f1c$var$Vk extends (0, $329ek.Loader) {
    /**
   * Constructs a new FBX loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(e){
        super(e);
    }
    /**
   * Starts loading from the given URL and passes the loaded FBX asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Group)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ load(e, t, i, n) {
        const s = this, a = s.path === "" ? (0, $329ek.LoaderUtils).extractUrlBase(e) : s.path, o = new (0, $329ek.FileLoader)(this.manager);
        o.setPath(s.path), o.setResponseType("arraybuffer"), o.setRequestHeader(s.requestHeader), o.setWithCredentials(s.withCredentials), o.load(e, function(g) {
            try {
                t(s.parse(g, a));
            } catch (l) {
                n ? n(l) : console.error(l), s.manager.itemError(e);
            }
        }, i, n);
    }
    /**
   * Parses the given FBX data and returns the resulting group.
   *
   * @param {ArrayBuffer} FBXBuffer - The raw FBX data as an array buffer.
   * @param {string} path - The URL base path.
   * @return {Group} An object representing the parsed asset.
   */ parse(e, t) {
        if ($d7238066c5de7f1c$var$v6(e)) $d7238066c5de7f1c$var$Ri = new $d7238066c5de7f1c$var$G6().parse(e);
        else {
            const n = $d7238066c5de7f1c$var$Hk(e);
            if (!$d7238066c5de7f1c$var$S6(n)) throw new Error("THREE.FBXLoader: Unknown format.");
            if ($d7238066c5de7f1c$var$p5(n) < 7e3) throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + $d7238066c5de7f1c$var$p5(n));
            $d7238066c5de7f1c$var$Ri = new $d7238066c5de7f1c$var$f6().parse(n);
        }
        const i = new (0, $329ek.TextureLoader)(this.manager).setPath(this.resourcePath || t).setCrossOrigin(this.crossOrigin);
        return new $d7238066c5de7f1c$var$b6(i, this.manager).parse($d7238066c5de7f1c$var$Ri);
    }
}
class $d7238066c5de7f1c$var$b6 {
    constructor(e, t){
        this.textureLoader = e, this.manager = t;
    }
    parse() {
        $d7238066c5de7f1c$var$Us = this.parseConnections();
        const e = this.parseImages(), t = this.parseTextures(e), i = this.parseMaterials(t), n = this.parseDeformers(), s = new $d7238066c5de7f1c$var$y6().parse(n);
        return this.parseScene(n, s, i), $d7238066c5de7f1c$var$$a;
    }
    // Parses FBXTree.Connections which holds parent-child connections between objects (e.g. material -> texture, model->geometry )
    // and details the connection type
    parseConnections() {
        const e = /* @__PURE__ */ new Map();
        return "Connections" in $d7238066c5de7f1c$var$Ri && $d7238066c5de7f1c$var$Ri.Connections.connections.forEach(function(i) {
            const n = i[0], s = i[1], a = i[2];
            e.has(n) || e.set(n, {
                parents: [],
                children: []
            });
            const o = {
                ID: s,
                relationship: a
            };
            e.get(n).parents.push(o), e.has(s) || e.set(s, {
                parents: [],
                children: []
            });
            const g = {
                ID: n,
                relationship: a
            };
            e.get(s).children.push(g);
        }), e;
    }
    // Parse FBXTree.Objects.Video for embedded image data
    // These images are connected to textures in FBXTree.Objects.Textures
    // via FBXTree.Connections.
    parseImages() {
        const e = {}, t = {};
        if ("Video" in $d7238066c5de7f1c$var$Ri.Objects) {
            const i = $d7238066c5de7f1c$var$Ri.Objects.Video;
            for(const n in i){
                const s = i[n], a = parseInt(n);
                if (e[a] = s.RelativeFilename || s.Filename, "Content" in s) {
                    const o = s.Content instanceof ArrayBuffer && s.Content.byteLength > 0, g = typeof s.Content == "string" && s.Content !== "";
                    if (o || g) {
                        const l = this.parseImage(i[n]);
                        t[s.RelativeFilename || s.Filename] = l;
                    }
                }
            }
        }
        for(const i in e){
            const n = e[i];
            t[n] !== void 0 ? e[i] = t[n] : e[i] = e[i].split("\\").pop();
        }
        return e;
    }
    // Parse embedded image data in FBXTree.Video.Content
    parseImage(e) {
        const t = e.Content, i = e.RelativeFilename || e.Filename, n = i.slice(i.lastIndexOf(".") + 1).toLowerCase();
        let s;
        switch(n){
            case "bmp":
                s = "image/bmp";
                break;
            case "jpg":
            case "jpeg":
                s = "image/jpeg";
                break;
            case "png":
                s = "image/png";
                break;
            case "tif":
                s = "image/tiff";
                break;
            case "tga":
                this.manager.getHandler(".tga") === null && console.warn("FBXLoader: TGA loader not found, skipping ", i), s = "image/tga";
                break;
            case "webp":
                s = "image/webp";
                break;
            default:
                console.warn('FBXLoader: Image type "' + n + '" is not supported.');
                return;
        }
        if (typeof t == "string") return "data:" + s + ";base64," + t;
        {
            const a = new Uint8Array(t);
            return window.URL.createObjectURL(new Blob([
                a
            ], {
                type: s
            }));
        }
    }
    // Parse nodes in FBXTree.Objects.Texture
    // These contain details such as UV scaling, cropping, rotation etc and are connected
    // to images in FBXTree.Objects.Video
    parseTextures(e) {
        const t = /* @__PURE__ */ new Map();
        if ("Texture" in $d7238066c5de7f1c$var$Ri.Objects) {
            const i = $d7238066c5de7f1c$var$Ri.Objects.Texture;
            for(const n in i){
                const s = this.parseTexture(i[n], e);
                t.set(parseInt(n), s);
            }
        }
        return t;
    }
    // Parse individual node in FBXTree.Objects.Texture
    parseTexture(e, t) {
        const i = this.loadTexture(e, t);
        i.ID = e.id, i.name = e.attrName;
        const n = e.WrapModeU, s = e.WrapModeV, a = n !== void 0 ? n.value : 0, o = s !== void 0 ? s.value : 0;
        if (i.wrapS = a === 0 ? (0, $329ek.RepeatWrapping) : (0, $329ek.ClampToEdgeWrapping), i.wrapT = o === 0 ? (0, $329ek.RepeatWrapping) : (0, $329ek.ClampToEdgeWrapping), "Scaling" in e) {
            const g = e.Scaling.value;
            i.repeat.x = g[0], i.repeat.y = g[1];
        }
        if ("Translation" in e) {
            const g = e.Translation.value;
            i.offset.x = g[0], i.offset.y = g[1];
        }
        return i;
    }
    // load a texture specified as a blob or data URI, or via an external URL using TextureLoader
    loadTexture(e, t) {
        const i = e.FileName.split(".").pop().toLowerCase();
        let n = this.manager.getHandler(`.${i}`);
        n === null && (n = this.textureLoader);
        const s = n.path;
        s || n.setPath(this.textureLoader.path);
        const a = $d7238066c5de7f1c$var$Us.get(e.id).children;
        let o;
        if (a !== void 0 && a.length > 0 && t[a[0].ID] !== void 0 && (o = t[a[0].ID], (o.indexOf("blob:") === 0 || o.indexOf("data:") === 0) && n.setPath(void 0)), o === void 0) return console.warn("FBXLoader: Undefined filename, creating placeholder texture."), new (0, $329ek.Texture)();
        const g = n.load(o);
        return n.setPath(s), g;
    }
    // Parse nodes in FBXTree.Objects.Material
    parseMaterials(e) {
        const t = /* @__PURE__ */ new Map();
        if ("Material" in $d7238066c5de7f1c$var$Ri.Objects) {
            const i = $d7238066c5de7f1c$var$Ri.Objects.Material;
            for(const n in i){
                const s = this.parseMaterial(i[n], e);
                s !== null && t.set(parseInt(n), s);
            }
        }
        return t;
    }
    // Parse single node in FBXTree.Objects.Material
    // Materials are connected to texture maps in FBXTree.Objects.Textures
    // FBX format currently only supports Lambert and Phong shading models
    parseMaterial(e, t) {
        const i = e.id, n = e.attrName;
        let s = e.ShadingModel;
        if (typeof s == "object" && (s = s.value), !$d7238066c5de7f1c$var$Us.has(i)) return null;
        const a = this.parseParameters(e, t, i);
        let o;
        switch(s.toLowerCase()){
            case "phong":
                o = new (0, $329ek.MeshPhongMaterial)();
                break;
            case "lambert":
                o = new (0, $329ek.MeshLambertMaterial)();
                break;
            default:
                console.warn('THREE.FBXLoader: unknown material type "%s". Defaulting to MeshPhongMaterial.', s), o = new (0, $329ek.MeshPhongMaterial)();
                break;
        }
        return o.setValues(a), o.name = n, o;
    }
    // Parse FBX material and return parameters suitable for a three.js material
    // Also parse the texture map and return any textures associated with the material
    parseParameters(e, t, i) {
        const n = {};
        e.BumpFactor && (n.bumpScale = e.BumpFactor.value), e.Diffuse ? n.color = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(e.Diffuse.value), (0, $329ek.SRGBColorSpace)) : e.DiffuseColor && (e.DiffuseColor.type === "Color" || e.DiffuseColor.type === "ColorRGB") && (n.color = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(e.DiffuseColor.value), (0, $329ek.SRGBColorSpace))), e.DisplacementFactor && (n.displacementScale = e.DisplacementFactor.value), e.Emissive ? n.emissive = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(e.Emissive.value), (0, $329ek.SRGBColorSpace)) : e.EmissiveColor && (e.EmissiveColor.type === "Color" || e.EmissiveColor.type === "ColorRGB") && (n.emissive = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(e.EmissiveColor.value), (0, $329ek.SRGBColorSpace))), e.EmissiveFactor && (n.emissiveIntensity = parseFloat(e.EmissiveFactor.value)), n.opacity = 1 - (e.TransparencyFactor ? parseFloat(e.TransparencyFactor.value) : 0), (n.opacity === 1 || n.opacity === 0) && (n.opacity = e.Opacity ? parseFloat(e.Opacity.value) : null, n.opacity === null && (n.opacity = 1 - (e.TransparentColor ? parseFloat(e.TransparentColor.value[0]) : 0))), n.opacity < 1 && (n.transparent = !0), e.ReflectionFactor && (n.reflectivity = e.ReflectionFactor.value), e.Shininess && (n.shininess = e.Shininess.value), e.Specular ? n.specular = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(e.Specular.value), (0, $329ek.SRGBColorSpace)) : e.SpecularColor && e.SpecularColor.type === "Color" && (n.specular = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(e.SpecularColor.value), (0, $329ek.SRGBColorSpace)));
        const s = this;
        return $d7238066c5de7f1c$var$Us.get(i).children.forEach(function(a) {
            const o = a.relationship;
            switch(o){
                case "Bump":
                    n.bumpMap = s.getTexture(t, a.ID);
                    break;
                case "Maya|TEX_ao_map":
                    n.aoMap = s.getTexture(t, a.ID);
                    break;
                case "DiffuseColor":
                case "Maya|TEX_color_map":
                    n.map = s.getTexture(t, a.ID), n.map !== void 0 && (n.map.colorSpace = (0, $329ek.SRGBColorSpace));
                    break;
                case "DisplacementColor":
                    n.displacementMap = s.getTexture(t, a.ID);
                    break;
                case "EmissiveColor":
                    n.emissiveMap = s.getTexture(t, a.ID), n.emissiveMap !== void 0 && (n.emissiveMap.colorSpace = (0, $329ek.SRGBColorSpace));
                    break;
                case "NormalMap":
                case "Maya|TEX_normal_map":
                    n.normalMap = s.getTexture(t, a.ID);
                    break;
                case "ReflectionColor":
                    n.envMap = s.getTexture(t, a.ID), n.envMap !== void 0 && (n.envMap.mapping = (0, $329ek.EquirectangularReflectionMapping), n.envMap.colorSpace = (0, $329ek.SRGBColorSpace));
                    break;
                case "SpecularColor":
                    n.specularMap = s.getTexture(t, a.ID), n.specularMap !== void 0 && (n.specularMap.colorSpace = (0, $329ek.SRGBColorSpace));
                    break;
                case "TransparentColor":
                case "TransparencyFactor":
                    n.alphaMap = s.getTexture(t, a.ID), n.transparent = !0;
                    break;
                case "AmbientColor":
                case "ShininessExponent":
                case "SpecularFactor":
                case "VectorDisplacementColor":
                default:
                    console.warn("THREE.FBXLoader: %s map is not supported in three.js, skipping texture.", o);
                    break;
            }
        }), n;
    }
    // get a texture from the textureMap for use by a material.
    getTexture(e, t) {
        return "LayeredTexture" in $d7238066c5de7f1c$var$Ri.Objects && t in $d7238066c5de7f1c$var$Ri.Objects.LayeredTexture && (console.warn("THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer."), t = $d7238066c5de7f1c$var$Us.get(t).children[0].ID), e.get(t);
    }
    // Parse nodes in FBXTree.Objects.Deformer
    // Deformer node can contain skinning or Vertex Cache animation data, however only skinning is supported here
    // Generates map of Skeleton-like objects for use later when generating and binding skeletons.
    parseDeformers() {
        const e = {}, t = {};
        if ("Deformer" in $d7238066c5de7f1c$var$Ri.Objects) {
            const i = $d7238066c5de7f1c$var$Ri.Objects.Deformer;
            for(const n in i){
                const s = i[n], a = $d7238066c5de7f1c$var$Us.get(parseInt(n));
                if (s.attrType === "Skin") {
                    const o = this.parseSkeleton(a, i);
                    o.ID = n, a.parents.length > 1 && console.warn("THREE.FBXLoader: skeleton attached to more than one geometry is not supported."), o.geometryID = a.parents[0].ID, e[n] = o;
                } else if (s.attrType === "BlendShape") {
                    const o = {
                        id: n
                    };
                    o.rawTargets = this.parseMorphTargets(a, i), o.id = n, a.parents.length > 1 && console.warn("THREE.FBXLoader: morph target attached to more than one geometry is not supported."), t[n] = o;
                }
            }
        }
        return {
            skeletons: e,
            morphTargets: t
        };
    }
    // Parse single nodes in FBXTree.Objects.Deformer
    // The top level skeleton node has type 'Skin' and sub nodes have type 'Cluster'
    // Each skin node represents a skeleton and each cluster node represents a bone
    parseSkeleton(e, t) {
        const i = [];
        return e.children.forEach(function(n) {
            const s = t[n.ID];
            if (s.attrType !== "Cluster") return;
            const a = {
                ID: n.ID,
                indices: [],
                weights: [],
                transformLink: new (0, $329ek.Matrix4)().fromArray(s.TransformLink.a)
            };
            "Indexes" in s && (a.indices = s.Indexes.a, a.weights = s.Weights.a), i.push(a);
        }), {
            rawBones: i,
            bones: []
        };
    }
    // The top level morph deformer node has type "BlendShape" and sub nodes have type "BlendShapeChannel"
    parseMorphTargets(e, t) {
        const i = [];
        for(let n = 0; n < e.children.length; n++){
            const s = e.children[n], a = t[s.ID], o = {
                name: a.attrName,
                initialWeight: a.DeformPercent,
                id: a.id,
                fullWeights: a.FullWeights.a
            };
            if (a.attrType !== "BlendShapeChannel") return;
            o.geoID = $d7238066c5de7f1c$var$Us.get(parseInt(s.ID)).children.filter(function(g) {
                return g.relationship === void 0;
            })[0].ID, i.push(o);
        }
        return i;
    }
    // create the main Group() to be returned by the loader
    parseScene(e, t, i) {
        $d7238066c5de7f1c$var$$a = new (0, $329ek.Group)();
        const n = this.parseModels(e.skeletons, t, i), s = $d7238066c5de7f1c$var$Ri.Objects.Model, a = this;
        n.forEach(function(g) {
            const l = s[g.ID];
            a.setLookAtProperties(g, l), $d7238066c5de7f1c$var$Us.get(g.ID).parents.forEach(function(d) {
                const p = n.get(d.ID);
                p !== void 0 && p.add(g);
            }), g.parent === null && $d7238066c5de7f1c$var$$a.add(g);
        }), this.bindSkeleton(e.skeletons, t, n), this.addGlobalSceneSettings(), $d7238066c5de7f1c$var$$a.traverse(function(g) {
            if (g.userData.transformData) {
                g.parent && (g.userData.transformData.parentMatrix = g.parent.matrix, g.userData.transformData.parentMatrixWorld = g.parent.matrixWorld);
                const l = $d7238066c5de7f1c$var$Wk(g.userData.transformData);
                g.applyMatrix4(l), g.updateWorldMatrix();
            }
        });
        const o = new $d7238066c5de7f1c$var$B6().parse();
        $d7238066c5de7f1c$var$$a.children.length === 1 && $d7238066c5de7f1c$var$$a.children[0].isGroup && ($d7238066c5de7f1c$var$$a.children[0].animations = o, $d7238066c5de7f1c$var$$a = $d7238066c5de7f1c$var$$a.children[0]), $d7238066c5de7f1c$var$$a.animations = o;
    }
    // parse nodes in FBXTree.Objects.Model
    parseModels(e, t, i) {
        const n = /* @__PURE__ */ new Map(), s = $d7238066c5de7f1c$var$Ri.Objects.Model;
        for(const a in s){
            const o = parseInt(a), g = s[a], l = $d7238066c5de7f1c$var$Us.get(o);
            let c = this.buildSkeleton(l, e, o, g.attrName);
            if (!c) {
                switch(g.attrType){
                    case "Camera":
                        c = this.createCamera(l);
                        break;
                    case "Light":
                        c = this.createLight(l);
                        break;
                    case "Mesh":
                        c = this.createMesh(l, t, i);
                        break;
                    case "NurbsCurve":
                        c = this.createCurve(l, t);
                        break;
                    case "LimbNode":
                    case "Root":
                        c = new (0, $329ek.Bone)();
                        break;
                    case "Null":
                    default:
                        c = new (0, $329ek.Group)();
                        break;
                }
                c.name = g.attrName ? (0, $329ek.PropertyBinding).sanitizeNodeName(g.attrName) : "", c.userData.originalName = g.attrName, c.ID = o;
            }
            this.getTransformData(c, g), n.set(o, c);
        }
        return n;
    }
    buildSkeleton(e, t, i, n) {
        let s = null;
        return e.parents.forEach(function(a) {
            for(const o in t){
                const g = t[o];
                g.rawBones.forEach(function(l, c) {
                    if (l.ID === a.ID) {
                        const d = s;
                        s = new (0, $329ek.Bone)(), s.matrixWorld.copy(l.transformLink), s.name = n ? (0, $329ek.PropertyBinding).sanitizeNodeName(n) : "", s.userData.originalName = n, s.ID = i, g.bones[c] = s, d !== null && s.add(d);
                    }
                });
            }
        }), s;
    }
    // create a PerspectiveCamera or OrthographicCamera
    createCamera(e) {
        let t, i;
        if (e.children.forEach(function(n) {
            const s = $d7238066c5de7f1c$var$Ri.Objects.NodeAttribute[n.ID];
            s !== void 0 && (i = s);
        }), i === void 0) t = new (0, $329ek.Object3D)();
        else {
            let n = 0;
            i.CameraProjectionType !== void 0 && i.CameraProjectionType.value === 1 && (n = 1);
            let s = 1;
            i.NearPlane !== void 0 && (s = i.NearPlane.value / 1e3);
            let a = 1e3;
            i.FarPlane !== void 0 && (a = i.FarPlane.value / 1e3);
            let o = window.innerWidth, g = window.innerHeight;
            i.AspectWidth !== void 0 && i.AspectHeight !== void 0 && (o = i.AspectWidth.value, g = i.AspectHeight.value);
            const l = o / g;
            let c = 45;
            i.FieldOfView !== void 0 && (c = i.FieldOfView.value);
            const d = i.FocalLength ? i.FocalLength.value : null;
            switch(n){
                case 0:
                    t = new (0, $329ek.PerspectiveCamera)(c, l, s, a), d !== null && t.setFocalLength(d);
                    break;
                case 1:
                    console.warn("THREE.FBXLoader: Orthographic cameras not supported yet."), t = new (0, $329ek.Object3D)();
                    break;
                default:
                    console.warn("THREE.FBXLoader: Unknown camera type " + n + "."), t = new (0, $329ek.Object3D)();
                    break;
            }
        }
        return t;
    }
    // Create a DirectionalLight, PointLight or SpotLight
    createLight(e) {
        let t, i;
        if (e.children.forEach(function(n) {
            const s = $d7238066c5de7f1c$var$Ri.Objects.NodeAttribute[n.ID];
            s !== void 0 && (i = s);
        }), i === void 0) t = new (0, $329ek.Object3D)();
        else {
            let n;
            i.LightType === void 0 ? n = 0 : n = i.LightType.value;
            let s = 16777215;
            i.Color !== void 0 && (s = (0, $329ek.ColorManagement).colorSpaceToWorking(new (0, $329ek.Color)().fromArray(i.Color.value), (0, $329ek.SRGBColorSpace)));
            let a = i.Intensity === void 0 ? 1 : i.Intensity.value / 100;
            i.CastLightOnObject !== void 0 && i.CastLightOnObject.value === 0 && (a = 0);
            let o = 0;
            i.FarAttenuationEnd !== void 0 && (i.EnableFarAttenuation !== void 0 && i.EnableFarAttenuation.value === 0 ? o = 0 : o = i.FarAttenuationEnd.value);
            const g = 1;
            switch(n){
                case 0:
                    t = new (0, $329ek.PointLight)(s, a, o, g);
                    break;
                case 1:
                    t = new (0, $329ek.DirectionalLight)(s, a);
                    break;
                case 2:
                    let l = Math.PI / 3;
                    i.InnerAngle !== void 0 && (l = (0, $329ek.MathUtils).degToRad(i.InnerAngle.value));
                    let c = 0;
                    i.OuterAngle !== void 0 && (c = (0, $329ek.MathUtils).degToRad(i.OuterAngle.value), c = Math.max(c, 1)), t = new (0, $329ek.SpotLight)(s, a, o, l, c, g);
                    break;
                default:
                    console.warn("THREE.FBXLoader: Unknown light type " + i.LightType.value + ", defaulting to a PointLight."), t = new (0, $329ek.PointLight)(s, a);
                    break;
            }
            i.CastShadows !== void 0 && i.CastShadows.value === 1 && (t.castShadow = !0);
        }
        return t;
    }
    createMesh(e, t, i) {
        let n, s = null, a = null;
        const o = [];
        if (e.children.forEach(function(g) {
            t.has(g.ID) && (s = t.get(g.ID)), i.has(g.ID) && o.push(i.get(g.ID));
        }), o.length > 1 ? a = o : o.length > 0 ? a = o[0] : (a = new (0, $329ek.MeshPhongMaterial)({
            name: (0, $329ek.Loader).DEFAULT_MATERIAL_NAME,
            color: 13421772
        }), o.push(a)), "color" in s.attributes && o.forEach(function(g) {
            g.vertexColors = !0;
        }), s.groups.length > 0) {
            let g = !1;
            for(let l = 0, c = s.groups.length; l < c; l++){
                const d = s.groups[l];
                (d.materialIndex < 0 || d.materialIndex >= o.length) && (d.materialIndex = o.length, g = !0);
            }
            if (g) {
                const l = new (0, $329ek.MeshPhongMaterial)();
                o.push(l);
            }
        }
        return s.FBX_Deformer ? (n = new (0, $329ek.SkinnedMesh)(s, a), n.normalizeSkinWeights()) : n = new (0, $329ek.Mesh)(s, a), n;
    }
    createCurve(e, t) {
        const i = e.children.reduce(function(s, a) {
            return t.has(a.ID) && (s = t.get(a.ID)), s;
        }, null), n = new (0, $329ek.LineBasicMaterial)({
            name: (0, $329ek.Loader).DEFAULT_MATERIAL_NAME,
            color: 3342591,
            linewidth: 1
        });
        return new (0, $329ek.Line)(i, n);
    }
    // parse the model node for transform data
    getTransformData(e, t) {
        const i = {};
        "InheritType" in t && (i.inheritType = parseInt(t.InheritType.value)), "RotationOrder" in t ? i.eulerOrder = $d7238066c5de7f1c$var$oB(t.RotationOrder.value) : i.eulerOrder = $d7238066c5de7f1c$var$oB(0), "Lcl_Translation" in t && (i.translation = t.Lcl_Translation.value), "PreRotation" in t && (i.preRotation = t.PreRotation.value), "Lcl_Rotation" in t && (i.rotation = t.Lcl_Rotation.value), "PostRotation" in t && (i.postRotation = t.PostRotation.value), "Lcl_Scaling" in t && (i.scale = t.Lcl_Scaling.value), "ScalingOffset" in t && (i.scalingOffset = t.ScalingOffset.value), "ScalingPivot" in t && (i.scalingPivot = t.ScalingPivot.value), "RotationOffset" in t && (i.rotationOffset = t.RotationOffset.value), "RotationPivot" in t && (i.rotationPivot = t.RotationPivot.value), e.userData.transformData = i;
    }
    setLookAtProperties(e, t) {
        "LookAtProperty" in t && $d7238066c5de7f1c$var$Us.get(e.ID).children.forEach(function(n) {
            if (n.relationship === "LookAtProperty") {
                const s = $d7238066c5de7f1c$var$Ri.Objects.Model[n.ID];
                if ("Lcl_Translation" in s) {
                    const a = s.Lcl_Translation.value;
                    e.target !== void 0 ? (e.target.position.fromArray(a), $d7238066c5de7f1c$var$$a.add(e.target)) : e.lookAt(new (0, $329ek.Vector3)().fromArray(a));
                }
            }
        });
    }
    bindSkeleton(e, t, i) {
        const n = this.parsePoseNodes();
        for(const s in e){
            const a = e[s];
            $d7238066c5de7f1c$var$Us.get(parseInt(a.ID)).parents.forEach(function(g) {
                if (t.has(g.ID)) {
                    const l = g.ID;
                    $d7238066c5de7f1c$var$Us.get(l).parents.forEach(function(d) {
                        i.has(d.ID) && i.get(d.ID).bind(new (0, $329ek.Skeleton)(a.bones), n[d.ID]);
                    });
                }
            });
        }
    }
    parsePoseNodes() {
        const e = {};
        if ("Pose" in $d7238066c5de7f1c$var$Ri.Objects) {
            const t = $d7238066c5de7f1c$var$Ri.Objects.Pose;
            for(const i in t)if (t[i].attrType === "BindPose" && t[i].NbPoseNodes > 0) {
                const n = t[i].PoseNode;
                Array.isArray(n) ? n.forEach(function(s) {
                    e[s.Node] = new (0, $329ek.Matrix4)().fromArray(s.Matrix.a);
                }) : e[n.Node] = new (0, $329ek.Matrix4)().fromArray(n.Matrix.a);
            }
        }
        return e;
    }
    addGlobalSceneSettings() {
        if ("GlobalSettings" in $d7238066c5de7f1c$var$Ri) {
            if ("AmbientColor" in $d7238066c5de7f1c$var$Ri.GlobalSettings) {
                const e = $d7238066c5de7f1c$var$Ri.GlobalSettings.AmbientColor.value, t = e[0], i = e[1], n = e[2];
                if (t !== 0 || i !== 0 || n !== 0) {
                    const s = new (0, $329ek.Color)().setRGB(t, i, n, (0, $329ek.SRGBColorSpace));
                    $d7238066c5de7f1c$var$$a.add(new (0, $329ek.AmbientLight)(s, 1));
                }
            }
            "UnitScaleFactor" in $d7238066c5de7f1c$var$Ri.GlobalSettings && ($d7238066c5de7f1c$var$$a.userData.unitScaleFactor = $d7238066c5de7f1c$var$Ri.GlobalSettings.UnitScaleFactor.value);
        }
    }
}
class $d7238066c5de7f1c$var$y6 {
    constructor(){
        this.negativeMaterialIndices = !1;
    }
    // Parse nodes in FBXTree.Objects.Geometry
    parse(e) {
        const t = /* @__PURE__ */ new Map();
        if ("Geometry" in $d7238066c5de7f1c$var$Ri.Objects) {
            const i = $d7238066c5de7f1c$var$Ri.Objects.Geometry;
            for(const n in i){
                const s = $d7238066c5de7f1c$var$Us.get(parseInt(n)), a = this.parseGeometry(s, i[n], e);
                t.set(parseInt(n), a);
            }
        }
        return this.negativeMaterialIndices === !0 && console.warn("THREE.FBXLoader: The FBX file contains invalid (negative) material indices. The asset might not render as expected."), t;
    }
    // Parse single node in FBXTree.Objects.Geometry
    parseGeometry(e, t, i) {
        switch(t.attrType){
            case "Mesh":
                return this.parseMeshGeometry(e, t, i);
            case "NurbsCurve":
                return this.parseNurbsGeometry(t);
        }
    }
    // Parse single node mesh geometry in FBXTree.Objects.Geometry
    parseMeshGeometry(e, t, i) {
        const n = i.skeletons, s = [], a = e.parents.map(function(d) {
            return $d7238066c5de7f1c$var$Ri.Objects.Model[d.ID];
        });
        if (a.length === 0) return;
        const o = e.children.reduce(function(d, p) {
            return n[p.ID] !== void 0 && (d = n[p.ID]), d;
        }, null);
        e.children.forEach(function(d) {
            i.morphTargets[d.ID] !== void 0 && s.push(i.morphTargets[d.ID]);
        });
        const g = a[0], l = {};
        "RotationOrder" in g && (l.eulerOrder = $d7238066c5de7f1c$var$oB(g.RotationOrder.value)), "InheritType" in g && (l.inheritType = parseInt(g.InheritType.value)), "GeometricTranslation" in g && (l.translation = g.GeometricTranslation.value), "GeometricRotation" in g && (l.rotation = g.GeometricRotation.value), "GeometricScaling" in g && (l.scale = g.GeometricScaling.value);
        const c = $d7238066c5de7f1c$var$Wk(l);
        return this.genGeometry(t, o, s, c);
    }
    // Generate a BufferGeometry from a node in FBXTree.Objects.Geometry
    genGeometry(e, t, i, n) {
        const s = new (0, $329ek.BufferGeometry)();
        e.attrName && (s.name = e.attrName);
        const a = this.parseGeoNode(e, t), o = this.genBuffers(a), g = new (0, $329ek.Float32BufferAttribute)(o.vertex, 3);
        if (g.applyMatrix4(n), s.setAttribute("position", g), o.colors.length > 0 && s.setAttribute("color", new (0, $329ek.Float32BufferAttribute)(o.colors, 3)), t && (s.setAttribute("skinIndex", new (0, $329ek.Uint16BufferAttribute)(o.weightsIndices, 4)), s.setAttribute("skinWeight", new (0, $329ek.Float32BufferAttribute)(o.vertexWeights, 4)), s.FBX_Deformer = t), o.normal.length > 0) {
            const l = new (0, $329ek.Matrix3)().getNormalMatrix(n), c = new (0, $329ek.Float32BufferAttribute)(o.normal, 3);
            c.applyNormalMatrix(l), s.setAttribute("normal", c);
        }
        if (o.uvs.forEach(function(l, c) {
            const d = c === 0 ? "uv" : `uv${c}`;
            s.setAttribute(d, new (0, $329ek.Float32BufferAttribute)(o.uvs[c], 2));
        }), a.material && a.material.mappingType !== "AllSame") {
            let l = o.materialIndex[0], c = 0;
            if (o.materialIndex.forEach(function(d, p) {
                d !== l && (s.addGroup(c, p - c, l), l = d, c = p);
            }), s.groups.length > 0) {
                const d = s.groups[s.groups.length - 1], p = d.start + d.count;
                p !== o.materialIndex.length && s.addGroup(p, o.materialIndex.length - p, l);
            }
            s.groups.length === 0 && s.addGroup(0, o.materialIndex.length, o.materialIndex[0]);
        }
        return this.addMorphTargets(s, e, i, n), s;
    }
    parseGeoNode(e, t) {
        const i = {};
        if (i.vertexPositions = e.Vertices !== void 0 ? e.Vertices.a : [], i.vertexIndices = e.PolygonVertexIndex !== void 0 ? e.PolygonVertexIndex.a : [], e.LayerElementColor && e.LayerElementColor[0].Colors && (i.color = this.parseVertexColors(e.LayerElementColor[0])), e.LayerElementMaterial && (i.material = this.parseMaterialIndices(e.LayerElementMaterial[0])), e.LayerElementNormal && (i.normal = this.parseNormals(e.LayerElementNormal[0])), e.LayerElementUV) {
            i.uv = [];
            let n = 0;
            for(; e.LayerElementUV[n];)e.LayerElementUV[n].UV && i.uv.push(this.parseUVs(e.LayerElementUV[n])), n++;
        }
        return i.weightTable = {}, t !== null && (i.skeleton = t, t.rawBones.forEach(function(n, s) {
            n.indices.forEach(function(a, o) {
                i.weightTable[a] === void 0 && (i.weightTable[a] = []), i.weightTable[a].push({
                    id: s,
                    weight: n.weights[o]
                });
            });
        })), i;
    }
    genBuffers(e) {
        const t = {
            vertex: [],
            normal: [],
            colors: [],
            uvs: [],
            materialIndex: [],
            vertexWeights: [],
            weightsIndices: []
        };
        let i = 0, n = 0, s = !1, a = [], o = [], g = [], l = [], c = [], d = [];
        const p = this;
        return e.vertexIndices.forEach(function(A, y) {
            let G, Z = !1;
            A < 0 && (A = A ^ -1, Z = !0);
            let v = [], V = [];
            if (a.push(A * 3, A * 3 + 1, A * 3 + 2), e.color) {
                const H = $d7238066c5de7f1c$var$uv(y, i, A, e.color);
                g.push(H[0], H[1], H[2]);
            }
            if (e.skeleton) {
                if (e.weightTable[A] !== void 0 && e.weightTable[A].forEach(function(H) {
                    V.push(H.weight), v.push(H.id);
                }), V.length > 4) {
                    s || (console.warn("THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights."), s = !0);
                    const H = [
                        0,
                        0,
                        0,
                        0
                    ], N = [
                        0,
                        0,
                        0,
                        0
                    ];
                    V.forEach(function(Y, K) {
                        let z = Y, M = v[K];
                        N.forEach(function(_, O, ie) {
                            if (z > _) {
                                ie[O] = z, z = _;
                                const he = H[O];
                                H[O] = M, M = he;
                            }
                        });
                    }), v = H, V = N;
                }
                for(; V.length < 4;)V.push(0), v.push(0);
                for(let H = 0; H < 4; ++H)c.push(V[H]), d.push(v[H]);
            }
            if (e.normal) {
                const H = $d7238066c5de7f1c$var$uv(y, i, A, e.normal);
                o.push(H[0], H[1], H[2]);
            }
            e.material && e.material.mappingType !== "AllSame" && (G = $d7238066c5de7f1c$var$uv(y, i, A, e.material)[0], G < 0 && (p.negativeMaterialIndices = !0, G = 0)), e.uv && e.uv.forEach(function(H, N) {
                const Y = $d7238066c5de7f1c$var$uv(y, i, A, H);
                l[N] === void 0 && (l[N] = []), l[N].push(Y[0]), l[N].push(Y[1]);
            }), n++, Z && (p.genFace(t, e, a, G, o, g, l, c, d, n), i++, n = 0, a = [], o = [], g = [], l = [], c = [], d = []);
        }), t;
    }
    // See https://www.khronos.org/opengl/wiki/Calculating_a_Surface_Normal
    getNormalNewell(e) {
        const t = new (0, $329ek.Vector3)(0, 0, 0);
        for(let i = 0; i < e.length; i++){
            const n = e[i], s = e[(i + 1) % e.length];
            t.x += (n.y - s.y) * (n.z + s.z), t.y += (n.z - s.z) * (n.x + s.x), t.z += (n.x - s.x) * (n.y + s.y);
        }
        return t.normalize(), t;
    }
    getNormalTangentAndBitangent(e) {
        const t = this.getNormalNewell(e), n = (Math.abs(t.z) > 0.5 ? new (0, $329ek.Vector3)(0, 1, 0) : new (0, $329ek.Vector3)(0, 0, 1)).cross(t).normalize(), s = t.clone().cross(n).normalize();
        return {
            normal: t,
            tangent: n,
            bitangent: s
        };
    }
    flattenVertex(e, t, i) {
        return new (0, $329ek.Vector2)(e.dot(t), e.dot(i));
    }
    // Generate data for a single face in a geometry. If the face is a quad then split it into 2 tris
    genFace(e, t, i, n, s, a, o, g, l, c) {
        let d;
        if (c > 3) {
            const p = [], A = t.baseVertexPositions || t.vertexPositions;
            for(let v = 0; v < i.length; v += 3)p.push(new (0, $329ek.Vector3)(A[i[v]], A[i[v + 1]], A[i[v + 2]]));
            const { tangent: y, bitangent: G } = this.getNormalTangentAndBitangent(p), Z = [];
            for (const v of p)Z.push(this.flattenVertex(v, y, G));
            d = (0, $329ek.ShapeUtils).triangulateShape(Z, []);
        } else d = [
            [
                0,
                1,
                2
            ]
        ];
        for (const [p, A, y] of d)e.vertex.push(t.vertexPositions[i[p * 3]]), e.vertex.push(t.vertexPositions[i[p * 3 + 1]]), e.vertex.push(t.vertexPositions[i[p * 3 + 2]]), e.vertex.push(t.vertexPositions[i[A * 3]]), e.vertex.push(t.vertexPositions[i[A * 3 + 1]]), e.vertex.push(t.vertexPositions[i[A * 3 + 2]]), e.vertex.push(t.vertexPositions[i[y * 3]]), e.vertex.push(t.vertexPositions[i[y * 3 + 1]]), e.vertex.push(t.vertexPositions[i[y * 3 + 2]]), t.skeleton && (e.vertexWeights.push(g[p * 4]), e.vertexWeights.push(g[p * 4 + 1]), e.vertexWeights.push(g[p * 4 + 2]), e.vertexWeights.push(g[p * 4 + 3]), e.vertexWeights.push(g[A * 4]), e.vertexWeights.push(g[A * 4 + 1]), e.vertexWeights.push(g[A * 4 + 2]), e.vertexWeights.push(g[A * 4 + 3]), e.vertexWeights.push(g[y * 4]), e.vertexWeights.push(g[y * 4 + 1]), e.vertexWeights.push(g[y * 4 + 2]), e.vertexWeights.push(g[y * 4 + 3]), e.weightsIndices.push(l[p * 4]), e.weightsIndices.push(l[p * 4 + 1]), e.weightsIndices.push(l[p * 4 + 2]), e.weightsIndices.push(l[p * 4 + 3]), e.weightsIndices.push(l[A * 4]), e.weightsIndices.push(l[A * 4 + 1]), e.weightsIndices.push(l[A * 4 + 2]), e.weightsIndices.push(l[A * 4 + 3]), e.weightsIndices.push(l[y * 4]), e.weightsIndices.push(l[y * 4 + 1]), e.weightsIndices.push(l[y * 4 + 2]), e.weightsIndices.push(l[y * 4 + 3])), t.color && (e.colors.push(a[p * 3]), e.colors.push(a[p * 3 + 1]), e.colors.push(a[p * 3 + 2]), e.colors.push(a[A * 3]), e.colors.push(a[A * 3 + 1]), e.colors.push(a[A * 3 + 2]), e.colors.push(a[y * 3]), e.colors.push(a[y * 3 + 1]), e.colors.push(a[y * 3 + 2])), t.material && t.material.mappingType !== "AllSame" && (e.materialIndex.push(n), e.materialIndex.push(n), e.materialIndex.push(n)), t.normal && (e.normal.push(s[p * 3]), e.normal.push(s[p * 3 + 1]), e.normal.push(s[p * 3 + 2]), e.normal.push(s[A * 3]), e.normal.push(s[A * 3 + 1]), e.normal.push(s[A * 3 + 2]), e.normal.push(s[y * 3]), e.normal.push(s[y * 3 + 1]), e.normal.push(s[y * 3 + 2])), t.uv && t.uv.forEach(function(G, Z) {
            e.uvs[Z] === void 0 && (e.uvs[Z] = []), e.uvs[Z].push(o[Z][p * 2]), e.uvs[Z].push(o[Z][p * 2 + 1]), e.uvs[Z].push(o[Z][A * 2]), e.uvs[Z].push(o[Z][A * 2 + 1]), e.uvs[Z].push(o[Z][y * 2]), e.uvs[Z].push(o[Z][y * 2 + 1]);
        });
    }
    addMorphTargets(e, t, i, n) {
        if (i.length === 0) return;
        e.morphTargetsRelative = !0, e.morphAttributes.position = [];
        const s = this;
        i.forEach(function(a) {
            a.rawTargets.forEach(function(o) {
                const g = $d7238066c5de7f1c$var$Ri.Objects.Geometry[o.geoID];
                g !== void 0 && s.genMorphGeometry(e, t, g, n, o.name);
            });
        });
    }
    // a morph geometry node is similar to a standard  node, and the node is also contained
    // in FBXTree.Objects.Geometry, however it can only have attributes for position, normal
    // and a special attribute Index defining which vertices of the original geometry are affected
    // Normal and position attributes only have data for the vertices that are affected by the morph
    genMorphGeometry(e, t, i, n, s) {
        const a = t.Vertices !== void 0 ? t.Vertices.a : [], o = t.PolygonVertexIndex !== void 0 ? t.PolygonVertexIndex.a : [], g = i.Vertices !== void 0 ? i.Vertices.a : [], l = i.Indexes !== void 0 ? i.Indexes.a : [], c = e.attributes.position.count * 3, d = new Float32Array(c);
        for(let G = 0; G < l.length; G++){
            const Z = l[G] * 3;
            d[Z] = g[G * 3], d[Z + 1] = g[G * 3 + 1], d[Z + 2] = g[G * 3 + 2];
        }
        const p = {
            vertexIndices: o,
            vertexPositions: d,
            baseVertexPositions: a
        }, A = this.genBuffers(p), y = new (0, $329ek.Float32BufferAttribute)(A.vertex, 3);
        y.name = s || i.attrName, y.applyMatrix4(n), e.morphAttributes.position.push(y);
    }
    // Parse normal from FBXTree.Objects.Geometry.LayerElementNormal if it exists
    parseNormals(e) {
        const t = e.MappingInformationType, i = e.ReferenceInformationType, n = e.Normals.a;
        let s = [];
        return i === "IndexToDirect" && ("NormalIndex" in e ? s = e.NormalIndex.a : "NormalsIndex" in e && (s = e.NormalsIndex.a)), {
            dataSize: 3,
            buffer: n,
            indices: s,
            mappingType: t,
            referenceType: i
        };
    }
    // Parse UVs from FBXTree.Objects.Geometry.LayerElementUV if it exists
    parseUVs(e) {
        const t = e.MappingInformationType, i = e.ReferenceInformationType, n = e.UV.a;
        let s = [];
        return i === "IndexToDirect" && (s = e.UVIndex.a), {
            dataSize: 2,
            buffer: n,
            indices: s,
            mappingType: t,
            referenceType: i
        };
    }
    // Parse Vertex Colors from FBXTree.Objects.Geometry.LayerElementColor if it exists
    parseVertexColors(e) {
        const t = e.MappingInformationType, i = e.ReferenceInformationType, n = e.Colors.a;
        let s = [];
        i === "IndexToDirect" && (s = e.ColorIndex.a);
        for(let a = 0, o = new (0, $329ek.Color)(); a < n.length; a += 4)o.fromArray(n, a), (0, $329ek.ColorManagement).colorSpaceToWorking(o, (0, $329ek.SRGBColorSpace)), o.toArray(n, a);
        return {
            dataSize: 4,
            buffer: n,
            indices: s,
            mappingType: t,
            referenceType: i
        };
    }
    // Parse mapping and material data in FBXTree.Objects.Geometry.LayerElementMaterial if it exists
    parseMaterialIndices(e) {
        const t = e.MappingInformationType, i = e.ReferenceInformationType;
        if (t === "NoMappingInformation") return {
            dataSize: 1,
            buffer: [
                0
            ],
            indices: [
                0
            ],
            mappingType: "AllSame",
            referenceType: i
        };
        const n = e.Materials.a, s = [];
        for(let a = 0; a < n.length; ++a)s.push(a);
        return {
            dataSize: 1,
            buffer: n,
            indices: s,
            mappingType: t,
            referenceType: i
        };
    }
    // Generate a NurbGeometry from a node in FBXTree.Objects.Geometry
    parseNurbsGeometry(e) {
        const t = parseInt(e.Order);
        if (isNaN(t)) return console.error("THREE.FBXLoader: Invalid Order %s given for geometry ID: %s", e.Order, e.id), new (0, $329ek.BufferGeometry)();
        const i = t - 1, n = e.KnotVector.a, s = [], a = e.Points.a;
        for(let d = 0, p = a.length; d < p; d += 4)s.push(new (0, $329ek.Vector4)().fromArray(a, d));
        let o, g;
        if (e.Form === "Closed") s.push(s[0]);
        else if (e.Form === "Periodic") {
            o = i, g = n.length - 1 - o;
            for(let d = 0; d < i; ++d)s.push(s[d]);
        }
        const c = new $d7238066c5de7f1c$var$A6(i, n, s, o, g).getPoints(s.length * 12);
        return new (0, $329ek.BufferGeometry)().setFromPoints(c);
    }
}
class $d7238066c5de7f1c$var$B6 {
    // take raw animation clips and turn them into three.js animation clips
    parse() {
        const e = [], t = this.parseClips();
        if (t !== void 0) for(const i in t){
            const n = t[i], s = this.addClip(n);
            e.push(s);
        }
        return e;
    }
    parseClips() {
        if ($d7238066c5de7f1c$var$Ri.Objects.AnimationCurve === void 0) return;
        const e = this.parseAnimationCurveNodes();
        this.parseAnimationCurves(e);
        const t = this.parseAnimationLayers(e);
        return this.parseAnimStacks(t);
    }
    // parse nodes in FBXTree.Objects.AnimationCurveNode
    // each AnimationCurveNode holds data for an animation transform for a model (e.g. left arm rotation )
    // and is referenced by an AnimationLayer
    parseAnimationCurveNodes() {
        const e = $d7238066c5de7f1c$var$Ri.Objects.AnimationCurveNode, t = /* @__PURE__ */ new Map();
        for(const i in e){
            const n = e[i];
            if (n.attrName.match(/S|R|T|DeformPercent/) !== null) {
                const s = {
                    id: n.id,
                    attr: n.attrName,
                    curves: {}
                };
                t.set(s.id, s);
            }
        }
        return t;
    }
    // parse nodes in FBXTree.Objects.AnimationCurve and connect them up to
    // previously parsed AnimationCurveNodes. Each AnimationCurve holds data for a single animated
    // axis ( e.g. times and values of x rotation)
    parseAnimationCurves(e) {
        const t = $d7238066c5de7f1c$var$Ri.Objects.AnimationCurve;
        for(const i in t){
            const n = {
                id: t[i].id,
                times: t[i].KeyTime.a.map($d7238066c5de7f1c$var$Z6),
                values: t[i].KeyValueFloat.a
            }, s = $d7238066c5de7f1c$var$Us.get(n.id);
            if (s !== void 0) {
                const a = s.parents[0].ID, o = s.parents[0].relationship;
                o.match(/X/) ? e.get(a).curves.x = n : o.match(/Y/) ? e.get(a).curves.y = n : o.match(/Z/) ? e.get(a).curves.z = n : o.match(/DeformPercent/) && e.has(a) && (e.get(a).curves.morph = n);
            }
        }
    }
    // parse nodes in FBXTree.Objects.AnimationLayer. Each layers holds references
    // to various AnimationCurveNodes and is referenced by an AnimationStack node
    // note: theoretically a stack can have multiple layers, however in practice there always seems to be one per stack
    parseAnimationLayers(e) {
        const t = $d7238066c5de7f1c$var$Ri.Objects.AnimationLayer, i = /* @__PURE__ */ new Map();
        for(const n in t){
            const s = [], a = $d7238066c5de7f1c$var$Us.get(parseInt(n));
            a !== void 0 && (a.children.forEach(function(g, l) {
                if (e.has(g.ID)) {
                    const c = e.get(g.ID);
                    if (c.curves.x !== void 0 || c.curves.y !== void 0 || c.curves.z !== void 0) {
                        if (s[l] === void 0) {
                            const d = $d7238066c5de7f1c$var$Us.get(g.ID).parents.filter(function(p) {
                                return p.relationship !== void 0;
                            })[0].ID;
                            if (d !== void 0) {
                                const p = $d7238066c5de7f1c$var$Ri.Objects.Model[d.toString()];
                                if (p === void 0) {
                                    console.warn("THREE.FBXLoader: Encountered a unused curve.", g);
                                    return;
                                }
                                const A = {
                                    modelName: p.attrName ? (0, $329ek.PropertyBinding).sanitizeNodeName(p.attrName) : "",
                                    ID: p.id,
                                    initialPosition: [
                                        0,
                                        0,
                                        0
                                    ],
                                    initialRotation: [
                                        0,
                                        0,
                                        0
                                    ],
                                    initialScale: [
                                        1,
                                        1,
                                        1
                                    ]
                                };
                                $d7238066c5de7f1c$var$$a.traverse(function(y) {
                                    y.ID === p.id && (A.transform = y.matrix, y.userData.transformData && (A.eulerOrder = y.userData.transformData.eulerOrder));
                                }), A.transform || (A.transform = new (0, $329ek.Matrix4)()), "PreRotation" in p && (A.preRotation = p.PreRotation.value), "PostRotation" in p && (A.postRotation = p.PostRotation.value), s[l] = A;
                            }
                        }
                        s[l] && (s[l][c.attr] = c);
                    } else if (c.curves.morph !== void 0) {
                        if (s[l] === void 0) {
                            const d = $d7238066c5de7f1c$var$Us.get(g.ID).parents.filter(function(v) {
                                return v.relationship !== void 0;
                            })[0].ID, p = $d7238066c5de7f1c$var$Us.get(d).parents[0].ID, A = $d7238066c5de7f1c$var$Us.get(p).parents[0].ID, y = $d7238066c5de7f1c$var$Us.get(A).parents[0].ID, G = $d7238066c5de7f1c$var$Ri.Objects.Model[y], Z = {
                                modelName: G.attrName ? (0, $329ek.PropertyBinding).sanitizeNodeName(G.attrName) : "",
                                morphName: $d7238066c5de7f1c$var$Ri.Objects.Deformer[d].attrName
                            };
                            s[l] = Z;
                        }
                        s[l][c.attr] = c;
                    }
                }
            }), i.set(parseInt(n), s));
        }
        return i;
    }
    // parse nodes in FBXTree.Objects.AnimationStack. These are the top level node in the animation
    // hierarchy. Each Stack node will be used to create an AnimationClip
    parseAnimStacks(e) {
        const t = $d7238066c5de7f1c$var$Ri.Objects.AnimationStack, i = {};
        for(const n in t){
            const s = $d7238066c5de7f1c$var$Us.get(parseInt(n)).children;
            s.length > 1 && console.warn("THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.");
            const a = e.get(s[0].ID);
            i[n] = {
                name: t[n].attrName,
                layer: a
            };
        }
        return i;
    }
    addClip(e) {
        let t = [];
        const i = this;
        return e.layer.forEach(function(n) {
            t = t.concat(i.generateTracks(n));
        }), new (0, $329ek.AnimationClip)(e.name, -1, t);
    }
    generateTracks(e) {
        const t = [];
        let i = new (0, $329ek.Vector3)(), n = new (0, $329ek.Vector3)();
        if (e.transform && e.transform.decompose(i, new (0, $329ek.Quaternion)(), n), i = i.toArray(), n = n.toArray(), e.T !== void 0 && Object.keys(e.T.curves).length > 0) {
            const s = this.generateVectorTrack(e.modelName, e.T.curves, i, "position");
            s !== void 0 && t.push(s);
        }
        if (e.R !== void 0 && Object.keys(e.R.curves).length > 0) {
            const s = this.generateRotationTrack(e.modelName, e.R.curves, e.preRotation, e.postRotation, e.eulerOrder);
            s !== void 0 && t.push(s);
        }
        if (e.S !== void 0 && Object.keys(e.S.curves).length > 0) {
            const s = this.generateVectorTrack(e.modelName, e.S.curves, n, "scale");
            s !== void 0 && t.push(s);
        }
        if (e.DeformPercent !== void 0) {
            const s = this.generateMorphTrack(e);
            s !== void 0 && t.push(s);
        }
        return t;
    }
    generateVectorTrack(e, t, i, n) {
        const s = this.getTimesForAllAxes(t), a = this.getKeyframeTrackValues(s, t, i);
        return new (0, $329ek.VectorKeyframeTrack)(e + "." + n, s, a);
    }
    generateRotationTrack(e, t, i, n, s) {
        let a, o;
        if (t.x !== void 0 && t.y !== void 0 && t.z !== void 0) {
            const p = this.interpolateRotations(t.x, t.y, t.z, s);
            a = p[0], o = p[1];
        }
        const g = $d7238066c5de7f1c$var$oB(0);
        i !== void 0 && (i = i.map((0, $329ek.MathUtils).degToRad), i.push(g), i = new (0, $329ek.Euler)().fromArray(i), i = new (0, $329ek.Quaternion)().setFromEuler(i)), n !== void 0 && (n = n.map((0, $329ek.MathUtils).degToRad), n.push(g), n = new (0, $329ek.Euler)().fromArray(n), n = new (0, $329ek.Quaternion)().setFromEuler(n).invert());
        const l = new (0, $329ek.Quaternion)(), c = new (0, $329ek.Euler)(), d = [];
        if (!o || !a) return new (0, $329ek.QuaternionKeyframeTrack)(e + ".quaternion", [
            0
        ], [
            0
        ]);
        for(let p = 0; p < o.length; p += 3)c.set(o[p], o[p + 1], o[p + 2], s), l.setFromEuler(c), i !== void 0 && l.premultiply(i), n !== void 0 && l.multiply(n), p > 2 && new (0, $329ek.Quaternion)().fromArray(d, (p - 3) / 3 * 4).dot(l) < 0 && l.set(-l.x, -l.y, -l.z, -l.w), l.toArray(d, p / 3 * 4);
        return new (0, $329ek.QuaternionKeyframeTrack)(e + ".quaternion", a, d);
    }
    generateMorphTrack(e) {
        const t = e.DeformPercent.curves.morph, i = t.values.map(function(s) {
            return s / 100;
        }), n = $d7238066c5de7f1c$var$$a.getObjectByName(e.modelName).morphTargetDictionary[e.morphName];
        return new (0, $329ek.NumberKeyframeTrack)(e.modelName + ".morphTargetInfluences[" + n + "]", t.times, i);
    }
    // For all animated objects, times are defined separately for each axis
    // Here we'll combine the times into one sorted array without duplicates
    getTimesForAllAxes(e) {
        let t = [];
        if (e.x !== void 0 && (t = t.concat(e.x.times)), e.y !== void 0 && (t = t.concat(e.y.times)), e.z !== void 0 && (t = t.concat(e.z.times)), t = t.sort(function(i, n) {
            return i - n;
        }), t.length > 1) {
            let i = 1, n = t[0];
            for(let s = 1; s < t.length; s++){
                const a = t[s];
                a !== n && (t[i] = a, n = a, i++);
            }
            t = t.slice(0, i);
        }
        return t;
    }
    getKeyframeTrackValues(e, t, i) {
        const n = i, s = [];
        let a = -1, o = -1, g = -1;
        return e.forEach(function(l) {
            if (t.x && (a = t.x.times.indexOf(l)), t.y && (o = t.y.times.indexOf(l)), t.z && (g = t.z.times.indexOf(l)), a !== -1) {
                const c = t.x.values[a];
                s.push(c), n[0] = c;
            } else s.push(n[0]);
            if (o !== -1) {
                const c = t.y.values[o];
                s.push(c), n[1] = c;
            } else s.push(n[1]);
            if (g !== -1) {
                const c = t.z.values[g];
                s.push(c), n[2] = c;
            } else s.push(n[2]);
        }), s;
    }
    // Rotations are defined as Euler angles which can have values  of any size
    // These will be converted to quaternions which don't support values greater than
    // PI, so we'll interpolate large rotations
    interpolateRotations(e, t, i, n) {
        const s = [], a = [];
        s.push(e.times[0]), a.push((0, $329ek.MathUtils).degToRad(e.values[0])), a.push((0, $329ek.MathUtils).degToRad(t.values[0])), a.push((0, $329ek.MathUtils).degToRad(i.values[0]));
        for(let o = 1; o < e.values.length; o++){
            const g = [
                e.values[o - 1],
                t.values[o - 1],
                i.values[o - 1]
            ];
            if (isNaN(g[0]) || isNaN(g[1]) || isNaN(g[2])) continue;
            const l = g.map((0, $329ek.MathUtils).degToRad), c = [
                e.values[o],
                t.values[o],
                i.values[o]
            ];
            if (isNaN(c[0]) || isNaN(c[1]) || isNaN(c[2])) continue;
            const d = c.map((0, $329ek.MathUtils).degToRad), p = [
                c[0] - g[0],
                c[1] - g[1],
                c[2] - g[2]
            ], A = [
                Math.abs(p[0]),
                Math.abs(p[1]),
                Math.abs(p[2])
            ];
            if (A[0] >= 180 || A[1] >= 180 || A[2] >= 180) {
                const G = Math.max(...A) / 180, Z = new (0, $329ek.Euler)(...l, n), v = new (0, $329ek.Euler)(...d, n), V = new (0, $329ek.Quaternion)().setFromEuler(Z), H = new (0, $329ek.Quaternion)().setFromEuler(v);
                V.dot(H) && H.set(-H.x, -H.y, -H.z, -H.w);
                const N = e.times[o - 1], Y = e.times[o] - N, K = new (0, $329ek.Quaternion)(), z = new (0, $329ek.Euler)();
                for(let M = 0; M < 1; M += 1 / G)K.copy(V.clone().slerp(H.clone(), M)), s.push(N + M * Y), z.setFromQuaternion(K, n), a.push(z.x), a.push(z.y), a.push(z.z);
            } else s.push(e.times[o]), a.push((0, $329ek.MathUtils).degToRad(e.values[o])), a.push((0, $329ek.MathUtils).degToRad(t.values[o])), a.push((0, $329ek.MathUtils).degToRad(i.values[o]));
        }
        return [
            s,
            a
        ];
    }
}
class $d7238066c5de7f1c$var$f6 {
    getPrevNode() {
        return this.nodeStack[this.currentIndent - 2];
    }
    getCurrentNode() {
        return this.nodeStack[this.currentIndent - 1];
    }
    getCurrentProp() {
        return this.currentProp;
    }
    pushStack(e) {
        this.nodeStack.push(e), this.currentIndent += 1;
    }
    popStack() {
        this.nodeStack.pop(), this.currentIndent -= 1;
    }
    setCurrentProp(e, t) {
        this.currentProp = e, this.currentPropName = t;
    }
    parse(e) {
        this.currentIndent = 0, this.allNodes = new $d7238066c5de7f1c$var$wk(), this.nodeStack = [], this.currentProp = [], this.currentPropName = "";
        const t = this, i = e.split(/[\r\n]+/);
        return i.forEach(function(n, s) {
            const a = n.match(/^[\s\t]*;/), o = n.match(/^[\s\t]*$/);
            if (a || o) return;
            const g = n.match("^\\t{" + t.currentIndent + "}(\\w+):(.*){", ""), l = n.match("^\\t{" + t.currentIndent + "}(\\w+):[\\s\\t\\r\\n](.*)"), c = n.match("^\\t{" + (t.currentIndent - 1) + "}}");
            g ? t.parseNodeBegin(n, g) : l ? t.parseNodeProperty(n, l, i[++s]) : c ? t.popStack() : n.match(/^[^\s\t}]/) && t.parseNodePropertyContinued(n);
        }), this.allNodes;
    }
    parseNodeBegin(e, t) {
        const i = t[1].trim().replace(/^"/, "").replace(/"$/, ""), n = t[2].split(",").map(function(g) {
            return g.trim().replace(/^"/, "").replace(/"$/, "");
        }), s = {
            name: i
        }, a = this.parseNodeAttr(n), o = this.getCurrentNode();
        this.currentIndent === 0 ? this.allNodes.add(i, s) : i in o ? (i === "PoseNode" ? o.PoseNode.push(s) : o[i].id !== void 0 && (o[i] = {}, o[i][o[i].id] = o[i]), a.id !== "" && (o[i][a.id] = s)) : typeof a.id == "number" ? (o[i] = {}, o[i][a.id] = s) : i !== "Properties70" && (i === "PoseNode" ? o[i] = [
            s
        ] : o[i] = s), typeof a.id == "number" && (s.id = a.id), a.name !== "" && (s.attrName = a.name), a.type !== "" && (s.attrType = a.type), this.pushStack(s);
    }
    parseNodeAttr(e) {
        let t = e[0];
        e[0] !== "" && (t = parseInt(e[0]), isNaN(t) && (t = e[0]));
        let i = "", n = "";
        return e.length > 1 && (i = e[1].replace(/^(\w+)::/, ""), n = e[2]), {
            id: t,
            name: i,
            type: n
        };
    }
    parseNodeProperty(e, t, i) {
        let n = t[1].replace(/^"/, "").replace(/"$/, "").trim(), s = t[2].replace(/^"/, "").replace(/"$/, "").trim();
        n === "Content" && s === "," && (s = i.replace(/"/g, "").replace(/,$/, "").trim());
        const a = this.getCurrentNode();
        if (a.name === "Properties70") {
            this.parseNodeSpecialProperty(e, n, s);
            return;
        }
        if (n === "C") {
            const g = s.split(",").slice(1), l = parseInt(g[0]), c = parseInt(g[1]);
            let d = s.split(",").slice(3);
            d = d.map(function(p) {
                return p.trim().replace(/^"/, "");
            }), n = "connections", s = [
                l,
                c
            ], $d7238066c5de7f1c$var$V6(s, d), a[n] === void 0 && (a[n] = []);
        }
        n === "Node" && (a.id = s), n in a && Array.isArray(a[n]) ? a[n].push(s) : n !== "a" ? a[n] = s : a.a = s, this.setCurrentProp(a, n), n === "a" && s.slice(-1) !== "," && (a.a = $d7238066c5de7f1c$var$TW(s));
    }
    parseNodePropertyContinued(e) {
        const t = this.getCurrentNode();
        t.a += e, e.slice(-1) !== "," && (t.a = $d7238066c5de7f1c$var$TW(t.a));
    }
    // parse "Property70"
    parseNodeSpecialProperty(e, t, i) {
        const n = i.split('",').map(function(c) {
            return c.trim().replace(/^\"/, "").replace(/\s/, "_");
        }), s = n[0], a = n[1], o = n[2], g = n[3];
        let l = n[4];
        switch(a){
            case "int":
            case "enum":
            case "bool":
            case "ULongLong":
            case "double":
            case "Number":
            case "FieldOfView":
                l = parseFloat(l);
                break;
            case "Color":
            case "ColorRGB":
            case "Vector3D":
            case "Lcl_Translation":
            case "Lcl_Rotation":
            case "Lcl_Scaling":
                l = $d7238066c5de7f1c$var$TW(l);
                break;
        }
        this.getPrevNode()[s] = {
            type: a,
            type2: o,
            flag: g,
            value: l
        }, this.setCurrentProp(this.getPrevNode(), s);
    }
}
class $d7238066c5de7f1c$var$G6 {
    parse(e) {
        const t = new $d7238066c5de7f1c$var$C5(e);
        t.skip(23);
        const i = t.getUint32();
        if (i < 6400) throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + i);
        const n = new $d7238066c5de7f1c$var$wk();
        for(; !this.endOfContent(t);){
            const s = this.parseNode(t, i);
            s !== null && n.add(s.name, s);
        }
        return n;
    }
    // Check if reader has reached the end of content.
    endOfContent(e) {
        return e.size() % 16 === 0 ? (e.getOffset() + 160 + 16 & -16) >= e.size() : e.getOffset() + 160 + 16 >= e.size();
    }
    // recursively parse nodes until the end of the file is reached
    parseNode(e, t) {
        const i = {}, n = t >= 7500 ? e.getUint64() : e.getUint32(), s = t >= 7500 ? e.getUint64() : e.getUint32();
        t >= 7500 ? e.getUint64() : e.getUint32();
        const a = e.getUint8(), o = e.getString(a);
        if (n === 0) return null;
        const g = [];
        for(let p = 0; p < s; p++)g.push(this.parseProperty(e));
        const l = g.length > 0 ? g[0] : "", c = g.length > 1 ? g[1] : "", d = g.length > 2 ? g[2] : "";
        for(i.singleProperty = s === 1 && e.getOffset() === n; n > e.getOffset();){
            const p = this.parseNode(e, t);
            p !== null && this.parseSubNode(o, i, p);
        }
        return i.propertyList = g, typeof l == "number" && (i.id = l), c !== "" && (i.attrName = c), d !== "" && (i.attrType = d), o !== "" && (i.name = o), i;
    }
    parseSubNode(e, t, i) {
        if (i.singleProperty === !0) {
            const n = i.propertyList[0];
            Array.isArray(n) ? (t[i.name] = i, i.a = n) : t[i.name] = n;
        } else if (e === "Connections" && i.name === "C") {
            const n = [];
            i.propertyList.forEach(function(s, a) {
                a !== 0 && n.push(s);
            }), t.connections === void 0 && (t.connections = []), t.connections.push(n);
        } else if (i.name === "Properties70") Object.keys(i).forEach(function(s) {
            t[s] = i[s];
        });
        else if (e === "Properties70" && i.name === "P") {
            let n = i.propertyList[0], s = i.propertyList[1];
            const a = i.propertyList[2], o = i.propertyList[3];
            let g;
            n.indexOf("Lcl ") === 0 && (n = n.replace("Lcl ", "Lcl_")), s.indexOf("Lcl ") === 0 && (s = s.replace("Lcl ", "Lcl_")), s === "Color" || s === "ColorRGB" || s === "Vector" || s === "Vector3D" || s.indexOf("Lcl_") === 0 ? g = [
                i.propertyList[4],
                i.propertyList[5],
                i.propertyList[6]
            ] : g = i.propertyList[4], t[n] = {
                type: s,
                type2: a,
                flag: o,
                value: g
            };
        } else t[i.name] === void 0 ? typeof i.id == "number" ? (t[i.name] = {}, t[i.name][i.id] = i) : t[i.name] = i : i.name === "PoseNode" ? (Array.isArray(t[i.name]) || (t[i.name] = [
            t[i.name]
        ]), t[i.name].push(i)) : t[i.name][i.id] === void 0 && (t[i.name][i.id] = i);
    }
    parseProperty(e) {
        const t = e.getString(1);
        let i;
        switch(t){
            case "C":
                return e.getBoolean();
            case "D":
                return e.getFloat64();
            case "F":
                return e.getFloat32();
            case "I":
                return e.getInt32();
            case "L":
                return e.getInt64();
            case "R":
                return i = e.getUint32(), e.getArrayBuffer(i);
            case "S":
                return i = e.getUint32(), e.getString(i);
            case "Y":
                return e.getInt16();
            case "b":
            case "c":
            case "d":
            case "f":
            case "i":
            case "l":
                const n = e.getUint32(), s = e.getUint32(), a = e.getUint32();
                if (s === 0) switch(t){
                    case "b":
                    case "c":
                        return e.getBooleanArray(n);
                    case "d":
                        return e.getFloat64Array(n);
                    case "f":
                        return e.getFloat32Array(n);
                    case "i":
                        return e.getInt32Array(n);
                    case "l":
                        return e.getInt64Array(n);
                }
                const o = $d7238066c5de7f1c$var$g6(new Uint8Array(e.getArrayBuffer(a))), g = new $d7238066c5de7f1c$var$C5(o.buffer);
                switch(t){
                    case "b":
                    case "c":
                        return g.getBooleanArray(n);
                    case "d":
                        return g.getFloat64Array(n);
                    case "f":
                        return g.getFloat32Array(n);
                    case "i":
                        return g.getInt32Array(n);
                    case "l":
                        return g.getInt64Array(n);
                }
                break;
            default:
                throw new Error("THREE.FBXLoader: Unknown property type " + t);
        }
    }
}
class $d7238066c5de7f1c$var$C5 {
    constructor(e, t){
        this.dv = new DataView(e), this.offset = 0, this.littleEndian = t !== void 0 ? t : !0, this._textDecoder = new TextDecoder();
    }
    getOffset() {
        return this.offset;
    }
    size() {
        return this.dv.buffer.byteLength;
    }
    skip(e) {
        this.offset += e;
    }
    // seems like true/false representation depends on exporter.
    // true: 1 or 'Y'(=0x59), false: 0 or 'T'(=0x54)
    // then sees LSB.
    getBoolean() {
        return (this.getUint8() & 1) === 1;
    }
    getBooleanArray(e) {
        const t = [];
        for(let i = 0; i < e; i++)t.push(this.getBoolean());
        return t;
    }
    getUint8() {
        const e = this.dv.getUint8(this.offset);
        return this.offset += 1, e;
    }
    getInt16() {
        const e = this.dv.getInt16(this.offset, this.littleEndian);
        return this.offset += 2, e;
    }
    getInt32() {
        const e = this.dv.getInt32(this.offset, this.littleEndian);
        return this.offset += 4, e;
    }
    getInt32Array(e) {
        const t = [];
        for(let i = 0; i < e; i++)t.push(this.getInt32());
        return t;
    }
    getUint32() {
        const e = this.dv.getUint32(this.offset, this.littleEndian);
        return this.offset += 4, e;
    }
    // JavaScript doesn't support 64-bit integer so calculate this here
    // 1 << 32 will return 1 so using multiply operation instead here.
    // There's a possibility that this method returns wrong value if the value
    // is out of the range between Number.MAX_SAFE_INTEGER and Number.MIN_SAFE_INTEGER.
    // TODO: safely handle 64-bit integer
    getInt64() {
        let e, t;
        return this.littleEndian ? (e = this.getUint32(), t = this.getUint32()) : (t = this.getUint32(), e = this.getUint32()), t & 2147483648 ? (t = ~t & 4294967295, e = ~e & 4294967295, e === 4294967295 && (t = t + 1 & 4294967295), e = e + 1 & 4294967295, -(t * 4294967296 + e)) : t * 4294967296 + e;
    }
    getInt64Array(e) {
        const t = [];
        for(let i = 0; i < e; i++)t.push(this.getInt64());
        return t;
    }
    // Note: see getInt64() comment
    getUint64() {
        let e, t;
        return this.littleEndian ? (e = this.getUint32(), t = this.getUint32()) : (t = this.getUint32(), e = this.getUint32()), t * 4294967296 + e;
    }
    getFloat32() {
        const e = this.dv.getFloat32(this.offset, this.littleEndian);
        return this.offset += 4, e;
    }
    getFloat32Array(e) {
        const t = [];
        for(let i = 0; i < e; i++)t.push(this.getFloat32());
        return t;
    }
    getFloat64() {
        const e = this.dv.getFloat64(this.offset, this.littleEndian);
        return this.offset += 8, e;
    }
    getFloat64Array(e) {
        const t = [];
        for(let i = 0; i < e; i++)t.push(this.getFloat64());
        return t;
    }
    getArrayBuffer(e) {
        const t = this.dv.buffer.slice(this.offset, this.offset + e);
        return this.offset += e, t;
    }
    getString(e) {
        const t = this.offset;
        let i = new Uint8Array(this.dv.buffer, t, e);
        this.skip(e);
        const n = i.indexOf(0);
        return n >= 0 && (i = new Uint8Array(this.dv.buffer, t, n)), this._textDecoder.decode(i);
    }
}
class $d7238066c5de7f1c$var$wk {
    add(e, t) {
        this[e] = t;
    }
}
function $d7238066c5de7f1c$var$v6(r) {
    const e = "Kaydara FBX Binary  \0";
    return r.byteLength >= e.length && e === $d7238066c5de7f1c$var$Hk(r, 0, e.length);
}
function $d7238066c5de7f1c$var$S6(r) {
    const e = [
        "K",
        "a",
        "y",
        "d",
        "a",
        "r",
        "a",
        "\\",
        "F",
        "B",
        "X",
        "\\",
        "B",
        "i",
        "n",
        "a",
        "r",
        "y",
        "\\",
        "\\"
    ];
    let t = 0;
    function i(n) {
        const s = r[n - 1];
        return r = r.slice(t + n), t++, s;
    }
    for(let n = 0; n < e.length; ++n)if (i(1) === e[n]) return !1;
    return !0;
}
function $d7238066c5de7f1c$var$p5(r) {
    const e = /FBXVersion: (\d+)/, t = r.match(e);
    if (t) return parseInt(t[1]);
    throw new Error("THREE.FBXLoader: Cannot find the version number for the file given.");
}
function $d7238066c5de7f1c$var$Z6(r) {
    return r / 46186158e3;
}
const $d7238066c5de7f1c$var$R6 = [];
function $d7238066c5de7f1c$var$uv(r, e, t, i) {
    let n;
    switch(i.mappingType){
        case "ByPolygonVertex":
            n = r;
            break;
        case "ByPolygon":
            n = e;
            break;
        case "ByVertice":
            n = t;
            break;
        case "AllSame":
            n = i.indices[0];
            break;
        default:
            console.warn("THREE.FBXLoader: unknown attribute mapping type " + i.mappingType);
    }
    i.referenceType === "IndexToDirect" && (n = i.indices[n]);
    const s = n * i.dataSize, a = s + i.dataSize;
    return $d7238066c5de7f1c$var$w6($d7238066c5de7f1c$var$R6, i.buffer, s, a);
}
const $d7238066c5de7f1c$var$FW = new (0, $329ek.Euler)(), $d7238066c5de7f1c$var$Gm = new (0, $329ek.Vector3)();
function $d7238066c5de7f1c$var$Wk(r) {
    const e = new (0, $329ek.Matrix4)(), t = new (0, $329ek.Matrix4)(), i = new (0, $329ek.Matrix4)(), n = new (0, $329ek.Matrix4)(), s = new (0, $329ek.Matrix4)(), a = new (0, $329ek.Matrix4)(), o = new (0, $329ek.Matrix4)(), g = new (0, $329ek.Matrix4)(), l = new (0, $329ek.Matrix4)(), c = new (0, $329ek.Matrix4)(), d = new (0, $329ek.Matrix4)(), p = new (0, $329ek.Matrix4)(), A = r.inheritType ? r.inheritType : 0;
    r.translation && e.setPosition($d7238066c5de7f1c$var$Gm.fromArray(r.translation));
    const y = $d7238066c5de7f1c$var$oB(0);
    if (r.preRotation) {
        const ie = r.preRotation.map((0, $329ek.MathUtils).degToRad);
        ie.push(y), t.makeRotationFromEuler($d7238066c5de7f1c$var$FW.fromArray(ie));
    }
    if (r.rotation) {
        const ie = r.rotation.map((0, $329ek.MathUtils).degToRad);
        ie.push(r.eulerOrder || y), i.makeRotationFromEuler($d7238066c5de7f1c$var$FW.fromArray(ie));
    }
    if (r.postRotation) {
        const ie = r.postRotation.map((0, $329ek.MathUtils).degToRad);
        ie.push(y), n.makeRotationFromEuler($d7238066c5de7f1c$var$FW.fromArray(ie)), n.invert();
    }
    r.scale && s.scale($d7238066c5de7f1c$var$Gm.fromArray(r.scale)), r.scalingOffset && o.setPosition($d7238066c5de7f1c$var$Gm.fromArray(r.scalingOffset)), r.scalingPivot && a.setPosition($d7238066c5de7f1c$var$Gm.fromArray(r.scalingPivot)), r.rotationOffset && g.setPosition($d7238066c5de7f1c$var$Gm.fromArray(r.rotationOffset)), r.rotationPivot && l.setPosition($d7238066c5de7f1c$var$Gm.fromArray(r.rotationPivot)), r.parentMatrixWorld && (d.copy(r.parentMatrix), c.copy(r.parentMatrixWorld));
    const G = t.clone().multiply(i).multiply(n), Z = new (0, $329ek.Matrix4)();
    Z.extractRotation(c);
    const v = new (0, $329ek.Matrix4)();
    v.copyPosition(c);
    const V = v.clone().invert().multiply(c), H = Z.clone().invert().multiply(V), N = s, Y = new (0, $329ek.Matrix4)();
    if (A === 0) Y.copy(Z).multiply(G).multiply(H).multiply(N);
    else if (A === 1) Y.copy(Z).multiply(H).multiply(G).multiply(N);
    else {
        const he = new (0, $329ek.Matrix4)().scale(new (0, $329ek.Vector3)().setFromMatrixScale(d)).clone().invert(), pe = H.clone().multiply(he);
        Y.copy(Z).multiply(G).multiply(pe).multiply(N);
    }
    const K = l.clone().invert(), z = a.clone().invert();
    let M = e.clone().multiply(g).multiply(l).multiply(t).multiply(i).multiply(n).multiply(K).multiply(o).multiply(a).multiply(s).multiply(z);
    const _ = new (0, $329ek.Matrix4)().copyPosition(M), O = c.clone().multiply(_);
    return p.copyPosition(O), M = p.clone().multiply(Y), M.premultiply(c.invert()), M;
}
function $d7238066c5de7f1c$var$oB(r) {
    r = r || 0;
    const e = [
        "ZYX",
        // -> XYZ extrinsic
        "YZX",
        // -> XZY extrinsic
        "XZY",
        // -> YZX extrinsic
        "ZXY",
        // -> YXZ extrinsic
        "YXZ",
        // -> ZXY extrinsic
        "XYZ"
    ];
    return r === 6 ? (console.warn("THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect."), e[0]) : e[r];
}
function $d7238066c5de7f1c$var$TW(r) {
    return r.split(",").map(function(t) {
        return parseFloat(t);
    });
}
function $d7238066c5de7f1c$var$Hk(r, e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = r.byteLength), new TextDecoder().decode(new Uint8Array(r, e, t));
}
function $d7238066c5de7f1c$var$V6(r, e) {
    for(let t = 0, i = r.length, n = e.length; t < n; t++, i++)r[i] = e[t];
}
function $d7238066c5de7f1c$var$w6(r, e, t, i) {
    for(let n = t, s = 0; n < i; n++, s++)r[s] = e[n];
    return r;
}
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d7238066c5de7f1c$var$MB = "181", $d7238066c5de7f1c$var$W6 = 0, $d7238066c5de7f1c$var$H6 = 1, $d7238066c5de7f1c$var$X6 = 2, $d7238066c5de7f1c$var$N6 = 0, $d7238066c5de7f1c$var$L6 = 1, $d7238066c5de7f1c$var$SS = 3, $d7238066c5de7f1c$var$nh = 0, $d7238066c5de7f1c$var$Ka = 1, $d7238066c5de7f1c$var$YC = 2, $d7238066c5de7f1c$var$xA = 0, $d7238066c5de7f1c$var$uI = 1, $d7238066c5de7f1c$var$_S = 2, $d7238066c5de7f1c$var$PS = 3, $d7238066c5de7f1c$var$QS = 4, $d7238066c5de7f1c$var$Yy = 5, $d7238066c5de7f1c$var$Pl = 100, $d7238066c5de7f1c$var$Xk = 101, $d7238066c5de7f1c$var$Nk = 102, $d7238066c5de7f1c$var$Y6 = 103, $d7238066c5de7f1c$var$K6 = 104, $d7238066c5de7f1c$var$kd = 200, $d7238066c5de7f1c$var$Lk = 201, $d7238066c5de7f1c$var$Yk = 202, $d7238066c5de7f1c$var$Kk = 203, $d7238066c5de7f1c$var$OS = 204, $d7238066c5de7f1c$var$jS = 205, $d7238066c5de7f1c$var$xk = 206, $d7238066c5de7f1c$var$Fk = 207, $d7238066c5de7f1c$var$Tk = 208, $d7238066c5de7f1c$var$Mk = 209, $d7238066c5de7f1c$var$zk = 210, $d7238066c5de7f1c$var$kk = 0, $d7238066c5de7f1c$var$Ek = 1, $d7238066c5de7f1c$var$Jk = 2, $d7238066c5de7f1c$var$qS = 3, $d7238066c5de7f1c$var$Uk = 4, $d7238066c5de7f1c$var$Dk = 5, $d7238066c5de7f1c$var$_k = 6, $d7238066c5de7f1c$var$Pk = 7, $d7238066c5de7f1c$var$nR = 0, $d7238066c5de7f1c$var$x6 = 1, $d7238066c5de7f1c$var$F6 = 2, $d7238066c5de7f1c$var$VC = 0, $d7238066c5de7f1c$var$T6 = 1, $d7238066c5de7f1c$var$M6 = 2, $d7238066c5de7f1c$var$z6 = 3, $d7238066c5de7f1c$var$k6 = 4, $d7238066c5de7f1c$var$E6 = 6, $d7238066c5de7f1c$var$J6 = 7, $d7238066c5de7f1c$var$_N = 300, $d7238066c5de7f1c$var$gB = 301, $d7238066c5de7f1c$var$$S = 302, $d7238066c5de7f1c$var$PN = 303, $d7238066c5de7f1c$var$QN = 304, $d7238066c5de7f1c$var$A2 = 306, $d7238066c5de7f1c$var$FA = 1e3, $d7238066c5de7f1c$var$qc = 1001, $d7238066c5de7f1c$var$TA = 1002, $d7238066c5de7f1c$var$Sr = 1003, $d7238066c5de7f1c$var$Qk = 1004, $d7238066c5de7f1c$var$lB = 1005, $d7238066c5de7f1c$var$ro = 1006, $d7238066c5de7f1c$var$b2 = 1007, $d7238066c5de7f1c$var$II = 1008, $d7238066c5de7f1c$var$U6 = 1008, $d7238066c5de7f1c$var$Ya = 1009, $d7238066c5de7f1c$var$fA = 1010, $d7238066c5de7f1c$var$GA = 1011, $d7238066c5de7f1c$var$wC = 1012, $d7238066c5de7f1c$var$Na = 1013, $d7238066c5de7f1c$var$Xs = 1014, $d7238066c5de7f1c$var$vo = 1015, $d7238066c5de7f1c$var$Ia = 1016, $d7238066c5de7f1c$var$Ok = 1017, $d7238066c5de7f1c$var$jk = 1018, $d7238066c5de7f1c$var$sh = 1020, $d7238066c5de7f1c$var$ON = 35902, $d7238066c5de7f1c$var$jN = 35899, $d7238066c5de7f1c$var$qk = 1021, $d7238066c5de7f1c$var$sR = 1022, $d7238066c5de7f1c$var$sg = 1023, $d7238066c5de7f1c$var$nu = 1026, $d7238066c5de7f1c$var$dI = 1027, $d7238066c5de7f1c$var$rR = 1028, $d7238066c5de7f1c$var$aR = 1029, $d7238066c5de7f1c$var$gI = 1030, $d7238066c5de7f1c$var$oR = 1031, $d7238066c5de7f1c$var$D6 = 1032, $d7238066c5de7f1c$var$gR = 1033, $d7238066c5de7f1c$var$Ky = 33776, $d7238066c5de7f1c$var$xy = 33777, $d7238066c5de7f1c$var$Fy = 33778, $d7238066c5de7f1c$var$Ty = 33779, $d7238066c5de7f1c$var$y2 = 35840, $d7238066c5de7f1c$var$B2 = 35841, $d7238066c5de7f1c$var$f2 = 35842, $d7238066c5de7f1c$var$G2 = 35843, $d7238066c5de7f1c$var$eZ = 36196, $d7238066c5de7f1c$var$tZ = 37492, $d7238066c5de7f1c$var$iZ = 37496, $d7238066c5de7f1c$var$nZ = 37808, $d7238066c5de7f1c$var$sZ = 37809, $d7238066c5de7f1c$var$rZ = 37810, $d7238066c5de7f1c$var$aZ = 37811, $d7238066c5de7f1c$var$oZ = 37812, $d7238066c5de7f1c$var$gZ = 37813, $d7238066c5de7f1c$var$lZ = 37814, $d7238066c5de7f1c$var$cZ = 37815, $d7238066c5de7f1c$var$uZ = 37816, $d7238066c5de7f1c$var$IZ = 37817, $d7238066c5de7f1c$var$dZ = 37818, $d7238066c5de7f1c$var$hZ = 37819, $d7238066c5de7f1c$var$CZ = 37820, $d7238066c5de7f1c$var$pZ = 37821, $d7238066c5de7f1c$var$mZ = 36492, $d7238066c5de7f1c$var$_6 = 36494, $d7238066c5de7f1c$var$P6 = 36495, $d7238066c5de7f1c$var$AZ = 36283, $d7238066c5de7f1c$var$bZ = 36284, $d7238066c5de7f1c$var$yZ = 36285, $d7238066c5de7f1c$var$BZ = 36286, $d7238066c5de7f1c$var$oh = 0, $d7238066c5de7f1c$var$Q6 = 1, $d7238066c5de7f1c$var$gh = "", $d7238066c5de7f1c$var$$o = "srgb", $d7238066c5de7f1c$var$fZ = "srgb-linear", $d7238066c5de7f1c$var$GZ = "linear", $d7238066c5de7f1c$var$Qt = "srgb", $d7238066c5de7f1c$var$O6 = 0, $d7238066c5de7f1c$var$SC = 7680, $d7238066c5de7f1c$var$j6 = 7681, $d7238066c5de7f1c$var$q6 = 7682, $d7238066c5de7f1c$var$$6 = 7683, $d7238066c5de7f1c$var$e$ = 34055, $d7238066c5de7f1c$var$t$ = 34056, $d7238066c5de7f1c$var$i$ = 5386, $d7238066c5de7f1c$var$n$ = 512, $d7238066c5de7f1c$var$s$ = 513, $d7238066c5de7f1c$var$r$ = 514, $d7238066c5de7f1c$var$a$ = 515, $d7238066c5de7f1c$var$o$ = 516, $d7238066c5de7f1c$var$g$ = 517, $d7238066c5de7f1c$var$l$ = 518, $d7238066c5de7f1c$var$v2 = 519, $d7238066c5de7f1c$var$$k = 512, $d7238066c5de7f1c$var$qN = 513, $d7238066c5de7f1c$var$e3 = 514, $d7238066c5de7f1c$var$t3 = 515, $d7238066c5de7f1c$var$i3 = 516, $d7238066c5de7f1c$var$n3 = 517, $d7238066c5de7f1c$var$s3 = 518, $d7238066c5de7f1c$var$r3 = 519, $d7238066c5de7f1c$var$vZ = 35044, $d7238066c5de7f1c$var$dA = 35048, $d7238066c5de7f1c$var$rg = 2e3, $d7238066c5de7f1c$var$uu = 2001, $d7238066c5de7f1c$var$$c = {
    COMPUTE: "compute",
    RENDER: "render"
};
function $d7238066c5de7f1c$var$a3(r) {
    for(let e = r.length - 1; e >= 0; --e)if (r[e] >= 65535) return !0;
    return !1;
}
function $d7238066c5de7f1c$var$SZ(r) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", r);
}
function $d7238066c5de7f1c$var$c$() {
    const r = $d7238066c5de7f1c$var$SZ("canvas");
    return r.style.display = "block", r;
}
const $d7238066c5de7f1c$var$m5 = {};
function $d7238066c5de7f1c$var$S2(...r) {
    const e = "THREE." + r.shift();
    console.log(e, ...r);
}
function $d7238066c5de7f1c$var$ze(...r) {
    const e = "THREE." + r.shift();
    console.warn(e, ...r);
}
function $d7238066c5de7f1c$var$nt(...r) {
    const e = "THREE." + r.shift();
    console.error(e, ...r);
}
function $d7238066c5de7f1c$var$es(...r) {
    const e = r.join(" ");
    e in $d7238066c5de7f1c$var$m5 || ($d7238066c5de7f1c$var$m5[e] = !0, $d7238066c5de7f1c$var$ze(...r));
}
let $d7238066c5de7f1c$var$wI = class {
    /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */ addEventListener(e, t) {
        this._listeners === void 0 && (this._listeners = {});
        const i = this._listeners;
        i[e] === void 0 && (i[e] = []), i[e].indexOf(t) === -1 && i[e].push(t);
    }
    /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */ hasEventListener(e, t) {
        const i = this._listeners;
        return i === void 0 ? !1 : i[e] !== void 0 && i[e].indexOf(t) !== -1;
    }
    /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */ removeEventListener(e, t) {
        const i = this._listeners;
        if (i === void 0) return;
        const n = i[e];
        if (n !== void 0) {
            const s = n.indexOf(t);
            s !== -1 && n.splice(s, 1);
        }
    }
    /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */ dispatchEvent(e) {
        const t = this._listeners;
        if (t === void 0) return;
        const i = t[e.type];
        if (i !== void 0) {
            e.target = this;
            const n = i.slice(0);
            for(let s = 0, a = n.length; s < a; s++)n[s].call(this, e);
            e.target = null;
        }
    }
};
const $d7238066c5de7f1c$var$Wa = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $d7238066c5de7f1c$var$A5 = 1234567;
const $d7238066c5de7f1c$var$My = Math.PI / 180, $d7238066c5de7f1c$var$MA = 180 / Math.PI;
function $d7238066c5de7f1c$var$hI() {
    const r = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0;
    return ($d7238066c5de7f1c$var$Wa[r & 255] + $d7238066c5de7f1c$var$Wa[r >> 8 & 255] + $d7238066c5de7f1c$var$Wa[r >> 16 & 255] + $d7238066c5de7f1c$var$Wa[r >> 24 & 255] + "-" + $d7238066c5de7f1c$var$Wa[e & 255] + $d7238066c5de7f1c$var$Wa[e >> 8 & 255] + "-" + $d7238066c5de7f1c$var$Wa[e >> 16 & 15 | 64] + $d7238066c5de7f1c$var$Wa[e >> 24 & 255] + "-" + $d7238066c5de7f1c$var$Wa[t & 63 | 128] + $d7238066c5de7f1c$var$Wa[t >> 8 & 255] + "-" + $d7238066c5de7f1c$var$Wa[t >> 16 & 255] + $d7238066c5de7f1c$var$Wa[t >> 24 & 255] + $d7238066c5de7f1c$var$Wa[i & 255] + $d7238066c5de7f1c$var$Wa[i >> 8 & 255] + $d7238066c5de7f1c$var$Wa[i >> 16 & 255] + $d7238066c5de7f1c$var$Wa[i >> 24 & 255]).toLowerCase();
}
function $d7238066c5de7f1c$var$Ni(r, e, t) {
    return Math.max(e, Math.min(t, r));
}
function $d7238066c5de7f1c$var$$N(r, e) {
    return (r % e + e) % e;
}
function $d7238066c5de7f1c$var$u$(r, e, t, i, n) {
    return i + (r - e) * (n - i) / (t - e);
}
function $d7238066c5de7f1c$var$I$(r, e, t) {
    return r !== e ? (t - r) / (e - r) : 0;
}
function $d7238066c5de7f1c$var$zy(r, e, t) {
    return (1 - t) * r + t * e;
}
function $d7238066c5de7f1c$var$d$(r, e, t, i) {
    return $d7238066c5de7f1c$var$zy(r, e, 1 - Math.exp(-t * i));
}
function $d7238066c5de7f1c$var$h$(r, e = 1) {
    return e - Math.abs($d7238066c5de7f1c$var$$N(r, e * 2) - e);
}
function $d7238066c5de7f1c$var$C$(r, e, t) {
    return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * (3 - 2 * r));
}
function $d7238066c5de7f1c$var$p$(r, e, t) {
    return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * r * (r * (r * 6 - 15) + 10));
}
function $d7238066c5de7f1c$var$m$(r, e) {
    return r + Math.floor(Math.random() * (e - r + 1));
}
function $d7238066c5de7f1c$var$A$(r, e) {
    return r + Math.random() * (e - r);
}
function $d7238066c5de7f1c$var$b$(r) {
    return r * (0.5 - Math.random());
}
function $d7238066c5de7f1c$var$y$(r) {
    r !== void 0 && ($d7238066c5de7f1c$var$A5 = r);
    let e = $d7238066c5de7f1c$var$A5 += 1831565813;
    return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function $d7238066c5de7f1c$var$B$(r) {
    return r * $d7238066c5de7f1c$var$My;
}
function $d7238066c5de7f1c$var$f$(r) {
    return r * $d7238066c5de7f1c$var$MA;
}
function $d7238066c5de7f1c$var$G$(r) {
    return (r & r - 1) === 0 && r !== 0;
}
function $d7238066c5de7f1c$var$v$(r) {
    return Math.pow(2, Math.ceil(Math.log(r) / Math.LN2));
}
function $d7238066c5de7f1c$var$S$(r) {
    return Math.pow(2, Math.floor(Math.log(r) / Math.LN2));
}
function $d7238066c5de7f1c$var$Z$(r, e, t, i, n) {
    const s = Math.cos, a = Math.sin, o = s(t / 2), g = a(t / 2), l = s((e + i) / 2), c = a((e + i) / 2), d = s((e - i) / 2), p = a((e - i) / 2), A = s((i - e) / 2), y = a((i - e) / 2);
    switch(n){
        case "XYX":
            r.set(o * c, g * d, g * p, o * l);
            break;
        case "YZY":
            r.set(g * p, o * c, g * d, o * l);
            break;
        case "ZXZ":
            r.set(g * d, g * p, o * c, o * l);
            break;
        case "XZX":
            r.set(o * c, g * y, g * A, o * l);
            break;
        case "YXY":
            r.set(g * A, o * c, g * y, o * l);
            break;
        case "ZYZ":
            r.set(g * y, g * A, o * c, o * l);
            break;
        default:
            $d7238066c5de7f1c$var$ze("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + n);
    }
}
function $d7238066c5de7f1c$var$to(r, e) {
    switch(e.constructor){
        case Float32Array:
            return r;
        case Uint32Array:
            return r / 4294967295;
        case Uint16Array:
            return r / 65535;
        case Uint8Array:
            return r / 255;
        case Int32Array:
            return Math.max(r / 2147483647, -1);
        case Int16Array:
            return Math.max(r / 32767, -1);
        case Int8Array:
            return Math.max(r / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $d7238066c5de7f1c$var$gi(r, e) {
    switch(e.constructor){
        case Float32Array:
            return r;
        case Uint32Array:
            return Math.round(r * 4294967295);
        case Uint16Array:
            return Math.round(r * 65535);
        case Uint8Array:
            return Math.round(r * 255);
        case Int32Array:
            return Math.round(r * 2147483647);
        case Int16Array:
            return Math.round(r * 32767);
        case Int8Array:
            return Math.round(r * 127);
        default:
            throw new Error("Invalid component type.");
    }
}
const $d7238066c5de7f1c$var$o3 = {
    DEG2RAD: $d7238066c5de7f1c$var$My,
    RAD2DEG: $d7238066c5de7f1c$var$MA,
    /**
   * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */ generateUUID: $d7238066c5de7f1c$var$hI,
    /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */ clamp: $d7238066c5de7f1c$var$Ni,
    /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */ euclideanModulo: $d7238066c5de7f1c$var$$N,
    /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */ mapLinear: $d7238066c5de7f1c$var$u$,
    /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */ inverseLerp: $d7238066c5de7f1c$var$I$,
    /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */ lerp: $d7238066c5de7f1c$var$zy,
    /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */ damp: $d7238066c5de7f1c$var$d$,
    /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */ pingpong: $d7238066c5de7f1c$var$h$,
    /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */ smoothstep: $d7238066c5de7f1c$var$C$,
    /**
   * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */ smootherstep: $d7238066c5de7f1c$var$p$,
    /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */ randInt: $d7238066c5de7f1c$var$m$,
    /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */ randFloat: $d7238066c5de7f1c$var$A$,
    /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */ randFloatSpread: $d7238066c5de7f1c$var$b$,
    /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */ seededRandom: $d7238066c5de7f1c$var$y$,
    /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */ degToRad: $d7238066c5de7f1c$var$B$,
    /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */ radToDeg: $d7238066c5de7f1c$var$f$,
    /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */ isPowerOfTwo: $d7238066c5de7f1c$var$G$,
    /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */ ceilPowerOfTwo: $d7238066c5de7f1c$var$v$,
    /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */ floorPowerOfTwo: $d7238066c5de7f1c$var$S$,
    /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */ setQuaternionFromProperEuler: $d7238066c5de7f1c$var$Z$,
    /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */ normalize: $d7238066c5de7f1c$var$gi,
    /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */ denormalize: $d7238066c5de7f1c$var$to
};
class $d7238066c5de7f1c$var$Ii {
    /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */ constructor(e = 0, t = 0){
        $d7238066c5de7f1c$var$Ii.prototype.isVector2 = !0, this.x = e, this.y = t;
    }
    /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */ get width() {
        return this.x;
    }
    set width(e) {
        this.x = e;
    }
    /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */ get height() {
        return this.y;
    }
    set height(e) {
        this.y = e;
    }
    /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */ set(e, t) {
        return this.x = e, this.y = t, this;
    }
    /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */ setScalar(e) {
        return this.x = e, this.y = e, this;
    }
    /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */ setX(e) {
        return this.x = e, this;
    }
    /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */ setY(e) {
        return this.y = e, this;
    }
    /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */ setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            default:
                throw new Error("index is out of range: " + e);
        }
        return this;
    }
    /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */ getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + e);
        }
    }
    /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */ copy(e) {
        return this.x = e.x, this.y = e.y, this;
    }
    /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */ add(e) {
        return this.x += e.x, this.y += e.y, this;
    }
    /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */ addScalar(e) {
        return this.x += e, this.y += e, this;
    }
    /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */ addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this;
    }
    /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */ addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this;
    }
    /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */ sub(e) {
        return this.x -= e.x, this.y -= e.y, this;
    }
    /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */ subScalar(e) {
        return this.x -= e, this.y -= e, this;
    }
    /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */ subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this;
    }
    /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */ multiply(e) {
        return this.x *= e.x, this.y *= e.y, this;
    }
    /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */ multiplyScalar(e) {
        return this.x *= e, this.y *= e, this;
    }
    /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */ divide(e) {
        return this.x /= e.x, this.y /= e.y, this;
    }
    /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */ divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */ applyMatrix3(e) {
        const t = this.x, i = this.y, n = e.elements;
        return this.x = n[0] * t + n[3] * i + n[6], this.y = n[1] * t + n[4] * i + n[7], this;
    }
    /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */ min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
    }
    /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */ max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
    }
    /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */ clamp(e, t) {
        return this.x = $d7238066c5de7f1c$var$Ni(this.x, e.x, t.x), this.y = $d7238066c5de7f1c$var$Ni(this.y, e.y, t.y), this;
    }
    /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */ clampScalar(e, t) {
        return this.x = $d7238066c5de7f1c$var$Ni(this.x, e, t), this.y = $d7238066c5de7f1c$var$Ni(this.y, e, t), this;
    }
    /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */ clampLength(e, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($d7238066c5de7f1c$var$Ni(i, e, t));
    }
    /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */ floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */ ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */ round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */ roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
    }
    /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */ negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */ dot(e) {
        return this.x * e.x + this.y * e.y;
    }
    /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */ cross(e) {
        return this.x * e.y - this.y * e.x;
    }
    /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */ angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */ angleTo(e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (t === 0) return Math.PI / 2;
        const i = this.dot(e) / t;
        return Math.acos($d7238066c5de7f1c$var$Ni(i, -1, 1));
    }
    /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */ distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
    }
    /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */ distanceToSquared(e) {
        const t = this.x - e.x, i = this.y - e.y;
        return t * t + i * i;
    }
    /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */ manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
    }
    /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */ setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */ lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
    }
    /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */ lerpVectors(e, t, i) {
        return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this;
    }
    /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */ equals(e) {
        return e.x === this.x && e.y === this.y;
    }
    /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */ fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this;
    }
    /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */ toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e;
    }
    /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */ fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this;
    }
    /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */ rotateAround(e, t) {
        const i = Math.cos(t), n = Math.sin(t), s = this.x - e.x, a = this.y - e.y;
        return this.x = s * i - a * n + e.x, this.y = s * n + a * i + e.y, this;
    }
    /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */ random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}
class $d7238066c5de7f1c$var$t0 {
    /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */ constructor(e = 0, t = 0, i = 0, n = 1){
        this.isQuaternion = !0, this._x = e, this._y = t, this._z = i, this._w = n;
    }
    /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */ static slerpFlat(e, t, i, n, s, a, o) {
        let g = i[n + 0], l = i[n + 1], c = i[n + 2], d = i[n + 3], p = s[a + 0], A = s[a + 1], y = s[a + 2], G = s[a + 3];
        if (o <= 0) {
            e[t + 0] = g, e[t + 1] = l, e[t + 2] = c, e[t + 3] = d;
            return;
        }
        if (o >= 1) {
            e[t + 0] = p, e[t + 1] = A, e[t + 2] = y, e[t + 3] = G;
            return;
        }
        if (d !== G || g !== p || l !== A || c !== y) {
            let Z = g * p + l * A + c * y + d * G;
            Z < 0 && (p = -p, A = -A, y = -y, G = -G, Z = -Z);
            let v = 1 - o;
            if (Z < 0.9995) {
                const V = Math.acos(Z), H = Math.sin(V);
                v = Math.sin(v * V) / H, o = Math.sin(o * V) / H, g = g * v + p * o, l = l * v + A * o, c = c * v + y * o, d = d * v + G * o;
            } else {
                g = g * v + p * o, l = l * v + A * o, c = c * v + y * o, d = d * v + G * o;
                const V = 1 / Math.sqrt(g * g + l * l + c * c + d * d);
                g *= V, l *= V, c *= V, d *= V;
            }
        }
        e[t] = g, e[t + 1] = l, e[t + 2] = c, e[t + 3] = d;
    }
    /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */ static multiplyQuaternionsFlat(e, t, i, n, s, a) {
        const o = i[n], g = i[n + 1], l = i[n + 2], c = i[n + 3], d = s[a], p = s[a + 1], A = s[a + 2], y = s[a + 3];
        return e[t] = o * y + c * d + g * A - l * p, e[t + 1] = g * y + c * p + l * d - o * A, e[t + 2] = l * y + c * A + o * p - g * d, e[t + 3] = c * y - o * d - g * p - l * A, e;
    }
    /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(e) {
        this._x = e, this._onChangeCallback();
    }
    /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(e) {
        this._y = e, this._onChangeCallback();
    }
    /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */ get z() {
        return this._z;
    }
    set z(e) {
        this._z = e, this._onChangeCallback();
    }
    /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */ get w() {
        return this._w;
    }
    set w(e) {
        this._w = e, this._onChangeCallback();
    }
    /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */ set(e, t, i, n) {
        return this._x = e, this._y = t, this._z = i, this._w = n, this._onChangeCallback(), this;
    }
    /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */ copy(e) {
        return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
    }
    /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */ setFromEuler(e, t = !0) {
        const i = e._x, n = e._y, s = e._z, a = e._order, o = Math.cos, g = Math.sin, l = o(i / 2), c = o(n / 2), d = o(s / 2), p = g(i / 2), A = g(n / 2), y = g(s / 2);
        switch(a){
            case "XYZ":
                this._x = p * c * d + l * A * y, this._y = l * A * d - p * c * y, this._z = l * c * y + p * A * d, this._w = l * c * d - p * A * y;
                break;
            case "YXZ":
                this._x = p * c * d + l * A * y, this._y = l * A * d - p * c * y, this._z = l * c * y - p * A * d, this._w = l * c * d + p * A * y;
                break;
            case "ZXY":
                this._x = p * c * d - l * A * y, this._y = l * A * d + p * c * y, this._z = l * c * y + p * A * d, this._w = l * c * d - p * A * y;
                break;
            case "ZYX":
                this._x = p * c * d - l * A * y, this._y = l * A * d + p * c * y, this._z = l * c * y - p * A * d, this._w = l * c * d + p * A * y;
                break;
            case "YZX":
                this._x = p * c * d + l * A * y, this._y = l * A * d + p * c * y, this._z = l * c * y - p * A * d, this._w = l * c * d - p * A * y;
                break;
            case "XZY":
                this._x = p * c * d - l * A * y, this._y = l * A * d - p * c * y, this._z = l * c * y + p * A * d, this._w = l * c * d + p * A * y;
                break;
            default:
                $d7238066c5de7f1c$var$ze("Quaternion: .setFromEuler() encountered an unknown order: " + a);
        }
        return t === !0 && this._onChangeCallback(), this;
    }
    /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */ setFromAxisAngle(e, t) {
        const i = t / 2, n = Math.sin(i);
        return this._x = e.x * n, this._y = e.y * n, this._z = e.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
    }
    /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */ setFromRotationMatrix(e) {
        const t = e.elements, i = t[0], n = t[4], s = t[8], a = t[1], o = t[5], g = t[9], l = t[2], c = t[6], d = t[10], p = i + o + d;
        if (p > 0) {
            const A = 0.5 / Math.sqrt(p + 1);
            this._w = 0.25 / A, this._x = (c - g) * A, this._y = (s - l) * A, this._z = (a - n) * A;
        } else if (i > o && i > d) {
            const A = 2 * Math.sqrt(1 + i - o - d);
            this._w = (c - g) / A, this._x = 0.25 * A, this._y = (n + a) / A, this._z = (s + l) / A;
        } else if (o > d) {
            const A = 2 * Math.sqrt(1 + o - i - d);
            this._w = (s - l) / A, this._x = (n + a) / A, this._y = 0.25 * A, this._z = (g + c) / A;
        } else {
            const A = 2 * Math.sqrt(1 + d - i - o);
            this._w = (a - n) / A, this._x = (s + l) / A, this._y = (g + c) / A, this._z = 0.25 * A;
        }
        return this._onChangeCallback(), this;
    }
    /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */ setFromUnitVectors(e, t) {
        let i = e.dot(t) + 1;
        return i < 1e-8 ? (i = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = i)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = i), this.normalize();
    }
    /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */ angleTo(e) {
        return 2 * Math.acos(Math.abs($d7238066c5de7f1c$var$Ni(this.dot(e), -1, 1)));
    }
    /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */ rotateTowards(e, t) {
        const i = this.angleTo(e);
        if (i === 0) return this;
        const n = Math.min(1, t / i);
        return this.slerp(e, n), this;
    }
    /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */ invert() {
        return this.conjugate();
    }
    /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */ conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */ dot(e) {
        return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
    }
    /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */ normalize() {
        let e = this.length();
        return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
    }
    /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */ multiply(e) {
        return this.multiplyQuaternions(this, e);
    }
    /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */ premultiply(e) {
        return this.multiplyQuaternions(e, this);
    }
    /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */ multiplyQuaternions(e, t) {
        const i = e._x, n = e._y, s = e._z, a = e._w, o = t._x, g = t._y, l = t._z, c = t._w;
        return this._x = i * c + a * o + n * l - s * g, this._y = n * c + a * g + s * o - i * l, this._z = s * c + a * l + i * g - n * o, this._w = a * c - i * o - n * g - s * l, this._onChangeCallback(), this;
    }
    /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */ slerp(e, t) {
        if (t <= 0) return this;
        if (t >= 1) return this.copy(e);
        let i = e._x, n = e._y, s = e._z, a = e._w, o = this.dot(e);
        o < 0 && (i = -i, n = -n, s = -s, a = -a, o = -o);
        let g = 1 - t;
        if (o < 0.9995) {
            const l = Math.acos(o), c = Math.sin(l);
            g = Math.sin(g * l) / c, t = Math.sin(t * l) / c, this._x = this._x * g + i * t, this._y = this._y * g + n * t, this._z = this._z * g + s * t, this._w = this._w * g + a * t, this._onChangeCallback();
        } else this._x = this._x * g + i * t, this._y = this._y * g + n * t, this._z = this._z * g + s * t, this._w = this._w * g + a * t, this.normalize();
        return this;
    }
    /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */ slerpQuaternions(e, t, i) {
        return this.copy(e).slerp(t, i);
    }
    /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */ random() {
        const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), i = Math.random(), n = Math.sqrt(1 - i), s = Math.sqrt(i);
        return this.set(n * Math.sin(e), n * Math.cos(e), s * Math.sin(t), s * Math.cos(t));
    }
    /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */ equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
    }
    /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */ fromArray(e, t = 0) {
        return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
    }
    /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */ toArray(e = [], t = 0) {
        return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
    }
    /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */ fromBufferAttribute(e, t) {
        return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
    }
    /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */ toJSON() {
        return this.toArray();
    }
    _onChange(e) {
        return this._onChangeCallback = e, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}
class $d7238066c5de7f1c$var$Ce {
    /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */ constructor(e = 0, t = 0, i = 0){
        $d7238066c5de7f1c$var$Ce.prototype.isVector3 = !0, this.x = e, this.y = t, this.z = i;
    }
    /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */ set(e, t, i) {
        return i === void 0 && (i = this.z), this.x = e, this.y = t, this.z = i, this;
    }
    /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */ setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this;
    }
    /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */ setX(e) {
        return this.x = e, this;
    }
    /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */ setY(e) {
        return this.y = e, this;
    }
    /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */ setZ(e) {
        return this.z = e, this;
    }
    /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */ setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            default:
                throw new Error("index is out of range: " + e);
        }
        return this;
    }
    /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */ getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + e);
        }
    }
    /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */ copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this;
    }
    /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */ add(e) {
        return this.x += e.x, this.y += e.y, this.z += e.z, this;
    }
    /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */ addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this;
    }
    /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */ addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
    }
    /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */ addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
    }
    /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */ sub(e) {
        return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
    }
    /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */ subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this;
    }
    /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */ subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
    }
    /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */ multiply(e) {
        return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
    }
    /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */ multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this;
    }
    /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */ multiplyVectors(e, t) {
        return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
    }
    /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */ applyEuler(e) {
        return this.applyQuaternion($d7238066c5de7f1c$var$b5.setFromEuler(e));
    }
    /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */ applyAxisAngle(e, t) {
        return this.applyQuaternion($d7238066c5de7f1c$var$b5.setFromAxisAngle(e, t));
    }
    /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */ applyMatrix3(e) {
        const t = this.x, i = this.y, n = this.z, s = e.elements;
        return this.x = s[0] * t + s[3] * i + s[6] * n, this.y = s[1] * t + s[4] * i + s[7] * n, this.z = s[2] * t + s[5] * i + s[8] * n, this;
    }
    /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */ applyNormalMatrix(e) {
        return this.applyMatrix3(e).normalize();
    }
    /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */ applyMatrix4(e) {
        const t = this.x, i = this.y, n = this.z, s = e.elements, a = 1 / (s[3] * t + s[7] * i + s[11] * n + s[15]);
        return this.x = (s[0] * t + s[4] * i + s[8] * n + s[12]) * a, this.y = (s[1] * t + s[5] * i + s[9] * n + s[13]) * a, this.z = (s[2] * t + s[6] * i + s[10] * n + s[14]) * a, this;
    }
    /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */ applyQuaternion(e) {
        const t = this.x, i = this.y, n = this.z, s = e.x, a = e.y, o = e.z, g = e.w, l = 2 * (a * n - o * i), c = 2 * (o * t - s * n), d = 2 * (s * i - a * t);
        return this.x = t + g * l + a * d - o * c, this.y = i + g * c + o * l - s * d, this.z = n + g * d + s * c - a * l, this;
    }
    /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */ project(e) {
        return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
    }
    /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */ unproject(e) {
        return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
    }
    /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */ transformDirection(e) {
        const t = this.x, i = this.y, n = this.z, s = e.elements;
        return this.x = s[0] * t + s[4] * i + s[8] * n, this.y = s[1] * t + s[5] * i + s[9] * n, this.z = s[2] * t + s[6] * i + s[10] * n, this.normalize();
    }
    /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */ divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
    }
    /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */ divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */ min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
    }
    /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */ max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
    }
    /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */ clamp(e, t) {
        return this.x = $d7238066c5de7f1c$var$Ni(this.x, e.x, t.x), this.y = $d7238066c5de7f1c$var$Ni(this.y, e.y, t.y), this.z = $d7238066c5de7f1c$var$Ni(this.z, e.z, t.z), this;
    }
    /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */ clampScalar(e, t) {
        return this.x = $d7238066c5de7f1c$var$Ni(this.x, e, t), this.y = $d7238066c5de7f1c$var$Ni(this.y, e, t), this.z = $d7238066c5de7f1c$var$Ni(this.z, e, t), this;
    }
    /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */ clampLength(e, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($d7238066c5de7f1c$var$Ni(i, e, t));
    }
    /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */ floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */ ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */ round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */ roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
    }
    /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */ negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */ dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z;
    }
    // TODO lengthSquared?
    /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */ setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */ lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
    }
    /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */ lerpVectors(e, t, i) {
        return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this.z = e.z + (t.z - e.z) * i, this;
    }
    /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */ cross(e) {
        return this.crossVectors(this, e);
    }
    /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */ crossVectors(e, t) {
        const i = e.x, n = e.y, s = e.z, a = t.x, o = t.y, g = t.z;
        return this.x = n * g - s * o, this.y = s * a - i * g, this.z = i * o - n * a, this;
    }
    /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */ projectOnVector(e) {
        const t = e.lengthSq();
        if (t === 0) return this.set(0, 0, 0);
        const i = e.dot(this) / t;
        return this.copy(e).multiplyScalar(i);
    }
    /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */ projectOnPlane(e) {
        return $d7238066c5de7f1c$var$MW.copy(this).projectOnVector(e), this.sub($d7238066c5de7f1c$var$MW);
    }
    /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */ reflect(e) {
        return this.sub($d7238066c5de7f1c$var$MW.copy(e).multiplyScalar(2 * this.dot(e)));
    }
    /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */ angleTo(e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (t === 0) return Math.PI / 2;
        const i = this.dot(e) / t;
        return Math.acos($d7238066c5de7f1c$var$Ni(i, -1, 1));
    }
    /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */ distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
    }
    /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */ distanceToSquared(e) {
        const t = this.x - e.x, i = this.y - e.y, n = this.z - e.z;
        return t * t + i * i + n * n;
    }
    /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */ manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
    }
    /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */ setFromSpherical(e) {
        return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
    }
    /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */ setFromSphericalCoords(e, t, i) {
        const n = Math.sin(t) * e;
        return this.x = n * Math.sin(i), this.y = Math.cos(t) * e, this.z = n * Math.cos(i), this;
    }
    /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */ setFromCylindrical(e) {
        return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
    }
    /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */ setFromCylindricalCoords(e, t, i) {
        return this.x = e * Math.sin(t), this.y = i, this.z = e * Math.cos(t), this;
    }
    /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */ setFromMatrixPosition(e) {
        const t = e.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this;
    }
    /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */ setFromMatrixScale(e) {
        const t = this.setFromMatrixColumn(e, 0).length(), i = this.setFromMatrixColumn(e, 1).length(), n = this.setFromMatrixColumn(e, 2).length();
        return this.x = t, this.y = i, this.z = n, this;
    }
    /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */ setFromMatrixColumn(e, t) {
        return this.fromArray(e.elements, t * 4);
    }
    /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */ setFromMatrix3Column(e, t) {
        return this.fromArray(e.elements, t * 3);
    }
    /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */ setFromEuler(e) {
        return this.x = e._x, this.y = e._y, this.z = e._z, this;
    }
    /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */ setFromColor(e) {
        return this.x = e.r, this.y = e.g, this.z = e.b, this;
    }
    /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */ equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z;
    }
    /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */ fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
    }
    /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */ toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
    }
    /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */ fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
    }
    /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */ random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */ randomDirection() {
        const e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, i = Math.sqrt(1 - t * t);
        return this.x = i * Math.cos(e), this.y = t, this.z = i * Math.sin(e), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}
const $d7238066c5de7f1c$var$MW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$b5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$t0();
class $d7238066c5de7f1c$var$Lo {
    /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */ constructor(e, t, i, n, s, a, o, g, l){
        $d7238066c5de7f1c$var$Lo.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], e !== void 0 && this.set(e, t, i, n, s, a, o, g, l);
    }
    /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */ set(e, t, i, n, s, a, o, g, l) {
        const c = this.elements;
        return c[0] = e, c[1] = n, c[2] = o, c[3] = t, c[4] = s, c[5] = g, c[6] = i, c[7] = a, c[8] = l, this;
    }
    /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */ identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */ copy(e) {
        const t = this.elements, i = e.elements;
        return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], this;
    }
    /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */ extractBasis(e, t, i) {
        return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
    }
    /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */ setFromMatrix4(e) {
        const t = e.elements;
        return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
    }
    /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */ multiply(e) {
        return this.multiplyMatrices(this, e);
    }
    /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */ premultiply(e) {
        return this.multiplyMatrices(e, this);
    }
    /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */ multiplyMatrices(e, t) {
        const i = e.elements, n = t.elements, s = this.elements, a = i[0], o = i[3], g = i[6], l = i[1], c = i[4], d = i[7], p = i[2], A = i[5], y = i[8], G = n[0], Z = n[3], v = n[6], V = n[1], H = n[4], N = n[7], Y = n[2], K = n[5], z = n[8];
        return s[0] = a * G + o * V + g * Y, s[3] = a * Z + o * H + g * K, s[6] = a * v + o * N + g * z, s[1] = l * G + c * V + d * Y, s[4] = l * Z + c * H + d * K, s[7] = l * v + c * N + d * z, s[2] = p * G + A * V + y * Y, s[5] = p * Z + A * H + y * K, s[8] = p * v + A * N + y * z, this;
    }
    /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */ multiplyScalar(e) {
        const t = this.elements;
        return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
    }
    /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */ determinant() {
        const e = this.elements, t = e[0], i = e[1], n = e[2], s = e[3], a = e[4], o = e[5], g = e[6], l = e[7], c = e[8];
        return t * a * c - t * o * l - i * s * c + i * o * g + n * s * l - n * a * g;
    }
    /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */ invert() {
        const e = this.elements, t = e[0], i = e[1], n = e[2], s = e[3], a = e[4], o = e[5], g = e[6], l = e[7], c = e[8], d = c * a - o * l, p = o * g - c * s, A = l * s - a * g, y = t * d + i * p + n * A;
        if (y === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const G = 1 / y;
        return e[0] = d * G, e[1] = (n * l - c * i) * G, e[2] = (o * i - n * a) * G, e[3] = p * G, e[4] = (c * t - n * g) * G, e[5] = (n * s - o * t) * G, e[6] = A * G, e[7] = (i * g - l * t) * G, e[8] = (a * t - i * s) * G, this;
    }
    /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */ transpose() {
        let e;
        const t = this.elements;
        return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
    }
    /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */ getNormalMatrix(e) {
        return this.setFromMatrix4(e).invert().transpose();
    }
    /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */ transposeIntoArray(e) {
        const t = this.elements;
        return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
    }
    /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */ setUvTransform(e, t, i, n, s, a, o) {
        const g = Math.cos(s), l = Math.sin(s);
        return this.set(i * g, i * l, -i * (g * a + l * o) + a + e, -n * l, n * g, -n * (-l * a + g * o) + o + t, 0, 0, 1), this;
    }
    /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */ scale(e, t) {
        return this.premultiply($d7238066c5de7f1c$var$zW.makeScale(e, t)), this;
    }
    /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */ rotate(e) {
        return this.premultiply($d7238066c5de7f1c$var$zW.makeRotation(-e)), this;
    }
    /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */ translate(e, t) {
        return this.premultiply($d7238066c5de7f1c$var$zW.makeTranslation(e, t)), this;
    }
    // for 2D Transforms
    /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */ makeTranslation(e, t) {
        return e.isVector2 ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1) : this.set(1, 0, e, 0, 1, t, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */ makeRotation(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(t, -i, 0, i, t, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */ makeScale(e, t) {
        return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this;
    }
    /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */ equals(e) {
        const t = this.elements, i = e.elements;
        for(let n = 0; n < 9; n++)if (t[n] !== i[n]) return !1;
        return !0;
    }
    /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */ fromArray(e, t = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = e[i + t];
        return this;
    }
    /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */ toArray(e = [], t = 0) {
        const i = this.elements;
        return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e;
    }
    /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $d7238066c5de7f1c$var$zW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Lo(), $d7238066c5de7f1c$var$y5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Lo().set(0.4123908, 0.3575843, 0.1804808, 0.212639, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322), $d7238066c5de7f1c$var$B5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Lo().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $d7238066c5de7f1c$var$R$() {
    const r = {
        enabled: !0,
        workingColorSpace: $d7238066c5de7f1c$var$fZ,
        /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */ spaces: {},
        convert: function(n, s, a) {
            return this.enabled === !1 || s === a || !s || !a || (this.spaces[s].transfer === $d7238066c5de7f1c$var$Qt && (n.r = $d7238066c5de7f1c$var$CI(n.r), n.g = $d7238066c5de7f1c$var$CI(n.g), n.b = $d7238066c5de7f1c$var$CI(n.b)), this.spaces[s].primaries !== this.spaces[a].primaries && (n.applyMatrix3(this.spaces[s].toXYZ), n.applyMatrix3(this.spaces[a].fromXYZ)), this.spaces[a].transfer === $d7238066c5de7f1c$var$Qt && (n.r = $d7238066c5de7f1c$var$vA(n.r), n.g = $d7238066c5de7f1c$var$vA(n.g), n.b = $d7238066c5de7f1c$var$vA(n.b))), n;
        },
        workingToColorSpace: function(n, s) {
            return this.convert(n, this.workingColorSpace, s);
        },
        colorSpaceToWorking: function(n, s) {
            return this.convert(n, s, this.workingColorSpace);
        },
        getPrimaries: function(n) {
            return this.spaces[n].primaries;
        },
        getTransfer: function(n) {
            return n === $d7238066c5de7f1c$var$gh ? $d7238066c5de7f1c$var$GZ : this.spaces[n].transfer;
        },
        getToneMappingMode: function(n) {
            return this.spaces[n].outputColorSpaceConfig.toneMappingMode || "standard";
        },
        getLuminanceCoefficients: function(n, s = this.workingColorSpace) {
            return n.fromArray(this.spaces[s].luminanceCoefficients);
        },
        define: function(n) {
            Object.assign(this.spaces, n);
        },
        // Internal APIs
        _getMatrix: function(n, s, a) {
            return n.copy(this.spaces[s].toXYZ).multiply(this.spaces[a].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(n) {
            return this.spaces[n].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(n = this.workingColorSpace) {
            return this.spaces[n].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(n, s) {
            return $d7238066c5de7f1c$var$es("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), r.workingToColorSpace(n, s);
        },
        toWorkingColorSpace: function(n, s) {
            return $d7238066c5de7f1c$var$es("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), r.colorSpaceToWorking(n, s);
        }
    }, e = [
        0.64,
        0.33,
        0.3,
        0.6,
        0.15,
        0.06
    ], t = [
        0.2126,
        0.7152,
        0.0722
    ], i = [
        0.3127,
        0.329
    ];
    return r.define({
        [$d7238066c5de7f1c$var$fZ]: {
            primaries: e,
            whitePoint: i,
            transfer: $d7238066c5de7f1c$var$GZ,
            toXYZ: $d7238066c5de7f1c$var$y5,
            fromXYZ: $d7238066c5de7f1c$var$B5,
            luminanceCoefficients: t,
            workingColorSpaceConfig: {
                unpackColorSpace: $d7238066c5de7f1c$var$$o
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $d7238066c5de7f1c$var$$o
            }
        },
        [$d7238066c5de7f1c$var$$o]: {
            primaries: e,
            whitePoint: i,
            transfer: $d7238066c5de7f1c$var$Qt,
            toXYZ: $d7238066c5de7f1c$var$y5,
            fromXYZ: $d7238066c5de7f1c$var$B5,
            luminanceCoefficients: t,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $d7238066c5de7f1c$var$$o
            }
        }
    }), r;
}
const $d7238066c5de7f1c$var$sn = /* @__PURE__ */ $d7238066c5de7f1c$var$R$();
function $d7238066c5de7f1c$var$CI(r) {
    return r < 0.04045 ? r * 0.0773993808 : Math.pow(r * 0.9478672986 + 0.0521327014, 2.4);
}
function $d7238066c5de7f1c$var$vA(r) {
    return r < 31308e-7 ? r * 12.92 : 1.055 * Math.pow(r, 0.41666) - 0.055;
}
let $d7238066c5de7f1c$var$vm;
class $d7238066c5de7f1c$var$V$ {
    /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */ static getDataURL(e, t = "image/png") {
        if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u") return e.src;
        let i;
        if (e instanceof HTMLCanvasElement) i = e;
        else {
            $d7238066c5de7f1c$var$vm === void 0 && ($d7238066c5de7f1c$var$vm = $d7238066c5de7f1c$var$SZ("canvas")), $d7238066c5de7f1c$var$vm.width = e.width, $d7238066c5de7f1c$var$vm.height = e.height;
            const n = $d7238066c5de7f1c$var$vm.getContext("2d");
            e instanceof ImageData ? n.putImageData(e, 0, 0) : n.drawImage(e, 0, 0, e.width, e.height), i = $d7238066c5de7f1c$var$vm;
        }
        return i.toDataURL(t);
    }
    /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */ static sRGBToLinear(e) {
        if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
            const t = $d7238066c5de7f1c$var$SZ("canvas");
            t.width = e.width, t.height = e.height;
            const i = t.getContext("2d");
            i.drawImage(e, 0, 0, e.width, e.height);
            const n = i.getImageData(0, 0, e.width, e.height), s = n.data;
            for(let a = 0; a < s.length; a++)s[a] = $d7238066c5de7f1c$var$CI(s[a] / 255) * 255;
            return i.putImageData(n, 0, 0), t;
        } else if (e.data) {
            const t = e.data.slice(0);
            for(let i = 0; i < t.length; i++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[i] = Math.floor($d7238066c5de7f1c$var$CI(t[i] / 255) * 255) : t[i] = $d7238066c5de7f1c$var$CI(t[i]);
            return {
                data: t,
                width: e.width,
                height: e.height
            };
        } else return $d7238066c5de7f1c$var$ze("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
    }
}
let $d7238066c5de7f1c$var$w$ = 0;
class $d7238066c5de7f1c$var$eL {
    /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */ constructor(e = null){
        this.isSource = !0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$w$++
        }), this.uuid = $d7238066c5de7f1c$var$hI(), this.data = e, this.dataReady = !0, this.version = 0;
    }
    /**
   * Returns the dimensions of the source into the given target vector.
   *
   * @param {(Vector2|Vector3)} target - The target object the result is written into.
   * @return {(Vector2|Vector3)} The dimensions of the source.
   */ getSize(e) {
        const t = this.data;
        return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : t instanceof VideoFrame ? e.set(t.displayHeight, t.displayWidth, 0) : t !== null ? e.set(t.width, t.height, t.depth || 0) : e.set(0, 0, 0), e;
    }
    /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        e === !0 && this.version++;
    }
    /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */ toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid];
        const i = {
            uuid: this.uuid,
            url: ""
        }, n = this.data;
        if (n !== null) {
            let s;
            if (Array.isArray(n)) {
                s = [];
                for(let a = 0, o = n.length; a < o; a++)n[a].isDataTexture ? s.push($d7238066c5de7f1c$var$kW(n[a].image)) : s.push($d7238066c5de7f1c$var$kW(n[a]));
            } else s = $d7238066c5de7f1c$var$kW(n);
            i.url = s;
        }
        return t || (e.images[this.uuid] = i), i;
    }
}
function $d7238066c5de7f1c$var$kW(r) {
    return typeof HTMLImageElement < "u" && r instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r instanceof ImageBitmap ? $d7238066c5de7f1c$var$V$.getDataURL(r) : r.data ? {
        data: Array.from(r.data),
        width: r.width,
        height: r.height,
        type: r.data.constructor.name
    } : ($d7238066c5de7f1c$var$ze("Texture: Unable to serialize Texture."), {});
}
let $d7238066c5de7f1c$var$W$ = 0;
const $d7238066c5de7f1c$var$EW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$Ca extends $d7238066c5de7f1c$var$wI {
    /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */ constructor(e = $d7238066c5de7f1c$var$Ca.DEFAULT_IMAGE, t = $d7238066c5de7f1c$var$Ca.DEFAULT_MAPPING, i = $d7238066c5de7f1c$var$qc, n = $d7238066c5de7f1c$var$qc, s = $d7238066c5de7f1c$var$ro, a = $d7238066c5de7f1c$var$II, o = $d7238066c5de7f1c$var$sg, g = $d7238066c5de7f1c$var$Ya, l = $d7238066c5de7f1c$var$Ca.DEFAULT_ANISOTROPY, c = $d7238066c5de7f1c$var$gh){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$W$++
        }), this.uuid = $d7238066c5de7f1c$var$hI(), this.name = "", this.source = new $d7238066c5de7f1c$var$eL(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = s, this.minFilter = a, this.anisotropy = l, this.format = o, this.internalFormat = null, this.type = g, this.offset = new $d7238066c5de7f1c$var$Ii(0, 0), this.repeat = new $d7238066c5de7f1c$var$Ii(1, 1), this.center = new $d7238066c5de7f1c$var$Ii(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $d7238066c5de7f1c$var$Lo(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = c, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0;
    }
    /**
   * The width of the texture in pixels.
   */ get width() {
        return this.source.getSize($d7238066c5de7f1c$var$EW).x;
    }
    /**
   * The height of the texture in pixels.
   */ get height() {
        return this.source.getSize($d7238066c5de7f1c$var$EW).y;
    }
    /**
   * The depth of the texture in pixels.
   */ get depth() {
        return this.source.getSize($d7238066c5de7f1c$var$EW).z;
    }
    /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */ get image() {
        return this.source.data;
    }
    set image(e = null) {
        this.source.data = e;
    }
    /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
   * Adds a range of data in the data texture to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */ addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    /**
   * Clears the update ranges.
   */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */ copy(e) {
        return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
    }
    /**
   * Sets this texture's properties based on `values`.
   * @param {Object} values - A container with texture parameters.
   */ setValues(e) {
        for(const t in e){
            const i = e[t];
            if (i === void 0) {
                $d7238066c5de7f1c$var$ze(`Texture.setValues(): parameter '${t}' has value of undefined.`);
                continue;
            }
            const n = this[t];
            if (n === void 0) {
                $d7238066c5de7f1c$var$ze(`Texture.setValues(): property '${t}' does not exist.`);
                continue;
            }
            n && i && n.isVector2 && i.isVector2 || n && i && n.isVector3 && i.isVector3 || n && i && n.isMatrix3 && i.isMatrix3 ? n.copy(i) : this[t] = i;
        }
    }
    /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */ toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        if (!t && e.textures[this.uuid] !== void 0) return e.textures[this.uuid];
        const i = {
            metadata: {
                version: 4.7,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(e).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (i.userData = this.userData), t || (e.textures[this.uuid] = i), i;
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */ transformUv(e) {
        if (this.mapping !== $d7238066c5de7f1c$var$_N) return e;
        if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1) switch(this.wrapS){
            case $d7238066c5de7f1c$var$FA:
                e.x = e.x - Math.floor(e.x);
                break;
            case $d7238066c5de7f1c$var$qc:
                e.x = e.x < 0 ? 0 : 1;
                break;
            case $d7238066c5de7f1c$var$TA:
                Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
                break;
        }
        if (e.y < 0 || e.y > 1) switch(this.wrapT){
            case $d7238066c5de7f1c$var$FA:
                e.y = e.y - Math.floor(e.y);
                break;
            case $d7238066c5de7f1c$var$qc:
                e.y = e.y < 0 ? 0 : 1;
                break;
            case $d7238066c5de7f1c$var$TA:
                Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
                break;
        }
        return this.flipY && (e.y = 1 - e.y), e;
    }
    /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        e === !0 && (this.version++, this.source.needsUpdate = !0);
    }
    /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */ set needsPMREMUpdate(e) {
        e === !0 && this.pmremVersion++;
    }
}
$d7238066c5de7f1c$var$Ca.DEFAULT_IMAGE = null;
$d7238066c5de7f1c$var$Ca.DEFAULT_MAPPING = $d7238066c5de7f1c$var$_N;
$d7238066c5de7f1c$var$Ca.DEFAULT_ANISOTROPY = 1;
class $d7238066c5de7f1c$var$Gi {
    /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */ constructor(e = 0, t = 0, i = 0, n = 1){
        $d7238066c5de7f1c$var$Gi.prototype.isVector4 = !0, this.x = e, this.y = t, this.z = i, this.w = n;
    }
    /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */ get width() {
        return this.z;
    }
    set width(e) {
        this.z = e;
    }
    /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */ get height() {
        return this.w;
    }
    set height(e) {
        this.w = e;
    }
    /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */ set(e, t, i, n) {
        return this.x = e, this.y = t, this.z = i, this.w = n, this;
    }
    /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */ setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this.w = e, this;
    }
    /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */ setX(e) {
        return this.x = e, this;
    }
    /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */ setY(e) {
        return this.y = e, this;
    }
    /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */ setZ(e) {
        return this.z = e, this;
    }
    /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */ setW(e) {
        return this.w = e, this;
    }
    /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */ setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            case 3:
                this.w = t;
                break;
            default:
                throw new Error("index is out of range: " + e);
        }
        return this;
    }
    /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */ getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + e);
        }
    }
    /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */ copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
    }
    /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */ add(e) {
        return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
    }
    /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */ addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this.w += e, this;
    }
    /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */ addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
    }
    /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */ addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
    }
    /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */ sub(e) {
        return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
    }
    /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */ subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
    }
    /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */ subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
    }
    /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */ multiply(e) {
        return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
    }
    /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */ multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
    }
    /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */ applyMatrix4(e) {
        const t = this.x, i = this.y, n = this.z, s = this.w, a = e.elements;
        return this.x = a[0] * t + a[4] * i + a[8] * n + a[12] * s, this.y = a[1] * t + a[5] * i + a[9] * n + a[13] * s, this.z = a[2] * t + a[6] * i + a[10] * n + a[14] * s, this.w = a[3] * t + a[7] * i + a[11] * n + a[15] * s, this;
    }
    /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */ divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
    }
    /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */ divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */ setAxisAngleFromQuaternion(e) {
        this.w = 2 * Math.acos(e.w);
        const t = Math.sqrt(1 - e.w * e.w);
        return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
    }
    /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */ setAxisAngleFromRotationMatrix(e) {
        let t, i, n, s;
        const g = e.elements, l = g[0], c = g[4], d = g[8], p = g[1], A = g[5], y = g[9], G = g[2], Z = g[6], v = g[10];
        if (Math.abs(c - p) < 0.01 && Math.abs(d - G) < 0.01 && Math.abs(y - Z) < 0.01) {
            if (Math.abs(c + p) < 0.1 && Math.abs(d + G) < 0.1 && Math.abs(y + Z) < 0.1 && Math.abs(l + A + v - 3) < 0.1) return this.set(1, 0, 0, 0), this;
            t = Math.PI;
            const H = (l + 1) / 2, N = (A + 1) / 2, Y = (v + 1) / 2, K = (c + p) / 4, z = (d + G) / 4, M = (y + Z) / 4;
            return H > N && H > Y ? H < 0.01 ? (i = 0, n = 0.707106781, s = 0.707106781) : (i = Math.sqrt(H), n = K / i, s = z / i) : N > Y ? N < 0.01 ? (i = 0.707106781, n = 0, s = 0.707106781) : (n = Math.sqrt(N), i = K / n, s = M / n) : Y < 0.01 ? (i = 0.707106781, n = 0.707106781, s = 0) : (s = Math.sqrt(Y), i = z / s, n = M / s), this.set(i, n, s, t), this;
        }
        let V = Math.sqrt((Z - y) * (Z - y) + (d - G) * (d - G) + (p - c) * (p - c));
        return Math.abs(V) < 1e-3 && (V = 1), this.x = (Z - y) / V, this.y = (d - G) / V, this.z = (p - c) / V, this.w = Math.acos((l + A + v - 1) / 2), this;
    }
    /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */ setFromMatrixPosition(e) {
        const t = e.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
    }
    /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */ min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
    }
    /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */ max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
    }
    /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */ clamp(e, t) {
        return this.x = $d7238066c5de7f1c$var$Ni(this.x, e.x, t.x), this.y = $d7238066c5de7f1c$var$Ni(this.y, e.y, t.y), this.z = $d7238066c5de7f1c$var$Ni(this.z, e.z, t.z), this.w = $d7238066c5de7f1c$var$Ni(this.w, e.w, t.w), this;
    }
    /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */ clampScalar(e, t) {
        return this.x = $d7238066c5de7f1c$var$Ni(this.x, e, t), this.y = $d7238066c5de7f1c$var$Ni(this.y, e, t), this.z = $d7238066c5de7f1c$var$Ni(this.z, e, t), this.w = $d7238066c5de7f1c$var$Ni(this.w, e, t), this;
    }
    /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */ clampLength(e, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($d7238066c5de7f1c$var$Ni(i, e, t));
    }
    /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */ floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */ ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */ round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */ roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
    }
    /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */ negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */ dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
    }
    /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */ setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */ lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
    }
    /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */ lerpVectors(e, t, i) {
        return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this.z = e.z + (t.z - e.z) * i, this.w = e.w + (t.w - e.w) * i, this;
    }
    /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */ equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
    }
    /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */ fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
    }
    /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */ toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
    }
    /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */ fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
    }
    /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */ random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}
class $d7238066c5de7f1c$var$WI extends $d7238066c5de7f1c$var$wI {
    /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   * @property {number} [depth=1] - The texture depth.
   * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
   */ /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */ constructor(e = 1, t = 1, i = {}){
        super(), i = Object.assign({
            generateMipmaps: !1,
            internalFormat: null,
            minFilter: $d7238066c5de7f1c$var$ro,
            depthBuffer: !0,
            stencilBuffer: !1,
            resolveDepthBuffer: !0,
            resolveStencilBuffer: !0,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: !1
        }, i), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = i.depth, this.scissor = new $d7238066c5de7f1c$var$Gi(0, 0, e, t), this.scissorTest = !1, this.viewport = new $d7238066c5de7f1c$var$Gi(0, 0, e, t);
        const n = {
            width: e,
            height: t,
            depth: i.depth
        }, s = new $d7238066c5de7f1c$var$Ca(n);
        this.textures = [];
        const a = i.count;
        for(let o = 0; o < a; o++)this.textures[o] = s.clone(), this.textures[o].isRenderTargetTexture = !0, this.textures[o].renderTarget = this;
        this._setTextureOptions(i), this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.resolveDepthBuffer = i.resolveDepthBuffer, this.resolveStencilBuffer = i.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = i.depthTexture, this.samples = i.samples, this.multiview = i.multiview;
    }
    _setTextureOptions(e = {}) {
        const t = {
            minFilter: $d7238066c5de7f1c$var$ro,
            generateMipmaps: !1,
            flipY: !1,
            internalFormat: null
        };
        e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
        for(let i = 0; i < this.textures.length; i++)this.textures[i].setValues(t);
    }
    /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */ get texture() {
        return this.textures[0];
    }
    set texture(e) {
        this.textures[0] = e;
    }
    set depthTexture(e) {
        this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
    }
    /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */ get depthTexture() {
        return this._depthTexture;
    }
    /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */ setSize(e, t, i = 1) {
        if (this.width !== e || this.height !== t || this.depth !== i) {
            this.width = e, this.height = t, this.depth = i;
            for(let n = 0, s = this.textures.length; n < s; n++)this.textures[n].image.width = e, this.textures[n].image.height = t, this.textures[n].image.depth = i, this.textures[n].isData3DTexture !== !0 && (this.textures[n].isArrayTexture = this.textures[n].image.depth > 1);
            this.dispose();
        }
        this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
    }
    /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */ copy(e) {
        this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
        for(let t = 0, i = e.textures.length; t < i; t++){
            this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
            const n = Object.assign({}, e.textures[t].image);
            this.textures[t].source = new $d7238066c5de7f1c$var$eL(n);
        }
        return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $d7238066c5de7f1c$var$H$ extends $d7238066c5de7f1c$var$WI {
    /**
   * Constructs a new 3D render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */ constructor(e = 1, t = 1, i = {}){
        super(e, t, i), this.isWebGLRenderTarget = !0;
    }
}
class $d7238066c5de7f1c$var$X$ extends $d7238066c5de7f1c$var$Ca {
    /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */ constructor(e = null, t = 1, i = 1, n = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: e,
            width: t,
            height: i,
            depth: n
        }, this.magFilter = $d7238066c5de7f1c$var$Sr, this.minFilter = $d7238066c5de7f1c$var$Sr, this.wrapR = $d7238066c5de7f1c$var$qc, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
    }
    /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */ addLayerUpdate(e) {
        this.layerUpdates.add(e);
    }
    /**
   * Resets the layer updates registry.
   */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $d7238066c5de7f1c$var$zB {
    /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */ constructor(e = new $d7238066c5de7f1c$var$Ce(1 / 0, 1 / 0, 1 / 0), t = new $d7238066c5de7f1c$var$Ce(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = e, this.max = t;
    }
    /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */ set(e, t) {
        return this.min.copy(e), this.max.copy(t), this;
    }
    /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */ setFromArray(e) {
        this.makeEmpty();
        for(let t = 0, i = e.length; t < i; t += 3)this.expandByPoint($d7238066c5de7f1c$var$Kl.fromArray(e, t));
        return this;
    }
    /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */ setFromBufferAttribute(e) {
        this.makeEmpty();
        for(let t = 0, i = e.count; t < i; t++)this.expandByPoint($d7238066c5de7f1c$var$Kl.fromBufferAttribute(e, t));
        return this;
    }
    /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */ setFromPoints(e) {
        this.makeEmpty();
        for(let t = 0, i = e.length; t < i; t++)this.expandByPoint(e[t]);
        return this;
    }
    /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */ setFromCenterAndSize(e, t) {
        const i = $d7238066c5de7f1c$var$Kl.copy(t).multiplyScalar(0.5);
        return this.min.copy(e).sub(i), this.max.copy(e).add(i), this;
    }
    /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */ setFromObject(e, t = !1) {
        return this.makeEmpty(), this.expandByObject(e, t);
    }
    /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */ copy(e) {
        return this.min.copy(e.min), this.max.copy(e.max), this;
    }
    /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */ makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */ isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */ getCenter(e) {
        return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */ getSize(e) {
        return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
    }
    /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */ expandByPoint(e) {
        return this.min.min(e), this.max.max(e), this;
    }
    /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */ expandByVector(e) {
        return this.min.sub(e), this.max.add(e), this;
    }
    /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */ expandByScalar(e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this;
    }
    /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */ expandByObject(e, t = !1) {
        e.updateWorldMatrix(!1, !1);
        const i = e.geometry;
        if (i !== void 0) {
            const s = i.getAttribute("position");
            if (t === !0 && s !== void 0 && e.isInstancedMesh !== !0) for(let a = 0, o = s.count; a < o; a++)e.isMesh === !0 ? e.getVertexPosition(a, $d7238066c5de7f1c$var$Kl) : $d7238066c5de7f1c$var$Kl.fromBufferAttribute(s, a), $d7238066c5de7f1c$var$Kl.applyMatrix4(e.matrixWorld), this.expandByPoint($d7238066c5de7f1c$var$Kl);
            else e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), $d7238066c5de7f1c$var$Iv.copy(e.boundingBox)) : (i.boundingBox === null && i.computeBoundingBox(), $d7238066c5de7f1c$var$Iv.copy(i.boundingBox)), $d7238066c5de7f1c$var$Iv.applyMatrix4(e.matrixWorld), this.union($d7238066c5de7f1c$var$Iv);
        }
        const n = e.children;
        for(let s = 0, a = n.length; s < a; s++)this.expandByObject(n[s], t);
        return this;
    }
    /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */ containsPoint(e) {
        return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
    }
    /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */ containsBox(e) {
        return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
    }
    /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */ getParameter(e, t) {
        return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */ intersectsBox(e) {
        return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
    }
    /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */ intersectsSphere(e) {
        return this.clampPoint(e.center, $d7238066c5de7f1c$var$Kl), $d7238066c5de7f1c$var$Kl.distanceToSquared(e.center) <= e.radius * e.radius;
    }
    /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */ intersectsPlane(e) {
        let t, i;
        return e.normal.x > 0 ? (t = e.normal.x * this.min.x, i = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, i = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, i += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, i += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, i += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, i += e.normal.z * this.min.z), t <= -e.constant && i >= -e.constant;
    }
    /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */ intersectsTriangle(e) {
        if (this.isEmpty()) return !1;
        this.getCenter($d7238066c5de7f1c$var$Wb), $d7238066c5de7f1c$var$dv.subVectors(this.max, $d7238066c5de7f1c$var$Wb), $d7238066c5de7f1c$var$Sm.subVectors(e.a, $d7238066c5de7f1c$var$Wb), $d7238066c5de7f1c$var$Zm.subVectors(e.b, $d7238066c5de7f1c$var$Wb), $d7238066c5de7f1c$var$Rm.subVectors(e.c, $d7238066c5de7f1c$var$Wb), $d7238066c5de7f1c$var$Rd.subVectors($d7238066c5de7f1c$var$Zm, $d7238066c5de7f1c$var$Sm), $d7238066c5de7f1c$var$Vd.subVectors($d7238066c5de7f1c$var$Rm, $d7238066c5de7f1c$var$Zm), $d7238066c5de7f1c$var$nC.subVectors($d7238066c5de7f1c$var$Sm, $d7238066c5de7f1c$var$Rm);
        let t = [
            0,
            -$d7238066c5de7f1c$var$Rd.z,
            $d7238066c5de7f1c$var$Rd.y,
            0,
            -$d7238066c5de7f1c$var$Vd.z,
            $d7238066c5de7f1c$var$Vd.y,
            0,
            -$d7238066c5de7f1c$var$nC.z,
            $d7238066c5de7f1c$var$nC.y,
            $d7238066c5de7f1c$var$Rd.z,
            0,
            -$d7238066c5de7f1c$var$Rd.x,
            $d7238066c5de7f1c$var$Vd.z,
            0,
            -$d7238066c5de7f1c$var$Vd.x,
            $d7238066c5de7f1c$var$nC.z,
            0,
            -$d7238066c5de7f1c$var$nC.x,
            -$d7238066c5de7f1c$var$Rd.y,
            $d7238066c5de7f1c$var$Rd.x,
            0,
            -$d7238066c5de7f1c$var$Vd.y,
            $d7238066c5de7f1c$var$Vd.x,
            0,
            -$d7238066c5de7f1c$var$nC.y,
            $d7238066c5de7f1c$var$nC.x,
            0
        ];
        return !$d7238066c5de7f1c$var$JW(t, $d7238066c5de7f1c$var$Sm, $d7238066c5de7f1c$var$Zm, $d7238066c5de7f1c$var$Rm, $d7238066c5de7f1c$var$dv) || (t = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !$d7238066c5de7f1c$var$JW(t, $d7238066c5de7f1c$var$Sm, $d7238066c5de7f1c$var$Zm, $d7238066c5de7f1c$var$Rm, $d7238066c5de7f1c$var$dv)) ? !1 : ($d7238066c5de7f1c$var$hv.crossVectors($d7238066c5de7f1c$var$Rd, $d7238066c5de7f1c$var$Vd), t = [
            $d7238066c5de7f1c$var$hv.x,
            $d7238066c5de7f1c$var$hv.y,
            $d7238066c5de7f1c$var$hv.z
        ], $d7238066c5de7f1c$var$JW(t, $d7238066c5de7f1c$var$Sm, $d7238066c5de7f1c$var$Zm, $d7238066c5de7f1c$var$Rm, $d7238066c5de7f1c$var$dv));
    }
    /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */ clampPoint(e, t) {
        return t.copy(e).clamp(this.min, this.max);
    }
    /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */ distanceToPoint(e) {
        return this.clampPoint(e, $d7238066c5de7f1c$var$Kl).distanceTo(e);
    }
    /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */ getBoundingSphere(e) {
        return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize($d7238066c5de7f1c$var$Kl).length() * 0.5), e;
    }
    /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */ intersect(e) {
        return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
    }
    /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */ union(e) {
        return this.min.min(e.min), this.max.max(e.max), this;
    }
    /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */ applyMatrix4(e) {
        return this.isEmpty() ? this : ($d7238066c5de7f1c$var$Du[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), $d7238066c5de7f1c$var$Du[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints($d7238066c5de7f1c$var$Du), this);
    }
    /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */ translate(e) {
        return this.min.add(e), this.max.add(e), this;
    }
    /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */ equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
    }
    /**
   * Returns a serialized structure of the bounding box.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
   * Returns a serialized structure of the bounding box.
   *
   * @param {Object} json - The serialized json to set the box from.
   * @return {Box3} A reference to this bounding box.
   */ fromJSON(e) {
        return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
    }
}
const $d7238066c5de7f1c$var$Du = [
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(),
    /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce()
], $d7238066c5de7f1c$var$Kl = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Iv = /* @__PURE__ */ new $d7238066c5de7f1c$var$zB(), $d7238066c5de7f1c$var$Sm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Zm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Rm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Rd = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Vd = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$nC = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Wb = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$dv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$hv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$sC = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
function $d7238066c5de7f1c$var$JW(r, e, t, i, n) {
    for(let s = 0, a = r.length - 3; s <= a; s += 3){
        $d7238066c5de7f1c$var$sC.fromArray(r, s);
        const o = n.x * Math.abs($d7238066c5de7f1c$var$sC.x) + n.y * Math.abs($d7238066c5de7f1c$var$sC.y) + n.z * Math.abs($d7238066c5de7f1c$var$sC.z), g = e.dot($d7238066c5de7f1c$var$sC), l = t.dot($d7238066c5de7f1c$var$sC), c = i.dot($d7238066c5de7f1c$var$sC);
        if (Math.max(-Math.max(g, l, c), Math.min(g, l, c)) > o) return !1;
    }
    return !0;
}
const $d7238066c5de7f1c$var$N$ = /* @__PURE__ */ new $d7238066c5de7f1c$var$zB(), $d7238066c5de7f1c$var$Hb = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$UW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$lR {
    /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */ constructor(e = new $d7238066c5de7f1c$var$Ce(), t = -1){
        this.isSphere = !0, this.center = e, this.radius = t;
    }
    /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */ set(e, t) {
        return this.center.copy(e), this.radius = t, this;
    }
    /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */ setFromPoints(e, t) {
        const i = this.center;
        t !== void 0 ? i.copy(t) : $d7238066c5de7f1c$var$N$.setFromPoints(e).getCenter(i);
        let n = 0;
        for(let s = 0, a = e.length; s < a; s++)n = Math.max(n, i.distanceToSquared(e[s]));
        return this.radius = Math.sqrt(n), this;
    }
    /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */ copy(e) {
        return this.center.copy(e.center), this.radius = e.radius, this;
    }
    /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */ isEmpty() {
        return this.radius < 0;
    }
    /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */ makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */ containsPoint(e) {
        return e.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */ distanceToPoint(e) {
        return e.distanceTo(this.center) - this.radius;
    }
    /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */ intersectsSphere(e) {
        const t = this.radius + e.radius;
        return e.center.distanceToSquared(this.center) <= t * t;
    }
    /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */ intersectsBox(e) {
        return e.intersectsSphere(this);
    }
    /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */ intersectsPlane(e) {
        return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
    }
    /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */ clampPoint(e, t) {
        const i = this.center.distanceToSquared(e);
        return t.copy(e), i > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
    }
    /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */ getBoundingBox(e) {
        return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
    }
    /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */ applyMatrix4(e) {
        return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
    }
    /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */ translate(e) {
        return this.center.add(e), this;
    }
    /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */ expandByPoint(e) {
        if (this.isEmpty()) return this.center.copy(e), this.radius = 0, this;
        $d7238066c5de7f1c$var$Hb.subVectors(e, this.center);
        const t = $d7238066c5de7f1c$var$Hb.lengthSq();
        if (t > this.radius * this.radius) {
            const i = Math.sqrt(t), n = (i - this.radius) * 0.5;
            this.center.addScaledVector($d7238066c5de7f1c$var$Hb, n / i), this.radius += n;
        }
        return this;
    }
    /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */ union(e) {
        return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : ($d7238066c5de7f1c$var$UW.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint($d7238066c5de7f1c$var$Hb.copy(e.center).add($d7238066c5de7f1c$var$UW)), this.expandByPoint($d7238066c5de7f1c$var$Hb.copy(e.center).sub($d7238066c5de7f1c$var$UW))), this);
    }
    /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */ equals(e) {
        return e.center.equals(this.center) && e.radius === this.radius;
    }
    /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @param {Object} json - The serialized json to set the sphere from.
   * @return {Box3} A reference to this bounding sphere.
   */ fromJSON(e) {
        return this.radius = e.radius, this.center.fromArray(e.center), this;
    }
}
const $d7238066c5de7f1c$var$_u = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$DW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Cv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$wd = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$_W = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$pv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$PW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$L$ {
    /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */ constructor(e = new $d7238066c5de7f1c$var$Ce(), t = new $d7238066c5de7f1c$var$Ce(0, 0, -1)){
        this.origin = e, this.direction = t;
    }
    /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */ set(e, t) {
        return this.origin.copy(e), this.direction.copy(t), this;
    }
    /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */ copy(e) {
        return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
    }
    /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */ at(e, t) {
        return t.copy(this.origin).addScaledVector(this.direction, e);
    }
    /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */ lookAt(e) {
        return this.direction.copy(e).sub(this.origin).normalize(), this;
    }
    /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */ recast(e) {
        return this.origin.copy(this.at(e, $d7238066c5de7f1c$var$_u)), this;
    }
    /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */ closestPointToPoint(e, t) {
        t.subVectors(e, this.origin);
        const i = t.dot(this.direction);
        return i < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, i);
    }
    /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */ distanceToPoint(e) {
        return Math.sqrt(this.distanceSqToPoint(e));
    }
    /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */ distanceSqToPoint(e) {
        const t = $d7238066c5de7f1c$var$_u.subVectors(e, this.origin).dot(this.direction);
        return t < 0 ? this.origin.distanceToSquared(e) : ($d7238066c5de7f1c$var$_u.copy(this.origin).addScaledVector(this.direction, t), $d7238066c5de7f1c$var$_u.distanceToSquared(e));
    }
    /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */ distanceSqToSegment(e, t, i, n) {
        $d7238066c5de7f1c$var$DW.copy(e).add(t).multiplyScalar(0.5), $d7238066c5de7f1c$var$Cv.copy(t).sub(e).normalize(), $d7238066c5de7f1c$var$wd.copy(this.origin).sub($d7238066c5de7f1c$var$DW);
        const s = e.distanceTo(t) * 0.5, a = -this.direction.dot($d7238066c5de7f1c$var$Cv), o = $d7238066c5de7f1c$var$wd.dot(this.direction), g = -$d7238066c5de7f1c$var$wd.dot($d7238066c5de7f1c$var$Cv), l = $d7238066c5de7f1c$var$wd.lengthSq(), c = Math.abs(1 - a * a);
        let d, p, A, y;
        if (c > 0) {
            if (d = a * g - o, p = a * o - g, y = s * c, d >= 0) {
                if (p >= -y) {
                    if (p <= y) {
                        const G = 1 / c;
                        d *= G, p *= G, A = d * (d + a * p + 2 * o) + p * (a * d + p + 2 * g) + l;
                    } else p = s, d = Math.max(0, -(a * p + o)), A = -d * d + p * (p + 2 * g) + l;
                } else p = -s, d = Math.max(0, -(a * p + o)), A = -d * d + p * (p + 2 * g) + l;
            } else p <= -y ? (d = Math.max(0, -(-a * s + o)), p = d > 0 ? -s : Math.min(Math.max(-s, -g), s), A = -d * d + p * (p + 2 * g) + l) : p <= y ? (d = 0, p = Math.min(Math.max(-s, -g), s), A = p * (p + 2 * g) + l) : (d = Math.max(0, -(a * s + o)), p = d > 0 ? s : Math.min(Math.max(-s, -g), s), A = -d * d + p * (p + 2 * g) + l);
        } else p = a > 0 ? -s : s, d = Math.max(0, -(a * p + o)), A = -d * d + p * (p + 2 * g) + l;
        return i && i.copy(this.origin).addScaledVector(this.direction, d), n && n.copy($d7238066c5de7f1c$var$DW).addScaledVector($d7238066c5de7f1c$var$Cv, p), A;
    }
    /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */ intersectSphere(e, t) {
        $d7238066c5de7f1c$var$_u.subVectors(e.center, this.origin);
        const i = $d7238066c5de7f1c$var$_u.dot(this.direction), n = $d7238066c5de7f1c$var$_u.dot($d7238066c5de7f1c$var$_u) - i * i, s = e.radius * e.radius;
        if (n > s) return null;
        const a = Math.sqrt(s - n), o = i - a, g = i + a;
        return g < 0 ? null : o < 0 ? this.at(g, t) : this.at(o, t);
    }
    /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */ intersectsSphere(e) {
        return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
    }
    /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */ distanceToPlane(e) {
        const t = e.normal.dot(this.direction);
        if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null;
        const i = -(this.origin.dot(e.normal) + e.constant) / t;
        return i >= 0 ? i : null;
    }
    /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */ intersectPlane(e, t) {
        const i = this.distanceToPlane(e);
        return i === null ? null : this.at(i, t);
    }
    /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */ intersectsPlane(e) {
        const t = e.distanceToPoint(this.origin);
        return t === 0 || e.normal.dot(this.direction) * t < 0;
    }
    /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */ intersectBox(e, t) {
        let i, n, s, a, o, g;
        const l = 1 / this.direction.x, c = 1 / this.direction.y, d = 1 / this.direction.z, p = this.origin;
        return l >= 0 ? (i = (e.min.x - p.x) * l, n = (e.max.x - p.x) * l) : (i = (e.max.x - p.x) * l, n = (e.min.x - p.x) * l), c >= 0 ? (s = (e.min.y - p.y) * c, a = (e.max.y - p.y) * c) : (s = (e.max.y - p.y) * c, a = (e.min.y - p.y) * c), i > a || s > n || ((s > i || isNaN(i)) && (i = s), (a < n || isNaN(n)) && (n = a), d >= 0 ? (o = (e.min.z - p.z) * d, g = (e.max.z - p.z) * d) : (o = (e.max.z - p.z) * d, g = (e.min.z - p.z) * d), i > g || o > n) || ((o > i || i !== i) && (i = o), (g < n || n !== n) && (n = g), n < 0) ? null : this.at(i >= 0 ? i : n, t);
    }
    /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */ intersectsBox(e) {
        return this.intersectBox(e, $d7238066c5de7f1c$var$_u) !== null;
    }
    /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */ intersectTriangle(e, t, i, n, s) {
        $d7238066c5de7f1c$var$_W.subVectors(t, e), $d7238066c5de7f1c$var$pv.subVectors(i, e), $d7238066c5de7f1c$var$PW.crossVectors($d7238066c5de7f1c$var$_W, $d7238066c5de7f1c$var$pv);
        let a = this.direction.dot($d7238066c5de7f1c$var$PW), o;
        if (a > 0) {
            if (n) return null;
            o = 1;
        } else if (a < 0) o = -1, a = -a;
        else return null;
        $d7238066c5de7f1c$var$wd.subVectors(this.origin, e);
        const g = o * this.direction.dot($d7238066c5de7f1c$var$pv.crossVectors($d7238066c5de7f1c$var$wd, $d7238066c5de7f1c$var$pv));
        if (g < 0) return null;
        const l = o * this.direction.dot($d7238066c5de7f1c$var$_W.cross($d7238066c5de7f1c$var$wd));
        if (l < 0 || g + l > a) return null;
        const c = -o * $d7238066c5de7f1c$var$wd.dot($d7238066c5de7f1c$var$PW);
        return c < 0 ? null : this.at(c / a, s);
    }
    /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */ applyMatrix4(e) {
        return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
    }
    /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */ equals(e) {
        return e.origin.equals(this.origin) && e.direction.equals(this.direction);
    }
    /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
}
class $d7238066c5de7f1c$var$Ji {
    /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */ constructor(e, t, i, n, s, a, o, g, l, c, d, p, A, y, G, Z){
        $d7238066c5de7f1c$var$Ji.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ], e !== void 0 && this.set(e, t, i, n, s, a, o, g, l, c, d, p, A, y, G, Z);
    }
    /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */ set(e, t, i, n, s, a, o, g, l, c, d, p, A, y, G, Z) {
        const v = this.elements;
        return v[0] = e, v[4] = t, v[8] = i, v[12] = n, v[1] = s, v[5] = a, v[9] = o, v[13] = g, v[2] = l, v[6] = c, v[10] = d, v[14] = p, v[3] = A, v[7] = y, v[11] = G, v[15] = Z, this;
    }
    /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */ identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */ clone() {
        return new $d7238066c5de7f1c$var$Ji().fromArray(this.elements);
    }
    /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */ copy(e) {
        const t = this.elements, i = e.elements;
        return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], t[9] = i[9], t[10] = i[10], t[11] = i[11], t[12] = i[12], t[13] = i[13], t[14] = i[14], t[15] = i[15], this;
    }
    /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */ copyPosition(e) {
        const t = this.elements, i = e.elements;
        return t[12] = i[12], t[13] = i[13], t[14] = i[14], this;
    }
    /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */ setFromMatrix3(e) {
        const t = e.elements;
        return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
    }
    /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */ extractBasis(e, t, i) {
        return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
    }
    /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */ makeBasis(e, t, i) {
        return this.set(e.x, t.x, i.x, 0, e.y, t.y, i.y, 0, e.z, t.z, i.z, 0, 0, 0, 0, 1), this;
    }
    /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */ extractRotation(e) {
        const t = this.elements, i = e.elements, n = 1 / $d7238066c5de7f1c$var$Vm.setFromMatrixColumn(e, 0).length(), s = 1 / $d7238066c5de7f1c$var$Vm.setFromMatrixColumn(e, 1).length(), a = 1 / $d7238066c5de7f1c$var$Vm.setFromMatrixColumn(e, 2).length();
        return t[0] = i[0] * n, t[1] = i[1] * n, t[2] = i[2] * n, t[3] = 0, t[4] = i[4] * s, t[5] = i[5] * s, t[6] = i[6] * s, t[7] = 0, t[8] = i[8] * a, t[9] = i[9] * a, t[10] = i[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */ makeRotationFromEuler(e) {
        const t = this.elements, i = e.x, n = e.y, s = e.z, a = Math.cos(i), o = Math.sin(i), g = Math.cos(n), l = Math.sin(n), c = Math.cos(s), d = Math.sin(s);
        if (e.order === "XYZ") {
            const p = a * c, A = a * d, y = o * c, G = o * d;
            t[0] = g * c, t[4] = -g * d, t[8] = l, t[1] = A + y * l, t[5] = p - G * l, t[9] = -o * g, t[2] = G - p * l, t[6] = y + A * l, t[10] = a * g;
        } else if (e.order === "YXZ") {
            const p = g * c, A = g * d, y = l * c, G = l * d;
            t[0] = p + G * o, t[4] = y * o - A, t[8] = a * l, t[1] = a * d, t[5] = a * c, t[9] = -o, t[2] = A * o - y, t[6] = G + p * o, t[10] = a * g;
        } else if (e.order === "ZXY") {
            const p = g * c, A = g * d, y = l * c, G = l * d;
            t[0] = p - G * o, t[4] = -a * d, t[8] = y + A * o, t[1] = A + y * o, t[5] = a * c, t[9] = G - p * o, t[2] = -a * l, t[6] = o, t[10] = a * g;
        } else if (e.order === "ZYX") {
            const p = a * c, A = a * d, y = o * c, G = o * d;
            t[0] = g * c, t[4] = y * l - A, t[8] = p * l + G, t[1] = g * d, t[5] = G * l + p, t[9] = A * l - y, t[2] = -l, t[6] = o * g, t[10] = a * g;
        } else if (e.order === "YZX") {
            const p = a * g, A = a * l, y = o * g, G = o * l;
            t[0] = g * c, t[4] = G - p * d, t[8] = y * d + A, t[1] = d, t[5] = a * c, t[9] = -o * c, t[2] = -l * c, t[6] = A * d + y, t[10] = p - G * d;
        } else if (e.order === "XZY") {
            const p = a * g, A = a * l, y = o * g, G = o * l;
            t[0] = g * c, t[4] = -d, t[8] = l * c, t[1] = p * d + G, t[5] = a * c, t[9] = A * d - y, t[2] = y * d - A, t[6] = o * c, t[10] = G * d + p;
        }
        return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */ makeRotationFromQuaternion(e) {
        return this.compose($d7238066c5de7f1c$var$Y$, e, $d7238066c5de7f1c$var$K$);
    }
    /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */ lookAt(e, t, i) {
        const n = this.elements;
        return $d7238066c5de7f1c$var$Po.subVectors(e, t), $d7238066c5de7f1c$var$Po.lengthSq() === 0 && ($d7238066c5de7f1c$var$Po.z = 1), $d7238066c5de7f1c$var$Po.normalize(), $d7238066c5de7f1c$var$Wd.crossVectors(i, $d7238066c5de7f1c$var$Po), $d7238066c5de7f1c$var$Wd.lengthSq() === 0 && (Math.abs(i.z) === 1 ? $d7238066c5de7f1c$var$Po.x += 1e-4 : $d7238066c5de7f1c$var$Po.z += 1e-4, $d7238066c5de7f1c$var$Po.normalize(), $d7238066c5de7f1c$var$Wd.crossVectors(i, $d7238066c5de7f1c$var$Po)), $d7238066c5de7f1c$var$Wd.normalize(), $d7238066c5de7f1c$var$mv.crossVectors($d7238066c5de7f1c$var$Po, $d7238066c5de7f1c$var$Wd), n[0] = $d7238066c5de7f1c$var$Wd.x, n[4] = $d7238066c5de7f1c$var$mv.x, n[8] = $d7238066c5de7f1c$var$Po.x, n[1] = $d7238066c5de7f1c$var$Wd.y, n[5] = $d7238066c5de7f1c$var$mv.y, n[9] = $d7238066c5de7f1c$var$Po.y, n[2] = $d7238066c5de7f1c$var$Wd.z, n[6] = $d7238066c5de7f1c$var$mv.z, n[10] = $d7238066c5de7f1c$var$Po.z, this;
    }
    /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */ multiply(e) {
        return this.multiplyMatrices(this, e);
    }
    /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */ premultiply(e) {
        return this.multiplyMatrices(e, this);
    }
    /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */ multiplyMatrices(e, t) {
        const i = e.elements, n = t.elements, s = this.elements, a = i[0], o = i[4], g = i[8], l = i[12], c = i[1], d = i[5], p = i[9], A = i[13], y = i[2], G = i[6], Z = i[10], v = i[14], V = i[3], H = i[7], N = i[11], Y = i[15], K = n[0], z = n[4], M = n[8], _ = n[12], O = n[1], ie = n[5], he = n[9], pe = n[13], ce = n[2], $ = n[6], te = n[10], Ge = n[14], q = n[3], de = n[7], ge = n[11], Ye = n[15];
        return s[0] = a * K + o * O + g * ce + l * q, s[4] = a * z + o * ie + g * $ + l * de, s[8] = a * M + o * he + g * te + l * ge, s[12] = a * _ + o * pe + g * Ge + l * Ye, s[1] = c * K + d * O + p * ce + A * q, s[5] = c * z + d * ie + p * $ + A * de, s[9] = c * M + d * he + p * te + A * ge, s[13] = c * _ + d * pe + p * Ge + A * Ye, s[2] = y * K + G * O + Z * ce + v * q, s[6] = y * z + G * ie + Z * $ + v * de, s[10] = y * M + G * he + Z * te + v * ge, s[14] = y * _ + G * pe + Z * Ge + v * Ye, s[3] = V * K + H * O + N * ce + Y * q, s[7] = V * z + H * ie + N * $ + Y * de, s[11] = V * M + H * he + N * te + Y * ge, s[15] = V * _ + H * pe + N * Ge + Y * Ye, this;
    }
    /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */ multiplyScalar(e) {
        const t = this.elements;
        return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
    }
    /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
   *
   * @return {number} The determinant.
   */ determinant() {
        const e = this.elements, t = e[0], i = e[4], n = e[8], s = e[12], a = e[1], o = e[5], g = e[9], l = e[13], c = e[2], d = e[6], p = e[10], A = e[14], y = e[3], G = e[7], Z = e[11], v = e[15];
        return y * (+s * g * d - n * l * d - s * o * p + i * l * p + n * o * A - i * g * A) + G * (+t * g * A - t * l * p + s * a * p - n * a * A + n * l * c - s * g * c) + Z * (+t * l * d - t * o * A - s * a * d + i * a * A + s * o * c - i * l * c) + v * (-n * o * c - t * g * d + t * o * p + n * a * d - i * a * p + i * g * c);
    }
    /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */ transpose() {
        const e = this.elements;
        let t;
        return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
    }
    /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */ setPosition(e, t, i) {
        const n = this.elements;
        return e.isVector3 ? (n[12] = e.x, n[13] = e.y, n[14] = e.z) : (n[12] = e, n[13] = t, n[14] = i), this;
    }
    /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */ invert() {
        const e = this.elements, t = e[0], i = e[1], n = e[2], s = e[3], a = e[4], o = e[5], g = e[6], l = e[7], c = e[8], d = e[9], p = e[10], A = e[11], y = e[12], G = e[13], Z = e[14], v = e[15], V = d * Z * l - G * p * l + G * g * A - o * Z * A - d * g * v + o * p * v, H = y * p * l - c * Z * l - y * g * A + a * Z * A + c * g * v - a * p * v, N = c * G * l - y * d * l + y * o * A - a * G * A - c * o * v + a * d * v, Y = y * d * g - c * G * g - y * o * p + a * G * p + c * o * Z - a * d * Z, K = t * V + i * H + n * N + s * Y;
        if (K === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const z = 1 / K;
        return e[0] = V * z, e[1] = (G * p * s - d * Z * s - G * n * A + i * Z * A + d * n * v - i * p * v) * z, e[2] = (o * Z * s - G * g * s + G * n * l - i * Z * l - o * n * v + i * g * v) * z, e[3] = (d * g * s - o * p * s - d * n * l + i * p * l + o * n * A - i * g * A) * z, e[4] = H * z, e[5] = (c * Z * s - y * p * s + y * n * A - t * Z * A - c * n * v + t * p * v) * z, e[6] = (y * g * s - a * Z * s - y * n * l + t * Z * l + a * n * v - t * g * v) * z, e[7] = (a * p * s - c * g * s + c * n * l - t * p * l - a * n * A + t * g * A) * z, e[8] = N * z, e[9] = (y * d * s - c * G * s - y * i * A + t * G * A + c * i * v - t * d * v) * z, e[10] = (a * G * s - y * o * s + y * i * l - t * G * l - a * i * v + t * o * v) * z, e[11] = (c * o * s - a * d * s - c * i * l + t * d * l + a * i * A - t * o * A) * z, e[12] = Y * z, e[13] = (c * G * n - y * d * n + y * i * p - t * G * p - c * i * Z + t * d * Z) * z, e[14] = (y * o * n - a * G * n - y * i * g + t * G * g + a * i * Z - t * o * Z) * z, e[15] = (a * d * n - c * o * n + c * i * g - t * d * g - a * i * p + t * o * p) * z, this;
    }
    /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */ scale(e) {
        const t = this.elements, i = e.x, n = e.y, s = e.z;
        return t[0] *= i, t[4] *= n, t[8] *= s, t[1] *= i, t[5] *= n, t[9] *= s, t[2] *= i, t[6] *= n, t[10] *= s, t[3] *= i, t[7] *= n, t[11] *= s, this;
    }
    /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */ getMaxScaleOnAxis() {
        const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], i = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], n = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
        return Math.sqrt(Math.max(t, i, n));
    }
    /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */ makeTranslation(e, t, i) {
        return e.isVector3 ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1) : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, i, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */ makeRotationX(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(1, 0, 0, 0, 0, t, -i, 0, 0, i, t, 0, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */ makeRotationY(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(t, 0, i, 0, 0, 1, 0, 0, -i, 0, t, 0, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */ makeRotationZ(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(t, -i, 0, 0, i, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */ makeRotationAxis(e, t) {
        const i = Math.cos(t), n = Math.sin(t), s = 1 - i, a = e.x, o = e.y, g = e.z, l = s * a, c = s * o;
        return this.set(l * a + i, l * o - n * g, l * g + n * o, 0, l * o + n * g, c * o + i, c * g - n * a, 0, l * g - n * o, c * g + n * a, s * g * g + i, 0, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */ makeScale(e, t, i) {
        return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */ makeShear(e, t, i, n, s, a) {
        return this.set(1, i, s, 0, e, 1, a, 0, t, n, 1, 0, 0, 0, 0, 1), this;
    }
    /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */ compose(e, t, i) {
        const n = this.elements, s = t._x, a = t._y, o = t._z, g = t._w, l = s + s, c = a + a, d = o + o, p = s * l, A = s * c, y = s * d, G = a * c, Z = a * d, v = o * d, V = g * l, H = g * c, N = g * d, Y = i.x, K = i.y, z = i.z;
        return n[0] = (1 - (G + v)) * Y, n[1] = (A + N) * Y, n[2] = (y - H) * Y, n[3] = 0, n[4] = (A - N) * K, n[5] = (1 - (p + v)) * K, n[6] = (Z + V) * K, n[7] = 0, n[8] = (y + H) * z, n[9] = (Z - V) * z, n[10] = (1 - (p + G)) * z, n[11] = 0, n[12] = e.x, n[13] = e.y, n[14] = e.z, n[15] = 1, this;
    }
    /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */ decompose(e, t, i) {
        const n = this.elements;
        let s = $d7238066c5de7f1c$var$Vm.set(n[0], n[1], n[2]).length();
        const a = $d7238066c5de7f1c$var$Vm.set(n[4], n[5], n[6]).length(), o = $d7238066c5de7f1c$var$Vm.set(n[8], n[9], n[10]).length();
        this.determinant() < 0 && (s = -s), e.x = n[12], e.y = n[13], e.z = n[14], $d7238066c5de7f1c$var$xl.copy(this);
        const l = 1 / s, c = 1 / a, d = 1 / o;
        return $d7238066c5de7f1c$var$xl.elements[0] *= l, $d7238066c5de7f1c$var$xl.elements[1] *= l, $d7238066c5de7f1c$var$xl.elements[2] *= l, $d7238066c5de7f1c$var$xl.elements[4] *= c, $d7238066c5de7f1c$var$xl.elements[5] *= c, $d7238066c5de7f1c$var$xl.elements[6] *= c, $d7238066c5de7f1c$var$xl.elements[8] *= d, $d7238066c5de7f1c$var$xl.elements[9] *= d, $d7238066c5de7f1c$var$xl.elements[10] *= d, t.setFromRotationMatrix($d7238066c5de7f1c$var$xl), i.x = s, i.y = a, i.z = o, this;
    }
    /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */ makePerspective(e, t, i, n, s, a, o = $d7238066c5de7f1c$var$rg, g = !1) {
        const l = this.elements, c = 2 * s / (t - e), d = 2 * s / (i - n), p = (t + e) / (t - e), A = (i + n) / (i - n);
        let y, G;
        if (g) y = s / (a - s), G = a * s / (a - s);
        else if (o === $d7238066c5de7f1c$var$rg) y = -(a + s) / (a - s), G = -2 * a * s / (a - s);
        else if (o === $d7238066c5de7f1c$var$uu) y = -a / (a - s), G = -a * s / (a - s);
        else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
        return l[0] = c, l[4] = 0, l[8] = p, l[12] = 0, l[1] = 0, l[5] = d, l[9] = A, l[13] = 0, l[2] = 0, l[6] = 0, l[10] = y, l[14] = G, l[3] = 0, l[7] = 0, l[11] = -1, l[15] = 0, this;
    }
    /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */ makeOrthographic(e, t, i, n, s, a, o = $d7238066c5de7f1c$var$rg, g = !1) {
        const l = this.elements, c = 2 / (t - e), d = 2 / (i - n), p = -(t + e) / (t - e), A = -(i + n) / (i - n);
        let y, G;
        if (g) y = 1 / (a - s), G = a / (a - s);
        else if (o === $d7238066c5de7f1c$var$rg) y = -2 / (a - s), G = -(a + s) / (a - s);
        else if (o === $d7238066c5de7f1c$var$uu) y = -1 / (a - s), G = -s / (a - s);
        else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
        return l[0] = c, l[4] = 0, l[8] = 0, l[12] = p, l[1] = 0, l[5] = d, l[9] = 0, l[13] = A, l[2] = 0, l[6] = 0, l[10] = y, l[14] = G, l[3] = 0, l[7] = 0, l[11] = 0, l[15] = 1, this;
    }
    /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */ equals(e) {
        const t = this.elements, i = e.elements;
        for(let n = 0; n < 16; n++)if (t[n] !== i[n]) return !1;
        return !0;
    }
    /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */ fromArray(e, t = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = e[i + t];
        return this;
    }
    /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */ toArray(e = [], t = 0) {
        const i = this.elements;
        return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e[t + 9] = i[9], e[t + 10] = i[10], e[t + 11] = i[11], e[t + 12] = i[12], e[t + 13] = i[13], e[t + 14] = i[14], e[t + 15] = i[15], e;
    }
}
const $d7238066c5de7f1c$var$Vm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$xl = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Y$ = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(0, 0, 0), $d7238066c5de7f1c$var$K$ = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(1, 1, 1), $d7238066c5de7f1c$var$Wd = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$mv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Po = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$f5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$G5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$t0();
class $d7238066c5de7f1c$var$il {
    /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */ constructor(e = 0, t = 0, i = 0, n = $d7238066c5de7f1c$var$il.DEFAULT_ORDER){
        this.isEuler = !0, this._x = e, this._y = t, this._z = i, this._order = n;
    }
    /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(e) {
        this._x = e, this._onChangeCallback();
    }
    /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(e) {
        this._y = e, this._onChangeCallback();
    }
    /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */ get z() {
        return this._z;
    }
    set z(e) {
        this._z = e, this._onChangeCallback();
    }
    /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */ get order() {
        return this._order;
    }
    set order(e) {
        this._order = e, this._onChangeCallback();
    }
    /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */ set(e, t, i, n = this._order) {
        return this._x = e, this._y = t, this._z = i, this._order = n, this._onChangeCallback(), this;
    }
    /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */ copy(e) {
        return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
    }
    /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */ setFromRotationMatrix(e, t = this._order, i = !0) {
        const n = e.elements, s = n[0], a = n[4], o = n[8], g = n[1], l = n[5], c = n[9], d = n[2], p = n[6], A = n[10];
        switch(t){
            case "XYZ":
                this._y = Math.asin($d7238066c5de7f1c$var$Ni(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-c, A), this._z = Math.atan2(-a, s)) : (this._x = Math.atan2(p, l), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-$d7238066c5de7f1c$var$Ni(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._y = Math.atan2(o, A), this._z = Math.atan2(g, l)) : (this._y = Math.atan2(-d, s), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin($d7238066c5de7f1c$var$Ni(p, -1, 1)), Math.abs(p) < 0.9999999 ? (this._y = Math.atan2(-d, A), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(g, s));
                break;
            case "ZYX":
                this._y = Math.asin(-$d7238066c5de7f1c$var$Ni(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._x = Math.atan2(p, A), this._z = Math.atan2(g, s)) : (this._x = 0, this._z = Math.atan2(-a, l));
                break;
            case "YZX":
                this._z = Math.asin($d7238066c5de7f1c$var$Ni(g, -1, 1)), Math.abs(g) < 0.9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-d, s)) : (this._x = 0, this._y = Math.atan2(o, A));
                break;
            case "XZY":
                this._z = Math.asin(-$d7238066c5de7f1c$var$Ni(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(p, l), this._y = Math.atan2(o, s)) : (this._x = Math.atan2(-c, A), this._y = 0);
                break;
            default:
                $d7238066c5de7f1c$var$ze("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
        }
        return this._order = t, i === !0 && this._onChangeCallback(), this;
    }
    /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */ setFromQuaternion(e, t, i) {
        return $d7238066c5de7f1c$var$f5.makeRotationFromQuaternion(e), this.setFromRotationMatrix($d7238066c5de7f1c$var$f5, t, i);
    }
    /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */ setFromVector3(e, t = this._order) {
        return this.set(e.x, e.y, e.z, t);
    }
    /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */ reorder(e) {
        return $d7238066c5de7f1c$var$G5.setFromEuler(this), this.setFromQuaternion($d7238066c5de7f1c$var$G5, e);
    }
    /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */ equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
    }
    /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */ fromArray(e) {
        return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
    }
    /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */ toArray(e = [], t = 0) {
        return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
    }
    _onChange(e) {
        return this._onChangeCallback = e, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
}
$d7238066c5de7f1c$var$il.DEFAULT_ORDER = "XYZ";
class $d7238066c5de7f1c$var$x$ {
    /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */ constructor(){
        this.mask = 1;
    }
    /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */ set(e) {
        this.mask = (1 << e | 0) >>> 0;
    }
    /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */ enable(e) {
        this.mask |= 1 << e | 0;
    }
    /**
   * Adds membership to all layers.
   */ enableAll() {
        this.mask = -1;
    }
    /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */ toggle(e) {
        this.mask ^= 1 << e | 0;
    }
    /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */ disable(e) {
        this.mask &= ~(1 << e | 0);
    }
    /**
   * Removes the membership from all layers.
   */ disableAll() {
        this.mask = 0;
    }
    /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */ test(e) {
        return (this.mask & e.mask) !== 0;
    }
    /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */ isEnabled(e) {
        return (this.mask & (1 << e | 0)) !== 0;
    }
}
let $d7238066c5de7f1c$var$F$ = 0;
const $d7238066c5de7f1c$var$v5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$wm = /* @__PURE__ */ new $d7238066c5de7f1c$var$t0(), $d7238066c5de7f1c$var$Pu = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Av = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Xb = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$T$ = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$M$ = /* @__PURE__ */ new $d7238066c5de7f1c$var$t0(), $d7238066c5de7f1c$var$S5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(1, 0, 0), $d7238066c5de7f1c$var$Z5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(0, 1, 0), $d7238066c5de7f1c$var$R5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(0, 0, 1), $d7238066c5de7f1c$var$V5 = {
    type: "added"
}, $d7238066c5de7f1c$var$z$ = {
    type: "removed"
}, $d7238066c5de7f1c$var$Wm = {
    type: "childadded",
    child: null
}, $d7238066c5de7f1c$var$QW = {
    type: "childremoved",
    child: null
};
class $d7238066c5de7f1c$var$lr extends $d7238066c5de7f1c$var$wI {
    /**
   * Constructs a new 3D object.
   */ constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$F$++
        }), this.uuid = $d7238066c5de7f1c$var$hI(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = $d7238066c5de7f1c$var$lr.DEFAULT_UP.clone();
        const e = new $d7238066c5de7f1c$var$Ce(), t = new $d7238066c5de7f1c$var$il(), i = new $d7238066c5de7f1c$var$t0(), n = new $d7238066c5de7f1c$var$Ce(1, 1, 1);
        function s() {
            i.setFromEuler(t, !1);
        }
        function a() {
            t.setFromQuaternion(i, void 0, !1);
        }
        t._onChange(s), i._onChange(a), Object.defineProperties(this, {
            /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */ position: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */ rotation: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */ quaternion: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */ scale: {
                configurable: !0,
                enumerable: !0,
                value: n
            },
            /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */ modelViewMatrix: {
                value: new $d7238066c5de7f1c$var$Ji()
            },
            /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */ normalMatrix: {
                value: new $d7238066c5de7f1c$var$Lo()
            }
        }), this.matrix = new $d7238066c5de7f1c$var$Ji(), this.matrixWorld = new $d7238066c5de7f1c$var$Ji(), this.matrixAutoUpdate = $d7238066c5de7f1c$var$lr.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = $d7238066c5de7f1c$var$lr.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new $d7238066c5de7f1c$var$x$(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
    }
    /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */ onBeforeShadow() {}
    /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */ onAfterShadow() {}
    /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */ onBeforeRender() {}
    /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */ onAfterRender() {}
    /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */ applyMatrix4(e) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */ applyQuaternion(e) {
        return this.quaternion.premultiply(e), this;
    }
    /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */ setRotationFromAxisAngle(e, t) {
        this.quaternion.setFromAxisAngle(e, t);
    }
    /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */ setRotationFromEuler(e) {
        this.quaternion.setFromEuler(e, !0);
    }
    /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */ setRotationFromMatrix(e) {
        this.quaternion.setFromRotationMatrix(e);
    }
    /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */ setRotationFromQuaternion(e) {
        this.quaternion.copy(e);
    }
    /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */ rotateOnAxis(e, t) {
        return $d7238066c5de7f1c$var$wm.setFromAxisAngle(e, t), this.quaternion.multiply($d7238066c5de7f1c$var$wm), this;
    }
    /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */ rotateOnWorldAxis(e, t) {
        return $d7238066c5de7f1c$var$wm.setFromAxisAngle(e, t), this.quaternion.premultiply($d7238066c5de7f1c$var$wm), this;
    }
    /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */ rotateX(e) {
        return this.rotateOnAxis($d7238066c5de7f1c$var$S5, e);
    }
    /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */ rotateY(e) {
        return this.rotateOnAxis($d7238066c5de7f1c$var$Z5, e);
    }
    /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */ rotateZ(e) {
        return this.rotateOnAxis($d7238066c5de7f1c$var$R5, e);
    }
    /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */ translateOnAxis(e, t) {
        return $d7238066c5de7f1c$var$v5.copy(e).applyQuaternion(this.quaternion), this.position.add($d7238066c5de7f1c$var$v5.multiplyScalar(t)), this;
    }
    /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */ translateX(e) {
        return this.translateOnAxis($d7238066c5de7f1c$var$S5, e);
    }
    /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */ translateY(e) {
        return this.translateOnAxis($d7238066c5de7f1c$var$Z5, e);
    }
    /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */ translateZ(e) {
        return this.translateOnAxis($d7238066c5de7f1c$var$R5, e);
    }
    /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */ localToWorld(e) {
        return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
    }
    /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */ worldToLocal(e) {
        return this.updateWorldMatrix(!0, !1), e.applyMatrix4($d7238066c5de7f1c$var$Pu.copy(this.matrixWorld).invert());
    }
    /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */ lookAt(e, t, i) {
        e.isVector3 ? $d7238066c5de7f1c$var$Av.copy(e) : $d7238066c5de7f1c$var$Av.set(e, t, i);
        const n = this.parent;
        this.updateWorldMatrix(!0, !1), $d7238066c5de7f1c$var$Xb.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $d7238066c5de7f1c$var$Pu.lookAt($d7238066c5de7f1c$var$Xb, $d7238066c5de7f1c$var$Av, this.up) : $d7238066c5de7f1c$var$Pu.lookAt($d7238066c5de7f1c$var$Av, $d7238066c5de7f1c$var$Xb, this.up), this.quaternion.setFromRotationMatrix($d7238066c5de7f1c$var$Pu), n && ($d7238066c5de7f1c$var$Pu.extractRotation(n.matrixWorld), $d7238066c5de7f1c$var$wm.setFromRotationMatrix($d7238066c5de7f1c$var$Pu), this.quaternion.premultiply($d7238066c5de7f1c$var$wm.invert()));
    }
    /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */ add(e) {
        if (arguments.length > 1) {
            for(let t = 0; t < arguments.length; t++)this.add(arguments[t]);
            return this;
        }
        return e === this ? ($d7238066c5de7f1c$var$nt("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent($d7238066c5de7f1c$var$V5), $d7238066c5de7f1c$var$Wm.child = e, this.dispatchEvent($d7238066c5de7f1c$var$Wm), $d7238066c5de7f1c$var$Wm.child = null) : $d7238066c5de7f1c$var$nt("Object3D.add: object not an instance of THREE.Object3D.", e), this);
    }
    /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */ remove(e) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const t = this.children.indexOf(e);
        return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent($d7238066c5de7f1c$var$z$), $d7238066c5de7f1c$var$QW.child = e, this.dispatchEvent($d7238066c5de7f1c$var$QW), $d7238066c5de7f1c$var$QW.child = null), this;
    }
    /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */ removeFromParent() {
        const e = this.parent;
        return e !== null && e.remove(this), this;
    }
    /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */ clear() {
        return this.remove(...this.children);
    }
    /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */ attach(e) {
        return this.updateWorldMatrix(!0, !1), $d7238066c5de7f1c$var$Pu.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), $d7238066c5de7f1c$var$Pu.multiply(e.parent.matrixWorld)), e.applyMatrix4($d7238066c5de7f1c$var$Pu), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent($d7238066c5de7f1c$var$V5), $d7238066c5de7f1c$var$Wm.child = e, this.dispatchEvent($d7238066c5de7f1c$var$Wm), $d7238066c5de7f1c$var$Wm.child = null, this;
    }
    /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */ getObjectById(e) {
        return this.getObjectByProperty("id", e);
    }
    /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */ getObjectByName(e) {
        return this.getObjectByProperty("name", e);
    }
    /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */ getObjectByProperty(e, t) {
        if (this[e] === t) return this;
        for(let i = 0, n = this.children.length; i < n; i++){
            const a = this.children[i].getObjectByProperty(e, t);
            if (a !== void 0) return a;
        }
    }
    /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */ getObjectsByProperty(e, t, i = []) {
        this[e] === t && i.push(this);
        const n = this.children;
        for(let s = 0, a = n.length; s < a; s++)n[s].getObjectsByProperty(e, t, i);
        return i;
    }
    /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */ getWorldPosition(e) {
        return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
    }
    /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */ getWorldQuaternion(e) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($d7238066c5de7f1c$var$Xb, e, $d7238066c5de7f1c$var$T$), e;
    }
    /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */ getWorldScale(e) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($d7238066c5de7f1c$var$Xb, $d7238066c5de7f1c$var$M$, e), e;
    }
    /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */ getWorldDirection(e) {
        this.updateWorldMatrix(!0, !1);
        const t = this.matrixWorld.elements;
        return e.set(t[8], t[9], t[10]).normalize();
    }
    /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */ raycast() {}
    /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */ traverse(e) {
        e(this);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].traverse(e);
    }
    /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */ traverseVisible(e) {
        if (this.visible === !1) return;
        e(this);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].traverseVisible(e);
    }
    /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */ traverseAncestors(e) {
        const t = this.parent;
        t !== null && (e(t), t.traverseAncestors(e));
    }
    /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */ updateMatrixWorld(e) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].updateMatrixWorld(e);
    }
    /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */ updateWorldMatrix(e, t) {
        const i = this.parent;
        if (e === !0 && i !== null && i.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), t === !0) {
            const n = this.children;
            for(let s = 0, a = n.length; s < a; s++)n[s].updateWorldMatrix(!1, !0);
        }
    }
    /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */ toJSON(e) {
        const t = e === void 0 || typeof e == "string", i = {};
        t && (e = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, i.metadata = {
            version: 4.7,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        const n = {};
        n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.castShadow === !0 && (n.castShadow = !0), this.receiveShadow === !0 && (n.receiveShadow = !0), this.visible === !1 && (n.visible = !1), this.frustumCulled === !1 && (n.frustumCulled = !1), this.renderOrder !== 0 && (n.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), n.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (n.matrixAutoUpdate = !1), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (n.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (n.type = "BatchedMesh", n.perObjectFrustumCulled = this.perObjectFrustumCulled, n.sortObjects = this.sortObjects, n.drawRanges = this._drawRanges, n.reservedRanges = this._reservedRanges, n.geometryInfo = this._geometryInfo.map((o)=>({
                ...o,
                boundingBox: o.boundingBox ? o.boundingBox.toJSON() : void 0,
                boundingSphere: o.boundingSphere ? o.boundingSphere.toJSON() : void 0
            })), n.instanceInfo = this._instanceInfo.map((o)=>({
                ...o
            })), n.availableInstanceIds = this._availableInstanceIds.slice(), n.availableGeometryIds = this._availableGeometryIds.slice(), n.nextIndexStart = this._nextIndexStart, n.nextVertexStart = this._nextVertexStart, n.geometryCount = this._geometryCount, n.maxInstanceCount = this._maxInstanceCount, n.maxVertexCount = this._maxVertexCount, n.maxIndexCount = this._maxIndexCount, n.geometryInitialized = this._geometryInitialized, n.matricesTexture = this._matricesTexture.toJSON(e), n.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (n.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (n.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (n.boundingBox = this.boundingBox.toJSON()));
        function s(o, g) {
            return o[g.uuid] === void 0 && (o[g.uuid] = g.toJSON(e)), g.uuid;
        }
        if (this.isScene) this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (n.environment = this.environment.toJSON(e).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            n.geometry = s(e.geometries, this.geometry);
            const o = this.geometry.parameters;
            if (o !== void 0 && o.shapes !== void 0) {
                const g = o.shapes;
                if (Array.isArray(g)) for(let l = 0, c = g.length; l < c; l++){
                    const d = g[l];
                    s(e.shapes, d);
                }
                else s(e.shapes, g);
            }
        }
        if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s(e.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), this.material !== void 0) {
            if (Array.isArray(this.material)) {
                const o = [];
                for(let g = 0, l = this.material.length; g < l; g++)o.push(s(e.materials, this.material[g]));
                n.material = o;
            } else n.material = s(e.materials, this.material);
        }
        if (this.children.length > 0) {
            n.children = [];
            for(let o = 0; o < this.children.length; o++)n.children.push(this.children[o].toJSON(e).object);
        }
        if (this.animations.length > 0) {
            n.animations = [];
            for(let o = 0; o < this.animations.length; o++){
                const g = this.animations[o];
                n.animations.push(s(e.animations, g));
            }
        }
        if (t) {
            const o = a(e.geometries), g = a(e.materials), l = a(e.textures), c = a(e.images), d = a(e.shapes), p = a(e.skeletons), A = a(e.animations), y = a(e.nodes);
            o.length > 0 && (i.geometries = o), g.length > 0 && (i.materials = g), l.length > 0 && (i.textures = l), c.length > 0 && (i.images = c), d.length > 0 && (i.shapes = d), p.length > 0 && (i.skeletons = p), A.length > 0 && (i.animations = A), y.length > 0 && (i.nodes = y);
        }
        return i.object = n, i;
        function a(o) {
            const g = [];
            for(const l in o){
                const c = o[l];
                delete c.metadata, g.push(c);
            }
            return g;
        }
    }
    /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */ clone(e) {
        return new this.constructor().copy(this, e);
    }
    /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */ copy(e, t = !0) {
        if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0) for(let i = 0; i < e.children.length; i++){
            const n = e.children[i];
            this.add(n.clone());
        }
        return this;
    }
}
$d7238066c5de7f1c$var$lr.DEFAULT_UP = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(0, 1, 0);
$d7238066c5de7f1c$var$lr.DEFAULT_MATRIX_AUTO_UPDATE = !0;
$d7238066c5de7f1c$var$lr.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const $d7238066c5de7f1c$var$Fl = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Qu = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$OW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Ou = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Hm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Xm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$w5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$jW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$qW = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$$W = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$eH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$tH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$iH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi();
class $d7238066c5de7f1c$var$Ql {
    /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */ constructor(e = new $d7238066c5de7f1c$var$Ce(), t = new $d7238066c5de7f1c$var$Ce(), i = new $d7238066c5de7f1c$var$Ce()){
        this.a = e, this.b = t, this.c = i;
    }
    /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */ static getNormal(e, t, i, n) {
        n.subVectors(i, t), $d7238066c5de7f1c$var$Fl.subVectors(e, t), n.cross($d7238066c5de7f1c$var$Fl);
        const s = n.lengthSq();
        return s > 0 ? n.multiplyScalar(1 / Math.sqrt(s)) : n.set(0, 0, 0);
    }
    /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */ static getBarycoord(e, t, i, n, s) {
        $d7238066c5de7f1c$var$Fl.subVectors(n, t), $d7238066c5de7f1c$var$Qu.subVectors(i, t), $d7238066c5de7f1c$var$OW.subVectors(e, t);
        const a = $d7238066c5de7f1c$var$Fl.dot($d7238066c5de7f1c$var$Fl), o = $d7238066c5de7f1c$var$Fl.dot($d7238066c5de7f1c$var$Qu), g = $d7238066c5de7f1c$var$Fl.dot($d7238066c5de7f1c$var$OW), l = $d7238066c5de7f1c$var$Qu.dot($d7238066c5de7f1c$var$Qu), c = $d7238066c5de7f1c$var$Qu.dot($d7238066c5de7f1c$var$OW), d = a * l - o * o;
        if (d === 0) return s.set(0, 0, 0), null;
        const p = 1 / d, A = (l * g - o * c) * p, y = (a * c - o * g) * p;
        return s.set(1 - A - y, y, A);
    }
    /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */ static containsPoint(e, t, i, n) {
        return this.getBarycoord(e, t, i, n, $d7238066c5de7f1c$var$Ou) === null ? !1 : $d7238066c5de7f1c$var$Ou.x >= 0 && $d7238066c5de7f1c$var$Ou.y >= 0 && $d7238066c5de7f1c$var$Ou.x + $d7238066c5de7f1c$var$Ou.y <= 1;
    }
    /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */ static getInterpolation(e, t, i, n, s, a, o, g) {
        return this.getBarycoord(e, t, i, n, $d7238066c5de7f1c$var$Ou) === null ? (g.x = 0, g.y = 0, "z" in g && (g.z = 0), "w" in g && (g.w = 0), null) : (g.setScalar(0), g.addScaledVector(s, $d7238066c5de7f1c$var$Ou.x), g.addScaledVector(a, $d7238066c5de7f1c$var$Ou.y), g.addScaledVector(o, $d7238066c5de7f1c$var$Ou.z), g);
    }
    /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */ static getInterpolatedAttribute(e, t, i, n, s, a) {
        return $d7238066c5de7f1c$var$eH.setScalar(0), $d7238066c5de7f1c$var$tH.setScalar(0), $d7238066c5de7f1c$var$iH.setScalar(0), $d7238066c5de7f1c$var$eH.fromBufferAttribute(e, t), $d7238066c5de7f1c$var$tH.fromBufferAttribute(e, i), $d7238066c5de7f1c$var$iH.fromBufferAttribute(e, n), a.setScalar(0), a.addScaledVector($d7238066c5de7f1c$var$eH, s.x), a.addScaledVector($d7238066c5de7f1c$var$tH, s.y), a.addScaledVector($d7238066c5de7f1c$var$iH, s.z), a;
    }
    /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */ static isFrontFacing(e, t, i, n) {
        return $d7238066c5de7f1c$var$Fl.subVectors(i, t), $d7238066c5de7f1c$var$Qu.subVectors(e, t), $d7238066c5de7f1c$var$Fl.cross($d7238066c5de7f1c$var$Qu).dot(n) < 0;
    }
    /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */ set(e, t, i) {
        return this.a.copy(e), this.b.copy(t), this.c.copy(i), this;
    }
    /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */ setFromPointsAndIndices(e, t, i, n) {
        return this.a.copy(e[t]), this.b.copy(e[i]), this.c.copy(e[n]), this;
    }
    /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */ setFromAttributeAndIndices(e, t, i, n) {
        return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, i), this.c.fromBufferAttribute(e, n), this;
    }
    /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */ copy(e) {
        return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
    }
    /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */ getArea() {
        return $d7238066c5de7f1c$var$Fl.subVectors(this.c, this.b), $d7238066c5de7f1c$var$Qu.subVectors(this.a, this.b), $d7238066c5de7f1c$var$Fl.cross($d7238066c5de7f1c$var$Qu).length() * 0.5;
    }
    /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */ getMidpoint(e) {
        return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */ getNormal(e) {
        return $d7238066c5de7f1c$var$Ql.getNormal(this.a, this.b, this.c, e);
    }
    /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */ getPlane(e) {
        return e.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */ getBarycoord(e, t) {
        return $d7238066c5de7f1c$var$Ql.getBarycoord(e, this.a, this.b, this.c, t);
    }
    /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */ getInterpolation(e, t, i, n, s) {
        return $d7238066c5de7f1c$var$Ql.getInterpolation(e, this.a, this.b, this.c, t, i, n, s);
    }
    /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */ containsPoint(e) {
        return $d7238066c5de7f1c$var$Ql.containsPoint(e, this.a, this.b, this.c);
    }
    /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */ isFrontFacing(e) {
        return $d7238066c5de7f1c$var$Ql.isFrontFacing(this.a, this.b, this.c, e);
    }
    /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */ intersectsBox(e) {
        return e.intersectsTriangle(this);
    }
    /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */ closestPointToPoint(e, t) {
        const i = this.a, n = this.b, s = this.c;
        let a, o;
        $d7238066c5de7f1c$var$Hm.subVectors(n, i), $d7238066c5de7f1c$var$Xm.subVectors(s, i), $d7238066c5de7f1c$var$jW.subVectors(e, i);
        const g = $d7238066c5de7f1c$var$Hm.dot($d7238066c5de7f1c$var$jW), l = $d7238066c5de7f1c$var$Xm.dot($d7238066c5de7f1c$var$jW);
        if (g <= 0 && l <= 0) return t.copy(i);
        $d7238066c5de7f1c$var$qW.subVectors(e, n);
        const c = $d7238066c5de7f1c$var$Hm.dot($d7238066c5de7f1c$var$qW), d = $d7238066c5de7f1c$var$Xm.dot($d7238066c5de7f1c$var$qW);
        if (c >= 0 && d <= c) return t.copy(n);
        const p = g * d - c * l;
        if (p <= 0 && g >= 0 && c <= 0) return a = g / (g - c), t.copy(i).addScaledVector($d7238066c5de7f1c$var$Hm, a);
        $d7238066c5de7f1c$var$$W.subVectors(e, s);
        const A = $d7238066c5de7f1c$var$Hm.dot($d7238066c5de7f1c$var$$W), y = $d7238066c5de7f1c$var$Xm.dot($d7238066c5de7f1c$var$$W);
        if (y >= 0 && A <= y) return t.copy(s);
        const G = A * l - g * y;
        if (G <= 0 && l >= 0 && y <= 0) return o = l / (l - y), t.copy(i).addScaledVector($d7238066c5de7f1c$var$Xm, o);
        const Z = c * y - A * d;
        if (Z <= 0 && d - c >= 0 && A - y >= 0) return $d7238066c5de7f1c$var$w5.subVectors(s, n), o = (d - c) / (d - c + (A - y)), t.copy(n).addScaledVector($d7238066c5de7f1c$var$w5, o);
        const v = 1 / (Z + G + p);
        return a = G * v, o = p * v, t.copy(i).addScaledVector($d7238066c5de7f1c$var$Hm, a).addScaledVector($d7238066c5de7f1c$var$Xm, o);
    }
    /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */ equals(e) {
        return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
    }
}
const $d7238066c5de7f1c$var$g3 = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, $d7238066c5de7f1c$var$Hd = {
    h: 0,
    s: 0,
    l: 0
}, $d7238066c5de7f1c$var$bv = {
    h: 0,
    s: 0,
    l: 0
};
function $d7238066c5de7f1c$var$nH(r, e, t) {
    return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * 6 * t : t < 0.5 ? e : t < 2 / 3 ? r + (e - r) * 6 * (2 / 3 - t) : r;
}
class $d7238066c5de7f1c$var$rn {
    /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */ constructor(e, t, i){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, i);
    }
    /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */ set(e, t, i) {
        if (t === void 0 && i === void 0) {
            const n = e;
            n && n.isColor ? this.copy(n) : typeof n == "number" ? this.setHex(n) : typeof n == "string" && this.setStyle(n);
        } else this.setRGB(e, t, i);
        return this;
    }
    /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */ setScalar(e) {
        return this.r = e, this.g = e, this.b = e, this;
    }
    /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */ setHex(e, t = $d7238066c5de7f1c$var$$o) {
        return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, $d7238066c5de7f1c$var$sn.colorSpaceToWorking(this, t), this;
    }
    /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */ setRGB(e, t, i, n = $d7238066c5de7f1c$var$sn.workingColorSpace) {
        return this.r = e, this.g = t, this.b = i, $d7238066c5de7f1c$var$sn.colorSpaceToWorking(this, n), this;
    }
    /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */ setHSL(e, t, i, n = $d7238066c5de7f1c$var$sn.workingColorSpace) {
        if (e = $d7238066c5de7f1c$var$$N(e, 1), t = $d7238066c5de7f1c$var$Ni(t, 0, 1), i = $d7238066c5de7f1c$var$Ni(i, 0, 1), t === 0) this.r = this.g = this.b = i;
        else {
            const s = i <= 0.5 ? i * (1 + t) : i + t - i * t, a = 2 * i - s;
            this.r = $d7238066c5de7f1c$var$nH(a, s, e + 1 / 3), this.g = $d7238066c5de7f1c$var$nH(a, s, e), this.b = $d7238066c5de7f1c$var$nH(a, s, e - 1 / 3);
        }
        return $d7238066c5de7f1c$var$sn.colorSpaceToWorking(this, n), this;
    }
    /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */ setStyle(e, t = $d7238066c5de7f1c$var$$o) {
        function i(s) {
            s !== void 0 && parseFloat(s) < 1 && $d7238066c5de7f1c$var$ze("Color: Alpha component of " + e + " will be ignored.");
        }
        let n;
        if (n = /^(\w+)\(([^\)]*)\)/.exec(e)) {
            let s;
            const a = n[1], o = n[2];
            switch(a){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return i(s[4]), this.setRGB(Math.min(255, parseInt(s[1], 10)) / 255, Math.min(255, parseInt(s[2], 10)) / 255, Math.min(255, parseInt(s[3], 10)) / 255, t);
                    if (s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return i(s[4]), this.setRGB(Math.min(100, parseInt(s[1], 10)) / 100, Math.min(100, parseInt(s[2], 10)) / 100, Math.min(100, parseInt(s[3], 10)) / 100, t);
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return i(s[4]), this.setHSL(parseFloat(s[1]) / 360, parseFloat(s[2]) / 100, parseFloat(s[3]) / 100, t);
                    break;
                default:
                    $d7238066c5de7f1c$var$ze("Color: Unknown color model " + e);
            }
        } else if (n = /^\#([A-Fa-f\d]+)$/.exec(e)) {
            const s = n[1], a = s.length;
            if (a === 3) return this.setRGB(parseInt(s.charAt(0), 16) / 15, parseInt(s.charAt(1), 16) / 15, parseInt(s.charAt(2), 16) / 15, t);
            if (a === 6) return this.setHex(parseInt(s, 16), t);
            $d7238066c5de7f1c$var$ze("Color: Invalid hex color " + e);
        } else if (e && e.length > 0) return this.setColorName(e, t);
        return this;
    }
    /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */ setColorName(e, t = $d7238066c5de7f1c$var$$o) {
        const i = $d7238066c5de7f1c$var$g3[e.toLowerCase()];
        return i !== void 0 ? this.setHex(i, t) : $d7238066c5de7f1c$var$ze("Color: Unknown color " + e), this;
    }
    /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */ copy(e) {
        return this.r = e.r, this.g = e.g, this.b = e.b, this;
    }
    /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */ copySRGBToLinear(e) {
        return this.r = $d7238066c5de7f1c$var$CI(e.r), this.g = $d7238066c5de7f1c$var$CI(e.g), this.b = $d7238066c5de7f1c$var$CI(e.b), this;
    }
    /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */ copyLinearToSRGB(e) {
        return this.r = $d7238066c5de7f1c$var$vA(e.r), this.g = $d7238066c5de7f1c$var$vA(e.g), this.b = $d7238066c5de7f1c$var$vA(e.b), this;
    }
    /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */ convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */ convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */ getHex(e = $d7238066c5de7f1c$var$$o) {
        return $d7238066c5de7f1c$var$sn.workingToColorSpace($d7238066c5de7f1c$var$Ha.copy(this), e), Math.round($d7238066c5de7f1c$var$Ni($d7238066c5de7f1c$var$Ha.r * 255, 0, 255)) * 65536 + Math.round($d7238066c5de7f1c$var$Ni($d7238066c5de7f1c$var$Ha.g * 255, 0, 255)) * 256 + Math.round($d7238066c5de7f1c$var$Ni($d7238066c5de7f1c$var$Ha.b * 255, 0, 255));
    }
    /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */ getHexString(e = $d7238066c5de7f1c$var$$o) {
        return ("000000" + this.getHex(e).toString(16)).slice(-6);
    }
    /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */ getHSL(e, t = $d7238066c5de7f1c$var$sn.workingColorSpace) {
        $d7238066c5de7f1c$var$sn.workingToColorSpace($d7238066c5de7f1c$var$Ha.copy(this), t);
        const i = $d7238066c5de7f1c$var$Ha.r, n = $d7238066c5de7f1c$var$Ha.g, s = $d7238066c5de7f1c$var$Ha.b, a = Math.max(i, n, s), o = Math.min(i, n, s);
        let g, l;
        const c = (o + a) / 2;
        if (o === a) g = 0, l = 0;
        else {
            const d = a - o;
            switch(l = c <= 0.5 ? d / (a + o) : d / (2 - a - o), a){
                case i:
                    g = (n - s) / d + (n < s ? 6 : 0);
                    break;
                case n:
                    g = (s - i) / d + 2;
                    break;
                case s:
                    g = (i - n) / d + 4;
                    break;
            }
            g /= 6;
        }
        return e.h = g, e.s = l, e.l = c, e;
    }
    /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */ getRGB(e, t = $d7238066c5de7f1c$var$sn.workingColorSpace) {
        return $d7238066c5de7f1c$var$sn.workingToColorSpace($d7238066c5de7f1c$var$Ha.copy(this), t), e.r = $d7238066c5de7f1c$var$Ha.r, e.g = $d7238066c5de7f1c$var$Ha.g, e.b = $d7238066c5de7f1c$var$Ha.b, e;
    }
    /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */ getStyle(e = $d7238066c5de7f1c$var$$o) {
        $d7238066c5de7f1c$var$sn.workingToColorSpace($d7238066c5de7f1c$var$Ha.copy(this), e);
        const t = $d7238066c5de7f1c$var$Ha.r, i = $d7238066c5de7f1c$var$Ha.g, n = $d7238066c5de7f1c$var$Ha.b;
        return e !== $d7238066c5de7f1c$var$$o ? `color(${e} ${t.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})` : `rgb(${Math.round(t * 255)},${Math.round(i * 255)},${Math.round(n * 255)})`;
    }
    /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */ offsetHSL(e, t, i) {
        return this.getHSL($d7238066c5de7f1c$var$Hd), this.setHSL($d7238066c5de7f1c$var$Hd.h + e, $d7238066c5de7f1c$var$Hd.s + t, $d7238066c5de7f1c$var$Hd.l + i);
    }
    /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */ add(e) {
        return this.r += e.r, this.g += e.g, this.b += e.b, this;
    }
    /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */ addColors(e, t) {
        return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
    }
    /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */ addScalar(e) {
        return this.r += e, this.g += e, this.b += e, this;
    }
    /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */ sub(e) {
        return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
    }
    /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */ multiply(e) {
        return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
    }
    /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */ multiplyScalar(e) {
        return this.r *= e, this.g *= e, this.b *= e, this;
    }
    /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */ lerp(e, t) {
        return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
    }
    /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */ lerpColors(e, t, i) {
        return this.r = e.r + (t.r - e.r) * i, this.g = e.g + (t.g - e.g) * i, this.b = e.b + (t.b - e.b) * i, this;
    }
    /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */ lerpHSL(e, t) {
        this.getHSL($d7238066c5de7f1c$var$Hd), e.getHSL($d7238066c5de7f1c$var$bv);
        const i = $d7238066c5de7f1c$var$zy($d7238066c5de7f1c$var$Hd.h, $d7238066c5de7f1c$var$bv.h, t), n = $d7238066c5de7f1c$var$zy($d7238066c5de7f1c$var$Hd.s, $d7238066c5de7f1c$var$bv.s, t), s = $d7238066c5de7f1c$var$zy($d7238066c5de7f1c$var$Hd.l, $d7238066c5de7f1c$var$bv.l, t);
        return this.setHSL(i, n, s), this;
    }
    /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */ setFromVector3(e) {
        return this.r = e.x, this.g = e.y, this.b = e.z, this;
    }
    /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */ applyMatrix3(e) {
        const t = this.r, i = this.g, n = this.b, s = e.elements;
        return this.r = s[0] * t + s[3] * i + s[6] * n, this.g = s[1] * t + s[4] * i + s[7] * n, this.b = s[2] * t + s[5] * i + s[8] * n, this;
    }
    /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */ equals(e) {
        return e.r === this.r && e.g === this.g && e.b === this.b;
    }
    /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */ fromArray(e, t = 0) {
        return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
    }
    /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */ toArray(e = [], t = 0) {
        return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
    }
    /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */ fromBufferAttribute(e, t) {
        return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
    }
    /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
}
const $d7238066c5de7f1c$var$Ha = /* @__PURE__ */ new $d7238066c5de7f1c$var$rn();
$d7238066c5de7f1c$var$rn.NAMES = $d7238066c5de7f1c$var$g3;
let $d7238066c5de7f1c$var$k$ = 0;
class $d7238066c5de7f1c$var$Ho extends $d7238066c5de7f1c$var$wI {
    /**
   * Constructs a new material.
   */ constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$k$++
        }), this.uuid = $d7238066c5de7f1c$var$hI(), this.name = "", this.type = "Material", this.blending = $d7238066c5de7f1c$var$uI, this.side = $d7238066c5de7f1c$var$nh, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = $d7238066c5de7f1c$var$OS, this.blendDst = $d7238066c5de7f1c$var$jS, this.blendEquation = $d7238066c5de7f1c$var$Pl, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new $d7238066c5de7f1c$var$rn(0, 0, 0), this.blendAlpha = 0, this.depthFunc = $d7238066c5de7f1c$var$qS, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = $d7238066c5de7f1c$var$v2, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = $d7238066c5de7f1c$var$SC, this.stencilZFail = $d7238066c5de7f1c$var$SC, this.stencilZPass = $d7238066c5de7f1c$var$SC, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(e) {
        this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
    }
    /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */ onBeforeRender() {}
    /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */ onBeforeCompile() {}
    /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */ setValues(e) {
        if (e !== void 0) for(const t in e){
            const i = e[t];
            if (i === void 0) {
                $d7238066c5de7f1c$var$ze(`Material: parameter '${t}' has value of undefined.`);
                continue;
            }
            const n = this[t];
            if (n === void 0) {
                $d7238066c5de7f1c$var$ze(`Material: '${t}' is not a property of THREE.${this.type}.`);
                continue;
            }
            n && n.isColor ? n.set(i) : n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[t] = i;
        }
    }
    /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */ toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        t && (e = {
            textures: {},
            images: {}
        });
        const i = {
            metadata: {
                version: 4.7,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), this.roughness !== void 0 && (i.roughness = this.roughness), this.metalness !== void 0 && (i.metalness = this.metalness), this.sheen !== void 0 && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (i.shininess = this.shininess), this.clearcoat !== void 0 && (i.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (i.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (i.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (i.dispersion = this.dispersion), this.iridescence !== void 0 && (i.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (i.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (i.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(e).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(e).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(e).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(e).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(e).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (i.combine = this.combine)), this.envMapRotation !== void 0 && (i.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (i.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (i.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (i.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (i.size = this.size), this.shadowSide !== null && (i.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (i.sizeAttenuation = this.sizeAttenuation), this.blending !== $d7238066c5de7f1c$var$uI && (i.blending = this.blending), this.side !== $d7238066c5de7f1c$var$nh && (i.side = this.side), this.vertexColors === !0 && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), this.transparent === !0 && (i.transparent = !0), this.blendSrc !== $d7238066c5de7f1c$var$OS && (i.blendSrc = this.blendSrc), this.blendDst !== $d7238066c5de7f1c$var$jS && (i.blendDst = this.blendDst), this.blendEquation !== $d7238066c5de7f1c$var$Pl && (i.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (i.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (i.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (i.blendAlpha = this.blendAlpha), this.depthFunc !== $d7238066c5de7f1c$var$qS && (i.depthFunc = this.depthFunc), this.depthTest === !1 && (i.depthTest = this.depthTest), this.depthWrite === !1 && (i.depthWrite = this.depthWrite), this.colorWrite === !1 && (i.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (i.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== $d7238066c5de7f1c$var$v2 && (i.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (i.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== $d7238066c5de7f1c$var$SC && (i.stencilFail = this.stencilFail), this.stencilZFail !== $d7238066c5de7f1c$var$SC && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== $d7238066c5de7f1c$var$SC && (i.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (i.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (i.rotation = this.rotation), this.polygonOffset === !0 && (i.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (i.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (i.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (i.linewidth = this.linewidth), this.dashSize !== void 0 && (i.dashSize = this.dashSize), this.gapSize !== void 0 && (i.gapSize = this.gapSize), this.scale !== void 0 && (i.scale = this.scale), this.dithering === !0 && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), this.alphaHash === !0 && (i.alphaHash = !0), this.alphaToCoverage === !0 && (i.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (i.premultipliedAlpha = !0), this.forceSinglePass === !0 && (i.forceSinglePass = !0), this.wireframe === !0 && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (i.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (i.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (i.flatShading = !0), this.visible === !1 && (i.visible = !1), this.toneMapped === !1 && (i.toneMapped = !1), this.fog === !1 && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData);
        function n(s) {
            const a = [];
            for(const o in s){
                const g = s[o];
                delete g.metadata, a.push(g);
            }
            return a;
        }
        if (t) {
            const s = n(e.textures), a = n(e.images);
            s.length > 0 && (i.textures = s), a.length > 0 && (i.images = a);
        }
        return i;
    }
    /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */ copy(e) {
        this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
        const t = e.clippingPlanes;
        let i = null;
        if (t !== null) {
            const n = t.length;
            i = new Array(n);
            for(let s = 0; s !== n; ++s)i[s] = t[s].clone();
        }
        return this.clippingPlanes = i, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        e === !0 && this.version++;
    }
}
class $d7238066c5de7f1c$var$Dd extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $d7238066c5de7f1c$var$il(), this.combine = $d7238066c5de7f1c$var$nR, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
    }
}
const $d7238066c5de7f1c$var$sI = /* @__PURE__ */ $d7238066c5de7f1c$var$E$();
function $d7238066c5de7f1c$var$E$() {
    const r = new ArrayBuffer(4), e = new Float32Array(r), t = new Uint32Array(r), i = new Uint32Array(512), n = new Uint32Array(512);
    for(let g = 0; g < 256; ++g){
        const l = g - 127;
        l < -27 ? (i[g] = 0, i[g | 256] = 32768, n[g] = 24, n[g | 256] = 24) : l < -14 ? (i[g] = 1024 >> -l - 14, i[g | 256] = 1024 >> -l - 14 | 32768, n[g] = -l - 1, n[g | 256] = -l - 1) : l <= 15 ? (i[g] = l + 15 << 10, i[g | 256] = l + 15 << 10 | 32768, n[g] = 13, n[g | 256] = 13) : l < 128 ? (i[g] = 31744, i[g | 256] = 64512, n[g] = 24, n[g | 256] = 24) : (i[g] = 31744, i[g | 256] = 64512, n[g] = 13, n[g | 256] = 13);
    }
    const s = new Uint32Array(2048), a = new Uint32Array(64), o = new Uint32Array(64);
    for(let g = 1; g < 1024; ++g){
        let l = g << 13, c = 0;
        for(; !(l & 8388608);)l <<= 1, c -= 8388608;
        l &= -8388609, c += 947912704, s[g] = l | c;
    }
    for(let g = 1024; g < 2048; ++g)s[g] = 939524096 + (g - 1024 << 13);
    for(let g = 1; g < 31; ++g)a[g] = g << 23;
    a[31] = 1199570944, a[32] = 2147483648;
    for(let g = 33; g < 63; ++g)a[g] = 2147483648 + (g - 32 << 23);
    a[63] = 3347054592;
    for(let g = 1; g < 64; ++g)g !== 32 && (o[g] = 1024);
    return {
        floatView: e,
        uint32View: t,
        baseTable: i,
        shiftTable: n,
        mantissaTable: s,
        exponentTable: a,
        offsetTable: o
    };
}
function $d7238066c5de7f1c$var$Qo(r) {
    Math.abs(r) > 65504 && $d7238066c5de7f1c$var$ze("DataUtils.toHalfFloat(): Value out of range."), r = $d7238066c5de7f1c$var$Ni(r, -65504, 65504), $d7238066c5de7f1c$var$sI.floatView[0] = r;
    const e = $d7238066c5de7f1c$var$sI.uint32View[0], t = e >> 23 & 511;
    return $d7238066c5de7f1c$var$sI.baseTable[t] + ((e & 8388607) >> $d7238066c5de7f1c$var$sI.shiftTable[t]);
}
function $d7238066c5de7f1c$var$yv(r) {
    const e = r >> 10;
    return $d7238066c5de7f1c$var$sI.uint32View[0] = $d7238066c5de7f1c$var$sI.mantissaTable[$d7238066c5de7f1c$var$sI.offsetTable[e] + (r & 1023)] + $d7238066c5de7f1c$var$sI.exponentTable[e], $d7238066c5de7f1c$var$sI.floatView[0];
}
const $d7238066c5de7f1c$var$tr = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Bv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
let $d7238066c5de7f1c$var$J$ = 0;
class $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */ constructor(e, t, i = !1){
        if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$J$++
        }), this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = i, this.usage = $d7238066c5de7f1c$var$vZ, this.updateRanges = [], this.gpuType = $d7238066c5de7f1c$var$vo, this.version = 0;
    }
    /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */ onUploadCallback() {}
    /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        e === !0 && this.version++;
    }
    /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */ setUsage(e) {
        return this.usage = e, this;
    }
    /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */ addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    /**
   * Clears the update ranges.
   */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */ copy(e) {
        return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
    }
    /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */ copyAt(e, t, i) {
        e *= this.itemSize, i *= t.itemSize;
        for(let n = 0, s = this.itemSize; n < s; n++)this.array[e + n] = t.array[i + n];
        return this;
    }
    /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */ copyArray(e) {
        return this.array.set(e), this;
    }
    /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */ applyMatrix3(e) {
        if (this.itemSize === 2) for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$Bv.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$Bv.applyMatrix3(e), this.setXY(t, $d7238066c5de7f1c$var$Bv.x, $d7238066c5de7f1c$var$Bv.y);
        else if (this.itemSize === 3) for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$tr.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$tr.applyMatrix3(e), this.setXYZ(t, $d7238066c5de7f1c$var$tr.x, $d7238066c5de7f1c$var$tr.y, $d7238066c5de7f1c$var$tr.z);
        return this;
    }
    /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */ applyMatrix4(e) {
        for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$tr.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$tr.applyMatrix4(e), this.setXYZ(t, $d7238066c5de7f1c$var$tr.x, $d7238066c5de7f1c$var$tr.y, $d7238066c5de7f1c$var$tr.z);
        return this;
    }
    /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */ applyNormalMatrix(e) {
        for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$tr.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$tr.applyNormalMatrix(e), this.setXYZ(t, $d7238066c5de7f1c$var$tr.x, $d7238066c5de7f1c$var$tr.y, $d7238066c5de7f1c$var$tr.z);
        return this;
    }
    /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */ transformDirection(e) {
        for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$tr.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$tr.transformDirection(e), this.setXYZ(t, $d7238066c5de7f1c$var$tr.x, $d7238066c5de7f1c$var$tr.y, $d7238066c5de7f1c$var$tr.z);
        return this;
    }
    /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */ set(e, t = 0) {
        return this.array.set(e, t), this;
    }
    /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */ getComponent(e, t) {
        let i = this.array[e * this.itemSize + t];
        return this.normalized && (i = $d7238066c5de7f1c$var$to(i, this.array)), i;
    }
    /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setComponent(e, t, i) {
        return this.normalized && (i = $d7238066c5de7f1c$var$gi(i, this.array)), this.array[e * this.itemSize + t] = i, this;
    }
    /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */ getX(e) {
        let t = this.array[e * this.itemSize];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setX(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize] = t, this;
    }
    /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */ getY(e) {
        let t = this.array[e * this.itemSize + 1];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setY(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
    }
    /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */ getZ(e) {
        let t = this.array[e * this.itemSize + 2];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setZ(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
    }
    /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */ getW(e) {
        let t = this.array[e * this.itemSize + 3];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setW(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
    }
    /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setXY(e, t, i) {
        return e *= this.itemSize, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this;
    }
    /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setXYZ(e, t, i, n) {
        return e *= this.itemSize, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array), n = $d7238066c5de7f1c$var$gi(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this.array[e + 2] = n, this;
    }
    /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */ setXYZW(e, t, i, n, s) {
        return e *= this.itemSize, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array), n = $d7238066c5de7f1c$var$gi(n, this.array), s = $d7238066c5de7f1c$var$gi(s, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this.array[e + 2] = n, this.array[e + 3] = s, this;
    }
    /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */ onUpload(e) {
        return this.onUploadCallback = e, this;
    }
    /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */ toJSON() {
        const e = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return this.name !== "" && (e.name = this.name), this.usage !== $d7238066c5de7f1c$var$vZ && (e.usage = this.usage), e;
    }
}
class $d7238066c5de7f1c$var$l3 extends $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */ constructor(e, t, i){
        super(new Uint16Array(e), t, i);
    }
}
class $d7238066c5de7f1c$var$c3 extends $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */ constructor(e, t, i){
        super(new Uint32Array(e), t, i);
    }
}
class $d7238066c5de7f1c$var$u3 extends $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */ constructor(e, t, i){
        super(new Uint16Array(e), t, i), this.isFloat16BufferAttribute = !0;
    }
    getX(e) {
        let t = $d7238066c5de7f1c$var$yv(this.array[e * this.itemSize]);
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    setX(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize] = $d7238066c5de7f1c$var$Qo(t), this;
    }
    getY(e) {
        let t = $d7238066c5de7f1c$var$yv(this.array[e * this.itemSize + 1]);
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    setY(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize + 1] = $d7238066c5de7f1c$var$Qo(t), this;
    }
    getZ(e) {
        let t = $d7238066c5de7f1c$var$yv(this.array[e * this.itemSize + 2]);
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    setZ(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize + 2] = $d7238066c5de7f1c$var$Qo(t), this;
    }
    getW(e) {
        let t = $d7238066c5de7f1c$var$yv(this.array[e * this.itemSize + 3]);
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    setW(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.array[e * this.itemSize + 3] = $d7238066c5de7f1c$var$Qo(t), this;
    }
    setXY(e, t, i) {
        return e *= this.itemSize, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array)), this.array[e + 0] = $d7238066c5de7f1c$var$Qo(t), this.array[e + 1] = $d7238066c5de7f1c$var$Qo(i), this;
    }
    setXYZ(e, t, i, n) {
        return e *= this.itemSize, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array), n = $d7238066c5de7f1c$var$gi(n, this.array)), this.array[e + 0] = $d7238066c5de7f1c$var$Qo(t), this.array[e + 1] = $d7238066c5de7f1c$var$Qo(i), this.array[e + 2] = $d7238066c5de7f1c$var$Qo(n), this;
    }
    setXYZW(e, t, i, n, s) {
        return e *= this.itemSize, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array), n = $d7238066c5de7f1c$var$gi(n, this.array), s = $d7238066c5de7f1c$var$gi(s, this.array)), this.array[e + 0] = $d7238066c5de7f1c$var$Qo(t), this.array[e + 1] = $d7238066c5de7f1c$var$Qo(i), this.array[e + 2] = $d7238066c5de7f1c$var$Qo(n), this.array[e + 3] = $d7238066c5de7f1c$var$Qo(s), this;
    }
}
class $d7238066c5de7f1c$var$so extends $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */ constructor(e, t, i){
        super(new Float32Array(e), t, i);
    }
}
let $d7238066c5de7f1c$var$U$ = 0;
const $d7238066c5de7f1c$var$Mg = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$sH = /* @__PURE__ */ new $d7238066c5de7f1c$var$lr(), $d7238066c5de7f1c$var$Nm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Oo = /* @__PURE__ */ new $d7238066c5de7f1c$var$zB(), $d7238066c5de7f1c$var$Nb = /* @__PURE__ */ new $d7238066c5de7f1c$var$zB(), $d7238066c5de7f1c$var$Lr = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$Cu extends $d7238066c5de7f1c$var$wI {
    /**
   * Constructs a new geometry.
   */ constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$U$++
        }), this.uuid = $d7238066c5de7f1c$var$hI(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */ getIndex() {
        return this.index;
    }
    /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */ setIndex(e) {
        return Array.isArray(e) ? this.index = new ($d7238066c5de7f1c$var$a3(e) ? $d7238066c5de7f1c$var$c3 : $d7238066c5de7f1c$var$l3)(e, 1) : this.index = e, this;
    }
    /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @return {BufferGeometry} A reference to this instance.
   */ setIndirect(e) {
        return this.indirect = e, this;
    }
    /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */ getIndirect() {
        return this.indirect;
    }
    /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */ getAttribute(e) {
        return this.attributes[e];
    }
    /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */ setAttribute(e, t) {
        return this.attributes[e] = t, this;
    }
    /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */ deleteAttribute(e) {
        return delete this.attributes[e], this;
    }
    /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */ hasAttribute(e) {
        return this.attributes[e] !== void 0;
    }
    /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */ addGroup(e, t, i = 0) {
        this.groups.push({
            start: e,
            count: t,
            materialIndex: i
        });
    }
    /**
   * Clears all groups.
   */ clearGroups() {
        this.groups = [];
    }
    /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */ setDrawRange(e, t) {
        this.drawRange.start = e, this.drawRange.count = t;
    }
    /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */ applyMatrix4(e) {
        const t = this.attributes.position;
        t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
        const i = this.attributes.normal;
        if (i !== void 0) {
            const s = new $d7238066c5de7f1c$var$Lo().getNormalMatrix(e);
            i.applyNormalMatrix(s), i.needsUpdate = !0;
        }
        const n = this.attributes.tangent;
        return n !== void 0 && (n.transformDirection(e), n.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
    }
    /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */ applyQuaternion(e) {
        return $d7238066c5de7f1c$var$Mg.makeRotationFromQuaternion(e), this.applyMatrix4($d7238066c5de7f1c$var$Mg), this;
    }
    /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */ rotateX(e) {
        return $d7238066c5de7f1c$var$Mg.makeRotationX(e), this.applyMatrix4($d7238066c5de7f1c$var$Mg), this;
    }
    /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */ rotateY(e) {
        return $d7238066c5de7f1c$var$Mg.makeRotationY(e), this.applyMatrix4($d7238066c5de7f1c$var$Mg), this;
    }
    /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */ rotateZ(e) {
        return $d7238066c5de7f1c$var$Mg.makeRotationZ(e), this.applyMatrix4($d7238066c5de7f1c$var$Mg), this;
    }
    /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */ translate(e, t, i) {
        return $d7238066c5de7f1c$var$Mg.makeTranslation(e, t, i), this.applyMatrix4($d7238066c5de7f1c$var$Mg), this;
    }
    /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */ scale(e, t, i) {
        return $d7238066c5de7f1c$var$Mg.makeScale(e, t, i), this.applyMatrix4($d7238066c5de7f1c$var$Mg), this;
    }
    /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */ lookAt(e) {
        return $d7238066c5de7f1c$var$sH.lookAt(e), $d7238066c5de7f1c$var$sH.updateMatrix(), this.applyMatrix4($d7238066c5de7f1c$var$sH.matrix), this;
    }
    /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */ center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter($d7238066c5de7f1c$var$Nm).negate(), this.translate($d7238066c5de7f1c$var$Nm.x, $d7238066c5de7f1c$var$Nm.y, $d7238066c5de7f1c$var$Nm.z), this;
    }
    /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */ setFromPoints(e) {
        const t = this.getAttribute("position");
        if (t === void 0) {
            const i = [];
            for(let n = 0, s = e.length; n < s; n++){
                const a = e[n];
                i.push(a.x, a.y, a.z || 0);
            }
            this.setAttribute("position", new $d7238066c5de7f1c$var$so(i, 3));
        } else {
            const i = Math.min(e.length, t.count);
            for(let n = 0; n < i; n++){
                const s = e[n];
                t.setXYZ(n, s.x, s.y, s.z || 0);
            }
            e.length > t.count && $d7238066c5de7f1c$var$ze("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
        }
        return this;
    }
    /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */ computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new $d7238066c5de7f1c$var$zB());
        const e = this.attributes.position, t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) {
            $d7238066c5de7f1c$var$nt("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(new $d7238066c5de7f1c$var$Ce(-1 / 0, -1 / 0, -1 / 0), new $d7238066c5de7f1c$var$Ce(1 / 0, 1 / 0, 1 / 0));
            return;
        }
        if (e !== void 0) {
            if (this.boundingBox.setFromBufferAttribute(e), t) for(let i = 0, n = t.length; i < n; i++){
                const s = t[i];
                $d7238066c5de7f1c$var$Oo.setFromBufferAttribute(s), this.morphTargetsRelative ? ($d7238066c5de7f1c$var$Lr.addVectors(this.boundingBox.min, $d7238066c5de7f1c$var$Oo.min), this.boundingBox.expandByPoint($d7238066c5de7f1c$var$Lr), $d7238066c5de7f1c$var$Lr.addVectors(this.boundingBox.max, $d7238066c5de7f1c$var$Oo.max), this.boundingBox.expandByPoint($d7238066c5de7f1c$var$Lr)) : (this.boundingBox.expandByPoint($d7238066c5de7f1c$var$Oo.min), this.boundingBox.expandByPoint($d7238066c5de7f1c$var$Oo.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && $d7238066c5de7f1c$var$nt('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */ computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new $d7238066c5de7f1c$var$lR());
        const e = this.attributes.position, t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) {
            $d7238066c5de7f1c$var$nt("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new $d7238066c5de7f1c$var$Ce(), 1 / 0);
            return;
        }
        if (e) {
            const i = this.boundingSphere.center;
            if ($d7238066c5de7f1c$var$Oo.setFromBufferAttribute(e), t) for(let s = 0, a = t.length; s < a; s++){
                const o = t[s];
                $d7238066c5de7f1c$var$Nb.setFromBufferAttribute(o), this.morphTargetsRelative ? ($d7238066c5de7f1c$var$Lr.addVectors($d7238066c5de7f1c$var$Oo.min, $d7238066c5de7f1c$var$Nb.min), $d7238066c5de7f1c$var$Oo.expandByPoint($d7238066c5de7f1c$var$Lr), $d7238066c5de7f1c$var$Lr.addVectors($d7238066c5de7f1c$var$Oo.max, $d7238066c5de7f1c$var$Nb.max), $d7238066c5de7f1c$var$Oo.expandByPoint($d7238066c5de7f1c$var$Lr)) : ($d7238066c5de7f1c$var$Oo.expandByPoint($d7238066c5de7f1c$var$Nb.min), $d7238066c5de7f1c$var$Oo.expandByPoint($d7238066c5de7f1c$var$Nb.max));
            }
            $d7238066c5de7f1c$var$Oo.getCenter(i);
            let n = 0;
            for(let s = 0, a = e.count; s < a; s++)$d7238066c5de7f1c$var$Lr.fromBufferAttribute(e, s), n = Math.max(n, i.distanceToSquared($d7238066c5de7f1c$var$Lr));
            if (t) for(let s = 0, a = t.length; s < a; s++){
                const o = t[s], g = this.morphTargetsRelative;
                for(let l = 0, c = o.count; l < c; l++)$d7238066c5de7f1c$var$Lr.fromBufferAttribute(o, l), g && ($d7238066c5de7f1c$var$Nm.fromBufferAttribute(e, l), $d7238066c5de7f1c$var$Lr.add($d7238066c5de7f1c$var$Nm)), n = Math.max(n, i.distanceToSquared($d7238066c5de7f1c$var$Lr));
            }
            this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && $d7238066c5de7f1c$var$nt('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */ computeTangents() {
        const e = this.index, t = this.attributes;
        if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
            $d7238066c5de7f1c$var$nt("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const i = t.position, n = t.normal, s = t.uv;
        this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new $d7238066c5de7f1c$var$gg(new Float32Array(4 * i.count), 4));
        const a = this.getAttribute("tangent"), o = [], g = [];
        for(let M = 0; M < i.count; M++)o[M] = new $d7238066c5de7f1c$var$Ce(), g[M] = new $d7238066c5de7f1c$var$Ce();
        const l = new $d7238066c5de7f1c$var$Ce(), c = new $d7238066c5de7f1c$var$Ce(), d = new $d7238066c5de7f1c$var$Ce(), p = new $d7238066c5de7f1c$var$Ii(), A = new $d7238066c5de7f1c$var$Ii(), y = new $d7238066c5de7f1c$var$Ii(), G = new $d7238066c5de7f1c$var$Ce(), Z = new $d7238066c5de7f1c$var$Ce();
        function v(M, _, O) {
            l.fromBufferAttribute(i, M), c.fromBufferAttribute(i, _), d.fromBufferAttribute(i, O), p.fromBufferAttribute(s, M), A.fromBufferAttribute(s, _), y.fromBufferAttribute(s, O), c.sub(l), d.sub(l), A.sub(p), y.sub(p);
            const ie = 1 / (A.x * y.y - y.x * A.y);
            isFinite(ie) && (G.copy(c).multiplyScalar(y.y).addScaledVector(d, -A.y).multiplyScalar(ie), Z.copy(d).multiplyScalar(A.x).addScaledVector(c, -y.x).multiplyScalar(ie), o[M].add(G), o[_].add(G), o[O].add(G), g[M].add(Z), g[_].add(Z), g[O].add(Z));
        }
        let V = this.groups;
        V.length === 0 && (V = [
            {
                start: 0,
                count: e.count
            }
        ]);
        for(let M = 0, _ = V.length; M < _; ++M){
            const O = V[M], ie = O.start, he = O.count;
            for(let pe = ie, ce = ie + he; pe < ce; pe += 3)v(e.getX(pe + 0), e.getX(pe + 1), e.getX(pe + 2));
        }
        const H = new $d7238066c5de7f1c$var$Ce(), N = new $d7238066c5de7f1c$var$Ce(), Y = new $d7238066c5de7f1c$var$Ce(), K = new $d7238066c5de7f1c$var$Ce();
        function z(M) {
            Y.fromBufferAttribute(n, M), K.copy(Y);
            const _ = o[M];
            H.copy(_), H.sub(Y.multiplyScalar(Y.dot(_))).normalize(), N.crossVectors(K, _);
            const ie = N.dot(g[M]) < 0 ? -1 : 1;
            a.setXYZW(M, H.x, H.y, H.z, ie);
        }
        for(let M = 0, _ = V.length; M < _; ++M){
            const O = V[M], ie = O.start, he = O.count;
            for(let pe = ie, ce = ie + he; pe < ce; pe += 3)z(e.getX(pe + 0)), z(e.getX(pe + 1)), z(e.getX(pe + 2));
        }
    }
    /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */ computeVertexNormals() {
        const e = this.index, t = this.getAttribute("position");
        if (t !== void 0) {
            let i = this.getAttribute("normal");
            if (i === void 0) i = new $d7238066c5de7f1c$var$gg(new Float32Array(t.count * 3), 3), this.setAttribute("normal", i);
            else for(let p = 0, A = i.count; p < A; p++)i.setXYZ(p, 0, 0, 0);
            const n = new $d7238066c5de7f1c$var$Ce(), s = new $d7238066c5de7f1c$var$Ce(), a = new $d7238066c5de7f1c$var$Ce(), o = new $d7238066c5de7f1c$var$Ce(), g = new $d7238066c5de7f1c$var$Ce(), l = new $d7238066c5de7f1c$var$Ce(), c = new $d7238066c5de7f1c$var$Ce(), d = new $d7238066c5de7f1c$var$Ce();
            if (e) for(let p = 0, A = e.count; p < A; p += 3){
                const y = e.getX(p + 0), G = e.getX(p + 1), Z = e.getX(p + 2);
                n.fromBufferAttribute(t, y), s.fromBufferAttribute(t, G), a.fromBufferAttribute(t, Z), c.subVectors(a, s), d.subVectors(n, s), c.cross(d), o.fromBufferAttribute(i, y), g.fromBufferAttribute(i, G), l.fromBufferAttribute(i, Z), o.add(c), g.add(c), l.add(c), i.setXYZ(y, o.x, o.y, o.z), i.setXYZ(G, g.x, g.y, g.z), i.setXYZ(Z, l.x, l.y, l.z);
            }
            else for(let p = 0, A = t.count; p < A; p += 3)n.fromBufferAttribute(t, p + 0), s.fromBufferAttribute(t, p + 1), a.fromBufferAttribute(t, p + 2), c.subVectors(a, s), d.subVectors(n, s), c.cross(d), i.setXYZ(p + 0, c.x, c.y, c.z), i.setXYZ(p + 1, c.x, c.y, c.z), i.setXYZ(p + 2, c.x, c.y, c.z);
            this.normalizeNormals(), i.needsUpdate = !0;
        }
    }
    /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */ normalizeNormals() {
        const e = this.attributes.normal;
        for(let t = 0, i = e.count; t < i; t++)$d7238066c5de7f1c$var$Lr.fromBufferAttribute(e, t), $d7238066c5de7f1c$var$Lr.normalize(), e.setXYZ(t, $d7238066c5de7f1c$var$Lr.x, $d7238066c5de7f1c$var$Lr.y, $d7238066c5de7f1c$var$Lr.z);
    }
    /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */ toNonIndexed() {
        function e(o, g) {
            const l = o.array, c = o.itemSize, d = o.normalized, p = new l.constructor(g.length * c);
            let A = 0, y = 0;
            for(let G = 0, Z = g.length; G < Z; G++){
                o.isInterleavedBufferAttribute ? A = g[G] * o.data.stride + o.offset : A = g[G] * c;
                for(let v = 0; v < c; v++)p[y++] = l[A++];
            }
            return new $d7238066c5de7f1c$var$gg(p, c, d);
        }
        if (this.index === null) return $d7238066c5de7f1c$var$ze("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        const t = new $d7238066c5de7f1c$var$Cu(), i = this.index.array, n = this.attributes;
        for(const o in n){
            const g = n[o], l = e(g, i);
            t.setAttribute(o, l);
        }
        const s = this.morphAttributes;
        for(const o in s){
            const g = [], l = s[o];
            for(let c = 0, d = l.length; c < d; c++){
                const p = l[c], A = e(p, i);
                g.push(A);
            }
            t.morphAttributes[o] = g;
        }
        t.morphTargetsRelative = this.morphTargetsRelative;
        const a = this.groups;
        for(let o = 0, g = a.length; o < g; o++){
            const l = a[o];
            t.addGroup(l.start, l.count, l.materialIndex);
        }
        return t;
    }
    /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */ toJSON() {
        const e = {
            metadata: {
                version: 4.7,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
            const g = this.parameters;
            for(const l in g)g[l] !== void 0 && (e[l] = g[l]);
            return e;
        }
        e.data = {
            attributes: {}
        };
        const t = this.index;
        t !== null && (e.data.index = {
            type: t.array.constructor.name,
            array: Array.prototype.slice.call(t.array)
        });
        const i = this.attributes;
        for(const g in i){
            const l = i[g];
            e.data.attributes[g] = l.toJSON(e.data);
        }
        const n = {};
        let s = !1;
        for(const g in this.morphAttributes){
            const l = this.morphAttributes[g], c = [];
            for(let d = 0, p = l.length; d < p; d++){
                const A = l[d];
                c.push(A.toJSON(e.data));
            }
            c.length > 0 && (n[g] = c, s = !0);
        }
        s && (e.data.morphAttributes = n, e.data.morphTargetsRelative = this.morphTargetsRelative);
        const a = this.groups;
        a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
        const o = this.boundingSphere;
        return o !== null && (e.data.boundingSphere = o.toJSON()), e;
    }
    /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */ copy(e) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        const t = {};
        this.name = e.name;
        const i = e.index;
        i !== null && this.setIndex(i.clone());
        const n = e.attributes;
        for(const l in n){
            const c = n[l];
            this.setAttribute(l, c.clone(t));
        }
        const s = e.morphAttributes;
        for(const l in s){
            const c = [], d = s[l];
            for(let p = 0, A = d.length; p < A; p++)c.push(d[p].clone(t));
            this.morphAttributes[l] = c;
        }
        this.morphTargetsRelative = e.morphTargetsRelative;
        const a = e.groups;
        for(let l = 0, c = a.length; l < c; l++){
            const d = a[l];
            this.addGroup(d.start, d.count, d.materialIndex);
        }
        const o = e.boundingBox;
        o !== null && (this.boundingBox = o.clone());
        const g = e.boundingSphere;
        return g !== null && (this.boundingSphere = g.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $d7238066c5de7f1c$var$W5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$rC = /* @__PURE__ */ new $d7238066c5de7f1c$var$L$(), $d7238066c5de7f1c$var$fv = /* @__PURE__ */ new $d7238066c5de7f1c$var$lR(), $d7238066c5de7f1c$var$H5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Gv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$vv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Sv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$rH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Zv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$X5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Rv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$SI extends $d7238066c5de7f1c$var$lr {
    /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */ constructor(e = new $d7238066c5de7f1c$var$Cu(), t = new $d7238066c5de7f1c$var$Dd()){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
    }
    copy(e, t) {
        return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
    }
    /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */ updateMorphTargets() {
        const t = this.geometry.morphAttributes, i = Object.keys(t);
        if (i.length > 0) {
            const n = t[i[0]];
            if (n !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, a = n.length; s < a; s++){
                    const o = n[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
                }
            }
        }
    }
    /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */ getVertexPosition(e, t) {
        const i = this.geometry, n = i.attributes.position, s = i.morphAttributes.position, a = i.morphTargetsRelative;
        t.fromBufferAttribute(n, e);
        const o = this.morphTargetInfluences;
        if (s && o) {
            $d7238066c5de7f1c$var$Zv.set(0, 0, 0);
            for(let g = 0, l = s.length; g < l; g++){
                const c = o[g], d = s[g];
                c !== 0 && ($d7238066c5de7f1c$var$rH.fromBufferAttribute(d, e), a ? $d7238066c5de7f1c$var$Zv.addScaledVector($d7238066c5de7f1c$var$rH, c) : $d7238066c5de7f1c$var$Zv.addScaledVector($d7238066c5de7f1c$var$rH.sub(t), c));
            }
            t.add($d7238066c5de7f1c$var$Zv);
        }
        return t;
    }
    /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */ raycast(e, t) {
        const i = this.geometry, n = this.material, s = this.matrixWorld;
        n !== void 0 && (i.boundingSphere === null && i.computeBoundingSphere(), $d7238066c5de7f1c$var$fv.copy(i.boundingSphere), $d7238066c5de7f1c$var$fv.applyMatrix4(s), $d7238066c5de7f1c$var$rC.copy(e.ray).recast(e.near), !($d7238066c5de7f1c$var$fv.containsPoint($d7238066c5de7f1c$var$rC.origin) === !1 && ($d7238066c5de7f1c$var$rC.intersectSphere($d7238066c5de7f1c$var$fv, $d7238066c5de7f1c$var$H5) === null || $d7238066c5de7f1c$var$rC.origin.distanceToSquared($d7238066c5de7f1c$var$H5) > (e.far - e.near) ** 2)) && ($d7238066c5de7f1c$var$W5.copy(s).invert(), $d7238066c5de7f1c$var$rC.copy(e.ray).applyMatrix4($d7238066c5de7f1c$var$W5), !(i.boundingBox !== null && $d7238066c5de7f1c$var$rC.intersectsBox(i.boundingBox) === !1) && this._computeIntersections(e, t, $d7238066c5de7f1c$var$rC)));
    }
    _computeIntersections(e, t, i) {
        let n;
        const s = this.geometry, a = this.material, o = s.index, g = s.attributes.position, l = s.attributes.uv, c = s.attributes.uv1, d = s.attributes.normal, p = s.groups, A = s.drawRange;
        if (o !== null) {
            if (Array.isArray(a)) for(let y = 0, G = p.length; y < G; y++){
                const Z = p[y], v = a[Z.materialIndex], V = Math.max(Z.start, A.start), H = Math.min(o.count, Math.min(Z.start + Z.count, A.start + A.count));
                for(let N = V, Y = H; N < Y; N += 3){
                    const K = o.getX(N), z = o.getX(N + 1), M = o.getX(N + 2);
                    n = $d7238066c5de7f1c$var$Vv(this, v, e, i, l, c, d, K, z, M), n && (n.faceIndex = Math.floor(N / 3), n.face.materialIndex = Z.materialIndex, t.push(n));
                }
            }
            else {
                const y = Math.max(0, A.start), G = Math.min(o.count, A.start + A.count);
                for(let Z = y, v = G; Z < v; Z += 3){
                    const V = o.getX(Z), H = o.getX(Z + 1), N = o.getX(Z + 2);
                    n = $d7238066c5de7f1c$var$Vv(this, a, e, i, l, c, d, V, H, N), n && (n.faceIndex = Math.floor(Z / 3), t.push(n));
                }
            }
        } else if (g !== void 0) {
            if (Array.isArray(a)) for(let y = 0, G = p.length; y < G; y++){
                const Z = p[y], v = a[Z.materialIndex], V = Math.max(Z.start, A.start), H = Math.min(g.count, Math.min(Z.start + Z.count, A.start + A.count));
                for(let N = V, Y = H; N < Y; N += 3){
                    const K = N, z = N + 1, M = N + 2;
                    n = $d7238066c5de7f1c$var$Vv(this, v, e, i, l, c, d, K, z, M), n && (n.faceIndex = Math.floor(N / 3), n.face.materialIndex = Z.materialIndex, t.push(n));
                }
            }
            else {
                const y = Math.max(0, A.start), G = Math.min(g.count, A.start + A.count);
                for(let Z = y, v = G; Z < v; Z += 3){
                    const V = Z, H = Z + 1, N = Z + 2;
                    n = $d7238066c5de7f1c$var$Vv(this, a, e, i, l, c, d, V, H, N), n && (n.faceIndex = Math.floor(Z / 3), t.push(n));
                }
            }
        }
    }
}
function $d7238066c5de7f1c$var$D$(r, e, t, i, n, s, a, o) {
    let g;
    if (e.side === $d7238066c5de7f1c$var$Ka ? g = i.intersectTriangle(a, s, n, !0, o) : g = i.intersectTriangle(n, s, a, e.side === $d7238066c5de7f1c$var$nh, o), g === null) return null;
    $d7238066c5de7f1c$var$Rv.copy(o), $d7238066c5de7f1c$var$Rv.applyMatrix4(r.matrixWorld);
    const l = t.ray.origin.distanceTo($d7238066c5de7f1c$var$Rv);
    return l < t.near || l > t.far ? null : {
        distance: l,
        point: $d7238066c5de7f1c$var$Rv.clone(),
        object: r
    };
}
function $d7238066c5de7f1c$var$Vv(r, e, t, i, n, s, a, o, g, l) {
    r.getVertexPosition(o, $d7238066c5de7f1c$var$Gv), r.getVertexPosition(g, $d7238066c5de7f1c$var$vv), r.getVertexPosition(l, $d7238066c5de7f1c$var$Sv);
    const c = $d7238066c5de7f1c$var$D$(r, e, t, i, $d7238066c5de7f1c$var$Gv, $d7238066c5de7f1c$var$vv, $d7238066c5de7f1c$var$Sv, $d7238066c5de7f1c$var$X5);
    if (c) {
        const d = new $d7238066c5de7f1c$var$Ce();
        $d7238066c5de7f1c$var$Ql.getBarycoord($d7238066c5de7f1c$var$X5, $d7238066c5de7f1c$var$Gv, $d7238066c5de7f1c$var$vv, $d7238066c5de7f1c$var$Sv, d), n && (c.uv = $d7238066c5de7f1c$var$Ql.getInterpolatedAttribute(n, o, g, l, d, new $d7238066c5de7f1c$var$Ii())), s && (c.uv1 = $d7238066c5de7f1c$var$Ql.getInterpolatedAttribute(s, o, g, l, d, new $d7238066c5de7f1c$var$Ii())), a && (c.normal = $d7238066c5de7f1c$var$Ql.getInterpolatedAttribute(a, o, g, l, d, new $d7238066c5de7f1c$var$Ce()), c.normal.dot(i.direction) > 0 && c.normal.multiplyScalar(-1));
        const p = {
            a: o,
            b: g,
            c: l,
            normal: new $d7238066c5de7f1c$var$Ce(),
            materialIndex: 0
        };
        $d7238066c5de7f1c$var$Ql.getNormal($d7238066c5de7f1c$var$Gv, $d7238066c5de7f1c$var$vv, $d7238066c5de7f1c$var$Sv, p.normal), c.face = p, c.barycoord = d;
    }
    return c;
}
class $d7238066c5de7f1c$var$kB extends $d7238066c5de7f1c$var$Cu {
    /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */ constructor(e = 1, t = 1, i = 1, n = 1, s = 1, a = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: e,
            height: t,
            depth: i,
            widthSegments: n,
            heightSegments: s,
            depthSegments: a
        };
        const o = this;
        n = Math.floor(n), s = Math.floor(s), a = Math.floor(a);
        const g = [], l = [], c = [], d = [];
        let p = 0, A = 0;
        y("z", "y", "x", -1, -1, i, t, e, a, s, 0), y("z", "y", "x", 1, -1, i, t, -e, a, s, 1), y("x", "z", "y", 1, 1, e, i, t, n, a, 2), y("x", "z", "y", 1, -1, e, i, -t, n, a, 3), y("x", "y", "z", 1, -1, e, t, i, n, s, 4), y("x", "y", "z", -1, -1, e, t, -i, n, s, 5), this.setIndex(g), this.setAttribute("position", new $d7238066c5de7f1c$var$so(l, 3)), this.setAttribute("normal", new $d7238066c5de7f1c$var$so(c, 3)), this.setAttribute("uv", new $d7238066c5de7f1c$var$so(d, 2));
        function y(G, Z, v, V, H, N, Y, K, z, M, _) {
            const O = N / z, ie = Y / M, he = N / 2, pe = Y / 2, ce = K / 2, $ = z + 1, te = M + 1;
            let Ge = 0, q = 0;
            const de = new $d7238066c5de7f1c$var$Ce();
            for(let ge = 0; ge < te; ge++){
                const Ye = ge * ie - pe;
                for(let Fe = 0; Fe < $; Fe++){
                    const Xe = Fe * O - he;
                    de[G] = Xe * V, de[Z] = Ye * H, de[v] = ce, l.push(de.x, de.y, de.z), de[G] = 0, de[Z] = 0, de[v] = K > 0 ? 1 : -1, c.push(de.x, de.y, de.z), d.push(Fe / z), d.push(1 - ge / M), Ge += 1;
                }
            }
            for(let ge = 0; ge < M; ge++)for(let Ye = 0; Ye < z; Ye++){
                const Fe = p + Ye + $ * ge, Xe = p + Ye + $ * (ge + 1), Te = p + (Ye + 1) + $ * (ge + 1), ct = p + (Ye + 1) + $ * ge;
                g.push(Fe, Xe, ct), g.push(Xe, Te, ct), q += 6;
            }
            o.addGroup(A, q, _), A += q, p += Ge;
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */ static fromJSON(e) {
        return new $d7238066c5de7f1c$var$kB(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
    }
}
function $d7238066c5de7f1c$var$I3(r) {
    const e = {};
    for(const t in r){
        e[t] = {};
        for(const i in r[t]){
            const n = r[t][i];
            n && (n.isColor || n.isMatrix3 || n.isMatrix4 || n.isVector2 || n.isVector3 || n.isVector4 || n.isTexture || n.isQuaternion) ? n.isRenderTargetTexture ? ($d7238066c5de7f1c$var$ze("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[t][i] = null) : e[t][i] = n.clone() : Array.isArray(n) ? e[t][i] = n.slice() : e[t][i] = n;
        }
    }
    return e;
}
function $d7238066c5de7f1c$var$_$(r) {
    const e = [];
    for(let t = 0; t < r.length; t++)e.push(r[t].clone());
    return e;
}
var $d7238066c5de7f1c$var$P$ = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, $d7238066c5de7f1c$var$Q$ = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class $d7238066c5de7f1c$var$O$ extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = $d7238066c5de7f1c$var$P$, this.fragmentShader = $d7238066c5de7f1c$var$Q$, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
            clipCullDistance: !1,
            // set to use vertex shader clipping
            multiDraw: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv1: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = $d7238066c5de7f1c$var$I3(e.uniforms), this.uniformsGroups = $d7238066c5de7f1c$var$_$(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        t.glslVersion = this.glslVersion, t.uniforms = {};
        for(const n in this.uniforms){
            const a = this.uniforms[n].value;
            a && a.isTexture ? t.uniforms[n] = {
                type: "t",
                value: a.toJSON(e).uuid
            } : a && a.isColor ? t.uniforms[n] = {
                type: "c",
                value: a.getHex()
            } : a && a.isVector2 ? t.uniforms[n] = {
                type: "v2",
                value: a.toArray()
            } : a && a.isVector3 ? t.uniforms[n] = {
                type: "v3",
                value: a.toArray()
            } : a && a.isVector4 ? t.uniforms[n] = {
                type: "v4",
                value: a.toArray()
            } : a && a.isMatrix3 ? t.uniforms[n] = {
                type: "m3",
                value: a.toArray()
            } : a && a.isMatrix4 ? t.uniforms[n] = {
                type: "m4",
                value: a.toArray()
            } : t.uniforms[n] = {
                value: a
            };
        }
        Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
        const i = {};
        for(const n in this.extensions)this.extensions[n] === !0 && (i[n] = !0);
        return Object.keys(i).length > 0 && (t.extensions = i), t;
    }
}
class $d7238066c5de7f1c$var$tL extends $d7238066c5de7f1c$var$lr {
    /**
   * Constructs a new camera.
   */ constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new $d7238066c5de7f1c$var$Ji(), this.projectionMatrix = new $d7238066c5de7f1c$var$Ji(), this.projectionMatrixInverse = new $d7238066c5de7f1c$var$Ji(), this.coordinateSystem = $d7238066c5de7f1c$var$rg, this._reversedDepth = !1;
    }
    /**
   * The flag that indicates whether the camera uses a reversed depth buffer.
   *
   * @type {boolean}
   * @default false
   */ get reversedDepth() {
        return this._reversedDepth;
    }
    copy(e, t) {
        return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
    }
    /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */ getWorldDirection(e) {
        return super.getWorldDirection(e).negate();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, t) {
        super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d7238066c5de7f1c$var$Xd = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$N5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii(), $d7238066c5de7f1c$var$L5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
let $d7238066c5de7f1c$var$tg = class extends $d7238066c5de7f1c$var$tL {
    /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */ constructor(e = 50, t = 1, i = 0.1, n = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = i, this.far = n, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(e, t) {
        return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
    }
    /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */ setFocalLength(e) {
        const t = 0.5 * this.getFilmHeight() / e;
        this.fov = $d7238066c5de7f1c$var$MA * 2 * Math.atan(t), this.updateProjectionMatrix();
    }
    /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */ getFocalLength() {
        const e = Math.tan($d7238066c5de7f1c$var$My * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / e;
    }
    /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */ getEffectiveFOV() {
        return $d7238066c5de7f1c$var$MA * 2 * Math.atan(Math.tan($d7238066c5de7f1c$var$My * 0.5 * this.fov) / this.zoom);
    }
    /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */ getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */ getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */ getViewBounds(e, t, i) {
        $d7238066c5de7f1c$var$Xd.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), t.set($d7238066c5de7f1c$var$Xd.x, $d7238066c5de7f1c$var$Xd.y).multiplyScalar(-e / $d7238066c5de7f1c$var$Xd.z), $d7238066c5de7f1c$var$Xd.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), i.set($d7238066c5de7f1c$var$Xd.x, $d7238066c5de7f1c$var$Xd.y).multiplyScalar(-e / $d7238066c5de7f1c$var$Xd.z);
    }
    /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */ getViewSize(e, t) {
        return this.getViewBounds(e, $d7238066c5de7f1c$var$N5, $d7238066c5de7f1c$var$L5), t.subVectors($d7238066c5de7f1c$var$L5, $d7238066c5de7f1c$var$N5);
    }
    /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */ setViewOffset(e, t, i, n, s, a) {
        this.aspect = e / t, this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = s, this.view.height = a, this.updateProjectionMatrix();
    }
    /**
   * Removes the view offset from the projection matrix.
   */ clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */ updateProjectionMatrix() {
        const e = this.near;
        let t = e * Math.tan($d7238066c5de7f1c$var$My * 0.5 * this.fov) / this.zoom, i = 2 * t, n = this.aspect * i, s = -0.5 * n;
        const a = this.view;
        if (this.view !== null && this.view.enabled) {
            const g = a.fullWidth, l = a.fullHeight;
            s += a.offsetX * n / g, t -= a.offsetY * i / l, n *= a.width / g, i *= a.height / l;
        }
        const o = this.filmOffset;
        o !== 0 && (s += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(s, s + n, t, t - i, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
    }
};
const $d7238066c5de7f1c$var$Lm = -90, $d7238066c5de7f1c$var$Ym = 1;
class $d7238066c5de7f1c$var$d3 extends $d7238066c5de7f1c$var$lr {
    /**
   * Constructs a new cube camera.
   *
   * @param {number} near - The camera's near plane.
   * @param {number} far - The camera's far plane.
   * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
   */ constructor(e, t, i){
        super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
        const n = new $d7238066c5de7f1c$var$tg($d7238066c5de7f1c$var$Lm, $d7238066c5de7f1c$var$Ym, e, t);
        n.layers = this.layers, this.add(n);
        const s = new $d7238066c5de7f1c$var$tg($d7238066c5de7f1c$var$Lm, $d7238066c5de7f1c$var$Ym, e, t);
        s.layers = this.layers, this.add(s);
        const a = new $d7238066c5de7f1c$var$tg($d7238066c5de7f1c$var$Lm, $d7238066c5de7f1c$var$Ym, e, t);
        a.layers = this.layers, this.add(a);
        const o = new $d7238066c5de7f1c$var$tg($d7238066c5de7f1c$var$Lm, $d7238066c5de7f1c$var$Ym, e, t);
        o.layers = this.layers, this.add(o);
        const g = new $d7238066c5de7f1c$var$tg($d7238066c5de7f1c$var$Lm, $d7238066c5de7f1c$var$Ym, e, t);
        g.layers = this.layers, this.add(g);
        const l = new $d7238066c5de7f1c$var$tg($d7238066c5de7f1c$var$Lm, $d7238066c5de7f1c$var$Ym, e, t);
        l.layers = this.layers, this.add(l);
    }
    /**
   * Must be called when the coordinate system of the cube camera is changed.
   */ updateCoordinateSystem() {
        const e = this.coordinateSystem, t = this.children.concat(), [i, n, s, a, o, g] = t;
        for (const l of t)this.remove(l);
        if (e === $d7238066c5de7f1c$var$rg) i.up.set(0, 1, 0), i.lookAt(1, 0, 0), n.up.set(0, 1, 0), n.lookAt(-1, 0, 0), s.up.set(0, 0, -1), s.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), o.up.set(0, 1, 0), o.lookAt(0, 0, 1), g.up.set(0, 1, 0), g.lookAt(0, 0, -1);
        else if (e === $d7238066c5de7f1c$var$uu) i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), n.up.set(0, -1, 0), n.lookAt(1, 0, 0), s.up.set(0, 0, 1), s.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), o.up.set(0, -1, 0), o.lookAt(0, 0, 1), g.up.set(0, -1, 0), g.lookAt(0, 0, -1);
        else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
        for (const l of t)this.add(l), l.updateMatrixWorld();
    }
    /**
   * Calling this method will render the given scene with the given renderer
   * into the cube render target of the camera.
   *
   * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
   * @param {Scene} scene - The scene to render.
   */ update(e, t) {
        this.parent === null && this.updateMatrixWorld();
        const { renderTarget: i, activeMipmapLevel: n } = this;
        this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
        const [s, a, o, g, l, c] = this.children, d = e.getRenderTarget(), p = e.getActiveCubeFace(), A = e.getActiveMipmapLevel(), y = e.xr.enabled;
        e.xr.enabled = !1;
        const G = i.texture.generateMipmaps;
        i.texture.generateMipmaps = !1, e.setRenderTarget(i, 0, n), e.render(t, s), e.setRenderTarget(i, 1, n), e.render(t, a), e.setRenderTarget(i, 2, n), e.render(t, o), e.setRenderTarget(i, 3, n), e.render(t, g), e.setRenderTarget(i, 4, n), e.render(t, l), i.texture.generateMipmaps = G, e.setRenderTarget(i, 5, n), e.render(t, c), e.setRenderTarget(d, p, A), e.xr.enabled = y, i.texture.needsPMREMUpdate = !0;
    }
}
class $d7238066c5de7f1c$var$cR extends $d7238066c5de7f1c$var$Ca {
    /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */ constructor(e = [], t = $d7238066c5de7f1c$var$gB, i, n, s, a, o, g, l, c){
        super(e, t, i, n, s, a, o, g, l, c), this.isCubeTexture = !0, this.flipY = !1;
    }
    /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */ get images() {
        return this.image;
    }
    set images(e) {
        this.image = e;
    }
}
class $d7238066c5de7f1c$var$j$ extends $d7238066c5de7f1c$var$H$ {
    /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */ constructor(e = 1, t = {}){
        super(e, e, t), this.isWebGLCubeRenderTarget = !0;
        const i = {
            width: e,
            height: e,
            depth: 1
        }, n = [
            i,
            i,
            i,
            i,
            i,
            i
        ];
        this.texture = new $d7238066c5de7f1c$var$cR(n), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
    }
    /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {WebGLCubeRenderTarget} A reference to this cube render target.
   */ fromEquirectangularTexture(e, t) {
        this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
        const i = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        }, n = new $d7238066c5de7f1c$var$kB(5, 5, 5), s = new $d7238066c5de7f1c$var$O$({
            name: "CubemapFromEquirect",
            uniforms: $d7238066c5de7f1c$var$I3(i.uniforms),
            vertexShader: i.vertexShader,
            fragmentShader: i.fragmentShader,
            side: $d7238066c5de7f1c$var$Ka,
            blending: $d7238066c5de7f1c$var$xA
        });
        s.uniforms.tEquirect.value = t;
        const a = new $d7238066c5de7f1c$var$SI(n, s), o = t.minFilter;
        return t.minFilter === $d7238066c5de7f1c$var$II && (t.minFilter = $d7238066c5de7f1c$var$ro), new $d7238066c5de7f1c$var$d3(1, 10, this).update(e, a), t.minFilter = o, a.geometry.dispose(), a.material.dispose(), this;
    }
    /**
   * Clears this cube render target.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */ clear(e, t = !0, i = !0, n = !0) {
        const s = e.getRenderTarget();
        for(let a = 0; a < 6; a++)e.setRenderTarget(this, a), e.clear(t, i, n);
        e.setRenderTarget(s);
    }
}
class $d7238066c5de7f1c$var$wv extends $d7238066c5de7f1c$var$lr {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}
const $d7238066c5de7f1c$var$q$ = {
    type: "move"
};
class $d7238066c5de7f1c$var$$$ {
    /**
   * Constructs a new XR controller.
   */ constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    /**
   * Returns a group representing the hand space of the XR controller.
   *
   * @return {Group} A group representing the hand space of the XR controller.
   */ getHandSpace() {
        return this._hand === null && (this._hand = new $d7238066c5de7f1c$var$wv(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    /**
   * Returns a group representing the target ray space of the XR controller.
   *
   * @return {Group} A group representing the target ray space of the XR controller.
   */ getTargetRaySpace() {
        return this._targetRay === null && (this._targetRay = new $d7238066c5de7f1c$var$wv(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new $d7238066c5de7f1c$var$Ce(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new $d7238066c5de7f1c$var$Ce()), this._targetRay;
    }
    /**
   * Returns a group representing the grip space of the XR controller.
   *
   * @return {Group} A group representing the grip space of the XR controller.
   */ getGripSpace() {
        return this._grip === null && (this._grip = new $d7238066c5de7f1c$var$wv(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new $d7238066c5de7f1c$var$Ce(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new $d7238066c5de7f1c$var$Ce()), this._grip;
    }
    /**
   * Dispatches the given event to the groups representing
   * the different coordinate spaces of the XR controller.
   *
   * @param {Object} event - The event to dispatch.
   * @return {WebXRController} A reference to this instance.
   */ dispatchEvent(e) {
        return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
    }
    /**
   * Connects the controller with the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */ connect(e) {
        if (e && e.hand) {
            const t = this._hand;
            if (t) for (const i of e.hand.values())this._getHandJoint(t, i);
        }
        return this.dispatchEvent({
            type: "connected",
            data: e
        }), this;
    }
    /**
   * Disconnects the controller from the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */ disconnect(e) {
        return this.dispatchEvent({
            type: "disconnected",
            data: e
        }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
    }
    /**
   * Updates the controller with the given input source, XR frame and reference space.
   * This updates the transformations of the groups that represent the different
   * coordinate systems of the controller.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @param {XRFrame} frame - The XR frame.
   * @param {XRReferenceSpace} referenceSpace - The reference space.
   * @return {WebXRController} A reference to this instance.
   */ update(e, t, i) {
        let n = null, s = null, a = null;
        const o = this._targetRay, g = this._grip, l = this._hand;
        if (e && t.session.visibilityState !== "visible-blurred") {
            if (l && e.hand) {
                a = !0;
                for (const G of e.hand.values()){
                    const Z = t.getJointPose(G, i), v = this._getHandJoint(l, G);
                    Z !== null && (v.matrix.fromArray(Z.transform.matrix), v.matrix.decompose(v.position, v.rotation, v.scale), v.matrixWorldNeedsUpdate = !0, v.jointRadius = Z.radius), v.visible = Z !== null;
                }
                const c = l.joints["index-finger-tip"], d = l.joints["thumb-tip"], p = c.position.distanceTo(d.position), A = 0.02, y = 5e-3;
                l.inputState.pinching && p > A + y ? (l.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: e.handedness,
                    target: this
                })) : !l.inputState.pinching && p <= A - y && (l.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: e.handedness,
                    target: this
                }));
            } else g !== null && e.gripSpace && (s = t.getPose(e.gripSpace, i), s !== null && (g.matrix.fromArray(s.transform.matrix), g.matrix.decompose(g.position, g.rotation, g.scale), g.matrixWorldNeedsUpdate = !0, s.linearVelocity ? (g.hasLinearVelocity = !0, g.linearVelocity.copy(s.linearVelocity)) : g.hasLinearVelocity = !1, s.angularVelocity ? (g.hasAngularVelocity = !0, g.angularVelocity.copy(s.angularVelocity)) : g.hasAngularVelocity = !1));
            o !== null && (n = t.getPose(e.targetRaySpace, i), n === null && s !== null && (n = s), n !== null && (o.matrix.fromArray(n.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, n.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(n.linearVelocity)) : o.hasLinearVelocity = !1, n.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(n.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent($d7238066c5de7f1c$var$q$)));
        }
        return o !== null && (o.visible = n !== null), g !== null && (g.visible = s !== null), l !== null && (l.visible = a !== null), this;
    }
    /**
   * Returns a group representing the hand joint for the given input joint.
   *
   * @private
   * @param {Group} hand - The group representing the hand space.
   * @param {XRJointSpace} inputjoint - The hand joint data.
   * @return {Group} A group representing the hand joint for the given input joint.
   */ _getHandJoint(e, t) {
        if (e.joints[t.jointName] === void 0) {
            const i = new $d7238066c5de7f1c$var$wv();
            i.matrixAutoUpdate = !1, i.visible = !1, e.joints[t.jointName] = i, e.add(i);
        }
        return e.joints[t.jointName];
    }
}
let $d7238066c5de7f1c$var$iL = class extends $d7238066c5de7f1c$var$lr {
    /**
   * Constructs a new scene.
   */ constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new $d7238066c5de7f1c$var$il(), this.environmentIntensity = 1, this.environmentRotation = new $d7238066c5de7f1c$var$il(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(e, t) {
        return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
    }
};
class $d7238066c5de7f1c$var$h3 {
    /**
   * Constructs a new interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   */ constructor(e, t){
        this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = $d7238066c5de7f1c$var$vZ, this.updateRanges = [], this.version = 0, this.uuid = $d7238066c5de7f1c$var$hI();
    }
    /**
   * A callback function that is executed after the renderer has transferred the attribute array
   * data to the GPU.
   */ onUploadCallback() {}
    /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        e === !0 && this.version++;
    }
    /**
   * Sets the usage of this interleaved buffer.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {InterleavedBuffer} A reference to this interleaved buffer.
   */ setUsage(e) {
        return this.usage = e, this;
    }
    /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */ addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    /**
   * Clears the update ranges.
   */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
   * Copies the values of the given interleaved buffer to this instance.
   *
   * @param {InterleavedBuffer} source - The interleaved buffer to copy.
   * @return {InterleavedBuffer} A reference to this instance.
   */ copy(e) {
        return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
    }
    /**
   * Copies a vector from the given interleaved buffer to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this interleaved buffer.
   * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
   * @param {number} index2 - The source index into the given interleaved buffer.
   * @return {InterleavedBuffer} A reference to this instance.
   */ copyAt(e, t, i) {
        e *= this.stride, i *= t.stride;
        for(let n = 0, s = this.stride; n < s; n++)this.array[e + n] = t.array[i + n];
        return this;
    }
    /**
   * Sets the given array data in the interleaved buffer.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this interleaved buffer's array.
   * @return {InterleavedBuffer} A reference to this instance.
   */ set(e, t = 0) {
        return this.array.set(e, t), this;
    }
    /**
   * Returns a new interleaved buffer with copied values from this instance.
   *
   * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
   * @return {InterleavedBuffer} A clone of this instance.
   */ clone(e) {
        e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = $d7238066c5de7f1c$var$hI()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), i = new this.constructor(t, this.stride);
        return i.setUsage(this.usage), i;
    }
    /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the array data to the GPU. Can be used to perform clean-up operations after
   * the upload when data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {InterleavedBuffer} A reference to this instance.
   */ onUpload(e) {
        return this.onUploadCallback = e, this;
    }
    /**
   * Serializes the interleaved buffer into JSON.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized interleaved buffer.
   */ toJSON(e) {
        return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = $d7238066c5de7f1c$var$hI()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d7238066c5de7f1c$var$Oa = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$nL {
    /**
   * Constructs a new interleaved buffer attribute.
   *
   * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
   * @param {number} itemSize - The item size.
   * @param {number} offset - The attribute offset into the buffer.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */ constructor(e, t, i, n = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = i, this.normalized = n;
    }
    /**
   * The item count of this buffer attribute.
   *
   * @type {number}
   * @readonly
   */ get count() {
        return this.data.count;
    }
    /**
   * The array holding the interleaved buffer attribute data.
   *
   * @type {TypedArray}
   */ get array() {
        return this.data.array;
    }
    /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        this.data.needsUpdate = e;
    }
    /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ applyMatrix4(e) {
        for(let t = 0, i = this.data.count; t < i; t++)$d7238066c5de7f1c$var$Oa.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$Oa.applyMatrix4(e), this.setXYZ(t, $d7238066c5de7f1c$var$Oa.x, $d7238066c5de7f1c$var$Oa.y, $d7238066c5de7f1c$var$Oa.z);
        return this;
    }
    /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ applyNormalMatrix(e) {
        for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$Oa.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$Oa.applyNormalMatrix(e), this.setXYZ(t, $d7238066c5de7f1c$var$Oa.x, $d7238066c5de7f1c$var$Oa.y, $d7238066c5de7f1c$var$Oa.z);
        return this;
    }
    /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ transformDirection(e) {
        for(let t = 0, i = this.count; t < i; t++)$d7238066c5de7f1c$var$Oa.fromBufferAttribute(this, t), $d7238066c5de7f1c$var$Oa.transformDirection(e), this.setXYZ(t, $d7238066c5de7f1c$var$Oa.x, $d7238066c5de7f1c$var$Oa.y, $d7238066c5de7f1c$var$Oa.z);
        return this;
    }
    /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */ getComponent(e, t) {
        let i = this.array[e * this.data.stride + this.offset + t];
        return this.normalized && (i = $d7238066c5de7f1c$var$to(i, this.array)), i;
    }
    /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setComponent(e, t, i) {
        return this.normalized && (i = $d7238066c5de7f1c$var$gi(i, this.array)), this.data.array[e * this.data.stride + this.offset + t] = i, this;
    }
    /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setX(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
    }
    /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setY(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
    }
    /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setZ(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
    }
    /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setW(e, t) {
        return this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
    }
    /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */ getX(e) {
        let t = this.data.array[e * this.data.stride + this.offset];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */ getY(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 1];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */ getZ(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 2];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */ getW(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 3];
        return this.normalized && (t = $d7238066c5de7f1c$var$to(t, this.array)), t;
    }
    /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setXY(e, t, i) {
        return e = e * this.data.stride + this.offset, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = i, this;
    }
    /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setXYZ(e, t, i, n) {
        return e = e * this.data.stride + this.offset, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array), n = $d7238066c5de7f1c$var$gi(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = i, this.data.array[e + 2] = n, this;
    }
    /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */ setXYZW(e, t, i, n, s) {
        return e = e * this.data.stride + this.offset, this.normalized && (t = $d7238066c5de7f1c$var$gi(t, this.array), i = $d7238066c5de7f1c$var$gi(i, this.array), n = $d7238066c5de7f1c$var$gi(n, this.array), s = $d7238066c5de7f1c$var$gi(s, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = i, this.data.array[e + 2] = n, this.data.array[e + 3] = s, this;
    }
    /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
   * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
   */ clone(e) {
        if (e === void 0) {
            $d7238066c5de7f1c$var$S2("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const t = [];
            for(let i = 0; i < this.count; i++){
                const n = i * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)t.push(this.data.array[n + s]);
            }
            return new $d7238066c5de7f1c$var$gg(new this.array.constructor(t), this.itemSize, this.normalized);
        } else return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new $d7238066c5de7f1c$var$nL(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    /**
   * Serializes the buffer attribute into JSON.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */ toJSON(e) {
        if (e === void 0) {
            $d7238066c5de7f1c$var$S2("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const t = [];
            for(let i = 0; i < this.count; i++){
                const n = i * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)t.push(this.data.array[n + s]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: t,
                normalized: this.normalized
            };
        } else return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
}
class $d7238066c5de7f1c$var$eee extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new sprite material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.rotation = e.rotation, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$C3 extends $d7238066c5de7f1c$var$Ca {
    /**
   * Constructs a new data texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */ constructor(e = null, t = 1, i = 1, n, s, a, o, g, l = $d7238066c5de7f1c$var$Sr, c = $d7238066c5de7f1c$var$Sr, d, p){
        super(null, a, o, g, l, c, n, s, d, p), this.isDataTexture = !0, this.image = {
            data: e,
            width: t,
            height: i
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
class $d7238066c5de7f1c$var$SA extends $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new instanced buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
   */ constructor(e, t, i, n = 1){
        super(e, t, i), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = n;
    }
    copy(e) {
        return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
    }
}
const $d7238066c5de7f1c$var$aH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$tee = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$iee = /* @__PURE__ */ new $d7238066c5de7f1c$var$Lo();
class $d7238066c5de7f1c$var$Ed {
    /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */ constructor(e = new $d7238066c5de7f1c$var$Ce(1, 0, 0), t = 0){
        this.isPlane = !0, this.normal = e, this.constant = t;
    }
    /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */ set(e, t) {
        return this.normal.copy(e), this.constant = t, this;
    }
    /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */ setComponents(e, t, i, n) {
        return this.normal.set(e, t, i), this.constant = n, this;
    }
    /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */ setFromNormalAndCoplanarPoint(e, t) {
        return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
    }
    /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */ setFromCoplanarPoints(e, t, i) {
        const n = $d7238066c5de7f1c$var$aH.subVectors(i, t).cross($d7238066c5de7f1c$var$tee.subVectors(e, t)).normalize();
        return this.setFromNormalAndCoplanarPoint(n, e), this;
    }
    /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */ copy(e) {
        return this.normal.copy(e.normal), this.constant = e.constant, this;
    }
    /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */ normalize() {
        const e = 1 / this.normal.length();
        return this.normal.multiplyScalar(e), this.constant *= e, this;
    }
    /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */ negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */ distanceToPoint(e) {
        return this.normal.dot(e) + this.constant;
    }
    /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */ distanceToSphere(e) {
        return this.distanceToPoint(e.center) - e.radius;
    }
    /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */ projectPoint(e, t) {
        return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
    }
    /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */ intersectLine(e, t) {
        const i = e.delta($d7238066c5de7f1c$var$aH), n = this.normal.dot(i);
        if (n === 0) return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
        const s = -(e.start.dot(this.normal) + this.constant) / n;
        return s < 0 || s > 1 ? null : t.copy(e.start).addScaledVector(i, s);
    }
    /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */ intersectsLine(e) {
        const t = this.distanceToPoint(e.start), i = this.distanceToPoint(e.end);
        return t < 0 && i > 0 || i < 0 && t > 0;
    }
    /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */ intersectsBox(e) {
        return e.intersectsPlane(this);
    }
    /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */ intersectsSphere(e) {
        return e.intersectsPlane(this);
    }
    /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */ coplanarPoint(e) {
        return e.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */ applyMatrix4(e, t) {
        const i = t || $d7238066c5de7f1c$var$iee.getNormalMatrix(e), n = this.coplanarPoint($d7238066c5de7f1c$var$aH).applyMatrix4(e), s = this.normal.applyMatrix3(i).normalize();
        return this.constant = -n.dot(s), this;
    }
    /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */ translate(e) {
        return this.constant -= e.dot(this.normal), this;
    }
    /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */ equals(e) {
        return e.normal.equals(this.normal) && e.constant === this.constant;
    }
    /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
}
const $d7238066c5de7f1c$var$aC = /* @__PURE__ */ new $d7238066c5de7f1c$var$lR(), $d7238066c5de7f1c$var$nee = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii(0.5, 0.5), $d7238066c5de7f1c$var$Wv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$sL {
    /**
   * Constructs a new frustum.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   */ constructor(e = new $d7238066c5de7f1c$var$Ed(), t = new $d7238066c5de7f1c$var$Ed(), i = new $d7238066c5de7f1c$var$Ed(), n = new $d7238066c5de7f1c$var$Ed(), s = new $d7238066c5de7f1c$var$Ed(), a = new $d7238066c5de7f1c$var$Ed()){
        this.planes = [
            e,
            t,
            i,
            n,
            s,
            a
        ];
    }
    /**
   * Sets the frustum planes by copying the given planes.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   * @return {Frustum} A reference to this frustum.
   */ set(e, t, i, n, s, a) {
        const o = this.planes;
        return o[0].copy(e), o[1].copy(t), o[2].copy(i), o[3].copy(n), o[4].copy(s), o[5].copy(a), this;
    }
    /**
   * Copies the values of the given frustum to this instance.
   *
   * @param {Frustum} frustum - The frustum to copy.
   * @return {Frustum} A reference to this frustum.
   */ copy(e) {
        const t = this.planes;
        for(let i = 0; i < 6; i++)t[i].copy(e.planes[i]);
        return this;
    }
    /**
   * Sets the frustum planes from the given projection matrix.
   *
   * @param {Matrix4} m - The projection matrix.
   * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
   * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
   * @return {Frustum} A reference to this frustum.
   */ setFromProjectionMatrix(e, t = $d7238066c5de7f1c$var$rg, i = !1) {
        const n = this.planes, s = e.elements, a = s[0], o = s[1], g = s[2], l = s[3], c = s[4], d = s[5], p = s[6], A = s[7], y = s[8], G = s[9], Z = s[10], v = s[11], V = s[12], H = s[13], N = s[14], Y = s[15];
        if (n[0].setComponents(l - a, A - c, v - y, Y - V).normalize(), n[1].setComponents(l + a, A + c, v + y, Y + V).normalize(), n[2].setComponents(l + o, A + d, v + G, Y + H).normalize(), n[3].setComponents(l - o, A - d, v - G, Y - H).normalize(), i) n[4].setComponents(g, p, Z, N).normalize(), n[5].setComponents(l - g, A - p, v - Z, Y - N).normalize();
        else if (n[4].setComponents(l - g, A - p, v - Z, Y - N).normalize(), t === $d7238066c5de7f1c$var$rg) n[5].setComponents(l + g, A + p, v + Z, Y + N).normalize();
        else if (t === $d7238066c5de7f1c$var$uu) n[5].setComponents(g, p, Z, N).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
        return this;
    }
    /**
   * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
   *
   * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
   */ intersectsObject(e) {
        if (e.boundingSphere !== void 0) e.boundingSphere === null && e.computeBoundingSphere(), $d7238066c5de7f1c$var$aC.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
        else {
            const t = e.geometry;
            t.boundingSphere === null && t.computeBoundingSphere(), $d7238066c5de7f1c$var$aC.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
        }
        return this.intersectsSphere($d7238066c5de7f1c$var$aC);
    }
    /**
   * Returns `true` if the given sprite is intersecting this frustum.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @return {boolean} Whether the sprite is intersecting this frustum or not.
   */ intersectsSprite(e) {
        $d7238066c5de7f1c$var$aC.center.set(0, 0, 0);
        const t = $d7238066c5de7f1c$var$nee.distanceTo(e.center);
        return $d7238066c5de7f1c$var$aC.radius = 0.7071067811865476 + t, $d7238066c5de7f1c$var$aC.applyMatrix4(e.matrixWorld), this.intersectsSphere($d7238066c5de7f1c$var$aC);
    }
    /**
   * Returns `true` if the given bounding sphere is intersecting this frustum.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
   */ intersectsSphere(e) {
        const t = this.planes, i = e.center, n = -e.radius;
        for(let s = 0; s < 6; s++)if (t[s].distanceToPoint(i) < n) return !1;
        return !0;
    }
    /**
   * Returns `true` if the given bounding box is intersecting this frustum.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box is intersecting this frustum or not.
   */ intersectsBox(e) {
        const t = this.planes;
        for(let i = 0; i < 6; i++){
            const n = t[i];
            if ($d7238066c5de7f1c$var$Wv.x = n.normal.x > 0 ? e.max.x : e.min.x, $d7238066c5de7f1c$var$Wv.y = n.normal.y > 0 ? e.max.y : e.min.y, $d7238066c5de7f1c$var$Wv.z = n.normal.z > 0 ? e.max.z : e.min.z, n.distanceToPoint($d7238066c5de7f1c$var$Wv) < 0) return !1;
        }
        return !0;
    }
    /**
   * Returns `true` if the given point lies within the frustum.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the point lies within this frustum or not.
   */ containsPoint(e) {
        const t = this.planes;
        for(let i = 0; i < 6; i++)if (t[i].distanceToPoint(e) < 0) return !1;
        return !0;
    }
    /**
   * Returns a new frustum with copied values from this instance.
   *
   * @return {Frustum} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
}
const $d7238066c5de7f1c$var$Xc = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Nc = /* @__PURE__ */ new $d7238066c5de7f1c$var$sL();
class $d7238066c5de7f1c$var$rL {
    /**
   * Constructs a new frustum array.
   *
   */ constructor(){
        this.coordinateSystem = $d7238066c5de7f1c$var$rg;
    }
    /**
   * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
   * from the camera array.
   *
   * @param {Object3D} object - The 3D object to test.
   * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
   * @return {boolean} Whether the 3D object is visible in any camera.
   */ intersectsObject(e, t) {
        if (!t.isArrayCamera || t.cameras.length === 0) return !1;
        for(let i = 0; i < t.cameras.length; i++){
            const n = t.cameras[i];
            if ($d7238066c5de7f1c$var$Xc.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), $d7238066c5de7f1c$var$Nc.setFromProjectionMatrix($d7238066c5de7f1c$var$Xc, n.coordinateSystem, n.reversedDepth), $d7238066c5de7f1c$var$Nc.intersectsObject(e)) return !0;
        }
        return !1;
    }
    /**
   * Returns `true` if the given sprite is intersecting any frustum
   * from the camera array.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
   * @return {boolean} Whether the sprite is visible in any camera.
   */ intersectsSprite(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let i = 0; i < t.cameras.length; i++){
            const n = t.cameras[i];
            if ($d7238066c5de7f1c$var$Xc.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), $d7238066c5de7f1c$var$Nc.setFromProjectionMatrix($d7238066c5de7f1c$var$Xc, n.coordinateSystem, n.reversedDepth), $d7238066c5de7f1c$var$Nc.intersectsSprite(e)) return !0;
        }
        return !1;
    }
    /**
   * Returns `true` if the given bounding sphere is intersecting any frustum
   * from the camera array.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
   * @return {boolean} Whether the sphere is visible in any camera.
   */ intersectsSphere(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let i = 0; i < t.cameras.length; i++){
            const n = t.cameras[i];
            if ($d7238066c5de7f1c$var$Xc.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), $d7238066c5de7f1c$var$Nc.setFromProjectionMatrix($d7238066c5de7f1c$var$Xc, n.coordinateSystem, n.reversedDepth), $d7238066c5de7f1c$var$Nc.intersectsSphere(e)) return !0;
        }
        return !1;
    }
    /**
   * Returns `true` if the given bounding box is intersecting any frustum
   * from the camera array.
   *
   * @param {Box3} box - The bounding box to test.
   * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
   * @return {boolean} Whether the box is visible in any camera.
   */ intersectsBox(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let i = 0; i < t.cameras.length; i++){
            const n = t.cameras[i];
            if ($d7238066c5de7f1c$var$Xc.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), $d7238066c5de7f1c$var$Nc.setFromProjectionMatrix($d7238066c5de7f1c$var$Xc, n.coordinateSystem, n.reversedDepth), $d7238066c5de7f1c$var$Nc.intersectsBox(e)) return !0;
        }
        return !1;
    }
    /**
   * Returns `true` if the given point lies within any frustum
   * from the camera array.
   *
   * @param {Vector3} point - The point to test.
   * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
   * @return {boolean} Whether the point is visible in any camera.
   */ containsPoint(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let i = 0; i < t.cameras.length; i++){
            const n = t.cameras[i];
            if ($d7238066c5de7f1c$var$Xc.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), $d7238066c5de7f1c$var$Nc.setFromProjectionMatrix($d7238066c5de7f1c$var$Xc, n.coordinateSystem, n.reversedDepth), $d7238066c5de7f1c$var$Nc.containsPoint(e)) return !0;
        }
        return !1;
    }
    /**
   * Returns a new frustum array with copied values from this instance.
   *
   * @return {FrustumArray} A clone of this instance.
   */ clone() {
        return new $d7238066c5de7f1c$var$rL();
    }
}
class $d7238066c5de7f1c$var$p3 extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new line basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$see extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new points material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$aL extends $d7238066c5de7f1c$var$Ca {
    /**
   * Constructs a new framebuffer texture.
   *
   * @param {number} [width] - The width of the texture.
   * @param {number} [height] - The height of the texture.
   */ constructor(e, t){
        super({
            width: e,
            height: t
        }), this.isFramebufferTexture = !0, this.magFilter = $d7238066c5de7f1c$var$Sr, this.minFilter = $d7238066c5de7f1c$var$Sr, this.generateMipmaps = !1, this.needsUpdate = !0;
    }
}
class $d7238066c5de7f1c$var$$l extends $d7238066c5de7f1c$var$Ca {
    /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   * @param {number} [depth=1] - The depth of the texture.
   */ constructor(e, t, i = $d7238066c5de7f1c$var$Xs, n, s, a, o = $d7238066c5de7f1c$var$Sr, g = $d7238066c5de7f1c$var$Sr, l, c = $d7238066c5de7f1c$var$nu, d = 1){
        if (c !== $d7238066c5de7f1c$var$nu && c !== $d7238066c5de7f1c$var$dI) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        const p = {
            width: e,
            height: t,
            depth: d
        };
        super(p, n, s, a, o, g, c, i, l), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
    }
    copy(e) {
        return super.copy(e), this.source = new $d7238066c5de7f1c$var$eL(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
    }
}
class $d7238066c5de7f1c$var$oL extends $d7238066c5de7f1c$var$Cu {
    /**
   * Constructs a new cylinder geometry.
   *
   * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
   * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
   * @param {number} [height=1] - Height of the cylinder.
   * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
   * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
   * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
   * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
   * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
   * The default value results in a complete cylinder.
   */ constructor(e = 1, t = 1, i = 1, n = 32, s = 1, a = !1, o = 0, g = Math.PI * 2){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: e,
            radiusBottom: t,
            height: i,
            radialSegments: n,
            heightSegments: s,
            openEnded: a,
            thetaStart: o,
            thetaLength: g
        };
        const l = this;
        n = Math.floor(n), s = Math.floor(s);
        const c = [], d = [], p = [], A = [];
        let y = 0;
        const G = [], Z = i / 2;
        let v = 0;
        V(), a === !1 && (e > 0 && H(!0), t > 0 && H(!1)), this.setIndex(c), this.setAttribute("position", new $d7238066c5de7f1c$var$so(d, 3)), this.setAttribute("normal", new $d7238066c5de7f1c$var$so(p, 3)), this.setAttribute("uv", new $d7238066c5de7f1c$var$so(A, 2));
        function V() {
            const N = new $d7238066c5de7f1c$var$Ce(), Y = new $d7238066c5de7f1c$var$Ce();
            let K = 0;
            const z = (t - e) / i;
            for(let M = 0; M <= s; M++){
                const _ = [], O = M / s, ie = O * (t - e) + e;
                for(let he = 0; he <= n; he++){
                    const pe = he / n, ce = pe * g + o, $ = Math.sin(ce), te = Math.cos(ce);
                    Y.x = ie * $, Y.y = -O * i + Z, Y.z = ie * te, d.push(Y.x, Y.y, Y.z), N.set($, z, te).normalize(), p.push(N.x, N.y, N.z), A.push(pe, 1 - O), _.push(y++);
                }
                G.push(_);
            }
            for(let M = 0; M < n; M++)for(let _ = 0; _ < s; _++){
                const O = G[_][M], ie = G[_ + 1][M], he = G[_ + 1][M + 1], pe = G[_][M + 1];
                (e > 0 || _ !== 0) && (c.push(O, ie, pe), K += 3), (t > 0 || _ !== s - 1) && (c.push(ie, he, pe), K += 3);
            }
            l.addGroup(v, K, 0), v += K;
        }
        function H(N) {
            const Y = y, K = new $d7238066c5de7f1c$var$Ii(), z = new $d7238066c5de7f1c$var$Ce();
            let M = 0;
            const _ = N === !0 ? e : t, O = N === !0 ? 1 : -1;
            for(let he = 1; he <= n; he++)d.push(0, Z * O, 0), p.push(0, O, 0), A.push(0.5, 0.5), y++;
            const ie = y;
            for(let he = 0; he <= n; he++){
                const ce = he / n * g + o, $ = Math.cos(ce), te = Math.sin(ce);
                z.x = _ * te, z.y = Z * O, z.z = _ * $, d.push(z.x, z.y, z.z), p.push(0, O, 0), K.x = $ * 0.5 + 0.5, K.y = te * 0.5 * O + 0.5, A.push(K.x, K.y), y++;
            }
            for(let he = 0; he < n; he++){
                const pe = Y + he, ce = ie + he;
                N === !0 ? c.push(ce, ce + 1, pe) : c.push(ce + 1, ce, pe), M += 3;
            }
            l.addGroup(v, M, N === !0 ? 1 : 2), v += M;
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {CylinderGeometry} A new instance.
   */ static fromJSON(e) {
        return new $d7238066c5de7f1c$var$oL(e.radiusTop, e.radiusBottom, e.height, e.radialSegments, e.heightSegments, e.openEnded, e.thetaStart, e.thetaLength);
    }
}
class $d7238066c5de7f1c$var$gL extends $d7238066c5de7f1c$var$Cu {
    /**
   * Constructs a new plane geometry.
   *
   * @param {number} [width=1] - The width along the X axis.
   * @param {number} [height=1] - The height along the Y axis
   * @param {number} [widthSegments=1] - The number of segments along the X axis.
   * @param {number} [heightSegments=1] - The number of segments along the Y axis.
   */ constructor(e = 1, t = 1, i = 1, n = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: e,
            height: t,
            widthSegments: i,
            heightSegments: n
        };
        const s = e / 2, a = t / 2, o = Math.floor(i), g = Math.floor(n), l = o + 1, c = g + 1, d = e / o, p = t / g, A = [], y = [], G = [], Z = [];
        for(let v = 0; v < c; v++){
            const V = v * p - a;
            for(let H = 0; H < l; H++){
                const N = H * d - s;
                y.push(N, -V, 0), G.push(0, 0, 1), Z.push(H / o), Z.push(1 - v / g);
            }
        }
        for(let v = 0; v < g; v++)for(let V = 0; V < o; V++){
            const H = V + l * v, N = V + l * (v + 1), Y = V + 1 + l * (v + 1), K = V + 1 + l * v;
            A.push(H, N, K), A.push(N, Y, K);
        }
        this.setIndex(A), this.setAttribute("position", new $d7238066c5de7f1c$var$so(y, 3)), this.setAttribute("normal", new $d7238066c5de7f1c$var$so(G, 3)), this.setAttribute("uv", new $d7238066c5de7f1c$var$so(Z, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PlaneGeometry} A new instance.
   */ static fromJSON(e) {
        return new $d7238066c5de7f1c$var$gL(e.width, e.height, e.widthSegments, e.heightSegments);
    }
}
class $d7238066c5de7f1c$var$lL extends $d7238066c5de7f1c$var$Cu {
    /**
   * Constructs a new sphere geometry.
   *
   * @param {number} [radius=1] - The sphere radius.
   * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
   * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
   * @param {number} [phiStart=0] - The horizontal starting angle in radians.
   * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
   * @param {number} [thetaStart=0] - The vertical starting angle in radians.
   * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
   */ constructor(e = 1, t = 32, i = 16, n = 0, s = Math.PI * 2, a = 0, o = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: e,
            widthSegments: t,
            heightSegments: i,
            phiStart: n,
            phiLength: s,
            thetaStart: a,
            thetaLength: o
        }, t = Math.max(3, Math.floor(t)), i = Math.max(2, Math.floor(i));
        const g = Math.min(a + o, Math.PI);
        let l = 0;
        const c = [], d = new $d7238066c5de7f1c$var$Ce(), p = new $d7238066c5de7f1c$var$Ce(), A = [], y = [], G = [], Z = [];
        for(let v = 0; v <= i; v++){
            const V = [], H = v / i;
            let N = 0;
            v === 0 && a === 0 ? N = 0.5 / t : v === i && g === Math.PI && (N = -0.5 / t);
            for(let Y = 0; Y <= t; Y++){
                const K = Y / t;
                d.x = -e * Math.cos(n + K * s) * Math.sin(a + H * o), d.y = e * Math.cos(a + H * o), d.z = e * Math.sin(n + K * s) * Math.sin(a + H * o), y.push(d.x, d.y, d.z), p.copy(d).normalize(), G.push(p.x, p.y, p.z), Z.push(K + N, 1 - H), V.push(l++);
            }
            c.push(V);
        }
        for(let v = 0; v < i; v++)for(let V = 0; V < t; V++){
            const H = c[v][V + 1], N = c[v][V], Y = c[v + 1][V], K = c[v + 1][V + 1];
            (v !== 0 || a > 0) && A.push(H, N, K), (v !== i - 1 || g < Math.PI) && A.push(N, Y, K);
        }
        this.setIndex(A), this.setAttribute("position", new $d7238066c5de7f1c$var$so(y, 3)), this.setAttribute("normal", new $d7238066c5de7f1c$var$so(G, 3)), this.setAttribute("uv", new $d7238066c5de7f1c$var$so(Z, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {SphereGeometry} A new instance.
   */ static fromJSON(e) {
        return new $d7238066c5de7f1c$var$lL(e.radius, e.widthSegments, e.heightSegments, e.phiStart, e.phiLength, e.thetaStart, e.thetaLength);
    }
}
class $d7238066c5de7f1c$var$ree extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new shadow material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new $d7238066c5de7f1c$var$rn(0), this.transparent = !0, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$m3 extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh standard material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = {
            STANDARD: ""
        }, this.color = new $d7238066c5de7f1c$var$rn(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $d7238066c5de7f1c$var$rn(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $d7238066c5de7f1c$var$oh, this.normalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $d7238066c5de7f1c$var$il(), this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.defines = {
            STANDARD: ""
        }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$aee extends $d7238066c5de7f1c$var$m3 {
    /**
   * Constructs a new mesh physical material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshPhysicalMaterial = !0, this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $d7238066c5de7f1c$var$Ni(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(t) {
                this.ior = (1 + 0.4 * t) / (1 - 0.4 * t);
            }
        }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
            100,
            400
        ], this.iridescenceThicknessMap = null, this.sheenColor = new $d7238066c5de7f1c$var$rn(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new $d7238066c5de7f1c$var$rn(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new $d7238066c5de7f1c$var$rn(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._dispersion = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e);
    }
    /**
   * The anisotropy strength, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(e) {
        this._anisotropy > 0 != e > 0 && this.version++, this._anisotropy = e;
    }
    /**
   * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
   * clear coat related properties to enable multilayer materials that have a
   * thin translucent layer over the base layer.
   *
   * @type {number}
   * @default 0
   */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(e) {
        this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
    }
    /**
   * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
   * the surface and the viewer, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(e) {
        this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
    }
    /**
   * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
   * through a relatively clear volume. Any value zero or larger is valid, the typical range of
   * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
   *
   * @type {number}
   * @default 0
   */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(e) {
        this._dispersion > 0 != e > 0 && this.version++, this._dispersion = e;
    }
    /**
   * The intensity of the sheen layer, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */ get sheen() {
        return this._sheen;
    }
    set sheen(e) {
        this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
    }
    /**
   * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
   *
   * Thin, transparent or semitransparent, plastic or glass materials remain
   * largely reflective even if they are fully transmissive. The transmission
   * property can be used to model these materials.
   *
   * When transmission is non-zero, `opacity` should be  set to `1`.
   *
   * @type {number}
   * @default 0
   */ get transmission() {
        return this._transmission;
    }
    set transmission(e) {
        this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
    }
    copy(e) {
        return super.copy(e), this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.anisotropy = e.anisotropy, this.anisotropyRotation = e.anisotropyRotation, this.anisotropyMap = e.anisotropyMap, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.dispersion = e.dispersion, this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [
            ...e.iridescenceThicknessRange
        ], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
    }
}
class $d7238066c5de7f1c$var$oee extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh phong material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.specular = new $d7238066c5de7f1c$var$rn(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $d7238066c5de7f1c$var$rn(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $d7238066c5de7f1c$var$oh, this.normalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $d7238066c5de7f1c$var$il(), this.combine = $d7238066c5de7f1c$var$nR, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$gee extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh toon material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshToonMaterial = !0, this.defines = {
            TOON: ""
        }, this.type = "MeshToonMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $d7238066c5de7f1c$var$rn(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $d7238066c5de7f1c$var$oh, this.normalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.gradientMap = e.gradientMap, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.alphaMap = e.alphaMap, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$lee extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh normal material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $d7238066c5de7f1c$var$oh, this.normalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.flatShading = e.flatShading, this;
    }
}
class $d7238066c5de7f1c$var$cee extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh lambert material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $d7238066c5de7f1c$var$rn(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $d7238066c5de7f1c$var$oh, this.normalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $d7238066c5de7f1c$var$il(), this.combine = $d7238066c5de7f1c$var$nR, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$uee extends $d7238066c5de7f1c$var$Ho {
    /**
   * Constructs a new mesh matcap material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isMeshMatcapMaterial = !0, this.defines = {
            MATCAP: ""
        }, this.type = "MeshMatcapMaterial", this.color = new $d7238066c5de7f1c$var$rn(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $d7238066c5de7f1c$var$oh, this.normalScale = new $d7238066c5de7f1c$var$Ii(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.defines = {
            MATCAP: ""
        }, this.color.copy(e.color), this.matcap = e.matcap, this.map = e.map, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.alphaMap = e.alphaMap, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $d7238066c5de7f1c$var$Iee extends $d7238066c5de7f1c$var$p3 {
    /**
   * Constructs a new line dashed material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */ constructor(e){
        super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.scale = e.scale, this.dashSize = e.dashSize, this.gapSize = e.gapSize, this;
    }
}
const $d7238066c5de7f1c$var$oH = {
    /**
   * Whether caching is enabled or not.
   *
   * @static
   * @type {boolean}
   * @default false
   */ enabled: !1,
    /**
   * A dictionary that holds cached files.
   *
   * @static
   * @type {Object<string,Object>}
   */ files: {},
    /**
   * Adds a cache entry with a key to reference the file. If this key already
   * holds a file, it is overwritten.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @param {Object} file -  The file to be cached.
   */ add: function(r, e) {
        this.enabled !== !1 && (this.files[r] = e);
    },
    /**
   * Gets the cached value for the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
   */ get: function(r) {
        if (this.enabled !== !1) return this.files[r];
    },
    /**
   * Removes the cached file associated with the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   */ remove: function(r) {
        delete this.files[r];
    },
    /**
   * Remove all values from the cache.
   *
   * @static
   */ clear: function() {
        this.files = {};
    }
};
class $d7238066c5de7f1c$var$dee {
    /**
   * Constructs a new loading manager.
   *
   * @param {Function} [onLoad] - Executes when all items have been loaded.
   * @param {Function} [onProgress] - Executes when single items have been loaded.
   * @param {Function} [onError] - Executes when an error occurs.
   */ constructor(e, t, i){
        const n = this;
        let s = !1, a = 0, o = 0, g;
        const l = [];
        this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = i, this._abortController = null, this.itemStart = function(c) {
            o++, s === !1 && n.onStart !== void 0 && n.onStart(c, a, o), s = !0;
        }, this.itemEnd = function(c) {
            a++, n.onProgress !== void 0 && n.onProgress(c, a, o), a === o && (s = !1, n.onLoad !== void 0 && n.onLoad());
        }, this.itemError = function(c) {
            n.onError !== void 0 && n.onError(c);
        }, this.resolveURL = function(c) {
            return g ? g(c) : c;
        }, this.setURLModifier = function(c) {
            return g = c, this;
        }, this.addHandler = function(c, d) {
            return l.push(c, d), this;
        }, this.removeHandler = function(c) {
            const d = l.indexOf(c);
            return d !== -1 && l.splice(d, 2), this;
        }, this.getHandler = function(c) {
            for(let d = 0, p = l.length; d < p; d += 2){
                const A = l[d], y = l[d + 1];
                if (A.global && (A.lastIndex = 0), A.test(c)) return y;
            }
            return null;
        }, this.abort = function() {
            return this.abortController.abort(), this._abortController = null, this;
        };
    }
    // TODO: Revert this back to a single member variable once this issue has been fixed
    // https://github.com/cloudflare/workerd/issues/3657
    /**
   * Used for aborting ongoing requests in loaders using this manager.
   *
   * @type {AbortController}
   */ get abortController() {
        return this._abortController || (this._abortController = new AbortController()), this._abortController;
    }
}
const $d7238066c5de7f1c$var$hee = /* @__PURE__ */ new $d7238066c5de7f1c$var$dee();
class $d7238066c5de7f1c$var$cL {
    /**
   * Constructs a new loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(e){
        this.manager = e !== void 0 ? e : $d7238066c5de7f1c$var$hee, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for loading assets from the backend.
   *
   * @abstract
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {Function} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   */ load() {}
    /**
   * A async version of {@link Loader#load}.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @return {Promise} A Promise that resolves when the asset has been loaded.
   */ loadAsync(e, t) {
        const i = this;
        return new Promise(function(n, s) {
            i.load(e, n, t, s);
        });
    }
    /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for parsing the asset into three.js entities.
   *
   * @abstract
   * @param {any} data - The data to parse.
   */ parse() {}
    /**
   * Sets the `crossOrigin` String to implement CORS for loading the URL
   * from a different domain that allows CORS.
   *
   * @param {string} crossOrigin - The `crossOrigin` value.
   * @return {Loader} A reference to this instance.
   */ setCrossOrigin(e) {
        return this.crossOrigin = e, this;
    }
    /**
   * Whether the XMLHttpRequest uses credentials such as cookies, authorization
   * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
   *
   * Note: This setting has no effect if you are loading files locally or from the same domain.
   *
   * @param {boolean} value - The `withCredentials` value.
   * @return {Loader} A reference to this instance.
   */ setWithCredentials(e) {
        return this.withCredentials = e, this;
    }
    /**
   * Sets the base path for the asset.
   *
   * @param {string} path - The base path.
   * @return {Loader} A reference to this instance.
   */ setPath(e) {
        return this.path = e, this;
    }
    /**
   * Sets the base path for dependent resources like textures.
   *
   * @param {string} resourcePath - The resource path.
   * @return {Loader} A reference to this instance.
   */ setResourcePath(e) {
        return this.resourcePath = e, this;
    }
    /**
   * Sets the given request header.
   *
   * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
   * for configuring the HTTP request.
   * @return {Loader} A reference to this instance.
   */ setRequestHeader(e) {
        return this.requestHeader = e, this;
    }
    /**
   * This method can be implemented in loaders for aborting ongoing requests.
   *
   * @abstract
   * @return {Loader} A reference to this instance.
   */ abort() {
        return this;
    }
}
$d7238066c5de7f1c$var$cL.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $d7238066c5de7f1c$var$Km = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$Cee extends $d7238066c5de7f1c$var$cL {
    /**
   * Constructs a new image loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(e){
        super(e);
    }
    /**
   * Starts loading from the given URL and passes the loaded image
   * to the `onLoad()` callback. The method also returns a new `Image` object which can
   * directly be used for texture creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Image)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Image} The image.
   */ load(e, t, i, n) {
        this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
        const s = this, a = $d7238066c5de7f1c$var$oH.get(`image:${e}`);
        if (a !== void 0) {
            if (a.complete === !0) s.manager.itemStart(e), setTimeout(function() {
                t && t(a), s.manager.itemEnd(e);
            }, 0);
            else {
                let d = $d7238066c5de7f1c$var$Km.get(a);
                d === void 0 && (d = [], $d7238066c5de7f1c$var$Km.set(a, d)), d.push({
                    onLoad: t,
                    onError: n
                });
            }
            return a;
        }
        const o = $d7238066c5de7f1c$var$SZ("img");
        function g() {
            c(), t && t(this);
            const d = $d7238066c5de7f1c$var$Km.get(this) || [];
            for(let p = 0; p < d.length; p++){
                const A = d[p];
                A.onLoad && A.onLoad(this);
            }
            $d7238066c5de7f1c$var$Km.delete(this), s.manager.itemEnd(e);
        }
        function l(d) {
            c(), n && n(d), $d7238066c5de7f1c$var$oH.remove(`image:${e}`);
            const p = $d7238066c5de7f1c$var$Km.get(this) || [];
            for(let A = 0; A < p.length; A++){
                const y = p[A];
                y.onError && y.onError(d);
            }
            $d7238066c5de7f1c$var$Km.delete(this), s.manager.itemError(e), s.manager.itemEnd(e);
        }
        function c() {
            o.removeEventListener("load", g, !1), o.removeEventListener("error", l, !1);
        }
        return o.addEventListener("load", g, !1), o.addEventListener("error", l, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (o.crossOrigin = this.crossOrigin), $d7238066c5de7f1c$var$oH.add(`image:${e}`, o), s.manager.itemStart(e), o.src = e, o;
    }
}
class $d7238066c5de7f1c$var$pee extends $d7238066c5de7f1c$var$cL {
    /**
   * Constructs a new texture loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(e){
        super(e);
    }
    /**
   * Starts loading from the given URL and pass the fully loaded texture
   * to the `onLoad()` callback. The method also returns a new texture object which can
   * directly be used for material creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Texture} The texture.
   */ load(e, t, i, n) {
        const s = new $d7238066c5de7f1c$var$Ca(), a = new $d7238066c5de7f1c$var$Cee(this.manager);
        return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e, function(o) {
            s.image = o, s.needsUpdate = !0, t !== void 0 && t(s);
        }, i, n), s;
    }
}
class $d7238066c5de7f1c$var$QC extends $d7238066c5de7f1c$var$lr {
    /**
   * Constructs a new light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */ constructor(e, t = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new $d7238066c5de7f1c$var$rn(e), this.intensity = t;
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */ dispose() {}
    copy(e, t) {
        return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, this.groundColor !== void 0 && (t.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (t.object.distance = this.distance), this.angle !== void 0 && (t.object.angle = this.angle), this.decay !== void 0 && (t.object.decay = this.decay), this.penumbra !== void 0 && (t.object.penumbra = this.penumbra), this.shadow !== void 0 && (t.object.shadow = this.shadow.toJSON()), this.target !== void 0 && (t.object.target = this.target.uuid), t;
    }
}
class $d7238066c5de7f1c$var$mee extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new hemisphere light.
   *
   * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
   * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */ constructor(e, t, i){
        super(e, i), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy($d7238066c5de7f1c$var$lr.DEFAULT_UP), this.updateMatrix(), this.groundColor = new $d7238066c5de7f1c$var$rn(t);
    }
    copy(e, t) {
        return super.copy(e, t), this.groundColor.copy(e.groundColor), this;
    }
}
const $d7238066c5de7f1c$var$gH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Y5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$K5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$uL {
    /**
   * Constructs a new light shadow.
   *
   * @param {Camera} camera - The light's view of the world.
   */ constructor(e){
        this.camera = e, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new $d7238066c5de7f1c$var$Ii(512, 512), this.mapType = $d7238066c5de7f1c$var$Ya, this.map = null, this.mapPass = null, this.matrix = new $d7238066c5de7f1c$var$Ji(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new $d7238066c5de7f1c$var$sL(), this._frameExtents = new $d7238066c5de7f1c$var$Ii(1, 1), this._viewportCount = 1, this._viewports = [
            new $d7238066c5de7f1c$var$Gi(0, 0, 1, 1)
        ];
    }
    /**
   * Used internally by the renderer to get the number of viewports that need
   * to be rendered for this shadow.
   *
   * @return {number} The viewport count.
   */ getViewportCount() {
        return this._viewportCount;
    }
    /**
   * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
   *
   * @return {Frustum} The shadow camera frustum.
   */ getFrustum() {
        return this._frustum;
    }
    /**
   * Update the matrices for the camera and shadow, used internally by the renderer.
   *
   * @param {Light} light - The light for which the shadow is being rendered.
   */ updateMatrices(e) {
        const t = this.camera, i = this.matrix;
        $d7238066c5de7f1c$var$Y5.setFromMatrixPosition(e.matrixWorld), t.position.copy($d7238066c5de7f1c$var$Y5), $d7238066c5de7f1c$var$K5.setFromMatrixPosition(e.target.matrixWorld), t.lookAt($d7238066c5de7f1c$var$K5), t.updateMatrixWorld(), $d7238066c5de7f1c$var$gH.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix($d7238066c5de7f1c$var$gH, t.coordinateSystem, t.reversedDepth), t.reversedDepth ? i.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 1, 0, 0, 0, 0, 1) : i.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1), i.multiply($d7238066c5de7f1c$var$gH);
    }
    /**
   * Returns a viewport definition for the given viewport index.
   *
   * @param {number} viewportIndex - The viewport index.
   * @return {Vector4} The viewport.
   */ getViewport(e) {
        return this._viewports[e];
    }
    /**
   * Returns the frame extends.
   *
   * @return {Vector2} The frame extends.
   */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */ dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    /**
   * Copies the values of the given light shadow instance to this instance.
   *
   * @param {LightShadow} source - The light shadow to copy.
   * @return {LightShadow} A reference to this light shadow instance.
   */ copy(e) {
        return this.camera = e.camera.clone(), this.intensity = e.intensity, this.bias = e.bias, this.radius = e.radius, this.autoUpdate = e.autoUpdate, this.needsUpdate = e.needsUpdate, this.normalBias = e.normalBias, this.blurSamples = e.blurSamples, this.mapSize.copy(e.mapSize), this;
    }
    /**
   * Returns a new light shadow instance with copied values from this instance.
   *
   * @return {LightShadow} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Serializes the light shadow into JSON.
   *
   * @return {Object} A JSON object representing the serialized light shadow.
   * @see {@link ObjectLoader#parse}
   */ toJSON() {
        const e = {};
        return this.intensity !== 1 && (e.intensity = this.intensity), this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
    }
}
class $d7238066c5de7f1c$var$Aee extends $d7238066c5de7f1c$var$uL {
    /**
   * Constructs a new spot light shadow.
   */ constructor(){
        super(new $d7238066c5de7f1c$var$tg(50, 1, 0.5, 500)), this.isSpotLightShadow = !0, this.focus = 1, this.aspect = 1;
    }
    updateMatrices(e) {
        const t = this.camera, i = $d7238066c5de7f1c$var$MA * 2 * e.angle * this.focus, n = this.mapSize.width / this.mapSize.height * this.aspect, s = e.distance || t.far;
        (i !== t.fov || n !== t.aspect || s !== t.far) && (t.fov = i, t.aspect = n, t.far = s, t.updateProjectionMatrix()), super.updateMatrices(e);
    }
    copy(e) {
        return super.copy(e), this.focus = e.focus, this;
    }
}
class $d7238066c5de7f1c$var$IL extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new spot light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
   * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */ constructor(e, t, i = 0, n = Math.PI / 3, s = 0, a = 2){
        super(e, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy($d7238066c5de7f1c$var$lr.DEFAULT_UP), this.updateMatrix(), this.target = new $d7238066c5de7f1c$var$lr(), this.distance = i, this.angle = n, this.penumbra = s, this.decay = a, this.map = null, this.shadow = new $d7238066c5de7f1c$var$Aee();
    }
    /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   *  Changing the power will also change the light's intensity.
   *
   * @type {number}
   */ get power() {
        return this.intensity * Math.PI;
    }
    set power(e) {
        this.intensity = e / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(e, t) {
        return super.copy(e, t), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
    }
}
const $d7238066c5de7f1c$var$x5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Lb = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$lH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$bee extends $d7238066c5de7f1c$var$uL {
    /**
   * Constructs a new point light shadow.
   */ constructor(){
        super(new $d7238066c5de7f1c$var$tg(90, 1, 0.5, 500)), this.isPointLightShadow = !0, this._frameExtents = new $d7238066c5de7f1c$var$Ii(4, 2), this._viewportCount = 6, this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d7238066c5de7f1c$var$Gi(2, 1, 1, 1),
            // negative X
            new $d7238066c5de7f1c$var$Gi(0, 1, 1, 1),
            // positive Z
            new $d7238066c5de7f1c$var$Gi(3, 1, 1, 1),
            // negative Z
            new $d7238066c5de7f1c$var$Gi(1, 1, 1, 1),
            // positive Y
            new $d7238066c5de7f1c$var$Gi(3, 0, 1, 1),
            // negative Y
            new $d7238066c5de7f1c$var$Gi(1, 0, 1, 1)
        ], this._cubeDirections = [
            new $d7238066c5de7f1c$var$Ce(1, 0, 0),
            new $d7238066c5de7f1c$var$Ce(-1, 0, 0),
            new $d7238066c5de7f1c$var$Ce(0, 0, 1),
            new $d7238066c5de7f1c$var$Ce(0, 0, -1),
            new $d7238066c5de7f1c$var$Ce(0, 1, 0),
            new $d7238066c5de7f1c$var$Ce(0, -1, 0)
        ], this._cubeUps = [
            new $d7238066c5de7f1c$var$Ce(0, 1, 0),
            new $d7238066c5de7f1c$var$Ce(0, 1, 0),
            new $d7238066c5de7f1c$var$Ce(0, 1, 0),
            new $d7238066c5de7f1c$var$Ce(0, 1, 0),
            new $d7238066c5de7f1c$var$Ce(0, 0, 1),
            new $d7238066c5de7f1c$var$Ce(0, 0, -1)
        ];
    }
    /**
   * Update the matrices for the camera and shadow, used internally by the renderer.
   *
   * @param {Light} light - The light for which the shadow is being rendered.
   * @param {number} [viewportIndex=0] - The viewport index.
   */ updateMatrices(e, t = 0) {
        const i = this.camera, n = this.matrix, s = e.distance || i.far;
        s !== i.far && (i.far = s, i.updateProjectionMatrix()), $d7238066c5de7f1c$var$Lb.setFromMatrixPosition(e.matrixWorld), i.position.copy($d7238066c5de7f1c$var$Lb), $d7238066c5de7f1c$var$lH.copy(i.position), $d7238066c5de7f1c$var$lH.add(this._cubeDirections[t]), i.up.copy(this._cubeUps[t]), i.lookAt($d7238066c5de7f1c$var$lH), i.updateMatrixWorld(), n.makeTranslation(-$d7238066c5de7f1c$var$Lb.x, -$d7238066c5de7f1c$var$Lb.y, -$d7238066c5de7f1c$var$Lb.z), $d7238066c5de7f1c$var$x5.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), this._frustum.setFromProjectionMatrix($d7238066c5de7f1c$var$x5, i.coordinateSystem, i.reversedDepth);
    }
}
class $d7238066c5de7f1c$var$yee extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new point light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */ constructor(e, t, i = 0, n = 2){
        super(e, t), this.isPointLight = !0, this.type = "PointLight", this.distance = i, this.decay = n, this.shadow = new $d7238066c5de7f1c$var$bee();
    }
    /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   * Changing the power will also change the light's intensity.
   *
   * @type {number}
   */ get power() {
        return this.intensity * 4 * Math.PI;
    }
    set power(e) {
        this.intensity = e / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(e, t) {
        return super.copy(e, t), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
    }
}
class $d7238066c5de7f1c$var$dL extends $d7238066c5de7f1c$var$tL {
    /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */ constructor(e = -1, t = 1, i = 1, n = -1, s = 0.1, a = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = i, this.bottom = n, this.near = s, this.far = a, this.updateProjectionMatrix();
    }
    copy(e, t) {
        return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
    }
    /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */ setViewOffset(e, t, i, n, s, a) {
        this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = s, this.view.height = a, this.updateProjectionMatrix();
    }
    /**
   * Removes the view offset from the projection matrix.
   */ clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */ updateProjectionMatrix() {
        const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
        let s = i - e, a = i + e, o = n + t, g = n - t;
        if (this.view !== null && this.view.enabled) {
            const l = (this.right - this.left) / this.view.fullWidth / this.zoom, c = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            s += l * this.view.offsetX, a = s + l * this.view.width, o -= c * this.view.offsetY, g = o - c * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(s, a, o, g, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
    }
}
class $d7238066c5de7f1c$var$Bee extends $d7238066c5de7f1c$var$uL {
    /**
   * Constructs a new directional light shadow.
   */ constructor(){
        super(new $d7238066c5de7f1c$var$dL(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
    }
}
class $d7238066c5de7f1c$var$fee extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new directional light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */ constructor(e, t){
        super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy($d7238066c5de7f1c$var$lr.DEFAULT_UP), this.updateMatrix(), this.target = new $d7238066c5de7f1c$var$lr(), this.shadow = new $d7238066c5de7f1c$var$Bee();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(e) {
        return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
    }
}
class $d7238066c5de7f1c$var$Gee extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new ambient light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */ constructor(e, t){
        super(e, t), this.isAmbientLight = !0, this.type = "AmbientLight";
    }
}
class $d7238066c5de7f1c$var$vee extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new area light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   * @param {number} [width=10] - The width of the light.
   * @param {number} [height=10] - The height of the light.
   */ constructor(e, t, i = 10, n = 10){
        super(e, t), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = i, this.height = n;
    }
    /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   * Changing the power will also change the light's intensity.
   *
   * @type {number}
   */ get power() {
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(e) {
        this.intensity = e / (this.width * this.height * Math.PI);
    }
    copy(e) {
        return super.copy(e), this.width = e.width, this.height = e.height, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.width = this.width, t.object.height = this.height, t;
    }
}
class $d7238066c5de7f1c$var$See {
    /**
   * Constructs a new spherical harmonics.
   */ constructor(){
        this.isSphericalHarmonics3 = !0, this.coefficients = [];
        for(let e = 0; e < 9; e++)this.coefficients.push(new $d7238066c5de7f1c$var$Ce());
    }
    /**
   * Sets the given SH coefficients to this instance by copying
   * the values.
   *
   * @param {Array<Vector3>} coefficients - The SH coefficients.
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ set(e) {
        for(let t = 0; t < 9; t++)this.coefficients[t].copy(e[t]);
        return this;
    }
    /**
   * Sets all SH coefficients to `0`.
   *
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ zero() {
        for(let e = 0; e < 9; e++)this.coefficients[e].set(0, 0, 0);
        return this;
    }
    /**
   * Returns the radiance in the direction of the given normal.
   *
   * @param {Vector3} normal - The normal vector (assumed to be unit length)
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The radiance.
   */ getAt(e, t) {
        const i = e.x, n = e.y, s = e.z, a = this.coefficients;
        return t.copy(a[0]).multiplyScalar(0.282095), t.addScaledVector(a[1], 0.488603 * n), t.addScaledVector(a[2], 0.488603 * s), t.addScaledVector(a[3], 0.488603 * i), t.addScaledVector(a[4], 1.092548 * (i * n)), t.addScaledVector(a[5], 1.092548 * (n * s)), t.addScaledVector(a[6], 0.315392 * (3 * s * s - 1)), t.addScaledVector(a[7], 1.092548 * (i * s)), t.addScaledVector(a[8], 0.546274 * (i * i - n * n)), t;
    }
    /**
   * Returns the irradiance (radiance convolved with cosine lobe) in the
   * direction of the given normal.
   *
   * @param {Vector3} normal - The normal vector (assumed to be unit length)
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The irradiance.
   */ getIrradianceAt(e, t) {
        const i = e.x, n = e.y, s = e.z, a = this.coefficients;
        return t.copy(a[0]).multiplyScalar(0.886227), t.addScaledVector(a[1], 1.023328 * n), t.addScaledVector(a[2], 1.023328 * s), t.addScaledVector(a[3], 1.023328 * i), t.addScaledVector(a[4], 0.858086 * i * n), t.addScaledVector(a[5], 0.858086 * n * s), t.addScaledVector(a[6], 0.743125 * s * s - 0.247708), t.addScaledVector(a[7], 0.858086 * i * s), t.addScaledVector(a[8], 0.429043 * (i * i - n * n)), t;
    }
    /**
   * Adds the given SH to this instance.
   *
   * @param {SphericalHarmonics3} sh - The SH to add.
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ add(e) {
        for(let t = 0; t < 9; t++)this.coefficients[t].add(e.coefficients[t]);
        return this;
    }
    /**
   * A convenience method for performing {@link SphericalHarmonics3#add} and
   * {@link SphericalHarmonics3#scale} at once.
   *
   * @param {SphericalHarmonics3} sh - The SH to add.
   * @param {number} s - The scale factor.
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ addScaledSH(e, t) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(e.coefficients[i], t);
        return this;
    }
    /**
   * Scales this SH by the given scale factor.
   *
   * @param {number} s - The scale factor.
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ scale(e) {
        for(let t = 0; t < 9; t++)this.coefficients[t].multiplyScalar(e);
        return this;
    }
    /**
   * Linear interpolates between the given SH and this instance by the given
   * alpha factor.
   *
   * @param {SphericalHarmonics3} sh - The SH to interpolate with.
   * @param {number} alpha - The alpha factor.
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ lerp(e, t) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(e.coefficients[i], t);
        return this;
    }
    /**
   * Returns `true` if this spherical harmonics is equal with the given one.
   *
   * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
   * @return {boolean} Whether this spherical harmonics is equal with the given one.
   */ equals(e) {
        for(let t = 0; t < 9; t++)if (!this.coefficients[t].equals(e.coefficients[t])) return !1;
        return !0;
    }
    /**
   * Copies the values of the given spherical harmonics to this instance.
   *
   * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
   * @return {SphericalHarmonics3} A reference to this spherical harmonics.
   */ copy(e) {
        return this.set(e.coefficients);
    }
    /**
   * Returns a new spherical harmonics with copied values from this instance.
   *
   * @return {SphericalHarmonics3} A clone of this instance.
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Sets the SH coefficients of this instance from the given array.
   *
   * @param {Array<number>} array - An array holding the SH coefficients.
   * @param {number} [offset=0] - The array offset where to start copying.
   * @return {SphericalHarmonics3} A clone of this instance.
   */ fromArray(e, t = 0) {
        const i = this.coefficients;
        for(let n = 0; n < 9; n++)i[n].fromArray(e, t + n * 3);
        return this;
    }
    /**
   * Returns an array with the SH coefficients, or copies them into the provided
   * array. The coefficients are represented as numbers.
   *
   * @param {Array<number>} [array=[]] - The target array.
   * @param {number} [offset=0] - The array offset where to start copying.
   * @return {Array<number>} An array with flat SH coefficients.
   */ toArray(e = [], t = 0) {
        const i = this.coefficients;
        for(let n = 0; n < 9; n++)i[n].toArray(e, t + n * 3);
        return e;
    }
    /**
   * Computes the SH basis for the given normal vector.
   *
   * @param {Vector3} normal - The normal.
   * @param {Array<number>} shBasis - The target array holding the SH basis.
   */ static getBasisAt(e, t) {
        const i = e.x, n = e.y, s = e.z;
        t[0] = 0.282095, t[1] = 0.488603 * n, t[2] = 0.488603 * s, t[3] = 0.488603 * i, t[4] = 1.092548 * i * n, t[5] = 1.092548 * n * s, t[6] = 0.315392 * (3 * s * s - 1), t[7] = 1.092548 * i * s, t[8] = 0.546274 * (i * i - n * n);
    }
}
class $d7238066c5de7f1c$var$Zee extends $d7238066c5de7f1c$var$QC {
    /**
   * Constructs a new light probe.
   *
   * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */ constructor(e = new $d7238066c5de7f1c$var$See(), t = 1){
        super(void 0, t), this.isLightProbe = !0, this.sh = e;
    }
    copy(e) {
        return super.copy(e), this.sh.copy(e.sh), this;
    }
    /**
   * Deserializes the light prove from the given JSON.
   *
   * @param {Object} json - The JSON holding the serialized light probe.
   * @return {LightProbe} A reference to this light probe.
   */ fromJSON(e) {
        return this.intensity = e.intensity, this.sh.fromArray(e.sh), this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.sh = this.sh.toArray(), t;
    }
}
class $d7238066c5de7f1c$var$Ree extends $d7238066c5de7f1c$var$tg {
    /**
   * Constructs a new array camera.
   *
   * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
   */ constructor(e = []){
        super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
    }
}
class $d7238066c5de7f1c$var$Vee extends $d7238066c5de7f1c$var$h3 {
    /**
   * Constructs a new instanced interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
   */ constructor(e, t, i = 1){
        super(e, t), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = i;
    }
    copy(e) {
        return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
    }
    clone(e) {
        const t = super.clone(e);
        return t.meshPerAttribute = this.meshPerAttribute, t;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.isInstancedInterleavedBuffer = !0, t.meshPerAttribute = this.meshPerAttribute, t;
    }
}
class $d7238066c5de7f1c$var$uR {
    /**
   * Constructs a new 2x2 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   */ constructor(e, t, i, n){
        $d7238066c5de7f1c$var$uR.prototype.isMatrix2 = !0, this.elements = [
            1,
            0,
            0,
            1
        ], e !== void 0 && this.set(e, t, i, n);
    }
    /**
   * Sets this matrix to the 2x2 identity matrix.
   *
   * @return {Matrix2} A reference to this matrix.
   */ identity() {
        return this.set(1, 0, 0, 1), this;
    }
    /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix2} A reference to this matrix.
   */ fromArray(e, t = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = e[i + t];
        return this;
    }
    /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} n11 - 1-1 matrix element.
   * @param {number} n12 - 1-2 matrix element.
   * @param {number} n21 - 2-1 matrix element.
   * @param {number} n22 - 2-2 matrix element.
   * @return {Matrix2} A reference to this matrix.
   */ set(e, t, i, n) {
        const s = this.elements;
        return s[0] = e, s[2] = t, s[1] = i, s[3] = n, this;
    }
}
function $d7238066c5de7f1c$var$wee(r, e, t, i) {
    const n = $d7238066c5de7f1c$var$Wee(i);
    switch(t){
        case $d7238066c5de7f1c$var$qk:
            return r * e;
        case $d7238066c5de7f1c$var$rR:
            return r * e / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$aR:
            return r * e / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$gI:
            return r * e * 2 / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$oR:
            return r * e * 2 / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$sR:
            return r * e * 3 / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$sg:
            return r * e * 4 / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$gR:
            return r * e * 4 / n.components * n.byteLength;
        case $d7238066c5de7f1c$var$Ky:
        case $d7238066c5de7f1c$var$xy:
            return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 8;
        case $d7238066c5de7f1c$var$Fy:
        case $d7238066c5de7f1c$var$Ty:
            return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case $d7238066c5de7f1c$var$B2:
        case $d7238066c5de7f1c$var$G2:
            return Math.max(r, 16) * Math.max(e, 8) / 4;
        case $d7238066c5de7f1c$var$y2:
        case $d7238066c5de7f1c$var$f2:
            return Math.max(r, 8) * Math.max(e, 8) / 2;
        case $d7238066c5de7f1c$var$eZ:
        case $d7238066c5de7f1c$var$tZ:
            return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 8;
        case $d7238066c5de7f1c$var$iZ:
            return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case $d7238066c5de7f1c$var$nZ:
            return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case $d7238066c5de7f1c$var$sZ:
            return Math.floor((r + 4) / 5) * Math.floor((e + 3) / 4) * 16;
        case $d7238066c5de7f1c$var$rZ:
            return Math.floor((r + 4) / 5) * Math.floor((e + 4) / 5) * 16;
        case $d7238066c5de7f1c$var$aZ:
            return Math.floor((r + 5) / 6) * Math.floor((e + 4) / 5) * 16;
        case $d7238066c5de7f1c$var$oZ:
            return Math.floor((r + 5) / 6) * Math.floor((e + 5) / 6) * 16;
        case $d7238066c5de7f1c$var$gZ:
            return Math.floor((r + 7) / 8) * Math.floor((e + 4) / 5) * 16;
        case $d7238066c5de7f1c$var$lZ:
            return Math.floor((r + 7) / 8) * Math.floor((e + 5) / 6) * 16;
        case $d7238066c5de7f1c$var$cZ:
            return Math.floor((r + 7) / 8) * Math.floor((e + 7) / 8) * 16;
        case $d7238066c5de7f1c$var$uZ:
            return Math.floor((r + 9) / 10) * Math.floor((e + 4) / 5) * 16;
        case $d7238066c5de7f1c$var$IZ:
            return Math.floor((r + 9) / 10) * Math.floor((e + 5) / 6) * 16;
        case $d7238066c5de7f1c$var$dZ:
            return Math.floor((r + 9) / 10) * Math.floor((e + 7) / 8) * 16;
        case $d7238066c5de7f1c$var$hZ:
            return Math.floor((r + 9) / 10) * Math.floor((e + 9) / 10) * 16;
        case $d7238066c5de7f1c$var$CZ:
            return Math.floor((r + 11) / 12) * Math.floor((e + 9) / 10) * 16;
        case $d7238066c5de7f1c$var$pZ:
            return Math.floor((r + 11) / 12) * Math.floor((e + 11) / 12) * 16;
        case $d7238066c5de7f1c$var$mZ:
        case $d7238066c5de7f1c$var$_6:
        case $d7238066c5de7f1c$var$P6:
            return Math.ceil(r / 4) * Math.ceil(e / 4) * 16;
        case $d7238066c5de7f1c$var$AZ:
        case $d7238066c5de7f1c$var$bZ:
            return Math.ceil(r / 4) * Math.ceil(e / 4) * 8;
        case $d7238066c5de7f1c$var$yZ:
        case $d7238066c5de7f1c$var$BZ:
            return Math.ceil(r / 4) * Math.ceil(e / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${t} format.`);
}
function $d7238066c5de7f1c$var$Wee(r) {
    switch(r){
        case $d7238066c5de7f1c$var$Ya:
        case $d7238066c5de7f1c$var$fA:
            return {
                byteLength: 1,
                components: 1
            };
        case $d7238066c5de7f1c$var$wC:
        case $d7238066c5de7f1c$var$GA:
        case $d7238066c5de7f1c$var$Ia:
            return {
                byteLength: 2,
                components: 1
            };
        case $d7238066c5de7f1c$var$Ok:
        case $d7238066c5de7f1c$var$jk:
            return {
                byteLength: 2,
                components: 4
            };
        case $d7238066c5de7f1c$var$Xs:
        case $d7238066c5de7f1c$var$Na:
        case $d7238066c5de7f1c$var$vo:
            return {
                byteLength: 4,
                components: 1
            };
        case $d7238066c5de7f1c$var$ON:
        case $d7238066c5de7f1c$var$jN:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${r}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $d7238066c5de7f1c$var$MB
    }
}));
typeof window < "u" && (window.__THREE__ ? $d7238066c5de7f1c$var$ze("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = $d7238066c5de7f1c$var$MB);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d7238066c5de7f1c$var$Hee = [
    "alphaMap",
    "alphaTest",
    "anisotropy",
    "anisotropyMap",
    "anisotropyRotation",
    "aoMap",
    "aoMapIntensity",
    "attenuationColor",
    "attenuationDistance",
    "bumpMap",
    "clearcoat",
    "clearcoatMap",
    "clearcoatNormalMap",
    "clearcoatNormalScale",
    "clearcoatRoughness",
    "color",
    "dispersion",
    "displacementMap",
    "emissive",
    "emissiveIntensity",
    "emissiveMap",
    "envMap",
    "envMapIntensity",
    "gradientMap",
    "ior",
    "iridescence",
    "iridescenceIOR",
    "iridescenceMap",
    "iridescenceThicknessMap",
    "lightMap",
    "lightMapIntensity",
    "map",
    "matcap",
    "metalness",
    "metalnessMap",
    "normalMap",
    "normalScale",
    "opacity",
    "roughness",
    "roughnessMap",
    "sheen",
    "sheenColor",
    "sheenColorMap",
    "sheenRoughnessMap",
    "shininess",
    "specular",
    "specularColor",
    "specularColorMap",
    "specularIntensity",
    "specularIntensityMap",
    "specularMap",
    "thickness",
    "transmission",
    "transmissionMap"
], $d7238066c5de7f1c$var$cH = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$Xee {
    /**
   * Constructs a new node material observer.
   *
   * @param {NodeBuilder} builder - The node builder.
   */ constructor(e){
        this.renderObjects = /* @__PURE__ */ new WeakMap(), this.hasNode = this.containsNode(e), this.hasAnimation = e.object.isSkinnedMesh === !0, this.refreshUniforms = $d7238066c5de7f1c$var$Hee, this.renderId = 0;
    }
    /**
   * Returns `true` if the given render object is verified for the first time of this observer.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the given render object is verified for the first time of this observer.
   */ firstInitialization(e) {
        return this.renderObjects.has(e) === !1 ? (this.getRenderObjectData(e), !0) : !1;
    }
    /**
   * Returns `true` if the current rendering produces motion vectors.
   *
   * @param {Renderer} renderer - The renderer.
   * @return {boolean} Whether the current rendering produces motion vectors or not.
   */ needsVelocity(e) {
        const t = e.getMRT();
        return t !== null && t.has("velocity");
    }
    /**
   * Returns monitoring data for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Object} The monitoring data.
   */ getRenderObjectData(e) {
        let t = this.renderObjects.get(e);
        if (t === void 0) {
            const { geometry: i, material: n, object: s } = e;
            if (t = {
                material: this.getMaterialData(n),
                geometry: {
                    id: i.id,
                    attributes: this.getAttributesData(i.attributes),
                    indexVersion: i.index ? i.index.version : null,
                    drawRange: {
                        start: i.drawRange.start,
                        count: i.drawRange.count
                    }
                },
                worldMatrix: s.matrixWorld.clone()
            }, s.center && (t.center = s.center.clone()), s.morphTargetInfluences && (t.morphTargetInfluences = s.morphTargetInfluences.slice()), e.bundle !== null && (t.version = e.bundle.version), t.material.transmission > 0) {
                const { width: a, height: o } = e.context;
                t.bufferWidth = a, t.bufferHeight = o;
            }
            t.lights = this.getLightsData(e.lightsNode.getLights()), this.renderObjects.set(e, t);
        }
        return t;
    }
    /**
   * Returns an attribute data structure holding the attributes versions for
   * monitoring.
   *
   * @param {Object} attributes - The geometry attributes.
   * @return {Object} An object for monitoring the versions of attributes.
   */ getAttributesData(e) {
        const t = {};
        for(const i in e){
            const n = e[i];
            t[i] = {
                version: n.version
            };
        }
        return t;
    }
    /**
   * Returns `true` if the node builder's material uses
   * node properties.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether the node builder's material uses node properties or not.
   */ containsNode(e) {
        const t = e.material;
        for(const i in t)if (t[i] && t[i].isNode) return !0;
        return e.renderer.overrideNodes.modelViewMatrix !== null || e.renderer.overrideNodes.modelNormalViewMatrix !== null;
    }
    /**
   * Returns a material data structure holding the material property values for
   * monitoring.
   *
   * @param {Material} material - The material.
   * @return {Object} An object for monitoring material properties.
   */ getMaterialData(e) {
        const t = {};
        for (const i of this.refreshUniforms){
            const n = e[i];
            n != null && (typeof n == "object" && n.clone !== void 0 ? n.isTexture === !0 ? t[i] = {
                id: n.id,
                version: n.version
            } : t[i] = n.clone() : t[i] = n);
        }
        return t;
    }
    /**
   * Returns `true` if the given render object has not changed its state.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Light>} lightsData - The current material lights.
   * @return {boolean} Whether the given render object has changed its state or not.
   */ equals(e, t) {
        const { object: i, material: n, geometry: s } = e, a = this.getRenderObjectData(e);
        if (a.worldMatrix.equals(i.matrixWorld) !== !0) return a.worldMatrix.copy(i.matrixWorld), !1;
        const o = a.material;
        for(const Z in o){
            const v = o[Z], V = n[Z];
            if (v.equals !== void 0) {
                if (v.equals(V) === !1) return v.copy(V), !1;
            } else if (V.isTexture === !0) {
                if (v.id !== V.id || v.version !== V.version) return v.id = V.id, v.version = V.version, !1;
            } else if (v !== V) return o[Z] = V, !1;
        }
        if (o.transmission > 0) {
            const { width: Z, height: v } = e.context;
            if (a.bufferWidth !== Z || a.bufferHeight !== v) return a.bufferWidth = Z, a.bufferHeight = v, !1;
        }
        const g = a.geometry, l = s.attributes, c = g.attributes, d = Object.keys(c), p = Object.keys(l);
        if (g.id !== s.id) return g.id = s.id, !1;
        if (d.length !== p.length) return a.geometry.attributes = this.getAttributesData(l), !1;
        for (const Z of d){
            const v = c[Z], V = l[Z];
            if (V === void 0) return delete c[Z], !1;
            if (v.version !== V.version) return v.version = V.version, !1;
        }
        const A = s.index, y = g.indexVersion, G = A ? A.version : null;
        if (y !== G) return g.indexVersion = G, !1;
        if (g.drawRange.start !== s.drawRange.start || g.drawRange.count !== s.drawRange.count) return g.drawRange.start = s.drawRange.start, g.drawRange.count = s.drawRange.count, !1;
        if (a.morphTargetInfluences) {
            let Z = !1;
            for(let v = 0; v < a.morphTargetInfluences.length; v++)a.morphTargetInfluences[v] !== i.morphTargetInfluences[v] && (a.morphTargetInfluences[v] = i.morphTargetInfluences[v], Z = !0);
            if (Z) return !1;
        }
        if (a.lights) {
            for(let Z = 0; Z < t.length; Z++)if (a.lights[Z].map !== t[Z].map) return !1;
        }
        return a.center && a.center.equals(i.center) === !1 ? (a.center.copy(i.center), !0) : (e.bundle !== null && (a.version = e.bundle.version), !0);
    }
    /**
   * Returns the lights data for the given material lights.
   *
   * @param {Array<Light>} materialLights - The material lights.
   * @return {Array<Object>} The lights data for the given material lights.
   */ getLightsData(e) {
        const t = [];
        for (const i of e)i.isSpotLight === !0 && i.map !== null && t.push({
            map: i.map.version
        });
        return t;
    }
    /**
   * Returns the lights for the given lights node and render ID.
   *
   * @param {LightsNode} lightsNode - The lights node.
   * @param {number} renderId - The render ID.
   * @return {Array<Object>} The lights for the given lights node and render ID.
   */ getLights(e, t) {
        if ($d7238066c5de7f1c$var$cH.has(e)) {
            const n = $d7238066c5de7f1c$var$cH.get(e);
            if (n.renderId === t) return n.lightsData;
        }
        const i = this.getLightsData(e.getLights());
        return $d7238066c5de7f1c$var$cH.set(e, {
            renderId: t,
            lightsData: i
        }), i;
    }
    /**
   * Checks if the given render object requires a refresh.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {NodeFrame} nodeFrame - The current node frame.
   * @return {boolean} Whether the given render object requires a refresh or not.
   */ needsRefresh(e, t) {
        if (this.hasNode || this.hasAnimation || this.firstInitialization(e) || this.needsVelocity(t.renderer)) return !0;
        const { renderId: i } = t;
        if (this.renderId !== i) return this.renderId = i, !0;
        const n = e.object.static === !0, s = e.bundle !== null && e.bundle.static === !0 && this.getRenderObjectData(e).version === e.bundle.version;
        if (n || s) return !1;
        const a = this.getLights(e.lightsNode, i);
        return this.equals(e, a) !== !0;
    }
}
function $d7238066c5de7f1c$var$hL(r, e = 0) {
    let t = 3735928559 ^ e, i = 1103547991 ^ e;
    if (r instanceof Array) for(let n = 0, s; n < r.length; n++)s = r[n], t = Math.imul(t ^ s, 2654435761), i = Math.imul(i ^ s, 1597334677);
    else for(let n = 0, s; n < r.length; n++)s = r.charCodeAt(n), t = Math.imul(t ^ s, 2654435761), i = Math.imul(i ^ s, 1597334677);
    return t = Math.imul(t ^ t >>> 16, 2246822507), t ^= Math.imul(i ^ i >>> 13, 3266489909), i = Math.imul(i ^ i >>> 16, 2246822507), i ^= Math.imul(t ^ t >>> 13, 3266489909), 4294967296 * (2097151 & i) + (t >>> 0);
}
const $d7238066c5de7f1c$var$EB = (r)=>$d7238066c5de7f1c$var$hL(r), $d7238066c5de7f1c$var$i0 = (r)=>$d7238066c5de7f1c$var$hL(r), $d7238066c5de7f1c$var$ky = (...r)=>$d7238066c5de7f1c$var$hL(r), $d7238066c5de7f1c$var$Nee = /* @__PURE__ */ new Map([
    [
        1,
        "float"
    ],
    [
        2,
        "vec2"
    ],
    [
        3,
        "vec3"
    ],
    [
        4,
        "vec4"
    ],
    [
        9,
        "mat3"
    ],
    [
        16,
        "mat4"
    ]
]), $d7238066c5de7f1c$var$F5 = /* @__PURE__ */ new WeakMap();
function $d7238066c5de7f1c$var$A3(r) {
    return $d7238066c5de7f1c$var$Nee.get(r);
}
function $d7238066c5de7f1c$var$ZZ(r) {
    if (/[iu]?vec\d/.test(r)) return r.startsWith("ivec") ? Int32Array : r.startsWith("uvec") ? Uint32Array : Float32Array;
    if (/mat\d/.test(r) || /float/.test(r)) return Float32Array;
    if (/uint/.test(r)) return Uint32Array;
    if (/int/.test(r)) return Int32Array;
    throw new Error(`THREE.NodeUtils: Unsupported type: ${r}`);
}
function $d7238066c5de7f1c$var$b3(r) {
    if (/float|int|uint/.test(r)) return 1;
    if (/vec2/.test(r)) return 2;
    if (/vec3/.test(r)) return 3;
    if (/vec4/.test(r) || /mat2/.test(r)) return 4;
    if (/mat3/.test(r)) return 9;
    if (/mat4/.test(r)) return 16;
    $d7238066c5de7f1c$var$nt("TSL: Unsupported type:", r);
}
function $d7238066c5de7f1c$var$Lee(r) {
    if (/float|int|uint/.test(r)) return 1;
    if (/vec2/.test(r)) return 2;
    if (/vec3/.test(r)) return 3;
    if (/vec4/.test(r) || /mat2/.test(r)) return 4;
    if (/mat3/.test(r)) return 12;
    if (/mat4/.test(r)) return 16;
    $d7238066c5de7f1c$var$nt("TSL: Unsupported type:", r);
}
function $d7238066c5de7f1c$var$Yee(r) {
    if (/float|int|uint/.test(r)) return 4;
    if (/vec2/.test(r)) return 8;
    if (/vec3/.test(r) || /vec4/.test(r)) return 16;
    if (/mat2/.test(r)) return 8;
    if (/mat3/.test(r)) return 48;
    if (/mat4/.test(r)) return 64;
    $d7238066c5de7f1c$var$nt("TSL: Unsupported type:", r);
}
function $d7238066c5de7f1c$var$jd(r) {
    if (r == null) return null;
    const e = typeof r;
    return r.isNode === !0 ? "node" : e === "number" ? "float" : e === "boolean" ? "bool" : e === "string" ? "string" : e === "function" ? "shader" : r.isVector2 === !0 ? "vec2" : r.isVector3 === !0 ? "vec3" : r.isVector4 === !0 ? "vec4" : r.isMatrix2 === !0 ? "mat2" : r.isMatrix3 === !0 ? "mat3" : r.isMatrix4 === !0 ? "mat4" : r.isColor === !0 ? "color" : r instanceof ArrayBuffer ? "ArrayBuffer" : null;
}
function $d7238066c5de7f1c$var$CL(r, ...e) {
    const t = r ? r.slice(-4) : void 0;
    return e.length === 1 && (t === "vec2" ? e = [
        e[0],
        e[0]
    ] : t === "vec3" ? e = [
        e[0],
        e[0],
        e[0]
    ] : t === "vec4" && (e = [
        e[0],
        e[0],
        e[0],
        e[0]
    ])), r === "color" ? new $d7238066c5de7f1c$var$rn(...e) : t === "vec2" ? new $d7238066c5de7f1c$var$Ii(...e) : t === "vec3" ? new $d7238066c5de7f1c$var$Ce(...e) : t === "vec4" ? new $d7238066c5de7f1c$var$Gi(...e) : t === "mat2" ? new $d7238066c5de7f1c$var$uR(...e) : t === "mat3" ? new $d7238066c5de7f1c$var$Lo(...e) : t === "mat4" ? new $d7238066c5de7f1c$var$Ji(...e) : r === "bool" ? e[0] || !1 : r === "float" || r === "int" || r === "uint" ? e[0] || 0 : r === "string" ? e[0] || "" : r === "ArrayBuffer" ? $d7238066c5de7f1c$var$f3(e[0]) : null;
}
function $d7238066c5de7f1c$var$y3(r) {
    let e = $d7238066c5de7f1c$var$F5.get(r);
    return e === void 0 && (e = {}, $d7238066c5de7f1c$var$F5.set(r, e)), e;
}
function $d7238066c5de7f1c$var$B3(r) {
    let e = "";
    const t = new Uint8Array(r);
    for(let i = 0; i < t.length; i++)e += String.fromCharCode(t[i]);
    return btoa(e);
}
function $d7238066c5de7f1c$var$f3(r) {
    return Uint8Array.from(atob(r), (e)=>e.charCodeAt(0)).buffer;
}
const $d7238066c5de7f1c$var$by = {
    VERTEX: "vertex",
    FRAGMENT: "fragment"
}, $d7238066c5de7f1c$var$Dt = {
    NONE: "none",
    FRAME: "frame",
    RENDER: "render",
    OBJECT: "object"
}, $d7238066c5de7f1c$var$Kee = {
    BOOLEAN: "bool",
    INTEGER: "int",
    FLOAT: "float",
    VECTOR2: "vec2",
    VECTOR3: "vec3",
    VECTOR4: "vec4",
    MATRIX2: "mat2",
    MATRIX3: "mat3",
    MATRIX4: "mat4"
}, $d7238066c5de7f1c$var$da = {
    READ_ONLY: "readOnly",
    WRITE_ONLY: "writeOnly",
    READ_WRITE: "readWrite"
}, $d7238066c5de7f1c$var$G3 = [
    "fragment",
    "vertex"
], $d7238066c5de7f1c$var$Z2 = [
    "setup",
    "analyze",
    "generate"
], $d7238066c5de7f1c$var$R2 = [
    ...$d7238066c5de7f1c$var$G3,
    "compute"
], $d7238066c5de7f1c$var$OC = [
    "x",
    "y",
    "z",
    "w"
], $d7238066c5de7f1c$var$xee = {
    analyze: "setup",
    generate: "analyze"
};
let $d7238066c5de7f1c$var$Fee = 0;
class $d7238066c5de7f1c$var$Ct extends $d7238066c5de7f1c$var$wI {
    static get type() {
        return "Node";
    }
    /**
   * Constructs a new node.
   *
   * @param {?string} nodeType - The node type.
   */ constructor(e = null){
        super(), this.nodeType = e, this.updateType = $d7238066c5de7f1c$var$Dt.NONE, this.updateBeforeType = $d7238066c5de7f1c$var$Dt.NONE, this.updateAfterType = $d7238066c5de7f1c$var$Dt.NONE, this.uuid = $d7238066c5de7f1c$var$o3.generateUUID(), this.version = 0, this.name = "", this.global = !1, this.parents = !1, this.isNode = !0, this._beforeNodes = null, this._cacheKey = null, this._cacheKeyVersion = 0, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$Fee++
        });
    }
    /**
   * Set this property to `true` when the node should be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */ set needsUpdate(e) {
        e === !0 && this.version++;
    }
    /**
   * The type of the class. The value is usually the constructor name.
   *
   * @type {string}
  	 * @readonly
   */ get type() {
        return this.constructor.type;
    }
    /**
   * Convenient method for defining {@link Node#update}.
   *
   * @param {Function} callback - The update method.
   * @param {string} updateType - The update type.
   * @return {Node} A reference to this node.
   */ onUpdate(e, t) {
        return this.updateType = t, this.update = e.bind(this), this;
    }
    /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `FRAME`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */ onFrameUpdate(e) {
        return this.onUpdate(e, $d7238066c5de7f1c$var$Dt.FRAME);
    }
    /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `RENDER`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */ onRenderUpdate(e) {
        return this.onUpdate(e, $d7238066c5de7f1c$var$Dt.RENDER);
    }
    /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `OBJECT`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */ onObjectUpdate(e) {
        return this.onUpdate(e, $d7238066c5de7f1c$var$Dt.OBJECT);
    }
    /**
   * Convenient method for defining {@link Node#updateReference}.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */ onReference(e) {
        return this.updateReference = e.bind(this), this;
    }
    /**
   * Nodes might refer to other objects like materials. This method allows to dynamically update the reference
   * to such objects based on a given state (e.g. the current node frame or builder).
   *
   * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
   * @return {any} The updated reference.
   */ updateReference() {
        return this;
    }
    /**
   * By default this method returns the value of the {@link Node#global} flag. This method
   * can be overwritten in derived classes if an analytical way is required to determine the
   * global cache referring to the current shader-stage.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether this node is global or not.
   */ isGlobal() {
        return this.global;
    }
    /**
   * Generator function that can be used to iterate over the child nodes.
   *
   * @generator
   * @yields {Node} A child node.
   */ *getChildren() {
        for (const { childNode: e } of this._getChildren())yield e;
    }
    /**
   * Calling this method dispatches the `dispose` event. This event can be used
   * to register event listeners for clean up tasks.
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    /**
   * Callback for {@link Node#traverse}.
   *
   * @callback traverseCallback
   * @param {Node} node - The current node.
   */ /**
   * Can be used to traverse through the node's hierarchy.
   *
   * @param {traverseCallback} callback - A callback that is executed per node.
   */ traverse(e) {
        e(this);
        for (const t of this.getChildren())t.traverse(e);
    }
    /**
   * Returns the child nodes of this node.
   *
   * @private
   * @param {Set<Node>} [ignores=new Set()] - A set of nodes to ignore during the search to avoid circular references.
   * @returns {Array<Object>} An array of objects describing the child nodes.
   */ _getChildren(e = /* @__PURE__ */ new Set()) {
        const t = [];
        e.add(this);
        for (const i of Object.getOwnPropertyNames(this)){
            const n = this[i];
            if (!(i.startsWith("_") === !0 || e.has(n))) {
                if (Array.isArray(n) === !0) for(let s = 0; s < n.length; s++){
                    const a = n[s];
                    a && a.isNode === !0 && t.push({
                        property: i,
                        index: s,
                        childNode: a
                    });
                }
                else if (n && n.isNode === !0) t.push({
                    property: i,
                    childNode: n
                });
                else if (n && Object.getPrototypeOf(n) === Object.prototype) for(const s in n){
                    if (s.startsWith("_") === !0) continue;
                    const a = n[s];
                    a && a.isNode === !0 && t.push({
                        property: i,
                        index: s,
                        childNode: a
                    });
                }
            }
        }
        return t;
    }
    /**
   * Returns the cache key for this node.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of the cache key is forced.
   * @param {Set<Node>} [ignores=null] - A set of nodes to ignore during the computation of the cache key.
   * @return {number} The cache key of the node.
   */ getCacheKey(e = !1, t = null) {
        if (e = e || this.version !== this._cacheKeyVersion, e === !0 || this._cacheKey === null) {
            t === null && (t = /* @__PURE__ */ new Set());
            const i = [];
            for (const { property: n, childNode: s } of this._getChildren(t))i.push($d7238066c5de7f1c$var$EB(n.slice(0, -4)), s.getCacheKey(e, t));
            this._cacheKey = $d7238066c5de7f1c$var$ky($d7238066c5de7f1c$var$i0(i), this.customCacheKey()), this._cacheKeyVersion = this.version;
        }
        return this._cacheKey;
    }
    /**
   * Generate a custom cache key for this node.
   *
   * @return {number} The cache key of the node.
   */ customCacheKey() {
        return this.id;
    }
    /**
   * Returns the references to this node which is by default `this`.
   *
   * @return {Node} A reference to this node.
   */ getScope() {
        return this;
    }
    /**
   * Returns the hash of the node which is used to identify the node. By default it's
   * the {@link Node#uuid} however derived node classes might have to overwrite this method
   * depending on their implementation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */ getHash() {
        return this.uuid;
    }
    /**
   * Returns the update type of {@link Node#update}.
   *
   * @return {NodeUpdateType} The update type.
   */ getUpdateType() {
        return this.updateType;
    }
    /**
   * Returns the update type of {@link Node#updateBefore}.
   *
   * @return {NodeUpdateType} The update type.
   */ getUpdateBeforeType() {
        return this.updateBeforeType;
    }
    /**
   * Returns the update type of {@link Node#updateAfter}.
   *
   * @return {NodeUpdateType} The update type.
   */ getUpdateAfterType() {
        return this.updateAfterType;
    }
    /**
   * Certain types are composed of multiple elements. For example a `vec3`
   * is composed of three `float` values. This method returns the type of
   * these elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */ getElementType(e) {
        const t = this.getNodeType(e);
        return e.getElementType(t);
    }
    /**
   * Returns the node member type for the given name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member.
   * @return {string} The type of the node.
   */ getMemberType() {
        return "void";
    }
    /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */ getNodeType(e) {
        const t = e.getNodeProperties(this);
        return t.outputNode ? t.outputNode.getNodeType(e) : this.nodeType;
    }
    /**
   * This method is used during the build process of a node and ensures
   * equal nodes are not built multiple times but just once. For example if
   * `attribute( 'uv' )` is used multiple times by the user, the build
   * process makes sure to process just the first node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The shared node if possible. Otherwise `this` is returned.
   */ getShared(e) {
        const t = this.getHash(e);
        return e.getNodeFromHash(t) || this;
    }
    /**
   * Returns the number of elements in the node array.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?number} The number of elements in the node array.
   */ getArrayCount() {
        return null;
    }
    /**
   * Represents the setup stage which is the first step of the build process, see {@link Node#build} method.
   * This method is often overwritten in derived modules to prepare the node which is used as a node's output/result.
   * If an output node is prepared, then it must be returned in the `return` statement of the derived module's setup function.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?Node} The output node.
   */ setup(e) {
        const t = e.getNodeProperties(this);
        let i = 0;
        for (const n of this.getChildren())t["node" + i++] = n;
        return t.outputNode || null;
    }
    /**
   * Represents the analyze stage which is the second step of the build process, see {@link Node#build} method.
   * This stage analyzes the node hierarchy and ensures descendent nodes are built.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?Node} output - The target output node.
   */ analyze(e, t = null) {
        const i = e.increaseUsage(this);
        if (this.parents === !0) {
            const n = e.getDataFromNode(this, "any");
            n.stages = n.stages || {}, n.stages[e.shaderStage] = n.stages[e.shaderStage] || [], n.stages[e.shaderStage].push(t);
        }
        if (i === 1) {
            const n = e.getNodeProperties(this);
            for (const s of Object.values(n))s && s.isNode === !0 && s.build(e, this);
        }
    }
    /**
   * Represents the generate stage which is the third step of the build process, see {@link Node#build} method.
   * This state builds the output node and returns the resulting shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?string} [output] - Can be used to define the output type.
   * @return {?string} The generated shader string.
   */ generate(e, t) {
        const { outputNode: i } = e.getNodeProperties(this);
        if (i && i.isNode === !0) return i.build(e, t);
    }
    /**
   * The method can be implemented to update the node's internal state before it is used to render an object.
   * The {@link Node#updateBeforeType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */ updateBefore() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * The method can be implemented to update the node's internal state after it was used to render an object.
   * The {@link Node#updateAfterType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */ updateAfter() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * The method can be implemented to update the node's internal state when it is used to render an object.
   * The {@link Node#updateType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */ update() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    before(e) {
        return this._beforeNodes === null && (this._beforeNodes = []), this._beforeNodes.push(e), this;
    }
    /**
   * This method performs the build of a node. The behavior and return value depend on the current build stage:
   * - **setup**: Prepares the node and its children for the build process. This process can also create new nodes. Returns the node itself or a variant.
   * - **analyze**: Analyzes the node hierarchy for optimizations in the code generation stage. Returns `null`.
   * - **generate**: Generates the shader code for the node. Returns the generated shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?(string|Node)} [output=null] - Can be used to define the output type.
   * @return {?(Node|string)} The result of the build process, depending on the build stage.
   */ build(e, t = null) {
        const i = this.getShared(e);
        if (this !== i) return i.build(e, t);
        if (this._beforeNodes !== null) {
            const g = this._beforeNodes;
            this._beforeNodes = null;
            for (const l of g)l.build(e, t);
            this._beforeNodes = g;
        }
        const n = e.getDataFromNode(this);
        n.buildStages = n.buildStages || {}, n.buildStages[e.buildStage] = !0;
        const s = $d7238066c5de7f1c$var$xee[e.buildStage];
        if (s && n.buildStages[s] !== !0) {
            const g = e.getBuildStage();
            e.setBuildStage(s), this.build(e), e.setBuildStage(g);
        }
        e.addNode(this), e.addChain(this);
        let a = null;
        const o = e.getBuildStage();
        if (o === "setup") {
            this.updateReference(e);
            const g = e.getNodeProperties(this);
            if (g.initialized !== !0) {
                g.initialized = !0, g.outputNode = this.setup(e) || g.outputNode || null;
                for (const l of Object.values(g))if (l && l.isNode === !0) {
                    if (l.parents === !0) {
                        const c = e.getNodeProperties(l);
                        c.parents = c.parents || [], c.parents.push(this);
                    }
                    l.build(e);
                }
            }
            a = g.outputNode;
        } else if (o === "analyze") this.analyze(e, t);
        else if (o === "generate") {
            if (this.generate.length < 2) {
                const l = this.getNodeType(e), c = e.getDataFromNode(this);
                a = c.snippet, a === void 0 ? c.generated === void 0 ? (c.generated = !0, a = this.generate(e) || "", c.snippet = a) : ($d7238066c5de7f1c$var$ze("Node: Recursion detected.", this), a = "/* Recursion detected. */") : c.flowCodes !== void 0 && e.context.nodeBlock !== void 0 && e.addFlowCodeHierarchy(this, e.context.nodeBlock), a = e.format(a, l, t);
            } else a = this.generate(e, t) || "";
            a === "" && t !== null && t !== "void" && t !== "OutputType" && ($d7238066c5de7f1c$var$nt(`TSL: Invalid generated code, expected a "${t}".`), a = e.generateConst(t));
        }
        return e.removeChain(this), e.addSequentialNode(this), a;
    }
    /**
   * Returns the child nodes as a JSON object.
   *
   * @return {Generator<Object>} An iterable list of serialized child objects as JSON.
   */ getSerializeChildren() {
        return this._getChildren();
    }
    /**
   * Serializes the node to JSON.
   *
   * @param {Object} json - The output JSON object.
   */ serialize(e) {
        const t = this.getSerializeChildren(), i = {};
        for (const { property: n, index: s, childNode: a } of t)s !== void 0 ? (i[n] === void 0 && (i[n] = Number.isInteger(s) ? [] : {}), i[n][s] = a.toJSON(e.meta).uuid) : i[n] = a.toJSON(e.meta).uuid;
        Object.keys(i).length > 0 && (e.inputNodes = i);
    }
    /**
   * Deserializes the node from the given JSON.
   *
   * @param {Object} json - The JSON object.
   */ deserialize(e) {
        if (e.inputNodes !== void 0) {
            const t = e.meta.nodes;
            for(const i in e.inputNodes)if (Array.isArray(e.inputNodes[i])) {
                const n = [];
                for (const s of e.inputNodes[i])n.push(t[s]);
                this[i] = n;
            } else if (typeof e.inputNodes[i] == "object") {
                const n = {};
                for(const s in e.inputNodes[i]){
                    const a = e.inputNodes[i][s];
                    n[s] = t[a];
                }
                this[i] = n;
            } else {
                const n = e.inputNodes[i];
                this[i] = t[n];
            }
        }
    }
    /**
   * Serializes the node into the three.js JSON Object/Scene format.
   *
   * @param {?Object} meta - An optional JSON object that already holds serialized data from other scene objects.
   * @return {Object} The serialized node.
   */ toJSON(e) {
        const { uuid: t, type: i } = this, n = e === void 0 || typeof e == "string";
        n && (e = {
            textures: {},
            images: {},
            nodes: {}
        });
        let s = e.nodes[t];
        s === void 0 && (s = {
            uuid: t,
            type: i,
            meta: e,
            metadata: {
                version: 4.7,
                type: "Node",
                generator: "Node.toJSON"
            }
        }, n !== !0 && (e.nodes[s.uuid] = s), this.serialize(s), delete s.meta);
        function a(o) {
            const g = [];
            for(const l in o){
                const c = o[l];
                delete c.metadata, g.push(c);
            }
            return g;
        }
        if (n) {
            const o = a(e.textures), g = a(e.images), l = a(e.nodes);
            o.length > 0 && (s.textures = o), g.length > 0 && (s.images = g), l.length > 0 && (s.nodes = l);
        }
        return s;
    }
}
class $d7238066c5de7f1c$var$jC extends $d7238066c5de7f1c$var$Ct {
    // @TODO: If extending from TempNode it breaks webgpu_compute
    static get type() {
        return "ArrayElementNode";
    }
    /**
   * Constructs an array element node.
   *
   * @param {Node} node - The array-like node.
   * @param {Node} indexNode - The index node that defines the element access.
   */ constructor(e, t){
        super(), this.node = e, this.indexNode = t, this.isArrayElementNode = !0;
    }
    /**
   * This method is overwritten since the node type is inferred from the array-like node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.node.getElementType(e);
    }
    generate(e) {
        const t = this.indexNode.getNodeType(e), i = this.node.build(e), n = this.indexNode.build(e, !e.isVector(t) && e.isInteger(t) ? t : "uint");
        return `${i}[ ${n} ]`;
    }
}
class $d7238066c5de7f1c$var$v3 extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ConvertNode";
    }
    /**
   * Constructs a new convert node.
   *
   * @param {Node} node - The node which type should be converted.
   * @param {string} convertTo - The target node type. Multiple types can be defined by separating them with a `|` sign.
   */ constructor(e, t){
        super(), this.node = e, this.convertTo = t;
    }
    /**
   * This method is overwritten since the implementation tries to infer the best
   * matching type from the {@link ConvertNode#convertTo} property.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        const t = this.node.getNodeType(e);
        let i = null;
        for (const n of this.convertTo.split("|"))(i === null || e.getTypeLength(t) === e.getTypeLength(n)) && (i = n);
        return i;
    }
    serialize(e) {
        super.serialize(e), e.convertTo = this.convertTo;
    }
    deserialize(e) {
        super.deserialize(e), this.convertTo = e.convertTo;
    }
    generate(e, t) {
        const i = this.node, n = this.getNodeType(e), s = i.build(e, n);
        return e.format(s, n, t);
    }
}
class $d7238066c5de7f1c$var$Ks extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "TempNode";
    }
    /**
   * Constructs a temp node.
   *
   * @param {?string} nodeType - The node type.
   */ constructor(e = null){
        super(e), this.isTempNode = !0;
    }
    /**
   * Whether this node is used more than once in context of other nodes.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @return {boolean} A flag that indicates if there is more than one dependency to other nodes.
   */ hasDependencies(e) {
        return e.getDataFromNode(this).usageCount > 1;
    }
    build(e, t) {
        if (e.getBuildStage() === "generate") {
            const n = e.getVectorType(this.getNodeType(e, t)), s = e.getDataFromNode(this);
            if (s.propertyName !== void 0) return e.format(s.propertyName, n, t);
            if (n !== "void" && t !== "void" && this.hasDependencies(e)) {
                const a = super.build(e, n), o = e.getVarFromNode(this, null, n), g = e.getPropertyName(o);
                return e.addLineFlowCode(`${g} = ${a}`, this), s.snippet = a, s.propertyName = g, e.format(s.propertyName, n, t);
            }
        }
        return super.build(e, t);
    }
}
class $d7238066c5de7f1c$var$Tee extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "JoinNode";
    }
    /**
   * Constructs a new join node.
   *
   * @param {Array<Node>} nodes - An array of nodes that should be joined.
   * @param {?string} [nodeType=null] - The node type.
   */ constructor(e = [], t = null){
        super(t), this.nodes = e;
    }
    /**
   * This method is overwritten since the node type must be inferred from the
   * joined data length if not explicitly defined.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.nodeType !== null ? e.getVectorType(this.nodeType) : e.getTypeFromLength(this.nodes.reduce((t, i)=>t + e.getTypeLength(i.getNodeType(e)), 0));
    }
    generate(e, t) {
        const i = this.getNodeType(e), n = e.getTypeLength(i), s = this.nodes, a = e.getComponentType(i), o = [];
        let g = 0;
        for (const c of s){
            if (g >= n) {
                $d7238066c5de7f1c$var$nt(`TSL: Length of parameters exceeds maximum length of function '${i}()' type.`);
                break;
            }
            let d = c.getNodeType(e), p = e.getTypeLength(d), A;
            if (g + p > n && ($d7238066c5de7f1c$var$nt(`TSL: Length of '${i}()' data exceeds maximum length of output type.`), p = n - g, d = e.getTypeFromLength(p)), g += p, A = c.build(e, d), e.getComponentType(d) !== a) {
                const G = e.getTypeFromLength(p, a);
                A = e.format(A, d, G);
            }
            o.push(A);
        }
        const l = `${e.getType(i)}( ${o.join(", ")} )`;
        return e.format(l, i, t);
    }
}
const $d7238066c5de7f1c$var$Mee = $d7238066c5de7f1c$var$OC.join("");
class $d7238066c5de7f1c$var$S3 extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "SplitNode";
    }
    /**
   * Constructs a new split node.
   *
   * @param {Node} node - The node that should be accessed.
   * @param {string} [components='x'] - The components that should be accessed.
   */ constructor(e, t = "x"){
        super(), this.node = e, this.components = t, this.isSplitNode = !0;
    }
    /**
   * Returns the vector length which is computed based on the requested components.
   *
   * @return {number} The vector length.
   */ getVectorLength() {
        let e = this.components.length;
        for (const t of this.components)e = Math.max($d7238066c5de7f1c$var$OC.indexOf(t) + 1, e);
        return e;
    }
    /**
   * Returns the component type of the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The component type.
   */ getComponentType(e) {
        return e.getComponentType(this.node.getNodeType(e));
    }
    /**
   * This method is overwritten since the node type is inferred from requested components.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return e.getTypeFromLength(this.components.length, this.getComponentType(e));
    }
    /**
   * Returns the scope of the node.
   *
   * @return {Node} The scope of the node.
   */ getScope() {
        return this.node.getScope();
    }
    generate(e, t) {
        const i = this.node, n = e.getTypeLength(i.getNodeType(e));
        let s = null;
        if (n > 1) {
            let a = null;
            this.getVectorLength() >= n && (a = e.getTypeFromLength(this.getVectorLength(), this.getComponentType(e)));
            const g = i.build(e, a);
            this.components.length === n && this.components === $d7238066c5de7f1c$var$Mee.slice(0, this.components.length) ? s = e.format(g, a, t) : s = e.format(`${g}.${this.components}`, this.getNodeType(e), t);
        } else s = i.build(e, t);
        return s;
    }
    serialize(e) {
        super.serialize(e), e.components = this.components;
    }
    deserialize(e) {
        super.deserialize(e), this.components = e.components;
    }
}
class $d7238066c5de7f1c$var$zee extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "SetNode";
    }
    /**
   * Constructs a new set node.
   *
   * @param {Node} sourceNode - The node that should be updated.
   * @param {string} components - The components that should be updated.
   * @param {Node} targetNode - The value node.
   */ constructor(e, t, i){
        super(), this.sourceNode = e, this.components = t, this.targetNode = i;
    }
    /**
   * This method is overwritten since the node type is inferred from {@link SetNode#sourceNode}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.sourceNode.getNodeType(e);
    }
    generate(e) {
        const { sourceNode: t, components: i, targetNode: n } = this, s = this.getNodeType(e), a = e.getComponentType(n.getNodeType(e)), o = e.getTypeFromLength(i.length, a), g = n.build(e, o), l = t.build(e, s), c = e.getTypeLength(s), d = [];
        for(let p = 0; p < c; p++){
            const A = $d7238066c5de7f1c$var$OC[p];
            A === i[0] ? (d.push(g), p += i.length - 1) : d.push(l + "." + A);
        }
        return `${e.getType(s)}( ${d.join(", ")} )`;
    }
}
class $d7238066c5de7f1c$var$kee extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "FlipNode";
    }
    /**
   * Constructs a new flip node.
   *
   * @param {Node} sourceNode - The node which component(s) should be flipped.
   * @param {string} components - The components that should be flipped e.g. `'x'` or `'xy'`.
   */ constructor(e, t){
        super(), this.sourceNode = e, this.components = t;
    }
    /**
   * This method is overwritten since the node type is inferred from the source node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.sourceNode.getNodeType(e);
    }
    generate(e) {
        const { components: t, sourceNode: i } = this, n = this.getNodeType(e), s = i.build(e), a = e.getVarFromNode(this), o = e.getPropertyName(a);
        e.addLineFlowCode(o + " = " + s, this);
        const g = e.getTypeLength(n), l = [];
        let c = 0;
        for(let d = 0; d < g; d++){
            const p = $d7238066c5de7f1c$var$OC[d];
            p === t[c] ? (l.push("1.0 - " + (o + "." + p)), c++) : l.push(o + "." + p);
        }
        return `${e.getType(n)}( ${l.join(", ")} )`;
    }
}
class $d7238066c5de7f1c$var$pL extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "InputNode";
    }
    /**
   * Constructs a new input node.
   *
   * @param {any} value - The value of this node. This can be any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
   * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */ constructor(e, t = null){
        super(t), this.isInputNode = !0, this.value = e, this.precision = null;
    }
    getNodeType() {
        return this.nodeType === null ? $d7238066c5de7f1c$var$jd(this.value) : this.nodeType;
    }
    /**
   * Returns the input type of the node which is by default the node type. Derived modules
   * might overwrite this method and use a fixed type or compute one analytically.
   *
   * A typical example for different input and node types are textures. The input type of a
   * normal RGBA texture is `texture` whereas its node type is `vec4`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType(e) {
        return this.getNodeType(e);
    }
    /**
   * Sets the precision to the given value. The method can be
   * overwritten in derived classes if the final precision must be computed
   * analytically.
   *
   * @param {('low'|'medium'|'high')} precision - The precision of the input value in the shader.
   * @return {InputNode} A reference to this node.
   */ setPrecision(e) {
        return this.precision = e, this;
    }
    serialize(e) {
        super.serialize(e), e.value = this.value, this.value && this.value.toArray && (e.value = this.value.toArray()), e.valueType = $d7238066c5de7f1c$var$jd(this.value), e.nodeType = this.nodeType, e.valueType === "ArrayBuffer" && (e.value = $d7238066c5de7f1c$var$B3(e.value)), e.precision = this.precision;
    }
    deserialize(e) {
        super.deserialize(e), this.nodeType = e.nodeType, this.value = Array.isArray(e.value) ? $d7238066c5de7f1c$var$CL(e.valueType, ...e.value) : e.value, this.precision = e.precision || null, this.value && this.value.fromArray && (this.value = this.value.fromArray(e.value));
    }
    generate() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
}
const $d7238066c5de7f1c$var$T5 = /float|u?int/;
class $d7238066c5de7f1c$var$al extends $d7238066c5de7f1c$var$pL {
    static get type() {
        return "ConstNode";
    }
    /**
   * Constructs a new input node.
   *
   * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color).
   * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */ constructor(e, t = null){
        super(e, t), this.isConstNode = !0;
    }
    /**
   * Generates the shader string of the value with the current node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated value as a shader string.
   */ generateConst(e) {
        return e.generateConst(this.getNodeType(e), this.value);
    }
    generate(e, t) {
        const i = this.getNodeType(e);
        return $d7238066c5de7f1c$var$T5.test(i) && $d7238066c5de7f1c$var$T5.test(t) ? e.generateConst(t, this.value) : e.format(this.generateConst(e), i, t);
    }
}
class $d7238066c5de7f1c$var$Eee extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "MemberNode";
    }
    /**
   * Constructs a member node.
   *
   * @param {Node} structNode - The struct node.
   * @param {string} property - The property name.
   */ constructor(e, t){
        super(), this.structNode = e, this.property = t, this.isMemberNode = !0;
    }
    hasMember(e) {
        return this.structNode.isMemberNode && this.structNode.hasMember(e) === !1 ? !1 : this.structNode.getMemberType(e, this.property) !== "void";
    }
    getNodeType(e) {
        return this.hasMember(e) === !1 ? "float" : this.structNode.getMemberType(e, this.property);
    }
    getMemberType(e, t) {
        if (this.hasMember(e) === !1) return "float";
        const i = this.getNodeType(e);
        return e.getStructTypeNode(i).getMemberType(e, t);
    }
    generate(e) {
        if (this.hasMember(e) === !1) {
            $d7238066c5de7f1c$var$ze(`TSL: Member "${this.property}" does not exist in struct.`);
            const i = this.getNodeType(e);
            return e.generateConst(i);
        }
        return this.structNode.build(e) + "." + this.property;
    }
}
let $d7238066c5de7f1c$var$lh = null;
const $d7238066c5de7f1c$var$V2 = /* @__PURE__ */ new Map();
function $d7238066c5de7f1c$var$Se(r, e) {
    if ($d7238066c5de7f1c$var$V2.has(r)) {
        $d7238066c5de7f1c$var$ze(`TSL: Redefinition of method chaining '${r}'.`);
        return;
    }
    if (typeof e != "function") throw new Error(`THREE.TSL: Node element ${r} is not a function`);
    $d7238066c5de7f1c$var$V2.set(r, e), r !== "assign" && ($d7238066c5de7f1c$var$Ct.prototype[r] = function(...t) {
        return this.isStackNode ? this.addToStack(e(...t)) : e(this, ...t);
    }, $d7238066c5de7f1c$var$Ct.prototype[r + "Assign"] = function(...t) {
        return this.isStackNode ? this.assign(t[0], e(...t)) : this.assign(e(this, ...t));
    });
}
const $d7238066c5de7f1c$var$Jee = (r)=>r.replace(/r|s/g, "x").replace(/g|t/g, "y").replace(/b|p/g, "z").replace(/a|q/g, "w"), $d7238066c5de7f1c$var$M5 = (r)=>$d7238066c5de7f1c$var$Jee(r).split("").sort().join("");
$d7238066c5de7f1c$var$Ct.prototype.assign = function(...r) {
    if (this.isStackNode !== !0) return $d7238066c5de7f1c$var$lh !== null ? $d7238066c5de7f1c$var$lh.assign(this, ...r) : $d7238066c5de7f1c$var$nt("TSL: No stack defined for assign operation. Make sure the assign is inside a Fn()."), this;
    {
        const e = $d7238066c5de7f1c$var$V2.get("assign");
        return this.addToStack(e(...r));
    }
};
$d7238066c5de7f1c$var$Ct.prototype.toVarIntent = function() {
    return this;
};
$d7238066c5de7f1c$var$Ct.prototype.get = function(r) {
    return new $d7238066c5de7f1c$var$Eee(this, r);
};
const $d7238066c5de7f1c$var$Ey = {};
function $d7238066c5de7f1c$var$Hv(r, e, t) {
    $d7238066c5de7f1c$var$Ey[r] = $d7238066c5de7f1c$var$Ey[e] = $d7238066c5de7f1c$var$Ey[t] = {
        get () {
            this._cache = this._cache || {};
            let a = this._cache[r];
            return a === void 0 && (a = new $d7238066c5de7f1c$var$S3(this, r), this._cache[r] = a), a;
        },
        set (a) {
            this[r].assign($d7238066c5de7f1c$var$He(a));
        }
    };
    const i = r.toUpperCase(), n = e.toUpperCase(), s = t.toUpperCase();
    $d7238066c5de7f1c$var$Ct.prototype["set" + i] = $d7238066c5de7f1c$var$Ct.prototype["set" + n] = $d7238066c5de7f1c$var$Ct.prototype["set" + s] = function(a) {
        const o = $d7238066c5de7f1c$var$M5(r);
        return new $d7238066c5de7f1c$var$zee(this, o, $d7238066c5de7f1c$var$He(a));
    }, $d7238066c5de7f1c$var$Ct.prototype["flip" + i] = $d7238066c5de7f1c$var$Ct.prototype["flip" + n] = $d7238066c5de7f1c$var$Ct.prototype["flip" + s] = function() {
        const a = $d7238066c5de7f1c$var$M5(r);
        return new $d7238066c5de7f1c$var$kee(this, a);
    };
}
const $d7238066c5de7f1c$var$Lc = [
    "x",
    "y",
    "z",
    "w"
], $d7238066c5de7f1c$var$Yc = [
    "r",
    "g",
    "b",
    "a"
], $d7238066c5de7f1c$var$Kc = [
    "s",
    "t",
    "p",
    "q"
];
for(let r = 0; r < 4; r++){
    let e = $d7238066c5de7f1c$var$Lc[r], t = $d7238066c5de7f1c$var$Yc[r], i = $d7238066c5de7f1c$var$Kc[r];
    $d7238066c5de7f1c$var$Hv(e, t, i);
    for(let n = 0; n < 4; n++){
        e = $d7238066c5de7f1c$var$Lc[r] + $d7238066c5de7f1c$var$Lc[n], t = $d7238066c5de7f1c$var$Yc[r] + $d7238066c5de7f1c$var$Yc[n], i = $d7238066c5de7f1c$var$Kc[r] + $d7238066c5de7f1c$var$Kc[n], $d7238066c5de7f1c$var$Hv(e, t, i);
        for(let s = 0; s < 4; s++){
            e = $d7238066c5de7f1c$var$Lc[r] + $d7238066c5de7f1c$var$Lc[n] + $d7238066c5de7f1c$var$Lc[s], t = $d7238066c5de7f1c$var$Yc[r] + $d7238066c5de7f1c$var$Yc[n] + $d7238066c5de7f1c$var$Yc[s], i = $d7238066c5de7f1c$var$Kc[r] + $d7238066c5de7f1c$var$Kc[n] + $d7238066c5de7f1c$var$Kc[s], $d7238066c5de7f1c$var$Hv(e, t, i);
            for(let a = 0; a < 4; a++)e = $d7238066c5de7f1c$var$Lc[r] + $d7238066c5de7f1c$var$Lc[n] + $d7238066c5de7f1c$var$Lc[s] + $d7238066c5de7f1c$var$Lc[a], t = $d7238066c5de7f1c$var$Yc[r] + $d7238066c5de7f1c$var$Yc[n] + $d7238066c5de7f1c$var$Yc[s] + $d7238066c5de7f1c$var$Yc[a], i = $d7238066c5de7f1c$var$Kc[r] + $d7238066c5de7f1c$var$Kc[n] + $d7238066c5de7f1c$var$Kc[s] + $d7238066c5de7f1c$var$Kc[a], $d7238066c5de7f1c$var$Hv(e, t, i);
        }
    }
}
for(let r = 0; r < 32; r++)$d7238066c5de7f1c$var$Ey[r] = {
    get () {
        this._cache = this._cache || {};
        let e = this._cache[r];
        return e === void 0 && (e = new $d7238066c5de7f1c$var$jC(this, new $d7238066c5de7f1c$var$al(r, "uint")), this._cache[r] = e), e;
    },
    set (e) {
        this[r].assign($d7238066c5de7f1c$var$He(e));
    }
};
Object.defineProperties($d7238066c5de7f1c$var$Ct.prototype, $d7238066c5de7f1c$var$Ey);
const $d7238066c5de7f1c$var$z5 = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$Uee = function(r, e = null) {
    const t = $d7238066c5de7f1c$var$jd(r);
    return t === "node" ? r : e === null && (t === "float" || t === "boolean") || t && t !== "shader" && t !== "string" ? $d7238066c5de7f1c$var$He($d7238066c5de7f1c$var$w2(r, e)) : t === "shader" ? r.isFn ? r : $d7238066c5de7f1c$var$oe(r) : r;
}, $d7238066c5de7f1c$var$Dee = function(r, e = null) {
    for(const t in r)r[t] = $d7238066c5de7f1c$var$He(r[t], e);
    return r;
}, $d7238066c5de7f1c$var$_ee = function(r, e = null) {
    const t = r.length;
    for(let i = 0; i < t; i++)r[i] = $d7238066c5de7f1c$var$He(r[i], e);
    return r;
}, $d7238066c5de7f1c$var$Z3 = function(r, e = null, t = null, i = null) {
    function n(c) {
        return i !== null ? (c = $d7238066c5de7f1c$var$He(Object.assign(c, i)), i.intent === !0 && (c = c.toVarIntent())) : c = $d7238066c5de7f1c$var$He(c), c;
    }
    let s, a = e, o, g;
    function l(c) {
        let d;
        return a ? d = /[a-z]/i.test(a) ? a + "()" : a : d = r.type, o !== void 0 && c.length < o ? ($d7238066c5de7f1c$var$nt(`TSL: "${d}" parameter length is less than minimum required.`), c.concat(new Array(o - c.length).fill(0))) : g !== void 0 && c.length > g ? ($d7238066c5de7f1c$var$nt(`TSL: "${d}" parameter length exceeds limit.`), c.slice(0, g)) : c;
    }
    return e === null ? s = (...c)=>n(new r(...$d7238066c5de7f1c$var$KC(l(c)))) : t !== null ? (t = $d7238066c5de7f1c$var$He(t), s = (...c)=>n(new r(e, ...$d7238066c5de7f1c$var$KC(l(c)), t))) : s = (...c)=>n(new r(e, ...$d7238066c5de7f1c$var$KC(l(c)))), s.setParameterLength = (...c)=>(c.length === 1 ? o = g = c[0] : c.length === 2 && ([o, g] = c), s), s.setName = (c)=>(a = c, s), s;
}, $d7238066c5de7f1c$var$Pee = function(r, ...e) {
    return $d7238066c5de7f1c$var$He(new r(...$d7238066c5de7f1c$var$KC(e)));
};
class $d7238066c5de7f1c$var$Qee extends $d7238066c5de7f1c$var$Ct {
    constructor(e, t){
        super(), this.shaderNode = e, this.rawInputs = t, this.isShaderCallNodeInternal = !0;
    }
    getNodeType(e) {
        return this.shaderNode.nodeType || this.getOutputNode(e).getNodeType(e);
    }
    getElementType(e) {
        return this.getOutputNode(e).getElementType(e);
    }
    getMemberType(e, t) {
        return this.getOutputNode(e).getMemberType(e, t);
    }
    call(e) {
        const { shaderNode: t, rawInputs: i } = this, n = e.getNodeProperties(t), s = e.getClosestSubBuild(t.subBuilds) || "", a = s || "default";
        if (n[a]) return n[a];
        const o = e.subBuildFn, g = e.fnCall;
        e.subBuildFn = s, e.fnCall = this;
        let l = null;
        if (t.layout) {
            let c = $d7238066c5de7f1c$var$z5.get(e.constructor);
            c === void 0 && (c = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$z5.set(e.constructor, c));
            let d = c.get(t);
            d === void 0 && (d = $d7238066c5de7f1c$var$He(e.buildFunctionNode(t)), c.set(t, d)), e.addInclude(d);
            const p = i ? $d7238066c5de7f1c$var$Oee(i) : null;
            l = $d7238066c5de7f1c$var$He(d.call(p));
        } else {
            const c = new Proxy(e, {
                get: (G, Z, v)=>{
                    let V;
                    return Symbol.iterator === Z ? V = function*() {
                        yield void 0;
                    } : V = Reflect.get(G, Z, v), V;
                }
            }), d = i ? $d7238066c5de7f1c$var$jee(i) : null, p = Array.isArray(i) ? i.length > 0 : i !== null, A = t.jsFunc, y = p || A.length > 1 ? A(d, c) : A(c);
            l = $d7238066c5de7f1c$var$He(y);
        }
        return e.subBuildFn = o, e.fnCall = g, t.once && (n[a] = l), l;
    }
    setupOutput(e) {
        return e.addStack(), e.stack.outputNode = this.call(e), e.removeStack();
    }
    getOutputNode(e) {
        const t = e.getNodeProperties(this), i = e.getSubBuildOutput(this);
        return t[i] = t[i] || this.setupOutput(e), t[i].subBuild = e.getClosestSubBuild(this), t[i];
    }
    build(e, t = null) {
        let i = null;
        const n = e.getBuildStage(), s = e.getNodeProperties(this), a = e.getSubBuildOutput(this), o = this.getOutputNode(e), g = e.fnCall;
        if (e.fnCall = this, n === "setup") {
            const l = e.getSubBuildProperty("initialized", this);
            if (s[l] !== !0 && (s[l] = !0, s[a] = this.getOutputNode(e), s[a].build(e), this.shaderNode.subBuilds)) for (const c of e.chaining){
                const d = e.getDataFromNode(c, "any");
                d.subBuilds = d.subBuilds || /* @__PURE__ */ new Set();
                for (const p of this.shaderNode.subBuilds)d.subBuilds.add(p);
            }
            i = s[a];
        } else n === "analyze" ? o.build(e, t) : n === "generate" && (i = o.build(e, t) || "");
        return e.fnCall = g, i;
    }
}
function $d7238066c5de7f1c$var$Oee(r) {
    let e;
    return $d7238066c5de7f1c$var$hR(r), r[0] && (r[0].isNode || Object.getPrototypeOf(r[0]) !== Object.prototype) ? e = [
        ...r
    ] : e = r[0], e;
}
function $d7238066c5de7f1c$var$jee(r) {
    let e = 0;
    return $d7238066c5de7f1c$var$hR(r), new Proxy(r, {
        get: (t, i, n)=>{
            let s;
            if (i === "length") return s = r.length, s;
            if (Symbol.iterator === i) s = function*() {
                for (const a of r)yield $d7238066c5de7f1c$var$He(a);
            };
            else {
                if (r.length > 0) {
                    if (Object.getPrototypeOf(r[0]) === Object.prototype) {
                        const a = r[0];
                        a[i] === void 0 ? s = a[e++] : s = Reflect.get(a, i, n);
                    } else r[0] instanceof $d7238066c5de7f1c$var$Ct && (r[i] === void 0 ? s = r[e++] : s = Reflect.get(r, i, n));
                } else s = Reflect.get(t, i, n);
                s = $d7238066c5de7f1c$var$He(s);
            }
            return s;
        }
    });
}
class $d7238066c5de7f1c$var$qee extends $d7238066c5de7f1c$var$Ct {
    constructor(e, t){
        super(t), this.jsFunc = e, this.layout = null, this.global = !0, this.once = !1;
    }
    setLayout(e) {
        return this.layout = e, this;
    }
    getLayout() {
        return this.layout;
    }
    call(e = null) {
        return new $d7238066c5de7f1c$var$Qee(this, e);
    }
    setup() {
        return this.call();
    }
}
const $d7238066c5de7f1c$var$$ee = [
    !1,
    !0
], $d7238066c5de7f1c$var$ete = [
    0,
    1,
    2,
    3
], $d7238066c5de7f1c$var$tte = [
    -1,
    -2
], $d7238066c5de7f1c$var$R3 = [
    0.5,
    1.5,
    1 / 3,
    1e-6,
    1e6,
    Math.PI,
    Math.PI * 2,
    1 / Math.PI,
    2 / Math.PI,
    1 / (Math.PI * 2),
    Math.PI / 2
], $d7238066c5de7f1c$var$mL = /* @__PURE__ */ new Map();
for (const r of $d7238066c5de7f1c$var$$ee)$d7238066c5de7f1c$var$mL.set(r, new $d7238066c5de7f1c$var$al(r));
const $d7238066c5de7f1c$var$AL = /* @__PURE__ */ new Map();
for (const r of $d7238066c5de7f1c$var$ete)$d7238066c5de7f1c$var$AL.set(r, new $d7238066c5de7f1c$var$al(r, "uint"));
const $d7238066c5de7f1c$var$bL = new Map([
    ...$d7238066c5de7f1c$var$AL
].map((r)=>new $d7238066c5de7f1c$var$al(r.value, "int")));
for (const r of $d7238066c5de7f1c$var$tte)$d7238066c5de7f1c$var$bL.set(r, new $d7238066c5de7f1c$var$al(r, "int"));
const $d7238066c5de7f1c$var$IR = new Map([
    ...$d7238066c5de7f1c$var$bL
].map((r)=>new $d7238066c5de7f1c$var$al(r.value)));
for (const r of $d7238066c5de7f1c$var$R3)$d7238066c5de7f1c$var$IR.set(r, new $d7238066c5de7f1c$var$al(r));
for (const r of $d7238066c5de7f1c$var$R3)$d7238066c5de7f1c$var$IR.set(-r, new $d7238066c5de7f1c$var$al(-r));
const $d7238066c5de7f1c$var$dR = {
    bool: $d7238066c5de7f1c$var$mL,
    uint: $d7238066c5de7f1c$var$AL,
    ints: $d7238066c5de7f1c$var$bL,
    float: $d7238066c5de7f1c$var$IR
}, $d7238066c5de7f1c$var$k5 = new Map([
    ...$d7238066c5de7f1c$var$mL,
    ...$d7238066c5de7f1c$var$IR
]), $d7238066c5de7f1c$var$w2 = (r, e)=>$d7238066c5de7f1c$var$k5.has(r) ? $d7238066c5de7f1c$var$k5.get(r) : r.isNode === !0 ? r : new $d7238066c5de7f1c$var$al(r, e), $d7238066c5de7f1c$var$ur = function(r, e = null) {
    return (...t)=>{
        for (const n of t)if (n === void 0) return $d7238066c5de7f1c$var$nt(`TSL: Invalid parameter for the type "${r}".`), $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$al(0, r));
        if ((t.length === 0 || ![
            "bool",
            "float",
            "int",
            "uint"
        ].includes(r) && t.every((n)=>{
            const s = typeof n;
            return s !== "object" && s !== "function";
        })) && (t = [
            $d7238066c5de7f1c$var$CL(r, ...t)
        ]), t.length === 1 && e !== null && e.has(t[0])) return $d7238066c5de7f1c$var$yy(e.get(t[0]));
        if (t.length === 1) {
            const n = $d7238066c5de7f1c$var$w2(t[0], r);
            return n.nodeType === r ? $d7238066c5de7f1c$var$yy(n) : $d7238066c5de7f1c$var$yy(new $d7238066c5de7f1c$var$v3(n, r));
        }
        const i = t.map((n)=>$d7238066c5de7f1c$var$w2(n));
        return $d7238066c5de7f1c$var$yy(new $d7238066c5de7f1c$var$Tee(i, r));
    };
}, $d7238066c5de7f1c$var$cB = (r)=>typeof r == "object" && r !== null ? r.value : r, $d7238066c5de7f1c$var$V3 = (r)=>r != null ? r.nodeType || r.convertTo || (typeof r == "string" ? r : null) : null;
function $d7238066c5de7f1c$var$hA(r, e) {
    return new $d7238066c5de7f1c$var$qee(r, e);
}
const $d7238066c5de7f1c$var$He = (r, e = null)=>/* new */ $d7238066c5de7f1c$var$Uee(r, e), $d7238066c5de7f1c$var$yy = (r, e = null)=>/* new */ $d7238066c5de7f1c$var$He(r, e).toVarIntent(), $d7238066c5de7f1c$var$hR = (r, e = null)=>new $d7238066c5de7f1c$var$Dee(r, e), $d7238066c5de7f1c$var$KC = (r, e = null)=>new $d7238066c5de7f1c$var$_ee(r, e), $d7238066c5de7f1c$var$zt = (r, e = null, t = null, i = null)=>new $d7238066c5de7f1c$var$Z3(r, e, t, i), $d7238066c5de7f1c$var$je = (r, ...e)=>new $d7238066c5de7f1c$var$Pee(r, ...e), $d7238066c5de7f1c$var$De = (r, e = null, t = null, i = {})=>new $d7238066c5de7f1c$var$Z3(r, e, t, {
        ...i,
        intent: !0
    });
let $d7238066c5de7f1c$var$ite = 0;
class $d7238066c5de7f1c$var$nte extends $d7238066c5de7f1c$var$Ct {
    constructor(e, t = null){
        super();
        let i = null;
        t !== null && (typeof t == "object" ? i = t.return : (typeof t == "string" ? i = t : $d7238066c5de7f1c$var$nt("TSL: Invalid layout type."), t = null)), this.shaderNode = new $d7238066c5de7f1c$var$hA(e, i), t !== null && this.setLayout(t), this.isFn = !0;
    }
    setLayout(e) {
        const t = this.shaderNode.nodeType;
        if (typeof e.inputs != "object") {
            const i = {
                name: "fn" + $d7238066c5de7f1c$var$ite++,
                type: t,
                inputs: []
            };
            for(const n in e)n !== "return" && i.inputs.push({
                name: n,
                type: e[n]
            });
            e = i;
        }
        return this.shaderNode.setLayout(e), this;
    }
    getNodeType(e) {
        return this.shaderNode.getNodeType(e) || "float";
    }
    call(...e) {
        const t = this.shaderNode.call(e);
        return this.shaderNode.nodeType === "void" && t.toStack(), t.toVarIntent();
    }
    once(e = null) {
        return this.shaderNode.once = !0, this.shaderNode.subBuilds = e, this;
    }
    generate(e) {
        const t = this.getNodeType(e);
        return $d7238066c5de7f1c$var$nt('TSL: "Fn()" was declared but not invoked. Try calling it like "Fn()( ...params )".'), e.generateConst(t);
    }
}
function $d7238066c5de7f1c$var$oe(r, e = null) {
    const t = new $d7238066c5de7f1c$var$nte(r, e);
    return new Proxy(()=>{}, {
        apply (i, n, s) {
            return t.call(...s);
        },
        get (i, n, s) {
            return Reflect.get(t, n, s);
        },
        set (i, n, s, a) {
            return Reflect.set(t, n, s, a);
        }
    });
}
const $d7238066c5de7f1c$var$uB = (r)=>{
    $d7238066c5de7f1c$var$lh = r;
}, $d7238066c5de7f1c$var$yL = ()=>$d7238066c5de7f1c$var$lh, $d7238066c5de7f1c$var$Ht = (...r)=>$d7238066c5de7f1c$var$lh.If(...r), $d7238066c5de7f1c$var$ste = (...r)=>$d7238066c5de7f1c$var$lh.Switch(...r);
function $d7238066c5de7f1c$var$CR(r) {
    return $d7238066c5de7f1c$var$lh && $d7238066c5de7f1c$var$lh.addToStack(r), r;
}
$d7238066c5de7f1c$var$Se("toStack", $d7238066c5de7f1c$var$CR);
const $d7238066c5de7f1c$var$w3 = new $d7238066c5de7f1c$var$ur("color"), $d7238066c5de7f1c$var$J = new $d7238066c5de7f1c$var$ur("float", $d7238066c5de7f1c$var$dR.float), $d7238066c5de7f1c$var$ee = new $d7238066c5de7f1c$var$ur("int", $d7238066c5de7f1c$var$dR.ints), $d7238066c5de7f1c$var$Ue = new $d7238066c5de7f1c$var$ur("uint", $d7238066c5de7f1c$var$dR.uint), $d7238066c5de7f1c$var$nl = new $d7238066c5de7f1c$var$ur("bool", $d7238066c5de7f1c$var$dR.bool), $d7238066c5de7f1c$var$Ne = new $d7238066c5de7f1c$var$ur("vec2"), $d7238066c5de7f1c$var$vr = new $d7238066c5de7f1c$var$ur("ivec2"), $d7238066c5de7f1c$var$W3 = new $d7238066c5de7f1c$var$ur("uvec2"), $d7238066c5de7f1c$var$H3 = new $d7238066c5de7f1c$var$ur("bvec2"), $d7238066c5de7f1c$var$ne = new $d7238066c5de7f1c$var$ur("vec3"), $d7238066c5de7f1c$var$X3 = new $d7238066c5de7f1c$var$ur("ivec3"), $d7238066c5de7f1c$var$n0 = new $d7238066c5de7f1c$var$ur("uvec3"), $d7238066c5de7f1c$var$BL = new $d7238066c5de7f1c$var$ur("bvec3"), $d7238066c5de7f1c$var$Rt = new $d7238066c5de7f1c$var$ur("vec4"), $d7238066c5de7f1c$var$N3 = new $d7238066c5de7f1c$var$ur("ivec4"), $d7238066c5de7f1c$var$L3 = new $d7238066c5de7f1c$var$ur("uvec4"), $d7238066c5de7f1c$var$Y3 = new $d7238066c5de7f1c$var$ur("bvec4"), $d7238066c5de7f1c$var$pR = new $d7238066c5de7f1c$var$ur("mat2"), $d7238066c5de7f1c$var$Fa = new $d7238066c5de7f1c$var$ur("mat3"), $d7238066c5de7f1c$var$xC = new $d7238066c5de7f1c$var$ur("mat4"), $d7238066c5de7f1c$var$rte = (r = "")=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$al(r, "string")), $d7238066c5de7f1c$var$ate = (r)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$al(r, "ArrayBuffer"));
$d7238066c5de7f1c$var$Se("toColor", $d7238066c5de7f1c$var$w3);
$d7238066c5de7f1c$var$Se("toFloat", $d7238066c5de7f1c$var$J);
$d7238066c5de7f1c$var$Se("toInt", $d7238066c5de7f1c$var$ee);
$d7238066c5de7f1c$var$Se("toUint", $d7238066c5de7f1c$var$Ue);
$d7238066c5de7f1c$var$Se("toBool", $d7238066c5de7f1c$var$nl);
$d7238066c5de7f1c$var$Se("toVec2", $d7238066c5de7f1c$var$Ne);
$d7238066c5de7f1c$var$Se("toIVec2", $d7238066c5de7f1c$var$vr);
$d7238066c5de7f1c$var$Se("toUVec2", $d7238066c5de7f1c$var$W3);
$d7238066c5de7f1c$var$Se("toBVec2", $d7238066c5de7f1c$var$H3);
$d7238066c5de7f1c$var$Se("toVec3", $d7238066c5de7f1c$var$ne);
$d7238066c5de7f1c$var$Se("toIVec3", $d7238066c5de7f1c$var$X3);
$d7238066c5de7f1c$var$Se("toUVec3", $d7238066c5de7f1c$var$n0);
$d7238066c5de7f1c$var$Se("toBVec3", $d7238066c5de7f1c$var$BL);
$d7238066c5de7f1c$var$Se("toVec4", $d7238066c5de7f1c$var$Rt);
$d7238066c5de7f1c$var$Se("toIVec4", $d7238066c5de7f1c$var$N3);
$d7238066c5de7f1c$var$Se("toUVec4", $d7238066c5de7f1c$var$L3);
$d7238066c5de7f1c$var$Se("toBVec4", $d7238066c5de7f1c$var$Y3);
$d7238066c5de7f1c$var$Se("toMat2", $d7238066c5de7f1c$var$pR);
$d7238066c5de7f1c$var$Se("toMat3", $d7238066c5de7f1c$var$Fa);
$d7238066c5de7f1c$var$Se("toMat4", $d7238066c5de7f1c$var$xC);
const $d7238066c5de7f1c$var$K3 = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$jC).setParameterLength(2), $d7238066c5de7f1c$var$x3 = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$v3($d7238066c5de7f1c$var$He(r), e)), $d7238066c5de7f1c$var$ote = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$S3($d7238066c5de7f1c$var$He(r), e));
$d7238066c5de7f1c$var$Se("element", $d7238066c5de7f1c$var$K3);
$d7238066c5de7f1c$var$Se("convert", $d7238066c5de7f1c$var$x3);
const $d7238066c5de7f1c$var$gte = (r)=>($d7238066c5de7f1c$var$ze("TSL: append() has been renamed to Stack()."), $d7238066c5de7f1c$var$CR(r));
$d7238066c5de7f1c$var$Se("append", (r)=>($d7238066c5de7f1c$var$ze("TSL: .append() has been renamed to .toStack()."), $d7238066c5de7f1c$var$CR(r)));
class $d7238066c5de7f1c$var$pn extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "PropertyNode";
    }
    /**
   * Constructs a new property node.
   *
   * @param {string} nodeType - The type of the node.
   * @param {?string} [name=null] - The name of the property in the shader.
   * @param {boolean} [varying=false] - Whether this property is a varying or not.
   */ constructor(e, t = null, i = !1){
        super(e), this.name = t, this.varying = i, this.isPropertyNode = !0, this.global = !0;
    }
    customCacheKey() {
        return $d7238066c5de7f1c$var$EB(this.type + ":" + (this.name || "") + ":" + (this.varying ? "1" : "0"));
    }
    getHash(e) {
        return this.name || super.getHash(e);
    }
    generate(e) {
        let t;
        return this.varying === !0 ? (t = e.getVaryingFromNode(this, this.name), t.needsInterpolation = !0) : t = e.getVarFromNode(this, this.name), e.getPropertyName(t);
    }
}
const $d7238066c5de7f1c$var$pI = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$pn(r, e)), $d7238066c5de7f1c$var$IB = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$pn(r, e, !0)), $d7238066c5de7f1c$var$Ei = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "vec4", "DiffuseColor"), $d7238066c5de7f1c$var$W2 = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "vec3", "EmissiveColor"), $d7238066c5de7f1c$var$jc = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Roughness"), $d7238066c5de7f1c$var$dB = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Metalness"), $d7238066c5de7f1c$var$RZ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Clearcoat"), $d7238066c5de7f1c$var$hB = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "ClearcoatRoughness"), $d7238066c5de7f1c$var$WC = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "vec3", "Sheen"), $d7238066c5de7f1c$var$mR = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "SheenRoughness"), $d7238066c5de7f1c$var$AR = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Iridescence"), $d7238066c5de7f1c$var$fL = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "IridescenceIOR"), $d7238066c5de7f1c$var$GL = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "IridescenceThickness"), $d7238066c5de7f1c$var$VZ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "AlphaT"), $d7238066c5de7f1c$var$Jd = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Anisotropy"), $d7238066c5de7f1c$var$Jy = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "vec3", "AnisotropyT"), $d7238066c5de7f1c$var$FC = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "vec3", "AnisotropyB"), $d7238066c5de7f1c$var$_g = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "color", "SpecularColor"), $d7238066c5de7f1c$var$CB = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "SpecularF90"), $d7238066c5de7f1c$var$wZ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Shininess"), $d7238066c5de7f1c$var$ZA = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "vec4", "Output"), $d7238066c5de7f1c$var$ZS = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "dashSize"), $d7238066c5de7f1c$var$H2 = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "gapSize"), $d7238066c5de7f1c$var$lte = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "pointWidth"), $d7238066c5de7f1c$var$Uy = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "IOR"), $d7238066c5de7f1c$var$WZ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Transmission"), $d7238066c5de7f1c$var$vL = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Thickness"), $d7238066c5de7f1c$var$SL = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "AttenuationDistance"), $d7238066c5de7f1c$var$ZL = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "color", "AttenuationColor"), $d7238066c5de7f1c$var$RL = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$pn, "float", "Dispersion");
class $d7238066c5de7f1c$var$F3 extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "UniformGroupNode";
    }
    /**
   * Constructs a new uniform group node.
   *
   * @param {string} name - The name of the uniform group node.
   * @param {boolean} [shared=false] - Whether this uniform group node is shared or not.
   * @param {number} [order=1] - Influences the internal sorting.
   */ constructor(e, t = !1, i = 1){
        super("string"), this.name = e, this.shared = t, this.order = i, this.isUniformGroup = !0;
    }
    serialize(e) {
        super.serialize(e), e.name = this.name, e.version = this.version, e.shared = this.shared;
    }
    deserialize(e) {
        super.deserialize(e), this.name = e.name, this.version = e.version, this.shared = e.shared;
    }
}
const $d7238066c5de7f1c$var$T3 = (r)=>new $d7238066c5de7f1c$var$F3(r), $d7238066c5de7f1c$var$bR = (r, e = 0)=>new $d7238066c5de7f1c$var$F3(r, !0, e), $d7238066c5de7f1c$var$M3 = /* @__PURE__ */ $d7238066c5de7f1c$var$bR("frame"), $d7238066c5de7f1c$var$ft = /* @__PURE__ */ $d7238066c5de7f1c$var$bR("render"), $d7238066c5de7f1c$var$VL = /* @__PURE__ */ $d7238066c5de7f1c$var$T3("object");
class $d7238066c5de7f1c$var$JB extends $d7238066c5de7f1c$var$pL {
    static get type() {
        return "UniformNode";
    }
    /**
   * Constructs a new uniform node.
   *
   * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color, texture).
   * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */ constructor(e, t = null){
        super(e, t), this.isUniformNode = !0, this.name = "", this.groupNode = $d7238066c5de7f1c$var$VL;
    }
    /**
   * Sets the {@link UniformNode#name} property.
   *
   * @param {string} name - The name of the uniform.
   * @return {UniformNode} A reference to this node.
   */ setName(e) {
        return this.name = e, this;
    }
    /**
   * Sets the {@link UniformNode#name} property.
   *
   * @deprecated
   * @param {string} name - The name of the uniform.
   * @return {UniformNode} A reference to this node.
   */ label(e) {
        return $d7238066c5de7f1c$var$ze('TSL: "label()" has been deprecated. Use "setName()" instead.'), this.setName(e);
    }
    /**
   * Sets the {@link UniformNode#groupNode} property.
   *
   * @param {UniformGroupNode} group - The uniform group.
   * @return {UniformNode} A reference to this node.
   */ setGroup(e) {
        return this.groupNode = e, this;
    }
    /**
   * Returns the {@link UniformNode#groupNode}.
   *
   * @return {UniformGroupNode} The uniform group.
   */ getGroup() {
        return this.groupNode;
    }
    /**
   * By default, this method returns the result of {@link Node#getHash} but derived
   * classes might overwrite this method with a different implementation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The uniform hash.
   */ getUniformHash(e) {
        return this.getHash(e);
    }
    onUpdate(e, t) {
        return e = e.bind(this), super.onUpdate((i)=>{
            const n = e(i, this);
            n !== void 0 && (this.value = n);
        }, t);
    }
    getInputType(e) {
        let t = super.getInputType(e);
        return t === "bool" && (t = "uint"), t;
    }
    generate(e, t) {
        const i = this.getNodeType(e), n = this.getUniformHash(e);
        let s = e.getNodeFromHash(n);
        s === void 0 && (e.setHashNode(this, n), s = this);
        const a = s.getInputType(e), o = e.getUniformFromNode(s, a, e.shaderStage, this.name || e.context.nodeName), g = e.getPropertyName(o);
        e.context.nodeName !== void 0 && delete e.context.nodeName;
        let l = g;
        if (i === "bool") {
            const c = e.getDataFromNode(this);
            let d = c.propertyName;
            if (d === void 0) {
                const p = e.getVarFromNode(this, null, "bool");
                d = e.getPropertyName(p), c.propertyName = d, l = e.format(g, a, i), e.addLineFlowCode(`${d} = ${l}`, this);
            }
            l = d;
        }
        return e.format(l, i, t);
    }
}
const $d7238066c5de7f1c$var$yt = (r, e)=>{
    const t = $d7238066c5de7f1c$var$V3(e || r);
    return t === r && (r = $d7238066c5de7f1c$var$CL(t)), r = r && r.isNode === !0 ? r.node && r.node.value || r.value : r, $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$JB(r, t));
};
class $d7238066c5de7f1c$var$E5 extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "ArrayNode";
    }
    /**
   * Constructs a new array node.
   *
   * @param {?string} nodeType - The data type of the elements.
   * @param {number} count - Size of the array.
   * @param {?Array<Node>} [values=null] - Array default values.
   */ constructor(e, t, i = null){
        super(e), this.count = t, this.values = i, this.isArrayNode = !0;
    }
    /**
   * Returns the number of elements in the node array.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {number} The number of elements in the node array.
   */ getArrayCount() {
        return this.count;
    }
    /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */ getNodeType(e) {
        return this.nodeType === null && (this.nodeType = this.values[0].getNodeType(e)), this.nodeType;
    }
    /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */ getElementType(e) {
        return this.getNodeType(e);
    }
    /**
   * This method builds the output node and returns the resulting array as a shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated shader string.
   */ generate(e) {
        const t = this.getNodeType(e);
        return e.generateArray(t, this.count, this.values);
    }
}
const $d7238066c5de7f1c$var$z3 = (...r)=>{
    let e;
    if (r.length === 1) {
        const t = r[0];
        e = new $d7238066c5de7f1c$var$E5(null, t.length, t);
    } else {
        const t = r[0], i = r[1];
        e = new $d7238066c5de7f1c$var$E5(t, i);
    }
    return $d7238066c5de7f1c$var$He(e);
};
$d7238066c5de7f1c$var$Se("toArray", (r, e)=>$d7238066c5de7f1c$var$z3(Array(e).fill(r)));
class $d7238066c5de7f1c$var$cte extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "AssignNode";
    }
    /**
   * Constructs a new assign node.
   *
   * @param {Node} targetNode - The target node.
   * @param {Node} sourceNode - The source type.
   */ constructor(e, t){
        super(), this.targetNode = e, this.sourceNode = t, this.isAssignNode = !0;
    }
    /**
   * Whether this node is used more than once in context of other nodes. This method
   * is overwritten since it always returns `false` (assigns are unique).
   *
   * @return {boolean} A flag that indicates if there is more than one dependency to other nodes. Always `false`.
   */ hasDependencies() {
        return !1;
    }
    getNodeType(e, t) {
        return t !== "void" ? this.targetNode.getNodeType(e) : "void";
    }
    /**
   * Whether a split is required when assigning source to target. This can happen when the component length of
   * target and source data type does not match.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether a split is required when assigning source to target.
   */ needsSplitAssign(e) {
        const { targetNode: t } = this;
        if (e.isAvailable("swizzleAssign") === !1 && t.isSplitNode && t.components.length > 1) {
            const i = e.getTypeLength(t.node.getNodeType(e));
            return $d7238066c5de7f1c$var$OC.join("").slice(0, i) !== t.components;
        }
        return !1;
    }
    setup(e) {
        const { targetNode: t, sourceNode: i } = this, n = t.getScope(), s = e.getNodeProperties(n);
        s.assign = !0;
        const a = e.getNodeProperties(this);
        a.sourceNode = i, a.targetNode = t.context({
            assign: !0
        });
    }
    generate(e, t) {
        const { targetNode: i, sourceNode: n } = e.getNodeProperties(this), s = this.needsSplitAssign(e), a = i.build(e), o = i.getNodeType(e), g = n.build(e, o), l = n.getNodeType(e), c = e.getDataFromNode(this);
        let d;
        if (c.initialized === !0) t !== "void" && (d = a);
        else if (s) {
            const p = e.getVarFromNode(this, null, o), A = e.getPropertyName(p);
            e.addLineFlowCode(`${A} = ${g}`, this);
            const y = i.node, Z = y.node.context({
                assign: !0
            }).build(e);
            for(let v = 0; v < y.components.length; v++){
                const V = y.components[v];
                e.addLineFlowCode(`${Z}.${V} = ${A}[ ${v} ]`, this);
            }
            t !== "void" && (d = a);
        } else d = `${a} = ${g}`, (t === "void" || l === "void") && (e.addLineFlowCode(d, this), t !== "void" && (d = a));
        return c.initialized = !0, e.format(d, o, t);
    }
}
const $d7238066c5de7f1c$var$k3 = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$cte).setParameterLength(2);
$d7238066c5de7f1c$var$Se("assign", $d7238066c5de7f1c$var$k3);
class $d7238066c5de7f1c$var$ute extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "FunctionCallNode";
    }
    /**
   * Constructs a new function call node.
   *
   * @param {?FunctionNode} functionNode - The function node.
   * @param {Object<string, Node>} [parameters={}] - The parameters for the function call.
   */ constructor(e = null, t = {}){
        super(), this.functionNode = e, this.parameters = t;
    }
    /**
   * Sets the parameters of the function call node.
   *
   * @param {Object<string, Node>} parameters - The parameters to set.
   * @return {FunctionCallNode} A reference to this node.
   */ setParameters(e) {
        return this.parameters = e, this;
    }
    /**
   * Returns the parameters of the function call node.
   *
   * @return {Object<string, Node>} The parameters of this node.
   */ getParameters() {
        return this.parameters;
    }
    /**
   * Returns the type of this function call node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @returns {string} The type of this node.
   */ getNodeType(e) {
        return this.functionNode.getNodeType(e);
    }
    /**
   * Returns the function node of this function call node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} [name] - The name of the member.
   * @returns {string} The type of the member.
   */ getMemberType(e, t) {
        return this.functionNode.getMemberType(e, t);
    }
    generate(e) {
        const t = [], i = this.functionNode, n = i.getInputs(e), s = this.parameters, a = (g, l)=>{
            const c = l.type, d = c === "pointer";
            let p;
            return d ? p = "&" + g.build(e) : p = g.build(e, c), p;
        };
        if (Array.isArray(s)) {
            if (s.length > n.length) $d7238066c5de7f1c$var$nt("TSL: The number of provided parameters exceeds the expected number of inputs in 'Fn()'."), s.length = n.length;
            else if (s.length < n.length) for($d7238066c5de7f1c$var$nt("TSL: The number of provided parameters is less than the expected number of inputs in 'Fn()'."); s.length < n.length;)s.push($d7238066c5de7f1c$var$J(0));
            for(let g = 0; g < s.length; g++)t.push(a(s[g], n[g]));
        } else for (const g of n){
            const l = s[g.name];
            l !== void 0 ? t.push(a(l, g)) : ($d7238066c5de7f1c$var$nt(`TSL: Input '${g.name}' not found in 'Fn()'.`), t.push(a($d7238066c5de7f1c$var$J(0), g)));
        }
        return `${i.build(e, "property")}( ${t.join(", ")} )`;
    }
}
const $d7238066c5de7f1c$var$E3 = (r, ...e)=>(e = e.length > 1 || e[0] && e[0].isNode === !0 ? $d7238066c5de7f1c$var$KC(e) : $d7238066c5de7f1c$var$hR(e[0]), new $d7238066c5de7f1c$var$ute($d7238066c5de7f1c$var$He(r), e));
$d7238066c5de7f1c$var$Se("call", $d7238066c5de7f1c$var$E3);
const $d7238066c5de7f1c$var$Ite = {
    "==": "equal",
    "!=": "notEqual",
    "<": "lessThan",
    ">": "greaterThan",
    "<=": "lessThanEqual",
    ">=": "greaterThanEqual",
    "%": "mod"
};
class $d7238066c5de7f1c$var$ls extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "OperatorNode";
    }
    /**
   * Constructs a new operator node.
   *
   * @param {string} op - The operator.
   * @param {Node} aNode - The first input.
   * @param {Node} bNode - The second input.
   * @param {...Node} params - Additional input parameters.
   */ constructor(e, t, i, ...n){
        if (super(), n.length > 0) {
            let s = new $d7238066c5de7f1c$var$ls(e, t, i);
            for(let a = 0; a < n.length - 1; a++)s = new $d7238066c5de7f1c$var$ls(e, s, n[a]);
            t = s, i = n[n.length - 1];
        }
        this.op = e, this.aNode = t, this.bNode = i, this.isOperatorNode = !0;
    }
    /**
   * Returns the operator method name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The output type.
   * @returns {string} The operator method name.
   */ getOperatorMethod(e, t) {
        return e.getMethod($d7238066c5de7f1c$var$Ite[this.op], t);
    }
    /**
   * This method is overwritten since the node type is inferred from the operator
   * and the input node types.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?string} [output=null] - The output type.
   * @return {string} The node type.
   */ getNodeType(e, t = null) {
        const i = this.op, n = this.aNode, s = this.bNode, a = n.getNodeType(e), o = s ? s.getNodeType(e) : null;
        if (a === "void" || o === "void") return t || "void";
        if (i === "%") return a;
        if (i === "~" || i === "&" || i === "|" || i === "^" || i === ">>" || i === "<<") return e.getIntegerType(a);
        if (i === "!" || i === "&&" || i === "||" || i === "^^") return "bool";
        if (i === "==" || i === "!=" || i === "<" || i === ">" || i === "<=" || i === ">=") {
            const g = Math.max(e.getTypeLength(a), e.getTypeLength(o));
            return g > 1 ? `bvec${g}` : "bool";
        } else {
            if (e.isMatrix(a)) {
                if (o === "float") return a;
                if (e.isVector(o)) return e.getVectorFromMatrix(a);
                if (e.isMatrix(o)) return a;
            } else if (e.isMatrix(o)) {
                if (a === "float") return o;
                if (e.isVector(a)) return e.getVectorFromMatrix(o);
            }
            return e.getTypeLength(o) > e.getTypeLength(a) ? o : a;
        }
    }
    generate(e, t) {
        const i = this.op, { aNode: n, bNode: s } = this, a = this.getNodeType(e, t);
        let o = null, g = null;
        a !== "void" ? (o = n.getNodeType(e), g = s ? s.getNodeType(e) : null, i === "<" || i === ">" || i === "<=" || i === ">=" || i === "==" || i === "!=" ? e.isVector(o) ? g = o : e.isVector(g) ? o = g : o !== g && (o = g = "float") : i === ">>" || i === "<<" ? (o = a, g = e.changeComponentType(g, "uint")) : i === "%" ? (o = a, g = e.isInteger(o) && e.isInteger(g) ? g : o) : e.isMatrix(o) ? g === "float" ? g = "float" : e.isVector(g) ? g = e.getVectorFromMatrix(o) : e.isMatrix(g) || (o = g = a) : e.isMatrix(g) ? o === "float" ? o = "float" : e.isVector(o) ? o = e.getVectorFromMatrix(g) : o = g = a : o = g = a) : o = g = a;
        const l = n.build(e, o), c = s ? s.build(e, g) : null, d = e.getFunctionOperator(i);
        if (t !== "void") {
            const p = e.renderer.coordinateSystem === $d7238066c5de7f1c$var$rg;
            if (i === "==" || i === "!=" || i === "<" || i === ">" || i === "<=" || i === ">=") return p ? e.isVector(o) ? e.format(`${this.getOperatorMethod(e, t)}( ${l}, ${c} )`, a, t) : e.format(`( ${l} ${i} ${c} )`, a, t) : e.format(`( ${l} ${i} ${c} )`, a, t);
            if (i === "%") return e.isInteger(g) ? e.format(`( ${l} % ${c} )`, a, t) : e.format(`${this.getOperatorMethod(e, a)}( ${l}, ${c} )`, a, t);
            if (i === "!" || i === "~") return e.format(`(${i}${l})`, o, t);
            if (d) return e.format(`${d}( ${l}, ${c} )`, a, t);
            if (e.isMatrix(o) && g === "float") return e.format(`( ${c} ${i} ${l} )`, a, t);
            if (o === "float" && e.isMatrix(g)) return e.format(`${l} ${i} ${c}`, a, t);
            {
                let A = `( ${l} ${i} ${c} )`;
                return !p && a === "bool" && e.isVector(o) && e.isVector(g) && (A = `all${A}`), e.format(A, a, t);
            }
        } else if (o !== "void") return d ? e.format(`${d}( ${l}, ${c} )`, a, t) : e.isMatrix(o) && g === "float" ? e.format(`${c} ${i} ${l}`, a, t) : e.format(`${l} ${i} ${c}`, a, t);
    }
    serialize(e) {
        super.serialize(e), e.op = this.op;
    }
    deserialize(e) {
        super.deserialize(e), this.op = e.op;
    }
}
const $d7238066c5de7f1c$var$Ps = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "+").setParameterLength(2, 1 / 0).setName("add"), $d7238066c5de7f1c$var$wi = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "-").setParameterLength(2, 1 / 0).setName("sub"), $d7238066c5de7f1c$var$Et = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "*").setParameterLength(2, 1 / 0).setName("mul"), $d7238066c5de7f1c$var$cg = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "/").setParameterLength(2, 1 / 0).setName("div"), $d7238066c5de7f1c$var$UB = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "%").setParameterLength(2).setName("mod"), $d7238066c5de7f1c$var$wL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "==").setParameterLength(2).setName("equal"), $d7238066c5de7f1c$var$J3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "!=").setParameterLength(2).setName("notEqual"), $d7238066c5de7f1c$var$U3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "<").setParameterLength(2).setName("lessThan"), $d7238066c5de7f1c$var$WL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, ">").setParameterLength(2).setName("greaterThan"), $d7238066c5de7f1c$var$D3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "<=").setParameterLength(2).setName("lessThanEqual"), $d7238066c5de7f1c$var$_3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, ">=").setParameterLength(2).setName("greaterThanEqual"), $d7238066c5de7f1c$var$P3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "&&").setParameterLength(2, 1 / 0).setName("and"), $d7238066c5de7f1c$var$Q3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "||").setParameterLength(2, 1 / 0).setName("or"), $d7238066c5de7f1c$var$O3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "!").setParameterLength(1).setName("not"), $d7238066c5de7f1c$var$j3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "^^").setParameterLength(2).setName("xor"), $d7238066c5de7f1c$var$q3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "&").setParameterLength(2).setName("bitAnd"), $d7238066c5de7f1c$var$$3 = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "~").setParameterLength(1).setName("bitNot"), $d7238066c5de7f1c$var$eE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "|").setParameterLength(2).setName("bitOr"), $d7238066c5de7f1c$var$tE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "^").setParameterLength(2).setName("bitXor"), $d7238066c5de7f1c$var$iE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, "<<").setParameterLength(2).setName("shiftLeft"), $d7238066c5de7f1c$var$nE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$ls, ">>").setParameterLength(2).setName("shiftRight"), $d7238066c5de7f1c$var$sE = $d7238066c5de7f1c$var$oe(([r])=>(r.addAssign(1), r)), $d7238066c5de7f1c$var$rE = $d7238066c5de7f1c$var$oe(([r])=>(r.subAssign(1), r)), $d7238066c5de7f1c$var$aE = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ee(r).toConst();
    return r.addAssign(1), e;
}), $d7238066c5de7f1c$var$oE = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ee(r).toConst();
    return r.subAssign(1), e;
});
$d7238066c5de7f1c$var$Se("add", $d7238066c5de7f1c$var$Ps);
$d7238066c5de7f1c$var$Se("sub", $d7238066c5de7f1c$var$wi);
$d7238066c5de7f1c$var$Se("mul", $d7238066c5de7f1c$var$Et);
$d7238066c5de7f1c$var$Se("div", $d7238066c5de7f1c$var$cg);
$d7238066c5de7f1c$var$Se("mod", $d7238066c5de7f1c$var$UB);
$d7238066c5de7f1c$var$Se("equal", $d7238066c5de7f1c$var$wL);
$d7238066c5de7f1c$var$Se("notEqual", $d7238066c5de7f1c$var$J3);
$d7238066c5de7f1c$var$Se("lessThan", $d7238066c5de7f1c$var$U3);
$d7238066c5de7f1c$var$Se("greaterThan", $d7238066c5de7f1c$var$WL);
$d7238066c5de7f1c$var$Se("lessThanEqual", $d7238066c5de7f1c$var$D3);
$d7238066c5de7f1c$var$Se("greaterThanEqual", $d7238066c5de7f1c$var$_3);
$d7238066c5de7f1c$var$Se("and", $d7238066c5de7f1c$var$P3);
$d7238066c5de7f1c$var$Se("or", $d7238066c5de7f1c$var$Q3);
$d7238066c5de7f1c$var$Se("not", $d7238066c5de7f1c$var$O3);
$d7238066c5de7f1c$var$Se("xor", $d7238066c5de7f1c$var$j3);
$d7238066c5de7f1c$var$Se("bitAnd", $d7238066c5de7f1c$var$q3);
$d7238066c5de7f1c$var$Se("bitNot", $d7238066c5de7f1c$var$$3);
$d7238066c5de7f1c$var$Se("bitOr", $d7238066c5de7f1c$var$eE);
$d7238066c5de7f1c$var$Se("bitXor", $d7238066c5de7f1c$var$tE);
$d7238066c5de7f1c$var$Se("shiftLeft", $d7238066c5de7f1c$var$iE);
$d7238066c5de7f1c$var$Se("shiftRight", $d7238066c5de7f1c$var$nE);
$d7238066c5de7f1c$var$Se("incrementBefore", $d7238066c5de7f1c$var$sE);
$d7238066c5de7f1c$var$Se("decrementBefore", $d7238066c5de7f1c$var$rE);
$d7238066c5de7f1c$var$Se("increment", $d7238066c5de7f1c$var$aE);
$d7238066c5de7f1c$var$Se("decrement", $d7238066c5de7f1c$var$oE);
const $d7238066c5de7f1c$var$gE = (r, e)=>($d7238066c5de7f1c$var$ze('TSL: "modInt()" is deprecated. Use "mod( int( ... ) )" instead.'), $d7238066c5de7f1c$var$UB($d7238066c5de7f1c$var$ee(r), $d7238066c5de7f1c$var$ee(e)));
$d7238066c5de7f1c$var$Se("modInt", $d7238066c5de7f1c$var$gE);
class $d7238066c5de7f1c$var$Ie extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "MathNode";
    }
    /**
   * Constructs a new math node.
   *
   * @param {string} method - The method name.
   * @param {Node} aNode - The first input.
   * @param {?Node} [bNode=null] - The second input.
   * @param {?Node} [cNode=null] - The third input.
   */ constructor(e, t, i = null, n = null){
        if (super(), (e === $d7238066c5de7f1c$var$Ie.MAX || e === $d7238066c5de7f1c$var$Ie.MIN) && arguments.length > 3) {
            let s = new $d7238066c5de7f1c$var$Ie(e, t, i);
            for(let a = 2; a < arguments.length - 1; a++)s = new $d7238066c5de7f1c$var$Ie(e, s, arguments[a]);
            t = s, i = arguments[arguments.length - 1], n = null;
        }
        this.method = e, this.aNode = t, this.bNode = i, this.cNode = n, this.isMathNode = !0;
    }
    /**
   * The input type is inferred from the node types of the input nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType(e) {
        const t = this.aNode.getNodeType(e), i = this.bNode ? this.bNode.getNodeType(e) : null, n = this.cNode ? this.cNode.getNodeType(e) : null, s = e.isMatrix(t) ? 0 : e.getTypeLength(t), a = e.isMatrix(i) ? 0 : e.getTypeLength(i), o = e.isMatrix(n) ? 0 : e.getTypeLength(n);
        return s > a && s > o ? t : a > o ? i : o > s ? n : t;
    }
    /**
   * The selected method as well as the input type determine the node type of this node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        const t = this.method;
        return t === $d7238066c5de7f1c$var$Ie.LENGTH || t === $d7238066c5de7f1c$var$Ie.DISTANCE || t === $d7238066c5de7f1c$var$Ie.DOT ? "float" : t === $d7238066c5de7f1c$var$Ie.CROSS ? "vec3" : t === $d7238066c5de7f1c$var$Ie.ALL || t === $d7238066c5de7f1c$var$Ie.ANY ? "bool" : t === $d7238066c5de7f1c$var$Ie.EQUALS ? e.changeComponentType(this.aNode.getNodeType(e), "bool") : this.getInputType(e);
    }
    setup(e) {
        const { aNode: t, bNode: i, method: n } = this;
        let s = null;
        if (n === $d7238066c5de7f1c$var$Ie.ONE_MINUS) s = $d7238066c5de7f1c$var$wi(1, t);
        else if (n === $d7238066c5de7f1c$var$Ie.RECIPROCAL) s = $d7238066c5de7f1c$var$cg(1, t);
        else if (n === $d7238066c5de7f1c$var$Ie.DIFFERENCE) s = $d7238066c5de7f1c$var$Wn($d7238066c5de7f1c$var$wi(t, i));
        else if (n === $d7238066c5de7f1c$var$Ie.TRANSFORM_DIRECTION) {
            let a = t, o = i;
            e.isMatrix(a.getNodeType(e)) ? o = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$ne(o), 0) : a = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$ne(a), 0);
            const g = $d7238066c5de7f1c$var$Et(a, o).xyz;
            s = $d7238066c5de7f1c$var$wo(g);
        }
        return s !== null ? s : super.setup(e);
    }
    generate(e, t) {
        if (e.getNodeProperties(this).outputNode) return super.generate(e, t);
        let n = this.method;
        const s = this.getNodeType(e), a = this.getInputType(e), o = this.aNode, g = this.bNode, l = this.cNode, c = e.renderer.coordinateSystem;
        if (n === $d7238066c5de7f1c$var$Ie.NEGATE) return e.format("( - " + o.build(e, a) + " )", s, t);
        {
            const d = [];
            return n === $d7238066c5de7f1c$var$Ie.CROSS ? d.push(o.build(e, s), g.build(e, s)) : c === $d7238066c5de7f1c$var$rg && n === $d7238066c5de7f1c$var$Ie.STEP ? d.push(o.build(e, e.getTypeLength(o.getNodeType(e)) === 1 ? "float" : a), g.build(e, a)) : c === $d7238066c5de7f1c$var$rg && (n === $d7238066c5de7f1c$var$Ie.MIN || n === $d7238066c5de7f1c$var$Ie.MAX) ? d.push(o.build(e, a), g.build(e, e.getTypeLength(g.getNodeType(e)) === 1 ? "float" : a)) : n === $d7238066c5de7f1c$var$Ie.REFRACT ? d.push(o.build(e, a), g.build(e, a), l.build(e, "float")) : n === $d7238066c5de7f1c$var$Ie.MIX ? d.push(o.build(e, a), g.build(e, a), l.build(e, e.getTypeLength(l.getNodeType(e)) === 1 ? "float" : a)) : (c === $d7238066c5de7f1c$var$uu && n === $d7238066c5de7f1c$var$Ie.ATAN && g !== null && (n = "atan2"), e.shaderStage !== "fragment" && (n === $d7238066c5de7f1c$var$Ie.DFDX || n === $d7238066c5de7f1c$var$Ie.DFDY) && ($d7238066c5de7f1c$var$ze(`TSL: '${n}' is not supported in the ${e.shaderStage} stage.`), n = "/*" + n + "*/"), d.push(o.build(e, a)), g !== null && d.push(g.build(e, a)), l !== null && d.push(l.build(e, a))), e.format(`${e.getMethod(n, s)}( ${d.join(", ")} )`, s, t);
        }
    }
    serialize(e) {
        super.serialize(e), e.method = this.method;
    }
    deserialize(e) {
        super.deserialize(e), this.method = e.method;
    }
}
$d7238066c5de7f1c$var$Ie.ALL = "all";
$d7238066c5de7f1c$var$Ie.ANY = "any";
$d7238066c5de7f1c$var$Ie.RADIANS = "radians";
$d7238066c5de7f1c$var$Ie.DEGREES = "degrees";
$d7238066c5de7f1c$var$Ie.EXP = "exp";
$d7238066c5de7f1c$var$Ie.EXP2 = "exp2";
$d7238066c5de7f1c$var$Ie.LOG = "log";
$d7238066c5de7f1c$var$Ie.LOG2 = "log2";
$d7238066c5de7f1c$var$Ie.SQRT = "sqrt";
$d7238066c5de7f1c$var$Ie.INVERSE_SQRT = "inversesqrt";
$d7238066c5de7f1c$var$Ie.FLOOR = "floor";
$d7238066c5de7f1c$var$Ie.CEIL = "ceil";
$d7238066c5de7f1c$var$Ie.NORMALIZE = "normalize";
$d7238066c5de7f1c$var$Ie.FRACT = "fract";
$d7238066c5de7f1c$var$Ie.SIN = "sin";
$d7238066c5de7f1c$var$Ie.COS = "cos";
$d7238066c5de7f1c$var$Ie.TAN = "tan";
$d7238066c5de7f1c$var$Ie.ASIN = "asin";
$d7238066c5de7f1c$var$Ie.ACOS = "acos";
$d7238066c5de7f1c$var$Ie.ATAN = "atan";
$d7238066c5de7f1c$var$Ie.ABS = "abs";
$d7238066c5de7f1c$var$Ie.SIGN = "sign";
$d7238066c5de7f1c$var$Ie.LENGTH = "length";
$d7238066c5de7f1c$var$Ie.NEGATE = "negate";
$d7238066c5de7f1c$var$Ie.ONE_MINUS = "oneMinus";
$d7238066c5de7f1c$var$Ie.DFDX = "dFdx";
$d7238066c5de7f1c$var$Ie.DFDY = "dFdy";
$d7238066c5de7f1c$var$Ie.ROUND = "round";
$d7238066c5de7f1c$var$Ie.RECIPROCAL = "reciprocal";
$d7238066c5de7f1c$var$Ie.TRUNC = "trunc";
$d7238066c5de7f1c$var$Ie.FWIDTH = "fwidth";
$d7238066c5de7f1c$var$Ie.TRANSPOSE = "transpose";
$d7238066c5de7f1c$var$Ie.DETERMINANT = "determinant";
$d7238066c5de7f1c$var$Ie.INVERSE = "inverse";
$d7238066c5de7f1c$var$Ie.EQUALS = "equals";
$d7238066c5de7f1c$var$Ie.MIN = "min";
$d7238066c5de7f1c$var$Ie.MAX = "max";
$d7238066c5de7f1c$var$Ie.STEP = "step";
$d7238066c5de7f1c$var$Ie.REFLECT = "reflect";
$d7238066c5de7f1c$var$Ie.DISTANCE = "distance";
$d7238066c5de7f1c$var$Ie.DIFFERENCE = "difference";
$d7238066c5de7f1c$var$Ie.DOT = "dot";
$d7238066c5de7f1c$var$Ie.CROSS = "cross";
$d7238066c5de7f1c$var$Ie.POW = "pow";
$d7238066c5de7f1c$var$Ie.TRANSFORM_DIRECTION = "transformDirection";
$d7238066c5de7f1c$var$Ie.MIX = "mix";
$d7238066c5de7f1c$var$Ie.CLAMP = "clamp";
$d7238066c5de7f1c$var$Ie.REFRACT = "refract";
$d7238066c5de7f1c$var$Ie.SMOOTHSTEP = "smoothstep";
$d7238066c5de7f1c$var$Ie.FACEFORWARD = "faceforward";
const $d7238066c5de7f1c$var$HL = /* @__PURE__ */ $d7238066c5de7f1c$var$J(1e-6), $d7238066c5de7f1c$var$dte = /* @__PURE__ */ $d7238066c5de7f1c$var$J(1e6), $d7238066c5de7f1c$var$HZ = /* @__PURE__ */ $d7238066c5de7f1c$var$J(Math.PI), $d7238066c5de7f1c$var$hte = /* @__PURE__ */ $d7238066c5de7f1c$var$J(Math.PI * 2), $d7238066c5de7f1c$var$Cte = /* @__PURE__ */ $d7238066c5de7f1c$var$J(Math.PI * 2), $d7238066c5de7f1c$var$pte = /* @__PURE__ */ $d7238066c5de7f1c$var$J(Math.PI * 0.5), $d7238066c5de7f1c$var$lE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ALL).setParameterLength(1), $d7238066c5de7f1c$var$cE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ANY).setParameterLength(1), $d7238066c5de7f1c$var$uE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.RADIANS).setParameterLength(1), $d7238066c5de7f1c$var$IE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DEGREES).setParameterLength(1), $d7238066c5de7f1c$var$XL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.EXP).setParameterLength(1), $d7238066c5de7f1c$var$zA = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.EXP2).setParameterLength(1), $d7238066c5de7f1c$var$yR = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.LOG).setParameterLength(1), $d7238066c5de7f1c$var$su = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.LOG2).setParameterLength(1), $d7238066c5de7f1c$var$So = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.SQRT).setParameterLength(1), $d7238066c5de7f1c$var$NL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.INVERSE_SQRT).setParameterLength(1), $d7238066c5de7f1c$var$ru = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.FLOOR).setParameterLength(1), $d7238066c5de7f1c$var$BR = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.CEIL).setParameterLength(1), $d7238066c5de7f1c$var$wo = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.NORMALIZE).setParameterLength(1), $d7238066c5de7f1c$var$ec = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.FRACT).setParameterLength(1), $d7238066c5de7f1c$var$Go = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.SIN).setParameterLength(1), $d7238066c5de7f1c$var$_c = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.COS).setParameterLength(1), $d7238066c5de7f1c$var$dE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.TAN).setParameterLength(1), $d7238066c5de7f1c$var$hE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ASIN).setParameterLength(1), $d7238066c5de7f1c$var$LL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ACOS).setParameterLength(1), $d7238066c5de7f1c$var$fR = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ATAN).setParameterLength(1, 2), $d7238066c5de7f1c$var$Wn = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ABS).setParameterLength(1), $d7238066c5de7f1c$var$pB = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.SIGN).setParameterLength(1), $d7238066c5de7f1c$var$au = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.LENGTH).setParameterLength(1), $d7238066c5de7f1c$var$CE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.NEGATE).setParameterLength(1), $d7238066c5de7f1c$var$pE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ONE_MINUS).setParameterLength(1), $d7238066c5de7f1c$var$YL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DFDX).setParameterLength(1), $d7238066c5de7f1c$var$KL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DFDY).setParameterLength(1), $d7238066c5de7f1c$var$mE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.ROUND).setParameterLength(1), $d7238066c5de7f1c$var$AE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.RECIPROCAL).setParameterLength(1), $d7238066c5de7f1c$var$xL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.TRUNC).setParameterLength(1), $d7238066c5de7f1c$var$FL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.FWIDTH).setParameterLength(1), $d7238066c5de7f1c$var$bE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.TRANSPOSE).setParameterLength(1), $d7238066c5de7f1c$var$yE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DETERMINANT).setParameterLength(1), $d7238066c5de7f1c$var$BE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.INVERSE).setParameterLength(1), $d7238066c5de7f1c$var$fE = (r, e)=>($d7238066c5de7f1c$var$ze('TSL: "equals" is deprecated. Use "equal" inside a vector instead, like: "bvec*( equal( ... ) )"'), $d7238066c5de7f1c$var$wL(r, e)), $d7238066c5de7f1c$var$Xo = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.MIN).setParameterLength(2, 1 / 0), $d7238066c5de7f1c$var$En = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.MAX).setParameterLength(2, 1 / 0), $d7238066c5de7f1c$var$GR = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.STEP).setParameterLength(2), $d7238066c5de7f1c$var$GE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.REFLECT).setParameterLength(2), $d7238066c5de7f1c$var$vE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DISTANCE).setParameterLength(2), $d7238066c5de7f1c$var$SE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DIFFERENCE).setParameterLength(2), $d7238066c5de7f1c$var$tc = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.DOT).setParameterLength(2), $d7238066c5de7f1c$var$kC = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.CROSS).setParameterLength(2), $d7238066c5de7f1c$var$qg = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.POW).setParameterLength(2), $d7238066c5de7f1c$var$TL = (r)=>$d7238066c5de7f1c$var$Et(r, r), $d7238066c5de7f1c$var$ZE = (r)=>$d7238066c5de7f1c$var$Et(r, r, r), $d7238066c5de7f1c$var$ML = (r)=>$d7238066c5de7f1c$var$Et(r, r, r, r), $d7238066c5de7f1c$var$RE = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.TRANSFORM_DIRECTION).setParameterLength(2), $d7238066c5de7f1c$var$VE = (r)=>$d7238066c5de7f1c$var$Et($d7238066c5de7f1c$var$pB(r), $d7238066c5de7f1c$var$qg($d7238066c5de7f1c$var$Wn(r), 1 / 3)), $d7238066c5de7f1c$var$zL = (r)=>$d7238066c5de7f1c$var$tc(r, r), $d7238066c5de7f1c$var$qi = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.MIX).setParameterLength(3), $d7238066c5de7f1c$var$sl = (r, e = 0, t = 1)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Ie($d7238066c5de7f1c$var$Ie.CLAMP, $d7238066c5de7f1c$var$He(r), $d7238066c5de7f1c$var$He(e), $d7238066c5de7f1c$var$He(t))), $d7238066c5de7f1c$var$kL = (r)=>$d7238066c5de7f1c$var$sl(r), $d7238066c5de7f1c$var$EL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.REFRACT).setParameterLength(3), $d7238066c5de7f1c$var$ic = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.SMOOTHSTEP).setParameterLength(3), $d7238066c5de7f1c$var$JL = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$Ie, $d7238066c5de7f1c$var$Ie.FACEFORWARD).setParameterLength(3), $d7238066c5de7f1c$var$wE = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const i = 43758.5453, n = $d7238066c5de7f1c$var$tc(r.xy, $d7238066c5de7f1c$var$Ne(12.9898, 78.233)), s = $d7238066c5de7f1c$var$UB(n, $d7238066c5de7f1c$var$HZ);
    return $d7238066c5de7f1c$var$ec($d7238066c5de7f1c$var$Go(s).mul(i));
}), $d7238066c5de7f1c$var$WE = (r, e, t)=>$d7238066c5de7f1c$var$qi(e, t, r), $d7238066c5de7f1c$var$HE = (r, e, t)=>$d7238066c5de7f1c$var$ic(e, t, r), $d7238066c5de7f1c$var$XE = (r, e)=>$d7238066c5de7f1c$var$GR(e, r), $d7238066c5de7f1c$var$NE = (r, e)=>($d7238066c5de7f1c$var$ze('TSL: "atan2" is overloaded. Use "atan" instead.'), $d7238066c5de7f1c$var$fR(r, e)), $d7238066c5de7f1c$var$mte = $d7238066c5de7f1c$var$JL, $d7238066c5de7f1c$var$Ate = $d7238066c5de7f1c$var$NL;
$d7238066c5de7f1c$var$Se("all", $d7238066c5de7f1c$var$lE);
$d7238066c5de7f1c$var$Se("any", $d7238066c5de7f1c$var$cE);
$d7238066c5de7f1c$var$Se("equals", $d7238066c5de7f1c$var$fE);
$d7238066c5de7f1c$var$Se("radians", $d7238066c5de7f1c$var$uE);
$d7238066c5de7f1c$var$Se("degrees", $d7238066c5de7f1c$var$IE);
$d7238066c5de7f1c$var$Se("exp", $d7238066c5de7f1c$var$XL);
$d7238066c5de7f1c$var$Se("exp2", $d7238066c5de7f1c$var$zA);
$d7238066c5de7f1c$var$Se("log", $d7238066c5de7f1c$var$yR);
$d7238066c5de7f1c$var$Se("log2", $d7238066c5de7f1c$var$su);
$d7238066c5de7f1c$var$Se("sqrt", $d7238066c5de7f1c$var$So);
$d7238066c5de7f1c$var$Se("inverseSqrt", $d7238066c5de7f1c$var$NL);
$d7238066c5de7f1c$var$Se("floor", $d7238066c5de7f1c$var$ru);
$d7238066c5de7f1c$var$Se("ceil", $d7238066c5de7f1c$var$BR);
$d7238066c5de7f1c$var$Se("normalize", $d7238066c5de7f1c$var$wo);
$d7238066c5de7f1c$var$Se("fract", $d7238066c5de7f1c$var$ec);
$d7238066c5de7f1c$var$Se("sin", $d7238066c5de7f1c$var$Go);
$d7238066c5de7f1c$var$Se("cos", $d7238066c5de7f1c$var$_c);
$d7238066c5de7f1c$var$Se("tan", $d7238066c5de7f1c$var$dE);
$d7238066c5de7f1c$var$Se("asin", $d7238066c5de7f1c$var$hE);
$d7238066c5de7f1c$var$Se("acos", $d7238066c5de7f1c$var$LL);
$d7238066c5de7f1c$var$Se("atan", $d7238066c5de7f1c$var$fR);
$d7238066c5de7f1c$var$Se("abs", $d7238066c5de7f1c$var$Wn);
$d7238066c5de7f1c$var$Se("sign", $d7238066c5de7f1c$var$pB);
$d7238066c5de7f1c$var$Se("length", $d7238066c5de7f1c$var$au);
$d7238066c5de7f1c$var$Se("lengthSq", $d7238066c5de7f1c$var$zL);
$d7238066c5de7f1c$var$Se("negate", $d7238066c5de7f1c$var$CE);
$d7238066c5de7f1c$var$Se("oneMinus", $d7238066c5de7f1c$var$pE);
$d7238066c5de7f1c$var$Se("dFdx", $d7238066c5de7f1c$var$YL);
$d7238066c5de7f1c$var$Se("dFdy", $d7238066c5de7f1c$var$KL);
$d7238066c5de7f1c$var$Se("round", $d7238066c5de7f1c$var$mE);
$d7238066c5de7f1c$var$Se("reciprocal", $d7238066c5de7f1c$var$AE);
$d7238066c5de7f1c$var$Se("trunc", $d7238066c5de7f1c$var$xL);
$d7238066c5de7f1c$var$Se("fwidth", $d7238066c5de7f1c$var$FL);
$d7238066c5de7f1c$var$Se("atan2", $d7238066c5de7f1c$var$NE);
$d7238066c5de7f1c$var$Se("min", $d7238066c5de7f1c$var$Xo);
$d7238066c5de7f1c$var$Se("max", $d7238066c5de7f1c$var$En);
$d7238066c5de7f1c$var$Se("step", $d7238066c5de7f1c$var$XE);
$d7238066c5de7f1c$var$Se("reflect", $d7238066c5de7f1c$var$GE);
$d7238066c5de7f1c$var$Se("distance", $d7238066c5de7f1c$var$vE);
$d7238066c5de7f1c$var$Se("dot", $d7238066c5de7f1c$var$tc);
$d7238066c5de7f1c$var$Se("cross", $d7238066c5de7f1c$var$kC);
$d7238066c5de7f1c$var$Se("pow", $d7238066c5de7f1c$var$qg);
$d7238066c5de7f1c$var$Se("pow2", $d7238066c5de7f1c$var$TL);
$d7238066c5de7f1c$var$Se("pow3", $d7238066c5de7f1c$var$ZE);
$d7238066c5de7f1c$var$Se("pow4", $d7238066c5de7f1c$var$ML);
$d7238066c5de7f1c$var$Se("transformDirection", $d7238066c5de7f1c$var$RE);
$d7238066c5de7f1c$var$Se("mix", $d7238066c5de7f1c$var$WE);
$d7238066c5de7f1c$var$Se("clamp", $d7238066c5de7f1c$var$sl);
$d7238066c5de7f1c$var$Se("refract", $d7238066c5de7f1c$var$EL);
$d7238066c5de7f1c$var$Se("smoothstep", $d7238066c5de7f1c$var$HE);
$d7238066c5de7f1c$var$Se("faceForward", $d7238066c5de7f1c$var$JL);
$d7238066c5de7f1c$var$Se("difference", $d7238066c5de7f1c$var$SE);
$d7238066c5de7f1c$var$Se("saturate", $d7238066c5de7f1c$var$kL);
$d7238066c5de7f1c$var$Se("cbrt", $d7238066c5de7f1c$var$VE);
$d7238066c5de7f1c$var$Se("transpose", $d7238066c5de7f1c$var$bE);
$d7238066c5de7f1c$var$Se("determinant", $d7238066c5de7f1c$var$yE);
$d7238066c5de7f1c$var$Se("inverse", $d7238066c5de7f1c$var$BE);
$d7238066c5de7f1c$var$Se("rand", $d7238066c5de7f1c$var$wE);
class $d7238066c5de7f1c$var$bte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ConditionalNode";
    }
    /**
   * Constructs a new conditional node.
   *
   * @param {Node} condNode - The node that defines the condition.
   * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
   * @param {?Node} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
   */ constructor(e, t, i = null){
        super(), this.condNode = e, this.ifNode = t, this.elseNode = i;
    }
    /**
   * This method is overwritten since the node type is inferred from the if/else
   * nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        const { ifNode: t, elseNode: i } = e.getNodeProperties(this);
        if (t === void 0) return e.flowBuildStage(this, "setup"), this.getNodeType(e);
        const n = t.getNodeType(e);
        if (i !== null) {
            const s = i.getNodeType(e);
            if (e.getTypeLength(s) > e.getTypeLength(n)) return s;
        }
        return n;
    }
    setup(e) {
        const t = this.condNode, i = this.ifNode.isolate(), n = this.elseNode ? this.elseNode.isolate() : null, s = e.context.nodeBlock;
        e.getDataFromNode(i).parentNodeBlock = s, n !== null && (e.getDataFromNode(n).parentNodeBlock = s);
        const a = e.context.uniformFlow, o = e.getNodeProperties(this);
        o.condNode = t, o.ifNode = a ? i : i.context({
            nodeBlock: i
        }), o.elseNode = n ? a ? n : n.context({
            nodeBlock: n
        }) : null;
    }
    generate(e, t) {
        const i = this.getNodeType(e), n = e.getDataFromNode(this);
        if (n.nodeProperty !== void 0) return n.nodeProperty;
        const { condNode: s, ifNode: a, elseNode: o } = e.getNodeProperties(this), g = e.currentFunctionNode, l = t !== "void", c = l ? $d7238066c5de7f1c$var$pI(i).build(e) : "";
        n.nodeProperty = c;
        const d = s.build(e, "bool");
        if (e.context.uniformFlow && o !== null) {
            const y = a.build(e, i), G = o.build(e, i), Z = e.getTernary(d, y, G);
            return e.format(Z, i, t);
        }
        e.addFlowCode(`
${e.tab}if ( ${d} ) {

`).addFlowTab();
        let A = a.build(e, i);
        if (A && (l ? A = c + " = " + A + ";" : (A = "return " + A + ";", g === null && ($d7238066c5de7f1c$var$ze("TSL: Return statement used in an inline 'Fn()'. Define a layout struct to allow return values."), A = "// " + A))), e.removeFlowTab().addFlowCode(e.tab + "	" + A + `

` + e.tab + "}"), o !== null) {
            e.addFlowCode(` else {

`).addFlowTab();
            let y = o.build(e, i);
            y && (l ? y = c + " = " + y + ";" : (y = "return " + y + ";", g === null && ($d7238066c5de7f1c$var$ze("TSL: Return statement used in an inline 'Fn()'. Define a layout struct to allow return values."), y = "// " + y))), e.removeFlowTab().addFlowCode(e.tab + "	" + y + `

` + e.tab + `}

`);
        } else e.addFlowCode(`

`);
        return e.format(c, i, t);
    }
}
const $d7238066c5de7f1c$var$or = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$bte).setParameterLength(2, 3);
$d7238066c5de7f1c$var$Se("select", $d7238066c5de7f1c$var$or);
class $d7238066c5de7f1c$var$LE extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ContextNode";
    }
    /**
   * Constructs a new context node.
   *
   * @param {Node} node - The node whose context should be modified.
   * @param {Object} [value={}] - The modified context data.
   */ constructor(e, t = {}){
        super(), this.isContextNode = !0, this.node = e, this.value = t;
    }
    /**
   * This method is overwritten to ensure it returns the reference to {@link ContextNode#node}.
   *
   * @return {Node} A reference to {@link ContextNode#node}.
   */ getScope() {
        return this.node.getScope();
    }
    /**
   * This method is overwritten to ensure it returns the type of {@link ContextNode#node}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.node.getNodeType(e);
    }
    /**
   * This method is overwritten to ensure it returns the member type of {@link ContextNode#node}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The member name.
   * @returns {string} The member type.
   */ getMemberType(e, t) {
        return this.node.getMemberType(e, t);
    }
    analyze(e) {
        const t = e.addContext(this.value);
        this.node.build(e), e.setContext(t);
    }
    setup(e) {
        const t = e.addContext(this.value);
        this.node.build(e), e.setContext(t);
    }
    generate(e, t) {
        const i = e.addContext(this.value), n = this.node.build(e, t);
        return e.setContext(i), n;
    }
}
const $d7238066c5de7f1c$var$DB = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$LE).setParameterLength(1, 2), $d7238066c5de7f1c$var$YE = (r)=>$d7238066c5de7f1c$var$DB(r, {
        uniformFlow: !0
    }), $d7238066c5de7f1c$var$UL = (r, e)=>$d7238066c5de7f1c$var$DB(r, {
        nodeName: e
    });
function $d7238066c5de7f1c$var$KE(r, e) {
    return $d7238066c5de7f1c$var$ze('TSL: "label()" has been deprecated. Use "setName()" instead.'), $d7238066c5de7f1c$var$UL(r, e);
}
$d7238066c5de7f1c$var$Se("context", $d7238066c5de7f1c$var$DB);
$d7238066c5de7f1c$var$Se("label", $d7238066c5de7f1c$var$KE);
$d7238066c5de7f1c$var$Se("uniformFlow", $d7238066c5de7f1c$var$YE);
$d7238066c5de7f1c$var$Se("setName", $d7238066c5de7f1c$var$UL);
class $d7238066c5de7f1c$var$RS extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "VarNode";
    }
    /**
   * Constructs a new variable node.
   *
   * @param {Node} node - The node for which a variable should be created.
   * @param {?string} [name=null] - The name of the variable in the shader.
   * @param {boolean} [readOnly=false] - The read-only flag.
   */ constructor(e, t = null, i = !1){
        super(), this.node = e, this.name = t, this.global = !0, this.isVarNode = !0, this.readOnly = i, this.parents = !0, this.intent = !1;
    }
    /**
   * Sets the intent flag for this node.
   *
   * This flag is used to indicate that this node is used for intent
   * and should not be built directly. Instead, it is used to indicate that
   * the node should be treated as a variable intent.
   *
   * It's useful for assigning variables without needing creating a new variable node.
   *
   * @param {boolean} value - The value to set for the intent flag.
   * @returns {VarNode} This node.
   */ setIntent(e) {
        return this.intent = e, this;
    }
    /**
   * Returns the intent flag of this node.
   *
   * @return {boolean} The intent flag.
   */ getIntent() {
        return this.intent;
    }
    getMemberType(e, t) {
        return this.node.getMemberType(e, t);
    }
    getElementType(e) {
        return this.node.getElementType(e);
    }
    getNodeType(e) {
        return this.node.getNodeType(e);
    }
    getArrayCount(e) {
        return this.node.getArrayCount(e);
    }
    isAssign(e) {
        let i = e.getNodeProperties(this).assign;
        return i !== !0 && this.node.isShaderCallNodeInternal && this.node.shaderNode.getLayout() === null && e.fnCall && e.fnCall.shaderNode && e.getDataFromNode(this.node.shaderNode).hasLoop && (i = !0), i;
    }
    build(...e) {
        const t = e[0];
        return this._hasStack(t) === !1 && t.buildStage === "setup" && (t.context.nodeLoop || t.context.nodeBlock) && t.getBaseStack().addToStack(this), this.intent === !0 && this.isAssign(t) !== !0 ? this.node.build(...e) : super.build(...e);
    }
    generate(e) {
        const { node: t, name: i, readOnly: n } = this, { renderer: s } = e, a = s.backend.isWebGPUBackend === !0;
        let o = !1, g = !1;
        n && (o = e.isDeterministic(t), g = a ? n : o);
        const l = this.getNodeType(e);
        if (l == "void") return this.intent !== !0 && $d7238066c5de7f1c$var$nt('TSL: ".toVar()" can not be used with void type.'), t.build(e);
        const c = e.getVectorType(l), d = t.build(e, c), p = e.getVarFromNode(this, i, c, void 0, g), A = e.getPropertyName(p);
        let y = A;
        if (g) {
            if (a) y = o ? `const ${A}` : `let ${A}`;
            else {
                const G = t.getArrayCount(e);
                y = `const ${e.getVar(p.type, A, G)}`;
            }
        }
        return e.addLineFlowCode(`${y} = ${d}`, this), A;
    }
    _hasStack(e) {
        return e.getDataFromNode(this).stack !== void 0;
    }
}
const $d7238066c5de7f1c$var$DL = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$RS), $d7238066c5de7f1c$var$xE = (r, e = null)=>$d7238066c5de7f1c$var$DL(r, e).toStack(), $d7238066c5de7f1c$var$FE = (r, e = null)=>$d7238066c5de7f1c$var$DL(r, e, !0).toStack(), $d7238066c5de7f1c$var$TE = (r)=>$d7238066c5de7f1c$var$DL(r).setIntent(!0).toStack();
$d7238066c5de7f1c$var$Se("toVar", $d7238066c5de7f1c$var$xE);
$d7238066c5de7f1c$var$Se("toConst", $d7238066c5de7f1c$var$FE);
$d7238066c5de7f1c$var$Se("toVarIntent", $d7238066c5de7f1c$var$TE);
class $d7238066c5de7f1c$var$yte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "SubBuild";
    }
    constructor(e, t, i = null){
        super(i), this.node = e, this.name = t, this.isSubBuildNode = !0;
    }
    getNodeType(e) {
        if (this.nodeType !== null) return this.nodeType;
        e.addSubBuild(this.name);
        const t = this.node.getNodeType(e);
        return e.removeSubBuild(), t;
    }
    build(e, ...t) {
        e.addSubBuild(this.name);
        const i = this.node.build(e, ...t);
        return e.removeSubBuild(), i;
    }
}
const $d7238066c5de7f1c$var$RA = (r, e, t = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$yte($d7238066c5de7f1c$var$He(r), e, t));
class $d7238066c5de7f1c$var$Bte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "VaryingNode";
    }
    /**
   * Constructs a new varying node.
   *
   * @param {Node} node - The node for which a varying should be created.
   * @param {?string} name - The name of the varying in the shader.
   */ constructor(e, t = null){
        super(), this.node = e, this.name = t, this.isVaryingNode = !0, this.interpolationType = null, this.interpolationSampling = null, this.global = !0;
    }
    /**
   * Defines the interpolation type of the varying.
   *
   * @param {string} type - The interpolation type.
   * @param {?string} sampling - The interpolation sampling type
   * @return {VaryingNode} A reference to this node.
   */ setInterpolation(e, t = null) {
        return this.interpolationType = e, this.interpolationSampling = t, this;
    }
    getHash(e) {
        return this.name || super.getHash(e);
    }
    getNodeType(e) {
        return this.node.getNodeType(e);
    }
    /**
   * This method performs the setup of a varying node with the current node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeVarying} The node varying from the node builder.
   */ setupVarying(e) {
        const t = e.getNodeProperties(this);
        let i = t.varying;
        if (i === void 0) {
            const n = this.name, s = this.getNodeType(e), a = this.interpolationType, o = this.interpolationSampling;
            t.varying = i = e.getVaryingFromNode(this, n, s, a, o), t.node = $d7238066c5de7f1c$var$RA(this.node, "VERTEX");
        }
        return i.needsInterpolation || (i.needsInterpolation = e.shaderStage === "fragment"), i;
    }
    setup(e) {
        this.setupVarying(e), e.flowNodeFromShaderStage($d7238066c5de7f1c$var$by.VERTEX, this.node);
    }
    analyze(e) {
        this.setupVarying(e), e.flowNodeFromShaderStage($d7238066c5de7f1c$var$by.VERTEX, this.node);
    }
    generate(e) {
        const t = e.getSubBuildProperty("property", e.currentStack), i = e.getNodeProperties(this), n = this.setupVarying(e);
        if (i[t] === void 0) {
            const s = this.getNodeType(e), a = e.getPropertyName(n, $d7238066c5de7f1c$var$by.VERTEX);
            e.flowNodeFromShaderStage($d7238066c5de7f1c$var$by.VERTEX, i.node, s, a), i[t] = a;
        }
        return e.getPropertyName(n);
    }
}
const $d7238066c5de7f1c$var$pu = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Bte).setParameterLength(1, 2), $d7238066c5de7f1c$var$ME = (r)=>$d7238066c5de7f1c$var$pu(r);
$d7238066c5de7f1c$var$Se("toVarying", $d7238066c5de7f1c$var$pu);
$d7238066c5de7f1c$var$Se("toVertexStage", $d7238066c5de7f1c$var$ME);
$d7238066c5de7f1c$var$Se("varying", (...r)=>($d7238066c5de7f1c$var$ze("TSL: .varying() has been renamed to .toVarying()."), $d7238066c5de7f1c$var$pu(...r)));
$d7238066c5de7f1c$var$Se("vertexStage", (...r)=>($d7238066c5de7f1c$var$ze("TSL: .vertexStage() has been renamed to .toVertexStage()."), $d7238066c5de7f1c$var$pu(...r)));
const $d7238066c5de7f1c$var$zE = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = r.mul(0.9478672986).add(0.0521327014).pow(2.4), t = r.mul(0.0773993808), i = r.lessThanEqual(0.04045);
    return $d7238066c5de7f1c$var$qi(e, t, i);
}).setLayout({
    name: "sRGBTransferEOTF",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$kE = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = r.pow(0.41666).mul(1.055).sub(0.055), t = r.mul(12.92), i = r.lessThanEqual(31308e-7);
    return $d7238066c5de7f1c$var$qi(e, t, i);
}).setLayout({
    name: "sRGBTransferOETF",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$_L = "WorkingColorSpace", $d7238066c5de7f1c$var$fte = "OutputColorSpace";
class $d7238066c5de7f1c$var$PL extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "ColorSpaceNode";
    }
    /**
   * Constructs a new color space node.
   *
   * @param {Node} colorNode - Represents the color to convert.
   * @param {string} source - The source color space.
   * @param {string} target - The target color space.
   */ constructor(e, t, i){
        super("vec4"), this.colorNode = e, this.source = t, this.target = i;
    }
    /**
   * This method resolves the constants `WORKING_COLOR_SPACE` and
   * `OUTPUT_COLOR_SPACE` based on the current configuration of the
   * color management and renderer.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} colorSpace - The color space to resolve.
   * @return {string} The resolved color space.
   */ resolveColorSpace(e, t) {
        return t === $d7238066c5de7f1c$var$_L ? $d7238066c5de7f1c$var$sn.workingColorSpace : t === $d7238066c5de7f1c$var$fte ? e.context.outputColorSpace || e.renderer.outputColorSpace : t;
    }
    setup(e) {
        const { colorNode: t } = this, i = this.resolveColorSpace(e, this.source), n = this.resolveColorSpace(e, this.target);
        let s = t;
        return $d7238066c5de7f1c$var$sn.enabled === !1 || i === n || !i || !n || ($d7238066c5de7f1c$var$sn.getTransfer(i) === $d7238066c5de7f1c$var$Qt && (s = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$zE(s.rgb), s.a)), $d7238066c5de7f1c$var$sn.getPrimaries(i) !== $d7238066c5de7f1c$var$sn.getPrimaries(n) && (s = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$sn._getMatrix(new $d7238066c5de7f1c$var$Lo(), i, n)).mul(s.rgb), s.a)), $d7238066c5de7f1c$var$sn.getTransfer(n) === $d7238066c5de7f1c$var$Qt && (s = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$kE(s.rgb), s.a))), s;
    }
}
const $d7238066c5de7f1c$var$EE = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$PL($d7238066c5de7f1c$var$He(r), $d7238066c5de7f1c$var$_L, e)), $d7238066c5de7f1c$var$vR = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$PL($d7238066c5de7f1c$var$He(r), e, $d7238066c5de7f1c$var$_L)), $d7238066c5de7f1c$var$Gte = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$PL($d7238066c5de7f1c$var$He(r), e, t));
$d7238066c5de7f1c$var$Se("workingToColorSpace", $d7238066c5de7f1c$var$EE);
$d7238066c5de7f1c$var$Se("colorSpaceToWorking", $d7238066c5de7f1c$var$vR);
let $d7238066c5de7f1c$var$vte = class extends $d7238066c5de7f1c$var$jC {
    static get type() {
        return "ReferenceElementNode";
    }
    /**
   * Constructs a new reference element node.
   *
   * @param {ReferenceBaseNode} referenceNode - The reference node.
   * @param {Node} indexNode - The index node that defines the element access.
   */ constructor(e, t){
        super(e, t), this.referenceNode = e, this.isReferenceElementNode = !0;
    }
    /**
   * This method is overwritten since the node type is inferred from
   * the uniform type of the reference node.
   *
   * @return {string} The node type.
   */ getNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(e) {
        const t = super.generate(e), i = this.referenceNode.getNodeType(), n = this.getNodeType();
        return e.format(t, i, n);
    }
};
class $d7238066c5de7f1c$var$JE extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ReferenceBaseNode";
    }
    /**
   * Constructs a new reference base node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} uniformType - The uniform type that should be used to represent the property value.
   * @param {?Object} [object=null] - The object the property belongs to.
   * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
   */ constructor(e, t, i = null, n = null){
        super(), this.property = e, this.uniformType = t, this.object = i, this.count = n, this.properties = e.split("."), this.reference = i, this.node = null, this.group = null, this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT;
    }
    /**
   * Sets the uniform group for this reference node.
   *
   * @param {UniformGroupNode} group - The uniform group to set.
   * @return {ReferenceBaseNode} A reference to this node.
   */ setGroup(e) {
        return this.group = e, this;
    }
    /**
   * When the referred property is array-like, this method can be used
   * to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {ReferenceElementNode} A reference to an element.
   */ element(e) {
        return $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$vte(this, $d7238066c5de7f1c$var$He(e)));
    }
    /**
   * Sets the node type which automatically defines the internal
   * uniform type.
   *
   * @param {string} uniformType - The type to set.
   */ setNodeType(e) {
        const t = $d7238066c5de7f1c$var$yt(null, e);
        this.group !== null && t.setGroup(this.group), this.node = t;
    }
    /**
   * This method is overwritten since the node type is inferred from
   * the type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.node === null && (this.updateReference(e), this.updateValue()), this.node.getNodeType(e);
    }
    /**
   * Returns the property value from the given referred object.
   *
   * @param {Object} [object=this.reference] - The object to retrieve the property value from.
   * @return {any} The value.
   */ getValueFromReference(e = this.reference) {
        const { properties: t } = this;
        let i = e[t[0]];
        for(let n = 1; n < t.length; n++)i = i[t[n]];
        return i;
    }
    /**
   * Allows to update the reference based on the given state. The state is only
   * evaluated {@link ReferenceBaseNode#object} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */ updateReference(e) {
        return this.reference = this.object !== null ? this.object : e.object, this.reference;
    }
    /**
   * The output of the reference node is the internal uniform node.
   *
   * @return {UniformNode} The output node.
   */ setup() {
        return this.updateValue(), this.node;
    }
    /**
   * Overwritten to update the internal uniform value.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update() {
        this.updateValue();
    }
    /**
   * Retrieves the value from the referred object property and uses it
   * to updated the internal uniform.
   */ updateValue() {
        this.node === null && this.setNodeType(this.uniformType);
        const e = this.getValueFromReference();
        Array.isArray(e) ? this.node.array = e : this.node.value = e;
    }
}
const $d7238066c5de7f1c$var$Ste = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$JE(r, e, t));
class $d7238066c5de7f1c$var$Zte extends $d7238066c5de7f1c$var$JE {
    static get type() {
        return "RendererReferenceNode";
    }
    /**
   * Constructs a new renderer reference node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} inputType - The uniform type that should be used to represent the property value.
   * @param {?Renderer} [renderer=null] - The renderer the property belongs to. When no renderer is set,
   * the node refers to the renderer of the current state.
   */ constructor(e, t, i = null){
        super(e, t, i), this.renderer = i, this.setGroup($d7238066c5de7f1c$var$ft);
    }
    /**
   * Updates the reference based on the given state. The state is only evaluated
   * {@link RendererReferenceNode#renderer} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */ updateReference(e) {
        return this.reference = this.renderer !== null ? this.renderer : e.renderer, this.reference;
    }
}
const $d7238066c5de7f1c$var$UE = (r, e, t = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Zte(r, e, t));
class $d7238066c5de7f1c$var$Rte extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "ToneMappingNode";
    }
    /**
   * Constructs a new tone mapping node.
   *
   * @param {number} toneMapping - The tone mapping type.
   * @param {Node} exposureNode - The tone mapping exposure.
   * @param {Node} [colorNode=null] - The color node to process.
   */ constructor(e, t = $d7238066c5de7f1c$var$_E, i = null){
        super("vec3"), this._toneMapping = e, this.exposureNode = t, this.colorNode = i;
    }
    /**
   * Overwrites the default `customCacheKey()` implementation by including the tone
   * mapping type into the cache key.
   *
   * @return {number} The hash.
   */ customCacheKey() {
        return $d7238066c5de7f1c$var$ky(this._toneMapping);
    }
    /**
   * Sets the tone mapping type.
   *
   * @param {number} value - The tone mapping type.
   * @return {ToneMappingNode} A reference to this node.
   */ setToneMapping(e) {
        return this._toneMapping = e, this;
    }
    /**
   * Gets the tone mapping type.
   *
   * @returns {number} The tone mapping type.
   */ getToneMapping() {
        return this._toneMapping;
    }
    setup(e) {
        const t = this.colorNode || e.context.color, i = this._toneMapping;
        if (i === $d7238066c5de7f1c$var$VC) return t;
        let n = null;
        const s = e.renderer.library.getToneMappingFunction(i);
        return s !== null ? n = $d7238066c5de7f1c$var$Rt(s(t.rgb, this.exposureNode), t.a) : ($d7238066c5de7f1c$var$nt("ToneMappingNode: Unsupported Tone Mapping configuration.", i), n = t), n;
    }
}
const $d7238066c5de7f1c$var$DE = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Rte(r, $d7238066c5de7f1c$var$He(e), $d7238066c5de7f1c$var$He(t))), $d7238066c5de7f1c$var$_E = /* @__PURE__ */ $d7238066c5de7f1c$var$UE("toneMappingExposure", "float");
$d7238066c5de7f1c$var$Se("toneMapping", (r, e, t)=>$d7238066c5de7f1c$var$DE(e, t, r));
class $d7238066c5de7f1c$var$Vte extends $d7238066c5de7f1c$var$pL {
    static get type() {
        return "BufferAttributeNode";
    }
    /**
   * Constructs a new buffer attribute node.
   *
   * @param {BufferAttribute|InterleavedBuffer|TypedArray} value - The attribute data.
   * @param {?string} [bufferType=null] - The buffer type (e.g. `'vec3'`).
   * @param {number} [bufferStride=0] - The buffer stride.
   * @param {number} [bufferOffset=0] - The buffer offset.
   */ constructor(e, t = null, i = 0, n = 0){
        super(e, t), this.isBufferNode = !0, this.bufferType = t, this.bufferStride = i, this.bufferOffset = n, this.usage = $d7238066c5de7f1c$var$vZ, this.instanced = !1, this.attribute = null, this.global = !0, e && e.isBufferAttribute === !0 && (this.attribute = e, this.usage = e.usage, this.instanced = e.isInstancedBufferAttribute);
    }
    /**
   * This method is overwritten since the attribute data might be shared
   * and thus the hash should be shared as well.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */ getHash(e) {
        if (this.bufferStride === 0 && this.bufferOffset === 0) {
            let t = e.globalCache.getData(this.value);
            return t === void 0 && (t = {
                node: this
            }, e.globalCache.setData(this.value, t)), t.node.uuid;
        }
        return this.uuid;
    }
    /**
   * This method is overwritten since the node type is inferred from
   * the buffer attribute.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.bufferType === null && (this.bufferType = e.getTypeFromAttribute(this.attribute)), this.bufferType;
    }
    /**
   * Depending on which value was passed to the node, `setup()` behaves
   * differently. If no instance of `BufferAttribute` was passed, the method
   * creates an internal attribute and configures it respectively.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        if (this.attribute !== null) return;
        const t = this.getNodeType(e), i = this.value, n = e.getTypeLength(t), s = this.bufferStride || n, a = this.bufferOffset, o = i.isInterleavedBuffer === !0 ? i : new $d7238066c5de7f1c$var$h3(i, s), g = new $d7238066c5de7f1c$var$nL(o, n, a);
        o.setUsage(this.usage), this.attribute = g, this.attribute.isInstancedBufferAttribute = this.instanced;
    }
    /**
   * Generates the code snippet of the buffer attribute node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */ generate(e) {
        const t = this.getNodeType(e), i = e.getBufferAttributeFromNode(this, t), n = e.getPropertyName(i);
        let s = null;
        return e.shaderStage === "vertex" || e.shaderStage === "compute" ? (this.name = n, s = n) : s = $d7238066c5de7f1c$var$pu(this).build(e, t), s;
    }
    /**
   * Overwrites the default implementation to return a fixed value `'bufferAttribute'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return "bufferAttribute";
    }
    /**
   * Sets the `usage` property to the given value.
   *
   * @param {number} value - The usage to set.
   * @return {BufferAttributeNode} A reference to this node.
   */ setUsage(e) {
        return this.usage = e, this.attribute && this.attribute.isBufferAttribute === !0 && (this.attribute.usage = e), this;
    }
    /**
   * Sets the `instanced` property to the given value.
   *
   * @param {boolean} value - The value to set.
   * @return {BufferAttributeNode} A reference to this node.
   */ setInstanced(e) {
        return this.instanced = e, this;
    }
}
const $d7238066c5de7f1c$var$_B = (r, e = null, t = 0, i = 0)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Vte(r, e, t, i)), $d7238066c5de7f1c$var$PE = (r, e = null, t = 0, i = 0)=>$d7238066c5de7f1c$var$_B(r, e, t, i).setUsage($d7238066c5de7f1c$var$dA), $d7238066c5de7f1c$var$XZ = (r, e = null, t = 0, i = 0)=>$d7238066c5de7f1c$var$_B(r, e, t, i).setInstanced(!0), $d7238066c5de7f1c$var$X2 = (r, e = null, t = 0, i = 0)=>$d7238066c5de7f1c$var$PE(r, e, t, i).setInstanced(!0);
$d7238066c5de7f1c$var$Se("toAttribute", (r)=>$d7238066c5de7f1c$var$_B(r.value));
class $d7238066c5de7f1c$var$wte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ComputeNode";
    }
    /**
   * Constructs a new compute node.
   *
   * @param {Node} computeNode - TODO
   * @param {Array<number>} workgroupSize - TODO.
   */ constructor(e, t){
        super("void"), this.isComputeNode = !0, this.computeNode = e, this.workgroupSize = t, this.count = null, this.version = 1, this.name = "", this.updateBeforeType = $d7238066c5de7f1c$var$Dt.OBJECT, this.onInitFunction = null;
    }
    /**
   * TODO
   *
   * @param {number|Array<number>} count - Array with [ x, y, z ] values for dispatch or a single number for the count
   * @return {ComputeNode}
   */ setCount(e) {
        return this.count = e, this;
    }
    /**
   * TODO
   *
   * @return {number|Array<number>}
   */ getCount() {
        return this.count;
    }
    /**
   * Executes the `dispose` event for this node.
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    /**
   * Sets the {@link ComputeNode#name} property.
   *
   * @param {string} name - The name of the uniform.
   * @return {ComputeNode} A reference to this node.
   */ setName(e) {
        return this.name = e, this;
    }
    /**
   * Sets the {@link ComputeNode#name} property.
   *
   * @deprecated
   * @param {string} name - The name of the uniform.
   * @return {ComputeNode} A reference to this node.
   */ label(e) {
        return $d7238066c5de7f1c$var$ze('TSL: "label()" has been deprecated. Use "setName()" instead.'), this.setName(e);
    }
    /**
   * TODO
   *
   * @param {Function} callback - TODO.
   * @return {ComputeNode} A reference to this node.
   */ onInit(e) {
        return this.onInitFunction = e, this;
    }
    /**
   * The method execute the compute for this node.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ updateBefore({ renderer: e }) {
        e.compute(this);
    }
    setup(e) {
        const t = this.computeNode.build(e);
        if (t) {
            const i = e.getNodeProperties(this);
            i.outputComputeNode = t.outputNode, t.outputNode = null;
        }
        return t;
    }
    generate(e, t) {
        const { shaderStage: i } = e;
        if (i === "compute") {
            const n = this.computeNode.build(e, "void");
            n !== "" && e.addLineFlowCode(n, this);
        } else {
            const s = e.getNodeProperties(this).outputComputeNode;
            if (s) return s.build(e, t);
        }
    }
}
const $d7238066c5de7f1c$var$QL = (r, e = [
    64
])=>{
    (e.length === 0 || e.length > 3) && $d7238066c5de7f1c$var$nt("TSL: compute() workgroupSize must have 1, 2, or 3 elements");
    for(let t = 0; t < e.length; t++){
        const i = e[t];
        (typeof i != "number" || i <= 0 || !Number.isInteger(i)) && $d7238066c5de7f1c$var$nt(`TSL: compute() workgroupSize element at index [ ${t} ] must be a positive integer`);
    }
    for(; e.length < 3;)e.push(1);
    return $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$wte($d7238066c5de7f1c$var$He(r), e));
}, $d7238066c5de7f1c$var$QE = (r, e, t)=>$d7238066c5de7f1c$var$QL(r, t).setCount(e);
$d7238066c5de7f1c$var$Se("compute", $d7238066c5de7f1c$var$QE);
$d7238066c5de7f1c$var$Se("computeKernel", $d7238066c5de7f1c$var$QL);
class $d7238066c5de7f1c$var$Wte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "IsolateNode";
    }
    /**
   * Constructs a new cache node.
   *
   * @param {Node} node - The node that should be cached.
   * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
   */ constructor(e, t = !0){
        super(), this.node = e, this.parent = t, this.isIsolateNode = !0;
    }
    getNodeType(e) {
        const t = e.getCache(), i = e.getCacheFromNode(this, this.parent);
        e.setCache(i);
        const n = this.node.getNodeType(e);
        return e.setCache(t), n;
    }
    build(e, ...t) {
        const i = e.getCache(), n = e.getCacheFromNode(this, this.parent);
        e.setCache(n);
        const s = this.node.build(e, ...t);
        return e.setCache(i), s;
    }
    setParent(e) {
        return this.parent = e, this;
    }
    getParent() {
        return this.parent;
    }
}
const $d7238066c5de7f1c$var$VA = (r)=>new $d7238066c5de7f1c$var$Wte($d7238066c5de7f1c$var$He(r));
function $d7238066c5de7f1c$var$OE(r, e = !0) {
    return $d7238066c5de7f1c$var$ze('TSL: "cache()" has been deprecated. Use "isolate()" instead.'), $d7238066c5de7f1c$var$VA(r).setParent(e);
}
$d7238066c5de7f1c$var$Se("cache", $d7238066c5de7f1c$var$OE);
$d7238066c5de7f1c$var$Se("isolate", $d7238066c5de7f1c$var$VA);
class $d7238066c5de7f1c$var$Hte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "BypassNode";
    }
    /**
   * Constructs a new bypass node.
   *
   * @param {Node} outputNode - The output node.
   * @param {Node} callNode - The call node.
   */ constructor(e, t){
        super(), this.isBypassNode = !0, this.outputNode = e, this.callNode = t;
    }
    getNodeType(e) {
        return this.outputNode.getNodeType(e);
    }
    generate(e) {
        const t = this.callNode.build(e, "void");
        return t !== "" && e.addLineFlowCode(t, this), this.outputNode.build(e);
    }
}
const $d7238066c5de7f1c$var$jE = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Hte).setParameterLength(2);
$d7238066c5de7f1c$var$Se("bypass", $d7238066c5de7f1c$var$jE);
class $d7238066c5de7f1c$var$qE extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "RemapNode";
    }
    /**
   * Constructs a new remap node.
   *
   * @param {Node} node - The node that should be remapped.
   * @param {Node} inLowNode - The source or current lower bound of the range.
   * @param {Node} inHighNode - The source or current upper bound of the range.
   * @param {Node} [outLowNode=float(0)] - The target lower bound of the range.
   * @param {Node} [outHighNode=float(1)] - The target upper bound of the range.
   */ constructor(e, t, i, n = $d7238066c5de7f1c$var$J(0), s = $d7238066c5de7f1c$var$J(1)){
        super(), this.node = e, this.inLowNode = t, this.inHighNode = i, this.outLowNode = n, this.outHighNode = s, this.doClamp = !0;
    }
    setup() {
        const { node: e, inLowNode: t, inHighNode: i, outLowNode: n, outHighNode: s, doClamp: a } = this;
        let o = e.sub(t).div(i.sub(t));
        return a === !0 && (o = o.clamp()), o.mul(s.sub(n)).add(n);
    }
}
const $d7238066c5de7f1c$var$$E = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$qE, null, null, {
    doClamp: !1
}).setParameterLength(3, 5), $d7238066c5de7f1c$var$eJ = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$qE).setParameterLength(3, 5);
$d7238066c5de7f1c$var$Se("remap", $d7238066c5de7f1c$var$$E);
$d7238066c5de7f1c$var$Se("remapClamp", $d7238066c5de7f1c$var$eJ);
class $d7238066c5de7f1c$var$VS extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ExpressionNode";
    }
    /**
   * Constructs a new expression node.
   *
   * @param {string} [snippet=''] - The native code snippet.
   * @param {string} [nodeType='void'] - The node type.
   */ constructor(e = "", t = "void"){
        super(t), this.snippet = e;
    }
    generate(e, t) {
        const i = this.getNodeType(e), n = this.snippet;
        if (i === "void") e.addLineFlowCode(n, this);
        else return e.format(n, i, t);
    }
}
const $d7238066c5de7f1c$var$ZI = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$VS).setParameterLength(1, 2), $d7238066c5de7f1c$var$tJ = (r)=>(r ? $d7238066c5de7f1c$var$or(r, $d7238066c5de7f1c$var$ZI("discard")) : $d7238066c5de7f1c$var$ZI("discard")).toStack(), $d7238066c5de7f1c$var$Xte = ()=>$d7238066c5de7f1c$var$ZI("return").toStack();
$d7238066c5de7f1c$var$Se("discard", $d7238066c5de7f1c$var$tJ);
class $d7238066c5de7f1c$var$Nte extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "RenderOutputNode";
    }
    /**
   * Constructs a new render output node.
   *
   * @param {Node} colorNode - The color node to process.
   * @param {?number} toneMapping - The tone mapping type.
   * @param {?string} outputColorSpace - The output color space.
   */ constructor(e, t, i){
        super("vec4"), this.colorNode = e, this._toneMapping = t, this.outputColorSpace = i, this.isRenderOutputNode = !0;
    }
    /**
   * Sets the tone mapping type.
   *
   * @param {number} value - The tone mapping type.
   * @return {ToneMappingNode} A reference to this node.
   */ setToneMapping(e) {
        return this._toneMapping = e, this;
    }
    /**
   * Gets the tone mapping type.
   *
   * @returns {number} The tone mapping type.
   */ getToneMapping() {
        return this._toneMapping;
    }
    setup({ context: e }) {
        let t = this.colorNode || e.color;
        const i = (this._toneMapping !== null ? this._toneMapping : e.toneMapping) || $d7238066c5de7f1c$var$VC, n = (this.outputColorSpace !== null ? this.outputColorSpace : e.outputColorSpace) || $d7238066c5de7f1c$var$gh;
        return i !== $d7238066c5de7f1c$var$VC && (t = t.toneMapping(i)), n !== $d7238066c5de7f1c$var$gh && n !== $d7238066c5de7f1c$var$sn.workingColorSpace && (t = t.workingToColorSpace(n)), t;
    }
}
const $d7238066c5de7f1c$var$iJ = (r, e = null, t = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Nte($d7238066c5de7f1c$var$He(r), e, t));
$d7238066c5de7f1c$var$Se("renderOutput", $d7238066c5de7f1c$var$iJ);
class $d7238066c5de7f1c$var$Lte extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "DebugNode";
    }
    constructor(e, t = null){
        super(), this.node = e, this.callback = t;
    }
    getNodeType(e) {
        return this.node.getNodeType(e);
    }
    setup(e) {
        return this.node.build(e);
    }
    analyze(e) {
        return this.node.build(e);
    }
    generate(e) {
        const t = this.callback, i = this.node.build(e), n = "--- TSL debug - " + e.shaderStage + " shader ---", s = "-".repeat(n.length);
        let a = "";
        return a += "// #" + n + `#
`, a += e.flow.code.replace(/^\t/mg, "") + `
`, a += "/* ... */ " + i + ` /* ... */
`, a += "// #" + s + `#
`, t !== null ? t(e, a) : $d7238066c5de7f1c$var$S2(a), i;
    }
}
const $d7238066c5de7f1c$var$nJ = (r, e = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Lte($d7238066c5de7f1c$var$He(r), e)).toStack();
$d7238066c5de7f1c$var$Se("debug", $d7238066c5de7f1c$var$nJ);
class $d7238066c5de7f1c$var$sJ {
    /**
   * Creates a new InspectorBase.
   */ constructor(){
        this._renderer = null, this.currentFrame = null;
    }
    /**
   * Returns the node frame for the current renderer.
   *
   * @return {Object} The node frame.
   */ get nodeFrame() {
        return this._renderer._nodes.nodeFrame;
    }
    /**
   * Sets the renderer for this inspector.
   *
   * @param {WebGLRenderer} renderer - The renderer to associate with this inspector.
   * @return {InspectorBase} This inspector instance.
   */ setRenderer(e) {
        return this._renderer = e, this;
    }
    /**
   * Returns the renderer associated with this inspector.
   *
   * @return {WebGLRenderer} The associated renderer.
   */ getRenderer() {
        return this._renderer;
    }
    /**
   * Initializes the inspector.
   */ init() {}
    /**
   * Called when a frame begins.
   */ begin() {}
    /**
   * Called when a frame ends.
   */ finish() {}
    /**
   * Inspects a node.
   *
   * @param {Node} node - The node to inspect.
   */ inspect() {}
    /**
   * When a compute operation is performed.
   *
   * @param {ComputeNode} computeNode - The compute node being executed.
   * @param {number|Array<number>} dispatchSizeOrCount - The dispatch size or count.
   */ computeAsync() {}
    /**
   * Called when a compute operation begins.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @param {ComputeNode} computeNode - The compute node being executed.
   */ beginCompute() {}
    /**
   * Called when a compute operation ends.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @param {ComputeNode} computeNode - The compute node being executed.
   */ finishCompute() {}
    /**
   * Called when a render operation begins.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @param {Scene} scene - The scene being rendered.
   * @param {Camera} camera - The camera being used for rendering.
   * @param {?WebGLRenderTarget} renderTarget - The render target, if any.
   */ beginRender() {}
    /**
   * Called when an animation loop ends.
   *
   * @param {string} uid - A unique identifier for the render context.
   */ finishRender() {}
    /**
   * Called when a texture copy operation is performed.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   */ copyTextureToTexture() {}
    /**
   * Called when a framebuffer copy operation is performed.
   *
   * @param {Texture} framebufferTexture - The texture associated with the framebuffer.
   */ copyFramebufferToTexture() {}
}
class $d7238066c5de7f1c$var$Yte extends $d7238066c5de7f1c$var$Ct {
    /**
   * Returns the type of the node.
   *
   * @returns {string}
   */ static get type() {
        return "InspectorNode";
    }
    /**
   * Creates an InspectorNode.
   *
   * @param {Node} node - The node to inspect.
   * @param {string} [name=''] - Optional name for the inspector node.
   * @param {Function|null} [callback=null] - Optional callback to modify the node during setup.
   */ constructor(e, t = "", i = null){
        super(), this.node = e, this.name = t, this.callback = i, this.updateType = $d7238066c5de7f1c$var$Dt.FRAME, this.isInspectorNode = !0;
    }
    /**
   * Returns the name of the inspector node.
   *
   * @returns {string}
   */ getName() {
        return this.name || this.node.name;
    }
    /**
   * Updates the inspector node, allowing inspection of the wrapped node.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update(e) {
        e.renderer.inspector.inspect(this);
    }
    /**
   * Returns the type of the wrapped node.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @returns {string}
   */ getNodeType(e) {
        return this.node.getNodeType(e);
    }
    /**
   * Sets up the inspector node.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @returns {Node} The setup node.
   */ setup(e) {
        let t = this.node;
        return e.context.inspector === !0 && this.callback !== null && (t = this.callback(t)), e.renderer.backend.isWebGPUBackend !== !0 && e.renderer.inspector.constructor !== $d7238066c5de7f1c$var$sJ && $d7238066c5de7f1c$var$es('TSL: ".toInspector()" is only available with WebGPU.'), t;
    }
}
function $d7238066c5de7f1c$var$rJ(r, e = "", t = null) {
    return r = $d7238066c5de7f1c$var$He(r), r.before(new $d7238066c5de7f1c$var$Yte(r, e, t));
}
$d7238066c5de7f1c$var$Se("toInspector", $d7238066c5de7f1c$var$rJ);
function $d7238066c5de7f1c$var$Kte(r) {
    $d7238066c5de7f1c$var$ze("TSL: AddNodeElement has been removed in favor of tree-shaking. Trying add", r);
}
class $d7238066c5de7f1c$var$aJ extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "AttributeNode";
    }
    /**
   * Constructs a new attribute node.
   *
   * @param {string} attributeName - The name of the attribute.
   * @param {?string} nodeType - The node type.
   */ constructor(e, t = null){
        super(t), this.global = !0, this._attributeName = e;
    }
    getHash(e) {
        return this.getAttributeName(e);
    }
    getNodeType(e) {
        let t = this.nodeType;
        if (t === null) {
            const i = this.getAttributeName(e);
            if (e.hasGeometryAttribute(i)) {
                const n = e.geometry.getAttribute(i);
                t = e.getTypeFromAttribute(n);
            } else t = "float";
        }
        return t;
    }
    /**
   * Sets the attribute name to the given value. The method can be
   * overwritten in derived classes if the final name must be computed
   * analytically.
   *
   * @param {string} attributeName - The name of the attribute.
   * @return {AttributeNode} A reference to this node.
   */ setAttributeName(e) {
        return this._attributeName = e, this;
    }
    /**
   * Returns the attribute name of this node. The method can be
   * overwritten in derived classes if the final name must be computed
   * analytically.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The attribute name.
   */ getAttributeName() {
        return this._attributeName;
    }
    generate(e) {
        const t = this.getAttributeName(e), i = this.getNodeType(e);
        if (e.hasGeometryAttribute(t) === !0) {
            const s = e.geometry.getAttribute(t), a = e.getTypeFromAttribute(s), o = e.getAttribute(t, a);
            return e.shaderStage === "vertex" ? e.format(o.name, a, i) : $d7238066c5de7f1c$var$pu(this).build(e, i);
        } else return $d7238066c5de7f1c$var$ze(`AttributeNode: Vertex attribute "${t}" not found on geometry.`), e.generateConst(i);
    }
    serialize(e) {
        super.serialize(e), e.global = this.global, e._attributeName = this._attributeName;
    }
    deserialize(e) {
        super.deserialize(e), this.global = e.global, this._attributeName = e._attributeName;
    }
}
const $d7238066c5de7f1c$var$RI = (r, e = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$aJ(r, e)), $d7238066c5de7f1c$var$yn = (r = 0)=>$d7238066c5de7f1c$var$RI("uv" + (r > 0 ? r : ""), "vec2");
class $d7238066c5de7f1c$var$xte extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "TextureSizeNode";
    }
    /**
   * Constructs a new texture size node.
   *
   * @param {TextureNode} textureNode - A texture node which size should be retrieved.
   * @param {?Node<int>} [levelNode=null] - A level node which defines the requested mip.
   */ constructor(e, t = null){
        super("uvec2"), this.isTextureSizeNode = !0, this.textureNode = e, this.levelNode = t;
    }
    generate(e, t) {
        const i = this.textureNode.build(e, "property"), n = this.levelNode === null ? "0" : this.levelNode.build(e, "int");
        return e.format(`${e.getMethod("textureDimensions")}( ${i}, ${n} )`, this.getNodeType(e), t);
    }
}
const $d7238066c5de7f1c$var$mI = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$xte).setParameterLength(1, 2);
class $d7238066c5de7f1c$var$Fte extends $d7238066c5de7f1c$var$JB {
    static get type() {
        return "MaxMipLevelNode";
    }
    /**
   * Constructs a new max mip level node.
   *
   * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
   */ constructor(e){
        super(0), this._textureNode = e, this.updateType = $d7238066c5de7f1c$var$Dt.FRAME;
    }
    /**
   * The texture node to compute the max mip level for.
   *
   * @readonly
   * @type {TextureNode}
   */ get textureNode() {
        return this._textureNode;
    }
    /**
   * The texture.
   *
   * @readonly
   * @type {Texture}
   */ get texture() {
        return this._textureNode.value;
    }
    update() {
        const e = this.texture, t = e.images, i = t && t.length > 0 ? t[0] && t[0].image || t[0] : e.image;
        if (i && i.width !== void 0) {
            const { width: n, height: s } = i;
            this.value = Math.log2(Math.max(n, s));
        }
    }
}
const $d7238066c5de7f1c$var$OL = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Fte).setParameterLength(1), $d7238066c5de7f1c$var$jL = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ca();
class $d7238066c5de7f1c$var$Iu extends $d7238066c5de7f1c$var$JB {
    static get type() {
        return "TextureNode";
    }
    /**
   * Constructs a new texture node.
   *
   * @param {Texture} [value=EmptyTexture] - The texture.
   * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
   * @param {?Node<int>} [levelNode=null] - The level node.
   * @param {?Node<float>} [biasNode=null] - The bias node.
   */ constructor(e = $d7238066c5de7f1c$var$jL, t = null, i = null, n = null){
        super(e), this.isTextureNode = !0, this.uvNode = t, this.levelNode = i, this.biasNode = n, this.compareNode = null, this.depthNode = null, this.gradNode = null, this.offsetNode = null, this.sampler = !0, this.updateMatrix = !1, this.updateType = $d7238066c5de7f1c$var$Dt.NONE, this.referenceNode = null, this._value = e, this._matrixUniform = null, this._flipYUniform = null, this.setUpdateMatrix(t === null);
    }
    set value(e) {
        this.referenceNode ? this.referenceNode.value = e : this._value = e;
    }
    /**
   * The texture value.
   *
   * @type {Texture}
   */ get value() {
        return this.referenceNode ? this.referenceNode.value : this._value;
    }
    /**
   * Overwritten since the uniform hash is defined by the texture's UUID.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The uniform hash.
   */ getUniformHash() {
        return this.value.uuid;
    }
    /**
   * Overwritten since the node type is inferred from the texture type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType() {
        return this.value.isDepthTexture === !0 ? "float" : this.value.type === $d7238066c5de7f1c$var$Xs ? "uvec4" : this.value.type === $d7238066c5de7f1c$var$Na ? "ivec4" : "vec4";
    }
    /**
   * Overwrites the default implementation to return a fixed value `'texture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return "texture";
    }
    /**
   * Returns a default uvs based on the current texture's channel.
   *
   * @return {AttributeNode<vec2>} The default uvs.
   */ getDefaultUV() {
        return $d7238066c5de7f1c$var$yn(this.value.channel);
    }
    /**
   * Overwritten to always return the texture reference of the node.
   *
   * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
   * @return {Texture} The texture reference.
   */ updateReference() {
        return this.value;
    }
    /**
   * Transforms the given uv node with the texture transformation matrix.
   *
   * @param {Node} uvNode - The uv node to transform.
   * @return {Node} The transformed uv node.
   */ getTransformedUV(e) {
        return this._matrixUniform === null && (this._matrixUniform = $d7238066c5de7f1c$var$yt(this.value.matrix)), this._matrixUniform.mul($d7238066c5de7f1c$var$ne(e, 1)).xy;
    }
    /**
   * Defines whether the uv transformation matrix should automatically be updated or not.
   *
   * @param {boolean} value - The update toggle.
   * @return {TextureNode} A reference to this node.
   */ setUpdateMatrix(e) {
        return this.updateMatrix = e, this;
    }
    /**
   * Setups the uv node. Depending on the backend as well as texture's image and type, it might be necessary
   * to modify the uv node for correct sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The updated uv node.
   */ setupUV(e, t) {
        return e.isFlipY() && (this._flipYUniform === null && (this._flipYUniform = $d7238066c5de7f1c$var$yt(!1)), t = t.toVar(), this.sampler ? t = this._flipYUniform.select(t.flipY(), t) : t = this._flipYUniform.select(t.setY($d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$mI(this, this.levelNode).y).sub(t.y).sub(1)), t)), t;
    }
    /**
   * Setups texture node by preparing the internal nodes for code generation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        const t = e.getNodeProperties(this);
        t.referenceNode = this.referenceNode;
        const i = this.value;
        if (!i || i.isTexture !== !0) throw new Error("THREE.TSL: `texture( value )` function expects a valid instance of THREE.Texture().");
        const n = $d7238066c5de7f1c$var$oe(()=>{
            let a = this.uvNode;
            return (a === null || e.context.forceUVContext === !0) && e.context.getUV && (a = e.context.getUV(this, e)), a || (a = this.getDefaultUV()), this.updateMatrix === !0 && (a = this.getTransformedUV(a)), a = this.setupUV(e, a), this.updateType = this._matrixUniform !== null || this._flipYUniform !== null ? $d7238066c5de7f1c$var$Dt.OBJECT : $d7238066c5de7f1c$var$Dt.NONE, a;
        })();
        let s = this.levelNode;
        s === null && e.context.getTextureLevel && (s = e.context.getTextureLevel(this)), t.uvNode = n, t.levelNode = s, t.biasNode = this.biasNode, t.compareNode = this.compareNode, t.gradNode = this.gradNode, t.depthNode = this.depthNode, t.offsetNode = this.offsetNode;
    }
    /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */ generateUV(e, t) {
        return t.build(e, this.sampler === !0 ? "vec2" : "ivec2");
    }
    /**
   * Generates the offset code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} offsetNode - The offset node to generate code for.
   * @return {string} The generated code snippet.
   */ generateOffset(e, t) {
        return t.build(e, "ivec2");
    }
    /**
   * Generates the snippet for the texture sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} textureProperty - The texture property.
   * @param {string} uvSnippet - The uv snippet.
   * @param {?string} levelSnippet - The level snippet.
   * @param {?string} biasSnippet - The bias snippet.
   * @param {?string} depthSnippet - The depth snippet.
   * @param {?string} compareSnippet - The compare snippet.
   * @param {?Array<string>} gradSnippet - The grad snippet.
   * @param {?string} offsetSnippet - The offset snippet.
   * @return {string} The generated code snippet.
   */ generateSnippet(e, t, i, n, s, a, o, g, l) {
        const c = this.value;
        let d;
        return s ? d = e.generateTextureBias(c, t, i, s, a, l) : g ? d = e.generateTextureGrad(c, t, i, g, a, l) : o ? d = e.generateTextureCompare(c, t, i, o, a, l) : this.sampler === !1 ? d = e.generateTextureLoad(c, t, i, n, a, l) : n ? d = e.generateTextureLevel(c, t, i, n, a, l) : d = e.generateTexture(c, t, i, a, l), d;
    }
    /**
   * Generates the code snippet of the texture node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The current output.
   * @return {string} The generated code snippet.
   */ generate(e, t) {
        const i = this.value, n = e.getNodeProperties(this), s = super.generate(e, "property");
        if (/^sampler/.test(t)) return s + "_sampler";
        if (e.isReference(t)) return s;
        {
            const a = e.getDataFromNode(this);
            let o = a.propertyName;
            if (o === void 0) {
                const { uvNode: c, levelNode: d, biasNode: p, compareNode: A, depthNode: y, gradNode: G, offsetNode: Z } = n, v = this.generateUV(e, c), V = d ? d.build(e, "float") : null, H = p ? p.build(e, "float") : null, N = y ? y.build(e, "int") : null, Y = A ? A.build(e, "float") : null, K = G ? [
                    G[0].build(e, "vec2"),
                    G[1].build(e, "vec2")
                ] : null, z = Z ? this.generateOffset(e, Z) : null, M = e.getVarFromNode(this);
                o = e.getPropertyName(M);
                const _ = this.generateSnippet(e, s, v, V, H, N, Y, K, z);
                e.addLineFlowCode(`${o} = ${_}`, this), a.snippet = _, a.propertyName = o;
            }
            let g = o;
            const l = this.getNodeType(e);
            return e.needsToWorkingColorSpace(i) && (g = $d7238066c5de7f1c$var$vR($d7238066c5de7f1c$var$ZI(g, l), i.colorSpace).setup(e).build(e, l)), e.format(g, l, t);
        }
    }
    /**
   * Sets the sampler value.
   *
   * @param {boolean} value - The sampler value to set.
   * @return {TextureNode} A reference to this texture node.
   */ setSampler(e) {
        return this.sampler = e, this;
    }
    /**
   * Returns the sampler value.
   *
   * @return {boolean} The sampler value.
   */ getSampler() {
        return this.sampler;
    }
    // @TODO: Move to TSL
    /**
   * @function
   * @deprecated since r172. Use {@link TextureNode#sample} instead.
   *
   * @param {Node} uvNode - The uv node.
   * @return {TextureNode} A texture node representing the texture sample.
   */ uv(e) {
        return $d7238066c5de7f1c$var$ze("TextureNode: .uv() has been renamed. Use .sample() instead."), this.sample(e);
    }
    /**
   * Samples the texture with the given uv node.
   *
   * @param {Node} uvNode - The uv node.
   * @return {TextureNode} A texture node representing the texture sample.
   */ sample(e) {
        const t = this.clone();
        return t.uvNode = $d7238066c5de7f1c$var$He(e), t.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(t);
    }
    /**
   * TSL function for creating a texture node that fetches/loads texels without interpolation.
   *
   * @param {Node<uvec2>} uvNode - The uv node.
   * @returns {TextureNode} A texture node representing the texture load.
   */ load(e) {
        return this.sample(e).setSampler(!1);
    }
    /**
   * Samples a blurred version of the texture by defining an internal bias.
   *
   * @param {Node<float>} amountNode - How blurred the texture should be.
   * @return {TextureNode} A texture node representing the texture sample.
   */ blur(e) {
        const t = this.clone();
        t.biasNode = $d7238066c5de7f1c$var$He(e).mul($d7238066c5de7f1c$var$OL(t)), t.referenceNode = this.getBase();
        const i = t.value;
        return t.generateMipmaps === !1 && (i && i.generateMipmaps === !1 || i.minFilter === $d7238066c5de7f1c$var$Sr || i.magFilter === $d7238066c5de7f1c$var$Sr) && ($d7238066c5de7f1c$var$ze("TSL: texture().blur() requires mipmaps and sampling. Use .generateMipmaps=true and .minFilter/.magFilter=THREE.LinearFilter in the Texture."), t.biasNode = null), $d7238066c5de7f1c$var$He(t);
    }
    /**
   * Samples a specific mip of the texture.
   *
   * @param {Node<int>} levelNode - The mip level to sample.
   * @return {TextureNode} A texture node representing the texture sample.
   */ level(e) {
        const t = this.clone();
        return t.levelNode = $d7238066c5de7f1c$var$He(e), t.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(t);
    }
    /**
   * Returns the texture size of the requested level.
   *
   * @param {Node<int>} levelNode - The level to compute the size for.
   * @return {TextureSizeNode} The texture size.
   */ size(e) {
        return $d7238066c5de7f1c$var$mI(this, e);
    }
    /**
   * Samples the texture with the given bias.
   *
   * @param {Node<float>} biasNode - The bias node.
   * @return {TextureNode} A texture node representing the texture sample.
   */ bias(e) {
        const t = this.clone();
        return t.biasNode = $d7238066c5de7f1c$var$He(e), t.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(t);
    }
    /**
   * Returns the base texture of this node.
   * @return {TextureNode} The base texture node.
   */ getBase() {
        return this.referenceNode ? this.referenceNode.getBase() : this;
    }
    /**
   * Samples the texture by executing a compare operation.
   *
   * @param {Node<float>} compareNode - The node that defines the compare value.
   * @return {TextureNode} A texture node representing the texture sample.
   */ compare(e) {
        const t = this.clone();
        return t.compareNode = $d7238066c5de7f1c$var$He(e), t.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(t);
    }
    /**
   * Samples the texture using an explicit gradient.
   *
   * @param {Node<vec2>} gradNodeX - The gradX node.
   * @param {Node<vec2>} gradNodeY - The gradY node.
   * @return {TextureNode} A texture node representing the texture sample.
   */ grad(e, t) {
        const i = this.clone();
        return i.gradNode = [
            $d7238066c5de7f1c$var$He(e),
            $d7238066c5de7f1c$var$He(t)
        ], i.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(i);
    }
    /**
   * Samples the texture by defining a depth node.
   *
   * @param {Node<int>} depthNode - The depth node.
   * @return {TextureNode} A texture node representing the texture sample.
   */ depth(e) {
        const t = this.clone();
        return t.depthNode = $d7238066c5de7f1c$var$He(e), t.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(t);
    }
    /**
   * Samples the texture by defining an offset node.
   *
   * @param {Node<ivec2>} offsetNode - The offset node.
   * @return {TextureNode} A texture node representing the texture sample.
   */ offset(e) {
        const t = this.clone();
        return t.offsetNode = $d7238066c5de7f1c$var$He(e), t.referenceNode = this.getBase(), $d7238066c5de7f1c$var$He(t);
    }
    // --
    serialize(e) {
        super.serialize(e), e.value = this.value.toJSON(e.meta).uuid, e.sampler = this.sampler, e.updateMatrix = this.updateMatrix, e.updateType = this.updateType;
    }
    deserialize(e) {
        super.deserialize(e), this.value = e.meta.textures[e.value], this.sampler = e.sampler, this.updateMatrix = e.updateMatrix, this.updateType = e.updateType;
    }
    /**
   * The update is used to implement the update of the uv transformation matrix.
   */ update() {
        const e = this.value, t = this._matrixUniform;
        t !== null && (t.value = e.matrix), e.matrixAutoUpdate === !0 && e.updateMatrix();
        const i = this._flipYUniform;
        i !== null && (i.value = e.image instanceof ImageBitmap && e.flipY === !0 || e.isRenderTargetTexture === !0 || e.isFramebufferTexture === !0 || e.isDepthTexture === !0);
    }
    /**
   * Clones the texture node.
   *
   * @return {TextureNode} The cloned texture node.
   */ clone() {
        const e = new this.constructor(this.value, this.uvNode, this.levelNode, this.biasNode);
        return e.sampler = this.sampler, e.depthNode = this.depthNode, e.compareNode = this.compareNode, e.gradNode = this.gradNode, e.offsetNode = this.offsetNode, e;
    }
}
const $d7238066c5de7f1c$var$Tte = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Iu).setParameterLength(1, 4).setName("texture"), $d7238066c5de7f1c$var$ni = (r = $d7238066c5de7f1c$var$jL, e = null, t = null, i = null)=>{
    let n;
    return r && r.isTextureNode === !0 ? (n = $d7238066c5de7f1c$var$He(r.clone()), n.referenceNode = r.getBase(), e !== null && (n.uvNode = $d7238066c5de7f1c$var$He(e)), t !== null && (n.levelNode = $d7238066c5de7f1c$var$He(t)), i !== null && (n.biasNode = $d7238066c5de7f1c$var$He(i))) : n = $d7238066c5de7f1c$var$Tte(r, e, t, i), n;
}, $d7238066c5de7f1c$var$Mte = (r = $d7238066c5de7f1c$var$jL)=>$d7238066c5de7f1c$var$ni(r), $d7238066c5de7f1c$var$ys = (...r)=>$d7238066c5de7f1c$var$ni(...r).setSampler(!1), $d7238066c5de7f1c$var$zte = (r, e, t)=>$d7238066c5de7f1c$var$ni(r, e).level(t), $d7238066c5de7f1c$var$kte = (r)=>(r.isNode === !0 ? r : $d7238066c5de7f1c$var$ni(r)).convert("sampler"), $d7238066c5de7f1c$var$Ete = (r)=>(r.isNode === !0 ? r : $d7238066c5de7f1c$var$ni(r)).convert("samplerComparison");
class $d7238066c5de7f1c$var$qL extends $d7238066c5de7f1c$var$JB {
    static get type() {
        return "BufferNode";
    }
    /**
   * Constructs a new buffer node.
   *
   * @param {Array<number>} value - Array-like buffer data.
   * @param {string} bufferType - The data type of the buffer.
   * @param {number} [bufferCount=0] - The count of buffer elements.
   */ constructor(e, t, i = 0){
        super(e, t), this.isBufferNode = !0, this.bufferType = t, this.bufferCount = i;
    }
    /**
   * The data type of the buffer elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The element type.
   */ getElementType(e) {
        return this.getNodeType(e);
    }
    /**
   * Overwrites the default implementation to return a fixed value `'buffer'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return "buffer";
    }
}
const $d7238066c5de7f1c$var$PB = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$qL(r, e, t));
class $d7238066c5de7f1c$var$Jte extends $d7238066c5de7f1c$var$jC {
    static get type() {
        return "UniformArrayElementNode";
    }
    /**
   * Constructs a new buffer node.
   *
   * @param {UniformArrayNode} uniformArrayNode - The uniform array node to access.
   * @param {IndexNode} indexNode - The index data that define the position of the accessed element in the array.
   */ constructor(e, t){
        super(e, t), this.isArrayBufferElementNode = !0;
    }
    generate(e) {
        const t = super.generate(e), i = this.getNodeType(), n = this.node.getPaddedType();
        return e.format(t, n, i);
    }
}
class $d7238066c5de7f1c$var$Ute extends $d7238066c5de7f1c$var$qL {
    static get type() {
        return "UniformArrayNode";
    }
    /**
   * Constructs a new uniform array node.
   *
   * @param {Array<any>} value - Array holding the buffer data.
   * @param {?string} [elementType=null] - The data type of a buffer element.
   */ constructor(e, t = null){
        super(null), this.array = e, this.elementType = t === null ? $d7238066c5de7f1c$var$jd(e[0]) : t, this.paddedType = this.getPaddedType(), this.updateType = $d7238066c5de7f1c$var$Dt.RENDER, this.isArrayBufferNode = !0;
    }
    /**
   * This method is overwritten since the node type is inferred from the
   * {@link UniformArrayNode#paddedType}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType() {
        return this.paddedType;
    }
    /**
   * The data type of the array elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The element type.
   */ getElementType() {
        return this.elementType;
    }
    /**
   * Returns the padded type based on the element type.
   *
   * @return {string} The padded type.
   */ getPaddedType() {
        const e = this.elementType;
        let t = "vec4";
        return e === "mat2" ? t = "mat2" : /mat/.test(e) === !0 ? t = "mat4" : e.charAt(0) === "i" ? t = "ivec4" : e.charAt(0) === "u" && (t = "uvec4"), t;
    }
    /**
   * The update makes sure to correctly transfer the data from the (complex) objects
   * in the array to the internal, correctly padded value buffer.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update() {
        const { array: e, value: t } = this, i = this.elementType;
        if (i === "float" || i === "int" || i === "uint") for(let n = 0; n < e.length; n++){
            const s = n * 4;
            t[s] = e[n];
        }
        else if (i === "color") for(let n = 0; n < e.length; n++){
            const s = n * 4, a = e[n];
            t[s] = a.r, t[s + 1] = a.g, t[s + 2] = a.b || 0;
        }
        else if (i === "mat2") for(let n = 0; n < e.length; n++){
            const s = n * 4, a = e[n];
            t[s] = a.elements[0], t[s + 1] = a.elements[1], t[s + 2] = a.elements[2], t[s + 3] = a.elements[3];
        }
        else if (i === "mat3") for(let n = 0; n < e.length; n++){
            const s = n * 16, a = e[n];
            t[s] = a.elements[0], t[s + 1] = a.elements[1], t[s + 2] = a.elements[2], t[s + 4] = a.elements[3], t[s + 5] = a.elements[4], t[s + 6] = a.elements[5], t[s + 8] = a.elements[6], t[s + 9] = a.elements[7], t[s + 10] = a.elements[8], t[s + 15] = 1;
        }
        else if (i === "mat4") for(let n = 0; n < e.length; n++){
            const s = n * 16, a = e[n];
            for(let o = 0; o < a.elements.length; o++)t[s + o] = a.elements[o];
        }
        else for(let n = 0; n < e.length; n++){
            const s = n * 4, a = e[n];
            t[s] = a.x, t[s + 1] = a.y, t[s + 2] = a.z || 0, t[s + 3] = a.w || 0;
        }
    }
    /**
   * Implement the value buffer creation based on the array data.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {null}
   */ setup(e) {
        const t = this.array.length, i = this.elementType;
        let n = Float32Array;
        const s = this.paddedType, a = e.getTypeLength(s);
        return i.charAt(0) === "i" && (n = Int32Array), i.charAt(0) === "u" && (n = Uint32Array), this.value = new n(t * a), this.bufferCount = t, this.bufferType = s, super.setup(e);
    }
    /**
   * Overwrites the default `element()` method to provide element access
   * based on {@link UniformArrayNode}.
   *
   * @param {IndexNode} indexNode - The index node.
   * @return {UniformArrayElementNode}
   */ element(e) {
        return $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Jte(this, $d7238066c5de7f1c$var$He(e)));
    }
}
const $d7238066c5de7f1c$var$La = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Ute(r, e));
class $d7238066c5de7f1c$var$Dte extends $d7238066c5de7f1c$var$Ct {
    /**
   * Constructs a new builtin node.
   *
   * @param {string} name - The name of the built-in shader variable.
   */ constructor(e){
        super("float"), this.name = e, this.isBuiltinNode = !0;
    }
    /**
   * Generates the code snippet of the builtin node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */ generate() {
        return this.name;
    }
}
const $d7238066c5de7f1c$var$HI = $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Dte).setParameterLength(1);
let $d7238066c5de7f1c$var$Yb, $d7238066c5de7f1c$var$Kb;
class $d7238066c5de7f1c$var$Ln extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ScreenNode";
    }
    /**
   * Constructs a new screen node.
   *
   * @param {('coordinate'|'viewport'|'size'|'uv'|'dpr')} scope - The node's scope.
   */ constructor(e){
        super(), this.scope = e, this._output = null, this.isViewportNode = !0;
    }
    /**
   * This method is overwritten since the node type depends on the selected scope.
   *
   * @return {('float'|'vec2'|'vec4')} The node type.
   */ getNodeType() {
        return this.scope === $d7238066c5de7f1c$var$Ln.DPR ? "float" : this.scope === $d7238066c5de7f1c$var$Ln.VIEWPORT ? "vec4" : "vec2";
    }
    /**
   * This method is overwritten since the node's update type depends on the selected scope.
   *
   * @return {NodeUpdateType} The update type.
   */ getUpdateType() {
        let e = $d7238066c5de7f1c$var$Dt.NONE;
        return (this.scope === $d7238066c5de7f1c$var$Ln.SIZE || this.scope === $d7238066c5de7f1c$var$Ln.VIEWPORT || this.scope === $d7238066c5de7f1c$var$Ln.DPR) && (e = $d7238066c5de7f1c$var$Dt.RENDER), this.updateType = e, e;
    }
    /**
   * `ScreenNode` implements {@link Node#update} to retrieve viewport and size information
   * from the current renderer.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update({ renderer: e }) {
        const t = e.getRenderTarget();
        this.scope === $d7238066c5de7f1c$var$Ln.VIEWPORT ? t !== null ? $d7238066c5de7f1c$var$Kb.copy(t.viewport) : (e.getViewport($d7238066c5de7f1c$var$Kb), $d7238066c5de7f1c$var$Kb.multiplyScalar(e.getPixelRatio())) : this.scope === $d7238066c5de7f1c$var$Ln.DPR ? this._output.value = e.getPixelRatio() : t !== null ? ($d7238066c5de7f1c$var$Yb.width = t.width, $d7238066c5de7f1c$var$Yb.height = t.height) : e.getDrawingBufferSize($d7238066c5de7f1c$var$Yb);
    }
    setup() {
        const e = this.scope;
        let t = null;
        return e === $d7238066c5de7f1c$var$Ln.SIZE ? t = $d7238066c5de7f1c$var$yt($d7238066c5de7f1c$var$Yb || ($d7238066c5de7f1c$var$Yb = new $d7238066c5de7f1c$var$Ii())) : e === $d7238066c5de7f1c$var$Ln.VIEWPORT ? t = $d7238066c5de7f1c$var$yt($d7238066c5de7f1c$var$Kb || ($d7238066c5de7f1c$var$Kb = new $d7238066c5de7f1c$var$Gi())) : e === $d7238066c5de7f1c$var$Ln.DPR ? t = $d7238066c5de7f1c$var$yt(1) : t = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$QB.div($d7238066c5de7f1c$var$EC)), this._output = t, t;
    }
    generate(e) {
        if (this.scope === $d7238066c5de7f1c$var$Ln.COORDINATE) {
            let t = e.getFragCoord();
            if (e.isFlipY()) {
                const i = e.getNodeProperties($d7238066c5de7f1c$var$EC).outputNode.build(e);
                t = `${e.getType("vec2")}( ${t}.x, ${i}.y - ${t}.y )`;
            }
            return t;
        }
        return super.generate(e);
    }
}
$d7238066c5de7f1c$var$Ln.COORDINATE = "coordinate";
$d7238066c5de7f1c$var$Ln.VIEWPORT = "viewport";
$d7238066c5de7f1c$var$Ln.SIZE = "size";
$d7238066c5de7f1c$var$Ln.UV = "uv";
$d7238066c5de7f1c$var$Ln.DPR = "dpr";
const $d7238066c5de7f1c$var$oJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Ln, $d7238066c5de7f1c$var$Ln.DPR), $d7238066c5de7f1c$var$AI = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Ln, $d7238066c5de7f1c$var$Ln.UV), $d7238066c5de7f1c$var$EC = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Ln, $d7238066c5de7f1c$var$Ln.SIZE), $d7238066c5de7f1c$var$QB = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Ln, $d7238066c5de7f1c$var$Ln.COORDINATE), $d7238066c5de7f1c$var$$L = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Ln, $d7238066c5de7f1c$var$Ln.VIEWPORT), $d7238066c5de7f1c$var$eY = $d7238066c5de7f1c$var$$L.zw, $d7238066c5de7f1c$var$gJ = /* @__PURE__ */ $d7238066c5de7f1c$var$QB.sub($d7238066c5de7f1c$var$$L.xy), $d7238066c5de7f1c$var$_te = /* @__PURE__ */ $d7238066c5de7f1c$var$gJ.div($d7238066c5de7f1c$var$eY), $d7238066c5de7f1c$var$Pte = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(()=>($d7238066c5de7f1c$var$ze('TSL: "viewportResolution" is deprecated. Use "screenSize" instead.'), $d7238066c5de7f1c$var$EC), "vec2").once()(), $d7238066c5de7f1c$var$uh = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(0, "uint").setName("u_cameraIndex").setGroup($d7238066c5de7f1c$var$bR("cameraIndex")).toVarying("v_cameraIndex"), $d7238066c5de7f1c$var$_d = /* @__PURE__ */ $d7238066c5de7f1c$var$yt("float").setName("cameraNear").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: r })=>r.near), $d7238066c5de7f1c$var$Pd = /* @__PURE__ */ $d7238066c5de7f1c$var$yt("float").setName("cameraFar").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: r })=>r.far), $d7238066c5de7f1c$var$s0 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for (const n of r.cameras)t.push(n.projectionMatrix);
        e = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft).setName("cameraProjectionMatrices").element(r.isMultiViewCamera ? $d7238066c5de7f1c$var$HI("gl_ViewID_OVR") : $d7238066c5de7f1c$var$uh).toConst("cameraProjectionMatrix");
    } else e = $d7238066c5de7f1c$var$yt("mat4").setName("cameraProjectionMatrix").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t })=>t.projectionMatrix);
    return e;
}).once()(), $d7238066c5de7f1c$var$Qte = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for (const n of r.cameras)t.push(n.projectionMatrixInverse);
        e = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft).setName("cameraProjectionMatricesInverse").element(r.isMultiViewCamera ? $d7238066c5de7f1c$var$HI("gl_ViewID_OVR") : $d7238066c5de7f1c$var$uh).toConst("cameraProjectionMatrixInverse");
    } else e = $d7238066c5de7f1c$var$yt("mat4").setName("cameraProjectionMatrixInverse").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t })=>t.projectionMatrixInverse);
    return e;
}).once()(), $d7238066c5de7f1c$var$ol = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for (const n of r.cameras)t.push(n.matrixWorldInverse);
        e = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft).setName("cameraViewMatrices").element(r.isMultiViewCamera ? $d7238066c5de7f1c$var$HI("gl_ViewID_OVR") : $d7238066c5de7f1c$var$uh).toConst("cameraViewMatrix");
    } else e = $d7238066c5de7f1c$var$yt("mat4").setName("cameraViewMatrix").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t })=>t.matrixWorldInverse);
    return e;
}).once()(), $d7238066c5de7f1c$var$Ote = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for (const n of r.cameras)t.push(n.matrixWorld);
        e = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft).setName("cameraWorldMatrices").element(r.isMultiViewCamera ? $d7238066c5de7f1c$var$HI("gl_ViewID_OVR") : $d7238066c5de7f1c$var$uh).toConst("cameraWorldMatrix");
    } else e = $d7238066c5de7f1c$var$yt("mat4").setName("cameraWorldMatrix").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t })=>t.matrixWorld);
    return e;
}).once()(), $d7238066c5de7f1c$var$jte = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for (const n of r.cameras)t.push(n.normalMatrix);
        e = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft).setName("cameraNormalMatrices").element(r.isMultiViewCamera ? $d7238066c5de7f1c$var$HI("gl_ViewID_OVR") : $d7238066c5de7f1c$var$uh).toConst("cameraNormalMatrix");
    } else e = $d7238066c5de7f1c$var$yt("mat3").setName("cameraNormalMatrix").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t })=>t.normalMatrix);
    return e;
}).once()(), $d7238066c5de7f1c$var$lJ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for(let n = 0, s = r.cameras.length; n < s; n++)t.push(new $d7238066c5de7f1c$var$Ce());
        e = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft).setName("cameraPositions").onRenderUpdate(({ camera: n }, s)=>{
            const a = n.cameras, o = s.array;
            for(let g = 0, l = a.length; g < l; g++)o[g].setFromMatrixPosition(a[g].matrixWorld);
        }).element(r.isMultiViewCamera ? $d7238066c5de7f1c$var$HI("gl_ViewID_OVR") : $d7238066c5de7f1c$var$uh).toConst("cameraPosition");
    } else e = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce()).setName("cameraPosition").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t }, i)=>i.value.setFromMatrixPosition(t.matrixWorld));
    return e;
}).once()(), $d7238066c5de7f1c$var$qte = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ camera: r })=>{
    let e;
    if (r.isArrayCamera && r.cameras.length > 0) {
        const t = [];
        for (const n of r.cameras)t.push(n.viewport);
        e = $d7238066c5de7f1c$var$La(t, "vec4").setGroup($d7238066c5de7f1c$var$ft).setName("cameraViewports").element($d7238066c5de7f1c$var$uh).toConst("cameraViewport");
    } else e = $d7238066c5de7f1c$var$Rt(0, 0, $d7238066c5de7f1c$var$EC.x, $d7238066c5de7f1c$var$EC.y).toConst("cameraViewport");
    return e;
}).once()(), $d7238066c5de7f1c$var$J5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$lR();
class $d7238066c5de7f1c$var$Xi extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "Object3DNode";
    }
    /**
   * Constructs a new object 3D node.
   *
   * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
   * @param {?Object3D} [object3d=null] - The 3D object.
   */ constructor(e, t = null){
        super(), this.scope = e, this.object3d = t, this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT, this.uniformNode = new $d7238066c5de7f1c$var$JB(null);
    }
    /**
   * Overwritten since the node type is inferred from the scope.
   *
   * @return {('mat4'|'vec3'|'float')} The node type.
   */ getNodeType() {
        const e = this.scope;
        if (e === $d7238066c5de7f1c$var$Xi.WORLD_MATRIX) return "mat4";
        if (e === $d7238066c5de7f1c$var$Xi.POSITION || e === $d7238066c5de7f1c$var$Xi.VIEW_POSITION || e === $d7238066c5de7f1c$var$Xi.DIRECTION || e === $d7238066c5de7f1c$var$Xi.SCALE) return "vec3";
        if (e === $d7238066c5de7f1c$var$Xi.RADIUS) return "float";
    }
    /**
   * Updates the uniform value depending on the scope.
   *
   * @param {NodeFrame} frame - The current node frame.
   */ update(e) {
        const t = this.object3d, i = this.uniformNode, n = this.scope;
        if (n === $d7238066c5de7f1c$var$Xi.WORLD_MATRIX) i.value = t.matrixWorld;
        else if (n === $d7238066c5de7f1c$var$Xi.POSITION) i.value = i.value || new $d7238066c5de7f1c$var$Ce(), i.value.setFromMatrixPosition(t.matrixWorld);
        else if (n === $d7238066c5de7f1c$var$Xi.SCALE) i.value = i.value || new $d7238066c5de7f1c$var$Ce(), i.value.setFromMatrixScale(t.matrixWorld);
        else if (n === $d7238066c5de7f1c$var$Xi.DIRECTION) i.value = i.value || new $d7238066c5de7f1c$var$Ce(), t.getWorldDirection(i.value);
        else if (n === $d7238066c5de7f1c$var$Xi.VIEW_POSITION) {
            const s = e.camera;
            i.value = i.value || new $d7238066c5de7f1c$var$Ce(), i.value.setFromMatrixPosition(t.matrixWorld), i.value.applyMatrix4(s.matrixWorldInverse);
        } else if (n === $d7238066c5de7f1c$var$Xi.RADIUS) {
            const s = e.object.geometry;
            s.boundingSphere === null && s.computeBoundingSphere(), $d7238066c5de7f1c$var$J5.copy(s.boundingSphere).applyMatrix4(t.matrixWorld), i.value = $d7238066c5de7f1c$var$J5.radius;
        }
    }
    /**
   * Generates the code snippet of the uniform node. The node type of the uniform
   * node also depends on the selected scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */ generate(e) {
        const t = this.scope;
        return t === $d7238066c5de7f1c$var$Xi.WORLD_MATRIX ? this.uniformNode.nodeType = "mat4" : t === $d7238066c5de7f1c$var$Xi.POSITION || t === $d7238066c5de7f1c$var$Xi.VIEW_POSITION || t === $d7238066c5de7f1c$var$Xi.DIRECTION || t === $d7238066c5de7f1c$var$Xi.SCALE ? this.uniformNode.nodeType = "vec3" : t === $d7238066c5de7f1c$var$Xi.RADIUS && (this.uniformNode.nodeType = "float"), this.uniformNode.build(e);
    }
    serialize(e) {
        super.serialize(e), e.scope = this.scope;
    }
    deserialize(e) {
        super.deserialize(e), this.scope = e.scope;
    }
}
$d7238066c5de7f1c$var$Xi.WORLD_MATRIX = "worldMatrix";
$d7238066c5de7f1c$var$Xi.POSITION = "position";
$d7238066c5de7f1c$var$Xi.SCALE = "scale";
$d7238066c5de7f1c$var$Xi.VIEW_POSITION = "viewPosition";
$d7238066c5de7f1c$var$Xi.DIRECTION = "direction";
$d7238066c5de7f1c$var$Xi.RADIUS = "radius";
const $d7238066c5de7f1c$var$$te = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xi, $d7238066c5de7f1c$var$Xi.DIRECTION).setParameterLength(1), $d7238066c5de7f1c$var$eie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xi, $d7238066c5de7f1c$var$Xi.WORLD_MATRIX).setParameterLength(1), $d7238066c5de7f1c$var$cJ = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xi, $d7238066c5de7f1c$var$Xi.POSITION).setParameterLength(1), $d7238066c5de7f1c$var$tie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xi, $d7238066c5de7f1c$var$Xi.SCALE).setParameterLength(1), $d7238066c5de7f1c$var$iie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xi, $d7238066c5de7f1c$var$Xi.VIEW_POSITION).setParameterLength(1), $d7238066c5de7f1c$var$nie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xi, $d7238066c5de7f1c$var$Xi.RADIUS).setParameterLength(1);
class $d7238066c5de7f1c$var$rl extends $d7238066c5de7f1c$var$Xi {
    static get type() {
        return "ModelNode";
    }
    /**
   * Constructs a new object model node.
   *
   * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
   */ constructor(e){
        super(e);
    }
    /**
   * Extracts the model reference from the frame state and then
   * updates the uniform value depending on the scope.
   *
   * @param {NodeFrame} frame - The current node frame.
   */ update(e) {
        this.object3d = e.object, super.update(e);
    }
}
const $d7238066c5de7f1c$var$sie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$rl, $d7238066c5de7f1c$var$rl.DIRECTION), $d7238066c5de7f1c$var$$g = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$rl, $d7238066c5de7f1c$var$rl.WORLD_MATRIX), $d7238066c5de7f1c$var$rie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$rl, $d7238066c5de7f1c$var$rl.POSITION), $d7238066c5de7f1c$var$aie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$rl, $d7238066c5de7f1c$var$rl.SCALE), $d7238066c5de7f1c$var$oie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$rl, $d7238066c5de7f1c$var$rl.VIEW_POSITION), $d7238066c5de7f1c$var$gie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$rl, $d7238066c5de7f1c$var$rl.RADIUS), $d7238066c5de7f1c$var$uJ = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Lo()).onObjectUpdate(({ object: r }, e)=>e.value.getNormalMatrix(r.matrixWorld)), $d7238066c5de7f1c$var$lie = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ji()).onObjectUpdate(({ object: r }, e)=>e.value.copy(r.matrixWorld).invert()), $d7238066c5de7f1c$var$qC = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>r.renderer.overrideNodes.modelViewMatrix || $d7238066c5de7f1c$var$IJ).once()().toVar("modelViewMatrix"), $d7238066c5de7f1c$var$IJ = /* @__PURE__ */ $d7238066c5de7f1c$var$ol.mul($d7238066c5de7f1c$var$$g), $d7238066c5de7f1c$var$N2 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>(r.context.isHighPrecisionModelViewMatrix = !0, $d7238066c5de7f1c$var$yt("mat4").onObjectUpdate(({ object: e, camera: t })=>e.modelViewMatrix.multiplyMatrices(t.matrixWorldInverse, e.matrixWorld)))).once()().toVar("highpModelViewMatrix"), $d7238066c5de7f1c$var$L2 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    const e = r.context.isHighPrecisionModelViewMatrix;
    return $d7238066c5de7f1c$var$yt("mat3").onObjectUpdate(({ object: t, camera: i })=>(e !== !0 && t.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix)));
}).once()().toVar("highpModelNormalViewMatrix"), $d7238066c5de7f1c$var$OB = /* @__PURE__ */ $d7238066c5de7f1c$var$RI("position", "vec3"), $d7238066c5de7f1c$var$Ns = /* @__PURE__ */ $d7238066c5de7f1c$var$OB.toVarying("positionLocal"), $d7238066c5de7f1c$var$NZ = /* @__PURE__ */ $d7238066c5de7f1c$var$OB.toVarying("positionPrevious"), $d7238066c5de7f1c$var$ou = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>$d7238066c5de7f1c$var$$g.mul($d7238066c5de7f1c$var$Ns).xyz.toVarying(r.getSubBuildProperty("v_positionWorld")), "vec3").once([
    "POSITION"
])(), $d7238066c5de7f1c$var$tY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(()=>$d7238066c5de7f1c$var$Ns.transformDirection($d7238066c5de7f1c$var$$g).toVarying("v_positionWorldDirection").normalize().toVar("positionWorldDirection"), "vec3").once([
    "POSITION"
])(), $d7238066c5de7f1c$var$Ls = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>r.context.setupPositionView().toVarying("v_positionView"), "vec3").once([
    "POSITION"
])(), $d7238066c5de7f1c$var$kn = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    let e;
    return r.camera.isOrthographicCamera ? e = $d7238066c5de7f1c$var$ne(0, 0, 1) : e = $d7238066c5de7f1c$var$Ls.negate().toVarying("v_positionViewDirection").normalize(), e.toVar("positionViewDirection");
}, "vec3").once([
    "POSITION"
])();
class $d7238066c5de7f1c$var$cie extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "FrontFacingNode";
    }
    /**
   * Constructs a new front facing node.
   */ constructor(){
        super("bool"), this.isFrontFacingNode = !0;
    }
    generate(e) {
        if (e.shaderStage !== "fragment") return "true";
        const { material: t } = e;
        return t.side === $d7238066c5de7f1c$var$Ka ? "false" : e.getFrontFacing();
    }
}
const $d7238066c5de7f1c$var$dJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$cie), $d7238066c5de7f1c$var$iY = /* @__PURE__ */ $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$dJ).mul(2).sub(1), $d7238066c5de7f1c$var$r0 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r], { material: e })=>{
    const t = e.side;
    return t === $d7238066c5de7f1c$var$Ka ? r = r.mul(-1) : t === $d7238066c5de7f1c$var$YC && (r = r.mul($d7238066c5de7f1c$var$iY)), r;
}), $d7238066c5de7f1c$var$SR = /* @__PURE__ */ $d7238066c5de7f1c$var$RI("normal", "vec3"), $d7238066c5de7f1c$var$No = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>r.geometry.hasAttribute("normal") === !1 ? ($d7238066c5de7f1c$var$ze('TSL: Vertex attribute "normal" not found on geometry.'), $d7238066c5de7f1c$var$ne(0, 1, 0)) : $d7238066c5de7f1c$var$SR, "vec3").once()().toVar("normalLocal"), $d7238066c5de7f1c$var$hJ = /* @__PURE__ */ $d7238066c5de7f1c$var$Ls.dFdx().cross($d7238066c5de7f1c$var$Ls.dFdy()).normalize().toVar("normalFlat"), $d7238066c5de7f1c$var$kA = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    let e;
    return r.material.flatShading === !0 ? e = $d7238066c5de7f1c$var$hJ : e = $d7238066c5de7f1c$var$nY($d7238066c5de7f1c$var$No).toVarying("v_normalViewGeometry").normalize(), e;
}, "vec3").once()().toVar("normalViewGeometry"), $d7238066c5de7f1c$var$CJ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    let e = $d7238066c5de7f1c$var$kA.transformDirection($d7238066c5de7f1c$var$ol);
    return r.material.flatShading !== !0 && (e = e.toVarying("v_normalWorldGeometry")), e.normalize().toVar("normalWorldGeometry");
}, "vec3").once()(), $d7238066c5de7f1c$var$gn = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ subBuildFn: r, material: e, context: t })=>{
    let i;
    return r === "NORMAL" || r === "VERTEX" ? (i = $d7238066c5de7f1c$var$kA, e.flatShading !== !0 && (i = $d7238066c5de7f1c$var$r0(i))) : i = t.setupNormal().context({
        getUV: null
    }), i;
}, "vec3").once([
    "NORMAL",
    "VERTEX"
])().toVar("normalView"), $d7238066c5de7f1c$var$Ih = /* @__PURE__ */ $d7238066c5de7f1c$var$gn.transformDirection($d7238066c5de7f1c$var$ol).toVar("normalWorld"), $d7238066c5de7f1c$var$HC = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ subBuildFn: r, context: e })=>{
    let t;
    return r === "NORMAL" || r === "VERTEX" ? t = $d7238066c5de7f1c$var$gn : t = e.setupClearcoatNormal().context({
        getUV: null
    }), t;
}, "vec3").once([
    "NORMAL",
    "VERTEX"
])().toVar("clearcoatNormalView"), $d7238066c5de7f1c$var$pJ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e = $d7238066c5de7f1c$var$$g])=>{
    const t = $d7238066c5de7f1c$var$Fa(e), i = r.div($d7238066c5de7f1c$var$ne(t[0].dot(t[0]), t[1].dot(t[1]), t[2].dot(t[2])));
    return t.mul(i).xyz;
}), $d7238066c5de7f1c$var$nY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r], e)=>{
    const t = e.renderer.overrideNodes.modelNormalViewMatrix;
    if (t !== null) return t.transformDirection(r);
    const i = $d7238066c5de7f1c$var$uJ.mul(r);
    return $d7238066c5de7f1c$var$ol.transformDirection(i);
}), $d7238066c5de7f1c$var$uie = $d7238066c5de7f1c$var$oe(()=>($d7238066c5de7f1c$var$ze('TSL: "transformedNormalView" is deprecated. Use "normalView" instead.'), $d7238066c5de7f1c$var$gn)).once([
    "NORMAL",
    "VERTEX"
])(), $d7238066c5de7f1c$var$Iie = $d7238066c5de7f1c$var$oe(()=>($d7238066c5de7f1c$var$ze('TSL: "transformedNormalWorld" is deprecated. Use "normalWorld" instead.'), $d7238066c5de7f1c$var$Ih)).once([
    "NORMAL",
    "VERTEX"
])(), $d7238066c5de7f1c$var$die = $d7238066c5de7f1c$var$oe(()=>($d7238066c5de7f1c$var$ze('TSL: "transformedClearcoatNormalView" is deprecated. Use "clearcoatNormalView" instead.'), $d7238066c5de7f1c$var$HC)).once([
    "NORMAL",
    "VERTEX"
])(), $d7238066c5de7f1c$var$U5 = /* @__PURE__ */ new $d7238066c5de7f1c$var$il(), $d7238066c5de7f1c$var$uH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$mJ = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(0).onReference(({ material: r })=>r).onObjectUpdate(({ material: r })=>r.refractionRatio), $d7238066c5de7f1c$var$wS = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(1).onReference(({ material: r })=>r).onObjectUpdate(function({ material: r, scene: e }) {
    return r.envMap ? r.envMapIntensity : e.environmentIntensity;
}), $d7238066c5de7f1c$var$sY = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ji()).onReference(function(r) {
    return r.material;
}).onObjectUpdate(function({ material: r, scene: e }) {
    const t = e.environment !== null && r.envMap === null ? e.environmentRotation : r.envMapRotation;
    return t ? ($d7238066c5de7f1c$var$U5.copy(t), $d7238066c5de7f1c$var$uH.makeRotationFromEuler($d7238066c5de7f1c$var$U5)) : $d7238066c5de7f1c$var$uH.identity(), $d7238066c5de7f1c$var$uH;
}), $d7238066c5de7f1c$var$AJ = /* @__PURE__ */ $d7238066c5de7f1c$var$kn.negate().reflect($d7238066c5de7f1c$var$gn), $d7238066c5de7f1c$var$bJ = /* @__PURE__ */ $d7238066c5de7f1c$var$kn.negate().refract($d7238066c5de7f1c$var$gn, $d7238066c5de7f1c$var$mJ), $d7238066c5de7f1c$var$yJ = /* @__PURE__ */ $d7238066c5de7f1c$var$AJ.transformDirection($d7238066c5de7f1c$var$ol).toVar("reflectVector"), $d7238066c5de7f1c$var$BJ = /* @__PURE__ */ $d7238066c5de7f1c$var$bJ.transformDirection($d7238066c5de7f1c$var$ol).toVar("reflectVector"), $d7238066c5de7f1c$var$fJ = /* @__PURE__ */ new $d7238066c5de7f1c$var$cR();
class $d7238066c5de7f1c$var$hie extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "CubeTextureNode";
    }
    /**
   * Constructs a new cube texture node.
   *
   * @param {CubeTexture} value - The cube texture.
   * @param {?Node<vec3>} [uvNode=null] - The uv node.
   * @param {?Node<int>} [levelNode=null] - The level node.
   * @param {?Node<float>} [biasNode=null] - The bias node.
   */ constructor(e, t = null, i = null, n = null){
        super(e, t, i, n), this.isCubeTextureNode = !0;
    }
    /**
   * Overwrites the default implementation to return a fixed value `'cubeTexture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return "cubeTexture";
    }
    /**
   * Returns a default uvs based on the mapping type of the cube texture.
   *
   * @return {Node<vec3>} The default uv attribute.
   */ getDefaultUV() {
        const e = this.value;
        return e.mapping === $d7238066c5de7f1c$var$gB ? $d7238066c5de7f1c$var$yJ : e.mapping === $d7238066c5de7f1c$var$$S ? $d7238066c5de7f1c$var$BJ : ($d7238066c5de7f1c$var$nt('CubeTextureNode: Mapping "%s" not supported.', e.mapping), $d7238066c5de7f1c$var$ne(0, 0, 0));
    }
    /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for cube textures. The uv transformation matrix is not applied to cube textures.
   *
   * @param {boolean} value - The update toggle.
   */ setUpdateMatrix() {}
    // Ignore .updateMatrix for CubeTextureNode
    /**
   * Setups the uv node. Depending on the backend as well as the texture type, it might be necessary
   * to modify the uv node for correct sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The updated uv node.
   */ setupUV(e, t) {
        const i = this.value;
        return (e.renderer.coordinateSystem === $d7238066c5de7f1c$var$uu || !i.isRenderTargetTexture) && (t = $d7238066c5de7f1c$var$ne(t.x.negate(), t.yz)), $d7238066c5de7f1c$var$sY.mul(t);
    }
    /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} cubeUV - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */ generateUV(e, t) {
        return t.build(e, this.sampler === !0 ? "vec3" : "ivec3");
    }
}
const $d7238066c5de7f1c$var$rY = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$hie).setParameterLength(1, 4).setName("cubeTexture"), $d7238066c5de7f1c$var$EA = (r = $d7238066c5de7f1c$var$fJ, e = null, t = null, i = null)=>{
    let n;
    return r && r.isCubeTextureNode === !0 ? (n = $d7238066c5de7f1c$var$He(r.clone()), n.referenceNode = r, e !== null && (n.uvNode = $d7238066c5de7f1c$var$He(e)), t !== null && (n.levelNode = $d7238066c5de7f1c$var$He(t)), i !== null && (n.biasNode = $d7238066c5de7f1c$var$He(i))) : n = $d7238066c5de7f1c$var$rY(r, e, t, i), n;
}, $d7238066c5de7f1c$var$Cie = (r = $d7238066c5de7f1c$var$fJ)=>$d7238066c5de7f1c$var$rY(r);
class $d7238066c5de7f1c$var$pie extends $d7238066c5de7f1c$var$jC {
    static get type() {
        return "ReferenceElementNode";
    }
    /**
   * Constructs a new reference element node.
   *
   * @param {?ReferenceNode} referenceNode - The reference node.
   * @param {Node} indexNode - The index node that defines the element access.
   */ constructor(e, t){
        super(e, t), this.referenceNode = e, this.isReferenceElementNode = !0;
    }
    /**
   * This method is overwritten since the node type is inferred from
   * the uniform type of the reference node.
   *
   * @return {string} The node type.
   */ getNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(e) {
        const t = super.generate(e), i = this.referenceNode.getNodeType(), n = this.getNodeType();
        return e.format(t, i, n);
    }
}
class $d7238066c5de7f1c$var$ZR extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ReferenceNode";
    }
    /**
   * Constructs a new reference node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} uniformType - The uniform type that should be used to represent the property value.
   * @param {?Object} [object=null] - The object the property belongs to.
   * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
   */ constructor(e, t, i = null, n = null){
        super(), this.property = e, this.uniformType = t, this.object = i, this.count = n, this.properties = e.split("."), this.reference = i, this.node = null, this.group = null, this.name = null, this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT;
    }
    /**
   * When the referred property is array-like, this method can be used
   * to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {ReferenceElementNode} A reference to an element.
   */ element(e) {
        return $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$pie(this, $d7238066c5de7f1c$var$He(e)));
    }
    /**
   * Sets the uniform group for this reference node.
   *
   * @param {UniformGroupNode} group - The uniform group to set.
   * @return {ReferenceNode} A reference to this node.
   */ setGroup(e) {
        return this.group = e, this;
    }
    /**
   * Sets the name for the internal uniform.
   *
   * @param {string} name - The label to set.
   * @return {ReferenceNode} A reference to this node.
   */ setName(e) {
        return this.name = e, this;
    }
    /**
   * Sets the label for the internal uniform.
   *
   * @deprecated
   * @param {string} name - The label to set.
   * @return {ReferenceNode} A reference to this node.
   */ label(e) {
        return $d7238066c5de7f1c$var$ze('TSL: "label()" has been deprecated. Use "setName()" instead.'), this.setName(e);
    }
    /**
   * Sets the node type which automatically defines the internal
   * uniform type.
   *
   * @param {string} uniformType - The type to set.
   */ setNodeType(e) {
        let t = null;
        this.count !== null ? t = $d7238066c5de7f1c$var$PB(null, e, this.count) : Array.isArray(this.getValueFromReference()) ? t = $d7238066c5de7f1c$var$La(null, e) : e === "texture" ? t = $d7238066c5de7f1c$var$ni(null) : e === "cubeTexture" ? t = $d7238066c5de7f1c$var$EA(null) : t = $d7238066c5de7f1c$var$yt(null, e), this.group !== null && t.setGroup(this.group), this.name !== null && t.setName(this.name), this.node = t;
    }
    /**
   * This method is overwritten since the node type is inferred from
   * the type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.node === null && (this.updateReference(e), this.updateValue()), this.node.getNodeType(e);
    }
    /**
   * Returns the property value from the given referred object.
   *
   * @param {Object} [object=this.reference] - The object to retrieve the property value from.
   * @return {any} The value.
   */ getValueFromReference(e = this.reference) {
        const { properties: t } = this;
        let i = e[t[0]];
        for(let n = 1; n < t.length; n++)i = i[t[n]];
        return i;
    }
    /**
   * Allows to update the reference based on the given state. The state is only
   * evaluated {@link ReferenceNode#object} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */ updateReference(e) {
        return this.reference = this.object !== null ? this.object : e.object, this.reference;
    }
    /**
   * The output of the reference node is the internal uniform node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {UniformNode} The output node.
   */ setup() {
        return this.updateValue(), this.node;
    }
    /**
   * Overwritten to update the internal uniform value.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update() {
        this.updateValue();
    }
    /**
   * Retrieves the value from the referred object property and uses it
   * to updated the internal uniform.
   */ updateValue() {
        this.node === null && this.setNodeType(this.uniformType);
        const e = this.getValueFromReference();
        Array.isArray(e) ? this.node.array = e : this.node.value = e;
    }
}
const $d7238066c5de7f1c$var$vn = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$ZR(r, e, t)), $d7238066c5de7f1c$var$Y2 = (r, e, t, i)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$ZR(r, e, i, t));
class $d7238066c5de7f1c$var$mie extends $d7238066c5de7f1c$var$ZR {
    static get type() {
        return "MaterialReferenceNode";
    }
    /**
   * Constructs a new material reference node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} inputType - The uniform type that should be used to represent the property value.
   * @param {?Material} [material=null] - The material the property belongs to. When no material is set,
   * the node refers to the material of the current rendered object.
   */ constructor(e, t, i = null){
        super(e, t, i), this.material = i, this.isMaterialReferenceNode = !0;
    }
    /**
   * Updates the reference based on the given state. The state is only evaluated
   * {@link MaterialReferenceNode#material} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */ updateReference(e) {
        return this.reference = this.material !== null ? this.material : e.material, this.reference;
    }
}
const $d7238066c5de7f1c$var$rI = (r, e, t = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$mie(r, e, t)), $d7238066c5de7f1c$var$GJ = $d7238066c5de7f1c$var$yn(), $d7238066c5de7f1c$var$Aie = $d7238066c5de7f1c$var$Ls.dFdx(), $d7238066c5de7f1c$var$bie = $d7238066c5de7f1c$var$Ls.dFdy(), $d7238066c5de7f1c$var$vJ = $d7238066c5de7f1c$var$GJ.dFdx(), $d7238066c5de7f1c$var$SJ = $d7238066c5de7f1c$var$GJ.dFdy(), $d7238066c5de7f1c$var$ZJ = $d7238066c5de7f1c$var$gn, $d7238066c5de7f1c$var$RJ = $d7238066c5de7f1c$var$bie.cross($d7238066c5de7f1c$var$ZJ), $d7238066c5de7f1c$var$VJ = $d7238066c5de7f1c$var$ZJ.cross($d7238066c5de7f1c$var$Aie), $d7238066c5de7f1c$var$K2 = $d7238066c5de7f1c$var$RJ.mul($d7238066c5de7f1c$var$vJ.x).add($d7238066c5de7f1c$var$VJ.mul($d7238066c5de7f1c$var$SJ.x)), $d7238066c5de7f1c$var$x2 = $d7238066c5de7f1c$var$RJ.mul($d7238066c5de7f1c$var$vJ.y).add($d7238066c5de7f1c$var$VJ.mul($d7238066c5de7f1c$var$SJ.y)), $d7238066c5de7f1c$var$D5 = $d7238066c5de7f1c$var$K2.dot($d7238066c5de7f1c$var$K2).max($d7238066c5de7f1c$var$x2.dot($d7238066c5de7f1c$var$x2)), $d7238066c5de7f1c$var$wJ = $d7238066c5de7f1c$var$D5.equal(0).select(0, $d7238066c5de7f1c$var$D5.inverseSqrt()), $d7238066c5de7f1c$var$yie = /* @__PURE__ */ $d7238066c5de7f1c$var$K2.mul($d7238066c5de7f1c$var$wJ).toVar("tangentViewFrame"), $d7238066c5de7f1c$var$Bie = /* @__PURE__ */ $d7238066c5de7f1c$var$x2.mul($d7238066c5de7f1c$var$wJ).toVar("bitangentViewFrame"), $d7238066c5de7f1c$var$RR = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>(r.geometry.hasAttribute("tangent") === !1 && r.geometry.computeTangents(), $d7238066c5de7f1c$var$RI("tangent", "vec4")))(), $d7238066c5de7f1c$var$jB = /* @__PURE__ */ $d7238066c5de7f1c$var$RR.xyz.toVar("tangentLocal"), $d7238066c5de7f1c$var$VR = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ subBuildFn: r, geometry: e, material: t })=>{
    let i;
    return r === "VERTEX" || e.hasAttribute("tangent") ? i = $d7238066c5de7f1c$var$qC.mul($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$jB, 0)).xyz.toVarying("v_tangentView").normalize() : i = $d7238066c5de7f1c$var$yie, t.flatShading !== !0 && (i = $d7238066c5de7f1c$var$r0(i)), i;
}, "vec3").once([
    "NORMAL",
    "VERTEX"
])().toVar("tangentView"), $d7238066c5de7f1c$var$WJ = /* @__PURE__ */ $d7238066c5de7f1c$var$VR.transformDirection($d7238066c5de7f1c$var$ol).toVarying("v_tangentWorld").normalize().toVar("tangentWorld"), $d7238066c5de7f1c$var$wR = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e], { subBuildFn: t, material: i })=>{
    let n = r.mul($d7238066c5de7f1c$var$RR.w).xyz;
    return t === "NORMAL" && i.flatShading !== !0 && (n = n.toVarying(e)), n;
}).once([
    "NORMAL"
]), $d7238066c5de7f1c$var$fie = /* @__PURE__ */ $d7238066c5de7f1c$var$wR($d7238066c5de7f1c$var$SR.cross($d7238066c5de7f1c$var$RR), "v_bitangentGeometry").normalize().toVar("bitangentGeometry"), $d7238066c5de7f1c$var$Gie = /* @__PURE__ */ $d7238066c5de7f1c$var$wR($d7238066c5de7f1c$var$No.cross($d7238066c5de7f1c$var$jB), "v_bitangentLocal").normalize().toVar("bitangentLocal"), $d7238066c5de7f1c$var$HJ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ subBuildFn: r, geometry: e, material: t })=>{
    let i;
    return r === "VERTEX" || e.hasAttribute("tangent") ? i = $d7238066c5de7f1c$var$wR($d7238066c5de7f1c$var$gn.cross($d7238066c5de7f1c$var$VR), "v_bitangentView").normalize() : i = $d7238066c5de7f1c$var$Bie, t.flatShading !== !0 && (i = $d7238066c5de7f1c$var$r0(i)), i;
}, "vec3").once([
    "NORMAL",
    "VERTEX"
])().toVar("bitangentView"), $d7238066c5de7f1c$var$vie = /* @__PURE__ */ $d7238066c5de7f1c$var$wR($d7238066c5de7f1c$var$Ih.cross($d7238066c5de7f1c$var$WJ), "v_bitangentWorld").normalize().toVar("bitangentWorld"), $d7238066c5de7f1c$var$XC = /* @__PURE__ */ $d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$VR, $d7238066c5de7f1c$var$HJ, $d7238066c5de7f1c$var$gn).toVar("TBNViewMatrix"), $d7238066c5de7f1c$var$XJ = /* @__PURE__ */ $d7238066c5de7f1c$var$kn.mul($d7238066c5de7f1c$var$XC), $d7238066c5de7f1c$var$Sie = (r, e)=>r.sub($d7238066c5de7f1c$var$XJ.mul(e)), $d7238066c5de7f1c$var$NJ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(()=>{
    let r = $d7238066c5de7f1c$var$FC.cross($d7238066c5de7f1c$var$kn);
    return r = r.cross($d7238066c5de7f1c$var$FC).normalize(), r = $d7238066c5de7f1c$var$qi(r, $d7238066c5de7f1c$var$gn, $d7238066c5de7f1c$var$Jd.mul($d7238066c5de7f1c$var$jc.oneMinus()).oneMinus().pow2().pow2()).normalize(), r;
}).once()();
class $d7238066c5de7f1c$var$Zie extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "NormalMapNode";
    }
    /**
   * Constructs a new normal map node.
   *
   * @param {Node<vec3>} node - Represents the normal map data.
   * @param {?Node<vec2>} [scaleNode=null] - Controls the intensity of the effect.
   */ constructor(e, t = null){
        super("vec3"), this.node = e, this.scaleNode = t, this.normalMapType = $d7238066c5de7f1c$var$oh;
    }
    setup({ material: e }) {
        const { normalMapType: t, scaleNode: i } = this;
        let n = this.node.mul(2).sub(1);
        if (i !== null) {
            let a = i;
            e.flatShading === !0 && (a = $d7238066c5de7f1c$var$r0(a)), n = $d7238066c5de7f1c$var$ne(n.xy.mul(a), n.z);
        }
        let s = null;
        return t === $d7238066c5de7f1c$var$Q6 ? s = $d7238066c5de7f1c$var$nY(n) : t === $d7238066c5de7f1c$var$oh ? s = $d7238066c5de7f1c$var$XC.mul(n).normalize() : ($d7238066c5de7f1c$var$nt(`NodeMaterial: Unsupported normal map type: ${t}`), s = $d7238066c5de7f1c$var$gn), s;
    }
}
const $d7238066c5de7f1c$var$F2 = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Zie).setParameterLength(1, 2), $d7238066c5de7f1c$var$Rie = $d7238066c5de7f1c$var$oe(({ textureNode: r, bumpScale: e })=>{
    const t = (n)=>r.isolate().context({
            getUV: (s)=>n(s.uvNode || $d7238066c5de7f1c$var$yn()),
            forceUVContext: !0
        }), i = $d7238066c5de7f1c$var$J(t((n)=>n));
    return $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$J(t((n)=>n.add(n.dFdx()))).sub(i), $d7238066c5de7f1c$var$J(t((n)=>n.add(n.dFdy()))).sub(i)).mul(e);
}), $d7238066c5de7f1c$var$Vie = $d7238066c5de7f1c$var$oe((r)=>{
    const { surf_pos: e, surf_norm: t, dHdxy: i } = r, n = e.dFdx().normalize(), s = e.dFdy().normalize(), a = t, o = s.cross(a), g = a.cross(n), l = n.dot(o).mul($d7238066c5de7f1c$var$iY), c = l.sign().mul(i.x.mul(o).add(i.y.mul(g)));
    return l.abs().mul(t).sub(c).normalize();
});
class $d7238066c5de7f1c$var$wie extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "BumpMapNode";
    }
    /**
   * Constructs a new bump map node.
   *
   * @param {Node<float>} textureNode - Represents the bump map data.
   * @param {?Node<float>} [scaleNode=null] - Controls the intensity of the bump effect.
   */ constructor(e, t = null){
        super("vec3"), this.textureNode = e, this.scaleNode = t;
    }
    setup() {
        const e = this.scaleNode !== null ? this.scaleNode : 1, t = $d7238066c5de7f1c$var$Rie({
            textureNode: this.textureNode,
            bumpScale: e
        });
        return $d7238066c5de7f1c$var$Vie({
            surf_pos: $d7238066c5de7f1c$var$Ls,
            surf_norm: $d7238066c5de7f1c$var$gn,
            dHdxy: t
        });
    }
}
const $d7238066c5de7f1c$var$aY = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$wie).setParameterLength(1, 2), $d7238066c5de7f1c$var$_5 = /* @__PURE__ */ new Map();
class $d7238066c5de7f1c$var$we extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "MaterialNode";
    }
    /**
   * Constructs a new material node.
   *
   * @param {string} scope - The scope defines what kind of material property is referred by the node.
   */ constructor(e){
        super(), this.scope = e;
    }
    /**
   * Returns a cached reference node for the given property and type.
   *
   * @param {string} property - The name of the material property.
   * @param {string} type - The uniform type of the property.
   * @return {MaterialReferenceNode} A material reference node representing the property access.
   */ getCache(e, t) {
        let i = $d7238066c5de7f1c$var$_5.get(e);
        return i === void 0 && (i = $d7238066c5de7f1c$var$rI(e, t), $d7238066c5de7f1c$var$_5.set(e, i)), i;
    }
    /**
   * Returns a float-typed material reference node for the given property name.
   *
   * @param {string} property - The name of the material property.
   * @return {MaterialReferenceNode<float>} A material reference node representing the property access.
   */ getFloat(e) {
        return this.getCache(e, "float");
    }
    /**
   * Returns a color-typed material reference node for the given property name.
   *
   * @param {string} property - The name of the material property.
   * @return {MaterialReferenceNode<color>} A material reference node representing the property access.
   */ getColor(e) {
        return this.getCache(e, "color");
    }
    /**
   * Returns a texture-typed material reference node for the given property name.
   *
   * @param {string} property - The name of the material property.
   * @return {MaterialReferenceNode} A material reference node representing the property access.
   */ getTexture(e) {
        return this.getCache(e === "map" ? "map" : e + "Map", "texture");
    }
    /**
   * The node setup is done depending on the selected scope. Multiple material properties
   * might be grouped into a single node composition if they logically belong together.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The node representing the selected scope.
   */ setup(e) {
        const t = e.context.material, i = this.scope;
        let n = null;
        if (i === $d7238066c5de7f1c$var$we.COLOR) {
            const s = t.color !== void 0 ? this.getColor(i) : $d7238066c5de7f1c$var$ne();
            t.map && t.map.isTexture === !0 ? n = s.mul(this.getTexture("map")) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.OPACITY) {
            const s = this.getFloat(i);
            t.alphaMap && t.alphaMap.isTexture === !0 ? n = s.mul(this.getTexture("alpha")) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.SPECULAR_STRENGTH) t.specularMap && t.specularMap.isTexture === !0 ? n = this.getTexture("specular").r : n = $d7238066c5de7f1c$var$J(1);
        else if (i === $d7238066c5de7f1c$var$we.SPECULAR_INTENSITY) {
            const s = this.getFloat(i);
            t.specularIntensityMap && t.specularIntensityMap.isTexture === !0 ? n = s.mul(this.getTexture(i).a) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.SPECULAR_COLOR) {
            const s = this.getColor(i);
            t.specularColorMap && t.specularColorMap.isTexture === !0 ? n = s.mul(this.getTexture(i).rgb) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.ROUGHNESS) {
            const s = this.getFloat(i);
            t.roughnessMap && t.roughnessMap.isTexture === !0 ? n = s.mul(this.getTexture(i).g) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.METALNESS) {
            const s = this.getFloat(i);
            t.metalnessMap && t.metalnessMap.isTexture === !0 ? n = s.mul(this.getTexture(i).b) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.EMISSIVE) {
            const s = this.getFloat("emissiveIntensity"), a = this.getColor(i).mul(s);
            t.emissiveMap && t.emissiveMap.isTexture === !0 ? n = a.mul(this.getTexture(i)) : n = a;
        } else if (i === $d7238066c5de7f1c$var$we.NORMAL) t.normalMap ? (n = $d7238066c5de7f1c$var$F2(this.getTexture("normal"), this.getCache("normalScale", "vec2")), n.normalMapType = t.normalMapType) : t.bumpMap ? n = $d7238066c5de7f1c$var$aY(this.getTexture("bump").r, this.getFloat("bumpScale")) : n = $d7238066c5de7f1c$var$gn;
        else if (i === $d7238066c5de7f1c$var$we.CLEARCOAT) {
            const s = this.getFloat(i);
            t.clearcoatMap && t.clearcoatMap.isTexture === !0 ? n = s.mul(this.getTexture(i).r) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.CLEARCOAT_ROUGHNESS) {
            const s = this.getFloat(i);
            t.clearcoatRoughnessMap && t.clearcoatRoughnessMap.isTexture === !0 ? n = s.mul(this.getTexture(i).r) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.CLEARCOAT_NORMAL) t.clearcoatNormalMap ? n = $d7238066c5de7f1c$var$F2(this.getTexture(i), this.getCache(i + "Scale", "vec2")) : n = $d7238066c5de7f1c$var$gn;
        else if (i === $d7238066c5de7f1c$var$we.SHEEN) {
            const s = this.getColor("sheenColor").mul(this.getFloat("sheen"));
            t.sheenColorMap && t.sheenColorMap.isTexture === !0 ? n = s.mul(this.getTexture("sheenColor").rgb) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.SHEEN_ROUGHNESS) {
            const s = this.getFloat(i);
            t.sheenRoughnessMap && t.sheenRoughnessMap.isTexture === !0 ? n = s.mul(this.getTexture(i).a) : n = s, n = n.clamp(0.07, 1);
        } else if (i === $d7238066c5de7f1c$var$we.ANISOTROPY) {
            if (t.anisotropyMap && t.anisotropyMap.isTexture === !0) {
                const s = this.getTexture(i);
                n = $d7238066c5de7f1c$var$pR($d7238066c5de7f1c$var$nA.x, $d7238066c5de7f1c$var$nA.y, $d7238066c5de7f1c$var$nA.y.negate(), $d7238066c5de7f1c$var$nA.x).mul(s.rg.mul(2).sub($d7238066c5de7f1c$var$Ne(1)).normalize().mul(s.b));
            } else n = $d7238066c5de7f1c$var$nA;
        } else if (i === $d7238066c5de7f1c$var$we.IRIDESCENCE_THICKNESS) {
            const s = $d7238066c5de7f1c$var$vn("1", "float", t.iridescenceThicknessRange);
            if (t.iridescenceThicknessMap) {
                const a = $d7238066c5de7f1c$var$vn("0", "float", t.iridescenceThicknessRange);
                n = s.sub(a).mul(this.getTexture(i).g).add(a);
            } else n = s;
        } else if (i === $d7238066c5de7f1c$var$we.TRANSMISSION) {
            const s = this.getFloat(i);
            t.transmissionMap ? n = s.mul(this.getTexture(i).r) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.THICKNESS) {
            const s = this.getFloat(i);
            t.thicknessMap ? n = s.mul(this.getTexture(i).g) : n = s;
        } else if (i === $d7238066c5de7f1c$var$we.IOR) n = this.getFloat(i);
        else if (i === $d7238066c5de7f1c$var$we.LIGHT_MAP) n = this.getTexture(i).rgb.mul(this.getFloat("lightMapIntensity"));
        else if (i === $d7238066c5de7f1c$var$we.AO) n = this.getTexture(i).r.sub(1).mul(this.getFloat("aoMapIntensity")).add(1);
        else if (i === $d7238066c5de7f1c$var$we.LINE_DASH_OFFSET) n = t.dashOffset ? this.getFloat(i) : $d7238066c5de7f1c$var$J(0);
        else {
            const s = this.getNodeType(e);
            n = this.getCache(i, s);
        }
        return n;
    }
}
$d7238066c5de7f1c$var$we.ALPHA_TEST = "alphaTest";
$d7238066c5de7f1c$var$we.COLOR = "color";
$d7238066c5de7f1c$var$we.OPACITY = "opacity";
$d7238066c5de7f1c$var$we.SHININESS = "shininess";
$d7238066c5de7f1c$var$we.SPECULAR = "specular";
$d7238066c5de7f1c$var$we.SPECULAR_STRENGTH = "specularStrength";
$d7238066c5de7f1c$var$we.SPECULAR_INTENSITY = "specularIntensity";
$d7238066c5de7f1c$var$we.SPECULAR_COLOR = "specularColor";
$d7238066c5de7f1c$var$we.REFLECTIVITY = "reflectivity";
$d7238066c5de7f1c$var$we.ROUGHNESS = "roughness";
$d7238066c5de7f1c$var$we.METALNESS = "metalness";
$d7238066c5de7f1c$var$we.NORMAL = "normal";
$d7238066c5de7f1c$var$we.CLEARCOAT = "clearcoat";
$d7238066c5de7f1c$var$we.CLEARCOAT_ROUGHNESS = "clearcoatRoughness";
$d7238066c5de7f1c$var$we.CLEARCOAT_NORMAL = "clearcoatNormal";
$d7238066c5de7f1c$var$we.EMISSIVE = "emissive";
$d7238066c5de7f1c$var$we.ROTATION = "rotation";
$d7238066c5de7f1c$var$we.SHEEN = "sheen";
$d7238066c5de7f1c$var$we.SHEEN_ROUGHNESS = "sheenRoughness";
$d7238066c5de7f1c$var$we.ANISOTROPY = "anisotropy";
$d7238066c5de7f1c$var$we.IRIDESCENCE = "iridescence";
$d7238066c5de7f1c$var$we.IRIDESCENCE_IOR = "iridescenceIOR";
$d7238066c5de7f1c$var$we.IRIDESCENCE_THICKNESS = "iridescenceThickness";
$d7238066c5de7f1c$var$we.IOR = "ior";
$d7238066c5de7f1c$var$we.TRANSMISSION = "transmission";
$d7238066c5de7f1c$var$we.THICKNESS = "thickness";
$d7238066c5de7f1c$var$we.ATTENUATION_DISTANCE = "attenuationDistance";
$d7238066c5de7f1c$var$we.ATTENUATION_COLOR = "attenuationColor";
$d7238066c5de7f1c$var$we.LINE_SCALE = "scale";
$d7238066c5de7f1c$var$we.LINE_DASH_SIZE = "dashSize";
$d7238066c5de7f1c$var$we.LINE_GAP_SIZE = "gapSize";
$d7238066c5de7f1c$var$we.LINE_WIDTH = "linewidth";
$d7238066c5de7f1c$var$we.LINE_DASH_OFFSET = "dashOffset";
$d7238066c5de7f1c$var$we.POINT_SIZE = "size";
$d7238066c5de7f1c$var$we.DISPERSION = "dispersion";
$d7238066c5de7f1c$var$we.LIGHT_MAP = "light";
$d7238066c5de7f1c$var$we.AO = "ao";
const $d7238066c5de7f1c$var$LJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.ALPHA_TEST), $d7238066c5de7f1c$var$YJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.COLOR), $d7238066c5de7f1c$var$KJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SHININESS), $d7238066c5de7f1c$var$xJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.EMISSIVE), $d7238066c5de7f1c$var$oY = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.OPACITY), $d7238066c5de7f1c$var$FJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SPECULAR), $d7238066c5de7f1c$var$T2 = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SPECULAR_INTENSITY), $d7238066c5de7f1c$var$TJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SPECULAR_COLOR), $d7238066c5de7f1c$var$Dy = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SPECULAR_STRENGTH), $d7238066c5de7f1c$var$WS = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.REFLECTIVITY), $d7238066c5de7f1c$var$MJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.ROUGHNESS), $d7238066c5de7f1c$var$zJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.METALNESS), $d7238066c5de7f1c$var$kJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.NORMAL), $d7238066c5de7f1c$var$EJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.CLEARCOAT), $d7238066c5de7f1c$var$JJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.CLEARCOAT_ROUGHNESS), $d7238066c5de7f1c$var$UJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.CLEARCOAT_NORMAL), $d7238066c5de7f1c$var$DJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.ROTATION), $d7238066c5de7f1c$var$_J = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SHEEN), $d7238066c5de7f1c$var$PJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.SHEEN_ROUGHNESS), $d7238066c5de7f1c$var$QJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.ANISOTROPY), $d7238066c5de7f1c$var$OJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.IRIDESCENCE), $d7238066c5de7f1c$var$jJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.IRIDESCENCE_IOR), $d7238066c5de7f1c$var$qJ = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.IRIDESCENCE_THICKNESS), $d7238066c5de7f1c$var$$J = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.TRANSMISSION), $d7238066c5de7f1c$var$eU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.THICKNESS), $d7238066c5de7f1c$var$tU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.IOR), $d7238066c5de7f1c$var$iU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.ATTENUATION_DISTANCE), $d7238066c5de7f1c$var$nU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.ATTENUATION_COLOR), $d7238066c5de7f1c$var$sU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.LINE_SCALE), $d7238066c5de7f1c$var$rU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.LINE_DASH_SIZE), $d7238066c5de7f1c$var$aU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.LINE_GAP_SIZE), $d7238066c5de7f1c$var$Wie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.LINE_WIDTH), $d7238066c5de7f1c$var$oU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.LINE_DASH_OFFSET), $d7238066c5de7f1c$var$gU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.POINT_SIZE), $d7238066c5de7f1c$var$lU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.DISPERSION), $d7238066c5de7f1c$var$gY = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.LIGHT_MAP), $d7238066c5de7f1c$var$cU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$we, $d7238066c5de7f1c$var$we.AO), $d7238066c5de7f1c$var$nA = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ii()).onReference(function(r) {
    return r.material;
}).onRenderUpdate(function({ material: r }) {
    this.value.set(r.anisotropy * Math.cos(r.anisotropyRotation), r.anisotropy * Math.sin(r.anisotropyRotation));
}), $d7238066c5de7f1c$var$lY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>r.context.setupModelViewProjection(), "vec4").once()().toVarying("v_modelViewProjection");
class $d7238066c5de7f1c$var$ts extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "IndexNode";
    }
    /**
   * Constructs a new index node.
   *
   * @param {('vertex'|'instance'|'subgroup'|'invocationLocal'|'invocationGlobal'|'invocationSubgroup'|'draw')} scope - The scope of the index node.
   */ constructor(e){
        super("uint"), this.scope = e, this.isIndexNode = !0;
    }
    generate(e) {
        const t = this.getNodeType(e), i = this.scope;
        let n;
        if (i === $d7238066c5de7f1c$var$ts.VERTEX) n = e.getVertexIndex();
        else if (i === $d7238066c5de7f1c$var$ts.INSTANCE) n = e.getInstanceIndex();
        else if (i === $d7238066c5de7f1c$var$ts.DRAW) n = e.getDrawIndex();
        else if (i === $d7238066c5de7f1c$var$ts.INVOCATION_LOCAL) n = e.getInvocationLocalIndex();
        else if (i === $d7238066c5de7f1c$var$ts.INVOCATION_SUBGROUP) n = e.getInvocationSubgroupIndex();
        else if (i === $d7238066c5de7f1c$var$ts.SUBGROUP) n = e.getSubgroupIndex();
        else throw new Error("THREE.IndexNode: Unknown scope: " + i);
        let s;
        return e.shaderStage === "vertex" || e.shaderStage === "compute" ? s = n : s = $d7238066c5de7f1c$var$pu(this).build(e, t), s;
    }
}
$d7238066c5de7f1c$var$ts.VERTEX = "vertex";
$d7238066c5de7f1c$var$ts.INSTANCE = "instance";
$d7238066c5de7f1c$var$ts.SUBGROUP = "subgroup";
$d7238066c5de7f1c$var$ts.INVOCATION_LOCAL = "invocationLocal";
$d7238066c5de7f1c$var$ts.INVOCATION_SUBGROUP = "invocationSubgroup";
$d7238066c5de7f1c$var$ts.DRAW = "draw";
const $d7238066c5de7f1c$var$uU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$ts, $d7238066c5de7f1c$var$ts.VERTEX), $d7238066c5de7f1c$var$rh = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$ts, $d7238066c5de7f1c$var$ts.INSTANCE), $d7238066c5de7f1c$var$Hie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$ts, $d7238066c5de7f1c$var$ts.SUBGROUP), $d7238066c5de7f1c$var$Xie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$ts, $d7238066c5de7f1c$var$ts.INVOCATION_SUBGROUP), $d7238066c5de7f1c$var$Nie = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$ts, $d7238066c5de7f1c$var$ts.INVOCATION_LOCAL), $d7238066c5de7f1c$var$IU = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$ts, $d7238066c5de7f1c$var$ts.DRAW);
class $d7238066c5de7f1c$var$dU extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "InstanceNode";
    }
    /**
   * Constructs a new instance node.
   *
   * @param {number} count - The number of instances.
   * @param {InstancedBufferAttribute} instanceMatrix - Instanced buffer attribute representing the instance transformations.
   * @param {?InstancedBufferAttribute} instanceColor - Instanced buffer attribute representing the instance colors.
   */ constructor(e, t, i = null){
        super("void"), this.count = e, this.instanceMatrix = t, this.instanceColor = i, this.instanceMatrixNode = null, this.instanceColorNode = null, this.updateType = $d7238066c5de7f1c$var$Dt.FRAME, this.buffer = null, this.bufferColor = null;
    }
    /**
   * Setups the internal buffers and nodes and assigns the transformed vertex data
   * to predefined node variables for accumulation. That follows the same patterns
   * like with morph and skinning nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        const { instanceMatrix: t, instanceColor: i } = this, { count: n } = t;
        let { instanceMatrixNode: s, instanceColorNode: a } = this;
        if (s === null) {
            if (n <= 1e3) s = $d7238066c5de7f1c$var$PB(t.array, "mat4", Math.max(n, 1)).element($d7238066c5de7f1c$var$rh);
            else {
                const g = new $d7238066c5de7f1c$var$Vee(t.array, 16, 1);
                this.buffer = g;
                const l = t.usage === $d7238066c5de7f1c$var$dA ? $d7238066c5de7f1c$var$X2 : $d7238066c5de7f1c$var$XZ, c = [
                    // F.Signature -> bufferAttribute( array, type, stride, offset )
                    l(g, "vec4", 16, 0),
                    l(g, "vec4", 16, 4),
                    l(g, "vec4", 16, 8),
                    l(g, "vec4", 16, 12)
                ];
                s = $d7238066c5de7f1c$var$xC(...c);
            }
            this.instanceMatrixNode = s;
        }
        if (i && a === null) {
            const g = new $d7238066c5de7f1c$var$SA(i.array, 3), l = i.usage === $d7238066c5de7f1c$var$dA ? $d7238066c5de7f1c$var$X2 : $d7238066c5de7f1c$var$XZ;
            this.bufferColor = g, a = $d7238066c5de7f1c$var$ne(l(g, "vec3", 3, 0)), this.instanceColorNode = a;
        }
        const o = s.mul($d7238066c5de7f1c$var$Ns).xyz;
        if ($d7238066c5de7f1c$var$Ns.assign(o), e.hasGeometryAttribute("normal")) {
            const g = $d7238066c5de7f1c$var$pJ($d7238066c5de7f1c$var$No, s);
            $d7238066c5de7f1c$var$No.assign(g);
        }
        this.instanceColorNode !== null && $d7238066c5de7f1c$var$IB("vec3", "vInstanceColor").assign(this.instanceColorNode);
    }
    /**
   * Checks if the internal buffers required an update.
   *
   * @param {NodeFrame} frame - The current node frame.
   */ update() {
        this.buffer !== null && (this.buffer.clearUpdateRanges(), this.buffer.updateRanges.push(...this.instanceMatrix.updateRanges), this.instanceMatrix.usage !== $d7238066c5de7f1c$var$dA && this.instanceMatrix.version !== this.buffer.version && (this.buffer.version = this.instanceMatrix.version)), this.instanceColor && this.bufferColor !== null && (this.bufferColor.clearUpdateRanges(), this.bufferColor.updateRanges.push(...this.instanceColor.updateRanges), this.instanceColor.usage !== $d7238066c5de7f1c$var$dA && this.instanceColor.version !== this.bufferColor.version && (this.bufferColor.version = this.instanceColor.version));
    }
}
const $d7238066c5de7f1c$var$Lie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$dU).setParameterLength(2, 3);
class $d7238066c5de7f1c$var$Yie extends $d7238066c5de7f1c$var$dU {
    static get type() {
        return "InstancedMeshNode";
    }
    /**
   * Constructs a new instanced mesh node.
   *
   * @param {InstancedMesh} instancedMesh - The instanced mesh.
   */ constructor(e){
        const { count: t, instanceMatrix: i, instanceColor: n } = e;
        super(t, i, n), this.instancedMesh = e;
    }
}
const $d7238066c5de7f1c$var$hU = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Yie).setParameterLength(1);
class $d7238066c5de7f1c$var$Kie extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "BatchNode";
    }
    /**
   * Constructs a new batch node.
   *
   * @param {BatchedMesh} batchMesh - A reference to batched mesh.
   */ constructor(e){
        super("void"), this.batchMesh = e, this.batchingIdNode = null;
    }
    /**
   * Setups the internal buffers and nodes and assigns the transformed vertex data
   * to predefined node variables for accumulation. That follows the same patterns
   * like with morph and skinning nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        this.batchingIdNode === null && (e.getDrawIndex() === null ? this.batchingIdNode = $d7238066c5de7f1c$var$rh : this.batchingIdNode = $d7238066c5de7f1c$var$IU);
        const i = $d7238066c5de7f1c$var$oe(([y])=>{
            const G = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$mI($d7238066c5de7f1c$var$ys(this.batchMesh._indirectTexture), 0).x), Z = $d7238066c5de7f1c$var$ee(y).mod(G), v = $d7238066c5de7f1c$var$ee(y).div(G);
            return $d7238066c5de7f1c$var$ys(this.batchMesh._indirectTexture, $d7238066c5de7f1c$var$vr(Z, v)).x;
        }).setLayout({
            name: "getIndirectIndex",
            type: "uint",
            inputs: [
                {
                    name: "id",
                    type: "int"
                }
            ]
        })($d7238066c5de7f1c$var$ee(this.batchingIdNode)), n = this.batchMesh._matricesTexture, s = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$mI($d7238066c5de7f1c$var$ys(n), 0).x), a = $d7238066c5de7f1c$var$J(i).mul(4).toInt().toVar(), o = a.mod(s), g = a.div(s), l = $d7238066c5de7f1c$var$xC($d7238066c5de7f1c$var$ys(n, $d7238066c5de7f1c$var$vr(o, g)), $d7238066c5de7f1c$var$ys(n, $d7238066c5de7f1c$var$vr(o.add(1), g)), $d7238066c5de7f1c$var$ys(n, $d7238066c5de7f1c$var$vr(o.add(2), g)), $d7238066c5de7f1c$var$ys(n, $d7238066c5de7f1c$var$vr(o.add(3), g))), c = this.batchMesh._colorsTexture;
        if (c !== null) {
            const G = $d7238066c5de7f1c$var$oe(([Z])=>{
                const v = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$mI($d7238066c5de7f1c$var$ys(c), 0).x), V = Z, H = V.mod(v), N = V.div(v);
                return $d7238066c5de7f1c$var$ys(c, $d7238066c5de7f1c$var$vr(H, N)).rgb;
            }).setLayout({
                name: "getBatchingColor",
                type: "vec3",
                inputs: [
                    {
                        name: "id",
                        type: "int"
                    }
                ]
            })(i);
            $d7238066c5de7f1c$var$IB("vec3", "vBatchColor").assign(G);
        }
        const d = $d7238066c5de7f1c$var$Fa(l);
        $d7238066c5de7f1c$var$Ns.assign(l.mul($d7238066c5de7f1c$var$Ns));
        const p = $d7238066c5de7f1c$var$No.div($d7238066c5de7f1c$var$ne(d[0].dot(d[0]), d[1].dot(d[1]), d[2].dot(d[2]))), A = d.mul(p).xyz;
        $d7238066c5de7f1c$var$No.assign(A), e.hasGeometryAttribute("tangent") && $d7238066c5de7f1c$var$jB.mulAssign(d);
    }
}
const $d7238066c5de7f1c$var$CU = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Kie).setParameterLength(1);
class $d7238066c5de7f1c$var$xie extends $d7238066c5de7f1c$var$jC {
    static get type() {
        return "StorageArrayElementNode";
    }
    /**
   * Constructs storage buffer element node.
   *
   * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
   * @param {Node} indexNode - The index node that defines the element access.
   */ constructor(e, t){
        super(e, t), this.isStorageArrayElementNode = !0;
    }
    /**
   * The storage buffer node.
   *
   * @param {Node} value
   * @type {StorageBufferNode}
   */ set storageBufferNode(e) {
        this.node = e;
    }
    get storageBufferNode() {
        return this.node;
    }
    getMemberType(e, t) {
        const i = this.storageBufferNode.structTypeNode;
        return i ? i.getMemberType(e, t) : "void";
    }
    setup(e) {
        return e.isAvailable("storageBuffer") === !1 && this.node.isPBO === !0 && e.setupPBO(this.node), super.setup(e);
    }
    generate(e, t) {
        let i;
        const n = e.context.assign;
        if (e.isAvailable("storageBuffer") === !1 ? this.node.isPBO === !0 && n !== !0 && (this.node.value.isInstancedBufferAttribute || e.shaderStage !== "compute") ? i = e.generatePBO(this) : i = this.node.build(e) : i = super.generate(e), n !== !0) {
            const s = this.getNodeType(e);
            i = e.format(i, s, t);
        }
        return i;
    }
}
const $d7238066c5de7f1c$var$Fie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$xie).setParameterLength(2);
class $d7238066c5de7f1c$var$Tie extends $d7238066c5de7f1c$var$qL {
    static get type() {
        return "StorageBufferNode";
    }
    /**
   * Constructs a new storage buffer node.
   *
   * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
   * @param {?(string|Struct)} [bufferType=null] - The buffer type (e.g. `'vec3'`).
   * @param {number} [bufferCount=0] - The buffer count.
   */ constructor(e, t = null, i = 0){
        let n, s = null;
        t && t.isStruct ? (n = "struct", s = t.layout, (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) && (i = e.count)) : t === null && (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) ? (n = $d7238066c5de7f1c$var$A3(e.itemSize), i = e.count) : n = t, super(e, n, i), this.isStorageBufferNode = !0, this.structTypeNode = s, this.access = $d7238066c5de7f1c$var$da.READ_WRITE, this.isAtomic = !1, this.isPBO = !1, this._attribute = null, this._varying = null, this.global = !0, e.isStorageBufferAttribute !== !0 && e.isStorageInstancedBufferAttribute !== !0 && (e.isInstancedBufferAttribute ? e.isStorageInstancedBufferAttribute = !0 : e.isStorageBufferAttribute = !0);
    }
    /**
   * This method is overwritten since the buffer data might be shared
   * and thus the hash should be shared as well.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */ getHash(e) {
        if (this.bufferCount === 0) {
            let t = e.globalCache.getData(this.value);
            return t === void 0 && (t = {
                node: this
            }, e.globalCache.setData(this.value, t)), t.node.uuid;
        }
        return this.uuid;
    }
    /**
   * Overwrites the default implementation to return a fixed value `'indirectStorageBuffer'` or `'storageBuffer'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return this.value.isIndirectStorageBufferAttribute ? "indirectStorageBuffer" : "storageBuffer";
    }
    /**
   * Enables element access with the given index node.
   *
   * @param {IndexNode} indexNode - The index node.
   * @return {StorageArrayElementNode} A node representing the element access.
   */ element(e) {
        return $d7238066c5de7f1c$var$Fie(this, e);
    }
    /**
   * Defines whether this node is a PBO or not. Only relevant for WebGL.
   *
   * @param {boolean} value - The value so set.
   * @return {StorageBufferNode} A reference to this node.
   */ setPBO(e) {
        return this.isPBO = e, this;
    }
    /**
   * Returns the `isPBO` value.
   *
   * @return {boolean} Whether the node represents a PBO or not.
   */ getPBO() {
        return this.isPBO;
    }
    /**
   * Defines the node access.
   *
   * @param {string} value - The node access.
   * @return {StorageBufferNode} A reference to this node.
   */ setAccess(e) {
        return this.access = e, this;
    }
    /**
   * Convenience method for configuring a read-only node access.
   *
   * @return {StorageBufferNode} A reference to this node.
   */ toReadOnly() {
        return this.setAccess($d7238066c5de7f1c$var$da.READ_ONLY);
    }
    /**
   * Defines whether the node is atomic or not.
   *
   * @param {boolean} value - The atomic flag.
   * @return {StorageBufferNode} A reference to this node.
   */ setAtomic(e) {
        return this.isAtomic = e, this;
    }
    /**
   * Convenience method for making this node atomic.
   *
   * @return {StorageBufferNode} A reference to this node.
   */ toAtomic() {
        return this.setAtomic(!0);
    }
    /**
   * Returns attribute data for this storage buffer node.
   *
   * @return {{attribute: BufferAttributeNode, varying: VaryingNode}} The attribute data.
   */ getAttributeData() {
        return this._attribute === null && (this._attribute = $d7238066c5de7f1c$var$_B(this.value), this._varying = $d7238066c5de7f1c$var$pu(this._attribute)), {
            attribute: this._attribute,
            varying: this._varying
        };
    }
    /**
   * This method is overwritten since the node type from the availability of storage buffers
   * and the attribute data.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        if (this.structTypeNode !== null) return this.structTypeNode.getNodeType(e);
        if (e.isAvailable("storageBuffer") || e.isAvailable("indirectStorageBuffer")) return super.getNodeType(e);
        const { attribute: t } = this.getAttributeData();
        return t.getNodeType(e);
    }
    /**
   * Returns the type of a member of the struct.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member.
   * @return {string} The type of the member.
   */ getMemberType(e, t) {
        return this.structTypeNode !== null ? this.structTypeNode.getMemberType(e, t) : "void";
    }
    /**
   * Generates the code snippet of the storage buffer node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */ generate(e) {
        if (this.structTypeNode !== null && this.structTypeNode.build(e), e.isAvailable("storageBuffer") || e.isAvailable("indirectStorageBuffer")) return super.generate(e);
        const { attribute: t, varying: i } = this.getAttributeData(), n = i.build(e);
        return e.registerTransform(n, t), n;
    }
}
const $d7238066c5de7f1c$var$TC = (r, e = null, t = 0)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Tie(r, e, t)), $d7238066c5de7f1c$var$Mie = (r, e, t)=>($d7238066c5de7f1c$var$ze('TSL: "storageObject()" is deprecated. Use "storage().setPBO( true )" instead.'), $d7238066c5de7f1c$var$TC(r, e, t).setPBO(!0)), $d7238066c5de7f1c$var$P5 = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$pU extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "SkinningNode";
    }
    /**
   * Constructs a new skinning node.
   *
   * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
   */ constructor(e){
        super("void"), this.skinnedMesh = e, this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT, this.skinIndexNode = $d7238066c5de7f1c$var$RI("skinIndex", "uvec4"), this.skinWeightNode = $d7238066c5de7f1c$var$RI("skinWeight", "vec4"), this.bindMatrixNode = $d7238066c5de7f1c$var$vn("bindMatrix", "mat4"), this.bindMatrixInverseNode = $d7238066c5de7f1c$var$vn("bindMatrixInverse", "mat4"), this.boneMatricesNode = $d7238066c5de7f1c$var$Y2("skeleton.boneMatrices", "mat4", e.skeleton.bones.length), this.positionNode = $d7238066c5de7f1c$var$Ns, this.toPositionNode = $d7238066c5de7f1c$var$Ns, this.previousBoneMatricesNode = null;
    }
    /**
   * Transforms the given vertex position via skinning.
   *
   * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
   * @param {Node<vec3>} [position=this.positionNode] - The vertex position in local space.
   * @return {Node<vec3>} The transformed vertex position.
   */ getSkinnedPosition(e = this.boneMatricesNode, t = this.positionNode) {
        const { skinIndexNode: i, skinWeightNode: n, bindMatrixNode: s, bindMatrixInverseNode: a } = this, o = e.element(i.x), g = e.element(i.y), l = e.element(i.z), c = e.element(i.w), d = s.mul(t), p = $d7238066c5de7f1c$var$Ps(o.mul(n.x).mul(d), g.mul(n.y).mul(d), l.mul(n.z).mul(d), c.mul(n.w).mul(d));
        return a.mul(p).xyz;
    }
    /**
   * Transforms the given vertex normal via skinning.
   *
   * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
   * @param {Node<vec3>} [normal=normalLocal] - The vertex normal in local space.
   * @return {Node<vec3>} The transformed vertex normal.
   */ getSkinnedNormal(e = this.boneMatricesNode, t = $d7238066c5de7f1c$var$No) {
        const { skinIndexNode: i, skinWeightNode: n, bindMatrixNode: s, bindMatrixInverseNode: a } = this, o = e.element(i.x), g = e.element(i.y), l = e.element(i.z), c = e.element(i.w);
        let d = $d7238066c5de7f1c$var$Ps(n.x.mul(o), n.y.mul(g), n.z.mul(l), n.w.mul(c));
        return d = a.mul(d).mul(s), d.transformDirection(t).xyz;
    }
    /**
   * Computes the transformed/skinned vertex position of the previous frame.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The skinned position from the previous frame.
   */ getPreviousSkinnedPosition(e) {
        const t = e.object;
        return this.previousBoneMatricesNode === null && (t.skeleton.previousBoneMatrices = new Float32Array(t.skeleton.boneMatrices), this.previousBoneMatricesNode = $d7238066c5de7f1c$var$Y2("skeleton.previousBoneMatrices", "mat4", t.skeleton.bones.length)), this.getSkinnedPosition(this.previousBoneMatricesNode, $d7238066c5de7f1c$var$NZ);
    }
    /**
   * Returns `true` if bone matrices from the previous frame are required. Relevant
   * when computing motion vectors with {@link VelocityNode}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether bone matrices from the previous frame are required or not.
   */ needsPreviousBoneMatrices(e) {
        const t = e.renderer.getMRT();
        return t && t.has("velocity") || $d7238066c5de7f1c$var$y3(e.object).useVelocity === !0;
    }
    /**
   * Setups the skinning node by assigning the transformed vertex data to predefined node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The transformed vertex position.
   */ setup(e) {
        this.needsPreviousBoneMatrices(e) && $d7238066c5de7f1c$var$NZ.assign(this.getPreviousSkinnedPosition(e));
        const t = this.getSkinnedPosition();
        if (this.toPositionNode && this.toPositionNode.assign(t), e.hasGeometryAttribute("normal")) {
            const i = this.getSkinnedNormal();
            $d7238066c5de7f1c$var$No.assign(i), e.hasGeometryAttribute("tangent") && $d7238066c5de7f1c$var$jB.assign(i);
        }
        return t;
    }
    /**
   * Generates the code snippet of the skinning node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The current output.
   * @return {string} The generated code snippet.
   */ generate(e, t) {
        if (t !== "void") return super.generate(e, t);
    }
    /**
   * Updates the state of the skinned mesh by updating the skeleton once per frame.
   *
   * @param {NodeFrame} frame - The current node frame.
   */ update(e) {
        const t = e.object && e.object.skeleton ? e.object.skeleton : this.skinnedMesh.skeleton;
        $d7238066c5de7f1c$var$P5.get(t) !== e.frameId && ($d7238066c5de7f1c$var$P5.set(t, e.frameId), this.previousBoneMatricesNode !== null && t.previousBoneMatrices.set(t.boneMatrices), t.update());
    }
}
const $d7238066c5de7f1c$var$mU = (r)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$pU(r)), $d7238066c5de7f1c$var$zie = (r, e = null)=>{
    const t = new $d7238066c5de7f1c$var$pU(r);
    return t.positionNode = $d7238066c5de7f1c$var$TC(new $d7238066c5de7f1c$var$SA(r.geometry.getAttribute("position").array, 3), "vec3").setPBO(!0).toReadOnly().element($d7238066c5de7f1c$var$rh).toVar(), t.skinIndexNode = $d7238066c5de7f1c$var$TC(new $d7238066c5de7f1c$var$SA(new Uint32Array(r.geometry.getAttribute("skinIndex").array), 4), "uvec4").setPBO(!0).toReadOnly().element($d7238066c5de7f1c$var$rh).toVar(), t.skinWeightNode = $d7238066c5de7f1c$var$TC(new $d7238066c5de7f1c$var$SA(r.geometry.getAttribute("skinWeight").array, 4), "vec4").setPBO(!0).toReadOnly().element($d7238066c5de7f1c$var$rh).toVar(), t.bindMatrixNode = $d7238066c5de7f1c$var$yt(r.bindMatrix, "mat4"), t.bindMatrixInverseNode = $d7238066c5de7f1c$var$yt(r.bindMatrixInverse, "mat4"), t.boneMatricesNode = $d7238066c5de7f1c$var$PB(r.skeleton.boneMatrices, "mat4", r.skeleton.bones.length), t.toPositionNode = e, $d7238066c5de7f1c$var$He(t);
};
class $d7238066c5de7f1c$var$kie extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "LoopNode";
    }
    /**
   * Constructs a new loop node.
   *
   * @param {Array<any>} params - Depending on the loop type, array holds different parameterization values for the loop.
   */ constructor(e = []){
        super("void"), this.params = e;
    }
    /**
   * Returns a loop variable name based on an index. The pattern is
   * `0` = `i`, `1`= `j`, `2`= `k` and so on.
   *
   * @param {number} index - The index.
   * @return {string} The loop variable name.
   */ getVarName(e) {
        return String.fromCharCode(105 + e);
    }
    /**
   * Returns properties about this node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Object} The node properties.
   */ getProperties(e) {
        const t = e.getNodeProperties(this);
        if (t.stackNode !== void 0) return t;
        const i = {};
        for(let o = 0, g = this.params.length - 1; o < g; o++){
            const l = this.params[o], c = l.isNode !== !0 && l.name || this.getVarName(o), d = l.isNode !== !0 && l.type || "int";
            i[c] = $d7238066c5de7f1c$var$ZI(c, d);
        }
        const n = e.addStack(), s = this.params[this.params.length - 1](i);
        t.returnsNode = s.context({
            nodeLoop: s
        }), t.stackNode = n;
        const a = this.params[0];
        if (a.isNode !== !0 && typeof a.update == "function") {
            const o = $d7238066c5de7f1c$var$oe(this.params[0].update)(i);
            t.updateNode = o.context({
                nodeLoop: o
            });
        }
        return e.removeStack(), t;
    }
    setup(e) {
        if (this.getProperties(e), e.fnCall) {
            const t = e.getDataFromNode(e.fnCall.shaderNode);
            t.hasLoop = !0;
        }
    }
    generate(e) {
        const t = this.getProperties(e), i = this.params, n = t.stackNode;
        for(let a = 0, o = i.length - 1; a < o; a++){
            const g = i[a];
            let l = !1, c = null, d = null, p = null, A = null, y = null, G = null;
            g.isNode ? g.getNodeType(e) === "bool" ? (l = !0, A = "bool", d = g.build(e, A)) : (A = "int", p = this.getVarName(a), c = "0", d = g.build(e, A), y = "<") : (A = g.type || "int", p = g.name || this.getVarName(a), c = g.start, d = g.end, y = g.condition, G = g.update, typeof c == "number" ? c = e.generateConst(A, c) : c && c.isNode && (c = c.build(e, A)), typeof d == "number" ? d = e.generateConst(A, d) : d && d.isNode && (d = d.build(e, A)), c !== void 0 && d === void 0 ? (c = c + " - 1", d = "0", y = ">=") : d !== void 0 && c === void 0 && (c = "0", y = "<"), y === void 0 && (Number(c) > Number(d) ? y = ">=" : y = "<"));
            let Z;
            if (l) Z = `while ( ${d} )`;
            else {
                const v = {
                    start: c,
                    end: d
                }, V = v.start, H = v.end;
                let N;
                const Y = ()=>y.includes("<") ? "+=" : "-=";
                if (G != null) switch(typeof G){
                    case "function":
                        N = e.flowStagesNode(t.updateNode, "void").code.replace(/\t|;/g, "");
                        break;
                    case "number":
                        N = p + " " + Y() + " " + e.generateConst(A, G);
                        break;
                    case "string":
                        N = p + " " + G;
                        break;
                    default:
                        G.isNode ? N = p + " " + Y() + " " + G.build(e) : ($d7238066c5de7f1c$var$nt("TSL: 'Loop( { update: ... } )' is not a function, string or number."), N = "break /* invalid update */");
                }
                else A === "int" || A === "uint" ? G = y.includes("<") ? "++" : "--" : G = Y() + " 1.", N = p + " " + G;
                const K = e.getVar(A, p) + " = " + V, z = p + " " + y + " " + H;
                Z = `for ( ${K}; ${z}; ${N} )`;
            }
            e.addFlowCode((a === 0 ? `
` : "") + e.tab + Z + ` {

`).addFlowTab();
        }
        const s = n.build(e, "void");
        t.returnsNode.build(e, "void"), e.removeFlowTab().addFlowCode(`
` + e.tab + s);
        for(let a = 0, o = this.params.length - 1; a < o; a++)e.addFlowCode((a === 0 ? "" : e.tab) + `}

`).removeFlowTab();
        e.addFlowTab();
    }
}
const $d7238066c5de7f1c$var$Cn = (...r)=>new $d7238066c5de7f1c$var$kie($d7238066c5de7f1c$var$KC(r, "int")).toStack(), $d7238066c5de7f1c$var$Eie = ()=>$d7238066c5de7f1c$var$ZI("continue").toStack(), $d7238066c5de7f1c$var$AU = ()=>$d7238066c5de7f1c$var$ZI("break").toStack(), $d7238066c5de7f1c$var$IH = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$jo = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$Q5 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ bufferMap: r, influence: e, stride: t, width: i, depth: n, offset: s })=>{
    const a = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$uU).mul(t).add(s), o = a.div(i), g = a.sub(o.mul(i));
    return $d7238066c5de7f1c$var$ys(r, $d7238066c5de7f1c$var$vr(g, o)).depth(n).xyz.mul(e);
});
function $d7238066c5de7f1c$var$Jie(r) {
    const e = r.morphAttributes.position !== void 0, t = r.morphAttributes.normal !== void 0, i = r.morphAttributes.color !== void 0, n = r.morphAttributes.position || r.morphAttributes.normal || r.morphAttributes.color, s = n !== void 0 ? n.length : 0;
    let a = $d7238066c5de7f1c$var$IH.get(r);
    if (a === void 0 || a.count !== s) {
        let v = function() {
            G.dispose(), $d7238066c5de7f1c$var$IH.delete(r), r.removeEventListener("dispose", v);
        };
        a !== void 0 && a.texture.dispose();
        const o = r.morphAttributes.position || [], g = r.morphAttributes.normal || [], l = r.morphAttributes.color || [];
        let c = 0;
        e === !0 && (c = 1), t === !0 && (c = 2), i === !0 && (c = 3);
        let d = r.attributes.position.count * c, p = 1;
        const A = 4096;
        d > A && (p = Math.ceil(d / A), d = A);
        const y = new Float32Array(d * p * 4 * s), G = new $d7238066c5de7f1c$var$X$(y, d, p, s);
        G.type = $d7238066c5de7f1c$var$vo, G.needsUpdate = !0;
        const Z = c * 4;
        for(let V = 0; V < s; V++){
            const H = o[V], N = g[V], Y = l[V], K = d * p * 4 * V;
            for(let z = 0; z < H.count; z++){
                const M = z * Z;
                e === !0 && ($d7238066c5de7f1c$var$jo.fromBufferAttribute(H, z), y[K + M + 0] = $d7238066c5de7f1c$var$jo.x, y[K + M + 1] = $d7238066c5de7f1c$var$jo.y, y[K + M + 2] = $d7238066c5de7f1c$var$jo.z, y[K + M + 3] = 0), t === !0 && ($d7238066c5de7f1c$var$jo.fromBufferAttribute(N, z), y[K + M + 4] = $d7238066c5de7f1c$var$jo.x, y[K + M + 5] = $d7238066c5de7f1c$var$jo.y, y[K + M + 6] = $d7238066c5de7f1c$var$jo.z, y[K + M + 7] = 0), i === !0 && ($d7238066c5de7f1c$var$jo.fromBufferAttribute(Y, z), y[K + M + 8] = $d7238066c5de7f1c$var$jo.x, y[K + M + 9] = $d7238066c5de7f1c$var$jo.y, y[K + M + 10] = $d7238066c5de7f1c$var$jo.z, y[K + M + 11] = Y.itemSize === 4 ? $d7238066c5de7f1c$var$jo.w : 1);
            }
        }
        a = {
            count: s,
            texture: G,
            stride: c,
            size: new $d7238066c5de7f1c$var$Ii(d, p)
        }, $d7238066c5de7f1c$var$IH.set(r, a), r.addEventListener("dispose", v);
    }
    return a;
}
class $d7238066c5de7f1c$var$Uie extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "MorphNode";
    }
    /**
   * Constructs a new morph node.
   *
   * @param {Mesh} mesh - The mesh holding the morph targets.
   */ constructor(e){
        super("void"), this.mesh = e, this.morphBaseInfluence = $d7238066c5de7f1c$var$yt(1), this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT;
    }
    /**
   * Setups the morph node by assigning the transformed vertex data to predefined node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        const { geometry: t } = e, i = t.morphAttributes.position !== void 0, n = t.hasAttribute("normal") && t.morphAttributes.normal !== void 0, s = t.morphAttributes.position || t.morphAttributes.normal || t.morphAttributes.color, a = s !== void 0 ? s.length : 0, { texture: o, stride: g, size: l } = $d7238066c5de7f1c$var$Jie(t);
        i === !0 && $d7238066c5de7f1c$var$Ns.mulAssign(this.morphBaseInfluence), n === !0 && $d7238066c5de7f1c$var$No.mulAssign(this.morphBaseInfluence);
        const c = $d7238066c5de7f1c$var$ee(l.width);
        $d7238066c5de7f1c$var$Cn(a, ({ i: d })=>{
            const p = $d7238066c5de7f1c$var$J(0).toVar();
            this.mesh.count > 1 && this.mesh.morphTexture !== null && this.mesh.morphTexture !== void 0 ? p.assign($d7238066c5de7f1c$var$ys(this.mesh.morphTexture, $d7238066c5de7f1c$var$vr($d7238066c5de7f1c$var$ee(d).add(1), $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$rh))).r) : p.assign($d7238066c5de7f1c$var$vn("morphTargetInfluences", "float").element(d).toVar()), $d7238066c5de7f1c$var$Ht(p.notEqual(0), ()=>{
                i === !0 && $d7238066c5de7f1c$var$Ns.addAssign($d7238066c5de7f1c$var$Q5({
                    bufferMap: o,
                    influence: p,
                    stride: g,
                    width: c,
                    depth: d,
                    offset: $d7238066c5de7f1c$var$ee(0)
                })), n === !0 && $d7238066c5de7f1c$var$No.addAssign($d7238066c5de7f1c$var$Q5({
                    bufferMap: o,
                    influence: p,
                    stride: g,
                    width: c,
                    depth: d,
                    offset: $d7238066c5de7f1c$var$ee(1)
                }));
            });
        });
    }
    /**
   * Updates the state of the morphed mesh by updating the base influence.
   *
   * @param {NodeFrame} frame - The current node frame.
   */ update() {
        const e = this.morphBaseInfluence;
        this.mesh.geometry.morphTargetsRelative ? e.value = 1 : e.value = 1 - this.mesh.morphTargetInfluences.reduce((t, i)=>t + i, 0);
    }
}
const $d7238066c5de7f1c$var$bU = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Uie).setParameterLength(1);
class $d7238066c5de7f1c$var$a0 extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "LightingNode";
    }
    /**
   * Constructs a new lighting node.
   */ constructor(){
        super("vec3"), this.isLightingNode = !0;
    }
}
class $d7238066c5de7f1c$var$Die extends $d7238066c5de7f1c$var$a0 {
    static get type() {
        return "AONode";
    }
    /**
   * Constructs a new AO node.
   *
   * @param {?Node<float>} [aoNode=null] - The ambient occlusion node.
   */ constructor(e = null){
        super(), this.aoNode = e;
    }
    setup(e) {
        e.context.ambientOcclusion.mulAssign(this.aoNode);
    }
}
class $d7238066c5de7f1c$var$_ie extends $d7238066c5de7f1c$var$LE {
    static get type() {
        return "LightingContextNode";
    }
    /**
   * Constructs a new lighting context node.
   *
   * @param {LightsNode} lightsNode - The lights node.
   * @param {?LightingModel} [lightingModel=null] - The current lighting model.
   * @param {?Node<vec3>} [backdropNode=null] - A backdrop node.
   * @param {?Node<float>} [backdropAlphaNode=null] - A backdrop alpha node.
   */ constructor(e, t = null, i = null, n = null){
        super(e), this.lightingModel = t, this.backdropNode = i, this.backdropAlphaNode = n, this._value = null;
    }
    /**
   * Returns a lighting context object.
   *
   * @return {{
   * radiance: Node<vec3>,
   * irradiance: Node<vec3>,
   * iblIrradiance: Node<vec3>,
   * ambientOcclusion: Node<float>,
   * reflectedLight: {directDiffuse: Node<vec3>, directSpecular: Node<vec3>, indirectDiffuse: Node<vec3>, indirectSpecular: Node<vec3>},
   * backdrop: Node<vec3>,
   * backdropAlpha: Node<float>
   * }} The lighting context object.
   */ getContext() {
        const { backdropNode: e, backdropAlphaNode: t } = this, i = $d7238066c5de7f1c$var$ne().toVar("directDiffuse"), n = $d7238066c5de7f1c$var$ne().toVar("directSpecular"), s = $d7238066c5de7f1c$var$ne().toVar("indirectDiffuse"), a = $d7238066c5de7f1c$var$ne().toVar("indirectSpecular"), o = {
            directDiffuse: i,
            directSpecular: n,
            indirectDiffuse: s,
            indirectSpecular: a
        };
        return {
            radiance: $d7238066c5de7f1c$var$ne().toVar("radiance"),
            irradiance: $d7238066c5de7f1c$var$ne().toVar("irradiance"),
            iblIrradiance: $d7238066c5de7f1c$var$ne().toVar("iblIrradiance"),
            ambientOcclusion: $d7238066c5de7f1c$var$J(1).toVar("ambientOcclusion"),
            reflectedLight: o,
            backdrop: e,
            backdropAlpha: t
        };
    }
    setup(e) {
        return this.value = this._value || (this._value = this.getContext()), this.value.lightingModel = this.lightingModel || e.context.lightingModel, super.setup(e);
    }
}
const $d7238066c5de7f1c$var$yU = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$_ie);
class $d7238066c5de7f1c$var$Pie extends $d7238066c5de7f1c$var$a0 {
    static get type() {
        return "IrradianceNode";
    }
    /**
   * Constructs a new irradiance node.
   *
   * @param {Node<vec3>} node - A node contributing irradiance.
   */ constructor(e){
        super(), this.node = e;
    }
    setup(e) {
        e.context.irradiance.addAssign(this.node);
    }
}
const $d7238066c5de7f1c$var$xm = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
class $d7238066c5de7f1c$var$WR extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "ViewportTextureNode";
    }
    /**
   * Constructs a new viewport texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {?Node} [levelNode=null] - The level node.
   * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
   */ constructor(e = $d7238066c5de7f1c$var$AI, t = null, i = null){
        let n = null;
        i === null ? (n = new $d7238066c5de7f1c$var$aL(), n.minFilter = $d7238066c5de7f1c$var$II, i = n) : n = i, super(i, e, t), this.generateMipmaps = !1, this.defaultFramebuffer = n, this.isOutputTextureNode = !0, this.updateBeforeType = $d7238066c5de7f1c$var$Dt.FRAME, this._cacheTextures = /* @__PURE__ */ new WeakMap();
    }
    /**
   * This methods returns a texture for the given render target reference.
   *
   * To avoid rendering errors, `ViewportTextureNode` must use unique framebuffer textures
   * for different render contexts.
   *
   * @param {?RenderTarget} [reference=null] - The render target reference.
   * @return {Texture} The framebuffer texture.
   */ getTextureForReference(e = null) {
        let t, i;
        if (this.referenceNode ? (t = this.referenceNode.defaultFramebuffer, i = this.referenceNode._cacheTextures) : (t = this.defaultFramebuffer, i = this._cacheTextures), e === null) return t;
        if (i.has(e) === !1) {
            const n = t.clone();
            i.set(e, n);
        }
        return i.get(e);
    }
    updateReference(e) {
        const t = e.renderer.getRenderTarget();
        return this.value = this.getTextureForReference(t), this.value;
    }
    updateBefore(e) {
        const t = e.renderer, i = t.getRenderTarget();
        i === null ? t.getDrawingBufferSize($d7238066c5de7f1c$var$xm) : $d7238066c5de7f1c$var$xm.set(i.width, i.height);
        const n = this.getTextureForReference(i);
        (n.image.width !== $d7238066c5de7f1c$var$xm.width || n.image.height !== $d7238066c5de7f1c$var$xm.height) && (n.image.width = $d7238066c5de7f1c$var$xm.width, n.image.height = $d7238066c5de7f1c$var$xm.height, n.needsUpdate = !0);
        const s = n.generateMipmaps;
        n.generateMipmaps = this.generateMipmaps, t.copyFramebufferToTexture(n), n.generateMipmaps = s;
    }
    clone() {
        const e = new this.constructor(this.uvNode, this.levelNode, this.value);
        return e.generateMipmaps = this.generateMipmaps, e;
    }
}
const $d7238066c5de7f1c$var$Qie = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$WR).setParameterLength(0, 3), $d7238066c5de7f1c$var$cY = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$WR, null, null, {
    generateMipmaps: !0
}).setParameterLength(0, 3);
let $d7238066c5de7f1c$var$Xv = null;
class $d7238066c5de7f1c$var$Oie extends $d7238066c5de7f1c$var$WR {
    static get type() {
        return "ViewportDepthTextureNode";
    }
    /**
   * Constructs a new viewport depth texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {?Node} [levelNode=null] - The level node.
   */ constructor(e = $d7238066c5de7f1c$var$AI, t = null){
        $d7238066c5de7f1c$var$Xv === null && ($d7238066c5de7f1c$var$Xv = new $d7238066c5de7f1c$var$$l()), super(e, t, $d7238066c5de7f1c$var$Xv);
    }
    /**
   * Overwritten so the method always returns the unique shared
   * depth texture.
   *
   * @return {DepthTexture} The shared depth texture.
   */ getTextureForReference() {
        return $d7238066c5de7f1c$var$Xv;
    }
}
const $d7238066c5de7f1c$var$uY = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Oie).setParameterLength(0, 2);
class $d7238066c5de7f1c$var$Zo extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ViewportDepthNode";
    }
    /**
   * Constructs a new viewport depth node.
   *
   * @param {('depth'|'depthBase'|'linearDepth')} scope - The node's scope.
   * @param {?Node} [valueNode=null] - The value node.
   */ constructor(e, t = null){
        super("float"), this.scope = e, this.valueNode = t, this.isViewportDepthNode = !0;
    }
    generate(e) {
        const { scope: t } = this;
        return t === $d7238066c5de7f1c$var$Zo.DEPTH_BASE ? e.getFragDepth() : super.generate(e);
    }
    setup({ camera: e }) {
        const { scope: t } = this, i = this.valueNode;
        let n = null;
        if (t === $d7238066c5de7f1c$var$Zo.DEPTH_BASE) i !== null && (n = $d7238066c5de7f1c$var$fU().assign(i));
        else if (t === $d7238066c5de7f1c$var$Zo.DEPTH) e.isPerspectiveCamera ? n = $d7238066c5de7f1c$var$BU($d7238066c5de7f1c$var$Ls.z, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd) : n = $d7238066c5de7f1c$var$wA($d7238066c5de7f1c$var$Ls.z, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd);
        else if (t === $d7238066c5de7f1c$var$Zo.LINEAR_DEPTH) {
            if (i !== null) {
                if (e.isPerspectiveCamera) {
                    const s = $d7238066c5de7f1c$var$IY(i, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd);
                    n = $d7238066c5de7f1c$var$wA(s, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd);
                } else n = i;
            } else n = $d7238066c5de7f1c$var$wA($d7238066c5de7f1c$var$Ls.z, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd);
        }
        return n;
    }
}
$d7238066c5de7f1c$var$Zo.DEPTH_BASE = "depthBase";
$d7238066c5de7f1c$var$Zo.DEPTH = "depth";
$d7238066c5de7f1c$var$Zo.LINEAR_DEPTH = "linearDepth";
const $d7238066c5de7f1c$var$wA = (r, e, t)=>r.add(e).div(e.sub(t)), $d7238066c5de7f1c$var$jie = (r, e, t)=>e.sub(t).mul(r).sub(e), $d7238066c5de7f1c$var$BU = (r, e, t)=>e.add(r).mul(t).div(t.sub(e).mul(r)), $d7238066c5de7f1c$var$IY = (r, e, t)=>e.mul(t).div(t.sub(e).mul(r).sub(t)), $d7238066c5de7f1c$var$dY = (r, e, t)=>{
    e = e.max(1e-6).toVar();
    const i = $d7238066c5de7f1c$var$su(r.negate().div(e)), n = $d7238066c5de7f1c$var$su(t.div(e));
    return i.div(n);
}, $d7238066c5de7f1c$var$qie = (r, e, t)=>{
    const i = r.mul($d7238066c5de7f1c$var$yR(t.div(e)));
    return $d7238066c5de7f1c$var$J(Math.E).pow(i).mul(e).negate();
}, $d7238066c5de7f1c$var$fU = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Zo, $d7238066c5de7f1c$var$Zo.DEPTH_BASE), $d7238066c5de7f1c$var$hY = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Zo, $d7238066c5de7f1c$var$Zo.DEPTH), $d7238066c5de7f1c$var$LZ = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Zo, $d7238066c5de7f1c$var$Zo.LINEAR_DEPTH).setParameterLength(0, 1), $d7238066c5de7f1c$var$$ie = /* @__PURE__ */ $d7238066c5de7f1c$var$LZ($d7238066c5de7f1c$var$uY());
$d7238066c5de7f1c$var$hY.assign = (r)=>$d7238066c5de7f1c$var$fU(r);
class $d7238066c5de7f1c$var$tl extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ClippingNode";
    }
    /**
   * Constructs a new clipping node.
   *
   * @param {('default'|'hardware'|'alphaToCoverage')} [scope='default'] - The node's scope. Similar to other nodes,
   * the selected scope influences the behavior of the node and what type of code is generated.
   */ constructor(e = $d7238066c5de7f1c$var$tl.DEFAULT){
        super(), this.scope = e;
    }
    /**
   * Setups the node depending on the selected scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The result node.
   */ setup(e) {
        super.setup(e);
        const t = e.clippingContext, { intersectionPlanes: i, unionPlanes: n } = t;
        return this.hardwareClipping = e.material.hardwareClipping, this.scope === $d7238066c5de7f1c$var$tl.ALPHA_TO_COVERAGE ? this.setupAlphaToCoverage(i, n) : this.scope === $d7238066c5de7f1c$var$tl.HARDWARE ? this.setupHardwareClipping(n, e) : this.setupDefault(i, n);
    }
    /**
   * Setups alpha to coverage.
   *
   * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @return {Node} The result node.
   */ setupAlphaToCoverage(e, t) {
        return $d7238066c5de7f1c$var$oe(()=>{
            const i = $d7238066c5de7f1c$var$J().toVar("distanceToPlane"), n = $d7238066c5de7f1c$var$J().toVar("distanceToGradient"), s = $d7238066c5de7f1c$var$J(1).toVar("clipOpacity"), a = t.length;
            if (this.hardwareClipping === !1 && a > 0) {
                const g = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft);
                $d7238066c5de7f1c$var$Cn(a, ({ i: l })=>{
                    const c = g.element(l);
                    i.assign($d7238066c5de7f1c$var$Ls.dot(c.xyz).negate().add(c.w)), n.assign(i.fwidth().div(2)), s.mulAssign($d7238066c5de7f1c$var$ic(n.negate(), n, i));
                });
            }
            const o = e.length;
            if (o > 0) {
                const g = $d7238066c5de7f1c$var$La(e).setGroup($d7238066c5de7f1c$var$ft), l = $d7238066c5de7f1c$var$J(1).toVar("intersectionClipOpacity");
                $d7238066c5de7f1c$var$Cn(o, ({ i: c })=>{
                    const d = g.element(c);
                    i.assign($d7238066c5de7f1c$var$Ls.dot(d.xyz).negate().add(d.w)), n.assign(i.fwidth().div(2)), l.mulAssign($d7238066c5de7f1c$var$ic(n.negate(), n, i).oneMinus());
                }), s.mulAssign(l.oneMinus());
            }
            $d7238066c5de7f1c$var$Ei.a.mulAssign(s), $d7238066c5de7f1c$var$Ei.a.equal(0).discard();
        })();
    }
    /**
   * Setups the default clipping.
   *
   * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @return {Node} The result node.
   */ setupDefault(e, t) {
        return $d7238066c5de7f1c$var$oe(()=>{
            const i = t.length;
            if (this.hardwareClipping === !1 && i > 0) {
                const s = $d7238066c5de7f1c$var$La(t).setGroup($d7238066c5de7f1c$var$ft);
                $d7238066c5de7f1c$var$Cn(i, ({ i: a })=>{
                    const o = s.element(a);
                    $d7238066c5de7f1c$var$Ls.dot(o.xyz).greaterThan(o.w).discard();
                });
            }
            const n = e.length;
            if (n > 0) {
                const s = $d7238066c5de7f1c$var$La(e).setGroup($d7238066c5de7f1c$var$ft), a = $d7238066c5de7f1c$var$nl(!0).toVar("clipped");
                $d7238066c5de7f1c$var$Cn(n, ({ i: o })=>{
                    const g = s.element(o);
                    a.assign($d7238066c5de7f1c$var$Ls.dot(g.xyz).greaterThan(g.w).and(a));
                }), a.discard();
            }
        })();
    }
    /**
   * Setups hardware clipping.
   *
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The result node.
   */ setupHardwareClipping(e, t) {
        const i = e.length;
        return t.enableHardwareClipping(i), $d7238066c5de7f1c$var$oe(()=>{
            const n = $d7238066c5de7f1c$var$La(e).setGroup($d7238066c5de7f1c$var$ft), s = $d7238066c5de7f1c$var$HI(t.getClipDistance());
            $d7238066c5de7f1c$var$Cn(i, ({ i: a })=>{
                const o = n.element(a), g = $d7238066c5de7f1c$var$Ls.dot(o.xyz).sub(o.w).negate();
                s.element(a).assign(g);
            });
        })();
    }
}
$d7238066c5de7f1c$var$tl.ALPHA_TO_COVERAGE = "alphaToCoverage";
$d7238066c5de7f1c$var$tl.DEFAULT = "default";
$d7238066c5de7f1c$var$tl.HARDWARE = "hardware";
const $d7238066c5de7f1c$var$ene = ()=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$tl()), $d7238066c5de7f1c$var$tne = ()=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$tl($d7238066c5de7f1c$var$tl.ALPHA_TO_COVERAGE)), $d7238066c5de7f1c$var$ine = ()=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$tl($d7238066c5de7f1c$var$tl.HARDWARE)), $d7238066c5de7f1c$var$nne = 0.05, $d7238066c5de7f1c$var$O5 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>$d7238066c5de7f1c$var$ec($d7238066c5de7f1c$var$Et(1e4, $d7238066c5de7f1c$var$Go($d7238066c5de7f1c$var$Et(17, r.x).add($d7238066c5de7f1c$var$Et(0.1, r.y)))).mul($d7238066c5de7f1c$var$Ps(0.1, $d7238066c5de7f1c$var$Wn($d7238066c5de7f1c$var$Go($d7238066c5de7f1c$var$Et(13, r.y).add(r.x))))))), $d7238066c5de7f1c$var$j5 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>$d7238066c5de7f1c$var$O5($d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$O5(r.xy), r.z))), $d7238066c5de7f1c$var$sne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$En($d7238066c5de7f1c$var$au($d7238066c5de7f1c$var$YL(r.xyz)), $d7238066c5de7f1c$var$au($d7238066c5de7f1c$var$KL(r.xyz))), t = $d7238066c5de7f1c$var$J(1).div($d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$nne).mul(e)).toVar("pixScale"), i = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$zA($d7238066c5de7f1c$var$ru($d7238066c5de7f1c$var$su(t))), $d7238066c5de7f1c$var$zA($d7238066c5de7f1c$var$BR($d7238066c5de7f1c$var$su(t)))), n = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$j5($d7238066c5de7f1c$var$ru(i.x.mul(r.xyz))), $d7238066c5de7f1c$var$j5($d7238066c5de7f1c$var$ru(i.y.mul(r.xyz)))), s = $d7238066c5de7f1c$var$ec($d7238066c5de7f1c$var$su(t)), a = $d7238066c5de7f1c$var$Ps($d7238066c5de7f1c$var$Et(s.oneMinus(), n.x), $d7238066c5de7f1c$var$Et(s, n.y)), o = $d7238066c5de7f1c$var$Xo(s, s.oneMinus()), g = $d7238066c5de7f1c$var$ne(a.mul(a).div($d7238066c5de7f1c$var$Et(2, o).mul($d7238066c5de7f1c$var$wi(1, o))), a.sub($d7238066c5de7f1c$var$Et(0.5, o)).div($d7238066c5de7f1c$var$wi(1, o)), $d7238066c5de7f1c$var$wi(1, $d7238066c5de7f1c$var$wi(1, a).mul($d7238066c5de7f1c$var$wi(1, a)).div($d7238066c5de7f1c$var$Et(2, o).mul($d7238066c5de7f1c$var$wi(1, o))))), l = a.lessThan(o.oneMinus()).select(a.lessThan(o).select(g.x, g.y), g.z);
    return $d7238066c5de7f1c$var$sl(l, 1e-6, 1);
}).setLayout({
    name: "getAlphaHashThreshold",
    type: "float",
    inputs: [
        {
            name: "position",
            type: "vec3"
        }
    ]
});
class $d7238066c5de7f1c$var$rne extends $d7238066c5de7f1c$var$aJ {
    static get type() {
        return "VertexColorNode";
    }
    /**
   * Constructs a new vertex color node.
   *
   * @param {number} index - The attribute index.
   */ constructor(e){
        super(null, "vec4"), this.isVertexColorNode = !0, this.index = e;
    }
    /**
   * Overwrites the default implementation by honoring the attribute index.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The attribute name.
   */ getAttributeName() {
        const e = this.index;
        return "color" + (e > 0 ? e : "");
    }
    generate(e) {
        const t = this.getAttributeName(e), i = e.hasGeometryAttribute(t);
        let n;
        return i === !0 ? n = super.generate(e) : n = e.generateConst(this.nodeType, new $d7238066c5de7f1c$var$Gi(1, 1, 1, 1)), n;
    }
    serialize(e) {
        super.serialize(e), e.index = this.index;
    }
    deserialize(e) {
        super.deserialize(e), this.index = e.index;
    }
}
const $d7238066c5de7f1c$var$GU = (r = 0)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$rne(r)), $d7238066c5de7f1c$var$vU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>$d7238066c5de7f1c$var$Xo(1, r.oneMinus().div(e)).oneMinus()).setLayout({
    name: "blendBurn",
    type: "vec3",
    inputs: [
        {
            name: "base",
            type: "vec3"
        },
        {
            name: "blend",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$SU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>$d7238066c5de7f1c$var$Xo(r.div(e.oneMinus()), 1)).setLayout({
    name: "blendDodge",
    type: "vec3",
    inputs: [
        {
            name: "base",
            type: "vec3"
        },
        {
            name: "blend",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$ZU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>r.oneMinus().mul(e.oneMinus()).oneMinus()).setLayout({
    name: "blendScreen",
    type: "vec3",
    inputs: [
        {
            name: "base",
            type: "vec3"
        },
        {
            name: "blend",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$RU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>$d7238066c5de7f1c$var$qi(r.mul(2).mul(e), r.oneMinus().mul(2).mul(e.oneMinus()).oneMinus(), $d7238066c5de7f1c$var$GR(0.5, r))).setLayout({
    name: "blendOverlay",
    type: "vec3",
    inputs: [
        {
            name: "base",
            type: "vec3"
        },
        {
            name: "blend",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$ane = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = e.a.add(r.a.mul(e.a.oneMinus()));
    return $d7238066c5de7f1c$var$Rt(e.rgb.mul(e.a).add(r.rgb.mul(r.a).mul(e.a.oneMinus())).div(t), t);
}).setLayout({
    name: "blendColor",
    type: "vec4",
    inputs: [
        {
            name: "base",
            type: "vec4"
        },
        {
            name: "blend",
            type: "vec4"
        }
    ]
}), $d7238066c5de7f1c$var$VU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>$d7238066c5de7f1c$var$Rt(r.rgb.mul(r.a), r.a), {
    color: "vec4",
    return: "vec4"
}), $d7238066c5de7f1c$var$one = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>($d7238066c5de7f1c$var$Ht(r.a.equal(0), ()=>$d7238066c5de7f1c$var$Rt(0)), $d7238066c5de7f1c$var$Rt(r.rgb.div(r.a), r.a)), {
    color: "vec4",
    return: "vec4"
}), $d7238066c5de7f1c$var$gne = (...r)=>($d7238066c5de7f1c$var$ze('TSL: "burn" has been renamed. Use "blendBurn" instead.'), $d7238066c5de7f1c$var$vU(r)), $d7238066c5de7f1c$var$lne = (...r)=>($d7238066c5de7f1c$var$ze('TSL: "dodge" has been renamed. Use "blendDodge" instead.'), $d7238066c5de7f1c$var$SU(r)), $d7238066c5de7f1c$var$cne = (...r)=>($d7238066c5de7f1c$var$ze('TSL: "screen" has been renamed. Use "blendScreen" instead.'), $d7238066c5de7f1c$var$ZU(r)), $d7238066c5de7f1c$var$une = (...r)=>($d7238066c5de7f1c$var$ze('TSL: "overlay" has been renamed. Use "blendOverlay" instead.'), $d7238066c5de7f1c$var$RU(r));
class $d7238066c5de7f1c$var$Bs extends $d7238066c5de7f1c$var$Ho {
    static get type() {
        return "NodeMaterial";
    }
    /**
   * Represents the type of the node material.
   *
   * @type {string}
   */ get type() {
        return this.constructor.type;
    }
    set type(e) {}
    /**
   * Constructs a new node material.
   */ constructor(){
        super(), this.isNodeMaterial = !0, this.fog = !0, this.lights = !1, this.hardwareClipping = !1, this.lightsNode = null, this.envNode = null, this.aoNode = null, this.colorNode = null, this.normalNode = null, this.opacityNode = null, this.backdropNode = null, this.backdropAlphaNode = null, this.alphaTestNode = null, this.maskNode = null, this.positionNode = null, this.geometryNode = null, this.depthNode = null, this.receivedShadowPositionNode = null, this.castShadowPositionNode = null, this.receivedShadowNode = null, this.castShadowNode = null, this.outputNode = null, this.mrtNode = null, this.fragmentNode = null, this.vertexNode = null, Object.defineProperty(this, "shadowPositionNode", {
            // @deprecated, r176
            get: ()=>this.receivedShadowPositionNode,
            set: (e)=>{
                $d7238066c5de7f1c$var$ze('NodeMaterial: ".shadowPositionNode" was renamed to ".receivedShadowPositionNode".'), this.receivedShadowPositionNode = e;
            }
        });
    }
    /**
   * Returns an array of child nodes for this material.
   *
   * @private
   * @returns {Array<{property: string, childNode: Node}>}
   */ _getNodeChildren() {
        const e = [];
        for (const t of Object.getOwnPropertyNames(this)){
            if (t.startsWith("_") === !0) continue;
            const i = this[t];
            i && i.isNode === !0 && e.push({
                property: t,
                childNode: i
            });
        }
        return e;
    }
    /**
   * Allows to define a custom cache key that influence the material key computation
   * for render objects.
   *
   * @return {string} The custom cache key.
   */ customProgramCacheKey() {
        const e = [];
        for (const { property: t, childNode: i } of this._getNodeChildren())e.push($d7238066c5de7f1c$var$EB(t.slice(0, -4)), i.getCacheKey());
        return this.type + $d7238066c5de7f1c$var$i0(e);
    }
    /**
   * Builds this material with the given node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ build(e) {
        this.setup(e);
    }
    /**
   * Setups a node material observer with the given builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeMaterialObserver} The node material observer.
   */ setupObserver(e) {
        return new $d7238066c5de7f1c$var$Xee(e);
    }
    /**
   * Setups the vertex and fragment stage of this node material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        e.context.setupNormal = ()=>$d7238066c5de7f1c$var$RA(this.setupNormal(e), "NORMAL", "vec3"), e.context.setupPositionView = ()=>this.setupPositionView(e), e.context.setupModelViewProjection = ()=>this.setupModelViewProjection(e);
        const t = e.renderer, i = t.getRenderTarget();
        e.addStack();
        const n = $d7238066c5de7f1c$var$RA(this.setupVertex(e), "VERTEX"), s = this.vertexNode || n;
        e.stack.outputNode = s, this.setupHardwareClipping(e), this.geometryNode !== null && (e.stack.outputNode = e.stack.outputNode.bypass(this.geometryNode)), e.addFlow("vertex", e.removeStack()), e.addStack();
        let a;
        const o = this.setupClipping(e);
        if ((this.depthWrite === !0 || this.depthTest === !0) && (i !== null ? i.depthBuffer === !0 && this.setupDepth(e) : t.depth === !0 && this.setupDepth(e)), this.fragmentNode === null) {
            this.setupDiffuseColor(e), this.setupVariants(e);
            const g = this.setupLighting(e);
            o !== null && e.stack.addToStack(o);
            const l = $d7238066c5de7f1c$var$Rt(g, $d7238066c5de7f1c$var$Ei.a).max(0);
            a = this.setupOutput(e, l), $d7238066c5de7f1c$var$ZA.assign(a);
            const c = this.outputNode !== null;
            if (c && (a = this.outputNode), i !== null) {
                const d = t.getMRT(), p = this.mrtNode;
                d !== null ? (c && $d7238066c5de7f1c$var$ZA.assign(a), a = d, p !== null && (a = d.merge(p))) : p !== null && (a = p);
            }
        } else {
            let g = this.fragmentNode;
            g.isOutputStructNode !== !0 && (g = $d7238066c5de7f1c$var$Rt(g)), a = this.setupOutput(e, g);
        }
        e.stack.outputNode = a, e.addFlow("fragment", e.removeStack()), e.observer = this.setupObserver(e);
    }
    /**
   * Setups the clipping node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {ClippingNode} The clipping node.
   */ setupClipping(e) {
        if (e.clippingContext === null) return null;
        const { unionPlanes: t, intersectionPlanes: i } = e.clippingContext;
        let n = null;
        if (t.length > 0 || i.length > 0) {
            const s = e.renderer.currentSamples;
            this.alphaToCoverage && s > 1 ? n = $d7238066c5de7f1c$var$tne() : e.stack.addToStack($d7238066c5de7f1c$var$ene());
        }
        return n;
    }
    /**
   * Setups the hardware clipping if available on the current device.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupHardwareClipping(e) {
        if (this.hardwareClipping = !1, e.clippingContext === null) return;
        const t = e.clippingContext.unionPlanes.length;
        t > 0 && t <= 8 && e.isAvailable("clipDistance") && (e.stack.addToStack($d7238066c5de7f1c$var$ine()), this.hardwareClipping = !0);
    }
    /**
   * Setups the depth of this material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupDepth(e) {
        const { renderer: t, camera: i } = e;
        let n = this.depthNode;
        if (n === null) {
            const s = t.getMRT();
            s && s.has("depth") ? n = s.get("depth") : t.logarithmicDepthBuffer === !0 && (i.isPerspectiveCamera ? n = $d7238066c5de7f1c$var$dY($d7238066c5de7f1c$var$Ls.z, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd) : n = $d7238066c5de7f1c$var$wA($d7238066c5de7f1c$var$Ls.z, $d7238066c5de7f1c$var$_d, $d7238066c5de7f1c$var$Pd));
        }
        n !== null && $d7238066c5de7f1c$var$hY.assign(n).toStack();
    }
    /**
   * Setups the position node in view space. This method exists
   * so derived node materials can modify the implementation e.g. sprite materials.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in view space.
   */ setupPositionView() {
        return $d7238066c5de7f1c$var$qC.mul($d7238066c5de7f1c$var$Ns).xyz;
    }
    /**
   * Setups the position in clip space.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The position in view space.
   */ setupModelViewProjection() {
        return $d7238066c5de7f1c$var$s0.mul($d7238066c5de7f1c$var$Ls);
    }
    /**
   * Setups the logic for the vertex stage.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The position in clip space.
   */ setupVertex(e) {
        return e.addStack(), this.setupPosition(e), e.context.vertex = e.removeStack(), $d7238066c5de7f1c$var$lY;
    }
    /**
   * Setups the computation of the position in local space.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in local space.
   */ setupPosition(e) {
        const { object: t, geometry: i } = e;
        if ((i.morphAttributes.position || i.morphAttributes.normal || i.morphAttributes.color) && $d7238066c5de7f1c$var$bU(t).toStack(), t.isSkinnedMesh === !0 && $d7238066c5de7f1c$var$mU(t).toStack(), this.displacementMap) {
            const n = $d7238066c5de7f1c$var$rI("displacementMap", "texture"), s = $d7238066c5de7f1c$var$rI("displacementScale", "float"), a = $d7238066c5de7f1c$var$rI("displacementBias", "float");
            $d7238066c5de7f1c$var$Ns.addAssign($d7238066c5de7f1c$var$No.normalize().mul(n.x.mul(s).add(a)));
        }
        return t.isBatchedMesh && $d7238066c5de7f1c$var$CU(t).toStack(), t.isInstancedMesh && t.instanceMatrix && t.instanceMatrix.isInstancedBufferAttribute === !0 && $d7238066c5de7f1c$var$hU(t).toStack(), this.positionNode !== null && $d7238066c5de7f1c$var$Ns.assign($d7238066c5de7f1c$var$RA(this.positionNode, "POSITION", "vec3")), $d7238066c5de7f1c$var$Ns;
    }
    /**
   * Setups the computation of the material's diffuse color.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {BufferGeometry} geometry - The geometry.
   */ setupDiffuseColor(e) {
        const { object: t, geometry: i } = e;
        this.maskNode !== null && $d7238066c5de7f1c$var$nl(this.maskNode).not().discard();
        let n = this.colorNode ? $d7238066c5de7f1c$var$Rt(this.colorNode) : $d7238066c5de7f1c$var$YJ;
        this.vertexColors === !0 && i.hasAttribute("color") && (n = n.mul($d7238066c5de7f1c$var$GU())), t.instanceColor && (n = $d7238066c5de7f1c$var$IB("vec3", "vInstanceColor").mul(n)), t.isBatchedMesh && t._colorsTexture && (n = $d7238066c5de7f1c$var$IB("vec3", "vBatchColor").mul(n)), $d7238066c5de7f1c$var$Ei.assign(n);
        const s = this.opacityNode ? $d7238066c5de7f1c$var$J(this.opacityNode) : $d7238066c5de7f1c$var$oY;
        $d7238066c5de7f1c$var$Ei.a.assign($d7238066c5de7f1c$var$Ei.a.mul(s));
        let a = null;
        (this.alphaTestNode !== null || this.alphaTest > 0) && (a = this.alphaTestNode !== null ? $d7238066c5de7f1c$var$J(this.alphaTestNode) : $d7238066c5de7f1c$var$LJ, this.alphaToCoverage === !0 ? ($d7238066c5de7f1c$var$Ei.a = $d7238066c5de7f1c$var$ic(a, a.add($d7238066c5de7f1c$var$FL($d7238066c5de7f1c$var$Ei.a)), $d7238066c5de7f1c$var$Ei.a), $d7238066c5de7f1c$var$Ei.a.lessThanEqual(0).discard()) : $d7238066c5de7f1c$var$Ei.a.lessThanEqual(a).discard()), this.alphaHash === !0 && $d7238066c5de7f1c$var$Ei.a.lessThan($d7238066c5de7f1c$var$sne($d7238066c5de7f1c$var$Ns)).discard(), e.isOpaque() && $d7238066c5de7f1c$var$Ei.a.assign(1);
    }
    /**
   * Abstract interface method that can be implemented by derived materials
   * to setup material-specific node variables.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */ setupVariants() {}
    /**
   * Setups the outgoing light node variable
   *
   * @return {Node<vec3>} The outgoing light node.
   */ setupOutgoingLight() {
        return this.lights === !0 ? $d7238066c5de7f1c$var$ne(0) : $d7238066c5de7f1c$var$Ei.rgb;
    }
    /**
   * Setups the normal node from the material.
   *
   * @return {Node<vec3>} The normal node.
   */ setupNormal() {
        return this.normalNode ? $d7238066c5de7f1c$var$ne(this.normalNode) : $d7238066c5de7f1c$var$kJ;
    }
    /**
   * Setups the environment node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The environment node.
   */ setupEnvironment() {
        let e = null;
        return this.envNode ? e = this.envNode : this.envMap && (e = this.envMap.isCubeTexture ? $d7238066c5de7f1c$var$rI("envMap", "cubeTexture") : $d7238066c5de7f1c$var$rI("envMap", "texture")), e;
    }
    /**
   * Setups the light map node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The light map node.
   */ setupLightMap(e) {
        let t = null;
        return e.material.lightMap && (t = new $d7238066c5de7f1c$var$Pie($d7238066c5de7f1c$var$gY)), t;
    }
    /**
   * Setups the lights node based on the scene, environment and material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {LightsNode} The lights node.
   */ setupLights(e) {
        const t = [], i = this.setupEnvironment(e);
        i && i.isLightingNode && t.push(i);
        const n = this.setupLightMap(e);
        if (n && n.isLightingNode && t.push(n), this.aoNode !== null || e.material.aoMap) {
            const a = this.aoNode !== null ? this.aoNode : $d7238066c5de7f1c$var$cU;
            t.push(new $d7238066c5de7f1c$var$Die(a));
        }
        let s = this.lightsNode || e.lightsNode;
        return t.length > 0 && (s = e.renderer.lighting.createNode([
            ...s.getLights(),
            ...t
        ])), s;
    }
    /**
   * This method should be implemented by most derived materials
   * since it defines the material's lighting model.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   * @return {LightingModel} The lighting model.
   */ setupLightingModel() {}
    /**
   * Setups the outgoing light node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The outgoing light node.
   */ setupLighting(e) {
        const { material: t } = e, { backdropNode: i, backdropAlphaNode: n, emissiveNode: s } = this, o = this.lights === !0 || this.lightsNode !== null ? this.setupLights(e) : null;
        let g = this.setupOutgoingLight(e);
        if (o && o.getScope().hasLights) {
            const l = this.setupLightingModel(e) || null;
            g = $d7238066c5de7f1c$var$yU(o, l, i, n);
        } else i !== null && (g = $d7238066c5de7f1c$var$ne(n !== null ? $d7238066c5de7f1c$var$qi(g, i, n) : i));
        return (s && s.isNode === !0 || t.emissive && t.emissive.isColor === !0) && ($d7238066c5de7f1c$var$W2.assign($d7238066c5de7f1c$var$ne(s || $d7238066c5de7f1c$var$xJ)), g = g.add($d7238066c5de7f1c$var$W2)), g;
    }
    /**
   * Setup the fog.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */ setupFog(e, t) {
        const i = e.fogNode;
        return i && ($d7238066c5de7f1c$var$ZA.assign(t), t = $d7238066c5de7f1c$var$Rt(i.toVar())), t;
    }
    /**
   * Setups premultiplied alpha.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */ setupPremultipliedAlpha(e, t) {
        return $d7238066c5de7f1c$var$VU(t);
    }
    /**
   * Setups the output node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */ setupOutput(e, t) {
        return this.fog === !0 && (t = this.setupFog(e, t)), this.premultipliedAlpha === !0 && (t = this.setupPremultipliedAlpha(e, t)), t;
    }
    /**
   * Most classic material types have a node pendant e.g. for `MeshBasicMaterial`
   * there is `MeshBasicNodeMaterial`. This utility method is intended for
   * defining all material properties of the classic type in the node type.
   *
   * @param {Material} material - The material to copy properties with their values to this node material.
   */ setDefaultValues(e) {
        for(const i in e){
            const n = e[i];
            this[i] === void 0 && (this[i] = n, n && n.clone && (this[i] = n.clone()));
        }
        const t = Object.getOwnPropertyDescriptors(e.constructor.prototype);
        for(const i in t)Object.getOwnPropertyDescriptor(this.constructor.prototype, i) === void 0 && t[i].get !== void 0 && Object.defineProperty(this.constructor.prototype, i, t[i]);
    }
    /**
   * Serializes this material to JSON.
   *
   * @param {?(Object|string)} meta - The meta information for serialization.
   * @return {Object} The serialized node.
   */ toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        t && (e = {
            textures: {},
            images: {},
            nodes: {}
        });
        const i = $d7238066c5de7f1c$var$Ho.prototype.toJSON.call(this, e);
        i.inputNodes = {};
        for (const { property: s, childNode: a } of this._getNodeChildren())i.inputNodes[s] = a.toJSON(e).uuid;
        function n(s) {
            const a = [];
            for(const o in s){
                const g = s[o];
                delete g.metadata, a.push(g);
            }
            return a;
        }
        if (t) {
            const s = n(e.textures), a = n(e.images), o = n(e.nodes);
            s.length > 0 && (i.textures = s), a.length > 0 && (i.images = a), o.length > 0 && (i.nodes = o);
        }
        return i;
    }
    /**
   * Copies the properties of the given node material to this instance.
   *
   * @param {NodeMaterial} source - The material to copy.
   * @return {NodeMaterial} A reference to this node material.
   */ copy(e) {
        return this.lightsNode = e.lightsNode, this.envNode = e.envNode, this.aoNode = e.aoNode, this.colorNode = e.colorNode, this.normalNode = e.normalNode, this.opacityNode = e.opacityNode, this.backdropNode = e.backdropNode, this.backdropAlphaNode = e.backdropAlphaNode, this.alphaTestNode = e.alphaTestNode, this.maskNode = e.maskNode, this.positionNode = e.positionNode, this.geometryNode = e.geometryNode, this.depthNode = e.depthNode, this.receivedShadowPositionNode = e.receivedShadowPositionNode, this.castShadowPositionNode = e.castShadowPositionNode, this.receivedShadowNode = e.receivedShadowNode, this.castShadowNode = e.castShadowNode, this.outputNode = e.outputNode, this.mrtNode = e.mrtNode, this.fragmentNode = e.fragmentNode, this.vertexNode = e.vertexNode, super.copy(e);
    }
}
const $d7238066c5de7f1c$var$Ine = /* @__PURE__ */ new $d7238066c5de7f1c$var$p3();
class $d7238066c5de7f1c$var$dne extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "LineBasicNodeMaterial";
    }
    /**
   * Constructs a new line basic node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isLineBasicNodeMaterial = !0, this.setDefaultValues($d7238066c5de7f1c$var$Ine), this.setValues(e);
    }
}
const $d7238066c5de7f1c$var$hne = /* @__PURE__ */ new $d7238066c5de7f1c$var$Iee();
class $d7238066c5de7f1c$var$Cne extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "LineDashedNodeMaterial";
    }
    /**
   * Constructs a new line dashed node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isLineDashedNodeMaterial = !0, this.setDefaultValues($d7238066c5de7f1c$var$hne), this.dashOffset = 0, this.offsetNode = null, this.dashScaleNode = null, this.dashSizeNode = null, this.gapSizeNode = null, this.setValues(e);
    }
    /**
   * Setups the dash specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupVariants() {
        const e = this.offsetNode ? $d7238066c5de7f1c$var$J(this.offsetNode) : $d7238066c5de7f1c$var$oU, t = this.dashScaleNode ? $d7238066c5de7f1c$var$J(this.dashScaleNode) : $d7238066c5de7f1c$var$sU, i = this.dashSizeNode ? $d7238066c5de7f1c$var$J(this.dashSizeNode) : $d7238066c5de7f1c$var$rU, n = this.gapSizeNode ? $d7238066c5de7f1c$var$J(this.gapSizeNode) : $d7238066c5de7f1c$var$aU;
        $d7238066c5de7f1c$var$ZS.assign(i), $d7238066c5de7f1c$var$H2.assign(n);
        const s = $d7238066c5de7f1c$var$pu($d7238066c5de7f1c$var$RI("lineDistance").mul(t));
        (e ? s.add(e) : s).mod($d7238066c5de7f1c$var$ZS.add($d7238066c5de7f1c$var$H2)).greaterThan($d7238066c5de7f1c$var$ZS).discard();
    }
}
let $d7238066c5de7f1c$var$Nv = null;
class $d7238066c5de7f1c$var$pne extends $d7238066c5de7f1c$var$WR {
    static get type() {
        return "ViewportSharedTextureNode";
    }
    /**
   * Constructs a new viewport shared texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {?Node} [levelNode=null] - The level node.
   */ constructor(e = $d7238066c5de7f1c$var$AI, t = null){
        $d7238066c5de7f1c$var$Nv === null && ($d7238066c5de7f1c$var$Nv = new $d7238066c5de7f1c$var$aL()), super(e, t, $d7238066c5de7f1c$var$Nv);
    }
    /**
   * Overwritten so the method always returns the unique shared
   * framebuffer texture.
   *
   * @return {FramebufferTexture} The shared framebuffer texture.
   */ getTextureForReference() {
        return $d7238066c5de7f1c$var$Nv;
    }
    updateReference() {
        return this;
    }
}
const $d7238066c5de7f1c$var$mne = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$pne).setParameterLength(0, 2), $d7238066c5de7f1c$var$wU = (r)=>$d7238066c5de7f1c$var$He(r).mul(0.5).add(0.5), $d7238066c5de7f1c$var$Ane = (r)=>$d7238066c5de7f1c$var$He(r).mul(2).sub(1), $d7238066c5de7f1c$var$bne = /* @__PURE__ */ new $d7238066c5de7f1c$var$lee();
class $d7238066c5de7f1c$var$yne extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshNormalNodeMaterial";
    }
    /**
   * Constructs a new mesh normal node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshNormalNodeMaterial = !0, this.setDefaultValues($d7238066c5de7f1c$var$bne), this.setValues(e);
    }
    /**
   * Overwrites the default implementation by computing the diffuse color
   * based on the normal data.
   */ setupDiffuseColor() {
        const e = this.opacityNode ? $d7238066c5de7f1c$var$J(this.opacityNode) : $d7238066c5de7f1c$var$oY;
        $d7238066c5de7f1c$var$Ei.assign($d7238066c5de7f1c$var$vR($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$wU($d7238066c5de7f1c$var$gn), e), $d7238066c5de7f1c$var$$o));
    }
}
const $d7238066c5de7f1c$var$CY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r = $d7238066c5de7f1c$var$tY])=>{
    const e = r.z.atan(r.x).mul(1 / (Math.PI * 2)).add(0.5), t = r.y.clamp(-1, 1).asin().mul(1 / Math.PI).add(0.5);
    return $d7238066c5de7f1c$var$Ne(e, t);
});
class $d7238066c5de7f1c$var$WU extends $d7238066c5de7f1c$var$j$ {
    /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */ constructor(e = 1, t = {}){
        super(e, t), this.isCubeRenderTarget = !0;
    }
    /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {CubeRenderTarget} A reference to this cube render target.
   */ fromEquirectangularTexture(e, t) {
        const i = t.minFilter, n = t.generateMipmaps;
        t.generateMipmaps = !0, this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
        const s = new $d7238066c5de7f1c$var$kB(5, 5, 5), a = $d7238066c5de7f1c$var$CY($d7238066c5de7f1c$var$tY), o = new $d7238066c5de7f1c$var$Bs();
        o.colorNode = $d7238066c5de7f1c$var$ni(t, a, 0), o.side = $d7238066c5de7f1c$var$Ka, o.blending = $d7238066c5de7f1c$var$xA;
        const g = new $d7238066c5de7f1c$var$SI(s, o), l = new $d7238066c5de7f1c$var$iL();
        l.add(g), t.minFilter === $d7238066c5de7f1c$var$II && (t.minFilter = $d7238066c5de7f1c$var$ro);
        const c = new $d7238066c5de7f1c$var$d3(1, 10, this), d = e.getMRT();
        return e.setMRT(null), c.update(e, l), e.setMRT(d), t.minFilter = i, t.currentGenerateMipmaps = n, g.geometry.dispose(), g.material.dispose(), this;
    }
}
const $d7238066c5de7f1c$var$_y = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$Bne extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "CubeMapNode";
    }
    /**
   * Constructs a new cube map node.
   *
   * @param {Node} envNode - The node representing the environment map.
   */ constructor(e){
        super("vec3"), this.envNode = e, this._cubeTexture = null, this._cubeTextureNode = $d7238066c5de7f1c$var$EA(null);
        const t = new $d7238066c5de7f1c$var$cR();
        t.isRenderTargetTexture = !0, this._defaultTexture = t, this.updateBeforeType = $d7238066c5de7f1c$var$Dt.RENDER;
    }
    updateBefore(e) {
        const { renderer: t, material: i } = e, n = this.envNode;
        if (n.isTextureNode || n.isMaterialReferenceNode) {
            const s = n.isTextureNode ? n.value : i[n.property];
            if (s && s.isTexture) {
                const a = s.mapping;
                if (a === $d7238066c5de7f1c$var$PN || a === $d7238066c5de7f1c$var$QN) {
                    if ($d7238066c5de7f1c$var$_y.has(s)) {
                        const o = $d7238066c5de7f1c$var$_y.get(s);
                        $d7238066c5de7f1c$var$q5(o, s.mapping), this._cubeTexture = o;
                    } else {
                        const o = s.image;
                        if ($d7238066c5de7f1c$var$fne(o)) {
                            const g = new $d7238066c5de7f1c$var$WU(o.height);
                            g.fromEquirectangularTexture(t, s), $d7238066c5de7f1c$var$q5(g.texture, s.mapping), this._cubeTexture = g.texture, $d7238066c5de7f1c$var$_y.set(s, g.texture), s.addEventListener("dispose", $d7238066c5de7f1c$var$HU);
                        } else this._cubeTexture = this._defaultTexture;
                    }
                    this._cubeTextureNode.value = this._cubeTexture;
                } else this._cubeTextureNode = this.envNode;
            }
        }
    }
    setup(e) {
        return this.updateBefore(e), this._cubeTextureNode;
    }
}
function $d7238066c5de7f1c$var$fne(r) {
    return r == null ? !1 : r.height > 0;
}
function $d7238066c5de7f1c$var$HU(r) {
    const e = r.target;
    e.removeEventListener("dispose", $d7238066c5de7f1c$var$HU);
    const t = $d7238066c5de7f1c$var$_y.get(e);
    t !== void 0 && ($d7238066c5de7f1c$var$_y.delete(e), t.dispose());
}
function $d7238066c5de7f1c$var$q5(r, e) {
    e === $d7238066c5de7f1c$var$PN ? r.mapping = $d7238066c5de7f1c$var$gB : e === $d7238066c5de7f1c$var$QN && (r.mapping = $d7238066c5de7f1c$var$$S);
}
const $d7238066c5de7f1c$var$XU = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Bne).setParameterLength(1);
class $d7238066c5de7f1c$var$pY extends $d7238066c5de7f1c$var$a0 {
    static get type() {
        return "BasicEnvironmentNode";
    }
    /**
   * Constructs a new basic environment node.
   *
   * @param {Node} [envNode=null] - A node representing the environment.
   */ constructor(e = null){
        super(), this.envNode = e;
    }
    setup(e) {
        e.context.environment = $d7238066c5de7f1c$var$XU(this.envNode);
    }
}
class $d7238066c5de7f1c$var$Gne extends $d7238066c5de7f1c$var$a0 {
    static get type() {
        return "BasicLightMapNode";
    }
    /**
   * Constructs a new basic light map node.
   *
   * @param {?Node<vec3>} [lightMapNode=null] - The light map node.
   */ constructor(e = null){
        super(), this.lightMapNode = e;
    }
    setup(e) {
        const t = $d7238066c5de7f1c$var$J(1 / Math.PI);
        e.context.irradianceLightMap = this.lightMapNode.mul(t);
    }
}
class $d7238066c5de7f1c$var$HR {
    /**
   * This method is intended for setting up lighting model and context data
   * which are later used in the evaluation process.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */ start(e) {
        e.lightsNode.setupLights(e, e.lightsNode.getLightNodes(e)), this.indirect(e);
    }
    /**
   * This method is intended for executing final tasks like final updates
   * to the outgoing light.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */ finish() {}
    /**
   * This method is intended for implementing the direct light term and
   * executed during the build process of directional, point and spot light nodes.
   *
   * @abstract
   * @param {Object} lightData - The light data.
   * @param {NodeBuilder} builder - The current node builder.
   */ direct() {}
    /**
   * This method is intended for implementing the direct light term for
   * rect area light nodes.
   *
   * @abstract
   * @param {Object} lightData - The light data.
   * @param {NodeBuilder} builder - The current node builder.
   */ directRectArea() {}
    /**
   * This method is intended for implementing the indirect light term.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */ indirect() {}
    /**
   * This method is intended for implementing the ambient occlusion term.
   * Unlike other methods, this method must be called manually by the lighting
   * model in its indirect term.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */ ambientOcclusion() {}
}
class $d7238066c5de7f1c$var$NU extends $d7238066c5de7f1c$var$HR {
    /**
   * Constructs a new basic lighting model.
   */ constructor(){
        super();
    }
    /**
   * Implements the baked indirect lighting with its modulation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ indirect({ context: e }) {
        const t = e.ambientOcclusion, i = e.reflectedLight, n = e.irradianceLightMap;
        i.indirectDiffuse.assign($d7238066c5de7f1c$var$Rt(0)), n ? i.indirectDiffuse.addAssign(n) : i.indirectDiffuse.addAssign($d7238066c5de7f1c$var$Rt(1, 1, 1, 0)), i.indirectDiffuse.mulAssign(t), i.indirectDiffuse.mulAssign($d7238066c5de7f1c$var$Ei.rgb);
    }
    /**
   * Implements the environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ finish(e) {
        const { material: t, context: i } = e, n = i.outgoingLight, s = e.context.environment;
        if (s) switch(t.combine){
            case $d7238066c5de7f1c$var$nR:
                n.rgb.assign($d7238066c5de7f1c$var$qi(n.rgb, n.rgb.mul(s.rgb), $d7238066c5de7f1c$var$Dy.mul($d7238066c5de7f1c$var$WS)));
                break;
            case $d7238066c5de7f1c$var$x6:
                n.rgb.assign($d7238066c5de7f1c$var$qi(n.rgb, s.rgb, $d7238066c5de7f1c$var$Dy.mul($d7238066c5de7f1c$var$WS)));
                break;
            case $d7238066c5de7f1c$var$F6:
                n.rgb.addAssign(s.rgb.mul($d7238066c5de7f1c$var$Dy.mul($d7238066c5de7f1c$var$WS)));
                break;
            default:
                $d7238066c5de7f1c$var$ze("BasicLightingModel: Unsupported .combine value:", t.combine);
                break;
        }
    }
}
const $d7238066c5de7f1c$var$vne = /* @__PURE__ */ new $d7238066c5de7f1c$var$Dd();
class $d7238066c5de7f1c$var$Sne extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshBasicNodeMaterial";
    }
    /**
   * Constructs a new mesh basic node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshBasicNodeMaterial = !0, this.lights = !0, this.setDefaultValues($d7238066c5de7f1c$var$vne), this.setValues(e);
    }
    /**
   * Basic materials are not affected by normal and bump maps so we
   * return by default {@link normalViewGeometry}.
   *
   * @return {Node<vec3>} The normal node.
   */ setupNormal() {
        return $d7238066c5de7f1c$var$r0($d7238066c5de7f1c$var$kA);
    }
    /**
   * Overwritten since this type of material uses {@link BasicEnvironmentNode}
   * to implement the default environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?BasicEnvironmentNode<vec3>} The environment node.
   */ setupEnvironment(e) {
        const t = super.setupEnvironment(e);
        return t ? new $d7238066c5de7f1c$var$pY(t) : null;
    }
    /**
   * This method must be overwritten since light maps are evaluated
   * with a special scaling factor for basic materials.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?BasicLightMapNode<vec3>} The light map node.
   */ setupLightMap(e) {
        let t = null;
        return e.material.lightMap && (t = new $d7238066c5de7f1c$var$Gne($d7238066c5de7f1c$var$gY)), t;
    }
    /**
   * The material overwrites this method because `lights` is set to `true` but
   * we still want to return the diffuse color as the outgoing light.
   *
   * @return {Node<vec3>} The outgoing light node.
   */ setupOutgoingLight() {
        return $d7238066c5de7f1c$var$Ei.rgb;
    }
    /**
   * Setups the lighting model.
   *
   * @return {BasicLightingModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$NU();
    }
}
const $d7238066c5de7f1c$var$JA = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ f0: r, f90: e, dotVH: t })=>{
    const i = t.mul(-5.55473).sub(6.98316).mul(t).exp2();
    return r.mul(i.oneMinus()).add(e.mul(i));
}), $d7238066c5de7f1c$var$JC = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>r.diffuseColor.mul(1 / Math.PI)), $d7238066c5de7f1c$var$Zne = ()=>$d7238066c5de7f1c$var$J(0.25), $d7238066c5de7f1c$var$Rne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ dotNH: r })=>$d7238066c5de7f1c$var$wZ.mul($d7238066c5de7f1c$var$J(0.5)).add(1).mul($d7238066c5de7f1c$var$J(1 / Math.PI)).mul(r.pow($d7238066c5de7f1c$var$wZ))), $d7238066c5de7f1c$var$Vne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ lightDirection: r })=>{
    const e = r.add($d7238066c5de7f1c$var$kn).normalize(), t = $d7238066c5de7f1c$var$gn.dot(e).clamp(), i = $d7238066c5de7f1c$var$kn.dot(e).clamp(), n = $d7238066c5de7f1c$var$JA({
        f0: $d7238066c5de7f1c$var$_g,
        f90: 1,
        dotVH: i
    }), s = $d7238066c5de7f1c$var$Zne(), a = $d7238066c5de7f1c$var$Rne({
        dotNH: t
    });
    return n.mul(s).mul(a);
});
class $d7238066c5de7f1c$var$LU extends $d7238066c5de7f1c$var$NU {
    /**
   * Constructs a new phong lighting model.
   *
   * @param {boolean} [specular=true] - Whether specular is supported or not.
   */ constructor(e = !0){
        super(), this.specular = e;
    }
    /**
   * Implements the direct lighting. The specular portion is optional an can be controlled
   * with the {@link PhongLightingModel#specular} flag.
   *
   * @param {Object} lightData - The light data.
   */ direct({ lightDirection: e, lightColor: t, reflectedLight: i }) {
        const s = $d7238066c5de7f1c$var$gn.dot(e).clamp().mul(t);
        i.directDiffuse.addAssign(s.mul($d7238066c5de7f1c$var$JC({
            diffuseColor: $d7238066c5de7f1c$var$Ei.rgb
        }))), this.specular === !0 && i.directSpecular.addAssign(s.mul($d7238066c5de7f1c$var$Vne({
            lightDirection: e
        })).mul($d7238066c5de7f1c$var$Dy));
    }
    /**
   * Implements the indirect lighting.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ indirect(e) {
        const { ambientOcclusion: t, irradiance: i, reflectedLight: n } = e.context;
        n.indirectDiffuse.addAssign(i.mul($d7238066c5de7f1c$var$JC({
            diffuseColor: $d7238066c5de7f1c$var$Ei
        }))), n.indirectDiffuse.mulAssign(t);
    }
}
const $d7238066c5de7f1c$var$wne = /* @__PURE__ */ new $d7238066c5de7f1c$var$cee();
class $d7238066c5de7f1c$var$Wne extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshLambertNodeMaterial";
    }
    /**
   * Constructs a new mesh lambert node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshLambertNodeMaterial = !0, this.lights = !0, this.setDefaultValues($d7238066c5de7f1c$var$wne), this.setValues(e);
    }
    /**
   * Overwritten since this type of material uses {@link BasicEnvironmentNode}
   * to implement the default environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?BasicEnvironmentNode<vec3>} The environment node.
   */ setupEnvironment(e) {
        const t = super.setupEnvironment(e);
        return t ? new $d7238066c5de7f1c$var$pY(t) : null;
    }
    /**
   * Setups the lighting model.
   *
   * @return {PhongLightingModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$LU(!1);
    }
}
const $d7238066c5de7f1c$var$Hne = /* @__PURE__ */ new $d7238066c5de7f1c$var$oee();
class $d7238066c5de7f1c$var$Xne extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshPhongNodeMaterial";
    }
    /**
   * Constructs a new mesh lambert node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshPhongNodeMaterial = !0, this.lights = !0, this.shininessNode = null, this.specularNode = null, this.setDefaultValues($d7238066c5de7f1c$var$Hne), this.setValues(e);
    }
    /**
   * Overwritten since this type of material uses {@link BasicEnvironmentNode}
   * to implement the default environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?BasicEnvironmentNode<vec3>} The environment node.
   */ setupEnvironment(e) {
        const t = super.setupEnvironment(e);
        return t ? new $d7238066c5de7f1c$var$pY(t) : null;
    }
    /**
   * Setups the lighting model.
   *
   * @return {PhongLightingModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$LU();
    }
    /**
   * Setups the phong specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupVariants() {
        const e = (this.shininessNode ? $d7238066c5de7f1c$var$J(this.shininessNode) : $d7238066c5de7f1c$var$KJ).max(1e-4);
        $d7238066c5de7f1c$var$wZ.assign(e);
        const t = this.specularNode || $d7238066c5de7f1c$var$FJ;
        $d7238066c5de7f1c$var$_g.assign(t);
    }
    copy(e) {
        return this.shininessNode = e.shininessNode, this.specularNode = e.specularNode, super.copy(e);
    }
}
const $d7238066c5de7f1c$var$YU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    if (r.geometry.hasAttribute("normal") === !1) return $d7238066c5de7f1c$var$J(0);
    const e = $d7238066c5de7f1c$var$kA.dFdx().abs().max($d7238066c5de7f1c$var$kA.dFdy().abs());
    return e.x.max(e.y).max(e.z);
}), $d7238066c5de7f1c$var$mY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    const { roughness: e } = r, t = $d7238066c5de7f1c$var$YU();
    let i = e.max(0.0525);
    return i = i.add(t), i = i.min(1), i;
}), $d7238066c5de7f1c$var$KU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ alpha: r, dotNL: e, dotNV: t })=>{
    const i = r.pow2(), n = e.mul(i.add(i.oneMinus().mul(t.pow2())).sqrt()), s = t.mul(i.add(i.oneMinus().mul(e.pow2())).sqrt());
    return $d7238066c5de7f1c$var$cg(0.5, n.add(s).max($d7238066c5de7f1c$var$HL));
}).setLayout({
    name: "V_GGX_SmithCorrelated",
    type: "float",
    inputs: [
        {
            name: "alpha",
            type: "float"
        },
        {
            name: "dotNL",
            type: "float"
        },
        {
            name: "dotNV",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Nne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ alphaT: r, alphaB: e, dotTV: t, dotBV: i, dotTL: n, dotBL: s, dotNV: a, dotNL: o })=>{
    const g = o.mul($d7238066c5de7f1c$var$ne(r.mul(t), e.mul(i), a).length()), l = a.mul($d7238066c5de7f1c$var$ne(r.mul(n), e.mul(s), o).length());
    return $d7238066c5de7f1c$var$cg(0.5, g.add(l)).saturate();
}).setLayout({
    name: "V_GGX_SmithCorrelated_Anisotropic",
    type: "float",
    inputs: [
        {
            name: "alphaT",
            type: "float",
            qualifier: "in"
        },
        {
            name: "alphaB",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotTV",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotBV",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotTL",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotBL",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotNV",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotNL",
            type: "float",
            qualifier: "in"
        }
    ]
}), $d7238066c5de7f1c$var$xU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ alpha: r, dotNH: e })=>{
    const t = r.pow2(), i = e.pow2().mul(t.oneMinus()).oneMinus();
    return t.div(i.pow2()).mul(1 / Math.PI);
}).setLayout({
    name: "D_GGX",
    type: "float",
    inputs: [
        {
            name: "alpha",
            type: "float"
        },
        {
            name: "dotNH",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Lne = /* @__PURE__ */ $d7238066c5de7f1c$var$J(1 / Math.PI), $d7238066c5de7f1c$var$Yne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ alphaT: r, alphaB: e, dotNH: t, dotTH: i, dotBH: n })=>{
    const s = r.mul(e), a = $d7238066c5de7f1c$var$ne(e.mul(i), r.mul(n), s.mul(t)), o = a.dot(a), g = s.div(o);
    return $d7238066c5de7f1c$var$Lne.mul(s.mul(g.pow2()));
}).setLayout({
    name: "D_GGX_Anisotropic",
    type: "float",
    inputs: [
        {
            name: "alphaT",
            type: "float",
            qualifier: "in"
        },
        {
            name: "alphaB",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotNH",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotTH",
            type: "float",
            qualifier: "in"
        },
        {
            name: "dotBH",
            type: "float",
            qualifier: "in"
        }
    ]
}), $d7238066c5de7f1c$var$AY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ lightDirection: r, f0: e, f90: t, roughness: i, f: n, normalView: s = $d7238066c5de7f1c$var$gn, USE_IRIDESCENCE: a, USE_ANISOTROPY: o })=>{
    const g = i.pow2(), l = r.add($d7238066c5de7f1c$var$kn).normalize(), c = s.dot(r).clamp(), d = s.dot($d7238066c5de7f1c$var$kn).clamp(), p = s.dot(l).clamp(), A = $d7238066c5de7f1c$var$kn.dot(l).clamp();
    let y = $d7238066c5de7f1c$var$JA({
        f0: e,
        f90: t,
        dotVH: A
    }), G, Z;
    if ($d7238066c5de7f1c$var$cB(a) && (y = $d7238066c5de7f1c$var$AR.mix(y, n)), $d7238066c5de7f1c$var$cB(o)) {
        const v = $d7238066c5de7f1c$var$Jy.dot(r), V = $d7238066c5de7f1c$var$Jy.dot($d7238066c5de7f1c$var$kn), H = $d7238066c5de7f1c$var$Jy.dot(l), N = $d7238066c5de7f1c$var$FC.dot(r), Y = $d7238066c5de7f1c$var$FC.dot($d7238066c5de7f1c$var$kn), K = $d7238066c5de7f1c$var$FC.dot(l);
        G = $d7238066c5de7f1c$var$Nne({
            alphaT: $d7238066c5de7f1c$var$VZ,
            alphaB: g,
            dotTV: V,
            dotBV: Y,
            dotTL: v,
            dotBL: N,
            dotNV: d,
            dotNL: c
        }), Z = $d7238066c5de7f1c$var$Yne({
            alphaT: $d7238066c5de7f1c$var$VZ,
            alphaB: g,
            dotNH: p,
            dotTH: H,
            dotBH: K
        });
    } else G = $d7238066c5de7f1c$var$KU({
        alpha: g,
        dotNL: c,
        dotNV: d
    }), Z = $d7238066c5de7f1c$var$xU({
        alpha: g,
        dotNH: p
    });
    return y.mul(G).mul(Z);
}), $d7238066c5de7f1c$var$Kne = new Uint16Array([
    11481,
    15204,
    11534,
    15171,
    11808,
    15015,
    12385,
    14843,
    12894,
    14716,
    13396,
    14600,
    13693,
    14483,
    13976,
    14366,
    14237,
    14171,
    14405,
    13961,
    14511,
    13770,
    14605,
    13598,
    14687,
    13444,
    14760,
    13305,
    14822,
    13066,
    14876,
    12857,
    14923,
    12675,
    14963,
    12517,
    14997,
    12379,
    15025,
    12230,
    15049,
    12023,
    15070,
    11843,
    15086,
    11687,
    15100,
    11551,
    15111,
    11433,
    15120,
    11330,
    15127,
    11217,
    15132,
    11060,
    15135,
    10922,
    15138,
    10801,
    15139,
    10695,
    15139,
    10600,
    13012,
    14923,
    13020,
    14917,
    13064,
    14886,
    13176,
    14800,
    13349,
    14666,
    13513,
    14526,
    13724,
    14398,
    13960,
    14230,
    14200,
    14020,
    14383,
    13827,
    14488,
    13651,
    14583,
    13491,
    14667,
    13348,
    14740,
    13132,
    14803,
    12908,
    14856,
    12713,
    14901,
    12542,
    14938,
    12394,
    14968,
    12241,
    14992,
    12017,
    15010,
    11822,
    15024,
    11654,
    15034,
    11507,
    15041,
    11380,
    15044,
    11269,
    15044,
    11081,
    15042,
    10913,
    15037,
    10764,
    15031,
    10635,
    15023,
    10520,
    15014,
    10419,
    15003,
    10330,
    13657,
    14676,
    13658,
    14673,
    13670,
    14660,
    13698,
    14622,
    13750,
    14547,
    13834,
    14442,
    13956,
    14317,
    14112,
    14093,
    14291,
    13889,
    14407,
    13704,
    14499,
    13538,
    14586,
    13389,
    14664,
    13201,
    14733,
    12966,
    14792,
    12758,
    14842,
    12577,
    14882,
    12418,
    14915,
    12272,
    14940,
    12033,
    14959,
    11826,
    14972,
    11646,
    14980,
    11490,
    14983,
    11355,
    14983,
    11212,
    14979,
    11008,
    14971,
    10830,
    14961,
    10675,
    14950,
    10540,
    14936,
    10420,
    14923,
    10315,
    14909,
    10204,
    14894,
    10041,
    14089,
    14460,
    14090,
    14459,
    14096,
    14452,
    14112,
    14431,
    14141,
    14388,
    14186,
    14305,
    14252,
    14130,
    14341,
    13941,
    14399,
    13756,
    14467,
    13585,
    14539,
    13430,
    14610,
    13272,
    14677,
    13026,
    14737,
    12808,
    14790,
    12617,
    14833,
    12449,
    14869,
    12303,
    14896,
    12065,
    14916,
    11845,
    14929,
    11655,
    14937,
    11490,
    14939,
    11347,
    14936,
    11184,
    14930,
    10970,
    14921,
    10783,
    14912,
    10621,
    14900,
    10480,
    14885,
    10356,
    14867,
    10247,
    14848,
    10062,
    14827,
    9894,
    14805,
    9745,
    14400,
    14208,
    14400,
    14206,
    14402,
    14198,
    14406,
    14174,
    14415,
    14122,
    14427,
    14035,
    14444,
    13913,
    14469,
    13767,
    14504,
    13613,
    14548,
    13463,
    14598,
    13324,
    14651,
    13082,
    14704,
    12858,
    14752,
    12658,
    14795,
    12483,
    14831,
    12330,
    14860,
    12106,
    14881,
    11875,
    14895,
    11675,
    14903,
    11501,
    14905,
    11351,
    14903,
    11178,
    14900,
    10953,
    14892,
    10757,
    14880,
    10589,
    14865,
    10442,
    14847,
    10313,
    14827,
    10162,
    14805,
    9965,
    14782,
    9792,
    14757,
    9642,
    14731,
    9507,
    14562,
    13883,
    14562,
    13883,
    14563,
    13877,
    14566,
    13862,
    14570,
    13830,
    14576,
    13773,
    14584,
    13689,
    14595,
    13582,
    14613,
    13461,
    14637,
    13336,
    14668,
    13120,
    14704,
    12897,
    14741,
    12695,
    14776,
    12516,
    14808,
    12358,
    14835,
    12150,
    14856,
    11910,
    14870,
    11701,
    14878,
    11519,
    14882,
    11361,
    14884,
    11187,
    14880,
    10951,
    14871,
    10748,
    14858,
    10572,
    14842,
    10418,
    14823,
    10286,
    14801,
    10099,
    14777,
    9897,
    14751,
    9722,
    14725,
    9567,
    14696,
    9430,
    14666,
    9309,
    14702,
    13604,
    14702,
    13604,
    14702,
    13600,
    14703,
    13591,
    14705,
    13570,
    14707,
    13533,
    14709,
    13477,
    14712,
    13400,
    14718,
    13305,
    14727,
    13106,
    14743,
    12907,
    14762,
    12716,
    14784,
    12539,
    14807,
    12380,
    14827,
    12190,
    14844,
    11943,
    14855,
    11727,
    14863,
    11539,
    14870,
    11376,
    14871,
    11204,
    14868,
    10960,
    14858,
    10748,
    14845,
    10565,
    14829,
    10406,
    14809,
    10269,
    14786,
    10058,
    14761,
    9852,
    14734,
    9671,
    14705,
    9512,
    14674,
    9374,
    14641,
    9253,
    14608,
    9076,
    14821,
    13366,
    14821,
    13365,
    14821,
    13364,
    14821,
    13358,
    14821,
    13344,
    14821,
    13320,
    14819,
    13252,
    14817,
    13145,
    14815,
    13011,
    14814,
    12858,
    14817,
    12698,
    14823,
    12539,
    14832,
    12389,
    14841,
    12214,
    14850,
    11968,
    14856,
    11750,
    14861,
    11558,
    14866,
    11390,
    14867,
    11226,
    14862,
    10972,
    14853,
    10754,
    14840,
    10565,
    14823,
    10401,
    14803,
    10259,
    14780,
    10032,
    14754,
    9820,
    14725,
    9635,
    14694,
    9473,
    14661,
    9333,
    14627,
    9203,
    14593,
    8988,
    14557,
    8798,
    14923,
    13014,
    14922,
    13014,
    14922,
    13012,
    14922,
    13004,
    14920,
    12987,
    14919,
    12957,
    14915,
    12907,
    14909,
    12834,
    14902,
    12738,
    14894,
    12623,
    14888,
    12498,
    14883,
    12370,
    14880,
    12203,
    14878,
    11970,
    14875,
    11759,
    14873,
    11569,
    14874,
    11401,
    14872,
    11243,
    14865,
    10986,
    14855,
    10762,
    14842,
    10568,
    14825,
    10401,
    14804,
    10255,
    14781,
    10017,
    14754,
    9799,
    14725,
    9611,
    14692,
    9445,
    14658,
    9301,
    14623,
    9139,
    14587,
    8920,
    14548,
    8729,
    14509,
    8562,
    15008,
    12672,
    15008,
    12672,
    15008,
    12671,
    15007,
    12667,
    15005,
    12656,
    15001,
    12637,
    14997,
    12605,
    14989,
    12556,
    14978,
    12490,
    14966,
    12407,
    14953,
    12313,
    14940,
    12136,
    14927,
    11934,
    14914,
    11742,
    14903,
    11563,
    14896,
    11401,
    14889,
    11247,
    14879,
    10992,
    14866,
    10767,
    14851,
    10570,
    14833,
    10400,
    14812,
    10252,
    14789,
    10007,
    14761,
    9784,
    14731,
    9592,
    14698,
    9424,
    14663,
    9279,
    14627,
    9088,
    14588,
    8868,
    14548,
    8676,
    14508,
    8508,
    14467,
    8360,
    15080,
    12386,
    15080,
    12386,
    15079,
    12385,
    15078,
    12383,
    15076,
    12378,
    15072,
    12367,
    15066,
    12347,
    15057,
    12315,
    15045,
    12253,
    15030,
    12138,
    15012,
    11998,
    14993,
    11845,
    14972,
    11685,
    14951,
    11530,
    14935,
    11383,
    14920,
    11228,
    14904,
    10981,
    14887,
    10762,
    14870,
    10567,
    14850,
    10397,
    14827,
    10248,
    14803,
    9997,
    14774,
    9771,
    14743,
    9578,
    14710,
    9407,
    14674,
    9259,
    14637,
    9048,
    14596,
    8826,
    14555,
    8632,
    14514,
    8464,
    14471,
    8317,
    14427,
    8182,
    15139,
    12008,
    15139,
    12008,
    15138,
    12008,
    15137,
    12007,
    15135,
    12003,
    15130,
    11990,
    15124,
    11969,
    15115,
    11929,
    15102,
    11872,
    15086,
    11794,
    15064,
    11693,
    15041,
    11581,
    15013,
    11459,
    14987,
    11336,
    14966,
    11170,
    14944,
    10944,
    14921,
    10738,
    14898,
    10552,
    14875,
    10387,
    14850,
    10239,
    14824,
    9983,
    14794,
    9758,
    14762,
    9563,
    14728,
    9392,
    14692,
    9244,
    14653,
    9014,
    14611,
    8791,
    14569,
    8597,
    14526,
    8427,
    14481,
    8281,
    14436,
    8110,
    14391,
    7885,
    15188,
    11617,
    15188,
    11617,
    15187,
    11617,
    15186,
    11618,
    15183,
    11617,
    15179,
    11612,
    15173,
    11601,
    15163,
    11581,
    15150,
    11546,
    15133,
    11495,
    15110,
    11427,
    15083,
    11346,
    15051,
    11246,
    15024,
    11057,
    14996,
    10868,
    14967,
    10687,
    14938,
    10517,
    14911,
    10362,
    14882,
    10206,
    14853,
    9956,
    14821,
    9737,
    14787,
    9543,
    14752,
    9375,
    14715,
    9228,
    14675,
    8980,
    14632,
    8760,
    14589,
    8565,
    14544,
    8395,
    14498,
    8248,
    14451,
    8049,
    14404,
    7824,
    14357,
    7630,
    15228,
    11298,
    15228,
    11298,
    15227,
    11299,
    15226,
    11301,
    15223,
    11303,
    15219,
    11302,
    15213,
    11299,
    15204,
    11290,
    15191,
    11271,
    15174,
    11217,
    15150,
    11129,
    15119,
    11015,
    15087,
    10886,
    15057,
    10744,
    15024,
    10599,
    14990,
    10455,
    14957,
    10318,
    14924,
    10143,
    14891,
    9911,
    14856,
    9701,
    14820,
    9516,
    14782,
    9352,
    14744,
    9200,
    14703,
    8946,
    14659,
    8725,
    14615,
    8533,
    14568,
    8366,
    14521,
    8220,
    14472,
    7992,
    14423,
    7770,
    14374,
    7578,
    14315,
    7408,
    15260,
    10819,
    15260,
    10819,
    15259,
    10822,
    15258,
    10826,
    15256,
    10832,
    15251,
    10836,
    15246,
    10841,
    15237,
    10838,
    15225,
    10821,
    15207,
    10788,
    15183,
    10734,
    15151,
    10660,
    15120,
    10571,
    15087,
    10469,
    15049,
    10359,
    15012,
    10249,
    14974,
    10041,
    14937,
    9837,
    14900,
    9647,
    14860,
    9475,
    14820,
    9320,
    14779,
    9147,
    14736,
    8902,
    14691,
    8688,
    14646,
    8499,
    14598,
    8335,
    14549,
    8189,
    14499,
    7940,
    14448,
    7720,
    14397,
    7529,
    14347,
    7363,
    14256,
    7218,
    15285,
    10410,
    15285,
    10411,
    15285,
    10413,
    15284,
    10418,
    15282,
    10425,
    15278,
    10434,
    15272,
    10442,
    15264,
    10449,
    15252,
    10445,
    15235,
    10433,
    15210,
    10403,
    15179,
    10358,
    15149,
    10301,
    15113,
    10218,
    15073,
    10059,
    15033,
    9894,
    14991,
    9726,
    14951,
    9565,
    14909,
    9413,
    14865,
    9273,
    14822,
    9073,
    14777,
    8845,
    14730,
    8641,
    14682,
    8459,
    14633,
    8300,
    14583,
    8129,
    14531,
    7883,
    14479,
    7670,
    14426,
    7482,
    14373,
    7321,
    14305,
    7176,
    14201,
    6939,
    15305,
    9939,
    15305,
    9940,
    15305,
    9945,
    15304,
    9955,
    15302,
    9967,
    15298,
    9989,
    15293,
    10010,
    15286,
    10033,
    15274,
    10044,
    15258,
    10045,
    15233,
    10022,
    15205,
    9975,
    15174,
    9903,
    15136,
    9808,
    15095,
    9697,
    15053,
    9578,
    15009,
    9451,
    14965,
    9327,
    14918,
    9198,
    14871,
    8973,
    14825,
    8766,
    14775,
    8579,
    14725,
    8408,
    14675,
    8259,
    14622,
    8058,
    14569,
    7821,
    14515,
    7615,
    14460,
    7435,
    14405,
    7276,
    14350,
    7108,
    14256,
    6866,
    14149,
    6653,
    15321,
    9444,
    15321,
    9445,
    15321,
    9448,
    15320,
    9458,
    15317,
    9470,
    15314,
    9490,
    15310,
    9515,
    15302,
    9540,
    15292,
    9562,
    15276,
    9579,
    15251,
    9577,
    15226,
    9559,
    15195,
    9519,
    15156,
    9463,
    15116,
    9389,
    15071,
    9304,
    15025,
    9208,
    14978,
    9023,
    14927,
    8838,
    14878,
    8661,
    14827,
    8496,
    14774,
    8344,
    14722,
    8206,
    14667,
    7973,
    14612,
    7749,
    14556,
    7555,
    14499,
    7382,
    14443,
    7229,
    14385,
    7025,
    14322,
    6791,
    14210,
    6588,
    14100,
    6409,
    15333,
    8920,
    15333,
    8921,
    15332,
    8927,
    15332,
    8943,
    15329,
    8965,
    15326,
    9002,
    15322,
    9048,
    15316,
    9106,
    15307,
    9162,
    15291,
    9204,
    15267,
    9221,
    15244,
    9221,
    15212,
    9196,
    15175,
    9134,
    15133,
    9043,
    15088,
    8930,
    15040,
    8801,
    14990,
    8665,
    14938,
    8526,
    14886,
    8391,
    14830,
    8261,
    14775,
    8087,
    14719,
    7866,
    14661,
    7664,
    14603,
    7482,
    14544,
    7322,
    14485,
    7178,
    14426,
    6936,
    14367,
    6713,
    14281,
    6517,
    14166,
    6348,
    14054,
    6198,
    15341,
    8360,
    15341,
    8361,
    15341,
    8366,
    15341,
    8379,
    15339,
    8399,
    15336,
    8431,
    15332,
    8473,
    15326,
    8527,
    15318,
    8585,
    15302,
    8632,
    15281,
    8670,
    15258,
    8690,
    15227,
    8690,
    15191,
    8664,
    15149,
    8612,
    15104,
    8543,
    15055,
    8456,
    15001,
    8360,
    14948,
    8259,
    14892,
    8122,
    14834,
    7923,
    14776,
    7734,
    14716,
    7558,
    14656,
    7397,
    14595,
    7250,
    14534,
    7070,
    14472,
    6835,
    14410,
    6628,
    14350,
    6443,
    14243,
    6283,
    14125,
    6135,
    14010,
    5889,
    15348,
    7715,
    15348,
    7717,
    15348,
    7725,
    15347,
    7745,
    15345,
    7780,
    15343,
    7836,
    15339,
    7905,
    15334,
    8e3,
    15326,
    8103,
    15310,
    8193,
    15293,
    8239,
    15270,
    8270,
    15240,
    8287,
    15204,
    8283,
    15163,
    8260,
    15118,
    8223,
    15067,
    8143,
    15014,
    8014,
    14958,
    7873,
    14899,
    7723,
    14839,
    7573,
    14778,
    7430,
    14715,
    7293,
    14652,
    7164,
    14588,
    6931,
    14524,
    6720,
    14460,
    6531,
    14396,
    6362,
    14330,
    6210,
    14207,
    6015,
    14086,
    5781,
    13969,
    5576,
    15352,
    7114,
    15352,
    7116,
    15352,
    7128,
    15352,
    7159,
    15350,
    7195,
    15348,
    7237,
    15345,
    7299,
    15340,
    7374,
    15332,
    7457,
    15317,
    7544,
    15301,
    7633,
    15280,
    7703,
    15251,
    7754,
    15216,
    7775,
    15176,
    7767,
    15131,
    7733,
    15079,
    7670,
    15026,
    7588,
    14967,
    7492,
    14906,
    7387,
    14844,
    7278,
    14779,
    7171,
    14714,
    6965,
    14648,
    6770,
    14581,
    6587,
    14515,
    6420,
    14448,
    6269,
    14382,
    6123,
    14299,
    5881,
    14172,
    5665,
    14049,
    5477,
    13929,
    5310,
    15355,
    6329,
    15355,
    6330,
    15355,
    6339,
    15355,
    6362,
    15353,
    6410,
    15351,
    6472,
    15349,
    6572,
    15344,
    6688,
    15337,
    6835,
    15323,
    6985,
    15309,
    7142,
    15287,
    7220,
    15260,
    7277,
    15226,
    7310,
    15188,
    7326,
    15142,
    7318,
    15090,
    7285,
    15036,
    7239,
    14976,
    7177,
    14914,
    7045,
    14849,
    6892,
    14782,
    6736,
    14714,
    6581,
    14645,
    6433,
    14576,
    6293,
    14506,
    6164,
    14438,
    5946,
    14369,
    5733,
    14270,
    5540,
    14140,
    5369,
    14014,
    5216,
    13892,
    5043,
    15357,
    5483,
    15357,
    5484,
    15357,
    5496,
    15357,
    5528,
    15356,
    5597,
    15354,
    5692,
    15351,
    5835,
    15347,
    6011,
    15339,
    6195,
    15328,
    6317,
    15314,
    6446,
    15293,
    6566,
    15268,
    6668,
    15235,
    6746,
    15197,
    6796,
    15152,
    6811,
    15101,
    6790,
    15046,
    6748,
    14985,
    6673,
    14921,
    6583,
    14854,
    6479,
    14785,
    6371,
    14714,
    6259,
    14643,
    6149,
    14571,
    5946,
    14499,
    5750,
    14428,
    5567,
    14358,
    5401,
    14242,
    5250,
    14109,
    5111,
    13980,
    4870,
    13856,
    4657,
    15359,
    4555,
    15359,
    4557,
    15358,
    4573,
    15358,
    4633,
    15357,
    4715,
    15355,
    4841,
    15353,
    5061,
    15349,
    5216,
    15342,
    5391,
    15331,
    5577,
    15318,
    5770,
    15299,
    5967,
    15274,
    6150,
    15243,
    6223,
    15206,
    6280,
    15161,
    6310,
    15111,
    6317,
    15055,
    6300,
    14994,
    6262,
    14928,
    6208,
    14860,
    6141,
    14788,
    5994,
    14715,
    5838,
    14641,
    5684,
    14566,
    5529,
    14492,
    5384,
    14418,
    5247,
    14346,
    5121,
    14216,
    4892,
    14079,
    4682,
    13948,
    4496,
    13822,
    4330,
    15359,
    3498,
    15359,
    3501,
    15359,
    3520,
    15359,
    3598,
    15358,
    3719,
    15356,
    3860,
    15355,
    4137,
    15351,
    4305,
    15344,
    4563,
    15334,
    4809,
    15321,
    5116,
    15303,
    5273,
    15280,
    5418,
    15250,
    5547,
    15214,
    5653,
    15170,
    5722,
    15120,
    5761,
    15064,
    5763,
    15002,
    5733,
    14935,
    5673,
    14865,
    5597,
    14792,
    5504,
    14716,
    5400,
    14640,
    5294,
    14563,
    5185,
    14486,
    5041,
    14410,
    4841,
    14335,
    4655,
    14191,
    4482,
    14051,
    4325,
    13918,
    4183,
    13790,
    4012,
    15360,
    2282,
    15360,
    2285,
    15360,
    2306,
    15360,
    2401,
    15359,
    2547,
    15357,
    2748,
    15355,
    3103,
    15352,
    3349,
    15345,
    3675,
    15336,
    4020,
    15324,
    4272,
    15307,
    4496,
    15285,
    4716,
    15255,
    4908,
    15220,
    5086,
    15178,
    5170,
    15128,
    5214,
    15072,
    5234,
    15010,
    5231,
    14943,
    5206,
    14871,
    5166,
    14796,
    5102,
    14718,
    4971,
    14639,
    4833,
    14559,
    4687,
    14480,
    4541,
    14402,
    4401,
    14315,
    4268,
    14167,
    4142,
    14025,
    3958,
    13888,
    3747,
    13759,
    3556,
    15360,
    923,
    15360,
    925,
    15360,
    946,
    15360,
    1052,
    15359,
    1214,
    15357,
    1494,
    15356,
    1892,
    15352,
    2274,
    15346,
    2663,
    15338,
    3099,
    15326,
    3393,
    15309,
    3679,
    15288,
    3980,
    15260,
    4183,
    15226,
    4325,
    15185,
    4437,
    15136,
    4517,
    15080,
    4570,
    15018,
    4591,
    14950,
    4581,
    14877,
    4545,
    14800,
    4485,
    14720,
    4411,
    14638,
    4325,
    14556,
    4231,
    14475,
    4136,
    14395,
    3988,
    14297,
    3803,
    14145,
    3628,
    13999,
    3465,
    13861,
    3314,
    13729,
    3177,
    15360,
    263,
    15360,
    264,
    15360,
    272,
    15360,
    325,
    15359,
    407,
    15358,
    548,
    15356,
    780,
    15352,
    1144,
    15347,
    1580,
    15339,
    2099,
    15328,
    2425,
    15312,
    2795,
    15292,
    3133,
    15264,
    3329,
    15232,
    3517,
    15191,
    3689,
    15143,
    3819,
    15088,
    3923,
    15025,
    3978,
    14956,
    3999,
    14882,
    3979,
    14804,
    3931,
    14722,
    3855,
    14639,
    3756,
    14554,
    3645,
    14470,
    3529,
    14388,
    3409,
    14279,
    3289,
    14124,
    3173,
    13975,
    3055,
    13834,
    2848,
    13701,
    2658,
    15360,
    49,
    15360,
    49,
    15360,
    52,
    15360,
    75,
    15359,
    111,
    15358,
    201,
    15356,
    283,
    15353,
    519,
    15348,
    726,
    15340,
    1045,
    15329,
    1415,
    15314,
    1795,
    15295,
    2173,
    15269,
    2410,
    15237,
    2649,
    15197,
    2866,
    15150,
    3054,
    15095,
    3140,
    15032,
    3196,
    14963,
    3228,
    14888,
    3236,
    14808,
    3224,
    14725,
    3191,
    14639,
    3146,
    14553,
    3088,
    14466,
    2976,
    14382,
    2836,
    14262,
    2692,
    14103,
    2549,
    13952,
    2409,
    13808,
    2278,
    13674,
    2154,
    15360,
    4,
    15360,
    4,
    15360,
    4,
    15360,
    13,
    15359,
    33,
    15358,
    59,
    15357,
    112,
    15353,
    199,
    15348,
    302,
    15341,
    456,
    15331,
    628,
    15316,
    827,
    15297,
    1082,
    15272,
    1332,
    15241,
    1601,
    15202,
    1851,
    15156,
    2069,
    15101,
    2172,
    15039,
    2256,
    14970,
    2314,
    14894,
    2348,
    14813,
    2358,
    14728,
    2344,
    14640,
    2311,
    14551,
    2263,
    14463,
    2203,
    14376,
    2133,
    14247,
    2059,
    14084,
    1915,
    13930,
    1761,
    13784,
    1609,
    13648,
    1464,
    15360,
    0,
    15360,
    0,
    15360,
    0,
    15360,
    3,
    15359,
    18,
    15358,
    26,
    15357,
    53,
    15354,
    80,
    15348,
    97,
    15341,
    165,
    15332,
    238,
    15318,
    326,
    15299,
    427,
    15275,
    529,
    15245,
    654,
    15207,
    771,
    15161,
    885,
    15108,
    994,
    15046,
    1089,
    14976,
    1170,
    14900,
    1229,
    14817,
    1266,
    14731,
    1284,
    14641,
    1282,
    14550,
    1260,
    14460,
    1223,
    14370,
    1174,
    14232,
    1116,
    14066,
    1050,
    13909,
    981,
    13761,
    910,
    13623,
    839
]);
let $d7238066c5de7f1c$var$ju = null;
const $d7238066c5de7f1c$var$mB = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ roughness: r, dotNV: e })=>{
    $d7238066c5de7f1c$var$ju === null && ($d7238066c5de7f1c$var$ju = new $d7238066c5de7f1c$var$C3($d7238066c5de7f1c$var$Kne, 32, 32, $d7238066c5de7f1c$var$gI, $d7238066c5de7f1c$var$Ia), $d7238066c5de7f1c$var$ju.minFilter = $d7238066c5de7f1c$var$ro, $d7238066c5de7f1c$var$ju.magFilter = $d7238066c5de7f1c$var$ro, $d7238066c5de7f1c$var$ju.wrapS = $d7238066c5de7f1c$var$qc, $d7238066c5de7f1c$var$ju.wrapT = $d7238066c5de7f1c$var$qc, $d7238066c5de7f1c$var$ju.generateMipmaps = !1, $d7238066c5de7f1c$var$ju.needsUpdate = !0);
    const t = $d7238066c5de7f1c$var$Ne(r, e);
    return $d7238066c5de7f1c$var$ni($d7238066c5de7f1c$var$ju, t).rg;
}), $d7238066c5de7f1c$var$xne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ lightDirection: r, f0: e, f90: t, roughness: i, f: n, USE_IRIDESCENCE: s, USE_ANISOTROPY: a })=>{
    const o = $d7238066c5de7f1c$var$AY({
        lightDirection: r,
        f0: e,
        f90: t,
        roughness: i,
        f: n,
        USE_IRIDESCENCE: s,
        USE_ANISOTROPY: a
    }), g = $d7238066c5de7f1c$var$gn.dot(r).clamp(), l = $d7238066c5de7f1c$var$gn.dot($d7238066c5de7f1c$var$kn).clamp(), c = $d7238066c5de7f1c$var$mB({
        roughness: i,
        dotNV: l
    }), d = $d7238066c5de7f1c$var$mB({
        roughness: i,
        dotNV: g
    }), p = e.mul(c.x).add(t.mul(c.y)), A = e.mul(d.x).add(t.mul(d.y)), y = c.x.add(c.y), G = d.x.add(d.y), Z = $d7238066c5de7f1c$var$J(1).sub(y), v = $d7238066c5de7f1c$var$J(1).sub(G), V = e.add(e.oneMinus().mul(0.047619)), H = p.mul(A).mul(V).div($d7238066c5de7f1c$var$J(1).sub(Z.mul(v).mul(V).mul(V)).add($d7238066c5de7f1c$var$HL)), N = Z.mul(v), Y = H.mul(N);
    return o.add(Y);
}), $d7238066c5de7f1c$var$FU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe((r)=>{
    const { dotNV: e, specularColor: t, specularF90: i, roughness: n } = r, s = $d7238066c5de7f1c$var$mB({
        dotNV: e,
        roughness: n
    });
    return t.mul(s.x).add(i.mul(s.y));
}), $d7238066c5de7f1c$var$TU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ f: r, f90: e, dotVH: t })=>{
    const i = t.oneMinus().saturate(), n = i.mul(i), s = i.mul(n, n).clamp(0, 0.9999);
    return r.sub($d7238066c5de7f1c$var$ne(e).mul(s)).div(s.oneMinus());
}).setLayout({
    name: "Schlick_to_F0",
    type: "vec3",
    inputs: [
        {
            name: "f",
            type: "vec3"
        },
        {
            name: "f90",
            type: "float"
        },
        {
            name: "dotVH",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Fne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ roughness: r, dotNH: e })=>{
    const t = r.pow2(), i = $d7238066c5de7f1c$var$J(1).div(t), s = e.pow2().oneMinus().max(78125e-7);
    return $d7238066c5de7f1c$var$J(2).add(i).mul(s.pow(i.mul(0.5))).div(2 * Math.PI);
}).setLayout({
    name: "D_Charlie",
    type: "float",
    inputs: [
        {
            name: "roughness",
            type: "float"
        },
        {
            name: "dotNH",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Tne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ dotNV: r, dotNL: e })=>$d7238066c5de7f1c$var$J(1).div($d7238066c5de7f1c$var$J(4).mul(e.add(r).sub(e.mul(r))))).setLayout({
    name: "V_Neubelt",
    type: "float",
    inputs: [
        {
            name: "dotNV",
            type: "float"
        },
        {
            name: "dotNL",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Mne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ lightDirection: r })=>{
    const e = r.add($d7238066c5de7f1c$var$kn).normalize(), t = $d7238066c5de7f1c$var$gn.dot(r).clamp(), i = $d7238066c5de7f1c$var$gn.dot($d7238066c5de7f1c$var$kn).clamp(), n = $d7238066c5de7f1c$var$gn.dot(e).clamp(), s = $d7238066c5de7f1c$var$Fne({
        roughness: $d7238066c5de7f1c$var$mR,
        dotNH: n
    }), a = $d7238066c5de7f1c$var$Tne({
        dotNV: i,
        dotNL: t
    });
    return $d7238066c5de7f1c$var$WC.mul(s).mul(a);
}), $d7238066c5de7f1c$var$zne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ N: r, V: e, roughness: t })=>{
    const s = 78125e-7, a = r.dot(e).saturate(), o = $d7238066c5de7f1c$var$Ne(t, a.oneMinus().sqrt());
    return o.assign(o.mul(0.984375).add(s)), o;
}).setLayout({
    name: "LTC_Uv",
    type: "vec2",
    inputs: [
        {
            name: "N",
            type: "vec3"
        },
        {
            name: "V",
            type: "vec3"
        },
        {
            name: "roughness",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$kne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ f: r })=>{
    const e = r.length();
    return $d7238066c5de7f1c$var$En(e.mul(e).add(r.z).div(e.add(1)), 0);
}).setLayout({
    name: "LTC_ClippedSphereFormFactor",
    type: "float",
    inputs: [
        {
            name: "f",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$Lv = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ v1: r, v2: e })=>{
    const t = r.dot(e), i = t.abs().toVar(), n = i.mul(0.0145206).add(0.4965155).mul(i).add(0.8543985).toVar(), s = i.add(4.1616724).mul(i).add(3.417594).toVar(), a = n.div(s), o = t.greaterThan(0).select(a, $d7238066c5de7f1c$var$En(t.mul(t).oneMinus(), 1e-7).inverseSqrt().mul(0.5).sub(a));
    return r.cross(e).mul(o);
}).setLayout({
    name: "LTC_EdgeVectorFormFactor",
    type: "vec3",
    inputs: [
        {
            name: "v1",
            type: "vec3"
        },
        {
            name: "v2",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$$5 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ N: r, V: e, P: t, mInv: i, p0: n, p1: s, p2: a, p3: o })=>{
    const g = s.sub(n).toVar(), l = o.sub(n).toVar(), c = g.cross(l), d = $d7238066c5de7f1c$var$ne().toVar();
    return $d7238066c5de7f1c$var$Ht(c.dot(t.sub(n)).greaterThanEqual(0), ()=>{
        const p = e.sub(r.mul(e.dot(r))).normalize(), A = r.cross(p).negate(), y = i.mul($d7238066c5de7f1c$var$Fa(p, A, r).transpose()).toVar(), G = y.mul(n.sub(t)).normalize().toVar(), Z = y.mul(s.sub(t)).normalize().toVar(), v = y.mul(a.sub(t)).normalize().toVar(), V = y.mul(o.sub(t)).normalize().toVar(), H = $d7238066c5de7f1c$var$ne(0).toVar();
        H.addAssign($d7238066c5de7f1c$var$Lv({
            v1: G,
            v2: Z
        })), H.addAssign($d7238066c5de7f1c$var$Lv({
            v1: Z,
            v2: v
        })), H.addAssign($d7238066c5de7f1c$var$Lv({
            v1: v,
            v2: V
        })), H.addAssign($d7238066c5de7f1c$var$Lv({
            v1: V,
            v2: G
        })), d.assign($d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$kne({
            f: H
        })));
    }), d;
}).setLayout({
    name: "LTC_Evaluate",
    type: "vec3",
    inputs: [
        {
            name: "N",
            type: "vec3"
        },
        {
            name: "V",
            type: "vec3"
        },
        {
            name: "P",
            type: "vec3"
        },
        {
            name: "mInv",
            type: "mat3"
        },
        {
            name: "p0",
            type: "vec3"
        },
        {
            name: "p1",
            type: "vec3"
        },
        {
            name: "p2",
            type: "vec3"
        },
        {
            name: "p3",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$XR = 1 / 6, $d7238066c5de7f1c$var$MU = (r)=>$d7238066c5de7f1c$var$Et($d7238066c5de7f1c$var$XR, $d7238066c5de7f1c$var$Et(r, $d7238066c5de7f1c$var$Et(r, r.negate().add(3)).sub(3)).add(1)), $d7238066c5de7f1c$var$M2 = (r)=>$d7238066c5de7f1c$var$Et($d7238066c5de7f1c$var$XR, $d7238066c5de7f1c$var$Et(r, $d7238066c5de7f1c$var$Et(r, $d7238066c5de7f1c$var$Et(3, r).sub(6))).add(4)), $d7238066c5de7f1c$var$zU = (r)=>$d7238066c5de7f1c$var$Et($d7238066c5de7f1c$var$XR, $d7238066c5de7f1c$var$Et(r, $d7238066c5de7f1c$var$Et(r, $d7238066c5de7f1c$var$Et(-3, r).add(3)).add(3)).add(1)), $d7238066c5de7f1c$var$z2 = (r)=>$d7238066c5de7f1c$var$Et($d7238066c5de7f1c$var$XR, $d7238066c5de7f1c$var$qg(r, 3)), $d7238066c5de7f1c$var$e9 = (r)=>$d7238066c5de7f1c$var$MU(r).add($d7238066c5de7f1c$var$M2(r)), $d7238066c5de7f1c$var$t9 = (r)=>$d7238066c5de7f1c$var$zU(r).add($d7238066c5de7f1c$var$z2(r)), $d7238066c5de7f1c$var$i9 = (r)=>$d7238066c5de7f1c$var$Ps(-1, $d7238066c5de7f1c$var$M2(r).div($d7238066c5de7f1c$var$MU(r).add($d7238066c5de7f1c$var$M2(r)))), $d7238066c5de7f1c$var$n9 = (r)=>$d7238066c5de7f1c$var$Ps(1, $d7238066c5de7f1c$var$z2(r).div($d7238066c5de7f1c$var$zU(r).add($d7238066c5de7f1c$var$z2(r)))), $d7238066c5de7f1c$var$s9 = (r, e, t)=>{
    const i = r.uvNode, n = $d7238066c5de7f1c$var$Et(i, e.zw).add(0.5), s = $d7238066c5de7f1c$var$ru(n), a = $d7238066c5de7f1c$var$ec(n), o = $d7238066c5de7f1c$var$e9(a.x), g = $d7238066c5de7f1c$var$t9(a.x), l = $d7238066c5de7f1c$var$i9(a.x), c = $d7238066c5de7f1c$var$n9(a.x), d = $d7238066c5de7f1c$var$i9(a.y), p = $d7238066c5de7f1c$var$n9(a.y), A = $d7238066c5de7f1c$var$Ne(s.x.add(l), s.y.add(d)).sub(0.5).mul(e.xy), y = $d7238066c5de7f1c$var$Ne(s.x.add(c), s.y.add(d)).sub(0.5).mul(e.xy), G = $d7238066c5de7f1c$var$Ne(s.x.add(l), s.y.add(p)).sub(0.5).mul(e.xy), Z = $d7238066c5de7f1c$var$Ne(s.x.add(c), s.y.add(p)).sub(0.5).mul(e.xy), v = $d7238066c5de7f1c$var$e9(a.y).mul($d7238066c5de7f1c$var$Ps(o.mul(r.sample(A).level(t)), g.mul(r.sample(y).level(t)))), V = $d7238066c5de7f1c$var$t9(a.y).mul($d7238066c5de7f1c$var$Ps(o.mul(r.sample(G).level(t)), g.mul(r.sample(Z).level(t))));
    return v.add(V);
}, $d7238066c5de7f1c$var$bY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$Ne(r.size($d7238066c5de7f1c$var$ee(e))), i = $d7238066c5de7f1c$var$Ne(r.size($d7238066c5de7f1c$var$ee(e.add(1)))), n = $d7238066c5de7f1c$var$cg(1, t), s = $d7238066c5de7f1c$var$cg(1, i), a = $d7238066c5de7f1c$var$s9(r, $d7238066c5de7f1c$var$Rt(n, t), $d7238066c5de7f1c$var$ru(e)), o = $d7238066c5de7f1c$var$s9(r, $d7238066c5de7f1c$var$Rt(s, i), $d7238066c5de7f1c$var$BR(e));
    return $d7238066c5de7f1c$var$ec(e).mix(a, o);
}), $d7238066c5de7f1c$var$Ene = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = e.mul($d7238066c5de7f1c$var$OL(r));
    return $d7238066c5de7f1c$var$bY(r, t);
}), $d7238066c5de7f1c$var$r9 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n])=>{
    const s = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$EL(e.negate(), $d7238066c5de7f1c$var$wo(r), $d7238066c5de7f1c$var$cg(1, i))), a = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$au(n[0].xyz), $d7238066c5de7f1c$var$au(n[1].xyz), $d7238066c5de7f1c$var$au(n[2].xyz));
    return $d7238066c5de7f1c$var$wo(s).mul(t.mul(a));
}).setLayout({
    name: "getVolumeTransmissionRay",
    type: "vec3",
    inputs: [
        {
            name: "n",
            type: "vec3"
        },
        {
            name: "v",
            type: "vec3"
        },
        {
            name: "thickness",
            type: "float"
        },
        {
            name: "ior",
            type: "float"
        },
        {
            name: "modelMatrix",
            type: "mat4"
        }
    ]
}), $d7238066c5de7f1c$var$Jne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>r.mul($d7238066c5de7f1c$var$sl(e.mul(2).sub(2), 0, 1))).setLayout({
    name: "applyIorToRoughness",
    type: "float",
    inputs: [
        {
            name: "roughness",
            type: "float"
        },
        {
            name: "ior",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Une = /* @__PURE__ */ $d7238066c5de7f1c$var$cY(), $d7238066c5de7f1c$var$Dne = /* @__PURE__ */ $d7238066c5de7f1c$var$cY(), $d7238066c5de7f1c$var$a9 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t], { material: i })=>{
    const s = (i.side === $d7238066c5de7f1c$var$Ka ? $d7238066c5de7f1c$var$Une : $d7238066c5de7f1c$var$Dne).sample(r), a = $d7238066c5de7f1c$var$su($d7238066c5de7f1c$var$EC.x).mul($d7238066c5de7f1c$var$Jne(e, t));
    return $d7238066c5de7f1c$var$bY(s, a);
}), $d7238066c5de7f1c$var$o9 = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>($d7238066c5de7f1c$var$Ht(t.notEqual(0), ()=>{
        const i = $d7238066c5de7f1c$var$yR(e).negate().div(t);
        return $d7238066c5de7f1c$var$XL(i.negate().mul(r));
    }), $d7238066c5de7f1c$var$ne(1))).setLayout({
    name: "volumeAttenuation",
    type: "vec3",
    inputs: [
        {
            name: "transmissionDistance",
            type: "float"
        },
        {
            name: "attenuationColor",
            type: "vec3"
        },
        {
            name: "attenuationDistance",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$_ne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a, o, g, l, c, d, p, A, y])=>{
    let G, Z;
    if (y) {
        G = $d7238066c5de7f1c$var$Rt().toVar(), Z = $d7238066c5de7f1c$var$ne().toVar();
        const Y = c.sub(1).mul(y.mul(0.025)), K = $d7238066c5de7f1c$var$ne(c.sub(Y), c, c.add(Y));
        $d7238066c5de7f1c$var$Cn({
            start: 0,
            end: 3
        }, ({ i: z })=>{
            const M = K.element(z), _ = $d7238066c5de7f1c$var$r9(r, e, d, M, o), O = a.add(_), ie = l.mul(g.mul($d7238066c5de7f1c$var$Rt(O, 1))), he = $d7238066c5de7f1c$var$Ne(ie.xy.div(ie.w)).toVar();
            he.addAssign(1), he.divAssign(2), he.assign($d7238066c5de7f1c$var$Ne(he.x, he.y.oneMinus()));
            const pe = $d7238066c5de7f1c$var$a9(he, t, M);
            G.element(z).assign(pe.element(z)), G.a.addAssign(pe.a), Z.element(z).assign(i.element(z).mul($d7238066c5de7f1c$var$o9($d7238066c5de7f1c$var$au(_), p, A).element(z)));
        }), G.a.divAssign(3);
    } else {
        const Y = $d7238066c5de7f1c$var$r9(r, e, d, c, o), K = a.add(Y), z = l.mul(g.mul($d7238066c5de7f1c$var$Rt(K, 1))), M = $d7238066c5de7f1c$var$Ne(z.xy.div(z.w)).toVar();
        M.addAssign(1), M.divAssign(2), M.assign($d7238066c5de7f1c$var$Ne(M.x, M.y.oneMinus())), G = $d7238066c5de7f1c$var$a9(M, t, c), Z = i.mul($d7238066c5de7f1c$var$o9($d7238066c5de7f1c$var$au(Y), p, A));
    }
    const v = Z.rgb.mul(G.rgb), V = r.dot(e).clamp(), H = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$FU({
        // n, v, specularColor, specularF90, roughness
        dotNV: V,
        specularColor: n,
        specularF90: s,
        roughness: t
    })), N = Z.r.add(Z.g, Z.b).div(3);
    return $d7238066c5de7f1c$var$Rt(H.oneMinus().mul(v), G.a.oneMinus().mul(N).oneMinus());
}), $d7238066c5de7f1c$var$Pne = /* @__PURE__ */ $d7238066c5de7f1c$var$Fa(3.2404542, -0.969266, 0.0556434, -1.5371385, 1.8760108, -0.2040259, -0.4985314, 0.041556, 1.0572252), $d7238066c5de7f1c$var$Qne = (r)=>{
    const e = r.sqrt();
    return $d7238066c5de7f1c$var$ne(1).add(e).div($d7238066c5de7f1c$var$ne(1).sub(e));
}, $d7238066c5de7f1c$var$g9 = (r, e)=>r.sub(e).div(r.add(e)).pow2(), $d7238066c5de7f1c$var$One = (r, e)=>{
    const t = r.mul(2 * Math.PI * 1e-9), i = $d7238066c5de7f1c$var$ne(54856e-17, 44201e-17, 52481e-17), n = $d7238066c5de7f1c$var$ne(1681e3, 1795300, 2208400), s = $d7238066c5de7f1c$var$ne(43278e5, 93046e5, 66121e5), a = $d7238066c5de7f1c$var$J(9747e-17 * Math.sqrt(2 * Math.PI * 45282e5)).mul(t.mul(2239900).add(e.x).cos()).mul(t.pow2().mul(-4528200000).exp());
    let o = i.mul(s.mul(2 * Math.PI).sqrt()).mul(n.mul(t).add(e).cos()).mul(t.pow2().negate().mul(s).exp());
    return o = $d7238066c5de7f1c$var$ne(o.x.add(a), o.y, o.z).div(10685e-11), $d7238066c5de7f1c$var$Pne.mul(o);
}, $d7238066c5de7f1c$var$jne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ outsideIOR: r, eta2: e, cosTheta1: t, thinFilmThickness: i, baseF0: n })=>{
    const s = $d7238066c5de7f1c$var$qi(r, e, $d7238066c5de7f1c$var$ic(0, 0.03, i)), o = r.div(s).pow2().mul(t.pow2().oneMinus()).oneMinus();
    $d7238066c5de7f1c$var$Ht(o.lessThan(0), ()=>$d7238066c5de7f1c$var$ne(1));
    const g = o.sqrt(), l = $d7238066c5de7f1c$var$g9(s, r), c = $d7238066c5de7f1c$var$JA({
        f0: l,
        f90: 1,
        dotVH: t
    }), d = c.oneMinus(), p = s.lessThan(r).select(Math.PI, 0), A = $d7238066c5de7f1c$var$J(Math.PI).sub(p), y = $d7238066c5de7f1c$var$Qne(n.clamp(0, 0.9999)), G = $d7238066c5de7f1c$var$g9(y, s.toVec3()), Z = $d7238066c5de7f1c$var$JA({
        f0: G,
        f90: 1,
        dotVH: g
    }), v = $d7238066c5de7f1c$var$ne(y.x.lessThan(s).select(Math.PI, 0), y.y.lessThan(s).select(Math.PI, 0), y.z.lessThan(s).select(Math.PI, 0)), V = s.mul(i, g, 2), H = $d7238066c5de7f1c$var$ne(A).add(v), N = c.mul(Z).clamp(1e-5, 0.9999), Y = N.sqrt(), K = d.pow2().mul(Z).div($d7238066c5de7f1c$var$ne(1).sub(N)), M = c.add(K).toVar(), _ = K.sub(d).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: 1,
        end: 2,
        condition: "<=",
        name: "m"
    }, ({ m: O })=>{
        _.mulAssign(Y);
        const ie = $d7238066c5de7f1c$var$One($d7238066c5de7f1c$var$J(O).mul(V), $d7238066c5de7f1c$var$J(O).mul(H)).mul(2);
        M.addAssign(_.mul(ie));
    }), M.max($d7238066c5de7f1c$var$ne(0));
}).setLayout({
    name: "evalIridescence",
    type: "vec3",
    inputs: [
        {
            name: "outsideIOR",
            type: "float"
        },
        {
            name: "eta2",
            type: "float"
        },
        {
            name: "cosTheta1",
            type: "float"
        },
        {
            name: "thinFilmThickness",
            type: "float"
        },
        {
            name: "baseF0",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$qne = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ normal: r, viewDir: e, roughness: t })=>{
    const i = r.dot(e).saturate(), n = t.pow2(), s = $d7238066c5de7f1c$var$or(t.lessThan(0.25), $d7238066c5de7f1c$var$J(-339.2).mul(n).add($d7238066c5de7f1c$var$J(161.4).mul(t)).sub(25.9), $d7238066c5de7f1c$var$J(-8.48).mul(n).add($d7238066c5de7f1c$var$J(14.3).mul(t)).sub(9.95)), a = $d7238066c5de7f1c$var$or(t.lessThan(0.25), $d7238066c5de7f1c$var$J(44).mul(n).sub($d7238066c5de7f1c$var$J(23.7).mul(t)).add(3.26), $d7238066c5de7f1c$var$J(1.97).mul(n).sub($d7238066c5de7f1c$var$J(3.27).mul(t)).add(0.72));
    return $d7238066c5de7f1c$var$or(t.lessThan(0.25), 0, $d7238066c5de7f1c$var$J(0.1).mul(t).sub(0.025)).add(s.mul(i).add(a).exp()).mul(1 / Math.PI).saturate();
}), $d7238066c5de7f1c$var$dH = $d7238066c5de7f1c$var$ne(0.04), $d7238066c5de7f1c$var$hH = $d7238066c5de7f1c$var$J(1);
class $d7238066c5de7f1c$var$kU extends $d7238066c5de7f1c$var$HR {
    /**
   * Constructs a new physical lighting model.
   *
   * @param {boolean} [clearcoat=false] - Whether clearcoat is supported or not.
   * @param {boolean} [sheen=false] - Whether sheen is supported or not.
   * @param {boolean} [iridescence=false] - Whether iridescence is supported or not.
   * @param {boolean} [anisotropy=false] - Whether anisotropy is supported or not.
   * @param {boolean} [transmission=false] - Whether transmission is supported or not.
   * @param {boolean} [dispersion=false] - Whether dispersion is supported or not.
   */ constructor(e = !1, t = !1, i = !1, n = !1, s = !1, a = !1){
        super(), this.clearcoat = e, this.sheen = t, this.iridescence = i, this.anisotropy = n, this.transmission = s, this.dispersion = a, this.clearcoatRadiance = null, this.clearcoatSpecularDirect = null, this.clearcoatSpecularIndirect = null, this.sheenSpecularDirect = null, this.sheenSpecularIndirect = null, this.iridescenceFresnel = null, this.iridescenceF0 = null;
    }
    /**
   * Depending on what features are requested, the method prepares certain node variables
   * which are later used for lighting computations.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ start(e) {
        if (this.clearcoat === !0 && (this.clearcoatRadiance = $d7238066c5de7f1c$var$ne().toVar("clearcoatRadiance"), this.clearcoatSpecularDirect = $d7238066c5de7f1c$var$ne().toVar("clearcoatSpecularDirect"), this.clearcoatSpecularIndirect = $d7238066c5de7f1c$var$ne().toVar("clearcoatSpecularIndirect")), this.sheen === !0 && (this.sheenSpecularDirect = $d7238066c5de7f1c$var$ne().toVar("sheenSpecularDirect"), this.sheenSpecularIndirect = $d7238066c5de7f1c$var$ne().toVar("sheenSpecularIndirect")), this.iridescence === !0) {
            const t = $d7238066c5de7f1c$var$gn.dot($d7238066c5de7f1c$var$kn).clamp();
            this.iridescenceFresnel = $d7238066c5de7f1c$var$jne({
                outsideIOR: $d7238066c5de7f1c$var$J(1),
                eta2: $d7238066c5de7f1c$var$fL,
                cosTheta1: t,
                thinFilmThickness: $d7238066c5de7f1c$var$GL,
                baseF0: $d7238066c5de7f1c$var$_g
            }), this.iridescenceF0 = $d7238066c5de7f1c$var$TU({
                f: this.iridescenceFresnel,
                f90: 1,
                dotVH: t
            });
        }
        if (this.transmission === !0) {
            const t = $d7238066c5de7f1c$var$ou, i = $d7238066c5de7f1c$var$lJ.sub($d7238066c5de7f1c$var$ou).normalize(), n = $d7238066c5de7f1c$var$Ih, s = e.context;
            s.backdrop = $d7238066c5de7f1c$var$_ne(n, i, $d7238066c5de7f1c$var$jc, $d7238066c5de7f1c$var$Ei, $d7238066c5de7f1c$var$_g, $d7238066c5de7f1c$var$CB, // specularF90
            t, // positionWorld
            $d7238066c5de7f1c$var$$g, // modelMatrix
            $d7238066c5de7f1c$var$ol, // viewMatrix
            $d7238066c5de7f1c$var$s0, // projMatrix
            $d7238066c5de7f1c$var$Uy, $d7238066c5de7f1c$var$vL, $d7238066c5de7f1c$var$ZL, $d7238066c5de7f1c$var$SL, this.dispersion ? $d7238066c5de7f1c$var$RL : null), s.backdropAlpha = $d7238066c5de7f1c$var$WZ, $d7238066c5de7f1c$var$Ei.a.mulAssign($d7238066c5de7f1c$var$qi(1, s.backdrop.a, $d7238066c5de7f1c$var$WZ));
        }
        super.start(e);
    }
    // Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
    // Approximates multi-scattering in order to preserve energy.
    // http://www.jcgt.org/published/0008/01/03/
    computeMultiscattering(e, t, i) {
        const n = $d7238066c5de7f1c$var$gn.dot($d7238066c5de7f1c$var$kn).clamp(), s = $d7238066c5de7f1c$var$mB({
            roughness: $d7238066c5de7f1c$var$jc,
            dotNV: n
        }), a = this.iridescenceF0 ? $d7238066c5de7f1c$var$AR.mix($d7238066c5de7f1c$var$_g, this.iridescenceF0) : $d7238066c5de7f1c$var$_g, o = a.mul(s.x).add(i.mul(s.y)), l = s.x.add(s.y).oneMinus(), c = a.add(a.oneMinus().mul(0.047619)), d = o.mul(c).div(l.mul(c).oneMinus());
        e.addAssign(o), t.addAssign(d.mul(l));
    }
    /**
   * Implements the direct light.
   *
   * @param {Object} lightData - The light data.
   * @param {NodeBuilder} builder - The current node builder.
   */ direct({ lightDirection: e, lightColor: t, reflectedLight: i }) {
        const s = $d7238066c5de7f1c$var$gn.dot(e).clamp().mul(t);
        if (this.sheen === !0 && this.sheenSpecularDirect.addAssign(s.mul($d7238066c5de7f1c$var$Mne({
            lightDirection: e
        }))), this.clearcoat === !0) {
            const o = $d7238066c5de7f1c$var$HC.dot(e).clamp().mul(t);
            this.clearcoatSpecularDirect.addAssign(o.mul($d7238066c5de7f1c$var$AY({
                lightDirection: e,
                f0: $d7238066c5de7f1c$var$dH,
                f90: $d7238066c5de7f1c$var$hH,
                roughness: $d7238066c5de7f1c$var$hB,
                normalView: $d7238066c5de7f1c$var$HC
            })));
        }
        i.directDiffuse.addAssign(s.mul($d7238066c5de7f1c$var$JC({
            diffuseColor: $d7238066c5de7f1c$var$Ei.rgb
        }))), i.directSpecular.addAssign(s.mul($d7238066c5de7f1c$var$xne({
            lightDirection: e,
            f0: $d7238066c5de7f1c$var$_g,
            f90: 1,
            roughness: $d7238066c5de7f1c$var$jc,
            f: this.iridescenceFresnel,
            USE_IRIDESCENCE: this.iridescence,
            USE_ANISOTROPY: this.anisotropy
        })));
    }
    /**
   * This method is intended for implementing the direct light term for
   * rect area light nodes.
   *
   * @param {Object} input - The input data.
   * @param {NodeBuilder} builder - The current node builder.
   */ directRectArea({ lightColor: e, lightPosition: t, halfWidth: i, halfHeight: n, reflectedLight: s, ltc_1: a, ltc_2: o }) {
        const g = t.add(i).sub(n), l = t.sub(i).sub(n), c = t.sub(i).add(n), d = t.add(i).add(n), p = $d7238066c5de7f1c$var$gn, A = $d7238066c5de7f1c$var$kn, y = $d7238066c5de7f1c$var$Ls.toVar(), G = $d7238066c5de7f1c$var$zne({
            N: p,
            V: A,
            roughness: $d7238066c5de7f1c$var$jc
        }), Z = a.sample(G).toVar(), v = o.sample(G).toVar(), V = $d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$ne(Z.x, 0, Z.y), $d7238066c5de7f1c$var$ne(0, 1, 0), $d7238066c5de7f1c$var$ne(Z.z, 0, Z.w)).toVar(), H = $d7238066c5de7f1c$var$_g.mul(v.x).add($d7238066c5de7f1c$var$_g.oneMinus().mul(v.y)).toVar();
        s.directSpecular.addAssign(e.mul(H).mul($d7238066c5de7f1c$var$$5({
            N: p,
            V: A,
            P: y,
            mInv: V,
            p0: g,
            p1: l,
            p2: c,
            p3: d
        }))), s.directDiffuse.addAssign(e.mul($d7238066c5de7f1c$var$Ei).mul($d7238066c5de7f1c$var$$5({
            N: p,
            V: A,
            P: y,
            mInv: $d7238066c5de7f1c$var$Fa(1, 0, 0, 0, 1, 0, 0, 0, 1),
            p0: g,
            p1: l,
            p2: c,
            p3: d
        })));
    }
    /**
   * Implements the indirect lighting.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ indirect(e) {
        this.indirectDiffuse(e), this.indirectSpecular(e), this.ambientOcclusion(e);
    }
    /**
   * Implements the indirect diffuse term.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ indirectDiffuse(e) {
        const { irradiance: t, reflectedLight: i } = e.context;
        i.indirectDiffuse.addAssign(t.mul($d7238066c5de7f1c$var$JC({
            diffuseColor: $d7238066c5de7f1c$var$Ei
        })));
    }
    /**
   * Implements the indirect specular term.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ indirectSpecular(e) {
        const { radiance: t, iblIrradiance: i, reflectedLight: n } = e.context;
        if (this.sheen === !0 && this.sheenSpecularIndirect.addAssign(i.mul($d7238066c5de7f1c$var$WC, $d7238066c5de7f1c$var$qne({
            normal: $d7238066c5de7f1c$var$gn,
            viewDir: $d7238066c5de7f1c$var$kn,
            roughness: $d7238066c5de7f1c$var$mR
        }))), this.clearcoat === !0) {
            const c = $d7238066c5de7f1c$var$HC.dot($d7238066c5de7f1c$var$kn).clamp(), d = $d7238066c5de7f1c$var$FU({
                dotNV: c,
                specularColor: $d7238066c5de7f1c$var$dH,
                specularF90: $d7238066c5de7f1c$var$hH,
                roughness: $d7238066c5de7f1c$var$hB
            });
            this.clearcoatSpecularIndirect.addAssign(this.clearcoatRadiance.mul(d));
        }
        const s = $d7238066c5de7f1c$var$ne().toVar("singleScattering"), a = $d7238066c5de7f1c$var$ne().toVar("multiScattering"), o = i.mul(1 / Math.PI);
        this.computeMultiscattering(s, a, $d7238066c5de7f1c$var$CB);
        const g = s.add(a), l = $d7238066c5de7f1c$var$Ei.mul(g.r.max(g.g).max(g.b).oneMinus());
        n.indirectSpecular.addAssign(t.mul(s)), n.indirectSpecular.addAssign(a.mul(o)), n.indirectDiffuse.addAssign(l.mul(o));
    }
    /**
   * Implements the ambient occlusion term.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ ambientOcclusion(e) {
        const { ambientOcclusion: t, reflectedLight: i } = e.context, s = $d7238066c5de7f1c$var$gn.dot($d7238066c5de7f1c$var$kn).clamp().add(t), a = $d7238066c5de7f1c$var$jc.mul(-16).oneMinus().negate().exp2(), o = t.sub(s.pow(a).oneMinus()).clamp();
        this.clearcoat === !0 && this.clearcoatSpecularIndirect.mulAssign(t), this.sheen === !0 && this.sheenSpecularIndirect.mulAssign(t), i.indirectDiffuse.mulAssign(t), i.indirectSpecular.mulAssign(o);
    }
    /**
   * Used for final lighting accumulations depending on the requested features.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ finish({ context: e }) {
        const { outgoingLight: t } = e;
        if (this.clearcoat === !0) {
            const i = $d7238066c5de7f1c$var$HC.dot($d7238066c5de7f1c$var$kn).clamp(), n = $d7238066c5de7f1c$var$JA({
                dotVH: i,
                f0: $d7238066c5de7f1c$var$dH,
                f90: $d7238066c5de7f1c$var$hH
            }), s = t.mul($d7238066c5de7f1c$var$RZ.mul(n).oneMinus()).add(this.clearcoatSpecularDirect.add(this.clearcoatSpecularIndirect).mul($d7238066c5de7f1c$var$RZ));
            t.assign(s);
        }
        if (this.sheen === !0) {
            const i = $d7238066c5de7f1c$var$WC.r.max($d7238066c5de7f1c$var$WC.g).max($d7238066c5de7f1c$var$WC.b).mul(0.157).oneMinus(), n = t.mul(i).add(this.sheenSpecularDirect, this.sheenSpecularIndirect);
            t.assign(n);
        }
    }
}
const $d7238066c5de7f1c$var$l9 = /* @__PURE__ */ $d7238066c5de7f1c$var$J(1), $d7238066c5de7f1c$var$k2 = /* @__PURE__ */ $d7238066c5de7f1c$var$J(-2), $d7238066c5de7f1c$var$Yv = /* @__PURE__ */ $d7238066c5de7f1c$var$J(0.8), $d7238066c5de7f1c$var$CH = /* @__PURE__ */ $d7238066c5de7f1c$var$J(-1), $d7238066c5de7f1c$var$Kv = /* @__PURE__ */ $d7238066c5de7f1c$var$J(0.4), $d7238066c5de7f1c$var$pH = /* @__PURE__ */ $d7238066c5de7f1c$var$J(2), $d7238066c5de7f1c$var$xv = /* @__PURE__ */ $d7238066c5de7f1c$var$J(0.305), $d7238066c5de7f1c$var$mH = /* @__PURE__ */ $d7238066c5de7f1c$var$J(3), $d7238066c5de7f1c$var$c9 = /* @__PURE__ */ $d7238066c5de7f1c$var$J(0.21), $d7238066c5de7f1c$var$$ne = /* @__PURE__ */ $d7238066c5de7f1c$var$J(4), $d7238066c5de7f1c$var$u9 = /* @__PURE__ */ $d7238066c5de7f1c$var$J(4), $d7238066c5de7f1c$var$ese = /* @__PURE__ */ $d7238066c5de7f1c$var$J(16), $d7238066c5de7f1c$var$tse = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$Wn(r)).toVar(), t = $d7238066c5de7f1c$var$J(-1).toVar();
    return $d7238066c5de7f1c$var$Ht(e.x.greaterThan(e.z), ()=>{
        $d7238066c5de7f1c$var$Ht(e.x.greaterThan(e.y), ()=>{
            t.assign($d7238066c5de7f1c$var$or(r.x.greaterThan(0), 0, 3));
        }).Else(()=>{
            t.assign($d7238066c5de7f1c$var$or(r.y.greaterThan(0), 1, 4));
        });
    }).Else(()=>{
        $d7238066c5de7f1c$var$Ht(e.z.greaterThan(e.y), ()=>{
            t.assign($d7238066c5de7f1c$var$or(r.z.greaterThan(0), 2, 5));
        }).Else(()=>{
            t.assign($d7238066c5de7f1c$var$or(r.y.greaterThan(0), 1, 4));
        });
    }), t;
}).setLayout({
    name: "getFace",
    type: "float",
    inputs: [
        {
            name: "direction",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$ise = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$Ne().toVar();
    return $d7238066c5de7f1c$var$Ht(e.equal(0), ()=>{
        t.assign($d7238066c5de7f1c$var$Ne(r.z, r.y).div($d7238066c5de7f1c$var$Wn(r.x)));
    }).ElseIf(e.equal(1), ()=>{
        t.assign($d7238066c5de7f1c$var$Ne(r.x.negate(), r.z.negate()).div($d7238066c5de7f1c$var$Wn(r.y)));
    }).ElseIf(e.equal(2), ()=>{
        t.assign($d7238066c5de7f1c$var$Ne(r.x.negate(), r.y).div($d7238066c5de7f1c$var$Wn(r.z)));
    }).ElseIf(e.equal(3), ()=>{
        t.assign($d7238066c5de7f1c$var$Ne(r.z.negate(), r.y).div($d7238066c5de7f1c$var$Wn(r.x)));
    }).ElseIf(e.equal(4), ()=>{
        t.assign($d7238066c5de7f1c$var$Ne(r.x.negate(), r.z).div($d7238066c5de7f1c$var$Wn(r.y)));
    }).Else(()=>{
        t.assign($d7238066c5de7f1c$var$Ne(r.x, r.y).div($d7238066c5de7f1c$var$Wn(r.z)));
    }), $d7238066c5de7f1c$var$Et(0.5, t.add(1));
}).setLayout({
    name: "getUV",
    type: "vec2",
    inputs: [
        {
            name: "direction",
            type: "vec3"
        },
        {
            name: "face",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$nse = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(0).toVar();
    return $d7238066c5de7f1c$var$Ht(r.greaterThanEqual($d7238066c5de7f1c$var$Yv), ()=>{
        e.assign($d7238066c5de7f1c$var$l9.sub(r).mul($d7238066c5de7f1c$var$CH.sub($d7238066c5de7f1c$var$k2)).div($d7238066c5de7f1c$var$l9.sub($d7238066c5de7f1c$var$Yv)).add($d7238066c5de7f1c$var$k2));
    }).ElseIf(r.greaterThanEqual($d7238066c5de7f1c$var$Kv), ()=>{
        e.assign($d7238066c5de7f1c$var$Yv.sub(r).mul($d7238066c5de7f1c$var$pH.sub($d7238066c5de7f1c$var$CH)).div($d7238066c5de7f1c$var$Yv.sub($d7238066c5de7f1c$var$Kv)).add($d7238066c5de7f1c$var$CH));
    }).ElseIf(r.greaterThanEqual($d7238066c5de7f1c$var$xv), ()=>{
        e.assign($d7238066c5de7f1c$var$Kv.sub(r).mul($d7238066c5de7f1c$var$mH.sub($d7238066c5de7f1c$var$pH)).div($d7238066c5de7f1c$var$Kv.sub($d7238066c5de7f1c$var$xv)).add($d7238066c5de7f1c$var$pH));
    }).ElseIf(r.greaterThanEqual($d7238066c5de7f1c$var$c9), ()=>{
        e.assign($d7238066c5de7f1c$var$xv.sub(r).mul($d7238066c5de7f1c$var$$ne.sub($d7238066c5de7f1c$var$mH)).div($d7238066c5de7f1c$var$xv.sub($d7238066c5de7f1c$var$c9)).add($d7238066c5de7f1c$var$mH));
    }).Else(()=>{
        e.assign($d7238066c5de7f1c$var$J(-2).mul($d7238066c5de7f1c$var$su($d7238066c5de7f1c$var$Et(1.16, r))));
    }), e;
}).setLayout({
    name: "roughnessToMip",
    type: "float",
    inputs: [
        {
            name: "roughness",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$EU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = r.toVar();
    t.assign($d7238066c5de7f1c$var$Et(2, t).sub(1));
    const i = $d7238066c5de7f1c$var$ne(t, 1).toVar();
    return $d7238066c5de7f1c$var$Ht(e.equal(0), ()=>{
        i.assign(i.zyx);
    }).ElseIf(e.equal(1), ()=>{
        i.assign(i.xzy), i.xz.mulAssign(-1);
    }).ElseIf(e.equal(2), ()=>{
        i.x.mulAssign(-1);
    }).ElseIf(e.equal(3), ()=>{
        i.assign(i.zyx), i.xz.mulAssign(-1);
    }).ElseIf(e.equal(4), ()=>{
        i.assign(i.xzy), i.xy.mulAssign(-1);
    }).ElseIf(e.equal(5), ()=>{
        i.z.mulAssign(-1);
    }), i;
}).setLayout({
    name: "getDirection",
    type: "vec3",
    inputs: [
        {
            name: "uv",
            type: "vec2"
        },
        {
            name: "face",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$JU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s])=>{
    const a = $d7238066c5de7f1c$var$J(t), o = $d7238066c5de7f1c$var$ne(e), g = $d7238066c5de7f1c$var$sl($d7238066c5de7f1c$var$nse(a), $d7238066c5de7f1c$var$k2, s), l = $d7238066c5de7f1c$var$ec(g), c = $d7238066c5de7f1c$var$ru(g), d = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$AB(r, o, c, i, n, s)).toVar();
    return $d7238066c5de7f1c$var$Ht(l.notEqual(0), ()=>{
        const p = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$AB(r, o, c.add(1), i, n, s)).toVar();
        d.assign($d7238066c5de7f1c$var$qi(d, p, l));
    }), d;
}), $d7238066c5de7f1c$var$AB = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s])=>{
    const a = $d7238066c5de7f1c$var$J(t).toVar(), o = $d7238066c5de7f1c$var$ne(e), g = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$tse(o)).toVar(), l = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$En($d7238066c5de7f1c$var$u9.sub(a), 0)).toVar();
    a.assign($d7238066c5de7f1c$var$En(a, $d7238066c5de7f1c$var$u9));
    const c = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$zA(a)).toVar(), d = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$ise(o, g).mul(c.sub(2)).add(1)).toVar();
    return $d7238066c5de7f1c$var$Ht(g.greaterThan(2), ()=>{
        d.y.addAssign(c), g.subAssign(3);
    }), d.x.addAssign(g.mul(c)), d.x.addAssign(l.mul($d7238066c5de7f1c$var$Et(3, $d7238066c5de7f1c$var$ese))), d.y.addAssign($d7238066c5de7f1c$var$Et(4, $d7238066c5de7f1c$var$zA(s).sub(c))), d.x.mulAssign(i), d.y.mulAssign(n), r.sample(d).grad($d7238066c5de7f1c$var$Ne(), $d7238066c5de7f1c$var$Ne());
}), $d7238066c5de7f1c$var$AH = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ envMap: r, mipInt: e, outputDirection: t, theta: i, axis: n, CUBEUV_TEXEL_WIDTH: s, CUBEUV_TEXEL_HEIGHT: a, CUBEUV_MAX_MIP: o })=>{
    const g = $d7238066c5de7f1c$var$_c(i), l = t.mul(g).add(n.cross(t).mul($d7238066c5de7f1c$var$Go(i))).add(n.mul(n.dot(t).mul(g.oneMinus())));
    return $d7238066c5de7f1c$var$AB(r, l, e, s, a, o);
}), $d7238066c5de7f1c$var$UU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ n: r, latitudinal: e, poleAxis: t, outputDirection: i, weights: n, samples: s, dTheta: a, mipInt: o, envMap: g, CUBEUV_TEXEL_WIDTH: l, CUBEUV_TEXEL_HEIGHT: c, CUBEUV_MAX_MIP: d })=>{
    const p = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$or(e, t, $d7238066c5de7f1c$var$kC(t, i))).toVar();
    $d7238066c5de7f1c$var$Ht(p.equal($d7238066c5de7f1c$var$ne(0)), ()=>{
        p.assign($d7238066c5de7f1c$var$ne(i.z, 0, i.x.negate()));
    }), p.assign($d7238066c5de7f1c$var$wo(p));
    const A = $d7238066c5de7f1c$var$ne().toVar();
    return A.addAssign(n.element(0).mul($d7238066c5de7f1c$var$AH({
        theta: 0,
        axis: p,
        outputDirection: i,
        mipInt: o,
        envMap: g,
        CUBEUV_TEXEL_WIDTH: l,
        CUBEUV_TEXEL_HEIGHT: c,
        CUBEUV_MAX_MIP: d
    }))), $d7238066c5de7f1c$var$Cn({
        start: $d7238066c5de7f1c$var$ee(1),
        end: r
    }, ({ i: y })=>{
        $d7238066c5de7f1c$var$Ht(y.greaterThanEqual(s), ()=>{
            $d7238066c5de7f1c$var$AU();
        });
        const G = $d7238066c5de7f1c$var$J(a.mul($d7238066c5de7f1c$var$J(y))).toVar();
        A.addAssign(n.element(y).mul($d7238066c5de7f1c$var$AH({
            theta: G.mul(-1),
            axis: p,
            outputDirection: i,
            mipInt: o,
            envMap: g,
            CUBEUV_TEXEL_WIDTH: l,
            CUBEUV_TEXEL_HEIGHT: c,
            CUBEUV_MAX_MIP: d
        }))), A.addAssign(n.element(y).mul($d7238066c5de7f1c$var$AH({
            theta: G,
            axis: p,
            outputDirection: i,
            mipInt: o,
            envMap: g,
            CUBEUV_TEXEL_WIDTH: l,
            CUBEUV_TEXEL_HEIGHT: c,
            CUBEUV_MAX_MIP: d
        })));
    }), $d7238066c5de7f1c$var$Rt(A, 1);
}), $d7238066c5de7f1c$var$sse = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Ue(r).toVar();
    return e.assign(e.shiftLeft($d7238066c5de7f1c$var$Ue(16)).bitOr(e.shiftRight($d7238066c5de7f1c$var$Ue(16)))), e.assign(e.bitAnd($d7238066c5de7f1c$var$Ue(1431655765)).shiftLeft($d7238066c5de7f1c$var$Ue(1)).bitOr(e.bitAnd($d7238066c5de7f1c$var$Ue(2863311530)).shiftRight($d7238066c5de7f1c$var$Ue(1)))), e.assign(e.bitAnd($d7238066c5de7f1c$var$Ue(858993459)).shiftLeft($d7238066c5de7f1c$var$Ue(2)).bitOr(e.bitAnd($d7238066c5de7f1c$var$Ue(3435973836)).shiftRight($d7238066c5de7f1c$var$Ue(2)))), e.assign(e.bitAnd($d7238066c5de7f1c$var$Ue(252645135)).shiftLeft($d7238066c5de7f1c$var$Ue(4)).bitOr(e.bitAnd($d7238066c5de7f1c$var$Ue(4042322160)).shiftRight($d7238066c5de7f1c$var$Ue(4)))), e.assign(e.bitAnd($d7238066c5de7f1c$var$Ue(16711935)).shiftLeft($d7238066c5de7f1c$var$Ue(8)).bitOr(e.bitAnd($d7238066c5de7f1c$var$Ue(4278255360)).shiftRight($d7238066c5de7f1c$var$Ue(8)))), $d7238066c5de7f1c$var$J(e).mul(23283064365386963e-26);
}), $d7238066c5de7f1c$var$rse = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>$d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$J(r).div($d7238066c5de7f1c$var$J(e)), $d7238066c5de7f1c$var$sse(r))), $d7238066c5de7f1c$var$ase = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ne(e).toVar(), n = $d7238066c5de7f1c$var$J(t), s = n.mul(n).toVar(), a = $d7238066c5de7f1c$var$wo($d7238066c5de7f1c$var$ne(s.mul(i.x), s.mul(i.y), i.z)).toVar(), o = a.x.mul(a.x).add(a.y.mul(a.y)), g = $d7238066c5de7f1c$var$or(o.greaterThan(0), $d7238066c5de7f1c$var$ne(a.y.negate(), a.x, 0).div($d7238066c5de7f1c$var$So(o)), $d7238066c5de7f1c$var$ne(1, 0, 0)).toVar(), l = $d7238066c5de7f1c$var$kC(a, g).toVar(), c = $d7238066c5de7f1c$var$So(r.x), d = $d7238066c5de7f1c$var$Et(2, 3.14159265359).mul(r.y), p = c.mul($d7238066c5de7f1c$var$_c(d)).toVar(), A = c.mul($d7238066c5de7f1c$var$Go(d)).toVar(), y = $d7238066c5de7f1c$var$Et(0.5, a.z.add(1));
    A.assign(y.oneMinus().mul($d7238066c5de7f1c$var$So(p.mul(p).oneMinus())).add(y.mul(A)));
    const G = g.mul(p).add(l.mul(A)).add(a.mul($d7238066c5de7f1c$var$So($d7238066c5de7f1c$var$En(0, p.mul(p).add(A.mul(A)).oneMinus()))));
    return $d7238066c5de7f1c$var$wo($d7238066c5de7f1c$var$ne(s.mul(G.x), s.mul(G.y), $d7238066c5de7f1c$var$En(0, G.z)));
}), $d7238066c5de7f1c$var$DU = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ roughness: r, mipInt: e, envMap: t, N_immutable: i, GGX_SAMPLES: n, CUBEUV_TEXEL_WIDTH: s, CUBEUV_TEXEL_HEIGHT: a, CUBEUV_MAX_MIP: o })=>{
    const g = $d7238066c5de7f1c$var$ne(i).toVar(), l = $d7238066c5de7f1c$var$ne(0).toVar(), c = $d7238066c5de7f1c$var$J(0).toVar();
    return $d7238066c5de7f1c$var$Ht(r.lessThan(1e-3), ()=>{
        l.assign($d7238066c5de7f1c$var$AB(t, g, e, s, a, o));
    }).Else(()=>{
        const d = $d7238066c5de7f1c$var$or($d7238066c5de7f1c$var$Wn(g.z).lessThan(0.999), $d7238066c5de7f1c$var$ne(0, 0, 1), $d7238066c5de7f1c$var$ne(1, 0, 0)), p = $d7238066c5de7f1c$var$wo($d7238066c5de7f1c$var$kC(d, g)).toVar(), A = $d7238066c5de7f1c$var$kC(g, p).toVar();
        $d7238066c5de7f1c$var$Cn({
            start: $d7238066c5de7f1c$var$Ue(0),
            end: n
        }, ({ i: y })=>{
            const G = $d7238066c5de7f1c$var$rse(y, n), Z = $d7238066c5de7f1c$var$ase(G, $d7238066c5de7f1c$var$ne(0, 0, 1), r), v = $d7238066c5de7f1c$var$wo(p.mul(Z.x).add(A.mul(Z.y)).add(g.mul(Z.z))), V = $d7238066c5de7f1c$var$wo(v.mul($d7238066c5de7f1c$var$tc(g, v).mul(2)).sub(g)), H = $d7238066c5de7f1c$var$En($d7238066c5de7f1c$var$tc(g, V), 0);
            $d7238066c5de7f1c$var$Ht(H.greaterThan(0), ()=>{
                const N = $d7238066c5de7f1c$var$AB(t, V, e, s, a, o);
                l.addAssign(N.mul(H)), c.addAssign(H);
            });
        }), $d7238066c5de7f1c$var$Ht(c.greaterThan(0), ()=>{
            l.assign(l.div(c));
        });
    }), $d7238066c5de7f1c$var$Rt(l, 1);
}), $d7238066c5de7f1c$var$qd = 4, $d7238066c5de7f1c$var$I9 = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
], $d7238066c5de7f1c$var$ZC = 20, $d7238066c5de7f1c$var$ose = 512, $d7238066c5de7f1c$var$xb = /* @__PURE__ */ new $d7238066c5de7f1c$var$dL(-1, 1, 1, -1, 0, 1), $d7238066c5de7f1c$var$gse = /* @__PURE__ */ new $d7238066c5de7f1c$var$tg(90, 1), $d7238066c5de7f1c$var$d9 = /* @__PURE__ */ new $d7238066c5de7f1c$var$rn();
let $d7238066c5de7f1c$var$bH = null, $d7238066c5de7f1c$var$yH = 0, $d7238066c5de7f1c$var$BH = 0;
const $d7238066c5de7f1c$var$lse = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$YZ = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$cse = [
    3,
    1,
    5,
    0,
    4,
    2
], $d7238066c5de7f1c$var$fH = /* @__PURE__ */ $d7238066c5de7f1c$var$EU($d7238066c5de7f1c$var$yn(), $d7238066c5de7f1c$var$RI("faceIndex")).normalize(), $d7238066c5de7f1c$var$NR = /* @__PURE__ */ $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$fH.x, $d7238066c5de7f1c$var$fH.y, $d7238066c5de7f1c$var$fH.z);
class $d7238066c5de7f1c$var$use {
    /**
   * Constructs a new PMREM generator.
   *
   * @param {Renderer} renderer - The renderer.
   */ constructor(e){
        this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._blurMaterial = null, this._ggxMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._backgroundBox = null;
    }
    get _hasInitialized() {
        return this._renderer.hasInitialized();
    }
    /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
   * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   * @see {@link PMREMGenerator#fromScene}
   */ fromScene(e, t = 0, i = 0.1, n = 100, s = {}) {
        const { size: a = 256, position: o = $d7238066c5de7f1c$var$lse, renderTarget: g = null } = s;
        if (this._setSize(a), this._hasInitialized === !1) {
            $d7238066c5de7f1c$var$ze('PMREMGenerator: ".fromScene()" called before the backend is initialized. Try using "await renderer.init()" instead.');
            const c = g || this._allocateTarget();
            return s.renderTarget = c, this.fromSceneAsync(e, t, i, n, s), c;
        }
        $d7238066c5de7f1c$var$bH = this._renderer.getRenderTarget(), $d7238066c5de7f1c$var$yH = this._renderer.getActiveCubeFace(), $d7238066c5de7f1c$var$BH = this._renderer.getActiveMipmapLevel();
        const l = g || this._allocateTarget();
        return l.depthBuffer = !0, this._init(l), this._sceneToCubeUV(e, i, n, l, o), t > 0 && this._blur(l, 0, 0, t), this._applyPMREM(l), this._cleanup(l), l;
    }
    /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   *
   * @deprecated
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
   * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
   * @return {Promise<RenderTarget>} A Promise that resolve with the PMREM when the generation has been finished.
   * @see {@link PMREMGenerator#fromScene}
   */ async fromSceneAsync(e, t = 0, i = 0.1, n = 100, s = {}) {
        return $d7238066c5de7f1c$var$es('PMREMGenerator: ".fromSceneAsync()" is deprecated. Use "await renderer.init()" instead.'), await this._renderer.init(), this.fromScene(e, t, i, n, s);
    }
    /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   * @see {@link PMREMGenerator#fromEquirectangularAsync}
   */ fromEquirectangular(e, t = null) {
        if (this._hasInitialized === !1) {
            $d7238066c5de7f1c$var$ze('PMREMGenerator: .fromEquirectangular() called before the backend is initialized. Try using "await renderer.init()" instead.'), this._setSizeFromTexture(e);
            const i = t || this._allocateTarget();
            return this.fromEquirectangularAsync(e, i), i;
        }
        return this._fromTexture(e, t);
    }
    /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @deprecated
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {Promise<RenderTarget>} The resulting PMREM.
   * @see {@link PMREMGenerator#fromEquirectangular}
   */ async fromEquirectangularAsync(e, t = null) {
        return $d7238066c5de7f1c$var$es('PMREMGenerator: ".fromEquirectangularAsync()" is deprecated. Use "await renderer.init()" instead.'), await this._renderer.init(), this._fromTexture(e, t);
    }
    /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   * @see {@link PMREMGenerator#fromCubemapAsync}
   */ fromCubemap(e, t = null) {
        if (this._hasInitialized === !1) {
            $d7238066c5de7f1c$var$ze("PMREMGenerator: .fromCubemap() called before the backend is initialized. Try using .fromCubemapAsync() instead."), this._setSizeFromTexture(e);
            const i = t || this._allocateTarget();
            return this.fromCubemapAsync(e, t), i;
        }
        return this._fromTexture(e, t);
    }
    /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * with the 256 x 256 cubemap output.
   *
   * @deprecated
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {Promise<RenderTarget>} The resulting PMREM.
   * @see {@link PMREMGenerator#fromCubemap}
   */ async fromCubemapAsync(e, t = null) {
        return $d7238066c5de7f1c$var$es('PMREMGenerator: ".fromCubemapAsync()" is deprecated. Use "await renderer.init()" instead.'), await this._renderer.init(), this._fromTexture(e, t);
    }
    /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   *
   * @returns {Promise}
   */ async compileCubemapShader() {
        this._cubemapMaterial === null && (this._cubemapMaterial = $d7238066c5de7f1c$var$C9(), await this._compileMaterial(this._cubemapMaterial));
    }
    /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   *
   * @returns {Promise}
   */ async compileEquirectangularShader() {
        this._equirectMaterial === null && (this._equirectMaterial = $d7238066c5de7f1c$var$p9(), await this._compileMaterial(this._equirectMaterial));
    }
    /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */ dispose() {
        this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
    }
    // private interface
    _setSizeFromTexture(e) {
        e.mapping === $d7238066c5de7f1c$var$gB || e.mapping === $d7238066c5de7f1c$var$$S ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4);
    }
    _setSize(e) {
        this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
        for(let e = 0; e < this._lodMeshes.length; e++)this._lodMeshes[e].geometry.dispose();
    }
    _cleanup(e) {
        this._renderer.setRenderTarget($d7238066c5de7f1c$var$bH, $d7238066c5de7f1c$var$yH, $d7238066c5de7f1c$var$BH), e.scissorTest = !1, $d7238066c5de7f1c$var$Fm(e, 0, 0, e.width, e.height);
    }
    _fromTexture(e, t) {
        this._setSizeFromTexture(e), $d7238066c5de7f1c$var$bH = this._renderer.getRenderTarget(), $d7238066c5de7f1c$var$yH = this._renderer.getActiveCubeFace(), $d7238066c5de7f1c$var$BH = this._renderer.getActiveMipmapLevel();
        const i = t || this._allocateTarget();
        return this._init(i), this._textureToCubeUV(e, i), this._applyPMREM(i), this._cleanup(i), i;
    }
    _allocateTarget() {
        const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize;
        return $d7238066c5de7f1c$var$h9(e, t);
    }
    _init(e) {
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e.width || this._pingPongRenderTarget.height !== e.height) {
            this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = $d7238066c5de7f1c$var$h9(e.width, e.height);
            const { _lodMax: t } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $d7238066c5de7f1c$var$Ise(t)), this._blurMaterial = $d7238066c5de7f1c$var$dse(t, e.width, e.height);
        }
    }
    async _compileMaterial(e) {
        const t = new $d7238066c5de7f1c$var$SI(new $d7238066c5de7f1c$var$Cu(), e);
        await this._renderer.compile(t, $d7238066c5de7f1c$var$xb);
    }
    _sceneToCubeUV(e, t, i, n, s) {
        const a = $d7238066c5de7f1c$var$gse;
        a.near = t, a.far = i;
        const o = [
            1,
            1,
            1,
            1,
            -1,
            1
        ], g = [
            1,
            -1,
            1,
            -1,
            1,
            -1
        ], l = this._renderer, c = l.autoClear;
        l.getClearColor($d7238066c5de7f1c$var$d9), l.autoClear = !1, this._backgroundBox === null && (this._backgroundBox = new $d7238066c5de7f1c$var$SI(new $d7238066c5de7f1c$var$kB(), new $d7238066c5de7f1c$var$Dd({
            name: "PMREM.Background",
            side: $d7238066c5de7f1c$var$Ka,
            depthWrite: !1,
            depthTest: !1
        })));
        const d = this._backgroundBox, p = d.material;
        let A = !1;
        const y = e.background;
        y ? y.isColor && (p.color.copy(y), e.background = null, A = !0) : (p.color.copy($d7238066c5de7f1c$var$d9), A = !0), l.setRenderTarget(n), l.clear(), A && l.render(d, a);
        for(let G = 0; G < 6; G++){
            const Z = G % 3;
            Z === 0 ? (a.up.set(0, o[G], 0), a.position.set(s.x, s.y, s.z), a.lookAt(s.x + g[G], s.y, s.z)) : Z === 1 ? (a.up.set(0, 0, o[G]), a.position.set(s.x, s.y, s.z), a.lookAt(s.x, s.y + g[G], s.z)) : (a.up.set(0, o[G], 0), a.position.set(s.x, s.y, s.z), a.lookAt(s.x, s.y, s.z + g[G]));
            const v = this._cubeSize;
            $d7238066c5de7f1c$var$Fm(n, Z * v, G > 2 ? v : 0, v, v), l.render(e, a);
        }
        l.autoClear = c, e.background = y;
    }
    _textureToCubeUV(e, t) {
        const i = this._renderer, n = e.mapping === $d7238066c5de7f1c$var$gB || e.mapping === $d7238066c5de7f1c$var$$S;
        n ? this._cubemapMaterial === null && (this._cubemapMaterial = $d7238066c5de7f1c$var$C9(e)) : this._equirectMaterial === null && (this._equirectMaterial = $d7238066c5de7f1c$var$p9(e));
        const s = n ? this._cubemapMaterial : this._equirectMaterial;
        s.fragmentNode.value = e;
        const a = this._lodMeshes[0];
        a.material = s;
        const o = this._cubeSize;
        $d7238066c5de7f1c$var$Fm(t, 0, 0, 3 * o, 2 * o), i.setRenderTarget(t), i.render(a, $d7238066c5de7f1c$var$xb);
    }
    _applyPMREM(e) {
        const t = this._renderer, i = t.autoClear;
        t.autoClear = !1;
        const n = this._lodMeshes.length;
        for(let s = 1; s < n; s++)this._applyGGXFilter(e, s - 1, s);
        t.autoClear = i;
    }
    /**
   * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
   * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
   * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
   * applies incremental roughness filtering to avoid over-blurring.
   *
   * @private
   * @param {RenderTarget} cubeUVRenderTarget
   * @param {number} lodIn - Source LOD level to read from
   * @param {number} lodOut - Target LOD level to write to
   */ _applyGGXFilter(e, t, i) {
        const n = this._renderer, s = this._pingPongRenderTarget;
        this._ggxMaterial === null && (this._ggxMaterial = $d7238066c5de7f1c$var$hse(this._lodMax, this._pingPongRenderTarget.width, this._pingPongRenderTarget.height));
        const a = this._ggxMaterial, o = this._lodMeshes[i];
        o.material = a;
        const g = $d7238066c5de7f1c$var$YZ.get(a), l = i / (this._lodMeshes.length - 1), c = t / (this._lodMeshes.length - 1), d = Math.sqrt(l * l - c * c), p = 0.05 + l * 0.95, A = d * p, { _lodMax: y } = this, G = this._sizeLods[i], Z = 3 * G * (i > y - $d7238066c5de7f1c$var$qd ? i - y + $d7238066c5de7f1c$var$qd : 0), v = 4 * (this._cubeSize - G);
        e.texture.frame = (e.texture.frame || 0) + 1, g.envMap.value = e.texture, g.roughness.value = A, g.mipInt.value = y - t, $d7238066c5de7f1c$var$Fm(s, Z, v, 3 * G, 2 * G), n.setRenderTarget(s), n.render(o, $d7238066c5de7f1c$var$xb), s.texture.frame = (s.texture.frame || 0) + 1, g.envMap.value = s.texture, g.roughness.value = 0, g.mipInt.value = y - i, $d7238066c5de7f1c$var$Fm(e, Z, v, 3 * G, 2 * G), n.setRenderTarget(e), n.render(o, $d7238066c5de7f1c$var$xb);
    }
    /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * Used for initial scene blur in fromScene() method when sigma > 0.
   *
   * @private
   * @param {RenderTarget} cubeUVRenderTarget - The cubemap render target.
   * @param {number} lodIn - The input level-of-detail.
   * @param {number} lodOut - The output level-of-detail.
   * @param {number} sigma - The blur radius in radians.
   * @param {Vector3} [poleAxis] - The pole axis.
   */ _blur(e, t, i, n, s) {
        const a = this._pingPongRenderTarget;
        this._halfBlur(e, a, t, i, n, "latitudinal", s), this._halfBlur(a, e, i, i, n, "longitudinal", s);
    }
    _halfBlur(e, t, i, n, s, a, o) {
        const g = this._renderer, l = this._blurMaterial;
        a !== "latitudinal" && a !== "longitudinal" && $d7238066c5de7f1c$var$nt("blur direction must be either latitudinal or longitudinal!");
        const c = 3, d = this._lodMeshes[n];
        d.material = l;
        const p = $d7238066c5de7f1c$var$YZ.get(l), A = this._sizeLods[i] - 1, y = isFinite(s) ? Math.PI / (2 * A) : 2 * Math.PI / (2 * $d7238066c5de7f1c$var$ZC - 1), G = s / y, Z = isFinite(s) ? 1 + Math.floor(c * G) : $d7238066c5de7f1c$var$ZC;
        Z > $d7238066c5de7f1c$var$ZC && $d7238066c5de7f1c$var$ze(`sigmaRadians, ${s}, is too large and will clip, as it requested ${Z} samples when the maximum is set to ${$d7238066c5de7f1c$var$ZC}`);
        const v = [];
        let V = 0;
        for(let z = 0; z < $d7238066c5de7f1c$var$ZC; ++z){
            const M = z / G, _ = Math.exp(-M * M / 2);
            v.push(_), z === 0 ? V += _ : z < Z && (V += 2 * _);
        }
        for(let z = 0; z < v.length; z++)v[z] = v[z] / V;
        e.texture.frame = (e.texture.frame || 0) + 1, p.envMap.value = e.texture, p.samples.value = Z, p.weights.array = v, p.latitudinal.value = a === "latitudinal" ? 1 : 0, o && (p.poleAxis.value = o);
        const { _lodMax: H } = this;
        p.dTheta.value = y, p.mipInt.value = H - i;
        const N = this._sizeLods[n], Y = 3 * N * (n > H - $d7238066c5de7f1c$var$qd ? n - H + $d7238066c5de7f1c$var$qd : 0), K = 4 * (this._cubeSize - N);
        $d7238066c5de7f1c$var$Fm(t, Y, K, 3 * N, 2 * N), g.setRenderTarget(t), g.render(d, $d7238066c5de7f1c$var$xb);
    }
}
function $d7238066c5de7f1c$var$Ise(r) {
    const e = [], t = [], i = [];
    let n = r;
    const s = r - $d7238066c5de7f1c$var$qd + 1 + $d7238066c5de7f1c$var$I9.length;
    for(let a = 0; a < s; a++){
        const o = Math.pow(2, n);
        e.push(o);
        let g = 1 / o;
        a > r - $d7238066c5de7f1c$var$qd ? g = $d7238066c5de7f1c$var$I9[a - r + $d7238066c5de7f1c$var$qd - 1] : a === 0 && (g = 0), t.push(g);
        const l = 1 / (o - 2), c = -l, d = 1 + l, p = [
            c,
            c,
            d,
            c,
            d,
            d,
            c,
            c,
            d,
            d,
            c,
            d
        ], A = 6, y = 6, G = 3, Z = 2, v = 1, V = new Float32Array(G * y * A), H = new Float32Array(Z * y * A), N = new Float32Array(v * y * A);
        for(let K = 0; K < A; K++){
            const z = K % 3 * 2 / 3 - 1, M = K > 2 ? 0 : -1, _ = [
                z,
                M,
                0,
                z + 2 / 3,
                M,
                0,
                z + 2 / 3,
                M + 1,
                0,
                z,
                M,
                0,
                z + 2 / 3,
                M + 1,
                0,
                z,
                M + 1,
                0
            ], O = $d7238066c5de7f1c$var$cse[K];
            V.set(_, G * y * O), H.set(p, Z * y * O);
            const ie = [
                O,
                O,
                O,
                O,
                O,
                O
            ];
            N.set(ie, v * y * O);
        }
        const Y = new $d7238066c5de7f1c$var$Cu();
        Y.setAttribute("position", new $d7238066c5de7f1c$var$gg(V, G)), Y.setAttribute("uv", new $d7238066c5de7f1c$var$gg(H, Z)), Y.setAttribute("faceIndex", new $d7238066c5de7f1c$var$gg(N, v)), i.push(new $d7238066c5de7f1c$var$SI(Y, null)), n > $d7238066c5de7f1c$var$qd && n--;
    }
    return {
        lodMeshes: i,
        sizeLods: e,
        sigmas: t
    };
}
function $d7238066c5de7f1c$var$h9(r, e) {
    const t = {
        magFilter: $d7238066c5de7f1c$var$ro,
        minFilter: $d7238066c5de7f1c$var$ro,
        generateMipmaps: !1,
        type: $d7238066c5de7f1c$var$Ia,
        format: $d7238066c5de7f1c$var$sg,
        colorSpace: $d7238066c5de7f1c$var$fZ
    }, i = new $d7238066c5de7f1c$var$WI(r, e, t);
    return i.texture.mapping = $d7238066c5de7f1c$var$A2, i.texture.name = "PMREM.cubeUv", i.texture.isPMREMTexture = !0, i.scissorTest = !0, i;
}
function $d7238066c5de7f1c$var$Fm(r, e, t, i, n) {
    r.viewport.set(e, t, i, n), r.scissor.set(e, t, i, n);
}
function $d7238066c5de7f1c$var$LR(r) {
    const e = new $d7238066c5de7f1c$var$Bs();
    return e.depthTest = !1, e.depthWrite = !1, e.blending = $d7238066c5de7f1c$var$xA, e.name = `PMREM_${r}`, e;
}
function $d7238066c5de7f1c$var$dse(r, e, t) {
    const i = $d7238066c5de7f1c$var$La(new Array($d7238066c5de7f1c$var$ZC).fill(0)), n = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce(0, 1, 0)), s = $d7238066c5de7f1c$var$yt(0), a = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$ZC), o = $d7238066c5de7f1c$var$yt(0), g = $d7238066c5de7f1c$var$yt(1), l = $d7238066c5de7f1c$var$ni(), c = $d7238066c5de7f1c$var$yt(0), d = $d7238066c5de7f1c$var$J(1 / e), p = $d7238066c5de7f1c$var$J(1 / t), A = $d7238066c5de7f1c$var$J(r), y = {
        n: a,
        latitudinal: o,
        weights: i,
        poleAxis: n,
        outputDirection: $d7238066c5de7f1c$var$NR,
        dTheta: s,
        samples: g,
        envMap: l,
        mipInt: c,
        CUBEUV_TEXEL_WIDTH: d,
        CUBEUV_TEXEL_HEIGHT: p,
        CUBEUV_MAX_MIP: A
    }, G = $d7238066c5de7f1c$var$LR("blur");
    return G.fragmentNode = $d7238066c5de7f1c$var$UU({
        ...y,
        latitudinal: o.equal(1)
    }), $d7238066c5de7f1c$var$YZ.set(G, y), G;
}
function $d7238066c5de7f1c$var$hse(r, e, t) {
    const i = $d7238066c5de7f1c$var$ni(), n = $d7238066c5de7f1c$var$yt(0), s = $d7238066c5de7f1c$var$yt(0), a = $d7238066c5de7f1c$var$J(1 / e), o = $d7238066c5de7f1c$var$J(1 / t), g = $d7238066c5de7f1c$var$J(r), l = {
        envMap: i,
        roughness: n,
        mipInt: s,
        CUBEUV_TEXEL_WIDTH: a,
        CUBEUV_TEXEL_HEIGHT: o,
        CUBEUV_MAX_MIP: g
    }, c = $d7238066c5de7f1c$var$LR("ggx");
    return c.fragmentNode = $d7238066c5de7f1c$var$DU({
        ...l,
        N_immutable: $d7238066c5de7f1c$var$NR,
        GGX_SAMPLES: $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ose)
    }), $d7238066c5de7f1c$var$YZ.set(c, l), c;
}
function $d7238066c5de7f1c$var$C9(r) {
    const e = $d7238066c5de7f1c$var$LR("cubemap");
    return e.fragmentNode = $d7238066c5de7f1c$var$EA(r, $d7238066c5de7f1c$var$NR), e;
}
function $d7238066c5de7f1c$var$p9(r) {
    const e = $d7238066c5de7f1c$var$LR("equirect");
    return e.fragmentNode = $d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$CY($d7238066c5de7f1c$var$NR), 0), e;
}
const $d7238066c5de7f1c$var$m9 = /* @__PURE__ */ new WeakMap();
function $d7238066c5de7f1c$var$Cse(r) {
    const e = Math.log2(r) - 2, t = 1 / r;
    return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 112)),
        texelHeight: t,
        maxMip: e
    };
}
function $d7238066c5de7f1c$var$pse(r, e, t) {
    const i = $d7238066c5de7f1c$var$mse(e);
    let n = i.get(r);
    if ((n !== void 0 ? n.pmremVersion : -1) !== r.pmremVersion) {
        const a = r.image;
        if (r.isCubeTexture) {
            if ($d7238066c5de7f1c$var$bse(a)) n = t.fromCubemap(r, n);
            else return null;
        } else if ($d7238066c5de7f1c$var$yse(a)) n = t.fromEquirectangular(r, n);
        else return null;
        n.pmremVersion = r.pmremVersion, i.set(r, n);
    }
    return n.texture;
}
function $d7238066c5de7f1c$var$mse(r) {
    let e = $d7238066c5de7f1c$var$m9.get(r);
    return e === void 0 && (e = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$m9.set(r, e)), e;
}
class $d7238066c5de7f1c$var$Ase extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "PMREMNode";
    }
    /**
   * Constructs a new function overloading node.
   *
   * @param {Texture} value - The input texture.
   * @param {Node<vec2>} [uvNode=null] - The uv node.
   * @param {Node<float>} [levelNode=null] - The level node.
   */ constructor(e, t = null, i = null){
        super("vec3"), this._value = e, this._pmrem = null, this.uvNode = t, this.levelNode = i, this._generator = null;
        const n = new $d7238066c5de7f1c$var$Ca();
        n.isRenderTargetTexture = !0, this._texture = $d7238066c5de7f1c$var$ni(n), this._width = $d7238066c5de7f1c$var$yt(0), this._height = $d7238066c5de7f1c$var$yt(0), this._maxMip = $d7238066c5de7f1c$var$yt(0), this.updateBeforeType = $d7238066c5de7f1c$var$Dt.RENDER;
    }
    set value(e) {
        this._value = e, this._pmrem = null;
    }
    /**
   * The node's texture value.
   *
   * @type {Texture}
   */ get value() {
        return this._value;
    }
    /**
   * Uses the given PMREM texture to update internal values.
   *
   * @param {Texture} texture - The PMREM texture.
   */ updateFromTexture(e) {
        const t = $d7238066c5de7f1c$var$Cse(e.image.height);
        this._texture.value = e, this._width.value = t.texelWidth, this._height.value = t.texelHeight, this._maxMip.value = t.maxMip;
    }
    updateBefore(e) {
        let t = this._pmrem;
        const i = t ? t.pmremVersion : -1, n = this._value;
        i !== n.pmremVersion && (n.isPMREMTexture === !0 ? t = n : t = $d7238066c5de7f1c$var$pse(n, e.renderer, this._generator), t !== null && (this._pmrem = t, this.updateFromTexture(t)));
    }
    setup(e) {
        this._generator === null && (this._generator = new $d7238066c5de7f1c$var$use(e.renderer)), this.updateBefore(e);
        let t = this.uvNode;
        t === null && e.context.getUV && (t = e.context.getUV(this)), t = $d7238066c5de7f1c$var$sY.mul($d7238066c5de7f1c$var$ne(t.x, t.y.negate(), t.z));
        let i = this.levelNode;
        return i === null && e.context.getTextureLevel && (i = e.context.getTextureLevel(this)), $d7238066c5de7f1c$var$JU(this._texture, t, i, this._width, this._height, this._maxMip);
    }
    dispose() {
        super.dispose(), this._generator !== null && this._generator.dispose();
    }
}
function $d7238066c5de7f1c$var$bse(r) {
    if (r == null) return !1;
    let e = 0;
    const t = 6;
    for(let i = 0; i < t; i++)r[i] !== void 0 && e++;
    return e === t;
}
function $d7238066c5de7f1c$var$yse(r) {
    return r == null ? !1 : r.height > 0;
}
const $d7238066c5de7f1c$var$yY = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Ase).setParameterLength(1, 3), $d7238066c5de7f1c$var$A9 = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$Bse extends $d7238066c5de7f1c$var$a0 {
    static get type() {
        return "EnvironmentNode";
    }
    /**
   * Constructs a new environment node.
   *
   * @param {Node} [envNode=null] - A node representing the environment.
   */ constructor(e = null){
        super(), this.envNode = e;
    }
    setup(e) {
        const { material: t } = e;
        let i = this.envNode;
        if (i.isTextureNode || i.isMaterialReferenceNode) {
            const d = i.isTextureNode ? i.value : t[i.property];
            let p = $d7238066c5de7f1c$var$A9.get(d);
            p === void 0 && (p = $d7238066c5de7f1c$var$yY(d), $d7238066c5de7f1c$var$A9.set(d, p)), i = p;
        }
        const s = t.useAnisotropy === !0 || t.anisotropy > 0 ? $d7238066c5de7f1c$var$NJ : $d7238066c5de7f1c$var$gn, a = i.context($d7238066c5de7f1c$var$b9($d7238066c5de7f1c$var$jc, s)).mul($d7238066c5de7f1c$var$wS), o = i.context($d7238066c5de7f1c$var$fse($d7238066c5de7f1c$var$Ih)).mul(Math.PI).mul($d7238066c5de7f1c$var$wS), g = $d7238066c5de7f1c$var$VA(a), l = $d7238066c5de7f1c$var$VA(o);
        e.context.radiance.addAssign(g), e.context.iblIrradiance.addAssign(l);
        const c = e.context.lightingModel.clearcoatRadiance;
        if (c) {
            const d = i.context($d7238066c5de7f1c$var$b9($d7238066c5de7f1c$var$hB, $d7238066c5de7f1c$var$HC)).mul($d7238066c5de7f1c$var$wS), p = $d7238066c5de7f1c$var$VA(d);
            c.addAssign(p);
        }
    }
}
const $d7238066c5de7f1c$var$b9 = (r, e)=>{
    let t = null;
    return {
        getUV: ()=>(t === null && (t = $d7238066c5de7f1c$var$kn.negate().reflect(e), t = $d7238066c5de7f1c$var$ML(r).mix(t, e).normalize(), t = t.transformDirection($d7238066c5de7f1c$var$ol)), t),
        getTextureLevel: ()=>r
    };
}, $d7238066c5de7f1c$var$fse = (r)=>({
        getUV: ()=>r,
        getTextureLevel: ()=>$d7238066c5de7f1c$var$J(1)
    }), $d7238066c5de7f1c$var$Gse = /* @__PURE__ */ new $d7238066c5de7f1c$var$m3();
class $d7238066c5de7f1c$var$BY extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshStandardNodeMaterial";
    }
    /**
   * Constructs a new mesh standard node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshStandardNodeMaterial = !0, this.lights = !0, this.emissiveNode = null, this.metalnessNode = null, this.roughnessNode = null, this.setDefaultValues($d7238066c5de7f1c$var$Gse), this.setValues(e);
    }
    /**
   * Overwritten since this type of material uses {@link EnvironmentNode}
   * to implement the PBR (PMREM based) environment mapping. Besides, the
   * method honors `Scene.environment`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?EnvironmentNode<vec3>} The environment node.
   */ setupEnvironment(e) {
        let t = super.setupEnvironment(e);
        return t === null && e.environmentNode && (t = e.environmentNode), t ? new $d7238066c5de7f1c$var$Bse(t) : null;
    }
    /**
   * Setups the lighting model.
   *
   * @return {PhysicalLightingModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$kU();
    }
    /**
   * Setups the specular related node variables.
   */ setupSpecular() {
        const e = $d7238066c5de7f1c$var$qi($d7238066c5de7f1c$var$ne(0.04), $d7238066c5de7f1c$var$Ei.rgb, $d7238066c5de7f1c$var$dB);
        $d7238066c5de7f1c$var$_g.assign(e), $d7238066c5de7f1c$var$CB.assign(1);
    }
    /**
   * Setups the standard specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupVariants() {
        const e = this.metalnessNode ? $d7238066c5de7f1c$var$J(this.metalnessNode) : $d7238066c5de7f1c$var$zJ;
        $d7238066c5de7f1c$var$dB.assign(e);
        let t = this.roughnessNode ? $d7238066c5de7f1c$var$J(this.roughnessNode) : $d7238066c5de7f1c$var$MJ;
        t = $d7238066c5de7f1c$var$mY({
            roughness: t
        }), $d7238066c5de7f1c$var$jc.assign(t), this.setupSpecular(), $d7238066c5de7f1c$var$Ei.assign($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$Ei.rgb.mul(e.oneMinus()), $d7238066c5de7f1c$var$Ei.a));
    }
    copy(e) {
        return this.emissiveNode = e.emissiveNode, this.metalnessNode = e.metalnessNode, this.roughnessNode = e.roughnessNode, super.copy(e);
    }
}
const $d7238066c5de7f1c$var$vse = /* @__PURE__ */ new $d7238066c5de7f1c$var$aee();
class $d7238066c5de7f1c$var$Sse extends $d7238066c5de7f1c$var$BY {
    static get type() {
        return "MeshPhysicalNodeMaterial";
    }
    /**
   * Constructs a new mesh physical node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshPhysicalNodeMaterial = !0, this.clearcoatNode = null, this.clearcoatRoughnessNode = null, this.clearcoatNormalNode = null, this.sheenNode = null, this.sheenRoughnessNode = null, this.iridescenceNode = null, this.iridescenceIORNode = null, this.iridescenceThicknessNode = null, this.specularIntensityNode = null, this.specularColorNode = null, this.iorNode = null, this.transmissionNode = null, this.thicknessNode = null, this.attenuationDistanceNode = null, this.attenuationColorNode = null, this.dispersionNode = null, this.anisotropyNode = null, this.setDefaultValues($d7238066c5de7f1c$var$vse), this.setValues(e);
    }
    /**
   * Whether the lighting model should use clearcoat or not.
   *
   * @type {boolean}
   * @default true
   */ get useClearcoat() {
        return this.clearcoat > 0 || this.clearcoatNode !== null;
    }
    /**
   * Whether the lighting model should use iridescence or not.
   *
   * @type {boolean}
   * @default true
   */ get useIridescence() {
        return this.iridescence > 0 || this.iridescenceNode !== null;
    }
    /**
   * Whether the lighting model should use sheen or not.
   *
   * @type {boolean}
   * @default true
   */ get useSheen() {
        return this.sheen > 0 || this.sheenNode !== null;
    }
    /**
   * Whether the lighting model should use anisotropy or not.
   *
   * @type {boolean}
   * @default true
   */ get useAnisotropy() {
        return this.anisotropy > 0 || this.anisotropyNode !== null;
    }
    /**
   * Whether the lighting model should use transmission or not.
   *
   * @type {boolean}
   * @default true
   */ get useTransmission() {
        return this.transmission > 0 || this.transmissionNode !== null;
    }
    /**
   * Whether the lighting model should use dispersion or not.
   *
   * @type {boolean}
   * @default true
   */ get useDispersion() {
        return this.dispersion > 0 || this.dispersionNode !== null;
    }
    /**
   * Setups the specular related node variables.
   */ setupSpecular() {
        const e = this.iorNode ? $d7238066c5de7f1c$var$J(this.iorNode) : $d7238066c5de7f1c$var$tU;
        $d7238066c5de7f1c$var$Uy.assign(e), $d7238066c5de7f1c$var$_g.assign($d7238066c5de7f1c$var$qi($d7238066c5de7f1c$var$Xo($d7238066c5de7f1c$var$TL($d7238066c5de7f1c$var$Uy.sub(1).div($d7238066c5de7f1c$var$Uy.add(1))).mul($d7238066c5de7f1c$var$TJ), $d7238066c5de7f1c$var$ne(1)).mul($d7238066c5de7f1c$var$T2), $d7238066c5de7f1c$var$Ei.rgb, $d7238066c5de7f1c$var$dB)), $d7238066c5de7f1c$var$CB.assign($d7238066c5de7f1c$var$qi($d7238066c5de7f1c$var$T2, 1, $d7238066c5de7f1c$var$dB));
    }
    /**
   * Setups the lighting model.
   *
   * @return {PhysicalLightingModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$kU(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion);
    }
    /**
   * Setups the physical specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupVariants(e) {
        if (super.setupVariants(e), this.useClearcoat) {
            const t = this.clearcoatNode ? $d7238066c5de7f1c$var$J(this.clearcoatNode) : $d7238066c5de7f1c$var$EJ, i = this.clearcoatRoughnessNode ? $d7238066c5de7f1c$var$J(this.clearcoatRoughnessNode) : $d7238066c5de7f1c$var$JJ;
            $d7238066c5de7f1c$var$RZ.assign(t), $d7238066c5de7f1c$var$hB.assign($d7238066c5de7f1c$var$mY({
                roughness: i
            }));
        }
        if (this.useSheen) {
            const t = this.sheenNode ? $d7238066c5de7f1c$var$ne(this.sheenNode) : $d7238066c5de7f1c$var$_J, i = this.sheenRoughnessNode ? $d7238066c5de7f1c$var$J(this.sheenRoughnessNode) : $d7238066c5de7f1c$var$PJ;
            $d7238066c5de7f1c$var$WC.assign(t), $d7238066c5de7f1c$var$mR.assign(i);
        }
        if (this.useIridescence) {
            const t = this.iridescenceNode ? $d7238066c5de7f1c$var$J(this.iridescenceNode) : $d7238066c5de7f1c$var$OJ, i = this.iridescenceIORNode ? $d7238066c5de7f1c$var$J(this.iridescenceIORNode) : $d7238066c5de7f1c$var$jJ, n = this.iridescenceThicknessNode ? $d7238066c5de7f1c$var$J(this.iridescenceThicknessNode) : $d7238066c5de7f1c$var$qJ;
            $d7238066c5de7f1c$var$AR.assign(t), $d7238066c5de7f1c$var$fL.assign(i), $d7238066c5de7f1c$var$GL.assign(n);
        }
        if (this.useAnisotropy) {
            const t = (this.anisotropyNode ? $d7238066c5de7f1c$var$Ne(this.anisotropyNode) : $d7238066c5de7f1c$var$QJ).toVar();
            $d7238066c5de7f1c$var$Jd.assign(t.length()), $d7238066c5de7f1c$var$Ht($d7238066c5de7f1c$var$Jd.equal(0), ()=>{
                t.assign($d7238066c5de7f1c$var$Ne(1, 0));
            }).Else(()=>{
                t.divAssign($d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$Jd)), $d7238066c5de7f1c$var$Jd.assign($d7238066c5de7f1c$var$Jd.saturate());
            }), $d7238066c5de7f1c$var$VZ.assign($d7238066c5de7f1c$var$Jd.pow2().mix($d7238066c5de7f1c$var$jc.pow2(), 1)), $d7238066c5de7f1c$var$Jy.assign($d7238066c5de7f1c$var$XC[0].mul(t.x).add($d7238066c5de7f1c$var$XC[1].mul(t.y))), $d7238066c5de7f1c$var$FC.assign($d7238066c5de7f1c$var$XC[1].mul(t.x).sub($d7238066c5de7f1c$var$XC[0].mul(t.y)));
        }
        if (this.useTransmission) {
            const t = this.transmissionNode ? $d7238066c5de7f1c$var$J(this.transmissionNode) : $d7238066c5de7f1c$var$$J, i = this.thicknessNode ? $d7238066c5de7f1c$var$J(this.thicknessNode) : $d7238066c5de7f1c$var$eU, n = this.attenuationDistanceNode ? $d7238066c5de7f1c$var$J(this.attenuationDistanceNode) : $d7238066c5de7f1c$var$iU, s = this.attenuationColorNode ? $d7238066c5de7f1c$var$ne(this.attenuationColorNode) : $d7238066c5de7f1c$var$nU;
            if ($d7238066c5de7f1c$var$WZ.assign(t), $d7238066c5de7f1c$var$vL.assign(i), $d7238066c5de7f1c$var$SL.assign(n), $d7238066c5de7f1c$var$ZL.assign(s), this.useDispersion) {
                const a = this.dispersionNode ? $d7238066c5de7f1c$var$J(this.dispersionNode) : $d7238066c5de7f1c$var$lU;
                $d7238066c5de7f1c$var$RL.assign(a);
            }
        }
    }
    /**
   * Setups the clearcoat normal node.
   *
   * @return {Node<vec3>} The clearcoat normal.
   */ setupClearcoatNormal() {
        return this.clearcoatNormalNode ? $d7238066c5de7f1c$var$ne(this.clearcoatNormalNode) : $d7238066c5de7f1c$var$UJ;
    }
    setup(e) {
        e.context.setupClearcoatNormal = ()=>$d7238066c5de7f1c$var$RA(this.setupClearcoatNormal(e), "NORMAL", "vec3"), super.setup(e);
    }
    copy(e) {
        return this.clearcoatNode = e.clearcoatNode, this.clearcoatRoughnessNode = e.clearcoatRoughnessNode, this.clearcoatNormalNode = e.clearcoatNormalNode, this.sheenNode = e.sheenNode, this.sheenRoughnessNode = e.sheenRoughnessNode, this.iridescenceNode = e.iridescenceNode, this.iridescenceIORNode = e.iridescenceIORNode, this.iridescenceThicknessNode = e.iridescenceThicknessNode, this.specularIntensityNode = e.specularIntensityNode, this.specularColorNode = e.specularColorNode, this.transmissionNode = e.transmissionNode, this.thicknessNode = e.thicknessNode, this.attenuationDistanceNode = e.attenuationDistanceNode, this.attenuationColorNode = e.attenuationColorNode, this.dispersionNode = e.dispersionNode, this.anisotropyNode = e.anisotropyNode, super.copy(e);
    }
}
const $d7238066c5de7f1c$var$Zse = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ normal: r, lightDirection: e, builder: t })=>{
    const i = r.dot(e), n = $d7238066c5de7f1c$var$Ne(i.mul(0.5).add(0.5), 0);
    if (t.material.gradientMap) {
        const s = $d7238066c5de7f1c$var$rI("gradientMap", "texture").context({
            getUV: ()=>n
        });
        return $d7238066c5de7f1c$var$ne(s.r);
    } else {
        const s = n.fwidth().mul(0.5);
        return $d7238066c5de7f1c$var$qi($d7238066c5de7f1c$var$ne(0.7), $d7238066c5de7f1c$var$ne(1), $d7238066c5de7f1c$var$ic($d7238066c5de7f1c$var$J(0.7).sub(s.x), $d7238066c5de7f1c$var$J(0.7).add(s.x), n.x));
    }
});
class $d7238066c5de7f1c$var$Rse extends $d7238066c5de7f1c$var$HR {
    /**
   * Implements the direct lighting. Instead of using a conventional smooth irradiance, the irradiance is
   * reduced to a small number of discrete shades to create a comic-like, flat look.
   *
   * @param {Object} lightData - The light data.
   * @param {NodeBuilder} builder - The current node builder.
   */ direct({ lightDirection: e, lightColor: t, reflectedLight: i }, n) {
        const s = $d7238066c5de7f1c$var$Zse({
            normal: $d7238066c5de7f1c$var$SR,
            lightDirection: e,
            builder: n
        }).mul(t);
        i.directDiffuse.addAssign(s.mul($d7238066c5de7f1c$var$JC({
            diffuseColor: $d7238066c5de7f1c$var$Ei.rgb
        })));
    }
    /**
   * Implements the indirect lighting.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ indirect(e) {
        const { ambientOcclusion: t, irradiance: i, reflectedLight: n } = e.context;
        n.indirectDiffuse.addAssign(i.mul($d7238066c5de7f1c$var$JC({
            diffuseColor: $d7238066c5de7f1c$var$Ei
        }))), n.indirectDiffuse.mulAssign(t);
    }
}
const $d7238066c5de7f1c$var$Vse = /* @__PURE__ */ new $d7238066c5de7f1c$var$gee();
class $d7238066c5de7f1c$var$wse extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshToonNodeMaterial";
    }
    /**
   * Constructs a new mesh toon node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshToonNodeMaterial = !0, this.lights = !0, this.setDefaultValues($d7238066c5de7f1c$var$Vse), this.setValues(e);
    }
    /**
   * Setups the lighting model.
   *
   * @return {ToonLightingModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$Rse();
    }
}
const $d7238066c5de7f1c$var$_U = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(()=>{
    const r = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$kn.z, 0, $d7238066c5de7f1c$var$kn.x.negate()).normalize(), e = $d7238066c5de7f1c$var$kn.cross(r);
    return $d7238066c5de7f1c$var$Ne(r.dot($d7238066c5de7f1c$var$gn), e.dot($d7238066c5de7f1c$var$gn)).mul(0.495).add(0.5);
}).once([
    "NORMAL",
    "VERTEX"
])().toVar("matcapUV"), $d7238066c5de7f1c$var$Wse = /* @__PURE__ */ new $d7238066c5de7f1c$var$uee();
class $d7238066c5de7f1c$var$Hse extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "MeshMatcapNodeMaterial";
    }
    /**
   * Constructs a new mesh normal node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isMeshMatcapNodeMaterial = !0, this.setDefaultValues($d7238066c5de7f1c$var$Wse), this.setValues(e);
    }
    /**
   * Setups the matcap specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupVariants(e) {
        const t = $d7238066c5de7f1c$var$_U;
        let i;
        e.material.matcap ? i = $d7238066c5de7f1c$var$rI("matcap", "texture").context({
            getUV: ()=>t
        }) : i = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$qi(0.2, 0.8, t.y)), $d7238066c5de7f1c$var$Ei.rgb.mulAssign(i.rgb);
    }
}
class $d7238066c5de7f1c$var$Xse extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "RotateNode";
    }
    /**
   * Constructs a new rotate node.
   *
   * @param {Node} positionNode - The position node.
   * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
   * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
   */ constructor(e, t){
        super(), this.positionNode = e, this.rotationNode = t;
    }
    /**
   * The type of the {@link RotateNode#positionNode} defines the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node's type.
   */ getNodeType(e) {
        return this.positionNode.getNodeType(e);
    }
    setup(e) {
        const { rotationNode: t, positionNode: i } = this;
        if (this.getNodeType(e) === "vec2") {
            const s = t.cos(), a = t.sin();
            return $d7238066c5de7f1c$var$pR(s, a, a.negate(), s).mul(i);
        } else {
            const s = t, a = $d7238066c5de7f1c$var$xC($d7238066c5de7f1c$var$Rt(1, 0, 0, 0), $d7238066c5de7f1c$var$Rt(0, $d7238066c5de7f1c$var$_c(s.x), $d7238066c5de7f1c$var$Go(s.x).negate(), 0), $d7238066c5de7f1c$var$Rt(0, $d7238066c5de7f1c$var$Go(s.x), $d7238066c5de7f1c$var$_c(s.x), 0), $d7238066c5de7f1c$var$Rt(0, 0, 0, 1)), o = $d7238066c5de7f1c$var$xC($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$_c(s.y), 0, $d7238066c5de7f1c$var$Go(s.y), 0), $d7238066c5de7f1c$var$Rt(0, 1, 0, 0), $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$Go(s.y).negate(), 0, $d7238066c5de7f1c$var$_c(s.y), 0), $d7238066c5de7f1c$var$Rt(0, 0, 0, 1)), g = $d7238066c5de7f1c$var$xC($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$_c(s.z), $d7238066c5de7f1c$var$Go(s.z).negate(), 0, 0), $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$Go(s.z), $d7238066c5de7f1c$var$_c(s.z), 0, 0), $d7238066c5de7f1c$var$Rt(0, 0, 1, 0), $d7238066c5de7f1c$var$Rt(0, 0, 0, 1));
            return a.mul(o).mul(g).mul($d7238066c5de7f1c$var$Rt(i, 1)).xyz;
        }
    }
}
const $d7238066c5de7f1c$var$qB = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Xse).setParameterLength(2), $d7238066c5de7f1c$var$Nse = /* @__PURE__ */ new $d7238066c5de7f1c$var$eee();
class $d7238066c5de7f1c$var$PU extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "SpriteNodeMaterial";
    }
    /**
   * Constructs a new sprite node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isSpriteNodeMaterial = !0, this._useSizeAttenuation = !0, this.positionNode = null, this.rotationNode = null, this.scaleNode = null, this.transparent = !0, this.setDefaultValues($d7238066c5de7f1c$var$Nse), this.setValues(e);
    }
    /**
   * Setups the position node in view space. This method implements
   * the sprite specific vertex shader.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in view space.
   */ setupPositionView(e) {
        const { object: t, camera: i } = e, { positionNode: n, rotationNode: s, scaleNode: a, sizeAttenuation: o } = this, g = $d7238066c5de7f1c$var$qC.mul($d7238066c5de7f1c$var$ne(n || 0));
        let l = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$$g[0].xyz.length(), $d7238066c5de7f1c$var$$g[1].xyz.length());
        a !== null && (l = l.mul($d7238066c5de7f1c$var$Ne(a))), i.isPerspectiveCamera && o === !1 && (l = l.mul(g.z.negate()));
        let c = $d7238066c5de7f1c$var$OB.xy;
        if (t.center && t.center.isVector2 === !0) {
            const A = $d7238066c5de7f1c$var$Ste("center", "vec2", t);
            c = c.sub(A.sub(0.5));
        }
        c = c.mul(l);
        const d = $d7238066c5de7f1c$var$J(s || $d7238066c5de7f1c$var$DJ), p = $d7238066c5de7f1c$var$qB(c, d);
        return $d7238066c5de7f1c$var$Rt(g.xy.add(p), g.zw);
    }
    copy(e) {
        return this.positionNode = e.positionNode, this.rotationNode = e.rotationNode, this.scaleNode = e.scaleNode, super.copy(e);
    }
    /**
   * Whether to use size attenuation or not.
   *
   * @type {boolean}
   * @default true
   */ get sizeAttenuation() {
        return this._useSizeAttenuation;
    }
    set sizeAttenuation(e) {
        this._useSizeAttenuation !== e && (this._useSizeAttenuation = e, this.needsUpdate = !0);
    }
}
const $d7238066c5de7f1c$var$Lse = /* @__PURE__ */ new $d7238066c5de7f1c$var$see(), $d7238066c5de7f1c$var$Yse = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
class $d7238066c5de7f1c$var$Kse extends $d7238066c5de7f1c$var$PU {
    static get type() {
        return "PointsNodeMaterial";
    }
    /**
   * Constructs a new points node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.sizeNode = null, this.isPointsNodeMaterial = !0, this.setDefaultValues($d7238066c5de7f1c$var$Lse), this.setValues(e);
    }
    setupPositionView() {
        const { positionNode: e } = this;
        return $d7238066c5de7f1c$var$qC.mul($d7238066c5de7f1c$var$ne(e || $d7238066c5de7f1c$var$Ns)).xyz;
    }
    setupVertexSprite(e) {
        const { material: t, camera: i } = e, { rotationNode: n, scaleNode: s, sizeNode: a, sizeAttenuation: o } = this;
        let g = super.setupVertex(e);
        if (t.isNodeMaterial !== !0) return g;
        let l = a !== null ? $d7238066c5de7f1c$var$Ne(a) : $d7238066c5de7f1c$var$gU;
        l = l.mul($d7238066c5de7f1c$var$oJ), i.isPerspectiveCamera && o === !0 && (l = l.mul($d7238066c5de7f1c$var$xse.div($d7238066c5de7f1c$var$Ls.z.negate()))), s && s.isNode && (l = l.mul($d7238066c5de7f1c$var$Ne(s)));
        let c = $d7238066c5de7f1c$var$OB.xy;
        if (n && n.isNode) {
            const d = $d7238066c5de7f1c$var$J(n);
            c = $d7238066c5de7f1c$var$qB(c, d);
        }
        return c = c.mul(l), c = c.div($d7238066c5de7f1c$var$eY.div(2)), c = c.mul(g.w), g = g.add($d7238066c5de7f1c$var$Rt(c, 0, 0)), g;
    }
    setupVertex(e) {
        return e.object.isPoints ? super.setupVertex(e) : this.setupVertexSprite(e);
    }
    /**
   * Whether alpha to coverage should be used or not.
   *
   * @type {boolean}
   * @default true
   */ get alphaToCoverage() {
        return this._useAlphaToCoverage;
    }
    set alphaToCoverage(e) {
        this._useAlphaToCoverage !== e && (this._useAlphaToCoverage = e, this.needsUpdate = !0);
    }
}
const $d7238066c5de7f1c$var$xse = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(1).onFrameUpdate(function({ renderer: r }) {
    const e = r.getSize($d7238066c5de7f1c$var$Yse);
    this.value = 0.5 * e.y;
});
class $d7238066c5de7f1c$var$Fse extends $d7238066c5de7f1c$var$HR {
    /**
   * Constructs a new shadow mask model.
   */ constructor(){
        super(), this.shadowNode = $d7238066c5de7f1c$var$J(1).toVar("shadowMask");
    }
    /**
   * Only used to save the shadow mask.
   *
   * @param {Object} input - The input data.
   */ direct({ lightNode: e }) {
        e.shadowNode !== null && this.shadowNode.mulAssign(e.shadowNode);
    }
    /**
   * Uses the shadow mask to produce the final color.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ finish({ context: e }) {
        $d7238066c5de7f1c$var$Ei.a.mulAssign(this.shadowNode.oneMinus()), e.outgoingLight.rgb.assign($d7238066c5de7f1c$var$Ei.rgb);
    }
}
const $d7238066c5de7f1c$var$Tse = /* @__PURE__ */ new $d7238066c5de7f1c$var$ree();
class $d7238066c5de7f1c$var$Mse extends $d7238066c5de7f1c$var$Bs {
    static get type() {
        return "ShadowNodeMaterial";
    }
    /**
   * Constructs a new shadow node material.
   *
   * @param {Object} [parameters] - The configuration parameter.
   */ constructor(e){
        super(), this.isShadowNodeMaterial = !0, this.lights = !0, this.transparent = !0, this.setDefaultValues($d7238066c5de7f1c$var$Tse), this.setValues(e);
    }
    /**
   * Setups the lighting model.
   *
   * @return {ShadowMaskModel} The lighting model.
   */ setupLightingModel() {
        return new $d7238066c5de7f1c$var$Fse();
    }
}
$d7238066c5de7f1c$var$pI("vec3");
$d7238066c5de7f1c$var$pI("vec3");
$d7238066c5de7f1c$var$pI("vec3");
class $d7238066c5de7f1c$var$zse {
    /**
   * Constructs a new animation loop management component.
   *
   * @param {Renderer} renderer - A reference to the main renderer.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */ constructor(e, t, i){
        this.renderer = e, this.nodes = t, this.info = i, this._context = typeof self < "u" ? self : null, this._animationLoop = null, this._requestId = null;
    }
    /**
   * Starts the internal animation loop.
   */ start() {
        const e = (t, i)=>{
            this._requestId = this._context.requestAnimationFrame(e), this.info.autoReset === !0 && this.info.reset(), this.nodes.nodeFrame.update(), this.info.frame = this.nodes.nodeFrame.frameId, this.renderer._inspector.begin(), this._animationLoop !== null && this._animationLoop(t, i), this.renderer._inspector.finish();
        };
        e();
    }
    /**
   * Stops the internal animation loop.
   */ stop() {
        this._context.cancelAnimationFrame(this._requestId), this._requestId = null;
    }
    /**
   * Returns the user-level animation loop.
   *
   * @return {?Function} The animation loop.
   */ getAnimationLoop() {
        return this._animationLoop;
    }
    /**
   * Defines the user-level animation loop.
   *
   * @param {?Function} callback - The animation loop.
   */ setAnimationLoop(e) {
        this._animationLoop = e;
    }
    /**
   * Returns the animation context.
   *
   * @return {Window|XRSession} The animation context.
   */ getContext() {
        return this._context;
    }
    /**
   * Defines the context in which `requestAnimationFrame()` is executed.
   *
   * @param {Window|XRSession} context - The context to set.
   */ setContext(e) {
        this._context = e;
    }
    /**
   * Frees all internal resources and stops the animation loop.
   */ dispose() {
        this.stop();
    }
}
class $d7238066c5de7f1c$var$nc {
    /**
   * Constructs a new Chain Map.
   */ constructor(){
        this.weakMap = /* @__PURE__ */ new WeakMap();
    }
    /**
   * Returns the value for the given array of keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @return {any} The value. Returns `undefined` if no value was found.
   */ get(e) {
        let t = this.weakMap;
        for(let i = 0; i < e.length - 1; i++)if (t = t.get(e[i]), t === void 0) return;
        return t.get(e[e.length - 1]);
    }
    /**
   * Sets the value for the given keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @param {any} value - The value to set.
   * @return {ChainMap} A reference to this Chain Map.
   */ set(e, t) {
        let i = this.weakMap;
        for(let n = 0; n < e.length - 1; n++){
            const s = e[n];
            i.has(s) === !1 && i.set(s, /* @__PURE__ */ new WeakMap()), i = i.get(s);
        }
        return i.set(e[e.length - 1], t), this;
    }
    /**
   * Deletes a value for the given keys.
   *
   * @param {Array<Object>} keys - The keys.
   * @return {boolean} Returns `true` if the value has been removed successfully and `false` if the value has not be found.
   */ delete(e) {
        let t = this.weakMap;
        for(let i = 0; i < e.length - 1; i++)if (t = t.get(e[i]), t === void 0) return !1;
        return t.delete(e[e.length - 1]);
    }
}
let $d7238066c5de7f1c$var$kse = 0;
function $d7238066c5de7f1c$var$Ese(r) {
    const e = Object.keys(r);
    let t = Object.getPrototypeOf(r);
    for(; t;){
        const i = Object.getOwnPropertyDescriptors(t);
        for(const n in i)if (i[n] !== void 0) {
            const s = i[n];
            s && typeof s.get == "function" && e.push(n);
        }
        t = Object.getPrototypeOf(t);
    }
    return e;
}
class $d7238066c5de7f1c$var$Jse {
    /**
   * Constructs a new render object.
   *
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Geometries} geometries - Renderer component for managing geometries.
   * @param {Renderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The 3D object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The lights node.
   * @param {RenderContext} renderContext - The render context.
   * @param {ClippingContext} clippingContext - The clipping context.
   */ constructor(e, t, i, n, s, a, o, g, l, c){
        this.id = $d7238066c5de7f1c$var$kse++, this._nodes = e, this._geometries = t, this.renderer = i, this.object = n, this.material = s, this.scene = a, this.camera = o, this.lightsNode = g, this.context = l, this.geometry = n.geometry, this.version = s.version, this.drawRange = null, this.attributes = null, this.attributesId = null, this.pipeline = null, this.group = null, this.vertexBuffers = null, this.drawParams = null, this.bundle = null, this.clippingContext = c, this.clippingContextCacheKey = c !== null ? c.cacheKey : "", this.initialNodesCacheKey = this.getDynamicCacheKey(), this.initialCacheKey = this.getCacheKey(), this._nodeBuilderState = null, this._bindings = null, this._monitor = null, this.onDispose = null, this.isRenderObject = !0, this.onMaterialDispose = ()=>{
            this.dispose();
        }, this.onGeometryDispose = ()=>{
            this.attributes = null, this.attributesId = null;
        }, this.material.addEventListener("dispose", this.onMaterialDispose), this.geometry.addEventListener("dispose", this.onGeometryDispose);
    }
    /**
   * Updates the clipping context.
   *
   * @param {ClippingContext} context - The clipping context to set.
   */ updateClipping(e) {
        this.clippingContext = e;
    }
    /**
   * Whether the clipping requires an update or not.
   *
   * @type {boolean}
   * @readonly
   */ get clippingNeedsUpdate() {
        return this.clippingContext === null || this.clippingContext.cacheKey === this.clippingContextCacheKey ? !1 : (this.clippingContextCacheKey = this.clippingContext.cacheKey, !0);
    }
    /**
   * The number of clipping planes defined in context of hardware clipping.
   *
   * @type {number}
   * @readonly
   */ get hardwareClippingPlanes() {
        return this.material.hardwareClipping === !0 ? this.clippingContext.unionClippingCount : 0;
    }
    /**
   * Returns the node builder state of this render object.
   *
   * @return {NodeBuilderState} The node builder state.
   */ getNodeBuilderState() {
        return this._nodeBuilderState || (this._nodeBuilderState = this._nodes.getForRender(this));
    }
    /**
   * Returns the node material observer of this render object.
   *
   * @return {NodeMaterialObserver} The node material observer.
   */ getMonitor() {
        return this._monitor || (this._monitor = this.getNodeBuilderState().observer);
    }
    /**
   * Returns an array of bind groups of this render object.
   *
   * @return {Array<BindGroup>} The bindings.
   */ getBindings() {
        return this._bindings || (this._bindings = this.getNodeBuilderState().createBindings());
    }
    /**
   * Returns a binding group by group name of this render object.
   *
   * @param {string} name - The name of the binding group.
   * @return {?BindGroup} The bindings.
   */ getBindingGroup(e) {
        for (const t of this.getBindings())if (t.name === e) return t;
    }
    /**
   * Returns the index of the render object's geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` for non-indexed geometries.
   */ getIndex() {
        return this._geometries.getIndex(this);
    }
    /**
   * Returns the indirect buffer attribute.
   *
   * @return {?BufferAttribute} The indirect attribute. `null` if no indirect drawing is used.
   */ getIndirect() {
        return this._geometries.getIndirect(this);
    }
    /**
   * Returns an array that acts as a key for identifying the render object in a chain map.
   *
   * @return {Array<Object>} An array with object references.
   */ getChainArray() {
        return [
            this.object,
            this.material,
            this.context,
            this.lightsNode
        ];
    }
    /**
   * This method is used when the geometry of a 3D object has been exchanged and the
   * respective render object now requires an update.
   *
   * @param {BufferGeometry} geometry - The geometry to set.
   */ setGeometry(e) {
        this.geometry = e, this.attributes = null, this.attributesId = null;
    }
    /**
   * Returns the buffer attributes of the render object. The returned array holds
   * attribute definitions on geometry and node level.
   *
   * @return {Array<BufferAttribute>} An array with buffer attributes.
   */ getAttributes() {
        if (this.attributes !== null) return this.attributes;
        const e = this.getNodeBuilderState().nodeAttributes, t = this.geometry, i = [], n = /* @__PURE__ */ new Set(), s = {};
        for (const a of e){
            let o;
            if (a.node && a.node.attribute ? o = a.node.attribute : (o = t.getAttribute(a.name), s[a.name] = o.version), o === void 0) continue;
            i.push(o);
            const g = o.isInterleavedBufferAttribute ? o.data : o;
            n.add(g);
        }
        return this.attributes = i, this.attributesId = s, this.vertexBuffers = Array.from(n.values()), i;
    }
    /**
   * Returns the vertex buffers of the render object.
   *
   * @return {Array<BufferAttribute|InterleavedBuffer>} An array with buffer attribute or interleaved buffers.
   */ getVertexBuffers() {
        return this.vertexBuffers === null && this.getAttributes(), this.vertexBuffers;
    }
    /**
   * Returns the draw parameters for the render object.
   *
   * @return {?{vertexCount: number, firstVertex: number, instanceCount: number, firstInstance: number}} The draw parameters.
   */ getDrawParameters() {
        const { object: e, material: t, geometry: i, group: n, drawRange: s } = this, a = this.drawParams || (this.drawParams = {
            vertexCount: 0,
            firstVertex: 0,
            instanceCount: 0,
            firstInstance: 0
        }), o = this.getIndex(), g = o !== null;
        let l = 1;
        if (i.isInstancedBufferGeometry === !0 ? l = i.instanceCount : e.count !== void 0 && (l = Math.max(0, e.count)), l === 0) return null;
        if (a.instanceCount = l, e.isBatchedMesh === !0) return a;
        let c = 1;
        t.wireframe === !0 && !e.isPoints && !e.isLineSegments && !e.isLine && !e.isLineLoop && (c = 2);
        let d = s.start * c, p = (s.start + s.count) * c;
        n !== null && (d = Math.max(d, n.start * c), p = Math.min(p, (n.start + n.count) * c));
        const A = i.attributes.position;
        let y = 1 / 0;
        g ? y = o.count : A != null && (y = A.count), d = Math.max(d, 0), p = Math.min(p, y);
        const G = p - d;
        return G < 0 || G === 1 / 0 ? null : (a.vertexCount = G, a.firstVertex = d, a);
    }
    /**
   * Returns the render object's geometry cache key.
   *
   * The geometry cache key is part of the material cache key.
   *
   * @return {string} The geometry cache key.
   */ getGeometryCacheKey() {
        const { geometry: e } = this;
        let t = "";
        for (const i of Object.keys(e.attributes).sort()){
            const n = e.attributes[i];
            t += i + ",", n.data && (t += n.data.stride + ","), n.offset && (t += n.offset + ","), n.itemSize && (t += n.itemSize + ","), n.normalized && (t += "n,");
        }
        for (const i of Object.keys(e.morphAttributes).sort()){
            const n = e.morphAttributes[i];
            t += "morph-" + i + ",";
            for(let s = 0, a = n.length; s < a; s++){
                const o = n[s];
                t += o.id + ",";
            }
        }
        return e.index && (t += "index,"), t;
    }
    /**
   * Returns the render object's material cache key.
   *
   * The material cache key is part of the render object cache key.
   *
   * @return {number} The material cache key.
   */ getMaterialCacheKey() {
        const { object: e, material: t, renderer: i } = this;
        let n = t.customProgramCacheKey();
        for (const s of $d7238066c5de7f1c$var$Ese(t)){
            if (/^(is[A-Z]|_)|^(visible|version|uuid|name|opacity|userData)$/.test(s)) continue;
            const a = t[s];
            let o;
            if (a !== null) {
                const g = typeof a;
                g === "number" ? o = a !== 0 ? "1" : "0" : g === "object" ? (o = "{", a.isTexture && (o += a.mapping, i.backend.isWebGPUBackend === !0 && (o += a.magFilter, o += a.minFilter, o += a.wrapS, o += a.wrapT, o += a.wrapR)), o += "}") : o = String(a);
            } else o = String(a);
            n += /*property + ':' +*/ o + ",";
        }
        return n += this.clippingContextCacheKey + ",", e.geometry && (n += this.getGeometryCacheKey()), e.skeleton && (n += e.skeleton.bones.length + ","), e.isBatchedMesh && (n += e._matricesTexture.uuid + ",", e._colorsTexture !== null && (n += e._colorsTexture.uuid + ",")), (e.isInstancedMesh || e.count > 1 || Array.isArray(e.morphTargetInfluences)) && (n += e.uuid + ","), n += e.receiveShadow + ",", $d7238066c5de7f1c$var$EB(n);
    }
    /**
   * Whether the geometry requires an update or not.
   *
   * @type {boolean}
   * @readonly
   */ get needsGeometryUpdate() {
        if (this.geometry.id !== this.object.geometry.id) return !0;
        if (this.attributes !== null) {
            const e = this.attributesId;
            for(const t in e){
                const i = this.geometry.getAttribute(t);
                if (i === void 0 || e[t] !== i.id) return !0;
            }
        }
        return !1;
    }
    /**
   * Whether the render object requires an update or not.
   *
   * Note: There are two distinct places where render objects are checked for an update.
   *
   * 1. In `RenderObjects.get()` which is executed when the render object is request. This
   * method checks the `needsUpdate` flag and recreates the render object if necessary.
   * 2. In `Renderer._renderObjectDirect()` right after getting the render object via
   * `RenderObjects.get()`. The render object's NodeMaterialObserver is then used to detect
   * a need for a refresh due to material, geometry or object related value changes.
   *
   * TODO: Investigate if it's possible to merge both steps so there is only a single place
   * that performs the 'needsUpdate' check.
   *
   * @type {boolean}
   * @readonly
   */ get needsUpdate() {
        return /*this.object.static !== true &&*/ this.initialNodesCacheKey !== this.getDynamicCacheKey() || this.clippingNeedsUpdate;
    }
    /**
   * Returns the dynamic cache key which represents a key that is computed per draw command.
   *
   * @return {number} The cache key.
   */ getDynamicCacheKey() {
        let e = 0;
        return this.material.isShadowPassMaterial !== !0 && (e = this._nodes.getCacheKey(this.scene, this.lightsNode)), this.camera.isArrayCamera && (e = $d7238066c5de7f1c$var$ky(e, this.camera.cameras.length)), this.object.receiveShadow && (e = $d7238066c5de7f1c$var$ky(e, 1)), e = $d7238066c5de7f1c$var$ky(e, this.camera.id), e;
    }
    /**
   * Returns the render object's cache key.
   *
   * @return {number} The cache key.
   */ getCacheKey() {
        return this.getMaterialCacheKey() + this.getDynamicCacheKey();
    }
    /**
   * Frees internal resources.
   */ dispose() {
        this.material.removeEventListener("dispose", this.onMaterialDispose), this.geometry.removeEventListener("dispose", this.onGeometryDispose), this.onDispose();
    }
}
const $d7238066c5de7f1c$var$oC = [];
class $d7238066c5de7f1c$var$Use {
    /**
   * Constructs a new render object management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Geometries} geometries - Renderer component for managing geometries.
   * @param {Pipelines} pipelines - Renderer component for managing pipelines.
   * @param {Bindings} bindings - Renderer component for managing bindings.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */ constructor(e, t, i, n, s, a){
        this.renderer = e, this.nodes = t, this.geometries = i, this.pipelines = n, this.bindings = s, this.info = a, this.chainMaps = {};
    }
    /**
   * Returns a render object for the given object and state data.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The 3D object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the 3D object should be rendered with.
   * @param {LightsNode} lightsNode - The lights node.
   * @param {RenderContext} renderContext - The render context.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {string} [passId] - An optional ID for identifying the pass.
   * @return {RenderObject} The render object.
   */ get(e, t, i, n, s, a, o, g) {
        const l = this.getChainMap(g);
        $d7238066c5de7f1c$var$oC[0] = e, $d7238066c5de7f1c$var$oC[1] = t, $d7238066c5de7f1c$var$oC[2] = a, $d7238066c5de7f1c$var$oC[3] = s;
        let c = l.get($d7238066c5de7f1c$var$oC);
        return c === void 0 ? (c = this.createRenderObject(this.nodes, this.geometries, this.renderer, e, t, i, n, s, a, o, g), l.set($d7238066c5de7f1c$var$oC, c)) : (c.updateClipping(o), c.needsGeometryUpdate && c.setGeometry(e.geometry), (c.version !== t.version || c.needsUpdate) && (c.initialCacheKey !== c.getCacheKey() ? (c.dispose(), c = this.get(e, t, i, n, s, a, o, g)) : c.version = t.version)), $d7238066c5de7f1c$var$oC.length = 0, c;
    }
    /**
   * Returns a chain map for the given pass ID.
   *
   * @param {string} [passId='default'] - The pass ID.
   * @return {ChainMap} The chain map.
   */ getChainMap(e = "default") {
        return this.chainMaps[e] || (this.chainMaps[e] = new $d7238066c5de7f1c$var$nc());
    }
    /**
   * Frees internal resources.
   */ dispose() {
        this.chainMaps = {};
    }
    /**
   * Factory method for creating render objects with the given list of parameters.
   *
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Geometries} geometries - Renderer component for managing geometries.
   * @param {Renderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The lights node.
   * @param {RenderContext} renderContext - The render context.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {string} [passId] - An optional ID for identifying the pass.
   * @return {RenderObject} The render object.
   */ createRenderObject(e, t, i, n, s, a, o, g, l, c, d) {
        const p = this.getChainMap(d), A = new $d7238066c5de7f1c$var$Jse(e, t, i, n, s, a, o, g, l, c);
        return A.onDispose = ()=>{
            this.pipelines.delete(A), this.bindings.deleteForRender(A), this.nodes.delete(A), p.delete(A.getChainArray());
        }, A;
    }
}
class $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new data map.
   */ constructor(){
        this.data = /* @__PURE__ */ new WeakMap();
    }
    /**
   * Returns the dictionary for the given object.
   *
   * @param {Object} object - The object.
   * @return {Object} The dictionary.
   */ get(e) {
        let t = this.data.get(e);
        return t === void 0 && (t = {}, this.data.set(e, t)), t;
    }
    /**
   * Deletes the dictionary for the given object.
   *
   * @param {Object} object - The object.
   * @return {?Object} The deleted dictionary.
   */ delete(e) {
        let t = null;
        return this.data.has(e) && (t = this.data.get(e), this.data.delete(e)), t;
    }
    /**
   * Returns `true` if the given object has a dictionary defined.
   *
   * @param {Object} object - The object to test.
   * @return {boolean} Whether a dictionary is defined or not.
   */ has(e) {
        return this.data.has(e);
    }
    /**
   * Frees internal resources.
   */ dispose() {
        this.data = /* @__PURE__ */ new WeakMap();
    }
}
const $d7238066c5de7f1c$var$el = {
    VERTEX: 1,
    INDEX: 2,
    STORAGE: 3,
    INDIRECT: 4
}, $d7238066c5de7f1c$var$Qd = 16, $d7238066c5de7f1c$var$Dse = 211, $d7238066c5de7f1c$var$_se = 212;
class $d7238066c5de7f1c$var$Pse extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new attribute management component.
   *
   * @param {Backend} backend - The renderer's backend.
   */ constructor(e){
        super(), this.backend = e;
    }
    /**
   * Deletes the data for the given attribute.
   *
   * @param {BufferAttribute} attribute - The attribute.
   * @return {?Object} The deleted attribute data.
   */ delete(e) {
        const t = super.delete(e);
        return t !== null && this.backend.destroyAttribute(e), t;
    }
    /**
   * Updates the given attribute. This method creates attribute buffers
   * for new attributes and updates data for existing ones.
   *
   * @param {BufferAttribute} attribute - The attribute to update.
   * @param {number} type - The attribute type.
   */ update(e, t) {
        const i = this.get(e);
        if (i.version === void 0) t === $d7238066c5de7f1c$var$el.VERTEX ? this.backend.createAttribute(e) : t === $d7238066c5de7f1c$var$el.INDEX ? this.backend.createIndexAttribute(e) : t === $d7238066c5de7f1c$var$el.STORAGE ? this.backend.createStorageAttribute(e) : t === $d7238066c5de7f1c$var$el.INDIRECT && this.backend.createIndirectStorageAttribute(e), i.version = this._getBufferAttribute(e).version;
        else {
            const n = this._getBufferAttribute(e);
            (i.version < n.version || n.usage === $d7238066c5de7f1c$var$dA) && (this.backend.updateAttribute(e), i.version = n.version);
        }
    }
    /**
   * Utility method for handling interleaved buffer attributes correctly.
   * To process them, their `InterleavedBuffer` is returned.
   *
   * @param {BufferAttribute} attribute - The attribute.
   * @return {BufferAttribute|InterleavedBuffer}
   */ _getBufferAttribute(e) {
        return e.isInterleavedBufferAttribute && (e = e.data), e;
    }
}
function $d7238066c5de7f1c$var$QU(r) {
    return r.index !== null ? r.index.version : r.attributes.position.version;
}
function $d7238066c5de7f1c$var$y9(r) {
    const e = [], t = r.index, i = r.attributes.position;
    if (t !== null) {
        const s = t.array;
        for(let a = 0, o = s.length; a < o; a += 3){
            const g = s[a + 0], l = s[a + 1], c = s[a + 2];
            e.push(g, l, l, c, c, g);
        }
    } else {
        const s = i.array;
        for(let a = 0, o = s.length / 3 - 1; a < o; a += 3){
            const g = a + 0, l = a + 1, c = a + 2;
            e.push(g, l, l, c, c, g);
        }
    }
    const n = new ($d7238066c5de7f1c$var$a3(e) ? $d7238066c5de7f1c$var$c3 : $d7238066c5de7f1c$var$l3)(e, 1);
    return n.version = $d7238066c5de7f1c$var$QU(r), n;
}
class $d7238066c5de7f1c$var$Qse extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new geometry management component.
   *
   * @param {Attributes} attributes - Renderer component for managing attributes.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */ constructor(e, t){
        super(), this.attributes = e, this.info = t, this.wireframes = /* @__PURE__ */ new WeakMap(), this.attributeCall = /* @__PURE__ */ new WeakMap(), this._geometryDisposeListeners = /* @__PURE__ */ new Map();
    }
    /**
   * Returns `true` if the given render object has an initialized geometry.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether if the given render object has an initialized geometry or not.
   */ has(e) {
        const t = e.geometry;
        return super.has(t) && this.get(t).initialized === !0;
    }
    /**
   * Prepares the geometry of the given render object for rendering.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateForRender(e) {
        this.has(e) === !1 && this.initGeometry(e), this.updateAttributes(e);
    }
    /**
   * Initializes the geometry of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */ initGeometry(e) {
        const t = e.geometry, i = this.get(t);
        i.initialized = !0, this.info.memory.geometries++;
        const n = ()=>{
            this.info.memory.geometries--;
            const s = t.index, a = e.getAttributes();
            s !== null && this.attributes.delete(s);
            for (const g of a)this.attributes.delete(g);
            const o = this.wireframes.get(t);
            o !== void 0 && this.attributes.delete(o), t.removeEventListener("dispose", n), this._geometryDisposeListeners.delete(t);
        };
        t.addEventListener("dispose", n), this._geometryDisposeListeners.set(t, n);
    }
    /**
   * Updates the geometry attributes of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateAttributes(e) {
        const t = e.getAttributes();
        for (const s of t)s.isStorageBufferAttribute || s.isStorageInstancedBufferAttribute ? this.updateAttribute(s, $d7238066c5de7f1c$var$el.STORAGE) : this.updateAttribute(s, $d7238066c5de7f1c$var$el.VERTEX);
        const i = this.getIndex(e);
        i !== null && this.updateAttribute(i, $d7238066c5de7f1c$var$el.INDEX);
        const n = e.geometry.indirect;
        n !== null && this.updateAttribute(n, $d7238066c5de7f1c$var$el.INDIRECT);
    }
    /**
   * Updates the given attribute.
   *
   * @param {BufferAttribute} attribute - The attribute to update.
   * @param {number} type - The attribute type.
   */ updateAttribute(e, t) {
        const i = this.info.render.calls;
        e.isInterleavedBufferAttribute ? this.attributeCall.get(e) === void 0 ? (this.attributes.update(e, t), this.attributeCall.set(e, i)) : this.attributeCall.get(e.data) !== i && (this.attributes.update(e, t), this.attributeCall.set(e.data, i), this.attributeCall.set(e, i)) : this.attributeCall.get(e) !== i && (this.attributes.update(e, t), this.attributeCall.set(e, i));
    }
    /**
   * Returns the indirect buffer attribute of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {?BufferAttribute} The indirect attribute. `null` if no indirect drawing is used.
   */ getIndirect(e) {
        return e.geometry.indirect;
    }
    /**
   * Returns the index of the given render object's geometry. This is implemented
   * in a method to return a wireframe index if necessary.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {?BufferAttribute} The index. Returns `null` for non-indexed geometries.
   */ getIndex(e) {
        const { geometry: t, material: i } = e;
        let n = t.index;
        if (i.wireframe === !0) {
            const s = this.wireframes;
            let a = s.get(t);
            a === void 0 ? (a = $d7238066c5de7f1c$var$y9(t), s.set(t, a)) : a.version !== $d7238066c5de7f1c$var$QU(t) && (this.attributes.delete(a), a = $d7238066c5de7f1c$var$y9(t), s.set(t, a)), n = a;
        }
        return n;
    }
    dispose() {
        for (const [e, t] of this._geometryDisposeListeners.entries())e.removeEventListener("dispose", t);
        this._geometryDisposeListeners.clear();
    }
}
class $d7238066c5de7f1c$var$Ose {
    /**
   * Constructs a new info component.
   */ constructor(){
        this.autoReset = !0, this.frame = 0, this.calls = 0, this.render = {
            calls: 0,
            frameCalls: 0,
            drawCalls: 0,
            triangles: 0,
            points: 0,
            lines: 0,
            timestamp: 0
        }, this.compute = {
            calls: 0,
            frameCalls: 0,
            timestamp: 0
        }, this.memory = {
            geometries: 0,
            textures: 0
        };
    }
    /**
   * This method should be executed per draw call and updates the corresponding metrics.
   *
   * @param {Object3D} object - The 3D object that is going to be rendered.
   * @param {number} count - The vertex or index count.
   * @param {number} instanceCount - The instance count.
   */ update(e, t, i) {
        this.render.drawCalls++, e.isMesh || e.isSprite ? this.render.triangles += i * (t / 3) : e.isPoints ? this.render.points += i * t : e.isLineSegments ? this.render.lines += i * (t / 2) : e.isLine ? this.render.lines += i * (t - 1) : $d7238066c5de7f1c$var$nt("WebGPUInfo: Unknown object type.");
    }
    /**
   * Resets frame related metrics.
   */ reset() {
        this.render.drawCalls = 0, this.render.frameCalls = 0, this.compute.frameCalls = 0, this.render.triangles = 0, this.render.points = 0, this.render.lines = 0;
    }
    /**
   * Performs a complete reset of the object.
   */ dispose() {
        this.reset(), this.calls = 0, this.render.calls = 0, this.compute.calls = 0, this.render.timestamp = 0, this.compute.timestamp = 0, this.memory.geometries = 0, this.memory.textures = 0;
    }
}
class $d7238066c5de7f1c$var$OU {
    /**
   * Constructs a new pipeline.
   *
   * @param {string} cacheKey - The pipeline's cache key.
   */ constructor(e){
        this.cacheKey = e, this.usedTimes = 0;
    }
}
class $d7238066c5de7f1c$var$jse extends $d7238066c5de7f1c$var$OU {
    /**
   * Constructs a new render pipeline.
   *
   * @param {string} cacheKey - The pipeline's cache key.
   * @param {ProgrammableStage} vertexProgram - The pipeline's vertex shader.
   * @param {ProgrammableStage} fragmentProgram - The pipeline's fragment shader.
   */ constructor(e, t, i){
        super(e), this.vertexProgram = t, this.fragmentProgram = i;
    }
}
class $d7238066c5de7f1c$var$qse extends $d7238066c5de7f1c$var$OU {
    /**
   * Constructs a new render pipeline.
   *
   * @param {string} cacheKey - The pipeline's cache key.
   * @param {ProgrammableStage} computeProgram - The pipeline's compute shader.
   */ constructor(e, t){
        super(e), this.computeProgram = t, this.isComputePipeline = !0;
    }
}
let $d7238066c5de7f1c$var$$se = 0;
class $d7238066c5de7f1c$var$GH {
    /**
   * Constructs a new programmable stage.
   *
   * @param {string} code - The shader code.
   * @param {('vertex'|'fragment'|'compute')} stage - The type of stage.
   * @param {string} name - The name of the shader.
   * @param {?Array<Object>} [transforms=null] - The transforms (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
   * @param {?Array<Object>} [attributes=null] - The attributes (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
   */ constructor(e, t, i, n = null, s = null){
        this.id = $d7238066c5de7f1c$var$$se++, this.code = e, this.stage = t, this.name = i, this.transforms = n, this.attributes = s, this.usedTimes = 0;
    }
}
class $d7238066c5de7f1c$var$ere extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new pipeline management component.
   *
   * @param {Backend} backend - The renderer's backend.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   */ constructor(e, t){
        super(), this.backend = e, this.nodes = t, this.bindings = null, this.caches = /* @__PURE__ */ new Map(), this.programs = {
            vertex: /* @__PURE__ */ new Map(),
            fragment: /* @__PURE__ */ new Map(),
            compute: /* @__PURE__ */ new Map()
        };
    }
    /**
   * Returns a compute pipeline for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @return {ComputePipeline} The compute pipeline.
   */ getForCompute(e, t) {
        const { backend: i } = this, n = this.get(e);
        if (this._needsComputeUpdate(e)) {
            const s = n.pipeline;
            s && (s.usedTimes--, s.computeProgram.usedTimes--);
            const a = this.nodes.getForCompute(e);
            let o = this.programs.compute.get(a.computeShader);
            o === void 0 && (s && s.computeProgram.usedTimes === 0 && this._releaseProgram(s.computeProgram), o = new $d7238066c5de7f1c$var$GH(a.computeShader, "compute", e.name, a.transforms, a.nodeAttributes), this.programs.compute.set(a.computeShader, o), i.createProgram(o));
            const g = this._getComputeCacheKey(e, o);
            let l = this.caches.get(g);
            l === void 0 && (s && s.usedTimes === 0 && this._releasePipeline(s), l = this._getComputePipeline(e, o, g, t)), l.usedTimes++, o.usedTimes++, n.version = e.version, n.pipeline = l;
        }
        return n.pipeline;
    }
    /**
   * Returns a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {?Array<Promise>} [promises=null] - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
   * @return {RenderPipeline} The render pipeline.
   */ getForRender(e, t = null) {
        const { backend: i } = this, n = this.get(e);
        if (this._needsRenderUpdate(e)) {
            const s = n.pipeline;
            s && (s.usedTimes--, s.vertexProgram.usedTimes--, s.fragmentProgram.usedTimes--);
            const a = e.getNodeBuilderState(), o = e.material ? e.material.name : "";
            let g = this.programs.vertex.get(a.vertexShader);
            g === void 0 && (s && s.vertexProgram.usedTimes === 0 && this._releaseProgram(s.vertexProgram), g = new $d7238066c5de7f1c$var$GH(a.vertexShader, "vertex", o), this.programs.vertex.set(a.vertexShader, g), i.createProgram(g));
            let l = this.programs.fragment.get(a.fragmentShader);
            l === void 0 && (s && s.fragmentProgram.usedTimes === 0 && this._releaseProgram(s.fragmentProgram), l = new $d7238066c5de7f1c$var$GH(a.fragmentShader, "fragment", o), this.programs.fragment.set(a.fragmentShader, l), i.createProgram(l));
            const c = this._getRenderCacheKey(e, g, l);
            let d = this.caches.get(c);
            d === void 0 ? (s && s.usedTimes === 0 && this._releasePipeline(s), d = this._getRenderPipeline(e, g, l, c, t)) : e.pipeline = d, d.usedTimes++, g.usedTimes++, l.usedTimes++, n.pipeline = d;
        }
        return n.pipeline;
    }
    /**
   * Deletes the pipeline for the given render object.
   *
   * @param {RenderObject} object - The render object.
   * @return {?Object} The deleted dictionary.
   */ delete(e) {
        const t = this.get(e).pipeline;
        return t && (t.usedTimes--, t.usedTimes === 0 && this._releasePipeline(t), t.isComputePipeline ? (t.computeProgram.usedTimes--, t.computeProgram.usedTimes === 0 && this._releaseProgram(t.computeProgram)) : (t.fragmentProgram.usedTimes--, t.vertexProgram.usedTimes--, t.vertexProgram.usedTimes === 0 && this._releaseProgram(t.vertexProgram), t.fragmentProgram.usedTimes === 0 && this._releaseProgram(t.fragmentProgram))), super.delete(e);
    }
    /**
   * Frees internal resources.
   */ dispose() {
        super.dispose(), this.caches = /* @__PURE__ */ new Map(), this.programs = {
            vertex: /* @__PURE__ */ new Map(),
            fragment: /* @__PURE__ */ new Map(),
            compute: /* @__PURE__ */ new Map()
        };
    }
    /**
   * Updates the pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateForRender(e) {
        this.getForRender(e);
    }
    /**
   * Returns a compute pipeline for the given parameters.
   *
   * @private
   * @param {Node} computeNode - The compute node.
   * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
   * @param {string} cacheKey - The cache key.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @return {ComputePipeline} The compute pipeline.
   */ _getComputePipeline(e, t, i, n) {
        i = i || this._getComputeCacheKey(e, t);
        let s = this.caches.get(i);
        return s === void 0 && (s = new $d7238066c5de7f1c$var$qse(i, t), this.caches.set(i, s), this.backend.createComputePipeline(s, n)), s;
    }
    /**
   * Returns a render pipeline for the given parameters.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
   * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
   * @param {string} cacheKey - The cache key.
   * @param {?Array<Promise>} promises - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
   * @return {ComputePipeline} The compute pipeline.
   */ _getRenderPipeline(e, t, i, n, s) {
        n = n || this._getRenderCacheKey(e, t, i);
        let a = this.caches.get(n);
        return a === void 0 && (a = new $d7238066c5de7f1c$var$jse(n, t, i), this.caches.set(n, a), e.pipeline = a, this.backend.createRenderPipeline(e, s)), a;
    }
    /**
   * Computes a cache key representing a compute pipeline.
   *
   * @private
   * @param {Node} computeNode - The compute node.
   * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
   * @return {string} The cache key.
   */ _getComputeCacheKey(e, t) {
        return e.id + "," + t.id;
    }
    /**
   * Computes a cache key representing a render pipeline.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
   * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
   * @return {string} The cache key.
   */ _getRenderCacheKey(e, t, i) {
        return t.id + "," + i.id + "," + this.backend.getRenderCacheKey(e);
    }
    /**
   * Releases the given pipeline.
   *
   * @private
   * @param {Pipeline} pipeline - The pipeline to release.
   */ _releasePipeline(e) {
        this.caches.delete(e.cacheKey);
    }
    /**
   * Releases the shader program.
   *
   * @private
   * @param {Object} program - The shader program to release.
   */ _releaseProgram(e) {
        const t = e.code, i = e.stage;
        this.programs[i].delete(t);
    }
    /**
   * Returns `true` if the compute pipeline for the given compute node requires an update.
   *
   * @private
   * @param {Node} computeNode - The compute node.
   * @return {boolean} Whether the compute pipeline for the given compute node requires an update or not.
   */ _needsComputeUpdate(e) {
        const t = this.get(e);
        return t.pipeline === void 0 || t.version !== e.version;
    }
    /**
   * Returns `true` if the render pipeline for the given render object requires an update.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the render object for the given render object requires an update or not.
   */ _needsRenderUpdate(e) {
        return this.get(e).pipeline === void 0 || this.backend.needsRenderUpdate(e);
    }
}
class $d7238066c5de7f1c$var$tre extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new bindings management component.
   *
   * @param {Backend} backend - The renderer's backend.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Textures} textures - Renderer component for managing textures.
   * @param {Attributes} attributes - Renderer component for managing attributes.
   * @param {Pipelines} pipelines - Renderer component for managing pipelines.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */ constructor(e, t, i, n, s, a){
        super(), this.backend = e, this.textures = i, this.pipelines = s, this.attributes = n, this.nodes = t, this.info = a, this.pipelines.bindings = this;
    }
    /**
   * Returns the bind groups for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Array<BindGroup>} The bind groups.
   */ getForRender(e) {
        const t = e.getBindings();
        for (const i of t){
            const n = this.get(i);
            n.bindGroup === void 0 && (this._init(i), this.backend.createBindings(i, t, 0), n.bindGroup = i);
        }
        return t;
    }
    /**
   * Returns the bind groups for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   * @return {Array<BindGroup>} The bind groups.
   */ getForCompute(e) {
        const t = this.nodes.getForCompute(e).bindings;
        for (const i of t){
            const n = this.get(i);
            n.bindGroup === void 0 && (this._init(i), this.backend.createBindings(i, t, 0), n.bindGroup = i);
        }
        return t;
    }
    /**
   * Updates the bindings for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   */ updateForCompute(e) {
        this._updateBindings(this.getForCompute(e));
    }
    /**
   * Updates the bindings for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateForRender(e) {
        this._updateBindings(this.getForRender(e));
    }
    /**
   * Deletes the bindings for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   */ deleteForCompute(e) {
        const t = this.nodes.getForCompute(e).bindings;
        for (const i of t)this.delete(i);
    }
    /**
   * Deletes the bindings for the given renderObject node.
   *
   * @param {RenderObject} renderObject - The renderObject.
   */ deleteForRender(e) {
        const t = e.getBindings();
        for (const i of t)this.delete(i);
    }
    /**
   * Updates the given array of bindings.
   *
   * @param {Array<BindGroup>} bindings - The bind groups.
   */ _updateBindings(e) {
        for (const t of e)this._update(t, e);
    }
    /**
   * Initializes the given bind group.
   *
   * @param {BindGroup} bindGroup - The bind group to initialize.
   */ _init(e) {
        for (const t of e.bindings)if (t.isSampledTexture) this.textures.updateTexture(t.texture);
        else if (t.isSampler) this.textures.updateSampler(t.texture);
        else if (t.isStorageBuffer) {
            const i = t.attribute, n = i.isIndirectStorageBufferAttribute ? $d7238066c5de7f1c$var$el.INDIRECT : $d7238066c5de7f1c$var$el.STORAGE;
            this.attributes.update(i, n);
        }
    }
    /**
   * Updates the given bind group.
   *
   * @param {BindGroup} bindGroup - The bind group to update.
   * @param {Array<BindGroup>} bindings - The bind groups.
   */ _update(e, t) {
        const { backend: i } = this;
        let n = !1, s = !0, a = 0, o = 0;
        for (const g of e.bindings)if (!(g.isNodeUniformsGroup && this.nodes.updateGroup(g) === !1)) {
            if (g.isStorageBuffer) {
                const l = g.attribute, c = l.isIndirectStorageBufferAttribute ? $d7238066c5de7f1c$var$el.INDIRECT : $d7238066c5de7f1c$var$el.STORAGE;
                this.attributes.update(l, c);
            }
            if (g.isUniformBuffer) g.update() && i.updateBinding(g);
            else if (g.isSampledTexture) {
                const l = g.update(), c = g.texture, d = this.textures.get(c);
                if (l && (this.textures.updateTexture(c), g.generation !== d.generation && (g.generation = d.generation, n = !0, s = !1)), i.get(c).externalTexture !== void 0 || d.isDefaultTexture ? s = !1 : (a = a * 10 + c.id, o += c.version), c.isStorageTexture === !0 && c.mipmapsAutoUpdate === !0) {
                    const A = this.get(c);
                    g.store === !0 ? A.needsMipmap = !0 : this.textures.needsMipmaps(c) && A.needsMipmap === !0 && (this.backend.generateMipmaps(c), A.needsMipmap = !1);
                }
            } else if (g.isSampler && g.update()) {
                const c = this.textures.updateSampler(g.texture);
                g.samplerKey !== c && (g.samplerKey = c, n = !0, s = !1);
            }
        }
        n === !0 && this.backend.updateBindings(e, t, s ? a : 0, o);
    }
}
function $d7238066c5de7f1c$var$ire(r, e) {
    return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.z !== e.z ? r.z - e.z : r.id - e.id;
}
function $d7238066c5de7f1c$var$B9(r, e) {
    return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.z !== e.z ? e.z - r.z : r.id - e.id;
}
function $d7238066c5de7f1c$var$f9(r) {
    return (r.transmission > 0 || r.transmissionNode && r.transmissionNode.isNode) && r.side === $d7238066c5de7f1c$var$YC && r.forceSinglePass === !1;
}
class $d7238066c5de7f1c$var$nre {
    /**
   * Constructs a render list.
   *
   * @param {Lighting} lighting - The lighting management component.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera the scene is rendered with.
   */ constructor(e, t, i){
        this.renderItems = [], this.renderItemsIndex = 0, this.opaque = [], this.transparentDoublePass = [], this.transparent = [], this.bundles = [], this.lightsNode = e.getNode(t, i), this.lightsArray = [], this.scene = t, this.camera = i, this.occlusionQueryCount = 0;
    }
    /**
   * This method is called right at the beginning of a render call
   * before the scene is analyzed. It prepares the internal data
   * structures for the upcoming render lists generation.
   *
   * @return {RenderList} A reference to this render list.
   */ begin() {
        return this.renderItemsIndex = 0, this.opaque.length = 0, this.transparentDoublePass.length = 0, this.transparent.length = 0, this.bundles.length = 0, this.lightsArray.length = 0, this.occlusionQueryCount = 0, this;
    }
    /**
   * Returns a render item for the giving render item state. The state is defined
   * by a series of object-related parameters.
   *
   * The method avoids object creation by holding render items and reusing them in
   * subsequent render calls (just with different property values).
   *
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {number} groupOrder - The current group order.
   * @param {number} z - Th 3D object's depth value (z value in clip space).
   * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The current clipping context.
   * @return {Object} The render item.
   */ getNextRenderItem(e, t, i, n, s, a, o) {
        let g = this.renderItems[this.renderItemsIndex];
        return g === void 0 ? (g = {
            id: e.id,
            object: e,
            geometry: t,
            material: i,
            groupOrder: n,
            renderOrder: e.renderOrder,
            z: s,
            group: a,
            clippingContext: o
        }, this.renderItems[this.renderItemsIndex] = g) : (g.id = e.id, g.object = e, g.geometry = t, g.material = i, g.groupOrder = n, g.renderOrder = e.renderOrder, g.z = s, g.group = a, g.clippingContext = o), this.renderItemsIndex++, g;
    }
    /**
   * Pushes the given object as a render item to the internal render lists.
   * The selected lists depend on the object properties.
   *
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {number} groupOrder - The current group order.
   * @param {number} z - Th 3D object's depth value (z value in clip space).
   * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The current clipping context.
   */ push(e, t, i, n, s, a, o) {
        const g = this.getNextRenderItem(e, t, i, n, s, a, o);
        e.occlusionTest === !0 && this.occlusionQueryCount++, i.transparent === !0 || i.transmission > 0 || i.transmissionNode && i.transmissionNode.isNode || i.backdropNode && i.backdropNode.isNode ? ($d7238066c5de7f1c$var$f9(i) && this.transparentDoublePass.push(g), this.transparent.push(g)) : this.opaque.push(g);
    }
    /**
   * Inserts the given object as a render item at the start of the internal render lists.
   * The selected lists depend on the object properties.
   *
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {number} groupOrder - The current group order.
   * @param {number} z - Th 3D object's depth value (z value in clip space).
   * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The current clipping context.
   */ unshift(e, t, i, n, s, a, o) {
        const g = this.getNextRenderItem(e, t, i, n, s, a, o);
        i.transparent === !0 || i.transmission > 0 || i.transmissionNode && i.transmissionNode.isNode || i.backdropNode && i.backdropNode.isNode ? ($d7238066c5de7f1c$var$f9(i) && this.transparentDoublePass.unshift(g), this.transparent.unshift(g)) : this.opaque.unshift(g);
    }
    /**
   * Pushes render bundle group data into the render list.
   *
   * @param {Object} group - Bundle group data.
   */ pushBundle(e) {
        this.bundles.push(e);
    }
    /**
   * Pushes a light into the render list.
   *
   * @param {Light} light - The light.
   */ pushLight(e) {
        this.lightsArray.push(e);
    }
    /**
   * Sorts the internal render lists.
   *
   * @param {?function(any, any): number} customOpaqueSort - A custom sort function for opaque objects.
   * @param {?function(any, any): number} customTransparentSort -  A custom sort function for transparent objects.
   */ sort(e, t) {
        this.opaque.length > 1 && this.opaque.sort(e || $d7238066c5de7f1c$var$ire), this.transparentDoublePass.length > 1 && this.transparentDoublePass.sort(t || $d7238066c5de7f1c$var$B9), this.transparent.length > 1 && this.transparent.sort(t || $d7238066c5de7f1c$var$B9);
    }
    /**
   * This method performs finalizing tasks right after the render lists
   * have been generated.
   */ finish() {
        this.lightsNode.setLights(this.lightsArray);
        for(let e = this.renderItemsIndex, t = this.renderItems.length; e < t; e++){
            const i = this.renderItems[e];
            if (i.id === null) break;
            i.id = null, i.object = null, i.geometry = null, i.material = null, i.groupOrder = null, i.renderOrder = null, i.z = null, i.group = null, i.clippingContext = null;
        }
    }
}
const $d7238066c5de7f1c$var$Fb = [];
class $d7238066c5de7f1c$var$sre {
    /**
   * Constructs a render lists management component.
   *
   * @param {Lighting} lighting - The lighting management component.
   */ constructor(e){
        this.lighting = e, this.lists = new $d7238066c5de7f1c$var$nc();
    }
    /**
   * Returns a render list for the given scene and camera.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera.
   * @return {RenderList} The render list.
   */ get(e, t) {
        const i = this.lists;
        $d7238066c5de7f1c$var$Fb[0] = e, $d7238066c5de7f1c$var$Fb[1] = t;
        let n = i.get($d7238066c5de7f1c$var$Fb);
        return n === void 0 && (n = new $d7238066c5de7f1c$var$nre(this.lighting, e, t), i.set($d7238066c5de7f1c$var$Fb, n)), $d7238066c5de7f1c$var$Fb.length = 0, n;
    }
    /**
   * Frees all internal resources.
   */ dispose() {
        this.lists = new $d7238066c5de7f1c$var$nc();
    }
}
let $d7238066c5de7f1c$var$rre = 0;
class $d7238066c5de7f1c$var$are {
    /**
   * Constructs a new render context.
   */ constructor(){
        this.id = $d7238066c5de7f1c$var$rre++, this.color = !0, this.clearColor = !0, this.clearColorValue = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, this.depth = !0, this.clearDepth = !0, this.clearDepthValue = 1, this.stencil = !1, this.clearStencil = !0, this.clearStencilValue = 1, this.viewport = !1, this.viewportValue = new $d7238066c5de7f1c$var$Gi(), this.scissor = !1, this.scissorValue = new $d7238066c5de7f1c$var$Gi(), this.renderTarget = null, this.textures = null, this.depthTexture = null, this.activeCubeFace = 0, this.activeMipmapLevel = 0, this.sampleCount = 1, this.width = 0, this.height = 0, this.occlusionQueryCount = 0, this.clippingContext = null, this.isRenderContext = !0;
    }
    /**
   * Returns the cache key of this render context.
   *
   * @return {number} The cache key.
   */ getCacheKey() {
        return $d7238066c5de7f1c$var$jU(this);
    }
}
function $d7238066c5de7f1c$var$jU(r) {
    const { textures: e, activeCubeFace: t, activeMipmapLevel: i } = r, n = [
        t,
        i
    ];
    for (const s of e)n.push(s.id);
    return $d7238066c5de7f1c$var$i0(n);
}
const $d7238066c5de7f1c$var$Tb = [], $d7238066c5de7f1c$var$ore = /* @__PURE__ */ new $d7238066c5de7f1c$var$iL(), $d7238066c5de7f1c$var$gre = /* @__PURE__ */ new $d7238066c5de7f1c$var$tL();
class $d7238066c5de7f1c$var$lre {
    /**
   * Constructs a new render context management component.
   */ constructor(){
        this.chainMaps = {};
    }
    /**
   * Returns a render context for the given scene, camera and render target.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {?RenderTarget} [renderTarget=null] - The active render target.
   * @return {RenderContext} The render context.
   */ get(e, t, i = null) {
        $d7238066c5de7f1c$var$Tb[0] = e, $d7238066c5de7f1c$var$Tb[1] = t;
        let n;
        if (i === null) n = "default";
        else {
            const o = i.texture.format;
            n = `${i.textures.length}:${o}:${i.samples}:${i.depthBuffer}:${i.stencilBuffer}`;
        }
        const s = this._getChainMap(n);
        let a = s.get($d7238066c5de7f1c$var$Tb);
        return a === void 0 && (a = new $d7238066c5de7f1c$var$are(), s.set($d7238066c5de7f1c$var$Tb, a)), $d7238066c5de7f1c$var$Tb.length = 0, i !== null && (a.sampleCount = i.samples === 0 ? 1 : i.samples), a;
    }
    /**
   * Returns a render context intended for clear operations.
   *
   * @param {?RenderTarget} [renderTarget=null] - The active render target.
   * @return {RenderContext} The render context.
   */ getForClear(e = null) {
        return this.get($d7238066c5de7f1c$var$ore, $d7238066c5de7f1c$var$gre, e);
    }
    /**
   * Returns a chain map for the given attachment state.
   *
   * @private
   * @param {string} attachmentState - The attachment state.
   * @return {ChainMap} The chain map.
   */ _getChainMap(e) {
        return this.chainMaps[e] || (this.chainMaps[e] = new $d7238066c5de7f1c$var$nc());
    }
    /**
   * Frees internal resources.
   */ dispose() {
        this.chainMaps = {};
    }
}
const $d7238066c5de7f1c$var$cre = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$ure extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new texture management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Backend} backend - The renderer's backend.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */ constructor(e, t, i){
        super(), this.renderer = e, this.backend = t, this.info = i;
    }
    /**
   * Updates the given render target. Based on the given render target configuration,
   * it updates the texture states representing the attachments of the framebuffer.
   *
   * @param {RenderTarget} renderTarget - The render target to update.
   * @param {number} [activeMipmapLevel=0] - The active mipmap level.
   */ updateRenderTarget(e, t = 0) {
        const i = this.get(e), n = e.samples === 0 ? 1 : e.samples, s = i.depthTextureMips || (i.depthTextureMips = {}), a = e.textures, o = this.getSize(a[0]), g = o.width >> t, l = o.height >> t;
        let c = e.depthTexture || s[t];
        const d = e.depthBuffer === !0 || e.stencilBuffer === !0;
        let p = !1;
        c === void 0 && d && (c = new $d7238066c5de7f1c$var$$l(), c.format = e.stencilBuffer ? $d7238066c5de7f1c$var$dI : $d7238066c5de7f1c$var$nu, c.type = e.stencilBuffer ? $d7238066c5de7f1c$var$sh : $d7238066c5de7f1c$var$Xs, c.image.width = g, c.image.height = l, c.image.depth = o.depth, c.renderTarget = e, c.isArrayTexture = e.multiview === !0 && o.depth > 1, s[t] = c), (i.width !== o.width || o.height !== i.height) && (p = !0, c && (c.needsUpdate = !0, c.image.width = g, c.image.height = l, c.image.depth = c.isArrayTexture ? c.image.depth : 1)), i.width = o.width, i.height = o.height, i.textures = a, i.depthTexture = c || null, i.depth = e.depthBuffer, i.stencil = e.stencilBuffer, i.renderTarget = e, i.sampleCount !== n && (p = !0, c && (c.needsUpdate = !0), i.sampleCount = n);
        const A = {
            sampleCount: n
        };
        if (e.isXRRenderTarget !== !0) {
            for(let y = 0; y < a.length; y++){
                const G = a[y];
                p && (G.needsUpdate = !0), this.updateTexture(G, A);
            }
            c && this.updateTexture(c, A);
        }
        i.initialized !== !0 && (i.initialized = !0, i.onDispose = ()=>{
            this._destroyRenderTarget(e);
        }, e.addEventListener("dispose", i.onDispose));
    }
    /**
   * Updates the given texture. Depending on the texture state, this method
   * triggers the upload of texture data to the GPU memory. If the texture data are
   * not yet ready for the upload, it uses default texture data for as a placeholder.
   *
   * @param {Texture} texture - The texture to update.
   * @param {Object} [options={}] - The options.
   */ updateTexture(e, t = {}) {
        const i = this.get(e);
        if (i.initialized === !0 && i.version === e.version) return;
        const n = e.isRenderTargetTexture || e.isDepthTexture || e.isFramebufferTexture, s = this.backend;
        if (n && i.initialized === !0 && s.destroyTexture(e), e.isFramebufferTexture) {
            const l = this.renderer.getRenderTarget();
            l ? e.type = l.texture.type : e.type = $d7238066c5de7f1c$var$Ya;
        }
        const { width: a, height: o, depth: g } = this.getSize(e);
        if (t.width = a, t.height = o, t.depth = g, t.needsMipmaps = this.needsMipmaps(e), t.levels = t.needsMipmaps ? this.getMipLevels(e, a, o) : 1, e.isCubeTexture && e.mipmaps.length > 0 && t.levels++, n || e.isStorageTexture === !0 || e.isExternalTexture === !0) s.createTexture(e, t), i.generation = e.version;
        else if (e.version > 0) {
            const l = e.image;
            if (l === void 0) $d7238066c5de7f1c$var$ze("Renderer: Texture marked for update but image is undefined.");
            else if (l.complete === !1) $d7238066c5de7f1c$var$ze("Renderer: Texture marked for update but image is incomplete.");
            else {
                if (e.images) {
                    const d = [];
                    for (const p of e.images)d.push(p);
                    t.images = d;
                } else t.image = l;
                (i.isDefaultTexture === void 0 || i.isDefaultTexture === !0) && (s.createTexture(e, t), i.isDefaultTexture = !1, i.generation = e.version), e.source.dataReady === !0 && s.updateTexture(e, t);
                const c = e.isStorageTexture === !0 && e.mipmapsAutoUpdate === !1;
                t.needsMipmaps && e.mipmaps.length === 0 && !c && s.generateMipmaps(e), e.onUpdate && e.onUpdate(e);
            }
        } else s.createDefaultTexture(e), i.isDefaultTexture = !0, i.generation = e.version;
        i.initialized !== !0 && (i.initialized = !0, i.generation = e.version, this.info.memory.textures++, e.isVideoTexture && $d7238066c5de7f1c$var$sn.getTransfer(e.colorSpace) !== $d7238066c5de7f1c$var$Qt && $d7238066c5de7f1c$var$ze("WebGPURenderer: Video textures must use a color space with a sRGB transfer function, e.g. SRGBColorSpace."), i.onDispose = ()=>{
            this._destroyTexture(e);
        }, e.addEventListener("dispose", i.onDispose)), i.version = e.version;
    }
    /**
   * Updates the sampler for the given texture. This method has no effect
   * for the WebGL backend since it has no concept of samplers. Texture
   * parameters are configured with the `texParameter()` command for each
   * texture.
   *
   * In WebGPU, samplers are objects like textures and it's possible to share
   * them when the texture parameters match.
   *
   * @param {Texture} texture - The texture to update the sampler for.
   * @return {string} The current sampler key.
   */ updateSampler(e) {
        return this.backend.updateSampler(e);
    }
    /**
   * Computes the size of the given texture and writes the result
   * into the target vector. This vector is also returned by the
   * method.
   *
   * If no texture data are available for the compute yet, the method
   * returns default size values.
   *
   * @param {Texture} texture - The texture to compute the size for.
   * @param {Vector3} target - The target vector.
   * @return {Vector3} The target vector.
   */ getSize(e, t = $d7238066c5de7f1c$var$cre) {
        let i = e.images ? e.images[0] : e.image;
        return i ? (i.image !== void 0 && (i = i.image), typeof HTMLVideoElement < "u" && i instanceof HTMLVideoElement ? (t.width = i.videoWidth || 1, t.height = i.videoHeight || 1, t.depth = 1) : typeof VideoFrame < "u" && i instanceof VideoFrame ? (t.width = i.displayWidth || 1, t.height = i.displayHeight || 1, t.depth = 1) : (t.width = i.width || 1, t.height = i.height || 1, t.depth = e.isCubeTexture ? 6 : i.depth || 1)) : t.width = t.height = t.depth = 1, t;
    }
    /**
   * Computes the number of mipmap levels for the given texture.
   *
   * @param {Texture} texture - The texture.
   * @param {number} width - The texture's width.
   * @param {number} height - The texture's height.
   * @return {number} The number of mipmap levels.
   */ getMipLevels(e, t, i) {
        let n;
        return e.mipmaps.length > 0 ? n = e.mipmaps.length : e.isCompressedTexture === !0 ? n = 1 : n = Math.floor(Math.log2(Math.max(t, i))) + 1, n;
    }
    /**
   * Returns `true` if the given texture makes use of mipmapping.
   *
   * @param {Texture} texture - The texture.
   * @return {boolean} Whether mipmaps are required or not.
   */ needsMipmaps(e) {
        return e.generateMipmaps === !0 || e.mipmaps.length > 0;
    }
    /**
   * Frees internal resources when the given render target isn't
   * required anymore.
   *
   * @param {RenderTarget} renderTarget - The render target to destroy.
   */ _destroyRenderTarget(e) {
        if (this.has(e) === !0) {
            const t = this.get(e), i = t.textures, n = t.depthTexture;
            e.removeEventListener("dispose", t.onDispose);
            for(let s = 0; s < i.length; s++)this._destroyTexture(i[s]);
            n && this._destroyTexture(n), this.delete(e), this.backend.delete(e);
        }
    }
    /**
   * Frees internal resource when the given texture isn't
   * required anymore.
   *
   * @param {Texture} texture - The texture to destroy.
   */ _destroyTexture(e) {
        if (this.has(e) === !0) {
            const t = this.get(e);
            e.removeEventListener("dispose", t.onDispose);
            const i = t.isDefaultTexture;
            this.backend.destroyTexture(e, i), this.delete(e), this.info.memory.textures--;
        }
    }
}
class $d7238066c5de7f1c$var$fY extends $d7238066c5de7f1c$var$rn {
    /**
   * Constructs a new four-component color.
   * You can also pass a single THREE.Color, hex or
   * string argument to this constructor.
   *
   * @param {number|string} [r=1] - The red value.
   * @param {number} [g=1] - The green value.
   * @param {number} [b=1] - The blue value.
   * @param {number} [a=1] - The alpha value.
   */ constructor(e, t, i, n = 1){
        super(e, t, i), this.a = n;
    }
    /**
   * Overwrites the default to honor alpha.
   * You can also pass a single THREE.Color, hex or
   * string argument to this method.
   *
   * @param {number|string|Color} r - The red value.
   * @param {number} [g] - The green value.
   * @param {number} [b] - The blue value.
   * @param {number} [a=1] - The alpha value.
   * @return {Color4} A reference to this object.
   */ set(e, t, i, n = 1) {
        return this.a = n, super.set(e, t, i);
    }
    /**
   * Overwrites the default to honor alpha.
   *
   * @param {Color4} color - The color to copy.
   * @return {Color4} A reference to this object.
   */ copy(e) {
        return e.a !== void 0 && (this.a = e.a), super.copy(e);
    }
    /**
   * Overwrites the default to honor alpha.
   *
   * @return {Color4} The cloned color.
   */ clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
}
class $d7238066c5de7f1c$var$qU extends $d7238066c5de7f1c$var$pn {
    static get type() {
        return "ParameterNode";
    }
    /**
   * Constructs a new parameter node.
   *
   * @param {string} nodeType - The type of the node.
   * @param {?string} [name=null] - The name of the parameter in the shader.
   */ constructor(e, t = null){
        super(e, t), this.isParameterNode = !0;
    }
    /**
   * Gets the type of a member variable in the parameter node.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @param {string} name - The name of the member variable.
   * @returns {string}
   */ getMemberType(e, t) {
        const i = this.getNodeType(e), n = e.getStructTypeNode(i);
        let s;
        return n !== null ? s = n.getMemberType(e, t) : ($d7238066c5de7f1c$var$nt(`TSL: Member "${t}" not found in struct "${i}".`), s = "float"), s;
    }
    getHash() {
        return this.uuid;
    }
    generate() {
        return this.name;
    }
}
const $d7238066c5de7f1c$var$Ire = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$qU(r, e));
class $d7238066c5de7f1c$var$dre extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "StackNode";
    }
    /**
   * Constructs a new stack node.
   *
   * @param {?StackNode} [parent=null] - The parent stack node.
   */ constructor(e = null){
        super(), this.nodes = [], this.outputNode = null, this.parent = e, this._currentCond = null, this._expressionNode = null, this.isStackNode = !0;
    }
    getElementType(e) {
        return this.hasOutput ? this.outputNode.getElementType(e) : "void";
    }
    getNodeType(e) {
        return this.hasOutput ? this.outputNode.getNodeType(e) : "void";
    }
    getMemberType(e, t) {
        return this.hasOutput ? this.outputNode.getMemberType(e, t) : "void";
    }
    /**
   * Adds a node to this stack.
   *
   * @param {Node} node - The node to add.
   * @return {StackNode} A reference to this stack node.
   */ addToStack(e) {
        return e.isNode !== !0 ? ($d7238066c5de7f1c$var$nt("TSL: Invalid node added to stack."), this) : (this.nodes.push(e), this);
    }
    /**
   * Represent an `if` statement in TSL.
   *
   * @param {Node} boolNode - Represents the condition.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */ If(e, t) {
        const i = new $d7238066c5de7f1c$var$hA(t);
        return this._currentCond = $d7238066c5de7f1c$var$or(e, i), this.addToStack(this._currentCond);
    }
    /**
   * Represent an `elseif` statement in TSL.
   *
   * @param {Node} boolNode - Represents the condition.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */ ElseIf(e, t) {
        const i = new $d7238066c5de7f1c$var$hA(t), n = $d7238066c5de7f1c$var$or(e, i);
        return this._currentCond.elseNode = n, this._currentCond = n, this;
    }
    /**
   * Represent an `else` statement in TSL.
   *
   * @param {Function} method - TSL code which is executed in the `else` case.
   * @return {StackNode} A reference to this stack node.
   */ Else(e) {
        return this._currentCond.elseNode = new $d7238066c5de7f1c$var$hA(e), this;
    }
    /**
   * Represents a `switch` statement in TSL.
   *
   * @param {any} expression - Represents the expression.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */ Switch(e) {
        return this._expressionNode = $d7238066c5de7f1c$var$He(e), this;
    }
    /**
   * Represents a `case` statement in TSL. The TSL version accepts an arbitrary numbers of values.
   * The last parameter must be the callback method that should be executed in the `true` case.
   *
   * @param {...any} params - The values of the `Case()` statement as well as the callback method.
   * @return {StackNode} A reference to this stack node.
   */ Case(...e) {
        const t = [];
        if (e.length >= 2) for(let o = 0; o < e.length - 1; o++)t.push(this._expressionNode.equal($d7238066c5de7f1c$var$He(e[o])));
        else $d7238066c5de7f1c$var$nt("TSL: Invalid parameter length. Case() requires at least two parameters.");
        const i = e[e.length - 1], n = new $d7238066c5de7f1c$var$hA(i);
        let s = t[0];
        for(let o = 1; o < t.length; o++)s = s.or(t[o]);
        const a = $d7238066c5de7f1c$var$or(s, n);
        return this._currentCond === null ? (this._currentCond = a, this.addToStack(this._currentCond)) : (this._currentCond.elseNode = a, this._currentCond = a, this);
    }
    /**
   * Represents the default code block of a Switch/Case statement.
   *
   * @param {Function} method - TSL code which is executed in the `else` case.
   * @return {StackNode} A reference to this stack node.
   */ Default(e) {
        return this.Else(e), this;
    }
    setup(e) {
        const t = e.getNodeProperties(this);
        let i = 0;
        for (const n of this.getChildren())n.isVarNode && n.intent === !0 && n.isAssign(e) !== !0 || (t["node" + i++] = n);
        return t.outputNode || null;
    }
    get hasOutput() {
        return this.outputNode && this.outputNode.isNode;
    }
    build(e, ...t) {
        const i = $d7238066c5de7f1c$var$yL();
        $d7238066c5de7f1c$var$uB(this), e.setActiveStack(this);
        const n = e.buildStage;
        for (const a of this.nodes)if (!(a.isVarNode && a.intent === !0 && a.isAssign(e) !== !0)) {
            if (n === "setup") a.build(e);
            else if (n === "analyze") a.build(e, this);
            else if (n === "generate") {
                const o = e.getDataFromNode(a, "any").stages, g = o && o[e.shaderStage];
                if (a.isVarNode && g && g.length === 1 && g[0] && g[0].isStackNode) continue;
                a.build(e, "void");
            }
        }
        let s;
        return this.hasOutput ? s = this.outputNode.build(e, ...t) : s = super.build(e, ...t), $d7238066c5de7f1c$var$uB(i), e.removeActiveStack(this), s;
    }
}
const $d7238066c5de7f1c$var$HS = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$dre).setParameterLength(0, 1);
function $d7238066c5de7f1c$var$hre(r) {
    return Object.entries(r).map(([e, t])=>typeof t == "string" ? {
            name: e,
            type: t,
            atomic: !1
        } : {
            name: e,
            type: t.type,
            atomic: t.atomic || !1
        });
}
class $d7238066c5de7f1c$var$Cre extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "StructTypeNode";
    }
    /**
   * Creates an instance of StructTypeNode.
   *
   * @param {Object} membersLayout - The layout of the members for the struct.
   * @param {?string} [name=null] - The optional name of the struct.
   */ constructor(e, t = null){
        super("struct"), this.membersLayout = $d7238066c5de7f1c$var$hre(e), this.name = t, this.isStructLayoutNode = !0;
    }
    /**
   * Returns the length of the struct.
   * The length is calculated by summing the lengths of the struct's members.
   *
   * @returns {number} The length of the struct.
   */ getLength() {
        const t = Float32Array.BYTES_PER_ELEMENT;
        let i = 0;
        for (const n of this.membersLayout){
            const s = n.type, a = $d7238066c5de7f1c$var$Lee(s) * t, o = $d7238066c5de7f1c$var$Yee(s), g = i % 8, l = g % o, c = g + l;
            i += l, c !== 0 && 8 - c < a && (i += 8 - c), i += a;
        }
        return Math.ceil(i / 8) * 8 / t;
    }
    getMemberType(e, t) {
        const i = this.membersLayout.find((n)=>n.name === t);
        return i ? i.type : "void";
    }
    getNodeType(e) {
        return e.getStructTypeFromNode(this, this.membersLayout, this.name).name;
    }
    setup(e) {
        e.getStructTypeFromNode(this, this.membersLayout, this.name), e.addInclude(this);
    }
    generate(e) {
        return this.getNodeType(e);
    }
}
class $d7238066c5de7f1c$var$pre extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "StructNode";
    }
    constructor(e, t){
        super("vec3"), this.structTypeNode = e, this.values = t, this.isStructNode = !0;
    }
    getNodeType(e) {
        return this.structTypeNode.getNodeType(e);
    }
    getMemberType(e, t) {
        return this.structTypeNode.getMemberType(e, t);
    }
    generate(e) {
        const t = e.getVarFromNode(this), i = t.type, n = e.getPropertyName(t);
        return e.addLineFlowCode(`${n} = ${e.generateStruct(i, this.structTypeNode.membersLayout, this.values)}`, this), t.name;
    }
}
const $d7238066c5de7f1c$var$mre = (r, e = null)=>{
    const t = new $d7238066c5de7f1c$var$Cre(r, e), i = (...n)=>{
        let s = null;
        if (n.length > 0) {
            if (n[0].isNode) {
                s = {};
                const a = Object.keys(r);
                for(let o = 0; o < n.length; o++)s[a[o]] = n[o];
            } else s = n[0];
        }
        return $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$pre(t, s));
    };
    return i.layout = t, i.isStruct = !0, i;
};
class $d7238066c5de7f1c$var$$U extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "OutputStructNode";
    }
    /**
   * Constructs a new output struct node. The constructor can be invoked with an
   * arbitrary number of nodes representing the members.
   *
   * @param {...Node} members - A parameter list of nodes.
   */ constructor(...e){
        super(), this.members = e, this.isOutputStructNode = !0;
    }
    getNodeType(e) {
        const t = e.getNodeProperties(this);
        if (t.membersLayout === void 0) {
            const i = this.members, n = [];
            for(let s = 0; s < i.length; s++){
                const a = "m" + s, o = i[s].getNodeType(e);
                n.push({
                    name: a,
                    type: o,
                    index: s
                });
            }
            t.membersLayout = n, t.structType = e.getOutputStructTypeFromNode(this, t.membersLayout);
        }
        return t.structType.name;
    }
    generate(e) {
        const t = e.getOutputStructName(), i = this.members, n = t !== "" ? t + "." : "";
        for(let s = 0; s < i.length; s++){
            const a = i[s].build(e);
            e.addLineFlowCode(`${n}m${s} = ${a}`, this);
        }
        return t;
    }
}
const $d7238066c5de7f1c$var$Are = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$$U);
function $d7238066c5de7f1c$var$eD(r, e) {
    for(let t = 0; t < r.length; t++)if (r[t].name === e) return t;
    return -1;
}
class $d7238066c5de7f1c$var$bre extends $d7238066c5de7f1c$var$$U {
    static get type() {
        return "MRTNode";
    }
    /**
   * Constructs a new output struct node.
   *
   * @param {Object<string, Node>} outputNodes - The MRT outputs.
   */ constructor(e){
        super(), this.outputNodes = e, this.isMRTNode = !0;
    }
    /**
   * Returns `true` if the MRT node has an output with the given name.
   *
   * @param {string} name - The name of the output.
   * @return {NodeBuilder} Whether the MRT node has an output for the given name or not.
   */ has(e) {
        return this.outputNodes[e] !== void 0;
    }
    /**
   * Returns the output node for the given name.
   *
   * @param {string} name - The name of the output.
   * @return {Node} The output node.
   */ get(e) {
        return this.outputNodes[e];
    }
    /**
   * Merges the outputs of the given MRT node with the outputs of this node.
   *
   * @param {MRTNode} mrtNode - The MRT to merge.
   * @return {MRTNode} A new MRT node with merged outputs..
   */ merge(e) {
        const t = {
            ...this.outputNodes,
            ...e.outputNodes
        };
        return $d7238066c5de7f1c$var$tD(t);
    }
    setup(e) {
        const t = this.outputNodes, i = e.renderer.getRenderTarget(), n = [], s = i.textures;
        for(const a in t){
            const o = $d7238066c5de7f1c$var$eD(s, a);
            n[o] = $d7238066c5de7f1c$var$Rt(t[a]);
        }
        return this.members = n, super.setup(e);
    }
}
const $d7238066c5de7f1c$var$tD = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$bre);
class $d7238066c5de7f1c$var$$B extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "BitcastNode";
    }
    /**
   * Constructs a new bitcast node.
   *
   * @param {Node} valueNode - The value to convert.
   * @param {string} conversionType - The type to convert to.
   * @param {?string} [inputType = null] - The expected input data type of the bitcast operation.
   */ constructor(e, t, i = null){
        super(), this.valueNode = e, this.conversionType = t, this.inputType = i, this.isBitcastNode = !0;
    }
    getNodeType(e) {
        if (this.inputType !== null) {
            const t = this.valueNode.getNodeType(e), i = e.getTypeLength(t);
            return e.getTypeFromLength(i, this.conversionType);
        }
        return this.conversionType;
    }
    generate(e) {
        const t = this.getNodeType(e);
        let i = "";
        if (this.inputType !== null) {
            const n = this.valueNode.getNodeType(e);
            i = e.getTypeLength(n) === 1 ? this.inputType : e.changeComponentType(n, this.inputType);
        } else i = this.valueNode.getNodeType(e);
        return `${e.getBitcastMethod(t, i)}( ${this.valueNode.build(e, i)} )`;
    }
}
const $d7238066c5de7f1c$var$yre = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$$B).setParameterLength(2), $d7238066c5de7f1c$var$Bre = (r)=>new $d7238066c5de7f1c$var$$B(r, "int", "float"), $d7238066c5de7f1c$var$fre = (r)=>new $d7238066c5de7f1c$var$$B(r, "uint", "float"), $d7238066c5de7f1c$var$Gre = (r)=>new $d7238066c5de7f1c$var$$B(r, "float", "int"), $d7238066c5de7f1c$var$vre = (r)=>new $d7238066c5de7f1c$var$$B(r, "float", "uint"), $d7238066c5de7f1c$var$Sre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = r.toUint().mul(747796405).add(2891336453), t = e.shiftRight(e.shiftRight(28).add(4)).bitXor(e).mul(277803737);
    return t.shiftRight(22).bitXor(t).toFloat().mul(1 / 2 ** 32);
}), $d7238066c5de7f1c$var$E2 = (r, e)=>$d7238066c5de7f1c$var$qg($d7238066c5de7f1c$var$Et(4, r.mul($d7238066c5de7f1c$var$wi(1, r))), e), $d7238066c5de7f1c$var$Zre = (r, e)=>r.lessThan(0.5) ? $d7238066c5de7f1c$var$E2(r.mul(2), e).div(2) : $d7238066c5de7f1c$var$wi(1, $d7238066c5de7f1c$var$E2($d7238066c5de7f1c$var$Et($d7238066c5de7f1c$var$wi(1, r), 2), e).div(2)), $d7238066c5de7f1c$var$Rre = (r, e, t)=>$d7238066c5de7f1c$var$qg($d7238066c5de7f1c$var$cg($d7238066c5de7f1c$var$qg(r, e), $d7238066c5de7f1c$var$Ps($d7238066c5de7f1c$var$qg(r, e), $d7238066c5de7f1c$var$qg($d7238066c5de7f1c$var$wi(1, r), t))), 1 / e), $d7238066c5de7f1c$var$Vre = (r, e)=>$d7238066c5de7f1c$var$Go($d7238066c5de7f1c$var$HZ.mul(e.mul(r).sub(1))).div($d7238066c5de7f1c$var$HZ.mul(e.mul(r).sub(1))), $d7238066c5de7f1c$var$nI = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>r.fract().sub(0.5).abs()).setLayout({
    name: "tri",
    type: "float",
    inputs: [
        {
            name: "x",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$wre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>$d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$nI(r.z.add($d7238066c5de7f1c$var$nI(r.y.mul(1)))), $d7238066c5de7f1c$var$nI(r.z.add($d7238066c5de7f1c$var$nI(r.x.mul(1)))), $d7238066c5de7f1c$var$nI(r.y.add($d7238066c5de7f1c$var$nI(r.x.mul(1)))))).setLayout({
    name: "tri3",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$Wre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ne(r).toVar(), n = $d7238066c5de7f1c$var$J(1.4).toVar(), s = $d7238066c5de7f1c$var$J(0).toVar(), a = $d7238066c5de7f1c$var$ne(i).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: $d7238066c5de7f1c$var$J(0),
        end: $d7238066c5de7f1c$var$J(3),
        type: "float",
        condition: "<="
    }, ()=>{
        const o = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$wre(a.mul(2))).toVar();
        i.addAssign(o.add(t.mul($d7238066c5de7f1c$var$J(0.1).mul(e)))), a.mulAssign(1.8), n.mulAssign(1.5), i.mulAssign(1.2);
        const g = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$nI(i.z.add($d7238066c5de7f1c$var$nI(i.x.add($d7238066c5de7f1c$var$nI(i.y)))))).toVar();
        s.addAssign(g.div(n)), a.addAssign(0.14);
    }), s;
}).setLayout({
    name: "triNoise3D",
    type: "float",
    inputs: [
        {
            name: "position",
            type: "vec3"
        },
        {
            name: "speed",
            type: "float"
        },
        {
            name: "time",
            type: "float"
        }
    ]
});
class $d7238066c5de7f1c$var$Hre extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "FunctionOverloadingNode";
    }
    /**
   * Constructs a new function overloading node.
   *
   * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
   * @param {...Node} parametersNodes - A list of parameter nodes.
   */ constructor(e = [], ...t){
        super(), this.functionNodes = e, this.parametersNodes = t, this._candidateFn = null, this.global = !0;
    }
    /**
   * This method is overwritten since the node type is inferred from
   * the function's return type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.getCandidateFn(e).shaderNode.layout.type;
    }
    /**
   * Returns the candidate function for the current parameters.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {FunctionNode} The candidate function.
   */ getCandidateFn(e) {
        const t = this.parametersNodes;
        let i = this._candidateFn;
        if (i === null) {
            let n = null, s = -1;
            for (const a of this.functionNodes){
                const g = a.shaderNode.layout;
                if (g === null) throw new Error("FunctionOverloadingNode: FunctionNode must be a layout.");
                const l = g.inputs;
                if (t.length === l.length) {
                    let c = 0;
                    for(let d = 0; d < t.length; d++){
                        const p = t[d], A = l[d];
                        p.getNodeType(e) === A.type && c++;
                    }
                    c > s && (n = a, s = c);
                }
            }
            this._candidateFn = i = n;
        }
        return i;
    }
    /**
   * Sets up the node for the current parameters.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The setup node.
   */ setup(e) {
        return this.getCandidateFn(e)(...this.parametersNodes);
    }
}
const $d7238066c5de7f1c$var$Xre = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Hre), $d7238066c5de7f1c$var$pa = (r)=>(...e)=>$d7238066c5de7f1c$var$Xre(r, ...e), $d7238066c5de7f1c$var$o0 = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate((r)=>r.time), $d7238066c5de7f1c$var$Nre = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate((r)=>r.deltaTime), $d7238066c5de7f1c$var$iD = /* @__PURE__ */ $d7238066c5de7f1c$var$yt(0, "uint").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate((r)=>r.frameId), $d7238066c5de7f1c$var$Lre = (r = $d7238066c5de7f1c$var$o0)=>r.add(0.75).mul(Math.PI * 2).sin().mul(0.5).add(0.5), $d7238066c5de7f1c$var$Yre = (r = $d7238066c5de7f1c$var$o0)=>r.fract().round(), $d7238066c5de7f1c$var$Kre = (r = $d7238066c5de7f1c$var$o0)=>r.add(0.5).fract().mul(2).sub(1).abs(), $d7238066c5de7f1c$var$xre = (r = $d7238066c5de7f1c$var$o0)=>r.fract(), $d7238066c5de7f1c$var$Fre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t = $d7238066c5de7f1c$var$Ne(0.5)])=>$d7238066c5de7f1c$var$qB(r.sub(t), e).add(t)), $d7238066c5de7f1c$var$Tre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t = $d7238066c5de7f1c$var$Ne(0.5)])=>{
    const i = r.sub(t), n = i.dot(i), a = n.mul(n).mul(e);
    return r.add(i.mul(a));
}), $d7238066c5de7f1c$var$Mre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ position: r = null, horizontal: e = !0, vertical: t = !1 })=>{
    let i;
    r !== null ? (i = $d7238066c5de7f1c$var$$g.toVar(), i[3][0] = r.x, i[3][1] = r.y, i[3][2] = r.z) : i = $d7238066c5de7f1c$var$$g;
    const n = $d7238066c5de7f1c$var$ol.mul(i);
    return $d7238066c5de7f1c$var$cB(e) && (n[0][0] = $d7238066c5de7f1c$var$$g[0].length(), n[0][1] = 0, n[0][2] = 0), $d7238066c5de7f1c$var$cB(t) && (n[1][0] = 0, n[1][1] = $d7238066c5de7f1c$var$$g[1].length(), n[1][2] = 0), n[2][0] = 0, n[2][1] = 0, n[2][2] = 1, $d7238066c5de7f1c$var$s0.mul(n).mul($d7238066c5de7f1c$var$Ns);
}), $d7238066c5de7f1c$var$zre = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r = null])=>{
    const e = $d7238066c5de7f1c$var$LZ();
    return $d7238066c5de7f1c$var$LZ($d7238066c5de7f1c$var$uY(r)).sub(e).lessThan(0).select($d7238066c5de7f1c$var$AI, r);
});
class $d7238066c5de7f1c$var$kre extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "SpriteSheetUVNode";
    }
    /**
   * Constructs a new sprite sheet uv node.
   *
   * @param {Node<vec2>} countNode - The node that defines the number of sprites in the x and y direction (e.g 6x6).
   * @param {Node<vec2>} [uvNode=uv()] - The uv node.
   * @param {Node<float>} [frameNode=float()] - The node that defines the current frame/sprite.
   */ constructor(e, t = $d7238066c5de7f1c$var$yn(), i = $d7238066c5de7f1c$var$J(0)){
        super("vec2"), this.countNode = e, this.uvNode = t, this.frameNode = i;
    }
    setup() {
        const { frameNode: e, uvNode: t, countNode: i } = this, { width: n, height: s } = i, a = e.mod(n.mul(s)).floor(), o = a.mod(n), g = s.sub(a.add(1).div(n).ceil()), l = i.reciprocal(), c = $d7238066c5de7f1c$var$Ne(o, g);
        return t.add(c).mul(l);
    }
}
const $d7238066c5de7f1c$var$Ere = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$kre).setParameterLength(3), $d7238066c5de7f1c$var$nD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e = null, t = null, i = $d7238066c5de7f1c$var$J(1), n = $d7238066c5de7f1c$var$Ns, s = $d7238066c5de7f1c$var$No])=>{
    let a = s.abs().normalize();
    a = a.div(a.dot($d7238066c5de7f1c$var$ne(1)));
    const o = n.yz.mul(i), g = n.zx.mul(i), l = n.xy.mul(i), c = r.value, d = e !== null ? e.value : c, p = t !== null ? t.value : c, A = $d7238066c5de7f1c$var$ni(c, o).mul(a.x), y = $d7238066c5de7f1c$var$ni(d, g).mul(a.y), G = $d7238066c5de7f1c$var$ni(p, l).mul(a.z);
    return $d7238066c5de7f1c$var$Ps(A, y, G);
}), $d7238066c5de7f1c$var$Jre = (...r)=>$d7238066c5de7f1c$var$nD(...r), $d7238066c5de7f1c$var$Tm = new $d7238066c5de7f1c$var$Ed(), $d7238066c5de7f1c$var$gC = new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Mm = new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$vH = new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Mb = new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Fv = new $d7238066c5de7f1c$var$Ce(0, 0, -1), $d7238066c5de7f1c$var$xc = new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$zb = new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Tv = new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$kb = new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$Mv = new $d7238066c5de7f1c$var$Ii(), $d7238066c5de7f1c$var$KZ = new $d7238066c5de7f1c$var$WI(), $d7238066c5de7f1c$var$Ure = $d7238066c5de7f1c$var$AI.flipX();
$d7238066c5de7f1c$var$KZ.depthTexture = new $d7238066c5de7f1c$var$$l(1, 1);
let $d7238066c5de7f1c$var$zv = !1;
class $d7238066c5de7f1c$var$GY extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "ReflectorNode";
    }
    /**
   * Constructs a new reflector node.
   *
   * @param {Object} [parameters={}] - An object holding configuration parameters.
   * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
   * @param {number} [parameters.resolutionScale=1] - The resolution scale.
   * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
   * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
   * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
   * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
   * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
   * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
   */ constructor(e = {}){
        super(e.defaultTexture || $d7238066c5de7f1c$var$KZ.texture, $d7238066c5de7f1c$var$Ure), this._reflectorBaseNode = e.reflector || new $d7238066c5de7f1c$var$Dre(this, e), this._depthNode = null, this.setUpdateMatrix(!1);
    }
    /**
   * A reference to the internal reflector node.
   *
   * @type {ReflectorBaseNode}
   */ get reflector() {
        return this._reflectorBaseNode;
    }
    /**
   * A reference to 3D object the reflector is linked to.
   *
   * @type {Object3D}
   */ get target() {
        return this._reflectorBaseNode.target;
    }
    /**
   * Returns a node representing the mirror's depth. That can be used
   * to implement more advanced reflection effects like distance attenuation.
   *
   * @return {Node} The depth node.
   */ getDepthNode() {
        if (this._depthNode === null) {
            if (this._reflectorBaseNode.depth !== !0) throw new Error("THREE.ReflectorNode: Depth node can only be requested when the reflector is created with { depth: true }. ");
            this._depthNode = $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$GY({
                defaultTexture: $d7238066c5de7f1c$var$KZ.depthTexture,
                reflector: this._reflectorBaseNode
            }));
        }
        return this._depthNode;
    }
    setup(e) {
        return e.object.isQuadMesh || this._reflectorBaseNode.build(e), super.setup(e);
    }
    clone() {
        const e = new this.constructor(this.reflectorNode);
        return e.uvNode = this.uvNode, e.levelNode = this.levelNode, e.biasNode = this.biasNode, e.sampler = this.sampler, e.depthNode = this.depthNode, e.compareNode = this.compareNode, e.gradNode = this.gradNode, e.offsetNode = this.offsetNode, e._reflectorBaseNode = this._reflectorBaseNode, e;
    }
    /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */ dispose() {
        super.dispose(), this._reflectorBaseNode.dispose();
    }
}
class $d7238066c5de7f1c$var$Dre extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ReflectorBaseNode";
    }
    /**
   * Constructs a new reflector base node.
   *
   * @param {TextureNode} textureNode - Represents the rendered reflections as a texture node.
   * @param {Object} [parameters={}] - An object holding configuration parameters.
   * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
   * @param {number} [parameters.resolutionScale=1] - The resolution scale.
   * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
   * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
   * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
   * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
   */ constructor(e, t = {}){
        super();
        const { target: i = new $d7238066c5de7f1c$var$lr(), resolutionScale: n = 1, generateMipmaps: s = !1, bounces: a = !0, depth: o = !1, samples: g = 0 } = t;
        this.textureNode = e, this.target = i, this.resolutionScale = n, t.resolution !== void 0 && ($d7238066c5de7f1c$var$es('ReflectorNode: The "resolution" parameter has been renamed to "resolutionScale".'), this.resolutionScale = t.resolution), this.generateMipmaps = s, this.bounces = a, this.depth = o, this.samples = g, this.updateBeforeType = a ? $d7238066c5de7f1c$var$Dt.RENDER : $d7238066c5de7f1c$var$Dt.FRAME, this.virtualCameras = /* @__PURE__ */ new WeakMap(), this.renderTargets = /* @__PURE__ */ new Map(), this.forceUpdate = !1, this.hasOutput = !1;
    }
    /**
   * Updates the resolution of the internal render target.
   *
   * @private
   * @param {RenderTarget} renderTarget - The render target to resize.
   * @param {Renderer} renderer - The renderer that is used to determine the new size.
   */ _updateResolution(e, t) {
        const i = this.resolutionScale;
        t.getDrawingBufferSize($d7238066c5de7f1c$var$Mv), e.setSize(Math.round($d7238066c5de7f1c$var$Mv.width * i), Math.round($d7238066c5de7f1c$var$Mv.height * i));
    }
    setup(e) {
        return this._updateResolution($d7238066c5de7f1c$var$KZ, e.renderer), super.setup(e);
    }
    /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */ dispose() {
        super.dispose();
        for (const e of this.renderTargets.values())e.dispose();
    }
    /**
   * Returns a virtual camera for the given camera. The virtual camera is used to
   * render the scene from the reflector's view so correct reflections can be produced.
   *
   * @param {Camera} camera - The scene's camera.
   * @return {Camera} The corresponding virtual camera.
   */ getVirtualCamera(e) {
        let t = this.virtualCameras.get(e);
        return t === void 0 && (t = e.clone(), this.virtualCameras.set(e, t)), t;
    }
    /**
   * Returns a render target for the given camera. The reflections are rendered
   * into this render target.
   *
   * @param {Camera} camera - The scene's camera.
   * @return {RenderTarget} The render target.
   */ getRenderTarget(e) {
        let t = this.renderTargets.get(e);
        return t === void 0 && (t = new $d7238066c5de7f1c$var$WI(0, 0, {
            type: $d7238066c5de7f1c$var$Ia,
            samples: this.samples
        }), this.generateMipmaps === !0 && (t.texture.minFilter = $d7238066c5de7f1c$var$U6, t.texture.generateMipmaps = !0), this.depth === !0 && (t.depthTexture = new $d7238066c5de7f1c$var$$l()), this.renderTargets.set(e, t)), t;
    }
    updateBefore(e) {
        if (this.bounces === !1 && $d7238066c5de7f1c$var$zv) return !1;
        $d7238066c5de7f1c$var$zv = !0;
        const { scene: t, camera: i, renderer: n, material: s } = e, { target: a } = this, o = this.getVirtualCamera(i), g = this.getRenderTarget(o);
        n.getDrawingBufferSize($d7238066c5de7f1c$var$Mv), this._updateResolution(g, n), $d7238066c5de7f1c$var$Mm.setFromMatrixPosition(a.matrixWorld), $d7238066c5de7f1c$var$vH.setFromMatrixPosition(i.matrixWorld), $d7238066c5de7f1c$var$Mb.extractRotation(a.matrixWorld), $d7238066c5de7f1c$var$gC.set(0, 0, 1), $d7238066c5de7f1c$var$gC.applyMatrix4($d7238066c5de7f1c$var$Mb), $d7238066c5de7f1c$var$zb.subVectors($d7238066c5de7f1c$var$Mm, $d7238066c5de7f1c$var$vH);
        const l = $d7238066c5de7f1c$var$zb.dot($d7238066c5de7f1c$var$gC) > 0;
        let c = !1;
        if (l === !0 && this.forceUpdate === !1) {
            if (this.hasOutput === !1) {
                $d7238066c5de7f1c$var$zv = !1;
                return;
            }
            c = !0;
        }
        $d7238066c5de7f1c$var$zb.reflect($d7238066c5de7f1c$var$gC).negate(), $d7238066c5de7f1c$var$zb.add($d7238066c5de7f1c$var$Mm), $d7238066c5de7f1c$var$Mb.extractRotation(i.matrixWorld), $d7238066c5de7f1c$var$Fv.set(0, 0, -1), $d7238066c5de7f1c$var$Fv.applyMatrix4($d7238066c5de7f1c$var$Mb), $d7238066c5de7f1c$var$Fv.add($d7238066c5de7f1c$var$vH), $d7238066c5de7f1c$var$Tv.subVectors($d7238066c5de7f1c$var$Mm, $d7238066c5de7f1c$var$Fv), $d7238066c5de7f1c$var$Tv.reflect($d7238066c5de7f1c$var$gC).negate(), $d7238066c5de7f1c$var$Tv.add($d7238066c5de7f1c$var$Mm), o.coordinateSystem = i.coordinateSystem, o.position.copy($d7238066c5de7f1c$var$zb), o.up.set(0, 1, 0), o.up.applyMatrix4($d7238066c5de7f1c$var$Mb), o.up.reflect($d7238066c5de7f1c$var$gC), o.lookAt($d7238066c5de7f1c$var$Tv), o.near = i.near, o.far = i.far, o.updateMatrixWorld(), o.projectionMatrix.copy(i.projectionMatrix), $d7238066c5de7f1c$var$Tm.setFromNormalAndCoplanarPoint($d7238066c5de7f1c$var$gC, $d7238066c5de7f1c$var$Mm), $d7238066c5de7f1c$var$Tm.applyMatrix4(o.matrixWorldInverse), $d7238066c5de7f1c$var$xc.set($d7238066c5de7f1c$var$Tm.normal.x, $d7238066c5de7f1c$var$Tm.normal.y, $d7238066c5de7f1c$var$Tm.normal.z, $d7238066c5de7f1c$var$Tm.constant);
        const d = o.projectionMatrix;
        $d7238066c5de7f1c$var$kb.x = (Math.sign($d7238066c5de7f1c$var$xc.x) + d.elements[8]) / d.elements[0], $d7238066c5de7f1c$var$kb.y = (Math.sign($d7238066c5de7f1c$var$xc.y) + d.elements[9]) / d.elements[5], $d7238066c5de7f1c$var$kb.z = -1, $d7238066c5de7f1c$var$kb.w = (1 + d.elements[10]) / d.elements[14], $d7238066c5de7f1c$var$xc.multiplyScalar(1 / $d7238066c5de7f1c$var$xc.dot($d7238066c5de7f1c$var$kb));
        const p = 0;
        d.elements[2] = $d7238066c5de7f1c$var$xc.x, d.elements[6] = $d7238066c5de7f1c$var$xc.y, d.elements[10] = n.coordinateSystem === $d7238066c5de7f1c$var$uu ? $d7238066c5de7f1c$var$xc.z - p : $d7238066c5de7f1c$var$xc.z + 1 - p, d.elements[14] = $d7238066c5de7f1c$var$xc.w, this.textureNode.value = g.texture, this.depth === !0 && (this.textureNode.getDepthNode().value = g.depthTexture), s.visible = !1;
        const A = n.getRenderTarget(), y = n.getMRT(), G = n.autoClear;
        n.setMRT(null), n.setRenderTarget(g), n.autoClear = !0;
        const Z = t.name;
        t.name = (t.name || "Scene") + " [ Reflector ]", c ? (n.clear(), this.hasOutput = !1) : (n.render(t, o), this.hasOutput = !0), t.name = Z, n.setMRT(y), n.setRenderTarget(A), n.autoClear = G, s.visible = !0, $d7238066c5de7f1c$var$zv = !1, this.forceUpdate = !1;
    }
    /**
   * The resolution scale.
   *
   * @deprecated
   * @type {number}
   * @default {1}
   */ get resolution() {
        return $d7238066c5de7f1c$var$es('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'), this.resolutionScale;
    }
    set resolution(e) {
        $d7238066c5de7f1c$var$es('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'), this.resolutionScale = e;
    }
}
const $d7238066c5de7f1c$var$_re = (r)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$GY(r)), $d7238066c5de7f1c$var$SH = /* @__PURE__ */ new $d7238066c5de7f1c$var$dL(-1, 1, 1, -1, 0, 1);
class $d7238066c5de7f1c$var$Pre extends $d7238066c5de7f1c$var$Cu {
    /**
   * Constructs a new quad geometry.
   *
   * @param {boolean} [flipY=false] - Whether the uv coordinates should be flipped along the vertical axis or not.
   */ constructor(e = !1){
        super();
        const t = e === !1 ? [
            0,
            -1,
            0,
            1,
            2,
            1
        ] : [
            0,
            2,
            0,
            0,
            2,
            0
        ];
        this.setAttribute("position", new $d7238066c5de7f1c$var$so([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3)), this.setAttribute("uv", new $d7238066c5de7f1c$var$so(t, 2));
    }
}
const $d7238066c5de7f1c$var$Qre = /* @__PURE__ */ new $d7238066c5de7f1c$var$Pre();
class $d7238066c5de7f1c$var$YR extends $d7238066c5de7f1c$var$SI {
    /**
   * Constructs a new quad mesh.
   *
   * @param {?Material} [material=null] - The material to render the quad mesh with.
   */ constructor(e = null){
        super($d7238066c5de7f1c$var$Qre, e), this.camera = $d7238066c5de7f1c$var$SH, this.isQuadMesh = !0;
    }
    /**
   * Async version of `render()`.
   *
   * @async
   * @deprecated
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the render has been finished.
   */ async renderAsync(e) {
        $d7238066c5de7f1c$var$es('QuadMesh: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'), await e.init(), e.render(this, $d7238066c5de7f1c$var$SH);
    }
    /**
   * Renders the quad mesh
   *
   * @param {Renderer} renderer - The renderer.
   */ render(e) {
        e.render(this, $d7238066c5de7f1c$var$SH);
    }
}
const $d7238066c5de7f1c$var$Ore = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
class $d7238066c5de7f1c$var$jre extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "RTTNode";
    }
    /**
   * Constructs a new RTT node.
   *
   * @param {Node} node - The node to render a texture with.
   * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
   * @param {?number} [height=null] - The height of the internal render target.
   * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
   */ constructor(e, t = null, i = null, n = {
        type: $d7238066c5de7f1c$var$Ia
    }){
        const s = new $d7238066c5de7f1c$var$WI(t, i, n);
        super(s.texture, $d7238066c5de7f1c$var$yn()), this.isRTTNode = !0, this.node = e, this.width = t, this.height = i, this.pixelRatio = 1, this.renderTarget = s, this.textureNeedsUpdate = !0, this.autoUpdate = !0, this._rttNode = null, this._quadMesh = new $d7238066c5de7f1c$var$YR(new $d7238066c5de7f1c$var$Bs()), this.updateBeforeType = $d7238066c5de7f1c$var$Dt.RENDER;
    }
    /**
   * Whether the internal render target should automatically be resized or not.
   *
   * @type {boolean}
   * @readonly
   * @default true
   */ get autoResize() {
        return this.width === null;
    }
    setup(e) {
        return this._rttNode = this.node.context(e.getSharedContext()), this._quadMesh.material.name = "RTT", this._quadMesh.material.needsUpdate = !0, super.setup(e);
    }
    /**
   * Sets the size of the internal render target
   *
   * @param {number} width - The width to set.
   * @param {number} height - The width to set.
   */ setSize(e, t) {
        this.width = e, this.height = t;
        const i = e * this.pixelRatio, n = t * this.pixelRatio;
        this.renderTarget.setSize(i, n), this.textureNeedsUpdate = !0;
    }
    /**
   * Sets the pixel ratio. This will also resize the render target.
   *
   * @param {number} pixelRatio - The pixel ratio to set.
   */ setPixelRatio(e) {
        this.pixelRatio = e, this.setSize(this.width, this.height);
    }
    updateBefore({ renderer: e }) {
        if (this.textureNeedsUpdate === !1 && this.autoUpdate === !1) return;
        if (this.textureNeedsUpdate = !1, this.autoResize === !0) {
            const n = e.getPixelRatio(), s = e.getSize($d7238066c5de7f1c$var$Ore), a = Math.floor(s.width * n), o = Math.floor(s.height * n);
            (a !== this.renderTarget.width || o !== this.renderTarget.height) && (this.renderTarget.setSize(a, o), this.textureNeedsUpdate = !0);
        }
        let t = "RTT";
        this.node.name && (t = this.node.name + " [ " + t + " ]"), this._quadMesh.material.fragmentNode = this._rttNode, this._quadMesh.name = t;
        const i = e.getRenderTarget();
        e.setRenderTarget(this.renderTarget), this._quadMesh.render(e), e.setRenderTarget(i);
    }
    clone() {
        const e = new $d7238066c5de7f1c$var$Iu(this.value, this.uvNode, this.levelNode);
        return e.sampler = this.sampler, e.referenceNode = this, e;
    }
}
const $d7238066c5de7f1c$var$sD = (r, ...e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$jre($d7238066c5de7f1c$var$He(r), ...e)), $d7238066c5de7f1c$var$qre = (r, ...e)=>r.isSampleNode || r.isTextureNode ? r : r.isPassNode ? r.getTextureNode() : $d7238066c5de7f1c$var$sD(r, ...e), $d7238066c5de7f1c$var$sA = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t], i)=>{
    let n;
    i.renderer.coordinateSystem === $d7238066c5de7f1c$var$uu ? (r = $d7238066c5de7f1c$var$Ne(r.x, r.y.oneMinus()).mul(2).sub(1), n = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$ne(r, e), 1)) : n = $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$ne(r.x, r.y.oneMinus(), e).mul(2).sub(1), 1);
    const s = $d7238066c5de7f1c$var$Rt(t.mul(n));
    return s.xyz.div(s.w);
}), $d7238066c5de7f1c$var$$re = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = e.mul($d7238066c5de7f1c$var$Rt(r, 1)), i = t.xy.div(t.w).mul(0.5).add(0.5).toVar();
    return $d7238066c5de7f1c$var$Ne(i.x, i.y.oneMinus());
}), $d7238066c5de7f1c$var$eae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$mI($d7238066c5de7f1c$var$ys(e)), n = $d7238066c5de7f1c$var$vr(r.mul(i)).toVar(), s = $d7238066c5de7f1c$var$ys(e, n).toVar(), a = $d7238066c5de7f1c$var$ys(e, n.sub($d7238066c5de7f1c$var$vr(2, 0))).toVar(), o = $d7238066c5de7f1c$var$ys(e, n.sub($d7238066c5de7f1c$var$vr(1, 0))).toVar(), g = $d7238066c5de7f1c$var$ys(e, n.add($d7238066c5de7f1c$var$vr(1, 0))).toVar(), l = $d7238066c5de7f1c$var$ys(e, n.add($d7238066c5de7f1c$var$vr(2, 0))).toVar(), c = $d7238066c5de7f1c$var$ys(e, n.add($d7238066c5de7f1c$var$vr(0, 2))).toVar(), d = $d7238066c5de7f1c$var$ys(e, n.add($d7238066c5de7f1c$var$vr(0, 1))).toVar(), p = $d7238066c5de7f1c$var$ys(e, n.sub($d7238066c5de7f1c$var$vr(0, 1))).toVar(), A = $d7238066c5de7f1c$var$ys(e, n.sub($d7238066c5de7f1c$var$vr(0, 2))).toVar(), y = $d7238066c5de7f1c$var$Wn($d7238066c5de7f1c$var$wi($d7238066c5de7f1c$var$J(2).mul(o).sub(a), s)).toVar(), G = $d7238066c5de7f1c$var$Wn($d7238066c5de7f1c$var$wi($d7238066c5de7f1c$var$J(2).mul(g).sub(l), s)).toVar(), Z = $d7238066c5de7f1c$var$Wn($d7238066c5de7f1c$var$wi($d7238066c5de7f1c$var$J(2).mul(d).sub(c), s)).toVar(), v = $d7238066c5de7f1c$var$Wn($d7238066c5de7f1c$var$wi($d7238066c5de7f1c$var$J(2).mul(p).sub(A), s)).toVar(), V = $d7238066c5de7f1c$var$sA(r, s, t).toVar(), H = y.lessThan(G).select(V.sub($d7238066c5de7f1c$var$sA(r.sub($d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$J(1).div(i.x), 0)), o, t)), V.negate().add($d7238066c5de7f1c$var$sA(r.add($d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$J(1).div(i.x), 0)), g, t))), N = Z.lessThan(v).select(V.sub($d7238066c5de7f1c$var$sA(r.add($d7238066c5de7f1c$var$Ne(0, $d7238066c5de7f1c$var$J(1).div(i.y))), d, t)), V.negate().add($d7238066c5de7f1c$var$sA(r.sub($d7238066c5de7f1c$var$Ne(0, $d7238066c5de7f1c$var$J(1).div(i.y))), p, t)));
    return $d7238066c5de7f1c$var$wo($d7238066c5de7f1c$var$kC(H, N));
}), $d7238066c5de7f1c$var$tae = $d7238066c5de7f1c$var$oe(([r])=>$d7238066c5de7f1c$var$ec($d7238066c5de7f1c$var$J(52.9829189).mul($d7238066c5de7f1c$var$ec($d7238066c5de7f1c$var$tc(r, $d7238066c5de7f1c$var$Ne(0.06711056, 583715e-8)))))).setLayout({
    name: "interleavedGradientNoise",
    type: "float",
    inputs: [
        {
            name: "position",
            type: "vec2"
        }
    ]
});
class $d7238066c5de7f1c$var$iae extends $d7238066c5de7f1c$var$Ct {
    /**
   * Returns the type of the node.
   *
   * @type {string}
   * @readonly
   * @static
   */ static get type() {
        return "SampleNode";
    }
    /**
   * Creates an instance of SampleNode.
   *
   * @param {Function} callback - The function to be called when sampling. Should accept a UV node and return a value.
   * @param {?Node<vec2>} [uvNode=null] - The UV node to be used in the texture sampling.
   */ constructor(e, t = null){
        super(), this.callback = e, this.uvNode = t, this.isSampleNode = !0;
    }
    /**
   * Sets up the node by sampling with the default UV accessor.
   *
   * @returns {Node} The result of the callback function when called with the UV node.
   */ setup() {
        return this.sample($d7238066c5de7f1c$var$yn());
    }
    /**
   * Calls the callback function with the provided UV node.
   *
   * @param {Node<vec2>} uv - The UV node or value to be passed to the callback.
   * @returns {Node} The result of the callback function.
   */ sample(e) {
        return this.callback(e);
    }
}
const $d7238066c5de7f1c$var$nae = (r, e = null)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$iae(r, $d7238066c5de7f1c$var$He(e)));
class $d7238066c5de7f1c$var$Ro extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "EventNode";
    }
    /**
   * Creates an EventNode.
   *
   * @param {string} eventType - The type of event
   * @param {Function} callback - The callback to execute on update.
   */ constructor(e, t){
        super("void"), this.eventType = e, this.callback = t, e === $d7238066c5de7f1c$var$Ro.OBJECT ? this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT : e === $d7238066c5de7f1c$var$Ro.MATERIAL ? this.updateType = $d7238066c5de7f1c$var$Dt.RENDER : e === $d7238066c5de7f1c$var$Ro.BEFORE_OBJECT ? this.updateBeforeType = $d7238066c5de7f1c$var$Dt.OBJECT : e === $d7238066c5de7f1c$var$Ro.BEFORE_MATERIAL && (this.updateBeforeType = $d7238066c5de7f1c$var$Dt.RENDER);
    }
    update(e) {
        this.callback(e);
    }
    updateBefore(e) {
        this.callback(e);
    }
}
$d7238066c5de7f1c$var$Ro.OBJECT = "object";
$d7238066c5de7f1c$var$Ro.MATERIAL = "material";
$d7238066c5de7f1c$var$Ro.BEFORE_OBJECT = "beforeObject";
$d7238066c5de7f1c$var$Ro.BEFORE_MATERIAL = "beforeMaterial";
const $d7238066c5de7f1c$var$KR = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Ro(r, e)).toStack(), $d7238066c5de7f1c$var$sae = (r)=>$d7238066c5de7f1c$var$KR($d7238066c5de7f1c$var$Ro.OBJECT, r), $d7238066c5de7f1c$var$rae = (r)=>$d7238066c5de7f1c$var$KR($d7238066c5de7f1c$var$Ro.MATERIAL, r), $d7238066c5de7f1c$var$aae = (r)=>$d7238066c5de7f1c$var$KR($d7238066c5de7f1c$var$Ro.BEFORE_OBJECT, r), $d7238066c5de7f1c$var$oae = (r)=>$d7238066c5de7f1c$var$KR($d7238066c5de7f1c$var$Ro.BEFORE_MATERIAL, r);
class $d7238066c5de7f1c$var$gae extends $d7238066c5de7f1c$var$SA {
    /**
   * Constructs a new storage instanced buffer attribute.
   *
   * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
   * The subsequent parameters are then obsolete.
   * @param {number} itemSize - The item size.
   * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
   */ constructor(e, t, i = Float32Array){
        const n = ArrayBuffer.isView(e) ? e : new i(e * t);
        super(n, t), this.isStorageInstancedBufferAttribute = !0;
    }
}
class $d7238066c5de7f1c$var$lae extends $d7238066c5de7f1c$var$gg {
    /**
   * Constructs a new storage buffer attribute.
   *
   * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
   * The subsequent parameters are then obsolete.
   * @param {number} itemSize - The item size.
   * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
   */ constructor(e, t, i = Float32Array){
        const n = ArrayBuffer.isView(e) ? e : new i(e * t);
        super(n, t), this.isStorageBufferAttribute = !0;
    }
}
const $d7238066c5de7f1c$var$cae = (r, e = "float")=>{
    let t, i;
    e.isStruct === !0 ? (t = e.layout.getLength(), i = $d7238066c5de7f1c$var$ZZ("float")) : (t = $d7238066c5de7f1c$var$b3(e), i = $d7238066c5de7f1c$var$ZZ(e));
    const n = new $d7238066c5de7f1c$var$lae(r, t, i);
    return $d7238066c5de7f1c$var$TC(n, e, r);
}, $d7238066c5de7f1c$var$uae = (r, e = "float")=>{
    let t, i;
    e.isStruct === !0 ? (t = e.layout.getLength(), i = $d7238066c5de7f1c$var$ZZ("float")) : (t = $d7238066c5de7f1c$var$b3(e), i = $d7238066c5de7f1c$var$ZZ(e));
    const n = new $d7238066c5de7f1c$var$gae(r, t, i);
    return $d7238066c5de7f1c$var$TC(n, e, r);
};
class $d7238066c5de7f1c$var$Iae extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "PointUVNode";
    }
    /**
   * Constructs a new point uv node.
   */ constructor(){
        super("vec2"), this.isPointUVNode = !0;
    }
    generate() {
        return "vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y )";
    }
}
const $d7238066c5de7f1c$var$dae = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Iae), $d7238066c5de7f1c$var$Eb = /* @__PURE__ */ new $d7238066c5de7f1c$var$il(), $d7238066c5de7f1c$var$ZH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji();
class $d7238066c5de7f1c$var$Vo extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "SceneNode";
    }
    /**
   * Constructs a new scene node.
   *
   * @param {('backgroundBlurriness'|'backgroundIntensity'|'backgroundRotation')} scope - The scope defines the type of scene property that is accessed.
   * @param {?Scene} [scene=null] - A reference to the scene.
   */ constructor(e = $d7238066c5de7f1c$var$Vo.BACKGROUND_BLURRINESS, t = null){
        super(), this.scope = e, this.scene = t;
    }
    /**
   * Depending on the scope, the method returns a different type of node that represents
   * the respective scene property.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The output node.
   */ setup(e) {
        const t = this.scope, i = this.scene !== null ? this.scene : e.scene;
        let n;
        return t === $d7238066c5de7f1c$var$Vo.BACKGROUND_BLURRINESS ? n = $d7238066c5de7f1c$var$vn("backgroundBlurriness", "float", i) : t === $d7238066c5de7f1c$var$Vo.BACKGROUND_INTENSITY ? n = $d7238066c5de7f1c$var$vn("backgroundIntensity", "float", i) : t === $d7238066c5de7f1c$var$Vo.BACKGROUND_ROTATION ? n = $d7238066c5de7f1c$var$yt("mat4").setName("backgroundRotation").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(()=>{
            const s = i.background;
            return s !== null && s.isTexture && s.mapping !== $d7238066c5de7f1c$var$_N ? ($d7238066c5de7f1c$var$Eb.copy(i.backgroundRotation), $d7238066c5de7f1c$var$Eb.x *= -1, $d7238066c5de7f1c$var$Eb.y *= -1, $d7238066c5de7f1c$var$Eb.z *= -1, $d7238066c5de7f1c$var$ZH.makeRotationFromEuler($d7238066c5de7f1c$var$Eb)) : $d7238066c5de7f1c$var$ZH.identity(), $d7238066c5de7f1c$var$ZH;
        }) : $d7238066c5de7f1c$var$nt("SceneNode: Unknown scope:", t), n;
    }
}
$d7238066c5de7f1c$var$Vo.BACKGROUND_BLURRINESS = "backgroundBlurriness";
$d7238066c5de7f1c$var$Vo.BACKGROUND_INTENSITY = "backgroundIntensity";
$d7238066c5de7f1c$var$Vo.BACKGROUND_ROTATION = "backgroundRotation";
const $d7238066c5de7f1c$var$rD = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Vo, $d7238066c5de7f1c$var$Vo.BACKGROUND_BLURRINESS), $d7238066c5de7f1c$var$J2 = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Vo, $d7238066c5de7f1c$var$Vo.BACKGROUND_INTENSITY), $d7238066c5de7f1c$var$aD = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$Vo, $d7238066c5de7f1c$var$Vo.BACKGROUND_ROTATION);
class $d7238066c5de7f1c$var$hae extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "StorageTextureNode";
    }
    /**
   * Constructs a new storage texture node.
   *
   * @param {StorageTexture} value - The storage texture.
   * @param {Node<vec2|vec3>} uvNode - The uv node.
   * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
   */ constructor(e, t, i = null){
        super(e, t), this.storeNode = i, this.mipLevel = 0, this.isStorageTextureNode = !0, this.access = $d7238066c5de7f1c$var$da.WRITE_ONLY;
    }
    /**
   * Overwrites the default implementation to return a fixed value `'storageTexture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return "storageTexture";
    }
    setup(e) {
        super.setup(e);
        const t = e.getNodeProperties(this);
        return t.storeNode = this.storeNode, t;
    }
    /**
   * Defines the node access.
   *
   * @param {string} value - The node access.
   * @return {StorageTextureNode} A reference to this node.
   */ setAccess(e) {
        return this.access = e, this;
    }
    /**
   * Sets the mip level to write to.
   *
   * @param {number} level - The mip level.
   * @return {StorageTextureNode} A reference to this node.
   */ setMipLevel(e) {
        return this.mipLevel = e, this;
    }
    /**
   * Generates the code snippet of the storage node. If no `storeNode`
   * is defined, the texture node is generated as normal texture.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The current output.
   * @return {string} The generated code snippet.
   */ generate(e, t) {
        let i;
        return this.storeNode !== null ? i = this.generateStore(e) : i = super.generate(e, t), i;
    }
    /**
   * Convenience method for configuring a read/write node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */ toReadWrite() {
        return this.setAccess($d7238066c5de7f1c$var$da.READ_WRITE);
    }
    /**
   * Convenience method for configuring a read-only node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */ toReadOnly() {
        return this.setAccess($d7238066c5de7f1c$var$da.READ_ONLY);
    }
    /**
   * Convenience method for configuring a write-only node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */ toWriteOnly() {
        return this.setAccess($d7238066c5de7f1c$var$da.WRITE_ONLY);
    }
    /**
   * Generates the code snippet of the storage texture node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ generateStore(e) {
        const t = e.getNodeProperties(this), { uvNode: i, storeNode: n, depthNode: s } = t, a = super.generate(e, "property"), o = i.build(e, this.value.is3DTexture === !0 ? "uvec3" : "uvec2"), g = n.build(e, "vec4"), l = s ? s.build(e, "int") : null, c = e.generateTextureStore(e, a, o, l, g);
        e.addLineFlowCode(c, this);
    }
    clone() {
        const e = super.clone();
        return e.storeNode = this.storeNode, e.mipLevel = this.mipLevel, e;
    }
}
const $d7238066c5de7f1c$var$oD = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$hae).setParameterLength(1, 3), $d7238066c5de7f1c$var$Cae = (r, e, t)=>{
    const i = $d7238066c5de7f1c$var$oD(r, e, t);
    return t !== null && i.toStack(), i;
}, $d7238066c5de7f1c$var$pae = $d7238066c5de7f1c$var$oe(({ texture: r, uv: e })=>{
    const i = $d7238066c5de7f1c$var$ne().toVar();
    return $d7238066c5de7f1c$var$Ht(e.x.lessThan(1e-4), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(1, 0, 0));
    }).ElseIf(e.y.lessThan(1e-4), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(0, 1, 0));
    }).ElseIf(e.z.lessThan(1e-4), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(0, 0, 1));
    }).ElseIf(e.x.greaterThan(0.9999), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(-1, 0, 0));
    }).ElseIf(e.y.greaterThan(0.9999), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(0, -1, 0));
    }).ElseIf(e.z.greaterThan(0.9999), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(0, 0, -1));
    }).Else(()=>{
        const s = r.sample(e.add($d7238066c5de7f1c$var$ne(-0.01, 0, 0))).r.sub(r.sample(e.add($d7238066c5de7f1c$var$ne(0.01, 0, 0))).r), a = r.sample(e.add($d7238066c5de7f1c$var$ne(0, -0.01, 0))).r.sub(r.sample(e.add($d7238066c5de7f1c$var$ne(0, 0.01, 0))).r), o = r.sample(e.add($d7238066c5de7f1c$var$ne(0, 0, -0.01))).r.sub(r.sample(e.add($d7238066c5de7f1c$var$ne(0, 0, 0.01))).r);
        i.assign($d7238066c5de7f1c$var$ne(s, a, o));
    }), i.normalize();
});
class $d7238066c5de7f1c$var$mae extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "Texture3DNode";
    }
    /**
   * Constructs a new 3D texture node.
   *
   * @param {Data3DTexture} value - The 3D texture.
   * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
   * @param {?Node<int>} [levelNode=null] - The level node.
   */ constructor(e, t = null, i = null){
        super(e, t, i), this.isTexture3DNode = !0;
    }
    /**
   * Overwrites the default implementation to return a fixed value `'texture3D'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return "texture3D";
    }
    /**
   * Returns a default uv node which is in context of 3D textures a three-dimensional
   * uv node.
   *
   * @return {Node<vec3>} The default uv node.
   */ getDefaultUV() {
        return $d7238066c5de7f1c$var$ne(0.5, 0.5, 0.5);
    }
    /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for 3D textures. The uv transformation matrix is not applied to 3D textures.
   *
   * @param {boolean} value - The update toggle.
   */ setUpdateMatrix() {}
    // Ignore .updateMatrix for 3d TextureNode
    /**
   * Overwrites the default implementation to return the unmodified uv node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The unmodified uv node.
   */ setupUV(e, t) {
        const i = this.value;
        return e.isFlipY() && (i.isRenderTargetTexture === !0 || i.isFramebufferTexture === !0) && (this.sampler ? t = t.flipY() : t = t.setY($d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$mI(this, this.levelNode).y).sub(t.y).sub(1))), t;
    }
    /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */ generateUV(e, t) {
        return t.build(e, this.sampler === !0 ? "vec3" : "ivec3");
    }
    /**
   * Generates the offset code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} offsetNode - The offset node to generate code for.
   * @return {string} The generated code snippet.
   */ generateOffset(e, t) {
        return t.build(e, "ivec3");
    }
    /**
   * TODO.
   *
   * @param {Node<vec3>} uvNode - The uv node .
   * @return {Node<vec3>} TODO.
   */ normal(e) {
        return $d7238066c5de7f1c$var$pae({
            texture: this,
            uv: e
        });
    }
}
const $d7238066c5de7f1c$var$gD = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$mae).setParameterLength(1, 3);
class $d7238066c5de7f1c$var$Aae extends $d7238066c5de7f1c$var$ZR {
    static get type() {
        return "UserDataNode";
    }
    /**
   * Constructs a new user data node.
   *
   * @param {string} property - The property name that should be referenced by the node.
   * @param {string} inputType - The node data type of the reference.
   * @param {?Object} [userData=null] - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
   */ constructor(e, t, i = null){
        super(e, t, i), this.userData = i;
    }
    /**
   * Overwritten to make sure {@link ReferenceNode#reference} points to the correct
   * `userData` field.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state to evaluate.
   * @return {Object} A reference to the `userData` field.
   */ updateReference(e) {
        return this.reference = this.userData !== null ? this.userData : e.object.userData, this.reference;
    }
}
const $d7238066c5de7f1c$var$bae = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Aae(r, e, t)), $d7238066c5de7f1c$var$G9 = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$yae extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "VelocityNode";
    }
    /**
   * Constructs a new vertex color node.
   */ constructor(){
        super("vec2"), this.projectionMatrix = null, this.updateType = $d7238066c5de7f1c$var$Dt.OBJECT, this.updateAfterType = $d7238066c5de7f1c$var$Dt.OBJECT, this.previousModelWorldMatrix = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ji()), this.previousProjectionMatrix = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ji()).setGroup($d7238066c5de7f1c$var$ft), this.previousCameraViewMatrix = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ji());
    }
    /**
   * Sets the given projection matrix.
   *
   * @param {Matrix4} projectionMatrix - The projection matrix to set.
   */ setProjectionMatrix(e) {
        this.projectionMatrix = e;
    }
    /**
   * Updates velocity specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update({ frameId: e, camera: t, object: i }) {
        const n = $d7238066c5de7f1c$var$v9(i);
        this.previousModelWorldMatrix.value.copy(n);
        const s = $d7238066c5de7f1c$var$lD(t);
        s.frameId !== e && (s.frameId = e, s.previousProjectionMatrix === void 0 ? (s.previousProjectionMatrix = new $d7238066c5de7f1c$var$Ji(), s.previousCameraViewMatrix = new $d7238066c5de7f1c$var$Ji(), s.currentProjectionMatrix = new $d7238066c5de7f1c$var$Ji(), s.currentCameraViewMatrix = new $d7238066c5de7f1c$var$Ji(), s.previousProjectionMatrix.copy(this.projectionMatrix || t.projectionMatrix), s.previousCameraViewMatrix.copy(t.matrixWorldInverse)) : (s.previousProjectionMatrix.copy(s.currentProjectionMatrix), s.previousCameraViewMatrix.copy(s.currentCameraViewMatrix)), s.currentProjectionMatrix.copy(this.projectionMatrix || t.projectionMatrix), s.currentCameraViewMatrix.copy(t.matrixWorldInverse), this.previousProjectionMatrix.value.copy(s.previousProjectionMatrix), this.previousCameraViewMatrix.value.copy(s.previousCameraViewMatrix));
    }
    /**
   * Overwritten to updated velocity specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ updateAfter({ object: e }) {
        $d7238066c5de7f1c$var$v9(e).copy(e.matrixWorld);
    }
    /**
   * Implements the velocity computation based on the previous and current vertex data.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec2>} The motion vector.
   */ setup() {
        const e = this.projectionMatrix === null ? $d7238066c5de7f1c$var$s0 : $d7238066c5de7f1c$var$yt(this.projectionMatrix), t = this.previousCameraViewMatrix.mul(this.previousModelWorldMatrix), i = e.mul($d7238066c5de7f1c$var$qC).mul($d7238066c5de7f1c$var$Ns), n = this.previousProjectionMatrix.mul(t).mul($d7238066c5de7f1c$var$NZ), s = i.xy.div(i.w), a = n.xy.div(n.w);
        return $d7238066c5de7f1c$var$wi(s, a);
    }
}
function $d7238066c5de7f1c$var$lD(r) {
    let e = $d7238066c5de7f1c$var$G9.get(r);
    return e === void 0 && (e = {}, $d7238066c5de7f1c$var$G9.set(r, e)), e;
}
function $d7238066c5de7f1c$var$v9(r, e = 0) {
    const t = $d7238066c5de7f1c$var$lD(r);
    let i = t[e];
    return i === void 0 && (t[e] = i = new $d7238066c5de7f1c$var$Ji(), t[e].copy(r.matrixWorld)), i;
}
const $d7238066c5de7f1c$var$Bae = /* @__PURE__ */ $d7238066c5de7f1c$var$je($d7238066c5de7f1c$var$yae), $d7238066c5de7f1c$var$fae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>$d7238066c5de7f1c$var$vY(r.rgb)), $d7238066c5de7f1c$var$Gae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e = $d7238066c5de7f1c$var$J(1)])=>e.mix($d7238066c5de7f1c$var$vY(r.rgb), r.rgb)), $d7238066c5de7f1c$var$vae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e = $d7238066c5de7f1c$var$J(1)])=>{
    const t = $d7238066c5de7f1c$var$Ps(r.r, r.g, r.b).div(3), i = r.r.max(r.g.max(r.b)), n = i.sub(t).mul(e).mul(-3);
    return $d7238066c5de7f1c$var$qi(r.rgb, i, n);
}), $d7238066c5de7f1c$var$Sae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e = $d7238066c5de7f1c$var$J(1)])=>{
    const t = $d7238066c5de7f1c$var$ne(0.57735, 0.57735, 0.57735), i = e.cos();
    return $d7238066c5de7f1c$var$ne(r.rgb.mul(i).add(t.cross(r.rgb).mul(e.sin()).add(t.mul($d7238066c5de7f1c$var$tc(t, r.rgb).mul(i.oneMinus())))));
}), $d7238066c5de7f1c$var$vY = (r, e = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$sn.getLuminanceCoefficients(new $d7238066c5de7f1c$var$Ce())))=>$d7238066c5de7f1c$var$tc(r, e), $d7238066c5de7f1c$var$Zae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e = $d7238066c5de7f1c$var$ne(1), t = $d7238066c5de7f1c$var$ne(0), i = $d7238066c5de7f1c$var$ne(1), n = $d7238066c5de7f1c$var$J(1), // ASC CDL v1.2 explicitly requires Rec. 709 luminance coefficients.
s = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$sn.getLuminanceCoefficients(new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$fZ))])=>{
    const a = r.rgb.dot($d7238066c5de7f1c$var$ne(s)), o = $d7238066c5de7f1c$var$En(r.rgb.mul(e).add(t), 0).toVar(), g = o.pow(i).toVar();
    return $d7238066c5de7f1c$var$Ht(o.r.greaterThan(0), ()=>{
        o.r.assign(g.r);
    }), $d7238066c5de7f1c$var$Ht(o.g.greaterThan(0), ()=>{
        o.g.assign(g.g);
    }), $d7238066c5de7f1c$var$Ht(o.b.greaterThan(0), ()=>{
        o.b.assign(g.b);
    }), o.assign(a.add(o.sub(a).mul(n))), $d7238066c5de7f1c$var$Rt(o.rgb, r.a);
});
class $d7238066c5de7f1c$var$Rae extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "PosterizeNode";
    }
    /**
   * Constructs a new posterize node.
   *
   * @param {Node} sourceNode - The input color.
   * @param {Node} stepsNode - Controls the intensity of the posterization effect. A lower number results in a more blocky appearance.
   */ constructor(e, t){
        super(), this.sourceNode = e, this.stepsNode = t;
    }
    setup() {
        const { sourceNode: e, stepsNode: t } = this;
        return e.mul(t).floor().div(t);
    }
}
const $d7238066c5de7f1c$var$Vae = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Rae).setParameterLength(2), $d7238066c5de7f1c$var$kv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
class $d7238066c5de7f1c$var$cD extends $d7238066c5de7f1c$var$Iu {
    static get type() {
        return "PassTextureNode";
    }
    /**
   * Constructs a new pass texture node.
   *
   * @param {PassNode} passNode - The pass node.
   * @param {Texture} texture - The output texture.
   */ constructor(e, t){
        super(t), this.passNode = e, this.setUpdateMatrix(!1);
    }
    setup(e) {
        return this.passNode.build(e), super.setup(e);
    }
    clone() {
        return new this.constructor(this.passNode, this.value);
    }
}
class $d7238066c5de7f1c$var$S9 extends $d7238066c5de7f1c$var$cD {
    static get type() {
        return "PassMultipleTextureNode";
    }
    /**
   * Constructs a new pass texture node.
   *
   * @param {PassNode} passNode - The pass node.
   * @param {string} textureName - The output texture name.
   * @param {boolean} [previousTexture=false] - Whether previous frame data should be used or not.
   */ constructor(e, t, i = !1){
        super(e, null), this.textureName = t, this.previousTexture = i;
    }
    /**
   * Updates the texture reference of this node.
   */ updateTexture() {
        this.value = this.previousTexture ? this.passNode.getPreviousTexture(this.textureName) : this.passNode.getTexture(this.textureName);
    }
    setup(e) {
        return this.updateTexture(), super.setup(e);
    }
    clone() {
        const e = new this.constructor(this.passNode, this.textureName, this.previousTexture);
        return e.uvNode = this.uvNode, e.levelNode = this.levelNode, e.biasNode = this.biasNode, e.sampler = this.sampler, e.depthNode = this.depthNode, e.compareNode = this.compareNode, e.gradNode = this.gradNode, e.offsetNode = this.offsetNode, e;
    }
}
class $d7238066c5de7f1c$var$du extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "PassNode";
    }
    /**
   * Constructs a new pass node.
   *
   * @param {('color'|'depth')} scope - The scope of the pass. The scope determines whether the node outputs color or depth.
   * @param {Scene} scene - A reference to the scene.
   * @param {Camera} camera - A reference to the camera.
   * @param {Object} options - Options for the internal render target.
   */ constructor(e, t, i, n = {}){
        super("vec4"), this.scope = e, this.scene = t, this.camera = i, this.options = n, this._pixelRatio = 1, this._width = 1, this._height = 1;
        const s = new $d7238066c5de7f1c$var$$l();
        s.isRenderTargetTexture = !0, s.name = "depth";
        const a = new $d7238066c5de7f1c$var$WI(this._width * this._pixelRatio, this._height * this._pixelRatio, {
            type: $d7238066c5de7f1c$var$Ia,
            ...n
        });
        a.texture.name = "output", a.depthTexture = s, this.renderTarget = a, this._textures = {
            output: a.texture,
            depth: s
        }, this._textureNodes = {}, this._linearDepthNodes = {}, this._viewZNodes = {}, this._previousTextures = {}, this._previousTextureNodes = {}, this._cameraNear = $d7238066c5de7f1c$var$yt(0), this._cameraFar = $d7238066c5de7f1c$var$yt(0), this._mrt = null, this._layers = null, this._resolutionScale = 1, this._viewport = null, this._scissor = null, this.isPassNode = !0, this.updateBeforeType = $d7238066c5de7f1c$var$Dt.FRAME, this.global = !0;
    }
    /**
   * Sets the resolution scale for the pass.
   * The resolution scale is a factor that is multiplied with the renderer's width and height.
   *
   * @param {number} resolutionScale - The resolution scale to set. A value of `1` means full resolution.
   * @return {PassNode} A reference to this pass.
   */ setResolutionScale(e) {
        return this._resolutionScale = e, this;
    }
    /**
   * Gets the current resolution scale of the pass.
   *
   * @return {number} The current resolution scale. A value of `1` means full resolution.
   */ getResolutionScale() {
        return this._resolutionScale;
    }
    /**
   * Sets the resolution for the pass.
   * The resolution is a factor that is multiplied with the renderer's width and height.
   *
   * @param {number} resolution - The resolution to set. A value of `1` means full resolution.
   * @return {PassNode} A reference to this pass.
   * @deprecated since r181. Use {@link PassNode#setResolutionScale `setResolutionScale()`} instead.
   */ setResolution(e) {
        return $d7238066c5de7f1c$var$ze("PassNode: .setResolution() is deprecated. Use .setResolutionScale() instead."), this.setResolutionScale(e);
    }
    /**
   * Gets the current resolution of the pass.
   *
   * @return {number} The current resolution. A value of `1` means full resolution.
   * @deprecated since r181. Use {@link PassNode#getResolutionScale `getResolutionScale()`} instead.
   */ getResolution() {
        return $d7238066c5de7f1c$var$ze("PassNode: .getResolution() is deprecated. Use .getResolutionScale() instead."), this.getResolutionScale();
    }
    /**
   * Sets the layer configuration that should be used when rendering the pass.
   *
   * @param {Layers} layers - The layers object to set.
   * @return {PassNode} A reference to this pass.
   */ setLayers(e) {
        return this._layers = e, this;
    }
    /**
   * Gets the current layer configuration of the pass.
   *
   * @return {?Layers} .
   */ getLayers() {
        return this._layers;
    }
    /**
   * Sets the given MRT node to setup MRT for this pass.
   *
   * @param {MRTNode} mrt - The MRT object.
   * @return {PassNode} A reference to this pass.
   */ setMRT(e) {
        return this._mrt = e, this;
    }
    /**
   * Returns the current MRT node.
   *
   * @return {MRTNode} The current MRT node.
   */ getMRT() {
        return this._mrt;
    }
    /**
   * Returns the texture for the given output name.
   *
   * @param {string} name - The output name to get the texture for.
   * @return {Texture} The texture.
   */ getTexture(e) {
        let t = this._textures[e];
        return t === void 0 && (t = this.renderTarget.texture.clone(), t.name = e, this._textures[e] = t, this.renderTarget.textures.push(t)), t;
    }
    /**
   * Returns the texture holding the data of the previous frame for the given output name.
   *
   * @param {string} name - The output name to get the texture for.
   * @return {Texture} The texture holding the data of the previous frame.
   */ getPreviousTexture(e) {
        let t = this._previousTextures[e];
        return t === void 0 && (t = this.getTexture(e).clone(), this._previousTextures[e] = t), t;
    }
    /**
   * Switches current and previous textures for the given output name.
   *
   * @param {string} name - The output name.
   */ toggleTexture(e) {
        const t = this._previousTextures[e];
        if (t !== void 0) {
            const i = this._textures[e], n = this.renderTarget.textures.indexOf(i);
            this.renderTarget.textures[n] = t, this._textures[e] = t, this._previousTextures[e] = i, this._textureNodes[e].updateTexture(), this._previousTextureNodes[e].updateTexture();
        }
    }
    /**
   * Returns the texture node for the given output name.
   *
   * @param {string} [name='output'] - The output name to get the texture node for.
   * @return {TextureNode} The texture node.
   */ getTextureNode(e = "output") {
        let t = this._textureNodes[e];
        return t === void 0 && (t = $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$S9(this, e)), t.updateTexture(), this._textureNodes[e] = t), t;
    }
    /**
   * Returns the previous texture node for the given output name.
   *
   * @param {string} [name='output'] - The output name to get the previous texture node for.
   * @return {TextureNode} The previous texture node.
   */ getPreviousTextureNode(e = "output") {
        let t = this._previousTextureNodes[e];
        return t === void 0 && (this._textureNodes[e] === void 0 && this.getTextureNode(e), t = $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$S9(this, e, !0)), t.updateTexture(), this._previousTextureNodes[e] = t), t;
    }
    /**
   * Returns a viewZ node of this pass.
   *
   * @param {string} [name='depth'] - The output name to get the viewZ node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
   * @return {Node} The viewZ node.
   */ getViewZNode(e = "depth") {
        let t = this._viewZNodes[e];
        if (t === void 0) {
            const i = this._cameraNear, n = this._cameraFar;
            this._viewZNodes[e] = t = $d7238066c5de7f1c$var$IY(this.getTextureNode(e), i, n);
        }
        return t;
    }
    /**
   * Returns a linear depth node of this pass.
   *
   * @param {string} [name='depth'] - The output name to get the linear depth node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
   * @return {Node} The linear depth node.
   */ getLinearDepthNode(e = "depth") {
        let t = this._linearDepthNodes[e];
        if (t === void 0) {
            const i = this._cameraNear, n = this._cameraFar, s = this.getViewZNode(e);
            this._linearDepthNodes[e] = t = $d7238066c5de7f1c$var$wA(s, i, n);
        }
        return t;
    }
    /**
   * Precompiles the pass.
   *
   * Note that this method must be called after the pass configuration is complete.
   * So calls like `setMRT()` and `getTextureNode()` must proceed the precompilation.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the compile has been finished.
   * @see {@link Renderer#compileAsync}
   */ async compileAsync(e) {
        const t = e.getRenderTarget(), i = e.getMRT();
        e.setRenderTarget(this.renderTarget), e.setMRT(this._mrt), await e.compileAsync(this.scene, this.camera), e.setRenderTarget(t), e.setMRT(i);
    }
    setup({ renderer: e }) {
        return this.renderTarget.samples = this.options.samples === void 0 ? e.samples : this.options.samples, this.renderTarget.texture.type = e.getColorBufferType(), this.scope === $d7238066c5de7f1c$var$du.COLOR ? this.getTextureNode() : this.getLinearDepthNode();
    }
    updateBefore(e) {
        const { renderer: t } = e, { scene: i } = this;
        let n, s;
        const a = t.getOutputRenderTarget();
        a && a.isXRRenderTarget === !0 ? (s = 1, n = t.xr.getCamera(), t.xr.updateCamera(n), $d7238066c5de7f1c$var$kv.set(a.width, a.height)) : (n = this.camera, s = t.getPixelRatio(), t.getSize($d7238066c5de7f1c$var$kv)), this._pixelRatio = s, this.setSize($d7238066c5de7f1c$var$kv.width, $d7238066c5de7f1c$var$kv.height);
        const o = t.getRenderTarget(), g = t.getMRT(), l = t.autoClear, c = n.layers.mask;
        this._cameraNear.value = n.near, this._cameraFar.value = n.far, this._layers !== null && (n.layers.mask = this._layers.mask);
        for(const p in this._previousTextures)this.toggleTexture(p);
        t.setRenderTarget(this.renderTarget), t.setMRT(this._mrt), t.autoClear = !0;
        const d = i.name;
        i.name = this.name ? this.name : i.name, t.render(i, n), i.name = d, t.setRenderTarget(o), t.setMRT(g), t.autoClear = l, n.layers.mask = c;
    }
    /**
   * Sets the size of the pass's render target. Honors the pixel ratio.
   *
   * @param {number} width - The width to set.
   * @param {number} height - The height to set.
   */ setSize(e, t) {
        this._width = e, this._height = t;
        const i = Math.floor(this._width * this._pixelRatio * this._resolutionScale), n = Math.floor(this._height * this._pixelRatio * this._resolutionScale);
        this.renderTarget.setSize(i, n), this._scissor !== null && this.renderTarget.scissor.copy(this._scissor), this._viewport !== null && this.renderTarget.viewport.copy(this._viewport);
    }
    /**
   * This method allows to define the pass's scissor rectangle. By default, the scissor rectangle is kept
   * in sync with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
   * with `null` as the single argument.
   *
   * @param {?(number | Vector4)} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
   * Instead of passing four arguments, the method also works with a single four-dimensional vector.
   * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
   * @param {number} width - The width of the scissor box in logical pixel unit.
   * @param {number} height - The height of the scissor box in logical pixel unit.
   */ setScissor(e, t, i, n) {
        e === null ? this._scissor = null : (this._scissor === null && (this._scissor = new $d7238066c5de7f1c$var$Gi()), e.isVector4 ? this._scissor.copy(e) : this._scissor.set(e, t, i, n), this._scissor.multiplyScalar(this._pixelRatio * this._resolutionScale).floor());
    }
    /**
   * This method allows to define the pass's viewport. By default, the viewport is kept in sync
   * with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
   * with `null` as the single argument.
   *
   * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
   * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
   * @param {number} width - The width of the viewport in logical pixel unit.
   * @param {number} height - The height of the viewport in logical pixel unit.
   */ setViewport(e, t, i, n) {
        e === null ? this._viewport = null : (this._viewport === null && (this._viewport = new $d7238066c5de7f1c$var$Gi()), e.isVector4 ? this._viewport.copy(e) : this._viewport.set(e, t, i, n), this._viewport.multiplyScalar(this._pixelRatio * this._resolutionScale).floor());
    }
    /**
   * Sets the pixel ratio the pass's render target and updates the size.
   *
   * @param {number} pixelRatio - The pixel ratio to set.
   */ setPixelRatio(e) {
        this._pixelRatio = e, this.setSize(this._width, this._height);
    }
    /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */ dispose() {
        this.renderTarget.dispose();
    }
}
$d7238066c5de7f1c$var$du.COLOR = "color";
$d7238066c5de7f1c$var$du.DEPTH = "depth";
const $d7238066c5de7f1c$var$wae = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$du($d7238066c5de7f1c$var$du.COLOR, r, e, t)), $d7238066c5de7f1c$var$Wae = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$cD(r, e)), $d7238066c5de7f1c$var$Hae = (r, e, t)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$du($d7238066c5de7f1c$var$du.DEPTH, r, e, t));
class $d7238066c5de7f1c$var$Xae extends $d7238066c5de7f1c$var$du {
    static get type() {
        return "ToonOutlinePassNode";
    }
    /**
   * Constructs a new outline pass node.
   *
   * @param {Scene} scene - A reference to the scene.
   * @param {Camera} camera - A reference to the camera.
   * @param {Node} colorNode - Defines the outline's color.
   * @param {Node} thicknessNode - Defines the outline's thickness.
   * @param {Node} alphaNode - Defines the outline's alpha.
   */ constructor(e, t, i, n, s){
        super($d7238066c5de7f1c$var$du.COLOR, e, t), this.colorNode = i, this.thicknessNode = n, this.alphaNode = s, this._materialCache = /* @__PURE__ */ new WeakMap(), this.name = "Outline Pass";
    }
    updateBefore(e) {
        const { renderer: t } = e, i = t.getRenderObjectFunction();
        t.setRenderObjectFunction((n, s, a, o, g, l, c, d)=>{
            if ((g.isMeshToonMaterial || g.isMeshToonNodeMaterial) && g.wireframe === !1) {
                const p = this._getOutlineMaterial(g);
                t.renderObject(n, s, a, o, p, l, c, d);
            }
            t.renderObject(n, s, a, o, g, l, c, d);
        }), super.updateBefore(e), t.setRenderObjectFunction(i);
    }
    /**
   * Creates the material used for outline rendering.
   *
   * @private
   * @return {NodeMaterial} The outline material.
   */ _createMaterial() {
        const e = new $d7238066c5de7f1c$var$Bs();
        e.isMeshToonOutlineMaterial = !0, e.name = "Toon_Outline", e.side = $d7238066c5de7f1c$var$Ka;
        const t = $d7238066c5de7f1c$var$No.negate(), i = $d7238066c5de7f1c$var$s0.mul($d7238066c5de7f1c$var$qC), n = $d7238066c5de7f1c$var$J(1), s = i.mul($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$Ns, 1)), a = i.mul($d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$Ns.add(t), 1)), o = $d7238066c5de7f1c$var$wo(s.sub(a));
        return e.vertexNode = s.add(o.mul(this.thicknessNode).mul(s.w).mul(n)), e.colorNode = $d7238066c5de7f1c$var$Rt(this.colorNode, this.alphaNode), e;
    }
    /**
   * For the given toon material, this method returns a corresponding
   * outline material.
   *
   * @private
   * @param {(MeshToonMaterial|MeshToonNodeMaterial)} originalMaterial - The toon material.
   * @return {NodeMaterial} The outline material.
   */ _getOutlineMaterial(e) {
        let t = this._materialCache.get(e);
        return t === void 0 && (t = this._createMaterial(), this._materialCache.set(e, t)), t;
    }
}
const $d7238066c5de7f1c$var$Nae = (r, e, t = new $d7238066c5de7f1c$var$rn(0, 0, 0), i = 3e-3, n = 1)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$Xae(r, e, $d7238066c5de7f1c$var$He(t), $d7238066c5de7f1c$var$He(i), $d7238066c5de7f1c$var$He(n))), $d7238066c5de7f1c$var$uD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>r.mul(e).clamp()).setLayout({
    name: "linearToneMapping",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        },
        {
            name: "exposure",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$ID = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>(r = r.mul(e), r.div(r.add(1)).clamp())).setLayout({
    name: "reinhardToneMapping",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        },
        {
            name: "exposure",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$dD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    r = r.mul(e), r = r.sub(4e-3).max(0);
    const t = r.mul(r.mul(6.2).add(0.5)), i = r.mul(r.mul(6.2).add(1.7)).add(0.06);
    return t.div(i).pow(2.2);
}).setLayout({
    name: "cineonToneMapping",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        },
        {
            name: "exposure",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Lae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = r.mul(r.add(0.0245786)).sub(90537e-9), t = r.mul(r.add(0.432951).mul(0.983729)).add(0.238081);
    return e.div(t);
}), $d7238066c5de7f1c$var$hD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$Fa(0.59719, 0.35458, 0.04823, 0.076, 0.90834, 0.01566, 0.0284, 0.13383, 0.83777), i = $d7238066c5de7f1c$var$Fa(1.60475, -0.53108, -0.07367, -0.10208, 1.10813, -0.00605, -0.00327, -0.07276, 1.07602);
    return r = r.mul(e).div(0.6), r = t.mul(r), r = $d7238066c5de7f1c$var$Lae(r), r = i.mul(r), r.clamp();
}).setLayout({
    name: "acesFilmicToneMapping",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        },
        {
            name: "exposure",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Yae = /* @__PURE__ */ $d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$ne(1.6605, -0.1246, -0.0182), $d7238066c5de7f1c$var$ne(-0.5876, 1.1329, -0.1006), $d7238066c5de7f1c$var$ne(-0.0728, -0.0083, 1.1187)), $d7238066c5de7f1c$var$Kae = /* @__PURE__ */ $d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$ne(0.6274, 0.0691, 0.0164), $d7238066c5de7f1c$var$ne(0.3293, 0.9195, 0.088), $d7238066c5de7f1c$var$ne(0.0433, 0.0113, 0.8956)), $d7238066c5de7f1c$var$xae = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$ne(e.mul(e)).toVar(), i = $d7238066c5de7f1c$var$ne(t.mul(t)).toVar();
    return $d7238066c5de7f1c$var$J(15.5).mul(i.mul(t)).sub($d7238066c5de7f1c$var$Et(40.14, i.mul(e))).add($d7238066c5de7f1c$var$Et(31.96, i).sub($d7238066c5de7f1c$var$Et(6.868, t.mul(e))).add($d7238066c5de7f1c$var$Et(0.4298, t).add($d7238066c5de7f1c$var$Et(0.1191, e).sub(232e-5))));
}), $d7238066c5de7f1c$var$CD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$ne(r).toVar(), i = $d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$ne(0.856627153315983, 0.137318972929847, 0.11189821299995), $d7238066c5de7f1c$var$ne(0.0951212405381588, 0.761241990602591, 0.0767994186031903), $d7238066c5de7f1c$var$ne(0.0482516061458583, 0.101439036467562, 0.811302368396859)), n = $d7238066c5de7f1c$var$Fa($d7238066c5de7f1c$var$ne(1.1271005818144368, -0.1413297634984383, -0.14132976349843826), $d7238066c5de7f1c$var$ne(-0.11060664309660323, 1.157823702216272, -0.11060664309660294), $d7238066c5de7f1c$var$ne(-0.016493938717834573, -0.016493938717834257, 1.2519364065950405)), s = $d7238066c5de7f1c$var$J(-12.47393), a = $d7238066c5de7f1c$var$J(4.026069);
    return t.mulAssign(e), t.assign($d7238066c5de7f1c$var$Kae.mul(t)), t.assign(i.mul(t)), t.assign($d7238066c5de7f1c$var$En(t, 1e-10)), t.assign($d7238066c5de7f1c$var$su(t)), t.assign(t.sub(s).div(a.sub(s))), t.assign($d7238066c5de7f1c$var$sl(t, 0, 1)), t.assign($d7238066c5de7f1c$var$xae(t)), t.assign(n.mul(t)), t.assign($d7238066c5de7f1c$var$qg($d7238066c5de7f1c$var$En($d7238066c5de7f1c$var$ne(0), t), $d7238066c5de7f1c$var$ne(2.2))), t.assign($d7238066c5de7f1c$var$Yae.mul(t)), t.assign($d7238066c5de7f1c$var$sl(t, 0, 1)), t;
}).setLayout({
    name: "agxToneMapping",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        },
        {
            name: "exposure",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$pD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$J(0.76), i = $d7238066c5de7f1c$var$J(0.15);
    r = r.mul(e);
    const n = $d7238066c5de7f1c$var$Xo(r.r, $d7238066c5de7f1c$var$Xo(r.g, r.b)), s = $d7238066c5de7f1c$var$or(n.lessThan(0.08), n.sub($d7238066c5de7f1c$var$Et(6.25, n.mul(n))), 0.04);
    r.subAssign(s);
    const a = $d7238066c5de7f1c$var$En(r.r, $d7238066c5de7f1c$var$En(r.g, r.b));
    $d7238066c5de7f1c$var$Ht(a.lessThan(t), ()=>r);
    const o = $d7238066c5de7f1c$var$wi(1, t), g = $d7238066c5de7f1c$var$wi(1, o.mul(o).div(a.add(o.sub(t))));
    r.mulAssign(g.div(a));
    const l = $d7238066c5de7f1c$var$wi(1, $d7238066c5de7f1c$var$cg(1, i.mul(a.sub(g)).add(1)));
    return $d7238066c5de7f1c$var$qi(r, $d7238066c5de7f1c$var$ne(g), l);
}).setLayout({
    name: "neutralToneMapping",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        },
        {
            name: "exposure",
            type: "float"
        }
    ]
});
class $d7238066c5de7f1c$var$Fr extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "CodeNode";
    }
    /**
   * Constructs a new code node.
   *
   * @param {string} [code=''] - The native code.
   * @param {Array<Node>} [includes=[]] - An array of includes.
   * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
   */ constructor(e = "", t = [], i = ""){
        super("code"), this.isCodeNode = !0, this.global = !0, this.code = e, this.includes = t, this.language = i;
    }
    /**
   * Sets the includes of this code node.
   *
   * @param {Array<Node>} includes - The includes to set.
   * @return {CodeNode} A reference to this node.
   */ setIncludes(e) {
        return this.includes = e, this;
    }
    /**
   * Returns the includes of this code node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Array<Node>} The includes.
   */ getIncludes() {
        return this.includes;
    }
    generate(e) {
        const t = this.getIncludes(e);
        for (const n of t)n.build(e);
        const i = e.getCodeFromNode(this, this.getNodeType(e));
        return i.code = this.code, i.code;
    }
    serialize(e) {
        super.serialize(e), e.code = this.code, e.language = this.language;
    }
    deserialize(e) {
        super.deserialize(e), this.code = e.code, this.language = e.language;
    }
}
const $d7238066c5de7f1c$var$xR = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Fr).setParameterLength(1, 3), $d7238066c5de7f1c$var$Fae = (r, e)=>$d7238066c5de7f1c$var$xR(r, e, "js"), $d7238066c5de7f1c$var$Tae = (r, e)=>$d7238066c5de7f1c$var$xR(r, e, "wgsl"), $d7238066c5de7f1c$var$Mae = (r, e)=>$d7238066c5de7f1c$var$xR(r, e, "glsl");
class $d7238066c5de7f1c$var$mD extends $d7238066c5de7f1c$var$Fr {
    static get type() {
        return "FunctionNode";
    }
    /**
   * Constructs a new function node.
   *
   * @param {string} [code=''] - The native code.
   * @param {Array<Node>} [includes=[]] - An array of includes.
   * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
   */ constructor(e = "", t = [], i = ""){
        super(e, t, i);
    }
    /**
   * Returns the type of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type.
   */ getNodeType(e) {
        return this.getNodeFunction(e).type;
    }
    /**
   * Returns the type of a member of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member.
   * @return {string} The type of the member.
   */ getMemberType(e, t) {
        const i = this.getNodeType(e);
        return e.getStructTypeNode(i).getMemberType(e, t);
    }
    /**
   * Returns the inputs of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Array<NodeFunctionInput>} The inputs.
   */ getInputs(e) {
        return this.getNodeFunction(e).inputs;
    }
    /**
   * Returns the node function for this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeFunction} The node function.
   */ getNodeFunction(e) {
        const t = e.getDataFromNode(this);
        let i = t.nodeFunction;
        return i === void 0 && (i = e.parser.parseFunction(this.code), t.nodeFunction = i), i;
    }
    generate(e, t) {
        super.generate(e);
        const i = this.getNodeFunction(e), n = i.name, s = i.type, a = e.getCodeFromNode(this, s);
        n !== "" && (a.name = n);
        const o = e.getPropertyName(a), g = this.getNodeFunction(e).getCode(o);
        return a.code = g + `
`, t === "property" ? o : e.format(`${o}()`, s, t);
    }
}
const $d7238066c5de7f1c$var$AD = (r, e = [], t = "")=>{
    for(let s = 0; s < e.length; s++){
        const a = e[s];
        typeof a == "function" && (e[s] = a.functionNode);
    }
    const i = $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$mD(r, e, t)), n = (...s)=>i.call(...s);
    return n.functionNode = i, n;
}, $d7238066c5de7f1c$var$zae = (r, e)=>$d7238066c5de7f1c$var$AD(r, e, "glsl"), $d7238066c5de7f1c$var$kae = (r, e)=>$d7238066c5de7f1c$var$AD(r, e, "wgsl");
class $d7238066c5de7f1c$var$Eae extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ScriptableValueNode";
    }
    /**
   * Constructs a new scriptable node.
   *
   * @param {any} [value=null] - The value.
   */ constructor(e = null){
        super(), this._value = e, this._cache = null, this.inputType = null, this.outputType = null, this.events = new $d7238066c5de7f1c$var$wI(), this.isScriptableValueNode = !0;
    }
    /**
   * Whether this node represents an output or not.
   *
   * @type {boolean}
   * @readonly
   * @default true
   */ get isScriptableOutputNode() {
        return this.outputType !== null;
    }
    set value(e) {
        this._value !== e && (this._cache && this.inputType === "URL" && this.value.value instanceof ArrayBuffer && (URL.revokeObjectURL(this._cache), this._cache = null), this._value = e, this.events.dispatchEvent({
            type: "change"
        }), this.refresh());
    }
    /**
   * The node's value.
   *
   * @type {any}
   */ get value() {
        return this._value;
    }
    /**
   * Dispatches the `refresh` event.
   */ refresh() {
        this.events.dispatchEvent({
            type: "refresh"
        });
    }
    /**
   * The `value` property usually represents a node or even binary data in form of array buffers.
   * In this case, this method tries to return the actual value behind the complex type.
   *
   * @return {any} The value.
   */ getValue() {
        const e = this.value;
        if (e && this._cache === null && this.inputType === "URL" && e.value instanceof ArrayBuffer) this._cache = URL.createObjectURL(new Blob([
            e.value
        ]));
        else if (e && e.value !== null && e.value !== void 0 && ((this.inputType === "URL" || this.inputType === "String") && typeof e.value == "string" || this.inputType === "Number" && typeof e.value == "number" || this.inputType === "Vector2" && e.value.isVector2 || this.inputType === "Vector3" && e.value.isVector3 || this.inputType === "Vector4" && e.value.isVector4 || this.inputType === "Color" && e.value.isColor || this.inputType === "Matrix3" && e.value.isMatrix3 || this.inputType === "Matrix4" && e.value.isMatrix4)) return e.value;
        return this._cache || e;
    }
    /**
   * Overwritten since the node type is inferred from the value.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.value && this.value.isNode ? this.value.getNodeType(e) : "float";
    }
    setup() {
        return this.value && this.value.isNode ? this.value : $d7238066c5de7f1c$var$J();
    }
    serialize(e) {
        super.serialize(e), this.value !== null ? this.inputType === "ArrayBuffer" ? e.value = $d7238066c5de7f1c$var$B3(this.value) : e.value = this.value ? this.value.toJSON(e.meta).uuid : null : e.value = null, e.inputType = this.inputType, e.outputType = this.outputType;
    }
    deserialize(e) {
        super.deserialize(e);
        let t = null;
        e.value !== null && (e.inputType === "ArrayBuffer" ? t = $d7238066c5de7f1c$var$f3(e.value) : e.inputType === "Texture" ? t = e.meta.textures[e.value] : t = e.meta.nodes[e.value] || null), this.value = t, this.inputType = e.inputType, this.outputType = e.outputType;
    }
}
const $d7238066c5de7f1c$var$XS = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Eae).setParameterLength(1);
class $d7238066c5de7f1c$var$bD extends Map {
    get(e, t = null, ...i) {
        if (this.has(e)) return super.get(e);
        if (t !== null) {
            const n = t(...i);
            return this.set(e, n), n;
        }
    }
}
class $d7238066c5de7f1c$var$Jae {
    constructor(e){
        this.scriptableNode = e;
    }
    get parameters() {
        return this.scriptableNode.parameters;
    }
    get layout() {
        return this.scriptableNode.getLayout();
    }
    getInputLayout(e) {
        return this.scriptableNode.getInputLayout(e);
    }
    get(e) {
        const t = this.parameters[e];
        return t ? t.getValue() : null;
    }
}
const $d7238066c5de7f1c$var$NS = new $d7238066c5de7f1c$var$bD();
class $d7238066c5de7f1c$var$Uae extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ScriptableNode";
    }
    /**
   * Constructs a new scriptable node.
   *
   * @param {?CodeNode} [codeNode=null] - The code node.
   * @param {Object} [parameters={}] - The parameters definition.
   */ constructor(e = null, t = {}){
        super(), this.codeNode = e, this.parameters = t, this._local = new $d7238066c5de7f1c$var$bD(), this._output = $d7238066c5de7f1c$var$XS(null), this._outputs = {}, this._source = this.source, this._method = null, this._object = null, this._value = null, this._needsOutputUpdate = !0, this.onRefresh = this.onRefresh.bind(this), this.isScriptableNode = !0;
    }
    /**
   * The source code of the scriptable node.
   *
   * @type {string}
   */ get source() {
        return this.codeNode ? this.codeNode.code : "";
    }
    /**
   * Sets the reference of a local script variable.
   *
   * @param {string} name - The variable name.
   * @param {Object} value - The reference to set.
   * @return {Resources} The resource map
   */ setLocal(e, t) {
        return this._local.set(e, t);
    }
    /**
   * Gets the value of a local script variable.
   *
   * @param {string} name - The variable name.
   * @return {Object} The value.
   */ getLocal(e) {
        return this._local.get(e);
    }
    /**
   * Event listener for the `refresh` event.
   */ onRefresh() {
        this._refresh();
    }
    /**
   * Returns an input from the layout with the given id/name.
   *
   * @param {string} id - The id/name of the input.
   * @return {Object} The element entry.
   */ getInputLayout(e) {
        for (const t of this.getLayout())if (t.inputType && (t.id === e || t.name === e)) return t;
    }
    /**
   * Returns an output from the layout with the given id/name.
   *
   * @param {string} id - The id/name of the output.
   * @return {Object} The element entry.
   */ getOutputLayout(e) {
        for (const t of this.getLayout())if (t.outputType && (t.id === e || t.name === e)) return t;
    }
    /**
   * Defines a script output for the given name and value.
   *
   * @param {string} name - The name of the output.
   * @param {Node} value - The node value.
   * @return {ScriptableNode} A reference to this node.
   */ setOutput(e, t) {
        const i = this._outputs;
        return i[e] === void 0 ? i[e] = $d7238066c5de7f1c$var$XS(t) : i[e].value = t, this;
    }
    /**
   * Returns a script output for the given name.
   *
   * @param {string} name - The name of the output.
   * @return {ScriptableValueNode} The node value.
   */ getOutput(e) {
        return this._outputs[e];
    }
    /**
   * Returns a parameter for the given name
   *
   * @param {string} name - The name of the parameter.
   * @return {ScriptableValueNode} The node value.
   */ getParameter(e) {
        return this.parameters[e];
    }
    /**
   * Sets a value for the given parameter name.
   *
   * @param {string} name - The parameter name.
   * @param {any} value - The parameter value.
   * @return {ScriptableNode} A reference to this node.
   */ setParameter(e, t) {
        const i = this.parameters;
        return t && t.isScriptableNode ? (this.deleteParameter(e), i[e] = t, i[e].getDefaultOutput().events.addEventListener("refresh", this.onRefresh)) : t && t.isScriptableValueNode ? (this.deleteParameter(e), i[e] = t, i[e].events.addEventListener("refresh", this.onRefresh)) : i[e] === void 0 ? (i[e] = $d7238066c5de7f1c$var$XS(t), i[e].events.addEventListener("refresh", this.onRefresh)) : i[e].value = t, this;
    }
    /**
   * Returns the value of this node which is the value of
   * the default output.
   *
   * @return {Node} The value.
   */ getValue() {
        return this.getDefaultOutput().getValue();
    }
    /**
   * Deletes a parameter from the script.
   *
   * @param {string} name - The parameter to remove.
   * @return {ScriptableNode} A reference to this node.
   */ deleteParameter(e) {
        let t = this.parameters[e];
        return t && (t.isScriptableNode && (t = t.getDefaultOutput()), t.events.removeEventListener("refresh", this.onRefresh)), this;
    }
    /**
   * Deletes all parameters from the script.
   *
   * @return {ScriptableNode} A reference to this node.
   */ clearParameters() {
        for (const e of Object.keys(this.parameters))this.deleteParameter(e);
        return this.needsUpdate = !0, this;
    }
    /**
   * Calls a function from the script.
   *
   * @param {string} name - The function name.
   * @param {...any} params - A list of parameters.
   * @return {any} The result of the function call.
   */ call(e, ...t) {
        const n = this.getObject()[e];
        if (typeof n == "function") return n(...t);
    }
    /**
   * Asynchronously calls a function from the script.
   *
   * @param {string} name - The function name.
   * @param {...any} params - A list of parameters.
   * @return {Promise<any>} The result of the function call.
   */ async callAsync(e, ...t) {
        const n = this.getObject()[e];
        if (typeof n == "function") return n.constructor.name === "AsyncFunction" ? await n(...t) : n(...t);
    }
    /**
   * Overwritten since the node types is inferred from the script's output.
   *
   * @param {NodeBuilder} builder - The current node builder
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.getDefaultOutputNode().getNodeType(e);
    }
    /**
   * Refreshes the script node.
   *
   * @param {?string} [output=null] - An optional output.
   */ refresh(e = null) {
        e !== null ? this.getOutput(e).refresh() : this._refresh();
    }
    /**
   * Returns an object representation of the script.
   *
   * @return {Object} The result object.
   */ getObject() {
        if (this.needsUpdate && this.dispose(), this._object !== null) return this._object;
        const e = ()=>this.refresh(), t = (l, c)=>this.setOutput(l, c), i = new $d7238066c5de7f1c$var$Jae(this), n = $d7238066c5de7f1c$var$NS.get("THREE"), s = $d7238066c5de7f1c$var$NS.get("TSL"), a = this.getMethod(), o = [
            i,
            this._local,
            $d7238066c5de7f1c$var$NS,
            e,
            t,
            n,
            s
        ];
        this._object = a(...o);
        const g = this._object.layout;
        if (g && (g.cache === !1 && this._local.clear(), this._output.outputType = g.outputType || null, Array.isArray(g.elements))) for (const l of g.elements){
            const c = l.id || l.name;
            l.inputType && (this.getParameter(c) === void 0 && this.setParameter(c, null), this.getParameter(c).inputType = l.inputType), l.outputType && (this.getOutput(c) === void 0 && this.setOutput(c, null), this.getOutput(c).outputType = l.outputType);
        }
        return this._object;
    }
    deserialize(e) {
        super.deserialize(e);
        for(const t in this.parameters){
            let i = this.parameters[t];
            i.isScriptableNode && (i = i.getDefaultOutput()), i.events.addEventListener("refresh", this.onRefresh);
        }
    }
    /**
   * Returns the layout of the script.
   *
   * @return {Object} The script's layout.
   */ getLayout() {
        return this.getObject().layout;
    }
    /**
   * Returns default node output of the script.
   *
   * @return {Node} The default node output.
   */ getDefaultOutputNode() {
        const e = this.getDefaultOutput().value;
        return e && e.isNode ? e : $d7238066c5de7f1c$var$J();
    }
    /**
   * Returns default output of the script.
   *
   * @return {ScriptableValueNode} The default output.
   */ getDefaultOutput() {
        return this._exec()._output;
    }
    /**
   * Returns a function created from the node's script.
   *
   * @return {Function} The function representing the node's code.
   */ getMethod() {
        if (this.needsUpdate && this.dispose(), this._method !== null) return this._method;
        const e = [
            "parameters",
            "local",
            "global",
            "refresh",
            "setOutput",
            "THREE",
            "TSL"
        ], i = [
            "layout",
            "init",
            "main",
            "dispose"
        ].join(", "), n = "var " + i + `; var output = {};
`, s = `
return { ...output, ` + i + " };", a = n + this.codeNode.code + s;
        return this._method = new Function(...e, a), this._method;
    }
    /**
   * Frees all internal resources.
   */ dispose() {
        this._method !== null && (this._object && typeof this._object.dispose == "function" && this._object.dispose(), this._method = null, this._object = null, this._source = null, this._value = null, this._needsOutputUpdate = !0, this._output.value = null, this._outputs = {});
    }
    setup() {
        return this.getDefaultOutputNode();
    }
    getCacheKey(e) {
        const t = [
            $d7238066c5de7f1c$var$EB(this.source),
            this.getDefaultOutputNode().getCacheKey(e)
        ];
        for(const i in this.parameters)t.push(this.parameters[i].getCacheKey(e));
        return $d7238066c5de7f1c$var$i0(t);
    }
    set needsUpdate(e) {
        e === !0 && this.dispose();
    }
    get needsUpdate() {
        return this.source !== this._source;
    }
    /**
   * Executes the `main` function of the script.
   *
   * @private
   * @return {ScriptableNode} A reference to this node.
   */ _exec() {
        return this.codeNode === null ? this : (this._needsOutputUpdate === !0 && (this._value = this.call("main"), this._needsOutputUpdate = !1), this._output.value = this._value, this);
    }
    /**
   * Executes the refresh.
   *
   * @private
   */ _refresh() {
        this.needsUpdate = !0, this._exec(), this._output.refresh();
    }
}
const $d7238066c5de7f1c$var$Dae = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Uae).setParameterLength(1, 2);
function $d7238066c5de7f1c$var$yD(r) {
    let e;
    const t = r.context.getViewZ;
    return t !== void 0 && (e = t(this)), (e || $d7238066c5de7f1c$var$Ls.z).negate();
}
const $d7238066c5de7f1c$var$SY = $d7238066c5de7f1c$var$oe(([r, e], t)=>{
    const i = $d7238066c5de7f1c$var$yD(t);
    return $d7238066c5de7f1c$var$ic(r, e, i);
}), $d7238066c5de7f1c$var$ZY = $d7238066c5de7f1c$var$oe(([r], e)=>{
    const t = $d7238066c5de7f1c$var$yD(e);
    return r.mul(r, t, t).negate().exp().oneMinus();
}), $d7238066c5de7f1c$var$bB = $d7238066c5de7f1c$var$oe(([r, e])=>$d7238066c5de7f1c$var$Rt(e.toFloat().mix($d7238066c5de7f1c$var$ZA.rgb, r.toVec3()), $d7238066c5de7f1c$var$ZA.a));
function $d7238066c5de7f1c$var$_ae(r, e, t) {
    return $d7238066c5de7f1c$var$ze('TSL: "rangeFog( color, near, far )" is deprecated. Use "fog( color, rangeFogFactor( near, far ) )" instead.'), $d7238066c5de7f1c$var$bB(r, $d7238066c5de7f1c$var$SY(e, t));
}
function $d7238066c5de7f1c$var$Pae(r, e) {
    return $d7238066c5de7f1c$var$ze('TSL: "densityFog( color, density )" is deprecated. Use "fog( color, densityFogFactor( density ) )" instead.'), $d7238066c5de7f1c$var$bB(r, $d7238066c5de7f1c$var$ZY(e));
}
let $d7238066c5de7f1c$var$lC = null, $d7238066c5de7f1c$var$cC = null;
class $d7238066c5de7f1c$var$Qae extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "RangeNode";
    }
    /**
   * Constructs a new range node.
   *
   * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
   * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
   */ constructor(e = $d7238066c5de7f1c$var$J(), t = $d7238066c5de7f1c$var$J()){
        super(), this.minNode = e, this.maxNode = t;
    }
    /**
   * Returns the vector length which is computed based on the range definition.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {number} The vector length.
   */ getVectorLength(e) {
        const t = this.getConstNode(this.minNode), i = this.getConstNode(this.maxNode), n = e.getTypeLength($d7238066c5de7f1c$var$jd(t.value)), s = e.getTypeLength($d7238066c5de7f1c$var$jd(i.value));
        return n > s ? n : s;
    }
    /**
   * This method is overwritten since the node type is inferred from range definition.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return e.object.count > 1 ? e.getTypeFromLength(this.getVectorLength(e)) : "float";
    }
    /**
   * Returns a constant node from the given node by traversing it.
   *
   * @param {Node} node - The node to traverse.
   * @returns {Node} The constant node, if found.
   */ getConstNode(e) {
        let t = null;
        if (e.traverse((i)=>{
            i.isConstNode === !0 && (t = i);
        }), t === null) throw new Error('THREE.TSL: No "ConstNode" found in node graph.');
        return t;
    }
    setup(e) {
        const t = e.object;
        let i = null;
        if (t.count > 1) {
            const n = this.getConstNode(this.minNode), s = this.getConstNode(this.maxNode), a = n.value, o = s.value, g = e.getTypeLength($d7238066c5de7f1c$var$jd(a)), l = e.getTypeLength($d7238066c5de7f1c$var$jd(o));
            $d7238066c5de7f1c$var$lC = $d7238066c5de7f1c$var$lC || new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$cC = $d7238066c5de7f1c$var$cC || new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$lC.setScalar(0), $d7238066c5de7f1c$var$cC.setScalar(0), g === 1 ? $d7238066c5de7f1c$var$lC.setScalar(a) : a.isColor ? $d7238066c5de7f1c$var$lC.set(a.r, a.g, a.b, 1) : $d7238066c5de7f1c$var$lC.set(a.x, a.y, a.z || 0, a.w || 0), l === 1 ? $d7238066c5de7f1c$var$cC.setScalar(o) : o.isColor ? $d7238066c5de7f1c$var$cC.set(o.r, o.g, o.b, 1) : $d7238066c5de7f1c$var$cC.set(o.x, o.y, o.z || 0, o.w || 0);
            const c = 4, d = c * t.count, p = new Float32Array(d);
            for(let y = 0; y < d; y++){
                const G = y % c, Z = $d7238066c5de7f1c$var$lC.getComponent(G), v = $d7238066c5de7f1c$var$cC.getComponent(G);
                p[y] = $d7238066c5de7f1c$var$o3.lerp(Z, v, Math.random());
            }
            const A = this.getNodeType(e);
            if (t.count <= 4096) i = $d7238066c5de7f1c$var$PB(p, "vec4", t.count).element($d7238066c5de7f1c$var$rh).convert(A);
            else {
                const y = new $d7238066c5de7f1c$var$SA(p, 4);
                e.geometry.setAttribute("__range" + this.id, y), i = $d7238066c5de7f1c$var$XZ(y).convert(A);
            }
        } else i = $d7238066c5de7f1c$var$J(0);
        return i;
    }
}
const $d7238066c5de7f1c$var$Oae = /* @__PURE__ */ $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Qae).setParameterLength(2);
class $d7238066c5de7f1c$var$jae extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ComputeBuiltinNode";
    }
    /**
   * Constructs a new compute builtin node.
   *
   * @param {string} builtinName - The built-in name.
   * @param {string} nodeType - The node type.
   */ constructor(e, t){
        super(t), this._builtinName = e;
    }
    /**
   * This method is overwritten since hash is derived from the built-in name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */ getHash(e) {
        return this.getBuiltinName(e);
    }
    /**
   * This method is overwritten since the node type is simply derived from `nodeType`..
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType() {
        return this.nodeType;
    }
    /**
   * Sets the builtin name.
   *
   * @param {string} builtinName - The built-in name.
   * @return {ComputeBuiltinNode} A reference to this node.
   */ setBuiltinName(e) {
        return this._builtinName = e, this;
    }
    /**
   * Returns the builtin name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The builtin name.
   */ getBuiltinName() {
        return this._builtinName;
    }
    /**
   * Whether the current node builder has the builtin or not.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether the builder has the builtin or not.
   */ hasBuiltin(e) {
        return e.hasBuiltin(this._builtinName);
    }
    generate(e, t) {
        const i = this.getBuiltinName(e), n = this.getNodeType(e);
        return e.shaderStage === "compute" ? e.format(i, n, t) : ($d7238066c5de7f1c$var$ze(`ComputeBuiltinNode: Compute built-in value ${i} can not be accessed in the ${e.shaderStage} stage`), e.generateConst(n));
    }
    serialize(e) {
        super.serialize(e), e.global = this.global, e._builtinName = this._builtinName;
    }
    deserialize(e) {
        super.deserialize(e), this.global = e.global, this._builtinName = e._builtinName;
    }
}
const $d7238066c5de7f1c$var$ef = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$jae(r, e)), $d7238066c5de7f1c$var$qae = /* @__PURE__ */ $d7238066c5de7f1c$var$ef("numWorkgroups", "uvec3"), $d7238066c5de7f1c$var$$ae = /* @__PURE__ */ $d7238066c5de7f1c$var$ef("workgroupId", "uvec3"), $d7238066c5de7f1c$var$eoe = /* @__PURE__ */ $d7238066c5de7f1c$var$ef("globalId", "uvec3"), $d7238066c5de7f1c$var$toe = /* @__PURE__ */ $d7238066c5de7f1c$var$ef("localId", "uvec3"), $d7238066c5de7f1c$var$ioe = /* @__PURE__ */ $d7238066c5de7f1c$var$ef("subgroupSize", "uint");
class $d7238066c5de7f1c$var$noe extends $d7238066c5de7f1c$var$Ct {
    /**
   * Constructs a new barrier node.
   *
   * @param {string} scope - The scope defines the behavior of the node.
   */ constructor(e){
        super(), this.scope = e;
    }
    generate(e) {
        const { scope: t } = this, { renderer: i } = e;
        i.backend.isWebGLBackend === !0 ? e.addFlowCode(`	// ${t}Barrier 
`) : e.addLineFlowCode(`${t}Barrier()`, this);
    }
}
const $d7238066c5de7f1c$var$RY = $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$noe), $d7238066c5de7f1c$var$soe = ()=>$d7238066c5de7f1c$var$RY("workgroup").toStack(), $d7238066c5de7f1c$var$roe = ()=>$d7238066c5de7f1c$var$RY("storage").toStack(), $d7238066c5de7f1c$var$aoe = ()=>$d7238066c5de7f1c$var$RY("texture").toStack();
class $d7238066c5de7f1c$var$ooe extends $d7238066c5de7f1c$var$jC {
    /**
   * Constructs a new workgroup info element node.
   *
   * @param {Node} workgroupInfoNode - The workgroup info node.
   * @param {Node} indexNode - The index node that defines the element access.
   */ constructor(e, t){
        super(e, t), this.isWorkgroupInfoElementNode = !0;
    }
    generate(e, t) {
        let i;
        const n = e.context.assign;
        if (i = super.generate(e), n !== !0) {
            const s = this.getNodeType(e);
            i = e.format(i, s, t);
        }
        return i;
    }
}
class $d7238066c5de7f1c$var$goe extends $d7238066c5de7f1c$var$Ct {
    /**
   * Constructs a new buffer scoped to type scope.
   *
   * @param {string} scope - TODO.
   * @param {string} bufferType - The data type of a 'workgroup' scoped buffer element.
   * @param {number} [bufferCount=0] - The number of elements in the buffer.
   */ constructor(e, t, i = 0){
        super(t), this.bufferType = t, this.bufferCount = i, this.isWorkgroupInfoNode = !0, this.elementType = t, this.scope = e, this.name = "";
    }
    /**
   * Sets the name of this node.
   *
   * @param {string} name - The name to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */ setName(e) {
        return this.name = e, this;
    }
    /**
   * Sets the name/label of this node.
   *
   * @deprecated
   * @param {string} name - The name to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */ label(e) {
        return $d7238066c5de7f1c$var$ze('TSL: "label()" has been deprecated. Use "setName()" instead.'), this.setName(e);
    }
    /**
   * Sets the scope of this node.
   *
   * @param {string} scope - The scope to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */ setScope(e) {
        return this.scope = e, this;
    }
    /**
   * The data type of the array buffer.
   *
   * @return {string} The element type.
   */ getElementType() {
        return this.elementType;
    }
    /**
   * Overwrites the default implementation since the input type
   * is inferred from the scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType() {
        return `${this.scope}Array`;
    }
    /**
   * This method can be used to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {WorkgroupInfoElementNode} A reference to an element.
   */ element(e) {
        return $d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$ooe(this, e));
    }
    generate(e) {
        const t = this.name !== "" ? this.name : `${this.scope}Array_${this.id}`;
        return e.getScopedArray(t, this.scope.toLowerCase(), this.bufferType, this.bufferCount);
    }
}
const $d7238066c5de7f1c$var$loe = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$goe("Workgroup", r, e));
class $d7238066c5de7f1c$var$Vr extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "AtomicFunctionNode";
    }
    /**
   * Constructs a new atomic function node.
   *
   * @param {string} method - The signature of the atomic function to construct.
   * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
   * @param {Node} valueNode - The value that mutates the atomic variable.
   */ constructor(e, t, i){
        super("uint"), this.method = e, this.pointerNode = t, this.valueNode = i, this.parents = !0;
    }
    /**
   * Overwrites the default implementation to return the type of
   * the pointer node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */ getInputType(e) {
        return this.pointerNode.getNodeType(e);
    }
    /**
   * Overwritten since the node type is inferred from the input type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */ getNodeType(e) {
        return this.getInputType(e);
    }
    generate(e) {
        const t = e.getNodeProperties(this), i = t.parents, n = this.method, s = this.getNodeType(e), a = this.getInputType(e), o = this.pointerNode, g = this.valueNode, l = [];
        l.push(`&${o.build(e, a)}`), g !== null && l.push(g.build(e, a));
        const c = `${e.getMethod(n, s)}( ${l.join(", ")} )`;
        if (i ? i.length === 1 && i[0].isStackNode === !0 : !1) e.addLineFlowCode(c, this);
        else return t.constNode === void 0 && (t.constNode = $d7238066c5de7f1c$var$ZI(c, s).toConst()), t.constNode.build(e);
    }
}
$d7238066c5de7f1c$var$Vr.ATOMIC_LOAD = "atomicLoad";
$d7238066c5de7f1c$var$Vr.ATOMIC_STORE = "atomicStore";
$d7238066c5de7f1c$var$Vr.ATOMIC_ADD = "atomicAdd";
$d7238066c5de7f1c$var$Vr.ATOMIC_SUB = "atomicSub";
$d7238066c5de7f1c$var$Vr.ATOMIC_MAX = "atomicMax";
$d7238066c5de7f1c$var$Vr.ATOMIC_MIN = "atomicMin";
$d7238066c5de7f1c$var$Vr.ATOMIC_AND = "atomicAnd";
$d7238066c5de7f1c$var$Vr.ATOMIC_OR = "atomicOr";
$d7238066c5de7f1c$var$Vr.ATOMIC_XOR = "atomicXor";
const $d7238066c5de7f1c$var$coe = $d7238066c5de7f1c$var$zt($d7238066c5de7f1c$var$Vr), $d7238066c5de7f1c$var$mu = (r, e, t)=>$d7238066c5de7f1c$var$coe(r, e, t).toStack(), $d7238066c5de7f1c$var$uoe = (r)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_LOAD, r, null), $d7238066c5de7f1c$var$Ioe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_STORE, r, e), $d7238066c5de7f1c$var$doe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_ADD, r, e), $d7238066c5de7f1c$var$hoe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_SUB, r, e), $d7238066c5de7f1c$var$Coe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_MAX, r, e), $d7238066c5de7f1c$var$poe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_MIN, r, e), $d7238066c5de7f1c$var$moe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_AND, r, e), $d7238066c5de7f1c$var$Aoe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_OR, r, e), $d7238066c5de7f1c$var$boe = (r, e)=>$d7238066c5de7f1c$var$mu($d7238066c5de7f1c$var$Vr.ATOMIC_XOR, r, e);
class $d7238066c5de7f1c$var$it extends $d7238066c5de7f1c$var$Ks {
    static get type() {
        return "SubgroupFunctionNode";
    }
    /**
   * Constructs a new function node.
   *
   * @param {string} method - The subgroup/wave intrinsic method to construct.
   * @param {Node} [aNode=null] - The method's first argument.
   * @param {Node} [bNode=null] - The method's second argument.
   */ constructor(e, t = null, i = null){
        super(), this.method = e, this.aNode = t, this.bNode = i;
    }
    getInputType(e) {
        const t = this.aNode ? this.aNode.getNodeType(e) : null, i = this.bNode ? this.bNode.getNodeType(e) : null, n = e.isMatrix(t) ? 0 : e.getTypeLength(t), s = e.isMatrix(i) ? 0 : e.getTypeLength(i);
        return n > s ? t : i;
    }
    getNodeType(e) {
        const t = this.method;
        return t === $d7238066c5de7f1c$var$it.SUBGROUP_ELECT ? "bool" : t === $d7238066c5de7f1c$var$it.SUBGROUP_BALLOT ? "uvec4" : this.getInputType(e);
    }
    generate(e, t) {
        const i = this.method, n = this.getNodeType(e), s = this.getInputType(e), a = this.aNode, o = this.bNode, g = [];
        if (i === $d7238066c5de7f1c$var$it.SUBGROUP_BROADCAST || i === $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE || i === $d7238066c5de7f1c$var$it.QUAD_BROADCAST) {
            const c = o.getNodeType(e);
            g.push(a.build(e, n), o.build(e, c === "float" ? "int" : n));
        } else i === $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_XOR || i === $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_DOWN || i === $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_UP ? g.push(a.build(e, n), o.build(e, "uint")) : (a !== null && g.push(a.build(e, s)), o !== null && g.push(o.build(e, s)));
        const l = g.length === 0 ? "()" : `( ${g.join(", ")} )`;
        return e.format(`${e.getMethod(i, n)}${l}`, n, t);
    }
    serialize(e) {
        super.serialize(e), e.method = this.method;
    }
    deserialize(e) {
        super.deserialize(e), this.method = e.method;
    }
}
$d7238066c5de7f1c$var$it.SUBGROUP_ELECT = "subgroupElect";
$d7238066c5de7f1c$var$it.SUBGROUP_BALLOT = "subgroupBallot";
$d7238066c5de7f1c$var$it.SUBGROUP_ADD = "subgroupAdd";
$d7238066c5de7f1c$var$it.SUBGROUP_INCLUSIVE_ADD = "subgroupInclusiveAdd";
$d7238066c5de7f1c$var$it.SUBGROUP_EXCLUSIVE_AND = "subgroupExclusiveAdd";
$d7238066c5de7f1c$var$it.SUBGROUP_MUL = "subgroupMul";
$d7238066c5de7f1c$var$it.SUBGROUP_INCLUSIVE_MUL = "subgroupInclusiveMul";
$d7238066c5de7f1c$var$it.SUBGROUP_EXCLUSIVE_MUL = "subgroupExclusiveMul";
$d7238066c5de7f1c$var$it.SUBGROUP_AND = "subgroupAnd";
$d7238066c5de7f1c$var$it.SUBGROUP_OR = "subgroupOr";
$d7238066c5de7f1c$var$it.SUBGROUP_XOR = "subgroupXor";
$d7238066c5de7f1c$var$it.SUBGROUP_MIN = "subgroupMin";
$d7238066c5de7f1c$var$it.SUBGROUP_MAX = "subgroupMax";
$d7238066c5de7f1c$var$it.SUBGROUP_ALL = "subgroupAll";
$d7238066c5de7f1c$var$it.SUBGROUP_ANY = "subgroupAny";
$d7238066c5de7f1c$var$it.SUBGROUP_BROADCAST_FIRST = "subgroupBroadcastFirst";
$d7238066c5de7f1c$var$it.QUAD_SWAP_X = "quadSwapX";
$d7238066c5de7f1c$var$it.QUAD_SWAP_Y = "quadSwapY";
$d7238066c5de7f1c$var$it.QUAD_SWAP_DIAGONAL = "quadSwapDiagonal";
$d7238066c5de7f1c$var$it.SUBGROUP_BROADCAST = "subgroupBroadcast";
$d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE = "subgroupShuffle";
$d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_XOR = "subgroupShuffleXor";
$d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_UP = "subgroupShuffleUp";
$d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_DOWN = "subgroupShuffleDown";
$d7238066c5de7f1c$var$it.QUAD_BROADCAST = "quadBroadcast";
const $d7238066c5de7f1c$var$yoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_ELECT).setParameterLength(0), $d7238066c5de7f1c$var$Boe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_BALLOT).setParameterLength(1), $d7238066c5de7f1c$var$foe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_ADD).setParameterLength(1), $d7238066c5de7f1c$var$Goe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_INCLUSIVE_ADD).setParameterLength(1), $d7238066c5de7f1c$var$voe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_EXCLUSIVE_AND).setParameterLength(1), $d7238066c5de7f1c$var$Soe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_MUL).setParameterLength(1), $d7238066c5de7f1c$var$Zoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_INCLUSIVE_MUL).setParameterLength(1), $d7238066c5de7f1c$var$Roe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_EXCLUSIVE_MUL).setParameterLength(1), $d7238066c5de7f1c$var$Voe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_AND).setParameterLength(1), $d7238066c5de7f1c$var$woe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_OR).setParameterLength(1), $d7238066c5de7f1c$var$Woe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_XOR).setParameterLength(1), $d7238066c5de7f1c$var$Hoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_MIN).setParameterLength(1), $d7238066c5de7f1c$var$Xoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_MAX).setParameterLength(1), $d7238066c5de7f1c$var$Noe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_ALL).setParameterLength(0), $d7238066c5de7f1c$var$Loe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_ANY).setParameterLength(0), $d7238066c5de7f1c$var$Yoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_BROADCAST_FIRST).setParameterLength(2), $d7238066c5de7f1c$var$Koe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.QUAD_SWAP_X).setParameterLength(1), $d7238066c5de7f1c$var$xoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.QUAD_SWAP_Y).setParameterLength(1), $d7238066c5de7f1c$var$Foe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.QUAD_SWAP_DIAGONAL).setParameterLength(1), $d7238066c5de7f1c$var$Toe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_BROADCAST).setParameterLength(2), $d7238066c5de7f1c$var$Moe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE).setParameterLength(2), $d7238066c5de7f1c$var$zoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_XOR).setParameterLength(2), $d7238066c5de7f1c$var$koe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_UP).setParameterLength(2), $d7238066c5de7f1c$var$Eoe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.SUBGROUP_SHUFFLE_DOWN).setParameterLength(2), $d7238066c5de7f1c$var$Joe = /* @__PURE__ */ $d7238066c5de7f1c$var$De($d7238066c5de7f1c$var$it, $d7238066c5de7f1c$var$it.QUAD_BROADCAST).setParameterLength(1);
let $d7238066c5de7f1c$var$Ev;
function $d7238066c5de7f1c$var$FR(r) {
    $d7238066c5de7f1c$var$Ev = $d7238066c5de7f1c$var$Ev || /* @__PURE__ */ new WeakMap();
    let e = $d7238066c5de7f1c$var$Ev.get(r);
    return e === void 0 && $d7238066c5de7f1c$var$Ev.set(r, e = {}), e;
}
function $d7238066c5de7f1c$var$TR(r) {
    const e = $d7238066c5de7f1c$var$FR(r);
    return e.shadowMatrix || (e.shadowMatrix = $d7238066c5de7f1c$var$yt("mat4").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate((t)=>((r.castShadow !== !0 || t.renderer.shadowMap.enabled === !1) && (r.shadow.camera.coordinateSystem !== t.camera.coordinateSystem && (r.shadow.camera.coordinateSystem = t.camera.coordinateSystem, r.shadow.camera.updateProjectionMatrix()), r.shadow.updateMatrices(r)), r.shadow.matrix)));
}
function $d7238066c5de7f1c$var$BD(r, e = $d7238066c5de7f1c$var$ou) {
    const t = $d7238066c5de7f1c$var$TR(r).mul(e);
    return t.xyz.div(t.w);
}
function $d7238066c5de7f1c$var$VY(r) {
    const e = $d7238066c5de7f1c$var$FR(r);
    return e.position || (e.position = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce()).setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate((t, i)=>i.value.setFromMatrixPosition(r.matrixWorld)));
}
function $d7238066c5de7f1c$var$fD(r) {
    const e = $d7238066c5de7f1c$var$FR(r);
    return e.targetPosition || (e.targetPosition = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce()).setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate((t, i)=>i.value.setFromMatrixPosition(r.target.matrixWorld)));
}
function $d7238066c5de7f1c$var$wY(r) {
    const e = $d7238066c5de7f1c$var$FR(r);
    return e.viewPosition || (e.viewPosition = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce()).setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(({ camera: t }, i)=>{
        i.value = i.value || new $d7238066c5de7f1c$var$Ce(), i.value.setFromMatrixPosition(r.matrixWorld), i.value.applyMatrix4(t.matrixWorldInverse);
    }));
}
const $d7238066c5de7f1c$var$WY = (r)=>$d7238066c5de7f1c$var$ol.transformDirection($d7238066c5de7f1c$var$VY(r).sub($d7238066c5de7f1c$var$fD(r))), $d7238066c5de7f1c$var$Uoe = (r)=>r.sort((e, t)=>e.id - t.id), $d7238066c5de7f1c$var$Doe = (r, e)=>{
    for (const t of e)if (t.isAnalyticLightNode && t.light.id === r) return t;
    return null;
}, $d7238066c5de7f1c$var$RH = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$Jb = [];
class $d7238066c5de7f1c$var$HY extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "LightsNode";
    }
    /**
   * Constructs a new lights node.
   */ constructor(){
        super("vec3"), this.totalDiffuseNode = $d7238066c5de7f1c$var$pI("vec3", "totalDiffuse"), this.totalSpecularNode = $d7238066c5de7f1c$var$pI("vec3", "totalSpecular"), this.outgoingLightNode = $d7238066c5de7f1c$var$pI("vec3", "outgoingLight"), this._lights = [], this._lightNodes = null, this._lightNodesHash = null, this.global = !0;
    }
    /**
   * Overwrites the default {@link Node#customCacheKey} implementation by including
   * light data into the cache key.
   *
   * @return {number} The custom cache key.
   */ customCacheKey() {
        const e = this._lights;
        for(let i = 0; i < e.length; i++){
            const n = e[i];
            if ($d7238066c5de7f1c$var$Jb.push(n.id), $d7238066c5de7f1c$var$Jb.push(n.castShadow ? 1 : 0), n.isSpotLight === !0) {
                const s = n.map !== null ? n.map.id : -1, a = n.colorNode ? n.colorNode.getCacheKey() : -1;
                $d7238066c5de7f1c$var$Jb.push(s, a);
            }
        }
        const t = $d7238066c5de7f1c$var$i0($d7238066c5de7f1c$var$Jb);
        return $d7238066c5de7f1c$var$Jb.length = 0, t;
    }
    /**
   * Computes a hash value for identifying the current light nodes setup.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {string} The computed hash.
   */ getHash(e) {
        if (this._lightNodesHash === null) {
            this._lightNodes === null && this.setupLightsNode(e);
            const t = [];
            for (const i of this._lightNodes)t.push(i.getHash());
            this._lightNodesHash = "lights-" + t.join(",");
        }
        return this._lightNodesHash;
    }
    analyze(e) {
        const t = e.getNodeProperties(this);
        for (const i of t.nodes)i.build(e);
        t.outputNode.build(e);
    }
    /**
   * Creates lighting nodes for each scene light. This makes it possible to further
   * process lights in the node system.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   */ setupLightsNode(e) {
        const t = [], i = this._lightNodes, n = $d7238066c5de7f1c$var$Uoe(this._lights), s = e.renderer.library;
        for (const a of n)if (a.isNode) t.push($d7238066c5de7f1c$var$He(a));
        else {
            let o = null;
            if (i !== null && (o = $d7238066c5de7f1c$var$Doe(a.id, i)), o === null) {
                const g = s.getLightNodeClass(a.constructor);
                if (g === null) {
                    $d7238066c5de7f1c$var$ze(`LightsNode.setupNodeLights: Light node not found for ${a.constructor.name}`);
                    continue;
                }
                let l = null;
                $d7238066c5de7f1c$var$RH.has(a) ? l = $d7238066c5de7f1c$var$RH.get(a) : (l = $d7238066c5de7f1c$var$He(new g(a)), $d7238066c5de7f1c$var$RH.set(a, l)), t.push(l);
            }
        }
        this._lightNodes = t;
    }
    /**
   * Sets up a direct light in the lighting model.
   *
   * @param {Object} builder - The builder object containing the context and stack.
   * @param {Object} lightNode - The light node.
   * @param {Object} lightData - The light object containing color and direction properties.
   */ setupDirectLight(e, t, i) {
        const { lightingModel: n, reflectedLight: s } = e.context;
        n.direct({
            ...i,
            lightNode: t,
            reflectedLight: s
        }, e);
    }
    setupDirectRectAreaLight(e, t, i) {
        const { lightingModel: n, reflectedLight: s } = e.context;
        n.directRectArea({
            ...i,
            lightNode: t,
            reflectedLight: s
        }, e);
    }
    /**
   * Setups the internal lights by building all respective
   * light nodes.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Array<LightingNode>} lightNodes - An array of lighting nodes.
   */ setupLights(e, t) {
        for (const i of t)i.build(e);
    }
    getLightNodes(e) {
        return this._lightNodes === null && this.setupLightsNode(e), this._lightNodes;
    }
    /**
   * The implementation makes sure that for each light in the scene
   * there is a corresponding light node. By building the light nodes
   * and evaluating the lighting model the outgoing light is computed.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec3>} A node representing the outgoing light.
   */ setup(e) {
        const t = e.lightsNode;
        e.lightsNode = this;
        let i = this.outgoingLightNode;
        const n = e.context, s = n.lightingModel, a = e.getNodeProperties(this);
        if (s) {
            const { totalDiffuseNode: o, totalSpecularNode: g } = this;
            n.outgoingLight = i;
            const l = e.addStack();
            a.nodes = l.nodes, s.start(e);
            const { backdrop: c, backdropAlpha: d } = n, { directDiffuse: p, directSpecular: A, indirectDiffuse: y, indirectSpecular: G } = n.reflectedLight;
            let Z = p.add(y);
            c !== null && (d !== null ? Z = $d7238066c5de7f1c$var$ne(d.mix(Z, c)) : Z = $d7238066c5de7f1c$var$ne(c)), o.assign(Z), g.assign(A.add(G)), i.assign(o.add(g)), s.finish(e), i = i.bypass(e.removeStack());
        } else a.nodes = [];
        return e.lightsNode = t, i;
    }
    /**
   * Configures this node with an array of lights.
   *
   * @param {Array<Light>} lights - An array of lights.
   * @return {LightsNode} A reference to this node.
   */ setLights(e) {
        return this._lights = e, this._lightNodes = null, this._lightNodesHash = null, this;
    }
    /**
   * Returns an array of the scene's lights.
   *
   * @return {Array<Light>} The scene's lights.
   */ getLights() {
        return this._lights;
    }
    /**
   * Whether the scene has lights or not.
   *
   * @type {boolean}
   */ get hasLights() {
        return this._lights.length > 0;
    }
}
const $d7238066c5de7f1c$var$_oe = (r = [])=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$HY()).setLights(r);
class $d7238066c5de7f1c$var$Poe extends $d7238066c5de7f1c$var$Ct {
    static get type() {
        return "ShadowBaseNode";
    }
    /**
   * Constructs a new shadow base node.
   *
   * @param {Light} light - The shadow casting light.
   */ constructor(e){
        super(), this.light = e, this.updateBeforeType = $d7238066c5de7f1c$var$Dt.RENDER, this.isShadowBaseNode = !0;
    }
    /**
   * Setups the shadow position node which is by default the predefined TSL node object `shadowPositionWorld`.
   *
   * @param {NodeBuilder} object - A configuration object that must at least hold a material reference.
   */ setupShadowPosition({ context: e, material: t }) {
        $d7238066c5de7f1c$var$XY.assign(t.receivedShadowPositionNode || e.shadowPositionWorld || $d7238066c5de7f1c$var$ou);
    }
}
const $d7238066c5de7f1c$var$XY = /* @__PURE__ */ $d7238066c5de7f1c$var$pI("vec3", "shadowPositionWorld");
function $d7238066c5de7f1c$var$Qoe(r, e = {}) {
    return e.toneMapping = r.toneMapping, e.toneMappingExposure = r.toneMappingExposure, e.outputColorSpace = r.outputColorSpace, e.renderTarget = r.getRenderTarget(), e.activeCubeFace = r.getActiveCubeFace(), e.activeMipmapLevel = r.getActiveMipmapLevel(), e.renderObjectFunction = r.getRenderObjectFunction(), e.pixelRatio = r.getPixelRatio(), e.mrt = r.getMRT(), e.clearColor = r.getClearColor(e.clearColor || new $d7238066c5de7f1c$var$rn()), e.clearAlpha = r.getClearAlpha(), e.autoClear = r.autoClear, e.scissorTest = r.getScissorTest(), e;
}
function $d7238066c5de7f1c$var$Ooe(r, e) {
    return e = $d7238066c5de7f1c$var$Qoe(r, e), r.setMRT(null), r.setRenderObjectFunction(null), r.setClearColor(0, 1), r.autoClear = !0, e;
}
function $d7238066c5de7f1c$var$joe(r, e) {
    r.toneMapping = e.toneMapping, r.toneMappingExposure = e.toneMappingExposure, r.outputColorSpace = e.outputColorSpace, r.setRenderTarget(e.renderTarget, e.activeCubeFace, e.activeMipmapLevel), r.setRenderObjectFunction(e.renderObjectFunction), r.setPixelRatio(e.pixelRatio), r.setMRT(e.mrt), r.setClearColor(e.clearColor, e.clearAlpha), r.autoClear = e.autoClear, r.setScissorTest(e.scissorTest);
}
function $d7238066c5de7f1c$var$qoe(r, e = {}) {
    return e.background = r.background, e.backgroundNode = r.backgroundNode, e.overrideMaterial = r.overrideMaterial, e;
}
function $d7238066c5de7f1c$var$$oe(r, e) {
    return e = $d7238066c5de7f1c$var$qoe(r, e), r.background = null, r.backgroundNode = null, r.overrideMaterial = null, e;
}
function $d7238066c5de7f1c$var$ege(r, e) {
    r.background = e.background, r.backgroundNode = e.backgroundNode, r.overrideMaterial = e.overrideMaterial;
}
function $d7238066c5de7f1c$var$tge(r, e, t) {
    return t = $d7238066c5de7f1c$var$Ooe(r, t), t = $d7238066c5de7f1c$var$$oe(e, t), t;
}
function $d7238066c5de7f1c$var$ige(r, e, t) {
    $d7238066c5de7f1c$var$joe(r, t), $d7238066c5de7f1c$var$ege(e, t);
}
const $d7238066c5de7f1c$var$Z9 = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$GD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ depthTexture: r, shadowCoord: e, depthLayer: t })=>{
    let i = $d7238066c5de7f1c$var$ni(r, e.xy).setName("t_basic");
    return r.isArrayTexture && (i = i.depth(t)), i.compare(e.z);
}), $d7238066c5de7f1c$var$vD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ depthTexture: r, shadowCoord: e, shadow: t, depthLayer: i })=>{
    const n = (Z, v)=>{
        let V = $d7238066c5de7f1c$var$ni(r, Z);
        return r.isArrayTexture && (V = V.depth(i)), V.compare(v);
    }, s = $d7238066c5de7f1c$var$vn("mapSize", "vec2", t).setGroup($d7238066c5de7f1c$var$ft), a = $d7238066c5de7f1c$var$vn("radius", "float", t).setGroup($d7238066c5de7f1c$var$ft), o = $d7238066c5de7f1c$var$Ne(1).div(s), g = o.x.negate().mul(a), l = o.y.negate().mul(a), c = o.x.mul(a), d = o.y.mul(a), p = g.div(2), A = l.div(2), y = c.div(2), G = d.div(2);
    return $d7238066c5de7f1c$var$Ps(n(e.xy.add($d7238066c5de7f1c$var$Ne(g, l)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(0, l)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(c, l)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(p, A)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(0, A)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(y, A)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(g, 0)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(p, 0)), e.z), n(e.xy, e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(y, 0)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(c, 0)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(p, G)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(0, G)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(y, G)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(g, d)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(0, d)), e.z), n(e.xy.add($d7238066c5de7f1c$var$Ne(c, d)), e.z)).mul(1 / 17);
}), $d7238066c5de7f1c$var$SD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ depthTexture: r, shadowCoord: e, shadow: t, depthLayer: i })=>{
    const n = (d, p)=>{
        let A = $d7238066c5de7f1c$var$ni(r, d);
        return r.isArrayTexture && (A = A.depth(i)), A.compare(p);
    }, s = $d7238066c5de7f1c$var$vn("mapSize", "vec2", t).setGroup($d7238066c5de7f1c$var$ft), a = $d7238066c5de7f1c$var$Ne(1).div(s), o = a.x, g = a.y, l = e.xy, c = $d7238066c5de7f1c$var$ec(l.mul(s).add(0.5));
    return l.subAssign(c.mul(a)), $d7238066c5de7f1c$var$Ps(n(l, e.z), n(l.add($d7238066c5de7f1c$var$Ne(o, 0)), e.z), n(l.add($d7238066c5de7f1c$var$Ne(0, g)), e.z), n(l.add(a), e.z), $d7238066c5de7f1c$var$qi(n(l.add($d7238066c5de7f1c$var$Ne(o.negate(), 0)), e.z), n(l.add($d7238066c5de7f1c$var$Ne(o.mul(2), 0)), e.z), c.x), $d7238066c5de7f1c$var$qi(n(l.add($d7238066c5de7f1c$var$Ne(o.negate(), g)), e.z), n(l.add($d7238066c5de7f1c$var$Ne(o.mul(2), g)), e.z), c.x), $d7238066c5de7f1c$var$qi(n(l.add($d7238066c5de7f1c$var$Ne(0, g.negate())), e.z), n(l.add($d7238066c5de7f1c$var$Ne(0, g.mul(2))), e.z), c.y), $d7238066c5de7f1c$var$qi(n(l.add($d7238066c5de7f1c$var$Ne(o, g.negate())), e.z), n(l.add($d7238066c5de7f1c$var$Ne(o, g.mul(2))), e.z), c.y), $d7238066c5de7f1c$var$qi($d7238066c5de7f1c$var$qi(n(l.add($d7238066c5de7f1c$var$Ne(o.negate(), g.negate())), e.z), n(l.add($d7238066c5de7f1c$var$Ne(o.mul(2), g.negate())), e.z), c.x), $d7238066c5de7f1c$var$qi(n(l.add($d7238066c5de7f1c$var$Ne(o.negate(), g.mul(2))), e.z), n(l.add($d7238066c5de7f1c$var$Ne(o.mul(2), g.mul(2))), e.z), c.x), c.y)).mul(1 / 9);
}), $d7238066c5de7f1c$var$ZD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ depthTexture: r, shadowCoord: e, depthLayer: t })=>{
    const i = $d7238066c5de7f1c$var$J(1).toVar();
    let n = $d7238066c5de7f1c$var$ni(r).sample(e.xy);
    r.isArrayTexture && (n = n.depth(t)), n = n.rg;
    const s = $d7238066c5de7f1c$var$GR(e.z, n.x);
    return $d7238066c5de7f1c$var$Ht(s.notEqual($d7238066c5de7f1c$var$J(1)), ()=>{
        const a = e.z.sub(n.x), o = $d7238066c5de7f1c$var$En(0, n.y.mul(n.y));
        let g = o.div(o.add(a.mul(a)));
        g = $d7238066c5de7f1c$var$sl($d7238066c5de7f1c$var$wi(g, 0.3).div(0.95 - 0.3)), i.assign($d7238066c5de7f1c$var$sl($d7238066c5de7f1c$var$En(s, g)));
    }), i;
}), $d7238066c5de7f1c$var$nge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    let i = $d7238066c5de7f1c$var$ou.sub(r).length();
    return i = i.sub(e).div(t.sub(e)), i = i.saturate(), i;
}), $d7238066c5de7f1c$var$sge = (r)=>{
    const e = r.shadow.camera, t = $d7238066c5de7f1c$var$vn("near", "float", e).setGroup($d7238066c5de7f1c$var$ft), i = $d7238066c5de7f1c$var$vn("far", "float", e).setGroup($d7238066c5de7f1c$var$ft), n = $d7238066c5de7f1c$var$cJ(r);
    return $d7238066c5de7f1c$var$nge(n, t, i);
}, $d7238066c5de7f1c$var$RD = (r)=>{
    let e = $d7238066c5de7f1c$var$Z9.get(r);
    if (e === void 0) {
        const t = r.isPointLight ? $d7238066c5de7f1c$var$sge(r) : null;
        e = new $d7238066c5de7f1c$var$Bs(), e.colorNode = $d7238066c5de7f1c$var$Rt(0, 0, 0, 1), e.depthNode = t, e.isShadowPassMaterial = !0, e.name = "ShadowMaterial", e.fog = !1, $d7238066c5de7f1c$var$Z9.set(r, e);
    }
    return e;
}, $d7238066c5de7f1c$var$R9 = /* @__PURE__ */ new $d7238066c5de7f1c$var$nc(), $d7238066c5de7f1c$var$zm = [], $d7238066c5de7f1c$var$VD = (r, e, t, i)=>{
    $d7238066c5de7f1c$var$zm[0] = r, $d7238066c5de7f1c$var$zm[1] = e;
    let n = $d7238066c5de7f1c$var$R9.get($d7238066c5de7f1c$var$zm);
    return (n === void 0 || n.shadowType !== t || n.useVelocity !== i) && (n = (s, a, o, g, l, c, ...d)=>{
        (s.castShadow === !0 || s.receiveShadow && t === $d7238066c5de7f1c$var$SS) && (i && ($d7238066c5de7f1c$var$y3(s).useVelocity = !0), s.onBeforeShadow(r, s, o, e.camera, g, a.overrideMaterial, c), r.renderObject(s, a, o, g, l, c, ...d), s.onAfterShadow(r, s, o, e.camera, g, a.overrideMaterial, c));
    }, n.shadowType = t, n.useVelocity = i, $d7238066c5de7f1c$var$R9.set($d7238066c5de7f1c$var$zm, n)), $d7238066c5de7f1c$var$zm[0] = null, $d7238066c5de7f1c$var$zm[1] = null, n;
}, $d7238066c5de7f1c$var$rge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ samples: r, radius: e, size: t, shadowPass: i, depthLayer: n })=>{
    const s = $d7238066c5de7f1c$var$J(0).toVar("meanVertical"), a = $d7238066c5de7f1c$var$J(0).toVar("squareMeanVertical"), o = r.lessThanEqual($d7238066c5de7f1c$var$J(1)).select($d7238066c5de7f1c$var$J(0), $d7238066c5de7f1c$var$J(2).div(r.sub(1))), g = r.lessThanEqual($d7238066c5de7f1c$var$J(1)).select($d7238066c5de7f1c$var$J(0), $d7238066c5de7f1c$var$J(-1));
    $d7238066c5de7f1c$var$Cn({
        start: $d7238066c5de7f1c$var$ee(0),
        end: $d7238066c5de7f1c$var$ee(r),
        type: "int",
        condition: "<"
    }, ({ i: c })=>{
        const d = g.add($d7238066c5de7f1c$var$J(c).mul(o));
        let p = i.sample($d7238066c5de7f1c$var$Ps($d7238066c5de7f1c$var$QB.xy, $d7238066c5de7f1c$var$Ne(0, d).mul(e)).div(t));
        i.value.isArrayTexture && (p = p.depth(n)), p = p.x, s.addAssign(p), a.addAssign(p.mul(p));
    }), s.divAssign(r), a.divAssign(r);
    const l = $d7238066c5de7f1c$var$So(a.sub(s.mul(s)));
    return $d7238066c5de7f1c$var$Ne(s, l);
}), $d7238066c5de7f1c$var$age = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ samples: r, radius: e, size: t, shadowPass: i, depthLayer: n })=>{
    const s = $d7238066c5de7f1c$var$J(0).toVar("meanHorizontal"), a = $d7238066c5de7f1c$var$J(0).toVar("squareMeanHorizontal"), o = r.lessThanEqual($d7238066c5de7f1c$var$J(1)).select($d7238066c5de7f1c$var$J(0), $d7238066c5de7f1c$var$J(2).div(r.sub(1))), g = r.lessThanEqual($d7238066c5de7f1c$var$J(1)).select($d7238066c5de7f1c$var$J(0), $d7238066c5de7f1c$var$J(-1));
    $d7238066c5de7f1c$var$Cn({
        start: $d7238066c5de7f1c$var$ee(0),
        end: $d7238066c5de7f1c$var$ee(r),
        type: "int",
        condition: "<"
    }, ({ i: c })=>{
        const d = g.add($d7238066c5de7f1c$var$J(c).mul(o));
        let p = i.sample($d7238066c5de7f1c$var$Ps($d7238066c5de7f1c$var$QB.xy, $d7238066c5de7f1c$var$Ne(d, 0).mul(e)).div(t));
        i.value.isArrayTexture && (p = p.depth(n)), s.addAssign(p.x), a.addAssign($d7238066c5de7f1c$var$Ps(p.y.mul(p.y), p.x.mul(p.x)));
    }), s.divAssign(r), a.divAssign(r);
    const l = $d7238066c5de7f1c$var$So(a.sub(s.mul(s)));
    return $d7238066c5de7f1c$var$Ne(s, l);
}), $d7238066c5de7f1c$var$oge = [
    $d7238066c5de7f1c$var$GD,
    $d7238066c5de7f1c$var$vD,
    $d7238066c5de7f1c$var$SD,
    $d7238066c5de7f1c$var$ZD
];
let $d7238066c5de7f1c$var$VH;
const $d7238066c5de7f1c$var$Jv = /* @__PURE__ */ new $d7238066c5de7f1c$var$YR();
class $d7238066c5de7f1c$var$wD extends $d7238066c5de7f1c$var$Poe {
    static get type() {
        return "ShadowNode";
    }
    /**
   * Constructs a new shadow node.
   *
   * @param {Light} light - The shadow casting light.
   * @param {?LightShadow} [shadow=null] - An optional light shadow.
   */ constructor(e, t = null){
        super(e), this.shadow = t || e.shadow, this.shadowMap = null, this.vsmShadowMapVertical = null, this.vsmShadowMapHorizontal = null, this.vsmMaterialVertical = null, this.vsmMaterialHorizontal = null, this._node = null, this._currentShadowType = null, this._cameraFrameId = /* @__PURE__ */ new WeakMap(), this.isShadowNode = !0, this.depthLayer = 0;
    }
    /**
   * Setups the shadow filtering.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Object} inputs - A configuration object that defines the shadow filtering.
   * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
   * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
   * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
   * @param {LightShadow} inputs.shadow - The light shadow.
   * @return {Node<float>} The result node of the shadow filtering.
   */ setupShadowFilter(e, { filterFn: t, depthTexture: i, shadowCoord: n, shadow: s, depthLayer: a }) {
        const o = n.x.greaterThanEqual(0).and(n.x.lessThanEqual(1)).and(n.y.greaterThanEqual(0)).and(n.y.lessThanEqual(1)).and(n.z.lessThanEqual(1)), g = t({
            depthTexture: i,
            shadowCoord: n,
            shadow: s,
            depthLayer: a
        });
        return o.select(g, $d7238066c5de7f1c$var$J(1));
    }
    /**
   * Setups the shadow coordinates.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
   * @return {Node<vec3>} The shadow coordinates.
   */ setupShadowCoord(e, t) {
        const { shadow: i } = this, { renderer: n } = e, s = $d7238066c5de7f1c$var$vn("bias", "float", i).setGroup($d7238066c5de7f1c$var$ft);
        let a = t, o;
        if (i.camera.isOrthographicCamera || n.logarithmicDepthBuffer !== !0) a = a.xyz.div(a.w), o = a.z, n.coordinateSystem === $d7238066c5de7f1c$var$uu && (o = o.mul(2).sub(1));
        else {
            const g = a.w;
            a = a.xy.div(g);
            const l = $d7238066c5de7f1c$var$vn("near", "float", i.camera).setGroup($d7238066c5de7f1c$var$ft), c = $d7238066c5de7f1c$var$vn("far", "float", i.camera).setGroup($d7238066c5de7f1c$var$ft);
            o = $d7238066c5de7f1c$var$dY(g.negate(), l, c);
        }
        return a = $d7238066c5de7f1c$var$ne(a.x, a.y.oneMinus(), // follow webgpu standards
        o.add(s)), a;
    }
    /**
   * Returns the shadow filtering function for the given shadow type.
   *
   * @param {number} type - The shadow type.
   * @return {Function} The filtering function.
   */ getShadowFilterFn(e) {
        return $d7238066c5de7f1c$var$oge[e];
    }
    setupRenderTarget(e, t) {
        const i = new $d7238066c5de7f1c$var$$l(e.mapSize.width, e.mapSize.height);
        i.name = "ShadowDepthTexture", i.compareFunction = $d7238066c5de7f1c$var$qN;
        const n = t.createRenderTarget(e.mapSize.width, e.mapSize.height);
        return n.texture.name = "ShadowMap", n.texture.type = e.mapType, n.depthTexture = i, {
            shadowMap: n,
            depthTexture: i
        };
    }
    /**
   * Setups the shadow output node.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec3>} The shadow output node.
   */ setupShadow(e) {
        const { renderer: t, camera: i } = e, { light: n, shadow: s } = this, a = t.shadowMap.type, { depthTexture: o, shadowMap: g } = this.setupRenderTarget(s, e);
        if (s.camera.coordinateSystem = i.coordinateSystem, s.camera.updateProjectionMatrix(), a === $d7238066c5de7f1c$var$SS && s.isPointLightShadow !== !0) {
            o.compareFunction = null, g.depth > 1 ? (g._vsmShadowMapVertical || (g._vsmShadowMapVertical = e.createRenderTarget(s.mapSize.width, s.mapSize.height, {
                format: $d7238066c5de7f1c$var$gI,
                type: $d7238066c5de7f1c$var$Ia,
                depth: g.depth,
                depthBuffer: !1
            }), g._vsmShadowMapVertical.texture.name = "VSMVertical"), this.vsmShadowMapVertical = g._vsmShadowMapVertical, g._vsmShadowMapHorizontal || (g._vsmShadowMapHorizontal = e.createRenderTarget(s.mapSize.width, s.mapSize.height, {
                format: $d7238066c5de7f1c$var$gI,
                type: $d7238066c5de7f1c$var$Ia,
                depth: g.depth,
                depthBuffer: !1
            }), g._vsmShadowMapHorizontal.texture.name = "VSMHorizontal"), this.vsmShadowMapHorizontal = g._vsmShadowMapHorizontal) : (this.vsmShadowMapVertical = e.createRenderTarget(s.mapSize.width, s.mapSize.height, {
                format: $d7238066c5de7f1c$var$gI,
                type: $d7238066c5de7f1c$var$Ia,
                depthBuffer: !1
            }), this.vsmShadowMapHorizontal = e.createRenderTarget(s.mapSize.width, s.mapSize.height, {
                format: $d7238066c5de7f1c$var$gI,
                type: $d7238066c5de7f1c$var$Ia,
                depthBuffer: !1
            }));
            let H = $d7238066c5de7f1c$var$ni(o);
            o.isArrayTexture && (H = H.depth(this.depthLayer));
            let N = $d7238066c5de7f1c$var$ni(this.vsmShadowMapVertical.texture);
            o.isArrayTexture && (N = N.depth(this.depthLayer));
            const Y = $d7238066c5de7f1c$var$vn("blurSamples", "float", s).setGroup($d7238066c5de7f1c$var$ft), K = $d7238066c5de7f1c$var$vn("radius", "float", s).setGroup($d7238066c5de7f1c$var$ft), z = $d7238066c5de7f1c$var$vn("mapSize", "vec2", s).setGroup($d7238066c5de7f1c$var$ft);
            let M = this.vsmMaterialVertical || (this.vsmMaterialVertical = new $d7238066c5de7f1c$var$Bs());
            M.fragmentNode = $d7238066c5de7f1c$var$rge({
                samples: Y,
                radius: K,
                size: z,
                shadowPass: H,
                depthLayer: this.depthLayer
            }).context(e.getSharedContext()), M.name = "VSMVertical", M = this.vsmMaterialHorizontal || (this.vsmMaterialHorizontal = new $d7238066c5de7f1c$var$Bs()), M.fragmentNode = $d7238066c5de7f1c$var$age({
                samples: Y,
                radius: K,
                size: z,
                shadowPass: N,
                depthLayer: this.depthLayer
            }).context(e.getSharedContext()), M.name = "VSMHorizontal";
        }
        const l = $d7238066c5de7f1c$var$vn("intensity", "float", s).setGroup($d7238066c5de7f1c$var$ft), c = $d7238066c5de7f1c$var$vn("normalBias", "float", s).setGroup($d7238066c5de7f1c$var$ft), d = $d7238066c5de7f1c$var$TR(n).mul($d7238066c5de7f1c$var$XY.add($d7238066c5de7f1c$var$Ih.mul(c))), p = this.setupShadowCoord(e, d), A = s.filterNode || this.getShadowFilterFn(t.shadowMap.type) || null;
        if (A === null) throw new Error("THREE.WebGPURenderer: Shadow map type not supported yet.");
        const y = a === $d7238066c5de7f1c$var$SS && s.isPointLightShadow !== !0 ? this.vsmShadowMapHorizontal.texture : o, G = this.setupShadowFilter(e, {
            filterFn: A,
            shadowTexture: g.texture,
            depthTexture: y,
            shadowCoord: p,
            shadow: s,
            depthLayer: this.depthLayer
        });
        let Z = $d7238066c5de7f1c$var$ni(g.texture, p);
        o.isArrayTexture && (Z = Z.depth(this.depthLayer));
        const v = $d7238066c5de7f1c$var$qi(1, G.rgb.mix(Z, 1), l.mul(Z.a)).toVar();
        this.shadowMap = g, this.shadow.map = g;
        const V = `${this.light.type} Shadow [ ${this.light.name || "ID: " + this.light.id} ]`;
        return v.toInspector(`${V} / Color`, ()=>$d7238066c5de7f1c$var$ni(this.shadowMap.texture)).toInspector(`${V} / Depth`, ()=>$d7238066c5de7f1c$var$ys(this.shadowMap.depthTexture, $d7238066c5de7f1c$var$yn().mul($d7238066c5de7f1c$var$mI($d7238066c5de7f1c$var$ni(this.shadowMap.depthTexture)))).x.oneMinus());
    }
    /**
   * The implementation performs the setup of the output node. An output is only
   * produces if shadow mapping is globally enabled in the renderer.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {ShaderCallNodeInternal} The output node.
   */ setup(e) {
        if (e.renderer.shadowMap.enabled !== !1) return $d7238066c5de7f1c$var$oe(()=>{
            const t = e.renderer.shadowMap.type;
            this._currentShadowType !== t && (this._reset(), this._node = null);
            let i = this._node;
            return this.setupShadowPosition(e), i === null && (this._node = i = this.setupShadow(e), this._currentShadowType = t), e.material.shadowNode && $d7238066c5de7f1c$var$ze('NodeMaterial: ".shadowNode" is deprecated. Use ".castShadowNode" instead.'), e.material.receivedShadowNode && (i = e.material.receivedShadowNode(i)), i;
        })();
    }
    /**
   * Renders the shadow. The logic of this function could be included
   * into {@link ShadowNode#updateShadow} however more specialized shadow
   * nodes might require a custom shadow map rendering. By having a
   * dedicated method, it's easier to overwrite the default behavior.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ renderShadow(e) {
        const { shadow: t, shadowMap: i, light: n } = this, { renderer: s, scene: a } = e;
        t.updateMatrices(n), i.setSize(t.mapSize.width, t.mapSize.height, i.depth);
        const o = a.name;
        a.name = `Shadow Map [ ${n.name || "ID: " + n.id} ]`, s.render(a, t.camera), a.name = o;
    }
    /**
   * Updates the shadow.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ updateShadow(e) {
        const { shadowMap: t, light: i, shadow: n } = this, { renderer: s, scene: a, camera: o } = e, g = s.shadowMap.type, l = t.depthTexture.version;
        this._depthVersionCached = l;
        const c = n.camera.layers.mask;
        n.camera.layers.mask & 4294967294 || (n.camera.layers.mask = o.layers.mask);
        const d = s.getRenderObjectFunction(), p = s.getMRT(), A = p ? p.has("velocity") : !1;
        $d7238066c5de7f1c$var$VH = $d7238066c5de7f1c$var$tge(s, a, $d7238066c5de7f1c$var$VH), a.overrideMaterial = $d7238066c5de7f1c$var$RD(i), s.setRenderObjectFunction($d7238066c5de7f1c$var$VD(s, n, g, A)), s.setClearColor(0, 0), s.setRenderTarget(t), this.renderShadow(e), s.setRenderObjectFunction(d), g === $d7238066c5de7f1c$var$SS && n.isPointLightShadow !== !0 && this.vsmPass(s), n.camera.layers.mask = c, $d7238066c5de7f1c$var$ige(s, a, $d7238066c5de7f1c$var$VH);
    }
    /**
   * For VSM additional render passes are required.
   *
   * @param {Renderer} renderer - A reference to the current renderer.
   */ vsmPass(e) {
        const { shadow: t } = this, i = this.shadowMap.depth;
        this.vsmShadowMapVertical.setSize(t.mapSize.width, t.mapSize.height, i), this.vsmShadowMapHorizontal.setSize(t.mapSize.width, t.mapSize.height, i), e.setRenderTarget(this.vsmShadowMapVertical), $d7238066c5de7f1c$var$Jv.material = this.vsmMaterialVertical, $d7238066c5de7f1c$var$Jv.render(e), e.setRenderTarget(this.vsmShadowMapHorizontal), $d7238066c5de7f1c$var$Jv.material = this.vsmMaterialHorizontal, $d7238066c5de7f1c$var$Jv.render(e);
    }
    /**
   * Frees the internal resources of this shadow node.
   */ dispose() {
        this._reset(), super.dispose();
    }
    /**
   * Resets the resouce state of this shadow node.
   *
   * @private
   */ _reset() {
        this._currentShadowType = null, this.shadowMap && (this.shadowMap.dispose(), this.shadowMap = null), this.vsmShadowMapVertical !== null && (this.vsmShadowMapVertical.dispose(), this.vsmShadowMapVertical = null, this.vsmMaterialVertical.dispose(), this.vsmMaterialVertical = null), this.vsmShadowMapHorizontal !== null && (this.vsmShadowMapHorizontal.dispose(), this.vsmShadowMapHorizontal = null, this.vsmMaterialHorizontal.dispose(), this.vsmMaterialHorizontal = null);
    }
    /**
   * The implementation performs the update of the shadow map if necessary.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ updateBefore(e) {
        const { shadow: t } = this;
        let i = t.needsUpdate || t.autoUpdate;
        i && (this._cameraFrameId[e.camera] === e.frameId && (i = !1), this._cameraFrameId[e.camera] = e.frameId), i && (this.updateShadow(e), this.shadowMap.depthTexture.version === this._depthVersionCached && (t.needsUpdate = !1));
    }
}
const $d7238066c5de7f1c$var$WD = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$wD(r, e)), $d7238066c5de7f1c$var$gge = /* @__PURE__ */ new $d7238066c5de7f1c$var$rn(), $d7238066c5de7f1c$var$kl = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = r.toVar(), i = $d7238066c5de7f1c$var$Wn(t), n = $d7238066c5de7f1c$var$cg(1, $d7238066c5de7f1c$var$En(i.x, $d7238066c5de7f1c$var$En(i.y, i.z)));
    i.mulAssign(n), t.mulAssign(n.mul(e.mul(2).oneMinus()));
    const s = $d7238066c5de7f1c$var$Ne(t.xy).toVar(), o = e.mul(1.5).oneMinus();
    return $d7238066c5de7f1c$var$Ht(i.z.greaterThanEqual(o), ()=>{
        $d7238066c5de7f1c$var$Ht(t.z.greaterThan(0), ()=>{
            s.x.assign($d7238066c5de7f1c$var$wi(4, t.x));
        });
    }).ElseIf(i.x.greaterThanEqual(o), ()=>{
        const g = $d7238066c5de7f1c$var$pB(t.x);
        s.x.assign(t.z.mul(g).add(g.mul(2)));
    }).ElseIf(i.y.greaterThanEqual(o), ()=>{
        const g = $d7238066c5de7f1c$var$pB(t.y);
        s.x.assign(t.x.add(g.mul(2)).add(2)), s.y.assign(t.z.mul(g).sub(2));
    }), $d7238066c5de7f1c$var$Ne(0.125, 0.25).mul(s).add($d7238066c5de7f1c$var$Ne(0.375, 0.75)).flipY();
}).setLayout({
    name: "cubeToUV",
    type: "vec2",
    inputs: [
        {
            name: "pos",
            type: "vec3"
        },
        {
            name: "texelSizeY",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$HD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ depthTexture: r, bd3D: e, dp: t, texelSize: i })=>$d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e, i.y)).compare(t)), $d7238066c5de7f1c$var$XD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ depthTexture: r, bd3D: e, dp: t, texelSize: i, shadow: n })=>{
    const s = $d7238066c5de7f1c$var$vn("radius", "float", n).setGroup($d7238066c5de7f1c$var$ft), a = $d7238066c5de7f1c$var$Ne(-1, 1).mul(s).mul(i.y);
    return $d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.xyy), i.y)).compare(t).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.yyy), i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.xyx), i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.yyx), i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e, i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.xxy), i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.yxy), i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.xxx), i.y)).compare(t)).add($d7238066c5de7f1c$var$ni(r, $d7238066c5de7f1c$var$kl(e.add(a.yxx), i.y)).compare(t)).mul(1 / 9);
}), $d7238066c5de7f1c$var$lge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ filterFn: r, depthTexture: e, shadowCoord: t, shadow: i })=>{
    const n = t.xyz.toVar(), s = n.length(), a = $d7238066c5de7f1c$var$yt("float").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(()=>i.camera.near), o = $d7238066c5de7f1c$var$yt("float").setGroup($d7238066c5de7f1c$var$ft).onRenderUpdate(()=>i.camera.far), g = $d7238066c5de7f1c$var$vn("bias", "float", i).setGroup($d7238066c5de7f1c$var$ft), l = $d7238066c5de7f1c$var$yt(i.mapSize).setGroup($d7238066c5de7f1c$var$ft), c = $d7238066c5de7f1c$var$J(1).toVar();
    return $d7238066c5de7f1c$var$Ht(s.sub(o).lessThanEqual(0).and(s.sub(a).greaterThanEqual(0)), ()=>{
        const d = s.sub(a).div(o.sub(a)).toVar();
        d.addAssign(g);
        const p = n.normalize(), A = $d7238066c5de7f1c$var$Ne(1).div(l.mul($d7238066c5de7f1c$var$Ne(4, 2)));
        c.assign(r({
            depthTexture: e,
            bd3D: p,
            dp: d,
            texelSize: A,
            shadow: i
        }));
    }), c;
}), $d7238066c5de7f1c$var$V9 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$km = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii(), $d7238066c5de7f1c$var$Ub = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii();
class $d7238066c5de7f1c$var$cge extends $d7238066c5de7f1c$var$wD {
    static get type() {
        return "PointShadowNode";
    }
    /**
   * Constructs a new point shadow node.
   *
   * @param {PointLight} light - The shadow casting point light.
   * @param {?PointLightShadow} [shadow=null] - An optional point light shadow.
   */ constructor(e, t = null){
        super(e, t);
    }
    /**
   * Overwrites the default implementation to return point light shadow specific
   * filtering functions.
   *
   * @param {number} type - The shadow type.
   * @return {Function} The filtering function.
   */ getShadowFilterFn(e) {
        return e === $d7238066c5de7f1c$var$N6 ? $d7238066c5de7f1c$var$HD : $d7238066c5de7f1c$var$XD;
    }
    /**
   * Overwrites the default implementation so the unaltered shadow position is used.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
   * @return {Node<vec3>} The shadow coordinates.
   */ setupShadowCoord(e, t) {
        return t;
    }
    /**
   * Overwrites the default implementation to only use point light specific
   * shadow filter functions.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Object} inputs - A configuration object that defines the shadow filtering.
   * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
   * @param {Texture} inputs.shadowTexture - A reference to the shadow map's texture.
   * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
   * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
   * @param {LightShadow} inputs.shadow - The light shadow.
   * @return {Node<float>} The result node of the shadow filtering.
   */ setupShadowFilter(e, { filterFn: t, shadowTexture: i, depthTexture: n, shadowCoord: s, shadow: a }) {
        return $d7238066c5de7f1c$var$lge({
            filterFn: t,
            shadowTexture: i,
            depthTexture: n,
            shadowCoord: s,
            shadow: a
        });
    }
    /**
   * Overwrites the default implementation with point light specific
   * rendering code.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ renderShadow(e) {
        const { shadow: t, shadowMap: i, light: n } = this, { renderer: s, scene: a } = e, o = t.getFrameExtents();
        $d7238066c5de7f1c$var$Ub.copy(t.mapSize), $d7238066c5de7f1c$var$Ub.multiply(o), i.setSize($d7238066c5de7f1c$var$Ub.width, $d7238066c5de7f1c$var$Ub.height), $d7238066c5de7f1c$var$km.copy(t.mapSize);
        const g = s.autoClear, l = s.getClearColor($d7238066c5de7f1c$var$gge), c = s.getClearAlpha();
        s.autoClear = !1, s.setClearColor(t.clearColor, t.clearAlpha), s.clear();
        const d = t.getViewportCount();
        for(let p = 0; p < d; p++){
            const A = t.getViewport(p), y = $d7238066c5de7f1c$var$km.x * A.x, G = $d7238066c5de7f1c$var$Ub.y - $d7238066c5de7f1c$var$km.y - $d7238066c5de7f1c$var$km.y * A.y;
            $d7238066c5de7f1c$var$V9.set(y, G, $d7238066c5de7f1c$var$km.x * A.z, $d7238066c5de7f1c$var$km.y * A.w), i.viewport.copy($d7238066c5de7f1c$var$V9), t.updateMatrices(n, p);
            const Z = a.name;
            a.name = `Point Light Shadow [ ${n.name || "ID: " + n.id} ] - Face ${p + 1}`, s.render(a, t.camera), a.name = Z;
        }
        s.autoClear = g, s.setClearColor(l, c);
    }
}
const $d7238066c5de7f1c$var$ND = (r, e)=>$d7238066c5de7f1c$var$He(new $d7238066c5de7f1c$var$cge(r, e));
class $d7238066c5de7f1c$var$$C extends $d7238066c5de7f1c$var$a0 {
    static get type() {
        return "AnalyticLightNode";
    }
    /**
   * Constructs a new analytic light node.
   *
   * @param {?Light} [light=null] - The light source.
   */ constructor(e = null){
        super(), this.light = e, this.color = new $d7238066c5de7f1c$var$rn(), this.colorNode = e && e.colorNode || $d7238066c5de7f1c$var$yt(this.color).setGroup($d7238066c5de7f1c$var$ft), this.baseColorNode = null, this.shadowNode = null, this.shadowColorNode = null, this.isAnalyticLightNode = !0, this.updateType = $d7238066c5de7f1c$var$Dt.FRAME;
    }
    getHash() {
        return this.light.uuid;
    }
    /**
   * Returns a node representing a direction vector which points from the current
   * position in view space to the light's position in view space.
   *
   * @param {NodeBuilder} builder - The builder object used for setting up the light.
   * @return {Node<vec3>} The light vector node.
   */ getLightVector(e) {
        return $d7238066c5de7f1c$var$wY(this.light).sub(e.context.positionView || $d7238066c5de7f1c$var$Ls);
    }
    /**
   * Sets up the direct lighting for the analytic light node.
   *
   * @abstract
   * @param {NodeBuilder} builder - The builder object used for setting up the light.
   * @return {Object|undefined} The direct light data (color and direction).
   */ setupDirect() {}
    /**
   * Sets up the direct rect area lighting for the analytic light node.
   *
   * @abstract
   * @param {NodeBuilder} builder - The builder object used for setting up the light.
   * @return {Object|undefined} The direct rect area light data.
   */ setupDirectRectArea() {}
    /**
   * Setups the shadow node for this light. The method exists so concrete light classes
   * can setup different types of shadow nodes.
   *
   * @return {ShadowNode} The created shadow node.
   */ setupShadowNode() {
        return $d7238066c5de7f1c$var$WD(this.light);
    }
    /**
   * Setups the shadow for this light. This method is only executed if the light
   * cast shadows and the current build object receives shadows. It incorporates
   * shadows into the lighting computation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setupShadow(e) {
        const { renderer: t } = e;
        if (t.shadowMap.enabled === !1) return;
        let i = this.shadowColorNode;
        if (i === null) {
            const n = this.light.shadow.shadowNode;
            let s;
            n !== void 0 ? s = $d7238066c5de7f1c$var$He(n) : s = this.setupShadowNode(), this.shadowNode = s, this.shadowColorNode = i = this.colorNode.mul(s), this.baseColorNode = this.colorNode;
        }
        this.colorNode = i;
    }
    /**
   * Unlike most other nodes, lighting nodes do not return a output node in {@link Node#setup}.
   * The main purpose of lighting nodes is to configure the current {@link LightingModel} and/or
   * invocate the respective interface methods.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */ setup(e) {
        this.colorNode = this.baseColorNode || this.colorNode, this.light.castShadow ? e.object.receiveShadow && this.setupShadow(e) : this.shadowNode !== null && (this.shadowNode.dispose(), this.shadowNode = null, this.shadowColorNode = null);
        const t = this.setupDirect(e), i = this.setupDirectRectArea(e);
        t && e.lightsNode.setupDirectLight(e, this, t), i && e.lightsNode.setupDirectRectAreaLight(e, this, i);
    }
    /**
   * The update method is used to update light uniforms per frame.
   * Potentially overwritten in concrete light nodes to update light
   * specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update() {
        const { light: e } = this;
        this.color.copy(e.color).multiplyScalar(e.intensity);
    }
}
const $d7238066c5de7f1c$var$NY = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(({ lightDistance: r, cutoffDistance: e, decayExponent: t })=>{
    const i = r.pow(t).max(0.01).reciprocal();
    return e.greaterThan(0).select(i.mul(r.div(e).pow4().oneMinus().clamp().pow2()), i);
}), $d7238066c5de7f1c$var$LD = ({ color: r, lightVector: e, cutoffDistance: t, decayExponent: i })=>{
    const n = e.normalize(), s = e.length(), a = $d7238066c5de7f1c$var$NY({
        lightDistance: s,
        cutoffDistance: t,
        decayExponent: i
    }), o = r.mul(a);
    return {
        lightDirection: n,
        lightColor: o
    };
};
class $d7238066c5de7f1c$var$uge extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "PointLightNode";
    }
    /**
   * Constructs a new point light node.
   *
   * @param {?PointLight} [light=null] - The point light source.
   */ constructor(e = null){
        super(e), this.cutoffDistanceNode = $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft), this.decayExponentNode = $d7238066c5de7f1c$var$yt(2).setGroup($d7238066c5de7f1c$var$ft);
    }
    /**
   * Overwritten to updated point light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update(e) {
        const { light: t } = this;
        super.update(e), this.cutoffDistanceNode.value = t.distance, this.decayExponentNode.value = t.decay;
    }
    /**
   * Overwritten to setup point light specific shadow.
   *
   * @return {PointShadowNode}
   */ setupShadowNode() {
        return $d7238066c5de7f1c$var$ND(this.light);
    }
    setupDirect(e) {
        return $d7238066c5de7f1c$var$LD({
            color: this.colorNode,
            lightVector: this.getLightVector(e),
            cutoffDistance: this.cutoffDistanceNode,
            decayExponent: this.decayExponentNode
        });
    }
}
const $d7238066c5de7f1c$var$Ige = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r = $d7238066c5de7f1c$var$yn()])=>{
    const e = r.mul(2), t = e.x.floor(), i = e.y.floor();
    return t.add(i).mod(2).sign();
}), $d7238066c5de7f1c$var$dge = $d7238066c5de7f1c$var$oe(([r = $d7238066c5de7f1c$var$yn()], { renderer: e, material: t })=>{
    const i = $d7238066c5de7f1c$var$zL(r.mul(2).sub(1));
    let n;
    if (t.alphaToCoverage && e.currentSamples > 0) {
        const s = $d7238066c5de7f1c$var$J(i.fwidth()).toVar();
        n = $d7238066c5de7f1c$var$ic(s.oneMinus(), s.add(1), i).oneMinus();
    } else n = $d7238066c5de7f1c$var$or(i.greaterThan(1), 0, 1);
    return n;
}), $d7238066c5de7f1c$var$Py = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$J(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$nl(r).toVar();
    return $d7238066c5de7f1c$var$or(s, n, i);
}).setLayout({
    name: "mx_select",
    type: "float",
    inputs: [
        {
            name: "b",
            type: "bool"
        },
        {
            name: "t",
            type: "float"
        },
        {
            name: "f",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$xZ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$nl(e).toVar(), i = $d7238066c5de7f1c$var$J(r).toVar();
    return $d7238066c5de7f1c$var$or(t, i.negate(), i);
}).setLayout({
    name: "mx_negate_if",
    type: "float",
    inputs: [
        {
            name: "val",
            type: "float"
        },
        {
            name: "b",
            type: "bool"
        }
    ]
}), $d7238066c5de7f1c$var$_s = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(r).toVar();
    return $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$ru(e));
}).setLayout({
    name: "mx_floor",
    type: "int",
    inputs: [
        {
            name: "x",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$rs = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$J(r).toVar();
    return e.assign($d7238066c5de7f1c$var$_s(t)), t.sub($d7238066c5de7f1c$var$J(e));
}), $d7238066c5de7f1c$var$hge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s])=>{
    const a = $d7238066c5de7f1c$var$J(s).toVar(), o = $d7238066c5de7f1c$var$J(n).toVar(), g = $d7238066c5de7f1c$var$J(i).toVar(), l = $d7238066c5de7f1c$var$J(t).toVar(), c = $d7238066c5de7f1c$var$J(e).toVar(), d = $d7238066c5de7f1c$var$J(r).toVar(), p = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, o)).toVar();
    return $d7238066c5de7f1c$var$wi(1, a).mul(d.mul(p).add(c.mul(o))).add(a.mul(l.mul(p).add(g.mul(o))));
}).setLayout({
    name: "mx_bilerp_0",
    type: "float",
    inputs: [
        {
            name: "v0",
            type: "float"
        },
        {
            name: "v1",
            type: "float"
        },
        {
            name: "v2",
            type: "float"
        },
        {
            name: "v3",
            type: "float"
        },
        {
            name: "s",
            type: "float"
        },
        {
            name: "t",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Cge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s])=>{
    const a = $d7238066c5de7f1c$var$J(s).toVar(), o = $d7238066c5de7f1c$var$J(n).toVar(), g = $d7238066c5de7f1c$var$ne(i).toVar(), l = $d7238066c5de7f1c$var$ne(t).toVar(), c = $d7238066c5de7f1c$var$ne(e).toVar(), d = $d7238066c5de7f1c$var$ne(r).toVar(), p = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, o)).toVar();
    return $d7238066c5de7f1c$var$wi(1, a).mul(d.mul(p).add(c.mul(o))).add(a.mul(l.mul(p).add(g.mul(o))));
}).setLayout({
    name: "mx_bilerp_1",
    type: "vec3",
    inputs: [
        {
            name: "v0",
            type: "vec3"
        },
        {
            name: "v1",
            type: "vec3"
        },
        {
            name: "v2",
            type: "vec3"
        },
        {
            name: "v3",
            type: "vec3"
        },
        {
            name: "s",
            type: "float"
        },
        {
            name: "t",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$YD = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$hge,
    $d7238066c5de7f1c$var$Cge
]), $d7238066c5de7f1c$var$pge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a, o, g, l, c])=>{
    const d = $d7238066c5de7f1c$var$J(c).toVar(), p = $d7238066c5de7f1c$var$J(l).toVar(), A = $d7238066c5de7f1c$var$J(g).toVar(), y = $d7238066c5de7f1c$var$J(o).toVar(), G = $d7238066c5de7f1c$var$J(a).toVar(), Z = $d7238066c5de7f1c$var$J(s).toVar(), v = $d7238066c5de7f1c$var$J(n).toVar(), V = $d7238066c5de7f1c$var$J(i).toVar(), H = $d7238066c5de7f1c$var$J(t).toVar(), N = $d7238066c5de7f1c$var$J(e).toVar(), Y = $d7238066c5de7f1c$var$J(r).toVar(), K = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, A)).toVar(), z = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, p)).toVar();
    return $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, d)).toVar().mul(z.mul(Y.mul(K).add(N.mul(A))).add(p.mul(H.mul(K).add(V.mul(A))))).add(d.mul(z.mul(v.mul(K).add(Z.mul(A))).add(p.mul(G.mul(K).add(y.mul(A))))));
}).setLayout({
    name: "mx_trilerp_0",
    type: "float",
    inputs: [
        {
            name: "v0",
            type: "float"
        },
        {
            name: "v1",
            type: "float"
        },
        {
            name: "v2",
            type: "float"
        },
        {
            name: "v3",
            type: "float"
        },
        {
            name: "v4",
            type: "float"
        },
        {
            name: "v5",
            type: "float"
        },
        {
            name: "v6",
            type: "float"
        },
        {
            name: "v7",
            type: "float"
        },
        {
            name: "s",
            type: "float"
        },
        {
            name: "t",
            type: "float"
        },
        {
            name: "r",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$mge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a, o, g, l, c])=>{
    const d = $d7238066c5de7f1c$var$J(c).toVar(), p = $d7238066c5de7f1c$var$J(l).toVar(), A = $d7238066c5de7f1c$var$J(g).toVar(), y = $d7238066c5de7f1c$var$ne(o).toVar(), G = $d7238066c5de7f1c$var$ne(a).toVar(), Z = $d7238066c5de7f1c$var$ne(s).toVar(), v = $d7238066c5de7f1c$var$ne(n).toVar(), V = $d7238066c5de7f1c$var$ne(i).toVar(), H = $d7238066c5de7f1c$var$ne(t).toVar(), N = $d7238066c5de7f1c$var$ne(e).toVar(), Y = $d7238066c5de7f1c$var$ne(r).toVar(), K = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, A)).toVar(), z = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, p)).toVar();
    return $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$wi(1, d)).toVar().mul(z.mul(Y.mul(K).add(N.mul(A))).add(p.mul(H.mul(K).add(V.mul(A))))).add(d.mul(z.mul(v.mul(K).add(Z.mul(A))).add(p.mul(G.mul(K).add(y.mul(A))))));
}).setLayout({
    name: "mx_trilerp_1",
    type: "vec3",
    inputs: [
        {
            name: "v0",
            type: "vec3"
        },
        {
            name: "v1",
            type: "vec3"
        },
        {
            name: "v2",
            type: "vec3"
        },
        {
            name: "v3",
            type: "vec3"
        },
        {
            name: "v4",
            type: "vec3"
        },
        {
            name: "v5",
            type: "vec3"
        },
        {
            name: "v6",
            type: "vec3"
        },
        {
            name: "v7",
            type: "vec3"
        },
        {
            name: "s",
            type: "float"
        },
        {
            name: "t",
            type: "float"
        },
        {
            name: "r",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$KD = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$pge,
    $d7238066c5de7f1c$var$mge
]), $d7238066c5de7f1c$var$Age = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$J(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$Ue(r).toVar(), a = $d7238066c5de7f1c$var$Ue(s.bitAnd($d7238066c5de7f1c$var$Ue(7))).toVar(), o = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$Py(a.lessThan($d7238066c5de7f1c$var$Ue(4)), n, i)).toVar(), g = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$Et(2, $d7238066c5de7f1c$var$Py(a.lessThan($d7238066c5de7f1c$var$Ue(4)), i, n))).toVar();
    return $d7238066c5de7f1c$var$xZ(o, $d7238066c5de7f1c$var$nl(a.bitAnd($d7238066c5de7f1c$var$Ue(1)))).add($d7238066c5de7f1c$var$xZ(g, $d7238066c5de7f1c$var$nl(a.bitAnd($d7238066c5de7f1c$var$Ue(2)))));
}).setLayout({
    name: "mx_gradient_float_0",
    type: "float",
    inputs: [
        {
            name: "hash",
            type: "uint"
        },
        {
            name: "x",
            type: "float"
        },
        {
            name: "y",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$bge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$J(i).toVar(), s = $d7238066c5de7f1c$var$J(t).toVar(), a = $d7238066c5de7f1c$var$J(e).toVar(), o = $d7238066c5de7f1c$var$Ue(r).toVar(), g = $d7238066c5de7f1c$var$Ue(o.bitAnd($d7238066c5de7f1c$var$Ue(15))).toVar(), l = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$Py(g.lessThan($d7238066c5de7f1c$var$Ue(8)), a, s)).toVar(), c = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$Py(g.lessThan($d7238066c5de7f1c$var$Ue(4)), s, $d7238066c5de7f1c$var$Py(g.equal($d7238066c5de7f1c$var$Ue(12)).or(g.equal($d7238066c5de7f1c$var$Ue(14))), a, n))).toVar();
    return $d7238066c5de7f1c$var$xZ(l, $d7238066c5de7f1c$var$nl(g.bitAnd($d7238066c5de7f1c$var$Ue(1)))).add($d7238066c5de7f1c$var$xZ(c, $d7238066c5de7f1c$var$nl(g.bitAnd($d7238066c5de7f1c$var$Ue(2)))));
}).setLayout({
    name: "mx_gradient_float_1",
    type: "float",
    inputs: [
        {
            name: "hash",
            type: "uint"
        },
        {
            name: "x",
            type: "float"
        },
        {
            name: "y",
            type: "float"
        },
        {
            name: "z",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Tr = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Age,
    $d7238066c5de7f1c$var$bge
]), $d7238066c5de7f1c$var$yge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$J(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$n0(r).toVar();
    return $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$Tr(s.x, n, i), $d7238066c5de7f1c$var$Tr(s.y, n, i), $d7238066c5de7f1c$var$Tr(s.z, n, i));
}).setLayout({
    name: "mx_gradient_vec3_0",
    type: "vec3",
    inputs: [
        {
            name: "hash",
            type: "uvec3"
        },
        {
            name: "x",
            type: "float"
        },
        {
            name: "y",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Bge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$J(i).toVar(), s = $d7238066c5de7f1c$var$J(t).toVar(), a = $d7238066c5de7f1c$var$J(e).toVar(), o = $d7238066c5de7f1c$var$n0(r).toVar();
    return $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$Tr(o.x, a, s, n), $d7238066c5de7f1c$var$Tr(o.y, a, s, n), $d7238066c5de7f1c$var$Tr(o.z, a, s, n));
}).setLayout({
    name: "mx_gradient_vec3_1",
    type: "vec3",
    inputs: [
        {
            name: "hash",
            type: "uvec3"
        },
        {
            name: "x",
            type: "float"
        },
        {
            name: "y",
            type: "float"
        },
        {
            name: "z",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Jg = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$yge,
    $d7238066c5de7f1c$var$Bge
]), $d7238066c5de7f1c$var$fge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(r).toVar();
    return $d7238066c5de7f1c$var$Et(0.6616, e);
}).setLayout({
    name: "mx_gradient_scale2d_0",
    type: "float",
    inputs: [
        {
            name: "v",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Gge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(r).toVar();
    return $d7238066c5de7f1c$var$Et(0.982, e);
}).setLayout({
    name: "mx_gradient_scale3d_0",
    type: "float",
    inputs: [
        {
            name: "v",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$vge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar();
    return $d7238066c5de7f1c$var$Et(0.6616, e);
}).setLayout({
    name: "mx_gradient_scale2d_1",
    type: "vec3",
    inputs: [
        {
            name: "v",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$xD = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$fge,
    $d7238066c5de7f1c$var$vge
]), $d7238066c5de7f1c$var$Sge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar();
    return $d7238066c5de7f1c$var$Et(0.982, e);
}).setLayout({
    name: "mx_gradient_scale3d_1",
    type: "vec3",
    inputs: [
        {
            name: "v",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$FD = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Gge,
    $d7238066c5de7f1c$var$Sge
]), $d7238066c5de7f1c$var$eg = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$ee(e).toVar(), i = $d7238066c5de7f1c$var$Ue(r).toVar();
    return i.shiftLeft(t).bitOr(i.shiftRight($d7238066c5de7f1c$var$ee(32).sub(t)));
}).setLayout({
    name: "mx_rotl32",
    type: "uint",
    inputs: [
        {
            name: "x",
            type: "uint"
        },
        {
            name: "k",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$TD = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    r.subAssign(t), r.bitXorAssign($d7238066c5de7f1c$var$eg(t, $d7238066c5de7f1c$var$ee(4))), t.addAssign(e), e.subAssign(r), e.bitXorAssign($d7238066c5de7f1c$var$eg(r, $d7238066c5de7f1c$var$ee(6))), r.addAssign(t), t.subAssign(e), t.bitXorAssign($d7238066c5de7f1c$var$eg(e, $d7238066c5de7f1c$var$ee(8))), e.addAssign(r), r.subAssign(t), r.bitXorAssign($d7238066c5de7f1c$var$eg(t, $d7238066c5de7f1c$var$ee(16))), t.addAssign(e), e.subAssign(r), e.bitXorAssign($d7238066c5de7f1c$var$eg(r, $d7238066c5de7f1c$var$ee(19))), r.addAssign(t), t.subAssign(e), t.bitXorAssign($d7238066c5de7f1c$var$eg(e, $d7238066c5de7f1c$var$ee(4))), e.addAssign(r);
}), $d7238066c5de7f1c$var$tf = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$Ue(t).toVar(), n = $d7238066c5de7f1c$var$Ue(e).toVar(), s = $d7238066c5de7f1c$var$Ue(r).toVar();
    return i.bitXorAssign(n), i.subAssign($d7238066c5de7f1c$var$eg(n, $d7238066c5de7f1c$var$ee(14))), s.bitXorAssign(i), s.subAssign($d7238066c5de7f1c$var$eg(i, $d7238066c5de7f1c$var$ee(11))), n.bitXorAssign(s), n.subAssign($d7238066c5de7f1c$var$eg(s, $d7238066c5de7f1c$var$ee(25))), i.bitXorAssign(n), i.subAssign($d7238066c5de7f1c$var$eg(n, $d7238066c5de7f1c$var$ee(16))), s.bitXorAssign(i), s.subAssign($d7238066c5de7f1c$var$eg(i, $d7238066c5de7f1c$var$ee(4))), n.bitXorAssign(s), n.subAssign($d7238066c5de7f1c$var$eg(s, $d7238066c5de7f1c$var$ee(14))), i.bitXorAssign(n), i.subAssign($d7238066c5de7f1c$var$eg(n, $d7238066c5de7f1c$var$ee(24))), i;
}).setLayout({
    name: "mx_bjfinal",
    type: "uint",
    inputs: [
        {
            name: "a",
            type: "uint"
        },
        {
            name: "b",
            type: "uint"
        },
        {
            name: "c",
            type: "uint"
        }
    ]
}), $d7238066c5de7f1c$var$xa = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Ue(r).toVar();
    return $d7238066c5de7f1c$var$J(e).div($d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ee(4294967295))));
}).setLayout({
    name: "mx_bits_to_01",
    type: "float",
    inputs: [
        {
            name: "bits",
            type: "uint"
        }
    ]
}), $d7238066c5de7f1c$var$gu = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(r).toVar();
    return e.mul(e).mul(e).mul(e.mul(e.mul(6).sub(15)).add(10));
}).setLayout({
    name: "mx_fade",
    type: "float",
    inputs: [
        {
            name: "t",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Zge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ee(r).toVar(), t = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$Ue(1)).toVar(), i = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ee(3735928559)).add(t.shiftLeft($d7238066c5de7f1c$var$Ue(2))).add($d7238066c5de7f1c$var$Ue(13))).toVar();
    return $d7238066c5de7f1c$var$tf(i.add($d7238066c5de7f1c$var$Ue(e)), i, i);
}).setLayout({
    name: "mx_hash_int_0",
    type: "uint",
    inputs: [
        {
            name: "x",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$Rge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$ee(e).toVar(), i = $d7238066c5de7f1c$var$ee(r).toVar(), n = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$Ue(2)).toVar(), s = $d7238066c5de7f1c$var$Ue().toVar(), a = $d7238066c5de7f1c$var$Ue().toVar(), o = $d7238066c5de7f1c$var$Ue().toVar();
    return s.assign(a.assign(o.assign($d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ee(3735928559)).add(n.shiftLeft($d7238066c5de7f1c$var$Ue(2))).add($d7238066c5de7f1c$var$Ue(13))))), s.addAssign($d7238066c5de7f1c$var$Ue(i)), a.addAssign($d7238066c5de7f1c$var$Ue(t)), $d7238066c5de7f1c$var$tf(s, a, o);
}).setLayout({
    name: "mx_hash_int_1",
    type: "uint",
    inputs: [
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$Vge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$ee(e).toVar(), s = $d7238066c5de7f1c$var$ee(r).toVar(), a = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$Ue(3)).toVar(), o = $d7238066c5de7f1c$var$Ue().toVar(), g = $d7238066c5de7f1c$var$Ue().toVar(), l = $d7238066c5de7f1c$var$Ue().toVar();
    return o.assign(g.assign(l.assign($d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ee(3735928559)).add(a.shiftLeft($d7238066c5de7f1c$var$Ue(2))).add($d7238066c5de7f1c$var$Ue(13))))), o.addAssign($d7238066c5de7f1c$var$Ue(s)), g.addAssign($d7238066c5de7f1c$var$Ue(n)), l.addAssign($d7238066c5de7f1c$var$Ue(i)), $d7238066c5de7f1c$var$tf(o, g, l);
}).setLayout({
    name: "mx_hash_int_2",
    type: "uint",
    inputs: [
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        },
        {
            name: "z",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$wge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$ee(i).toVar(), s = $d7238066c5de7f1c$var$ee(t).toVar(), a = $d7238066c5de7f1c$var$ee(e).toVar(), o = $d7238066c5de7f1c$var$ee(r).toVar(), g = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$Ue(4)).toVar(), l = $d7238066c5de7f1c$var$Ue().toVar(), c = $d7238066c5de7f1c$var$Ue().toVar(), d = $d7238066c5de7f1c$var$Ue().toVar();
    return l.assign(c.assign(d.assign($d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ee(3735928559)).add(g.shiftLeft($d7238066c5de7f1c$var$Ue(2))).add($d7238066c5de7f1c$var$Ue(13))))), l.addAssign($d7238066c5de7f1c$var$Ue(o)), c.addAssign($d7238066c5de7f1c$var$Ue(a)), d.addAssign($d7238066c5de7f1c$var$Ue(s)), $d7238066c5de7f1c$var$TD(l, c, d), l.addAssign($d7238066c5de7f1c$var$Ue(n)), $d7238066c5de7f1c$var$tf(l, c, d);
}).setLayout({
    name: "mx_hash_int_3",
    type: "uint",
    inputs: [
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        },
        {
            name: "z",
            type: "int"
        },
        {
            name: "xx",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$Wge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n])=>{
    const s = $d7238066c5de7f1c$var$ee(n).toVar(), a = $d7238066c5de7f1c$var$ee(i).toVar(), o = $d7238066c5de7f1c$var$ee(t).toVar(), g = $d7238066c5de7f1c$var$ee(e).toVar(), l = $d7238066c5de7f1c$var$ee(r).toVar(), c = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$Ue(5)).toVar(), d = $d7238066c5de7f1c$var$Ue().toVar(), p = $d7238066c5de7f1c$var$Ue().toVar(), A = $d7238066c5de7f1c$var$Ue().toVar();
    return d.assign(p.assign(A.assign($d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$ee(3735928559)).add(c.shiftLeft($d7238066c5de7f1c$var$Ue(2))).add($d7238066c5de7f1c$var$Ue(13))))), d.addAssign($d7238066c5de7f1c$var$Ue(l)), p.addAssign($d7238066c5de7f1c$var$Ue(g)), A.addAssign($d7238066c5de7f1c$var$Ue(o)), $d7238066c5de7f1c$var$TD(d, p, A), d.addAssign($d7238066c5de7f1c$var$Ue(a)), p.addAssign($d7238066c5de7f1c$var$Ue(s)), $d7238066c5de7f1c$var$tf(d, p, A);
}).setLayout({
    name: "mx_hash_int_4",
    type: "uint",
    inputs: [
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        },
        {
            name: "z",
            type: "int"
        },
        {
            name: "xx",
            type: "int"
        },
        {
            name: "yy",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$bn = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Zge,
    $d7238066c5de7f1c$var$Rge,
    $d7238066c5de7f1c$var$Vge,
    $d7238066c5de7f1c$var$wge,
    $d7238066c5de7f1c$var$Wge
]), $d7238066c5de7f1c$var$Hge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = $d7238066c5de7f1c$var$ee(e).toVar(), i = $d7238066c5de7f1c$var$ee(r).toVar(), n = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$bn(i, t)).toVar(), s = $d7238066c5de7f1c$var$n0().toVar();
    return s.x.assign(n.bitAnd($d7238066c5de7f1c$var$ee(255))), s.y.assign(n.shiftRight($d7238066c5de7f1c$var$ee(8)).bitAnd($d7238066c5de7f1c$var$ee(255))), s.z.assign(n.shiftRight($d7238066c5de7f1c$var$ee(16)).bitAnd($d7238066c5de7f1c$var$ee(255))), s;
}).setLayout({
    name: "mx_hash_vec3_0",
    type: "uvec3",
    inputs: [
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$Xge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$ee(e).toVar(), s = $d7238066c5de7f1c$var$ee(r).toVar(), a = $d7238066c5de7f1c$var$Ue($d7238066c5de7f1c$var$bn(s, n, i)).toVar(), o = $d7238066c5de7f1c$var$n0().toVar();
    return o.x.assign(a.bitAnd($d7238066c5de7f1c$var$ee(255))), o.y.assign(a.shiftRight($d7238066c5de7f1c$var$ee(8)).bitAnd($d7238066c5de7f1c$var$ee(255))), o.z.assign(a.shiftRight($d7238066c5de7f1c$var$ee(16)).bitAnd($d7238066c5de7f1c$var$ee(255))), o;
}).setLayout({
    name: "mx_hash_vec3_1",
    type: "uvec3",
    inputs: [
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        },
        {
            name: "z",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$Ug = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Hge,
    $d7238066c5de7f1c$var$Xge
]), $d7238066c5de7f1c$var$Nge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Ne(r).toVar(), t = $d7238066c5de7f1c$var$ee().toVar(), i = $d7238066c5de7f1c$var$ee().toVar(), n = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.x, t)).toVar(), s = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.y, i)).toVar(), a = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(n)).toVar(), o = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(s)).toVar(), g = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$YD($d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t, i), n, s), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t.add($d7238066c5de7f1c$var$ee(1)), i), n.sub(1), s), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t, i.add($d7238066c5de7f1c$var$ee(1))), n, s.sub(1)), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t.add($d7238066c5de7f1c$var$ee(1)), i.add($d7238066c5de7f1c$var$ee(1))), n.sub(1), s.sub(1)), a, o)).toVar();
    return $d7238066c5de7f1c$var$xD(g);
}).setLayout({
    name: "mx_perlin_noise_float_0",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec2"
        }
    ]
}), $d7238066c5de7f1c$var$Lge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$ee().toVar(), i = $d7238066c5de7f1c$var$ee().toVar(), n = $d7238066c5de7f1c$var$ee().toVar(), s = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.x, t)).toVar(), a = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.y, i)).toVar(), o = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.z, n)).toVar(), g = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(s)).toVar(), l = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(a)).toVar(), c = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(o)).toVar(), d = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$KD($d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t, i, n), s, a, o), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t.add($d7238066c5de7f1c$var$ee(1)), i, n), s.sub(1), a, o), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t, i.add($d7238066c5de7f1c$var$ee(1)), n), s, a.sub(1), o), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t.add($d7238066c5de7f1c$var$ee(1)), i.add($d7238066c5de7f1c$var$ee(1)), n), s.sub(1), a.sub(1), o), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t, i, n.add($d7238066c5de7f1c$var$ee(1))), s, a, o.sub(1)), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t.add($d7238066c5de7f1c$var$ee(1)), i, n.add($d7238066c5de7f1c$var$ee(1))), s.sub(1), a, o.sub(1)), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t, i.add($d7238066c5de7f1c$var$ee(1)), n.add($d7238066c5de7f1c$var$ee(1))), s, a.sub(1), o.sub(1)), $d7238066c5de7f1c$var$Tr($d7238066c5de7f1c$var$bn(t.add($d7238066c5de7f1c$var$ee(1)), i.add($d7238066c5de7f1c$var$ee(1)), n.add($d7238066c5de7f1c$var$ee(1))), s.sub(1), a.sub(1), o.sub(1)), g, l, c)).toVar();
    return $d7238066c5de7f1c$var$FD(d);
}).setLayout({
    name: "mx_perlin_noise_float_1",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$LY = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Nge,
    $d7238066c5de7f1c$var$Lge
]), $d7238066c5de7f1c$var$Yge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Ne(r).toVar(), t = $d7238066c5de7f1c$var$ee().toVar(), i = $d7238066c5de7f1c$var$ee().toVar(), n = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.x, t)).toVar(), s = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.y, i)).toVar(), a = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(n)).toVar(), o = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(s)).toVar(), g = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$YD($d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t, i), n, s), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t.add($d7238066c5de7f1c$var$ee(1)), i), n.sub(1), s), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t, i.add($d7238066c5de7f1c$var$ee(1))), n, s.sub(1)), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t.add($d7238066c5de7f1c$var$ee(1)), i.add($d7238066c5de7f1c$var$ee(1))), n.sub(1), s.sub(1)), a, o)).toVar();
    return $d7238066c5de7f1c$var$xD(g);
}).setLayout({
    name: "mx_perlin_noise_vec3_0",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec2"
        }
    ]
}), $d7238066c5de7f1c$var$Kge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$ee().toVar(), i = $d7238066c5de7f1c$var$ee().toVar(), n = $d7238066c5de7f1c$var$ee().toVar(), s = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.x, t)).toVar(), a = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.y, i)).toVar(), o = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$rs(e.z, n)).toVar(), g = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(s)).toVar(), l = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(a)).toVar(), c = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$gu(o)).toVar(), d = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$KD($d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t, i, n), s, a, o), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t.add($d7238066c5de7f1c$var$ee(1)), i, n), s.sub(1), a, o), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t, i.add($d7238066c5de7f1c$var$ee(1)), n), s, a.sub(1), o), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t.add($d7238066c5de7f1c$var$ee(1)), i.add($d7238066c5de7f1c$var$ee(1)), n), s.sub(1), a.sub(1), o), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t, i, n.add($d7238066c5de7f1c$var$ee(1))), s, a, o.sub(1)), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t.add($d7238066c5de7f1c$var$ee(1)), i, n.add($d7238066c5de7f1c$var$ee(1))), s.sub(1), a, o.sub(1)), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t, i.add($d7238066c5de7f1c$var$ee(1)), n.add($d7238066c5de7f1c$var$ee(1))), s, a.sub(1), o.sub(1)), $d7238066c5de7f1c$var$Jg($d7238066c5de7f1c$var$Ug(t.add($d7238066c5de7f1c$var$ee(1)), i.add($d7238066c5de7f1c$var$ee(1)), n.add($d7238066c5de7f1c$var$ee(1))), s.sub(1), a.sub(1), o.sub(1)), g, l, c)).toVar();
    return $d7238066c5de7f1c$var$FD(d);
}).setLayout({
    name: "mx_perlin_noise_vec3_1",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$nf = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Yge,
    $d7238066c5de7f1c$var$Kge
]), $d7238066c5de7f1c$var$xge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e)).toVar();
    return $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t));
}).setLayout({
    name: "mx_cell_noise_float_0",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Fge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Ne(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.x)).toVar(), i = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.y)).toVar();
    return $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i));
}).setLayout({
    name: "mx_cell_noise_float_1",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec2"
        }
    ]
}), $d7238066c5de7f1c$var$Tge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.x)).toVar(), i = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.y)).toVar(), n = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.z)).toVar();
    return $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n));
}).setLayout({
    name: "mx_cell_noise_float_2",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$Mge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Rt(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.x)).toVar(), i = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.y)).toVar(), n = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.z)).toVar(), s = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.w)).toVar();
    return $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, s));
}).setLayout({
    name: "mx_cell_noise_float_3",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec4"
        }
    ]
}), $d7238066c5de7f1c$var$zge = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$xge,
    $d7238066c5de7f1c$var$Fge,
    $d7238066c5de7f1c$var$Tge,
    $d7238066c5de7f1c$var$Mge
]), $d7238066c5de7f1c$var$kge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$J(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e)).toVar();
    return $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, $d7238066c5de7f1c$var$ee(0))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, $d7238066c5de7f1c$var$ee(1))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, $d7238066c5de7f1c$var$ee(2))));
}).setLayout({
    name: "mx_cell_noise_vec3_0",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Ege = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Ne(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.x)).toVar(), i = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.y)).toVar();
    return $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, $d7238066c5de7f1c$var$ee(0))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, $d7238066c5de7f1c$var$ee(1))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, $d7238066c5de7f1c$var$ee(2))));
}).setLayout({
    name: "mx_cell_noise_vec3_1",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec2"
        }
    ]
}), $d7238066c5de7f1c$var$Jge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.x)).toVar(), i = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.y)).toVar(), n = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.z)).toVar();
    return $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, $d7238066c5de7f1c$var$ee(0))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, $d7238066c5de7f1c$var$ee(1))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, $d7238066c5de7f1c$var$ee(2))));
}).setLayout({
    name: "mx_cell_noise_vec3_2",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$Uge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$Rt(r).toVar(), t = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.x)).toVar(), i = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.y)).toVar(), n = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.z)).toVar(), s = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$_s(e.w)).toVar();
    return $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, s, $d7238066c5de7f1c$var$ee(0))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, s, $d7238066c5de7f1c$var$ee(1))), $d7238066c5de7f1c$var$xa($d7238066c5de7f1c$var$bn(t, i, n, s, $d7238066c5de7f1c$var$ee(2))));
}).setLayout({
    name: "mx_cell_noise_vec3_3",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec4"
        }
    ]
}), $d7238066c5de7f1c$var$MR = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$kge,
    $d7238066c5de7f1c$var$Ege,
    $d7238066c5de7f1c$var$Jge,
    $d7238066c5de7f1c$var$Uge
]), $d7238066c5de7f1c$var$FZ = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$J(i).toVar(), s = $d7238066c5de7f1c$var$J(t).toVar(), a = $d7238066c5de7f1c$var$ee(e).toVar(), o = $d7238066c5de7f1c$var$ne(r).toVar(), g = $d7238066c5de7f1c$var$J(0).toVar(), l = $d7238066c5de7f1c$var$J(1).toVar();
    return $d7238066c5de7f1c$var$Cn(a, ()=>{
        g.addAssign(l.mul($d7238066c5de7f1c$var$LY(o))), l.mulAssign(n), o.mulAssign(s);
    }), g;
}).setLayout({
    name: "mx_fractal_noise_float",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "octaves",
            type: "int"
        },
        {
            name: "lacunarity",
            type: "float"
        },
        {
            name: "diminish",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$zR = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$J(i).toVar(), s = $d7238066c5de7f1c$var$J(t).toVar(), a = $d7238066c5de7f1c$var$ee(e).toVar(), o = $d7238066c5de7f1c$var$ne(r).toVar(), g = $d7238066c5de7f1c$var$ne(0).toVar(), l = $d7238066c5de7f1c$var$J(1).toVar();
    return $d7238066c5de7f1c$var$Cn(a, ()=>{
        g.addAssign(l.mul($d7238066c5de7f1c$var$nf(o))), l.mulAssign(n), o.mulAssign(s);
    }), g;
}).setLayout({
    name: "mx_fractal_noise_vec3",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "octaves",
            type: "int"
        },
        {
            name: "lacunarity",
            type: "float"
        },
        {
            name: "diminish",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Dge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$J(i).toVar(), s = $d7238066c5de7f1c$var$J(t).toVar(), a = $d7238066c5de7f1c$var$ee(e).toVar(), o = $d7238066c5de7f1c$var$ne(r).toVar();
    return $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$FZ(o, a, s, n), $d7238066c5de7f1c$var$FZ(o.add($d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$ee(19), $d7238066c5de7f1c$var$ee(193), $d7238066c5de7f1c$var$ee(17))), a, s, n));
}).setLayout({
    name: "mx_fractal_noise_vec2",
    type: "vec2",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "octaves",
            type: "int"
        },
        {
            name: "lacunarity",
            type: "float"
        },
        {
            name: "diminish",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$_ge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i])=>{
    const n = $d7238066c5de7f1c$var$J(i).toVar(), s = $d7238066c5de7f1c$var$J(t).toVar(), a = $d7238066c5de7f1c$var$ee(e).toVar(), o = $d7238066c5de7f1c$var$ne(r).toVar(), g = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$zR(o, a, s, n)).toVar(), l = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$FZ(o.add($d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$ee(19), $d7238066c5de7f1c$var$ee(193), $d7238066c5de7f1c$var$ee(17))), a, s, n)).toVar();
    return $d7238066c5de7f1c$var$Rt(g, l);
}).setLayout({
    name: "mx_fractal_noise_vec4",
    type: "vec4",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "octaves",
            type: "int"
        },
        {
            name: "lacunarity",
            type: "float"
        },
        {
            name: "diminish",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$Pge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a])=>{
    const o = $d7238066c5de7f1c$var$ee(a).toVar(), g = $d7238066c5de7f1c$var$J(s).toVar(), l = $d7238066c5de7f1c$var$ee(n).toVar(), c = $d7238066c5de7f1c$var$ee(i).toVar(), d = $d7238066c5de7f1c$var$ee(t).toVar(), p = $d7238066c5de7f1c$var$ee(e).toVar(), A = $d7238066c5de7f1c$var$Ne(r).toVar(), y = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$MR($d7238066c5de7f1c$var$Ne(p.add(c), d.add(l)))).toVar(), G = $d7238066c5de7f1c$var$Ne(y.x, y.y).toVar();
    G.subAssign(0.5), G.mulAssign(g), G.addAssign(0.5);
    const Z = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$J(p), $d7238066c5de7f1c$var$J(d)).add(G)).toVar(), v = $d7238066c5de7f1c$var$Ne(Z.sub(A)).toVar();
    return $d7238066c5de7f1c$var$Ht(o.equal($d7238066c5de7f1c$var$ee(2)), ()=>$d7238066c5de7f1c$var$Wn(v.x).add($d7238066c5de7f1c$var$Wn(v.y))), $d7238066c5de7f1c$var$Ht(o.equal($d7238066c5de7f1c$var$ee(3)), ()=>$d7238066c5de7f1c$var$En($d7238066c5de7f1c$var$Wn(v.x), $d7238066c5de7f1c$var$Wn(v.y))), $d7238066c5de7f1c$var$tc(v, v);
}).setLayout({
    name: "mx_worley_distance_0",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec2"
        },
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        },
        {
            name: "xoff",
            type: "int"
        },
        {
            name: "yoff",
            type: "int"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$Qge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a, o, g])=>{
    const l = $d7238066c5de7f1c$var$ee(g).toVar(), c = $d7238066c5de7f1c$var$J(o).toVar(), d = $d7238066c5de7f1c$var$ee(a).toVar(), p = $d7238066c5de7f1c$var$ee(s).toVar(), A = $d7238066c5de7f1c$var$ee(n).toVar(), y = $d7238066c5de7f1c$var$ee(i).toVar(), G = $d7238066c5de7f1c$var$ee(t).toVar(), Z = $d7238066c5de7f1c$var$ee(e).toVar(), v = $d7238066c5de7f1c$var$ne(r).toVar(), V = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$MR($d7238066c5de7f1c$var$ne(Z.add(A), G.add(p), y.add(d)))).toVar();
    V.subAssign(0.5), V.mulAssign(c), V.addAssign(0.5);
    const H = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$J(Z), $d7238066c5de7f1c$var$J(G), $d7238066c5de7f1c$var$J(y)).add(V)).toVar(), N = $d7238066c5de7f1c$var$ne(H.sub(v)).toVar();
    return $d7238066c5de7f1c$var$Ht(l.equal($d7238066c5de7f1c$var$ee(2)), ()=>$d7238066c5de7f1c$var$Wn(N.x).add($d7238066c5de7f1c$var$Wn(N.y)).add($d7238066c5de7f1c$var$Wn(N.z))), $d7238066c5de7f1c$var$Ht(l.equal($d7238066c5de7f1c$var$ee(3)), ()=>$d7238066c5de7f1c$var$En($d7238066c5de7f1c$var$Wn(N.x), $d7238066c5de7f1c$var$Wn(N.y), $d7238066c5de7f1c$var$Wn(N.z))), $d7238066c5de7f1c$var$tc(N, N);
}).setLayout({
    name: "mx_worley_distance_1",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "x",
            type: "int"
        },
        {
            name: "y",
            type: "int"
        },
        {
            name: "z",
            type: "int"
        },
        {
            name: "xoff",
            type: "int"
        },
        {
            name: "yoff",
            type: "int"
        },
        {
            name: "zoff",
            type: "int"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$g0 = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Pge,
    $d7238066c5de7f1c$var$Qge
]), $d7238066c5de7f1c$var$Oge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$Ne(r).toVar(), a = $d7238066c5de7f1c$var$ee().toVar(), o = $d7238066c5de7f1c$var$ee().toVar(), g = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$rs(s.x, a), $d7238066c5de7f1c$var$rs(s.y, o)).toVar(), l = $d7238066c5de7f1c$var$J(1e6).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: -1,
        end: $d7238066c5de7f1c$var$ee(1),
        name: "x",
        condition: "<="
    }, ({ x: c })=>{
        $d7238066c5de7f1c$var$Cn({
            start: -1,
            end: $d7238066c5de7f1c$var$ee(1),
            name: "y",
            condition: "<="
        }, ({ y: d })=>{
            const p = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$g0(g, c, d, a, o, n, i)).toVar();
            l.assign($d7238066c5de7f1c$var$Xo(l, p));
        });
    }), $d7238066c5de7f1c$var$Ht(i.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        l.assign($d7238066c5de7f1c$var$So(l));
    }), l;
}).setLayout({
    name: "mx_worley_noise_float_0",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec2"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$jge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$Ne(r).toVar(), a = $d7238066c5de7f1c$var$ee().toVar(), o = $d7238066c5de7f1c$var$ee().toVar(), g = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$rs(s.x, a), $d7238066c5de7f1c$var$rs(s.y, o)).toVar(), l = $d7238066c5de7f1c$var$Ne(1e6, 1e6).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: -1,
        end: $d7238066c5de7f1c$var$ee(1),
        name: "x",
        condition: "<="
    }, ({ x: c })=>{
        $d7238066c5de7f1c$var$Cn({
            start: -1,
            end: $d7238066c5de7f1c$var$ee(1),
            name: "y",
            condition: "<="
        }, ({ y: d })=>{
            const p = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$g0(g, c, d, a, o, n, i)).toVar();
            $d7238066c5de7f1c$var$Ht(p.lessThan(l.x), ()=>{
                l.y.assign(l.x), l.x.assign(p);
            }).ElseIf(p.lessThan(l.y), ()=>{
                l.y.assign(p);
            });
        });
    }), $d7238066c5de7f1c$var$Ht(i.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        l.assign($d7238066c5de7f1c$var$So(l));
    }), l;
}).setLayout({
    name: "mx_worley_noise_vec2_0",
    type: "vec2",
    inputs: [
        {
            name: "p",
            type: "vec2"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$qge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$Ne(r).toVar(), a = $d7238066c5de7f1c$var$ee().toVar(), o = $d7238066c5de7f1c$var$ee().toVar(), g = $d7238066c5de7f1c$var$Ne($d7238066c5de7f1c$var$rs(s.x, a), $d7238066c5de7f1c$var$rs(s.y, o)).toVar(), l = $d7238066c5de7f1c$var$ne(1e6, 1e6, 1e6).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: -1,
        end: $d7238066c5de7f1c$var$ee(1),
        name: "x",
        condition: "<="
    }, ({ x: c })=>{
        $d7238066c5de7f1c$var$Cn({
            start: -1,
            end: $d7238066c5de7f1c$var$ee(1),
            name: "y",
            condition: "<="
        }, ({ y: d })=>{
            const p = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$g0(g, c, d, a, o, n, i)).toVar();
            $d7238066c5de7f1c$var$Ht(p.lessThan(l.x), ()=>{
                l.z.assign(l.y), l.y.assign(l.x), l.x.assign(p);
            }).ElseIf(p.lessThan(l.y), ()=>{
                l.z.assign(l.y), l.y.assign(p);
            }).ElseIf(p.lessThan(l.z), ()=>{
                l.z.assign(p);
            });
        });
    }), $d7238066c5de7f1c$var$Ht(i.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        l.assign($d7238066c5de7f1c$var$So(l));
    }), l;
}).setLayout({
    name: "mx_worley_noise_vec3_0",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec2"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$$ge = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$ne(r).toVar(), a = $d7238066c5de7f1c$var$ee().toVar(), o = $d7238066c5de7f1c$var$ee().toVar(), g = $d7238066c5de7f1c$var$ee().toVar(), l = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$rs(s.x, a), $d7238066c5de7f1c$var$rs(s.y, o), $d7238066c5de7f1c$var$rs(s.z, g)).toVar(), c = $d7238066c5de7f1c$var$J(1e6).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: -1,
        end: $d7238066c5de7f1c$var$ee(1),
        name: "x",
        condition: "<="
    }, ({ x: d })=>{
        $d7238066c5de7f1c$var$Cn({
            start: -1,
            end: $d7238066c5de7f1c$var$ee(1),
            name: "y",
            condition: "<="
        }, ({ y: p })=>{
            $d7238066c5de7f1c$var$Cn({
                start: -1,
                end: $d7238066c5de7f1c$var$ee(1),
                name: "z",
                condition: "<="
            }, ({ z: A })=>{
                const y = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$g0(l, d, p, A, a, o, g, n, i)).toVar();
                c.assign($d7238066c5de7f1c$var$Xo(c, y));
            });
        });
    }), $d7238066c5de7f1c$var$Ht(i.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        c.assign($d7238066c5de7f1c$var$So(c));
    }), c;
}).setLayout({
    name: "mx_worley_noise_float_1",
    type: "float",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$ele = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$Oge,
    $d7238066c5de7f1c$var$$ge
]), $d7238066c5de7f1c$var$tle = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$ne(r).toVar(), a = $d7238066c5de7f1c$var$ee().toVar(), o = $d7238066c5de7f1c$var$ee().toVar(), g = $d7238066c5de7f1c$var$ee().toVar(), l = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$rs(s.x, a), $d7238066c5de7f1c$var$rs(s.y, o), $d7238066c5de7f1c$var$rs(s.z, g)).toVar(), c = $d7238066c5de7f1c$var$Ne(1e6, 1e6).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: -1,
        end: $d7238066c5de7f1c$var$ee(1),
        name: "x",
        condition: "<="
    }, ({ x: d })=>{
        $d7238066c5de7f1c$var$Cn({
            start: -1,
            end: $d7238066c5de7f1c$var$ee(1),
            name: "y",
            condition: "<="
        }, ({ y: p })=>{
            $d7238066c5de7f1c$var$Cn({
                start: -1,
                end: $d7238066c5de7f1c$var$ee(1),
                name: "z",
                condition: "<="
            }, ({ z: A })=>{
                const y = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$g0(l, d, p, A, a, o, g, n, i)).toVar();
                $d7238066c5de7f1c$var$Ht(y.lessThan(c.x), ()=>{
                    c.y.assign(c.x), c.x.assign(y);
                }).ElseIf(y.lessThan(c.y), ()=>{
                    c.y.assign(y);
                });
            });
        });
    }), $d7238066c5de7f1c$var$Ht(i.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        c.assign($d7238066c5de7f1c$var$So(c));
    }), c;
}).setLayout({
    name: "mx_worley_noise_vec2_1",
    type: "vec2",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$ile = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$jge,
    $d7238066c5de7f1c$var$tle
]), $d7238066c5de7f1c$var$nle = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$ee(t).toVar(), n = $d7238066c5de7f1c$var$J(e).toVar(), s = $d7238066c5de7f1c$var$ne(r).toVar(), a = $d7238066c5de7f1c$var$ee().toVar(), o = $d7238066c5de7f1c$var$ee().toVar(), g = $d7238066c5de7f1c$var$ee().toVar(), l = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$rs(s.x, a), $d7238066c5de7f1c$var$rs(s.y, o), $d7238066c5de7f1c$var$rs(s.z, g)).toVar(), c = $d7238066c5de7f1c$var$ne(1e6, 1e6, 1e6).toVar();
    return $d7238066c5de7f1c$var$Cn({
        start: -1,
        end: $d7238066c5de7f1c$var$ee(1),
        name: "x",
        condition: "<="
    }, ({ x: d })=>{
        $d7238066c5de7f1c$var$Cn({
            start: -1,
            end: $d7238066c5de7f1c$var$ee(1),
            name: "y",
            condition: "<="
        }, ({ y: p })=>{
            $d7238066c5de7f1c$var$Cn({
                start: -1,
                end: $d7238066c5de7f1c$var$ee(1),
                name: "z",
                condition: "<="
            }, ({ z: A })=>{
                const y = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$g0(l, d, p, A, a, o, g, n, i)).toVar();
                $d7238066c5de7f1c$var$Ht(y.lessThan(c.x), ()=>{
                    c.z.assign(c.y), c.y.assign(c.x), c.x.assign(y);
                }).ElseIf(y.lessThan(c.y), ()=>{
                    c.z.assign(c.y), c.y.assign(y);
                }).ElseIf(y.lessThan(c.z), ()=>{
                    c.z.assign(y);
                });
            });
        });
    }), $d7238066c5de7f1c$var$Ht(i.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        c.assign($d7238066c5de7f1c$var$So(c));
    }), c;
}).setLayout({
    name: "mx_worley_noise_vec3_1",
    type: "vec3",
    inputs: [
        {
            name: "p",
            type: "vec3"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "metric",
            type: "int"
        }
    ]
}), $d7238066c5de7f1c$var$YY = /* @__PURE__ */ $d7238066c5de7f1c$var$pa([
    $d7238066c5de7f1c$var$qge,
    $d7238066c5de7f1c$var$nle
]), $d7238066c5de7f1c$var$sle = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a, o, g, l, c])=>{
    const d = $d7238066c5de7f1c$var$ee(r).toVar(), p = $d7238066c5de7f1c$var$Ne(e).toVar(), A = $d7238066c5de7f1c$var$Ne(t).toVar(), y = $d7238066c5de7f1c$var$Ne(i).toVar(), G = $d7238066c5de7f1c$var$J(n).toVar(), Z = $d7238066c5de7f1c$var$J(s).toVar(), v = $d7238066c5de7f1c$var$J(a).toVar(), V = $d7238066c5de7f1c$var$nl(o).toVar(), H = $d7238066c5de7f1c$var$ee(g).toVar(), N = $d7238066c5de7f1c$var$J(l).toVar(), Y = $d7238066c5de7f1c$var$J(c).toVar(), K = p.mul(A).add(y), z = $d7238066c5de7f1c$var$J(0).toVar();
    return $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        z.assign($d7238066c5de7f1c$var$nf(K));
    }), $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(1)), ()=>{
        z.assign($d7238066c5de7f1c$var$MR(K));
    }), $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(2)), ()=>{
        z.assign($d7238066c5de7f1c$var$YY(K, G, $d7238066c5de7f1c$var$ee(0)));
    }), $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(3)), ()=>{
        z.assign($d7238066c5de7f1c$var$zR($d7238066c5de7f1c$var$ne(K, 0), H, N, Y));
    }), z.assign(z.mul(v.sub(Z)).add(Z)), $d7238066c5de7f1c$var$Ht(V, ()=>{
        z.assign($d7238066c5de7f1c$var$sl(z, Z, v));
    }), z;
}).setLayout({
    name: "mx_unifiednoise2d",
    type: "float",
    inputs: [
        {
            name: "noiseType",
            type: "int"
        },
        {
            name: "texcoord",
            type: "vec2"
        },
        {
            name: "freq",
            type: "vec2"
        },
        {
            name: "offset",
            type: "vec2"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "outmin",
            type: "float"
        },
        {
            name: "outmax",
            type: "float"
        },
        {
            name: "clampoutput",
            type: "bool"
        },
        {
            name: "octaves",
            type: "int"
        },
        {
            name: "lacunarity",
            type: "float"
        },
        {
            name: "diminish",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$rle = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t, i, n, s, a, o, g, l, c])=>{
    const d = $d7238066c5de7f1c$var$ee(r).toVar(), p = $d7238066c5de7f1c$var$ne(e).toVar(), A = $d7238066c5de7f1c$var$ne(t).toVar(), y = $d7238066c5de7f1c$var$ne(i).toVar(), G = $d7238066c5de7f1c$var$J(n).toVar(), Z = $d7238066c5de7f1c$var$J(s).toVar(), v = $d7238066c5de7f1c$var$J(a).toVar(), V = $d7238066c5de7f1c$var$nl(o).toVar(), H = $d7238066c5de7f1c$var$ee(g).toVar(), N = $d7238066c5de7f1c$var$J(l).toVar(), Y = $d7238066c5de7f1c$var$J(c).toVar(), K = p.mul(A).add(y), z = $d7238066c5de7f1c$var$J(0).toVar();
    return $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
        z.assign($d7238066c5de7f1c$var$nf(K));
    }), $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(1)), ()=>{
        z.assign($d7238066c5de7f1c$var$MR(K));
    }), $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(2)), ()=>{
        z.assign($d7238066c5de7f1c$var$YY(K, G, $d7238066c5de7f1c$var$ee(0)));
    }), $d7238066c5de7f1c$var$Ht(d.equal($d7238066c5de7f1c$var$ee(3)), ()=>{
        z.assign($d7238066c5de7f1c$var$zR(K, H, N, Y));
    }), z.assign(z.mul(v.sub(Z)).add(Z)), $d7238066c5de7f1c$var$Ht(V, ()=>{
        z.assign($d7238066c5de7f1c$var$sl(z, Z, v));
    }), z;
}).setLayout({
    name: "mx_unifiednoise3d",
    type: "float",
    inputs: [
        {
            name: "noiseType",
            type: "int"
        },
        {
            name: "position",
            type: "vec3"
        },
        {
            name: "freq",
            type: "vec3"
        },
        {
            name: "offset",
            type: "vec3"
        },
        {
            name: "jitter",
            type: "float"
        },
        {
            name: "outmin",
            type: "float"
        },
        {
            name: "outmax",
            type: "float"
        },
        {
            name: "clampoutput",
            type: "bool"
        },
        {
            name: "octaves",
            type: "int"
        },
        {
            name: "lacunarity",
            type: "float"
        },
        {
            name: "diminish",
            type: "float"
        }
    ]
}), $d7238066c5de7f1c$var$ale = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = r.y, t = r.z, i = $d7238066c5de7f1c$var$ne().toVar();
    return $d7238066c5de7f1c$var$Ht(e.lessThan(1e-4), ()=>{
        i.assign($d7238066c5de7f1c$var$ne(t, t, t));
    }).Else(()=>{
        let n = r.x;
        n = n.sub($d7238066c5de7f1c$var$ru(n)).mul(6).toVar();
        const s = $d7238066c5de7f1c$var$ee($d7238066c5de7f1c$var$xL(n)), a = n.sub($d7238066c5de7f1c$var$J(s)), o = t.mul(e.oneMinus()), g = t.mul(e.mul(a).oneMinus()), l = t.mul(e.mul(a.oneMinus()).oneMinus());
        $d7238066c5de7f1c$var$Ht(s.equal($d7238066c5de7f1c$var$ee(0)), ()=>{
            i.assign($d7238066c5de7f1c$var$ne(t, l, o));
        }).ElseIf(s.equal($d7238066c5de7f1c$var$ee(1)), ()=>{
            i.assign($d7238066c5de7f1c$var$ne(g, t, o));
        }).ElseIf(s.equal($d7238066c5de7f1c$var$ee(2)), ()=>{
            i.assign($d7238066c5de7f1c$var$ne(o, t, l));
        }).ElseIf(s.equal($d7238066c5de7f1c$var$ee(3)), ()=>{
            i.assign($d7238066c5de7f1c$var$ne(o, g, t));
        }).ElseIf(s.equal($d7238066c5de7f1c$var$ee(4)), ()=>{
            i.assign($d7238066c5de7f1c$var$ne(l, o, t));
        }).Else(()=>{
            i.assign($d7238066c5de7f1c$var$ne(t, o, g));
        });
    }), i;
}).setLayout({
    name: "mx_hsvtorgb",
    type: "vec3",
    inputs: [
        {
            name: "hsv",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$ole = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$J(e.x).toVar(), i = $d7238066c5de7f1c$var$J(e.y).toVar(), n = $d7238066c5de7f1c$var$J(e.z).toVar(), s = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$Xo(t, $d7238066c5de7f1c$var$Xo(i, n))).toVar(), a = $d7238066c5de7f1c$var$J($d7238066c5de7f1c$var$En(t, $d7238066c5de7f1c$var$En(i, n))).toVar(), o = $d7238066c5de7f1c$var$J(a.sub(s)).toVar(), g = $d7238066c5de7f1c$var$J().toVar(), l = $d7238066c5de7f1c$var$J().toVar(), c = $d7238066c5de7f1c$var$J().toVar();
    return c.assign(a), $d7238066c5de7f1c$var$Ht(a.greaterThan(0), ()=>{
        l.assign(o.div(a));
    }).Else(()=>{
        l.assign(0);
    }), $d7238066c5de7f1c$var$Ht(l.lessThanEqual(0), ()=>{
        g.assign(0);
    }).Else(()=>{
        $d7238066c5de7f1c$var$Ht(t.greaterThanEqual(a), ()=>{
            g.assign(i.sub(n).div(o));
        }).ElseIf(i.greaterThanEqual(a), ()=>{
            g.assign($d7238066c5de7f1c$var$Ps(2, n.sub(t).div(o)));
        }).Else(()=>{
            g.assign($d7238066c5de7f1c$var$Ps(4, t.sub(i).div(o)));
        }), g.mulAssign(1 / 6), $d7238066c5de7f1c$var$Ht(g.lessThan(0), ()=>{
            g.addAssign(1);
        });
    }), $d7238066c5de7f1c$var$ne(g, l, c);
}).setLayout({
    name: "mx_rgbtohsv",
    type: "vec3",
    inputs: [
        {
            name: "c",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$gle = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r])=>{
    const e = $d7238066c5de7f1c$var$ne(r).toVar(), t = $d7238066c5de7f1c$var$BL($d7238066c5de7f1c$var$WL(e, $d7238066c5de7f1c$var$ne(0.04045))).toVar(), i = $d7238066c5de7f1c$var$ne(e.div(12.92)).toVar(), n = $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$qg($d7238066c5de7f1c$var$En(e.add($d7238066c5de7f1c$var$ne(0.055)), $d7238066c5de7f1c$var$ne(0)).div(1.055), $d7238066c5de7f1c$var$ne(2.4))).toVar();
    return $d7238066c5de7f1c$var$qi(i, n, t);
}).setLayout({
    name: "mx_srgb_texture_to_lin_rec709",
    type: "vec3",
    inputs: [
        {
            name: "color",
            type: "vec3"
        }
    ]
}), $d7238066c5de7f1c$var$MD = (r, e)=>{
    r = $d7238066c5de7f1c$var$J(r), e = $d7238066c5de7f1c$var$J(e);
    const t = $d7238066c5de7f1c$var$Ne(e.dFdx(), e.dFdy()).length().mul(0.7071067811865476);
    return $d7238066c5de7f1c$var$ic(r.sub(t), r.add(t), e);
}, $d7238066c5de7f1c$var$zD = (r, e, t, i)=>$d7238066c5de7f1c$var$qi(r, e, t[i].clamp()), $d7238066c5de7f1c$var$lle = (r, e, t = $d7238066c5de7f1c$var$yn())=>$d7238066c5de7f1c$var$zD(r, e, t, "x"), $d7238066c5de7f1c$var$cle = (r, e, t = $d7238066c5de7f1c$var$yn())=>$d7238066c5de7f1c$var$zD(r, e, t, "y"), $d7238066c5de7f1c$var$ule = (r, e, t, i, n = $d7238066c5de7f1c$var$yn())=>{
    const s = n.x.clamp(), a = n.y.clamp(), o = $d7238066c5de7f1c$var$qi(r, e, s), g = $d7238066c5de7f1c$var$qi(t, i, s);
    return $d7238066c5de7f1c$var$qi(o, g, a);
}, $d7238066c5de7f1c$var$kD = (r, e, t, i, n)=>$d7238066c5de7f1c$var$qi(r, e, $d7238066c5de7f1c$var$MD(t, i[n])), $d7238066c5de7f1c$var$Ile = (r, e, t, i = $d7238066c5de7f1c$var$yn())=>$d7238066c5de7f1c$var$kD(r, e, t, i, "x"), $d7238066c5de7f1c$var$dle = (r, e, t, i = $d7238066c5de7f1c$var$yn())=>$d7238066c5de7f1c$var$kD(r, e, t, i, "y"), $d7238066c5de7f1c$var$hle = (r = 1, e = 0, t = $d7238066c5de7f1c$var$yn())=>t.mul(r).add(e), $d7238066c5de7f1c$var$Cle = (r, e = 1)=>(r = $d7238066c5de7f1c$var$J(r), r.abs().pow(e).mul(r.sign())), $d7238066c5de7f1c$var$ple = (r, e = 1, t = 0.5)=>$d7238066c5de7f1c$var$J(r).sub(t).mul(e).add(t), $d7238066c5de7f1c$var$mle = (r = $d7238066c5de7f1c$var$yn(), e = 1, t = 0)=>$d7238066c5de7f1c$var$LY(r.convert("vec2|vec3")).mul(e).add(t), $d7238066c5de7f1c$var$Ale = (r = $d7238066c5de7f1c$var$yn(), e = 1, t = 0)=>$d7238066c5de7f1c$var$nf(r.convert("vec2|vec3")).mul(e).add(t), $d7238066c5de7f1c$var$ble = (r = $d7238066c5de7f1c$var$yn(), e = 1, t = 0)=>(r = r.convert("vec2|vec3"), $d7238066c5de7f1c$var$Rt($d7238066c5de7f1c$var$nf(r), $d7238066c5de7f1c$var$LY(r.add($d7238066c5de7f1c$var$Ne(19, 73)))).mul(e).add(t)), $d7238066c5de7f1c$var$yle = (r, e = $d7238066c5de7f1c$var$yn(), t = $d7238066c5de7f1c$var$Ne(1, 1), i = $d7238066c5de7f1c$var$Ne(0, 0), n = 1, s = 0, a = 1, o = !1, g = 1, l = 2, c = 0.5)=>$d7238066c5de7f1c$var$sle(r, e.convert("vec2|vec3"), t, i, n, s, a, o, g, l, c), $d7238066c5de7f1c$var$Ble = (r, e = $d7238066c5de7f1c$var$yn(), t = $d7238066c5de7f1c$var$Ne(1, 1), i = $d7238066c5de7f1c$var$Ne(0, 0), n = 1, s = 0, a = 1, o = !1, g = 1, l = 2, c = 0.5)=>$d7238066c5de7f1c$var$rle(r, e.convert("vec2|vec3"), t, i, n, s, a, o, g, l, c), $d7238066c5de7f1c$var$fle = (r = $d7238066c5de7f1c$var$yn(), e = 1)=>$d7238066c5de7f1c$var$ele(r.convert("vec2|vec3"), e, $d7238066c5de7f1c$var$ee(1)), $d7238066c5de7f1c$var$Gle = (r = $d7238066c5de7f1c$var$yn(), e = 1)=>$d7238066c5de7f1c$var$ile(r.convert("vec2|vec3"), e, $d7238066c5de7f1c$var$ee(1)), $d7238066c5de7f1c$var$vle = (r = $d7238066c5de7f1c$var$yn(), e = 1)=>$d7238066c5de7f1c$var$YY(r.convert("vec2|vec3"), e, $d7238066c5de7f1c$var$ee(1)), $d7238066c5de7f1c$var$Sle = (r = $d7238066c5de7f1c$var$yn())=>$d7238066c5de7f1c$var$zge(r.convert("vec2|vec3")), $d7238066c5de7f1c$var$Zle = (r = $d7238066c5de7f1c$var$yn(), e = 3, t = 2, i = 0.5, n = 1)=>$d7238066c5de7f1c$var$FZ(r, $d7238066c5de7f1c$var$ee(e), t, i).mul(n), $d7238066c5de7f1c$var$Rle = (r = $d7238066c5de7f1c$var$yn(), e = 3, t = 2, i = 0.5, n = 1)=>$d7238066c5de7f1c$var$Dge(r, $d7238066c5de7f1c$var$ee(e), t, i).mul(n), $d7238066c5de7f1c$var$Vle = (r = $d7238066c5de7f1c$var$yn(), e = 3, t = 2, i = 0.5, n = 1)=>$d7238066c5de7f1c$var$zR(r, $d7238066c5de7f1c$var$ee(e), t, i).mul(n), $d7238066c5de7f1c$var$wle = (r = $d7238066c5de7f1c$var$yn(), e = 3, t = 2, i = 0.5, n = 1)=>$d7238066c5de7f1c$var$_ge(r, $d7238066c5de7f1c$var$ee(e), t, i).mul(n), $d7238066c5de7f1c$var$Wle = (r, e = $d7238066c5de7f1c$var$J(0))=>$d7238066c5de7f1c$var$Ps(r, e), $d7238066c5de7f1c$var$Hle = (r, e = $d7238066c5de7f1c$var$J(0))=>$d7238066c5de7f1c$var$wi(r, e), $d7238066c5de7f1c$var$Xle = (r, e = $d7238066c5de7f1c$var$J(1))=>$d7238066c5de7f1c$var$Et(r, e), $d7238066c5de7f1c$var$Nle = (r, e = $d7238066c5de7f1c$var$J(1))=>$d7238066c5de7f1c$var$cg(r, e), $d7238066c5de7f1c$var$Lle = (r, e = $d7238066c5de7f1c$var$J(1))=>$d7238066c5de7f1c$var$UB(r, e), $d7238066c5de7f1c$var$Yle = (r, e = $d7238066c5de7f1c$var$J(1))=>$d7238066c5de7f1c$var$qg(r, e), $d7238066c5de7f1c$var$Kle = (r = $d7238066c5de7f1c$var$J(0), e = $d7238066c5de7f1c$var$J(1))=>$d7238066c5de7f1c$var$fR(r, e), $d7238066c5de7f1c$var$xle = ()=>$d7238066c5de7f1c$var$o0, $d7238066c5de7f1c$var$Fle = ()=>$d7238066c5de7f1c$var$iD, $d7238066c5de7f1c$var$Tle = (r, e = $d7238066c5de7f1c$var$J(1))=>$d7238066c5de7f1c$var$wi(e, r), $d7238066c5de7f1c$var$Mle = (r, e, t, i)=>r.greaterThan(e).mix(t, i), $d7238066c5de7f1c$var$zle = (r, e, t, i)=>r.greaterThanEqual(e).mix(t, i), $d7238066c5de7f1c$var$kle = (r, e, t, i)=>r.equal(e).mix(t, i), $d7238066c5de7f1c$var$Ele = (r, e = null)=>{
    if (typeof e == "string") {
        const t = {
            x: 0,
            r: 0,
            y: 1,
            g: 1,
            z: 2,
            b: 2,
            w: 3,
            a: 3
        }, i = e.replace(/^out/, "").toLowerCase();
        if (t[i] !== void 0) return r.element(t[i]);
    }
    if (typeof e == "number") return r.element(e);
    if (typeof e == "string" && e.length === 1) {
        const t = {
            x: 0,
            r: 0,
            y: 1,
            g: 1,
            z: 2,
            b: 2,
            w: 3,
            a: 3
        };
        if (t[e] !== void 0) return r.element(t[e]);
    }
    return r;
}, $d7238066c5de7f1c$var$Jle = (r, e = $d7238066c5de7f1c$var$Ne(0.5, 0.5), t = $d7238066c5de7f1c$var$Ne(1, 1), i = $d7238066c5de7f1c$var$J(0), n = $d7238066c5de7f1c$var$Ne(0, 0))=>{
    let s = r;
    if (e && (s = s.sub(e)), t && (s = s.mul(t)), i) {
        const a = i.mul(Math.PI / 180), o = a.cos(), g = a.sin();
        s = $d7238066c5de7f1c$var$Ne(s.x.mul(o).sub(s.y.mul(g)), s.x.mul(g).add(s.y.mul(o)));
    }
    return e && (s = s.add(e)), n && (s = s.add(n)), s;
}, $d7238066c5de7f1c$var$Ule = (r, e)=>{
    r = $d7238066c5de7f1c$var$Ne(r), e = $d7238066c5de7f1c$var$J(e);
    const t = e.mul(Math.PI / 180);
    return $d7238066c5de7f1c$var$qB(r, t);
}, $d7238066c5de7f1c$var$Dle = (r, e, t)=>{
    r = $d7238066c5de7f1c$var$ne(r), e = $d7238066c5de7f1c$var$J(e), t = $d7238066c5de7f1c$var$ne(t);
    const i = e.mul(Math.PI / 180), n = t.normalize(), s = i.cos(), a = i.sin(), o = $d7238066c5de7f1c$var$J(1).sub(s);
    return r.mul(s).add(n.cross(r).mul(a)).add(n.mul(n.dot(r)).mul(o));
}, $d7238066c5de7f1c$var$_le = (r, e)=>(r = $d7238066c5de7f1c$var$ne(r), e = $d7238066c5de7f1c$var$J(e), $d7238066c5de7f1c$var$aY(r, e)), $d7238066c5de7f1c$var$Ple = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e, t])=>{
    const i = $d7238066c5de7f1c$var$wo(r).toVar(), n = $d7238066c5de7f1c$var$wi($d7238066c5de7f1c$var$J(0.5).mul(e.sub(t)), $d7238066c5de7f1c$var$ou).div(i).toVar(), s = $d7238066c5de7f1c$var$wi($d7238066c5de7f1c$var$J(-0.5).mul(e.sub(t)), $d7238066c5de7f1c$var$ou).div(i).toVar(), a = $d7238066c5de7f1c$var$ne().toVar();
    a.x = i.x.greaterThan($d7238066c5de7f1c$var$J(0)).select(n.x, s.x), a.y = i.y.greaterThan($d7238066c5de7f1c$var$J(0)).select(n.y, s.y), a.z = i.z.greaterThan($d7238066c5de7f1c$var$J(0)).select(n.z, s.z);
    const o = $d7238066c5de7f1c$var$Xo(a.x, a.y, a.z).toVar();
    return $d7238066c5de7f1c$var$ou.add(i.mul(o)).toVar().sub(t);
}), $d7238066c5de7f1c$var$ED = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = r.x, i = r.y, n = r.z;
    let s = e.element(0).mul(0.886227);
    return s = s.add(e.element(1).mul(1.023328).mul(i)), s = s.add(e.element(2).mul(1.023328).mul(n)), s = s.add(e.element(3).mul(1.023328).mul(t)), s = s.add(e.element(4).mul(0.858086).mul(t).mul(i)), s = s.add(e.element(5).mul(0.858086).mul(i).mul(n)), s = s.add(e.element(6).mul(n.mul(n).mul(0.743125).sub(0.247708))), s = s.add(e.element(7).mul(0.858086).mul(t).mul(n)), s = s.add(e.element(8).mul(0.429043).mul($d7238066c5de7f1c$var$Et(t, t).sub($d7238066c5de7f1c$var$Et(i, i)))), s;
});
var $d7238066c5de7f1c$var$W = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    BRDF_GGX: $d7238066c5de7f1c$var$AY,
    BRDF_Lambert: $d7238066c5de7f1c$var$JC,
    BasicPointShadowFilter: $d7238066c5de7f1c$var$HD,
    BasicShadowFilter: $d7238066c5de7f1c$var$GD,
    Break: $d7238066c5de7f1c$var$AU,
    Const: $d7238066c5de7f1c$var$FE,
    Continue: $d7238066c5de7f1c$var$Eie,
    DFGApprox: $d7238066c5de7f1c$var$mB,
    D_GGX: $d7238066c5de7f1c$var$xU,
    Discard: $d7238066c5de7f1c$var$tJ,
    EPSILON: $d7238066c5de7f1c$var$HL,
    F_Schlick: $d7238066c5de7f1c$var$JA,
    Fn: $d7238066c5de7f1c$var$oe,
    HALF_PI: $d7238066c5de7f1c$var$pte,
    INFINITY: $d7238066c5de7f1c$var$dte,
    If: $d7238066c5de7f1c$var$Ht,
    Loop: $d7238066c5de7f1c$var$Cn,
    NodeAccess: $d7238066c5de7f1c$var$da,
    NodeShaderStage: $d7238066c5de7f1c$var$by,
    NodeType: $d7238066c5de7f1c$var$Kee,
    NodeUpdateType: $d7238066c5de7f1c$var$Dt,
    OnBeforeMaterialUpdate: $d7238066c5de7f1c$var$oae,
    OnBeforeObjectUpdate: $d7238066c5de7f1c$var$aae,
    OnMaterialUpdate: $d7238066c5de7f1c$var$rae,
    OnObjectUpdate: $d7238066c5de7f1c$var$sae,
    PCFShadowFilter: $d7238066c5de7f1c$var$vD,
    PCFSoftShadowFilter: $d7238066c5de7f1c$var$SD,
    PI: $d7238066c5de7f1c$var$HZ,
    PI2: $d7238066c5de7f1c$var$hte,
    PointShadowFilter: $d7238066c5de7f1c$var$XD,
    Return: $d7238066c5de7f1c$var$Xte,
    Schlick_to_F0: $d7238066c5de7f1c$var$TU,
    ScriptableNodeResources: $d7238066c5de7f1c$var$NS,
    ShaderNode: $d7238066c5de7f1c$var$hA,
    Stack: $d7238066c5de7f1c$var$CR,
    Switch: $d7238066c5de7f1c$var$ste,
    TBNViewMatrix: $d7238066c5de7f1c$var$XC,
    TWO_PI: $d7238066c5de7f1c$var$Cte,
    VSMShadowFilter: $d7238066c5de7f1c$var$ZD,
    V_GGX_SmithCorrelated: $d7238066c5de7f1c$var$KU,
    Var: $d7238066c5de7f1c$var$xE,
    VarIntent: $d7238066c5de7f1c$var$TE,
    abs: $d7238066c5de7f1c$var$Wn,
    acesFilmicToneMapping: $d7238066c5de7f1c$var$hD,
    acos: $d7238066c5de7f1c$var$LL,
    add: $d7238066c5de7f1c$var$Ps,
    addMethodChaining: $d7238066c5de7f1c$var$Se,
    addNodeElement: $d7238066c5de7f1c$var$Kte,
    agxToneMapping: $d7238066c5de7f1c$var$CD,
    all: $d7238066c5de7f1c$var$lE,
    alphaT: $d7238066c5de7f1c$var$VZ,
    and: $d7238066c5de7f1c$var$P3,
    anisotropy: $d7238066c5de7f1c$var$Jd,
    anisotropyB: $d7238066c5de7f1c$var$FC,
    anisotropyT: $d7238066c5de7f1c$var$Jy,
    any: $d7238066c5de7f1c$var$cE,
    append: $d7238066c5de7f1c$var$gte,
    array: $d7238066c5de7f1c$var$z3,
    arrayBuffer: $d7238066c5de7f1c$var$ate,
    asin: $d7238066c5de7f1c$var$hE,
    assign: $d7238066c5de7f1c$var$k3,
    atan: $d7238066c5de7f1c$var$fR,
    atan2: $d7238066c5de7f1c$var$NE,
    atomicAdd: $d7238066c5de7f1c$var$doe,
    atomicAnd: $d7238066c5de7f1c$var$moe,
    atomicFunc: $d7238066c5de7f1c$var$mu,
    atomicLoad: $d7238066c5de7f1c$var$uoe,
    atomicMax: $d7238066c5de7f1c$var$Coe,
    atomicMin: $d7238066c5de7f1c$var$poe,
    atomicOr: $d7238066c5de7f1c$var$Aoe,
    atomicStore: $d7238066c5de7f1c$var$Ioe,
    atomicSub: $d7238066c5de7f1c$var$hoe,
    atomicXor: $d7238066c5de7f1c$var$boe,
    attenuationColor: $d7238066c5de7f1c$var$ZL,
    attenuationDistance: $d7238066c5de7f1c$var$SL,
    attribute: $d7238066c5de7f1c$var$RI,
    attributeArray: $d7238066c5de7f1c$var$cae,
    backgroundBlurriness: $d7238066c5de7f1c$var$rD,
    backgroundIntensity: $d7238066c5de7f1c$var$J2,
    backgroundRotation: $d7238066c5de7f1c$var$aD,
    batch: $d7238066c5de7f1c$var$CU,
    bentNormalView: $d7238066c5de7f1c$var$NJ,
    billboarding: $d7238066c5de7f1c$var$Mre,
    bitAnd: $d7238066c5de7f1c$var$q3,
    bitNot: $d7238066c5de7f1c$var$$3,
    bitOr: $d7238066c5de7f1c$var$eE,
    bitXor: $d7238066c5de7f1c$var$tE,
    bitangentGeometry: $d7238066c5de7f1c$var$fie,
    bitangentLocal: $d7238066c5de7f1c$var$Gie,
    bitangentView: $d7238066c5de7f1c$var$HJ,
    bitangentWorld: $d7238066c5de7f1c$var$vie,
    bitcast: $d7238066c5de7f1c$var$yre,
    blendBurn: $d7238066c5de7f1c$var$vU,
    blendColor: $d7238066c5de7f1c$var$ane,
    blendDodge: $d7238066c5de7f1c$var$SU,
    blendOverlay: $d7238066c5de7f1c$var$RU,
    blendScreen: $d7238066c5de7f1c$var$ZU,
    blur: $d7238066c5de7f1c$var$UU,
    bool: $d7238066c5de7f1c$var$nl,
    buffer: $d7238066c5de7f1c$var$PB,
    bufferAttribute: $d7238066c5de7f1c$var$_B,
    builtin: $d7238066c5de7f1c$var$HI,
    bumpMap: $d7238066c5de7f1c$var$aY,
    burn: $d7238066c5de7f1c$var$gne,
    bvec2: $d7238066c5de7f1c$var$H3,
    bvec3: $d7238066c5de7f1c$var$BL,
    bvec4: $d7238066c5de7f1c$var$Y3,
    bypass: $d7238066c5de7f1c$var$jE,
    cache: $d7238066c5de7f1c$var$OE,
    call: $d7238066c5de7f1c$var$E3,
    cameraFar: $d7238066c5de7f1c$var$Pd,
    cameraIndex: $d7238066c5de7f1c$var$uh,
    cameraNear: $d7238066c5de7f1c$var$_d,
    cameraNormalMatrix: $d7238066c5de7f1c$var$jte,
    cameraPosition: $d7238066c5de7f1c$var$lJ,
    cameraProjectionMatrix: $d7238066c5de7f1c$var$s0,
    cameraProjectionMatrixInverse: $d7238066c5de7f1c$var$Qte,
    cameraViewMatrix: $d7238066c5de7f1c$var$ol,
    cameraViewport: $d7238066c5de7f1c$var$qte,
    cameraWorldMatrix: $d7238066c5de7f1c$var$Ote,
    cbrt: $d7238066c5de7f1c$var$VE,
    cdl: $d7238066c5de7f1c$var$Zae,
    ceil: $d7238066c5de7f1c$var$BR,
    checker: $d7238066c5de7f1c$var$Ige,
    cineonToneMapping: $d7238066c5de7f1c$var$dD,
    clamp: $d7238066c5de7f1c$var$sl,
    clearcoat: $d7238066c5de7f1c$var$RZ,
    clearcoatNormalView: $d7238066c5de7f1c$var$HC,
    clearcoatRoughness: $d7238066c5de7f1c$var$hB,
    code: $d7238066c5de7f1c$var$xR,
    color: $d7238066c5de7f1c$var$w3,
    colorSpaceToWorking: $d7238066c5de7f1c$var$vR,
    colorToDirection: $d7238066c5de7f1c$var$Ane,
    compute: $d7238066c5de7f1c$var$QE,
    computeKernel: $d7238066c5de7f1c$var$QL,
    computeSkinning: $d7238066c5de7f1c$var$zie,
    context: $d7238066c5de7f1c$var$DB,
    convert: $d7238066c5de7f1c$var$x3,
    convertColorSpace: $d7238066c5de7f1c$var$Gte,
    convertToTexture: $d7238066c5de7f1c$var$qre,
    cos: $d7238066c5de7f1c$var$_c,
    cross: $d7238066c5de7f1c$var$kC,
    cubeTexture: $d7238066c5de7f1c$var$EA,
    cubeTextureBase: $d7238066c5de7f1c$var$rY,
    cubeToUV: $d7238066c5de7f1c$var$kl,
    dFdx: $d7238066c5de7f1c$var$YL,
    dFdy: $d7238066c5de7f1c$var$KL,
    dashSize: $d7238066c5de7f1c$var$ZS,
    debug: $d7238066c5de7f1c$var$nJ,
    decrement: $d7238066c5de7f1c$var$oE,
    decrementBefore: $d7238066c5de7f1c$var$rE,
    defaultBuildStages: $d7238066c5de7f1c$var$Z2,
    defaultShaderStages: $d7238066c5de7f1c$var$G3,
    defined: $d7238066c5de7f1c$var$cB,
    degrees: $d7238066c5de7f1c$var$IE,
    deltaTime: $d7238066c5de7f1c$var$Nre,
    densityFog: $d7238066c5de7f1c$var$Pae,
    densityFogFactor: $d7238066c5de7f1c$var$ZY,
    depth: $d7238066c5de7f1c$var$hY,
    depthPass: $d7238066c5de7f1c$var$Hae,
    determinant: $d7238066c5de7f1c$var$yE,
    difference: $d7238066c5de7f1c$var$SE,
    diffuseColor: $d7238066c5de7f1c$var$Ei,
    directPointLight: $d7238066c5de7f1c$var$LD,
    directionToColor: $d7238066c5de7f1c$var$wU,
    directionToFaceDirection: $d7238066c5de7f1c$var$r0,
    dispersion: $d7238066c5de7f1c$var$RL,
    distance: $d7238066c5de7f1c$var$vE,
    div: $d7238066c5de7f1c$var$cg,
    dodge: $d7238066c5de7f1c$var$lne,
    dot: $d7238066c5de7f1c$var$tc,
    drawIndex: $d7238066c5de7f1c$var$IU,
    dynamicBufferAttribute: $d7238066c5de7f1c$var$PE,
    element: $d7238066c5de7f1c$var$K3,
    emissive: $d7238066c5de7f1c$var$W2,
    equal: $d7238066c5de7f1c$var$wL,
    equals: $d7238066c5de7f1c$var$fE,
    equirectUV: $d7238066c5de7f1c$var$CY,
    exp: $d7238066c5de7f1c$var$XL,
    exp2: $d7238066c5de7f1c$var$zA,
    expression: $d7238066c5de7f1c$var$ZI,
    faceDirection: $d7238066c5de7f1c$var$iY,
    faceForward: $d7238066c5de7f1c$var$JL,
    faceforward: $d7238066c5de7f1c$var$mte,
    float: $d7238066c5de7f1c$var$J,
    floatBitsToInt: $d7238066c5de7f1c$var$Bre,
    floatBitsToUint: $d7238066c5de7f1c$var$fre,
    floor: $d7238066c5de7f1c$var$ru,
    fog: $d7238066c5de7f1c$var$bB,
    fract: $d7238066c5de7f1c$var$ec,
    frameGroup: $d7238066c5de7f1c$var$M3,
    frameId: $d7238066c5de7f1c$var$iD,
    frontFacing: $d7238066c5de7f1c$var$dJ,
    fwidth: $d7238066c5de7f1c$var$FL,
    gain: $d7238066c5de7f1c$var$Zre,
    gapSize: $d7238066c5de7f1c$var$H2,
    getConstNodeType: $d7238066c5de7f1c$var$V3,
    getCurrentStack: $d7238066c5de7f1c$var$yL,
    getDirection: $d7238066c5de7f1c$var$EU,
    getDistanceAttenuation: $d7238066c5de7f1c$var$NY,
    getGeometryRoughness: $d7238066c5de7f1c$var$YU,
    getNormalFromDepth: $d7238066c5de7f1c$var$eae,
    getParallaxCorrectNormal: $d7238066c5de7f1c$var$Ple,
    getRoughness: $d7238066c5de7f1c$var$mY,
    getScreenPosition: $d7238066c5de7f1c$var$$re,
    getShIrradianceAt: $d7238066c5de7f1c$var$ED,
    getShadowMaterial: $d7238066c5de7f1c$var$RD,
    getShadowRenderObjectFunction: $d7238066c5de7f1c$var$VD,
    getTextureIndex: $d7238066c5de7f1c$var$eD,
    getViewPosition: $d7238066c5de7f1c$var$sA,
    ggxConvolution: $d7238066c5de7f1c$var$DU,
    globalId: $d7238066c5de7f1c$var$eoe,
    glsl: $d7238066c5de7f1c$var$Mae,
    glslFn: $d7238066c5de7f1c$var$zae,
    grayscale: $d7238066c5de7f1c$var$fae,
    greaterThan: $d7238066c5de7f1c$var$WL,
    greaterThanEqual: $d7238066c5de7f1c$var$_3,
    hash: $d7238066c5de7f1c$var$Sre,
    highpModelNormalViewMatrix: $d7238066c5de7f1c$var$L2,
    highpModelViewMatrix: $d7238066c5de7f1c$var$N2,
    hue: $d7238066c5de7f1c$var$Sae,
    increment: $d7238066c5de7f1c$var$aE,
    incrementBefore: $d7238066c5de7f1c$var$sE,
    inspector: $d7238066c5de7f1c$var$rJ,
    instance: $d7238066c5de7f1c$var$Lie,
    instanceIndex: $d7238066c5de7f1c$var$rh,
    instancedArray: $d7238066c5de7f1c$var$uae,
    instancedBufferAttribute: $d7238066c5de7f1c$var$XZ,
    instancedDynamicBufferAttribute: $d7238066c5de7f1c$var$X2,
    instancedMesh: $d7238066c5de7f1c$var$hU,
    int: $d7238066c5de7f1c$var$ee,
    intBitsToFloat: $d7238066c5de7f1c$var$Gre,
    interleavedGradientNoise: $d7238066c5de7f1c$var$tae,
    inverse: $d7238066c5de7f1c$var$BE,
    inverseSqrt: $d7238066c5de7f1c$var$NL,
    inversesqrt: $d7238066c5de7f1c$var$Ate,
    invocationLocalIndex: $d7238066c5de7f1c$var$Nie,
    invocationSubgroupIndex: $d7238066c5de7f1c$var$Xie,
    ior: $d7238066c5de7f1c$var$Uy,
    iridescence: $d7238066c5de7f1c$var$AR,
    iridescenceIOR: $d7238066c5de7f1c$var$fL,
    iridescenceThickness: $d7238066c5de7f1c$var$GL,
    isolate: $d7238066c5de7f1c$var$VA,
    ivec2: $d7238066c5de7f1c$var$vr,
    ivec3: $d7238066c5de7f1c$var$X3,
    ivec4: $d7238066c5de7f1c$var$N3,
    js: $d7238066c5de7f1c$var$Fae,
    label: $d7238066c5de7f1c$var$KE,
    length: $d7238066c5de7f1c$var$au,
    lengthSq: $d7238066c5de7f1c$var$zL,
    lessThan: $d7238066c5de7f1c$var$U3,
    lessThanEqual: $d7238066c5de7f1c$var$D3,
    lightPosition: $d7238066c5de7f1c$var$VY,
    lightProjectionUV: $d7238066c5de7f1c$var$BD,
    lightShadowMatrix: $d7238066c5de7f1c$var$TR,
    lightTargetDirection: $d7238066c5de7f1c$var$WY,
    lightTargetPosition: $d7238066c5de7f1c$var$fD,
    lightViewPosition: $d7238066c5de7f1c$var$wY,
    lightingContext: $d7238066c5de7f1c$var$yU,
    lights: $d7238066c5de7f1c$var$_oe,
    linearDepth: $d7238066c5de7f1c$var$LZ,
    linearToneMapping: $d7238066c5de7f1c$var$uD,
    localId: $d7238066c5de7f1c$var$toe,
    log: $d7238066c5de7f1c$var$yR,
    log2: $d7238066c5de7f1c$var$su,
    logarithmicDepthToViewZ: $d7238066c5de7f1c$var$qie,
    luminance: $d7238066c5de7f1c$var$vY,
    mat2: $d7238066c5de7f1c$var$pR,
    mat3: $d7238066c5de7f1c$var$Fa,
    mat4: $d7238066c5de7f1c$var$xC,
    matcapUV: $d7238066c5de7f1c$var$_U,
    materialAO: $d7238066c5de7f1c$var$cU,
    materialAlphaTest: $d7238066c5de7f1c$var$LJ,
    materialAnisotropy: $d7238066c5de7f1c$var$QJ,
    materialAnisotropyVector: $d7238066c5de7f1c$var$nA,
    materialAttenuationColor: $d7238066c5de7f1c$var$nU,
    materialAttenuationDistance: $d7238066c5de7f1c$var$iU,
    materialClearcoat: $d7238066c5de7f1c$var$EJ,
    materialClearcoatNormal: $d7238066c5de7f1c$var$UJ,
    materialClearcoatRoughness: $d7238066c5de7f1c$var$JJ,
    materialColor: $d7238066c5de7f1c$var$YJ,
    materialDispersion: $d7238066c5de7f1c$var$lU,
    materialEmissive: $d7238066c5de7f1c$var$xJ,
    materialEnvIntensity: $d7238066c5de7f1c$var$wS,
    materialEnvRotation: $d7238066c5de7f1c$var$sY,
    materialIOR: $d7238066c5de7f1c$var$tU,
    materialIridescence: $d7238066c5de7f1c$var$OJ,
    materialIridescenceIOR: $d7238066c5de7f1c$var$jJ,
    materialIridescenceThickness: $d7238066c5de7f1c$var$qJ,
    materialLightMap: $d7238066c5de7f1c$var$gY,
    materialLineDashOffset: $d7238066c5de7f1c$var$oU,
    materialLineDashSize: $d7238066c5de7f1c$var$rU,
    materialLineGapSize: $d7238066c5de7f1c$var$aU,
    materialLineScale: $d7238066c5de7f1c$var$sU,
    materialLineWidth: $d7238066c5de7f1c$var$Wie,
    materialMetalness: $d7238066c5de7f1c$var$zJ,
    materialNormal: $d7238066c5de7f1c$var$kJ,
    materialOpacity: $d7238066c5de7f1c$var$oY,
    materialPointSize: $d7238066c5de7f1c$var$gU,
    materialReference: $d7238066c5de7f1c$var$rI,
    materialReflectivity: $d7238066c5de7f1c$var$WS,
    materialRefractionRatio: $d7238066c5de7f1c$var$mJ,
    materialRotation: $d7238066c5de7f1c$var$DJ,
    materialRoughness: $d7238066c5de7f1c$var$MJ,
    materialSheen: $d7238066c5de7f1c$var$_J,
    materialSheenRoughness: $d7238066c5de7f1c$var$PJ,
    materialShininess: $d7238066c5de7f1c$var$KJ,
    materialSpecular: $d7238066c5de7f1c$var$FJ,
    materialSpecularColor: $d7238066c5de7f1c$var$TJ,
    materialSpecularIntensity: $d7238066c5de7f1c$var$T2,
    materialSpecularStrength: $d7238066c5de7f1c$var$Dy,
    materialThickness: $d7238066c5de7f1c$var$eU,
    materialTransmission: $d7238066c5de7f1c$var$$J,
    max: $d7238066c5de7f1c$var$En,
    maxMipLevel: $d7238066c5de7f1c$var$OL,
    mediumpModelViewMatrix: $d7238066c5de7f1c$var$IJ,
    metalness: $d7238066c5de7f1c$var$dB,
    min: $d7238066c5de7f1c$var$Xo,
    mix: $d7238066c5de7f1c$var$qi,
    mixElement: $d7238066c5de7f1c$var$WE,
    mod: $d7238066c5de7f1c$var$UB,
    modInt: $d7238066c5de7f1c$var$gE,
    modelDirection: $d7238066c5de7f1c$var$sie,
    modelNormalMatrix: $d7238066c5de7f1c$var$uJ,
    modelPosition: $d7238066c5de7f1c$var$rie,
    modelRadius: $d7238066c5de7f1c$var$gie,
    modelScale: $d7238066c5de7f1c$var$aie,
    modelViewMatrix: $d7238066c5de7f1c$var$qC,
    modelViewPosition: $d7238066c5de7f1c$var$oie,
    modelViewProjection: $d7238066c5de7f1c$var$lY,
    modelWorldMatrix: $d7238066c5de7f1c$var$$g,
    modelWorldMatrixInverse: $d7238066c5de7f1c$var$lie,
    morphReference: $d7238066c5de7f1c$var$bU,
    mrt: $d7238066c5de7f1c$var$tD,
    mul: $d7238066c5de7f1c$var$Et,
    mx_aastep: $d7238066c5de7f1c$var$MD,
    mx_add: $d7238066c5de7f1c$var$Wle,
    mx_atan2: $d7238066c5de7f1c$var$Kle,
    mx_cell_noise_float: $d7238066c5de7f1c$var$Sle,
    mx_contrast: $d7238066c5de7f1c$var$ple,
    mx_divide: $d7238066c5de7f1c$var$Nle,
    mx_fractal_noise_float: $d7238066c5de7f1c$var$Zle,
    mx_fractal_noise_vec2: $d7238066c5de7f1c$var$Rle,
    mx_fractal_noise_vec3: $d7238066c5de7f1c$var$Vle,
    mx_fractal_noise_vec4: $d7238066c5de7f1c$var$wle,
    mx_frame: $d7238066c5de7f1c$var$Fle,
    mx_heighttonormal: $d7238066c5de7f1c$var$_le,
    mx_hsvtorgb: $d7238066c5de7f1c$var$ale,
    mx_ifequal: $d7238066c5de7f1c$var$kle,
    mx_ifgreater: $d7238066c5de7f1c$var$Mle,
    mx_ifgreatereq: $d7238066c5de7f1c$var$zle,
    mx_invert: $d7238066c5de7f1c$var$Tle,
    mx_modulo: $d7238066c5de7f1c$var$Lle,
    mx_multiply: $d7238066c5de7f1c$var$Xle,
    mx_noise_float: $d7238066c5de7f1c$var$mle,
    mx_noise_vec3: $d7238066c5de7f1c$var$Ale,
    mx_noise_vec4: $d7238066c5de7f1c$var$ble,
    mx_place2d: $d7238066c5de7f1c$var$Jle,
    mx_power: $d7238066c5de7f1c$var$Yle,
    mx_ramp4: $d7238066c5de7f1c$var$ule,
    mx_ramplr: $d7238066c5de7f1c$var$lle,
    mx_ramptb: $d7238066c5de7f1c$var$cle,
    mx_rgbtohsv: $d7238066c5de7f1c$var$ole,
    mx_rotate2d: $d7238066c5de7f1c$var$Ule,
    mx_rotate3d: $d7238066c5de7f1c$var$Dle,
    mx_safepower: $d7238066c5de7f1c$var$Cle,
    mx_separate: $d7238066c5de7f1c$var$Ele,
    mx_splitlr: $d7238066c5de7f1c$var$Ile,
    mx_splittb: $d7238066c5de7f1c$var$dle,
    mx_srgb_texture_to_lin_rec709: $d7238066c5de7f1c$var$gle,
    mx_subtract: $d7238066c5de7f1c$var$Hle,
    mx_timer: $d7238066c5de7f1c$var$xle,
    mx_transform_uv: $d7238066c5de7f1c$var$hle,
    mx_unifiednoise2d: $d7238066c5de7f1c$var$yle,
    mx_unifiednoise3d: $d7238066c5de7f1c$var$Ble,
    mx_worley_noise_float: $d7238066c5de7f1c$var$fle,
    mx_worley_noise_vec2: $d7238066c5de7f1c$var$Gle,
    mx_worley_noise_vec3: $d7238066c5de7f1c$var$vle,
    negate: $d7238066c5de7f1c$var$CE,
    neutralToneMapping: $d7238066c5de7f1c$var$pD,
    nodeArray: $d7238066c5de7f1c$var$KC,
    nodeImmutable: $d7238066c5de7f1c$var$je,
    nodeObject: $d7238066c5de7f1c$var$He,
    nodeObjectIntent: $d7238066c5de7f1c$var$yy,
    nodeObjects: $d7238066c5de7f1c$var$hR,
    nodeProxy: $d7238066c5de7f1c$var$zt,
    nodeProxyIntent: $d7238066c5de7f1c$var$De,
    normalFlat: $d7238066c5de7f1c$var$hJ,
    normalGeometry: $d7238066c5de7f1c$var$SR,
    normalLocal: $d7238066c5de7f1c$var$No,
    normalMap: $d7238066c5de7f1c$var$F2,
    normalView: $d7238066c5de7f1c$var$gn,
    normalViewGeometry: $d7238066c5de7f1c$var$kA,
    normalWorld: $d7238066c5de7f1c$var$Ih,
    normalWorldGeometry: $d7238066c5de7f1c$var$CJ,
    normalize: $d7238066c5de7f1c$var$wo,
    not: $d7238066c5de7f1c$var$O3,
    notEqual: $d7238066c5de7f1c$var$J3,
    numWorkgroups: $d7238066c5de7f1c$var$qae,
    objectDirection: $d7238066c5de7f1c$var$$te,
    objectGroup: $d7238066c5de7f1c$var$VL,
    objectPosition: $d7238066c5de7f1c$var$cJ,
    objectRadius: $d7238066c5de7f1c$var$nie,
    objectScale: $d7238066c5de7f1c$var$tie,
    objectViewPosition: $d7238066c5de7f1c$var$iie,
    objectWorldMatrix: $d7238066c5de7f1c$var$eie,
    oneMinus: $d7238066c5de7f1c$var$pE,
    or: $d7238066c5de7f1c$var$Q3,
    orthographicDepthToViewZ: $d7238066c5de7f1c$var$jie,
    oscSawtooth: $d7238066c5de7f1c$var$xre,
    oscSine: $d7238066c5de7f1c$var$Lre,
    oscSquare: $d7238066c5de7f1c$var$Yre,
    oscTriangle: $d7238066c5de7f1c$var$Kre,
    output: $d7238066c5de7f1c$var$ZA,
    outputStruct: $d7238066c5de7f1c$var$Are,
    overlay: $d7238066c5de7f1c$var$une,
    overloadingFn: $d7238066c5de7f1c$var$pa,
    parabola: $d7238066c5de7f1c$var$E2,
    parallaxDirection: $d7238066c5de7f1c$var$XJ,
    parallaxUV: $d7238066c5de7f1c$var$Sie,
    parameter: $d7238066c5de7f1c$var$Ire,
    pass: $d7238066c5de7f1c$var$wae,
    passTexture: $d7238066c5de7f1c$var$Wae,
    pcurve: $d7238066c5de7f1c$var$Rre,
    perspectiveDepthToViewZ: $d7238066c5de7f1c$var$IY,
    pmremTexture: $d7238066c5de7f1c$var$yY,
    pointShadow: $d7238066c5de7f1c$var$ND,
    pointUV: $d7238066c5de7f1c$var$dae,
    pointWidth: $d7238066c5de7f1c$var$lte,
    positionGeometry: $d7238066c5de7f1c$var$OB,
    positionLocal: $d7238066c5de7f1c$var$Ns,
    positionPrevious: $d7238066c5de7f1c$var$NZ,
    positionView: $d7238066c5de7f1c$var$Ls,
    positionViewDirection: $d7238066c5de7f1c$var$kn,
    positionWorld: $d7238066c5de7f1c$var$ou,
    positionWorldDirection: $d7238066c5de7f1c$var$tY,
    posterize: $d7238066c5de7f1c$var$Vae,
    pow: $d7238066c5de7f1c$var$qg,
    pow2: $d7238066c5de7f1c$var$TL,
    pow3: $d7238066c5de7f1c$var$ZE,
    pow4: $d7238066c5de7f1c$var$ML,
    premultiplyAlpha: $d7238066c5de7f1c$var$VU,
    property: $d7238066c5de7f1c$var$pI,
    quadBroadcast: $d7238066c5de7f1c$var$Joe,
    quadSwapDiagonal: $d7238066c5de7f1c$var$Foe,
    quadSwapX: $d7238066c5de7f1c$var$Koe,
    quadSwapY: $d7238066c5de7f1c$var$xoe,
    radians: $d7238066c5de7f1c$var$uE,
    rand: $d7238066c5de7f1c$var$wE,
    range: $d7238066c5de7f1c$var$Oae,
    rangeFog: $d7238066c5de7f1c$var$_ae,
    rangeFogFactor: $d7238066c5de7f1c$var$SY,
    reciprocal: $d7238066c5de7f1c$var$AE,
    reference: $d7238066c5de7f1c$var$vn,
    referenceBuffer: $d7238066c5de7f1c$var$Y2,
    reflect: $d7238066c5de7f1c$var$GE,
    reflectVector: $d7238066c5de7f1c$var$yJ,
    reflectView: $d7238066c5de7f1c$var$AJ,
    reflector: $d7238066c5de7f1c$var$_re,
    refract: $d7238066c5de7f1c$var$EL,
    refractVector: $d7238066c5de7f1c$var$BJ,
    refractView: $d7238066c5de7f1c$var$bJ,
    reinhardToneMapping: $d7238066c5de7f1c$var$ID,
    remap: $d7238066c5de7f1c$var$$E,
    remapClamp: $d7238066c5de7f1c$var$eJ,
    renderGroup: $d7238066c5de7f1c$var$ft,
    renderOutput: $d7238066c5de7f1c$var$iJ,
    rendererReference: $d7238066c5de7f1c$var$UE,
    rotate: $d7238066c5de7f1c$var$qB,
    rotateUV: $d7238066c5de7f1c$var$Fre,
    roughness: $d7238066c5de7f1c$var$jc,
    round: $d7238066c5de7f1c$var$mE,
    rtt: $d7238066c5de7f1c$var$sD,
    sRGBTransferEOTF: $d7238066c5de7f1c$var$zE,
    sRGBTransferOETF: $d7238066c5de7f1c$var$kE,
    sample: $d7238066c5de7f1c$var$nae,
    sampler: $d7238066c5de7f1c$var$kte,
    samplerComparison: $d7238066c5de7f1c$var$Ete,
    saturate: $d7238066c5de7f1c$var$kL,
    saturation: $d7238066c5de7f1c$var$Gae,
    screen: $d7238066c5de7f1c$var$cne,
    screenCoordinate: $d7238066c5de7f1c$var$QB,
    screenDPR: $d7238066c5de7f1c$var$oJ,
    screenSize: $d7238066c5de7f1c$var$EC,
    screenUV: $d7238066c5de7f1c$var$AI,
    scriptable: $d7238066c5de7f1c$var$Dae,
    scriptableValue: $d7238066c5de7f1c$var$XS,
    select: $d7238066c5de7f1c$var$or,
    setCurrentStack: $d7238066c5de7f1c$var$uB,
    setName: $d7238066c5de7f1c$var$UL,
    shaderStages: $d7238066c5de7f1c$var$R2,
    shadow: $d7238066c5de7f1c$var$WD,
    shadowPositionWorld: $d7238066c5de7f1c$var$XY,
    shapeCircle: $d7238066c5de7f1c$var$dge,
    sharedUniformGroup: $d7238066c5de7f1c$var$bR,
    sheen: $d7238066c5de7f1c$var$WC,
    sheenRoughness: $d7238066c5de7f1c$var$mR,
    shiftLeft: $d7238066c5de7f1c$var$iE,
    shiftRight: $d7238066c5de7f1c$var$nE,
    shininess: $d7238066c5de7f1c$var$wZ,
    sign: $d7238066c5de7f1c$var$pB,
    sin: $d7238066c5de7f1c$var$Go,
    sinc: $d7238066c5de7f1c$var$Vre,
    skinning: $d7238066c5de7f1c$var$mU,
    smoothstep: $d7238066c5de7f1c$var$ic,
    smoothstepElement: $d7238066c5de7f1c$var$HE,
    specularColor: $d7238066c5de7f1c$var$_g,
    specularF90: $d7238066c5de7f1c$var$CB,
    spherizeUV: $d7238066c5de7f1c$var$Tre,
    split: $d7238066c5de7f1c$var$ote,
    spritesheetUV: $d7238066c5de7f1c$var$Ere,
    sqrt: $d7238066c5de7f1c$var$So,
    stack: $d7238066c5de7f1c$var$HS,
    step: $d7238066c5de7f1c$var$GR,
    stepElement: $d7238066c5de7f1c$var$XE,
    storage: $d7238066c5de7f1c$var$TC,
    storageBarrier: $d7238066c5de7f1c$var$roe,
    storageObject: $d7238066c5de7f1c$var$Mie,
    storageTexture: $d7238066c5de7f1c$var$oD,
    string: $d7238066c5de7f1c$var$rte,
    struct: $d7238066c5de7f1c$var$mre,
    sub: $d7238066c5de7f1c$var$wi,
    subBuild: $d7238066c5de7f1c$var$RA,
    subgroupAdd: $d7238066c5de7f1c$var$foe,
    subgroupAll: $d7238066c5de7f1c$var$Noe,
    subgroupAnd: $d7238066c5de7f1c$var$Voe,
    subgroupAny: $d7238066c5de7f1c$var$Loe,
    subgroupBallot: $d7238066c5de7f1c$var$Boe,
    subgroupBroadcast: $d7238066c5de7f1c$var$Toe,
    subgroupBroadcastFirst: $d7238066c5de7f1c$var$Yoe,
    subgroupElect: $d7238066c5de7f1c$var$yoe,
    subgroupExclusiveAdd: $d7238066c5de7f1c$var$voe,
    subgroupExclusiveMul: $d7238066c5de7f1c$var$Roe,
    subgroupInclusiveAdd: $d7238066c5de7f1c$var$Goe,
    subgroupInclusiveMul: $d7238066c5de7f1c$var$Zoe,
    subgroupIndex: $d7238066c5de7f1c$var$Hie,
    subgroupMax: $d7238066c5de7f1c$var$Xoe,
    subgroupMin: $d7238066c5de7f1c$var$Hoe,
    subgroupMul: $d7238066c5de7f1c$var$Soe,
    subgroupOr: $d7238066c5de7f1c$var$woe,
    subgroupShuffle: $d7238066c5de7f1c$var$Moe,
    subgroupShuffleDown: $d7238066c5de7f1c$var$Eoe,
    subgroupShuffleUp: $d7238066c5de7f1c$var$koe,
    subgroupShuffleXor: $d7238066c5de7f1c$var$zoe,
    subgroupSize: $d7238066c5de7f1c$var$ioe,
    subgroupXor: $d7238066c5de7f1c$var$Woe,
    tan: $d7238066c5de7f1c$var$dE,
    tangentGeometry: $d7238066c5de7f1c$var$RR,
    tangentLocal: $d7238066c5de7f1c$var$jB,
    tangentView: $d7238066c5de7f1c$var$VR,
    tangentWorld: $d7238066c5de7f1c$var$WJ,
    texture: $d7238066c5de7f1c$var$ni,
    texture3D: $d7238066c5de7f1c$var$gD,
    textureBarrier: $d7238066c5de7f1c$var$aoe,
    textureBicubic: $d7238066c5de7f1c$var$Ene,
    textureBicubicLevel: $d7238066c5de7f1c$var$bY,
    textureCubeUV: $d7238066c5de7f1c$var$JU,
    textureLevel: $d7238066c5de7f1c$var$zte,
    textureLoad: $d7238066c5de7f1c$var$ys,
    textureSize: $d7238066c5de7f1c$var$mI,
    textureStore: $d7238066c5de7f1c$var$Cae,
    thickness: $d7238066c5de7f1c$var$vL,
    time: $d7238066c5de7f1c$var$o0,
    toneMapping: $d7238066c5de7f1c$var$DE,
    toneMappingExposure: $d7238066c5de7f1c$var$_E,
    toonOutlinePass: $d7238066c5de7f1c$var$Nae,
    transformDirection: $d7238066c5de7f1c$var$RE,
    transformNormal: $d7238066c5de7f1c$var$pJ,
    transformNormalToView: $d7238066c5de7f1c$var$nY,
    transformedClearcoatNormalView: $d7238066c5de7f1c$var$die,
    transformedNormalView: $d7238066c5de7f1c$var$uie,
    transformedNormalWorld: $d7238066c5de7f1c$var$Iie,
    transmission: $d7238066c5de7f1c$var$WZ,
    transpose: $d7238066c5de7f1c$var$bE,
    triNoise3D: $d7238066c5de7f1c$var$Wre,
    triplanarTexture: $d7238066c5de7f1c$var$Jre,
    triplanarTextures: $d7238066c5de7f1c$var$nD,
    trunc: $d7238066c5de7f1c$var$xL,
    uint: $d7238066c5de7f1c$var$Ue,
    uintBitsToFloat: $d7238066c5de7f1c$var$vre,
    uniform: $d7238066c5de7f1c$var$yt,
    uniformArray: $d7238066c5de7f1c$var$La,
    uniformCubeTexture: $d7238066c5de7f1c$var$Cie,
    uniformFlow: $d7238066c5de7f1c$var$YE,
    uniformGroup: $d7238066c5de7f1c$var$T3,
    uniformTexture: $d7238066c5de7f1c$var$Mte,
    unpremultiplyAlpha: $d7238066c5de7f1c$var$one,
    userData: $d7238066c5de7f1c$var$bae,
    uv: $d7238066c5de7f1c$var$yn,
    uvec2: $d7238066c5de7f1c$var$W3,
    uvec3: $d7238066c5de7f1c$var$n0,
    uvec4: $d7238066c5de7f1c$var$L3,
    varying: $d7238066c5de7f1c$var$pu,
    varyingProperty: $d7238066c5de7f1c$var$IB,
    vec2: $d7238066c5de7f1c$var$Ne,
    vec3: $d7238066c5de7f1c$var$ne,
    vec4: $d7238066c5de7f1c$var$Rt,
    vectorComponents: $d7238066c5de7f1c$var$OC,
    velocity: $d7238066c5de7f1c$var$Bae,
    vertexColor: $d7238066c5de7f1c$var$GU,
    vertexIndex: $d7238066c5de7f1c$var$uU,
    vertexStage: $d7238066c5de7f1c$var$ME,
    vibrance: $d7238066c5de7f1c$var$vae,
    viewZToLogarithmicDepth: $d7238066c5de7f1c$var$dY,
    viewZToOrthographicDepth: $d7238066c5de7f1c$var$wA,
    viewZToPerspectiveDepth: $d7238066c5de7f1c$var$BU,
    viewport: $d7238066c5de7f1c$var$$L,
    viewportCoordinate: $d7238066c5de7f1c$var$gJ,
    viewportDepthTexture: $d7238066c5de7f1c$var$uY,
    viewportLinearDepth: $d7238066c5de7f1c$var$$ie,
    viewportMipTexture: $d7238066c5de7f1c$var$cY,
    viewportResolution: $d7238066c5de7f1c$var$Pte,
    viewportSafeUV: $d7238066c5de7f1c$var$zre,
    viewportSharedTexture: $d7238066c5de7f1c$var$mne,
    viewportSize: $d7238066c5de7f1c$var$eY,
    viewportTexture: $d7238066c5de7f1c$var$Qie,
    viewportUV: $d7238066c5de7f1c$var$_te,
    wgsl: $d7238066c5de7f1c$var$Tae,
    wgslFn: $d7238066c5de7f1c$var$kae,
    workgroupArray: $d7238066c5de7f1c$var$loe,
    workgroupBarrier: $d7238066c5de7f1c$var$soe,
    workgroupId: $d7238066c5de7f1c$var$$ae,
    workingToColorSpace: $d7238066c5de7f1c$var$EE,
    xor: $d7238066c5de7f1c$var$j3
});
const $d7238066c5de7f1c$var$Tl = /* @__PURE__ */ new $d7238066c5de7f1c$var$fY();
class $d7238066c5de7f1c$var$Qle extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new background management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   */ constructor(e, t){
        super(), this.renderer = e, this.nodes = t;
    }
    /**
   * Updates the background for the given scene. Depending on how `Scene.background`
   * or `Scene.backgroundNode` are configured, this method might configure a simple clear
   * or add a mesh to the render list for rendering the background as a textured plane
   * or skybox.
   *
   * @param {Scene} scene - The scene.
   * @param {RenderList} renderList - The current render list.
   * @param {RenderContext} renderContext - The current render context.
   */ update(e, t, i) {
        const n = this.renderer, s = this.nodes.getBackgroundNode(e) || e.background;
        let a = !1;
        if (s === null) n._clearColor.getRGB($d7238066c5de7f1c$var$Tl), $d7238066c5de7f1c$var$Tl.a = n._clearColor.a;
        else if (s.isColor === !0) s.getRGB($d7238066c5de7f1c$var$Tl), $d7238066c5de7f1c$var$Tl.a = 1, a = !0;
        else if (s.isNode === !0) {
            const g = this.get(e), l = s;
            $d7238066c5de7f1c$var$Tl.copy(n._clearColor);
            let c = g.backgroundMesh;
            if (c === void 0) {
                let G = function() {
                    s.removeEventListener("dispose", G), c.material.dispose(), c.geometry.dispose();
                };
                const p = $d7238066c5de7f1c$var$DB($d7238066c5de7f1c$var$Rt(l).mul($d7238066c5de7f1c$var$J2), {
                    // @TODO: Add Texture2D support using node context
                    getUV: ()=>$d7238066c5de7f1c$var$aD.mul($d7238066c5de7f1c$var$CJ),
                    getTextureLevel: ()=>$d7238066c5de7f1c$var$rD
                });
                let A = $d7238066c5de7f1c$var$lY;
                A = A.setZ(A.w);
                const y = new $d7238066c5de7f1c$var$Bs();
                y.name = "Background.material", y.side = $d7238066c5de7f1c$var$Ka, y.depthTest = !1, y.depthWrite = !1, y.allowOverride = !1, y.fog = !1, y.lights = !1, y.vertexNode = A, y.colorNode = p, g.backgroundMeshNode = p, g.backgroundMesh = c = new $d7238066c5de7f1c$var$SI(new $d7238066c5de7f1c$var$lL(1, 32, 32), y), c.frustumCulled = !1, c.name = "Background.mesh", c.onBeforeRender = function(Z, v, V) {
                    this.matrixWorld.copyPosition(V.matrixWorld);
                }, s.addEventListener("dispose", G);
            }
            const d = l.getCacheKey();
            g.backgroundCacheKey !== d && (g.backgroundMeshNode.node = $d7238066c5de7f1c$var$Rt(l).mul($d7238066c5de7f1c$var$J2), g.backgroundMeshNode.needsUpdate = !0, c.material.needsUpdate = !0, g.backgroundCacheKey = d), t.unshift(c, c.geometry, c.material, 0, 0, null, null);
        } else $d7238066c5de7f1c$var$nt("Renderer: Unsupported background configuration.", s);
        const o = n.xr.getEnvironmentBlendMode();
        if (o === "additive" ? $d7238066c5de7f1c$var$Tl.set(0, 0, 0, 1) : o === "alpha-blend" && $d7238066c5de7f1c$var$Tl.set(0, 0, 0, 0), n.autoClear === !0 || a === !0) {
            const g = i.clearColorValue;
            g.r = $d7238066c5de7f1c$var$Tl.r, g.g = $d7238066c5de7f1c$var$Tl.g, g.b = $d7238066c5de7f1c$var$Tl.b, g.a = $d7238066c5de7f1c$var$Tl.a, (n.backend.isWebGLBackend === !0 || n.alpha === !0) && (g.r *= g.a, g.g *= g.a, g.b *= g.a), i.depthClearValue = n._clearDepth, i.stencilClearValue = n._clearStencil, i.clearColor = n.autoClearColor === !0, i.clearDepth = n.autoClearDepth === !0, i.clearStencil = n.autoClearStencil === !0;
        } else i.clearColor = !1, i.clearDepth = !1, i.clearStencil = !1;
    }
}
let $d7238066c5de7f1c$var$Ole = 0;
class $d7238066c5de7f1c$var$U2 {
    /**
   * Constructs a new bind group.
   *
   * @param {string} name - The bind group's name.
   * @param {Array<Binding>} bindings - An array of bindings.
   * @param {number} index - The group index.
   * @param {Array<Binding>} bindingsReference - An array of reference bindings.
   */ constructor(e = "", t = [], i = 0, n = []){
        this.name = e, this.bindings = t, this.index = i, this.bindingsReference = n, this.id = $d7238066c5de7f1c$var$Ole++;
    }
}
class $d7238066c5de7f1c$var$jle {
    /**
   * Constructs a new node builder state.
   *
   * @param {string} vertexShader - The native vertex shader code.
   * @param {string} fragmentShader - The native fragment shader code.
   * @param {string} computeShader - The native compute shader code.
   * @param {Array<NodeAttribute>} nodeAttributes - An array of node attributes.
   * @param {Array<BindGroup>} bindings - An array of bind groups.
   * @param {Array<Node>} updateNodes - An array of nodes that implement their `update()` method.
   * @param {Array<Node>} updateBeforeNodes - An array of nodes that implement their `updateBefore()` method.
   * @param {Array<Node>} updateAfterNodes - An array of nodes that implement their `updateAfter()` method.
   * @param {NodeMaterialObserver} observer - A node material observer.
   * @param {Array<Object>} transforms - An array with transform attribute objects. Only relevant when using compute shaders with WebGL 2.
   */ constructor(e, t, i, n, s, a, o, g, l, c = []){
        this.vertexShader = e, this.fragmentShader = t, this.computeShader = i, this.transforms = c, this.nodeAttributes = n, this.bindings = s, this.updateNodes = a, this.updateBeforeNodes = o, this.updateAfterNodes = g, this.observer = l, this.usedTimes = 0;
    }
    /**
   * This method is used to create a array of bind groups based
   * on the existing bind groups of this state. Shared groups are
   * not cloned.
   *
   * @return {Array<BindGroup>} A array of bind groups.
   */ createBindings() {
        const e = [];
        for (const t of this.bindings)if (t.bindings[0].groupNode.shared !== !0) {
            const n = new $d7238066c5de7f1c$var$U2(t.name, [], t.index, t.bindingsReference);
            e.push(n);
            for (const s of t.bindings)n.bindings.push(s.clone());
        } else e.push(t);
        return e;
    }
}
class $d7238066c5de7f1c$var$w9 {
    /**
   * Constructs a new node attribute.
   *
   * @param {string} name - The name of the attribute.
   * @param {string} type - The type of the attribute.
   * @param {?Node} node - An optional reference to the node.
   */ constructor(e, t, i = null){
        this.isNodeAttribute = !0, this.name = e, this.type = t, this.node = i;
    }
}
class $d7238066c5de7f1c$var$qle {
    /**
   * Constructs a new node uniform.
   *
   * @param {string} name - The name of the uniform.
   * @param {string} type - The type of the uniform.
   * @param {UniformNode} node - An reference to the node.
   */ constructor(e, t, i){
        this.isNodeUniform = !0, this.name = e, this.type = t, this.node = i;
    }
    /**
   * The value of the uniform node.
   *
   * @type {any}
   */ get value() {
        return this.node.value;
    }
    set value(e) {
        this.node.value = e;
    }
    /**
   * The id of the uniform node.
   *
   * @type {number}
   */ get id() {
        return this.node.id;
    }
    /**
   * The uniform node's group.
   *
   * @type {UniformGroupNode}
   */ get groupNode() {
        return this.node.groupNode;
    }
}
class $d7238066c5de7f1c$var$JD {
    /**
   * Constructs a new node variable.
   *
   * @param {string} name - The name of the variable.
   * @param {string} type - The type of the variable.
   * @param {boolean} [readOnly=false] - The read-only flag.
   * @param {?number} [count=null] - The size.
   */ constructor(e, t, i = !1, n = null){
        this.isNodeVar = !0, this.name = e, this.type = t, this.readOnly = i, this.count = n;
    }
}
class $d7238066c5de7f1c$var$$le extends $d7238066c5de7f1c$var$JD {
    /**
   * Constructs a new node varying.
   *
   * @param {string} name - The name of the varying.
   * @param {string} type - The type of the varying.
   * @param {?string} interpolationType - The interpolation type of the varying.
   * @param {?string} interpolationSampling - The interpolation sampling type of the varying.
   */ constructor(e, t, i = null, n = null){
        super(e, t), this.needsInterpolation = !1, this.isNodeVarying = !0, this.interpolationType = i, this.interpolationSampling = n;
    }
}
class $d7238066c5de7f1c$var$ece {
    /**
   * Constructs a new code node.
   *
   * @param {string} name - The name of the code.
   * @param {string} type - The node type.
   * @param {string} [code=''] - The native shader code.
   */ constructor(e, t, i = ""){
        this.name = e, this.type = t, this.code = i, Object.defineProperty(this, "isNodeCode", {
            value: !0
        });
    }
}
let $d7238066c5de7f1c$var$tce = 0;
class $d7238066c5de7f1c$var$wH {
    /**
   * Constructs a new node cache.
   *
   * @param {?NodeCache} parent - A reference to a parent cache.
   */ constructor(e = null){
        this.id = $d7238066c5de7f1c$var$tce++, this.nodesData = /* @__PURE__ */ new WeakMap(), this.parent = e;
    }
    /**
   * Returns the data for the given node.
   *
   * @param {Node} node - The node.
   * @return {?Object} The data for the node.
   */ getData(e) {
        let t = this.nodesData.get(e);
        return t === void 0 && this.parent !== null && (t = this.parent.getData(e)), t;
    }
    /**
   * Sets the data for a given node.
   *
   * @param {Node} node - The node.
   * @param {Object} data - The data that should be cached.
   */ setData(e, t) {
        this.nodesData.set(e, t);
    }
}
class $d7238066c5de7f1c$var$ice {
    constructor(e, t){
        this.name = e, this.members = t, this.output = !1;
    }
}
class $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {any} value - The uniform's value.
   */ constructor(e, t){
        this.name = e, this.value = t, this.boundary = 0, this.itemSize = 0, this.offset = 0;
    }
    /**
   * Sets the uniform's value.
   *
   * @param {any} value - The value to set.
   */ setValue(e) {
        this.value = e;
    }
    /**
   * Returns the uniform's value.
   *
   * @return {any} The value.
   */ getValue() {
        return this.value;
    }
}
class $d7238066c5de7f1c$var$nce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {number} value - The uniform's value.
   */ constructor(e, t = 0){
        super(e, t), this.isNumberUniform = !0, this.boundary = 4, this.itemSize = 1;
    }
}
class $d7238066c5de7f1c$var$sce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Vector2} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$Ii()){
        super(e, t), this.isVector2Uniform = !0, this.boundary = 8, this.itemSize = 2;
    }
}
class $d7238066c5de7f1c$var$rce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Vector3} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$Ce()){
        super(e, t), this.isVector3Uniform = !0, this.boundary = 16, this.itemSize = 3;
    }
}
class $d7238066c5de7f1c$var$ace extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Vector4} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$Gi()){
        super(e, t), this.isVector4Uniform = !0, this.boundary = 16, this.itemSize = 4;
    }
}
class $d7238066c5de7f1c$var$oce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Color} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$rn()){
        super(e, t), this.isColorUniform = !0, this.boundary = 16, this.itemSize = 3;
    }
}
class $d7238066c5de7f1c$var$gce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Matrix2} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$uR()){
        super(e, t), this.isMatrix2Uniform = !0, this.boundary = 8, this.itemSize = 4;
    }
}
class $d7238066c5de7f1c$var$lce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Matrix3} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$Lo()){
        super(e, t), this.isMatrix3Uniform = !0, this.boundary = 48, this.itemSize = 12;
    }
}
class $d7238066c5de7f1c$var$cce extends $d7238066c5de7f1c$var$hh {
    /**
   * Constructs a new Number uniform.
   *
   * @param {string} name - The uniform's name.
   * @param {Matrix4} value - The uniform's value.
   */ constructor(e, t = new $d7238066c5de7f1c$var$Ji()){
        super(e, t), this.isMatrix4Uniform = !0, this.boundary = 64, this.itemSize = 16;
    }
}
class $d7238066c5de7f1c$var$uce extends $d7238066c5de7f1c$var$nce {
    /**
   * Constructs a new node-based Number uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {number} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$Ice extends $d7238066c5de7f1c$var$sce {
    /**
   * Constructs a new node-based Vector2 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Vector2} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$dce extends $d7238066c5de7f1c$var$rce {
    /**
   * Constructs a new node-based Vector3 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Vector3} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$hce extends $d7238066c5de7f1c$var$ace {
    /**
   * Constructs a new node-based Vector4 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Vector4} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$Cce extends $d7238066c5de7f1c$var$oce {
    /**
   * Constructs a new node-based Color uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Color} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$pce extends $d7238066c5de7f1c$var$gce {
    /**
   * Constructs a new node-based Matrix2 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Matrix2} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$mce extends $d7238066c5de7f1c$var$lce {
    /**
   * Constructs a new node-based Matrix3 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Matrix3} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
class $d7238066c5de7f1c$var$Ace extends $d7238066c5de7f1c$var$cce {
    /**
   * Constructs a new node-based Matrix4 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */ constructor(e){
        super(e.name, e.value), this.nodeUniform = e;
    }
    /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Matrix4} The value.
   */ getValue() {
        return this.nodeUniform.value;
    }
    /**
   * Returns the node uniform data type.
   *
   * @return {string} The data type.
   */ getType() {
        return this.nodeUniform.type;
    }
}
let $d7238066c5de7f1c$var$bce = 0;
const $d7238066c5de7f1c$var$W9 = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$yce = /* @__PURE__ */ new Map([
    [
        Int8Array,
        "int"
    ],
    [
        Int16Array,
        "int"
    ],
    [
        Int32Array,
        "int"
    ],
    [
        Uint8Array,
        "uint"
    ],
    [
        Uint16Array,
        "uint"
    ],
    [
        Uint32Array,
        "uint"
    ],
    [
        Float32Array,
        "float"
    ]
]), $d7238066c5de7f1c$var$Uv = (r)=>/e/g.test(r) ? String(r).replace(/\+/g, "") : (r = Number(r), r + (r % 1 ? "" : ".0"));
class $d7238066c5de7f1c$var$UD {
    /**
   * Constructs a new node builder.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Renderer} renderer - The current renderer.
   * @param {NodeParser} parser - A reference to a node parser.
   */ constructor(e, t, i){
        this.object = e, this.material = e && e.material || null, this.geometry = e && e.geometry || null, this.renderer = t, this.parser = i, this.scene = null, this.camera = null, this.nodes = [], this.sequentialNodes = [], this.updateNodes = [], this.updateBeforeNodes = [], this.updateAfterNodes = [], this.hashNodes = {}, this.observer = null, this.lightsNode = null, this.environmentNode = null, this.fogNode = null, this.clippingContext = null, this.vertexShader = null, this.fragmentShader = null, this.computeShader = null, this.flowNodes = {
            vertex: [],
            fragment: [],
            compute: []
        }, this.flowCode = {
            vertex: "",
            fragment: "",
            compute: ""
        }, this.uniforms = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        }, this.structs = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        }, this.types = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        }, this.bindings = {
            vertex: {},
            fragment: {},
            compute: {}
        }, this.bindingsIndexes = {}, this.bindGroups = null, this.attributes = [], this.bufferAttributes = [], this.varyings = [], this.codes = {}, this.vars = {}, this.declarations = {}, this.flow = {
            code: ""
        }, this.chaining = [], this.stack = $d7238066c5de7f1c$var$HS(), this.stacks = [], this.tab = "	", this.currentFunctionNode = null, this.context = {
            material: this.material
        }, this.cache = new $d7238066c5de7f1c$var$wH(), this.globalCache = this.cache, this.flowsData = /* @__PURE__ */ new WeakMap(), this.shaderStage = null, this.buildStage = null, this.subBuildLayers = [], this.activeStacks = [], this.subBuildFn = null, this.fnCall = null, Object.defineProperty(this, "id", {
            value: $d7238066c5de7f1c$var$bce++
        });
    }
    /**
   * Whether the material is opaque or not.
   *
   * @return {boolean} Whether the material is opaque or not.
   */ isOpaque() {
        const e = this.material;
        return e.transparent === !1 && e.blending === $d7238066c5de7f1c$var$uI && e.alphaToCoverage === !1;
    }
    /**
   * Returns the bind groups of the current renderer.
   *
   * @return {ChainMap} The cache.
   */ getBindGroupsCache() {
        let e = $d7238066c5de7f1c$var$W9.get(this.renderer);
        return e === void 0 && (e = new $d7238066c5de7f1c$var$nc(), $d7238066c5de7f1c$var$W9.set(this.renderer, e)), e;
    }
    /**
   * Factory method for creating an instance of {@link RenderTarget} with the given
   * dimensions and options.
   *
   * @param {number} width - The width of the render target.
   * @param {number} height - The height of the render target.
   * @param {Object} options - The options of the render target.
   * @return {RenderTarget} The render target.
   */ createRenderTarget(e, t, i) {
        return new $d7238066c5de7f1c$var$WI(e, t, i);
    }
    /**
   * Factory method for creating an instance of {@link CubeRenderTarget} with the given
   * dimensions and options.
   *
   * @param {number} size - The size of the cube render target.
   * @param {Object} options - The options of the cube render target.
   * @return {CubeRenderTarget} The cube render target.
   */ createCubeRenderTarget(e, t) {
        return new $d7238066c5de7f1c$var$WU(e, t);
    }
    /**
   * Whether the given node is included in the internal array of nodes or not.
   *
   * @param {Node} node - The node to test.
   * @return {boolean} Whether the given node is included in the internal array of nodes or not.
   */ includes(e) {
        return this.nodes.includes(e);
    }
    /**
   * Returns the output struct name which is required by
   * {@link OutputStructNode}.
   *
   * @abstract
   * @return {string} The name of the output struct.
   */ getOutputStructName() {}
    /**
   * Returns a bind group for the given group name and binding.
   *
   * @private
   * @param {string} groupName - The group name.
   * @param {Array<NodeUniformsGroup>} bindings - List of bindings.
   * @return {BindGroup} The bind group
   */ _getBindGroup(e, t) {
        const i = this.getBindGroupsCache(), n = [];
        let s = !0;
        for (const o of t)n.push(o), s = s && o.groupNode.shared !== !0;
        let a;
        return s ? (a = i.get(n), a === void 0 && (a = new $d7238066c5de7f1c$var$U2(e, n, this.bindingsIndexes[e].group, n), i.set(n, a))) : a = new $d7238066c5de7f1c$var$U2(e, n, this.bindingsIndexes[e].group, n), a;
    }
    /**
   * Returns an array of node uniform groups for the given group name and shader stage.
   *
   * @param {string} groupName - The group name.
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {Array<NodeUniformsGroup>} The array of node uniform groups.
   */ getBindGroupArray(e, t) {
        const i = this.bindings[t];
        let n = i[e];
        return n === void 0 && (this.bindingsIndexes[e] === void 0 && (this.bindingsIndexes[e] = {
            binding: 0,
            group: Object.keys(this.bindingsIndexes).length
        }), i[e] = n = []), n;
    }
    /**
   * Returns a list bindings of all shader stages separated by groups.
   *
   * @return {Array<BindGroup>} The list of bindings.
   */ getBindings() {
        let e = this.bindGroups;
        if (e === null) {
            const t = {}, i = this.bindings;
            for (const n of $d7238066c5de7f1c$var$R2)for(const s in i[n]){
                const a = i[n][s];
                (t[s] || (t[s] = [])).push(...a);
            }
            e = [];
            for(const n in t){
                const s = t[n], a = this._getBindGroup(n, s);
                e.push(a);
            }
            this.bindGroups = e;
        }
        return e;
    }
    /**
   * Sorts the bind groups and updates {@link NodeBuilder#bindingsIndexes}.
   */ sortBindingGroups() {
        const e = this.getBindings();
        e.sort((t, i)=>t.bindings[0].groupNode.order - i.bindings[0].groupNode.order);
        for(let t = 0; t < e.length; t++){
            const i = e[t];
            this.bindingsIndexes[i.name].group = t, i.index = t;
        }
    }
    /**
   * The builder maintains each node in a hash-based dictionary.
   * This method sets the given node (value) with the given hash (key) into this dictionary.
   *
   * @param {Node} node - The node to add.
   * @param {number} hash - The hash of the node.
   */ setHashNode(e, t) {
        this.hashNodes[t] = e;
    }
    /**
   * Adds a node to this builder.
   *
   * @param {Node} node - The node to add.
   */ addNode(e) {
        this.nodes.includes(e) === !1 && (this.nodes.push(e), this.setHashNode(e, e.getHash(this)));
    }
    /**
   * It is used to add Nodes that will be used as FRAME and RENDER events,
   * and need to follow a certain sequence in the calls to work correctly.
   * This function should be called after 'setup()' in the 'build()' process to ensure that the child nodes are processed first.
   *
   * @param {Node} node - The node to add.
   */ addSequentialNode(e) {
        this.sequentialNodes.includes(e) === !1 && this.sequentialNodes.push(e);
    }
    /**
   * Checks the update types of nodes
   */ buildUpdateNodes() {
        for (const e of this.nodes)e.getUpdateType() !== $d7238066c5de7f1c$var$Dt.NONE && this.updateNodes.push(e);
        for (const e of this.sequentialNodes){
            const t = e.getUpdateBeforeType(), i = e.getUpdateAfterType();
            t !== $d7238066c5de7f1c$var$Dt.NONE && this.updateBeforeNodes.push(e), i !== $d7238066c5de7f1c$var$Dt.NONE && this.updateAfterNodes.push(e);
        }
    }
    /**
   * A reference the current node which is the
   * last node in the chain of nodes.
   *
   * @type {Node}
   */ get currentNode() {
        return this.chaining[this.chaining.length - 1];
    }
    /**
   * Whether the given texture is filtered or not.
   *
   * @param {Texture} texture - The texture to check.
   * @return {boolean} Whether the given texture is filtered or not.
   */ isFilteredTexture(e) {
        return e.magFilter === $d7238066c5de7f1c$var$ro || e.magFilter === $d7238066c5de7f1c$var$b2 || e.magFilter === $d7238066c5de7f1c$var$lB || e.magFilter === $d7238066c5de7f1c$var$II || e.minFilter === $d7238066c5de7f1c$var$ro || e.minFilter === $d7238066c5de7f1c$var$b2 || e.minFilter === $d7238066c5de7f1c$var$lB || e.minFilter === $d7238066c5de7f1c$var$II;
    }
    /**
   * Adds the given node to the internal node chain.
   * This is used to check recursive calls in node-graph.
   *
   * @param {Node} node - The node to add.
   */ addChain(e) {
        this.chaining.push(e);
    }
    /**
   * Removes the given node from the internal node chain.
   *
   * @param {Node} node - The node to remove.
   */ removeChain(e) {
        if (this.chaining.pop() !== e) throw new Error("NodeBuilder: Invalid node chaining!");
    }
    /**
   * Returns the native shader method name for a given generic name. E.g.
   * the method name `textureDimensions` matches the WGSL name but must be
   * resolved to `textureSize` in GLSL.
   *
   * @abstract
   * @param {string} method - The method name to resolve.
   * @return {string} The resolved method name.
   */ getMethod(e) {
        return e;
    }
    /**
   * Returns the native snippet for a ternary operation. E.g. GLSL would output
   * a ternary op as `cond ? x : y` whereas WGSL would output it as `select(y, x, cond)`
   *
   * @abstract
   * @param {string} condSnippet - The condition determining which expression gets resolved.
   * @param {string} ifSnippet - The expression to resolve to if the condition is true.
   * @param {string} elseSnippet - The expression to resolve to if the condition is false.
   * @return {string} The resolved method name.
   */ getTernary() {
        return null;
    }
    /**
   * Returns a node for the given hash, see {@link NodeBuilder#setHashNode}.
   *
   * @param {number} hash - The hash of the node.
   * @return {Node} The found node.
   */ getNodeFromHash(e) {
        return this.hashNodes[e];
    }
    /**
   * Adds the Node to a target flow so that it can generate code in the 'generate' process.
   *
   * @param {('vertex'|'fragment'|'compute')} shaderStage - The shader stage.
   * @param {Node} node - The node to add.
   * @return {Node} The node.
   */ addFlow(e, t) {
        return this.flowNodes[e].push(t), t;
    }
    /**
   * Sets builder's context.
   *
   * @param {Object} context - The context to set.
   */ setContext(e) {
        this.context = e;
    }
    /**
   * Returns the builder's current context.
   *
   * @return {Object} The builder's current context.
   */ getContext() {
        return this.context;
    }
    /**
   * Adds context data to the builder's current context.
   *
   * @param {Object} context - The context to add.
   * @return {Object} The previous context.
   */ addContext(e) {
        const t = this.getContext();
        return this.setContext({
            ...this.context,
            ...e
        }), t;
    }
    /**
   * Gets a context used in shader construction that can be shared across different materials.
   * This is necessary since the renderer cache can reuse shaders generated in one material and use them in another.
   *
   * @return {Object} The builder's current context without material.
   */ getSharedContext() {
        return {
            ...this.context
        }, this.context;
    }
    /**
   * Sets builder's cache.
   *
   * @param {NodeCache} cache - The cache to set.
   */ setCache(e) {
        this.cache = e;
    }
    /**
   * Returns the builder's current cache.
   *
   * @return {NodeCache} The builder's current cache.
   */ getCache() {
        return this.cache;
    }
    /**
   * Returns a cache for the given node.
   *
   * @param {Node} node - The node.
   * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
   * @return {NodeCache} The cache.
   */ getCacheFromNode(e, t = !0) {
        const i = this.getDataFromNode(e);
        return i.cache === void 0 && (i.cache = new $d7238066c5de7f1c$var$wH(t ? this.getCache() : null)), i.cache;
    }
    /**
   * Whether the requested feature is available or not.
   *
   * @abstract
   * @param {string} name - The requested feature.
   * @return {boolean} Whether the requested feature is supported or not.
   */ isAvailable() {
        return !1;
    }
    /**
   * Returns the vertexIndex input variable as a native shader string.
   *
   * @abstract
   * @return {string} The instanceIndex shader string.
   */ getVertexIndex() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Contextually returns either the vertex stage instance index builtin
   * or the linearized index of an compute invocation within a grid of workgroups.
   *
   * @abstract
   * @return {string} The instanceIndex shader string.
   */ getInstanceIndex() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns the drawIndex input variable as a native shader string.
   * Only relevant for WebGL and its `WEBGL_multi_draw` extension.
   *
   * @abstract
   * @return {?string} The drawIndex shader string.
   */ getDrawIndex() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns the frontFacing input variable as a native shader string.
   *
   * @abstract
   * @return {string} The frontFacing shader string.
   */ getFrontFacing() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns the fragCoord input variable as a native shader string.
   *
   * @abstract
   * @return {string} The fragCoord shader string.
   */ getFragCoord() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Whether to flip texture data along its vertical axis or not. WebGL needs
   * this method evaluate to `true`, WebGPU to `false`.
   *
   * @abstract
   * @return {boolean} Whether to flip texture data along its vertical axis or not.
   */ isFlipY() {
        return !1;
    }
    /**
   * Calling this method increases the usage count for the given node by one.
   *
   * @param {Node} node - The node to increase the usage count for.
   * @return {number} The updated usage count.
   */ increaseUsage(e) {
        const t = this.getDataFromNode(e);
        return t.usageCount = t.usageCount === void 0 ? 1 : t.usageCount + 1, t.usageCount;
    }
    /**
   * Generates a texture sample shader string for the given texture data.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The texture property name.
   * @param {string} uvSnippet - Snippet defining the texture coordinates.
   * @return {string} The generated shader string.
   */ generateTexture() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Generates a texture LOD shader string for the given texture data.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The texture property name.
   * @param {string} uvSnippet - Snippet defining the texture coordinates.
   * @param {?string} depthSnippet - Snippet defining the 0-based texture array index to sample.
   * @param {string} levelSnippet - Snippet defining the mip level.
   * @return {string} The generated shader string.
   */ generateTextureLod() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Generates the array declaration string.
   *
   * @param {string} type - The type.
   * @param {?number} [count] - The count.
   * @return {string} The generated value as a shader string.
   */ generateArrayDeclaration(e, t) {
        return this.getType(e) + "[ " + t + " ]";
    }
    /**
   * Generates the array shader string for the given type and value.
   *
   * @param {string} type - The type.
   * @param {?number} [count] - The count.
   * @param {?Array<Node>} [values=null] - The default values.
   * @return {string} The generated value as a shader string.
   */ generateArray(e, t, i = null) {
        let n = this.generateArrayDeclaration(e, t) + "( ";
        for(let s = 0; s < t; s++){
            const a = i ? i[s] : null;
            a !== null ? n += a.build(this, e) : n += this.generateConst(e), s < t - 1 && (n += ", ");
        }
        return n += " )", n;
    }
    /**
   * Generates the struct shader string.
   *
   * @param {string} type - The type.
   * @param {Array<Object>} [membersLayout] - The count.
   * @param {?Array<Node>} [values=null] - The default values.
   * @return {string} The generated value as a shader string.
   */ generateStruct(e, t, i = null) {
        const n = [];
        for (const s of t){
            const { name: a, type: o } = s;
            i && i[a] && i[a].isNode ? n.push(i[a].build(this, o)) : n.push(this.generateConst(o));
        }
        return e + "( " + n.join(", ") + " )";
    }
    /**
   * Generates the shader string for the given type and value.
   *
   * @param {string} type - The type.
   * @param {?any} [value=null] - The value.
   * @return {string} The generated value as a shader string.
   */ generateConst(e, t = null) {
        if (t === null && (e === "float" || e === "int" || e === "uint" ? t = 0 : e === "bool" ? t = !1 : e === "color" ? t = new $d7238066c5de7f1c$var$rn() : e === "vec2" ? t = new $d7238066c5de7f1c$var$Ii() : e === "vec3" ? t = new $d7238066c5de7f1c$var$Ce() : e === "vec4" && (t = new $d7238066c5de7f1c$var$Gi())), e === "float") return $d7238066c5de7f1c$var$Uv(t);
        if (e === "int") return `${Math.round(t)}`;
        if (e === "uint") return t >= 0 ? `${Math.round(t)}u` : "0u";
        if (e === "bool") return t ? "true" : "false";
        if (e === "color") return `${this.getType("vec3")}( ${$d7238066c5de7f1c$var$Uv(t.r)}, ${$d7238066c5de7f1c$var$Uv(t.g)}, ${$d7238066c5de7f1c$var$Uv(t.b)} )`;
        const i = this.getTypeLength(e), n = this.getComponentType(e), s = (a)=>this.generateConst(n, a);
        if (i === 2) return `${this.getType(e)}( ${s(t.x)}, ${s(t.y)} )`;
        if (i === 3) return `${this.getType(e)}( ${s(t.x)}, ${s(t.y)}, ${s(t.z)} )`;
        if (i === 4 && e !== "mat2") return `${this.getType(e)}( ${s(t.x)}, ${s(t.y)}, ${s(t.z)}, ${s(t.w)} )`;
        if (i >= 4 && t && (t.isMatrix2 || t.isMatrix3 || t.isMatrix4)) return `${this.getType(e)}( ${t.elements.map(s).join(", ")} )`;
        if (i > 4) return `${this.getType(e)}()`;
        throw new Error(`NodeBuilder: Type '${e}' not found in generate constant attempt.`);
    }
    /**
   * It might be necessary to convert certain data types to different ones
   * so this method can be used to hide the conversion.
   *
   * @param {string} type - The type.
   * @return {string} The updated type.
   */ getType(e) {
        return e === "color" ? "vec3" : e;
    }
    /**
   * Whether the given attribute name is defined in the geometry or not.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether the given attribute name is defined in the geometry.
   */ hasGeometryAttribute(e) {
        return this.geometry && this.geometry.getAttribute(e) !== void 0;
    }
    /**
   * Returns a node attribute for the given name and type.
   *
   * @param {string} name - The attribute's name.
   * @param {string} type - The attribute's type.
   * @return {NodeAttribute} The node attribute.
   */ getAttribute(e, t) {
        const i = this.attributes;
        for (const s of i)if (s.name === e) return s;
        const n = new $d7238066c5de7f1c$var$w9(e, t);
        return this.registerDeclaration(n), i.push(n), n;
    }
    /**
   * Returns for the given node and shader stage the property name for the shader.
   *
   * @param {Node} node - The node.
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {string} The property name.
   */ getPropertyName(e) {
        return e.name;
    }
    /**
   * Whether the given type is a vector type or not.
   *
   * @param {string} type - The type to check.
   * @return {boolean} Whether the given type is a vector type or not.
   */ isVector(e) {
        return /vec\d/.test(e);
    }
    /**
   * Whether the given type is a matrix type or not.
   *
   * @param {string} type - The type to check.
   * @return {boolean} Whether the given type is a matrix type or not.
   */ isMatrix(e) {
        return /mat\d/.test(e);
    }
    /**
   * Whether the given type is a reference type or not.
   *
   * @param {string} type - The type to check.
   * @return {boolean} Whether the given type is a reference type or not.
   */ isReference(e) {
        return e === "void" || e === "property" || e === "sampler" || e === "samplerComparison" || e === "texture" || e === "cubeTexture" || e === "storageTexture" || e === "depthTexture" || e === "texture3D";
    }
    /**
   * Checks if the given texture requires a manual conversion to the working color space.
   *
   * @abstract
   * @param {Texture} texture - The texture to check.
   * @return {boolean} Whether the given texture requires a conversion to working color space or not.
   */ needsToWorkingColorSpace() {
        return !1;
    }
    /**
   * Returns the component type of a given texture.
   *
   * @param {Texture} texture - The texture.
   * @return {string} The component type.
   */ getComponentTypeFromTexture(e) {
        const t = e.type;
        if (e.isDataTexture) {
            if (t === $d7238066c5de7f1c$var$Na) return "int";
            if (t === $d7238066c5de7f1c$var$Xs) return "uint";
        }
        return "float";
    }
    /**
   * Returns the element type for a given type.
   *
   * @param {string} type - The type.
   * @return {string} The element type.
   */ getElementType(e) {
        return e === "mat2" ? "vec2" : e === "mat3" ? "vec3" : e === "mat4" ? "vec4" : this.getComponentType(e);
    }
    /**
   * Returns the component type for a given type.
   *
   * @param {string} type - The type.
   * @return {string} The component type.
   */ getComponentType(e) {
        if (e = this.getVectorType(e), e === "float" || e === "bool" || e === "int" || e === "uint") return e;
        const t = /(b|i|u|)(vec|mat)([2-4])/.exec(e);
        return t === null ? null : t[1] === "b" ? "bool" : t[1] === "i" ? "int" : t[1] === "u" ? "uint" : "float";
    }
    /**
   * Returns the vector type for a given type.
   *
   * @param {string} type - The type.
   * @return {string} The vector type.
   */ getVectorType(e) {
        return e === "color" ? "vec3" : e === "texture" || e === "cubeTexture" || e === "storageTexture" || e === "texture3D" ? "vec4" : e;
    }
    /**
   * Returns the data type for the given the length and component type.
   *
   * @param {number} length - The length.
   * @param {string} [componentType='float'] - The component type.
   * @return {string} The type.
   */ getTypeFromLength(e, t = "float") {
        if (e === 1) return t;
        let i = $d7238066c5de7f1c$var$A3(e);
        const n = t === "float" ? "" : t[0];
        return /mat2/.test(t) === !0 && (i = i.replace("vec", "mat")), n + i;
    }
    /**
   * Returns the type for a given typed array.
   *
   * @param {TypedArray} array - The typed array.
   * @return {string} The type.
   */ getTypeFromArray(e) {
        return $d7238066c5de7f1c$var$yce.get(e.constructor);
    }
    /**
   * Returns the type is an integer type.
   *
   * @param {string} type - The type.
   * @return {boolean} Whether the type is an integer type or not.
   */ isInteger(e) {
        return /int|uint|(i|u)vec/.test(e);
    }
    /**
   * Returns the type for a given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   * @return {string} The type.
   */ getTypeFromAttribute(e) {
        let t = e;
        e.isInterleavedBufferAttribute && (t = e.data);
        const i = t.array, n = e.itemSize, s = e.normalized;
        let a;
        return !(e instanceof $d7238066c5de7f1c$var$u3) && s !== !0 && (a = this.getTypeFromArray(i)), this.getTypeFromLength(n, a);
    }
    /**
   * Returns the length for the given data type.
   *
   * @param {string} type - The data type.
   * @return {number} The length.
   */ getTypeLength(e) {
        const t = this.getVectorType(e), i = /vec([2-4])/.exec(t);
        return i !== null ? Number(i[1]) : t === "float" || t === "bool" || t === "int" || t === "uint" ? 1 : /mat2/.test(e) === !0 ? 4 : /mat3/.test(e) === !0 ? 9 : /mat4/.test(e) === !0 ? 16 : 0;
    }
    /**
   * Returns the vector type for a given matrix type.
   *
   * @param {string} type - The matrix type.
   * @return {string} The vector type.
   */ getVectorFromMatrix(e) {
        return e.replace("mat", "vec");
    }
    /**
   * For a given type this method changes the component type to the
   * given value. E.g. `vec4` should be changed to the new component type
   * `uint` which results in `uvec4`.
   *
   * @param {string} type - The type.
   * @param {string} newComponentType - The new component type.
   * @return {string} The new type.
   */ changeComponentType(e, t) {
        return this.getTypeFromLength(this.getTypeLength(e), t);
    }
    /**
   * Returns the integer type pendant for the given type.
   *
   * @param {string} type - The type.
   * @return {string} The integer type.
   */ getIntegerType(e) {
        const t = this.getComponentType(e);
        return t === "int" || t === "uint" ? e : this.changeComponentType(e, "int");
    }
    /**
   * Adds an active stack to the internal stack.
   *
   * @param {StackNode} stack - The stack node to add.
   */ setActiveStack(e) {
        this.activeStacks.push(e);
    }
    /**
   * Removes the active stack from the internal stack.
   *
   * @param {StackNode} stack - The stack node to remove.
   */ removeActiveStack(e) {
        if (this.activeStacks[this.activeStacks.length - 1] === e) this.activeStacks.pop();
        else throw new Error("NodeBuilder: Invalid active stack removal.");
    }
    /**
   * Returns the active stack.
   *
   * @return {StackNode} The active stack.
   */ getActiveStack() {
        return this.activeStacks[this.activeStacks.length - 1];
    }
    /**
   * Returns the base stack.
   *
   * @return {StackNode} The base stack.
   */ getBaseStack() {
        return this.activeStacks[0];
    }
    /**
   * Adds a stack node to the internal stack.
   *
   * @return {StackNode} The added stack node.
   */ addStack() {
        this.stack = $d7238066c5de7f1c$var$HS(this.stack);
        const e = $d7238066c5de7f1c$var$yL();
        return this.stacks.push(e), $d7238066c5de7f1c$var$uB(this.stack), this.stack;
    }
    /**
   * Removes the last stack node from the internal stack.
   *
   * @return {StackNode} The removed stack node.
   */ removeStack() {
        const e = this.stack;
        for (const t of e.nodes){
            const i = this.getDataFromNode(t);
            i.stack = e;
        }
        return this.stack = e.parent, $d7238066c5de7f1c$var$uB(this.stacks.pop()), e;
    }
    /**
   * The builder maintains (cached) data for each node during the building process. This method
   * can be used to get these data for a specific shader stage and cache.
   *
   * @param {Node} node - The node to get the data for.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @param {?NodeCache} cache - An optional cache.
   * @return {Object} The node data.
   */ getDataFromNode(e, t = this.shaderStage, i = null) {
        i = i === null ? e.isGlobal(this) ? this.globalCache : this.cache : i;
        let n = i.getData(e);
        n === void 0 && (n = {}, i.setData(e, n)), n[t] === void 0 && (n[t] = {});
        let s = n[t];
        const a = n.any ? n.any.subBuilds : null, o = this.getClosestSubBuild(a);
        return o && (s.subBuildsCache === void 0 && (s.subBuildsCache = {}), s = s.subBuildsCache[o] || (s.subBuildsCache[o] = {}), s.subBuilds = a), s;
    }
    /**
   * Returns the properties for the given node and shader stage.
   *
   * Properties are typically used within a build stage to reference a node's
   * child node or nodes manually assigned to the properties in a separate build stage.
   * A typical usage pattern for defining nodes manually would be assigning dependency nodes
   * to the current node's properties in the setup stage and building those properties in the generate stage.
   *
   * @param {Node} node - The node to get the properties for.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage='any'] - The shader stage.
   * @return {Object} The node properties.
   */ getNodeProperties(e, t = "any") {
        const i = this.getDataFromNode(e, t);
        return i.properties || (i.properties = {
            outputNode: null
        });
    }
    /**
   * Returns an instance of {@link NodeAttribute} for the given buffer attribute node.
   *
   * @param {BufferAttributeNode} node - The buffer attribute node.
   * @param {string} type - The node type.
   * @return {NodeAttribute} The node attribute.
   */ getBufferAttributeFromNode(e, t) {
        const i = this.getDataFromNode(e);
        let n = i.bufferAttribute;
        if (n === void 0) {
            const s = this.uniforms.index++;
            n = new $d7238066c5de7f1c$var$w9("nodeAttribute" + s, t, e), this.bufferAttributes.push(n), i.bufferAttribute = n;
        }
        return n;
    }
    /**
   * Returns an instance of {@link StructType} for the given struct name and shader stage
   * or null if not found.
   *
   * @param {string} name - The name of the struct.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @return {?StructType} The struct type or null if not found.
   */ getStructTypeNode(e, t = this.shaderStage) {
        return this.types[t][e] || null;
    }
    /**
   * Returns an instance of {@link StructType} for the given output struct node.
   *
   * @param {OutputStructNode} node - The output struct node.
   * @param {Array<Object>} membersLayout - The output struct types.
   * @param {?string} [name=null] - The name of the struct.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @return {StructType} The struct type attribute.
   */ getStructTypeFromNode(e, t, i = null, n = this.shaderStage) {
        const s = this.getDataFromNode(e, n, this.globalCache);
        let a = s.structType;
        if (a === void 0) {
            const o = this.structs.index++;
            i === null && (i = "StructType" + o), a = new $d7238066c5de7f1c$var$ice(i, t), this.structs[n].push(a), this.types[n][i] = e, s.structType = a;
        }
        return a;
    }
    /**
   * Returns an instance of {@link StructType} for the given output struct node.
   *
   * @param {OutputStructNode} node - The output struct node.
   * @param {Array<Object>} membersLayout - The output struct types.
   * @return {StructType} The struct type attribute.
   */ getOutputStructTypeFromNode(e, t) {
        const i = this.getStructTypeFromNode(e, t, "OutputType", "fragment");
        return i.output = !0, i;
    }
    /**
   * Returns an instance of {@link NodeUniform} for the given uniform node.
   *
   * @param {UniformNode} node - The uniform node.
   * @param {string} type - The uniform type.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @param {?string} name - The name of the uniform.
   * @return {NodeUniform} The node uniform.
   */ getUniformFromNode(e, t, i = this.shaderStage, n = null) {
        const s = this.getDataFromNode(e, i, this.globalCache);
        let a = s.uniform;
        if (a === void 0) {
            const o = this.uniforms.index++;
            a = new $d7238066c5de7f1c$var$qle(n || "nodeUniform" + o, t, e), this.uniforms[i].push(a), this.registerDeclaration(a), s.uniform = a;
        }
        return a;
    }
    /**
   * Returns an instance of {@link NodeVar} for the given variable node.
   *
   * @param {VarNode} node - The variable node.
   * @param {?string} name - The variable's name.
   * @param {string} [type=node.getNodeType( this )] - The variable's type.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @param {boolean} [readOnly=false] - Whether the variable is read-only or not.
   *
   * @return {NodeVar} The node variable.
   */ getVarFromNode(e, t = null, i = e.getNodeType(this), n = this.shaderStage, s = !1) {
        const a = this.getDataFromNode(e, n), o = this.getSubBuildProperty("variable", a.subBuilds);
        let g = a[o];
        if (g === void 0) {
            const l = s ? "_const" : "_var", c = this.vars[n] || (this.vars[n] = []), d = this.vars[l] || (this.vars[l] = 0);
            t === null && (t = (s ? "nodeConst" : "nodeVar") + d, this.vars[l]++), o !== "variable" && (t = this.getSubBuildProperty(t, a.subBuilds));
            const p = e.getArrayCount(this);
            g = new $d7238066c5de7f1c$var$JD(t, i, s, p), s || c.push(g), this.registerDeclaration(g), a[o] = g;
        }
        return g;
    }
    /**
   * Returns whether a Node or its flow is deterministic, useful for use in `const`.
   *
   * @param {Node} node - The varying node.
   * @return {boolean} Returns true if deterministic.
   */ isDeterministic(e) {
        if (e.isMathNode) return this.isDeterministic(e.aNode) && (e.bNode ? this.isDeterministic(e.bNode) : !0) && (e.cNode ? this.isDeterministic(e.cNode) : !0);
        if (e.isOperatorNode) return this.isDeterministic(e.aNode) && (e.bNode ? this.isDeterministic(e.bNode) : !0);
        if (e.isArrayNode) {
            if (e.values !== null) {
                for (const t of e.values)if (!this.isDeterministic(t)) return !1;
            }
            return !0;
        } else if (e.isConstNode) return !0;
        return !1;
    }
    /**
   * Returns an instance of {@link NodeVarying} for the given varying node.
   *
   * @param {(VaryingNode|PropertyNode)} node - The varying node.
   * @param {?string} name - The varying's name.
   * @param {string} [type=node.getNodeType( this )] - The varying's type.
   * @param {?string} interpolationType - The interpolation type of the varying.
   * @param {?string} interpolationSampling - The interpolation sampling type of the varying.
   * @return {NodeVar} The node varying.
   */ getVaryingFromNode(e, t = null, i = e.getNodeType(this), n = null, s = null) {
        const a = this.getDataFromNode(e, "any"), o = this.getSubBuildProperty("varying", a.subBuilds);
        let g = a[o];
        if (g === void 0) {
            const l = this.varyings, c = l.length;
            t === null && (t = "nodeVarying" + c), o !== "varying" && (t = this.getSubBuildProperty(t, a.subBuilds)), g = new $d7238066c5de7f1c$var$$le(t, i, n, s), l.push(g), this.registerDeclaration(g), a[o] = g;
        }
        return g;
    }
    /**
   * Registers a node declaration in the current shader stage.
   *
   * @param {Object} node - The node to be registered.
   */ registerDeclaration(e) {
        const t = this.shaderStage, i = this.declarations[t] || (this.declarations[t] = {}), n = this.getPropertyName(e);
        let s = 1, a = n;
        for(; i[a] !== void 0;)a = n + "_" + s++;
        s > 1 && (e.name = a, $d7238066c5de7f1c$var$ze(`TSL: Declaration name '${n}' of '${e.type}' already in use. Renamed to '${a}'.`)), i[a] = e;
    }
    /**
   * Returns an instance of {@link NodeCode} for the given code node.
   *
   * @param {CodeNode} node - The code node.
   * @param {string} type - The node type.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @return {NodeCode} The node code.
   */ getCodeFromNode(e, t, i = this.shaderStage) {
        const n = this.getDataFromNode(e);
        let s = n.code;
        if (s === void 0) {
            const a = this.codes[i] || (this.codes[i] = []), o = a.length;
            s = new $d7238066c5de7f1c$var$ece("nodeCode" + o, t), a.push(s), n.code = s;
        }
        return s;
    }
    /**
  	 * Adds a code flow based on the code-block hierarchy.
  
  	 * This is used so that code-blocks like If,Else create their variables locally if the Node
  	 * is only used inside one of these conditionals in the current shader stage.
  	 *
  	 * @param {Node} node - The node to add.
  	 * @param {Node} nodeBlock - Node-based code-block. Usually 'ConditionalNode'.
  	 */ addFlowCodeHierarchy(e, t) {
        const { flowCodes: i, flowCodeBlock: n } = this.getDataFromNode(e);
        let s = !0, a = t;
        for(; a;){
            if (n.get(a) === !0) {
                s = !1;
                break;
            }
            a = this.getDataFromNode(a).parentNodeBlock;
        }
        if (s) for (const o of i)this.addLineFlowCode(o);
    }
    /**
   * Add a inline-code to the current flow code-block.
   *
   * @param {Node} node - The node to add.
   * @param {string} code - The code to add.
   * @param {Node} nodeBlock - Current ConditionalNode
   */ addLineFlowCodeBlock(e, t, i) {
        const n = this.getDataFromNode(e), s = n.flowCodes || (n.flowCodes = []), a = n.flowCodeBlock || (n.flowCodeBlock = /* @__PURE__ */ new WeakMap());
        s.push(t), a.set(i, !0);
    }
    /**
   * Add a inline-code to the current flow.
   *
   * @param {string} code - The code to add.
   * @param {?Node} [node= null] - Optional Node, can help the system understand if the Node is part of a code-block.
   * @return {NodeBuilder} A reference to this node builder.
   */ addLineFlowCode(e, t = null) {
        return e === "" ? this : (t !== null && this.context.nodeBlock && this.addLineFlowCodeBlock(t, e, this.context.nodeBlock), e = this.tab + e, /;\s*$/.test(e) || (e = e + `;
`), this.flow.code += e, this);
    }
    /**
   * Adds a code to the current code flow.
   *
   * @param {string} code - Shader code.
   * @return {NodeBuilder} A reference to this node builder.
   */ addFlowCode(e) {
        return this.flow.code += e, this;
    }
    /**
   * Add tab in the code that will be generated so that other snippets respect the current tabulation.
   * Typically used in codes with If,Else.
   *
   * @return {NodeBuilder} A reference to this node builder.
   */ addFlowTab() {
        return this.tab += "	", this;
    }
    /**
   * Removes a tab.
   *
   * @return {NodeBuilder} A reference to this node builder.
   */ removeFlowTab() {
        return this.tab = this.tab.slice(0, -1), this;
    }
    /**
   * Gets the current flow data based on a Node.
   *
   * @param {Node} node - Node that the flow was started.
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {Object} The flow data.
   */ getFlowData(e) {
        return this.flowsData.get(e);
    }
    /**
   * Executes the node flow based on a root node to generate the final shader code.
   *
   * @param {Node} node - The node to execute.
   * @return {Object} The code flow.
   */ flowNode(e) {
        const t = e.getNodeType(this), i = this.flowChildNode(e, t);
        return this.flowsData.set(e, i), i;
    }
    /**
   * Includes a node in the current function node.
   *
   * @param {Node} node - The node to include.
   * @returns {void}
   */ addInclude(e) {
        this.currentFunctionNode !== null && this.currentFunctionNode.includes.push(e);
    }
    /**
   * Returns the native shader operator name for a given generic name.
   * It is a similar type of method like {@link NodeBuilder#getMethod}.
   *
   * @param {ShaderNodeInternal} shaderNode - The shader node to build the function node with.
   * @return {FunctionNode} The build function node.
   */ buildFunctionNode(e) {
        const t = new $d7238066c5de7f1c$var$mD(), i = this.currentFunctionNode;
        return this.currentFunctionNode = t, t.code = this.buildFunctionCode(e), this.currentFunctionNode = i, t;
    }
    /**
   * Generates a code flow based on a TSL function: Fn().
   *
   * @param {ShaderNodeInternal} shaderNode - A function code will be generated based on the input.
   * @return {Object}
   */ flowShaderNode(e) {
        const t = e.layout, i = {
            [Symbol.iterator] () {
                let a = 0;
                const o = Object.values(this);
                return {
                    next: ()=>({
                            value: o[a],
                            done: a++ >= o.length
                        })
                };
            }
        };
        for (const a of t.inputs)i[a.name] = new $d7238066c5de7f1c$var$qU(a.type, a.name);
        e.layout = null;
        const n = e.call(i), s = this.flowStagesNode(n, t.type);
        return e.layout = t, s;
    }
    /**
   * Executes the node in a specific build stage.
   *
   * This function can be used to arbitrarily execute the specified build stage
   * outside of the standard build process. For instance, if a node's type depends
   * on properties created by the 'setup' stage, then flowBuildStage(node, 'setup')
   * can be used to execute the setup build stage and access its generated nodes
   * before the standard build process begins.
   *
   * @param {Node} node - The node to execute.
   * @param {string} buildStage - The build stage to execute the node in.
   * @param {?(Node|string)} [output=null] - Expected output type. For example 'vec3'.
   * @return {?(Node|string)} The result of the node build.
   */ flowBuildStage(e, t, i = null) {
        const n = this.getBuildStage();
        this.setBuildStage(t);
        const s = e.build(this, i);
        return this.setBuildStage(n), s;
    }
    /**
   * Runs the node flow through all the steps of creation, 'setup', 'analyze', 'generate'.
   *
   * @param {Node} node - The node to execute.
   * @param {?string} output - Expected output type. For example 'vec3'.
   * @return {Object}
   */ flowStagesNode(e, t = null) {
        const i = this.flow, n = this.vars, s = this.declarations, a = this.cache, o = this.buildStage, g = this.stack, l = {
            code: ""
        };
        this.flow = l, this.vars = {}, this.declarations = {}, this.cache = new $d7238066c5de7f1c$var$wH(), this.stack = $d7238066c5de7f1c$var$HS();
        for (const c of $d7238066c5de7f1c$var$Z2)this.setBuildStage(c), l.result = e.build(this, t);
        return l.vars = this.getVars(this.shaderStage), this.flow = i, this.vars = n, this.declarations = s, this.cache = a, this.stack = g, this.setBuildStage(o), l;
    }
    /**
   * Returns the native shader operator name for a given generic name.
   * It is a similar type of method like {@link NodeBuilder#getMethod}.
   *
   * @abstract
   * @param {string} op - The operator name to resolve.
   * @return {?string} The resolved operator name.
   */ getFunctionOperator() {
        return null;
    }
    /**
   * Builds the given shader node.
   *
   * @abstract
   * @param {ShaderNodeInternal} shaderNode - The shader node.
   * @return {string} The function code.
   */ buildFunctionCode() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Generates a code flow based on a child Node.
   *
   * @param {Node} node - The node to execute.
   * @param {?string} output - Expected output type. For example 'vec3'.
   * @return {Object} The code flow.
   */ flowChildNode(e, t = null) {
        const i = this.flow, n = {
            code: ""
        };
        return this.flow = n, n.result = e.build(this, t), this.flow = i, n;
    }
    /**
   * Executes a flow of code in a different stage.
   *
   * Some nodes like `varying()` have the ability to compute code in vertex-stage and
   * return the value in fragment-stage even if it is being executed in an input fragment.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @param {Node} node - The node to execute.
   * @param {?string} output - Expected output type. For example 'vec3'.
   * @param {?string} propertyName - The property name to assign the result.
   * @return {?(Object|Node)} The code flow or node.build() result.
   */ flowNodeFromShaderStage(e, t, i = null, n = null) {
        const s = this.tab, a = this.cache, o = this.shaderStage, g = this.context;
        this.setShaderStage(e);
        const l = {
            ...this.context
        };
        delete l.nodeBlock, this.cache = this.globalCache, this.tab = "	", this.context = l;
        let c = null;
        if (this.buildStage === "generate") {
            const d = this.flowChildNode(t, i);
            n !== null && (d.code += `${this.tab + n} = ${d.result};
`), this.flowCode[e] = this.flowCode[e] + d.code, c = d;
        } else c = t.build(this);
        return this.setShaderStage(o), this.cache = a, this.tab = s, this.context = g, c;
    }
    /**
   * Returns an array holding all node attributes of this node builder.
   *
   * @return {Array<NodeAttribute>} The node attributes of this builder.
   */ getAttributesArray() {
        return this.attributes.concat(this.bufferAttributes);
    }
    /**
   * Returns the attribute definitions as a shader string for the given shader stage.
   *
   * @abstract
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {string} The attribute code section.
   */ getAttributes() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns the varying definitions as a shader string for the given shader stage.
   *
   * @abstract
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {string} The varying code section.
   */ getVaryings() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns a single variable definition as a shader string for the given variable type and name.
   *
   * @param {string} type - The variable's type.
   * @param {string} name - The variable's name.
   * @param {?number} [count=null] - The array length.
   * @return {string} The shader string.
   */ getVar(e, t, i = null) {
        return `${i !== null ? this.generateArrayDeclaration(e, i) : this.getType(e)} ${t}`;
    }
    /**
   * Returns the variable definitions as a shader string for the given shader stage.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {string} The variable code section.
   */ getVars(e) {
        let t = "";
        const i = this.vars[e];
        if (i !== void 0) for (const n of i)t += `${this.getVar(n.type, n.name)}; `;
        return t;
    }
    /**
   * Returns the uniform definitions as a shader string for the given shader stage.
   *
   * @abstract
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {string} The uniform code section.
   */ getUniforms() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns the native code definitions as a shader string for the given shader stage.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {string} The native code section.
   */ getCodes(e) {
        const t = this.codes[e];
        let i = "";
        if (t !== void 0) for (const n of t)i += n.code + `
`;
        return i;
    }
    /**
   * Returns the hash of this node builder.
   *
   * @return {string} The hash.
   */ getHash() {
        return this.vertexShader + this.fragmentShader + this.computeShader;
    }
    /**
   * Sets the current shader stage.
   *
   * @param {?('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage to set.
   */ setShaderStage(e) {
        this.shaderStage = e;
    }
    /**
   * Returns the current shader stage.
   *
   * @return {?('vertex'|'fragment'|'compute'|'any')} The current shader stage.
   */ getShaderStage() {
        return this.shaderStage;
    }
    /**
   * Sets the current build stage.
   *
   * @param {?('setup'|'analyze'|'generate')} buildStage - The build stage to set.
   */ setBuildStage(e) {
        this.buildStage = e;
    }
    /**
   * Returns the current build stage.
   *
   * @return {?('setup'|'analyze'|'generate')} The current build stage.
   */ getBuildStage() {
        return this.buildStage;
    }
    /**
   * Controls the code build of the shader stages.
   *
   * @abstract
   */ buildCode() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
    /**
   * Returns the current sub-build layer.
   *
   * @return {SubBuildNode} The current sub-build layers.
   */ get subBuild() {
        return this.subBuildLayers[this.subBuildLayers.length - 1] || null;
    }
    /**
   * Adds a sub-build layer to the node builder.
   *
   * @param {SubBuildNode} subBuild - The sub-build layer to add.
   */ addSubBuild(e) {
        this.subBuildLayers.push(e);
    }
    /**
   * Removes the last sub-build layer from the node builder.
   *
   * @return {SubBuildNode} The removed sub-build layer.
   */ removeSubBuild() {
        return this.subBuildLayers.pop();
    }
    /**
   * Returns the closest sub-build layer for the given data.
   *
   * @param {Node|Set<string>|Array<string>} data - The data to get the closest sub-build layer from.
   * @return {?string} The closest sub-build name or null if none found.
   */ getClosestSubBuild(e) {
        let t;
        if (e && e.isNode ? e.isShaderCallNodeInternal ? t = e.shaderNode.subBuilds : e.isStackNode ? t = [
            e.subBuild
        ] : t = this.getDataFromNode(e, "any").subBuilds : e instanceof Set ? t = [
            ...e
        ] : t = e, !t) return null;
        const i = this.subBuildLayers;
        for(let n = t.length - 1; n >= 0; n--){
            const s = t[n];
            if (i.includes(s)) return s;
        }
        return null;
    }
    /**
   * Returns the output node of a sub-build layer.
   *
   * @param {Node} node - The node to get the output from.
   * @return {string} The output node name.
   */ getSubBuildOutput(e) {
        return this.getSubBuildProperty("outputNode", e);
    }
    /**
   * Returns the sub-build property name for the given property and node.
   *
   * @param {string} [property=''] - The property name.
   * @param {?Node} [node=null] - The node to get the sub-build from.
   * @return {string} The sub-build property name.
   */ getSubBuildProperty(e = "", t = null) {
        let i;
        t !== null ? i = this.getClosestSubBuild(t) : i = this.subBuildFn;
        let n;
        return i ? n = e ? i + "_" + e : i : n = e, n;
    }
    /**
   * Central build method which controls the build for the given object.
   *
   * @return {NodeBuilder} A reference to this node builder.
   */ build() {
        const { object: e, material: t, renderer: i } = this;
        if (t !== null) {
            let n = i.library.fromMaterial(t);
            n === null && ($d7238066c5de7f1c$var$nt(`NodeMaterial: Material "${t.type}" is not compatible.`), n = new $d7238066c5de7f1c$var$Bs()), n.build(this);
        } else this.addFlow("compute", e);
        for (const n of $d7238066c5de7f1c$var$Z2){
            this.setBuildStage(n), this.context.vertex && this.context.vertex.isNode && this.flowNodeFromShaderStage("vertex", this.context.vertex);
            for (const s of $d7238066c5de7f1c$var$R2){
                this.setShaderStage(s);
                const a = this.flowNodes[s];
                for (const o of a)n === "generate" ? this.flowNode(o) : o.build(this);
            }
        }
        return this.setBuildStage(null), this.setShaderStage(null), this.buildCode(), this.buildUpdateNodes(), this;
    }
    /**
   * Returns a uniform representation which is later used for UBO generation and rendering.
   *
   * @param {NodeUniform} uniformNode - The uniform node.
   * @param {string} type - The requested type.
   * @return {Uniform} The uniform.
   */ getNodeUniform(e, t) {
        if (t === "float" || t === "int" || t === "uint") return new $d7238066c5de7f1c$var$uce(e);
        if (t === "vec2" || t === "ivec2" || t === "uvec2") return new $d7238066c5de7f1c$var$Ice(e);
        if (t === "vec3" || t === "ivec3" || t === "uvec3") return new $d7238066c5de7f1c$var$dce(e);
        if (t === "vec4" || t === "ivec4" || t === "uvec4") return new $d7238066c5de7f1c$var$hce(e);
        if (t === "color") return new $d7238066c5de7f1c$var$Cce(e);
        if (t === "mat2") return new $d7238066c5de7f1c$var$pce(e);
        if (t === "mat3") return new $d7238066c5de7f1c$var$mce(e);
        if (t === "mat4") return new $d7238066c5de7f1c$var$Ace(e);
        throw new Error(`Uniform "${t}" not declared.`);
    }
    /**
   * Formats the given shader snippet from a given type into another one. E.g.
   * this method might be used to convert a simple float string `"1.0"` into a
   * `vec3` representation: `"vec3<f32>( 1.0 )"`.
   *
   * @param {string} snippet - The shader snippet.
   * @param {string} fromType - The source type.
   * @param {string} toType - The target type.
   * @return {string} The updated shader string.
   */ format(e, t, i) {
        if (t = this.getVectorType(t), i = this.getVectorType(i), t === i || i === null || this.isReference(i)) return e;
        const n = this.getTypeLength(t), s = this.getTypeLength(i);
        return n === 16 && s === 9 ? `${this.getType(i)}( ${e}[ 0 ].xyz, ${e}[ 1 ].xyz, ${e}[ 2 ].xyz )` : n === 9 && s === 4 ? `${this.getType(i)}( ${e}[ 0 ].xy, ${e}[ 1 ].xy )` : n > 4 || s > 4 || s === 0 ? e : n === s ? `${this.getType(i)}( ${e} )` : n > s ? (e = i === "bool" ? `all( ${e} )` : `${e}.${"xyz".slice(0, s)}`, this.format(e, this.getTypeFromLength(s, this.getComponentType(t)), i)) : s === 4 && n > 1 ? `${this.getType(i)}( ${this.format(e, t, "vec3")}, 1.0 )` : n === 2 ? `${this.getType(i)}( ${this.format(e, t, "vec2")}, 0.0 )` : (n === 1 && s > 1 && t !== this.getComponentType(i) && (e = `${this.getType(this.getComponentType(i))}( ${e} )`), `${this.getType(i)}( ${e} )`);
    }
    /**
   * Returns a signature with the engine's current revision.
   *
   * @return {string} The signature.
   */ getSignature() {
        return `// Three.js r${$d7238066c5de7f1c$var$MB} - Node System
`;
    }
}
class $d7238066c5de7f1c$var$H9 {
    /**
   * Constructs a new node fame.
   */ constructor(){
        this.time = 0, this.deltaTime = 0, this.frameId = 0, this.renderId = 0, this.updateMap = /* @__PURE__ */ new WeakMap(), this.updateBeforeMap = /* @__PURE__ */ new WeakMap(), this.updateAfterMap = /* @__PURE__ */ new WeakMap(), this.renderer = null, this.material = null, this.camera = null, this.object = null, this.scene = null;
    }
    /**
   * Returns a dictionary for a given node and update map which
   * is used to correctly call node update methods per frame or render.
   *
   * @private
   * @param {WeakMap<Node, Object>} referenceMap - The reference weak map.
   * @param {Node} nodeRef - The reference to the current node.
   * @return {Object<string,WeakMap<Object, number>>} The dictionary.
   */ _getMaps(e, t) {
        let i = e.get(t);
        return i === void 0 && (i = {
            renderId: 0,
            frameId: 0
        }, e.set(t, i)), i;
    }
    /**
   * This method executes the {@link Node#updateBefore} for the given node.
   * It makes sure {@link Node#updateBeforeType} is honored meaning the update
   * is only executed once per frame, render or object depending on the update
   * type.
   *
   * @param {Node} node - The node that should be updated.
   */ updateBeforeNode(e) {
        const t = e.getUpdateBeforeType(), i = e.updateReference(this);
        if (t === $d7238066c5de7f1c$var$Dt.FRAME) {
            const n = this._getMaps(this.updateBeforeMap, i);
            n.frameId !== this.frameId && e.updateBefore(this) !== !1 && (n.frameId = this.frameId);
        } else if (t === $d7238066c5de7f1c$var$Dt.RENDER) {
            const n = this._getMaps(this.updateBeforeMap, i);
            n.renderId !== this.renderId && e.updateBefore(this) !== !1 && (n.renderId = this.renderId);
        } else t === $d7238066c5de7f1c$var$Dt.OBJECT && e.updateBefore(this);
    }
    /**
   * This method executes the {@link Node#updateAfter} for the given node.
   * It makes sure {@link Node#updateAfterType} is honored meaning the update
   * is only executed once per frame, render or object depending on the update
   * type.
   *
   * @param {Node} node - The node that should be updated.
   */ updateAfterNode(e) {
        const t = e.getUpdateAfterType(), i = e.updateReference(this);
        if (t === $d7238066c5de7f1c$var$Dt.FRAME) {
            const n = this._getMaps(this.updateAfterMap, i);
            n.frameId !== this.frameId && e.updateAfter(this) !== !1 && (n.frameId = this.frameId);
        } else if (t === $d7238066c5de7f1c$var$Dt.RENDER) {
            const n = this._getMaps(this.updateAfterMap, i);
            n.renderId !== this.renderId && e.updateAfter(this) !== !1 && (n.renderId = this.renderId);
        } else t === $d7238066c5de7f1c$var$Dt.OBJECT && e.updateAfter(this);
    }
    /**
   * This method executes the {@link Node#update} for the given node.
   * It makes sure {@link Node#updateType} is honored meaning the update
   * is only executed once per frame, render or object depending on the update
   * type.
   *
   * @param {Node} node - The node that should be updated.
   */ updateNode(e) {
        const t = e.getUpdateType(), i = e.updateReference(this);
        if (t === $d7238066c5de7f1c$var$Dt.FRAME) {
            const n = this._getMaps(this.updateMap, i);
            n.frameId !== this.frameId && e.update(this) !== !1 && (n.frameId = this.frameId);
        } else if (t === $d7238066c5de7f1c$var$Dt.RENDER) {
            const n = this._getMaps(this.updateMap, i);
            n.renderId !== this.renderId && e.update(this) !== !1 && (n.renderId = this.renderId);
        } else t === $d7238066c5de7f1c$var$Dt.OBJECT && e.update(this);
    }
    /**
   * Updates the internal state of the node frame. This method is
   * called by the renderer in its internal animation loop.
   */ update() {
        this.frameId++, this.lastTime === void 0 && (this.lastTime = performance.now()), this.deltaTime = (performance.now() - this.lastTime) / 1e3, this.lastTime = performance.now(), this.time += this.deltaTime;
    }
}
class $d7238066c5de7f1c$var$KY {
    /**
   * Constructs a new node function input.
   *
   * @param {string} type - The input type.
   * @param {string} name - The input name.
   * @param {?number} [count=null] - If the input is an Array, count will be the length.
   * @param {('in'|'out'|'inout')} [qualifier=''] - The parameter qualifier (only relevant for GLSL).
   * @param {boolean} [isConst=false] - Whether the input uses a const qualifier or not (only relevant for GLSL).
   */ constructor(e, t, i = null, n = "", s = !1){
        this.type = e, this.name = t, this.count = i, this.qualifier = n, this.isConst = s;
    }
}
$d7238066c5de7f1c$var$KY.isNodeFunctionInput = !0;
class $d7238066c5de7f1c$var$Bce extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "DirectionalLightNode";
    }
    /**
   * Constructs a new directional light node.
   *
   * @param {?DirectionalLight} [light=null] - The directional light source.
   */ constructor(e = null){
        super(e);
    }
    setupDirect() {
        const e = this.colorNode;
        return {
            lightDirection: $d7238066c5de7f1c$var$WY(this.light),
            lightColor: e
        };
    }
}
const $d7238066c5de7f1c$var$WH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$Dv = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji();
let $d7238066c5de7f1c$var$Db = null;
class $d7238066c5de7f1c$var$fce extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "RectAreaLightNode";
    }
    /**
   * Constructs a new rect area light node.
   *
   * @param {?RectAreaLight} [light=null] - The rect area light source.
   */ constructor(e = null){
        super(e), this.halfHeight = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce()).setGroup($d7238066c5de7f1c$var$ft), this.halfWidth = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$Ce()).setGroup($d7238066c5de7f1c$var$ft), this.updateType = $d7238066c5de7f1c$var$Dt.RENDER;
    }
    /**
   * Overwritten to updated rect area light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update(e) {
        super.update(e);
        const { light: t } = this, i = e.camera.matrixWorldInverse;
        $d7238066c5de7f1c$var$Dv.identity(), $d7238066c5de7f1c$var$WH.copy(t.matrixWorld), $d7238066c5de7f1c$var$WH.premultiply(i), $d7238066c5de7f1c$var$Dv.extractRotation($d7238066c5de7f1c$var$WH), this.halfWidth.value.set(t.width * 0.5, 0, 0), this.halfHeight.value.set(0, t.height * 0.5, 0), this.halfWidth.value.applyMatrix4($d7238066c5de7f1c$var$Dv), this.halfHeight.value.applyMatrix4($d7238066c5de7f1c$var$Dv);
    }
    setupDirectRectArea(e) {
        let t, i;
        e.isAvailable("float32Filterable") ? (t = $d7238066c5de7f1c$var$ni($d7238066c5de7f1c$var$Db.LTC_FLOAT_1), i = $d7238066c5de7f1c$var$ni($d7238066c5de7f1c$var$Db.LTC_FLOAT_2)) : (t = $d7238066c5de7f1c$var$ni($d7238066c5de7f1c$var$Db.LTC_HALF_1), i = $d7238066c5de7f1c$var$ni($d7238066c5de7f1c$var$Db.LTC_HALF_2));
        const { colorNode: n, light: s } = this, a = $d7238066c5de7f1c$var$wY(s);
        return {
            lightColor: n,
            lightPosition: a,
            halfWidth: this.halfWidth,
            halfHeight: this.halfHeight,
            ltc_1: t,
            ltc_2: i
        };
    }
    /**
   * Used to configure the internal BRDF approximation texture data.
   *
   * @param {RectAreaLightTexturesLib} ltc - The BRDF approximation texture data.
   */ static setLTC(e) {
        $d7238066c5de7f1c$var$Db = e;
    }
}
class $d7238066c5de7f1c$var$xY extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "SpotLightNode";
    }
    /**
   * Constructs a new spot light node.
   *
   * @param {?SpotLight} [light=null] - The spot light source.
   */ constructor(e = null){
        super(e), this.coneCosNode = $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft), this.penumbraCosNode = $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft), this.cutoffDistanceNode = $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft), this.decayExponentNode = $d7238066c5de7f1c$var$yt(0).setGroup($d7238066c5de7f1c$var$ft), this.colorNode = $d7238066c5de7f1c$var$yt(this.color).setGroup($d7238066c5de7f1c$var$ft);
    }
    /**
   * Overwritten to updated spot light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update(e) {
        super.update(e);
        const { light: t } = this;
        this.coneCosNode.value = Math.cos(t.angle), this.penumbraCosNode.value = Math.cos(t.angle * (1 - t.penumbra)), this.cutoffDistanceNode.value = t.distance, this.decayExponentNode.value = t.decay;
    }
    /**
   * Computes the spot attenuation for the given angle.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
   * @return {Node<float>} The spot attenuation.
   */ getSpotAttenuation(e, t) {
        const { coneCosNode: i, penumbraCosNode: n } = this;
        return $d7238066c5de7f1c$var$ic(i, n, t);
    }
    getLightCoord(e) {
        const t = e.getNodeProperties(this);
        let i = t.projectionUV;
        return i === void 0 && (i = $d7238066c5de7f1c$var$BD(this.light, e.context.positionWorld), t.projectionUV = i), i;
    }
    setupDirect(e) {
        const { colorNode: t, cutoffDistanceNode: i, decayExponentNode: n, light: s } = this, a = this.getLightVector(e), o = a.normalize(), g = o.dot($d7238066c5de7f1c$var$WY(s)), l = this.getSpotAttenuation(e, g), c = a.length(), d = $d7238066c5de7f1c$var$NY({
            lightDistance: c,
            cutoffDistance: i,
            decayExponent: n
        });
        let p = t.mul(l).mul(d), A, y;
        return s.colorNode ? (y = this.getLightCoord(e), A = s.colorNode(y)) : s.map && (y = this.getLightCoord(e), A = $d7238066c5de7f1c$var$ni(s.map, y.xy).onRenderUpdate(()=>s.map)), A && (p = y.mul(2).sub(1).abs().lessThan(1).all().select(p.mul(A), p)), {
            lightColor: p,
            lightDirection: o
        };
    }
}
class $d7238066c5de7f1c$var$Gce extends $d7238066c5de7f1c$var$xY {
    static get type() {
        return "IESSpotLightNode";
    }
    /**
   * Overwrites the default implementation to compute an IES conform spot attenuation.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
   * @return {Node<float>} The spot attenuation.
   */ getSpotAttenuation(e, t) {
        const i = this.light.iesMap;
        let n = null;
        if (i && i.isTexture === !0) {
            const s = t.acos().mul(1 / Math.PI);
            n = $d7238066c5de7f1c$var$ni(i, $d7238066c5de7f1c$var$Ne(s, 0), 0).r;
        } else n = super.getSpotAttenuation(t);
        return n;
    }
}
const $d7238066c5de7f1c$var$vce = /* @__PURE__ */ $d7238066c5de7f1c$var$oe(([r, e])=>{
    const t = r.abs().sub(e);
    return $d7238066c5de7f1c$var$au($d7238066c5de7f1c$var$En(t, 0)).add($d7238066c5de7f1c$var$Xo($d7238066c5de7f1c$var$En(t.x, t.y), 0));
});
class $d7238066c5de7f1c$var$Sce extends $d7238066c5de7f1c$var$xY {
    static get type() {
        return "ProjectorLightNode";
    }
    update(e) {
        super.update(e);
        const t = this.light;
        if (this.penumbraCosNode.value = Math.min(Math.cos(t.angle * (1 - t.penumbra)), 0.99999), t.aspect === null) {
            let i = 1;
            t.map !== null && (i = t.map.width / t.map.height), t.shadow.aspect = i;
        } else t.shadow.aspect = t.aspect;
    }
    /**
   * Overwrites the default implementation to compute projection attenuation.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @return {Node<float>} The spot attenuation.
   */ getSpotAttenuation(e) {
        const t = $d7238066c5de7f1c$var$J(0), i = this.penumbraCosNode, n = $d7238066c5de7f1c$var$TR(this.light).mul(e.context.positionWorld || $d7238066c5de7f1c$var$ou);
        return $d7238066c5de7f1c$var$Ht(n.w.greaterThan(0), ()=>{
            const s = n.xyz.div(n.w), a = $d7238066c5de7f1c$var$vce(s.xy.sub($d7238066c5de7f1c$var$Ne(0.5)), $d7238066c5de7f1c$var$Ne(0.5)), o = $d7238066c5de7f1c$var$cg(-1, $d7238066c5de7f1c$var$wi(1, $d7238066c5de7f1c$var$LL(i)).sub(1));
            t.assign($d7238066c5de7f1c$var$kL(a.mul(-2).mul(o)));
        }), t;
    }
}
class $d7238066c5de7f1c$var$Zce extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "AmbientLightNode";
    }
    /**
   * Constructs a new ambient light node.
   *
   * @param {?AmbientLight} [light=null] - The ambient light source.
   */ constructor(e = null){
        super(e);
    }
    setup({ context: e }) {
        e.irradiance.addAssign(this.colorNode);
    }
}
class $d7238066c5de7f1c$var$Rce extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "HemisphereLightNode";
    }
    /**
   * Constructs a new hemisphere light node.
   *
   * @param {?HemisphereLight} [light=null] - The hemisphere light source.
   */ constructor(e = null){
        super(e), this.lightPositionNode = $d7238066c5de7f1c$var$VY(e), this.lightDirectionNode = this.lightPositionNode.normalize(), this.groundColorNode = $d7238066c5de7f1c$var$yt(new $d7238066c5de7f1c$var$rn()).setGroup($d7238066c5de7f1c$var$ft);
    }
    /**
   * Overwritten to updated hemisphere light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update(e) {
        const { light: t } = this;
        super.update(e), this.lightPositionNode.object3d = t, this.groundColorNode.value.copy(t.groundColor).multiplyScalar(t.intensity);
    }
    setup(e) {
        const { colorNode: t, groundColorNode: i, lightDirectionNode: n } = this, a = $d7238066c5de7f1c$var$Ih.dot(n).mul(0.5).add(0.5), o = $d7238066c5de7f1c$var$qi(i, t, a);
        e.context.irradiance.addAssign(o);
    }
}
class $d7238066c5de7f1c$var$Vce extends $d7238066c5de7f1c$var$$C {
    static get type() {
        return "LightProbeNode";
    }
    /**
   * Constructs a new light probe node.
   *
   * @param {?LightProbe} [light=null] - The light probe.
   */ constructor(e = null){
        super(e);
        const t = [];
        for(let i = 0; i < 9; i++)t.push(new $d7238066c5de7f1c$var$Ce());
        this.lightProbe = $d7238066c5de7f1c$var$La(t);
    }
    /**
   * Overwritten to updated light probe specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */ update(e) {
        const { light: t } = this;
        super.update(e);
        for(let i = 0; i < 9; i++)this.lightProbe.array[i].copy(t.sh.coefficients[i]).multiplyScalar(t.intensity);
    }
    setup(e) {
        const t = $d7238066c5de7f1c$var$ED($d7238066c5de7f1c$var$Ih, this.lightProbe);
        e.context.irradiance.addAssign(t);
    }
}
class $d7238066c5de7f1c$var$DD {
    /**
   * The method parses the given native code an returns a node function.
   *
   * @abstract
   * @param {string} source - The native shader code.
   * @return {NodeFunction} A node function.
   */ parseFunction() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
}
class $d7238066c5de7f1c$var$FY {
    /**
   * Constructs a new node function.
   *
   * @param {string} type - The node type. This type is the return type of the node function.
   * @param {Array<NodeFunctionInput>} inputs - The function's inputs.
   * @param {string} [name=''] - The function's name.
   * @param {string} [precision=''] - The precision qualifier.
   */ constructor(e, t, i = "", n = ""){
        this.type = e, this.inputs = t, this.name = i, this.precision = n;
    }
    /**
   * This method returns the native code of the node function.
   *
   * @abstract
   * @param {string} name - The function's name.
   * @return {string} A shader code.
   */ getCode() {
        $d7238066c5de7f1c$var$ze("Abstract function.");
    }
}
$d7238066c5de7f1c$var$FY.isNodeFunction = !0;
const $d7238066c5de7f1c$var$wce = /^\s*(highp|mediump|lowp)?\s*([a-z_0-9]+)\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)/i, $d7238066c5de7f1c$var$Wce = /[a-z_0-9]+/ig, $d7238066c5de7f1c$var$X9 = "#pragma main", $d7238066c5de7f1c$var$Hce = (r)=>{
    r = r.trim();
    const e = r.indexOf($d7238066c5de7f1c$var$X9), t = e !== -1 ? r.slice(e + $d7238066c5de7f1c$var$X9.length) : r, i = t.match($d7238066c5de7f1c$var$wce);
    if (i !== null && i.length === 5) {
        const n = i[4], s = [];
        let a = null;
        for(; (a = $d7238066c5de7f1c$var$Wce.exec(n)) !== null;)s.push(a);
        const o = [];
        let g = 0;
        for(; g < s.length;){
            const y = s[g][0] === "const";
            y === !0 && g++;
            let G = s[g][0];
            G === "in" || G === "out" || G === "inout" ? g++ : G = "";
            const Z = s[g++][0];
            let v = Number.parseInt(s[g][0]);
            Number.isNaN(v) === !1 ? g++ : v = null;
            const V = s[g++][0];
            o.push(new $d7238066c5de7f1c$var$KY(Z, V, v, G, y));
        }
        const l = t.substring(i[0].length), c = i[3] !== void 0 ? i[3] : "", d = i[2], p = i[1] !== void 0 ? i[1] : "", A = e !== -1 ? r.slice(0, e) : "";
        return {
            type: d,
            inputs: o,
            name: c,
            precision: p,
            inputsCode: n,
            blockCode: l,
            headerCode: A
        };
    } else throw new Error("FunctionNode: Function is not a GLSL code.");
};
class $d7238066c5de7f1c$var$Xce extends $d7238066c5de7f1c$var$FY {
    /**
   * Constructs a new GLSL node function.
   *
   * @param {string} source - The GLSL source.
   */ constructor(e){
        const { type: t, inputs: i, name: n, precision: s, inputsCode: a, blockCode: o, headerCode: g } = $d7238066c5de7f1c$var$Hce(e);
        super(t, i, n, s), this.inputsCode = a, this.blockCode = o, this.headerCode = g;
    }
    /**
   * This method returns the GLSL code of the node function.
   *
   * @param {string} [name=this.name] - The function's name.
   * @return {string} The shader code.
   */ getCode(e = this.name) {
        let t;
        const i = this.blockCode;
        if (i !== "") {
            const { type: n, inputsCode: s, headerCode: a, precision: o } = this;
            let g = `${n} ${e} ( ${s.trim()} )`;
            o !== "" && (g = `${o} ${g}`), t = a + g + i;
        } else t = "";
        return t;
    }
}
class $d7238066c5de7f1c$var$Nce extends $d7238066c5de7f1c$var$DD {
    /**
   * The method parses the given GLSL code an returns a node function.
   *
   * @param {string} source - The GLSL code.
   * @return {GLSLNodeFunction} A node function.
   */ parseFunction(e) {
        return new $d7238066c5de7f1c$var$Xce(e);
    }
}
const $d7238066c5de7f1c$var$N9 = /* @__PURE__ */ new WeakMap(), $d7238066c5de7f1c$var$Fc = [], $d7238066c5de7f1c$var$Nd = [];
class $d7238066c5de7f1c$var$Lce extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new nodes management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Backend} backend - The renderer's backend.
   */ constructor(e, t){
        super(), this.renderer = e, this.backend = t, this.nodeFrame = new $d7238066c5de7f1c$var$H9(), this.nodeBuilderCache = /* @__PURE__ */ new Map(), this.callHashCache = new $d7238066c5de7f1c$var$nc(), this.groupsData = new $d7238066c5de7f1c$var$nc(), this.cacheLib = {};
    }
    /**
   * Returns `true` if the given node uniforms group must be updated or not.
   *
   * @param {NodeUniformsGroup} nodeUniformsGroup - The node uniforms group.
   * @return {boolean} Whether the node uniforms group requires an update or not.
   */ updateGroup(e) {
        const t = e.groupNode, i = t.name;
        if (i === $d7238066c5de7f1c$var$VL.name) return !0;
        if (i === $d7238066c5de7f1c$var$ft.name) {
            const s = this.get(e), a = this.nodeFrame.renderId;
            return s.renderId !== a ? (s.renderId = a, !0) : !1;
        }
        if (i === $d7238066c5de7f1c$var$M3.name) {
            const s = this.get(e), a = this.nodeFrame.frameId;
            return s.frameId !== a ? (s.frameId = a, !0) : !1;
        }
        $d7238066c5de7f1c$var$Fc[0] = t, $d7238066c5de7f1c$var$Fc[1] = e;
        let n = this.groupsData.get($d7238066c5de7f1c$var$Fc);
        return n === void 0 && this.groupsData.set($d7238066c5de7f1c$var$Fc, n = {}), $d7238066c5de7f1c$var$Fc.length = 0, n.version !== t.version ? (n.version = t.version, !0) : !1;
    }
    /**
   * Returns the cache key for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {number} The cache key.
   */ getForRenderCacheKey(e) {
        return e.initialCacheKey;
    }
    /**
   * Returns a node builder state for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {NodeBuilderState} The node builder state.
   */ getForRender(e) {
        const t = this.get(e);
        let i = t.nodeBuilderState;
        if (i === void 0) {
            const { nodeBuilderCache: n } = this, s = this.getForRenderCacheKey(e);
            if (i = n.get(s), i === void 0) {
                const a = (g)=>{
                    const l = this.backend.createNodeBuilder(e.object, this.renderer);
                    return l.scene = e.scene, l.material = g, l.camera = e.camera, l.context.material = g, l.lightsNode = e.lightsNode, l.environmentNode = this.getEnvironmentNode(e.scene), l.fogNode = this.getFogNode(e.scene), l.clippingContext = e.clippingContext, this.renderer.getOutputRenderTarget() && this.renderer.getOutputRenderTarget().multiview && l.enableMultiview(), l;
                };
                let o = a(e.material);
                try {
                    o.build();
                } catch (g) {
                    o = a(new $d7238066c5de7f1c$var$Bs()), o.build(), $d7238066c5de7f1c$var$nt("TSL: " + g);
                }
                i = this._createNodeBuilderState(o), n.set(s, i);
            }
            i.usedTimes++, t.nodeBuilderState = i;
        }
        return i;
    }
    /**
   * Deletes the given object from the internal data map
   *
   * @param {any} object - The object to delete.
   * @return {?Object} The deleted dictionary.
   */ delete(e) {
        if (e.isRenderObject) {
            const t = this.get(e).nodeBuilderState;
            t.usedTimes--, t.usedTimes === 0 && this.nodeBuilderCache.delete(this.getForRenderCacheKey(e));
        }
        return super.delete(e);
    }
    /**
   * Returns a node builder state for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   * @return {NodeBuilderState} The node builder state.
   */ getForCompute(e) {
        const t = this.get(e);
        let i = t.nodeBuilderState;
        if (i === void 0) {
            const n = this.backend.createNodeBuilder(e, this.renderer);
            n.build(), i = this._createNodeBuilderState(n), t.nodeBuilderState = i;
        }
        return i;
    }
    /**
   * Creates a node builder state for the given node builder.
   *
   * @private
   * @param {NodeBuilder} nodeBuilder - The node builder.
   * @return {NodeBuilderState} The node builder state.
   */ _createNodeBuilderState(e) {
        return new $d7238066c5de7f1c$var$jle(e.vertexShader, e.fragmentShader, e.computeShader, e.getAttributesArray(), e.getBindings(), e.updateNodes, e.updateBeforeNodes, e.updateAfterNodes, e.observer, e.transforms);
    }
    /**
   * Returns an environment node for the current configured
   * scene environment.
   *
   * @param {Scene} scene - The scene.
   * @return {Node} A node representing the current scene environment.
   */ getEnvironmentNode(e) {
        this.updateEnvironment(e);
        let t = null;
        if (e.environmentNode && e.environmentNode.isNode) t = e.environmentNode;
        else {
            const i = this.get(e);
            i.environmentNode && (t = i.environmentNode);
        }
        return t;
    }
    /**
   * Returns a background node for the current configured
   * scene background.
   *
   * @param {Scene} scene - The scene.
   * @return {Node} A node representing the current scene background.
   */ getBackgroundNode(e) {
        this.updateBackground(e);
        let t = null;
        if (e.backgroundNode && e.backgroundNode.isNode) t = e.backgroundNode;
        else {
            const i = this.get(e);
            i.backgroundNode && (t = i.backgroundNode);
        }
        return t;
    }
    /**
   * Returns a fog node for the current configured scene fog.
   *
   * @param {Scene} scene - The scene.
   * @return {Node} A node representing the current scene fog.
   */ getFogNode(e) {
        return this.updateFog(e), e.fogNode || this.get(e).fogNode || null;
    }
    /**
   * Returns a cache key for the given scene and lights node.
   * This key is used by `RenderObject` as a part of the dynamic
   * cache key (a key that must be checked every time the render
   * objects is drawn).
   *
   * @param {Scene} scene - The scene.
   * @param {LightsNode} lightsNode - The lights node.
   * @return {number} The cache key.
   */ getCacheKey(e, t) {
        $d7238066c5de7f1c$var$Fc[0] = e, $d7238066c5de7f1c$var$Fc[1] = t;
        const i = this.renderer.info.calls, n = this.callHashCache.get($d7238066c5de7f1c$var$Fc) || {};
        if (n.callId !== i) {
            const s = this.getEnvironmentNode(e), a = this.getFogNode(e);
            t && $d7238066c5de7f1c$var$Nd.push(t.getCacheKey(!0)), s && $d7238066c5de7f1c$var$Nd.push(s.getCacheKey()), a && $d7238066c5de7f1c$var$Nd.push(a.getCacheKey()), $d7238066c5de7f1c$var$Nd.push(this.renderer.getOutputRenderTarget() && this.renderer.getOutputRenderTarget().multiview ? 1 : 0), $d7238066c5de7f1c$var$Nd.push(this.renderer.shadowMap.enabled ? 1 : 0), $d7238066c5de7f1c$var$Nd.push(this.renderer.shadowMap.type), n.callId = i, n.cacheKey = $d7238066c5de7f1c$var$i0($d7238066c5de7f1c$var$Nd), this.callHashCache.set($d7238066c5de7f1c$var$Fc, n), $d7238066c5de7f1c$var$Nd.length = 0;
        }
        return $d7238066c5de7f1c$var$Fc.length = 0, n.cacheKey;
    }
    /**
   * A boolean that indicates whether tone mapping should be enabled
   * or not.
   *
   * @type {boolean}
   */ get isToneMappingState() {
        return !this.renderer.getRenderTarget();
    }
    /**
   * If a scene background is configured, this method makes sure to
   * represent the background with a corresponding node-based implementation.
   *
   * @param {Scene} scene - The scene.
   */ updateBackground(e) {
        const t = this.get(e), i = e.background;
        if (i) {
            const n = e.backgroundBlurriness === 0 && t.backgroundBlurriness > 0 || e.backgroundBlurriness > 0 && t.backgroundBlurriness === 0;
            if (t.background !== i || n) {
                const s = this.getCacheNode("background", i, ()=>{
                    if (i.isCubeTexture === !0 || i.mapping === $d7238066c5de7f1c$var$PN || i.mapping === $d7238066c5de7f1c$var$QN || i.mapping === $d7238066c5de7f1c$var$A2) {
                        if (e.backgroundBlurriness > 0 || i.mapping === $d7238066c5de7f1c$var$A2) return $d7238066c5de7f1c$var$yY(i);
                        {
                            let a;
                            return i.isCubeTexture === !0 ? a = $d7238066c5de7f1c$var$EA(i) : a = $d7238066c5de7f1c$var$ni(i), $d7238066c5de7f1c$var$XU(a);
                        }
                    } else {
                        if (i.isTexture === !0) return $d7238066c5de7f1c$var$ni(i, $d7238066c5de7f1c$var$AI.flipY()).setUpdateMatrix(!0);
                        i.isColor !== !0 && $d7238066c5de7f1c$var$nt("WebGPUNodes: Unsupported background configuration.", i);
                    }
                }, n);
                t.backgroundNode = s, t.background = i, t.backgroundBlurriness = e.backgroundBlurriness;
            }
        } else t.backgroundNode && (delete t.backgroundNode, delete t.background);
    }
    /**
   * This method is part of the caching of nodes which are used to represents the
   * scene's background, fog or environment.
   *
   * @param {string} type - The type of object to cache.
   * @param {Object} object - The object.
   * @param {Function} callback - A callback that produces a node representation for the given object.
   * @param {boolean} [forceUpdate=false] - Whether an update should be enforced or not.
   * @return {Node} The node representation.
   */ getCacheNode(e, t, i, n = !1) {
        const s = this.cacheLib[e] || (this.cacheLib[e] = /* @__PURE__ */ new WeakMap());
        let a = s.get(t);
        return (a === void 0 || n) && (a = i(), s.set(t, a)), a;
    }
    /**
   * If a scene fog is configured, this method makes sure to
   * represent the fog with a corresponding node-based implementation.
   *
   * @param {Scene} scene - The scene.
   */ updateFog(e) {
        const t = this.get(e), i = e.fog;
        if (i) {
            if (t.fog !== i) {
                const n = this.getCacheNode("fog", i, ()=>{
                    if (i.isFogExp2) {
                        const s = $d7238066c5de7f1c$var$vn("color", "color", i).setGroup($d7238066c5de7f1c$var$ft), a = $d7238066c5de7f1c$var$vn("density", "float", i).setGroup($d7238066c5de7f1c$var$ft);
                        return $d7238066c5de7f1c$var$bB(s, $d7238066c5de7f1c$var$ZY(a));
                    } else if (i.isFog) {
                        const s = $d7238066c5de7f1c$var$vn("color", "color", i).setGroup($d7238066c5de7f1c$var$ft), a = $d7238066c5de7f1c$var$vn("near", "float", i).setGroup($d7238066c5de7f1c$var$ft), o = $d7238066c5de7f1c$var$vn("far", "float", i).setGroup($d7238066c5de7f1c$var$ft);
                        return $d7238066c5de7f1c$var$bB(s, $d7238066c5de7f1c$var$SY(a, o));
                    } else $d7238066c5de7f1c$var$nt("Renderer: Unsupported fog configuration.", i);
                });
                t.fogNode = n, t.fog = i;
            }
        } else delete t.fogNode, delete t.fog;
    }
    /**
   * If a scene environment is configured, this method makes sure to
   * represent the environment with a corresponding node-based implementation.
   *
   * @param {Scene} scene - The scene.
   */ updateEnvironment(e) {
        const t = this.get(e), i = e.environment;
        if (i) {
            if (t.environment !== i) {
                const n = this.getCacheNode("environment", i, ()=>{
                    if (i.isCubeTexture === !0) return $d7238066c5de7f1c$var$EA(i);
                    if (i.isTexture === !0) return $d7238066c5de7f1c$var$ni(i);
                    $d7238066c5de7f1c$var$nt("Nodes: Unsupported environment configuration.", i);
                });
                t.environmentNode = n, t.environment = i;
            }
        } else t.environmentNode && (delete t.environmentNode, delete t.environment);
    }
    getNodeFrame(e = this.renderer, t = null, i = null, n = null, s = null) {
        const a = this.nodeFrame;
        return a.renderer = e, a.scene = t, a.object = i, a.camera = n, a.material = s, a;
    }
    getNodeFrameForRender(e) {
        return this.getNodeFrame(e.renderer, e.scene, e.object, e.camera, e.material);
    }
    /**
   * Returns the current output cache key.
   *
   * @return {string} The output cache key.
   */ getOutputCacheKey() {
        const e = this.renderer;
        return e.toneMapping + "," + e.currentColorSpace + "," + e.xr.isPresenting;
    }
    /**
   * Checks if the output configuration (tone mapping and color space) for
   * the given target has changed.
   *
   * @param {Texture} outputTarget - The output target.
   * @return {boolean} Whether the output configuration has changed or not.
   */ hasOutputChange(e) {
        return $d7238066c5de7f1c$var$N9.get(e) !== this.getOutputCacheKey();
    }
    /**
   * Returns a node that represents the output configuration (tone mapping and
   * color space) for the current target.
   *
   * @param {Texture} outputTarget - The output target.
   * @return {Node} The output node.
   */ getOutputNode(e) {
        const t = this.renderer, i = this.getOutputCacheKey(), n = e.isArrayTexture ? $d7238066c5de7f1c$var$gD(e, $d7238066c5de7f1c$var$ne($d7238066c5de7f1c$var$AI, $d7238066c5de7f1c$var$HI("gl_ViewID_OVR"))).renderOutput(t.toneMapping, t.currentColorSpace) : $d7238066c5de7f1c$var$ni(e, $d7238066c5de7f1c$var$AI).renderOutput(t.toneMapping, t.currentColorSpace);
        return $d7238066c5de7f1c$var$N9.set(e, i), n;
    }
    /**
   * Triggers the call of `updateBefore()` methods
   * for all nodes of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateBefore(e) {
        const t = e.getNodeBuilderState();
        for (const i of t.updateBeforeNodes)this.getNodeFrameForRender(e).updateBeforeNode(i);
    }
    /**
   * Triggers the call of `updateAfter()` methods
   * for all nodes of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateAfter(e) {
        const t = e.getNodeBuilderState();
        for (const i of t.updateAfterNodes)this.getNodeFrameForRender(e).updateAfterNode(i);
    }
    /**
   * Triggers the call of `update()` methods
   * for all nodes of the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   */ updateForCompute(e) {
        const t = this.getNodeFrame(), i = this.getForCompute(e);
        for (const n of i.updateNodes)t.updateNode(n);
    }
    /**
   * Triggers the call of `update()` methods
   * for all nodes of the given compute node.
   *
   * @param {RenderObject} renderObject - The render object.
   */ updateForRender(e) {
        const t = this.getNodeFrameForRender(e), i = e.getNodeBuilderState();
        for (const n of i.updateNodes)t.updateNode(n);
    }
    /**
   * Returns `true` if the given render object requires a refresh.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the given render object requires a refresh or not.
   */ needsRefresh(e) {
        const t = this.getNodeFrameForRender(e);
        return e.getMonitor().needsRefresh(e, t);
    }
    /**
   * Frees the internal resources.
   */ dispose() {
        super.dispose(), this.nodeFrame = new $d7238066c5de7f1c$var$H9(), this.nodeBuilderCache = /* @__PURE__ */ new Map(), this.cacheLib = {};
    }
}
const $d7238066c5de7f1c$var$HH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ed();
class $d7238066c5de7f1c$var$TZ {
    /**
   * Constructs a new clipping context.
   *
   * @param {?ClippingContext} [parentContext=null] - A reference to the parent clipping context.
   */ constructor(e = null){
        this.version = 0, this.clipIntersection = null, this.cacheKey = "", this.shadowPass = !1, this.viewNormalMatrix = new $d7238066c5de7f1c$var$Lo(), this.clippingGroupContexts = /* @__PURE__ */ new WeakMap(), this.intersectionPlanes = [], this.unionPlanes = [], this.parentVersion = null, e !== null && (this.viewNormalMatrix = e.viewNormalMatrix, this.clippingGroupContexts = e.clippingGroupContexts, this.shadowPass = e.shadowPass, this.viewMatrix = e.viewMatrix);
    }
    /**
   * Projects the given source clipping planes and writes the result into the
   * destination array.
   *
   * @param {Array<Plane>} source - The source clipping planes.
   * @param {Array<Vector4>} destination - The destination.
   * @param {number} offset - The offset.
   */ projectPlanes(e, t, i) {
        const n = e.length;
        for(let s = 0; s < n; s++){
            $d7238066c5de7f1c$var$HH.copy(e[s]).applyMatrix4(this.viewMatrix, this.viewNormalMatrix);
            const a = t[i + s], o = $d7238066c5de7f1c$var$HH.normal;
            a.x = -o.x, a.y = -o.y, a.z = -o.z, a.w = $d7238066c5de7f1c$var$HH.constant;
        }
    }
    /**
   * Updates the root clipping context of a scene.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   */ updateGlobal(e, t) {
        this.shadowPass = e.overrideMaterial !== null && e.overrideMaterial.isShadowPassMaterial, this.viewMatrix = t.matrixWorldInverse, this.viewNormalMatrix.getNormalMatrix(this.viewMatrix);
    }
    /**
   * Updates the clipping context.
   *
   * @param {ClippingContext} parentContext - The parent context.
   * @param {ClippingGroup} clippingGroup - The clipping group this context belongs to.
   */ update(e, t) {
        let i = !1;
        e.version !== this.parentVersion && (this.intersectionPlanes = Array.from(e.intersectionPlanes), this.unionPlanes = Array.from(e.unionPlanes), this.parentVersion = e.version), this.clipIntersection !== t.clipIntersection && (this.clipIntersection = t.clipIntersection, this.clipIntersection ? this.unionPlanes.length = e.unionPlanes.length : this.intersectionPlanes.length = e.intersectionPlanes.length);
        const n = t.clippingPlanes, s = n.length;
        let a, o;
        if (this.clipIntersection ? (a = this.intersectionPlanes, o = e.intersectionPlanes.length) : (a = this.unionPlanes, o = e.unionPlanes.length), a.length !== o + s) {
            a.length = o + s;
            for(let g = 0; g < s; g++)a[o + g] = new $d7238066c5de7f1c$var$Gi();
            i = !0;
        }
        this.projectPlanes(n, a, o), i && (this.version++, this.cacheKey = `${this.intersectionPlanes.length}:${this.unionPlanes.length}`);
    }
    /**
   * Returns a clipping context for the given clipping group.
   *
   * @param {ClippingGroup} clippingGroup - The clipping group.
   * @return {ClippingContext} The clipping context.
   */ getGroupContext(e) {
        if (this.shadowPass && !e.clipShadows) return this;
        let t = this.clippingGroupContexts.get(e);
        return t === void 0 && (t = new $d7238066c5de7f1c$var$TZ(this), this.clippingGroupContexts.set(e, t)), t.update(this, e), t;
    }
    /**
   * The count of union clipping planes.
   *
   * @type {number}
   * @readonly
   */ get unionClippingCount() {
        return this.unionPlanes.length;
    }
}
class $d7238066c5de7f1c$var$Yce {
    /**
   * Constructs a new bundle group.
   *
   * @param {BundleGroup} bundleGroup - The bundle group.
   * @param {Camera} camera - The camera the bundle group is rendered with.
   */ constructor(e, t){
        this.bundleGroup = e, this.camera = t;
    }
}
const $d7238066c5de7f1c$var$_b = [];
class $d7238066c5de7f1c$var$Kce {
    /**
   * Constructs a new render bundle management component.
   */ constructor(){
        this.bundles = new $d7238066c5de7f1c$var$nc();
    }
    /**
   * Returns a render bundle for the given bundle group and camera.
   *
   * @param {BundleGroup} bundleGroup - The bundle group.
   * @param {Camera} camera - The camera the bundle group is rendered with.
   * @return {RenderBundle} The render bundle.
   */ get(e, t) {
        const i = this.bundles;
        $d7238066c5de7f1c$var$_b[0] = e, $d7238066c5de7f1c$var$_b[1] = t;
        let n = i.get($d7238066c5de7f1c$var$_b);
        return n === void 0 && (n = new $d7238066c5de7f1c$var$Yce(e, t), i.set($d7238066c5de7f1c$var$_b, n)), $d7238066c5de7f1c$var$_b.length = 0, n;
    }
    /**
   * Frees all internal resources.
   */ dispose() {
        this.bundles = new $d7238066c5de7f1c$var$nc();
    }
}
class $d7238066c5de7f1c$var$_D {
    /**
   * Constructs a new node library.
   */ constructor(){
        this.lightNodes = /* @__PURE__ */ new WeakMap(), this.materialNodes = /* @__PURE__ */ new Map(), this.toneMappingNodes = /* @__PURE__ */ new Map();
    }
    /**
   * Returns a matching node material instance for the given material object.
   *
   * This method also assigns/copies the properties of the given material object
   * to the node material. This is done to make sure the current material
   * configuration carries over to the node version.
   *
   * @param {Material} material - A material.
   * @return {NodeMaterial} The corresponding node material.
   */ fromMaterial(e) {
        if (e.isNodeMaterial) return e;
        let t = null;
        const i = this.getMaterialNodeClass(e.type);
        if (i !== null) {
            t = new i();
            for(const n in e)t[n] = e[n];
        }
        return t;
    }
    /**
   * Adds a tone mapping node function for a tone mapping technique (constant).
   *
   * @param {Function} toneMappingNode - The tone mapping node function.
   * @param {number} toneMapping - The tone mapping.
   */ addToneMapping(e, t) {
        this.addType(e, t, this.toneMappingNodes);
    }
    /**
   * Returns a tone mapping node function for a tone mapping technique (constant).
   *
   * @param {number} toneMapping - The tone mapping.
   * @return {?Function} The tone mapping node function. Returns `null` if no node function is found.
   */ getToneMappingFunction(e) {
        return this.toneMappingNodes.get(e) || null;
    }
    /**
   * Returns a node material class definition for a material type.
   *
   * @param {string} materialType - The material type.
   * @return {?NodeMaterial.constructor} The node material class definition. Returns `null` if no node material is found.
   */ getMaterialNodeClass(e) {
        return this.materialNodes.get(e) || null;
    }
    /**
   * Adds a node material class definition for a given material type.
   *
   * @param {NodeMaterial.constructor} materialNodeClass - The node material class definition.
   * @param {string} materialClassType - The material type.
   */ addMaterial(e, t) {
        this.addType(e, t, this.materialNodes);
    }
    /**
   * Returns a light node class definition for a light class definition.
   *
   * @param {Light.constructor} light - The light class definition.
   * @return {?AnalyticLightNode.constructor} The light node class definition. Returns `null` if no light node is found.
   */ getLightNodeClass(e) {
        return this.lightNodes.get(e) || null;
    }
    /**
   * Adds a light node class definition for a given light class definition.
   *
   * @param {AnalyticLightNode.constructor} lightNodeClass - The light node class definition.
   * @param {Light.constructor} lightClass - The light class definition.
   */ addLight(e, t) {
        this.addClass(e, t, this.lightNodes);
    }
    /**
   * Adds a node class definition for the given type to the provided type library.
   *
   * @param {Node.constructor} nodeClass - The node class definition.
   * @param {number|string} type - The object type.
   * @param {Map<number|string,Node.constructor>} library - The type library.
   */ addType(e, t, i) {
        if (i.has(t)) {
            $d7238066c5de7f1c$var$ze(`Redefinition of node ${t}`);
            return;
        }
        if (typeof e != "function") throw new Error(`Node class ${e.name} is not a class.`);
        if (typeof t == "function" || typeof t == "object") throw new Error(`Base class ${t} is not a class.`);
        i.set(t, e);
    }
    /**
   * Adds a node class definition for the given class definition to the provided type library.
   *
   * @param {Node.constructor} nodeClass - The node class definition.
   * @param {Node.constructor} baseClass - The class definition.
   * @param {WeakMap<Node.constructor, Node.constructor>} library - The type library.
   */ addClass(e, t, i) {
        if (i.has(t)) {
            $d7238066c5de7f1c$var$ze(`Redefinition of node ${t.name}`);
            return;
        }
        if (typeof e != "function") throw new Error(`Node class ${e.name} is not a class.`);
        if (typeof t != "function") throw new Error(`Base class ${t.name} is not a class.`);
        i.set(t, e);
    }
}
const $d7238066c5de7f1c$var$xce = /* @__PURE__ */ new $d7238066c5de7f1c$var$HY(), $d7238066c5de7f1c$var$Pb = [];
class $d7238066c5de7f1c$var$Fce extends $d7238066c5de7f1c$var$nc {
    /**
   * Constructs a lighting management component.
   */ constructor(){
        super();
    }
    /**
   * Creates a new lights node for the given array of lights.
   *
   * @param {Array<Light>} lights - The render object.
   * @return {LightsNode} The lights node.
   */ createNode(e = []) {
        return new $d7238066c5de7f1c$var$HY().setLights(e);
    }
    /**
   * Returns a lights node for the given scene and camera.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera.
   * @return {LightsNode} The lights node.
   */ getNode(e, t) {
        if (e.isQuadMesh) return $d7238066c5de7f1c$var$xce;
        $d7238066c5de7f1c$var$Pb[0] = e, $d7238066c5de7f1c$var$Pb[1] = t;
        let i = this.get($d7238066c5de7f1c$var$Pb);
        return i === void 0 && (i = this.createNode(), this.set($d7238066c5de7f1c$var$Pb, i)), $d7238066c5de7f1c$var$Pb.length = 0, i;
    }
}
class $d7238066c5de7f1c$var$By extends $d7238066c5de7f1c$var$WI {
    /**
   * Constructs a new XR render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {Object} [options={}] - The configuration options.
   */ constructor(e = 1, t = 1, i = {}){
        super(e, t, i), this.isXRRenderTarget = !0, this._hasExternalTextures = !1, this._autoAllocateDepthBuffer = !0, this._isOpaqueFramebuffer = !1;
    }
    copy(e) {
        return super.copy(e), this._hasExternalTextures = e._hasExternalTextures, this._autoAllocateDepthBuffer = e._autoAllocateDepthBuffer, this._isOpaqueFramebuffer = e._isOpaqueFramebuffer, this;
    }
}
const $d7238066c5de7f1c$var$L9 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce(), $d7238066c5de7f1c$var$Y9 = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ce();
class $d7238066c5de7f1c$var$Tce extends $d7238066c5de7f1c$var$wI {
    /**
   * Constructs a new XR manager.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {boolean} [multiview=false] - Enables multiview if the device supports it.
   */ constructor(e, t = !1){
        super(), this.enabled = !1, this.isPresenting = !1, this.cameraAutoUpdate = !0, this._renderer = e, this._cameraL = new $d7238066c5de7f1c$var$tg(), this._cameraL.viewport = new $d7238066c5de7f1c$var$Gi(), this._cameraR = new $d7238066c5de7f1c$var$tg(), this._cameraR.viewport = new $d7238066c5de7f1c$var$Gi(), this._cameras = [
            this._cameraL,
            this._cameraR
        ], this._cameraXR = new $d7238066c5de7f1c$var$Ree(), this._currentDepthNear = null, this._currentDepthFar = null, this._controllers = [], this._controllerInputSources = [], this._xrRenderTarget = null, this._layers = [], this._sessionUsesLayers = !1, this._supportsGlBinding = typeof XRWebGLBinding < "u", this._frameBufferTargets = null, this._createXRLayer = $d7238066c5de7f1c$var$Uce.bind(this), this._gl = null, this._currentAnimationContext = null, this._currentAnimationLoop = null, this._currentPixelRatio = null, this._currentSize = new $d7238066c5de7f1c$var$Ii(), this._onSessionEvent = $d7238066c5de7f1c$var$kce.bind(this), this._onSessionEnd = $d7238066c5de7f1c$var$Ece.bind(this), this._onInputSourcesChange = $d7238066c5de7f1c$var$Jce.bind(this), this._onAnimationFrame = $d7238066c5de7f1c$var$Dce.bind(this), this._referenceSpace = null, this._referenceSpaceType = "local-floor", this._customReferenceSpace = null, this._framebufferScaleFactor = 1, this._foveation = 1, this._session = null, this._glBaseLayer = null, this._glBinding = null, this._glProjLayer = null, this._xrFrame = null, this._supportsLayers = this._supportsGlBinding && "createProjectionLayer" in XRWebGLBinding.prototype, this._useMultiviewIfPossible = t, this._useMultiview = !1;
    }
    /**
   * Returns an instance of `THREE.Group` that represents the transformation
   * of a XR controller in target ray space. The requested controller is defined
   * by the given index.
   *
   * @param {number} index - The index of the XR controller.
   * @return {Group} A group that represents the controller's transformation.
   */ getController(e) {
        return this._getController(e).getTargetRaySpace();
    }
    /**
   * Returns an instance of `THREE.Group` that represents the transformation
   * of a XR controller in grip space. The requested controller is defined
   * by the given index.
   *
   * @param {number} index - The index of the XR controller.
   * @return {Group} A group that represents the controller's transformation.
   */ getControllerGrip(e) {
        return this._getController(e).getGripSpace();
    }
    /**
   * Returns an instance of `THREE.Group` that represents the transformation
   * of a XR controller in hand space. The requested controller is defined
   * by the given index.
   *
   * @param {number} index - The index of the XR controller.
   * @return {Group} A group that represents the controller's transformation.
   */ getHand(e) {
        return this._getController(e).getHandSpace();
    }
    /**
   * Returns the foveation value.
   *
   * @return {number|undefined} The foveation value. Returns `undefined` if no base or projection layer is defined.
   */ getFoveation() {
        if (!(this._glProjLayer === null && this._glBaseLayer === null)) return this._foveation;
    }
    /**
   * Sets the foveation value.
   *
   * @param {number} foveation - A number in the range `[0,1]` where `0` means no foveation (full resolution)
   * and `1` means maximum foveation (the edges render at lower resolution).
   */ setFoveation(e) {
        this._foveation = e, this._glProjLayer !== null && (this._glProjLayer.fixedFoveation = e), this._glBaseLayer !== null && this._glBaseLayer.fixedFoveation !== void 0 && (this._glBaseLayer.fixedFoveation = e);
    }
    /**
   * Returns the framebuffer scale factor.
   *
   * @return {number} The framebuffer scale factor.
   */ getFramebufferScaleFactor() {
        return this._framebufferScaleFactor;
    }
    /**
   * Sets the framebuffer scale factor.
   *
   * This method can not be used during a XR session.
   *
   * @param {number} factor - The framebuffer scale factor.
   */ setFramebufferScaleFactor(e) {
        this._framebufferScaleFactor = e, this.isPresenting === !0 && $d7238066c5de7f1c$var$ze("XRManager: Cannot change framebuffer scale while presenting.");
    }
    /**
   * Returns the reference space type.
   *
   * @return {XRReferenceSpaceType} The reference space type.
   */ getReferenceSpaceType() {
        return this._referenceSpaceType;
    }
    /**
   * Sets the reference space type.
   *
   * This method can not be used during a XR session.
   *
   * @param {XRReferenceSpaceType} type - The reference space type.
   */ setReferenceSpaceType(e) {
        this._referenceSpaceType = e, this.isPresenting === !0 && $d7238066c5de7f1c$var$ze("XRManager: Cannot change reference space type while presenting.");
    }
    /**
   * Returns the XR reference space.
   *
   * @return {XRReferenceSpace} The XR reference space.
   */ getReferenceSpace() {
        return this._customReferenceSpace || this._referenceSpace;
    }
    /**
   * Sets a custom XR reference space.
   *
   * @param {XRReferenceSpace} space - The XR reference space.
   */ setReferenceSpace(e) {
        this._customReferenceSpace = e;
    }
    /**
   * Returns the XR camera.
   *
   * @return {ArrayCamera} The XR camera.
   */ getCamera() {
        return this._cameraXR;
    }
    /**
   * Returns the environment blend mode from the current XR session.
   *
   * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
   */ getEnvironmentBlendMode() {
        if (this._session !== null) return this._session.environmentBlendMode;
    }
    /**
   * Returns the current XR binding.
   *
   * Creates a new binding if needed and the browser is
   * capable of doing so.
   *
   * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
   */ getBinding() {
        return this._glBinding === null && this._supportsGlBinding && (this._glBinding = new XRWebGLBinding(this._session, this._gl)), this._glBinding;
    }
    /**
   * Returns the current XR frame.
   *
   * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
   */ getFrame() {
        return this._xrFrame;
    }
    /**
   * Returns `true` if the engine renders to a multiview target.
   *
   * @return {boolean} Whether the engine renders to a multiview render target or not.
   */ useMultiview() {
        return this._useMultiview;
    }
    /**
   * This method can be used in XR applications to create a quadratic layer that presents a separate
   * rendered scene.
   *
   * @param {number} width - The width of the layer plane in world units.
   * @param {number} height - The height of the layer plane in world units.
   * @param {Vector3} translation - The position/translation of the layer plane in world units.
   * @param {Quaternion} quaternion - The orientation of the layer plane expressed as a quaternion.
   * @param {number} pixelwidth - The width of the layer's render target in pixels.
   * @param {number} pixelheight - The height of the layer's render target in pixels.
   * @param {Function} rendercall - A callback function that renders the layer. Similar to code in
   * the default animation loop, this method can be used to update/transform 3D object in the layer's scene.
   * @param {Object} [attributes={}] - Allows to configure the layer's render target.
   * @return {Mesh} A mesh representing the quadratic XR layer. This mesh should be added to the XR scene.
   */ createQuadLayer(e, t, i, n, s, a, o, g = {}) {
        const l = new $d7238066c5de7f1c$var$gL(e, t), c = new $d7238066c5de7f1c$var$By(s, a, {
            format: $d7238066c5de7f1c$var$sg,
            type: $d7238066c5de7f1c$var$Ya,
            depthTexture: new $d7238066c5de7f1c$var$$l(s, a, g.stencil ? $d7238066c5de7f1c$var$sh : $d7238066c5de7f1c$var$Xs, void 0, void 0, void 0, void 0, void 0, void 0, g.stencil ? $d7238066c5de7f1c$var$dI : $d7238066c5de7f1c$var$nu),
            stencilBuffer: g.stencil,
            resolveDepthBuffer: !1,
            resolveStencilBuffer: !1
        });
        c._autoAllocateDepthBuffer = !0;
        const d = new $d7238066c5de7f1c$var$Dd({
            color: 16777215,
            side: $d7238066c5de7f1c$var$nh
        });
        d.map = c.texture, d.map.offset.y = 1, d.map.repeat.y = -1;
        const p = new $d7238066c5de7f1c$var$SI(l, d);
        p.position.copy(i), p.quaternion.copy(n);
        const A = {
            type: "quad",
            width: e,
            height: t,
            translation: i,
            quaternion: n,
            pixelwidth: s,
            pixelheight: a,
            plane: p,
            material: d,
            rendercall: o,
            renderTarget: c
        };
        if (this._layers.push(A), this._session !== null) {
            A.plane.material = new $d7238066c5de7f1c$var$Dd({
                color: 16777215,
                side: $d7238066c5de7f1c$var$nh
            }), A.plane.material.blending = $d7238066c5de7f1c$var$Yy, A.plane.material.blendEquation = $d7238066c5de7f1c$var$Pl, A.plane.material.blendSrc = $d7238066c5de7f1c$var$kd, A.plane.material.blendDst = $d7238066c5de7f1c$var$kd, A.xrlayer = this._createXRLayer(A);
            const y = this._session.renderState.layers;
            y.unshift(A.xrlayer), this._session.updateRenderState({
                layers: y
            });
        } else c.isXRRenderTarget = !1;
        return p;
    }
    /**
   * This method can be used in XR applications to create a cylindrical layer that presents a separate
   * rendered scene.
   *
   * @param {number} radius - The radius of the cylinder in world units.
   * @param {number} centralAngle - The central angle of the cylinder in radians.
   * @param {number} aspectratio - The aspect ratio.
   * @param {Vector3} translation - The position/translation of the layer plane in world units.
   * @param {Quaternion} quaternion - The orientation of the layer plane expressed as a quaternion.
   * @param {number} pixelwidth - The width of the layer's render target in pixels.
   * @param {number} pixelheight - The height of the layer's render target in pixels.
   * @param {Function} rendercall - A callback function that renders the layer. Similar to code in
   * the default animation loop, this method can be used to update/transform 3D object in the layer's scene.
   * @param {Object} [attributes={}] - Allows to configure the layer's render target.
   * @return {Mesh} A mesh representing the cylindrical XR layer. This mesh should be added to the XR scene.
   */ createCylinderLayer(e, t, i, n, s, a, o, g, l = {}) {
        const c = new $d7238066c5de7f1c$var$oL(e, e, e * t / i, 64, 64, !0, Math.PI - t / 2, t), d = new $d7238066c5de7f1c$var$By(a, o, {
            format: $d7238066c5de7f1c$var$sg,
            type: $d7238066c5de7f1c$var$Ya,
            depthTexture: new $d7238066c5de7f1c$var$$l(a, o, l.stencil ? $d7238066c5de7f1c$var$sh : $d7238066c5de7f1c$var$Xs, void 0, void 0, void 0, void 0, void 0, void 0, l.stencil ? $d7238066c5de7f1c$var$dI : $d7238066c5de7f1c$var$nu),
            stencilBuffer: l.stencil,
            resolveDepthBuffer: !1,
            resolveStencilBuffer: !1
        });
        d._autoAllocateDepthBuffer = !0;
        const p = new $d7238066c5de7f1c$var$Dd({
            color: 16777215,
            side: $d7238066c5de7f1c$var$Ka
        });
        p.map = d.texture, p.map.offset.y = 1, p.map.repeat.y = -1;
        const A = new $d7238066c5de7f1c$var$SI(c, p);
        A.position.copy(n), A.quaternion.copy(s);
        const y = {
            type: "cylinder",
            radius: e,
            centralAngle: t,
            aspectratio: i,
            translation: n,
            quaternion: s,
            pixelwidth: a,
            pixelheight: o,
            plane: A,
            material: p,
            rendercall: g,
            renderTarget: d
        };
        if (this._layers.push(y), this._session !== null) {
            y.plane.material = new $d7238066c5de7f1c$var$Dd({
                color: 16777215,
                side: $d7238066c5de7f1c$var$Ka
            }), y.plane.material.blending = $d7238066c5de7f1c$var$Yy, y.plane.material.blendEquation = $d7238066c5de7f1c$var$Pl, y.plane.material.blendSrc = $d7238066c5de7f1c$var$kd, y.plane.material.blendDst = $d7238066c5de7f1c$var$kd, y.xrlayer = this._createXRLayer(y);
            const G = this._session.renderState.layers;
            G.unshift(y.xrlayer), this._session.updateRenderState({
                layers: G
            });
        } else d.isXRRenderTarget = !1;
        return A;
    }
    /**
   * Renders the XR layers that have been previously added to the scene.
   *
   * This method is usually called in your animation loop before rendering
   * the actual scene via `renderer.render( scene, camera );`.
   */ renderLayers() {
        const e = new $d7238066c5de7f1c$var$Ce(), t = new $d7238066c5de7f1c$var$t0(), i = this._renderer, n = this.isPresenting, s = i.getOutputRenderTarget(), a = i._frameBufferTarget;
        this.isPresenting = !1;
        const o = new $d7238066c5de7f1c$var$Ii();
        i.getSize(o);
        const g = i._quad;
        for (const l of this._layers)if (l.renderTarget.isXRRenderTarget = this._session !== null, l.renderTarget._hasExternalTextures = l.renderTarget.isXRRenderTarget, l.renderTarget.isXRRenderTarget && this._sessionUsesLayers) {
            l.xrlayer.transform = new XRRigidTransform(l.plane.getWorldPosition(e), l.plane.getWorldQuaternion(t));
            const c = this._glBinding.getSubImage(l.xrlayer, this._xrFrame);
            i.backend.setXRRenderTargetTextures(l.renderTarget, c.colorTexture, void 0), i._setXRLayerSize(l.renderTarget.width, l.renderTarget.height), i.setOutputRenderTarget(l.renderTarget), i.setRenderTarget(null), i._frameBufferTarget = null, this._frameBufferTargets || (this._frameBufferTargets = /* @__PURE__ */ new WeakMap());
            const { frameBufferTarget: d, quad: p } = this._frameBufferTargets.get(l.renderTarget) || {
                frameBufferTarget: null,
                quad: null
            };
            d ? (i._frameBufferTarget = d, i._quad = p) : (i._quad = new $d7238066c5de7f1c$var$YR(new $d7238066c5de7f1c$var$Bs()), this._frameBufferTargets.set(l.renderTarget, {
                frameBufferTarget: i._getFrameBufferTarget(),
                quad: i._quad
            })), l.rendercall(), i._frameBufferTarget = null;
        } else i.setRenderTarget(l.renderTarget), l.rendercall();
        i.setRenderTarget(null), i.setOutputRenderTarget(s), i._frameBufferTarget = a, i._setXRLayerSize(o.x, o.y), i._quad = g, this.isPresenting = n;
    }
    /**
   * Returns the current XR session.
   *
   * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
   */ getSession() {
        return this._session;
    }
    /**
   * After a XR session has been requested usually with one of the `*Button` modules, it
   * is injected into the renderer with this method. This method triggers the start of
   * the actual XR rendering.
   *
   * @async
   * @param {XRSession} session - The XR session to set.
   * @return {Promise} A Promise that resolves when the session has been set.
   */ async setSession(e) {
        const t = this._renderer, i = t.backend;
        this._gl = t.getContext();
        const n = this._gl, s = n.getContextAttributes();
        if (this._session = e, e !== null) {
            if (i.isWebGPUBackend === !0) throw new Error('THREE.XRManager: XR is currently not supported with a WebGPU backend. Use WebGL by passing "{ forceWebGL: true }" to the constructor of the renderer.');
            if (e.addEventListener("select", this._onSessionEvent), e.addEventListener("selectstart", this._onSessionEvent), e.addEventListener("selectend", this._onSessionEvent), e.addEventListener("squeeze", this._onSessionEvent), e.addEventListener("squeezestart", this._onSessionEvent), e.addEventListener("squeezeend", this._onSessionEvent), e.addEventListener("end", this._onSessionEnd), e.addEventListener("inputsourceschange", this._onInputSourcesChange), await i.makeXRCompatible(), this._currentPixelRatio = t.getPixelRatio(), t.getSize(this._currentSize), this._currentAnimationContext = t._animation.getContext(), this._currentAnimationLoop = t._animation.getAnimationLoop(), t._animation.stop(), this._supportsLayers === !0) {
                let a = null, o = null, g = null;
                t.depth && (g = t.stencil ? n.DEPTH24_STENCIL8 : n.DEPTH_COMPONENT24, a = t.stencil ? $d7238066c5de7f1c$var$dI : $d7238066c5de7f1c$var$nu, o = t.stencil ? $d7238066c5de7f1c$var$sh : $d7238066c5de7f1c$var$Xs);
                const l = {
                    colorFormat: n.RGBA8,
                    depthFormat: g,
                    scaleFactor: this._framebufferScaleFactor,
                    clearOnAccess: !1
                };
                this._useMultiviewIfPossible && t.hasFeature("OVR_multiview2") && (l.textureType = "texture-array", this._useMultiview = !0), this._glBinding = this.getBinding();
                const c = this._glBinding.createProjectionLayer(l), d = [
                    c
                ];
                this._glProjLayer = c, t.setPixelRatio(1), t._setXRLayerSize(c.textureWidth, c.textureHeight);
                const p = this._useMultiview ? 2 : 1, A = new $d7238066c5de7f1c$var$$l(c.textureWidth, c.textureHeight, o, void 0, void 0, void 0, void 0, void 0, void 0, a, p);
                if (this._xrRenderTarget = new $d7238066c5de7f1c$var$By(c.textureWidth, c.textureHeight, {
                    format: $d7238066c5de7f1c$var$sg,
                    type: $d7238066c5de7f1c$var$Ya,
                    colorSpace: t.outputColorSpace,
                    depthTexture: A,
                    stencilBuffer: t.stencil,
                    samples: s.antialias ? 4 : 0,
                    resolveDepthBuffer: c.ignoreDepthValues === !1,
                    resolveStencilBuffer: c.ignoreDepthValues === !1,
                    depth: this._useMultiview ? 2 : 1,
                    multiview: this._useMultiview
                }), this._xrRenderTarget._hasExternalTextures = !0, this._xrRenderTarget.depth = this._useMultiview ? 2 : 1, this._sessionUsesLayers = e.enabledFeatures.includes("layers"), this._referenceSpace = await e.requestReferenceSpace(this.getReferenceSpaceType()), this._sessionUsesLayers) for (const y of this._layers)y.plane.material = new $d7238066c5de7f1c$var$Dd({
                    color: 16777215,
                    side: y.type === "cylinder" ? $d7238066c5de7f1c$var$Ka : $d7238066c5de7f1c$var$nh
                }), y.plane.material.blending = $d7238066c5de7f1c$var$Yy, y.plane.material.blendEquation = $d7238066c5de7f1c$var$Pl, y.plane.material.blendSrc = $d7238066c5de7f1c$var$kd, y.plane.material.blendDst = $d7238066c5de7f1c$var$kd, y.xrlayer = this._createXRLayer(y), d.unshift(y.xrlayer);
                e.updateRenderState({
                    layers: d
                });
            } else {
                const a = {
                    antialias: t.currentSamples > 0,
                    alpha: !0,
                    depth: t.depth,
                    stencil: t.stencil,
                    framebufferScaleFactor: this.getFramebufferScaleFactor()
                }, o = new XRWebGLLayer(e, n, a);
                this._glBaseLayer = o, e.updateRenderState({
                    baseLayer: o
                }), t.setPixelRatio(1), t._setXRLayerSize(o.framebufferWidth, o.framebufferHeight), this._xrRenderTarget = new $d7238066c5de7f1c$var$By(o.framebufferWidth, o.framebufferHeight, {
                    format: $d7238066c5de7f1c$var$sg,
                    type: $d7238066c5de7f1c$var$Ya,
                    colorSpace: t.outputColorSpace,
                    stencilBuffer: t.stencil,
                    resolveDepthBuffer: o.ignoreDepthValues === !1,
                    resolveStencilBuffer: o.ignoreDepthValues === !1
                }), this._xrRenderTarget._isOpaqueFramebuffer = !0, this._referenceSpace = await e.requestReferenceSpace(this.getReferenceSpaceType());
            }
            this.setFoveation(this.getFoveation()), t._animation.setAnimationLoop(this._onAnimationFrame), t._animation.setContext(e), t._animation.start(), this.isPresenting = !0, this.dispatchEvent({
                type: "sessionstart"
            });
        }
    }
    /**
   * This method is called by the renderer per frame and updates the XR camera
   * and it sub cameras based on the given camera. The given camera is the "user"
   * camera created on application level and used for non-XR rendering.
   *
   * @param {PerspectiveCamera} camera - The camera.
   */ updateCamera(e) {
        const t = this._session;
        if (t === null) return;
        const i = e.near, n = e.far, s = this._cameraXR, a = this._cameraL, o = this._cameraR;
        s.near = o.near = a.near = i, s.far = o.far = a.far = n, s.isMultiViewCamera = this._useMultiview, (this._currentDepthNear !== s.near || this._currentDepthFar !== s.far) && (t.updateRenderState({
            depthNear: s.near,
            depthFar: s.far
        }), this._currentDepthNear = s.near, this._currentDepthFar = s.far), s.layers.mask = e.layers.mask | 6, a.layers.mask = s.layers.mask & 3, o.layers.mask = s.layers.mask & 5;
        const g = e.parent, l = s.cameras;
        $d7238066c5de7f1c$var$K9(s, g);
        for(let c = 0; c < l.length; c++)$d7238066c5de7f1c$var$K9(l[c], g);
        l.length === 2 ? $d7238066c5de7f1c$var$Mce(s, a, o) : s.projectionMatrix.copy(a.projectionMatrix), $d7238066c5de7f1c$var$zce(e, s, g);
    }
    /**
   * Returns a WebXR controller for the given controller index.
   *
   * @private
   * @param {number} index - The controller index.
   * @return {WebXRController} The XR controller.
   */ _getController(e) {
        let t = this._controllers[e];
        return t === void 0 && (t = new $d7238066c5de7f1c$var$$$(), this._controllers[e] = t), t;
    }
}
function $d7238066c5de7f1c$var$Mce(r, e, t) {
    $d7238066c5de7f1c$var$L9.setFromMatrixPosition(e.matrixWorld), $d7238066c5de7f1c$var$Y9.setFromMatrixPosition(t.matrixWorld);
    const i = $d7238066c5de7f1c$var$L9.distanceTo($d7238066c5de7f1c$var$Y9), n = e.projectionMatrix.elements, s = t.projectionMatrix.elements, a = n[14] / (n[10] - 1), o = n[14] / (n[10] + 1), g = (n[9] + 1) / n[5], l = (n[9] - 1) / n[5], c = (n[8] - 1) / n[0], d = (s[8] + 1) / s[0], p = a * c, A = a * d, y = i / (-c + d), G = y * -c;
    if (e.matrixWorld.decompose(r.position, r.quaternion, r.scale), r.translateX(G), r.translateZ(y), r.matrixWorld.compose(r.position, r.quaternion, r.scale), r.matrixWorldInverse.copy(r.matrixWorld).invert(), n[10] === -1) r.projectionMatrix.copy(e.projectionMatrix), r.projectionMatrixInverse.copy(e.projectionMatrixInverse);
    else {
        const Z = a + y, v = o + y, V = p - G, H = A + (i - G), N = g * o / v * Z, Y = l * o / v * Z;
        r.projectionMatrix.makePerspective(V, H, N, Y, Z, v), r.projectionMatrixInverse.copy(r.projectionMatrix).invert();
    }
}
function $d7238066c5de7f1c$var$K9(r, e) {
    e === null ? r.matrixWorld.copy(r.matrix) : r.matrixWorld.multiplyMatrices(e.matrixWorld, r.matrix), r.matrixWorldInverse.copy(r.matrixWorld).invert();
}
function $d7238066c5de7f1c$var$zce(r, e, t) {
    t === null ? r.matrix.copy(e.matrixWorld) : (r.matrix.copy(t.matrixWorld), r.matrix.invert(), r.matrix.multiply(e.matrixWorld)), r.matrix.decompose(r.position, r.quaternion, r.scale), r.updateMatrixWorld(!0), r.projectionMatrix.copy(e.projectionMatrix), r.projectionMatrixInverse.copy(e.projectionMatrixInverse), r.isPerspectiveCamera && (r.fov = $d7238066c5de7f1c$var$MA * 2 * Math.atan(1 / r.projectionMatrix.elements[5]), r.zoom = 1);
}
function $d7238066c5de7f1c$var$kce(r) {
    const e = this._controllerInputSources.indexOf(r.inputSource);
    if (e === -1) return;
    const t = this._controllers[e];
    if (t !== void 0) {
        const i = this.getReferenceSpace();
        t.update(r.inputSource, r.frame, i), t.dispatchEvent({
            type: r.type,
            data: r.inputSource
        });
    }
}
function $d7238066c5de7f1c$var$Ece() {
    const r = this._session, e = this._renderer;
    r.removeEventListener("select", this._onSessionEvent), r.removeEventListener("selectstart", this._onSessionEvent), r.removeEventListener("selectend", this._onSessionEvent), r.removeEventListener("squeeze", this._onSessionEvent), r.removeEventListener("squeezestart", this._onSessionEvent), r.removeEventListener("squeezeend", this._onSessionEvent), r.removeEventListener("end", this._onSessionEnd), r.removeEventListener("inputsourceschange", this._onInputSourcesChange);
    for(let t = 0; t < this._controllers.length; t++){
        const i = this._controllerInputSources[t];
        i !== null && (this._controllerInputSources[t] = null, this._controllers[t].disconnect(i));
    }
    if (this._currentDepthNear = null, this._currentDepthFar = null, e._resetXRState(), this._session = null, this._xrRenderTarget = null, this._glBinding = null, this._glBaseLayer = null, this._glProjLayer = null, this._sessionUsesLayers === !0) for (const t of this._layers)t.renderTarget = new $d7238066c5de7f1c$var$By(t.pixelwidth, t.pixelheight, {
        format: $d7238066c5de7f1c$var$sg,
        type: $d7238066c5de7f1c$var$Ya,
        depthTexture: new $d7238066c5de7f1c$var$$l(t.pixelwidth, t.pixelheight, t.stencilBuffer ? $d7238066c5de7f1c$var$sh : $d7238066c5de7f1c$var$Xs, void 0, void 0, void 0, void 0, void 0, void 0, t.stencilBuffer ? $d7238066c5de7f1c$var$dI : $d7238066c5de7f1c$var$nu),
        stencilBuffer: t.stencilBuffer,
        resolveDepthBuffer: !1,
        resolveStencilBuffer: !1
    }), t.renderTarget.isXRRenderTarget = !1, t.plane.material = t.material, t.material.map = t.renderTarget.texture, t.material.map.offset.y = 1, t.material.map.repeat.y = -1, delete t.xrlayer;
    this.isPresenting = !1, this._useMultiview = !1, e._animation.stop(), e._animation.setAnimationLoop(this._currentAnimationLoop), e._animation.setContext(this._currentAnimationContext), e._animation.start(), e.setPixelRatio(this._currentPixelRatio), e.setSize(this._currentSize.width, this._currentSize.height, !1), this.dispatchEvent({
        type: "sessionend"
    });
}
function $d7238066c5de7f1c$var$Jce(r) {
    const e = this._controllers, t = this._controllerInputSources;
    for(let i = 0; i < r.removed.length; i++){
        const n = r.removed[i], s = t.indexOf(n);
        s >= 0 && (t[s] = null, e[s].disconnect(n));
    }
    for(let i = 0; i < r.added.length; i++){
        const n = r.added[i];
        let s = t.indexOf(n);
        if (s === -1) {
            for(let o = 0; o < e.length; o++)if (o >= t.length) {
                t.push(n), s = o;
                break;
            } else if (t[o] === null) {
                t[o] = n, s = o;
                break;
            }
            if (s === -1) break;
        }
        const a = e[s];
        a && a.connect(n);
    }
}
function $d7238066c5de7f1c$var$Uce(r) {
    return r.type === "quad" ? this._glBinding.createQuadLayer({
        transform: new XRRigidTransform(r.translation, r.quaternion),
        width: r.width / 2,
        height: r.height / 2,
        space: this._referenceSpace,
        viewPixelWidth: r.pixelwidth,
        viewPixelHeight: r.pixelheight,
        clearOnAccess: !1
    }) : this._glBinding.createCylinderLayer({
        transform: new XRRigidTransform(r.translation, r.quaternion),
        radius: r.radius,
        centralAngle: r.centralAngle,
        aspectRatio: r.aspectRatio,
        space: this._referenceSpace,
        viewPixelWidth: r.pixelwidth,
        viewPixelHeight: r.pixelheight,
        clearOnAccess: !1
    });
}
function $d7238066c5de7f1c$var$Dce(r, e) {
    if (e === void 0) return;
    const t = this._cameraXR, i = this._renderer, n = i.backend, s = this._glBaseLayer, a = this.getReferenceSpace(), o = e.getViewerPose(a);
    if (this._xrFrame = e, o !== null) {
        const g = o.views;
        this._glBaseLayer !== null && n.setXRTarget(s.framebuffer);
        let l = !1;
        g.length !== t.cameras.length && (t.cameras.length = 0, l = !0);
        for(let c = 0; c < g.length; c++){
            const d = g[c];
            let p;
            if (this._supportsLayers === !0) {
                const y = this._glBinding.getViewSubImage(this._glProjLayer, d);
                p = y.viewport, c === 0 && n.setXRRenderTargetTextures(this._xrRenderTarget, y.colorTexture, this._glProjLayer.ignoreDepthValues && !this._useMultiview ? void 0 : y.depthStencilTexture);
            } else p = s.getViewport(d);
            let A = this._cameras[c];
            A === void 0 && (A = new $d7238066c5de7f1c$var$tg(), A.layers.enable(c), A.viewport = new $d7238066c5de7f1c$var$Gi(), this._cameras[c] = A), A.matrix.fromArray(d.transform.matrix), A.matrix.decompose(A.position, A.quaternion, A.scale), A.projectionMatrix.fromArray(d.projectionMatrix), A.projectionMatrixInverse.copy(A.projectionMatrix).invert(), A.viewport.set(p.x, p.y, p.width, p.height), c === 0 && (t.matrix.copy(A.matrix), t.matrix.decompose(t.position, t.quaternion, t.scale)), l === !0 && t.cameras.push(A);
        }
        i.setOutputRenderTarget(this._xrRenderTarget);
    }
    for(let g = 0; g < this._controllers.length; g++){
        const l = this._controllerInputSources[g], c = this._controllers[g];
        l !== null && c !== void 0 && c.update(l, e, a);
    }
    this._currentAnimationLoop && this._currentAnimationLoop(r, e), e.detectedPlanes && this.dispatchEvent({
        type: "planesdetected",
        data: e
    }), this._xrFrame = null;
}
class $d7238066c5de7f1c$var$_ce extends $d7238066c5de7f1c$var$wI {
    /**
   * Constructs a new CanvasTarget.
   *
   * @param {HTMLCanvasElement|OffscreenCanvas} domElement - The canvas element to render to.
   */ constructor(e){
        super(), this.domElement = e, this._pixelRatio = 1, this._width = this.domElement.width, this._height = this.domElement.height, this._viewport = new $d7238066c5de7f1c$var$Gi(0, 0, this._width, this._height), this._scissor = new $d7238066c5de7f1c$var$Gi(0, 0, this._width, this._height), this._scissorTest = !1, this.colorTexture = new $d7238066c5de7f1c$var$aL(), this.depthTexture = new $d7238066c5de7f1c$var$$l();
    }
    /**
   * Returns the pixel ratio.
   *
   * @return {number} The pixel ratio.
   */ getPixelRatio() {
        return this._pixelRatio;
    }
    /**
   * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
   *
   * @param {Vector2} target - The method writes the result in this target object.
   * @return {Vector2} The drawing buffer size.
   */ getDrawingBufferSize(e) {
        return e.set(this._width * this._pixelRatio, this._height * this._pixelRatio).floor();
    }
    /**
   * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
   *
   * @param {Vector2} target - The method writes the result in this target object.
   * @return {Vector2} The renderer's size in logical pixels.
   */ getSize(e) {
        return e.set(this._width, this._height);
    }
    /**
   * Sets the given pixel ratio and resizes the canvas if necessary.
   *
   * @param {number} [value=1] - The pixel ratio.
   */ setPixelRatio(e = 1) {
        this._pixelRatio !== e && (this._pixelRatio = e, this.setSize(this._width, this._height, !1));
    }
    /**
   * This method allows to define the drawing buffer size by specifying
   * width, height and pixel ratio all at once. The size of the drawing
   * buffer is computed with this formula:
   * ```js
   * size.x = width * pixelRatio;
   * size.y = height * pixelRatio;
   * ```
   *
   * @param {number} width - The width in logical pixels.
   * @param {number} height - The height in logical pixels.
   * @param {number} pixelRatio - The pixel ratio.
   */ setDrawingBufferSize(e, t, i) {
        this.xr && this.xr.isPresenting || (this._width = e, this._height = t, this._pixelRatio = i, this.domElement.width = Math.floor(e * i), this.domElement.height = Math.floor(t * i), this.setViewport(0, 0, e, t), this._dispatchResize());
    }
    /**
   * Sets the size of the renderer.
   *
   * @param {number} width - The width in logical pixels.
   * @param {number} height - The height in logical pixels.
   * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
   */ setSize(e, t, i = !0) {
        this.xr && this.xr.isPresenting || (this._width = e, this._height = t, this.domElement.width = Math.floor(e * this._pixelRatio), this.domElement.height = Math.floor(t * this._pixelRatio), i === !0 && (this.domElement.style.width = e + "px", this.domElement.style.height = t + "px"), this.setViewport(0, 0, e, t), this._dispatchResize());
    }
    /**
   * Returns the scissor rectangle.
   *
   * @param {Vector4} target - The method writes the result in this target object.
   * @return {Vector4} The scissor rectangle.
   */ getScissor(e) {
        const t = this._scissor;
        return e.x = t.x, e.y = t.y, e.width = t.width, e.height = t.height, e;
    }
    /**
   * Defines the scissor rectangle.
   *
   * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
   * Instead of passing four arguments, the method also works with a single four-dimensional vector.
   * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
   * @param {number} width - The width of the scissor box in logical pixel unit.
   * @param {number} height - The height of the scissor box in logical pixel unit.
   */ setScissor(e, t, i, n) {
        const s = this._scissor;
        e.isVector4 ? s.copy(e) : s.set(e, t, i, n);
    }
    /**
   * Returns the scissor test value.
   *
   * @return {boolean} Whether the scissor test should be enabled or not.
   */ getScissorTest() {
        return this._scissorTest;
    }
    /**
   * Defines the scissor test.
   *
   * @param {boolean} boolean - Whether the scissor test should be enabled or not.
   */ setScissorTest(e) {
        this._scissorTest = e;
    }
    /**
   * Returns the viewport definition.
   *
   * @param {Vector4} target - The method writes the result in this target object.
   * @return {Vector4} The viewport definition.
   */ getViewport(e) {
        return e.copy(this._viewport);
    }
    /**
   * Defines the viewport.
   *
   * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
   * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
   * @param {number} width - The width of the viewport in logical pixel unit.
   * @param {number} height - The height of the viewport in logical pixel unit.
   * @param {number} minDepth - The minimum depth value of the viewport. WebGPU only.
   * @param {number} maxDepth - The maximum depth value of the viewport. WebGPU only.
   */ setViewport(e, t, i, n, s = 0, a = 1) {
        const o = this._viewport;
        e.isVector4 ? o.copy(e) : o.set(e, t, i, n), o.minDepth = s, o.maxDepth = a;
    }
    /**
   * Dispatches the resize event.
   *
   * @private
   */ _dispatchResize() {
        this.dispatchEvent({
            type: "resize"
        });
    }
    /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */ dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $d7238066c5de7f1c$var$x9 = /* @__PURE__ */ new $d7238066c5de7f1c$var$iL(), $d7238066c5de7f1c$var$Em = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ii(), $d7238066c5de7f1c$var$XH = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi(), $d7238066c5de7f1c$var$NH = /* @__PURE__ */ new $d7238066c5de7f1c$var$sL(), $d7238066c5de7f1c$var$LH = /* @__PURE__ */ new $d7238066c5de7f1c$var$rL(), $d7238066c5de7f1c$var$_v = /* @__PURE__ */ new $d7238066c5de7f1c$var$Ji(), $d7238066c5de7f1c$var$qu = /* @__PURE__ */ new $d7238066c5de7f1c$var$Gi();
class $d7238066c5de7f1c$var$Pce {
    /**
   * Renderer options.
   *
   * @typedef {Object} Renderer~Options
   * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. This parameter can set to any other integer value than 0
   * to overwrite the default.
   * @property {?Function} [getFallback=null] - This callback function can be used to provide a fallback backend, if the primary backend can't be targeted.
   * @property {number} [colorBufferType=HalfFloatType] - Defines the type of color buffers. The default `HalfFloatType` is recommend for best
   * quality. To save memory and bandwidth, `UnsignedByteType` might be used. This will reduce rendering quality though.
   * @property {boolean} [multiview=false] - If set to `true`, the renderer will use multiview during WebXR rendering if supported.
   */ /**
  	 * Constructs a new renderer.
  	 *
  	 * @param {Backend} backend - The backend the renderer is targeting (e.g. WebGPU or WebGL 2).
  	 * @param {Renderer~Options} [parameters] - The configuration parameter.
  
  	 */ constructor(e, t = {}){
        this.isRenderer = !0;
        const { logarithmicDepthBuffer: i = !1, alpha: n = !0, depth: s = !0, stencil: a = !1, antialias: o = !1, samples: g = 0, getFallback: l = null, colorBufferType: c = $d7238066c5de7f1c$var$Ia, multiview: d = !1 } = t;
        this.backend = e, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.alpha = n, this.logarithmicDepthBuffer = i, this.outputColorSpace = $d7238066c5de7f1c$var$$o, this.toneMapping = $d7238066c5de7f1c$var$VC, this.toneMappingExposure = 1, this.sortObjects = !0, this.depth = s, this.stencil = a, this.info = new $d7238066c5de7f1c$var$Ose(), this.overrideNodes = {
            modelViewMatrix: null,
            modelNormalViewMatrix: null
        }, this.library = new $d7238066c5de7f1c$var$_D(), this.lighting = new $d7238066c5de7f1c$var$Fce(), this._samples = g || o === !0 ? 4 : 0, this._onCanvasTargetResize = this._onCanvasTargetResize.bind(this), this._canvasTarget = new $d7238066c5de7f1c$var$_ce(e.getDomElement()), this._canvasTarget.addEventListener("resize", this._onCanvasTargetResize), this._canvasTarget.isDefaultCanvasTarget = !0, this._inspector = new $d7238066c5de7f1c$var$sJ(), this._inspector.setRenderer(this), this._getFallback = l, this._attributes = null, this._geometries = null, this._nodes = null, this._animation = null, this._bindings = null, this._objects = null, this._pipelines = null, this._bundles = null, this._renderLists = null, this._renderContexts = null, this._textures = null, this._background = null, this._quad = new $d7238066c5de7f1c$var$YR(new $d7238066c5de7f1c$var$Bs()), this._quad.name = "Output Color Transform", this._quad.material.name = "outputColorTransform", this._currentRenderContext = null, this._opaqueSort = null, this._transparentSort = null, this._frameBufferTarget = null;
        const p = this.alpha === !0 ? 0 : 1;
        this._clearColor = new $d7238066c5de7f1c$var$fY(0, 0, 0, p), this._clearDepth = 1, this._clearStencil = 0, this._renderTarget = null, this._activeCubeFace = 0, this._activeMipmapLevel = 0, this._outputRenderTarget = null, this._mrt = null, this._renderObjectFunction = null, this._currentRenderObjectFunction = null, this._currentRenderBundle = null, this._handleObjectFunction = this._renderObjectDirect, this._isDeviceLost = !1, this.onDeviceLost = this._onDeviceLost, this._colorBufferType = c, this._cacheShadowNodes = /* @__PURE__ */ new WeakMap(), this._initialized = !1, this._initPromise = null, this._compilationPromises = null, this.transparent = !0, this.opaque = !0, this.shadowMap = {
            enabled: !1,
            type: $d7238066c5de7f1c$var$L6
        }, this.xr = new $d7238066c5de7f1c$var$Tce(this, d), this.debug = {
            checkShaderErrors: !0,
            onShaderError: null,
            getShaderAsync: async (A, y, G)=>{
                await this.compileAsync(A, y);
                const Z = this._renderLists.get(A, y), v = this._renderContexts.get(A, y, this._renderTarget), V = A.overrideMaterial || G.material, H = this._objects.get(G, V, A, y, Z.lightsNode, v, v.clippingContext), { fragmentShader: N, vertexShader: Y } = H.getNodeBuilderState();
                return {
                    fragmentShader: N,
                    vertexShader: Y
                };
            }
        };
    }
    /**
   * Initializes the renderer so it is ready for usage.
   *
   * @async
   * @return {Promise<this>} A Promise that resolves when the renderer has been initialized.
   */ async init() {
        return this._initPromise !== null ? this._initPromise : (this._initPromise = new Promise(async (e, t)=>{
            let i = this.backend;
            try {
                await i.init(this);
            } catch (n) {
                if (this._getFallback !== null) try {
                    this.backend = i = this._getFallback(n), await i.init(this);
                } catch (s) {
                    t(s);
                    return;
                }
                else {
                    t(n);
                    return;
                }
            }
            this._nodes = new $d7238066c5de7f1c$var$Lce(this, i), this._animation = new $d7238066c5de7f1c$var$zse(this, this._nodes, this.info), this._attributes = new $d7238066c5de7f1c$var$Pse(i), this._background = new $d7238066c5de7f1c$var$Qle(this, this._nodes), this._geometries = new $d7238066c5de7f1c$var$Qse(this._attributes, this.info), this._textures = new $d7238066c5de7f1c$var$ure(this, i, this.info), this._pipelines = new $d7238066c5de7f1c$var$ere(i, this._nodes), this._bindings = new $d7238066c5de7f1c$var$tre(i, this._nodes, this._textures, this._attributes, this._pipelines, this.info), this._objects = new $d7238066c5de7f1c$var$Use(this, this._nodes, this._geometries, this._pipelines, this._bindings, this.info), this._renderLists = new $d7238066c5de7f1c$var$sre(this.lighting), this._bundles = new $d7238066c5de7f1c$var$Kce(), this._renderContexts = new $d7238066c5de7f1c$var$lre(), this._animation.start(), this._initialized = !0, this._inspector.init(), e(this);
        }), this._initPromise);
    }
    /**
   * A reference to the canvas element the renderer is drawing to.
   * This value of this property will automatically be created by
   * the renderer.
   *
   * @type {HTMLCanvasElement|OffscreenCanvas}
   */ get domElement() {
        return this._canvasTarget.domElement;
    }
    /**
   * The coordinate system of the renderer. The value of this property
   * depends on the selected backend. Either `THREE.WebGLCoordinateSystem` or
   * `THREE.WebGPUCoordinateSystem`.
   *
   * @readonly
   * @type {number}
   */ get coordinateSystem() {
        return this.backend.coordinateSystem;
    }
    /**
   * Compiles all materials in the given scene. This can be useful to avoid a
   * phenomenon which is called "shader compilation stutter", which occurs when
   * rendering an object with a new shader for the first time.
   *
   * If you want to add a 3D object to an existing scene, use the third optional
   * parameter for applying the target scene. Note that the (target) scene's lighting
   * and environment must be configured before calling this method.
   *
   * @async
   * @param {Object3D} scene - The scene or 3D object to precompile.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {?Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
   * @return {Promise<Array|undefined>} A Promise that resolves when the compile has been finished.
   */ async compileAsync(e, t, i = null) {
        if (this._isDeviceLost === !0) return;
        this._initialized === !1 && await this.init();
        const n = this._nodes.nodeFrame, s = n.renderId, a = this._currentRenderContext, o = this._currentRenderObjectFunction, g = this._compilationPromises, l = e.isScene === !0 ? e : $d7238066c5de7f1c$var$x9;
        i === null && (i = e);
        const c = this._renderTarget, d = this._renderContexts.get(i, t, c), p = this._activeMipmapLevel, A = [];
        this._currentRenderContext = d, this._currentRenderObjectFunction = this.renderObject, this._handleObjectFunction = this._createObjectPipeline, this._compilationPromises = A, n.renderId++, n.update(), d.depth = this.depth, d.stencil = this.stencil, d.clippingContext || (d.clippingContext = new $d7238066c5de7f1c$var$TZ()), d.clippingContext.updateGlobal(l, t), l.onBeforeRender(this, e, t, c);
        const y = this._renderLists.get(e, t);
        if (y.begin(), this._projectObject(e, t, 0, y, d.clippingContext), i !== e && i.traverseVisible(function(H) {
            H.isLight && H.layers.test(t.layers) && y.pushLight(H);
        }), y.finish(), c !== null) {
            this._textures.updateRenderTarget(c, p);
            const H = this._textures.get(c);
            d.textures = H.textures, d.depthTexture = H.depthTexture;
        } else d.textures = null, d.depthTexture = null;
        this._background.update(l, y, d);
        const G = y.opaque, Z = y.transparent, v = y.transparentDoublePass, V = y.lightsNode;
        this.opaque === !0 && G.length > 0 && this._renderObjects(G, t, l, V), this.transparent === !0 && Z.length > 0 && this._renderTransparents(Z, v, t, l, V), n.renderId = s, this._currentRenderContext = a, this._currentRenderObjectFunction = o, this._compilationPromises = g, this._handleObjectFunction = this._renderObjectDirect, await Promise.all(A);
    }
    /**
   * Renders the scene in an async fashion.
   *
   * @async
   * @deprecated
   * @param {Object3D} scene - The scene or 3D object to render.
   * @param {Camera} camera - The camera.
   * @return {Promise} A Promise that resolves when the render has been finished.
   */ async renderAsync(e, t) {
        $d7238066c5de7f1c$var$es('Renderer: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'), await this.init(), this.render(e, t);
    }
    /**
   * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
   * the CPU waits for the GPU to complete its operation (e.g. a compute task).
   *
   * @async
   * @deprecated
   * @return {Promise} A Promise that resolves when synchronization has been finished.
   */ async waitForGPU() {
        $d7238066c5de7f1c$var$nt("Renderer: waitForGPU() has been removed. Read https://github.com/mrdoob/three.js/issues/32012 for more information.");
    }
    //
    /**
   * Sets the inspector instance. The inspector can be any class that extends from `InspectorBase`.
   *
   * @param {InspectorBase} value - The new inspector.
   */ set inspector(e) {
        this._inspector !== null && this._inspector.setRenderer(null), this._inspector = e, this._inspector.setRenderer(this);
    }
    get inspector() {
        return this._inspector;
    }
    /**
   * Enables or disables high precision for model-view and normal-view matrices.
   * When enabled, will use CPU 64-bit precision for higher precision instead of GPU 32-bit for higher performance.
   *
   * NOTE: 64-bit precision is not compatible with `InstancedMesh` and `SkinnedMesh`.
   *
   * @param {boolean} value - Whether to enable or disable high precision.
   * @type {boolean}
   */ set highPrecision(e) {
        e === !0 ? (this.overrideNodes.modelViewMatrix = $d7238066c5de7f1c$var$N2, this.overrideNodes.modelNormalViewMatrix = $d7238066c5de7f1c$var$L2) : this.highPrecision && (this.overrideNodes.modelViewMatrix = null, this.overrideNodes.modelNormalViewMatrix = null);
    }
    /**
   * Returns whether high precision is enabled or not.
   *
   * @return {boolean} Whether high precision is enabled or not.
   * @type {boolean}
   */ get highPrecision() {
        return this.overrideNodes.modelViewMatrix === $d7238066c5de7f1c$var$N2 && this.overrideNodes.modelNormalViewMatrix === $d7238066c5de7f1c$var$L2;
    }
    /**
   * Sets the given MRT configuration.
   *
   * @param {MRTNode} mrt - The MRT node to set.
   * @return {Renderer} A reference to this renderer.
   */ setMRT(e) {
        return this._mrt = e, this;
    }
    /**
   * Returns the MRT configuration.
   *
   * @return {MRTNode} The MRT configuration.
   */ getMRT() {
        return this._mrt;
    }
    /**
   * Returns the color buffer type.
   *
   * @return {number} The color buffer type.
   */ getColorBufferType() {
        return this._colorBufferType;
    }
    /**
   * Default implementation of the device lost callback.
   *
   * @private
   * @param {Object} info - Information about the context lost.
   */ _onDeviceLost(e) {
        let t = `THREE.WebGPURenderer: ${e.api} Device Lost:

Message: ${e.message}`;
        e.reason && (t += `
Reason: ${e.reason}`), $d7238066c5de7f1c$var$nt(t), this._isDeviceLost = !0;
    }
    /**
   * Renders the given render bundle.
   *
   * @private
   * @param {Object} bundle - Render bundle data.
   * @param {Scene} sceneRef - The scene the render bundle belongs to.
   * @param {LightsNode} lightsNode - The lights node.
   */ _renderBundle(e, t, i) {
        const { bundleGroup: n, camera: s, renderList: a } = e, o = this._currentRenderContext, g = this._bundles.get(n, s), l = this.backend.get(g);
        l.renderContexts === void 0 && (l.renderContexts = /* @__PURE__ */ new Set());
        const c = n.version !== l.version, d = l.renderContexts.has(o) === !1 || c;
        if (l.renderContexts.add(o), d) {
            this.backend.beginBundle(o), (l.renderObjects === void 0 || c) && (l.renderObjects = []), this._currentRenderBundle = g;
            const { transparentDoublePass: p, transparent: A, opaque: y } = a;
            this.opaque === !0 && y.length > 0 && this._renderObjects(y, s, t, i), this.transparent === !0 && A.length > 0 && this._renderTransparents(A, p, s, t, i), this._currentRenderBundle = null, this.backend.finishBundle(o, g), l.version = n.version;
        } else {
            const { renderObjects: p } = l;
            for(let A = 0, y = p.length; A < y; A++){
                const G = p[A];
                this._nodes.needsRefresh(G) && (this._nodes.updateBefore(G), this._nodes.updateForRender(G), this._bindings.updateForRender(G), this._nodes.updateAfter(G));
            }
        }
        this.backend.addBundle(o, g);
    }
    /**
   * Renders the scene or 3D object with the given camera. This method can only be called
   * if the renderer has been initialized. When using `render()` inside an animation loop,
   * it's guaranteed the renderer will be initialized. The animation loop must be defined
   * with {@link Renderer#setAnimationLoop} though.
   *
   * For all other use cases (like when using on-demand rendering), you must call
   * {@link Renderer#init} before rendering.
   *
   * The target of the method is the default framebuffer (meaning the canvas)
   * or alternatively a render target when specified via `setRenderTarget()`.
   *
   * @param {Object3D} scene - The scene or 3D object to render.
   * @param {Camera} camera - The camera to render the scene with.
   */ render(e, t) {
        if (this._initialized === !1) throw new Error('Renderer: .render() called before the backend is initialized. Use "await renderer.init();" before rendering.');
        this._renderScene(e, t);
    }
    /**
   * Returns whether the renderer has been initialized or not.
   *
   * @readonly
   * @return {boolean} Whether the renderer has been initialized or not.
   */ get initialized() {
        return this._initialized;
    }
    /**
   * Returns an internal render target which is used when computing the output tone mapping
   * and color space conversion. Unlike in `WebGLRenderer`, this is done in a separate render
   * pass and not inline to achieve more correct results.
   *
   * @private
   * @return {?RenderTarget} The render target. The method returns `null` if no output conversion should be applied.
   */ _getFrameBufferTarget() {
        const { currentToneMapping: e, currentColorSpace: t } = this, i = e !== $d7238066c5de7f1c$var$VC, n = t !== $d7238066c5de7f1c$var$sn.workingColorSpace;
        if (i === !1 && n === !1) return null;
        const { width: s, height: a } = this.getDrawingBufferSize($d7238066c5de7f1c$var$Em), { depth: o, stencil: g } = this;
        let l = this._frameBufferTarget;
        l === null && (l = new $d7238066c5de7f1c$var$WI(s, a, {
            depthBuffer: o,
            stencilBuffer: g,
            type: this._colorBufferType,
            format: $d7238066c5de7f1c$var$sg,
            colorSpace: $d7238066c5de7f1c$var$sn.workingColorSpace,
            generateMipmaps: !1,
            minFilter: $d7238066c5de7f1c$var$ro,
            magFilter: $d7238066c5de7f1c$var$ro,
            samples: this.samples
        }), l.isPostProcessingRenderTarget = !0, this._frameBufferTarget = l);
        const c = this.getOutputRenderTarget();
        l.depthBuffer = o, l.stencilBuffer = g, c !== null ? l.setSize(c.width, c.height, c.depth) : l.setSize(s, a, 1);
        const d = this._canvasTarget;
        return l.viewport.copy(d._viewport), l.scissor.copy(d._scissor), l.viewport.multiplyScalar(d._pixelRatio), l.scissor.multiplyScalar(d._pixelRatio), l.scissorTest = d._scissorTest, l.multiview = c !== null ? c.multiview : !1, l.resolveDepthBuffer = c !== null ? c.resolveDepthBuffer : !0, l._autoAllocateDepthBuffer = c !== null ? c._autoAllocateDepthBuffer : !1, l;
    }
    /**
   * Renders the scene or 3D object with the given camera.
   *
   * @private
   * @param {Object3D} scene - The scene or 3D object to render.
   * @param {Camera} camera - The camera to render the scene with.
   * @param {boolean} [useFrameBufferTarget=true] - Whether to use a framebuffer target or not.
   * @return {RenderContext} The current render context.
   */ _renderScene(e, t, i = !0) {
        if (this._isDeviceLost === !0) return;
        const n = i ? this._getFrameBufferTarget() : null, s = this._nodes.nodeFrame, a = s.renderId, o = this._currentRenderContext, g = this._currentRenderObjectFunction, l = e.isScene === !0 ? e : $d7238066c5de7f1c$var$x9, c = this._renderTarget || this._outputRenderTarget, d = this._activeCubeFace, p = this._activeMipmapLevel;
        let A;
        n !== null ? (A = n, this.setRenderTarget(A)) : A = c;
        const y = this._renderContexts.get(e, t, A);
        this._currentRenderContext = y, this._currentRenderObjectFunction = this._renderObjectFunction || this.renderObject, this.info.calls++, this.info.render.calls++, this.info.render.frameCalls++, s.renderId = this.info.calls, this.backend.updateTimeStampUID(y), this.inspector.beginRender(this.backend.getTimestampUID(y), e, t, A);
        const G = this.coordinateSystem, Z = this.xr;
        if (t.coordinateSystem !== G && Z.isPresenting === !1 && (t.coordinateSystem = G, t.updateProjectionMatrix(), t.isArrayCamera)) for (const ce of t.cameras)ce.coordinateSystem = G, ce.updateProjectionMatrix();
        e.matrixWorldAutoUpdate === !0 && e.updateMatrixWorld(), t.parent === null && t.matrixWorldAutoUpdate === !0 && t.updateMatrixWorld(), Z.enabled === !0 && Z.isPresenting === !0 && (Z.cameraAutoUpdate === !0 && Z.updateCamera(t), t = Z.getCamera());
        const v = this._canvasTarget;
        let V = v._viewport, H = v._scissor, N = v._pixelRatio;
        A !== null && (V = A.viewport, H = A.scissor, N = 1), this.getDrawingBufferSize($d7238066c5de7f1c$var$Em), $d7238066c5de7f1c$var$XH.set(0, 0, $d7238066c5de7f1c$var$Em.width, $d7238066c5de7f1c$var$Em.height);
        const Y = V.minDepth === void 0 ? 0 : V.minDepth, K = V.maxDepth === void 0 ? 1 : V.maxDepth;
        y.viewportValue.copy(V).multiplyScalar(N).floor(), y.viewportValue.width >>= p, y.viewportValue.height >>= p, y.viewportValue.minDepth = Y, y.viewportValue.maxDepth = K, y.viewport = y.viewportValue.equals($d7238066c5de7f1c$var$XH) === !1, y.scissorValue.copy(H).multiplyScalar(N).floor(), y.scissor = v._scissorTest && y.scissorValue.equals($d7238066c5de7f1c$var$XH) === !1, y.scissorValue.width >>= p, y.scissorValue.height >>= p, y.clippingContext || (y.clippingContext = new $d7238066c5de7f1c$var$TZ()), y.clippingContext.updateGlobal(l, t), l.onBeforeRender(this, e, t, A);
        const z = t.isArrayCamera ? $d7238066c5de7f1c$var$LH : $d7238066c5de7f1c$var$NH;
        t.isArrayCamera || ($d7238066c5de7f1c$var$_v.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), z.setFromProjectionMatrix($d7238066c5de7f1c$var$_v, t.coordinateSystem, t.reversedDepth));
        const M = this._renderLists.get(e, t);
        if (M.begin(), this._projectObject(e, t, 0, M, y.clippingContext), M.finish(), this.sortObjects === !0 && M.sort(this._opaqueSort, this._transparentSort), A !== null) {
            this._textures.updateRenderTarget(A, p);
            const ce = this._textures.get(A);
            y.textures = ce.textures, y.depthTexture = ce.depthTexture, y.width = ce.width, y.height = ce.height, y.renderTarget = A, y.depth = A.depthBuffer, y.stencil = A.stencilBuffer;
        } else y.textures = null, y.depthTexture = null, y.width = $d7238066c5de7f1c$var$Em.width, y.height = $d7238066c5de7f1c$var$Em.height, y.depth = this.depth, y.stencil = this.stencil;
        y.width >>= p, y.height >>= p, y.activeCubeFace = d, y.activeMipmapLevel = p, y.occlusionQueryCount = M.occlusionQueryCount, y.scissorValue.max($d7238066c5de7f1c$var$qu.set(0, 0, 0, 0)), y.scissorValue.x + y.scissorValue.width > y.width && (y.scissorValue.width = Math.max(y.width - y.scissorValue.x, 0)), y.scissorValue.y + y.scissorValue.height > y.height && (y.scissorValue.height = Math.max(y.height - y.scissorValue.y, 0)), this._background.update(l, M, y), y.camera = t, this.backend.beginRender(y);
        const { bundles: _, lightsNode: O, transparentDoublePass: ie, transparent: he, opaque: pe } = M;
        return _.length > 0 && this._renderBundles(_, l, O), this.opaque === !0 && pe.length > 0 && this._renderObjects(pe, t, l, O), this.transparent === !0 && he.length > 0 && this._renderTransparents(he, ie, t, l, O), this.backend.finishRender(y), s.renderId = a, this._currentRenderContext = o, this._currentRenderObjectFunction = g, n !== null && (this.setRenderTarget(c, d, p), this._renderOutput(A)), l.onAfterRender(this, e, t, A), this.inspector.finishRender(this.backend.getTimestampUID(y)), y;
    }
    _setXRLayerSize(e, t) {
        this._canvasTarget._width = e, this._canvasTarget._height = t, this.setViewport(0, 0, e, t);
    }
    /**
   * The output pass performs tone mapping and color space conversion.
   *
   * @private
   * @param {RenderTarget} renderTarget - The current render target.
   */ _renderOutput(e) {
        const t = this._quad;
        this._nodes.hasOutputChange(e.texture) && (t.material.fragmentNode = this._nodes.getOutputNode(e.texture), t.material.needsUpdate = !0);
        const i = this.autoClear, n = this.xr.enabled;
        this.autoClear = !1, this.xr.enabled = !1, this._renderScene(t, t.camera, !1), this.autoClear = i, this.xr.enabled = n;
    }
    /**
   * Returns the maximum available anisotropy for texture filtering.
   *
   * @return {number} The maximum available anisotropy.
   */ getMaxAnisotropy() {
        return this.backend.getMaxAnisotropy();
    }
    /**
   * Returns the active cube face.
   *
   * @return {number} The active cube face.
   */ getActiveCubeFace() {
        return this._activeCubeFace;
    }
    /**
   * Returns the active mipmap level.
   *
   * @return {number} The active mipmap level.
   */ getActiveMipmapLevel() {
        return this._activeMipmapLevel;
    }
    /**
   * Applications are advised to always define the animation loop
   * with this method and not manually with `requestAnimationFrame()`
   * for best compatibility.
   *
   * @async
   * @param {?onAnimationCallback} callback - The application's animation loop.
   * @return {Promise} A Promise that resolves when the set has been executed.
   */ async setAnimationLoop(e) {
        this._initialized === !1 && await this.init(), this._animation.setAnimationLoop(e);
    }
    /**
   * Returns the current animation loop callback.
   *
   * @return {?Function} The current animation loop callback.
   */ getAnimationLoop() {
        return this._animation.getAnimationLoop();
    }
    /**
   * Can be used to transfer buffer data from a storage buffer attribute
   * from the GPU to the CPU in context of compute shaders.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */ async getArrayBufferAsync(e) {
        return await this.backend.getArrayBufferAsync(e);
    }
    /**
   * Returns the rendering context.
   *
   * @return {GPUCanvasContext|WebGL2RenderingContext} The rendering context.
   */ getContext() {
        return this.backend.getContext();
    }
    /**
   * Returns the pixel ratio.
   *
   * @return {number} The pixel ratio.
   */ getPixelRatio() {
        return this._canvasTarget.getPixelRatio();
    }
    /**
   * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
   *
   * @param {Vector2} target - The method writes the result in this target object.
   * @return {Vector2} The drawing buffer size.
   */ getDrawingBufferSize(e) {
        return this._canvasTarget.getDrawingBufferSize(e);
    }
    /**
   * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
   *
   * @param {Vector2} target - The method writes the result in this target object.
   * @return {Vector2} The renderer's size in logical pixels.
   */ getSize(e) {
        return this._canvasTarget.getSize(e);
    }
    /**
   * Sets the given pixel ratio and resizes the canvas if necessary.
   *
   * @param {number} [value=1] - The pixel ratio.
   */ setPixelRatio(e = 1) {
        this._canvasTarget.setPixelRatio(e);
    }
    /**
   * This method allows to define the drawing buffer size by specifying
   * width, height and pixel ratio all at once. The size of the drawing
   * buffer is computed with this formula:
   * ```js
   * size.x = width * pixelRatio;
   * size.y = height * pixelRatio;
   * ```
   *
   * @param {number} width - The width in logical pixels.
   * @param {number} height - The height in logical pixels.
   * @param {number} pixelRatio - The pixel ratio.
   */ setDrawingBufferSize(e, t, i) {
        this.xr && this.xr.isPresenting || this._canvasTarget.setDrawingBufferSize(e, t, i);
    }
    /**
   * Sets the size of the renderer.
   *
   * @param {number} width - The width in logical pixels.
   * @param {number} height - The height in logical pixels.
   * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
   */ setSize(e, t, i = !0) {
        this.xr && this.xr.isPresenting || this._canvasTarget.setSize(e, t, i);
    }
    /**
   * Defines a manual sort function for the opaque render list.
   * Pass `null` to use the default sort.
   *
   * @param {Function} method - The sort function.
   */ setOpaqueSort(e) {
        this._opaqueSort = e;
    }
    /**
   * Defines a manual sort function for the transparent render list.
   * Pass `null` to use the default sort.
   *
   * @param {Function} method - The sort function.
   */ setTransparentSort(e) {
        this._transparentSort = e;
    }
    /**
   * Returns the scissor rectangle.
   *
   * @param {Vector4} target - The method writes the result in this target object.
   * @return {Vector4} The scissor rectangle.
   */ getScissor(e) {
        return this._canvasTarget.getScissor(e);
    }
    /**
   * Defines the scissor rectangle.
   *
   * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
   * Instead of passing four arguments, the method also works with a single four-dimensional vector.
   * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
   * @param {number} width - The width of the scissor box in logical pixel unit.
   * @param {number} height - The height of the scissor box in logical pixel unit.
   */ setScissor(e, t, i, n) {
        this._canvasTarget.setScissor(e, t, i, n);
    }
    /**
   * Returns the scissor test value.
   *
   * @return {boolean} Whether the scissor test should be enabled or not.
   */ getScissorTest() {
        return this._canvasTarget.getScissorTest();
    }
    /**
   * Defines the scissor test.
   *
   * @param {boolean} boolean - Whether the scissor test should be enabled or not.
   */ setScissorTest(e) {
        this._canvasTarget.setScissorTest(e), this.backend.setScissorTest(e);
    }
    /**
   * Returns the viewport definition.
   *
   * @param {Vector4} target - The method writes the result in this target object.
   * @return {Vector4} The viewport definition.
   */ getViewport(e) {
        return this._canvasTarget.getViewport(e);
    }
    /**
   * Defines the viewport.
   *
   * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
   * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
   * @param {number} width - The width of the viewport in logical pixel unit.
   * @param {number} height - The height of the viewport in logical pixel unit.
   * @param {number} minDepth - The minimum depth value of the viewport. WebGPU only.
   * @param {number} maxDepth - The maximum depth value of the viewport. WebGPU only.
   */ setViewport(e, t, i, n, s = 0, a = 1) {
        this._canvasTarget.setViewport(e, t, i, n, s, a);
    }
    /**
   * Returns the clear color.
   *
   * @param {Color} target - The method writes the result in this target object.
   * @return {Color} The clear color.
   */ getClearColor(e) {
        return e.copy(this._clearColor);
    }
    /**
   * Defines the clear color and optionally the clear alpha.
   *
   * @param {Color} color - The clear color.
   * @param {number} [alpha=1] - The clear alpha.
   */ setClearColor(e, t = 1) {
        this._clearColor.set(e), this._clearColor.a = t;
    }
    /**
   * Returns the clear alpha.
   *
   * @return {number} The clear alpha.
   */ getClearAlpha() {
        return this._clearColor.a;
    }
    /**
   * Defines the clear alpha.
   *
   * @param {number} alpha - The clear alpha.
   */ setClearAlpha(e) {
        this._clearColor.a = e;
    }
    /**
   * Returns the clear depth.
   *
   * @return {number} The clear depth.
   */ getClearDepth() {
        return this._clearDepth;
    }
    /**
   * Defines the clear depth.
   *
   * @param {number} depth - The clear depth.
   */ setClearDepth(e) {
        this._clearDepth = e;
    }
    /**
   * Returns the clear stencil.
   *
   * @return {number} The clear stencil.
   */ getClearStencil() {
        return this._clearStencil;
    }
    /**
   * Defines the clear stencil.
   *
   * @param {number} stencil - The clear stencil.
   */ setClearStencil(e) {
        this._clearStencil = e;
    }
    /**
   * This method performs an occlusion query for the given 3D object.
   * It returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object is fully occluded or not.
   */ isOccluded(e) {
        const t = this._currentRenderContext;
        return t && this.backend.isOccluded(t, e);
    }
    /**
   * Performs a manual clear operation. This method ignores `autoClear` properties.
   *
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */ clear(e = !0, t = !0, i = !0) {
        if (this._initialized === !1) throw new Error('Renderer: .clear() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        const n = this._renderTarget || this._getFrameBufferTarget();
        let s = null;
        if (n !== null) {
            this._textures.updateRenderTarget(n);
            const a = this._textures.get(n);
            s = this._renderContexts.getForClear(n), s.textures = a.textures, s.depthTexture = a.depthTexture, s.width = a.width, s.height = a.height, s.renderTarget = n, s.depth = n.depthBuffer, s.stencil = n.stencilBuffer, s.clearColorValue = this.backend.getClearColor(), s.activeCubeFace = this.getActiveCubeFace(), s.activeMipmapLevel = this.getActiveMipmapLevel();
        }
        this.backend.clear(e, t, i, s), n !== null && this._renderTarget === null && this._renderOutput(n);
    }
    /**
   * Performs a manual clear operation of the color buffer. This method ignores `autoClear` properties.
   */ clearColor() {
        this.clear(!0, !1, !1);
    }
    /**
   * Performs a manual clear operation of the depth buffer. This method ignores `autoClear` properties.
   */ clearDepth() {
        this.clear(!1, !0, !1);
    }
    /**
   * Performs a manual clear operation of the stencil buffer. This method ignores `autoClear` properties.
   */ clearStencil() {
        this.clear(!1, !1, !0);
    }
    /**
   * Async version of {@link Renderer#clear}.
   *
   * @async
   * @deprecated
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */ async clearAsync(e = !0, t = !0, i = !0) {
        $d7238066c5de7f1c$var$es('Renderer: "clearAsync()" has been deprecated. Use "clear()" and "await renderer.init();" when creating the renderer.'), await this.init(), this.clear(e, t, i);
    }
    /**
   * Async version of {@link Renderer#clearColor}.
   *
   * @async
   * @deprecated
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */ async clearColorAsync() {
        $d7238066c5de7f1c$var$es('Renderer: "clearColorAsync()" has been deprecated. Use "clearColor()" and "await renderer.init();" when creating the renderer.'), this.clear(!0, !1, !1);
    }
    /**
   * Async version of {@link Renderer#clearDepth}.
   *
   * @async
   * @deprecated
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */ async clearDepthAsync() {
        $d7238066c5de7f1c$var$es('Renderer: "clearDepthAsync()" has been deprecated. Use "clearDepth()" and "await renderer.init();" when creating the renderer.'), this.clear(!1, !0, !1);
    }
    /**
   * Async version of {@link Renderer#clearStencil}.
   *
   * @async
   * @deprecated
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */ async clearStencilAsync() {
        $d7238066c5de7f1c$var$es('Renderer: "clearStencilAsync()" has been deprecated. Use "clearStencil()" and "await renderer.init();" when creating the renderer.'), this.clear(!1, !1, !0);
    }
    /**
   * Returns `true` if a framebuffer target is needed to perform tone mapping or color space conversion.
   * If this is the case, the renderer allocates an internal render target for that purpose.
   *
   */ get needsFrameBufferTarget() {
        const e = this.currentToneMapping !== $d7238066c5de7f1c$var$VC, t = this.currentColorSpace !== $d7238066c5de7f1c$var$sn.workingColorSpace;
        return e || t;
    }
    /**
   * The number of samples used for multi-sample anti-aliasing (MSAA).
   *
   * @type {number}
   * @default 0
   */ get samples() {
        return this._samples;
    }
    /**
   * The current number of samples used for multi-sample anti-aliasing (MSAA).
   *
   * When rendering to a custom render target, the number of samples of that render target is used.
   * If the renderer needs an internal framebuffer target for tone mapping or color space conversion,
   * the number of samples is set to 0.
   *
   * @type {number}
   */ get currentSamples() {
        let e = this._samples;
        return this._renderTarget !== null ? e = this._renderTarget.samples : this.needsFrameBufferTarget && (e = 0), e;
    }
    /**
   * The current tone mapping of the renderer. When not producing screen output,
   * the tone mapping is always `NoToneMapping`.
   *
   * @type {number}
   */ get currentToneMapping() {
        return this.isOutputTarget ? this.toneMapping : $d7238066c5de7f1c$var$VC;
    }
    /**
   * The current color space of the renderer. When not producing screen output,
   * the color space is always the working color space.
   *
   * @type {string}
   */ get currentColorSpace() {
        return this.isOutputTarget ? this.outputColorSpace : $d7238066c5de7f1c$var$sn.workingColorSpace;
    }
    /**
   * Returns `true` if the rendering settings are set to screen output.
   *
   * @returns {boolean} True if the current render target is the same of output render target or `null`, otherwise false.
   */ get isOutputTarget() {
        return this._renderTarget === this._outputRenderTarget || this._renderTarget === null;
    }
    /**
   * Frees all internal resources of the renderer. Call this method if the renderer
   * is no longer in use by your app.
   */ dispose() {
        this._initialized === !0 && (this.info.dispose(), this.backend.dispose(), this._animation.dispose(), this._objects.dispose(), this._geometries.dispose(), this._pipelines.dispose(), this._nodes.dispose(), this._bindings.dispose(), this._renderLists.dispose(), this._renderContexts.dispose(), this._textures.dispose(), this._frameBufferTarget !== null && this._frameBufferTarget.dispose(), Object.values(this.backend.timestampQueryPool).forEach((e)=>{
            e !== null && e.dispose();
        })), this.setRenderTarget(null), this.setAnimationLoop(null);
    }
    /**
   * Sets the given render target. Calling this method means the renderer does not
   * target the default framebuffer (meaning the canvas) anymore but a custom framebuffer.
   * Use `null` as the first argument to reset the state.
   *
   * @param {?RenderTarget} renderTarget - The render target to set.
   * @param {number} [activeCubeFace=0] - The active cube face.
   * @param {number} [activeMipmapLevel=0] - The active mipmap level.
   */ setRenderTarget(e, t = 0, i = 0) {
        this._renderTarget = e, this._activeCubeFace = t, this._activeMipmapLevel = i;
    }
    /**
   * Returns the current render target.
   *
   * @return {?RenderTarget} The render target. Returns `null` if no render target is set.
   */ getRenderTarget() {
        return this._renderTarget;
    }
    /**
   * Sets the output render target for the renderer.
   *
   * @param {Object} renderTarget - The render target to set as the output target.
   */ setOutputRenderTarget(e) {
        this._outputRenderTarget = e;
    }
    /**
   * Returns the current output target.
   *
   * @return {?RenderTarget} The current output render target. Returns `null` if no output target is set.
   */ getOutputRenderTarget() {
        return this._outputRenderTarget;
    }
    /**
   * Sets the canvas target. The canvas target manages the HTML canvas
   * or the offscreen canvas the renderer draws into.
   *
   * @param {CanvasTarget} canvasTarget - The canvas target.
   */ setCanvasTarget(e) {
        this._canvasTarget.removeEventListener("resize", this._onCanvasTargetResize), this._canvasTarget = e, this._canvasTarget.addEventListener("resize", this._onCanvasTargetResize);
    }
    /**
   * Returns the current canvas target.
   *
   * @return {CanvasTarget} The current canvas target.
   */ getCanvasTarget() {
        return this._canvasTarget;
    }
    /**
   * Resets the renderer to the initial state before WebXR started.
   *
   */ _resetXRState() {
        this.backend.setXRTarget(null), this.setOutputRenderTarget(null), this.setRenderTarget(null), this._frameBufferTarget.dispose(), this._frameBufferTarget = null;
    }
    /**
   * Callback for {@link Renderer#setRenderObjectFunction}.
   *
   * @callback renderObjectFunction
   * @param {Object3D} object - The 3D object.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {BufferGeometry} geometry - The object's geometry.
   * @param {Material} material - The object's material.
   * @param {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {?string} [passId=null] - An optional ID for identifying the pass.
   */ /**
   * Sets the given render object function. Calling this method overwrites the default implementation
   * which is {@link Renderer#renderObject}. Defining a custom function can be useful
   * if you want to modify the way objects are rendered. For example you can define things like "every
   * object that has material of a certain type should perform a pre-pass with a special overwrite material".
   * The custom function must always call `renderObject()` in its implementation.
   *
   * Use `null` as the first argument to reset the state.
   *
   * @param {?renderObjectFunction} renderObjectFunction - The render object function.
   */ setRenderObjectFunction(e) {
        this._renderObjectFunction = e;
    }
    /**
   * Returns the current render object function.
   *
   * @return {?Function} The current render object function. Returns `null` if no function is set.
   */ getRenderObjectFunction() {
        return this._renderObjectFunction;
    }
    /**
   * Execute a single or an array of compute nodes. This method can only be called
   * if the renderer has been initialized.
   *
   * @param {Node|Array<Node>} computeNodes - The compute node(s).
   * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
   * - A single number representing count, or
   * - An array [x, y, z] representing dispatch size, or
   * - A IndirectStorageBufferAttribute for indirect dispatch size.
   * @return {Promise|undefined} A Promise that resolve when the compute has finished. Only returned when the renderer has not been initialized.
   */ compute(e, t = null) {
        if (this._isDeviceLost === !0) return;
        if (this._initialized === !1) return $d7238066c5de7f1c$var$ze("Renderer: .compute() called before the backend is initialized. Try using .computeAsync() instead."), this.computeAsync(e, t);
        const i = this._nodes.nodeFrame, n = i.renderId;
        this.info.calls++, this.info.compute.calls++, this.info.compute.frameCalls++, i.renderId = this.info.calls, this.backend.updateTimeStampUID(e), this.inspector.beginCompute(this.backend.getTimestampUID(e), e);
        const s = this.backend, a = this._pipelines, o = this._bindings, g = this._nodes, l = Array.isArray(e) ? e : [
            e
        ];
        if (l[0] === void 0 || l[0].isComputeNode !== !0) throw new Error("THREE.Renderer: .compute() expects a ComputeNode.");
        s.beginCompute(e);
        for (const c of l){
            if (a.has(c) === !1) {
                const A = ()=>{
                    c.removeEventListener("dispose", A), a.delete(c), o.deleteForCompute(c), g.delete(c);
                };
                c.addEventListener("dispose", A);
                const y = c.onInitFunction;
                y !== null && y.call(c, {
                    renderer: this
                });
            }
            g.updateForCompute(c), o.updateForCompute(c);
            const d = o.getForCompute(c), p = a.getForCompute(c, d);
            s.compute(e, c, d, p, t);
        }
        s.finishCompute(e), i.renderId = n, this.inspector.finishCompute(this.backend.getTimestampUID(e));
    }
    /**
   * Execute a single or an array of compute nodes.
   *
   * @async
   * @param {Node|Array<Node>} computeNodes - The compute node(s).
   * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
   * - A single number representing count, or
   * - An array [x, y, z] representing dispatch size, or
   * - A IndirectStorageBufferAttribute for indirect dispatch size.
   * @return {Promise} A Promise that resolve when the compute has finished.
   */ async computeAsync(e, t = null) {
        this._initialized === !1 && await this.init(), this.compute(e, t);
    }
    /**
   * Checks if the given feature is supported by the selected backend.
   *
   * @async
   * @deprecated
   * @param {string} name - The feature's name.
   * @return {Promise<boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
   */ async hasFeatureAsync(e) {
        return $d7238066c5de7f1c$var$es('Renderer: "hasFeatureAsync()" has been deprecated. Use "hasFeature()" and "await renderer.init();" when creating the renderer.'), await this.init(), this.hasFeature(e);
    }
    async resolveTimestampsAsync(e = "render") {
        return this._initialized === !1 && await this.init(), this.backend.resolveTimestampsAsync(e);
    }
    /**
   * Checks if the given feature is supported by the selected backend. If the
   * renderer has not been initialized, this method always returns `false`.
   *
   * @param {string} name - The feature's name.
   * @return {boolean} Whether the feature is supported or not.
   */ hasFeature(e) {
        if (this._initialized === !1) throw new Error('Renderer: .hasFeature() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        return this.backend.hasFeature(e);
    }
    /**
   * Returns `true` when the renderer has been initialized.
   *
   * @return {boolean} Whether the renderer has been initialized or not.
   */ hasInitialized() {
        return this._initialized;
    }
    /**
   * Initializes the given textures. Useful for preloading a texture rather than waiting until first render
   * (which can cause noticeable lags due to decode and GPU upload overhead).
   *
   * @async
   * @deprecated
   * @param {Texture} texture - The texture.
   * @return {Promise} A Promise that resolves when the texture has been initialized.
   */ async initTextureAsync(e) {
        $d7238066c5de7f1c$var$es('Renderer: "initTextureAsync()" has been deprecated. Use "initTexture()" and "await renderer.init();" when creating the renderer.'), await this.init(), this.initTexture(e);
    }
    /**
   * Initializes the given texture. Useful for preloading a texture rather than waiting until first render
   * (which can cause noticeable lags due to decode and GPU upload overhead).
   *
   * This method can only be used if the renderer has been initialized.
   *
   * @param {Texture} texture - The texture.
   */ initTexture(e) {
        if (this._initialized === !1) throw new Error('Renderer: .initTexture() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        this._textures.updateTexture(e);
    }
    /**
   * Copies the current bound framebuffer into the given texture.
   *
   * @param {FramebufferTexture} framebufferTexture - The texture.
   * @param {?(Vector2|Vector4)} [rectangle=null] - A two or four dimensional vector that defines the rectangular portion of the framebuffer that should be copied.
   */ copyFramebufferToTexture(e, t = null) {
        if (t !== null) {
            if (t.isVector2) t = $d7238066c5de7f1c$var$qu.set(t.x, t.y, e.image.width, e.image.height).floor();
            else if (t.isVector4) t = $d7238066c5de7f1c$var$qu.copy(t).floor();
            else {
                $d7238066c5de7f1c$var$nt("Renderer.copyFramebufferToTexture: Invalid rectangle.");
                return;
            }
        } else t = $d7238066c5de7f1c$var$qu.set(0, 0, e.image.width, e.image.height);
        let i = this._currentRenderContext, n;
        i !== null ? n = i.renderTarget : (n = this._renderTarget || this._getFrameBufferTarget(), n !== null && (this._textures.updateRenderTarget(n), i = this._textures.get(n))), this._textures.updateTexture(e, {
            renderTarget: n
        }), this.backend.copyFramebufferToTexture(e, i, t), this._inspector.copyFramebufferToTexture(e);
    }
    /**
   * Copies data of the given source texture into a destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {Box2|Box3} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
   * @param {Vector2|Vector3} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
   * @param {number} [srcLevel=0] - The source mip level to copy from.
   * @param {number} [dstLevel=0] - The destination mip level to copy to.
   */ copyTextureToTexture(e, t, i = null, n = null, s = 0, a = 0) {
        this._textures.updateTexture(e), this._textures.updateTexture(t), this.backend.copyTextureToTexture(e, t, i, n, s, a), this._inspector.copyTextureToTexture(e, t);
    }
    /**
   * Reads pixel data from the given render target.
   *
   * @async
   * @param {RenderTarget} renderTarget - The render target to read from.
   * @param {number} x - The `x` coordinate of the copy region's origin.
   * @param {number} y - The `y` coordinate of the copy region's origin.
   * @param {number} width - The width of the copy region.
   * @param {number} height - The height of the copy region.
   * @param {number} [textureIndex=0] - The texture index of a MRT render target.
   * @param {number} [faceIndex=0] - The active cube face index.
   * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
   */ async readRenderTargetPixelsAsync(e, t, i, n, s, a = 0, o = 0) {
        return this.backend.copyTextureToBuffer(e.textures[a], t, i, n, s, o);
    }
    /**
   * Analyzes the given 3D object's hierarchy and builds render lists from the
   * processed hierarchy.
   *
   * @param {Object3D} object - The 3D object to process (usually a scene).
   * @param {Camera} camera - The camera the object is rendered with.
   * @param {number} groupOrder - The group order is derived from the `renderOrder` of groups and is used to group 3D objects within groups.
   * @param {RenderList} renderList - The current render list.
   * @param {ClippingContext} clippingContext - The current clipping context.
   */ _projectObject(e, t, i, n, s) {
        if (e.visible === !1) return;
        if (e.layers.test(t.layers)) {
            if (e.isGroup) i = e.renderOrder, e.isClippingGroup && e.enabled && (s = s.getGroupContext(e));
            else if (e.isLOD) e.autoUpdate === !0 && e.update(t);
            else if (e.isLight) n.pushLight(e);
            else if (e.isSprite) {
                const g = t.isArrayCamera ? $d7238066c5de7f1c$var$LH : $d7238066c5de7f1c$var$NH;
                if (!e.frustumCulled || g.intersectsSprite(e, t)) {
                    this.sortObjects === !0 && $d7238066c5de7f1c$var$qu.setFromMatrixPosition(e.matrixWorld).applyMatrix4($d7238066c5de7f1c$var$_v);
                    const { geometry: l, material: c } = e;
                    c.visible && n.push(e, l, c, i, $d7238066c5de7f1c$var$qu.z, null, s);
                }
            } else if (e.isLineLoop) $d7238066c5de7f1c$var$nt("Renderer: Objects of type THREE.LineLoop are not supported. Please use THREE.Line or THREE.LineSegments.");
            else if (e.isMesh || e.isLine || e.isPoints) {
                const g = t.isArrayCamera ? $d7238066c5de7f1c$var$LH : $d7238066c5de7f1c$var$NH;
                if (!e.frustumCulled || g.intersectsObject(e, t)) {
                    const { geometry: l, material: c } = e;
                    if (this.sortObjects === !0 && (l.boundingSphere === null && l.computeBoundingSphere(), $d7238066c5de7f1c$var$qu.copy(l.boundingSphere.center).applyMatrix4(e.matrixWorld).applyMatrix4($d7238066c5de7f1c$var$_v)), Array.isArray(c)) {
                        const d = l.groups;
                        for(let p = 0, A = d.length; p < A; p++){
                            const y = d[p], G = c[y.materialIndex];
                            G && G.visible && n.push(e, l, G, i, $d7238066c5de7f1c$var$qu.z, y, s);
                        }
                    } else c.visible && n.push(e, l, c, i, $d7238066c5de7f1c$var$qu.z, null, s);
                }
            }
        }
        if (e.isBundleGroup === !0 && this.backend.beginBundle !== void 0) {
            const g = n;
            n = this._renderLists.get(e, t), n.begin(), g.pushBundle({
                bundleGroup: e,
                camera: t,
                renderList: n
            }), n.finish();
        }
        const o = e.children;
        for(let g = 0, l = o.length; g < l; g++)this._projectObject(o[g], t, i, n, s);
    }
    /**
   * Renders the given render bundles.
   *
   * @private
   * @param {Array<Object>} bundles - Array with render bundle data.
   * @param {Scene} sceneRef - The scene the render bundles belong to.
   * @param {LightsNode} lightsNode - The current lights node.
   */ _renderBundles(e, t, i) {
        for (const n of e)this._renderBundle(n, t, i);
    }
    /**
   * Renders the transparent objects from the given render lists.
   *
   * @private
   * @param {Array<Object>} renderList - The transparent render list.
   * @param {Array<Object>} doublePassList - The list of transparent objects which require a double pass (e.g. because of transmission).
   * @param {Camera} camera - The camera the render list should be rendered with.
   * @param {Scene} scene - The scene the render list belongs to.
   * @param {LightsNode} lightsNode - The current lights node.
   */ _renderTransparents(e, t, i, n, s) {
        if (t.length > 0) {
            for (const { material: a } of t)a.side = $d7238066c5de7f1c$var$Ka;
            this._renderObjects(t, i, n, s, "backSide");
            for (const { material: a } of t)a.side = $d7238066c5de7f1c$var$nh;
            this._renderObjects(e, i, n, s);
            for (const { material: a } of t)a.side = $d7238066c5de7f1c$var$YC;
        } else this._renderObjects(e, i, n, s);
    }
    /**
   * Renders the objects from the given render list.
   *
   * @private
   * @param {Array<Object>} renderList - The render list.
   * @param {Camera} camera - The camera the render list should be rendered with.
   * @param {Scene} scene - The scene the render list belongs to.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {?string} [passId=null] - An optional ID for identifying the pass.
   */ _renderObjects(e, t, i, n, s = null) {
        for(let a = 0, o = e.length; a < o; a++){
            const { object: g, geometry: l, material: c, group: d, clippingContext: p } = e[a];
            this._currentRenderObjectFunction(g, i, t, l, c, d, n, p, s);
        }
    }
    /**
   * Retrieves shadow nodes for the given material. This is used to setup shadow passes.
   * The result is cached per material and updated when the material's version changes.
   *
   * @param {Material} material
   * @returns {Object} - The shadow nodes for the material.
   */ _getShadowNodes(e) {
        const t = e.version;
        let i = this._cacheShadowNodes.get(e);
        if (i === void 0 || i.version !== t) {
            const n = e.map !== null, s = e.colorNode && e.colorNode.isNode, a = e.castShadowNode && e.castShadowNode.isNode;
            let o = null, g = null, l = null;
            if (n || s || a) {
                let c, d;
                a ? (c = e.castShadowNode.rgb, d = e.castShadowNode.a) : (c = $d7238066c5de7f1c$var$ne(0), d = $d7238066c5de7f1c$var$J(1)), n && (d = d.mul($d7238066c5de7f1c$var$vn("map", "texture", e).a)), s && (d = d.mul(e.colorNode.a)), g = $d7238066c5de7f1c$var$Rt(c, d);
            }
            e.depthNode && e.depthNode.isNode && (l = e.depthNode), e.castShadowPositionNode && e.castShadowPositionNode.isNode ? o = e.castShadowPositionNode : e.positionNode && e.positionNode.isNode && (o = e.positionNode), i = {
                version: t,
                colorNode: g,
                depthNode: l,
                positionNode: o
            }, this._cacheShadowNodes.set(e, i);
        }
        return i;
    }
    /**
   * This method represents the default render object function that manages the render lifecycle
   * of the object.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {BufferGeometry} geometry - The object's geometry.
   * @param {Material} material - The object's material.
   * @param {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {?ClippingContext} clippingContext - The clipping context.
   * @param {?string} [passId=null] - An optional ID for identifying the pass.
   */ renderObject(e, t, i, n, s, a, o, g = null, l = null) {
        let c = !1, d, p, A, y;
        if (e.onBeforeRender(this, t, i, n, s, a), s.allowOverride === !0 && t.overrideMaterial !== null) {
            const G = t.overrideMaterial;
            if (c = !0, d = t.overrideMaterial.colorNode, p = t.overrideMaterial.depthNode, A = t.overrideMaterial.positionNode, y = t.overrideMaterial.side, s.positionNode && s.positionNode.isNode && (G.positionNode = s.positionNode), G.alphaTest = s.alphaTest, G.alphaMap = s.alphaMap, G.transparent = s.transparent || s.transmission > 0 || s.transmissionNode && s.transmissionNode.isNode || s.backdropNode && s.backdropNode.isNode, G.isShadowPassMaterial) {
                const { colorNode: Z, depthNode: v, positionNode: V } = this._getShadowNodes(s);
                G.side = s.shadowSide === null ? s.side : s.shadowSide, Z !== null && (G.colorNode = Z), v !== null && (G.depthNode = v), V !== null && (G.positionNode = V);
            }
            s = G;
        }
        s.transparent === !0 && s.side === $d7238066c5de7f1c$var$YC && s.forceSinglePass === !1 ? (s.side = $d7238066c5de7f1c$var$Ka, this._handleObjectFunction(e, s, t, i, o, a, g, "backSide"), s.side = $d7238066c5de7f1c$var$nh, this._handleObjectFunction(e, s, t, i, o, a, g, l), s.side = $d7238066c5de7f1c$var$YC) : this._handleObjectFunction(e, s, t, i, o, a, g, l), c && (t.overrideMaterial.colorNode = d, t.overrideMaterial.depthNode = p, t.overrideMaterial.positionNode = A, t.overrideMaterial.side = y), e.onAfterRender(this, t, i, n, s, a);
    }
    /**
   * This method represents the default `_handleObjectFunction` implementation which creates
   * a render object from the given data and performs the draw command with the selected backend.
   *
   * @private
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {?{start: number, count: number}} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {string} [passId] - An optional ID for identifying the pass.
   */ _renderObjectDirect(e, t, i, n, s, a, o, g) {
        const l = this._objects.get(e, t, i, n, s, this._currentRenderContext, o, g);
        l.drawRange = e.geometry.drawRange, l.group = a;
        const c = this._nodes.needsRefresh(l);
        c && (this._nodes.updateBefore(l), this._geometries.updateForRender(l), this._nodes.updateForRender(l), this._bindings.updateForRender(l)), this._pipelines.updateForRender(l), this._currentRenderBundle !== null && (this.backend.get(this._currentRenderBundle).renderObjects.push(l), l.bundle = this._currentRenderBundle.bundleGroup), this.backend.draw(l, this.info), c && this._nodes.updateAfter(l);
    }
    /**
   * A different implementation for `_handleObjectFunction` which only makes sure the object is ready for rendering.
   * Used in `compileAsync()`.
   *
   * @private
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {?{start: number, count: number}} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {string} [passId] - An optional ID for identifying the pass.
   */ _createObjectPipeline(e, t, i, n, s, a, o, g) {
        const l = this._objects.get(e, t, i, n, s, this._currentRenderContext, o, g);
        l.drawRange = e.geometry.drawRange, l.group = a, this._nodes.updateBefore(l), this._geometries.updateForRender(l), this._nodes.updateForRender(l), this._bindings.updateForRender(l), this._pipelines.getForRender(l, this._compilationPromises), this._nodes.updateAfter(l);
    }
    /**
   * Callback when the canvas has been resized.
   *
   * @private
   */ _onCanvasTargetResize() {
        this._initialized && this.backend.updateSize();
    }
    /**
   * Alias for `compileAsync()`.
   *
   * @method
   * @param {Object3D} scene - The scene or 3D object to precompile.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
   * @return {function(Object3D, Camera, ?Scene): Promise|undefined} A Promise that resolves when the compile has been finished.
   */ get compile() {
        return this.compileAsync;
    }
}
class $d7238066c5de7f1c$var$PD {
    /**
   * Constructs a new binding.
   *
   * @param {string} [name=''] - The binding's name.
   */ constructor(e = ""){
        this.name = e, this.visibility = 0;
    }
    /**
   * Makes sure binding's resource is visible for the given shader stage.
   *
   * @param {number} visibility - The shader stage.
   */ setVisibility(e) {
        this.visibility |= e;
    }
    /**
   * Clones the binding.
   *
   * @return {Binding} The cloned binding.
   */ clone() {
        return Object.assign(new this.constructor(), this);
    }
}
function $d7238066c5de7f1c$var$Qce(r) {
    return r + ($d7238066c5de7f1c$var$Qd - r % $d7238066c5de7f1c$var$Qd) % $d7238066c5de7f1c$var$Qd;
}
let $d7238066c5de7f1c$var$QD = class extends $d7238066c5de7f1c$var$PD {
    /**
   * Constructs a new buffer.
   *
   * @param {string} name - The buffer's name.
   * @param {TypedArray} [buffer=null] - The buffer.
   */ constructor(e, t = null){
        super(e), this.isBuffer = !0, this.bytesPerElement = Float32Array.BYTES_PER_ELEMENT, this._buffer = t;
    }
    /**
   * The buffer's byte length.
   *
   * @type {number}
   * @readonly
   */ get byteLength() {
        return $d7238066c5de7f1c$var$Qce(this._buffer.byteLength);
    }
    /**
   * A reference to the internal buffer.
   *
   * @type {Float32Array}
   * @readonly
   */ get buffer() {
        return this._buffer;
    }
    /**
   * Updates the binding.
   *
   * @return {boolean} Whether the buffer has been updated and must be
   * uploaded to the GPU.
   */ update() {
        return !0;
    }
};
class $d7238066c5de7f1c$var$OD extends $d7238066c5de7f1c$var$QD {
    /**
   * Constructs a new uniform buffer.
   *
   * @param {string} name - The buffer's name.
   * @param {TypedArray} [buffer=null] - The buffer.
   */ constructor(e, t = null){
        super(e, t), this.isUniformBuffer = !0;
    }
}
let $d7238066c5de7f1c$var$Oce = 0;
class $d7238066c5de7f1c$var$jD extends $d7238066c5de7f1c$var$OD {
    /**
   * Constructs a new node-based uniform buffer.
   *
   * @param {BufferNode} nodeUniform - The uniform buffer node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */ constructor(e, t){
        super("UniformBuffer_" + $d7238066c5de7f1c$var$Oce++, e ? e.value : null), this.nodeUniform = e, this.groupNode = t;
    }
    /**
   * The uniform buffer.
   *
   * @type {Float32Array}
   */ get buffer() {
        return this.nodeUniform.value;
    }
}
class $d7238066c5de7f1c$var$jce extends $d7238066c5de7f1c$var$OD {
    /**
   * Constructs a new uniforms group.
   *
   * @param {string} name - The group's name.
   */ constructor(e){
        super(e), this.isUniformsGroup = !0, this._values = null, this.uniforms = [];
    }
    /**
   * Adds a uniform to this group.
   *
   * @param {Uniform} uniform - The uniform to add.
   * @return {UniformsGroup} A reference to this group.
   */ addUniform(e) {
        return this.uniforms.push(e), this;
    }
    /**
   * Removes a uniform from this group.
   *
   * @param {Uniform} uniform - The uniform to remove.
   * @return {UniformsGroup} A reference to this group.
   */ removeUniform(e) {
        const t = this.uniforms.indexOf(e);
        return t !== -1 && this.uniforms.splice(t, 1), this;
    }
    /**
   * An array with the raw uniform values.
   *
   * @type {Array<number>}
   */ get values() {
        return this._values === null && (this._values = Array.from(this.buffer)), this._values;
    }
    /**
   * A Float32 array buffer with the uniform values.
   *
   * @type {Float32Array}
   */ get buffer() {
        let e = this._buffer;
        if (e === null) {
            const t = this.byteLength;
            e = new Float32Array(new ArrayBuffer(t)), this._buffer = e;
        }
        return e;
    }
    /**
   * The byte length of the buffer with correct buffer alignment.
   *
   * @type {number}
   */ get byteLength() {
        const e = this.bytesPerElement;
        let t = 0;
        for(let i = 0, n = this.uniforms.length; i < n; i++){
            const s = this.uniforms[i], a = s.boundary, o = s.itemSize * e, g = t % $d7238066c5de7f1c$var$Qd, l = g % a, c = g + l;
            t += l, c !== 0 && $d7238066c5de7f1c$var$Qd - c < o && (t += $d7238066c5de7f1c$var$Qd - c), s.offset = t / e, t += o;
        }
        return Math.ceil(t / $d7238066c5de7f1c$var$Qd) * $d7238066c5de7f1c$var$Qd;
    }
    /**
   * Updates this group by updating each uniform object of
   * the internal uniform list. The uniform objects check if their
   * values has actually changed so this method only returns
   * `true` if there is a real value change.
   *
   * @return {boolean} Whether the uniforms have been updated and
   * must be uploaded to the GPU.
   */ update() {
        let e = !1;
        for (const t of this.uniforms)this.updateByType(t) === !0 && (e = !0);
        return e;
    }
    /**
   * Updates a given uniform by calling an update method matching
   * the uniforms type.
   *
   * @param {Uniform} uniform - The uniform to update.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateByType(e) {
        if (e.isNumberUniform) return this.updateNumber(e);
        if (e.isVector2Uniform) return this.updateVector2(e);
        if (e.isVector3Uniform) return this.updateVector3(e);
        if (e.isVector4Uniform) return this.updateVector4(e);
        if (e.isColorUniform) return this.updateColor(e);
        if (e.isMatrix3Uniform) return this.updateMatrix3(e);
        if (e.isMatrix4Uniform) return this.updateMatrix4(e);
        $d7238066c5de7f1c$var$nt("WebGPUUniformsGroup: Unsupported uniform type.", e);
    }
    /**
   * Updates a given Number uniform.
   *
   * @param {NumberUniform} uniform - The Number uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateNumber(e) {
        let t = !1;
        const i = this.values, n = e.getValue(), s = e.offset, a = e.getType();
        if (i[s] !== n) {
            const o = this._getBufferForType(a);
            o[s] = i[s] = n, t = !0;
        }
        return t;
    }
    /**
   * Updates a given Vector2 uniform.
   *
   * @param {Vector2Uniform} uniform - The Vector2 uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateVector2(e) {
        let t = !1;
        const i = this.values, n = e.getValue(), s = e.offset, a = e.getType();
        if (i[s + 0] !== n.x || i[s + 1] !== n.y) {
            const o = this._getBufferForType(a);
            o[s + 0] = i[s + 0] = n.x, o[s + 1] = i[s + 1] = n.y, t = !0;
        }
        return t;
    }
    /**
   * Updates a given Vector3 uniform.
   *
   * @param {Vector3Uniform} uniform - The Vector3 uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateVector3(e) {
        let t = !1;
        const i = this.values, n = e.getValue(), s = e.offset, a = e.getType();
        if (i[s + 0] !== n.x || i[s + 1] !== n.y || i[s + 2] !== n.z) {
            const o = this._getBufferForType(a);
            o[s + 0] = i[s + 0] = n.x, o[s + 1] = i[s + 1] = n.y, o[s + 2] = i[s + 2] = n.z, t = !0;
        }
        return t;
    }
    /**
   * Updates a given Vector4 uniform.
   *
   * @param {Vector4Uniform} uniform - The Vector4 uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateVector4(e) {
        let t = !1;
        const i = this.values, n = e.getValue(), s = e.offset, a = e.getType();
        if (i[s + 0] !== n.x || i[s + 1] !== n.y || i[s + 2] !== n.z || i[s + 4] !== n.w) {
            const o = this._getBufferForType(a);
            o[s + 0] = i[s + 0] = n.x, o[s + 1] = i[s + 1] = n.y, o[s + 2] = i[s + 2] = n.z, o[s + 3] = i[s + 3] = n.w, t = !0;
        }
        return t;
    }
    /**
   * Updates a given Color uniform.
   *
   * @param {ColorUniform} uniform - The Color uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateColor(e) {
        let t = !1;
        const i = this.values, n = e.getValue(), s = e.offset;
        if (i[s + 0] !== n.r || i[s + 1] !== n.g || i[s + 2] !== n.b) {
            const a = this.buffer;
            a[s + 0] = i[s + 0] = n.r, a[s + 1] = i[s + 1] = n.g, a[s + 2] = i[s + 2] = n.b, t = !0;
        }
        return t;
    }
    /**
   * Updates a given Matrix3 uniform.
   *
   * @param {Matrix3Uniform} uniform - The Matrix3 uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateMatrix3(e) {
        let t = !1;
        const i = this.values, n = e.getValue().elements, s = e.offset;
        if (i[s + 0] !== n[0] || i[s + 1] !== n[1] || i[s + 2] !== n[2] || i[s + 4] !== n[3] || i[s + 5] !== n[4] || i[s + 6] !== n[5] || i[s + 8] !== n[6] || i[s + 9] !== n[7] || i[s + 10] !== n[8]) {
            const a = this.buffer;
            a[s + 0] = i[s + 0] = n[0], a[s + 1] = i[s + 1] = n[1], a[s + 2] = i[s + 2] = n[2], a[s + 4] = i[s + 4] = n[3], a[s + 5] = i[s + 5] = n[4], a[s + 6] = i[s + 6] = n[5], a[s + 8] = i[s + 8] = n[6], a[s + 9] = i[s + 9] = n[7], a[s + 10] = i[s + 10] = n[8], t = !0;
        }
        return t;
    }
    /**
   * Updates a given Matrix4 uniform.
   *
   * @param {Matrix4Uniform} uniform - The Matrix4 uniform.
   * @return {boolean} Whether the uniform has been updated or not.
   */ updateMatrix4(e) {
        let t = !1;
        const i = this.values, n = e.getValue().elements, s = e.offset;
        return $d7238066c5de7f1c$var$$ce(i, n, s) === !1 && (this.buffer.set(n, s), $d7238066c5de7f1c$var$qce(i, n, s), t = !0), t;
    }
    /**
   * Returns a typed array that matches the given data type.
   *
   * @param {string} type - The data type.
   * @return {TypedArray} The typed array.
   */ _getBufferForType(e) {
        return e === "int" || e === "ivec2" || e === "ivec3" || e === "ivec4" ? new Int32Array(this.buffer.buffer) : e === "uint" || e === "uvec2" || e === "uvec3" || e === "uvec4" ? new Uint32Array(this.buffer.buffer) : this.buffer;
    }
}
function $d7238066c5de7f1c$var$qce(r, e, t) {
    for(let i = 0, n = e.length; i < n; i++)r[t + i] = e[i];
}
function $d7238066c5de7f1c$var$$ce(r, e, t) {
    for(let i = 0, n = e.length; i < n; i++)if (r[t + i] !== e[i]) return !1;
    return !0;
}
let $d7238066c5de7f1c$var$eue = 0;
class $d7238066c5de7f1c$var$qD extends $d7238066c5de7f1c$var$jce {
    /**
   * Constructs a new node-based uniforms group.
   *
   * @param {string} name - The group's name.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */ constructor(e, t){
        super(e), this.id = $d7238066c5de7f1c$var$eue++, this.groupNode = t, this.isNodeUniformsGroup = !0;
    }
}
class $d7238066c5de7f1c$var$$D extends $d7238066c5de7f1c$var$PD {
    /**
   * Constructs a new sampler.
   *
   * @param {string} name - The samplers's name.
   * @param {?Texture} texture - The texture this binding is referring to.
   */ constructor(e, t){
        super(e), this._texture = null, this._onTextureDispose = ()=>{
            this.generation = null, this.version = 0;
        }, this.texture = t, this.version = t ? t.version : 0, this.generation = null, this.samplerKey = "", this.isSampler = !0;
    }
    /**
   * Sets the texture of this sampler.
   *
   * @param {Texture} value - The texture to set.
   */ set texture(e) {
        this._texture !== e && (this._texture && this._texture.removeEventListener("dispose", this._onTextureDispose), this._texture = e, this.generation = null, this.version = 0, this._texture && this._texture.addEventListener("dispose", this._onTextureDispose));
    }
    /**
   * Gets the texture of this sampler.
   * @return {?Texture} The texture.
   */ get texture() {
        return this._texture;
    }
    /**
   * Updates the binding.
   *
   * @return {boolean} Whether the texture has been updated and must be
   * uploaded to the GPU.
   */ update() {
        const { texture: e, version: t } = this;
        return t !== e.version ? (this.version = e.version, !0) : !1;
    }
    clone() {
        const e = super.clone();
        return e._texture = null, e._onTextureDispose = ()=>{
            e.generation = null, e.version = 0;
        }, e.texture = this.texture, e;
    }
}
let $d7238066c5de7f1c$var$tue = 0;
class $d7238066c5de7f1c$var$iue extends $d7238066c5de7f1c$var$$D {
    /**
   * Constructs a new sampled texture.
   *
   * @param {string} name - The sampled texture's name.
   * @param {?Texture} texture - The texture this binding is referring to.
   */ constructor(e, t){
        super(e, t), this.id = $d7238066c5de7f1c$var$tue++, this.store = !1, this.mipLevel = 0, this.isSampledTexture = !0;
    }
}
class $d7238066c5de7f1c$var$kR extends $d7238066c5de7f1c$var$iue {
    /**
   * Constructs a new node-based sampled texture.
   *
   * @param {string} name - The textures's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   * @param {?string} [access=null] - The access type.
   */ constructor(e, t, i, n = null){
        super(e, t ? t.value : null), this.textureNode = t, this.groupNode = i, this.access = n;
    }
    /**
   * Updates the binding.
   *
   * @return {boolean} Whether the texture has been updated and must be
   * uploaded to the GPU.
   */ update() {
        const { textureNode: e } = this;
        return this.texture !== e.value ? (this.texture = e.value, !0) : super.update();
    }
}
class $d7238066c5de7f1c$var$e_ extends $d7238066c5de7f1c$var$kR {
    /**
   * Constructs a new node-based sampled cube texture.
   *
   * @param {string} name - The textures's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   * @param {?string} [access=null] - The access type.
   */ constructor(e, t, i, n = null){
        super(e, t, i, n), this.isSampledCubeTexture = !0;
    }
}
class $d7238066c5de7f1c$var$D2 extends $d7238066c5de7f1c$var$kR {
    /**
   * Constructs a new node-based sampled 3D texture.
   *
   * @param {string} name - The textures's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   * @param {?string} [access=null] - The access type.
   */ constructor(e, t, i, n = null){
        super(e, t, i, n), this.isSampledTexture3D = !0;
    }
}
const $d7238066c5de7f1c$var$F9 = {
    bitcast_int_uint: new $d7238066c5de7f1c$var$Fr(/* glsl */ "uint tsl_bitcast_uint_to_int ( int x ) { return floatBitsToInt( uintBitsToFloat( x ) ); }"),
    bitcast_uint_int: new $d7238066c5de7f1c$var$Fr(/* glsl */ "uint tsl_bitcast_int_to_uint ( int x ) { return floatBitsToUint( intBitsToFloat ( x ) ); }")
}, $d7238066c5de7f1c$var$nue = {
    textureDimensions: "textureSize",
    equals: "equal",
    bitcast_float_int: "floatBitsToInt",
    bitcast_int_float: "intBitsToFloat",
    bitcast_uint_float: "uintBitsToFloat",
    bitcast_float_uint: "floatBitsToUint",
    bitcast_uint_int: "tsl_bitcast_uint_to_int",
    bitcast_int_uint: "tsl_bitcast_int_to_uint"
}, $d7238066c5de7f1c$var$sue = {
    low: "lowp",
    medium: "mediump",
    high: "highp"
}, $d7238066c5de7f1c$var$T9 = {
    swizzleAssign: !0,
    storageBuffer: !1
}, $d7238066c5de7f1c$var$M9 = {
    perspective: "smooth",
    linear: "noperspective"
}, $d7238066c5de7f1c$var$z9 = {
    centroid: "centroid"
}, $d7238066c5de7f1c$var$k9 = `
precision highp float;
precision highp int;
precision highp sampler2D;
precision highp sampler3D;
precision highp samplerCube;
precision highp sampler2DArray;

precision highp usampler2D;
precision highp usampler3D;
precision highp usamplerCube;
precision highp usampler2DArray;

precision highp isampler2D;
precision highp isampler3D;
precision highp isamplerCube;
precision highp isampler2DArray;

precision lowp sampler2DShadow;
precision lowp sampler2DArrayShadow;
precision lowp samplerCubeShadow;
`;
class $d7238066c5de7f1c$var$rue extends $d7238066c5de7f1c$var$UD {
    /**
   * Constructs a new GLSL node builder renderer.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Renderer} renderer - The renderer.
   */ constructor(e, t){
        super(e, t, new $d7238066c5de7f1c$var$Nce()), this.uniformGroups = {}, this.transforms = [], this.extensions = {}, this.builtins = {
            vertex: [],
            fragment: [],
            compute: []
        };
    }
    /**
   * Checks if the given texture requires a manual conversion to the working color space.
   *
   * @param {Texture} texture - The texture to check.
   * @return {boolean} Whether the given texture requires a conversion to working color space or not.
   */ needsToWorkingColorSpace(e) {
        return e.isVideoTexture === !0 && e.colorSpace !== $d7238066c5de7f1c$var$gh;
    }
    /**
   * Includes the given method name into the current
   * function node.
   *
   * @private
   * @param {string} name - The method name to include.
   * @return {CodeNode} The respective code node.
   */ _include(e) {
        const t = $d7238066c5de7f1c$var$F9[e];
        return t.build(this), this.addInclude(t), t;
    }
    /**
   * Returns the native shader method name for a given generic name.
   *
   * @param {string} method - The method name to resolve.
   * @return {string} The resolved GLSL method name.
   */ getMethod(e) {
        return $d7238066c5de7f1c$var$F9[e] !== void 0 && this._include(e), $d7238066c5de7f1c$var$nue[e] || e;
    }
    /**
   * Returns the bitcast method name for a given input and outputType.
   *
   * @param {string} type - The output type to bitcast to.
   * @param {string} inputType - The input type of the.
   * @return {string} The resolved WGSL bitcast invocation.
   */ getBitcastMethod(e, t) {
        return this.getMethod(`bitcast_${t}_${e}`);
    }
    /**
   * Returns the native snippet for a ternary operation.
   *
   * @param {string} condSnippet - The condition determining which expression gets resolved.
   * @param {string} ifSnippet - The expression to resolve to if the condition is true.
   * @param {string} elseSnippet - The expression to resolve to if the condition is false.
   * @return {string} The resolved method name.
   */ getTernary(e, t, i) {
        return `${e} ? ${t} : ${i}`;
    }
    /**
   * Returns the output struct name. Not relevant for GLSL.
   *
   * @return {string}
   */ getOutputStructName() {
        return "";
    }
    /**
   * Builds the given shader node.
   *
   * @param {ShaderNodeInternal} shaderNode - The shader node.
   * @return {string} The GLSL function code.
   */ buildFunctionCode(e) {
        const t = e.layout, i = this.flowShaderNode(e), n = [];
        for (const a of t.inputs)n.push(this.getType(a.type) + " " + a.name);
        return `${this.getType(t.type)} ${t.name}( ${n.join(", ")} ) {

	${i.vars}

${i.code}
	return ${i.result};

}`;
    }
    /**
   * Setups the Pixel Buffer Object (PBO) for the given storage
   * buffer node.
   *
   * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
   */ setupPBO(e) {
        const t = e.value;
        if (t.pbo === void 0) {
            const i = t.array, n = t.count * t.itemSize, { itemSize: s } = t, a = t.array.constructor.name.toLowerCase().includes("int");
            let o = a ? $d7238066c5de7f1c$var$aR : $d7238066c5de7f1c$var$rR;
            s === 2 ? o = a ? $d7238066c5de7f1c$var$oR : $d7238066c5de7f1c$var$gI : s === 3 ? o = a ? $d7238066c5de7f1c$var$D6 : $d7238066c5de7f1c$var$sR : s === 4 && (o = a ? $d7238066c5de7f1c$var$gR : $d7238066c5de7f1c$var$sg);
            const g = {
                Float32Array: $d7238066c5de7f1c$var$vo,
                Uint8Array: $d7238066c5de7f1c$var$Ya,
                Uint16Array: $d7238066c5de7f1c$var$wC,
                Uint32Array: $d7238066c5de7f1c$var$Xs,
                Int8Array: $d7238066c5de7f1c$var$fA,
                Int16Array: $d7238066c5de7f1c$var$GA,
                Int32Array: $d7238066c5de7f1c$var$Na,
                Uint8ClampedArray: $d7238066c5de7f1c$var$Ya
            }, l = Math.pow(2, Math.ceil(Math.log2(Math.sqrt(n / s))));
            let c = Math.ceil(n / s / l);
            l * c * s < n && c++;
            const d = l * c * s, p = new i.constructor(d);
            p.set(i, 0), t.array = p;
            const A = new $d7238066c5de7f1c$var$C3(t.array, l, c, o, g[t.array.constructor.name] || $d7238066c5de7f1c$var$vo);
            A.needsUpdate = !0, A.isPBOTexture = !0;
            const y = new $d7238066c5de7f1c$var$Iu(A, null, null);
            y.setPrecision("high"), t.pboNode = y, t.pbo = y.value, this.getUniformFromNode(t.pboNode, "texture", this.shaderStage, this.context.nodeName);
        }
    }
    /**
   * Returns a GLSL snippet that represents the property name of the given node.
   *
   * @param {Node} node - The node.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The property name.
   */ getPropertyName(e, t = this.shaderStage) {
        return e.isNodeUniform && e.node.isTextureNode !== !0 && e.node.isBufferNode !== !0 ? t.charAt(0) + "_" + e.name : super.getPropertyName(e, t);
    }
    /**
   * Setups the Pixel Buffer Object (PBO) for the given storage
   * buffer node.
   *
   * @param {StorageArrayElementNode} storageArrayElementNode - The storage array element node.
   * @return {string} The property name.
   */ generatePBO(e) {
        const { node: t, indexNode: i } = e, n = t.value;
        if (this.renderer.backend.has(n)) {
            const c = this.renderer.backend.get(n);
            c.pbo = n.pbo;
        }
        const s = this.getUniformFromNode(n.pboNode, "texture", this.shaderStage, this.context.nodeName), a = this.getPropertyName(s);
        this.increaseUsage(i);
        const o = i.build(this, "uint"), g = this.getDataFromNode(e);
        let l = g.propertyName;
        if (l === void 0) {
            const c = this.getVarFromNode(e);
            l = this.getPropertyName(c);
            const d = this.getDataFromNode(t);
            let p = d.propertySizeName;
            p === void 0 && (p = l + "Size", this.getVarFromNode(t, p, "uint"), this.addLineFlowCode(`${p} = uint( textureSize( ${a}, 0 ).x )`, e), d.propertySizeName = p);
            const { itemSize: A } = n, y = "." + $d7238066c5de7f1c$var$OC.join("").slice(0, A), G = `ivec2(${o} % ${p}, ${o} / ${p})`, Z = this.generateTextureLoad(null, a, G, "0", null, null);
            let v = "vec4";
            n.pbo.type === $d7238066c5de7f1c$var$Xs ? v = "uvec4" : n.pbo.type === $d7238066c5de7f1c$var$Na && (v = "ivec4"), this.addLineFlowCode(`${l} = ${v}(${Z})${y}`, e), g.propertyName = l;
        }
        return l;
    }
    /**
   * Generates the GLSL snippet that reads a single texel from a texture without sampling or filtering.
   *
   * @param {?Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvIndexSnippet - A GLSL snippet that represents texture coordinates used for sampling.
   * @param {?string} levelSnippet - A GLSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @param {?string} depthSnippet - A GLSL snippet that represents the 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The GLSL snippet.
   */ generateTextureLoad(e, t, i, n, s, a) {
        n === null && (n = "0");
        let o;
        return s ? a ? o = `texelFetchOffset( ${t}, ivec3( ${i}, ${s} ), ${n}, ${a} )` : o = `texelFetch( ${t}, ivec3( ${i}, ${s} ), ${n} )` : a ? o = `texelFetchOffset( ${t}, ${i}, ${n}, ${a} )` : o = `texelFetch( ${t}, ${i}, ${n} )`, e !== null && e.isDepthTexture && (o += ".x"), o;
    }
    /**
   * Generates the GLSL snippet for sampling/loading the given texture.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
   * @param {?string} depthSnippet -  A GLSL snippet that represents the 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The GLSL snippet.
   */ generateTexture(e, t, i, n, s) {
        return n && (i = `vec3( ${i}, ${n} )`), e.isDepthTexture ? s ? `textureOffset( ${t}, ${i}, ${s} ).x` : `texture( ${t}, ${i} ).x` : s ? `textureOffset( ${t}, ${i}, ${s} )` : `texture( ${t}, ${i} )`;
    }
    /**
   * Generates the GLSL snippet when sampling textures with explicit mip level.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
   * @param {string} levelSnippet - A GLSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The GLSL snippet.
   */ generateTextureLevel(e, t, i, n, s) {
        return s ? `textureLodOffset( ${t}, ${i}, ${n}, ${s} )` : `textureLod( ${t}, ${i}, ${n} )`;
    }
    /**
   * Generates the GLSL snippet when sampling textures with a bias to the mip level.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
   * @param {string} biasSnippet - A GLSL snippet that represents the bias to apply to the mip level before sampling.
   * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The GLSL snippet.
   */ generateTextureBias(e, t, i, n, s) {
        return s ? `textureOffset( ${t}, ${i}, ${s}, ${n} )` : `texture( ${t}, ${i}, ${n} )`;
    }
    /**
   * Generates the GLSL snippet for sampling/loading the given texture using explicit gradients.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
   * @param {Array<string>} gradSnippet - An array holding both gradient GLSL snippets.
   * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The GLSL snippet.
   */ generateTextureGrad(e, t, i, n, s) {
        return s ? `textureGradOffset( ${t}, ${i}, ${n[0]}, ${n[1]}, ${s} )` : `textureGrad( ${t}, ${i}, ${n[0]}, ${n[1]} )`;
    }
    /**
   * Generates the GLSL snippet for sampling a depth texture and comparing the sampled depth values
   * against a reference value.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
   * @param {string} compareSnippet -  A GLSL snippet that represents the reference value.
   * @param {?string} depthSnippet - A GLSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The GLSL snippet.
   */ generateTextureCompare(e, t, i, n, s, a, o = this.shaderStage) {
        if (o === "fragment") return s ? a ? `textureOffset( ${t}, vec4( ${i}, ${s}, ${n} ), ${a} )` : `texture( ${t}, vec4( ${i}, ${s}, ${n} ) )` : a ? `textureOffset( ${t}, vec3( ${i}, ${n} ), ${a} )` : `texture( ${t}, vec3( ${i}, ${n} ) )`;
        $d7238066c5de7f1c$var$nt(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${o} shader.`);
    }
    /**
   * Returns the variables of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the variables.
   */ getVars(e) {
        const t = [], i = this.vars[e];
        if (i !== void 0) for (const n of i)t.push(`${this.getVar(n.type, n.name, n.count)};`);
        return t.join(`
	`);
    }
    /**
   * Returns the uniforms of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the uniforms.
   */ getUniforms(e) {
        const t = this.uniforms[e], i = [], n = {};
        for (const a of t){
            let o = null, g = !1;
            if (a.type === "texture" || a.type === "texture3D") {
                const c = a.node.value;
                let d = "";
                (c.isDataTexture === !0 || c.isData3DTexture === !0) && (c.type === $d7238066c5de7f1c$var$Xs ? d = "u" : c.type === $d7238066c5de7f1c$var$Na && (d = "i")), a.type === "texture3D" && c.isArrayTexture === !1 ? o = `${d}sampler3D ${a.name};` : c.compareFunction ? c.isArrayTexture === !0 ? o = `sampler2DArrayShadow ${a.name};` : o = `sampler2DShadow ${a.name};` : c.isArrayTexture === !0 || c.isDataArrayTexture === !0 || c.isCompressedArrayTexture === !0 ? o = `${d}sampler2DArray ${a.name};` : o = `${d}sampler2D ${a.name};`;
            } else if (a.type === "cubeTexture") o = `samplerCube ${a.name};`;
            else if (a.type === "buffer") {
                const c = a.node, d = this.getType(c.bufferType), p = c.bufferCount, A = p > 0 ? p : "";
                o = `${c.name} {
	${d} ${a.name}[${A}];
};
`;
            } else o = `${this.getVectorType(a.type)} ${this.getPropertyName(a, e)};`, g = !0;
            const l = a.node.precision;
            if (l !== null && (o = $d7238066c5de7f1c$var$sue[l] + " " + o), g) {
                o = "	" + o;
                const c = a.groupNode.name;
                (n[c] || (n[c] = [])).push(o);
            } else o = "uniform " + o, i.push(o);
        }
        let s = "";
        for(const a in n){
            const o = n[a];
            s += this._getGLSLUniformStruct(e + "_" + a, o.join(`
`)) + `
`;
        }
        return s += i.join(`
`), s;
    }
    /**
   * Returns the type for a given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   * @return {string} The type.
   */ getTypeFromAttribute(e) {
        let t = super.getTypeFromAttribute(e);
        if (/^[iu]/.test(t) && e.gpuType !== $d7238066c5de7f1c$var$Na) {
            let i = e;
            e.isInterleavedBufferAttribute && (i = e.data);
            const n = i.array;
            n instanceof Uint32Array || n instanceof Int32Array || (t = t.slice(1));
        }
        return t;
    }
    /**
   * Returns the shader attributes of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the shader attributes.
   */ getAttributes(e) {
        let t = "";
        if (e === "vertex" || e === "compute") {
            const i = this.getAttributesArray();
            let n = 0;
            for (const s of i)t += `layout( location = ${n++} ) in ${s.type} ${s.name};
`;
        }
        return t;
    }
    /**
   * Returns the members of the given struct type node as a GLSL string.
   *
   * @param {StructTypeNode} struct - The struct type node.
   * @return {string} The GLSL snippet that defines the struct members.
   */ getStructMembers(e) {
        const t = [];
        for (const i of e.members)t.push(`	${i.type} ${i.name};`);
        return t.join(`
`);
    }
    /**
   * Returns the structs of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the structs.
   */ getStructs(e) {
        const t = [], i = this.structs[e], n = [];
        for (const s of i)if (s.output) for (const a of s.members)n.push(`layout( location = ${a.index} ) out ${a.type} ${a.name};`);
        else {
            let a = "struct " + s.name + ` {
`;
            a += this.getStructMembers(s), a += `
};
`, t.push(a);
        }
        return n.length === 0 && n.push("layout( location = 0 ) out vec4 fragColor;"), `
` + n.join(`
`) + `

` + t.join(`
`);
    }
    /**
   * Returns the varyings of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the varyings.
   */ getVaryings(e) {
        let t = "";
        const i = this.varyings;
        if (e === "vertex" || e === "compute") for (const n of i){
            e === "compute" && (n.needsInterpolation = !0);
            const s = this.getType(n.type);
            if (n.needsInterpolation) {
                if (n.interpolationType) {
                    const a = $d7238066c5de7f1c$var$M9[n.interpolationType] || n.interpolationType, o = $d7238066c5de7f1c$var$z9[n.interpolationSampling] || "";
                    t += `${a} ${o} out ${s} ${n.name};
`;
                } else {
                    const a = s.includes("int") || s.includes("uv") || s.includes("iv") ? "flat " : "";
                    t += `${a}out ${s} ${n.name};
`;
                }
            } else t += `${s} ${n.name};
`;
        }
        else if (e === "fragment") {
            for (const n of i)if (n.needsInterpolation) {
                const s = this.getType(n.type);
                if (n.interpolationType) {
                    const a = $d7238066c5de7f1c$var$M9[n.interpolationType] || n.interpolationType, o = $d7238066c5de7f1c$var$z9[n.interpolationSampling] || "";
                    t += `${a} ${o} in ${s} ${n.name};
`;
                } else {
                    const a = s.includes("int") || s.includes("uv") || s.includes("iv") ? "flat " : "";
                    t += `${a}in ${s} ${n.name};
`;
                }
            }
        }
        for (const n of this.builtins[e])t += `${n};
`;
        return t;
    }
    /**
   * Returns the vertex index builtin.
   *
   * @return {string} The vertex index.
   */ getVertexIndex() {
        return "uint( gl_VertexID )";
    }
    /**
   * Contextually returns either the vertex stage instance index builtin
   * or the linearized index of an compute invocation within a grid of workgroups.
   *
   * @return {string} The instance index.
   */ getInstanceIndex() {
        return "uint( gl_InstanceID )";
    }
    /**
   * Returns a builtin representing the index of an invocation within its workgroup.
   *
   * @return {string} The invocation local index.
   */ getInvocationLocalIndex() {
        return `uint( gl_InstanceID ) % ${this.object.workgroupSize.reduce((i, n)=>i * n, 1)}u`;
    }
    /**
   * Returns a builtin representing the size of a subgroup within the current shader.
   */ getSubgroupSize() {
        $d7238066c5de7f1c$var$nt("GLSLNodeBuilder: WebGLBackend does not support the subgroupSize node");
    }
    /**
   * Returns a builtin representing the index of an invocation within its subgroup.
   */ getInvocationSubgroupIndex() {
        $d7238066c5de7f1c$var$nt("GLSLNodeBuilder: WebGLBackend does not support the invocationSubgroupIndex node");
    }
    /**
   * Returns a builtin representing the index of the current invocation's subgroup within its workgroup.
   */ getSubgroupIndex() {
        $d7238066c5de7f1c$var$nt("GLSLNodeBuilder: WebGLBackend does not support the subgroupIndex node");
    }
    /**
   * Returns the draw index builtin.
   *
   * @return {?string} The drawIndex shader string. Returns `null` if `WEBGL_multi_draw` isn't supported by the device.
   */ getDrawIndex() {
        return this.renderer.backend.extensions.has("WEBGL_multi_draw") ? "uint( gl_DrawID )" : null;
    }
    /**
   * Returns the front facing builtin.
   *
   * @return {string} The front facing builtin.
   */ getFrontFacing() {
        return "gl_FrontFacing";
    }
    /**
   * Returns the frag coord builtin.
   *
   * @return {string} The frag coord builtin.
   */ getFragCoord() {
        return "gl_FragCoord.xy";
    }
    /**
   * Returns the frag depth builtin.
   *
   * @return {string} The frag depth builtin.
   */ getFragDepth() {
        return "gl_FragDepth";
    }
    /**
   * Enables the given extension.
   *
   * @param {string} name - The extension name.
   * @param {string} behavior - The extension behavior.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage.
   */ enableExtension(e, t, i = this.shaderStage) {
        const n = this.extensions[i] || (this.extensions[i] = /* @__PURE__ */ new Map());
        n.has(e) === !1 && n.set(e, {
            name: e,
            behavior: t
        });
    }
    /**
   * Returns the enabled extensions of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the enabled extensions.
   */ getExtensions(e) {
        const t = [];
        if (e === "vertex") {
            const n = this.renderer.backend.extensions;
            this.object.isBatchedMesh && n.has("WEBGL_multi_draw") && this.enableExtension("GL_ANGLE_multi_draw", "require", e);
        }
        const i = this.extensions[e];
        if (i !== void 0) for (const { name: n, behavior: s } of i.values())t.push(`#extension ${n} : ${s}`);
        return t.join(`
`);
    }
    /**
   * Returns the clip distances builtin.
   *
   * @return {string} The clip distances builtin.
   */ getClipDistance() {
        return "gl_ClipDistance";
    }
    /**
   * Whether the requested feature is available or not.
   *
   * @param {string} name - The requested feature.
   * @return {boolean} Whether the requested feature is supported or not.
   */ isAvailable(e) {
        let t = $d7238066c5de7f1c$var$T9[e];
        if (t === void 0) {
            let i;
            switch(t = !1, e){
                case "float32Filterable":
                    i = "OES_texture_float_linear";
                    break;
                case "clipDistance":
                    i = "WEBGL_clip_cull_distance";
                    break;
            }
            if (i !== void 0) {
                const n = this.renderer.backend.extensions;
                n.has(i) && (n.get(i), t = !0);
            }
            $d7238066c5de7f1c$var$T9[e] = t;
        }
        return t;
    }
    /**
   * Whether to flip texture data along its vertical axis or not.
   *
   * @return {boolean} Returns always `true` in context of GLSL.
   */ isFlipY() {
        return !0;
    }
    /**
   * Enables hardware clipping.
   *
   * @param {string} planeCount - The clipping plane count.
   */ enableHardwareClipping(e) {
        this.enableExtension("GL_ANGLE_clip_cull_distance", "require"), this.builtins.vertex.push(`out float gl_ClipDistance[ ${e} ]`);
    }
    /**
   * Enables multiview.
   */ enableMultiview() {
        this.enableExtension("GL_OVR_multiview2", "require", "fragment"), this.enableExtension("GL_OVR_multiview2", "require", "vertex"), this.builtins.vertex.push("layout(num_views = 2) in");
    }
    /**
   * Registers a transform in context of Transform Feedback.
   *
   * @param {string} varyingName - The varying name.
   * @param {AttributeNode} attributeNode - The attribute node.
   */ registerTransform(e, t) {
        this.transforms.push({
            varyingName: e,
            attributeNode: t
        });
    }
    /**
   * Returns the transforms of the given shader stage as a GLSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The GLSL snippet that defines the transforms.
   */ getTransforms() {
        const e = this.transforms;
        let t = "";
        for(let i = 0; i < e.length; i++){
            const n = e[i], s = this.getPropertyName(n.attributeNode);
            s && (t += `${n.varyingName} = ${s};
	`);
        }
        return t;
    }
    /**
   * Returns a GLSL struct based on the given name and variables.
   *
   * @private
   * @param {string} name - The struct name.
   * @param {string} vars - The struct variables.
   * @return {string} The GLSL snippet representing a struct.
   */ _getGLSLUniformStruct(e, t) {
        return `
layout( std140 ) uniform ${e} {
${t}
};`;
    }
    /**
   * Returns a GLSL vertex shader based on the given shader data.
   *
   * @private
   * @param {Object} shaderData - The shader data.
   * @return {string} The vertex shader.
   */ _getGLSLVertexCode(e) {
        return `#version 300 es

${this.getSignature()}

// extensions
${e.extensions}

// precision
${$d7238066c5de7f1c$var$k9}

// uniforms
${e.uniforms}

// varyings
${e.varyings}

// attributes
${e.attributes}

// codes
${e.codes}

void main() {

	// vars
	${e.vars}

	// transforms
	${e.transforms}

	// flow
	${e.flow}

	gl_PointSize = 1.0;

}
`;
    }
    /**
   * Returns a GLSL fragment shader based on the given shader data.
   *
   * @private
   * @param {Object} shaderData - The shader data.
   * @return {string} The vertex shader.
   */ _getGLSLFragmentCode(e) {
        return `#version 300 es

${this.getSignature()}

// extensions
${e.extensions}

// precision
${$d7238066c5de7f1c$var$k9}

// structs
${e.structs}

// uniforms
${e.uniforms}

// varyings
${e.varyings}

// codes
${e.codes}

void main() {

	// vars
	${e.vars}

	// flow
	${e.flow}

}
`;
    }
    /**
   * Controls the code build of the shader stages.
   */ buildCode() {
        const e = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const t in e){
            let i = `// code

`;
            i += this.flowCode[t];
            const n = this.flowNodes[t], s = n[n.length - 1];
            for (const o of n){
                const g = this.getFlowData(o), l = o.name;
                l && (i.length > 0 && (i += `
`), i += `	// flow -> ${l}
	`), i += `${g.code}
	`, o === s && t !== "compute" && (i += `// result
	`, t === "vertex" ? (i += "gl_Position = ", i += `${g.result};`) : t === "fragment" && (o.outputNode.isOutputStructNode || (i += "fragColor = ", i += `${g.result};`)));
            }
            const a = e[t];
            a.extensions = this.getExtensions(t), a.uniforms = this.getUniforms(t), a.attributes = this.getAttributes(t), a.varyings = this.getVaryings(t), a.vars = this.getVars(t), a.structs = this.getStructs(t), a.codes = this.getCodes(t), a.transforms = this.getTransforms(t), a.flow = i;
        }
        this.material !== null ? (this.vertexShader = this._getGLSLVertexCode(e.vertex), this.fragmentShader = this._getGLSLFragmentCode(e.fragment)) : this.computeShader = this._getGLSLVertexCode(e.compute);
    }
    /**
   * This method is one of the more important ones since it's responsible
   * for generating a matching binding instance for the given uniform node.
   *
   * These bindings are later used in the renderer to create bind groups
   * and layouts.
   *
   * @param {UniformNode} node - The uniform node.
   * @param {string} type - The node data type.
   * @param {string} shaderStage - The shader stage.
   * @param {?string} [name=null] - An optional uniform name.
   * @return {NodeUniform} The node uniform object.
   */ getUniformFromNode(e, t, i, n = null) {
        const s = super.getUniformFromNode(e, t, i, n), a = this.getDataFromNode(e, i, this.globalCache);
        let o = a.uniformGPU;
        if (o === void 0) {
            const g = e.groupNode, l = g.name, c = this.getBindGroupArray(l, i);
            if (t === "texture") o = new $d7238066c5de7f1c$var$kR(s.name, s.node, g), c.push(o);
            else if (t === "cubeTexture") o = new $d7238066c5de7f1c$var$e_(s.name, s.node, g), c.push(o);
            else if (t === "texture3D") o = new $d7238066c5de7f1c$var$D2(s.name, s.node, g), c.push(o);
            else if (t === "buffer") {
                e.name = `NodeBuffer_${e.id}`, s.name = `buffer${e.id}`;
                const d = new $d7238066c5de7f1c$var$jD(e, g);
                d.name = e.name, c.push(d), o = d;
            } else {
                const d = this.uniformGroups[i] || (this.uniformGroups[i] = {});
                let p = d[l];
                p === void 0 && (p = new $d7238066c5de7f1c$var$qD(i + "_" + l, g), d[l] = p, c.push(p)), o = this.getNodeUniform(s, t), p.addUniform(o);
            }
            a.uniformGPU = o;
        }
        return s;
    }
}
let $d7238066c5de7f1c$var$YH = null, $d7238066c5de7f1c$var$Jm = null;
class $d7238066c5de7f1c$var$t_ {
    /**
   * Constructs a new backend.
   *
   * @param {Object} parameters - An object holding parameters for the backend.
   */ constructor(e = {}){
        this.parameters = Object.assign({}, e), this.data = /* @__PURE__ */ new WeakMap(), this.renderer = null, this.domElement = null, this.timestampQueryPool = {
            [$d7238066c5de7f1c$var$$c.RENDER]: null,
            [$d7238066c5de7f1c$var$$c.COMPUTE]: null
        }, this.trackTimestamp = e.trackTimestamp === !0;
    }
    /**
   * Initializes the backend so it is ready for usage. Concrete backends
   * are supposed to implement their rendering context creation and related
   * operations in this method.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the backend has been initialized.
   */ async init(e) {
        this.renderer = e;
    }
    /**
   * The coordinate system of the backend.
   *
   * @abstract
   * @type {number}
   * @readonly
   */ get coordinateSystem() {}
    // render context
    /**
   * This method is executed at the beginning of a render call and
   * can be used by the backend to prepare the state for upcoming
   * draw calls.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   */ beginRender() {}
    /**
   * This method is executed at the end of a render call and
   * can be used by the backend to finalize work after draw
   * calls.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   */ finishRender() {}
    /**
   * This method is executed at the beginning of a compute call and
   * can be used by the backend to prepare the state for upcoming
   * compute tasks.
   *
   * @abstract
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */ beginCompute() {}
    /**
   * This method is executed at the end of a compute call and
   * can be used by the backend to finalize work after compute
   * tasks.
   *
   * @abstract
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */ finishCompute() {}
    // render object
    /**
   * Executes a draw command for the given render object.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object to draw.
   * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
   */ draw() {}
    // compute node
    /**
   * Executes a compute command for the given compute node.
   *
   * @abstract
   * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   */ compute() {}
    // program
    /**
   * Creates a shader program from the given programmable stage.
   *
   * @abstract
   * @param {ProgrammableStage} program - The programmable stage.
   */ createProgram() {}
    /**
   * Destroys the shader program of the given programmable stage.
   *
   * @abstract
   * @param {ProgrammableStage} program - The programmable stage.
   */ destroyProgram() {}
    // bindings
    /**
   * Creates bindings from the given bind group definition.
   *
   * @abstract
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ createBindings() {}
    /**
   * Updates the given bind group definition.
   *
   * @abstract
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ updateBindings() {}
    /**
   * Updates a buffer binding.
   *
   * @abstract
   * @param {Buffer} binding - The buffer binding to update.
   */ updateBinding() {}
    // pipeline
    /**
   * Creates a render pipeline for the given render object.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */ createRenderPipeline() {}
    /**
   * Creates a compute pipeline for the given compute node.
   *
   * @abstract
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */ createComputePipeline() {}
    // cache key
    /**
   * Returns `true` if the render pipeline requires an update.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the render pipeline requires an update or not.
   */ needsRenderUpdate() {}
    /**
   * Returns a cache key that is used to identify render pipelines.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @return {string} The cache key.
   */ getRenderCacheKey() {}
    // node builder
    /**
   * Returns a node builder for the given render object.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @param {Renderer} renderer - The renderer.
   * @return {NodeBuilder} The node builder.
   */ createNodeBuilder() {}
    // textures
    /**
   * Updates a GPU sampler for the given texture.
   *
   * @abstract
   * @param {Texture} texture - The texture to update the sampler for.
   * @return {string} The current sampler key.
   */ updateSampler() {}
    /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @abstract
   * @param {Texture} texture - The texture to create a default texture for.
   */ createDefaultTexture() {}
    /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ createTexture() {}
    /**
   * Uploads the updated texture data to the GPU.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ updateTexture() {}
    /**
   * Generates mipmaps for the given texture.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   */ generateMipmaps() {}
    /**
   * Destroys the GPU data for the given texture object.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
   */ destroyTexture() {}
    /**
   * Returns texture data as a typed array.
   *
   * @abstract
   * @async
   * @param {Texture} texture - The texture to copy.
   * @param {number} x - The x coordinate of the copy origin.
   * @param {number} y - The y coordinate of the copy origin.
   * @param {number} width - The width of the copy.
   * @param {number} height - The height of the copy.
   * @param {number} faceIndex - The face index.
   * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
   */ async copyTextureToBuffer() {}
    /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @abstract
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
   * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
   * @param {number} [srcLevel=0] - The source mip level to copy from.
   * @param {number} [dstLevel=0] - The destination mip level to copy to.
   */ copyTextureToTexture() {}
    /**
  * Copies the current bound framebuffer to the given texture.
  *
  * @abstract
  * @param {Texture} texture - The destination texture.
  * @param {RenderContext} renderContext - The render context.
  * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
  */ copyFramebufferToTexture() {}
    // attributes
    /**
   * Creates the GPU buffer of a shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createAttribute() {}
    /**
   * Creates the GPU buffer of an indexed shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The indexed buffer attribute.
   */ createIndexAttribute() {}
    /**
   * Creates the GPU buffer of a storage attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createStorageAttribute() {}
    /**
   * Updates the GPU buffer of a shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute to update.
   */ updateAttribute() {}
    /**
   * Destroys the GPU buffer of a shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute to destroy.
   */ destroyAttribute() {}
    // canvas
    /**
   * Returns the backend's rendering context.
   *
   * @abstract
   * @return {Object} The rendering context.
   */ getContext() {}
    /**
   * Backends can use this method if they have to run
   * logic when the renderer gets resized.
   *
   * @abstract
   */ updateSize() {}
    /**
   * Updates the viewport with the values from the given render context.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   */ updateViewport() {}
    // utils
    /**
   * Updates a unique identifier for the given render context that can be used
   * to allocate resources like occlusion queries or timestamp queries.
   *
   * @param {RenderContext|ComputeNode} abstractRenderContext - The render context.
   */ updateTimeStampUID(e) {
        const t = this.get(e), i = this.renderer.info.frame;
        let n;
        e.isComputeNode === !0 ? n = "c:" + this.renderer.info.compute.frameCalls : n = "r:" + this.renderer.info.render.frameCalls, t.timestampUID = n + ":" + e.id + ":f" + i;
    }
    /**
   * Returns a unique identifier for the given render context that can be used
   * to allocate resources like occlusion queries or timestamp queries.
   *
   * @param {RenderContext|ComputeNode} abstractRenderContext - The render context.
   * @return {string} The unique identifier.
   */ getTimestampUID(e) {
        return this.get(e).timestampUID;
    }
    /**
   * Returns all timestamp frames for the given type.
   *
   * @param {string} type - The type of the time stamp.
   * @return {Array<number>} The timestamp frames.
   */ getTimestampFrames(e) {
        const t = this.timestampQueryPool[e];
        return t ? t.getTimestampFrames() : [];
    }
    /**
   * Returns the query pool for the given uid.
   *
   * @param {string} uid - The unique identifier.
   * @return {TimestampQueryPool} The query pool.
   */ _getQueryPool(e) {
        const t = e.startsWith("c:") ? $d7238066c5de7f1c$var$$c.COMPUTE : $d7238066c5de7f1c$var$$c.RENDER;
        return this.timestampQueryPool[t];
    }
    /**
   * Returns the timestamp for the given uid.
   *
   * @param {string} uid - The unique identifier.
   * @return {number} The timestamp.
   */ getTimestamp(e) {
        return this._getQueryPool(e).getTimestamp(e);
    }
    /**
   * Returns `true` if a timestamp for the given uid is available.
   *
   * @param {string} uid - The unique identifier.
   * @return {boolean} Whether the timestamp is available or not.
   */ hasTimestamp(e) {
        return this._getQueryPool(e).hasTimestamp(e);
    }
    /**
   * Returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene. Backends must implement this method by using
   * a Occlusion Query API.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object is fully occluded or not.
   */ isOccluded() {}
    /**
   * Resolves the time stamp for the given render context and type.
   *
   * @async
   * @abstract
   * @param {string} [type='render'] - The type of the time stamp.
   * @return {Promise<number>} A Promise that resolves with the time stamp.
   */ async resolveTimestampsAsync(e = "render") {
        if (!this.trackTimestamp) {
            $d7238066c5de7f1c$var$es("WebGPURenderer: Timestamp tracking is disabled.");
            return;
        }
        const t = this.timestampQueryPool[e];
        if (!t) return;
        const i = await t.resolveQueriesAsync();
        return this.renderer.info[e].timestamp = i, i;
    }
    /**
   * This method performs a readback operation by moving buffer data from
   * a storage buffer attribute from the GPU to the CPU.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */ async getArrayBufferAsync() {}
    /**
   * Checks if the given feature is supported by the backend.
   *
   * @async
   * @abstract
   * @param {string} name - The feature's name.
   * @return {Promise<boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
   */ async hasFeatureAsync() {}
    /**
   * Checks if the given feature is supported  by the backend.
   *
   * @abstract
   * @param {string} name - The feature's name.
   * @return {boolean} Whether the feature is supported or not.
   */ hasFeature() {}
    /**
   * Returns the maximum anisotropy texture filtering value.
   *
   * @abstract
   * @return {number} The maximum anisotropy texture filtering value.
   */ getMaxAnisotropy() {}
    /**
   * Returns the drawing buffer size.
   *
   * @return {Vector2} The drawing buffer size.
   */ getDrawingBufferSize() {
        return $d7238066c5de7f1c$var$YH = $d7238066c5de7f1c$var$YH || new $d7238066c5de7f1c$var$Ii(), this.renderer.getDrawingBufferSize($d7238066c5de7f1c$var$YH);
    }
    /**
   * Defines the scissor test.
   *
   * @abstract
   * @param {boolean} boolean - Whether the scissor test should be enabled or not.
   */ setScissorTest() {}
    /**
   * Returns the clear color and alpha into a single
   * color object.
   *
   * @return {Color4} The clear color.
   */ getClearColor() {
        const e = this.renderer;
        return $d7238066c5de7f1c$var$Jm = $d7238066c5de7f1c$var$Jm || new $d7238066c5de7f1c$var$fY(), e.getClearColor($d7238066c5de7f1c$var$Jm), $d7238066c5de7f1c$var$Jm.getRGB($d7238066c5de7f1c$var$Jm), $d7238066c5de7f1c$var$Jm;
    }
    /**
   * Returns the DOM element. If no DOM element exists, the backend
   * creates a new one.
   *
   * @return {HTMLCanvasElement} The DOM element.
   */ getDomElement() {
        let e = this.domElement;
        return e === null && (e = this.parameters.canvas !== void 0 ? this.parameters.canvas : $d7238066c5de7f1c$var$c$(), "setAttribute" in e && e.setAttribute("data-engine", `three.js r${$d7238066c5de7f1c$var$MB} webgpu`), this.domElement = e), e;
    }
    /**
   * Sets a dictionary for the given object into the
   * internal data structure.
   *
   * @param {Object} object - The object.
   * @param {Object} value - The dictionary to set.
   */ set(e, t) {
        this.data.set(e, t);
    }
    /**
   * Returns the dictionary for the given object.
   *
   * @param {Object} object - The object.
   * @return {Object} The object's dictionary.
   */ get(e) {
        let t = this.data.get(e);
        return t === void 0 && (t = {}, this.data.set(e, t)), t;
    }
    /**
   * Checks if the given object has a dictionary
   * with data defined.
   *
   * @param {Object} object - The object.
   * @return {boolean} Whether a dictionary for the given object as been defined or not.
   */ has(e) {
        return this.data.has(e);
    }
    /**
   * Deletes an object from the internal data structure.
   *
   * @param {Object} object - The object to delete.
   */ delete(e) {
        this.data.delete(e);
    }
    /**
   * Frees internal resources.
   *
   * @abstract
   */ dispose() {}
}
let $d7238066c5de7f1c$var$aue = 0;
class $d7238066c5de7f1c$var$oue {
    constructor(e, t){
        this.buffers = [
            e.bufferGPU,
            t
        ], this.type = e.type, this.bufferType = e.bufferType, this.pbo = e.pbo, this.byteLength = e.byteLength, this.bytesPerElement = e.BYTES_PER_ELEMENT, this.version = e.version, this.isInteger = e.isInteger, this.activeBufferIndex = 0, this.baseId = e.id;
    }
    get id() {
        return `${this.baseId}|${this.activeBufferIndex}`;
    }
    get bufferGPU() {
        return this.buffers[this.activeBufferIndex];
    }
    get transformBuffer() {
        return this.buffers[this.activeBufferIndex ^ 1];
    }
    switchBuffers() {
        this.activeBufferIndex ^= 1;
    }
}
class $d7238066c5de7f1c$var$gue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGLBackend} backend - The WebGL 2 backend.
   */ constructor(e){
        this.backend = e;
    }
    /**
   * Creates the GPU buffer for the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   * @param {GLenum } bufferType - A flag that indicates the buffer type and thus binding point target.
   */ createAttribute(e, t) {
        const i = this.backend, { gl: n } = i, s = e.array, a = e.usage || n.STATIC_DRAW, o = e.isInterleavedBufferAttribute ? e.data : e, g = i.get(o);
        let l = g.bufferGPU;
        l === void 0 && (l = this._createBuffer(n, t, s, a), g.bufferGPU = l, g.bufferType = t, g.version = o.version);
        let c;
        if (s instanceof Float32Array) c = n.FLOAT;
        else if (typeof Float16Array < "u" && s instanceof Float16Array) c = n.HALF_FLOAT;
        else if (s instanceof Uint16Array) e.isFloat16BufferAttribute ? c = n.HALF_FLOAT : c = n.UNSIGNED_SHORT;
        else if (s instanceof Int16Array) c = n.SHORT;
        else if (s instanceof Uint32Array) c = n.UNSIGNED_INT;
        else if (s instanceof Int32Array) c = n.INT;
        else if (s instanceof Int8Array) c = n.BYTE;
        else if (s instanceof Uint8Array) c = n.UNSIGNED_BYTE;
        else if (s instanceof Uint8ClampedArray) c = n.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLBackend: Unsupported buffer data format: " + s);
        let d = {
            bufferGPU: l,
            bufferType: t,
            type: c,
            byteLength: s.byteLength,
            bytesPerElement: s.BYTES_PER_ELEMENT,
            version: e.version,
            pbo: e.pbo,
            isInteger: c === n.INT || c === n.UNSIGNED_INT || e.gpuType === $d7238066c5de7f1c$var$Na,
            id: $d7238066c5de7f1c$var$aue++
        };
        if (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) {
            const p = this._createBuffer(n, t, s, a);
            d = new $d7238066c5de7f1c$var$oue(d, p);
        }
        i.set(e, d);
    }
    /**
   * Updates the GPU buffer of the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ updateAttribute(e) {
        const t = this.backend, { gl: i } = t, n = e.array, s = e.isInterleavedBufferAttribute ? e.data : e, a = t.get(s), o = a.bufferType, g = e.isInterleavedBufferAttribute ? e.data.updateRanges : e.updateRanges;
        if (i.bindBuffer(o, a.bufferGPU), g.length === 0) i.bufferSubData(o, 0, n);
        else {
            for(let l = 0, c = g.length; l < c; l++){
                const d = g[l];
                i.bufferSubData(o, d.start * n.BYTES_PER_ELEMENT, n, d.start, d.count);
            }
            s.clearUpdateRanges();
        }
        i.bindBuffer(o, null), a.version = s.version;
    }
    /**
   * Destroys the GPU buffer of the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ destroyAttribute(e) {
        const t = this.backend, { gl: i } = t;
        e.isInterleavedBufferAttribute && t.delete(e.data);
        const n = t.get(e);
        i.deleteBuffer(n.bufferGPU), t.delete(e);
    }
    /**
   * This method performs a readback operation by moving buffer data from
   * a storage buffer attribute from the GPU to the CPU.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */ async getArrayBufferAsync(e) {
        const t = this.backend, { gl: i } = t, n = e.isInterleavedBufferAttribute ? e.data : e, { bufferGPU: s } = t.get(n), a = e.array, o = a.byteLength;
        i.bindBuffer(i.COPY_READ_BUFFER, s);
        const g = i.createBuffer();
        i.bindBuffer(i.COPY_WRITE_BUFFER, g), i.bufferData(i.COPY_WRITE_BUFFER, o, i.STREAM_READ), i.copyBufferSubData(i.COPY_READ_BUFFER, i.COPY_WRITE_BUFFER, 0, 0, o), await t.utils._clientWaitAsync();
        const l = new e.array.constructor(a.length);
        return i.bindBuffer(i.COPY_WRITE_BUFFER, g), i.getBufferSubData(i.COPY_WRITE_BUFFER, 0, l), i.deleteBuffer(g), i.bindBuffer(i.COPY_READ_BUFFER, null), i.bindBuffer(i.COPY_WRITE_BUFFER, null), l.buffer;
    }
    /**
   * Creates a WebGL buffer with the given data.
   *
   * @private
   * @param {WebGL2RenderingContext} gl - The rendering context.
   * @param {GLenum } bufferType - A flag that indicates the buffer type and thus binding point target.
   * @param {TypedArray} array - The array of the buffer attribute.
   * @param {GLenum} usage - The usage.
   * @return {WebGLBuffer} The WebGL buffer.
   */ _createBuffer(e, t, i, n) {
        const s = e.createBuffer();
        return e.bindBuffer(t, s), e.bufferData(t, i, n), e.bindBuffer(t, null), s;
    }
}
let $d7238066c5de7f1c$var$KH, $d7238066c5de7f1c$var$Qb;
class $d7238066c5de7f1c$var$lue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGLBackend} backend - The WebGL 2 backend.
   */ constructor(e){
        this.backend = e, this.gl = this.backend.gl, this.enabled = {}, this.currentFlipSided = null, this.currentCullFace = null, this.currentProgram = null, this.currentBlendingEnabled = !1, this.currentBlending = null, this.currentBlendSrc = null, this.currentBlendDst = null, this.currentBlendSrcAlpha = null, this.currentBlendDstAlpha = null, this.currentPremultipledAlpha = null, this.currentPolygonOffsetFactor = null, this.currentPolygonOffsetUnits = null, this.currentColorMask = null, this.currentDepthFunc = null, this.currentDepthMask = null, this.currentStencilFunc = null, this.currentStencilRef = null, this.currentStencilFuncMask = null, this.currentStencilFail = null, this.currentStencilZFail = null, this.currentStencilZPass = null, this.currentStencilMask = null, this.currentLineWidth = null, this.currentClippingPlanes = 0, this.currentVAO = null, this.currentIndex = null, this.currentBoundFramebuffers = {}, this.currentDrawbuffers = /* @__PURE__ */ new WeakMap(), this.maxTextures = this.gl.getParameter(this.gl.MAX_TEXTURE_IMAGE_UNITS), this.currentTextureSlot = null, this.currentBoundTextures = {}, this.currentBoundBufferBases = {}, this._init();
    }
    /**
   * Inits the state of the utility.
   *
   * @private
   */ _init() {
        const e = this.gl;
        $d7238066c5de7f1c$var$KH = {
            [$d7238066c5de7f1c$var$Pl]: e.FUNC_ADD,
            [$d7238066c5de7f1c$var$Xk]: e.FUNC_SUBTRACT,
            [$d7238066c5de7f1c$var$Nk]: e.FUNC_REVERSE_SUBTRACT
        }, $d7238066c5de7f1c$var$Qb = {
            [$d7238066c5de7f1c$var$kd]: e.ZERO,
            [$d7238066c5de7f1c$var$Lk]: e.ONE,
            [$d7238066c5de7f1c$var$Yk]: e.SRC_COLOR,
            [$d7238066c5de7f1c$var$OS]: e.SRC_ALPHA,
            [$d7238066c5de7f1c$var$zk]: e.SRC_ALPHA_SATURATE,
            [$d7238066c5de7f1c$var$Tk]: e.DST_COLOR,
            [$d7238066c5de7f1c$var$xk]: e.DST_ALPHA,
            [$d7238066c5de7f1c$var$Kk]: e.ONE_MINUS_SRC_COLOR,
            [$d7238066c5de7f1c$var$jS]: e.ONE_MINUS_SRC_ALPHA,
            [$d7238066c5de7f1c$var$Mk]: e.ONE_MINUS_DST_COLOR,
            [$d7238066c5de7f1c$var$Fk]: e.ONE_MINUS_DST_ALPHA
        };
        const t = e.getParameter(e.SCISSOR_BOX), i = e.getParameter(e.VIEWPORT);
        this.currentScissor = new $d7238066c5de7f1c$var$Gi().fromArray(t), this.currentViewport = new $d7238066c5de7f1c$var$Gi().fromArray(i), this._tempVec4 = new $d7238066c5de7f1c$var$Gi();
    }
    /**
   * Enables the given WebGL capability.
   *
   * This method caches the capability state so
   * `gl.enable()` is only called when necessary.
   *
   * @param {GLenum} id - The capability to enable.
   */ enable(e) {
        const { enabled: t } = this;
        t[e] !== !0 && (this.gl.enable(e), t[e] = !0);
    }
    /**
   * Disables the given WebGL capability.
   *
   * This method caches the capability state so
   * `gl.disable()` is only called when necessary.
   *
   * @param {GLenum} id - The capability to enable.
   */ disable(e) {
        const { enabled: t } = this;
        t[e] !== !1 && (this.gl.disable(e), t[e] = !1);
    }
    /**
   * Specifies whether polygons are front- or back-facing
   * by setting the winding orientation.
   *
   * This method caches the state so `gl.frontFace()` is only
   * called when necessary.
   *
   * @param {boolean} flipSided - Whether triangles flipped their sides or not.
   */ setFlipSided(e) {
        if (this.currentFlipSided !== e) {
            const { gl: t } = this;
            e ? t.frontFace(t.CW) : t.frontFace(t.CCW), this.currentFlipSided = e;
        }
    }
    /**
   * Specifies whether or not front- and/or back-facing
   * polygons can be culled.
   *
   * This method caches the state so `gl.cullFace()` is only
   * called when necessary.
   *
   * @param {number} cullFace - Defines which polygons are candidates for culling.
   */ setCullFace(e) {
        const { gl: t } = this;
        e !== $d7238066c5de7f1c$var$W6 ? (this.enable(t.CULL_FACE), e !== this.currentCullFace && (e === $d7238066c5de7f1c$var$H6 ? t.cullFace(t.BACK) : e === $d7238066c5de7f1c$var$X6 ? t.cullFace(t.FRONT) : t.cullFace(t.FRONT_AND_BACK))) : this.disable(t.CULL_FACE), this.currentCullFace = e;
    }
    /**
   * Specifies the width of line primitives.
   *
   * This method caches the state so `gl.lineWidth()` is only
   * called when necessary.
   *
   * @param {number} width - The line width.
   */ setLineWidth(e) {
        const { currentLineWidth: t, gl: i } = this;
        e !== t && (i.lineWidth(e), this.currentLineWidth = e);
    }
    /**
   * Defines the blending.
   *
   * This method caches the state so `gl.blendEquation()`, `gl.blendEquationSeparate()`,
   * `gl.blendFunc()` and  `gl.blendFuncSeparate()` are only called when necessary.
   *
   * @param {number} blending - The blending type.
   * @param {number} blendEquation - The blending equation.
   * @param {number} blendSrc - Only relevant for custom blending. The RGB source blending factor.
   * @param {number} blendDst - Only relevant for custom blending. The RGB destination blending factor.
   * @param {number} blendEquationAlpha - Only relevant for custom blending. The blending equation for alpha.
   * @param {number} blendSrcAlpha - Only relevant for custom blending. The alpha source blending factor.
   * @param {number} blendDstAlpha - Only relevant for custom blending. The alpha destination blending factor.
   * @param {boolean} premultipliedAlpha - Whether premultiplied alpha is enabled or not.
   */ setBlending(e, t, i, n, s, a, o, g) {
        const { gl: l } = this;
        if (e === $d7238066c5de7f1c$var$xA) {
            this.currentBlendingEnabled === !0 && (this.disable(l.BLEND), this.currentBlendingEnabled = !1);
            return;
        }
        if (this.currentBlendingEnabled === !1 && (this.enable(l.BLEND), this.currentBlendingEnabled = !0), e !== $d7238066c5de7f1c$var$Yy) {
            if (e !== this.currentBlending || g !== this.currentPremultipledAlpha) {
                if ((this.currentBlendEquation !== $d7238066c5de7f1c$var$Pl || this.currentBlendEquationAlpha !== $d7238066c5de7f1c$var$Pl) && (l.blendEquation(l.FUNC_ADD), this.currentBlendEquation = $d7238066c5de7f1c$var$Pl, this.currentBlendEquationAlpha = $d7238066c5de7f1c$var$Pl), g) switch(e){
                    case $d7238066c5de7f1c$var$uI:
                        l.blendFuncSeparate(l.ONE, l.ONE_MINUS_SRC_ALPHA, l.ONE, l.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d7238066c5de7f1c$var$_S:
                        l.blendFunc(l.ONE, l.ONE);
                        break;
                    case $d7238066c5de7f1c$var$PS:
                        l.blendFuncSeparate(l.ZERO, l.ONE_MINUS_SRC_COLOR, l.ZERO, l.ONE);
                        break;
                    case $d7238066c5de7f1c$var$QS:
                        l.blendFuncSeparate(l.DST_COLOR, l.ONE_MINUS_SRC_ALPHA, l.ZERO, l.ONE);
                        break;
                    default:
                        $d7238066c5de7f1c$var$nt("WebGLState: Invalid blending: ", e);
                        break;
                }
                else switch(e){
                    case $d7238066c5de7f1c$var$uI:
                        l.blendFuncSeparate(l.SRC_ALPHA, l.ONE_MINUS_SRC_ALPHA, l.ONE, l.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d7238066c5de7f1c$var$_S:
                        l.blendFuncSeparate(l.SRC_ALPHA, l.ONE, l.ONE, l.ONE);
                        break;
                    case $d7238066c5de7f1c$var$PS:
                        $d7238066c5de7f1c$var$nt("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                        break;
                    case $d7238066c5de7f1c$var$QS:
                        $d7238066c5de7f1c$var$nt("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                        break;
                    default:
                        $d7238066c5de7f1c$var$nt("WebGLState: Invalid blending: ", e);
                        break;
                }
                this.currentBlendSrc = null, this.currentBlendDst = null, this.currentBlendSrcAlpha = null, this.currentBlendDstAlpha = null, this.currentBlending = e, this.currentPremultipledAlpha = g;
            }
            return;
        }
        s = s || t, a = a || i, o = o || n, (t !== this.currentBlendEquation || s !== this.currentBlendEquationAlpha) && (l.blendEquationSeparate($d7238066c5de7f1c$var$KH[t], $d7238066c5de7f1c$var$KH[s]), this.currentBlendEquation = t, this.currentBlendEquationAlpha = s), (i !== this.currentBlendSrc || n !== this.currentBlendDst || a !== this.currentBlendSrcAlpha || o !== this.currentBlendDstAlpha) && (l.blendFuncSeparate($d7238066c5de7f1c$var$Qb[i], $d7238066c5de7f1c$var$Qb[n], $d7238066c5de7f1c$var$Qb[a], $d7238066c5de7f1c$var$Qb[o]), this.currentBlendSrc = i, this.currentBlendDst = n, this.currentBlendSrcAlpha = a, this.currentBlendDstAlpha = o), this.currentBlending = e, this.currentPremultipledAlpha = !1;
    }
    /**
   * Specifies whether colors can be written when rendering
   * into a framebuffer or not.
   *
   * This method caches the state so `gl.colorMask()` is only
   * called when necessary.
   *
   * @param {boolean} colorMask - The color mask.
   */ setColorMask(e) {
        this.currentColorMask !== e && (this.gl.colorMask(e, e, e, e), this.currentColorMask = e);
    }
    /**
   * Specifies whether the depth test is enabled or not.
   *
   * @param {boolean} depthTest - Whether the depth test is enabled or not.
   */ setDepthTest(e) {
        const { gl: t } = this;
        e ? this.enable(t.DEPTH_TEST) : this.disable(t.DEPTH_TEST);
    }
    /**
   * Specifies whether depth values can be written when rendering
   * into a framebuffer or not.
   *
   * This method caches the state so `gl.depthMask()` is only
   * called when necessary.
   *
   * @param {boolean} depthMask - The depth mask.
   */ setDepthMask(e) {
        this.currentDepthMask !== e && (this.gl.depthMask(e), this.currentDepthMask = e);
    }
    /**
   * Specifies the depth compare function.
   *
   * This method caches the state so `gl.depthFunc()` is only
   * called when necessary.
   *
   * @param {number} depthFunc - The depth compare function.
   */ setDepthFunc(e) {
        if (this.currentDepthFunc !== e) {
            const { gl: t } = this;
            switch(e){
                case $d7238066c5de7f1c$var$kk:
                    t.depthFunc(t.NEVER);
                    break;
                case $d7238066c5de7f1c$var$Ek:
                    t.depthFunc(t.ALWAYS);
                    break;
                case $d7238066c5de7f1c$var$Jk:
                    t.depthFunc(t.LESS);
                    break;
                case $d7238066c5de7f1c$var$qS:
                    t.depthFunc(t.LEQUAL);
                    break;
                case $d7238066c5de7f1c$var$Uk:
                    t.depthFunc(t.EQUAL);
                    break;
                case $d7238066c5de7f1c$var$Dk:
                    t.depthFunc(t.GEQUAL);
                    break;
                case $d7238066c5de7f1c$var$_k:
                    t.depthFunc(t.GREATER);
                    break;
                case $d7238066c5de7f1c$var$Pk:
                    t.depthFunc(t.NOTEQUAL);
                    break;
                default:
                    t.depthFunc(t.LEQUAL);
            }
            this.currentDepthFunc = e;
        }
    }
    /**
   * Specifies the scissor box.
   *
   * @param {number} x - The x-coordinate of the lower left corner of the viewport.
   * @param {number} y - The y-coordinate of the lower left corner of the viewport.
   * @param {number} width - The width of the viewport.
   * @param {number} height - The height of the viewport.
   *
   */ scissor(e, t, i, n) {
        const s = this._tempVec4.set(e, t, i, n);
        if (this.currentScissor.equals(s) === !1) {
            const { gl: a } = this;
            a.scissor(s.x, s.y, s.z, s.w), this.currentScissor.copy(s);
        }
    }
    /**
   * Specifies the viewport.
   *
   * @param {number} x - The x-coordinate of the lower left corner of the viewport.
   * @param {number} y - The y-coordinate of the lower left corner of the viewport.
   * @param {number} width - The width of the viewport.
   * @param {number} height - The height of the viewport.
   *
   */ viewport(e, t, i, n) {
        const s = this._tempVec4.set(e, t, i, n);
        if (this.currentViewport.equals(s) === !1) {
            const { gl: a } = this;
            a.viewport(s.x, s.y, s.z, s.w), this.currentViewport.copy(s);
        }
    }
    /**
   * Defines the scissor test.
   *
   * @param {boolean} boolean - Whether the scissor test should be enabled or not.
   */ setScissorTest(e) {
        const t = this.gl;
        e ? t.enable(t.SCISSOR_TEST) : t.disable(t.SCISSOR_TEST);
    }
    /**
   * Specifies whether the stencil test is enabled or not.
   *
   * @param {boolean} stencilTest - Whether the stencil test is enabled or not.
   */ setStencilTest(e) {
        const { gl: t } = this;
        e ? this.enable(t.STENCIL_TEST) : this.disable(t.STENCIL_TEST);
    }
    /**
   * Specifies whether stencil values can be written when rendering
   * into a framebuffer or not.
   *
   * This method caches the state so `gl.stencilMask()` is only
   * called when necessary.
   *
   * @param {boolean} stencilMask - The stencil mask.
   */ setStencilMask(e) {
        this.currentStencilMask !== e && (this.gl.stencilMask(e), this.currentStencilMask = e);
    }
    /**
   * Specifies whether the stencil test functions.
   *
   * This method caches the state so `gl.stencilFunc()` is only
   * called when necessary.
   *
   * @param {number} stencilFunc - The stencil compare function.
   * @param {number} stencilRef - The reference value for the stencil test.
   * @param {number} stencilMask - A bit-wise mask that is used to AND the reference value and the stored stencil value when the test is done.
   */ setStencilFunc(e, t, i) {
        (this.currentStencilFunc !== e || this.currentStencilRef !== t || this.currentStencilFuncMask !== i) && (this.gl.stencilFunc(e, t, i), this.currentStencilFunc = e, this.currentStencilRef = t, this.currentStencilFuncMask = i);
    }
    /**
   * Specifies whether the stencil test operation.
   *
   * This method caches the state so `gl.stencilOp()` is only
   * called when necessary.
   *
   * @param {number} stencilFail - The function to use when the stencil test fails.
   * @param {number} stencilZFail - The function to use when the stencil test passes, but the depth test fail.
   * @param {number} stencilZPass - The function to use when both the stencil test and the depth test pass,
   * or when the stencil test passes and there is no depth buffer or depth testing is disabled.
   */ setStencilOp(e, t, i) {
        (this.currentStencilFail !== e || this.currentStencilZFail !== t || this.currentStencilZPass !== i) && (this.gl.stencilOp(e, t, i), this.currentStencilFail = e, this.currentStencilZFail = t, this.currentStencilZPass = i);
    }
    /**
   * Configures the WebGL state for the given material.
   *
   * @param {Material} material - The material to configure the state for.
   * @param {number} frontFaceCW - Whether the front faces are counter-clockwise or not.
   * @param {number} hardwareClippingPlanes - The number of hardware clipping planes.
   */ setMaterial(e, t, i) {
        const { gl: n } = this;
        e.side === $d7238066c5de7f1c$var$YC ? this.disable(n.CULL_FACE) : this.enable(n.CULL_FACE);
        let s = e.side === $d7238066c5de7f1c$var$Ka;
        t && (s = !s), this.setFlipSided(s), e.blending === $d7238066c5de7f1c$var$uI && e.transparent === !1 ? this.setBlending($d7238066c5de7f1c$var$xA) : this.setBlending(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.premultipliedAlpha), this.setDepthFunc(e.depthFunc), this.setDepthTest(e.depthTest), this.setDepthMask(e.depthWrite), this.setColorMask(e.colorWrite);
        const a = e.stencilWrite;
        if (this.setStencilTest(a), a && (this.setStencilMask(e.stencilWriteMask), this.setStencilFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask), this.setStencilOp(e.stencilFail, e.stencilZFail, e.stencilZPass)), this.setPolygonOffset(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits), e.alphaToCoverage === !0 && this.backend.renderer.currentSamples > 0 ? this.enable(n.SAMPLE_ALPHA_TO_COVERAGE) : this.disable(n.SAMPLE_ALPHA_TO_COVERAGE), i > 0 && this.currentClippingPlanes !== i) for(let g = 0; g < 8; g++)g < i ? this.enable(12288 + g) : this.disable(12288 + g);
    }
    /**
   * Specifies the polygon offset.
   *
   * This method caches the state so `gl.polygonOffset()` is only
   * called when necessary.
   *
   * @param {boolean} polygonOffset - Whether polygon offset is enabled or not.
   * @param {number} factor - The scale factor for the variable depth offset for each polygon.
   * @param {number} units - The multiplier by which an implementation-specific value is multiplied with to create a constant depth offset.
   */ setPolygonOffset(e, t, i) {
        const { gl: n } = this;
        e ? (this.enable(n.POLYGON_OFFSET_FILL), (this.currentPolygonOffsetFactor !== t || this.currentPolygonOffsetUnits !== i) && (n.polygonOffset(t, i), this.currentPolygonOffsetFactor = t, this.currentPolygonOffsetUnits = i)) : this.disable(n.POLYGON_OFFSET_FILL);
    }
    /**
   * Defines the usage of the given WebGL program.
   *
   * This method caches the state so `gl.useProgram()` is only
   * called when necessary.
   *
   * @param {WebGLProgram} program - The WebGL program to use.
   * @return {boolean} Whether a program change has been executed or not.
   */ useProgram(e) {
        return this.currentProgram !== e ? (this.gl.useProgram(e), this.currentProgram = e, !0) : !1;
    }
    /**
   * Sets the vertex state by binding the given VAO and element buffer.
   *
   * @param {WebGLVertexArrayObject} vao - The VAO.
   * @param {?WebGLBuffer} indexBuffer - The index buffer.
   * @return {boolean} Whether a vertex state has been changed or not.
   */ setVertexState(e, t = null) {
        const i = this.gl;
        return this.currentVAO !== e || this.currentIndex !== t ? (i.bindVertexArray(e), t !== null && i.bindBuffer(i.ELEMENT_ARRAY_BUFFER, t), this.currentVAO = e, this.currentIndex = t, !0) : !1;
    }
    /**
   * Resets the vertex array state by resetting the VAO and element buffer.
   */ resetVertexState() {
        const e = this.gl;
        e.bindVertexArray(null), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, null), this.currentVAO = null, this.currentIndex = null;
    }
    // framebuffer
    /**
   * Binds the given framebuffer.
   *
   * This method caches the state so `gl.bindFramebuffer()` is only
   * called when necessary.
   *
   * @param {number} target - The binding point (target).
   * @param {WebGLFramebuffer} framebuffer - The WebGL framebuffer to bind.
   * @return {boolean} Whether a bind has been executed or not.
   */ bindFramebuffer(e, t) {
        const { gl: i, currentBoundFramebuffers: n } = this;
        return n[e] !== t ? (i.bindFramebuffer(e, t), n[e] = t, e === i.DRAW_FRAMEBUFFER && (n[i.FRAMEBUFFER] = t), e === i.FRAMEBUFFER && (n[i.DRAW_FRAMEBUFFER] = t), !0) : !1;
    }
    /**
   * Defines draw buffers to which fragment colors are written into.
   * Configures the MRT setup of custom framebuffers.
   *
   * This method caches the state so `gl.drawBuffers()` is only
   * called when necessary.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {WebGLFramebuffer} framebuffer - The WebGL framebuffer.
   */ drawBuffers(e, t) {
        const { gl: i } = this;
        let n = [], s = !1;
        if (e.textures !== null) {
            n = this.currentDrawbuffers.get(t), n === void 0 && (n = [], this.currentDrawbuffers.set(t, n));
            const a = e.textures;
            if (n.length !== a.length || n[0] !== i.COLOR_ATTACHMENT0) {
                for(let o = 0, g = a.length; o < g; o++)n[o] = i.COLOR_ATTACHMENT0 + o;
                n.length = a.length, s = !0;
            }
        } else n[0] !== i.BACK && (n[0] = i.BACK, s = !0);
        s && i.drawBuffers(n);
    }
    // texture
    /**
   * Makes the given texture unit active.
   *
   * This method caches the state so `gl.activeTexture()` is only
   * called when necessary.
   *
   * @param {number} webglSlot - The texture unit to make active.
   */ activeTexture(e) {
        const { gl: t, currentTextureSlot: i, maxTextures: n } = this;
        e === void 0 && (e = t.TEXTURE0 + n - 1), i !== e && (t.activeTexture(e), this.currentTextureSlot = e);
    }
    /**
   * Binds the given WebGL texture to a target.
   *
   * This method caches the state so `gl.bindTexture()` is only
   * called when necessary.
   *
   * @param {number} webglType - The binding point (target).
   * @param {WebGLTexture} webglTexture - The WebGL texture to bind.
   * @param {number} webglSlot - The texture.
   */ bindTexture(e, t, i) {
        const { gl: n, currentTextureSlot: s, currentBoundTextures: a, maxTextures: o } = this;
        i === void 0 && (s === null ? i = n.TEXTURE0 + o - 1 : i = s);
        let g = a[i];
        g === void 0 && (g = {
            type: void 0,
            texture: void 0
        }, a[i] = g), (g.type !== e || g.texture !== t) && (s !== i && (n.activeTexture(i), this.currentTextureSlot = i), n.bindTexture(e, t), g.type = e, g.texture = t);
    }
    /**
   * Binds a given WebGL buffer to a given binding point (target) at a given index.
   *
   * This method caches the state so `gl.bindBufferBase()` is only
   * called when necessary.
   *
   * @param {number} target - The target for the bind operation.
   * @param {number} index - The index of the target.
   * @param {WebGLBuffer} buffer - The WebGL buffer.
   * @return {boolean} Whether a bind has been executed or not.
   */ bindBufferBase(e, t, i) {
        const { gl: n } = this, s = `${e}-${t}`;
        return this.currentBoundBufferBases[s] !== i ? (n.bindBufferBase(e, t, i), this.currentBoundBufferBases[s] = i, !0) : !1;
    }
    /**
   * Unbinds the current bound texture.
   *
   * This method caches the state so `gl.bindTexture()` is only
   * called when necessary.
   */ unbindTexture() {
        const { gl: e, currentTextureSlot: t, currentBoundTextures: i } = this, n = i[t];
        n !== void 0 && n.type !== void 0 && (e.bindTexture(n.type, null), n.type = void 0, n.texture = void 0);
    }
}
class $d7238066c5de7f1c$var$cue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGLBackend} backend - The WebGL 2 backend.
   */ constructor(e){
        this.backend = e, this.gl = this.backend.gl, this.extensions = e.extensions;
    }
    /**
   * Converts the given three.js constant into a WebGL constant.
   * The method currently supports the conversion of texture formats
   * and types.
   *
   * @param {number} p - The three.js constant.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   * @return {?number} The corresponding WebGL constant.
   */ convert(e, t = $d7238066c5de7f1c$var$gh) {
        const { gl: i, extensions: n } = this;
        let s;
        const a = $d7238066c5de7f1c$var$sn.getTransfer(t);
        if (e === $d7238066c5de7f1c$var$Ya) return i.UNSIGNED_BYTE;
        if (e === $d7238066c5de7f1c$var$Ok) return i.UNSIGNED_SHORT_4_4_4_4;
        if (e === $d7238066c5de7f1c$var$jk) return i.UNSIGNED_SHORT_5_5_5_1;
        if (e === $d7238066c5de7f1c$var$ON) return i.UNSIGNED_INT_5_9_9_9_REV;
        if (e === $d7238066c5de7f1c$var$jN) return i.UNSIGNED_INT_10F_11F_11F_REV;
        if (e === $d7238066c5de7f1c$var$fA) return i.BYTE;
        if (e === $d7238066c5de7f1c$var$GA) return i.SHORT;
        if (e === $d7238066c5de7f1c$var$wC) return i.UNSIGNED_SHORT;
        if (e === $d7238066c5de7f1c$var$Na) return i.INT;
        if (e === $d7238066c5de7f1c$var$Xs) return i.UNSIGNED_INT;
        if (e === $d7238066c5de7f1c$var$vo) return i.FLOAT;
        if (e === $d7238066c5de7f1c$var$Ia) return i.HALF_FLOAT;
        if (e === $d7238066c5de7f1c$var$qk) return i.ALPHA;
        if (e === $d7238066c5de7f1c$var$sR) return i.RGB;
        if (e === $d7238066c5de7f1c$var$sg) return i.RGBA;
        if (e === $d7238066c5de7f1c$var$nu) return i.DEPTH_COMPONENT;
        if (e === $d7238066c5de7f1c$var$dI) return i.DEPTH_STENCIL;
        if (e === $d7238066c5de7f1c$var$rR) return i.RED;
        if (e === $d7238066c5de7f1c$var$aR) return i.RED_INTEGER;
        if (e === $d7238066c5de7f1c$var$gI) return i.RG;
        if (e === $d7238066c5de7f1c$var$oR) return i.RG_INTEGER;
        if (e === $d7238066c5de7f1c$var$gR) return i.RGBA_INTEGER;
        if (e === $d7238066c5de7f1c$var$Ky || e === $d7238066c5de7f1c$var$xy || e === $d7238066c5de7f1c$var$Fy || e === $d7238066c5de7f1c$var$Ty) {
            if (a === $d7238066c5de7f1c$var$Qt) {
                if (s = n.get("WEBGL_compressed_texture_s3tc_srgb"), s !== null) {
                    if (e === $d7238066c5de7f1c$var$Ky) return s.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (e === $d7238066c5de7f1c$var$xy) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (e === $d7238066c5de7f1c$var$Fy) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (e === $d7238066c5de7f1c$var$Ty) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else if (s = n.get("WEBGL_compressed_texture_s3tc"), s !== null) {
                if (e === $d7238066c5de7f1c$var$Ky) return s.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (e === $d7238066c5de7f1c$var$xy) return s.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (e === $d7238066c5de7f1c$var$Fy) return s.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (e === $d7238066c5de7f1c$var$Ty) return s.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (e === $d7238066c5de7f1c$var$y2 || e === $d7238066c5de7f1c$var$B2 || e === $d7238066c5de7f1c$var$f2 || e === $d7238066c5de7f1c$var$G2) {
            if (s = n.get("WEBGL_compressed_texture_pvrtc"), s !== null) {
                if (e === $d7238066c5de7f1c$var$y2) return s.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (e === $d7238066c5de7f1c$var$B2) return s.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (e === $d7238066c5de7f1c$var$f2) return s.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (e === $d7238066c5de7f1c$var$G2) return s.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (e === $d7238066c5de7f1c$var$eZ || e === $d7238066c5de7f1c$var$tZ || e === $d7238066c5de7f1c$var$iZ) {
            if (s = n.get("WEBGL_compressed_texture_etc"), s !== null) {
                if (e === $d7238066c5de7f1c$var$eZ || e === $d7238066c5de7f1c$var$tZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ETC2 : s.COMPRESSED_RGB8_ETC2;
                if (e === $d7238066c5de7f1c$var$iZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : s.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        if (e === $d7238066c5de7f1c$var$nZ || e === $d7238066c5de7f1c$var$sZ || e === $d7238066c5de7f1c$var$rZ || e === $d7238066c5de7f1c$var$aZ || e === $d7238066c5de7f1c$var$oZ || e === $d7238066c5de7f1c$var$gZ || e === $d7238066c5de7f1c$var$lZ || e === $d7238066c5de7f1c$var$cZ || e === $d7238066c5de7f1c$var$uZ || e === $d7238066c5de7f1c$var$IZ || e === $d7238066c5de7f1c$var$dZ || e === $d7238066c5de7f1c$var$hZ || e === $d7238066c5de7f1c$var$CZ || e === $d7238066c5de7f1c$var$pZ) {
            if (s = n.get("WEBGL_compressed_texture_astc"), s !== null) {
                if (e === $d7238066c5de7f1c$var$nZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : s.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (e === $d7238066c5de7f1c$var$sZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : s.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (e === $d7238066c5de7f1c$var$rZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : s.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (e === $d7238066c5de7f1c$var$aZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : s.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (e === $d7238066c5de7f1c$var$oZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : s.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (e === $d7238066c5de7f1c$var$gZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : s.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (e === $d7238066c5de7f1c$var$lZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : s.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (e === $d7238066c5de7f1c$var$cZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : s.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (e === $d7238066c5de7f1c$var$uZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : s.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (e === $d7238066c5de7f1c$var$IZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : s.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (e === $d7238066c5de7f1c$var$dZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : s.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (e === $d7238066c5de7f1c$var$hZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : s.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (e === $d7238066c5de7f1c$var$CZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : s.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (e === $d7238066c5de7f1c$var$pZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : s.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        if (e === $d7238066c5de7f1c$var$mZ) {
            if (s = n.get("EXT_texture_compression_bptc"), s !== null) {
                if (e === $d7238066c5de7f1c$var$mZ) return a === $d7238066c5de7f1c$var$Qt ? s.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : s.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        if (e === $d7238066c5de7f1c$var$AZ || e === $d7238066c5de7f1c$var$bZ || e === $d7238066c5de7f1c$var$yZ || e === $d7238066c5de7f1c$var$BZ) {
            if (s = n.get("EXT_texture_compression_rgtc"), s !== null) {
                if (e === $d7238066c5de7f1c$var$AZ) return s.COMPRESSED_RED_RGTC1_EXT;
                if (e === $d7238066c5de7f1c$var$bZ) return s.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (e === $d7238066c5de7f1c$var$yZ) return s.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (e === $d7238066c5de7f1c$var$BZ) return s.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        return e === $d7238066c5de7f1c$var$sh ? i.UNSIGNED_INT_24_8 : i[e] !== void 0 ? i[e] : null;
    }
    /**
   * This method can be used to synchronize the CPU with the GPU by waiting until
   * ongoing GPU commands have been completed.
   *
   * @private
   * @return {Promise} A promise that resolves when all ongoing GPU commands have been completed.
   */ _clientWaitAsync() {
        const { gl: e } = this, t = e.fenceSync(e.SYNC_GPU_COMMANDS_COMPLETE, 0);
        return e.flush(), new Promise((i, n)=>{
            function s() {
                const a = e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0);
                if (a === e.WAIT_FAILED) {
                    e.deleteSync(t), n();
                    return;
                }
                if (a === e.TIMEOUT_EXPIRED) {
                    requestAnimationFrame(s);
                    return;
                }
                e.deleteSync(t), i();
            }
            s();
        });
    }
}
let $d7238066c5de7f1c$var$E9 = !1, $d7238066c5de7f1c$var$Pv, $d7238066c5de7f1c$var$xH, $d7238066c5de7f1c$var$J9;
class $d7238066c5de7f1c$var$uue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGLBackend} backend - The WebGL 2 backend.
   */ constructor(e){
        this.backend = e, this.gl = e.gl, this.extensions = e.extensions, this.defaultTextures = {}, this._srcFramebuffer = null, this._dstFramebuffer = null, $d7238066c5de7f1c$var$E9 === !1 && (this._init(), $d7238066c5de7f1c$var$E9 = !0);
    }
    /**
   * Inits the state of the utility.
   *
   * @private
   */ _init() {
        const e = this.gl;
        $d7238066c5de7f1c$var$Pv = {
            [$d7238066c5de7f1c$var$FA]: e.REPEAT,
            [$d7238066c5de7f1c$var$qc]: e.CLAMP_TO_EDGE,
            [$d7238066c5de7f1c$var$TA]: e.MIRRORED_REPEAT
        }, $d7238066c5de7f1c$var$xH = {
            [$d7238066c5de7f1c$var$Sr]: e.NEAREST,
            [$d7238066c5de7f1c$var$Qk]: e.NEAREST_MIPMAP_NEAREST,
            [$d7238066c5de7f1c$var$lB]: e.NEAREST_MIPMAP_LINEAR,
            [$d7238066c5de7f1c$var$ro]: e.LINEAR,
            [$d7238066c5de7f1c$var$b2]: e.LINEAR_MIPMAP_NEAREST,
            [$d7238066c5de7f1c$var$II]: e.LINEAR_MIPMAP_LINEAR
        }, $d7238066c5de7f1c$var$J9 = {
            [$d7238066c5de7f1c$var$$k]: e.NEVER,
            [$d7238066c5de7f1c$var$r3]: e.ALWAYS,
            [$d7238066c5de7f1c$var$qN]: e.LESS,
            [$d7238066c5de7f1c$var$t3]: e.LEQUAL,
            [$d7238066c5de7f1c$var$e3]: e.EQUAL,
            [$d7238066c5de7f1c$var$s3]: e.GEQUAL,
            [$d7238066c5de7f1c$var$i3]: e.GREATER,
            [$d7238066c5de7f1c$var$n3]: e.NOTEQUAL
        };
    }
    /**
   * Returns the native texture type for the given texture.
   *
   * @param {Texture} texture - The texture.
   * @return {GLenum} The native texture type.
   */ getGLTextureType(e) {
        const { gl: t } = this;
        let i;
        return e.isCubeTexture === !0 ? i = t.TEXTURE_CUBE_MAP : e.isArrayTexture === !0 || e.isDataArrayTexture === !0 || e.isCompressedArrayTexture === !0 ? i = t.TEXTURE_2D_ARRAY : e.isData3DTexture === !0 ? i = t.TEXTURE_3D : i = t.TEXTURE_2D, i;
    }
    /**
   * Returns the native texture type for the given texture.
   *
   * @param {?string} internalFormatName - The internal format name. When `null`, the internal format is derived from the subsequent parameters.
   * @param {GLenum} glFormat - The WebGL format.
   * @param {GLenum} glType - The WebGL type.
   * @param {string} colorSpace - The texture's color space.
   * @param {boolean} [forceLinearTransfer=false] - Whether to force a linear transfer or not.
   * @return {GLenum} The internal format.
   */ getInternalFormat(e, t, i, n, s = !1) {
        const { gl: a, extensions: o } = this;
        if (e !== null) {
            if (a[e] !== void 0) return a[e];
            $d7238066c5de7f1c$var$ze("WebGLBackend: Attempt to use non-existing WebGL internal format '" + e + "'");
        }
        let g = t;
        if (t === a.RED && (i === a.FLOAT && (g = a.R32F), i === a.HALF_FLOAT && (g = a.R16F), i === a.UNSIGNED_BYTE && (g = a.R8), i === a.UNSIGNED_SHORT && (g = a.R16), i === a.UNSIGNED_INT && (g = a.R32UI), i === a.BYTE && (g = a.R8I), i === a.SHORT && (g = a.R16I), i === a.INT && (g = a.R32I)), t === a.RED_INTEGER && (i === a.UNSIGNED_BYTE && (g = a.R8UI), i === a.UNSIGNED_SHORT && (g = a.R16UI), i === a.UNSIGNED_INT && (g = a.R32UI), i === a.BYTE && (g = a.R8I), i === a.SHORT && (g = a.R16I), i === a.INT && (g = a.R32I)), t === a.RG && (i === a.FLOAT && (g = a.RG32F), i === a.HALF_FLOAT && (g = a.RG16F), i === a.UNSIGNED_BYTE && (g = a.RG8), i === a.UNSIGNED_SHORT && (g = a.RG16), i === a.UNSIGNED_INT && (g = a.RG32UI), i === a.BYTE && (g = a.RG8I), i === a.SHORT && (g = a.RG16I), i === a.INT && (g = a.RG32I)), t === a.RG_INTEGER && (i === a.UNSIGNED_BYTE && (g = a.RG8UI), i === a.UNSIGNED_SHORT && (g = a.RG16UI), i === a.UNSIGNED_INT && (g = a.RG32UI), i === a.BYTE && (g = a.RG8I), i === a.SHORT && (g = a.RG16I), i === a.INT && (g = a.RG32I)), t === a.RGB) {
            const l = s ? $d7238066c5de7f1c$var$GZ : $d7238066c5de7f1c$var$sn.getTransfer(n);
            i === a.FLOAT && (g = a.RGB32F), i === a.HALF_FLOAT && (g = a.RGB16F), i === a.UNSIGNED_BYTE && (g = a.RGB8), i === a.UNSIGNED_SHORT && (g = a.RGB16), i === a.UNSIGNED_INT && (g = a.RGB32UI), i === a.BYTE && (g = a.RGB8I), i === a.SHORT && (g = a.RGB16I), i === a.INT && (g = a.RGB32I), i === a.UNSIGNED_BYTE && (g = l === $d7238066c5de7f1c$var$Qt ? a.SRGB8 : a.RGB8), i === a.UNSIGNED_SHORT_5_6_5 && (g = a.RGB565), i === a.UNSIGNED_SHORT_5_5_5_1 && (g = a.RGB5_A1), i === a.UNSIGNED_SHORT_4_4_4_4 && (g = a.RGB4), i === a.UNSIGNED_INT_5_9_9_9_REV && (g = a.RGB9_E5), i === a.UNSIGNED_INT_10F_11F_11F_REV && (g = a.R11F_G11F_B10F);
        }
        if (t === a.RGB_INTEGER && (i === a.UNSIGNED_BYTE && (g = a.RGB8UI), i === a.UNSIGNED_SHORT && (g = a.RGB16UI), i === a.UNSIGNED_INT && (g = a.RGB32UI), i === a.BYTE && (g = a.RGB8I), i === a.SHORT && (g = a.RGB16I), i === a.INT && (g = a.RGB32I)), t === a.RGBA) {
            const l = s ? $d7238066c5de7f1c$var$GZ : $d7238066c5de7f1c$var$sn.getTransfer(n);
            i === a.FLOAT && (g = a.RGBA32F), i === a.HALF_FLOAT && (g = a.RGBA16F), i === a.UNSIGNED_BYTE && (g = a.RGBA8), i === a.UNSIGNED_SHORT && (g = a.RGBA16), i === a.UNSIGNED_INT && (g = a.RGBA32UI), i === a.BYTE && (g = a.RGBA8I), i === a.SHORT && (g = a.RGBA16I), i === a.INT && (g = a.RGBA32I), i === a.UNSIGNED_BYTE && (g = l === $d7238066c5de7f1c$var$Qt ? a.SRGB8_ALPHA8 : a.RGBA8), i === a.UNSIGNED_SHORT_4_4_4_4 && (g = a.RGBA4), i === a.UNSIGNED_SHORT_5_5_5_1 && (g = a.RGB5_A1);
        }
        return t === a.RGBA_INTEGER && (i === a.UNSIGNED_BYTE && (g = a.RGBA8UI), i === a.UNSIGNED_SHORT && (g = a.RGBA16UI), i === a.UNSIGNED_INT && (g = a.RGBA32UI), i === a.BYTE && (g = a.RGBA8I), i === a.SHORT && (g = a.RGBA16I), i === a.INT && (g = a.RGBA32I)), t === a.DEPTH_COMPONENT && (i === a.UNSIGNED_SHORT && (g = a.DEPTH_COMPONENT16), i === a.UNSIGNED_INT && (g = a.DEPTH_COMPONENT24), i === a.FLOAT && (g = a.DEPTH_COMPONENT32F)), t === a.DEPTH_STENCIL && i === a.UNSIGNED_INT_24_8 && (g = a.DEPTH24_STENCIL8), (g === a.R16F || g === a.R32F || g === a.RG16F || g === a.RG32F || g === a.RGBA16F || g === a.RGBA32F) && o.get("EXT_color_buffer_float"), g;
    }
    /**
   * Sets the texture parameters for the given texture.
   *
   * @param {GLenum} textureType - The texture type.
   * @param {Texture} texture - The texture.
   */ setTextureParameters(e, t) {
        const { gl: i, extensions: n, backend: s } = this, a = $d7238066c5de7f1c$var$sn.getPrimaries($d7238066c5de7f1c$var$sn.workingColorSpace), o = t.colorSpace === $d7238066c5de7f1c$var$gh ? null : $d7238066c5de7f1c$var$sn.getPrimaries(t.colorSpace), g = t.colorSpace === $d7238066c5de7f1c$var$gh || a === o ? i.NONE : i.BROWSER_DEFAULT_WEBGL;
        i.pixelStorei(i.UNPACK_FLIP_Y_WEBGL, t.flipY), i.pixelStorei(i.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), i.pixelStorei(i.UNPACK_ALIGNMENT, t.unpackAlignment), i.pixelStorei(i.UNPACK_COLORSPACE_CONVERSION_WEBGL, g), i.texParameteri(e, i.TEXTURE_WRAP_S, $d7238066c5de7f1c$var$Pv[t.wrapS]), i.texParameteri(e, i.TEXTURE_WRAP_T, $d7238066c5de7f1c$var$Pv[t.wrapT]), (e === i.TEXTURE_3D || e === i.TEXTURE_2D_ARRAY) && (t.isArrayTexture || i.texParameteri(e, i.TEXTURE_WRAP_R, $d7238066c5de7f1c$var$Pv[t.wrapR])), i.texParameteri(e, i.TEXTURE_MAG_FILTER, $d7238066c5de7f1c$var$xH[t.magFilter]);
        const l = t.mipmaps !== void 0 && t.mipmaps.length > 0, c = t.minFilter === $d7238066c5de7f1c$var$ro && l ? $d7238066c5de7f1c$var$II : t.minFilter;
        if (i.texParameteri(e, i.TEXTURE_MIN_FILTER, $d7238066c5de7f1c$var$xH[c]), t.compareFunction && (i.texParameteri(e, i.TEXTURE_COMPARE_MODE, i.COMPARE_REF_TO_TEXTURE), i.texParameteri(e, i.TEXTURE_COMPARE_FUNC, $d7238066c5de7f1c$var$J9[t.compareFunction])), n.has("EXT_texture_filter_anisotropic") === !0) {
            if (t.magFilter === $d7238066c5de7f1c$var$Sr || t.minFilter !== $d7238066c5de7f1c$var$lB && t.minFilter !== $d7238066c5de7f1c$var$II || t.type === $d7238066c5de7f1c$var$vo && n.has("OES_texture_float_linear") === !1) return;
            if (t.anisotropy > 1) {
                const d = n.get("EXT_texture_filter_anisotropic");
                i.texParameterf(e, d.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(t.anisotropy, s.getMaxAnisotropy()));
            }
        }
    }
    /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @param {Texture} texture - The texture to create a default texture for.
   */ createDefaultTexture(e) {
        const { gl: t, backend: i, defaultTextures: n } = this, s = this.getGLTextureType(e);
        let a = n[s];
        a === void 0 && (a = t.createTexture(), i.state.bindTexture(s, a), t.texParameteri(s, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(s, t.TEXTURE_MAG_FILTER, t.NEAREST), n[s] = a), i.set(e, {
            textureGPU: a,
            glTextureType: s
        });
    }
    /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   * @return {undefined}
   */ createTexture(e, t) {
        const { gl: i, backend: n } = this, { levels: s, width: a, height: o, depth: g } = t, l = n.utils.convert(e.format, e.colorSpace), c = n.utils.convert(e.type), d = this.getInternalFormat(e.internalFormat, l, c, e.colorSpace, e.isVideoTexture), p = i.createTexture(), A = this.getGLTextureType(e);
        n.state.bindTexture(A, p), this.setTextureParameters(A, e), e.isArrayTexture || e.isDataArrayTexture || e.isCompressedArrayTexture ? i.texStorage3D(i.TEXTURE_2D_ARRAY, s, d, a, o, g) : e.isData3DTexture ? i.texStorage3D(i.TEXTURE_3D, s, d, a, o, g) : e.isVideoTexture || i.texStorage2D(A, s, d, a, o), n.set(e, {
            textureGPU: p,
            glTextureType: A,
            glFormat: l,
            glType: c,
            glInternalFormat: d
        });
    }
    /**
   * Uploads texture buffer data to the GPU memory.
   *
   * @param {WebGLBuffer} buffer - The buffer data.
   * @param {Texture} texture - The texture,
   */ copyBufferToTexture(e, t) {
        const { gl: i, backend: n } = this, { textureGPU: s, glTextureType: a, glFormat: o, glType: g } = n.get(t), { width: l, height: c } = t.source.data;
        i.bindBuffer(i.PIXEL_UNPACK_BUFFER, e), n.state.bindTexture(a, s), i.pixelStorei(i.UNPACK_FLIP_Y_WEBGL, !1), i.pixelStorei(i.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), i.texSubImage2D(a, 0, 0, 0, l, c, o, g, 0), i.bindBuffer(i.PIXEL_UNPACK_BUFFER, null), n.state.unbindTexture();
    }
    /**
   * Uploads the updated texture data to the GPU.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ updateTexture(e, t) {
        const { gl: i } = this, { width: n, height: s } = t, { textureGPU: a, glTextureType: o, glFormat: g, glType: l, glInternalFormat: c } = this.backend.get(e);
        if (!(e.isRenderTargetTexture || a === void 0)) {
            if (this.backend.state.bindTexture(o, a), this.setTextureParameters(o, e), e.isCompressedTexture) {
                const d = e.mipmaps, p = t.image;
                for(let A = 0; A < d.length; A++){
                    const y = d[A];
                    e.isCompressedArrayTexture ? e.format !== i.RGBA ? g !== null ? i.compressedTexSubImage3D(i.TEXTURE_2D_ARRAY, A, 0, 0, 0, y.width, y.height, p.depth, g, y.data) : $d7238066c5de7f1c$var$ze("WebGLBackend: Attempt to load unsupported compressed texture format in .uploadTexture()") : i.texSubImage3D(i.TEXTURE_2D_ARRAY, A, 0, 0, 0, y.width, y.height, p.depth, g, l, y.data) : g !== null ? i.compressedTexSubImage2D(i.TEXTURE_2D, A, 0, 0, y.width, y.height, g, y.data) : $d7238066c5de7f1c$var$ze("WebGLBackend: Unsupported compressed texture format");
                }
            } else if (e.isCubeTexture) {
                const d = t.images, p = e.mipmaps;
                for(let A = 0; A < 6; A++){
                    const y = $d7238066c5de7f1c$var$Qv(d[A]);
                    i.texSubImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + A, 0, 0, 0, n, s, g, l, y);
                    for(let G = 0; G < p.length; G++){
                        const Z = p[G], v = $d7238066c5de7f1c$var$Qv(Z.images[A]);
                        i.texSubImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + A, G + 1, 0, 0, v.width, v.height, g, l, v);
                    }
                }
            } else if (e.isDataArrayTexture || e.isArrayTexture) {
                const d = t.image;
                if (e.layerUpdates.size > 0) {
                    const p = $d7238066c5de7f1c$var$wee(d.width, d.height, e.format, e.type);
                    for (const A of e.layerUpdates){
                        const y = d.data.subarray(A * p / d.data.BYTES_PER_ELEMENT, (A + 1) * p / d.data.BYTES_PER_ELEMENT);
                        i.texSubImage3D(i.TEXTURE_2D_ARRAY, 0, 0, 0, A, d.width, d.height, 1, g, l, y);
                    }
                    e.clearLayerUpdates();
                } else i.texSubImage3D(i.TEXTURE_2D_ARRAY, 0, 0, 0, 0, d.width, d.height, d.depth, g, l, d.data);
            } else if (e.isData3DTexture) {
                const d = t.image;
                i.texSubImage3D(i.TEXTURE_3D, 0, 0, 0, 0, d.width, d.height, d.depth, g, l, d.data);
            } else if (e.isVideoTexture) e.update(), i.texImage2D(o, 0, c, g, l, t.image);
            else {
                const d = e.mipmaps;
                if (d.length > 0) for(let p = 0, A = d.length; p < A; p++){
                    const y = d[p], G = $d7238066c5de7f1c$var$Qv(y);
                    i.texSubImage2D(o, p, 0, 0, y.width, y.height, g, l, G);
                }
                else {
                    const p = $d7238066c5de7f1c$var$Qv(t.image);
                    i.texSubImage2D(o, 0, 0, 0, n, s, g, l, p);
                }
            }
        }
    }
    /**
   * Generates mipmaps for the given texture.
   *
   * @param {Texture} texture - The texture.
   */ generateMipmaps(e) {
        const { gl: t, backend: i } = this, { textureGPU: n, glTextureType: s } = i.get(e);
        i.state.bindTexture(s, n), t.generateMipmap(s);
    }
    /**
   * Deallocates the render buffers of the given render target.
   *
   * @param {RenderTarget} renderTarget - The render target.
   */ deallocateRenderBuffers(e) {
        const { gl: t, backend: i } = this;
        if (e) {
            const n = i.get(e);
            if (n.renderBufferStorageSetup = void 0, n.framebuffers) {
                for(const s in n.framebuffers)t.deleteFramebuffer(n.framebuffers[s]);
                delete n.framebuffers;
            }
            if (n.depthRenderbuffer && (t.deleteRenderbuffer(n.depthRenderbuffer), delete n.depthRenderbuffer), n.stencilRenderbuffer && (t.deleteRenderbuffer(n.stencilRenderbuffer), delete n.stencilRenderbuffer), n.msaaFrameBuffer && (t.deleteFramebuffer(n.msaaFrameBuffer), delete n.msaaFrameBuffer), n.msaaRenderbuffers) {
                for(let s = 0; s < n.msaaRenderbuffers.length; s++)t.deleteRenderbuffer(n.msaaRenderbuffers[s]);
                delete n.msaaRenderbuffers;
            }
        }
    }
    /**
   * Destroys the GPU data for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
   */ destroyTexture(e, t = !1) {
        const { gl: i, backend: n } = this, { textureGPU: s, renderTarget: a } = n.get(e);
        this.deallocateRenderBuffers(a), t === !1 && i.deleteTexture(s), n.delete(e);
    }
    /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
   * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
   * @param {number} [srcLevel=0] - The source mip level to copy from.
   * @param {number} [dstLevel=0] - The destination mip level to copy to.
   */ copyTextureToTexture(e, t, i = null, n = null, s = 0, a = 0) {
        const { gl: o, backend: g } = this, { state: l } = this.backend, { textureGPU: c, glTextureType: d, glType: p, glFormat: A } = g.get(t);
        l.bindTexture(d, c);
        let y, G, Z, v, V, H, N, Y, K;
        const z = e.isCompressedTexture ? e.mipmaps[a] : e.image;
        if (i !== null) y = i.max.x - i.min.x, G = i.max.y - i.min.y, Z = i.isBox3 ? i.max.z - i.min.z : 1, v = i.min.x, V = i.min.y, H = i.isBox3 ? i.min.z : 0;
        else {
            const $ = Math.pow(2, -s);
            y = Math.floor(z.width * $), G = Math.floor(z.height * $), e.isDataArrayTexture || e.isArrayTexture ? Z = z.depth : e.isData3DTexture ? Z = Math.floor(z.depth * $) : Z = 1, v = 0, V = 0, H = 0;
        }
        n !== null ? (N = n.x, Y = n.y, K = n.z) : (N = 0, Y = 0, K = 0), o.pixelStorei(o.UNPACK_FLIP_Y_WEBGL, t.flipY), o.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), o.pixelStorei(o.UNPACK_ALIGNMENT, t.unpackAlignment);
        const M = o.getParameter(o.UNPACK_ROW_LENGTH), _ = o.getParameter(o.UNPACK_IMAGE_HEIGHT), O = o.getParameter(o.UNPACK_SKIP_PIXELS), ie = o.getParameter(o.UNPACK_SKIP_ROWS), he = o.getParameter(o.UNPACK_SKIP_IMAGES);
        o.pixelStorei(o.UNPACK_ROW_LENGTH, z.width), o.pixelStorei(o.UNPACK_IMAGE_HEIGHT, z.height), o.pixelStorei(o.UNPACK_SKIP_PIXELS, v), o.pixelStorei(o.UNPACK_SKIP_ROWS, V), o.pixelStorei(o.UNPACK_SKIP_IMAGES, H);
        const pe = e.isDataArrayTexture || e.isData3DTexture || t.isArrayTexture, ce = t.isDataArrayTexture || t.isData3DTexture || t.isArrayTexture;
        if (e.isDepthTexture) {
            const $ = g.get(e), te = g.get(t), Ge = g.get($.renderTarget), q = g.get(te.renderTarget), de = Ge.framebuffers[$.cacheKey], ge = q.framebuffers[te.cacheKey];
            l.bindFramebuffer(o.READ_FRAMEBUFFER, de), l.bindFramebuffer(o.DRAW_FRAMEBUFFER, ge);
            for(let Ye = 0; Ye < Z; Ye++)pe && (o.framebufferTextureLayer(o.READ_FRAMEBUFFER, o.COLOR_ATTACHMENT0, $.textureGPU, s, H + Ye), o.framebufferTextureLayer(o.DRAW_FRAMEBUFFER, o.COLOR_ATTACHMENT0, c, a, K + Ye)), o.blitFramebuffer(v, V, y, G, N, Y, y, G, o.DEPTH_BUFFER_BIT, o.NEAREST);
            l.bindFramebuffer(o.READ_FRAMEBUFFER, null), l.bindFramebuffer(o.DRAW_FRAMEBUFFER, null);
        } else if (s !== 0 || e.isRenderTargetTexture || g.has(e)) {
            const $ = g.get(e);
            this._srcFramebuffer === null && (this._srcFramebuffer = o.createFramebuffer()), this._dstFramebuffer === null && (this._dstFramebuffer = o.createFramebuffer()), l.bindFramebuffer(o.READ_FRAMEBUFFER, this._srcFramebuffer), l.bindFramebuffer(o.DRAW_FRAMEBUFFER, this._dstFramebuffer);
            for(let te = 0; te < Z; te++)pe ? o.framebufferTextureLayer(o.READ_FRAMEBUFFER, o.COLOR_ATTACHMENT0, $.textureGPU, s, H + te) : o.framebufferTexture2D(o.READ_FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, $.textureGPU, s), ce ? o.framebufferTextureLayer(o.DRAW_FRAMEBUFFER, o.COLOR_ATTACHMENT0, c, a, K + te) : o.framebufferTexture2D(o.DRAW_FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, c, a), s !== 0 ? o.blitFramebuffer(v, V, y, G, N, Y, y, G, o.COLOR_BUFFER_BIT, o.NEAREST) : ce ? o.copyTexSubImage3D(d, a, N, Y, K + te, v, V, y, G) : o.copyTexSubImage2D(d, a, N, Y, v, V, y, G);
            l.bindFramebuffer(o.READ_FRAMEBUFFER, null), l.bindFramebuffer(o.DRAW_FRAMEBUFFER, null);
        } else ce ? e.isDataTexture || e.isData3DTexture ? o.texSubImage3D(d, a, N, Y, K, y, G, Z, A, p, z.data) : t.isCompressedArrayTexture ? o.compressedTexSubImage3D(d, a, N, Y, K, y, G, Z, A, z.data) : o.texSubImage3D(d, a, N, Y, K, y, G, Z, A, p, z) : e.isDataTexture ? o.texSubImage2D(o.TEXTURE_2D, a, N, Y, y, G, A, p, z.data) : e.isCompressedTexture ? o.compressedTexSubImage2D(o.TEXTURE_2D, a, N, Y, z.width, z.height, A, z.data) : o.texSubImage2D(o.TEXTURE_2D, a, N, Y, y, G, A, p, z);
        o.pixelStorei(o.UNPACK_ROW_LENGTH, M), o.pixelStorei(o.UNPACK_IMAGE_HEIGHT, _), o.pixelStorei(o.UNPACK_SKIP_PIXELS, O), o.pixelStorei(o.UNPACK_SKIP_ROWS, ie), o.pixelStorei(o.UNPACK_SKIP_IMAGES, he), a === 0 && t.generateMipmaps && o.generateMipmap(d), l.unbindTexture();
    }
    /**
   * Copies the current bound framebuffer to the given texture.
   *
   * @param {Texture} texture - The destination texture.
   * @param {RenderContext} renderContext - The render context.
   * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
   */ copyFramebufferToTexture(e, t, i) {
        const { gl: n } = this, { state: s } = this.backend, { textureGPU: a } = this.backend.get(e), { x: o, y: g, z: l, w: c } = i, d = e.isDepthTexture === !0 || t.renderTarget && t.renderTarget.samples > 0, p = t.renderTarget ? t.renderTarget.height : this.backend.getDrawingBufferSize().y;
        if (d) {
            const A = o !== 0 || g !== 0;
            let y, G;
            if (e.isDepthTexture === !0 ? (y = n.DEPTH_BUFFER_BIT, G = n.DEPTH_ATTACHMENT, t.stencil && (y |= n.STENCIL_BUFFER_BIT)) : (y = n.COLOR_BUFFER_BIT, G = n.COLOR_ATTACHMENT0), A) {
                const Z = this.backend.get(t.renderTarget), v = Z.framebuffers[t.getCacheKey()], V = Z.msaaFrameBuffer;
                s.bindFramebuffer(n.DRAW_FRAMEBUFFER, v), s.bindFramebuffer(n.READ_FRAMEBUFFER, V);
                const H = p - g - c;
                n.blitFramebuffer(o, H, o + l, H + c, o, H, o + l, H + c, y, n.NEAREST), s.bindFramebuffer(n.READ_FRAMEBUFFER, v), s.bindTexture(n.TEXTURE_2D, a), n.copyTexSubImage2D(n.TEXTURE_2D, 0, 0, 0, o, H, l, c), s.unbindTexture();
            } else {
                const Z = n.createFramebuffer();
                s.bindFramebuffer(n.DRAW_FRAMEBUFFER, Z), n.framebufferTexture2D(n.DRAW_FRAMEBUFFER, G, n.TEXTURE_2D, a, 0), n.blitFramebuffer(0, 0, l, c, 0, 0, l, c, y, n.NEAREST), n.deleteFramebuffer(Z);
            }
        } else s.bindTexture(n.TEXTURE_2D, a), n.copyTexSubImage2D(n.TEXTURE_2D, 0, 0, 0, o, p - c - g, l, c), s.unbindTexture();
        e.generateMipmaps && this.generateMipmaps(e), this.backend._setFramebuffer(t);
    }
    /**
   * SetupS storage for internal depth/stencil buffers and bind to correct framebuffer.
   *
   * @param {WebGLRenderbuffer} renderbuffer - The render buffer.
   * @param {RenderContext} renderContext - The render context.
   * @param {number} samples - The MSAA sample count.
   * @param {boolean} [useMultisampledRTT=false] - Whether to use WEBGL_multisampled_render_to_texture or not.
   */ setupRenderBufferStorage(e, t, i, n = !1) {
        const { gl: s } = this, a = t.renderTarget, { depthTexture: o, depthBuffer: g, stencilBuffer: l, width: c, height: d } = a;
        if (s.bindRenderbuffer(s.RENDERBUFFER, e), g && !l) {
            let p = s.DEPTH_COMPONENT24;
            n === !0 ? this.extensions.get("WEBGL_multisampled_render_to_texture").renderbufferStorageMultisampleEXT(s.RENDERBUFFER, a.samples, p, c, d) : i > 0 ? (o && o.isDepthTexture && o.type === s.FLOAT && (p = s.DEPTH_COMPONENT32F), s.renderbufferStorageMultisample(s.RENDERBUFFER, i, p, c, d)) : s.renderbufferStorage(s.RENDERBUFFER, p, c, d), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.DEPTH_ATTACHMENT, s.RENDERBUFFER, e);
        } else g && l && (i > 0 ? s.renderbufferStorageMultisample(s.RENDERBUFFER, i, s.DEPTH24_STENCIL8, c, d) : s.renderbufferStorage(s.RENDERBUFFER, s.DEPTH_STENCIL, c, d), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.DEPTH_STENCIL_ATTACHMENT, s.RENDERBUFFER, e));
        s.bindRenderbuffer(s.RENDERBUFFER, null);
    }
    /**
   * Returns texture data as a typed array.
   *
   * @async
   * @param {Texture} texture - The texture to copy.
   * @param {number} x - The x coordinate of the copy origin.
   * @param {number} y - The y coordinate of the copy origin.
   * @param {number} width - The width of the copy.
   * @param {number} height - The height of the copy.
   * @param {number} faceIndex - The face index.
   * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
   */ async copyTextureToBuffer(e, t, i, n, s, a) {
        const { backend: o, gl: g } = this, { textureGPU: l, glFormat: c, glType: d } = this.backend.get(e), p = g.createFramebuffer();
        g.bindFramebuffer(g.READ_FRAMEBUFFER, p);
        const A = e.isCubeTexture ? g.TEXTURE_CUBE_MAP_POSITIVE_X + a : g.TEXTURE_2D;
        g.framebufferTexture2D(g.READ_FRAMEBUFFER, g.COLOR_ATTACHMENT0, A, l, 0);
        const y = this._getTypedArrayType(d), G = this._getBytesPerTexel(d, c), v = n * s * G, V = g.createBuffer();
        g.bindBuffer(g.PIXEL_PACK_BUFFER, V), g.bufferData(g.PIXEL_PACK_BUFFER, v, g.STREAM_READ), g.readPixels(t, i, n, s, c, d, 0), g.bindBuffer(g.PIXEL_PACK_BUFFER, null), await o.utils._clientWaitAsync();
        const H = new y(v / y.BYTES_PER_ELEMENT);
        return g.bindBuffer(g.PIXEL_PACK_BUFFER, V), g.getBufferSubData(g.PIXEL_PACK_BUFFER, 0, H), g.bindBuffer(g.PIXEL_PACK_BUFFER, null), g.deleteFramebuffer(p), H;
    }
    /**
   * Returns the corresponding typed array type for the given WebGL data type.
   *
   * @private
   * @param {GLenum} glType - The WebGL data type.
   * @return {TypedArray.constructor} The typed array type.
   */ _getTypedArrayType(e) {
        const { gl: t } = this;
        if (e === t.UNSIGNED_BYTE) return Uint8Array;
        if (e === t.UNSIGNED_SHORT_4_4_4_4 || e === t.UNSIGNED_SHORT_5_5_5_1 || e === t.UNSIGNED_SHORT_5_6_5 || e === t.UNSIGNED_SHORT) return Uint16Array;
        if (e === t.UNSIGNED_INT) return Uint32Array;
        if (e === t.HALF_FLOAT) return Uint16Array;
        if (e === t.FLOAT) return Float32Array;
        throw new Error(`Unsupported WebGL type: ${e}`);
    }
    /**
   * Returns the bytes-per-texel value for the given WebGL data type and texture format.
   *
   * @private
   * @param {GLenum} glType - The WebGL data type.
   * @param {GLenum} glFormat - The WebGL texture format.
   * @return {number} The bytes-per-texel.
   */ _getBytesPerTexel(e, t) {
        const { gl: i } = this;
        let n = 0;
        if (e === i.UNSIGNED_BYTE && (n = 1), (e === i.UNSIGNED_SHORT_4_4_4_4 || e === i.UNSIGNED_SHORT_5_5_5_1 || e === i.UNSIGNED_SHORT_5_6_5 || e === i.UNSIGNED_SHORT || e === i.HALF_FLOAT) && (n = 2), (e === i.UNSIGNED_INT || e === i.FLOAT) && (n = 4), t === i.RGBA) return n * 4;
        if (t === i.RGB) return n * 3;
        if (t === i.ALPHA) return n;
    }
    /**
   * Frees the internal resources.
   */ dispose() {
        const { gl: e } = this;
        this._srcFramebuffer !== null && e.deleteFramebuffer(this._srcFramebuffer), this._dstFramebuffer !== null && e.deleteFramebuffer(this._dstFramebuffer);
    }
}
function $d7238066c5de7f1c$var$Qv(r) {
    return r.isDataTexture ? r.image.data : typeof HTMLImageElement < "u" && r instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r instanceof ImageBitmap || typeof OffscreenCanvas < "u" && r instanceof OffscreenCanvas ? r : r.data;
}
class $d7238066c5de7f1c$var$Iue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGLBackend} backend - The WebGL 2 backend.
   */ constructor(e){
        this.backend = e, this.gl = this.backend.gl, this.availableExtensions = this.gl.getSupportedExtensions(), this.extensions = {};
    }
    /**
   * Returns the extension object for the given extension name.
   *
   * @param {string} name - The extension name.
   * @return {Object} The extension object.
   */ get(e) {
        let t = this.extensions[e];
        return t === void 0 && (t = this.gl.getExtension(e), this.extensions[e] = t), t;
    }
    /**
   * Returns `true` if the requested extension is available.
   *
   * @param {string} name - The extension name.
   * @return {boolean} Whether the given extension is available or not.
   */ has(e) {
        return this.availableExtensions.includes(e);
    }
}
class $d7238066c5de7f1c$var$due {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGLBackend} backend - The WebGL 2 backend.
   */ constructor(e){
        this.backend = e, this.maxAnisotropy = null;
    }
    /**
   * Returns the maximum anisotropy texture filtering value. This value
   * depends on the device and is reported by the `EXT_texture_filter_anisotropic`
   * WebGL extension.
   *
   * @return {number} The maximum anisotropy texture filtering value.
   */ getMaxAnisotropy() {
        if (this.maxAnisotropy !== null) return this.maxAnisotropy;
        const e = this.backend.gl, t = this.backend.extensions;
        if (t.has("EXT_texture_filter_anisotropic") === !0) {
            const i = t.get("EXT_texture_filter_anisotropic");
            this.maxAnisotropy = e.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else this.maxAnisotropy = 0;
        return this.maxAnisotropy;
    }
}
const $d7238066c5de7f1c$var$U9 = {
    WEBGL_multi_draw: "WEBGL_multi_draw",
    WEBGL_compressed_texture_astc: "texture-compression-astc",
    WEBGL_compressed_texture_etc: "texture-compression-etc2",
    WEBGL_compressed_texture_etc1: "texture-compression-etc1",
    WEBGL_compressed_texture_pvrtc: "texture-compression-pvrtc",
    WEBGL_compressed_texture_s3tc: "texture-compression-s3tc",
    EXT_texture_compression_bptc: "texture-compression-bc",
    EXT_disjoint_timer_query_webgl2: "timestamp-query",
    OVR_multiview2: "OVR_multiview2"
};
class $d7238066c5de7f1c$var$hue {
    constructor(e){
        this.gl = e.gl, this.extensions = e.extensions, this.info = e.renderer.info, this.mode = null, this.index = 0, this.type = null, this.object = null;
    }
    render(e, t) {
        const { gl: i, mode: n, object: s, type: a, info: o, index: g } = this;
        g !== 0 ? i.drawElements(n, t, a, e) : i.drawArrays(n, e, t), o.update(s, t, 1);
    }
    renderInstances(e, t, i) {
        const { gl: n, mode: s, type: a, index: o, object: g, info: l } = this;
        i !== 0 && (o !== 0 ? n.drawElementsInstanced(s, t, a, e, i) : n.drawArraysInstanced(s, e, t, i), l.update(g, t, i));
    }
    renderMultiDraw(e, t, i) {
        const { extensions: n, mode: s, object: a, info: o } = this;
        if (i === 0) return;
        const g = n.get("WEBGL_multi_draw");
        if (g === null) for(let l = 0; l < i; l++)this.render(e[l], t[l]);
        else {
            this.index !== 0 ? g.multiDrawElementsWEBGL(s, t, 0, this.type, e, 0, i) : g.multiDrawArraysWEBGL(s, e, 0, t, 0, i);
            let l = 0;
            for(let c = 0; c < i; c++)l += t[c];
            o.update(a, l, 1);
        }
    }
    renderMultiDrawInstances(e, t, i, n) {
        const { extensions: s, mode: a, object: o, info: g } = this;
        if (i === 0) return;
        const l = s.get("WEBGL_multi_draw");
        if (l === null) for(let c = 0; c < i; c++)this.renderInstances(e[c], t[c], n[c]);
        else {
            this.index !== 0 ? l.multiDrawElementsInstancedWEBGL(a, t, 0, this.type, e, 0, n, 0, i) : l.multiDrawArraysInstancedWEBGL(a, e, 0, t, 0, n, 0, i);
            let c = 0;
            for(let d = 0; d < i; d++)c += t[d] * n[d];
            g.update(o, c, 1);
        }
    }
}
class $d7238066c5de7f1c$var$i_ {
    /**
   * Creates a new timestamp query pool.
   *
   * @param {number} [maxQueries=256] - Maximum number of queries this pool can hold.
   */ constructor(e = 256){
        this.trackTimestamp = !0, this.maxQueries = e, this.currentQueryIndex = 0, this.queryOffsets = /* @__PURE__ */ new Map(), this.isDisposed = !1, this.lastValue = 0, this.frames = [], this.pendingResolve = !1, this.timestamps = /* @__PURE__ */ new Map();
    }
    /**
   * Returns all timestamp frames.
   *
   * @return {Array<number>} The timestamp frames.
   */ getTimestampFrames() {
        return this.frames;
    }
    /**
   * Returns the timestamp for a given render context.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @return {?number} The timestamp, or undefined if not available.
   */ getTimestamp(e) {
        let t = this.timestamps.get(e);
        return t === void 0 && ($d7238066c5de7f1c$var$ze(`TimestampQueryPool: No timestamp available for uid ${e}.`), t = 0), t;
    }
    /**
   * Returns whether a timestamp is available for a given render context.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @return {boolean} True if a timestamp is available, false otherwise.
   */ hasTimestamp(e) {
        return this.timestamps.has(e);
    }
    /**
   * Allocate queries for a specific uid.
   *
   * @abstract
   * @param {string} uid - A unique identifier for the render context.
   * @param {number} frameId - The current frame identifier.
   * @returns {?number}
   */ allocateQueriesForContext() {}
    /**
   * Resolve all timestamps and return data (or process them).
   *
   * @abstract
   * @async
   * @returns {Promise<number>|number} The resolved timestamp value.
   */ async resolveQueriesAsync() {}
    /**
   * Dispose of the query pool.
   *
   * @abstract
   */ dispose() {}
}
class $d7238066c5de7f1c$var$Cue extends $d7238066c5de7f1c$var$i_ {
    /**
   * Creates a new WebGL timestamp query pool.
   *
   * @param {WebGLRenderingContext|WebGL2RenderingContext} gl - The WebGL context.
   * @param {string} type - The type identifier for this query pool.
   * @param {number} [maxQueries=2048] - Maximum number of queries this pool can hold.
   */ constructor(e, t, i = 2048){
        if (super(i), this.gl = e, this.type = t, this.ext = e.getExtension("EXT_disjoint_timer_query_webgl2") || e.getExtension("EXT_disjoint_timer_query"), !this.ext) {
            $d7238066c5de7f1c$var$ze("EXT_disjoint_timer_query not supported; timestamps will be disabled."), this.trackTimestamp = !1;
            return;
        }
        this.queries = [];
        for(let n = 0; n < this.maxQueries; n++)this.queries.push(e.createQuery());
        this.activeQuery = null, this.queryStates = /* @__PURE__ */ new Map();
    }
    /**
   * Allocates a pair of queries for a given render context.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @returns {?number} The base offset for the allocated queries, or null if allocation failed.
   */ allocateQueriesForContext(e) {
        if (!this.trackTimestamp) return null;
        if (this.currentQueryIndex + 2 > this.maxQueries) return $d7238066c5de7f1c$var$es(`WebGPUTimestampQueryPool [${this.type}]: Maximum number of queries exceeded, when using trackTimestamp it is necessary to resolves the queries via renderer.resolveTimestampsAsync( THREE.TimestampQuery.${this.type.toUpperCase()} ).`), null;
        const t = this.currentQueryIndex;
        return this.currentQueryIndex += 2, this.queryStates.set(t, "inactive"), this.queryOffsets.set(e, t), t;
    }
    /**
   * Begins a timestamp query for the specified render context.
   *
   * @param {string} uid - A unique identifier for the render context.
   */ beginQuery(e) {
        if (!this.trackTimestamp || this.isDisposed) return;
        const t = this.queryOffsets.get(e);
        if (t == null || this.activeQuery !== null) return;
        const i = this.queries[t];
        if (i) try {
            this.queryStates.get(t) === "inactive" && (this.gl.beginQuery(this.ext.TIME_ELAPSED_EXT, i), this.activeQuery = t, this.queryStates.set(t, "started"));
        } catch (n) {
            n("Error in beginQuery:", n), this.activeQuery = null, this.queryStates.set(t, "inactive");
        }
    }
    /**
   * Ends the active timestamp query for the specified render context.
   *
   * @param {string} uid - A unique identifier for the render context.
   */ endQuery(e) {
        if (!this.trackTimestamp || this.isDisposed) return;
        const t = this.queryOffsets.get(e);
        if (t != null && this.activeQuery === t) try {
            this.gl.endQuery(this.ext.TIME_ELAPSED_EXT), this.queryStates.set(t, "ended"), this.activeQuery = null;
        } catch (i) {
            i("Error in endQuery:", i), this.queryStates.set(t, "inactive"), this.activeQuery = null;
        }
    }
    /**
   * Asynchronously resolves all completed queries and returns the total duration.
   *
   * @async
   * @returns {Promise<number>} The total duration in milliseconds, or the last valid value if resolution fails.
   */ async resolveQueriesAsync() {
        if (!this.trackTimestamp || this.pendingResolve) return this.lastValue;
        this.pendingResolve = !0;
        try {
            const e = /* @__PURE__ */ new Map();
            for (const [s, a] of this.queryOffsets)if (this.queryStates.get(a) === "ended") {
                const g = this.queries[a];
                e.set(s, this.resolveQuery(g));
            }
            if (e.size === 0) return this.lastValue;
            const t = {}, i = [];
            for (const [s, a] of e){
                const o = s.match(/^(.*):f(\d+)$/), g = parseInt(o[2]);
                i.includes(g) === !1 && i.push(g), t[g] === void 0 && (t[g] = 0);
                const l = await a;
                this.timestamps.set(s, l), t[g] += l;
            }
            const n = t[i[i.length - 1]];
            return this.lastValue = n, this.frames = i, this.currentQueryIndex = 0, this.queryOffsets.clear(), this.queryStates.clear(), this.activeQuery = null, n;
        } catch (e) {
            return e("Error resolving queries:", e), this.lastValue;
        } finally{
            this.pendingResolve = !1;
        }
    }
    /**
   * Resolves a single query, checking for completion and disjoint operation.
   *
   * @async
   * @param {WebGLQuery} query - The query object to resolve.
   * @returns {Promise<number>} The elapsed time in milliseconds.
   */ async resolveQuery(e) {
        return new Promise((t)=>{
            if (this.isDisposed) {
                t(this.lastValue);
                return;
            }
            let i, n = !1;
            const s = ()=>{
                i && (clearTimeout(i), i = null);
            }, a = (g)=>{
                n || (n = !0, s(), t(g));
            }, o = ()=>{
                if (this.isDisposed) {
                    a(this.lastValue);
                    return;
                }
                try {
                    if (this.gl.getParameter(this.ext.GPU_DISJOINT_EXT)) {
                        a(this.lastValue);
                        return;
                    }
                    if (!this.gl.getQueryParameter(e, this.gl.QUERY_RESULT_AVAILABLE)) {
                        i = setTimeout(o, 1);
                        return;
                    }
                    const c = this.gl.getQueryParameter(e, this.gl.QUERY_RESULT);
                    t(Number(c) / 1e6);
                } catch (g) {
                    g("Error checking query:", g), t(this.lastValue);
                }
            };
            o();
        });
    }
    /**
   * Releases all resources held by this query pool.
   * This includes deleting all query objects and clearing internal state.
   */ dispose() {
        if (!this.isDisposed && (this.isDisposed = !0, !!this.trackTimestamp)) {
            for (const e of this.queries)this.gl.deleteQuery(e);
            this.queries = [], this.queryStates.clear(), this.queryOffsets.clear(), this.lastValue = 0, this.activeQuery = null;
        }
    }
}
class $d7238066c5de7f1c$var$D9 extends $d7238066c5de7f1c$var$t_ {
    /**
   * WebGLBackend options.
   *
   * @typedef {Object} WebGLBackend~Options
   * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
   * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
   * @property {WebGL2RenderingContext} [context=undefined] - A WebGL 2 rendering context.
   */ /**
   * Constructs a new WebGPU backend.
   *
   * @param {WebGLBackend~Options} [parameters] - The configuration parameter.
   */ constructor(e = {}){
        super(e), this.isWebGLBackend = !0, this.attributeUtils = null, this.extensions = null, this.capabilities = null, this.textureUtils = null, this.bufferRenderer = null, this.gl = null, this.state = null, this.utils = null, this.vaoCache = {}, this.transformFeedbackCache = {}, this.discard = !1, this.disjoint = null, this.parallel = null, this._currentContext = null, this._knownBindings = /* @__PURE__ */ new WeakSet(), this._supportsInvalidateFramebuffer = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), this._xrFramebuffer = null;
    }
    /**
   * Initializes the backend so it is ready for usage.
   *
   * @param {Renderer} renderer - The renderer.
   */ init(e) {
        super.init(e);
        const t = this.parameters, i = {
            antialias: e.currentSamples > 0,
            alpha: !0,
            // always true for performance reasons
            depth: e.depth,
            stencil: e.stencil
        }, n = t.context !== void 0 ? t.context : e.domElement.getContext("webgl2", i);
        function s(a) {
            a.preventDefault();
            const o = {
                api: "WebGL",
                message: a.statusMessage || "Unknown reason",
                reason: null,
                originalEvent: a
            };
            e.onDeviceLost(o);
        }
        this._onContextLost = s, e.domElement.addEventListener("webglcontextlost", s, !1), this.gl = n, this.extensions = new $d7238066c5de7f1c$var$Iue(this), this.capabilities = new $d7238066c5de7f1c$var$due(this), this.attributeUtils = new $d7238066c5de7f1c$var$gue(this), this.textureUtils = new $d7238066c5de7f1c$var$uue(this), this.bufferRenderer = new $d7238066c5de7f1c$var$hue(this), this.state = new $d7238066c5de7f1c$var$lue(this), this.utils = new $d7238066c5de7f1c$var$cue(this), this.extensions.get("EXT_color_buffer_float"), this.extensions.get("WEBGL_clip_cull_distance"), this.extensions.get("OES_texture_float_linear"), this.extensions.get("EXT_color_buffer_half_float"), this.extensions.get("WEBGL_multisampled_render_to_texture"), this.extensions.get("WEBGL_render_shared_exponent"), this.extensions.get("WEBGL_multi_draw"), this.extensions.get("OVR_multiview2"), this.disjoint = this.extensions.get("EXT_disjoint_timer_query_webgl2"), this.parallel = this.extensions.get("KHR_parallel_shader_compile");
    }
    /**
   * The coordinate system of the backend.
   *
   * @type {number}
   * @readonly
   */ get coordinateSystem() {
        return $d7238066c5de7f1c$var$rg;
    }
    /**
   * This method performs a readback operation by moving buffer data from
   * a storage buffer attribute from the GPU to the CPU.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */ async getArrayBufferAsync(e) {
        return await this.attributeUtils.getArrayBufferAsync(e);
    }
    /**
   * Ensures the backend is XR compatible.
   *
   * @async
   * @return {Promise} A Promise that resolve when the renderer is XR compatible.
   */ async makeXRCompatible() {
        this.gl.getContextAttributes().xrCompatible !== !0 && await this.gl.makeXRCompatible();
    }
    /**
   * Sets the XR rendering destination.
   *
   * @param {WebGLFramebuffer} xrFramebuffer - The XR framebuffer.
   */ setXRTarget(e) {
        this._xrFramebuffer = e;
    }
    /**
   * Configures the given XR render target with external textures.
   *
   * This method is only relevant when using the WebXR Layers API.
   *
   * @param {XRRenderTarget} renderTarget - The XR render target.
   * @param {WebGLTexture} colorTexture - A native color texture.
   * @param {?WebGLTexture} [depthTexture=null] - A native depth texture.
   */ setXRRenderTargetTextures(e, t, i = null) {
        const n = this.gl;
        if (this.set(e.texture, {
            textureGPU: t,
            glInternalFormat: n.RGBA8
        }), i !== null) {
            const s = e.stencilBuffer ? n.DEPTH24_STENCIL8 : n.DEPTH_COMPONENT24;
            this.set(e.depthTexture, {
                textureGPU: i,
                glInternalFormat: s
            }), this.extensions.has("WEBGL_multisampled_render_to_texture") === !0 && e._autoAllocateDepthBuffer === !0 && e.multiview === !1 && $d7238066c5de7f1c$var$ze("WebGLBackend: Render-to-texture extension was disabled because an external texture was provided"), e._autoAllocateDepthBuffer = !1;
        }
    }
    /**
   * Inits a time stamp query for the given render context.
   *
   * @param {string} type - The type of the timestamp query.
   * @param {string} uid - A unique identifier for the timestamp query.
   */ initTimestampQuery(e, t) {
        if (!this.disjoint || !this.trackTimestamp) return;
        this.timestampQueryPool[e] || (this.timestampQueryPool[e] = new $d7238066c5de7f1c$var$Cue(this.gl, e, 2048));
        const i = this.timestampQueryPool[e];
        i.allocateQueriesForContext(t) !== null && i.beginQuery(t);
    }
    // timestamp utils
    /**
   * Prepares the timestamp buffer.
   *
   * @param {string} type - The type of the timestamp query.
   * @param {string} uid - A unique identifier for the timestamp query.
   */ prepareTimestampBuffer(e, t) {
        if (!this.disjoint || !this.trackTimestamp) return;
        this.timestampQueryPool[e].endQuery(t);
    }
    /**
   * Returns the backend's rendering context.
   *
   * @return {WebGL2RenderingContext} The rendering context.
   */ getContext() {
        return this.gl;
    }
    /**
   * This method is executed at the beginning of a render call and prepares
   * the WebGL state for upcoming render calls
   *
   * @param {RenderContext} renderContext - The render context.
   */ beginRender(e) {
        const { state: t } = this, i = this.get(e);
        if (e.viewport) this.updateViewport(e);
        else {
            const { width: s, height: a } = this.getDrawingBufferSize();
            t.viewport(0, 0, s, a);
        }
        if (e.scissor) {
            const { x: s, y: a, width: o, height: g } = e.scissorValue;
            t.scissor(s, e.height - g - a, o, g);
        }
        this.initTimestampQuery($d7238066c5de7f1c$var$$c.RENDER, this.getTimestampUID(e)), i.previousContext = this._currentContext, this._currentContext = e, this._setFramebuffer(e), this.clear(e.clearColor, e.clearDepth, e.clearStencil, e, !1);
        const n = e.occlusionQueryCount;
        n > 0 && (i.currentOcclusionQueries = i.occlusionQueries, i.currentOcclusionQueryObjects = i.occlusionQueryObjects, i.lastOcclusionObject = null, i.occlusionQueries = new Array(n), i.occlusionQueryObjects = new Array(n), i.occlusionQueryIndex = 0);
    }
    /**
   * This method is executed at the end of a render call and finalizes work
   * after draw calls.
   *
   * @param {RenderContext} renderContext - The render context.
   */ finishRender(e) {
        const { gl: t, state: i } = this, n = this.get(e), s = n.previousContext;
        i.resetVertexState();
        const a = e.occlusionQueryCount;
        a > 0 && (a > n.occlusionQueryIndex && t.endQuery(t.ANY_SAMPLES_PASSED), this.resolveOccludedAsync(e));
        const o = e.textures;
        if (o !== null) for(let g = 0; g < o.length; g++){
            const l = o[g];
            l.generateMipmaps && this.generateMipmaps(l);
        }
        if (this._currentContext = s, this._resolveRenderTarget(e), s !== null) {
            if (this._setFramebuffer(s), s.viewport) this.updateViewport(s);
            else {
                const { width: g, height: l } = this.getDrawingBufferSize();
                i.viewport(0, 0, g, l);
            }
        }
        this.prepareTimestampBuffer($d7238066c5de7f1c$var$$c.RENDER, this.getTimestampUID(e));
    }
    /**
   * This method processes the result of occlusion queries and writes it
   * into render context data.
   *
   * @async
   * @param {RenderContext} renderContext - The render context.
   */ resolveOccludedAsync(e) {
        const t = this.get(e), { currentOcclusionQueries: i, currentOcclusionQueryObjects: n } = t;
        if (i && n) {
            const s = /* @__PURE__ */ new WeakSet(), { gl: a } = this;
            t.currentOcclusionQueryObjects = null, t.currentOcclusionQueries = null;
            const o = ()=>{
                let g = 0;
                for(let l = 0; l < i.length; l++){
                    const c = i[l];
                    c !== null && a.getQueryParameter(c, a.QUERY_RESULT_AVAILABLE) && (a.getQueryParameter(c, a.QUERY_RESULT) === 0 && s.add(n[l]), i[l] = null, a.deleteQuery(c), g++);
                }
                g < i.length ? requestAnimationFrame(o) : t.occluded = s;
            };
            o();
        }
    }
    /**
   * Returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object is fully occluded or not.
   */ isOccluded(e, t) {
        const i = this.get(e);
        return i.occluded && i.occluded.has(t);
    }
    /**
   * Updates the viewport with the values from the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   */ updateViewport(e) {
        const { state: t } = this, { x: i, y: n, width: s, height: a } = e.viewportValue;
        t.viewport(i, e.height - a - n, s, a);
    }
    /**
   * Defines the scissor test.
   *
   * @param {boolean} boolean - Whether the scissor test should be enabled or not.
   */ setScissorTest(e) {
        this.state.setScissorTest(e);
    }
    /**
   * Returns the clear color and alpha into a single
   * color object.
   *
   * @return {Color4} The clear color.
   */ getClearColor() {
        const e = super.getClearColor();
        return e.r *= e.a, e.g *= e.a, e.b *= e.a, e;
    }
    /**
   * Performs a clear operation.
   *
   * @param {boolean} color - Whether the color buffer should be cleared or not.
   * @param {boolean} depth - Whether the depth buffer should be cleared or not.
   * @param {boolean} stencil - Whether the stencil buffer should be cleared or not.
   * @param {?Object} [descriptor=null] - The render context of the current set render target.
   * @param {boolean} [setFrameBuffer=true] - Controls whether the intermediate framebuffer should be set or not.
   * @param {boolean} [resolveRenderTarget=true] - Controls whether an active render target should be resolved
   * or not. Only relevant for explicit clears.
   */ clear(e, t, i, n = null, s = !0, a = !0) {
        const { gl: o, renderer: g } = this;
        n === null && (n = {
            textures: null,
            clearColorValue: this.getClearColor()
        });
        let l = 0;
        if (e && (l |= o.COLOR_BUFFER_BIT), t && (l |= o.DEPTH_BUFFER_BIT), i && (l |= o.STENCIL_BUFFER_BIT), l !== 0) {
            let c;
            n.clearColorValue ? c = n.clearColorValue : c = this.getClearColor();
            const d = g.getClearDepth(), p = g.getClearStencil();
            if (t && this.state.setDepthMask(!0), n.textures === null) o.clearColor(c.r, c.g, c.b, c.a), o.clear(l);
            else {
                if (s && this._setFramebuffer(n), e) for(let A = 0; A < n.textures.length; A++)A === 0 ? o.clearBufferfv(o.COLOR, A, [
                    c.r,
                    c.g,
                    c.b,
                    c.a
                ]) : o.clearBufferfv(o.COLOR, A, [
                    0,
                    0,
                    0,
                    1
                ]);
                t && i ? o.clearBufferfi(o.DEPTH_STENCIL, 0, d, p) : t ? o.clearBufferfv(o.DEPTH, 0, [
                    d
                ]) : i && o.clearBufferiv(o.STENCIL, 0, [
                    p
                ]), s && a && this._resolveRenderTarget(n);
            }
        }
    }
    /**
   * This method is executed at the beginning of a compute call and
   * prepares the state for upcoming compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */ beginCompute(e) {
        const { state: t, gl: i } = this;
        t.bindFramebuffer(i.FRAMEBUFFER, null), this.initTimestampQuery($d7238066c5de7f1c$var$$c.COMPUTE, this.getTimestampUID(e));
    }
    /**
   * Executes a compute command for the given compute node.
   *
   * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {ComputePipeline} pipeline - The compute pipeline.
   * @param {?number} [count=null] - The count of compute invocations. If `null`, the count is determined by the compute node.
   */ compute(e, t, i, n, s = null) {
        const { state: a, gl: o } = this;
        this.discard === !1 && (o.enable(o.RASTERIZER_DISCARD), this.discard = !0);
        const { programGPU: g, transformBuffers: l, attributes: c } = this.get(n), d = this._getVaoKey(c), p = this.vaoCache[d];
        p === void 0 ? this.vaoCache[d] = this._createVao(c) : a.setVertexState(p), a.useProgram(g), this._bindUniforms(i);
        const A = this._getTransformFeedback(l);
        o.bindTransformFeedback(o.TRANSFORM_FEEDBACK, A), o.beginTransformFeedback(o.POINTS), s = s !== null ? s : t.count, Array.isArray(s) ? ($d7238066c5de7f1c$var$es("WebGLBackend.compute(): The count parameter must be a single number, not an array."), s = s[0]) : s && typeof s == "object" && s.isIndirectStorageBufferAttribute && ($d7238066c5de7f1c$var$es("WebGLBackend.compute(): The count parameter must be a single number, not IndirectStorageBufferAttribute"), s = t.count), c[0].isStorageInstancedBufferAttribute ? o.drawArraysInstanced(o.POINTS, 0, 1, s) : o.drawArrays(o.POINTS, 0, s), o.endTransformFeedback(), o.bindTransformFeedback(o.TRANSFORM_FEEDBACK, null);
        for(let y = 0; y < l.length; y++){
            const G = l[y];
            G.pbo && this.has(G.pbo) && this.textureUtils.copyBufferToTexture(G.transformBuffer, G.pbo), G.switchBuffers();
        }
    }
    /**
   * This method is executed at the end of a compute call and
   * finalizes work after compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */ finishCompute(e) {
        const t = this.gl;
        this.discard = !1, t.disable(t.RASTERIZER_DISCARD), this.prepareTimestampBuffer($d7238066c5de7f1c$var$$c.COMPUTE, this.getTimestampUID(e)), this._currentContext && this._setFramebuffer(this._currentContext);
    }
    /**
   * Internal to determine if the current render target is a render target array with depth 2D array texture.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {boolean} Whether the render target is a render target array with depth 2D array texture.
   *
   * @private
   */ _isRenderCameraDepthArray(e) {
        return e.depthTexture && e.depthTexture.isArrayTexture && e.camera.isArrayCamera;
    }
    /**
   * Executes a draw command for the given render object.
   *
   * @param {RenderObject} renderObject - The render object to draw.
   * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
   */ draw(e) {
        const { object: t, pipeline: i, material: n, context: s, hardwareClippingPlanes: a } = e, { programGPU: o } = this.get(i), { gl: g, state: l } = this, c = this.get(s), d = e.getDrawParameters();
        if (d === null) return;
        this._bindUniforms(e.getBindings());
        const p = t.isMesh && t.matrixWorld.determinant() < 0;
        l.setMaterial(n, p, a), l.useProgram(o);
        const A = e.getAttributes(), y = this.get(A);
        let G = y.vaoGPU;
        if (G === void 0) {
            const M = this._getVaoKey(A);
            G = this.vaoCache[M], G === void 0 && (G = this._createVao(A), this.vaoCache[M] = G, y.vaoGPU = G);
        }
        const Z = e.getIndex(), v = Z !== null ? this.get(Z).bufferGPU : null;
        l.setVertexState(G, v);
        const V = c.lastOcclusionObject;
        if (V !== t && V !== void 0) {
            if (V !== null && V.occlusionTest === !0 && (g.endQuery(g.ANY_SAMPLES_PASSED), c.occlusionQueryIndex++), t.occlusionTest === !0) {
                const M = g.createQuery();
                g.beginQuery(g.ANY_SAMPLES_PASSED, M), c.occlusionQueries[c.occlusionQueryIndex] = M, c.occlusionQueryObjects[c.occlusionQueryIndex] = t;
            }
            c.lastOcclusionObject = t;
        }
        const H = this.bufferRenderer;
        t.isPoints ? H.mode = g.POINTS : t.isLineSegments ? H.mode = g.LINES : t.isLine ? H.mode = g.LINE_STRIP : t.isLineLoop ? H.mode = g.LINE_LOOP : n.wireframe === !0 ? (l.setLineWidth(n.wireframeLinewidth * this.renderer.getPixelRatio()), H.mode = g.LINES) : H.mode = g.TRIANGLES;
        const { vertexCount: N, instanceCount: Y } = d;
        let { firstVertex: K } = d;
        if (H.object = t, Z !== null) {
            K *= Z.array.BYTES_PER_ELEMENT;
            const M = this.get(Z);
            H.index = Z.count, H.type = M.type;
        } else H.index = 0;
        const z = ()=>{
            t.isBatchedMesh ? t._multiDrawInstances !== null ? ($d7238066c5de7f1c$var$es("WebGLBackend: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), H.renderMultiDrawInstances(t._multiDrawStarts, t._multiDrawCounts, t._multiDrawCount, t._multiDrawInstances)) : this.hasFeature("WEBGL_multi_draw") ? H.renderMultiDraw(t._multiDrawStarts, t._multiDrawCounts, t._multiDrawCount) : $d7238066c5de7f1c$var$es("WebGLBackend: WEBGL_multi_draw not supported.") : Y > 1 ? H.renderInstances(K, N, Y) : H.render(K, N);
        };
        if (e.camera.isArrayCamera === !0 && e.camera.cameras.length > 0 && e.camera.isMultiViewCamera === !1) {
            const M = this.get(e.camera), _ = e.camera.cameras, O = e.getBindingGroup("cameraIndex").bindings[0];
            if (M.indexesGPU === void 0 || M.indexesGPU.length !== _.length) {
                const te = new Uint32Array([
                    0,
                    0,
                    0,
                    0
                ]), Ge = [];
                for(let q = 0, de = _.length; q < de; q++){
                    const ge = g.createBuffer();
                    te[0] = q, g.bindBuffer(g.UNIFORM_BUFFER, ge), g.bufferData(g.UNIFORM_BUFFER, te, g.STATIC_DRAW), Ge.push(ge);
                }
                M.indexesGPU = Ge;
            }
            const ie = this.get(O), he = this.renderer.getPixelRatio(), pe = this._currentContext.renderTarget, ce = this._isRenderCameraDepthArray(this._currentContext), $ = this._currentContext.activeCubeFace;
            if (ce) {
                const te = this.get(pe.depthTexture);
                if (te.clearedRenderId !== this.renderer._nodes.nodeFrame.renderId) {
                    te.clearedRenderId = this.renderer._nodes.nodeFrame.renderId;
                    const { stencilBuffer: Ge } = pe;
                    for(let q = 0, de = _.length; q < de; q++)this.renderer._activeCubeFace = q, this._currentContext.activeCubeFace = q, this._setFramebuffer(this._currentContext), this.clear(!1, !0, Ge, this._currentContext, !1, !1);
                    this.renderer._activeCubeFace = $, this._currentContext.activeCubeFace = $;
                }
            }
            for(let te = 0, Ge = _.length; te < Ge; te++){
                const q = _[te];
                if (t.layers.test(q.layers)) {
                    ce && (this.renderer._activeCubeFace = te, this._currentContext.activeCubeFace = te, this._setFramebuffer(this._currentContext));
                    const de = q.viewport;
                    if (de !== void 0) {
                        const ge = de.x * he, Ye = de.y * he, Fe = de.width * he, Xe = de.height * he;
                        l.viewport(Math.floor(ge), Math.floor(e.context.height - Xe - Ye), Math.floor(Fe), Math.floor(Xe));
                    }
                    l.bindBufferBase(g.UNIFORM_BUFFER, ie.index, M.indexesGPU[te]), z();
                }
                this._currentContext.activeCubeFace = $, this.renderer._activeCubeFace = $;
            }
        } else z();
    }
    /**
   * Explain why always null is returned.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the render pipeline requires an update or not.
   */ needsRenderUpdate() {
        return !1;
    }
    /**
   * Explain why no cache key is computed.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {string} The cache key.
   */ getRenderCacheKey() {
        return "";
    }
    // textures
    /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @param {Texture} texture - The texture to create a default texture for.
   */ createDefaultTexture(e) {
        this.textureUtils.createDefaultTexture(e);
    }
    /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ createTexture(e, t) {
        this.textureUtils.createTexture(e, t);
    }
    /**
   * Uploads the updated texture data to the GPU.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ updateTexture(e, t) {
        this.textureUtils.updateTexture(e, t);
    }
    /**
   * Generates mipmaps for the given texture.
   *
   * @param {Texture} texture - The texture.
   */ generateMipmaps(e) {
        this.textureUtils.generateMipmaps(e);
    }
    /**
   * Destroys the GPU data for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
   */ destroyTexture(e, t = !1) {
        this.textureUtils.destroyTexture(e, t);
    }
    /**
   * Returns texture data as a typed array.
   *
   * @async
   * @param {Texture} texture - The texture to copy.
   * @param {number} x - The x coordinate of the copy origin.
   * @param {number} y - The y coordinate of the copy origin.
   * @param {number} width - The width of the copy.
   * @param {number} height - The height of the copy.
   * @param {number} faceIndex - The face index.
   * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
   */ async copyTextureToBuffer(e, t, i, n, s, a) {
        return this.textureUtils.copyTextureToBuffer(e, t, i, n, s, a);
    }
    /**
   * This method does nothing since WebGL 2 has no concept of samplers.
   *
   * @param {Texture} texture - The texture to update the sampler for.
   * @return {string} The current sampler key.
   */ updateSampler() {
        return "";
    }
    // node builder
    /**
   * Returns a node builder for the given render object.
   *
   * @param {RenderObject} object - The render object.
   * @param {Renderer} renderer - The renderer.
   * @return {GLSLNodeBuilder} The node builder.
   */ createNodeBuilder(e, t) {
        return new $d7238066c5de7f1c$var$rue(e, t);
    }
    // program
    /**
   * Creates a shader program from the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */ createProgram(e) {
        const t = this.gl, { stage: i, code: n } = e, s = i === "fragment" ? t.createShader(t.FRAGMENT_SHADER) : t.createShader(t.VERTEX_SHADER);
        t.shaderSource(s, n), t.compileShader(s), this.set(e, {
            shaderGPU: s
        });
    }
    /**
   * Destroys the shader program of the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */ destroyProgram(e) {
        this.delete(e);
    }
    /**
   * Creates a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */ createRenderPipeline(e, t) {
        const i = this.gl, n = e.pipeline, { fragmentProgram: s, vertexProgram: a } = n, o = i.createProgram(), g = this.get(s).shaderGPU, l = this.get(a).shaderGPU;
        if (i.attachShader(o, g), i.attachShader(o, l), i.linkProgram(o), this.set(n, {
            programGPU: o,
            fragmentShader: g,
            vertexShader: l
        }), t !== null && this.parallel) {
            const c = new Promise((d)=>{
                const p = this.parallel, A = ()=>{
                    i.getProgramParameter(o, p.COMPLETION_STATUS_KHR) ? (this._completeCompile(e, n), d()) : requestAnimationFrame(A);
                };
                A();
            });
            t.push(c);
            return;
        }
        this._completeCompile(e, n);
    }
    /**
   * Formats the source code of error messages.
   *
   * @private
   * @param {string} string - The code.
   * @param {number} errorLine - The error line.
   * @return {string} The formatted code.
   */ _handleSource(e, t) {
        const i = e.split(`
`), n = [], s = Math.max(t - 6, 0), a = Math.min(t + 6, i.length);
        for(let o = s; o < a; o++){
            const g = o + 1;
            n.push(`${g === t ? ">" : " "} ${g}: ${i[o]}`);
        }
        return n.join(`
`);
    }
    /**
   * Gets the shader compilation errors from the info log.
   *
   * @private
   * @param {WebGL2RenderingContext} gl - The rendering context.
   * @param {WebGLShader} shader - The WebGL shader object.
   * @param {string} type - The shader type.
   * @return {string} The shader errors.
   */ _getShaderErrors(e, t, i) {
        const n = e.getShaderParameter(t, e.COMPILE_STATUS), a = (e.getShaderInfoLog(t) || "").trim();
        if (n && a === "") return "";
        const o = /ERROR: 0:(\d+)/.exec(a);
        if (o) {
            const g = parseInt(o[1]);
            return i.toUpperCase() + `

` + a + `

` + this._handleSource(e.getShaderSource(t), g);
        } else return a;
    }
    /**
   * Logs shader compilation errors.
   *
   * @private
   * @param {WebGLProgram} programGPU - The WebGL program.
   * @param {WebGLShader} glFragmentShader - The fragment shader as a native WebGL shader object.
   * @param {WebGLShader} glVertexShader - The vertex shader as a native WebGL shader object.
   */ _logProgramError(e, t, i) {
        if (this.renderer.debug.checkShaderErrors) {
            const n = this.gl, a = (n.getProgramInfoLog(e) || "").trim();
            if (n.getProgramParameter(e, n.LINK_STATUS) === !1) {
                if (typeof this.renderer.debug.onShaderError == "function") this.renderer.debug.onShaderError(n, e, i, t);
                else {
                    const o = this._getShaderErrors(n, i, "vertex"), g = this._getShaderErrors(n, t, "fragment");
                    $d7238066c5de7f1c$var$nt("THREE.WebGLProgram: Shader Error " + n.getError() + " - VALIDATE_STATUS " + n.getProgramParameter(e, n.VALIDATE_STATUS) + `

Program Info Log: ` + a + `
` + o + `
` + g);
                }
            } else a !== "" && $d7238066c5de7f1c$var$ze("WebGLProgram: Program Info Log:", a);
        }
    }
    /**
   * Completes the shader program setup for the given render object.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @param {RenderPipeline} pipeline - The render pipeline.
   */ _completeCompile(e, t) {
        const { state: i, gl: n } = this, s = this.get(t), { programGPU: a, fragmentShader: o, vertexShader: g } = s;
        n.getProgramParameter(a, n.LINK_STATUS) === !1 && this._logProgramError(a, o, g), i.useProgram(a);
        const l = e.getBindings();
        this._setupBindings(l, a), this.set(t, {
            programGPU: a
        });
    }
    /**
   * Creates a compute pipeline for the given compute node.
   *
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */ createComputePipeline(e, t) {
        const { state: i, gl: n } = this, s = {
            stage: "fragment",
            code: `#version 300 es
precision highp float;
void main() {}`
        };
        this.createProgram(s);
        const { computeProgram: a } = e, o = n.createProgram(), g = this.get(s).shaderGPU, l = this.get(a).shaderGPU, c = a.transforms, d = [], p = [];
        for(let Z = 0; Z < c.length; Z++){
            const v = c[Z];
            d.push(v.varyingName), p.push(v.attributeNode);
        }
        n.attachShader(o, g), n.attachShader(o, l), n.transformFeedbackVaryings(o, d, n.SEPARATE_ATTRIBS), n.linkProgram(o), n.getProgramParameter(o, n.LINK_STATUS) === !1 && this._logProgramError(o, g, l), i.useProgram(o), this._setupBindings(t, o);
        const A = a.attributes, y = [], G = [];
        for(let Z = 0; Z < A.length; Z++){
            const v = A[Z].node.attribute;
            y.push(v), this.has(v) || this.attributeUtils.createAttribute(v, n.ARRAY_BUFFER);
        }
        for(let Z = 0; Z < p.length; Z++){
            const v = p[Z].attribute;
            this.has(v) || this.attributeUtils.createAttribute(v, n.ARRAY_BUFFER);
            const V = this.get(v);
            G.push(V);
        }
        this.set(e, {
            programGPU: o,
            transformBuffers: G,
            attributes: y
        });
    }
    /**
   * Creates bindings from the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ createBindings(e, t) {
        if (this._knownBindings.has(t) === !1) {
            this._knownBindings.add(t);
            let i = 0, n = 0;
            for (const s of t){
                this.set(s, {
                    textures: n,
                    uniformBuffers: i
                });
                for (const a of s.bindings)a.isUniformBuffer && i++, a.isSampledTexture && n++;
            }
        }
        this.updateBindings(e, t);
    }
    /**
   * Updates the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ updateBindings(e) {
        const { gl: t } = this, i = this.get(e);
        let n = i.uniformBuffers, s = i.textures;
        for (const a of e.bindings){
            const o = this.get(a);
            if (a.isUniformsGroup || a.isUniformBuffer) {
                const g = a.buffer;
                let { bufferGPU: l } = this.get(g);
                l === void 0 ? (l = t.createBuffer(), t.bindBuffer(t.UNIFORM_BUFFER, l), t.bufferData(t.UNIFORM_BUFFER, g, t.DYNAMIC_DRAW), this.set(g, {
                    bufferGPU: l
                })) : (t.bindBuffer(t.UNIFORM_BUFFER, l), t.bufferSubData(t.UNIFORM_BUFFER, 0, g)), o.index = n++, o.bufferGPU = l, this.set(a, o);
            } else if (a.isSampledTexture) {
                const { textureGPU: g, glTextureType: l } = this.get(a.texture);
                o.index = s++, o.textureGPU = g, o.glTextureType = l, this.set(a, o);
            }
        }
    }
    /**
   * Updates a buffer binding.
   *
   *  @param {Buffer} binding - The buffer binding to update.
   */ updateBinding(e) {
        const t = this.gl;
        if (e.isUniformsGroup || e.isUniformBuffer) {
            const n = this.get(e).bufferGPU, s = e.buffer;
            t.bindBuffer(t.UNIFORM_BUFFER, n), t.bufferData(t.UNIFORM_BUFFER, s, t.DYNAMIC_DRAW);
        }
    }
    // attributes
    /**
   * Creates the GPU buffer of an indexed shader attribute.
   *
   * @param {BufferAttribute} attribute - The indexed buffer attribute.
   */ createIndexAttribute(e) {
        const t = this.gl;
        this.attributeUtils.createAttribute(e, t.ELEMENT_ARRAY_BUFFER);
    }
    /**
   * Creates the GPU buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createAttribute(e) {
        if (this.has(e)) return;
        const t = this.gl;
        this.attributeUtils.createAttribute(e, t.ARRAY_BUFFER);
    }
    /**
   * Creates the GPU buffer of a storage attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createStorageAttribute(e) {
        if (this.has(e)) return;
        const t = this.gl;
        this.attributeUtils.createAttribute(e, t.ARRAY_BUFFER);
    }
    /**
   * Updates the GPU buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to update.
   */ updateAttribute(e) {
        this.attributeUtils.updateAttribute(e);
    }
    /**
   * Destroys the GPU buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to destroy.
   */ destroyAttribute(e) {
        this.attributeUtils.destroyAttribute(e);
    }
    /**
   * Checks if the given feature is supported  by the backend.
   *
   * @param {string} name - The feature's name.
   * @return {boolean} Whether the feature is supported or not.
   */ hasFeature(e) {
        const t = Object.keys($d7238066c5de7f1c$var$U9).filter((n)=>$d7238066c5de7f1c$var$U9[n] === e), i = this.extensions;
        for(let n = 0; n < t.length; n++)if (i.has(t[n])) return !0;
        return !1;
    }
    /**
   * Returns the maximum anisotropy texture filtering value.
   *
   * @return {number} The maximum anisotropy texture filtering value.
   */ getMaxAnisotropy() {
        return this.capabilities.getMaxAnisotropy();
    }
    /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
   * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
   * @param {number} [srcLevel=0] - The source mip level to copy from.
   * @param {number} [dstLevel=0] - The destination mip level to copy to.
   */ copyTextureToTexture(e, t, i = null, n = null, s = 0, a = 0) {
        this.textureUtils.copyTextureToTexture(e, t, i, n, s, a);
    }
    /**
   * Copies the current bound framebuffer to the given texture.
   *
   * @param {Texture} texture - The destination texture.
   * @param {RenderContext} renderContext - The render context.
   * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
   */ copyFramebufferToTexture(e, t, i) {
        this.textureUtils.copyFramebufferToTexture(e, t, i);
    }
    /**
   * Configures the active framebuffer from the given render context.
   *
   * @private
   * @param {RenderContext} descriptor - The render context.
   */ _setFramebuffer(e) {
        const { gl: t, state: i } = this;
        let n = null;
        if (e.textures !== null) {
            const s = e.renderTarget, a = this.get(s), { samples: o, depthBuffer: g, stencilBuffer: l } = s, c = s.isWebGLCubeRenderTarget === !0, d = s.isRenderTarget3D === !0, p = s.depth > 1, A = s.isXRRenderTarget === !0, y = A === !0 && s._hasExternalTextures === !0;
            let G = a.msaaFrameBuffer, Z = a.depthRenderbuffer;
            const v = this.extensions.get("WEBGL_multisampled_render_to_texture"), V = this.extensions.get("OVR_multiview2"), H = this._useMultisampledExtension(s), N = $d7238066c5de7f1c$var$jU(e);
            let Y;
            if (c ? (a.cubeFramebuffers || (a.cubeFramebuffers = {}), Y = a.cubeFramebuffers[N]) : A && y === !1 ? Y = this._xrFramebuffer : (a.framebuffers || (a.framebuffers = {}), Y = a.framebuffers[N]), Y === void 0) {
                Y = t.createFramebuffer(), i.bindFramebuffer(t.FRAMEBUFFER, Y);
                const K = e.textures, z = [];
                if (c) {
                    a.cubeFramebuffers[N] = Y;
                    const { textureGPU: _ } = this.get(K[0]), O = this.renderer._activeCubeFace, ie = this.renderer._activeMipmapLevel;
                    t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + O, _, ie);
                } else {
                    a.framebuffers[N] = Y;
                    for(let _ = 0; _ < K.length; _++){
                        const O = K[_], ie = this.get(O);
                        ie.renderTarget = e.renderTarget, ie.cacheKey = N;
                        const he = t.COLOR_ATTACHMENT0 + _;
                        if (s.multiview) V.framebufferTextureMultisampleMultiviewOVR(t.FRAMEBUFFER, he, ie.textureGPU, 0, o, 0, 2);
                        else if (d || p) {
                            const pe = this.renderer._activeCubeFace, ce = this.renderer._activeMipmapLevel;
                            t.framebufferTextureLayer(t.FRAMEBUFFER, he, ie.textureGPU, ce, pe);
                        } else if (H) v.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, he, t.TEXTURE_2D, ie.textureGPU, 0, o);
                        else {
                            const pe = this.renderer._activeMipmapLevel;
                            t.framebufferTexture2D(t.FRAMEBUFFER, he, t.TEXTURE_2D, ie.textureGPU, pe);
                        }
                    }
                }
                const M = l ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
                if (s._autoAllocateDepthBuffer === !0) {
                    const _ = t.createRenderbuffer();
                    this.textureUtils.setupRenderBufferStorage(_, e, 0, H), a.xrDepthRenderbuffer = _, z.push(l ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT), t.bindRenderbuffer(t.RENDERBUFFER, _), t.framebufferRenderbuffer(t.FRAMEBUFFER, M, t.RENDERBUFFER, _);
                } else if (e.depthTexture !== null) {
                    z.push(l ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT);
                    const _ = this.get(e.depthTexture);
                    if (_.renderTarget = e.renderTarget, _.cacheKey = N, s.multiview) V.framebufferTextureMultisampleMultiviewOVR(t.FRAMEBUFFER, M, _.textureGPU, 0, o, 0, 2);
                    else if (y && H) v.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, M, t.TEXTURE_2D, _.textureGPU, 0, o);
                    else if (e.depthTexture.isArrayTexture) {
                        const O = this.renderer._activeCubeFace;
                        t.framebufferTextureLayer(t.FRAMEBUFFER, M, _.textureGPU, 0, O);
                    } else t.framebufferTexture2D(t.FRAMEBUFFER, M, t.TEXTURE_2D, _.textureGPU, 0);
                }
                a.depthInvalidationArray = z;
            } else {
                if (this._isRenderCameraDepthArray(e)) {
                    i.bindFramebuffer(t.FRAMEBUFFER, Y);
                    const z = this.renderer._activeCubeFace, M = this.get(e.depthTexture), _ = l ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
                    t.framebufferTextureLayer(t.FRAMEBUFFER, _, M.textureGPU, 0, z);
                }
                if ((A || H || s.multiview) && s._isOpaqueFramebuffer !== !0) {
                    i.bindFramebuffer(t.FRAMEBUFFER, Y);
                    const z = this.get(e.textures[0]);
                    s.multiview ? V.framebufferTextureMultisampleMultiviewOVR(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, z.textureGPU, 0, o, 0, 2) : H ? v.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, z.textureGPU, 0, o) : t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, z.textureGPU, 0);
                    const M = l ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
                    if (s._autoAllocateDepthBuffer === !0) {
                        const _ = a.xrDepthRenderbuffer;
                        t.bindRenderbuffer(t.RENDERBUFFER, _), t.framebufferRenderbuffer(t.FRAMEBUFFER, M, t.RENDERBUFFER, _);
                    } else {
                        const _ = this.get(e.depthTexture);
                        s.multiview ? V.framebufferTextureMultisampleMultiviewOVR(t.FRAMEBUFFER, M, _.textureGPU, 0, o, 0, 2) : H ? v.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, M, t.TEXTURE_2D, _.textureGPU, 0, o) : t.framebufferTexture2D(t.FRAMEBUFFER, M, t.TEXTURE_2D, _.textureGPU, 0);
                    }
                }
            }
            if (o > 0 && H === !1 && !s.multiview) {
                if (G === void 0) {
                    const K = [];
                    G = t.createFramebuffer(), i.bindFramebuffer(t.FRAMEBUFFER, G);
                    const z = [], M = e.textures;
                    for(let _ = 0; _ < M.length; _++){
                        z[_] = t.createRenderbuffer(), t.bindRenderbuffer(t.RENDERBUFFER, z[_]), K.push(t.COLOR_ATTACHMENT0 + _);
                        const O = e.textures[_], ie = this.get(O);
                        t.renderbufferStorageMultisample(t.RENDERBUFFER, o, ie.glInternalFormat, e.width, e.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + _, t.RENDERBUFFER, z[_]);
                    }
                    if (t.bindRenderbuffer(t.RENDERBUFFER, null), a.msaaFrameBuffer = G, a.msaaRenderbuffers = z, g && Z === void 0) {
                        Z = t.createRenderbuffer(), this.textureUtils.setupRenderBufferStorage(Z, e, o), a.depthRenderbuffer = Z;
                        const _ = l ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
                        K.push(_);
                    }
                    a.invalidationArray = K;
                }
                n = a.msaaFrameBuffer;
            } else n = Y;
            i.drawBuffers(e, Y);
        }
        i.bindFramebuffer(t.FRAMEBUFFER, n);
    }
    /**
   * Computes the VAO key for the given index and attributes.
   *
   * @private
   * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
   * @return {string} The VAO key.
   */ _getVaoKey(e) {
        let t = "";
        for(let i = 0; i < e.length; i++){
            const n = this.get(e[i]);
            t += ":" + n.id;
        }
        return t;
    }
    /**
   * Creates a VAO from the index and attributes.
   *
   * @private
   * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
   * @return {Object} The VAO data.
   */ _createVao(e) {
        const { gl: t } = this, i = t.createVertexArray();
        t.bindVertexArray(i);
        for(let n = 0; n < e.length; n++){
            const s = e[n], a = this.get(s);
            t.bindBuffer(t.ARRAY_BUFFER, a.bufferGPU), t.enableVertexAttribArray(n);
            let o, g;
            s.isInterleavedBufferAttribute === !0 ? (o = s.data.stride * a.bytesPerElement, g = s.offset * a.bytesPerElement) : (o = 0, g = 0), a.isInteger ? t.vertexAttribIPointer(n, s.itemSize, a.type, o, g) : t.vertexAttribPointer(n, s.itemSize, a.type, s.normalized, o, g), s.isInstancedBufferAttribute && !s.isInterleavedBufferAttribute ? t.vertexAttribDivisor(n, s.meshPerAttribute) : s.isInterleavedBufferAttribute && s.data.isInstancedInterleavedBuffer && t.vertexAttribDivisor(n, s.data.meshPerAttribute);
        }
        return t.bindBuffer(t.ARRAY_BUFFER, null), i;
    }
    /**
   * Creates a transform feedback from the given transform buffers.
   *
   * @private
   * @param {Array<DualAttributeData>} transformBuffers - The transform buffers.
   * @return {WebGLTransformFeedback} The transform feedback.
   */ _getTransformFeedback(e) {
        let t = "";
        for(let s = 0; s < e.length; s++)t += ":" + e[s].id;
        let i = this.transformFeedbackCache[t];
        if (i !== void 0) return i;
        const { gl: n } = this;
        i = n.createTransformFeedback(), n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, i);
        for(let s = 0; s < e.length; s++){
            const a = e[s];
            n.bindBufferBase(n.TRANSFORM_FEEDBACK_BUFFER, s, a.transformBuffer);
        }
        return n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, null), this.transformFeedbackCache[t] = i, i;
    }
    /**
   * Setups the given bindings.
   *
   * @private
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {WebGLProgram} programGPU - The WebGL program.
   */ _setupBindings(e, t) {
        const i = this.gl;
        for (const n of e)for (const s of n.bindings){
            const o = this.get(s).index;
            if (s.isUniformsGroup || s.isUniformBuffer) {
                const g = i.getUniformBlockIndex(t, s.name);
                i.uniformBlockBinding(t, g, o);
            } else if (s.isSampledTexture) {
                const g = i.getUniformLocation(t, s.name);
                i.uniform1i(g, o);
            }
        }
    }
    /**
   * Binds the given uniforms.
   *
   * @private
   * @param {Array<BindGroup>} bindings - The bindings.
   */ _bindUniforms(e) {
        const { gl: t, state: i } = this;
        for (const n of e)for (const s of n.bindings){
            const a = this.get(s), o = a.index;
            s.isUniformsGroup || s.isUniformBuffer ? i.bindBufferBase(t.UNIFORM_BUFFER, o, a.bufferGPU) : s.isSampledTexture && i.bindTexture(a.glTextureType, a.textureGPU, t.TEXTURE0 + o);
        }
    }
    /**
   * The method ensures multisampled render targets are resolved.
   *
   * @private
   * @param {RenderContext} renderContext - The render context.
   */ _resolveRenderTarget(e) {
        const { gl: t, state: i } = this, n = e.renderTarget;
        if (e.textures !== null && n) {
            const s = this.get(n);
            if (n.samples > 0 && this._useMultisampledExtension(n) === !1) {
                const a = s.framebuffers[e.getCacheKey()];
                let o = t.COLOR_BUFFER_BIT;
                n.resolveDepthBuffer && (n.depthBuffer && (o |= t.DEPTH_BUFFER_BIT), n.stencilBuffer && n.resolveStencilBuffer && (o |= t.STENCIL_BUFFER_BIT));
                const g = s.msaaFrameBuffer, l = s.msaaRenderbuffers, c = e.textures, d = c.length > 1;
                if (i.bindFramebuffer(t.READ_FRAMEBUFFER, g), i.bindFramebuffer(t.DRAW_FRAMEBUFFER, a), d) for(let p = 0; p < c.length; p++)t.framebufferRenderbuffer(t.READ_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + p, t.RENDERBUFFER, null), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + p, t.TEXTURE_2D, null, 0);
                for(let p = 0; p < c.length; p++){
                    if (d) {
                        const { textureGPU: A } = this.get(c[p]);
                        t.framebufferRenderbuffer(t.READ_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.RENDERBUFFER, l[p]), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, A, 0);
                    }
                    if (e.scissor) {
                        const { x: A, y: y, width: G, height: Z } = e.scissorValue, v = e.height - Z - y;
                        t.blitFramebuffer(A, v, A + G, v + Z, A, v, A + G, v + Z, o, t.NEAREST);
                    } else t.blitFramebuffer(0, 0, e.width, e.height, 0, 0, e.width, e.height, o, t.NEAREST);
                }
                if (d) for(let p = 0; p < c.length; p++){
                    const { textureGPU: A } = this.get(c[p]);
                    t.framebufferRenderbuffer(t.READ_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + p, t.RENDERBUFFER, l[p]), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + p, t.TEXTURE_2D, A, 0);
                }
                this._supportsInvalidateFramebuffer === !0 && t.invalidateFramebuffer(t.READ_FRAMEBUFFER, s.invalidationArray);
            } else if (n.resolveDepthBuffer === !1 && s.framebuffers) {
                const a = s.framebuffers[e.getCacheKey()];
                i.bindFramebuffer(t.DRAW_FRAMEBUFFER, a), t.invalidateFramebuffer(t.DRAW_FRAMEBUFFER, s.depthInvalidationArray);
            }
        }
    }
    /**
   * Returns `true` if the `WEBGL_multisampled_render_to_texture` extension
   * should be used when MSAA is enabled.
   *
   * @private
   * @param {RenderTarget} renderTarget - The render target that should be multisampled.
   * @return {boolean} Whether to use the `WEBGL_multisampled_render_to_texture` extension for MSAA or not.
   */ _useMultisampledExtension(e) {
        return e.multiview === !0 ? !0 : e.samples > 0 && this.extensions.has("WEBGL_multisampled_render_to_texture") === !0 && e._autoAllocateDepthBuffer !== !1;
    }
    /**
   * Frees internal resources.
   */ dispose() {
        this.textureUtils !== null && this.textureUtils.dispose();
        const e = this.extensions.get("WEBGL_lose_context");
        e && e.loseContext(), this.renderer.domElement.removeEventListener("webglcontextlost", this._onContextLost);
    }
}
const $d7238066c5de7f1c$var$CA = {
    PointList: "point-list",
    LineList: "line-list",
    LineStrip: "line-strip",
    TriangleList: "triangle-list",
    TriangleStrip: "triangle-strip"
}, $d7238066c5de7f1c$var$ra = {
    Never: "never",
    Less: "less",
    Equal: "equal",
    LessEqual: "less-equal",
    Greater: "greater",
    NotEqual: "not-equal",
    GreaterEqual: "greater-equal",
    Always: "always"
}, $d7238066c5de7f1c$var$eo = {
    Store: "store"
}, $d7238066c5de7f1c$var$dn = {
    Load: "load",
    Clear: "clear"
}, $d7238066c5de7f1c$var$_9 = {
    CCW: "ccw",
    CW: "cw"
}, $d7238066c5de7f1c$var$P9 = {
    None: "none",
    Back: "back"
}, $d7238066c5de7f1c$var$UA = {
    Uint16: "uint16",
    Uint32: "uint32"
}, $d7238066c5de7f1c$var$se = {
    // 8-bit formats
    R8Unorm: "r8unorm",
    R8Snorm: "r8snorm",
    R8Uint: "r8uint",
    R8Sint: "r8sint",
    // 16-bit formats
    R16Uint: "r16uint",
    R16Sint: "r16sint",
    R16Float: "r16float",
    RG8Unorm: "rg8unorm",
    RG8Snorm: "rg8snorm",
    RG8Uint: "rg8uint",
    RG8Sint: "rg8sint",
    // 32-bit formats
    R32Uint: "r32uint",
    R32Sint: "r32sint",
    R32Float: "r32float",
    RG16Uint: "rg16uint",
    RG16Sint: "rg16sint",
    RG16Float: "rg16float",
    RGBA8Unorm: "rgba8unorm",
    RGBA8UnormSRGB: "rgba8unorm-srgb",
    RGBA8Snorm: "rgba8snorm",
    RGBA8Uint: "rgba8uint",
    RGBA8Sint: "rgba8sint",
    BGRA8Unorm: "bgra8unorm",
    BGRA8UnormSRGB: "bgra8unorm-srgb",
    // Packed 32-bit formats
    RGB9E5UFloat: "rgb9e5ufloat",
    RGB10A2Unorm: "rgb10a2unorm",
    RG11B10UFloat: "rg11b10ufloat",
    // 64-bit formats
    RG32Uint: "rg32uint",
    RG32Sint: "rg32sint",
    RG32Float: "rg32float",
    RGBA16Uint: "rgba16uint",
    RGBA16Sint: "rgba16sint",
    RGBA16Float: "rgba16float",
    // 128-bit formats
    RGBA32Uint: "rgba32uint",
    RGBA32Sint: "rgba32sint",
    RGBA32Float: "rgba32float",
    Depth16Unorm: "depth16unorm",
    Depth24Plus: "depth24plus",
    Depth24PlusStencil8: "depth24plus-stencil8",
    Depth32Float: "depth32float",
    // 'depth32float-stencil8' extension
    Depth32FloatStencil8: "depth32float-stencil8",
    // BC compressed formats usable if 'texture-compression-bc' is both
    // supported by the device/user agent and enabled in requestDevice.
    BC1RGBAUnorm: "bc1-rgba-unorm",
    BC1RGBAUnormSRGB: "bc1-rgba-unorm-srgb",
    BC2RGBAUnorm: "bc2-rgba-unorm",
    BC2RGBAUnormSRGB: "bc2-rgba-unorm-srgb",
    BC3RGBAUnorm: "bc3-rgba-unorm",
    BC3RGBAUnormSRGB: "bc3-rgba-unorm-srgb",
    BC4RUnorm: "bc4-r-unorm",
    BC4RSnorm: "bc4-r-snorm",
    BC5RGUnorm: "bc5-rg-unorm",
    BC5RGSnorm: "bc5-rg-snorm",
    BC6HRGBUFloat: "bc6h-rgb-ufloat",
    BC6HRGBFloat: "bc6h-rgb-float",
    BC7RGBAUnorm: "bc7-rgba-unorm",
    BC7RGBAUnormSRGB: "bc7-rgba-unorm-srgb",
    // ETC2 compressed formats usable if 'texture-compression-etc2' is both
    // supported by the device/user agent and enabled in requestDevice.
    ETC2RGB8Unorm: "etc2-rgb8unorm",
    ETC2RGB8UnormSRGB: "etc2-rgb8unorm-srgb",
    ETC2RGB8A1Unorm: "etc2-rgb8a1unorm",
    ETC2RGB8A1UnormSRGB: "etc2-rgb8a1unorm-srgb",
    ETC2RGBA8Unorm: "etc2-rgba8unorm",
    ETC2RGBA8UnormSRGB: "etc2-rgba8unorm-srgb",
    EACR11Unorm: "eac-r11unorm",
    EACR11Snorm: "eac-r11snorm",
    EACRG11Unorm: "eac-rg11unorm",
    EACRG11Snorm: "eac-rg11snorm",
    // ASTC compressed formats usable if 'texture-compression-astc' is both
    // supported by the device/user agent and enabled in requestDevice.
    ASTC4x4Unorm: "astc-4x4-unorm",
    ASTC4x4UnormSRGB: "astc-4x4-unorm-srgb",
    ASTC5x4Unorm: "astc-5x4-unorm",
    ASTC5x4UnormSRGB: "astc-5x4-unorm-srgb",
    ASTC5x5Unorm: "astc-5x5-unorm",
    ASTC5x5UnormSRGB: "astc-5x5-unorm-srgb",
    ASTC6x5Unorm: "astc-6x5-unorm",
    ASTC6x5UnormSRGB: "astc-6x5-unorm-srgb",
    ASTC6x6Unorm: "astc-6x6-unorm",
    ASTC6x6UnormSRGB: "astc-6x6-unorm-srgb",
    ASTC8x5Unorm: "astc-8x5-unorm",
    ASTC8x5UnormSRGB: "astc-8x5-unorm-srgb",
    ASTC8x6Unorm: "astc-8x6-unorm",
    ASTC8x6UnormSRGB: "astc-8x6-unorm-srgb",
    ASTC8x8Unorm: "astc-8x8-unorm",
    ASTC8x8UnormSRGB: "astc-8x8-unorm-srgb",
    ASTC10x5Unorm: "astc-10x5-unorm",
    ASTC10x5UnormSRGB: "astc-10x5-unorm-srgb",
    ASTC10x6Unorm: "astc-10x6-unorm",
    ASTC10x6UnormSRGB: "astc-10x6-unorm-srgb",
    ASTC10x8Unorm: "astc-10x8-unorm",
    ASTC10x8UnormSRGB: "astc-10x8-unorm-srgb",
    ASTC10x10Unorm: "astc-10x10-unorm",
    ASTC10x10UnormSRGB: "astc-10x10-unorm-srgb",
    ASTC12x10Unorm: "astc-12x10-unorm",
    ASTC12x10UnormSRGB: "astc-12x10-unorm-srgb",
    ASTC12x12Unorm: "astc-12x12-unorm",
    ASTC12x12UnormSRGB: "astc-12x12-unorm-srgb"
}, $d7238066c5de7f1c$var$FH = {
    ClampToEdge: "clamp-to-edge",
    Repeat: "repeat",
    MirrorRepeat: "mirror-repeat"
}, $d7238066c5de7f1c$var$RC = {
    Linear: "linear",
    Nearest: "nearest"
}, $d7238066c5de7f1c$var$xi = {
    Zero: "zero",
    One: "one",
    Src: "src",
    OneMinusSrc: "one-minus-src",
    SrcAlpha: "src-alpha",
    OneMinusSrcAlpha: "one-minus-src-alpha",
    Dst: "dst",
    OneMinusDst: "one-minus-dst",
    DstAlpha: "dst-alpha",
    OneMinusDstAlpha: "one-minus-dst-alpha",
    SrcAlphaSaturated: "src-alpha-saturated",
    Constant: "constant",
    OneMinusConstant: "one-minus-constant"
}, $d7238066c5de7f1c$var$uC = {
    Add: "add",
    Subtract: "subtract",
    ReverseSubtract: "reverse-subtract",
    Min: "min",
    Max: "max"
}, $d7238066c5de7f1c$var$Q9 = {
    None: 0,
    All: 15
}, $d7238066c5de7f1c$var$Ld = {
    Keep: "keep",
    Zero: "zero",
    Replace: "replace",
    Invert: "invert",
    IncrementClamp: "increment-clamp",
    DecrementClamp: "decrement-clamp",
    IncrementWrap: "increment-wrap",
    DecrementWrap: "decrement-wrap"
}, $d7238066c5de7f1c$var$TH = {
    Storage: "storage",
    ReadOnlyStorage: "read-only-storage"
}, $d7238066c5de7f1c$var$MH = {
    WriteOnly: "write-only",
    ReadOnly: "read-only",
    ReadWrite: "read-write"
}, $d7238066c5de7f1c$var$O9 = {
    NonFiltering: "non-filtering",
    Comparison: "comparison"
}, $d7238066c5de7f1c$var$IC = {
    Float: "float",
    UnfilterableFloat: "unfilterable-float",
    Depth: "depth",
    SInt: "sint",
    UInt: "uint"
}, $d7238066c5de7f1c$var$j9 = {
    TwoD: "2d",
    ThreeD: "3d"
}, $d7238066c5de7f1c$var$nr = {
    TwoD: "2d",
    TwoDArray: "2d-array",
    Cube: "cube",
    ThreeD: "3d"
}, $d7238066c5de7f1c$var$pue = {
    All: "all"
}, $d7238066c5de7f1c$var$Ov = {
    Vertex: "vertex",
    Instance: "instance"
}, $d7238066c5de7f1c$var$_2 = {
    CoreFeaturesAndLimits: "core-features-and-limits",
    DepthClipControl: "depth-clip-control",
    Depth32FloatStencil8: "depth32float-stencil8",
    TextureCompressionBC: "texture-compression-bc",
    TextureCompressionBCSliced3D: "texture-compression-bc-sliced-3d",
    TextureCompressionETC2: "texture-compression-etc2",
    TextureCompressionASTC: "texture-compression-astc",
    TextureCompressionASTCSliced3D: "texture-compression-astc-sliced-3d",
    TimestampQuery: "timestamp-query",
    IndirectFirstInstance: "indirect-first-instance",
    ShaderF16: "shader-f16",
    RG11B10UFloat: "rg11b10ufloat-renderable",
    BGRA8UNormStorage: "bgra8unorm-storage",
    Float32Filterable: "float32-filterable",
    Float32Blendable: "float32-blendable",
    ClipDistances: "clip-distances",
    DualSourceBlending: "dual-source-blending",
    Subgroups: "subgroups",
    TextureFormatsTier1: "texture-formats-tier1",
    TextureFormatsTier2: "texture-formats-tier2"
}, $d7238066c5de7f1c$var$q9 = {
    "texture-compression-s3tc": "texture-compression-bc",
    "texture-compression-etc1": "texture-compression-etc2"
};
class $d7238066c5de7f1c$var$mue extends $d7238066c5de7f1c$var$$D {
    /**
   * Constructs a new node-based sampler.
   *
   * @param {string} name - The samplers's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */ constructor(e, t, i){
        super(e, t ? t.value : null), this.textureNode = t, this.groupNode = i;
    }
    /**
   * Updates the texture value of this sampler.
   *
   * @return {boolean} Whether the sampler needs an update or not.
   */ update() {
        const { textureNode: e } = this;
        return this.texture !== e.value ? (this.texture = e.value, !0) : super.update();
    }
}
class $d7238066c5de7f1c$var$Aue extends $d7238066c5de7f1c$var$QD {
    /**
   * Constructs a new uniform buffer.
   *
   * @param {string} name - The buffer's name.
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ constructor(e, t){
        super(e, t ? t.array : null), this.attribute = t, this.isStorageBuffer = !0;
    }
}
let $d7238066c5de7f1c$var$bue = 0;
class $d7238066c5de7f1c$var$yue extends $d7238066c5de7f1c$var$Aue {
    /**
   * Constructs a new node-based storage buffer.
   *
   * @param {StorageBufferNode} nodeUniform - The storage buffer node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */ constructor(e, t){
        super("StorageBuffer_" + $d7238066c5de7f1c$var$bue++, e ? e.value : null), this.nodeUniform = e, this.access = e ? e.access : $d7238066c5de7f1c$var$da.READ_WRITE, this.groupNode = t;
    }
    /**
   * The storage buffer.
   *
   * @type {BufferAttribute}
   */ get buffer() {
        return this.nodeUniform.value;
    }
}
class $d7238066c5de7f1c$var$Bue extends $d7238066c5de7f1c$var$dh {
    /**
   * Constructs a new utility object.
   *
   * @param {GPUDevice} device - The WebGPU device.
   */ constructor(e){
        super(), this.device = e;
        const t = `
struct VarysStruct {
	@builtin( position ) Position: vec4<f32>,
	@location( 0 ) vTex : vec2<f32>
};

@vertex
fn main( @builtin( vertex_index ) vertexIndex : u32 ) -> VarysStruct {

	var Varys : VarysStruct;

	var pos = array< vec2<f32>, 4 >(
		vec2<f32>( -1.0,  1.0 ),
		vec2<f32>(  1.0,  1.0 ),
		vec2<f32>( -1.0, -1.0 ),
		vec2<f32>(  1.0, -1.0 )
	);

	var tex = array< vec2<f32>, 4 >(
		vec2<f32>( 0.0, 0.0 ),
		vec2<f32>( 1.0, 0.0 ),
		vec2<f32>( 0.0, 1.0 ),
		vec2<f32>( 1.0, 1.0 )
	);

	Varys.vTex = tex[ vertexIndex ];
	Varys.Position = vec4<f32>( pos[ vertexIndex ], 0.0, 1.0 );

	return Varys;

}
`, i = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vTex );

}
`, n = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vec2( vTex.x, 1.0 - vTex.y ) );

}
`;
        this.mipmapSampler = e.createSampler({
            minFilter: $d7238066c5de7f1c$var$RC.Linear
        }), this.flipYSampler = e.createSampler({
            minFilter: $d7238066c5de7f1c$var$RC.Nearest
        }), this.transferPipelines = {}, this.flipYPipelines = {}, this.mipmapVertexShaderModule = e.createShaderModule({
            label: "mipmapVertex",
            code: t
        }), this.mipmapFragmentShaderModule = e.createShaderModule({
            label: "mipmapFragment",
            code: i
        }), this.flipYFragmentShaderModule = e.createShaderModule({
            label: "flipYFragment",
            code: n
        });
    }
    /**
   * Returns a render pipeline for the internal copy render pass. The pass
   * requires a unique render pipeline for each texture format.
   *
   * @param {string} format - The GPU texture format
   * @return {GPURenderPipeline} The GPU render pipeline.
   */ getTransferPipeline(e) {
        let t = this.transferPipelines[e];
        return t === void 0 && (t = this.device.createRenderPipeline({
            label: `mipmap-${e}`,
            vertex: {
                module: this.mipmapVertexShaderModule,
                entryPoint: "main"
            },
            fragment: {
                module: this.mipmapFragmentShaderModule,
                entryPoint: "main",
                targets: [
                    {
                        format: e
                    }
                ]
            },
            primitive: {
                topology: $d7238066c5de7f1c$var$CA.TriangleStrip,
                stripIndexFormat: $d7238066c5de7f1c$var$UA.Uint32
            },
            layout: "auto"
        }), this.transferPipelines[e] = t), t;
    }
    /**
   * Returns a render pipeline for the flipY render pass. The pass
   * requires a unique render pipeline for each texture format.
   *
   * @param {string} format - The GPU texture format
   * @return {GPURenderPipeline} The GPU render pipeline.
   */ getFlipYPipeline(e) {
        let t = this.flipYPipelines[e];
        return t === void 0 && (t = this.device.createRenderPipeline({
            label: `flipY-${e}`,
            vertex: {
                module: this.mipmapVertexShaderModule,
                entryPoint: "main"
            },
            fragment: {
                module: this.flipYFragmentShaderModule,
                entryPoint: "main",
                targets: [
                    {
                        format: e
                    }
                ]
            },
            primitive: {
                topology: $d7238066c5de7f1c$var$CA.TriangleStrip,
                stripIndexFormat: $d7238066c5de7f1c$var$UA.Uint32
            },
            layout: "auto"
        }), this.flipYPipelines[e] = t), t;
    }
    /**
   * Flip the contents of the given GPU texture along its vertical axis.
   *
   * @param {GPUTexture} textureGPU - The GPU texture object.
   * @param {Object} textureGPUDescriptor - The texture descriptor.
   * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
   */ flipY(e, t, i = 0) {
        const n = t.format, { width: s, height: a } = t.size, o = this.getTransferPipeline(n), g = this.getFlipYPipeline(n), l = this.device.createTexture({
            size: {
                width: s,
                height: a,
                depthOrArrayLayers: 1
            },
            format: n,
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
        }), c = e.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: $d7238066c5de7f1c$var$nr.TwoD,
            baseArrayLayer: i
        }), d = l.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: $d7238066c5de7f1c$var$nr.TwoD,
            baseArrayLayer: 0
        }), p = this.device.createCommandEncoder({}), A = (y, G, Z)=>{
            const v = y.getBindGroupLayout(0), V = this.device.createBindGroup({
                layout: v,
                entries: [
                    {
                        binding: 0,
                        resource: this.flipYSampler
                    },
                    {
                        binding: 1,
                        resource: G
                    }
                ]
            }), H = p.beginRenderPass({
                colorAttachments: [
                    {
                        view: Z,
                        loadOp: $d7238066c5de7f1c$var$dn.Clear,
                        storeOp: $d7238066c5de7f1c$var$eo.Store,
                        clearValue: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                ]
            });
            H.setPipeline(y), H.setBindGroup(0, V), H.draw(4, 1, 0, 0), H.end();
        };
        A(o, c, d), A(g, d, c), this.device.queue.submit([
            p.finish()
        ]), l.destroy();
    }
    /**
   * Generates mipmaps for the given GPU texture.
   *
   * @param {GPUTexture} textureGPU - The GPU texture object.
   * @param {Object} textureGPUDescriptor - The texture descriptor.
   * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
   * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
   */ generateMipmaps(e, t, i = 0, n = null) {
        const s = this.get(e);
        s.layers === void 0 && (s.layers = []);
        const a = s.layers[i] || this._mipmapCreateBundles(e, t, i), o = n || this.device.createCommandEncoder({
            label: "mipmapEncoder"
        });
        this._mipmapRunBundles(o, a), n === null && this.device.queue.submit([
            o.finish()
        ]), s.layers[i] = a;
    }
    /**
   * Since multiple copy render passes are required to generate mipmaps, the passes
   * are managed as render bundles to improve performance.
   *
   * @param {GPUTexture} textureGPU - The GPU texture object.
   * @param {Object} textureGPUDescriptor - The texture descriptor.
   * @param {number} baseArrayLayer - The index of the first array layer accessible to the texture view.
   * @return {Array<Object>} An array of render bundles.
   */ _mipmapCreateBundles(e, t, i) {
        const n = this.getTransferPipeline(t.format), s = n.getBindGroupLayout(0);
        let a = e.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: $d7238066c5de7f1c$var$nr.TwoD,
            baseArrayLayer: i
        });
        const o = [];
        for(let g = 1; g < t.mipLevelCount; g++){
            const l = this.device.createBindGroup({
                layout: s,
                entries: [
                    {
                        binding: 0,
                        resource: this.mipmapSampler
                    },
                    {
                        binding: 1,
                        resource: a
                    }
                ]
            }), c = e.createView({
                baseMipLevel: g,
                mipLevelCount: 1,
                dimension: $d7238066c5de7f1c$var$nr.TwoD,
                baseArrayLayer: i
            }), d = {
                colorAttachments: [
                    {
                        view: c,
                        loadOp: $d7238066c5de7f1c$var$dn.Clear,
                        storeOp: $d7238066c5de7f1c$var$eo.Store,
                        clearValue: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                ]
            }, p = this.device.createRenderBundleEncoder({
                colorFormats: [
                    t.format
                ]
            });
            p.setPipeline(n), p.setBindGroup(0, l), p.draw(4, 1, 0, 0), o.push({
                renderBundles: [
                    p.finish()
                ],
                passDescriptor: d
            }), a = c;
        }
        return o;
    }
    /**
   * Executes the render bundles.
   *
   * @param {GPUCommandEncoder} commandEncoder - The GPU command encoder.
   * @param {Array<Object>} passes - An array of render bundles.
   */ _mipmapRunBundles(e, t) {
        const i = t.length;
        for(let n = 0; n < i; n++){
            const s = t[n], a = e.beginRenderPass(s.passDescriptor);
            a.executeBundles(s.renderBundles), a.end();
        }
    }
}
const $d7238066c5de7f1c$var$fue = {
    [$d7238066c5de7f1c$var$$k]: "never",
    [$d7238066c5de7f1c$var$qN]: "less",
    [$d7238066c5de7f1c$var$e3]: "equal",
    [$d7238066c5de7f1c$var$t3]: "less-equal",
    [$d7238066c5de7f1c$var$i3]: "greater",
    [$d7238066c5de7f1c$var$s3]: "greater-equal",
    [$d7238066c5de7f1c$var$r3]: "always",
    [$d7238066c5de7f1c$var$n3]: "not-equal"
}, $d7238066c5de7f1c$var$Gue = [
    0,
    1,
    3,
    2,
    4,
    5
];
class $d7238066c5de7f1c$var$vue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGPUBackend} backend - The WebGPU backend.
   */ constructor(e){
        this.backend = e, this._passUtils = null, this.defaultTexture = {}, this.defaultCubeTexture = {}, this.defaultVideoFrame = null, this._samplerCache = /* @__PURE__ */ new Map();
    }
    /**
   * Creates a GPU sampler for the given texture.
   *
   * @param {Texture} texture - The texture to create the sampler for.
   * @return {string} The current sampler key.
   */ updateSampler(e) {
        const t = this.backend, i = e.minFilter + "-" + e.magFilter + "-" + e.wrapS + "-" + e.wrapT + "-" + (e.wrapR || "0") + "-" + e.anisotropy + "-" + (e.compareFunction || 0);
        let n = this._samplerCache.get(i);
        if (n === void 0) {
            const a = {
                addressModeU: this._convertAddressMode(e.wrapS),
                addressModeV: this._convertAddressMode(e.wrapT),
                addressModeW: this._convertAddressMode(e.wrapR),
                magFilter: this._convertFilterMode(e.magFilter),
                minFilter: this._convertFilterMode(e.minFilter),
                mipmapFilter: this._convertFilterMode(e.minFilter),
                maxAnisotropy: 1
            };
            a.magFilter === $d7238066c5de7f1c$var$RC.Linear && a.minFilter === $d7238066c5de7f1c$var$RC.Linear && a.mipmapFilter === $d7238066c5de7f1c$var$RC.Linear && (a.maxAnisotropy = e.anisotropy), e.isDepthTexture && e.compareFunction !== null && (a.compare = $d7238066c5de7f1c$var$fue[e.compareFunction]), n = {
                sampler: t.device.createSampler(a),
                usedTimes: 0
            }, this._samplerCache.set(i, n);
        }
        const s = t.get(e);
        if (s.sampler !== n.sampler) {
            if (s.sampler !== void 0) {
                const a = this._samplerCache.get(s.samplerKey);
                a.usedTimes--, a.usedTimes === 0 && this._samplerCache.delete(s.samplerKey);
            }
            s.samplerKey = i, s.sampler = n.sampler, n.usedTimes++;
        }
        return i;
    }
    /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @param {Texture} texture - The texture to create a default texture for.
   */ createDefaultTexture(e) {
        let t;
        const i = $d7238066c5de7f1c$var$P2(e);
        e.isCubeTexture ? t = this._getDefaultCubeTextureGPU(i) : t = this._getDefaultTextureGPU(i), this.backend.get(e).texture = t;
    }
    /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ createTexture(e, t = {}) {
        const i = this.backend, n = i.get(e);
        if (n.initialized) throw new Error("WebGPUTextureUtils: Texture already initialized.");
        if (e.isExternalTexture) {
            n.texture = e.sourceTexture, n.initialized = !0;
            return;
        }
        t.needsMipmaps === void 0 && (t.needsMipmaps = !1), t.levels === void 0 && (t.levels = 1), t.depth === void 0 && (t.depth = 1);
        const { width: s, height: a, depth: o, levels: g } = t;
        e.isFramebufferTexture && (t.renderTarget ? t.format = this.backend.utils.getCurrentColorFormat(t.renderTarget) : t.format = this.backend.utils.getPreferredCanvasFormat());
        const l = this._getDimension(e), c = e.internalFormat || t.format || $d7238066c5de7f1c$var$P2(e, i.device);
        n.format = c;
        const { samples: d, primarySamples: p, isMSAA: A } = i.utils.getTextureSampleData(e);
        let y = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC;
        e.isStorageTexture === !0 && (y |= GPUTextureUsage.STORAGE_BINDING), e.isCompressedTexture !== !0 && e.isCompressedArrayTexture !== !0 && c !== $d7238066c5de7f1c$var$se.RGB9E5UFloat && (y |= GPUTextureUsage.RENDER_ATTACHMENT);
        const G = {
            label: e.name,
            size: {
                width: s,
                height: a,
                depthOrArrayLayers: o
            },
            mipLevelCount: g,
            sampleCount: p,
            dimension: l,
            format: c,
            usage: y
        };
        if (c === void 0) {
            $d7238066c5de7f1c$var$ze("WebGPURenderer: Texture format not supported."), this.createDefaultTexture(e);
            return;
        }
        if (e.isCubeTexture && (G.textureBindingViewDimension = $d7238066c5de7f1c$var$nr.Cube), n.texture = i.device.createTexture(G), A) {
            const Z = Object.assign({}, G);
            Z.label = Z.label + "-msaa", Z.sampleCount = d, Z.mipLevelCount = 1, n.msaaTexture = i.device.createTexture(Z);
        }
        n.initialized = !0, n.textureDescriptorGPU = G;
    }
    /**
   * Destroys the GPU data for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
   */ destroyTexture(e, t = !1) {
        const i = this.backend, n = i.get(e);
        n.texture !== void 0 && t === !1 && n.texture.destroy(), n.msaaTexture !== void 0 && n.msaaTexture.destroy(), i.delete(e);
    }
    /**
   * Generates mipmaps for the given texture.
   *
   * @param {Texture} texture - The texture.
   * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
   */ generateMipmaps(e, t = null) {
        const i = this.backend.get(e);
        if (e.isCubeTexture) for(let n = 0; n < 6; n++)this._generateMipmaps(i.texture, i.textureDescriptorGPU, n, t);
        else {
            const n = e.image.depth || 1;
            for(let s = 0; s < n; s++)this._generateMipmaps(i.texture, i.textureDescriptorGPU, s, t);
        }
    }
    /**
   * Returns the color buffer representing the color
   * attachment of the default framebuffer.
   *
   * @return {GPUTexture} The color buffer.
   */ getColorBuffer() {
        const e = this.backend, t = e.renderer.getCanvasTarget(), { width: i, height: n } = e.getDrawingBufferSize(), s = e.renderer.currentSamples, a = t.colorTexture, o = e.get(a);
        if (a.width === i && a.height === n && a.samples === s) return o.texture;
        let g = o.texture;
        return g && g.destroy(), g = e.device.createTexture({
            label: "colorBuffer",
            size: {
                width: i,
                height: n,
                depthOrArrayLayers: 1
            },
            sampleCount: e.utils.getSampleCount(e.renderer.currentSamples),
            format: e.utils.getPreferredCanvasFormat(),
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC
        }), a.source.width = i, a.source.height = n, a.samples = s, o.texture = g, g;
    }
    /**
   * Returns the depth buffer representing the depth
   * attachment of the default framebuffer.
   *
   * @param {boolean} [depth=true] - Whether depth is enabled or not.
   * @param {boolean} [stencil=false] -  Whether stencil is enabled or not.
   * @return {GPUTexture} The depth buffer.
   */ getDepthBuffer(e = !0, t = !1) {
        const i = this.backend, n = i.renderer.getCanvasTarget(), { width: s, height: a } = i.getDrawingBufferSize(), o = i.renderer.currentSamples, g = n.depthTexture;
        if (g.width === s && g.height === a && g.samples === o && g.depth === e && g.stencil === t) return i.get(g).texture;
        const l = i.get(g).texture;
        let c, d;
        if (t ? (c = $d7238066c5de7f1c$var$dI, d = $d7238066c5de7f1c$var$sh) : e && (c = $d7238066c5de7f1c$var$nu, d = $d7238066c5de7f1c$var$Xs), l !== void 0) {
            if (g.image.width === s && g.image.height === a && g.format === c && g.type === d && g.samples === o) return l;
            this.destroyTexture(g);
        }
        return g.name = "depthBuffer", g.format = c, g.type = d, g.image.width = s, g.image.height = a, g.samples = o, this.createTexture(g, {
            width: s,
            height: a
        }), i.get(g).texture;
    }
    /**
   * Uploads the updated texture data to the GPU.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ updateTexture(e, t) {
        const i = this.backend.get(e), n = e.mipmaps, { textureDescriptorGPU: s } = i;
        if (!(e.isRenderTargetTexture || s === void 0)) {
            if (e.isDataTexture) {
                if (n.length > 0) for(let a = 0, o = n.length; a < o; a++){
                    const g = n[a];
                    this._copyBufferToTexture(g, i.texture, s, 0, e.flipY, 0, a);
                }
                else this._copyBufferToTexture(t.image, i.texture, s, 0, e.flipY);
            } else if (e.isArrayTexture || e.isDataArrayTexture || e.isData3DTexture) for(let a = 0; a < t.image.depth; a++)this._copyBufferToTexture(t.image, i.texture, s, a, e.flipY, a);
            else if (e.isCompressedTexture || e.isCompressedArrayTexture) this._copyCompressedBufferToTexture(e.mipmaps, i.texture, s);
            else if (e.isCubeTexture) this._copyCubeMapToTexture(e, i.texture, s);
            else if (n.length > 0) for(let a = 0, o = n.length; a < o; a++){
                const g = n[a];
                this._copyImageToTexture(g, i.texture, s, 0, e.flipY, e.premultiplyAlpha, a);
            }
            else this._copyImageToTexture(t.image, i.texture, s, 0, e.flipY, e.premultiplyAlpha);
            i.version = e.version;
        }
    }
    /**
   * Returns texture data as a typed array.
   *
   * @async
   * @param {Texture} texture - The texture to copy.
   * @param {number} x - The x coordinate of the copy origin.
   * @param {number} y - The y coordinate of the copy origin.
   * @param {number} width - The width of the copy.
   * @param {number} height - The height of the copy.
   * @param {number} faceIndex - The face index.
   * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
   */ async copyTextureToBuffer(e, t, i, n, s, a) {
        const o = this.backend.device, g = this.backend.get(e), l = g.texture, c = g.textureDescriptorGPU.format, d = this._getBytesPerTexel(c);
        let p = n * d;
        p = Math.ceil(p / 256) * 256;
        const A = o.createBuffer({
            size: (s - 1) * p + n * d,
            // see https://github.com/mrdoob/three.js/issues/31658#issuecomment-3229442010
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }), y = o.createCommandEncoder();
        y.copyTextureToBuffer({
            texture: l,
            origin: {
                x: t,
                y: i,
                z: a
            }
        }, {
            buffer: A,
            bytesPerRow: p
        }, {
            width: n,
            height: s
        });
        const G = this._getTypedArrayType(c);
        o.queue.submit([
            y.finish()
        ]), await A.mapAsync(GPUMapMode.READ);
        const Z = A.getMappedRange();
        return new G(Z);
    }
    /**
   * Frees all internal resources.
   */ dispose() {
        this._samplerCache.clear();
    }
    /**
   * Returns the default GPU texture for the given format.
   *
   * @private
   * @param {string} format - The GPU format.
   * @return {GPUTexture} The GPU texture.
   */ _getDefaultTextureGPU(e) {
        let t = this.defaultTexture[e];
        if (t === void 0) {
            const i = new $d7238066c5de7f1c$var$Ca();
            i.minFilter = $d7238066c5de7f1c$var$Sr, i.magFilter = $d7238066c5de7f1c$var$Sr, this.createTexture(i, {
                width: 1,
                height: 1,
                format: e
            }), this.defaultTexture[e] = t = i;
        }
        return this.backend.get(t).texture;
    }
    /**
   * Returns the default GPU cube texture for the given format.
   *
   * @private
   * @param {string} format - The GPU format.
   * @return {GPUTexture} The GPU texture.
   */ _getDefaultCubeTextureGPU(e) {
        let t = this.defaultTexture[e];
        if (t === void 0) {
            const i = new $d7238066c5de7f1c$var$cR();
            i.minFilter = $d7238066c5de7f1c$var$Sr, i.magFilter = $d7238066c5de7f1c$var$Sr, this.createTexture(i, {
                width: 1,
                height: 1,
                depth: 6
            }), this.defaultCubeTexture[e] = t = i;
        }
        return this.backend.get(t).texture;
    }
    /**
   * Uploads cube texture image data to the GPU memory.
   *
   * @private
   * @param {CubeTexture} texture - The cube texture.
   * @param {GPUTexture} textureGPU - The GPU texture.
   * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
   */ _copyCubeMapToTexture(e, t, i) {
        const n = e.images, s = e.mipmaps;
        for(let a = 0; a < 6; a++){
            const o = n[a], g = e.flipY === !0 ? $d7238066c5de7f1c$var$Gue[a] : a;
            o.isDataTexture ? this._copyBufferToTexture(o.image, t, i, g, e.flipY) : this._copyImageToTexture(o, t, i, g, e.flipY, e.premultiplyAlpha);
            for(let l = 0; l < s.length; l++){
                const d = s[l].images[a];
                d.isDataTexture ? this._copyBufferToTexture(d.image, t, i, g, e.flipY, 0, l + 1) : this._copyImageToTexture(d, t, i, g, e.flipY, e.premultiplyAlpha, l + 1);
            }
        }
    }
    /**
   * Uploads texture image data to the GPU memory.
   *
   * @private
   * @param {HTMLImageElement|ImageBitmap|HTMLCanvasElement} image - The image data.
   * @param {GPUTexture} textureGPU - The GPU texture.
   * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
   * @param {number} originDepth - The origin depth.
   * @param {boolean} flipY - Whether to flip texture data along their vertical axis or not.
   * @param {boolean} premultiplyAlpha - Whether the texture should have its RGB channels premultiplied by the alpha channel or not.
   * @param {number} [mipLevel=0] - The mip level where the data should be copied to.
   */ _copyImageToTexture(e, t, i, n, s, a, o = 0) {
        const g = this.backend.device, l = o > 0 ? e.width : i.size.width, c = o > 0 ? e.height : i.size.height;
        g.queue.copyExternalImageToTexture({
            source: e,
            flipY: s
        }, {
            texture: t,
            mipLevel: o,
            origin: {
                x: 0,
                y: 0,
                z: n
            },
            premultipliedAlpha: a
        }, {
            width: l,
            height: c,
            depthOrArrayLayers: 1
        });
    }
    /**
   * Returns the pass utils singleton.
   *
   * @private
   * @return {WebGPUTexturePassUtils} The utils instance.
   */ _getPassUtils() {
        let e = this._passUtils;
        return e === null && (this._passUtils = e = new $d7238066c5de7f1c$var$Bue(this.backend.device)), e;
    }
    /**
   * Generates mipmaps for the given GPU texture.
   *
   * @private
   * @param {GPUTexture} textureGPU - The GPU texture object.
   * @param {Object} textureDescriptorGPU - The texture descriptor.
   * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
   * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
   */ _generateMipmaps(e, t, i = 0, n = null) {
        this._getPassUtils().generateMipmaps(e, t, i, n);
    }
    /**
   * Flip the contents of the given GPU texture along its vertical axis.
   *
   * @private
   * @param {GPUTexture} textureGPU - The GPU texture object.
   * @param {Object} textureDescriptorGPU - The texture descriptor.
   * @param {number} [originDepth=0] - The origin depth.
   */ _flipY(e, t, i = 0) {
        this._getPassUtils().flipY(e, t, i);
    }
    /**
   * Uploads texture buffer data to the GPU memory.
   *
   * @private
   * @param {Object} image - An object defining the image buffer data.
   * @param {GPUTexture} textureGPU - The GPU texture.
   * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
   * @param {number} originDepth - The origin depth.
   * @param {boolean} flipY - Whether to flip texture data along their vertical axis or not.
   * @param {number} [depth=0] - The depth offset when copying array or 3D texture data.
   * @param {number} [mipLevel=0] - The mip level where the data should be copied to.
   */ _copyBufferToTexture(e, t, i, n, s, a = 0, o = 0) {
        const g = this.backend.device, l = e.data, c = this._getBytesPerTexel(i.format), d = e.width * c;
        g.queue.writeTexture({
            texture: t,
            mipLevel: o,
            origin: {
                x: 0,
                y: 0,
                z: n
            }
        }, l, {
            offset: e.width * e.height * c * a,
            bytesPerRow: d
        }, {
            width: e.width,
            height: e.height,
            depthOrArrayLayers: 1
        }), s === !0 && this._flipY(t, i, n);
    }
    /**
   * Uploads compressed texture data to the GPU memory.
   *
   * @private
   * @param {Array<Object>} mipmaps - An array with mipmap data.
   * @param {GPUTexture} textureGPU - The GPU texture.
   * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
   */ _copyCompressedBufferToTexture(e, t, i) {
        const n = this.backend.device, s = this._getBlockData(i.format), a = i.size.depthOrArrayLayers > 1;
        for(let o = 0; o < e.length; o++){
            const g = e[o], l = g.width, c = g.height, d = a ? i.size.depthOrArrayLayers : 1, p = Math.ceil(l / s.width) * s.byteLength, A = p * Math.ceil(c / s.height);
            for(let y = 0; y < d; y++)n.queue.writeTexture({
                texture: t,
                mipLevel: o,
                origin: {
                    x: 0,
                    y: 0,
                    z: y
                }
            }, g.data, {
                offset: y * A,
                bytesPerRow: p,
                rowsPerImage: Math.ceil(c / s.height)
            }, {
                width: Math.ceil(l / s.width) * s.width,
                height: Math.ceil(c / s.height) * s.height,
                depthOrArrayLayers: 1
            });
        }
    }
    /**
   * This method is only relevant for compressed texture formats. It returns a block
   * data descriptor for the given GPU compressed texture format.
   *
   * @private
   * @param {string} format - The GPU compressed texture format.
   * @return {Object} The block data descriptor.
   */ _getBlockData(e) {
        if (e === $d7238066c5de7f1c$var$se.BC1RGBAUnorm || e === $d7238066c5de7f1c$var$se.BC1RGBAUnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.BC2RGBAUnorm || e === $d7238066c5de7f1c$var$se.BC2RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.BC3RGBAUnorm || e === $d7238066c5de7f1c$var$se.BC3RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.BC4RUnorm || e === $d7238066c5de7f1c$var$se.BC4RSnorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.BC5RGUnorm || e === $d7238066c5de7f1c$var$se.BC5RGSnorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.BC6HRGBUFloat || e === $d7238066c5de7f1c$var$se.BC6HRGBFloat) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.BC7RGBAUnorm || e === $d7238066c5de7f1c$var$se.BC7RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.ETC2RGB8Unorm || e === $d7238066c5de7f1c$var$se.ETC2RGB8UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.ETC2RGB8A1Unorm || e === $d7238066c5de7f1c$var$se.ETC2RGB8A1UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.ETC2RGBA8Unorm || e === $d7238066c5de7f1c$var$se.ETC2RGBA8UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.EACR11Unorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.EACR11Snorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.EACRG11Unorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.EACRG11Snorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC4x4Unorm || e === $d7238066c5de7f1c$var$se.ASTC4x4UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC5x4Unorm || e === $d7238066c5de7f1c$var$se.ASTC5x4UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 4
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC5x5Unorm || e === $d7238066c5de7f1c$var$se.ASTC5x5UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 5
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC6x5Unorm || e === $d7238066c5de7f1c$var$se.ASTC6x5UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 5
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC6x6Unorm || e === $d7238066c5de7f1c$var$se.ASTC6x6UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 6
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC8x5Unorm || e === $d7238066c5de7f1c$var$se.ASTC8x5UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 5
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC8x6Unorm || e === $d7238066c5de7f1c$var$se.ASTC8x6UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 6
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC8x8Unorm || e === $d7238066c5de7f1c$var$se.ASTC8x8UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 8
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC10x5Unorm || e === $d7238066c5de7f1c$var$se.ASTC10x5UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 5
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC10x6Unorm || e === $d7238066c5de7f1c$var$se.ASTC10x6UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 6
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC10x8Unorm || e === $d7238066c5de7f1c$var$se.ASTC10x8UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 8
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC10x10Unorm || e === $d7238066c5de7f1c$var$se.ASTC10x10UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 10
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC12x10Unorm || e === $d7238066c5de7f1c$var$se.ASTC12x10UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 10
        };
        if (e === $d7238066c5de7f1c$var$se.ASTC12x12Unorm || e === $d7238066c5de7f1c$var$se.ASTC12x12UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 12
        };
    }
    /**
   * Converts the three.js uv wrapping constants to GPU address mode constants.
   *
   * @private
   * @param {number} value - The three.js constant defining a uv wrapping mode.
   * @return {string} The GPU address mode.
   */ _convertAddressMode(e) {
        let t = $d7238066c5de7f1c$var$FH.ClampToEdge;
        return e === $d7238066c5de7f1c$var$FA ? t = $d7238066c5de7f1c$var$FH.Repeat : e === $d7238066c5de7f1c$var$TA && (t = $d7238066c5de7f1c$var$FH.MirrorRepeat), t;
    }
    /**
   * Converts the three.js filter constants to GPU filter constants.
   *
   * @private
   * @param {number} value - The three.js constant defining a filter mode.
   * @return {string} The GPU filter mode.
   */ _convertFilterMode(e) {
        let t = $d7238066c5de7f1c$var$RC.Linear;
        return (e === $d7238066c5de7f1c$var$Sr || e === $d7238066c5de7f1c$var$Qk || e === $d7238066c5de7f1c$var$lB) && (t = $d7238066c5de7f1c$var$RC.Nearest), t;
    }
    /**
   * Returns the bytes-per-texel value for the given GPU texture format.
   *
   * @private
   * @param {string} format - The GPU texture format.
   * @return {number} The bytes-per-texel.
   */ _getBytesPerTexel(e) {
        if (e === $d7238066c5de7f1c$var$se.R8Unorm || e === $d7238066c5de7f1c$var$se.R8Snorm || e === $d7238066c5de7f1c$var$se.R8Uint || e === $d7238066c5de7f1c$var$se.R8Sint) return 1;
        if (e === $d7238066c5de7f1c$var$se.R16Uint || e === $d7238066c5de7f1c$var$se.R16Sint || e === $d7238066c5de7f1c$var$se.R16Float || e === $d7238066c5de7f1c$var$se.RG8Unorm || e === $d7238066c5de7f1c$var$se.RG8Snorm || e === $d7238066c5de7f1c$var$se.RG8Uint || e === $d7238066c5de7f1c$var$se.RG8Sint) return 2;
        if (e === $d7238066c5de7f1c$var$se.R32Uint || e === $d7238066c5de7f1c$var$se.R32Sint || e === $d7238066c5de7f1c$var$se.R32Float || e === $d7238066c5de7f1c$var$se.RG16Uint || e === $d7238066c5de7f1c$var$se.RG16Sint || e === $d7238066c5de7f1c$var$se.RG16Float || e === $d7238066c5de7f1c$var$se.RGBA8Unorm || e === $d7238066c5de7f1c$var$se.RGBA8UnormSRGB || e === $d7238066c5de7f1c$var$se.RGBA8Snorm || e === $d7238066c5de7f1c$var$se.RGBA8Uint || e === $d7238066c5de7f1c$var$se.RGBA8Sint || e === $d7238066c5de7f1c$var$se.BGRA8Unorm || e === $d7238066c5de7f1c$var$se.BGRA8UnormSRGB || // Packed 32-bit formats
        e === $d7238066c5de7f1c$var$se.RGB9E5UFloat || e === $d7238066c5de7f1c$var$se.RGB10A2Unorm || e === $d7238066c5de7f1c$var$se.RG11B10UFloat || e === $d7238066c5de7f1c$var$se.Depth32Float || e === $d7238066c5de7f1c$var$se.Depth24Plus || e === $d7238066c5de7f1c$var$se.Depth24PlusStencil8 || e === $d7238066c5de7f1c$var$se.Depth32FloatStencil8) return 4;
        if (e === $d7238066c5de7f1c$var$se.RG32Uint || e === $d7238066c5de7f1c$var$se.RG32Sint || e === $d7238066c5de7f1c$var$se.RG32Float || e === $d7238066c5de7f1c$var$se.RGBA16Uint || e === $d7238066c5de7f1c$var$se.RGBA16Sint || e === $d7238066c5de7f1c$var$se.RGBA16Float) return 8;
        if (e === $d7238066c5de7f1c$var$se.RGBA32Uint || e === $d7238066c5de7f1c$var$se.RGBA32Sint || e === $d7238066c5de7f1c$var$se.RGBA32Float) return 16;
    }
    /**
   * Returns the corresponding typed array type for the given GPU texture format.
   *
   * @private
   * @param {string} format - The GPU texture format.
   * @return {TypedArray.constructor} The typed array type.
   */ _getTypedArrayType(e) {
        if (e === $d7238066c5de7f1c$var$se.R8Uint) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.R8Sint) return Int8Array;
        if (e === $d7238066c5de7f1c$var$se.R8Unorm) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.R8Snorm) return Int8Array;
        if (e === $d7238066c5de7f1c$var$se.RG8Uint) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.RG8Sint) return Int8Array;
        if (e === $d7238066c5de7f1c$var$se.RG8Unorm) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.RG8Snorm) return Int8Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA8Uint) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA8Sint) return Int8Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA8Unorm || e === $d7238066c5de7f1c$var$se.RGBA8UnormSRGB) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA8Snorm) return Int8Array;
        if (e === $d7238066c5de7f1c$var$se.R16Uint) return Uint16Array;
        if (e === $d7238066c5de7f1c$var$se.R16Sint) return Int16Array;
        if (e === $d7238066c5de7f1c$var$se.RG16Uint) return Uint16Array;
        if (e === $d7238066c5de7f1c$var$se.RG16Sint) return Int16Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA16Uint) return Uint16Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA16Sint) return Int16Array;
        if (e === $d7238066c5de7f1c$var$se.R16Float || e === $d7238066c5de7f1c$var$se.RG16Float || e === $d7238066c5de7f1c$var$se.RGBA16Float) return Uint16Array;
        if (e === $d7238066c5de7f1c$var$se.R32Uint) return Uint32Array;
        if (e === $d7238066c5de7f1c$var$se.R32Sint) return Int32Array;
        if (e === $d7238066c5de7f1c$var$se.R32Float) return Float32Array;
        if (e === $d7238066c5de7f1c$var$se.RG32Uint) return Uint32Array;
        if (e === $d7238066c5de7f1c$var$se.RG32Sint) return Int32Array;
        if (e === $d7238066c5de7f1c$var$se.RG32Float) return Float32Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA32Uint) return Uint32Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA32Sint) return Int32Array;
        if (e === $d7238066c5de7f1c$var$se.RGBA32Float) return Float32Array;
        if (e === $d7238066c5de7f1c$var$se.BGRA8Unorm || e === $d7238066c5de7f1c$var$se.BGRA8UnormSRGB) return Uint8Array;
        if (e === $d7238066c5de7f1c$var$se.RGB10A2Unorm || e === $d7238066c5de7f1c$var$se.RGB9E5UFloat || e === $d7238066c5de7f1c$var$se.RG11B10UFloat) return Uint32Array;
        if (e === $d7238066c5de7f1c$var$se.Depth32Float) return Float32Array;
        if (e === $d7238066c5de7f1c$var$se.Depth24Plus || e === $d7238066c5de7f1c$var$se.Depth24PlusStencil8) return Uint32Array;
        if (e === $d7238066c5de7f1c$var$se.Depth32FloatStencil8) return Float32Array;
    }
    /**
   * Returns the GPU dimensions for the given texture.
   *
   * @private
   * @param {Texture} texture - The texture.
   * @return {string} The GPU dimension.
   */ _getDimension(e) {
        let t;
        return e.is3DTexture || e.isData3DTexture ? t = $d7238066c5de7f1c$var$j9.ThreeD : t = $d7238066c5de7f1c$var$j9.TwoD, t;
    }
}
function $d7238066c5de7f1c$var$P2(r, e = null) {
    const t = r.format, i = r.type, n = r.colorSpace, s = $d7238066c5de7f1c$var$sn.getTransfer(n);
    let a;
    if (r.isCompressedTexture === !0 || r.isCompressedArrayTexture === !0) switch(t){
        case $d7238066c5de7f1c$var$Ky:
        case $d7238066c5de7f1c$var$xy:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.BC1RGBAUnormSRGB : $d7238066c5de7f1c$var$se.BC1RGBAUnorm;
            break;
        case $d7238066c5de7f1c$var$Fy:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.BC2RGBAUnormSRGB : $d7238066c5de7f1c$var$se.BC2RGBAUnorm;
            break;
        case $d7238066c5de7f1c$var$Ty:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.BC3RGBAUnormSRGB : $d7238066c5de7f1c$var$se.BC3RGBAUnorm;
            break;
        case $d7238066c5de7f1c$var$AZ:
            a = $d7238066c5de7f1c$var$se.BC4RUnorm;
            break;
        case $d7238066c5de7f1c$var$bZ:
            a = $d7238066c5de7f1c$var$se.BC4RSnorm;
            break;
        case $d7238066c5de7f1c$var$yZ:
            a = $d7238066c5de7f1c$var$se.BC5RGUnorm;
            break;
        case $d7238066c5de7f1c$var$BZ:
            a = $d7238066c5de7f1c$var$se.BC5RGSnorm;
            break;
        case $d7238066c5de7f1c$var$mZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.BC7RGBAUnormSRGB : $d7238066c5de7f1c$var$se.BC7RGBAUnorm;
            break;
        case $d7238066c5de7f1c$var$tZ:
        case $d7238066c5de7f1c$var$eZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ETC2RGB8UnormSRGB : $d7238066c5de7f1c$var$se.ETC2RGB8Unorm;
            break;
        case $d7238066c5de7f1c$var$iZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ETC2RGBA8UnormSRGB : $d7238066c5de7f1c$var$se.ETC2RGBA8Unorm;
            break;
        case $d7238066c5de7f1c$var$nZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC4x4UnormSRGB : $d7238066c5de7f1c$var$se.ASTC4x4Unorm;
            break;
        case $d7238066c5de7f1c$var$sZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC5x4UnormSRGB : $d7238066c5de7f1c$var$se.ASTC5x4Unorm;
            break;
        case $d7238066c5de7f1c$var$rZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC5x5UnormSRGB : $d7238066c5de7f1c$var$se.ASTC5x5Unorm;
            break;
        case $d7238066c5de7f1c$var$aZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC6x5UnormSRGB : $d7238066c5de7f1c$var$se.ASTC6x5Unorm;
            break;
        case $d7238066c5de7f1c$var$oZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC6x6UnormSRGB : $d7238066c5de7f1c$var$se.ASTC6x6Unorm;
            break;
        case $d7238066c5de7f1c$var$gZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC8x5UnormSRGB : $d7238066c5de7f1c$var$se.ASTC8x5Unorm;
            break;
        case $d7238066c5de7f1c$var$lZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC8x6UnormSRGB : $d7238066c5de7f1c$var$se.ASTC8x6Unorm;
            break;
        case $d7238066c5de7f1c$var$cZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC8x8UnormSRGB : $d7238066c5de7f1c$var$se.ASTC8x8Unorm;
            break;
        case $d7238066c5de7f1c$var$uZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC10x5UnormSRGB : $d7238066c5de7f1c$var$se.ASTC10x5Unorm;
            break;
        case $d7238066c5de7f1c$var$IZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC10x6UnormSRGB : $d7238066c5de7f1c$var$se.ASTC10x6Unorm;
            break;
        case $d7238066c5de7f1c$var$dZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC10x8UnormSRGB : $d7238066c5de7f1c$var$se.ASTC10x8Unorm;
            break;
        case $d7238066c5de7f1c$var$hZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC10x10UnormSRGB : $d7238066c5de7f1c$var$se.ASTC10x10Unorm;
            break;
        case $d7238066c5de7f1c$var$CZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC12x10UnormSRGB : $d7238066c5de7f1c$var$se.ASTC12x10Unorm;
            break;
        case $d7238066c5de7f1c$var$pZ:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.ASTC12x12UnormSRGB : $d7238066c5de7f1c$var$se.ASTC12x12Unorm;
            break;
        case $d7238066c5de7f1c$var$sg:
            a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.RGBA8UnormSRGB : $d7238066c5de7f1c$var$se.RGBA8Unorm;
            break;
        default:
            $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture format.", t);
    }
    else switch(t){
        case $d7238066c5de7f1c$var$sg:
            switch(i){
                case $d7238066c5de7f1c$var$fA:
                    a = $d7238066c5de7f1c$var$se.RGBA8Snorm;
                    break;
                case $d7238066c5de7f1c$var$GA:
                    a = $d7238066c5de7f1c$var$se.RGBA16Sint;
                    break;
                case $d7238066c5de7f1c$var$wC:
                    a = $d7238066c5de7f1c$var$se.RGBA16Uint;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.RGBA32Uint;
                    break;
                case $d7238066c5de7f1c$var$Na:
                    a = $d7238066c5de7f1c$var$se.RGBA32Sint;
                    break;
                case $d7238066c5de7f1c$var$Ya:
                    a = s === $d7238066c5de7f1c$var$Qt ? $d7238066c5de7f1c$var$se.RGBA8UnormSRGB : $d7238066c5de7f1c$var$se.RGBA8Unorm;
                    break;
                case $d7238066c5de7f1c$var$Ia:
                    a = $d7238066c5de7f1c$var$se.RGBA16Float;
                    break;
                case $d7238066c5de7f1c$var$vo:
                    a = $d7238066c5de7f1c$var$se.RGBA32Float;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RGBAFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$sR:
            switch(i){
                case $d7238066c5de7f1c$var$ON:
                    a = $d7238066c5de7f1c$var$se.RGB9E5UFloat;
                    break;
                case $d7238066c5de7f1c$var$jN:
                    a = $d7238066c5de7f1c$var$se.RG11B10UFloat;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RGBFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$rR:
            switch(i){
                case $d7238066c5de7f1c$var$fA:
                    a = $d7238066c5de7f1c$var$se.R8Snorm;
                    break;
                case $d7238066c5de7f1c$var$GA:
                    a = $d7238066c5de7f1c$var$se.R16Sint;
                    break;
                case $d7238066c5de7f1c$var$wC:
                    a = $d7238066c5de7f1c$var$se.R16Uint;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.R32Uint;
                    break;
                case $d7238066c5de7f1c$var$Na:
                    a = $d7238066c5de7f1c$var$se.R32Sint;
                    break;
                case $d7238066c5de7f1c$var$Ya:
                    a = $d7238066c5de7f1c$var$se.R8Unorm;
                    break;
                case $d7238066c5de7f1c$var$Ia:
                    a = $d7238066c5de7f1c$var$se.R16Float;
                    break;
                case $d7238066c5de7f1c$var$vo:
                    a = $d7238066c5de7f1c$var$se.R32Float;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RedFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$gI:
            switch(i){
                case $d7238066c5de7f1c$var$fA:
                    a = $d7238066c5de7f1c$var$se.RG8Snorm;
                    break;
                case $d7238066c5de7f1c$var$GA:
                    a = $d7238066c5de7f1c$var$se.RG16Sint;
                    break;
                case $d7238066c5de7f1c$var$wC:
                    a = $d7238066c5de7f1c$var$se.RG16Uint;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.RG32Uint;
                    break;
                case $d7238066c5de7f1c$var$Na:
                    a = $d7238066c5de7f1c$var$se.RG32Sint;
                    break;
                case $d7238066c5de7f1c$var$Ya:
                    a = $d7238066c5de7f1c$var$se.RG8Unorm;
                    break;
                case $d7238066c5de7f1c$var$Ia:
                    a = $d7238066c5de7f1c$var$se.RG16Float;
                    break;
                case $d7238066c5de7f1c$var$vo:
                    a = $d7238066c5de7f1c$var$se.RG32Float;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RGFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$nu:
            switch(i){
                case $d7238066c5de7f1c$var$wC:
                    a = $d7238066c5de7f1c$var$se.Depth16Unorm;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.Depth24Plus;
                    break;
                case $d7238066c5de7f1c$var$vo:
                    a = $d7238066c5de7f1c$var$se.Depth32Float;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with DepthFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$dI:
            switch(i){
                case $d7238066c5de7f1c$var$sh:
                    a = $d7238066c5de7f1c$var$se.Depth24PlusStencil8;
                    break;
                case $d7238066c5de7f1c$var$vo:
                    e && e.features.has($d7238066c5de7f1c$var$_2.Depth32FloatStencil8) === !1 && $d7238066c5de7f1c$var$nt('WebGPURenderer: Depth textures with DepthStencilFormat + FloatType can only be used with the "depth32float-stencil8" GPU feature.'), a = $d7238066c5de7f1c$var$se.Depth32FloatStencil8;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with DepthStencilFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$aR:
            switch(i){
                case $d7238066c5de7f1c$var$Na:
                    a = $d7238066c5de7f1c$var$se.R32Sint;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.R32Uint;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RedIntegerFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$oR:
            switch(i){
                case $d7238066c5de7f1c$var$Na:
                    a = $d7238066c5de7f1c$var$se.RG32Sint;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.RG32Uint;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RGIntegerFormat.", i);
            }
            break;
        case $d7238066c5de7f1c$var$gR:
            switch(i){
                case $d7238066c5de7f1c$var$Na:
                    a = $d7238066c5de7f1c$var$se.RGBA32Sint;
                    break;
                case $d7238066c5de7f1c$var$Xs:
                    a = $d7238066c5de7f1c$var$se.RGBA32Uint;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture type with RGBAIntegerFormat.", i);
            }
            break;
        default:
            $d7238066c5de7f1c$var$nt("WebGPURenderer: Unsupported texture format.", t);
    }
    return a;
}
const $d7238066c5de7f1c$var$Sue = /^[fn]*\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)\s*[\-\>]*\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/i, $d7238066c5de7f1c$var$Zue = /([a-z_0-9]+)\s*:\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/ig, $d7238066c5de7f1c$var$$9 = {
    f32: "float",
    i32: "int",
    u32: "uint",
    bool: "bool",
    "vec2<f32>": "vec2",
    "vec2<i32>": "ivec2",
    "vec2<u32>": "uvec2",
    "vec2<bool>": "bvec2",
    vec2f: "vec2",
    vec2i: "ivec2",
    vec2u: "uvec2",
    vec2b: "bvec2",
    "vec3<f32>": "vec3",
    "vec3<i32>": "ivec3",
    "vec3<u32>": "uvec3",
    "vec3<bool>": "bvec3",
    vec3f: "vec3",
    vec3i: "ivec3",
    vec3u: "uvec3",
    vec3b: "bvec3",
    "vec4<f32>": "vec4",
    "vec4<i32>": "ivec4",
    "vec4<u32>": "uvec4",
    "vec4<bool>": "bvec4",
    vec4f: "vec4",
    vec4i: "ivec4",
    vec4u: "uvec4",
    vec4b: "bvec4",
    "mat2x2<f32>": "mat2",
    mat2x2f: "mat2",
    "mat3x3<f32>": "mat3",
    mat3x3f: "mat3",
    "mat4x4<f32>": "mat4",
    mat4x4f: "mat4",
    sampler: "sampler",
    texture_1d: "texture",
    texture_2d: "texture",
    texture_2d_array: "texture",
    texture_multisampled_2d: "cubeTexture",
    texture_depth_2d: "depthTexture",
    texture_depth_2d_array: "depthTexture",
    texture_depth_multisampled_2d: "depthTexture",
    texture_depth_cube: "depthTexture",
    texture_depth_cube_array: "depthTexture",
    texture_3d: "texture3D",
    texture_cube: "cubeTexture",
    texture_cube_array: "cubeTexture",
    texture_storage_1d: "storageTexture",
    texture_storage_2d: "storageTexture",
    texture_storage_2d_array: "storageTexture",
    texture_storage_3d: "storageTexture"
}, $d7238066c5de7f1c$var$Rue = (r)=>{
    r = r.trim();
    const e = r.match($d7238066c5de7f1c$var$Sue);
    if (e !== null && e.length === 4) {
        const t = e[2], i = [];
        let n = null;
        for(; (n = $d7238066c5de7f1c$var$Zue.exec(t)) !== null;)i.push({
            name: n[1],
            type: n[2]
        });
        const s = [];
        for(let c = 0; c < i.length; c++){
            const { name: d, type: p } = i[c];
            let A = p;
            A.startsWith("ptr") ? A = "pointer" : (A.startsWith("texture") && (A = p.split("<")[0]), A = $d7238066c5de7f1c$var$$9[A]), s.push(new $d7238066c5de7f1c$var$KY(A, d));
        }
        const a = r.substring(e[0].length), o = e[3] || "void", g = e[1] !== void 0 ? e[1] : "";
        return {
            type: $d7238066c5de7f1c$var$$9[o] || o,
            inputs: s,
            name: g,
            inputsCode: t,
            blockCode: a,
            outputType: o
        };
    } else throw new Error("FunctionNode: Function is not a WGSL code.");
};
class $d7238066c5de7f1c$var$Vue extends $d7238066c5de7f1c$var$FY {
    /**
   * Constructs a new WGSL node function.
   *
   * @param {string} source - The WGSL source.
   */ constructor(e){
        const { type: t, inputs: i, name: n, inputsCode: s, blockCode: a, outputType: o } = $d7238066c5de7f1c$var$Rue(e);
        super(t, i, n), this.inputsCode = s, this.blockCode = a, this.outputType = o;
    }
    /**
   * This method returns the WGSL code of the node function.
   *
   * @param {string} [name=this.name] - The function's name.
   * @return {string} The shader code.
   */ getCode(e = this.name) {
        const t = this.outputType !== "void" ? "-> " + this.outputType : "";
        return `fn ${e} ( ${this.inputsCode.trim()} ) ${t}` + this.blockCode;
    }
}
class $d7238066c5de7f1c$var$wue extends $d7238066c5de7f1c$var$DD {
    /**
   * The method parses the given WGSL code an returns a node function.
   *
   * @param {string} source - The WGSL code.
   * @return {WGSLNodeFunction} A node function.
   */ parseFunction(e) {
        return new $d7238066c5de7f1c$var$Vue(e);
    }
}
const $d7238066c5de7f1c$var$Um = typeof self < "u" ? self.GPUShaderStage : {
    VERTEX: 1,
    FRAGMENT: 2,
    COMPUTE: 4
}, $d7238066c5de7f1c$var$Wue = {
    [$d7238066c5de7f1c$var$da.READ_ONLY]: "read",
    [$d7238066c5de7f1c$var$da.WRITE_ONLY]: "write",
    [$d7238066c5de7f1c$var$da.READ_WRITE]: "read_write"
}, $d7238066c5de7f1c$var$eT = {
    [$d7238066c5de7f1c$var$FA]: "repeat",
    [$d7238066c5de7f1c$var$qc]: "clamp",
    [$d7238066c5de7f1c$var$TA]: "mirror"
}, $d7238066c5de7f1c$var$jv = {
    vertex: $d7238066c5de7f1c$var$Um ? $d7238066c5de7f1c$var$Um.VERTEX : 1,
    fragment: $d7238066c5de7f1c$var$Um ? $d7238066c5de7f1c$var$Um.FRAGMENT : 2,
    compute: $d7238066c5de7f1c$var$Um ? $d7238066c5de7f1c$var$Um.COMPUTE : 4
}, $d7238066c5de7f1c$var$tT = {
    instance: !0,
    swizzleAssign: !1,
    storageBuffer: !0
}, $d7238066c5de7f1c$var$Hue = {
    "^^": "tsl_xor"
}, $d7238066c5de7f1c$var$Xue = {
    float: "f32",
    int: "i32",
    uint: "u32",
    bool: "bool",
    color: "vec3<f32>",
    vec2: "vec2<f32>",
    ivec2: "vec2<i32>",
    uvec2: "vec2<u32>",
    bvec2: "vec2<bool>",
    vec3: "vec3<f32>",
    ivec3: "vec3<i32>",
    uvec3: "vec3<u32>",
    bvec3: "vec3<bool>",
    vec4: "vec4<f32>",
    ivec4: "vec4<i32>",
    uvec4: "vec4<u32>",
    bvec4: "vec4<bool>",
    mat2: "mat2x2<f32>",
    mat3: "mat3x3<f32>",
    mat4: "mat4x4<f32>"
}, $d7238066c5de7f1c$var$iT = {}, $d7238066c5de7f1c$var$Ob = {
    tsl_xor: new $d7238066c5de7f1c$var$Fr("fn tsl_xor( a : bool, b : bool ) -> bool { return ( a || b ) && !( a && b ); }"),
    mod_float: new $d7238066c5de7f1c$var$Fr("fn tsl_mod_float( x : f32, y : f32 ) -> f32 { return x - y * floor( x / y ); }"),
    mod_vec2: new $d7238066c5de7f1c$var$Fr("fn tsl_mod_vec2( x : vec2f, y : vec2f ) -> vec2f { return x - y * floor( x / y ); }"),
    mod_vec3: new $d7238066c5de7f1c$var$Fr("fn tsl_mod_vec3( x : vec3f, y : vec3f ) -> vec3f { return x - y * floor( x / y ); }"),
    mod_vec4: new $d7238066c5de7f1c$var$Fr("fn tsl_mod_vec4( x : vec4f, y : vec4f ) -> vec4f { return x - y * floor( x / y ); }"),
    equals_bool: new $d7238066c5de7f1c$var$Fr("fn tsl_equals_bool( a : bool, b : bool ) -> bool { return a == b; }"),
    equals_bvec2: new $d7238066c5de7f1c$var$Fr("fn tsl_equals_bvec2( a : vec2f, b : vec2f ) -> vec2<bool> { return vec2<bool>( a.x == b.x, a.y == b.y ); }"),
    equals_bvec3: new $d7238066c5de7f1c$var$Fr("fn tsl_equals_bvec3( a : vec3f, b : vec3f ) -> vec3<bool> { return vec3<bool>( a.x == b.x, a.y == b.y, a.z == b.z ); }"),
    equals_bvec4: new $d7238066c5de7f1c$var$Fr("fn tsl_equals_bvec4( a : vec4f, b : vec4f ) -> vec4<bool> { return vec4<bool>( a.x == b.x, a.y == b.y, a.z == b.z, a.w == b.w ); }"),
    repeatWrapping_float: new $d7238066c5de7f1c$var$Fr("fn tsl_repeatWrapping_float( coord: f32 ) -> f32 { return fract( coord ); }"),
    mirrorWrapping_float: new $d7238066c5de7f1c$var$Fr("fn tsl_mirrorWrapping_float( coord: f32 ) -> f32 { let mirrored = fract( coord * 0.5 ) * 2.0; return 1.0 - abs( 1.0 - mirrored ); }"),
    clampWrapping_float: new $d7238066c5de7f1c$var$Fr("fn tsl_clampWrapping_float( coord: f32 ) -> f32 { return clamp( coord, 0.0, 1.0 ); }"),
    biquadraticTexture: new $d7238066c5de7f1c$var$Fr(/* wgsl */ `
fn tsl_biquadraticTexture( map : texture_2d<f32>, coord : vec2f, iRes : vec2u, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`)
}, $d7238066c5de7f1c$var$Nue = {
    dFdx: "dpdx",
    dFdy: "- dpdy",
    mod_float: "tsl_mod_float",
    mod_vec2: "tsl_mod_vec2",
    mod_vec3: "tsl_mod_vec3",
    mod_vec4: "tsl_mod_vec4",
    equals_bool: "tsl_equals_bool",
    equals_bvec2: "tsl_equals_bvec2",
    equals_bvec3: "tsl_equals_bvec3",
    equals_bvec4: "tsl_equals_bvec4",
    inversesqrt: "inverseSqrt",
    bitcast: "bitcast<f32>"
};
let $d7238066c5de7f1c$var$n_ = "";
(typeof navigator < "u" && /Firefox|Deno/g.test(navigator.userAgent)) !== !0 && ($d7238066c5de7f1c$var$n_ += `diagnostic( off, derivative_uniformity );
`);
class $d7238066c5de7f1c$var$Lue extends $d7238066c5de7f1c$var$UD {
    /**
   * Constructs a new WGSL node builder renderer.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Renderer} renderer - The renderer.
   */ constructor(e, t){
        super(e, t, new $d7238066c5de7f1c$var$wue()), this.uniformGroups = {}, this.builtins = {}, this.directives = {}, this.scopedArrays = /* @__PURE__ */ new Map();
    }
    /**
   * Generates the WGSL snippet for sampled textures.
   *
   * @private
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The WGSL snippet.
   */ _generateTextureSample(e, t, i, n, s, a = this.shaderStage) {
        return a === "fragment" ? n ? s ? `textureSample( ${t}, ${t}_sampler, ${i}, ${n}, ${s} )` : `textureSample( ${t}, ${t}_sampler, ${i}, ${n} )` : s ? `textureSample( ${t}, ${t}_sampler, ${i}, ${s} )` : `textureSample( ${t}, ${t}_sampler, ${i} )` : this.generateTextureSampleLevel(e, t, i, "0", n);
    }
    /**
   * Generates the WGSL snippet when sampling textures with explicit mip level.
   *
   * @private
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @param {string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The WGSL snippet.
   */ generateTextureSampleLevel(e, t, i, n, s, a) {
        return this.isUnfilterable(e) === !1 ? a ? `textureSampleLevel( ${t}, ${t}_sampler, ${i}, ${n}, ${a} )` : `textureSampleLevel( ${t}, ${t}_sampler, ${i}, ${n} )` : this.isFilteredTexture(e) ? this.generateFilteredTexture(e, t, i, a, n) : this.generateTextureLod(e, t, i, s, a, n);
    }
    /**
   * Generates a wrap function used in context of textures.
   *
   * @param {Texture} texture - The texture to generate the function for.
   * @return {string} The name of the generated function.
   */ generateWrapFunction(e) {
        const t = `tsl_coord_${$d7238066c5de7f1c$var$eT[e.wrapS]}S_${$d7238066c5de7f1c$var$eT[e.wrapT]}_${e.isData3DTexture ? "3d" : "2d"}T`;
        let i = $d7238066c5de7f1c$var$iT[t];
        if (i === void 0) {
            const n = [], s = e.isData3DTexture ? "vec3f" : "vec2f";
            let a = `fn ${t}( coord : ${s} ) -> ${s} {

	return ${s}(
`;
            const o = (g, l)=>{
                g === $d7238066c5de7f1c$var$FA ? (n.push($d7238066c5de7f1c$var$Ob.repeatWrapping_float), a += `		tsl_repeatWrapping_float( coord.${l} )`) : g === $d7238066c5de7f1c$var$qc ? (n.push($d7238066c5de7f1c$var$Ob.clampWrapping_float), a += `		tsl_clampWrapping_float( coord.${l} )`) : g === $d7238066c5de7f1c$var$TA ? (n.push($d7238066c5de7f1c$var$Ob.mirrorWrapping_float), a += `		tsl_mirrorWrapping_float( coord.${l} )`) : (a += `		coord.${l}`, $d7238066c5de7f1c$var$ze(`WebGPURenderer: Unsupported texture wrap type "${g}" for vertex shader.`));
            };
            o(e.wrapS, "x"), a += `,
`, o(e.wrapT, "y"), e.isData3DTexture && (a += `,
`, o(e.wrapR, "z")), a += `
	);

}
`, $d7238066c5de7f1c$var$iT[t] = i = new $d7238066c5de7f1c$var$Fr(a, n);
        }
        return i.build(this), t;
    }
    /**
   * Generates the array declaration string.
   *
   * @param {string} type - The type.
   * @param {?number} [count] - The count.
   * @return {string} The generated value as a shader string.
   */ generateArrayDeclaration(e, t) {
        return `array< ${this.getType(e)}, ${t} >`;
    }
    /**
   * Generates a WGSL variable that holds the texture dimension of the given texture.
   * It also returns information about the number of layers (elements) of an arrayed
   * texture as well as the cube face count of cube textures.
   *
   * @param {Texture} texture - The texture to generate the function for.
   * @param {string} textureProperty - The name of the video texture uniform in the shader.
   * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @return {string} The name of the dimension variable.
   */ generateTextureDimension(e, t, i) {
        const n = this.getDataFromNode(e, this.shaderStage, this.globalCache);
        n.dimensionsSnippet === void 0 && (n.dimensionsSnippet = {});
        let s = n.dimensionsSnippet[i];
        if (n.dimensionsSnippet[i] === void 0) {
            let a, o;
            const { primarySamples: g } = this.renderer.backend.utils.getTextureSampleData(e), l = g > 1;
            e.isData3DTexture ? o = "vec3<u32>" : o = "vec2<u32>", l || e.isStorageTexture ? a = t : a = `${t}${i ? `, u32( ${i} )` : ""}`, s = new $d7238066c5de7f1c$var$RS(new $d7238066c5de7f1c$var$VS(`textureDimensions( ${a} )`, o)), n.dimensionsSnippet[i] = s, (e.isArrayTexture || e.isDataArrayTexture || e.isData3DTexture) && (n.arrayLayerCount = new $d7238066c5de7f1c$var$RS(new $d7238066c5de7f1c$var$VS(`textureNumLayers(${t})`, "u32"))), e.isTextureCube && (n.cubeFaceCount = new $d7238066c5de7f1c$var$RS(new $d7238066c5de7f1c$var$VS("6u", "u32")));
        }
        return s.build(this);
    }
    /**
   * Generates the WGSL snippet for a manual filtered texture.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [levelSnippet='0u'] - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @return {string} The WGSL snippet.
   */ generateFilteredTexture(e, t, i, n, s = "0u") {
        this._include("biquadraticTexture");
        const a = this.generateWrapFunction(e), o = this.generateTextureDimension(e, t, s);
        return n && (i = `${i} + vec2<f32>(${n}) / ${o}`), `tsl_biquadraticTexture( ${t}, ${a}( ${i} ), ${o}, u32( ${s} ) )`;
    }
    /**
   * Generates the WGSL snippet for a texture lookup with explicit level-of-detail.
   * Since it's a lookup, no sampling or filtering is applied.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [levelSnippet='0u'] - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @return {string} The WGSL snippet.
   */ generateTextureLod(e, t, i, n, s, a = "0u") {
        const o = this.generateWrapFunction(e), g = this.generateTextureDimension(e, t, a), l = e.isData3DTexture ? "vec3" : "vec2";
        s && (i = `${i} + ${l}<f32>(${s}) / ${l}<f32>( ${g} )`);
        const c = `${l}<u32>( ${o}( ${i} ) * ${l}<f32>( ${g} ) )`;
        return this.generateTextureLoad(e, t, c, a, n, null);
    }
    /**
   * Generates the WGSL snippet that reads a single texel from a texture without sampling or filtering.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {?string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @return {string} The WGSL snippet.
   */ generateTextureLoad(e, t, i, n, s, a) {
        n === null && (n = "0u"), a && (i = `${i} + ${a}`);
        let o;
        return s ? o = `textureLoad( ${t}, ${i}, ${s}, u32( ${n} ) )` : (o = `textureLoad( ${t}, ${i}, u32( ${n} ) )`, this.renderer.backend.compatibilityMode && e.isDepthTexture && (o += ".x")), o;
    }
    /**
   * Generates the WGSL snippet that writes a single texel to a texture.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {string} valueSnippet - A WGSL snippet that represent the new texel value.
   * @return {string} The WGSL snippet.
   */ generateTextureStore(e, t, i, n, s) {
        let a;
        return n ? a = `textureStore( ${t}, ${i}, ${n}, ${s} )` : a = `textureStore( ${t}, ${i}, ${s} )`, a;
    }
    /**
   * Returns `true` if the sampled values of the given texture should be compared against a reference value.
   *
   * @param {Texture} texture - The texture.
   * @return {boolean} Whether the sampled values of the given texture should be compared against a reference value or not.
   */ isSampleCompare(e) {
        return e.isDepthTexture === !0 && e.compareFunction !== null;
    }
    /**
   * Returns `true` if the given texture is unfilterable.
   *
   * @param {Texture} texture - The texture.
   * @return {boolean} Whether the given texture is unfilterable or not.
   */ isUnfilterable(e) {
        return this.getComponentTypeFromTexture(e) !== "float" || !this.isAvailable("float32Filterable") && e.isDataTexture === !0 && e.type === $d7238066c5de7f1c$var$vo || this.isSampleCompare(e) === !1 && e.minFilter === $d7238066c5de7f1c$var$Sr && e.magFilter === $d7238066c5de7f1c$var$Sr || this.renderer.backend.utils.getTextureSampleData(e).primarySamples > 1;
    }
    /**
   * Generates the WGSL snippet for sampling/loading the given texture.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The WGSL snippet.
   */ generateTexture(e, t, i, n, s, a = this.shaderStage) {
        let o = null;
        return this.isUnfilterable(e) ? o = this.generateTextureLod(e, t, i, n, s, "0", a) : o = this._generateTextureSample(e, t, i, n, s, a), o;
    }
    /**
   * Generates the WGSL snippet for sampling/loading the given texture using explicit gradients.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {Array<string>} gradSnippet - An array holding both gradient WGSL snippets.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The WGSL snippet.
   */ generateTextureGrad(e, t, i, n, s, a, o = this.shaderStage) {
        if (o === "fragment") return a ? `textureSampleGrad( ${t}, ${t}_sampler, ${i},  ${n[0]}, ${n[1]}, ${a} )` : `textureSampleGrad( ${t}, ${t}_sampler, ${i},  ${n[0]}, ${n[1]} )`;
        $d7238066c5de7f1c$var$nt(`WebGPURenderer: THREE.TextureNode.gradient() does not support ${o} shader.`);
    }
    /**
   * Generates the WGSL snippet for sampling a depth texture and comparing the sampled depth values
   * against a reference value.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {string} compareSnippet -  A WGSL snippet that represents the reference value.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The WGSL snippet.
   */ generateTextureCompare(e, t, i, n, s, a, o = this.shaderStage) {
        if (o === "fragment") return e.isDepthTexture === !0 && e.isArrayTexture === !0 ? a ? `textureSampleCompare( ${t}, ${t}_sampler, ${i}, ${s}, ${n}, ${a} )` : `textureSampleCompare( ${t}, ${t}_sampler, ${i}, ${s}, ${n} )` : a ? `textureSampleCompare( ${t}, ${t}_sampler, ${i}, ${n}, ${a} )` : `textureSampleCompare( ${t}, ${t}_sampler, ${i}, ${n} )`;
        $d7238066c5de7f1c$var$nt(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${o} shader.`);
    }
    /**
   * Generates the WGSL snippet when sampling textures with explicit mip level.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The WGSL snippet.
   */ generateTextureLevel(e, t, i, n, s, a) {
        return this.isUnfilterable(e) === !1 ? a ? `textureSampleLevel( ${t}, ${t}_sampler, ${i}, ${n}, ${a} )` : `textureSampleLevel( ${t}, ${t}_sampler, ${i}, ${n} )` : this.isFilteredTexture(e) ? this.generateFilteredTexture(e, t, i, a, n) : this.generateTextureLod(e, t, i, s, a, n);
    }
    /**
   * Generates the WGSL snippet when sampling textures with a bias to the mip level.
   *
   * @param {Texture} texture - The texture.
   * @param {string} textureProperty - The name of the texture uniform in the shader.
   * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
   * @param {string} biasSnippet - A WGSL snippet that represents the bias to apply to the mip level before sampling.
   * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
   * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The WGSL snippet.
   */ generateTextureBias(e, t, i, n, s, a, o = this.shaderStage) {
        if (o === "fragment") return a ? `textureSampleBias( ${t}, ${t}_sampler, ${i}, ${n}, ${a} )` : `textureSampleBias( ${t}, ${t}_sampler, ${i}, ${n} )`;
        $d7238066c5de7f1c$var$nt(`WebGPURenderer: THREE.TextureNode.biasNode does not support ${o} shader.`);
    }
    /**
   * Returns a WGSL snippet that represents the property name of the given node.
   *
   * @param {Node} node - The node.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The property name.
   */ getPropertyName(e, t = this.shaderStage) {
        if (e.isNodeVarying === !0 && e.needsInterpolation === !0) {
            if (t === "vertex") return `varyings.${e.name}`;
        } else if (e.isNodeUniform === !0) {
            const i = e.name, n = e.type;
            return n === "texture" || n === "cubeTexture" || n === "storageTexture" || n === "texture3D" ? i : n === "buffer" || n === "storageBuffer" || n === "indirectStorageBuffer" ? this.isCustomStruct(e) ? i : i + ".value" : e.groupNode.name + "." + i;
        }
        return super.getPropertyName(e);
    }
    /**
   * Returns the output struct name.
   *
   * @return {string} The name of the output struct.
   */ getOutputStructName() {
        return "output";
    }
    /**
   * Returns the native shader operator name for a given generic name.
   *
   * @param {string} op - The operator name to resolve.
   * @return {?string} The resolved operator name.
   */ getFunctionOperator(e) {
        const t = $d7238066c5de7f1c$var$Hue[e];
        return t !== void 0 ? (this._include(t), t) : null;
    }
    /**
   * Returns the node access for the given node and shader stage.
   *
   * @param {StorageTextureNode|StorageBufferNode} node - The storage node.
   * @param {string} shaderStage - The shader stage.
   * @return {string} The node access.
   */ getNodeAccess(e, t) {
        return t !== "compute" ? e.isAtomic === !0 ? ($d7238066c5de7f1c$var$ze("WebGPURenderer: Atomic operations are only supported in compute shaders."), $d7238066c5de7f1c$var$da.READ_WRITE) : $d7238066c5de7f1c$var$da.READ_ONLY : e.access;
    }
    /**
   * Returns A WGSL snippet representing the storage access.
   *
   * @param {StorageTextureNode|StorageBufferNode} node - The storage node.
   * @param {string} shaderStage - The shader stage.
   * @return {string} The WGSL snippet representing the storage access.
   */ getStorageAccess(e, t) {
        return $d7238066c5de7f1c$var$Wue[this.getNodeAccess(e, t)];
    }
    /**
   * This method is one of the more important ones since it's responsible
   * for generating a matching binding instance for the given uniform node.
   *
   * These bindings are later used in the renderer to create bind groups
   * and layouts.
   *
   * @param {UniformNode} node - The uniform node.
   * @param {string} type - The node data type.
   * @param {string} shaderStage - The shader stage.
   * @param {?string} [name=null] - An optional uniform name.
   * @return {NodeUniform} The node uniform object.
   */ getUniformFromNode(e, t, i, n = null) {
        const s = super.getUniformFromNode(e, t, i, n), a = this.getDataFromNode(e, i, this.globalCache);
        if (a.uniformGPU === void 0) {
            let o;
            const g = e.groupNode, l = g.name, c = this.getBindGroupArray(l, i);
            if (t === "texture" || t === "cubeTexture" || t === "storageTexture" || t === "texture3D") {
                let d = null;
                const p = this.getNodeAccess(e, i);
                if (t === "texture" || t === "storageTexture" ? e.value.is3DTexture === !0 ? d = new $d7238066c5de7f1c$var$D2(s.name, s.node, g, p) : d = new $d7238066c5de7f1c$var$kR(s.name, s.node, g, p) : t === "cubeTexture" ? d = new $d7238066c5de7f1c$var$e_(s.name, s.node, g, p) : t === "texture3D" && (d = new $d7238066c5de7f1c$var$D2(s.name, s.node, g, p)), d.store = e.isStorageTextureNode === !0, d.mipLevel = d.store ? e.mipLevel : 0, d.setVisibility($d7238066c5de7f1c$var$jv[i]), this.isUnfilterable(e.value) === !1 && d.store === !1) {
                    const A = new $d7238066c5de7f1c$var$mue(`${s.name}_sampler`, s.node, g);
                    A.setVisibility($d7238066c5de7f1c$var$jv[i]), c.push(A, d), o = [
                        A,
                        d
                    ];
                } else c.push(d), o = [
                    d
                ];
            } else if (t === "buffer" || t === "storageBuffer" || t === "indirectStorageBuffer") {
                const d = t === "buffer" ? $d7238066c5de7f1c$var$jD : $d7238066c5de7f1c$var$yue, p = new d(e, g);
                p.setVisibility($d7238066c5de7f1c$var$jv[i]), c.push(p), o = p, s.name = n || "NodeBuffer_" + s.id;
            } else {
                const d = this.uniformGroups[i] || (this.uniformGroups[i] = {});
                let p = d[l];
                p === void 0 && (p = new $d7238066c5de7f1c$var$qD(l, g), p.setVisibility($d7238066c5de7f1c$var$jv[i]), d[l] = p, c.push(p)), o = this.getNodeUniform(s, t), p.addUniform(o);
            }
            a.uniformGPU = o;
        }
        return s;
    }
    /**
   * This method should be used whenever builtins are required in nodes.
   * The internal builtins data structure will make sure builtins are
   * defined in the WGSL source.
   *
   * @param {string} name - The builtin name.
   * @param {string} property - The property name.
   * @param {string} type - The node data type.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {string} The property name.
   */ getBuiltin(e, t, i, n = this.shaderStage) {
        const s = this.builtins[n] || (this.builtins[n] = /* @__PURE__ */ new Map());
        return s.has(e) === !1 && s.set(e, {
            name: e,
            property: t,
            type: i
        }), t;
    }
    /**
   * Returns `true` if the given builtin is defined in the given shader stage.
   *
   * @param {string} name - The builtin name.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
   * @return {boolean} Whether the given builtin is defined in the given shader stage or not.
   */ hasBuiltin(e, t = this.shaderStage) {
        return this.builtins[t] !== void 0 && this.builtins[t].has(e);
    }
    /**
   * Returns the vertex index builtin.
   *
   * @return {string} The vertex index.
   */ getVertexIndex() {
        return this.shaderStage === "vertex" ? this.getBuiltin("vertex_index", "vertexIndex", "u32", "attribute") : "vertexIndex";
    }
    /**
   * Builds the given shader node.
   *
   * @param {ShaderNodeInternal} shaderNode - The shader node.
   * @return {string} The WGSL function code.
   */ buildFunctionCode(e) {
        const t = e.layout, i = this.flowShaderNode(e), n = [];
        for (const a of t.inputs)n.push(a.name + " : " + this.getType(a.type));
        let s = `fn ${t.name}( ${n.join(", ")} ) -> ${this.getType(t.type)} {
${i.vars}
${i.code}
`;
        return i.result && (s += `	return ${i.result};
`), s += `
}
`, s;
    }
    /**
   * Contextually returns either the vertex stage instance index builtin
   * or the linearized index of an compute invocation within a grid of workgroups.
   *
   * @return {string} The instance index.
   */ getInstanceIndex() {
        return this.shaderStage === "vertex" ? this.getBuiltin("instance_index", "instanceIndex", "u32", "attribute") : "instanceIndex";
    }
    /**
   * Returns a builtin representing the index of a compute invocation within the scope of a workgroup load.
   *
   * @return {string} The invocation local index.
   */ getInvocationLocalIndex() {
        return this.getBuiltin("local_invocation_index", "invocationLocalIndex", "u32", "attribute");
    }
    /**
   * Returns a builtin representing the size of a subgroup within the current shader.
   *
   * @return {string} The subgroup size.
   */ getSubgroupSize() {
        return this.enableSubGroups(), this.getBuiltin("subgroup_size", "subgroupSize", "u32", "attribute");
    }
    /**
   * Returns a builtin representing the index of a compute invocation within the scope of a subgroup.
   *
   * @return {string} The invocation subgroup index.
   */ getInvocationSubgroupIndex() {
        return this.enableSubGroups(), this.getBuiltin("subgroup_invocation_id", "invocationSubgroupIndex", "u32", "attribute");
    }
    /**
   * Returns a builtin representing the index of a compute invocation's subgroup within its workgroup.
   *
   * @return {string} The subgroup index.
   */ getSubgroupIndex() {
        return this.enableSubGroups(), this.getBuiltin("subgroup_id", "subgroupIndex", "u32", "attribute");
    }
    /**
   * Overwritten as a NOP since this method is intended for the WebGL 2 backend.
   *
   * @return {null} Null.
   */ getDrawIndex() {
        return null;
    }
    /**
   * Returns the front facing builtin.
   *
   * @return {string} The front facing builtin.
   */ getFrontFacing() {
        return this.getBuiltin("front_facing", "isFront", "bool");
    }
    /**
   * Returns the frag coord builtin.
   *
   * @return {string} The frag coord builtin.
   */ getFragCoord() {
        return this.getBuiltin("position", "fragCoord", "vec4<f32>") + ".xy";
    }
    /**
   * Returns the frag depth builtin.
   *
   * @return {string} The frag depth builtin.
   */ getFragDepth() {
        return "output." + this.getBuiltin("frag_depth", "depth", "f32", "output");
    }
    /**
   * Returns the clip distances builtin.
   *
   * @return {string} The clip distances builtin.
   */ getClipDistance() {
        return "varyings.hw_clip_distances";
    }
    /**
   * Whether to flip texture data along its vertical axis or not.
   *
   * @return {boolean} Returns always `false` in context of WGSL.
   */ isFlipY() {
        return !1;
    }
    /**
   * Enables the given directive for the given shader stage.
   *
   * @param {string} name - The directive name.
   * @param {string} [shaderStage=this.shaderStage] - The shader stage to enable the directive for.
   */ enableDirective(e, t = this.shaderStage) {
        (this.directives[t] || (this.directives[t] = /* @__PURE__ */ new Set())).add(e);
    }
    /**
   * Returns the directives of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} A WGSL snippet that enables the directives of the given stage.
   */ getDirectives(e) {
        const t = [], i = this.directives[e];
        if (i !== void 0) for (const n of i)t.push(`enable ${n};`);
        return t.join(`
`);
    }
    /**
   * Enables the 'subgroups' directive.
   */ enableSubGroups() {
        this.enableDirective("subgroups");
    }
    /**
   * Enables the 'subgroups-f16' directive.
   */ enableSubgroupsF16() {
        this.enableDirective("subgroups-f16");
    }
    /**
   * Enables the 'clip_distances' directive.
   */ enableClipDistances() {
        this.enableDirective("clip_distances");
    }
    /**
   * Enables the 'f16' directive.
   */ enableShaderF16() {
        this.enableDirective("f16");
    }
    /**
   * Enables the 'dual_source_blending' directive.
   */ enableDualSourceBlending() {
        this.enableDirective("dual_source_blending");
    }
    /**
   * Enables hardware clipping.
   *
   * @param {string} planeCount - The clipping plane count.
   */ enableHardwareClipping(e) {
        this.enableClipDistances(), this.getBuiltin("clip_distances", "hw_clip_distances", `array<f32, ${e} >`, "vertex");
    }
    /**
   * Returns the builtins of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} A WGSL snippet that represents the builtins of the given stage.
   */ getBuiltins(e) {
        const t = [], i = this.builtins[e];
        if (i !== void 0) for (const { name: n, property: s, type: a } of i.values())t.push(`@builtin( ${n} ) ${s} : ${a}`);
        return t.join(`,
	`);
    }
    /**
   * This method should be used when a new scoped buffer is used in context of
   * compute shaders. It adds the array to the internal data structure which is
   * later used to generate the respective WGSL.
   *
   * @param {string} name - The array name.
   * @param {string} scope - The scope.
   * @param {string} bufferType - The buffer type.
   * @param {string} bufferCount - The buffer count.
   * @return {string} The array name.
   */ getScopedArray(e, t, i, n) {
        return this.scopedArrays.has(e) === !1 && this.scopedArrays.set(e, {
            name: e,
            scope: t,
            bufferType: i,
            bufferCount: n
        }), e;
    }
    /**
   * Returns the scoped arrays of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string|undefined} The WGSL snippet that defines the scoped arrays.
   * Returns `undefined` when used in the vertex or fragment stage.
   */ getScopedArrays(e) {
        if (e !== "compute") return;
        const t = [];
        for (const { name: i, scope: n, bufferType: s, bufferCount: a } of this.scopedArrays.values()){
            const o = this.getType(s);
            t.push(`var<${n}> ${i}: array< ${o}, ${a} >;`);
        }
        return t.join(`
`);
    }
    /**
   * Returns the shader attributes of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The WGSL snippet that defines the shader attributes.
   */ getAttributes(e) {
        const t = [];
        if (e === "compute" && (this.getBuiltin("global_invocation_id", "globalId", "vec3<u32>", "attribute"), this.getBuiltin("workgroup_id", "workgroupId", "vec3<u32>", "attribute"), this.getBuiltin("local_invocation_id", "localId", "vec3<u32>", "attribute"), this.getBuiltin("num_workgroups", "numWorkgroups", "vec3<u32>", "attribute"), this.renderer.hasFeature("subgroups") && (this.enableDirective("subgroups", e), this.getBuiltin("subgroup_size", "subgroupSize", "u32", "attribute"))), e === "vertex" || e === "compute") {
            const i = this.getBuiltins("attribute");
            i && t.push(i);
            const n = this.getAttributesArray();
            for(let s = 0, a = n.length; s < a; s++){
                const o = n[s], g = o.name, l = this.getType(o.type);
                t.push(`@location( ${s} ) ${g} : ${l}`);
            }
        }
        return t.join(`,
	`);
    }
    /**
   * Returns the members of the given struct type node as a WGSL string.
   *
   * @param {StructTypeNode} struct - The struct type node.
   * @return {string} The WGSL snippet that defines the struct members.
   */ getStructMembers(e) {
        const t = [];
        for (const i of e.members){
            const n = e.output ? "@location( " + i.index + " ) " : "";
            let s = this.getType(i.type);
            i.atomic && (s = "atomic< " + s + " >"), t.push(`	${n + i.name} : ${s}`);
        }
        return e.output && t.push(`	${this.getBuiltins("output")}`), t.join(`,
`);
    }
    /**
   * Returns the structs of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The WGSL snippet that defines the structs.
   */ getStructs(e) {
        let t = "";
        const i = this.structs[e];
        if (i.length > 0) {
            const n = [];
            for (const s of i){
                let a = `struct ${s.name} {
`;
                a += this.getStructMembers(s), a += `
};`, n.push(a);
            }
            t = `
` + n.join(`

`) + `
`;
        }
        return t;
    }
    /**
   * Returns a WGSL string representing a variable.
   *
   * @param {string} type - The variable's type.
   * @param {string} name - The variable's name.
   * @param {?number} [count=null] - The array length.
   * @return {string} The WGSL snippet that defines a variable.
   */ getVar(e, t, i = null) {
        let n = `var ${t} : `;
        return i !== null ? n += this.generateArrayDeclaration(e, i) : n += this.getType(e), n;
    }
    /**
   * Returns the variables of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The WGSL snippet that defines the variables.
   */ getVars(e) {
        const t = [], i = this.vars[e];
        if (i !== void 0) for (const n of i)t.push(`	${this.getVar(n.type, n.name, n.count)};`);
        return `
${t.join(`
`)}
`;
    }
    /**
   * Returns the varyings of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The WGSL snippet that defines the varyings.
   */ getVaryings(e) {
        const t = [];
        if (e === "vertex" && this.getBuiltin("position", "Vertex", "vec4<f32>", "vertex"), e === "vertex" || e === "fragment") {
            const s = this.varyings, a = this.vars[e];
            for(let o = 0; o < s.length; o++){
                const g = s[o];
                if (g.needsInterpolation) {
                    let l = `@location( ${o} )`;
                    if (g.interpolationType) {
                        const c = g.interpolationSampling !== null ? `, ${g.interpolationSampling} )` : " )";
                        l += ` @interpolate( ${g.interpolationType}${c}`;
                    } else /^(int|uint|ivec|uvec)/.test(g.type) && (l += ` @interpolate( ${this.renderer.backend.compatibilityMode ? "flat, either" : "flat"} )`);
                    t.push(`${l} ${g.name} : ${this.getType(g.type)}`);
                } else e === "vertex" && a.includes(g) === !1 && a.push(g);
            }
        }
        const i = this.getBuiltins(e);
        i && t.push(i);
        const n = t.join(`,
	`);
        return e === "vertex" ? this._getWGSLStruct("VaryingsStruct", "	" + n) : n;
    }
    isCustomStruct(e) {
        const t = e.value, i = e.node, n = (t.isBufferAttribute || t.isInstancedBufferAttribute) && i.structTypeNode !== null, s = i.value && i.value.array && typeof i.value.itemSize == "number" && i.value.array.length > i.value.itemSize;
        return n && !s;
    }
    /**
   * Returns the uniforms of the given shader stage as a WGSL string.
   *
   * @param {string} shaderStage - The shader stage.
   * @return {string} The WGSL snippet that defines the uniforms.
   */ getUniforms(e) {
        const t = this.uniforms[e], i = [], n = [], s = [], a = {};
        for (const g of t){
            const l = g.groupNode.name, c = this.bindingsIndexes[l];
            if (g.type === "texture" || g.type === "cubeTexture" || g.type === "storageTexture" || g.type === "texture3D") {
                const d = g.node.value;
                this.isUnfilterable(d) === !1 && g.node.isStorageTextureNode !== !0 && (this.isSampleCompare(d) ? i.push(`@binding( ${c.binding++} ) @group( ${c.group} ) var ${g.name}_sampler : sampler_comparison;`) : i.push(`@binding( ${c.binding++} ) @group( ${c.group} ) var ${g.name}_sampler : sampler;`));
                let p, A = "";
                const { primarySamples: y } = this.renderer.backend.utils.getTextureSampleData(d);
                if (y > 1 && (A = "_multisampled"), d.isCubeTexture === !0) p = "texture_cube<f32>";
                else if (d.isDepthTexture === !0) this.renderer.backend.compatibilityMode && d.compareFunction === null ? p = `texture${A}_2d<f32>` : p = `texture_depth${A}_2d${d.isArrayTexture === !0 ? "_array" : ""}`;
                else if (g.node.isStorageTextureNode === !0) {
                    const G = $d7238066c5de7f1c$var$P2(d), Z = this.getStorageAccess(g.node, e), v = g.node.value.is3DTexture, V = g.node.value.isArrayTexture;
                    p = `texture_storage_${v ? "3d" : `2d${V ? "_array" : ""}`}<${G}, ${Z}>`;
                } else if (d.isArrayTexture === !0 || d.isDataArrayTexture === !0 || d.isCompressedArrayTexture === !0) p = "texture_2d_array<f32>";
                else if (d.is3DTexture === !0 || d.isData3DTexture === !0) p = "texture_3d<f32>";
                else {
                    const G = this.getComponentTypeFromTexture(d).charAt(0);
                    p = `texture${A}_2d<${G}32>`;
                }
                i.push(`@binding( ${c.binding++} ) @group( ${c.group} ) var ${g.name} : ${p};`);
            } else if (g.type === "buffer" || g.type === "storageBuffer" || g.type === "indirectStorageBuffer") {
                const d = g.node, p = this.getType(d.getNodeType(this)), A = d.bufferCount, y = A > 0 && g.type === "buffer" ? ", " + A : "", G = d.isStorageBufferNode ? `storage, ${this.getStorageAccess(d, e)}` : "uniform";
                if (this.isCustomStruct(g)) n.push(`@binding( ${c.binding++} ) @group( ${c.group} ) var<${G}> ${g.name} : ${p};`);
                else {
                    const v = `	value : array< ${d.isAtomic ? `atomic<${p}>` : `${p}`}${y} >`;
                    n.push(this._getWGSLStructBinding(g.name, v, G, c.binding++, c.group));
                }
            } else {
                const d = this.getType(this.getVectorType(g.type)), p = g.groupNode.name;
                (a[p] || (a[p] = {
                    index: c.binding++,
                    id: c.group,
                    snippets: []
                })).snippets.push(`	${g.name} : ${d}`);
            }
        }
        for(const g in a){
            const l = a[g];
            s.push(this._getWGSLStructBinding(g, l.snippets.join(`,
`), "uniform", l.index, l.id));
        }
        let o = i.join(`
`);
        return o += n.join(`
`), o += s.join(`
`), o;
    }
    /**
   * Controls the code build of the shader stages.
   */ buildCode() {
        const e = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const t in e){
            this.shaderStage = t;
            const i = e[t];
            i.uniforms = this.getUniforms(t), i.attributes = this.getAttributes(t), i.varyings = this.getVaryings(t), i.structs = this.getStructs(t), i.vars = this.getVars(t), i.codes = this.getCodes(t), i.directives = this.getDirectives(t), i.scopedArrays = this.getScopedArrays(t);
            let n = `// code

`;
            n += this.flowCode[t];
            const s = this.flowNodes[t], a = s[s.length - 1], o = a.outputNode, g = o !== void 0 && o.isOutputStructNode === !0;
            for (const l of s){
                const c = this.getFlowData(l), d = l.name;
                if (d && (n.length > 0 && (n += `
`), n += `	// flow -> ${d}
`), n += `${c.code}
	`, l === a && t !== "compute") {
                    if (n += `// result

	`, t === "vertex") n += `varyings.Vertex = ${c.result};`;
                    else if (t === "fragment") {
                        if (g) i.returnType = o.getNodeType(this), i.structs += "var<private> output : " + i.returnType + ";", n += `return ${c.result};`;
                        else {
                            let p = "	@location(0) color: vec4<f32>";
                            const A = this.getBuiltins("output");
                            A && (p += `,
	` + A), i.returnType = "OutputStruct", i.structs += this._getWGSLStruct("OutputStruct", p), i.structs += `
var<private> output : OutputStruct;`, n += `output.color = ${c.result};

	return output;`;
                        }
                    }
                }
            }
            i.flow = n;
        }
        if (this.shaderStage = null, this.material !== null) this.vertexShader = this._getWGSLVertexCode(e.vertex), this.fragmentShader = this._getWGSLFragmentCode(e.fragment);
        else {
            const t = this.object.workgroupSize;
            this.computeShader = this._getWGSLComputeCode(e.compute, t);
        }
    }
    /**
   * Returns the native shader method name for a given generic name.
   *
   * @param {string} method - The method name to resolve.
   * @param {?string} [output=null] - An optional output.
   * @return {string} The resolved WGSL method name.
   */ getMethod(e, t = null) {
        let i;
        return t !== null && (i = this._getWGSLMethod(e + "_" + t)), i === void 0 && (i = this._getWGSLMethod(e)), i || e;
    }
    /**
   * Returns the bitcast method name for a given input and outputType.
   *
   * @param {string} type - The output type to bitcast to.
   * @return {string} The resolved WGSL bitcast invocation.
   */ getBitcastMethod(e) {
        return `bitcast<${this.getType(e)}>`;
    }
    /**
   * Returns the native snippet for a ternary operation.
   *
   * @param {string} condSnippet - The condition determining which expression gets resolved.
   * @param {string} ifSnippet - The expression to resolve to if the condition is true.
   * @param {string} elseSnippet - The expression to resolve to if the condition is false.
   * @return {string} The resolved method name.
   */ getTernary(e, t, i) {
        return `select( ${i}, ${t}, ${e} )`;
    }
    /**
   * Returns the WGSL type of the given node data type.
   *
   * @param {string} type - The node data type.
   * @return {string} The WGSL type.
   */ getType(e) {
        return $d7238066c5de7f1c$var$Xue[e] || e;
    }
    /**
   * Whether the requested feature is available or not.
   *
   * @param {string} name - The requested feature.
   * @return {boolean} Whether the requested feature is supported or not.
   */ isAvailable(e) {
        let t = $d7238066c5de7f1c$var$tT[e];
        return t === void 0 && (e === "float32Filterable" ? t = this.renderer.hasFeature("float32-filterable") : e === "clipDistance" && (t = this.renderer.hasFeature("clip-distances")), $d7238066c5de7f1c$var$tT[e] = t), t;
    }
    /**
   * Returns the native shader method name for a given generic name.
   *
   * @private
   * @param {string} method - The method name to resolve.
   * @return {string} The resolved WGSL method name.
   */ _getWGSLMethod(e) {
        return $d7238066c5de7f1c$var$Ob[e] !== void 0 && this._include(e), $d7238066c5de7f1c$var$Nue[e];
    }
    /**
   * Includes the given method name into the current
   * function node.
   *
   * @private
   * @param {string} name - The method name to include.
   * @return {CodeNode} The respective code node.
   */ _include(e) {
        const t = $d7238066c5de7f1c$var$Ob[e];
        return t.build(this), this.addInclude(t), t;
    }
    /**
   * Returns a WGSL vertex shader based on the given shader data.
   *
   * @private
   * @param {Object} shaderData - The shader data.
   * @return {string} The vertex shader.
   */ _getWGSLVertexCode(e) {
        return `${this.getSignature()}
// directives
${e.directives}

// structs
${e.structs}

// uniforms
${e.uniforms}

// varyings
${e.varyings}
var<private> varyings : VaryingsStruct;

// codes
${e.codes}

@vertex
fn main( ${e.attributes} ) -> VaryingsStruct {

	// vars
	${e.vars}

	// flow
	${e.flow}

	return varyings;

}
`;
    }
    /**
   * Returns a WGSL fragment shader based on the given shader data.
   *
   * @private
   * @param {Object} shaderData - The shader data.
   * @return {string} The vertex shader.
   */ _getWGSLFragmentCode(e) {
        return `${this.getSignature()}
// global
${$d7238066c5de7f1c$var$n_}

// structs
${e.structs}

// uniforms
${e.uniforms}

// codes
${e.codes}

@fragment
fn main( ${e.varyings} ) -> ${e.returnType} {

	// vars
	${e.vars}

	// flow
	${e.flow}

}
`;
    }
    /**
   * Returns a WGSL compute shader based on the given shader data.
   *
   * @private
   * @param {Object} shaderData - The shader data.
   * @param {string} workgroupSize - The workgroup size.
   * @return {string} The vertex shader.
   */ _getWGSLComputeCode(e, t) {
        const [i, n, s] = t;
        return `${this.getSignature()}
// directives
${e.directives}

// system
var<private> instanceIndex : u32;

// locals
${e.scopedArrays}

// structs
${e.structs}

// uniforms
${e.uniforms}

// codes
${e.codes}

@compute @workgroup_size( ${i}, ${n}, ${s} )
fn main( ${e.attributes} ) {

	// system
	instanceIndex = globalId.x
		+ globalId.y * ( ${i} * numWorkgroups.x )
		+ globalId.z * ( ${i} * numWorkgroups.x ) * ( ${n} * numWorkgroups.y );

	// vars
	${e.vars}

	// flow
	${e.flow}

}
`;
    }
    /**
   * Returns a WGSL struct based on the given name and variables.
   *
   * @private
   * @param {string} name - The struct name.
   * @param {string} vars - The struct variables.
   * @return {string} The WGSL snippet representing a struct.
   */ _getWGSLStruct(e, t) {
        return `
struct ${e} {
${t}
};`;
    }
    /**
   * Returns a WGSL struct binding.
   *
   * @private
   * @param {string} name - The struct name.
   * @param {string} vars - The struct variables.
   * @param {string} access - The access.
   * @param {number} [binding=0] - The binding index.
   * @param {number} [group=0] - The group index.
   * @return {string} The WGSL snippet representing a struct binding.
   */ _getWGSLStructBinding(e, t, i, n = 0, s = 0) {
        const a = e + "Struct";
        return `${this._getWGSLStruct(a, t)}
@binding( ${n} ) @group( ${s} )
var<${i}> ${e} : ${a};`;
    }
}
class $d7238066c5de7f1c$var$Yue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGPUBackend} backend - The WebGPU backend.
   */ constructor(e){
        this.backend = e;
    }
    /**
   * Returns the depth/stencil GPU format for the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {string} The depth/stencil GPU texture format.
   */ getCurrentDepthStencilFormat(e) {
        let t;
        return e.depthTexture !== null ? t = this.getTextureFormatGPU(e.depthTexture) : e.depth && e.stencil ? t = $d7238066c5de7f1c$var$se.Depth24PlusStencil8 : e.depth && (t = $d7238066c5de7f1c$var$se.Depth24Plus), t;
    }
    /**
   * Returns the GPU format for the given texture.
   *
   * @param {Texture} texture - The texture.
   * @return {string} The GPU texture format.
   */ getTextureFormatGPU(e) {
        return this.backend.get(e).format;
    }
    /**
   * Returns an object that defines the multi-sampling state of the given texture.
   *
   * @param {Texture} texture - The texture.
   * @return {Object} The multi-sampling state.
   */ getTextureSampleData(e) {
        let t;
        if (e.isFramebufferTexture) t = 1;
        else if (e.isDepthTexture && !e.renderTarget) {
            const s = this.backend.renderer, a = s.getRenderTarget();
            t = a ? a.samples : s.currentSamples;
        } else e.renderTarget && (t = e.renderTarget.samples);
        t = t || 1;
        const i = t > 1 && e.renderTarget !== null && e.isDepthTexture !== !0 && e.isFramebufferTexture !== !0;
        return {
            samples: t,
            primarySamples: i ? 1 : t,
            isMSAA: i
        };
    }
    /**
   * Returns the default color attachment's GPU format of the current render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {string} The GPU texture format of the default color attachment.
   */ getCurrentColorFormat(e) {
        let t;
        return e.textures !== null ? t = this.getTextureFormatGPU(e.textures[0]) : t = this.getPreferredCanvasFormat(), t;
    }
    /**
   * Returns the GPU formats of all color attachments of the current render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {Array<string>} The GPU texture formats of all color attachments.
   */ getCurrentColorFormats(e) {
        return e.textures !== null ? e.textures.map((t)=>this.getTextureFormatGPU(t)) : [
            this.getPreferredCanvasFormat()
        ];
    }
    /**
   * Returns the output color space of the current render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {string} The output color space.
   */ getCurrentColorSpace(e) {
        return e.textures !== null ? e.textures[0].colorSpace : this.backend.renderer.outputColorSpace;
    }
    /**
   * Returns GPU primitive topology for the given object and material.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The material.
   * @return {string} The GPU primitive topology.
   */ getPrimitiveTopology(e, t) {
        if (e.isPoints) return $d7238066c5de7f1c$var$CA.PointList;
        if (e.isLineSegments || e.isMesh && t.wireframe === !0) return $d7238066c5de7f1c$var$CA.LineList;
        if (e.isLine) return $d7238066c5de7f1c$var$CA.LineStrip;
        if (e.isMesh) return $d7238066c5de7f1c$var$CA.TriangleList;
    }
    /**
   * Returns a modified sample count from the given sample count value.
   *
   * That is required since WebGPU only supports either 1 or 4.
   *
   * @param {number} sampleCount - The input sample count.
   * @return {number} The (potentially updated) output sample count.
   */ getSampleCount(e) {
        return e >= 4 ? 4 : 1;
    }
    /**
   * Returns the sample count of the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {number} The sample count.
   */ getSampleCountRenderContext(e) {
        return e.textures !== null ? this.getSampleCount(e.sampleCount) : this.getSampleCount(this.backend.renderer.currentSamples);
    }
    /**
   * Returns the preferred canvas format.
   *
   * There is a separate method for this so it's possible to
   * honor edge cases for specific devices.
   *
   * @return {string} The GPU texture format of the canvas.
   */ getPreferredCanvasFormat() {
        const e = this.backend.parameters.outputType;
        if (e === void 0) return navigator.gpu.getPreferredCanvasFormat();
        if (e === $d7238066c5de7f1c$var$Ya) return $d7238066c5de7f1c$var$se.BGRA8Unorm;
        if (e === $d7238066c5de7f1c$var$Ia) return $d7238066c5de7f1c$var$se.RGBA16Float;
        throw new Error("Unsupported outputType");
    }
}
const $d7238066c5de7f1c$var$s_ = /* @__PURE__ */ new Map([
    [
        Int8Array,
        [
            "sint8",
            "snorm8"
        ]
    ],
    [
        Uint8Array,
        [
            "uint8",
            "unorm8"
        ]
    ],
    [
        Int16Array,
        [
            "sint16",
            "snorm16"
        ]
    ],
    [
        Uint16Array,
        [
            "uint16",
            "unorm16"
        ]
    ],
    [
        Int32Array,
        [
            "sint32",
            "snorm32"
        ]
    ],
    [
        Uint32Array,
        [
            "uint32",
            "unorm32"
        ]
    ],
    [
        Float32Array,
        [
            "float32"
        ]
    ]
]);
typeof Float16Array < "u" && $d7238066c5de7f1c$var$s_.set(Float16Array, [
    "float16"
]);
const $d7238066c5de7f1c$var$Kue = /* @__PURE__ */ new Map([
    [
        $d7238066c5de7f1c$var$u3,
        [
            "float16"
        ]
    ]
]), $d7238066c5de7f1c$var$xue = /* @__PURE__ */ new Map([
    [
        Int32Array,
        "sint32"
    ],
    [
        Int16Array,
        "sint32"
    ],
    // patch for INT16
    [
        Uint32Array,
        "uint32"
    ],
    [
        Uint16Array,
        "uint32"
    ],
    // patch for UINT16
    [
        Float32Array,
        "float32"
    ]
]);
class $d7238066c5de7f1c$var$Fue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGPUBackend} backend - The WebGPU backend.
   */ constructor(e){
        this.backend = e;
    }
    /**
   * Creates the GPU buffer for the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   * @param {GPUBufferUsage} usage - A flag that indicates how the buffer may be used after its creation.
   */ createAttribute(e, t) {
        const i = this._getBufferAttribute(e), n = this.backend, s = n.get(i);
        let a = s.buffer;
        if (a === void 0) {
            const o = n.device;
            let g = i.array;
            if (e.normalized === !1) {
                if (g.constructor === Int16Array || g.constructor === Int8Array) g = new Int32Array(g);
                else if ((g.constructor === Uint16Array || g.constructor === Uint8Array) && (g = new Uint32Array(g), t & GPUBufferUsage.INDEX)) for(let d = 0; d < g.length; d++)g[d] === 65535 && (g[d] = 4294967295);
            }
            if (i.array = g, (i.isStorageBufferAttribute || i.isStorageInstancedBufferAttribute) && i.itemSize === 3) {
                g = new g.constructor(i.count * 4);
                for(let d = 0; d < i.count; d++)g.set(i.array.subarray(d * 3, d * 3 + 3), d * 4);
                i.itemSize = 4, i.array = g, s._force3to4BytesAlignment = !0;
            }
            const l = g.byteLength, c = l + (4 - l % 4) % 4;
            a = o.createBuffer({
                label: i.name,
                size: c,
                usage: t,
                mappedAtCreation: !0
            }), new g.constructor(a.getMappedRange()).set(g), a.unmap(), s.buffer = a;
        }
    }
    /**
   * Updates the GPU buffer of the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ updateAttribute(e) {
        const t = this._getBufferAttribute(e), i = this.backend, n = i.device, s = i.get(t), a = i.get(t).buffer;
        let o = t.array;
        if (s._force3to4BytesAlignment === !0) {
            o = new o.constructor(t.count * 4);
            for(let c = 0; c < t.count; c++)o.set(t.array.subarray(c * 3, c * 3 + 3), c * 4);
            t.array = o;
        }
        const g = this._isTypedArray(o), l = t.updateRanges;
        if (l.length === 0) n.queue.writeBuffer(a, 0, o, 0);
        else {
            const c = g ? 1 : o.BYTES_PER_ELEMENT;
            for(let d = 0, p = l.length; d < p; d++){
                const A = l[d];
                let y, G;
                if (s._force3to4BytesAlignment === !0) {
                    const v = Math.floor(A.start / 3), V = Math.ceil(A.count / 3);
                    y = v * 4 * c, G = V * 4 * c;
                } else y = A.start * c, G = A.count * c;
                const Z = y * (g ? o.BYTES_PER_ELEMENT : 1);
                n.queue.writeBuffer(a, Z, o, y, G);
            }
            t.clearUpdateRanges();
        }
    }
    /**
   * This method creates the vertex buffer layout data which are
   * require when creating a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Array<Object>} An array holding objects which describe the vertex buffer layout.
   */ createShaderVertexBuffers(e) {
        const t = e.getAttributes(), i = /* @__PURE__ */ new Map();
        for(let n = 0; n < t.length; n++){
            const s = t[n], a = s.array.BYTES_PER_ELEMENT, o = this._getBufferAttribute(s);
            let g = i.get(o);
            if (g === void 0) {
                let d, p;
                s.isInterleavedBufferAttribute === !0 ? (d = s.data.stride * a, p = s.data.isInstancedInterleavedBuffer ? $d7238066c5de7f1c$var$Ov.Instance : $d7238066c5de7f1c$var$Ov.Vertex) : (d = s.itemSize * a, p = s.isInstancedBufferAttribute ? $d7238066c5de7f1c$var$Ov.Instance : $d7238066c5de7f1c$var$Ov.Vertex), s.normalized === !1 && (s.array.constructor === Int16Array || s.array.constructor === Uint16Array) && (d = 4), g = {
                    arrayStride: d,
                    attributes: [],
                    stepMode: p
                }, i.set(o, g);
            }
            const l = this._getVertexFormat(s), c = s.isInterleavedBufferAttribute === !0 ? s.offset * a : 0;
            g.attributes.push({
                shaderLocation: n,
                offset: c,
                format: l
            });
        }
        return Array.from(i.values());
    }
    /**
   * Destroys the GPU buffer of the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ destroyAttribute(e) {
        const t = this.backend;
        t.get(this._getBufferAttribute(e)).buffer.destroy(), t.delete(e);
    }
    /**
   * This method performs a readback operation by moving buffer data from
   * a storage buffer attribute from the GPU to the CPU.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */ async getArrayBufferAsync(e) {
        const t = this.backend, i = t.device, s = t.get(this._getBufferAttribute(e)).buffer, a = s.size, o = i.createBuffer({
            label: `${e.name}_readback`,
            size: a,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }), g = i.createCommandEncoder({
            label: `readback_encoder_${e.name}`
        });
        g.copyBufferToBuffer(s, 0, o, 0, a);
        const l = g.finish();
        i.queue.submit([
            l
        ]), await o.mapAsync(GPUMapMode.READ);
        const c = o.getMappedRange(), d = new e.array.constructor(c.slice(0));
        return o.unmap(), d.buffer;
    }
    /**
   * Returns the vertex format of the given buffer attribute.
   *
   * @private
   * @param {BufferAttribute} geometryAttribute - The buffer attribute.
   * @return {string|undefined} The vertex format (e.g. 'float32x3').
   */ _getVertexFormat(e) {
        const { itemSize: t, normalized: i } = e, n = e.array.constructor, s = e.constructor;
        let a;
        if (t === 1) a = $d7238066c5de7f1c$var$xue.get(n);
        else {
            const g = ($d7238066c5de7f1c$var$Kue.get(s) || $d7238066c5de7f1c$var$s_.get(n))[i ? 1 : 0];
            if (g) {
                const l = n.BYTES_PER_ELEMENT * t, d = Math.floor((l + 3) / 4) * 4 / n.BYTES_PER_ELEMENT;
                if (d % 1) throw new Error("THREE.WebGPUAttributeUtils: Bad vertex format item size.");
                a = `${g}x${d}`;
            }
        }
        return a || $d7238066c5de7f1c$var$nt("WebGPUAttributeUtils: Vertex format not supported yet."), a;
    }
    /**
   * Returns `true` if the given array is a typed array.
   *
   * @private
   * @param {any} array - The array.
   * @return {boolean} Whether the given array is a typed array or not.
   */ _isTypedArray(e) {
        return ArrayBuffer.isView(e) && !(e instanceof DataView);
    }
    /**
   * Utility method for handling interleaved buffer attributes correctly.
   * To process them, their `InterleavedBuffer` is returned.
   *
   * @private
   * @param {BufferAttribute} attribute - The attribute.
   * @return {BufferAttribute|InterleavedBuffer}
   */ _getBufferAttribute(e) {
        return e.isInterleavedBufferAttribute && (e = e.data), e;
    }
}
class $d7238066c5de7f1c$var$Tue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGPUBackend} backend - The WebGPU backend.
   */ constructor(e){
        this.backend = e, this.bindGroupLayoutCache = /* @__PURE__ */ new WeakMap();
    }
    /**
   * Creates a GPU bind group layout for the given bind group.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @return {GPUBindGroupLayout} The GPU bind group layout.
   */ createBindingsLayout(e) {
        const t = this.backend, i = t.device, n = [];
        let s = 0;
        for (const a of e.bindings){
            const o = {
                binding: s++,
                visibility: a.visibility
            };
            if (a.isUniformBuffer || a.isStorageBuffer) {
                const g = {};
                a.isStorageBuffer && (a.visibility & 4 && (a.access === $d7238066c5de7f1c$var$da.READ_WRITE || a.access === $d7238066c5de7f1c$var$da.WRITE_ONLY) ? g.type = $d7238066c5de7f1c$var$TH.Storage : g.type = $d7238066c5de7f1c$var$TH.ReadOnlyStorage), o.buffer = g;
            } else if (a.isSampledTexture && a.store) {
                const g = {};
                g.format = this.backend.get(a.texture).texture.format;
                const l = a.access;
                l === $d7238066c5de7f1c$var$da.READ_WRITE ? g.access = $d7238066c5de7f1c$var$MH.ReadWrite : l === $d7238066c5de7f1c$var$da.WRITE_ONLY ? g.access = $d7238066c5de7f1c$var$MH.WriteOnly : g.access = $d7238066c5de7f1c$var$MH.ReadOnly, a.texture.isArrayTexture ? g.viewDimension = $d7238066c5de7f1c$var$nr.TwoDArray : a.texture.is3DTexture && (g.viewDimension = $d7238066c5de7f1c$var$nr.ThreeD), o.storageTexture = g;
            } else if (a.isSampledTexture) {
                const g = {}, { primarySamples: l } = t.utils.getTextureSampleData(a.texture);
                if (l > 1 && (g.multisampled = !0, a.texture.isDepthTexture || (g.sampleType = $d7238066c5de7f1c$var$IC.UnfilterableFloat)), a.texture.isDepthTexture) t.compatibilityMode && a.texture.compareFunction === null ? g.sampleType = $d7238066c5de7f1c$var$IC.UnfilterableFloat : g.sampleType = $d7238066c5de7f1c$var$IC.Depth;
                else if (a.texture.isDataTexture || a.texture.isDataArrayTexture || a.texture.isData3DTexture) {
                    const c = a.texture.type;
                    c === $d7238066c5de7f1c$var$Na ? g.sampleType = $d7238066c5de7f1c$var$IC.SInt : c === $d7238066c5de7f1c$var$Xs ? g.sampleType = $d7238066c5de7f1c$var$IC.UInt : c === $d7238066c5de7f1c$var$vo && (this.backend.hasFeature("float32-filterable") ? g.sampleType = $d7238066c5de7f1c$var$IC.Float : g.sampleType = $d7238066c5de7f1c$var$IC.UnfilterableFloat);
                }
                a.isSampledCubeTexture ? g.viewDimension = $d7238066c5de7f1c$var$nr.Cube : a.texture.isArrayTexture || a.texture.isDataArrayTexture || a.texture.isCompressedArrayTexture ? g.viewDimension = $d7238066c5de7f1c$var$nr.TwoDArray : a.isSampledTexture3D && (g.viewDimension = $d7238066c5de7f1c$var$nr.ThreeD), o.texture = g;
            } else if (a.isSampler) {
                const g = {};
                a.texture.isDepthTexture && (a.texture.compareFunction !== null ? g.type = $d7238066c5de7f1c$var$O9.Comparison : t.compatibilityMode && (g.type = $d7238066c5de7f1c$var$O9.NonFiltering)), o.sampler = g;
            } else $d7238066c5de7f1c$var$nt(`WebGPUBindingUtils: Unsupported binding "${a}".`);
            n.push(o);
        }
        return i.createBindGroupLayout({
            entries: n
        });
    }
    /**
   * Creates bindings from the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ createBindings(e, t, i, n = 0) {
        const { backend: s, bindGroupLayoutCache: a } = this, o = s.get(e);
        let g = a.get(e.bindingsReference);
        g === void 0 && (g = this.createBindingsLayout(e), a.set(e.bindingsReference, g));
        let l;
        i > 0 && (o.groups === void 0 && (o.groups = [], o.versions = []), o.versions[i] === n && (l = o.groups[i])), l === void 0 && (l = this.createBindGroup(e, g), i > 0 && (o.groups[i] = l, o.versions[i] = n)), o.group = l, o.layout = g;
    }
    /**
   * Updates a buffer binding.
   *
   *  @param {Buffer} binding - The buffer binding to update.
   */ updateBinding(e) {
        const t = this.backend, i = t.device, n = e.buffer, s = t.get(e).buffer;
        i.queue.writeBuffer(s, 0, n, 0);
    }
    /**
   * Creates a GPU bind group for the camera index.
   *
   * @param {Uint32Array} data - The index data.
   * @param {GPUBindGroupLayout} layout - The GPU bind group layout.
   * @return {GPUBindGroup} The GPU bind group.
   */ createBindGroupIndex(e, t) {
        const n = this.backend.device, s = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST, a = e[0], o = n.createBuffer({
            label: "bindingCameraIndex_" + a,
            size: 16,
            // uint(4) * 4
            usage: s
        });
        n.queue.writeBuffer(o, 0, e, 0);
        const g = [
            {
                binding: 0,
                resource: {
                    buffer: o
                }
            }
        ];
        return n.createBindGroup({
            label: "bindGroupCameraIndex_" + a,
            layout: t,
            entries: g
        });
    }
    /**
   * Creates a GPU bind group for the given bind group and GPU layout.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {GPUBindGroupLayout} layoutGPU - The GPU bind group layout.
   * @return {GPUBindGroup} The GPU bind group.
   */ createBindGroup(e, t) {
        const i = this.backend, n = i.device;
        let s = 0;
        const a = [];
        for (const o of e.bindings){
            if (o.isUniformBuffer) {
                const g = i.get(o);
                if (g.buffer === void 0) {
                    const l = o.byteLength, c = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST, d = n.createBuffer({
                        label: "bindingBuffer_" + o.name,
                        size: l,
                        usage: c
                    });
                    g.buffer = d;
                }
                a.push({
                    binding: s,
                    resource: {
                        buffer: g.buffer
                    }
                });
            } else if (o.isStorageBuffer) {
                const g = i.get(o);
                if (g.buffer === void 0) {
                    const l = o.attribute;
                    g.buffer = i.get(l).buffer;
                }
                a.push({
                    binding: s,
                    resource: {
                        buffer: g.buffer
                    }
                });
            } else if (o.isSampledTexture) {
                const g = i.get(o.texture);
                let l;
                if (g.externalTexture !== void 0) l = n.importExternalTexture({
                    source: g.externalTexture
                });
                else {
                    const c = o.store ? 1 : g.texture.mipLevelCount, d = o.store ? o.mipLevel : 0;
                    let p = `view-${g.texture.width}-${g.texture.height}`;
                    if (g.texture.depthOrArrayLayers > 1 && (p += `-${g.texture.depthOrArrayLayers}`), p += `-${c}-${d}`, l = g[p], l === void 0) {
                        const A = $d7238066c5de7f1c$var$pue.All;
                        let y;
                        o.isSampledCubeTexture ? y = $d7238066c5de7f1c$var$nr.Cube : o.isSampledTexture3D ? y = $d7238066c5de7f1c$var$nr.ThreeD : o.texture.isArrayTexture || o.texture.isDataArrayTexture || o.texture.isCompressedArrayTexture ? y = $d7238066c5de7f1c$var$nr.TwoDArray : y = $d7238066c5de7f1c$var$nr.TwoD, l = g[p] = g.texture.createView({
                            aspect: A,
                            dimension: y,
                            mipLevelCount: c,
                            baseMipLevel: d
                        });
                    }
                }
                a.push({
                    binding: s,
                    resource: l
                });
            } else if (o.isSampler) {
                const g = i.get(o.texture);
                a.push({
                    binding: s,
                    resource: g.sampler
                });
            }
            s++;
        }
        return n.createBindGroup({
            label: "bindGroup_" + e.name,
            layout: t,
            entries: a
        });
    }
}
class $d7238066c5de7f1c$var$Mue {
    /**
   * Constructs a new utility object.
   *
   * @param {WebGPUBackend} backend - The WebGPU backend.
   */ constructor(e){
        this.backend = e, this._activePipelines = /* @__PURE__ */ new WeakMap();
    }
    /**
   * Sets the given pipeline for the given pass. The method makes sure to only set the
   * pipeline when necessary.
   *
   * @param {(GPURenderPassEncoder|GPUComputePassEncoder)} pass - The pass encoder.
   * @param {(GPURenderPipeline|GPUComputePipeline)} pipeline - The pipeline.
   */ setPipeline(e, t) {
        this._activePipelines.get(e) !== t && (e.setPipeline(t), this._activePipelines.set(e, t));
    }
    /**
   * Returns the sample count derived from the given render context.
   *
   * @private
   * @param {RenderContext} renderContext - The render context.
   * @return {number} The sample count.
   */ _getSampleCount(e) {
        return this.backend.utils.getSampleCountRenderContext(e);
    }
    /**
   * Creates a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */ createRenderPipeline(e, t) {
        const { object: i, material: n, geometry: s, pipeline: a } = e, { vertexProgram: o, fragmentProgram: g } = a, l = this.backend, c = l.device, d = l.utils, p = l.get(a), A = [];
        for (const pe of e.getBindings()){
            const ce = l.get(pe);
            A.push(ce.layout);
        }
        const y = l.attributeUtils.createShaderVertexBuffers(e);
        let G;
        n.blending !== $d7238066c5de7f1c$var$xA && (n.blending !== $d7238066c5de7f1c$var$uI || n.transparent !== !1) && (G = this._getBlending(n));
        let Z = {};
        n.stencilWrite === !0 && (Z = {
            compare: this._getStencilCompare(n),
            failOp: this._getStencilOperation(n.stencilFail),
            depthFailOp: this._getStencilOperation(n.stencilZFail),
            passOp: this._getStencilOperation(n.stencilZPass)
        });
        const v = this._getColorWriteMask(n), V = [];
        if (e.context.textures !== null) {
            const pe = e.context.textures;
            for(let ce = 0; ce < pe.length; ce++){
                const $ = d.getTextureFormatGPU(pe[ce]);
                V.push({
                    format: $,
                    blend: G,
                    writeMask: v
                });
            }
        } else {
            const pe = d.getCurrentColorFormat(e.context);
            V.push({
                format: pe,
                blend: G,
                writeMask: v
            });
        }
        const H = l.get(o).module, N = l.get(g).module, Y = this._getPrimitiveState(i, s, n), K = this._getDepthCompare(n), z = d.getCurrentDepthStencilFormat(e.context), M = this._getSampleCount(e.context), _ = {
            label: `renderPipeline_${n.name || n.type}_${n.id}`,
            vertex: Object.assign({}, H, {
                buffers: y
            }),
            fragment: Object.assign({}, N, {
                targets: V
            }),
            primitive: Y,
            multisample: {
                count: M,
                alphaToCoverageEnabled: n.alphaToCoverage && M > 1
            },
            layout: c.createPipelineLayout({
                bindGroupLayouts: A
            })
        }, O = {}, ie = e.context.depth, he = e.context.stencil;
        if ((ie === !0 || he === !0) && (ie === !0 && (O.format = z, O.depthWriteEnabled = n.depthWrite, O.depthCompare = K), he === !0 && (O.stencilFront = Z, O.stencilBack = {}, O.stencilReadMask = n.stencilFuncMask, O.stencilWriteMask = n.stencilWriteMask), n.polygonOffset === !0 && (O.depthBias = n.polygonOffsetUnits, O.depthBiasSlopeScale = n.polygonOffsetFactor, O.depthBiasClamp = 0), _.depthStencil = O), c.pushErrorScope("validation"), t === null) p.pipeline = c.createRenderPipeline(_), c.popErrorScope().then((pe)=>{
            pe !== null && (p.error = !0, $d7238066c5de7f1c$var$nt(pe.message));
        });
        else {
            const pe = new Promise(async (ce)=>{
                try {
                    p.pipeline = await c.createRenderPipelineAsync(_);
                } catch  {}
                const $ = await c.popErrorScope();
                $ !== null && (p.error = !0, $d7238066c5de7f1c$var$nt($.message)), ce();
            });
            t.push(pe);
        }
    }
    /**
   * Creates GPU render bundle encoder for the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {?string} [label='renderBundleEncoder'] - The label.
   * @return {GPURenderBundleEncoder} The GPU render bundle encoder.
   */ createBundleEncoder(e, t = "renderBundleEncoder") {
        const i = this.backend, { utils: n, device: s } = i, a = n.getCurrentDepthStencilFormat(e), o = n.getCurrentColorFormats(e), g = this._getSampleCount(e), l = {
            label: t,
            colorFormats: o,
            depthStencilFormat: a,
            sampleCount: g
        };
        return s.createRenderBundleEncoder(l);
    }
    /**
   * Creates a compute pipeline for the given compute node.
   *
   * @param {ComputePipeline} pipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */ createComputePipeline(e, t) {
        const i = this.backend, n = i.device, s = i.get(e.computeProgram).module, a = i.get(e), o = [];
        for (const g of t){
            const l = i.get(g);
            o.push(l.layout);
        }
        a.pipeline = n.createComputePipeline({
            compute: s,
            layout: n.createPipelineLayout({
                bindGroupLayouts: o
            })
        });
    }
    /**
   * Returns the blending state as a descriptor object required
   * for the pipeline creation.
   *
   * @private
   * @param {Material} material - The material.
   * @return {Object} The blending state.
   */ _getBlending(e) {
        let t, i;
        const n = e.blending, s = e.blendSrc, a = e.blendDst, o = e.blendEquation;
        if (n === $d7238066c5de7f1c$var$Yy) {
            const g = e.blendSrcAlpha !== null ? e.blendSrcAlpha : s, l = e.blendDstAlpha !== null ? e.blendDstAlpha : a, c = e.blendEquationAlpha !== null ? e.blendEquationAlpha : o;
            t = {
                srcFactor: this._getBlendFactor(s),
                dstFactor: this._getBlendFactor(a),
                operation: this._getBlendOperation(o)
            }, i = {
                srcFactor: this._getBlendFactor(g),
                dstFactor: this._getBlendFactor(l),
                operation: this._getBlendOperation(c)
            };
        } else {
            const g = e.premultipliedAlpha, l = (c, d, p, A)=>{
                t = {
                    srcFactor: c,
                    dstFactor: d,
                    operation: $d7238066c5de7f1c$var$uC.Add
                }, i = {
                    srcFactor: p,
                    dstFactor: A,
                    operation: $d7238066c5de7f1c$var$uC.Add
                };
            };
            if (g) switch(n){
                case $d7238066c5de7f1c$var$uI:
                    l($d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.OneMinusSrcAlpha, $d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.OneMinusSrcAlpha);
                    break;
                case $d7238066c5de7f1c$var$_S:
                    l($d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.One);
                    break;
                case $d7238066c5de7f1c$var$PS:
                    l($d7238066c5de7f1c$var$xi.Zero, $d7238066c5de7f1c$var$xi.OneMinusSrc, $d7238066c5de7f1c$var$xi.Zero, $d7238066c5de7f1c$var$xi.One);
                    break;
                case $d7238066c5de7f1c$var$QS:
                    l($d7238066c5de7f1c$var$xi.Dst, $d7238066c5de7f1c$var$xi.OneMinusSrcAlpha, $d7238066c5de7f1c$var$xi.Zero, $d7238066c5de7f1c$var$xi.One);
                    break;
            }
            else switch(n){
                case $d7238066c5de7f1c$var$uI:
                    l($d7238066c5de7f1c$var$xi.SrcAlpha, $d7238066c5de7f1c$var$xi.OneMinusSrcAlpha, $d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.OneMinusSrcAlpha);
                    break;
                case $d7238066c5de7f1c$var$_S:
                    l($d7238066c5de7f1c$var$xi.SrcAlpha, $d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.One, $d7238066c5de7f1c$var$xi.One);
                    break;
                case $d7238066c5de7f1c$var$PS:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: SubtractiveBlending requires material.premultipliedAlpha = true");
                    break;
                case $d7238066c5de7f1c$var$QS:
                    $d7238066c5de7f1c$var$nt("WebGPURenderer: MultiplyBlending requires material.premultipliedAlpha = true");
                    break;
            }
        }
        if (t !== void 0 && i !== void 0) return {
            color: t,
            alpha: i
        };
        $d7238066c5de7f1c$var$nt("WebGPURenderer: Invalid blending: ", n);
    }
    /**
   * Returns the GPU blend factor which is required for the pipeline creation.
   *
   * @private
   * @param {number} blend - The blend factor as a three.js constant.
   * @return {string} The GPU blend factor.
   */ _getBlendFactor(e) {
        let t;
        switch(e){
            case $d7238066c5de7f1c$var$kd:
                t = $d7238066c5de7f1c$var$xi.Zero;
                break;
            case $d7238066c5de7f1c$var$Lk:
                t = $d7238066c5de7f1c$var$xi.One;
                break;
            case $d7238066c5de7f1c$var$Yk:
                t = $d7238066c5de7f1c$var$xi.Src;
                break;
            case $d7238066c5de7f1c$var$Kk:
                t = $d7238066c5de7f1c$var$xi.OneMinusSrc;
                break;
            case $d7238066c5de7f1c$var$OS:
                t = $d7238066c5de7f1c$var$xi.SrcAlpha;
                break;
            case $d7238066c5de7f1c$var$jS:
                t = $d7238066c5de7f1c$var$xi.OneMinusSrcAlpha;
                break;
            case $d7238066c5de7f1c$var$Tk:
                t = $d7238066c5de7f1c$var$xi.Dst;
                break;
            case $d7238066c5de7f1c$var$Mk:
                t = $d7238066c5de7f1c$var$xi.OneMinusDst;
                break;
            case $d7238066c5de7f1c$var$xk:
                t = $d7238066c5de7f1c$var$xi.DstAlpha;
                break;
            case $d7238066c5de7f1c$var$Fk:
                t = $d7238066c5de7f1c$var$xi.OneMinusDstAlpha;
                break;
            case $d7238066c5de7f1c$var$zk:
                t = $d7238066c5de7f1c$var$xi.SrcAlphaSaturated;
                break;
            case $d7238066c5de7f1c$var$Dse:
                t = $d7238066c5de7f1c$var$xi.Constant;
                break;
            case $d7238066c5de7f1c$var$_se:
                t = $d7238066c5de7f1c$var$xi.OneMinusConstant;
                break;
            default:
                $d7238066c5de7f1c$var$nt("WebGPURenderer: Blend factor not supported.", e);
        }
        return t;
    }
    /**
   * Returns the GPU stencil compare function which is required for the pipeline creation.
   *
   * @private
   * @param {Material} material - The material.
   * @return {string} The GPU stencil compare function.
   */ _getStencilCompare(e) {
        let t;
        const i = e.stencilFunc;
        switch(i){
            case $d7238066c5de7f1c$var$n$:
                t = $d7238066c5de7f1c$var$ra.Never;
                break;
            case $d7238066c5de7f1c$var$v2:
                t = $d7238066c5de7f1c$var$ra.Always;
                break;
            case $d7238066c5de7f1c$var$s$:
                t = $d7238066c5de7f1c$var$ra.Less;
                break;
            case $d7238066c5de7f1c$var$a$:
                t = $d7238066c5de7f1c$var$ra.LessEqual;
                break;
            case $d7238066c5de7f1c$var$r$:
                t = $d7238066c5de7f1c$var$ra.Equal;
                break;
            case $d7238066c5de7f1c$var$l$:
                t = $d7238066c5de7f1c$var$ra.GreaterEqual;
                break;
            case $d7238066c5de7f1c$var$o$:
                t = $d7238066c5de7f1c$var$ra.Greater;
                break;
            case $d7238066c5de7f1c$var$g$:
                t = $d7238066c5de7f1c$var$ra.NotEqual;
                break;
            default:
                $d7238066c5de7f1c$var$nt("WebGPURenderer: Invalid stencil function.", i);
        }
        return t;
    }
    /**
   * Returns the GPU stencil operation which is required for the pipeline creation.
   *
   * @private
   * @param {number} op - A three.js constant defining the stencil operation.
   * @return {string} The GPU stencil operation.
   */ _getStencilOperation(e) {
        let t;
        switch(e){
            case $d7238066c5de7f1c$var$SC:
                t = $d7238066c5de7f1c$var$Ld.Keep;
                break;
            case $d7238066c5de7f1c$var$O6:
                t = $d7238066c5de7f1c$var$Ld.Zero;
                break;
            case $d7238066c5de7f1c$var$j6:
                t = $d7238066c5de7f1c$var$Ld.Replace;
                break;
            case $d7238066c5de7f1c$var$i$:
                t = $d7238066c5de7f1c$var$Ld.Invert;
                break;
            case $d7238066c5de7f1c$var$q6:
                t = $d7238066c5de7f1c$var$Ld.IncrementClamp;
                break;
            case $d7238066c5de7f1c$var$$6:
                t = $d7238066c5de7f1c$var$Ld.DecrementClamp;
                break;
            case $d7238066c5de7f1c$var$e$:
                t = $d7238066c5de7f1c$var$Ld.IncrementWrap;
                break;
            case $d7238066c5de7f1c$var$t$:
                t = $d7238066c5de7f1c$var$Ld.DecrementWrap;
                break;
            default:
                $d7238066c5de7f1c$var$nt("WebGPURenderer: Invalid stencil operation.", t);
        }
        return t;
    }
    /**
   * Returns the GPU blend operation which is required for the pipeline creation.
   *
   * @private
   * @param {number} blendEquation - A three.js constant defining the blend equation.
   * @return {string} The GPU blend operation.
   */ _getBlendOperation(e) {
        let t;
        switch(e){
            case $d7238066c5de7f1c$var$Pl:
                t = $d7238066c5de7f1c$var$uC.Add;
                break;
            case $d7238066c5de7f1c$var$Xk:
                t = $d7238066c5de7f1c$var$uC.Subtract;
                break;
            case $d7238066c5de7f1c$var$Nk:
                t = $d7238066c5de7f1c$var$uC.ReverseSubtract;
                break;
            case $d7238066c5de7f1c$var$Y6:
                t = $d7238066c5de7f1c$var$uC.Min;
                break;
            case $d7238066c5de7f1c$var$K6:
                t = $d7238066c5de7f1c$var$uC.Max;
                break;
            default:
                $d7238066c5de7f1c$var$nt("WebGPUPipelineUtils: Blend equation not supported.", e);
        }
        return t;
    }
    /**
   * Returns the primitive state as a descriptor object required
   * for the pipeline creation.
   *
   * @private
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The geometry.
   * @param {Material} material - The material.
   * @return {Object} The primitive state.
   */ _getPrimitiveState(e, t, i) {
        const n = {}, s = this.backend.utils;
        n.topology = s.getPrimitiveTopology(e, i), t.index !== null && e.isLine === !0 && e.isLineSegments !== !0 && (n.stripIndexFormat = t.index.array instanceof Uint16Array ? $d7238066c5de7f1c$var$UA.Uint16 : $d7238066c5de7f1c$var$UA.Uint32);
        let a = i.side === $d7238066c5de7f1c$var$Ka;
        return e.isMesh && e.matrixWorld.determinant() < 0 && (a = !a), n.frontFace = a === !0 ? $d7238066c5de7f1c$var$_9.CW : $d7238066c5de7f1c$var$_9.CCW, n.cullMode = i.side === $d7238066c5de7f1c$var$YC ? $d7238066c5de7f1c$var$P9.None : $d7238066c5de7f1c$var$P9.Back, n;
    }
    /**
   * Returns the GPU color write mask which is required for the pipeline creation.
   *
   * @private
   * @param {Material} material - The material.
   * @return {number} The GPU color write mask.
   */ _getColorWriteMask(e) {
        return e.colorWrite === !0 ? $d7238066c5de7f1c$var$Q9.All : $d7238066c5de7f1c$var$Q9.None;
    }
    /**
   * Returns the GPU depth compare function which is required for the pipeline creation.
   *
   * @private
   * @param {Material} material - The material.
   * @return {string} The GPU depth compare function.
   */ _getDepthCompare(e) {
        let t;
        if (e.depthTest === !1) t = $d7238066c5de7f1c$var$ra.Always;
        else {
            const i = e.depthFunc;
            switch(i){
                case $d7238066c5de7f1c$var$kk:
                    t = $d7238066c5de7f1c$var$ra.Never;
                    break;
                case $d7238066c5de7f1c$var$Ek:
                    t = $d7238066c5de7f1c$var$ra.Always;
                    break;
                case $d7238066c5de7f1c$var$Jk:
                    t = $d7238066c5de7f1c$var$ra.Less;
                    break;
                case $d7238066c5de7f1c$var$qS:
                    t = $d7238066c5de7f1c$var$ra.LessEqual;
                    break;
                case $d7238066c5de7f1c$var$Uk:
                    t = $d7238066c5de7f1c$var$ra.Equal;
                    break;
                case $d7238066c5de7f1c$var$Dk:
                    t = $d7238066c5de7f1c$var$ra.GreaterEqual;
                    break;
                case $d7238066c5de7f1c$var$_k:
                    t = $d7238066c5de7f1c$var$ra.Greater;
                    break;
                case $d7238066c5de7f1c$var$Pk:
                    t = $d7238066c5de7f1c$var$ra.NotEqual;
                    break;
                default:
                    $d7238066c5de7f1c$var$nt("WebGPUPipelineUtils: Invalid depth function.", i);
            }
        }
        return t;
    }
}
class $d7238066c5de7f1c$var$zue extends $d7238066c5de7f1c$var$i_ {
    /**
   * Creates a new WebGPU timestamp query pool.
   *
   * @param {GPUDevice} device - The WebGPU device to create queries on.
   * @param {string} type - The type identifier for this query pool.
   * @param {number} [maxQueries=2048] - Maximum number of queries this pool can hold.
   */ constructor(e, t, i = 2048){
        super(i), this.device = e, this.type = t, this.querySet = this.device.createQuerySet({
            type: "timestamp",
            count: this.maxQueries,
            label: `queryset_global_timestamp_${t}`
        });
        const n = this.maxQueries * 8;
        this.resolveBuffer = this.device.createBuffer({
            label: `buffer_timestamp_resolve_${t}`,
            size: n,
            usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
        }), this.resultBuffer = this.device.createBuffer({
            label: `buffer_timestamp_result_${t}`,
            size: n,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
    }
    /**
   * Allocates a pair of queries for a given render context.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @returns {?number} The base offset for the allocated queries, or null if allocation failed.
   */ allocateQueriesForContext(e) {
        if (!this.trackTimestamp || this.isDisposed) return null;
        if (this.currentQueryIndex + 2 > this.maxQueries) return $d7238066c5de7f1c$var$es(`WebGPUTimestampQueryPool [${this.type}]: Maximum number of queries exceeded, when using trackTimestamp it is necessary to resolves the queries via renderer.resolveTimestampsAsync( THREE.TimestampQuery.${this.type.toUpperCase()} ).`), null;
        const t = this.currentQueryIndex;
        return this.currentQueryIndex += 2, this.queryOffsets.set(e, t), t;
    }
    /**
   * Asynchronously resolves all pending queries and returns the total duration.
   * If there's already a pending resolve operation, returns that promise instead.
   *
   * @async
   * @returns {Promise<number>} The total duration in milliseconds, or the last valid value if resolution fails.
   */ async resolveQueriesAsync() {
        if (!this.trackTimestamp || this.currentQueryIndex === 0 || this.isDisposed) return this.lastValue;
        if (this.pendingResolve) return this.pendingResolve;
        this.pendingResolve = this._resolveQueries();
        try {
            return await this.pendingResolve;
        } finally{
            this.pendingResolve = null;
        }
    }
    /**
   * Internal method to resolve queries and calculate total duration.
   *
   * @async
   * @private
   * @returns {Promise<number>} The total duration in milliseconds.
   */ async _resolveQueries() {
        if (this.isDisposed) return this.lastValue;
        try {
            if (this.resultBuffer.mapState !== "unmapped") return this.lastValue;
            const e = new Map(this.queryOffsets), t = this.currentQueryIndex, i = t * 8;
            this.currentQueryIndex = 0, this.queryOffsets.clear();
            const n = this.device.createCommandEncoder();
            n.resolveQuerySet(this.querySet, 0, t, this.resolveBuffer, 0), n.copyBufferToBuffer(this.resolveBuffer, 0, this.resultBuffer, 0, i);
            const s = n.finish();
            if (this.device.queue.submit([
                s
            ]), this.resultBuffer.mapState !== "unmapped") return this.lastValue;
            if (await this.resultBuffer.mapAsync(GPUMapMode.READ, 0, i), this.isDisposed) return this.resultBuffer.mapState === "mapped" && this.resultBuffer.unmap(), this.lastValue;
            const a = new BigUint64Array(this.resultBuffer.getMappedRange(0, i)), o = {}, g = [];
            for (const [c, d] of e){
                const p = c.match(/^(.*):f(\d+)$/), A = parseInt(p[2]);
                g.includes(A) === !1 && g.push(A), o[A] === void 0 && (o[A] = 0);
                const y = a[d], G = a[d + 1], Z = Number(G - y) / 1e6;
                this.timestamps.set(c, Z), o[A] += Z;
            }
            const l = o[g[g.length - 1]];
            return this.resultBuffer.unmap(), this.lastValue = l, this.frames = g, l;
        } catch (e) {
            return e("Error resolving queries:", e), this.resultBuffer.mapState === "mapped" && this.resultBuffer.unmap(), this.lastValue;
        }
    }
    /**
   * Dispose of the query pool.
   *
   * @async
   * @returns {Promise} A Promise that resolves when the dispose has been executed.
   */ async dispose() {
        if (!this.isDisposed) {
            if (this.isDisposed = !0, this.pendingResolve) try {
                await this.pendingResolve;
            } catch (e) {
                e("Error waiting for pending resolve:", e);
            }
            if (this.resultBuffer && this.resultBuffer.mapState === "mapped") try {
                this.resultBuffer.unmap();
            } catch (e) {
                e("Error unmapping buffer:", e);
            }
            this.querySet && (this.querySet.destroy(), this.querySet = null), this.resolveBuffer && (this.resolveBuffer.destroy(), this.resolveBuffer = null), this.resultBuffer && (this.resultBuffer.destroy(), this.resultBuffer = null), this.queryOffsets.clear(), this.pendingResolve = null;
        }
    }
}
class $d7238066c5de7f1c$var$kue extends $d7238066c5de7f1c$var$t_ {
    /**
   * WebGPUBackend options.
   *
   * @typedef {Object} WebGPUBackend~Options
   * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @property {boolean} [compatibilityMode=false] - Whether the backend should be in compatibility mode or not.
   * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
   * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
   * @property {boolean} [trackTimestamp=false] - Whether to track timestamps with a Timestamp Query API or not.
   * @property {string} [powerPreference=undefined] - The power preference.
   * @property {Object} [requiredLimits=undefined] - Specifies the limits that are required by the device request. The request will fail if the adapter cannot provide these limits.
   * @property {GPUDevice} [device=undefined] - If there is an existing GPU device on app level, it can be passed to the renderer as a parameter.
   * @property {number} [outputType=undefined] - Texture type for output to canvas. By default, device's preferred format is used; other formats may incur overhead.
   */ /**
   * Constructs a new WebGPU backend.
   *
   * @param {WebGPUBackend~Options} [parameters] - The configuration parameter.
   */ constructor(e = {}){
        super(e), this.isWebGPUBackend = !0, this.parameters.alpha = e.alpha === void 0 ? !0 : e.alpha, this.parameters.compatibilityMode = e.compatibilityMode === void 0 ? !1 : e.compatibilityMode, this.parameters.requiredLimits = e.requiredLimits === void 0 ? {} : e.requiredLimits, this.compatibilityMode = this.parameters.compatibilityMode, this.device = null, this.defaultRenderPassdescriptor = null, this.utils = new $d7238066c5de7f1c$var$Yue(this), this.attributeUtils = new $d7238066c5de7f1c$var$Fue(this), this.bindingUtils = new $d7238066c5de7f1c$var$Tue(this), this.pipelineUtils = new $d7238066c5de7f1c$var$Mue(this), this.textureUtils = new $d7238066c5de7f1c$var$vue(this), this.occludedResolveCache = /* @__PURE__ */ new Map();
    }
    /**
   * Initializes the backend so it is ready for usage.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the backend has been initialized.
   */ async init(e) {
        await super.init(e);
        const t = this.parameters;
        let i;
        if (t.device === void 0) {
            const n = {
                powerPreference: t.powerPreference,
                featureLevel: t.compatibilityMode ? "compatibility" : void 0
            }, s = typeof navigator < "u" ? await navigator.gpu.requestAdapter(n) : null;
            if (s === null) throw new Error("WebGPUBackend: Unable to create WebGPU adapter.");
            const a = Object.values($d7238066c5de7f1c$var$_2), o = [];
            for (const l of a)s.features.has(l) && o.push(l);
            const g = {
                requiredFeatures: o,
                requiredLimits: t.requiredLimits
            };
            i = await s.requestDevice(g);
        } else i = t.device;
        i.lost.then((n)=>{
            const s = {
                api: "WebGPU",
                message: n.message || "Unknown reason",
                reason: n.reason || null,
                originalEvent: n
            };
            e.onDeviceLost(s);
        }), this.device = i, this.trackTimestamp = this.trackTimestamp && this.hasFeature($d7238066c5de7f1c$var$_2.TimestampQuery), this.updateSize();
    }
    /**
   * A reference to the context.
   *
   * @type {?GPUCanvasContext}
   * @default null
   */ get context() {
        const e = this.renderer.getCanvasTarget(), t = this.get(e);
        let i = t.context;
        if (i === void 0) {
            const n = this.parameters;
            e.isDefaultCanvasTarget === !0 && n.context !== void 0 ? i = n.context : i = e.domElement.getContext("webgpu"), "setAttribute" in e.domElement && e.domElement.setAttribute("data-engine", `three.js r${$d7238066c5de7f1c$var$MB} webgpu`);
            const s = n.alpha ? "premultiplied" : "opaque", a = n.outputType === $d7238066c5de7f1c$var$Ia ? "extended" : "standard";
            i.configure({
                device: this.device,
                format: this.utils.getPreferredCanvasFormat(),
                usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
                alphaMode: s,
                toneMapping: {
                    mode: a
                }
            }), t.context = i;
        }
        return i;
    }
    /**
   * The coordinate system of the backend.
   *
   * @type {number}
   * @readonly
   */ get coordinateSystem() {
        return $d7238066c5de7f1c$var$uu;
    }
    /**
   * This method performs a readback operation by moving buffer data from
   * a storage buffer attribute from the GPU to the CPU.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */ async getArrayBufferAsync(e) {
        return await this.attributeUtils.getArrayBufferAsync(e);
    }
    /**
   * Returns the backend's rendering context.
   *
   * @return {GPUCanvasContext} The rendering context.
   */ getContext() {
        return this.context;
    }
    /**
   * Returns the default render pass descriptor.
   *
   * In WebGPU, the default framebuffer must be configured
   * like custom framebuffers so the backend needs a render
   * pass descriptor even when rendering directly to screen.
   *
   * @private
   * @return {Object} The render pass descriptor.
   */ _getDefaultRenderPassDescriptor() {
        const e = this.renderer, t = e.getCanvasTarget(), i = this.get(t), n = e.currentSamples;
        let s = i.descriptor;
        if (s === void 0 || i.samples !== n) {
            s = {
                colorAttachments: [
                    {
                        view: null
                    }
                ]
            }, (e.depth === !0 || e.stencil === !0) && (s.depthStencilAttachment = {
                view: this.textureUtils.getDepthBuffer(e.depth, e.stencil).createView()
            });
            const o = s.colorAttachments[0];
            n > 0 ? o.view = this.textureUtils.getColorBuffer().createView() : o.resolveTarget = void 0, i.descriptor = s, i.samples = n;
        }
        const a = s.colorAttachments[0];
        return n > 0 ? a.resolveTarget = this.context.getCurrentTexture().createView() : a.view = this.context.getCurrentTexture().createView(), s;
    }
    /**
   * Internal to determine if the current render target is a render target array with depth 2D array texture.
   *
   * @param {RenderContext} renderContext - The render context.
   * @return {boolean} Whether the render target is a render target array with depth 2D array texture.
   *
   * @private
   */ _isRenderCameraDepthArray(e) {
        return e.depthTexture && e.depthTexture.image.depth > 1 && e.camera.isArrayCamera;
    }
    /**
   * Returns the render pass descriptor for the given render context.
   *
   * @private
   * @param {RenderContext} renderContext - The render context.
   * @param {Object} colorAttachmentsConfig - Configuration object for the color attachments.
   * @return {Object} The render pass descriptor.
   */ _getRenderPassDescriptor(e, t = {}) {
        const i = e.renderTarget, n = this.get(i);
        let s = n.descriptors;
        (s === void 0 || n.width !== i.width || n.height !== i.height || n.samples !== i.samples) && (s = {}, n.descriptors = s);
        const a = e.getCacheKey();
        let o = s[a];
        if (o === void 0) {
            const l = e.textures, c = [];
            let d;
            const p = this._isRenderCameraDepthArray(e);
            for(let A = 0; A < l.length; A++){
                const y = this.get(l[A]), G = {
                    label: `colorAttachment_${A}`,
                    baseMipLevel: e.activeMipmapLevel,
                    mipLevelCount: 1,
                    baseArrayLayer: e.activeCubeFace,
                    arrayLayerCount: 1,
                    dimension: $d7238066c5de7f1c$var$nr.TwoD
                };
                if (i.isRenderTarget3D) d = e.activeCubeFace, G.baseArrayLayer = 0, G.dimension = $d7238066c5de7f1c$var$nr.ThreeD, G.depthOrArrayLayers = l[A].image.depth;
                else if (i.isRenderTarget && l[A].image.depth > 1) {
                    if (p === !0) {
                        const Z = e.camera.cameras;
                        for(let v = 0; v < Z.length; v++){
                            const V = {
                                ...G,
                                baseArrayLayer: v,
                                arrayLayerCount: 1,
                                dimension: $d7238066c5de7f1c$var$nr.TwoD
                            }, H = y.texture.createView(V);
                            c.push({
                                view: H,
                                resolveTarget: void 0,
                                depthSlice: void 0
                            });
                        }
                    } else G.dimension = $d7238066c5de7f1c$var$nr.TwoDArray, G.depthOrArrayLayers = l[A].image.depth;
                }
                if (p !== !0) {
                    const Z = y.texture.createView(G);
                    let v, V;
                    y.msaaTexture !== void 0 ? (v = y.msaaTexture.createView(), V = Z) : (v = Z, V = void 0), c.push({
                        view: v,
                        resolveTarget: V,
                        depthSlice: d
                    });
                }
            }
            if (o = {
                textureViews: c
            }, e.depth) {
                const A = this.get(e.depthTexture), y = {};
                e.depthTexture.isArrayTexture && (y.dimension = $d7238066c5de7f1c$var$nr.TwoD, y.arrayLayerCount = 1, y.baseArrayLayer = e.activeCubeFace), o.depthStencilView = A.texture.createView(y);
            }
            s[a] = o, n.width = i.width, n.height = i.height, n.samples = i.samples, n.activeMipmapLevel = e.activeMipmapLevel, n.activeCubeFace = e.activeCubeFace;
        }
        const g = {
            colorAttachments: []
        };
        for(let l = 0; l < o.textureViews.length; l++){
            const c = o.textureViews[l];
            let d = {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            };
            l === 0 && t.clearValue && (d = t.clearValue), g.colorAttachments.push({
                view: c.view,
                depthSlice: c.depthSlice,
                resolveTarget: c.resolveTarget,
                loadOp: t.loadOp || $d7238066c5de7f1c$var$dn.Load,
                storeOp: t.storeOp || $d7238066c5de7f1c$var$eo.Store,
                clearValue: d
            });
        }
        return o.depthStencilView && (g.depthStencilAttachment = {
            view: o.depthStencilView
        }), g;
    }
    /**
   * This method is executed at the beginning of a render call and prepares
   * the WebGPU state for upcoming render calls
   *
   * @param {RenderContext} renderContext - The render context.
   */ beginRender(e) {
        const t = this.get(e), i = this.device, n = e.occlusionQueryCount;
        let s;
        n > 0 && (t.currentOcclusionQuerySet && t.currentOcclusionQuerySet.destroy(), t.currentOcclusionQueryBuffer && t.currentOcclusionQueryBuffer.destroy(), t.currentOcclusionQuerySet = t.occlusionQuerySet, t.currentOcclusionQueryBuffer = t.occlusionQueryBuffer, t.currentOcclusionQueryObjects = t.occlusionQueryObjects, s = i.createQuerySet({
            type: "occlusion",
            count: n,
            label: `occlusionQuerySet_${e.id}`
        }), t.occlusionQuerySet = s, t.occlusionQueryIndex = 0, t.occlusionQueryObjects = new Array(n), t.lastOcclusionObject = null);
        let a;
        e.textures === null ? a = this._getDefaultRenderPassDescriptor() : a = this._getRenderPassDescriptor(e, {
            loadOp: $d7238066c5de7f1c$var$dn.Load
        }), this.initTimestampQuery($d7238066c5de7f1c$var$$c.RENDER, this.getTimestampUID(e), a), a.occlusionQuerySet = s;
        const o = a.depthStencilAttachment;
        if (e.textures !== null) {
            const l = a.colorAttachments;
            for(let c = 0; c < l.length; c++){
                const d = l[c];
                e.clearColor ? (d.clearValue = c === 0 ? e.clearColorValue : {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                }, d.loadOp = $d7238066c5de7f1c$var$dn.Clear) : d.loadOp = $d7238066c5de7f1c$var$dn.Load, d.storeOp = $d7238066c5de7f1c$var$eo.Store;
            }
        } else {
            const l = a.colorAttachments[0];
            e.clearColor ? (l.clearValue = e.clearColorValue, l.loadOp = $d7238066c5de7f1c$var$dn.Clear) : l.loadOp = $d7238066c5de7f1c$var$dn.Load, l.storeOp = $d7238066c5de7f1c$var$eo.Store;
        }
        e.depth && (e.clearDepth ? (o.depthClearValue = e.clearDepthValue, o.depthLoadOp = $d7238066c5de7f1c$var$dn.Clear) : o.depthLoadOp = $d7238066c5de7f1c$var$dn.Load, o.depthStoreOp = $d7238066c5de7f1c$var$eo.Store), e.stencil && (e.clearStencil ? (o.stencilClearValue = e.clearStencilValue, o.stencilLoadOp = $d7238066c5de7f1c$var$dn.Clear) : o.stencilLoadOp = $d7238066c5de7f1c$var$dn.Load, o.stencilStoreOp = $d7238066c5de7f1c$var$eo.Store);
        const g = i.createCommandEncoder({
            label: "renderContext_" + e.id
        });
        if (this._isRenderCameraDepthArray(e) === !0) {
            const l = e.camera.cameras;
            !t.layerDescriptors || t.layerDescriptors.length !== l.length ? this._createDepthLayerDescriptors(e, t, a, l) : this._updateDepthLayerDescriptors(e, t, l), t.bundleEncoders = [], t.bundleSets = [];
            for(let c = 0; c < l.length; c++){
                const d = this.pipelineUtils.createBundleEncoder(e, "renderBundleArrayCamera_" + c), p = {
                    attributes: {},
                    bindingGroups: [],
                    pipeline: null,
                    index: null
                };
                t.bundleEncoders.push(d), t.bundleSets.push(p);
            }
            t.currentPass = null;
        } else {
            const l = g.beginRenderPass(a);
            t.currentPass = l, e.viewport && this.updateViewport(e), e.scissor && this.updateScissor(e);
        }
        t.descriptor = a, t.encoder = g, t.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        }, t.renderBundles = [];
    }
    /**
   * This method creates layer descriptors for each camera in an array camera
   * to prepare for rendering to a depth array texture.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object} renderContextData - The render context data.
   * @param {Object} descriptor  - The render pass descriptor.
   * @param {ArrayCamera} cameras - The array camera.
   *
   * @private
   */ _createDepthLayerDescriptors(e, t, i, n) {
        const s = i.depthStencilAttachment;
        t.layerDescriptors = [];
        const a = this.get(e.depthTexture);
        a.viewCache || (a.viewCache = []);
        for(let o = 0; o < n.length; o++){
            const g = {
                ...i,
                colorAttachments: [
                    {
                        ...i.colorAttachments[0],
                        view: i.colorAttachments[o].view
                    }
                ]
            };
            if (i.depthStencilAttachment) {
                const l = o;
                a.viewCache[l] || (a.viewCache[l] = a.texture.createView({
                    dimension: $d7238066c5de7f1c$var$nr.TwoD,
                    baseArrayLayer: o,
                    arrayLayerCount: 1
                })), g.depthStencilAttachment = {
                    view: a.viewCache[l],
                    depthLoadOp: s.depthLoadOp || $d7238066c5de7f1c$var$dn.Clear,
                    depthStoreOp: s.depthStoreOp || $d7238066c5de7f1c$var$eo.Store,
                    depthClearValue: s.depthClearValue || 1
                }, e.stencil && (g.depthStencilAttachment.stencilLoadOp = s.stencilLoadOp, g.depthStencilAttachment.stencilStoreOp = s.stencilStoreOp, g.depthStencilAttachment.stencilClearValue = s.stencilClearValue);
            } else g.depthStencilAttachment = {
                ...s
            };
            t.layerDescriptors.push(g);
        }
    }
    /**
   * This method updates the layer descriptors for each camera in an array camera
   * to prepare for rendering to a depth array texture.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object} renderContextData - The render context data.
   * @param {ArrayCamera} cameras - The array camera.
   *
   */ _updateDepthLayerDescriptors(e, t, i) {
        for(let n = 0; n < i.length; n++){
            const s = t.layerDescriptors[n];
            if (s.depthStencilAttachment) {
                const a = s.depthStencilAttachment;
                e.depth && (e.clearDepth ? (a.depthClearValue = e.clearDepthValue, a.depthLoadOp = $d7238066c5de7f1c$var$dn.Clear) : a.depthLoadOp = $d7238066c5de7f1c$var$dn.Load), e.stencil && (e.clearStencil ? (a.stencilClearValue = e.clearStencilValue, a.stencilLoadOp = $d7238066c5de7f1c$var$dn.Clear) : a.stencilLoadOp = $d7238066c5de7f1c$var$dn.Load);
            }
        }
    }
    /**
   * This method is executed at the end of a render call and finalizes work
   * after draw calls.
   *
   * @param {RenderContext} renderContext - The render context.
   */ finishRender(e) {
        const t = this.get(e), i = e.occlusionQueryCount;
        t.renderBundles.length > 0 && t.currentPass.executeBundles(t.renderBundles), i > t.occlusionQueryIndex && t.currentPass.endOcclusionQuery();
        const n = t.encoder;
        if (this._isRenderCameraDepthArray(e) === !0) {
            const s = [];
            for(let a = 0; a < t.bundleEncoders.length; a++){
                const o = t.bundleEncoders[a];
                s.push(o.finish());
            }
            for(let a = 0; a < t.layerDescriptors.length; a++)if (a < s.length) {
                const o = t.layerDescriptors[a], g = n.beginRenderPass(o);
                if (e.viewport) {
                    const { x: l, y: c, width: d, height: p, minDepth: A, maxDepth: y } = e.viewportValue;
                    g.setViewport(l, c, d, p, A, y);
                }
                if (e.scissor) {
                    const { x: l, y: c, width: d, height: p } = e.scissorValue;
                    g.setScissorRect(l, c, d, p);
                }
                g.executeBundles([
                    s[a]
                ]), g.end();
            }
        } else t.currentPass && t.currentPass.end();
        if (i > 0) {
            const s = i * 8;
            let a = this.occludedResolveCache.get(s);
            a === void 0 && (a = this.device.createBuffer({
                size: s,
                usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
            }), this.occludedResolveCache.set(s, a));
            const o = this.device.createBuffer({
                size: s,
                usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
            });
            t.encoder.resolveQuerySet(t.occlusionQuerySet, 0, i, a, 0), t.encoder.copyBufferToBuffer(a, 0, o, 0, s), t.occlusionQueryBuffer = o, this.resolveOccludedAsync(e);
        }
        if (this.device.queue.submit([
            t.encoder.finish()
        ]), e.textures !== null) {
            const s = e.textures;
            for(let a = 0; a < s.length; a++){
                const o = s[a];
                o.generateMipmaps === !0 && this.textureUtils.generateMipmaps(o);
            }
        }
    }
    /**
   * Returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object is fully occluded or not.
   */ isOccluded(e, t) {
        const i = this.get(e);
        return i.occluded && i.occluded.has(t);
    }
    /**
   * This method processes the result of occlusion queries and writes it
   * into render context data.
   *
   * @async
   * @param {RenderContext} renderContext - The render context.
   * @return {Promise} A Promise that resolves when the occlusion query results have been processed.
   */ async resolveOccludedAsync(e) {
        const t = this.get(e), { currentOcclusionQueryBuffer: i, currentOcclusionQueryObjects: n } = t;
        if (i && n) {
            const s = /* @__PURE__ */ new WeakSet();
            t.currentOcclusionQueryObjects = null, t.currentOcclusionQueryBuffer = null, await i.mapAsync(GPUMapMode.READ);
            const a = i.getMappedRange(), o = new BigUint64Array(a);
            for(let g = 0; g < n.length; g++)o[g] === BigInt(0) && s.add(n[g]);
            i.destroy(), t.occluded = s;
        }
    }
    /**
   * Updates the viewport with the values from the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   */ updateViewport(e) {
        const { currentPass: t } = this.get(e), { x: i, y: n, width: s, height: a, minDepth: o, maxDepth: g } = e.viewportValue;
        t.setViewport(i, n, s, a, o, g);
    }
    /**
   * Updates the scissor with the values from the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   */ updateScissor(e) {
        const { currentPass: t } = this.get(e), { x: i, y: n, width: s, height: a } = e.scissorValue;
        t.setScissorRect(i, n, s, a);
    }
    /**
   * Returns the clear color and alpha into a single
   * color object.
   *
   * @return {Color4} The clear color.
   */ getClearColor() {
        const e = super.getClearColor();
        return this.renderer.alpha === !0 && (e.r *= e.a, e.g *= e.a, e.b *= e.a), e;
    }
    /**
   * Performs a clear operation.
   *
   * @param {boolean} color - Whether the color buffer should be cleared or not.
   * @param {boolean} depth - Whether the depth buffer should be cleared or not.
   * @param {boolean} stencil - Whether the stencil buffer should be cleared or not.
   * @param {?RenderContext} [renderTargetContext=null] - The render context of the current set render target.
   */ clear(e, t, i, n = null) {
        const s = this.device, a = this.renderer;
        let o = [], g, l, c, d;
        if (e) {
            const y = this.getClearColor();
            l = {
                r: y.r,
                g: y.g,
                b: y.b,
                a: y.a
            };
        }
        if (n === null) {
            c = a.depth, d = a.stencil;
            const y = this._getDefaultRenderPassDescriptor();
            if (e) {
                o = y.colorAttachments;
                const G = o[0];
                G.clearValue = l, G.loadOp = $d7238066c5de7f1c$var$dn.Clear, G.storeOp = $d7238066c5de7f1c$var$eo.Store;
            }
            (c || d) && (g = y.depthStencilAttachment);
        } else {
            c = n.depth, d = n.stencil;
            const y = {
                loadOp: e ? $d7238066c5de7f1c$var$dn.Clear : $d7238066c5de7f1c$var$dn.Load,
                clearValue: e ? l : void 0
            };
            c && (y.depthLoadOp = t ? $d7238066c5de7f1c$var$dn.Clear : $d7238066c5de7f1c$var$dn.Load, y.depthClearValue = t ? a.getClearDepth() : void 0, y.depthStoreOp = $d7238066c5de7f1c$var$eo.Store), d && (y.stencilLoadOp = i ? $d7238066c5de7f1c$var$dn.Clear : $d7238066c5de7f1c$var$dn.Load, y.stencilClearValue = i ? a.getClearStencil() : void 0, y.stencilStoreOp = $d7238066c5de7f1c$var$eo.Store);
            const G = this._getRenderPassDescriptor(n, y);
            o = G.colorAttachments, g = G.depthStencilAttachment;
        }
        c && g && (t ? (g.depthLoadOp = $d7238066c5de7f1c$var$dn.Clear, g.depthClearValue = a.getClearDepth(), g.depthStoreOp = $d7238066c5de7f1c$var$eo.Store) : (g.depthLoadOp = $d7238066c5de7f1c$var$dn.Load, g.depthStoreOp = $d7238066c5de7f1c$var$eo.Store)), d && g && (i ? (g.stencilLoadOp = $d7238066c5de7f1c$var$dn.Clear, g.stencilClearValue = a.getClearStencil(), g.stencilStoreOp = $d7238066c5de7f1c$var$eo.Store) : (g.stencilLoadOp = $d7238066c5de7f1c$var$dn.Load, g.stencilStoreOp = $d7238066c5de7f1c$var$eo.Store));
        const p = s.createCommandEncoder({
            label: "clear"
        });
        p.beginRenderPass({
            colorAttachments: o,
            depthStencilAttachment: g
        }).end(), s.queue.submit([
            p.finish()
        ]);
    }
    // compute
    /**
   * This method is executed at the beginning of a compute call and
   * prepares the state for upcoming compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */ beginCompute(e) {
        const t = this.get(e), i = {
            label: "computeGroup_" + e.id
        };
        this.initTimestampQuery($d7238066c5de7f1c$var$$c.COMPUTE, this.getTimestampUID(e), i), t.cmdEncoderGPU = this.device.createCommandEncoder({
            label: "computeGroup_" + e.id
        }), t.passEncoderGPU = t.cmdEncoderGPU.beginComputePass(i);
    }
    /**
   * Executes a compute command for the given compute node.
   *
   * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {ComputePipeline} pipeline - The compute pipeline.
   * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
   * - A single number representing count, or
   * - An array [x, y, z] representing dispatch size, or
   * - A IndirectStorageBufferAttribute for indirect dispatch size.
   */ compute(e, t, i, n, s = null) {
        const a = this.get(t), { passEncoderGPU: o } = this.get(e), g = this.get(n).pipeline;
        this.pipelineUtils.setPipeline(o, g);
        for(let l = 0, c = i.length; l < c; l++){
            const d = i[l], p = this.get(d);
            o.setBindGroup(l, p.group);
        }
        if (s === null && (s = t.count), s && typeof s == "object" && s.isIndirectStorageBufferAttribute) {
            const l = this.get(s).buffer;
            o.dispatchWorkgroupsIndirect(l, 0);
            return;
        }
        if (typeof s == "number") {
            const l = s;
            if (a.dispatchSize === void 0 || a.count !== l) {
                a.dispatchSize = [
                    0,
                    1,
                    1
                ], a.count = l;
                const c = t.workgroupSize;
                let d = c[0];
                for(let y = 1; y < c.length; y++)d *= c[y];
                const p = Math.ceil(l / d), A = this.device.limits.maxComputeWorkgroupsPerDimension;
                s = [
                    p,
                    1,
                    1
                ], p > A && (s[0] = Math.min(p, A), s[1] = Math.ceil(p / A)), a.dispatchSize = s;
            }
            s = a.dispatchSize;
        }
        o.dispatchWorkgroups(s[0], s[1] || 1, s[2] || 1);
    }
    /**
   * This method is executed at the end of a compute call and
   * finalizes work after compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */ finishCompute(e) {
        const t = this.get(e);
        t.passEncoderGPU.end(), this.device.queue.submit([
            t.cmdEncoderGPU.finish()
        ]);
    }
    // render object
    /**
   * Executes a draw command for the given render object.
   *
   * @param {RenderObject} renderObject - The render object to draw.
   * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
   */ draw(e, t) {
        const { object: i, material: n, context: s, pipeline: a } = e, o = e.getBindings(), g = this.get(s), l = this.get(a), c = l.pipeline;
        if (l.error === !0) return;
        const d = e.getIndex(), p = d !== null, A = e.getDrawParameters();
        if (A === null) return;
        const y = (Z, v)=>{
            this.pipelineUtils.setPipeline(Z, c), v.pipeline = c;
            const V = v.bindingGroups;
            for(let N = 0, Y = o.length; N < Y; N++){
                const K = o[N], z = this.get(K);
                V[K.index] !== K.id && (Z.setBindGroup(K.index, z.group), V[K.index] = K.id);
            }
            if (p === !0 && v.index !== d) {
                const N = this.get(d).buffer, Y = d.array instanceof Uint16Array ? $d7238066c5de7f1c$var$UA.Uint16 : $d7238066c5de7f1c$var$UA.Uint32;
                Z.setIndexBuffer(N, Y), v.index = d;
            }
            const H = e.getVertexBuffers();
            for(let N = 0, Y = H.length; N < Y; N++){
                const K = H[N];
                if (v.attributes[N] !== K) {
                    const z = this.get(K).buffer;
                    Z.setVertexBuffer(N, z), v.attributes[N] = K;
                }
            }
            s.stencil === !0 && n.stencilWrite === !0 && g.currentStencilRef !== n.stencilRef && (Z.setStencilReference(n.stencilRef), g.currentStencilRef = n.stencilRef);
        }, G = (Z, v)=>{
            if (y(Z, v), i.isBatchedMesh === !0) {
                const V = i._multiDrawStarts, H = i._multiDrawCounts, N = i._multiDrawCount, Y = i._multiDrawInstances;
                Y !== null && $d7238066c5de7f1c$var$es("WebGPUBackend: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.");
                for(let K = 0; K < N; K++){
                    const z = Y ? Y[K] : 1, M = z > 1 ? 0 : K;
                    p === !0 ? Z.drawIndexed(H[K], z, V[K] / d.array.BYTES_PER_ELEMENT, 0, M) : Z.draw(H[K], z, V[K], M), t.update(i, H[K], z);
                }
            } else if (p === !0) {
                const { vertexCount: V, instanceCount: H, firstVertex: N } = A, Y = e.getIndirect();
                if (Y !== null) {
                    const K = this.get(Y).buffer;
                    Z.drawIndexedIndirect(K, 0);
                } else Z.drawIndexed(V, H, N, 0, 0);
                t.update(i, V, H);
            } else {
                const { vertexCount: V, instanceCount: H, firstVertex: N } = A, Y = e.getIndirect();
                if (Y !== null) {
                    const K = this.get(Y).buffer;
                    Z.drawIndirect(K, 0);
                } else Z.draw(V, H, N, 0);
                t.update(i, V, H);
            }
        };
        if (e.camera.isArrayCamera && e.camera.cameras.length > 0) {
            const Z = this.get(e.camera), v = e.camera.cameras, V = e.getBindingGroup("cameraIndex");
            if (Z.indexesGPU === void 0 || Z.indexesGPU.length !== v.length) {
                const N = this.get(V), Y = [], K = new Uint32Array([
                    0,
                    0,
                    0,
                    0
                ]);
                for(let z = 0, M = v.length; z < M; z++){
                    K[0] = z;
                    const _ = this.bindingUtils.createBindGroupIndex(K, N.layout);
                    Y.push(_);
                }
                Z.indexesGPU = Y;
            }
            const H = this.renderer.getPixelRatio();
            for(let N = 0, Y = v.length; N < Y; N++){
                const K = v[N];
                if (i.layers.test(K.layers)) {
                    const z = K.viewport;
                    let M = g.currentPass, _ = g.currentSets;
                    if (g.bundleEncoders) {
                        const O = g.bundleEncoders[N], ie = g.bundleSets[N];
                        M = O, _ = ie;
                    }
                    z && M.setViewport(Math.floor(z.x * H), Math.floor(z.y * H), Math.floor(z.width * H), Math.floor(z.height * H), s.viewportValue.minDepth, s.viewportValue.maxDepth), V && Z.indexesGPU && (M.setBindGroup(V.index, Z.indexesGPU[N]), _.bindingGroups[V.index] = V.id), G(M, _);
                }
            }
        } else if (g.currentPass) {
            if (g.occlusionQuerySet !== void 0) {
                const Z = g.lastOcclusionObject;
                Z !== i && (Z !== null && Z.occlusionTest === !0 && (g.currentPass.endOcclusionQuery(), g.occlusionQueryIndex++), i.occlusionTest === !0 && (g.currentPass.beginOcclusionQuery(g.occlusionQueryIndex), g.occlusionQueryObjects[g.occlusionQueryIndex] = i), g.lastOcclusionObject = i);
            }
            G(g.currentPass, g.currentSets);
        }
    }
    // cache key
    /**
   * Returns `true` if the render pipeline requires an update.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the render pipeline requires an update or not.
   */ needsRenderUpdate(e) {
        const t = this.get(e), { object: i, material: n } = e, s = this.utils, a = s.getSampleCountRenderContext(e.context), o = s.getCurrentColorSpace(e.context), g = s.getCurrentColorFormat(e.context), l = s.getCurrentDepthStencilFormat(e.context), c = s.getPrimitiveTopology(i, n);
        let d = !1;
        return (t.material !== n || t.materialVersion !== n.version || t.transparent !== n.transparent || t.blending !== n.blending || t.premultipliedAlpha !== n.premultipliedAlpha || t.blendSrc !== n.blendSrc || t.blendDst !== n.blendDst || t.blendEquation !== n.blendEquation || t.blendSrcAlpha !== n.blendSrcAlpha || t.blendDstAlpha !== n.blendDstAlpha || t.blendEquationAlpha !== n.blendEquationAlpha || t.colorWrite !== n.colorWrite || t.depthWrite !== n.depthWrite || t.depthTest !== n.depthTest || t.depthFunc !== n.depthFunc || t.stencilWrite !== n.stencilWrite || t.stencilFunc !== n.stencilFunc || t.stencilFail !== n.stencilFail || t.stencilZFail !== n.stencilZFail || t.stencilZPass !== n.stencilZPass || t.stencilFuncMask !== n.stencilFuncMask || t.stencilWriteMask !== n.stencilWriteMask || t.side !== n.side || t.alphaToCoverage !== n.alphaToCoverage || t.sampleCount !== a || t.colorSpace !== o || t.colorFormat !== g || t.depthStencilFormat !== l || t.primitiveTopology !== c || t.clippingContextCacheKey !== e.clippingContextCacheKey) && (t.material = n, t.materialVersion = n.version, t.transparent = n.transparent, t.blending = n.blending, t.premultipliedAlpha = n.premultipliedAlpha, t.blendSrc = n.blendSrc, t.blendDst = n.blendDst, t.blendEquation = n.blendEquation, t.blendSrcAlpha = n.blendSrcAlpha, t.blendDstAlpha = n.blendDstAlpha, t.blendEquationAlpha = n.blendEquationAlpha, t.colorWrite = n.colorWrite, t.depthWrite = n.depthWrite, t.depthTest = n.depthTest, t.depthFunc = n.depthFunc, t.stencilWrite = n.stencilWrite, t.stencilFunc = n.stencilFunc, t.stencilFail = n.stencilFail, t.stencilZFail = n.stencilZFail, t.stencilZPass = n.stencilZPass, t.stencilFuncMask = n.stencilFuncMask, t.stencilWriteMask = n.stencilWriteMask, t.side = n.side, t.alphaToCoverage = n.alphaToCoverage, t.sampleCount = a, t.colorSpace = o, t.colorFormat = g, t.depthStencilFormat = l, t.primitiveTopology = c, t.clippingContextCacheKey = e.clippingContextCacheKey, d = !0), d;
    }
    /**
   * Returns a cache key that is used to identify render pipelines.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {string} The cache key.
   */ getRenderCacheKey(e) {
        const { object: t, material: i } = e, n = this.utils, s = e.context, a = t.isMesh && t.matrixWorld.determinant() < 0;
        return [
            i.transparent,
            i.blending,
            i.premultipliedAlpha,
            i.blendSrc,
            i.blendDst,
            i.blendEquation,
            i.blendSrcAlpha,
            i.blendDstAlpha,
            i.blendEquationAlpha,
            i.colorWrite,
            i.depthWrite,
            i.depthTest,
            i.depthFunc,
            i.stencilWrite,
            i.stencilFunc,
            i.stencilFail,
            i.stencilZFail,
            i.stencilZPass,
            i.stencilFuncMask,
            i.stencilWriteMask,
            i.side,
            a,
            n.getSampleCountRenderContext(s),
            n.getCurrentColorSpace(s),
            n.getCurrentColorFormat(s),
            n.getCurrentDepthStencilFormat(s),
            n.getPrimitiveTopology(t, i),
            e.getGeometryCacheKey(),
            e.clippingContextCacheKey
        ].join();
    }
    // textures
    /**
   * Updates a GPU sampler for the given texture.
   *
   * @param {Texture} texture - The texture to update the sampler for.
   * @return {string} The current sampler key.
   */ updateSampler(e) {
        return this.textureUtils.updateSampler(e);
    }
    /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @param {Texture} texture - The texture to create a default texture for.
   * @return {boolean} Whether the sampler has been updated or not.
   */ createDefaultTexture(e) {
        return this.textureUtils.createDefaultTexture(e);
    }
    /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ createTexture(e, t) {
        this.textureUtils.createTexture(e, t);
    }
    /**
   * Uploads the updated texture data to the GPU.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */ updateTexture(e, t) {
        this.textureUtils.updateTexture(e, t);
    }
    /**
   * Generates mipmaps for the given texture.
   *
   * @param {Texture} texture - The texture.
   */ generateMipmaps(e) {
        this.textureUtils.generateMipmaps(e);
    }
    /**
   * Destroys the GPU data for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
   */ destroyTexture(e, t = !1) {
        this.textureUtils.destroyTexture(e, t);
    }
    /**
   * Returns texture data as a typed array.
   *
   * @async
   * @param {Texture} texture - The texture to copy.
   * @param {number} x - The x coordinate of the copy origin.
   * @param {number} y - The y coordinate of the copy origin.
   * @param {number} width - The width of the copy.
   * @param {number} height - The height of the copy.
   * @param {number} faceIndex - The face index.
   * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
   */ async copyTextureToBuffer(e, t, i, n, s, a) {
        return this.textureUtils.copyTextureToBuffer(e, t, i, n, s, a);
    }
    /**
   * Inits a time stamp query for the given render context.
   *
   * @param {string} type - The type of the timestamp query (e.g. 'render', 'compute').
   * @param {number} uid - Unique id for the context (e.g. render context id).
   * @param {Object} descriptor - The query descriptor.
   */ initTimestampQuery(e, t, i) {
        if (!this.trackTimestamp) return;
        this.timestampQueryPool[e] || (this.timestampQueryPool[e] = new $d7238066c5de7f1c$var$zue(this.device, e, 2048));
        const n = this.timestampQueryPool[e], s = n.allocateQueriesForContext(t);
        i.timestampWrites = {
            querySet: n.querySet,
            beginningOfPassWriteIndex: s,
            endOfPassWriteIndex: s + 1
        };
    }
    // node builder
    /**
   * Returns a node builder for the given render object.
   *
   * @param {RenderObject} object - The render object.
   * @param {Renderer} renderer - The renderer.
   * @return {WGSLNodeBuilder} The node builder.
   */ createNodeBuilder(e, t) {
        return new $d7238066c5de7f1c$var$Lue(e, t);
    }
    // program
    /**
   * Creates a shader program from the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */ createProgram(e) {
        const t = this.get(e);
        t.module = {
            module: this.device.createShaderModule({
                code: e.code,
                label: e.stage + (e.name !== "" ? `_${e.name}` : "")
            }),
            entryPoint: "main"
        };
    }
    /**
   * Destroys the shader program of the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */ destroyProgram(e) {
        this.delete(e);
    }
    // pipelines
    /**
   * Creates a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */ createRenderPipeline(e, t) {
        this.pipelineUtils.createRenderPipeline(e, t);
    }
    /**
   * Creates a compute pipeline for the given compute node.
   *
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */ createComputePipeline(e, t) {
        this.pipelineUtils.createComputePipeline(e, t);
    }
    /**
   * Prepares the state for encoding render bundles.
   *
   * @param {RenderContext} renderContext - The render context.
   */ beginBundle(e) {
        const t = this.get(e);
        t._currentPass = t.currentPass, t._currentSets = t.currentSets, t.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        }, t.currentPass = this.pipelineUtils.createBundleEncoder(e);
    }
    /**
   * After processing render bundles this method finalizes related work.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {RenderBundle} bundle - The render bundle.
   */ finishBundle(e, t) {
        const i = this.get(e), s = i.currentPass.finish();
        this.get(t).bundleGPU = s, i.currentSets = i._currentSets, i.currentPass = i._currentPass;
    }
    /**
   * Adds a render bundle to the render context data.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {RenderBundle} bundle - The render bundle to add.
   */ addBundle(e, t) {
        this.get(e).renderBundles.push(this.get(t).bundleGPU);
    }
    // bindings
    /**
   * Creates bindings from the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ createBindings(e, t, i, n) {
        this.bindingUtils.createBindings(e, t, i, n);
    }
    /**
   * Updates the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {number} cacheIndex - The cache index.
   * @param {number} version - The version.
   */ updateBindings(e, t, i, n) {
        this.bindingUtils.createBindings(e, t, i, n);
    }
    /**
   * Updates a buffer binding.
   *
   *  @param {Buffer} binding - The buffer binding to update.
   */ updateBinding(e) {
        this.bindingUtils.updateBinding(e);
    }
    // attributes
    /**
   * Creates the buffer of an indexed shader attribute.
   *
   * @param {BufferAttribute} attribute - The indexed buffer attribute.
   */ createIndexAttribute(e) {
        let t = GPUBufferUsage.INDEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST;
        (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) && (t |= GPUBufferUsage.STORAGE), this.attributeUtils.createAttribute(e, t);
    }
    /**
   * Creates the GPU buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createAttribute(e) {
        this.attributeUtils.createAttribute(e, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
   * Creates the GPU buffer of a storage attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createStorageAttribute(e) {
        this.attributeUtils.createAttribute(e, GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
   * Creates the GPU buffer of an indirect storage attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */ createIndirectStorageAttribute(e) {
        this.attributeUtils.createAttribute(e, GPUBufferUsage.STORAGE | GPUBufferUsage.INDIRECT | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
   * Updates the GPU buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to update.
   */ updateAttribute(e) {
        this.attributeUtils.updateAttribute(e);
    }
    /**
   * Destroys the GPU buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to destroy.
   */ destroyAttribute(e) {
        this.attributeUtils.destroyAttribute(e);
    }
    // canvas
    /**
   * Triggers an update of the default render pass descriptor.
   */ updateSize() {
        this.delete(this.renderer.getCanvasTarget());
    }
    // utils public
    /**
   * Returns the maximum anisotropy texture filtering value.
   *
   * @return {number} The maximum anisotropy texture filtering value.
   */ getMaxAnisotropy() {
        return 16;
    }
    /**
   * Checks if the given feature is supported by the backend.
   *
   * @param {string} name - The feature's name.
   * @return {boolean} Whether the feature is supported or not.
   */ hasFeature(e) {
        return $d7238066c5de7f1c$var$q9[e] !== void 0 && (e = $d7238066c5de7f1c$var$q9[e]), this.device.features.has(e);
    }
    /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
   * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
   * @param {number} [srcLevel=0] - The mipmap level to copy.
   * @param {number} [dstLevel=0] - The destination mip level to copy to.
   */ copyTextureToTexture(e, t, i = null, n = null, s = 0, a = 0) {
        let o = 0, g = 0, l = 0, c = 0, d = 0, p = 0, A = e.image.width, y = e.image.height, G = 1;
        i !== null && (i.isBox3 === !0 ? (c = i.min.x, d = i.min.y, p = i.min.z, A = i.max.x - i.min.x, y = i.max.y - i.min.y, G = i.max.z - i.min.z) : (c = i.min.x, d = i.min.y, A = i.max.x - i.min.x, y = i.max.y - i.min.y, G = 1)), n !== null && (o = n.x, g = n.y, l = n.z || 0);
        const Z = this.device.createCommandEncoder({
            label: "copyTextureToTexture_" + e.id + "_" + t.id
        }), v = this.get(e).texture, V = this.get(t).texture;
        Z.copyTextureToTexture({
            texture: v,
            mipLevel: s,
            origin: {
                x: c,
                y: d,
                z: p
            }
        }, {
            texture: V,
            mipLevel: a,
            origin: {
                x: o,
                y: g,
                z: l
            }
        }, [
            A,
            y,
            G
        ]), this.device.queue.submit([
            Z.finish()
        ]), a === 0 && t.generateMipmaps && this.textureUtils.generateMipmaps(t);
    }
    /**
   * Copies the current bound framebuffer to the given texture.
   *
   * @param {Texture} texture - The destination texture.
   * @param {RenderContext} renderContext - The render context.
   * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
   */ copyFramebufferToTexture(e, t, i) {
        const n = this.get(t);
        let s = null;
        t.renderTarget ? e.isDepthTexture ? s = this.get(t.depthTexture).texture : s = this.get(t.textures[0]).texture : e.isDepthTexture ? s = this.textureUtils.getDepthBuffer(t.depth, t.stencil) : s = this.context.getCurrentTexture();
        const a = this.get(e).texture;
        if (s.format !== a.format) {
            $d7238066c5de7f1c$var$nt("WebGPUBackend: copyFramebufferToTexture: Source and destination formats do not match.", s.format, a.format);
            return;
        }
        let o;
        if (n.currentPass ? (n.currentPass.end(), o = n.encoder) : o = this.device.createCommandEncoder({
            label: "copyFramebufferToTexture_" + e.id
        }), o.copyTextureToTexture({
            texture: s,
            origin: [
                i.x,
                i.y,
                0
            ]
        }, {
            texture: a
        }, [
            i.z,
            i.w
        ]), e.generateMipmaps && this.textureUtils.generateMipmaps(e, o), n.currentPass) {
            const { descriptor: g } = n;
            for(let l = 0; l < g.colorAttachments.length; l++)g.colorAttachments[l].loadOp = $d7238066c5de7f1c$var$dn.Load;
            t.depth && (g.depthStencilAttachment.depthLoadOp = $d7238066c5de7f1c$var$dn.Load), t.stencil && (g.depthStencilAttachment.stencilLoadOp = $d7238066c5de7f1c$var$dn.Load), n.currentPass = o.beginRenderPass(g), n.currentSets = {
                attributes: {},
                bindingGroups: [],
                pipeline: null,
                index: null
            }, t.viewport && this.updateViewport(t), t.scissor && this.updateScissor(t);
        } else this.device.queue.submit([
            o.finish()
        ]);
    }
    dispose() {
        this.textureUtils.dispose();
    }
}
class $d7238066c5de7f1c$var$Eue extends $d7238066c5de7f1c$var$IL {
    /**
   * Constructs a new IES spot light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
   * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */ constructor(e, t, i, n, s, a){
        super(e, t, i, n, s, a), this.iesMap = null;
    }
    copy(e, t) {
        return super.copy(e, t), this.iesMap = e.iesMap, this;
    }
}
class $d7238066c5de7f1c$var$Jue extends $d7238066c5de7f1c$var$IL {
    /**
   * Constructs a new projector light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
   * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */ constructor(e, t, i, n, s, a){
        super(e, t, i, n, s, a), this.aspect = null;
    }
    copy(e, t) {
        return super.copy(e, t), this.aspect = e.aspect, this;
    }
}
class $d7238066c5de7f1c$var$Uue extends $d7238066c5de7f1c$var$_D {
    /**
   * Constructs a new standard node library.
   */ constructor(){
        super(), this.addMaterial($d7238066c5de7f1c$var$Xne, "MeshPhongMaterial"), this.addMaterial($d7238066c5de7f1c$var$BY, "MeshStandardMaterial"), this.addMaterial($d7238066c5de7f1c$var$Sse, "MeshPhysicalMaterial"), this.addMaterial($d7238066c5de7f1c$var$wse, "MeshToonMaterial"), this.addMaterial($d7238066c5de7f1c$var$Sne, "MeshBasicMaterial"), this.addMaterial($d7238066c5de7f1c$var$Wne, "MeshLambertMaterial"), this.addMaterial($d7238066c5de7f1c$var$yne, "MeshNormalMaterial"), this.addMaterial($d7238066c5de7f1c$var$Hse, "MeshMatcapMaterial"), this.addMaterial($d7238066c5de7f1c$var$dne, "LineBasicMaterial"), this.addMaterial($d7238066c5de7f1c$var$Cne, "LineDashedMaterial"), this.addMaterial($d7238066c5de7f1c$var$Kse, "PointsMaterial"), this.addMaterial($d7238066c5de7f1c$var$PU, "SpriteMaterial"), this.addMaterial($d7238066c5de7f1c$var$Mse, "ShadowMaterial"), this.addLight($d7238066c5de7f1c$var$uge, $d7238066c5de7f1c$var$yee), this.addLight($d7238066c5de7f1c$var$Bce, $d7238066c5de7f1c$var$fee), this.addLight($d7238066c5de7f1c$var$fce, $d7238066c5de7f1c$var$vee), this.addLight($d7238066c5de7f1c$var$xY, $d7238066c5de7f1c$var$IL), this.addLight($d7238066c5de7f1c$var$Zce, $d7238066c5de7f1c$var$Gee), this.addLight($d7238066c5de7f1c$var$Rce, $d7238066c5de7f1c$var$mee), this.addLight($d7238066c5de7f1c$var$Vce, $d7238066c5de7f1c$var$Zee), this.addLight($d7238066c5de7f1c$var$Gce, $d7238066c5de7f1c$var$Eue), this.addLight($d7238066c5de7f1c$var$Sce, $d7238066c5de7f1c$var$Jue), this.addToneMapping($d7238066c5de7f1c$var$uD, $d7238066c5de7f1c$var$T6), this.addToneMapping($d7238066c5de7f1c$var$ID, $d7238066c5de7f1c$var$M6), this.addToneMapping($d7238066c5de7f1c$var$dD, $d7238066c5de7f1c$var$z6), this.addToneMapping($d7238066c5de7f1c$var$hD, $d7238066c5de7f1c$var$k6), this.addToneMapping($d7238066c5de7f1c$var$CD, $d7238066c5de7f1c$var$E6), this.addToneMapping($d7238066c5de7f1c$var$pD, $d7238066c5de7f1c$var$J6);
    }
}
class $d7238066c5de7f1c$var$Due extends $d7238066c5de7f1c$var$Pce {
    /**
   * WebGPURenderer options.
   *
   * @typedef {Object} WebGPURenderer~Options
   * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
   * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
   * @property {boolean} [multiview=false] - If set to `true`, the renderer will use multiview during WebXR rendering if supported.
   * @property {number} [outputType=undefined] - Texture type for output to canvas. By default, device's preferred format is used; other formats may incur overhead.
   * @property {number} [colorBufferType=HalfFloatType] - Defines the type of color buffers. The default `HalfFloatType` is recommend for best
   * quality. To save memory and bandwidth, `UnsignedByteType` might be used. This will reduce rendering quality though.
   */ /**
   * Constructs a new WebGPU renderer.
   *
   * @param {WebGPURenderer~Options} [parameters] - The configuration parameter.
   */ constructor(e = {}){
        let t;
        e.forceWebGL ? t = $d7238066c5de7f1c$var$D9 : (t = $d7238066c5de7f1c$var$kue, e.getFallback = ()=>($d7238066c5de7f1c$var$ze("WebGPURenderer: WebGPU is not available, running under WebGL2 backend."), new $d7238066c5de7f1c$var$D9(e)));
        const i = new t(e);
        super(i, e), this.library = new $d7238066c5de7f1c$var$Uue(), this.isWebGPURenderer = !0, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
}
const $d7238066c5de7f1c$var$zH = /* @__PURE__ */ new WeakMap();
class $d7238066c5de7f1c$var$_ue extends (0, $329ek.Loader) {
    /**
   * Constructs a new Draco loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(e){
        super(e), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    /**
   * Provides configuration for the decoder libraries. Configuration cannot be changed after decoding begins.
   *
   * @param {string} path - The decoder path.
   * @return {DRACOLoader} A reference to this loader.
   */ setDecoderPath(e) {
        return this.decoderPath = e, this;
    }
    /**
   * Provides configuration for the decoder libraries. Configuration cannot be changed after decoding begins.
   *
   * @param {{type:('js'|'wasm')}} config - The decoder config.
   * @return {DRACOLoader} A reference to this loader.
   */ setDecoderConfig(e) {
        return this.decoderConfig = e, this;
    }
    /**
   * Sets the maximum number of Web Workers to be used during decoding.
   * A lower limit may be preferable if workers are also for other tasks in the application.
   *
   * @param {number} workerLimit - The worker limit.
   * @return {DRACOLoader} A reference to this loader.
   */ setWorkerLimit(e) {
        return this.workerLimit = e, this;
    }
    /**
   * Starts loading from the given URL and passes the loaded Draco asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ load(e, t, i, n) {
        const s = new (0, $329ek.FileLoader)(this.manager);
        s.setPath(this.path), s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(e, (a)=>{
            this.parse(a, t, n);
        }, i, n);
    }
    /**
   * Parses the given Draco data.
   *
   * @param {ArrayBuffer} buffer - The raw Draco data as an array buffer.
   * @param {function(BufferGeometry)} onLoad - Executed when the loading/parsing process has been finished.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ parse(e, t, i = ()=>{}) {
        this.decodeDracoFile(e, t, null, null, (0, $329ek.SRGBColorSpace), i).catch(i);
    }
    //
    decodeDracoFile(e, t, i, n, s = (0, $329ek.LinearSRGBColorSpace), a = ()=>{}) {
        const o = {
            attributeIDs: i || this.defaultAttributeIDs,
            attributeTypes: n || this.defaultAttributeTypes,
            useUniqueIDs: !!i,
            vertexColorSpace: s
        };
        return this.decodeGeometry(e, o).then(t).catch(a);
    }
    decodeGeometry(e, t) {
        const i = JSON.stringify(t);
        if ($d7238066c5de7f1c$var$zH.has(e)) {
            const g = $d7238066c5de7f1c$var$zH.get(e);
            if (g.key === i) return g.promise;
            if (e.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let n;
        const s = this.workerNextTaskID++, a = e.byteLength, o = this._getWorker(s, a).then((g)=>(n = g, new Promise((l, c)=>{
                n._callbacks[s] = {
                    resolve: l,
                    reject: c
                }, n.postMessage({
                    type: "decode",
                    id: s,
                    taskConfig: t,
                    buffer: e
                }, [
                    e
                ]);
            }))).then((g)=>this._createGeometry(g.geometry));
        return o.catch(()=>!0).then(()=>{
            n && s && this._releaseTask(n, s);
        }), $d7238066c5de7f1c$var$zH.set(e, {
            key: i,
            promise: o
        }), o;
    }
    _createGeometry(e) {
        const t = new (0, $329ek.BufferGeometry)();
        e.index && t.setIndex(new (0, $329ek.BufferAttribute)(e.index.array, 1));
        for(let i = 0; i < e.attributes.length; i++){
            const { name: n, array: s, itemSize: a, stride: o, vertexColorSpace: g } = e.attributes[i];
            let l;
            if (a === o) l = new (0, $329ek.BufferAttribute)(s, a);
            else {
                const c = new (0, $329ek.InterleavedBuffer)(s, o);
                l = new (0, $329ek.InterleavedBufferAttribute)(c, a, 0);
            }
            n === "color" && (this._assignVertexColorSpace(l, g), l.normalized = !(s instanceof Float32Array)), t.setAttribute(n, l);
        }
        return t;
    }
    _assignVertexColorSpace(e, t) {
        if (t !== (0, $329ek.SRGBColorSpace)) return;
        const i = new (0, $329ek.Color)();
        for(let n = 0, s = e.count; n < s; n++)i.fromBufferAttribute(e, n), (0, $329ek.ColorManagement).colorSpaceToWorking(i, (0, $329ek.SRGBColorSpace)), e.setXYZ(n, i.r, i.g, i.b);
    }
    _loadLibrary(e, t) {
        const i = new (0, $329ek.FileLoader)(this.manager);
        return i.setPath(this.decoderPath), i.setResponseType(t), i.setWithCredentials(this.withCredentials), new Promise((n, s)=>{
            i.load(e, n, void 0, s);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const e = typeof WebAssembly != "object" || this.decoderConfig.type === "js", t = [];
        return e ? t.push(this._loadLibrary("draco_decoder.js", "text")) : (t.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), t.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(t).then((i)=>{
            const n = i[0];
            e || (this.decoderConfig.wasmBinary = i[1]);
            const s = $d7238066c5de7f1c$var$Pue.toString(), a = [
                "/* draco decoder */",
                n,
                "",
                "/* worker */",
                s.substring(s.indexOf("{") + 1, s.lastIndexOf("}"))
            ].join(`
`);
            this.workerSourceURL = URL.createObjectURL(new Blob([
                a
            ]));
        }), this.decoderPending;
    }
    _getWorker(e, t) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const n = new Worker(this.workerSourceURL);
                n._callbacks = {}, n._taskCosts = {}, n._taskLoad = 0, n.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), n.onmessage = function(s) {
                    const a = s.data;
                    switch(a.type){
                        case "decode":
                            n._callbacks[a.id].resolve(a);
                            break;
                        case "error":
                            n._callbacks[a.id].reject(a);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + a.type + '"');
                    }
                }, this.workerPool.push(n);
            } else this.workerPool.sort(function(n, s) {
                return n._taskLoad > s._taskLoad ? -1 : 1;
            });
            const i = this.workerPool[this.workerPool.length - 1];
            return i._taskCosts[e] = t, i._taskLoad += t, i;
        });
    }
    _releaseTask(e, t) {
        e._taskLoad -= e._taskCosts[t], delete e._callbacks[t], delete e._taskCosts[t];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((e)=>e._taskLoad));
    }
    dispose() {
        for(let e = 0; e < this.workerPool.length; ++e)this.workerPool[e].terminate();
        return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
    }
}
function $d7238066c5de7f1c$var$Pue() {
    let r, e;
    onmessage = function(a) {
        const o = a.data;
        switch(o.type){
            case "init":
                r = o.decoderConfig, e = new Promise(function(c) {
                    r.onModuleLoaded = function(d) {
                        c({
                            draco: d
                        });
                    }, DracoDecoderModule(r);
                });
                break;
            case "decode":
                const g = o.buffer, l = o.taskConfig;
                e.then((c)=>{
                    const d = c.draco, p = new d.Decoder();
                    try {
                        const A = t(d, p, new Int8Array(g), l), y = A.attributes.map((G)=>G.array.buffer);
                        A.index && y.push(A.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: o.id,
                            geometry: A
                        }, y);
                    } catch (A) {
                        console.error(A), self.postMessage({
                            type: "error",
                            id: o.id,
                            error: A.message
                        });
                    } finally{
                        d.destroy(p);
                    }
                });
                break;
        }
    };
    function t(a, o, g, l) {
        const c = l.attributeIDs, d = l.attributeTypes;
        let p, A;
        const y = o.GetEncodedGeometryType(g);
        if (y === a.TRIANGULAR_MESH) p = new a.Mesh(), A = o.DecodeArrayToMesh(g, g.byteLength, p);
        else if (y === a.POINT_CLOUD) p = new a.PointCloud(), A = o.DecodeArrayToPointCloud(g, g.byteLength, p);
        else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!A.ok() || p.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + A.error_msg());
        const G = {
            index: null,
            attributes: []
        };
        for(const Z in c){
            const v = self[d[Z]];
            let V, H;
            if (l.useUniqueIDs) H = c[Z], V = o.GetAttributeByUniqueId(p, H);
            else {
                if (H = o.GetAttributeId(p, a[c[Z]]), H === -1) continue;
                V = o.GetAttribute(p, H);
            }
            const N = n(a, o, p, Z, v, V);
            Z === "color" && (N.vertexColorSpace = l.vertexColorSpace), G.attributes.push(N);
        }
        return y === a.TRIANGULAR_MESH && (G.index = i(a, o, p)), a.destroy(p), G;
    }
    function i(a, o, g) {
        const c = g.num_faces() * 3, d = c * 4, p = a._malloc(d);
        o.GetTrianglesUInt32Array(g, d, p);
        const A = new Uint32Array(a.HEAPF32.buffer, p, c).slice();
        return a._free(p), {
            array: A,
            itemSize: 1
        };
    }
    function n(a, o, g, l, c, d) {
        const p = g.num_points(), A = d.num_components(), y = s(a, c), G = A * c.BYTES_PER_ELEMENT, Z = Math.ceil(G / 4) * 4, v = Z / c.BYTES_PER_ELEMENT, V = p * G, H = p * Z, N = a._malloc(V);
        o.GetAttributeDataArrayForAllPoints(g, d, y, V, N);
        const Y = new c(a.HEAPF32.buffer, N, V / c.BYTES_PER_ELEMENT);
        let K;
        if (G === Z) K = Y.slice();
        else {
            K = new c(H / c.BYTES_PER_ELEMENT);
            let z = 0;
            for(let M = 0, _ = Y.length; M < _; M++){
                for(let O = 0; O < A; O++)K[z + O] = Y[M * A + O];
                z += v;
            }
        }
        return a._free(N), {
            name: l,
            count: p,
            itemSize: A,
            array: K,
            stride: v
        };
    }
    function s(a, o) {
        switch(o){
            case Float32Array:
                return a.DT_FLOAT32;
            case Int8Array:
                return a.DT_INT8;
            case Int16Array:
                return a.DT_INT16;
            case Int32Array:
                return a.DT_INT32;
            case Uint8Array:
                return a.DT_UINT8;
            case Uint16Array:
                return a.DT_UINT16;
            case Uint32Array:
                return a.DT_UINT32;
        }
    }
}
function $d7238066c5de7f1c$var$nT(r, e) {
    if (e === (0, $329ek.TrianglesDrawMode)) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), r;
    if (e === (0, $329ek.TriangleFanDrawMode) || e === (0, $329ek.TriangleStripDrawMode)) {
        let t = r.getIndex();
        if (t === null) {
            const a = [], o = r.getAttribute("position");
            if (o !== void 0) {
                for(let g = 0; g < o.count; g++)a.push(g);
                r.setIndex(a), t = r.getIndex();
            } else return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), r;
        }
        const i = t.count - 2, n = [];
        if (e === (0, $329ek.TriangleFanDrawMode)) for(let a = 1; a <= i; a++)n.push(t.getX(0)), n.push(t.getX(a)), n.push(t.getX(a + 1));
        else for(let a = 0; a < i; a++)a % 2 === 0 ? (n.push(t.getX(a)), n.push(t.getX(a + 1)), n.push(t.getX(a + 2))) : (n.push(t.getX(a + 2)), n.push(t.getX(a + 1)), n.push(t.getX(a)));
        n.length / 3 !== i && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const s = r.clone();
        return s.setIndex(n), s.clearGroups(), s;
    } else return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), r;
}
class $d7238066c5de7f1c$var$Que extends (0, $329ek.Loader) {
    /**
   * Constructs a new glTF loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(e){
        super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t) {
            return new $d7238066c5de7f1c$var$eIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$tIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$cIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$uIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$IIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$nIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$sIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$rIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$aIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$$ue(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$oIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$iIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$lIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$gIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$jue(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$dIe(t);
        }), this.register(function(t) {
            return new $d7238066c5de7f1c$var$hIe(t);
        });
    }
    /**
   * Starts loading from the given URL and passes the loaded glTF asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ load(e, t, i, n) {
        const s = this;
        let a;
        if (this.resourcePath !== "") a = this.resourcePath;
        else if (this.path !== "") {
            const l = (0, $329ek.LoaderUtils).extractUrlBase(e);
            a = (0, $329ek.LoaderUtils).resolveURL(l, this.path);
        } else a = (0, $329ek.LoaderUtils).extractUrlBase(e);
        this.manager.itemStart(e);
        const o = function(l) {
            n ? n(l) : console.error(l), s.manager.itemError(e), s.manager.itemEnd(e);
        }, g = new (0, $329ek.FileLoader)(this.manager);
        g.setPath(this.path), g.setResponseType("arraybuffer"), g.setRequestHeader(this.requestHeader), g.setWithCredentials(this.withCredentials), g.load(e, function(l) {
            try {
                s.parse(l, a, function(c) {
                    t(c), s.manager.itemEnd(e);
                }, o);
            } catch (c) {
                o(c);
            }
        }, i, o);
    }
    /**
   * Sets the given Draco loader to this loader. Required for decoding assets
   * compressed with the `KHR_draco_mesh_compression` extension.
   *
   * @param {DRACOLoader} dracoLoader - The Draco loader to set.
   * @return {GLTFLoader} A reference to this loader.
   */ setDRACOLoader(e) {
        return this.dracoLoader = e, this;
    }
    /**
   * Sets the given KTX2 loader to this loader. Required for loading KTX2
   * compressed textures.
   *
   * @param {KTX2Loader} ktx2Loader - The KTX2 loader to set.
   * @return {GLTFLoader} A reference to this loader.
   */ setKTX2Loader(e) {
        return this.ktx2Loader = e, this;
    }
    /**
   * Sets the given meshopt decoder. Required for decoding assets
   * compressed with the `EXT_meshopt_compression` extension.
   *
   * @param {Object} meshoptDecoder - The meshopt decoder to set.
   * @return {GLTFLoader} A reference to this loader.
   */ setMeshoptDecoder(e) {
        return this.meshoptDecoder = e, this;
    }
    /**
   * Registers a plugin callback. This API is internally used to implement the various
   * glTF extensions but can also used by third-party code to add additional logic
   * to the loader.
   *
   * @param {function(parser:GLTFParser)} callback - The callback function to register.
   * @return {GLTFLoader} A reference to this loader.
   */ register(e) {
        return this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e), this;
    }
    /**
   * Unregisters a plugin callback.
   *
   * @param {Function} callback - The callback function to unregister.
   * @return {GLTFLoader} A reference to this loader.
   */ unregister(e) {
        return this.pluginCallbacks.indexOf(e) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
    }
    /**
   * Parses the given FBX data and returns the resulting group.
   *
   * @param {string|ArrayBuffer} data - The raw glTF data.
   * @param {string} path - The URL base path.
   * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ parse(e, t, i, n) {
        let s;
        const a = {}, o = {}, g = new TextDecoder();
        if (typeof e == "string") s = JSON.parse(e);
        else if (e instanceof ArrayBuffer) {
            if (g.decode(new Uint8Array(e, 0, 4)) === $d7238066c5de7f1c$var$r_) {
                try {
                    a[$d7238066c5de7f1c$var$Ti.KHR_BINARY_GLTF] = new $d7238066c5de7f1c$var$CIe(e);
                } catch (d) {
                    n && n(d);
                    return;
                }
                s = JSON.parse(a[$d7238066c5de7f1c$var$Ti.KHR_BINARY_GLTF].content);
            } else s = JSON.parse(g.decode(e));
        } else s = e;
        if (s.asset === void 0 || s.asset.version[0] < 2) {
            n && n(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const l = new $d7238066c5de7f1c$var$VIe(s, {
            path: t || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        l.fileLoader.setRequestHeader(this.requestHeader);
        for(let c = 0; c < this.pluginCallbacks.length; c++){
            const d = this.pluginCallbacks[c](l);
            d.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), o[d.name] = d, a[d.name] = !0;
        }
        if (s.extensionsUsed) for(let c = 0; c < s.extensionsUsed.length; ++c){
            const d = s.extensionsUsed[c], p = s.extensionsRequired || [];
            switch(d){
                case $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_UNLIT:
                    a[d] = new $d7238066c5de7f1c$var$que();
                    break;
                case $d7238066c5de7f1c$var$Ti.KHR_DRACO_MESH_COMPRESSION:
                    a[d] = new $d7238066c5de7f1c$var$pIe(s, this.dracoLoader);
                    break;
                case $d7238066c5de7f1c$var$Ti.KHR_TEXTURE_TRANSFORM:
                    a[d] = new $d7238066c5de7f1c$var$mIe();
                    break;
                case $d7238066c5de7f1c$var$Ti.KHR_MESH_QUANTIZATION:
                    a[d] = new $d7238066c5de7f1c$var$AIe();
                    break;
                default:
                    p.indexOf(d) >= 0 && o[d] === void 0 && console.warn('THREE.GLTFLoader: Unknown extension "' + d + '".');
            }
        }
        l.setExtensions(a), l.setPlugins(o), l.parse(i, n);
    }
    /**
   * Async version of {@link GLTFLoader#parse}.
   *
   * @async
   * @param {string|ArrayBuffer} data - The raw glTF data.
   * @param {string} path - The URL base path.
   * @return {Promise<GLTFLoader~LoadObject>} A Promise that resolves with the loaded glTF when the parsing has been finished.
   */ parseAsync(e, t) {
        const i = this;
        return new Promise(function(n, s) {
            i.parse(e, t, n, s);
        });
    }
}
function $d7238066c5de7f1c$var$Oue() {
    let r = {};
    return {
        get: function(e) {
            return r[e];
        },
        add: function(e, t) {
            r[e] = t;
        },
        remove: function(e) {
            delete r[e];
        },
        removeAll: function() {
            r = {};
        }
    };
}
const $d7238066c5de7f1c$var$Ti = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_MATERIALS_BUMP: "EXT_materials_bump",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class $d7238066c5de7f1c$var$jue {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_LIGHTS_PUNCTUAL, this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const e = this.parser, t = this.parser.json.nodes || [];
        for(let i = 0, n = t.length; i < n; i++){
            const s = t[i];
            s.extensions && s.extensions[this.name] && s.extensions[this.name].light !== void 0 && e._addNodeRef(this.cache, s.extensions[this.name].light);
        }
    }
    _loadLight(e) {
        const t = this.parser, i = "light:" + e;
        let n = t.cache.get(i);
        if (n) return n;
        const s = t.json, g = ((s.extensions && s.extensions[this.name] || {}).lights || [])[e];
        let l;
        const c = new (0, $329ek.Color)(16777215);
        g.color !== void 0 && c.setRGB(g.color[0], g.color[1], g.color[2], (0, $329ek.LinearSRGBColorSpace));
        const d = g.range !== void 0 ? g.range : 0;
        switch(g.type){
            case "directional":
                l = new (0, $329ek.DirectionalLight)(c), l.target.position.set(0, 0, -1), l.add(l.target);
                break;
            case "point":
                l = new (0, $329ek.PointLight)(c), l.distance = d;
                break;
            case "spot":
                l = new (0, $329ek.SpotLight)(c), l.distance = d, g.spot = g.spot || {}, g.spot.innerConeAngle = g.spot.innerConeAngle !== void 0 ? g.spot.innerConeAngle : 0, g.spot.outerConeAngle = g.spot.outerConeAngle !== void 0 ? g.spot.outerConeAngle : Math.PI / 4, l.angle = g.spot.outerConeAngle, l.penumbra = 1 - g.spot.innerConeAngle / g.spot.outerConeAngle, l.target.position.set(0, 0, -1), l.add(l.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + g.type);
        }
        return l.position.set(0, 0, 0), $d7238066c5de7f1c$var$Ec(l, g), g.intensity !== void 0 && (l.intensity = g.intensity), l.name = t.createUniqueName(g.name || "light_" + e), n = Promise.resolve(l), t.cache.add(i, n), n;
    }
    getDependency(e, t) {
        if (e === "light") return this._loadLight(t);
    }
    createNodeAttachment(e) {
        const t = this, i = this.parser, s = i.json.nodes[e], o = (s.extensions && s.extensions[this.name] || {}).light;
        return o === void 0 ? null : this._loadLight(o).then(function(g) {
            return i._getNodeRef(t.cache, o, g);
        });
    }
}
class $d7238066c5de7f1c$var$que {
    constructor(){
        this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $329ek.MeshBasicMaterial;
    }
    extendParams(e, t, i) {
        const n = [];
        e.color = new (0, $329ek.Color)(1, 1, 1), e.opacity = 1;
        const s = t.pbrMetallicRoughness;
        if (s) {
            if (Array.isArray(s.baseColorFactor)) {
                const a = s.baseColorFactor;
                e.color.setRGB(a[0], a[1], a[2], (0, $329ek.LinearSRGBColorSpace)), e.opacity = a[3];
            }
            s.baseColorTexture !== void 0 && n.push(i.assignTexture(e, "map", s.baseColorTexture, (0, $329ek.SRGBColorSpace)));
        }
        return Promise.all(n);
    }
}
class $d7238066c5de7f1c$var$$ue {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(e, t) {
        const n = this.parser.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = n.extensions[this.name].emissiveStrength;
        return s !== void 0 && (t.emissiveIntensity = s), Promise.resolve();
    }
}
class $d7238066c5de7f1c$var$eIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        if (a.clearcoatFactor !== void 0 && (t.clearcoat = a.clearcoatFactor), a.clearcoatTexture !== void 0 && s.push(i.assignTexture(t, "clearcoatMap", a.clearcoatTexture)), a.clearcoatRoughnessFactor !== void 0 && (t.clearcoatRoughness = a.clearcoatRoughnessFactor), a.clearcoatRoughnessTexture !== void 0 && s.push(i.assignTexture(t, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), a.clearcoatNormalTexture !== void 0 && (s.push(i.assignTexture(t, "clearcoatNormalMap", a.clearcoatNormalTexture)), a.clearcoatNormalTexture.scale !== void 0)) {
            const o = a.clearcoatNormalTexture.scale;
            t.clearcoatNormalScale = new (0, $329ek.Vector2)(o, o);
        }
        return Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$tIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const n = this.parser.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = n.extensions[this.name];
        return t.dispersion = s.dispersion !== void 0 ? s.dispersion : 0, Promise.resolve();
    }
}
class $d7238066c5de7f1c$var$iIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        return a.iridescenceFactor !== void 0 && (t.iridescence = a.iridescenceFactor), a.iridescenceTexture !== void 0 && s.push(i.assignTexture(t, "iridescenceMap", a.iridescenceTexture)), a.iridescenceIor !== void 0 && (t.iridescenceIOR = a.iridescenceIor), t.iridescenceThicknessRange === void 0 && (t.iridescenceThicknessRange = [
            100,
            400
        ]), a.iridescenceThicknessMinimum !== void 0 && (t.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), a.iridescenceThicknessMaximum !== void 0 && (t.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), a.iridescenceThicknessTexture !== void 0 && s.push(i.assignTexture(t, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$nIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [];
        t.sheenColor = new (0, $329ek.Color)(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
        const a = n.extensions[this.name];
        if (a.sheenColorFactor !== void 0) {
            const o = a.sheenColorFactor;
            t.sheenColor.setRGB(o[0], o[1], o[2], (0, $329ek.LinearSRGBColorSpace));
        }
        return a.sheenRoughnessFactor !== void 0 && (t.sheenRoughness = a.sheenRoughnessFactor), a.sheenColorTexture !== void 0 && s.push(i.assignTexture(t, "sheenColorMap", a.sheenColorTexture, (0, $329ek.SRGBColorSpace))), a.sheenRoughnessTexture !== void 0 && s.push(i.assignTexture(t, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$sIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        return a.transmissionFactor !== void 0 && (t.transmission = a.transmissionFactor), a.transmissionTexture !== void 0 && s.push(i.assignTexture(t, "transmissionMap", a.transmissionTexture)), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$rIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        t.thickness = a.thicknessFactor !== void 0 ? a.thicknessFactor : 0, a.thicknessTexture !== void 0 && s.push(i.assignTexture(t, "thicknessMap", a.thicknessTexture)), t.attenuationDistance = a.attenuationDistance || 1 / 0;
        const o = a.attenuationColor || [
            1,
            1,
            1
        ];
        return t.attenuationColor = new (0, $329ek.Color)().setRGB(o[0], o[1], o[2], (0, $329ek.LinearSRGBColorSpace)), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$aIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_IOR;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const n = this.parser.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = n.extensions[this.name];
        return t.ior = s.ior !== void 0 ? s.ior : 1.5, Promise.resolve();
    }
}
class $d7238066c5de7f1c$var$oIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        t.specularIntensity = a.specularFactor !== void 0 ? a.specularFactor : 1, a.specularTexture !== void 0 && s.push(i.assignTexture(t, "specularIntensityMap", a.specularTexture));
        const o = a.specularColorFactor || [
            1,
            1,
            1
        ];
        return t.specularColor = new (0, $329ek.Color)().setRGB(o[0], o[1], o[2], (0, $329ek.LinearSRGBColorSpace)), a.specularColorTexture !== void 0 && s.push(i.assignTexture(t, "specularColorMap", a.specularColorTexture, (0, $329ek.SRGBColorSpace))), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$gIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.EXT_MATERIALS_BUMP;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        return t.bumpScale = a.bumpFactor !== void 0 ? a.bumpFactor : 1, a.bumpTexture !== void 0 && s.push(i.assignTexture(t, "bumpMap", a.bumpTexture)), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$lIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(e) {
        const i = this.parser.json.materials[e];
        return !i.extensions || !i.extensions[this.name] ? null : (0, $329ek.MeshPhysicalMaterial);
    }
    extendMaterialParams(e, t) {
        const i = this.parser, n = i.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const s = [], a = n.extensions[this.name];
        return a.anisotropyStrength !== void 0 && (t.anisotropy = a.anisotropyStrength), a.anisotropyRotation !== void 0 && (t.anisotropyRotation = a.anisotropyRotation), a.anisotropyTexture !== void 0 && s.push(i.assignTexture(t, "anisotropyMap", a.anisotropyTexture)), Promise.all(s);
    }
}
class $d7238066c5de7f1c$var$cIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.KHR_TEXTURE_BASISU;
    }
    loadTexture(e) {
        const t = this.parser, i = t.json, n = i.textures[e];
        if (!n.extensions || !n.extensions[this.name]) return null;
        const s = n.extensions[this.name], a = t.options.ktx2Loader;
        if (!a) {
            if (i.extensionsRequired && i.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            return null;
        }
        return t.loadTextureImage(e, s.source, a);
    }
}
class $d7238066c5de7f1c$var$uIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.EXT_TEXTURE_WEBP;
    }
    loadTexture(e) {
        const t = this.name, i = this.parser, n = i.json, s = n.textures[e];
        if (!s.extensions || !s.extensions[t]) return null;
        const a = s.extensions[t], o = n.images[a.source];
        let g = i.textureLoader;
        if (o.uri) {
            const l = i.options.manager.getHandler(o.uri);
            l !== null && (g = l);
        }
        return i.loadTextureImage(e, a.source, g);
    }
}
class $d7238066c5de7f1c$var$IIe {
    constructor(e){
        this.parser = e, this.name = $d7238066c5de7f1c$var$Ti.EXT_TEXTURE_AVIF;
    }
    loadTexture(e) {
        const t = this.name, i = this.parser, n = i.json, s = n.textures[e];
        if (!s.extensions || !s.extensions[t]) return null;
        const a = s.extensions[t], o = n.images[a.source];
        let g = i.textureLoader;
        if (o.uri) {
            const l = i.options.manager.getHandler(o.uri);
            l !== null && (g = l);
        }
        return i.loadTextureImage(e, a.source, g);
    }
}
class $d7238066c5de7f1c$var$dIe {
    constructor(e){
        this.name = $d7238066c5de7f1c$var$Ti.EXT_MESHOPT_COMPRESSION, this.parser = e;
    }
    loadBufferView(e) {
        const t = this.parser.json, i = t.bufferViews[e];
        if (i.extensions && i.extensions[this.name]) {
            const n = i.extensions[this.name], s = this.parser.getDependency("buffer", n.buffer), a = this.parser.options.meshoptDecoder;
            if (!a || !a.supported) {
                if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                return null;
            }
            return s.then(function(o) {
                const g = n.byteOffset || 0, l = n.byteLength || 0, c = n.count, d = n.byteStride, p = new Uint8Array(o, g, l);
                return a.decodeGltfBufferAsync ? a.decodeGltfBufferAsync(c, d, p, n.mode, n.filter).then(function(A) {
                    return A.buffer;
                }) : a.ready.then(function() {
                    const A = new ArrayBuffer(c * d);
                    return a.decodeGltfBuffer(new Uint8Array(A), c, d, p, n.mode, n.filter), A;
                });
            });
        } else return null;
    }
}
class $d7238066c5de7f1c$var$hIe {
    constructor(e){
        this.name = $d7238066c5de7f1c$var$Ti.EXT_MESH_GPU_INSTANCING, this.parser = e;
    }
    createNodeMesh(e) {
        const t = this.parser.json, i = t.nodes[e];
        if (!i.extensions || !i.extensions[this.name] || i.mesh === void 0) return null;
        const n = t.meshes[i.mesh];
        for (const l of n.primitives)if (l.mode !== $d7238066c5de7f1c$var$Eg.TRIANGLES && l.mode !== $d7238066c5de7f1c$var$Eg.TRIANGLE_STRIP && l.mode !== $d7238066c5de7f1c$var$Eg.TRIANGLE_FAN && l.mode !== void 0) return null;
        const a = i.extensions[this.name].attributes, o = [], g = {};
        for(const l in a)o.push(this.parser.getDependency("accessor", a[l]).then((c)=>(g[l] = c, g[l])));
        return o.length < 1 ? null : (o.push(this.parser.createNodeMesh(e)), Promise.all(o).then((l)=>{
            const c = l.pop(), d = c.isGroup ? c.children : [
                c
            ], p = l[0].count, A = [];
            for (const y of d){
                const G = new (0, $329ek.Matrix4)(), Z = new (0, $329ek.Vector3)(), v = new (0, $329ek.Quaternion)(), V = new (0, $329ek.Vector3)(1, 1, 1), H = new (0, $329ek.InstancedMesh)(y.geometry, y.material, p);
                for(let N = 0; N < p; N++)g.TRANSLATION && Z.fromBufferAttribute(g.TRANSLATION, N), g.ROTATION && v.fromBufferAttribute(g.ROTATION, N), g.SCALE && V.fromBufferAttribute(g.SCALE, N), H.setMatrixAt(N, G.compose(Z, v, V));
                for(const N in g)if (N === "_COLOR_0") {
                    const Y = g[N];
                    H.instanceColor = new (0, $329ek.InstancedBufferAttribute)(Y.array, Y.itemSize, Y.normalized);
                } else N !== "TRANSLATION" && N !== "ROTATION" && N !== "SCALE" && y.geometry.setAttribute(N, g[N]);
                (0, $329ek.Object3D).prototype.copy.call(H, y), this.parser.assignFinalMaterial(H), A.push(H);
            }
            return c.isGroup ? (c.clear(), c.add(...A), c) : A[0];
        }));
    }
}
const $d7238066c5de7f1c$var$r_ = "glTF", $d7238066c5de7f1c$var$jb = 12, $d7238066c5de7f1c$var$sT = {
    JSON: 1313821514,
    BIN: 5130562
};
class $d7238066c5de7f1c$var$CIe {
    constructor(e){
        this.name = $d7238066c5de7f1c$var$Ti.KHR_BINARY_GLTF, this.content = null, this.body = null;
        const t = new DataView(e, 0, $d7238066c5de7f1c$var$jb), i = new TextDecoder();
        if (this.header = {
            magic: i.decode(new Uint8Array(e.slice(0, 4))),
            version: t.getUint32(4, !0),
            length: t.getUint32(8, !0)
        }, this.header.magic !== $d7238066c5de7f1c$var$r_) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const n = this.header.length - $d7238066c5de7f1c$var$jb, s = new DataView(e, $d7238066c5de7f1c$var$jb);
        let a = 0;
        for(; a < n;){
            const o = s.getUint32(a, !0);
            a += 4;
            const g = s.getUint32(a, !0);
            if (a += 4, g === $d7238066c5de7f1c$var$sT.JSON) {
                const l = new Uint8Array(e, $d7238066c5de7f1c$var$jb + a, o);
                this.content = i.decode(l);
            } else if (g === $d7238066c5de7f1c$var$sT.BIN) {
                const l = $d7238066c5de7f1c$var$jb + a;
                this.body = e.slice(l, l + o);
            }
            a += o;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
class $d7238066c5de7f1c$var$pIe {
    constructor(e, t){
        if (!t) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $d7238066c5de7f1c$var$Ti.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = t, this.dracoLoader.preload();
    }
    decodePrimitive(e, t) {
        const i = this.json, n = this.dracoLoader, s = e.extensions[this.name].bufferView, a = e.extensions[this.name].attributes, o = {}, g = {}, l = {};
        for(const c in a){
            const d = $d7238066c5de7f1c$var$Q2[c] || c.toLowerCase();
            o[d] = a[c];
        }
        for(const c in e.attributes){
            const d = $d7238066c5de7f1c$var$Q2[c] || c.toLowerCase();
            if (a[c] !== void 0) {
                const p = i.accessors[e.attributes[c]], A = $d7238066c5de7f1c$var$WA[p.componentType];
                l[d] = A.name, g[d] = p.normalized === !0;
            }
        }
        return t.getDependency("bufferView", s).then(function(c) {
            return new Promise(function(d, p) {
                n.decodeDracoFile(c, function(A) {
                    for(const y in A.attributes){
                        const G = A.attributes[y], Z = g[y];
                        Z !== void 0 && (G.normalized = Z);
                    }
                    d(A);
                }, o, l, (0, $329ek.LinearSRGBColorSpace), p);
            });
        });
    }
}
class $d7238066c5de7f1c$var$mIe {
    constructor(){
        this.name = $d7238066c5de7f1c$var$Ti.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(e, t) {
        return (t.texCoord === void 0 || t.texCoord === e.channel) && t.offset === void 0 && t.rotation === void 0 && t.scale === void 0 || (e = e.clone(), t.texCoord !== void 0 && (e.channel = t.texCoord), t.offset !== void 0 && e.offset.fromArray(t.offset), t.rotation !== void 0 && (e.rotation = t.rotation), t.scale !== void 0 && e.repeat.fromArray(t.scale), e.needsUpdate = !0), e;
    }
}
class $d7238066c5de7f1c$var$AIe {
    constructor(){
        this.name = $d7238066c5de7f1c$var$Ti.KHR_MESH_QUANTIZATION;
    }
}
class $d7238066c5de7f1c$var$a_ extends (0, $329ek.Interpolant) {
    constructor(e, t, i, n){
        super(e, t, i, n);
    }
    copySampleValue_(e) {
        const t = this.resultBuffer, i = this.sampleValues, n = this.valueSize, s = e * n * 3 + n;
        for(let a = 0; a !== n; a++)t[a] = i[s + a];
        return t;
    }
    interpolate_(e, t, i, n) {
        const s = this.resultBuffer, a = this.sampleValues, o = this.valueSize, g = o * 2, l = o * 3, c = n - t, d = (i - t) / c, p = d * d, A = p * d, y = e * l, G = y - l, Z = -2 * A + 3 * p, v = A - p, V = 1 - Z, H = v - p + d;
        for(let N = 0; N !== o; N++){
            const Y = a[G + N + o], K = a[G + N + g] * c, z = a[y + N + o], M = a[y + N] * c;
            s[N] = V * Y + H * K + Z * z + v * M;
        }
        return s;
    }
}
const $d7238066c5de7f1c$var$bIe = new (0, $329ek.Quaternion)();
class $d7238066c5de7f1c$var$yIe extends $d7238066c5de7f1c$var$a_ {
    interpolate_(e, t, i, n) {
        const s = super.interpolate_(e, t, i, n);
        return $d7238066c5de7f1c$var$bIe.fromArray(s).normalize().toArray(s), s;
    }
}
const $d7238066c5de7f1c$var$Eg = {
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6
}, $d7238066c5de7f1c$var$WA = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
}, $d7238066c5de7f1c$var$rT = {
    9728: (0, $329ek.NearestFilter),
    9729: (0, $329ek.LinearFilter),
    9984: (0, $329ek.NearestMipmapNearestFilter),
    9985: (0, $329ek.LinearMipmapNearestFilter),
    9986: (0, $329ek.NearestMipmapLinearFilter),
    9987: (0, $329ek.LinearMipmapLinearFilter)
}, $d7238066c5de7f1c$var$aT = {
    33071: (0, $329ek.ClampToEdgeWrapping),
    33648: (0, $329ek.MirroredRepeatWrapping),
    10497: (0, $329ek.RepeatWrapping)
}, $d7238066c5de7f1c$var$kH = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
}, $d7238066c5de7f1c$var$Q2 = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
}, $d7238066c5de7f1c$var$Yd = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
}, $d7238066c5de7f1c$var$BIe = {
    CUBICSPLINE: void 0,
    // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $329ek.InterpolateLinear),
    STEP: (0, $329ek.InterpolateDiscrete)
}, $d7238066c5de7f1c$var$EH = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
function $d7238066c5de7f1c$var$fIe(r) {
    return r.DefaultMaterial === void 0 && (r.DefaultMaterial = new (0, $329ek.MeshStandardMaterial)({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: !1,
        depthTest: !0,
        side: (0, $329ek.FrontSide)
    })), r.DefaultMaterial;
}
function $d7238066c5de7f1c$var$dC(r, e, t) {
    for(const i in t.extensions)r[i] === void 0 && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[i] = t.extensions[i]);
}
function $d7238066c5de7f1c$var$Ec(r, e) {
    e.extras !== void 0 && (typeof e.extras == "object" ? Object.assign(r.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function $d7238066c5de7f1c$var$GIe(r, e, t) {
    let i = !1, n = !1, s = !1;
    for(let l = 0, c = e.length; l < c; l++){
        const d = e[l];
        if (d.POSITION !== void 0 && (i = !0), d.NORMAL !== void 0 && (n = !0), d.COLOR_0 !== void 0 && (s = !0), i && n && s) break;
    }
    if (!i && !n && !s) return Promise.resolve(r);
    const a = [], o = [], g = [];
    for(let l = 0, c = e.length; l < c; l++){
        const d = e[l];
        if (i) {
            const p = d.POSITION !== void 0 ? t.getDependency("accessor", d.POSITION) : r.attributes.position;
            a.push(p);
        }
        if (n) {
            const p = d.NORMAL !== void 0 ? t.getDependency("accessor", d.NORMAL) : r.attributes.normal;
            o.push(p);
        }
        if (s) {
            const p = d.COLOR_0 !== void 0 ? t.getDependency("accessor", d.COLOR_0) : r.attributes.color;
            g.push(p);
        }
    }
    return Promise.all([
        Promise.all(a),
        Promise.all(o),
        Promise.all(g)
    ]).then(function(l) {
        const c = l[0], d = l[1], p = l[2];
        return i && (r.morphAttributes.position = c), n && (r.morphAttributes.normal = d), s && (r.morphAttributes.color = p), r.morphTargetsRelative = !0, r;
    });
}
function $d7238066c5de7f1c$var$vIe(r, e) {
    if (r.updateMorphTargets(), e.weights !== void 0) for(let t = 0, i = e.weights.length; t < i; t++)r.morphTargetInfluences[t] = e.weights[t];
    if (e.extras && Array.isArray(e.extras.targetNames)) {
        const t = e.extras.targetNames;
        if (r.morphTargetInfluences.length === t.length) {
            r.morphTargetDictionary = {};
            for(let i = 0, n = t.length; i < n; i++)r.morphTargetDictionary[t[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $d7238066c5de7f1c$var$SIe(r) {
    let e;
    const t = r.extensions && r.extensions[$d7238066c5de7f1c$var$Ti.KHR_DRACO_MESH_COMPRESSION];
    if (t ? e = "draco:" + t.bufferView + ":" + t.indices + ":" + $d7238066c5de7f1c$var$JH(t.attributes) : e = r.indices + ":" + $d7238066c5de7f1c$var$JH(r.attributes) + ":" + r.mode, r.targets !== void 0) for(let i = 0, n = r.targets.length; i < n; i++)e += ":" + $d7238066c5de7f1c$var$JH(r.targets[i]);
    return e;
}
function $d7238066c5de7f1c$var$JH(r) {
    let e = "";
    const t = Object.keys(r).sort();
    for(let i = 0, n = t.length; i < n; i++)e += t[i] + ":" + r[t[i]] + ";";
    return e;
}
function $d7238066c5de7f1c$var$O2(r) {
    switch(r){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $d7238066c5de7f1c$var$ZIe(r) {
    return r.search(/\.jpe?g($|\?)/i) > 0 || r.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : r.search(/\.webp($|\?)/i) > 0 || r.search(/^data\:image\/webp/) === 0 ? "image/webp" : r.search(/\.ktx2($|\?)/i) > 0 || r.search(/^data\:image\/ktx2/) === 0 ? "image/ktx2" : "image/png";
}
const $d7238066c5de7f1c$var$RIe = new (0, $329ek.Matrix4)();
class $d7238066c5de7f1c$var$VIe {
    constructor(e = {}, t = {}){
        this.json = e, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new $d7238066c5de7f1c$var$Oue(), this.associations = /* @__PURE__ */ new Map(), this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
            refs: {},
            uses: {}
        }, this.cameraCache = {
            refs: {},
            uses: {}
        }, this.lightCache = {
            refs: {},
            uses: {}
        }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
        let i = !1, n = -1, s = !1, a = -1;
        if (typeof navigator < "u") {
            const o = navigator.userAgent;
            i = /^((?!chrome|android).)*safari/i.test(o) === !0;
            const g = o.match(/Version\/(\d+)/);
            n = i && g ? parseInt(g[1], 10) : -1, s = o.indexOf("Firefox") > -1, a = s ? o.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        typeof createImageBitmap > "u" || i && n < 17 || s && a < 98 ? this.textureLoader = new (0, $329ek.TextureLoader)(this.options.manager) : this.textureLoader = new (0, $329ek.ImageBitmapLoader)(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new (0, $329ek.FileLoader)(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0);
    }
    setExtensions(e) {
        this.extensions = e;
    }
    setPlugins(e) {
        this.plugins = e;
    }
    parse(e, t) {
        const i = this, n = this.json, s = this.extensions;
        this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(a) {
            return a._markDefs && a._markDefs();
        }), Promise.all(this._invokeAll(function(a) {
            return a.beforeRoot && a.beforeRoot();
        })).then(function() {
            return Promise.all([
                i.getDependencies("scene"),
                i.getDependencies("animation"),
                i.getDependencies("camera")
            ]);
        }).then(function(a) {
            const o = {
                scene: a[0][n.scene || 0],
                scenes: a[0],
                animations: a[1],
                cameras: a[2],
                asset: n.asset,
                parser: i,
                userData: {}
            };
            return $d7238066c5de7f1c$var$dC(s, o, n), $d7238066c5de7f1c$var$Ec(o, n), Promise.all(i._invokeAll(function(g) {
                return g.afterRoot && g.afterRoot(o);
            })).then(function() {
                for (const g of o.scenes)g.updateMatrixWorld();
                e(o);
            });
        }).catch(t);
    }
    /**
   * Marks the special nodes/meshes in json for efficient parse.
   *
   * @private
   */ _markDefs() {
        const e = this.json.nodes || [], t = this.json.skins || [], i = this.json.meshes || [];
        for(let n = 0, s = t.length; n < s; n++){
            const a = t[n].joints;
            for(let o = 0, g = a.length; o < g; o++)e[a[o]].isBone = !0;
        }
        for(let n = 0, s = e.length; n < s; n++){
            const a = e[n];
            a.mesh !== void 0 && (this._addNodeRef(this.meshCache, a.mesh), a.skin !== void 0 && (i[a.mesh].isSkinnedMesh = !0)), a.camera !== void 0 && this._addNodeRef(this.cameraCache, a.camera);
        }
    }
    /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   *
   * @private
   * @param {Object} cache
   * @param {Object3D} index
   */ _addNodeRef(e, t) {
        t !== void 0 && (e.refs[t] === void 0 && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
    }
    /**
   * Returns a reference to a shared resource, cloning it if necessary.
   *
   * @private
   * @param {Object} cache
   * @param {number} index
   * @param {Object} object
   * @return {Object}
   */ _getNodeRef(e, t, i) {
        if (e.refs[t] <= 1) return i;
        const n = i.clone(), s = (a, o)=>{
            const g = this.associations.get(a);
            g != null && this.associations.set(o, g);
            for (const [l, c] of a.children.entries())s(c, o.children[l]);
        };
        return s(i, n), n.name += "_instance_" + e.uses[t]++, n;
    }
    _invokeOne(e) {
        const t = Object.values(this.plugins);
        t.push(this);
        for(let i = 0; i < t.length; i++){
            const n = e(t[i]);
            if (n) return n;
        }
        return null;
    }
    _invokeAll(e) {
        const t = Object.values(this.plugins);
        t.unshift(this);
        const i = [];
        for(let n = 0; n < t.length; n++){
            const s = e(t[n]);
            s && i.push(s);
        }
        return i;
    }
    /**
   * Requests the specified dependency asynchronously, with caching.
   *
   * @private
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|Texture|AnimationClip|ArrayBuffer|Object>}
   */ getDependency(e, t) {
        const i = e + ":" + t;
        let n = this.cache.get(i);
        if (!n) {
            switch(e){
                case "scene":
                    n = this.loadScene(t);
                    break;
                case "node":
                    n = this._invokeOne(function(s) {
                        return s.loadNode && s.loadNode(t);
                    });
                    break;
                case "mesh":
                    n = this._invokeOne(function(s) {
                        return s.loadMesh && s.loadMesh(t);
                    });
                    break;
                case "accessor":
                    n = this.loadAccessor(t);
                    break;
                case "bufferView":
                    n = this._invokeOne(function(s) {
                        return s.loadBufferView && s.loadBufferView(t);
                    });
                    break;
                case "buffer":
                    n = this.loadBuffer(t);
                    break;
                case "material":
                    n = this._invokeOne(function(s) {
                        return s.loadMaterial && s.loadMaterial(t);
                    });
                    break;
                case "texture":
                    n = this._invokeOne(function(s) {
                        return s.loadTexture && s.loadTexture(t);
                    });
                    break;
                case "skin":
                    n = this.loadSkin(t);
                    break;
                case "animation":
                    n = this._invokeOne(function(s) {
                        return s.loadAnimation && s.loadAnimation(t);
                    });
                    break;
                case "camera":
                    n = this.loadCamera(t);
                    break;
                default:
                    if (n = this._invokeOne(function(s) {
                        return s != this && s.getDependency && s.getDependency(e, t);
                    }), !n) throw new Error("Unknown type: " + e);
                    break;
            }
            this.cache.add(i, n);
        }
        return n;
    }
    /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   *
   * @private
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */ getDependencies(e) {
        let t = this.cache.get(e);
        if (!t) {
            const i = this, n = this.json[e + (e === "mesh" ? "es" : "s")] || [];
            t = Promise.all(n.map(function(s, a) {
                return i.getDependency(e, a);
            })), this.cache.add(e, t);
        }
        return t;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   *
   * @private
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBuffer(e) {
        const t = this.json.buffers[e], i = this.fileLoader;
        if (t.type && t.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
        if (t.uri === void 0 && e === 0) return Promise.resolve(this.extensions[$d7238066c5de7f1c$var$Ti.KHR_BINARY_GLTF].body);
        const n = this.options;
        return new Promise(function(s, a) {
            i.load((0, $329ek.LoaderUtils).resolveURL(t.uri, n.path), s, void 0, function() {
                a(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
            });
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   *
   * @private
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBufferView(e) {
        const t = this.json.bufferViews[e];
        return this.getDependency("buffer", t.buffer).then(function(i) {
            const n = t.byteLength || 0, s = t.byteOffset || 0;
            return i.slice(s, s + n);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   *
   * @private
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */ loadAccessor(e) {
        const t = this, i = this.json, n = this.json.accessors[e];
        if (n.bufferView === void 0 && n.sparse === void 0) {
            const a = $d7238066c5de7f1c$var$kH[n.type], o = $d7238066c5de7f1c$var$WA[n.componentType], g = n.normalized === !0, l = new o(n.count * a);
            return Promise.resolve(new (0, $329ek.BufferAttribute)(l, a, g));
        }
        const s = [];
        return n.bufferView !== void 0 ? s.push(this.getDependency("bufferView", n.bufferView)) : s.push(null), n.sparse !== void 0 && (s.push(this.getDependency("bufferView", n.sparse.indices.bufferView)), s.push(this.getDependency("bufferView", n.sparse.values.bufferView))), Promise.all(s).then(function(a) {
            const o = a[0], g = $d7238066c5de7f1c$var$kH[n.type], l = $d7238066c5de7f1c$var$WA[n.componentType], c = l.BYTES_PER_ELEMENT, d = c * g, p = n.byteOffset || 0, A = n.bufferView !== void 0 ? i.bufferViews[n.bufferView].byteStride : void 0, y = n.normalized === !0;
            let G, Z;
            if (A && A !== d) {
                const v = Math.floor(p / A), V = "InterleavedBuffer:" + n.bufferView + ":" + n.componentType + ":" + v + ":" + n.count;
                let H = t.cache.get(V);
                H || (G = new l(o, v * A, n.count * A / c), H = new (0, $329ek.InterleavedBuffer)(G, A / c), t.cache.add(V, H)), Z = new (0, $329ek.InterleavedBufferAttribute)(H, g, p % A / c, y);
            } else o === null ? G = new l(n.count * g) : G = new l(o, p, n.count * g), Z = new (0, $329ek.BufferAttribute)(G, g, y);
            if (n.sparse !== void 0) {
                const v = $d7238066c5de7f1c$var$kH.SCALAR, V = $d7238066c5de7f1c$var$WA[n.sparse.indices.componentType], H = n.sparse.indices.byteOffset || 0, N = n.sparse.values.byteOffset || 0, Y = new V(a[1], H, n.sparse.count * v), K = new l(a[2], N, n.sparse.count * g);
                o !== null && (Z = new (0, $329ek.BufferAttribute)(Z.array.slice(), Z.itemSize, Z.normalized)), Z.normalized = !1;
                for(let z = 0, M = Y.length; z < M; z++){
                    const _ = Y[z];
                    if (Z.setX(_, K[z * g]), g >= 2 && Z.setY(_, K[z * g + 1]), g >= 3 && Z.setZ(_, K[z * g + 2]), g >= 4 && Z.setW(_, K[z * g + 3]), g >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
                Z.normalized = y;
            }
            return Z;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   *
   * @private
   * @param {number} textureIndex
   * @return {Promise<?Texture>}
   */ loadTexture(e) {
        const t = this.json, i = this.options, s = t.textures[e].source, a = t.images[s];
        let o = this.textureLoader;
        if (a.uri) {
            const g = i.manager.getHandler(a.uri);
            g !== null && (o = g);
        }
        return this.loadTextureImage(e, s, o);
    }
    loadTextureImage(e, t, i) {
        const n = this, s = this.json, a = s.textures[e], o = s.images[t], g = (o.uri || o.bufferView) + ":" + a.sampler;
        if (this.textureCache[g]) return this.textureCache[g];
        const l = this.loadImageSource(t, i).then(function(c) {
            c.flipY = !1, c.name = a.name || o.name || "", c.name === "" && typeof o.uri == "string" && o.uri.startsWith("data:image/") === !1 && (c.name = o.uri);
            const p = (s.samplers || {})[a.sampler] || {};
            return c.magFilter = $d7238066c5de7f1c$var$rT[p.magFilter] || (0, $329ek.LinearFilter), c.minFilter = $d7238066c5de7f1c$var$rT[p.minFilter] || (0, $329ek.LinearMipmapLinearFilter), c.wrapS = $d7238066c5de7f1c$var$aT[p.wrapS] || (0, $329ek.RepeatWrapping), c.wrapT = $d7238066c5de7f1c$var$aT[p.wrapT] || (0, $329ek.RepeatWrapping), c.generateMipmaps = !c.isCompressedTexture && c.minFilter !== (0, $329ek.NearestFilter) && c.minFilter !== (0, $329ek.LinearFilter), n.associations.set(c, {
                textures: e
            }), c;
        }).catch(function() {
            return null;
        });
        return this.textureCache[g] = l, l;
    }
    loadImageSource(e, t) {
        const i = this, n = this.json, s = this.options;
        if (this.sourceCache[e] !== void 0) return this.sourceCache[e].then((d)=>d.clone());
        const a = n.images[e], o = self.URL || self.webkitURL;
        let g = a.uri || "", l = !1;
        if (a.bufferView !== void 0) g = i.getDependency("bufferView", a.bufferView).then(function(d) {
            l = !0;
            const p = new Blob([
                d
            ], {
                type: a.mimeType
            });
            return g = o.createObjectURL(p), g;
        });
        else if (a.uri === void 0) throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
        const c = Promise.resolve(g).then(function(d) {
            return new Promise(function(p, A) {
                let y = p;
                t.isImageBitmapLoader === !0 && (y = function(G) {
                    const Z = new (0, $329ek.Texture)(G);
                    Z.needsUpdate = !0, p(Z);
                }), t.load((0, $329ek.LoaderUtils).resolveURL(d, s.path), y, void 0, A);
            });
        }).then(function(d) {
            return l === !0 && o.revokeObjectURL(g), $d7238066c5de7f1c$var$Ec(d, a), d.userData.mimeType = a.mimeType || $d7238066c5de7f1c$var$ZIe(a.uri), d;
        }).catch(function(d) {
            throw console.error("THREE.GLTFLoader: Couldn't load texture", g), d;
        });
        return this.sourceCache[e] = c, c;
    }
    /**
   * Asynchronously assigns a texture to the given material parameters.
   *
   * @private
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @param {string} [colorSpace]
   * @return {Promise<Texture>}
   */ assignTexture(e, t, i, n) {
        const s = this;
        return this.getDependency("texture", i.index).then(function(a) {
            if (!a) return null;
            if (i.texCoord !== void 0 && i.texCoord > 0 && (a = a.clone(), a.channel = i.texCoord), s.extensions[$d7238066c5de7f1c$var$Ti.KHR_TEXTURE_TRANSFORM]) {
                const o = i.extensions !== void 0 ? i.extensions[$d7238066c5de7f1c$var$Ti.KHR_TEXTURE_TRANSFORM] : void 0;
                if (o) {
                    const g = s.associations.get(a);
                    a = s.extensions[$d7238066c5de7f1c$var$Ti.KHR_TEXTURE_TRANSFORM].extendTexture(a, o), s.associations.set(a, g);
                }
            }
            return n !== void 0 && (a.colorSpace = n), e[t] = a, a;
        });
    }
    /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   *
   * @private
   * @param {Object3D} mesh Mesh, Line, or Points instance.
   */ assignFinalMaterial(e) {
        const t = e.geometry;
        let i = e.material;
        const n = t.attributes.tangent === void 0, s = t.attributes.color !== void 0, a = t.attributes.normal === void 0;
        if (e.isPoints) {
            const o = "PointsMaterial:" + i.uuid;
            let g = this.cache.get(o);
            g || (g = new (0, $329ek.PointsMaterial)(), (0, $329ek.Material).prototype.copy.call(g, i), g.color.copy(i.color), g.map = i.map, g.sizeAttenuation = !1, this.cache.add(o, g)), i = g;
        } else if (e.isLine) {
            const o = "LineBasicMaterial:" + i.uuid;
            let g = this.cache.get(o);
            g || (g = new (0, $329ek.LineBasicMaterial)(), (0, $329ek.Material).prototype.copy.call(g, i), g.color.copy(i.color), g.map = i.map, this.cache.add(o, g)), i = g;
        }
        if (n || s || a) {
            let o = "ClonedMaterial:" + i.uuid + ":";
            n && (o += "derivative-tangents:"), s && (o += "vertex-colors:"), a && (o += "flat-shading:");
            let g = this.cache.get(o);
            g || (g = i.clone(), s && (g.vertexColors = !0), a && (g.flatShading = !0), n && (g.normalScale && (g.normalScale.y *= -1), g.clearcoatNormalScale && (g.clearcoatNormalScale.y *= -1)), this.cache.add(o, g), this.associations.set(g, this.associations.get(i))), i = g;
        }
        e.material = i;
    }
    getMaterialType() {
        return 0, $329ek.MeshStandardMaterial;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   *
   * @private
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */ loadMaterial(e) {
        const t = this, i = this.json, n = this.extensions, s = i.materials[e];
        let a;
        const o = {}, g = s.extensions || {}, l = [];
        if (g[$d7238066c5de7f1c$var$Ti.KHR_MATERIALS_UNLIT]) {
            const d = n[$d7238066c5de7f1c$var$Ti.KHR_MATERIALS_UNLIT];
            a = d.getMaterialType(), l.push(d.extendParams(o, s, t));
        } else {
            const d = s.pbrMetallicRoughness || {};
            if (o.color = new (0, $329ek.Color)(1, 1, 1), o.opacity = 1, Array.isArray(d.baseColorFactor)) {
                const p = d.baseColorFactor;
                o.color.setRGB(p[0], p[1], p[2], (0, $329ek.LinearSRGBColorSpace)), o.opacity = p[3];
            }
            d.baseColorTexture !== void 0 && l.push(t.assignTexture(o, "map", d.baseColorTexture, (0, $329ek.SRGBColorSpace))), o.metalness = d.metallicFactor !== void 0 ? d.metallicFactor : 1, o.roughness = d.roughnessFactor !== void 0 ? d.roughnessFactor : 1, d.metallicRoughnessTexture !== void 0 && (l.push(t.assignTexture(o, "metalnessMap", d.metallicRoughnessTexture)), l.push(t.assignTexture(o, "roughnessMap", d.metallicRoughnessTexture))), a = this._invokeOne(function(p) {
                return p.getMaterialType && p.getMaterialType(e);
            }), l.push(Promise.all(this._invokeAll(function(p) {
                return p.extendMaterialParams && p.extendMaterialParams(e, o);
            })));
        }
        s.doubleSided === !0 && (o.side = (0, $329ek.DoubleSide));
        const c = s.alphaMode || $d7238066c5de7f1c$var$EH.OPAQUE;
        if (c === $d7238066c5de7f1c$var$EH.BLEND ? (o.transparent = !0, o.depthWrite = !1) : (o.transparent = !1, c === $d7238066c5de7f1c$var$EH.MASK && (o.alphaTest = s.alphaCutoff !== void 0 ? s.alphaCutoff : 0.5)), s.normalTexture !== void 0 && a !== (0, $329ek.MeshBasicMaterial) && (l.push(t.assignTexture(o, "normalMap", s.normalTexture)), o.normalScale = new (0, $329ek.Vector2)(1, 1), s.normalTexture.scale !== void 0)) {
            const d = s.normalTexture.scale;
            o.normalScale.set(d, d);
        }
        if (s.occlusionTexture !== void 0 && a !== (0, $329ek.MeshBasicMaterial) && (l.push(t.assignTexture(o, "aoMap", s.occlusionTexture)), s.occlusionTexture.strength !== void 0 && (o.aoMapIntensity = s.occlusionTexture.strength)), s.emissiveFactor !== void 0 && a !== (0, $329ek.MeshBasicMaterial)) {
            const d = s.emissiveFactor;
            o.emissive = new (0, $329ek.Color)().setRGB(d[0], d[1], d[2], (0, $329ek.LinearSRGBColorSpace));
        }
        return s.emissiveTexture !== void 0 && a !== (0, $329ek.MeshBasicMaterial) && l.push(t.assignTexture(o, "emissiveMap", s.emissiveTexture, (0, $329ek.SRGBColorSpace))), Promise.all(l).then(function() {
            const d = new a(o);
            return s.name && (d.name = s.name), $d7238066c5de7f1c$var$Ec(d, s), t.associations.set(d, {
                materials: e
            }), s.extensions && $d7238066c5de7f1c$var$dC(n, d, s), d;
        });
    }
    /**
   * When Object3D instances are targeted by animation, they need unique names.
   *
   * @private
   * @param {string} originalName
   * @return {string}
   */ createUniqueName(e) {
        const t = (0, $329ek.PropertyBinding).sanitizeNodeName(e || "");
        return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @private
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */ loadGeometries(e) {
        const t = this, i = this.extensions, n = this.primitiveCache;
        function s(o) {
            return i[$d7238066c5de7f1c$var$Ti.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(o, t).then(function(g) {
                return $d7238066c5de7f1c$var$oT(g, o, t);
            });
        }
        const a = [];
        for(let o = 0, g = e.length; o < g; o++){
            const l = e[o], c = $d7238066c5de7f1c$var$SIe(l), d = n[c];
            if (d) a.push(d.promise);
            else {
                let p;
                l.extensions && l.extensions[$d7238066c5de7f1c$var$Ti.KHR_DRACO_MESH_COMPRESSION] ? p = s(l) : p = $d7238066c5de7f1c$var$oT(new (0, $329ek.BufferGeometry)(), l, t), n[c] = {
                    primitive: l,
                    promise: p
                }, a.push(p);
            }
        }
        return Promise.all(a);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   *
   * @private
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh|Line|Points>}
   */ loadMesh(e) {
        const t = this, i = this.json, n = this.extensions, s = i.meshes[e], a = s.primitives, o = [];
        for(let g = 0, l = a.length; g < l; g++){
            const c = a[g].material === void 0 ? $d7238066c5de7f1c$var$fIe(this.cache) : this.getDependency("material", a[g].material);
            o.push(c);
        }
        return o.push(t.loadGeometries(a)), Promise.all(o).then(function(g) {
            const l = g.slice(0, g.length - 1), c = g[g.length - 1], d = [];
            for(let A = 0, y = c.length; A < y; A++){
                const G = c[A], Z = a[A];
                let v;
                const V = l[A];
                if (Z.mode === $d7238066c5de7f1c$var$Eg.TRIANGLES || Z.mode === $d7238066c5de7f1c$var$Eg.TRIANGLE_STRIP || Z.mode === $d7238066c5de7f1c$var$Eg.TRIANGLE_FAN || Z.mode === void 0) v = s.isSkinnedMesh === !0 ? new (0, $329ek.SkinnedMesh)(G, V) : new (0, $329ek.Mesh)(G, V), v.isSkinnedMesh === !0 && v.normalizeSkinWeights(), Z.mode === $d7238066c5de7f1c$var$Eg.TRIANGLE_STRIP ? v.geometry = $d7238066c5de7f1c$var$nT(v.geometry, (0, $329ek.TriangleStripDrawMode)) : Z.mode === $d7238066c5de7f1c$var$Eg.TRIANGLE_FAN && (v.geometry = $d7238066c5de7f1c$var$nT(v.geometry, (0, $329ek.TriangleFanDrawMode)));
                else if (Z.mode === $d7238066c5de7f1c$var$Eg.LINES) v = new (0, $329ek.LineSegments)(G, V);
                else if (Z.mode === $d7238066c5de7f1c$var$Eg.LINE_STRIP) v = new (0, $329ek.Line)(G, V);
                else if (Z.mode === $d7238066c5de7f1c$var$Eg.LINE_LOOP) v = new (0, $329ek.LineLoop)(G, V);
                else if (Z.mode === $d7238066c5de7f1c$var$Eg.POINTS) v = new (0, $329ek.Points)(G, V);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + Z.mode);
                Object.keys(v.geometry.morphAttributes).length > 0 && $d7238066c5de7f1c$var$vIe(v, s), v.name = t.createUniqueName(s.name || "mesh_" + e), $d7238066c5de7f1c$var$Ec(v, s), Z.extensions && $d7238066c5de7f1c$var$dC(n, v, Z), t.assignFinalMaterial(v), d.push(v);
            }
            for(let A = 0, y = d.length; A < y; A++)t.associations.set(d[A], {
                meshes: e,
                primitives: A
            });
            if (d.length === 1) return s.extensions && $d7238066c5de7f1c$var$dC(n, d[0], s), d[0];
            const p = new (0, $329ek.Group)();
            s.extensions && $d7238066c5de7f1c$var$dC(n, p, s), t.associations.set(p, {
                meshes: e
            });
            for(let A = 0, y = d.length; A < y; A++)p.add(d[A]);
            return p;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   *
   * @private
   * @param {number} cameraIndex
   * @return {Promise<Camera>|undefined}
   */ loadCamera(e) {
        let t;
        const i = this.json.cameras[e], n = i[i.type];
        if (!n) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        return i.type === "perspective" ? t = new (0, $329ek.PerspectiveCamera)((0, $329ek.MathUtils).radToDeg(n.yfov), n.aspectRatio || 1, n.znear || 1, n.zfar || 2e6) : i.type === "orthographic" && (t = new (0, $329ek.OrthographicCamera)(-n.xmag, n.xmag, n.ymag, -n.ymag, n.znear, n.zfar)), i.name && (t.name = this.createUniqueName(i.name)), $d7238066c5de7f1c$var$Ec(t, i), Promise.resolve(t);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   *
   * @private
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */ loadSkin(e) {
        const t = this.json.skins[e], i = [];
        for(let n = 0, s = t.joints.length; n < s; n++)i.push(this._loadNodeShallow(t.joints[n]));
        return t.inverseBindMatrices !== void 0 ? i.push(this.getDependency("accessor", t.inverseBindMatrices)) : i.push(null), Promise.all(i).then(function(n) {
            const s = n.pop(), a = n, o = [], g = [];
            for(let l = 0, c = a.length; l < c; l++){
                const d = a[l];
                if (d) {
                    o.push(d);
                    const p = new (0, $329ek.Matrix4)();
                    s !== null && p.fromArray(s.array, l * 16), g.push(p);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[l]);
            }
            return new (0, $329ek.Skeleton)(o, g);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   *
   * @private
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */ loadAnimation(e) {
        const t = this.json, i = this, n = t.animations[e], s = n.name ? n.name : "animation_" + e, a = [], o = [], g = [], l = [], c = [];
        for(let d = 0, p = n.channels.length; d < p; d++){
            const A = n.channels[d], y = n.samplers[A.sampler], G = A.target, Z = G.node, v = n.parameters !== void 0 ? n.parameters[y.input] : y.input, V = n.parameters !== void 0 ? n.parameters[y.output] : y.output;
            G.node !== void 0 && (a.push(this.getDependency("node", Z)), o.push(this.getDependency("accessor", v)), g.push(this.getDependency("accessor", V)), l.push(y), c.push(G));
        }
        return Promise.all([
            Promise.all(a),
            Promise.all(o),
            Promise.all(g),
            Promise.all(l),
            Promise.all(c)
        ]).then(function(d) {
            const p = d[0], A = d[1], y = d[2], G = d[3], Z = d[4], v = [];
            for(let H = 0, N = p.length; H < N; H++){
                const Y = p[H], K = A[H], z = y[H], M = G[H], _ = Z[H];
                if (Y === void 0) continue;
                Y.updateMatrix && Y.updateMatrix();
                const O = i._createAnimationTracks(Y, K, z, M, _);
                if (O) for(let ie = 0; ie < O.length; ie++)v.push(O[ie]);
            }
            const V = new (0, $329ek.AnimationClip)(s, void 0, v);
            return $d7238066c5de7f1c$var$Ec(V, n), V;
        });
    }
    createNodeMesh(e) {
        const t = this.json, i = this, n = t.nodes[e];
        return n.mesh === void 0 ? null : i.getDependency("mesh", n.mesh).then(function(s) {
            const a = i._getNodeRef(i.meshCache, n.mesh, s);
            return n.weights !== void 0 && a.traverse(function(o) {
                if (o.isMesh) for(let g = 0, l = n.weights.length; g < l; g++)o.morphTargetInfluences[g] = n.weights[g];
            }), a;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   *
   * @private
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */ loadNode(e) {
        const t = this.json, i = this, n = t.nodes[e], s = i._loadNodeShallow(e), a = [], o = n.children || [];
        for(let l = 0, c = o.length; l < c; l++)a.push(i.getDependency("node", o[l]));
        const g = n.skin === void 0 ? Promise.resolve(null) : i.getDependency("skin", n.skin);
        return Promise.all([
            s,
            Promise.all(a),
            g
        ]).then(function(l) {
            const c = l[0], d = l[1], p = l[2];
            p !== null && c.traverse(function(A) {
                A.isSkinnedMesh && A.bind(p, $d7238066c5de7f1c$var$RIe);
            });
            for(let A = 0, y = d.length; A < y; A++)c.add(d[A]);
            return c;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(e) {
        const t = this.json, i = this.extensions, n = this;
        if (this.nodeCache[e] !== void 0) return this.nodeCache[e];
        const s = t.nodes[e], a = s.name ? n.createUniqueName(s.name) : "", o = [], g = n._invokeOne(function(l) {
            return l.createNodeMesh && l.createNodeMesh(e);
        });
        return g && o.push(g), s.camera !== void 0 && o.push(n.getDependency("camera", s.camera).then(function(l) {
            return n._getNodeRef(n.cameraCache, s.camera, l);
        })), n._invokeAll(function(l) {
            return l.createNodeAttachment && l.createNodeAttachment(e);
        }).forEach(function(l) {
            o.push(l);
        }), this.nodeCache[e] = Promise.all(o).then(function(l) {
            let c;
            if (s.isBone === !0 ? c = new (0, $329ek.Bone)() : l.length > 1 ? c = new (0, $329ek.Group)() : l.length === 1 ? c = l[0] : c = new (0, $329ek.Object3D)(), c !== l[0]) for(let d = 0, p = l.length; d < p; d++)c.add(l[d]);
            if (s.name && (c.userData.name = s.name, c.name = a), $d7238066c5de7f1c$var$Ec(c, s), s.extensions && $d7238066c5de7f1c$var$dC(i, c, s), s.matrix !== void 0) {
                const d = new (0, $329ek.Matrix4)();
                d.fromArray(s.matrix), c.applyMatrix4(d);
            } else s.translation !== void 0 && c.position.fromArray(s.translation), s.rotation !== void 0 && c.quaternion.fromArray(s.rotation), s.scale !== void 0 && c.scale.fromArray(s.scale);
            if (!n.associations.has(c)) n.associations.set(c, {});
            else if (s.mesh !== void 0 && n.meshCache.refs[s.mesh] > 1) {
                const d = n.associations.get(c);
                n.associations.set(c, {
                    ...d
                });
            }
            return n.associations.get(c).nodes = e, c;
        }), this.nodeCache[e];
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   *
   * @private
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */ loadScene(e) {
        const t = this.extensions, i = this.json.scenes[e], n = this, s = new (0, $329ek.Group)();
        i.name && (s.name = n.createUniqueName(i.name)), $d7238066c5de7f1c$var$Ec(s, i), i.extensions && $d7238066c5de7f1c$var$dC(t, s, i);
        const a = i.nodes || [], o = [];
        for(let g = 0, l = a.length; g < l; g++)o.push(n.getDependency("node", a[g]));
        return Promise.all(o).then(function(g) {
            for(let c = 0, d = g.length; c < d; c++)s.add(g[c]);
            const l = (c)=>{
                const d = /* @__PURE__ */ new Map();
                for (const [p, A] of n.associations)(p instanceof (0, $329ek.Material) || p instanceof (0, $329ek.Texture)) && d.set(p, A);
                return c.traverse((p)=>{
                    const A = n.associations.get(p);
                    A != null && d.set(p, A);
                }), d;
            };
            return n.associations = l(s), s;
        });
    }
    _createAnimationTracks(e, t, i, n, s) {
        const a = [], o = e.name ? e.name : e.uuid, g = [];
        $d7238066c5de7f1c$var$Yd[s.path] === $d7238066c5de7f1c$var$Yd.weights ? e.traverse(function(p) {
            p.morphTargetInfluences && g.push(p.name ? p.name : p.uuid);
        }) : g.push(o);
        let l;
        switch($d7238066c5de7f1c$var$Yd[s.path]){
            case $d7238066c5de7f1c$var$Yd.weights:
                l = (0, $329ek.NumberKeyframeTrack);
                break;
            case $d7238066c5de7f1c$var$Yd.rotation:
                l = (0, $329ek.QuaternionKeyframeTrack);
                break;
            case $d7238066c5de7f1c$var$Yd.translation:
            case $d7238066c5de7f1c$var$Yd.scale:
                l = (0, $329ek.VectorKeyframeTrack);
                break;
            default:
                switch(i.itemSize){
                    case 1:
                        l = (0, $329ek.NumberKeyframeTrack);
                        break;
                    case 2:
                    case 3:
                    default:
                        l = (0, $329ek.VectorKeyframeTrack);
                        break;
                }
                break;
        }
        const c = n.interpolation !== void 0 ? $d7238066c5de7f1c$var$BIe[n.interpolation] : (0, $329ek.InterpolateLinear), d = this._getArrayFromAccessor(i);
        for(let p = 0, A = g.length; p < A; p++){
            const y = new l(g[p] + "." + $d7238066c5de7f1c$var$Yd[s.path], t.array, d, c);
            n.interpolation === "CUBICSPLINE" && this._createCubicSplineTrackInterpolant(y), a.push(y);
        }
        return a;
    }
    _getArrayFromAccessor(e) {
        let t = e.array;
        if (e.normalized) {
            const i = $d7238066c5de7f1c$var$O2(t.constructor), n = new Float32Array(t.length);
            for(let s = 0, a = t.length; s < a; s++)n[s] = t[s] * i;
            t = n;
        }
        return t;
    }
    _createCubicSplineTrackInterpolant(e) {
        e.createInterpolant = function(i) {
            const n = this instanceof (0, $329ek.QuaternionKeyframeTrack) ? $d7238066c5de7f1c$var$yIe : $d7238066c5de7f1c$var$a_;
            return new n(this.times, this.values, this.getValueSize() / 3, i);
        }, e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
    }
}
function $d7238066c5de7f1c$var$wIe(r, e, t) {
    const i = e.attributes, n = new (0, $329ek.Box3)();
    if (i.POSITION !== void 0) {
        const o = t.json.accessors[i.POSITION], g = o.min, l = o.max;
        if (g !== void 0 && l !== void 0) {
            if (n.set(new (0, $329ek.Vector3)(g[0], g[1], g[2]), new (0, $329ek.Vector3)(l[0], l[1], l[2])), o.normalized) {
                const c = $d7238066c5de7f1c$var$O2($d7238066c5de7f1c$var$WA[o.componentType]);
                n.min.multiplyScalar(c), n.max.multiplyScalar(c);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const s = e.targets;
    if (s !== void 0) {
        const o = new (0, $329ek.Vector3)(), g = new (0, $329ek.Vector3)();
        for(let l = 0, c = s.length; l < c; l++){
            const d = s[l];
            if (d.POSITION !== void 0) {
                const p = t.json.accessors[d.POSITION], A = p.min, y = p.max;
                if (A !== void 0 && y !== void 0) {
                    if (g.setX(Math.max(Math.abs(A[0]), Math.abs(y[0]))), g.setY(Math.max(Math.abs(A[1]), Math.abs(y[1]))), g.setZ(Math.max(Math.abs(A[2]), Math.abs(y[2]))), p.normalized) {
                        const G = $d7238066c5de7f1c$var$O2($d7238066c5de7f1c$var$WA[p.componentType]);
                        g.multiplyScalar(G);
                    }
                    o.max(g);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        n.expandByVector(o);
    }
    r.boundingBox = n;
    const a = new (0, $329ek.Sphere)();
    n.getCenter(a.center), a.radius = n.min.distanceTo(n.max) / 2, r.boundingSphere = a;
}
function $d7238066c5de7f1c$var$oT(r, e, t) {
    const i = e.attributes, n = [];
    function s(a, o) {
        return t.getDependency("accessor", a).then(function(g) {
            r.setAttribute(o, g);
        });
    }
    for(const a in i){
        const o = $d7238066c5de7f1c$var$Q2[a] || a.toLowerCase();
        o in r.attributes || n.push(s(i[a], o));
    }
    if (e.indices !== void 0 && !r.index) {
        const a = t.getDependency("accessor", e.indices).then(function(o) {
            r.setIndex(o);
        });
        n.push(a);
    }
    return (0, $329ek.ColorManagement).workingColorSpace !== (0, $329ek.LinearSRGBColorSpace) && "COLOR_0" in i && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $329ek.ColorManagement).workingColorSpace}" not supported.`), $d7238066c5de7f1c$var$Ec(r, e), $d7238066c5de7f1c$var$wIe(r, e, t), Promise.all(n).then(function() {
        return e.targets !== void 0 ? $d7238066c5de7f1c$var$GIe(r, e.targets, t) : r;
    });
}
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ $d7238066c5de7f1c$var$W.BRDF_GGX;
$d7238066c5de7f1c$var$W.BRDF_Lambert;
$d7238066c5de7f1c$var$W.BasicPointShadowFilter;
$d7238066c5de7f1c$var$W.BasicShadowFilter;
$d7238066c5de7f1c$var$W.Break;
$d7238066c5de7f1c$var$W.Const;
$d7238066c5de7f1c$var$W.Continue;
$d7238066c5de7f1c$var$W.DFGApprox;
$d7238066c5de7f1c$var$W.D_GGX;
$d7238066c5de7f1c$var$W.Discard;
$d7238066c5de7f1c$var$W.EPSILON;
$d7238066c5de7f1c$var$W.F_Schlick;
$d7238066c5de7f1c$var$W.Fn;
$d7238066c5de7f1c$var$W.INFINITY;
$d7238066c5de7f1c$var$W.If;
$d7238066c5de7f1c$var$W.Loop;
$d7238066c5de7f1c$var$W.NodeAccess;
$d7238066c5de7f1c$var$W.NodeShaderStage;
$d7238066c5de7f1c$var$W.NodeType;
$d7238066c5de7f1c$var$W.NodeUpdateType;
$d7238066c5de7f1c$var$W.PCFShadowFilter;
$d7238066c5de7f1c$var$W.PCFSoftShadowFilter;
$d7238066c5de7f1c$var$W.PI;
$d7238066c5de7f1c$var$W.PI2;
$d7238066c5de7f1c$var$W.TWO_PI;
$d7238066c5de7f1c$var$W.HALF_PI;
$d7238066c5de7f1c$var$W.PointShadowFilter;
$d7238066c5de7f1c$var$W.Return;
$d7238066c5de7f1c$var$W.Schlick_to_F0;
$d7238066c5de7f1c$var$W.ScriptableNodeResources;
$d7238066c5de7f1c$var$W.ShaderNode;
$d7238066c5de7f1c$var$W.Stack;
$d7238066c5de7f1c$var$W.Switch;
$d7238066c5de7f1c$var$W.TBNViewMatrix;
$d7238066c5de7f1c$var$W.VSMShadowFilter;
$d7238066c5de7f1c$var$W.V_GGX_SmithCorrelated;
$d7238066c5de7f1c$var$W.Var;
$d7238066c5de7f1c$var$W.VarIntent;
$d7238066c5de7f1c$var$W.abs;
$d7238066c5de7f1c$var$W.acesFilmicToneMapping;
$d7238066c5de7f1c$var$W.acos;
$d7238066c5de7f1c$var$W.add;
$d7238066c5de7f1c$var$W.addMethodChaining;
$d7238066c5de7f1c$var$W.addNodeElement;
$d7238066c5de7f1c$var$W.agxToneMapping;
$d7238066c5de7f1c$var$W.all;
$d7238066c5de7f1c$var$W.alphaT;
$d7238066c5de7f1c$var$W.and;
$d7238066c5de7f1c$var$W.anisotropy;
$d7238066c5de7f1c$var$W.anisotropyB;
$d7238066c5de7f1c$var$W.anisotropyT;
$d7238066c5de7f1c$var$W.any;
$d7238066c5de7f1c$var$W.append;
$d7238066c5de7f1c$var$W.array;
$d7238066c5de7f1c$var$W.arrayBuffer;
$d7238066c5de7f1c$var$W.asin;
$d7238066c5de7f1c$var$W.assign;
$d7238066c5de7f1c$var$W.atan;
$d7238066c5de7f1c$var$W.atan2;
$d7238066c5de7f1c$var$W.atomicAdd;
$d7238066c5de7f1c$var$W.atomicAnd;
$d7238066c5de7f1c$var$W.atomicFunc;
$d7238066c5de7f1c$var$W.atomicLoad;
$d7238066c5de7f1c$var$W.atomicMax;
$d7238066c5de7f1c$var$W.atomicMin;
$d7238066c5de7f1c$var$W.atomicOr;
$d7238066c5de7f1c$var$W.atomicStore;
$d7238066c5de7f1c$var$W.atomicSub;
$d7238066c5de7f1c$var$W.atomicXor;
$d7238066c5de7f1c$var$W.attenuationColor;
$d7238066c5de7f1c$var$W.attenuationDistance;
$d7238066c5de7f1c$var$W.attribute;
$d7238066c5de7f1c$var$W.attributeArray;
$d7238066c5de7f1c$var$W.backgroundBlurriness;
$d7238066c5de7f1c$var$W.backgroundIntensity;
$d7238066c5de7f1c$var$W.backgroundRotation;
$d7238066c5de7f1c$var$W.batch;
$d7238066c5de7f1c$var$W.bentNormalView;
$d7238066c5de7f1c$var$W.billboarding;
$d7238066c5de7f1c$var$W.bitAnd;
$d7238066c5de7f1c$var$W.bitNot;
$d7238066c5de7f1c$var$W.bitOr;
$d7238066c5de7f1c$var$W.bitXor;
$d7238066c5de7f1c$var$W.bitangentGeometry;
$d7238066c5de7f1c$var$W.bitangentLocal;
$d7238066c5de7f1c$var$W.bitangentView;
$d7238066c5de7f1c$var$W.bitangentWorld;
$d7238066c5de7f1c$var$W.bitcast;
$d7238066c5de7f1c$var$W.blendBurn;
$d7238066c5de7f1c$var$W.blendColor;
$d7238066c5de7f1c$var$W.blendDodge;
$d7238066c5de7f1c$var$W.blendOverlay;
$d7238066c5de7f1c$var$W.blendScreen;
$d7238066c5de7f1c$var$W.blur;
$d7238066c5de7f1c$var$W.bool;
$d7238066c5de7f1c$var$W.buffer;
$d7238066c5de7f1c$var$W.bufferAttribute;
$d7238066c5de7f1c$var$W.bumpMap;
$d7238066c5de7f1c$var$W.burn;
$d7238066c5de7f1c$var$W.builtin;
$d7238066c5de7f1c$var$W.bvec2;
$d7238066c5de7f1c$var$W.bvec3;
$d7238066c5de7f1c$var$W.bvec4;
$d7238066c5de7f1c$var$W.bypass;
$d7238066c5de7f1c$var$W.cache;
$d7238066c5de7f1c$var$W.call;
$d7238066c5de7f1c$var$W.cameraFar;
$d7238066c5de7f1c$var$W.cameraIndex;
$d7238066c5de7f1c$var$W.cameraNear;
$d7238066c5de7f1c$var$W.cameraNormalMatrix;
$d7238066c5de7f1c$var$W.cameraPosition;
$d7238066c5de7f1c$var$W.cameraProjectionMatrix;
$d7238066c5de7f1c$var$W.cameraProjectionMatrixInverse;
$d7238066c5de7f1c$var$W.cameraViewMatrix;
$d7238066c5de7f1c$var$W.cameraViewport;
$d7238066c5de7f1c$var$W.cameraWorldMatrix;
$d7238066c5de7f1c$var$W.cbrt;
$d7238066c5de7f1c$var$W.cdl;
$d7238066c5de7f1c$var$W.ceil;
$d7238066c5de7f1c$var$W.checker;
$d7238066c5de7f1c$var$W.cineonToneMapping;
$d7238066c5de7f1c$var$W.clamp;
$d7238066c5de7f1c$var$W.clearcoat;
$d7238066c5de7f1c$var$W.clearcoatNormalView;
$d7238066c5de7f1c$var$W.clearcoatRoughness;
$d7238066c5de7f1c$var$W.code;
const $d7238066c5de7f1c$var$gT = $d7238066c5de7f1c$var$W.color;
$d7238066c5de7f1c$var$W.colorSpaceToWorking;
$d7238066c5de7f1c$var$W.colorToDirection;
$d7238066c5de7f1c$var$W.compute;
$d7238066c5de7f1c$var$W.computeKernel;
$d7238066c5de7f1c$var$W.computeSkinning;
$d7238066c5de7f1c$var$W.context;
$d7238066c5de7f1c$var$W.convert;
$d7238066c5de7f1c$var$W.convertColorSpace;
$d7238066c5de7f1c$var$W.convertToTexture;
$d7238066c5de7f1c$var$W.cos;
$d7238066c5de7f1c$var$W.cross;
$d7238066c5de7f1c$var$W.cubeTexture;
$d7238066c5de7f1c$var$W.cubeTextureBase;
$d7238066c5de7f1c$var$W.cubeToUV;
$d7238066c5de7f1c$var$W.dFdx;
$d7238066c5de7f1c$var$W.dFdy;
$d7238066c5de7f1c$var$W.dashSize;
$d7238066c5de7f1c$var$W.debug;
$d7238066c5de7f1c$var$W.decrement;
$d7238066c5de7f1c$var$W.decrementBefore;
$d7238066c5de7f1c$var$W.defaultBuildStages;
$d7238066c5de7f1c$var$W.defaultShaderStages;
$d7238066c5de7f1c$var$W.defined;
$d7238066c5de7f1c$var$W.degrees;
$d7238066c5de7f1c$var$W.deltaTime;
$d7238066c5de7f1c$var$W.densityFog;
$d7238066c5de7f1c$var$W.densityFogFactor;
$d7238066c5de7f1c$var$W.depth;
$d7238066c5de7f1c$var$W.depthPass;
$d7238066c5de7f1c$var$W.determinant;
$d7238066c5de7f1c$var$W.difference;
$d7238066c5de7f1c$var$W.diffuseColor;
$d7238066c5de7f1c$var$W.directPointLight;
$d7238066c5de7f1c$var$W.directionToColor;
$d7238066c5de7f1c$var$W.directionToFaceDirection;
$d7238066c5de7f1c$var$W.dispersion;
$d7238066c5de7f1c$var$W.distance;
$d7238066c5de7f1c$var$W.div;
$d7238066c5de7f1c$var$W.dodge;
$d7238066c5de7f1c$var$W.dot;
$d7238066c5de7f1c$var$W.drawIndex;
$d7238066c5de7f1c$var$W.dynamicBufferAttribute;
$d7238066c5de7f1c$var$W.element;
$d7238066c5de7f1c$var$W.emissive;
$d7238066c5de7f1c$var$W.equal;
$d7238066c5de7f1c$var$W.equals;
$d7238066c5de7f1c$var$W.equirectUV;
$d7238066c5de7f1c$var$W.exp;
$d7238066c5de7f1c$var$W.exp2;
$d7238066c5de7f1c$var$W.expression;
$d7238066c5de7f1c$var$W.faceDirection;
$d7238066c5de7f1c$var$W.faceForward;
$d7238066c5de7f1c$var$W.faceforward;
const $d7238066c5de7f1c$var$hC = $d7238066c5de7f1c$var$W.float;
$d7238066c5de7f1c$var$W.floatBitsToInt;
$d7238066c5de7f1c$var$W.floatBitsToUint;
$d7238066c5de7f1c$var$W.floor;
$d7238066c5de7f1c$var$W.fog;
$d7238066c5de7f1c$var$W.fract;
$d7238066c5de7f1c$var$W.frameGroup;
$d7238066c5de7f1c$var$W.frameId;
$d7238066c5de7f1c$var$W.frontFacing;
$d7238066c5de7f1c$var$W.fwidth;
$d7238066c5de7f1c$var$W.gain;
$d7238066c5de7f1c$var$W.gapSize;
$d7238066c5de7f1c$var$W.getConstNodeType;
$d7238066c5de7f1c$var$W.getCurrentStack;
$d7238066c5de7f1c$var$W.getDirection;
$d7238066c5de7f1c$var$W.getDistanceAttenuation;
$d7238066c5de7f1c$var$W.getGeometryRoughness;
$d7238066c5de7f1c$var$W.getNormalFromDepth;
$d7238066c5de7f1c$var$W.interleavedGradientNoise;
$d7238066c5de7f1c$var$W.getParallaxCorrectNormal;
$d7238066c5de7f1c$var$W.getRoughness;
$d7238066c5de7f1c$var$W.getScreenPosition;
$d7238066c5de7f1c$var$W.getShIrradianceAt;
$d7238066c5de7f1c$var$W.getShadowMaterial;
$d7238066c5de7f1c$var$W.getShadowRenderObjectFunction;
$d7238066c5de7f1c$var$W.getTextureIndex;
$d7238066c5de7f1c$var$W.getViewPosition;
$d7238066c5de7f1c$var$W.globalId;
$d7238066c5de7f1c$var$W.glsl;
$d7238066c5de7f1c$var$W.glslFn;
$d7238066c5de7f1c$var$W.grayscale;
$d7238066c5de7f1c$var$W.greaterThan;
$d7238066c5de7f1c$var$W.greaterThanEqual;
$d7238066c5de7f1c$var$W.hash;
$d7238066c5de7f1c$var$W.highpModelNormalViewMatrix;
$d7238066c5de7f1c$var$W.highpModelViewMatrix;
$d7238066c5de7f1c$var$W.hue;
$d7238066c5de7f1c$var$W.increment;
$d7238066c5de7f1c$var$W.incrementBefore;
$d7238066c5de7f1c$var$W.instance;
$d7238066c5de7f1c$var$W.instanceIndex;
$d7238066c5de7f1c$var$W.instancedArray;
$d7238066c5de7f1c$var$W.instancedBufferAttribute;
$d7238066c5de7f1c$var$W.instancedDynamicBufferAttribute;
$d7238066c5de7f1c$var$W.instancedMesh;
$d7238066c5de7f1c$var$W.int;
$d7238066c5de7f1c$var$W.intBitsToFloat;
$d7238066c5de7f1c$var$W.inverse;
$d7238066c5de7f1c$var$W.inverseSqrt;
$d7238066c5de7f1c$var$W.inversesqrt;
$d7238066c5de7f1c$var$W.invocationLocalIndex;
$d7238066c5de7f1c$var$W.invocationSubgroupIndex;
$d7238066c5de7f1c$var$W.ior;
$d7238066c5de7f1c$var$W.iridescence;
$d7238066c5de7f1c$var$W.iridescenceIOR;
$d7238066c5de7f1c$var$W.iridescenceThickness;
$d7238066c5de7f1c$var$W.ivec2;
$d7238066c5de7f1c$var$W.ivec3;
$d7238066c5de7f1c$var$W.ivec4;
$d7238066c5de7f1c$var$W.js;
$d7238066c5de7f1c$var$W.label;
$d7238066c5de7f1c$var$W.length;
$d7238066c5de7f1c$var$W.lengthSq;
$d7238066c5de7f1c$var$W.lessThan;
$d7238066c5de7f1c$var$W.lessThanEqual;
$d7238066c5de7f1c$var$W.lightPosition;
$d7238066c5de7f1c$var$W.lightProjectionUV;
$d7238066c5de7f1c$var$W.lightShadowMatrix;
$d7238066c5de7f1c$var$W.lightTargetDirection;
$d7238066c5de7f1c$var$W.lightTargetPosition;
$d7238066c5de7f1c$var$W.lightViewPosition;
$d7238066c5de7f1c$var$W.lightingContext;
$d7238066c5de7f1c$var$W.lights;
$d7238066c5de7f1c$var$W.linearDepth;
$d7238066c5de7f1c$var$W.linearToneMapping;
$d7238066c5de7f1c$var$W.localId;
$d7238066c5de7f1c$var$W.log;
$d7238066c5de7f1c$var$W.log2;
$d7238066c5de7f1c$var$W.logarithmicDepthToViewZ;
$d7238066c5de7f1c$var$W.luminance;
$d7238066c5de7f1c$var$W.mat2;
$d7238066c5de7f1c$var$W.mat3;
$d7238066c5de7f1c$var$W.mat4;
$d7238066c5de7f1c$var$W.matcapUV;
$d7238066c5de7f1c$var$W.materialAO;
$d7238066c5de7f1c$var$W.materialAlphaTest;
$d7238066c5de7f1c$var$W.materialAnisotropy;
$d7238066c5de7f1c$var$W.materialAnisotropyVector;
$d7238066c5de7f1c$var$W.materialAttenuationColor;
$d7238066c5de7f1c$var$W.materialAttenuationDistance;
$d7238066c5de7f1c$var$W.materialClearcoat;
$d7238066c5de7f1c$var$W.materialClearcoatNormal;
$d7238066c5de7f1c$var$W.materialClearcoatRoughness;
$d7238066c5de7f1c$var$W.materialColor;
$d7238066c5de7f1c$var$W.materialDispersion;
$d7238066c5de7f1c$var$W.materialEmissive;
$d7238066c5de7f1c$var$W.materialEnvIntensity;
$d7238066c5de7f1c$var$W.materialEnvRotation;
$d7238066c5de7f1c$var$W.materialIOR;
$d7238066c5de7f1c$var$W.materialIridescence;
$d7238066c5de7f1c$var$W.materialIridescenceIOR;
$d7238066c5de7f1c$var$W.materialIridescenceThickness;
$d7238066c5de7f1c$var$W.materialLightMap;
$d7238066c5de7f1c$var$W.materialLineDashOffset;
$d7238066c5de7f1c$var$W.materialLineDashSize;
$d7238066c5de7f1c$var$W.materialLineGapSize;
$d7238066c5de7f1c$var$W.materialLineScale;
$d7238066c5de7f1c$var$W.materialLineWidth;
$d7238066c5de7f1c$var$W.materialMetalness;
$d7238066c5de7f1c$var$W.materialNormal;
$d7238066c5de7f1c$var$W.materialOpacity;
$d7238066c5de7f1c$var$W.materialPointSize;
$d7238066c5de7f1c$var$W.materialReference;
$d7238066c5de7f1c$var$W.materialReflectivity;
$d7238066c5de7f1c$var$W.materialRefractionRatio;
$d7238066c5de7f1c$var$W.materialRotation;
$d7238066c5de7f1c$var$W.materialRoughness;
$d7238066c5de7f1c$var$W.materialSheen;
$d7238066c5de7f1c$var$W.materialSheenRoughness;
$d7238066c5de7f1c$var$W.materialShininess;
$d7238066c5de7f1c$var$W.materialSpecular;
$d7238066c5de7f1c$var$W.materialSpecularColor;
$d7238066c5de7f1c$var$W.materialSpecularIntensity;
$d7238066c5de7f1c$var$W.materialSpecularStrength;
$d7238066c5de7f1c$var$W.materialThickness;
$d7238066c5de7f1c$var$W.materialTransmission;
$d7238066c5de7f1c$var$W.max;
$d7238066c5de7f1c$var$W.maxMipLevel;
$d7238066c5de7f1c$var$W.mediumpModelViewMatrix;
$d7238066c5de7f1c$var$W.metalness;
$d7238066c5de7f1c$var$W.min;
$d7238066c5de7f1c$var$W.mix;
$d7238066c5de7f1c$var$W.mixElement;
$d7238066c5de7f1c$var$W.mod;
$d7238066c5de7f1c$var$W.modInt;
$d7238066c5de7f1c$var$W.modelDirection;
$d7238066c5de7f1c$var$W.modelNormalMatrix;
$d7238066c5de7f1c$var$W.modelPosition;
$d7238066c5de7f1c$var$W.modelRadius;
$d7238066c5de7f1c$var$W.modelScale;
$d7238066c5de7f1c$var$W.modelViewMatrix;
$d7238066c5de7f1c$var$W.modelViewPosition;
$d7238066c5de7f1c$var$W.modelViewProjection;
$d7238066c5de7f1c$var$W.modelWorldMatrix;
$d7238066c5de7f1c$var$W.modelWorldMatrixInverse;
$d7238066c5de7f1c$var$W.morphReference;
$d7238066c5de7f1c$var$W.mrt;
const $d7238066c5de7f1c$var$qb = $d7238066c5de7f1c$var$W.mul;
$d7238066c5de7f1c$var$W.mx_aastep;
$d7238066c5de7f1c$var$W.mx_add;
$d7238066c5de7f1c$var$W.mx_atan2;
$d7238066c5de7f1c$var$W.mx_cell_noise_float;
$d7238066c5de7f1c$var$W.mx_contrast;
$d7238066c5de7f1c$var$W.mx_divide;
$d7238066c5de7f1c$var$W.mx_fractal_noise_float;
$d7238066c5de7f1c$var$W.mx_fractal_noise_vec2;
$d7238066c5de7f1c$var$W.mx_fractal_noise_vec3;
$d7238066c5de7f1c$var$W.mx_fractal_noise_vec4;
$d7238066c5de7f1c$var$W.mx_frame;
$d7238066c5de7f1c$var$W.mx_heighttonormal;
$d7238066c5de7f1c$var$W.mx_hsvtorgb;
$d7238066c5de7f1c$var$W.mx_ifequal;
$d7238066c5de7f1c$var$W.mx_ifgreater;
$d7238066c5de7f1c$var$W.mx_ifgreatereq;
$d7238066c5de7f1c$var$W.mx_invert;
$d7238066c5de7f1c$var$W.mx_modulo;
$d7238066c5de7f1c$var$W.mx_multiply;
$d7238066c5de7f1c$var$W.mx_noise_float;
$d7238066c5de7f1c$var$W.mx_noise_vec3;
$d7238066c5de7f1c$var$W.mx_noise_vec4;
$d7238066c5de7f1c$var$W.mx_place2d;
$d7238066c5de7f1c$var$W.mx_power;
$d7238066c5de7f1c$var$W.mx_ramp4;
$d7238066c5de7f1c$var$W.mx_ramplr;
$d7238066c5de7f1c$var$W.mx_ramptb;
$d7238066c5de7f1c$var$W.mx_rgbtohsv;
$d7238066c5de7f1c$var$W.mx_rotate2d;
$d7238066c5de7f1c$var$W.mx_rotate3d;
$d7238066c5de7f1c$var$W.mx_safepower;
$d7238066c5de7f1c$var$W.mx_separate;
$d7238066c5de7f1c$var$W.mx_splitlr;
$d7238066c5de7f1c$var$W.mx_splittb;
$d7238066c5de7f1c$var$W.mx_srgb_texture_to_lin_rec709;
$d7238066c5de7f1c$var$W.mx_subtract;
$d7238066c5de7f1c$var$W.mx_timer;
$d7238066c5de7f1c$var$W.mx_transform_uv;
$d7238066c5de7f1c$var$W.mx_unifiednoise2d;
$d7238066c5de7f1c$var$W.mx_unifiednoise3d;
$d7238066c5de7f1c$var$W.mx_worley_noise_float;
$d7238066c5de7f1c$var$W.mx_worley_noise_vec2;
$d7238066c5de7f1c$var$W.mx_worley_noise_vec3;
$d7238066c5de7f1c$var$W.negate;
$d7238066c5de7f1c$var$W.neutralToneMapping;
$d7238066c5de7f1c$var$W.nodeArray;
$d7238066c5de7f1c$var$W.nodeImmutable;
$d7238066c5de7f1c$var$W.nodeObject;
$d7238066c5de7f1c$var$W.nodeObjectIntent;
$d7238066c5de7f1c$var$W.nodeObjects;
$d7238066c5de7f1c$var$W.nodeProxy;
$d7238066c5de7f1c$var$W.nodeProxyIntent;
$d7238066c5de7f1c$var$W.normalFlat;
$d7238066c5de7f1c$var$W.normalGeometry;
$d7238066c5de7f1c$var$W.normalLocal;
$d7238066c5de7f1c$var$W.normalMap;
$d7238066c5de7f1c$var$W.normalView;
$d7238066c5de7f1c$var$W.normalViewGeometry;
$d7238066c5de7f1c$var$W.normalWorld;
$d7238066c5de7f1c$var$W.normalWorldGeometry;
$d7238066c5de7f1c$var$W.normalize;
$d7238066c5de7f1c$var$W.not;
$d7238066c5de7f1c$var$W.notEqual;
$d7238066c5de7f1c$var$W.numWorkgroups;
$d7238066c5de7f1c$var$W.objectDirection;
$d7238066c5de7f1c$var$W.objectGroup;
$d7238066c5de7f1c$var$W.objectPosition;
$d7238066c5de7f1c$var$W.objectRadius;
$d7238066c5de7f1c$var$W.objectScale;
$d7238066c5de7f1c$var$W.objectViewPosition;
$d7238066c5de7f1c$var$W.objectWorldMatrix;
$d7238066c5de7f1c$var$W.OnBeforeObjectUpdate;
$d7238066c5de7f1c$var$W.OnBeforeMaterialUpdate;
$d7238066c5de7f1c$var$W.OnObjectUpdate;
$d7238066c5de7f1c$var$W.OnMaterialUpdate;
$d7238066c5de7f1c$var$W.oneMinus;
$d7238066c5de7f1c$var$W.or;
$d7238066c5de7f1c$var$W.orthographicDepthToViewZ;
$d7238066c5de7f1c$var$W.oscSawtooth;
$d7238066c5de7f1c$var$W.oscSine;
$d7238066c5de7f1c$var$W.oscSquare;
$d7238066c5de7f1c$var$W.oscTriangle;
$d7238066c5de7f1c$var$W.output;
$d7238066c5de7f1c$var$W.outputStruct;
$d7238066c5de7f1c$var$W.overlay;
$d7238066c5de7f1c$var$W.overloadingFn;
$d7238066c5de7f1c$var$W.parabola;
$d7238066c5de7f1c$var$W.parallaxDirection;
$d7238066c5de7f1c$var$W.parallaxUV;
$d7238066c5de7f1c$var$W.parameter;
$d7238066c5de7f1c$var$W.pass;
$d7238066c5de7f1c$var$W.passTexture;
$d7238066c5de7f1c$var$W.pcurve;
$d7238066c5de7f1c$var$W.perspectiveDepthToViewZ;
$d7238066c5de7f1c$var$W.pmremTexture;
$d7238066c5de7f1c$var$W.pointShadow;
$d7238066c5de7f1c$var$W.pointUV;
$d7238066c5de7f1c$var$W.pointWidth;
$d7238066c5de7f1c$var$W.positionGeometry;
$d7238066c5de7f1c$var$W.positionLocal;
$d7238066c5de7f1c$var$W.positionPrevious;
$d7238066c5de7f1c$var$W.positionView;
$d7238066c5de7f1c$var$W.positionViewDirection;
$d7238066c5de7f1c$var$W.positionWorld;
$d7238066c5de7f1c$var$W.positionWorldDirection;
$d7238066c5de7f1c$var$W.posterize;
$d7238066c5de7f1c$var$W.pow;
$d7238066c5de7f1c$var$W.pow2;
$d7238066c5de7f1c$var$W.pow3;
$d7238066c5de7f1c$var$W.pow4;
$d7238066c5de7f1c$var$W.premultiplyAlpha;
$d7238066c5de7f1c$var$W.property;
$d7238066c5de7f1c$var$W.radians;
$d7238066c5de7f1c$var$W.rand;
$d7238066c5de7f1c$var$W.range;
$d7238066c5de7f1c$var$W.rangeFog;
$d7238066c5de7f1c$var$W.rangeFogFactor;
$d7238066c5de7f1c$var$W.reciprocal;
$d7238066c5de7f1c$var$W.reference;
$d7238066c5de7f1c$var$W.referenceBuffer;
$d7238066c5de7f1c$var$W.reflect;
$d7238066c5de7f1c$var$W.reflectVector;
$d7238066c5de7f1c$var$W.reflectView;
$d7238066c5de7f1c$var$W.reflector;
$d7238066c5de7f1c$var$W.refract;
$d7238066c5de7f1c$var$W.refractVector;
$d7238066c5de7f1c$var$W.refractView;
$d7238066c5de7f1c$var$W.reinhardToneMapping;
$d7238066c5de7f1c$var$W.remap;
$d7238066c5de7f1c$var$W.remapClamp;
$d7238066c5de7f1c$var$W.renderGroup;
$d7238066c5de7f1c$var$W.renderOutput;
$d7238066c5de7f1c$var$W.rendererReference;
$d7238066c5de7f1c$var$W.rotate;
$d7238066c5de7f1c$var$W.rotateUV;
$d7238066c5de7f1c$var$W.roughness;
$d7238066c5de7f1c$var$W.round;
$d7238066c5de7f1c$var$W.rtt;
$d7238066c5de7f1c$var$W.sRGBTransferEOTF;
$d7238066c5de7f1c$var$W.sRGBTransferOETF;
$d7238066c5de7f1c$var$W.sample;
$d7238066c5de7f1c$var$W.sampler;
$d7238066c5de7f1c$var$W.samplerComparison;
$d7238066c5de7f1c$var$W.saturate;
$d7238066c5de7f1c$var$W.saturation;
$d7238066c5de7f1c$var$W.screen;
$d7238066c5de7f1c$var$W.screenCoordinate;
$d7238066c5de7f1c$var$W.screenDPR;
$d7238066c5de7f1c$var$W.screenSize;
$d7238066c5de7f1c$var$W.screenUV;
$d7238066c5de7f1c$var$W.scriptable;
$d7238066c5de7f1c$var$W.scriptableValue;
$d7238066c5de7f1c$var$W.select;
$d7238066c5de7f1c$var$W.setCurrentStack;
$d7238066c5de7f1c$var$W.setName;
$d7238066c5de7f1c$var$W.shaderStages;
$d7238066c5de7f1c$var$W.shadow;
$d7238066c5de7f1c$var$W.shadowPositionWorld;
$d7238066c5de7f1c$var$W.shapeCircle;
$d7238066c5de7f1c$var$W.sharedUniformGroup;
$d7238066c5de7f1c$var$W.sheen;
$d7238066c5de7f1c$var$W.sheenRoughness;
$d7238066c5de7f1c$var$W.shiftLeft;
$d7238066c5de7f1c$var$W.shiftRight;
$d7238066c5de7f1c$var$W.shininess;
$d7238066c5de7f1c$var$W.sign;
$d7238066c5de7f1c$var$W.sin;
$d7238066c5de7f1c$var$W.sinc;
$d7238066c5de7f1c$var$W.skinning;
$d7238066c5de7f1c$var$W.smoothstep;
$d7238066c5de7f1c$var$W.smoothstepElement;
$d7238066c5de7f1c$var$W.specularColor;
$d7238066c5de7f1c$var$W.specularF90;
$d7238066c5de7f1c$var$W.spherizeUV;
$d7238066c5de7f1c$var$W.split;
$d7238066c5de7f1c$var$W.spritesheetUV;
$d7238066c5de7f1c$var$W.sqrt;
$d7238066c5de7f1c$var$W.stack;
$d7238066c5de7f1c$var$W.step;
$d7238066c5de7f1c$var$W.stepElement;
$d7238066c5de7f1c$var$W.storage;
$d7238066c5de7f1c$var$W.storageBarrier;
$d7238066c5de7f1c$var$W.storageObject;
$d7238066c5de7f1c$var$W.storageTexture;
$d7238066c5de7f1c$var$W.string;
$d7238066c5de7f1c$var$W.struct;
$d7238066c5de7f1c$var$W.sub;
$d7238066c5de7f1c$var$W.subgroupAdd;
$d7238066c5de7f1c$var$W.subgroupAll;
$d7238066c5de7f1c$var$W.subgroupAnd;
$d7238066c5de7f1c$var$W.subgroupAny;
$d7238066c5de7f1c$var$W.subgroupBallot;
$d7238066c5de7f1c$var$W.subgroupBroadcast;
$d7238066c5de7f1c$var$W.subgroupBroadcastFirst;
$d7238066c5de7f1c$var$W.subBuild;
$d7238066c5de7f1c$var$W.subgroupElect;
$d7238066c5de7f1c$var$W.subgroupExclusiveAdd;
$d7238066c5de7f1c$var$W.subgroupExclusiveMul;
$d7238066c5de7f1c$var$W.subgroupInclusiveAdd;
$d7238066c5de7f1c$var$W.subgroupInclusiveMul;
$d7238066c5de7f1c$var$W.subgroupIndex;
$d7238066c5de7f1c$var$W.subgroupMax;
$d7238066c5de7f1c$var$W.subgroupMin;
$d7238066c5de7f1c$var$W.subgroupMul;
$d7238066c5de7f1c$var$W.subgroupOr;
$d7238066c5de7f1c$var$W.subgroupShuffle;
$d7238066c5de7f1c$var$W.subgroupShuffleDown;
$d7238066c5de7f1c$var$W.subgroupShuffleUp;
$d7238066c5de7f1c$var$W.subgroupShuffleXor;
$d7238066c5de7f1c$var$W.subgroupSize;
$d7238066c5de7f1c$var$W.subgroupXor;
$d7238066c5de7f1c$var$W.tan;
$d7238066c5de7f1c$var$W.tangentGeometry;
$d7238066c5de7f1c$var$W.tangentLocal;
$d7238066c5de7f1c$var$W.tangentView;
$d7238066c5de7f1c$var$W.tangentWorld;
const $d7238066c5de7f1c$var$CC = $d7238066c5de7f1c$var$W.texture;
$d7238066c5de7f1c$var$W.texture3D;
$d7238066c5de7f1c$var$W.textureBarrier;
$d7238066c5de7f1c$var$W.textureBicubic;
$d7238066c5de7f1c$var$W.textureBicubicLevel;
$d7238066c5de7f1c$var$W.textureCubeUV;
$d7238066c5de7f1c$var$W.textureLoad;
$d7238066c5de7f1c$var$W.textureSize;
$d7238066c5de7f1c$var$W.textureLevel;
$d7238066c5de7f1c$var$W.textureStore;
$d7238066c5de7f1c$var$W.thickness;
$d7238066c5de7f1c$var$W.time;
$d7238066c5de7f1c$var$W.toneMapping;
$d7238066c5de7f1c$var$W.toneMappingExposure;
$d7238066c5de7f1c$var$W.toonOutlinePass;
$d7238066c5de7f1c$var$W.transformDirection;
$d7238066c5de7f1c$var$W.transformNormal;
$d7238066c5de7f1c$var$W.transformNormalToView;
$d7238066c5de7f1c$var$W.transformedClearcoatNormalView;
$d7238066c5de7f1c$var$W.transformedNormalView;
$d7238066c5de7f1c$var$W.transformedNormalWorld;
$d7238066c5de7f1c$var$W.transmission;
$d7238066c5de7f1c$var$W.transpose;
$d7238066c5de7f1c$var$W.triNoise3D;
$d7238066c5de7f1c$var$W.triplanarTexture;
$d7238066c5de7f1c$var$W.triplanarTextures;
$d7238066c5de7f1c$var$W.trunc;
$d7238066c5de7f1c$var$W.uint;
$d7238066c5de7f1c$var$W.uintBitsToFloat;
$d7238066c5de7f1c$var$W.uniform;
$d7238066c5de7f1c$var$W.uniformArray;
$d7238066c5de7f1c$var$W.uniformCubeTexture;
$d7238066c5de7f1c$var$W.uniformGroup;
$d7238066c5de7f1c$var$W.uniformFlow;
$d7238066c5de7f1c$var$W.uniformTexture;
$d7238066c5de7f1c$var$W.unpremultiplyAlpha;
$d7238066c5de7f1c$var$W.userData;
const $d7238066c5de7f1c$var$pC = $d7238066c5de7f1c$var$W.uv;
$d7238066c5de7f1c$var$W.uvec2;
$d7238066c5de7f1c$var$W.uvec3;
$d7238066c5de7f1c$var$W.uvec4;
$d7238066c5de7f1c$var$W.varying;
$d7238066c5de7f1c$var$W.varyingProperty;
$d7238066c5de7f1c$var$W.vec2;
$d7238066c5de7f1c$var$W.vec3;
$d7238066c5de7f1c$var$W.vec4;
$d7238066c5de7f1c$var$W.vectorComponents;
$d7238066c5de7f1c$var$W.velocity;
$d7238066c5de7f1c$var$W.vertexColor;
$d7238066c5de7f1c$var$W.vertexIndex;
$d7238066c5de7f1c$var$W.vertexStage;
$d7238066c5de7f1c$var$W.vibrance;
$d7238066c5de7f1c$var$W.viewZToLogarithmicDepth;
$d7238066c5de7f1c$var$W.viewZToOrthographicDepth;
$d7238066c5de7f1c$var$W.viewZToPerspectiveDepth;
$d7238066c5de7f1c$var$W.viewport;
$d7238066c5de7f1c$var$W.viewportCoordinate;
$d7238066c5de7f1c$var$W.viewportDepthTexture;
$d7238066c5de7f1c$var$W.viewportLinearDepth;
$d7238066c5de7f1c$var$W.viewportMipTexture;
$d7238066c5de7f1c$var$W.viewportResolution;
$d7238066c5de7f1c$var$W.viewportSafeUV;
$d7238066c5de7f1c$var$W.viewportSharedTexture;
$d7238066c5de7f1c$var$W.viewportSize;
$d7238066c5de7f1c$var$W.viewportTexture;
$d7238066c5de7f1c$var$W.viewportUV;
$d7238066c5de7f1c$var$W.wgsl;
$d7238066c5de7f1c$var$W.wgslFn;
$d7238066c5de7f1c$var$W.workgroupArray;
$d7238066c5de7f1c$var$W.workgroupBarrier;
$d7238066c5de7f1c$var$W.workgroupId;
$d7238066c5de7f1c$var$W.workingToColorSpace;
$d7238066c5de7f1c$var$W.xor;
var $d7238066c5de7f1c$var$WIe = function() {
    var r = "b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q:Odkr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq;w8Wqdbk;esezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9Uc;WFbGgocjdaocjd6EhDaicefhocbhqdnindndndnaeaq9nmbaDaeaq9RaqaDfae6Egkcsfglcl4cifcd4hxalc9WGgmTmecbhPawcjdfhsaohzinaraz9Rax6mvarazaxfgo9RcK6mvczhlcbhHinalgic9WfgOawcj;cbffhldndndndndnazaOco4fRbbaHcoG4ciGPlbedibkal9cb83ibalcwf9cb83ibxikalaoRblaoRbbgOco4gAaAciSgAE86bbawcj;cbfaifglcGfaoclfaAfgARbbaOcl4ciGgCaCciSgCE86bbalcVfaAaCfgARbbaOcd4ciGgCaCciSgCE86bbalc7faAaCfgARbbaOciGgOaOciSgOE86bbalctfaAaOfgARbbaoRbegOco4gCaCciSgCE86bbalc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbalc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbalc93faAaCfgARbbaOciGgOaOciSgOE86bbalc94faAaOfgARbbaoRbdgOco4gCaCciSgCE86bbalc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbalc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbalc97faAaCfgARbbaOciGgOaOciSgOE86bbalc98faAaOfgORbbaoRbigoco4gAaAciSgAE86bbalc99faOaAfgORbbaocl4ciGgAaAciSgAE86bbalc9:faOaAfgORbbaocd4ciGgAaAciSgAE86bbalcufaOaAfglRbbaociGgoaociSgoE86bbalaofhoxdkalaoRbwaoRbbgOcl4gAaAcsSgAE86bbawcj;cbfaifglcGfaocwfaAfgARbbaOcsGgOaOcsSgOE86bbalcVfaAaOfgORbbaoRbegAcl4gCaCcsSgCE86bbalc7faOaCfgORbbaAcsGgAaAcsSgAE86bbalctfaOaAfgORbbaoRbdgAcl4gCaCcsSgCE86bbalc91faOaCfgORbbaAcsGgAaAcsSgAE86bbalc4faOaAfgORbbaoRbigAcl4gCaCcsSgCE86bbalc93faOaCfgORbbaAcsGgAaAcsSgAE86bbalc94faOaAfgORbbaoRblgAcl4gCaCcsSgCE86bbalc95faOaCfgORbbaAcsGgAaAcsSgAE86bbalc96faOaAfgORbbaoRbvgAcl4gCaCcsSgCE86bbalc97faOaCfgORbbaAcsGgAaAcsSgAE86bbalc98faOaAfgORbbaoRbogAcl4gCaCcsSgCE86bbalc99faOaCfgORbbaAcsGgAaAcsSgAE86bbalc9:faOaAfgORbbaoRbrgocl4gAaAcsSgAE86bbalcufaOaAfglRbbaocsGgoaocsSgoE86bbalaofhoxekalao8Pbb83bbalcwfaocwf8Pbb83bbaoczfhokdnaiam9pmbaHcdfhHaiczfhlarao9RcL0mekkaiam6mvaoTmvdnakTmbawaPfRbbhHawcj;cbfhlashiakhOinaialRbbgzce4cbazceG9R7aHfgH86bbaiadfhialcefhlaOcufgOmbkkascefhsaohzaPcefgPad9hmbxikkcbc99arao9Radcaadca0ESEhoxlkaoaxad2fhCdnakmbadhlinaoTmlarao9Rax6mlaoaxfhoalcufglmbkaChoxekcbhmawcjdfhAinarao9Rax6miawamfRbbhHawcj;cbfhlaAhiakhOinaialRbbgzce4cbazceG9R7aHfgH86bbaiadfhialcefhlaOcufgOmbkaAcefhAaoaxfhoamcefgmad9hmbkaChokabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqaombkc9:hoxekc9:hokavcj;ebf8Kjjjjbaok;cseHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgwce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhDaicefgqarfhidnaeTmbcmcsawceSEhkcbhxcbhmcbhPcbhwcbhlindnaiaD9nmbc9:hoxikdndnaqRbbgoc;Ve0mbavc;abfalaocu7gscl4fcsGcitfgzydlhrazydbhzdnaocsGgHak9pmbavawasfcsGcdtfydbaxaHEhoaHThsdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkaxasfhxcdhHavawcdtfaoBdbawasfhwcehsalhOxdkdndnaHcsSmbaHc987aHamffcefhoxekaicefhoai8SbbgHcFeGhsdndnaHcu9mmbaohixekaicvfhiascFbGhscrhHdninao8SbbgOcFbGaHtasVhsaOcu9kmeaocefhoaHcrfgHc8J9hmbxdkkaocefhikasce4cbasceG9R7amfhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhHavawcdtfaoBdbcehsawcefhwalhOaohmxekdnaocpe0mbaxcefgHavawaDaocsGfRbbgocl49RcsGcdtfydbaocz6gzEhravawao9RcsGcdtfydbaHazfgAaocsGgHEhoaHThCdndnadcd9hmbabaPcetfgHax87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHaxBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfaxBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgOaxBdlaOarBdbavawazfgwcsGcdtfaoBdbalcefcsGhOawaCfhwaxhzaAaCfhxxekaxcbaiRbbgOEgzaoc;:eSgHfhraOcsGhCaOcl4hAdndnaOcs0mbarcefhoxekarhoavawaA9RcsGcdtfydbhrkdndnaCmbaocefhxxekaohxavawaO9RcsGcdtfydbhokdndnaHTmbaicefhHxekaicdfhHai8SbegscFeGhzdnascu9kmbaicofhXazcFbGhzcrhidninaH8SbbgscFbGaitazVhzascu9kmeaHcefhHaicrfgic8J9hmbkaXhHxekaHcefhHkazce4cbazceG9R7amfgmhzkdndnaAcsSmbaHhsxekaHcefhsaH8SbbgicFeGhrdnaicu9kmbaHcvfhXarcFbGhrcrhidninas8SbbgHcFbGaitarVhraHcu9kmeascefhsaicrfgic8J9hmbkaXhsxekascefhskarce4cbarceG9R7amfgmhrkdndnaCcsSmbashixekascefhias8SbbgocFeGhHdnaocu9kmbascvfhXaHcFbGhHcrhodninai8SbbgscFbGaotaHVhHascu9kmeaicefhiaocrfgoc8J9hmbkaXhixekaicefhikaHce4cbaHceG9R7amfgmhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfazBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgXazBdlaXarBdbavawaOcz6aAcsSVfgwcsGcdtfaoBdbawaCTaCcsSVfhwalcefcsGhOkaqcefhqavc;abfaOcitfgOarBdlaOaoBdbavc;abfalasfcsGcitfgraoBdlarazBdbawcsGhwalaHfcsGhlaPcifgPae6mbkkcbc99aiaDSEhokavc;aef8Kjjjjbaok:flevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;oiliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabaiavcefciGfcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:OhDxekcjjjj94hDkabaiavciGfgkcd7cetfaD87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:OhDxekcjjjj94hDkabaiavcufciGfcetfaD87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohvxekcjjjj94hvkabakcetfav87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2gdTmbinababydbgecwtcw91:Yaece91cjjj98Gcjjj;8if::NUdbabclfhbadcufgdmbkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaeczfheaiczfhiadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklzNbb", e = "b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q:6dkr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq:p9sqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk:N8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhlaicefhodnaeTmbadTmbalc;WFbGglcjdalcjd6EhwcbhDinawaeaD9RaDawfae6Egqcsfglc9WGgkci2hxakcethmalcl4cifcd4hPabaDad2fhsakc;ab6hzcbhHincbhOaohAdndninaraA9RaP6meavcj;cbfaOak2fhCaAaPfhocbhidnazmbarao9Rc;Gb6mbcbhlinaCalfhidndndndndnaAalco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaiaopbbbpklbaoczfhokdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaiaopbbbpklzaoczfhokdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaiaopbbbpklaaoczfhokdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaiaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WaoclfaYpQbfaXc:q:yjjbfRbbfhoxdkaiaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WaocwfaYpQbfaXc:q:yjjbfRbbfhoxekaiaopbbbpkl8Waoczfhokalc;abfhialcjefak0meaihlarao9Rc;Fb0mbkkdnaiak9pmbaici4hlinarao9RcK6miaCaifhXdndndndndnaAaico4fRbbalcoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpkbbxikaXaopbblaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkbbaoclfaYpQbfaKc:q:yjjbfRbbfhoxdkaXaopbbwaopbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkbbaocwfaYpQbfaKc:q:yjjbfRbbfhoxekaXaopbbbpkbbaoczfhokalcdfhlaiczfgiak6mbkkaoTmeaohAaOcefgOclSmdxbkkc9:hoxlkdnakTmbavcjdfaHfhiavaHfpbdbhYcbhXinaiavcj;cbfaXfglpblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLalakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEalamfpblbg3cep9Ta3aQp9op9Hp9rg3alaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfglaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaladfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfglaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaladfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfglaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaladfglaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaladfglaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaladfglaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaladfhiaXczfgXak6mbkkaHclfgHad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfgDae6mbkkcbc99arao9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk::seHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgwce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhDaicefgqarfhidnaeTmbcmcsawceSEhkcbhxcbhmcbhPcbhwcbhlindnaiaD9nmbc9:hoxikdndnaqRbbgoc;Ve0mbavc;abfalaocu7gscl4fcsGcitfgzydlhrazydbhzdnaocsGgHak9pmbavawasfcsGcdtfydbaxaHEhoaHThsdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkaxasfhxcdhHavawcdtfaoBdbawasfhwcehsalhOxdkdndnaHcsSmbaHc987aHamffcefhoxekaicefhoai8SbbgHcFeGhsdndnaHcu9mmbaohixekaicvfhiascFbGhscrhHdninao8SbbgOcFbGaHtasVhsaOcu9kmeaocefhoaHcrfgHc8J9hmbxdkkaocefhikasce4cbasceG9R7amfhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhHavawcdtfaoBdbcehsawcefhwalhOaohmxekdnaocpe0mbaxcefgHavawaDaocsGfRbbgocl49RcsGcdtfydbaocz6gzEhravawao9RcsGcdtfydbaHazfgAaocsGgHEhoaHThCdndnadcd9hmbabaPcetfgHax87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHaxBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfaxBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgOaxBdlaOarBdbavawazfgwcsGcdtfaoBdbalcefcsGhOawaCfhwaxhzaAaCfhxxekaxcbaiRbbgOEgzaoc;:eSgHfhraOcsGhCaOcl4hAdndnaOcs0mbarcefhoxekarhoavawaA9RcsGcdtfydbhrkdndnaCmbaocefhxxekaohxavawaO9RcsGcdtfydbhokdndnaHTmbaicefhHxekaicdfhHai8SbegscFeGhzdnascu9kmbaicofhXazcFbGhzcrhidninaH8SbbgscFbGaitazVhzascu9kmeaHcefhHaicrfgic8J9hmbkaXhHxekaHcefhHkazce4cbazceG9R7amfgmhzkdndnaAcsSmbaHhsxekaHcefhsaH8SbbgicFeGhrdnaicu9kmbaHcvfhXarcFbGhrcrhidninas8SbbgHcFbGaitarVhraHcu9kmeascefhsaicrfgic8J9hmbkaXhsxekascefhskarce4cbarceG9R7amfgmhrkdndnaCcsSmbashixekascefhias8SbbgocFeGhHdnaocu9kmbascvfhXaHcFbGhHcrhodninai8SbbgscFbGaotaHVhHascu9kmeaicefhiaocrfgoc8J9hmbkaXhixekaicefhikaHce4cbaHceG9R7amfgmhokdndnadcd9hmbabaPcetfgHaz87ebaHclfao87ebaHcdfar87ebxekabaPcdtfgHazBdbaHcwfaoBdbaHclfarBdbkcdhsavawcdtfazBdbavawcefgwcsGcdtfarBdbcihHavc;abfalcitfgXazBdlaXarBdbavawaOcz6aAcsSVfgwcsGcdtfaoBdbawaCTaCcsSVfhwalcefcsGhOkaqcefhqavc;abfaOcitfgOarBdlaOaoBdbavc;abfalasfcsGcitfgraoBdlarazBdbawcsGhwalaHfcsGhlaPcifgPae6mbkkcbc99aiaDSEhokavc;aef8Kjjjjbaok:flevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaic8Etc8F91aicd47avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:wPliuo97eue978Jjjjjbca9Rhiaec98Ghldndnadcl9hmbdnalTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalaeSmeaipxbbbbbbbbbbbbbbbbgqpklbaiabalcdtfgdaeciGglcdtgv;8qbbdnalTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDaqp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkadaiav;8qbbskdnalTmbcbhvabhdinadczfgxaxpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmbediwDqkzHOAKY8AEgwczp:Reczp:Sep;6egraDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eawczp:Sep;6egwp;Gearp;Gep;Kep;Legopxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegrpxb;:FSb;:FSb;:FSb;:FSararp;Meaoaop;Meawaqawamp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFFbbFFbbFFbbFFbbp9oaoawp;Meaqp;Keczp:Rep9qgoarawp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogrpmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oaoarpmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgval6mbkkalaeSmbaiaeciGgvcitgdfcbcaad9R;8kbaiabalcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmbediwDqkzHOAKY8AEgwczp:Reczp:Sep;6egraDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eawczp:Sep;6egwp;Gearp;Gep;Kep;Legopxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegrpxb;:FSb;:FSb;:FSb;:FSararp;Meaoaop;Meawaqawamp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFFbbFFbbFFbbFFbbp9oaoawp;Meaqp;Keczp:Rep9qgoarawp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogrpmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oaoarpmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaDakp;Mearp;Keamp9oaqakp;Mearp;Keczp:Rep9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalaeSmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaDakp;Mearp;Keamp9oaqakp;Mearp;Keczp:Rep9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbheabhdinadadpbbbgocwp:Recwp:Sep;6eaocep:SepxbbjFbbjFbbjFbbjFp9opxbbjZbbjZbbjZbbjZp:Uep;Mepkbbadczfhdaeclfgeav6mbkkdnavalSmbaialciGgecdtgdVcbc;abad9R;8kbaiabavcdtfgvad;8qbbdnaeTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjFbbjFbbjFbbjFp9opxbbjZbbjZbbjZbbjZp:Uep;Mepklbkavaiad;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz:Dbb", t = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]), i = new Uint8Array([
        32,
        0,
        65,
        2,
        1,
        106,
        34,
        33,
        3,
        128,
        11,
        4,
        13,
        64,
        6,
        253,
        10,
        7,
        15,
        116,
        127,
        5,
        8,
        12,
        40,
        16,
        19,
        54,
        20,
        9,
        27,
        255,
        113,
        17,
        42,
        67,
        24,
        23,
        146,
        148,
        18,
        14,
        22,
        45,
        70,
        69,
        56,
        114,
        101,
        21,
        25,
        63,
        75,
        136,
        108,
        28,
        118,
        29,
        73,
        115
    ]);
    if (typeof WebAssembly != "object") return {
        supported: !1
    };
    var n = WebAssembly.validate(t) ? o(e) : o(r), s, a = WebAssembly.instantiate(n, {}).then(function(v) {
        s = v.instance, s.exports.__wasm_call_ctors();
    });
    function o(v) {
        for(var V = new Uint8Array(v.length), H = 0; H < v.length; ++H){
            var N = v.charCodeAt(H);
            V[H] = N > 96 ? N - 97 : N > 64 ? N - 39 : N + 4;
        }
        for(var Y = 0, H = 0; H < v.length; ++H)V[Y++] = V[H] < 60 ? i[V[H]] : (V[H] - 60) * 64 + V[++H];
        return V.buffer.slice(0, Y);
    }
    function g(v, V, H, N, Y, K, z) {
        var M = v.exports.sbrk, _ = N + 3 & -4, O = M(_ * Y), ie = M(K.length), he = new Uint8Array(v.exports.memory.buffer);
        he.set(K, ie);
        var pe = V(O, N, Y, ie, K.length);
        if (pe == 0 && z && z(O, _, Y), H.set(he.subarray(O, O + N * Y)), M(O - M(0)), pe != 0) throw new Error("Malformed buffer data: " + pe);
    }
    var l = {
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    }, c = {
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    }, d = [], p = 0;
    function A(v) {
        var V = {
            object: new Worker(v),
            pending: 0,
            requests: {}
        };
        return V.object.onmessage = function(H) {
            var N = H.data;
            V.pending -= N.count, V.requests[N.id][N.action](N.value), delete V.requests[N.id];
        }, V;
    }
    function y(v) {
        for(var V = "self.ready = WebAssembly.instantiate(new Uint8Array([" + new Uint8Array(n) + "]), {}).then(function(result) { result.instance.exports.__wasm_call_ctors(); return result.instance; });self.onmessage = " + Z.name + ";" + g.toString() + Z.toString(), H = new Blob([
            V
        ], {
            type: "text/javascript"
        }), N = URL.createObjectURL(H), Y = d.length; Y < v; ++Y)d[Y] = A(N);
        for(var Y = v; Y < d.length; ++Y)d[Y].object.postMessage({});
        d.length = v, URL.revokeObjectURL(N);
    }
    function G(v, V, H, N, Y) {
        for(var K = d[0], z = 1; z < d.length; ++z)d[z].pending < K.pending && (K = d[z]);
        return new Promise(function(M, _) {
            var O = new Uint8Array(H), ie = ++p;
            K.pending += v, K.requests[ie] = {
                resolve: M,
                reject: _
            }, K.object.postMessage({
                id: ie,
                count: v,
                size: V,
                source: O,
                mode: N,
                filter: Y
            }, [
                O.buffer
            ]);
        });
    }
    function Z(v) {
        var V = v.data;
        if (!V.id) return self.close();
        self.ready.then(function(H) {
            try {
                var N = new Uint8Array(V.count * V.size);
                g(H, H.exports[V.mode], N, V.count, V.size, V.source, H.exports[V.filter]), self.postMessage({
                    id: V.id,
                    count: V.count,
                    action: "resolve",
                    value: N
                }, [
                    N.buffer
                ]);
            } catch (Y) {
                self.postMessage({
                    id: V.id,
                    count: V.count,
                    action: "reject",
                    value: Y
                });
            }
        });
    }
    return {
        ready: a,
        supported: !0,
        useWorkers: function(v) {
            y(v);
        },
        decodeVertexBuffer: function(v, V, H, N, Y) {
            g(s, s.exports.meshopt_decodeVertexBuffer, v, V, H, N, s.exports[l[Y]]);
        },
        decodeIndexBuffer: function(v, V, H, N) {
            g(s, s.exports.meshopt_decodeIndexBuffer, v, V, H, N);
        },
        decodeIndexSequence: function(v, V, H, N) {
            g(s, s.exports.meshopt_decodeIndexSequence, v, V, H, N);
        },
        decodeGltfBuffer: function(v, V, H, N, Y, K) {
            g(s, s.exports[c[Y]], v, V, H, N, s.exports[l[K]]);
        },
        decodeGltfBufferAsync: function(v, V, H, N, Y) {
            return d.length > 0 ? G(v, V, H, c[N], l[Y]) : a.then(function() {
                var K = new Uint8Array(v * V);
                return g(s, s.exports[c[N]], K, v, V, H, s.exports[l[Y]]), K;
            });
        }
    };
}();
function $d7238066c5de7f1c$var$HIe(r) {
    const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), i = r.clone();
    return $d7238066c5de7f1c$var$o_(r, i, function(n, s) {
        e.set(s, n), t.set(n, s);
    }), i.traverse(function(n) {
        if (!n.isSkinnedMesh) return;
        const s = n, a = e.get(n), o = a.skeleton.bones;
        s.skeleton = a.skeleton.clone(), s.bindMatrix.copy(a.bindMatrix), s.skeleton.bones = o.map(function(g) {
            return t.get(g);
        }), s.bind(s.skeleton, s.bindMatrix);
    }), i;
}
function $d7238066c5de7f1c$var$o_(r, e, t) {
    t(r, e);
    for(let i = 0; i < r.children.length; i++)$d7238066c5de7f1c$var$o_(r.children[i], e.children[i], t);
}
var $d7238066c5de7f1c$var$XIe = Object.defineProperty, $d7238066c5de7f1c$var$NIe = (r, e, t)=>e in r ? $d7238066c5de7f1c$var$XIe(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $d7238066c5de7f1c$var$P = (r, e, t)=>$d7238066c5de7f1c$var$NIe(r, typeof e != "symbol" ? e + "" : e, t), $d7238066c5de7f1c$var$Pc = /* @__PURE__ */ ((r)=>(r.none = "none", r.mixamo = "mixamo", r.actorcore = "actorcore", r.cc4 = "cc4", r))($d7238066c5de7f1c$var$Pc || {}), $d7238066c5de7f1c$var$rA = /* @__PURE__ */ ((r)=>(r.frequently = "frequently", r.often = "often", r.sometimes = "sometimes", r.occasionaly = "occasionaly", r.rarely = "rarely", r))($d7238066c5de7f1c$var$rA || {}), $d7238066c5de7f1c$export$f2e6b371e93925c7 = /* @__PURE__ */ ((r)=>(r[r.idle = 1] = "idle", r[r.waiting = 2] = "waiting", r[r.listening = 3] = "listening", r[r.speaking = 4] = "speaking", r))($d7238066c5de7f1c$export$f2e6b371e93925c7 || {}), $d7238066c5de7f1c$export$4a5f7b09ca822d8c = /* @__PURE__ */ ((r)=>(r[r.cc3 = 1] = "cc3", r[r.rpm = 2] = "rpm", r[r.avatarsdk = 3] = "avatarsdk", r[r.avaturn = 4] = "avaturn", r))($d7238066c5de7f1c$export$4a5f7b09ca822d8c || {});
const $d7238066c5de7f1c$var$g_ = {
    attributes: [
        "id",
        "characterid",
        "composition"
    ],
    contents: [
        "any"
    ]
}, $d7238066c5de7f1c$var$l_ = {
    attributes: null,
    contents: [
        "any"
    ]
}, $d7238066c5de7f1c$var$c_ = {
    attributes: null,
    contents: [
        "synchronize",
        "before",
        "after"
    ]
}, $d7238066c5de7f1c$var$u_ = {
    attributes: null,
    contents: [
        "sync"
    ]
}, $d7238066c5de7f1c$var$I_ = {
    attributes: [
        "ref"
    ],
    contents: [
        "sync"
    ]
}, $d7238066c5de7f1c$var$d_ = {
    attributes: [
        "ref"
    ],
    contents: [
        "sync"
    ]
}, $d7238066c5de7f1c$var$h_ = {
    attributes: [
        "ref"
    ],
    contents: null
}, $d7238066c5de7f1c$var$C_ = {
    attributes: [
        "id",
        "duration",
        "start",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$p_ = {
    attributes: [
        "id",
        "au",
        "side",
        "amount",
        "start",
        "attackpeak",
        "relax",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$m_ = {
    attributes: [
        "au",
        "side",
        "amount"
    ],
    contents: null
}, $d7238066c5de7f1c$var$A_ = {
    attributes: [
        "id",
        "amount",
        "overshoot",
        "start",
        "attackpeak",
        "relax",
        "end"
    ],
    contents: [
        "lexeme",
        "facs"
    ]
}, $d7238066c5de7f1c$var$b_ = {
    attributes: [
        "id",
        "amount",
        "start",
        "end"
    ],
    contents: [
        "lexeme",
        "facs"
    ]
}, $d7238066c5de7f1c$var$y_ = {
    attributes: [
        "id",
        "lexeme",
        "amount",
        "start",
        "attackpeak",
        "relax",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$B_ = {
    attributes: [
        "id",
        "target",
        "influence",
        "offsetangle",
        "offsetdirection",
        "start",
        "ready",
        "relax",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$f_ = {
    attributes: [
        "id",
        "target",
        "influence",
        "offsetangle",
        "offsetdirection",
        "start",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$G_ = {
    attributes: [
        "id",
        "lexeme",
        "mode",
        "start",
        "ready",
        "strokestart",
        "stroke",
        "strokeend",
        "relax",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$v_ = {
    attributes: [
        "id",
        "target",
        "mode",
        "start",
        "ready",
        "strokestart",
        "stroke",
        "strokeend",
        "relax",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$S_ = {
    attributes: [
        "id",
        "lexeme",
        "repetition",
        "amount",
        "start",
        "ready",
        "strokestart",
        "stroke",
        "strokeend",
        "relax",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$Z_ = {
    attributes: [
        "id",
        "target",
        "start",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$R_ = {
    attributes: [
        "id",
        "target",
        "manner",
        "start",
        "end"
    ],
    contents: null
}, $d7238066c5de7f1c$var$V_ = {
    attributes: [
        "id",
        "start",
        "ready",
        "relax",
        "end"
    ],
    contents: [
        "stance",
        "pose"
    ]
}, $d7238066c5de7f1c$var$w_ = {
    attributes: [
        "id",
        "start",
        "end"
    ],
    contents: [
        "stance",
        "pose"
    ]
}, $d7238066c5de7f1c$var$W_ = {
    attributes: [
        "type"
    ],
    contents: null
}, $d7238066c5de7f1c$var$H_ = {
    attributes: [
        "part",
        "lexeme"
    ],
    contents: null
}, $d7238066c5de7f1c$var$X_ = {
    attributes: [
        "id",
        "start",
        "end",
        "part",
        "lexeme"
    ],
    contents: [
        "text"
    ]
}, $d7238066c5de7f1c$var$N_ = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $d7238066c5de7f1c$var$L_ = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $d7238066c5de7f1c$var$Y_ = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $d7238066c5de7f1c$var$K_ = [
    "start",
    "ready",
    "strokestart",
    "stroke",
    "strokeend",
    "relax",
    "end"
], $d7238066c5de7f1c$var$fy = {
    bml: $d7238066c5de7f1c$var$g_,
    required: $d7238066c5de7f1c$var$l_,
    constraint: $d7238066c5de7f1c$var$c_,
    synchronize: $d7238066c5de7f1c$var$u_,
    before: $d7238066c5de7f1c$var$I_,
    after: $d7238066c5de7f1c$var$d_,
    sync: $d7238066c5de7f1c$var$h_,
    wait: $d7238066c5de7f1c$var$C_,
    facefacs: $d7238066c5de7f1c$var$p_,
    facs: $d7238066c5de7f1c$var$m_,
    face: $d7238066c5de7f1c$var$A_,
    faceshift: $d7238066c5de7f1c$var$b_,
    facelexeme: $d7238066c5de7f1c$var$y_,
    gaze: $d7238066c5de7f1c$var$B_,
    gazeshift: $d7238066c5de7f1c$var$f_,
    gesture: $d7238066c5de7f1c$var$G_,
    pointing: $d7238066c5de7f1c$var$v_,
    head: $d7238066c5de7f1c$var$S_,
    headdirectionshift: $d7238066c5de7f1c$var$Z_,
    locomotion: $d7238066c5de7f1c$var$R_,
    posture: $d7238066c5de7f1c$var$V_,
    postureshift: $d7238066c5de7f1c$var$w_,
    stance: $d7238066c5de7f1c$var$W_,
    pose: $d7238066c5de7f1c$var$H_,
    speech: $d7238066c5de7f1c$var$X_,
    torso: $d7238066c5de7f1c$var$N_,
    body: $d7238066c5de7f1c$var$L_,
    legs: $d7238066c5de7f1c$var$Y_,
    lips: $d7238066c5de7f1c$var$K_
}, $d7238066c5de7f1c$export$7bb8ef5c9b50e94d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    after: $d7238066c5de7f1c$var$d_,
    before: $d7238066c5de7f1c$var$I_,
    bml: $d7238066c5de7f1c$var$g_,
    body: $d7238066c5de7f1c$var$L_,
    constraint: $d7238066c5de7f1c$var$c_,
    default: $d7238066c5de7f1c$var$fy,
    face: $d7238066c5de7f1c$var$A_,
    facefacs: $d7238066c5de7f1c$var$p_,
    facelexeme: $d7238066c5de7f1c$var$y_,
    faceshift: $d7238066c5de7f1c$var$b_,
    facs: $d7238066c5de7f1c$var$m_,
    gaze: $d7238066c5de7f1c$var$B_,
    gazeshift: $d7238066c5de7f1c$var$f_,
    gesture: $d7238066c5de7f1c$var$G_,
    head: $d7238066c5de7f1c$var$S_,
    headdirectionshift: $d7238066c5de7f1c$var$Z_,
    legs: $d7238066c5de7f1c$var$Y_,
    lips: $d7238066c5de7f1c$var$K_,
    locomotion: $d7238066c5de7f1c$var$R_,
    pointing: $d7238066c5de7f1c$var$v_,
    pose: $d7238066c5de7f1c$var$H_,
    posture: $d7238066c5de7f1c$var$V_,
    postureshift: $d7238066c5de7f1c$var$w_,
    required: $d7238066c5de7f1c$var$l_,
    speech: $d7238066c5de7f1c$var$X_,
    stance: $d7238066c5de7f1c$var$W_,
    sync: $d7238066c5de7f1c$var$h_,
    synchronize: $d7238066c5de7f1c$var$u_,
    torso: $d7238066c5de7f1c$var$N_,
    wait: $d7238066c5de7f1c$var$C_
}, Symbol.toStringTag, {
    value: "Module"
}));
class $d7238066c5de7f1c$var$yB extends $1W96c.MeshPhysicalMaterial {
    constructor(e){
        super(), $d7238066c5de7f1c$var$P(this, "isSkinMaterial"), $d7238066c5de7f1c$var$P(this, "microNormalMap"), $d7238066c5de7f1c$var$P(this, "microMaskNormalMap"), $d7238066c5de7f1c$var$P(this, "microNormalScale"), $d7238066c5de7f1c$var$P(this, "cavityScale"), $d7238066c5de7f1c$var$P(this, "cavityMap"), $d7238066c5de7f1c$var$P(this, "cavityStrength"), $d7238066c5de7f1c$var$P(this, "_internalShader"), this.isSkinMaterial = !0, this.microNormalMap = e.microNormalMap ? e.microNormalMap : null, this.microMaskNormalMap = e.microMaskNormalMap ? e.microMaskNormalMap : null, this.microNormalScale = e.microNormalScale ? e.microNormalScale : new $1W96c.Vector2(30, 30), this.cavityScale = e.cavityScale ? e.cavityScale : new $1W96c.Vector2(5, 5), this.cavityMap = e.cavityMap ? e.cavityMap : null, this.cavityStrength = e.cavityStrength ? e.cavityStrength : 0.35, this.setValues(e);
    }
    onBeforeRender(e, t, i, n, s, a) {
        this.updateInternalUniforms();
    }
    updateInternalUniforms() {
        this._internalShader && (this.microNormalMap !== this._internalShader.uniforms.microNormalMap.value && (this._internalShader.uniforms.microNormalMap.value = this.microNormalMap), this.microMaskNormalMap !== this._internalShader.uniforms.microMaskNormalMap.value && (this._internalShader.uniforms.microMaskNormalMap.value = this.microMaskNormalMap), this.microNormalScale !== this._internalShader.uniforms.microNormalScale.value && (this._internalShader.uniforms.microNormalScale.value = this.microNormalScale), this.cavityMap !== this._internalShader.uniforms.cavityMap.value && (this._internalShader.uniforms.cavityMap.value = this.cavityMap), this.cavityStrength !== this._internalShader.uniforms.cavityStrength.value && (this._internalShader.uniforms.cavityStrength.value = this.cavityStrength), this.cavityScale !== this._internalShader.uniforms.cavityScale.value && (this._internalShader.uniforms.cavityScale.value = this.cavityScale));
    }
    onBeforeCompile(e) {
        this._internalShader = e, e.uniforms.microNormalMap = {
            value: this.microNormalMap
        }, e.uniforms.microMaskNormalMap = {
            value: this.microMaskNormalMap
        }, e.uniforms.microNormalScale = {
            value: this.microNormalScale
        }, e.uniforms.cavityMap = {
            value: this.cavityMap
        }, e.uniforms.cavityStrength = {
            value: this.cavityStrength
        }, e.uniforms.cavityScale = {
            value: this.cavityScale
        }, e.vertexShader = e.vertexShader.replace("#include <uv_vertex>", /* glsl */ `
        #include <uv_vertex>
        vUvMicro = uv * microNormalScale;
        vUvCavity = uv * cavityScale;`), e.vertexShader = e.vertexShader.replace("#include <common>", /* glsl */ `
          #include <common>
          uniform vec2 microNormalScale;
          uniform vec2 cavityScale;
          varying vec2 vUvCavity;
          varying vec2 vUvMicro;`), e.fragmentShader = e.fragmentShader.replace("void main() {", /* glsl */ `

            uniform sampler2D microNormalMap;
            uniform sampler2D microMaskNormalMap;
            uniform sampler2D cavityMap;
            uniform float cavityStrength;
            uniform vec2 cavityScale;
            varying vec2 vUv;
            varying vec2 vUvMicro;
            varying vec2 vUvCavity;
  
            // Function to blend two normal maps
          vec3 blendNormalMaps(vec3 normal1, vec3 normal2, float maskColor) {
            return mix(normal1, normal2, maskColor);
          }
  
            void main() {
            `), e.fragmentShader = e.fragmentShader.replace("#include <normal_fragment_maps>", /* glsl */ `
          #include <normal_fragment_maps>
          
          // Sample the micro normal map
          float maskColor = texture2D(microMaskNormalMap, vNormalMapUv ).r;
          vec3 microNormal = texture2D(microNormalMap, vUvMicro).rgb * 2.0 - 1.0;
          microNormal.xy *= normalScale;
          microNormal = normalize( tbn * microNormal );
          // Blend the classic and micro normal maps
          normal = mix(normal, microNormal, maskColor);
          `), e.fragmentShader = e.fragmentShader.replace("#include <tonemapping_fragment>", /* glsl */ `
          float cavityColor = texture2D(cavityMap, vUvCavity).r;
          //float cavityFinal = min(1.0,(cavityStrength+cavityColor * (1.0-cavityStrength)));
          float cavityFinal = mix(cavityColor, 1.0, 1.0 - cavityStrength);
          gl_FragColor.rgb =  gl_FragColor.rgb * cavityFinal;
          #include <tonemapping_fragment>`);
    }
    updateRenderTargets() {}
}
let $d7238066c5de7f1c$var$Kn = class {
    static convertToHairNodeMaterial(e) {
        const t = new $d7238066c5de7f1c$var$BY();
        let i = $d7238066c5de7f1c$var$gT(e.color);
        e.map && (i = $d7238066c5de7f1c$var$CC(e.map, $d7238066c5de7f1c$var$pC()));
        let n = $d7238066c5de7f1c$var$hC(e.opacity);
        if (e.alphaMap) {
            const s = $d7238066c5de7f1c$var$CC(e.alphaMap, $d7238066c5de7f1c$var$pC());
            n = $d7238066c5de7f1c$var$qb($d7238066c5de7f1c$var$hC(e.opacity), s.g), i = $d7238066c5de7f1c$var$qb(i, n);
        }
        return t.colorNode = i, t.opacity = e.opacity, t.roughnessNode = $d7238066c5de7f1c$var$hC(e.roughness), t.metalnessNode = $d7238066c5de7f1c$var$hC(e.metalness), e.emissiveMap ? t.emissiveNode = $d7238066c5de7f1c$var$CC(e.emissiveMap, $d7238066c5de7f1c$var$pC()) : t.emissiveNode = $d7238066c5de7f1c$var$gT(e.emissive), e.normalMap && (t.normalNode = $d7238066c5de7f1c$var$CC(e.normalMap, $d7238066c5de7f1c$var$pC())), e.roughnessMap && (t.roughnessNode = $d7238066c5de7f1c$var$qb($d7238066c5de7f1c$var$hC(e.roughness), $d7238066c5de7f1c$var$CC(e.roughnessMap, $d7238066c5de7f1c$var$pC()).g)), e.metalnessMap && (t.metalnessNode = $d7238066c5de7f1c$var$qb($d7238066c5de7f1c$var$hC(e.metalness), $d7238066c5de7f1c$var$CC(e.metalnessMap, $d7238066c5de7f1c$var$pC()).b)), e.aoMap && (t.aoNode = $d7238066c5de7f1c$var$qb($d7238066c5de7f1c$var$hC(e.aoMapIntensity || 1), $d7238066c5de7f1c$var$CC(e.aoMap, $d7238066c5de7f1c$var$pC()).r)), t.transparent = e.transparent, t.side = e.side, t.envMapIntensity = e.envMapIntensity, t.depthTest = e.depthTest, t.depthWrite = e.depthWrite, t.alphaTest = e.alphaTest, t.alphaHash = e.alphaHash, t.alphaToCoverage = e.alphaToCoverage, t;
    }
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Kn, "gltfLoader", new $d7238066c5de7f1c$var$Que()), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Kn, "fbxLoader", new $d7238066c5de7f1c$var$Vk()), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Kn, "dracoLoader", new $d7238066c5de7f1c$var$_ue()), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Kn, "textureLoader", new $d7238066c5de7f1c$var$pee());
$d7238066c5de7f1c$var$Kn.dracoLoader.setDecoderPath("https://cdn.retorik.ai/bodyengine-three/draco/");
$d7238066c5de7f1c$var$Kn.gltfLoader.setDRACOLoader($d7238066c5de7f1c$var$Kn.dracoLoader);
$d7238066c5de7f1c$var$Kn.gltfLoader.setMeshoptDecoder($d7238066c5de7f1c$var$WIe);
const $d7238066c5de7f1c$var$j2 = class aa extends $1W96c.Loader {
    constructor(e){
        super(e), $d7238066c5de7f1c$var$P(this, "textureLoader", null);
    }
    load(e, t, i, n) {
        const s = this;
        s.path === "" ? $1W96c.LoaderUtils.extractUrlBase(e) : s.path;
        const a = e.replace(".fbx", ".fbm/"), o = e.replace(".fbx", ".json"), g = new $d7238066c5de7f1c$var$Vk(this.manager);
        g.setPath(s.path), g.setResourcePath(a), g.load(e, async (l)=>{
            try {
                t(await s.autoSetup(l, o));
            } catch (c) {
                n ? n(c) : console.error(c), s.manager.itemError(e);
            }
        }, i, n);
    }
    loadAsync(e, t) {
        const i = this;
        return new Promise((n, s)=>{
            i.load(e, n, t, s);
        });
    }
    async autoSetup(e, t) {
        const i = $1W96c.LoaderUtils.extractUrlBase(t), n = t.slice(i.length, t.length - 5), s = await new $d7238066c5de7f1c$var$YIe(this.manager).setCrossOrigin(this.crossOrigin).loadAsync(t);
        return this.textureLoader = new $1W96c.TextureLoader(this.manager).setPath(i).setCrossOrigin(this.crossOrigin).setRequestHeader(this.requestHeader), await this.setupMeshes(e, s[n].Object[n].Meshes), e;
    }
    async setupMeshes(e, t) {
        var i, n;
        e.up = new $1W96c.Vector3(0, 1, 0), e.rotateX(-(Math.PI / 2));
        const s = [];
        e.traverse((o)=>{
            o.isMesh && s.push(o);
        });
        const a = [];
        for(const o in t){
            const g = s.find((l)=>l.name.includes(o));
            if (g && (((n = (i = g == null ? void 0 : g.geometry) == null ? void 0 : i.attributes) == null ? void 0 : n.uv) !== void 0 && (g.geometry.attributes.uv2 = g.geometry.attributes.uv), g.frustumCulled = !1, g.material !== void 0)) {
                const l = t[o].Materials;
                if (Object.keys(l).length > 1) for(const c in l){
                    const d = g.material.findIndex((p)=>p.name == c);
                    a.push(new Promise((p, A)=>{
                        this.setupMaterial(g.material[d], l[c]).then((y)=>{
                            g.material[d] = y, (c.toUpperCase().includes("HAIR") || c.toUpperCase().includes("FRONT")) && this.setDoublePassForHairForMultiMaterial(g, d), p();
                        });
                    }));
                }
                else a.push(new Promise((c, d)=>{
                    this.setupMaterial(g.material, l[Object.keys(l)[0]]).then((p)=>{
                        g.material = p;
                        const A = Object.keys(l)[0];
                        (A.toUpperCase().includes("HAIR") || A.toUpperCase().includes("FRONT")) && this.setDoublePassForHairForSimpleMaterial(g), c();
                    });
                }));
            }
        }
        await Promise.all(a);
    }
    async setSkinMaterial(e) {
        aa.cavityMap === void 0 && (aa.cavityMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg").catch((t)=>{
            console.warn("Can't load cavity map :", t);
        }), aa.cavityMap && (aa.cavityMap.wrapS = aa.cavityMap.wrapT = $1W96c.RepeatWrapping, aa.cavityMap = aa.cavityMap)), e.cavityMap = aa.cavityMap, e.reflectivity = 0.25, e.transmissionMap && (e.transmission = 0.5), e.attenuationDistance = 1e-3, e.thickness = 0.02, e.attenuationColor = new $1W96c.Color(0.8, 0.4, 0.3), e.microNormalScale = new $1W96c.Vector2(28, 28), e.cavityScale = new $1W96c.Vector2(20, 20), e.cavityStrength = 0.5;
    }
    async setSkinBodyMaterial(e) {
        aa.cavityMap === void 0 && (aa.cavityMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg").catch((t)=>{
            console.warn("Can't load cavity map :", t);
        }), aa.cavityMap && (aa.cavityMap.wrapS = aa.cavityMap.wrapT = $1W96c.RepeatWrapping, aa.cavityMap = aa.cavityMap)), e.cavityMap = aa.cavityMap, e.reflectivity = 0.25, e.transmissionMap && (e.transmission = 0.5), e.attenuationDistance = 1e-3, e.thickness = 0.02, e.attenuationColor = new $1W96c.Color(0.8, 0.4, 0.3), e.microNormalScale = new $1W96c.Vector2(45, 45), e.cavityScale = new $1W96c.Vector2(33, 33), e.cavityStrength = 0.5;
    }
    setDoublePassForHairForMultiMaterial(e, t) {
        const i = e.parent, n = e.material[t], s = new $1W96c.MeshBasicMaterial({
            color: 0
        });
        s.visible = !1;
        const a = e.clone(), o = e.clone();
        e.name = "Hair", a.name = "HairClone", o.name = "Hair2Clone", n.onBeforeCompile = (c)=>{
            c.fragmentShader = c.fragmentShader.replace("#include <alphamap_fragment>", $1W96c.ShaderChunk.alphamap_fragment.replace("diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g", "diffuseColor.a *= min(1.0, 0.10+texture2D( alphaMap, vAlphaMapUv ).g)"));
        }, e.frustumCulled = a.frustumCulled = !1, n.alphaTest = n.reflectivity = n.specularIntensity = n.sheen = 0, n.side = $1W96c.DoubleSide, n.depthWrite = n.alphaHash = !1, n.premultipliedAlpha = n.transparent = !0, n.alphaToCoverage = !1, a.material[t] = n.clone(), o.material[t] = n.clone();
        const g = a.material[t], l = o.material[t];
        n.opacity = 0.2, g.opacity = 1, g.alphaToCoverage = !1, l.transparent = l.alphaToCoverage = !0, l.alphaHash = !1, l.depthWrite = !0, l.alphaTest = 0, e.renderOrder = 1, a.renderOrder = 3, o.renderOrder = 2, i.add(a), i.add(o);
        for(let c = 0; c < a.material.length; c++)c !== t && (a.material[c] = s);
        for(let c = 0; c < o.material.length; c++)c !== t && (o.material[c] = s);
    }
    setDoublePassForHairForSimpleMaterial(e) {
        const t = e.parent, i = e.material, n = e.clone();
        i.onBeforeCompile = (a)=>{
            a.fragmentShader = a.fragmentShader.replace("#include <alphamap_fragment>", $1W96c.ShaderChunk.alphamap_fragment.replace("diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g", "diffuseColor.a *= min(1.0, 0.10+texture2D( alphaMap, vAlphaMapUv ).g)"));
        }, e.frustumCulled = n.frustumCulled = !1, i.alphaTest = i.reflectivity = i.specularIntensity = i.sheen = 0, i.side = $1W96c.DoubleSide, i.alphaToCoverage = i.depthWrite = i.alphaHash = i.transparent = !1, i.premultipliedAlpha = i.transparent = !0, n.material = i.clone();
        const s = n.material;
        i.opacity = 0.33, s.opacity = 1, e.renderOrder = 1, n.renderOrder = 2, t.add(n);
    }
    async setupMaterial(e, t) {
        var i, n, s, a, o, g, l, c, d, p, A, y;
        let G;
        if (e.name.includes("Skin_Arm") || e.name.includes("Skin_Leg") || e.name.includes("Skin_Body") ? G = new $d7238066c5de7f1c$var$yB({
            side: $1W96c.DoubleSide
        }) : e.name.includes("Skin_Head") ? G = new $d7238066c5de7f1c$var$yB({
            side: $1W96c.DoubleSide
        }) : G = new $1W96c.MeshPhysicalMaterial(), G.name = e.name, G.ior = 1.45, G.sheen = 0.5, G.sheenRoughness = 1, t["Two Side"] ? G.side = $1W96c.DoubleSide : G.side = $1W96c.FrontSide, t["Diffuse Color"]) {
            const Z = t["Diffuse Color"];
            G.color.setRGB(1 * Z[0] / 255, 1 * Z[1] / 255, 1 * Z[2] / 255);
        }
        if (t.Textures["Base Color"] && t.Textures["Base Color"]["Base Path"] !== "") {
            const Z = t.Textures["Base Color"], v = await ((i = this.textureLoader) == null ? void 0 : i.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Base Color map :", V);
            }));
            v && (v.anisotropy = 4, v.colorSpace = $1W96c.SRGBColorSpace, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.map = v);
        }
        if (t.Textures.Metallic && t.Textures.Metallic["Texture Path"] !== "") {
            const Z = t.Textures.Metallic, v = await ((n = this.textureLoader) == null ? void 0 : n.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Metallic map :", V);
            }));
            v ? (v.anisotropy = 4, v.colorSpace = $1W96c.NoColorSpace, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.name.includes("Cornea") && (G.clearcoat = 1, G.clearcoatRoughness = 0.15), G.name.includes("Std_Eye_") && (G.clearcoatRoughness = 0.03), G.metalnessMap = v, G.metalness = Z.Strength / 100) : G.metalness = 0;
        }
        if (t.Textures.Specular && t.Textures.Specular["Texture Path"] !== "") {
            const Z = t.Textures.Specular, v = await ((s = this.textureLoader) == null ? void 0 : s.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Specular map :", V);
            }));
            if (v) {
                if (v.anisotropy = 4, v.colorSpace = $1W96c.NoColorSpace, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, t["Specular Color"]) {
                    const V = t["Specular Color"];
                    G.specularColor.setRGB(1 * V[0] / 255, 1 * V[1] / 255, 1 * V[2] / 255);
                }
                G.specularColorMap = v, G.specularIntensity = Z.Strength / 100, G.specularIntensityMap = v;
            }
        }
        if (t.Textures.Opacity && t.Textures.Opacity["Texture Path"] !== "") {
            const Z = t.Textures.Opacity, v = await ((a = this.textureLoader) == null ? void 0 : a.loadAsync(Z["Texture Path"]).catch((Y)=>{
                console.warn("Can't load Alpha map :", Y);
            }));
            v && (v.anisotropy = 4, v.colorSpace = $1W96c.NoColorSpace, v.format = $1W96c.RGBAFormat, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.alphaMap = v);
            let V = 0, H = e.opacity, N = !0;
            (G.name.toUpperCase().includes("SCALP") || G.name.toUpperCase().includes("BASE")) && (V = 0, G.alphaToCoverage = !1), (G.name.toUpperCase().includes("HAIR") || G.name.toUpperCase().includes("FRONT")) && (V = 0, G.alphaToCoverage = !1, N = !0, G.alphaHash = !1, G.depthWrite = !1, H = 1), G.name.toUpperCase().includes("EYELASH") && (G.depthWrite = !1), G.name.includes("Brow_Transparency") && (V = 0, G.alphaToCoverage = !0, N = !1, G.alphaHash = !0, G.depthWrite = !0, H = 1), G.name.includes("Brow_Base_Transparency") && (V = 0, G.alphaToCoverage = !0, H = 1), G.name.includes("Eyelash") && (V = 0, H = 0.75, N = !0), G.name.includes("Eye_Occlusion") && (G.visible = !1), G.alphaTest = V, G.opacity = H * Z.Strength / 100, G.transparent = N;
        }
        if (t.Textures.Displacement && t.Textures.Displacement["Texture Path"] !== "") {
            const Z = t.Textures.Displacement, v = await ((o = this.textureLoader) == null ? void 0 : o.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Displacement map :", V);
            }));
            v && (v.anisotropy = 4, v.colorSpace = $1W96c.NoColorSpace, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.displacementMap = v, G.displacementBias = 0, G.displacementScale = 0.5);
        }
        if (t.Textures.Roughness && t.Textures.Roughness["Texture Path"] !== "") {
            const Z = t.Textures.Roughness, v = await ((g = this.textureLoader) == null ? void 0 : g.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Roughness map :", V);
            }));
            v ? (v.anisotropy = 4, v.format = $1W96c.RGBAFormat, v.colorSpace = $1W96c.NoColorSpace, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.roughnessMap = v, G.roughness = Z.Strength / 100) : G.roughness = 1;
        }
        if (t.Textures.Normal && t.Textures.Normal["Texture Path"] !== "") {
            const Z = t.Textures.Normal, v = await ((l = this.textureLoader) == null ? void 0 : l.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Normal map :", V);
            }));
            v && (v.anisotropy = 4, v.colorSpace = $1W96c.NoColorSpace, v.format = $1W96c.RGBAFormat, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.normalScale = new $1W96c.Vector2(Z.Strength / 100, -Z.Strength / 100), G.normalMap = v);
        }
        if (t.Textures.AO && t.Textures.AO["Texture Path"] !== "") {
            const Z = t.Textures.AO, v = await ((c = this.textureLoader) == null ? void 0 : c.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load AO map :", V);
            }));
            v && (v.anisotropy = 4, v.colorSpace = $1W96c.SRGBColorSpace, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, v.channel = 1, G.aoMap = v, G.aoMapIntensity = 0.5 * Z.Strength / 100);
        }
        if (t.Textures.Glow && t.Textures.Glow["Texture Path"] !== "") {
            const Z = t.Textures.Glow, v = await ((d = this.textureLoader) == null ? void 0 : d.loadAsync(Z["Texture Path"]).catch((V)=>{
                console.warn("Can't load Glow map :", V);
            }));
            v && (v.anisotropy = 4, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.emissiveMap = v, G.emissiveIntensity = 1 * Z.Strength / 100, G.emissive = new $1W96c.Color(16777215));
        }
        if (t["Custom Shader"] && (t["Custom Shader"]["Shader Name"] === "RLHead" || t["Custom Shader"]["Shader Name"] === "RLSkin")) {
            const Z = await ((p = this.textureLoader) == null ? void 0 : p.loadAsync(t["Custom Shader"].Image["Transmission Map"]["Texture Path"]).catch((H)=>{
                console.warn("Can't load Transmission map :", H);
            }));
            Z && (Z.anisotropy = 4, Z.wrapS = $1W96c.RepeatWrapping, Z.wrapT = $1W96c.RepeatWrapping, G.transmissionMap = Z, G.transmission = 1, G.reflectivity = 0.5);
            const v = await ((A = this.textureLoader) == null ? void 0 : A.loadAsync(t["Custom Shader"].Image.MicroNormalMask["Texture Path"]).catch((H)=>{
                console.warn("Can't load Transmission map :", H);
            }));
            v && (v.anisotropy = 4, v.wrapS = $1W96c.RepeatWrapping, v.wrapT = $1W96c.RepeatWrapping, G.microMaskNormalMap = v);
            const V = await ((y = this.textureLoader) == null ? void 0 : y.loadAsync(t["Custom Shader"].Image.MicroNormal["Texture Path"]).catch((H)=>{
                console.warn("Can't load Transmission map :", H);
            }));
            V && (V.anisotropy = 4, V.wrapS = $1W96c.RepeatWrapping, V.wrapT = $1W96c.RepeatWrapping, G.microNormalMap = V);
        }
        return (e.name.includes("Skin_Arm") || e.name.includes("Skin_Leg") || e.name.includes("Skin_Body")) && this.setSkinBodyMaterial(G), e.name.includes("Skin_Head") && this.setSkinMaterial(G), G;
    }
    setupPhysics(e, t) {}
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$j2, "cavityMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$j2, "microNormalMap");
let $d7238066c5de7f1c$var$LIe = $d7238066c5de7f1c$var$j2;
class $d7238066c5de7f1c$var$YIe extends $1W96c.Loader {
    constructor(e){
        super(e);
    }
    load(e, t, i, n) {
        const s = this;
        s.path === "" ? $1W96c.LoaderUtils.extractUrlBase(e) : s.path;
        const a = new $1W96c.FileLoader(this.manager);
        a.setPath(s.path), a.setRequestHeader(s.requestHeader), a.setWithCredentials(s.withCredentials), a.load(e, (o)=>{
            try {
                t(s.parse(o));
            } catch (g) {
                n ? n(g) : console.error(g), s.manager.itemError(e);
            }
        }, i, n);
    }
    async loadAsync(e, t) {
        const i = this;
        i.path === "" ? $1W96c.LoaderUtils.extractUrlBase(e) : i.path;
        const n = new $1W96c.FileLoader(this.manager);
        n.setPath(i.path), n.setRequestHeader(i.requestHeader), n.setWithCredentials(i.withCredentials);
        const s = await n.loadAsync(e, t);
        return i.parse(s);
    }
    parse(e) {
        return JSON.parse(e);
    }
}
const $d7238066c5de7f1c$var$Gy = class qo extends $1W96c.Loader {
    constructor(e){
        super(e);
    }
    load(e, t, i, n) {
        $d7238066c5de7f1c$var$Kn.gltfLoader.load(e, (s)=>{
            this.setMaterial(s.scene).then(()=>{
                t(s.scene);
            });
        }, i, n);
    }
    loadAsync(e, t) {
        const i = this;
        return new Promise(function(n, s) {
            i.load(e, n, t, s);
        });
    }
    async setMaterial(e) {
        const t = [];
        e.traverse((n)=>{
            n.isMesh && t.push(n);
        });
        const i = t.find((n)=>n.name.includes("Head_Mesh"));
        if (i) {
            qo.cavityMap || (qo.cavityMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/cavity.png")), qo.microMap || (qo.microMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/cavity.png")), qo.microNormalMaskMap || (qo.microNormalMaskMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/cavity.png")), qo.transMap || (qo.transMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/cavity.png"));
            const n = new $d7238066c5de7f1c$var$yB({
                color: i.material.color,
                metalness: i.material.metalness,
                roughness: i.material.roughness,
                map: i.material.map,
                normalMap: i.material.normalMap,
                normalScale: i.material.normalScale,
                roughnessMap: i.material.roughnessMap,
                metalnessMap: i.material.metalnessMap,
                side: $1W96c.DoubleSide
            });
            i.material = n, i.material.cavityMap = qo.cavityMap, i.material.reflectivity = 0.25, i.material.transmissionMap = qo.transMap, i.material.transmissionMap && (i.material.transmission = 0.5), i.material.attenuationDistance = 1e-3, i.material.thickness = 1e-3, i.material.attenuationColor = new $1W96c.Color(0.8, 0.4, 0.3), i.material.microNormalScale = new $1W96c.Vector2(50, 50), i.material.normalScale = new $1W96c.Vector2(2, -2), i.material.cavityScale = new $1W96c.Vector2(20, 20), i.material.cavityStrength = 0.9, i.material.microNormalMap = qo.microMap, i.material.microMaskNormalMap = qo.microNormalMaskMap;
        }
    }
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Gy, "cavityMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Gy, "microMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Gy, "microNormalMaskMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$Gy, "transMap");
let $d7238066c5de7f1c$var$KIe = $d7238066c5de7f1c$var$Gy;
const $d7238066c5de7f1c$var$LS = class ja extends $1W96c.Loader {
    constructor(e){
        super(e);
    }
    load(e, t, i, n) {
        $d7238066c5de7f1c$var$Kn.gltfLoader.load(e, (s)=>{
            this.setMaterial(s.scene).then(()=>{
                t(s.scene);
            });
        }, i, n);
    }
    loadAsync(e, t) {
        const i = this;
        return new Promise((n, s)=>{
            i.load(e, n, t, s);
        });
    }
    async setMaterial(e) {
        const t = [];
        e.traverse((o)=>{
            var g;
            if (o.isMesh) {
                o.castShadow = o.receiveShadow = !0, t.push(o);
                for(const l in o.material)l.toUpperCase().includes("MAP") && (g = o.material[l]) != null && g.anisotropy && (o.material[l].anisotropy = 8);
            }
        });
        const i = t.find((o)=>o.name.includes("Head_Mesh")), n = t.find((o)=>o.name.includes("avaturn_hair_1")), s = t.find((o)=>o.name.includes("avaturn_hair_0"));
        if (s) {
            const o = s.clone(), g = s.clone();
            o.material = s.material.clone(), g.material = s.material.clone(), s.material.transparent = !0, s.material.depthWrite = !1, s.material.alphaTest = 0, s.parent.add(o), g.material.transparent = g.material.alphaToCoverage = !0, g.material.alphaHash = !1, g.material.depthWrite = !0, g.material.alphaTest = 0, s.parent.add(g), s.renderOrder = 1, g.renderOrder = 2, o.renderOrder = 3;
        }
        const a = t.find((o)=>o.name.includes("Eye_Mesh"));
        i && await this.setHead(i), n && await this.setHair(n), a && await this.setEye(a);
    }
    setEye(e) {
        e.material.roughnessMap = null, e.material.roughness = 1;
        const t = e.clone();
        t.geometry = e.geometry.clone(), t.geometry.translate(0, 0, 1e-3), t.material = t.material = new $1W96c.MeshPhysicalMaterial({
            color: new $1W96c.Color(0.5, 0.5, 0.5),
            metalness: 0,
            roughness: 0,
            transmission: 1,
            transparent: !0,
            opacity: 0.5,
            side: $1W96c.FrontSide
        }), e.parent.add(t);
    }
    async setHair(e) {
        const t = e.material;
        t.alphaTest = t.reflectivity = t.specularIntensity = t.sheen = 0, t.side = $1W96c.DoubleSide, t.alphaHash = !1, t.premultipliedAlpha = !1, t.alphaToCoverage = !1;
        const i = e.clone(), n = e.clone();
        i.material = e.material.clone(), t.onBeforeCompile = (o)=>{
            o.fragmentShader = o.fragmentShader.replace("#include <alphamap_fragment>", $1W96c.ShaderChunk.alphamap_fragment.replace("diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g", "diffuseColor.a *= min(1.0, 0.10+texture2D( alphaMap, vAlphaMapUv ).g)"));
        }, n.material = e.material.clone(), e.name = "Hair", i.name = "HairClone", n.name = "Hair2Clone";
        const s = i.material;
        s.name = "HairMaterialClone";
        const a = n.material;
        a.name = "HairMaterial2Clone", t.opacity = 0.3, s.opacity = 0.5, a.transparent = a.alphaToCoverage = !0, a.alphaHash = !1, a.depthWrite = !1, a.alphaTest = 0, e.renderOrder = 1, i.renderOrder = 3, n.renderOrder = 2, e.parent.add(i), e.parent.add(n);
    }
    async setHead(e) {
        ja.cavityMap || (ja.cavityMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg"), ja.cavityMap.wrapS = ja.cavityMap.wrapT = $1W96c.RepeatWrapping), ja.microMap || (ja.microMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/micro.jpg"), ja.microMap.wrapS = ja.microMap.wrapT = $1W96c.RepeatWrapping), ja.microNormalMaskMap || (ja.microNormalMaskMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/normalMask.jpg"), ja.microNormalMaskMap.flipY = !0);
        const t = new $d7238066c5de7f1c$var$yB({
            color: e.material.color,
            metalness: e.material.metalness,
            roughness: e.material.roughness,
            map: e.material.map,
            normalMap: e.material.normalMap,
            normalScale: e.material.normalScale,
            roughnessMap: e.material.roughnessMap,
            metalnessMap: e.material.metalnessMap,
            side: $1W96c.DoubleSide,
            cavityMap: ja.cavityMap,
            attenuationDistance: 1e-3,
            thickness: 1e-3,
            attenuationColor: new $1W96c.Color(0.8, 0.4, 0.3),
            microNormalScale: new $1W96c.Vector2(50, 50),
            microNormalMap: ja.microMap,
            microMaskNormalMap: ja.microNormalMaskMap,
            cavityStrength: 0.7,
            cavityScale: new $1W96c.Vector2(20, 20)
        });
        e.material = t;
    }
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$LS, "cavityMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$LS, "microMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$LS, "microNormalMaskMap");
let $d7238066c5de7f1c$var$xIe = $d7238066c5de7f1c$var$LS;
const $d7238066c5de7f1c$var$YS = class qa extends $1W96c.Loader {
    constructor(e){
        super(e);
    }
    load(e, t, i, n) {
        $d7238066c5de7f1c$var$Kn.gltfLoader.load(e, (s)=>{
            this.setMaterial(s.scene).then(()=>{
                t(s.scene);
            });
        }, i, n);
    }
    loadAsync(e, t) {
        const i = this;
        return new Promise((n, s)=>{
            i.load(e, n, t, s);
        });
    }
    async setMaterial(e) {
        const t = [];
        e.castShadow = e.receiveShadow = !0, e.traverse((l)=>{
            var c;
            l.castShadow = l.receiveShadow = !0, l.isMesh && (t.push(l), l.material.premultipliedAlpha = !1);
            for(const d in l.material)d.toUpperCase().includes("MAP") && (c = l.material[d]) != null && c.anisotropy && (l.material[d].anisotropy = 8);
        });
        const i = t.filter((l)=>l.name.includes("Cornea")), n = t.find((l)=>l.name.includes("AvatarHead")), s = t.find((l)=>l.name.includes("haircut")), a = t.find((l)=>l.name.includes("AvatarLeftEyeball")), o = t.find((l)=>l.name.includes("AvatarRightEyeball")), g = t.find((l)=>l.name.includes("AvatarEyelashes"));
        i.forEach((l)=>{
            l.visible = !1;
        }), n && await this.setHead(n), s && await this.setHair(s), a && await this.setEye(a), o && await this.setEye(o), g && (g.material.transparent = !0, g.material.side = $1W96c.DoubleSide, g.material.opacity = 0.7);
    }
    setCornea(e) {
        e.material.dispose(), e.material = new $1W96c.MeshPhysicalMaterial({
            metalness: 0,
            roughness: 0,
            transmission: 1,
            transparent: !0,
            opacity: 0.5,
            side: $1W96c.FrontSide
        });
    }
    setEye(e) {
        var t;
        const i = e.clone();
        i.geometry = e.geometry.clone();
        const n = (t = i.geometry.boundingBox) == null ? void 0 : t.getCenter(new $1W96c.Vector3());
        i.geometry.translate(-n.x, -n.y, -n.z), i.geometry.rotateX(Math.PI / 2), i.geometry.translate(n.x, n.y, n.z), i.geometry.translate(0, 0, 1e-3), i.material = new $1W96c.MeshPhysicalMaterial({
            color: new $1W96c.Color(1, 1, 1),
            metalness: 0,
            roughness: 0,
            opacity: 0.8,
            transmission: 1,
            transparent: !0,
            side: $1W96c.FrontSide,
            premultipliedAlpha: !1
        }), e.parent.add(i);
    }
    async setHair(e) {
        e.material.alphaTest = e.material.reflectivity = e.material.specularIntensity = e.material.sheen = 0, e.material = new $1W96c.MeshPhysicalMaterial({
            color: e.material.color,
            metalness: e.material.metalness,
            roughness: e.material.roughness,
            map: e.material.map,
            normalMap: e.material.normalMap,
            normalScale: e.material.normalScale,
            roughnessMap: e.material.roughnessMap,
            metalnessMap: e.material.metalnessMap,
            side: $1W96c.DoubleSide,
            transparent: e.material.transparent,
            alphaTest: e.material.alphaTest,
            alphaMap: e.material.alphaMap,
            opacity: e.material.opacity,
            specularColor: new $1W96c.Color(1, 1, 1),
            sheen: 0.2,
            sheenRoughness: 0.5,
            sheenColor: new $1W96c.Color(1, 1, 1)
        }), e.material.premultipliedAlpha = !1;
        const t = e.material;
        t.side = $1W96c.DoubleSide, t.depthWrite = t.transparent = !1, t.transparent = !0, t.alphaToCoverage = !1;
        const i = e.clone();
        i.material = e.material.clone(), i.geometry = e.geometry.clone(), e.name = "Hair", i.name = "Hair2Clone";
        const n = i.material;
        n.side = $1W96c.FrontSide, n.alphaToCoverage = !0, n.depthWrite = !0, e.renderOrder = 1, i.renderOrder = 3, e.parent.add(i);
    }
    async setHead(e) {
        qa.cavityMap || (qa.cavityMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/cavity.jpg"), qa.cavityMap.wrapS = qa.cavityMap.wrapT = $1W96c.RepeatWrapping), qa.microMap || (qa.microMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/micro.jpg"), qa.microMap.wrapS = qa.microMap.wrapT = $1W96c.RepeatWrapping), qa.microNormalMaskMap || (qa.microNormalMaskMap = await $d7238066c5de7f1c$var$Kn.textureLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/characters/common/normalMask.jpg"), qa.microNormalMaskMap.flipY = !0);
        const t = new $d7238066c5de7f1c$var$yB({
            color: e.material.color,
            metalness: e.material.metalness,
            roughness: e.material.roughness,
            map: e.material.map,
            normalMap: e.material.normalMap,
            normalScale: e.material.normalScale,
            roughnessMap: e.material.roughnessMap,
            metalnessMap: e.material.metalnessMap,
            specularMap: e.material.specularMap,
            specularIntensity: e.material.specularIntensity,
            specularColor: e.material.specularColor,
            side: $1W96c.DoubleSide,
            cavityMap: qa.cavityMap,
            attenuationDistance: 1e-3,
            thickness: 1e-3,
            attenuationColor: new $1W96c.Color(0.8, 0.4, 0.3),
            microNormalScale: new $1W96c.Vector2(50, 50),
            microNormalMap: qa.microMap,
            microMaskNormalMap: qa.microNormalMaskMap,
            cavityStrength: 0.7,
            cavityScale: new $1W96c.Vector2(20, 20)
        });
        e.material = t;
    }
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$YS, "cavityMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$YS, "microMap"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$YS, "microNormalMaskMap");
let $d7238066c5de7f1c$var$FIe = $d7238066c5de7f1c$var$YS;
var $d7238066c5de7f1c$var$x_ = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0
}, $d7238066c5de7f1c$var$TY = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
}, $d7238066c5de7f1c$var$TIe = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
], $d7238066c5de7f1c$var$MZ = {
    CSS: {},
    springs: {}
};
function $d7238066c5de7f1c$var$eu(r, e, t) {
    return Math.min(Math.max(r, e), t);
}
function $d7238066c5de7f1c$var$Qy(r, e) {
    return r.indexOf(e) > -1;
}
function $d7238066c5de7f1c$var$UH(r, e) {
    return r.apply(null, e);
}
var $d7238066c5de7f1c$var$Ft = {
    arr: function(r) {
        return Array.isArray(r);
    },
    obj: function(r) {
        return $d7238066c5de7f1c$var$Qy(Object.prototype.toString.call(r), "Object");
    },
    pth: function(r) {
        return $d7238066c5de7f1c$var$Ft.obj(r) && r.hasOwnProperty("totalLength");
    },
    svg: function(r) {
        return r instanceof SVGElement;
    },
    inp: function(r) {
        return r instanceof HTMLInputElement;
    },
    dom: function(r) {
        return r.nodeType || $d7238066c5de7f1c$var$Ft.svg(r);
    },
    str: function(r) {
        return typeof r == "string";
    },
    fnc: function(r) {
        return typeof r == "function";
    },
    und: function(r) {
        return typeof r > "u";
    },
    nil: function(r) {
        return $d7238066c5de7f1c$var$Ft.und(r) || r === null;
    },
    hex: function(r) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(r);
    },
    rgb: function(r) {
        return /^rgb/.test(r);
    },
    hsl: function(r) {
        return /^hsl/.test(r);
    },
    col: function(r) {
        return $d7238066c5de7f1c$var$Ft.hex(r) || $d7238066c5de7f1c$var$Ft.rgb(r) || $d7238066c5de7f1c$var$Ft.hsl(r);
    },
    key: function(r) {
        return !$d7238066c5de7f1c$var$x_.hasOwnProperty(r) && !$d7238066c5de7f1c$var$TY.hasOwnProperty(r) && r !== "targets" && r !== "keyframes";
    }
};
function $d7238066c5de7f1c$var$F_(r) {
    var e = /\(([^)]+)\)/.exec(r);
    return e ? e[1].split(",").map(function(t) {
        return parseFloat(t);
    }) : [];
}
function $d7238066c5de7f1c$var$T_(r, e) {
    var t = $d7238066c5de7f1c$var$F_(r), i = $d7238066c5de7f1c$var$eu($d7238066c5de7f1c$var$Ft.und(t[0]) ? 1 : t[0], 0.1, 100), n = $d7238066c5de7f1c$var$eu($d7238066c5de7f1c$var$Ft.und(t[1]) ? 100 : t[1], 0.1, 100), s = $d7238066c5de7f1c$var$eu($d7238066c5de7f1c$var$Ft.und(t[2]) ? 10 : t[2], 0.1, 100), a = $d7238066c5de7f1c$var$eu($d7238066c5de7f1c$var$Ft.und(t[3]) ? 0 : t[3], 0.1, 100), o = Math.sqrt(n / i), g = s / (2 * Math.sqrt(n * i)), l = g < 1 ? o * Math.sqrt(1 - g * g) : 0, c = 1, d = g < 1 ? (g * o + -a) / l : -a + o;
    function p(y) {
        var G = e ? e * y / 1e3 : y;
        return g < 1 ? G = Math.exp(-G * g * o) * (c * Math.cos(l * G) + d * Math.sin(l * G)) : G = (c + d * G) * Math.exp(-G * o), y === 0 || y === 1 ? y : 1 - G;
    }
    function A() {
        var y = $d7238066c5de7f1c$var$MZ.springs[r];
        if (y) return y;
        for(var G = 1 / 6, Z = 0, v = 0;;)if (Z += G, p(Z) === 1) {
            if (v++, v >= 16) break;
        } else v = 0;
        var V = Z * G * 1e3;
        return $d7238066c5de7f1c$var$MZ.springs[r] = V, V;
    }
    return e ? p : A;
}
function $d7238066c5de7f1c$var$MIe(r) {
    return r === void 0 && (r = 10), function(e) {
        return Math.ceil($d7238066c5de7f1c$var$eu(e, 1e-6, 1) * r) * (1 / r);
    };
}
var $d7238066c5de7f1c$var$zIe = function() {
    var r = 11, e = 1 / (r - 1);
    function t(c, d) {
        return 1 - 3 * d + 3 * c;
    }
    function i(c, d) {
        return 3 * d - 6 * c;
    }
    function n(c) {
        return 3 * c;
    }
    function s(c, d, p) {
        return ((t(d, p) * c + i(d, p)) * c + n(d)) * c;
    }
    function a(c, d, p) {
        return 3 * t(d, p) * c * c + 2 * i(d, p) * c + n(d);
    }
    function o(c, d, p, A, y) {
        var G, Z, v = 0;
        do Z = d + (p - d) / 2, G = s(Z, A, y) - c, G > 0 ? p = Z : d = Z;
        while (Math.abs(G) > 1e-7 && ++v < 10);
        return Z;
    }
    function g(c, d, p, A) {
        for(var y = 0; y < 4; ++y){
            var G = a(d, p, A);
            if (G === 0) return d;
            var Z = s(d, p, A) - c;
            d -= Z / G;
        }
        return d;
    }
    function l(c, d, p, A) {
        if (!(0 <= c && c <= 1 && 0 <= p && p <= 1)) return;
        var y = new Float32Array(r);
        if (c !== d || p !== A) for(var G = 0; G < r; ++G)y[G] = s(G * e, c, p);
        function Z(v) {
            for(var V = 0, H = 1, N = r - 1; H !== N && y[H] <= v; ++H)V += e;
            --H;
            var Y = (v - y[H]) / (y[H + 1] - y[H]), K = V + Y * e, z = a(K, c, p);
            return z >= 1e-3 ? g(v, K, c, p) : z === 0 ? K : o(v, V, V + e, c, p);
        }
        return function(v) {
            return c === d && p === A || v === 0 || v === 1 ? v : s(Z(v), d, A);
        };
    }
    return l;
}(), $d7238066c5de7f1c$var$M_ = function() {
    var r = {
        linear: function() {
            return function(i) {
                return i;
            };
        }
    }, e = {
        Sine: function() {
            return function(i) {
                return 1 - Math.cos(i * Math.PI / 2);
            };
        },
        Expo: function() {
            return function(i) {
                return i ? Math.pow(2, 10 * i - 10) : 0;
            };
        },
        Circ: function() {
            return function(i) {
                return 1 - Math.sqrt(1 - i * i);
            };
        },
        Back: function() {
            return function(i) {
                return i * i * (3 * i - 2);
            };
        },
        Bounce: function() {
            return function(i) {
                for(var n, s = 4; i < ((n = Math.pow(2, --s)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - s) - 7.5625 * Math.pow((n * 3 - 2) / 22 - i, 2);
            };
        },
        Elastic: function(i, n) {
            i === void 0 && (i = 1), n === void 0 && (n = 0.5);
            var s = $d7238066c5de7f1c$var$eu(i, 1, 10), a = $d7238066c5de7f1c$var$eu(n, 0.1, 2);
            return function(o) {
                return o === 0 || o === 1 ? o : -s * Math.pow(2, 10 * (o - 1)) * Math.sin((o - 1 - a / (Math.PI * 2) * Math.asin(1 / s)) * (Math.PI * 2) / a);
            };
        }
    }, t = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint"
    ];
    return t.forEach(function(i, n) {
        e[i] = function() {
            return function(s) {
                return Math.pow(s, n + 2);
            };
        };
    }), Object.keys(e).forEach(function(i) {
        var n = e[i];
        r["easeIn" + i] = n, r["easeOut" + i] = function(s, a) {
            return function(o) {
                return 1 - n(s, a)(1 - o);
            };
        }, r["easeInOut" + i] = function(s, a) {
            return function(o) {
                return o < 0.5 ? n(s, a)(o * 2) / 2 : 1 - n(s, a)(o * -2 + 2) / 2;
            };
        }, r["easeOutIn" + i] = function(s, a) {
            return function(o) {
                return o < 0.5 ? (1 - n(s, a)(1 - o * 2)) / 2 : (n(s, a)(o * 2 - 1) + 1) / 2;
            };
        };
    }), r;
}();
function $d7238066c5de7f1c$var$MY(r, e) {
    if ($d7238066c5de7f1c$var$Ft.fnc(r)) return r;
    var t = r.split("(")[0], i = $d7238066c5de7f1c$var$M_[t], n = $d7238066c5de7f1c$var$F_(r);
    switch(t){
        case "spring":
            return $d7238066c5de7f1c$var$T_(r, e);
        case "cubicBezier":
            return $d7238066c5de7f1c$var$UH($d7238066c5de7f1c$var$zIe, n);
        case "steps":
            return $d7238066c5de7f1c$var$UH($d7238066c5de7f1c$var$MIe, n);
        default:
            return $d7238066c5de7f1c$var$UH(i, n);
    }
}
function $d7238066c5de7f1c$var$z_(r) {
    try {
        var e = document.querySelectorAll(r);
        return e;
    } catch  {
        return;
    }
}
function $d7238066c5de7f1c$var$ER(r, e) {
    for(var t = r.length, i = arguments.length >= 2 ? arguments[1] : void 0, n = [], s = 0; s < t; s++)if (s in r) {
        var a = r[s];
        e.call(i, a, s, r) && n.push(a);
    }
    return n;
}
function $d7238066c5de7f1c$var$JR(r) {
    return r.reduce(function(e, t) {
        return e.concat($d7238066c5de7f1c$var$Ft.arr(t) ? $d7238066c5de7f1c$var$JR(t) : t);
    }, []);
}
function $d7238066c5de7f1c$var$lT(r) {
    return $d7238066c5de7f1c$var$Ft.arr(r) ? r : ($d7238066c5de7f1c$var$Ft.str(r) && (r = $d7238066c5de7f1c$var$z_(r) || r), r instanceof NodeList || r instanceof HTMLCollection ? [].slice.call(r) : [
        r
    ]);
}
function $d7238066c5de7f1c$var$zY(r, e) {
    return r.some(function(t) {
        return t === e;
    });
}
function $d7238066c5de7f1c$var$kY(r) {
    var e = {};
    for(var t in r)e[t] = r[t];
    return e;
}
function $d7238066c5de7f1c$var$q2(r, e) {
    var t = $d7238066c5de7f1c$var$kY(r);
    for(var i in r)t[i] = e.hasOwnProperty(i) ? e[i] : r[i];
    return t;
}
function $d7238066c5de7f1c$var$UR(r, e) {
    var t = $d7238066c5de7f1c$var$kY(r);
    for(var i in e)t[i] = $d7238066c5de7f1c$var$Ft.und(r[i]) ? e[i] : r[i];
    return t;
}
function $d7238066c5de7f1c$var$kIe(r) {
    var e = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(r);
    return e ? "rgba(" + e[1] + ",1)" : r;
}
function $d7238066c5de7f1c$var$EIe(r) {
    var e = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, t = r.replace(e, function(o, g, l, c) {
        return g + g + l + l + c + c;
    }), i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t), n = parseInt(i[1], 16), s = parseInt(i[2], 16), a = parseInt(i[3], 16);
    return "rgba(" + n + "," + s + "," + a + ",1)";
}
function $d7238066c5de7f1c$var$JIe(r) {
    var e = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(r) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(r), t = parseInt(e[1], 10) / 360, i = parseInt(e[2], 10) / 100, n = parseInt(e[3], 10) / 100, s = e[4] || 1;
    function a(p, A, y) {
        return y < 0 && (y += 1), y > 1 && (y -= 1), y < 1 / 6 ? p + (A - p) * 6 * y : y < 0.5 ? A : y < 2 / 3 ? p + (A - p) * (2 / 3 - y) * 6 : p;
    }
    var o, g, l;
    if (i == 0) o = g = l = n;
    else {
        var c = n < 0.5 ? n * (1 + i) : n + i - n * i, d = 2 * n - c;
        o = a(d, c, t + 1 / 3), g = a(d, c, t), l = a(d, c, t - 1 / 3);
    }
    return "rgba(" + o * 255 + "," + g * 255 + "," + l * 255 + "," + s + ")";
}
function $d7238066c5de7f1c$var$UIe(r) {
    if ($d7238066c5de7f1c$var$Ft.rgb(r)) return $d7238066c5de7f1c$var$kIe(r);
    if ($d7238066c5de7f1c$var$Ft.hex(r)) return $d7238066c5de7f1c$var$EIe(r);
    if ($d7238066c5de7f1c$var$Ft.hsl(r)) return $d7238066c5de7f1c$var$JIe(r);
}
function $d7238066c5de7f1c$var$bI(r) {
    var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(r);
    if (e) return e[1];
}
function $d7238066c5de7f1c$var$DIe(r) {
    if ($d7238066c5de7f1c$var$Qy(r, "translate") || r === "perspective") return "px";
    if ($d7238066c5de7f1c$var$Qy(r, "rotate") || $d7238066c5de7f1c$var$Qy(r, "skew")) return "deg";
}
function $d7238066c5de7f1c$var$$2(r, e) {
    return $d7238066c5de7f1c$var$Ft.fnc(r) ? r(e.target, e.id, e.total) : r;
}
function $d7238066c5de7f1c$var$tu(r, e) {
    return r.getAttribute(e);
}
function $d7238066c5de7f1c$var$EY(r, e, t) {
    var i = $d7238066c5de7f1c$var$bI(e);
    if ($d7238066c5de7f1c$var$zY([
        t,
        "deg",
        "rad",
        "turn"
    ], i)) return e;
    var n = $d7238066c5de7f1c$var$MZ.CSS[e + t];
    if (!$d7238066c5de7f1c$var$Ft.und(n)) return n;
    var s = 100, a = document.createElement(r.tagName), o = r.parentNode && r.parentNode !== document ? r.parentNode : document.body;
    o.appendChild(a), a.style.position = "absolute", a.style.width = s + t;
    var g = s / a.offsetWidth;
    o.removeChild(a);
    var l = g * parseFloat(e);
    return $d7238066c5de7f1c$var$MZ.CSS[e + t] = l, l;
}
function $d7238066c5de7f1c$var$k_(r, e, t) {
    if (e in r.style) {
        var i = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), n = r.style[e] || getComputedStyle(r).getPropertyValue(i) || "0";
        return t ? $d7238066c5de7f1c$var$EY(r, n, t) : n;
    }
}
function $d7238066c5de7f1c$var$JY(r, e) {
    if ($d7238066c5de7f1c$var$Ft.dom(r) && !$d7238066c5de7f1c$var$Ft.inp(r) && (!$d7238066c5de7f1c$var$Ft.nil($d7238066c5de7f1c$var$tu(r, e)) || $d7238066c5de7f1c$var$Ft.svg(r) && r[e])) return "attribute";
    if ($d7238066c5de7f1c$var$Ft.dom(r) && $d7238066c5de7f1c$var$zY($d7238066c5de7f1c$var$TIe, e)) return "transform";
    if ($d7238066c5de7f1c$var$Ft.dom(r) && e !== "transform" && $d7238066c5de7f1c$var$k_(r, e)) return "css";
    if (r[e] != null) return "object";
}
function $d7238066c5de7f1c$var$E_(r) {
    if ($d7238066c5de7f1c$var$Ft.dom(r)) {
        for(var e = r.style.transform || "", t = /(\w+)\(([^)]*)\)/g, i = /* @__PURE__ */ new Map(), n; n = t.exec(e);)i.set(n[1], n[2]);
        return i;
    }
}
function $d7238066c5de7f1c$var$_Ie(r, e, t, i) {
    var n = $d7238066c5de7f1c$var$Qy(e, "scale") ? 1 : 0 + $d7238066c5de7f1c$var$DIe(e), s = $d7238066c5de7f1c$var$E_(r).get(e) || n;
    return t && (t.transforms.list.set(e, s), t.transforms.last = e), i ? $d7238066c5de7f1c$var$EY(r, s, i) : s;
}
function $d7238066c5de7f1c$var$UY(r, e, t, i) {
    switch($d7238066c5de7f1c$var$JY(r, e)){
        case "transform":
            return $d7238066c5de7f1c$var$_Ie(r, e, i, t);
        case "css":
            return $d7238066c5de7f1c$var$k_(r, e, t);
        case "attribute":
            return $d7238066c5de7f1c$var$tu(r, e);
        default:
            return r[e] || 0;
    }
}
function $d7238066c5de7f1c$var$DY(r, e) {
    var t = /^(\*=|\+=|-=)/.exec(r);
    if (!t) return r;
    var i = $d7238066c5de7f1c$var$bI(r) || 0, n = parseFloat(e), s = parseFloat(r.replace(t[0], ""));
    switch(t[0][0]){
        case "+":
            return n + s + i;
        case "-":
            return n - s + i;
        case "*":
            return n * s + i;
    }
}
function $d7238066c5de7f1c$var$J_(r, e) {
    if ($d7238066c5de7f1c$var$Ft.col(r)) return $d7238066c5de7f1c$var$UIe(r);
    if (/\s/g.test(r)) return r;
    var t = $d7238066c5de7f1c$var$bI(r), i = t ? r.substr(0, r.length - t.length) : r;
    return e ? i + e : i;
}
function $d7238066c5de7f1c$var$_Y(r, e) {
    return Math.sqrt(Math.pow(e.x - r.x, 2) + Math.pow(e.y - r.y, 2));
}
function $d7238066c5de7f1c$var$PIe(r) {
    return Math.PI * 2 * $d7238066c5de7f1c$var$tu(r, "r");
}
function $d7238066c5de7f1c$var$QIe(r) {
    return $d7238066c5de7f1c$var$tu(r, "width") * 2 + $d7238066c5de7f1c$var$tu(r, "height") * 2;
}
function $d7238066c5de7f1c$var$OIe(r) {
    return $d7238066c5de7f1c$var$_Y({
        x: $d7238066c5de7f1c$var$tu(r, "x1"),
        y: $d7238066c5de7f1c$var$tu(r, "y1")
    }, {
        x: $d7238066c5de7f1c$var$tu(r, "x2"),
        y: $d7238066c5de7f1c$var$tu(r, "y2")
    });
}
function $d7238066c5de7f1c$var$U_(r) {
    for(var e = r.points, t = 0, i, n = 0; n < e.numberOfItems; n++){
        var s = e.getItem(n);
        n > 0 && (t += $d7238066c5de7f1c$var$_Y(i, s)), i = s;
    }
    return t;
}
function $d7238066c5de7f1c$var$jIe(r) {
    var e = r.points;
    return $d7238066c5de7f1c$var$U_(r) + $d7238066c5de7f1c$var$_Y(e.getItem(e.numberOfItems - 1), e.getItem(0));
}
function $d7238066c5de7f1c$var$D_(r) {
    if (r.getTotalLength) return r.getTotalLength();
    switch(r.tagName.toLowerCase()){
        case "circle":
            return $d7238066c5de7f1c$var$PIe(r);
        case "rect":
            return $d7238066c5de7f1c$var$QIe(r);
        case "line":
            return $d7238066c5de7f1c$var$OIe(r);
        case "polyline":
            return $d7238066c5de7f1c$var$U_(r);
        case "polygon":
            return $d7238066c5de7f1c$var$jIe(r);
    }
}
function $d7238066c5de7f1c$var$qIe(r) {
    var e = $d7238066c5de7f1c$var$D_(r);
    return r.setAttribute("stroke-dasharray", e), e;
}
function $d7238066c5de7f1c$var$$Ie(r) {
    for(var e = r.parentNode; $d7238066c5de7f1c$var$Ft.svg(e) && $d7238066c5de7f1c$var$Ft.svg(e.parentNode);)e = e.parentNode;
    return e;
}
function $d7238066c5de7f1c$var$__(r, e) {
    var t = e || {}, i = t.el || $d7238066c5de7f1c$var$$Ie(r), n = i.getBoundingClientRect(), s = $d7238066c5de7f1c$var$tu(i, "viewBox"), a = n.width, o = n.height, g = t.viewBox || (s ? s.split(" ") : [
        0,
        0,
        a,
        o
    ]);
    return {
        el: i,
        viewBox: g,
        x: g[0] / 1,
        y: g[1] / 1,
        w: a,
        h: o,
        vW: g[2],
        vH: g[3]
    };
}
function $d7238066c5de7f1c$var$ede(r, e) {
    var t = $d7238066c5de7f1c$var$Ft.str(r) ? $d7238066c5de7f1c$var$z_(r)[0] : r, i = e || 100;
    return function(n) {
        return {
            property: n,
            el: t,
            svg: $d7238066c5de7f1c$var$__(t),
            totalLength: $d7238066c5de7f1c$var$D_(t) * (i / 100)
        };
    };
}
function $d7238066c5de7f1c$var$tde(r, e, t) {
    function i(c) {
        c === void 0 && (c = 0);
        var d = e + c >= 1 ? e + c : 0;
        return r.el.getPointAtLength(d);
    }
    var n = $d7238066c5de7f1c$var$__(r.el, r.svg), s = i(), a = i(-1), o = i(1), g = t ? 1 : n.w / n.vW, l = t ? 1 : n.h / n.vH;
    switch(r.property){
        case "x":
            return (s.x - n.x) * g;
        case "y":
            return (s.y - n.y) * l;
        case "angle":
            return Math.atan2(o.y - a.y, o.x - a.x) * 180 / Math.PI;
    }
}
function $d7238066c5de7f1c$var$cT(r, e) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, i = $d7238066c5de7f1c$var$J_($d7238066c5de7f1c$var$Ft.pth(r) ? r.totalLength : r, e) + "";
    return {
        original: i,
        numbers: i.match(t) ? i.match(t).map(Number) : [
            0
        ],
        strings: $d7238066c5de7f1c$var$Ft.str(r) || e ? i.split(t) : []
    };
}
function $d7238066c5de7f1c$var$PY(r) {
    var e = r ? $d7238066c5de7f1c$var$JR($d7238066c5de7f1c$var$Ft.arr(r) ? r.map($d7238066c5de7f1c$var$lT) : $d7238066c5de7f1c$var$lT(r)) : [];
    return $d7238066c5de7f1c$var$ER(e, function(t, i, n) {
        return n.indexOf(t) === i;
    });
}
function $d7238066c5de7f1c$var$P_(r) {
    var e = $d7238066c5de7f1c$var$PY(r);
    return e.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: e.length,
            transforms: {
                list: $d7238066c5de7f1c$var$E_(t)
            }
        };
    });
}
function $d7238066c5de7f1c$var$ide(r, e) {
    var t = $d7238066c5de7f1c$var$kY(e);
    if (/^spring/.test(t.easing) && (t.duration = $d7238066c5de7f1c$var$T_(t.easing)), $d7238066c5de7f1c$var$Ft.arr(r)) {
        var i = r.length, n = i === 2 && !$d7238066c5de7f1c$var$Ft.obj(r[0]);
        n ? r = {
            value: r
        } : $d7238066c5de7f1c$var$Ft.fnc(e.duration) || (t.duration = e.duration / i);
    }
    var s = $d7238066c5de7f1c$var$Ft.arr(r) ? r : [
        r
    ];
    return s.map(function(a, o) {
        var g = $d7238066c5de7f1c$var$Ft.obj(a) && !$d7238066c5de7f1c$var$Ft.pth(a) ? a : {
            value: a
        };
        return $d7238066c5de7f1c$var$Ft.und(g.delay) && (g.delay = o ? 0 : e.delay), $d7238066c5de7f1c$var$Ft.und(g.endDelay) && (g.endDelay = o === s.length - 1 ? e.endDelay : 0), g;
    }).map(function(a) {
        return $d7238066c5de7f1c$var$UR(a, t);
    });
}
function $d7238066c5de7f1c$var$nde(r) {
    for(var e = $d7238066c5de7f1c$var$ER($d7238066c5de7f1c$var$JR(r.map(function(s) {
        return Object.keys(s);
    })), function(s) {
        return $d7238066c5de7f1c$var$Ft.key(s);
    }).reduce(function(s, a) {
        return s.indexOf(a) < 0 && s.push(a), s;
    }, []), t = {}, i = function(s) {
        var a = e[s];
        t[a] = r.map(function(o) {
            var g = {};
            for(var l in o)$d7238066c5de7f1c$var$Ft.key(l) ? l == a && (g.value = o[l]) : g[l] = o[l];
            return g;
        });
    }, n = 0; n < e.length; n++)i(n);
    return t;
}
function $d7238066c5de7f1c$var$sde(r, e) {
    var t = [], i = e.keyframes;
    i && (e = $d7238066c5de7f1c$var$UR($d7238066c5de7f1c$var$nde(i), e));
    for(var n in e)$d7238066c5de7f1c$var$Ft.key(n) && t.push({
        name: n,
        tweens: $d7238066c5de7f1c$var$ide(e[n], r)
    });
    return t;
}
function $d7238066c5de7f1c$var$rde(r, e) {
    var t = {};
    for(var i in r){
        var n = $d7238066c5de7f1c$var$$2(r[i], e);
        $d7238066c5de7f1c$var$Ft.arr(n) && (n = n.map(function(s) {
            return $d7238066c5de7f1c$var$$2(s, e);
        }), n.length === 1 && (n = n[0])), t[i] = n;
    }
    return t.duration = parseFloat(t.duration), t.delay = parseFloat(t.delay), t;
}
function $d7238066c5de7f1c$var$ade(r, e) {
    var t;
    return r.tweens.map(function(i) {
        var n = $d7238066c5de7f1c$var$rde(i, e), s = n.value, a = $d7238066c5de7f1c$var$Ft.arr(s) ? s[1] : s, o = $d7238066c5de7f1c$var$bI(a), g = $d7238066c5de7f1c$var$UY(e.target, r.name, o, e), l = t ? t.to.original : g, c = $d7238066c5de7f1c$var$Ft.arr(s) ? s[0] : l, d = $d7238066c5de7f1c$var$bI(c) || $d7238066c5de7f1c$var$bI(g), p = o || d;
        return $d7238066c5de7f1c$var$Ft.und(a) && (a = l), n.from = $d7238066c5de7f1c$var$cT(c, p), n.to = $d7238066c5de7f1c$var$cT($d7238066c5de7f1c$var$DY(a, c), p), n.start = t ? t.end : 0, n.end = n.start + n.delay + n.duration + n.endDelay, n.easing = $d7238066c5de7f1c$var$MY(n.easing, n.duration), n.isPath = $d7238066c5de7f1c$var$Ft.pth(s), n.isPathTargetInsideSVG = n.isPath && $d7238066c5de7f1c$var$Ft.svg(e.target), n.isColor = $d7238066c5de7f1c$var$Ft.col(n.from.original), n.isColor && (n.round = 1), t = n, n;
    });
}
var $d7238066c5de7f1c$var$Q_ = {
    css: function(r, e, t) {
        return r.style[e] = t;
    },
    attribute: function(r, e, t) {
        return r.setAttribute(e, t);
    },
    object: function(r, e, t) {
        return r[e] = t;
    },
    transform: function(r, e, t, i, n) {
        if (i.list.set(e, t), e === i.last || n) {
            var s = "";
            i.list.forEach(function(a, o) {
                s += o + "(" + a + ") ";
            }), r.style.transform = s;
        }
    }
};
function $d7238066c5de7f1c$var$O_(r, e) {
    var t = $d7238066c5de7f1c$var$P_(r);
    t.forEach(function(i) {
        for(var n in e){
            var s = $d7238066c5de7f1c$var$$2(e[n], i), a = i.target, o = $d7238066c5de7f1c$var$bI(s), g = $d7238066c5de7f1c$var$UY(a, n, o, i), l = o || $d7238066c5de7f1c$var$bI(g), c = $d7238066c5de7f1c$var$DY($d7238066c5de7f1c$var$J_(s, l), g), d = $d7238066c5de7f1c$var$JY(a, n);
            $d7238066c5de7f1c$var$Q_[d](a, n, c, i.transforms, !0);
        }
    });
}
function $d7238066c5de7f1c$var$ode(r, e) {
    var t = $d7238066c5de7f1c$var$JY(r.target, e.name);
    if (t) {
        var i = $d7238066c5de7f1c$var$ade(e, r), n = i[i.length - 1];
        return {
            type: t,
            property: e.name,
            animatable: r,
            tweens: i,
            duration: n.end,
            delay: i[0].delay,
            endDelay: n.endDelay
        };
    }
}
function $d7238066c5de7f1c$var$gde(r, e) {
    return $d7238066c5de7f1c$var$ER($d7238066c5de7f1c$var$JR(r.map(function(t) {
        return e.map(function(i) {
            return $d7238066c5de7f1c$var$ode(t, i);
        });
    })), function(t) {
        return !$d7238066c5de7f1c$var$Ft.und(t);
    });
}
function $d7238066c5de7f1c$var$j_(r, e) {
    var t = r.length, i = function(s) {
        return s.timelineOffset ? s.timelineOffset : 0;
    }, n = {};
    return n.duration = t ? Math.max.apply(Math, r.map(function(s) {
        return i(s) + s.duration;
    })) : e.duration, n.delay = t ? Math.min.apply(Math, r.map(function(s) {
        return i(s) + s.delay;
    })) : e.delay, n.endDelay = t ? n.duration - Math.max.apply(Math, r.map(function(s) {
        return i(s) + s.duration - s.endDelay;
    })) : e.endDelay, n;
}
var $d7238066c5de7f1c$var$uT = 0;
function $d7238066c5de7f1c$var$lde(r) {
    var e = $d7238066c5de7f1c$var$q2($d7238066c5de7f1c$var$x_, r), t = $d7238066c5de7f1c$var$q2($d7238066c5de7f1c$var$TY, r), i = $d7238066c5de7f1c$var$sde(t, r), n = $d7238066c5de7f1c$var$P_(r.targets), s = $d7238066c5de7f1c$var$gde(n, i), a = $d7238066c5de7f1c$var$j_(s, t), o = $d7238066c5de7f1c$var$uT;
    return $d7238066c5de7f1c$var$uT++, $d7238066c5de7f1c$var$UR(e, {
        id: o,
        children: [],
        animatables: n,
        animations: s,
        duration: a.duration,
        delay: a.delay,
        endDelay: a.endDelay
    });
}
var $d7238066c5de7f1c$var$Ol = [], $d7238066c5de7f1c$var$q_ = function() {
    var r;
    function e() {
        !r && (!$d7238066c5de7f1c$var$IT() || !$d7238066c5de7f1c$var$ci.suspendWhenDocumentHidden) && $d7238066c5de7f1c$var$Ol.length > 0 && (r = requestAnimationFrame(t));
    }
    function t(n) {
        for(var s = $d7238066c5de7f1c$var$Ol.length, a = 0; a < s;){
            var o = $d7238066c5de7f1c$var$Ol[a];
            o.paused ? ($d7238066c5de7f1c$var$Ol.splice(a, 1), s--) : (o.tick(n), a++);
        }
        r = a > 0 ? requestAnimationFrame(t) : void 0;
    }
    function i() {
        $d7238066c5de7f1c$var$ci.suspendWhenDocumentHidden && ($d7238066c5de7f1c$var$IT() ? r = cancelAnimationFrame(r) : ($d7238066c5de7f1c$var$Ol.forEach(function(n) {
            return n._onDocumentVisibility();
        }), $d7238066c5de7f1c$var$q_()));
    }
    return typeof document < "u" && document.addEventListener("visibilitychange", i), e;
}();
function $d7238066c5de7f1c$var$IT() {
    return !!document && document.hidden;
}
function $d7238066c5de7f1c$var$ci(r) {
    r === void 0 && (r = {});
    var e = 0, t = 0, i = 0, n, s = 0, a = null;
    function o(V) {
        var H = window.Promise && new Promise(function(N) {
            return a = N;
        });
        return V.finished = H, H;
    }
    var g = $d7238066c5de7f1c$var$lde(r);
    o(g);
    function l() {
        var V = g.direction;
        V !== "alternate" && (g.direction = V !== "normal" ? "normal" : "reverse"), g.reversed = !g.reversed, n.forEach(function(H) {
            return H.reversed = g.reversed;
        });
    }
    function c(V) {
        return g.reversed ? g.duration - V : V;
    }
    function d() {
        e = 0, t = c(g.currentTime) * (1 / $d7238066c5de7f1c$var$ci.speed);
    }
    function p(V, H) {
        H && H.seek(V - H.timelineOffset);
    }
    function A(V) {
        if (g.reversePlayback) for(var H = s; H--;)p(V, n[H]);
        else for(var N = 0; N < s; N++)p(V, n[N]);
    }
    function y(V) {
        for(var H = 0, N = g.animations, Y = N.length; H < Y;){
            var K = N[H], z = K.animatable, M = K.tweens, _ = M.length - 1, O = M[_];
            _ && (O = $d7238066c5de7f1c$var$ER(M, function(st) {
                return V < st.end;
            })[0] || O);
            for(var ie = $d7238066c5de7f1c$var$eu(V - O.start - O.delay, 0, O.duration) / O.duration, he = isNaN(ie) ? 1 : O.easing(ie), pe = O.to.strings, ce = O.round, $ = [], te = O.to.numbers.length, Ge = void 0, q = 0; q < te; q++){
                var de = void 0, ge = O.to.numbers[q], Ye = O.from.numbers[q] || 0;
                O.isPath ? de = $d7238066c5de7f1c$var$tde(O.value, he * ge, O.isPathTargetInsideSVG) : de = Ye + he * (ge - Ye), ce && (O.isColor && q > 2 || (de = Math.round(de * ce) / ce)), $.push(de);
            }
            var Fe = pe.length;
            if (!Fe) Ge = $[0];
            else {
                Ge = pe[0];
                for(var Xe = 0; Xe < Fe; Xe++){
                    pe[Xe];
                    var Te = pe[Xe + 1], ct = $[Xe];
                    isNaN(ct) || (Te ? Ge += ct + Te : Ge += ct + " ");
                }
            }
            $d7238066c5de7f1c$var$Q_[K.type](z.target, K.property, Ge, z.transforms), K.currentValue = Ge, H++;
        }
    }
    function G(V) {
        g[V] && !g.passThrough && g[V](g);
    }
    function Z() {
        g.remaining && g.remaining !== !0 && g.remaining--;
    }
    function v(V) {
        var H = g.duration, N = g.delay, Y = H - g.endDelay, K = c(V);
        g.progress = $d7238066c5de7f1c$var$eu(K / H * 100, 0, 100), g.reversePlayback = K < g.currentTime, n && A(K), !g.began && g.currentTime > 0 && (g.began = !0, G("begin")), !g.loopBegan && g.currentTime > 0 && (g.loopBegan = !0, G("loopBegin")), K <= N && g.currentTime !== 0 && y(0), (K >= Y && g.currentTime !== H || !H) && y(H), K > N && K < Y ? (g.changeBegan || (g.changeBegan = !0, g.changeCompleted = !1, G("changeBegin")), G("change"), y(K)) : g.changeBegan && (g.changeCompleted = !0, g.changeBegan = !1, G("changeComplete")), g.currentTime = $d7238066c5de7f1c$var$eu(K, 0, H), g.began && G("update"), V >= H && (t = 0, Z(), g.remaining ? (e = i, G("loopComplete"), g.loopBegan = !1, g.direction === "alternate" && l()) : (g.paused = !0, g.completed || (g.completed = !0, G("loopComplete"), G("complete"), !g.passThrough && "Promise" in window && (a(), o(g)))));
    }
    return g.reset = function() {
        var V = g.direction;
        g.passThrough = !1, g.currentTime = 0, g.progress = 0, g.paused = !0, g.began = !1, g.loopBegan = !1, g.changeBegan = !1, g.completed = !1, g.changeCompleted = !1, g.reversePlayback = !1, g.reversed = V === "reverse", g.remaining = g.loop, n = g.children, s = n.length;
        for(var H = s; H--;)g.children[H].reset();
        (g.reversed && g.loop !== !0 || V === "alternate" && g.loop === 1) && g.remaining++, y(g.reversed ? g.duration : 0);
    }, g._onDocumentVisibility = d, g.set = function(V, H) {
        return $d7238066c5de7f1c$var$O_(V, H), g;
    }, g.tick = function(V) {
        i = V, e || (e = i), v((i + (t - e)) * $d7238066c5de7f1c$var$ci.speed);
    }, g.seek = function(V) {
        v(c(V));
    }, g.pause = function() {
        g.paused = !0, d();
    }, g.play = function() {
        g.paused && (g.completed && g.reset(), g.paused = !1, $d7238066c5de7f1c$var$Ol.push(g), d(), $d7238066c5de7f1c$var$q_());
    }, g.reverse = function() {
        l(), g.completed = !g.reversed, d();
    }, g.restart = function() {
        g.reset(), g.play();
    }, g.remove = function(V) {
        var H = $d7238066c5de7f1c$var$PY(V);
        $d7238066c5de7f1c$var$$_(H, g);
    }, g.reset(), g.autoplay && g.play(), g;
}
function $d7238066c5de7f1c$var$dT(r, e) {
    for(var t = e.length; t--;)$d7238066c5de7f1c$var$zY(r, e[t].animatable.target) && e.splice(t, 1);
}
function $d7238066c5de7f1c$var$$_(r, e) {
    var t = e.animations, i = e.children;
    $d7238066c5de7f1c$var$dT(r, t);
    for(var n = i.length; n--;){
        var s = i[n], a = s.animations;
        $d7238066c5de7f1c$var$dT(r, a), !a.length && !s.children.length && i.splice(n, 1);
    }
    !t.length && !i.length && e.pause();
}
function $d7238066c5de7f1c$var$cde(r) {
    for(var e = $d7238066c5de7f1c$var$PY(r), t = $d7238066c5de7f1c$var$Ol.length; t--;){
        var i = $d7238066c5de7f1c$var$Ol[t];
        $d7238066c5de7f1c$var$$_(e, i);
    }
}
function $d7238066c5de7f1c$var$ude(r, e) {
    e === void 0 && (e = {});
    var t = e.direction || "normal", i = e.easing ? $d7238066c5de7f1c$var$MY(e.easing) : null, n = e.grid, s = e.axis, a = e.from || 0, o = a === "first", g = a === "center", l = a === "last", c = $d7238066c5de7f1c$var$Ft.arr(r), d = parseFloat(c ? r[0] : r), p = c ? parseFloat(r[1]) : 0, A = $d7238066c5de7f1c$var$bI(c ? r[1] : r) || 0, y = e.start || 0 + (c ? d : 0), G = [], Z = 0;
    return function(v, V, H) {
        if (o && (a = 0), g && (a = (H - 1) / 2), l && (a = H - 1), !G.length) {
            for(var N = 0; N < H; N++){
                if (!n) G.push(Math.abs(a - N));
                else {
                    var Y = g ? (n[0] - 1) / 2 : a % n[0], K = g ? (n[1] - 1) / 2 : Math.floor(a / n[0]), z = N % n[0], M = Math.floor(N / n[0]), _ = Y - z, O = K - M, ie = Math.sqrt(_ * _ + O * O);
                    s === "x" && (ie = -_), s === "y" && (ie = -O), G.push(ie);
                }
                Z = Math.max.apply(Math, G);
            }
            i && (G = G.map(function(pe) {
                return i(pe / Z) * Z;
            })), t === "reverse" && (G = G.map(function(pe) {
                return s ? pe < 0 ? pe * -1 : -pe : Math.abs(Z - pe);
            }));
        }
        var he = c ? (p - d) / Z : d;
        return y + he * (Math.round(G[V] * 100) / 100) + A;
    };
}
function $d7238066c5de7f1c$var$Ide(r) {
    r === void 0 && (r = {});
    var e = $d7238066c5de7f1c$var$ci(r);
    return e.duration = 0, e.add = function(t, i) {
        var n = $d7238066c5de7f1c$var$Ol.indexOf(e), s = e.children;
        n > -1 && $d7238066c5de7f1c$var$Ol.splice(n, 1);
        function a(p) {
            p.passThrough = !0;
        }
        for(var o = 0; o < s.length; o++)a(s[o]);
        var g = $d7238066c5de7f1c$var$UR(t, $d7238066c5de7f1c$var$q2($d7238066c5de7f1c$var$TY, r));
        g.targets = g.targets || r.targets;
        var l = e.duration;
        g.autoplay = !1, g.direction = e.direction, g.timelineOffset = $d7238066c5de7f1c$var$Ft.und(i) ? l : $d7238066c5de7f1c$var$DY(i, l), a(e), e.seek(g.timelineOffset);
        var c = $d7238066c5de7f1c$var$ci(g);
        a(c), s.push(c);
        var d = $d7238066c5de7f1c$var$j_(s, r);
        return e.delay = d.delay, e.endDelay = d.endDelay, e.duration = d.duration, e.seek(0), e.reset(), e.autoplay && e.play(), e;
    }, e;
}
$d7238066c5de7f1c$var$ci.version = "3.2.1";
$d7238066c5de7f1c$var$ci.speed = 1;
$d7238066c5de7f1c$var$ci.suspendWhenDocumentHidden = !0;
$d7238066c5de7f1c$var$ci.running = $d7238066c5de7f1c$var$Ol;
$d7238066c5de7f1c$var$ci.remove = $d7238066c5de7f1c$var$cde;
$d7238066c5de7f1c$var$ci.get = $d7238066c5de7f1c$var$UY;
$d7238066c5de7f1c$var$ci.set = $d7238066c5de7f1c$var$O_;
$d7238066c5de7f1c$var$ci.convertPx = $d7238066c5de7f1c$var$EY;
$d7238066c5de7f1c$var$ci.path = $d7238066c5de7f1c$var$ede;
$d7238066c5de7f1c$var$ci.setDashoffset = $d7238066c5de7f1c$var$qIe;
$d7238066c5de7f1c$var$ci.stagger = $d7238066c5de7f1c$var$ude;
$d7238066c5de7f1c$var$ci.timeline = $d7238066c5de7f1c$var$Ide;
$d7238066c5de7f1c$var$ci.easing = $d7238066c5de7f1c$var$MY;
$d7238066c5de7f1c$var$ci.penner = $d7238066c5de7f1c$var$M_;
$d7238066c5de7f1c$var$ci.random = function(r, e) {
    return Math.floor(Math.random() * (e - r + 1)) + r;
};
const $d7238066c5de7f1c$var$dde = {
    fast: 2
}, $d7238066c5de7f1c$var$hde = {
    short: 150
}, $d7238066c5de7f1c$var$eP = [
    "eyeBlinkLeft",
    "eyeBlinkRight"
], $d7238066c5de7f1c$var$Cde = [
    "Eye_Blink_L",
    "Eye_Blink_R"
], $d7238066c5de7f1c$var$pde = [
    "eyeBlinkLeft",
    "eyeBlinkRight"
];
class $d7238066c5de7f1c$var$mde {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_morphTargets"), $d7238066c5de7f1c$var$P(this, "_blinkAnime", null), $d7238066c5de7f1c$var$P(this, "_blink", {
            value: 0
        }), $d7238066c5de7f1c$var$P(this, "_started", !1), $d7238066c5de7f1c$var$P(this, "duration"), $d7238066c5de7f1c$var$P(this, "blinkSpeed"), this._morphTargets = (e == null ? void 0 : e.morphTargets) || [], this.duration = (e == null ? void 0 : e.blinkDuration) ?? $d7238066c5de7f1c$var$hde.short, this.blinkSpeed = (e == null ? void 0 : e.blinkSpeed) ?? $d7238066c5de7f1c$var$dde.fast, this.start();
    }
    _initAnimation() {
        const e = this;
        function t() {
            e._blinkAnime = $d7238066c5de7f1c$var$ci({
                targets: [
                    e._blink
                ],
                keyframes: [
                    {
                        value: 0.9,
                        duration: e.duration * 1 / 2,
                        easing: "easeInQuad"
                    },
                    // Return to 0 in 100ms
                    {
                        value: 0.9,
                        duration: e.duration * 1 / 2,
                        easing: "linear"
                    },
                    // Stay at target for 2 seconds
                    {
                        value: 0,
                        duration: e.duration * 1 / 2,
                        easing: "easeOutQuad"
                    }
                ],
                duration: e.duration,
                delay: (Math.random() * e.blinkSpeed + e.blinkSpeed) * 1e3,
                loop: !1,
                complete: t
            });
        }
        t();
    }
    start() {
        this._started = !0, this._initAnimation();
    }
    stop() {
        var e;
        (e = this._blinkAnime) == null || e.pause(), this._blinkAnime = null, this._blink = {
            value: 0
        }, this._started = !1;
    }
    update(e) {
        var t;
        const i = [];
        return this._started && ((t = this._blinkAnime) == null || t.tick(e), this._morphTargets.forEach((n)=>{
            i.push({
                name: n,
                value: 0.1 + this._blink.value
            });
        })), i;
    }
}
class $d7238066c5de7f1c$var$Ade {
    constructor(e){
        if ($d7238066c5de7f1c$var$P(this, "_animationMixer"), $d7238066c5de7f1c$var$P(this, "_morphTargets"), $d7238066c5de7f1c$var$P(this, "_mesh"), $d7238066c5de7f1c$var$P(this, "_startTime", 0), $d7238066c5de7f1c$var$P(this, "_visemeIntensity", 1), $d7238066c5de7f1c$var$P(this, "_duration", 200), $d7238066c5de7f1c$var$P(this, "_durationThreshold", 0.04), $d7238066c5de7f1c$var$P(this, "_visemeDataArray", []), $d7238066c5de7f1c$var$P(this, "_animationActionArray", []), $d7238066c5de7f1c$var$P(this, "_currentAnimationActionIndex", 0), $d7238066c5de7f1c$var$P(this, "_timeout", null), $d7238066c5de7f1c$var$P(this, "_type"), this._mesh = e.lipSyncMesh, this._morphTargets = e.lipSyncTargets, e.lipSyncVisemeIntensity) this._visemeIntensity = e.lipSyncVisemeIntensity;
        else switch(e.type){
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avatarsdk:
                this._visemeIntensity = 0.6;
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avaturn:
                this._visemeIntensity = 0.55;
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.rpm:
                this._visemeIntensity = 0.5;
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.cc3:
            default:
                this._visemeIntensity = 0.6;
                break;
        }
        this._animationMixer = e.animationMixer, this._type = e.type;
    }
    update(e) {
        if (this._animationActionArray.length && this._currentAnimationActionIndex < this._animationActionArray.length) {
            const t = this._animationActionArray[this._currentAnimationActionIndex];
            if (this._animationMixer.time >= t.startAt) {
                if (t.action.play(), this._currentAnimationActionIndex > 0) {
                    const i = this._animationActionArray[this._currentAnimationActionIndex - 1].action;
                    i.stop(), this._animationMixer.uncacheAction(i.getClip());
                }
                this._currentAnimationActionIndex++;
            }
        }
    }
    start() {
        this._startTime = this._animationMixer.time;
    }
    stop() {
        this._startTime = 0;
        const e = this._animationMixer._actions.filter((t)=>t.getClip().name.startsWith("viseme"));
        for (const t of e)t.stop();
        this._visemeDataArray = [], this._animationActionArray = [], this._currentAnimationActionIndex = 0;
    }
    get isStarted() {
        return this._startTime != 0;
    }
    get visemeIntensity() {
        return this._visemeIntensity;
    }
    set visemeIntensity(e) {
        this._visemeIntensity = e;
    }
    /**
   * Add a silence at the end of the speech to get the mouth back in default position after the speech.
   * @param {number} intensity morph target deformation intensity
   */ _triggerTimeoutForLastViseme(e) {
        this._timeout && clearTimeout(this._timeout), this._timeout = setTimeout(()=>{
            this._visemeDataArray[this._visemeDataArray.length - 1] && this.PlayVisemeAsync("sil", this._visemeDataArray[this._visemeDataArray.length - 1].offset + this._duration / 1e3, e, !0);
        }, 1e3);
    }
    async PlayVisemeAsync(e, t, i, n) {
        if (this._morphTargets) {
            const s = this._morphTargets[e], a = i || this._visemeIntensity;
            if (s != null) {
                const o = {
                    data: s.map((l)=>({
                            morphTargetName: l.morphTargetName,
                            value: l.value * a
                        })),
                    offset: n ? t || 0 : (t || 0) / 1e3
                };
                this._visemeDataArray.push(o);
                const g = this._visemeDataArray.length - 2;
                if (this._visemeDataArray.length > 1) {
                    const l = this._visemeDataArray[g], c = g ? this._visemeDataArray[g - 1] : {
                        data: this._morphTargets.sil,
                        offset: 0
                    }, d = o.offset - l.offset;
                    if (d < this._durationThreshold) this._visemeDataArray.pop();
                    else {
                        const p = d > 1 && e === "sil", A = await this._createAnimationClip(`${e}${t}`, [
                            c,
                            l,
                            o
                        ], d, p), y = this._animationMixer.clipAction(A);
                        y.setLoop($1W96c.LoopOnce, 1), y.clampWhenFinished = !0, this._animationActionArray.push({
                            startAt: this._startTime + l.offset,
                            action: y
                        });
                    }
                }
            }
            !n && this._triggerTimeoutForLastViseme(a);
        }
    }
    async _createAnimationClip(e, t, i, n) {
        const s = n ? [
            0,
            0.25,
            i - 0.25,
            i
        ] : [
            0,
            i / 2,
            i
        ], a = new Array();
        return new Promise((o)=>{
            this._mesh.traverse((l)=>{
                if (l.type == "SkinnedMesh" && l.morphTargetDictionary !== void 0) {
                    const c = l;
                    for(let d = 0; d < t[1].data.length; d++){
                        const p = t[1].data[d];
                        if ("morphTargetName" in p && c.morphTargetDictionary && p.morphTargetName in c.morphTargetDictionary) {
                            const A = n ? [
                                (t[0].data[d].value + p.value) / 2,
                                p.value,
                                p.value,
                                (p.value + t[2].data[d].value) / 2
                            ] : [
                                (t[0].data[d].value + p.value) / 2,
                                p.value,
                                (p.value + t[2].data[d].value) / 2
                            ];
                            if (Math.max(...A) === 0) continue;
                            const y = new $1W96c.NumberKeyframeTrack(`${l.name}.morphTargetInfluences[${p.morphTargetName}]`, s, A, $1W96c.InterpolateSmooth);
                            a.push(y);
                        }
                    }
                }
            });
            const g = new $1W96c.AnimationClip("viseme" + e, s[s.length - 1], a);
            o(g);
        });
    }
}
const $d7238066c5de7f1c$var$bde = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 1
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 1
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$yde = [], $d7238066c5de7f1c$var$Bde = [], $d7238066c5de7f1c$var$fde = [
    {
        index: 1,
        strength: 0.36
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0.56
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0.37
    }
], $d7238066c5de7f1c$var$Gde = [], $d7238066c5de7f1c$var$vde = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0.8
    },
    {
        index: 5,
        strength: 0.3
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0.3
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0.8
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 1
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$Sde = [], $d7238066c5de7f1c$var$Zde = [], $d7238066c5de7f1c$var$Rde = [
    {
        index: 1,
        strength: 1
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 1
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0.8
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$Vde = [], $d7238066c5de7f1c$var$wde = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0.6
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0.6
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 1
    },
    {
        index: 16,
        strength: 1
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$Wde = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 1,
        side: "left"
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$Hde = [], $d7238066c5de7f1c$var$Xde = [
    {
        index: 1,
        strength: 1
    },
    {
        index: 2,
        strength: 1
    },
    {
        index: 4,
        strength: 1
    },
    {
        index: 5,
        strength: 1
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 1
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 1
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 1
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$Nde = [], $d7238066c5de7f1c$var$Lde = [], $d7238066c5de7f1c$var$Yde = [
    {
        index: 1,
        strength: 1
    },
    {
        index: 2,
        strength: 1
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 1
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 1
    },
    {
        index: 26,
        strength: 1
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$tP = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0.8
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 1
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0.4
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$var$iP = [
    {
        index: 1,
        strength: 0
    },
    {
        index: 2,
        strength: 0
    },
    {
        index: 4,
        strength: 0
    },
    {
        index: 5,
        strength: 0
    },
    {
        index: 6,
        strength: 0
    },
    {
        index: 7,
        strength: 0
    },
    {
        index: 9,
        strength: 0
    },
    {
        index: 10,
        strength: 0
    },
    {
        index: 12,
        strength: 0
    },
    {
        index: 14,
        strength: 0
    },
    {
        index: 15,
        strength: 0
    },
    {
        index: 16,
        strength: 0
    },
    {
        index: 17,
        strength: 0
    },
    {
        index: 18,
        strength: 0
    },
    {
        index: 20,
        strength: 0
    },
    {
        index: 23,
        strength: 0
    },
    {
        index: 24,
        strength: 0
    },
    {
        index: 25,
        strength: 0
    },
    {
        index: 26,
        strength: 0
    },
    {
        index: 28,
        strength: 0
    },
    {
        index: 45,
        strength: 0
    }
], $d7238066c5de7f1c$export$5fd798d8cf720e75 = {
    joy: $d7238066c5de7f1c$var$bde,
    anger: $d7238066c5de7f1c$var$vde,
    contempt: $d7238066c5de7f1c$var$Wde,
    disgust: $d7238066c5de7f1c$var$wde,
    dislike: $d7238066c5de7f1c$var$Lde,
    distress: $d7238066c5de7f1c$var$Hde,
    fear: $d7238066c5de7f1c$var$Xde,
    frustration: $d7238066c5de7f1c$var$Zde,
    guilt: $d7238066c5de7f1c$var$Sde,
    hope: $d7238066c5de7f1c$var$Bde,
    love: $d7238066c5de7f1c$var$fde,
    pride: $d7238066c5de7f1c$var$yde,
    regret: $d7238066c5de7f1c$var$Nde,
    relief: $d7238066c5de7f1c$var$Gde,
    sadness: $d7238066c5de7f1c$var$Rde,
    shame: $d7238066c5de7f1c$var$Vde,
    smile: $d7238066c5de7f1c$var$tP,
    surprise: $d7238066c5de7f1c$var$Yde,
    neutral: $d7238066c5de7f1c$var$iP
}, $d7238066c5de7f1c$var$Kde = [
    1,
    2
], $d7238066c5de7f1c$var$DH = [
    5,
    45
], $d7238066c5de7f1c$var$xde = [
    10,
    12,
    14,
    15,
    16,
    17,
    18,
    20,
    22,
    23,
    24,
    25,
    26,
    28
], $d7238066c5de7f1c$var$Fde = {
    emotion: 0,
    intensity: 0
}, $d7238066c5de7f1c$var$Tde = {
    inner: 0,
    outer: 0
};
class $d7238066c5de7f1c$var$Mde {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_globalManager"), $d7238066c5de7f1c$var$P(this, "_actionUnitToMorphTarget"), $d7238066c5de7f1c$var$P(this, "_eyesRelatedMorphTargets", []), $d7238066c5de7f1c$var$P(this, "_baseMorphTargetData", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_defaultBaseMorphTargetData", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_alpha", 0.5), $d7238066c5de7f1c$var$P(this, "_parent"), $d7238066c5de7f1c$var$P(this, "_defaultIntensity", 50), $d7238066c5de7f1c$var$P(this, "_defaultFadeInDuration", 250), $d7238066c5de7f1c$var$P(this, "_defaultFadeOutDuration", 250), $d7238066c5de7f1c$var$P(this, "_playingFacialAnimation", !1), $d7238066c5de7f1c$var$P(this, "_randomSmileMinIntensity", 10), $d7238066c5de7f1c$var$P(this, "_randomSmileMaxIntensity", 50), $d7238066c5de7f1c$var$P(this, "_currentAction", null), $d7238066c5de7f1c$var$P(this, "_numberOfPlayingActions", 0), $d7238066c5de7f1c$var$P(this, "_releaseBlinkManager", !1), $d7238066c5de7f1c$var$P(this, "_lipsAnime", null), $d7238066c5de7f1c$var$P(this, "_eyeBrowsAnime", null), $d7238066c5de7f1c$var$P(this, "_randomLipsData", $d7238066c5de7f1c$var$Fde), $d7238066c5de7f1c$var$P(this, "_randomEyeBrowsData", $d7238066c5de7f1c$var$Tde), $d7238066c5de7f1c$var$P(this, "_lipsAnimeStopped", !0), $d7238066c5de7f1c$var$P(this, "_eyeBrowsAnimeStopped", !0), this._globalManager = e.globalManager, this._parent = e.parent, this._actionUnitToMorphTarget = e.FACS, $d7238066c5de7f1c$var$DH.forEach((t)=>{
            var i;
            const n = (i = this._actionUnitToMorphTarget[t]) == null ? void 0 : i.both;
            n && (this._eyesRelatedMorphTargets = [
                ...this._eyesRelatedMorphTargets,
                ...n
            ]);
        }), this._parent.traverse((t)=>{
            if (t.type === "SkinnedMesh" && t.morphTargetDictionary !== void 0) {
                const i = t, n = i.morphTargetDictionary, s = i.morphTargetInfluences;
                n && s != null && s.length && Array.from(Object.keys(n)).forEach((a)=>{
                    i.morphTargetInfluences && i.morphTargetDictionary && (i.morphTargetInfluences[i.morphTargetDictionary[a]] = 0), !this._eyesRelatedMorphTargets.includes(a) && this._defaultBaseMorphTargetData.set(a, 0);
                });
            }
        }), this._baseMorphTargetData = new Map(this._defaultBaseMorphTargetData), this._globalManager.animationMixer.addEventListener("finished", (t)=>{
            t.action.getClip().name.startsWith("actionUnits") && (this._numberOfPlayingActions--, this._numberOfPlayingActions === 0 && (this._playingFacialAnimation = !1, this._releaseBlinkManager && (this._globalManager.eyeBlinkManager.start(), this._releaseBlinkManager = !1)), setTimeout(()=>{
                t.action.stop();
            }, 40));
        });
    }
    _initLipsAnimation() {
        const e = this;
        e._lipsAnimeStopped = !1;
        const t = ()=>{
            e._lipsAnime = $d7238066c5de7f1c$var$ci({
                targets: e._randomLipsData,
                emotion: ()=>0,
                intensity: ()=>Math.round(e._randomSmileMinIntensity + Math.random() * (e._randomSmileMaxIntensity - e._randomSmileMinIntensity)),
                delay: ()=>(0.5 + Math.random() * 2.5) * 1e3,
                duration: $d7238066c5de7f1c$var$ci.random(250, 750),
                autoplay: !0,
                complete: t,
                easing: "linear"
            });
        };
        t();
    }
    _stopLipsAnimation() {
        var e;
        const t = this;
        t._lipsAnimeStopped = !0, (e = t._lipsAnime) == null || e.pause(), t._lipsAnime = null, t._lipsAnime = $d7238066c5de7f1c$var$ci({
            targets: t._randomLipsData,
            emotion: ()=>0,
            intensity: ()=>0,
            duration: t._defaultFadeOutDuration,
            autoplay: !0,
            complete: ()=>{
                t._lipsAnime = null;
            },
            easing: "linear"
        });
    }
    _initEyeBrowsAnimation() {
        const e = this;
        e._eyeBrowsAnimeStopped = !1;
        const t = ()=>{
            e._eyeBrowsAnime = $d7238066c5de7f1c$var$ci({
                targets: e._randomEyeBrowsData,
                inner: ()=>Math.round(Math.random() * 50),
                outer: ()=>Math.round(Math.random() * 50),
                delay: ()=>(0.5 + Math.random() * 1.5) * 1e3,
                duration: $d7238066c5de7f1c$var$ci.random(150, 300),
                autoplay: !0,
                complete: t,
                easing: "linear"
            });
        };
        t();
    }
    _stopEyeBrowsAnimation() {
        var e;
        const t = this;
        t._eyeBrowsAnimeStopped = !0, (e = t._eyeBrowsAnime) == null || e.pause(), t._eyeBrowsAnime = null, t._eyeBrowsAnime = $d7238066c5de7f1c$var$ci({
            targets: t._randomEyeBrowsData,
            inner: ()=>0,
            outer: ()=>0,
            duration: 200,
            autoplay: !0,
            complete: ()=>{
                t._eyeBrowsAnime = null;
            },
            easing: "linear"
        });
    }
    update(e, t, i) {
        var n, s;
        (n = this._lipsAnime) == null || n.tick(e), (s = this._eyeBrowsAnime) == null || s.tick(e);
        const a = [], o = /* @__PURE__ */ new Map();
        if (this._parent.traverse((g)=>{
            if (g.type === "SkinnedMesh" && g.morphTargetDictionary !== void 0) {
                const l = g.morphTargetDictionary, c = g.morphTargetInfluences;
                l && c != null && c.length && Array.from(Object.keys(l)).forEach((d)=>{
                    const p = c[l[d]];
                    !this._eyesRelatedMorphTargets.includes(d) && o.set(d, p);
                });
            }
        }), t != null && t.length) !this._lipsAnimeStopped && this._stopLipsAnimation(), !this._eyeBrowsAnimeStopped && this._stopEyeBrowsAnimation(), t.forEach((g)=>{
            const l = this._actionUnitToMorphTarget[g.index], c = g.side && l[g.side] || l.both;
            c == null || c.forEach((d)=>{
                const p = o.has(d) && o.get(d) || 0;
                let A = 0;
                const y = g.index === 45 ? 1.5 : 1;
                g.index === 45 ? A = Math.min(y, g.strength) : A = Math.min(y, this._alpha * g.strength + (1 - this._alpha) * p), a.push({
                    name: d,
                    value: A
                });
            });
        });
        else if (this._playingFacialAnimation) !this._lipsAnimeStopped && this._stopLipsAnimation(), !this._eyeBrowsAnimeStopped && this._stopEyeBrowsAnimation(), this._baseMorphTargetData = new Map(o);
        else {
            const g = new Map(this._baseMorphTargetData);
            for (const [l, c] of g)!l.toLowerCase().includes("brow") && !l.toLowerCase().includes("mouth") && g.delete(l);
            if (i === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking) {
                this._eyeBrowsAnimeStopped && this._initEyeBrowsAnimation(), !this._lipsAnimeStopped && this._stopLipsAnimation();
                const l = [
                    ...g.keys()
                ];
                for (const c of l)c.toLowerCase().includes("viseme") && g.delete(c);
            } else {
                this._lipsAnimeStopped && this._initLipsAnimation(), !this._eyeBrowsAnimeStopped && this._stopEyeBrowsAnimation();
                const l = this._randomLipsData.intensity / 100;
                (this._randomLipsData.emotion === 0 ? $d7238066c5de7f1c$var$tP : $d7238066c5de7f1c$var$iP).forEach((c)=>{
                    if ($d7238066c5de7f1c$var$xde.includes(c.index)) {
                        const d = this._actionUnitToMorphTarget[c.index], p = c.side && d[c.side] || d.both;
                        p == null || p.forEach((A)=>{
                            const y = this._baseMorphTargetData.get(A) || 0, G = o.get(A) || 0, Z = (this._alpha * c.strength + (1 - this._alpha) * G) * l;
                            g.set(A, Math.max(Z, y));
                        });
                    }
                });
            }
            $d7238066c5de7f1c$var$Kde.forEach((l)=>{
                const c = this._actionUnitToMorphTarget[l].both, d = (l === 1 ? this._randomEyeBrowsData.inner : this._randomEyeBrowsData.outer) / 100;
                c == null || c.forEach((p)=>{
                    const A = this._baseMorphTargetData.get(p) || 0, y = o.get(p) || 0, G = this._alpha * d + (1 - this._alpha) * y;
                    g.set(p, Math.max(G, A));
                });
            }), Array.from(g).forEach(([l, c])=>{
                a.push({
                    name: l,
                    value: c
                });
            });
        }
        return a;
    }
    _handleClip(e, t, i, n) {
        var s;
        const a = this._globalManager.animationMixer.clipAction(e);
        a.setLoop($1W96c.LoopOnce, 1), t && (a.clampWhenFinished = !0), i && (this._globalManager.eyeBlinkManager.stop(), this._releaseBlinkManager = !0), a.play(), this._numberOfPlayingActions++, n && ((s = this._currentAction) == null || s.stop()), this._currentAction = a;
    }
    /**
   * Play a single facial animation and keep it or release it after some time.
   * @param {FacialAnimationData} data
   */ playFacialAnimation(e) {
        setTimeout(()=>{
            this._playingFacialAnimation = !0;
            let t = !1;
            const i = [];
            this._parent.traverse((n)=>{
                n.type === "SkinnedMesh" && n.morphTargetDictionary !== void 0 && e.AU.forEach((s)=>{
                    $d7238066c5de7f1c$var$DH.includes(s.index) && (t = !0);
                    const a = this._actionUnitToMorphTarget[s.index], o = s.side && a[s.side] || a.both, g = n;
                    o.forEach((l)=>{
                        if (g.morphTargetDictionary && g.morphTargetInfluences && l in g.morphTargetDictionary) {
                            const c = g.morphTargetInfluences[g.morphTargetDictionary[l]], d = [
                                0,
                                (e.fadeInDuration || this._defaultFadeInDuration) / 1e3
                            ];
                            if (e.releaseAfterDuration) {
                                const y = (e.fadeInDuration || this._defaultFadeInDuration) / 1e3 + (e.releaseAfterDuration || 0) / 1e3, G = (e.fadeInDuration || this._defaultFadeInDuration) / 1e3 + (e.fadeOutDuration || this._defaultFadeOutDuration) / 1e3 + (e.releaseAfterDuration || 0) / 1e3;
                                d.push(y, G);
                            }
                            const p = s.strength * (e.intensity || this._defaultIntensity) / 100, A = e.releaseAfterDuration ? [
                                c,
                                p,
                                p,
                                c
                            ] : [
                                c,
                                p
                            ];
                            i.push(new $1W96c.NumberKeyframeTrack(`${n.name}.morphTargetInfluences[${l}]`, d, A, $1W96c.InterpolateLinear));
                        }
                    });
                });
            }), this._handleClip(new $1W96c.AnimationClip(`actionUnits${Date.now()}`, -1, i, $1W96c.NormalAnimationBlendMode), !!e.keepAlive, t, !0);
        }, e.delay || 0);
    }
    /**
   * Process the timeline of the block to get the array of times at which the values will change
   * @param {Timeline} timeline timeline of this block
   * @param {number} strength value to be attained by the related morphtarget
   * @returns {Array<number>}
   */ _processTimeline(e, t) {
        const i = [], n = [];
        return e.start !== void 0 && (e.attackpeak && (i.push(e.attackpeak - e.start), n.push(t)), e.relax && (i.push(e.relax - e.start), n.push(t))), {
            processedTimes: i,
            processedValues: n
        };
    }
    updateFacialAnimation(e, t) {
        this._playingFacialAnimation = !0;
        let i = !1;
        const n = [];
        this._parent.traverse((s)=>{
            s.type === "SkinnedMesh" && s.morphTargetDictionary !== void 0 && e.forEach((a)=>{
                $d7238066c5de7f1c$var$DH.includes(a.index) && (i = !0);
                const o = this._actionUnitToMorphTarget[a.index], g = a.side && o[a.side] || o.both, l = s;
                g.forEach((c)=>{
                    if (l.morphTargetDictionary && l.morphTargetInfluences && c in l.morphTargetDictionary) {
                        const d = l.morphTargetInfluences[l.morphTargetDictionary[c]];
                        let p = [], A = [];
                        if (a.shift) {
                            if (a.timeline) {
                                const { processedTimes: y, processedValues: G } = this._processTimeline(a.timeline, a.strength);
                                y.length ? (p = [
                                    0,
                                    ...y,
                                    a.duration || t
                                ], A = [
                                    d,
                                    ...G,
                                    a.strength
                                ]) : (p = [
                                    0,
                                    a.duration || t
                                ], A = [
                                    d,
                                    a.strength
                                ]);
                            } else p = [
                                0,
                                a.duration || t
                            ], A = [
                                d,
                                a.strength
                            ];
                        } else if (a.timeline) {
                            const { processedTimes: y, processedValues: G } = this._processTimeline(a.timeline, a.strength);
                            y.length ? (p = [
                                0,
                                ...y,
                                a.duration || t
                            ], A = [
                                d,
                                ...G,
                                d
                            ]) : (p = [
                                0,
                                this._defaultFadeInDuration / 1e3,
                                (a.duration || t) - this._defaultFadeOutDuration / 1e3,
                                a.duration || t
                            ], A = [
                                d,
                                a.strength,
                                a.strength,
                                d
                            ]);
                        } else p = [
                            0,
                            t / 2,
                            t
                        ], A = [
                            d,
                            a.strength,
                            d
                        ];
                        n.push(new $1W96c.NumberKeyframeTrack(`${s.name}.morphTargetInfluences[${c}]`, p, A, $1W96c.InterpolateLinear));
                    }
                });
            });
        }), this._handleClip(new $1W96c.AnimationClip(`actionUnits${Date.now()}`, t, n, $1W96c.NormalAnimationBlendMode), !0, i, !1);
    }
    setRandomSmileIntensity(e, t) {
        e <= t ? (this._randomSmileMinIntensity = e, this._randomSmileMaxIntensity = t) : (this._randomSmileMinIntensity = t, this._randomSmileMaxIntensity = e);
    }
}
let $d7238066c5de7f1c$var$eN = class {
    constructor(r){
        $d7238066c5de7f1c$var$P(this, "bones", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "obj"), r && this.from(r);
    }
    from(r) {
        this.obj = r;
        const e = r.bones;
        let t, i, n, s;
        for (const a of e){
            a.updateMatrixWorld(!0);
            for (t of $d7238066c5de7f1c$var$Jde)if (n = t.test(a.name)) {
                i = this.bones.get(n), s = this.obj.bones.findIndex((o)=>o.id == a.id), i ? i && t.isChain && i.push(s, a) : this.bones.set(n, new $d7238066c5de7f1c$var$zde(a, s));
                break;
            }
        }
    }
    getBoneMap(r) {
        return this.bones.get(r);
    }
    getBoneIndex(r) {
        const e = this.bones.get(r);
        return e ? e.items[0].index : -1;
    }
    getBones(r) {
        const e = this.obj.bones, t = [];
        let i, n;
        for (const s of r)if (i = this.bones.get(s), i) for (n of i.items)t.push(e[n.index]);
        else console.warn("Bonemap.getBones - Bone not found", s);
        return t.length >= r.length ? t : null;
    }
    getChestBone() {
        const r = this.obj.bones, e = [], t = this.bones.get("spine");
        return t && e.push(r[t.lastIndex]), e.length > 0 ? e : null;
    }
}, $d7238066c5de7f1c$var$zde = class {
    constructor(r, e){
        $d7238066c5de7f1c$var$P(this, "items", []), r && this.push(e, r);
    }
    push(r, e) {
        return this.items.push({
            index: r,
            name: e.name
        }), this;
    }
    get isChain() {
        return this.items.length > 1;
    }
    get count() {
        return this.items.length;
    }
    get index() {
        return this.items.length ? this.items[0].index : 0;
    }
    get lastIndex() {
        return this.items.length ? this.items[this.items.length - 1].index : 0;
    }
}, $d7238066c5de7f1c$var$Yr = class {
    constructor(r, e, t, i, n = !1){
        $d7238066c5de7f1c$var$P(this, "name"), $d7238066c5de7f1c$var$P(this, "isLR"), $d7238066c5de7f1c$var$P(this, "isChain"), $d7238066c5de7f1c$var$P(this, "reFind"), $d7238066c5de7f1c$var$P(this, "reExclude"), this.name = r, this.isLR = e, this.isChain = n, this.reFind = new RegExp(t, "i"), i && (this.reExclude = new RegExp(i, "i"));
    }
    test(r) {
        return !this.reFind.test(r) || this.reExclude && this.reExclude.test(r) ? null : this.isLR && $d7238066c5de7f1c$var$kde.test(r) ? this.name + "_l" : this.isLR && $d7238066c5de7f1c$var$Ede.test(r) ? this.name + "_r" : this.name;
    }
};
const $d7238066c5de7f1c$var$kde = new RegExp("\\.l|left|_l", "i"), $d7238066c5de7f1c$var$Ede = new RegExp("\\.r|right|_r", "i"), $d7238066c5de7f1c$var$Jde = [
    new $d7238066c5de7f1c$var$Yr("thigh", !0, "thigh|upleg|upperleg", "twist"),
    //upleg | upperleg
    new $d7238066c5de7f1c$var$Yr("shin", !0, "shin|leg|calf", "up|twist"),
    new $d7238066c5de7f1c$var$Yr("foot", !0, "foot"),
    new $d7238066c5de7f1c$var$Yr("toe", !0, "toebase"),
    new $d7238066c5de7f1c$var$Yr("shoulder", !0, "clavicle|shoulder"),
    new $d7238066c5de7f1c$var$Yr("upperarm", !0, "(upper.*arm|arm)", "fore|twist|lower"),
    new $d7238066c5de7f1c$var$Yr("forearm", !0, "forearm|arm", "up|twist"),
    new $d7238066c5de7f1c$var$Yr("hand", !0, "hand", "thumb|index|middle|ring|pinky"),
    new $d7238066c5de7f1c$var$Yr("head", !1, "head"),
    new $d7238066c5de7f1c$var$Yr("neck", !1, "neck*d*", void 0, !0),
    new $d7238066c5de7f1c$var$Yr("hip", !1, "hips*|pelvis", void 0, !1),
    new $d7238066c5de7f1c$var$Yr("root", !1, "root"),
    new $d7238066c5de7f1c$var$Yr("spine", !1, "waist|spine*d*|chest", void 0, !0),
    new $d7238066c5de7f1c$var$Yr("thumb", !0, "thumb*d*", "toe", !0),
    new $d7238066c5de7f1c$var$Yr("index", !0, "index*d*", "toe", !0),
    new $d7238066c5de7f1c$var$Yr("middle", !0, "middle*d*|mid*d", "toe", !0),
    new $d7238066c5de7f1c$var$Yr("ring", !0, "ring*d*", "toe", !0),
    new $d7238066c5de7f1c$var$Yr("pinky", !0, "pinky*d*", "toe", !0)
];
function $d7238066c5de7f1c$var$Ude(r) {
    return r.set(1 / r.x, 1 / r.y, 1 / r.z), r;
}
function $d7238066c5de7f1c$var$hT(r) {
    const e = new $1W96c.Quaternion(), t = 1 / r.lengthSq();
    return e.x = -r.x * t, e.y = -r.y * t, e.z = -r.z * t, e.w = r.w * t, e;
}
function $d7238066c5de7f1c$var$Dde(r) {
    const e = new $1W96c.Quaternion();
    return e.x = -r.x, e.y = -r.y, e.z = -r.z, e.w = -r.w, e;
}
class $d7238066c5de7f1c$var$qv {
    constructor(e, t){
        $d7238066c5de7f1c$var$P(this, "srcIndex", -1), $d7238066c5de7f1c$var$P(this, "tarIndex", -1), $d7238066c5de7f1c$var$P(this, "qSrcParent", new $1W96c.Quaternion()), $d7238066c5de7f1c$var$P(this, "qTarParent", new $1W96c.Quaternion()), $d7238066c5de7f1c$var$P(this, "qDotCheck", new $1W96c.Quaternion()), $d7238066c5de7f1c$var$P(this, "qSrcToTar", new $1W96c.Quaternion()), $d7238066c5de7f1c$var$P(this, "qTarToSrc", new $1W96c.Quaternion()), this.srcIndex = e, this.tarIndex = t;
    }
    // #endregion
    bind(e, t) {
        var i;
        const n = e.bones[this.srcIndex], s = t.bones[this.tarIndex];
        return this.qDotCheck.copy(n.getWorldQuaternion(new $1W96c.Quaternion())), (i = n.parent) == null || i.updateMatrixWorld(!0), this.qSrcParent.copy(n.parent !== null ? n.parent.getWorldQuaternion(new $1W96c.Quaternion()) : new $1W96c.Quaternion()), this.qTarParent.copy($d7238066c5de7f1c$var$hT(s.parent !== null ? s.parent.getWorldQuaternion(new $1W96c.Quaternion()) : new $1W96c.Quaternion())), this.qSrcToTar.copy($d7238066c5de7f1c$var$hT(n.getWorldQuaternion(new $1W96c.Quaternion()))), this.qSrcToTar.multiply(s.getWorldQuaternion(new $1W96c.Quaternion())), this;
    }
}
class $d7238066c5de7f1c$var$nP {
    constructor(){
        $d7238066c5de7f1c$var$P(this, "links", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "srcPose"), $d7238066c5de7f1c$var$P(this, "tarPose"), $d7238066c5de7f1c$var$P(this, "srcHip", new $1W96c.Vector3()), $d7238066c5de7f1c$var$P(this, "tarHip", new $1W96c.Vector3()), $d7238066c5de7f1c$var$P(this, "hipScale", 1), $d7238066c5de7f1c$var$P(this, "firstFrame", !0);
    }
    bindTPoses(e, t) {
        this.srcPose = e, this.tarPose = t, this.srcPose.updateMatrixWorld(!0), this.tarPose.updateMatrixWorld(!0);
        const i = new $d7238066c5de7f1c$var$eN(e.skeleton), n = new $d7238066c5de7f1c$var$eN(t.skeleton);
        let s;
        for (const [o, g] of i.bones)if (s = n.bones.get(o), !!s) {
            if (s.isChain || g.isChain) {
                const l = g.count - 1, c = s.count - 1;
                this.links.set(o + "_first", new $d7238066c5de7f1c$var$qv(g.index, s.index).bind(e.skeleton, t.skeleton)), this.links.set(o + "_last", new $d7238066c5de7f1c$var$qv(g.items[l].index, s.items[c].index).bind(e.skeleton, t.skeleton));
                for(let d = 1; d <= Math.min(l - 1, c - 1); d++)this.links.set(o + "_" + d, new $d7238066c5de7f1c$var$qv(g.items[d].index, s.items[d].index).bind(e.skeleton, t.skeleton));
            } else this.links.set(o, new $d7238066c5de7f1c$var$qv(g.index, s.index).bind(e.skeleton, t.skeleton));
        }
        const a = this.links.get("hip");
        if (a) {
            const o = e.skeleton.bones[a.srcIndex], g = t.skeleton.bones[a.tarIndex];
            this.srcHip.copy(o.getWorldPosition(new $1W96c.Vector3())), this.tarHip.copy(g.position);
        }
        return this;
    }
    // #region CALCULATIONS
    retargetPose() {
        var e;
        const t = new $1W96c.Quaternion();
        let i, n, s;
        for (i of this.links.values())n = this.srcPose.skeleton.bones[i.srcIndex], s = this.tarPose.skeleton.bones[i.tarIndex], t.multiplyQuaternions(i.qSrcParent, n.quaternion), t.dot(i.qDotCheck) < 0 ? t.multiply($d7238066c5de7f1c$var$Dde(i.qSrcToTar)) : t.multiply(i.qSrcToTar), s.quaternion.multiplyQuaternions(i.qTarParent, t);
        if (i = this.links.get("hip"), i) {
            n = this.srcPose.skeleton.bones[i.srcIndex], s = this.tarPose.skeleton.bones[i.tarIndex], n.getWorldScale(new $1W96c.Vector3());
            const a = s.getWorldScale(new $1W96c.Vector3());
            s.position.copy(n.getWorldPosition(new $1W96c.Vector3()).sub(this.srcHip)), s.position.divide(a), s.position.applyQuaternion((e = s.parent) == null ? void 0 : e.getWorldQuaternion(new $1W96c.Quaternion()).invert()), s.position.add(this.tarHip);
        }
    }
    // #endregion
    reset() {
        this.links = /* @__PURE__ */ new Map(), this.srcHip = new $1W96c.Vector3(), this.tarHip = new $1W96c.Vector3(), this.hipScale = 1;
    }
}
const $d7238066c5de7f1c$var$$b = "https://cdn.retorik.ai/bodyengine-three/animations/cc4/female/standing/", $d7238066c5de7f1c$var$_de = {
    [$d7238066c5de7f1c$var$rA.frequently]: 0.4,
    [$d7238066c5de7f1c$var$rA.often]: 0.3,
    [$d7238066c5de7f1c$var$rA.sometimes]: 0.15,
    [$d7238066c5de7f1c$var$rA.occasionaly]: 0.1,
    [$d7238066c5de7f1c$var$rA.rarely]: 0.05
}, $d7238066c5de7f1c$var$KS = class vy {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "state", vy.isIdle), $d7238066c5de7f1c$var$P(this, "enabled", !1), $d7238066c5de7f1c$var$P(this, "hitbox"), $d7238066c5de7f1c$var$P(this, "raycaster", new $1W96c.Raycaster()), $d7238066c5de7f1c$var$P(this, "mesh"), $d7238066c5de7f1c$var$P(this, "camera"), $d7238066c5de7f1c$var$P(this, "orbitControls"), $d7238066c5de7f1c$var$P(this, "direction", {
            front: !1,
            back: !1,
            left: !1,
            right: !1,
            sprint: !1,
            jump: !1
        }), $d7238066c5de7f1c$var$P(this, "walkDirection", new $1W96c.Vector3()), $d7238066c5de7f1c$var$P(this, "finalDirection", new $1W96c.Vector3()), $d7238066c5de7f1c$var$P(this, "rotateAngle", new $1W96c.Vector3(0, 1, 0)), $d7238066c5de7f1c$var$P(this, "rotateQuaternion", new $1W96c.Quaternion()), $d7238066c5de7f1c$var$P(this, "cameraTarget", new $1W96c.Vector3()), $d7238066c5de7f1c$var$P(this, "runVelocity", 10), $d7238066c5de7f1c$var$P(this, "walkVelocity", 4), $d7238066c5de7f1c$var$P(this, "path", []), $d7238066c5de7f1c$var$P(this, "navMesh"), $d7238066c5de7f1c$var$P(this, "navMeshGroup"), $d7238066c5de7f1c$var$P(this, "graphHelper"), $d7238066c5de7f1c$var$P(this, "currentRegion"), this.mesh = e, window.addEventListener("keydown", (t)=>{
            switch(t.code){
                case "ShiftLeft":
                    this.direction.sprint = !0;
                    break;
                case "ArrowUp":
                case "KeyW":
                    this.direction.front = !0;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    this.direction.left = !0;
                    break;
                case "ArrowDown":
                case "KeyS":
                    this.direction.back = !0;
                    break;
                case "ArrowRight":
                case "KeyD":
                    this.direction.right = !0;
                    break;
            }
        }), window.addEventListener("keyup", (t)=>{
            switch(t.code){
                case "ShiftLeft":
                    this.direction.sprint = !1;
                    break;
                case "ArrowUp":
                case "KeyW":
                    this.direction.front = !1;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    this.direction.left = !1;
                    break;
                case "ArrowDown":
                case "KeyS":
                    this.direction.back = !1;
                    break;
                case "ArrowRight":
                case "KeyD":
                    this.direction.right = !1;
                    break;
            }
        });
    }
    init(e) {
        console.log(e), e && e.enabled && (this.enabled = !0), this.camera = e.camera, this.orbitControls = e.orbitControls, this.hitbox = e.hitbox;
    }
    // Pathfinding to the position passed
    goTo(e) {
        if (this.mesh && this.hitbox) {
            const t = this.mesh.position.clone();
            t.y += 0.2, this.raycaster.set(t, new $1W96c.Vector3(0, -1, 0));
            let i = this.raycaster.intersectObjects([
                this.hitbox
            ], !0);
            i.length && t.copy(i[0].point), e.y += 0.2, this.raycaster.set(e, new $1W96c.Vector3(0, -1, 0)), i = this.raycaster.intersectObjects([
                this.hitbox
            ], !0), i.length && e.copy(i[0].point), this.path = this.navMesh.findPath(t, e);
        }
    }
    // Check if a key is pressed on keyboard
    getIsAKeyPressed() {
        return this.direction.front || this.direction.back || this.direction.left || this.direction.right;
    }
    // Get direction the avatar should be facing based on the keys pressed
    getDirectionOffset() {
        let e = 0;
        return this.direction.back ? this.direction.right ? e = Math.PI / 4 : this.direction.left ? e = -Math.PI / 4 : e = 0 : this.direction.front ? this.direction.right ? e = Math.PI / 2 + Math.PI / 4 : this.direction.left ? e = -Math.PI / 2 - Math.PI / 4 : e = Math.PI : this.direction.right ? e = Math.PI / 2 : this.direction.left && (e = -Math.PI / 2), e;
    }
    // Update the avatar position based on the keys pressed 
    update(e) {
        if (!(!this.enabled || !this.navMesh || !this.mesh)) {
            if (this.path.length) {
                const t = this.path[0].clone().sub(this.mesh.position);
                if (t.length() > 0.05) {
                    t.normalize(), this.mesh.position.add(t.multiplyScalar(e * this.walkVelocity));
                    const i = this.mesh.position.clone().add(t);
                    i.y = this.mesh.position.y, this.mesh.lookAt(i), this.mesh.position.y += 0.2, this.raycaster.set(this.mesh.position, new $1W96c.Vector3(0, -1, 0));
                    const n = this.hitbox ? this.raycaster.intersectObjects([
                        this.hitbox
                    ], !0) : [];
                    n.length && this.mesh.position.copy(n[0].point);
                } else this.path.shift();
            } else if (this.camera) {
                const t = Math.atan2(this.camera.position.x - this.mesh.position.x, this.camera.position.z - this.mesh.position.z);
                if (this.getIsAKeyPressed()) {
                    const c = this.getDirectionOffset();
                    this.rotateQuaternion.setFromAxisAngle(this.rotateAngle, t + c), this.mesh.quaternion.rotateTowards(this.rotateQuaternion, 0.25), this.camera.getWorldDirection(this.walkDirection), this.walkDirection.y = 0, this.walkDirection.normalize(), this.walkDirection.applyAxisAngle(this.rotateAngle, c), this.walkDirection.multiplyScalar(-1), this.state = this.direction.sprint ? vy.isRunnning : vy.isWalking;
                } else this.walkDirection.multiplyScalar(0.7), this.state = vy.isIdle;
                const i = this.direction.sprint ? this.runVelocity : this.walkVelocity, n = this.camera.position.clone().sub(this.mesh.position);
                this.finalDirection = this.walkDirection.clone(), this.finalDirection.multiplyScalar(i * e);
                let s = this.mesh.position.clone();
                this.raycaster.set(s.clone().add(new $1W96c.Vector3(0, 0.5, 0)), new $1W96c.Vector3(0, -1, 0));
                const a = this.hitbox ? this.raycaster.intersectObjects([
                    this.hitbox
                ], !0) : [];
                a.length && (s = a[0].point);
                const o = s.clone(), g = s.add(this.finalDirection), l = o.clone().lerp(g, 1 + 0.2 / o.distanceTo(g));
                this.navMesh.getRegionForPoint(l, this.navMesh.epsilonContainsTest) && (this.mesh.position.copy(g), this.currentRegion = this.navMesh.clampMovement(this.currentRegion, o, g, this.mesh.position)), this.updateCameraTarget(n);
            }
        }
    }
    // Make the camera follow the avatar
    updateCameraTarget(e) {
        this.camera && this.mesh && this.orbitControls && (this.camera.position.copy(this.mesh.position).add(e), this.cameraTarget.x = this.mesh.position.x, this.cameraTarget.y = this.mesh.position.y + 1, this.cameraTarget.z = this.mesh.position.z, this.orbitControls.target = this.cameraTarget, this.orbitControls.update());
    }
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$KS, "isRunnning", "running"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$KS, "isWalking", "walking"), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$KS, "isIdle", "idle");
let $d7238066c5de7f1c$var$Sy = $d7238066c5de7f1c$var$KS;
class $d7238066c5de7f1c$var$Pde extends $1W96c.AnimationMixer {
    constructor(e){
        super(e.rootObject), $d7238066c5de7f1c$var$P(this, "_animationActions", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_idleAnimationActions", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_explainAnimationActions", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_otherAnimationActions", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_inhaleAnimationAction", null), $d7238066c5de7f1c$var$P(this, "_exhaleAnimationAction", null), $d7238066c5de7f1c$var$P(this, "_currentAnimationActions", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_idleFrequencyData", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_explainFrequencyData", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_commonFrequencyData", null), $d7238066c5de7f1c$var$P(this, "_fadeDuration", 0.5), $d7238066c5de7f1c$var$P(this, "_fastFadeDuration", 0.25), $d7238066c5de7f1c$var$P(this, "_breathingEffectiveWeight", 0.5), $d7238066c5de7f1c$var$P(this, "_autoAnimate", !0), $d7238066c5de7f1c$var$P(this, "_breathing", !0), $d7238066c5de7f1c$var$P(this, "_state", $d7238066c5de7f1c$export$f2e6b371e93925c7.idle), $d7238066c5de7f1c$var$P(this, "_movingState", $d7238066c5de7f1c$var$Sy.isIdle), $d7238066c5de7f1c$var$P(this, "_timerForAutoAnimation", null), $d7238066c5de7f1c$var$P(this, "changeState", (a)=>{
            let o = null;
            this._state === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking ? o = this.getRandom(0) : a === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking && (o = this.getRandom(1)), o && this.autoAnimate && this.playAnimationAction(o), this.state = a;
        }), $d7238066c5de7f1c$var$P(this, "getRandom", (a, o)=>{
            var g, l;
            let c = /* @__PURE__ */ new Map();
            switch(a){
                case 0:
                    if (!((g = this._idleAnimationActions) != null && g.size)) return null;
                    c = this._idleFrequencyData;
                    break;
                case 1:
                    if (!((l = this._explainAnimationActions) != null && l.size)) return null;
                    c = this._explainFrequencyData;
                    break;
                default:
                    return null;
            }
            if (this._commonFrequencyData) {
                const d = (this._commonFrequencyData.maxCumulativeWeight || 1) * Math.random(), p = this._commonFrequencyData.cumulativeWeights.filter((y, G)=>{
                    var Z;
                    return this._commonFrequencyData && ((Z = c.get(this._commonFrequencyData.weights[G])) == null ? void 0 : Z.length);
                }), A = p.find((y)=>y >= d) || p.reverse().find((y)=>y < d);
                if (A !== void 0) {
                    const y = this._commonFrequencyData.weights[this._commonFrequencyData.cumulativeWeights.indexOf(A)];
                    let G = c.get(y);
                    if (G != null && G.length) {
                        o != null && o.length && G.length > o.length && (G = G.filter((v)=>!o.includes(v)));
                        const Z = G[Math.floor(Math.random() * (G.length - 1))];
                        return this._animationActions.get(Z) || null;
                    }
                }
            }
            return null;
        }), e.fadeDuration && (this._fadeDuration = e.fadeDuration);
        const t = e.animationWeights || $d7238066c5de7f1c$var$_de, i = [
            t.rarely,
            t.occasionaly,
            t.sometimes,
            t.often,
            t.frequently
        ], n = [];
        let s = 0;
        i.forEach((a)=>{
            s += a, n.push(s);
        }), this._commonFrequencyData = {
            animationWeights: t,
            weights: i,
            cumulativeWeights: n,
            maxCumulativeWeight: n[n.length - 1]
        }, this.addEventListener("loop", (a)=>{
            var o, g;
            if (a.action.getClip().name.includes("inhale")) (o = this._inhaleAnimationAction) == null || o.fadeOut(this._fadeDuration), setTimeout(()=>{
                var l;
                (l = this._exhaleAnimationAction) == null || l.reset().fadeIn(this._fadeDuration).play();
            }, 500);
            else if (a.action.getClip().name.includes("exhale")) (g = this._exhaleAnimationAction) == null || g.fadeOut(this._fadeDuration), setTimeout(()=>{
                var l;
                (l = this._inhaleAnimationAction) == null || l.reset().fadeIn(this._fadeDuration).play();
            }, 1500);
            else if (a.action.getClip().name.startsWith("bml_")) {
                const l = this._currentAnimationActions.get(a.action.getClip().name);
                if (l) {
                    if (this._currentAnimationActions.size === 1 && this._autoAnimate) {
                        const c = this.getRandom(this._state === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking ? 1 : 0);
                        c && (this._timerForAutoAnimation && clearTimeout(this._timerForAutoAnimation), this._timerForAutoAnimation = setTimeout(()=>{
                            c.reset().fadeIn(this._fadeDuration).play(), this._currentAnimationActions.set(c.getClip().name, c);
                        }, 1e3));
                    }
                    this.stopAnimation(l.getClip().name);
                }
            } else if (this._autoAnimate) {
                let l = null;
                switch(this._movingState){
                    case $d7238066c5de7f1c$var$Sy.isRunnning:
                        l = this._otherAnimationActions.get("running") || null;
                        break;
                    case $d7238066c5de7f1c$var$Sy.isWalking:
                        l = this._otherAnimationActions.get("walking") || null;
                        break;
                    case $d7238066c5de7f1c$var$Sy.isIdle:
                    default:
                        const c = [];
                        this._currentAnimationActions.forEach((d, p)=>c.push(p.toLowerCase())), l = this.getRandom(this._state === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking ? 1 : 0, c);
                        break;
                }
                l && (this._currentAnimationActions.has(l == null ? void 0 : l.getClip().name) ? l == null || l.reset().play() : (l == null || l.reset().fadeIn(this._fadeDuration).play(), this.stopAnimations(), this._currentAnimationActions.set(l == null ? void 0 : l.getClip().name, l)));
            }
        }), this.addEventListener("finished", (a)=>{
            if (!this._autoAnimate) return;
            const o = this.getRandom(this._state === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking ? 1 : 0);
            o && (this._currentAnimationActions.has(o == null ? void 0 : o.getClip().name) ? o == null || o.reset().play() : (this.stopAnimations(), o == null || o.reset().fadeIn(this._fadeDuration).play(), this._currentAnimationActions.set(o == null ? void 0 : o.getClip().name, o)));
        }), setInterval(()=>{
            if (!this._autoAnimate) return;
            const a = this._currentAnimationActions.entries().next().value, o = a ? a[1] : void 0;
            (o == null ? void 0 : o.time) === 0 && o.play();
        }, 5e3);
    }
    get autoAnimate() {
        return this._autoAnimate;
    }
    set autoAnimate(e) {
        this._autoAnimate = e;
    }
    get breathing() {
        return this._breathing;
    }
    set breathing(e) {
        this._breathing = e;
    }
    get speaking() {
        return this._state === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking;
    }
    get state() {
        return this._state;
    }
    set state(e) {
        this._state = e;
    }
    get movingState() {
        return this._movingState;
    }
    set movingState(e) {
        this._movingState = e;
    }
    addAnimation(e, t = "often") {
        var i, n, s, a;
        const o = this.clipAction(e);
        o.setLoop($1W96c.LoopPingPong, 2), o.clampWhenFinished = !0;
        const g = ((i = this._commonFrequencyData) == null ? void 0 : i.animationWeights[t]) || ((n = this._commonFrequencyData) == null ? void 0 : n.animationWeights.often);
        if (this._animationActions.set(e.name, o), e.name.toLowerCase().includes("idle")) {
            this._idleAnimationActions.set(e.name, o);
            const l = this._idleFrequencyData.get(g);
            l != null && l.length ? this._idleFrequencyData.set(g, [
                ...l,
                e.name
            ]) : this._idleFrequencyData.set(g, [
                e.name
            ]);
        } else if (e.name.toLowerCase().includes("explain")) {
            this._explainAnimationActions.set(e.name, o);
            const l = this._explainFrequencyData.get(g);
            l != null && l.length ? this._explainFrequencyData.set(g, [
                ...l,
                e.name
            ]) : this._explainFrequencyData.set(g, [
                e.name
            ]);
        } else this._otherAnimationActions.set(e.name, o);
        if (this._autoAnimate && !this._currentAnimationActions.size && ((s = this._idleAnimationActions) == null ? void 0 : s.size) > 1 && ((a = this._explainAnimationActions) == null ? void 0 : a.size) > 1) {
            const l = this.getRandom(this._state === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking ? 1 : 0);
            l && (this._currentAnimationActions.set(l.getClip().name, l), l.reset().play());
        }
    }
    /**
   * Start breathing animation that will continue on its own.
   */ startBreathing() {
        var e;
        (e = this._inhaleAnimationAction) == null || e.reset().play(), this._breathing = !0;
    }
    /**
   * Stop breathing animation.
   */ stopBreathing() {
        var e, t;
        (e = this._inhaleAnimationAction) == null || e.stop(), (t = this._exhaleAnimationAction) == null || t.stop(), this._breathing = !1;
    }
    /**
   * Add the special breathing animation. We receive an inhaling animation, copy its reversed tracks to get an exhaling one, and play them successively.
   * @param {THREE.AnimationClip} inhaleClip animation clip containing the inhaling animation.
   */ addBreathingAnimation(e) {
        const t = [];
        for(let n = e.tracks.length - 1; n >= 0; n--)t.push(e.tracks[n]);
        const i = new $1W96c.AnimationClip("exhaleClip", -1, t, $1W96c.NormalAnimationBlendMode);
        $1W96c.AnimationUtils.makeClipAdditive(i), this._exhaleAnimationAction = this.clipAction(i), this._exhaleAnimationAction.setLoop($1W96c.LoopPingPong, 1 / 0), this._exhaleAnimationAction.setEffectiveWeight(this._breathingEffectiveWeight), e.name = "inhaleClip", $1W96c.AnimationUtils.makeClipAdditive(e), this._inhaleAnimationAction = this.clipAction(e), this._inhaleAnimationAction.setLoop($1W96c.LoopPingPong, 1 / 0), this._inhaleAnimationAction.reset().play();
    }
    getAllAnimations() {
        const e = /* @__PURE__ */ new Map();
        return this._animationActions.forEach((t, i)=>{
            e.set(i, t.getClip());
        }), e;
    }
    /**
   * Get an array containing the names of all the animations stored inside the AnimationMixer.
   * @returns {Array<string>}
   */ getAllAnimationNames() {
        return [
            ...this._animationActions.keys()
        ];
    }
    /**
   * Conditionnaly fades out the current playing animations and fades in the animation to be played in 0.5s.
   * @param {string} name name of the stored AnimAtionAction that should be played. Can be retrieved by using getAllAnimationsNames().
   * @param {boolean | undefined} keepOtherAnimationsAlive true to keep already playing animations alive.
   */ playAnimation(e, t) {
        this._timerForAutoAnimation && clearTimeout(this._timerForAutoAnimation);
        const i = this._animationActions.get(e);
        i && (this._currentAnimationActions.size ? (i.reset().fadeIn(this._fadeDuration).play(), !t && this.stopAnimations()) : i.play(), this._currentAnimationActions.set(e, i));
    }
    /**
   * Conditionnaly fades out the current playing animations and fades in the animation to be played in 0.5s.
   * @param {THREE.AnimationAction} action AnimAtionAction that should be played.
   * @param {boolean | undefined} keepOtherAnimationsAlive true to keep already playing animations alive.
   */ playAnimationAction(e, t) {
        this._timerForAutoAnimation && clearTimeout(this._timerForAutoAnimation), this._currentAnimationActions.size ? (e.reset().fadeIn(this._fadeDuration).play(), !t && this.stopAnimations()) : e.play(), this._currentAnimationActions.set(e.getClip().name, e);
    }
    /**
   * Stop all the currently playing animations.
   */ stopAnimations() {
        if (this._currentAnimationActions.size) {
            const e = [];
            this._currentAnimationActions.forEach((t, i)=>{
                const n = this._currentAnimationActions.get(i);
                n && (n.halt(this._fadeDuration / 10).fadeOut(this._fadeDuration), e.push(n), this._currentAnimationActions.delete(i));
            }), setTimeout(()=>{
                e.forEach((t)=>{
                    t.stop();
                });
            }, this._fadeDuration * 1e3);
        }
    }
    /**
   * Stop a playing animation by name
   * @param {string} name name of the animation to stop.
   */ stopAnimation(e, t) {
        const i = this._currentAnimationActions.get(e);
        i && (i.halt(this._fadeDuration / 10).fadeOut(t ? this._fastFadeDuration : this._fadeDuration), this._currentAnimationActions.delete(e), setTimeout(()=>{
            i.stop();
        }, (t ? this._fastFadeDuration : this._fadeDuration) * 1e3));
    }
    update(e) {
        return super.update(e), this;
    }
}
class $d7238066c5de7f1c$var$Qde extends Worker {
    constructor(e, t){
        super(e, t);
    }
    async postMessageAsync(e, t = [], i = ()=>{}) {
        return new Promise((n, s)=>{
            this.onmessage = (a)=>{
                n(a.data), this.onmessage = null;
            }, this.onerror = (a)=>s(a), this.postMessage(e, t);
        });
    }
}

const $d7238066c5de7f1c$var$Ode = "" + new URL((parcelRequire("kdDvg"))).href, $d7238066c5de7f1c$var$jde = new RegExp("((spine)|(shoulder))+", "i"), $d7238066c5de7f1c$var$CT = new RegExp("((neck)|(head)|(eye)|(facial)|(jaw)|(tongue)|(teeth))+", "i");
class $d7238066c5de7f1c$var$qde {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_armature"), $d7238066c5de7f1c$var$P(this, "_mesh"), $d7238066c5de7f1c$var$P(this, "_targetMesh"), $d7238066c5de7f1c$var$P(this, "_retarget", new $d7238066c5de7f1c$var$nP()), $d7238066c5de7f1c$var$P(this, "_fadeDuration", 0.5), $d7238066c5de7f1c$var$P(this, "_needsRetargeting", !0), $d7238066c5de7f1c$var$P(this, "_animationOverride", !0), $d7238066c5de7f1c$var$P(this, "controllableManager"), $d7238066c5de7f1c$var$P(this, "worker"), $d7238066c5de7f1c$var$P(this, "animationMixer", null), e.animationOverride !== void 0 && (this._animationOverride = e.animationOverride), this._armature = e.sourceMesh, this._mesh = e.mesh, this._targetMesh = e.targetMesh, this.animationMixer = new $d7238066c5de7f1c$var$Pde({
            rootObject: this._armature,
            fadeDuration: this._fadeDuration,
            animationWeights: e.animationWeights
        }), this._retarget.bindTPoses(this._armature, this._targetMesh), this.controllableManager = new $d7238066c5de7f1c$var$Sy(this._mesh), this.worker = new $d7238066c5de7f1c$var$Qde($d7238066c5de7f1c$var$Ode, {
            type: "module"
        });
    }
    playAnimation(e) {
        var t;
        (t = this.animationMixer) == null || t.playAnimation(e);
    }
    /**
   * Stop an animation by its name
   * @param {string} name name of the animation to stop
   * @param {boolean | undefined} fast if the animation should be stopped faster than normal (base : 0.25s instead of 0.5s)
   */ stopAnimation(e, t) {
        var i;
        (i = this.animationMixer) == null || i.stopAnimation(e, t);
    }
    /**
   * Stop all currently playing animations
   */ stopAnimations() {
        var e;
        (e = this.animationMixer) == null || e.stopAnimations();
    }
    enableCoreAutoAnimate() {
        this.animationMixer && (this.animationMixer.autoAnimate = !0);
    }
    disableCoreAutoAnimate() {
        this.animationMixer && (this.animationMixer.autoAnimate = !1);
    }
    enableBreathing() {
        var e;
        (e = this.animationMixer) == null || e.startBreathing();
    }
    disableBreathing() {
        var e;
        (e = this.animationMixer) == null || e.stopBreathing();
    }
    /**
   * Add a retorik animation. No need of retargeting the clip source to the basic armature.
   * @param retorikAnimation THREE.Group : animation data
   * @param name string | undefined : name other than the animation clip's one if wanted
   */ addAnimation(e, t) {
        var i;
        const n = e.animations[0];
        t && (n.name = t), (i = this.animationMixer) == null || i.addAnimation(n);
    }
    /**
   * Add a mixamo animation. Need to retarget the clip source to the basic armature.
   * @param mixamoAnimation THREE.Group : animation data
   * @param name string | undefined : name other than the animation clip's one if wanted
   */ async addMixamoAnimation(e) {
        var t;
        const i = await this.worker.postMessageAsync({
            type: "retargetMixamo",
            clip: e.url,
            name: e.name
        }), n = $1W96c.AnimationClip.parse(i.retargetedClip);
        if (e.returnClip) return n;
        {
            const s = n, a = n.tracks;
            this._animationOverride && (s.tracks = a.filter((o)=>!o.name.split(".")[1].match($d7238066c5de7f1c$var$CT))), (t = this.animationMixer) == null || t.addAnimation(s, e.frequency);
        }
        return null;
    }
    /**
   * Add a CC4 animation. Need to retarget the clip source to the basic armature.
   * @param CC4Animation THREE.Group : animation data
   * @param name string | undefined : name other than the animation clip's one if wanted
   */ async addCC4Animation(e) {
        var t;
        const i = await this.worker.postMessageAsync({
            type: "retargetCC4",
            clip: e.url,
            name: e.name
        }), n = $1W96c.AnimationClip.parse(i.retargetedClip);
        if (e.returnClip) return n;
        {
            const s = n, a = n.tracks;
            this._animationOverride && (s.tracks = a.filter((o)=>!o.name.split(".")[1].match($d7238066c5de7f1c$var$CT))), (t = this.animationMixer) == null || t.addAnimation(s, e.frequency);
        }
        return null;
    }
    getAllAnimationNames() {
        return this.animationMixer ? this.animationMixer.getAllAnimationNames() : [];
    }
    addBreathingAnimation(e, t) {
        const i = e.animations[0];
        i.name = "breathing";
        const n = i.tracks;
        switch(i.tracks = n.filter((s)=>s.name.split(".")[0].match($d7238066c5de7f1c$var$jde)), t){
            case $d7238066c5de7f1c$var$Pc.cc4:
                i.tracks.forEach((s)=>{
                    s.name.toLowerCase().includes("rightshoulder") ? s.name = s.name.replace("mixamorigRightShoulder", "CC_Base_R_Clavicle") : s.name.toLowerCase().includes("leftshoulder") ? s.name = s.name.replace("mixamorigLeftShoulder", "CC_Base_L_Clavicle") : s.name.toLowerCase().includes("spine2") ? s.name = s.name.replace("mixamorigSpine2", "CC_Base_Spine02") : s.name.toLowerCase().includes("spine1") ? s.name = s.name.replace("mixamorigSpine1", "CC_Base_Spine02") : s.name.toLowerCase().includes("spine") && (s.name = s.name.replace("mixamorigSpine", "CC_Base_Waist"));
                });
                break;
            case $d7238066c5de7f1c$var$Pc.mixamo:
                this._needsRetargeting || i.tracks.forEach((s)=>{
                    s.name = s.name.replace("mixamorig", "");
                });
            case $d7238066c5de7f1c$var$Pc.none:
        }
        $1W96c.AnimationUtils.makeClipAdditive(i);
    }
    getAllAnimations() {
        return this.animationMixer ? this.animationMixer.getAllAnimations() : /* @__PURE__ */ new Map();
    }
    update(e, t) {
        this.animationMixer && (this.controllableManager && (this.controllableManager.update(e), this.animationMixer.movingState = this.controllableManager.state), this.animationMixer.state !== t && this.animationMixer.changeState(t), this.animationMixer.update(e), this._needsRetargeting && (this._armature.updateMatrixWorld(!0), this._retarget.retargetPose(), this._targetMesh.updateWorldMatrix(!0, !0)));
    }
}
class $d7238066c5de7f1c$var$$de {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_globalManager"), $d7238066c5de7f1c$var$P(this, "_headBone"), $d7238066c5de7f1c$var$P(this, "_bones", []), $d7238066c5de7f1c$var$P(this, "_nbBones", 0), $d7238066c5de7f1c$var$P(this, "_previousRotations", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_alpha", 0.75), $d7238066c5de7f1c$var$P(this, "_lookAt", null), $d7238066c5de7f1c$var$P(this, "_defaultFadeDuration", 1e3), $d7238066c5de7f1c$var$P(this, "_defaultReleaseDuration", 2e3), $d7238066c5de7f1c$var$P(this, "_playingHeadAnimation", !1), $d7238066c5de7f1c$var$P(this, "_camera", null), $d7238066c5de7f1c$var$P(this, "_movementAnime", null), $d7238066c5de7f1c$var$P(this, "_baseBoneRotations", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_boneRotation", {
            x: 0,
            y: 0,
            z: 0
        }), $d7238066c5de7f1c$var$P(this, "_limitBoneRotationInRadians", {
            x: 0.6981317008,
            // 40 degrees
            y: 1.0471975512,
            // 60 degrees
            z: 0.6981317008
        }), this._globalManager = e.globalManager, this._headBone = e.parent.getObjectByName(e.headBone), e.bones.forEach((t)=>{
            this._bones.push(e.parent.getObjectByName(t));
        }), this._bones.push(this._headBone), this._bones.forEach((t)=>{
            this._baseBoneRotations.set(t.name, t.rotation.clone()), this._previousRotations.set(t.name, t.rotation.clone());
        }), this._nbBones = this._bones.length, this._limitBoneRotationInRadians = {
            x: this._limitBoneRotationInRadians.x / this._nbBones,
            y: this._limitBoneRotationInRadians.y / this._nbBones,
            z: this._limitBoneRotationInRadians.z / this._nbBones
        }, this._globalManager.animationMixer.addEventListener("finished", (t)=>{
            t.action.getClip().name.startsWith("headPose") && (this._playingHeadAnimation = !1, setTimeout(()=>{
                t.action.stop();
            }, 40));
        }), this._globalManager.animationMixer.addEventListener("loop", (t)=>{
            const i = t.action.getClip();
            i.name.startsWith("headPose_shifted_") && (i.tracks.forEach((n)=>{
                const s = n.name.split(".")[0], a = n.values.slice(n.values.length - 4), o = new $1W96c.Euler().setFromQuaternion(new $1W96c.Quaternion(a[0], a[1], a[2], a[3]));
                this._baseBoneRotations.set(s, o), this._previousRotations.set(s, o);
            }), this._boneRotation = {
                x: 0,
                y: 0,
                z: 0
            }, this._initAnimation(), this._playingHeadAnimation = !1, setTimeout(()=>{
                t.action.stop();
            }, 40));
        }), this._initAnimation();
    }
    _calculateTargetRotation(e) {
        const t = {
            x: 0,
            y: 0,
            z: 0
        }, i = this._headBone.quaternion.clone();
        return e && (this._headBone.lookAt(e), this._headBone.quaternion.copy(this._headBone.quaternion.clone().slerp(i, 0.5))), this._bones.forEach((n)=>{
            const s = this._baseBoneRotations.get(n.name) || new $1W96c.Euler(0, 0, 0), a = new $1W96c.Euler();
            a.setFromQuaternion(n.quaternion.clone()), t.x += a.x - s.x, t.y += a.y - s.y, t.z += a.z - s.z;
        }), this._headBone.quaternion.copy(i), {
            x: t.x / this._nbBones,
            y: t.y / this._nbBones,
            z: t.z / this._nbBones
        };
    }
    _initAnimation() {
        const e = this, t = ()=>{
            const i = $1W96c.MathUtils.degToRad(-5 + Math.random() * 10) / e._nbBones, n = $1W96c.MathUtils.degToRad(-25 + Math.random() * 50) / e._nbBones, s = $1W96c.MathUtils.degToRad(-25 + Math.random() * 50) / e._nbBones, a = $d7238066c5de7f1c$var$ci.random(2e3, 2500), o = $d7238066c5de7f1c$var$ci.random(2e3, 3e3);
            e._movementAnime = $d7238066c5de7f1c$var$ci({
                targets: e._boneRotation,
                keyframes: [
                    {
                        x: i,
                        y: n,
                        z: s,
                        duration: a * 0.5
                    },
                    {
                        x: i,
                        y: n,
                        z: s,
                        duration: a * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: o * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: o
                    }
                ],
                autoplay: !1,
                complete: t,
                easing: "easeInOutQuad"
            });
        };
        t();
    }
    _initLookAtCamera(e, t) {
        const i = this, n = ()=>{
            i._movementAnime = $d7238066c5de7f1c$var$ci({
                targets: i._boneRotation,
                x: t.x,
                y: t.y,
                z: t.z,
                duration: e,
                autoplay: !0,
                complete: ()=>{
                    s();
                },
                easing: "easeInOutSine"
            });
        }, s = ()=>{
            if (i._camera) {
                const o = i._calculateTargetRotation(i._camera.position);
                i._movementAnime = $d7238066c5de7f1c$var$ci({
                    targets: i._boneRotation,
                    x: o.x,
                    y: o.y,
                    z: o.z,
                    duration: 200,
                    autoplay: !0,
                    complete: ()=>{
                        i._lookAt = !0, i._boneRotation = {
                            x: 0,
                            y: 0,
                            z: 0
                        }, a();
                    },
                    easing: "linear"
                });
            }
        }, a = ()=>{
            const o = $1W96c.MathUtils.degToRad(-5 + Math.random() * 10) / i._nbBones, g = $1W96c.MathUtils.degToRad(-20 + Math.random() * 40) / i._nbBones, l = $1W96c.MathUtils.degToRad(-20 + Math.random() * 40) / i._nbBones, c = $d7238066c5de7f1c$var$ci.random(2e3, 2500), d = $d7238066c5de7f1c$var$ci.random(2e3, 3e3);
            i._movementAnime = $d7238066c5de7f1c$var$ci({
                targets: i._boneRotation,
                keyframes: [
                    {
                        x: o,
                        y: g,
                        z: l,
                        duration: c * 0.5
                    },
                    {
                        x: o,
                        y: g,
                        z: l,
                        duration: c * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: d * 0.5
                    },
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        duration: d
                    }
                ],
                autoplay: !1,
                complete: a,
                easing: "easeInOutQuad"
            });
        };
        n();
    }
    _initReleaseLookAt(e) {
        const t = this, i = (a)=>{
            t._lookAt = !1, t._movementAnime = $d7238066c5de7f1c$var$ci({
                targets: t._boneRotation,
                x: [
                    a.x,
                    0
                ],
                y: [
                    a.y,
                    0
                ],
                z: [
                    a.z,
                    0
                ],
                duration: e,
                autoplay: !0,
                complete: ()=>{
                    t._initAnimation();
                },
                easing: "easeInOutSine"
            });
        }, n = t._previousRotations.get(t._bones[0].name), s = t._baseBoneRotations.get(t._bones[0].name);
        n && s && i({
            x: n.x - s.x,
            y: n.y - s.y,
            z: n.z - s.z
        });
    }
    addHeadPoseSequence(e) {
        const t = e.fps || 25, i = (e.duration || e.data.length / t) / e.data.length, n = [];
        for(let a = 0; a < e.data.length; a++)n.push(a * i);
        const s = new Array();
        e.data.forEach((a)=>{
            this._bones.forEach((o)=>{
                const g = this._previousRotations.get(o.name);
                if (g) {
                    const l = this._alpha * (a.x / this._bones.length) + (1 - this._alpha) * g.x, c = -this._alpha * (a.y / this._bones.length) + (1 - this._alpha) * g.y, d = -this._alpha * (a.z / this._bones.length) + (1 - this._alpha) * g.z, p = new $1W96c.Euler(l, c, d, "XYZ"), A = new $1W96c.Quaternion(), y = new $1W96c.Quaternion(), G = new $1W96c.Quaternion();
                    A.setFromEuler(g), y.setFromEuler(new $1W96c.Euler((g.x + l) / 2, (g.y + c) / 2, (g.z + d) / 2, "XYZ")), G.setFromEuler(p);
                    const Z = new $1W96c.QuaternionKeyframeTrack(`${o.name}.quaternion`, n, [
                        ...A.toArray(),
                        ...y.toArray(),
                        ...G.toArray()
                    ], $1W96c.InterpolateLinear);
                    s.push(Z), this._previousRotations.set(o.name, new $1W96c.Euler(l, c, d, "XYZ"));
                }
            });
        });
    }
    _calculateRotationWithLimits(e, t) {
        const i = {
            ...e
        };
        Math.abs(e.y - t.y) > this._limitBoneRotationInRadians.y && (e.y - t.y > 0 ? i.y = t.y + this._limitBoneRotationInRadians.y : i.y = t.y - this._limitBoneRotationInRadians.y);
        const n = (1 - Math.abs(i.y - t.y) / this._limitBoneRotationInRadians.y) * this._limitBoneRotationInRadians.x;
        Math.abs(e.x - t.x) > n && (e.x - t.x > 0 ? i.x = t.x + n : i.x = t.x - n);
        const s = Math.min(n, (1 - Math.abs(i.x - t.x) / this._limitBoneRotationInRadians.x) * this._limitBoneRotationInRadians.z);
        return Math.abs(e.z - t.z) > s && (e.z - t.z > 0 ? i.z = t.z + s : i.z = t.z - s), i.z = t.z, i;
    }
    update(e, t) {
        var i;
        const n = [];
        if (!this._playingHeadAnimation) {
            if ((i = this._movementAnime) == null || i.tick(e), t) this._bones.forEach((s)=>{
                const a = this._previousRotations.get(s.name), o = this._baseBoneRotations.get(s.name);
                if (a && o) {
                    const g = this._alpha * (o.x + t.x / this._bones.length) + (1 - this._alpha) * a.x, l = -(this._alpha * (o.y + t.y / this._bones.length) + (1 - this._alpha) * a.y), c = -(this._alpha * (o.z + t.z / this._bones.length) + (1 - this._alpha) * a.z), d = new $1W96c.Quaternion().setFromEuler(a), p = new $1W96c.Quaternion().setFromEuler(new $1W96c.Euler(g, l, c, "XYZ"));
                    n.push({
                        name: s.name,
                        value: [
                            ...d.toArray(),
                            ...p.toArray()
                        ]
                    }), this._previousRotations.set(s.name, new $1W96c.Euler(g, l, c, "XYZ"));
                }
            });
            else if (this._boneRotation) {
                const s = {
                    x: this._boneRotation.x,
                    y: this._boneRotation.y,
                    z: this._boneRotation.z
                };
                if (this._lookAt && this._camera) {
                    const a = this._calculateTargetRotation(this._camera.position);
                    s.x += a.x, s.y += a.y, s.z += a.z;
                }
                this._bones.forEach((a)=>{
                    const o = this._previousRotations.get(a.name), g = this._baseBoneRotations.get(a.name);
                    if (o && g) {
                        const l = {
                            x: this._alpha * (g.x + s.x) + (1 - this._alpha) * o.x,
                            y: this._alpha * (g.y + s.y) + (1 - this._alpha) * o.y,
                            z: this._alpha * (g.z + s.z) + (1 - this._alpha) * o.z
                        }, c = this._calculateRotationWithLimits(l, g), d = new $1W96c.Euler(c.x, c.y, c.z, "XYZ"), p = new $1W96c.Quaternion().setFromEuler(o), A = new $1W96c.Quaternion().setFromEuler(d);
                        n.push({
                            name: a.name,
                            value: [
                                ...p.toArray(),
                                ...A.toArray()
                            ]
                        }), this._previousRotations.set(a.name, d);
                    }
                });
            }
        }
        return n;
    }
    /**
   * Stop looking at a target.
   * @param {number | undefined} fadeDuration time in milliseconds to get back to base position. Default 1000.
   */ releaseLookAt(e) {
        var t;
        this._lookAt !== null && ((t = this._movementAnime) == null || t.pause(), this._initReleaseLookAt(e || this._defaultFadeDuration));
    }
    /**
   * Look at the target and get back to normal after some time.
   * @param {THREE.Camera} target camera to which the face will look at.
   * @param {number | undefined} fadeInDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   * @param {number | undefined} fadeOutDuration time in milliseconds to get back to base position. Default 1000.
   * @param {number | undefined} releaseAfterDuration time in milliseconds after which the animation gets back to base position. Default 2000.
   */ lookAtAndRelease(e, t, i, n) {
        this.lookAtAndKeep(e, t || this._defaultFadeDuration), setTimeout(()=>{
            this.releaseLookAt(i || this._defaultFadeDuration);
        }, n || this._defaultReleaseDuration);
    }
    /**
   * Look at the target camera and then keep looking at it until release.
   * @param {THREE.Camera} target camera to which the face will keep looking at.
   * @param {number | undefined} fadeDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   */ lookAtAndKeep(e, t) {
        var i;
        this._camera = e;
        const n = e.position, s = this._calculateTargetRotation(n);
        (i = this._movementAnime) == null || i.pause(), this._initLookAtCamera(t || this._defaultFadeDuration, s);
    }
    _processTimeline(e, t, i, n) {
        var s, a, o;
        const g = new $1W96c.Quaternion().setFromEuler(t), l = new $1W96c.Quaternion().setFromEuler(new $1W96c.Euler(t.x + 1e-3, t.y + 1e-3, t.z, "XYZ")), c = [
            0
        ];
        let d = [
            ...g.toArray()
        ];
        const p = e.planes.indexOf("x"), A = e.planes.indexOf("y"), y = e.planes.indexOf("z"), G = p > -1 ? {
            max: t.x + $1W96c.MathUtils.degToRad(e.upperlimit[p] / this._nbBones),
            min: (s = e.lowerlimit) != null && s.length ? t.x + $1W96c.MathUtils.degToRad(e.lowerlimit[p]) : 0
        } : void 0, Z = A > -1 ? {
            max: t.y + $1W96c.MathUtils.degToRad(e.upperlimit[A] / this._nbBones),
            min: (a = e.lowerlimit) != null && a.length ? t.y + $1W96c.MathUtils.degToRad(e.lowerlimit[A]) : 0
        } : void 0, v = y > -1 ? {
            max: t.z + $1W96c.MathUtils.degToRad(e.upperlimit[y] / this._nbBones),
            min: (o = e.lowerlimit) != null && o.length ? t.z + $1W96c.MathUtils.degToRad(e.lowerlimit[y]) : 0
        } : void 0, V = this._calculateRotationWithLimits({
            x: (G == null ? void 0 : G.max) === void 0 ? t.x : G.max,
            y: (Z == null ? void 0 : Z.max) === void 0 ? t.y : Z.max,
            z: (v == null ? void 0 : v.max) === void 0 ? t.z : v.max
        }, i), H = new $1W96c.Quaternion().setFromEuler(new $1W96c.Euler(V.x, V.y, V.z, "XYZ")), N = this._calculateRotationWithLimits({
            x: (G == null ? void 0 : G.min) === void 0 ? t.x : G.min,
            y: (Z == null ? void 0 : Z.min) === void 0 ? t.y : Z.min,
            z: (v == null ? void 0 : v.min) === void 0 ? t.z : v.min
        }, i), Y = new $1W96c.Quaternion().setFromEuler(new $1W96c.Euler(N.x, N.y, N.z, "XYZ"));
        if (e.shift) c.push(n), d = [
            ...d,
            ...H.toArray()
        ];
        else if (e.timeline.start !== void 0 && e.timeline.end !== void 0) {
            if (e.timeline.ready && (c.push(e.timeline.ready - e.timeline.start), d = [
                ...d,
                ...l.toArray()
            ]), e.forthAndBack) {
                if (d = [
                    ...d,
                    ...H.toArray()
                ], d = [
                    ...d,
                    ...Y.toArray()
                ], e.timeline.strokestart && e.timeline.strokeend) c.push(e.timeline.strokestart - e.timeline.start), c.push(e.timeline.strokeend - e.timeline.start);
                else {
                    const K = e.timeline.ready ? e.timeline.ready - e.timeline.start : 0, z = (e.timeline.relax ? e.timeline.relax - e.timeline.start : n) - K;
                    c.push(K + z / 4), c.push(K + z * 3 / 4);
                }
            } else if (d = [
                ...d,
                ...H.toArray()
            ], e.timeline.strokestart && e.timeline.strokeend) {
                c.push(e.timeline.strokestart - e.timeline.start), c.push(e.timeline.strokeend - e.timeline.start);
                const K = new $1W96c.Quaternion(H.x + 1e-3, H.y + 1e-3, H.z, H.w);
                d = [
                    ...d,
                    ...K.toArray()
                ];
            } else e.timeline.stroke ? c.push(e.timeline.stroke - e.timeline.start) : e.timeline.ready ? e.timeline.relax ? c.push(e.timeline.ready - e.timeline.start + (e.timeline.relax - e.timeline.ready) / 2) : c.push(e.timeline.ready - e.timeline.start + (e.timeline.end - e.timeline.ready) / 2) : e.timeline.relax ? c.push((e.timeline.relax - e.timeline.start) / 2) : c.push(n / 2);
            e.timeline.relax && (c.push(e.timeline.relax - e.timeline.start), d = [
                ...d,
                ...l.toArray()
            ]), c.push(n), d = [
                ...d,
                ...g.toArray()
            ];
        }
        return {
            processedTimes: c,
            processedValues: d
        };
    }
    _handleClip(e, t, i) {
        const n = this._globalManager.animationMixer.clipAction(e);
        i ? n.setLoop($1W96c.LoopPingPong, 2) : (n.setLoop($1W96c.LoopRepeat, t), n.setEffectiveTimeScale(t)), n.clampWhenFinished = !0, n.play();
    }
    updateHeadPosition(e, t) {
        var i;
        if (this._playingHeadAnimation = !0, (i = this._movementAnime) == null || i.pause(), e.shift) {
            this._movementAnime = null;
            const s = this._calculateTargetRotation(new $1W96c.Vector3(e.upperlimit[0], e.upperlimit[1], e.upperlimit[2]));
            e.upperlimit = [
                $1W96c.MathUtils.radToDeg(s.x),
                $1W96c.MathUtils.radToDeg(s.y),
                $1W96c.MathUtils.radToDeg(s.z)
            ];
        }
        const n = [];
        e.timeline && (this._bones.forEach((s)=>{
            const a = this._previousRotations.get(s.name);
            if (a) {
                const { processedTimes: o, processedValues: g } = this._processTimeline(e, a, this._baseBoneRotations.get(s.name), t);
                n.push(new $1W96c.QuaternionKeyframeTrack(`${s.name}.quaternion`, o, g, $1W96c.InterpolateLinear));
            }
        }), n.length && this._handleClip(new $1W96c.AnimationClip(`headPose${e.shift ? "_shifted_" : ""}${Date.now()}`, t, n, $1W96c.NormalAnimationBlendMode), e.repetition, e.shift));
    }
}
const $d7238066c5de7f1c$var$mC = 10, $d7238066c5de7f1c$var$AC = 20;
class $d7238066c5de7f1c$var$ehe {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_bones"), $d7238066c5de7f1c$var$P(this, "_headBone"), $d7238066c5de7f1c$var$P(this, "_morphTargets", null), $d7238066c5de7f1c$var$P(this, "_leftEyePreviousRotation"), $d7238066c5de7f1c$var$P(this, "_leftEyeOriginRotation"), $d7238066c5de7f1c$var$P(this, "_leftEyeOriginQuaternion"), $d7238066c5de7f1c$var$P(this, "_rightEyeOriginQuaternion"), $d7238066c5de7f1c$var$P(this, "_rightEyePreviousRotation"), $d7238066c5de7f1c$var$P(this, "_rightEyeOriginRotation"), $d7238066c5de7f1c$var$P(this, "_camera", null), $d7238066c5de7f1c$var$P(this, "_lookAt", !1), $d7238066c5de7f1c$var$P(this, "_type"), $d7238066c5de7f1c$var$P(this, "_saccadeAnime", null), $d7238066c5de7f1c$var$P(this, "_eyeRotation", {
            x: 0,
            y: 0,
            z: 0
        }), this._bones = {
            left: e.parent.getObjectByName(e.bones[0]),
            right: e.parent.getObjectByName(e.bones[1])
        }, this._headBone = e.parent.getObjectByName(e.headBone), e.morphTargets && (this._morphTargets = e.morphTargets), this._type = e.type, this._leftEyePreviousRotation = this._bones.left.rotation.clone(), this._leftEyeOriginRotation = this._bones.left.rotation.clone(), this._leftEyeOriginQuaternion = this._bones.left.quaternion.clone(), this._rightEyeOriginQuaternion = this._bones.right.quaternion.clone(), this._rightEyePreviousRotation = this._bones.right.rotation.clone(), this._rightEyeOriginRotation = this._bones.right.rotation.clone(), this._eyeRotation = {
            x: $1W96c.MathUtils.degToRad(-$d7238066c5de7f1c$var$mC / 2 + Math.random() * $d7238066c5de7f1c$var$mC),
            y: $1W96c.MathUtils.degToRad(-$d7238066c5de7f1c$var$AC + Math.random() * $d7238066c5de7f1c$var$AC),
            z: 0
        }, this._initAnimation();
    }
    _initAnimation() {
        const e = this;
        function t() {
            const i = $d7238066c5de7f1c$var$ci.random(1500, 2e3), n = $d7238066c5de7f1c$var$ci.random(3e3, 3500), s = e._eyeRotation.x, a = $1W96c.MathUtils.degToRad(-$d7238066c5de7f1c$var$mC / 2 + Math.random() * $d7238066c5de7f1c$var$mC), o = Math.abs(s - a) > $1W96c.MathUtils.degToRad($d7238066c5de7f1c$var$mC / 2) ? (s + a) / 2 : a, g = e._eyeRotation.y, l = $1W96c.MathUtils.degToRad(-$d7238066c5de7f1c$var$AC / 2 + Math.random() * $d7238066c5de7f1c$var$AC), c = Math.abs(g - l) > $1W96c.MathUtils.degToRad($d7238066c5de7f1c$var$AC / 2) ? (g + l) / 2 : l;
            e._saccadeAnime = $d7238066c5de7f1c$var$ci({
                targets: [
                    e._eyeRotation
                ],
                keyframes: [
                    {
                        x: o,
                        y: c,
                        duration: i * 0.05
                    },
                    // Move to target in 100ms
                    {
                        x: o,
                        y: c,
                        duration: i * 0.95,
                        easing: "linear"
                    },
                    // Stay at target for 2 seconds
                    {
                        x: 0,
                        y: 0,
                        duration: n * 0.05
                    },
                    // Return to 0 in 100ms
                    {
                        x: 0,
                        y: 0,
                        duration: n * 0.95,
                        easing: "linear"
                    }
                ],
                autoplay: !1,
                easing: "easeInOutQuad",
                complete: t
            });
        }
        t();
    }
    updateRotations(e, t) {
        const i = [], n = new $1W96c.Vector3(e.left.x, e.left.y, e.left.z), s = new $1W96c.Vector3(e.right.x, e.right.y, e.right.z), a = new $1W96c.Quaternion().setFromEuler(this._leftEyePreviousRotation), o = new $1W96c.Quaternion().setFromEuler(new $1W96c.Euler(n.x, n.y, n.z, "XYZ"));
        return i.push({
            name: this._bones.left.name,
            value: [
                ...a.toArray(),
                ...o.toArray()
            ]
        }), a.setFromEuler(this._rightEyePreviousRotation), o.setFromEuler(new $1W96c.Euler(s.x, s.y, s.z, "XYZ")), i.push({
            name: this._bones.right.name,
            value: [
                ...a.toArray(),
                ...o.toArray()
            ]
        }), this._leftEyePreviousRotation = new $1W96c.Euler(n.x, n.y, n.z, "XYZ"), this._rightEyePreviousRotation = new $1W96c.Euler(s.x, s.y, s.z, "XYZ"), i;
    }
    updateMorphTargets(e) {
        const t = [];
        let i = 1, n = 1;
        const s = new $1W96c.Euler().setFromQuaternion(this._bones.left.quaternion.clone().multiply(this._leftEyeOriginQuaternion.clone().invert())), a = new $1W96c.Euler().setFromQuaternion(this._bones.right.quaternion.clone().multiply(this._rightEyeOriginQuaternion.clone().invert()));
        let o = 0, g = 0, l = 0, c = 0;
        switch(this._type){
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.cc3:
                o = s.x, g = -s.z, l = a.x, c = -a.z, i = 0.5, n = 0.35;
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avatarsdk:
                o = s.y, g = -s.x, l = a.y, c = -a.x, n = 0.25, i = 0.3;
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avaturn:
                o = s.y, g = -s.x, l = a.y, c = -a.x, i = 1, n = 0.4;
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.rpm:
                o = s.y, g = -s.x, l = a.y, c = -a.x, i = 0.05, n = 0.05;
        }
        return this._morphTargets && (t.push({
            name: o > 0 ? this._morphTargets.left.out : this._morphTargets.left.in,
            value: $1W96c.MathUtils.radToDeg(Math.abs(o)) / ($d7238066c5de7f1c$var$mC / 2) * n
        }), t.push({
            name: o > 0 ? this._morphTargets.left.in : this._morphTargets.left.out,
            value: 0
        }), t.push({
            name: g > 0 ? this._morphTargets.left.up : this._morphTargets.left.down,
            value: $1W96c.MathUtils.radToDeg(Math.abs(g)) / ($d7238066c5de7f1c$var$AC / 2) * i
        }), t.push({
            name: g > 0 ? this._morphTargets.left.down : this._morphTargets.left.up,
            value: 0
        }), t.push({
            name: l > 0 ? this._morphTargets.right.in : this._morphTargets.right.out,
            value: $1W96c.MathUtils.radToDeg(Math.abs(l)) / ($d7238066c5de7f1c$var$mC / 2) * n
        }), t.push({
            name: l > 0 ? this._morphTargets.right.out : this._morphTargets.right.in,
            value: 0
        }), t.push({
            name: c > 0 ? this._morphTargets.right.up : this._morphTargets.right.down,
            value: $1W96c.MathUtils.radToDeg(Math.abs(c)) / ($d7238066c5de7f1c$var$AC / 2) * i
        }), t.push({
            name: c > 0 ? this._morphTargets.right.down : this._morphTargets.right.up,
            value: 0
        })), t;
    }
    update(e, t, i) {
        var n, s, a;
        (n = this._saccadeAnime) != null && n.paused ? (s = this._saccadeAnime) == null || s.play() : (a = this._saccadeAnime) == null || a.tick(e);
        let o = {
            left: new $1W96c.Euler(this._eyeRotation.x + this._leftEyeOriginRotation.x, this._eyeRotation.y + this._leftEyeOriginRotation.y, this._eyeRotation.z + this._leftEyeOriginRotation.z),
            right: new $1W96c.Euler(this._eyeRotation.x + this._rightEyeOriginRotation.x, this._eyeRotation.y + this._rightEyeOriginRotation.y, this._eyeRotation.z + this._rightEyeOriginRotation.z)
        };
        if (this._lookAt && this._camera) {
            const l = new $1W96c.Euler(), c = new $1W96c.Euler(), d = new $1W96c.Quaternion();
            i.forEach((Z)=>{
                d.multiply(new $1W96c.Quaternion().fromArray(Z.value).invert());
            });
            const p = this._bones.left.quaternion.clone(), A = this._bones.right.quaternion.clone();
            switch(this._bones.left.lookAt(this._camera.position.clone()), this._bones.right.lookAt(this._camera.position.clone()), this._bones.left.quaternion.multiply(d), this._bones.right.quaternion.multiply(d), new $1W96c.Euler().setFromQuaternion(this._bones.left.quaternion.clone().multiply(this._leftEyeOriginQuaternion.clone().invert())), this._type){
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.cc3:
                    this._bones.left.rotation.y += Math.PI / 2.5, this._bones.right.rotation.y += Math.PI / 2.5, this._bones.left.rotation.x = this._bones.right.rotation.x = Math.max(Math.min(this._bones.left.rotation.x, -Math.PI * 1 / 3), -Math.PI * 2 / 3), this._bones.left.rotation.y = this._bones.right.rotation.y = Math.max(Math.min(this._bones.left.rotation.y, Math.PI / 2.5 + Math.PI / 5), Math.PI / 2.5 - Math.PI / 5);
                    break;
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avatarsdk:
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avaturn:
                    this._bones.left.rotation.x = this._bones.right.rotation.x = Math.max(Math.min(this._bones.left.rotation.x, Math.PI / 8), 0), this._bones.left.rotation.y = this._bones.right.rotation.y = Math.max(Math.min(this._bones.left.rotation.y, Math.PI / 6), -Math.PI / 6);
                    break;
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.rpm:
                    this._bones.left.rotation.x += Math.PI / 16, this._bones.right.rotation.x += Math.PI / 16, this._bones.left.rotation.x = this._bones.right.rotation.x = Math.max(Math.min(this._bones.left.rotation.x, Math.PI / 6), -Math.PI / 6), this._bones.left.rotation.y = this._bones.right.rotation.y = Math.max(Math.min(this._bones.left.rotation.y, Math.PI / 6), -Math.PI / 6);
            }
            const y = this._bones.left.quaternion.clone(), G = this._bones.right.quaternion.clone();
            this._bones.left.quaternion.copy(p), this._bones.right.quaternion.copy(A), l.setFromQuaternion(y), l.x += this._eyeRotation.x, l.y += this._eyeRotation.y, l.z += this._eyeRotation.z, c.setFromQuaternion(G), c.x += this._eyeRotation.x, c.y += this._eyeRotation.y, c.z += this._eyeRotation.z, o = {
                left: l,
                right: c
            };
        } else t && (o = {
            left: new $1W96c.Euler(this._leftEyeOriginRotation.x + t.left.x, +this._leftEyeOriginRotation.y + t.left.y, +this._leftEyeOriginRotation.z + t.left.z),
            right: new $1W96c.Euler(this._rightEyeOriginRotation.x + t.right.x, this._rightEyeOriginRotation.y + t.right.y, this._rightEyeOriginRotation.z + t.right.z)
        });
        const g = this.updateRotations(o, !!t);
        return [
            this.updateMorphTargets(o),
            g
        ];
    }
    releaseLookAt() {
        this._lookAt = !1;
    }
    lookAtAndKeep(e) {
        this._lookAt = !0, this._camera = e;
    }
}
class $d7238066c5de7f1c$var$sP {
    constructor(e, t){
        $d7238066c5de7f1c$var$P(this, "id", ""), $d7238066c5de7f1c$var$P(this, "type"), $d7238066c5de7f1c$var$P(this, "parentId"), $d7238066c5de7f1c$var$P(this, "attributes", []), $d7238066c5de7f1c$var$P(this, "syncPoints", []), $d7238066c5de7f1c$var$P(this, "timeline", {}), this.type = e, this.parentId = t;
    }
    updateTimeline(e, t) {
        this.timeline = {
            ...this.timeline,
            [e]: t
        };
    }
}
var $d7238066c5de7f1c$var$sr = /* @__PURE__ */ ((r)=>(r.START = "start", r.READY = "ready", r.STROKESTART = "strokestart", r.STROKE = "stroke", r.STROKEEND = "strokeend", r.RELAX = "relax", r.END = "end", r.ATTACKPEAK = "attackpeak", r))($d7238066c5de7f1c$var$sr || {}), $d7238066c5de7f1c$var$Gt = /* @__PURE__ */ ((r)=>(r.DURATION = "duration", r.LEXEME = "lexeme", r.AMOUNT = "amount", r.AU = "au", r.SIDE = "side", r.TARGET = "target", r.INFLUENCE = "influence", r.OFFSETANGLE = "offsetdngle", r.OFFSETDIRECTION = "offsetdirection", r.OVERSHOOT = "overshoot", r.MODE = "mode", r.REPETITION = "repetition", r.MANNER = "manner", r.PART = "part", r.TYPE = "type", r))($d7238066c5de7f1c$var$Gt || {}), $d7238066c5de7f1c$var$Vi = /* @__PURE__ */ ((r)=>(r.BML = "bml", r.CONSTRAINT = "constraint", r.SYNCHRONIZE = "synchronize", r.BEFORE = "before", r.AFTER = "after", r.WAIT = "wait", r.FACE = "face", r.FACELEXEME = "facelexeme", r.FACEFACS = "facefacs", r.FACESHIFT = "faceshift", r.GAZE = "gaze", r.GAZESHIFT = "gazeshift", r.GESTURE = "gesture", r.POINTING = "pointing", r.HEAD = "head", r.HEADDIRECTIONSHIFT = "headdirectionshift", r.LOCOMOTION = "locomotion", r.POSTURE = "posture", r.POSTURESHIFT = "postureshift", r.SPEECH = "speech", r.OTHER = "other", r))($d7238066c5de7f1c$var$Vi || {}), $d7238066c5de7f1c$var$Ds = /* @__PURE__ */ ((r)=>(r.SYNC = "sync", r.STANCE = "stance", r.POSE = "pose", r.TEXT = "text", r.LEXEME = "lexeme", r.FACS = "facs", r))($d7238066c5de7f1c$var$Ds || {}), $d7238066c5de7f1c$var$Zy = /* @__PURE__ */ ((r)=>(r[r.MERGE = 0] = "MERGE", r[r.APPEND = 1] = "APPEND", r[r.REPLACE = 2] = "REPLACE", r))($d7238066c5de7f1c$var$Zy || {});
class $d7238066c5de7f1c$var$BB {
    constructor(e, t){
        $d7238066c5de7f1c$var$P(this, "id"), $d7238066c5de7f1c$var$P(this, "bmlParentId"), $d7238066c5de7f1c$var$P(this, "parentId"), $d7238066c5de7f1c$var$P(this, "syncReference"), $d7238066c5de7f1c$var$P(this, "referenceId"), $d7238066c5de7f1c$var$P(this, "referenceParentId"), $d7238066c5de7f1c$var$P(this, "referenceSyncRef"), $d7238066c5de7f1c$var$P(this, "additionalTime"), $d7238066c5de7f1c$var$P(this, "triggerTime"), this.bmlParentId = e.bmlParentId, this.parentId = e.parentId, this.syncReference = e.syncReference.toLowerCase(), this.referenceId = e.referenceId, this.referenceParentId = e.referenceParentId, this.referenceSyncRef = e.referenceSyncRef, this.additionalTime = e.additionalTime, this.triggerTime = e.triggerTime, e.syncReference === $d7238066c5de7f1c$var$sr.START && !e.referenceId && t && (this.referenceId = t, this.referenceSyncRef = $d7238066c5de7f1c$var$sr.START), this.id = `${this.bmlParentId}_${this.parentId}_${this.syncReference}`;
    }
    update(e, t, i) {
        const n = {
            ended: !1,
            updateTimeline: void 0
        };
        return this.triggerTime === void 0 && i !== void 0 && (this.triggerTime = this.additionalTime ? i + this.additionalTime : i, n.updateTimeline = this.triggerTime), this.triggerTime !== void 0 ? n.ended = this.triggerTime <= e : (t.forEach((s)=>{
            this.referenceParentId ? this.referenceParentId === s.blockParentId && this.referenceId === s.blockId && this.referenceSyncRef === s.syncRef && (this.additionalTime ? this.triggerTime = e + this.additionalTime : n.ended = !0) : this.referenceId === s.blockId && this.referenceSyncRef === s.syncRef && (this.additionalTime ? this.triggerTime = e + this.additionalTime : n.ended = !0);
        }), n.updateTimeline = this.triggerTime), n;
    }
}
class $d7238066c5de7f1c$var$DR extends $d7238066c5de7f1c$var$sP {
    constructor(e, t){
        var i;
        super(e.type, t), $d7238066c5de7f1c$var$P(this, "shift", !1);
        const n = (i = e.attributes.find((s)=>s.name === "id")) == null ? void 0 : i.value;
        this.id = typeof n == "string" ? n : `${n}`;
    }
}
class $d7238066c5de7f1c$var$the extends $d7238066c5de7f1c$var$DR {
    constructor(e, t, i){
        super({
            type: $d7238066c5de7f1c$var$Ds.POSE,
            attributes: []
        }, t), $d7238066c5de7f1c$var$P(this, "part", ""), $d7238066c5de7f1c$var$P(this, "lexeme", ""), $d7238066c5de7f1c$var$P(this, "parentAttributes", []), this.id = `${t}_pose_${Date.now()}`, this.parentAttributes = i, e.forEach((n)=>{
            switch(n.name){
                case $d7238066c5de7f1c$var$Gt.PART:
                    this.part = n.value;
                    break;
                case $d7238066c5de7f1c$var$Gt.LEXEME:
                    this.lexeme = n.value;
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$ihe extends $d7238066c5de7f1c$var$DR {
    constructor(e, t, i){
        var n;
        super({
            type: $d7238066c5de7f1c$var$Ds.STANCE,
            attributes: []
        }, t), $d7238066c5de7f1c$var$P(this, "lowType"), $d7238066c5de7f1c$var$P(this, "parentAttributes", []), this.id = `${t}_stance_${Date.now()}`, this.parentAttributes = i, this.lowType = (n = e.find((s)=>s.name === $d7238066c5de7f1c$var$Gt.TYPE)) == null ? void 0 : n.value;
    }
}
class $d7238066c5de7f1c$var$nhe extends $d7238066c5de7f1c$var$DR {
    constructor(e, t, i){
        var n;
        super({
            type: $d7238066c5de7f1c$var$Ds.LEXEME,
            attributes: []
        }, t), $d7238066c5de7f1c$var$P(this, "lexeme"), $d7238066c5de7f1c$var$P(this, "parentAttributes", []), this.id = `${t}_lexeme_${Date.now()}`, this.parentAttributes = i, this.lexeme = (n = e.find((s)=>s.name === $d7238066c5de7f1c$var$Gt.LEXEME)) == null ? void 0 : n.value;
    }
}
class $d7238066c5de7f1c$var$she extends $d7238066c5de7f1c$var$DR {
    constructor(e, t, i){
        super({
            type: $d7238066c5de7f1c$var$Ds.FACS,
            attributes: []
        }, t), $d7238066c5de7f1c$var$P(this, "au", 0), $d7238066c5de7f1c$var$P(this, "side", "BOTH"), $d7238066c5de7f1c$var$P(this, "amount", 1), $d7238066c5de7f1c$var$P(this, "parentAttributes", []), this.id = `${t}_facs_${Date.now()}`, this.parentAttributes = i, [
            ...e,
            ...i
        ].forEach((n)=>{
            switch(n.name){
                case $d7238066c5de7f1c$var$Gt.AU:
                    {
                        const s = typeof n.value == "number" ? n.value : parseFloat(n.value);
                        !isNaN(s) && (this.au = s);
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.SIDE:
                    this.side = n.value.toLowerCase();
                    break;
                case $d7238066c5de7f1c$var$Gt.AMOUNT:
                    {
                        const s = typeof n.value == "number" ? n.value : parseFloat(n.value);
                        !isNaN(s) && (this.amount = s);
                        break;
                    }
            }
        });
    }
}
class $d7238066c5de7f1c$var$Ta extends $d7238066c5de7f1c$var$sP {
    constructor(e, t){
        super(e.type, t), $d7238066c5de7f1c$var$P(this, "childrenElements"), $d7238066c5de7f1c$var$P(this, "childrenBlocks", []), this.childrenElements = e.children || [];
        const i = e.attributes.find((n)=>n.name === "id");
        this.id = i ? typeof i.value == "string" ? i.value : `${i.value}` : "", e.attributes.forEach((n)=>{
            switch(n.name){
                case $d7238066c5de7f1c$var$sr.READY:
                case $d7238066c5de7f1c$var$sr.START:
                case $d7238066c5de7f1c$var$sr.STROKESTART:
                case $d7238066c5de7f1c$var$sr.STROKE:
                case $d7238066c5de7f1c$var$sr.STROKEEND:
                case $d7238066c5de7f1c$var$sr.END:
                case $d7238066c5de7f1c$var$sr.RELAX:
                case $d7238066c5de7f1c$var$sr.ATTACKPEAK:
                    this._createSyncPoint(n, t);
            }
        });
    }
    _parseValue(e) {
        let t = this.parentId || "", i, n = $d7238066c5de7f1c$var$sr.START, s;
        if (typeof e == "string") {
            const a = parseFloat(e);
            if (!isNaN(a)) s = a;
            else {
                const o = e.split(":");
                if (o.length === 2) {
                    if (t = o[0], o[1].includes("+") || o[1].includes("-")) {
                        const g = o[1].includes("+") ? "+" : "-", l = o[1].split(g);
                        n = l[0].replaceAll(" ", "");
                        const c = parseFloat(l[1].replaceAll(" ", ""));
                        !isNaN(c) && (s = c);
                    } else n = o[1];
                } else if (o.length === 3) {
                    if (i = o[0], t = o[1], o[2].includes("+") || o[2].includes("-")) {
                        const g = o[2].includes("+") ? "+" : "-", l = o[2].split(g);
                        n = l[0].replaceAll(" ", "");
                        const c = parseFloat(l[1].replaceAll(" ", ""));
                        !isNaN(c) && (s = c);
                    } else n = o[2];
                }
            }
        } else s = e;
        return {
            referenceId: t,
            referenceParentId: i,
            referenceSyncRef: n,
            additionalTime: s
        };
    }
    _createSyncPoint(e, t) {
        const { referenceId: i, referenceParentId: n, referenceSyncRef: s, additionalTime: a } = this._parseValue(e.value), o = {
            bmlParentId: t,
            parentId: this.id,
            syncReference: e.name,
            referenceId: i,
            referenceParentId: n,
            referenceSyncRef: s,
            additionalTime: a
        };
        this.syncPoints.push(new $d7238066c5de7f1c$var$BB(o, this.parentId));
    }
    /**
   * For each parent's syncpoint, duplicate it for each child
   */ _createSyncPointForChildren() {
        this.childrenBlocks.length && this.syncPoints.length && this.childrenBlocks.forEach((e)=>{
            const t = [];
            this.syncPoints.forEach((i)=>{
                t.push(new $d7238066c5de7f1c$var$BB({
                    ...i,
                    parentId: e.id
                }, this.id));
            }), e.syncPoints = t;
        });
    }
    /**
   * Low level block creation function
   * @param {LowLevelBlockData} data
   * @param {string | undefined} parentId
   * @returns {Block | undefined}
   */ _createLowLevelBlock(e, t, i) {
        switch(e.type){
            case $d7238066c5de7f1c$var$Ds.FACS:
                return new $d7238066c5de7f1c$var$she(e.attributes, t, i);
            case $d7238066c5de7f1c$var$Ds.LEXEME:
                return new $d7238066c5de7f1c$var$nhe(e.attributes, t, i);
            case $d7238066c5de7f1c$var$Ds.POSE:
                return new $d7238066c5de7f1c$var$the(e.attributes, t, i);
            case $d7238066c5de7f1c$var$Ds.STANCE:
                return new $d7238066c5de7f1c$var$ihe(e.attributes, t, i);
            case $d7238066c5de7f1c$var$Ds.SYNC:
            case $d7238066c5de7f1c$var$Ds.TEXT:
            default:
                return;
        }
    }
    processChildren() {
        this.childrenElements.length && (this.childrenElements.forEach((e)=>{
            const t = e.tagName.toLowerCase();
            if (Object.values($d7238066c5de7f1c$var$Ds).includes(t)) {
                const i = [];
                e.getAttributeNames().forEach((s)=>{
                    i.push({
                        name: s,
                        value: e.getAttribute(s) || 0
                    });
                });
                const n = this._createLowLevelBlock({
                    type: t,
                    attributes: i
                }, this.id, this.attributes);
                n && (n.shift = this.type.toLowerCase().includes("shift"), this.childrenBlocks.push(n));
            }
        }), this._createSyncPointForChildren());
    }
}
class $d7238066c5de7f1c$var$rhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e){
        if (super({
            attributes: [],
            ...e
        }, e.id), $d7238066c5de7f1c$var$P(this, "characterId"), $d7238066c5de7f1c$var$P(this, "composition", $d7238066c5de7f1c$var$Zy.MERGE), e.characterId && (this.characterId = e.characterId), e.composition) switch(e.composition.toLowerCase()){
            case "merge":
                this.composition = $d7238066c5de7f1c$var$Zy.MERGE;
                const i = {
                    parentId: e.id || "root",
                    syncReference: $d7238066c5de7f1c$var$sr.START,
                    referenceId: "",
                    referenceParentId: "",
                    referenceSyncRef: "",
                    triggerTime: e.currentGlobalTimer
                };
                this.updateTimeline("start", e.currentGlobalTimer), this.syncPoints.push(new $d7238066c5de7f1c$var$BB(i, this.parentId));
                break;
            case "append":
                this.composition = $d7238066c5de7f1c$var$Zy.APPEND;
                break;
            case "replace":
                this.composition = $d7238066c5de7f1c$var$Zy.REPLACE, e.killAllCurrentTasks();
                break;
        }
        const t = {
            parentId: e.id || "root",
            syncReference: $d7238066c5de7f1c$var$sr.START,
            referenceId: "",
            referenceParentId: "",
            referenceSyncRef: "",
            triggerTime: e.currentGlobalTimer
        };
        this.updateTimeline("start", e.currentGlobalTimer), this.syncPoints.push(new $d7238066c5de7f1c$var$BB(t, this.parentId));
    }
}
class $d7238066c5de7f1c$var$ahe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        if (super(e, t), $d7238066c5de7f1c$var$P(this, "text", ""), e.children && e.children.length === 1 && e.children[0].tagName === $d7238066c5de7f1c$var$Ds.TEXT) {
            const i = e.children[0];
            this.text = i.innerHTML;
        }
    }
}
class $d7238066c5de7f1c$var$ohe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        var i;
        super(e, t), $d7238066c5de7f1c$var$P(this, "duration");
        const n = (i = e.attributes.find((s)=>s.name === $d7238066c5de7f1c$var$Gt.DURATION)) == null ? void 0 : i.value;
        if (this.duration = typeof n == "string" ? parseFloat(n) : n, this.attributes.push({
            name: $d7238066c5de7f1c$var$Gt.DURATION,
            value: this.duration || 0
        }), !e.attributes.find((s)=>s.name === $d7238066c5de7f1c$var$sr.END) && this.duration) {
            const s = {
                parentId: this.id,
                syncReference: $d7238066c5de7f1c$var$sr.END,
                referenceId: this.id,
                referenceParentId: this.parentId,
                referenceSyncRef: $d7238066c5de7f1c$var$sr.START,
                additionalTime: this.duration
            };
            this.syncPoints.push(new $d7238066c5de7f1c$var$BB(s));
        }
    }
}
class $d7238066c5de7f1c$var$ghe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "amount", 1), $d7238066c5de7f1c$var$P(this, "overshoot", 0), e.attributes.forEach((i)=>{
            const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.AMOUNT:
                    !isNaN(n) && (this.amount = n), this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.AMOUNT,
                        value: this.amount
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.OVERSHOOT:
                    !isNaN(n) && (this.overshoot = n), this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.OVERSHOOT,
                        value: this.overshoot
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$lhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "au", 0), $d7238066c5de7f1c$var$P(this, "side", "BOTH"), $d7238066c5de7f1c$var$P(this, "amount", 1), $d7238066c5de7f1c$var$P(this, "overshoot", 0), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.SIDE:
                    this.side = i.value.toLowerCase(), this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.SIDE,
                        value: this.side
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.AU:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.au = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.AU,
                            value: this.au
                        });
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.AMOUNT:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.amount = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.OVERSHOOT:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.overshoot = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.OVERSHOOT,
                            value: this.overshoot
                        });
                        break;
                    }
            }
        });
    }
}
class $d7238066c5de7f1c$var$che extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "lexeme", ""), $d7238066c5de7f1c$var$P(this, "amount", 1), $d7238066c5de7f1c$var$P(this, "overshoot", 0), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.LEXEME:
                    this.lexeme = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.LEXEME,
                        value: this.lexeme
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.AMOUNT:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.amount = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.OVERSHOOT:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.overshoot = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.OVERSHOOT,
                            value: this.overshoot
                        });
                        break;
                    }
            }
        });
    }
}
class $d7238066c5de7f1c$var$uhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "amount", 1), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.AMOUNT:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.amount = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
            }
        });
    }
}
class $d7238066c5de7f1c$var$Ihe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "target", ""), $d7238066c5de7f1c$var$P(this, "influence", ""), $d7238066c5de7f1c$var$P(this, "offsetAngle", 0), $d7238066c5de7f1c$var$P(this, "offsetDirection", "RIGHT"), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.TARGET:
                    this.target = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.TARGET,
                        value: this.target
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.INFLUENCE:
                    this.influence = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.INFLUENCE,
                        value: this.influence
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.OFFSETANGLE:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.offsetAngle = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.OFFSETANGLE,
                            value: this.offsetAngle
                        });
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.OFFSETDIRECTION:
                    this.offsetDirection = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.OFFSETDIRECTION,
                        value: this.offsetDirection
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$dhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "target", ""), $d7238066c5de7f1c$var$P(this, "influence"), $d7238066c5de7f1c$var$P(this, "offsetAngle", 0), $d7238066c5de7f1c$var$P(this, "offsetDirection", "RIGHT"), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.TARGET:
                    this.target = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.TARGET,
                        value: this.target
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.INFLUENCE:
                    this.influence = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.INFLUENCE,
                        value: this.influence
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.OFFSETANGLE:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.offsetAngle = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.OFFSETANGLE,
                            value: this.offsetAngle
                        });
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.OFFSETDIRECTION:
                    this.offsetDirection = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.OFFSETDIRECTION,
                        value: this.offsetDirection
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$hhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "mode"), $d7238066c5de7f1c$var$P(this, "lexeme", ""), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.MODE:
                    this.mode = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.MODE,
                        value: this.mode
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.LEXEME:
                    this.lexeme = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.LEXEME,
                        value: this.lexeme
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$Che extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "mode"), $d7238066c5de7f1c$var$P(this, "target"), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.MODE:
                    this.mode = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.MODE,
                        value: this.mode
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.TARGET:
                    this.target = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.TARGET,
                        value: this.target
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$phe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "lexeme", ""), $d7238066c5de7f1c$var$P(this, "repetition", 1), $d7238066c5de7f1c$var$P(this, "amount", 1), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.LEXEME:
                    this.lexeme = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.LEXEME,
                        value: this.lexeme
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.REPETITION:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.repetition = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.REPETITION,
                            value: this.repetition
                        });
                        break;
                    }
                case $d7238066c5de7f1c$var$Gt.AMOUNT:
                    {
                        const n = typeof i.value == "number" ? i.value : parseFloat(i.value);
                        !isNaN(n) && (this.amount = n), this.attributes.push({
                            name: $d7238066c5de7f1c$var$Gt.AMOUNT,
                            value: this.amount
                        });
                        break;
                    }
            }
        });
    }
}
class $d7238066c5de7f1c$var$mhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "target", ""), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.TARGET:
                    this.target = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.TARGET,
                        value: this.target
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$Ahe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "target", ""), $d7238066c5de7f1c$var$P(this, "manner"), e.attributes.forEach((i)=>{
            switch(i.name){
                case $d7238066c5de7f1c$var$Gt.TARGET:
                    this.target = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.TARGET,
                        value: this.target
                    });
                    break;
                case $d7238066c5de7f1c$var$Gt.MANNER:
                    this.manner = i.value, this.attributes.push({
                        name: $d7238066c5de7f1c$var$Gt.MANNER,
                        value: this.manner
                    });
                    break;
            }
        });
    }
}
class $d7238066c5de7f1c$var$bhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "stance"), $d7238066c5de7f1c$var$P(this, "poses");
    }
}
class $d7238066c5de7f1c$var$yhe extends $d7238066c5de7f1c$var$Ta {
    constructor(e, t){
        super(e, t), $d7238066c5de7f1c$var$P(this, "stance"), $d7238066c5de7f1c$var$P(this, "poses");
    }
}
class $d7238066c5de7f1c$var$Bhe {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "parentRealizer"), $d7238066c5de7f1c$var$P(this, "parsedBlocks"), this.parentRealizer = e, this.parsedBlocks = [];
    }
    /**
   * Block creation function for any type of tag
   * @param {RootAttribute | BlockData} data
   * @param {string | undefined} parentId
   * @returns {Block}
   */ _createBlock(e, t) {
        switch(e.type){
            case $d7238066c5de7f1c$var$Vi.BML:
                return new $d7238066c5de7f1c$var$rhe(e);
            case $d7238066c5de7f1c$var$Vi.WAIT:
                return new $d7238066c5de7f1c$var$ohe(e, t);
            case $d7238066c5de7f1c$var$Vi.FACE:
                return new $d7238066c5de7f1c$var$ghe(e, t);
            case $d7238066c5de7f1c$var$Vi.FACEFACS:
                return new $d7238066c5de7f1c$var$lhe(e, t);
            case $d7238066c5de7f1c$var$Vi.FACELEXEME:
                return new $d7238066c5de7f1c$var$che(e, t);
            case $d7238066c5de7f1c$var$Vi.FACESHIFT:
                return new $d7238066c5de7f1c$var$uhe(e, t);
            case $d7238066c5de7f1c$var$Vi.GAZE:
                return new $d7238066c5de7f1c$var$Ihe(e, t);
            case $d7238066c5de7f1c$var$Vi.GAZESHIFT:
                return new $d7238066c5de7f1c$var$dhe(e, t);
            case $d7238066c5de7f1c$var$Vi.GESTURE:
                return new $d7238066c5de7f1c$var$hhe(e, t);
            case $d7238066c5de7f1c$var$Vi.POINTING:
                return new $d7238066c5de7f1c$var$Che(e, t);
            case $d7238066c5de7f1c$var$Vi.HEAD:
                return new $d7238066c5de7f1c$var$phe(e, t);
            case $d7238066c5de7f1c$var$Vi.HEADDIRECTIONSHIFT:
                return new $d7238066c5de7f1c$var$mhe(e, t);
            case $d7238066c5de7f1c$var$Vi.LOCOMOTION:
                return new $d7238066c5de7f1c$var$Ahe(e, t);
            case $d7238066c5de7f1c$var$Vi.POSTURE:
                return new $d7238066c5de7f1c$var$bhe(e, t);
            case $d7238066c5de7f1c$var$Vi.POSTURESHIFT:
                return new $d7238066c5de7f1c$var$yhe(e, t);
            case $d7238066c5de7f1c$var$Vi.SPEECH:
                return new $d7238066c5de7f1c$var$ahe(e, t);
            default:
                return;
        }
    }
    /**
   * Process any tag other than `<bml>` to create a corresponding Block
   * @param {string} parentId
   * @param {Element} child
   * @returns {Block}
   */ _processChild(e, t) {
        const i = t.tagName.toLowerCase();
        if ($d7238066c5de7f1c$var$fy[i]) {
            const n = $d7238066c5de7f1c$var$fy[i].attributes, s = $d7238066c5de7f1c$var$fy[i].contents, a = [];
            t.getAttributeNames().filter((g)=>n.includes(g.toLowerCase())).forEach((g)=>a.push({
                    name: g.toLowerCase(),
                    value: t.getAttribute(g) || 0
                }));
            const o = [];
            return s && t.hasChildNodes() && Array.from(t.children).forEach((g)=>{
                s.includes(g.tagName) && o.push(g);
            }), this._createBlock({
                type: i,
                attributes: a,
                children: o
            }, e);
        }
    }
    /**
   * Process a `<bml>` tag to create a BmlBlock
   * @param {Element} root
   * @param {number} currentGlobalTimer
   * @returns {Block}
   */ _processRoot(e) {
        const t = {
            id: void 0,
            type: $d7238066c5de7f1c$var$Vi.BML,
            characterId: void 0,
            composition: void 0,
            currentGlobalTimer: this.parentRealizer.globalTimer,
            killAllCurrentTasks: this.parentRealizer.onKillAll
        };
        return e.getAttributeNames().filter((i)=>$d7238066c5de7f1c$var$fy.bml.attributes.includes(i)).forEach((i)=>t[i] = e.getAttribute(i)), this._createBlock(t);
    }
    /**
   * Check if the data are enclosed in a single `<bml>` tag or if there are several `<bml>` tags to process, and 
   * call processRoot and processChild to create the cooresponding array of Block
   * @param {HTMLElement} rootElement
   * @param {number} currentGlobalTimer current global timer from the bml realizer to update timelines accordingly when creating a bmlblock
   * @returns {Array<Block> | null}
   */ _parseXML(e) {
        const t = [], i = e.getElementsByTagName("bml");
        if (i.length) Array.from(i).forEach((n)=>{
            const s = n.getAttribute("id"), a = this._processRoot(n);
            a && t.push(a), Array.from(n.children).forEach((o)=>{
                var g;
                const l = s ? this._processChild(s, o) : void 0;
                l && (t.push(l), l.processChildren(), (g = l.childrenBlocks) == null || g.forEach((c)=>{
                    t.push(c);
                }));
            });
        });
        else if (e.tagName === "bml" && e.childElementCount) {
            const n = e.getAttribute("id"), s = this._processRoot(e);
            s && t.push(s), Array.from(e.children).forEach((a)=>{
                var o;
                const g = n ? this._processChild(n, a) : void 0;
                g && (t.push(g), g.processChildren(), (o = g.childrenBlocks) == null || o.forEach((l)=>{
                    t.push(l);
                }));
            });
        }
        return t.length ? t : null;
    }
    /**
   * Parse an XMLDocument or a string to create the corresponding Blocks and SyncPoints used by the Realizer 
   * @param {string | XMLDocument} bmlDocument
   * @returns {Array<Block> | null}
   */ parse(e) {
        if (typeof e == "string") {
            const t = new DOMParser().parseFromString(e, "text/xml").documentElement;
            return this._parseXML(t);
        } else if (typeof e === XMLDocument.toString()) return this._parseXML(e.documentElement);
        return null;
    }
}
const $d7238066c5de7f1c$var$fhe = [
    $d7238066c5de7f1c$var$Vi.FACEFACS,
    $d7238066c5de7f1c$var$Vi.FACELEXEME,
    $d7238066c5de7f1c$var$Vi.FACESHIFT,
    $d7238066c5de7f1c$var$Ds.FACS,
    $d7238066c5de7f1c$var$Ds.LEXEME
];
class $d7238066c5de7f1c$var$Ghe {
    constructor(e, t, i){
        $d7238066c5de7f1c$var$P(this, "parser"), $d7238066c5de7f1c$var$P(this, "bmlBlocks", []), $d7238066c5de7f1c$var$P(this, "syncPoints", []), $d7238066c5de7f1c$var$P(this, "finishedTasks", []), $d7238066c5de7f1c$var$P(this, "globalTimer", 0), $d7238066c5de7f1c$var$P(this, "_started", !1), $d7238066c5de7f1c$var$P(this, "onFinish", ()=>{}), $d7238066c5de7f1c$var$P(this, "onKillAll", this.flush), this.parser = new $d7238066c5de7f1c$var$Bhe(this), t && (this.onFinish = t), i && (this.onKillAll = ()=>{
            i(), this.flush();
        }), e && this.parse(e);
    }
    get started() {
        return this._started;
    }
    parse(e) {
        const t = this.parser.parse(e);
        if (t && (this.bmlBlocks = [
            ...this.bmlBlocks,
            ...t
        ]), this.bmlBlocks.length) {
            let i = [
                ...this.syncPoints
            ];
            this.bmlBlocks.forEach((n)=>{
                n.syncPoints.length && (i = [
                    ...i,
                    ...n.syncPoints
                ]);
            }), this.syncPoints = i;
        }
        !this._started && this.start();
    }
    update(e) {
        if (this._started) {
            this.globalTimer += e;
            let t = !1, i = [];
            const n = [];
            for(; !t;)t = !0, i = [], this.syncPoints.forEach((s)=>{
                var a;
                let o;
                s.triggerTime === void 0 && (o = this.syncPoints.find((c)=>c.id === `${s.referenceParentId || s.bmlParentId}_${s.referenceId}_${s.referenceSyncRef}`));
                const { ended: g, updateTimeline: l } = s.update(this.globalTimer, this.finishedTasks, o == null ? void 0 : o.triggerTime);
                if (l !== void 0) {
                    const c = this.bmlBlocks.find((d)=>d.id === s.parentId);
                    c == null || c.updateTimeline(s.syncReference, l);
                }
                if (g) {
                    t = !1;
                    const c = {
                        blockType: ((a = this.bmlBlocks.find((d)=>d.id === s.parentId)) == null ? void 0 : a.type) || $d7238066c5de7f1c$var$Vi.OTHER,
                        blockId: s.parentId,
                        syncRef: s.syncReference
                    };
                    this.finishedTasks.push(c), n.push(c);
                } else i.push(s);
            }), this.syncPoints = [
                ...i
            ];
            if (n.length) {
                console.log("Finished tasks : ", n);
                const s = [];
                n.forEach((a)=>{
                    $d7238066c5de7f1c$var$fhe.includes(a.blockType) ? a.syncRef === $d7238066c5de7f1c$var$sr.START && s.push(a) : this.onFinish(a);
                }), s.length && console.log("Au array : ", s), s.length && this.onFinish(s);
            }
        }
    }
    start() {
        this._started || (this._started = !0, this.globalTimer = 0, this.update(0));
    }
    flush() {
        this.bmlBlocks = [], this.syncPoints = [], this.finishedTasks = [];
    }
    reset() {
        this._started = !1, this.flush(), this.globalTimer = 0;
    }
}
const $d7238066c5de7f1c$var$rP = {
    au: [
        1,
        4
    ],
    side: "both"
}, $d7238066c5de7f1c$var$aP = {
    au: [
        1,
        2
    ],
    side: "both"
}, $d7238066c5de7f1c$var$oP = {
    au: [
        1,
        2
    ],
    side: "left"
}, $d7238066c5de7f1c$var$gP = {
    au: [
        1,
        2
    ],
    side: "right"
}, $d7238066c5de7f1c$var$lP = {
    au: [
        4
    ],
    side: "both"
}, $d7238066c5de7f1c$var$cP = {
    au: [
        4
    ],
    side: "left"
}, $d7238066c5de7f1c$var$uP = {
    au: [
        4
    ],
    side: "right"
}, $d7238066c5de7f1c$var$IP = {
    au: [
        15
    ],
    side: "both"
}, $d7238066c5de7f1c$var$dP = {
    au: [
        15
    ],
    side: "left"
}, $d7238066c5de7f1c$var$hP = {
    au: [
        15
    ],
    side: "right"
}, $d7238066c5de7f1c$var$CP = {
    au: [
        12
    ],
    side: "both"
}, $d7238066c5de7f1c$var$pP = {
    au: [
        12
    ],
    side: "left"
}, $d7238066c5de7f1c$var$mP = {
    au: [
        12
    ],
    side: "right"
}, $d7238066c5de7f1c$var$AP = {
    au: [
        25,
        26
    ],
    side: null
}, $d7238066c5de7f1c$var$bP = {
    au: [
        25
    ],
    side: null
}, $d7238066c5de7f1c$var$yP = {
    au: [
        5,
        7
    ],
    side: null
}, $d7238066c5de7f1c$var$BP = {
    au: [
        45
    ],
    side: null
}, $d7238066c5de7f1c$var$vhe = {
    OBLIQUE_BROWS: $d7238066c5de7f1c$var$rP,
    RAISE_BROWS: $d7238066c5de7f1c$var$aP,
    RAISE_LEFT_BROW: $d7238066c5de7f1c$var$oP,
    RAISE_RIGHT_BROW: $d7238066c5de7f1c$var$gP,
    LOWER_BROWS: $d7238066c5de7f1c$var$lP,
    LOWER_LEFT_BROW: $d7238066c5de7f1c$var$cP,
    LOWER_RIGHT_BROW: $d7238066c5de7f1c$var$uP,
    LOWER_MOUTH_CORNERS: $d7238066c5de7f1c$var$IP,
    LOWER_LEFT_MOUTH_CORNER: $d7238066c5de7f1c$var$dP,
    LOWER_RIGHT_MOUTH_CORNER: $d7238066c5de7f1c$var$hP,
    RAISE_MOUTH_CORNERS: $d7238066c5de7f1c$var$CP,
    RAISE_LEFT_MOUTH_CORNER: $d7238066c5de7f1c$var$pP,
    RAISE_RIGHT_MOUTH_CORNER: $d7238066c5de7f1c$var$mP,
    OPEN_MOUTH: $d7238066c5de7f1c$var$AP,
    OPEN_LIPS: $d7238066c5de7f1c$var$bP,
    WIDEN_EYES: $d7238066c5de7f1c$var$yP,
    CLOSE_EYES: $d7238066c5de7f1c$var$BP
}, $d7238066c5de7f1c$var$pT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    CLOSE_EYES: $d7238066c5de7f1c$var$BP,
    LOWER_BROWS: $d7238066c5de7f1c$var$lP,
    LOWER_LEFT_BROW: $d7238066c5de7f1c$var$cP,
    LOWER_LEFT_MOUTH_CORNER: $d7238066c5de7f1c$var$dP,
    LOWER_MOUTH_CORNERS: $d7238066c5de7f1c$var$IP,
    LOWER_RIGHT_BROW: $d7238066c5de7f1c$var$uP,
    LOWER_RIGHT_MOUTH_CORNER: $d7238066c5de7f1c$var$hP,
    OBLIQUE_BROWS: $d7238066c5de7f1c$var$rP,
    OPEN_LIPS: $d7238066c5de7f1c$var$bP,
    OPEN_MOUTH: $d7238066c5de7f1c$var$AP,
    RAISE_BROWS: $d7238066c5de7f1c$var$aP,
    RAISE_LEFT_BROW: $d7238066c5de7f1c$var$oP,
    RAISE_LEFT_MOUTH_CORNER: $d7238066c5de7f1c$var$pP,
    RAISE_MOUTH_CORNERS: $d7238066c5de7f1c$var$CP,
    RAISE_RIGHT_BROW: $d7238066c5de7f1c$var$gP,
    RAISE_RIGHT_MOUTH_CORNER: $d7238066c5de7f1c$var$mP,
    WIDEN_EYES: $d7238066c5de7f1c$var$yP,
    default: $d7238066c5de7f1c$var$vhe
}, Symbol.toStringTag, {
    value: "Module"
})), $d7238066c5de7f1c$var$fP = {
    planes: [
        "x"
    ],
    upperlimit: [
        25
    ]
}, $d7238066c5de7f1c$var$GP = {
    planes: [
        "y"
    ],
    upperlimit: [
        20
    ],
    lowerlimit: [
        -20
    ],
    forthAndBack: !0
}, $d7238066c5de7f1c$var$vP = {
    planes: [
        "z"
    ],
    upperlimit: [
        20
    ],
    lowerlimit: [
        -20
    ]
}, $d7238066c5de7f1c$var$SP = {
    planes: [
        "y"
    ],
    upperlimit: [
        25
    ]
}, $d7238066c5de7f1c$var$ZP = {
    planes: [
        "y"
    ],
    upperlimit: [
        25
    ]
}, $d7238066c5de7f1c$var$RP = {
    planes: [
        "x"
    ],
    upperlimit: [
        20
    ]
}, $d7238066c5de7f1c$var$VP = {
    planes: [
        "x"
    ],
    upperlimit: [
        20
    ]
}, $d7238066c5de7f1c$var$She = {
    NOD: $d7238066c5de7f1c$var$fP,
    SHAKE: $d7238066c5de7f1c$var$GP,
    TILT: $d7238066c5de7f1c$var$vP,
    MOVE_LEFT: $d7238066c5de7f1c$var$SP,
    MOVE_RIGHT: $d7238066c5de7f1c$var$ZP,
    MOVE_UP: $d7238066c5de7f1c$var$RP,
    MOVE_DOWN: $d7238066c5de7f1c$var$VP
}, $d7238066c5de7f1c$var$mT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    MOVE_DOWN: $d7238066c5de7f1c$var$VP,
    MOVE_LEFT: $d7238066c5de7f1c$var$SP,
    MOVE_RIGHT: $d7238066c5de7f1c$var$ZP,
    MOVE_UP: $d7238066c5de7f1c$var$RP,
    NOD: $d7238066c5de7f1c$var$fP,
    SHAKE: $d7238066c5de7f1c$var$GP,
    TILT: $d7238066c5de7f1c$var$vP,
    default: $d7238066c5de7f1c$var$She
}, Symbol.toStringTag, {
    value: "Module"
})), $d7238066c5de7f1c$var$Zhe = new RegExp("((leftshoulder)|(leftarm)|(leftforearm)|(lefthand))+", "i"), $d7238066c5de7f1c$var$Rhe = new RegExp("((rightshoulder)|(rightarm)|(rightforearm)|(righthand))+", "i"), $d7238066c5de7f1c$var$AT = "https://cdn.retorik.ai/bodyengine-three/animations/bml/", $d7238066c5de7f1c$var$bT = {
    left: {
        x: 2,
        y: 1,
        z: 1
    },
    right: {
        x: -2,
        y: 1,
        z: 1
    }
};
class $d7238066c5de7f1c$var$Vhe {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_realizer", null), $d7238066c5de7f1c$var$P(this, "_globalManager"), $d7238066c5de7f1c$var$P(this, "_animationClipMap", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_animationActionMap", /* @__PURE__ */ new Map()), $d7238066c5de7f1c$var$P(this, "_playingAnimations", /* @__PURE__ */ new Map()), this._realizer = new $d7238066c5de7f1c$var$Ghe(void 0, (t)=>this.handleBreakPoint(t), ()=>this.killAllPlayingAnimations()), this._globalManager = e;
    }
    get animationActionMap() {
        return this._animationActionMap;
    }
    _removeTracksAndMakeAction(e) {
        var t, i, n;
        let s;
        return e.name.includes("_BG") ? s = $d7238066c5de7f1c$var$Zhe : e.name.includes("_BD") && (s = $d7238066c5de7f1c$var$Rhe), s && (e.tracks = e.tracks.filter((a)=>s.test(a.name))), this._animationClipMap.set(e.name, e), (n = (i = (t = this._globalManager) == null ? void 0 : t.animationManager) == null ? void 0 : i.animationMixer) == null ? void 0 : n.clipAction(e);
    }
    async loadAnimations(e) {
        const t = await fetch(`${$d7238066c5de7f1c$var$AT}list.json`).then((n)=>n.json()), i = [];
        t.forEach((n)=>{
            i.push({
                url: `${$d7238066c5de7f1c$var$AT}${n[0]}`,
                name: n[0].split(".")[0]
            });
        });
        for (const n of i)await new Promise(async (s, a)=>{
            var o, g;
            const l = {
                url: n.url,
                name: void 0,
                returnClip: !0
            }, c = await ((g = (o = this._globalManager) == null ? void 0 : o.animationManager) == null ? void 0 : g.addCC4Animation(l));
            if (c) {
                c.name = `bml_${n.name}`;
                const d = this._removeTracksAndMakeAction(c);
                d && (d.setLoop($1W96c.LoopPingPong, 2), d.clampWhenFinished = !0, this._animationActionMap.set(c.name, {
                    action: d,
                    defaultDuration: c.duration
                }));
            }
            s();
        });
        return !0;
    }
    _handleFaceFacs(e) {
        var t;
        let i = 0;
        const n = [];
        e.forEach((s)=>{
            var a, o, g, l, c, d;
            const p = (a = this._realizer) == null ? void 0 : a.bmlBlocks.find((A)=>A.id === s.blockId);
            if (p) {
                const A = p.timeline.start !== void 0 && p.timeline.end !== void 0 && p.timeline.end > p.timeline.start ? p.timeline.end - p.timeline.start : 0;
                switch(A > i && (i = A), p.type){
                    case $d7238066c5de7f1c$var$Vi.FACEFACS:
                        {
                            const y = p;
                            n.push({
                                index: y.au,
                                strength: y.amount || 0,
                                side: ((o = y.side) == null ? void 0 : o.toLowerCase()) || void 0,
                                duration: A,
                                timeline: y.timeline
                            });
                            break;
                        }
                    case $d7238066c5de7f1c$var$Ds.FACS:
                        {
                            const y = p;
                            n.push({
                                index: y.au,
                                strength: y.amount || 0,
                                side: ((g = y.side) == null ? void 0 : g.toLowerCase()) || void 0,
                                duration: A,
                                timeline: y.timeline,
                                shift: y.shift
                            });
                            break;
                        }
                    case $d7238066c5de7f1c$var$Vi.FACELEXEME:
                        {
                            const y = p, G = $d7238066c5de7f1c$var$pT[y.lexeme];
                            (l = G == null ? void 0 : G.au) != null && l.length && G.au.forEach((Z)=>{
                                var v;
                                n.push({
                                    index: Z,
                                    strength: y.amount || 0,
                                    side: ((v = G.side) == null ? void 0 : v.toLowerCase()) || void 0,
                                    duration: A,
                                    timeline: y.timeline
                                });
                            });
                            break;
                        }
                    case $d7238066c5de7f1c$var$Ds.LEXEME:
                        {
                            const y = p, G = $d7238066c5de7f1c$var$pT[y.lexeme];
                            if ((c = G == null ? void 0 : G.au) != null && c.length) {
                                const Z = (d = y.parentAttributes.find((v)=>v.name === "amount")) == null ? void 0 : d.value;
                                G.au.forEach((v)=>{
                                    var V;
                                    n.push({
                                        index: v,
                                        strength: typeof Z == "number" ? Z : 0,
                                        side: ((V = G.side) == null ? void 0 : V.toLowerCase()) || void 0,
                                        duration: A,
                                        timeline: y.timeline,
                                        shift: y.shift
                                    });
                                });
                            }
                            break;
                        }
                }
            }
        }), (t = this._globalManager) == null || t.FACSManager.updateFacialAnimation(n, i);
    }
    _handleHead(e, t) {
        var i, n, s;
        if (e.lexeme && $d7238066c5de7f1c$var$mT[e.lexeme]) {
            const a = $d7238066c5de7f1c$var$mT[e.lexeme];
            if (e.amount) for(let o = 0; o < a.planes.length; o++)a.upperlimit[o] *= e.amount, (i = a.lowerlimit) != null && i.length && (a.lowerlimit[o] *= e.amount);
            (s = (n = this._globalManager) == null ? void 0 : n.headPoseManager) == null || s.updateHeadPosition({
                ...a,
                repetition: e.repetition,
                timeline: e.timeline
            }, t);
        }
    }
    _handleHeadDirection(e, t) {
        var i, n;
        if (e.target && $d7238066c5de7f1c$var$bT[e.target]) {
            const s = $d7238066c5de7f1c$var$bT[e.target], a = {
                planes: [
                    "x",
                    "y",
                    "z"
                ],
                upperlimit: [
                    s.x,
                    s.y,
                    s.z
                ]
            };
            (n = (i = this._globalManager) == null ? void 0 : i.headPoseManager) == null || n.updateHeadPosition({
                ...a,
                repetition: 1,
                timeline: e.timeline,
                shift: !0
            }, t);
        }
    }
    _handlePointing(e, t, i, n) {
        var s, a, o, g, l, c, d, p, A, y;
        let G = "";
        if (i) switch(i.toLowerCase()){
            case "up":
                G = "bml_gestureup";
                break;
            case "upright":
                G = "bml_gestureupright";
                break;
            case "upleft":
                G = "bml_gestureupleft";
                break;
            case "down":
                G = "bml_gesturedown";
                break;
            case "downright":
                G = "bml_gesturedownright";
                break;
            case "downleft":
                G = "bml_gesturedownleft";
                break;
            case "left":
                G = "bml_gestureleft";
                break;
            case "right":
                G = "bml_gestureright";
                break;
            case "user":
                G = "bml_gestureuser2";
                break;
            case "me":
                G = "bml_gestureme2";
                break;
        }
        if (G) {
            let Z;
            switch(t == null ? void 0 : t.toLowerCase()){
                case "left_hand":
                    Z = (s = this._animationClipMap.get(G + "_BG")) == null ? void 0 : s.clone();
                    break;
                case "right_hand":
                    Z = (a = this._animationClipMap.get(G + "_BD")) == null ? void 0 : a.clone();
                    break;
                case "both_hands":
                    const v = (o = this._animationClipMap.get(G + "_BG")) == null ? void 0 : o.clone(), V = (g = this._animationClipMap.get(G + "_BD")) == null ? void 0 : g.clone();
                    v && V && (Z = new $1W96c.AnimationClip(G + "_BOTH", Math.max(v.duration, V.duration), [
                        ...v.tracks,
                        ...V.tracks
                    ], $1W96c.NormalAnimationBlendMode));
                    break;
                default:
                    Z = (l = this._animationClipMap.get(G + "_BD")) == null ? void 0 : l.clone();
                    break;
            }
            if (Z) {
                this._playingAnimations.size && $1W96c.AnimationUtils.makeClipAdditive(Z);
                const v = (p = (d = (c = this._globalManager) == null ? void 0 : c.animationManager) == null ? void 0 : d.animationMixer) == null ? void 0 : p.clipAction(Z);
                v && (v.setLoop($1W96c.LoopPingPong, 2), v.clampWhenFinished = !0, n && v.setDuration(n), (y = (A = this._globalManager) == null ? void 0 : A.animationManager.animationMixer) == null || y.playAnimationAction(v, !!this._playingAnimations.size), this._playingAnimations.set(e, v.getClip().name));
            }
        }
    }
    _handleStartTask(e) {
        var t, i;
        const n = (t = this._realizer) == null ? void 0 : t.bmlBlocks.find((s)=>s.id === e.blockId);
        if (n && n.timeline.start) {
            const s = n.timeline.end, a = s && (i = this._realizer) != null && i.globalTimer ? s - n.timeline.start : 0;
            switch(n.type){
                case $d7238066c5de7f1c$var$Vi.FACE:
                case $d7238066c5de7f1c$var$Vi.FACESHIFT:
                    break;
                case $d7238066c5de7f1c$var$Vi.FACEFACS:
                case $d7238066c5de7f1c$var$Vi.FACELEXEME:
                    break;
                case $d7238066c5de7f1c$var$Vi.GAZE:
                case $d7238066c5de7f1c$var$Vi.GAZESHIFT:
                case $d7238066c5de7f1c$var$Vi.GESTURE:
                case $d7238066c5de7f1c$var$Vi.HEAD:
                    this._handleHead(n, a);
                    break;
                case $d7238066c5de7f1c$var$Vi.HEADDIRECTIONSHIFT:
                    this._handleHeadDirection(n, a);
                    break;
                case $d7238066c5de7f1c$var$Vi.LOCOMOTION:
                    break;
                case $d7238066c5de7f1c$var$Vi.POINTING:
                    this._handlePointing(e.blockId, n.mode, n.target, a);
                    break;
                case $d7238066c5de7f1c$var$Vi.POSTURE:
                case $d7238066c5de7f1c$var$Vi.POSTURESHIFT:
                    break;
                case $d7238066c5de7f1c$var$Vi.SPEECH:
                case $d7238066c5de7f1c$var$Vi.WAIT:
                    break;
                case $d7238066c5de7f1c$var$Ds.FACS:
                case $d7238066c5de7f1c$var$Ds.LEXEME:
                    break;
                case $d7238066c5de7f1c$var$Ds.POSE:
                case $d7238066c5de7f1c$var$Ds.STANCE:
                    break;
            }
        }
    }
    _handleEndTask(e) {
        this._playingAnimations.has(e.blockId) && this._playingAnimations.delete(e.blockId);
    }
    killAllPlayingAnimations() {
        this._playingAnimations.size && (this._playingAnimations.forEach((e)=>{
            var t, i;
            (i = (t = this._globalManager) == null ? void 0 : t.animationManager) == null || i.stopAnimation(e, !0);
        }), this._playingAnimations = /* @__PURE__ */ new Map());
    }
    handleBreakPoint(e) {
        if (Array.isArray(e)) this._handleFaceFacs(e);
        else switch(e.syncRef){
            case $d7238066c5de7f1c$var$sr.START:
                this._handleStartTask(e);
                break;
            case $d7238066c5de7f1c$var$sr.END:
                this._handleEndTask(e);
                break;
        }
    }
    parse(e) {
        var t;
        e && ((t = this._realizer) == null || t.parse(e));
    }
    update(e) {
        var t;
        (t = this._realizer) == null || t.update(e);
    }
}
const $d7238066c5de7f1c$var$QY = {
    left: {
        up: "eyeLookUpLeft",
        down: "eyeLookDownLeft",
        in: "eyeLookInLeft",
        out: "eyeLookOutLeft"
    },
    right: {
        up: "eyeLookUpRight",
        down: "eyeLookDownRight",
        in: "eyeLookInRight",
        out: "eyeLookOutRight"
    }
}, $d7238066c5de7f1c$var$whe = [
    "eyeLookUpLeft",
    "eyeLookDownLeft",
    "eyeLookInLeft",
    "eyeLookOutLeft",
    "eyeLookUpRight",
    "eyeLookDownRight",
    "eyeLookInRight",
    "eyeLookOutRight"
], $d7238066c5de7f1c$var$Whe = {
    left: {
        up: "Eye_L_Look_Up",
        down: "Eye_L_Look_Down",
        in: "Eye_L_Look_R",
        out: "Eye_L_Look_L"
    },
    right: {
        up: "Eye_R_Look_Up",
        down: "Eye_R_Look_Down",
        in: "Eye_R_Look_L",
        out: "Eye_R_Look_R"
    }
}, $d7238066c5de7f1c$var$wP = [
    "LeftEye",
    "RightEye"
], $d7238066c5de7f1c$var$Hhe = [
    "CC_Base_L_Eye",
    "CC_Base_R_Eye"
], $d7238066c5de7f1c$var$Xhe = [
    "LeftEye",
    "RightEye"
];
class $d7238066c5de7f1c$var$Nhe {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "BreathingMeshs", []), $d7238066c5de7f1c$var$P(this, "NoBreathingMeshs", []), $d7238066c5de7f1c$var$P(this, "_breathAnime", null), $d7238066c5de7f1c$var$P(this, "_breath", {
            x: 1,
            y: 1,
            z: 1
        }), $d7238066c5de7f1c$var$P(this, "_started", !1), $d7238066c5de7f1c$var$P(this, "duration", 4e3), $d7238066c5de7f1c$var$P(this, "breathSpeed", 1), e.traverse((t)=>{
            t.isBone && t.name.toLowerCase().includes("spine") && t.children.length > 0 && t.name !== t.parent.name && this.BreathingMeshs.push(t);
        }), e.traverse((t)=>{
            if (t.isBone && t.name.toLowerCase().includes("spine")) for (const i of t.children)i.name.toLowerCase().includes("spine") || this.NoBreathingMeshs.push(i);
        }), this.BreathingMeshs = [
            ...new Set(this.BreathingMeshs)
        ], this.NoBreathingMeshs = [
            ...new Set(this.NoBreathingMeshs)
        ], this.breathSpeed = this.breathSpeed, this.start();
    }
    _initAnimation() {
        const e = this;
        function t() {
            e.duration = $d7238066c5de7f1c$var$ci.random(3e3, 4e3), e._breathAnime = $d7238066c5de7f1c$var$ci({
                targets: [
                    e._breath
                ],
                keyframes: [
                    {
                        x: 1 + 0.1 / e.BreathingMeshs.length,
                        y: 1 + 0.05 / e.BreathingMeshs.length,
                        z: 1 + 0.2 / e.BreathingMeshs.length,
                        duration: e.duration * (1 / 3 * 0.75)
                    },
                    {
                        x: 1 + 0.1 / e.BreathingMeshs.length,
                        y: 1 + 0.05 / e.BreathingMeshs.length,
                        z: 1 + 0.2 / e.BreathingMeshs.length,
                        duration: e.duration * (1 / 3 * 0.25)
                    },
                    {
                        x: 1,
                        y: 1,
                        z: 1,
                        duration: e.duration * (2 / 3 * 0.75)
                    },
                    {
                        x: 1,
                        y: 1,
                        z: 1,
                        duration: e.duration * (2 / 3 * 0.25)
                    }
                ],
                loop: !1,
                easing: "linear",
                complete: t
            });
        }
        t();
    }
    start() {
        this._started = !0, this._initAnimation();
    }
    stop() {
        var e;
        (e = this._breathAnime) == null || e.pause(), this._breathAnime = null, this._breath = {
            x: 1,
            y: 1,
            z: 1
        }, this._started = !1;
    }
    update(e) {
        var t;
        const i = [];
        if (this._started) {
            (t = this._breathAnime) == null || t.tick(e);
            for (const n of this.BreathingMeshs)i.push({
                name: n.name,
                value: [
                    n.scale.x,
                    n.scale.y,
                    n.scale.z,
                    1 + (this._breath.x - 1) / this.BreathingMeshs.length,
                    1 + (this._breath.y - 1) / this.BreathingMeshs.length,
                    1 + (this._breath.z - 1) / this.BreathingMeshs.length
                ]
            });
            for (const n of this.NoBreathingMeshs)i.push({
                name: n.name,
                value: [
                    n.scale.x,
                    n.scale.y,
                    n.scale.z,
                    1 / this._breath.x,
                    1 / this._breath.y,
                    1 / this._breath.z
                ]
            });
        }
        return i;
    }
}
class $d7238066c5de7f1c$var$Lhe {
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "_mesh"), $d7238066c5de7f1c$var$P(this, "animationMixer"), $d7238066c5de7f1c$var$P(this, "lipSyncManager"), $d7238066c5de7f1c$var$P(this, "animationManager"), $d7238066c5de7f1c$var$P(this, "eyeBlinkManager"), $d7238066c5de7f1c$var$P(this, "breathingManager"), $d7238066c5de7f1c$var$P(this, "FACSManager"), $d7238066c5de7f1c$var$P(this, "gazeManager"), $d7238066c5de7f1c$var$P(this, "headPoseManager"), $d7238066c5de7f1c$var$P(this, "bmlManager", null), $d7238066c5de7f1c$var$P(this, "animationOverride", !0), $d7238066c5de7f1c$var$P(this, "_fps", 25), $d7238066c5de7f1c$var$P(this, "_times", [
            0,
            1 / this._fps
        ]), $d7238066c5de7f1c$var$P(this, "_lastTimestamp", 0), $d7238066c5de7f1c$var$P(this, "_animationClip", new $1W96c.AnimationClip("globalClip", -1, [], $1W96c.NormalAnimationBlendMode)), $d7238066c5de7f1c$var$P(this, "_animationAction", null), this._mesh = e.mesh, e.animationOverride !== void 0 && (this.animationOverride = e.animationOverride), this.animationMixer = new $1W96c.AnimationMixer(this._mesh), this.lipSyncManager = new $d7238066c5de7f1c$var$Ade({
            lipSyncTargets: e.lipSyncTargets,
            lipSyncMesh: this._mesh,
            type: e.type,
            animationMixer: this.animationMixer,
            lipSyncVisemeIntensity: e.lipSyncVisemeIntensity
        }), this.animationManager = new $d7238066c5de7f1c$var$qde(e), this.breathingManager = new $d7238066c5de7f1c$var$Nhe(this._mesh), this.eyeBlinkManager = new $d7238066c5de7f1c$var$mde({
            morphTargets: e.blinkTargets
        }), this.gazeManager = new $d7238066c5de7f1c$var$ehe({
            ...e.gazeData,
            parent: this._mesh,
            type: e.type,
            headBone: e.headPoseData.headBone
        }), this.FACSManager = new $d7238066c5de7f1c$var$Mde({
            FACS: e.FACS,
            parent: this._mesh,
            globalManager: this
        }), this.headPoseManager = new $d7238066c5de7f1c$var$$de({
            ...e.headPoseData,
            parent: this._mesh,
            globalManager: this
        }), e.enableBmlManager && (this.bmlManager = new $d7238066c5de7f1c$var$Vhe(this));
    }
    /**
   * Stop looking at a target.
   * @param {number | undefined} fadeDuration time in milliseconds to get back to base position. Default 1000.
   */ releaseLookAt(e) {
        var t;
        this.headPoseManager.releaseLookAt(e), (t = this.gazeManager) == null || t.releaseLookAt();
    }
    /**
   * Look at the target and get back to normal after some time.
   * @param {THREE.Camera} target camera to which the face will look at.
   * @param {number | undefined} fadeInDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   * @param {number | undefined} fadeOutDuration time in milliseconds to get back to base position. Default 1000.
   * @param {number | undefined} releaseAfterDuration time in milliseconds after which the animation gets back to base position. Default 2000.
   */ lookAtAndRelease(e, t, i, n) {
        this.headPoseManager.lookAtAndRelease(e, t, i, n);
    }
    /**
   * Look at the target camera and then keep looking at it until release.
   * @param {THREE.Camera} target camera to which the face will keep looking at.
   * @param {number | undefined} fadeDuration time in milliseconds to go from the current position to the look at position. Default 1000.
   */ lookAtAndKeep(e, t) {
        var i, n;
        (i = this.headPoseManager) == null || i.lookAtAndKeep(e, t), (n = this.gazeManager) == null || n.lookAtAndKeep(e);
    }
    update(e) {
        var t, i;
        const n = e.characterState || $d7238066c5de7f1c$export$f2e6b371e93925c7.idle;
        (t = this.bmlManager) == null || t.update(e.deltaTime), this.lipSyncManager.update(e.deltaTime), this.animationManager.update(e.deltaTime, n);
        const s = [], a = !this.animationOverride || (i = e.AU) != null && i.length ? [] : this.eyeBlinkManager.update(e.timestamp), o = this.animationOverride ? this.breathingManager.update(e.timestamp) : [], g = this.animationOverride ? this.FACSManager.update(e.timestamp, e.AU, n) : [], l = this.animationOverride ? this.headPoseManager.update(e.timestamp, e.headPose || null) : [], c = this.animationOverride ? this.gazeManager.update(e.timestamp, e.gaze || null, l) : [
            [],
            []
        ], d = [
            ...a,
            ...c[0],
            ...g
        ], p = [
            ...c[1],
            ...l
        ], A = [
            ...o
        ], y = (e.timestamp - this._lastTimestamp) / 1e3;
        this._lastTimestamp = e.timestamp, (d.length || p.length) && this._mesh.traverse((G)=>{
            if (G.type === "SkinnedMesh" && G.morphTargetDictionary !== void 0) {
                const Z = G;
                d.forEach((v)=>{
                    if (!(G.name === "Eye_Mesh" && $d7238066c5de7f1c$var$whe.includes(v.name)) && Z.morphTargetDictionary && Z.morphTargetInfluences && v.name in Z.morphTargetDictionary) {
                        const V = Z.morphTargetInfluences[Z.morphTargetDictionary[v.name]];
                        s.push(new $1W96c.NumberKeyframeTrack(`${G.name}.morphTargetInfluences[${v.name}]`, [
                            0,
                            y
                        ], [
                            V,
                            v.value
                        ], $1W96c.InterpolateLinear));
                    }
                });
            }
        }), p.forEach((G)=>{
            s.push(new $1W96c.QuaternionKeyframeTrack(`${G.name}.quaternion`, this._times, G.value, $1W96c.InterpolateLinear));
        }), A.forEach((G)=>{
            s.push(new $1W96c.VectorKeyframeTrack(`${G.name}.scale`, this._times, G.value, $1W96c.InterpolateLinear));
        }), this.animationMixer.uncacheClip(this._animationClip), this.animationMixer.uncacheAction(this._animationClip), this._animationClip.tracks = s, this._animationClip.duration = y, this._animationAction = this.animationMixer.clipAction(this._animationClip), this._animationAction.setLoop($1W96c.LoopOnce, 1), this._animationAction.clampWhenFinished = !0, this._animationAction.reset().play(), this.animationMixer.update(e.deltaTime);
    }
}
const $d7238066c5de7f1c$var$ey = new $1W96c.Vector3(1, 0, 0), $d7238066c5de7f1c$var$Yhe = new $1W96c.Vector3(-1, 0, 0), $d7238066c5de7f1c$var$$v = new $1W96c.Vector3(0, 1, 0), $d7238066c5de7f1c$var$yT = new $1W96c.Vector3(0, -1, 0), $d7238066c5de7f1c$var$eS = new $1W96c.Vector3(0, 0, 1), $d7238066c5de7f1c$var$BT = new $1W96c.Vector3(0, 0, -1), $d7238066c5de7f1c$var$ty = class Md {
    // X
    // #endregion
    // #region MAIN
    constructor(e){
        $d7238066c5de7f1c$var$P(this, "swing"), $d7238066c5de7f1c$var$P(this, "twist"), $d7238066c5de7f1c$var$P(this, "ortho"), this.swing = $d7238066c5de7f1c$var$$v.clone(), this.twist = $d7238066c5de7f1c$var$eS.clone(), this.ortho = $d7238066c5de7f1c$var$ey.clone(), e && this.copy(e);
    }
    // #endregion
    // #region METHODS
    /** Get new BoneAxes with quaternion applied */ getFromQuat(e, t = new Md()) {
        return t.copy(this).applyQuat(e);
    }
    copy(e) {
        return this.swing.copy(e.swing), this.twist.copy(e.twist), this.ortho.copy(e.ortho), this;
    }
    /** Apply rotation on current axes directions */ applyQuat(e) {
        return this.swing.copy(this.swing.clone().applyQuaternion(e)).normalize(), this.twist.copy(this.twist.clone().applyQuaternion(e)).normalize(), this.ortho.copy(this.ortho.clone().applyQuaternion(e)).normalize(), this;
    }
    /** Set a quaternion direction set. For swing-twist ik rotations
   * please make sure the quaternion passed in are inverted first
   * when your looking to support qi axes.
   */ setQuatDirections(e, t = Md.UFR) {
        switch(t){
            case Md.UFR:
                this.swing.copy($d7238066c5de7f1c$var$$v.clone().applyQuaternion(e)), this.twist.copy($d7238066c5de7f1c$var$eS.clone().applyQuaternion(e)), this.ortho.copy($d7238066c5de7f1c$var$ey.clone().applyQuaternion(e));
                break;
            case Md.RBD:
                this.swing.copy($d7238066c5de7f1c$var$ey.clone().applyQuaternion(e)), this.twist.copy($d7238066c5de7f1c$var$BT.clone().applyQuaternion(e)), this.ortho.copy($d7238066c5de7f1c$var$yT.clone().applyQuaternion(e));
                break;
            case Md.LBU:
                this.swing.copy($d7238066c5de7f1c$var$Yhe.clone().applyQuaternion(e)), this.twist.copy($d7238066c5de7f1c$var$BT.clone().applyQuaternion(e)), this.ortho.copy($d7238066c5de7f1c$var$$v.clone().applyQuaternion(e));
                break;
            case Md.DFR:
                this.swing.copy($d7238066c5de7f1c$var$yT.clone().applyQuaternion(e)), this.twist.copy($d7238066c5de7f1c$var$eS.clone().applyQuaternion(e)), this.ortho.copy($d7238066c5de7f1c$var$ey.clone().applyQuaternion(e));
                break;
            case Md.FUR:
                this.swing.copy($d7238066c5de7f1c$var$eS.clone().applyQuaternion(e)), this.twist.copy($d7238066c5de7f1c$var$$v.clone().applyQuaternion(e)), this.ortho.copy($d7238066c5de7f1c$var$ey.clone().applyQuaternion(e));
                break;
        }
        return this.swing.normalize(), this.twist.normalize(), this.ortho.normalize(), this;
    }
};
$d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$ty, "UFR", 0), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$ty, "RBD", 1), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$ty, "LBU", 2), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$ty, "DFR", 3), $d7238066c5de7f1c$var$P($d7238066c5de7f1c$var$ty, "FUR", 4);
class $d7238066c5de7f1c$var$Kr {
    constructor(e, t, i, n, s = !1){
        $d7238066c5de7f1c$var$P(this, "name"), $d7238066c5de7f1c$var$P(this, "isLR"), $d7238066c5de7f1c$var$P(this, "isChain"), $d7238066c5de7f1c$var$P(this, "reFind"), $d7238066c5de7f1c$var$P(this, "reExclude"), this.name = e, this.isLR = t, this.isChain = s, this.reFind = new RegExp(i, "i"), n && (this.reExclude = new RegExp(n, "i"));
    }
    test(e) {
        return !this.reFind.test(e) || this.reExclude && this.reExclude.test(e) ? null : this.isLR && $d7238066c5de7f1c$var$Khe.test(e) ? this.name + "_l" : this.isLR && $d7238066c5de7f1c$var$xhe.test(e) ? this.name + "_r" : this.name;
    }
}
const $d7238066c5de7f1c$var$Khe = new RegExp("\\.l|left|_l", "i"), $d7238066c5de7f1c$var$xhe = new RegExp("\\.r|right|_r", "i");
new $d7238066c5de7f1c$var$Kr("thigh", !0, "thigh|upleg|upperleg", "twist"), new $d7238066c5de7f1c$var$Kr("shin", !0, "shin|leg|calf", "up|twist"), new $d7238066c5de7f1c$var$Kr("foot", !0, "foot"), new $d7238066c5de7f1c$var$Kr("toe", !0, "toebase"), new $d7238066c5de7f1c$var$Kr("shoulder", !0, "clavicle|shoulder"), new $d7238066c5de7f1c$var$Kr("upperarm", !0, "(upper.*arm|arm)", "fore|twist|lower"), new $d7238066c5de7f1c$var$Kr("forearm", !0, "forearm|arm", "up|twist"), new $d7238066c5de7f1c$var$Kr("hand", !0, "hand", "thumb|index|middle|ring|pinky"), new $d7238066c5de7f1c$var$Kr("head", !1, "head"), new $d7238066c5de7f1c$var$Kr("neck", !1, "neck", void 0, !0), new $d7238066c5de7f1c$var$Kr("hip", !1, "hips*|pelvis", void 0, !1), new $d7238066c5de7f1c$var$Kr("root", !1, "root"), new $d7238066c5de7f1c$var$Kr("spine", !1, "waist|spine*d*|chest", void 0, !0), new $d7238066c5de7f1c$var$Kr("thumb", !0, "thumb*d*", "toe", !0), new $d7238066c5de7f1c$var$Kr("index", !0, "index*d*", "toe", !0), new $d7238066c5de7f1c$var$Kr("middle", !0, "middle*d*|mid*d", "toe", !0), new $d7238066c5de7f1c$var$Kr("ring", !0, "ring*d*", "toe", !0), new $d7238066c5de7f1c$var$Kr("pinky", !0, "pinky*d*", "toe", !0);
class $d7238066c5de7f1c$var$la {
    constructor(e, t, i){
        $d7238066c5de7f1c$var$P(this, "rot", new $1W96c.Quaternion()), $d7238066c5de7f1c$var$P(this, "pos", new $1W96c.Vector3(0)), $d7238066c5de7f1c$var$P(this, "scl", new $1W96c.Vector3(1)), e instanceof $d7238066c5de7f1c$var$la ? this.copy(e) : e && t && i && this.set(e, t, i);
    }
    // #endregion
    // #region SETTERS / GETTERS
    reset() {
        return this.rot.identity(), this.pos.set(0, 0, 0), this.scl.set(1, 1, 1), this;
    }
    copy(e) {
        return this.rot.copy(e.rot), this.pos.copy(e.pos), this.scl.copy(e.scl), this;
    }
    set(e, t, i) {
        return e && this.rot.copy(e), t && this.pos.copy(t), i && this.scl.copy(i), this;
    }
    clone() {
        return new $d7238066c5de7f1c$var$la(this);
    }
    mul(e, t, i) {
        return e instanceof $d7238066c5de7f1c$var$la && (t = e.pos, i = e.scl, e = e.rot), e && t && (this.pos.add(this.scl.clone().multiply(t).applyQuaternion(this.rot)), i && this.scl.multiply(i), this.rot.multiply(e)), this;
    }
    premultiply(e, t, i) {
        return e instanceof $d7238066c5de7f1c$var$la && (t = e.pos, i = e.scl, e = e.rot), !e || !t || !i ? this : (this.pos.multiply(i).applyQuaternion(e).add(t), i && this.scl.multiply(i), this.rot.premultiply(e), this);
    }
    addPos(e, t = !1) {
        return t ? this.pos.add(e.clone().applyQuaternion(this.rot)) : this.pos.add(e.clone().multiply(this.scl).applyQuaternion(this.rot)), this;
    }
    // #endregion
    // #region FROM OPERATORS
    fromMul(e, t) {
        const i = e.scl.clone().multiply(t.pos).applyQuaternion(e.rot);
        return this.pos = e.pos.clone().add(i), this.scl = e.scl.clone().multiply(t.scl), this.rot = e.rot.clone().multiply(t.rot), this;
    }
    fromInvert(e) {
        return this.rot = e.rot.invert(), this.scl = $d7238066c5de7f1c$var$Ude(e.scl.clone()), this.pos = e.pos.clone().negate().multiply(this.scl).applyQuaternion(this.rot), this;
    }
    // #endregion
    // #region TRANSFORMATION
    transformVec3(e, t) {
        return (t || e).clone().multiply(this.scl).applyQuaternion(this.rot).add(this.pos);
    }
    // #endregion
    static fromObject3D(e) {
        return new $d7238066c5de7f1c$var$la(e.quaternion, e.position, e.scale);
    }
    static fromWorlObject3D(e) {
        const t = new $1W96c.Quaternion(), i = new $1W96c.Vector3(), n = new $1W96c.Vector3();
        return e.getWorldQuaternion(t), e.getWorldPosition(i), e.getWorldScale(n), new $d7238066c5de7f1c$var$la(t, i, n);
    }
}
class $d7238066c5de7f1c$var$OY {
    // Source pose that this pose came from
    constructor(e){
        if ($d7238066c5de7f1c$var$P(this, "arm"), $d7238066c5de7f1c$var$P(this, "offset", new $d7238066c5de7f1c$var$la()), $d7238066c5de7f1c$var$P(this, "linkedBone"), $d7238066c5de7f1c$var$P(this, "bones", new Array()), $d7238066c5de7f1c$var$P(this, "srcPose"), e && (this.arm = e), e != null && e.bones) for(let t = 0; t < e.bones.length; t++)this.bones.push(e.bones[t].clone());
    }
    // #endregion
    // #region GETTERS
    getBone(e) {
        switch(typeof e){
            case "string":
                return this.arm.getBoneByName(e) || null;
            case "number":
                return this.bones[e];
        }
        return null;
    }
    getBones(e) {
        const t = [];
        let i;
        for (const n of e)(i = this.getBone(n)) && t.push(i);
        return t;
    }
    clone() {
        const e = new $d7238066c5de7f1c$var$OY();
        e.arm = this.arm, e.offset.copy(this.offset);
        for (const t of this.bones)e.bones.push(t.clone());
        return e;
    }
    getWorldTailPos(e, t = new $1W96c.Vector3()) {
        const i = this.getBone(e);
        return i && $d7238066c5de7f1c$var$la.fromWorlObject3D(i).transformVec3(t.set(0, 0, 0)), t;
    }
    // #endregion
    // #region SETTERS
    setLocalPos(e, t) {
        const i = this.getBone(e);
        return i && i.position.copy(t), this;
    }
    setLocalRot(e, t) {
        const i = this.getBone(e);
        return i && i.quaternion.copy(t), this;
    }
    copy(e) {
        const t = this.bones.length;
        this.srcPose = e;
        for(let i = 0; i < t; i++)this.bones[i].matrix.copy(e.bones[i].matrix), this.bones[i].matrixWorld.copy(e.bones[i].matrixWorld);
        return this;
    }
    // #endregion
    // #region COMPUTE
    updateWorld() {
        for (const e of this.bones){
            const t = $d7238066c5de7f1c$var$la.fromObject3D(e), i = $d7238066c5de7f1c$var$la.fromWorlObject3D(e);
            e.parent !== null ? i.fromMul($d7238066c5de7f1c$var$la.fromWorlObject3D(e.parent), t) : (i.fromMul(this.offset, t), this.linkedBone && i.premultiply($d7238066c5de7f1c$var$la.fromWorlObject3D(this.linkedBone)));
        }
        return this;
    }
    getWorldRotation(e, t = new $1W96c.Quaternion()) {
        let i = this.getBone(e);
        if (!i) return e === -1 ? t.copy(this.offset.rot) : console.error("Pose.getWorldRotation - bone not found", e), t;
        for(t.copy(i.quaternion); i && i.userData.pindex >= 0;)i = this.bones[i.userData.pindex], t.premultiply(i.quaternion);
        return t.premultiply(this.offset.rot), this.linkedBone && t.premultiply(this.linkedBone.getWorldQuaternion(new $1W96c.Quaternion())), t;
    }
    getWorldTransform(e, t = new $d7238066c5de7f1c$var$la()) {
        const i = this.getBone(e);
        if (!i) return e === -1 ? t.copy(this.offset) : console.error("Pose.getWorldTransform - bone not found", e), t;
        for(t.copy($d7238066c5de7f1c$var$la.fromObject3D(i)); i.parent !== null;)t.premultiply($d7238066c5de7f1c$var$la.fromObject3D(i.parent));
        return t.premultiply(this.offset), this.linkedBone && t.premultiply($d7238066c5de7f1c$var$la.fromWorlObject3D(this.linkedBone)), t;
    }
    getWorldPosition(e, t = new $1W96c.Vector3()) {
        return t.copy(this.getWorldTransform(e).pos);
    }
    getWorldScale(e, t = new $1W96c.Vector3()) {
        return t.copy(this.getWorldTransform(e).scl);
    }
    getWorldQuaternion(e, t = new $1W96c.Quaternion()) {
        return t.copy(this.getWorldTransform(e).rot);
    }
    // #endregion
    // #region OPERATIONS
    rotLocal(e, t, i = 0) {
        const n = this.getBone(e);
        if (n) switch(i){
            case 1:
                n.rotateY(t * Math.PI / 180);
                break;
            case 2:
                n.rotateZ(t * Math.PI / 180);
                break;
            default:
                n.rotateX(t * Math.PI / 180);
                break;
        }
        else console.warn("Bone not found, ", e);
        return this;
    }
    rotWorld(e, t, i = "x") {
        const n = this.getBone(e);
        if (n) {
            const s = this.getWorldQuaternion(e), a = s.clone().multiply(n.quaternion), o = i == "y" ? new $1W96c.Vector3(0, 1, 0) : i == "z" ? new $1W96c.Vector3(0, 0, 1) : new $1W96c.Vector3(1, 0, 0);
            n.applyQuaternion(a.premultiply(new $1W96c.Quaternion().setFromAxisAngle(o, t * Math.PI / 180)).premultiply(s).invert());
        } else console.error("Pose.rotWorld - bone not found", e);
        return this;
    }
    moveLocal(e, t) {
        const i = this.getBone(e);
        return i ? i.position.add(t) : console.warn("Pose.moveLocal - bone not found, ", e), this;
    }
    posLocal(e, t) {
        const i = this.getBone(e);
        return i ? i.position.copy(t) : console.warn("Pose.posLocal - bone not found, ", e), this;
    }
    sclLocal(e, t) {
        const i = this.getBone(e);
        return i ? t instanceof $1W96c.Vector3 ? i.scale.copy(t) : typeof t == "number" && i.scale.set(t, t, t) : console.warn("Pose.sclLocal - bone not found, ", e), this;
    }
}
class $d7238066c5de7f1c$var$Jc extends $1W96c.SkeletonHelper {
    constructor(e){
        var t;
        super(e), $d7238066c5de7f1c$var$P(this, "_boneMap"), $d7238066c5de7f1c$var$P(this, "object"), $d7238066c5de7f1c$var$P(this, "_skeleton"), this.object = e, this._skeleton = new $1W96c.Skeleton(this.bones);
        for (const i of this._skeleton.bones)i.userData.index = this._skeleton.bones.indexOf(i), (t = i.parent) != null && t.isBone && (i.userData.pindex = this._skeleton.bones.indexOf(i.parent));
        this._boneMap = new $d7238066c5de7f1c$var$eN(this._skeleton);
    }
    get skeleton() {
        return this._skeleton;
    }
    set skeleton(e) {
        this._skeleton = e;
    }
    clone(e) {
        const t = $d7238066c5de7f1c$var$HIe(this.object);
        return console.log("clone", t), new $d7238066c5de7f1c$var$Jc(t);
    }
    newPose(e = !1) {
        const t = new $d7238066c5de7f1c$var$OY(this.skeleton);
        return e ? t.updateWorld() : t;
    }
    alignArmature(e) {
        new $d7238066c5de7f1c$var$nP().bindTPoses(e, this), this.updateMatrixWorld(!0);
    }
}
const $d7238066c5de7f1c$var$li = 1, $d7238066c5de7f1c$var$Fhe = {
    sil: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    DD: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    kk: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    RR: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "ou",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "sil",
            value: 0
        },
        {
            morphTargetName: "PP",
            value: 0
        },
        {
            morphTargetName: "FF",
            value: 0
        },
        {
            morphTargetName: "TH",
            value: 0
        },
        {
            morphTargetName: "DD",
            value: 0
        },
        {
            morphTargetName: "kk",
            value: 0
        },
        {
            morphTargetName: "CH",
            value: 0
        },
        {
            morphTargetName: "SS",
            value: 0
        },
        {
            morphTargetName: "nn",
            value: 0
        },
        {
            morphTargetName: "RR",
            value: 0
        },
        {
            morphTargetName: "aa",
            value: 0
        },
        {
            morphTargetName: "E",
            value: 0
        },
        {
            morphTargetName: "ih",
            value: 0
        },
        {
            morphTargetName: "oh",
            value: 0
        },
        {
            morphTargetName: "ou",
            value: $d7238066c5de7f1c$var$li
        }
    ]
}, $d7238066c5de7f1c$var$The = {
    sil: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 1
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 1
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.075
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "V_Open",
            value: 0.205
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.205
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.705
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0.455
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 1
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0.202
        }
    ],
    DD: [
        {
            morphTargetName: "V_Open",
            value: 0.071
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.071
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.606
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.062
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0.609
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0.702
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0.205
        }
    ],
    kk: [
        {
            morphTargetName: "V_Open",
            value: 0.065
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.065
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.801
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.019
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 1
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0.202
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 1
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "V_Open",
            value: 0.071
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.071
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.606
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0.609
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0.702
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0.205
        }
    ],
    RR: [
        {
            morphTargetName: "V_Open",
            value: 0.109
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.109
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0.91
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.0604
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0.509
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0.509
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0.102
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0.354
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "V_Open",
            value: 1
        },
        {
            morphTargetName: "Jaw_Open",
            value: 1
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.3
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 1
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.91
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "V_Open",
            value: 0.152
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.152
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0.705
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.047
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "V_Open",
            value: 0.606
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0.606
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0
        },
        {
            morphTargetName: "V_Tight",
            value: 0.804
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0.183
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "V_Open",
            value: 0
        },
        {
            morphTargetName: "Jaw_Open",
            value: 0
        },
        {
            morphTargetName: "V_Explosive",
            value: 0
        },
        {
            morphTargetName: "V_Dental_Lip",
            value: 0
        },
        {
            morphTargetName: "V_Tight_O",
            value: 0.804
        },
        {
            morphTargetName: "V_Tight",
            value: 0
        },
        {
            morphTargetName: "V_Wide",
            value: 0
        },
        {
            morphTargetName: "V_Affricate",
            value: 0
        },
        {
            morphTargetName: "V_Lip_Open",
            value: 0
        },
        {
            morphTargetName: "Merged_Open_Mouth",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Up",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Raise",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Out",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Narrow",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Lower",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_U",
            value: 0
        },
        {
            morphTargetName: "V_Tongue_Curl_D",
            value: 0
        }
    ]
}, $d7238066c5de7f1c$var$Mhe = {
    sil: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    DD: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    kk: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    RR: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: $d7238066c5de7f1c$var$li
        }
    ]
}, $d7238066c5de7f1c$var$zhe = {
    sil: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    PP: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    FF: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    TH: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    DD: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    kk: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    CH: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    SS: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    nn: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    RR: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    aa: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    E: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    I: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    O: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: $d7238066c5de7f1c$var$li
        },
        {
            morphTargetName: "viseme_U",
            value: 0
        }
    ],
    U: [
        {
            morphTargetName: "viseme_sil",
            value: 0
        },
        {
            morphTargetName: "viseme_PP",
            value: 0
        },
        {
            morphTargetName: "viseme_FF",
            value: 0
        },
        {
            morphTargetName: "viseme_TH",
            value: 0
        },
        {
            morphTargetName: "viseme_DD",
            value: 0
        },
        {
            morphTargetName: "viseme_kk",
            value: 0
        },
        {
            morphTargetName: "viseme_CH",
            value: 0
        },
        {
            morphTargetName: "viseme_SS",
            value: 0
        },
        {
            morphTargetName: "viseme_nn",
            value: 0
        },
        {
            morphTargetName: "viseme_RR",
            value: 0
        },
        {
            morphTargetName: "viseme_aa",
            value: 0
        },
        {
            morphTargetName: "viseme_E",
            value: 0
        },
        {
            morphTargetName: "viseme_I",
            value: 0
        },
        {
            morphTargetName: "viseme_O",
            value: 0
        },
        {
            morphTargetName: "viseme_U",
            value: $d7238066c5de7f1c$var$li
        }
    ]
}, $d7238066c5de7f1c$var$WP = {
    1: {
        both: [
            "browInnerUp"
        ]
    },
    2: {
        left: [
            "browOuterUpLeft"
        ],
        right: [
            "browOuterUpRight"
        ],
        both: [
            "browOuterUpLeft",
            "browOuterUpRight"
        ]
    },
    4: {
        left: [
            "browDownLeft"
        ],
        right: [
            "browDownRight"
        ],
        both: [
            "browDownLeft",
            "browDownRight"
        ]
    },
    5: {
        left: [
            "eyeWideLeft"
        ],
        right: [
            "eyeWideRight"
        ],
        both: [
            "eyeWideLeft",
            "eyeWideRight"
        ]
    },
    6: {
        left: [
            "cheekSquintLeft"
        ],
        right: [
            "cheekSquintRight"
        ],
        both: [
            "cheekSquintLeft",
            "cheekSquintRight"
        ]
    },
    7: {
        left: [
            "eyeSquintLeft"
        ],
        right: [
            "eyeSquintRight"
        ],
        both: [
            "eyeSquintLeft",
            "eyeSquintRight"
        ]
    },
    9: {
        left: [
            "noseSneerLeft"
        ],
        right: [
            "noseSneerRight"
        ],
        both: [
            "noseSneerLeft",
            "noseSneerRight"
        ]
    },
    10: {
        left: [
            "mouthUpperUpLeft"
        ],
        right: [
            "mouthUpperUpRight"
        ],
        both: [
            "mouthUpperUpLeft",
            "mouthUpperUpRight"
        ]
    },
    12: {
        left: [
            "mouthSmileLeft"
        ],
        right: [
            "mouthSmileRight"
        ],
        both: [
            "mouthSmileLeft",
            "mouthSmileRight"
        ]
    },
    14: {
        left: [
            "mouthDimpleLeft"
        ],
        right: [
            "mouthDimpleRight"
        ],
        both: [
            "mouthDimpleLeft",
            "mouthDimpleRight"
        ]
    },
    15: {
        left: [
            "mouthFrownLeft"
        ],
        right: [
            "mouthFrownRight"
        ],
        both: [
            "mouthFrownLeft",
            "mouthFrownRight"
        ]
    },
    16: {
        left: [
            "mouthLowerDownLeft"
        ],
        right: [
            "mouthLowerDownRight"
        ],
        both: [
            "mouthLowerDownLeft",
            "mouthLowerDownRight"
        ]
    },
    17: {
        both: [
            "mouthShrugLower"
        ]
    },
    18: {
        both: [
            "mouthPucker"
        ]
    },
    20: {
        left: [
            "mouthStretchLeft"
        ],
        right: [
            "mouthStretchRight"
        ],
        both: [
            "mouthStretchLeft",
            "mouthStretchRight"
        ]
    },
    22: {
        both: [
            "mouthFunnel"
        ]
    },
    23: {
        both: []
    },
    24: {
        left: [
            "mouthPressLeft"
        ],
        right: [
            "mouthPressRigh"
        ],
        both: [
            "mouthPressLeft",
            "mouthPressRight"
        ]
    },
    25: {
        both: []
    },
    26: {
        both: [
            "jawOpen"
        ]
    },
    28: {
        both: [
            "mouthRollLower",
            "mouthRollUpper"
        ]
    },
    45: {
        left: [
            "eyeBlinkLeft"
        ],
        right: [
            "eyeBlinkRight"
        ],
        both: [
            "eyeBlinkLeft",
            "eyeBlinkRight"
        ]
    }
}, $d7238066c5de7f1c$var$khe = {
    1: {
        left: [
            "Brow_Raise_Inner_L"
        ],
        right: [
            "Brow_Raise_Inner_R"
        ],
        both: [
            "Brow_Raise_Inner_L",
            "Brow_Raise_Inner_R"
        ]
    },
    2: {
        left: [
            "Brow_Raise_Outer_L"
        ],
        right: [
            "Brow_Raise_Outer_R"
        ],
        both: [
            "Brow_Raise_Outer_L",
            "Brow_Raise_Outer_R"
        ]
    },
    4: {
        left: [
            "Brow_Drop_L"
        ],
        right: [
            "Brow_Drop_R"
        ],
        both: [
            "Brow_Drop_L",
            "Brow_Drop_R"
        ]
    },
    5: {
        left: [
            "Eye_Wide_L"
        ],
        right: [
            "Eye_Wide_R"
        ],
        both: [
            "Eye_Wide_L",
            "Eye_Wide_R"
        ]
    },
    6: {
        left: [
            "Cheek_Raise_L"
        ],
        right: [
            "Cheek_Raise_R"
        ],
        both: [
            "Cheek_Raise_L",
            "Cheek_Raise_R"
        ]
    },
    7: {
        left: [
            "Eye_Squint_L"
        ],
        right: [
            "Eye_Squint_R"
        ],
        both: [
            "Eye_Squint_L",
            "Eye_Squint_R"
        ]
    },
    9: {
        left: [
            "Nose_Sneer_L"
        ],
        right: [
            "Nose_Sneer_R"
        ],
        both: [
            "Nose_Sneer_L",
            "Nose_Sneer_R"
        ]
    },
    10: {
        left: [
            "Mouth_Upper_L"
        ],
        right: [
            "Mouth_Upper_R"
        ],
        both: [
            "Mouth_Upper_L",
            "Mouth_Upper_R"
        ]
    },
    12: {
        left: [
            "Mouth_Smile_L"
        ],
        right: [
            "Mouth_Smile_R"
        ],
        both: [
            "Mouth_Smile_L",
            "Mouth_Smile_R"
        ]
    },
    14: {
        left: [
            "Mouth_Dimple_L"
        ],
        right: [
            "Mouth_Dimple_R"
        ],
        both: [
            "Mouth_Dimple_L",
            "Mouth_Dimple_R"
        ]
    },
    15: {
        left: [
            "Mouth_Frown_L"
        ],
        right: [
            "Mouth_Frown_R"
        ],
        both: [
            "Mouth_Frown_L",
            "Mouth_Frown_R"
        ]
    },
    16: {
        left: [
            "Mouth_Down_Lower_L"
        ],
        right: [
            "Mouth_Down_Lower_R"
        ],
        both: [
            "Mouth_Down_Lower_L",
            "Mouth_Down_Lower_R"
        ]
    },
    17: {
        both: [
            "Mouth_Shrug_Lower"
        ]
    },
    18: {
        left: [
            "Mouth_Pucker_Up_L",
            "Mouth_Pucker_Down_L"
        ],
        right: [
            "Mouth_Pucker_Up_R",
            "Mouth_Pucker_Up_R"
        ],
        both: [
            "Mouth_Pucker_Up_L",
            "Mouth_Pucker_Down_L",
            "Mouth_Pucker_Up_R",
            "Mouth_Pucker_Up_R"
        ]
    },
    20: {
        left: [
            "Mouth_Stretch_L"
        ],
        right: [
            "Mouth_Stretch_R"
        ],
        both: [
            "Mouth_Stretch_L",
            "Mouth_Stretch_R"
        ]
    },
    22: {
        left: [
            "Mouth_Funnel_Up_L",
            "Mouth_Funnel_Down_L"
        ],
        right: [
            "Mouth_Funnel_Up_R",
            "Mouth_Funnel_Down_R"
        ],
        both: [
            "Mouth_Funnel_Up_L",
            "Mouth_Funnel_Up_R",
            "Mouth_Funnel_Down_L",
            "Mouth_Funnel_Down_R"
        ]
    },
    23: {
        left: [
            "Mouth_Tighten_L"
        ],
        right: [
            "Mouth_Tighten_R"
        ],
        both: [
            "Mouth_Tighten_L",
            "Mouth_Tighten_R"
        ]
    },
    24: {
        left: [
            "Mouth_Press_L"
        ],
        right: [
            "Mouth_Press_R"
        ],
        both: [
            "Mouth_Press_L",
            "Mouth_Press_R"
        ]
    },
    25: {
        both: [
            "Mouth_Down"
        ]
    },
    26: {
        both: [
            "Jaw_Open"
        ]
    },
    28: {
        left: [
            "Mouth_Roll_In_Upper_L",
            "Mouth_Roll_In_Lower_L"
        ],
        right: [
            "Mouth_Roll_In_Upper_R",
            "Mouth_Roll_In_Lower_R"
        ],
        both: [
            "Mouth_Roll_In_Upper_L",
            "Mouth_Roll_In_Upper_R",
            "Mouth_Roll_In_Lower_L",
            "Mouth_Roll_In_Lower_R"
        ]
    },
    45: {
        left: [
            "Eye_Blink_L"
        ],
        right: [
            "Eye_Blink_R"
        ],
        both: [
            "Eye_Blink_L",
            "Eye_Blink_R"
        ],
        limit: 1
    }
}, $d7238066c5de7f1c$var$Ehe = {
    1: {
        both: [
            "browInnerUp"
        ]
    },
    2: {
        left: [
            "browOuterUpLeft"
        ],
        right: [
            "browOuterUpRight"
        ],
        both: [
            "browOuterUpLeft",
            "browOuterUpRight"
        ]
    },
    4: {
        left: [
            "browDownLeft"
        ],
        right: [
            "browDownRight"
        ],
        both: [
            "browDownLeft",
            "browDownRight"
        ]
    },
    5: {
        left: [
            "eyeWideLeft"
        ],
        right: [
            "eyeWideRight"
        ],
        both: [
            "eyeWideLeft",
            "eyeWideRight"
        ]
    },
    6: {
        left: [
            "cheekSquintLeft"
        ],
        right: [
            "cheekSquintRight"
        ],
        both: [
            "cheekSquintLeft",
            "cheekSquintRight"
        ]
    },
    7: {
        left: [
            "eyeSquintLeft"
        ],
        right: [
            "eyeSquintRight"
        ],
        both: [
            "eyeSquintLeft",
            "eyeSquintRight"
        ]
    },
    9: {
        left: [
            "noseSneerLeft"
        ],
        right: [
            "noseSneerRight"
        ],
        both: [
            "noseSneerLeft",
            "noseSneerRight"
        ]
    },
    10: {
        left: [
            "mouthUpperUpLeft"
        ],
        right: [
            "mouthUpperUpRight"
        ],
        both: [
            "mouthUpperUpLeft",
            "mouthUpperUpRight"
        ]
    },
    12: {
        left: [
            "mouthSmileLeft"
        ],
        right: [
            "mouthSmileRight"
        ],
        both: [
            "mouthSmileLeft",
            "mouthSmileRight"
        ]
    },
    14: {
        left: [
            "mouthDimpleLeft"
        ],
        right: [
            "mouthDimpleRight"
        ],
        both: [
            "mouthDimpleLeft",
            "mouthDimpleRight"
        ]
    },
    15: {
        left: [
            "mouthFrownLeft"
        ],
        right: [
            "mouthFrownRight"
        ],
        both: [
            "mouthFrownLeft",
            "mouthFrownRight"
        ]
    },
    16: {
        left: [
            "mouthLowerDownLeft"
        ],
        right: [
            "mouthLowerDownRight"
        ],
        both: [
            "mouthLowerDownLeft",
            "mouthLowerDownRight"
        ]
    },
    17: {
        both: [
            "mouthShrugLower"
        ]
    },
    18: {
        both: [
            "mouthPucker"
        ]
    },
    20: {
        left: [
            "mouthStretchLeft"
        ],
        right: [
            "mouthStretchRight"
        ],
        both: [
            "mouthStretchLeft",
            "mouthStretchRight"
        ]
    },
    22: {
        both: [
            "mouthFunnel"
        ]
    },
    23: {
        both: []
    },
    24: {
        left: [
            "mouthPressLeft"
        ],
        right: [
            "mouthPressRight"
        ],
        both: [
            "mouthPressLeft",
            "mouthPressRight"
        ]
    },
    25: {
        both: []
    },
    26: {
        both: [
            "jawOpen"
        ]
    },
    28: {
        both: [
            "mouthRollLower",
            "mouthRollUpper"
        ]
    },
    45: {
        left: [
            "eyeBlinkLeft"
        ],
        right: [
            "eyeBlinkRight"
        ],
        both: [
            "eyeBlinkLeft",
            "eyeBlinkRight"
        ]
    }
}, $d7238066c5de7f1c$var$HP = [
    "Neck"
], $d7238066c5de7f1c$var$Jhe = [
    "CC_Base_NeckTwist01"
], $d7238066c5de7f1c$var$Uhe = [
    "Neck"
], $d7238066c5de7f1c$var$XP = "Head", $d7238066c5de7f1c$var$Dhe = "CC_Base_Head", $d7238066c5de7f1c$var$_he = "Head", $d7238066c5de7f1c$var$Phe = {
    lipSyncTargets: $d7238066c5de7f1c$var$Fhe,
    blinkTargets: $d7238066c5de7f1c$var$eP,
    gazeData: {
        bones: $d7238066c5de7f1c$var$wP,
        morphTargets: $d7238066c5de7f1c$var$QY
    },
    FACS: $d7238066c5de7f1c$var$WP,
    headPoseData: {
        bones: $d7238066c5de7f1c$var$HP,
        headBone: $d7238066c5de7f1c$var$XP
    }
}, $d7238066c5de7f1c$var$Qhe = {
    lipSyncTargets: $d7238066c5de7f1c$var$The,
    blinkTargets: $d7238066c5de7f1c$var$Cde,
    gazeData: {
        bones: $d7238066c5de7f1c$var$Hhe,
        morphTargets: $d7238066c5de7f1c$var$Whe
    },
    FACS: $d7238066c5de7f1c$var$khe,
    headPoseData: {
        bones: $d7238066c5de7f1c$var$Jhe,
        headBone: $d7238066c5de7f1c$var$Dhe
    }
}, $d7238066c5de7f1c$var$Ohe = {
    lipSyncTargets: $d7238066c5de7f1c$var$Mhe,
    blinkTargets: $d7238066c5de7f1c$var$pde,
    gazeData: {
        bones: $d7238066c5de7f1c$var$Xhe,
        morphTargets: $d7238066c5de7f1c$var$QY
    },
    FACS: $d7238066c5de7f1c$var$Ehe,
    headPoseData: {
        bones: $d7238066c5de7f1c$var$Uhe,
        headBone: $d7238066c5de7f1c$var$_he
    }
}, $d7238066c5de7f1c$var$jhe = {
    lipSyncTargets: $d7238066c5de7f1c$var$zhe,
    blinkTargets: $d7238066c5de7f1c$var$eP,
    gazeData: {
        bones: $d7238066c5de7f1c$var$wP,
        morphTargets: $d7238066c5de7f1c$var$QY
    },
    FACS: $d7238066c5de7f1c$var$WP,
    headPoseData: {
        bones: $d7238066c5de7f1c$var$HP,
        headBone: $d7238066c5de7f1c$var$XP
    }
}, $d7238066c5de7f1c$var$$u = {
    content: "  ----    Retorik Licence missing or not available    ----  ",
    width: 300,
    height: 169,
    rotation: 29.5,
    fontStyle: "normal",
    fontWeight: "normal",
    fontColor: "rgba(0,0,0,0.2)",
    fontSize: 14,
    fontFamily: "sans-serif"
};
class $d7238066c5de7f1c$var$qhe {
    constructor(e, t){
        $d7238066c5de7f1c$var$P(this, "htmlDivElement", null);
        const i = document.createElement("canvas"), n = i.getContext("2d");
        if (n) {
            const s = window.devicePixelRatio || 1, a = $d7238066c5de7f1c$var$$u.height * s, o = Number($d7238066c5de7f1c$var$$u.fontSize) * s, g = `${$d7238066c5de7f1c$var$$u.width * s}px`, l = `${a}px`;
            i.setAttribute("width", g), i.setAttribute("height", l), n.rotate(Math.PI / 180 * $d7238066c5de7f1c$var$$u.rotation), n.font = `${$d7238066c5de7f1c$var$$u.fontStyle} normal ${$d7238066c5de7f1c$var$$u.fontWeight} ${o}px/${a}px ${$d7238066c5de7f1c$var$$u.fontFamily}`, n.fillStyle = $d7238066c5de7f1c$var$$u.fontColor, n.fillText($d7238066c5de7f1c$var$$u.content, 0, 0);
            const c = document.createElement("div");
            c.style.position = "absolute", c.style.top = "0px", c.style.width = `${e}px`, c.style.height = `${t}px`, c.style.zIndex = "9999", c.style.pointerEvents = "none", c.style.backgroundImage = `url(${i.toDataURL()})`, c.style.backgroundRepeat = "repeat", this.htmlDivElement = c;
        }
    }
}
class $d7238066c5de7f1c$var$os extends $1W96c.Object3D {
    constructor(e){
        var t, i;
        if (super(), $d7238066c5de7f1c$var$P(this, "_globalManager"), $d7238066c5de7f1c$var$P(this, "_controller"), $d7238066c5de7f1c$var$P(this, "onAnimationsLoaded"), this._controller = e.controller || null, this._globalManager = new $d7238066c5de7f1c$var$Lhe({
            ...e
        }), this.onAnimationsLoaded = e.onAnimationsLoaded || null, this.add(e.mesh), this.init(e.animationsUrl || $d7238066c5de7f1c$var$$b, e.debug), e.license) console.log("Retorik Bodyengine-Three > license found");
        else {
            console.log("Retorik Bodyengine-Three > no license provided");
            let n = Array.from(document.getElementsByTagName("canvas")).find((s)=>s.getAttribute("data-engine") !== null);
            if (!n) {
                const s = (t = Array.from(document.querySelectorAll("*")).find((a)=>a.shadowRoot)) == null ? void 0 : t.shadowRoot;
                s && (n = Array.from(s.querySelectorAll("canvas")).find((a)=>a.getAttribute("data-engine") !== null));
            }
            if (n) {
                const s = new $d7238066c5de7f1c$var$qhe(n.width, n.height);
                s.htmlDivElement && ((i = n.parentElement) == null || i.appendChild(s.htmlDivElement));
            }
        }
    }
    get globalManager() {
        return this._globalManager;
    }
    get lipSyncManager() {
        return this._globalManager.lipSyncManager;
    }
    get animationManager() {
        return this._globalManager.animationManager;
    }
    get eyeBlinkManager() {
        return this._globalManager.eyeBlinkManager;
    }
    get gazeManager() {
        return this._globalManager.gazeManager;
    }
    get FACSManager() {
        return this._globalManager.FACSManager;
    }
    get headPoseManager() {
        return this._globalManager.headPoseManager;
    }
    get bmlManager() {
        return this._globalManager.bmlManager;
    }
    static logDebug(e) {
        console.log(`* @davi-ai/bodyengine-three debug : ${e.text} `, e.value);
    }
    async init(e, t) {
        var i, n;
        typeof e == "string" && (e = [
            e
        ]), t && $d7238066c5de7f1c$var$os.logDebug({
            text: "animations url",
            value: e
        });
        const s = [];
        for (const a of e){
            const o = await fetch(`${a}list.json`).then((g)=>g.json());
            t && $d7238066c5de7f1c$var$os.logDebug({
                text: "animation list fetched",
                value: o
            }), o.forEach((g)=>{
                s.push({
                    url: `${a}${g[0]}`,
                    from: $d7238066c5de7f1c$var$Pc[g[1]],
                    frequency: g.length > 2 ? g[2] : void 0
                });
            });
        }
        t && $d7238066c5de7f1c$var$os.logDebug({
            text: "array of animations to load",
            value: s
        }), s.length ? await this.addAnimationsFromUrls(s, $d7238066c5de7f1c$var$Pc.none) : (i = this.onAnimationsLoaded) == null || i.call(this), this._controller && ((n = this._globalManager.animationManager.controllableManager) == null || n.init(this._controller));
    }
    update(e) {
        this._globalManager.update(e);
    }
    static async loadArmatures() {
        return {
            armature: await $d7238066c5de7f1c$var$Kn.gltfLoader.loadAsync("https://cdn.retorik.ai/bodyengine-three/armatures/armaturetest.glb")
        };
    }
    static async fromCharacterCreator(e) {
        const t = e.animationsUrl || $d7238066c5de7f1c$var$$b;
        return e.mesh.getObjectByName("CC_Base_L_Clavicle").rotation.z += 0.025, e.mesh.getObjectByName("CC_Base_R_Clavicle").rotation.z -= 0.025, e.mesh.getObjectByName("CC_Base_L_Thumb1").rotation.z -= Math.PI / 8, e.mesh.getObjectByName("CC_Base_L_Thumb1").rotation.x -= Math.PI / 12, e.mesh.getObjectByName("CC_Base_R_Thumb1").rotation.z += Math.PI / 8, e.mesh.getObjectByName("CC_Base_R_Thumb1").rotation.x -= Math.PI / 12, new Promise(async function(i) {
            const { armature: n } = await $d7238066c5de7f1c$var$os.loadArmatures();
            e.debug && $d7238066c5de7f1c$var$os.logDebug({
                text: "armature loaded",
                value: n
            });
            try {
                const s = new $d7238066c5de7f1c$var$os({
                    ...e,
                    sourceMesh: new $d7238066c5de7f1c$var$Jc(n.scene.children[0]),
                    targetMesh: new $d7238066c5de7f1c$var$Jc(e.mesh),
                    animationsUrl: t,
                    ...$d7238066c5de7f1c$var$Qhe,
                    type: $d7238066c5de7f1c$export$4a5f7b09ca822d8c.cc3
                });
                e.debug && $d7238066c5de7f1c$var$os.logDebug({
                    text: "resolve character",
                    value: s
                }), i(s);
            } catch (s) {
                console.warn(s), i(null);
            }
        });
    }
    // Export model with parameters ?morphTargets=ARKit,Oculus Visemes&pose=T
    static async fromReadyPlayerMe(e) {
        const t = e.animationsUrl || $d7238066c5de7f1c$var$$b;
        return e.mesh.getObjectByName("LeftShoulder").position.y -= 0.015, e.mesh.getObjectByName("RightShoulder").position.y -= 0.015, new Promise(async function(i) {
            const { armature: n } = await $d7238066c5de7f1c$var$os.loadArmatures();
            e.debug && $d7238066c5de7f1c$var$os.logDebug({
                text: "armature loaded",
                value: n
            });
            try {
                const s = new $d7238066c5de7f1c$var$os({
                    ...e,
                    mesh: e.mesh,
                    sourceMesh: new $d7238066c5de7f1c$var$Jc(n.scene.children[0]),
                    targetMesh: new $d7238066c5de7f1c$var$Jc(e.mesh),
                    animationsUrl: t,
                    ...$d7238066c5de7f1c$var$Ohe,
                    type: $d7238066c5de7f1c$export$4a5f7b09ca822d8c.rpm
                });
                e.debug && $d7238066c5de7f1c$var$os.logDebug({
                    text: "resolve character",
                    value: s
                }), i(s);
            } catch (s) {
                console.warn(s), i(null);
            }
        });
    }
    static async fromAvatarSDK(e) {
        const t = e.animationsUrl || $d7238066c5de7f1c$var$$b;
        return e.mesh.getObjectByName("LeftShoulder").position.y -= 0.015, e.mesh.getObjectByName("RightShoulder").position.y -= 0.015, e.mesh.getObjectByName("LeftArm").rotation.x -= 0.05, e.mesh.getObjectByName("RightArm").rotation.x -= 0.05, e.mesh.getObjectByName("LeftHandThumb1").rotation.y += 0.5, e.mesh.getObjectByName("LeftHandThumb1").rotation.z -= 0.25, e.mesh.getObjectByName("RightHandThumb1").rotation.y -= 0.5, e.mesh.getObjectByName("RightHandThumb1").rotation.z += 0.25, e.mesh.getObjectByName("LeftFoot").rotation.x -= 0.05, e.mesh.getObjectByName("RightFoot").rotation.x -= 0.05, e.gender === "male" && (e.mesh.getObjectByName("LeftFoot").rotation.z -= 0.35, e.mesh.getObjectByName("RightFoot").rotation.z += 0.35), new Promise(async function(i) {
            const { armature: n } = await $d7238066c5de7f1c$var$os.loadArmatures();
            e.debug && $d7238066c5de7f1c$var$os.logDebug({
                text: "armature loaded",
                value: n
            });
            try {
                const s = new $d7238066c5de7f1c$var$os({
                    ...e,
                    sourceMesh: new $d7238066c5de7f1c$var$Jc(n.scene),
                    targetMesh: new $d7238066c5de7f1c$var$Jc(e.mesh),
                    animationsUrl: t,
                    ...$d7238066c5de7f1c$var$Phe,
                    type: $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avatarsdk
                });
                e.debug && $d7238066c5de7f1c$var$os.logDebug({
                    text: "resolve character",
                    value: s
                }), i(s);
            } catch (s) {
                console.warn(s), i(null);
            }
        });
    }
    static async fromAvaturn(e) {
        const t = e.animationsUrl || $d7238066c5de7f1c$var$$b;
        return e.mesh.getObjectByName("LeftShoulder").position.y -= 0.015, e.mesh.getObjectByName("RightShoulder").position.y -= 0.015, new Promise(async function(i) {
            const { armature: n } = await $d7238066c5de7f1c$var$os.loadArmatures();
            e.debug && $d7238066c5de7f1c$var$os.logDebug({
                text: "armature loaded",
                value: n
            });
            const s = new $d7238066c5de7f1c$var$os({
                ...e,
                sourceMesh: new $d7238066c5de7f1c$var$Jc(n.scene),
                targetMesh: new $d7238066c5de7f1c$var$Jc(e.mesh),
                animationsUrl: t,
                ...$d7238066c5de7f1c$var$jhe,
                type: $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avaturn
            });
            e.debug && $d7238066c5de7f1c$var$os.logDebug({
                text: "resolve character",
                value: s
            }), i(s);
        });
    }
    //////////////////////////// ANIMATION UTILS /////////////////////////////////////
    /**
   * Add one animation to the animationManager
   * @param {AnimationData} data
   */ async addAnimationFromUrl(e) {
        var t;
        try {
            const i = ((t = e.url.split("/").pop()) == null ? void 0 : t.split(".")) || "";
            if (i.length !== 2) throw new Error(`invalid animation url : ${e.url}`);
            let n = new $1W96c.Group();
            const s = {
                url: e.url,
                name: i[0],
                returnClip: !1,
                frequency: e.frequency
            };
            switch(e.from){
                case $d7238066c5de7f1c$var$Pc.mixamo:
                    await this._globalManager.animationManager.addMixamoAnimation(s);
                    break;
                case $d7238066c5de7f1c$var$Pc.actorcore:
                case $d7238066c5de7f1c$var$Pc.cc4:
                    await this._globalManager.animationManager.addCC4Animation(s);
                    break;
                case $d7238066c5de7f1c$var$Pc.none:
                default:
                    switch(i[1]){
                        case "fbx":
                            n = await $d7238066c5de7f1c$var$Kn.fbxLoader.loadAsync(e.url);
                            break;
                        case "glb":
                            {
                                const a = await $d7238066c5de7f1c$var$Kn.gltfLoader.loadAsync(e.url);
                                a.scene.animations = a.animations, n = a.scene;
                                break;
                            }
                    }
                    return n;
            }
        } catch (i) {
            console.error(i);
        }
        return null;
    }
    static async overrideArmatureAvatarSDK(e, t, i) {
        var n, s, a;
        const o = (await $d7238066c5de7f1c$var$Kn.gltfLoader.loadAsync(e)).scene, g = [], l = t.getObjectByName("AvatarBody").skeleton.bones.map((G)=>G.name);
        for (const G of l)o.getObjectByName(G) && g.push(o.getObjectByName(G));
        t.updateMatrixWorld();
        let c = new $1W96c.Box3().setFromObject(t), d = new $1W96c.Vector3();
        c.getSize(d);
        const p = new $1W96c.Skeleton(g), A = t.getObjectByName("Hips");
        A && ((n = t.getObjectByName("AvatarRoot")) == null || n.remove(A));
        const y = (s = o.getObjectByName("AvatarRoot")) == null ? void 0 : s.children[0];
        y && ((a = t.getObjectByName("AvatarRoot")) == null || a.attach(y)), t.traverse((G)=>{
            G.type === "SkinnedMesh" && (G.skeleton = p, G.bind(p));
        }), c = new $1W96c.Box3().setFromObject(t), d = new $1W96c.Vector3(), c.getSize(d);
    }
    static setTPose(e, t, i) {
        const n = [];
        e.traverse((s)=>{
            if (s.isSkinnedMesh) {
                const a = s.skeleton.bones;
                for(const o in t){
                    const g = a.find((l)=>l.name === o);
                    !g || n.includes(g.uuid) || (n.push(g.uuid), g.rotation.x += t[o].x, g.rotation.y += t[o].y, g.rotation.z += t[o].z);
                }
            }
        });
    }
    /**
   * Add several animations to the animationManager
   * @param {Array<AnimationData>} data
   */ async addAnimationsFromUrls(e, t) {
        var i, n, s, a;
        const o = e.filter((l)=>l.url.includes("idle")).splice(0, 2), g = e.filter((l)=>l.url.includes("explain")).splice(0, 2);
        e = e.filter((l)=>!o.includes(l) && !g.includes(l));
        for (const l of o)await new Promise((c, d)=>{
            this.addAnimationFromUrl(l).then(()=>c()).catch((p)=>d(p));
        });
        for (const l of g)await new Promise((c, d)=>{
            this.addAnimationFromUrl(l).then(()=>c()).catch((p)=>d(p));
        });
        (i = this._globalManager) != null && i.bmlManager && await ((s = (n = this._globalManager) == null ? void 0 : n.bmlManager) == null ? void 0 : s.loadAnimations(this.addAnimationFromUrl)), (a = this.onAnimationsLoaded) == null || a.call(this);
        for (const l of e)await new Promise((c, d)=>{
            this.addAnimationFromUrl(l).then(()=>c()).catch((p)=>d(p));
        });
    }
    playDefaultIdleAnimation() {
        const e = this.getAllAnimationNames().find((t)=>t.includes("idle"));
        e && this._globalManager.animationManager.playAnimation(e);
    }
    showAllAnimations() {
        const e = this.getAllAnimationNames();
        this.testAnimations(e, 0);
    }
    testAnimations(e, t) {
        this._globalManager.animationManager.playAnimation(e[t]), setTimeout(()=>{
            this.testAnimations(e, t === e.length - 1 ? 0 : t + 1);
        }, 3e3);
    }
    stopAnimation() {
        this._globalManager.animationManager.stopAnimations();
    }
    playAnimation(e) {
        this._globalManager.animationManager.playAnimation(e);
    }
    getAllAnimationNames() {
        return this._globalManager.animationManager.getAllAnimationNames();
    }
    getAllAnimations() {
        return this._globalManager.animationManager.getAllAnimations();
    }
}
function $d7238066c5de7f1c$var$fB() {
    return $d7238066c5de7f1c$var$fB = Object.assign ? Object.assign.bind() : function(r) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var i in t)({}).hasOwnProperty.call(t, i) && (r[i] = t[i]);
        }
        return r;
    }, $d7238066c5de7f1c$var$fB.apply(null, arguments);
}
var $d7238066c5de7f1c$var$tS = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $d7238066c5de7f1c$var$NP(r) {
    return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function $d7238066c5de7f1c$var$$he(r) {
    if (r.__esModule) return r;
    var e = r.default;
    if (typeof e == "function") {
        var t = function i() {
            return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t.prototype = e.prototype;
    } else t = {};
    return Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.keys(r).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(r, i);
        Object.defineProperty(t, i, n.get ? n : {
            enumerable: !0,
            get: function() {
                return r[i];
            }
        });
    }), t;
}
var $d7238066c5de7f1c$var$tN = {
    exports: {}
}, $d7238066c5de7f1c$var$Kd = {};
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7238066c5de7f1c$var$fT;
function $d7238066c5de7f1c$var$eCe() {
    return $d7238066c5de7f1c$var$fT || ($d7238066c5de7f1c$var$fT = 1, $d7238066c5de7f1c$var$Kd.ConcurrentRoot = 1, $d7238066c5de7f1c$var$Kd.ContinuousEventPriority = 4, $d7238066c5de7f1c$var$Kd.DefaultEventPriority = 16, $d7238066c5de7f1c$var$Kd.DiscreteEventPriority = 1, $d7238066c5de7f1c$var$Kd.IdleEventPriority = 536870912, $d7238066c5de7f1c$var$Kd.LegacyRoot = 0), $d7238066c5de7f1c$var$Kd;
}
var $d7238066c5de7f1c$var$xd = {};
/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7238066c5de7f1c$var$GT;
function $d7238066c5de7f1c$var$tCe() {
    return $d7238066c5de7f1c$var$GT || ($d7238066c5de7f1c$var$GT = 1), $d7238066c5de7f1c$var$xd;
}
$d7238066c5de7f1c$var$tN.exports = $d7238066c5de7f1c$var$eCe();
var $d7238066c5de7f1c$var$pA = $d7238066c5de7f1c$var$tN.exports;
function $d7238066c5de7f1c$var$iCe(r) {
    let e;
    const t = /* @__PURE__ */ new Set(), i = (l, c)=>{
        const d = typeof l == "function" ? l(e) : l;
        if (d !== e) {
            const p = e;
            e = c ? d : Object.assign({}, e, d), t.forEach((A)=>A(e, p));
        }
    }, n = ()=>e, s = (l, c = n, d = Object.is)=>{
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        let p = c(e);
        function A() {
            const y = c(e);
            if (!d(p, y)) {
                const G = p;
                l(p = y, G);
            }
        }
        return t.add(A), ()=>t.delete(A);
    }, g = {
        setState: i,
        getState: n,
        subscribe: (l, c, d)=>c || d ? s(l, c, d) : (t.add(l), ()=>t.delete(l)),
        destroy: ()=>t.clear()
    };
    return e = r(i, n, g), g;
}
const $d7238066c5de7f1c$var$nCe = typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), $d7238066c5de7f1c$var$vT = $d7238066c5de7f1c$var$nCe ? (0, $bxRTa.useEffect) : (0, $bxRTa.useLayoutEffect);
function $d7238066c5de7f1c$var$LP(r) {
    const e = typeof r == "function" ? $d7238066c5de7f1c$var$iCe(r) : r, t = (i = e.getState, n = Object.is)=>{
        const [, s] = (0, $bxRTa.useReducer)((Z)=>Z + 1, 0), a = e.getState(), o = (0, $bxRTa.useRef)(a), g = (0, $bxRTa.useRef)(i), l = (0, $bxRTa.useRef)(n), c = (0, $bxRTa.useRef)(!1), d = (0, $bxRTa.useRef)();
        d.current === void 0 && (d.current = i(a));
        let p, A = !1;
        (o.current !== a || g.current !== i || l.current !== n || c.current) && (p = i(a), A = !n(d.current, p)), $d7238066c5de7f1c$var$vT(()=>{
            A && (d.current = p), o.current = a, g.current = i, l.current = n, c.current = !1;
        });
        const y = (0, $bxRTa.useRef)(a);
        $d7238066c5de7f1c$var$vT(()=>{
            const Z = ()=>{
                try {
                    const V = e.getState(), H = g.current(V);
                    l.current(d.current, H) || (o.current = V, d.current = H, s());
                } catch  {
                    c.current = !0, s();
                }
            }, v = e.subscribe(Z);
            return e.getState() !== y.current && Z(), v;
        }, []);
        const G = A ? p : d.current;
        return (0, $bxRTa.useDebugValue)(G), G;
    };
    return Object.assign(t, e), t[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        const i = [
            t,
            e
        ];
        return {
            next () {
                const n = i.length <= 0;
                return {
                    value: i.shift(),
                    done: n
                };
            }
        };
    }, t;
}
const $d7238066c5de7f1c$var$sCe = (r)=>typeof r == "object" && typeof r.then == "function", $d7238066c5de7f1c$var$NC = [];
function $d7238066c5de7f1c$var$YP(r, e, t = (i, n)=>i === n) {
    if (r === e) return !0;
    if (!r || !e) return !1;
    const i = r.length;
    if (e.length !== i) return !1;
    for(let n = 0; n < i; n++)if (!t(r[n], e[n])) return !1;
    return !0;
}
function $d7238066c5de7f1c$var$KP(r, e = null, t = !1, i = {}) {
    e === null && (e = [
        r
    ]);
    for (const s of $d7238066c5de7f1c$var$NC)if ($d7238066c5de7f1c$var$YP(e, s.keys, s.equal)) {
        if (t) return;
        if (Object.prototype.hasOwnProperty.call(s, "error")) throw s.error;
        if (Object.prototype.hasOwnProperty.call(s, "response")) return i.lifespan && i.lifespan > 0 && (s.timeout && clearTimeout(s.timeout), s.timeout = setTimeout(s.remove, i.lifespan)), s.response;
        if (!t) throw s.promise;
    }
    const n = {
        keys: e,
        equal: i.equal,
        remove: ()=>{
            const s = $d7238066c5de7f1c$var$NC.indexOf(n);
            s !== -1 && $d7238066c5de7f1c$var$NC.splice(s, 1);
        },
        promise: // Execute the promise
        ($d7238066c5de7f1c$var$sCe(r) ? r : r(...e)).then((s)=>{
            n.response = s, i.lifespan && i.lifespan > 0 && (n.timeout = setTimeout(n.remove, i.lifespan));
        }).catch((s)=>n.error = s)
    };
    if ($d7238066c5de7f1c$var$NC.push(n), !t) throw n.promise;
}
const $d7238066c5de7f1c$var$xP = (r, e, t)=>$d7238066c5de7f1c$var$KP(r, e, !1, t), $d7238066c5de7f1c$var$rCe = (r, e, t)=>void $d7238066c5de7f1c$var$KP(r, e, !0, t), $d7238066c5de7f1c$var$aCe = (r)=>{
    if (r === void 0 || r.length === 0) $d7238066c5de7f1c$var$NC.splice(0, $d7238066c5de7f1c$var$NC.length);
    else {
        const e = $d7238066c5de7f1c$var$NC.find((t)=>$d7238066c5de7f1c$var$YP(r, t.keys, t.equal));
        e && e.remove();
    }
};
var $d7238066c5de7f1c$var$iN = {
    exports: {}
}, $d7238066c5de7f1c$var$nN = {
    exports: {}
}, $d7238066c5de7f1c$var$_H = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7238066c5de7f1c$var$ST;
function $d7238066c5de7f1c$var$oCe() {
    return $d7238066c5de7f1c$var$ST || ($d7238066c5de7f1c$var$ST = 1, function(r) {
        function e(q, de) {
            var ge = q.length;
            q.push(de);
            e: for(; 0 < ge;){
                var Ye = ge - 1 >>> 1, Fe = q[Ye];
                if (0 < n(Fe, de)) q[Ye] = de, q[ge] = Fe, ge = Ye;
                else break e;
            }
        }
        function t(q) {
            return q.length === 0 ? null : q[0];
        }
        function i(q) {
            if (q.length === 0) return null;
            var de = q[0], ge = q.pop();
            if (ge !== de) {
                q[0] = ge;
                e: for(var Ye = 0, Fe = q.length, Xe = Fe >>> 1; Ye < Xe;){
                    var Te = 2 * (Ye + 1) - 1, ct = q[Te], st = Te + 1, Xt = q[st];
                    if (0 > n(ct, ge)) st < Fe && 0 > n(Xt, ct) ? (q[Ye] = Xt, q[st] = ge, Ye = st) : (q[Ye] = ct, q[Te] = ge, Ye = Te);
                    else if (st < Fe && 0 > n(Xt, ge)) q[Ye] = Xt, q[st] = ge, Ye = st;
                    else break e;
                }
            }
            return de;
        }
        function n(q, de) {
            var ge = q.sortIndex - de.sortIndex;
            return ge !== 0 ? ge : q.id - de.id;
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
            var s = performance;
            r.unstable_now = function() {
                return s.now();
            };
        } else {
            var a = Date, o = a.now();
            r.unstable_now = function() {
                return a.now() - o;
            };
        }
        var g = [], l = [], c = 1, d = null, p = 3, A = !1, y = !1, G = !1, Z = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, V = typeof setImmediate < "u" ? setImmediate : null;
        typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        function H(q) {
            for(var de = t(l); de !== null;){
                if (de.callback === null) i(l);
                else if (de.startTime <= q) i(l), de.sortIndex = de.expirationTime, e(g, de);
                else break;
                de = t(l);
            }
        }
        function N(q) {
            if (G = !1, H(q), !y) {
                if (t(g) !== null) y = !0, te(Y);
                else {
                    var de = t(l);
                    de !== null && Ge(N, de.startTime - q);
                }
            }
        }
        function Y(q, de) {
            y = !1, G && (G = !1, v(M), M = -1), A = !0;
            var ge = p;
            try {
                for(H(de), d = t(g); d !== null && (!(d.expirationTime > de) || q && !ie());){
                    var Ye = d.callback;
                    if (typeof Ye == "function") {
                        d.callback = null, p = d.priorityLevel;
                        var Fe = Ye(d.expirationTime <= de);
                        de = r.unstable_now(), typeof Fe == "function" ? d.callback = Fe : d === t(g) && i(g), H(de);
                    } else i(g);
                    d = t(g);
                }
                if (d !== null) var Xe = !0;
                else {
                    var Te = t(l);
                    Te !== null && Ge(N, Te.startTime - de), Xe = !1;
                }
                return Xe;
            } finally{
                d = null, p = ge, A = !1;
            }
        }
        var K = !1, z = null, M = -1, _ = 5, O = -1;
        function ie() {
            return !(r.unstable_now() - O < _);
        }
        function he() {
            if (z !== null) {
                var q = r.unstable_now();
                O = q;
                var de = !0;
                try {
                    de = z(!0, q);
                } finally{
                    de ? pe() : (K = !1, z = null);
                }
            } else K = !1;
        }
        var pe;
        if (typeof V == "function") pe = function() {
            V(he);
        };
        else if (typeof MessageChannel < "u") {
            var ce = new MessageChannel(), $ = ce.port2;
            ce.port1.onmessage = he, pe = function() {
                $.postMessage(null);
            };
        } else pe = function() {
            Z(he, 0);
        };
        function te(q) {
            z = q, K || (K = !0, pe());
        }
        function Ge(q, de) {
            M = Z(function() {
                q(r.unstable_now());
            }, de);
        }
        r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(q) {
            q.callback = null;
        }, r.unstable_continueExecution = function() {
            y || A || (y = !0, te(Y));
        }, r.unstable_forceFrameRate = function(q) {
            0 > q || 125 < q ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : _ = 0 < q ? Math.floor(1e3 / q) : 5;
        }, r.unstable_getCurrentPriorityLevel = function() {
            return p;
        }, r.unstable_getFirstCallbackNode = function() {
            return t(g);
        }, r.unstable_next = function(q) {
            switch(p){
                case 1:
                case 2:
                case 3:
                    var de = 3;
                    break;
                default:
                    de = p;
            }
            var ge = p;
            p = de;
            try {
                return q();
            } finally{
                p = ge;
            }
        }, r.unstable_pauseExecution = function() {}, r.unstable_requestPaint = function() {}, r.unstable_runWithPriority = function(q, de) {
            switch(q){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    q = 3;
            }
            var ge = p;
            p = q;
            try {
                return de();
            } finally{
                p = ge;
            }
        }, r.unstable_scheduleCallback = function(q, de, ge) {
            var Ye = r.unstable_now();
            switch(typeof ge == "object" && ge !== null ? (ge = ge.delay, ge = typeof ge == "number" && 0 < ge ? Ye + ge : Ye) : ge = Ye, q){
                case 1:
                    var Fe = -1;
                    break;
                case 2:
                    Fe = 250;
                    break;
                case 5:
                    Fe = 1073741823;
                    break;
                case 4:
                    Fe = 1e4;
                    break;
                default:
                    Fe = 5e3;
            }
            return Fe = ge + Fe, q = {
                id: c++,
                callback: de,
                priorityLevel: q,
                startTime: ge,
                expirationTime: Fe,
                sortIndex: -1
            }, ge > Ye ? (q.sortIndex = ge, e(l, q), t(g) === null && q === t(l) && (G ? (v(M), M = -1) : G = !0, Ge(N, ge - Ye))) : (q.sortIndex = Fe, e(g, q), y || A || (y = !0, te(Y))), q;
        }, r.unstable_shouldYield = ie, r.unstable_wrapCallback = function(q) {
            var de = p;
            return function() {
                var ge = p;
                p = de;
                try {
                    return q.apply(this, arguments);
                } finally{
                    p = ge;
                }
            };
        };
    }($d7238066c5de7f1c$var$_H)), $d7238066c5de7f1c$var$_H;
}
var $d7238066c5de7f1c$var$PH = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7238066c5de7f1c$var$ZT;
function $d7238066c5de7f1c$var$gCe() {
    return $d7238066c5de7f1c$var$ZT || ($d7238066c5de7f1c$var$ZT = 1), $d7238066c5de7f1c$var$PH;
}
$d7238066c5de7f1c$var$nN.exports = $d7238066c5de7f1c$var$oCe();
var $d7238066c5de7f1c$var$zZ = $d7238066c5de7f1c$var$nN.exports;
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7238066c5de7f1c$var$QH, $d7238066c5de7f1c$var$RT;
function $d7238066c5de7f1c$var$lCe() {
    return $d7238066c5de7f1c$var$RT || ($d7238066c5de7f1c$var$RT = 1, $d7238066c5de7f1c$var$QH = function(e) {
        var t = {}, i = (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))), n = $d7238066c5de7f1c$var$zZ, s = Object.assign;
        function a(h) {
            for(var C = "https://reactjs.org/docs/error-decoder.html?invariant=" + h, B = 1; B < arguments.length; B++)C += "&args[]=" + encodeURIComponent(arguments[B]);
            return "Minified React error #" + h + "; visit " + C + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var o = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, g = Symbol.for("react.element"), l = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), p = Symbol.for("react.profiler"), A = Symbol.for("react.provider"), y = Symbol.for("react.context"), G = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), V = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), Y = Symbol.iterator;
        function K(h) {
            return h === null || typeof h != "object" ? null : (h = Y && h[Y] || h["@@iterator"], typeof h == "function" ? h : null);
        }
        function z(h) {
            if (h == null) return null;
            if (typeof h == "function") return h.displayName || h.name || null;
            if (typeof h == "string") return h;
            switch(h){
                case c:
                    return "Fragment";
                case l:
                    return "Portal";
                case p:
                    return "Profiler";
                case d:
                    return "StrictMode";
                case Z:
                    return "Suspense";
                case v:
                    return "SuspenseList";
            }
            if (typeof h == "object") switch(h.$$typeof){
                case y:
                    return (h.displayName || "Context") + ".Consumer";
                case A:
                    return (h._context.displayName || "Context") + ".Provider";
                case G:
                    var C = h.render;
                    return h = h.displayName, h || (h = C.displayName || C.name || "", h = h !== "" ? "ForwardRef(" + h + ")" : "ForwardRef"), h;
                case V:
                    return C = h.displayName || null, C !== null ? C : z(h.type) || "Memo";
                case H:
                    C = h._payload, h = h._init;
                    try {
                        return z(h(C));
                    } catch  {}
            }
            return null;
        }
        function M(h) {
            var C = h.type;
            switch(h.tag){
                case 24:
                    return "Cache";
                case 9:
                    return (C.displayName || "Context") + ".Consumer";
                case 10:
                    return (C._context.displayName || "Context") + ".Provider";
                case 18:
                    return "DehydratedFragment";
                case 11:
                    return h = C.render, h = h.displayName || h.name || "", C.displayName || (h !== "" ? "ForwardRef(" + h + ")" : "ForwardRef");
                case 7:
                    return "Fragment";
                case 5:
                    return C;
                case 4:
                    return "Portal";
                case 3:
                    return "Root";
                case 6:
                    return "Text";
                case 16:
                    return z(C);
                case 8:
                    return C === d ? "StrictMode" : "Mode";
                case 22:
                    return "Offscreen";
                case 12:
                    return "Profiler";
                case 21:
                    return "Scope";
                case 13:
                    return "Suspense";
                case 19:
                    return "SuspenseList";
                case 25:
                    return "TracingMarker";
                case 1:
                case 0:
                case 17:
                case 2:
                case 14:
                case 15:
                    if (typeof C == "function") return C.displayName || C.name || null;
                    if (typeof C == "string") return C;
            }
            return null;
        }
        function _(h) {
            var C = h, B = h;
            if (h.alternate) for(; C.return;)C = C.return;
            else {
                h = C;
                do C = h, C.flags & 4098 && (B = C.return), h = C.return;
                while (h);
            }
            return C.tag === 3 ? B : null;
        }
        function O(h) {
            if (_(h) !== h) throw Error(a(188));
        }
        function ie(h) {
            var C = h.alternate;
            if (!C) {
                if (C = _(h), C === null) throw Error(a(188));
                return C !== h ? null : h;
            }
            for(var B = h, S = C;;){
                var w = B.return;
                if (w === null) break;
                var L = w.alternate;
                if (L === null) {
                    if (S = w.return, S !== null) {
                        B = S;
                        continue;
                    }
                    break;
                }
                if (w.child === L.child) {
                    for(L = w.child; L;){
                        if (L === B) return O(w), h;
                        if (L === S) return O(w), C;
                        L = L.sibling;
                    }
                    throw Error(a(188));
                }
                if (B.return !== S.return) B = w, S = L;
                else {
                    for(var Q = !1, le = w.child; le;){
                        if (le === B) {
                            Q = !0, B = w, S = L;
                            break;
                        }
                        if (le === S) {
                            Q = !0, S = w, B = L;
                            break;
                        }
                        le = le.sibling;
                    }
                    if (!Q) {
                        for(le = L.child; le;){
                            if (le === B) {
                                Q = !0, B = L, S = w;
                                break;
                            }
                            if (le === S) {
                                Q = !0, S = L, B = w;
                                break;
                            }
                            le = le.sibling;
                        }
                        if (!Q) throw Error(a(189));
                    }
                }
                if (B.alternate !== S) throw Error(a(190));
            }
            if (B.tag !== 3) throw Error(a(188));
            return B.stateNode.current === B ? h : C;
        }
        function he(h) {
            return h = ie(h), h !== null ? pe(h) : null;
        }
        function pe(h) {
            if (h.tag === 5 || h.tag === 6) return h;
            for(h = h.child; h !== null;){
                var C = pe(h);
                if (C !== null) return C;
                h = h.sibling;
            }
            return null;
        }
        function ce(h) {
            if (h.tag === 5 || h.tag === 6) return h;
            for(h = h.child; h !== null;){
                if (h.tag !== 4) {
                    var C = ce(h);
                    if (C !== null) return C;
                }
                h = h.sibling;
            }
            return null;
        }
        var $ = Array.isArray, te = e.getPublicInstance, Ge = e.getRootHostContext, q = e.getChildHostContext, de = e.prepareForCommit, ge = e.resetAfterCommit, Ye = e.createInstance, Fe = e.appendInitialChild, Xe = e.finalizeInitialChildren, Te = e.prepareUpdate, ct = e.shouldSetTextContent, st = e.createTextInstance, Xt = e.scheduleTimeout, Mi = e.cancelTimeout, Jn = e.noTimeout, Un = e.isPrimaryRenderer, mn = e.supportsMutation, Qs = e.supportsPersistence, Di = e.supportsHydration, kr = e.getInstanceFromNode, oo = e.preparePortalMount, za = e.getCurrentEventPriority, Dn = e.detachDeletedInstance, Er = e.supportsMicrotasks, Cg = e.scheduleMicrotask, ka = e.supportsTestSelectors, cs = e.findFiberRoot, ul = e.getBoundingRect, Bu = e.getTextContent, pg = e.isHiddenSubtree, Il = e.matchAccessibilityRole, fu = e.setFocusIfFocusable, FI = e.setupIntersectionObserver, Gu = e.appendChild, gc = e.appendChildToContainer, lt = e.commitTextUpdate, Mt = e.commitMount, di = e.commitUpdate, Nt = e.insertBefore, Li = e.insertInContainerBefore, dr = e.removeChild, Bt = e.removeChildFromContainer, gt = e.resetTextContent, yi = e.hideInstance, _i = e.hideTextInstance, Je = e.unhideInstance, vu = e.unhideTextInstance, mg = e.clearContainer, Su = e.cloneInstance, ph = e.createContainerChildSet, Wi = e.appendChildToContainerChildSet, Ko = e.finalizeContainerChildren, dl = e.replaceContainerChildren, hl = e.cloneHiddenInstance, xo = e.cloneHiddenTextInstance, Aa = e.canHydrateInstance, h0 = e.canHydrateTextInstance, lc = e.canHydrateSuspenseInstance, Cl = e.isSuspenseInstancePending, mh = e.isSuspenseInstanceFallback, Ag = e.registerSuspenseInstanceRetry, xn = e.getNextHydratableSibling, hi = e.getFirstHydratableChild, Ah = e.getFirstHydratableChildWithinContainer, bh = e.getFirstHydratableChildWithinSuspenseInstance, x = e.hydrateInstance, D = e.hydrateTextInstance, re = e.hydrateSuspenseInstance, Be = e.getNextHydratableInstanceAfterSuspenseInstance, Ve = e.commitHydratedContainer, Re = e.commitHydratedSuspenseInstance, _e = e.clearSuspenseBoundary, Me = e.clearSuspenseBoundaryFromContainer, Qe = e.shouldDeleteUnhydratedTailInstances, tt = e.didNotMatchHydratedContainerTextInstance, et = e.didNotMatchHydratedTextInstance, $e;
        function ln(h) {
            if ($e === void 0) try {
                throw Error();
            } catch (B) {
                var C = B.stack.trim().match(/\n( *(at )?)/);
                $e = C && C[1] || "";
            }
            return `
` + $e + h;
        }
        var St = !1;
        function wt(h, C) {
            if (!h || St) return "";
            St = !0;
            var B = Error.prepareStackTrace;
            Error.prepareStackTrace = void 0;
            try {
                if (C) {
                    if (C = function() {
                        throw Error();
                    }, Object.defineProperty(C.prototype, "props", {
                        set: function() {
                            throw Error();
                        }
                    }), typeof Reflect == "object" && Reflect.construct) {
                        try {
                            Reflect.construct(C, []);
                        } catch (Oe) {
                            var S = Oe;
                        }
                        Reflect.construct(h, [], C);
                    } else {
                        try {
                            C.call();
                        } catch (Oe) {
                            S = Oe;
                        }
                        h.call(C.prototype);
                    }
                } else {
                    try {
                        throw Error();
                    } catch (Oe) {
                        S = Oe;
                    }
                    h();
                }
            } catch (Oe) {
                if (Oe && S && typeof Oe.stack == "string") {
                    for(var w = Oe.stack.split(`
`), L = S.stack.split(`
`), Q = w.length - 1, le = L.length - 1; 1 <= Q && 0 <= le && w[Q] !== L[le];)le--;
                    for(; 1 <= Q && 0 <= le; Q--, le--)if (w[Q] !== L[le]) {
                        if (Q !== 1 || le !== 1) do if (Q--, le--, 0 > le || w[Q] !== L[le]) {
                            var We = `
` + w[Q].replace(" at new ", " at ");
                            return h.displayName && We.includes("<anonymous>") && (We = We.replace("<anonymous>", h.displayName)), We;
                        }
                        while (1 <= Q && 0 <= le);
                        break;
                    }
                }
            } finally{
                St = !1, Error.prepareStackTrace = B;
            }
            return (h = h ? h.displayName || h.name : "") ? ln(h) : "";
        }
        var _t = Object.prototype.hasOwnProperty, ei = [], zi = -1;
        function Hi(h) {
            return {
                current: h
            };
        }
        function Ot(h) {
            0 > zi || (h.current = ei[zi], ei[zi] = null, zi--);
        }
        function Kt(h, C) {
            zi++, ei[zi] = h.current, h.current = C;
        }
        var Si = {}, Bn = Hi(Si), oi = Hi(!1), Vn = Si;
        function wr(h, C) {
            var B = h.type.contextTypes;
            if (!B) return Si;
            var S = h.stateNode;
            if (S && S.__reactInternalMemoizedUnmaskedChildContext === C) return S.__reactInternalMemoizedMaskedChildContext;
            var w = {}, L;
            for(L in B)w[L] = C[L];
            return S && (h = h.stateNode, h.__reactInternalMemoizedUnmaskedChildContext = C, h.__reactInternalMemoizedMaskedChildContext = w), w;
        }
        function fs(h) {
            return h = h.childContextTypes, h != null;
        }
        function xs() {
            Ot(oi), Ot(Bn);
        }
        function $i(h, C, B) {
            if (Bn.current !== Si) throw Error(a(168));
            Kt(Bn, C), Kt(oi, B);
        }
        function Gs(h, C, B) {
            var S = h.stateNode;
            if (C = C.childContextTypes, typeof S.getChildContext != "function") return B;
            S = S.getChildContext();
            for(var w in S)if (!(w in C)) throw Error(a(108, M(h) || "Unknown", w));
            return s({}, B, S);
        }
        function en(h) {
            return h = (h = h.stateNode) && h.__reactInternalMemoizedMergedChildContext || Si, Vn = Bn.current, Kt(Bn, h), Kt(oi, oi.current), !0;
        }
        function Pi(h, C, B) {
            var S = h.stateNode;
            if (!S) throw Error(a(169));
            B ? (h = Gs(h, C, Vn), S.__reactInternalMemoizedMergedChildContext = h, Ot(oi), Ot(Bn), Kt(Bn, h)) : Ot(oi), Kt(oi, B);
        }
        var Hn = Math.clz32 ? Math.clz32 : Ea, pl = Math.log, hr = Math.LN2;
        function Ea(h) {
            return h >>>= 0, h === 0 ? 32 : 31 - (pl(h) / hr | 0) | 0;
        }
        var sp = 64, ba = 4194304;
        function cc(h) {
            switch(h & -h){
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 4:
                    return 4;
                case 8:
                    return 8;
                case 16:
                    return 16;
                case 32:
                    return 32;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                    return h & 4194240;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    return h & 130023424;
                case 134217728:
                    return 134217728;
                case 268435456:
                    return 268435456;
                case 536870912:
                    return 536870912;
                case 1073741824:
                    return 1073741824;
                default:
                    return h;
            }
        }
        function Wr(h, C) {
            var B = h.pendingLanes;
            if (B === 0) return 0;
            var S = 0, w = h.suspendedLanes, L = h.pingedLanes, Q = B & 268435455;
            if (Q !== 0) {
                var le = Q & ~w;
                le !== 0 ? S = cc(le) : (L &= Q, L !== 0 && (S = cc(L)));
            } else Q = B & ~w, Q !== 0 ? S = cc(Q) : L !== 0 && (S = cc(L));
            if (S === 0) return 0;
            if (C !== 0 && C !== S && !(C & w) && (w = S & -S, L = C & -C, w >= L || w === 16 && (L & 4194240) !== 0)) return C;
            if (S & 4 && (S |= B & 16), C = h.entangledLanes, C !== 0) for(h = h.entanglements, C &= S; 0 < C;)B = 31 - Hn(C), w = 1 << B, S |= h[B], C &= ~w;
            return S;
        }
        function bV(h, C) {
            switch(h){
                case 1:
                case 2:
                case 4:
                    return C + 250;
                case 8:
                case 16:
                case 32:
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                    return C + 5e3;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    return -1;
                case 134217728:
                case 268435456:
                case 536870912:
                case 1073741824:
                    return -1;
                default:
                    return -1;
            }
        }
        function yV(h, C) {
            for(var B = h.suspendedLanes, S = h.pingedLanes, w = h.expirationTimes, L = h.pendingLanes; 0 < L;){
                var Q = 31 - Hn(L), le = 1 << Q, We = w[Q];
                We === -1 ? (!(le & B) || le & S) && (w[Q] = bV(le, C)) : We <= C && (h.expiredLanes |= le), L &= ~le;
            }
        }
        function C0(h) {
            return h = h.pendingLanes & -1073741825, h !== 0 ? h : h & 1073741824 ? 1073741824 : 0;
        }
        function p0(h) {
            for(var C = [], B = 0; 31 > B; B++)C.push(h);
            return C;
        }
        function yh(h, C, B) {
            h.pendingLanes |= C, C !== 536870912 && (h.suspendedLanes = 0, h.pingedLanes = 0), h = h.eventTimes, C = 31 - Hn(C), h[C] = B;
        }
        function BV(h, C) {
            var B = h.pendingLanes & ~C;
            h.pendingLanes = C, h.suspendedLanes = 0, h.pingedLanes = 0, h.expiredLanes &= C, h.mutableReadLanes &= C, h.entangledLanes &= C, C = h.entanglements;
            var S = h.eventTimes;
            for(h = h.expirationTimes; 0 < B;){
                var w = 31 - Hn(B), L = 1 << w;
                C[w] = 0, S[w] = -1, h[w] = -1, B &= ~L;
            }
        }
        function uc(h, C) {
            var B = h.entangledLanes |= C;
            for(h = h.entanglements; B;){
                var S = 31 - Hn(B), w = 1 << S;
                w & C | h[S] & C && (h[S] |= C), B &= ~w;
            }
        }
        var ji = 0;
        function ff(h) {
            return h &= -h, 1 < h ? 4 < h ? h & 268435455 ? 16 : 536870912 : 4 : 1;
        }
        var m0 = n.unstable_scheduleCallback, TI = n.unstable_cancelCallback, fV = n.unstable_shouldYield, GV = n.unstable_requestPaint, Os = n.unstable_now, A0 = n.unstable_ImmediatePriority, vV = n.unstable_UserBlockingPriority, b0 = n.unstable_NormalPriority, SV = n.unstable_IdlePriority, rp = null, bg = null;
        function ZV(h) {
            if (bg && typeof bg.onCommitFiberRoot == "function") try {
                bg.onCommitFiberRoot(rp, h, void 0, (h.current.flags & 128) === 128);
            } catch  {}
        }
        function RV(h, C) {
            return h === C && (h !== 0 || 1 / h === 1 / C) || h !== h && C !== C;
        }
        var yg = typeof Object.is == "function" ? Object.is : RV, Bg = null, ap = !1, y0 = !1;
        function Gf(h) {
            Bg === null ? Bg = [
                h
            ] : Bg.push(h);
        }
        function VV(h) {
            ap = !0, Gf(h);
        }
        function fg() {
            if (!y0 && Bg !== null) {
                y0 = !0;
                var h = 0, C = ji;
                try {
                    var B = Bg;
                    for(ji = 1; h < B.length; h++){
                        var S = B[h];
                        do S = S(!0);
                        while (S !== null);
                    }
                    Bg = null, ap = !1;
                } catch (w) {
                    throw Bg !== null && (Bg = Bg.slice(h + 1)), m0(A0, fg), w;
                } finally{
                    ji = C, y0 = !1;
                }
            }
            return null;
        }
        var wV = o.ReactCurrentBatchConfig;
        function Bh(h, C) {
            if (yg(h, C)) return !0;
            if (typeof h != "object" || h === null || typeof C != "object" || C === null) return !1;
            var B = Object.keys(h), S = Object.keys(C);
            if (B.length !== S.length) return !1;
            for(S = 0; S < B.length; S++){
                var w = B[S];
                if (!_t.call(C, w) || !yg(h[w], C[w])) return !1;
            }
            return !0;
        }
        function vf(h) {
            switch(h.tag){
                case 5:
                    return ln(h.type);
                case 16:
                    return ln("Lazy");
                case 13:
                    return ln("Suspense");
                case 19:
                    return ln("SuspenseList");
                case 0:
                case 2:
                case 15:
                    return h = wt(h.type, !1), h;
                case 11:
                    return h = wt(h.type.render, !1), h;
                case 1:
                    return h = wt(h.type, !0), h;
                default:
                    return "";
            }
        }
        function Fo(h, C) {
            if (h && h.defaultProps) {
                C = s({}, C), h = h.defaultProps;
                for(var B in h)C[B] === void 0 && (C[B] = h[B]);
                return C;
            }
            return C;
        }
        var fh = Hi(null), Gh = null, Zu = null, B0 = null;
        function f0() {
            B0 = Zu = Gh = null;
        }
        function Sf(h, C, B) {
            Un ? (Kt(fh, C._currentValue), C._currentValue = B) : (Kt(fh, C._currentValue2), C._currentValue2 = B);
        }
        function op(h) {
            var C = fh.current;
            Ot(fh), Un ? h._currentValue = C : h._currentValue2 = C;
        }
        function vh(h, C, B) {
            for(; h !== null;){
                var S = h.alternate;
                if ((h.childLanes & C) !== C ? (h.childLanes |= C, S !== null && (S.childLanes |= C)) : S !== null && (S.childLanes & C) !== C && (S.childLanes |= C), h === B) break;
                h = h.return;
            }
        }
        function MI(h, C) {
            Gh = h, B0 = Zu = null, h = h.dependencies, h !== null && h.firstContext !== null && (h.lanes & C && (Ua = !0), h.firstContext = null);
        }
        function Jr(h) {
            var C = Un ? h._currentValue : h._currentValue2;
            if (B0 !== h) {
                if (h = {
                    context: h,
                    memoizedValue: C,
                    next: null
                }, Zu === null) {
                    if (Gh === null) throw Error(a(308));
                    Zu = h, Gh.dependencies = {
                        lanes: 0,
                        firstContext: h
                    };
                } else Zu = Zu.next = h;
            }
            return C;
        }
        var Gg = null, Ic = !1;
        function G0(h) {
            h.updateQueue = {
                baseState: h.memoizedState,
                firstBaseUpdate: null,
                lastBaseUpdate: null,
                shared: {
                    pending: null,
                    interleaved: null,
                    lanes: 0
                },
                effects: null
            };
        }
        function Zf(h, C) {
            h = h.updateQueue, C.updateQueue === h && (C.updateQueue = {
                baseState: h.baseState,
                firstBaseUpdate: h.firstBaseUpdate,
                lastBaseUpdate: h.lastBaseUpdate,
                shared: h.shared,
                effects: h.effects
            });
        }
        function ml(h, C) {
            return {
                eventTime: h,
                lane: C,
                tag: 0,
                payload: null,
                callback: null,
                next: null
            };
        }
        function dc(h, C) {
            var B = h.updateQueue;
            B !== null && (B = B.shared, Rs !== null && h.mode & 1 && !(pi & 2) ? (h = B.interleaved, h === null ? (C.next = C, Gg === null ? Gg = [
                B
            ] : Gg.push(B)) : (C.next = h.next, h.next = C), B.interleaved = C) : (h = B.pending, h === null ? C.next = C : (C.next = h.next, h.next = C), B.pending = C));
        }
        function gp(h, C, B) {
            if (C = C.updateQueue, C !== null && (C = C.shared, (B & 4194240) !== 0)) {
                var S = C.lanes;
                S &= h.pendingLanes, B |= S, C.lanes = B, uc(h, B);
            }
        }
        function v0(h, C) {
            var B = h.updateQueue, S = h.alternate;
            if (S !== null && (S = S.updateQueue, B === S)) {
                var w = null, L = null;
                if (B = B.firstBaseUpdate, B !== null) {
                    do {
                        var Q = {
                            eventTime: B.eventTime,
                            lane: B.lane,
                            tag: B.tag,
                            payload: B.payload,
                            callback: B.callback,
                            next: null
                        };
                        L === null ? w = L = Q : L = L.next = Q, B = B.next;
                    }while (B !== null);
                    L === null ? w = L = C : L = L.next = C;
                } else w = L = C;
                B = {
                    baseState: S.baseState,
                    firstBaseUpdate: w,
                    lastBaseUpdate: L,
                    shared: S.shared,
                    effects: S.effects
                }, h.updateQueue = B;
                return;
            }
            h = B.lastBaseUpdate, h === null ? B.firstBaseUpdate = C : h.next = C, B.lastBaseUpdate = C;
        }
        function lp(h, C, B, S) {
            var w = h.updateQueue;
            Ic = !1;
            var L = w.firstBaseUpdate, Q = w.lastBaseUpdate, le = w.shared.pending;
            if (le !== null) {
                w.shared.pending = null;
                var We = le, Oe = We.next;
                We.next = null, Q === null ? L = Oe : Q.next = Oe, Q = We;
                var bt = h.alternate;
                bt !== null && (bt = bt.updateQueue, le = bt.lastBaseUpdate, le !== Q && (le === null ? bt.firstBaseUpdate = Oe : le.next = Oe, bt.lastBaseUpdate = We));
            }
            if (L !== null) {
                var qt = w.baseState;
                Q = 0, bt = Oe = We = null, le = L;
                do {
                    var Yt = le.lane, cn = le.eventTime;
                    if ((S & Yt) === Yt) {
                        bt !== null && (bt = bt.next = {
                            eventTime: cn,
                            lane: 0,
                            tag: le.tag,
                            payload: le.payload,
                            callback: le.callback,
                            next: null
                        });
                        e: {
                            var Vt = h, qs = le;
                            switch(Yt = C, cn = B, qs.tag){
                                case 1:
                                    if (Vt = qs.payload, typeof Vt == "function") {
                                        qt = Vt.call(cn, qt, Yt);
                                        break e;
                                    }
                                    qt = Vt;
                                    break e;
                                case 3:
                                    Vt.flags = Vt.flags & -65537 | 128;
                                case 0:
                                    if (Vt = qs.payload, Yt = typeof Vt == "function" ? Vt.call(cn, qt, Yt) : Vt, Yt == null) break e;
                                    qt = s({}, qt, Yt);
                                    break e;
                                case 2:
                                    Ic = !0;
                            }
                        }
                        le.callback !== null && le.lane !== 0 && (h.flags |= 64, Yt = w.effects, Yt === null ? w.effects = [
                            le
                        ] : Yt.push(le));
                    } else cn = {
                        eventTime: cn,
                        lane: Yt,
                        tag: le.tag,
                        payload: le.payload,
                        callback: le.callback,
                        next: null
                    }, bt === null ? (Oe = bt = cn, We = qt) : bt = bt.next = cn, Q |= Yt;
                    if (le = le.next, le === null) {
                        if (le = w.shared.pending, le === null) break;
                        Yt = le, le = Yt.next, Yt.next = null, w.lastBaseUpdate = Yt, w.shared.pending = null;
                    }
                }while (!0);
                if (bt === null && (We = qt), w.baseState = We, w.firstBaseUpdate = Oe, w.lastBaseUpdate = bt, C = w.shared.interleaved, C !== null) {
                    w = C;
                    do Q |= w.lane, w = w.next;
                    while (w !== C);
                } else L === null && (w.shared.lanes = 0);
                rd |= Q, h.lanes = Q, h.memoizedState = qt;
            }
        }
        function Rf(h, C, B) {
            if (h = C.effects, C.effects = null, h !== null) for(C = 0; C < h.length; C++){
                var S = h[C], w = S.callback;
                if (w !== null) {
                    if (S.callback = null, S = B, typeof w != "function") throw Error(a(191, w));
                    w.call(S);
                }
            }
        }
        var Vf = new i.Component().refs;
        function S0(h, C, B, S) {
            C = h.memoizedState, B = B(S, C), B = B == null ? C : s({}, C, B), h.memoizedState = B, h.lanes === 0 && (h.updateQueue.baseState = B);
        }
        var cp = {
            isMounted: function(h) {
                return (h = h._reactInternals) ? _(h) === h : !1;
            },
            enqueueSetState: function(h, C, B) {
                h = h._reactInternals;
                var S = Qr(), w = ks(h), L = ml(S, w);
                L.payload = C, B != null && (L.callback = B), dc(h, L), C = ws(h, w, S), C !== null && gp(C, h, w);
            },
            enqueueReplaceState: function(h, C, B) {
                h = h._reactInternals;
                var S = Qr(), w = ks(h), L = ml(S, w);
                L.tag = 1, L.payload = C, B != null && (L.callback = B), dc(h, L), C = ws(h, w, S), C !== null && gp(C, h, w);
            },
            enqueueForceUpdate: function(h, C) {
                h = h._reactInternals;
                var B = Qr(), S = ks(h), w = ml(B, S);
                w.tag = 2, C != null && (w.callback = C), dc(h, w), C = ws(h, S, B), C !== null && gp(C, h, S);
            }
        };
        function wf(h, C, B, S, w, L, Q) {
            return h = h.stateNode, typeof h.shouldComponentUpdate == "function" ? h.shouldComponentUpdate(S, L, Q) : C.prototype && C.prototype.isPureReactComponent ? !Bh(B, S) || !Bh(w, L) : !0;
        }
        function Wf(h, C, B) {
            var S = !1, w = Si, L = C.contextType;
            return typeof L == "object" && L !== null ? L = Jr(L) : (w = fs(C) ? Vn : Bn.current, S = C.contextTypes, L = (S = S != null) ? wr(h, w) : Si), C = new C(B, L), h.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, C.updater = cp, h.stateNode = C, C._reactInternals = h, S && (h = h.stateNode, h.__reactInternalMemoizedUnmaskedChildContext = w, h.__reactInternalMemoizedMaskedChildContext = L), C;
        }
        function Hf(h, C, B, S) {
            h = C.state, typeof C.componentWillReceiveProps == "function" && C.componentWillReceiveProps(B, S), typeof C.UNSAFE_componentWillReceiveProps == "function" && C.UNSAFE_componentWillReceiveProps(B, S), C.state !== h && cp.enqueueReplaceState(C, C.state, null);
        }
        function Z0(h, C, B, S) {
            var w = h.stateNode;
            w.props = B, w.state = h.memoizedState, w.refs = Vf, G0(h);
            var L = C.contextType;
            typeof L == "object" && L !== null ? w.context = Jr(L) : (L = fs(C) ? Vn : Bn.current, w.context = wr(h, L)), w.state = h.memoizedState, L = C.getDerivedStateFromProps, typeof L == "function" && (S0(h, C, L, B), w.state = h.memoizedState), typeof C.getDerivedStateFromProps == "function" || typeof w.getSnapshotBeforeUpdate == "function" || typeof w.UNSAFE_componentWillMount != "function" && typeof w.componentWillMount != "function" || (C = w.state, typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount(), C !== w.state && cp.enqueueReplaceState(w, w.state, null), lp(h, B, w, S), w.state = h.memoizedState), typeof w.componentDidMount == "function" && (h.flags |= 4194308);
        }
        var zI = [], kI = 0, up = null, Ip = 0, go = [], lo = 0, Ru = null, Al = 1, bl = "";
        function Vu(h, C) {
            zI[kI++] = Ip, zI[kI++] = up, up = h, Ip = C;
        }
        function EI(h, C, B) {
            go[lo++] = Al, go[lo++] = bl, go[lo++] = Ru, Ru = h;
            var S = Al;
            h = bl;
            var w = 32 - Hn(S) - 1;
            S &= ~(1 << w), B += 1;
            var L = 32 - Hn(C) + w;
            if (30 < L) {
                var Q = w - w % 5;
                L = (S & (1 << Q) - 1).toString(32), S >>= Q, w -= Q, Al = 1 << 32 - Hn(C) + w | B << w | S, bl = L + h;
            } else Al = 1 << L | B << w | S, bl = h;
        }
        function dp(h) {
            h.return !== null && (Vu(h, 1), EI(h, 1, 0));
        }
        function hp(h) {
            for(; h === up;)up = zI[--kI], zI[kI] = null, Ip = zI[--kI], zI[kI] = null;
            for(; h === Ru;)Ru = go[--lo], go[lo] = null, bl = go[--lo], go[lo] = null, Al = go[--lo], go[lo] = null;
        }
        var ya = null, Ba = null, Xn = !1, JI = !1, co = null;
        function R0(h, C) {
            var B = jr(5, null, null, 0);
            B.elementType = "DELETED", B.stateNode = C, B.return = h, C = h.deletions, C === null ? (h.deletions = [
                B
            ], h.flags |= 16) : C.push(B);
        }
        function Xf(h, C) {
            switch(h.tag){
                case 5:
                    return C = Aa(C, h.type, h.pendingProps), C !== null ? (h.stateNode = C, ya = h, Ba = hi(C), !0) : !1;
                case 6:
                    return C = h0(C, h.pendingProps), C !== null ? (h.stateNode = C, ya = h, Ba = null, !0) : !1;
                case 13:
                    if (C = lc(C), C !== null) {
                        var B = Ru !== null ? {
                            id: Al,
                            overflow: bl
                        } : null;
                        return h.memoizedState = {
                            dehydrated: C,
                            treeContext: B,
                            retryLane: 1073741824
                        }, B = jr(18, null, null, 0), B.stateNode = C, B.return = h, h.child = B, ya = h, Ba = null, !0;
                    }
                    return !1;
                default:
                    return !1;
            }
        }
        function V0(h) {
            return (h.mode & 1) !== 0 && (h.flags & 128) === 0;
        }
        function Sh(h) {
            if (Xn) {
                var C = Ba;
                if (C) {
                    var B = C;
                    if (!Xf(h, C)) {
                        if (V0(h)) throw Error(a(418));
                        C = xn(B);
                        var S = ya;
                        C && Xf(h, C) ? R0(S, B) : (h.flags = h.flags & -4097 | 2, Xn = !1, ya = h);
                    }
                } else {
                    if (V0(h)) throw Error(a(418));
                    h.flags = h.flags & -4097 | 2, Xn = !1, ya = h;
                }
            }
        }
        function Cp(h) {
            for(h = h.return; h !== null && h.tag !== 5 && h.tag !== 3 && h.tag !== 13;)h = h.return;
            ya = h;
        }
        function uo(h) {
            if (!Di || h !== ya) return !1;
            if (!Xn) return Cp(h), Xn = !0, !1;
            if (h.tag !== 3 && (h.tag !== 5 || Qe(h.type) && !ct(h.type, h.memoizedProps))) {
                var C = Ba;
                if (C) {
                    if (V0(h)) {
                        for(h = Ba; h;)h = xn(h);
                        throw Error(a(418));
                    }
                    for(; C;)R0(h, C), C = xn(C);
                }
            }
            if (Cp(h), h.tag === 13) {
                if (!Di) throw Error(a(316));
                if (h = h.memoizedState, h = h !== null ? h.dehydrated : null, !h) throw Error(a(317));
                Ba = Be(h);
            } else Ba = ya ? xn(h.stateNode) : null;
            return !0;
        }
        function hc() {
            Di && (Ba = ya = null, JI = Xn = !1);
        }
        function UI(h) {
            co === null ? co = [
                h
            ] : co.push(h);
        }
        function Zh(h, C, B) {
            if (h = B.ref, h !== null && typeof h != "function" && typeof h != "object") {
                if (B._owner) {
                    if (B = B._owner, B) {
                        if (B.tag !== 1) throw Error(a(309));
                        var S = B.stateNode;
                    }
                    if (!S) throw Error(a(147, h));
                    var w = S, L = "" + h;
                    return C !== null && C.ref !== null && typeof C.ref == "function" && C.ref._stringRef === L ? C.ref : (C = function(Q) {
                        var le = w.refs;
                        le === Vf && (le = w.refs = {}), Q === null ? delete le[L] : le[L] = Q;
                    }, C._stringRef = L, C);
                }
                if (typeof h != "string") throw Error(a(284));
                if (!B._owner) throw Error(a(290, h));
            }
            return h;
        }
        function DI(h, C) {
            throw h = Object.prototype.toString.call(C), Error(a(31, h === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : h));
        }
        function Nf(h) {
            var C = h._init;
            return C(h._payload);
        }
        function pp(h) {
            function C(be, ue) {
                if (h) {
                    var ve = be.deletions;
                    ve === null ? (be.deletions = [
                        ue
                    ], be.flags |= 16) : ve.push(ue);
                }
            }
            function B(be, ue) {
                if (!h) return null;
                for(; ue !== null;)C(be, ue), ue = ue.sibling;
                return null;
            }
            function S(be, ue) {
                for(be = /* @__PURE__ */ new Map(); ue !== null;)ue.key !== null ? be.set(ue.key, ue) : be.set(ue.index, ue), ue = ue.sibling;
                return be;
            }
            function w(be, ue) {
                return be = Vl(be, ue), be.index = 0, be.sibling = null, be;
            }
            function L(be, ue, ve) {
                return be.index = ve, h ? (ve = be.alternate, ve !== null ? (ve = ve.index, ve < ue ? (be.flags |= 2, ue) : ve) : (be.flags |= 2, ue)) : (be.flags |= 1048576, ue);
            }
            function Q(be) {
                return h && be.alternate === null && (be.flags |= 2), be;
            }
            function le(be, ue, ve, rt) {
                return ue === null || ue.tag !== 6 ? (ue = _a(ve, be.mode, rt), ue.return = be, ue) : (ue = w(ue, ve), ue.return = be, ue);
            }
            function We(be, ue, ve, rt) {
                var Zt = ve.type;
                return Zt === c ? bt(be, ue, ve.props.children, rt, ve.key) : ue !== null && (ue.elementType === Zt || typeof Zt == "object" && Zt !== null && Zt.$$typeof === H && Nf(Zt) === ue.type) ? (rt = w(ue, ve.props), rt.ref = Zh(be, ue, ve), rt.return = be, rt) : (rt = dd(ve.type, ve.key, ve.props, null, be.mode, rt), rt.ref = Zh(be, ue, ve), rt.return = be, rt);
            }
            function Oe(be, ue, ve, rt) {
                return ue === null || ue.tag !== 4 || ue.stateNode.containerInfo !== ve.containerInfo || ue.stateNode.implementation !== ve.implementation ? (ue = hd(ve, be.mode, rt), ue.return = be, ue) : (ue = w(ue, ve.children || []), ue.return = be, ue);
            }
            function bt(be, ue, ve, rt, Zt) {
                return ue === null || ue.tag !== 7 ? (ue = xu(ve, be.mode, rt, Zt), ue.return = be, ue) : (ue = w(ue, ve), ue.return = be, ue);
            }
            function qt(be, ue, ve) {
                if (typeof ue == "string" && ue !== "" || typeof ue == "number") return ue = _a("" + ue, be.mode, ve), ue.return = be, ue;
                if (typeof ue == "object" && ue !== null) {
                    switch(ue.$$typeof){
                        case g:
                            return ve = dd(ue.type, ue.key, ue.props, null, be.mode, ve), ve.ref = Zh(be, null, ue), ve.return = be, ve;
                        case l:
                            return ue = hd(ue, be.mode, ve), ue.return = be, ue;
                        case H:
                            var rt = ue._init;
                            return qt(be, rt(ue._payload), ve);
                    }
                    if ($(ue) || K(ue)) return ue = xu(ue, be.mode, ve, null), ue.return = be, ue;
                    DI(be, ue);
                }
                return null;
            }
            function Yt(be, ue, ve, rt) {
                var Zt = ue !== null ? ue.key : null;
                if (typeof ve == "string" && ve !== "" || typeof ve == "number") return Zt !== null ? null : le(be, ue, "" + ve, rt);
                if (typeof ve == "object" && ve !== null) {
                    switch(ve.$$typeof){
                        case g:
                            return ve.key === Zt ? We(be, ue, ve, rt) : null;
                        case l:
                            return ve.key === Zt ? Oe(be, ue, ve, rt) : null;
                        case H:
                            return Zt = ve._init, Yt(be, ue, Zt(ve._payload), rt);
                    }
                    if ($(ve) || K(ve)) return Zt !== null ? null : bt(be, ue, ve, rt, null);
                    DI(be, ve);
                }
                return null;
            }
            function cn(be, ue, ve, rt, Zt) {
                if (typeof rt == "string" && rt !== "" || typeof rt == "number") return be = be.get(ve) || null, le(ue, be, "" + rt, Zt);
                if (typeof rt == "object" && rt !== null) {
                    switch(rt.$$typeof){
                        case g:
                            return be = be.get(rt.key === null ? ve : rt.key) || null, We(ue, be, rt, Zt);
                        case l:
                            return be = be.get(rt.key === null ? ve : rt.key) || null, Oe(ue, be, rt, Zt);
                        case H:
                            var si = rt._init;
                            return cn(be, ue, ve, si(rt._payload), Zt);
                    }
                    if ($(rt) || K(rt)) return be = be.get(ve) || null, bt(ue, be, rt, Zt, null);
                    DI(ue, rt);
                }
                return null;
            }
            function Vt(be, ue, ve, rt) {
                for(var Zt = null, si = null, ii = ue, Yi = ue = 0, $s = null; ii !== null && Yi < ve.length; Yi++){
                    ii.index > Yi ? ($s = ii, ii = null) : $s = ii.sibling;
                    var Oi = Yt(be, ii, ve[Yi], rt);
                    if (Oi === null) {
                        ii === null && (ii = $s);
                        break;
                    }
                    h && ii && Oi.alternate === null && C(be, ii), ue = L(Oi, ue, Yi), si === null ? Zt = Oi : si.sibling = Oi, si = Oi, ii = $s;
                }
                if (Yi === ve.length) return B(be, ii), Xn && Vu(be, Yi), Zt;
                if (ii === null) {
                    for(; Yi < ve.length; Yi++)ii = qt(be, ve[Yi], rt), ii !== null && (ue = L(ii, ue, Yi), si === null ? Zt = ii : si.sibling = ii, si = ii);
                    return Xn && Vu(be, Yi), Zt;
                }
                for(ii = S(be, ii); Yi < ve.length; Yi++)$s = cn(ii, be, Yi, ve[Yi], rt), $s !== null && (h && $s.alternate !== null && ii.delete($s.key === null ? Yi : $s.key), ue = L($s, ue, Yi), si === null ? Zt = $s : si.sibling = $s, si = $s);
                return h && ii.forEach(function(Eo) {
                    return C(be, Eo);
                }), Xn && Vu(be, Yi), Zt;
            }
            function qs(be, ue, ve, rt) {
                var Zt = K(ve);
                if (typeof Zt != "function") throw Error(a(150));
                if (ve = Zt.call(ve), ve == null) throw Error(a(151));
                for(var si = Zt = null, ii = ue, Yi = ue = 0, $s = null, Oi = ve.next(); ii !== null && !Oi.done; Yi++, Oi = ve.next()){
                    ii.index > Yi ? ($s = ii, ii = null) : $s = ii.sibling;
                    var Eo = Yt(be, ii, Oi.value, rt);
                    if (Eo === null) {
                        ii === null && (ii = $s);
                        break;
                    }
                    h && ii && Eo.alternate === null && C(be, ii), ue = L(Eo, ue, Yi), si === null ? Zt = Eo : si.sibling = Eo, si = Eo, ii = $s;
                }
                if (Oi.done) return B(be, ii), Xn && Vu(be, Yi), Zt;
                if (ii === null) {
                    for(; !Oi.done; Yi++, Oi = ve.next())Oi = qt(be, Oi.value, rt), Oi !== null && (ue = L(Oi, ue, Yi), si === null ? Zt = Oi : si.sibling = Oi, si = Oi);
                    return Xn && Vu(be, Yi), Zt;
                }
                for(ii = S(be, ii); !Oi.done; Yi++, Oi = ve.next())Oi = cn(ii, be, Yi, Oi.value, rt), Oi !== null && (h && Oi.alternate !== null && ii.delete(Oi.key === null ? Yi : Oi.key), ue = L(Oi, ue, Yi), si === null ? Zt = Oi : si.sibling = Oi, si = Oi);
                return h && ii.forEach(function(eG) {
                    return C(be, eG);
                }), Xn && Vu(be, Yi), Zt;
            }
            function qr(be, ue, ve, rt) {
                if (typeof ve == "object" && ve !== null && ve.type === c && ve.key === null && (ve = ve.props.children), typeof ve == "object" && ve !== null) {
                    switch(ve.$$typeof){
                        case g:
                            e: {
                                for(var Zt = ve.key, si = ue; si !== null;){
                                    if (si.key === Zt) {
                                        if (Zt = ve.type, Zt === c) {
                                            if (si.tag === 7) {
                                                B(be, si.sibling), ue = w(si, ve.props.children), ue.return = be, be = ue;
                                                break e;
                                            }
                                        } else if (si.elementType === Zt || typeof Zt == "object" && Zt !== null && Zt.$$typeof === H && Nf(Zt) === si.type) {
                                            B(be, si.sibling), ue = w(si, ve.props), ue.ref = Zh(be, si, ve), ue.return = be, be = ue;
                                            break e;
                                        }
                                        B(be, si);
                                        break;
                                    } else C(be, si);
                                    si = si.sibling;
                                }
                                ve.type === c ? (ue = xu(ve.props.children, be.mode, rt, ve.key), ue.return = be, be = ue) : (rt = dd(ve.type, ve.key, ve.props, null, be.mode, rt), rt.ref = Zh(be, ue, ve), rt.return = be, be = rt);
                            }
                            return Q(be);
                        case l:
                            e: {
                                for(si = ve.key; ue !== null;){
                                    if (ue.key === si) {
                                        if (ue.tag === 4 && ue.stateNode.containerInfo === ve.containerInfo && ue.stateNode.implementation === ve.implementation) {
                                            B(be, ue.sibling), ue = w(ue, ve.children || []), ue.return = be, be = ue;
                                            break e;
                                        } else {
                                            B(be, ue);
                                            break;
                                        }
                                    } else C(be, ue);
                                    ue = ue.sibling;
                                }
                                ue = hd(ve, be.mode, rt), ue.return = be, be = ue;
                            }
                            return Q(be);
                        case H:
                            return si = ve._init, qr(be, ue, si(ve._payload), rt);
                    }
                    if ($(ve)) return Vt(be, ue, ve, rt);
                    if (K(ve)) return qs(be, ue, ve, rt);
                    DI(be, ve);
                }
                return typeof ve == "string" && ve !== "" || typeof ve == "number" ? (ve = "" + ve, ue !== null && ue.tag === 6 ? (B(be, ue.sibling), ue = w(ue, ve), ue.return = be, be = ue) : (B(be, ue), ue = _a(ve, be.mode, rt), ue.return = be, be = ue), Q(be)) : B(be, ue);
            }
            return qr;
        }
        var _I = pp(!0), mp = pp(!1), PI = {}, Ja = Hi(PI), QI = Hi(PI), yl = Hi(PI);
        function vs(h) {
            if (h === PI) throw Error(a(174));
            return h;
        }
        function Rh(h, C) {
            Kt(yl, C), Kt(QI, h), Kt(Ja, PI), h = Ge(C), Ot(Ja), Kt(Ja, h);
        }
        function Bl() {
            Ot(Ja), Ot(QI), Ot(yl);
        }
        function vg(h) {
            var C = vs(yl.current), B = vs(Ja.current);
            C = q(B, h.type, C), B !== C && (Kt(QI, h), Kt(Ja, C));
        }
        function Sg(h) {
            QI.current === h && (Ot(Ja), Ot(QI));
        }
        var Bi = Hi(0);
        function Ss(h) {
            for(var C = h; C !== null;){
                if (C.tag === 13) {
                    var B = C.memoizedState;
                    if (B !== null && (B = B.dehydrated, B === null || Cl(B) || mh(B))) return C;
                } else if (C.tag === 19 && C.memoizedProps.revealOrder !== void 0) {
                    if (C.flags & 128) return C;
                } else if (C.child !== null) {
                    C.child.return = C, C = C.child;
                    continue;
                }
                if (C === h) break;
                for(; C.sibling === null;){
                    if (C.return === null || C.return === h) return null;
                    C = C.return;
                }
                C.sibling.return = C.return, C = C.sibling;
            }
            return null;
        }
        var Vh = [];
        function Ur() {
            for(var h = 0; h < Vh.length; h++){
                var C = Vh[h];
                Un ? C._workInProgressVersionPrimary = null : C._workInProgressVersionSecondary = null;
            }
            Vh.length = 0;
        }
        var Io = o.ReactCurrentDispatcher, us = o.ReactCurrentBatchConfig, Cc = 0, fn = null, Cr = null, _n = null, wu = !1, fa = !1, pc = 0, w0 = 0;
        function pr() {
            throw Error(a(321));
        }
        function Ap(h, C) {
            if (C === null) return !1;
            for(var B = 0; B < C.length && B < h.length; B++)if (!yg(h[B], C[B])) return !1;
            return !0;
        }
        function OI(h, C, B, S, w, L) {
            if (Cc = L, fn = C, C.memoizedState = null, C.updateQueue = null, C.lanes = 0, Io.current = h === null || h.memoizedState === null ? Y0 : K0, h = B(S, w), fa) {
                L = 0;
                do {
                    if (fa = !1, pc = 0, 25 <= L) throw Error(a(301));
                    L += 1, _n = Cr = null, C.updateQueue = null, Io.current = x0, h = B(S, w);
                }while (fa);
            }
            if (Io.current = qI, C = Cr !== null && Cr.next !== null, Cc = 0, _n = Cr = fn = null, wu = !1, C) throw Error(a(300));
            return h;
        }
        function bp() {
            var h = pc !== 0;
            return pc = 0, h;
        }
        function fl() {
            var h = {
                memoizedState: null,
                baseState: null,
                baseQueue: null,
                queue: null,
                next: null
            };
            return _n === null ? fn.memoizedState = _n = h : _n = _n.next = h, _n;
        }
        function Dr() {
            if (Cr === null) {
                var h = fn.alternate;
                h = h !== null ? h.memoizedState : null;
            } else h = Cr.next;
            var C = _n === null ? fn.memoizedState : _n.next;
            if (C !== null) _n = C, Cr = h;
            else {
                if (h === null) throw Error(a(310));
                Cr = h, h = {
                    memoizedState: Cr.memoizedState,
                    baseState: Cr.baseState,
                    baseQueue: Cr.baseQueue,
                    queue: Cr.queue,
                    next: null
                }, _n === null ? fn.memoizedState = _n = h : _n = _n.next = h;
            }
            return _n;
        }
        function mc(h, C) {
            return typeof C == "function" ? C(h) : C;
        }
        function Jt(h) {
            var C = Dr(), B = C.queue;
            if (B === null) throw Error(a(311));
            B.lastRenderedReducer = h;
            var S = Cr, w = S.baseQueue, L = B.pending;
            if (L !== null) {
                if (w !== null) {
                    var Q = w.next;
                    w.next = L.next, L.next = Q;
                }
                S.baseQueue = w = L, B.pending = null;
            }
            if (w !== null) {
                L = w.next, S = S.baseState;
                var le = Q = null, We = null, Oe = L;
                do {
                    var bt = Oe.lane;
                    if ((Cc & bt) === bt) We !== null && (We = We.next = {
                        lane: 0,
                        action: Oe.action,
                        hasEagerState: Oe.hasEagerState,
                        eagerState: Oe.eagerState,
                        next: null
                    }), S = Oe.hasEagerState ? Oe.eagerState : h(S, Oe.action);
                    else {
                        var qt = {
                            lane: bt,
                            action: Oe.action,
                            hasEagerState: Oe.hasEagerState,
                            eagerState: Oe.eagerState,
                            next: null
                        };
                        We === null ? (le = We = qt, Q = S) : We = We.next = qt, fn.lanes |= bt, rd |= bt;
                    }
                    Oe = Oe.next;
                }while (Oe !== null && Oe !== L);
                We === null ? Q = S : We.next = le, yg(S, C.memoizedState) || (Ua = !0), C.memoizedState = S, C.baseState = Q, C.baseQueue = We, B.lastRenderedState = S;
            }
            if (h = B.interleaved, h !== null) {
                w = h;
                do L = w.lane, fn.lanes |= L, rd |= L, w = w.next;
                while (w !== h);
            } else w === null && (B.lanes = 0);
            return [
                C.memoizedState,
                B.dispatch
            ];
        }
        function tn(h) {
            var C = Dr(), B = C.queue;
            if (B === null) throw Error(a(311));
            B.lastRenderedReducer = h;
            var S = B.dispatch, w = B.pending, L = C.memoizedState;
            if (w !== null) {
                B.pending = null;
                var Q = w = w.next;
                do L = h(L, Q.action), Q = Q.next;
                while (Q !== w);
                yg(L, C.memoizedState) || (Ua = !0), C.memoizedState = L, C.baseQueue === null && (C.baseState = L), B.lastRenderedState = L;
            }
            return [
                L,
                S
            ];
        }
        function Qi() {}
        function Is(h, C) {
            var B = fn, S = Dr(), w = C(), L = !yg(S.memoizedState, w);
            if (L && (S.memoizedState = w, Ua = !0), S = S.queue, ho(Lf.bind(null, B, S, h), [
                h
            ]), S.getSnapshot !== C || L || _n !== null && _n.memoizedState.tag & 1) {
                if (B.flags |= 2048, Wu(9, W0.bind(null, B, S, w, C), void 0, null), Rs === null) throw Error(a(349));
                Cc & 30 || To(B, C, w);
            }
            return w;
        }
        function To(h, C, B) {
            h.flags |= 16384, h = {
                getSnapshot: C,
                value: B
            }, C = fn.updateQueue, C === null ? (C = {
                lastEffect: null,
                stores: null
            }, fn.updateQueue = C, C.stores = [
                h
            ]) : (B = C.stores, B === null ? C.stores = [
                h
            ] : B.push(h));
        }
        function W0(h, C, B, S) {
            C.value = B, C.getSnapshot = S, Yf(C) && ws(h, 1, -1);
        }
        function Lf(h, C, B) {
            return B(function() {
                Yf(C) && ws(h, 1, -1);
            });
        }
        function Yf(h) {
            var C = h.getSnapshot;
            h = h.value;
            try {
                var B = C();
                return !yg(h, B);
            } catch  {
                return !0;
            }
        }
        function H0(h) {
            var C = fl();
            return typeof h == "function" && (h = h()), C.memoizedState = C.baseState = h, h = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: mc,
                lastRenderedState: h
            }, C.queue = h, h = h.dispatch = L0.bind(null, fn, h), [
                C.memoizedState,
                h
            ];
        }
        function Wu(h, C, B, S) {
            return h = {
                tag: h,
                create: C,
                destroy: B,
                deps: S,
                next: null
            }, C = fn.updateQueue, C === null ? (C = {
                lastEffect: null,
                stores: null
            }, fn.updateQueue = C, C.lastEffect = h.next = h) : (B = C.lastEffect, B === null ? C.lastEffect = h.next = h : (S = B.next, B.next = h, h.next = S, C.lastEffect = h)), h;
        }
        function ke() {
            return Dr().memoizedState;
        }
        function ds(h, C, B, S) {
            var w = fl();
            fn.flags |= h, w.memoizedState = Wu(1 | C, B, void 0, S === void 0 ? null : S);
        }
        function Ci(h, C, B, S) {
            var w = Dr();
            S = S === void 0 ? null : S;
            var L = void 0;
            if (Cr !== null) {
                var Q = Cr.memoizedState;
                if (L = Q.destroy, S !== null && Ap(S, Q.deps)) {
                    w.memoizedState = Wu(C, B, L, S);
                    return;
                }
            }
            fn.flags |= h, w.memoizedState = Wu(1 | C, B, L, S);
        }
        function Ac(h, C) {
            return ds(8390656, 8, h, C);
        }
        function ho(h, C) {
            return Ci(2048, 8, h, C);
        }
        function bc(h, C) {
            return Ci(4, 2, h, C);
        }
        function Zg(h, C) {
            return Ci(4, 4, h, C);
        }
        function jI(h, C) {
            if (typeof C == "function") return h = h(), C(h), function() {
                C(null);
            };
            if (C != null) return h = h(), C.current = h, function() {
                C.current = null;
            };
        }
        function Hu(h, C, B) {
            return B = B != null ? B.concat([
                h
            ]) : null, Ci(4, 4, jI.bind(null, C, h), B);
        }
        function Xu() {}
        function yp(h, C) {
            var B = Dr();
            C = C === void 0 ? null : C;
            var S = B.memoizedState;
            return S !== null && C !== null && Ap(C, S[1]) ? S[0] : (B.memoizedState = [
                h,
                C
            ], h);
        }
        function Bp(h, C) {
            var B = Dr();
            C = C === void 0 ? null : C;
            var S = B.memoizedState;
            return S !== null && C !== null && Ap(C, S[1]) ? S[0] : (h = h(), B.memoizedState = [
                h,
                C
            ], h);
        }
        function X0(h, C) {
            var B = ji;
            ji = B !== 0 && 4 > B ? B : 4, h(!0);
            var S = us.transition;
            us.transition = {};
            try {
                h(!1), C();
            } finally{
                ji = B, us.transition = S;
            }
        }
        function fp() {
            return Dr().memoizedState;
        }
        function N0(h, C, B) {
            var S = ks(h);
            B = {
                lane: S,
                action: B,
                hasEagerState: !1,
                eagerState: null,
                next: null
            }, Gp(h) ? vp(C, B) : (Sp(h, C, B), B = Qr(), h = ws(h, S, B), h !== null && Zp(h, C, S));
        }
        function L0(h, C, B) {
            var S = ks(h), w = {
                lane: S,
                action: B,
                hasEagerState: !1,
                eagerState: null,
                next: null
            };
            if (Gp(h)) vp(C, w);
            else {
                Sp(h, C, w);
                var L = h.alternate;
                if (h.lanes === 0 && (L === null || L.lanes === 0) && (L = C.lastRenderedReducer, L !== null)) try {
                    var Q = C.lastRenderedState, le = L(Q, B);
                    if (w.hasEagerState = !0, w.eagerState = le, yg(le, Q)) return;
                } catch  {} finally{}
                B = Qr(), h = ws(h, S, B), h !== null && Zp(h, C, S);
            }
        }
        function Gp(h) {
            var C = h.alternate;
            return h === fn || C !== null && C === fn;
        }
        function vp(h, C) {
            fa = wu = !0;
            var B = h.pending;
            B === null ? C.next = C : (C.next = B.next, B.next = C), h.pending = C;
        }
        function Sp(h, C, B) {
            Rs !== null && h.mode & 1 && !(pi & 2) ? (h = C.interleaved, h === null ? (B.next = B, Gg === null ? Gg = [
                C
            ] : Gg.push(C)) : (B.next = h.next, h.next = B), C.interleaved = B) : (h = C.pending, h === null ? B.next = B : (B.next = h.next, h.next = B), C.pending = B);
        }
        function Zp(h, C, B) {
            if (B & 4194240) {
                var S = C.lanes;
                S &= h.pendingLanes, B |= S, C.lanes = B, uc(h, B);
            }
        }
        var qI = {
            readContext: Jr,
            useCallback: pr,
            useContext: pr,
            useEffect: pr,
            useImperativeHandle: pr,
            useInsertionEffect: pr,
            useLayoutEffect: pr,
            useMemo: pr,
            useReducer: pr,
            useRef: pr,
            useState: pr,
            useDebugValue: pr,
            useDeferredValue: pr,
            useTransition: pr,
            useMutableSource: pr,
            useSyncExternalStore: pr,
            useId: pr,
            unstable_isNewReconciler: !1
        }, Y0 = {
            readContext: Jr,
            useCallback: function(h, C) {
                return fl().memoizedState = [
                    h,
                    C === void 0 ? null : C
                ], h;
            },
            useContext: Jr,
            useEffect: Ac,
            useImperativeHandle: function(h, C, B) {
                return B = B != null ? B.concat([
                    h
                ]) : null, ds(4194308, 4, jI.bind(null, C, h), B);
            },
            useLayoutEffect: function(h, C) {
                return ds(4194308, 4, h, C);
            },
            useInsertionEffect: function(h, C) {
                return ds(4, 2, h, C);
            },
            useMemo: function(h, C) {
                var B = fl();
                return C = C === void 0 ? null : C, h = h(), B.memoizedState = [
                    h,
                    C
                ], h;
            },
            useReducer: function(h, C, B) {
                var S = fl();
                return C = B !== void 0 ? B(C) : C, S.memoizedState = S.baseState = C, h = {
                    pending: null,
                    interleaved: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: h,
                    lastRenderedState: C
                }, S.queue = h, h = h.dispatch = N0.bind(null, fn, h), [
                    S.memoizedState,
                    h
                ];
            },
            useRef: function(h) {
                var C = fl();
                return h = {
                    current: h
                }, C.memoizedState = h;
            },
            useState: H0,
            useDebugValue: Xu,
            useDeferredValue: function(h) {
                var C = H0(h), B = C[0], S = C[1];
                return Ac(function() {
                    var w = us.transition;
                    us.transition = {};
                    try {
                        S(h);
                    } finally{
                        us.transition = w;
                    }
                }, [
                    h
                ]), B;
            },
            useTransition: function() {
                var h = H0(!1), C = h[0];
                return h = X0.bind(null, h[1]), fl().memoizedState = h, [
                    C,
                    h
                ];
            },
            useMutableSource: function() {},
            useSyncExternalStore: function(h, C, B) {
                var S = fn, w = fl();
                if (Xn) {
                    if (B === void 0) throw Error(a(407));
                    B = B();
                } else {
                    if (B = C(), Rs === null) throw Error(a(349));
                    Cc & 30 || To(S, C, B);
                }
                w.memoizedState = B;
                var L = {
                    value: B,
                    getSnapshot: C
                };
                return w.queue = L, Ac(Lf.bind(null, S, L, h), [
                    h
                ]), S.flags |= 2048, Wu(9, W0.bind(null, S, L, B, C), void 0, null), B;
            },
            useId: function() {
                var h = fl(), C = Rs.identifierPrefix;
                if (Xn) {
                    var B = bl, S = Al;
                    B = (S & ~(1 << 32 - Hn(S) - 1)).toString(32) + B, C = ":" + C + "R" + B, B = pc++, 0 < B && (C += "H" + B.toString(32)), C += ":";
                } else B = w0++, C = ":" + C + "r" + B.toString(32) + ":";
                return h.memoizedState = C;
            },
            unstable_isNewReconciler: !1
        }, K0 = {
            readContext: Jr,
            useCallback: yp,
            useContext: Jr,
            useEffect: ho,
            useImperativeHandle: Hu,
            useInsertionEffect: bc,
            useLayoutEffect: Zg,
            useMemo: Bp,
            useReducer: Jt,
            useRef: ke,
            useState: function() {
                return Jt(mc);
            },
            useDebugValue: Xu,
            useDeferredValue: function(h) {
                var C = Jt(mc), B = C[0], S = C[1];
                return ho(function() {
                    var w = us.transition;
                    us.transition = {};
                    try {
                        S(h);
                    } finally{
                        us.transition = w;
                    }
                }, [
                    h
                ]), B;
            },
            useTransition: function() {
                var h = Jt(mc)[0], C = Dr().memoizedState;
                return [
                    h,
                    C
                ];
            },
            useMutableSource: Qi,
            useSyncExternalStore: Is,
            useId: fp,
            unstable_isNewReconciler: !1
        }, x0 = {
            readContext: Jr,
            useCallback: yp,
            useContext: Jr,
            useEffect: ho,
            useImperativeHandle: Hu,
            useInsertionEffect: bc,
            useLayoutEffect: Zg,
            useMemo: Bp,
            useReducer: tn,
            useRef: ke,
            useState: function() {
                return tn(mc);
            },
            useDebugValue: Xu,
            useDeferredValue: function(h) {
                var C = tn(mc), B = C[0], S = C[1];
                return ho(function() {
                    var w = us.transition;
                    us.transition = {};
                    try {
                        S(h);
                    } finally{
                        us.transition = w;
                    }
                }, [
                    h
                ]), B;
            },
            useTransition: function() {
                var h = tn(mc)[0], C = Dr().memoizedState;
                return [
                    h,
                    C
                ];
            },
            useMutableSource: Qi,
            useSyncExternalStore: Is,
            useId: fp,
            unstable_isNewReconciler: !1
        };
        function wh(h, C) {
            try {
                var B = "", S = C;
                do B += vf(S), S = S.return;
                while (S);
                var w = B;
            } catch (L) {
                w = `
Error generating stack: ` + L.message + `
` + L.stack;
            }
            return {
                value: h,
                source: C,
                stack: w
            };
        }
        function $I(h, C) {
            try {
                console.error(C.value);
            } catch (B) {
                setTimeout(function() {
                    throw B;
                });
            }
        }
        var ed = typeof WeakMap == "function" ? WeakMap : Map;
        function Rp(h, C, B) {
            B = ml(-1, B), B.tag = 3, B.payload = {
                element: null
            };
            var S = C.value;
            return B.callback = function() {
                _p || (_p = !0, Q0 = S), $I(h, C);
            }, B;
        }
        function Vp(h, C, B) {
            B = ml(-1, B), B.tag = 3;
            var S = h.type.getDerivedStateFromError;
            if (typeof S == "function") {
                var w = C.value;
                B.payload = function() {
                    return S(w);
                }, B.callback = function() {
                    $I(h, C);
                };
            }
            var L = h.stateNode;
            return L !== null && typeof L.componentDidCatch == "function" && (B.callback = function() {
                $I(h, C), typeof S != "function" && (vc === null ? vc = /* @__PURE__ */ new Set([
                    this
                ]) : vc.add(this));
                var Q = C.stack;
                this.componentDidCatch(C.value, {
                    componentStack: Q !== null ? Q : ""
                });
            }), B;
        }
        function wp(h, C, B) {
            var S = h.pingCache;
            if (S === null) {
                S = h.pingCache = new ed();
                var w = /* @__PURE__ */ new Set();
                S.set(C, w);
            } else w = S.get(C), w === void 0 && (w = /* @__PURE__ */ new Set(), S.set(C, w));
            w.has(B) || (w.add(B), h = Th.bind(null, h, C, B), C.then(h, h));
        }
        function Wp(h) {
            do {
                var C;
                if ((C = h.tag === 13) && (C = h.memoizedState, C = C !== null ? C.dehydrated !== null : !0), C) return h;
                h = h.return;
            }while (h !== null);
            return null;
        }
        function F0(h, C, B, S, w) {
            return h.mode & 1 ? (h.flags |= 65536, h.lanes = w, h) : (h === C ? h.flags |= 65536 : (h.flags |= 128, B.flags |= 131072, B.flags &= -52805, B.tag === 1 && (B.alternate === null ? B.tag = 17 : (C = ml(-1, 1), C.tag = 2, dc(B, C))), B.lanes |= 1), h);
        }
        function Ga(h) {
            h.flags |= 4;
        }
        function T0(h, C) {
            if (h !== null && h.child === C.child) return !0;
            if (C.flags & 16) return !1;
            for(h = C.child; h !== null;){
                if (h.flags & 12854 || h.subtreeFlags & 12854) return !1;
                h = h.sibling;
            }
            return !0;
        }
        var Gl, Mo, Hr, Hp;
        if (mn) Gl = function(h, C) {
            for(var B = C.child; B !== null;){
                if (B.tag === 5 || B.tag === 6) Fe(h, B.stateNode);
                else if (B.tag !== 4 && B.child !== null) {
                    B.child.return = B, B = B.child;
                    continue;
                }
                if (B === C) break;
                for(; B.sibling === null;){
                    if (B.return === null || B.return === C) return;
                    B = B.return;
                }
                B.sibling.return = B.return, B = B.sibling;
            }
        }, Mo = function() {}, Hr = function(h, C, B, S, w) {
            if (h = h.memoizedProps, h !== S) {
                var L = C.stateNode, Q = vs(Ja.current);
                B = Te(L, B, h, S, w, Q), (C.updateQueue = B) && Ga(C);
            }
        }, Hp = function(h, C, B, S) {
            B !== S && Ga(C);
        };
        else if (Qs) {
            Gl = function(h, C, B, S) {
                for(var w = C.child; w !== null;){
                    if (w.tag === 5) {
                        var L = w.stateNode;
                        B && S && (L = hl(L, w.type, w.memoizedProps, w)), Fe(h, L);
                    } else if (w.tag === 6) L = w.stateNode, B && S && (L = xo(L, w.memoizedProps, w)), Fe(h, L);
                    else if (w.tag !== 4) {
                        if (w.tag === 22 && w.memoizedState !== null) L = w.child, L !== null && (L.return = w), Gl(h, w, !0, !0);
                        else if (w.child !== null) {
                            w.child.return = w, w = w.child;
                            continue;
                        }
                    }
                    if (w === C) break;
                    for(; w.sibling === null;){
                        if (w.return === null || w.return === C) return;
                        w = w.return;
                    }
                    w.sibling.return = w.return, w = w.sibling;
                }
            };
            var Gn = function(h, C, B, S) {
                for(var w = C.child; w !== null;){
                    if (w.tag === 5) {
                        var L = w.stateNode;
                        B && S && (L = hl(L, w.type, w.memoizedProps, w)), Wi(h, L);
                    } else if (w.tag === 6) L = w.stateNode, B && S && (L = xo(L, w.memoizedProps, w)), Wi(h, L);
                    else if (w.tag !== 4) {
                        if (w.tag === 22 && w.memoizedState !== null) L = w.child, L !== null && (L.return = w), Gn(h, w, !0, !0);
                        else if (w.child !== null) {
                            w.child.return = w, w = w.child;
                            continue;
                        }
                    }
                    if (w === C) break;
                    for(; w.sibling === null;){
                        if (w.return === null || w.return === C) return;
                        w = w.return;
                    }
                    w.sibling.return = w.return, w = w.sibling;
                }
            };
            Mo = function(h, C) {
                var B = C.stateNode;
                if (!T0(h, C)) {
                    h = B.containerInfo;
                    var S = ph(h);
                    Gn(S, C, !1, !1), B.pendingChildren = S, Ga(C), Ko(h, S);
                }
            }, Hr = function(h, C, B, S, w) {
                var L = h.stateNode, Q = h.memoizedProps;
                if ((h = T0(h, C)) && Q === S) C.stateNode = L;
                else {
                    var le = C.stateNode, We = vs(Ja.current), Oe = null;
                    Q !== S && (Oe = Te(le, B, Q, S, w, We)), h && Oe === null ? C.stateNode = L : (L = Su(L, Oe, B, Q, S, C, h, le), Xe(L, B, S, w, We) && Ga(C), C.stateNode = L, h ? Ga(C) : Gl(L, C, !1, !1));
                }
            }, Hp = function(h, C, B, S) {
                B !== S ? (h = vs(yl.current), B = vs(Ja.current), C.stateNode = st(S, h, B, C), Ga(C)) : C.stateNode = h.stateNode;
            };
        } else Mo = function() {}, Hr = function() {}, Hp = function() {};
        function yc(h, C) {
            if (!Xn) switch(h.tailMode){
                case "hidden":
                    C = h.tail;
                    for(var B = null; C !== null;)C.alternate !== null && (B = C), C = C.sibling;
                    B === null ? h.tail = null : B.sibling = null;
                    break;
                case "collapsed":
                    B = h.tail;
                    for(var S = null; B !== null;)B.alternate !== null && (S = B), B = B.sibling;
                    S === null ? C || h.tail === null ? h.tail = null : h.tail.sibling = null : S.sibling = null;
            }
        }
        function Fs(h) {
            var C = h.alternate !== null && h.alternate.child === h.child, B = 0, S = 0;
            if (C) for(var w = h.child; w !== null;)B |= w.lanes | w.childLanes, S |= w.subtreeFlags & 14680064, S |= w.flags & 14680064, w.return = h, w = w.sibling;
            else for(w = h.child; w !== null;)B |= w.lanes | w.childLanes, S |= w.subtreeFlags, S |= w.flags, w.return = h, w = w.sibling;
            return h.subtreeFlags |= S, h.childLanes = B, C;
        }
        function Wh(h, C, B) {
            var S = C.pendingProps;
            switch(hp(C), C.tag){
                case 2:
                case 16:
                case 15:
                case 0:
                case 11:
                case 7:
                case 8:
                case 12:
                case 9:
                case 14:
                    return Fs(C), null;
                case 1:
                    return fs(C.type) && xs(), Fs(C), null;
                case 3:
                    return S = C.stateNode, Bl(), Ot(oi), Ot(Bn), Ur(), S.pendingContext && (S.context = S.pendingContext, S.pendingContext = null), (h === null || h.child === null) && (uo(C) ? Ga(C) : h === null || h.memoizedState.isDehydrated && !(C.flags & 256) || (C.flags |= 1024, co !== null && (jp(co), co = null))), Mo(h, C), Fs(C), null;
                case 5:
                    Sg(C), B = vs(yl.current);
                    var w = C.type;
                    if (h !== null && C.stateNode != null) Hr(h, C, w, S, B), h.ref !== C.ref && (C.flags |= 512, C.flags |= 2097152);
                    else {
                        if (!S) {
                            if (C.stateNode === null) throw Error(a(166));
                            return Fs(C), null;
                        }
                        if (h = vs(Ja.current), uo(C)) {
                            if (!Di) throw Error(a(175));
                            h = x(C.stateNode, C.type, C.memoizedProps, B, h, C, !JI), C.updateQueue = h, h !== null && Ga(C);
                        } else {
                            var L = Ye(w, S, B, h, C);
                            Gl(L, C, !1, !1), C.stateNode = L, Xe(L, w, S, B, h) && Ga(C);
                        }
                        C.ref !== null && (C.flags |= 512, C.flags |= 2097152);
                    }
                    return Fs(C), null;
                case 6:
                    if (h && C.stateNode != null) Hp(h, C, h.memoizedProps, S);
                    else {
                        if (typeof S != "string" && C.stateNode === null) throw Error(a(166));
                        if (h = vs(yl.current), B = vs(Ja.current), uo(C)) {
                            if (!Di) throw Error(a(176));
                            if (h = C.stateNode, S = C.memoizedProps, (B = D(h, S, C, !JI)) && (w = ya, w !== null)) switch(L = (w.mode & 1) !== 0, w.tag){
                                case 3:
                                    tt(w.stateNode.containerInfo, h, S, L);
                                    break;
                                case 5:
                                    et(w.type, w.memoizedProps, w.stateNode, h, S, L);
                            }
                            B && Ga(C);
                        } else C.stateNode = st(S, h, B, C);
                    }
                    return Fs(C), null;
                case 13:
                    if (Ot(Bi), S = C.memoizedState, Xn && Ba !== null && C.mode & 1 && !(C.flags & 128)) {
                        for(h = Ba; h;)h = xn(h);
                        return hc(), C.flags |= 98560, C;
                    }
                    if (S !== null && S.dehydrated !== null) {
                        if (S = uo(C), h === null) {
                            if (!S) throw Error(a(318));
                            if (!Di) throw Error(a(344));
                            if (h = C.memoizedState, h = h !== null ? h.dehydrated : null, !h) throw Error(a(317));
                            re(h, C);
                        } else hc(), !(C.flags & 128) && (C.memoizedState = null), C.flags |= 4;
                        return Fs(C), null;
                    }
                    return co !== null && (jp(co), co = null), C.flags & 128 ? (C.lanes = B, C) : (S = S !== null, B = !1, h === null ? uo(C) : B = h.memoizedState !== null, S && !B && (C.child.flags |= 8192, C.mode & 1 && (h === null || Bi.current & 1 ? zs === 0 && (zs = 3) : qp())), C.updateQueue !== null && (C.flags |= 4), Fs(C), null);
                case 4:
                    return Bl(), Mo(h, C), h === null && oo(C.stateNode.containerInfo), Fs(C), null;
                case 10:
                    return op(C.type._context), Fs(C), null;
                case 17:
                    return fs(C.type) && xs(), Fs(C), null;
                case 19:
                    if (Ot(Bi), w = C.memoizedState, w === null) return Fs(C), null;
                    if (S = (C.flags & 128) !== 0, L = w.rendering, L === null) {
                        if (S) yc(w, !1);
                        else {
                            if (zs !== 0 || h !== null && h.flags & 128) for(h = C.child; h !== null;){
                                if (L = Ss(h), L !== null) {
                                    for(C.flags |= 128, yc(w, !1), h = L.updateQueue, h !== null && (C.updateQueue = h, C.flags |= 4), C.subtreeFlags = 0, h = B, S = C.child; S !== null;)B = S, w = h, B.flags &= 14680066, L = B.alternate, L === null ? (B.childLanes = 0, B.lanes = w, B.child = null, B.subtreeFlags = 0, B.memoizedProps = null, B.memoizedState = null, B.updateQueue = null, B.dependencies = null, B.stateNode = null) : (B.childLanes = L.childLanes, B.lanes = L.lanes, B.child = L.child, B.subtreeFlags = 0, B.deletions = null, B.memoizedProps = L.memoizedProps, B.memoizedState = L.memoizedState, B.updateQueue = L.updateQueue, B.type = L.type, w = L.dependencies, B.dependencies = w === null ? null : {
                                        lanes: w.lanes,
                                        firstContext: w.firstContext
                                    }), S = S.sibling;
                                    return Kt(Bi, Bi.current & 1 | 2), C.child;
                                }
                                h = h.sibling;
                            }
                            w.tail !== null && Os() > P0 && (C.flags |= 128, S = !0, yc(w, !1), C.lanes = 4194304);
                        }
                    } else {
                        if (!S) {
                            if (h = Ss(L), h !== null) {
                                if (C.flags |= 128, S = !0, h = h.updateQueue, h !== null && (C.updateQueue = h, C.flags |= 4), yc(w, !0), w.tail === null && w.tailMode === "hidden" && !L.alternate && !Xn) return Fs(C), null;
                            } else 2 * Os() - w.renderingStartTime > P0 && B !== 1073741824 && (C.flags |= 128, S = !0, yc(w, !1), C.lanes = 4194304);
                        }
                        w.isBackwards ? (L.sibling = C.child, C.child = L) : (h = w.last, h !== null ? h.sibling = L : C.child = L, w.last = L);
                    }
                    return w.tail !== null ? (C = w.tail, w.rendering = C, w.tail = C.sibling, w.renderingStartTime = Os(), C.sibling = null, h = Bi.current, Kt(Bi, S ? h & 1 | 2 : h & 1), C) : (Fs(C), null);
                case 22:
                case 23:
                    return $0(), S = C.memoizedState !== null, h !== null && h.memoizedState !== null !== S && (C.flags |= 8192), S && C.mode & 1 ? mr & 1073741824 && (Fs(C), mn && C.subtreeFlags & 6 && (C.flags |= 8192)) : Fs(C), null;
                case 24:
                    return null;
                case 25:
                    return null;
            }
            throw Error(a(156, C.tag));
        }
        var Xp = o.ReactCurrentOwner, Ua = !1;
        function _r(h, C, B, S) {
            C.child = h === null ? mp(C, null, B, S) : _I(C, h.child, B, S);
        }
        function Kf(h, C, B, S, w) {
            B = B.render;
            var L = C.ref;
            return MI(C, w), S = OI(h, C, B, S, L, w), B = bp(), h !== null && !Ua ? (C.updateQueue = h.updateQueue, C.flags &= -2053, h.lanes &= ~w, Rg(h, C, w)) : (Xn && B && dp(C), C.flags |= 1, _r(h, C, S, w), C.child);
        }
        function xf(h, C, B, S, w) {
            if (h === null) {
                var L = B.type;
                return typeof L == "function" && !$p(L) && L.defaultProps === void 0 && B.compare === null && B.defaultProps === void 0 ? (C.tag = 15, C.type = L, Np(h, C, L, S, w)) : (h = dd(B.type, null, S, C, C.mode, w), h.ref = C.ref, h.return = C, C.child = h);
            }
            if (L = h.child, !(h.lanes & w)) {
                var Q = L.memoizedProps;
                if (B = B.compare, B = B !== null ? B : Bh, B(Q, S) && h.ref === C.ref) return Rg(h, C, w);
            }
            return C.flags |= 1, h = Vl(L, S), h.ref = C.ref, h.return = C, C.child = h;
        }
        function Np(h, C, B, S, w) {
            if (h !== null && Bh(h.memoizedProps, S) && h.ref === C.ref) {
                if (Ua = !1, (h.lanes & w) !== 0) h.flags & 131072 && (Ua = !0);
                else return C.lanes = h.lanes, Rg(h, C, w);
            }
            return Yp(h, C, B, S, w);
        }
        function Ff(h, C, B) {
            var S = C.pendingProps, w = S.children, L = h !== null ? h.memoizedState : null;
            if (S.mode === "hidden") {
                if (!(C.mode & 1)) C.memoizedState = {
                    baseLanes: 0,
                    cachePool: null
                }, Kt(ko, mr), mr |= B;
                else if (B & 1073741824) C.memoizedState = {
                    baseLanes: 0,
                    cachePool: null
                }, S = L !== null ? L.baseLanes : B, Kt(ko, mr), mr |= S;
                else return h = L !== null ? L.baseLanes | B : B, C.lanes = C.childLanes = 1073741824, C.memoizedState = {
                    baseLanes: h,
                    cachePool: null
                }, C.updateQueue = null, Kt(ko, mr), mr |= h, null;
            } else L !== null ? (S = L.baseLanes | B, C.memoizedState = null) : S = B, Kt(ko, mr), mr |= S;
            return _r(h, C, w, B), C.child;
        }
        function Lp(h, C) {
            var B = C.ref;
            (h === null && B !== null || h !== null && h.ref !== B) && (C.flags |= 512, C.flags |= 2097152);
        }
        function Yp(h, C, B, S, w) {
            var L = fs(B) ? Vn : Bn.current;
            return L = wr(C, L), MI(C, w), B = OI(h, C, B, S, L, w), S = bp(), h !== null && !Ua ? (C.updateQueue = h.updateQueue, C.flags &= -2053, h.lanes &= ~w, Rg(h, C, w)) : (Xn && S && dp(C), C.flags |= 1, _r(h, C, B, w), C.child);
        }
        function Tf(h, C, B, S, w) {
            if (fs(B)) {
                var L = !0;
                en(C);
            } else L = !1;
            if (MI(C, w), C.stateNode === null) h !== null && (h.alternate = null, C.alternate = null, C.flags |= 2), Wf(C, B, S), Z0(C, B, S, w), S = !0;
            else if (h === null) {
                var Q = C.stateNode, le = C.memoizedProps;
                Q.props = le;
                var We = Q.context, Oe = B.contextType;
                typeof Oe == "object" && Oe !== null ? Oe = Jr(Oe) : (Oe = fs(B) ? Vn : Bn.current, Oe = wr(C, Oe));
                var bt = B.getDerivedStateFromProps, qt = typeof bt == "function" || typeof Q.getSnapshotBeforeUpdate == "function";
                qt || typeof Q.UNSAFE_componentWillReceiveProps != "function" && typeof Q.componentWillReceiveProps != "function" || (le !== S || We !== Oe) && Hf(C, Q, S, Oe), Ic = !1;
                var Yt = C.memoizedState;
                Q.state = Yt, lp(C, S, Q, w), We = C.memoizedState, le !== S || Yt !== We || oi.current || Ic ? (typeof bt == "function" && (S0(C, B, bt, S), We = C.memoizedState), (le = Ic || wf(C, B, le, S, Yt, We, Oe)) ? (qt || typeof Q.UNSAFE_componentWillMount != "function" && typeof Q.componentWillMount != "function" || (typeof Q.componentWillMount == "function" && Q.componentWillMount(), typeof Q.UNSAFE_componentWillMount == "function" && Q.UNSAFE_componentWillMount()), typeof Q.componentDidMount == "function" && (C.flags |= 4194308)) : (typeof Q.componentDidMount == "function" && (C.flags |= 4194308), C.memoizedProps = S, C.memoizedState = We), Q.props = S, Q.state = We, Q.context = Oe, S = le) : (typeof Q.componentDidMount == "function" && (C.flags |= 4194308), S = !1);
            } else {
                Q = C.stateNode, Zf(h, C), le = C.memoizedProps, Oe = C.type === C.elementType ? le : Fo(C.type, le), Q.props = Oe, qt = C.pendingProps, Yt = Q.context, We = B.contextType, typeof We == "object" && We !== null ? We = Jr(We) : (We = fs(B) ? Vn : Bn.current, We = wr(C, We));
                var cn = B.getDerivedStateFromProps;
                (bt = typeof cn == "function" || typeof Q.getSnapshotBeforeUpdate == "function") || typeof Q.UNSAFE_componentWillReceiveProps != "function" && typeof Q.componentWillReceiveProps != "function" || (le !== qt || Yt !== We) && Hf(C, Q, S, We), Ic = !1, Yt = C.memoizedState, Q.state = Yt, lp(C, S, Q, w);
                var Vt = C.memoizedState;
                le !== qt || Yt !== Vt || oi.current || Ic ? (typeof cn == "function" && (S0(C, B, cn, S), Vt = C.memoizedState), (Oe = Ic || wf(C, B, Oe, S, Yt, Vt, We) || !1) ? (bt || typeof Q.UNSAFE_componentWillUpdate != "function" && typeof Q.componentWillUpdate != "function" || (typeof Q.componentWillUpdate == "function" && Q.componentWillUpdate(S, Vt, We), typeof Q.UNSAFE_componentWillUpdate == "function" && Q.UNSAFE_componentWillUpdate(S, Vt, We)), typeof Q.componentDidUpdate == "function" && (C.flags |= 4), typeof Q.getSnapshotBeforeUpdate == "function" && (C.flags |= 1024)) : (typeof Q.componentDidUpdate != "function" || le === h.memoizedProps && Yt === h.memoizedState || (C.flags |= 4), typeof Q.getSnapshotBeforeUpdate != "function" || le === h.memoizedProps && Yt === h.memoizedState || (C.flags |= 1024), C.memoizedProps = S, C.memoizedState = Vt), Q.props = S, Q.state = Vt, Q.context = We, S = Oe) : (typeof Q.componentDidUpdate != "function" || le === h.memoizedProps && Yt === h.memoizedState || (C.flags |= 4), typeof Q.getSnapshotBeforeUpdate != "function" || le === h.memoizedProps && Yt === h.memoizedState || (C.flags |= 1024), S = !1);
            }
            return td(h, C, B, S, L, w);
        }
        function td(h, C, B, S, w, L) {
            Lp(h, C);
            var Q = (C.flags & 128) !== 0;
            if (!S && !Q) return w && Pi(C, B, !1), Rg(h, C, L);
            S = C.stateNode, Xp.current = C;
            var le = Q && typeof B.getDerivedStateFromError != "function" ? null : S.render();
            return C.flags |= 1, h !== null && Q ? (C.child = _I(C, h.child, null, L), C.child = _I(C, null, le, L)) : _r(h, C, le, L), C.memoizedState = S.state, w && Pi(C, B, !0), C.child;
        }
        function Mf(h) {
            var C = h.stateNode;
            C.pendingContext ? $i(h, C.pendingContext, C.pendingContext !== C.context) : C.context && $i(h, C.context, !1), Rh(h, C.containerInfo);
        }
        function M0(h, C, B, S, w) {
            return hc(), UI(w), C.flags |= 256, _r(h, C, B, S), C.child;
        }
        var Kp = {
            dehydrated: null,
            treeContext: null,
            retryLane: 0
        };
        function xp(h) {
            return {
                baseLanes: h,
                cachePool: null
            };
        }
        function Bc(h, C, B) {
            var S = C.pendingProps, w = Bi.current, L = !1, Q = (C.flags & 128) !== 0, le;
            if ((le = Q) || (le = h !== null && h.memoizedState === null ? !1 : (w & 2) !== 0), le ? (L = !0, C.flags &= -129) : (h === null || h.memoizedState !== null) && (w |= 1), Kt(Bi, w & 1), h === null) return Sh(C), h = C.memoizedState, h !== null && (h = h.dehydrated, h !== null) ? (C.mode & 1 ? mh(h) ? C.lanes = 8 : C.lanes = 1073741824 : C.lanes = 1, null) : (w = S.children, h = S.fallback, L ? (S = C.mode, L = C.child, w = {
                mode: "hidden",
                children: w
            }, !(S & 1) && L !== null ? (L.childLanes = 0, L.pendingProps = w) : L = em(w, S, 0, null), h = xu(h, S, B, null), L.return = C, h.return = C, L.sibling = h, C.child = L, C.child.memoizedState = xp(B), C.memoizedState = Kp, h) : Nu(C, w));
            if (w = h.memoizedState, w !== null) {
                if (le = w.dehydrated, le !== null) {
                    if (Q) return C.flags & 256 ? (C.flags &= -257, Xr(h, C, B, Error(a(422)))) : C.memoizedState !== null ? (C.child = h.child, C.flags |= 128, null) : (L = S.fallback, w = C.mode, S = em({
                        mode: "visible",
                        children: S.children
                    }, w, 0, null), L = xu(L, w, B, null), L.flags |= 2, S.return = C, L.return = C, S.sibling = L, C.child = S, C.mode & 1 && _I(C, h.child, null, B), C.child.memoizedState = xp(B), C.memoizedState = Kp, L);
                    if (!(C.mode & 1)) C = Xr(h, C, B, null);
                    else if (mh(le)) C = Xr(h, C, B, Error(a(419)));
                    else if (S = (B & h.childLanes) !== 0, Ua || S) {
                        if (S = Rs, S !== null) {
                            switch(B & -B){
                                case 4:
                                    L = 2;
                                    break;
                                case 16:
                                    L = 8;
                                    break;
                                case 64:
                                case 128:
                                case 256:
                                case 512:
                                case 1024:
                                case 2048:
                                case 4096:
                                case 8192:
                                case 16384:
                                case 32768:
                                case 65536:
                                case 131072:
                                case 262144:
                                case 524288:
                                case 1048576:
                                case 2097152:
                                case 4194304:
                                case 8388608:
                                case 16777216:
                                case 33554432:
                                case 67108864:
                                    L = 32;
                                    break;
                                case 536870912:
                                    L = 268435456;
                                    break;
                                default:
                                    L = 0;
                            }
                            S = L & (S.suspendedLanes | B) ? 0 : L, S !== 0 && S !== w.retryLane && (w.retryLane = S, ws(h, S, -1));
                        }
                        qp(), C = Xr(h, C, B, Error(a(421)));
                    } else Cl(le) ? (C.flags |= 128, C.child = h.child, C = Mh.bind(null, h), Ag(le, C), C = null) : (B = w.treeContext, Di && (Ba = bh(le), ya = C, Xn = !0, co = null, JI = !1, B !== null && (go[lo++] = Al, go[lo++] = bl, go[lo++] = Ru, Al = B.id, bl = B.overflow, Ru = C)), C = Nu(C, C.pendingProps.children), C.flags |= 4096);
                    return C;
                }
                return L ? (S = Fp(h, C, S.children, S.fallback, B), L = C.child, w = h.child.memoizedState, L.memoizedState = w === null ? xp(B) : {
                    baseLanes: w.baseLanes | B,
                    cachePool: null
                }, L.childLanes = h.childLanes & ~B, C.memoizedState = Kp, S) : (B = fc(h, C, S.children, B), C.memoizedState = null, B);
            }
            return L ? (S = Fp(h, C, S.children, S.fallback, B), L = C.child, w = h.child.memoizedState, L.memoizedState = w === null ? xp(B) : {
                baseLanes: w.baseLanes | B,
                cachePool: null
            }, L.childLanes = h.childLanes & ~B, C.memoizedState = Kp, S) : (B = fc(h, C, S.children, B), C.memoizedState = null, B);
        }
        function Nu(h, C) {
            return C = em({
                mode: "visible",
                children: C
            }, h.mode, 0, null), C.return = h, h.child = C;
        }
        function fc(h, C, B, S) {
            var w = h.child;
            return h = w.sibling, B = Vl(w, {
                mode: "visible",
                children: B
            }), !(C.mode & 1) && (B.lanes = S), B.return = C, B.sibling = null, h !== null && (S = C.deletions, S === null ? (C.deletions = [
                h
            ], C.flags |= 16) : S.push(h)), C.child = B;
        }
        function Fp(h, C, B, S, w) {
            var L = C.mode;
            h = h.child;
            var Q = h.sibling, le = {
                mode: "hidden",
                children: B
            };
            return !(L & 1) && C.child !== h ? (B = C.child, B.childLanes = 0, B.pendingProps = le, C.deletions = null) : (B = Vl(h, le), B.subtreeFlags = h.subtreeFlags & 14680064), Q !== null ? S = Vl(Q, S) : (S = xu(S, L, w, null), S.flags |= 2), S.return = C, B.return = C, B.sibling = S, C.child = B, S;
        }
        function Xr(h, C, B, S) {
            return S !== null && UI(S), _I(C, h.child, null, B), h = Nu(C, C.pendingProps.children), h.flags |= 2, C.memoizedState = null, h;
        }
        function Lu(h, C, B) {
            h.lanes |= C;
            var S = h.alternate;
            S !== null && (S.lanes |= C), vh(h.return, C, B);
        }
        function ti(h, C, B, S, w) {
            var L = h.memoizedState;
            L === null ? h.memoizedState = {
                isBackwards: C,
                rendering: null,
                renderingStartTime: 0,
                last: S,
                tail: B,
                tailMode: w
            } : (L.isBackwards = C, L.rendering = null, L.renderingStartTime = 0, L.last = S, L.tail = B, L.tailMode = w);
        }
        function Hh(h, C, B) {
            var S = C.pendingProps, w = S.revealOrder, L = S.tail;
            if (_r(h, C, S.children, B), S = Bi.current, S & 2) S = S & 1 | 2, C.flags |= 128;
            else {
                if (h !== null && h.flags & 128) e: for(h = C.child; h !== null;){
                    if (h.tag === 13) h.memoizedState !== null && Lu(h, B, C);
                    else if (h.tag === 19) Lu(h, B, C);
                    else if (h.child !== null) {
                        h.child.return = h, h = h.child;
                        continue;
                    }
                    if (h === C) break e;
                    for(; h.sibling === null;){
                        if (h.return === null || h.return === C) break e;
                        h = h.return;
                    }
                    h.sibling.return = h.return, h = h.sibling;
                }
                S &= 1;
            }
            if (Kt(Bi, S), !(C.mode & 1)) C.memoizedState = null;
            else switch(w){
                case "forwards":
                    for(B = C.child, w = null; B !== null;)h = B.alternate, h !== null && Ss(h) === null && (w = B), B = B.sibling;
                    B = w, B === null ? (w = C.child, C.child = null) : (w = B.sibling, B.sibling = null), ti(C, !1, w, B, L);
                    break;
                case "backwards":
                    for(B = null, w = C.child, C.child = null; w !== null;){
                        if (h = w.alternate, h !== null && Ss(h) === null) {
                            C.child = w;
                            break;
                        }
                        h = w.sibling, w.sibling = B, B = w, w = h;
                    }
                    ti(C, !0, B, null, L);
                    break;
                case "together":
                    ti(C, !1, null, null, void 0);
                    break;
                default:
                    C.memoizedState = null;
            }
            return C.child;
        }
        function Rg(h, C, B) {
            if (h !== null && (C.dependencies = h.dependencies), rd |= C.lanes, !(B & C.childLanes)) return null;
            if (h !== null && C.child !== h.child) throw Error(a(153));
            if (C.child !== null) {
                for(h = C.child, B = Vl(h, h.pendingProps), C.child = B, B.return = C; h.sibling !== null;)h = h.sibling, B = B.sibling = Vl(h, h.pendingProps), B.return = C;
                B.sibling = null;
            }
            return C.child;
        }
        function Gx(h, C, B) {
            switch(C.tag){
                case 3:
                    Mf(C), hc();
                    break;
                case 5:
                    vg(C);
                    break;
                case 1:
                    fs(C.type) && en(C);
                    break;
                case 4:
                    Rh(C, C.stateNode.containerInfo);
                    break;
                case 10:
                    Sf(C, C.type._context, C.memoizedProps.value);
                    break;
                case 13:
                    var S = C.memoizedState;
                    if (S !== null) return S.dehydrated !== null ? (Kt(Bi, Bi.current & 1), C.flags |= 128, null) : B & C.child.childLanes ? Bc(h, C, B) : (Kt(Bi, Bi.current & 1), h = Rg(h, C, B), h !== null ? h.sibling : null);
                    Kt(Bi, Bi.current & 1);
                    break;
                case 19:
                    if (S = (B & C.childLanes) !== 0, h.flags & 128) {
                        if (S) return Hh(h, C, B);
                        C.flags |= 128;
                    }
                    var w = C.memoizedState;
                    if (w !== null && (w.rendering = null, w.tail = null, w.lastEffect = null), Kt(Bi, Bi.current), S) break;
                    return null;
                case 22:
                case 23:
                    return C.lanes = 0, Ff(h, C, B);
            }
            return Rg(h, C, B);
        }
        function WV(h, C) {
            switch(hp(C), C.tag){
                case 1:
                    return fs(C.type) && xs(), h = C.flags, h & 65536 ? (C.flags = h & -65537 | 128, C) : null;
                case 3:
                    return Bl(), Ot(oi), Ot(Bn), Ur(), h = C.flags, h & 65536 && !(h & 128) ? (C.flags = h & -65537 | 128, C) : null;
                case 5:
                    return Sg(C), null;
                case 13:
                    if (Ot(Bi), h = C.memoizedState, h !== null && h.dehydrated !== null) {
                        if (C.alternate === null) throw Error(a(340));
                        hc();
                    }
                    return h = C.flags, h & 65536 ? (C.flags = h & -65537 | 128, C) : null;
                case 19:
                    return Ot(Bi), null;
                case 4:
                    return Bl(), null;
                case 10:
                    return op(C.type._context), null;
                case 22:
                case 23:
                    return $0(), null;
                case 24:
                    return null;
                default:
                    return null;
            }
        }
        var id = !1, zo = !1, HV = typeof WeakSet == "function" ? WeakSet : Set, ut = null;
        function Tp(h, C) {
            var B = h.ref;
            if (B !== null) {
                if (typeof B == "function") try {
                    B(null);
                } catch (S) {
                    Ws(h, C, S);
                }
                else B.current = null;
            }
        }
        function Xh(h, C, B) {
            try {
                B();
            } catch (S) {
                Ws(h, C, S);
            }
        }
        var zf = !1;
        function kf(h, C) {
            for(de(h.containerInfo), ut = C; ut !== null;)if (h = ut, C = h.child, (h.subtreeFlags & 1028) !== 0 && C !== null) C.return = h, ut = C;
            else for(; ut !== null;){
                h = ut;
                try {
                    var B = h.alternate;
                    if (h.flags & 1024) switch(h.tag){
                        case 0:
                        case 11:
                        case 15:
                            break;
                        case 1:
                            if (B !== null) {
                                var S = B.memoizedProps, w = B.memoizedState, L = h.stateNode, Q = L.getSnapshotBeforeUpdate(h.elementType === h.type ? S : Fo(h.type, S), w);
                                L.__reactInternalSnapshotBeforeUpdate = Q;
                            }
                            break;
                        case 3:
                            mn && mg(h.stateNode.containerInfo);
                            break;
                        case 5:
                        case 6:
                        case 4:
                        case 17:
                            break;
                        default:
                            throw Error(a(163));
                    }
                } catch (le) {
                    Ws(h, h.return, le);
                }
                if (C = h.sibling, C !== null) {
                    C.return = h.return, ut = C;
                    break;
                }
                ut = h.return;
            }
            return B = zf, zf = !1, B;
        }
        function Gc(h, C, B) {
            var S = C.updateQueue;
            if (S = S !== null ? S.lastEffect : null, S !== null) {
                var w = S = S.next;
                do {
                    if ((w.tag & h) === h) {
                        var L = w.destroy;
                        w.destroy = void 0, L !== void 0 && Xh(C, B, L);
                    }
                    w = w.next;
                }while (w !== S);
            }
        }
        function va(h, C) {
            if (C = C.updateQueue, C = C !== null ? C.lastEffect : null, C !== null) {
                var B = C = C.next;
                do {
                    if ((B.tag & h) === h) {
                        var S = B.create;
                        B.destroy = S();
                    }
                    B = B.next;
                }while (B !== C);
            }
        }
        function Yu(h) {
            var C = h.ref;
            if (C !== null) {
                var B = h.stateNode;
                switch(h.tag){
                    case 5:
                        h = te(B);
                        break;
                    default:
                        h = B;
                }
                typeof C == "function" ? C(h) : C.current = h;
            }
        }
        function nd(h, C, B) {
            if (bg && typeof bg.onCommitFiberUnmount == "function") try {
                bg.onCommitFiberUnmount(rp, C);
            } catch  {}
            switch(C.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    if (h = C.updateQueue, h !== null && (h = h.lastEffect, h !== null)) {
                        var S = h = h.next;
                        do {
                            var w = S, L = w.destroy;
                            w = w.tag, L !== void 0 && (w & 2 || w & 4) && Xh(C, B, L), S = S.next;
                        }while (S !== h);
                    }
                    break;
                case 1:
                    if (Tp(C, B), h = C.stateNode, typeof h.componentWillUnmount == "function") try {
                        h.props = C.memoizedProps, h.state = C.memoizedState, h.componentWillUnmount();
                    } catch (Q) {
                        Ws(C, B, Q);
                    }
                    break;
                case 5:
                    Tp(C, B);
                    break;
                case 4:
                    mn ? E0(h, C, B) : Qs && Qs && (C = C.stateNode.containerInfo, B = ph(C), dl(C, B));
            }
        }
        function Mp(h, C, B) {
            for(var S = C;;)if (nd(h, S, B), S.child === null || mn && S.tag === 4) {
                if (S === C) break;
                for(; S.sibling === null;){
                    if (S.return === null || S.return === C) return;
                    S = S.return;
                }
                S.sibling.return = S.return, S = S.sibling;
            } else S.child.return = S, S = S.child;
        }
        function sd(h) {
            var C = h.alternate;
            C !== null && (h.alternate = null, sd(C)), h.child = null, h.deletions = null, h.sibling = null, h.tag === 5 && (C = h.stateNode, C !== null && Dn(C)), h.stateNode = null, h.return = null, h.dependencies = null, h.memoizedProps = null, h.memoizedState = null, h.pendingProps = null, h.stateNode = null, h.updateQueue = null;
        }
        function Co(h) {
            return h.tag === 5 || h.tag === 3 || h.tag === 4;
        }
        function Ts(h) {
            e: for(;;){
                for(; h.sibling === null;){
                    if (h.return === null || Co(h.return)) return null;
                    h = h.return;
                }
                for(h.sibling.return = h.return, h = h.sibling; h.tag !== 5 && h.tag !== 6 && h.tag !== 18;){
                    if (h.flags & 2 || h.child === null || h.tag === 4) continue e;
                    h.child.return = h, h = h.child;
                }
                if (!(h.flags & 2)) return h.stateNode;
            }
        }
        function Ef(h) {
            if (mn) {
                e: {
                    for(var C = h.return; C !== null;){
                        if (Co(C)) break e;
                        C = C.return;
                    }
                    throw Error(a(160));
                }
                var B = C;
                switch(B.tag){
                    case 5:
                        C = B.stateNode, B.flags & 32 && (gt(C), B.flags &= -33), B = Ts(h), k0(h, B, C);
                        break;
                    case 3:
                    case 4:
                        C = B.stateNode.containerInfo, B = Ts(h), z0(h, B, C);
                        break;
                    default:
                        throw Error(a(161));
                }
            }
        }
        function z0(h, C, B) {
            var S = h.tag;
            if (S === 5 || S === 6) h = h.stateNode, C ? Li(B, h, C) : gc(B, h);
            else if (S !== 4 && (h = h.child, h !== null)) for(z0(h, C, B), h = h.sibling; h !== null;)z0(h, C, B), h = h.sibling;
        }
        function k0(h, C, B) {
            var S = h.tag;
            if (S === 5 || S === 6) h = h.stateNode, C ? Nt(B, h, C) : Gu(B, h);
            else if (S !== 4 && (h = h.child, h !== null)) for(k0(h, C, B), h = h.sibling; h !== null;)k0(h, C, B), h = h.sibling;
        }
        function E0(h, C, B) {
            for(var S = C, w = !1, L, Q;;){
                if (!w) {
                    w = S.return;
                    e: for(;;){
                        if (w === null) throw Error(a(160));
                        switch(L = w.stateNode, w.tag){
                            case 5:
                                Q = !1;
                                break e;
                            case 3:
                                L = L.containerInfo, Q = !0;
                                break e;
                            case 4:
                                L = L.containerInfo, Q = !0;
                                break e;
                        }
                        w = w.return;
                    }
                    w = !0;
                }
                if (S.tag === 5 || S.tag === 6) Mp(h, S, B), Q ? Bt(L, S.stateNode) : dr(L, S.stateNode);
                else if (S.tag === 18) Q ? Me(L, S.stateNode) : _e(L, S.stateNode);
                else if (S.tag === 4) {
                    if (S.child !== null) {
                        L = S.stateNode.containerInfo, Q = !0, S.child.return = S, S = S.child;
                        continue;
                    }
                } else if (nd(h, S, B), S.child !== null) {
                    S.child.return = S, S = S.child;
                    continue;
                }
                if (S === C) break;
                for(; S.sibling === null;){
                    if (S.return === null || S.return === C) return;
                    S = S.return, S.tag === 4 && (w = !1);
                }
                S.sibling.return = S.return, S = S.sibling;
            }
        }
        function zp(h, C) {
            if (mn) {
                switch(C.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        Gc(3, C, C.return), va(3, C), Gc(5, C, C.return);
                        return;
                    case 1:
                        return;
                    case 5:
                        var B = C.stateNode;
                        if (B != null) {
                            var S = C.memoizedProps;
                            h = h !== null ? h.memoizedProps : S;
                            var w = C.type, L = C.updateQueue;
                            C.updateQueue = null, L !== null && di(B, L, w, h, S, C);
                        }
                        return;
                    case 6:
                        if (C.stateNode === null) throw Error(a(162));
                        B = C.memoizedProps, lt(C.stateNode, h !== null ? h.memoizedProps : B, B);
                        return;
                    case 3:
                        Di && h !== null && h.memoizedState.isDehydrated && Ve(C.stateNode.containerInfo);
                        return;
                    case 12:
                        return;
                    case 13:
                        Nh(C);
                        return;
                    case 19:
                        Nh(C);
                        return;
                    case 17:
                        return;
                }
                throw Error(a(163));
            }
            switch(C.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Gc(3, C, C.return), va(3, C), Gc(5, C, C.return);
                    return;
                case 12:
                    return;
                case 13:
                    Nh(C);
                    return;
                case 19:
                    Nh(C);
                    return;
                case 3:
                    Di && h !== null && h.memoizedState.isDehydrated && Ve(C.stateNode.containerInfo);
                    break;
                case 22:
                case 23:
                    return;
            }
            e: if (Qs) {
                switch(C.tag){
                    case 1:
                    case 5:
                    case 6:
                        break e;
                    case 3:
                    case 4:
                        C = C.stateNode, dl(C.containerInfo, C.pendingChildren);
                        break e;
                }
                throw Error(a(163));
            }
        }
        function Nh(h) {
            var C = h.updateQueue;
            if (C !== null) {
                h.updateQueue = null;
                var B = h.stateNode;
                B === null && (B = h.stateNode = new HV()), C.forEach(function(S) {
                    var w = zh.bind(null, h, S);
                    B.has(S) || (B.add(S), S.then(w, w));
                });
            }
        }
        function XV(h, C) {
            for(ut = C; ut !== null;){
                C = ut;
                var B = C.deletions;
                if (B !== null) for(var S = 0; S < B.length; S++){
                    var w = B[S];
                    try {
                        var L = h;
                        mn ? E0(L, w, C) : Mp(L, w, C);
                        var Q = w.alternate;
                        Q !== null && (Q.return = null), w.return = null;
                    } catch (Zt) {
                        Ws(w, C, Zt);
                    }
                }
                if (B = C.child, C.subtreeFlags & 12854 && B !== null) B.return = C, ut = B;
                else for(; ut !== null;){
                    C = ut;
                    try {
                        var le = C.flags;
                        if (le & 32 && mn && gt(C.stateNode), le & 512) {
                            var We = C.alternate;
                            if (We !== null) {
                                var Oe = We.ref;
                                Oe !== null && (typeof Oe == "function" ? Oe(null) : Oe.current = null);
                            }
                        }
                        if (le & 8192) switch(C.tag){
                            case 13:
                                if (C.memoizedState !== null) {
                                    var bt = C.alternate;
                                    (bt === null || bt.memoizedState === null) && (Dp = Os());
                                }
                                break;
                            case 22:
                                var qt = C.memoizedState !== null, Yt = C.alternate, cn = Yt !== null && Yt.memoizedState !== null;
                                if (B = C, mn) {
                                    e: if (S = B, w = qt, L = null, mn) for(var Vt = S;;){
                                        if (Vt.tag === 5) {
                                            if (L === null) {
                                                L = Vt;
                                                var qs = Vt.stateNode;
                                                w ? yi(qs) : Je(Vt.stateNode, Vt.memoizedProps);
                                            }
                                        } else if (Vt.tag === 6) {
                                            if (L === null) {
                                                var qr = Vt.stateNode;
                                                w ? _i(qr) : vu(qr, Vt.memoizedProps);
                                            }
                                        } else if ((Vt.tag !== 22 && Vt.tag !== 23 || Vt.memoizedState === null || Vt === S) && Vt.child !== null) {
                                            Vt.child.return = Vt, Vt = Vt.child;
                                            continue;
                                        }
                                        if (Vt === S) break;
                                        for(; Vt.sibling === null;){
                                            if (Vt.return === null || Vt.return === S) break e;
                                            L === Vt && (L = null), Vt = Vt.return;
                                        }
                                        L === Vt && (L = null), Vt.sibling.return = Vt.return, Vt = Vt.sibling;
                                    }
                                }
                                if (qt && !cn && B.mode & 1) {
                                    ut = B;
                                    for(var be = B.child; be !== null;){
                                        for(B = ut = be; ut !== null;){
                                            S = ut;
                                            var ue = S.child;
                                            switch(S.tag){
                                                case 0:
                                                case 11:
                                                case 14:
                                                case 15:
                                                    Gc(4, S, S.return);
                                                    break;
                                                case 1:
                                                    Tp(S, S.return);
                                                    var ve = S.stateNode;
                                                    if (typeof ve.componentWillUnmount == "function") {
                                                        var rt = S.return;
                                                        try {
                                                            ve.props = S.memoizedProps, ve.state = S.memoizedState, ve.componentWillUnmount();
                                                        } catch (Zt) {
                                                            Ws(S, rt, Zt);
                                                        }
                                                    }
                                                    break;
                                                case 5:
                                                    Tp(S, S.return);
                                                    break;
                                                case 22:
                                                    if (S.memoizedState !== null) {
                                                        Lh(B);
                                                        continue;
                                                    }
                                            }
                                            ue !== null ? (ue.return = S, ut = ue) : Lh(B);
                                        }
                                        be = be.sibling;
                                    }
                                }
                        }
                        switch(le & 4102){
                            case 2:
                                Ef(C), C.flags &= -3;
                                break;
                            case 6:
                                Ef(C), C.flags &= -3, zp(C.alternate, C);
                                break;
                            case 4096:
                                C.flags &= -4097;
                                break;
                            case 4100:
                                C.flags &= -4097, zp(C.alternate, C);
                                break;
                            case 4:
                                zp(C.alternate, C);
                        }
                    } catch (Zt) {
                        Ws(C, C.return, Zt);
                    }
                    if (B = C.sibling, B !== null) {
                        B.return = C.return, ut = B;
                        break;
                    }
                    ut = C.return;
                }
            }
        }
        function NV(h, C, B) {
            ut = h, Jf(h);
        }
        function Jf(h, C, B) {
            for(var S = (h.mode & 1) !== 0; ut !== null;){
                var w = ut, L = w.child;
                if (w.tag === 22 && S) {
                    var Q = w.memoizedState !== null || id;
                    if (!Q) {
                        var le = w.alternate, We = le !== null && le.memoizedState !== null || zo;
                        le = id;
                        var Oe = zo;
                        if (id = Q, (zo = We) && !Oe) for(ut = w; ut !== null;)Q = ut, We = Q.child, Q.tag === 22 && Q.memoizedState !== null ? J0(w) : We !== null ? (We.return = Q, ut = We) : J0(w);
                        for(; L !== null;)ut = L, Jf(L), L = L.sibling;
                        ut = w, id = le, zo = Oe;
                    }
                    Ms(h);
                } else w.subtreeFlags & 8772 && L !== null ? (L.return = w, ut = L) : Ms(h);
            }
        }
        function Ms(h) {
            for(; ut !== null;){
                var C = ut;
                if (C.flags & 8772) {
                    var B = C.alternate;
                    try {
                        if (C.flags & 8772) switch(C.tag){
                            case 0:
                            case 11:
                            case 15:
                                zo || va(5, C);
                                break;
                            case 1:
                                var S = C.stateNode;
                                if (C.flags & 4 && !zo) {
                                    if (B === null) S.componentDidMount();
                                    else {
                                        var w = C.elementType === C.type ? B.memoizedProps : Fo(C.type, B.memoizedProps);
                                        S.componentDidUpdate(w, B.memoizedState, S.__reactInternalSnapshotBeforeUpdate);
                                    }
                                }
                                var L = C.updateQueue;
                                L !== null && Rf(C, L, S);
                                break;
                            case 3:
                                var Q = C.updateQueue;
                                if (Q !== null) {
                                    if (B = null, C.child !== null) switch(C.child.tag){
                                        case 5:
                                            B = te(C.child.stateNode);
                                            break;
                                        case 1:
                                            B = C.child.stateNode;
                                    }
                                    Rf(C, Q, B);
                                }
                                break;
                            case 5:
                                var le = C.stateNode;
                                B === null && C.flags & 4 && Mt(le, C.type, C.memoizedProps, C);
                                break;
                            case 6:
                                break;
                            case 4:
                                break;
                            case 12:
                                break;
                            case 13:
                                if (Di && C.memoizedState === null) {
                                    var We = C.alternate;
                                    if (We !== null) {
                                        var Oe = We.memoizedState;
                                        if (Oe !== null) {
                                            var bt = Oe.dehydrated;
                                            bt !== null && Re(bt);
                                        }
                                    }
                                }
                                break;
                            case 19:
                            case 17:
                            case 21:
                            case 22:
                            case 23:
                                break;
                            default:
                                throw Error(a(163));
                        }
                        zo || C.flags & 512 && Yu(C);
                    } catch (qt) {
                        Ws(C, C.return, qt);
                    }
                }
                if (C === h) {
                    ut = null;
                    break;
                }
                if (B = C.sibling, B !== null) {
                    B.return = C.return, ut = B;
                    break;
                }
                ut = C.return;
            }
        }
        function Lh(h) {
            for(; ut !== null;){
                var C = ut;
                if (C === h) {
                    ut = null;
                    break;
                }
                var B = C.sibling;
                if (B !== null) {
                    B.return = C.return, ut = B;
                    break;
                }
                ut = C.return;
            }
        }
        function J0(h) {
            for(; ut !== null;){
                var C = ut;
                try {
                    switch(C.tag){
                        case 0:
                        case 11:
                        case 15:
                            var B = C.return;
                            try {
                                va(4, C);
                            } catch (We) {
                                Ws(C, B, We);
                            }
                            break;
                        case 1:
                            var S = C.stateNode;
                            if (typeof S.componentDidMount == "function") {
                                var w = C.return;
                                try {
                                    S.componentDidMount();
                                } catch (We) {
                                    Ws(C, w, We);
                                }
                            }
                            var L = C.return;
                            try {
                                Yu(C);
                            } catch (We) {
                                Ws(C, L, We);
                            }
                            break;
                        case 5:
                            var Q = C.return;
                            try {
                                Yu(C);
                            } catch (We) {
                                Ws(C, Q, We);
                            }
                    }
                } catch (We) {
                    Ws(C, C.return, We);
                }
                if (C === h) {
                    ut = null;
                    break;
                }
                var le = C.sibling;
                if (le !== null) {
                    le.return = C.return, ut = le;
                    break;
                }
                ut = C.return;
            }
        }
        var vl = 0, Yh = 1, kp = 2, Ep = 3, Sl = 4;
        if (typeof Symbol == "function" && Symbol.for) {
            var Zs = Symbol.for;
            vl = Zs("selector.component"), Yh = Zs("selector.has_pseudo_class"), kp = Zs("selector.role"), Ep = Zs("selector.test_id"), Sl = Zs("selector.text");
        }
        function It(h) {
            var C = kr(h);
            if (C != null) {
                if (typeof C.memoizedProps["data-testname"] != "string") throw Error(a(364));
                return C;
            }
            if (h = cs(h), h === null) throw Error(a(362));
            return h.stateNode.current;
        }
        function po(h, C) {
            switch(C.$$typeof){
                case vl:
                    if (h.type === C.value) return !0;
                    break;
                case Yh:
                    e: {
                        C = C.value, h = [
                            h,
                            0
                        ];
                        for(var B = 0; B < h.length;){
                            var S = h[B++], w = h[B++], L = C[w];
                            if (S.tag !== 5 || !pg(S)) {
                                for(; L != null && po(S, L);)w++, L = C[w];
                                if (w === C.length) {
                                    C = !0;
                                    break e;
                                } else for(S = S.child; S !== null;)h.push(S, w), S = S.sibling;
                            }
                        }
                        C = !1;
                    }
                    return C;
                case kp:
                    if (h.tag === 5 && Il(h.stateNode, C.value)) return !0;
                    break;
                case Sl:
                    if ((h.tag === 5 || h.tag === 6) && (h = Bu(h), h !== null && 0 <= h.indexOf(C.value))) return !0;
                    break;
                case Ep:
                    if (h.tag === 5 && (h = h.memoizedProps["data-testname"], typeof h == "string" && h.toLowerCase() === C.value.toLowerCase())) return !0;
                    break;
                default:
                    throw Error(a(365));
            }
            return !1;
        }
        function Da(h) {
            switch(h.$$typeof){
                case vl:
                    return "<" + (z(h.value) || "Unknown") + ">";
                case Yh:
                    return ":has(" + (Da(h) || "") + ")";
                case kp:
                    return '[role="' + h.value + '"]';
                case Sl:
                    return '"' + h.value + '"';
                case Ep:
                    return '[data-testname="' + h.value + '"]';
                default:
                    throw Error(a(365));
            }
        }
        function Uf(h, C) {
            var B = [];
            h = [
                h,
                0
            ];
            for(var S = 0; S < h.length;){
                var w = h[S++], L = h[S++], Q = C[L];
                if (w.tag !== 5 || !pg(w)) {
                    for(; Q != null && po(w, Q);)L++, Q = C[L];
                    if (L === C.length) B.push(w);
                    else for(w = w.child; w !== null;)h.push(w, L), w = w.sibling;
                }
            }
            return B;
        }
        function U0(h, C) {
            if (!ka) throw Error(a(363));
            h = It(h), h = Uf(h, C), C = [], h = Array.from(h);
            for(var B = 0; B < h.length;){
                var S = h[B++];
                if (S.tag === 5) pg(S) || C.push(S.stateNode);
                else for(S = S.child; S !== null;)h.push(S), S = S.sibling;
            }
            return C;
        }
        var LV = Math.ceil, Jp = o.ReactCurrentDispatcher, D0 = o.ReactCurrentOwner, fi = o.ReactCurrentBatchConfig, pi = 0, Rs = null, Vs = null, js = 0, mr = 0, ko = Hi(0), zs = 0, Kh = null, rd = 0, Up = 0, _0 = 0, xh = null, Pr = null, Dp = 0, P0 = 1 / 0;
        function ad() {
            P0 = Os() + 500;
        }
        var _p = !1, Q0 = null, vc = null, Pp = !1, Zl = null, Qp = 0, od = 0, O0 = null, Op = -1, gd = 0;
        function Qr() {
            return pi & 6 ? Os() : Op !== -1 ? Op : Op = Os();
        }
        function ks(h) {
            return h.mode & 1 ? pi & 2 && js !== 0 ? js & -js : wV.transition !== null ? (gd === 0 && (h = sp, sp <<= 1, !(sp & 4194240) && (sp = 64), gd = h), gd) : (h = ji, h !== 0 ? h : za()) : 1;
        }
        function ws(h, C, B) {
            if (50 < od) throw od = 0, O0 = null, Error(a(185));
            var S = ld(h, C);
            return S === null ? null : (yh(S, C, B), (!(pi & 2) || S !== Rs) && (S === Rs && (!(pi & 2) && (Up |= C), zs === 4 && Rl(S, js)), Nr(S, B), C === 1 && pi === 0 && !(h.mode & 1) && (ad(), ap && fg())), S);
        }
        function ld(h, C) {
            h.lanes |= C;
            var B = h.alternate;
            for(B !== null && (B.lanes |= C), B = h, h = h.return; h !== null;)h.childLanes |= C, B = h.alternate, B !== null && (B.childLanes |= C), B = h, h = h.return;
            return B.tag === 3 ? B.stateNode : null;
        }
        function Nr(h, C) {
            var B = h.callbackNode;
            yV(h, C);
            var S = Wr(h, h === Rs ? js : 0);
            if (S === 0) B !== null && TI(B), h.callbackNode = null, h.callbackPriority = 0;
            else if (C = S & -S, h.callbackPriority !== C) {
                if (B != null && TI(B), C === 1) h.tag === 0 ? VV(Df.bind(null, h)) : Gf(Df.bind(null, h)), Er ? Cg(function() {
                    pi === 0 && fg();
                }) : m0(A0, fg), B = null;
                else {
                    switch(ff(S)){
                        case 1:
                            B = A0;
                            break;
                        case 4:
                            B = vV;
                            break;
                        case 16:
                            B = b0;
                            break;
                        case 536870912:
                            B = SV;
                            break;
                        default:
                            B = b0;
                    }
                    B = Id(B, j0.bind(null, h));
                }
                h.callbackPriority = C, h.callbackNode = B;
            }
        }
        function j0(h, C) {
            if (Op = -1, gd = 0, pi & 6) throw Error(a(327));
            var B = h.callbackNode;
            if (br() && h.callbackNode !== B) return null;
            var S = Wr(h, h === Rs ? js : 0);
            if (S === 0) return null;
            if (S & 30 || S & h.expiredLanes || C) C = Or(h, S);
            else {
                C = S;
                var w = pi;
                pi |= 2;
                var L = eb();
                (Rs !== h || js !== C) && (ad(), wg(h, C));
                for(;;)try {
                    YV();
                    break;
                } catch (le) {
                    Pf(h, le);
                }
                f0(), Jp.current = L, pi = w, Vs !== null ? C = 0 : (Rs = null, js = 0, C = zs);
            }
            if (C !== 0) {
                if (C === 2 && (w = C0(h), w !== 0 && (S = w, C = q0(h, w))), C === 1) throw B = Kh, wg(h, 0), Rl(h, S), Nr(h, Os()), B;
                if (C === 6) Rl(h, S);
                else {
                    if (w = h.current.alternate, !(S & 30) && !Vg(w) && (C = Or(h, S), C === 2 && (L = C0(h), L !== 0 && (S = L, C = q0(h, L))), C === 1)) throw B = Kh, wg(h, 0), Rl(h, S), Nr(h, Os()), B;
                    switch(h.finishedWork = w, h.finishedLanes = S, C){
                        case 0:
                        case 1:
                            throw Error(a(345));
                        case 2:
                            Fn(h, Pr);
                            break;
                        case 3:
                            if (Rl(h, S), (S & 130023424) === S && (C = Dp + 500 - Os(), 10 < C)) {
                                if (Wr(h, 0) !== 0) break;
                                if (w = h.suspendedLanes, (w & S) !== S) {
                                    Qr(), h.pingedLanes |= h.suspendedLanes & w;
                                    break;
                                }
                                h.timeoutHandle = Xt(Fn.bind(null, h, Pr), C);
                                break;
                            }
                            Fn(h, Pr);
                            break;
                        case 4:
                            if (Rl(h, S), (S & 4194240) === S) break;
                            for(C = h.eventTimes, w = -1; 0 < S;){
                                var Q = 31 - Hn(S);
                                L = 1 << Q, Q = C[Q], Q > w && (w = Q), S &= ~L;
                            }
                            if (S = w, S = Os() - S, S = (120 > S ? 120 : 480 > S ? 480 : 1080 > S ? 1080 : 1920 > S ? 1920 : 3e3 > S ? 3e3 : 4320 > S ? 4320 : 1960 * LV(S / 1960)) - S, 10 < S) {
                                h.timeoutHandle = Xt(Fn.bind(null, h, Pr), S);
                                break;
                            }
                            Fn(h, Pr);
                            break;
                        case 5:
                            Fn(h, Pr);
                            break;
                        default:
                            throw Error(a(329));
                    }
                }
            }
            return Nr(h, Os()), h.callbackNode === B ? j0.bind(null, h) : null;
        }
        function q0(h, C) {
            var B = xh;
            return h.current.memoizedState.isDehydrated && (wg(h, C).flags |= 256), h = Or(h, C), h !== 2 && (C = Pr, Pr = B, C !== null && jp(C)), h;
        }
        function jp(h) {
            Pr === null ? Pr = h : Pr.push.apply(Pr, h);
        }
        function Vg(h) {
            for(var C = h;;){
                if (C.flags & 16384) {
                    var B = C.updateQueue;
                    if (B !== null && (B = B.stores, B !== null)) for(var S = 0; S < B.length; S++){
                        var w = B[S], L = w.getSnapshot;
                        w = w.value;
                        try {
                            if (!yg(L(), w)) return !1;
                        } catch  {
                            return !1;
                        }
                    }
                }
                if (B = C.child, C.subtreeFlags & 16384 && B !== null) B.return = C, C = B;
                else {
                    if (C === h) break;
                    for(; C.sibling === null;){
                        if (C.return === null || C.return === h) return !0;
                        C = C.return;
                    }
                    C.sibling.return = C.return, C = C.sibling;
                }
            }
            return !0;
        }
        function Rl(h, C) {
            for(C &= ~_0, C &= ~Up, h.suspendedLanes |= C, h.pingedLanes &= ~C, h = h.expirationTimes; 0 < C;){
                var B = 31 - Hn(C), S = 1 << B;
                h[B] = -1, C &= ~S;
            }
        }
        function Df(h) {
            if (pi & 6) throw Error(a(327));
            br();
            var C = Wr(h, 0);
            if (!(C & 1)) return Nr(h, Os()), null;
            var B = Or(h, C);
            if (h.tag !== 0 && B === 2) {
                var S = C0(h);
                S !== 0 && (C = S, B = q0(h, S));
            }
            if (B === 1) throw B = Kh, wg(h, 0), Rl(h, C), Nr(h, Os()), B;
            if (B === 6) throw Error(a(345));
            return h.finishedWork = h.current.alternate, h.finishedLanes = C, Fn(h, Pr), Nr(h, Os()), null;
        }
        function _f(h) {
            Zl !== null && Zl.tag === 0 && !(pi & 6) && br();
            var C = pi;
            pi |= 1;
            var B = fi.transition, S = ji;
            try {
                if (fi.transition = null, ji = 1, h) return h();
            } finally{
                ji = S, fi.transition = B, pi = C, !(pi & 6) && fg();
            }
        }
        function $0() {
            mr = ko.current, Ot(ko);
        }
        function wg(h, C) {
            h.finishedWork = null, h.finishedLanes = 0;
            var B = h.timeoutHandle;
            if (B !== Jn && (h.timeoutHandle = Jn, Mi(B)), Vs !== null) for(B = Vs.return; B !== null;){
                var S = B;
                switch(hp(S), S.tag){
                    case 1:
                        S = S.type.childContextTypes, S != null && xs();
                        break;
                    case 3:
                        Bl(), Ot(oi), Ot(Bn), Ur();
                        break;
                    case 5:
                        Sg(S);
                        break;
                    case 4:
                        Bl();
                        break;
                    case 13:
                        Ot(Bi);
                        break;
                    case 19:
                        Ot(Bi);
                        break;
                    case 10:
                        op(S.type._context);
                        break;
                    case 22:
                    case 23:
                        $0();
                }
                B = B.return;
            }
            if (Rs = h, Vs = h = Vl(h.current, null), js = mr = C, zs = 0, Kh = null, _0 = Up = rd = 0, Pr = xh = null, Gg !== null) {
                for(C = 0; C < Gg.length; C++)if (B = Gg[C], S = B.interleaved, S !== null) {
                    B.interleaved = null;
                    var w = S.next, L = B.pending;
                    if (L !== null) {
                        var Q = L.next;
                        L.next = w, S.next = Q;
                    }
                    B.pending = S;
                }
                Gg = null;
            }
            return h;
        }
        function Pf(h, C) {
            do {
                var B = Vs;
                try {
                    if (f0(), Io.current = qI, wu) {
                        for(var S = fn.memoizedState; S !== null;){
                            var w = S.queue;
                            w !== null && (w.pending = null), S = S.next;
                        }
                        wu = !1;
                    }
                    if (Cc = 0, _n = Cr = fn = null, fa = !1, pc = 0, D0.current = null, B === null || B.return === null) {
                        zs = 1, Kh = C, Vs = null;
                        break;
                    }
                    e: {
                        var L = h, Q = B.return, le = B, We = C;
                        if (C = js, le.flags |= 32768, We !== null && typeof We == "object" && typeof We.then == "function") {
                            var Oe = We, bt = le, qt = bt.tag;
                            if (!(bt.mode & 1) && (qt === 0 || qt === 11 || qt === 15)) {
                                var Yt = bt.alternate;
                                Yt ? (bt.updateQueue = Yt.updateQueue, bt.memoizedState = Yt.memoizedState, bt.lanes = Yt.lanes) : (bt.updateQueue = null, bt.memoizedState = null);
                            }
                            var cn = Wp(Q);
                            if (cn !== null) {
                                cn.flags &= -257, F0(cn, Q, le, L, C), cn.mode & 1 && wp(L, Oe, C), C = cn, We = Oe;
                                var Vt = C.updateQueue;
                                if (Vt === null) {
                                    var qs = /* @__PURE__ */ new Set();
                                    qs.add(We), C.updateQueue = qs;
                                } else Vt.add(We);
                                break e;
                            } else {
                                if (!(C & 1)) {
                                    wp(L, Oe, C), qp();
                                    break e;
                                }
                                We = Error(a(426));
                            }
                        } else if (Xn && le.mode & 1) {
                            var qr = Wp(Q);
                            if (qr !== null) {
                                !(qr.flags & 65536) && (qr.flags |= 256), F0(qr, Q, le, L, C), UI(We);
                                break e;
                            }
                        }
                        L = We, zs !== 4 && (zs = 2), xh === null ? xh = [
                            L
                        ] : xh.push(L), We = wh(We, le), le = Q;
                        do {
                            switch(le.tag){
                                case 3:
                                    le.flags |= 65536, C &= -C, le.lanes |= C;
                                    var be = Rp(le, We, C);
                                    v0(le, be);
                                    break e;
                                case 1:
                                    L = We;
                                    var ue = le.type, ve = le.stateNode;
                                    if (!(le.flags & 128) && (typeof ue.getDerivedStateFromError == "function" || ve !== null && typeof ve.componentDidCatch == "function" && (vc === null || !vc.has(ve)))) {
                                        le.flags |= 65536, C &= -C, le.lanes |= C;
                                        var rt = Vp(le, L, C);
                                        v0(le, rt);
                                        break e;
                                    }
                            }
                            le = le.return;
                        }while (le !== null);
                    }
                    Ar(B);
                } catch (Zt) {
                    C = Zt, Vs === B && B !== null && (Vs = B = B.return);
                    continue;
                }
                break;
            }while (!0);
        }
        function eb() {
            var h = Jp.current;
            return Jp.current = qI, h === null ? qI : h;
        }
        function qp() {
            (zs === 0 || zs === 3 || zs === 2) && (zs = 4), Rs === null || !(rd & 268435455) && !(Up & 268435455) || Rl(Rs, js);
        }
        function Or(h, C) {
            var B = pi;
            pi |= 2;
            var S = eb();
            Rs === h && js === C || wg(h, C);
            for(;;)try {
                Fh();
                break;
            } catch (w) {
                Pf(h, w);
            }
            if (f0(), pi = B, Jp.current = S, Vs !== null) throw Error(a(261));
            return Rs = null, js = 0, zs;
        }
        function Fh() {
            for(; Vs !== null;)Qf(Vs);
        }
        function YV() {
            for(; Vs !== null && !fV();)Qf(Vs);
        }
        function Qf(h) {
            var C = ud(h.alternate, h, mr);
            h.memoizedProps = h.pendingProps, C === null ? Ar(h) : Vs = C, D0.current = null;
        }
        function Ar(h) {
            var C = h;
            do {
                var B = C.alternate;
                if (h = C.return, C.flags & 32768) {
                    if (B = WV(B, C), B !== null) {
                        B.flags &= 32767, Vs = B;
                        return;
                    }
                    if (h !== null) h.flags |= 32768, h.subtreeFlags = 0, h.deletions = null;
                    else {
                        zs = 6, Vs = null;
                        return;
                    }
                } else if (B = Wh(B, C, mr), B !== null) {
                    Vs = B;
                    return;
                }
                if (C = C.sibling, C !== null) {
                    Vs = C;
                    return;
                }
                Vs = C = h;
            }while (C !== null);
            zs === 0 && (zs = 5);
        }
        function Fn(h, C) {
            var B = ji, S = fi.transition;
            try {
                fi.transition = null, ji = 1, Wg(h, C, B);
            } finally{
                fi.transition = S, ji = B;
            }
            return null;
        }
        function Wg(h, C, B) {
            do br();
            while (Zl !== null);
            if (pi & 6) throw Error(a(327));
            var S = h.finishedWork, w = h.finishedLanes;
            if (S === null) return null;
            if (h.finishedWork = null, h.finishedLanes = 0, S === h.current) throw Error(a(177));
            h.callbackNode = null, h.callbackPriority = 0;
            var L = S.lanes | S.childLanes;
            if (BV(h, L), h === Rs && (Vs = Rs = null, js = 0), !(S.subtreeFlags & 2064) && !(S.flags & 2064) || Pp || (Pp = !0, Id(b0, function() {
                return br(), null;
            })), L = (S.flags & 15990) !== 0, S.subtreeFlags & 15990 || L) {
                L = fi.transition, fi.transition = null;
                var Q = ji;
                ji = 1;
                var le = pi;
                pi |= 4, D0.current = null, kf(h, S), XV(h, S), ge(h.containerInfo), h.current = S, NV(S), GV(), pi = le, ji = Q, fi.transition = L;
            } else h.current = S;
            if (Pp && (Pp = !1, Zl = h, Qp = w), L = h.pendingLanes, L === 0 && (vc = null), ZV(S.stateNode), Nr(h, Os()), C !== null) for(B = h.onRecoverableError, S = 0; S < C.length; S++)B(C[S]);
            if (_p) throw _p = !1, h = Q0, Q0 = null, h;
            return Qp & 1 && h.tag !== 0 && br(), L = h.pendingLanes, L & 1 ? h === O0 ? od++ : (od = 0, O0 = h) : od = 0, fg(), null;
        }
        function br() {
            if (Zl !== null) {
                var h = ff(Qp), C = fi.transition, B = ji;
                try {
                    if (fi.transition = null, ji = 16 > h ? 16 : h, Zl === null) var S = !1;
                    else {
                        if (h = Zl, Zl = null, Qp = 0, pi & 6) throw Error(a(331));
                        var w = pi;
                        for(pi |= 4, ut = h.current; ut !== null;){
                            var L = ut, Q = L.child;
                            if (ut.flags & 16) {
                                var le = L.deletions;
                                if (le !== null) {
                                    for(var We = 0; We < le.length; We++){
                                        var Oe = le[We];
                                        for(ut = Oe; ut !== null;){
                                            var bt = ut;
                                            switch(bt.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                    Gc(8, bt, L);
                                            }
                                            var qt = bt.child;
                                            if (qt !== null) qt.return = bt, ut = qt;
                                            else for(; ut !== null;){
                                                bt = ut;
                                                var Yt = bt.sibling, cn = bt.return;
                                                if (sd(bt), bt === Oe) {
                                                    ut = null;
                                                    break;
                                                }
                                                if (Yt !== null) {
                                                    Yt.return = cn, ut = Yt;
                                                    break;
                                                }
                                                ut = cn;
                                            }
                                        }
                                    }
                                    var Vt = L.alternate;
                                    if (Vt !== null) {
                                        var qs = Vt.child;
                                        if (qs !== null) {
                                            Vt.child = null;
                                            do {
                                                var qr = qs.sibling;
                                                qs.sibling = null, qs = qr;
                                            }while (qs !== null);
                                        }
                                    }
                                    ut = L;
                                }
                            }
                            if (L.subtreeFlags & 2064 && Q !== null) Q.return = L, ut = Q;
                            else e: for(; ut !== null;){
                                if (L = ut, L.flags & 2048) switch(L.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Gc(9, L, L.return);
                                }
                                var be = L.sibling;
                                if (be !== null) {
                                    be.return = L.return, ut = be;
                                    break e;
                                }
                                ut = L.return;
                            }
                        }
                        var ue = h.current;
                        for(ut = ue; ut !== null;){
                            Q = ut;
                            var ve = Q.child;
                            if (Q.subtreeFlags & 2064 && ve !== null) ve.return = Q, ut = ve;
                            else e: for(Q = ue; ut !== null;){
                                if (le = ut, le.flags & 2048) try {
                                    switch(le.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            va(9, le);
                                    }
                                } catch (Zt) {
                                    Ws(le, le.return, Zt);
                                }
                                if (le === Q) {
                                    ut = null;
                                    break e;
                                }
                                var rt = le.sibling;
                                if (rt !== null) {
                                    rt.return = le.return, ut = rt;
                                    break e;
                                }
                                ut = le.return;
                            }
                        }
                        if (pi = w, fg(), bg && typeof bg.onPostCommitFiberRoot == "function") try {
                            bg.onPostCommitFiberRoot(rp, h);
                        } catch  {}
                        S = !0;
                    }
                    return S;
                } finally{
                    ji = B, fi.transition = C;
                }
            }
            return !1;
        }
        function Of(h, C, B) {
            C = wh(B, C), C = Rp(h, C, 1), dc(h, C), C = Qr(), h = ld(h, 1), h !== null && (yh(h, 1, C), Nr(h, C));
        }
        function Ws(h, C, B) {
            if (h.tag === 3) Of(h, h, B);
            else for(; C !== null;){
                if (C.tag === 3) {
                    Of(C, h, B);
                    break;
                } else if (C.tag === 1) {
                    var S = C.stateNode;
                    if (typeof C.type.getDerivedStateFromError == "function" || typeof S.componentDidCatch == "function" && (vc === null || !vc.has(S))) {
                        h = wh(B, h), h = Vp(C, h, 1), dc(C, h), h = Qr(), C = ld(C, 1), C !== null && (yh(C, 1, h), Nr(C, h));
                        break;
                    }
                }
                C = C.return;
            }
        }
        function Th(h, C, B) {
            var S = h.pingCache;
            S !== null && S.delete(C), C = Qr(), h.pingedLanes |= h.suspendedLanes & B, Rs === h && (js & B) === B && (zs === 4 || zs === 3 && (js & 130023424) === js && 500 > Os() - Dp ? wg(h, 0) : _0 |= B), Nr(h, C);
        }
        function cd(h, C) {
            C === 0 && (h.mode & 1 ? (C = ba, ba <<= 1, !(ba & 130023424) && (ba = 4194304)) : C = 1);
            var B = Qr();
            h = ld(h, C), h !== null && (yh(h, C, B), Nr(h, B));
        }
        function Mh(h) {
            var C = h.memoizedState, B = 0;
            C !== null && (B = C.retryLane), cd(h, B);
        }
        function zh(h, C) {
            var B = 0;
            switch(h.tag){
                case 13:
                    var S = h.stateNode, w = h.memoizedState;
                    w !== null && (B = w.retryLane);
                    break;
                case 19:
                    S = h.stateNode;
                    break;
                default:
                    throw Error(a(314));
            }
            S !== null && S.delete(C), cd(h, B);
        }
        var ud;
        ud = function(h, C, B) {
            if (h !== null) {
                if (h.memoizedProps !== C.pendingProps || oi.current) Ua = !0;
                else {
                    if (!(h.lanes & B) && !(C.flags & 128)) return Ua = !1, Gx(h, C, B);
                    Ua = !!(h.flags & 131072);
                }
            } else Ua = !1, Xn && C.flags & 1048576 && EI(C, Ip, C.index);
            switch(C.lanes = 0, C.tag){
                case 2:
                    var S = C.type;
                    h !== null && (h.alternate = null, C.alternate = null, C.flags |= 2), h = C.pendingProps;
                    var w = wr(C, Bn.current);
                    MI(C, B), w = OI(null, C, S, h, w, B);
                    var L = bp();
                    return C.flags |= 1, typeof w == "object" && w !== null && typeof w.render == "function" && w.$$typeof === void 0 ? (C.tag = 1, C.memoizedState = null, C.updateQueue = null, fs(S) ? (L = !0, en(C)) : L = !1, C.memoizedState = w.state !== null && w.state !== void 0 ? w.state : null, G0(C), w.updater = cp, C.stateNode = w, w._reactInternals = C, Z0(C, S, h, B), C = td(null, C, S, !0, L, B)) : (C.tag = 0, Xn && L && dp(C), _r(null, C, w, B), C = C.child), C;
                case 16:
                    S = C.elementType;
                    e: {
                        switch(h !== null && (h.alternate = null, C.alternate = null, C.flags |= 2), h = C.pendingProps, w = S._init, S = w(S._payload), C.type = S, w = C.tag = jf(S), h = Fo(S, h), w){
                            case 0:
                                C = Yp(null, C, S, h, B);
                                break e;
                            case 1:
                                C = Tf(null, C, S, h, B);
                                break e;
                            case 11:
                                C = Kf(null, C, S, h, B);
                                break e;
                            case 14:
                                C = xf(null, C, S, Fo(S.type, h), B);
                                break e;
                        }
                        throw Error(a(306, S, ""));
                    }
                    return C;
                case 0:
                    return S = C.type, w = C.pendingProps, w = C.elementType === S ? w : Fo(S, w), Yp(h, C, S, w, B);
                case 1:
                    return S = C.type, w = C.pendingProps, w = C.elementType === S ? w : Fo(S, w), Tf(h, C, S, w, B);
                case 3:
                    e: {
                        if (Mf(C), h === null) throw Error(a(387));
                        S = C.pendingProps, L = C.memoizedState, w = L.element, Zf(h, C), lp(C, S, null, B);
                        var Q = C.memoizedState;
                        if (S = Q.element, Di && L.isDehydrated) {
                            if (L = {
                                element: S,
                                isDehydrated: !1,
                                cache: Q.cache,
                                transitions: Q.transitions
                            }, C.updateQueue.baseState = L, C.memoizedState = L, C.flags & 256) {
                                w = Error(a(423)), C = M0(h, C, S, B, w);
                                break e;
                            } else if (S !== w) {
                                w = Error(a(424)), C = M0(h, C, S, B, w);
                                break e;
                            } else for(Di && (Ba = Ah(C.stateNode.containerInfo), ya = C, Xn = !0, co = null, JI = !1), B = mp(C, null, S, B), C.child = B; B;)B.flags = B.flags & -3 | 4096, B = B.sibling;
                        } else {
                            if (hc(), S === w) {
                                C = Rg(h, C, B);
                                break e;
                            }
                            _r(h, C, S, B);
                        }
                        C = C.child;
                    }
                    return C;
                case 5:
                    return vg(C), h === null && Sh(C), S = C.type, w = C.pendingProps, L = h !== null ? h.memoizedProps : null, Q = w.children, ct(S, w) ? Q = null : L !== null && ct(S, L) && (C.flags |= 32), Lp(h, C), _r(h, C, Q, B), C.child;
                case 6:
                    return h === null && Sh(C), null;
                case 13:
                    return Bc(h, C, B);
                case 4:
                    return Rh(C, C.stateNode.containerInfo), S = C.pendingProps, h === null ? C.child = _I(C, null, S, B) : _r(h, C, S, B), C.child;
                case 11:
                    return S = C.type, w = C.pendingProps, w = C.elementType === S ? w : Fo(S, w), Kf(h, C, S, w, B);
                case 7:
                    return _r(h, C, C.pendingProps, B), C.child;
                case 8:
                    return _r(h, C, C.pendingProps.children, B), C.child;
                case 12:
                    return _r(h, C, C.pendingProps.children, B), C.child;
                case 10:
                    e: {
                        if (S = C.type._context, w = C.pendingProps, L = C.memoizedProps, Q = w.value, Sf(C, S, Q), L !== null) {
                            if (yg(L.value, Q)) {
                                if (L.children === w.children && !oi.current) {
                                    C = Rg(h, C, B);
                                    break e;
                                }
                            } else for(L = C.child, L !== null && (L.return = C); L !== null;){
                                var le = L.dependencies;
                                if (le !== null) {
                                    Q = L.child;
                                    for(var We = le.firstContext; We !== null;){
                                        if (We.context === S) {
                                            if (L.tag === 1) {
                                                We = ml(-1, B & -B), We.tag = 2;
                                                var Oe = L.updateQueue;
                                                if (Oe !== null) {
                                                    Oe = Oe.shared;
                                                    var bt = Oe.pending;
                                                    bt === null ? We.next = We : (We.next = bt.next, bt.next = We), Oe.pending = We;
                                                }
                                            }
                                            L.lanes |= B, We = L.alternate, We !== null && (We.lanes |= B), vh(L.return, B, C), le.lanes |= B;
                                            break;
                                        }
                                        We = We.next;
                                    }
                                } else if (L.tag === 10) Q = L.type === C.type ? null : L.child;
                                else if (L.tag === 18) {
                                    if (Q = L.return, Q === null) throw Error(a(341));
                                    Q.lanes |= B, le = Q.alternate, le !== null && (le.lanes |= B), vh(Q, B, C), Q = L.sibling;
                                } else Q = L.child;
                                if (Q !== null) Q.return = L;
                                else for(Q = L; Q !== null;){
                                    if (Q === C) {
                                        Q = null;
                                        break;
                                    }
                                    if (L = Q.sibling, L !== null) {
                                        L.return = Q.return, Q = L;
                                        break;
                                    }
                                    Q = Q.return;
                                }
                                L = Q;
                            }
                        }
                        _r(h, C, w.children, B), C = C.child;
                    }
                    return C;
                case 9:
                    return w = C.type, S = C.pendingProps.children, MI(C, B), w = Jr(w), S = S(w), C.flags |= 1, _r(h, C, S, B), C.child;
                case 14:
                    return S = C.type, w = Fo(S, C.pendingProps), w = Fo(S.type, w), xf(h, C, S, w, B);
                case 15:
                    return Np(h, C, C.type, C.pendingProps, B);
                case 17:
                    return S = C.type, w = C.pendingProps, w = C.elementType === S ? w : Fo(S, w), h !== null && (h.alternate = null, C.alternate = null, C.flags |= 2), C.tag = 1, fs(S) ? (h = !0, en(C)) : h = !1, MI(C, B), Wf(C, S, w), Z0(C, S, w, B), td(null, C, S, !0, h, B);
                case 19:
                    return Hh(h, C, B);
                case 22:
                    return Ff(h, C, B);
            }
            throw Error(a(156, C.tag));
        };
        function Id(h, C) {
            return m0(h, C);
        }
        function Ku(h, C, B, S) {
            this.tag = h, this.key = B, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = C, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = S, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
        }
        function jr(h, C, B, S) {
            return new Ku(h, C, B, S);
        }
        function $p(h) {
            return h = h.prototype, !(!h || !h.isReactComponent);
        }
        function jf(h) {
            if (typeof h == "function") return $p(h) ? 1 : 0;
            if (h != null) {
                if (h = h.$$typeof, h === G) return 11;
                if (h === V) return 14;
            }
            return 2;
        }
        function Vl(h, C) {
            var B = h.alternate;
            return B === null ? (B = jr(h.tag, C, h.key, h.mode), B.elementType = h.elementType, B.type = h.type, B.stateNode = h.stateNode, B.alternate = h, h.alternate = B) : (B.pendingProps = C, B.type = h.type, B.flags = 0, B.subtreeFlags = 0, B.deletions = null), B.flags = h.flags & 14680064, B.childLanes = h.childLanes, B.lanes = h.lanes, B.child = h.child, B.memoizedProps = h.memoizedProps, B.memoizedState = h.memoizedState, B.updateQueue = h.updateQueue, C = h.dependencies, B.dependencies = C === null ? null : {
                lanes: C.lanes,
                firstContext: C.firstContext
            }, B.sibling = h.sibling, B.index = h.index, B.ref = h.ref, B;
        }
        function dd(h, C, B, S, w, L) {
            var Q = 2;
            if (S = h, typeof h == "function") $p(h) && (Q = 1);
            else if (typeof h == "string") Q = 5;
            else e: switch(h){
                case c:
                    return xu(B.children, w, L, C);
                case d:
                    Q = 8, w |= 8;
                    break;
                case p:
                    return h = jr(12, B, C, w | 2), h.elementType = p, h.lanes = L, h;
                case Z:
                    return h = jr(13, B, C, w), h.elementType = Z, h.lanes = L, h;
                case v:
                    return h = jr(19, B, C, w), h.elementType = v, h.lanes = L, h;
                case N:
                    return em(B, w, L, C);
                default:
                    if (typeof h == "object" && h !== null) switch(h.$$typeof){
                        case A:
                            Q = 10;
                            break e;
                        case y:
                            Q = 9;
                            break e;
                        case G:
                            Q = 11;
                            break e;
                        case V:
                            Q = 14;
                            break e;
                        case H:
                            Q = 16, S = null;
                            break e;
                    }
                    throw Error(a(130, h == null ? h : typeof h, ""));
            }
            return C = jr(Q, B, C, w), C.elementType = h, C.type = S, C.lanes = L, C;
        }
        function xu(h, C, B, S) {
            return h = jr(7, h, S, C), h.lanes = B, h;
        }
        function em(h, C, B, S) {
            return h = jr(22, h, S, C), h.elementType = N, h.lanes = B, h.stateNode = {}, h;
        }
        function _a(h, C, B) {
            return h = jr(6, h, null, C), h.lanes = B, h;
        }
        function hd(h, C, B) {
            return C = jr(4, h.children !== null ? h.children : [], h.key, C), C.lanes = B, C.stateNode = {
                containerInfo: h.containerInfo,
                pendingChildren: null,
                implementation: h.implementation
            }, C;
        }
        function kh(h, C, B, S, w) {
            this.tag = C, this.containerInfo = h, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = Jn, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = p0(0), this.expirationTimes = p0(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = p0(0), this.identifierPrefix = S, this.onRecoverableError = w, Di && (this.mutableSourceEagerHydrationData = null);
        }
        function Eh(h, C, B, S, w, L, Q, le, We) {
            return h = new kh(h, C, B, le, We), C === 1 ? (C = 1, L === !0 && (C |= 8)) : C = 0, L = jr(3, null, null, C), h.current = L, L.stateNode = h, L.memoizedState = {
                element: S,
                isDehydrated: B,
                cache: null,
                transitions: null
            }, G0(L), h;
        }
        function Fu(h) {
            if (!h) return Si;
            h = h._reactInternals;
            e: {
                if (_(h) !== h || h.tag !== 1) throw Error(a(170));
                var C = h;
                do {
                    switch(C.tag){
                        case 3:
                            C = C.stateNode.context;
                            break e;
                        case 1:
                            if (fs(C.type)) {
                                C = C.stateNode.__reactInternalMemoizedMergedChildContext;
                                break e;
                            }
                    }
                    C = C.return;
                }while (C !== null);
                throw Error(a(171));
            }
            if (h.tag === 1) {
                var B = h.type;
                if (fs(B)) return Gs(h, B, C);
            }
            return C;
        }
        function tm(h) {
            var C = h._reactInternals;
            if (C === void 0) throw typeof h.render == "function" ? Error(a(188)) : (h = Object.keys(h).join(","), Error(a(268, h)));
            return h = he(C), h === null ? null : h.stateNode;
        }
        function Jh(h, C) {
            if (h = h.memoizedState, h !== null && h.dehydrated !== null) {
                var B = h.retryLane;
                h.retryLane = B !== 0 && B < C ? B : C;
            }
        }
        function Cd(h, C) {
            Jh(h, C), (h = h.alternate) && Jh(h, C);
        }
        function qf(h) {
            return h = he(h), h === null ? null : h.stateNode;
        }
        function $f() {
            return null;
        }
        return t.attemptContinuousHydration = function(h) {
            if (h.tag === 13) {
                var C = Qr();
                ws(h, 134217728, C), Cd(h, 134217728);
            }
        }, t.attemptHydrationAtCurrentPriority = function(h) {
            if (h.tag === 13) {
                var C = Qr(), B = ks(h);
                ws(h, B, C), Cd(h, B);
            }
        }, t.attemptSynchronousHydration = function(h) {
            switch(h.tag){
                case 3:
                    var C = h.stateNode;
                    if (C.current.memoizedState.isDehydrated) {
                        var B = cc(C.pendingLanes);
                        B !== 0 && (uc(C, B | 1), Nr(C, Os()), !(pi & 6) && (ad(), fg()));
                    }
                    break;
                case 13:
                    var S = Qr();
                    _f(function() {
                        return ws(h, 1, S);
                    }), Cd(h, 1);
            }
        }, t.batchedUpdates = function(h, C) {
            var B = pi;
            pi |= 1;
            try {
                return h(C);
            } finally{
                pi = B, pi === 0 && (ad(), ap && fg());
            }
        }, t.createComponentSelector = function(h) {
            return {
                $$typeof: vl,
                value: h
            };
        }, t.createContainer = function(h, C, B, S, w, L, Q) {
            return Eh(h, C, !1, null, B, S, w, L, Q);
        }, t.createHasPseudoClassSelector = function(h) {
            return {
                $$typeof: Yh,
                value: h
            };
        }, t.createHydrationContainer = function(h, C, B, S, w, L, Q, le, We) {
            return h = Eh(B, S, !0, h, w, L, Q, le, We), h.context = Fu(null), B = h.current, S = Qr(), w = ks(B), L = ml(S, w), L.callback = C ?? null, dc(B, L), h.current.lanes = w, yh(h, w, S), Nr(h, S), h;
        }, t.createPortal = function(h, C, B) {
            var S = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
            return {
                $$typeof: l,
                key: S == null ? null : "" + S,
                children: h,
                containerInfo: C,
                implementation: B
            };
        }, t.createRoleSelector = function(h) {
            return {
                $$typeof: kp,
                value: h
            };
        }, t.createTestNameSelector = function(h) {
            return {
                $$typeof: Ep,
                value: h
            };
        }, t.createTextSelector = function(h) {
            return {
                $$typeof: Sl,
                value: h
            };
        }, t.deferredUpdates = function(h) {
            var C = ji, B = fi.transition;
            try {
                return fi.transition = null, ji = 16, h();
            } finally{
                ji = C, fi.transition = B;
            }
        }, t.discreteUpdates = function(h, C, B, S, w) {
            var L = ji, Q = fi.transition;
            try {
                return fi.transition = null, ji = 1, h(C, B, S, w);
            } finally{
                ji = L, fi.transition = Q, pi === 0 && ad();
            }
        }, t.findAllNodes = U0, t.findBoundingRects = function(h, C) {
            if (!ka) throw Error(a(363));
            C = U0(h, C), h = [];
            for(var B = 0; B < C.length; B++)h.push(ul(C[B]));
            for(C = h.length - 1; 0 < C; C--){
                B = h[C];
                for(var S = B.x, w = S + B.width, L = B.y, Q = L + B.height, le = C - 1; 0 <= le; le--)if (C !== le) {
                    var We = h[le], Oe = We.x, bt = Oe + We.width, qt = We.y, Yt = qt + We.height;
                    if (S >= Oe && L >= qt && w <= bt && Q <= Yt) {
                        h.splice(C, 1);
                        break;
                    } else if (S !== Oe || B.width !== We.width || Yt < L || qt > Q) {
                        if (!(L !== qt || B.height !== We.height || bt < S || Oe > w)) {
                            Oe > S && (We.width += Oe - S, We.x = S), bt < w && (We.width = w - Oe), h.splice(C, 1);
                            break;
                        }
                    } else {
                        qt > L && (We.height += qt - L, We.y = L), Yt < Q && (We.height = Q - qt), h.splice(C, 1);
                        break;
                    }
                }
            }
            return h;
        }, t.findHostInstance = tm, t.findHostInstanceWithNoPortals = function(h) {
            return h = ie(h), h = h !== null ? ce(h) : null, h === null ? null : h.stateNode;
        }, t.findHostInstanceWithWarning = function(h) {
            return tm(h);
        }, t.flushControlled = function(h) {
            var C = pi;
            pi |= 1;
            var B = fi.transition, S = ji;
            try {
                fi.transition = null, ji = 1, h();
            } finally{
                ji = S, fi.transition = B, pi = C, pi === 0 && (ad(), fg());
            }
        }, t.flushPassiveEffects = br, t.flushSync = _f, t.focusWithin = function(h, C) {
            if (!ka) throw Error(a(363));
            for(h = It(h), C = Uf(h, C), C = Array.from(C), h = 0; h < C.length;){
                var B = C[h++];
                if (!pg(B)) {
                    if (B.tag === 5 && fu(B.stateNode)) return !0;
                    for(B = B.child; B !== null;)C.push(B), B = B.sibling;
                }
            }
            return !1;
        }, t.getCurrentUpdatePriority = function() {
            return ji;
        }, t.getFindAllNodesFailureDescription = function(h, C) {
            if (!ka) throw Error(a(363));
            var B = 0, S = [];
            h = [
                It(h),
                0
            ];
            for(var w = 0; w < h.length;){
                var L = h[w++], Q = h[w++], le = C[Q];
                if ((L.tag !== 5 || !pg(L)) && (po(L, le) && (S.push(Da(le)), Q++, Q > B && (B = Q)), Q < C.length)) for(L = L.child; L !== null;)h.push(L, Q), L = L.sibling;
            }
            if (B < C.length) {
                for(h = []; B < C.length; B++)h.push(Da(C[B]));
                return `findAllNodes was able to match part of the selector:
  ` + (S.join(" > ") + `

No matching component was found for:
  `) + h.join(" > ");
            }
            return null;
        }, t.getPublicRootInstance = function(h) {
            if (h = h.current, !h.child) return null;
            switch(h.child.tag){
                case 5:
                    return te(h.child.stateNode);
                default:
                    return h.child.stateNode;
            }
        }, t.injectIntoDevTools = function(h) {
            if (h = {
                bundleType: h.bundleType,
                version: h.version,
                rendererPackageName: h.rendererPackageName,
                rendererConfig: h.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setErrorHandler: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: o.ReactCurrentDispatcher,
                findHostInstanceByFiber: qf,
                findFiberByHostInstance: h.findFiberByHostInstance || $f,
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null,
                reconcilerVersion: "18.0.0-fc46dba67-20220329"
            }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") h = !1;
            else {
                var C = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (C.isDisabled || !C.supportsFiber) h = !0;
                else {
                    try {
                        rp = C.inject(h), bg = C;
                    } catch  {}
                    h = !!C.checkDCE;
                }
            }
            return h;
        }, t.isAlreadyRendering = function() {
            return !1;
        }, t.observeVisibleRects = function(h, C, B, S) {
            if (!ka) throw Error(a(363));
            h = U0(h, C);
            var w = FI(h, B, S).disconnect;
            return {
                disconnect: function() {
                    w();
                }
            };
        }, t.registerMutableSourceForHydration = function(h, C) {
            var B = C._getVersion;
            B = B(C._source), h.mutableSourceEagerHydrationData == null ? h.mutableSourceEagerHydrationData = [
                C,
                B
            ] : h.mutableSourceEagerHydrationData.push(C, B);
        }, t.runWithPriority = function(h, C) {
            var B = ji;
            try {
                return ji = h, C();
            } finally{
                ji = B;
            }
        }, t.shouldError = function() {
            return null;
        }, t.shouldSuspend = function() {
            return !1;
        }, t.updateContainer = function(h, C, B, S) {
            var w = C.current, L = Qr(), Q = ks(w);
            return B = Fu(B), C.context === null ? C.context = B : C.pendingContext = B, C = ml(L, Q), C.payload = {
                element: h
            }, S = S === void 0 ? null : S, S !== null && (C.callback = S), dc(w, C), h = ws(w, Q, L), h !== null && gp(h, w, Q), Q;
        }, t;
    }), $d7238066c5de7f1c$var$QH;
}
var $d7238066c5de7f1c$var$OH = {
    exports: {}
};
/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7238066c5de7f1c$var$VT;
function $d7238066c5de7f1c$var$cCe() {
    return $d7238066c5de7f1c$var$VT || ($d7238066c5de7f1c$var$VT = 1, false), $d7238066c5de7f1c$var$OH.exports;
}
$d7238066c5de7f1c$var$iN.exports = $d7238066c5de7f1c$var$lCe();
var $d7238066c5de7f1c$var$uCe = $d7238066c5de7f1c$var$iN.exports;
const $d7238066c5de7f1c$var$ICe = /* @__PURE__ */ $d7238066c5de7f1c$var$NP($d7238066c5de7f1c$var$uCe), $d7238066c5de7f1c$var$jY = {}, $d7238066c5de7f1c$var$qY = (r)=>void Object.assign($d7238066c5de7f1c$var$jY, r);
function $d7238066c5de7f1c$var$dCe(r, e) {
    function t(c, { args: d = [], attach: p, ...A }, y) {
        let G = `${c[0].toUpperCase()}${c.slice(1)}`, Z;
        if (c === "primitive") {
            if (A.object === void 0) throw new Error("R3F: Primitives without 'object' are invalid!");
            const v = A.object;
            Z = $d7238066c5de7f1c$var$aA(v, {
                type: c,
                root: y,
                attach: p,
                primitive: !0
            });
        } else {
            const v = $d7238066c5de7f1c$var$jY[G];
            if (!v) throw new Error(`R3F: ${G} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
            if (!Array.isArray(d)) throw new Error("R3F: The args prop must be an array!");
            Z = $d7238066c5de7f1c$var$aA(new v(...d), {
                type: c,
                root: y,
                attach: p,
                // Save args in case we need to reconstruct later for HMR
                memoizedProps: {
                    args: d
                }
            });
        }
        return Z.__r3f.attach === void 0 && (Z.isBufferGeometry ? Z.__r3f.attach = "geometry" : Z.isMaterial && (Z.__r3f.attach = "material")), G !== "inject" && $d7238066c5de7f1c$var$$H(Z, A), Z;
    }
    function i(c, d) {
        let p = !1;
        if (d) {
            var A, y;
            (A = d.__r3f) != null && A.attach ? $d7238066c5de7f1c$var$qH(c, d, d.__r3f.attach) : d.isObject3D && c.isObject3D && (c.add(d), p = !0), p || (y = c.__r3f) == null || y.objects.push(d), d.__r3f || $d7238066c5de7f1c$var$aA(d, {}), d.__r3f.parent = c, $d7238066c5de7f1c$var$rN(d), $d7238066c5de7f1c$var$oA(d);
        }
    }
    function n(c, d, p) {
        let A = !1;
        if (d) {
            var y, G;
            if ((y = d.__r3f) != null && y.attach) $d7238066c5de7f1c$var$qH(c, d, d.__r3f.attach);
            else if (d.isObject3D && c.isObject3D) {
                d.parent = c, d.dispatchEvent({
                    type: "added"
                }), c.dispatchEvent({
                    type: "childadded",
                    child: d
                });
                const Z = c.children.filter((V)=>V !== d), v = Z.indexOf(p);
                c.children = [
                    ...Z.slice(0, v),
                    d,
                    ...Z.slice(v)
                ], A = !0;
            }
            A || (G = c.__r3f) == null || G.objects.push(d), d.__r3f || $d7238066c5de7f1c$var$aA(d, {}), d.__r3f.parent = c, $d7238066c5de7f1c$var$rN(d), $d7238066c5de7f1c$var$oA(d);
        }
    }
    function s(c, d, p = !1) {
        c && [
            ...c
        ].forEach((A)=>a(d, A, p));
    }
    function a(c, d, p) {
        if (d) {
            var A, y, G;
            if (d.__r3f && (d.__r3f.parent = null), (A = c.__r3f) != null && A.objects && (c.__r3f.objects = c.__r3f.objects.filter((N)=>N !== d)), (y = d.__r3f) != null && y.attach) $d7238066c5de7f1c$var$NT(c, d, d.__r3f.attach);
            else if (d.isObject3D && c.isObject3D) {
                var Z;
                c.remove(d), (Z = d.__r3f) != null && Z.root && $d7238066c5de7f1c$var$BCe($d7238066c5de7f1c$var$xS(d), d);
            }
            const V = (G = d.__r3f) == null ? void 0 : G.primitive, H = !V && (p === void 0 ? d.dispose !== null : p);
            if (!V) {
                var v;
                s((v = d.__r3f) == null ? void 0 : v.objects, d, H), s(d.children, d, H);
            }
            if (delete d.__r3f, H && d.dispose && d.type !== "Scene") {
                const N = ()=>{
                    try {
                        d.dispose();
                    } catch  {}
                };
                typeof IS_REACT_ACT_ENVIRONMENT > "u" ? $d7238066c5de7f1c$var$zZ.unstable_scheduleCallback($d7238066c5de7f1c$var$zZ.unstable_IdlePriority, N) : N();
            }
            $d7238066c5de7f1c$var$oA(c);
        }
    }
    function o(c, d, p, A) {
        var y;
        const G = (y = c.__r3f) == null ? void 0 : y.parent;
        if (!G) return;
        const Z = t(d, p, c.__r3f.root);
        if (c.children) {
            for (const v of c.children)v.__r3f && i(Z, v);
            c.children = c.children.filter((v)=>!v.__r3f);
        }
        c.__r3f.objects.forEach((v)=>i(Z, v)), c.__r3f.objects = [], c.__r3f.autoRemovedBeforeAppend || a(G, c), Z.parent && (Z.__r3f.autoRemovedBeforeAppend = !0), i(G, Z), Z.raycast && Z.__r3f.eventCount && $d7238066c5de7f1c$var$xS(Z).getState().internal.interaction.push(Z), [
            A,
            A.alternate
        ].forEach((v)=>{
            v !== null && (v.stateNode = Z, v.ref && (typeof v.ref == "function" ? v.ref(Z) : v.ref.current = Z));
        });
    }
    const g = ()=>{};
    return {
        reconciler: $d7238066c5de7f1c$var$ICe({
            createInstance: t,
            removeChild: a,
            appendChild: i,
            appendInitialChild: i,
            insertBefore: n,
            supportsMutation: !0,
            isPrimaryRenderer: !1,
            supportsPersistence: !1,
            supportsHydration: !1,
            noTimeout: -1,
            appendChildToContainer: (c, d)=>{
                if (!d) return;
                const p = c.getState().scene;
                p.__r3f && (p.__r3f.root = c, i(p, d));
            },
            removeChildFromContainer: (c, d)=>{
                d && a(c.getState().scene, d);
            },
            insertInContainerBefore: (c, d, p)=>{
                if (!d || !p) return;
                const A = c.getState().scene;
                A.__r3f && n(A, d, p);
            },
            getRootHostContext: ()=>null,
            getChildHostContext: (c)=>c,
            finalizeInitialChildren (c) {
                var d;
                return !!((d = c == null ? void 0 : c.__r3f) != null ? d : {}).handlers;
            },
            prepareUpdate (c, d, p, A) {
                var y;
                if (((y = c == null ? void 0 : c.__r3f) != null ? y : {}).primitive && A.object && A.object !== c) return [
                    !0
                ];
                {
                    const { args: Z = [], children: v, ...V } = A, { args: H = [], children: N, ...Y } = p;
                    if (!Array.isArray(Z)) throw new Error("R3F: the args prop must be an array!");
                    if (Z.some((z, M)=>z !== H[M])) return [
                        !0
                    ];
                    const K = $d7238066c5de7f1c$var$JP(c, V, Y, !0);
                    return K.changes.length ? [
                        !1,
                        K
                    ] : null;
                }
            },
            commitUpdate (c, [d, p], A, y, G, Z) {
                d ? o(c, A, G, Z) : $d7238066c5de7f1c$var$$H(c, p);
            },
            commitMount (c, d, p, A) {
                var y;
                const G = (y = c.__r3f) != null ? y : {};
                c.raycast && G.handlers && G.eventCount && $d7238066c5de7f1c$var$xS(c).getState().internal.interaction.push(c);
            },
            getPublicInstance: (c)=>c,
            prepareForCommit: ()=>null,
            preparePortalMount: (c)=>$d7238066c5de7f1c$var$aA(c.getState().scene),
            resetAfterCommit: ()=>{},
            shouldSetTextContent: ()=>!1,
            clearContainer: ()=>!1,
            hideInstance (c) {
                var d;
                const { attach: p, parent: A } = (d = c.__r3f) != null ? d : {};
                p && A && $d7238066c5de7f1c$var$NT(A, c, p), c.isObject3D && (c.visible = !1), $d7238066c5de7f1c$var$oA(c);
            },
            unhideInstance (c, d) {
                var p;
                const { attach: A, parent: y } = (p = c.__r3f) != null ? p : {};
                A && y && $d7238066c5de7f1c$var$qH(y, c, A), (c.isObject3D && d.visible == null || d.visible) && (c.visible = !0), $d7238066c5de7f1c$var$oA(c);
            },
            createTextInstance: g,
            hideTextInstance: g,
            unhideTextInstance: g,
            // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
            // @ts-expect-error
            getCurrentEventPriority: ()=>e ? e() : $d7238066c5de7f1c$var$pA.DefaultEventPriority,
            beforeActiveInstanceBlur: ()=>{},
            afterActiveInstanceBlur: ()=>{},
            detachDeletedInstance: ()=>{},
            now: typeof performance < "u" && $d7238066c5de7f1c$var$zn.fun(performance.now) ? performance.now : $d7238066c5de7f1c$var$zn.fun(Date.now) ? Date.now : ()=>0,
            // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
            scheduleTimeout: $d7238066c5de7f1c$var$zn.fun(setTimeout) ? setTimeout : void 0,
            cancelTimeout: $d7238066c5de7f1c$var$zn.fun(clearTimeout) ? clearTimeout : void 0
        }),
        applyProps: $d7238066c5de7f1c$var$$H
    };
}
var $d7238066c5de7f1c$var$wT, $d7238066c5de7f1c$var$WT;
const $d7238066c5de7f1c$var$jH = (r)=>"colorSpace" in r || "outputColorSpace" in r, $d7238066c5de7f1c$var$FP = ()=>{
    var r;
    return (r = $d7238066c5de7f1c$var$jY.ColorManagement) != null ? r : null;
}, $d7238066c5de7f1c$var$TP = (r)=>r && r.isOrthographicCamera, $d7238066c5de7f1c$var$hCe = (r)=>r && r.hasOwnProperty("current"), $d7238066c5de7f1c$var$sf = typeof window < "u" && (($d7238066c5de7f1c$var$wT = window.document) != null && $d7238066c5de7f1c$var$wT.createElement || (($d7238066c5de7f1c$var$WT = window.navigator) == null ? void 0 : $d7238066c5de7f1c$var$WT.product) === "ReactNative") ? $bxRTa.useLayoutEffect : $bxRTa.useEffect;
function $d7238066c5de7f1c$var$MP(r) {
    const e = $bxRTa.useRef(r);
    return $d7238066c5de7f1c$var$sf(()=>void (e.current = r), [
        r
    ]), e;
}
function $d7238066c5de7f1c$var$CCe({ set: r }) {
    return $d7238066c5de7f1c$var$sf(()=>(r(new Promise(()=>null)), ()=>r(!1)), [
        r
    ]), null;
}
class $d7238066c5de7f1c$var$zP extends $bxRTa.Component {
    constructor(...e){
        super(...e), this.state = {
            error: !1
        };
    }
    componentDidCatch(e) {
        this.props.set(e);
    }
    render() {
        return this.state.error ? null : this.props.children;
    }
}
$d7238066c5de7f1c$var$zP.getDerivedStateFromError = ()=>({
        error: !0
    });
const $d7238066c5de7f1c$var$kP = "__default", $d7238066c5de7f1c$var$HT = /* @__PURE__ */ new Map(), $d7238066c5de7f1c$var$pCe = (r)=>r && !!r.memoized && !!r.changes;
function $d7238066c5de7f1c$var$EP(r) {
    var e;
    const t = typeof window < "u" ? (e = window.devicePixelRatio) != null ? e : 2 : 1;
    return Array.isArray(r) ? Math.min(Math.max(r[0], t), r[1]) : r;
}
const $d7238066c5de7f1c$var$iy = (r)=>{
    var e;
    return (e = r.__r3f) == null ? void 0 : e.root.getState();
};
function $d7238066c5de7f1c$var$xS(r) {
    let e = r.__r3f.root;
    for(; e.getState().previousRoot;)e = e.getState().previousRoot;
    return e;
}
const $d7238066c5de7f1c$var$zn = {
    obj: (r)=>r === Object(r) && !$d7238066c5de7f1c$var$zn.arr(r) && typeof r != "function",
    fun: (r)=>typeof r == "function",
    str: (r)=>typeof r == "string",
    num: (r)=>typeof r == "number",
    boo: (r)=>typeof r == "boolean",
    und: (r)=>r === void 0,
    arr: (r)=>Array.isArray(r),
    equ (r, e, { arrays: t = "shallow", objects: i = "reference", strict: n = !0 } = {}) {
        if (typeof r != typeof e || !!r != !!e) return !1;
        if ($d7238066c5de7f1c$var$zn.str(r) || $d7238066c5de7f1c$var$zn.num(r) || $d7238066c5de7f1c$var$zn.boo(r)) return r === e;
        const s = $d7238066c5de7f1c$var$zn.obj(r);
        if (s && i === "reference") return r === e;
        const a = $d7238066c5de7f1c$var$zn.arr(r);
        if (a && t === "reference") return r === e;
        if ((a || s) && r === e) return !0;
        let o;
        for(o in r)if (!(o in e)) return !1;
        if (s && t === "shallow" && i === "shallow") {
            for(o in n ? e : r)if (!$d7238066c5de7f1c$var$zn.equ(r[o], e[o], {
                strict: n,
                objects: "reference"
            })) return !1;
        } else for(o in n ? e : r)if (r[o] !== e[o]) return !1;
        if ($d7238066c5de7f1c$var$zn.und(o)) {
            if (a && r.length === 0 && e.length === 0 || s && Object.keys(r).length === 0 && Object.keys(e).length === 0) return !0;
            if (r !== e) return !1;
        }
        return !0;
    }
};
function $d7238066c5de7f1c$var$mCe(r) {
    const e = {
        nodes: {},
        materials: {}
    };
    return r && r.traverse((t)=>{
        t.name && (e.nodes[t.name] = t), t.material && !e.materials[t.material.name] && (e.materials[t.material.name] = t.material);
    }), e;
}
function $d7238066c5de7f1c$var$ACe(r) {
    r.dispose && r.type !== "Scene" && r.dispose();
    for(const e in r)e.dispose == null || e.dispose(), delete r[e];
}
function $d7238066c5de7f1c$var$aA(r, e) {
    const t = r;
    return t.__r3f = {
        type: "",
        root: null,
        previousAttach: null,
        memoizedProps: {},
        eventCount: 0,
        handlers: {},
        objects: [],
        parent: null,
        ...e
    }, r;
}
function $d7238066c5de7f1c$var$sN(r, e) {
    let t = r;
    if (e.includes("-")) {
        const i = e.split("-"), n = i.pop();
        return t = i.reduce((s, a)=>s[a], r), {
            target: t,
            key: n
        };
    } else return {
        target: t,
        key: e
    };
}
const $d7238066c5de7f1c$var$XT = /-\d+$/;
function $d7238066c5de7f1c$var$qH(r, e, t) {
    if ($d7238066c5de7f1c$var$zn.str(t)) {
        if ($d7238066c5de7f1c$var$XT.test(t)) {
            const s = t.replace($d7238066c5de7f1c$var$XT, ""), { target: a, key: o } = $d7238066c5de7f1c$var$sN(r, s);
            Array.isArray(a[o]) || (a[o] = []);
        }
        const { target: i, key: n } = $d7238066c5de7f1c$var$sN(r, t);
        e.__r3f.previousAttach = i[n], i[n] = e;
    } else e.__r3f.previousAttach = t(r, e);
}
function $d7238066c5de7f1c$var$NT(r, e, t) {
    var i, n;
    if ($d7238066c5de7f1c$var$zn.str(t)) {
        const { target: s, key: a } = $d7238066c5de7f1c$var$sN(r, t), o = e.__r3f.previousAttach;
        o === void 0 ? delete s[a] : s[a] = o;
    } else (i = e.__r3f) == null || i.previousAttach == null || i.previousAttach(r, e);
    (n = e.__r3f) == null || delete n.previousAttach;
}
function $d7238066c5de7f1c$var$JP(r, { children: e, key: t, ref: i, ...n }, { children: s, key: a, ref: o, ...g } = {}, l = !1) {
    const c = r.__r3f, d = Object.entries(n), p = [];
    if (l) {
        const y = Object.keys(g);
        for(let G = 0; G < y.length; G++)n.hasOwnProperty(y[G]) || d.unshift([
            y[G],
            $d7238066c5de7f1c$var$kP + "remove"
        ]);
    }
    d.forEach(([y, G])=>{
        var Z;
        if ((Z = r.__r3f) != null && Z.primitive && y === "object" || $d7238066c5de7f1c$var$zn.equ(G, g[y])) return;
        if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(y)) return p.push([
            y,
            G,
            !0,
            []
        ]);
        let v = [];
        y.includes("-") && (v = y.split("-")), p.push([
            y,
            G,
            !1,
            v
        ]);
        for(const V in n){
            const H = n[V];
            V.startsWith(`${y}-`) && p.push([
                V,
                H,
                !1,
                V.split("-")
            ]);
        }
    });
    const A = {
        ...n
    };
    return c != null && c.memoizedProps && c != null && c.memoizedProps.args && (A.args = c.memoizedProps.args), c != null && c.memoizedProps && c != null && c.memoizedProps.attach && (A.attach = c.memoizedProps.attach), {
        memoized: A,
        changes: p
    };
}
const $d7238066c5de7f1c$var$bCe = false;
function $d7238066c5de7f1c$var$$H(r, e) {
    var t;
    const i = r.__r3f, n = i == null ? void 0 : i.root, s = n == null || n.getState == null ? void 0 : n.getState(), { memoized: a, changes: o } = $d7238066c5de7f1c$var$pCe(e) ? e : $d7238066c5de7f1c$var$JP(r, e), g = i == null ? void 0 : i.eventCount;
    r.__r3f && (r.__r3f.memoizedProps = a);
    for(let p = 0; p < o.length; p++){
        let [A, y, G, Z] = o[p];
        if ($d7238066c5de7f1c$var$jH(r)) {
            const N = "srgb", Y = "srgb-linear";
            A === "encoding" ? (A = "colorSpace", y = y === 3001 ? N : Y) : A === "outputEncoding" && (A = "outputColorSpace", y = y === 3001 ? N : Y);
        }
        let v = r, V = v[A];
        if (Z.length && (V = Z.reduce((H, N)=>H[N], r), !(V && V.set))) {
            const [H, ...N] = Z.reverse();
            v = N.reverse().reduce((Y, K)=>Y[K], r), A = H;
        }
        if (y === $d7238066c5de7f1c$var$kP + "remove") {
            if (v.constructor) {
                let H = $d7238066c5de7f1c$var$HT.get(v.constructor);
                H || (H = new v.constructor(), $d7238066c5de7f1c$var$HT.set(v.constructor, H)), y = H[A];
            } else y = 0;
        }
        if (G && i) y ? i.handlers[A] = y : delete i.handlers[A], i.eventCount = Object.keys(i.handlers).length;
        else if (V && V.set && (V.copy || V instanceof $1W96c.Layers)) {
            if (Array.isArray(y)) V.fromArray ? V.fromArray(y) : V.set(...y);
            else if (V.copy && y && y.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
            // Loosen to unminified names, ignoring descendents.
            // https://github.com/pmndrs/react-three-fiber/issues/2856
            // TODO: fix upstream and remove in v9
            ($d7238066c5de7f1c$var$bCe ? V.constructor.name === y.constructor.name : V.constructor === y.constructor)) V.copy(y);
            else if (y !== void 0) {
                var l;
                const H = (l = V) == null ? void 0 : l.isColor;
                !H && V.setScalar ? V.setScalar(y) : V instanceof $1W96c.Layers && y instanceof $1W96c.Layers ? V.mask = y.mask : V.set(y), !$d7238066c5de7f1c$var$FP() && s && !s.linear && H && V.convertSRGBToLinear();
            }
        } else {
            var c;
            if (v[A] = y, (c = v[A]) != null && c.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            v[A].format === $1W96c.RGBAFormat && v[A].type === $1W96c.UnsignedByteType && s) {
                const H = v[A];
                $d7238066c5de7f1c$var$jH(H) && $d7238066c5de7f1c$var$jH(s.gl) ? H.colorSpace = s.gl.outputColorSpace : H.encoding = s.gl.outputEncoding;
            }
        }
        $d7238066c5de7f1c$var$oA(r);
    }
    if (i && i.parent && r.raycast && g !== i.eventCount) {
        const p = $d7238066c5de7f1c$var$xS(r).getState().internal, A = p.interaction.indexOf(r);
        A > -1 && p.interaction.splice(A, 1), i.eventCount && p.interaction.push(r);
    }
    return !(o.length === 1 && o[0][0] === "onUpdate") && o.length && (t = r.__r3f) != null && t.parent && $d7238066c5de7f1c$var$rN(r), r;
}
function $d7238066c5de7f1c$var$oA(r) {
    var e, t;
    const i = (e = r.__r3f) == null || (t = e.root) == null || t.getState == null ? void 0 : t.getState();
    i && i.internal.frames === 0 && i.invalidate();
}
function $d7238066c5de7f1c$var$rN(r) {
    r.onUpdate == null || r.onUpdate(r);
}
function $d7238066c5de7f1c$var$UP(r, e) {
    r.manual || ($d7238066c5de7f1c$var$TP(r) ? (r.left = e.width / -2, r.right = e.width / 2, r.top = e.height / 2, r.bottom = e.height / -2) : r.aspect = e.width / e.height, r.updateProjectionMatrix(), r.updateMatrixWorld());
}
function $d7238066c5de7f1c$var$iS(r) {
    return (r.eventObject || r.object).uuid + "/" + r.index + r.instanceId;
}
function $d7238066c5de7f1c$var$yCe() {
    var r;
    const e = typeof self < "u" && self || typeof window < "u" && window;
    if (!e) return $d7238066c5de7f1c$var$pA.DefaultEventPriority;
    switch((r = e.event) == null ? void 0 : r.type){
        case "click":
        case "contextmenu":
        case "dblclick":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
            return $d7238066c5de7f1c$var$pA.DiscreteEventPriority;
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerenter":
        case "pointerleave":
        case "wheel":
            return $d7238066c5de7f1c$var$pA.ContinuousEventPriority;
        default:
            return $d7238066c5de7f1c$var$pA.DefaultEventPriority;
    }
}
function $d7238066c5de7f1c$var$DP(r, e, t, i) {
    const n = t.get(e);
    n && (t.delete(e), t.size === 0 && (r.delete(i), n.target.releasePointerCapture(i)));
}
function $d7238066c5de7f1c$var$BCe(r, e) {
    const { internal: t } = r.getState();
    t.interaction = t.interaction.filter((i)=>i !== e), t.initialHits = t.initialHits.filter((i)=>i !== e), t.hovered.forEach((i, n)=>{
        (i.eventObject === e || i.object === e) && t.hovered.delete(n);
    }), t.capturedMap.forEach((i, n)=>{
        $d7238066c5de7f1c$var$DP(t.capturedMap, e, i, n);
    });
}
function $d7238066c5de7f1c$var$fCe(r) {
    function e(g) {
        const { internal: l } = r.getState(), c = g.offsetX - l.initialClick[0], d = g.offsetY - l.initialClick[1];
        return Math.round(Math.sqrt(c * c + d * d));
    }
    function t(g) {
        return g.filter((l)=>[
                "Move",
                "Over",
                "Enter",
                "Out",
                "Leave"
            ].some((c)=>{
                var d;
                return (d = l.__r3f) == null ? void 0 : d.handlers["onPointer" + c];
            }));
    }
    function i(g, l) {
        const c = r.getState(), d = /* @__PURE__ */ new Set(), p = [], A = l ? l(c.internal.interaction) : c.internal.interaction;
        for(let v = 0; v < A.length; v++){
            const V = $d7238066c5de7f1c$var$iy(A[v]);
            V && (V.raycaster.camera = void 0);
        }
        c.previousRoot || c.events.compute == null || c.events.compute(g, c);
        function y(v) {
            const V = $d7238066c5de7f1c$var$iy(v);
            if (!V || !V.events.enabled || V.raycaster.camera === null) return [];
            if (V.raycaster.camera === void 0) {
                var H;
                V.events.compute == null || V.events.compute(g, V, (H = V.previousRoot) == null ? void 0 : H.getState()), V.raycaster.camera === void 0 && (V.raycaster.camera = null);
            }
            return V.raycaster.camera ? V.raycaster.intersectObject(v, !0) : [];
        }
        let G = A.flatMap(y).sort((v, V)=>{
            const H = $d7238066c5de7f1c$var$iy(v.object), N = $d7238066c5de7f1c$var$iy(V.object);
            return !H || !N ? v.distance - V.distance : N.events.priority - H.events.priority || v.distance - V.distance;
        }).filter((v)=>{
            const V = $d7238066c5de7f1c$var$iS(v);
            return d.has(V) ? !1 : (d.add(V), !0);
        });
        c.events.filter && (G = c.events.filter(G, c));
        for (const v of G){
            let V = v.object;
            for(; V;){
                var Z;
                (Z = V.__r3f) != null && Z.eventCount && p.push({
                    ...v,
                    eventObject: V
                }), V = V.parent;
            }
        }
        if ("pointerId" in g && c.internal.capturedMap.has(g.pointerId)) for (let v of c.internal.capturedMap.get(g.pointerId).values())d.has($d7238066c5de7f1c$var$iS(v.intersection)) || p.push(v.intersection);
        return p;
    }
    function n(g, l, c, d) {
        const p = r.getState();
        if (g.length) {
            const A = {
                stopped: !1
            };
            for (const y of g){
                const G = $d7238066c5de7f1c$var$iy(y.object) || p, { raycaster: Z, pointer: v, camera: V, internal: H } = G, N = new $1W96c.Vector3(v.x, v.y, 0).unproject(V), Y = (O)=>{
                    var ie, he;
                    return (ie = (he = H.capturedMap.get(O)) == null ? void 0 : he.has(y.eventObject)) != null ? ie : !1;
                }, K = (O)=>{
                    const ie = {
                        intersection: y,
                        target: l.target
                    };
                    H.capturedMap.has(O) ? H.capturedMap.get(O).set(y.eventObject, ie) : H.capturedMap.set(O, /* @__PURE__ */ new Map([
                        [
                            y.eventObject,
                            ie
                        ]
                    ])), l.target.setPointerCapture(O);
                }, z = (O)=>{
                    const ie = H.capturedMap.get(O);
                    ie && $d7238066c5de7f1c$var$DP(H.capturedMap, y.eventObject, ie, O);
                };
                let M = {};
                for(let O in l){
                    let ie = l[O];
                    typeof ie != "function" && (M[O] = ie);
                }
                let _ = {
                    ...y,
                    ...M,
                    pointer: v,
                    intersections: g,
                    stopped: A.stopped,
                    delta: c,
                    unprojectedPoint: N,
                    ray: Z.ray,
                    camera: V,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation () {
                        const O = "pointerId" in l && H.capturedMap.get(l.pointerId);
                        if (// ...if this pointer hasn't been captured
                        (!O || // ... or if the hit object is capturing the pointer
                        O.has(y.eventObject)) && (_.stopped = A.stopped = !0, H.hovered.size && Array.from(H.hovered.values()).find((ie)=>ie.eventObject === y.eventObject))) {
                            const ie = g.slice(0, g.indexOf(y));
                            s([
                                ...ie,
                                y
                            ]);
                        }
                    },
                    // there should be a distinction between target and currentTarget
                    target: {
                        hasPointerCapture: Y,
                        setPointerCapture: K,
                        releasePointerCapture: z
                    },
                    currentTarget: {
                        hasPointerCapture: Y,
                        setPointerCapture: K,
                        releasePointerCapture: z
                    },
                    nativeEvent: l
                };
                if (d(_), A.stopped === !0) break;
            }
        }
        return g;
    }
    function s(g) {
        const { internal: l } = r.getState();
        for (const c of l.hovered.values())if (!g.length || !g.find((d)=>d.object === c.object && d.index === c.index && d.instanceId === c.instanceId)) {
            const p = c.eventObject.__r3f, A = p == null ? void 0 : p.handlers;
            if (l.hovered.delete($d7238066c5de7f1c$var$iS(c)), p != null && p.eventCount) {
                const y = {
                    ...c,
                    intersections: g
                };
                A.onPointerOut == null || A.onPointerOut(y), A.onPointerLeave == null || A.onPointerLeave(y);
            }
        }
    }
    function a(g, l) {
        for(let c = 0; c < l.length; c++){
            const d = l[c].__r3f;
            d == null || d.handlers.onPointerMissed == null || d.handlers.onPointerMissed(g);
        }
    }
    function o(g) {
        switch(g){
            case "onPointerLeave":
            case "onPointerCancel":
                return ()=>s([]);
            case "onLostPointerCapture":
                return (l)=>{
                    const { internal: c } = r.getState();
                    "pointerId" in l && c.capturedMap.has(l.pointerId) && requestAnimationFrame(()=>{
                        c.capturedMap.has(l.pointerId) && (c.capturedMap.delete(l.pointerId), s([]));
                    });
                };
        }
        return function(c) {
            const { onPointerMissed: d, internal: p } = r.getState();
            p.lastEvent.current = c;
            const A = g === "onPointerMove", y = g === "onClick" || g === "onContextMenu" || g === "onDoubleClick", Z = i(c, A ? t : void 0), v = y ? e(c) : 0;
            g === "onPointerDown" && (p.initialClick = [
                c.offsetX,
                c.offsetY
            ], p.initialHits = Z.map((H)=>H.eventObject)), y && !Z.length && v <= 2 && (a(c, p.interaction), d && d(c)), A && s(Z);
            function V(H) {
                const N = H.eventObject, Y = N.__r3f, K = Y == null ? void 0 : Y.handlers;
                if (Y != null && Y.eventCount) {
                    if (A) {
                        if (K.onPointerOver || K.onPointerEnter || K.onPointerOut || K.onPointerLeave) {
                            const z = $d7238066c5de7f1c$var$iS(H), M = p.hovered.get(z);
                            M ? M.stopped && H.stopPropagation() : (p.hovered.set(z, H), K.onPointerOver == null || K.onPointerOver(H), K.onPointerEnter == null || K.onPointerEnter(H));
                        }
                        K.onPointerMove == null || K.onPointerMove(H);
                    } else {
                        const z = K[g];
                        z ? (!y || p.initialHits.includes(N)) && (a(c, p.interaction.filter((M)=>!p.initialHits.includes(M))), z(H)) : y && p.initialHits.includes(N) && a(c, p.interaction.filter((M)=>!p.initialHits.includes(M)));
                    }
                }
            }
            n(Z, c, v, V);
        };
    }
    return {
        handlePointer: o
    };
}
const $d7238066c5de7f1c$var$GCe = [
    "set",
    "get",
    "setSize",
    "setFrameloop",
    "setDpr",
    "events",
    "invalidate",
    "advance",
    "size",
    "viewport"
], $d7238066c5de7f1c$var$_P = (r)=>!!(r != null && r.render), $d7238066c5de7f1c$var$$Y = /* @__PURE__ */ $bxRTa.createContext(null), $d7238066c5de7f1c$var$vCe = (r, e)=>{
    const t = $d7238066c5de7f1c$var$LP((o, g)=>{
        const l = new $1W96c.Vector3(), c = new $1W96c.Vector3(), d = new $1W96c.Vector3();
        function p(v = g().camera, V = c, H = g().size) {
            const { width: N, height: Y, top: K, left: z } = H, M = N / Y;
            V.isVector3 ? d.copy(V) : d.set(...V);
            const _ = v.getWorldPosition(l).distanceTo(d);
            if ($d7238066c5de7f1c$var$TP(v)) return {
                width: N / v.zoom,
                height: Y / v.zoom,
                top: K,
                left: z,
                factor: 1,
                distance: _,
                aspect: M
            };
            {
                const O = v.fov * Math.PI / 180, ie = 2 * Math.tan(O / 2) * _, he = ie * (N / Y);
                return {
                    width: he,
                    height: ie,
                    top: K,
                    left: z,
                    factor: N / he,
                    distance: _,
                    aspect: M
                };
            }
        }
        let A;
        const y = (v)=>o((V)=>({
                    performance: {
                        ...V.performance,
                        current: v
                    }
                })), G = new $1W96c.Vector2();
        return {
            set: o,
            get: g,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: !0,
                connected: !1
            },
            xr: null,
            scene: null,
            invalidate: (v = 1)=>r(g(), v),
            advance: (v, V)=>e(v, V, g()),
            legacy: !1,
            linear: !1,
            flat: !1,
            controls: null,
            clock: new $1W96c.Clock(),
            pointer: G,
            mouse: G,
            frameloop: "always",
            onPointerMissed: void 0,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const v = g();
                    A && clearTimeout(A), v.performance.current !== v.performance.min && y(v.performance.min), A = setTimeout(()=>y(g().performance.max), v.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                updateStyle: !1
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: p
            },
            setEvents: (v)=>o((V)=>({
                        ...V,
                        events: {
                            ...V.events,
                            ...v
                        }
                    })),
            setSize: (v, V, H, N, Y)=>{
                const K = g().camera, z = {
                    width: v,
                    height: V,
                    top: N || 0,
                    left: Y || 0,
                    updateStyle: H
                };
                o((M)=>({
                        size: z,
                        viewport: {
                            ...M.viewport,
                            ...p(K, c, z)
                        }
                    }));
            },
            setDpr: (v)=>o((V)=>{
                    const H = $d7238066c5de7f1c$var$EP(v);
                    return {
                        viewport: {
                            ...V.viewport,
                            dpr: H,
                            initialDpr: V.viewport.initialDpr || H
                        }
                    };
                }),
            setFrameloop: (v = "always")=>{
                const V = g().clock;
                V.stop(), V.elapsedTime = 0, v !== "never" && (V.start(), V.elapsedTime = 0), o(()=>({
                        frameloop: v
                    }));
            },
            previousRoot: void 0,
            internal: {
                active: !1,
                priority: 0,
                frames: 0,
                lastEvent: /* @__PURE__ */ $bxRTa.createRef(),
                interaction: [],
                hovered: /* @__PURE__ */ new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: /* @__PURE__ */ new Map(),
                subscribe: (v, V, H)=>{
                    const N = g().internal;
                    return N.priority = N.priority + (V > 0 ? 1 : 0), N.subscribers.push({
                        ref: v,
                        priority: V,
                        store: H
                    }), N.subscribers = N.subscribers.sort((Y, K)=>Y.priority - K.priority), ()=>{
                        const Y = g().internal;
                        Y != null && Y.subscribers && (Y.priority = Y.priority - (V > 0 ? 1 : 0), Y.subscribers = Y.subscribers.filter((K)=>K.ref !== v));
                    };
                }
            }
        };
    }), i = t.getState();
    let n = i.size, s = i.viewport.dpr, a = i.camera;
    return t.subscribe(()=>{
        const { camera: o, size: g, viewport: l, gl: c, set: d } = t.getState();
        if (g.width !== n.width || g.height !== n.height || l.dpr !== s) {
            var p;
            n = g, s = l.dpr, $d7238066c5de7f1c$var$UP(o, g), c.setPixelRatio(l.dpr);
            const A = (p = g.updateStyle) != null ? p : typeof HTMLCanvasElement < "u" && c.domElement instanceof HTMLCanvasElement;
            c.setSize(g.width, g.height, A);
        }
        o !== a && (a = o, d((A)=>({
                viewport: {
                    ...A.viewport,
                    ...A.viewport.getCurrentViewport(o)
                }
            })));
    }), t.subscribe((o)=>r(o)), t;
};
let $d7238066c5de7f1c$var$nS, $d7238066c5de7f1c$var$SCe = /* @__PURE__ */ new Set(), $d7238066c5de7f1c$var$ZCe = /* @__PURE__ */ new Set(), $d7238066c5de7f1c$var$RCe = /* @__PURE__ */ new Set();
function $d7238066c5de7f1c$var$eX(r, e) {
    if (r.size) for (const { callback: t } of r.values())t(e);
}
function $d7238066c5de7f1c$var$ny(r, e) {
    switch(r){
        case "before":
            return $d7238066c5de7f1c$var$eX($d7238066c5de7f1c$var$SCe, e);
        case "after":
            return $d7238066c5de7f1c$var$eX($d7238066c5de7f1c$var$ZCe, e);
        case "tail":
            return $d7238066c5de7f1c$var$eX($d7238066c5de7f1c$var$RCe, e);
    }
}
let $d7238066c5de7f1c$var$tX, $d7238066c5de7f1c$var$iX;
function $d7238066c5de7f1c$var$nX(r, e, t) {
    let i = e.clock.getDelta();
    for(e.frameloop === "never" && typeof r == "number" && (i = r - e.clock.elapsedTime, e.clock.oldTime = e.clock.elapsedTime, e.clock.elapsedTime = r), $d7238066c5de7f1c$var$tX = e.internal.subscribers, $d7238066c5de7f1c$var$nS = 0; $d7238066c5de7f1c$var$nS < $d7238066c5de7f1c$var$tX.length; $d7238066c5de7f1c$var$nS++)$d7238066c5de7f1c$var$iX = $d7238066c5de7f1c$var$tX[$d7238066c5de7f1c$var$nS], $d7238066c5de7f1c$var$iX.ref.current($d7238066c5de7f1c$var$iX.store.getState(), i, t);
    return !e.internal.priority && e.gl.render && e.gl.render(e.scene, e.camera), e.internal.frames = Math.max(0, e.internal.frames - 1), e.frameloop === "always" ? 1 : e.internal.frames;
}
function $d7238066c5de7f1c$var$VCe(r) {
    let e = !1, t = !1, i, n, s;
    function a(l) {
        n = requestAnimationFrame(a), e = !0, i = 0, $d7238066c5de7f1c$var$ny("before", l), t = !0;
        for (const d of r.values()){
            var c;
            s = d.store.getState(), s.internal.active && (s.frameloop === "always" || s.internal.frames > 0) && !((c = s.gl.xr) != null && c.isPresenting) && (i += $d7238066c5de7f1c$var$nX(l, s));
        }
        if (t = !1, $d7238066c5de7f1c$var$ny("after", l), i === 0) return $d7238066c5de7f1c$var$ny("tail", l), e = !1, cancelAnimationFrame(n);
    }
    function o(l, c = 1) {
        var d;
        if (!l) return r.forEach((p)=>o(p.store.getState(), c));
        (d = l.gl.xr) != null && d.isPresenting || !l.internal.active || l.frameloop === "never" || (c > 1 ? l.internal.frames = Math.min(60, l.internal.frames + c) : t ? l.internal.frames = 2 : l.internal.frames = 1, e || (e = !0, requestAnimationFrame(a)));
    }
    function g(l, c = !0, d, p) {
        if (c && $d7238066c5de7f1c$var$ny("before", l), d) $d7238066c5de7f1c$var$nX(l, d, p);
        else for (const A of r.values())$d7238066c5de7f1c$var$nX(l, A.store.getState());
        c && $d7238066c5de7f1c$var$ny("after", l);
    }
    return {
        loop: a,
        invalidate: o,
        advance: g
    };
}
function $d7238066c5de7f1c$var$eK() {
    const r = $bxRTa.useContext($d7238066c5de7f1c$var$$Y);
    if (!r) throw new Error("R3F: Hooks can only be used within the Canvas component!");
    return r;
}
function $d7238066c5de7f1c$var$gs(r = (t)=>t, e) {
    return $d7238066c5de7f1c$var$eK()(r, e);
}
function $d7238066c5de7f1c$var$_R(r, e = 0) {
    const t = $d7238066c5de7f1c$var$eK(), i = t.getState().internal.subscribe, n = $d7238066c5de7f1c$var$MP(r);
    return $d7238066c5de7f1c$var$sf(()=>i(n, e, t), [
        e,
        i,
        t
    ]), null;
}
const $d7238066c5de7f1c$var$LT = /* @__PURE__ */ new WeakMap();
function $d7238066c5de7f1c$var$PP(r, e) {
    return function(t, ...i) {
        let n = $d7238066c5de7f1c$var$LT.get(t);
        return n || (n = new t(), $d7238066c5de7f1c$var$LT.set(t, n)), r && r(n), Promise.all(i.map((s)=>new Promise((a, o)=>n.load(s, (g)=>{
                    g.scene && Object.assign(g, $d7238066c5de7f1c$var$mCe(g.scene)), a(g);
                }, e, (g)=>o(new Error(`Could not load ${s}: ${g == null ? void 0 : g.message}`))))));
    };
}
function $d7238066c5de7f1c$var$DA(r, e, t, i) {
    const n = Array.isArray(e) ? e : [
        e
    ], s = $d7238066c5de7f1c$var$xP($d7238066c5de7f1c$var$PP(t, i), [
        r,
        ...n
    ], {
        equal: $d7238066c5de7f1c$var$zn.equ
    });
    return Array.isArray(e) ? s : s[0];
}
$d7238066c5de7f1c$var$DA.preload = function(r, e, t) {
    const i = Array.isArray(e) ? e : [
        e
    ];
    return $d7238066c5de7f1c$var$rCe($d7238066c5de7f1c$var$PP(t), [
        r,
        ...i
    ]);
};
$d7238066c5de7f1c$var$DA.clear = function(r, e) {
    const t = Array.isArray(e) ? e : [
        e
    ];
    return $d7238066c5de7f1c$var$aCe([
        r,
        ...t
    ]);
};
const $d7238066c5de7f1c$var$_A = /* @__PURE__ */ new Map(), { invalidate: $d7238066c5de7f1c$var$YT, advance: $d7238066c5de7f1c$var$KT } = $d7238066c5de7f1c$var$VCe($d7238066c5de7f1c$var$_A), { reconciler: $d7238066c5de7f1c$var$GB, applyProps: $d7238066c5de7f1c$var$Ud } = $d7238066c5de7f1c$var$dCe($d7238066c5de7f1c$var$_A, $d7238066c5de7f1c$var$yCe), $d7238066c5de7f1c$var$Dm = {
    objects: "shallow",
    strict: !1
}, $d7238066c5de7f1c$var$wCe = (r, e)=>{
    const t = typeof r == "function" ? r(e) : r;
    return $d7238066c5de7f1c$var$_P(t) ? t : new $1W96c.WebGLRenderer({
        powerPreference: "high-performance",
        canvas: e,
        antialias: !0,
        alpha: !0,
        ...r
    });
};
function $d7238066c5de7f1c$var$WCe(r, e) {
    const t = typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement;
    if (e) {
        const { width: i, height: n, top: s, left: a, updateStyle: o = t } = e;
        return {
            width: i,
            height: n,
            top: s,
            left: a,
            updateStyle: o
        };
    } else if (typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement && r.parentElement) {
        const { width: i, height: n, top: s, left: a } = r.parentElement.getBoundingClientRect();
        return {
            width: i,
            height: n,
            top: s,
            left: a,
            updateStyle: t
        };
    } else if (typeof OffscreenCanvas < "u" && r instanceof OffscreenCanvas) return {
        width: r.width,
        height: r.height,
        top: 0,
        left: 0,
        updateStyle: t
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    };
}
function $d7238066c5de7f1c$var$HCe(r) {
    const e = $d7238066c5de7f1c$var$_A.get(r), t = e == null ? void 0 : e.fiber, i = e == null ? void 0 : e.store;
    e && console.warn("R3F.createRoot should only be called once!");
    const n = typeof reportError == "function" ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error, s = i || $d7238066c5de7f1c$var$vCe($d7238066c5de7f1c$var$YT, $d7238066c5de7f1c$var$KT), a = t || $d7238066c5de7f1c$var$GB.createContainer(s, $d7238066c5de7f1c$var$pA.ConcurrentRoot, null, !1, null, "", n, null);
    e || $d7238066c5de7f1c$var$_A.set(r, {
        fiber: a,
        store: s
    });
    let o, g = !1, l;
    return {
        configure (c = {}) {
            let { gl: d, size: p, scene: A, events: y, onCreated: G, shadows: Z = !1, linear: v = !1, flat: V = !1, legacy: H = !1, orthographic: N = !1, frameloop: Y = "always", dpr: K = [
                1,
                2
            ], performance: z, raycaster: M, camera: _, onPointerMissed: O } = c, ie = s.getState(), he = ie.gl;
            ie.gl || ie.set({
                gl: he = $d7238066c5de7f1c$var$wCe(d, r)
            });
            let pe = ie.raycaster;
            pe || ie.set({
                raycaster: pe = new $1W96c.Raycaster()
            });
            const { params: ce, ...$ } = M || {};
            if ($d7238066c5de7f1c$var$zn.equ($, pe, $d7238066c5de7f1c$var$Dm) || $d7238066c5de7f1c$var$Ud(pe, {
                ...$
            }), $d7238066c5de7f1c$var$zn.equ(ce, pe.params, $d7238066c5de7f1c$var$Dm) || $d7238066c5de7f1c$var$Ud(pe, {
                params: {
                    ...pe.params,
                    ...ce
                }
            }), !ie.camera || ie.camera === l && !$d7238066c5de7f1c$var$zn.equ(l, _, $d7238066c5de7f1c$var$Dm)) {
                l = _;
                const ge = _ instanceof $1W96c.Camera, Ye = ge ? _ : N ? new $1W96c.OrthographicCamera(0, 0, 0, 0, 0.1, 1e3) : new $1W96c.PerspectiveCamera(75, 0, 0.1, 1e3);
                ge || (Ye.position.z = 5, _ && ($d7238066c5de7f1c$var$Ud(Ye, _), ("aspect" in _ || "left" in _ || "right" in _ || "bottom" in _ || "top" in _) && (Ye.manual = !0, Ye.updateProjectionMatrix())), !ie.camera && !(_ != null && _.rotation) && Ye.lookAt(0, 0, 0)), ie.set({
                    camera: Ye
                }), pe.camera = Ye;
            }
            if (!ie.scene) {
                let ge;
                A != null && A.isScene ? ge = A : (ge = new $1W96c.Scene(), A && $d7238066c5de7f1c$var$Ud(ge, A)), ie.set({
                    scene: $d7238066c5de7f1c$var$aA(ge)
                });
            }
            if (!ie.xr) {
                var te;
                const ge = (Xe, Te)=>{
                    const ct = s.getState();
                    ct.frameloop !== "never" && $d7238066c5de7f1c$var$KT(Xe, !0, ct, Te);
                }, Ye = ()=>{
                    const Xe = s.getState();
                    Xe.gl.xr.enabled = Xe.gl.xr.isPresenting, Xe.gl.xr.setAnimationLoop(Xe.gl.xr.isPresenting ? ge : null), Xe.gl.xr.isPresenting || $d7238066c5de7f1c$var$YT(Xe);
                }, Fe = {
                    connect () {
                        const Xe = s.getState().gl;
                        Xe.xr.addEventListener("sessionstart", Ye), Xe.xr.addEventListener("sessionend", Ye);
                    },
                    disconnect () {
                        const Xe = s.getState().gl;
                        Xe.xr.removeEventListener("sessionstart", Ye), Xe.xr.removeEventListener("sessionend", Ye);
                    }
                };
                typeof ((te = he.xr) == null ? void 0 : te.addEventListener) == "function" && Fe.connect(), ie.set({
                    xr: Fe
                });
            }
            if (he.shadowMap) {
                const ge = he.shadowMap.enabled, Ye = he.shadowMap.type;
                if (he.shadowMap.enabled = !!Z, $d7238066c5de7f1c$var$zn.boo(Z)) he.shadowMap.type = $1W96c.PCFSoftShadowMap;
                else if ($d7238066c5de7f1c$var$zn.str(Z)) {
                    var Ge;
                    const Fe = {
                        basic: $1W96c.BasicShadowMap,
                        percentage: $1W96c.PCFShadowMap,
                        soft: $1W96c.PCFSoftShadowMap,
                        variance: $1W96c.VSMShadowMap
                    };
                    he.shadowMap.type = (Ge = Fe[Z]) != null ? Ge : $1W96c.PCFSoftShadowMap;
                } else $d7238066c5de7f1c$var$zn.obj(Z) && Object.assign(he.shadowMap, Z);
                (ge !== he.shadowMap.enabled || Ye !== he.shadowMap.type) && (he.shadowMap.needsUpdate = !0);
            }
            const q = $d7238066c5de7f1c$var$FP();
            q && ("enabled" in q ? q.enabled = !H : "legacyMode" in q && (q.legacyMode = H)), g || $d7238066c5de7f1c$var$Ud(he, {
                outputEncoding: v ? 3e3 : 3001,
                toneMapping: V ? $1W96c.NoToneMapping : $1W96c.ACESFilmicToneMapping
            }), ie.legacy !== H && ie.set(()=>({
                    legacy: H
                })), ie.linear !== v && ie.set(()=>({
                    linear: v
                })), ie.flat !== V && ie.set(()=>({
                    flat: V
                })), d && !$d7238066c5de7f1c$var$zn.fun(d) && !$d7238066c5de7f1c$var$_P(d) && !$d7238066c5de7f1c$var$zn.equ(d, he, $d7238066c5de7f1c$var$Dm) && $d7238066c5de7f1c$var$Ud(he, d), y && !ie.events.handlers && ie.set({
                events: y(s)
            });
            const de = $d7238066c5de7f1c$var$WCe(r, p);
            return $d7238066c5de7f1c$var$zn.equ(de, ie.size, $d7238066c5de7f1c$var$Dm) || ie.setSize(de.width, de.height, de.updateStyle, de.top, de.left), K && ie.viewport.dpr !== $d7238066c5de7f1c$var$EP(K) && ie.setDpr(K), ie.frameloop !== Y && ie.setFrameloop(Y), ie.onPointerMissed || ie.set({
                onPointerMissed: O
            }), z && !$d7238066c5de7f1c$var$zn.equ(z, ie.performance, $d7238066c5de7f1c$var$Dm) && ie.set((ge)=>({
                    performance: {
                        ...ge.performance,
                        ...z
                    }
                })), o = G, g = !0, this;
        },
        render (c) {
            return g || this.configure(), $d7238066c5de7f1c$var$GB.updateContainer(/* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$XCe, {
                store: s,
                children: c,
                onCreated: o,
                rootElement: r
            }), a, null, ()=>{}), s;
        },
        unmount () {
            $d7238066c5de7f1c$var$QP(r);
        }
    };
}
function $d7238066c5de7f1c$var$XCe({ store: r, children: e, onCreated: t, rootElement: i }) {
    return $d7238066c5de7f1c$var$sf(()=>{
        const n = r.getState();
        n.set((s)=>({
                internal: {
                    ...s.internal,
                    active: !0
                }
            })), t && t(n), r.getState().events.connected || n.events.connect == null || n.events.connect(i);
    }, []), /* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$$Y.Provider, {
        value: r,
        children: e
    });
}
function $d7238066c5de7f1c$var$QP(r, e) {
    const t = $d7238066c5de7f1c$var$_A.get(r), i = t == null ? void 0 : t.fiber;
    if (i) {
        const n = t == null ? void 0 : t.store.getState();
        n && (n.internal.active = !1), $d7238066c5de7f1c$var$GB.updateContainer(null, i, null, ()=>{
            n && setTimeout(()=>{
                try {
                    var s, a, o, g;
                    n.events.disconnect == null || n.events.disconnect(), (s = n.gl) == null || (a = s.renderLists) == null || a.dispose == null || a.dispose(), (o = n.gl) == null || o.forceContextLoss == null || o.forceContextLoss(), (g = n.gl) != null && g.xr && n.xr.disconnect(), $d7238066c5de7f1c$var$ACe(n), $d7238066c5de7f1c$var$_A.delete(r);
                } catch  {}
            }, 500);
        });
    }
}
function $d7238066c5de7f1c$var$NCe(r, e, t) {
    return /* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$LCe, {
        children: r,
        container: e,
        state: t
    }, e.uuid);
}
function $d7238066c5de7f1c$var$LCe({ state: r = {}, children: e, container: t }) {
    const { events: i, size: n, ...s } = r, a = $d7238066c5de7f1c$var$eK(), [o] = $bxRTa.useState(()=>new $1W96c.Raycaster()), [g] = $bxRTa.useState(()=>new $1W96c.Vector2()), l = $bxRTa.useCallback((d, p)=>{
        const A = {
            ...d
        };
        Object.keys(d).forEach((G)=>{
            // Some props should be off-limits
            ($d7238066c5de7f1c$var$GCe.includes(G) || // Otherwise filter out the props that are different and let the inject layer take precedence
            // Unless the inject layer props is undefined, then we keep the root layer
            d[G] !== p[G] && p[G]) && delete A[G];
        });
        let y;
        if (p && n) {
            const G = p.camera;
            y = d.viewport.getCurrentViewport(G, new $1W96c.Vector3(), n), G !== d.camera && $d7238066c5de7f1c$var$UP(G, n);
        }
        return {
            // The intersect consists of the previous root state
            ...A,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: t,
            raycaster: o,
            pointer: g,
            mouse: g,
            // Their previous root is the layer before it
            previousRoot: a,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...d.events,
                ...p == null ? void 0 : p.events,
                ...i
            },
            size: {
                ...d.size,
                ...n
            },
            viewport: {
                ...d.viewport,
                ...y
            },
            ...s
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        r
    ]), [c] = $bxRTa.useState(()=>{
        const d = a.getState();
        return $d7238066c5de7f1c$var$LP((A, y)=>({
                ...d,
                scene: t,
                raycaster: o,
                pointer: g,
                mouse: g,
                previousRoot: a,
                events: {
                    ...d.events,
                    ...i
                },
                size: {
                    ...d.size,
                    ...n
                },
                ...s,
                // Set and get refer to this root-state
                set: A,
                get: y,
                // Layers are allowed to override events
                setEvents: (G)=>A((Z)=>({
                            ...Z,
                            events: {
                                ...Z.events,
                                ...G
                            }
                        }))
            }));
    });
    return $bxRTa.useEffect(()=>{
        const d = a.subscribe((p)=>c.setState((A)=>l(p, A)));
        return ()=>{
            d();
        };
    }, [
        l
    ]), $bxRTa.useEffect(()=>{
        c.setState((d)=>l(a.getState(), d));
    }, [
        l
    ]), $bxRTa.useEffect(()=>()=>{
            c.destroy();
        }, []), /* @__PURE__ */ (0, $fl9nK.jsx)((0, $fl9nK.Fragment), {
        children: $d7238066c5de7f1c$var$GB.createPortal(/* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$$Y.Provider, {
            value: c,
            children: e
        }), c, null)
    });
}
$d7238066c5de7f1c$var$GB.injectIntoDevTools({
    bundleType: 0,
    rendererPackageName: "@react-three/fiber",
    version: $bxRTa.version
});
const $d7238066c5de7f1c$var$sX = {
    onClick: [
        "click",
        !1
    ],
    onContextMenu: [
        "contextmenu",
        !1
    ],
    onDoubleClick: [
        "dblclick",
        !1
    ],
    onWheel: [
        "wheel",
        !0
    ],
    onPointerDown: [
        "pointerdown",
        !0
    ],
    onPointerUp: [
        "pointerup",
        !0
    ],
    onPointerLeave: [
        "pointerleave",
        !0
    ],
    onPointerMove: [
        "pointermove",
        !0
    ],
    onPointerCancel: [
        "pointercancel",
        !0
    ],
    onLostPointerCapture: [
        "lostpointercapture",
        !0
    ]
};
function $d7238066c5de7f1c$var$YCe(r) {
    const { handlePointer: e } = $d7238066c5de7f1c$var$fCe(r);
    return {
        priority: 1,
        enabled: !0,
        compute (t, i, n) {
            i.pointer.set(t.offsetX / i.size.width * 2 - 1, -(t.offsetY / i.size.height) * 2 + 1), i.raycaster.setFromCamera(i.pointer, i.camera);
        },
        connected: void 0,
        handlers: Object.keys($d7238066c5de7f1c$var$sX).reduce((t, i)=>({
                ...t,
                [i]: e(i)
            }), {}),
        update: ()=>{
            var t;
            const { events: i, internal: n } = r.getState();
            (t = n.lastEvent) != null && t.current && i.handlers && i.handlers.onPointerMove(n.lastEvent.current);
        },
        connect: (t)=>{
            var i;
            const { set: n, events: s } = r.getState();
            s.disconnect == null || s.disconnect(), n((a)=>({
                    events: {
                        ...a.events,
                        connected: t
                    }
                })), Object.entries((i = s.handlers) != null ? i : []).forEach(([a, o])=>{
                const [g, l] = $d7238066c5de7f1c$var$sX[a];
                t.addEventListener(g, o, {
                    passive: l
                });
            });
        },
        disconnect: ()=>{
            const { set: t, events: i } = r.getState();
            if (i.connected) {
                var n;
                Object.entries((n = i.handlers) != null ? n : []).forEach(([s, a])=>{
                    if (i && i.connected instanceof HTMLElement) {
                        const [o] = $d7238066c5de7f1c$var$sX[s];
                        i.connected.removeEventListener(o, a);
                    }
                }), t((s)=>({
                        events: {
                            ...s.events,
                            connected: void 0
                        }
                    }));
            }
        }
    };
}
function $d7238066c5de7f1c$var$xT(r, e) {
    let t;
    return (...i)=>{
        window.clearTimeout(t), t = window.setTimeout(()=>r(...i), e);
    };
}
function $d7238066c5de7f1c$var$KCe({ debounce: r, scroll: e, polyfill: t, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const n = t || (typeof window > "u" ? class {
    } : window.ResizeObserver);
    if (!n) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [s, a] = (0, $bxRTa.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), o = (0, $bxRTa.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: s,
        orientationHandler: null
    }), g = r ? typeof r == "number" ? r : r.scroll : null, l = r ? typeof r == "number" ? r : r.resize : null, c = (0, $bxRTa.useRef)(!1);
    (0, $bxRTa.useEffect)(()=>(c.current = !0, ()=>void (c.current = !1)));
    const [d, p, A] = (0, $bxRTa.useMemo)(()=>{
        const v = ()=>{
            if (!o.current.element) return;
            const { left: V, top: H, width: N, height: Y, bottom: K, right: z, x: M, y: _ } = o.current.element.getBoundingClientRect(), O = {
                left: V,
                top: H,
                width: N,
                height: Y,
                bottom: K,
                right: z,
                x: M,
                y: _
            };
            o.current.element instanceof HTMLElement && i && (O.height = o.current.element.offsetHeight, O.width = o.current.element.offsetWidth), Object.freeze(O), c.current && !$d7238066c5de7f1c$var$MCe(o.current.lastBounds, O) && a(o.current.lastBounds = O);
        };
        return [
            v,
            l ? $d7238066c5de7f1c$var$xT(v, l) : v,
            g ? $d7238066c5de7f1c$var$xT(v, g) : v
        ];
    }, [
        a,
        i,
        g,
        l
    ]);
    function y() {
        o.current.scrollContainers && (o.current.scrollContainers.forEach((v)=>v.removeEventListener("scroll", A, !0)), o.current.scrollContainers = null), o.current.resizeObserver && (o.current.resizeObserver.disconnect(), o.current.resizeObserver = null), o.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", o.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", o.current.orientationHandler));
    }
    function G() {
        o.current.element && (o.current.resizeObserver = new n(A), o.current.resizeObserver.observe(o.current.element), e && o.current.scrollContainers && o.current.scrollContainers.forEach((v)=>v.addEventListener("scroll", A, {
                capture: !0,
                passive: !0
            })), o.current.orientationHandler = ()=>{
            A();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", o.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", o.current.orientationHandler));
    }
    const Z = (v)=>{
        !v || v === o.current.element || (y(), o.current.element = v, o.current.scrollContainers = $d7238066c5de7f1c$var$OP(v), G());
    };
    return $d7238066c5de7f1c$var$FCe(A, !!e), $d7238066c5de7f1c$var$xCe(p), (0, $bxRTa.useEffect)(()=>{
        y(), G();
    }, [
        e,
        A,
        p
    ]), (0, $bxRTa.useEffect)(()=>y, []), [
        Z,
        s,
        d
    ];
}
function $d7238066c5de7f1c$var$xCe(r) {
    (0, $bxRTa.useEffect)(()=>{
        const e = r;
        return window.addEventListener("resize", e), ()=>void window.removeEventListener("resize", e);
    }, [
        r
    ]);
}
function $d7238066c5de7f1c$var$FCe(r, e) {
    (0, $bxRTa.useEffect)(()=>{
        if (e) {
            const t = r;
            return window.addEventListener("scroll", t, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", t, !0);
        }
    }, [
        r,
        e
    ]);
}
function $d7238066c5de7f1c$var$OP(r) {
    const e = [];
    if (!r || r === document.body) return e;
    const { overflow: t, overflowX: i, overflowY: n } = window.getComputedStyle(r);
    return [
        t,
        i,
        n
    ].some((s)=>s === "auto" || s === "scroll") && e.push(r), [
        ...e,
        ...$d7238066c5de7f1c$var$OP(r.parentElement)
    ];
}
const $d7238066c5de7f1c$var$TCe = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $d7238066c5de7f1c$var$MCe = (r, e)=>$d7238066c5de7f1c$var$TCe.every((t)=>r[t] === e[t]);
var $d7238066c5de7f1c$var$zCe = Object.defineProperty, $d7238066c5de7f1c$var$kCe = Object.defineProperties, $d7238066c5de7f1c$var$ECe = Object.getOwnPropertyDescriptors, $d7238066c5de7f1c$var$FT = Object.getOwnPropertySymbols, $d7238066c5de7f1c$var$JCe = Object.prototype.hasOwnProperty, $d7238066c5de7f1c$var$UCe = Object.prototype.propertyIsEnumerable, $d7238066c5de7f1c$var$TT = (r, e, t)=>e in r ? $d7238066c5de7f1c$var$zCe(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $d7238066c5de7f1c$var$MT = (r, e)=>{
    for(var t in e || (e = {}))$d7238066c5de7f1c$var$JCe.call(e, t) && $d7238066c5de7f1c$var$TT(r, t, e[t]);
    if ($d7238066c5de7f1c$var$FT) for (var t of $d7238066c5de7f1c$var$FT(e))$d7238066c5de7f1c$var$UCe.call(e, t) && $d7238066c5de7f1c$var$TT(r, t, e[t]);
    return r;
}, $d7238066c5de7f1c$var$DCe = (r, e)=>$d7238066c5de7f1c$var$kCe(r, $d7238066c5de7f1c$var$ECe(e)), $d7238066c5de7f1c$var$zT, $d7238066c5de7f1c$var$kT;
typeof window < "u" && (($d7238066c5de7f1c$var$zT = window.document) != null && $d7238066c5de7f1c$var$zT.createElement || (($d7238066c5de7f1c$var$kT = window.navigator) == null ? void 0 : $d7238066c5de7f1c$var$kT.product) === "ReactNative") ? $bxRTa.useLayoutEffect : $bxRTa.useEffect;
function $d7238066c5de7f1c$var$jP(r, e, t) {
    if (!r) return;
    if (t(r) === !0) return r;
    let i = r.child;
    for(; i;){
        const n = $d7238066c5de7f1c$var$jP(i, e, t);
        if (n) return n;
        i = i.sibling;
    }
}
function $d7238066c5de7f1c$var$qP(r) {
    try {
        return Object.defineProperties(r, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch  {
        return r;
    }
}
const $d7238066c5de7f1c$var$ET = console.error;
console.error = function() {
    const r = [
        ...arguments
    ].join("");
    if (r != null && r.startsWith("Warning:") && r.includes("useContext")) {
        console.error = $d7238066c5de7f1c$var$ET;
        return;
    }
    return $d7238066c5de7f1c$var$ET.apply(this, arguments);
};
const $d7238066c5de7f1c$var$tK = $d7238066c5de7f1c$var$qP($bxRTa.createContext(null));
class $d7238066c5de7f1c$var$$P extends $bxRTa.Component {
    render() {
        return /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$tK.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $d7238066c5de7f1c$var$_Ce() {
    const r = $bxRTa.useContext($d7238066c5de7f1c$var$tK);
    if (r === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const e = $bxRTa.useId();
    return $bxRTa.useMemo(()=>{
        for (const i of [
            r,
            r == null ? void 0 : r.alternate
        ]){
            if (!i) continue;
            const n = $d7238066c5de7f1c$var$jP(i, !1, (s)=>{
                let a = s.memoizedState;
                for(; a;){
                    if (a.memoizedState === e) return !0;
                    a = a.next;
                }
            });
            if (n) return n;
        }
    }, [
        r,
        e
    ]);
}
function $d7238066c5de7f1c$var$PCe() {
    const r = $d7238066c5de7f1c$var$_Ce(), [e] = $bxRTa.useState(()=>/* @__PURE__ */ new Map());
    e.clear();
    let t = r;
    for(; t;){
        if (t.type && typeof t.type == "object") {
            const n = t.type._context === void 0 && t.type.Provider === t.type ? t.type : t.type._context;
            n && n !== $d7238066c5de7f1c$var$tK && !e.has(n) && e.set(n, $bxRTa.useContext($d7238066c5de7f1c$var$qP(n)));
        }
        t = t.return;
    }
    return e;
}
function $d7238066c5de7f1c$var$QCe() {
    const r = $d7238066c5de7f1c$var$PCe();
    return $bxRTa.useMemo(()=>Array.from(r.keys()).reduce((e, t)=>(i)=>/* @__PURE__ */ $bxRTa.createElement(e, null, /* @__PURE__ */ $bxRTa.createElement(t.Provider, $d7238066c5de7f1c$var$DCe($d7238066c5de7f1c$var$MT({}, i), {
                    value: r.get(t)
                }))), (e)=>/* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$$P, $d7238066c5de7f1c$var$MT({}, e))), [
        r
    ]);
}
const $d7238066c5de7f1c$var$OCe = /* @__PURE__ */ $bxRTa.forwardRef(function({ children: e, fallback: t, resize: i, style: n, gl: s, events: a = $d7238066c5de7f1c$var$YCe, eventSource: o, eventPrefix: g, shadows: l, linear: c, flat: d, legacy: p, orthographic: A, frameloop: y, dpr: G, performance: Z, raycaster: v, camera: V, scene: H, onPointerMissed: N, onCreated: Y, ...K }, z) {
    $bxRTa.useMemo(()=>$d7238066c5de7f1c$var$qY($1W96c), []);
    const M = $d7238066c5de7f1c$var$QCe(), [_, O] = $d7238066c5de7f1c$var$KCe({
        scroll: !0,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...i
    }), ie = $bxRTa.useRef(null), he = $bxRTa.useRef(null);
    $bxRTa.useImperativeHandle(z, ()=>ie.current);
    const pe = $d7238066c5de7f1c$var$MP(N), [ce, $] = $bxRTa.useState(!1), [te, Ge] = $bxRTa.useState(!1);
    if (ce) throw ce;
    if (te) throw te;
    const q = $bxRTa.useRef(null);
    return $d7238066c5de7f1c$var$sf(()=>{
        const ge = ie.current;
        O.width > 0 && O.height > 0 && ge && (q.current || (q.current = $d7238066c5de7f1c$var$HCe(ge)), q.current.configure({
            gl: s,
            events: a,
            shadows: l,
            linear: c,
            flat: d,
            legacy: p,
            orthographic: A,
            frameloop: y,
            dpr: G,
            performance: Z,
            raycaster: v,
            camera: V,
            scene: H,
            size: O,
            // Pass mutable reference to onPointerMissed so it's free to update
            onPointerMissed: (...Ye)=>pe.current == null ? void 0 : pe.current(...Ye),
            onCreated: (Ye)=>{
                Ye.events.connect == null || Ye.events.connect(o ? $d7238066c5de7f1c$var$hCe(o) ? o.current : o : he.current), g && Ye.setEvents({
                    compute: (Fe, Xe)=>{
                        const Te = Fe[g + "X"], ct = Fe[g + "Y"];
                        Xe.pointer.set(Te / Xe.size.width * 2 - 1, -(ct / Xe.size.height) * 2 + 1), Xe.raycaster.setFromCamera(Xe.pointer, Xe.camera);
                    }
                }), Y == null || Y(Ye);
            }
        }), q.current.render(/* @__PURE__ */ (0, $fl9nK.jsx)(M, {
            children: /* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$zP, {
                set: Ge,
                children: /* @__PURE__ */ (0, $fl9nK.jsx)($bxRTa.Suspense, {
                    fallback: /* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$CCe, {
                        set: $
                    }),
                    children: e ?? null
                })
            })
        })));
    }), $bxRTa.useEffect(()=>{
        const ge = ie.current;
        if (ge) return ()=>$d7238066c5de7f1c$var$QP(ge);
    }, []), /* @__PURE__ */ (0, $fl9nK.jsx)("div", {
        ref: he,
        style: {
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: o ? "none" : "auto",
            ...n
        },
        ...K,
        children: /* @__PURE__ */ (0, $fl9nK.jsx)("div", {
            ref: _,
            style: {
                width: "100%",
                height: "100%"
            },
            children: /* @__PURE__ */ (0, $fl9nK.jsx)("canvas", {
                ref: ie,
                style: {
                    display: "block"
                },
                children: t
            })
        })
    });
}), $d7238066c5de7f1c$var$jCe = /* @__PURE__ */ $bxRTa.forwardRef(function(e, t) {
    return /* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$$P, {
        children: /* @__PURE__ */ (0, $fl9nK.jsx)($d7238066c5de7f1c$var$OCe, {
            ...e,
            ref: t
        })
    });
}), $d7238066c5de7f1c$var$eQ = parseInt((0, $329ek.REVISION).replace(/\D+/g, ""));
var $d7238066c5de7f1c$var$Og = Uint8Array, $d7238066c5de7f1c$var$$d = Uint16Array, $d7238066c5de7f1c$var$aN = Uint32Array, $d7238066c5de7f1c$var$tQ = new $d7238066c5de7f1c$var$Og([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]), $d7238066c5de7f1c$var$iQ = new $d7238066c5de7f1c$var$Og([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]), $d7238066c5de7f1c$var$qCe = new $d7238066c5de7f1c$var$Og([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $d7238066c5de7f1c$var$nQ = function(r, e) {
    for(var t = new $d7238066c5de7f1c$var$$d(31), i = 0; i < 31; ++i)t[i] = e += 1 << r[i - 1];
    for(var n = new $d7238066c5de7f1c$var$aN(t[30]), i = 1; i < 30; ++i)for(var s = t[i]; s < t[i + 1]; ++s)n[s] = s - t[i] << 5 | i;
    return [
        t,
        n
    ];
}, $d7238066c5de7f1c$var$sQ = $d7238066c5de7f1c$var$nQ($d7238066c5de7f1c$var$tQ, 2), $d7238066c5de7f1c$var$rQ = $d7238066c5de7f1c$var$sQ[0], $d7238066c5de7f1c$var$$Ce = $d7238066c5de7f1c$var$sQ[1];
$d7238066c5de7f1c$var$rQ[28] = 258, $d7238066c5de7f1c$var$$Ce[258] = 28;
var $d7238066c5de7f1c$var$epe = $d7238066c5de7f1c$var$nQ($d7238066c5de7f1c$var$iQ, 0), $d7238066c5de7f1c$var$tpe = $d7238066c5de7f1c$var$epe[0], $d7238066c5de7f1c$var$oN = new $d7238066c5de7f1c$var$$d(32768);
for(var $d7238066c5de7f1c$var$ss = 0; $d7238066c5de7f1c$var$ss < 32768; ++$d7238066c5de7f1c$var$ss){
    var $d7238066c5de7f1c$var$Fd = ($d7238066c5de7f1c$var$ss & 43690) >>> 1 | ($d7238066c5de7f1c$var$ss & 21845) << 1;
    $d7238066c5de7f1c$var$Fd = ($d7238066c5de7f1c$var$Fd & 52428) >>> 2 | ($d7238066c5de7f1c$var$Fd & 13107) << 2, $d7238066c5de7f1c$var$Fd = ($d7238066c5de7f1c$var$Fd & 61680) >>> 4 | ($d7238066c5de7f1c$var$Fd & 3855) << 4, $d7238066c5de7f1c$var$oN[$d7238066c5de7f1c$var$ss] = (($d7238066c5de7f1c$var$Fd & 65280) >>> 8 | ($d7238066c5de7f1c$var$Fd & 255) << 8) >>> 1;
}
var $d7238066c5de7f1c$var$Oy = function(r, e, t) {
    for(var i = r.length, n = 0, s = new $d7238066c5de7f1c$var$$d(e); n < i; ++n)++s[r[n] - 1];
    var a = new $d7238066c5de7f1c$var$$d(e);
    for(n = 0; n < e; ++n)a[n] = a[n - 1] + s[n - 1] << 1;
    var o;
    if (t) {
        o = new $d7238066c5de7f1c$var$$d(1 << e);
        var g = 15 - e;
        for(n = 0; n < i; ++n)if (r[n]) for(var l = n << 4 | r[n], c = e - r[n], d = a[r[n] - 1]++ << c, p = d | (1 << c) - 1; d <= p; ++d)o[$d7238066c5de7f1c$var$oN[d] >>> g] = l;
    } else for(o = new $d7238066c5de7f1c$var$$d(i), n = 0; n < i; ++n)r[n] && (o[n] = $d7238066c5de7f1c$var$oN[a[r[n] - 1]++] >>> 15 - r[n]);
    return o;
}, $d7238066c5de7f1c$var$rf = new $d7238066c5de7f1c$var$Og(288);
for(var $d7238066c5de7f1c$var$ss = 0; $d7238066c5de7f1c$var$ss < 144; ++$d7238066c5de7f1c$var$ss)$d7238066c5de7f1c$var$rf[$d7238066c5de7f1c$var$ss] = 8;
for(var $d7238066c5de7f1c$var$ss = 144; $d7238066c5de7f1c$var$ss < 256; ++$d7238066c5de7f1c$var$ss)$d7238066c5de7f1c$var$rf[$d7238066c5de7f1c$var$ss] = 9;
for(var $d7238066c5de7f1c$var$ss = 256; $d7238066c5de7f1c$var$ss < 280; ++$d7238066c5de7f1c$var$ss)$d7238066c5de7f1c$var$rf[$d7238066c5de7f1c$var$ss] = 7;
for(var $d7238066c5de7f1c$var$ss = 280; $d7238066c5de7f1c$var$ss < 288; ++$d7238066c5de7f1c$var$ss)$d7238066c5de7f1c$var$rf[$d7238066c5de7f1c$var$ss] = 8;
var $d7238066c5de7f1c$var$aQ = new $d7238066c5de7f1c$var$Og(32);
for(var $d7238066c5de7f1c$var$ss = 0; $d7238066c5de7f1c$var$ss < 32; ++$d7238066c5de7f1c$var$ss)$d7238066c5de7f1c$var$aQ[$d7238066c5de7f1c$var$ss] = 5;
var $d7238066c5de7f1c$var$ipe = /* @__PURE__ */ $d7238066c5de7f1c$var$Oy($d7238066c5de7f1c$var$rf, 9, 1), $d7238066c5de7f1c$var$npe = /* @__PURE__ */ $d7238066c5de7f1c$var$Oy($d7238066c5de7f1c$var$aQ, 5, 1), $d7238066c5de7f1c$var$rX = function(r) {
    for(var e = r[0], t = 1; t < r.length; ++t)r[t] > e && (e = r[t]);
    return e;
}, $d7238066c5de7f1c$var$Ml = function(r, e, t) {
    var i = e / 8 | 0;
    return (r[i] | r[i + 1] << 8) >> (e & 7) & t;
}, $d7238066c5de7f1c$var$aX = function(r, e) {
    var t = e / 8 | 0;
    return (r[t] | r[t + 1] << 8 | r[t + 2] << 16) >> (e & 7);
}, $d7238066c5de7f1c$var$spe = function(r) {
    return (r / 8 | 0) + (r & 7 && 1);
}, $d7238066c5de7f1c$var$rpe = function(r, e, t) {
    (t == null || t > r.length) && (t = r.length);
    var i = new (r instanceof $d7238066c5de7f1c$var$$d ? $d7238066c5de7f1c$var$$d : r instanceof $d7238066c5de7f1c$var$aN ? $d7238066c5de7f1c$var$aN : $d7238066c5de7f1c$var$Og)(t - e);
    return i.set(r.subarray(e, t)), i;
}, $d7238066c5de7f1c$var$ape = function(r, e, t) {
    var i = r.length;
    if (!i || t && !t.l && i < 5) return e || new $d7238066c5de7f1c$var$Og(0);
    var n = !e || t, s = !t || t.i;
    t || (t = {}), e || (e = new $d7238066c5de7f1c$var$Og(i * 3));
    var a = function(st) {
        var Xt = e.length;
        if (st > Xt) {
            var Mi = new $d7238066c5de7f1c$var$Og(Math.max(Xt * 2, st));
            Mi.set(e), e = Mi;
        }
    }, o = t.f || 0, g = t.p || 0, l = t.b || 0, c = t.l, d = t.d, p = t.m, A = t.n, y = i * 8;
    do {
        if (!c) {
            t.f = o = $d7238066c5de7f1c$var$Ml(r, g, 1);
            var G = $d7238066c5de7f1c$var$Ml(r, g + 1, 3);
            if (g += 3, G) {
                if (G == 1) c = $d7238066c5de7f1c$var$ipe, d = $d7238066c5de7f1c$var$npe, p = 9, A = 5;
                else if (G == 2) {
                    var H = $d7238066c5de7f1c$var$Ml(r, g, 31) + 257, N = $d7238066c5de7f1c$var$Ml(r, g + 10, 15) + 4, Y = H + $d7238066c5de7f1c$var$Ml(r, g + 5, 31) + 1;
                    g += 14;
                    for(var K = new $d7238066c5de7f1c$var$Og(Y), z = new $d7238066c5de7f1c$var$Og(19), M = 0; M < N; ++M)z[$d7238066c5de7f1c$var$qCe[M]] = $d7238066c5de7f1c$var$Ml(r, g + M * 3, 7);
                    g += N * 3;
                    for(var _ = $d7238066c5de7f1c$var$rX(z), O = (1 << _) - 1, ie = $d7238066c5de7f1c$var$Oy(z, _, 1), M = 0; M < Y;){
                        var he = ie[$d7238066c5de7f1c$var$Ml(r, g, O)];
                        g += he & 15;
                        var Z = he >>> 4;
                        if (Z < 16) K[M++] = Z;
                        else {
                            var pe = 0, ce = 0;
                            for(Z == 16 ? (ce = 3 + $d7238066c5de7f1c$var$Ml(r, g, 3), g += 2, pe = K[M - 1]) : Z == 17 ? (ce = 3 + $d7238066c5de7f1c$var$Ml(r, g, 7), g += 3) : Z == 18 && (ce = 11 + $d7238066c5de7f1c$var$Ml(r, g, 127), g += 7); ce--;)K[M++] = pe;
                        }
                    }
                    var $ = K.subarray(0, H), te = K.subarray(H);
                    p = $d7238066c5de7f1c$var$rX($), A = $d7238066c5de7f1c$var$rX(te), c = $d7238066c5de7f1c$var$Oy($, p, 1), d = $d7238066c5de7f1c$var$Oy(te, A, 1);
                } else throw "invalid block type";
            } else {
                var Z = $d7238066c5de7f1c$var$spe(g) + 4, v = r[Z - 4] | r[Z - 3] << 8, V = Z + v;
                if (V > i) {
                    if (s) throw "unexpected EOF";
                    break;
                }
                n && a(l + v), e.set(r.subarray(Z, V), l), t.b = l += v, t.p = g = V * 8;
                continue;
            }
            if (g > y) {
                if (s) throw "unexpected EOF";
                break;
            }
        }
        n && a(l + 131072);
        for(var Ge = (1 << p) - 1, q = (1 << A) - 1, de = g;; de = g){
            var pe = c[$d7238066c5de7f1c$var$aX(r, g) & Ge], ge = pe >>> 4;
            if (g += pe & 15, g > y) {
                if (s) throw "unexpected EOF";
                break;
            }
            if (!pe) throw "invalid length/literal";
            if (ge < 256) e[l++] = ge;
            else if (ge == 256) {
                de = g, c = null;
                break;
            } else {
                var Ye = ge - 254;
                if (ge > 264) {
                    var M = ge - 257, Fe = $d7238066c5de7f1c$var$tQ[M];
                    Ye = $d7238066c5de7f1c$var$Ml(r, g, (1 << Fe) - 1) + $d7238066c5de7f1c$var$rQ[M], g += Fe;
                }
                var Xe = d[$d7238066c5de7f1c$var$aX(r, g) & q], Te = Xe >>> 4;
                if (!Xe) throw "invalid distance";
                g += Xe & 15;
                var te = $d7238066c5de7f1c$var$tpe[Te];
                if (Te > 3) {
                    var Fe = $d7238066c5de7f1c$var$iQ[Te];
                    te += $d7238066c5de7f1c$var$aX(r, g) & (1 << Fe) - 1, g += Fe;
                }
                if (g > y) {
                    if (s) throw "unexpected EOF";
                    break;
                }
                n && a(l + 131072);
                for(var ct = l + Ye; l < ct; l += 4)e[l] = e[l - te], e[l + 1] = e[l + 1 - te], e[l + 2] = e[l + 2 - te], e[l + 3] = e[l + 3 - te];
                l = ct;
            }
        }
        t.l = c, t.p = de, t.b = l, c && (o = 1, t.m = p, t.d = d, t.n = A);
    }while (!o);
    return l == e.length ? e : $d7238066c5de7f1c$var$rpe(e, 0, l);
}, $d7238066c5de7f1c$var$ope = /* @__PURE__ */ new $d7238066c5de7f1c$var$Og(0), $d7238066c5de7f1c$var$gpe = function(r) {
    if ((r[0] & 15) != 8 || r[0] >>> 4 > 7 || (r[0] << 8 | r[1]) % 31) throw "invalid zlib data";
    if (r[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
function $d7238066c5de7f1c$var$sS(r, e) {
    return $d7238066c5de7f1c$var$ape(($d7238066c5de7f1c$var$gpe(r), r.subarray(2, -4)), e);
}
var $d7238066c5de7f1c$var$lpe = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), $d7238066c5de7f1c$var$cpe = 0;
try {
    $d7238066c5de7f1c$var$lpe.decode($d7238066c5de7f1c$var$ope, {
        stream: !0
    }), $d7238066c5de7f1c$var$cpe = 1;
} catch  {}
const $d7238066c5de7f1c$var$upe = (r)=>r && r.isCubeTexture;
class $d7238066c5de7f1c$var$Ipe extends (0, $329ek.Mesh) {
    constructor(e, t){
        var i, n;
        const s = $d7238066c5de7f1c$var$upe(e), o = ((n = s ? (i = e.image[0]) == null ? void 0 : i.width : e.image.width) != null ? n : 1024) / 4, g = Math.floor(Math.log2(o)), l = Math.pow(2, g), c = 3 * Math.max(l, 112), d = 4 * l, p = [
            s ? "#define ENVMAP_TYPE_CUBE" : "",
            `#define CUBEUV_TEXEL_WIDTH ${1 / c}`,
            `#define CUBEUV_TEXEL_HEIGHT ${1 / d}`,
            `#define CUBEUV_MAX_MIP ${g}.0`
        ], A = /* glsl */ `
        varying vec3 vWorldPosition;
        void main() 
        {
            vec4 worldPosition = ( modelMatrix * vec4( position, 1.0 ) );
            vWorldPosition = worldPosition.xyz;
            
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
        `, y = p.join(`
`) + /* glsl */ `
        #define ENVMAP_TYPE_CUBE_UV
        varying vec3 vWorldPosition;
        uniform float radius;
        uniform float height;
        uniform float angle;
        #ifdef ENVMAP_TYPE_CUBE
            uniform samplerCube map;
        #else
            uniform sampler2D map;
        #endif
        // From: https://www.shadertoy.com/view/4tsBD7
        float diskIntersectWithBackFaceCulling( vec3 ro, vec3 rd, vec3 c, vec3 n, float r ) 
        {
            float d = dot ( rd, n );
            
            if( d > 0.0 ) { return 1e6; }
            
            vec3  o = ro - c;
            float t = - dot( n, o ) / d;
            vec3  q = o + rd * t;
            
            return ( dot( q, q ) < r * r ) ? t : 1e6;
        }
        // From: https://www.iquilezles.org/www/articles/intersectors/intersectors.htm
        float sphereIntersect( vec3 ro, vec3 rd, vec3 ce, float ra ) 
        {
            vec3 oc = ro - ce;
            float b = dot( oc, rd );
            float c = dot( oc, oc ) - ra * ra;
            float h = b * b - c;
            
            if( h < 0.0 ) { return -1.0; }
            
            h = sqrt( h );
            
            return - b + h;
        }
        vec3 project() 
        {
            vec3 p = normalize( vWorldPosition );
            vec3 camPos = cameraPosition;
            camPos.y -= height;
            float intersection = sphereIntersect( camPos, p, vec3( 0.0 ), radius );
            if( intersection > 0.0 ) {
                
                vec3 h = vec3( 0.0, - height, 0.0 );
                float intersection2 = diskIntersectWithBackFaceCulling( camPos, p, h, vec3( 0.0, 1.0, 0.0 ), radius );
                p = ( camPos + min( intersection, intersection2 ) * p ) / radius;
            } else {
                p = vec3( 0.0, 1.0, 0.0 );
            }
            return p;
        }
        #include <common>
        #include <cube_uv_reflection_fragment>
        void main() 
        {
            vec3 projectedWorldPosition = project();
            
            #ifdef ENVMAP_TYPE_CUBE
                vec3 outcolor = textureCube( map, projectedWorldPosition ).rgb;
            #else
                vec3 direction = normalize( projectedWorldPosition );
                vec2 uv = equirectUv( direction );
                vec3 outcolor = texture2D( map, uv ).rgb;
            #endif
            gl_FragColor = vec4( outcolor, 1.0 );
            #include <tonemapping_fragment>
            #include <${$d7238066c5de7f1c$var$eQ >= 154 ? "colorspace_fragment" : "encodings_fragment"}>
        }
        `, G = {
            map: {
                value: e
            },
            height: {
                value: (t == null ? void 0 : t.height) || 15
            },
            radius: {
                value: (t == null ? void 0 : t.radius) || 100
            }
        }, Z = new (0, $329ek.IcosahedronGeometry)(1, 16), v = new (0, $329ek.ShaderMaterial)({
            uniforms: G,
            fragmentShader: y,
            vertexShader: A,
            side: (0, $329ek.DoubleSide)
        });
        super(Z, v);
    }
    set radius(e) {
        this.material.uniforms.radius.value = e;
    }
    get radius() {
        return this.material.uniforms.radius.value;
    }
    set height(e) {
        this.material.uniforms.height.value = e;
    }
    get height() {
        return this.material.uniforms.height.value;
    }
}
class $d7238066c5de7f1c$var$dpe extends (0, $329ek.DataTextureLoader) {
    constructor(e){
        super(e), this.type = (0, $329ek.HalfFloatType);
    }
    // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
    parse(e) {
        const a = function(M, _) {
            switch(M){
                case 1:
                    throw new Error("THREE.RGBELoader: Read Error: " + (_ || ""));
                case 2:
                    throw new Error("THREE.RGBELoader: Write Error: " + (_ || ""));
                case 3:
                    throw new Error("THREE.RGBELoader: Bad File Format: " + (_ || ""));
                default:
                case 4:
                    throw new Error("THREE.RGBELoader: Memory Error: " + (_ || ""));
            }
        }, c = `
`, d = function(M, _, O) {
            _ = _ || 1024;
            let he = M.pos, pe = -1, ce = 0, $ = "", te = String.fromCharCode.apply(null, new Uint16Array(M.subarray(he, he + 128)));
            for(; 0 > (pe = te.indexOf(c)) && ce < _ && he < M.byteLength;)$ += te, ce += te.length, he += 128, te += String.fromCharCode.apply(null, new Uint16Array(M.subarray(he, he + 128)));
            return -1 < pe ? (M.pos += ce + pe + 1, $ + te.slice(0, pe)) : !1;
        }, p = function(M) {
            const _ = /^#\?(\S+)/, O = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, ie = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, he = /^\s*FORMAT=(\S+)\s*$/, pe = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, ce = {
                valid: 0,
                string: "",
                comments: "",
                programtype: "RGBE",
                format: "",
                gamma: 1,
                exposure: 1,
                width: 0,
                height: 0
            };
            let $, te;
            for((M.pos >= M.byteLength || !($ = d(M))) && a(1, "no header found"), (te = $.match(_)) || a(3, "bad initial token"), ce.valid |= 1, ce.programtype = te[1], ce.string += $ + `
`; $ = d(M), $ !== !1;){
                if (ce.string += $ + `
`, $.charAt(0) === "#") {
                    ce.comments += $ + `
`;
                    continue;
                }
                if ((te = $.match(O)) && (ce.gamma = parseFloat(te[1])), (te = $.match(ie)) && (ce.exposure = parseFloat(te[1])), (te = $.match(he)) && (ce.valid |= 2, ce.format = te[1]), (te = $.match(pe)) && (ce.valid |= 4, ce.height = parseInt(te[1], 10), ce.width = parseInt(te[2], 10)), ce.valid & 2 && ce.valid & 4) break;
            }
            return ce.valid & 2 || a(3, "missing format specifier"), ce.valid & 4 || a(3, "missing image size specifier"), ce;
        }, A = function(M, _, O) {
            const ie = _;
            if (// run length encoding is not allowed so read flat
            ie < 8 || ie > 32767 || // this file is not run length encoded
            M[0] !== 2 || M[1] !== 2 || M[2] & 128) return new Uint8Array(M);
            ie !== (M[2] << 8 | M[3]) && a(3, "wrong scanline width");
            const he = new Uint8Array(4 * _ * O);
            he.length || a(4, "unable to allocate buffer space");
            let pe = 0, ce = 0;
            const $ = 4 * ie, te = new Uint8Array(4), Ge = new Uint8Array($);
            let q = O;
            for(; q > 0 && ce < M.byteLength;){
                ce + 4 > M.byteLength && a(1), te[0] = M[ce++], te[1] = M[ce++], te[2] = M[ce++], te[3] = M[ce++], (te[0] != 2 || te[1] != 2 || (te[2] << 8 | te[3]) != ie) && a(3, "bad rgbe scanline format");
                let de = 0, ge;
                for(; de < $ && ce < M.byteLength;){
                    ge = M[ce++];
                    const Fe = ge > 128;
                    if (Fe && (ge -= 128), (ge === 0 || de + ge > $) && a(3, "bad scanline data"), Fe) {
                        const Xe = M[ce++];
                        for(let Te = 0; Te < ge; Te++)Ge[de++] = Xe;
                    } else Ge.set(M.subarray(ce, ce + ge), de), de += ge, ce += ge;
                }
                const Ye = ie;
                for(let Fe = 0; Fe < Ye; Fe++){
                    let Xe = 0;
                    he[pe] = Ge[Fe + Xe], Xe += ie, he[pe + 1] = Ge[Fe + Xe], Xe += ie, he[pe + 2] = Ge[Fe + Xe], Xe += ie, he[pe + 3] = Ge[Fe + Xe], pe += 4;
                }
                q--;
            }
            return he;
        }, y = function(M, _, O, ie) {
            const he = M[_ + 3], pe = Math.pow(2, he - 128) / 255;
            O[ie + 0] = M[_ + 0] * pe, O[ie + 1] = M[_ + 1] * pe, O[ie + 2] = M[_ + 2] * pe, O[ie + 3] = 1;
        }, G = function(M, _, O, ie) {
            const he = M[_ + 3], pe = Math.pow(2, he - 128) / 255;
            O[ie + 0] = (0, $329ek.DataUtils).toHalfFloat(Math.min(M[_ + 0] * pe, 65504)), O[ie + 1] = (0, $329ek.DataUtils).toHalfFloat(Math.min(M[_ + 1] * pe, 65504)), O[ie + 2] = (0, $329ek.DataUtils).toHalfFloat(Math.min(M[_ + 2] * pe, 65504)), O[ie + 3] = (0, $329ek.DataUtils).toHalfFloat(1);
        }, Z = new Uint8Array(e);
        Z.pos = 0;
        const v = p(Z), V = v.width, H = v.height, N = A(Z.subarray(Z.pos), V, H);
        let Y, K, z;
        switch(this.type){
            case 0, $329ek.FloatType:
                z = N.length / 4;
                const M = new Float32Array(z * 4);
                for(let O = 0; O < z; O++)y(N, O * 4, M, O * 4);
                Y = M, K = (0, $329ek.FloatType);
                break;
            case 0, $329ek.HalfFloatType:
                z = N.length / 4;
                const _ = new Uint16Array(z * 4);
                for(let O = 0; O < z; O++)G(N, O * 4, _, O * 4);
                Y = _, K = (0, $329ek.HalfFloatType);
                break;
            default:
                throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
        }
        return {
            width: V,
            height: H,
            data: Y,
            header: v.string,
            gamma: v.gamma,
            exposure: v.exposure,
            type: K
        };
    }
    setDataType(e) {
        return this.type = e, this;
    }
    load(e, t, i, n) {
        function s(a, o) {
            switch(a.type){
                case 0, $329ek.FloatType:
                case 0, $329ek.HalfFloatType:
                    "colorSpace" in a ? a.colorSpace = "srgb-linear" : a.encoding = 3e3, a.minFilter = (0, $329ek.LinearFilter), a.magFilter = (0, $329ek.LinearFilter), a.generateMipmaps = !1, a.flipY = !0;
                    break;
            }
            t && t(a, o);
        }
        return super.load(e, s, i, n);
    }
}
const $d7238066c5de7f1c$var$sy = $d7238066c5de7f1c$var$eQ >= 152;
class $d7238066c5de7f1c$var$hpe extends (0, $329ek.DataTextureLoader) {
    constructor(e){
        super(e), this.type = (0, $329ek.HalfFloatType);
    }
    parse(e) {
        const _ = Math.pow(2.7182818, 2.2);
        function O(x, D) {
            for(var re = 0, Be = 0; Be < 65536; ++Be)(Be == 0 || x[Be >> 3] & 1 << (Be & 7)) && (D[re++] = Be);
            for(var Ve = re - 1; re < 65536;)D[re++] = 0;
            return Ve;
        }
        function ie(x) {
            for(var D = 0; D < 16384; D++)x[D] = {}, x[D].len = 0, x[D].lit = 0, x[D].p = null;
        }
        const he = {
            l: 0,
            c: 0,
            lc: 0
        };
        function pe(x, D, re, Be, Ve) {
            for(; re < x;)D = D << 8 | dr(Be, Ve), re += 8;
            re -= x, he.l = D >> re & (1 << x) - 1, he.c = D, he.lc = re;
        }
        const ce = new Array(59);
        function $(x) {
            for(var D = 0; D <= 58; ++D)ce[D] = 0;
            for(var D = 0; D < 65537; ++D)ce[x[D]] += 1;
            for(var re = 0, D = 58; D > 0; --D){
                var Be = re + ce[D] >> 1;
                ce[D] = re, re = Be;
            }
            for(var D = 0; D < 65537; ++D){
                var Ve = x[D];
                Ve > 0 && (x[D] = Ve | ce[Ve]++ << 6);
            }
        }
        function te(x, D, re, Be, Ve, Re, _e) {
            for(var Me = re, Qe = 0, tt = 0; Ve <= Re; Ve++){
                if (Me.value - re.value > Be) return !1;
                pe(6, Qe, tt, x, Me);
                var et = he.l;
                if (Qe = he.c, tt = he.lc, _e[Ve] = et, et == 63) {
                    if (Me.value - re.value > Be) throw "Something wrong with hufUnpackEncTable";
                    pe(8, Qe, tt, x, Me);
                    var $e = he.l + 6;
                    if (Qe = he.c, tt = he.lc, Ve + $e > Re + 1) throw "Something wrong with hufUnpackEncTable";
                    for(; $e--;)_e[Ve++] = 0;
                    Ve--;
                } else if (et >= 59) {
                    var $e = et - 59 + 2;
                    if (Ve + $e > Re + 1) throw "Something wrong with hufUnpackEncTable";
                    for(; $e--;)_e[Ve++] = 0;
                    Ve--;
                }
            }
            $(_e);
        }
        function Ge(x) {
            return x & 63;
        }
        function q(x) {
            return x >> 6;
        }
        function de(x, D, re, Be) {
            for(; D <= re; D++){
                var Ve = q(x[D]), Re = Ge(x[D]);
                if (Ve >> Re) throw "Invalid table entry";
                if (Re > 14) {
                    var _e = Be[Ve >> Re - 14];
                    if (_e.len) throw "Invalid table entry";
                    if (_e.lit++, _e.p) {
                        var Me = _e.p;
                        _e.p = new Array(_e.lit);
                        for(var Qe = 0; Qe < _e.lit - 1; ++Qe)_e.p[Qe] = Me[Qe];
                    } else _e.p = new Array(1);
                    _e.p[_e.lit - 1] = D;
                } else if (Re) for(var tt = 0, Qe = 1 << 14 - Re; Qe > 0; Qe--){
                    var _e = Be[(Ve << 14 - Re) + tt];
                    if (_e.len || _e.p) throw "Invalid table entry";
                    _e.len = Re, _e.lit = D, tt++;
                }
            }
            return !0;
        }
        const ge = {
            c: 0,
            lc: 0
        };
        function Ye(x, D, re, Be) {
            x = x << 8 | dr(re, Be), D += 8, ge.c = x, ge.lc = D;
        }
        const Fe = {
            c: 0,
            lc: 0
        };
        function Xe(x, D, re, Be, Ve, Re, _e, Me, Qe, tt) {
            if (x == D) {
                Be < 8 && (Ye(re, Be, Ve, _e), re = ge.c, Be = ge.lc), Be -= 8;
                var et = re >> Be, et = new Uint8Array([
                    et
                ])[0];
                if (Qe.value + et > tt) return !1;
                for(var $e = Me[Qe.value - 1]; et-- > 0;)Me[Qe.value++] = $e;
            } else if (Qe.value < tt) Me[Qe.value++] = x;
            else return !1;
            Fe.c = re, Fe.lc = Be;
        }
        function Te(x) {
            return x & 65535;
        }
        function ct(x) {
            var D = Te(x);
            return D > 32767 ? D - 65536 : D;
        }
        const st = {
            a: 0,
            b: 0
        };
        function Xt(x, D) {
            var re = ct(x), Be = ct(D), Ve = Be, Re = re + (Ve & 1) + (Ve >> 1), _e = Re, Me = Re - Ve;
            st.a = _e, st.b = Me;
        }
        function Mi(x, D) {
            var re = Te(x), Be = Te(D), Ve = re - (Be >> 1) & 65535, Re = Be + Ve - 32768 & 65535;
            st.a = Re, st.b = Ve;
        }
        function Jn(x, D, re, Be, Ve, Re, _e) {
            for(var Me = _e < 16384, Qe = re > Ve ? Ve : re, tt = 1, et; tt <= Qe;)tt <<= 1;
            for(tt >>= 1, et = tt, tt >>= 1; tt >= 1;){
                for(var $e = 0, ln = $e + Re * (Ve - et), St = Re * tt, wt = Re * et, _t = Be * tt, ei = Be * et, zi, Hi, Ot, Kt; $e <= ln; $e += wt){
                    for(var Si = $e, Bn = $e + Be * (re - et); Si <= Bn; Si += ei){
                        var oi = Si + _t, Vn = Si + St, wr = Vn + _t;
                        Me ? (Xt(x[Si + D], x[Vn + D]), zi = st.a, Ot = st.b, Xt(x[oi + D], x[wr + D]), Hi = st.a, Kt = st.b, Xt(zi, Hi), x[Si + D] = st.a, x[oi + D] = st.b, Xt(Ot, Kt), x[Vn + D] = st.a, x[wr + D] = st.b) : (Mi(x[Si + D], x[Vn + D]), zi = st.a, Ot = st.b, Mi(x[oi + D], x[wr + D]), Hi = st.a, Kt = st.b, Mi(zi, Hi), x[Si + D] = st.a, x[oi + D] = st.b, Mi(Ot, Kt), x[Vn + D] = st.a, x[wr + D] = st.b);
                    }
                    if (re & tt) {
                        var Vn = Si + St;
                        Me ? Xt(x[Si + D], x[Vn + D]) : Mi(x[Si + D], x[Vn + D]), zi = st.a, x[Vn + D] = st.b, x[Si + D] = zi;
                    }
                }
                if (Ve & tt) for(var Si = $e, Bn = $e + Be * (re - et); Si <= Bn; Si += ei){
                    var oi = Si + _t;
                    Me ? Xt(x[Si + D], x[oi + D]) : Mi(x[Si + D], x[oi + D]), zi = st.a, x[oi + D] = st.b, x[Si + D] = zi;
                }
                et = tt, tt >>= 1;
            }
            return $e;
        }
        function Un(x, D, re, Be, Ve, Re, _e, Me, Qe, tt) {
            for(var et = 0, $e = 0, ln = Me, St = Math.trunc(Ve.value + (Re + 7) / 8); Ve.value < St;)for(Ye(et, $e, re, Ve), et = ge.c, $e = ge.lc; $e >= 14;){
                var wt = et >> $e - 14 & 16383, _t = D[wt];
                if (_t.len) $e -= _t.len, Xe(_t.lit, _e, et, $e, re, Be, Ve, Qe, tt, ln), et = Fe.c, $e = Fe.lc;
                else {
                    if (!_t.p) throw "hufDecode issues";
                    var ei;
                    for(ei = 0; ei < _t.lit; ei++){
                        for(var zi = Ge(x[_t.p[ei]]); $e < zi && Ve.value < St;)Ye(et, $e, re, Ve), et = ge.c, $e = ge.lc;
                        if ($e >= zi && q(x[_t.p[ei]]) == (et >> $e - zi & (1 << zi) - 1)) {
                            $e -= zi, Xe(_t.p[ei], _e, et, $e, re, Be, Ve, Qe, tt, ln), et = Fe.c, $e = Fe.lc;
                            break;
                        }
                    }
                    if (ei == _t.lit) throw "hufDecode issues";
                }
            }
            var Hi = 8 - Re & 7;
            for(et >>= Hi, $e -= Hi; $e > 0;){
                var _t = D[et << 14 - $e & 16383];
                if (_t.len) $e -= _t.len, Xe(_t.lit, _e, et, $e, re, Be, Ve, Qe, tt, ln), et = Fe.c, $e = Fe.lc;
                else throw "hufDecode issues";
            }
            return !0;
        }
        function mn(x, D, re, Be, Ve, Re) {
            var _e = {
                value: 0
            }, Me = re.value, Qe = Li(D, re), tt = Li(D, re);
            re.value += 4;
            var et = Li(D, re);
            if (re.value += 4, Qe < 0 || Qe >= 65537 || tt < 0 || tt >= 65537) throw "Something wrong with HUF_ENCSIZE";
            var $e = new Array(65537), ln = new Array(16384);
            ie(ln);
            var St = Be - (re.value - Me);
            if (te(x, D, re, St, Qe, tt, $e), et > 8 * (Be - (re.value - Me))) throw "Something wrong with hufUncompress";
            de($e, Qe, tt, ln), Un($e, ln, x, D, re, et, tt, Re, Ve, _e);
        }
        function Qs(x, D, re) {
            for(var Be = 0; Be < re; ++Be)D[Be] = x[D[Be]];
        }
        function Di(x) {
            for(var D = 1; D < x.length; D++){
                var re = x[D - 1] + x[D] - 128;
                x[D] = re;
            }
        }
        function kr(x, D) {
            for(var re = 0, Be = Math.floor((x.length + 1) / 2), Ve = 0, Re = x.length - 1; !(Ve > Re || (D[Ve++] = x[re++], Ve > Re));)D[Ve++] = x[Be++];
        }
        function oo(x) {
            for(var D = x.byteLength, re = new Array(), Be = 0, Ve = new DataView(x); D > 0;){
                var Re = Ve.getInt8(Be++);
                if (Re < 0) {
                    var _e = -Re;
                    D -= _e + 1;
                    for(var Me = 0; Me < _e; Me++)re.push(Ve.getUint8(Be++));
                } else {
                    var _e = Re;
                    D -= 2;
                    for(var Qe = Ve.getUint8(Be++), Me = 0; Me < _e + 1; Me++)re.push(Qe);
                }
            }
            return re;
        }
        function za(x, D, re, Be, Ve, Re) {
            var oi = new DataView(Re.buffer), _e = re[x.idx[0]].width, Me = re[x.idx[0]].height, Qe = 3, tt = Math.floor(_e / 8), et = Math.ceil(_e / 8), $e = Math.ceil(Me / 8), ln = _e - (et - 1) * 8, St = Me - ($e - 1) * 8, wt = {
                value: 0
            }, _t = new Array(Qe), ei = new Array(Qe), zi = new Array(Qe), Hi = new Array(Qe), Ot = new Array(Qe);
            for(let $i = 0; $i < Qe; ++$i)Ot[$i] = D[x.idx[$i]], _t[$i] = $i < 1 ? 0 : _t[$i - 1] + et * $e, ei[$i] = new Float32Array(64), zi[$i] = new Uint16Array(64), Hi[$i] = new Uint16Array(et * 64);
            for(let $i = 0; $i < $e; ++$i){
                var Kt = 8;
                $i == $e - 1 && (Kt = St);
                var Si = 8;
                for(let en = 0; en < et; ++en){
                    en == et - 1 && (Si = ln);
                    for(let Pi = 0; Pi < Qe; ++Pi)zi[Pi].fill(0), zi[Pi][0] = Ve[_t[Pi]++], Dn(wt, Be, zi[Pi]), Er(zi[Pi], ei[Pi]), Cg(ei[Pi]);
                    ka(ei);
                    for(let Pi = 0; Pi < Qe; ++Pi)cs(ei[Pi], Hi[Pi], en * 64);
                }
                let Gs = 0;
                for(let en = 0; en < Qe; ++en){
                    const Pi = re[x.idx[en]].type;
                    for(let Hn = 8 * $i; Hn < 8 * $i + Kt; ++Hn){
                        Gs = Ot[en][Hn];
                        for(let pl = 0; pl < tt; ++pl){
                            const hr = pl * 64 + (Hn & 7) * 8;
                            oi.setUint16(Gs + 0 * Pi, Hi[en][hr + 0], !0), oi.setUint16(Gs + 2 * Pi, Hi[en][hr + 1], !0), oi.setUint16(Gs + 4 * Pi, Hi[en][hr + 2], !0), oi.setUint16(Gs + 6 * Pi, Hi[en][hr + 3], !0), oi.setUint16(Gs + 8 * Pi, Hi[en][hr + 4], !0), oi.setUint16(Gs + 10 * Pi, Hi[en][hr + 5], !0), oi.setUint16(Gs + 12 * Pi, Hi[en][hr + 6], !0), oi.setUint16(Gs + 14 * Pi, Hi[en][hr + 7], !0), Gs += 16 * Pi;
                        }
                    }
                    if (tt != et) for(let Hn = 8 * $i; Hn < 8 * $i + Kt; ++Hn){
                        const pl = Ot[en][Hn] + 8 * tt * 2 * Pi, hr = tt * 64 + (Hn & 7) * 8;
                        for(let Ea = 0; Ea < Si; ++Ea)oi.setUint16(pl + Ea * 2 * Pi, Hi[en][hr + Ea], !0);
                    }
                }
            }
            for(var Bn = new Uint16Array(_e), oi = new DataView(Re.buffer), Vn = 0; Vn < Qe; ++Vn){
                re[x.idx[Vn]].decoded = !0;
                var wr = re[x.idx[Vn]].type;
                if (re[Vn].type == 2) for(var fs = 0; fs < Me; ++fs){
                    const $i = Ot[Vn][fs];
                    for(var xs = 0; xs < _e; ++xs)Bn[xs] = oi.getUint16($i + xs * 2 * wr, !0);
                    for(var xs = 0; xs < _e; ++xs)oi.setFloat32($i + xs * 2 * wr, Je(Bn[xs]), !0);
                }
            }
        }
        function Dn(x, D, re) {
            for(var Be, Ve = 1; Ve < 64;)Be = D[x.value], Be == 65280 ? Ve = 64 : Be >> 8 == 255 ? Ve += Be & 255 : (re[Ve] = Be, Ve++), x.value++;
        }
        function Er(x, D) {
            D[0] = Je(x[0]), D[1] = Je(x[1]), D[2] = Je(x[5]), D[3] = Je(x[6]), D[4] = Je(x[14]), D[5] = Je(x[15]), D[6] = Je(x[27]), D[7] = Je(x[28]), D[8] = Je(x[2]), D[9] = Je(x[4]), D[10] = Je(x[7]), D[11] = Je(x[13]), D[12] = Je(x[16]), D[13] = Je(x[26]), D[14] = Je(x[29]), D[15] = Je(x[42]), D[16] = Je(x[3]), D[17] = Je(x[8]), D[18] = Je(x[12]), D[19] = Je(x[17]), D[20] = Je(x[25]), D[21] = Je(x[30]), D[22] = Je(x[41]), D[23] = Je(x[43]), D[24] = Je(x[9]), D[25] = Je(x[11]), D[26] = Je(x[18]), D[27] = Je(x[24]), D[28] = Je(x[31]), D[29] = Je(x[40]), D[30] = Je(x[44]), D[31] = Je(x[53]), D[32] = Je(x[10]), D[33] = Je(x[19]), D[34] = Je(x[23]), D[35] = Je(x[32]), D[36] = Je(x[39]), D[37] = Je(x[45]), D[38] = Je(x[52]), D[39] = Je(x[54]), D[40] = Je(x[20]), D[41] = Je(x[22]), D[42] = Je(x[33]), D[43] = Je(x[38]), D[44] = Je(x[46]), D[45] = Je(x[51]), D[46] = Je(x[55]), D[47] = Je(x[60]), D[48] = Je(x[21]), D[49] = Je(x[34]), D[50] = Je(x[37]), D[51] = Je(x[47]), D[52] = Je(x[50]), D[53] = Je(x[56]), D[54] = Je(x[59]), D[55] = Je(x[61]), D[56] = Je(x[35]), D[57] = Je(x[36]), D[58] = Je(x[48]), D[59] = Je(x[49]), D[60] = Je(x[57]), D[61] = Je(x[58]), D[62] = Je(x[62]), D[63] = Je(x[63]);
        }
        function Cg(x) {
            const D = 0.5 * Math.cos(0.7853975), re = 0.5 * Math.cos(3.14159 / 16), Be = 0.5 * Math.cos(3.14159 / 8), Ve = 0.5 * Math.cos(3 * 3.14159 / 16), Re = 0.5 * Math.cos(0.981746875), _e = 0.5 * Math.cos(3 * 3.14159 / 8), Me = 0.5 * Math.cos(1.374445625);
            for(var Qe = new Array(4), tt = new Array(4), et = new Array(4), $e = new Array(4), ln = 0; ln < 8; ++ln){
                var St = ln * 8;
                Qe[0] = Be * x[St + 2], Qe[1] = _e * x[St + 2], Qe[2] = Be * x[St + 6], Qe[3] = _e * x[St + 6], tt[0] = re * x[St + 1] + Ve * x[St + 3] + Re * x[St + 5] + Me * x[St + 7], tt[1] = Ve * x[St + 1] - Me * x[St + 3] - re * x[St + 5] - Re * x[St + 7], tt[2] = Re * x[St + 1] - re * x[St + 3] + Me * x[St + 5] + Ve * x[St + 7], tt[3] = Me * x[St + 1] - Re * x[St + 3] + Ve * x[St + 5] - re * x[St + 7], et[0] = D * (x[St + 0] + x[St + 4]), et[3] = D * (x[St + 0] - x[St + 4]), et[1] = Qe[0] + Qe[3], et[2] = Qe[1] - Qe[2], $e[0] = et[0] + et[1], $e[1] = et[3] + et[2], $e[2] = et[3] - et[2], $e[3] = et[0] - et[1], x[St + 0] = $e[0] + tt[0], x[St + 1] = $e[1] + tt[1], x[St + 2] = $e[2] + tt[2], x[St + 3] = $e[3] + tt[3], x[St + 4] = $e[3] - tt[3], x[St + 5] = $e[2] - tt[2], x[St + 6] = $e[1] - tt[1], x[St + 7] = $e[0] - tt[0];
            }
            for(var wt = 0; wt < 8; ++wt)Qe[0] = Be * x[16 + wt], Qe[1] = _e * x[16 + wt], Qe[2] = Be * x[48 + wt], Qe[3] = _e * x[48 + wt], tt[0] = re * x[8 + wt] + Ve * x[24 + wt] + Re * x[40 + wt] + Me * x[56 + wt], tt[1] = Ve * x[8 + wt] - Me * x[24 + wt] - re * x[40 + wt] - Re * x[56 + wt], tt[2] = Re * x[8 + wt] - re * x[24 + wt] + Me * x[40 + wt] + Ve * x[56 + wt], tt[3] = Me * x[8 + wt] - Re * x[24 + wt] + Ve * x[40 + wt] - re * x[56 + wt], et[0] = D * (x[wt] + x[32 + wt]), et[3] = D * (x[wt] - x[32 + wt]), et[1] = Qe[0] + Qe[3], et[2] = Qe[1] - Qe[2], $e[0] = et[0] + et[1], $e[1] = et[3] + et[2], $e[2] = et[3] - et[2], $e[3] = et[0] - et[1], x[0 + wt] = $e[0] + tt[0], x[8 + wt] = $e[1] + tt[1], x[16 + wt] = $e[2] + tt[2], x[24 + wt] = $e[3] + tt[3], x[32 + wt] = $e[3] - tt[3], x[40 + wt] = $e[2] - tt[2], x[48 + wt] = $e[1] - tt[1], x[56 + wt] = $e[0] - tt[0];
        }
        function ka(x) {
            for(var D = 0; D < 64; ++D){
                var re = x[0][D], Be = x[1][D], Ve = x[2][D];
                x[0][D] = re + 1.5747 * Ve, x[1][D] = re - 0.1873 * Be - 0.4682 * Ve, x[2][D] = re + 1.8556 * Be;
            }
        }
        function cs(x, D, re) {
            for(var Be = 0; Be < 64; ++Be)D[re + Be] = (0, $329ek.DataUtils).toHalfFloat(ul(x[Be]));
        }
        function ul(x) {
            return x <= 1 ? Math.sign(x) * Math.pow(Math.abs(x), 2.2) : Math.sign(x) * Math.pow(_, Math.abs(x) - 1);
        }
        function Bu(x) {
            return new DataView(x.array.buffer, x.offset.value, x.size);
        }
        function pg(x) {
            var D = x.viewer.buffer.slice(x.offset.value, x.offset.value + x.size), re = new Uint8Array(oo(D)), Be = new Uint8Array(re.length);
            return Di(re), kr(re, Be), new DataView(Be.buffer);
        }
        function Il(x) {
            var D = x.array.slice(x.offset.value, x.offset.value + x.size), re = $d7238066c5de7f1c$var$sS(D), Be = new Uint8Array(re.length);
            return Di(re), kr(re, Be), new DataView(Be.buffer);
        }
        function fu(x) {
            for(var D = x.viewer, re = {
                value: x.offset.value
            }, Be = new Uint16Array(x.width * x.scanlineBlockSize * (x.channels * x.type)), Ve = new Uint8Array(8192), Re = 0, _e = new Array(x.channels), Me = 0; Me < x.channels; Me++)_e[Me] = {}, _e[Me].start = Re, _e[Me].end = _e[Me].start, _e[Me].nx = x.width, _e[Me].ny = x.lines, _e[Me].size = x.type, Re += _e[Me].nx * _e[Me].ny * _e[Me].size;
            var Qe = vu(D, re), tt = vu(D, re);
            if (tt >= 8192) throw "Something is wrong with PIZ_COMPRESSION BITMAP_SIZE";
            if (Qe <= tt) for(var Me = 0; Me < tt - Qe + 1; Me++)Ve[Me + Qe] = Bt(D, re);
            var et = new Uint16Array(65536), $e = O(Ve, et), ln = Li(D, re);
            mn(x.array, D, re, ln, Be, Re);
            for(var Me = 0; Me < x.channels; ++Me)for(var St = _e[Me], wt = 0; wt < _e[Me].size; ++wt)Jn(Be, St.start + wt, St.nx, St.size, St.ny, St.nx * St.size, $e);
            Qs(et, Be, Re);
            for(var _t = 0, ei = new Uint8Array(Be.buffer.byteLength), zi = 0; zi < x.lines; zi++)for(var Hi = 0; Hi < x.channels; Hi++){
                var St = _e[Hi], Ot = St.nx * St.size, Kt = new Uint8Array(Be.buffer, St.end * 2, Ot * 2);
                ei.set(Kt, _t), _t += Ot * 2, St.end += Ot;
            }
            return new DataView(ei.buffer);
        }
        function FI(x) {
            var D = x.array.slice(x.offset.value, x.offset.value + x.size), re = $d7238066c5de7f1c$var$sS(D);
            const Be = x.lines * x.channels * x.width, Ve = x.type == 1 ? new Uint16Array(Be) : new Uint32Array(Be);
            let Re = 0, _e = 0;
            const Me = new Array(4);
            for(let Qe = 0; Qe < x.lines; Qe++)for(let tt = 0; tt < x.channels; tt++){
                let et = 0;
                switch(x.type){
                    case 1:
                        Me[0] = Re, Me[1] = Me[0] + x.width, Re = Me[1] + x.width;
                        for(let $e = 0; $e < x.width; ++$e){
                            const ln = re[Me[0]++] << 8 | re[Me[1]++];
                            et += ln, Ve[_e] = et, _e++;
                        }
                        break;
                    case 2:
                        Me[0] = Re, Me[1] = Me[0] + x.width, Me[2] = Me[1] + x.width, Re = Me[2] + x.width;
                        for(let $e = 0; $e < x.width; ++$e){
                            const ln = re[Me[0]++] << 24 | re[Me[1]++] << 16 | re[Me[2]++] << 8;
                            et += ln, Ve[_e] = et, _e++;
                        }
                        break;
                }
            }
            return new DataView(Ve.buffer);
        }
        function Gu(x) {
            var D = x.viewer, re = {
                value: x.offset.value
            }, Be = new Uint8Array(x.width * x.lines * (x.channels * x.type * 2)), Ve = {
                version: gt(D, re),
                unknownUncompressedSize: gt(D, re),
                unknownCompressedSize: gt(D, re),
                acCompressedSize: gt(D, re),
                dcCompressedSize: gt(D, re),
                rleCompressedSize: gt(D, re),
                rleUncompressedSize: gt(D, re),
                rleRawSize: gt(D, re),
                totalAcUncompressedCount: gt(D, re),
                totalDcUncompressedCount: gt(D, re),
                acCompression: gt(D, re)
            };
            if (Ve.version < 2) throw "EXRLoader.parse: " + xn.compression + " version " + Ve.version + " is unsupported";
            for(var Re = new Array(), _e = vu(D, re) - 2; _e > 0;){
                var Me = gc(D.buffer, re), Qe = Bt(D, re), tt = Qe >> 2 & 3, et = (Qe >> 4) - 1, $e = new Int8Array([
                    et
                ])[0], ln = Bt(D, re);
                Re.push({
                    name: Me,
                    index: $e,
                    type: ln,
                    compression: tt
                }), _e -= Me.length + 3;
            }
            for(var St = xn.channels, wt = new Array(x.channels), _t = 0; _t < x.channels; ++_t){
                var ei = wt[_t] = {}, zi = St[_t];
                ei.name = zi.name, ei.compression = 0, ei.decoded = !1, ei.type = zi.pixelType, ei.pLinear = zi.pLinear, ei.width = x.width, ei.height = x.lines;
            }
            for(var Hi = {
                idx: new Array(3)
            }, Ot = 0; Ot < x.channels; ++Ot)for(var ei = wt[Ot], _t = 0; _t < Re.length; ++_t){
                var Kt = Re[_t];
                ei.name == Kt.name && (ei.compression = Kt.compression, Kt.index >= 0 && (Hi.idx[Kt.index] = Ot), ei.offset = Ot);
            }
            if (Ve.acCompressedSize > 0) switch(Ve.acCompression){
                case 0:
                    var oi = new Uint16Array(Ve.totalAcUncompressedCount);
                    mn(x.array, D, re, Ve.acCompressedSize, oi, Ve.totalAcUncompressedCount);
                    break;
                case 1:
                    var Si = x.array.slice(re.value, re.value + Ve.totalAcUncompressedCount), Bn = $d7238066c5de7f1c$var$sS(Si), oi = new Uint16Array(Bn.buffer);
                    re.value += Ve.totalAcUncompressedCount;
                    break;
            }
            if (Ve.dcCompressedSize > 0) {
                var Vn = {
                    array: x.array,
                    offset: re,
                    size: Ve.dcCompressedSize
                }, wr = new Uint16Array(Il(Vn).buffer);
                re.value += Ve.dcCompressedSize;
            }
            if (Ve.rleRawSize > 0) {
                var Si = x.array.slice(re.value, re.value + Ve.rleCompressedSize), Bn = $d7238066c5de7f1c$var$sS(Si), fs = oo(Bn.buffer);
                re.value += Ve.rleCompressedSize;
            }
            for(var xs = 0, $i = new Array(wt.length), _t = 0; _t < $i.length; ++_t)$i[_t] = new Array();
            for(var Gs = 0; Gs < x.lines; ++Gs)for(var en = 0; en < wt.length; ++en)$i[en].push(xs), xs += wt[en].width * x.type * 2;
            za(Hi, $i, wt, oi, wr, Be);
            for(var _t = 0; _t < wt.length; ++_t){
                var ei = wt[_t];
                if (!ei.decoded) switch(ei.compression){
                    case 2:
                        for(var Pi = 0, Hn = 0, Gs = 0; Gs < x.lines; ++Gs){
                            for(var pl = $i[_t][Pi], hr = 0; hr < ei.width; ++hr){
                                for(var Ea = 0; Ea < 2 * ei.type; ++Ea)Be[pl++] = fs[Hn + Ea * ei.width * ei.height];
                                Hn++;
                            }
                            Pi++;
                        }
                        break;
                    case 1:
                    default:
                        throw "EXRLoader.parse: unsupported channel compression";
                }
            }
            return new DataView(Be.buffer);
        }
        function gc(x, D) {
            for(var re = new Uint8Array(x), Be = 0; re[D.value + Be] != 0;)Be += 1;
            var Ve = new TextDecoder().decode(re.slice(D.value, D.value + Be));
            return D.value = D.value + Be + 1, Ve;
        }
        function lt(x, D, re) {
            var Be = new TextDecoder().decode(new Uint8Array(x).slice(D.value, D.value + re));
            return D.value = D.value + re, Be;
        }
        function Mt(x, D) {
            var re = Nt(x, D), Be = Li(x, D);
            return [
                re,
                Be
            ];
        }
        function di(x, D) {
            var re = Li(x, D), Be = Li(x, D);
            return [
                re,
                Be
            ];
        }
        function Nt(x, D) {
            var re = x.getInt32(D.value, !0);
            return D.value = D.value + 4, re;
        }
        function Li(x, D) {
            var re = x.getUint32(D.value, !0);
            return D.value = D.value + 4, re;
        }
        function dr(x, D) {
            var re = x[D.value];
            return D.value = D.value + 1, re;
        }
        function Bt(x, D) {
            var re = x.getUint8(D.value);
            return D.value = D.value + 1, re;
        }
        const gt = function(x, D) {
            let re;
            return "getBigInt64" in DataView.prototype ? re = Number(x.getBigInt64(D.value, !0)) : re = x.getUint32(D.value + 4, !0) + Number(x.getUint32(D.value, !0) << 32), D.value += 8, re;
        };
        function yi(x, D) {
            var re = x.getFloat32(D.value, !0);
            return D.value += 4, re;
        }
        function _i(x, D) {
            return (0, $329ek.DataUtils).toHalfFloat(yi(x, D));
        }
        function Je(x) {
            var D = (x & 31744) >> 10, re = x & 1023;
            return (x >> 15 ? -1 : 1) * (D ? D === 31 ? re ? NaN : 1 / 0 : Math.pow(2, D - 15) * (1 + re / 1024) : 6103515625e-14 * (re / 1024));
        }
        function vu(x, D) {
            var re = x.getUint16(D.value, !0);
            return D.value += 2, re;
        }
        function mg(x, D) {
            return Je(vu(x, D));
        }
        function Su(x, D, re, Be) {
            for(var Ve = re.value, Re = []; re.value < Ve + Be - 1;){
                var _e = gc(D, re), Me = Nt(x, re), Qe = Bt(x, re);
                re.value += 3;
                var tt = Nt(x, re), et = Nt(x, re);
                Re.push({
                    name: _e,
                    pixelType: Me,
                    pLinear: Qe,
                    xSampling: tt,
                    ySampling: et
                });
            }
            return re.value += 1, Re;
        }
        function ph(x, D) {
            var re = yi(x, D), Be = yi(x, D), Ve = yi(x, D), Re = yi(x, D), _e = yi(x, D), Me = yi(x, D), Qe = yi(x, D), tt = yi(x, D);
            return {
                redX: re,
                redY: Be,
                greenX: Ve,
                greenY: Re,
                blueX: _e,
                blueY: Me,
                whiteX: Qe,
                whiteY: tt
            };
        }
        function Wi(x, D) {
            var re = [
                "NO_COMPRESSION",
                "RLE_COMPRESSION",
                "ZIPS_COMPRESSION",
                "ZIP_COMPRESSION",
                "PIZ_COMPRESSION",
                "PXR24_COMPRESSION",
                "B44_COMPRESSION",
                "B44A_COMPRESSION",
                "DWAA_COMPRESSION",
                "DWAB_COMPRESSION"
            ], Be = Bt(x, D);
            return re[Be];
        }
        function Ko(x, D) {
            var re = Li(x, D), Be = Li(x, D), Ve = Li(x, D), Re = Li(x, D);
            return {
                xMin: re,
                yMin: Be,
                xMax: Ve,
                yMax: Re
            };
        }
        function dl(x, D) {
            var re = [
                "INCREASING_Y"
            ], Be = Bt(x, D);
            return re[Be];
        }
        function hl(x, D) {
            var re = yi(x, D), Be = yi(x, D);
            return [
                re,
                Be
            ];
        }
        function xo(x, D) {
            var re = yi(x, D), Be = yi(x, D), Ve = yi(x, D);
            return [
                re,
                Be,
                Ve
            ];
        }
        function Aa(x, D, re, Be, Ve) {
            if (Be === "string" || Be === "stringvector" || Be === "iccProfile") return lt(D, re, Ve);
            if (Be === "chlist") return Su(x, D, re, Ve);
            if (Be === "chromaticities") return ph(x, re);
            if (Be === "compression") return Wi(x, re);
            if (Be === "box2i") return Ko(x, re);
            if (Be === "lineOrder") return dl(x, re);
            if (Be === "float") return yi(x, re);
            if (Be === "v2f") return hl(x, re);
            if (Be === "v3f") return xo(x, re);
            if (Be === "int") return Nt(x, re);
            if (Be === "rational") return Mt(x, re);
            if (Be === "timecode") return di(x, re);
            if (Be === "preview") return re.value += Ve, "skipped";
            re.value += Ve;
        }
        function h0(x, D, re) {
            const Be = {};
            if (x.getUint32(0, !0) != 20000630) throw "THREE.EXRLoader: provided file doesn't appear to be in OpenEXR format.";
            Be.version = x.getUint8(4);
            const Ve = x.getUint8(5);
            Be.spec = {
                singleTile: !!(Ve & 2),
                longName: !!(Ve & 4),
                deepFormat: !!(Ve & 8),
                multiPart: !!(Ve & 16)
            }, re.value = 8;
            for(var Re = !0; Re;){
                var _e = gc(D, re);
                if (_e == 0) Re = !1;
                else {
                    var Me = gc(D, re), Qe = Li(x, re), tt = Aa(x, D, re, Me, Qe);
                    tt === void 0 ? console.warn(`EXRLoader.parse: skipped unknown header attribute type '${Me}'.`) : Be[_e] = tt;
                }
            }
            if (Ve & -5) throw console.error("EXRHeader:", Be), "THREE.EXRLoader: provided file is currently unsupported.";
            return Be;
        }
        function lc(x, D, re, Be, Ve) {
            const Re = {
                size: 0,
                viewer: D,
                array: re,
                offset: Be,
                width: x.dataWindow.xMax - x.dataWindow.xMin + 1,
                height: x.dataWindow.yMax - x.dataWindow.yMin + 1,
                channels: x.channels.length,
                bytesPerLine: null,
                lines: null,
                inputSize: null,
                type: x.channels[0].pixelType,
                uncompress: null,
                getter: null,
                format: null,
                [$d7238066c5de7f1c$var$sy ? "colorSpace" : "encoding"]: null
            };
            switch(x.compression){
                case "NO_COMPRESSION":
                    Re.lines = 1, Re.uncompress = Bu;
                    break;
                case "RLE_COMPRESSION":
                    Re.lines = 1, Re.uncompress = pg;
                    break;
                case "ZIPS_COMPRESSION":
                    Re.lines = 1, Re.uncompress = Il;
                    break;
                case "ZIP_COMPRESSION":
                    Re.lines = 16, Re.uncompress = Il;
                    break;
                case "PIZ_COMPRESSION":
                    Re.lines = 32, Re.uncompress = fu;
                    break;
                case "PXR24_COMPRESSION":
                    Re.lines = 16, Re.uncompress = FI;
                    break;
                case "DWAA_COMPRESSION":
                    Re.lines = 32, Re.uncompress = Gu;
                    break;
                case "DWAB_COMPRESSION":
                    Re.lines = 256, Re.uncompress = Gu;
                    break;
                default:
                    throw "EXRLoader.parse: " + x.compression + " is unsupported";
            }
            if (Re.scanlineBlockSize = Re.lines, Re.type == 1) switch(Ve){
                case 0, $329ek.FloatType:
                    Re.getter = mg, Re.inputSize = 2;
                    break;
                case 0, $329ek.HalfFloatType:
                    Re.getter = vu, Re.inputSize = 2;
                    break;
            }
            else if (Re.type == 2) switch(Ve){
                case 0, $329ek.FloatType:
                    Re.getter = yi, Re.inputSize = 4;
                    break;
                case 0, $329ek.HalfFloatType:
                    Re.getter = _i, Re.inputSize = 4;
            }
            else throw "EXRLoader.parse: unsupported pixelType " + Re.type + " for " + x.compression + ".";
            Re.blockCount = (x.dataWindow.yMax + 1) / Re.scanlineBlockSize;
            for(var _e = 0; _e < Re.blockCount; _e++)gt(D, Be);
            Re.outputChannels = Re.channels == 3 ? 4 : Re.channels;
            const Me = Re.width * Re.height * Re.outputChannels;
            switch(Ve){
                case 0, $329ek.FloatType:
                    Re.byteArray = new Float32Array(Me), Re.channels < Re.outputChannels && Re.byteArray.fill(1, 0, Me);
                    break;
                case 0, $329ek.HalfFloatType:
                    Re.byteArray = new Uint16Array(Me), Re.channels < Re.outputChannels && Re.byteArray.fill(15360, 0, Me);
                    break;
                default:
                    console.error("THREE.EXRLoader: unsupported type: ", Ve);
                    break;
            }
            return Re.bytesPerLine = Re.width * Re.inputSize * Re.channels, Re.outputChannels == 4 ? Re.format = (0, $329ek.RGBAFormat) : Re.format = (0, $329ek.RedFormat), $d7238066c5de7f1c$var$sy ? Re.colorSpace = "srgb-linear" : Re.encoding = 3e3, Re;
        }
        const Cl = new DataView(e), mh = new Uint8Array(e), Ag = {
            value: 0
        }, xn = h0(Cl, e, Ag), hi = lc(xn, Cl, mh, Ag, this.type), Ah = {
            value: 0
        }, bh = {
            R: 0,
            G: 1,
            B: 2,
            A: 3,
            Y: 0
        };
        for(let x = 0; x < hi.height / hi.scanlineBlockSize; x++){
            const D = Li(Cl, Ag);
            hi.size = Li(Cl, Ag), hi.lines = D + hi.scanlineBlockSize > hi.height ? hi.height - D : hi.scanlineBlockSize;
            const Be = hi.size < hi.lines * hi.bytesPerLine ? hi.uncompress(hi) : Bu(hi);
            Ag.value += hi.size;
            for(let Ve = 0; Ve < hi.scanlineBlockSize; Ve++){
                const Re = Ve + x * hi.scanlineBlockSize;
                if (Re >= hi.height) break;
                for(let _e = 0; _e < hi.channels; _e++){
                    const Me = bh[xn.channels[_e].name];
                    for(let Qe = 0; Qe < hi.width; Qe++){
                        Ah.value = (Ve * (hi.channels * hi.width) + _e * hi.width + Qe) * hi.inputSize;
                        const tt = (hi.height - 1 - Re) * (hi.width * hi.outputChannels) + Qe * hi.outputChannels + Me;
                        hi.byteArray[tt] = hi.getter(Be, Ah);
                    }
                }
            }
        }
        return {
            header: xn,
            width: hi.width,
            height: hi.height,
            data: hi.byteArray,
            format: hi.format,
            [$d7238066c5de7f1c$var$sy ? "colorSpace" : "encoding"]: hi[$d7238066c5de7f1c$var$sy ? "colorSpace" : "encoding"],
            type: this.type
        };
    }
    setDataType(e) {
        return this.type = e, this;
    }
    load(e, t, i, n) {
        function s(a, o) {
            $d7238066c5de7f1c$var$sy ? a.colorSpace = o.colorSpace : a.encoding = o.encoding, a.minFilter = (0, $329ek.LinearFilter), a.magFilter = (0, $329ek.LinearFilter), a.generateMipmaps = !1, a.flipY = !1, t && t(a, o);
        }
        return super.load(e, s, i, n);
    }
}
function $d7238066c5de7f1c$var$Cpe(r, e, t) {
    const i = $d7238066c5de7f1c$var$gs((p)=>p.size), n = $d7238066c5de7f1c$var$gs((p)=>p.viewport), s = typeof r == "number" ? r : i.width * n.dpr, a = i.height * n.dpr, o = (typeof r == "number" ? t : r) || {}, { samples: g = 0, depth: l, ...c } = o, d = $bxRTa.useMemo(()=>{
        const p = new $1W96c.WebGLRenderTarget(s, a, {
            minFilter: $1W96c.LinearFilter,
            magFilter: $1W96c.LinearFilter,
            type: $1W96c.HalfFloatType,
            ...c
        });
        return l && (p.depthTexture = new $1W96c.DepthTexture(s, a, $1W96c.FloatType)), p.samples = g, p;
    }, []);
    return $bxRTa.useLayoutEffect(()=>{
        d.setSize(s, a), g && (d.samples = g);
    }, [
        g,
        d,
        s,
        a
    ]), $bxRTa.useEffect(()=>()=>d.dispose(), []), d;
}
const $d7238066c5de7f1c$var$ppe = (r)=>typeof r == "function", $d7238066c5de7f1c$var$mpe = /* @__PURE__ */ $bxRTa.forwardRef(({ envMap: r, resolution: e = 256, frames: t = 1 / 0, makeDefault: i, children: n, ...s }, a)=>{
    const o = $d7238066c5de7f1c$var$gs(({ set: Z })=>Z), g = $d7238066c5de7f1c$var$gs(({ camera: Z })=>Z), l = $d7238066c5de7f1c$var$gs(({ size: Z })=>Z), c = $bxRTa.useRef(null);
    $bxRTa.useImperativeHandle(a, ()=>c.current, []);
    const d = $bxRTa.useRef(null), p = $d7238066c5de7f1c$var$Cpe(e);
    $bxRTa.useLayoutEffect(()=>{
        s.manual || (c.current.aspect = l.width / l.height);
    }, [
        l,
        s
    ]), $bxRTa.useLayoutEffect(()=>{
        c.current.updateProjectionMatrix();
    });
    let A = 0, y = null;
    const G = $d7238066c5de7f1c$var$ppe(n);
    return $d7238066c5de7f1c$var$_R((Z)=>{
        G && (t === 1 / 0 || A < t) && (d.current.visible = !1, Z.gl.setRenderTarget(p), y = Z.scene.background, r && (Z.scene.background = r), Z.gl.render(Z.scene, c.current), Z.scene.background = y, Z.gl.setRenderTarget(null), d.current.visible = !0, A++);
    }), $bxRTa.useLayoutEffect(()=>{
        if (i) {
            const Z = g;
            return o(()=>({
                    camera: c.current
                })), ()=>o(()=>({
                        camera: Z
                    }));
        }
    }, [
        c,
        i,
        o
    ]), /* @__PURE__ */ $bxRTa.createElement($bxRTa.Fragment, null, /* @__PURE__ */ $bxRTa.createElement("perspectiveCamera", $d7238066c5de7f1c$var$fB({
        ref: c
    }, s), !G && n), /* @__PURE__ */ $bxRTa.createElement("group", {
        ref: d
    }, G && n(p.texture)));
});
/*!
 * camera-controls
 * https://github.com/yomotsu/camera-controls
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */ const $d7238066c5de7f1c$var$bs = {
    LEFT: 1,
    RIGHT: 2,
    MIDDLE: 4
}, $d7238066c5de7f1c$var$fe = Object.freeze({
    NONE: 0,
    ROTATE: 1,
    TRUCK: 2,
    SCREEN_PAN: 4,
    OFFSET: 8,
    DOLLY: 16,
    ZOOM: 32,
    TOUCH_ROTATE: 64,
    TOUCH_TRUCK: 128,
    TOUCH_SCREEN_PAN: 256,
    TOUCH_OFFSET: 512,
    TOUCH_DOLLY: 1024,
    TOUCH_ZOOM: 2048,
    TOUCH_DOLLY_TRUCK: 4096,
    TOUCH_DOLLY_SCREEN_PAN: 8192,
    TOUCH_DOLLY_OFFSET: 16384,
    TOUCH_DOLLY_ROTATE: 32768,
    TOUCH_ZOOM_TRUCK: 65536,
    TOUCH_ZOOM_OFFSET: 131072,
    TOUCH_ZOOM_SCREEN_PAN: 262144,
    TOUCH_ZOOM_ROTATE: 524288
}), $d7238066c5de7f1c$var$_m = {
    NONE: 0,
    IN: 1,
    OUT: -1
};
function $d7238066c5de7f1c$var$bC(r) {
    return r.isPerspectiveCamera;
}
function $d7238066c5de7f1c$var$zd(r) {
    return r.isOrthographicCamera;
}
const $d7238066c5de7f1c$var$Pm = Math.PI * 2, $d7238066c5de7f1c$var$JT = Math.PI / 2, $d7238066c5de7f1c$var$oQ = 1e-5, $d7238066c5de7f1c$var$ry = Math.PI / 180;
function $d7238066c5de7f1c$var$zl(r, e, t) {
    return Math.max(e, Math.min(t, r));
}
function $d7238066c5de7f1c$var$Tn(r, e = $d7238066c5de7f1c$var$oQ) {
    return Math.abs(r) < e;
}
function $d7238066c5de7f1c$var$An(r, e, t = $d7238066c5de7f1c$var$oQ) {
    return $d7238066c5de7f1c$var$Tn(r - e, t);
}
function $d7238066c5de7f1c$var$UT(r, e) {
    return Math.round(r / e) * e;
}
function $d7238066c5de7f1c$var$ay(r) {
    return isFinite(r) ? r : r < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
}
function $d7238066c5de7f1c$var$oy(r) {
    return Math.abs(r) < Number.MAX_VALUE ? r : r * (1 / 0);
}
function $d7238066c5de7f1c$var$rS(r, e, t, i, n = 1 / 0, s) {
    i = Math.max(1e-4, i);
    const a = 2 / i, o = a * s, g = 1 / (1 + o + 0.48 * o * o + 0.235 * o * o * o);
    let l = r - e;
    const c = e, d = n * i;
    l = $d7238066c5de7f1c$var$zl(l, -d, d), e = r - l;
    const p = (t.value + a * l) * s;
    t.value = (t.value - a * p) * g;
    let A = e + (l + p) * g;
    return c - r > 0 == A > c && (A = c, t.value = (A - c) / s), A;
}
function $d7238066c5de7f1c$var$DT(r, e, t, i, n = 1 / 0, s, a) {
    i = Math.max(1e-4, i);
    const o = 2 / i, g = o * s, l = 1 / (1 + g + 0.48 * g * g + 0.235 * g * g * g);
    let c = e.x, d = e.y, p = e.z, A = r.x - c, y = r.y - d, G = r.z - p;
    const Z = c, v = d, V = p, H = n * i, N = H * H, Y = A * A + y * y + G * G;
    if (Y > N) {
        const $ = Math.sqrt(Y);
        A = A / $ * H, y = y / $ * H, G = G / $ * H;
    }
    c = r.x - A, d = r.y - y, p = r.z - G;
    const K = (t.x + o * A) * s, z = (t.y + o * y) * s, M = (t.z + o * G) * s;
    t.x = (t.x - o * K) * l, t.y = (t.y - o * z) * l, t.z = (t.z - o * M) * l, a.x = c + (A + K) * l, a.y = d + (y + z) * l, a.z = p + (G + M) * l;
    const _ = Z - r.x, O = v - r.y, ie = V - r.z, he = a.x - Z, pe = a.y - v, ce = a.z - V;
    return _ * he + O * pe + ie * ce > 0 && (a.x = Z, a.y = v, a.z = V, t.x = (a.x - Z) / s, t.y = (a.y - v) / s, t.z = (a.z - V) / s), a;
}
function $d7238066c5de7f1c$var$oX(r, e) {
    e.set(0, 0), r.forEach((t)=>{
        e.x += t.clientX, e.y += t.clientY;
    }), e.x /= r.length, e.y /= r.length;
}
function $d7238066c5de7f1c$var$gX(r, e) {
    return $d7238066c5de7f1c$var$zd(r) ? (console.warn(`${e} is not supported in OrthographicCamera`), !0) : !1;
}
class $d7238066c5de7f1c$var$Ape {
    constructor(){
        this._listeners = {};
    }
    /**
   * Adds the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */ addEventListener(e, t) {
        const i = this._listeners;
        i[e] === void 0 && (i[e] = []), i[e].indexOf(t) === -1 && i[e].push(t);
    }
    /**
   * Presence of the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */ hasEventListener(e, t) {
        const i = this._listeners;
        return i[e] !== void 0 && i[e].indexOf(t) !== -1;
    }
    /**
   * Removes the specified event listener
   * @param type event name
   * @param listener handler function
   * @category Methods
   */ removeEventListener(e, t) {
        const n = this._listeners[e];
        if (n !== void 0) {
            const s = n.indexOf(t);
            s !== -1 && n.splice(s, 1);
        }
    }
    /**
   * Removes all event listeners
   * @param type event name
   * @category Methods
   */ removeAllEventListeners(e) {
        if (!e) {
            this._listeners = {};
            return;
        }
        Array.isArray(this._listeners[e]) && (this._listeners[e].length = 0);
    }
    /**
   * Fire an event type.
   * @param event DispatcherEvent
   * @category Methods
   */ dispatchEvent(e) {
        const i = this._listeners[e.type];
        if (i !== void 0) {
            e.target = this;
            const n = i.slice(0);
            for(let s = 0, a = n.length; s < a; s++)n[s].call(this, e);
        }
    }
}
var $d7238066c5de7f1c$var$lX;
const $d7238066c5de7f1c$var$bpe = "2.10.1", $d7238066c5de7f1c$var$aS = 1 / 8, $d7238066c5de7f1c$var$ype = /Mac/.test(($d7238066c5de7f1c$var$lX = globalThis == null ? void 0 : globalThis.navigator) === null || $d7238066c5de7f1c$var$lX === void 0 ? void 0 : $d7238066c5de7f1c$var$lX.platform);
let $d7238066c5de7f1c$var$jt, $d7238066c5de7f1c$var$_T, $d7238066c5de7f1c$var$oS, $d7238066c5de7f1c$var$cX, $d7238066c5de7f1c$var$Bo, $d7238066c5de7f1c$var$Ai, $d7238066c5de7f1c$var$on, $d7238066c5de7f1c$var$Qm, $d7238066c5de7f1c$var$gy, $d7238066c5de7f1c$var$Tc, $d7238066c5de7f1c$var$Mc, $d7238066c5de7f1c$var$yC, $d7238066c5de7f1c$var$PT, $d7238066c5de7f1c$var$QT, $d7238066c5de7f1c$var$zg, $d7238066c5de7f1c$var$ly, $d7238066c5de7f1c$var$Om, $d7238066c5de7f1c$var$OT, $d7238066c5de7f1c$var$uX, $d7238066c5de7f1c$var$jT, $d7238066c5de7f1c$var$IX, $d7238066c5de7f1c$var$dX, $d7238066c5de7f1c$var$gS, $d7238066c5de7f1c$var$hX = class gN extends $d7238066c5de7f1c$var$Ape {
    /**
       * Injects THREE as the dependency. You can then proceed to use CameraControls.
       *
       * e.g
       * ```javascript
       * CameraControls.install( { THREE: THREE } );
       * ```
       *
       * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
       *
       * ```js
       * import {
       * 	Vector2,
       * 	Vector3,
       * 	Vector4,
       * 	Quaternion,
       * 	Matrix4,
       * 	Spherical,
       * 	Box3,
       * 	Sphere,
       * 	Raycaster,
       * 	MathUtils,
       * } from 'three';
       *
       * const subsetOfTHREE = {
       * 	Vector2   : Vector2,
       * 	Vector3   : Vector3,
       * 	Vector4   : Vector4,
       * 	Quaternion: Quaternion,
       * 	Matrix4   : Matrix4,
       * 	Spherical : Spherical,
       * 	Box3      : Box3,
       * 	Sphere    : Sphere,
       * 	Raycaster : Raycaster,
       * };
  
       * CameraControls.install( { THREE: subsetOfTHREE } );
       * ```
       * @category Statics
       */ static install(e) {
        $d7238066c5de7f1c$var$jt = e.THREE, $d7238066c5de7f1c$var$_T = Object.freeze(new $d7238066c5de7f1c$var$jt.Vector3(0, 0, 0)), $d7238066c5de7f1c$var$oS = Object.freeze(new $d7238066c5de7f1c$var$jt.Vector3(0, 1, 0)), $d7238066c5de7f1c$var$cX = Object.freeze(new $d7238066c5de7f1c$var$jt.Vector3(0, 0, 1)), $d7238066c5de7f1c$var$Bo = new $d7238066c5de7f1c$var$jt.Vector2(), $d7238066c5de7f1c$var$Ai = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$on = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$Qm = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$gy = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$Tc = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$Mc = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$yC = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$PT = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$QT = new $d7238066c5de7f1c$var$jt.Vector3(), $d7238066c5de7f1c$var$zg = new $d7238066c5de7f1c$var$jt.Spherical(), $d7238066c5de7f1c$var$ly = new $d7238066c5de7f1c$var$jt.Spherical(), $d7238066c5de7f1c$var$Om = new $d7238066c5de7f1c$var$jt.Box3(), $d7238066c5de7f1c$var$OT = new $d7238066c5de7f1c$var$jt.Box3(), $d7238066c5de7f1c$var$uX = new $d7238066c5de7f1c$var$jt.Sphere(), $d7238066c5de7f1c$var$jT = new $d7238066c5de7f1c$var$jt.Quaternion(), $d7238066c5de7f1c$var$IX = new $d7238066c5de7f1c$var$jt.Quaternion(), $d7238066c5de7f1c$var$dX = new $d7238066c5de7f1c$var$jt.Matrix4(), $d7238066c5de7f1c$var$gS = new $d7238066c5de7f1c$var$jt.Raycaster();
    }
    /**
   * list all ACTIONs
   * @category Statics
   */ static get ACTION() {
        return $d7238066c5de7f1c$var$fe;
    }
    /**
   * @deprecated Use `cameraControls.mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.
   */ set verticalDragToForward(e) {
        console.warn("camera-controls: `verticalDragToForward` was removed. Use `mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.");
    }
    /**
   * Creates a `CameraControls` instance.
   *
   * Note:
   * You **must install** three.js before using camera-controls. see [#install](#install)
   * Not doing so will lead to runtime errors (`undefined` references to THREE).
   *
   * e.g.
   * ```
   * CameraControls.install( { THREE } );
   * const cameraControls = new CameraControls( camera, domElement );
   * ```
   *
   * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
   * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
   * @category Constructor
   */ constructor(e, t){
        super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = 0.01, this.maxZoom = 1 / 0, this.smoothTime = 0.25, this.draggingSmoothTime = 0.125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.boundaryFriction = 0, this.restThreshold = 0.01, this.colliderMeshes = [], this.cancel = ()=>{}, this._enabled = !0, this._state = $d7238066c5de7f1c$var$fe.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect(), this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = $d7238066c5de7f1c$var$_m.NONE, this._thetaVelocity = {
            value: 0
        }, this._phiVelocity = {
            value: 0
        }, this._radiusVelocity = {
            value: 0
        }, this._targetVelocity = new $d7238066c5de7f1c$var$jt.Vector3(), this._focalOffsetVelocity = new $d7238066c5de7f1c$var$jt.Vector3(), this._zoomVelocity = {
            value: 0
        }, this._truckInternal = (v, V, H, N)=>{
            let Y, K;
            if ($d7238066c5de7f1c$var$bC(this._camera)) {
                const z = $d7238066c5de7f1c$var$Ai.copy(this._camera.position).sub(this._target), M = this._camera.getEffectiveFOV() * $d7238066c5de7f1c$var$ry, _ = z.length() * Math.tan(M * 0.5);
                Y = this.truckSpeed * v * _ / this._elementRect.height, K = this.truckSpeed * V * _ / this._elementRect.height;
            } else if ($d7238066c5de7f1c$var$zd(this._camera)) {
                const z = this._camera;
                Y = this.truckSpeed * v * (z.right - z.left) / z.zoom / this._elementRect.width, K = this.truckSpeed * V * (z.top - z.bottom) / z.zoom / this._elementRect.height;
            } else return;
            N ? (H ? this.setFocalOffset(this._focalOffsetEnd.x + Y, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(Y, 0, !0), this.forward(-K, !0)) : H ? this.setFocalOffset(this._focalOffsetEnd.x + Y, this._focalOffsetEnd.y + K, this._focalOffsetEnd.z, !0) : this.truck(Y, K, !0);
        }, this._rotateInternal = (v, V)=>{
            const H = $d7238066c5de7f1c$var$Pm * this.azimuthRotateSpeed * v / this._elementRect.height, N = $d7238066c5de7f1c$var$Pm * this.polarRotateSpeed * V / this._elementRect.height;
            this.rotate(H, N, !0);
        }, this._dollyInternal = (v, V, H)=>{
            const N = Math.pow(0.95, -v * this.dollySpeed), Y = this._sphericalEnd.radius, K = this._sphericalEnd.radius * N, z = $d7238066c5de7f1c$var$zl(K, this.minDistance, this.maxDistance), M = z - K;
            this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(K, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(M, !0), this._dollyToNoClamp(z, !0)) : this._dollyToNoClamp(z, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? K : z) - Y, this._dollyControlCoord.set(V, H)), this._lastDollyDirection = Math.sign(-v);
        }, this._zoomInternal = (v, V, H)=>{
            const N = Math.pow(0.95, v * this.dollySpeed), Y = this._zoom, K = this._zoom * N;
            this.zoomTo(K, !0), this.dollyToCursor && (this._changedZoom += K - Y, this._dollyControlCoord.set(V, H));
        }, typeof $d7238066c5de7f1c$var$jt > "u" && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = e, this._yAxisUpSpace = new $d7238066c5de7f1c$var$jt.Quaternion().setFromUnitVectors(this._camera.up, $d7238066c5de7f1c$var$oS), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = $d7238066c5de7f1c$var$fe.NONE, this._target = new $d7238066c5de7f1c$var$jt.Vector3(), this._targetEnd = this._target.clone(), this._focalOffset = new $d7238066c5de7f1c$var$jt.Vector3(), this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = new $d7238066c5de7f1c$var$jt.Spherical().setFromVector3($d7238066c5de7f1c$var$Ai.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
            new $d7238066c5de7f1c$var$jt.Vector3(),
            new $d7238066c5de7f1c$var$jt.Vector3(),
            new $d7238066c5de7f1c$var$jt.Vector3(),
            new $d7238066c5de7f1c$var$jt.Vector3()
        ], this._updateNearPlaneCorners(), this._boundary = new $d7238066c5de7f1c$var$jt.Box3(new $d7238066c5de7f1c$var$jt.Vector3(-1 / 0, -1 / 0, -1 / 0), new $d7238066c5de7f1c$var$jt.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new $d7238066c5de7f1c$var$jt.Vector2(), this.mouseButtons = {
            left: $d7238066c5de7f1c$var$fe.ROTATE,
            middle: $d7238066c5de7f1c$var$fe.DOLLY,
            right: $d7238066c5de7f1c$var$fe.TRUCK,
            wheel: $d7238066c5de7f1c$var$bC(this._camera) ? $d7238066c5de7f1c$var$fe.DOLLY : $d7238066c5de7f1c$var$zd(this._camera) ? $d7238066c5de7f1c$var$fe.ZOOM : $d7238066c5de7f1c$var$fe.NONE
        }, this.touches = {
            one: $d7238066c5de7f1c$var$fe.TOUCH_ROTATE,
            two: $d7238066c5de7f1c$var$bC(this._camera) ? $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK : $d7238066c5de7f1c$var$zd(this._camera) ? $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK : $d7238066c5de7f1c$var$fe.NONE,
            three: $d7238066c5de7f1c$var$fe.TOUCH_TRUCK
        };
        const i = new $d7238066c5de7f1c$var$jt.Vector2(), n = new $d7238066c5de7f1c$var$jt.Vector2(), s = new $d7238066c5de7f1c$var$jt.Vector2(), a = (v)=>{
            if (!this._enabled || !this._domElement) return;
            if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
                const N = this._domElement.getBoundingClientRect(), Y = v.clientX / N.width, K = v.clientY / N.height;
                if (Y < this._interactiveArea.left || Y > this._interactiveArea.right || K < this._interactiveArea.top || K > this._interactiveArea.bottom) return;
            }
            const V = v.pointerType !== "mouse" ? null : (v.buttons & $d7238066c5de7f1c$var$bs.LEFT) === $d7238066c5de7f1c$var$bs.LEFT ? $d7238066c5de7f1c$var$bs.LEFT : (v.buttons & $d7238066c5de7f1c$var$bs.MIDDLE) === $d7238066c5de7f1c$var$bs.MIDDLE ? $d7238066c5de7f1c$var$bs.MIDDLE : (v.buttons & $d7238066c5de7f1c$var$bs.RIGHT) === $d7238066c5de7f1c$var$bs.RIGHT ? $d7238066c5de7f1c$var$bs.RIGHT : null;
            if (V !== null) {
                const N = this._findPointerByMouseButton(V);
                N && this._disposePointer(N);
            }
            if ((v.buttons & $d7238066c5de7f1c$var$bs.LEFT) === $d7238066c5de7f1c$var$bs.LEFT && this._lockedPointer) return;
            const H = {
                pointerId: v.pointerId,
                clientX: v.clientX,
                clientY: v.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton: V
            };
            this._activePointers.push(H), this._domElement.ownerDocument.removeEventListener("pointermove", o, {
                passive: !1
            }), this._domElement.ownerDocument.removeEventListener("pointerup", g), this._domElement.ownerDocument.addEventListener("pointermove", o, {
                passive: !1
            }), this._domElement.ownerDocument.addEventListener("pointerup", g), this._isDragging = !0, p(v);
        }, o = (v)=>{
            v.cancelable && v.preventDefault();
            const V = v.pointerId, H = this._lockedPointer || this._findPointerById(V);
            if (H) {
                if (H.clientX = v.clientX, H.clientY = v.clientY, H.deltaX = v.movementX, H.deltaY = v.movementY, this._state = 0, v.pointerType === "touch") switch(this._activePointers.length){
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
                else (!this._isDragging && this._lockedPointer || this._isDragging && (v.buttons & $d7238066c5de7f1c$var$bs.LEFT) === $d7238066c5de7f1c$var$bs.LEFT) && (this._state = this._state | this.mouseButtons.left), this._isDragging && (v.buttons & $d7238066c5de7f1c$var$bs.MIDDLE) === $d7238066c5de7f1c$var$bs.MIDDLE && (this._state = this._state | this.mouseButtons.middle), this._isDragging && (v.buttons & $d7238066c5de7f1c$var$bs.RIGHT) === $d7238066c5de7f1c$var$bs.RIGHT && (this._state = this._state | this.mouseButtons.right);
                A();
            }
        }, g = (v)=>{
            const V = this._findPointerById(v.pointerId);
            if (!(V && V === this._lockedPointer)) {
                if (V && this._disposePointer(V), v.pointerType === "touch") switch(this._activePointers.length){
                    case 0:
                        this._state = $d7238066c5de7f1c$var$fe.NONE;
                        break;
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
                else this._state = $d7238066c5de7f1c$var$fe.NONE;
                y();
            }
        };
        let l = -1;
        const c = (v)=>{
            if (!this._domElement || !this._enabled || this.mouseButtons.wheel === $d7238066c5de7f1c$var$fe.NONE) return;
            if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
                const K = this._domElement.getBoundingClientRect(), z = v.clientX / K.width, M = v.clientY / K.height;
                if (z < this._interactiveArea.left || z > this._interactiveArea.right || M < this._interactiveArea.top || M > this._interactiveArea.bottom) return;
            }
            if (v.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === $d7238066c5de7f1c$var$fe.ROTATE || this.mouseButtons.wheel === $d7238066c5de7f1c$var$fe.TRUCK) {
                const K = performance.now();
                l - K < 1e3 && this._getClientRect(this._elementRect), l = K;
            }
            const V = $d7238066c5de7f1c$var$ype ? -1 : -3, H = v.deltaMode === 1 || v.ctrlKey ? v.deltaY / V : v.deltaY / (V * 10), N = this.dollyToCursor ? (v.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, Y = this.dollyToCursor ? (v.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
            switch(this.mouseButtons.wheel){
                case $d7238066c5de7f1c$var$fe.ROTATE:
                    this._rotateInternal(v.deltaX, v.deltaY), this._isUserControllingRotate = !0;
                    break;
                case $d7238066c5de7f1c$var$fe.TRUCK:
                    this._truckInternal(v.deltaX, v.deltaY, !1, !1), this._isUserControllingTruck = !0;
                    break;
                case $d7238066c5de7f1c$var$fe.SCREEN_PAN:
                    this._truckInternal(v.deltaX, v.deltaY, !1, !0), this._isUserControllingTruck = !0;
                    break;
                case $d7238066c5de7f1c$var$fe.OFFSET:
                    this._truckInternal(v.deltaX, v.deltaY, !0, !1), this._isUserControllingOffset = !0;
                    break;
                case $d7238066c5de7f1c$var$fe.DOLLY:
                    this._dollyInternal(-H, N, Y), this._isUserControllingDolly = !0;
                    break;
                case $d7238066c5de7f1c$var$fe.ZOOM:
                    this._zoomInternal(-H, N, Y), this._isUserControllingZoom = !0;
                    break;
            }
            this.dispatchEvent({
                type: "control"
            });
        }, d = (v)=>{
            if (!(!this._domElement || !this._enabled)) {
                if (this.mouseButtons.right === gN.ACTION.NONE) {
                    const V = v instanceof PointerEvent ? v.pointerId : 0, H = this._findPointerById(V);
                    H && this._disposePointer(H), this._domElement.ownerDocument.removeEventListener("pointermove", o, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", g);
                    return;
                }
                v.preventDefault();
            }
        }, p = (v)=>{
            if (!this._enabled) return;
            if ($d7238066c5de7f1c$var$oX(this._activePointers, $d7238066c5de7f1c$var$Bo), this._getClientRect(this._elementRect), i.copy($d7238066c5de7f1c$var$Bo), n.copy($d7238066c5de7f1c$var$Bo), this._activePointers.length >= 2) {
                const H = $d7238066c5de7f1c$var$Bo.x - this._activePointers[1].clientX, N = $d7238066c5de7f1c$var$Bo.y - this._activePointers[1].clientY, Y = Math.sqrt(H * H + N * N);
                s.set(0, Y);
                const K = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5, z = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
                n.set(K, z);
            }
            if (this._state = 0, !v) this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
            else if ("pointerType" in v && v.pointerType === "touch") switch(this._activePointers.length){
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else !this._lockedPointer && (v.buttons & $d7238066c5de7f1c$var$bs.LEFT) === $d7238066c5de7f1c$var$bs.LEFT && (this._state = this._state | this.mouseButtons.left), (v.buttons & $d7238066c5de7f1c$var$bs.MIDDLE) === $d7238066c5de7f1c$var$bs.MIDDLE && (this._state = this._state | this.mouseButtons.middle), (v.buttons & $d7238066c5de7f1c$var$bs.RIGHT) === $d7238066c5de7f1c$var$bs.RIGHT && (this._state = this._state | this.mouseButtons.right);
            ((this._state & $d7238066c5de7f1c$var$fe.ROTATE) === $d7238066c5de7f1c$var$fe.ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) && (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), ((this._state & $d7238066c5de7f1c$var$fe.TRUCK) === $d7238066c5de7f1c$var$fe.TRUCK || (this._state & $d7238066c5de7f1c$var$fe.SCREEN_PAN) === $d7238066c5de7f1c$var$fe.SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN) && (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), ((this._state & $d7238066c5de7f1c$var$fe.DOLLY) === $d7238066c5de7f1c$var$fe.DOLLY || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE) && (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), ((this._state & $d7238066c5de7f1c$var$fe.ZOOM) === $d7238066c5de7f1c$var$fe.ZOOM || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) && (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), ((this._state & $d7238066c5de7f1c$var$fe.OFFSET) === $d7238066c5de7f1c$var$fe.OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET) && (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({
                type: "controlstart"
            });
        }, A = ()=>{
            if (!this._enabled || !this._dragNeedsUpdate) return;
            this._dragNeedsUpdate = !1, $d7238066c5de7f1c$var$oX(this._activePointers, $d7238066c5de7f1c$var$Bo);
            const V = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, H = V ? -V.deltaX : n.x - $d7238066c5de7f1c$var$Bo.x, N = V ? -V.deltaY : n.y - $d7238066c5de7f1c$var$Bo.y;
            if (n.copy($d7238066c5de7f1c$var$Bo), ((this._state & $d7238066c5de7f1c$var$fe.ROTATE) === $d7238066c5de7f1c$var$fe.ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) && (this._rotateInternal(H, N), this._isUserControllingRotate = !0), (this._state & $d7238066c5de7f1c$var$fe.DOLLY) === $d7238066c5de7f1c$var$fe.DOLLY || (this._state & $d7238066c5de7f1c$var$fe.ZOOM) === $d7238066c5de7f1c$var$fe.ZOOM) {
                const Y = this.dollyToCursor ? (i.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, K = this.dollyToCursor ? (i.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, z = this.dollyDragInverted ? -1 : 1;
                (this._state & $d7238066c5de7f1c$var$fe.DOLLY) === $d7238066c5de7f1c$var$fe.DOLLY ? (this._dollyInternal(z * N * $d7238066c5de7f1c$var$aS, Y, K), this._isUserControllingDolly = !0) : (this._zoomInternal(z * N * $d7238066c5de7f1c$var$aS, Y, K), this._isUserControllingZoom = !0);
            }
            if ((this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_ROTATE) {
                const Y = $d7238066c5de7f1c$var$Bo.x - this._activePointers[1].clientX, K = $d7238066c5de7f1c$var$Bo.y - this._activePointers[1].clientY, z = Math.sqrt(Y * Y + K * K), M = s.y - z;
                s.set(0, z);
                const _ = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, O = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_ROTATE || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(M * $d7238066c5de7f1c$var$aS, _, O), this._isUserControllingDolly = !0) : (this._zoomInternal(M * $d7238066c5de7f1c$var$aS, _, O), this._isUserControllingZoom = !0);
            }
            ((this._state & $d7238066c5de7f1c$var$fe.TRUCK) === $d7238066c5de7f1c$var$fe.TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_TRUCK || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_TRUCK) && (this._truckInternal(H, N, !1, !1), this._isUserControllingTruck = !0), ((this._state & $d7238066c5de7f1c$var$fe.SCREEN_PAN) === $d7238066c5de7f1c$var$fe.SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_SCREEN_PAN || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_SCREEN_PAN) && (this._truckInternal(H, N, !1, !0), this._isUserControllingTruck = !0), ((this._state & $d7238066c5de7f1c$var$fe.OFFSET) === $d7238066c5de7f1c$var$fe.OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_DOLLY_OFFSET || (this._state & $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET) === $d7238066c5de7f1c$var$fe.TOUCH_ZOOM_OFFSET) && (this._truckInternal(H, N, !0, !1), this._isUserControllingOffset = !0), this.dispatchEvent({
                type: "control"
            });
        }, y = ()=>{
            $d7238066c5de7f1c$var$oX(this._activePointers, $d7238066c5de7f1c$var$Bo), n.copy($d7238066c5de7f1c$var$Bo), this._dragNeedsUpdate = !1, (this._activePointers.length === 0 || this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), this._activePointers.length === 0 && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", o, {
                passive: !1
            }), this._domElement.ownerDocument.removeEventListener("pointerup", g), this.dispatchEvent({
                type: "controlend"
            }));
        };
        this.lockPointer = ()=>{
            !this._enabled || !this._domElement || (this.cancel(), this._lockedPointer = {
                pointerId: -1,
                clientX: 0,
                clientY: 0,
                deltaX: 0,
                deltaY: 0,
                mouseButton: null
            }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", o, {
                passive: !1
            }), this._domElement.ownerDocument.removeEventListener("pointerup", g), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", G), this._domElement.ownerDocument.addEventListener("pointerlockerror", Z), this._domElement.ownerDocument.addEventListener("pointermove", o, {
                passive: !1
            }), this._domElement.ownerDocument.addEventListener("pointerup", g), p());
        }, this.unlockPointer = ()=>{
            var v, V, H;
            this._lockedPointer !== null && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), (v = this._domElement) === null || v === void 0 || v.ownerDocument.exitPointerLock(), (V = this._domElement) === null || V === void 0 || V.ownerDocument.removeEventListener("pointerlockchange", G), (H = this._domElement) === null || H === void 0 || H.ownerDocument.removeEventListener("pointerlockerror", Z), this.cancel();
        };
        const G = ()=>{
            this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
        }, Z = ()=>{
            this.unlockPointer();
        };
        this._addAllEventListeners = (v)=>{
            this._domElement = v, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", a), this._domElement.addEventListener("pointercancel", g), this._domElement.addEventListener("wheel", c, {
                passive: !1
            }), this._domElement.addEventListener("contextmenu", d);
        }, this._removeAllEventListeners = ()=>{
            this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", a), this._domElement.removeEventListener("pointercancel", g), this._domElement.removeEventListener("wheel", c, {
                passive: !1
            }), this._domElement.removeEventListener("contextmenu", d), this._domElement.ownerDocument.removeEventListener("pointermove", o, {
                passive: !1
            }), this._domElement.ownerDocument.removeEventListener("pointerup", g), this._domElement.ownerDocument.removeEventListener("pointerlockchange", G), this._domElement.ownerDocument.removeEventListener("pointerlockerror", Z));
        }, this.cancel = ()=>{
            this._state !== $d7238066c5de7f1c$var$fe.NONE && (this._state = $d7238066c5de7f1c$var$fe.NONE, this._activePointers.length = 0, y());
        }, t && this.connect(t), this.update(0);
    }
    /**
   * The camera to be controlled
   * @category Properties
   */ get camera() {
        return this._camera;
    }
    set camera(e) {
        this._camera = e, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
    }
    /**
   * Whether or not the controls are enabled.
   * `false` to disable user dragging/touch-move, but all methods works.
   * @category Properties
   */ get enabled() {
        return this._enabled;
    }
    set enabled(e) {
        this._enabled = e, this._domElement && (e ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
    }
    /**
   * Returns `true` if the controls are active updating.
   * readonly value.
   * @category Properties
   */ get active() {
        return !this._hasRested;
    }
    /**
   * Getter for the current `ACTION`.
   * readonly value.
   * @category Properties
   */ get currentAction() {
        return this._state;
    }
    /**
   * get/set Current distance.
   * @category Properties
   */ get distance() {
        return this._spherical.radius;
    }
    set distance(e) {
        this._spherical.radius === e && this._sphericalEnd.radius === e || (this._spherical.radius = e, this._sphericalEnd.radius = e, this._needsUpdate = !0);
    }
    // horizontal angle
    /**
   * get/set the azimuth angle (horizontal) in radians.
   * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
   * @category Properties
   */ get azimuthAngle() {
        return this._spherical.theta;
    }
    set azimuthAngle(e) {
        this._spherical.theta === e && this._sphericalEnd.theta === e || (this._spherical.theta = e, this._sphericalEnd.theta = e, this._needsUpdate = !0);
    }
    // vertical angle
    /**
   * get/set the polar angle (vertical) in radians.
   * @category Properties
   */ get polarAngle() {
        return this._spherical.phi;
    }
    set polarAngle(e) {
        this._spherical.phi === e && this._sphericalEnd.phi === e || (this._spherical.phi = e, this._sphericalEnd.phi = e, this._needsUpdate = !0);
    }
    /**
   * Whether camera position should be enclosed in the boundary or not.
   * @category Properties
   */ get boundaryEnclosesCamera() {
        return this._boundaryEnclosesCamera;
    }
    set boundaryEnclosesCamera(e) {
        this._boundaryEnclosesCamera = e, this._needsUpdate = !0;
    }
    /**
   * Set drag-start, touches and wheel enable area in the domElement.
   * each values are between `0` and `1` inclusive, where `0` is left/top and `1` is right/bottom of the screen.
   * e.g. `{ x: 0, y: 0, width: 1, height: 1 }` for entire area.
   * @category Properties
   */ set interactiveArea(e) {
        this._interactiveArea.width = $d7238066c5de7f1c$var$zl(e.width, 0, 1), this._interactiveArea.height = $d7238066c5de7f1c$var$zl(e.height, 0, 1), this._interactiveArea.x = $d7238066c5de7f1c$var$zl(e.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = $d7238066c5de7f1c$var$zl(e.y, 0, 1 - this._interactiveArea.height);
    }
    /**
   * Adds the specified event listener.
   * Applicable event types (which is `K`) are:
   * | Event name          | Timing |
   * | ------------------- | ------ |
   * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
   * | `'control'`         | When the user controls the camera (dragging). |
   * | `'controlend'`      | When the user ends to control the camera. ¹ |
   * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
   * | `'update'`          | When the camera position is updated. |
   * | `'wake'`            | When the camera starts moving. |
   * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
   * | `'sleep'`           | When the camera end moving. |
   *
   * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
   * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
   *
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */ addEventListener(e, t) {
        super.addEventListener(e, t);
    }
    /**
   * Removes the specified event listener
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */ removeEventListener(e, t) {
        super.removeEventListener(e, t);
    }
    /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical).
   * Every value is added to the current value.
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ rotate(e, t, i = !1) {
        return this.rotateTo(this._sphericalEnd.theta + e, this._sphericalEnd.phi + t, i);
    }
    /**
   * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
   *
   * e.g.
   * ```
   * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ rotateAzimuthTo(e, t = !1) {
        return this.rotateTo(e, this._sphericalEnd.phi, t);
    }
    /**
   * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
   *
   * e.g.
   * ```
   * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ rotatePolarTo(e, t = !1) {
        return this.rotateTo(this._sphericalEnd.theta, e, t);
    }
    /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
   * Camera view will rotate over the orbit pivot absolutely:
   *
   * azimuthAngle
   * ```
   *       0º
   *         \
   * 90º -----+----- -90º
   *           \
   *           180º
   * ```
   * | direction | angle                  |
   * | --------- | ---------------------- |
   * | front     | 0º                     |
   * | left      | 90º (`Math.PI / 2`)    |
   * | right     | -90º (`- Math.PI / 2`) |
   * | back      | 180º (`Math.PI`)       |
   *
   * polarAngle
   * ```
   *     180º
   *      |
   *      90º
   *      |
   *      0º
   * ```
   * | direction            | angle                  |
   * | -------------------- | ---------------------- |
   * | top/sky              | 180º (`Math.PI`)       |
   * | horizontal from view | 90º (`Math.PI / 2`)    |
   * | bottom/floor         | 0º                     |
   *
   * @param azimuthAngle Azimuth rotate angle to. In radian.
   * @param polarAngle Polar rotate angle to. In radian.
   * @param enableTransition  Whether to move smoothly or immediately
   * @category Methods
   */ rotateTo(e, t, i = !1) {
        this._isUserControllingRotate = !1;
        const n = $d7238066c5de7f1c$var$zl(e, this.minAzimuthAngle, this.maxAzimuthAngle), s = $d7238066c5de7f1c$var$zl(t, this.minPolarAngle, this.maxPolarAngle);
        this._sphericalEnd.theta = n, this._sphericalEnd.phi = s, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, i || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
        const a = !i || $d7238066c5de7f1c$var$An(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
        return this._createOnRestPromise(a);
    }
    /**
   * Dolly in/out camera position.
   * @param distance Distance of dollyIn. Negative number for dollyOut.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */ dolly(e, t = !1) {
        return this.dollyTo(this._sphericalEnd.radius - e, t);
    }
    /**
   * Dolly in/out camera position to given distance.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */ dollyTo(e, t = !1) {
        return this._isUserControllingDolly = !1, this._lastDollyDirection = $d7238066c5de7f1c$var$_m.NONE, this._changedDolly = 0, this._dollyToNoClamp($d7238066c5de7f1c$var$zl(e, this.minDistance, this.maxDistance), t);
    }
    _dollyToNoClamp(e, t = !1) {
        const i = this._sphericalEnd.radius;
        if (this.colliderMeshes.length >= 1) {
            const a = this._collisionTest(), o = $d7238066c5de7f1c$var$An(a, this._spherical.radius);
            if (!(i > e) && o) return Promise.resolve();
            this._sphericalEnd.radius = Math.min(e, a);
        } else this._sphericalEnd.radius = e;
        this._needsUpdate = !0, t || (this._spherical.radius = this._sphericalEnd.radius);
        const s = !t || $d7238066c5de7f1c$var$An(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(s);
    }
    /**
   * Dolly in, but does not change the distance between the target and the camera, and moves the target position instead.
   * Specify a negative value for dolly out.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */ dollyInFixed(e, t = !1) {
        this._targetEnd.add(this._getCameraDirection($d7238066c5de7f1c$var$gy).multiplyScalar(e)), t || this._target.copy(this._targetEnd);
        const i = !t || $d7238066c5de7f1c$var$An(this._target.x, this._targetEnd.x, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.y, this._targetEnd.y, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(i);
    }
    /**
   * Zoom in/out camera. The value is added to camera zoom.
   * Limits set with `.minZoom` and `.maxZoom`
   * @param zoomStep zoom scale
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ zoom(e, t = !1) {
        return this.zoomTo(this._zoomEnd + e, t);
    }
    /**
   * Zoom in/out camera to given scale. The value overwrites camera zoom.
   * Limits set with .minZoom and .maxZoom
   * @param zoom
   * @param enableTransition
   * @category Methods
   */ zoomTo(e, t = !1) {
        this._isUserControllingZoom = !1, this._zoomEnd = $d7238066c5de7f1c$var$zl(e, this.minZoom, this.maxZoom), this._needsUpdate = !0, t || (this._zoom = this._zoomEnd);
        const i = !t || $d7238066c5de7f1c$var$An(this._zoom, this._zoomEnd, this.restThreshold);
        return this._changedZoom = 0, this._createOnRestPromise(i);
    }
    /**
   * @deprecated `pan()` has been renamed to `truck()`
   * @category Methods
   */ pan(e, t, i = !1) {
        return console.warn("`pan` has been renamed to `truck`"), this.truck(e, t, i);
    }
    /**
   * Truck and pedestal camera using current azimuthal angle
   * @param x Horizontal translate amount
   * @param y Vertical translate amount
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ truck(e, t, i = !1) {
        this._camera.updateMatrix(), $d7238066c5de7f1c$var$Tc.setFromMatrixColumn(this._camera.matrix, 0), $d7238066c5de7f1c$var$Mc.setFromMatrixColumn(this._camera.matrix, 1), $d7238066c5de7f1c$var$Tc.multiplyScalar(e), $d7238066c5de7f1c$var$Mc.multiplyScalar(-t);
        const n = $d7238066c5de7f1c$var$Ai.copy($d7238066c5de7f1c$var$Tc).add($d7238066c5de7f1c$var$Mc), s = $d7238066c5de7f1c$var$on.copy(this._targetEnd).add(n);
        return this.moveTo(s.x, s.y, s.z, i);
    }
    /**
   * Move forward / backward.
   * @param distance Amount to move forward / backward. Negative value to move backward
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ forward(e, t = !1) {
        $d7238066c5de7f1c$var$Ai.setFromMatrixColumn(this._camera.matrix, 0), $d7238066c5de7f1c$var$Ai.crossVectors(this._camera.up, $d7238066c5de7f1c$var$Ai), $d7238066c5de7f1c$var$Ai.multiplyScalar(e);
        const i = $d7238066c5de7f1c$var$on.copy(this._targetEnd).add($d7238066c5de7f1c$var$Ai);
        return this.moveTo(i.x, i.y, i.z, t);
    }
    /**
   * Move up / down.
   * @param height Amount to move up / down. Negative value to move down
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ elevate(e, t = !1) {
        return $d7238066c5de7f1c$var$Ai.copy(this._camera.up).multiplyScalar(e), this.moveTo(this._targetEnd.x + $d7238066c5de7f1c$var$Ai.x, this._targetEnd.y + $d7238066c5de7f1c$var$Ai.y, this._targetEnd.z + $d7238066c5de7f1c$var$Ai.z, t);
    }
    /**
   * Move target position to given point.
   * @param x x coord to move center position
   * @param y y coord to move center position
   * @param z z coord to move center position
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */ moveTo(e, t, i, n = !1) {
        this._isUserControllingTruck = !1;
        const s = $d7238066c5de7f1c$var$Ai.set(e, t, i).sub(this._targetEnd);
        this._encloseToBoundary(this._targetEnd, s, this.boundaryFriction), this._needsUpdate = !0, n || this._target.copy(this._targetEnd);
        const a = !n || $d7238066c5de7f1c$var$An(this._target.x, this._targetEnd.x, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.y, this._targetEnd.y, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(a);
    }
    /**
   * Look in the given point direction.
   * @param x point x.
   * @param y point y.
   * @param z point z.
   * @param enableTransition Whether to move smoothly or immediately.
   * @returns Transition end promise
   * @category Methods
   */ lookInDirectionOf(e, t, i, n = !1) {
        const o = $d7238066c5de7f1c$var$Ai.set(e, t, i).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
        return this.setPosition(o.x, o.y, o.z, n);
    }
    /**
   * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
   * set `cover: true` to fill enter screen.
   * e.g.
   * ```
   * cameraControls.fitToBox( myMesh );
   * ```
   * @param box3OrObject Axis aligned bounding box to fit the view.
   * @param enableTransition Whether to move smoothly or immediately.
   * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
   * @returns Transition end promise
   * @category Methods
   */ fitToBox(e, t, { cover: i = !1, paddingLeft: n = 0, paddingRight: s = 0, paddingBottom: a = 0, paddingTop: o = 0 } = {}) {
        const g = [], l = e.isBox3 ? $d7238066c5de7f1c$var$Om.copy(e) : $d7238066c5de7f1c$var$Om.setFromObject(e);
        l.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
        const c = $d7238066c5de7f1c$var$UT(this._sphericalEnd.theta, $d7238066c5de7f1c$var$JT), d = $d7238066c5de7f1c$var$UT(this._sphericalEnd.phi, $d7238066c5de7f1c$var$JT);
        g.push(this.rotateTo(c, d, t));
        const p = $d7238066c5de7f1c$var$Ai.setFromSpherical(this._sphericalEnd).normalize(), A = $d7238066c5de7f1c$var$jT.setFromUnitVectors(p, $d7238066c5de7f1c$var$cX), y = $d7238066c5de7f1c$var$An(Math.abs(p.y), 1);
        y && A.multiply($d7238066c5de7f1c$var$IX.setFromAxisAngle($d7238066c5de7f1c$var$oS, c)), A.multiply(this._yAxisUpSpaceInverse);
        const G = $d7238066c5de7f1c$var$OT.makeEmpty();
        $d7238066c5de7f1c$var$on.copy(l.min).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.min).setX(l.max.x).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.min).setY(l.max.y).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.max).setZ(l.min.z).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.min).setZ(l.max.z).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.max).setY(l.min.y).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.max).setX(l.min.x).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), $d7238066c5de7f1c$var$on.copy(l.max).applyQuaternion(A), G.expandByPoint($d7238066c5de7f1c$var$on), G.min.x -= n, G.min.y -= a, G.max.x += s, G.max.y += o, A.setFromUnitVectors($d7238066c5de7f1c$var$cX, p), y && A.premultiply($d7238066c5de7f1c$var$IX.invert()), A.premultiply(this._yAxisUpSpace);
        const Z = G.getSize($d7238066c5de7f1c$var$Ai), v = G.getCenter($d7238066c5de7f1c$var$on).applyQuaternion(A);
        if ($d7238066c5de7f1c$var$bC(this._camera)) {
            const V = this.getDistanceToFitBox(Z.x, Z.y, Z.z, i);
            g.push(this.moveTo(v.x, v.y, v.z, t)), g.push(this.dollyTo(V, t)), g.push(this.setFocalOffset(0, 0, 0, t));
        } else if ($d7238066c5de7f1c$var$zd(this._camera)) {
            const V = this._camera, H = V.right - V.left, N = V.top - V.bottom, Y = i ? Math.max(H / Z.x, N / Z.y) : Math.min(H / Z.x, N / Z.y);
            g.push(this.moveTo(v.x, v.y, v.z, t)), g.push(this.zoomTo(Y, t)), g.push(this.setFocalOffset(0, 0, 0, t));
        }
        return Promise.all(g);
    }
    /**
   * Fit the viewport to the sphere or the bounding sphere of the object.
   * @param sphereOrMesh
   * @param enableTransition
   * @category Methods
   */ fitToSphere(e, t) {
        const i = [], s = "isObject3D" in e ? gN.createBoundingSphere(e, $d7238066c5de7f1c$var$uX) : $d7238066c5de7f1c$var$uX.copy(e);
        if (i.push(this.moveTo(s.center.x, s.center.y, s.center.z, t)), $d7238066c5de7f1c$var$bC(this._camera)) {
            const a = this.getDistanceToFitSphere(s.radius);
            i.push(this.dollyTo(a, t));
        } else if ($d7238066c5de7f1c$var$zd(this._camera)) {
            const a = this._camera.right - this._camera.left, o = this._camera.top - this._camera.bottom, g = 2 * s.radius, l = Math.min(a / g, o / g);
            i.push(this.zoomTo(l, t));
        }
        return i.push(this.setFocalOffset(0, 0, 0, t)), Promise.all(i);
    }
    /**
   * Look at the `target` from the `position`.
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */ setLookAt(e, t, i, n, s, a, o = !1) {
        this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = $d7238066c5de7f1c$var$_m.NONE, this._changedDolly = 0;
        const g = $d7238066c5de7f1c$var$on.set(n, s, a), l = $d7238066c5de7f1c$var$Ai.set(e, t, i);
        this._targetEnd.copy(g), this._sphericalEnd.setFromVector3(l.sub(g).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, o || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
        const c = !o || $d7238066c5de7f1c$var$An(this._target.x, this._targetEnd.x, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.y, this._targetEnd.y, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.z, this._targetEnd.z, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(c);
    }
    /**
   * Similar to setLookAt, but it interpolates between two states.
   * @param positionAX
   * @param positionAY
   * @param positionAZ
   * @param targetAX
   * @param targetAY
   * @param targetAZ
   * @param positionBX
   * @param positionBY
   * @param positionBZ
   * @param targetBX
   * @param targetBY
   * @param targetBZ
   * @param t
   * @param enableTransition
   * @category Methods
   */ lerpLookAt(e, t, i, n, s, a, o, g, l, c, d, p, A, y = !1) {
        this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = $d7238066c5de7f1c$var$_m.NONE, this._changedDolly = 0;
        const G = $d7238066c5de7f1c$var$Ai.set(n, s, a), Z = $d7238066c5de7f1c$var$on.set(e, t, i);
        $d7238066c5de7f1c$var$zg.setFromVector3(Z.sub(G).applyQuaternion(this._yAxisUpSpace));
        const v = $d7238066c5de7f1c$var$Qm.set(c, d, p), V = $d7238066c5de7f1c$var$on.set(o, g, l);
        $d7238066c5de7f1c$var$ly.setFromVector3(V.sub(v).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(G.lerp(v, A));
        const H = $d7238066c5de7f1c$var$ly.theta - $d7238066c5de7f1c$var$zg.theta, N = $d7238066c5de7f1c$var$ly.phi - $d7238066c5de7f1c$var$zg.phi, Y = $d7238066c5de7f1c$var$ly.radius - $d7238066c5de7f1c$var$zg.radius;
        this._sphericalEnd.set($d7238066c5de7f1c$var$zg.radius + Y * A, $d7238066c5de7f1c$var$zg.phi + N * A, $d7238066c5de7f1c$var$zg.theta + H * A), this.normalizeRotations(), this._needsUpdate = !0, y || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
        const K = !y || $d7238066c5de7f1c$var$An(this._target.x, this._targetEnd.x, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.y, this._targetEnd.y, this.restThreshold) && $d7238066c5de7f1c$var$An(this._target.z, this._targetEnd.z, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && $d7238066c5de7f1c$var$An(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(K);
    }
    /**
   * Set angle and distance by given position.
   * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param enableTransition
   * @category Methods
   */ setPosition(e, t, i, n = !1) {
        return this.setLookAt(e, t, i, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, n);
    }
    /**
   * Set the target position where gaze at.
   * An alias of `setLookAt()`, without position change. Thus keep the same position.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */ setTarget(e, t, i, n = !1) {
        const s = this.getPosition($d7238066c5de7f1c$var$Ai), a = this.setLookAt(s.x, s.y, s.z, e, t, i, n);
        return this._sphericalEnd.phi = $d7238066c5de7f1c$var$zl(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), a;
    }
    /**
   * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
   * @param x
   * @param y
   * @param z
   * @param enableTransition
   * @category Methods
   */ setFocalOffset(e, t, i, n = !1) {
        this._isUserControllingOffset = !1, this._focalOffsetEnd.set(e, t, i), this._needsUpdate = !0, n || this._focalOffset.copy(this._focalOffsetEnd);
        const s = !n || $d7238066c5de7f1c$var$An(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && $d7238066c5de7f1c$var$An(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && $d7238066c5de7f1c$var$An(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
        return this._createOnRestPromise(s);
    }
    /**
   * Set orbit point without moving the camera.
   * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @category Methods
   */ setOrbitPoint(e, t, i) {
        this._camera.updateMatrixWorld(), $d7238066c5de7f1c$var$Tc.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), $d7238066c5de7f1c$var$Mc.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), $d7238066c5de7f1c$var$yC.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
        const n = $d7238066c5de7f1c$var$Ai.set(e, t, i), s = n.distanceTo(this._camera.position), a = n.sub(this._camera.position);
        $d7238066c5de7f1c$var$Tc.multiplyScalar(a.x), $d7238066c5de7f1c$var$Mc.multiplyScalar(a.y), $d7238066c5de7f1c$var$yC.multiplyScalar(a.z), $d7238066c5de7f1c$var$Ai.copy($d7238066c5de7f1c$var$Tc).add($d7238066c5de7f1c$var$Mc).add($d7238066c5de7f1c$var$yC), $d7238066c5de7f1c$var$Ai.z = $d7238066c5de7f1c$var$Ai.z + s, this.dollyTo(s, !1), this.setFocalOffset(-$d7238066c5de7f1c$var$Ai.x, $d7238066c5de7f1c$var$Ai.y, -$d7238066c5de7f1c$var$Ai.z, !1), this.moveTo(e, t, i, !1);
    }
    /**
   * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
   * @param box3
   * @category Methods
   */ setBoundary(e) {
        if (!e) {
            this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), this._needsUpdate = !0;
            return;
        }
        this._boundary.copy(e), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
    }
    /**
   * Set (or unset) the current viewport.
   * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
   * @param viewportOrX
   * @param y
   * @param width
   * @param height
   * @category Methods
   */ setViewport(e, t, i, n) {
        if (e === null) {
            this._viewport = null;
            return;
        }
        this._viewport = this._viewport || new $d7238066c5de7f1c$var$jt.Vector4(), typeof e == "number" ? this._viewport.set(e, t, i, n) : this._viewport.copy(e);
    }
    /**
   * Calculate the distance to fit the box.
   * @param width box width
   * @param height box height
   * @param depth box depth
   * @returns distance
   * @category Methods
   */ getDistanceToFitBox(e, t, i, n = !1) {
        if ($d7238066c5de7f1c$var$gX(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
        const s = e / t, a = this._camera.getEffectiveFOV() * $d7238066c5de7f1c$var$ry, o = this._camera.aspect;
        return ((n ? s > o : s < o) ? t : e / o) * 0.5 / Math.tan(a * 0.5) + i * 0.5;
    }
    /**
   * Calculate the distance to fit the sphere.
   * @param radius sphere radius
   * @returns distance
   * @category Methods
   */ getDistanceToFitSphere(e) {
        if ($d7238066c5de7f1c$var$gX(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
        const t = this._camera.getEffectiveFOV() * $d7238066c5de7f1c$var$ry, i = Math.atan(Math.tan(t * 0.5) * this._camera.aspect) * 2, n = 1 < this._camera.aspect ? t : i;
        return e / Math.sin(n * 0.5);
    }
    /**
   * Returns the orbit center position, where the camera looking at.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */ getTarget(e, t = !0) {
        return (e && e.isVector3 ? e : new $d7238066c5de7f1c$var$jt.Vector3()).copy(t ? this._targetEnd : this._target);
    }
    /**
   * Returns the camera position.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */ getPosition(e, t = !0) {
        return (e && e.isVector3 ? e : new $d7238066c5de7f1c$var$jt.Vector3()).setFromSpherical(t ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(t ? this._targetEnd : this._target);
    }
    /**
   * Returns the spherical coordinates of the orbit.
   * @param out The receiving Spherical instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */ getSpherical(e, t = !0) {
        return (e || new $d7238066c5de7f1c$var$jt.Spherical()).copy(t ? this._sphericalEnd : this._spherical);
    }
    /**
   * Returns the focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */ getFocalOffset(e, t = !0) {
        return (e && e.isVector3 ? e : new $d7238066c5de7f1c$var$jt.Vector3()).copy(t ? this._focalOffsetEnd : this._focalOffset);
    }
    /**
   * Normalize camera azimuth angle rotation between 0 and 360 degrees.
   * @category Methods
   */ normalizeRotations() {
        this._sphericalEnd.theta = this._sphericalEnd.theta % $d7238066c5de7f1c$var$Pm, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += $d7238066c5de7f1c$var$Pm), this._spherical.theta += $d7238066c5de7f1c$var$Pm * Math.round((this._sphericalEnd.theta - this._spherical.theta) / $d7238066c5de7f1c$var$Pm);
    }
    /**
   * stop all transitions.
   */ stop() {
        this._focalOffset.copy(this._focalOffsetEnd), this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd), this._zoom = this._zoomEnd;
    }
    /**
   * Reset all rotation and position to defaults.
   * @param enableTransition
   * @category Methods
   */ reset(e = !1) {
        if (!$d7238066c5de7f1c$var$An(this._camera.up.x, this._cameraUp0.x) || !$d7238066c5de7f1c$var$An(this._camera.up.y, this._cameraUp0.y) || !$d7238066c5de7f1c$var$An(this._camera.up.z, this._cameraUp0.z)) {
            this._camera.up.copy(this._cameraUp0);
            const i = this.getPosition($d7238066c5de7f1c$var$Ai);
            this.updateCameraUp(), this.setPosition(i.x, i.y, i.z);
        }
        const t = [
            this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, e),
            this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, e),
            this.zoomTo(this._zoom0, e)
        ];
        return Promise.all(t);
    }
    /**
   * Set current camera position as the default position.
   * @category Methods
   */ saveState() {
        this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
    }
    /**
   * Sync camera-up direction.
   * When camera-up vector is changed, `.updateCameraUp()` must be called.
   * @category Methods
   */ updateCameraUp() {
        this._yAxisUpSpace.setFromUnitVectors(this._camera.up, $d7238066c5de7f1c$var$oS), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
    }
    /**
   * Apply current camera-up direction to the camera.
   * The orbit system will be re-initialized with the current position.
   * @category Methods
   */ applyCameraUp() {
        const e = $d7238066c5de7f1c$var$Ai.subVectors(this._target, this._camera.position).normalize(), t = $d7238066c5de7f1c$var$on.crossVectors(e, this._camera.up);
        this._camera.up.crossVectors(t, e).normalize(), this._camera.updateMatrixWorld();
        const i = this.getPosition($d7238066c5de7f1c$var$Ai);
        this.updateCameraUp(), this.setPosition(i.x, i.y, i.z);
    }
    /**
   * Update camera position and directions.
   * This should be called in your tick loop every time, and returns true if re-rendering is needed.
   * @param delta
   * @returns updated
   * @category Methods
   */ update(e) {
        const t = this._sphericalEnd.theta - this._spherical.theta, i = this._sphericalEnd.phi - this._spherical.phi, n = this._sphericalEnd.radius - this._spherical.radius, s = $d7238066c5de7f1c$var$PT.subVectors(this._targetEnd, this._target), a = $d7238066c5de7f1c$var$QT.subVectors(this._focalOffsetEnd, this._focalOffset), o = this._zoomEnd - this._zoom;
        if ($d7238066c5de7f1c$var$Tn(t)) this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
        else {
            const d = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.theta = $d7238066c5de7f1c$var$rS(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, d, 1 / 0, e), this._needsUpdate = !0;
        }
        if ($d7238066c5de7f1c$var$Tn(i)) this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
        else {
            const d = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.phi = $d7238066c5de7f1c$var$rS(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, d, 1 / 0, e), this._needsUpdate = !0;
        }
        if ($d7238066c5de7f1c$var$Tn(n)) this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
        else {
            const d = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.radius = $d7238066c5de7f1c$var$rS(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, d, this.maxSpeed, e), this._needsUpdate = !0;
        }
        if ($d7238066c5de7f1c$var$Tn(s.x) && $d7238066c5de7f1c$var$Tn(s.y) && $d7238066c5de7f1c$var$Tn(s.z)) this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
        else {
            const d = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
            $d7238066c5de7f1c$var$DT(this._target, this._targetEnd, this._targetVelocity, d, this.maxSpeed, e, this._target), this._needsUpdate = !0;
        }
        if ($d7238066c5de7f1c$var$Tn(a.x) && $d7238066c5de7f1c$var$Tn(a.y) && $d7238066c5de7f1c$var$Tn(a.z)) this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
        else {
            const d = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
            $d7238066c5de7f1c$var$DT(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, d, this.maxSpeed, e, this._focalOffset), this._needsUpdate = !0;
        }
        if ($d7238066c5de7f1c$var$Tn(o)) this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
        else {
            const d = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
            this._zoom = $d7238066c5de7f1c$var$rS(this._zoom, this._zoomEnd, this._zoomVelocity, d, 1 / 0, e);
        }
        if (this.dollyToCursor) {
            if ($d7238066c5de7f1c$var$bC(this._camera) && this._changedDolly !== 0) {
                const d = this._spherical.radius - this._lastDistance, p = this._camera, A = this._getCameraDirection($d7238066c5de7f1c$var$gy), y = $d7238066c5de7f1c$var$Ai.copy(A).cross(p.up).normalize();
                y.lengthSq() === 0 && (y.x = 1);
                const G = $d7238066c5de7f1c$var$on.crossVectors(y, A), Z = this._sphericalEnd.radius * Math.tan(p.getEffectiveFOV() * $d7238066c5de7f1c$var$ry * 0.5), V = (this._sphericalEnd.radius - d - this._sphericalEnd.radius) / this._sphericalEnd.radius, H = $d7238066c5de7f1c$var$Qm.copy(this._targetEnd).add(y.multiplyScalar(this._dollyControlCoord.x * Z * p.aspect)).add(G.multiplyScalar(this._dollyControlCoord.y * Z)), N = $d7238066c5de7f1c$var$Ai.copy(this._targetEnd).lerp(H, V), Y = this._lastDollyDirection === $d7238066c5de7f1c$var$_m.IN && this._spherical.radius <= this.minDistance, K = this._lastDollyDirection === $d7238066c5de7f1c$var$_m.OUT && this.maxDistance <= this._spherical.radius;
                if (this.infinityDolly && (Y || K)) {
                    this._sphericalEnd.radius -= d, this._spherical.radius -= d;
                    const M = $d7238066c5de7f1c$var$on.copy(A).multiplyScalar(-d);
                    N.add(M);
                }
                this._boundary.clampPoint(N, N);
                const z = $d7238066c5de7f1c$var$on.subVectors(N, this._targetEnd);
                this._targetEnd.copy(N), this._target.add(z), this._changedDolly -= d, $d7238066c5de7f1c$var$Tn(this._changedDolly) && (this._changedDolly = 0);
            } else if ($d7238066c5de7f1c$var$zd(this._camera) && this._changedZoom !== 0) {
                const d = this._zoom - this._lastZoom, p = this._camera, A = $d7238066c5de7f1c$var$Ai.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (p.near + p.far) / (p.near - p.far)).unproject(p), y = $d7238066c5de7f1c$var$on.set(0, 0, -1).applyQuaternion(p.quaternion), G = $d7238066c5de7f1c$var$Qm.copy(A).add(y.multiplyScalar(-A.dot(p.up))), v = -(this._zoom - d - this._zoom) / this._zoom, V = this._getCameraDirection($d7238066c5de7f1c$var$gy), H = this._targetEnd.dot(V), N = $d7238066c5de7f1c$var$Ai.copy(this._targetEnd).lerp(G, v), Y = N.dot(V), K = V.multiplyScalar(Y - H);
                N.sub(K), this._boundary.clampPoint(N, N);
                const z = $d7238066c5de7f1c$var$on.subVectors(N, this._targetEnd);
                this._targetEnd.copy(N), this._target.add(z), this._changedZoom -= d, $d7238066c5de7f1c$var$Tn(this._changedZoom) && (this._changedZoom = 0);
            }
        }
        this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
        const g = this._collisionTest();
        this._spherical.radius = Math.min(this._spherical.radius, g), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!$d7238066c5de7f1c$var$Tn(this._focalOffset.x) || !$d7238066c5de7f1c$var$Tn(this._focalOffset.y) || !$d7238066c5de7f1c$var$Tn(this._focalOffset.z)) && ($d7238066c5de7f1c$var$Tc.setFromMatrixColumn(this._camera.matrix, 0), $d7238066c5de7f1c$var$Mc.setFromMatrixColumn(this._camera.matrix, 1), $d7238066c5de7f1c$var$yC.setFromMatrixColumn(this._camera.matrix, 2), $d7238066c5de7f1c$var$Tc.multiplyScalar(this._focalOffset.x), $d7238066c5de7f1c$var$Mc.multiplyScalar(-this._focalOffset.y), $d7238066c5de7f1c$var$yC.multiplyScalar(this._focalOffset.z), $d7238066c5de7f1c$var$Ai.copy($d7238066c5de7f1c$var$Tc).add($d7238066c5de7f1c$var$Mc).add($d7238066c5de7f1c$var$yC), this._camera.position.add($d7238066c5de7f1c$var$Ai), this._camera.updateMatrixWorld()), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), $d7238066c5de7f1c$var$Ai.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
        const c = this._needsUpdate;
        return c && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({
            type: "wake"
        }), this.dispatchEvent({
            type: "update"
        })) : c ? (this.dispatchEvent({
            type: "update"
        }), $d7238066c5de7f1c$var$Tn(t, this.restThreshold) && $d7238066c5de7f1c$var$Tn(i, this.restThreshold) && $d7238066c5de7f1c$var$Tn(n, this.restThreshold) && $d7238066c5de7f1c$var$Tn(s.x, this.restThreshold) && $d7238066c5de7f1c$var$Tn(s.y, this.restThreshold) && $d7238066c5de7f1c$var$Tn(s.z, this.restThreshold) && $d7238066c5de7f1c$var$Tn(a.x, this.restThreshold) && $d7238066c5de7f1c$var$Tn(a.y, this.restThreshold) && $d7238066c5de7f1c$var$Tn(a.z, this.restThreshold) && $d7238066c5de7f1c$var$Tn(o, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({
            type: "rest"
        }))) : !c && this._updatedLastTime && this.dispatchEvent({
            type: "sleep"
        }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = c, this._needsUpdate = !1, c;
    }
    /**
   * Get all state in JSON string
   * @category Methods
   */ toJSON() {
        return JSON.stringify({
            enabled: this._enabled,
            minDistance: this.minDistance,
            maxDistance: $d7238066c5de7f1c$var$ay(this.maxDistance),
            minZoom: this.minZoom,
            maxZoom: $d7238066c5de7f1c$var$ay(this.maxZoom),
            minPolarAngle: this.minPolarAngle,
            maxPolarAngle: $d7238066c5de7f1c$var$ay(this.maxPolarAngle),
            minAzimuthAngle: $d7238066c5de7f1c$var$ay(this.minAzimuthAngle),
            maxAzimuthAngle: $d7238066c5de7f1c$var$ay(this.maxAzimuthAngle),
            smoothTime: this.smoothTime,
            draggingSmoothTime: this.draggingSmoothTime,
            dollySpeed: this.dollySpeed,
            truckSpeed: this.truckSpeed,
            dollyToCursor: this.dollyToCursor,
            target: this._targetEnd.toArray(),
            position: $d7238066c5de7f1c$var$Ai.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
            zoom: this._zoomEnd,
            focalOffset: this._focalOffsetEnd.toArray(),
            target0: this._target0.toArray(),
            position0: this._position0.toArray(),
            zoom0: this._zoom0,
            focalOffset0: this._focalOffset0.toArray()
        });
    }
    /**
   * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
   * @param json
   * @param enableTransition
   * @category Methods
   */ fromJSON(e, t = !1) {
        const i = JSON.parse(e);
        this.enabled = i.enabled, this.minDistance = i.minDistance, this.maxDistance = $d7238066c5de7f1c$var$oy(i.maxDistance), this.minZoom = i.minZoom, this.maxZoom = $d7238066c5de7f1c$var$oy(i.maxZoom), this.minPolarAngle = i.minPolarAngle, this.maxPolarAngle = $d7238066c5de7f1c$var$oy(i.maxPolarAngle), this.minAzimuthAngle = $d7238066c5de7f1c$var$oy(i.minAzimuthAngle), this.maxAzimuthAngle = $d7238066c5de7f1c$var$oy(i.maxAzimuthAngle), this.smoothTime = i.smoothTime, this.draggingSmoothTime = i.draggingSmoothTime, this.dollySpeed = i.dollySpeed, this.truckSpeed = i.truckSpeed, this.dollyToCursor = i.dollyToCursor, this._target0.fromArray(i.target0), this._position0.fromArray(i.position0), this._zoom0 = i.zoom0, this._focalOffset0.fromArray(i.focalOffset0), this.moveTo(i.target[0], i.target[1], i.target[2], t), $d7238066c5de7f1c$var$zg.setFromVector3($d7238066c5de7f1c$var$Ai.fromArray(i.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo($d7238066c5de7f1c$var$zg.theta, $d7238066c5de7f1c$var$zg.phi, t), this.dollyTo($d7238066c5de7f1c$var$zg.radius, t), this.zoomTo(i.zoom, t), this.setFocalOffset(i.focalOffset[0], i.focalOffset[1], i.focalOffset[2], t), this._needsUpdate = !0;
    }
    /**
   * Attach all internal event handlers to enable drag control.
   * @category Methods
   */ connect(e) {
        if (this._domElement) {
            console.warn("camera-controls is already connected.");
            return;
        }
        e.setAttribute("data-camera-controls-version", $d7238066c5de7f1c$var$bpe), this._addAllEventListeners(e), this._getClientRect(this._elementRect);
    }
    /**
   * Detach all internal event handlers to disable drag control.
   */ disconnect() {
        this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
    }
    /**
   * Dispose the cameraControls instance itself, remove all eventListeners.
   * @category Methods
   */ dispose() {
        this.removeAllEventListeners(), this.disconnect();
    }
    // it's okay to expose public though
    _getTargetDirection(e) {
        return e.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
    }
    // it's okay to expose public though
    _getCameraDirection(e) {
        return this._getTargetDirection(e).negate();
    }
    _findPointerById(e) {
        return this._activePointers.find((t)=>t.pointerId === e);
    }
    _findPointerByMouseButton(e) {
        return this._activePointers.find((t)=>t.mouseButton === e);
    }
    _disposePointer(e) {
        this._activePointers.splice(this._activePointers.indexOf(e), 1);
    }
    _encloseToBoundary(e, t, i) {
        const n = t.lengthSq();
        if (n === 0) return e;
        const s = $d7238066c5de7f1c$var$on.copy(t).add(e), o = this._boundary.clampPoint(s, $d7238066c5de7f1c$var$Qm).sub(s), g = o.lengthSq();
        if (g === 0) return e.add(t);
        if (g === n) return e;
        if (i === 0) return e.add(t).add(o);
        {
            const l = 1 + i * g / t.dot(o);
            return e.add($d7238066c5de7f1c$var$on.copy(t).multiplyScalar(l)).add(o.multiplyScalar(1 - i));
        }
    }
    _updateNearPlaneCorners() {
        if ($d7238066c5de7f1c$var$bC(this._camera)) {
            const e = this._camera, t = e.near, i = e.getEffectiveFOV() * $d7238066c5de7f1c$var$ry, n = Math.tan(i * 0.5) * t, s = n * e.aspect;
            this._nearPlaneCorners[0].set(-s, -n, 0), this._nearPlaneCorners[1].set(s, -n, 0), this._nearPlaneCorners[2].set(s, n, 0), this._nearPlaneCorners[3].set(-s, n, 0);
        } else if ($d7238066c5de7f1c$var$zd(this._camera)) {
            const e = this._camera, t = 1 / e.zoom, i = e.left * t, n = e.right * t, s = e.top * t, a = e.bottom * t;
            this._nearPlaneCorners[0].set(i, s, 0), this._nearPlaneCorners[1].set(n, s, 0), this._nearPlaneCorners[2].set(n, a, 0), this._nearPlaneCorners[3].set(i, a, 0);
        }
    }
    // lateUpdate
    _collisionTest() {
        let e = 1 / 0;
        if (!(this.colliderMeshes.length >= 1) || $d7238066c5de7f1c$var$gX(this._camera, "_collisionTest")) return e;
        const i = this._getTargetDirection($d7238066c5de7f1c$var$gy);
        $d7238066c5de7f1c$var$dX.lookAt($d7238066c5de7f1c$var$_T, i, this._camera.up);
        for(let n = 0; n < 4; n++){
            const s = $d7238066c5de7f1c$var$on.copy(this._nearPlaneCorners[n]);
            s.applyMatrix4($d7238066c5de7f1c$var$dX);
            const a = $d7238066c5de7f1c$var$Qm.addVectors(this._target, s);
            $d7238066c5de7f1c$var$gS.set(a, i), $d7238066c5de7f1c$var$gS.far = this._spherical.radius + 1;
            const o = $d7238066c5de7f1c$var$gS.intersectObjects(this.colliderMeshes);
            o.length !== 0 && o[0].distance < e && (e = o[0].distance);
        }
        return e;
    }
    /**
   * Get its client rect and package into given `DOMRect` .
   */ _getClientRect(e) {
        if (!this._domElement) return;
        const t = this._domElement.getBoundingClientRect();
        return e.x = t.left, e.y = t.top, this._viewport ? (e.x += this._viewport.x, e.y += t.height - this._viewport.w - this._viewport.y, e.width = this._viewport.z, e.height = this._viewport.w) : (e.width = t.width, e.height = t.height), e;
    }
    _createOnRestPromise(e) {
        return e ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({
            type: "transitionstart"
        }), new Promise((t)=>{
            const i = ()=>{
                this.removeEventListener("rest", i), t();
            };
            this.addEventListener("rest", i);
        }));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _addAllEventListeners(e) {}
    _removeAllEventListeners() {}
    /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */ get dampingFactor() {
        return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
    }
    /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */ set dampingFactor(e) {
        console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
    }
    /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */ get draggingDampingFactor() {
        return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
    }
    /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */ set draggingDampingFactor(e) {
        console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
    }
    static createBoundingSphere(e, t = new $d7238066c5de7f1c$var$jt.Sphere()) {
        const i = t, n = i.center;
        $d7238066c5de7f1c$var$Om.makeEmpty(), e.traverseVisible((a)=>{
            a.isMesh && $d7238066c5de7f1c$var$Om.expandByObject(a);
        }), $d7238066c5de7f1c$var$Om.getCenter(n);
        let s = 0;
        return e.traverseVisible((a)=>{
            if (!a.isMesh) return;
            const o = a;
            if (!o.geometry) return;
            const g = o.geometry.clone();
            g.applyMatrix4(o.matrixWorld);
            const c = g.attributes.position;
            for(let d = 0, p = c.count; d < p; d++)$d7238066c5de7f1c$var$Ai.fromBufferAttribute(c, d), s = Math.max(s, n.distanceToSquared($d7238066c5de7f1c$var$Ai));
        }), i.radius = Math.sqrt(s), i;
    }
};
const $d7238066c5de7f1c$var$Bpe = /* @__PURE__ */ (0, $bxRTa.forwardRef)((r, e)=>{
    (0, $bxRTa.useMemo)(()=>{
        const Y = {
            Box3: (0, $329ek.Box3),
            MathUtils: {
                clamp: (0, $329ek.MathUtils).clamp
            },
            Matrix4: (0, $329ek.Matrix4),
            Quaternion: (0, $329ek.Quaternion),
            Raycaster: (0, $329ek.Raycaster),
            Sphere: (0, $329ek.Sphere),
            Spherical: (0, $329ek.Spherical),
            Vector2: (0, $329ek.Vector2),
            Vector3: (0, $329ek.Vector3),
            Vector4: (0, $329ek.Vector4)
        };
        $d7238066c5de7f1c$var$hX.install({
            THREE: Y
        }), $d7238066c5de7f1c$var$qY({
            CameraControlsImpl: $d7238066c5de7f1c$var$hX
        });
    }, []);
    const { camera: t, domElement: i, makeDefault: n, onStart: s, onEnd: a, onChange: o, regress: g, ...l } = r, c = $d7238066c5de7f1c$var$gs((Y)=>Y.camera), d = $d7238066c5de7f1c$var$gs((Y)=>Y.gl), p = $d7238066c5de7f1c$var$gs((Y)=>Y.invalidate), A = $d7238066c5de7f1c$var$gs((Y)=>Y.events), y = $d7238066c5de7f1c$var$gs((Y)=>Y.setEvents), G = $d7238066c5de7f1c$var$gs((Y)=>Y.set), Z = $d7238066c5de7f1c$var$gs((Y)=>Y.get), v = $d7238066c5de7f1c$var$gs((Y)=>Y.performance), V = t || c, H = i || A.connected || d.domElement, N = (0, $bxRTa.useMemo)(()=>new $d7238066c5de7f1c$var$hX(V), [
        V
    ]);
    return $d7238066c5de7f1c$var$_R((Y, K)=>{
        N.enabled && N.update(K);
    }, -1), (0, $bxRTa.useEffect)(()=>(N.connect(H), ()=>void N.disconnect()), [
        H,
        N
    ]), (0, $bxRTa.useEffect)(()=>{
        const Y = (M)=>{
            p(), g && v.regress(), o && o(M);
        }, K = (M)=>{
            s && s(M);
        }, z = (M)=>{
            a && a(M);
        };
        return N.addEventListener("update", Y), N.addEventListener("controlstart", K), N.addEventListener("controlend", z), N.addEventListener("control", Y), N.addEventListener("transitionstart", Y), N.addEventListener("wake", Y), ()=>{
            N.removeEventListener("update", Y), N.removeEventListener("controlstart", K), N.removeEventListener("controlend", z), N.removeEventListener("control", Y), N.removeEventListener("transitionstart", Y), N.removeEventListener("wake", Y);
        };
    }, [
        N,
        s,
        a,
        p,
        y,
        g,
        o
    ]), (0, $bxRTa.useEffect)(()=>{
        if (n) {
            const Y = Z().controls;
            return G({
                controls: N
            }), ()=>G({
                    controls: Y
                });
        }
    }, [
        n,
        N
    ]), /* @__PURE__ */ $bxRTa.createElement("primitive", $d7238066c5de7f1c$var$fB({
        ref: e,
        object: N
    }, l));
});
function $d7238066c5de7f1c$var$CX(r, e, t, i) {
    return new (t || (t = Promise))(function(n, s) {
        function a(l) {
            try {
                g(i.next(l));
            } catch (c) {
                s(c);
            }
        }
        function o(l) {
            try {
                g(i.throw(l));
            } catch (c) {
                s(c);
            }
        }
        function g(l) {
            var c;
            l.done ? n(l.value) : (c = l.value, c instanceof t ? c : new t(function(d) {
                d(c);
            })).then(a, o);
        }
        g((i = i.apply(r, [])).next());
    });
}
const $d7238066c5de7f1c$var$fpe = [
    "geforce 320m",
    "geforce 8600",
    "geforce 8600m gt",
    "geforce 8800 gs",
    "geforce 8800 gt",
    "geforce 9400",
    "geforce 9400m g",
    "geforce 9400m",
    "geforce 9600m gt",
    "geforce 9600m",
    "geforce fx go5200",
    "geforce gt 120",
    "geforce gt 130",
    "geforce gt 330m",
    "geforce gtx 285",
    "google swiftshader",
    "intel g41",
    "intel g45",
    "intel gma 4500mhd",
    "intel gma x3100",
    "intel hd 3000",
    "intel q45",
    "legacy",
    "mali-2",
    "mali-3",
    "mali-4",
    "quadro fx 1500",
    "quadro fx 4",
    "quadro fx 5",
    "radeon hd 2400",
    "radeon hd 2600",
    "radeon hd 4670",
    "radeon hd 4850",
    "radeon hd 4870",
    "radeon hd 5670",
    "radeon hd 5750",
    "radeon hd 6290",
    "radeon hd 6300",
    "radeon hd 6310",
    "radeon hd 6320",
    "radeon hd 6490m",
    "radeon hd 6630m",
    "radeon hd 6750m",
    "radeon hd 6770m",
    "radeon hd 6970m",
    "sgx 543",
    "sgx543"
];
function $d7238066c5de7f1c$var$qT(r) {
    return r = r.toLowerCase().replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
const $d7238066c5de7f1c$var$gQ = typeof window > "u", $d7238066c5de7f1c$var$Uc = (()=>{
    if ($d7238066c5de7f1c$var$gQ) return;
    const { userAgent: r, platform: e, maxTouchPoints: t } = window.navigator, i = /(iphone|ipod|ipad)/i.test(r), n = e === "iPad" || e === "MacIntel" && t > 0 && !window.MSStream;
    return {
        isIpad: n,
        isMobile: /android/i.test(r) || i || n,
        isSafari12: /Version\/12.+Safari/.test(r),
        isFirefox: /Firefox/.test(r)
    };
})();
function $d7238066c5de7f1c$var$Gpe(r, e, t) {
    if (!t) return [
        e
    ];
    const i = function(l) {
        const c = `
    precision highp float;
    attribute vec3 aPosition;
    varying float vvv;
    void main() {
      vvv = 0.31622776601683794;
      gl_Position = vec4(aPosition, 1.0);
    }
  `, d = `
    precision highp float;
    varying float vvv;
    void main() {
      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;
      enc = fract(enc);
      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);
      gl_FragColor = enc;
    }
  `, p = l.createShader(35633), A = l.createShader(35632), y = l.createProgram();
        if (!(A && p && y)) return;
        l.shaderSource(p, c), l.shaderSource(A, d), l.compileShader(p), l.compileShader(A), l.attachShader(y, p), l.attachShader(y, A), l.linkProgram(y), l.detachShader(y, p), l.detachShader(y, A), l.deleteShader(p), l.deleteShader(A), l.useProgram(y);
        const G = l.createBuffer();
        l.bindBuffer(34962, G), l.bufferData(34962, new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), 35044);
        const Z = l.getAttribLocation(y, "aPosition");
        l.vertexAttribPointer(Z, 3, 5126, !1, 0, 0), l.enableVertexAttribArray(Z), l.clearColor(1, 1, 1, 1), l.clear(16384), l.viewport(0, 0, 1, 1), l.drawArrays(4, 0, 3);
        const v = new Uint8Array(4);
        return l.readPixels(0, 0, 1, 1, 6408, 5121, v), l.deleteProgram(y), l.deleteBuffer(G), v.join("");
    }(r), n = "801621810", s = "8016218135", a = "80162181161", o = $d7238066c5de7f1c$var$Uc != null && $d7238066c5de7f1c$var$Uc.isIpad ? [
        [
            "a7",
            a,
            12
        ],
        [
            "a8",
            s,
            15
        ],
        [
            "a8x",
            s,
            15
        ],
        [
            "a9",
            s,
            15
        ],
        [
            "a9x",
            s,
            15
        ],
        [
            "a10",
            s,
            15
        ],
        [
            "a10x",
            s,
            15
        ],
        [
            "a12",
            n,
            15
        ],
        [
            "a12x",
            n,
            15
        ],
        [
            "a12z",
            n,
            15
        ],
        [
            "a14",
            n,
            15
        ],
        [
            "a15",
            n,
            15
        ],
        [
            "m1",
            n,
            15
        ],
        [
            "m2",
            n,
            15
        ]
    ] : [
        [
            "a7",
            a,
            12
        ],
        [
            "a8",
            s,
            12
        ],
        [
            "a9",
            s,
            15
        ],
        [
            "a10",
            s,
            15
        ],
        [
            "a11",
            n,
            15
        ],
        [
            "a12",
            n,
            15
        ],
        [
            "a13",
            n,
            15
        ],
        [
            "a14",
            n,
            15
        ],
        [
            "a15",
            n,
            15
        ],
        [
            "a16",
            n,
            15
        ],
        [
            "a17",
            n,
            15
        ]
    ];
    let g;
    return i === "80162181255" ? g = o.filter(([, , l])=>l >= 14) : (g = o.filter(([, l])=>l === i), g.length || (g = o)), g.map(([l])=>`apple ${l} gpu`);
}
class $d7238066c5de7f1c$var$$T extends Error {
    constructor(e){
        super(e), Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $d7238066c5de7f1c$var$pX = [], $d7238066c5de7f1c$var$eM = [];
function $d7238066c5de7f1c$var$vpe(r, e) {
    if (r === e) return 0;
    const t = r;
    r.length > e.length && (r = e, e = t);
    let i = r.length, n = e.length;
    for(; i > 0 && r.charCodeAt(~-i) === e.charCodeAt(~-n);)i--, n--;
    let s, a = 0;
    for(; a < i && r.charCodeAt(a) === e.charCodeAt(a);)a++;
    if (i -= a, n -= a, i === 0) return n;
    let o, g, l = 0, c = 0, d = 0;
    for(; c < i;)$d7238066c5de7f1c$var$eM[c] = r.charCodeAt(a + c), $d7238066c5de7f1c$var$pX[c] = ++c;
    for(; d < n;)for(s = e.charCodeAt(a + d), o = d++, l = d, c = 0; c < i; c++)g = s === $d7238066c5de7f1c$var$eM[c] ? o : o + 1, o = $d7238066c5de7f1c$var$pX[c], l = $d7238066c5de7f1c$var$pX[c] = o > l ? g > l ? l + 1 : g : g > o ? o + 1 : g;
    return l;
}
function $d7238066c5de7f1c$var$Spe(r) {
    return r != null;
}
const $d7238066c5de7f1c$var$Zpe = ({ mobileTiers: r = [
    0,
    15,
    30,
    60
], desktopTiers: e = [
    0,
    15,
    30,
    60
], override: t = {}, glContext: i, failIfMajorPerformanceCaveat: n = !1, benchmarksURL: s = "https://unpkg.com/detect-gpu@5.0.70/dist/benchmarks" } = {})=>$d7238066c5de7f1c$var$CX(void 0, void 0, void 0, function*() {
        const a = {};
        if ($d7238066c5de7f1c$var$gQ) return {
            tier: 0,
            type: "SSR"
        };
        const { isIpad: o = !!($d7238066c5de7f1c$var$Uc != null && $d7238066c5de7f1c$var$Uc.isIpad), isMobile: g = !!($d7238066c5de7f1c$var$Uc != null && $d7238066c5de7f1c$var$Uc.isMobile), screenSize: l = window.screen, loadBenchmarks: c = (Y)=>$d7238066c5de7f1c$var$CX(void 0, void 0, void 0, function*() {
                const K = yield fetch(`${s}/${Y}`).then((z)=>z.json());
                if (parseInt(K.shift().split(".")[0], 10) < 4) throw new $d7238066c5de7f1c$var$$T("Detect GPU benchmark data is out of date. Please update to version 4x");
                return K;
            }) } = t;
        let { renderer: d } = t;
        const p = (Y, K, z, M, _)=>({
                device: _,
                fps: M,
                gpu: z,
                isMobile: g,
                tier: Y,
                type: K
            });
        let A, y = "";
        if (d) d = $d7238066c5de7f1c$var$qT(d), A = [
            d
        ];
        else {
            const Y = i || function(z, M = !1) {
                const _ = {
                    alpha: !1,
                    antialias: !1,
                    depth: !1,
                    failIfMajorPerformanceCaveat: M,
                    powerPreference: "high-performance",
                    stencil: !1
                };
                z && delete _.powerPreference;
                const O = window.document.createElement("canvas"), ie = O.getContext("webgl", _) || O.getContext("experimental-webgl", _);
                return ie ?? void 0;
            }($d7238066c5de7f1c$var$Uc == null ? void 0 : $d7238066c5de7f1c$var$Uc.isSafari12, n);
            if (!Y) return p(0, "WEBGL_UNSUPPORTED");
            const K = $d7238066c5de7f1c$var$Uc != null && $d7238066c5de7f1c$var$Uc.isFirefox ? null : Y.getExtension("WEBGL_debug_renderer_info");
            if (d = K ? Y.getParameter(K.UNMASKED_RENDERER_WEBGL) : Y.getParameter(Y.RENDERER), !d) return p(1, "FALLBACK");
            y = d, d = $d7238066c5de7f1c$var$qT(d), A = function(z, M, _) {
                return M === "apple gpu" ? $d7238066c5de7f1c$var$Gpe(z, M, _) : [
                    M
                ];
            }(Y, d, g);
        }
        const G = (yield Promise.all(A.map(function(Y) {
            var K;
            return $d7238066c5de7f1c$var$CX(this, void 0, void 0, function*() {
                const z = ((Xe)=>{
                    const Te = g ? [
                        "adreno",
                        "apple",
                        "mali-t",
                        "mali",
                        "nvidia",
                        "powervr",
                        "samsung"
                    ] : [
                        "intel",
                        "apple",
                        "amd",
                        "radeon",
                        "nvidia",
                        "geforce",
                        "adreno"
                    ];
                    for (const ct of Te)if (Xe.includes(ct)) return ct;
                })(Y);
                if (!z) return;
                const M = `${g ? "m" : "d"}-${z}${o ? "-ipad" : ""}.json`, _ = a[M] = (K = a[M]) !== null && K !== void 0 ? K : c(M);
                let O;
                try {
                    O = yield _;
                } catch (Xe) {
                    if (Xe instanceof $d7238066c5de7f1c$var$$T) throw Xe;
                    return;
                }
                const ie = function(Xe) {
                    var Te;
                    const ct = (Xe = Xe.replace(/\([^)]+\)/, "")).match(/\d+/) || Xe.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                    return (Te = ct == null ? void 0 : ct.join("").replace(/\W|amd/g, "")) !== null && Te !== void 0 ? Te : "";
                }(Y);
                let he = O.filter(([, Xe])=>Xe === ie);
                he.length || (he = O.filter(([Xe])=>Xe.includes(Y)));
                const pe = he.length;
                if (pe === 0) return;
                const ce = Y.split(/[.,()\[\]/\s]/g).sort().filter((Xe, Te, ct)=>Te === 0 || Xe !== ct[Te - 1]).join(" ");
                let $, [te, , , , Ge] = pe > 1 ? he.map((Xe)=>[
                        Xe,
                        $d7238066c5de7f1c$var$vpe(ce, Xe[2])
                    ]).sort(([, Xe], [, Te])=>Xe - Te)[0][0] : he[0], q = Number.MAX_VALUE;
                const { devicePixelRatio: de } = window, ge = l.width * de * l.height * de;
                for (const Xe of Ge){
                    const [Te, ct] = Xe, st = Te * ct, Xt = Math.abs(ge - st);
                    Xt < q && (q = Xt, $ = Xe);
                }
                if (!$) return;
                const [, , Ye, Fe] = $;
                return [
                    q,
                    Ye,
                    te,
                    Fe
                ];
            });
        }))).filter($d7238066c5de7f1c$var$Spe).sort(([Y = Number.MAX_VALUE, K], [z = Number.MAX_VALUE, M])=>Y === z ? K - M : Y - z);
        if (!G.length) {
            const Y = $d7238066c5de7f1c$var$fpe.find((K)=>d.includes(K));
            return Y ? p(0, "BLOCKLISTED", Y) : p(1, "FALLBACK", `${d} (${y})`);
        }
        const [, Z, v, V] = G[0];
        if (Z === -1) return p(0, "BLOCKLISTED", v, Z, V);
        const H = g ? r : e;
        let N = 0;
        for(let Y = 0; Y < H.length; Y++)Z >= H[Y] && (N = Y);
        return p(N, "BENCHMARK", v, Z, V);
    }), $d7238066c5de7f1c$var$Rpe = (r)=>$d7238066c5de7f1c$var$xP(()=>$d7238066c5de7f1c$var$Zpe(r), [
        "useDetectGPU"
    ]), $d7238066c5de7f1c$var$Vpe = 3e3, $d7238066c5de7f1c$var$wpe = 3001, $d7238066c5de7f1c$var$lQ = (r, e, t)=>{
    let i;
    switch(r){
        case 0, $329ek.UnsignedByteType:
            i = new Uint8ClampedArray(e * t * 4);
            break;
        case 0, $329ek.HalfFloatType:
            i = new Uint16Array(e * t * 4);
            break;
        case 0, $329ek.UnsignedIntType:
            i = new Uint32Array(e * t * 4);
            break;
        case 0, $329ek.ByteType:
            i = new Int8Array(e * t * 4);
            break;
        case 0, $329ek.ShortType:
            i = new Int16Array(e * t * 4);
            break;
        case 0, $329ek.IntType:
            i = new Int32Array(e * t * 4);
            break;
        case 0, $329ek.FloatType:
            i = new Float32Array(e * t * 4);
            break;
        default:
            throw new Error("Unsupported data type");
    }
    return i;
};
let $d7238066c5de7f1c$var$lS;
const $d7238066c5de7f1c$var$Wpe = (r, e, t, i)=>{
    if ($d7238066c5de7f1c$var$lS !== void 0) return $d7238066c5de7f1c$var$lS;
    const n = new (0, $329ek.WebGLRenderTarget)(1, 1, i);
    e.setRenderTarget(n);
    const s = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(), new (0, $329ek.MeshBasicMaterial)({
        color: 16777215
    }));
    e.render(s, t), e.setRenderTarget(null);
    const a = $d7238066c5de7f1c$var$lQ(r, n.width, n.height);
    return e.readRenderTargetPixels(n, 0, 0, n.width, n.height, a), n.dispose(), s.geometry.dispose(), s.material.dispose(), $d7238066c5de7f1c$var$lS = a[0] !== 0, $d7238066c5de7f1c$var$lS;
};
class $d7238066c5de7f1c$var$iK {
    /**
   * Constructs a new QuadRenderer
   *
   * @param options Parameters for this QuadRenderer
   */ constructor(e){
        var t, i, n, s, a, o, g, l, c, d, p, A, y, G, Z, v;
        this._rendererIsDisposable = !1, this._supportsReadPixels = !0, this.render = ()=>{
            this._renderer.setRenderTarget(this._renderTarget);
            try {
                this._renderer.render(this._scene, this._camera);
            } catch (H) {
                throw this._renderer.setRenderTarget(null), H;
            }
            this._renderer.setRenderTarget(null);
        }, this._width = e.width, this._height = e.height, this._type = e.type, this._colorSpace = e.colorSpace;
        const V = {
            // fixed options
            format: (0, $329ek.RGBAFormat),
            depthBuffer: !1,
            stencilBuffer: !1,
            // user options
            type: this._type,
            // set in class property
            colorSpace: this._colorSpace,
            // set in class property
            anisotropy: ((t = e.renderTargetOptions) === null || t === void 0 ? void 0 : t.anisotropy) !== void 0 ? (i = e.renderTargetOptions) === null || i === void 0 ? void 0 : i.anisotropy : 1,
            generateMipmaps: ((n = e.renderTargetOptions) === null || n === void 0 ? void 0 : n.generateMipmaps) !== void 0 ? (s = e.renderTargetOptions) === null || s === void 0 ? void 0 : s.generateMipmaps : !1,
            magFilter: ((a = e.renderTargetOptions) === null || a === void 0 ? void 0 : a.magFilter) !== void 0 ? (o = e.renderTargetOptions) === null || o === void 0 ? void 0 : o.magFilter : (0, $329ek.LinearFilter),
            minFilter: ((g = e.renderTargetOptions) === null || g === void 0 ? void 0 : g.minFilter) !== void 0 ? (l = e.renderTargetOptions) === null || l === void 0 ? void 0 : l.minFilter : (0, $329ek.LinearFilter),
            samples: ((c = e.renderTargetOptions) === null || c === void 0 ? void 0 : c.samples) !== void 0 ? (d = e.renderTargetOptions) === null || d === void 0 ? void 0 : d.samples : void 0,
            wrapS: ((p = e.renderTargetOptions) === null || p === void 0 ? void 0 : p.wrapS) !== void 0 ? (A = e.renderTargetOptions) === null || A === void 0 ? void 0 : A.wrapS : (0, $329ek.ClampToEdgeWrapping),
            wrapT: ((y = e.renderTargetOptions) === null || y === void 0 ? void 0 : y.wrapT) !== void 0 ? (G = e.renderTargetOptions) === null || G === void 0 ? void 0 : G.wrapT : (0, $329ek.ClampToEdgeWrapping)
        };
        if (this._material = e.material, e.renderer ? this._renderer = e.renderer : (this._renderer = $d7238066c5de7f1c$var$iK.instantiateRenderer(), this._rendererIsDisposable = !0), this._scene = new (0, $329ek.Scene)(), this._camera = new (0, $329ek.OrthographicCamera)(), this._camera.position.set(0, 0, 10), this._camera.left = -0.5, this._camera.right = 0.5, this._camera.top = 0.5, this._camera.bottom = -0.5, this._camera.updateProjectionMatrix(), !$d7238066c5de7f1c$var$Wpe(this._type, this._renderer, this._camera, V)) {
            let H;
            switch(this._type){
                case 0, $329ek.HalfFloatType:
                    H = this._renderer.extensions.has("EXT_color_buffer_float") ? (0, $329ek.FloatType) : void 0;
                    break;
            }
            H !== void 0 ? (console.warn(`This browser does not support reading pixels from ${this._type} RenderTargets, switching to ${(0, $329ek.FloatType)}`), this._type = H) : (this._supportsReadPixels = !1, console.warn("This browser dos not support toArray or toDataTexture, calls to those methods will result in an error thrown"));
        }
        this._quad = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(), this._material), this._quad.geometry.computeBoundingBox(), this._scene.add(this._quad), this._renderTarget = new (0, $329ek.WebGLRenderTarget)(this.width, this.height, V), this._renderTarget.texture.mapping = ((Z = e.renderTargetOptions) === null || Z === void 0 ? void 0 : Z.mapping) !== void 0 ? (v = e.renderTargetOptions) === null || v === void 0 ? void 0 : v.mapping : (0, $329ek.UVMapping);
    }
    /**
   * Instantiates a temporary renderer
   *
   * @returns
   */ static instantiateRenderer() {
        const e = new (0, $1W96c.WebGLRenderer)();
        return e.setSize(128, 128), e;
    }
    /**
   * Obtains a Buffer containing the rendered texture.
   *
   * @throws Error if the browser cannot read pixels from this RenderTarget type.
   * @returns a TypedArray containing RGBA values from this renderer
   */ toArray() {
        if (!this._supportsReadPixels) throw new Error("Can't read pixels in this browser");
        const e = $d7238066c5de7f1c$var$lQ(this._type, this._width, this._height);
        return this._renderer.readRenderTargetPixels(this._renderTarget, 0, 0, this._width, this._height, e), e;
    }
    /**
   * Performs a readPixel operation in the renderTarget
   * and returns a DataTexture containing the read data
   *
   * @param options options
   * @returns
   */ toDataTexture(e) {
        const t = new (0, $329ek.DataTexture)(// fixed values
        this.toArray(), this.width, this.height, (0, $329ek.RGBAFormat), this._type, // user values
        (e == null ? void 0 : e.mapping) || (0, $329ek.UVMapping), (e == null ? void 0 : e.wrapS) || (0, $329ek.ClampToEdgeWrapping), (e == null ? void 0 : e.wrapT) || (0, $329ek.ClampToEdgeWrapping), (e == null ? void 0 : e.magFilter) || (0, $329ek.LinearFilter), (e == null ? void 0 : e.minFilter) || (0, $329ek.LinearFilter), (e == null ? void 0 : e.anisotropy) || 1, // fixed value
        (0, $329ek.LinearSRGBColorSpace));
        return t.generateMipmaps = (e == null ? void 0 : e.generateMipmaps) !== void 0 ? e == null ? void 0 : e.generateMipmaps : !1, t;
    }
    /**
   * If using a disposable renderer, it will dispose it.
   */ disposeOnDemandRenderer() {
        this._renderer.setRenderTarget(null), this._rendererIsDisposable && (this._renderer.dispose(), this._renderer.forceContextLoss());
    }
    /**
   * Will dispose of **all** assets used by this renderer.
   *
   *
   * @param disposeRenderTarget will dispose of the renderTarget which will not be usable later
   * set this to true if you passed the `renderTarget.texture` to a `PMREMGenerator`
   * or are otherwise done with it.
   *
   * @example
   * ```js
   * const loader = new HDRJPGLoader(renderer)
   * const result = await loader.loadAsync('gainmap.jpeg')
   * const mesh = new Mesh(geometry, new MeshBasicMaterial({ map: result.renderTarget.texture }) )
   * // DO NOT dispose the renderTarget here,
   * // it is used directly in the material
   * result.dispose()
   * ```
   *
   * @example
   * ```js
   * const loader = new HDRJPGLoader(renderer)
   * const pmremGenerator = new PMREMGenerator( renderer );
   * const result = await loader.loadAsync('gainmap.jpeg')
   * const envMap = pmremGenerator.fromEquirectangular(result.renderTarget.texture)
   * const mesh = new Mesh(geometry, new MeshStandardMaterial({ envMap }) )
   * // renderTarget can be disposed here
   * // because it was used to generate a PMREM texture
   * result.dispose(true)
   * ```
   */ dispose(e) {
        this.disposeOnDemandRenderer(), e && this.renderTarget.dispose(), this.material instanceof (0, $329ek.ShaderMaterial) && Object.values(this.material.uniforms).forEach((t)=>{
            t.value instanceof (0, $329ek.Texture) && t.value.dispose();
        }), Object.values(this.material).forEach((t)=>{
            t instanceof (0, $329ek.Texture) && t.dispose();
        }), this.material.dispose(), this._quad.geometry.dispose();
    }
    /**
   * Width of the texture
   */ get width() {
        return this._width;
    }
    set width(e) {
        this._width = e, this._renderTarget.setSize(this._width, this._height);
    }
    /**
   * Height of the texture
   */ get height() {
        return this._height;
    }
    set height(e) {
        this._height = e, this._renderTarget.setSize(this._width, this._height);
    }
    /**
   * The renderer used
   */ get renderer() {
        return this._renderer;
    }
    /**
   * The `WebGLRenderTarget` used.
   */ get renderTarget() {
        return this._renderTarget;
    }
    set renderTarget(e) {
        this._renderTarget = e, this._width = e.width, this._height = e.height;
    }
    /**
   * The `Material` used.
   */ get material() {
        return this._material;
    }
    /**
   *
   */ get type() {
        return this._type;
    }
    get colorSpace() {
        return this._colorSpace;
    }
}
const $d7238066c5de7f1c$var$Hpe = /* glsl */ `
varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`, $d7238066c5de7f1c$var$Xpe = /* glsl */ `
// min half float value
#define HALF_FLOAT_MIN vec3( -65504, -65504, -65504 )
// max half float value
#define HALF_FLOAT_MAX vec3( 65504, 65504, 65504 )

uniform sampler2D sdr;
uniform sampler2D gainMap;
uniform vec3 gamma;
uniform vec3 offsetHdr;
uniform vec3 offsetSdr;
uniform vec3 gainMapMin;
uniform vec3 gainMapMax;
uniform float weightFactor;

varying vec2 vUv;

void main() {
  vec3 rgb = texture2D( sdr, vUv ).rgb;
  vec3 recovery = texture2D( gainMap, vUv ).rgb;
  vec3 logRecovery = pow( recovery, gamma );
  vec3 logBoost = gainMapMin * ( 1.0 - logRecovery ) + gainMapMax * logRecovery;
  vec3 hdrColor = (rgb + offsetSdr) * exp2( logBoost * weightFactor ) - offsetHdr;
  vec3 clampedHdrColor = max( HALF_FLOAT_MIN, min( HALF_FLOAT_MAX, hdrColor ));
  gl_FragColor = vec4( clampedHdrColor , 1.0 );
}
`;
class $d7238066c5de7f1c$var$Npe extends (0, $329ek.ShaderMaterial) {
    /**
   *
   * @param params
   */ constructor({ gamma: e, offsetHdr: t, offsetSdr: i, gainMapMin: n, gainMapMax: s, maxDisplayBoost: a, hdrCapacityMin: o, hdrCapacityMax: g, sdr: l, gainMap: c }){
        super({
            name: "GainMapDecoderMaterial",
            vertexShader: $d7238066c5de7f1c$var$Hpe,
            fragmentShader: $d7238066c5de7f1c$var$Xpe,
            uniforms: {
                sdr: {
                    value: l
                },
                gainMap: {
                    value: c
                },
                gamma: {
                    value: new (0, $329ek.Vector3)(1 / e[0], 1 / e[1], 1 / e[2])
                },
                offsetHdr: {
                    value: new (0, $329ek.Vector3)().fromArray(t)
                },
                offsetSdr: {
                    value: new (0, $329ek.Vector3)().fromArray(i)
                },
                gainMapMin: {
                    value: new (0, $329ek.Vector3)().fromArray(n)
                },
                gainMapMax: {
                    value: new (0, $329ek.Vector3)().fromArray(s)
                },
                weightFactor: {
                    value: (Math.log2(a) - o) / (g - o)
                }
            },
            blending: (0, $329ek.NoBlending),
            depthTest: !1,
            depthWrite: !1
        }), this._maxDisplayBoost = a, this._hdrCapacityMin = o, this._hdrCapacityMax = g, this.needsUpdate = !0, this.uniformsNeedUpdate = !0;
    }
    get sdr() {
        return this.uniforms.sdr.value;
    }
    set sdr(e) {
        this.uniforms.sdr.value = e;
    }
    get gainMap() {
        return this.uniforms.gainMap.value;
    }
    set gainMap(e) {
        this.uniforms.gainMap.value = e;
    }
    /**
   * @see {@link GainMapMetadata.offsetHdr}
   */ get offsetHdr() {
        return this.uniforms.offsetHdr.value.toArray();
    }
    set offsetHdr(e) {
        this.uniforms.offsetHdr.value.fromArray(e);
    }
    /**
   * @see {@link GainMapMetadata.offsetSdr}
   */ get offsetSdr() {
        return this.uniforms.offsetSdr.value.toArray();
    }
    set offsetSdr(e) {
        this.uniforms.offsetSdr.value.fromArray(e);
    }
    /**
   * @see {@link GainMapMetadata.gainMapMin}
   */ get gainMapMin() {
        return this.uniforms.gainMapMin.value.toArray();
    }
    set gainMapMin(e) {
        this.uniforms.gainMapMin.value.fromArray(e);
    }
    /**
   * @see {@link GainMapMetadata.gainMapMax}
   */ get gainMapMax() {
        return this.uniforms.gainMapMax.value.toArray();
    }
    set gainMapMax(e) {
        this.uniforms.gainMapMax.value.fromArray(e);
    }
    /**
   * @see {@link GainMapMetadata.gamma}
   */ get gamma() {
        const e = this.uniforms.gamma.value;
        return [
            1 / e.x,
            1 / e.y,
            1 / e.z
        ];
    }
    set gamma(e) {
        const t = this.uniforms.gamma.value;
        t.x = 1 / e[0], t.y = 1 / e[1], t.z = 1 / e[2];
    }
    /**
   * @see {@link GainMapMetadata.hdrCapacityMin}
   * @remarks Logarithmic space
   */ get hdrCapacityMin() {
        return this._hdrCapacityMin;
    }
    set hdrCapacityMin(e) {
        this._hdrCapacityMin = e, this.calculateWeight();
    }
    /**
   * @see {@link GainMapMetadata.hdrCapacityMin}
   * @remarks Logarithmic space
   */ get hdrCapacityMax() {
        return this._hdrCapacityMax;
    }
    set hdrCapacityMax(e) {
        this._hdrCapacityMax = e, this.calculateWeight();
    }
    /**
   * @see {@link GainmapDecodingParameters.maxDisplayBoost}
   * @remarks Non Logarithmic space
   */ get maxDisplayBoost() {
        return this._maxDisplayBoost;
    }
    set maxDisplayBoost(e) {
        this._maxDisplayBoost = Math.max(1, Math.min(65504, e)), this.calculateWeight();
    }
    calculateWeight() {
        const e = (Math.log2(this._maxDisplayBoost) - this._hdrCapacityMin) / (this._hdrCapacityMax - this._hdrCapacityMin);
        this.uniforms.weightFactor.value = Math.max(0, Math.min(1, e));
    }
}
class $d7238066c5de7f1c$var$cQ extends Error {
}
class $d7238066c5de7f1c$var$uQ extends Error {
}
const $d7238066c5de7f1c$var$cy = (r, e, t)=>{
    const i = new RegExp(`${e}="([^"]*)"`, "i").exec(r);
    if (i) return i[1];
    const n = new RegExp(`<${e}[^>]*>([\\s\\S]*?)</${e}>`, "i").exec(r);
    if (n) {
        const s = n[1].match(/<rdf:li>([^<]*)<\/rdf:li>/g);
        return s && s.length === 3 ? s.map((a)=>a.replace(/<\/?rdf:li>/g, "")) : n[1].trim();
    }
    if (t !== void 0) return t;
    throw new Error(`Can't find ${e} in gainmap metadata`);
}, $d7238066c5de7f1c$var$Lpe = (r)=>{
    let e;
    typeof TextDecoder < "u" ? e = new TextDecoder().decode(r) : e = r.toString();
    let t = e.indexOf("<x:xmpmeta");
    for(; t !== -1;){
        const i = e.indexOf("x:xmpmeta>", t), n = e.slice(t, i + 10);
        try {
            const s = $d7238066c5de7f1c$var$cy(n, "hdrgm:GainMapMin", "0"), a = $d7238066c5de7f1c$var$cy(n, "hdrgm:GainMapMax"), o = $d7238066c5de7f1c$var$cy(n, "hdrgm:Gamma", "1"), g = $d7238066c5de7f1c$var$cy(n, "hdrgm:OffsetSDR", "0.015625"), l = $d7238066c5de7f1c$var$cy(n, "hdrgm:OffsetHDR", "0.015625"), c = /hdrgm:HDRCapacityMin="([^"]*)"/.exec(n), d = c ? c[1] : "0", p = /hdrgm:HDRCapacityMax="([^"]*)"/.exec(n);
            if (!p) throw new Error("Incomplete gainmap metadata");
            const A = p[1];
            return {
                gainMapMin: Array.isArray(s) ? s.map((y)=>parseFloat(y)) : [
                    parseFloat(s),
                    parseFloat(s),
                    parseFloat(s)
                ],
                gainMapMax: Array.isArray(a) ? a.map((y)=>parseFloat(y)) : [
                    parseFloat(a),
                    parseFloat(a),
                    parseFloat(a)
                ],
                gamma: Array.isArray(o) ? o.map((y)=>parseFloat(y)) : [
                    parseFloat(o),
                    parseFloat(o),
                    parseFloat(o)
                ],
                offsetSdr: Array.isArray(g) ? g.map((y)=>parseFloat(y)) : [
                    parseFloat(g),
                    parseFloat(g),
                    parseFloat(g)
                ],
                offsetHdr: Array.isArray(l) ? l.map((y)=>parseFloat(y)) : [
                    parseFloat(l),
                    parseFloat(l),
                    parseFloat(l)
                ],
                hdrCapacityMin: parseFloat(d),
                hdrCapacityMax: parseFloat(A)
            };
        } catch  {}
        t = e.indexOf("<x:xmpmeta", i);
    }
};
class $d7238066c5de7f1c$var$Ype {
    constructor(e){
        this.options = {
            debug: e && e.debug !== void 0 ? e.debug : !1,
            extractFII: e && e.extractFII !== void 0 ? e.extractFII : !0,
            extractNonFII: e && e.extractNonFII !== void 0 ? e.extractNonFII : !0
        };
    }
    extract(e) {
        return new Promise((t, i)=>{
            const n = this.options.debug, s = new DataView(e.buffer);
            if (s.getUint16(0) !== 65496) {
                i(new Error("Not a valid jpeg"));
                return;
            }
            const a = s.byteLength;
            let o = 2, g = 0, l;
            for(; o < a;){
                if (++g > 250) {
                    i(new Error(`Found no marker after ${g} loops \u{1F635}`));
                    return;
                }
                if (s.getUint8(o) !== 255) {
                    i(new Error(`Not a valid marker at offset 0x${o.toString(16)}, found: 0x${s.getUint8(o).toString(16)}`));
                    return;
                }
                if (l = s.getUint8(o + 1), n && console.log(`Marker: ${l.toString(16)}`), l === 226) {
                    n && console.log("Found APP2 marker (0xffe2)");
                    const c = o + 4;
                    if (s.getUint32(c) === 1297106432) {
                        const d = c + 4;
                        let p;
                        if (s.getUint16(d) === 18761) p = !1;
                        else if (s.getUint16(d) === 19789) p = !0;
                        else {
                            i(new Error("No valid endianness marker found in TIFF header"));
                            return;
                        }
                        if (s.getUint16(d + 2, !p) !== 42) {
                            i(new Error("Not valid TIFF data! (no 0x002A marker)"));
                            return;
                        }
                        const A = s.getUint32(d + 4, !p);
                        if (A < 8) {
                            i(new Error("Not valid TIFF data! (First offset less than 8)"));
                            return;
                        }
                        const y = d + A, G = s.getUint16(y, !p), Z = y + 2;
                        let v = 0;
                        for(let Y = Z; Y < Z + 12 * G; Y += 12)s.getUint16(Y, !p) === 45057 && (v = s.getUint32(Y + 8, !p));
                        const H = y + 2 + G * 12 + 4, N = [];
                        for(let Y = H; Y < H + v * 16; Y += 16){
                            const K = {
                                MPType: s.getUint32(Y, !p),
                                size: s.getUint32(Y + 4, !p),
                                // This offset is specified relative to the address of the MP Endian
                                // field in the MP Header, unless the image is a First Individual Image,
                                // in which case the value of the offset shall be NULL (0x00000000).
                                dataOffset: s.getUint32(Y + 8, !p),
                                dependantImages: s.getUint32(Y + 12, !p),
                                start: -1,
                                end: -1,
                                isFII: !1
                            };
                            K.dataOffset ? (K.start = d + K.dataOffset, K.isFII = !1) : (K.start = 0, K.isFII = !0), K.end = K.start + K.size, N.push(K);
                        }
                        if (this.options.extractNonFII && N.length) {
                            const Y = new Blob([
                                s
                            ]), K = [];
                            for (const z of N){
                                if (z.isFII && !this.options.extractFII) continue;
                                const M = Y.slice(z.start, z.end + 1, "image/jpeg");
                                K.push(M);
                            }
                            t(K);
                        }
                    }
                }
                o += 2 + s.getUint16(o + 2);
            }
        });
    }
}
const $d7238066c5de7f1c$var$Kpe = async (r)=>{
    const e = $d7238066c5de7f1c$var$Lpe(r);
    if (!e) throw new $d7238066c5de7f1c$var$uQ("Gain map XMP metadata not found");
    const i = await new $d7238066c5de7f1c$var$Ype({
        extractFII: !0,
        extractNonFII: !0
    }).extract(r);
    if (i.length !== 2) throw new $d7238066c5de7f1c$var$cQ("Gain map recovery image not found");
    return {
        sdr: new Uint8Array(await i[0].arrayBuffer()),
        gainMap: new Uint8Array(await i[1].arrayBuffer()),
        metadata: e
    };
}, $d7238066c5de7f1c$var$tM = (r)=>new Promise((e, t)=>{
        const i = document.createElement("img");
        i.onload = ()=>{
            e(i);
        }, i.onerror = (n)=>{
            t(n);
        }, i.src = URL.createObjectURL(r);
    });
class $d7238066c5de7f1c$var$IQ extends (0, $329ek.Loader) {
    /**
   *
   * @param renderer
   * @param manager
   */ constructor(e, t){
        super(t), e && (this._renderer = e), this._internalLoadingManager = new (0, $329ek.LoadingManager)();
    }
    /**
   * Specify the renderer to use when rendering the gain map
   *
   * @param renderer
   * @returns
   */ setRenderer(e) {
        return this._renderer = e, this;
    }
    /**
   * Specify the renderTarget options to use when rendering the gain map
   *
   * @param options
   * @returns
   */ setRenderTargetOptions(e) {
        return this._renderTargetOptions = e, this;
    }
    /**
   * @private
   * @returns
   */ prepareQuadRenderer() {
        this._renderer || console.warn("WARNING: An existing WebGL Renderer was not passed to this Loader constructor or in setRenderer, the result of this Loader will need to be converted to a Data Texture with toDataTexture() before you can use it in your renderer.");
        const e = new $d7238066c5de7f1c$var$Npe({
            gainMapMax: [
                1,
                1,
                1
            ],
            gainMapMin: [
                0,
                0,
                0
            ],
            gamma: [
                1,
                1,
                1
            ],
            offsetHdr: [
                1,
                1,
                1
            ],
            offsetSdr: [
                1,
                1,
                1
            ],
            hdrCapacityMax: 1,
            hdrCapacityMin: 0,
            maxDisplayBoost: 1,
            gainMap: new (0, $329ek.Texture)(),
            sdr: new (0, $329ek.Texture)()
        });
        return new $d7238066c5de7f1c$var$iK({
            width: 16,
            height: 16,
            type: (0, $329ek.HalfFloatType),
            colorSpace: (0, $329ek.LinearSRGBColorSpace),
            material: e,
            renderer: this._renderer,
            renderTargetOptions: this._renderTargetOptions
        });
    }
    /**
  * @private
  * @param quadRenderer
  * @param metadata
  * @param sdrBuffer
  * @param gainMapBuffer
  */ async render(e, t, i, n) {
        const s = n ? new Blob([
            n
        ], {
            type: "image/jpeg"
        }) : void 0, a = new Blob([
            i
        ], {
            type: "image/jpeg"
        });
        let o, g, l = !1;
        if (typeof createImageBitmap > "u") {
            const p = await Promise.all([
                s ? $d7238066c5de7f1c$var$tM(s) : Promise.resolve(void 0),
                $d7238066c5de7f1c$var$tM(a)
            ]);
            g = p[0], o = p[1], l = !0;
        } else {
            const p = await Promise.all([
                s ? createImageBitmap(s, {
                    imageOrientation: "flipY"
                }) : Promise.resolve(void 0),
                createImageBitmap(a, {
                    imageOrientation: "flipY"
                })
            ]);
            g = p[0], o = p[1];
        }
        const c = new (0, $329ek.Texture)(g || new ImageData(2, 2), (0, $329ek.UVMapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.LinearFilter), (0, $329ek.LinearMipMapLinearFilter), (0, $329ek.RGBAFormat), (0, $329ek.UnsignedByteType), 1, (0, $329ek.LinearSRGBColorSpace));
        c.flipY = l, c.needsUpdate = !0;
        const d = new (0, $329ek.Texture)(o, (0, $329ek.UVMapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.ClampToEdgeWrapping), (0, $329ek.LinearFilter), (0, $329ek.LinearMipMapLinearFilter), (0, $329ek.RGBAFormat), (0, $329ek.UnsignedByteType), 1, (0, $329ek.SRGBColorSpace));
        d.flipY = l, d.needsUpdate = !0, e.width = o.width, e.height = o.height, e.material.gainMap = c, e.material.sdr = d, e.material.gainMapMin = t.gainMapMin, e.material.gainMapMax = t.gainMapMax, e.material.offsetHdr = t.offsetHdr, e.material.offsetSdr = t.offsetSdr, e.material.gamma = t.gamma, e.material.hdrCapacityMin = t.hdrCapacityMin, e.material.hdrCapacityMax = t.hdrCapacityMax, e.material.maxDisplayBoost = Math.pow(2, t.hdrCapacityMax), e.material.needsUpdate = !0, e.render();
    }
}
class $d7238066c5de7f1c$var$xpe extends $d7238066c5de7f1c$var$IQ {
    /**
   * Loads a gainmap using separate data
   * * sdr image
   * * gain map image
   * * metadata json
   *
   * useful for webp gain maps
   *
   * @param urls An array in the form of [sdr.jpg, gainmap.jpg, metadata.json]
   * @param onLoad Load complete callback, will receive the result
   * @param onProgress Progress callback, will receive a {@link ProgressEvent}
   * @param onError Error callback
   * @returns
   */ load([e, t, i], n, s, a) {
        const o = this.prepareQuadRenderer();
        let g, l, c;
        const d = async ()=>{
            if (g && l && c) {
                try {
                    await this.render(o, c, g, l);
                } catch (_) {
                    this.manager.itemError(e), this.manager.itemError(t), this.manager.itemError(i), typeof a == "function" && a(_), o.disposeOnDemandRenderer();
                    return;
                }
                typeof n == "function" && n(o), this.manager.itemEnd(e), this.manager.itemEnd(t), this.manager.itemEnd(i), o.disposeOnDemandRenderer();
            }
        };
        let p = !0, A = 0, y = 0, G = !0, Z = 0, v = 0, V = !0, H = 0, N = 0;
        const Y = ()=>{
            if (typeof s == "function") {
                const _ = A + Z + H, O = y + v + N, ie = p && G && V;
                s(new ProgressEvent("progress", {
                    lengthComputable: ie,
                    loaded: O,
                    total: _
                }));
            }
        };
        this.manager.itemStart(e), this.manager.itemStart(t), this.manager.itemStart(i);
        const K = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        K.setResponseType("arraybuffer"), K.setRequestHeader(this.requestHeader), K.setPath(this.path), K.setWithCredentials(this.withCredentials), K.load(e, async (_)=>{
            if (typeof _ == "string") throw new Error("Invalid sdr buffer");
            g = _, await d();
        }, (_)=>{
            p = _.lengthComputable, y = _.loaded, A = _.total, Y();
        }, (_)=>{
            this.manager.itemError(e), typeof a == "function" && a(_);
        });
        const z = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        z.setResponseType("arraybuffer"), z.setRequestHeader(this.requestHeader), z.setPath(this.path), z.setWithCredentials(this.withCredentials), z.load(t, async (_)=>{
            if (typeof _ == "string") throw new Error("Invalid gainmap buffer");
            l = _, await d();
        }, (_)=>{
            G = _.lengthComputable, v = _.loaded, Z = _.total, Y();
        }, (_)=>{
            this.manager.itemError(t), typeof a == "function" && a(_);
        });
        const M = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        return M.setRequestHeader(this.requestHeader), M.setPath(this.path), M.setWithCredentials(this.withCredentials), M.load(i, async (_)=>{
            if (typeof _ != "string") throw new Error("Invalid metadata string");
            c = JSON.parse(_), await d();
        }, (_)=>{
            V = _.lengthComputable, N = _.loaded, H = _.total, Y();
        }, (_)=>{
            this.manager.itemError(i), typeof a == "function" && a(_);
        }), o;
    }
}
class $d7238066c5de7f1c$var$Fpe extends $d7238066c5de7f1c$var$IQ {
    /**
   * Loads a JPEG containing gain map metadata
   * Renders a normal SDR image if gainmap data is not found
   *
   * @param url An array in the form of [sdr.jpg, gainmap.jpg, metadata.json]
   * @param onLoad Load complete callback, will receive the result
   * @param onProgress Progress callback, will receive a {@link ProgressEvent}
   * @param onError Error callback
   * @returns
   */ load(e, t, i, n) {
        const s = this.prepareQuadRenderer(), a = new (0, $329ek.FileLoader)(this._internalLoadingManager);
        return a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setPath(this.path), a.setWithCredentials(this.withCredentials), this.manager.itemStart(e), a.load(e, async (o)=>{
            if (typeof o == "string") throw new Error("Invalid buffer, received [string], was expecting [ArrayBuffer]");
            const g = new Uint8Array(o);
            let l, c, d;
            try {
                const p = await $d7238066c5de7f1c$var$Kpe(g);
                l = p.sdr, c = p.gainMap, d = p.metadata;
            } catch (p) {
                if (p instanceof $d7238066c5de7f1c$var$uQ || p instanceof $d7238066c5de7f1c$var$cQ) console.warn(`Failure to reconstruct an HDR image from ${e}: Gain map metadata not found in the file, HDRJPGLoader will render the SDR jpeg`), d = {
                    gainMapMin: [
                        0,
                        0,
                        0
                    ],
                    gainMapMax: [
                        1,
                        1,
                        1
                    ],
                    gamma: [
                        1,
                        1,
                        1
                    ],
                    hdrCapacityMin: 0,
                    hdrCapacityMax: 1,
                    offsetHdr: [
                        0,
                        0,
                        0
                    ],
                    offsetSdr: [
                        0,
                        0,
                        0
                    ]
                }, l = g;
                else throw p;
            }
            try {
                await this.render(s, d, l, c);
            } catch (p) {
                this.manager.itemError(e), typeof n == "function" && n(p), s.disposeOnDemandRenderer();
                return;
            }
            typeof t == "function" && t(s), this.manager.itemEnd(e), s.disposeOnDemandRenderer();
        }, i, (o)=>{
            this.manager.itemError(e), typeof n == "function" && n(o);
        }), s;
    }
}
const $d7238066c5de7f1c$var$vB = {
    apartment: "lebombo_1k.hdr",
    city: "potsdamer_platz_1k.hdr",
    dawn: "kiara_1_dawn_1k.hdr",
    forest: "forest_slope_1k.hdr",
    lobby: "st_fagans_interior_1k.hdr",
    night: "dikhololo_night_1k.hdr",
    park: "rooitou_park_1k.hdr",
    studio: "studio_small_03_1k.hdr",
    sunset: "venice_sunset_1k.hdr",
    warehouse: "empty_warehouse_01_1k.hdr"
}, $d7238066c5de7f1c$var$dQ = "https://raw.githack.com/pmndrs/drei-assets/456060a26bbeb8fdf79326f224b6d99b8bcce736/hdri/", $d7238066c5de7f1c$var$HA = (r)=>Array.isArray(r), $d7238066c5de7f1c$var$nK = [
    "/px.png",
    "/nx.png",
    "/py.png",
    "/ny.png",
    "/pz.png",
    "/nz.png"
];
function $d7238066c5de7f1c$var$PR({ files: r = $d7238066c5de7f1c$var$nK, path: e = "", preset: t, encoding: i, extensions: n } = {}) {
    let s = null, a = !1;
    t && ($d7238066c5de7f1c$var$sK(t), r = $d7238066c5de7f1c$var$vB[t], e = $d7238066c5de7f1c$var$dQ), a = $d7238066c5de7f1c$var$HA(r);
    const { extension: o, isCubemap: g } = $d7238066c5de7f1c$var$rK(r);
    if (s = $d7238066c5de7f1c$var$aK(o), !s) throw new Error("useEnvironment: Unrecognized file extension: " + r);
    const l = $d7238066c5de7f1c$var$gs((A)=>A.gl);
    (0, $bxRTa.useLayoutEffect)(()=>{
        if (o !== "webp" && o !== "jpg" && o !== "jpeg") return;
        function A() {
            $d7238066c5de7f1c$var$DA.clear(// @ts-expect-error
            s, a ? [
                r
            ] : r);
        }
        l.domElement.addEventListener("webglcontextlost", A, {
            once: !0
        });
    }, [
        r,
        l.domElement
    ]);
    const c = $d7238066c5de7f1c$var$DA(// @ts-expect-error
    s, a ? [
        r
    ] : r, (A)=>{
        (o === "webp" || o === "jpg" || o === "jpeg") && A.setRenderer(l), A.setPath == null || A.setPath(e), n && n(A);
    });
    let d = a ? // @ts-ignore
    c[0] : c;
    if (o === "jpg" || o === "jpeg" || o === "webp") {
        var p;
        d = (p = d.renderTarget) == null ? void 0 : p.texture;
    }
    return d.mapping = g ? (0, $329ek.CubeReflectionMapping) : (0, $329ek.EquirectangularReflectionMapping), "colorSpace" in d ? d.colorSpace = i ?? g ? "srgb" : "srgb-linear" : d.encoding = i ?? g ? $d7238066c5de7f1c$var$wpe : $d7238066c5de7f1c$var$Vpe, d;
}
const $d7238066c5de7f1c$var$Tpe = {
    files: $d7238066c5de7f1c$var$nK,
    path: "",
    preset: void 0,
    extensions: void 0
};
$d7238066c5de7f1c$var$PR.preload = (r)=>{
    const e = {
        ...$d7238066c5de7f1c$var$Tpe,
        ...r
    };
    let { files: t, path: i = "" } = e;
    const { preset: n, extensions: s } = e;
    n && ($d7238066c5de7f1c$var$sK(n), t = $d7238066c5de7f1c$var$vB[n], i = $d7238066c5de7f1c$var$dQ);
    const { extension: a } = $d7238066c5de7f1c$var$rK(t);
    if (a === "webp" || a === "jpg" || a === "jpeg") throw new Error("useEnvironment: Preloading gainmaps is not supported");
    const o = $d7238066c5de7f1c$var$aK(a);
    if (!o) throw new Error("useEnvironment: Unrecognized file extension: " + t);
    $d7238066c5de7f1c$var$DA.preload(// @ts-expect-error
    o, $d7238066c5de7f1c$var$HA(t) ? [
        t
    ] : t, (g)=>{
        g.setPath == null || g.setPath(i), s && s(g);
    });
};
const $d7238066c5de7f1c$var$Mpe = {
    files: $d7238066c5de7f1c$var$nK,
    preset: void 0
};
$d7238066c5de7f1c$var$PR.clear = (r)=>{
    const e = {
        ...$d7238066c5de7f1c$var$Mpe,
        ...r
    };
    let { files: t } = e;
    const { preset: i } = e;
    i && ($d7238066c5de7f1c$var$sK(i), t = $d7238066c5de7f1c$var$vB[i]);
    const { extension: n } = $d7238066c5de7f1c$var$rK(t), s = $d7238066c5de7f1c$var$aK(n);
    if (!s) throw new Error("useEnvironment: Unrecognized file extension: " + t);
    $d7238066c5de7f1c$var$DA.clear(// @ts-expect-error
    s, $d7238066c5de7f1c$var$HA(t) ? [
        t
    ] : t);
};
function $d7238066c5de7f1c$var$sK(r) {
    if (!(r in $d7238066c5de7f1c$var$vB)) throw new Error("Preset must be one of: " + Object.keys($d7238066c5de7f1c$var$vB).join(", "));
}
function $d7238066c5de7f1c$var$rK(r) {
    var e;
    const t = $d7238066c5de7f1c$var$HA(r) && r.length === 6, i = $d7238066c5de7f1c$var$HA(r) && r.length === 3 && r.some((a)=>a.endsWith("json")), n = $d7238066c5de7f1c$var$HA(r) ? r[0] : r;
    return {
        extension: t ? "cube" : i ? "webp" : n.startsWith("data:application/exr") ? "exr" : n.startsWith("data:application/hdr") ? "hdr" : n.startsWith("data:image/jpeg") ? "jpg" : (e = n.split(".").pop()) == null || (e = e.split("?")) == null || (e = e.shift()) == null ? void 0 : e.toLowerCase(),
        isCubemap: t,
        isGainmap: i
    };
}
function $d7238066c5de7f1c$var$aK(r) {
    return r === "cube" ? (0, $329ek.CubeTextureLoader) : r === "hdr" ? $d7238066c5de7f1c$var$dpe : r === "exr" ? $d7238066c5de7f1c$var$hpe : r === "jpg" || r === "jpeg" ? $d7238066c5de7f1c$var$Fpe : r === "webp" ? $d7238066c5de7f1c$var$xpe : null;
}
const $d7238066c5de7f1c$var$zpe = (r)=>r.current && r.current.isScene, $d7238066c5de7f1c$var$kpe = (r)=>$d7238066c5de7f1c$var$zpe(r) ? r.current : r;
function $d7238066c5de7f1c$var$oK(r, e, t, i, n = {}) {
    var s, a, o, g, l;
    n = {
        backgroundBlurriness: (s = n.blur) !== null && s !== void 0 ? s : 0,
        backgroundIntensity: 1,
        backgroundRotation: [
            0,
            0,
            0
        ],
        environmentIntensity: 1,
        environmentRotation: [
            0,
            0,
            0
        ],
        ...n
    };
    const c = $d7238066c5de7f1c$var$kpe(e || t), d = c.background, p = c.environment, A = {
        // @ts-ignore
        backgroundBlurriness: c.backgroundBlurriness,
        // @ts-ignore
        backgroundIntensity: c.backgroundIntensity,
        // @ts-ignore
        backgroundRotation: (a = (o = c.backgroundRotation) == null || o.clone == null ? void 0 : o.clone()) !== null && a !== void 0 ? a : [
            0,
            0,
            0
        ],
        // @ts-ignore
        environmentIntensity: c.environmentIntensity,
        // @ts-ignore
        environmentRotation: (g = (l = c.environmentRotation) == null || l.clone == null ? void 0 : l.clone()) !== null && g !== void 0 ? g : [
            0,
            0,
            0
        ]
    };
    return r !== "only" && (c.environment = i), r && (c.background = i), $d7238066c5de7f1c$var$Ud(c, n), ()=>{
        r !== "only" && (c.environment = p), r && (c.background = d), $d7238066c5de7f1c$var$Ud(c, A);
    };
}
function $d7238066c5de7f1c$var$gK({ scene: r, background: e = !1, map: t, ...i }) {
    const n = $d7238066c5de7f1c$var$gs((s)=>s.scene);
    return $bxRTa.useLayoutEffect(()=>{
        if (t) return $d7238066c5de7f1c$var$oK(e, r, n, t, i);
    }), null;
}
function $d7238066c5de7f1c$var$hQ({ background: r = !1, scene: e, blur: t, backgroundBlurriness: i, backgroundIntensity: n, backgroundRotation: s, environmentIntensity: a, environmentRotation: o, ...g }) {
    const l = $d7238066c5de7f1c$var$PR(g), c = $d7238066c5de7f1c$var$gs((d)=>d.scene);
    return $bxRTa.useLayoutEffect(()=>$d7238066c5de7f1c$var$oK(r, e, c, l, {
            blur: t,
            backgroundBlurriness: i,
            backgroundIntensity: n,
            backgroundRotation: s,
            environmentIntensity: a,
            environmentRotation: o
        })), null;
}
function $d7238066c5de7f1c$var$Epe({ children: r, near: e = 1, far: t = 1e3, resolution: i = 256, frames: n = 1, map: s, background: a = !1, blur: o, backgroundBlurriness: g, backgroundIntensity: l, backgroundRotation: c, environmentIntensity: d, environmentRotation: p, scene: A, files: y, path: G, preset: Z, extensions: v }) {
    const V = $d7238066c5de7f1c$var$gs((M)=>M.gl), H = $d7238066c5de7f1c$var$gs((M)=>M.scene), N = $bxRTa.useRef(null), [Y] = $bxRTa.useState(()=>new (0, $329ek.Scene)()), K = $bxRTa.useMemo(()=>{
        const M = new (0, $329ek.WebGLCubeRenderTarget)(i);
        return M.texture.type = (0, $329ek.HalfFloatType), M;
    }, [
        i
    ]);
    $bxRTa.useLayoutEffect(()=>(n === 1 && N.current.update(V, Y), $d7238066c5de7f1c$var$oK(a, A, H, K.texture, {
            blur: o,
            backgroundBlurriness: g,
            backgroundIntensity: l,
            backgroundRotation: c,
            environmentIntensity: d,
            environmentRotation: p
        })), [
        r,
        Y,
        K.texture,
        A,
        H,
        a,
        n,
        V
    ]);
    let z = 1;
    return $d7238066c5de7f1c$var$_R(()=>{
        (n === 1 / 0 || z < n) && (N.current.update(V, Y), z++);
    }), /* @__PURE__ */ $bxRTa.createElement($bxRTa.Fragment, null, $d7238066c5de7f1c$var$NCe(/* @__PURE__ */ $bxRTa.createElement($bxRTa.Fragment, null, r, /* @__PURE__ */ $bxRTa.createElement("cubeCamera", {
        ref: N,
        args: [
            e,
            t,
            K
        ]
    }), y || Z ? /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$hQ, {
        background: !0,
        files: y,
        preset: Z,
        path: G,
        extensions: v
    }) : s ? /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$gK, {
        background: !0,
        map: s,
        extensions: v
    }) : null), Y));
}
function $d7238066c5de7f1c$var$Jpe(r) {
    var e, t, i, n;
    const s = $d7238066c5de7f1c$var$PR(r), a = r.map || s;
    $bxRTa.useMemo(()=>$d7238066c5de7f1c$var$qY({
            GroundProjectedEnvImpl: $d7238066c5de7f1c$var$Ipe
        }), []);
    const o = $bxRTa.useMemo(()=>[
            a
        ], [
        a
    ]), g = (e = r.ground) == null ? void 0 : e.height, l = (t = r.ground) == null ? void 0 : t.radius, c = (i = (n = r.ground) == null ? void 0 : n.scale) !== null && i !== void 0 ? i : 1e3;
    return /* @__PURE__ */ $bxRTa.createElement($bxRTa.Fragment, null, /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$gK, $d7238066c5de7f1c$var$fB({}, r, {
        map: a
    })), /* @__PURE__ */ $bxRTa.createElement("groundProjectedEnvImpl", {
        args: o,
        scale: c,
        height: g,
        radius: l
    }));
}
function $d7238066c5de7f1c$var$Upe(r) {
    return r.ground ? /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$Jpe, r) : r.map ? /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$gK, r) : r.children ? /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$Epe, r) : /* @__PURE__ */ $bxRTa.createElement($d7238066c5de7f1c$var$hQ, r);
}
let $d7238066c5de7f1c$var$cS;
const $d7238066c5de7f1c$var$Dpe = new Uint8Array(16);
function $d7238066c5de7f1c$var$_pe() {
    if (!$d7238066c5de7f1c$var$cS && ($d7238066c5de7f1c$var$cS = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !$d7238066c5de7f1c$var$cS)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $d7238066c5de7f1c$var$cS($d7238066c5de7f1c$var$Dpe);
}
const $d7238066c5de7f1c$var$oa = [];
for(let r = 0; r < 256; ++r)$d7238066c5de7f1c$var$oa.push((r + 256).toString(16).slice(1));
function $d7238066c5de7f1c$var$Ppe(r, e = 0) {
    return $d7238066c5de7f1c$var$oa[r[e + 0]] + $d7238066c5de7f1c$var$oa[r[e + 1]] + $d7238066c5de7f1c$var$oa[r[e + 2]] + $d7238066c5de7f1c$var$oa[r[e + 3]] + "-" + $d7238066c5de7f1c$var$oa[r[e + 4]] + $d7238066c5de7f1c$var$oa[r[e + 5]] + "-" + $d7238066c5de7f1c$var$oa[r[e + 6]] + $d7238066c5de7f1c$var$oa[r[e + 7]] + "-" + $d7238066c5de7f1c$var$oa[r[e + 8]] + $d7238066c5de7f1c$var$oa[r[e + 9]] + "-" + $d7238066c5de7f1c$var$oa[r[e + 10]] + $d7238066c5de7f1c$var$oa[r[e + 11]] + $d7238066c5de7f1c$var$oa[r[e + 12]] + $d7238066c5de7f1c$var$oa[r[e + 13]] + $d7238066c5de7f1c$var$oa[r[e + 14]] + $d7238066c5de7f1c$var$oa[r[e + 15]];
}
const $d7238066c5de7f1c$var$Qpe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), $d7238066c5de7f1c$var$iM = {
    randomUUID: $d7238066c5de7f1c$var$Qpe
};
function $d7238066c5de7f1c$var$Ope(r, e, t) {
    if ($d7238066c5de7f1c$var$iM.randomUUID && !r) return $d7238066c5de7f1c$var$iM.randomUUID();
    r = r || {};
    const i = r.random || (r.rng || $d7238066c5de7f1c$var$_pe)();
    return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, $d7238066c5de7f1c$var$Ppe(i);
}
function $d7238066c5de7f1c$var$jpe({ pixelated: r }) {
    const e = $d7238066c5de7f1c$var$gs((a)=>a.gl), t = $d7238066c5de7f1c$var$gs((a)=>a.internal.active), i = $d7238066c5de7f1c$var$gs((a)=>a.performance.current), n = $d7238066c5de7f1c$var$gs((a)=>a.viewport.initialDpr), s = $d7238066c5de7f1c$var$gs((a)=>a.setDpr);
    return $bxRTa.useEffect(()=>{
        const a = e.domElement;
        return ()=>{
            t && s(n), r && a && (a.style.imageRendering = "auto");
        };
    }, []), $bxRTa.useEffect(()=>{
        s(i * n), r && e.domElement && (e.domElement.style.imageRendering = i === 1 ? "auto" : "pixelated");
    }, [
        i
    ]), null;
}
const $d7238066c5de7f1c$var$nM = (r)=>{
    let e;
    const t = /* @__PURE__ */ new Set(), i = (l, c)=>{
        const d = typeof l == "function" ? l(e) : l;
        if (!Object.is(d, e)) {
            const p = e;
            e = c ?? (typeof d != "object" || d === null) ? d : Object.assign({}, e, d), t.forEach((A)=>A(e, p));
        }
    }, n = ()=>e, o = {
        setState: i,
        getState: n,
        getInitialState: ()=>g,
        subscribe: (l)=>(t.add(l), ()=>t.delete(l))
    }, g = e = r(i, n, o);
    return o;
}, $d7238066c5de7f1c$var$qpe = (r)=>r ? $d7238066c5de7f1c$var$nM(r) : $d7238066c5de7f1c$var$nM, $d7238066c5de7f1c$var$$pe = (r)=>r;
function $d7238066c5de7f1c$var$eme(r, e = $d7238066c5de7f1c$var$$pe) {
    const t = (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useSyncExternalStore(r.subscribe, (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useCallback(()=>e(r.getState()), [
        r,
        e
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useCallback(()=>e(r.getInitialState()), [
        r,
        e
    ]));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).useDebugValue(t), t;
}
const $d7238066c5de7f1c$var$tme = (r)=>{
    const e = $d7238066c5de7f1c$var$qpe(r), t = (i)=>$d7238066c5de7f1c$var$eme(e, i);
    return Object.assign(t, e), t;
}, $d7238066c5de7f1c$var$l0 = (r)=>$d7238066c5de7f1c$var$tme, $d7238066c5de7f1c$export$c7fe76dc325a276e = $d7238066c5de7f1c$var$l0()(()=>({
        character: null,
        managers: [],
        globalManager: null,
        lipSyncManager: null,
        eyeBlinkManager: null,
        animationManager: null,
        FACSManager: null,
        headPoseManager: null,
        gazeManager: null,
        bmlManager: null,
        animationsLoaded: !1,
        characterWidth: 0,
        characterHeight: 0,
        characterDepth: 0,
        characterState: $d7238066c5de7f1c$export$f2e6b371e93925c7.idle
    })), $d7238066c5de7f1c$var$ime = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        character: r
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        managers: {
            lipSyncManager: (r == null ? void 0 : r.lipSyncManager) || null,
            eyeBlinkManager: (r == null ? void 0 : r.eyeBlinkManager) || null,
            animationManager: (r == null ? void 0 : r.animationManager) || null
        }
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        globalManager: (r == null ? void 0 : r.globalManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        lipSyncManager: (r == null ? void 0 : r.lipSyncManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        eyeBlinkManager: (r == null ? void 0 : r.eyeBlinkManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        animationManager: (r == null ? void 0 : r.animationManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        FACSManager: (r == null ? void 0 : r.FACSManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        headPoseManager: (r == null ? void 0 : r.headPoseManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        gazeManager: (r == null ? void 0 : r.gazeManager) || null
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        bmlManager: (r == null ? void 0 : r.bmlManager) || null
    });
}, $d7238066c5de7f1c$var$sM = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        animationsLoaded: r
    });
}, $d7238066c5de7f1c$var$nme = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterWidth: r.x
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterHeight: r.y
    }), $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterDepth: r.z
    });
}, $d7238066c5de7f1c$export$83a16ee147243363 = (r)=>{
    $d7238066c5de7f1c$export$c7fe76dc325a276e.setState({
        characterState: r
    });
}, $d7238066c5de7f1c$var$PA = $d7238066c5de7f1c$var$l0()(()=>({
        animationsNames: [],
        animations: /* @__PURE__ */ new Map(),
        currentAnimation: null,
        autoPlay: !0
    })), $d7238066c5de7f1c$var$sme = (r)=>{
    $d7238066c5de7f1c$var$PA.setState({
        animationsNames: r
    });
}, $d7238066c5de7f1c$var$rme = (r)=>{
    $d7238066c5de7f1c$var$PA.setState({
        animations: r
    });
}, $d7238066c5de7f1c$export$b021c3458b2d227d = ()=>$d7238066c5de7f1c$var$PA.getState().animations, $d7238066c5de7f1c$export$ddf7477d0ab427b2 = (r)=>{
    $d7238066c5de7f1c$var$PA.setState({
        autoPlay: r
    });
}, $d7238066c5de7f1c$export$f4b33447f2fe6a80 = (r)=>{
    if ($d7238066c5de7f1c$var$PA.setState({
        autoPlay: !1
    }), $d7238066c5de7f1c$var$PA.getState().animationsNames.includes(r)) {
        const t = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().animationManager;
        t == null || t.playAnimation(r);
    }
}, $d7238066c5de7f1c$var$Wo = $d7238066c5de7f1c$var$l0()(()=>({
        cameraRef: null,
        cameraPosition: new (0, $329ek.Vector3)(0, 0, 5),
        bodyCenter: null,
        defaultPositions: null,
        defaultDistances: null,
        lookAt: null,
        movable: !0
    })), $d7238066c5de7f1c$var$ame = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        cameraRef: r
    });
}, $d7238066c5de7f1c$export$e5bf5ad244df1ebf = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        cameraPosition: r
    });
}, $d7238066c5de7f1c$var$ome = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        bodyCenter: r
    });
}, $d7238066c5de7f1c$var$gme = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        defaultPositions: r
    });
}, $d7238066c5de7f1c$var$lme = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        defaultDistances: r
    });
}, $d7238066c5de7f1c$var$oM = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        lookAt: r
    });
}, $d7238066c5de7f1c$export$545c1d117b311d16 = (r)=>{
    $d7238066c5de7f1c$var$Wo.setState({
        movable: r
    });
};
var $d7238066c5de7f1c$export$53ba1d920b7b1325 = /* @__PURE__ */ ((r)=>(r.eye = "eye", r.mouth = "mouth", r.neck = "neck", r.clavicle = "clavicle", r.torso = "torso", r.belly = "belly", r.lowerbelly = "lowerbelly", r.hips = "hips", r.higherthigh = "higherthigh", r.thigh = "thigh", r.knee = "knee", r.leg = "leg", r.feet = "feet", r))($d7238066c5de7f1c$export$53ba1d920b7b1325 || {}), $d7238066c5de7f1c$export$bf368148f23d1abd = /* @__PURE__ */ ((r)=>(r[r.face = 1] = "face", r[r.eighthleft = 2] = "eighthleft", r[r.thirdleft = 3] = "thirdleft", r[r.quarterleft = 4] = "quarterleft", r[r.halfleft = 5] = "halfleft", r[r.eighthright = 6] = "eighthright", r[r.thirdright = 7] = "thirdright", r[r.quarterright = 8] = "quarterright", r[r.halfright = 9] = "halfright", r))($d7238066c5de7f1c$export$bf368148f23d1abd || {}), $d7238066c5de7f1c$export$9e8ba99cc9517849 = /* @__PURE__ */ ((r)=>(r[r.veryclose = 1] = "veryclose", r[r.closer = 2] = "closer", r[r.close = 3] = "close", r[r.midclose = 4] = "midclose", r[r.medium = 5] = "medium", r[r.midfar = 6] = "midfar", r[r.far = 7] = "far", r[r.farther = 8] = "farther", r[r.veryfar = 9] = "veryfar", r))($d7238066c5de7f1c$export$9e8ba99cc9517849 || {}), $d7238066c5de7f1c$var$Ry = /* @__PURE__ */ ((r)=>(r.cc3 = "CC_Base_Body", r.rpm = "Wolf3D_Body", r.avatarsdk = "AvatarBody", r.avaturn = "Body_Mesh", r))($d7238066c5de7f1c$var$Ry || {}), $d7238066c5de7f1c$var$lK = /* @__PURE__ */ ((r)=>(r.Jay = "joy", r.Anger = "anger", r.Contempt = "contempt", r.Disgust = "disgust", r.Dislike = "dislike", r.Distress = "distress", r.Fear = "fear", r.Frustration = "frustration", r.Guilt = "guilt", r.Hope = "hope", r.Love = "love", r.Pride = "pride", r.Regret = "regret", r.Relief = "relief", r.Sadness = "sadness", r.Shame = "shame", r.Smile = "smile", r.Surprise = "surprise", r.Neutral = "neutral", r))($d7238066c5de7f1c$var$lK || {});
const $d7238066c5de7f1c$var$gM = /* @__PURE__ */ new Map([
    [
        0,
        "sil"
    ],
    [
        1,
        "aa"
    ],
    [
        2,
        "aa"
    ],
    [
        3,
        "O"
    ],
    [
        4,
        "E"
    ],
    [
        5,
        "E"
    ],
    [
        6,
        "I"
    ],
    [
        7,
        "U"
    ],
    [
        8,
        "O"
    ],
    [
        9,
        "U"
    ],
    [
        10,
        "O"
    ],
    [
        11,
        "aa"
    ],
    [
        12,
        "kk"
    ],
    [
        13,
        "RR"
    ],
    [
        14,
        "nn"
    ],
    [
        15,
        "SS"
    ],
    [
        16,
        "CH"
    ],
    [
        17,
        "TH"
    ],
    [
        18,
        "FF"
    ],
    [
        19,
        "DD"
    ],
    [
        20,
        "kk"
    ],
    [
        21,
        "PP"
    ]
]), $d7238066c5de7f1c$var$ume = /* @__PURE__ */ new Map([
    [
        "#",
        "#"
    ],
    [
        "p",
        "p"
    ],
    [
        "b",
        "b"
    ],
    [
        "t",
        "t"
    ],
    [
        "d",
        "d"
    ],
    [
        "k",
        "k"
    ],
    [
        "g",
        "g"
    ],
    [
        "f",
        "f"
    ],
    [
        "s",
        "s"
    ],
    [
        "S",
        "\u0283"
    ],
    [
        "v",
        "v"
    ],
    [
        "z",
        "z"
    ],
    [
        "Z",
        "\u0292"
    ],
    [
        "m",
        "m"
    ],
    [
        "n",
        "n"
    ],
    [
        "l",
        "l"
    ],
    [
        "R",
        "\u0281"
    ],
    [
        "j",
        "j"
    ],
    [
        "w",
        "w"
    ],
    [
        "H",
        "\u0265"
    ],
    [
        "E",
        "\u025B"
    ],
    [
        "A/",
        "\u0251"
    ],
    [
        "9",
        "oe"
    ],
    [
        "i",
        "i"
    ],
    [
        "e",
        "e"
    ],
    [
        "O/",
        "o"
    ],
    [
        "u",
        "u"
    ],
    [
        "y",
        "y"
    ],
    [
        "2",
        "\xf8"
    ],
    [
        "@",
        "\u0259"
    ],
    [
        "a~",
        "\xe3"
    ],
    [
        "U~/",
        "\u025B\u0303"
    ],
    [
        "U~/",
        "oe\u0303"
    ],
    [
        "O~",
        "\u0254\u0303"
    ],
    [
        "a",
        "a"
    ],
    [
        "A",
        "\u0251"
    ],
    [
        "3",
        "\u025C"
    ],
    [
        "I",
        "\u026A"
    ],
    [
        "o",
        "o"
    ],
    [
        "O",
        "\u0254"
    ],
    [
        "U",
        "\u028A"
    ],
    [
        "Y",
        "\u028F"
    ],
    [
        "A~",
        "\u0251\u0303"
    ],
    [
        "E~",
        "\u025B\u0303"
    ],
    [
        "e~",
        "\u025B\u0303"
    ],
    [
        "9~",
        "oe\u0303"
    ],
    [
        "N",
        "\u014B"
    ],
    [
        "J",
        "\u0272"
    ]
]), $d7238066c5de7f1c$var$Ime = /* @__PURE__ */ new Map([
    [
        "#",
        0
    ],
    [
        "\xe6",
        1
    ],
    [
        "\u0259",
        1
    ],
    [
        "\u028C",
        1
    ],
    [
        "\u0251",
        2
    ],
    [
        "\u0254",
        3
    ],
    [
        "\u025B",
        4
    ],
    [
        "\u028A",
        4
    ],
    [
        "\u025D",
        5
    ],
    [
        "j",
        6
    ],
    [
        "i",
        6
    ],
    [
        "\u026A",
        6
    ],
    [
        "w",
        7
    ],
    [
        "u",
        7
    ],
    [
        "o",
        8
    ],
    [
        "a\u028A",
        9
    ],
    [
        "\u0254\u026A",
        10
    ],
    [
        "a\u026A",
        11
    ],
    [
        "h",
        12
    ],
    [
        "\u0279",
        13
    ],
    [
        "l",
        14
    ],
    [
        "s",
        15
    ],
    [
        "z",
        15
    ],
    [
        "\u0283",
        16
    ],
    [
        "t\u0283",
        16
    ],
    [
        "d\u0292",
        16
    ],
    [
        "\u0292",
        16
    ],
    [
        "\xf0",
        17
    ],
    [
        "f",
        18
    ],
    [
        "v",
        18
    ],
    [
        "d",
        19
    ],
    [
        "t",
        19
    ],
    [
        "n",
        19
    ],
    [
        "\u03B8",
        19
    ],
    [
        "k",
        20
    ],
    [
        "g",
        20
    ],
    [
        "\u014B",
        20
    ],
    [
        "p",
        21
    ],
    [
        "b",
        21
    ],
    [
        "m",
        21
    ]
]), $d7238066c5de7f1c$var$dme = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.farther,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.lowerbelly
}, $d7238066c5de7f1c$var$hme = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.close,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth
}, $d7238066c5de7f1c$var$Cme = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.midclose,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth
}, $d7238066c5de7f1c$var$pme = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.neck,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.close,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.neck
}, $d7238066c5de7f1c$var$mme = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.eye,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.medium,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.neck
}, $d7238066c5de7f1c$var$Ame = {
    position: $d7238066c5de7f1c$export$53ba1d920b7b1325.eye,
    distance: $d7238066c5de7f1c$export$9e8ba99cc9517849.medium,
    lookAt: $d7238066c5de7f1c$export$53ba1d920b7b1325.clavicle
}, $d7238066c5de7f1c$export$7afd9c1079ecedf7 = {
    default: $d7238066c5de7f1c$var$dme,
    head: $d7238066c5de7f1c$var$hme,
    neck: $d7238066c5de7f1c$var$Cme,
    shoulders: $d7238066c5de7f1c$var$pme,
    chest: $d7238066c5de7f1c$var$mme,
    belly: $d7238066c5de7f1c$var$Ame
}, $d7238066c5de7f1c$var$ar = $d7238066c5de7f1c$var$l0()(()=>({
        credentials: void 0,
        currentUtterance: null,
        boundaries: [],
        visemes: [],
        currentVisemeIndex: 0,
        voice: null,
        voices: [],
        textToSpeak: null,
        visemeIntensity: 1
    })), $d7238066c5de7f1c$var$bme = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        credentials: r
    });
}, $d7238066c5de7f1c$export$361f43c8d19dc717 = (r)=>{
    if (r) {
        const e = $d7238066c5de7f1c$var$ar.getState().voice;
        e && (r.voice = e);
    }
    $d7238066c5de7f1c$var$ar.setState({
        currentUtterance: r
    }), $d7238066c5de7f1c$var$ar.setState({
        textToSpeak: null
    });
}, $d7238066c5de7f1c$export$53e124f45dac8729 = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        visemes: r
    });
}, $d7238066c5de7f1c$export$a6f0d0f24e5dc19b = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        visemes: [
            ...$d7238066c5de7f1c$var$ar.getState().visemes,
            r
        ]
    });
}, $d7238066c5de7f1c$export$e71a64fa83f377e7 = (r, e)=>{
    const t = $d7238066c5de7f1c$var$ume.get(r.name);
    if (t) {
        const i = $d7238066c5de7f1c$var$Ime.get(t);
        i !== void 0 && $d7238066c5de7f1c$export$a6f0d0f24e5dc19b({
            ...r,
            name: `${i}`,
            elapsedTime: r.elapsedTime * (e || 1e7)
        });
    }
}, $d7238066c5de7f1c$var$Bme = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        currentVisemeIndex: r
    });
}, $d7238066c5de7f1c$export$1a9c534915c6839e = ()=>{
    var r;
    $d7238066c5de7f1c$var$ar.setState({
        visemes: [],
        currentVisemeIndex: 0
    }), (r = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().lipSyncManager) == null || r.stop();
}, $d7238066c5de7f1c$export$f7fa6f9f21f4683c = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        voice: r
    });
}, $d7238066c5de7f1c$var$lM = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        voices: r
    });
}, $d7238066c5de7f1c$export$14dfb2a29f632771 = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        textToSpeak: r
    });
}, $d7238066c5de7f1c$export$d474912f4c21f069 = ()=>$d7238066c5de7f1c$var$ar.getState().voices, $d7238066c5de7f1c$export$80884be05e236fad = (r)=>{
    $d7238066c5de7f1c$var$ar.setState({
        visemeIntensity: r
    });
}, $d7238066c5de7f1c$var$vme = (r, e, t)=>{
    let i = t[r.position || $d7238066c5de7f1c$export$53ba1d920b7b1325.eye].getComponent(0);
    const n = t[r.position || $d7238066c5de7f1c$export$53ba1d920b7b1325.mouth].getComponent(1);
    let s = 0;
    const a = typeof r.distance == "string" ? parseInt(r.distance) : r.distance, o = typeof r.rotation == "string" ? parseInt(r.rotation) : r.rotation;
    switch(a){
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.veryclose:
            s = e.veryclose;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.closer:
            s = e.closer;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.close:
            s = e.close;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.midclose:
            s = e.midclose;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.medium:
            s = e.medium;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.midfar:
            s = e.midfar;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.far:
            s = e.far;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.farther:
        case void 0:
        default:
            s = e.farther;
            break;
        case $d7238066c5de7f1c$export$9e8ba99cc9517849.veryfar:
            s = e.veryfar;
            break;
    }
    if (o && o !== $d7238066c5de7f1c$export$bf368148f23d1abd.face) switch(o){
        case $d7238066c5de7f1c$export$bf368148f23d1abd.eighthleft:
            {
                const g = 0.2588190451;
                i = i - s * g, s = s * Math.sqrt(1 - Math.pow(g, 2));
                break;
            }
        case $d7238066c5de7f1c$export$bf368148f23d1abd.thirdleft:
            i = i - s * 0.5, s = s * (Math.sqrt(3) / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.quarterleft:
            i = i - s * (Math.SQRT2 / 2), s = s * (Math.SQRT2 / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.halfleft:
            i = i - s, s = t.eye.getComponent(2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.eighthright:
            {
                const g = 0.2588190451;
                i = i + s * g, s = s * Math.sqrt(1 - Math.pow(g, 2));
                break;
            }
        case $d7238066c5de7f1c$export$bf368148f23d1abd.thirdright:
            i = i + s * 0.5, s = s * (Math.sqrt(3) / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.quarterright:
            i = i + s * (Math.SQRT2 / 2), s = s * (Math.SQRT2 / 2);
            break;
        case $d7238066c5de7f1c$export$bf368148f23d1abd.halfright:
            i = i + s, s = t.eye.getComponent(2);
            break;
    }
    return new $1W96c.Vector3(i, n, s);
};
var $d7238066c5de7f1c$var$pQ = {
    exports: {}
};
const $d7238066c5de7f1c$var$kZ = ()=>$d7238066c5de7f1c$var$Ope(), $d7238066c5de7f1c$var$Rn = ()=>$d7238066c5de7f1c$var$kZ().replace(new RegExp("-", "g"), "").toUpperCase();
var $d7238066c5de7f1c$var$Ys;
(function(r) {
    r[r.Debug = 0] = "Debug", r[r.Info = 1] = "Info", r[r.Warning = 2] = "Warning", r[r.Error = 3] = "Error", r[r.None = 4] = "None";
})($d7238066c5de7f1c$var$Ys || ($d7238066c5de7f1c$var$Ys = {}));
class $d7238066c5de7f1c$var$lu {
    constructor(e, t){
        this.privName = e, this.privEventId = $d7238066c5de7f1c$var$Rn(), this.privEventTime = /* @__PURE__ */ new Date().toISOString(), this.privEventType = t, this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}
class $d7238066c5de7f1c$var$af extends $d7238066c5de7f1c$var$lu {
    constructor(e, t, i = $d7238066c5de7f1c$var$Ys.Info){
        super(e, i), this.privAudioSourceId = t;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
class $d7238066c5de7f1c$var$QR extends $d7238066c5de7f1c$var$af {
    constructor(e){
        super("AudioSourceInitializingEvent", e);
    }
}
class $d7238066c5de7f1c$var$SB extends $d7238066c5de7f1c$var$af {
    constructor(e){
        super("AudioSourceReadyEvent", e);
    }
}
class $d7238066c5de7f1c$var$mQ extends $d7238066c5de7f1c$var$af {
    constructor(e){
        super("AudioSourceOffEvent", e);
    }
}
class $d7238066c5de7f1c$var$EZ extends $d7238066c5de7f1c$var$af {
    constructor(e, t){
        super("AudioSourceErrorEvent", e, $d7238066c5de7f1c$var$Ys.Error), this.privError = t;
    }
    get error() {
        return this.privError;
    }
}
class $d7238066c5de7f1c$var$OR extends $d7238066c5de7f1c$var$af {
    constructor(e, t, i){
        super(e, t), this.privAudioNodeId = i;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $d7238066c5de7f1c$var$of extends $d7238066c5de7f1c$var$OR {
    constructor(e, t){
        super("AudioStreamNodeAttachingEvent", e, t);
    }
}
class $d7238066c5de7f1c$var$gf extends $d7238066c5de7f1c$var$OR {
    constructor(e, t){
        super("AudioStreamNodeAttachedEvent", e, t);
    }
}
class $d7238066c5de7f1c$var$VI extends $d7238066c5de7f1c$var$OR {
    constructor(e, t){
        super("AudioStreamNodeDetachedEvent", e, t);
    }
}
class $d7238066c5de7f1c$var$cK extends $d7238066c5de7f1c$var$OR {
    constructor(e, t, i){
        super("AudioStreamNodeErrorEvent", e, t), this.privError = i;
    }
    get error() {
        return this.privError;
    }
}
class $d7238066c5de7f1c$var$uK extends $d7238066c5de7f1c$var$lu {
    constructor(e, t, i = $d7238066c5de7f1c$var$Ys.Info){
        super(e, i), this.privJsonResult = t;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
class $d7238066c5de7f1c$var$ep extends $d7238066c5de7f1c$var$lu {
    constructor(e, t, i = $d7238066c5de7f1c$var$Ys.Info){
        super(e, i), this.privConnectionId = t;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
class $d7238066c5de7f1c$var$AQ extends $d7238066c5de7f1c$var$ep {
    constructor(e, t, i){
        super("ConnectionStartEvent", e), this.privUri = t, this.privHeaders = i;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
class $d7238066c5de7f1c$var$bQ extends $d7238066c5de7f1c$var$ep {
    constructor(e){
        super("ConnectionEstablishedEvent", e);
    }
}
class $d7238066c5de7f1c$var$Sme extends $d7238066c5de7f1c$var$ep {
    constructor(e, t, i){
        super("ConnectionClosedEvent", e, $d7238066c5de7f1c$var$Ys.Debug), this.privReason = i, this.privStatusCode = t;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $d7238066c5de7f1c$var$Zme extends $d7238066c5de7f1c$var$ep {
    constructor(e, t, i){
        super("ConnectionErrorEvent", e, $d7238066c5de7f1c$var$Ys.Debug), this.privMessage = t, this.privType = i;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
class $d7238066c5de7f1c$var$Rme extends $d7238066c5de7f1c$var$ep {
    constructor(e, t, i){
        super("ConnectionEstablishErrorEvent", e, $d7238066c5de7f1c$var$Ys.Error), this.privStatusCode = t, this.privReason = i;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $d7238066c5de7f1c$var$lN extends $d7238066c5de7f1c$var$ep {
    constructor(e, t, i){
        super("ConnectionMessageReceivedEvent", e), this.privNetworkReceivedTime = t, this.privMessage = i;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $d7238066c5de7f1c$var$Vme extends $d7238066c5de7f1c$var$ep {
    constructor(e, t, i){
        super("ConnectionMessageSentEvent", e), this.privNetworkSentTime = t, this.privMessage = i;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $d7238066c5de7f1c$var$Zr extends Error {
    /**
   * Creates an instance of ArgumentNullError.
   *
   * @param {string} argumentName - Name of the argument that is null
   *
   * @memberOf ArgumentNullError
   */ constructor(e){
        super(e), this.name = "ArgumentNull", this.message = e;
    }
}
class $d7238066c5de7f1c$var$io extends Error {
    /**
   * Creates an instance of InvalidOperationError.
   *
   * @param {string} error - The error
   *
   * @memberOf InvalidOperationError
   */ constructor(e){
        super(e), this.name = "InvalidOperation", this.message = e;
    }
}
class $d7238066c5de7f1c$var$IK extends Error {
    /**
   * Creates an instance of ObjectDisposedError.
   *
   * @param {string} objectName - The object that is disposed
   * @param {string} error - The error
   *
   * @memberOf ObjectDisposedError
   */ constructor(e, t){
        super(t), this.name = e + "ObjectDisposed", this.message = t;
    }
}
var $d7238066c5de7f1c$var$Tt;
(function(r) {
    r[r.Text = 0] = "Text", r[r.Binary = 1] = "Binary";
})($d7238066c5de7f1c$var$Tt || ($d7238066c5de7f1c$var$Tt = {}));
let $d7238066c5de7f1c$var$JZ = class {
    constructor(e, t, i, n){
        if (this.privBody = null, e === $d7238066c5de7f1c$var$Tt.Text && t && typeof t != "string") throw new $d7238066c5de7f1c$var$io("Payload must be a string");
        if (e === $d7238066c5de7f1c$var$Tt.Binary && t && !(t instanceof ArrayBuffer)) throw new $d7238066c5de7f1c$var$io("Payload must be ArrayBuffer");
        switch(this.privMessageType = e, this.privBody = t, this.privHeaders = i || {}, this.privId = n || $d7238066c5de7f1c$var$Rn(), this.messageType){
            case $d7238066c5de7f1c$var$Tt.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $d7238066c5de7f1c$var$Tt.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $d7238066c5de7f1c$var$Tt.Binary) throw new $d7238066c5de7f1c$var$io("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $d7238066c5de7f1c$var$Tt.Text) throw new $d7238066c5de7f1c$var$io("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
};
class $d7238066c5de7f1c$var$mX {
    constructor(e, t){
        this.privStatusCode = e, this.privReason = t;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}
class $d7238066c5de7f1c$var$wme {
    constructor(){
        this.privMap = {};
    }
    add(e, t) {
        this.privMap[e] = t;
    }
    getId(e) {
        return this.privMap[e];
    }
    complete(e, t) {
        try {
            this.privMap[e].resolve(t);
        } catch (i) {
            this.privMap[e].reject(i);
        } finally{
            this.privMap[e] = void 0;
        }
    }
}
class $d7238066c5de7f1c$var$Wme extends $d7238066c5de7f1c$var$lu {
    constructor(e, t = $d7238066c5de7f1c$var$Ys.Info){
        super(e, t);
    }
}
class $d7238066c5de7f1c$var$Hme extends $d7238066c5de7f1c$var$Wme {
    constructor(e){
        super("SendingAgentContextMessageEvent"), this.privAgentConfig = e;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
}
class $d7238066c5de7f1c$var$sc {
    constructor(e){
        this.privEventListeners = {}, this.privIsDisposed = !1, this.privConsoleListener = void 0, this.privMetadata = e;
    }
    onEvent(e) {
        if (this.isDisposed()) throw new $d7238066c5de7f1c$var$IK("EventSource");
        if (this.metadata) for(const t in this.metadata)t && e.metadata && (e.metadata[t] || (e.metadata[t] = this.metadata[t]));
        for(const t in this.privEventListeners)t && this.privEventListeners[t] && this.privEventListeners[t](e);
    }
    attach(e) {
        const t = $d7238066c5de7f1c$var$Rn();
        return this.privEventListeners[t] = e, {
            detach: ()=>(delete this.privEventListeners[t], Promise.resolve())
        };
    }
    attachListener(e) {
        return this.attach((t)=>e.onEvent(t));
    }
    attachConsoleListener(e) {
        return this.privConsoleListener && this.privConsoleListener.detach(), this.privConsoleListener = this.attach((t)=>e.onEvent(t)), this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null, this.privIsDisposed = !0;
    }
    get metadata() {
        return this.privMetadata;
    }
}
class $d7238066c5de7f1c$var$as {
    static setEventSource(e) {
        if (!e) throw new $d7238066c5de7f1c$var$Zr("eventSource");
        $d7238066c5de7f1c$var$as.privInstance = e;
    }
    static get instance() {
        return $d7238066c5de7f1c$var$as.privInstance;
    }
}
$d7238066c5de7f1c$var$as.privInstance = new $d7238066c5de7f1c$var$sc();
var $d7238066c5de7f1c$var$ir;
(function(r) {
    r[r.None = 0] = "None", r[r.Connected = 1] = "Connected", r[r.Connecting = 2] = "Connecting", r[r.Disconnected = 3] = "Disconnected";
})($d7238066c5de7f1c$var$ir || ($d7238066c5de7f1c$var$ir = {}));
class $d7238066c5de7f1c$var$Qc {
    constructor(e){
        if (this.privSubscriptionIdCounter = 0, this.privAddSubscriptions = {}, this.privRemoveSubscriptions = {}, this.privDisposedSubscriptions = {}, this.privDisposeReason = null, this.privList = [], e) for (const t of e)this.privList.push(t);
    }
    get(e) {
        return this.throwIfDisposed(), this.privList[e];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(e) {
        this.throwIfDisposed(), this.insertAt(this.privList.length, e);
    }
    insertAt(e, t) {
        this.throwIfDisposed(), e === 0 ? this.privList.unshift(t) : e === this.privList.length ? this.privList.push(t) : this.privList.splice(e, 0, t), this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        return this.throwIfDisposed(), this.removeAt(0);
    }
    removeLast() {
        return this.throwIfDisposed(), this.removeAt(this.length() - 1);
    }
    removeAt(e) {
        return this.throwIfDisposed(), this.remove(e, 1)[0];
    }
    remove(e, t) {
        this.throwIfDisposed();
        const i = this.privList.splice(e, t);
        return this.triggerSubscriptions(this.privRemoveSubscriptions), i;
    }
    clear() {
        this.throwIfDisposed(), this.remove(0, this.length());
    }
    length() {
        return this.throwIfDisposed(), this.privList.length;
    }
    onAdded(e) {
        this.throwIfDisposed();
        const t = this.privSubscriptionIdCounter++;
        return this.privAddSubscriptions[t] = e, {
            detach: ()=>(delete this.privAddSubscriptions[t], Promise.resolve())
        };
    }
    onRemoved(e) {
        this.throwIfDisposed();
        const t = this.privSubscriptionIdCounter++;
        return this.privRemoveSubscriptions[t] = e, {
            detach: ()=>(delete this.privRemoveSubscriptions[t], Promise.resolve())
        };
    }
    onDisposed(e) {
        this.throwIfDisposed();
        const t = this.privSubscriptionIdCounter++;
        return this.privDisposedSubscriptions[t] = e, {
            detach: ()=>(delete this.privDisposedSubscriptions[t], Promise.resolve())
        };
    }
    join(e) {
        return this.throwIfDisposed(), this.privList.join(e);
    }
    toArray() {
        const e = Array();
        return this.privList.forEach((t)=>{
            e.push(t);
        }), e;
    }
    any(e) {
        return this.throwIfDisposed(), e ? this.where(e).length() > 0 : this.length() > 0;
    }
    all(e) {
        return this.throwIfDisposed(), this.where(e).length() === this.length();
    }
    forEach(e) {
        this.throwIfDisposed();
        for(let t = 0; t < this.length(); t++)e(this.privList[t], t);
    }
    select(e) {
        this.throwIfDisposed();
        const t = [];
        for(let i = 0; i < this.privList.length; i++)t.push(e(this.privList[i], i));
        return new $d7238066c5de7f1c$var$Qc(t);
    }
    where(e) {
        this.throwIfDisposed();
        const t = new $d7238066c5de7f1c$var$Qc();
        for(let i = 0; i < this.privList.length; i++)e(this.privList[i], i) && t.add(this.privList[i]);
        return t;
    }
    orderBy(e) {
        this.throwIfDisposed();
        const i = this.toArray().sort(e);
        return new $d7238066c5de7f1c$var$Qc(i);
    }
    orderByDesc(e) {
        return this.throwIfDisposed(), this.orderBy((t, i)=>e(i, t));
    }
    clone() {
        return this.throwIfDisposed(), new $d7238066c5de7f1c$var$Qc(this.toArray());
    }
    concat(e) {
        return this.throwIfDisposed(), new $d7238066c5de7f1c$var$Qc(this.privList.concat(e.toArray()));
    }
    concatArray(e) {
        return this.throwIfDisposed(), new $d7238066c5de7f1c$var$Qc(this.privList.concat(e));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(e) {
        this.isDisposed() || (this.privDisposeReason = e, this.privList = null, this.privAddSubscriptions = null, this.privRemoveSubscriptions = null, this.triggerSubscriptions(this.privDisposedSubscriptions));
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new $d7238066c5de7f1c$var$IK("List", this.privDisposeReason);
    }
    triggerSubscriptions(e) {
        if (e) for(const t in e)t && e[t]();
    }
}
var $d7238066c5de7f1c$var$cM;
(function(r) {
    r[r.None = 0] = "None", r[r.Resolved = 1] = "Resolved", r[r.Rejected = 2] = "Rejected";
})($d7238066c5de7f1c$var$cM || ($d7238066c5de7f1c$var$cM = {}));
class $d7238066c5de7f1c$var$Ui {
    constructor(){
        this.resolve = (e)=>(this.privResolve(e), this), this.reject = (e)=>(this.privReject(e), this), this.privPromise = new Promise((e, t)=>{
            this.privResolve = e, this.privReject = t;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
function $d7238066c5de7f1c$var$ri(r, e, t) {
    r.then((i)=>{
        try {
            e && e(i);
        } catch (n) {
            if (t) try {
                if (n instanceof Error) {
                    const s = n;
                    t(s.name + ": " + s.message);
                } else t(n);
            } catch  {}
        }
    }, (i)=>{
        if (t) try {
            if (i instanceof Error) {
                const n = i;
                t(n.name + ": " + n.message);
            } else t(i);
        } catch  {}
    });
}
var $d7238066c5de7f1c$var$uM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
}, $d7238066c5de7f1c$var$jy;
(function(r) {
    r[r.Dequeue = 0] = "Dequeue", r[r.Peek = 1] = "Peek";
})($d7238066c5de7f1c$var$jy || ($d7238066c5de7f1c$var$jy = {}));
let $d7238066c5de7f1c$var$ZB = class {
    constructor(e){
        this.privPromiseStore = new $d7238066c5de7f1c$var$Qc(), this.privIsDrainInProgress = !1, this.privIsDisposing = !1, this.privDisposeReason = null, this.privList = e || new $d7238066c5de7f1c$var$Qc(), this.privDetachables = [], this.privSubscribers = new $d7238066c5de7f1c$var$Qc(), this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
    enqueue(e) {
        this.throwIfDispose(), this.enqueueFromPromise(new Promise((t)=>t(e)));
    }
    enqueueFromPromise(e) {
        this.throwIfDispose(), e.then((t)=>{
            this.privList.add(t);
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const e = new $d7238066c5de7f1c$var$Ui();
        return this.privSubscribers && (this.privSubscribers.add({
            deferral: e,
            type: $d7238066c5de7f1c$var$jy.Dequeue
        }), this.drain()), e.promise;
    }
    peek() {
        this.throwIfDispose();
        const e = new $d7238066c5de7f1c$var$Ui();
        return this.privSubscribers && (this.privSubscribers.add({
            deferral: e,
            type: $d7238066c5de7f1c$var$jy.Peek
        }), this.drain()), e.promise;
    }
    length() {
        return this.throwIfDispose(), this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    drainAndDispose(e, t) {
        return $d7238066c5de7f1c$var$uM(this, void 0, void 0, function*() {
            if (!this.isDisposed() && !this.privIsDisposing) {
                this.privDisposeReason = t, this.privIsDisposing = !0;
                const i = this.privSubscribers;
                if (i) {
                    for(; i.length() > 0;)i.removeFirst().deferral.resolve(void 0);
                    this.privSubscribers === i && (this.privSubscribers = i);
                }
                for (const n of this.privDetachables)yield n.detach();
                if (this.privPromiseStore.length() > 0 && e) {
                    const n = [];
                    return this.privPromiseStore.toArray().forEach((s)=>{
                        n.push(s);
                    }), Promise.all(n).finally(()=>{
                        this.privSubscribers = null, this.privList.forEach((s)=>{
                            e(s);
                        }), this.privList = null;
                    }).then();
                } else this.privSubscribers = null, this.privList = null;
            }
        });
    }
    dispose(e) {
        return $d7238066c5de7f1c$var$uM(this, void 0, void 0, function*() {
            yield this.drainAndDispose(null, e);
        });
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = !0;
            const e = this.privSubscribers, t = this.privList;
            if (e && t) {
                for(; t.length() > 0 && e.length() > 0 && !this.privIsDisposing;){
                    const i = e.removeFirst();
                    if (i.type === $d7238066c5de7f1c$var$jy.Peek) i.deferral.resolve(t.first());
                    else {
                        const n = t.removeFirst();
                        i.deferral.resolve(n);
                    }
                }
                this.privSubscribers === e && (this.privSubscribers = e), this.privList === t && (this.privList = t);
            }
            this.privIsDrainInProgress = !1;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) throw this.privDisposeReason ? new $d7238066c5de7f1c$var$io(this.privDisposeReason) : new $d7238066c5de7f1c$var$IK("Queue");
        if (this.privIsDisposing) throw new $d7238066c5de7f1c$var$io("Queue disposing");
    }
};
class $d7238066c5de7f1c$var$RB {
    constructor(e, t, i){
        if (this.privPayload = null, !t) throw new $d7238066c5de7f1c$var$Zr("payload");
        if (e === $d7238066c5de7f1c$var$Tt.Binary && t.__proto__.constructor.name !== "ArrayBuffer") throw new $d7238066c5de7f1c$var$io("Payload must be ArrayBuffer");
        if (e === $d7238066c5de7f1c$var$Tt.Text && typeof t != "string") throw new $d7238066c5de7f1c$var$io("Payload must be a string");
        this.privMessageType = e, this.privPayload = t, this.privId = i || $d7238066c5de7f1c$var$Rn();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === $d7238066c5de7f1c$var$Tt.Binary) throw new $d7238066c5de7f1c$var$io("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === $d7238066c5de7f1c$var$Tt.Text) throw new $d7238066c5de7f1c$var$io("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}
class $d7238066c5de7f1c$var$Xme {
    constructor(e, t){
        this.privActualSampleRate = e, this.privDesiredSampleRate = t;
    }
    encode(e) {
        const t = this.downSampleAudioFrame(e, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!t) return null;
        const i = t.length * 2, n = new ArrayBuffer(i), s = new DataView(n);
        return this.floatTo16BitPCM(s, 0, t), n;
    }
    setString(e, t, i) {
        for(let n = 0; n < i.length; n++)e.setUint8(t + n, i.charCodeAt(n));
    }
    floatTo16BitPCM(e, t, i) {
        for(let n = 0; n < i.length; n++, t += 2){
            const s = Math.max(-1, Math.min(1, i[n]));
            e.setInt16(t, s < 0 ? s * 32768 : s * 32767, !0);
        }
    }
    downSampleAudioFrame(e, t, i) {
        if (!e) return null;
        if (i === t || i > t) return e;
        const n = t / i, s = Math.round(e.length / n), a = new Float32Array(s);
        let o = 0, g = 0;
        for(; g < s;){
            const l = Math.round((g + 1) * n);
            let c = 0, d = 0;
            for(; o < l && o < e.length;)c += e[o++], d++;
            a[g++] = c / d;
        }
        return a;
    }
}
var $d7238066c5de7f1c$var$Nme = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$yQ {
    constructor(e){
        this.privIsWriteEnded = !1, this.privIsReadEnded = !1, this.privId = e || $d7238066c5de7f1c$var$Rn(), this.privReaderQueue = new $d7238066c5de7f1c$var$ZB();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        this.privIsWriteEnded || (this.writeStreamChunk({
            buffer: null,
            isEnd: !0,
            timeReceived: Date.now()
        }), this.privIsWriteEnded = !0);
    }
    writeStreamChunk(e) {
        if (this.throwIfClosed(), !this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(e);
        } catch  {}
    }
    read() {
        if (this.privIsReadEnded) throw new $d7238066c5de7f1c$var$io("Stream read has already finished");
        return this.privReaderQueue.dequeue().then((e)=>$d7238066c5de7f1c$var$Nme(this, void 0, void 0, function*() {
                return (e === void 0 || e.isEnd) && (yield this.privReaderQueue.dispose("End of stream reached")), e;
            }));
    }
    readEnded() {
        this.privIsReadEnded || (this.privIsReadEnded = !0, this.privReaderQueue = new $d7238066c5de7f1c$var$ZB());
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new $d7238066c5de7f1c$var$io("Stream closed");
    }
}
var $d7238066c5de7f1c$var$VB;
(function(r) {
    r[r.Success = 0] = "Success", r[r.Error = 1] = "Error";
})($d7238066c5de7f1c$var$VB || ($d7238066c5de7f1c$var$VB = {}));
class $d7238066c5de7f1c$var$dK extends $d7238066c5de7f1c$var$yQ {
    constructor(e, t){
        super(t), this.privTargetChunkSize = e, this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(e) {
        if (e.isEnd || this.privNextBufferReadyBytes === 0 && e.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(e);
            return;
        }
        let t = 0;
        for(; t < e.buffer.byteLength;){
            this.privNextBufferToWrite === void 0 && (this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize), this.privNextBufferStartTime = e.timeReceived);
            const i = Math.min(e.buffer.byteLength - t, this.privTargetChunkSize - this.privNextBufferReadyBytes), n = new Uint8Array(this.privNextBufferToWrite), s = new Uint8Array(e.buffer.slice(t, i + t));
            n.set(s, this.privNextBufferReadyBytes), this.privNextBufferReadyBytes += i, t += i, this.privNextBufferReadyBytes === this.privTargetChunkSize && (super.writeStreamChunk({
                buffer: this.privNextBufferToWrite,
                isEnd: !1,
                timeReceived: this.privNextBufferStartTime
            }), this.privNextBufferReadyBytes = 0, this.privNextBufferToWrite = void 0);
        }
    }
    close() {
        this.privNextBufferReadyBytes !== 0 && !this.isClosed && super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: !1,
            timeReceived: this.privNextBufferStartTime
        }), super.close();
    }
}
class $d7238066c5de7f1c$var$Mr {
    static load() {
        const e = /* @__PURE__ */ new Map([
            [
                0,
                ()=>{}
            ]
        ]), t = /* @__PURE__ */ new Map(), n = "data:text/javascript;base64," + btoa(`!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`), s = new Worker(n);
        return s.addEventListener("message", ({ data: g })=>{
            if ($d7238066c5de7f1c$var$Mr.isCallNotification(g)) {
                const { params: { timerId: l } } = g, c = e.get(l);
                if (typeof c == "number") {
                    const d = t.get(c);
                    if (d === void 0 || d !== l) throw new Error("The timer is in an undefined state.");
                } else if (typeof c < "u") c(), e.delete(l);
                else throw new Error("The timer is in an undefined state.");
            } else if ($d7238066c5de7f1c$var$Mr.isClearResponse(g)) {
                const { id: l } = g, c = t.get(l);
                if (c === void 0) throw new Error("The timer is in an undefined state.");
                t.delete(l), e.delete(c);
            } else {
                const { error: { message: l } } = g;
                throw new Error(l);
            }
        }), {
            clearTimeout: (g)=>{
                const l = Math.random();
                t.set(l, g), e.set(g, l), s.postMessage({
                    id: l,
                    method: "clear",
                    params: {
                        timerId: g
                    }
                });
            },
            setTimeout: (g, l)=>{
                const c = Math.random();
                return e.set(c, g), s.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: l,
                        now: performance.now(),
                        timerId: c
                    }
                }), c;
            }
        };
    }
    static loadWorkerTimers() {
        return ()=>($d7238066c5de7f1c$var$Mr.workerTimers !== null || ($d7238066c5de7f1c$var$Mr.workerTimers = $d7238066c5de7f1c$var$Mr.load()), $d7238066c5de7f1c$var$Mr.workerTimers);
    }
    static isCallNotification(e) {
        return e.method !== void 0 && e.method === "call";
    }
    static isClearResponse(e) {
        return e.error === null && typeof e.id == "number";
    }
}
$d7238066c5de7f1c$var$Mr.workerTimers = null;
$d7238066c5de7f1c$var$Mr.clearTimeout = (r)=>$d7238066c5de7f1c$var$Mr.timers().clearTimeout(r);
$d7238066c5de7f1c$var$Mr.setTimeout = (r, e)=>$d7238066c5de7f1c$var$Mr.timers().setTimeout(r, e);
$d7238066c5de7f1c$var$Mr.timers = $d7238066c5de7f1c$var$Mr.loadWorkerTimers();
class $d7238066c5de7f1c$var$yI extends $d7238066c5de7f1c$var$lu {
    constructor(e){
        super("BackgroundEvent", $d7238066c5de7f1c$var$Ys.Error), this.privError = e;
    }
    get error() {
        return this.privError;
    }
}
class $d7238066c5de7f1c$var$Fi {
}
$d7238066c5de7f1c$var$Fi.AuthKey = "Ocp-Apim-Subscription-Key";
$d7238066c5de7f1c$var$Fi.Authorization = "Authorization";
$d7238066c5de7f1c$var$Fi.SpIDAuthKey = "Apim-Subscription-Id";
$d7238066c5de7f1c$var$Fi.ConnectionId = "X-ConnectionId";
$d7238066c5de7f1c$var$Fi.ContentType = "Content-Type";
$d7238066c5de7f1c$var$Fi.CustomCommandsAppId = "X-CommandsAppId";
$d7238066c5de7f1c$var$Fi.Path = "Path";
$d7238066c5de7f1c$var$Fi.RequestId = "X-RequestId";
$d7238066c5de7f1c$var$Fi.RequestStreamId = "X-StreamId";
$d7238066c5de7f1c$var$Fi.RequestTimestamp = "X-Timestamp";
class $d7238066c5de7f1c$var$cN {
    constructor(e, t){
        this.privHeaderName = e, this.privToken = t;
    }
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
}
class $d7238066c5de7f1c$var$BQ {
    /**
   * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
   * @constructor
   * @param {string} subscriptionKey - The subscription key
   */ constructor(e){
        if (!e) throw new $d7238066c5de7f1c$var$Zr("subscriptionKey");
        this.privAuthInfo = new $d7238066c5de7f1c$var$cN($d7238066c5de7f1c$var$Fi.AuthKey, e);
    }
    /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(e) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchOnExpiry(e) {
        return Promise.resolve(this.privAuthInfo);
    }
}
class $d7238066c5de7f1c$var$UC {
    constructor(e, t){
        if (!e) throw new $d7238066c5de7f1c$var$Zr("fetchCallback");
        if (!t) throw new $d7238066c5de7f1c$var$Zr("fetchOnExpiryCallback");
        this.privFetchCallback = e, this.privFetchOnExpiryCallback = t;
    }
    fetch(e) {
        return this.privFetchCallback(e).then((t)=>new $d7238066c5de7f1c$var$cN($d7238066c5de7f1c$var$Fi.Authorization, t === void 0 ? void 0 : $d7238066c5de7f1c$var$UC.privTokenPrefix + t));
    }
    fetchOnExpiry(e) {
        return this.privFetchOnExpiryCallback(e).then((t)=>new $d7238066c5de7f1c$var$cN($d7238066c5de7f1c$var$Fi.Authorization, t === void 0 ? void 0 : $d7238066c5de7f1c$var$UC.privTokenPrefix + t));
    }
}
$d7238066c5de7f1c$var$UC.privTokenPrefix = "Bearer ";
const $d7238066c5de7f1c$var$AX = {};
class $d7238066c5de7f1c$var$U {
    static throwIfNullOrUndefined(e, t) {
        if (e == null) throw new Error("throwIfNullOrUndefined:" + t);
    }
    static throwIfNull(e, t) {
        if (e === null) throw new Error("throwIfNull:" + t);
    }
    static throwIfNullOrWhitespace(e, t) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, t), ("" + e).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + t);
    }
    static throwIfNullOrTooLong(e, t, i) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, t), ("" + e).length > i) throw new Error("throwIfNullOrTooLong:" + t + " (more than " + i.toString() + " characters)");
    }
    static throwIfNullOrTooShort(e, t, i) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, t), ("" + e).length < i) throw new Error("throwIfNullOrTooShort:" + t + " (less than " + i.toString() + " characters)");
    }
    static throwIfDisposed(e) {
        if (e) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(e, t) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, t), e.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + t);
        for (const i of e)$d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i, t);
    }
    static throwIfFileDoesNotExist(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, t);
    }
    static throwIfNotUndefined(e, t) {
        if (e !== void 0) throw new Error("throwIfNotUndefined:" + t);
    }
}
class $d7238066c5de7f1c$var$Lme {
    constructor(e = $d7238066c5de7f1c$var$Ys.None){
        this.privLogPath = void 0, this.privEnableConsoleOutput = !0, this.privLogLevelFilter = e;
    }
    set logPath(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(void 0, `
File System access not available`), this.privLogPath = e;
    }
    set enableConsoleOutput(e) {
        this.privEnableConsoleOutput = e;
    }
    onEvent(e) {
        if (e.eventType >= this.privLogLevelFilter) {
            const t = this.toString(e);
            if (this.privLogPath && (void 0)(this.privLogPath, t + `
`, {
                flag: "a+"
            }), this.privEnableConsoleOutput) switch(e.eventType){
                case $d7238066c5de7f1c$var$Ys.Debug:
                    console.debug(t);
                    break;
                case $d7238066c5de7f1c$var$Ys.Info:
                    console.info(t);
                    break;
                case $d7238066c5de7f1c$var$Ys.Warning:
                    console.warn(t);
                    break;
                case $d7238066c5de7f1c$var$Ys.Error:
                    console.error(t);
                    break;
                default:
                    console.log(t);
                    break;
            }
        }
    }
    toString(e) {
        const t = [
            `${e.eventTime}`,
            `${e.name}`
        ], i = e;
        for(const n in i)if (n && e.hasOwnProperty(n) && n !== "eventTime" && n !== "eventType" && n !== "eventId" && n !== "name" && n !== "constructor") {
            const s = i[n];
            let a = "<NULL>";
            s != null && (typeof s == "number" || typeof s == "string" ? a = s.toString() : a = JSON.stringify(s)), t.push(`${n}: ${a}`);
        }
        return t.join(" | ");
    }
}
var $d7238066c5de7f1c$var$Lt;
(function(r) {
    r[r.PCM = 1] = "PCM", r[r.MuLaw = 2] = "MuLaw", r[r.Siren = 3] = "Siren", r[r.MP3 = 4] = "MP3", r[r.SILKSkype = 5] = "SILKSkype", r[r.OGG_OPUS = 6] = "OGG_OPUS", r[r.WEBM_OPUS = 7] = "WEBM_OPUS", r[r.ALaw = 8] = "ALaw", r[r.FLAC = 9] = "FLAC", r[r.OPUS = 10] = "OPUS";
})($d7238066c5de7f1c$var$Lt || ($d7238066c5de7f1c$var$Lt = {}));
class $d7238066c5de7f1c$var$c0 {
    /**
   * Creates an audio stream format object representing the default audio stream
   * format (16KHz 16bit mono PCM).
   * @member AudioStreamFormat.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormat} The audio stream format being created.
   */ static getDefaultInputFormat() {
        return $d7238066c5de7f1c$var$BI.getDefaultInputFormat();
    }
    /**
   * Creates an audio stream format object with the specified format characteristics.
   * @member AudioStreamFormat.getWaveFormat
   * @function
   * @public
   * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
   * @param {number} bitsPerSample - Bits per sample, typically 16.
   * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
   * uses one channel and stereo data uses two channels.
   * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
   * @returns {AudioStreamFormat} The audio stream format being created.
   */ static getWaveFormat(e, t, i, n) {
        return new $d7238066c5de7f1c$var$BI(e, t, i, n);
    }
    /**
   * Creates an audio stream format object with the specified pcm waveformat characteristics.
   * @member AudioStreamFormat.getWaveFormatPCM
   * @function
   * @public
   * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
   * @param {number} bitsPerSample - Bits per sample, typically 16.
   * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
   * uses one channel and stereo data uses two channels.
   * @returns {AudioStreamFormat} The audio stream format being created.
   */ static getWaveFormatPCM(e, t, i) {
        return new $d7238066c5de7f1c$var$BI(e, t, i);
    }
}
class $d7238066c5de7f1c$var$BI extends $d7238066c5de7f1c$var$c0 {
    /**
   * Creates an instance with the given values.
   * @constructor
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {number} channels - Number of channels.
   * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
   */ constructor(e = 16e3, t = 16, i = 1, n = $d7238066c5de7f1c$var$Lt.PCM){
        super();
        let s = !0;
        switch(n){
            case $d7238066c5de7f1c$var$Lt.PCM:
                this.formatTag = 1;
                break;
            case $d7238066c5de7f1c$var$Lt.ALaw:
                this.formatTag = 6;
                break;
            case $d7238066c5de7f1c$var$Lt.MuLaw:
                this.formatTag = 7;
                break;
            default:
                s = !1;
        }
        if (this.bitsPerSample = t, this.samplesPerSec = e, this.channels = i, this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8), this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8), s) {
            this.privHeader = new ArrayBuffer(44);
            const a = new DataView(this.privHeader);
            this.setString(a, 0, "RIFF"), a.setUint32(4, 0, !0), this.setString(a, 8, "WAVEfmt "), a.setUint32(16, 16, !0), a.setUint16(20, this.formatTag, !0), a.setUint16(22, this.channels, !0), a.setUint32(24, this.samplesPerSec, !0), a.setUint32(28, this.avgBytesPerSec, !0), a.setUint16(32, this.channels * (this.bitsPerSample / 8), !0), a.setUint16(34, this.bitsPerSample, !0), this.setString(a, 36, "data"), a.setUint32(40, 0, !0);
        }
    }
    /**
   * Retrieves the default input format.
   * @member AudioStreamFormatImpl.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormatImpl} The default input format.
   */ static getDefaultInputFormat() {
        return new $d7238066c5de7f1c$var$BI();
    }
    /**
   * Creates an audio context appropriate to current browser
   * @member AudioStreamFormatImpl.getAudioContext
   * @function
   * @public
   * @returns {AudioContext} An audio context instance
   */ /* eslint-disable */ static getAudioContext(e) {
        const t = window.AudioContext || window.webkitAudioContext || !1;
        if (t) return e !== void 0 && navigator.mediaDevices.getSupportedConstraints().sampleRate ? new t({
            sampleRate: e
        }) : new t();
        throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
   * Closes the configuration object.
   * @member AudioStreamFormatImpl.prototype.close
   * @function
   * @public
   */ close() {}
    get header() {
        return this.privHeader;
    }
    setString(e, t, i) {
        for(let n = 0; n < i.length; n++)e.setUint8(t + n, i.charCodeAt(n));
    }
}
var $d7238066c5de7f1c$var$uS = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
const $d7238066c5de7f1c$var$Yme = "MICROPHONE-WorkletSourceUrl";
class $d7238066c5de7f1c$var$Dl {
    constructor(e, t, i, n){
        this.privRecorder = e, this.deviceId = t, this.privStreams = {}, this.privOutputChunkSize = $d7238066c5de7f1c$var$Dl.AUDIOFORMAT.avgBytesPerSec / 10, this.privId = i || $d7238066c5de7f1c$var$Rn(), this.privEvents = new $d7238066c5de7f1c$var$sc(), this.privMediaStream = n || null, this.privIsClosing = !1;
    }
    get format() {
        return Promise.resolve($d7238066c5de7f1c$var$Dl.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new $d7238066c5de7f1c$var$Ui();
        try {
            this.createAudioContext();
        } catch (i) {
            if (i instanceof Error) {
                const n = i;
                this.privInitializeDeferral.reject(n.name + ": " + n.message);
            } else this.privInitializeDeferral.reject(i);
            return this.privInitializeDeferral.promise;
        }
        const e = window.navigator;
        let t = // eslint-disable-next-line
        e.getUserMedia || e.webkitGetUserMedia || e.mozGetUserMedia || e.msGetUserMedia;
        if (e.mediaDevices && (t = (i, n, s)=>{
            e.mediaDevices.getUserMedia(i).then(n).catch(s);
        }), t) {
            const i = ()=>{
                this.onEvent(new $d7238066c5de7f1c$var$QR(this.privId)), this.privMediaStream && this.privMediaStream.active ? (this.onEvent(new $d7238066c5de7f1c$var$SB(this.privId)), this.privInitializeDeferral.resolve()) : t({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : !0,
                    video: !1
                }, (n)=>{
                    this.privMediaStream = n, this.onEvent(new $d7238066c5de7f1c$var$SB(this.privId)), this.privInitializeDeferral.resolve();
                }, (n)=>{
                    const s = `Error occurred during microphone initialization: ${n}`;
                    this.privInitializeDeferral.reject(s), this.onEvent(new $d7238066c5de7f1c$var$EZ(this.privId, s));
                });
            };
            this.privContext.state === "suspended" ? this.privContext.resume().then(i).catch((n)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${n}`);
            }) : i();
        } else {
            const i = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(i), this.onEvent(new $d7238066c5de7f1c$var$EZ(i, ""));
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(e) {
        return this.onEvent(new $d7238066c5de7f1c$var$of(this.privId, e)), this.listen(e).then((t)=>(this.onEvent(new $d7238066c5de7f1c$var$gf(this.privId, e)), {
                detach: ()=>$d7238066c5de7f1c$var$uS(this, void 0, void 0, function*() {
                        return t.readEnded(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e)), this.turnOff();
                    }),
                id: ()=>e,
                read: ()=>t.read()
            }));
    }
    detach(e) {
        e && this.privStreams[e] && (this.privStreams[e].close(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e)));
    }
    turnOff() {
        return $d7238066c5de7f1c$var$uS(this, void 0, void 0, function*() {
            for(const e in this.privStreams)if (e) {
                const t = this.privStreams[e];
                t && t.close();
            }
            this.onEvent(new $d7238066c5de7f1c$var$mQ(this.privId)), this.privInitializeDeferral && (yield this.privInitializeDeferral, this.privInitializeDeferral = null), yield this.destroyAudioContext();
        });
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((e)=>({
                bitspersample: $d7238066c5de7f1c$var$Dl.AUDIOFORMAT.bitsPerSample,
                channelcount: $d7238066c5de7f1c$var$Dl.AUDIOFORMAT.channels,
                connectivity: $d7238066c5de7f1c$var$qA.Unknown,
                manufacturer: "Speech SDK",
                model: e,
                samplerate: $d7238066c5de7f1c$var$Dl.AUDIOFORMAT.samplesPerSec,
                type: $d7238066c5de7f1c$var$PC.Microphones
            }));
    }
    setProperty(e, t) {
        if (e === $d7238066c5de7f1c$var$Yme) this.privRecorder.setWorkletUrl(t);
        else throw new Error("Property '" + e + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const e = "microphone";
        if (this.privMicrophoneLabel !== void 0) return Promise.resolve(this.privMicrophoneLabel);
        if (this.privMediaStream === void 0 || !this.privMediaStream.active) return Promise.resolve(e);
        this.privMicrophoneLabel = e;
        const t = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        if (t === void 0) return Promise.resolve(this.privMicrophoneLabel);
        const i = new $d7238066c5de7f1c$var$Ui();
        return navigator.mediaDevices.enumerateDevices().then((n)=>{
            for (const s of n)if (s.deviceId === t) {
                this.privMicrophoneLabel = s.label;
                break;
            }
            i.resolve(this.privMicrophoneLabel);
        }, ()=>i.resolve(this.privMicrophoneLabel)), i.promise;
    }
    listen(e) {
        return $d7238066c5de7f1c$var$uS(this, void 0, void 0, function*() {
            yield this.turnOn();
            const t = new $d7238066c5de7f1c$var$dK(this.privOutputChunkSize, e);
            this.privStreams[e] = t;
            try {
                this.privRecorder.record(this.privContext, this.privMediaStream, t);
            } catch (n) {
                throw this.onEvent(new $d7238066c5de7f1c$var$cK(this.privId, e, n)), n;
            }
            return t;
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
    createAudioContext() {
        this.privContext || (this.privContext = $d7238066c5de7f1c$var$BI.getAudioContext($d7238066c5de7f1c$var$Dl.AUDIOFORMAT.samplesPerSec));
    }
    destroyAudioContext() {
        return $d7238066c5de7f1c$var$uS(this, void 0, void 0, function*() {
            if (!this.privContext) return;
            this.privRecorder.releaseMediaResources(this.privContext);
            let e = !1;
            "close" in this.privContext && (e = !0), e ? this.privIsClosing || (this.privIsClosing = !0, yield this.privContext.close(), this.privContext = null, this.privIsClosing = !1) : this.privContext !== null && this.privContext.state === "running" && (yield this.privContext.suspend());
        });
    }
}
$d7238066c5de7f1c$var$Dl.AUDIOFORMAT = $d7238066c5de7f1c$var$c0.getDefaultInputFormat();
var $d7238066c5de7f1c$var$bX = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Kme {
    constructor(e, t, i){
        this.privStreams = {}, this.privHeaderEnd = 44, this.privId = i || $d7238066c5de7f1c$var$Rn(), this.privEvents = new $d7238066c5de7f1c$var$sc(), this.privSource = e, typeof window < "u" && typeof Blob < "u" && this.privSource instanceof Blob ? this.privFilename = e.name : this.privFilename = t || "unknown.wav", this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const e = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            return this.onEvent(new $d7238066c5de7f1c$var$EZ(e, "")), Promise.reject(e);
        }
        this.onEvent(new $d7238066c5de7f1c$var$QR(this.privId)), this.onEvent(new $d7238066c5de7f1c$var$SB(this.privId));
    }
    id() {
        return this.privId;
    }
    attach(e) {
        return $d7238066c5de7f1c$var$bX(this, void 0, void 0, function*() {
            this.onEvent(new $d7238066c5de7f1c$var$of(this.privId, e));
            const t = yield this.upload(e);
            return this.onEvent(new $d7238066c5de7f1c$var$gf(this.privId, e)), Promise.resolve({
                detach: ()=>$d7238066c5de7f1c$var$bX(this, void 0, void 0, function*() {
                        t.readEnded(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e)), yield this.turnOff();
                    }),
                id: ()=>e,
                read: ()=>t.read()
            });
        });
    }
    detach(e) {
        e && this.privStreams[e] && (this.privStreams[e].close(), delete this.privStreams[e], this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e)));
    }
    turnOff() {
        for(const e in this.privStreams)if (e) {
            const t = this.privStreams[e];
            t && !t.isClosed && t.close();
        }
        return this.onEvent(new $d7238066c5de7f1c$var$mQ(this.privId)), Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((e)=>Promise.resolve({
                bitspersample: e.bitsPerSample,
                channelcount: e.channels,
                connectivity: $d7238066c5de7f1c$var$qA.Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: e.samplesPerSec,
                type: $d7238066c5de7f1c$var$PC.File
            }));
    }
    readHeader() {
        const t = this.privSource.slice(0, 4296), i = new $d7238066c5de7f1c$var$Ui(), n = (s)=>{
            const a = new DataView(s), o = (A)=>String.fromCharCode(a.getUint8(A), a.getUint8(A + 1), a.getUint8(A + 2), a.getUint8(A + 3));
            if (o(0) !== "RIFF") {
                i.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            if (o(8) !== "WAVE" || o(12) !== "fmt ") {
                i.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const g = a.getInt32(16, !0), l = a.getUint16(22, !0), c = a.getUint32(24, !0), d = a.getUint16(34, !0);
            let p = 36 + Math.max(g - 16, 0);
            for(; o(p) !== "data"; p += 2)if (p > 4288) {
                i.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = p + 8, i.resolve($d7238066c5de7f1c$var$c0.getWaveFormatPCM(c, d, l));
        };
        if (typeof window < "u" && typeof Blob < "u" && t instanceof Blob) {
            const s = new FileReader();
            s.onload = (a)=>{
                const o = a.target.result;
                n(o);
            }, s.readAsArrayBuffer(t);
        } else {
            const s = t;
            n(s.buffer.slice(s.byteOffset, s.byteOffset + s.byteLength));
        }
        return i.promise;
    }
    upload(e) {
        return $d7238066c5de7f1c$var$bX(this, void 0, void 0, function*() {
            const t = (i)=>{
                const n = `Error occurred while processing '${this.privFilename}'. ${i}`;
                throw this.onEvent(new $d7238066c5de7f1c$var$cK(this.privId, e, n)), new Error(n);
            };
            try {
                yield this.turnOn();
                const i = yield this.privAudioFormatPromise, n = new $d7238066c5de7f1c$var$dK(i.avgBytesPerSec / 10, e);
                this.privStreams[e] = n;
                const s = this.privSource.slice(this.privHeaderEnd), a = (o)=>{
                    n.isClosed || (n.writeStreamChunk({
                        buffer: o,
                        isEnd: !1,
                        timeReceived: Date.now()
                    }), n.close());
                };
                if (typeof window < "u" && typeof Blob < "u" && s instanceof Blob) {
                    const o = new FileReader();
                    o.onerror = (g)=>t(g.toString()), o.onload = (g)=>{
                        const l = g.target.result;
                        a(l);
                    }, o.readAsArrayBuffer(s);
                } else {
                    const o = s;
                    a(o.buffer.slice(o.byteOffset, o.byteOffset + o.byteLength));
                }
                return n;
            } catch (i) {
                t(i);
            }
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
}

class $d7238066c5de7f1c$var$yX {
    constructor(e){
        this.privStopInputOnRelease = e;
    }
    record(e, t, i) {
        const s = new $d7238066c5de7f1c$var$Xme(e.sampleRate, 16e3), a = e.createMediaStreamSource(t), o = ()=>{
            const c = (()=>{
                let d = 0;
                try {
                    return e.createScriptProcessor(d, 1, 1);
                } catch  {
                    d = 2048;
                    let A = e.sampleRate;
                    for(; d < 16384 && A >= 32e3;)d <<= 1, A >>= 1;
                    return e.createScriptProcessor(d, 1, 1);
                }
            })();
            c.onaudioprocess = (d)=>{
                const p = d.inputBuffer.getChannelData(0);
                if (i && !i.isClosed) {
                    const A = s.encode(p);
                    A && i.writeStreamChunk({
                        buffer: A,
                        isEnd: !1,
                        timeReceived: Date.now()
                    });
                }
            }, a.connect(c), c.connect(e.destination), this.privMediaResources = {
                scriptProcessorNode: c,
                source: a,
                stream: t
            };
        }, g = (c)=>{
            const d = new AudioWorkletNode(c, "speech-processor");
            d.port.onmessage = (p)=>{
                const A = p.data;
                if (i && !i.isClosed) {
                    const y = s.encode(A);
                    y && i.writeStreamChunk({
                        buffer: y,
                        isEnd: !1,
                        timeReceived: Date.now()
                    });
                }
            }, a.connect(d), d.connect(c.destination), this.privMediaResources = {
                scriptProcessorNode: d,
                source: a,
                stream: t
            };
        }, l = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
        if (e.audioWorklet && !l) this.privSpeechProcessorScript = new URL((parcelRequire("9HfWD"))).toString(), e.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
            g(e);
        }).catch(()=>{
            const c = `class SP extends AudioWorkletProcessor {
                        constructor(options) {
                        super(options);
                        }
                        process(inputs, outputs) {
                        const input = inputs[0];
                        const output = [];
                        for (let channel = 0; channel < input.length; channel += 1) {
                            output[channel] = input[channel];
                        }
                        this.port.postMessage(output[0]);
                        return true;
                        }
                    }
                    registerProcessor('speech-processor', SP);`, d = new Blob([
                c
            ], {
                type: "application/javascript; charset=utf-8"
            });
            this.privSpeechProcessorScript = URL.createObjectURL(d), e.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                g(e);
            }).catch(()=>{
                o();
            });
        });
        else try {
            o();
        } catch (c) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${c}`);
        }
    }
    releaseMediaResources(e) {
        this.privMediaResources && (this.privMediaResources.scriptProcessorNode && (this.privMediaResources.scriptProcessorNode.disconnect(e.destination), this.privMediaResources.scriptProcessorNode = null), this.privMediaResources.source && (this.privMediaResources.source.disconnect(), this.privStopInputOnRelease && this.privMediaResources.stream.getTracks().forEach((t)=>t.stop()), this.privMediaResources.source = null));
    }
    setWorkletUrl(e) {
        this.privSpeechProcessorScript = e;
    }
}
var $d7238066c5de7f1c$var$IM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$wB {
    constructor(e, t, i, n, s, a){
        if (!e) throw new $d7238066c5de7f1c$var$Zr("uri");
        if (!i) throw new $d7238066c5de7f1c$var$Zr("messageFormatter");
        this.proxyInfo = n, this.privConnectionEvents = new $d7238066c5de7f1c$var$sc(), this.privConnectionId = t, this.privMessageFormatter = i, this.privConnectionState = $d7238066c5de7f1c$var$ir.None, this.privUri = e, this.privHeaders = s, this.privEnableCompression = a, this.privHeaders[$d7238066c5de7f1c$var$Fi.ConnectionId] = this.privConnectionId, this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === $d7238066c5de7f1c$var$ir.Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new $d7238066c5de7f1c$var$Ui(), this.privCertificateValidatedDeferral = new $d7238066c5de7f1c$var$Ui(), this.privConnectionState = $d7238066c5de7f1c$var$ir.Connecting;
        try {
            if (typeof WebSocket < "u" && !$d7238066c5de7f1c$var$wB.forceNpmWebSocket) this.privCertificateValidatedDeferral.resolve(), this.privWebsocketClient = new WebSocket(this.privUri);
            else {
                const e = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                this.privCertificateValidatedDeferral.resolve(), e.agent = this.getAgent();
                let i = new URL(this.privUri).protocol;
                (i == null ? void 0 : i.toLocaleLowerCase()) === "wss:" ? i = "https:" : (i == null ? void 0 : i.toLocaleLowerCase()) === "ws:" && (i = "http:"), e.agent.protocol = i, this.privWebsocketClient = new $d7238066c5de7f1c$var$AX(this.privUri, e);
            }
            this.privWebsocketClient.binaryType = "arraybuffer", this.privReceivingMessageQueue = new $d7238066c5de7f1c$var$ZB(), this.privDisconnectDeferral = new $d7238066c5de7f1c$var$Ui(), this.privSendMessageQueue = new $d7238066c5de7f1c$var$ZB(), this.processSendQueue().catch((e)=>{
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(e));
            });
        } catch (e) {
            return this.privConnectionEstablishDeferral.resolve(new $d7238066c5de7f1c$var$mX(500, e)), this.privConnectionEstablishDeferral.promise;
        }
        return this.onEvent(new $d7238066c5de7f1c$var$AQ(this.privConnectionId, this.privUri)), this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = $d7238066c5de7f1c$var$ir.Connected, this.onEvent(new $d7238066c5de7f1c$var$bQ(this.privConnectionId)), this.privConnectionEstablishDeferral.resolve(new $d7238066c5de7f1c$var$mX(200, ""));
            }, (e)=>{
                this.privConnectionEstablishDeferral.reject(e);
            });
        }, this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new $d7238066c5de7f1c$var$Zme(this.privConnectionId, e.message, e.type)), this.privLastErrorReceived = e.message;
        }, this.privWebsocketClient.onclose = (e)=>{
            this.privConnectionState === $d7238066c5de7f1c$var$ir.Connecting ? (this.privConnectionState = $d7238066c5de7f1c$var$ir.Disconnected, this.privConnectionEstablishDeferral.resolve(new $d7238066c5de7f1c$var$mX(e.code, e.reason + " " + this.privLastErrorReceived))) : (this.privConnectionState = $d7238066c5de7f1c$var$ir.Disconnected, this.privWebsocketClient = null, this.onEvent(new $d7238066c5de7f1c$var$Sme(this.privConnectionId, e.code, e.reason))), this.onClose(e.code, e.reason).catch((t)=>{
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(t));
            });
        }, this.privWebsocketClient.onmessage = (e)=>{
            const t = /* @__PURE__ */ new Date().toISOString();
            if (this.privConnectionState === $d7238066c5de7f1c$var$ir.Connected) {
                const i = new $d7238066c5de7f1c$var$Ui();
                if (this.privReceivingMessageQueue.enqueueFromPromise(i.promise), e.data instanceof ArrayBuffer) {
                    const n = new $d7238066c5de7f1c$var$RB($d7238066c5de7f1c$var$Tt.Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(n).then((s)=>{
                        this.onEvent(new $d7238066c5de7f1c$var$lN(this.privConnectionId, t, s)), i.resolve(s);
                    }, (s)=>{
                        i.reject(`Invalid binary message format. Error: ${s}`);
                    });
                } else {
                    const n = new $d7238066c5de7f1c$var$RB($d7238066c5de7f1c$var$Tt.Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(n).then((s)=>{
                        this.onEvent(new $d7238066c5de7f1c$var$lN(this.privConnectionId, t, s)), i.resolve(s);
                    }, (s)=>{
                        i.reject(`Invalid text message format. Error: ${s}`);
                    });
                }
            }
        }, this.privConnectionEstablishDeferral.promise;
    }
    send(e) {
        if (this.privConnectionState !== $d7238066c5de7f1c$var$ir.Connected) return Promise.reject(`Cannot send on connection that is in ${$d7238066c5de7f1c$var$ir[this.privConnectionState]} state`);
        const t = new $d7238066c5de7f1c$var$Ui(), i = new $d7238066c5de7f1c$var$Ui();
        return this.privSendMessageQueue.enqueueFromPromise(i.promise), this.privMessageFormatter.fromConnectionMessage(e).then((n)=>{
            i.resolve({
                Message: e,
                RawWebsocketMessage: n,
                sendStatusDeferral: t
            });
        }, (n)=>{
            i.reject(`Error formatting the message. ${n}`);
        }), t.promise;
    }
    read() {
        return this.privConnectionState !== $d7238066c5de7f1c$var$ir.Connected ? Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`) : this.privReceivingMessageQueue.dequeue();
    }
    close(e) {
        if (this.privWebsocketClient) this.privConnectionState !== $d7238066c5de7f1c$var$ir.Disconnected && this.privWebsocketClient.close(1e3, e || "Normal closure by client");
        else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(e) {
        try {
            if (!e) return Promise.resolve();
            if (this.onEvent(new $d7238066c5de7f1c$var$Vme(this.privConnectionId, /* @__PURE__ */ new Date().toISOString(), e.Message)), this.isWebsocketOpen) this.privWebsocketClient.send(e.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + e.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (t) {
            return Promise.reject(`websocket send error: ${t}`);
        }
    }
    onClose(e, t) {
        return $d7238066c5de7f1c$var$IM(this, void 0, void 0, function*() {
            const i = `Connection closed. ${e}: ${t}`;
            this.privConnectionState = $d7238066c5de7f1c$var$ir.Disconnected, this.privDisconnectDeferral.resolve(), yield this.privReceivingMessageQueue.drainAndDispose(()=>{}, i), yield this.privSendMessageQueue.drainAndDispose((n)=>{
                n.sendStatusDeferral.reject(i);
            }, i);
        });
    }
    processSendQueue() {
        return $d7238066c5de7f1c$var$IM(this, void 0, void 0, function*() {
            for(;;){
                const t = yield this.privSendMessageQueue.dequeue();
                if (!t) return;
                try {
                    yield this.sendRawMessage(t), t.sendStatusDeferral.resolve();
                } catch (i) {
                    t.sendStatusDeferral.reject(i);
                }
            }
        });
    }
    onEvent(e) {
        this.privConnectionEvents.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        const e = new $d7238066c5de7f1c$var$AX.Agent(this.createConnection);
        return this.proxyInfo !== void 0 && this.proxyInfo.HostName !== void 0 && this.proxyInfo.Port > 0 && (e.proxyInfo = this.proxyInfo), e;
    }
    static GetProxyAgent(e) {
        const t = {
            host: e.HostName,
            port: e.Port
        };
        return e.UserName ? t.headers = {
            "Proxy-Authentication": "Basic " + new $d7238066c5de7f1c$require$Buffer(`${e.UserName}:${e.Password === void 0 ? "" : e.Password}`).toString("base64")
        } : t.headers = {}, t.headers.requestOCSP = "true", new $d7238066c5de7f1c$var$AX(t);
    }
    createConnection(e, t) {
        let i;
        if (t = Object.assign(Object.assign({}, t), {
            requestOCSP: !0,
            servername: t.host
        }), this.proxyInfo) {
            const s = $d7238066c5de7f1c$var$wB.GetProxyAgent(this.proxyInfo);
            i = new Promise((a, o)=>{
                s.callback(e, t, (g, l)=>{
                    g ? o(g) : a(l);
                });
            });
        } else t.secureEndpoint, i = Promise.resolve((void 0)(t));
        return i;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
$d7238066c5de7f1c$var$wB.forceNpmWebSocket = !1;
var $d7238066c5de7f1c$var$xme = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Au {
    constructor(e, t, i, n, s, a = !1, o){
        if (this.privIsDisposed = !1, !e) throw new $d7238066c5de7f1c$var$Zr("uri");
        if (!n) throw new $d7238066c5de7f1c$var$Zr("messageFormatter");
        this.privMessageFormatter = n;
        let g = "", l = 0;
        if (t) {
            for(const c in t)if (c) {
                g += l === 0 && e.indexOf("?") === -1 ? "?" : "&";
                const d = encodeURIComponent(c);
                g += d;
                let p = t[c];
                p && (p = encodeURIComponent(p), g += `=${p}`), l++;
            }
        }
        if (i) {
            for(const c in i)if (c) {
                g += l === 0 && e.indexOf("?") === -1 ? "?" : "&";
                const d = encodeURIComponent(i[c]);
                g += `${c}=${d}`, l++;
            }
        }
        this.privUri = e + g, this.privId = o || $d7238066c5de7f1c$var$Rn(), this.privConnectionMessageAdapter = new $d7238066c5de7f1c$var$wB(this.privUri, this.id, this.privMessageFormatter, s, i, a);
    }
    dispose() {
        return $d7238066c5de7f1c$var$xme(this, void 0, void 0, function*() {
            this.privIsDisposed = !0, this.privConnectionMessageAdapter && (yield this.privConnectionMessageAdapter.close());
        });
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(e) {
        return this.privConnectionMessageAdapter.send(e);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}
class $d7238066c5de7f1c$var$jR {
    constructor(e, t){
        this.privBuffers = [], this.privReplayOffset = 0, this.privLastShrinkOffset = 0, this.privBufferStartOffset = 0, this.privBufferSerial = 0, this.privBufferedBytes = 0, this.privReplay = !1, this.privLastChunkAcquiredTime = 0, this.privAudioNode = e, this.privBytesPerSecond = t;
    }
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        if (this.privReplay && this.privBuffers.length !== 0) {
            const e = this.privReplayOffset - this.privBufferStartOffset;
            let t = Math.round(e * this.privBytesPerSecond * 1e-7);
            t % 2 !== 0 && t++;
            let i = 0;
            for(; i < this.privBuffers.length && t >= this.privBuffers[i].chunk.buffer.byteLength;)t -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const n = this.privBuffers[i].chunk.buffer.slice(t);
                return this.privReplayOffset += n.byteLength / this.privBytesPerSecond * 1e7, i === this.privBuffers.length - 1 && (this.privReplay = !1), Promise.resolve({
                    buffer: n,
                    isEnd: !1,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((e)=>(e && e.buffer && (this.privBuffers.push(new $d7238066c5de7f1c$var$Fme(e, this.privBufferSerial++, this.privBufferedBytes)), this.privBufferedBytes += e.buffer.byteLength), e));
    }
    detach() {
        return this.privBuffers = void 0, this.privAudioNode.detach();
    }
    replay() {
        this.privBuffers && this.privBuffers.length !== 0 && (this.privReplay = !0, this.privReplayOffset = this.privLastShrinkOffset);
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(e) {
        if (this.privBuffers === void 0 || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = e;
        const t = e - this.privBufferStartOffset;
        let i = Math.round(t * this.privBytesPerSecond * 1e-7), n = 0;
        for(; n < this.privBuffers.length && i >= this.privBuffers[n].chunk.buffer.byteLength;)i -= this.privBuffers[n++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(e - i / this.privBytesPerSecond * 1e7), this.privBuffers = this.privBuffers.slice(n);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(e) {
        if (e < this.privBufferStartOffset || this.privBuffers === void 0) return 0;
        for (const t of this.privBuffers){
            const i = t.byteOffset / this.privBytesPerSecond * 1e7, n = i + t.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (e >= i && e <= n) return t.chunk.timeReceived;
        }
        return 0;
    }
}
class $d7238066c5de7f1c$var$Fme {
    constructor(e, t, i){
        this.chunk = e, this.serial = t, this.byteOffset = i;
    }
}
class $d7238066c5de7f1c$var$fQ {
    constructor(e){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(void 0, `
File System access not available, please use Push or PullAudioOutputStream`), this.privFd = (void 0)(e, "w");
    }
    set format(e) {
        $d7238066c5de7f1c$var$U.throwIfNotUndefined(this.privAudioFormat, "format is already set"), this.privAudioFormat = e;
        let t = 0;
        this.privAudioFormat.hasHeader && (t = this.privAudioFormat.header.byteLength), this.privFd !== void 0 && (this.privWriteStream = (void 0)("", {
            fd: this.privFd,
            start: t,
            autoClose: !1
        }));
    }
    write(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing."), this.privWriteStream !== void 0 && this.privWriteStream.write(new Uint8Array(e.slice(0)));
    }
    close() {
        this.privFd !== void 0 && (this.privWriteStream.on("finish", ()=>{
            this.privAudioFormat.hasHeader && (this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten), (void 0)(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0)), (void 0)(this.privFd), this.privFd = void 0;
        }), this.privWriteStream.end());
    }
    id() {
        return this.privId;
    }
}
var $d7238066c5de7f1c$var$uN = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$lf {
    /**
   * Creates and initializes an instance.
   * @constructor
   */ constructor(){}
    /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member AudioInputStream.createPushStream
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The audio input stream being created.
   */ static createPushStream(e) {
        return $d7238066c5de7f1c$var$hK.create(e);
    }
    /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
   * and close() methods.
   * @member AudioInputStream.createPullStream
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
   * PullAudioInputStreamCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
   * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The audio input stream being created.
   */ static createPullStream(e, t) {
        return $d7238066c5de7f1c$var$CK.create(e, t);
    }
}
class $d7238066c5de7f1c$var$hK extends $d7238066c5de7f1c$var$lf {
    /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member PushAudioInputStream.create
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
   * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The push audio input stream being created.
   */ static create(e) {
        return new $d7238066c5de7f1c$var$Tme(e);
    }
}
class $d7238066c5de7f1c$var$Tme extends $d7238066c5de7f1c$var$hK {
    /**
   * Creates and initalizes an instance with the given values.
   * @constructor
   * @param {AudioStreamFormat} format - The audio stream format.
   */ constructor(e){
        super(), e === void 0 ? this.privFormat = $d7238066c5de7f1c$var$BI.getDefaultInputFormat() : this.privFormat = e, this.privEvents = new $d7238066c5de7f1c$var$sc(), this.privId = $d7238066c5de7f1c$var$Rn(), this.privStream = new $d7238066c5de7f1c$var$dK(this.privFormat.avgBytesPerSec / 10);
    }
    /**
   * Format information for the audio
   */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PushAudioInputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */ write(e) {
        this.privStream.writeStreamChunk({
            buffer: e,
            isEnd: !1,
            timeReceived: Date.now()
        });
    }
    /**
   * Closes the stream.
   * @member PushAudioInputStreamImpl.prototype.close
   * @function
   * @public
   */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $d7238066c5de7f1c$var$QR(this.privId)), this.onEvent(new $d7238066c5de7f1c$var$SB(this.privId));
    }
    attach(e) {
        return $d7238066c5de7f1c$var$uN(this, void 0, void 0, function*() {
            this.onEvent(new $d7238066c5de7f1c$var$of(this.privId, e)), yield this.turnOn();
            const t = this.privStream;
            return this.onEvent(new $d7238066c5de7f1c$var$gf(this.privId, e)), {
                detach: ()=>$d7238066c5de7f1c$var$uN(this, void 0, void 0, function*() {
                        return this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e)), this.turnOff();
                    }),
                id: ()=>e,
                read: ()=>t.read()
            };
        });
    }
    detach(e) {
        this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e));
    }
    turnOff() {}
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $d7238066c5de7f1c$var$qA.Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $d7238066c5de7f1c$var$PC.Stream
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
    toBuffer(e) {
        const t = $d7238066c5de7f1c$require$Buffer.alloc(e.byteLength), i = new Uint8Array(e);
        for(let n = 0; n < t.length; ++n)t[n] = i[n];
        return t;
    }
}
class $d7238066c5de7f1c$var$CK extends $d7238066c5de7f1c$var$lf {
    /**
   * Creates and initializes and instance.
   * @constructor
   */ constructor(){
        super();
    }
    /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @member PullAudioInputStream.create
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   * derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The push audio input stream being created.
   */ static create(e, t) {
        return new $d7238066c5de7f1c$var$GQ(e, t);
    }
}
class $d7238066c5de7f1c$var$GQ extends $d7238066c5de7f1c$var$CK {
    /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @constructor
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   * derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   */ constructor(e, t){
        super(), t === void 0 ? this.privFormat = $d7238066c5de7f1c$var$c0.getDefaultInputFormat() : this.privFormat = t, this.privEvents = new $d7238066c5de7f1c$var$sc(), this.privId = $d7238066c5de7f1c$var$Rn(), this.privCallback = e, this.privIsClosed = !1, this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
   * Format information for the audio
   */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
   * Closes the stream.
   * @member PullAudioInputStreamImpl.prototype.close
   * @function
   * @public
   */ close() {
        this.privIsClosed = !0, this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $d7238066c5de7f1c$var$QR(this.privId)), this.onEvent(new $d7238066c5de7f1c$var$SB(this.privId));
    }
    attach(e) {
        return $d7238066c5de7f1c$var$uN(this, void 0, void 0, function*() {
            return this.onEvent(new $d7238066c5de7f1c$var$of(this.privId, e)), yield this.turnOn(), this.onEvent(new $d7238066c5de7f1c$var$gf(this.privId, e)), {
                detach: ()=>(this.privCallback.close(), this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e)), this.turnOff()),
                id: ()=>e,
                read: ()=>{
                    let t = 0, i;
                    for(; t < this.privBufferSize;){
                        const n = new ArrayBuffer(this.privBufferSize - t), s = this.privCallback.read(n);
                        if (i === void 0 ? i = n : new Int8Array(i).set(new Int8Array(n), t), s === 0) break;
                        t += s;
                    }
                    return Promise.resolve({
                        buffer: i.slice(0, t),
                        isEnd: this.privIsClosed || t === 0,
                        timeReceived: Date.now()
                    });
                }
            };
        });
    }
    detach(e) {
        this.onEvent(new $d7238066c5de7f1c$var$VI(this.privId, e));
    }
    turnOff() {}
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $d7238066c5de7f1c$var$qA.Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $d7238066c5de7f1c$var$PC.Stream
        });
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
}
var $d7238066c5de7f1c$var$$t;
(function(r) {
    r[r.Raw8Khz8BitMonoMULaw = 0] = "Raw8Khz8BitMonoMULaw", r[r.Riff16Khz16KbpsMonoSiren = 1] = "Riff16Khz16KbpsMonoSiren", r[r.Audio16Khz16KbpsMonoSiren = 2] = "Audio16Khz16KbpsMonoSiren", r[r.Audio16Khz32KBitRateMonoMp3 = 3] = "Audio16Khz32KBitRateMonoMp3", r[r.Audio16Khz128KBitRateMonoMp3 = 4] = "Audio16Khz128KBitRateMonoMp3", r[r.Audio16Khz64KBitRateMonoMp3 = 5] = "Audio16Khz64KBitRateMonoMp3", r[r.Audio24Khz48KBitRateMonoMp3 = 6] = "Audio24Khz48KBitRateMonoMp3", r[r.Audio24Khz96KBitRateMonoMp3 = 7] = "Audio24Khz96KBitRateMonoMp3", r[r.Audio24Khz160KBitRateMonoMp3 = 8] = "Audio24Khz160KBitRateMonoMp3", r[r.Raw16Khz16BitMonoTrueSilk = 9] = "Raw16Khz16BitMonoTrueSilk", r[r.Riff16Khz16BitMonoPcm = 10] = "Riff16Khz16BitMonoPcm", r[r.Riff8Khz16BitMonoPcm = 11] = "Riff8Khz16BitMonoPcm", r[r.Riff24Khz16BitMonoPcm = 12] = "Riff24Khz16BitMonoPcm", r[r.Riff8Khz8BitMonoMULaw = 13] = "Riff8Khz8BitMonoMULaw", r[r.Raw16Khz16BitMonoPcm = 14] = "Raw16Khz16BitMonoPcm", r[r.Raw24Khz16BitMonoPcm = 15] = "Raw24Khz16BitMonoPcm", r[r.Raw8Khz16BitMonoPcm = 16] = "Raw8Khz16BitMonoPcm", r[r.Ogg16Khz16BitMonoOpus = 17] = "Ogg16Khz16BitMonoOpus", r[r.Ogg24Khz16BitMonoOpus = 18] = "Ogg24Khz16BitMonoOpus", r[r.Raw48Khz16BitMonoPcm = 19] = "Raw48Khz16BitMonoPcm", r[r.Riff48Khz16BitMonoPcm = 20] = "Riff48Khz16BitMonoPcm", r[r.Audio48Khz96KBitRateMonoMp3 = 21] = "Audio48Khz96KBitRateMonoMp3", r[r.Audio48Khz192KBitRateMonoMp3 = 22] = "Audio48Khz192KBitRateMonoMp3", r[r.Ogg48Khz16BitMonoOpus = 23] = "Ogg48Khz16BitMonoOpus", r[r.Webm16Khz16BitMonoOpus = 24] = "Webm16Khz16BitMonoOpus", r[r.Webm24Khz16BitMonoOpus = 25] = "Webm24Khz16BitMonoOpus", r[r.Raw24Khz16BitMonoTrueSilk = 26] = "Raw24Khz16BitMonoTrueSilk", r[r.Raw8Khz8BitMonoALaw = 27] = "Raw8Khz8BitMonoALaw", r[r.Riff8Khz8BitMonoALaw = 28] = "Riff8Khz8BitMonoALaw", r[r.Webm24Khz16Bit24KbpsMonoOpus = 29] = "Webm24Khz16Bit24KbpsMonoOpus", r[r.Audio16Khz16Bit32KbpsMonoOpus = 30] = "Audio16Khz16Bit32KbpsMonoOpus", r[r.Audio24Khz16Bit48KbpsMonoOpus = 31] = "Audio24Khz16Bit48KbpsMonoOpus", r[r.Audio24Khz16Bit24KbpsMonoOpus = 32] = "Audio24Khz16Bit24KbpsMonoOpus", r[r.Raw22050Hz16BitMonoPcm = 33] = "Raw22050Hz16BitMonoPcm", r[r.Riff22050Hz16BitMonoPcm = 34] = "Riff22050Hz16BitMonoPcm", r[r.Raw44100Hz16BitMonoPcm = 35] = "Raw44100Hz16BitMonoPcm", r[r.Riff44100Hz16BitMonoPcm = 36] = "Riff44100Hz16BitMonoPcm";
})($d7238066c5de7f1c$var$$t || ($d7238066c5de7f1c$var$$t = {}));
class $d7238066c5de7f1c$var$Ut extends $d7238066c5de7f1c$var$BI {
    /**
   * Creates an instance with the given values.
   * @constructor
   * @param formatTag
   * @param {number} channels - Number of channels.
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} avgBytesPerSec - Average bytes per second.
   * @param {number} blockAlign - Block alignment.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {string} audioFormatString - Audio format string
   * @param {string} requestAudioFormatString - Audio format string sent to service.
   * @param {boolean} hasHeader - If the format has header or not.
   */ constructor(e, t, i, n, s, a, o, g, l){
        super(i, a, t, e), this.formatTag = e, this.avgBytesPerSec = n, this.blockAlign = s, this.priAudioFormatString = o, this.priRequestAudioFormatString = g, this.priHasHeader = l;
    }
    static fromSpeechSynthesisOutputFormat(e) {
        return e === void 0 ? $d7238066c5de7f1c$var$Ut.getDefaultOutputFormat() : $d7238066c5de7f1c$var$Ut.fromSpeechSynthesisOutputFormatString($d7238066c5de7f1c$var$Ut.SpeechSynthesisOutputFormatToString[e]);
    }
    static fromSpeechSynthesisOutputFormatString(e) {
        switch(e){
            case "raw-8khz-8bit-mono-mulaw":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MuLaw, 1, 8e3, 8e3, 1, 8, e, e, !1);
            case "riff-16khz-16kbps-mono-siren":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.Siren, 1, 16e3, 2e3, 40, 0, e, "audio-16khz-16kbps-mono-siren", !0);
            case "audio-16khz-16kbps-mono-siren":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.Siren, 1, 16e3, 2e3, 40, 0, e, e, !1);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 16e3, 4096, 2, 16, e, e, !1);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 16e3, 16384, 2, 16, e, e, !1);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 16e3, 8192, 2, 16, e, e, !1);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 24e3, 6144, 2, 16, e, e, !1);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 24e3, 12288, 2, 16, e, e, !1);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 24e3, 20480, 2, 16, e, e, !1);
            case "raw-16khz-16bit-mono-truesilk":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.SILKSkype, 1, 16e3, 32e3, 2, 16, e, e, !1);
            case "riff-8khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 8e3, 16e3, 2, 16, e, "raw-8khz-16bit-mono-pcm", !0);
            case "riff-24khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 24e3, 48e3, 2, 16, e, "raw-24khz-16bit-mono-pcm", !0);
            case "riff-8khz-8bit-mono-mulaw":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MuLaw, 1, 8e3, 8e3, 1, 8, e, "raw-8khz-8bit-mono-mulaw", !0);
            case "raw-16khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 16e3, 32e3, 2, 16, e, "raw-16khz-16bit-mono-pcm", !1);
            case "raw-24khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 24e3, 48e3, 2, 16, e, "raw-24khz-16bit-mono-pcm", !1);
            case "raw-8khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 8e3, 16e3, 2, 16, e, "raw-8khz-16bit-mono-pcm", !1);
            case "ogg-16khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.OGG_OPUS, 1, 16e3, 8192, 2, 16, e, e, !1);
            case "ogg-24khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.OGG_OPUS, 1, 24e3, 8192, 2, 16, e, e, !1);
            case "raw-48khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 48e3, 96e3, 2, 16, e, "raw-48khz-16bit-mono-pcm", !1);
            case "riff-48khz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 48e3, 96e3, 2, 16, e, "raw-48khz-16bit-mono-pcm", !0);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 48e3, 12288, 2, 16, e, e, !1);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.MP3, 1, 48e3, 24576, 2, 16, e, e, !1);
            case "ogg-48khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.OGG_OPUS, 1, 48e3, 12e3, 2, 16, e, e, !1);
            case "webm-16khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.WEBM_OPUS, 1, 16e3, 4e3, 2, 16, e, e, !1);
            case "webm-24khz-16bit-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.WEBM_OPUS, 1, 24e3, 6e3, 2, 16, e, e, !1);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.WEBM_OPUS, 1, 24e3, 3e3, 2, 16, e, e, !1);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.OPUS, 1, 16e3, 4e3, 2, 16, e, e, !1);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.OPUS, 1, 24e3, 6e3, 2, 16, e, e, !1);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.OPUS, 1, 24e3, 3e3, 2, 16, e, e, !1);
            case "audio-24khz-16bit-mono-flac":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.FLAC, 1, 24e3, 24e3, 2, 16, e, e, !1);
            case "audio-48khz-16bit-mono-flac":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.FLAC, 1, 48e3, 3e4, 2, 16, e, e, !1);
            case "raw-24khz-16bit-mono-truesilk":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.SILKSkype, 1, 24e3, 48e3, 2, 16, e, e, !1);
            case "raw-8khz-8bit-mono-alaw":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.ALaw, 1, 8e3, 8e3, 1, 8, e, e, !1);
            case "riff-8khz-8bit-mono-alaw":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.ALaw, 1, 8e3, 8e3, 1, 8, e, "raw-8khz-8bit-mono-alaw", !0);
            case "raw-22050hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 22050, 44100, 2, 16, e, e, !1);
            case "riff-22050hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 22050, 44100, 2, 16, e, "raw-22050hz-16bit-mono-pcm", !0);
            case "raw-44100hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 44100, 88200, 2, 16, e, e, !1);
            case "riff-44100hz-16bit-mono-pcm":
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 44100, 88200, 2, 16, e, "raw-44100hz-16bit-mono-pcm", !0);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $d7238066c5de7f1c$var$Ut($d7238066c5de7f1c$var$Lt.PCM, 1, 16e3, 32e3, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", !0);
        }
    }
    static getDefaultOutputFormat() {
        return $d7238066c5de7f1c$var$Ut.fromSpeechSynthesisOutputFormatString(typeof window < "u" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
   * Specifies if this audio output format has a header
   * @boolean AudioOutputFormatImpl.prototype.hasHeader
   * @function
   * @public
   */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
   * Specifies the header of this format
   * @ArrayBuffer AudioOutputFormatImpl.prototype.header
   * @function
   * @public
   */ get header() {
        if (this.hasHeader) return this.privHeader;
    }
    /**
   * Updates the header based on the audio length
   * @member AudioOutputFormatImpl.updateHeader
   * @function
   * @public
   * @param {number} audioLength - the audio length
   */ updateHeader(e) {
        if (this.priHasHeader) {
            const t = new DataView(this.privHeader);
            t.setUint32(4, e + this.privHeader.byteLength - 8, !0), t.setUint32(40, e, !0);
        }
    }
    /**
   * Specifies the audio format string to be sent to the service
   * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
   * @function
   * @public
   */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
    /**
   * Adds audio header
   * @param audio the raw audio without header
   * @returns the audio with header if applicable
   */ addHeader(e) {
        if (!this.hasHeader) return e;
        this.updateHeader(e.byteLength);
        const t = new Uint8Array(e.byteLength + this.header.byteLength);
        return t.set(new Uint8Array(this.header), 0), t.set(new Uint8Array(e), this.header.byteLength), t.buffer;
    }
}
$d7238066c5de7f1c$var$Ut.SpeechSynthesisOutputFormatToString = {
    [$d7238066c5de7f1c$var$$t.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [$d7238066c5de7f1c$var$$t.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [$d7238066c5de7f1c$var$$t.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [$d7238066c5de7f1c$var$$t.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [$d7238066c5de7f1c$var$$t.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [$d7238066c5de7f1c$var$$t.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$$t.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$$t.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [$d7238066c5de7f1c$var$$t.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$$t.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$$t.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [$d7238066c5de7f1c$var$$t.Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [$d7238066c5de7f1c$var$$t.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [$d7238066c5de7f1c$var$$t.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [$d7238066c5de7f1c$var$$t.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [$d7238066c5de7f1c$var$$t.Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [$d7238066c5de7f1c$var$$t.Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [$d7238066c5de7f1c$var$$t.Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [$d7238066c5de7f1c$var$$t.Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [$d7238066c5de7f1c$var$$t.Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm"
};
var $d7238066c5de7f1c$var$Mme = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$qR {
    /**
   * Creates and initializes an instance.
   * @constructor
   */ constructor(){}
    /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member AudioOutputStream.createPullStream
   * @function
   * @public
   * @returns {PullAudioOutputStream} The audio output stream being created.
   */ static createPullStream() {
        return $d7238066c5de7f1c$var$cf.create();
    }
}
class $d7238066c5de7f1c$var$cf extends $d7238066c5de7f1c$var$qR {
    /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member PullAudioOutputStream.create
   * @function
   * @public
   * @returns {PullAudioOutputStream} The push audio output stream being created.
   */ static create() {
        return new $d7238066c5de7f1c$var$pK();
    }
}
class $d7238066c5de7f1c$var$pK extends $d7238066c5de7f1c$var$cf {
    /**
   * Creates and initializes an instance with the given values.
   * @constructor
   */ constructor(){
        super(), this.privId = $d7238066c5de7f1c$var$Rn(), this.privStream = new $d7238066c5de7f1c$var$yQ();
    }
    /**
   * Sets the format information to the stream. For internal use only.
   * @param {AudioStreamFormat} format - the format to be set.
   */ set format(e) {
        e == null && (this.privFormat = $d7238066c5de7f1c$var$Ut.getDefaultOutputFormat()), this.privFormat = e;
    }
    /**
   * Format information for the audio
   */ get format() {
        return this.privFormat;
    }
    /**
   * Checks if the stream is closed
   * @member PullAudioOutputStreamImpl.prototype.isClosed
   * @property
   * @public
   */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
   * Gets the id of the stream
   * @member PullAudioOutputStreamImpl.prototype.id
   * @property
   * @public
   */ id() {
        return this.privId;
    }
    /**
   * Reads audio data from the internal buffer.
   * @member PullAudioOutputStreamImpl.prototype.read
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
   * @returns {Promise<number>} - Audio buffer length has been read.
   */ read(e) {
        return $d7238066c5de7f1c$var$Mme(this, void 0, void 0, function*() {
            const t = new Int8Array(e);
            let i = 0;
            if (this.privLastChunkView !== void 0) {
                if (this.privLastChunkView.length > e.byteLength) return t.set(this.privLastChunkView.slice(0, e.byteLength)), this.privLastChunkView = this.privLastChunkView.slice(e.byteLength), Promise.resolve(e.byteLength);
                t.set(this.privLastChunkView), i = this.privLastChunkView.length, this.privLastChunkView = void 0;
            }
            for(; i < e.byteLength && !this.privStream.isReadEnded;){
                const n = yield this.privStream.read();
                if (n !== void 0 && !n.isEnd) {
                    let s;
                    n.buffer.byteLength > e.byteLength - i ? (s = n.buffer.slice(0, e.byteLength - i), this.privLastChunkView = new Int8Array(n.buffer.slice(e.byteLength - i))) : s = n.buffer, t.set(new Int8Array(s), i), i += s.byteLength;
                } else this.privStream.readEnded();
            }
            return i;
        });
    }
    /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PullAudioOutputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */ write(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privStream, "must set format before writing"), this.privStream.writeStreamChunk({
            buffer: e,
            isEnd: !1,
            timeReceived: Date.now()
        });
    }
    /**
   * Closes the stream.
   * @member PullAudioOutputStreamImpl.prototype.close
   * @function
   * @public
   */ close() {
        this.privStream.close();
    }
}
class $d7238066c5de7f1c$var$mK extends $d7238066c5de7f1c$var$qR {
    /**
   * Creates and initializes and instance.
   * @constructor
   */ constructor(){
        super();
    }
    /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * write() and close() methods.
   * @member PushAudioOutputStream.create
   * @function
   * @public
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   * derived from PushAudioOutputStreamCallback
   * @returns {PushAudioOutputStream} The push audio output stream being created.
   */ static create(e) {
        return new $d7238066c5de7f1c$var$AK(e);
    }
}
class $d7238066c5de7f1c$var$AK extends $d7238066c5de7f1c$var$mK {
    /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * read() and close() methods.
   * @constructor
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   * derived from PushAudioOutputStreamCallback
   */ constructor(e){
        super(), this.privId = $d7238066c5de7f1c$var$Rn(), this.privCallback = e;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(e) {}
    write(e) {
        this.privCallback.write && this.privCallback.write(e);
    }
    close() {
        this.privCallback.close && this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}
class $d7238066c5de7f1c$var$XI {
    /**
   * Creates an AudioConfig object representing the default microphone on the system.
   * @member AudioConfig.fromDefaultMicrophoneInput
   * @function
   * @public
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromDefaultMicrophoneInput() {
        const e = new $d7238066c5de7f1c$var$yX(!0);
        return new $d7238066c5de7f1c$var$jm(new $d7238066c5de7f1c$var$Dl(e));
    }
    /**
   * Creates an AudioConfig object representing a microphone with the specified device ID.
   * @member AudioConfig.fromMicrophoneInput
   * @function
   * @public
   * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
   * Default microphone is used the value is omitted.
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromMicrophoneInput(e) {
        const t = new $d7238066c5de7f1c$var$yX(!0);
        return new $d7238066c5de7f1c$var$jm(new $d7238066c5de7f1c$var$Dl(t, e));
    }
    /**
   * Creates an AudioConfig object representing the specified file.
   * @member AudioConfig.fromWavFileInput
   * @function
   * @public
   * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromWavFileInput(e, t = "unnamedBuffer.wav") {
        return new $d7238066c5de7f1c$var$jm(new $d7238066c5de7f1c$var$Kme(e, t));
    }
    /**
   * Creates an AudioConfig object representing the specified stream.
   * @member AudioConfig.fromStreamInput
   * @function
   * @public
   * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
   * stream. Currently, only WAV / PCM is supported.
   * @returns {AudioConfig} The audio input configuration being created.
   */ static fromStreamInput(e) {
        if (e instanceof $d7238066c5de7f1c$var$vQ) return new $d7238066c5de7f1c$var$jm(new $d7238066c5de7f1c$var$GQ(e));
        if (e instanceof $d7238066c5de7f1c$var$lf) return new $d7238066c5de7f1c$var$jm(e);
        if (typeof MediaStream < "u" && e instanceof MediaStream) {
            const t = new $d7238066c5de7f1c$var$yX(!1);
            return new $d7238066c5de7f1c$var$jm(new $d7238066c5de7f1c$var$Dl(t, null, null, e));
        }
        throw new Error("Not Supported Type");
    }
    /**
   * Creates an AudioConfig object representing the default speaker.
   * @member AudioConfig.fromDefaultSpeakerOutput
   * @function
   * @public
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */ static fromDefaultSpeakerOutput() {
        return new $d7238066c5de7f1c$var$qm(new $d7238066c5de7f1c$var$vN());
    }
    /**
   * Creates an AudioConfig object representing the custom IPlayer object.
   * You can use the IPlayer object to control pause, resume, etc.
   * @member AudioConfig.fromSpeakerOutput
   * @function
   * @public
   * @param {IPlayer} player - the IPlayer object for playback.
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.12.0
   */ static fromSpeakerOutput(e) {
        if (e === void 0) return $d7238066c5de7f1c$var$XI.fromDefaultSpeakerOutput();
        if (e instanceof $d7238066c5de7f1c$var$vN) return new $d7238066c5de7f1c$var$qm(e);
        throw new Error("Not Supported Type");
    }
    /**
   * Creates an AudioConfig object representing a specified output audio file
   * @member AudioConfig.fromAudioFileOutput
   * @function
   * @public
   * @param {PathLike} filename - the filename of the output audio file
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */ static fromAudioFileOutput(e) {
        return new $d7238066c5de7f1c$var$qm(new $d7238066c5de7f1c$var$fQ(e));
    }
    /**
   * Creates an AudioConfig object representing a specified audio output stream
   * @member AudioConfig.fromStreamOutput
   * @function
   * @public
   * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
   * stream.
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */ static fromStreamOutput(e) {
        if (e instanceof $d7238066c5de7f1c$var$bK) return new $d7238066c5de7f1c$var$qm(new $d7238066c5de7f1c$var$AK(e));
        if (e instanceof $d7238066c5de7f1c$var$mK) return new $d7238066c5de7f1c$var$qm(e);
        if (e instanceof $d7238066c5de7f1c$var$cf) return new $d7238066c5de7f1c$var$qm(e);
        throw new Error("Not Supported Type");
    }
}
class $d7238066c5de7f1c$var$jm extends $d7238066c5de7f1c$var$XI {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioSource} source - An audio source.
   */ constructor(e){
        super(), this.privSource = e;
    }
    /**
   * Format information for the audio
   */ get format() {
        return this.privSource.format;
    }
    /**
   * @member AudioConfigImpl.prototype.close
   * @function
   * @public
   */ close(e, t) {
        this.privSource.turnOff().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        });
    }
    /**
   * @member AudioConfigImpl.prototype.id
   * @function
   * @public
   */ id() {
        return this.privSource.id();
    }
    /**
   * @member AudioConfigImpl.prototype.turnOn
   * @function
   * @public
   * @returns {Promise<void>} A promise.
   */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
   * @member AudioConfigImpl.prototype.attach
   * @function
   * @public
   * @param {string} audioNodeId - The audio node id.
   * @returns {Promise<IAudioStreamNode>} A promise.
   */ attach(e) {
        return this.privSource.attach(e);
    }
    /**
   * @member AudioConfigImpl.prototype.detach
   * @function
   * @public
   * @param {string} audioNodeId - The audio node id.
   */ detach(e) {
        return this.privSource.detach(e);
    }
    /**
   * @member AudioConfigImpl.prototype.turnOff
   * @function
   * @public
   * @returns {Promise<void>} A promise.
   */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
   * @member AudioConfigImpl.prototype.events
   * @function
   * @public
   * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
   */ get events() {
        return this.privSource.events;
    }
    setProperty(e, t) {
        if ($d7238066c5de7f1c$var$U.throwIfNull(t, "value"), this.privSource.setProperty !== void 0) this.privSource.setProperty(e, t);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(e, t) {
        if (this.privSource.getProperty !== void 0) return this.privSource.getProperty(e, t);
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
class $d7238066c5de7f1c$var$qm extends $d7238066c5de7f1c$var$XI {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioDestination} destination - An audio destination.
   */ constructor(e){
        super(), this.privDestination = e;
    }
    set format(e) {
        this.privDestination.format = e;
    }
    write(e) {
        this.privDestination.write(e);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}
var $d7238066c5de7f1c$var$Zn;
(function(r) {
    r[r.Error = 0] = "Error", r[r.EndOfStream = 1] = "EndOfStream";
})($d7238066c5de7f1c$var$Zn || ($d7238066c5de7f1c$var$Zn = {}));
class $d7238066c5de7f1c$var$vQ {
}
class $d7238066c5de7f1c$var$bK {
}
class $d7238066c5de7f1c$var$zme {
    /**
   * Create and initializes a new instance.
   * @constructor
   */ constructor(){
        this.privDisposed = !1;
    }
    /**
   * Creates a keyword recognition model using the specified filename.
   * @member KeywordRecognitionModel.fromFile
   * @function
   * @public
   * @param {string} fileName - A string that represents file name for the keyword recognition model.
   * Note, the file can point to a zip file in which case the model
   * will be extracted from the zip.
   * @returns {KeywordRecognitionModel} The keyword recognition model being created.
   */ static fromFile(e) {
        throw $d7238066c5de7f1c$var$U.throwIfFileDoesNotExist(e, "fileName"), new Error("Not yet implemented.");
    }
    /**
   * Creates a keyword recognition model using the specified filename.
   * @member KeywordRecognitionModel.fromStream
   * @function
   * @public
   * @param {string} file - A File that represents file for the keyword recognition model.
   * Note, the file can point to a zip file in which case the model will be extracted from the zip.
   * @returns {KeywordRecognitionModel} The keyword recognition model being created.
   */ static fromStream(e) {
        throw $d7238066c5de7f1c$var$U.throwIfNull(e, "file"), new Error("Not yet implemented.");
    }
    /**
   * Dispose of associated resources.
   * @member KeywordRecognitionModel.prototype.close
   * @function
   * @public
   */ close() {
        this.privDisposed || (this.privDisposed = !0);
    }
}
class $d7238066c5de7f1c$var$zr {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionId - The session id.
   */ constructor(e){
        this.privSessionId = e;
    }
    /**
   * Represents the session identifier.
   * @member SessionEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} Represents the session identifier.
   */ get sessionId() {
        return this.privSessionId;
    }
}
class $d7238066c5de7f1c$var$rc extends $d7238066c5de7f1c$var$zr {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t){
        super(t), this.privOffset = e;
    }
    /**
   * Represents the message offset
   * @member RecognitionEventArgs.prototype.offset
   * @function
   * @public
   */ get offset() {
        return this.privOffset;
    }
}
var $d7238066c5de7f1c$var$bi;
(function(r) {
    r[r.Simple = 0] = "Simple", r[r.Detailed = 1] = "Detailed";
})($d7238066c5de7f1c$var$bi || ($d7238066c5de7f1c$var$bi = {}));
class $d7238066c5de7f1c$var$mA extends $d7238066c5de7f1c$var$rc {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param result - The result of the intent recognition.
   * @param offset - The offset.
   * @param sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Represents the intent recognition result.
   * @member IntentRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {IntentRecognitionResult} Represents the intent recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$$R {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, a, o, g, l, c){
        this.privResultId = e, this.privReason = t, this.privText = i, this.privDuration = n, this.privOffset = s, this.privLanguage = a, this.privLanguageDetectionConfidence = o, this.privErrorDetails = g, this.privJson = l, this.privProperties = c;
    }
    /**
   * Specifies the result identifier.
   * @member RecognitionResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */ get resultId() {
        return this.privResultId;
    }
    /**
   * Specifies status of the result.
   * @member RecognitionResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */ get reason() {
        return this.privReason;
    }
    /**
   * Presents the recognized text in the result.
   * @member RecognitionResult.prototype.text
   * @function
   * @public
   * @returns {string} Presents the recognized text in the result.
   */ get text() {
        return this.privText;
    }
    /**
   * Duration of recognized speech in 100 nano second increments.
   * @member RecognitionResult.prototype.duration
   * @function
   * @public
   * @returns {number} Duration of recognized speech in 100 nano second increments.
   */ get duration() {
        return this.privDuration;
    }
    /**
   * Offset of recognized speech in 100 nano second increments.
   * @member RecognitionResult.prototype.offset
   * @function
   * @public
   * @returns {number} Offset of recognized speech in 100 nano second increments.
   */ get offset() {
        return this.privOffset;
    }
    /**
   * Primary Language detected.
   * @member RecognitionResult.prototype.language
   * @function
   * @public
   * @returns {string} language detected.
   */ get language() {
        return this.privLanguage;
    }
    /**
   * Primary Language detection confidence (Unknown, Low, Medium, High).
   * @member RecognitionResult.prototype.languageDetectionConfidence
   * @function
   * @public
   * @returns {string} detection confidence strength.
   */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member RecognitionResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
   * A string containing Json serialized recognition result as it was received from the service.
   * @member RecognitionResult.prototype.json
   * @function
   * @private
   * @returns {string} Json serialized representation of the result.
   */ get json() {
        return this.privJson;
    }
    /**
   * The set of properties exposed in the result.
   * @member RecognitionResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */ get properties() {
        return this.privProperties;
    }
}
class $d7238066c5de7f1c$var$no extends $d7238066c5de7f1c$var$$R {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @public
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} speakerId - speaker id for conversation transcription, if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, a, o, g, l, c, d){
        super(e, t, i, n, s, a, o, l, c, d), this.privSpeakerId = g;
    }
    /**
   * speaker id from conversation transcription/id scenarios
   * @member SpeechRecognitionResult.prototype.speakerId
   * @function
   * @public
   * @returns {string} id of speaker in given result
   */ get speakerId() {
        return this.privSpeakerId;
    }
}
class $d7238066c5de7f1c$var$gA extends $d7238066c5de7f1c$var$no {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param intentId - The intent id.
   * @param resultId - The result id.
   * @param reason - The reason.
   * @param text - The recognized text.
   * @param duration - The duration.
   * @param offset - The offset into the stream.
   * @param language - Primary Language detected, if provided.
   * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param errorDetails - Error details, if provided.
   * @param json - Additional Json, if provided.
   * @param properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, a, o, g, l, c, d){
        super(t, i, n, s, a, o, g, void 0, l, c, d), this.privIntentId = e;
    }
    /**
   * A String that represents the intent identifier being recognized.
   * @member IntentRecognitionResult.prototype.intentId
   * @function
   * @public
   * @returns {string} A String that represents the intent identifier being recognized.
   */ get intentId() {
        return this.privIntentId;
    }
}
class $d7238066c5de7f1c$var$SQ {
    /**
   * Creates and initializes a new instance
   * @constructor
   */ constructor(){}
    /**
   * Creates an language understanding model using the specified endpoint.
   * @member LanguageUnderstandingModel.fromEndpoint
   * @function
   * @public
   * @param {URL} uri - A String that represents the endpoint of the language understanding model.
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */ static fromEndpoint(e) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "uri"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e.hostname, "uri");
        const t = new $d7238066c5de7f1c$var$BX(), i = e.host.indexOf(".");
        if (i === -1) throw new Error("Could not determine region from endpoint");
        t.region = e.host.substr(0, i);
        const n = e.pathname.lastIndexOf("/") + 1;
        if (n === -1) throw new Error("Could not determine appId from endpoint");
        if (t.appId = e.pathname.substr(n), t.subscriptionKey = e.searchParams.get("subscription-key"), t.subscriptionKey === void 0) throw new Error("Could not determine subscription key from endpoint");
        return t;
    }
    /**
   * Creates an language understanding model using the application id of Language Understanding service.
   * @member LanguageUnderstandingModel.fromAppId
   * @function
   * @public
   * @param {string} appId - A String that represents the application id of Language Understanding service.
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */ static fromAppId(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "appId");
        const t = new $d7238066c5de7f1c$var$BX();
        return t.appId = e, t;
    }
    /**
   * Creates a language understanding model using hostname, subscription key and application
   * id of Language Understanding service.
   * @member LanguageUnderstandingModel.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - A String that represents the subscription key of
   * Language Understanding service.
   * @param {string} appId - A String that represents the application id of Language
   * Understanding service.
   * @param {LanguageUnderstandingModel} region - A String that represents the region
   * of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */ static fromSubscription(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "subscriptionKey"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "appId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i, "region");
        const n = new $d7238066c5de7f1c$var$BX();
        return n.appId = t, n.region = i, n.subscriptionKey = e, n;
    }
}
class $d7238066c5de7f1c$var$BX extends $d7238066c5de7f1c$var$SQ {
}
class $d7238066c5de7f1c$var$fI extends $d7238066c5de7f1c$var$rc {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechRecognitionResult} result - The speech recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the recognition result.
   * @member SpeechRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechRecognitionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$IN extends $d7238066c5de7f1c$var$rc {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ConversationTranscriptionResult} result - The conversation transcription result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the transcription result.
   * @member ConversationTranscription1EventArgs.prototype.result
   * @function
   * @public
   * @returns {ConversationTranscriptionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$kme extends $d7238066c5de7f1c$var$fI {
}
class $d7238066c5de7f1c$var$eV extends $d7238066c5de7f1c$var$rc {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i, n, s){
        super(n, s), this.privReason = e, this.privErrorDetails = t, this.privErrorCode = i;
    }
    /**
   * The reason the recognition was canceled.
   * @member CancellationEventArgsBase.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
    /**
   * The error code in case of an unsuccessful operation.
   * @return An error code that represents the error reason.
   */ get errorCode() {
        return this.privErrorCode;
    }
    /**
   * In case of an unsuccessful operation, provides details of the occurred error.
   * @member CancellationEventArgsBase.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$yK extends $d7238066c5de7f1c$var$eV {
}
class $d7238066c5de7f1c$var$Vy extends $d7238066c5de7f1c$var$rc {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {TranslationRecognitionResult} result - The translation recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the recognition result.
   * @member TranslationRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationRecognitionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$dN extends $d7238066c5de7f1c$var$zr {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {TranslationSynthesisResult} result - The translation synthesis result.
   * @param {string} sessionId - The session id.
   */ constructor(e, t){
        super(t), this.privResult = e;
    }
    /**
   * Specifies the translation synthesis result.
   * @member TranslationSynthesisEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$aI extends $d7238066c5de7f1c$var$no {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {Translations} translations - The translations.
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, a, o, g, l, c, d){
        super(t, i, n, s, a, o, g, void 0, l, c, d), this.privTranslations = e;
    }
    static fromSpeechRecognitionResult(e) {
        return new $d7238066c5de7f1c$var$aI(void 0, e.resultId, e.reason, e.text, e.duration, e.offset, e.language, e.languageDetectionConfidence, e.errorDetails, e.json, e.properties);
    }
    /**
   * Presents the translation results. Each item in the dictionary represents
   * a translation result in one of target languages, where the key is the name
   * of the target language, in BCP-47 format, and the value is the translation
   * text in the specified language.
   * @member TranslationRecognitionResult.prototype.translations
   * @function
   * @public
   * @returns {Translations} the current translation map that holds all translations requested.
   */ get translations() {
        return this.privTranslations;
    }
}
class $d7238066c5de7f1c$var$hN {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ResultReason} reason - The synthesis reason.
   * @param {ArrayBuffer} audio - The audio data.
   */ constructor(e, t){
        this.privReason = e, this.privAudio = t;
    }
    /**
   * Translated text in the target language.
   * @member TranslationSynthesisResult.prototype.audio
   * @function
   * @public
   * @returns {ArrayBuffer} Translated audio in the target language.
   */ get audio() {
        return this.privAudio;
    }
    /**
   * The synthesis status.
   * @member TranslationSynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} The synthesis status.
   */ get reason() {
        return this.privReason;
    }
}
var $d7238066c5de7f1c$var$At;
(function(r) {
    r[r.NoMatch = 0] = "NoMatch", r[r.Canceled = 1] = "Canceled", r[r.RecognizingSpeech = 2] = "RecognizingSpeech", r[r.RecognizedSpeech = 3] = "RecognizedSpeech", r[r.RecognizedKeyword = 4] = "RecognizedKeyword", r[r.RecognizingIntent = 5] = "RecognizingIntent", r[r.RecognizedIntent = 6] = "RecognizedIntent", r[r.TranslatingSpeech = 7] = "TranslatingSpeech", r[r.TranslatedSpeech = 8] = "TranslatedSpeech", r[r.SynthesizingAudio = 9] = "SynthesizingAudio", r[r.SynthesizingAudioCompleted = 10] = "SynthesizingAudioCompleted", r[r.SynthesizingAudioStarted = 11] = "SynthesizingAudioStarted", r[r.EnrollingVoiceProfile = 12] = "EnrollingVoiceProfile", r[r.EnrolledVoiceProfile = 13] = "EnrolledVoiceProfile", r[r.RecognizedSpeakers = 14] = "RecognizedSpeakers", r[r.RecognizedSpeaker = 15] = "RecognizedSpeaker", r[r.ResetVoiceProfile = 16] = "ResetVoiceProfile", r[r.DeletedVoiceProfile = 17] = "DeletedVoiceProfile", r[r.VoicesListRetrieved = 18] = "VoicesListRetrieved", r[r.TranslatingParticipantSpeech = 19] = "TranslatingParticipantSpeech", r[r.TranslatedParticipantSpeech = 20] = "TranslatedParticipantSpeech", r[r.TranslatedInstantMessage = 21] = "TranslatedInstantMessage", r[r.TranslatedParticipantInstantMessage = 22] = "TranslatedParticipantInstantMessage";
})($d7238066c5de7f1c$var$At || ($d7238066c5de7f1c$var$At = {}));
class $d7238066c5de7f1c$var$BK {
    /**
   * Creates and initializes an instance.
   * @constructor
   */ constructor(){}
    /**
   * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
   * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
   * @member SpeechConfig.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - The subscription key.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechConfig} The speech factory
   */ static fromSubscription(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "subscriptionKey"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$eh();
        return i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, t), i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_IntentRegion, t), i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, e), i;
    }
    /**
   * Creates an instance of the speech config with specified endpoint and subscription key.
   * This method is intended only for users who use a non-standard service endpoint or parameters.
   * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
   * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
   * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
   * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
   * and the effective language is "de-DE". Only the parameters that are not specified in the
   * endpoint URL can be set by other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
   * use the authorization token.
   * @member SpeechConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromEndpoint(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "endpoint");
        const i = new $d7238066c5de7f1c$var$eh();
        return i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, e.href), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), i;
    }
    /**
   * Creates an instance of the speech config with specified host and subscription key.
   * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
   * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL),
   * and then set the AuthorizationToken property on the created SpeechConfig instance.
   * Note: Added in version 1.9.0.
   * @member SpeechConfig.fromHost
   * @function
   * @public
   * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromHost(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "hostName");
        const i = new $d7238066c5de7f1c$var$eh();
        return i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, e.protocol + "//" + e.hostname + (e.port === "" ? "" : ":" + e.port)), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), i;
    }
    /**
   * Creates an instance of the speech factory with specified initial authorization token and region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   * expires, the caller needs to refresh it by calling this setter with a new valid token.
   * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
   * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
   * the new token value will not apply to recognizers that have already been created. For recognizers
   * that have been created before, you need to set authorization token of the corresponding recognizer
   * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member SpeechConfig.fromAuthorizationToken
   * @function
   * @public
   * @param {string} authorizationToken - The initial authorization token.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromAuthorizationToken(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "authorizationToken"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$eh();
        return i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, t), i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_IntentRegion, t), i.authorizationToken = e, i;
    }
    /**
   * Closes the configuration.
   * @member SpeechConfig.prototype.close
   * @function
   * @public
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
}
class $d7238066c5de7f1c$var$eh extends $d7238066c5de7f1c$var$BK {
    constructor(){
        super(), this.privProperties = new $d7238066c5de7f1c$var$vi(), this.speechRecognitionLanguage = "en-US", this.outputFormat = $d7238066c5de7f1c$var$bi.Simple;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, e);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages, e);
    }
    get outputFormat() {
        return $d7238066c5de7f1c$var$bi[this.privProperties.getProperty($d7238066c5de7f1c$var$ug, void 0)];
    }
    set outputFormat(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[e]);
    }
    get endpointId() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId);
    }
    set endpointId(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, e);
    }
    setProperty(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(t, "value"), this.privProperties.setProperty(e, t);
    }
    getProperty(e, t) {
        return this.privProperties.getProperty(e, t);
    }
    setProxy(e, t, i, n) {
        this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyHostName], e), this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPort], t), this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyUserName], i), this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPassword], n);
    }
    setServiceProperty(e, t) {
        const i = JSON.parse(this.privProperties.getProperty($d7238066c5de7f1c$var$GI, "{}"));
        i[e] = t, this.privProperties.setProperty($d7238066c5de7f1c$var$GI, JSON.stringify(i));
    }
    setProfanity(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_ProfanityOption, $d7238066c5de7f1c$var$_C[e]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty($d7238066c5de7f1c$var$$K, "true");
    }
    clone() {
        const e = new $d7238066c5de7f1c$var$eh();
        return e.privProperties = this.privProperties.clone(), e;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthLanguage, e);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthVoice, e);
    }
    get speechSynthesisOutputFormat() {
        return $d7238066c5de7f1c$var$$t[this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(e) {
        this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, $d7238066c5de7f1c$var$$t[e]);
    }
}
class $d7238066c5de7f1c$var$fK extends $d7238066c5de7f1c$var$BK {
    /**
   * Creates an instance of recognizer config.
   */ constructor(){
        super();
    }
    /**
   * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
   * @member SpeechTranslationConfig.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - The subscription key.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechTranslationConfig} The speech translation config.
   */ static fromSubscription(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "subscriptionKey"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$wy();
        return i.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, e), i.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, t), i;
    }
    /**
   * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   * expires, the caller needs to refresh it by setting the property authorizationToken with a new
   * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
   * will encounter errors during recognition.
   * As configuration values are copied when creating a new recognizer, the new token value will not apply
   * to recognizers that have already been created.
   * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
   * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member SpeechTranslationConfig.fromAuthorizationToken
   * @function
   * @public
   * @param {string} authorizationToken - The authorization token.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechTranslationConfig} The speech translation config.
   */ static fromAuthorizationToken(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "authorizationToken"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "region");
        const i = new $d7238066c5de7f1c$var$wy();
        return i.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e), i.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, t), i;
    }
    /**
   * Creates an instance of the speech config with specified host and subscription key.
   * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
   * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL),
   * and then set the AuthorizationToken property on the created SpeechConfig instance.
   * Note: Added in version 1.9.0.
   * @member SpeechConfig.fromHost
   * @function
   * @public
   * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */ static fromHost(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "hostName");
        const i = new $d7238066c5de7f1c$var$wy();
        return i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, e.protocol + "//" + e.hostname + (e.port === "" ? "" : ":" + e.port)), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), i;
    }
    /**
   * Creates an instance of the speech translation config with specified endpoint and subscription key.
   * This method is intended only for users who use a non-standard service endpoint or paramters.
   * Note: The query properties specified in the endpoint URL are not changed, even if they are
   * set by any other APIs. For example, if language is defined in the uri as query parameter
   * "language=de-DE", and also set by the speechRecognitionLanguage property, the language
   * setting in uri takes precedence, and the effective language is "de-DE".
   * Only the properties that are not specified in the endpoint URL can be set by other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
   * use the authorization token.
   * @member SpeechTranslationConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key.
   * @returns {SpeechTranslationConfig} A speech config instance.
   */ static fromEndpoint(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "endpoint"), $d7238066c5de7f1c$var$U.throwIfNull(t, "subscriptionKey");
        const i = new $d7238066c5de7f1c$var$wy();
        return i.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, e.href), i.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), i;
    }
}
class $d7238066c5de7f1c$var$wy extends $d7238066c5de7f1c$var$fK {
    constructor(){
        super(), this.privSpeechProperties = new $d7238066c5de7f1c$var$vi(), this.outputFormat = $d7238066c5de7f1c$var$bi.Simple;
    }
    /**
   * Gets/Sets the authorization token.
   * If this is set, subscription key is ignored.
   * User needs to make sure the provided authorization token is valid and not expired.
   * @member SpeechTranslationConfigImpl.prototype.authorizationToken
   * @function
   * @public
   * @param {string} value - The authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Sets the speech recognition language.
   * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @param {string} value - The authorization token.
   */ set speechRecognitionLanguage(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, e);
    }
    /**
   * Gets the speech recognition language.
   * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @return {string} The speechRecognitionLanguage.
   */ get speechRecognitionLanguage() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]);
    }
    /**
   * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
   * @function
   * @public
   */ get subscriptionKey() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_Key]);
    }
    /**
   * Gets the output format
   * @member SpeechTranslationConfigImpl.prototype.outputFormat
   * @function
   * @public
   */ get outputFormat() {
        return $d7238066c5de7f1c$var$bi[this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$ug, void 0)];
    }
    /**
   * Gets/Sets the output format
   * @member SpeechTranslationConfigImpl.prototype.outputFormat
   * @function
   * @public
   */ set outputFormat(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[e]);
    }
    /**
   * Gets the endpoint id.
   * @member SpeechTranslationConfigImpl.prototype.endpointId
   * @function
   * @public
   */ get endpointId() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId);
    }
    /**
   * Gets/Sets the endpoint id.
   * @member SpeechTranslationConfigImpl.prototype.endpointId
   * @function
   * @public
   */ set endpointId(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, e);
    }
    /**
   * Add a (text) target language to translate into.
   * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
   * @function
   * @public
   * @param {string} value - The language such as de-DE
   */ addTargetLanguage(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "value");
        const t = this.targetLanguages;
        t.includes(e) || (t.push(e), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, t.join(",")));
    }
    /**
   * Gets the (text) target language to translate into.
   * @member SpeechTranslationConfigImpl.prototype.targetLanguages
   * @function
   * @public
   * @param {string} value - The language such as de-DE
   */ get targetLanguages() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages).split(",") : [];
    }
    /**
   * Gets the voice name.
   * @member SpeechTranslationConfigImpl.prototype.voiceName
   * @function
   * @public
   */ get voiceName() {
        return this.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice]);
    }
    /**
   * Gets/Sets the voice of the translated language, enable voice synthesis output.
   * @member SpeechTranslationConfigImpl.prototype.voiceName
   * @function
   * @public
   * @param {string} value - The name of the voice.
   */ set voiceName(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice, e);
    }
    /**
   * Provides the region.
   * @member SpeechTranslationConfigImpl.prototype.region
   * @function
   * @public
   * @returns {string} The region.
   */ get region() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region);
    }
    setProxy(e, t, i, n) {
        this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyHostName], e), this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPort], t), this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyUserName], i), this.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPassword], n);
    }
    /**
   * Gets an arbitrary property value.
   * @member SpeechTranslationConfigImpl.prototype.getProperty
   * @function
   * @public
   * @param {string} name - The name of the property.
   * @param {string} def - The default value of the property in case it is not set.
   * @returns {string} The value of the property.
   */ getProperty(e, t) {
        return this.privSpeechProperties.getProperty(e, t);
    }
    /**
   * Gets/Sets an arbitrary property value.
   * @member SpeechTranslationConfigImpl.prototype.setProperty
   * @function
   * @public
   * @param {string | PropertyId} name - The name of the property to set.
   * @param {string} value - The value of the property.
   */ setProperty(e, t) {
        this.privSpeechProperties.setProperty(e, t);
    }
    /**
   * Provides access to custom properties.
   * @member SpeechTranslationConfigImpl.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The properties.
   */ get properties() {
        return this.privSpeechProperties;
    }
    /**
   * Dispose of associated resources.
   * @member SpeechTranslationConfigImpl.prototype.close
   * @function
   * @public
   */ close() {}
    setServiceProperty(e, t) {
        const i = JSON.parse(this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$GI, "{}"));
        i[e] = t, this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$GI, JSON.stringify(i));
    }
    setProfanity(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_ProfanityOption, $d7238066c5de7f1c$var$_C[e]);
    }
    enableAudioLogging() {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$$K, "true");
    }
    get speechSynthesisLanguage() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthLanguage, e);
    }
    get speechSynthesisVoiceName() {
        return this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthVoice, e);
    }
    get speechSynthesisOutputFormat() {
        return $d7238066c5de7f1c$var$$t[this.privSpeechProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(e) {
        this.privSpeechProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, $d7238066c5de7f1c$var$$t[e]);
    }
}
class $d7238066c5de7f1c$var$vi {
    constructor(){
        this.privKeys = [], this.privValues = [];
    }
    /**
   * Returns the property value in type String.
   * Currently only String, int and bool are allowed.
   * If the name is not available, the specified defaultValue is returned.
   * @member PropertyCollection.prototype.getProperty
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string | number | boolean} def - The default value which is returned if the parameter
   * is not available in the collection.
   * @returns {string} value of the parameter.
   */ getProperty(e, t) {
        let i;
        typeof e == "string" ? i = e : i = $d7238066c5de7f1c$var$T[e];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === i) return this.privValues[n];
        if (t !== void 0) return String(t);
    }
    /**
   * Sets the String value of the parameter specified by name.
   * @member PropertyCollection.prototype.setProperty
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} value - The value of the parameter.
   */ setProperty(e, t) {
        let i;
        typeof e == "string" ? i = e : i = $d7238066c5de7f1c$var$T[e];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === i) {
            this.privValues[n] = t;
            return;
        }
        this.privKeys.push(i), this.privValues.push(t);
    }
    /**
   * Clones the collection.
   * @member PropertyCollection.prototype.clone
   * @function
   * @public
   * @returns {PropertyCollection} A copy of the collection.
   */ clone() {
        const e = new $d7238066c5de7f1c$var$vi();
        for(let t = 0; t < this.privKeys.length; t++)e.privKeys.push(this.privKeys[t]), e.privValues.push(this.privValues[t]);
        return e;
    }
    /**
   * Merges this set of properties into another, no overwrites.
   * @member PropertyCollection.prototype.mergeTo
   * @function
   * @public
   * @param {PropertyCollection}  destinationCollection - The collection to merge into.
   */ mergeTo(e) {
        this.privKeys.forEach((t)=>{
            if (e.getProperty(t, void 0) === void 0) {
                const i = this.getProperty(t);
                e.setProperty(t, i);
            }
        });
    }
    /**
   * Get the keys in Property Collection.
   * @member PropertyCollection.prototype.keys
   * @function
   * @public
   * @returns {string []} Keys in the collection.
   */ get keys() {
        return this.privKeys;
    }
}
var $d7238066c5de7f1c$var$T;
(function(r) {
    r[r.SpeechServiceConnection_Key = 0] = "SpeechServiceConnection_Key", r[r.SpeechServiceConnection_Endpoint = 1] = "SpeechServiceConnection_Endpoint", r[r.SpeechServiceConnection_Region = 2] = "SpeechServiceConnection_Region", r[r.SpeechServiceAuthorization_Token = 3] = "SpeechServiceAuthorization_Token", r[r.SpeechServiceAuthorization_Type = 4] = "SpeechServiceAuthorization_Type", r[r.SpeechServiceConnection_EndpointId = 5] = "SpeechServiceConnection_EndpointId", r[r.SpeechServiceConnection_TranslationToLanguages = 6] = "SpeechServiceConnection_TranslationToLanguages", r[r.SpeechServiceConnection_TranslationVoice = 7] = "SpeechServiceConnection_TranslationVoice", r[r.SpeechServiceConnection_TranslationFeatures = 8] = "SpeechServiceConnection_TranslationFeatures", r[r.SpeechServiceConnection_IntentRegion = 9] = "SpeechServiceConnection_IntentRegion", r[r.SpeechServiceConnection_ProxyHostName = 10] = "SpeechServiceConnection_ProxyHostName", r[r.SpeechServiceConnection_ProxyPort = 11] = "SpeechServiceConnection_ProxyPort", r[r.SpeechServiceConnection_ProxyUserName = 12] = "SpeechServiceConnection_ProxyUserName", r[r.SpeechServiceConnection_ProxyPassword = 13] = "SpeechServiceConnection_ProxyPassword", r[r.SpeechServiceConnection_RecoMode = 14] = "SpeechServiceConnection_RecoMode", r[r.SpeechServiceConnection_RecoLanguage = 15] = "SpeechServiceConnection_RecoLanguage", r[r.Speech_SessionId = 16] = "Speech_SessionId", r[r.SpeechServiceConnection_SynthLanguage = 17] = "SpeechServiceConnection_SynthLanguage", r[r.SpeechServiceConnection_SynthVoice = 18] = "SpeechServiceConnection_SynthVoice", r[r.SpeechServiceConnection_SynthOutputFormat = 19] = "SpeechServiceConnection_SynthOutputFormat", r[r.SpeechServiceConnection_AutoDetectSourceLanguages = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages", r[r.SpeechServiceResponse_RequestDetailedResultTrueFalse = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse", r[r.SpeechServiceResponse_RequestProfanityFilterTrueFalse = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse", r[r.SpeechServiceResponse_JsonResult = 23] = "SpeechServiceResponse_JsonResult", r[r.SpeechServiceResponse_JsonErrorDetails = 24] = "SpeechServiceResponse_JsonErrorDetails", r[r.CancellationDetails_Reason = 25] = "CancellationDetails_Reason", r[r.CancellationDetails_ReasonText = 26] = "CancellationDetails_ReasonText", r[r.CancellationDetails_ReasonDetailedText = 27] = "CancellationDetails_ReasonDetailedText", r[r.LanguageUnderstandingServiceResponse_JsonResult = 28] = "LanguageUnderstandingServiceResponse_JsonResult", r[r.SpeechServiceConnection_Url = 29] = "SpeechServiceConnection_Url", r[r.SpeechServiceConnection_InitialSilenceTimeoutMs = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs", r[r.SpeechServiceConnection_EndSilenceTimeoutMs = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs", r[r.Speech_SegmentationSilenceTimeoutMs = 32] = "Speech_SegmentationSilenceTimeoutMs", r[r.SpeechServiceConnection_EnableAudioLogging = 33] = "SpeechServiceConnection_EnableAudioLogging", r[r.SpeechServiceConnection_LanguageIdMode = 34] = "SpeechServiceConnection_LanguageIdMode", r[r.SpeechServiceConnection_RecognitionEndpointVersion = 35] = "SpeechServiceConnection_RecognitionEndpointVersion", r[r.SpeechServiceConnection_SpeakerIdMode = 36] = "SpeechServiceConnection_SpeakerIdMode", r[r.SpeechServiceResponse_ProfanityOption = 37] = "SpeechServiceResponse_ProfanityOption", r[r.SpeechServiceResponse_PostProcessingOption = 38] = "SpeechServiceResponse_PostProcessingOption", r[r.SpeechServiceResponse_RequestWordLevelTimestamps = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps", r[r.SpeechServiceResponse_StablePartialResultThreshold = 40] = "SpeechServiceResponse_StablePartialResultThreshold", r[r.SpeechServiceResponse_OutputFormatOption = 41] = "SpeechServiceResponse_OutputFormatOption", r[r.SpeechServiceResponse_TranslationRequestStablePartialResult = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult", r[r.SpeechServiceResponse_RequestWordBoundary = 43] = "SpeechServiceResponse_RequestWordBoundary", r[r.SpeechServiceResponse_RequestPunctuationBoundary = 44] = "SpeechServiceResponse_RequestPunctuationBoundary", r[r.SpeechServiceResponse_RequestSentenceBoundary = 45] = "SpeechServiceResponse_RequestSentenceBoundary", r[r.Conversation_ApplicationId = 46] = "Conversation_ApplicationId", r[r.Conversation_DialogType = 47] = "Conversation_DialogType", r[r.Conversation_Initial_Silence_Timeout = 48] = "Conversation_Initial_Silence_Timeout", r[r.Conversation_From_Id = 49] = "Conversation_From_Id", r[r.Conversation_Conversation_Id = 50] = "Conversation_Conversation_Id", r[r.Conversation_Custom_Voice_Deployment_Ids = 51] = "Conversation_Custom_Voice_Deployment_Ids", r[r.Conversation_Speech_Activity_Template = 52] = "Conversation_Speech_Activity_Template", r[r.Conversation_Request_Bot_Status_Messages = 53] = "Conversation_Request_Bot_Status_Messages", r[r.Conversation_Agent_Connection_Id = 54] = "Conversation_Agent_Connection_Id", r[r.SpeechServiceConnection_Host = 55] = "SpeechServiceConnection_Host", r[r.ConversationTranslator_Host = 56] = "ConversationTranslator_Host", r[r.ConversationTranslator_Name = 57] = "ConversationTranslator_Name", r[r.ConversationTranslator_CorrelationId = 58] = "ConversationTranslator_CorrelationId", r[r.ConversationTranslator_Token = 59] = "ConversationTranslator_Token", r[r.PronunciationAssessment_ReferenceText = 60] = "PronunciationAssessment_ReferenceText", r[r.PronunciationAssessment_GradingSystem = 61] = "PronunciationAssessment_GradingSystem", r[r.PronunciationAssessment_Granularity = 62] = "PronunciationAssessment_Granularity", r[r.PronunciationAssessment_EnableMiscue = 63] = "PronunciationAssessment_EnableMiscue", r[r.PronunciationAssessment_Json = 64] = "PronunciationAssessment_Json", r[r.PronunciationAssessment_Params = 65] = "PronunciationAssessment_Params", r[r.SpeakerRecognition_Api_Version = 66] = "SpeakerRecognition_Api_Version", r[r.WebWorkerLoadType = 67] = "WebWorkerLoadType", r[r.TalkingAvatarService_WebRTC_SDP = 68] = "TalkingAvatarService_WebRTC_SDP";
})($d7238066c5de7f1c$var$T || ($d7238066c5de7f1c$var$T = {}));
var $d7238066c5de7f1c$var$uy = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$gl {
    /**
   * Creates and initializes an instance of a Recognizer
   * @constructor
   * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
   * @param {PropertyCollection} properties - A set of properties to set on the recognizer
   * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
   */ constructor(e, t, i){
        this.audioConfig = e !== void 0 ? e : $d7238066c5de7f1c$var$XI.fromDefaultMicrophoneInput(), this.privDisposed = !1, this.privProperties = t.clone(), this.privConnectionFactory = i, this.implCommonRecognizerSetup();
    }
    /**
   * Dispose of associated resources.
   * @member Recognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    /**
   * @Internal
   * Internal data member to support fromRecognizer* pattern methods on other classes.
   * Do not use externally, object returned will change without warning or notice.
   */ get internalData() {
        return this.privReco;
    }
    /**
   * This method performs cleanup of resources.
   * The Boolean parameter disposing indicates whether the method is called
   * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
   * Derived classes should override this method to dispose resource if needed.
   * @member Recognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - Flag to request disposal.
   */ dispose(e) {
        return $d7238066c5de7f1c$var$uy(this, void 0, void 0, function*() {
            this.privDisposed || (this.privDisposed = !0, e && this.privReco && (yield this.privReco.audioSource.turnOff(), yield this.privReco.dispose()));
        });
    }
    /**
   * This method returns the current state of the telemetry setting.
   * @member Recognizer.prototype.telemetryEnabled
   * @function
   * @public
   * @returns true if the telemetry is enabled, false otherwise.
   */ static get telemetryEnabled() {
        return $d7238066c5de7f1c$var$ha.telemetryDataEnabled;
    }
    /**
   * This method globally enables or disables telemetry.
   * @member Recognizer.prototype.enableTelemetry
   * @function
   * @public
   * @param enabled - Global setting for telemetry collection.
   * If set to true, telemetry information like microphone errors,
   * recognition errors are collected and sent to Microsoft.
   * If set to false, no telemetry is sent to Microsoft.
   */ static enableTelemetry(e) {
        $d7238066c5de7f1c$var$ha.telemetryDataEnabled = e;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let e = typeof window < "u" ? "Browser" : "Node", t = "unknown", i = "unknown";
        typeof navigator < "u" && (e = e + "/" + navigator.platform, t = navigator.userAgent, i = navigator.appVersion);
        const n = this.createRecognizerConfig(new $d7238066c5de7f1c$var$rV(new $d7238066c5de7f1c$var$aV(new $d7238066c5de7f1c$var$e4(e, t, i))));
        this.privReco = this.createServiceRecognizer($d7238066c5de7f1c$var$gl.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, n);
    }
    recognizeOnceAsyncImpl(e) {
        return $d7238066c5de7f1c$var$uy(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed);
            const t = new $d7238066c5de7f1c$var$Ui();
            yield this.implRecognizerStop(), yield this.privReco.recognize(e, t.resolve, t.reject);
            const i = yield t.promise;
            return yield this.implRecognizerStop(), i;
        });
    }
    startContinuousRecognitionAsyncImpl(e) {
        return $d7238066c5de7f1c$var$uy(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop(), yield this.privReco.recognize(e, void 0, void 0);
        });
    }
    stopContinuousRecognitionAsyncImpl() {
        return $d7238066c5de7f1c$var$uy(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop();
        });
    }
    implRecognizerStop() {
        return $d7238066c5de7f1c$var$uy(this, void 0, void 0, function*() {
            this.privReco && (yield this.privReco.stopRecognizing());
        });
    }
    static getAuthFromProperties(e) {
        const t = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, void 0);
        return t && t !== "" ? new $d7238066c5de7f1c$var$BQ(t) : new $d7238066c5de7f1c$var$UC(()=>{
            const n = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(n);
        }, ()=>{
            const n = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(n);
        });
    }
}
var $d7238066c5de7f1c$var$Eme = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$GK extends $d7238066c5de7f1c$var$gl {
    /**
   * SpeechRecognizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNull(i, "speechConfig"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]), super(t, i.properties, new $d7238066c5de7f1c$var$SAe()), this.privDisposedRecognizer = !1;
    }
    /**
   * SpeechRecognizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$GK(e, i);
    }
    /**
   * Gets the endpoint id of a customized speech model that is used for speech recognition.
   * @member SpeechRecognizer.prototype.endpointId
   * @function
   * @public
   * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
   */ get endpointId() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member SpeechRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member SpeechRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Gets the spoken language of recognition.
   * @member SpeechRecognizer.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} The spoken language of recognition.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets the output format of recognition.
   * @member SpeechRecognizer.prototype.outputFormat
   * @function
   * @public
   * @returns {OutputFormat} The output format of recognition.
   */ get outputFormat() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]) === $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple] ? $d7238066c5de7f1c$var$bi.Simple : $d7238066c5de7f1c$var$bi.Detailed;
    }
    /**
   * The collection of properties and their values defined for this SpeechRecognizer.
   * @member SpeechRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Starts speech recognition, and stops after the first utterance is recognized.
   * The task returns the recognition text as result.
   * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
   * so it is suitable only for single shot recognition
   * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
   * @member SpeechRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the SpeechRecognitionResult.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.recognizeOnceAsyncImpl($d7238066c5de7f1c$var$cr.Interactive), e, t);
    }
    /**
   * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$cr.Conversation), e, t);
    }
    /**
   * Stops continuous speech recognition.
   * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * Starts speech recognition with keyword spotting, until
   * stopKeywordRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * Note: Key word spotting functionality is only available on the
   * Speech Devices SDK. This functionality is currently not included in the SDK itself.
   * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
   * @function
   * @public
   * @param {KeywordRecognitionModel} model The keyword recognition model that
   * specifies the keyword to be recognized.
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startKeywordRecognitionAsync(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "model"), i && i("Not yet implemented.");
    }
    /**
   * Stops continuous speech recognition.
   * Note: Key word spotting functionality is only available on the
   * Speech Devices SDK. This functionality is currently not included in the SDK itself.
   * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopKeywordRecognitionAsync(e) {
        e && e();
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member SpeechRecognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    /**
   * Disposes any resources held by the object.
   * @member SpeechRecognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$Eme(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$wAe(e, t, s, n, this);
    }
}
var $d7238066c5de7f1c$var$Jme = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Ume extends $d7238066c5de7f1c$var$gl {
    /**
   * Initializes an instance of the IntentRecognizer.
   * @constructor
   * @param {SpeechConfig} speechConfig - The set of configuration properties.
   * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
   */ constructor(e, t){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "speechConfig");
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(i, "speechConfig"), super(t, i.properties, new $d7238066c5de7f1c$var$yAe()), this.privAddedIntents = [], this.privAddedLmIntents = {}, this.privDisposedIntentRecognizer = !1, this.privProperties = i.properties, $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]);
    }
    /**
   * Gets the spoken language of recognition.
   * @member IntentRecognizer.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} the spoken language of recognition.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedIntentRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member IntentRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
   * @member IntentRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} value - Authorization token.
   */ set authorizationToken(e) {
        this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this IntentRecognizer.
   * @member IntentRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their
   * values defined for this IntentRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Starts intent recognition, and stops after the first utterance is recognized.
   * The task returns the recognition text and intent as result.
   * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
   * so it is suitable only for single shot recognition like command or query.
   * For long-running recognition, use StartContinuousRecognitionAsync() instead.
   * @member IntentRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e, t) {
        if ($d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedIntentRecognizer), Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
            const i = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", i.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(i.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $d7238066c5de7f1c$var$ri(this.recognizeOnceAsyncImpl($d7238066c5de7f1c$var$cr.Interactive), e, t);
    }
    /**
   * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startContinuousRecognitionAsync(e, t) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
            const i = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", i.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(i.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $d7238066c5de7f1c$var$ri(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$cr.Conversation), e, t);
    }
    /**
   * Stops continuous intent recognition.
   * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
   * User must subscribe to events to receive recognition results.
   * Note: Key word spotting functionality is only available on the Speech Devices SDK.
   * This functionality is currently not included in the SDK itself.
   * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
   * @function
   * @public
   * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
   * @param cb - Callback invoked once the recognition has started.
   * @param err - Callback invoked in case of an error.
   */ startKeywordRecognitionAsync(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "model"), i && i("Not yet implemented.");
    }
    /**
   * Stops continuous speech recognition.
   * Note: Key word spotting functionality is only available on the Speech Devices SDK.
   * This functionality is currently not included in the SDK itself.
   * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
   * @function
   * @public
   * @param cb - Callback invoked once the recognition has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopKeywordRecognitionAsync(e, t) {
        if (e) try {
            e();
        } catch (i) {
            t && t(i);
        }
    }
    /**
   * Adds a phrase that should be recognized as intent.
   * @member IntentRecognizer.prototype.addIntent
   * @function
   * @public
   * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
   * @param {string} phrase - A String that specifies the phrase representing the intent.
   */ addIntent(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedIntentRecognizer), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "intentId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "simplePhrase"), this.privAddedIntents.push([
            t,
            e
        ]);
    }
    /**
   * Adds an intent from Language Understanding service for recognition.
   * @member IntentRecognizer.prototype.addIntentWithLanguageModel
   * @function
   * @public
   * @param {string} intentId - A String that represents the identifier of the intent
   * to be recognized. Ignored if intentName is empty.
   * @param {string} model - The intent model from Language Understanding service.
   * @param {string} intentName - The intent name defined in the intent model. If it
   * is empty, all intent names defined in the model will be added.
   */ addIntentWithLanguageModel(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedIntentRecognizer), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "intentId"), $d7238066c5de7f1c$var$U.throwIfNull(t, "model");
        const n = t;
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(n.appId, "model.appId"), this.privAddedLmIntents[e] = new $d7238066c5de7f1c$var$vM(n, i);
    }
    /**
   * @summary Adds all intents from the specified Language Understanding Model.
   * @member IntentRecognizer.prototype.addAllIntents
   * @function
   * @public
   * @function
   * @public
   * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
   * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
   */ addAllIntents(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "model");
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i.appId, "model.appId"), this.privUmbrellaIntent = new $d7238066c5de7f1c$var$vM(i, t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member IntentRecognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedIntentRecognizer), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$NAe(e, t, s, n, this);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$Jme(this, void 0, void 0, function*() {
            this.privDisposedIntentRecognizer || e && (this.privDisposedIntentRecognizer = !0, yield t.dispose.call(this, e));
        });
    }
    buildSpeechContext() {
        let e, t, i;
        const n = [];
        this.privUmbrellaIntent !== void 0 && (e = this.privUmbrellaIntent.modelImpl.appId, t = this.privUmbrellaIntent.modelImpl.region, i = this.privUmbrellaIntent.modelImpl.subscriptionKey);
        for (const s of Object.keys(this.privAddedLmIntents)){
            const a = this.privAddedLmIntents[s];
            if (e === void 0) e = a.modelImpl.appId;
            else if (e !== a.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
            if (t === void 0) t = a.modelImpl.region;
            else if (t !== a.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
            if (i === void 0) i = a.modelImpl.subscriptionKey;
            else if (i !== a.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
            const o = "luis/" + e + "-PRODUCTION#" + s;
            n.push(o);
        }
        return {
            Intent: {
                id: e,
                key: i === void 0 ? this.privProperties.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_Key]) : i,
                provider: "LUIS"
            },
            ReferenceGrammars: this.privUmbrellaIntent === void 0 ? n : [
                "luis/" + e + "-PRODUCTION"
            ]
        };
    }
}
var $d7238066c5de7f1c$var$iu;
(function(r) {
    r[r.TextIndependentIdentification = 0] = "TextIndependentIdentification", r[r.TextDependentVerification = 1] = "TextDependentVerification", r[r.TextIndependentVerification = 2] = "TextIndependentVerification";
})($d7238066c5de7f1c$var$iu || ($d7238066c5de7f1c$var$iu = {}));
class $d7238066c5de7f1c$var$Dme {
}
class $d7238066c5de7f1c$var$dM {
    constructor(e){
        this.privConnectionMessage = e, this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privConnectionMessage.headers[$d7238066c5de7f1c$var$Fi.ConnectionId] && this.privProperties.setProperty($d7238066c5de7f1c$var$T.Speech_SessionId, this.privConnectionMessage.headers[$d7238066c5de7f1c$var$Fi.ConnectionId]), Object.keys(this.privConnectionMessage.headers).forEach((t)=>{
            this.privProperties.setProperty(t, this.privConnectionMessage.headers[t]);
        });
    }
    /**
   * The message path.
   */ get path() {
        return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((e)=>e.toLowerCase() === "path".toLowerCase())];
    }
    /**
   * Checks to see if the ConnectionMessage is a text message.
   * See also IsBinaryMessage().
   */ get isTextMessage() {
        return this.privConnectionMessage.messageType === $d7238066c5de7f1c$var$Tt.Text;
    }
    /**
   * Checks to see if the ConnectionMessage is a binary message.
   * See also GetBinaryMessage().
   */ get isBinaryMessage() {
        return this.privConnectionMessage.messageType === $d7238066c5de7f1c$var$Tt.Binary;
    }
    /**
   * Gets the text message payload. Typically the text message content-type is
   * application/json. To determine other content-types use
   * Properties.GetProperty("Content-Type").
   */ get TextMessage() {
        return this.privConnectionMessage.textBody;
    }
    /**
   * Gets the binary message payload.
   */ get binaryMessage() {
        return this.privConnectionMessage.binaryBody;
    }
    /**
   * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
   * Message headers can be accessed via this collection (e.g. "Content-Type").
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Returns a string that represents the connection message.
   */ toString() {
        return "";
    }
}
class $d7238066c5de7f1c$var$DC {
    /**
   * Gets the Connection instance from the specified recognizer.
   * @param recognizer The recognizer associated with the connection.
   * @return The Connection instance of the recognizer.
   */ static fromRecognizer(e) {
        const t = e.internalData, i = new $d7238066c5de7f1c$var$DC();
        return i.privInternalData = t, i.setupEvents(), i;
    }
    /**
   * Gets the Connection instance from the specified synthesizer.
   * @param synthesizer The synthesizer associated with the connection.
   * @return The Connection instance of the synthesizer.
   */ static fromSynthesizer(e) {
        const t = e.internalData, i = new $d7238066c5de7f1c$var$DC();
        return i.privInternalData = t, i.setupEvents(), i;
    }
    /**
   * Starts to set up connection to the service.
   * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
   * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
   *
   * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
   * be notified when the connection is established.
   */ openConnection(e, t) {
        $d7238066c5de7f1c$var$ri(this.privInternalData.connect(), e, t);
    }
    /**
   * Closes the connection the service.
   * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
   *
   * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
   */ closeConnection(e, t) {
        if (this.privInternalData instanceof $d7238066c5de7f1c$var$YB) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        $d7238066c5de7f1c$var$ri(this.privInternalData.disconnect(), e, t);
    }
    /**
   * Appends a parameter in a message to service.
   * Added in version 1.12.1.
   * @param path The path of the network message.
   * @param propertyName Name of the property
   * @param propertyValue Value of the property. This is a json string.
   */ setMessageProperty(e, t, i) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "propertyName"), this.privInternalData instanceof $d7238066c5de7f1c$var$ha) {
            if (e.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            this.privInternalData.speechContext.setSection(t, i);
        } else if (this.privInternalData instanceof $d7238066c5de7f1c$var$YB) {
            if (e.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
            this.privInternalData.synthesisContext.setSection(t, i);
        }
    }
    /**
   * Sends a message to the speech service.
   * Added in version 1.13.0.
   * @param path The WebSocket path of the message
   * @param payload The payload of the message. This is a json string or a ArrayBuffer.
   * @param success A callback to indicate success.
   * @param error A callback to indicate an error.
   */ sendMessageAsync(e, t, i, n) {
        $d7238066c5de7f1c$var$ri(this.privInternalData.sendNetworkMessage(e, t), i, n);
    }
    /**
   * Dispose of associated resources.
   */ close() {}
    setupEvents() {
        this.privEventListener = this.privInternalData.connectionEvents.attach((e)=>{
            e.name === "ConnectionEstablishedEvent" ? this.connected && this.connected(new $d7238066c5de7f1c$var$pN(e.connectionId)) : e.name === "ConnectionClosedEvent" ? this.disconnected && this.disconnected(new $d7238066c5de7f1c$var$pN(e.connectionId)) : e.name === "ConnectionMessageSentEvent" ? this.messageSent && this.messageSent(new $d7238066c5de7f1c$var$mN(new $d7238066c5de7f1c$var$dM(e.message))) : e.name === "ConnectionMessageReceivedEvent" && this.messageReceived && this.messageReceived(new $d7238066c5de7f1c$var$mN(new $d7238066c5de7f1c$var$dM(e.message)));
        }), this.privServiceEventListener = this.privInternalData.serviceEvents.attach((e)=>{
            this.receivedServiceMessage && this.receivedServiceMessage(new $d7238066c5de7f1c$var$RQ(e.jsonString, e.name));
        });
    }
}
var $d7238066c5de7f1c$var$_me = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$tV extends $d7238066c5de7f1c$var$gl {
    /**
   * Initializes an instance of the TranslationRecognizer.
   * @constructor
   * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
   * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
   * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
   */ constructor(e, t, i){
        const n = e;
        $d7238066c5de7f1c$var$U.throwIfNull(n, "speechConfig"), super(t, n.properties, i || new $d7238066c5de7f1c$var$OQ()), this.privDisposedTranslationRecognizer = !1, this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice), $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice]), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages), $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages]), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]);
    }
    /**
   * TranslationRecognizer constructor.
   * @constructor
   * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$tV(e, i);
    }
    /**
   * Gets the language name that was set when the recognizer was created.
   * @member TranslationRecognizer.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} Gets the language name that was set when the recognizer was created.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets target languages for translation that were set when the recognizer was created.
   * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
   * @member TranslationRecognizer.prototype.targetLanguages
   * @function
   * @public
   * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
   */ get targetLanguages() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    /**
   * Gets the name of output voice.
   * @member TranslationRecognizer.prototype.voiceName
   * @function
   * @public
   * @returns {string} the name of output voice.
   */ get voiceName() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice, void 0);
    }
    /**
   * The collection of properties and their values defined for this TranslationRecognizer.
   * @member TranslationRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member TranslationRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member TranslationRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} value - Authorization token.
   */ set authorizationToken(e) {
        this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Starts recognition and translation, and stops after the first utterance is recognized.
   * The task returns the translation text as result.
   * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
   * for single shot recognition like command or query. For long-running recognition,
   * use startContinuousRecognitionAsync() instead.
   * @member TranslationRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the result when the translation has completed.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedTranslationRecognizer), $d7238066c5de7f1c$var$ri(this.recognizeOnceAsyncImpl($d7238066c5de7f1c$var$cr.Interactive), e, t);
    }
    /**
   * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
   * User must subscribe to events to receive translation results.
   * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback that received the translation has started.
   * @param err - Callback invoked in case of an error.
   */ startContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$cr.Conversation), e, t);
    }
    /**
   * Stops continuous recognition and translation.
   * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
   * @function
   * @public
   * @param cb - Callback that received the translation has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * dynamically remove a language from list of target language
   * (can be used while recognition is ongoing)
   * @member TranslationRecognizer.prototype.removeTargetLanguage
   * @function
   * @param lang - language to be removed
   * @public
   */ removeTargetLanguage(e) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "language to be removed"), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0) {
            const t = this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages).split(","), i = t.indexOf(e);
            i > -1 && (t.splice(i, 1), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, t.join(",")), this.updateLanguages(t));
        }
    }
    /**
   * dynamically add a language to list of target language
   * (can be used while recognition is ongoing)
   * @member TranslationRecognizer.prototype.addTargetLanguage
   * @function
   * @param lang - language to be added
   * @public
   */ addTargetLanguage(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "language to be added");
        let t = [];
        this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? (t = this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages).split(","), t.includes(e) || (t.push(e), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, t.join(",")))) : (this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, e), t = [
            e
        ]), this.updateLanguages(t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member TranslationRecognizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedTranslationRecognizer), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    /**
   * handles ConnectionEstablishedEvent for conversation translation scenarios.
   * @member TranslationRecognizer.prototype.onConnection
   * @function
   * @public
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    onConnection() {}
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$_me(this, void 0, void 0, function*() {
            this.privDisposedTranslationRecognizer || (this.privDisposedTranslationRecognizer = !0, e && (yield this.implRecognizerStop(), yield t.dispose.call(this, e)));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$RAe(e, t, s, n, this);
    }
    updateLanguages(e) {
        const t = $d7238066c5de7f1c$var$DC.fromRecognizer(this);
        t && (t.setMessageProperty("speech.context", "translationcontext", {
            to: e
        }), t.sendMessageAsync("event", JSON.stringify({
            id: "translation",
            name: "updateLanguage",
            to: e
        })));
    }
}
class $d7238066c5de7f1c$var$vK {
    constructor(){
        this.privMap = new $d7238066c5de7f1c$var$vi();
    }
    /**
   * Get the languages in the object in a String array.
   * @member Translations.prototype.languages
   * @function
   * @public
   * @returns {string[]} languages in translations object.
   */ get languages() {
        return this.privMap.keys;
    }
    /**
   * Returns the parameter value in type String. The parameter must have the same type as String.
   * Currently only String, int and bool are allowed.
   * If the name is not available, the specified defaultValue is returned.
   * @member Translations.prototype.get
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} def - The default value which is returned if the parameter is not available in the collection.
   * @returns {string} value of the parameter.
   */ get(e, t) {
        return this.privMap.getProperty(e, t);
    }
    /**
   * Sets the String value of the parameter specified by name.
   * @member Translations.prototype.set
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} value - The value of the parameter.
   */ set(e, t) {
        this.privMap.setProperty(e, t);
    }
}
var $d7238066c5de7f1c$var$LC;
(function(r) {
    r[r.NotRecognized = 0] = "NotRecognized", r[r.InitialSilenceTimeout = 1] = "InitialSilenceTimeout", r[r.InitialBabbleTimeout = 2] = "InitialBabbleTimeout";
})($d7238066c5de7f1c$var$LC || ($d7238066c5de7f1c$var$LC = {}));
class $d7238066c5de7f1c$var$SK {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {NoMatchReason} reason - The no-match reason.
   */ constructor(e){
        this.privReason = e;
    }
    /**
   * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
   * @member NoMatchDetails.fromResult
   * @function
   * @public
   * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
   * result - The recognition result that was not recognized.
   * @returns {NoMatchDetails} The no match details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$YI.fromJSON(e.json);
        let i = $d7238066c5de7f1c$var$LC.NotRecognized;
        switch(t.RecognitionStatus){
            case $d7238066c5de7f1c$var$ki.BabbleTimeout:
                i = $d7238066c5de7f1c$var$LC.InitialBabbleTimeout;
                break;
            case $d7238066c5de7f1c$var$ki.InitialSilenceTimeout:
                i = $d7238066c5de7f1c$var$LC.InitialSilenceTimeout;
                break;
            default:
                i = $d7238066c5de7f1c$var$LC.NotRecognized;
                break;
        }
        return new $d7238066c5de7f1c$var$SK(i);
    }
    /**
   * The reason the recognition was canceled.
   * @member NoMatchDetails.prototype.reason
   * @function
   * @public
   * @returns {NoMatchReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
}
class $d7238066c5de7f1c$var$CN {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionid - The session id.
   * @param {CancellationReason} cancellationReason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {TranslationRecognitionResult} result - The result.
   */ constructor(e, t, i, n, s){
        this.privCancelReason = t, this.privErrorDetails = i, this.privResult = s, this.privSessionId = e, this.privErrorCode = n;
    }
    /**
   * Specifies the recognition result.
   * @member TranslationRecognitionCanceledEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationRecognitionResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
    /**
   * Specifies the session identifier.
   * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} the session identifier.
   */ get sessionId() {
        return this.privSessionId;
    }
    /**
   * The reason the recognition was canceled.
   * @member TranslationRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privCancelReason;
    }
    /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */ get errorCode() {
        return this.privErrorCode;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$ZQ extends $d7238066c5de7f1c$var$mA {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} result - The result of the intent recognition.
   * @param {string} offset - The offset.
   * @param {IntentRecognitionResult} sessionId - The session id.
   */ constructor(e, t, i, n, s, a){
        super(n, s, a), this.privReason = e, this.privErrorDetails = t, this.privErrorCode = i;
    }
    /**
   * The reason the recognition was canceled.
   * @member IntentRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
    /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */ get errorCode() {
        return this.privErrorCode;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$uf {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - The error details, if provided.
   */ constructor(e, t, i){
        this.privReason = e, this.privErrorDetails = t, this.privErrorCode = i;
    }
    /**
   * The reason the recognition was canceled.
   * @member CancellationDetailsBase.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */ get reason() {
        return this.privReason;
    }
    /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member CancellationDetailsBase.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */ get ErrorCode() {
        return this.privErrorCode;
    }
}
class $d7238066c5de7f1c$var$ZK extends $d7238066c5de7f1c$var$uf {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
   * @member CancellationDetails.fromResult
   * @function
   * @public
   * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
   * @returns {CancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        let t = $d7238066c5de7f1c$var$Zn.Error, i = $d7238066c5de7f1c$var$vt.NoError;
        if (e instanceof $d7238066c5de7f1c$var$$R && e.json) {
            const n = $d7238066c5de7f1c$var$YI.fromJSON(e.json);
            t = $d7238066c5de7f1c$var$gr.implTranslateCancelResult(n.RecognitionStatus);
        }
        return e.properties && (i = $d7238066c5de7f1c$var$vt[e.properties.getProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[$d7238066c5de7f1c$var$vt.NoError])]), new $d7238066c5de7f1c$var$ZK(t, e.errorDetails || $d7238066c5de7f1c$var$gr.implTranslateErrorDetails(i), i);
    }
}
var $d7238066c5de7f1c$var$vt;
(function(r) {
    r[r.NoError = 0] = "NoError", r[r.AuthenticationFailure = 1] = "AuthenticationFailure", r[r.BadRequestParameters = 2] = "BadRequestParameters", r[r.TooManyRequests = 3] = "TooManyRequests", r[r.ConnectionFailure = 4] = "ConnectionFailure", r[r.ServiceTimeout = 5] = "ServiceTimeout", r[r.ServiceError = 6] = "ServiceError", r[r.RuntimeError = 7] = "RuntimeError", r[r.Forbidden = 8] = "Forbidden";
})($d7238066c5de7f1c$var$vt || ($d7238066c5de7f1c$var$vt = {}));
class $d7238066c5de7f1c$var$pN extends $d7238066c5de7f1c$var$zr {
}
class $d7238066c5de7f1c$var$RQ extends $d7238066c5de7f1c$var$zr {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} json - json payload of the USP message.
   */ constructor(e, t, i){
        super(i), this.privJsonResult = e, this.privEventName = t;
    }
    get jsonString() {
        return this.privJsonResult;
    }
    get eventName() {
        return this.privEventName;
    }
}
class $d7238066c5de7f1c$var$RK {
    constructor(e){
        this.privGrammerBuilder = e.dynamicGrammar;
    }
    /**
   * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
   * @param recognizer The recognizer to add phrase lists to.
   */ static fromRecognizer(e) {
        const t = e.internalData;
        return new $d7238066c5de7f1c$var$RK(t);
    }
    /**
   * Adds a single phrase to the current recognizer.
   * @param phrase Phrase to add.
   */ addPhrase(e) {
        this.privGrammerBuilder.addPhrase(e);
    }
    /**
   * Adds multiple phrases to the current recognizer.
   * @param phrases Array of phrases to add.
   */ addPhrases(e) {
        this.privGrammerBuilder.addPhrase(e);
    }
    /**
   * Clears all phrases added to the current recognizer.
   */ clear() {
        this.privGrammerBuilder.clearPhrases();
    }
}
class $d7238066c5de7f1c$var$ag {
    /**
   * Creates an instance of DialogService config.
   * @constructor
   */ constructor(){}
    /**
   * Sets the corresponding backend application identifier.
   * @member DialogServiceConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to set.
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(e) {}
    static get DialogTypes() {
        return {
            BotFramework: "bot_framework",
            CustomCommands: "custom_commands"
        };
    }
}
class $d7238066c5de7f1c$var$Od extends $d7238066c5de7f1c$var$ag {
    /**
   * Creates an instance of dialogService config.
   */ constructor(){
        super(), this.privSpeechConfig = new $d7238066c5de7f1c$var$eh();
    }
    /**
   * Provides access to custom properties.
   * @member DialogServiceConfigImpl.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The properties.
   */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
   * Gets the speech recognition language.
   * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
   * Sets the speech recognition language.
   * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @param {string} value - The language to set.
   */ set speechRecognitionLanguage(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "value"), this.privSpeechConfig.speechRecognitionLanguage = e;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(e) {
        this.privSpeechConfig.outputFormat = e;
    }
    /**
   * Sets a named property as value
   * @member DialogServiceConfigImpl.prototype.setProperty
   * @function
   * @public
   * @param {PropertyId | string} name - The property to set.
   * @param {string} value - The value.
   */ setProperty(e, t) {
        this.privSpeechConfig.setProperty(e, t);
    }
    /**
   * Sets a named property as value
   * @member DialogServiceConfigImpl.prototype.getProperty
   * @function
   * @public
   * @param {PropertyId | string} name - The property to get.
   * @param {string} def - The default value to return in case the property is not known.
   * @returns {string} The current value, or provided default, of the given property.
   */ getProperty(e, t) {
        return this.privSpeechConfig.getProperty(e);
    }
    /**
   * Sets the proxy configuration.
   * Only relevant in Node.js environments.
   * Added in version 1.4.0.
   * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
   * @param proxyPort The port number of the proxy server.
   * @param proxyUserName The user name of the proxy server.
   * @param proxyPassword The password of the proxy server.
   */ setProxy(e, t, i, n) {
        this.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyHostName, e), this.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPort, `${t}`), i && this.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyUserName, i), n && this.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPassword, n);
    }
    setServiceProperty(e, t, i) {
        this.privSpeechConfig.setServiceProperty(e, t);
    }
    /**
   * Dispose of associated resources.
   * @member DialogServiceConfigImpl.prototype.close
   * @function
   * @public
   */ close() {}
}
class $d7238066c5de7f1c$var$Pme extends $d7238066c5de7f1c$var$Od {
    /**
   * Creates an instance of BotFrameworkConfig.
   */ constructor(){
        super();
    }
    /**
   * Creates a bot framework configuration instance with the provided subscription information.
   * @member BotFrameworkConfig.fromSubscription
   * @function
   * @public
   * @param subscription Subscription key associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   * resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */ static fromSubscription(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "subscription"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "region");
        const n = new $d7238066c5de7f1c$var$Od();
        return n.setProperty($d7238066c5de7f1c$var$T.Conversation_DialogType, $d7238066c5de7f1c$var$ag.DialogTypes.BotFramework), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, e), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, t), i && n.setProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId, i), n;
    }
    /**
   * Creates a bot framework configuration instance for the specified authorization token and region.
   * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
   * caller must refresh it by setting the authorizationToken property on the corresponding
   * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
   * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
   * original configuration's authorization token. Create a new configuration instance or set the
   * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
   * further DialogServiceConnectors.
   * @member BotFrameworkConfig.fromAuthorizationToken
   * @function
   * @public
   * @param authorizationToken The authorization token associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   * resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */ static fromAuthorizationToken(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "authorizationToken"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "region");
        const n = new $d7238066c5de7f1c$var$Od();
        return n.setProperty($d7238066c5de7f1c$var$T.Conversation_DialogType, $d7238066c5de7f1c$var$ag.DialogTypes.BotFramework), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, t), i && n.setProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId, i), n;
    }
    /**
   * Creates an instance of a BotFrameworkConfig.
   * This method is intended only for users who use a non-default service host. The standard resource path will be
   * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
   * property on the created BotFrameworkConfig instance.
   * Note: Added in version 1.15.0.
   * @member BotFrameworkConfig.fromHost
   * @function
   * @public
   * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
   * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
   * wss://{host}.convai.speech.azure.us.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
   * token must be set.
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   * resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */ static fromHost(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "host");
        const n = e instanceof URL ? e : new URL(`wss://${e}.convai.speech.azure.us`);
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(n, "resolvedHost");
        const s = new $d7238066c5de7f1c$var$Od();
        return s.setProperty($d7238066c5de7f1c$var$T.Conversation_DialogType, $d7238066c5de7f1c$var$ag.DialogTypes.BotFramework), s.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, n.toString()), t !== void 0 && s.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), s;
    }
    /**
   * Creates an instance of a BotFrameworkConfig.
   * This method is intended only for users who use a non-standard service endpoint or parameters.
   * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
   * use the authorization token.
   * Note: Added in version 1.15.0.
   * @member BotFrameworkConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
   * token must be set.
   * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
   */ static fromEndpoint(e, t) {
        $d7238066c5de7f1c$var$U.throwIfNull(e, "endpoint");
        const i = new $d7238066c5de7f1c$var$Od();
        return i.setProperty($d7238066c5de7f1c$var$T.Conversation_DialogType, $d7238066c5de7f1c$var$ag.DialogTypes.BotFramework), i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, e.toString()), t !== void 0 && i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), i;
    }
}
class $d7238066c5de7f1c$var$Qme extends $d7238066c5de7f1c$var$Od {
    /**
   * Creates an instance of CustomCommandsConfig.
   */ constructor(){
        super();
    }
    /**
   * Creates an instance of the bot framework config with the specified subscription and region.
   * @member CustomCommandsConfig.fromSubscription
   * @function
   * @public
   * @param applicationId Speech Commands application id.
   * @param subscription Subscription key associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {CustomCommandsConfig} A new bot framework config.
   */ static fromSubscription(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "applicationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "subscription"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i, "region");
        const n = new $d7238066c5de7f1c$var$Od();
        return n.setProperty($d7238066c5de7f1c$var$T.Conversation_DialogType, $d7238066c5de7f1c$var$ag.DialogTypes.CustomCommands), n.setProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId, e), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, t), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, i), n;
    }
    /**
   * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   * expires, the caller needs to refresh it by calling this setter with a new valid token.
   * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
   * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
   * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member CustomCommandsConfig.fromAuthorizationToken
   * @function
   * @public
   * @param applicationId Speech Commands application id.
   * @param authorizationToken The authorization token associated with the application.
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {CustomCommandsConfig} A new speech commands config.
   */ static fromAuthorizationToken(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "applicationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, "authorizationToken"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i, "region");
        const n = new $d7238066c5de7f1c$var$Od();
        return n.setProperty($d7238066c5de7f1c$var$T.Conversation_DialogType, $d7238066c5de7f1c$var$ag.DialogTypes.CustomCommands), n.setProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId, e), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, t), n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, i), n;
    }
    /**
   * Sets the corresponding backend application identifier.
   * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to set.
   */ set applicationId(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "value"), this.setProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId, e);
    }
    /**
   * Gets the corresponding backend application identifier.
   * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to get.
   */ get applicationId() {
        return this.getProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId);
    }
}
class $d7238066c5de7f1c$var$dt {
}
$d7238066c5de7f1c$var$dt.BotId = "botid";
$d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId = "cid";
$d7238066c5de7f1c$var$dt.CustomVoiceDeploymentId = "deploymentId";
$d7238066c5de7f1c$var$dt.EnableAudioLogging = "storeAudio";
$d7238066c5de7f1c$var$dt.EnableLanguageId = "lidEnabled";
$d7238066c5de7f1c$var$dt.EnableWordLevelTimestamps = "wordLevelTimestamps";
$d7238066c5de7f1c$var$dt.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$d7238066c5de7f1c$var$dt.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
$d7238066c5de7f1c$var$dt.Format = "format";
$d7238066c5de7f1c$var$dt.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$d7238066c5de7f1c$var$dt.Language = "language";
$d7238066c5de7f1c$var$dt.Profanity = "profanity";
$d7238066c5de7f1c$var$dt.RequestBotStatusMessages = "enableBotMessageStatus";
$d7238066c5de7f1c$var$dt.StableIntermediateThreshold = "stableIntermediateThreshold";
$d7238066c5de7f1c$var$dt.StableTranslation = "stableTranslation";
$d7238066c5de7f1c$var$dt.TestHooks = "testhooks";
$d7238066c5de7f1c$var$dt.Postprocessing = "postprocessing";
$d7238066c5de7f1c$var$dt.CtsMeetingId = "meetingId";
$d7238066c5de7f1c$var$dt.CtsDeviceId = "deviceId";
$d7238066c5de7f1c$var$dt.CtsIsParticipant = "isParticipant";
$d7238066c5de7f1c$var$dt.EnableAvatar = "enableTalkingAvatar";
class $d7238066c5de7f1c$var$Rr {
    static getHostSuffix(e) {
        if (e) {
            if (e.toLowerCase().startsWith("china")) return ".azure.cn";
            if (e.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    }
    setCommonUrlParams(e, t, i) {
        /* @__PURE__ */ new Map([
            [
                $d7238066c5de7f1c$var$T.Speech_SegmentationSilenceTimeoutMs,
                $d7238066c5de7f1c$var$dt.SegmentationSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceConnection_EnableAudioLogging,
                $d7238066c5de7f1c$var$dt.EnableAudioLogging
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceConnection_EndSilenceTimeoutMs,
                $d7238066c5de7f1c$var$dt.EndSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $d7238066c5de7f1c$var$dt.InitialSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_PostProcessingOption,
                $d7238066c5de7f1c$var$dt.Postprocessing
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_ProfanityOption,
                $d7238066c5de7f1c$var$dt.Profanity
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordLevelTimestamps,
                $d7238066c5de7f1c$var$dt.EnableWordLevelTimestamps
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_StablePartialResultThreshold,
                $d7238066c5de7f1c$var$dt.StableIntermediateThreshold
            ]
        ]).forEach((a, o)=>{
            this.setUrlParameter(o, a, e, t, i);
        });
        const s = JSON.parse(e.parameters.getProperty($d7238066c5de7f1c$var$GI, "{}"));
        Object.keys(s).forEach((a)=>{
            t[a] = s[a];
        });
    }
    setUrlParameter(e, t, i, n, s) {
        const a = i.parameters.getProperty(e, void 0);
        a && (!s || s.search(t) === -1) && (n[t] = a.toLocaleLowerCase());
    }
}
class $d7238066c5de7f1c$var$QA extends $d7238066c5de7f1c$var$Rr {
    create(e, t, i) {
        const n = e.parameters.getProperty($d7238066c5de7f1c$var$T.Conversation_ApplicationId, ""), s = e.parameters.getProperty($d7238066c5de7f1c$var$T.Conversation_DialogType), a = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region), o = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, "en-US"), g = e.parameters.getProperty($d7238066c5de7f1c$var$T.Conversation_Request_Bot_Status_Messages, "true"), l = {};
        l[$d7238066c5de7f1c$var$Fi.ConnectionId] = i, l[$d7238066c5de7f1c$var$dt.Format] = e.parameters.getProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]).toLowerCase(), l[$d7238066c5de7f1c$var$dt.Language] = o, l[$d7238066c5de7f1c$var$dt.RequestBotStatusMessages] = g, n && (l[$d7238066c5de7f1c$var$dt.BotId] = n, s === $d7238066c5de7f1c$var$ag.DialogTypes.CustomCommands && (l[$d7238066c5de7f1c$var$Fi.CustomCommandsAppId] = n));
        const c = s === $d7238066c5de7f1c$var$ag.DialogTypes.CustomCommands ? "commands/" : "", d = s === $d7238066c5de7f1c$var$ag.DialogTypes.CustomCommands ? "v1" : s === $d7238066c5de7f1c$var$ag.DialogTypes.BotFramework ? "v3" : "v0", p = {};
        t.token != null && t.token !== "" && (p[t.headerName] = t.token);
        let A = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, "");
        if (!A) {
            const G = $d7238066c5de7f1c$var$Rr.getHostSuffix(a), Z = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, `wss://${a}.${$d7238066c5de7f1c$var$QA.BaseUrl}${G}`);
            A = `${Z.endsWith("/") ? Z : Z + "/"}${c}${$d7238066c5de7f1c$var$QA.ApiKey}/${d}`;
        }
        this.setCommonUrlParams(e, l, A);
        const y = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(A, l, p, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), y, i);
    }
}
$d7238066c5de7f1c$var$QA.ApiKey = "api";
$d7238066c5de7f1c$var$QA.BaseUrl = "convai.speech";
var $d7238066c5de7f1c$var$hM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$Ome extends $d7238066c5de7f1c$var$gl {
    /**
   * Initializes an instance of the DialogServiceConnector.
   * @constructor
   * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
   * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNull(e, "dialogConfig"), super(t, i.properties, new $d7238066c5de7f1c$var$QA()), this.isTurnComplete = !0, this.privIsDisposed = !1, this.privProperties = i.properties.clone();
        const n = this.buildAgentConfig();
        this.privReco.agentConfig.set(n);
    }
    /**
   * Starts a connection to the service.
   * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
   *
   * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
   * be notified when the connection is established.
   * @member DialogServiceConnector.prototype.connect
   * @function
   * @public
   */ connect(e, t) {
        $d7238066c5de7f1c$var$ri(this.privReco.connect(), e, t);
    }
    /**
   * Closes the connection the service.
   * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
   *
   * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
   */ disconnect(e, t) {
        $d7238066c5de7f1c$var$ri(this.privReco.disconnect(), e, t);
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member DialogServiceConnector.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Sets the authorization token used to communicate with the service.
   * @member DialogServiceConnector.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this DialogServiceConnector.
   * @member DialogServiceConnector.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
   */ get properties() {
        return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
   * Properties from the template will be stamped on the generated activity.
   * It can be empty
   */ get speechActivityTemplate() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
   * Properties from the template will be stamped on the generated activity.
   * It can be null or empty.
   * Note: it has to be a valid Json object.
   */ set speechActivityTemplate(e) {
        this.properties.setProperty($d7238066c5de7f1c$var$T.Conversation_Speech_Activity_Template, e);
    }
    /**
   * Starts recognition and stops after the first utterance is recognized.
   * @member DialogServiceConnector.prototype.listenOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the result when the reco has completed.
   * @param err - Callback invoked in case of an error.
   */ listenOnceAsync(e, t) {
        if (this.isTurnComplete) {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed);
            const n = $d7238066c5de7f1c$var$hM(this, void 0, void 0, function*() {
                yield this.privReco.connect(), yield this.implRecognizerStop(), this.isTurnComplete = !1;
                const s = new $d7238066c5de7f1c$var$Ui();
                yield this.privReco.recognize($d7238066c5de7f1c$var$cr.Conversation, s.resolve, s.reject);
                const a = yield s.promise;
                return yield this.implRecognizerStop(), a;
            });
            n.catch(()=>{
                this.dispose(!0).catch(()=>{});
            }), $d7238066c5de7f1c$var$ri(n.finally(()=>{
                this.isTurnComplete = !0;
            }), e, t);
        }
    }
    sendActivityAsync(e, t, i) {
        $d7238066c5de7f1c$var$ri(this.privReco.sendMessage(e), t, i);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member DialogServiceConnector.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$hM(this, void 0, void 0, function*() {
            this.privIsDisposed || e && (this.privIsDisposed = !0, yield this.implRecognizerStop(), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$MAe(e, t, s, n, this);
    }
    buildAgentConfig() {
        return {
            botInfo: {
                commType: this.properties.getProperty("Conversation_Communication_Type", "Default"),
                commandsCulture: void 0,
                connectionId: this.properties.getProperty($d7238066c5de7f1c$var$T.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($d7238066c5de7f1c$var$T.Conversation_Conversation_Id, void 0),
                fromId: this.properties.getProperty($d7238066c5de7f1c$var$T.Conversation_From_Id, void 0),
                ttsAudioFormat: this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, void 0)
            },
            version: 0.2
        };
    }
}
class $d7238066c5de7f1c$var$VQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {any} activity - The activity..
   */ constructor(e, t){
        this.privActivity = e, this.privAudioStream = t;
    }
    /**
   * Gets the received activity
   * @member ActivityReceivedEventArgs.prototype.activity
   * @function
   * @public
   * @returns {any} the received activity.
   */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
}
class $d7238066c5de7f1c$var$VK {
    constructor(e){
        this.privMessageStatusResponse = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$VK(e);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                return this.privMessageStatusResponse.statusCode;
        }
    }
}
class $d7238066c5de7f1c$var$wQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} turnStatus - The JSON-encoded turn status message.
   */ constructor(e){
        this.privTurnStatus = $d7238066c5de7f1c$var$VK.fromJSON(e);
    }
    /**
   * Gets the interaction identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.interactionId
   * @function
   * @public
   * @returns {any} the received interaction id.
   */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
   * Gets the conversation identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.conversationId
   * @function
   * @public
   * @returns {any} the received conversation id.
   */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
   * Gets the received turn status code.
   * @member TurnStatusReceivedEventArgs.prototype.statusCode
   * @function
   * @public
   * @returns {number} the received turn status.
   */ get statusCode() {
        return this.privTurnStatus.statusCode;
    }
}
var $d7238066c5de7f1c$var$UZ;
(function(r) {
    r[r.UriQueryParameter = 0] = "UriQueryParameter";
})($d7238066c5de7f1c$var$UZ || ($d7238066c5de7f1c$var$UZ = {}));
var $d7238066c5de7f1c$var$_C;
(function(r) {
    r[r.Masked = 0] = "Masked", r[r.Removed = 1] = "Removed", r[r.Raw = 2] = "Raw";
})($d7238066c5de7f1c$var$_C || ($d7238066c5de7f1c$var$_C = {}));
var $d7238066c5de7f1c$var$jme = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$qme {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
   */ constructor(e){
        this.audioContext = null, this.gainNode = null, this.autoUpdateBufferTimer = 0, e === void 0 && (e = $d7238066c5de7f1c$var$c0.getDefaultInputFormat()), this.init(e);
    }
    /**
   * play Audio sample
   * @param newAudioData audio data to be played.
   */ playAudioSample(e, t, i) {
        try {
            this.ensureInitializedContext();
            const n = this.formatAudioData(e), s = new Float32Array(this.samples.length + n.length);
            s.set(this.samples, 0), s.set(n, this.samples.length), this.samples = s, t && t();
        } catch (n) {
            i && i(n);
        }
    }
    /**
   * stops audio and clears the buffers
   */ stopAudio(e, t) {
        this.audioContext !== null && (this.samples = new Float32Array(), clearInterval(this.autoUpdateBufferTimer), this.audioContext.close().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        }), this.audioContext = null);
    }
    init(e) {
        this.audioFormat = e, this.samples = new Float32Array();
    }
    ensureInitializedContext() {
        if (this.audioContext === null) {
            this.createAudioContext();
            const e = 200;
            this.autoUpdateBufferTimer = setInterval(()=>{
                this.updateAudioBuffer();
            }, e);
        }
    }
    createAudioContext() {
        this.audioContext = $d7238066c5de7f1c$var$BI.getAudioContext(), this.gainNode = this.audioContext.createGain(), this.gainNode.gain.value = 1, this.gainNode.connect(this.audioContext.destination), this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(e) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(e), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(e), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(e), 2147483648);
            default:
                throw new $d7238066c5de7f1c$var$io("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    }
    formatArrayBuffer(e, t) {
        const i = new Float32Array(e.length);
        for(let n = 0; n < e.length; n++)i[n] = e[n] / t;
        return i;
    }
    updateAudioBuffer() {
        if (this.samples.length === 0) return;
        const e = this.audioFormat.channels, t = this.audioContext.createBufferSource(), i = this.samples.length / e, n = this.audioContext.createBuffer(e, i, this.audioFormat.samplesPerSec);
        for(let s = 0; s < e; s++){
            let a = s;
            const o = n.getChannelData(s);
            for(let g = 0; g < this.samples.length; g++, a += e)o[g] = this.samples[a];
        }
        this.startTime < this.audioContext.currentTime && (this.startTime = this.audioContext.currentTime), t.buffer = n, t.connect(this.gainNode), t.start(this.startTime), this.startTime += n.duration, this.samples = new Float32Array();
    }
    playAudio(e) {
        return $d7238066c5de7f1c$var$jme(this, void 0, void 0, function*() {
            this.audioContext === null && this.createAudioContext();
            const t = this.audioContext.createBufferSource(), i = this.audioContext.destination;
            yield this.audioContext.decodeAudioData(e, (n)=>{
                t.buffer = n, t.connect(i), t.start(0);
            });
        });
    }
}
class $d7238066c5de7f1c$var$mN {
    constructor(e){
        this.privConnectionMessage = e;
    }
    /**
   * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
   */ get message() {
        return this.privConnectionMessage;
    }
    /**
   * Returns a string that represents the connection message event.
   */ toString() {
        return "Message: " + this.privConnectionMessage.toString();
    }
}
class $d7238066c5de7f1c$var$WQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} profileId - profileId of this Voice Profile.
   * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
   */ constructor(e, t){
        this.privId = e, this.privProfileType = t;
    }
    /**
   * profileId of this Voice Profile instance
   * @member VoiceProfile.prototype.profileId
   * @function
   * @public
   * @returns {string} profileId of this Voice Profile instance.
   */ get profileId() {
        return this.privId;
    }
    /**
   * profileType of this Voice Profile instance
   * @member VoiceProfile.prototype.profileType
   * @function
   * @public
   * @returns {VoiceProfileType} profile type of this Voice Profile instance.
   */ get profileType() {
        return this.privProfileType;
    }
}
class $d7238066c5de7f1c$var$th {
    constructor(e, t, i){
        this.privReason = e, this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privReason !== $d7238066c5de7f1c$var$At.Canceled ? t && (this.privDetails = JSON.parse(t), this.privDetails.enrollmentStatus.toLowerCase() === "enrolling" && (this.privReason = $d7238066c5de7f1c$var$At.EnrollingVoiceProfile)) : (this.privErrorDetails = i, this.privProperties.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[$d7238066c5de7f1c$var$vt.ServiceError]));
    }
    get reason() {
        return this.privReason;
    }
    get enrollmentsCount() {
        return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
        return this.privDetails.enrollmentsLength;
    }
    get properties() {
        return this.privProperties;
    }
    get enrollmentResultDetails() {
        return this.privDetails;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    static FromIdentificationProfileList(e) {
        const t = [];
        for (const i of e.value){
            const n = i.enrollmentStatus.toLowerCase() === "enrolling" ? $d7238066c5de7f1c$var$At.EnrollingVoiceProfile : i.enrollmentStatus.toLowerCase() === "enrolled" ? $d7238066c5de7f1c$var$At.EnrolledVoiceProfile : $d7238066c5de7f1c$var$At.Canceled, s = new $d7238066c5de7f1c$var$th(n, null, null);
            s.privDetails = this.getIdentificationDetails(i), t.push(s);
        }
        return t;
    }
    static FromVerificationProfileList(e) {
        const t = [];
        for (const i of e.value){
            const n = i.enrollmentStatus.toLowerCase() === "enrolling" ? $d7238066c5de7f1c$var$At.EnrollingVoiceProfile : i.enrollmentStatus.toLowerCase() === "enrolled" ? $d7238066c5de7f1c$var$At.EnrolledVoiceProfile : $d7238066c5de7f1c$var$At.Canceled, s = new $d7238066c5de7f1c$var$th(n, null, null);
            s.privDetails = this.getVerificationDetails(i), t.push(s);
        }
        return t;
    }
    static getIdentificationDetails(e) {
        return {
            audioLength: e.audioLength ? parseFloat(e.audioLength) : 0,
            audioSpeechLength: e.audioSpeechLength ? parseFloat(e.audioSpeechLength) : 0,
            enrollmentStatus: e.enrollmentStatus,
            enrollmentsCount: e.enrollmentsCount || 0,
            enrollmentsLength: e.enrollmentsLength ? parseFloat(e.enrollmentsLength) : 0,
            enrollmentsSpeechLength: e.enrollmentsSpeechLength ? parseFloat(e.enrollmentsSpeechLength) : 0,
            profileId: e.profileId || e.identificationProfileId,
            remainingEnrollmentsSpeechLength: e.remainingEnrollmentsSpeechLength ? parseFloat(e.remainingEnrollmentsSpeechLength) : 0
        };
    }
    static getVerificationDetails(e) {
        return {
            audioLength: e.audioLength ? parseFloat(e.audioLength) : 0,
            audioSpeechLength: e.audioSpeechLength ? parseFloat(e.audioSpeechLength) : 0,
            enrollmentStatus: e.enrollmentStatus,
            enrollmentsCount: e.enrollmentsCount,
            enrollmentsLength: e.enrollmentsLength ? parseFloat(e.enrollmentsLength) : 0,
            enrollmentsSpeechLength: e.enrollmentsSpeechLength ? parseFloat(e.enrollmentsSpeechLength) : 0,
            profileId: e.profileId || e.verificationProfileId,
            remainingEnrollmentsCount: e.remainingEnrollments || e.remainingEnrollmentsCount,
            remainingEnrollmentsSpeechLength: e.remainingEnrollmentsSpeechLength ? parseFloat(e.remainingEnrollmentsSpeechLength) : 0
        };
    }
}
class $d7238066c5de7f1c$var$wK extends $d7238066c5de7f1c$var$uf {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
   * @member VoiceProfileEnrollmentCancellationDetails.fromResult
   * @function
   * @public
   * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
   * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$Zn.Error;
        let i = $d7238066c5de7f1c$var$vt.NoError;
        return e.properties && (i = $d7238066c5de7f1c$var$vt[e.properties.getProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[$d7238066c5de7f1c$var$vt.NoError])]), new $d7238066c5de7f1c$var$wK(t, e.errorDetails, i);
    }
}
class $d7238066c5de7f1c$var$iV {
    constructor(e, t){
        this.privReason = e, this.privProperties = new $d7238066c5de7f1c$var$vi(), e === $d7238066c5de7f1c$var$At.Canceled && ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(t, "statusText"), this.privErrorDetails = t, this.privProperties.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[$d7238066c5de7f1c$var$vt.ServiceError]));
    }
    get reason() {
        return this.privReason;
    }
    get properties() {
        return this.privProperties;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d7238066c5de7f1c$var$WK extends $d7238066c5de7f1c$var$uf {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
   * @member VoiceProfileCancellationDetails.fromResult
   * @function
   * @public
   * @param {VoiceProfileResult} result - The result that was canceled.
   * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$Zn.Error;
        let i = $d7238066c5de7f1c$var$vt.NoError;
        return e.properties && (i = $d7238066c5de7f1c$var$vt[e.properties.getProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[$d7238066c5de7f1c$var$vt.NoError])]), new $d7238066c5de7f1c$var$WK(t, e.errorDetails, i);
    }
}
class $d7238066c5de7f1c$var$AN extends $d7238066c5de7f1c$var$iV {
    constructor(e, t, i, n){
        super(e, t), this.privPhrases = [], $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(n, "phrase array"), this.privType = i, n && n[0] && (this.privPhrases = n);
    }
    get phrases() {
        return this.privPhrases;
    }
    get type() {
        return this.privType;
    }
}
var $d7238066c5de7f1c$var$eI = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$$me extends $d7238066c5de7f1c$var$gl {
    /**
   * VoiceProfileClient constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
   */ constructor(e){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "speechConfig");
        const t = e;
        $d7238066c5de7f1c$var$U.throwIfNull(t, "speechConfig"), super($d7238066c5de7f1c$var$XI.fromStreamInput($d7238066c5de7f1c$var$lf.createPushStream()), t.properties, new $d7238066c5de7f1c$var$fAe()), this.privProperties = t.properties.clone(), this.privVoiceAdapter = this.privReco, this.privDisposedVoiceAdapter = !1;
    }
    /**
   * The collection of properties and their values defined for this VoiceProfileClient.
   * @member VoiceProfileClient.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member VoiceProfileClient.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member VoiceProfileClient.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Create a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.createProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfileType} profileType Type of Voice Profile to be created
   * @param {string} lang Language string (locale) for Voice Profile
   * @return {Promise<VoiceProfile>} - Promise of a VoiceProfile.
   */ createProfileAsync(e, t) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            const i = yield this.privVoiceAdapter.createProfile(e, t);
            return new $d7238066c5de7f1c$var$WQ(i[0], e);
        });
    }
    /**
   * Get current information of a voice profile
   * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to retrieve info for
   * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
   */ retrieveEnrollmentResultAsync(e) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.retrieveEnrollmentResult(e);
        });
    }
    /**
   * Get all voice profiles on account with given voice profile type
   * @member VoiceProfileClient.prototype.getAllProfilesAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
   * @return {Promise<VoiceProfileEnrollmentResult[]>} - Promise of an array of VoiceProfileEnrollmentResults.
   */ getAllProfilesAsync(e) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.getAllProfiles(e);
        });
    }
    /**
   * Get valid authorization phrases for voice profile enrollment
   * @member VoiceProfileClient.prototype.getActivationPhrasesAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfileType} profileType Profile Type to get activation phrases for
   * @param {string} lang Language string (locale) for Voice Profile
   */ getActivationPhrasesAsync(e, t) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.getActivationPhrases(e, t);
        });
    }
    /**
   * Create a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.enrollProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to create enrollment for
   * @param {AudioConfig} audioConfig source info from which to create enrollment
   * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
   */ enrollProfileAsync(e, t) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            const i = t;
            return $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(i, "audioConfig"), this.audioConfig = t, this.privVoiceAdapter.SpeakerAudioSource = i, this.privVoiceAdapter.enrollProfile(e);
        });
    }
    /**
   * Delete a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.deleteProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to be deleted
   * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
   */ deleteProfileAsync(e) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.deleteProfile(e);
        });
    }
    /**
   * Remove all enrollments for a speaker recognition voice profile
   * @member VoiceProfileClient.prototype.resetProfileAsync
   * @function
   * @public
   * @async
   * @param {VoiceProfile} profile Voice Profile to be reset
   * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
   */ resetProfileAsync(e) {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            return this.privVoiceAdapter.resetProfile(e);
        });
    }
    /**
   * Clean up object and close underlying connection
   * @member VoiceProfileClient.prototype.close
   * @function
   * @async
   * @public
   */ close() {
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            yield this.dispose(!0);
        });
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$I0e(e, t, s, n, this);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$eI(this, void 0, void 0, function*() {
            this.privDisposedVoiceAdapter || (this.privDisposedVoiceAdapter = !0, e && (yield t.dispose.call(this, e)));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.properties);
    }
    getResult(e, t) {
        return new $d7238066c5de7f1c$var$iV(e.ok ? t : $d7238066c5de7f1c$var$At.Canceled, e.statusText);
    }
}
var $d7238066c5de7f1c$var$Iy = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$eAe extends $d7238066c5de7f1c$var$gl {
    /**
   * Initializes an instance of the SpeakerRecognizer.
   * @constructor
   * @param {SpeechConfig} speechConfig - The set of configuration properties.
   * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
   */ constructor(e, t){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "speechConfig");
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(i, "speechConfig"), super(t, i.properties, new $d7238066c5de7f1c$var$BAe()), this.privAudioConfigImpl = t, $d7238066c5de7f1c$var$U.throwIfNull(this.privAudioConfigImpl, "audioConfig"), this.privDisposedSpeakerRecognizer = !1, this.privProperties = i.properties;
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member SpeakerRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member SpeakerRecognizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this SpeakerRecognizer.
   * @member SpeakerRecognizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Get recognition result for model using given audio
   * @member SpeakerRecognizer.prototype.recognizeOnceAsync
   * @function
   * @public
   * @async
   * @param {SpeakerIdentificationModel | SpeakerVerificationModel} model Model containing Voice Profiles to be identified
   * @param cb - Callback invoked once result is returned.
   * @param err - Callback invoked in case of an error.
   */ recognizeOnceAsync(e) {
        return $d7238066c5de7f1c$var$Iy(this, void 0, void 0, function*() {
            return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedSpeakerRecognizer), this.recognizeSpeakerOnceAsyncImpl(e);
        });
    }
    /**
   * Included for compatibility
   * @member SpeakerRecognizer.prototype.close
   * @function
   * @public
   * @async
   */ close() {
        return $d7238066c5de7f1c$var$Iy(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedSpeakerRecognizer), yield this.dispose(!0);
        });
    }
    recognizeSpeakerOnceAsyncImpl(e) {
        return $d7238066c5de7f1c$var$Iy(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedSpeakerRecognizer), yield this.implRecognizerStop();
            const t = yield this.privReco.recognizeSpeaker(e);
            return yield this.implRecognizerStop(), t;
        });
    }
    implRecognizerStop() {
        return $d7238066c5de7f1c$var$Iy(this, void 0, void 0, function*() {
            this.privReco && (yield this.privReco.stopRecognizing());
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$u0e(e, t, s, n, this);
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$Iy(this, void 0, void 0, function*() {
            this.privDisposedSpeakerRecognizer || e && (this.privDisposedSpeakerRecognizer = !0, yield t.dispose.call(this, e));
        });
    }
}
class $d7238066c5de7f1c$var$HK {
    constructor(e){
        if (this.privVoiceProfiles = [], this.privProfileIds = [], $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "VoiceProfiles"), e.length === 0) throw new Error("Empty Voice Profiles array");
        for (const t of e){
            if (t.profileType !== $d7238066c5de7f1c$var$iu.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + t.profileId);
            this.privVoiceProfiles.push(t), this.privProfileIds.push(t.profileId);
        }
    }
    static fromProfiles(e) {
        return new $d7238066c5de7f1c$var$HK(e);
    }
    get voiceProfileIds() {
        return this.privProfileIds.join(",");
    }
    get profileIds() {
        return this.privProfileIds;
    }
    get scenario() {
        return "TextIndependentIdentification";
    }
}
class $d7238066c5de7f1c$var$XK {
    constructor(e){
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "VoiceProfile"), e.profileType === $d7238066c5de7f1c$var$iu.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = e;
    }
    static fromProfile(e) {
        return new $d7238066c5de7f1c$var$XK(e);
    }
    get voiceProfile() {
        return this.privVoiceProfile;
    }
    get profileIds() {
        return [
            this.voiceProfile.profileId
        ];
    }
    get scenario() {
        return this.voiceProfile.profileType === $d7238066c5de7f1c$var$iu.TextDependentVerification ? "TextDependentVerification" : "TextIndependentVerification";
    }
}
var $d7238066c5de7f1c$var$WB;
(function(r) {
    r[r.AtStart = 0] = "AtStart", r[r.Continuous = 1] = "Continuous";
})($d7238066c5de7f1c$var$WB || ($d7238066c5de7f1c$var$WB = {}));
class $d7238066c5de7f1c$var$qy {
    constructor(){
        this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_LanguageIdMode, "AtStart"), this.privLanguageIdMode = $d7238066c5de7f1c$var$WB.AtStart;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.fromOpenRange
   * @function
   * @public
   * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
   * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
   * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
   * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
   */ static fromOpenRange() {
        const e = new $d7238066c5de7f1c$var$qy();
        return e.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages, $d7238066c5de7f1c$var$t4), e;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.fromLanguages
   * @function
   * @public
   * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
   * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
   * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
   */ static fromLanguages(e) {
        $d7238066c5de7f1c$var$U.throwIfArrayEmptyOrWhitespace(e, "languages");
        const t = new $d7238066c5de7f1c$var$qy();
        return t.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages, e.join()), t;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
   * @function
   * @public
   * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
   * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
   * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
   */ static fromSourceLanguageConfigs(e) {
        if (e.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        const t = new $d7238066c5de7f1c$var$qy(), i = [];
        return e.forEach((n)=>{
            if (i.push(n.language), n.endpointId !== void 0 && n.endpointId !== "") {
                const s = n.language + $d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId.toString();
                t.properties.setProperty(s, n.endpointId);
            }
        }), t.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages, i.join()), t;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.prototype.properties
   * @function
   * @public
   * @return {PropertyCollection} Properties of the config.
   * @summary Gets an auto detected language config properties
   */ get properties() {
        return this.privProperties;
    }
    /**
   * @member AutoDetectSourceLanguageConfig.prototype.mode
   * @function
   * @public
   * @param {LanguageIdMode} mode LID mode desired.
   * @summary Sets LID operation to desired mode
   */ set mode(e) {
        e === $d7238066c5de7f1c$var$WB.Continuous ? (this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecognitionEndpointVersion, "2"), this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_LanguageIdMode, "Continuous")) : (this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecognitionEndpointVersion, "1"), this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_LanguageIdMode, "AtStart")), this.privLanguageIdMode = e;
    }
}
class $d7238066c5de7f1c$var$DZ {
    constructor(e, t){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "language"), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(t, "languageDetectionConfidence"), this.privLanguage = e, this.privLanguageDetectionConfidence = t;
    }
    /**
   * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
   * @member AutoDetectSourceLanguageResult.fromResult
   * @function
   * @public
   * @param {SpeechRecognitionResult} result - The recognition result.
   * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
   */ static fromResult(e) {
        return new $d7238066c5de7f1c$var$DZ(e.language, e.languageDetectionConfidence);
    }
    /**
   * Creates an instance of AutoDetectSourceLanguageResult object from a ConversationTranscriptionResult instance.
   * @member AutoDetectSourceLanguageResult.fromConversationTranscriptionResult
   * @function
   * @public
   * @param {ConversationTranscriptionResult} result - The transcription result.
   * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
   */ static fromConversationTranscriptionResult(e) {
        return new $d7238066c5de7f1c$var$DZ(e.language, e.languageDetectionConfidence);
    }
    get language() {
        return this.privLanguage;
    }
    get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
}
class $d7238066c5de7f1c$var$NK {
    constructor(e, t){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "language"), this.privLanguage = e, this.privEndpointId = t;
    }
    /**
   * @member SourceLanguageConfig.fromLanguage
   * @function
   * @public
   * @param {string} language language (eg. "en-US") value of config.
   * @param {string?} endpointId endpointId of model bound to given language of config.
   * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
   * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
   * Added in version 1.13.0.
   */ static fromLanguage(e, t) {
        return new $d7238066c5de7f1c$var$NK(e, t);
    }
    get language() {
        return this.privLanguage;
    }
    get endpointId() {
        return this.privEndpointId;
    }
}
var $d7238066c5de7f1c$var$XA;
(function(r) {
    r[r.Verify = 0] = "Verify", r[r.Identify = 1] = "Identify";
})($d7238066c5de7f1c$var$XA || ($d7238066c5de7f1c$var$XA = {}));
class $d7238066c5de7f1c$var$FS {
    constructor(e, t = $d7238066c5de7f1c$var$At.RecognizedSpeaker, i = $d7238066c5de7f1c$var$vt.NoError, n = ""){
        this.privProperties = new $d7238066c5de7f1c$var$vi();
        const s = e.scenario === "TextIndependentIdentification" ? $d7238066c5de7f1c$var$XA.Identify : $d7238066c5de7f1c$var$XA.Verify;
        this.privReason = t, this.privReason !== $d7238066c5de7f1c$var$At.Canceled ? s === $d7238066c5de7f1c$var$XA.Identify ? (this.privProfileId = e.identificationResult.identifiedProfile.profileId, this.privScore = e.identificationResult.identifiedProfile.score, this.privReason = $d7238066c5de7f1c$var$At.RecognizedSpeakers) : (this.privScore = e.verificationResult.score, e.verificationResult.recognitionResult.toLowerCase() !== "accept" && (this.privReason = $d7238066c5de7f1c$var$At.NoMatch), e.verificationResult.profileId !== void 0 && e.verificationResult.profileId !== "" && (this.privProfileId = e.verificationResult.profileId)) : (this.privErrorDetails = n, this.privProperties.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[i])), this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, JSON.stringify(e));
    }
    get properties() {
        return this.privProperties;
    }
    get reason() {
        return this.privReason;
    }
    get profileId() {
        return this.privProfileId;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    get score() {
        return this.privScore;
    }
}
class $d7238066c5de7f1c$var$LK extends $d7238066c5de7f1c$var$uf {
    constructor(e, t, i){
        super(e, t, i);
    }
    /**
   * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
   * @member SpeakerRecognitionCancellationDetails.fromResult
   * @function
   * @public
   * @param {SpeakerRecognitionResult} result - The result that was canceled.
   * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
   */ static fromResult(e) {
        const t = $d7238066c5de7f1c$var$Zn.Error;
        let i = $d7238066c5de7f1c$var$vt.NoError;
        return e.properties && (i = $d7238066c5de7f1c$var$vt[e.properties.getProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[$d7238066c5de7f1c$var$vt.NoError])]), new $d7238066c5de7f1c$var$LK(t, e.errorDetails, i);
    }
}
var $d7238066c5de7f1c$var$TS = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$HQ {
    constructor(){}
    /**
   * Create a conversation
   * @param speechConfig
   * @param cb
   * @param err
   */ static createConversationAsync(e, t, i, n) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, $d7238066c5de7f1c$var$ui.restErrors.invalidArgs.replace("{arg}", "config")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e.region, $d7238066c5de7f1c$var$ui.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), !e.subscriptionKey && !e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token]) && $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e.subscriptionKey, $d7238066c5de7f1c$var$ui.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        let s, a, o;
        return typeof t == "string" ? (s = new $d7238066c5de7f1c$var$bN(e, t), $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$TS(this, void 0, void 0, function*() {}), i, n)) : (s = new $d7238066c5de7f1c$var$bN(e), a = t, o = i, s.createConversationAsync(()=>{
            a && a();
        }, (g)=>{
            o && o(g);
        })), s;
    }
}
class $d7238066c5de7f1c$var$bN extends $d7238066c5de7f1c$var$HQ {
    /**
   * Create a conversation impl
   * @param speechConfig
   * @param {string} id - optional conversationId
   */ constructor(e, t){
        if (super(), this.privErrors = $d7238066c5de7f1c$var$ui.restErrors, this.onConnected = (s)=>{
            var a;
            this.privIsConnected = !0;
            try {
                !((a = this.privConversationTranslator) === null || a === void 0) && a.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, s);
            } catch  {}
        }, this.onDisconnected = (s)=>{
            var a;
            try {
                !((a = this.privConversationTranslator) === null || a === void 0) && a.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, s);
            } catch  {} finally{
                this.close(!1);
            }
        }, this.onCanceled = (s, a)=>{
            var o;
            try {
                !((o = this.privConversationTranslator) === null || o === void 0) && o.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, a);
            } catch  {}
        }, this.onParticipantUpdateCommandReceived = (s, a)=>{
            try {
                const o = this.privParticipants.getParticipant(a.id);
                if (o !== void 0) {
                    switch(a.key){
                        case $d7238066c5de7f1c$var$Yn.changeNickname:
                            o.displayName = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setUseTTS:
                            o.isUsingTts = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setProfanityFiltering:
                            o.profanity = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setMute:
                            o.isMuted = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setTranslateToLanguages:
                            o.translateToLanguages = a.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(o), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.Updated, [
                        this.toParticipant(o)
                    ], a.sessionId));
                }
            } catch  {}
        }, this.onLockRoomCommandReceived = ()=>{}, this.onMuteAllCommandReceived = (s, a)=>{
            try {
                this.privParticipants.participants.forEach((o)=>o.isMuted = o.isHost ? !1 : a.isMuted), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.Updated, this.toParticipants(!1), a.sessionId));
            } catch  {}
        }, this.onParticipantJoinCommandReceived = (s, a)=>{
            try {
                const o = this.privParticipants.addOrUpdateParticipant(a.participant);
                o !== void 0 && this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.JoinedConversation, [
                    this.toParticipant(o)
                ], a.sessionId));
            } catch  {}
        }, this.onParticipantLeaveCommandReceived = (s, a)=>{
            try {
                const o = this.privParticipants.getParticipant(a.participant.id);
                o !== void 0 && (this.privParticipants.deleteParticipant(a.participant.id), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.LeftConversation, [
                    this.toParticipant(o)
                ], a.sessionId)));
            } catch  {}
        }, this.onTranslationReceived = (s, a)=>{
            try {
                switch(a.command){
                    case $d7238066c5de7f1c$var$On.final:
                        this.privConversationTranslator && this.privConversationTranslator.transcribed(this.privConversationTranslator, new $d7238066c5de7f1c$var$MC(a.payload, void 0, a.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$On.partial:
                        this.privConversationTranslator && this.privConversationTranslator.transcribing(this.privConversationTranslator, new $d7238066c5de7f1c$var$MC(a.payload, void 0, a.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$On.instantMessage:
                        this.privConversationTranslator && this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $d7238066c5de7f1c$var$MC(a.payload, void 0, a.sessionId));
                        break;
                }
            } catch  {}
        }, this.onParticipantsListReceived = (s, a)=>{
            var o;
            try {
                if (a.sessionToken !== void 0 && a.sessionToken !== null && (this.privRoom.token = a.sessionToken), this.privParticipants.participants = [
                    ...a.participants
                ], this.privParticipants.me !== void 0 && (this.privIsReady = !0), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.JoinedConversation, this.toParticipants(!0), a.sessionId)), this.me.isHost) {
                    const g = (o = this.privConversationTranslator) === null || o === void 0 ? void 0 : o.properties.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Name);
                    g !== void 0 && g.length > 0 && g !== this.me.displayName && this.changeNicknameAsync(g);
                }
            } catch  {}
        }, this.onConversationExpiration = (s, a)=>{
            try {
                this.privConversationTranslator && this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, a);
            } catch  {}
        }, this.privIsConnected = !1, this.privIsDisposed = !1, this.privConversationId = "", this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privManager = new $d7238066c5de7f1c$var$qQ(), e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]) || e.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage], $d7238066c5de7f1c$var$ui.defaultLanguageCode), this.privLanguage = e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]), t) this.privConversationId = t;
        else {
            e.targetLanguages.length === 0 && e.addTargetLanguage(this.privLanguage), e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceResponse_ProfanityOption]) || e.setProfanity($d7238066c5de7f1c$var$_C.Masked);
            let a = e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.ConversationTranslator_Name]);
            a == null && (a = "Host"), $d7238066c5de7f1c$var$U.throwIfNullOrTooLong(a, "nickname", 50), $d7238066c5de7f1c$var$U.throwIfNullOrTooShort(a, "nickname", 2), e.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.ConversationTranslator_Name], a);
        }
        this.privConfig = e;
        const n = e;
        $d7238066c5de7f1c$var$U.throwIfNull(n, "speechConfig"), this.privProperties = n.properties.clone(), this.privIsConnected = !1, this.privParticipants = new $d7238066c5de7f1c$var$$Q(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the conversation Id
    get conversationId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        var e, t;
        return !((e = this.privParticipants.me) === null || e === void 0) && e.isHost ? !1 : (t = this.privParticipants.me) === null || t === void 0 ? void 0 : t.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(!0);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get conversationInfo() {
        const e = this.conversationId, t = this.participants.map((s)=>({
                id: s.id,
                preferredLanguage: s.preferredLanguage,
                voice: s.voice
            })), i = {};
        for (const s of $d7238066c5de7f1c$var$ui.transcriptionEventKeys){
            const a = this.properties.getProperty(s, "");
            a !== "" && (i[s] = a);
        }
        return {
            id: e,
            participants: t,
            conversationProperties: i
        };
    }
    get canSend() {
        var e;
        return this.privIsConnected && !(!((e = this.privParticipants.me) === null || e === void 0) && e.isMuted);
    }
    get canSendAsHost() {
        var e;
        return this.privIsConnected && ((e = this.privParticipants.me) === null || e === void 0 ? void 0 : e.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "authorizationToken"), this.privToken = e;
    }
    set conversationTranslator(e) {
        this.privConversationTranslator = e;
    }
    onToken(e) {
        this.privConversationTranslator.onToken(e);
    }
    /**
   * Create a new conversation as Host
   * @param cb
   * @param err
   */ createConversationAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), this.privManager.createOrJoin(this.privProperties, void 0, (i)=>{
                i || this.handleError(new Error(this.privErrors.permissionDeniedConnect), t), this.privRoom = i, this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Starts a new conversation as host.
   * @param cb
   * @param err
   */ startConversationAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer = $d7238066c5de7f1c$var$e0e.fromConfig(this, this.privConfig), this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Join a conversation as a participant.
   * @param { IParticipant } participant - participant to add
   * @param cb
   * @param err
   */ addParticipantAsync(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "Participant"), $d7238066c5de7f1c$var$ri(this.addParticipantImplAsync(e), t, i);
    }
    /**
   * Join a conversation as a participant.
   * @param conversation
   * @param nickname
   * @param lang
   * @param cb
   * @param err
   */ joinConversationAsync(e, t, i, n, s) {
        try {
            $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, e, (a)=>{
                $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(a, this.privErrors.permissionDeniedConnect), this.privRoom = a, this.privConfig.authorizationToken = a.cognitiveSpeechAuthToken, n && n(a.cognitiveSpeechAuthToken);
            }, (a)=>{
                this.handleError(a, s);
            });
        } catch (a) {
            this.handleError(a, s);
        }
    }
    /**
   * Deletes a conversation
   * @param cb
   * @param err
   */ deleteConversationAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.deleteConversationImplAsync(), e, t);
    }
    deleteConversationImplAsync() {
        return $d7238066c5de7f1c$var$TS(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), yield this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
        });
    }
    /**
   * Issues a request to close the client websockets
   * @param cb
   * @param err
   */ endConversationAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.endConversationImplAsync(), e, t);
    }
    endConversationImplAsync() {
        return this.close(!0);
    }
    /**
   * Issues a request to lock the conversation
   * @param cb
   * @param err
   */ lockConversationAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute the conversation
   * @param cb
   * @param err
   */ muteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute a participant in the conversation
   * @param userId
   * @param cb
   * @param err
   */ muteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !0), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to remove a participant from the conversation
   * @param userId
   * @param cb
   * @param err
   */ removeParticipantAsync(e, t, i) {
        try {
            if ($d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && e.hasOwnProperty("id")) $d7238066c5de7f1c$var$ri(this.removeParticipantImplAsync(e), t, i);
            else {
                $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), i);
                let n = "";
                typeof e == "string" ? n = e : e.hasOwnProperty("id") ? n = e.id : e.hasOwnProperty("userId") && (n = e.userId), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(n, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((a)=>a.id === n) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getEjectCommand(n), ()=>{
                    this.handleCallback(t, i);
                }, (a)=>{
                    this.handleError(a, i);
                });
            }
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to unlock the conversation
   * @param cb
   * @param err
   */ unlockConversationAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute all participants in the conversation
   * @param cb
   * @param err
   */ unmuteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute a participant in the conversation
   * @param userId
   * @param cb
   * @param err
   */ unmuteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !1), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Send a text message
   * @param message
   * @param cb
   * @param err
   */ sendTextMessageAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "message")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), e.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMessageCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Set translated to languages
   * @param {string[]} languages - languages to translate to
   * @param cb
   * @param err
   */ setTranslatedLanguagesAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfArrayEmptyOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "languages")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Change nickname
   * @param {string} nickname - new nickname for the room
   * @param cb
   * @param err
   */ changeNicknameAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.isDisposed || (this.privIsDisposed = !0, this.config && this.config.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    connectTranscriberRecognizer(e) {
        return $d7238066c5de7f1c$var$TS(this, void 0, void 0, function*() {
            this.privTranscriberRecognizer && (yield this.privTranscriberRecognizer.close()), yield e.enforceAudioGating(), this.privTranscriberRecognizer = e, this.privTranscriberRecognizer.conversation = this;
        });
    }
    getKeepAlive() {
        const e = this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: e,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(e) {
        if (this.privParticipants.addOrUpdateParticipant(e) !== void 0 && this.privTranscriberRecognizer) {
            const i = this.conversationInfo;
            return i.participants = [
                e
            ], this.privTranscriberRecognizer.pushConversationEvent(i, "join");
        }
    }
    removeParticipantImplAsync(e) {
        this.privParticipants.deleteParticipant(e.id);
        const t = this.conversationInfo;
        return t.participants = [
            e
        ], this.privTranscriberRecognizer.pushConversationEvent(t, "leave");
    }
    close(e) {
        var t;
        return $d7238066c5de7f1c$var$TS(this, void 0, void 0, function*() {
            try {
                this.privIsConnected = !1, yield (t = this.privConversationRecognizer) === null || t === void 0 ? void 0 : t.close(), this.privConversationRecognizer = void 0, this.privConversationTranslator && this.privConversationTranslator.dispose();
            } catch (i) {
                throw i;
            }
            e && this.dispose();
        });
    }
    /** Helpers */ handleCallback(e, t) {
        if (e) {
            try {
                e();
            } catch (i) {
                t && t(i);
            }
            e = void 0;
        }
    }
    handleError(e, t) {
        if (t) {
            if (e instanceof Error) {
                const i = e;
                t(i.name + ": " + i.message);
            } else t(e);
        }
    }
    /** Participant Helpers */ toParticipants(e) {
        const t = this.privParticipants.participants.map((i)=>this.toParticipant(i));
        return e ? t : t.filter((i)=>i.isHost === !1);
    }
    toParticipant(e) {
        return new $d7238066c5de7f1c$var$If(e.id, e.avatar, e.displayName, e.isHost, e.isMuted, e.isUsingTts, e.preferredLanguage, e.voice);
    }
    getMuteAllCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getMuteCommand(e, t) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: t
        });
    }
    getLockCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getEjectCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getChangeNicknameCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "nickname"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.changeNickname,
            nickname: e,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getMessageCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "message"), JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: e,
            type: $d7238066c5de7f1c$var$On.instantMessage
        });
    }
}
class $d7238066c5de7f1c$var$tAe {
    constructor(e){
        this.privAudioConfig = e;
    }
    handleCallback(e, t) {
        if (e) {
            try {
                e();
            } catch (i) {
                t && t(i);
            }
            e = void 0;
        }
    }
    handleError(e, t) {
        if (t) {
            if (e instanceof Error) {
                const i = e;
                t(i.name + ": " + i.message);
            } else t(e);
        }
    }
}
class $d7238066c5de7f1c$var$XQ extends $d7238066c5de7f1c$var$zr {
    constructor(e, t){
        super(t), this.privExpirationTime = e;
    }
    /** How much longer until the conversation expires (in minutes). */ get expirationTime() {
        return this.privExpirationTime;
    }
}
class $d7238066c5de7f1c$var$jl extends $d7238066c5de7f1c$var$zr {
    constructor(e, t, i){
        super(i), this.privReason = e, this.privParticipant = t;
    }
    get reason() {
        return this.privReason;
    }
    get participants() {
        return this.privParticipant;
    }
}
class $d7238066c5de7f1c$var$YK extends $d7238066c5de7f1c$var$eV {
}
class $d7238066c5de7f1c$var$MC extends $d7238066c5de7f1c$var$rc {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ConversationTranslationResult} result - The translation recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */ constructor(e, t, i){
        super(t, i), this.privResult = e;
    }
    /**
   * Specifies the recognition result.
   * @returns {ConversationTranslationResult} the recognition result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$yN extends $d7238066c5de7f1c$var$aI {
    constructor(e, t, i, n, s, a, o, g, l, c, d){
        super(t, n, s, a, o, g, void 0, void 0, l, c, d), this.privId = e, this.privOrigLang = i;
    }
    /**
   * The unique identifier for the participant this result is for.
   */ get participantId() {
        return this.privId;
    }
    /**
   * The original language this result was in.
   */ get originalLang() {
        return this.privOrigLang;
    }
}
class $d7238066c5de7f1c$var$BN {
    /**
   * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
   * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
   * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
   * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
   * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
   */ static formatString(e, t) {
        if (!e) return "";
        if (!t) return e;
        let i = "", n = "";
        const s = (g)=>{
            i += g;
        }, a = (g)=>{
            n += g;
        };
        let o = s;
        for(let g = 0; g < e.length; g++){
            const l = e[g], c = g + 1 < e.length ? e[g + 1] : "";
            switch(l){
                case "{":
                    c === "{" ? (o("{"), g++) : o = a;
                    break;
                case "}":
                    c === "}" ? (o("}"), g++) : (t.hasOwnProperty(n) && (i += t[n]), o = s, n = "");
                    break;
                default:
                    o(l);
                    break;
            }
        }
        return i;
    }
}
class $d7238066c5de7f1c$var$nV extends $d7238066c5de7f1c$var$Rr {
    constructor(e){
        super(), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "convGetter"), this.privConvGetter = e;
    }
    create(e, t, i) {
        const n = e.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE", s = this.privConvGetter().room, a = s.cognitiveSpeechRegion || e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, ""), o = {
            hostSuffix: $d7238066c5de7f1c$var$Rr.getHostSuffix(a),
            path: $d7238066c5de7f1c$var$nV.CTS_VIRT_MIC_PATH,
            region: encodeURIComponent(a)
        };
        o[$d7238066c5de7f1c$var$dt.Language] = encodeURIComponent(e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, "")), o[$d7238066c5de7f1c$var$dt.CtsMeetingId] = encodeURIComponent(s.roomId), o[$d7238066c5de7f1c$var$dt.CtsDeviceId] = encodeURIComponent(s.participantId), o[$d7238066c5de7f1c$var$dt.CtsIsParticipant] = s.isHost ? "" : "&" + $d7238066c5de7f1c$var$dt.CtsIsParticipant;
        let g = "";
        const l = {}, c = {};
        if (n) {
            g = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint), g || (g = "wss://" + e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}") + "{path}"), g = $d7238066c5de7f1c$var$BN.formatString(g, o);
            const p = new URL(g);
            p.searchParams.forEach((y, G)=>{
                l[G] = y;
            }), new $d7238066c5de7f1c$var$QQ().setQueryParams(l, e, g), l[$d7238066c5de7f1c$var$dt.CtsMeetingId] = o[$d7238066c5de7f1c$var$dt.CtsMeetingId], l[$d7238066c5de7f1c$var$dt.CtsDeviceId] = o[$d7238066c5de7f1c$var$dt.CtsDeviceId], s.isHost || (l[$d7238066c5de7f1c$var$dt.CtsIsParticipant] = ""), $d7238066c5de7f1c$var$dt.Format in l || (l[$d7238066c5de7f1c$var$dt.Format] = "simple"), p.searchParams.forEach((y, G)=>{
                p.searchParams.set(G, l[G]), delete l[G];
            }), g = p.toString();
        } else {
            const p = new $d7238066c5de7f1c$var$OQ();
            g = p.getEndpointUrl(e, !0), g = $d7238066c5de7f1c$var$BN.formatString(g, o), p.setQueryParams(l, e, g);
        }
        c[$d7238066c5de7f1c$var$Fi.ConnectionId] = i, c[$d7238066c5de7f1c$var$cu.configParams.token] = s.token, t.token && (c[t.headerName] = t.token);
        const d = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
        return new $d7238066c5de7f1c$var$Au(g, l, c, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), d, i);
    }
}
$d7238066c5de7f1c$var$nV.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio";
var $d7238066c5de7f1c$var$Oc = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
}, $d7238066c5de7f1c$var$Dg;
(function(r) {
    r[r.Inactive = 0] = "Inactive", r[r.Connecting = 1] = "Connecting", r[r.Connected = 2] = "Connected";
})($d7238066c5de7f1c$var$Dg || ($d7238066c5de7f1c$var$Dg = {}));
class $d7238066c5de7f1c$var$iAe extends $d7238066c5de7f1c$var$tV {
    constructor(e, t, i, n){
        super(e, t, new $d7238066c5de7f1c$var$nV(n)), this.privSpeechState = $d7238066c5de7f1c$var$Dg.Inactive, i && (this.privTranslator = i, this.sessionStarted = ()=>{
            this.privSpeechState = $d7238066c5de7f1c$var$Dg.Connected;
        }, this.sessionStopped = ()=>{
            this.privSpeechState = $d7238066c5de7f1c$var$Dg.Inactive;
        }, this.recognizing = (s, a)=>{
            this.privTranslator.recognizing && this.privTranslator.recognizing(this.privTranslator, a);
        }, this.recognized = (s, a)=>$d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
                var o;
                !((o = a.result) === null || o === void 0) && o.errorDetails ? (yield this.cancelSpeech(), this.fireCancelEvent(a.result.errorDetails)) : this.privTranslator.recognized && this.privTranslator.recognized(this.privTranslator, a);
            }), this.canceled = ()=>$d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
                if (this.privSpeechState !== $d7238066c5de7f1c$var$Dg.Inactive) try {
                    yield this.cancelSpeech();
                } catch  {
                    this.privSpeechState = $d7238066c5de7f1c$var$Dg.Inactive;
                }
            }));
    }
    get state() {
        return this.privSpeechState;
    }
    set state(e) {
        this.privSpeechState = e;
    }
    set authentication(e) {
        this.privReco.authentication = e;
    }
    onConnection() {
        this.privSpeechState = $d7238066c5de7f1c$var$Dg.Connected;
    }
    onCancelSpeech() {
        return $d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            this.privSpeechState = $d7238066c5de7f1c$var$Dg.Inactive, yield this.cancelSpeech();
        });
    }
    /**
   * Fire a cancel event
   * @param error
   */ fireCancelEvent(e) {
        try {
            if (this.privTranslator.canceled) {
                const t = new $d7238066c5de7f1c$var$YK($d7238066c5de7f1c$var$Zn.Error, e, $d7238066c5de7f1c$var$vt.RuntimeError);
                this.privTranslator.canceled(this.privTranslator, t);
            }
        } catch  {}
    }
    cancelSpeech() {
        var e;
        return $d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            try {
                this.stopContinuousRecognitionAsync(), yield (e = this.privReco) === null || e === void 0 ? void 0 : e.disconnect(), this.privSpeechState = $d7238066c5de7f1c$var$Dg.Inactive;
            } catch  {}
        });
    }
}
class $d7238066c5de7f1c$var$nAe extends $d7238066c5de7f1c$var$tAe {
    constructor(e){
        super(e), this.privErrors = $d7238066c5de7f1c$var$ui.restErrors, this.privIsDisposed = !1, this.privIsSpeaking = !1, this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345", this.privPlaceholderRegion = "westus", this.privProperties = new $d7238066c5de7f1c$var$vi();
    }
    get properties() {
        return this.privProperties;
    }
    get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    get participants() {
        var e;
        return (e = this.privConversation) === null || e === void 0 ? void 0 : e.participants;
    }
    get canSpeak() {
        return !(!this.privConversation.isConnected || !this.privCTRecognizer || this.privIsSpeaking || this.privCTRecognizer.state === $d7238066c5de7f1c$var$Dg.Connected || this.privCTRecognizer.state === $d7238066c5de7f1c$var$Dg.Connecting || this.privConversation.isMutedByHost);
    }
    onToken(e) {
        this.privCTRecognizer.authentication = e;
    }
    setServiceProperty(e, t) {
        const i = JSON.parse(this.privProperties.getProperty($d7238066c5de7f1c$var$GI, "{}"));
        i[e] = t, this.privProperties.setProperty($d7238066c5de7f1c$var$GI, JSON.stringify(i));
    }
    joinConversationAsync(e, t, i, n, s) {
        try {
            if (typeof e == "string") {
                $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privConversation && this.handleError(new Error(this.privErrors.permissionDeniedStart), s);
                let a = i;
                (a == null || a === "") && (a = $d7238066c5de7f1c$var$ui.defaultLanguageCode), this.privSpeechTranslationConfig = $d7238066c5de7f1c$var$fK.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion), this.privSpeechTranslationConfig.setProfanity($d7238066c5de7f1c$var$_C.Masked), this.privSpeechTranslationConfig.addTargetLanguage(a), this.privSpeechTranslationConfig.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage], a), this.privSpeechTranslationConfig.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.ConversationTranslator_Name], t);
                const o = [
                    $d7238066c5de7f1c$var$T.SpeechServiceConnection_Host,
                    $d7238066c5de7f1c$var$T.ConversationTranslator_Host,
                    $d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint,
                    $d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyHostName,
                    $d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPassword,
                    $d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPort,
                    $d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyUserName,
                    "ConversationTranslator_MultiChannelAudio",
                    "ConversationTranslator_Region"
                ];
                for (const l of o){
                    const c = this.privProperties.getProperty(l);
                    if (c) {
                        const d = typeof l == "string" ? l : $d7238066c5de7f1c$var$T[l];
                        this.privSpeechTranslationConfig.setProperty(d, c);
                    }
                }
                const g = JSON.parse(this.privProperties.getProperty($d7238066c5de7f1c$var$GI, "{}"));
                for (const l of Object.keys(g))this.privSpeechTranslationConfig.setServiceProperty(l, g[l], $d7238066c5de7f1c$var$UZ.UriQueryParameter);
                this.privConversation = new $d7238066c5de7f1c$var$bN(this.privSpeechTranslationConfig), this.privConversation.conversationTranslator = this, this.privConversation.joinConversationAsync(e, t, a, (l)=>{
                    l || this.handleError(new Error(this.privErrors.permissionDeniedConnect), s), this.privSpeechTranslationConfig.authorizationToken = l, this.privConversation.room.isHost = !1, this.privConversation.startConversationAsync(()=>{
                        this.handleCallback(n, s);
                    }, (c)=>{
                        this.handleError(c, s);
                    });
                }, (l)=>{
                    this.handleError(l, s);
                });
            } else typeof e == "object" ? ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privProperties.setProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Name, t), this.privConversation = e, this.privConversation.conversationTranslator = this, this.privConversation.room.isHost = !0, $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privSpeechTranslationConfig = e.config, this.handleCallback(i, n)) : this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), n);
        } catch (a) {
            this.handleError(a, typeof i == "string" ? s : n);
        }
    }
    /**
   * Leave the conversation
   * @param cb
   * @param err
   */ leaveConversationAsync(e, t) {
        $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            yield this.cancelSpeech(), yield this.privConversation.endConversationImplAsync(), yield this.privConversation.deleteConversationImplAsync(), this.dispose();
        }), e, t);
    }
    /**
   * Send a text message
   * @param message
   * @param cb
   * @param err
   */ sendTextMessageAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", e)), this.privConversation.sendTextMessageAsync(e, t, i);
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Start speaking
   * @param cb
   * @param err
   */ startTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            try {
                $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privCTRecognizer === void 0 && (yield this.connectTranslatorRecognizer()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend), this.canSpeak || this.handleError(new Error(this.privErrors.permissionDeniedSend), t), yield this.startContinuousRecognition(), this.privIsSpeaking = !0;
            } catch (i) {
                throw this.privIsSpeaking = !1, yield this.cancelSpeech(), i;
            }
        }), e, t);
    }
    /**
   * Stop speaking
   * @param cb
   * @param err
   */ stopTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            try {
                if (!this.privIsSpeaking) {
                    yield this.cancelSpeech();
                    return;
                }
                this.privIsSpeaking = !1, yield new Promise((i, n)=>{
                    this.privCTRecognizer.stopContinuousRecognitionAsync(i, n);
                });
            } catch  {
                yield this.cancelSpeech();
            }
        }), e, t);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(e, t, i) {
        $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            this.isDisposed && !this.privIsSpeaking || (yield this.cancelSpeech(), this.privIsDisposed = !0, this.privSpeechTranslationConfig.close(), this.privSpeechRecognitionLanguage = void 0, this.privProperties = void 0, this.privAudioConfig = void 0, this.privSpeechTranslationConfig = void 0, this.privConversation.dispose(), this.privConversation = void 0);
        }), t, i);
    }
    /**
   * Cancel the speech websocket
   */ cancelSpeech() {
        var e;
        return $d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            try {
                this.privIsSpeaking = !1, yield (e = this.privCTRecognizer) === null || e === void 0 ? void 0 : e.onCancelSpeech(), this.privCTRecognizer = void 0;
            } catch  {}
        });
    }
    /**
   * Connect to the speech translation recognizer.
   * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
   * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
   * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
   */ connectTranslatorRecognizer() {
        return $d7238066c5de7f1c$var$Oc(this, void 0, void 0, function*() {
            try {
                this.privAudioConfig === void 0 && (this.privAudioConfig = $d7238066c5de7f1c$var$XI.fromDefaultMicrophoneInput()), this.privSpeechTranslationConfig.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_Key]) === this.privPlaceholderKey && this.privSpeechTranslationConfig.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_Key], "");
                const e = ()=>this.privConversation;
                this.privCTRecognizer = new $d7238066c5de7f1c$var$iAe(this.privSpeechTranslationConfig, this.privAudioConfig, this, e);
            } catch (e) {
                throw yield this.cancelSpeech(), e;
            }
        });
    }
    /**
   * Handle the start speaking request
   */ startContinuousRecognition() {
        return new Promise((e, t)=>{
            this.privCTRecognizer.startContinuousRecognitionAsync(e, t);
        });
    }
}
var $d7238066c5de7f1c$var$sAe = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$KK extends $d7238066c5de7f1c$var$gl {
    /**
   * ConversationTranscriber constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNull(i, "speechConfig"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage), $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]), super(t, i.properties, new $d7238066c5de7f1c$var$ZAe()), this.privProperties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecognitionEndpointVersion, "2"), this.privDisposedRecognizer = !1;
    }
    /**
   * ConversationTranscriber constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$KK(e, i);
    }
    /**
   * Gets the endpoint id of a customized speech model that is used for transcription.
   * @member ConversationTranscriber.prototype.endpointId
   * @function
   * @public
   * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
   */ get endpointId() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member ConversationTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member ConversationTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * Gets the spoken language of transcription.
   * @member ConversationTranscriber.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} The spoken language of transcription.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * Gets the output format of transcription.
   * @member ConversationTranscriber.prototype.outputFormat
   * @function
   * @public
   * @returns {OutputFormat} The output format of transcription.
   */ get outputFormat() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]) === $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple] ? $d7238066c5de7f1c$var$bi.Simple : $d7238066c5de7f1c$var$bi.Detailed;
    }
    /**
   * The collection of properties and their values defined for this conversation transcriber.
   * @member ConversationTranscriber.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Starts conversation transcription, until stopTranscribingAsync() is called.
   * User must subscribe to events to receive transcription results.
   * @member ConversationTranscriber.prototype.startTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has started.
   * @param err - Callback invoked in case of an error.
   */ startTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$cr.Conversation), e, t);
    }
    /**
   * Stops conversation transcription.
   * @member ConversationTranscriber.prototype.stopTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has stopped.
   * @param err - Callback invoked in case of an error.
   */ stopTranscribingAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member ConversationTranscriber.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    /**
   * Disposes any resources held by the object.
   * @member SpeechRecognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$sAe(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return n.isSpeakerDiarizationEnabled = !0, new $d7238066c5de7f1c$var$HAe(e, t, s, n, this);
    }
}
class $d7238066c5de7f1c$var$rAe {
    constructor(e){
        this.privUserId = e;
    }
    get userId() {
        return this.privUserId;
    }
}
class $d7238066c5de7f1c$var$If {
    constructor(e, t, i, n, s, a, o, g){
        this.privId = e, this.privAvatar = t, this.privDisplayName = i, this.privIsHost = n, this.privIsMuted = s, this.privIsUsingTts = a, this.privPreferredLanguage = o, this.privVoice = g, this.privProperties = new $d7238066c5de7f1c$var$vi();
    }
    get avatar() {
        return this.privAvatar;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get id() {
        return this.privId;
    }
    get preferredLanguage() {
        return this.privPreferredLanguage;
    }
    get isHost() {
        return this.privIsHost;
    }
    get isMuted() {
        return this.privIsMuted;
    }
    get isUsingTts() {
        return this.privIsUsingTts;
    }
    get voice() {
        return this.privVoice;
    }
    get properties() {
        return this.privProperties;
    }
    static From(e, t, i) {
        return new $d7238066c5de7f1c$var$If(e, "", e, !1, !1, !1, t, i);
    }
}
var $d7238066c5de7f1c$var$ig;
(function(r) {
    r[r.JoinedConversation = 0] = "JoinedConversation", r[r.LeftConversation = 1] = "LeftConversation", r[r.Updated = 2] = "Updated";
})($d7238066c5de7f1c$var$ig || ($d7238066c5de7f1c$var$ig = {}));
var $d7238066c5de7f1c$var$MS = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$NQ {
    constructor(){}
    /**
   * Create a meeting
   * @param speechConfig
   * @param meetingId
   * @param cb
   * @param err
   */ static createMeetingAsync(e, t, i, n) {
        if ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, $d7238066c5de7f1c$var$ui.restErrors.invalidArgs.replace("{arg}", "config")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e.region, $d7238066c5de7f1c$var$ui.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), $d7238066c5de7f1c$var$U.throwIfNull(t, "meetingId"), t.length === 0) throw new Error("meetingId cannot be empty");
        !e.subscriptionKey && !e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token]) && $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e.subscriptionKey, $d7238066c5de7f1c$var$ui.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        const s = new $d7238066c5de7f1c$var$LQ(e, t);
        return $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$MS(this, void 0, void 0, function*() {}), i, n), s;
    }
}
class $d7238066c5de7f1c$var$LQ extends $d7238066c5de7f1c$var$NQ {
    /**
   * Create a Meeting impl
   * @param speechConfig
   * @param {string} id - optional conversationId
   */ constructor(e, t){
        super(), this.privErrors = $d7238066c5de7f1c$var$ui.restErrors, this.onConnected = (s)=>{
            var a;
            this.privIsConnected = !0;
            try {
                !((a = this.privConversationTranslator) === null || a === void 0) && a.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, s);
            } catch  {}
        }, this.onDisconnected = (s)=>{
            var a;
            try {
                !((a = this.privConversationTranslator) === null || a === void 0) && a.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, s);
            } catch  {} finally{
                this.close(!1);
            }
        }, this.onCanceled = (s, a)=>{
            var o;
            try {
                !((o = this.privConversationTranslator) === null || o === void 0) && o.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, a);
            } catch  {}
        }, this.onParticipantUpdateCommandReceived = (s, a)=>{
            try {
                const o = this.privParticipants.getParticipant(a.id);
                if (o !== void 0) {
                    switch(a.key){
                        case $d7238066c5de7f1c$var$Yn.changeNickname:
                            o.displayName = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setUseTTS:
                            o.isUsingTts = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setProfanityFiltering:
                            o.profanity = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setMute:
                            o.isMuted = a.value;
                            break;
                        case $d7238066c5de7f1c$var$Yn.setTranslateToLanguages:
                            o.translateToLanguages = a.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(o), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.Updated, [
                        this.toParticipant(o)
                    ], a.sessionId));
                }
            } catch  {}
        }, this.onLockRoomCommandReceived = ()=>{}, this.onMuteAllCommandReceived = (s, a)=>{
            try {
                this.privParticipants.participants.forEach((o)=>o.isMuted = o.isHost ? !1 : a.isMuted), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.Updated, this.toParticipants(!1), a.sessionId));
            } catch  {}
        }, this.onParticipantJoinCommandReceived = (s, a)=>{
            try {
                const o = this.privParticipants.addOrUpdateParticipant(a.participant);
                o !== void 0 && this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.JoinedConversation, [
                    this.toParticipant(o)
                ], a.sessionId));
            } catch  {}
        }, this.onParticipantLeaveCommandReceived = (s, a)=>{
            try {
                const o = this.privParticipants.getParticipant(a.participant.id);
                o !== void 0 && (this.privParticipants.deleteParticipant(a.participant.id), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.LeftConversation, [
                    this.toParticipant(o)
                ], a.sessionId)));
            } catch  {}
        }, this.onTranslationReceived = (s, a)=>{
            try {
                switch(a.command){
                    case $d7238066c5de7f1c$var$On.final:
                        this.privConversationTranslator && this.privConversationTranslator.transcribed(this.privConversationTranslator, new $d7238066c5de7f1c$var$MC(a.payload, void 0, a.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$On.partial:
                        this.privConversationTranslator && this.privConversationTranslator.transcribing(this.privConversationTranslator, new $d7238066c5de7f1c$var$MC(a.payload, void 0, a.sessionId));
                        break;
                    case $d7238066c5de7f1c$var$On.instantMessage:
                        this.privConversationTranslator && this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $d7238066c5de7f1c$var$MC(a.payload, void 0, a.sessionId));
                        break;
                }
            } catch  {}
        }, this.onParticipantsListReceived = (s, a)=>{
            var o;
            try {
                if (a.sessionToken !== void 0 && a.sessionToken !== null && (this.privRoom.token = a.sessionToken), this.privParticipants.participants = [
                    ...a.participants
                ], this.privParticipants.me !== void 0 && (this.privIsReady = !0), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $d7238066c5de7f1c$var$jl($d7238066c5de7f1c$var$ig.JoinedConversation, this.toParticipants(!0), a.sessionId)), this.me.isHost) {
                    const g = (o = this.privConversationTranslator) === null || o === void 0 ? void 0 : o.properties.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Name);
                    g !== void 0 && g.length > 0 && g !== this.me.displayName && this.changeNicknameAsync(g);
                }
            } catch  {}
        }, this.onConversationExpiration = (s, a)=>{
            try {
                this.privConversationTranslator && this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, a);
            } catch  {}
        }, this.privIsConnected = !1, this.privIsDisposed = !1, this.privConversationId = "", this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privManager = new $d7238066c5de7f1c$var$qQ(), e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]) || e.setProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage], $d7238066c5de7f1c$var$ui.defaultLanguageCode), this.privLanguage = e.getProperty($d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]), this.privConversationId = t, this.privConfig = e;
        const n = e;
        $d7238066c5de7f1c$var$U.throwIfNull(n, "speechConfig"), this.privProperties = n.properties.clone(), this.privIsConnected = !1, this.privParticipants = new $d7238066c5de7f1c$var$$Q(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the meeting Id
    get meetingId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        var e, t;
        return !((e = this.privParticipants.me) === null || e === void 0) && e.isHost ? !1 : (t = this.privParticipants.me) === null || t === void 0 ? void 0 : t.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(!0);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get meetingInfo() {
        const e = this.meetingId, t = this.participants.map((s)=>({
                id: s.id,
                preferredLanguage: s.preferredLanguage,
                voice: s.voice
            })), i = {};
        for (const s of $d7238066c5de7f1c$var$ui.transcriptionEventKeys){
            const a = this.properties.getProperty(s, "");
            a !== "" && (i[s] = a);
        }
        return {
            id: e,
            participants: t,
            meetingProperties: i
        };
    }
    get canSend() {
        var e;
        return this.privIsConnected && !(!((e = this.privParticipants.me) === null || e === void 0) && e.isMuted);
    }
    get canSendAsHost() {
        var e;
        return this.privIsConnected && ((e = this.privParticipants.me) === null || e === void 0 ? void 0 : e.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "authorizationToken"), this.privToken = e;
    }
    /**
   * Create a new meeting as Host
   * @param cb
   * @param err
   */ createMeetingAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), this.privManager.createOrJoin(this.privProperties, void 0, (i)=>{
                i || this.handleError(new Error(this.privErrors.permissionDeniedConnect), t), this.privRoom = i, this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Starts a new meeting as host.
   * @param cb
   * @param err
   */ startMeetingAsync(e, t) {
        try {
            this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Join a meeting as a participant.
   * @param { IParticipant } participant - participant to add
   * @param cb
   * @param err
   */ addParticipantAsync(e, t, i) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "Participant"), $d7238066c5de7f1c$var$ri(this.addParticipantImplAsync(e), t, i);
    }
    /**
   * Join a meeting as a participant.
   * @param meeting
   * @param nickname
   * @param lang
   * @param cb
   * @param err
   */ joinMeetingAsync(e, t, i, n, s) {
        try {
            $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, e, (a)=>{
                $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(a, this.privErrors.permissionDeniedConnect), this.privRoom = a, this.privConfig.authorizationToken = a.cognitiveSpeechAuthToken, n && n(a.cognitiveSpeechAuthToken);
            }, (a)=>{
                this.handleError(a, s);
            });
        } catch (a) {
            this.handleError(a, s);
        }
    }
    /**
   * Deletes a meeting
   * @param cb
   * @param err
   */ deleteMeetingAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.deleteMeetingImplAsync(), e, t);
    }
    deleteMeetingImplAsync() {
        return $d7238066c5de7f1c$var$MS(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), yield this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
        });
    }
    /**
   * Issues a request to close the client websockets
   * @param cb
   * @param err
   */ endMeetingAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.endMeetingImplAsync(), e, t);
    }
    endMeetingImplAsync() {
        return this.close(!0);
    }
    /**
   * Issues a request to lock the conversation
   * @param cb
   * @param err
   */ lockMeetingAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute the meeting
   * @param cb
   * @param err
   */ muteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!0), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to mute a participant in the meeting
   * @param userId
   * @param cb
   * @param err
   */ muteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !0), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to remove a participant from the conversation
   * @param userId
   * @param cb
   * @param err
   */ removeParticipantAsync(e, t, i) {
        try {
            if ($d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && e.hasOwnProperty("id")) $d7238066c5de7f1c$var$ri(this.removeParticipantImplAsync(e), t, i);
            else {
                $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), i);
                let n = "";
                typeof e == "string" ? n = e : e.hasOwnProperty("id") ? n = e.id : e.hasOwnProperty("userId") && (n = e.userId), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(n, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((a)=>a.id === n) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getEjectCommand(n), ()=>{
                    this.handleCallback(t, i);
                }, (a)=>{
                    this.handleError(a, i);
                });
            }
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Issues a request to unlock the meeting
   * @param cb
   * @param err
   */ unlockMeetingAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute all participants in the meeting
   * @param cb
   * @param err
   */ unmuteAllParticipantsAsync(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), t), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!1), ()=>{
                this.handleCallback(e, t);
            }, (i)=>{
                this.handleError(i, t);
            });
        } catch (i) {
            this.handleError(i, t);
        }
    }
    /**
   * Issues a request to unmute a participant in the meeting
   * @param userId
   * @param cb
   * @param err
   */ unmuteParticipantAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), i), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(e, !1), ()=>{
                this.handleCallback(t, i);
            }, (s)=>{
                this.handleError(s, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Send a text message
   * @param message
   * @param cb
   * @param err
   */ sendTextMessageAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "message")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), e.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMessageCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Set translated to languages
   * @param {string[]} languages - languages to translate to
   * @param cb
   * @param err
   */ setTranslatedLanguagesAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfArrayEmptyOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "languages")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    /**
   * Change nickname
   * @param {string} nickname - new nickname for the room
   * @param cb
   * @param err
   */ changeNicknameAsync(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfDisposed(this.privConversationRecognizer.isDisposed()), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "nickname")), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), i), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(e), ()=>{
                this.handleCallback(t, i);
            }, (n)=>{
                this.handleError(n, i);
            });
        } catch (n) {
            this.handleError(n, i);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.isDisposed || (this.privIsDisposed = !0, this.config && this.config.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    connectTranscriberRecognizer(e) {
        return $d7238066c5de7f1c$var$MS(this, void 0, void 0, function*() {
            this.privTranscriberRecognizer && (yield this.privTranscriberRecognizer.close()), yield e.enforceAudioGating(), this.privTranscriberRecognizer = e, this.privTranscriberRecognizer.meeting = this;
        });
    }
    getKeepAlive() {
        const e = this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: e,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(e) {
        if (this.privParticipants.addOrUpdateParticipant(e) !== void 0 && this.privTranscriberRecognizer) {
            const i = this.meetingInfo;
            return i.participants = [
                e
            ], this.privTranscriberRecognizer.pushMeetingEvent(i, "join");
        }
    }
    removeParticipantImplAsync(e) {
        this.privParticipants.deleteParticipant(e.id);
        const t = this.meetingInfo;
        return t.participants = [
            e
        ], this.privTranscriberRecognizer.pushMeetingEvent(t, "leave");
    }
    close(e) {
        var t;
        return $d7238066c5de7f1c$var$MS(this, void 0, void 0, function*() {
            try {
                this.privIsConnected = !1, yield (t = this.privConversationRecognizer) === null || t === void 0 ? void 0 : t.close(), this.privConversationRecognizer = void 0, this.privConversationTranslator && this.privConversationTranslator.dispose();
            } catch (i) {
                throw i;
            }
            e && this.dispose();
        });
    }
    /** Helpers */ handleCallback(e, t) {
        if (e) {
            try {
                e();
            } catch (i) {
                t && t(i);
            }
            e = void 0;
        }
    }
    handleError(e, t) {
        if (t) {
            if (e instanceof Error) {
                const i = e;
                t(i.name + ": " + i.message);
            } else t(e);
        }
    }
    /** Participant Helpers */ toParticipants(e) {
        const t = this.privParticipants.participants.map((i)=>this.toParticipant(i));
        return e ? t : t.filter((i)=>i.isHost === !1);
    }
    toParticipant(e) {
        return new $d7238066c5de7f1c$var$If(e.id, e.avatar, e.displayName, e.isHost, e.isMuted, e.isUsingTts, e.preferredLanguage, e.voice);
    }
    getMuteAllCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingd"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getMuteCommand(e, t) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: t
        });
    }
    getLockCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getEjectCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: e,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getChangeNicknameCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "nickname"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
            command: $d7238066c5de7f1c$var$Yn.changeNickname,
            nickname: e,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $d7238066c5de7f1c$var$On.participantCommand,
            value: e
        });
    }
    getMessageCommand(e) {
        return $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "message"), JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: e,
            type: $d7238066c5de7f1c$var$On.instantMessage
        });
    }
}
var $d7238066c5de7f1c$var$CM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$aAe {
    /**
   * MeetingTranscriber constructor.
   * @constructor
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */ constructor(e){
        this.privAudioConfig = e, this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privRecognizer = void 0, this.privDisposedRecognizer = !1;
    }
    /**
   * Gets the spoken language of recognition.
   * @member MeetingTranscriber.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @returns {string} The spoken language of recognition.
   */ get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    /**
   * The collection of properties and their values defined for this MeetingTranscriber.
   * @member MeetingTranscriber.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this MeetingTranscriber.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * @Internal
   * Internal data member to support fromRecognizer* pattern methods on other classes.
   * Do not use externally, object returned will change without warning or notice.
   */ get internalData() {
        return this.privRecognizer.internalData;
    }
    /**
   * @Deprecated
   * @Obsolete
   * Please use the Connection.fromRecognizer pattern to obtain a connection object
   */ get connection() {
        return $d7238066c5de7f1c$var$DC.fromRecognizer(this.privRecognizer);
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member MeetingTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member MeetingTranscriber.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * @param {Meeting} meeting - meeting to be recognized
   */ joinMeetingAsync(e, t, i) {
        const n = e;
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined($d7238066c5de7f1c$var$LQ, "Meeting"), this.privRecognizer = new $d7238066c5de7f1c$var$i0e(e.config, this.privAudioConfig), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privRecognizer, "Recognizer"), this.privRecognizer.connectMeetingCallbacks(this), $d7238066c5de7f1c$var$ri(n.connectTranscriberRecognizer(this.privRecognizer), t, i);
    }
    /**
   * Starts meeting transcription, until stopTranscribingAsync() is called.
   * User must subscribe to events to receive transcription results.
   * @member MeetingTranscriber.prototype.startTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has started.
   * @param err - Callback invoked in case of an error.
   */ startTranscribingAsync(e, t) {
        this.privRecognizer.startContinuousRecognitionAsync(e, t);
    }
    /**
   * Starts meeting transcription, until stopTranscribingAsync() is called.
   * User must subscribe to events to receive transcription results.
   * @member MeetingTranscriber.prototype.stopTranscribingAsync
   * @function
   * @public
   * @param cb - Callback invoked once the transcription has started.
   * @param err - Callback invoked in case of an error.
   */ stopTranscribingAsync(e, t) {
        this.privRecognizer.stopContinuousRecognitionAsync(e, t);
    }
    /**
   * Leave the current meeting. After this is called, you will no longer receive any events.
   */ leaveMeetingAsync(e, t) {
        this.privRecognizer.disconnectCallbacks(), $d7238066c5de7f1c$var$ri($d7238066c5de7f1c$var$CM(this, void 0, void 0, function*() {}), e, t);
    }
    /**
   * closes all external resources held by an instance of this class.
   * @member MeetingTranscriber.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    /**
   * Disposes any resources held by the object.
   * @member MeetingTranscriber.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        return $d7238066c5de7f1c$var$CM(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (this.privRecognizer && (yield this.privRecognizer.close(), this.privRecognizer = void 0), e && (this.privDisposedRecognizer = !0));
        });
    }
}
class $d7238066c5de7f1c$var$zS extends $d7238066c5de7f1c$var$$R {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @public
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} speakerId - speaker id for conversation transcription.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s, a, o, g, l, c, d){
        super(e, t, i, n, s, a, o, l, c, d), this.privSpeakerId = g;
    }
    /**
   * speaker id
   * @member ConversationTranscriptionResult.prototype.speakerId
   * @function
   * @public
   * @returns {string} id of speaker in given result
   */ get speakerId() {
        return this.privSpeakerId;
    }
}
var $d7238066c5de7f1c$var$pM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$df {
    /**
   * Creates and initializes an instance of a Recognizer
   * @constructor
   * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
   */ constructor(e){
        const t = e;
        $d7238066c5de7f1c$var$U.throwIfNull(t, "speechConfig"), this.privProperties = t.properties.clone(), this.privDisposed = !1, this.privSynthesizing = !1, this.synthesisRequestQueue = new $d7238066c5de7f1c$var$ZB();
    }
    /**
   * Gets the authorization token used to communicate with the service.
   * @member Synthesizer.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */ get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    /**
   * Gets/Sets the authorization token used to communicate with the service.
   * @member Synthesizer.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */ set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    /**
   * The collection of properties and their values defined for this Synthesizer.
   * @member Synthesizer.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
   */ get properties() {
        return this.privProperties;
    }
    /**
   * Indicates if auto detect source language is enabled
   * @member Synthesizer.prototype.autoDetectSourceLanguage
   * @function
   * @public
   * @returns {boolean} if auto detect source language is enabled
   */ get autoDetectSourceLanguage() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages) === $d7238066c5de7f1c$var$t4;
    }
    buildSsml(e) {
        const t = {
            "af-ZA": "af-ZA-AdriNeural",
            "am-ET": "am-ET-AmehaNeural",
            "ar-AE": "ar-AE-FatimaNeural",
            "ar-BH": "ar-BH-AliNeural",
            "ar-DZ": "ar-DZ-AminaNeural",
            "ar-EG": "ar-EG-SalmaNeural",
            "ar-IQ": "ar-IQ-BasselNeural",
            "ar-JO": "ar-JO-SanaNeural",
            "ar-KW": "ar-KW-FahedNeural",
            "ar-LY": "ar-LY-ImanNeural",
            "ar-MA": "ar-MA-JamalNeural",
            "ar-QA": "ar-QA-AmalNeural",
            "ar-SA": "ar-SA-HamedNeural",
            "ar-SY": "ar-SY-AmanyNeural",
            "ar-TN": "ar-TN-HediNeural",
            "ar-YE": "ar-YE-MaryamNeural",
            "bg-BG": "bg-BG-BorislavNeural",
            "bn-BD": "bn-BD-NabanitaNeural",
            "bn-IN": "bn-IN-BashkarNeural",
            "ca-ES": "ca-ES-JoanaNeural",
            "cs-CZ": "cs-CZ-AntoninNeural",
            "cy-GB": "cy-GB-AledNeural",
            "da-DK": "da-DK-ChristelNeural",
            "de-AT": "de-AT-IngridNeural",
            "de-CH": "de-CH-JanNeural",
            "de-DE": "de-DE-KatjaNeural",
            "el-GR": "el-GR-AthinaNeural",
            "en-AU": "en-AU-NatashaNeural",
            "en-CA": "en-CA-ClaraNeural",
            "en-GB": "en-GB-LibbyNeural",
            "en-HK": "en-HK-SamNeural",
            "en-IE": "en-IE-ConnorNeural",
            "en-IN": "en-IN-NeerjaNeural",
            "en-KE": "en-KE-AsiliaNeural",
            "en-NG": "en-NG-AbeoNeural",
            "en-NZ": "en-NZ-MitchellNeural",
            "en-PH": "en-PH-JamesNeural",
            "en-SG": "en-SG-LunaNeural",
            "en-TZ": "en-TZ-ElimuNeural",
            "en-US": "en-US-JennyNeural",
            "en-ZA": "en-ZA-LeahNeural",
            "es-AR": "es-AR-ElenaNeural",
            "es-BO": "es-BO-MarceloNeural",
            "es-CL": "es-CL-CatalinaNeural",
            "es-CO": "es-CO-GonzaloNeural",
            "es-CR": "es-CR-JuanNeural",
            "es-CU": "es-CU-BelkysNeural",
            "es-DO": "es-DO-EmilioNeural",
            "es-EC": "es-EC-AndreaNeural",
            "es-ES": "es-ES-AlvaroNeural",
            "es-GQ": "es-GQ-JavierNeural",
            "es-GT": "es-GT-AndresNeural",
            "es-HN": "es-HN-CarlosNeural",
            "es-MX": "es-MX-DaliaNeural",
            "es-NI": "es-NI-FedericoNeural",
            "es-PA": "es-PA-MargaritaNeural",
            "es-PE": "es-PE-AlexNeural",
            "es-PR": "es-PR-KarinaNeural",
            "es-PY": "es-PY-MarioNeural",
            "es-SV": "es-SV-LorenaNeural",
            "es-US": "es-US-AlonsoNeural",
            "es-UY": "es-UY-MateoNeural",
            "es-VE": "es-VE-PaolaNeural",
            "et-EE": "et-EE-AnuNeural",
            "fa-IR": "fa-IR-DilaraNeural",
            "fi-FI": "fi-FI-SelmaNeural",
            "fil-PH": "fil-PH-AngeloNeural",
            "fr-BE": "fr-BE-CharlineNeural",
            "fr-CA": "fr-CA-SylvieNeural",
            "fr-CH": "fr-CH-ArianeNeural",
            "fr-FR": "fr-FR-DeniseNeural",
            "ga-IE": "ga-IE-ColmNeural",
            "gl-ES": "gl-ES-RoiNeural",
            "gu-IN": "gu-IN-DhwaniNeural",
            "he-IL": "he-IL-AvriNeural",
            "hi-IN": "hi-IN-MadhurNeural",
            "hr-HR": "hr-HR-GabrijelaNeural",
            "hu-HU": "hu-HU-NoemiNeural",
            "id-ID": "id-ID-ArdiNeural",
            "is-IS": "is-IS-GudrunNeural",
            "it-IT": "it-IT-IsabellaNeural",
            "ja-JP": "ja-JP-NanamiNeural",
            "jv-ID": "jv-ID-DimasNeural",
            "kk-KZ": "kk-KZ-AigulNeural",
            "km-KH": "km-KH-PisethNeural",
            "kn-IN": "kn-IN-GaganNeural",
            "ko-KR": "ko-KR-SunHiNeural",
            "lo-LA": "lo-LA-ChanthavongNeural",
            "lt-LT": "lt-LT-LeonasNeural",
            "lv-LV": "lv-LV-EveritaNeural",
            "mk-MK": "mk-MK-AleksandarNeural",
            "ml-IN": "ml-IN-MidhunNeural",
            "mr-IN": "mr-IN-AarohiNeural",
            "ms-MY": "ms-MY-OsmanNeural",
            "mt-MT": "mt-MT-GraceNeural",
            "my-MM": "my-MM-NilarNeural",
            "nb-NO": "nb-NO-PernilleNeural",
            "nl-BE": "nl-BE-ArnaudNeural",
            "nl-NL": "nl-NL-ColetteNeural",
            "pl-PL": "pl-PL-AgnieszkaNeural",
            "ps-AF": "ps-AF-GulNawazNeural",
            "pt-BR": "pt-BR-FranciscaNeural",
            "pt-PT": "pt-PT-DuarteNeural",
            "ro-RO": "ro-RO-AlinaNeural",
            "ru-RU": "ru-RU-SvetlanaNeural",
            "si-LK": "si-LK-SameeraNeural",
            "sk-SK": "sk-SK-LukasNeural",
            "sl-SI": "sl-SI-PetraNeural",
            "so-SO": "so-SO-MuuseNeural",
            "sr-RS": "sr-RS-NicholasNeural",
            "su-ID": "su-ID-JajangNeural",
            "sv-SE": "sv-SE-SofieNeural",
            "sw-KE": "sw-KE-RafikiNeural",
            "sw-TZ": "sw-TZ-DaudiNeural",
            "ta-IN": "ta-IN-PallaviNeural",
            "ta-LK": "ta-LK-KumarNeural",
            "ta-SG": "ta-SG-AnbuNeural",
            "te-IN": "te-IN-MohanNeural",
            "th-TH": "th-TH-PremwadeeNeural",
            "tr-TR": "tr-TR-AhmetNeural",
            "uk-UA": "uk-UA-OstapNeural",
            "ur-IN": "ur-IN-GulNeural",
            "ur-PK": "ur-PK-AsadNeural",
            "uz-UZ": "uz-UZ-MadinaNeural",
            "vi-VN": "vi-VN-HoaiMyNeural",
            "zh-CN": "zh-CN-XiaoxiaoNeural",
            "zh-HK": "zh-HK-HiuMaanNeural",
            "zh-TW": "zh-TW-HsiaoChenNeural",
            "zu-ZA": "zu-ZA-ThandoNeural"
        };
        let i = this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthLanguage, "en-US"), n = this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthVoice, ""), s = $d7238066c5de7f1c$var$df.XMLEncode(e);
        return this.autoDetectSourceLanguage ? i = "en-US" : n = n || t[i], n && (s = `<voice name='${n}'>${s}</voice>`), s = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${i}'>${s}</speak>`, s;
    }
    /**
   * This method performs cleanup of resources.
   * The Boolean parameter disposing indicates whether the method is called
   * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
   * Derived classes should override this method to dispose resource if needed.
   * @member Synthesizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - Flag to request disposal.
   */ dispose(e) {
        return $d7238066c5de7f1c$var$pM(this, void 0, void 0, function*() {
            this.privDisposed || (e && this.privAdapter && (yield this.privAdapter.dispose()), this.privDisposed = !0);
        });
    }
    adapterSpeak() {
        return $d7238066c5de7f1c$var$pM(this, void 0, void 0, function*() {
            if (!this.privDisposed && !this.privSynthesizing) {
                this.privSynthesizing = !0;
                const e = yield this.synthesisRequestQueue.dequeue();
                return this.privAdapter.Speak(e.text, e.isSSML, e.requestId, e.cb, e.err, e.dataStream);
            }
        });
    }
    createSynthesizerConfig(e) {
        return new $d7238066c5de7f1c$var$l0e(e, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
        let e = typeof window < "u" ? "Browser" : "Node", t = "unknown", i = "unknown";
        typeof navigator < "u" && (e = e + "/" + navigator.platform, t = navigator.userAgent, i = navigator.appVersion);
        const n = this.createSynthesizerConfig(new $d7238066c5de7f1c$var$rV(new $d7238066c5de7f1c$var$aV(new $d7238066c5de7f1c$var$e4(e, t, i)))), s = this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key, void 0), a = s && s !== "" ? new $d7238066c5de7f1c$var$BQ(s) : new $d7238066c5de7f1c$var$UC(()=>{
            const o = this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(o);
        }, ()=>{
            const o = this.privProperties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, void 0);
            return Promise.resolve(o);
        });
        this.privAdapter = this.createSynthesisAdapter(a, this.privConnectionFactory, n), this.privRestAdapter = this.createRestSynthesisAdapter(a, n);
    }
    static XMLEncode(e) {
        return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
}
class $d7238066c5de7f1c$var$YQ {
    constructor(e, t, i, n, s, a){
        this.requestId = e, this.text = t, this.isSSML = i, this.cb = n, this.err = s, this.dataStream = a;
    }
}
var $d7238066c5de7f1c$var$mM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$xK extends $d7238066c5de7f1c$var$df {
    /**
   * SpeechSynthesizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
   */ constructor(e, t){
        super(e), t !== null && (t === void 0 ? this.audioConfig = typeof window > "u" ? void 0 : $d7238066c5de7f1c$var$XI.fromDefaultSpeakerOutput() : this.audioConfig = t), this.privConnectionFactory = new $d7238066c5de7f1c$var$kQ(), this.implCommonSynthesizeSetup();
    }
    /**
   * SpeechSynthesizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
   * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
   */ static FromConfig(e, t, i) {
        const n = e;
        return t.properties.mergeTo(n.properties), new $d7238066c5de7f1c$var$xK(e, i);
    }
    /**
   * Executes speech synthesis on plain text.
   * The task returns the synthesis result.
   * @member SpeechSynthesizer.prototype.speakTextAsync
   * @function
   * @public
   * @param text - Text to be synthesized.
   * @param cb - Callback that received the SpeechSynthesisResult.
   * @param err - Callback invoked in case of an error.
   * @param stream - AudioOutputStream to receive the synthesized audio.
   */ speakTextAsync(e, t, i, n) {
        this.speakImpl(e, !1, t, i, n);
    }
    /**
   * Executes speech synthesis on SSML.
   * The task returns the synthesis result.
   * @member SpeechSynthesizer.prototype.speakSsmlAsync
   * @function
   * @public
   * @param ssml - SSML to be synthesized.
   * @param cb - Callback that received the SpeechSynthesisResult.
   * @param err - Callback invoked in case of an error.
   * @param stream - AudioOutputStream to receive the synthesized audio.
   */ speakSsmlAsync(e, t, i, n) {
        this.speakImpl(e, !0, t, i, n);
    }
    /**
   * Get list of synthesis voices available.
   * The task returns the synthesis voice result.
   * @member SpeechSynthesizer.prototype.getVoicesAsync
   * @function
   * @async
   * @public
   * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
   * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
   */ getVoicesAsync(e = "") {
        return $d7238066c5de7f1c$var$mM(this, void 0, void 0, function*() {
            return this.getVoices(e);
        });
    }
    /**
   * Dispose of associated resources.
   * @member SpeechSynthesizer.prototype.close
   * @function
   * @public
   */ close(e, t) {
        $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed), $d7238066c5de7f1c$var$ri(this.dispose(!0), e, t);
    }
    /**
   * @Internal
   * Do not use externally, object returned will change without warning or notice.
   */ get internalData() {
        return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(e, t, i) {
        return new $d7238066c5de7f1c$var$o0e(e, t, i, this, this.audioConfig);
    }
    createRestSynthesisAdapter(e, t) {
        return new $d7238066c5de7f1c$var$g0e(t, e);
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup(), this.privAdapter.audioOutputFormat = $d7238066c5de7f1c$var$Ut.fromSpeechSynthesisOutputFormat($d7238066c5de7f1c$var$$t[this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, void 0)]);
    }
    speakImpl(e, t, i, n, s) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed);
            const a = $d7238066c5de7f1c$var$Rn();
            let o;
            s instanceof $d7238066c5de7f1c$var$bK ? o = new $d7238066c5de7f1c$var$AK(s) : s instanceof $d7238066c5de7f1c$var$cf ? o = s : s !== void 0 ? o = new $d7238066c5de7f1c$var$fQ(s) : o = void 0, this.synthesisRequestQueue.enqueue(new $d7238066c5de7f1c$var$YQ(a, e, t, (g)=>{
                if (this.privSynthesizing = !1, i) try {
                    i(g);
                } catch (l) {
                    n && n(l);
                }
                i = void 0, this.adapterSpeak().catch(()=>{});
            }, (g)=>{
                n && n(g);
            }, o)), this.adapterSpeak().catch(()=>{});
        } catch (a) {
            if (n) {
                if (a instanceof Error) {
                    const o = a;
                    n(o.name + ": " + o.message);
                } else n(a);
            }
            this.dispose(!0).catch(()=>{});
        }
    }
    getVoices(e) {
        return $d7238066c5de7f1c$var$mM(this, void 0, void 0, function*() {
            const t = $d7238066c5de7f1c$var$Rn(), i = yield this.privRestAdapter.getVoicesList(t);
            if (i.ok && Array.isArray(i.json)) {
                let n = i.json;
                return e && e.length > 0 && (n = n.filter((s)=>!!s.Locale && s.Locale.toLowerCase() === e.toLowerCase())), new $d7238066c5de7f1c$var$GN(t, n, void 0);
            } else return new $d7238066c5de7f1c$var$GN(t, void 0, `Error: ${i.status}: ${i.statusText}`);
        });
    }
}
class $d7238066c5de7f1c$var$zC {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n){
        this.privResultId = e, this.privReason = t, this.privErrorDetails = i, this.privProperties = n;
    }
    /**
   * Specifies the result identifier.
   * @member SynthesisResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */ get resultId() {
        return this.privResultId;
    }
    /**
   * Specifies status of the result.
   * @member SynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */ get reason() {
        return this.privReason;
    }
    /**
   * In case of an unsuccessful synthesis, provides details of the occurred error.
   * @member SynthesisResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
   * The set of properties exposed in the result.
   * @member SynthesisResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */ get properties() {
        return this.privProperties;
    }
}
class $d7238066c5de7f1c$var$HB extends $d7238066c5de7f1c$var$zC {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {ArrayBuffer} audioData - The synthesized audio binary.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   * @param {number} audioDuration - The audio duration.
   */ constructor(e, t, i, n, s, a){
        super(e, t, n, s), this.privAudioData = i, this.privAudioDuration = a;
    }
    /**
   * The synthesized audio data
   * @member SpeechSynthesisResult.prototype.audioData
   * @function
   * @public
   * @returns {ArrayBuffer} The synthesized audio data.
   */ get audioData() {
        return this.privAudioData;
    }
    /**
   * The time duration of synthesized audio, in ticks (100 nanoseconds).
   * @member SpeechSynthesisResult.prototype.audioDuration
   * @function
   * @public
   * @returns {number} The time duration of synthesized audio.
   */ get audioDuration() {
        return this.privAudioDuration;
    }
}
class $d7238066c5de7f1c$var$Wy {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechSynthesisResult} result - The speech synthesis result.
   */ constructor(e){
        this.privResult = e;
    }
    /**
   * Specifies the synthesis result.
   * @member SpeechSynthesisEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechSynthesisResult} the synthesis result.
   */ get result() {
        return this.privResult;
    }
}
class $d7238066c5de7f1c$var$KQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} duration - The audio duration.
   * @param {string} text - The text.
   * @param {number} wordLength - The length of the word.
   * @param {number} textOffset - The text offset.
   * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
   */ constructor(e, t, i, n, s, a){
        this.privAudioOffset = e, this.privDuration = t, this.privText = i, this.privWordLength = n, this.privTextOffset = s, this.privBoundaryType = a;
    }
    /**
   * Specifies the audio offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
   * Specifies the duration, in ticks (100 nanoseconds).
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
   * @function
   * @public
   * @returns {number} Duration in 100 nanosecond increments.
   */ get duration() {
        return this.privDuration;
    }
    /**
   * Specifies the text of the word boundary event.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the text.
   */ get text() {
        return this.privText;
    }
    /**
   * Specifies the word length
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
   * @function
   * @public
   * @returns {number} the word length
   */ get wordLength() {
        return this.privWordLength;
    }
    /**
   * Specifies the text offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
   * @function
   * @public
   * @returns {number} the text offset.
   */ get textOffset() {
        return this.privTextOffset;
    }
    /**
   * Specifies the boundary type.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
   * @function
   * @public
   * @returns {SpeechSynthesisBoundaryType} the boundary type.
   */ get boundaryType() {
        return this.privBoundaryType;
    }
}
class $d7238066c5de7f1c$var$xQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} text - The bookmark text.
   */ constructor(e, t){
        this.privAudioOffset = e, this.privText = t;
    }
    /**
   * Specifies the audio offset.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
   * Specifies the bookmark.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the bookmark text.
   */ get text() {
        return this.privText;
    }
}
class $d7238066c5de7f1c$var$FQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} visemeId - The viseme ID.
   * @param {string} animation - The animation, could be in svg or other format.
   */ constructor(e, t, i){
        this.privAudioOffset = e, this.privVisemeId = t, this.privAnimation = i;
    }
    /**
   * Specifies the audio offset.
   * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
   * Specifies the viseme ID.
   * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
   * @function
   * @public
   * @returns {number} the viseme ID.
   */ get visemeId() {
        return this.privVisemeId;
    }
    /**
   * Specifies the animation.
   * @member SpeechSynthesisVisemeEventArgs.prototype.animation
   * @function
   * @public
   * @returns {string} the animation, could be in svg or other format.
   */ get animation() {
        return this.privAnimation;
    }
}
var $d7238066c5de7f1c$var$fN;
(function(r) {
    r.Word = "WordBoundary", r.Punctuation = "PunctuationBoundary", r.Sentence = "SentenceBoundary";
})($d7238066c5de7f1c$var$fN || ($d7238066c5de7f1c$var$fN = {}));
class $d7238066c5de7f1c$var$GN extends $d7238066c5de7f1c$var$zC {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param requestId - result id for request.
   * @param json - json payload from endpoint.
   */ constructor(e, t, i){
        if (Array.isArray(t)) {
            super(e, $d7238066c5de7f1c$var$At.VoicesListRetrieved, void 0, new $d7238066c5de7f1c$var$vi()), this.privVoices = [];
            for (const n of t)this.privVoices.push(new $d7238066c5de7f1c$var$TQ(n));
        } else super(e, $d7238066c5de7f1c$var$At.Canceled, i || "Error information unavailable", new $d7238066c5de7f1c$var$vi());
    }
    /**
   * The list of voices
   * @member SynthesisVoicesResult.prototype.voices
   * @function
   * @public
   * @returns {VoiceInfo[]} List of synthesized voices.
   */ get voices() {
        return this.privVoices;
    }
}
var $d7238066c5de7f1c$var$$y;
(function(r) {
    r[r.Unknown = 0] = "Unknown", r[r.Female = 1] = "Female", r[r.Male = 2] = "Male";
})($d7238066c5de7f1c$var$$y || ($d7238066c5de7f1c$var$$y = {}));
var $d7238066c5de7f1c$var$_Z;
(function(r) {
    r[r.OnlineNeural = 1] = "OnlineNeural", r[r.OnlineStandard = 2] = "OnlineStandard", r[r.OfflineNeural = 3] = "OfflineNeural", r[r.OfflineStandard = 4] = "OfflineStandard";
})($d7238066c5de7f1c$var$_Z || ($d7238066c5de7f1c$var$_Z = {}));
class $d7238066c5de7f1c$var$TQ {
    constructor(e){
        if (this.privStyleList = [], this.privVoicePath = "", e && (this.privName = e.Name, this.privLocale = e.Locale, this.privShortName = e.ShortName, this.privLocaleName = e.LocaleName, this.privDisplayName = e.DisplayName, this.privLocalName = e.LocalName, this.privVoiceType = e.VoiceType.endsWith("Standard") ? $d7238066c5de7f1c$var$_Z.OnlineStandard : $d7238066c5de7f1c$var$_Z.OnlineNeural, this.privGender = e.Gender === "Male" ? $d7238066c5de7f1c$var$$y.Male : e.Gender === "Female" ? $d7238066c5de7f1c$var$$y.Female : $d7238066c5de7f1c$var$$y.Unknown, e.StyleList && Array.isArray(e.StyleList))) for (const t of e.StyleList)this.privStyleList.push(t);
    }
    get name() {
        return this.privName;
    }
    get locale() {
        return this.privLocale;
    }
    get shortName() {
        return this.privShortName;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get localName() {
        return this.privLocalName;
    }
    get localeName() {
        return this.privLocaleName;
    }
    get gender() {
        return this.privGender;
    }
    get voiceType() {
        return this.privVoiceType;
    }
    get styleList() {
        return this.privStyleList;
    }
    get voicePath() {
        return this.privVoicePath;
    }
}
var $d7238066c5de7f1c$var$fX = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
const $d7238066c5de7f1c$var$oAe = 1800, $d7238066c5de7f1c$var$AM = {
    [$d7238066c5de7f1c$var$Lt.PCM]: "audio/wav",
    [$d7238066c5de7f1c$var$Lt.MuLaw]: "audio/x-wav",
    [$d7238066c5de7f1c$var$Lt.MP3]: "audio/mpeg",
    [$d7238066c5de7f1c$var$Lt.OGG_OPUS]: "audio/ogg",
    [$d7238066c5de7f1c$var$Lt.WEBM_OPUS]: "audio/webm; codecs=opus",
    [$d7238066c5de7f1c$var$Lt.ALaw]: "audio/x-wav",
    [$d7238066c5de7f1c$var$Lt.FLAC]: "audio/flac"
};
class $d7238066c5de7f1c$var$vN {
    constructor(e){
        this.privPlaybackStarted = !1, this.privAppendingToBuffer = !1, this.privMediaSourceOpened = !1, this.privBytesReceived = 0, this.privId = e || $d7238066c5de7f1c$var$Rn(), this.privIsPaused = !1, this.privIsClosed = !1;
    }
    id() {
        return this.privId;
    }
    write(e, t, i) {
        this.privAudioBuffer !== void 0 ? (this.privAudioBuffer.push(e), this.updateSourceBuffer().then(()=>{
            t && t();
        }, (n)=>{
            i && i(n);
        })) : this.privAudioOutputStream !== void 0 && (this.privAudioOutputStream.write(e), this.privBytesReceived += e.byteLength);
    }
    close(e, t) {
        if (this.privIsClosed = !0, this.privSourceBuffer !== void 0) this.handleSourceBufferUpdateEnd().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        });
        else if (this.privAudioOutputStream !== void 0 && typeof window < "u") {
            if ((this.privFormat.formatTag === $d7238066c5de7f1c$var$Lt.PCM || this.privFormat.formatTag === $d7238066c5de7f1c$var$Lt.MuLaw || this.privFormat.formatTag === $d7238066c5de7f1c$var$Lt.ALaw) && this.privFormat.hasHeader === !1) console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header."), this.onAudioEnd && this.onAudioEnd(this);
            else {
                let i = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(i).then(()=>{
                    i = this.privFormat.addHeader(i);
                    const n = new Blob([
                        i
                    ], {
                        type: $d7238066c5de7f1c$var$AM[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(n), this.notifyPlayback().then(()=>{
                        e && e();
                    }, (s)=>{
                        t && t(s);
                    });
                }, (n)=>{
                    t && t(n);
                });
            }
        } else this.onAudioEnd && this.onAudioEnd(this);
    }
    set format(e) {
        if (typeof AudioContext < "u" || typeof window < "u" && typeof window.webkitAudioContext < "u") {
            this.privFormat = e;
            const t = $d7238066c5de7f1c$var$AM[this.privFormat.formatTag];
            t === void 0 ? console.warn(`Unknown mimeType for format ${$d7238066c5de7f1c$var$Lt[this.privFormat.formatTag]}; playback is not supported.`) : typeof MediaSource < "u" && MediaSource.isTypeSupported(t) ? (this.privAudio = new Audio(), this.privAudioBuffer = [], this.privMediaSource = new MediaSource(), this.privAudio.src = URL.createObjectURL(this.privMediaSource), this.privAudio.load(), this.privMediaSource.onsourceopen = ()=>{
                this.privMediaSourceOpened = !0, this.privMediaSource.duration = $d7238066c5de7f1c$var$oAe, this.privSourceBuffer = this.privMediaSource.addSourceBuffer(t), this.privSourceBuffer.onupdate = ()=>{
                    this.updateSourceBuffer().catch((i)=>{
                        $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(i));
                    });
                }, this.privSourceBuffer.onupdateend = ()=>{
                    this.handleSourceBufferUpdateEnd().catch((i)=>{
                        $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(i));
                    });
                }, this.privSourceBuffer.onupdatestart = ()=>{
                    this.privAppendingToBuffer = !1;
                };
            }, this.updateSourceBuffer().catch((i)=>{
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(i));
            })) : (console.warn(`Format ${$d7238066c5de7f1c$var$Lt[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`), this.privAudioOutputStream = new $d7238066c5de7f1c$var$pK(), this.privAudioOutputStream.format = this.privFormat, this.privAudio = new Audio());
        }
    }
    get volume() {
        var e, t;
        return (t = (e = this.privAudio) === null || e === void 0 ? void 0 : e.volume) !== null && t !== void 0 ? t : -1;
    }
    set volume(e) {
        this.privAudio && (this.privAudio.volume = e);
    }
    mute() {
        this.privAudio && (this.privAudio.muted = !0);
    }
    unmute() {
        this.privAudio && (this.privAudio.muted = !1);
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        return this.privAudio !== void 0 ? this.privAudio.currentTime : -1;
    }
    pause() {
        !this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.pause(), this.privIsPaused = !0);
    }
    resume(e, t) {
        this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.play().then(()=>{
            e && e();
        }, (i)=>{
            t && t(i);
        }), this.privIsPaused = !1);
    }
    get internalAudio() {
        return this.privAudio;
    }
    updateSourceBuffer() {
        return $d7238066c5de7f1c$var$fX(this, void 0, void 0, function*() {
            if (this.privAudioBuffer !== void 0 && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
                this.privAppendingToBuffer = !0;
                const e = this.privAudioBuffer.shift();
                try {
                    this.privSourceBuffer.appendBuffer(e);
                } catch  {
                    this.privAudioBuffer.unshift(e), console.log("buffer filled, pausing addition of binaries until space is made");
                    return;
                }
                yield this.notifyPlayback();
            } else this.canEndStream() && (yield this.handleSourceBufferUpdateEnd());
        });
    }
    handleSourceBufferUpdateEnd() {
        return $d7238066c5de7f1c$var$fX(this, void 0, void 0, function*() {
            this.canEndStream() && this.sourceBufferAvailable() && (this.privMediaSource.endOfStream(), yield this.notifyPlayback());
        });
    }
    notifyPlayback() {
        return $d7238066c5de7f1c$var$fX(this, void 0, void 0, function*() {
            !this.privPlaybackStarted && this.privAudio !== void 0 && (this.privPlaybackStarted = !0, this.onAudioStart && this.onAudioStart(this), this.privAudio.onended = ()=>{
                this.onAudioEnd && this.onAudioEnd(this);
            }, this.privIsPaused || (yield this.privAudio.play()));
        });
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== void 0 && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== void 0 && !this.privSourceBuffer.updating;
    }
}
class $d7238066c5de7f1c$var$FK extends $d7238066c5de7f1c$var$eV {
}
class $d7238066c5de7f1c$var$MQ extends $d7238066c5de7f1c$var$eV {
}
var $d7238066c5de7f1c$var$XB;
(function(r) {
    r[r.FivePoint = 1] = "FivePoint", r[r.HundredMark = 2] = "HundredMark";
})($d7238066c5de7f1c$var$XB || ($d7238066c5de7f1c$var$XB = {}));
var $d7238066c5de7f1c$var$NB;
(function(r) {
    r[r.Phoneme = 1] = "Phoneme", r[r.Word = 2] = "Word", r[r.FullText = 3] = "FullText";
})($d7238066c5de7f1c$var$NB || ($d7238066c5de7f1c$var$NB = {}));
class $d7238066c5de7f1c$var$TK {
    /**
   * PronunciationAssessmentConfig constructor.
   * @constructor
   * @param {string} referenceText
   * @param gradingSystem
   * @param granularity
   * @param enableMiscue
   */ constructor(e, t = $d7238066c5de7f1c$var$XB.FivePoint, i = $d7238066c5de7f1c$var$NB.Phoneme, n = !1){
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "referenceText"), this.privProperties = new $d7238066c5de7f1c$var$vi(), this.privProperties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_ReferenceText, e), this.privProperties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_GradingSystem, $d7238066c5de7f1c$var$XB[t]), this.privProperties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Granularity, $d7238066c5de7f1c$var$NB[i]), this.privProperties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_EnableMiscue, String(n));
    }
    /**
   * @member PronunciationAssessmentConfig.fromJSON
   * @function
   * @public
   * @param {string} json The json string containing the pronunciation assessment parameters.
   * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
   * @summary Creates an instance of the PronunciationAssessmentConfig from json.
   * This method is designed to support the pronunciation assessment parameters still in preview.
   * Under normal circumstances, use the constructor instead.
   */ static fromJSON(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "json");
        const t = new $d7238066c5de7f1c$var$TK("");
        return t.privProperties = new $d7238066c5de7f1c$var$vi(), t.properties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Json, e), t;
    }
    toJSON() {
        return this.updateJson(), this.privProperties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Params);
    }
    applyTo(e) {
        this.updateJson();
        const t = e.internalData;
        t.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Params), this.privContentAssessmentTopic, t.isSpeakerDiarizationEnabled);
    }
    /**
   * Gets the reference text.
   * @member PronunciationAssessmentConfig.prototype.referenceText
   * @function
   * @public
   * @returns {string} Reference text.
   */ get referenceText() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_ReferenceText);
    }
    /**
   * Gets/Sets the reference text.
   * @member PronunciationAssessmentConfig.prototype.referenceText
   * @function
   * @public
   * @param {string} referenceText - Reference text.
   */ set referenceText(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "referenceText"), this.properties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_ReferenceText, e);
    }
    /**
   * Sets the phoneme alphabet.
   * The valid values are "SAPI" (default) and "IPA".
   * Added in version 1.20.0
   * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
   * @function
   * @public
   * @param {string} phonemeAlphabet - Phoneme alphabet.
   */ set phonemeAlphabet(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "phonemeAlphabet"), this.privPhonemeAlphabet = e;
    }
    /**
   * Sets the boolean enableMiscue property.
   * Added in version 1.26.0
   * @member PronunciationAssessmentConfig.prototype.enableMiscue
   * @function
   * @public
   * @param {boolean} enableMiscue - enable miscue.
   */ set enableMiscue(e) {
        const t = e ? "true" : "false";
        this.properties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_EnableMiscue, t);
    }
    /**
   * Gets the boolean enableMiscue property.
   * Added in version 1.26.0
   * @member PronunciationAssessmentConfig.prototype.enableMiscue
   * @function
   * @public
   * @return {boolean} enableMiscue - enable miscue.
   */ get enableMiscue() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_EnableMiscue, "false").toLowerCase() === "true";
    }
    /**
   * Sets the nbest phoneme count
   * Added in version 1.20.0
   * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
   * @function
   * @public
   * @param {number} nbestPhonemeCount - NBest phoneme count.
   */ set nbestPhonemeCount(e) {
        this.privNBestPhonemeCount = e;
    }
    /**
   * Enables the prosody assessment.
   * Added in version 1.34.0
   * @member PronunciationAssessmentConfig.prototype.enableProsodyAssessment
   * @function
   * @public
   * @param {boolean} enableProsodyAssessment - enable prosody assessment.
   */ set enableProsodyAssessment(e) {
        this.privEnableProsodyAssessment = e;
    }
    /**
   * Enables content assessment and sets the topic.
   * Added in version 1.34.0
   * @member PronunciationAssessmentConfig.prototype.enableContentAssessmentWithTopic
   * @function
   * @public
   * @param {string} topic - Topic for content assessment.
   */ enableContentAssessmentWithTopic(e) {
        this.privContentAssessmentTopic = e;
    }
    /**
   * @member PronunciationAssessmentConfig.prototype.properties
   * @function
   * @public
   * @return {PropertyCollection} Properties of the config.
   * @summary Gets a pronunciation assessment config properties
   */ get properties() {
        return this.privProperties;
    }
    updateJson() {
        const e = this.privProperties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Json, "{}"), t = JSON.parse(e), i = this.privProperties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_ReferenceText);
        i && (t.referenceText = i);
        const n = this.privProperties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_GradingSystem);
        n && (t.gradingSystem = n);
        const s = this.privProperties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Granularity);
        s && (t.granularity = s), this.privPhonemeAlphabet && (t.phonemeAlphabet = this.privPhonemeAlphabet), this.privNBestPhonemeCount && (t.nbestPhonemeCount = this.privNBestPhonemeCount), t.enableProsodyAssessment = this.privEnableProsodyAssessment, t.dimension = "Comprehensive", this.privProperties.getProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_EnableMiscue) && (t.enableMiscue = this.enableMiscue), this.privProperties.setProperty($d7238066c5de7f1c$var$T.PronunciationAssessment_Params, JSON.stringify(t));
    }
}
class $d7238066c5de7f1c$var$gAe {
    /**
   * @Internal
   * Do not use externally.
   */ constructor(e){
        this.privPronJson = e;
    }
    /**
   * Correctness in using grammar and variety of sentence patterns.
   * Grammatical errors are jointly evaluated by lexical accuracy,
   * grammatical accuracy and diversity of sentence structures.
   * @member ContentAssessmentResult.prototype.grammarScore
   * @function
   * @public
   * @returns {number} Grammar score.
   */ get grammarScore() {
        return this.privPronJson.ContentAssessment.GrammarScore;
    }
    /**
   * Proficiency in lexical usage. It evaluates the speaker's effective usage
   * of words and their appropriateness within the given context to express
   * ideas accurately, as well as level of lexical complexity.
   * @member ContentAssessmentResult.prototype.vocabularyScore
   * @function
   * @public
   * @returns {number} Vocabulary score.
   */ get vocabularyScore() {
        return this.privPronJson.ContentAssessment.VocabularyScore;
    }
    /**
   * Level of understanding and engagement with the topic, which provides
   * insights into the speaker’s ability to express their thoughts and ideas
   * effectively and the ability to engage with the topic.
   * @member ContentAssessmentResult.prototype.topicScore
   * @function
   * @public
   * @returns {number} Topic score.
   */ get topicScore() {
        return this.privPronJson.ContentAssessment.TopicScore;
    }
}
class $d7238066c5de7f1c$var$MK {
    constructor(e){
        const t = JSON.parse(e);
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(t.NBest[0], "NBest"), this.privPronJson = t.NBest[0];
    }
    /**
   * @member PronunciationAssessmentResult.fromResult
   * @function
   * @public
   * @param {RecognitionResult} result The recognition result.
   * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
   * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
   */ static fromResult(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "result");
        const t = e.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult);
        return $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(t, "json"), new $d7238066c5de7f1c$var$MK(t);
    }
    /**
   * Gets the detail result of pronunciation assessment.
   * @member PronunciationAssessmentConfig.prototype.detailResult
   * @function
   * @public
   * @returns {DetailResult} detail result.
   */ get detailResult() {
        return this.privPronJson;
    }
    /**
   * The score indicating the pronunciation accuracy of the given speech, which indicates
   * how closely the phonemes match a native speaker's pronunciation.
   * @member PronunciationAssessmentResult.prototype.accuracyScore
   * @function
   * @public
   * @returns {number} Accuracy score.
   */ get accuracyScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.AccuracyScore;
    }
    /**
   * The overall score indicating the pronunciation quality of the given speech.
   * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
   * @member PronunciationAssessmentResult.prototype.pronunciationScore
   * @function
   * @public
   * @returns {number} Pronunciation score.
   */ get pronunciationScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.PronScore;
    }
    /**
   * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
   * @member PronunciationAssessmentResult.prototype.completenessScore
   * @function
   * @public
   * @returns {number} Completeness score.
   */ get completenessScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.CompletenessScore;
    }
    /**
   * The score indicating the fluency of the given speech.
   * @member PronunciationAssessmentResult.prototype.fluencyScore
   * @function
   * @public
   * @returns {number} Fluency score.
   */ get fluencyScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.FluencyScore;
    }
    /**
   * The prosody score, which indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.
   * @member PronunciationAssessmentResult.prototype.prosodyScore
   * @function
   * @public
   * @returns {number} Prosody score.
   */ get prosodyScore() {
        var e;
        return (e = this.detailResult.PronunciationAssessment) === null || e === void 0 ? void 0 : e.ProsodyScore;
    }
    /**
   * The concent assessment result.
   * Only available when content assessment is enabled.
   * @member PronunciationAssessmentResult.prototype.contentAssessmentResult
   * @function
   * @public
   * @returns {ContentAssessmentResult} Content assessment result.
   */ get contentAssessmentResult() {
        if (this.detailResult.ContentAssessment !== void 0) return new $d7238066c5de7f1c$var$gAe(this.detailResult);
    }
}
class $d7238066c5de7f1c$var$lAe {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} character - The avatar character.
   * @param {string} style - The avatar style.
   * @param {AvatarVideoFormat} videoFormat - The talking avatar output video format.
   */ constructor(e, t, i){
        this.privCustomized = !1, $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "character"), this.character = e, this.style = t, i === void 0 && (i = new $d7238066c5de7f1c$var$EQ()), this.videoFormat = i;
    }
    /**
   * Indicates if the talking avatar is customized.
   */ get customized() {
        return this.privCustomized;
    }
    /**
   * Sets if the talking avatar is customized.
   */ set customized(e) {
        this.privCustomized = e;
    }
    /**
   * Sets the background color.
   */ get backgroundColor() {
        return this.privBackgroundColor;
    }
    /**
   * Gets the background color.
   */ set backgroundColor(e) {
        this.privBackgroundColor = e;
    }
}
var $d7238066c5de7f1c$var$bM;
(function(r) {
    r.SwitchedToSpeaking = "SwitchedToSpeaking", r.SwitchedToIdle = "SwitchedToIdle", r.SessionClosed = "SessionClosed";
})($d7238066c5de7f1c$var$bM || ($d7238066c5de7f1c$var$bM = {}));
class $d7238066c5de7f1c$var$zQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} description - The description of the event.
   */ constructor(e, t){
        this.privOffset = e, this.privDescription = t;
    }
    /**
   * The type of the event.
   * @public
   * @returns {AvatarEventTypes} The type of the event.
   */ get type() {
        return this.privType;
    }
    /**
   * The time offset associated with this event.
   * @public
   * @returns {number} The time offset associated with this event.
   */ get offset() {
        return this.privOffset;
    }
    /**
   * The description of the event.
   * @public
   * @returns {string} The description of the event.
   */ get description() {
        return this.privDescription;
    }
}
class $d7238066c5de7f1c$var$kQ {
    constructor(){
        this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, void 0), a = $d7238066c5de7f1c$var$Rr.getHostSuffix(s), o = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, void 0), g = o === void 0 ? "tts" : "voice", l = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "wss://" + s + "." + g + ".speech" + a), c = {}, d = {};
        t.token !== void 0 && t.token !== "" && (d[t.headerName] = t.token), d[$d7238066c5de7f1c$var$Fi.ConnectionId] = i, o !== void 0 && o !== "" && (!n || n.search($d7238066c5de7f1c$var$dt.CustomVoiceDeploymentId) === -1) && (c[$d7238066c5de7f1c$var$dt.CustomVoiceDeploymentId] = o), e.avatarEnabled && (!n || n.search($d7238066c5de7f1c$var$dt.EnableAvatar) === -1) && (c[$d7238066c5de7f1c$var$dt.EnableAvatar] = "true"), n || (n = l + this.synthesisUri), e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, n);
        const p = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(n, c, d, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromParameters(e.parameters), p, i);
    }
}
var $d7238066c5de7f1c$var$BC = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$cAe extends $d7238066c5de7f1c$var$df {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechConfig} speechConfig - The speech config.
   * @param {AvatarConfig} avatarConfig - The talking avatar config.
   */ constructor(e, t){
        super(e), $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(t, "avatarConfig"), this.privConnectionFactory = new $d7238066c5de7f1c$var$kQ(), this.privAvatarConfig = t, this.implCommonSynthesizeSetup();
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup(), this.privAdapter.audioOutputFormat = $d7238066c5de7f1c$var$Ut.fromSpeechSynthesisOutputFormat($d7238066c5de7f1c$var$$t.Riff24Khz16BitMonoPcm);
    }
    /**
   * Starts the talking avatar session and establishes the WebRTC connection.
   * @member AvatarSynthesizer.prototype.startAvatarAsync
   * @function
   * @public
   * @param {AvatarWebRTCConnectionInfo} peerConnection - The peer connection.
   * @returns {Promise<SynthesisResult>} The promise of the connection result.
   */ startAvatarAsync(e) {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "peerConnection"), this.privIceServers = e.getConfiguration().iceServers, $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privIceServers, "Ice servers must be set.");
            const t = new $d7238066c5de7f1c$var$Ui();
            e.onicegatheringstatechange = ()=>{
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$lu("peer connection: ice gathering state: " + e.iceGatheringState, $d7238066c5de7f1c$var$Ys.Debug)), e.iceGatheringState === "complete" && ($d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$lu("peer connection: ice gathering complete.", $d7238066c5de7f1c$var$Ys.Info)), t.resolve());
            };
            const i = yield e.createOffer();
            yield e.setLocalDescription(i), yield t.promise, $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$lu("peer connection: got local SDP.", $d7238066c5de7f1c$var$Ys.Info)), this.privProperties.setProperty($d7238066c5de7f1c$var$T.TalkingAvatarService_WebRTC_SDP, JSON.stringify(e.localDescription));
            const n = yield this.speak("", !1), s = atob(n.properties.getProperty($d7238066c5de7f1c$var$T.TalkingAvatarService_WebRTC_SDP)), a = new RTCSessionDescription(JSON.parse(s));
            return yield e.setRemoteDescription(a), new $d7238066c5de7f1c$var$zC(n.resultId, n.reason, void 0, n.properties);
        });
    }
    /**
   * Speaks plain text asynchronously. The rendered audio and video will be sent via the WebRTC connection.
   * @member AvatarSynthesizer.prototype.speakTextAsync
   * @function
   * @public
   * @param {string} text - The plain text to speak.
   * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
   */ speakTextAsync(e) {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            const t = yield this.speak(e, !1);
            return new $d7238066c5de7f1c$var$zC(t.resultId, t.reason, t.errorDetails, t.properties);
        });
    }
    /**
   * Speaks SSML asynchronously. The rendered audio and video will be sent via the WebRTC connection.
   * @member AvatarSynthesizer.prototype.speakSsmlAsync
   * @function
   * @public
   * @param {string} ssml - The SSML text to speak.
   * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
   */ speakSsmlAsync(e) {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            const t = yield this.speak(e, !0);
            return new $d7238066c5de7f1c$var$zC(t.resultId, t.reason, t.errorDetails, t.properties);
        });
    }
    /**
   * Speaks text asynchronously. The avatar will switch to idle state.
   * @member AvatarSynthesizer.prototype.stopSpeakingAsync
   * @function
   * @public
   * @returns {Promise<void>} The promise of the void result.
   */ stopSpeakingAsync() {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            return this.privAdapter.stopSpeaking();
        });
    }
    /**
   * Stops the talking avatar session and closes the WebRTC connection.
   * For now, this is the same as close().
   * You need to create a new AvatarSynthesizer instance to start a new session.
   * @member AvatarSynthesizer.prototype.stopAvatarAsync
   * @function
   * @public
   * @returns {Promise<void>} The promise of the void result.
   */ stopAvatarAsync() {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposed), this.dispose(!0);
        });
    }
    /**
   * Dispose of associated resources.
   * @member AvatarSynthesizer.prototype.close
   * @function
   * @public
   */ close() {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            if (!this.privDisposed) return this.dispose(!0);
        });
    }
    /**
   * Gets the ICE servers. Internal use only.
   */ get iceServers() {
        return this.privIceServers;
    }
    // Creates the synthesis adapter
    createSynthesisAdapter(e, t, i) {
        return new $d7238066c5de7f1c$var$a0e(e, t, i, this, this.privAvatarConfig);
    }
    createRestSynthesisAdapter(e, t) {}
    createSynthesizerConfig(e) {
        const t = super.createSynthesizerConfig(e);
        return t.avatarEnabled = !0, t;
    }
    speak(e, t) {
        return $d7238066c5de7f1c$var$BC(this, void 0, void 0, function*() {
            const i = $d7238066c5de7f1c$var$Rn(), n = new $d7238066c5de7f1c$var$Ui();
            return this.synthesisRequestQueue.enqueue(new $d7238066c5de7f1c$var$YQ(i, e, t, (s)=>{
                n.resolve(s), this.privSynthesizing = !1, this.adapterSpeak();
            }, (s)=>{
                n.reject(s), this.privSynthesizing = !1;
            })), this.adapterSpeak(), n.promise;
        });
    }
}
class $d7238066c5de7f1c$var$uAe {
    constructor(e, t){
        this.x = e, this.y = t;
    }
}
class $d7238066c5de7f1c$var$EQ {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} codec - The video codec.
   * @param {number} bitrate - The video bitrate.
   * @param {number} width - The video width.
   * @param {number} height - The video height.
   */ constructor(e = "H264", t = 2e6, i = 1920, n = 1080){
        this.codec = e, this.bitrate = t, this.width = i, this.height = n;
    }
    /**
   * Sets the video crop range.
   */ setCropRange(e, t) {
        this.cropRange = {
            bottomRight: t,
            topLeft: e
        };
    }
}
class $d7238066c5de7f1c$var$IAe extends $d7238066c5de7f1c$var$zC {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {RTCSessionDescriptionInit} SDPAnswer - The SDP answer of WebRTC connection.
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */ constructor(e, t, i, n, s){
        super(t, i, n, s), this.privSDPAnswer = e;
    }
    /**
   * Specifies SDP (Session Description Protocol) answer of WebRTC connection.
   * @member AvatarWebRTCConnectionResult.prototype.SDPAnswer
   * @function
   * @public
   * @returns {RTCSessionDescriptionInit} Specifies the SDP answer of WebRTC connection.
   */ get SDPAnswer() {
        return this.privSDPAnswer;
    }
}
class $d7238066c5de7f1c$var$JQ {
    static SetLoggingLevel(e) {
        this.privListener = new $d7238066c5de7f1c$var$Lme(e), $d7238066c5de7f1c$var$as.instance.attachConsoleListener(this.privListener);
    }
    static StartConsoleOutput() {
        this.privListener && (this.privListener.enableConsoleOutput = !0);
    }
    static StopConsoleOutput() {
        this.privListener && (this.privListener.enableConsoleOutput = !1);
    }
    static SetLogOutputPath(e) {
        if (typeof window > "u") this.privListener && (this.privListener.logPath = e);
        else throw new Error("File system logging not available in browser.");
    }
}
$d7238066c5de7f1c$var$JQ.privListener = void 0;
class $d7238066c5de7f1c$var$ll {
    constructor(e, t, i, n){
        this.privProxyHostName = e, this.privProxyPort = t, this.privProxyUserName = i, this.privProxyPassword = n;
    }
    static fromParameters(e) {
        return new $d7238066c5de7f1c$var$ll(e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyHostName), parseInt(e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPort), 10), e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyUserName), e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(e) {
        return this.fromParameters(e.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
}
const $d7238066c5de7f1c$var$dAe = /* @__PURE__ */ new Set([
    "json",
    "buffer",
    "string"
]);
var $d7238066c5de7f1c$var$hAe = (r)=>(...e)=>{
        const t = /* @__PURE__ */ new Set();
        let i, n, s, a = "";
        return e.forEach((o)=>{
            if (typeof o == "string") {
                if (o.toUpperCase() === o) {
                    if (i) {
                        const g = `Can't set method to ${o}, already set to ${i}.`;
                        throw new Error(g);
                    } else i = o;
                } else if (o.startsWith("http:") || o.startsWith("https:")) a = o;
                else if ($d7238066c5de7f1c$var$dAe.has(o)) n = o;
                else throw new Error(`Unknown encoding, ${o}`);
            } else if (typeof o == "number") t.add(o);
            else if (typeof o == "object") {
                if (Array.isArray(o) || o instanceof Set) o.forEach((g)=>t.add(g));
                else {
                    if (s) throw new Error("Cannot set headers twice.");
                    s = o;
                }
            } else throw new Error(`Unknown type: ${typeof o}`);
        }), i || (i = "GET"), t.size === 0 && t.add(200), r(t, i, n, s, a);
    };
const $d7238066c5de7f1c$var$CAe = $d7238066c5de7f1c$var$hAe;
class $d7238066c5de7f1c$var$zK extends Error {
    constructor(e, ...t){
        super(...t), Error.captureStackTrace && Error.captureStackTrace(this, $d7238066c5de7f1c$var$zK), this.name = "StatusError", this.message = e.statusMessage, this.statusCode = e.status, this.res = e, this.json = e.json.bind(e), this.text = e.text.bind(e), this.arrayBuffer = e.arrayBuffer.bind(e);
        let i;
        Object.defineProperty(this, "responseBody", {
            get: ()=>(i || (i = this.arrayBuffer()), i)
        }), this.headers = {};
        for (const [s, a] of e.headers.entries())this.headers[s.toLowerCase()] = a;
    }
}
const $d7238066c5de7f1c$var$pAe = (r, e, t, i, n)=>async (s, a, o = {})=>{
        s = n + (s || "");
        let g = new URL(s);
        if (i || (i = {}), g.username && (i.Authorization = "Basic " + btoa(g.username + ":" + g.password), g = new URL(g.protocol + "//" + g.host + g.pathname + g.search)), g.protocol !== "https:" && g.protocol !== "http:") throw new Error(`Unknown protocol, ${g.protocol}`);
        if (a && !(a instanceof ArrayBuffer || ArrayBuffer.isView(a) || typeof a == "string")) {
            if (typeof a == "object") a = JSON.stringify(a), i["Content-Type"] = "application/json";
            else throw new Error("Unknown body type.");
        }
        o = new Headers({
            ...i || {},
            ...o
        });
        const l = await fetch(g, {
            method: e,
            headers: o,
            body: a
        });
        if (l.statusCode = l.status, !r.has(l.status)) throw new $d7238066c5de7f1c$var$zK(l);
        return t === "json" ? l.json() : t === "buffer" ? l.arrayBuffer() : t === "string" ? l.text() : l;
    };
var $d7238066c5de7f1c$var$mAe = $d7238066c5de7f1c$var$CAe($d7238066c5de7f1c$var$pAe);
const $d7238066c5de7f1c$var$AAe = /* @__PURE__ */ $d7238066c5de7f1c$var$NP($d7238066c5de7f1c$var$mAe);
var $d7238066c5de7f1c$var$bAe = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
}, $d7238066c5de7f1c$var$ah;
(function(r) {
    r.Get = "GET", r.Post = "POST", r.Delete = "DELETE", r.File = "file";
})($d7238066c5de7f1c$var$ah || ($d7238066c5de7f1c$var$ah = {}));
class $d7238066c5de7f1c$var$SN {
    constructor(e){
        if (!e) throw new $d7238066c5de7f1c$var$Zr("configParams");
        this.privHeaders = e.headers, this.privIgnoreCache = e.ignoreCache;
    }
    static extractHeaderValue(e, t) {
        let i = "";
        try {
            const n = t.trim().split(/[\r\n]+/), s = {};
            n.forEach((a)=>{
                const o = a.split(": "), g = o.shift().toLowerCase(), l = o.join(": ");
                s[g] = l;
            }), i = s[e.toLowerCase()];
        } catch  {}
        return i;
    }
    set options(e) {
        this.privHeaders = e.headers, this.privIgnoreCache = e.ignoreCache;
    }
    setHeaders(e, t) {
        this.privHeaders[e] = t;
    }
    request(e, t, i = {}, n = null) {
        const s = new $d7238066c5de7f1c$var$Ui(), a = e === $d7238066c5de7f1c$var$ah.File ? "POST" : e, o = (l, c = {})=>{
            const d = l;
            return {
                data: JSON.stringify(c),
                headers: JSON.stringify(l.headers),
                json: c,
                ok: l.statusCode >= 200 && l.statusCode < 300,
                status: l.statusCode,
                statusText: c.error ? c.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        }, g = (l)=>{
            const c = $d7238066c5de7f1c$var$AAe(t, a, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404), d = this.queryParams(i) === "" ? "" : `?${this.queryParams(i)}`;
            c(d, l).then((p)=>$d7238066c5de7f1c$var$bAe(this, void 0, void 0, function*() {
                    if (e === $d7238066c5de7f1c$var$ah.Delete || p.statusCode === 204) s.resolve(o(p));
                    else try {
                        const A = yield p.json();
                        s.resolve(o(p, A));
                    } catch  {
                        s.resolve(o(p));
                    }
                })).catch((p)=>{
                s.reject(p);
            });
        };
        return this.privIgnoreCache && (this.privHeaders["Cache-Control"] = "no-cache"), e === $d7238066c5de7f1c$var$ah.Post && n && (this.privHeaders["content-type"] = "application/json", this.privHeaders["Content-Type"] = "application/json"), g(n), s.promise;
    }
    queryParams(e = {}) {
        return Object.keys(e).map((t)=>encodeURIComponent(t) + "=" + encodeURIComponent(e[t])).join("&");
    }
}
class $d7238066c5de7f1c$var$cu {
    static get requestOptions() {
        return $d7238066c5de7f1c$var$cu.privDefaultRequestOptions;
    }
    static get configParams() {
        return $d7238066c5de7f1c$var$cu.privDefaultParams;
    }
    static get restErrors() {
        return $d7238066c5de7f1c$var$cu.privRestErrors;
    }
}
$d7238066c5de7f1c$var$cu.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: !1,
    timeout: 1e4
};
$d7238066c5de7f1c$var$cu.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$d7238066c5de7f1c$var$cu.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};
class $d7238066c5de7f1c$var$yAe extends $d7238066c5de7f1c$var$Rr {
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint);
        if (!n) {
            const g = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_IntentRegion), l = $d7238066c5de7f1c$var$Rr.getHostSuffix(g);
            n = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "wss://" + g + ".sr.speech" + l) + "/speech/recognition/interactive/cognitiveservices/v1";
        }
        const s = {
            format: "simple",
            language: e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(e, s, n);
        const a = {};
        t.token !== void 0 && t.token !== "" && (a[t.headerName] = t.token), a[$d7238066c5de7f1c$var$Fi.ConnectionId] = i, e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, n);
        const o = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(n, s, a, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), o, i);
    }
    getSpeechRegionFromIntentRegion(e) {
        switch(e){
            case "West US":
            case "US West":
            case "westus":
                return "uswest";
            case "West US 2":
            case "US West 2":
            case "westus2":
                return "uswest2";
            case "South Central US":
            case "US South Central":
            case "southcentralus":
                return "ussouthcentral";
            case "West Central US":
            case "US West Central":
            case "westcentralus":
                return "uswestcentral";
            case "East US":
            case "US East":
            case "eastus":
                return "useast";
            case "East US 2":
            case "US East 2":
            case "eastus2":
                return "useast2";
            case "West Europe":
            case "Europe West":
            case "westeurope":
                return "europewest";
            case "North Europe":
            case "Europe North":
            case "northeurope":
                return "europenorth";
            case "Brazil South":
            case "South Brazil":
            case "southbrazil":
                return "brazilsouth";
            case "Australia East":
            case "East Australia":
            case "eastaustralia":
                return "australiaeast";
            case "Southeast Asia":
            case "Asia Southeast":
            case "southeastasia":
                return "asiasoutheast";
            case "East Asia":
            case "Asia East":
            case "eastasia":
                return "asiaeast";
            default:
                return e;
        }
    }
}
class $d7238066c5de7f1c$var$UQ extends $d7238066c5de7f1c$var$Rr {
    create(e, t, i, n) {
        let s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint);
        if (!s) {
            const l = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region), c = $d7238066c5de7f1c$var$Rr.getHostSuffix(l), d = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, `wss://${l}.spr-frontend.speech${c}`), p = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SpeakerIdMode, "TextIndependentIdentification");
            s = `${d}/speaker/ws/${this.scenarioToPath(p)}/${i}`;
        }
        const a = {
            format: "simple",
            language: e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(e, a, s);
        const o = {};
        t.token !== void 0 && t.token !== "" && (o[t.headerName] = t.token), o[$d7238066c5de7f1c$var$Fi.ConnectionId] = n, o[$d7238066c5de7f1c$var$Fi.SpIDAuthKey] = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key), e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, s);
        const g = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(s, a, o, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), g, n);
    }
    scenarioToPath(e) {
        switch(e){
            case "TextIndependentVerification":
            case "2":
                return "verification/text-independent";
            case "TextDependentVerification":
            case "1":
                return "verification/text-dependent";
            default:
                return "identification/text-independent";
        }
    }
}
class $d7238066c5de7f1c$var$BAe extends $d7238066c5de7f1c$var$UQ {
    create(e, t, i) {
        return super.create(e, t, "recognition", i);
    }
}
class $d7238066c5de7f1c$var$fAe extends $d7238066c5de7f1c$var$UQ {
    create(e, t, i) {
        return super.create(e, t, "profile", i);
    }
}
class $d7238066c5de7f1c$var$sV extends $d7238066c5de7f1c$var$lu {
    constructor(e, t, i, n = $d7238066c5de7f1c$var$Ys.Info){
        super(e, n), this.privRequestId = t, this.privSessionId = i;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $d7238066c5de7f1c$var$DQ extends $d7238066c5de7f1c$var$sV {
    constructor(e, t, i, n){
        super("RecognitionTriggeredEvent", e, t), this.privAudioSourceId = i, this.privAudioNodeId = n;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $d7238066c5de7f1c$var$GAe extends $d7238066c5de7f1c$var$sV {
    constructor(e, t, i, n){
        super("ListeningStartedEvent", e, t), this.privAudioSourceId = i, this.privAudioNodeId = n;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $d7238066c5de7f1c$var$_Q extends $d7238066c5de7f1c$var$sV {
    constructor(e, t, i){
        super("ConnectingToServiceEvent", e, i), this.privAuthFetchEventid = t;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
class $d7238066c5de7f1c$var$vAe extends $d7238066c5de7f1c$var$sV {
    constructor(e, t, i, n, s){
        super("RecognitionStartedEvent", e, s), this.privAudioSourceId = t, this.privAudioNodeId = i, this.privAuthFetchEventId = n;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $d7238066c5de7f1c$var$yM;
(function(r) {
    r[r.Success = 0] = "Success", r[r.AudioSourceError = 1] = "AudioSourceError", r[r.AudioSourceTimeout = 2] = "AudioSourceTimeout", r[r.AuthTokenFetchError = 3] = "AuthTokenFetchError", r[r.AuthTokenFetchTimeout = 4] = "AuthTokenFetchTimeout", r[r.UnAuthorized = 5] = "UnAuthorized", r[r.ConnectTimeout = 6] = "ConnectTimeout", r[r.ConnectError = 7] = "ConnectError", r[r.ClientRecognitionActivityTimeout = 8] = "ClientRecognitionActivityTimeout", r[r.UnknownError = 9] = "UnknownError";
})($d7238066c5de7f1c$var$yM || ($d7238066c5de7f1c$var$yM = {}));
class $d7238066c5de7f1c$var$$n extends $d7238066c5de7f1c$var$JZ {
    constructor(e, t, i, n, s, a, o, g){
        if (!t) throw new $d7238066c5de7f1c$var$Zr("path");
        if (!i) throw new $d7238066c5de7f1c$var$Zr("requestId");
        const l = {};
        if (l[$d7238066c5de7f1c$var$Fi.Path] = t, l[$d7238066c5de7f1c$var$Fi.RequestId] = i, l[$d7238066c5de7f1c$var$Fi.RequestTimestamp] = /* @__PURE__ */ new Date().toISOString(), n && (l[$d7238066c5de7f1c$var$Fi.ContentType] = n), a && (l[$d7238066c5de7f1c$var$Fi.RequestStreamId] = a), o) for(const c in o)c && (l[c] = o[c]);
        g ? super(e, s, l, g) : super(e, s, l), this.privPath = t, this.privRequestId = i, this.privContentType = n, this.privStreamId = a, this.privAdditionalHeaders = o;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(e) {
        let t = null, i = null, n = null, s = null;
        const a = {};
        if (e.headers) for(const o in e.headers)o && (o.toLowerCase() === $d7238066c5de7f1c$var$Fi.Path.toLowerCase() ? t = e.headers[o] : o.toLowerCase() === $d7238066c5de7f1c$var$Fi.RequestId.toLowerCase() ? i = e.headers[o] : o.toLowerCase() === $d7238066c5de7f1c$var$Fi.ContentType.toLowerCase() ? n = e.headers[o] : o.toLowerCase() === $d7238066c5de7f1c$var$Fi.RequestStreamId.toLowerCase() ? s = e.headers[o] : a[o] = e.headers[o]);
        return new $d7238066c5de7f1c$var$$n(e.messageType, t, i, n, e.body, s, a, e.id);
    }
}
var $d7238066c5de7f1c$var$xr = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        if (this.privConnectionConfigurationPromise = void 0, this.privConnectionPromise = void 0, this.privSetTimeout = setTimeout, this.privIsLiveAudio = !1, this.privAverageBytesPerMs = 0, this.privEnableSpeakerId = !1, this.recognizeOverride = void 0, this.recognizeSpeaker = void 0, this.disconnectOverride = void 0, this.receiveMessageOverride = void 0, this.sendPrePayloadJSONOverride = void 0, this.postConnectImplOverride = void 0, this.configConnectionOverride = void 0, this.handleSpeechPhraseMessage = void 0, this.handleSpeechHypothesisMessage = void 0, !e) throw new $d7238066c5de7f1c$var$Zr("authentication");
        if (!t) throw new $d7238066c5de7f1c$var$Zr("connectionFactory");
        if (!i) throw new $d7238066c5de7f1c$var$Zr("audioSource");
        if (!n) throw new $d7238066c5de7f1c$var$Zr("recognizerConfig");
        this.privEnableSpeakerId = n.isSpeakerDiarizationEnabled, this.privMustReportEndOfStream = !1, this.privAuthentication = e, this.privConnectionFactory = t, this.privAudioSource = i, this.privRecognizerConfig = n, this.privIsDisposed = !1, this.privRecognizer = s, this.privRequestSession = new $d7238066c5de7f1c$var$YAe(this.privAudioSource.id()), this.privConnectionEvents = new $d7238066c5de7f1c$var$sc(), this.privServiceEvents = new $d7238066c5de7f1c$var$sc(), this.privDynamicGrammar = new $d7238066c5de7f1c$var$xAe(), this.privSpeechContext = new $d7238066c5de7f1c$var$KAe(this.privDynamicGrammar), this.privAgentConfig = new $d7238066c5de7f1c$var$jQ(), this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.WebWorkerLoadType, "on").toLowerCase() === "on" && typeof Blob < "u" && typeof Worker < "u" ? this.privSetTimeout = $d7238066c5de7f1c$var$Mr.setTimeout : typeof window < "u" && (this.privSetTimeout = window.setTimeout.bind(window)), this.connectionEvents.attach((o)=>{
            if (o.name === "ConnectionClosedEvent") {
                const g = o;
                (g.statusCode === 1003 || g.statusCode === 1007 || g.statusCode === 1002 || g.statusCode === 4e3 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) && this.cancelRecognitionLocal($d7238066c5de7f1c$var$Zn.Error, g.statusCode === 1007 ? $d7238066c5de7f1c$var$vt.BadRequestParameters : $d7238066c5de7f1c$var$vt.ConnectionFailure, `${g.reason} websocket error code: ${g.statusCode}`);
            }
        }), this.privEnableSpeakerId && (this.privDiarizationSessionId = $d7238066c5de7f1c$var$Rn()), this.setLanguageIdJson(), this.setOutputDetailLevelJson();
    }
    setTranslationJson() {
        const e = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, void 0);
        if (e !== void 0) {
            const t = e.split(","), i = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice, void 0), n = i !== void 0 ? "Synthesize" : "None";
            if (this.privSpeechContext.setSection("translation", {
                onSuccess: {
                    action: n
                },
                output: {
                    interimResults: {
                        mode: "Always"
                    }
                },
                targetLanguages: t
            }), i !== void 0) {
                const s = {};
                for (const a of t)s[a] = i;
                this.privSpeechContext.setSection("synthesis", {
                    defaultVoices: s
                });
            }
        }
    }
    setSpeechSegmentationTimeoutJson() {
        const e = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.Speech_SegmentationSilenceTimeoutMs, void 0);
        if (e !== void 0) {
            const t = this.recognitionMode === $d7238066c5de7f1c$var$cr.Conversation ? "CONVERSATION" : this.recognitionMode === $d7238066c5de7f1c$var$cr.Dictation ? "DICTATION" : "INTERACTIVE", i = parseInt(e, 10), n = this.privSpeechContext.getSection("phraseDetection");
            n.mode = t, n[t] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: i
                }
            }, this.privSpeechContext.setSection("phraseDetection", n);
        }
    }
    setLanguageIdJson() {
        const e = this.privSpeechContext.getSection("phraseDetection");
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== void 0) {
            const i = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
            let n;
            this.privRecognizerConfig.languageIdMode === "Continuous" ? n = "DetectContinuous" : n = "DetectAtAudioStart", this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: i,
                mode: n,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            }), this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            const s = this.privRecognizerConfig.sourceLanguageModels;
            s !== void 0 && (e.customModels = s, e.onInterim = {
                action: "None"
            }, e.onSuccess = {
                action: "None"
            });
        }
        this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 && (e.onInterim = {
            action: "Translate"
        }, e.onSuccess = {
            action: "Translate"
        }, this.privSpeechContext.setSection("phraseOutput", {
            interimResults: {
                resultType: "None"
            },
            phraseResults: {
                resultType: "None"
            }
        })), this.privSpeechContext.setSection("phraseDetection", e);
    }
    setOutputDetailLevelJson() {
        this.privEnableSpeakerId && (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true" ? this.privSpeechContext.setWordLevelTimings() : this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]).toLowerCase() === $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Detailed].toLocaleLowerCase() && this.privSpeechContext.setDetailedOutputFormat());
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(e) {
        this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Token, e);
    }
    set voiceProfileType(e) {
        this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SpeakerIdMode, e);
    }
    set authentication(e) {
        this.privAuthentication = e;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(e) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            if (this.privIsDisposed = !0, this.privConnectionConfigurationPromise !== void 0) try {
                yield (yield this.privConnectionConfigurationPromise).dispose(e);
            } catch  {
                return;
            }
        });
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    recognize(e, t, i) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            if (this.recognizeOverride !== void 0) {
                yield this.recognizeOverride(e, t, i);
                return;
            }
            this.privConnectionConfigurationPromise = void 0, this.privRecognizerConfig.recognitionMode = e, this.setSpeechSegmentationTimeoutJson(), this.setTranslationJson(), this.privSuccessCallback = t, this.privErrorCallback = i, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
            const n = this.connectImpl();
            let s;
            try {
                const g = yield this.audioSource.attach(this.privRequestSession.audioNodeId), l = yield this.audioSource.format, c = yield this.audioSource.deviceInfo;
                this.privIsLiveAudio = c.type && c.type === $d7238066c5de7f1c$var$PC.Microphones, s = new $d7238066c5de7f1c$var$jR(g, l.avgBytesPerSec), yield this.privRequestSession.onAudioSourceAttachCompleted(s, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                    source: c
                };
            } catch (g) {
                throw yield this.privRequestSession.onStopRecognizing(), g;
            }
            try {
                yield n;
            } catch (g) {
                yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.ConnectionFailure, g);
                return;
            }
            const a = new $d7238066c5de7f1c$var$zr(this.privRequestSession.sessionId);
            this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, a), this.receiveMessage(), this.sendAudio(s).catch((g)=>$d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
                    yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.RuntimeError, g);
                }));
        });
    }
    stopRecognizing() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) try {
                yield this.audioSource.turnOff(), yield this.sendFinalAudio(), yield this.privRequestSession.onStopRecognizing(), yield this.privRequestSession.turnCompletionPromise;
            } finally{
                yield this.privRequestSession.dispose();
            }
        });
    }
    connect() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            return yield this.connectImpl(), Promise.resolve();
        });
    }
    connectAsync(e, t) {
        this.connectImpl().then(()=>{
            try {
                e && e();
            } catch (i) {
                t && t(i);
            }
        }, (i)=>{
            try {
                t && t(i);
            } catch  {}
        });
    }
    disconnect() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            if (yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.NoError, "Disconnecting"), this.disconnectOverride !== void 0 && (yield this.disconnectOverride()), this.privConnectionPromise !== void 0) try {
                yield (yield this.privConnectionPromise).dispose();
            } catch  {}
            this.privConnectionPromise = void 0;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(e) {}
    sendNetworkMessage(e, t) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            const i = typeof t == "string" ? $d7238066c5de7f1c$var$Tt.Text : $d7238066c5de7f1c$var$Tt.Binary, n = typeof t == "string" ? "application/json" : "";
            return (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$$n(i, e, this.privRequestSession.requestId, n, t));
        });
    }
    set activityTemplate(e) {
        this.privActivityTemplate = e;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    sendTelemetryData() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            const e = this.privRequestSession.getTelemetry();
            if ($d7238066c5de7f1c$var$ha.telemetryDataEnabled !== !0 || this.privIsDisposed || e === null) return;
            if ($d7238066c5de7f1c$var$ha.telemetryData) try {
                $d7238066c5de7f1c$var$ha.telemetryData(e);
            } catch  {}
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "telemetry", this.privRequestSession.requestId, "application/json", e));
        });
    }
    // Cancels recognition.
    cancelRecognitionLocal(e, t, i) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing(), this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, e, t, i));
        });
    }
    receiveMessage() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            try {
                if (this.privIsDisposed) return;
                let e = yield this.fetchConnection();
                const t = yield e.read();
                if (this.receiveMessageOverride !== void 0) return this.receiveMessageOverride();
                if (!t) return this.receiveMessage();
                this.privServiceHasSentMessage = !0;
                const i = $d7238066c5de7f1c$var$$n.fromConnectionMessage(t);
                if (i.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(i.path.toLowerCase()){
                    case "turn.start":
                        this.privMustReportEndOfStream = !0, this.privRequestSession.onServiceTurnStartResponse();
                        break;
                    case "speech.startdetected":
                        const n = $d7238066c5de7f1c$var$jA.fromJSON(i.textBody), s = new $d7238066c5de7f1c$var$rc(n.Offset, this.privRequestSession.sessionId);
                        this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, s);
                        break;
                    case "speech.enddetected":
                        let a;
                        i.textBody.length > 0 ? a = i.textBody : a = "{ Offset: 0 }";
                        const o = $d7238066c5de7f1c$var$jA.fromJSON(a), g = new $d7238066c5de7f1c$var$rc(o.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, g);
                        break;
                    case "turn.end":
                        yield this.sendTelemetryData(), this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream && (this.privMustReportEndOfStream = !1, yield this.cancelRecognitionLocal($d7238066c5de7f1c$var$Zn.EndOfStream, $d7238066c5de7f1c$var$vt.NoError, void 0));
                        const l = new $d7238066c5de7f1c$var$zr(this.privRequestSession.sessionId);
                        if (yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition), !this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                            this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, l);
                            return;
                        } else e = yield this.fetchConnection(), yield this.sendPrePayloadJSON(e);
                        break;
                    default:
                        (yield this.processTypeSpecificMessages(i)) || this.privServiceEvents && this.serviceEvents.onEvent(new $d7238066c5de7f1c$var$uK(i.path.toLowerCase(), i.textBody));
                }
                return this.receiveMessage();
            } catch  {
                return null;
            }
        });
    }
    updateSpeakerDiarizationAudioOffset() {
        const t = this.privRequestSession.recognitionBytesSent / this.privAverageBytesPerMs;
        this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(t);
    }
    sendSpeechContext(e, t) {
        this.privEnableSpeakerId && this.updateSpeakerDiarizationAudioOffset();
        const i = this.speechContext.toJSON();
        if (t && this.privRequestSession.onSpeechContext(), i) return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speech.context", this.privRequestSession.requestId, "application/json", i));
    }
    noOp() {}
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendPrePayloadJSON(e, t = !0) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            if (this.sendPrePayloadJSONOverride !== void 0) return this.sendPrePayloadJSONOverride(e);
            yield this.sendSpeechContext(e, t), yield this.sendWaveHeader(e);
        });
    }
    sendWaveHeader(e) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            const t = yield this.audioSource.format;
            return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", t.header));
        });
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        return this.privConnectionPromise !== void 0 ? this.privConnectionPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$ir.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = void 0, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, ()=>(this.privConnectionId = null, this.privConnectionPromise = void 0, this.privServiceHasSentMessage = !1, this.connectImpl())) : (this.privConnectionPromise = this.retryableConnect(), this.privConnectionPromise.catch(()=>{}), this.postConnectImplOverride !== void 0 ? this.postConnectImplOverride(this.privConnectionPromise) : this.privConnectionPromise);
    }
    sendSpeechServiceConfig(e, t, i) {
        if (t.onSpeechContext(), $d7238066c5de7f1c$var$ha.telemetryDataEnabled !== !0) {
            const s = {
                context: {
                    system: JSON.parse(i).context.system
                }
            };
            i = JSON.stringify(s);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const n = JSON.parse(i);
            n.context.DisableReferenceChannel = "True", n.context.MicSpec = "1_0_0", i = JSON.stringify(n);
        }
        if (i) return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speech.config", t.requestId, "application/json", i));
    }
    fetchConnection() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            return this.privConnectionConfigurationPromise !== void 0 ? this.privConnectionConfigurationPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$ir.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, ()=>(this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
        });
    }
    sendAudio(e) {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            const t = yield this.audioSource.format;
            this.privAverageBytesPerMs = t.avgBytesPerSec / 1e3;
            let i = Date.now();
            const n = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000"), s = t.avgBytesPerSec / 1e3 * parseInt(n, 10), a = this.privRequestSession.recogNumber, o = ()=>$d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
                    if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === a) {
                        const g = yield this.fetchConnection(), l = yield e.read();
                        if (this.privRequestSession.isSpeechEnded) return;
                        let c, d;
                        if (!l || l.isEnd ? (c = null, d = 0) : (c = l.buffer, this.privRequestSession.onAudioSent(c.byteLength), s >= this.privRequestSession.bytesSent ? d = 0 : d = Math.max(0, i - Date.now())), d !== 0 && (yield this.delay(d)), c !== null && (i = Date.now() + c.byteLength * 1e3 / (t.avgBytesPerSec * 2)), !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === a) {
                            if (g.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Binary, "audio", this.privRequestSession.requestId, null, c)).catch(()=>{
                                this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                            }), l != null && l.isEnd) this.privIsLiveAudio || this.privRequestSession.onSpeechEnded();
                            else return o();
                        }
                    }
                });
            return o();
        });
    }
    retryableConnect() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            let e = !1;
            this.privAuthFetchEventId = $d7238066c5de7f1c$var$Rn();
            const t = this.privRequestSession.sessionId;
            this.privConnectionId = t !== void 0 ? t : $d7238066c5de7f1c$var$Rn(), this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
            let i = 0, n = "";
            for(; this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount;){
                const a = yield e ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                yield this.privRequestSession.onAuthCompleted(!1);
                const o = this.privConnectionFactory.create(this.privRecognizerConfig, a, this.privConnectionId);
                this.privRequestSession.listenForServiceTelemetry(o.events), o.events.attach((l)=>{
                    this.connectionEvents.onEvent(l);
                });
                const g = yield o.open();
                if (g.statusCode === 200) return yield this.privRequestSession.onConnectionEstablishCompleted(g.statusCode), Promise.resolve(o);
                g.statusCode === 1006 && (e = !0), i = g.statusCode, n = g.reason, this.privRequestSession.onRetryConnection();
            }
            return yield this.privRequestSession.onConnectionEstablishCompleted(i, n), Promise.reject(`Unable to contact server. StatusCode: ${i}, ${this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint)} Reason: ${n}`);
        });
    }
    delay(e) {
        return new Promise((t)=>this.privSetTimeout(t, e));
    }
    writeBufferToConsole(e) {
        let t = "Buffer Size: ";
        if (e === null) t += "null";
        else {
            const i = new Uint8Array(e);
            t += `${e.byteLength}\r
`;
            for(let n = 0; n < e.byteLength; n++)t += i[n].toString(16).padStart(2, "0") + " ", (n + 1) % 16 === 0 && (console.info(t), t = "");
        }
        console.info(t);
    }
    sendFinalAudio() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Binary, "audio", this.privRequestSession.requestId, null, null));
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $d7238066c5de7f1c$var$xr(this, void 0, void 0, function*() {
            const e = yield this.connectImpl();
            return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(e) : (yield this.sendSpeechServiceConfig(e, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendPrePayloadJSON(e, !1), e);
        });
    }
}
$d7238066c5de7f1c$var$ha.telemetryDataEnabled = !0;
var $d7238066c5de7f1c$var$GX = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$PQ extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.handleSpeechPhraseMessage = (a)=>$d7238066c5de7f1c$var$GX(this, void 0, void 0, function*() {
                return this.handleSpeechPhrase(a);
            }), this.handleSpeechHypothesisMessage = (a)=>this.handleSpeechHypothesis(a);
    }
    processTypeSpecificMessages(e) {}
    handleRecognizedCallback(e, t, i) {}
    handleRecognizingCallback(e, t, i) {}
    processSpeechMessages(e) {
        return $d7238066c5de7f1c$var$GX(this, void 0, void 0, function*() {
            let t = !1;
            switch(e.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    this.handleSpeechHypothesisMessage && this.handleSpeechHypothesisMessage(e.textBody), t = !0;
                    break;
                case "speech.phrase":
                    this.handleSpeechPhraseMessage && (yield this.handleSpeechPhraseMessage(e.textBody)), t = !0;
                    break;
            }
            return t;
        });
    }
    cancelRecognition(e, t, i, n, s) {}
    handleSpeechPhrase(e) {
        return $d7238066c5de7f1c$var$GX(this, void 0, void 0, function*() {
            const t = $d7238066c5de7f1c$var$YI.fromJSON(e), i = $d7238066c5de7f1c$var$gr.implTranslateRecognitionResult(t.RecognitionStatus);
            let n;
            const s = new $d7238066c5de7f1c$var$vi();
            s.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e);
            const a = t.Offset + this.privRequestSession.currentTurnAudioOffset;
            let o = a;
            if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + t.Offset + t.Duration), $d7238066c5de7f1c$var$At.Canceled === i) {
                const g = $d7238066c5de7f1c$var$gr.implTranslateCancelResult(t.RecognitionStatus), l = $d7238066c5de7f1c$var$gr.implTranslateCancelErrorCode(t.RecognitionStatus);
                yield this.cancelRecognitionLocal(g, l, $d7238066c5de7f1c$var$gr.implTranslateErrorDetails(l));
            } else if (!(this.privRequestSession.isSpeechEnded && i === $d7238066c5de7f1c$var$At.NoMatch && t.RecognitionStatus !== $d7238066c5de7f1c$var$ki.InitialSilenceTimeout)) {
                if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$ug) === $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]) n = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, i, t.DisplayText, t.Duration, a, t.Language, t.LanguageDetectionConfidence, t.SpeakerId, void 0, e, s);
                else {
                    const g = $d7238066c5de7f1c$var$hf.fromJSON(e), l = g.Offset + this.privRequestSession.currentTurnAudioOffset, c = g.getJsonWithCorrectedOffsets(l);
                    n = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, i, g.Text, g.Duration, l, g.Language, g.LanguageDetectionConfidence, g.SpeakerId, void 0, c, s), o = n.offset;
                }
                this.handleRecognizedCallback(n, o, this.privRequestSession.sessionId);
            }
        });
    }
    handleSpeechHypothesis(e) {
        const t = $d7238066c5de7f1c$var$tp.fromJSON(e), i = t.Offset + this.privRequestSession.currentTurnAudioOffset, n = new $d7238066c5de7f1c$var$vi();
        n.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e);
        const s = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, $d7238066c5de7f1c$var$At.RecognizingSpeech, t.Text, t.Duration, i, t.Language, t.LanguageDetectionConfidence, t.SpeakerId, void 0, e, n);
        this.privRequestSession.onHypothesis(i), this.handleRecognizingCallback(s, t.Duration, this.privRequestSession.sessionId);
    }
}
var $d7238066c5de7f1c$var$cr;
(function(r) {
    r[r.Interactive = 0] = "Interactive", r[r.Conversation = 1] = "Conversation", r[r.Dictation = 2] = "Dictation";
})($d7238066c5de7f1c$var$cr || ($d7238066c5de7f1c$var$cr = {}));
var $d7238066c5de7f1c$var$BM;
(function(r) {
    r[r.Simple = 0] = "Simple", r[r.Detailed = 1] = "Detailed";
})($d7238066c5de7f1c$var$BM || ($d7238066c5de7f1c$var$BM = {}));
class $d7238066c5de7f1c$var$NI {
    constructor(e, t){
        this.privSpeechServiceConfig = e || new $d7238066c5de7f1c$var$rV(new $d7238066c5de7f1c$var$aV(null)), this.privParameters = t, this.privMaxRetryCount = parseInt(t.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10), this.privLanguageIdMode = t.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_LanguageIdMode, void 0), this.privEnableSpeakerId = !1;
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(e) {
        this.privRecognitionMode = e, this.privRecognitionActivityTimeout = e === $d7238066c5de7f1c$var$cr.Interactive ? 8e3 : 25e3, this.privSpeechServiceConfig.Recognition = $d7238066c5de7f1c$var$cr[e];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $d7238066c5de7f1c$var$cr.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_AutoDetectSourceLanguages, void 0);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecognitionEndpointVersion, void 0);
    }
    get sourceLanguageModels() {
        const e = [];
        let t = !1;
        if (this.autoDetectSourceLanguages !== void 0) for (const i of this.autoDetectSourceLanguages.split(",")){
            const n = i + $d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId.toString(), s = this.parameters.getProperty(n, void 0);
            s !== void 0 ? (e.push({
                language: i,
                endpoint: s
            }), t = !0) : e.push({
                language: i,
                endpoint: ""
            });
        }
        return t ? e : void 0;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    set isSpeakerDiarizationEnabled(e) {
        this.privEnableSpeakerId = e;
    }
}
const $d7238066c5de7f1c$var$fM = `\r
`;
class $d7238066c5de7f1c$var$LI {
    toConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$Ui();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$Tt.Text) {
                const i = e.textContent;
                let n = {}, s = null;
                if (i) {
                    const a = i.split(`\r
\r
`);
                    a && a.length > 0 && (n = this.parseHeaders(a[0]), a.length > 1 && (s = a[1]));
                }
                t.resolve(new $d7238066c5de7f1c$var$JZ(e.messageType, s, n, e.id));
            } else if (e.messageType === $d7238066c5de7f1c$var$Tt.Binary) {
                const i = e.binaryContent;
                let n = {}, s = null;
                if (!i || i.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                const a = new DataView(i), o = a.getInt16(0);
                if (i.byteLength < o + 2) throw new Error("Invalid binary message format. Header content missing.");
                let g = "";
                for(let l = 0; l < o; l++)g += String.fromCharCode(a.getInt8(l + 2));
                n = this.parseHeaders(g), i.byteLength > o + 2 && (s = i.slice(2 + o)), t.resolve(new $d7238066c5de7f1c$var$JZ(e.messageType, s, n, e.id));
            }
        } catch (i) {
            t.reject(`Error formatting the message. Error: ${i}`);
        }
        return t.promise;
    }
    fromConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$Ui();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$Tt.Text) {
                const i = `${this.makeHeaders(e)}${$d7238066c5de7f1c$var$fM}${e.textBody ? e.textBody : ""}`;
                t.resolve(new $d7238066c5de7f1c$var$RB($d7238066c5de7f1c$var$Tt.Text, i, e.id));
            } else if (e.messageType === $d7238066c5de7f1c$var$Tt.Binary) {
                const i = this.makeHeaders(e), n = e.binaryBody, s = this.stringToArrayBuffer(i), a = new Int8Array(s), o = a.byteLength, g = new Int8Array(2 + o + (n ? n.byteLength : 0));
                if (g[0] = o >> 8 & 255, g[1] = o & 255, g.set(a, 2), n) {
                    const c = new Int8Array(n);
                    g.set(c, 2 + o);
                }
                const l = g.buffer;
                t.resolve(new $d7238066c5de7f1c$var$RB($d7238066c5de7f1c$var$Tt.Binary, l, e.id));
            }
        } catch (i) {
            t.reject(`Error formatting the message. ${i}`);
        }
        return t.promise;
    }
    makeHeaders(e) {
        let t = "";
        if (e.headers) for(const i in e.headers)i && (t += `${i}: ${e.headers[i]}${$d7238066c5de7f1c$var$fM}`);
        return t;
    }
    parseHeaders(e) {
        const t = {};
        if (e) {
            const i = e.match(/[^\r\n]+/g);
            if (t) {
                for (const n of i)if (n) {
                    const s = n.indexOf(":"), a = s > 0 ? n.substr(0, s).trim().toLowerCase() : n, o = s > 0 && n.length > s + 1 ? n.substr(s + 1).trim() : "";
                    t[a] = o;
                }
            }
        }
        return t;
    }
    stringToArrayBuffer(e) {
        const t = new ArrayBuffer(e.length), i = new DataView(t);
        for(let n = 0; n < e.length; n++)i.setUint8(n, e.charCodeAt(n));
        return t;
    }
}
class $d7238066c5de7f1c$var$SAe extends $d7238066c5de7f1c$var$Rr {
    constructor(){
        super(...arguments), this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1", this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1", this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1", this.universalUri = "/speech/universal/v";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, void 0), a = $d7238066c5de7f1c$var$Rr.getHostSuffix(s), o = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "wss://" + s + ".stt.speech" + a), g = {}, l = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, void 0), c = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, void 0);
        if (l ? (!n || n.search($d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId) === -1) && (g[$d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId] = l) : c && (!n || n.search($d7238066c5de7f1c$var$dt.Language) === -1) && (g[$d7238066c5de7f1c$var$dt.Language] = c), (!n || n.search($d7238066c5de7f1c$var$dt.Format) === -1) && (g[$d7238066c5de7f1c$var$dt.Format] = e.parameters.getProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]).toLowerCase()), e.autoDetectSourceLanguages !== void 0 && (g[$d7238066c5de7f1c$var$dt.EnableLanguageId] = "true"), this.setCommonUrlParams(e, g, n), !n) switch(e.recognitionMode){
            case $d7238066c5de7f1c$var$cr.Conversation:
                e.parameters.getProperty($d7238066c5de7f1c$var$$K, "false") === "true" ? n = o + this.dictationRelativeUri : e.recognitionEndpointVersion !== void 0 && parseInt(e.recognitionEndpointVersion, 10) > 1 ? n = `${o}${this.universalUri}${e.recognitionEndpointVersion}` : n = o + this.conversationRelativeUri;
                break;
            case $d7238066c5de7f1c$var$cr.Dictation:
                n = o + this.dictationRelativeUri;
                break;
            default:
                e.recognitionEndpointVersion !== void 0 && parseInt(e.recognitionEndpointVersion, 10) > 1 ? n = `${o}${this.universalUri}${e.recognitionEndpointVersion}` : n = o + this.interactiveRelativeUri;
                break;
        }
        const d = {};
        t.token !== void 0 && t.token !== "" && (d[t.headerName] = t.token), d[$d7238066c5de7f1c$var$Fi.ConnectionId] = i;
        const p = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true", A = new $d7238066c5de7f1c$var$Au(n, g, d, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), p, i), y = A.uri;
        return e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, y), A;
    }
}
class $d7238066c5de7f1c$var$ZAe extends $d7238066c5de7f1c$var$Rr {
    constructor(){
        super(...arguments), this.universalUri = "/speech/universal/v2";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, void 0), a = $d7238066c5de7f1c$var$Rr.getHostSuffix(s), o = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "wss://" + s + ".stt.speech" + a), g = {}, l = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, void 0), c = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, void 0);
        l ? (!n || n.search($d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId) === -1) && (g[$d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId] = l) : c && (!n || n.search($d7238066c5de7f1c$var$dt.Language) === -1) && (g[$d7238066c5de7f1c$var$dt.Language] = c), e.autoDetectSourceLanguages !== void 0 && (g[$d7238066c5de7f1c$var$dt.EnableLanguageId] = "true"), this.setV2UrlParams(e, g, n), n || (n = `${o}${this.universalUri}`);
        const d = {};
        t.token !== void 0 && t.token !== "" && (d[t.headerName] = t.token), d[$d7238066c5de7f1c$var$Fi.ConnectionId] = i;
        const p = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true", A = new $d7238066c5de7f1c$var$Au(n, g, d, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), p, i), y = A.uri;
        return e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, y), A;
    }
    setV2UrlParams(e, t, i) {
        /* @__PURE__ */ new Map([
            [
                $d7238066c5de7f1c$var$T.Speech_SegmentationSilenceTimeoutMs,
                $d7238066c5de7f1c$var$dt.SegmentationSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceConnection_EnableAudioLogging,
                $d7238066c5de7f1c$var$dt.EnableAudioLogging
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceConnection_EndSilenceTimeoutMs,
                $d7238066c5de7f1c$var$dt.EndSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $d7238066c5de7f1c$var$dt.InitialSilenceTimeoutMs
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_PostProcessingOption,
                $d7238066c5de7f1c$var$dt.Postprocessing
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_ProfanityOption,
                $d7238066c5de7f1c$var$dt.Profanity
            ],
            [
                $d7238066c5de7f1c$var$T.SpeechServiceResponse_StablePartialResultThreshold,
                $d7238066c5de7f1c$var$dt.StableIntermediateThreshold
            ]
        ]).forEach((a, o)=>{
            this.setUrlParameter(o, a, e, t, i);
        });
        const s = JSON.parse(e.parameters.getProperty($d7238066c5de7f1c$var$GI, "{}"));
        Object.keys(s).forEach((a)=>{
            t[a] = s[a];
        });
    }
}
class $d7238066c5de7f1c$var$QQ extends $d7238066c5de7f1c$var$Rr {
    constructor(){
        super(...arguments), this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
    }
    create(e, t, i) {
        let n = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, void 0);
        const s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, "centralus"), a = $d7238066c5de7f1c$var$Rr.getHostSuffix(s), o = "wss://transcribe." + s + ".cts.speech" + a + this.multiaudioRelativeUri, g = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, o), l = {};
        this.setQueryParams(l, e, n), n || (n = g);
        const c = {};
        t.token !== void 0 && t.token !== "" && (c[t.headerName] = t.token), c[$d7238066c5de7f1c$var$Fi.ConnectionId] = i, e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, n);
        const d = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(n, l, c, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), d, i);
    }
    setQueryParams(e, t, i) {
        const n = t.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_EndpointId, void 0), s = t.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, void 0);
        n && !($d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId in e) && (e[$d7238066c5de7f1c$var$dt.CustomSpeechDeploymentId] = n), s && !($d7238066c5de7f1c$var$dt.Language in e) && (e[$d7238066c5de7f1c$var$dt.Language] = s);
        const a = t.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true", o = t.parameters.getProperty($d7238066c5de7f1c$var$ug, $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]) !== $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple];
        (a || o) && (e[$d7238066c5de7f1c$var$dt.Format] = $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Detailed].toLowerCase()), this.setCommonUrlParams(t, e, i);
    }
}
class $d7238066c5de7f1c$var$OQ extends $d7238066c5de7f1c$var$Rr {
    create(e, t, i) {
        const n = this.getEndpointUrl(e), s = {};
        e.autoDetectSourceLanguages !== void 0 && (s[$d7238066c5de7f1c$var$dt.EnableLanguageId] = "true"), this.setQueryParams(s, e, n);
        const a = {};
        t.token !== void 0 && t.token !== "" && (a[t.headerName] = t.token), a[$d7238066c5de7f1c$var$Fi.ConnectionId] = i, e.parameters.setProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Url, n);
        const o = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(n, s, a, new $d7238066c5de7f1c$var$LI(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), o, i);
    }
    getEndpointUrl(e, t) {
        const i = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region), n = $d7238066c5de7f1c$var$Rr.getHostSuffix(i);
        let s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, void 0);
        return s || (e.autoDetectSourceLanguages !== void 0 ? s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + n) + "/speech/universal/v2" : s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + n) + "/speech/translation/cognitiveservices/v1"), t === !0 ? s : $d7238066c5de7f1c$var$BN.formatString(s, {
            region: i
        });
    }
    setQueryParams(e, t, i) {
        e.from = t.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage), e.to = t.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationToLanguages), e.scenario = t.recognitionMode === $d7238066c5de7f1c$var$cr.Interactive ? "interactive" : t.recognitionMode === $d7238066c5de7f1c$var$cr.Conversation ? "conversation" : "", this.setCommonUrlParams(t, e, i), this.setUrlParameter($d7238066c5de7f1c$var$T.SpeechServiceResponse_TranslationRequestStablePartialResult, $d7238066c5de7f1c$var$dt.StableTranslation, t, e, i);
        const n = t.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_TranslationVoice, void 0);
        n !== void 0 && (e.voice = n, e.features = "texttospeech");
    }
}
class $d7238066c5de7f1c$var$gr {
    static implTranslateRecognitionResult(e) {
        let t = $d7238066c5de7f1c$var$At.Canceled;
        switch(e){
            case $d7238066c5de7f1c$var$ki.Success:
                t = $d7238066c5de7f1c$var$At.RecognizedSpeech;
                break;
            case $d7238066c5de7f1c$var$ki.NoMatch:
            case $d7238066c5de7f1c$var$ki.InitialSilenceTimeout:
            case $d7238066c5de7f1c$var$ki.BabbleTimeout:
            case $d7238066c5de7f1c$var$ki.EndOfDictation:
                t = $d7238066c5de7f1c$var$At.NoMatch;
                break;
            case $d7238066c5de7f1c$var$ki.Error:
            case $d7238066c5de7f1c$var$ki.BadRequest:
            case $d7238066c5de7f1c$var$ki.Forbidden:
            default:
                t = $d7238066c5de7f1c$var$At.Canceled;
                break;
        }
        return t;
    }
    static implTranslateCancelResult(e) {
        let t = $d7238066c5de7f1c$var$Zn.EndOfStream;
        switch(e){
            case $d7238066c5de7f1c$var$ki.Success:
            case $d7238066c5de7f1c$var$ki.EndOfDictation:
            case $d7238066c5de7f1c$var$ki.NoMatch:
                t = $d7238066c5de7f1c$var$Zn.EndOfStream;
                break;
            case $d7238066c5de7f1c$var$ki.InitialSilenceTimeout:
            case $d7238066c5de7f1c$var$ki.BabbleTimeout:
            case $d7238066c5de7f1c$var$ki.Error:
            case $d7238066c5de7f1c$var$ki.BadRequest:
            case $d7238066c5de7f1c$var$ki.Forbidden:
            default:
                t = $d7238066c5de7f1c$var$Zn.Error;
                break;
        }
        return t;
    }
    static implTranslateCancelErrorCode(e) {
        let t = $d7238066c5de7f1c$var$vt.NoError;
        switch(e){
            case $d7238066c5de7f1c$var$ki.Error:
                t = $d7238066c5de7f1c$var$vt.ServiceError;
                break;
            case $d7238066c5de7f1c$var$ki.TooManyRequests:
                t = $d7238066c5de7f1c$var$vt.TooManyRequests;
                break;
            case $d7238066c5de7f1c$var$ki.BadRequest:
                t = $d7238066c5de7f1c$var$vt.BadRequestParameters;
                break;
            case $d7238066c5de7f1c$var$ki.Forbidden:
                t = $d7238066c5de7f1c$var$vt.Forbidden;
                break;
            default:
                t = $d7238066c5de7f1c$var$vt.NoError;
                break;
        }
        return t;
    }
    static implTranslateErrorDetails(e) {
        let t = "The speech service encountered an internal error and could not continue.";
        switch(e){
            case $d7238066c5de7f1c$var$vt.Forbidden:
                t = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case $d7238066c5de7f1c$var$vt.BadRequestParameters:
                t = "Invalid parameter or unsupported audio format in the request.";
                break;
            case $d7238066c5de7f1c$var$vt.TooManyRequests:
                t = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
        }
        return t;
    }
}
var $d7238066c5de7f1c$var$OA;
(function(r) {
    r[r.Success = 0] = "Success", r[r.SynthesisEnd = 1] = "SynthesisEnd", r[r.Error = 2] = "Error";
})($d7238066c5de7f1c$var$OA || ($d7238066c5de7f1c$var$OA = {}));
var $d7238066c5de7f1c$var$ki;
(function(r) {
    r[r.Success = 0] = "Success", r[r.NoMatch = 1] = "NoMatch", r[r.InitialSilenceTimeout = 2] = "InitialSilenceTimeout", r[r.BabbleTimeout = 3] = "BabbleTimeout", r[r.Error = 4] = "Error", r[r.EndOfDictation = 5] = "EndOfDictation", r[r.TooManyRequests = 6] = "TooManyRequests", r[r.BadRequest = 7] = "BadRequest", r[r.Forbidden = 8] = "Forbidden";
})($d7238066c5de7f1c$var$ki || ($d7238066c5de7f1c$var$ki = {}));
class $d7238066c5de7f1c$var$kK {
    constructor(e){
        this.privSynthesisEnd = JSON.parse(e), this.privSynthesisEnd.SynthesisStatus && (this.privSynthesisEnd.SynthesisStatus = $d7238066c5de7f1c$var$OA[this.privSynthesisEnd.SynthesisStatus]), this.privSynthesisEnd.Status && (this.privSynthesisEnd.SynthesisStatus = $d7238066c5de7f1c$var$OA[this.privSynthesisEnd.Status]);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$kK(e);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
}
class $d7238066c5de7f1c$var$LB {
    constructor(e){
        this.privTranslationHypothesis = e, this.privTranslationHypothesis.Translation.TranslationStatus = $d7238066c5de7f1c$var$VB[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$LB(JSON.parse(e));
    }
    static fromTranslationResponse(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "translationHypothesis");
        const t = e.SpeechHypothesis;
        return e.SpeechHypothesis = void 0, t.Translation = e, new $d7238066c5de7f1c$var$LB(t);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
    get Language() {
        var e;
        return (e = this.privTranslationHypothesis.PrimaryLanguage) === null || e === void 0 ? void 0 : e.Language;
    }
}
class $d7238066c5de7f1c$var$NA {
    constructor(e){
        this.privTranslationPhrase = e, this.privTranslationPhrase.RecognitionStatus = $d7238066c5de7f1c$var$ki[this.privTranslationPhrase.RecognitionStatus], this.privTranslationPhrase.Translation !== void 0 && (this.privTranslationPhrase.Translation.TranslationStatus = $d7238066c5de7f1c$var$VB[this.privTranslationPhrase.Translation.TranslationStatus]);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$NA(JSON.parse(e));
    }
    static fromTranslationResponse(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "translationResponse");
        const t = e.SpeechPhrase;
        return e.SpeechPhrase = void 0, t.Translation = e, t.Text = t.DisplayText, new $d7238066c5de7f1c$var$NA(t);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Language() {
        var e;
        return (e = this.privTranslationPhrase.PrimaryLanguage) === null || e === void 0 ? void 0 : e.Language;
    }
    get Confidence() {
        var e;
        return (e = this.privTranslationPhrase.PrimaryLanguage) === null || e === void 0 ? void 0 : e.Confidence;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
}
var $d7238066c5de7f1c$var$GM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$RAe extends $d7238066c5de7f1c$var$PQ {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privTranslationRecognizer = s, this.connectionEvents.attach((a)=>{
            a.name === "ConnectionEstablishedEvent" && this.privTranslationRecognizer.onConnection();
        });
    }
    processTypeSpecificMessages(e) {
        return $d7238066c5de7f1c$var$GM(this, void 0, void 0, function*() {
            const t = new $d7238066c5de7f1c$var$vi();
            let i = yield this.processSpeechMessages(e);
            if (i) return !0;
            const n = (a)=>$d7238066c5de7f1c$var$GM(this, void 0, void 0, function*() {
                    if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + a.Offset + a.Duration), a.RecognitionStatus === $d7238066c5de7f1c$var$ki.Success) {
                        const o = this.fireEventForResult(a, t);
                        if (this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, o);
                        } catch  {}
                        if (this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(o.result);
                            } catch (g) {
                                this.privErrorCallback && this.privErrorCallback(g);
                            }
                            this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                        }
                    } else {
                        const o = $d7238066c5de7f1c$var$gr.implTranslateRecognitionResult(a.RecognitionStatus), g = new $d7238066c5de7f1c$var$aI(void 0, this.privRequestSession.requestId, o, a.Text, a.Duration, this.privRequestSession.currentTurnAudioOffset + a.Offset, a.Language, a.Confidence, void 0, e.textBody, t);
                        if (o === $d7238066c5de7f1c$var$At.Canceled) {
                            const l = $d7238066c5de7f1c$var$gr.implTranslateCancelResult(a.RecognitionStatus), c = $d7238066c5de7f1c$var$gr.implTranslateCancelErrorCode(a.RecognitionStatus);
                            yield this.cancelRecognitionLocal(l, c, $d7238066c5de7f1c$var$gr.implTranslateErrorDetails(c));
                        } else {
                            if (!(this.privRequestSession.isSpeechEnded && o === $d7238066c5de7f1c$var$At.NoMatch && a.RecognitionStatus !== $d7238066c5de7f1c$var$ki.InitialSilenceTimeout)) {
                                const l = new $d7238066c5de7f1c$var$Vy(g, g.offset, this.privRequestSession.sessionId);
                                if (this.privTranslationRecognizer.recognized) try {
                                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, l);
                                } catch  {}
                            }
                            if (this.privSuccessCallback) {
                                try {
                                    this.privSuccessCallback(g);
                                } catch (l) {
                                    this.privErrorCallback && this.privErrorCallback(l);
                                }
                                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                            }
                        }
                        i = !0;
                    }
                }), s = (a, o)=>{
                const g = this.fireEventForResult(a, o);
                if (this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + g.offset), this.privTranslationRecognizer.recognizing) try {
                    this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, g);
                } catch  {}
                i = !0;
            };
            switch(e.messageType === $d7238066c5de7f1c$var$Tt.Text && t.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
                case "translation.hypothesis":
                    s($d7238066c5de7f1c$var$LB.fromJSON(e.textBody), t);
                    break;
                case "translation.response":
                    const a = JSON.parse(e.textBody);
                    if (a.SpeechPhrase) yield n($d7238066c5de7f1c$var$NA.fromTranslationResponse(a));
                    else {
                        const g = JSON.parse(e.textBody);
                        g.SpeechHypothesis && s($d7238066c5de7f1c$var$LB.fromTranslationResponse(g), t);
                    }
                    break;
                case "translation.phrase":
                    yield n($d7238066c5de7f1c$var$NA.fromJSON(e.textBody));
                    break;
                case "translation.synthesis":
                    this.sendSynthesisAudio(e.binaryBody, this.privRequestSession.sessionId), i = !0;
                    break;
                case "audio.end":
                case "translation.synthesis.end":
                    const o = $d7238066c5de7f1c$var$kK.fromJSON(e.textBody);
                    switch(o.SynthesisStatus){
                        case $d7238066c5de7f1c$var$OA.Error:
                            if (this.privTranslationRecognizer.synthesizing) {
                                const g = new $d7238066c5de7f1c$var$hN($d7238066c5de7f1c$var$At.Canceled, void 0), l = new $d7238066c5de7f1c$var$dN(g, this.privRequestSession.sessionId);
                                try {
                                    this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, l);
                                } catch  {}
                            }
                            if (this.privTranslationRecognizer.canceled) {
                                const g = new $d7238066c5de7f1c$var$CN(this.privRequestSession.sessionId, $d7238066c5de7f1c$var$Zn.Error, o.FailureReason, $d7238066c5de7f1c$var$vt.ServiceError, null);
                                try {
                                    this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, g);
                                } catch  {}
                            }
                            break;
                        case $d7238066c5de7f1c$var$OA.Success:
                            this.sendSynthesisAudio(void 0, this.privRequestSession.sessionId);
                            break;
                    }
                    i = !0;
                    break;
            }
            return i;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const a = new $d7238066c5de7f1c$var$vi();
        if (a.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]), this.privTranslationRecognizer.canceled) {
            const o = new $d7238066c5de7f1c$var$CN(e, i, s, n, void 0);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, o);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const o = new $d7238066c5de7f1c$var$aI(void 0, // Translations
            t, $d7238066c5de7f1c$var$At.Canceled, void 0, // Text
            void 0, // Druation
            void 0, // Offset
            void 0, // Language
            void 0, // LanguageDetectionConfidence
            s, void 0, // Json
            a);
            try {
                this.privSuccessCallback(o), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
    handleRecognizingCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$Vy($d7238066c5de7f1c$var$aI.fromSpeechRecognitionResult(e), t, i);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, n);
        } catch  {}
    }
    handleRecognizedCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$Vy($d7238066c5de7f1c$var$aI.fromSpeechRecognitionResult(e), t, i);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, n);
        } catch  {}
    }
    fireEventForResult(e, t) {
        let i;
        if (e.Translation.Translations !== void 0) {
            i = new $d7238066c5de7f1c$var$vK();
            for (const c of e.Translation.Translations)i.set(c.Language, c.Text || c.DisplayText);
        }
        let n, s;
        e instanceof $d7238066c5de7f1c$var$NA ? (e.Translation && e.Translation.TranslationStatus === $d7238066c5de7f1c$var$VB.Success ? n = $d7238066c5de7f1c$var$At.TranslatedSpeech : n = $d7238066c5de7f1c$var$At.RecognizedSpeech, s = e.Confidence) : n = $d7238066c5de7f1c$var$At.TranslatingSpeech;
        const a = e.Language, o = e.Offset + this.privRequestSession.currentTurnAudioOffset, g = new $d7238066c5de7f1c$var$aI(i, this.privRequestSession.requestId, n, e.Text, e.Duration, o, a, s, e.Translation.FailureReason, JSON.stringify(e), t);
        return new $d7238066c5de7f1c$var$Vy(g, o, this.privRequestSession.sessionId);
    }
    sendSynthesisAudio(e, t) {
        const i = e === void 0 ? $d7238066c5de7f1c$var$At.SynthesizingAudioCompleted : $d7238066c5de7f1c$var$At.SynthesizingAudio, n = new $d7238066c5de7f1c$var$hN(i, e), s = new $d7238066c5de7f1c$var$dN(n, t);
        if (this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, s);
        } catch  {}
    }
}
class $d7238066c5de7f1c$var$jA {
    constructor(e){
        this.privSpeechStartDetected = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$jA(e);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}
class $d7238066c5de7f1c$var$tp {
    constructor(e){
        this.privSpeechHypothesis = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$tp(e);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}
class $d7238066c5de7f1c$var$EK {
    constructor(e){
        this.privSpeechKeyword = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$EK(e);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
}
var $d7238066c5de7f1c$var$VAe = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$wAe extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privSpeechRecognizer = s;
    }
    processTypeSpecificMessages(e) {
        return $d7238066c5de7f1c$var$VAe(this, void 0, void 0, function*() {
            let t;
            const i = new $d7238066c5de7f1c$var$vi();
            i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody);
            let n = !1;
            switch(e.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const s = $d7238066c5de7f1c$var$tp.fromJSON(e.textBody), a = s.Offset + this.privRequestSession.currentTurnAudioOffset;
                    t = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, $d7238066c5de7f1c$var$At.RecognizingSpeech, s.Text, s.Duration, a, s.Language, s.LanguageDetectionConfidence, void 0, // Speaker Id
                    void 0, e.textBody, i), this.privRequestSession.onHypothesis(a);
                    const o = new $d7238066c5de7f1c$var$fI(t, s.Duration, this.privRequestSession.sessionId);
                    if (this.privSpeechRecognizer.recognizing) try {
                        this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, o);
                    } catch  {}
                    n = !0;
                    break;
                case "speech.phrase":
                    const g = $d7238066c5de7f1c$var$YI.fromJSON(e.textBody), l = $d7238066c5de7f1c$var$gr.implTranslateRecognitionResult(g.RecognitionStatus);
                    if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + g.Offset + g.Duration), $d7238066c5de7f1c$var$At.Canceled === l) {
                        const c = $d7238066c5de7f1c$var$gr.implTranslateCancelResult(g.RecognitionStatus), d = $d7238066c5de7f1c$var$gr.implTranslateCancelErrorCode(g.RecognitionStatus);
                        yield this.cancelRecognitionLocal(c, d, $d7238066c5de7f1c$var$gr.implTranslateErrorDetails(d));
                    } else {
                        if (!(this.privRequestSession.isSpeechEnded && l === $d7238066c5de7f1c$var$At.NoMatch && g.RecognitionStatus !== $d7238066c5de7f1c$var$ki.InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$ug) === $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]) t = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, l, g.DisplayText, g.Duration, g.Offset + this.privRequestSession.currentTurnAudioOffset, g.Language, g.LanguageDetectionConfidence, void 0, // Speaker Id
                            void 0, e.textBody, i);
                            else {
                                const d = $d7238066c5de7f1c$var$hf.fromJSON(e.textBody), p = d.Offset + this.privRequestSession.currentTurnAudioOffset, A = d.getJsonWithCorrectedOffsets(p);
                                t = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, l, d.RecognitionStatus === $d7238066c5de7f1c$var$ki.Success ? d.NBest[0].Display : void 0, d.Duration, p, d.Language, d.LanguageDetectionConfidence, void 0, // Speaker Id
                                void 0, A, i);
                            }
                            const c = new $d7238066c5de7f1c$var$fI(t, t.offset, this.privRequestSession.sessionId);
                            if (this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, c);
                            } catch  {}
                        }
                        if (this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(t);
                            } catch (c) {
                                this.privErrorCallback && this.privErrorCallback(c);
                            }
                            this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                        }
                    }
                    n = !0;
                    break;
            }
            return n;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const a = new $d7238066c5de7f1c$var$vi();
        if (a.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]), this.privSpeechRecognizer.canceled) {
            const o = new $d7238066c5de7f1c$var$yK(i, s, n, void 0, e);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, o);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const o = new $d7238066c5de7f1c$var$no(t, $d7238066c5de7f1c$var$At.Canceled, void 0, // Text
            void 0, // Duration
            void 0, // Offset
            void 0, // Language
            void 0, // Language Detection Confidence
            void 0, // Speaker Id
            s, void 0, // Json
            a);
            try {
                this.privSuccessCallback(o), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
}
var $d7238066c5de7f1c$var$WAe = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$HAe extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privConversationTranscriber = s, this.setSpeakerDiarizationJson();
    }
    setSpeakerDiarizationJson() {
        if (this.privEnableSpeakerId) {
            const e = this.privSpeechContext.getSection("phraseDetection");
            e.mode = "Conversation";
            const t = {};
            t.mode = "Anonymous", t.audioSessionId = this.privDiarizationSessionId, t.audioOffsetMs = 0, e.speakerDiarization = t, this.privSpeechContext.setSection("phraseDetection", e);
        }
    }
    processTypeSpecificMessages(e) {
        return $d7238066c5de7f1c$var$WAe(this, void 0, void 0, function*() {
            let t;
            const i = new $d7238066c5de7f1c$var$vi();
            i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody);
            let n = !1;
            switch(e.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const s = $d7238066c5de7f1c$var$tp.fromJSON(e.textBody), a = s.Offset + this.privRequestSession.currentTurnAudioOffset;
                    t = new $d7238066c5de7f1c$var$zS(this.privRequestSession.requestId, $d7238066c5de7f1c$var$At.RecognizingSpeech, s.Text, s.Duration, a, s.Language, s.LanguageDetectionConfidence, void 0, // Speaker Id
                    void 0, e.textBody, i), this.privRequestSession.onHypothesis(a);
                    const o = new $d7238066c5de7f1c$var$IN(t, s.Duration, this.privRequestSession.sessionId);
                    if (this.privConversationTranscriber.transcribing) try {
                        this.privConversationTranscriber.transcribing(this.privConversationTranscriber, o);
                    } catch  {}
                    n = !0;
                    break;
                case "speech.phrase":
                    const g = $d7238066c5de7f1c$var$YI.fromJSON(e.textBody), l = $d7238066c5de7f1c$var$gr.implTranslateRecognitionResult(g.RecognitionStatus);
                    if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + g.Offset + g.Duration), $d7238066c5de7f1c$var$At.Canceled === l) {
                        const c = $d7238066c5de7f1c$var$gr.implTranslateCancelResult(g.RecognitionStatus), d = $d7238066c5de7f1c$var$gr.implTranslateCancelErrorCode(g.RecognitionStatus);
                        yield this.cancelRecognitionLocal(c, d, $d7238066c5de7f1c$var$gr.implTranslateErrorDetails(d));
                    } else if (!(this.privRequestSession.isSpeechEnded && l === $d7238066c5de7f1c$var$At.NoMatch && g.RecognitionStatus !== $d7238066c5de7f1c$var$ki.InitialSilenceTimeout)) {
                        if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$ug) === $d7238066c5de7f1c$var$bi[$d7238066c5de7f1c$var$bi.Simple]) t = new $d7238066c5de7f1c$var$zS(this.privRequestSession.requestId, l, g.DisplayText, g.Duration, g.Offset + this.privRequestSession.currentTurnAudioOffset, g.Language, g.LanguageDetectionConfidence, g.SpeakerId, void 0, e.textBody, i);
                        else {
                            const d = $d7238066c5de7f1c$var$hf.fromJSON(e.textBody), p = d.Offset + this.privRequestSession.currentTurnAudioOffset, A = d.getJsonWithCorrectedOffsets(p);
                            t = new $d7238066c5de7f1c$var$zS(this.privRequestSession.requestId, l, d.RecognitionStatus === $d7238066c5de7f1c$var$ki.Success ? d.NBest[0].Display : void 0, d.Duration, p, d.Language, d.LanguageDetectionConfidence, g.SpeakerId, void 0, A, i);
                        }
                        const c = new $d7238066c5de7f1c$var$IN(t, t.offset, this.privRequestSession.sessionId);
                        if (this.privConversationTranscriber.transcribed) try {
                            this.privConversationTranscriber.transcribed(this.privConversationTranscriber, c);
                        } catch  {}
                    }
                    n = !0;
                    break;
            }
            return n;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        if (new $d7238066c5de7f1c$var$vi().setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]), this.privConversationTranscriber.canceled) {
            const o = new $d7238066c5de7f1c$var$FK(i, s, n, void 0, e);
            try {
                this.privConversationTranscriber.canceled(this.privConversationTranscriber, o);
            } catch  {}
        }
    }
}
var $d7238066c5de7f1c$var$vX = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$XAe extends $d7238066c5de7f1c$var$PQ {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privTranscriberRecognizer = s, this.sendPrePayloadJSONOverride = (a)=>this.sendTranscriptionStartJSON(a), this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordLevelTimestamps) === "true" && this.privSpeechContext.setWordLevelTimings();
    }
    sendSpeechEventAsync(e, t) {
        return $d7238066c5de7f1c$var$vX(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) {
                const i = yield this.fetchConnection();
                yield this.sendSpeechEvent(i, this.createSpeechEventPayload(e, t));
            }
        });
    }
    sendMeetingSpeechEventAsync(e, t) {
        return $d7238066c5de7f1c$var$vX(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) {
                const i = yield this.fetchConnection();
                yield this.sendSpeechEvent(i, this.createMeetingSpeechEventPayload(e, t));
            }
        });
    }
    processTypeSpecificMessages(e) {
        return this.processSpeechMessages(e);
    }
    handleRecognizedCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$fI(e, t, i);
            if (this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, n), this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(e);
                } catch (s) {
                    this.privErrorCallback && this.privErrorCallback(s);
                }
                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
            }
        } catch  {}
    }
    handleRecognizingCallback(e, t, i) {
        try {
            const n = new $d7238066c5de7f1c$var$fI(e, t, i);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, n);
        } catch  {}
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const a = new $d7238066c5de7f1c$var$vi();
        if (a.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]), this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            if (this.privTranscriberRecognizer.canceled) {
                const o = new $d7238066c5de7f1c$var$MQ(i, s, n, void 0, e);
                try {
                    this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, o);
                } catch  {}
            }
        } else if (this.privTranscriberRecognizer.canceled) {
            const o = new $d7238066c5de7f1c$var$FK(i, s, n, void 0, e);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, o);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const o = new $d7238066c5de7f1c$var$no(t, $d7238066c5de7f1c$var$At.Canceled, void 0, // Text
            void 0, // Duration
            void 0, // Offset
            void 0, // Language
            void 0, // Language Detection Confidence
            void 0, // Speaker Id
            s, void 0, // Json
            a);
            try {
                this.privSuccessCallback(o), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendTranscriptionStartJSON(e) {
        return $d7238066c5de7f1c$var$vX(this, void 0, void 0, function*() {
            if (yield this.sendSpeechContext(e, !0), this.privTranscriberRecognizer.IsMeetingRecognizer()) {
                const t = this.privTranscriberRecognizer.getMeetingInfo(), i = this.createMeetingSpeechEventPayload(t, "start");
                yield this.sendSpeechEvent(e, i);
            } else {
                const t = this.privTranscriberRecognizer.getConversationInfo(), i = this.createSpeechEventPayload(t, "start");
                yield this.sendSpeechEvent(e, i);
            }
            yield this.sendWaveHeader(e);
        });
    }
    sendSpeechEvent(e, t) {
        const i = JSON.stringify(t);
        if (i) return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speech.event", this.privRequestSession.requestId, "application/json", i));
    }
    createSpeechEventPayload(e, t) {
        const i = {
            id: "meeting",
            name: t,
            meeting: e.conversationProperties
        };
        return i.meeting.id = e.id, i.meeting.attendees = e.participants, i;
    }
    createMeetingSpeechEventPayload(e, t) {
        const i = {
            id: "meeting",
            name: t,
            meeting: e.meetingProperties
        };
        return i.meeting.id = e.id, i.meeting.attendees = e.participants, i;
    }
}
class $d7238066c5de7f1c$var$hf {
    constructor(e){
        this.privDetailedSpeechPhrase = JSON.parse(e), this.privDetailedSpeechPhrase.RecognitionStatus = $d7238066c5de7f1c$var$ki[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$hf(e);
    }
    getJsonWithCorrectedOffsets(e) {
        if (this.privDetailedSpeechPhrase.NBest) {
            let t;
            for (const i of this.privDetailedSpeechPhrase.NBest)if (i.Words && i.Words[0]) {
                t = i.Words[0].Offset;
                break;
            }
            if (t && t < e) {
                const i = e - t;
                for (const n of this.privDetailedSpeechPhrase.NBest){
                    if (n.Words) for (const s of n.Words)s.Offset += i;
                    if (n.DisplayWords) for (const s of n.DisplayWords)s.Offset += i;
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        return this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0] ? this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText : this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
}
class $d7238066c5de7f1c$var$YI {
    constructor(e){
        this.privSimpleSpeechPhrase = JSON.parse(e), this.privSimpleSpeechPhrase.RecognitionStatus = $d7238066c5de7f1c$var$ki[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$YI(e);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
}
class $d7238066c5de7f1c$var$vM {
    /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param modelImpl - The model.
   * @param intentName - The intent name.
   */ constructor(e, t){
        this.modelImpl = e, this.intentName = t;
    }
}
class $d7238066c5de7f1c$var$NAe extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privIntentRecognizer = s, this.privIntentDataSent = !1;
    }
    setIntents(e, t) {
        this.privAddedLmIntents = e, this.privUmbrellaIntent = t, this.privIntentDataSent = !0;
    }
    processTypeSpecificMessages(e) {
        let t, i, n = !1;
        const s = new $d7238066c5de7f1c$var$vi();
        switch(e.messageType === $d7238066c5de7f1c$var$Tt.Text && s.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
            case "speech.hypothesis":
                const o = $d7238066c5de7f1c$var$tp.fromJSON(e.textBody);
                if (t = new $d7238066c5de7f1c$var$gA(void 0, this.privRequestSession.requestId, $d7238066c5de7f1c$var$At.RecognizingIntent, o.Text, o.Duration, o.Offset + this.privRequestSession.currentTurnAudioOffset, o.Language, o.LanguageDetectionConfidence, void 0, e.textBody, s), this.privRequestSession.onHypothesis(t.offset), i = new $d7238066c5de7f1c$var$mA(t, o.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privIntentRecognizer.recognizing) try {
                    this.privIntentRecognizer.recognizing(this.privIntentRecognizer, i);
                } catch  {}
                n = !0;
                break;
            case "speech.phrase":
                const g = $d7238066c5de7f1c$var$YI.fromJSON(e.textBody);
                t = new $d7238066c5de7f1c$var$gA(void 0, this.privRequestSession.requestId, $d7238066c5de7f1c$var$gr.implTranslateRecognitionResult(g.RecognitionStatus), g.DisplayText, g.Duration, g.Offset + this.privRequestSession.currentTurnAudioOffset, g.Language, g.LanguageDetectionConfidence, void 0, e.textBody, s), i = new $d7238066c5de7f1c$var$mA(t, t.offset, this.privRequestSession.sessionId);
                const l = ()=>{
                    if (this.privIntentRecognizer.recognized) try {
                        this.privIntentRecognizer.recognized(this.privIntentRecognizer, i);
                    } catch  {}
                    if (this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(t);
                        } catch (d) {
                            this.privErrorCallback && this.privErrorCallback(d);
                        }
                        this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                    }
                };
                this.privIntentDataSent === !1 || $d7238066c5de7f1c$var$At.NoMatch === i.result.reason ? (this.privRequestSession.onPhraseRecognized(i.offset + i.result.duration), l()) : this.privPendingIntentArgs = i, n = !0;
                break;
            case "response":
                if (i = this.privPendingIntentArgs, this.privPendingIntentArgs = void 0, i === void 0) {
                    if (e.textBody === "") return;
                    i = new $d7238066c5de7f1c$var$mA(new $d7238066c5de7f1c$var$gA(), 0, this.privRequestSession.sessionId);
                }
                const c = $d7238066c5de7f1c$var$JK.fromJSON(e.textBody);
                if (c !== null && c.topScoringIntent && c.topScoringIntent.intent) {
                    let d = this.privAddedLmIntents[c.topScoringIntent.intent];
                    if (this.privUmbrellaIntent !== void 0 && (d = this.privUmbrellaIntent), d) {
                        const p = d === void 0 || d.intentName === void 0 ? c.topScoringIntent.intent : d.intentName;
                        let A = i.result.reason;
                        p !== void 0 && (A = $d7238066c5de7f1c$var$At.RecognizedIntent);
                        const y = i.result.properties !== void 0 ? i.result.properties : new $d7238066c5de7f1c$var$vi();
                        y.setProperty($d7238066c5de7f1c$var$T.LanguageUnderstandingServiceResponse_JsonResult, e.textBody), i = new $d7238066c5de7f1c$var$mA(new $d7238066c5de7f1c$var$gA(p, i.result.resultId, A, i.result.text, i.result.duration, i.result.offset, void 0, void 0, i.result.errorDetails, i.result.json, y), i.offset, i.sessionId);
                    }
                }
                if (this.privRequestSession.onPhraseRecognized(i.offset + i.result.duration), this.privIntentRecognizer.recognized) try {
                    this.privIntentRecognizer.recognized(this.privIntentRecognizer, i);
                } catch  {}
                if (this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(i.result);
                    } catch (d) {
                        this.privErrorCallback && this.privErrorCallback(d);
                    }
                    this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                n = !0;
                break;
        }
        const a = new $d7238066c5de7f1c$var$Ui();
        return a.resolve(n), a.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        const a = new $d7238066c5de7f1c$var$vi();
        if (a.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]), this.privIntentRecognizer.canceled) {
            const o = new $d7238066c5de7f1c$var$ZQ(i, s, n, void 0, void 0, e);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, o);
            } catch  {}
        }
        if (this.privSuccessCallback) {
            const o = new $d7238066c5de7f1c$var$gA(void 0, // Intent Id
            t, $d7238066c5de7f1c$var$At.Canceled, void 0, // Text
            void 0, // Duration
            void 0, // Offset
            void 0, // Language
            void 0, // LanguageDetectionConfidence
            s, void 0, // Json
            a);
            try {
                this.privSuccessCallback(o), this.privSuccessCallback = void 0;
            } catch  {}
        }
    }
}
class $d7238066c5de7f1c$var$JK {
    constructor(e){
        e === "" ? this.privIntentResponse = {} : this.privIntentResponse = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$JK(e);
    }
    get query() {
        return this.privIntentResponse.query;
    }
    get topScoringIntent() {
        return this.privIntentResponse.topScoringIntent;
    }
    get entities() {
        return this.privIntentResponse.entities;
    }
}
class $d7238066c5de7f1c$var$LAe {
    constructor(e, t, i){
        this.privIsDisposed = !1, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privRequestId = e, this.privAudioSourceId = t, this.privAudioNodeId = i, this.privReceivedMessages = {}, this.privPhraseLatencies = [], this.privHypothesisLatencies = [];
    }
    phraseReceived(e) {
        e > 0 && this.privPhraseLatencies.push(Date.now() - e);
    }
    hypothesisReceived(e) {
        e > 0 && this.privHypothesisLatencies.push(Date.now() - e);
    }
    onEvent(e) {
        this.privIsDisposed || (e instanceof $d7238066c5de7f1c$var$DQ && e.requestId === this.privRequestId && (this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        }), e instanceof $d7238066c5de7f1c$var$of && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = e.eventTime), e instanceof $d7238066c5de7f1c$var$gf && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = e.eventTime), e instanceof $d7238066c5de7f1c$var$EZ && e.audioSourceId === this.privAudioSourceId && (this.privMicMetric || (this.privMicMetric = {
            End: e.eventTime,
            Error: e.error,
            Name: "Microphone",
            Start: this.privMicStartTime
        })), e instanceof $d7238066c5de7f1c$var$cK && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
            End: e.eventTime,
            Error: e.error,
            Name: "Microphone",
            Start: this.privMicStartTime
        })), e instanceof $d7238066c5de7f1c$var$VI && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
            End: e.eventTime,
            Name: "Microphone",
            Start: this.privMicStartTime
        })), e instanceof $d7238066c5de7f1c$var$_Q && e.requestId === this.privRequestId && (this.privConnectionId = e.sessionId), e instanceof $d7238066c5de7f1c$var$AQ && e.connectionId === this.privConnectionId && (this.privConnectionStartTime = e.eventTime), e instanceof $d7238066c5de7f1c$var$bQ && e.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
            End: e.eventTime,
            Id: this.privConnectionId,
            Name: "Connection",
            Start: this.privConnectionStartTime
        })), e instanceof $d7238066c5de7f1c$var$Rme && e.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
            End: e.eventTime,
            Error: this.getConnectionError(e.statusCode),
            Id: this.privConnectionId,
            Name: "Connection",
            Start: this.privConnectionStartTime
        })), e instanceof $d7238066c5de7f1c$var$lN && e.connectionId === this.privConnectionId && e.message && e.message.headers && e.message.headers.path && (this.privReceivedMessages[e.message.headers.path] || (this.privReceivedMessages[e.message.headers.path] = new Array()), this.privReceivedMessages[e.message.headers.path].length < 50 && this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime)));
    }
    getTelemetry() {
        const e = new Array();
        this.privListeningTriggerMetric && e.push(this.privListeningTriggerMetric), this.privMicMetric && e.push(this.privMicMetric), this.privConnectionEstablishMetric && e.push(this.privConnectionEstablishMetric), this.privPhraseLatencies.length > 0 && e.push({
            PhraseLatencyMs: this.privPhraseLatencies
        }), this.privHypothesisLatencies.length > 0 && e.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const t = {
            Metrics: e,
            ReceivedMessages: this.privReceivedMessages
        }, i = JSON.stringify(t);
        return this.privReceivedMessages = {}, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privPhraseLatencies = [], this.privHypothesisLatencies = [], i;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = !0;
    }
    getConnectionError(e) {
        switch(e){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + e.toString();
        }
    }
}
var $d7238066c5de7f1c$var$Td = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$YAe {
    constructor(e){
        this.privIsDisposed = !1, this.privDetachables = new Array(), this.privIsAudioNodeDetached = !1, this.privIsRecognizing = !1, this.privIsSpeechEnded = !1, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privHypothesisReceived = !1, this.privBytesSent = 0, this.privRecognitionBytesSent = 0, this.privRecogNumber = 0, this.privInTurn = !1, this.privConnectionAttempts = 0, this.privAudioSourceId = e, this.privRequestId = $d7238066c5de7f1c$var$Rn(), this.privAudioNodeId = $d7238066c5de7f1c$var$Rn(), this.privTurnDeferral = new $d7238066c5de7f1c$var$Ui(), this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    // The number of bytes sent for the current recognition.
    // Counter is reset to 0 each time recognition is started.
    get recognitionBytesSent() {
        return this.privRecognitionBytesSent;
    }
    listenForServiceTelemetry(e) {
        this.privServiceTelemetryListener && this.privDetachables.push(e.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privRecognitionBytesSent = 0, this.privIsSpeechEnded = !1, this.privIsRecognizing = !0, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privRecogNumber++, this.privServiceTelemetryListener = new $d7238066c5de7f1c$var$LAe(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId), this.onEvent(new $d7238066c5de7f1c$var$DQ(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onAudioSourceAttachCompleted(e, t) {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            this.privAudioNode = e, this.privIsAudioNodeDetached = !1, t ? yield this.onComplete() : this.onEvent(new $d7238066c5de7f1c$var$GAe(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
        });
    }
    onPreConnectionStart(e, t) {
        this.privAuthFetchEventId = e, this.privSessionId = t, this.onEvent(new $d7238066c5de7f1c$var$_Q(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    onAuthCompleted(e) {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            e && (yield this.onComplete());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onConnectionEstablishCompleted(e, t) {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            if (e === 200) {
                this.onEvent(new $d7238066c5de7f1c$var$vAe(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId)), this.privAudioNode && this.privAudioNode.replay(), this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privBytesSent = 0;
                return;
            } else e === 403 && (yield this.onComplete());
        });
    }
    onServiceTurnEndResponse(e) {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            this.privTurnDeferral.resolve(), !e || this.isSpeechEnded ? (yield this.onComplete(), this.privInTurn = !1) : (this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privAudioNode.replay());
        });
    }
    onSpeechContext() {
        this.privRequestId = $d7238066c5de7f1c$var$Rn();
    }
    onServiceTurnStartResponse() {
        this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(()=>{})), this.privInTurn = !0, this.privTurnDeferral = new $d7238066c5de7f1c$var$Ui();
    }
    onHypothesis(e) {
        this.privHypothesisReceived || (this.privHypothesisReceived = !0, this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(e)));
    }
    onPhraseRecognized(e) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(e)), this.onServiceRecognized(e);
    }
    onServiceRecognized(e) {
        this.privLastRecoOffset = e, this.privHypothesisReceived = !1, this.privAudioNode.shrinkBuffers(e), this.privConnectionAttempts = 0;
    }
    onAudioSent(e) {
        this.privBytesSent += e, this.privRecognitionBytesSent += e;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    dispose() {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                this.privIsDisposed = !0;
                for (const e of this.privDetachables)yield e.detach();
                this.privServiceTelemetryListener && this.privServiceTelemetryListener.dispose(), this.privIsRecognizing = !1;
            }
        });
    }
    getTelemetry() {
        return this.privServiceTelemetryListener.hasTelemetry ? this.privServiceTelemetryListener.getTelemetry() : null;
    }
    onStopRecognizing() {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            yield this.onComplete();
        });
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = !0;
    }
    onEvent(e) {
        this.privServiceTelemetryListener && this.privServiceTelemetryListener.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
    onComplete() {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            this.privIsRecognizing && (this.privIsRecognizing = !1, yield this.detachAudioNode());
        });
    }
    detachAudioNode() {
        return $d7238066c5de7f1c$var$Td(this, void 0, void 0, function*() {
            this.privIsAudioNodeDetached || (this.privIsAudioNodeDetached = !0, this.privAudioNode && (yield this.privAudioNode.detach()));
        });
    }
}
class $d7238066c5de7f1c$var$KAe {
    constructor(e){
        this.privContext = {}, this.privDynamicGrammar = e;
    }
    /**
   * Gets a section of the speech.context object.
   * @param sectionName Name of the section to get.
   * @return string or Context JSON serializable object that represents the value.
   */ getSection(e) {
        return this.privContext[e] || {};
    }
    /**
   * Adds a section to the speech.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */ setSection(e, t) {
        this.privContext[e] = t;
    }
    /**
   * @Internal
   * This is only used by pronunciation assessment config.
   * Do not use externally, object returned will change without warning or notice.
   */ setPronunciationAssessmentParams(e, t, i = !1) {
        this.privContext.phraseDetection === void 0 && (this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        }), this.privContext.phraseDetection.enrichment === void 0 && (this.privContext.phraseDetection.enrichment = {
            pronunciationAssessment: {}
        }), this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(e), i && (this.privContext.phraseDetection.mode = "Conversation"), this.setWordLevelTimings(), this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment"), this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1 && this.privContext.phraseOutput.detailed.options.push("SNR"), t && (this.privContext.phraseDetection.enrichment.contentAssessment = {
            topic: t
        }, this.privContext.phraseOutput.detailed.options.push("ContentAssessment"));
    }
    setDetailedOutputFormat() {
        this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        }), this.privContext.phraseOutput.detailed === void 0 && (this.privContext.phraseOutput.detailed = {
            options: []
        }), this.privContext.phraseOutput.format = "Detailed";
    }
    setWordLevelTimings() {
        this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        }), this.privContext.phraseOutput.detailed === void 0 && (this.privContext.phraseOutput.detailed = {
            options: []
        }), this.privContext.phraseOutput.format = "Detailed", this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1 && this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    setSpeakerDiarizationAudioOffsetMs(e) {
        this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = e;
    }
    toJSON() {
        const e = this.privDynamicGrammar.generateGrammarObject();
        return this.setSection("dgi", e), JSON.stringify(this.privContext);
    }
}
class $d7238066c5de7f1c$var$xAe {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(e) {
        this.privPhrases || (this.privPhrases = []), e instanceof Array ? this.privPhrases = this.privPhrases.concat(e) : this.privPhrases.push(e);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = void 0;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(e) {
        this.privGrammars || (this.privGrammars = []), e instanceof Array ? this.privGrammars = this.privGrammars.concat(e) : this.privGrammars.push(e);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = void 0;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === void 0 && this.privPhrases === void 0) return;
        const e = {};
        if (e.ReferenceGrammars = this.privGrammars, this.privPhrases !== void 0 && this.privPhrases.length !== 0) {
            const t = [];
            this.privPhrases.forEach((i)=>{
                t.push({
                    Text: i
                });
            }), e.Groups = [
                {
                    Type: "Generic",
                    Items: t
                }
            ];
        }
        return e;
    }
}
class $d7238066c5de7f1c$var$UK {
    constructor(e){
        this.privActivityResponse = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$UK(e);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
}
var $d7238066c5de7f1c$var$ZN;
(function(r) {
    r[r.None = 0] = "None", r[r.TextToSpeechAudio = 1] = "TextToSpeechAudio";
})($d7238066c5de7f1c$var$ZN || ($d7238066c5de7f1c$var$ZN = {}));
class $d7238066c5de7f1c$var$FAe {
    constructor(e, t){
        this.privRequestId = t, this.privIsCompleted = !1, this.privAudioStream = null, this.privTurnManager = e, this.resetTurnEndTimeout();
    }
    get audioStream() {
        return this.resetTurnEndTimeout(), this.privAudioStream;
    }
    processActivityPayload(e, t) {
        return e.messageDataStreamType === $d7238066c5de7f1c$var$ZN.TextToSpeechAudio && (this.privAudioStream = $d7238066c5de7f1c$var$qR.createPullStream(), this.privAudioStream.format = t !== void 0 ? t : $d7238066c5de7f1c$var$Ut.getDefaultOutputFormat()), this.privAudioStream;
    }
    endAudioStream() {
        this.privAudioStream !== null && !this.privAudioStream.isClosed && this.privAudioStream.close();
    }
    complete() {
        this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.endAudioStream();
    }
    resetTurnEndTimeout() {
        this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.privTimeoutToken = setTimeout(()=>{
            this.privTurnManager.CompleteTurn(this.privRequestId);
        }, 2e3);
    }
}
class $d7238066c5de7f1c$var$TAe {
    constructor(){
        this.privTurnMap = /* @__PURE__ */ new Map();
    }
    StartTurn(e) {
        if (this.privTurnMap.has(e)) throw new $d7238066c5de7f1c$var$io("Service error: There is already a turn with id:" + e);
        const t = new $d7238066c5de7f1c$var$FAe(this, e);
        return this.privTurnMap.set(e, t), this.privTurnMap.get(e);
    }
    GetTurn(e) {
        return this.privTurnMap.get(e);
    }
    CompleteTurn(e) {
        if (!this.privTurnMap.has(e)) throw new $d7238066c5de7f1c$var$io("Service error: Received turn end for an unknown turn id:" + e);
        const t = this.privTurnMap.get(e);
        return t.complete(), this.privTurnMap.delete(e), t;
    }
}
var $d7238066c5de7f1c$var$tI = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$MAe extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privEvents = new $d7238066c5de7f1c$var$sc(), this.privDialogServiceConnector = s, this.receiveMessageOverride = ()=>this.receiveDialogMessageOverride(), this.privTurnStateManager = new $d7238066c5de7f1c$var$TAe(), this.recognizeOverride = (a, o, g)=>this.listenOnce(a, o, g), this.postConnectImplOverride = (a)=>this.dialogConnectImpl(a), this.configConnectionOverride = (a)=>this.configConnection(a), this.disconnectOverride = ()=>this.privDisconnect(), this.privDialogAudioSource = i, this.agentConfigSent = !1, this.privLastResult = null, this.connectionEvents.attach((a)=>{
            a.name === "ConnectionClosedEvent" && (this.terminateMessageLoop = !0);
        });
    }
    sendMessage(e) {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            const t = $d7238066c5de7f1c$var$kZ(), i = $d7238066c5de7f1c$var$Rn(), n = {
                context: {
                    interactionId: t
                },
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                messagePayload: JSON.parse(e),
                version: 0.5
            }, s = JSON.stringify(n);
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "agent", i, "application/json", s));
        });
    }
    privDisconnect() {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.NoError, "Disconnecting"), this.terminateMessageLoop = !0, this.agentConfigSent = !1;
        });
    }
    processTypeSpecificMessages(e) {
        const t = new $d7238066c5de7f1c$var$vi();
        e.messageType === $d7238066c5de7f1c$var$Tt.Text && t.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody);
        let i, n;
        switch(e.path.toLowerCase()){
            case "speech.phrase":
                const a = $d7238066c5de7f1c$var$YI.fromJSON(e.textBody);
                if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + a.Offset + a.Duration), a.RecognitionStatus !== $d7238066c5de7f1c$var$ki.TooManyRequests && a.RecognitionStatus !== $d7238066c5de7f1c$var$ki.Error) {
                    const p = this.fireEventForResult(a, t);
                    if (this.privLastResult = p.result, this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, p);
                    } catch  {}
                }
                n = !0;
                break;
            case "speech.hypothesis":
                const o = $d7238066c5de7f1c$var$tp.fromJSON(e.textBody), g = o.Offset + this.privRequestSession.currentTurnAudioOffset;
                i = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, $d7238066c5de7f1c$var$At.RecognizingSpeech, o.Text, o.Duration, g, o.Language, o.LanguageDetectionConfidence, void 0, void 0, e.textBody, t), this.privRequestSession.onHypothesis(g);
                const l = new $d7238066c5de7f1c$var$fI(i, o.Duration, this.privRequestSession.sessionId);
                if (this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, l);
                } catch  {}
                n = !0;
                break;
            case "speech.keyword":
                const c = $d7238066c5de7f1c$var$EK.fromJSON(e.textBody);
                i = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, c.Status === "Accepted" ? $d7238066c5de7f1c$var$At.RecognizedKeyword : $d7238066c5de7f1c$var$At.NoMatch, c.Text, c.Duration, c.Offset, void 0, void 0, void 0, void 0, e.textBody, t), c.Status !== "Accepted" && (this.privLastResult = i);
                const d = new $d7238066c5de7f1c$var$fI(i, i.duration, i.resultId);
                if (this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, d);
                } catch  {}
                n = !0;
                break;
            case "audio":
                {
                    const p = e.requestId.toUpperCase(), A = this.privTurnStateManager.GetTurn(p);
                    try {
                        e.binaryBody ? A.audioStream.write(e.binaryBody) : A.endAudioStream();
                    } catch  {}
                }
                n = !0;
                break;
            case "response":
                this.handleResponseMessage(e), n = !0;
                break;
        }
        const s = new $d7238066c5de7f1c$var$Ui();
        return s.resolve(n), s.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            if (this.terminateMessageLoop = !0, this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing()), this.privDialogServiceConnector.canceled) {
                const a = new $d7238066c5de7f1c$var$vi();
                a.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]);
                const o = new $d7238066c5de7f1c$var$yK(i, s, n, void 0, e);
                try {
                    this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, o);
                } catch  {}
                if (this.privSuccessCallback) {
                    const g = new $d7238066c5de7f1c$var$no(void 0, // ResultId
                    $d7238066c5de7f1c$var$At.Canceled, void 0, // Text
                    void 0, // Duration
                    void 0, // Offset
                    void 0, // Language
                    void 0, // Language Detection Confidence
                    void 0, // Speaker Id
                    s, void 0, // Json
                    a);
                    try {
                        this.privSuccessCallback(g), this.privSuccessCallback = void 0;
                    } catch  {}
                }
            }
        });
    }
    listenOnce(e, t, i) {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            this.privRecognizerConfig.recognitionMode = e, this.privSuccessCallback = t, this.privErrorCallback = i, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events), this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$T.Speech_SessionId, this.privRequestSession.sessionId);
            const n = this.connectImpl(), s = this.sendPreAudioMessages(), a = yield this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId), o = yield this.privDialogAudioSource.format, g = yield this.privDialogAudioSource.deviceInfo, l = new $d7238066c5de7f1c$var$jR(a, o.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(l, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: g
            };
            try {
                yield n, yield s;
            } catch (p) {
                return yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.ConnectionFailure, p), Promise.resolve();
            }
            const c = new $d7238066c5de7f1c$var$zr(this.privRequestSession.sessionId);
            this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, c), this.sendAudio(l).then(()=>{}, (p)=>$d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
                    yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.RuntimeError, p);
                }));
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(e) {
        return this.privConnectionLoop = this.startMessageLoop(), e;
    }
    receiveDialogMessageOverride() {
        const e = new $d7238066c5de7f1c$var$Ui(), t = ()=>$d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
                try {
                    const i = this.isDisposed(), n = !this.isDisposed() && this.terminateMessageLoop;
                    if (i || n) {
                        e.resolve(void 0);
                        return;
                    }
                    const a = yield (yield this.fetchConnection()).read();
                    if (!a) return t();
                    const o = $d7238066c5de7f1c$var$$n.fromConnectionMessage(a);
                    switch(o.path.toLowerCase()){
                        case "turn.start":
                            {
                                const y = o.requestId.toUpperCase(), G = this.privRequestSession.requestId.toUpperCase();
                                y !== G ? this.privTurnStateManager.StartTurn(y) : this.privRequestSession.onServiceTurnStartResponse();
                            }
                            break;
                        case "speech.startdetected":
                            const l = $d7238066c5de7f1c$var$jA.fromJSON(o.textBody), c = new $d7238066c5de7f1c$var$rc(l.Offset, this.privRequestSession.sessionId);
                            this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, c);
                            break;
                        case "speech.enddetected":
                            let d;
                            o.textBody.length > 0 ? d = o.textBody : d = "{ Offset: 0 }";
                            const p = $d7238066c5de7f1c$var$jA.fromJSON(d);
                            this.privRequestSession.onServiceRecognized(p.Offset + this.privRequestSession.currentTurnAudioOffset);
                            const A = new $d7238066c5de7f1c$var$rc(p.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                            this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, A);
                            break;
                        case "turn.end":
                            {
                                const y = o.requestId.toUpperCase(), G = this.privRequestSession.requestId.toUpperCase();
                                if (y !== G) this.privTurnStateManager.CompleteTurn(y);
                                else {
                                    const Z = new $d7238066c5de7f1c$var$zr(this.privRequestSession.sessionId);
                                    if (yield this.privRequestSession.onServiceTurnEndResponse(!1), (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) && this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, Z), this.privSuccessCallback && this.privLastResult) {
                                        try {
                                            this.privSuccessCallback(this.privLastResult), this.privLastResult = null;
                                        } catch (v) {
                                            this.privErrorCallback && this.privErrorCallback(v);
                                        }
                                        this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                                    }
                                }
                            }
                            break;
                        default:
                            try {
                                (yield this.processTypeSpecificMessages(o)) || this.serviceEvents && this.serviceEvents.onEvent(new $d7238066c5de7f1c$var$uK(o.path.toLowerCase(), o.textBody));
                            } catch  {}
                    }
                    return t();
                } catch  {
                    this.terminateMessageLoop = !0, e.resolve();
                }
            });
        return t().catch((i)=>{
            $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(i));
        }), e.promise;
    }
    startMessageLoop() {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            this.terminateMessageLoop = !1;
            try {
                yield this.receiveDialogMessageOverride();
            } catch (e) {
                yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.RuntimeError, e);
            }
            return Promise.resolve();
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configConnection(e) {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            return this.terminateMessageLoop ? (this.terminateMessageLoop = !1, Promise.reject("Connection to service terminated.")) : (yield this.sendSpeechServiceConfig(e, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendAgentConfig(e), e);
        });
    }
    sendPreAudioMessages() {
        return $d7238066c5de7f1c$var$tI(this, void 0, void 0, function*() {
            const e = yield this.fetchConnection();
            this.addKeywordContextData(), yield this.sendSpeechContext(e, !0), yield this.sendAgentContext(e), yield this.sendWaveHeader(e);
        });
    }
    sendAgentConfig(e) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.Conversation_DialogType) === $d7238066c5de7f1c$var$ag.DialogTypes.CustomCommands) {
                const i = this.agentConfig.get();
                i.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, "en-us"), this.agentConfig.set(i);
            }
            this.onEvent(new $d7238066c5de7f1c$var$Hme(this.agentConfig));
            const t = this.agentConfig.toJsonString();
            return this.agentConfigSent = !0, e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "agent.config", this.privRequestSession.requestId, "application/json", t));
        }
    }
    sendAgentContext(e) {
        const t = $d7238066c5de7f1c$var$kZ(), i = this.privDialogServiceConnector.properties.getProperty($d7238066c5de7f1c$var$T.Conversation_Speech_Activity_Template), s = JSON.stringify({
            channelData: "",
            context: {
                interactionId: t
            },
            messagePayload: i,
            version: 0.5
        });
        return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", s));
    }
    fireEventForResult(e, t) {
        const i = $d7238066c5de7f1c$var$gr.implTranslateRecognitionResult(e.RecognitionStatus), n = e.Offset + this.privRequestSession.currentTurnAudioOffset, s = new $d7238066c5de7f1c$var$no(this.privRequestSession.requestId, i, e.DisplayText, e.Duration, n, e.Language, e.LanguageDetectionConfidence, void 0, void 0, JSON.stringify(e), t);
        return new $d7238066c5de7f1c$var$fI(s, n, this.privRequestSession.sessionId);
    }
    handleResponseMessage(e) {
        const t = JSON.parse(e.textBody);
        switch(t.messageType.toLowerCase()){
            case "message":
                const i = e.requestId.toUpperCase(), n = $d7238066c5de7f1c$var$UK.fromJSON(e.textBody), s = this.privTurnStateManager.GetTurn(i);
                if (n.conversationId) {
                    const g = this.agentConfig.get();
                    g.botInfo.conversationId = n.conversationId, this.agentConfig.set(g);
                }
                const a = s.processActivityPayload(n, $d7238066c5de7f1c$var$Ut.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_SynthOutputFormat, void 0))), o = new $d7238066c5de7f1c$var$VQ(n.messagePayload, a);
                if (this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, o);
                } catch  {}
                break;
            case "messagestatus":
                if (this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new $d7238066c5de7f1c$var$wQ(e.textBody));
                } catch  {}
                break;
            default:
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(`Unexpected response of type ${t.messageType}. Ignoring.`));
                break;
        }
    }
    onEvent(e) {
        this.privEvents.onEvent(e), $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
    addKeywordContextData() {
        const e = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (e === void 0) return;
        const t = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets"), i = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations"), n = e.split(";"), s = t === void 0 ? [] : t.split(";"), a = i === void 0 ? [] : i.split(";"), o = [];
        for(let g = 0; g < n.length; g++){
            const l = {};
            l.text = n[g], g < s.length && (l.offset = Number(s[g])), g < a.length && (l.duration = Number(a[g])), o.push(l);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword"), this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: o,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    }
}
class $d7238066c5de7f1c$var$jQ {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
   * Setter for the agent.config object.
   * @param value a JSON serializable object.
   */ set(e) {
        this.iPrivConfig = e;
    }
}
class $d7238066c5de7f1c$var$ui extends $d7238066c5de7f1c$var$cu {
    static get host() {
        return $d7238066c5de7f1c$var$ui.privHost;
    }
    static get apiVersion() {
        return $d7238066c5de7f1c$var$ui.privApiVersion;
    }
    static get clientAppId() {
        return $d7238066c5de7f1c$var$ui.privClientAppId;
    }
    static get defaultLanguageCode() {
        return $d7238066c5de7f1c$var$ui.privDefaultLanguageCode;
    }
    static get restPath() {
        return $d7238066c5de7f1c$var$ui.privRestPath;
    }
    static get webSocketPath() {
        return $d7238066c5de7f1c$var$ui.privWebSocketPath;
    }
    static get transcriptionEventKeys() {
        return $d7238066c5de7f1c$var$ui.privTranscriptionEventKeys;
    }
}
$d7238066c5de7f1c$var$ui.privHost = "dev.microsofttranslator.com";
$d7238066c5de7f1c$var$ui.privRestPath = "/capito/room";
$d7238066c5de7f1c$var$ui.privApiVersion = "2.0";
$d7238066c5de7f1c$var$ui.privDefaultLanguageCode = "en-US";
$d7238066c5de7f1c$var$ui.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
$d7238066c5de7f1c$var$ui.privWebSocketPath = "/capito/translate";
$d7238066c5de7f1c$var$ui.privTranscriptionEventKeys = [
    "iCalUid",
    "callId",
    "organizer",
    "FLAC",
    "MTUri",
    "DifferentiateGuestSpeakers",
    "audiorecording",
    "Threadid",
    "OrganizerMri",
    "OrganizerTenantId",
    "UserToken"
];
class $d7238066c5de7f1c$var$qQ {
    constructor(){
        this.privRequestParams = $d7238066c5de7f1c$var$ui.configParams, this.privErrors = $d7238066c5de7f1c$var$ui.restErrors, this.privHost = $d7238066c5de7f1c$var$ui.host, this.privApiVersion = $d7238066c5de7f1c$var$ui.apiVersion, this.privRestPath = $d7238066c5de7f1c$var$ui.restPath, this.privRestAdapter = new $d7238066c5de7f1c$var$SN({});
    }
    /**
   * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
   * @param args
   * @param conversationCode
   * @param callback
   * @param errorCallback
   */ createOrJoin(e, t, i, n) {
        try {
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "args");
            const s = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage, $d7238066c5de7f1c$var$ui.defaultLanguageCode), a = e.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Name, "conversation_host"), o = e.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Host, this.privHost), g = e.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_CorrelationId), l = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Key), c = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region), d = e.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
            $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(s, "languageCode"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(a, "nickname"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(o, "endpointHost");
            const p = {};
            p[this.privRequestParams.apiVersion] = this.privApiVersion, p[this.privRequestParams.languageCode] = s, p[this.privRequestParams.nickname] = a;
            const A = {};
            g && (A[this.privRequestParams.correlationId] = g), A[this.privRequestParams.clientAppId] = $d7238066c5de7f1c$var$ui.clientAppId, t !== void 0 ? p[this.privRequestParams.roomId] = t : ($d7238066c5de7f1c$var$U.throwIfNullOrUndefined(c, this.privErrors.authInvalidSubscriptionRegion), A[this.privRequestParams.subscriptionRegion] = c, l ? A[this.privRequestParams.subscriptionKey] = l : d ? A[this.privRequestParams.authorization] = `Bearer ${d}` : $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(l, this.privErrors.authInvalidSubscriptionKey));
            const y = {};
            y.headers = A, this.privRestAdapter.options = y;
            const G = `https://${o}${this.privRestPath}`;
            this.privRestAdapter.request($d7238066c5de7f1c$var$ah.Post, G, p, null).then((Z)=>{
                const v = $d7238066c5de7f1c$var$SN.extractHeaderValue(this.privRequestParams.requestId, Z.headers);
                if (!Z.ok) {
                    if (n) {
                        let H = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", Z.status.toString()), N;
                        try {
                            N = JSON.parse(Z.data), H += ` [${N.error.code}: ${N.error.message}]`;
                        } catch  {
                            H += ` [${Z.data}]`;
                        }
                        v && (H += ` ${v}`), n(H);
                    }
                    return;
                }
                const V = JSON.parse(Z.data);
                if (V && (V.requestId = v), i) {
                    try {
                        i(V);
                    } catch (H) {
                        n && n(H);
                    }
                    i = void 0;
                }
            }).catch(()=>{});
        } catch (s) {
            if (n) {
                if (s instanceof Error) {
                    const a = s;
                    n(a.name + ": " + a.message);
                } else n(s);
            }
        }
    }
    /**
   * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
   * @param args
   * @param sessionToken
   * @param callback
   */ leave(e, t) {
        return new Promise((i, n)=>{
            try {
                $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "config")), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "token"));
                const s = e.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Host, this.privHost), a = e.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_CorrelationId), o = {};
                o[this.privRequestParams.apiVersion] = this.privApiVersion, o[this.privRequestParams.sessionToken] = t;
                const g = {};
                a && (g[this.privRequestParams.correlationId] = a);
                const l = {};
                l.headers = g, this.privRestAdapter.options = l;
                const c = `https://${s}${this.privRestPath}`;
                this.privRestAdapter.request($d7238066c5de7f1c$var$ah.Delete, c, o, null).then((d)=>{
                    d.ok, i();
                }).catch(()=>{});
            } catch (s) {
                if (s instanceof Error) {
                    const a = s;
                    n(a.name + ": " + a.message);
                } else n(s);
            }
        });
    }
}
class $d7238066c5de7f1c$var$PZ extends $d7238066c5de7f1c$var$JZ {
    constructor(e, t, i, n){
        super(e, t, i, n);
        const s = JSON.parse(this.textBody);
        s.type !== void 0 && (this.privConversationMessageType = s.type);
    }
    get conversationMessageType() {
        return this.privConversationMessageType;
    }
}
class $d7238066c5de7f1c$var$zAe {
    /**
   * Format incoming messages: text (speech partial/final, IM) or binary (tts)
   */ toConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$Ui();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$Tt.Text) {
                const i = new $d7238066c5de7f1c$var$PZ(e.messageType, e.textContent, {}, e.id);
                t.resolve(i);
            } else e.messageType === $d7238066c5de7f1c$var$Tt.Binary && t.resolve(new $d7238066c5de7f1c$var$PZ(e.messageType, e.binaryContent, void 0, e.id));
        } catch (i) {
            t.reject(`Error formatting the message. Error: ${i}`);
        }
        return t.promise;
    }
    /**
   * Format outgoing messages: text (commands or IM)
   */ fromConnectionMessage(e) {
        const t = new $d7238066c5de7f1c$var$Ui();
        try {
            if (e.messageType === $d7238066c5de7f1c$var$Tt.Text) {
                const i = `${e.textBody ? e.textBody : ""}`;
                t.resolve(new $d7238066c5de7f1c$var$RB($d7238066c5de7f1c$var$Tt.Text, i, e.id));
            }
        } catch (i) {
            t.reject(`Error formatting the message. ${i}`);
        }
        return t.promise;
    }
}
class $d7238066c5de7f1c$var$kAe extends $d7238066c5de7f1c$var$Rr {
    create(e, t, i) {
        const n = e.parameters.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Host, $d7238066c5de7f1c$var$ui.host), s = e.parameters.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_CorrelationId, $d7238066c5de7f1c$var$kZ()), a = `wss://${n}${$d7238066c5de7f1c$var$ui.webSocketPath}`, o = e.parameters.getProperty($d7238066c5de7f1c$var$T.ConversationTranslator_Token, void 0);
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(o, "token");
        const g = {};
        g[$d7238066c5de7f1c$var$ui.configParams.apiVersion] = $d7238066c5de7f1c$var$ui.apiVersion, g[$d7238066c5de7f1c$var$ui.configParams.token] = o, g[$d7238066c5de7f1c$var$ui.configParams.correlationId] = s;
        const l = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $d7238066c5de7f1c$var$Au(a, g, {}, new $d7238066c5de7f1c$var$zAe(), $d7238066c5de7f1c$var$ll.fromRecognizerConfig(e), l, i);
    }
}
var $d7238066c5de7f1c$var$EAe = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$JAe {
    constructor(e){
        this.privIsDisposed = !1, this.privDetachables = new Array(), this.privSessionId = e, this.privRequestId = $d7238066c5de7f1c$var$Rn(), this.privRequestCompletionDeferral = new $d7238066c5de7f1c$var$Ui();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get completionPromise() {
        return this.privRequestCompletionDeferral.promise;
    }
    onPreConnectionStart(e, t) {
        this.privSessionId = t;
    }
    onAuthCompleted(e) {
        e && this.onComplete();
    }
    onConnectionEstablishCompleted(e) {
        e !== 200 && e === 403 && this.onComplete();
    }
    onServiceTurnEndResponse(e) {
        e ? this.privRequestId = $d7238066c5de7f1c$var$Rn() : this.onComplete();
    }
    dispose() {
        return $d7238066c5de7f1c$var$EAe(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                this.privIsDisposed = !0;
                for (const e of this.privDetachables)yield e.detach();
            }
        });
    }
    onComplete() {}
}
class $d7238066c5de7f1c$var$UAe extends $d7238066c5de7f1c$var$zr {
    constructor(e, t){
        super(t), this.privIsMuted = e;
    }
    get isMuted() {
        return this.privIsMuted;
    }
}
class $d7238066c5de7f1c$var$DAe extends $d7238066c5de7f1c$var$zr {
    constructor(e, t){
        super(t), this.privIsLocked = e;
    }
    get isMuted() {
        return this.privIsLocked;
    }
}
class $d7238066c5de7f1c$var$SM extends $d7238066c5de7f1c$var$zr {
    constructor(e, t){
        super(t), this.privParticipant = e;
    }
    get participant() {
        return this.privParticipant;
    }
}
class $d7238066c5de7f1c$var$dy extends $d7238066c5de7f1c$var$zr {
    constructor(e, t, i, n){
        super(n), this.privKey = t, this.privValue = i, this.privParticipantId = e;
    }
    get value() {
        return this.privValue;
    }
    get key() {
        return this.privKey;
    }
    get id() {
        return this.privParticipantId;
    }
}
class $d7238066c5de7f1c$var$_Ae extends $d7238066c5de7f1c$var$zr {
    constructor(e, t, i, n, s, a, o, g, l){
        super(l), this.privRoomId = e, this.privSessionToken = t, this.privTranslateTo = i, this.privProfanityFilter = n, this.privRoomProfanityFilter = s, this.privIsRoomLocked = a, this.privIsRoomLocked = o, this.privParticipants = g;
    }
    get sessionToken() {
        return this.privSessionToken;
    }
    get conversationId() {
        return this.privRoomId;
    }
    get translateTo() {
        return this.privTranslateTo;
    }
    get profanityFilter() {
        return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
        return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
        return this.privIsRoomLocked;
    }
    get isMuteAll() {
        return this.privIsMuteAll;
    }
    get participants() {
        return this.privParticipants;
    }
}
class $d7238066c5de7f1c$var$SX {
    constructor(e, t, i){
        this.privPayload = t, this.privCommand = e, this.privSessionId = i;
    }
    get payload() {
        return this.privPayload;
    }
    get command() {
        return this.privCommand;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $d7238066c5de7f1c$var$$Q {
    constructor(e = [], t){
        this.participants = e, this.meId = t;
    }
    /**
   * Add or update a participant
   * @param value
   */ addOrUpdateParticipant(e) {
        if (e === void 0) return;
        const t = this.getParticipantIndex(e.id);
        return t > -1 ? this.participants.splice(t, 1, e) : this.participants.push(e), this.getParticipant(e.id);
    }
    /**
   * Find the participant's position in the participants list.
   * @param id
   */ getParticipantIndex(e) {
        return this.participants.findIndex((t)=>t.id === e);
    }
    /**
   * Find the participant by id.
   * @param id
   */ getParticipant(e) {
        return this.participants.find((t)=>t.id === e);
    }
    /**
   * Remove a participant from the participants list.
   */ deleteParticipant(e) {
        this.participants = this.participants.filter((t)=>t.id !== e);
    }
    /**
   * Helper to return the conversation host.
   */ get host() {
        return this.participants.find((e)=>e.isHost === !0);
    }
    /**
   * Helper to return the current user.
   */ get me() {
        return this.getParticipant(this.meId);
    }
}
const $d7238066c5de7f1c$var$On = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    keepAlive: "keep_alive",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
}, $d7238066c5de7f1c$var$Yn = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
}, $d7238066c5de7f1c$var$PAe = (r)=>JSON.parse(r);
class $d7238066c5de7f1c$var$DK {
    constructor(e){
        this.privCommandResponse = $d7238066c5de7f1c$var$PAe(e);
    }
    get type() {
        return this.privCommandResponse.type;
    }
    get command() {
        return this.privCommandResponse.command;
    }
    get id() {
        return this.privCommandResponse.id;
    }
    get nickname() {
        return this.privCommandResponse.nickname;
    }
    get participantId() {
        return this.privCommandResponse.participantId;
    }
    get roomid() {
        return this.privCommandResponse.roomid;
    }
    get value() {
        return this.privCommandResponse.value;
    }
    get token() {
        return this.privCommandResponse.token;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$DK(e);
    }
}
const $d7238066c5de7f1c$var$QAe = (r)=>JSON.parse(r), $d7238066c5de7f1c$var$OAe = (r)=>JSON.parse(r);
class $d7238066c5de7f1c$var$_K {
    constructor(e){
        this.privParticipantsPayloadResponse = $d7238066c5de7f1c$var$QAe(e);
    }
    get roomid() {
        return this.privParticipantsPayloadResponse.roomid;
    }
    get id() {
        return this.privParticipantsPayloadResponse.id;
    }
    get command() {
        return this.privParticipantsPayloadResponse.command;
    }
    get participants() {
        return this.privParticipantsPayloadResponse.participants;
    }
    get token() {
        return this.privParticipantsPayloadResponse.token;
    }
    get translateTo() {
        return this.privParticipantsPayloadResponse.translateTo;
    }
    get profanityFilter() {
        return this.privParticipantsPayloadResponse.profanityFilter;
    }
    get roomProfanityFilter() {
        return this.privParticipantsPayloadResponse.roomProfanityFilter;
    }
    get roomLocked() {
        return this.privParticipantsPayloadResponse.roomLocked;
    }
    get muteAll() {
        return this.privParticipantsPayloadResponse.muteAll;
    }
    get type() {
        return this.privParticipantsPayloadResponse.type;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$_K(e);
    }
}
class $d7238066c5de7f1c$var$PK {
    constructor(e){
        this.privParticipantPayloadResponse = $d7238066c5de7f1c$var$OAe(e);
    }
    get nickname() {
        return this.privParticipantPayloadResponse.nickname;
    }
    get locale() {
        return this.privParticipantPayloadResponse.locale;
    }
    get usetts() {
        return this.privParticipantPayloadResponse.usetts;
    }
    get ismuted() {
        return this.privParticipantPayloadResponse.ismuted;
    }
    get ishost() {
        return this.privParticipantPayloadResponse.ishost;
    }
    get participantId() {
        return this.privParticipantPayloadResponse.participantId;
    }
    get avatar() {
        return this.privParticipantPayloadResponse.avatar;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$PK(e);
    }
}
const $d7238066c5de7f1c$var$jAe = (r)=>JSON.parse(r), $d7238066c5de7f1c$var$qAe = (r)=>JSON.parse(r);
class $d7238066c5de7f1c$var$QK {
    constructor(e){
        this.privSpeechResponse = $d7238066c5de7f1c$var$jAe(e);
    }
    get recognition() {
        return this.privSpeechResponse.recognition;
    }
    get translations() {
        return this.privSpeechResponse.translations;
    }
    get id() {
        return this.privSpeechResponse.id;
    }
    get language() {
        return this.privSpeechResponse.language;
    }
    get nickname() {
        return this.privSpeechResponse.nickname;
    }
    get participantId() {
        return this.privSpeechResponse.participantId;
    }
    get roomid() {
        return this.privSpeechResponse.roomid;
    }
    get timestamp() {
        return this.privSpeechResponse.timestamp;
    }
    get type() {
        return this.privSpeechResponse.type;
    }
    get isFinal() {
        return this.privSpeechResponse.type === "final";
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$QK(e);
    }
}
class $d7238066c5de7f1c$var$OK {
    constructor(e){
        this.privTextResponse = $d7238066c5de7f1c$var$qAe(e);
    }
    get originalText() {
        return this.privTextResponse.originalText;
    }
    get translations() {
        return this.privTextResponse.translations;
    }
    get id() {
        return this.privTextResponse.id;
    }
    get language() {
        return this.privTextResponse.language;
    }
    get nickname() {
        return this.privTextResponse.nickname;
    }
    get participantId() {
        return this.privTextResponse.participantId;
    }
    get roomid() {
        return this.privTextResponse.roomid;
    }
    get timestamp() {
        return this.privTextResponse.timestamp;
    }
    get type() {
        return this.privTextResponse.type;
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$OK(e);
    }
}
var $d7238066c5de7f1c$var$fC = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$$Ae extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privConnectionConfigPromise = void 0, this.privLastPartialUtteranceId = "", this.privConversationServiceConnector = s, this.privConversationAuthentication = e, this.receiveMessageOverride = ()=>this.receiveConversationMessageOverride(), this.recognizeOverride = ()=>this.noOp(), this.postConnectImplOverride = (a)=>this.conversationConnectImpl(a), this.configConnectionOverride = ()=>this.configConnection(), this.disconnectOverride = ()=>this.privDisconnect(), this.privConversationRequestSession = new $d7238066c5de7f1c$var$JAe($d7238066c5de7f1c$var$Rn()), this.privConversationConnectionFactory = t, this.privConversationIsDisposed = !1;
    }
    isDisposed() {
        return super.isDisposed() || this.privConversationIsDisposed;
    }
    dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            this.privConversationIsDisposed = !0, this.privConnectionConfigPromise !== void 0 && (yield (yield this.privConnectionConfigPromise).dispose(e)), yield t.dispose.call(this, e);
        });
    }
    sendMessage(e) {
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            return (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$PZ($d7238066c5de7f1c$var$Tt.Text, e));
        });
    }
    sendMessageAsync(e) {
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            yield (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$PZ($d7238066c5de7f1c$var$Tt.Text, e));
        });
    }
    privDisconnect() {
        if (!this.terminateMessageLoop) return this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.NoError, "Disconnecting"), this.terminateMessageLoop = !0, Promise.resolve();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    processTypeSpecificMessages() {
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            return !0;
        });
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        this.terminateMessageLoop = !0;
        const a = new $d7238066c5de7f1c$var$YK(i, s, n, void 0, e);
        try {
            this.privConversationServiceConnector.canceled && this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, a);
        } catch  {}
    }
    /**
   * Establishes a websocket connection to the end point.
   */ conversationConnectImpl(e) {
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            return this.privConnectionLoop = this.startMessageLoop(), e;
        });
    }
    /**
   * Process incoming websocket messages
   */ receiveConversationMessageOverride() {
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            if (this.isDisposed() || this.terminateMessageLoop) return Promise.resolve();
            const e = new $d7238066c5de7f1c$var$Ui();
            try {
                const i = yield (yield this.fetchConnection()).read();
                if (this.isDisposed() || this.terminateMessageLoop) return e.resolve(), Promise.resolve();
                if (!i) return this.receiveConversationMessageOverride();
                const n = this.privConversationRequestSession.sessionId, s = i.conversationMessageType.toLowerCase();
                let a = !1;
                try {
                    switch(s){
                        case "info":
                        case "participant_command":
                        case "command":
                            const o = $d7238066c5de7f1c$var$DK.fromJSON(i.textBody);
                            switch(o.command.toLowerCase()){
                                case "participantlist":
                                    const A = $d7238066c5de7f1c$var$_K.fromJSON(i.textBody), y = A.participants.map((N)=>({
                                            avatar: N.avatar,
                                            displayName: N.nickname,
                                            id: N.participantId,
                                            isHost: N.ishost,
                                            isMuted: N.ismuted,
                                            isUsingTts: N.usetts,
                                            preferredLanguage: N.locale
                                        }));
                                    this.privConversationServiceConnector.participantsListReceived && this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$_Ae(A.roomid, A.token, A.translateTo, A.profanityFilter, A.roomProfanityFilter, A.roomLocked, A.muteAll, y, n));
                                    break;
                                case "settranslatetolanguages":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$dy(o.participantId, $d7238066c5de7f1c$var$Yn.setTranslateToLanguages, o.value, n));
                                    break;
                                case "setprofanityfiltering":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$dy(o.participantId, $d7238066c5de7f1c$var$Yn.setProfanityFiltering, o.value, n));
                                    break;
                                case "setmute":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$dy(o.participantId, $d7238066c5de7f1c$var$Yn.setMute, o.value, n));
                                    break;
                                case "setmuteall":
                                    this.privConversationServiceConnector.muteAllCommandReceived && this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$UAe(o.value, n));
                                    break;
                                case "roomexpirationwarning":
                                    this.privConversationServiceConnector.conversationExpiration && this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$XQ(o.value, this.privConversationRequestSession.sessionId));
                                    break;
                                case "setusetts":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$dy(o.participantId, $d7238066c5de7f1c$var$Yn.setUseTTS, o.value, n));
                                    break;
                                case "setlockstate":
                                    this.privConversationServiceConnector.lockRoomCommandReceived && this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$DAe(o.value, n));
                                    break;
                                case "changenickname":
                                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$dy(o.participantId, $d7238066c5de7f1c$var$Yn.changeNickname, o.value, n));
                                    break;
                                case "joinsession":
                                    const G = $d7238066c5de7f1c$var$PK.fromJSON(i.textBody), Z = {
                                        avatar: G.avatar,
                                        displayName: G.nickname,
                                        id: G.participantId,
                                        isHost: G.ishost,
                                        isMuted: G.ismuted,
                                        isUsingTts: G.usetts,
                                        preferredLanguage: G.locale
                                    };
                                    this.privConversationServiceConnector.participantJoinCommandReceived && this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$SM(Z, n));
                                    break;
                                case "leavesession":
                                    const v = {
                                        id: o.participantId
                                    };
                                    this.privConversationServiceConnector.participantLeaveCommandReceived && this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$SM(v, n));
                                    break;
                                case "disconnectsession":
                                    const V = {
                                        id: o.participantId
                                    };
                                    break;
                                case "token":
                                    const H = new $d7238066c5de7f1c$var$UC(()=>{
                                        const N = o.token;
                                        return Promise.resolve(N);
                                    }, ()=>{
                                        const N = o.token;
                                        return Promise.resolve(N);
                                    });
                                    this.authentication = H, this.privConversationServiceConnector.onToken(H);
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case "partial":
                        case "final":
                            const g = $d7238066c5de7f1c$var$QK.fromJSON(i.textBody), l = s === "final" ? $d7238066c5de7f1c$var$At.TranslatedParticipantSpeech : $d7238066c5de7f1c$var$At.TranslatingParticipantSpeech, c = new $d7238066c5de7f1c$var$yN(g.participantId, this.getTranslations(g.translations), g.language, g.id, l, g.recognition, void 0, void 0, i.textBody, void 0);
                            g.isFinal ? ((c.text !== void 0 && c.text.length > 0 || g.id === this.privLastPartialUtteranceId) && (a = !0), a && this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$SX($d7238066c5de7f1c$var$On.final, c, n))) : c.text !== void 0 && (this.privLastPartialUtteranceId = g.id, this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$SX($d7238066c5de7f1c$var$On.partial, c, n)));
                            break;
                        case "translated_message":
                            const d = $d7238066c5de7f1c$var$OK.fromJSON(i.textBody), p = new $d7238066c5de7f1c$var$yN(d.participantId, this.getTranslations(d.translations), d.language, void 0, void 0, d.originalText, void 0, void 0, void 0, i.textBody, void 0);
                            this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $d7238066c5de7f1c$var$SX($d7238066c5de7f1c$var$On.instantMessage, p, n));
                            break;
                        default:
                            break;
                    }
                } catch  {}
                return this.receiveConversationMessageOverride();
            } catch  {
                this.terminateMessageLoop = !0;
            }
            return e.promise;
        });
    }
    startMessageLoop() {
        return $d7238066c5de7f1c$var$fC(this, void 0, void 0, function*() {
            if (this.isDisposed()) return Promise.resolve();
            this.terminateMessageLoop = !1;
            const e = this.receiveConversationMessageOverride();
            try {
                return yield e;
            } catch (t) {
                return this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.RuntimeError, t), null;
            }
        });
    }
    // Takes an established websocket connection to the endpoint
    configConnection() {
        return this.isDisposed() ? Promise.resolve(void 0) : this.privConnectionConfigPromise !== void 0 ? this.privConnectionConfigPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$ir.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigPromise = void 0, this.configConnection()) : this.privConnectionConfigPromise, ()=>(this.privConnectionId = null, this.privConnectionConfigPromise = void 0, this.configConnection())) : this.terminateMessageLoop ? Promise.resolve(void 0) : (this.privConnectionConfigPromise = this.connectImpl().then((e)=>e), this.privConnectionConfigPromise);
    }
    getTranslations(e) {
        let t;
        if (e !== void 0) {
            t = new $d7238066c5de7f1c$var$vK();
            for (const i of e)t.set(i.lang, i.translation);
        }
        return t;
    }
}
var $d7238066c5de7f1c$var$ZM = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$e0e {
    static fromConfig(e, t, i) {
        return new $d7238066c5de7f1c$var$t0e(e, t, i);
    }
}
class $d7238066c5de7f1c$var$t0e extends $d7238066c5de7f1c$var$gl {
    constructor(e, t, i){
        const n = t;
        $d7238066c5de7f1c$var$U.throwIfNull(n, "speechConfig");
        const s = e;
        $d7238066c5de7f1c$var$U.throwIfNull(s, "conversationImpl"), super(i, n.properties, new $d7238066c5de7f1c$var$kAe()), this.privConversation = s, this.privIsDisposed = !1, this.privProperties = n.properties.clone(), this.privConnection = $d7238066c5de7f1c$var$DC.fromRecognizer(this), this.privProperties.getProperty($d7238066c5de7f1c$var$T.WebWorkerLoadType, "on").toLowerCase() === "on" && typeof Blob < "u" && typeof Worker < "u" ? (this.privSetTimeout = $d7238066c5de7f1c$var$Mr.setTimeout, this.privClearTimeout = $d7238066c5de7f1c$var$Mr.clearTimeout) : typeof window < "u" ? (this.privSetTimeout = window.setTimeout.bind(window), this.privClearTimeout = window.clearTimeout.bind(window)) : (this.privSetTimeout = setTimeout, this.privClearTimeout = clearTimeout);
    }
    set connected(e) {
        this.privConnection.connected = e;
    }
    set disconnected(e) {
        this.privConnection.disconnected = e;
    }
    /**
   * Return the speech language used by the recognizer
   */ get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    /**
   * Return the properties for the recognizer
   */ get properties() {
        return this.privProperties;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    /**
   * Connect to the recognizer
   * @param token
   */ connect(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.privReco.conversationTranslatorToken = e, this.resetConversationTimeout(), this.privReco.connectAsync(t, i);
        } catch (n) {
            if (i) {
                if (n instanceof Error) {
                    const s = n;
                    i(s.name + ": " + s.message);
                } else i(n);
            }
        }
    }
    /**
   * Disconnect from the recognizer
   */ disconnect(e, t) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privReco.disconnect().then(()=>{
                e && e();
            }, (i)=>{
                t && t(i);
            });
        } catch (i) {
            if (t) {
                if (i instanceof Error) {
                    const n = i;
                    t(n.name + ": " + n.message);
                } else t(i);
            }
            this.dispose(!0).catch((n)=>{
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(n));
            });
        }
    }
    /**
   * Send the mute all participants command to the websocket
   * @param conversationId
   * @param participantId
   * @param isMuted
   */ sendRequest(e, t, i) {
        try {
            $d7238066c5de7f1c$var$U.throwIfDisposed(this.privIsDisposed), this.sendMessage(e, t, i);
        } catch (n) {
            if (i) {
                if (n instanceof Error) {
                    const s = n;
                    i(s.name + ": " + s.message);
                } else i(n);
            }
            this.dispose(!0).catch((s)=>{
                $d7238066c5de7f1c$var$as.instance.onEvent(new $d7238066c5de7f1c$var$yI(s));
            });
        }
    }
    /**
   * Handle update of service auth token (#694)
   */ onToken(e) {
        this.privConversation.onToken(e);
    }
    /**
   * Close and dispose the recognizer
   */ close() {
        return $d7238066c5de7f1c$var$ZM(this, void 0, void 0, function*() {
            this.privIsDisposed || (this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close()), this.privConnection = void 0, yield this.dispose(!0));
        });
    }
    /**
   * Dispose the recognizer
   * @param disposing
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$ZM(this, void 0, void 0, function*() {
            this.privIsDisposed || e && (this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privIsDisposed = !0, this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close(), this.privConnection = void 0), yield t.dispose.call(this, e));
        });
    }
    /**
   * Create the config for the recognizer
   * @param speechConfig
   */ createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.privProperties);
    }
    /**
   * Create the service recognizer.
   * The audio source is redundnant here but is required by the implementation.
   * @param authentication
   * @param connectionFactory
   * @param audioConfig
   * @param recognizerConfig
   */ createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$$Ae(e, t, s, n, this);
    }
    sendMessage(e, t, i) {
        const n = this.privReco;
        ((a, o, g)=>{
            a !== void 0 ? a.then(()=>{
                try {
                    o && o();
                } catch (l) {
                    g && g(`'Unhandled error on promise callback: ${l}'`);
                }
            }, (l)=>{
                try {
                    g && g(l);
                } catch  {}
            }) : g && g("Null promise");
        })(n.sendMessageAsync(e), t, i), this.resetConversationTimeout();
    }
    resetConversationTimeout() {
        this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privTimeoutToken = this.privSetTimeout(()=>{
            this.sendRequest(this.privConversation.getKeepAlive());
        }, 6e4);
    }
}
var $d7238066c5de7f1c$var$hy = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$i0e extends $d7238066c5de7f1c$var$gl {
    /**
   * TranscriberRecognizer constructor.
   * @constructor
   * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
   * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
   */ constructor(e, t){
        const i = e;
        $d7238066c5de7f1c$var$U.throwIfNull(i, "speechTranslationConfig");
        const n = t;
        $d7238066c5de7f1c$var$U.throwIfNull(n, "audioConfigImpl"), $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(i.speechRecognitionLanguage, $d7238066c5de7f1c$var$T[$d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage]), super(t, i.properties, new $d7238066c5de7f1c$var$QQ()), this.privDisposedRecognizer = !1, this.isMeetingRecognizer = !1;
    }
    get speechRecognitionLanguage() {
        return $d7238066c5de7f1c$var$U.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
        return this.privProperties;
    }
    get authorizationToken() {
        return this.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty($d7238066c5de7f1c$var$T.SpeechServiceAuthorization_Token, e);
    }
    set conversation(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "Conversation"), this.isMeetingRecognizer = !1, this.privConversation = e;
    }
    getConversationInfo() {
        return $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privConversation, "Conversation"), this.privConversation.conversationInfo;
    }
    set meeting(e) {
        $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(e, "Meeting"), this.isMeetingRecognizer = !0, this.privMeeting = e;
    }
    getMeetingInfo() {
        return $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(this.privMeeting, "Meeting"), this.privMeeting.meetingInfo;
    }
    IsMeetingRecognizer() {
        return this.isMeetingRecognizer;
    }
    startContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.startContinuousRecognitionAsyncImpl($d7238066c5de7f1c$var$cr.Conversation), e, t);
    }
    stopContinuousRecognitionAsync(e, t) {
        $d7238066c5de7f1c$var$ri(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    close() {
        return $d7238066c5de7f1c$var$hy(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (yield this.dispose(!0));
        });
    }
    // Push async join/leave conversation message via serviceRecognizer
    pushConversationEvent(e, t) {
        return $d7238066c5de7f1c$var$hy(this, void 0, void 0, function*() {
            const i = this.privReco;
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(i, "serviceRecognizer"), yield i.sendSpeechEventAsync(e, t);
        });
    }
    // Push async join/leave meeting message via serviceRecognizer
    pushMeetingEvent(e, t) {
        return $d7238066c5de7f1c$var$hy(this, void 0, void 0, function*() {
            const i = this.privReco;
            $d7238066c5de7f1c$var$U.throwIfNullOrUndefined(i, "serviceRecognizer"), yield i.sendMeetingSpeechEventAsync(e, t);
        });
    }
    enforceAudioGating() {
        return $d7238066c5de7f1c$var$hy(this, void 0, void 0, function*() {
            const i = (yield this.audioConfig.format).channels;
            if (i === 1) {
                if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true") throw new Error("Single channel audio configuration for MeetingTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
            } else if (i !== 8) throw new Error(`Unsupported audio configuration: Detected ${i}-channel audio`);
        });
    }
    connectMeetingCallbacks(e) {
        this.isMeetingRecognizer = !0, this.canceled = (t, i)=>{
            e.canceled && e.canceled(e, i);
        }, this.recognizing = (t, i)=>{
            e.transcribing && e.transcribing(e, i);
        }, this.recognized = (t, i)=>{
            e.transcribed && e.transcribed(e, i);
        }, this.sessionStarted = (t, i)=>{
            e.sessionStarted && e.sessionStarted(e, i);
        }, this.sessionStopped = (t, i)=>{
            e.sessionStopped && e.sessionStopped(e, i);
        };
    }
    disconnectCallbacks() {
        this.canceled = void 0, this.recognizing = void 0, this.recognized = void 0, this.sessionStarted = void 0, this.sessionStopped = void 0;
    }
    /**
   * Disposes any resources held by the object.
   * @member ConversationTranscriber.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - true if disposing the object.
   */ dispose(e) {
        const t = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $d7238066c5de7f1c$var$hy(this, void 0, void 0, function*() {
            this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
        });
    }
    createRecognizerConfig(e) {
        return new $d7238066c5de7f1c$var$NI(e, this.properties);
    }
    createServiceRecognizer(e, t, i, n) {
        const s = i;
        return new $d7238066c5de7f1c$var$XAe(e, t, s, n, this);
    }
}
var $d7238066c5de7f1c$var$Dc;
(function(r) {
    r.WordBoundary = "WordBoundary", r.Bookmark = "Bookmark", r.Viseme = "Viseme", r.SentenceBoundary = "SentenceBoundary", r.SessionEnd = "SessionEnd", r.AvatarSignal = "TalkingAvatarSignal";
})($d7238066c5de7f1c$var$Dc || ($d7238066c5de7f1c$var$Dc = {}));
class $d7238066c5de7f1c$var$jK {
    constructor(e){
        this.privSynthesisAudioMetadata = JSON.parse(e);
    }
    static fromJSON(e) {
        return new $d7238066c5de7f1c$var$jK(e);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}
class $d7238066c5de7f1c$var$qK extends $d7238066c5de7f1c$var$lu {
    constructor(e, t, i = $d7238066c5de7f1c$var$Ys.Info){
        super(e, i), this.privRequestId = t;
    }
    get requestId() {
        return this.privRequestId;
    }
}
class $d7238066c5de7f1c$var$n0e extends $d7238066c5de7f1c$var$qK {
    constructor(e, t, i){
        super("SynthesisTriggeredEvent", e), this.privSessionAudioDestinationId = t, this.privTurnAudioDestinationId = i;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
class $d7238066c5de7f1c$var$s0e extends $d7238066c5de7f1c$var$qK {
    constructor(e, t){
        super("ConnectingToSynthesisServiceEvent", e), this.privAuthFetchEventId = t;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
class $d7238066c5de7f1c$var$r0e extends $d7238066c5de7f1c$var$qK {
    constructor(e, t){
        super("SynthesisStartedEvent", e), this.privAuthFetchEventId = t;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $d7238066c5de7f1c$var$IS = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$QZ {
    constructor(){
        this.privIsDisposed = !1, this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !1, this.privBytesReceived = 0, this.privInTurn = !1, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privSentenceOffset = 0, this.privNextSearchSentenceIndex = 0, this.privRequestId = $d7238066c5de7f1c$var$Rn(), this.privTurnDeferral = new $d7238066c5de7f1c$var$Ui(), this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(e) {
        this.privStreamId = e;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(e) {
        this.privAudioOutputFormat = e;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    get extraProperties() {
        if (this.privWebRTCSDP) {
            const e = new $d7238066c5de7f1c$var$vi();
            return e.setProperty($d7238066c5de7f1c$var$T.TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP), e;
        }
    }
    getAllReceivedAudio() {
        return $d7238066c5de7f1c$var$IS(this, void 0, void 0, function*() {
            return this.privReceivedAudio ? Promise.resolve(this.privReceivedAudio) : this.privIsSynthesisEnded ? (yield this.readAllAudioFromStream(), Promise.resolve(this.privReceivedAudio)) : null;
        });
    }
    getAllReceivedAudioWithHeader() {
        return $d7238066c5de7f1c$var$IS(this, void 0, void 0, function*() {
            if (this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
            if (!this.privIsSynthesisEnded) return null;
            if (this.audioOutputFormat.hasHeader) {
                const e = yield this.getAllReceivedAudio();
                return this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(e), this.privReceivedAudioWithHeader;
            } else return this.getAllReceivedAudio();
        });
    }
    startNewSynthesis(e, t, i, n) {
        this.privIsSynthesisEnded = !1, this.privIsSynthesizing = !0, this.privRequestId = e, this.privRawText = t, this.privIsSSML = i, this.privAudioOutputStream = new $d7238066c5de7f1c$var$pK(), this.privAudioOutputStream.format = this.privAudioOutputFormat, this.privReceivedAudio = null, this.privReceivedAudioWithHeader = null, this.privBytesReceived = 0, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privSentenceOffset = 0, this.privNextSearchSentenceIndex = 0, this.privPartialVisemeAnimation = "", this.privWebRTCSDP = "", n !== void 0 && (this.privTurnAudioDestination = n, this.privTurnAudioDestination.format = this.privAudioOutputFormat), this.onEvent(new $d7238066c5de7f1c$var$n0e(this.requestId, void 0, n === void 0 ? void 0 : n.id()));
    }
    onPreConnectionStart(e) {
        this.privAuthFetchEventId = e, this.onEvent(new $d7238066c5de7f1c$var$s0e(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(e) {
        e && this.onComplete();
    }
    onConnectionEstablishCompleted(e) {
        if (e === 200) {
            this.onEvent(new $d7238066c5de7f1c$var$r0e(this.requestId, this.privAuthFetchEventId)), this.privBytesReceived = 0;
            return;
        } else e === 403 && this.onComplete();
    }
    onServiceResponseMessage(e) {
        const t = JSON.parse(e);
        this.streamId = t.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = !1, this.privTurnDeferral.resolve(), this.onComplete();
    }
    onServiceTurnStartResponse(e) {
        this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(()=>{})), this.privInTurn = !0, this.privTurnDeferral = new $d7238066c5de7f1c$var$Ui();
        const t = JSON.parse(e);
        t.webrtc && (this.privWebRTCSDP = t.webrtc.connectionString);
    }
    onAudioChunkReceived(e) {
        this.isSynthesizing && (this.privAudioOutputStream.write(e), this.privBytesReceived += e.byteLength, this.privTurnAudioDestination !== void 0 && this.privTurnAudioDestination.write(e));
    }
    onTextBoundaryEvent(e) {
        this.updateTextOffset(e.Data.text.Text, e.Type);
    }
    onVisemeMetadataReceived(e) {
        e.Data.AnimationChunk !== void 0 && (this.privPartialVisemeAnimation += e.Data.AnimationChunk);
    }
    onSessionEnd(e) {
        this.privAudioDuration = e.Data.Offset;
    }
    constructSynthesisResult() {
        return $d7238066c5de7f1c$var$IS(this, void 0, void 0, function*() {
            const e = yield this.getAllReceivedAudioWithHeader();
            return new $d7238066c5de7f1c$var$HB(this.requestId, $d7238066c5de7f1c$var$At.SynthesizingAudioCompleted, e, void 0, this.extraProperties, this.audioDuration);
        });
    }
    dispose() {
        this.privIsDisposed || (this.privIsDisposed = !0);
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
   * Gets the viseme animation string (merged from animation chunk), and clears the internal
   * partial animation.
   */ getAndClearVisemeAnimation() {
        const e = this.privPartialVisemeAnimation;
        return this.privPartialVisemeAnimation = "", e;
    }
    onEvent(e) {
        $d7238066c5de7f1c$var$as.instance.onEvent(e);
    }
    /**
   * Check if the text is an XML(SSML) tag
   * @param text
   * @private
   */ static isXmlTag(e) {
        return e.length >= 2 && e[0] === "<" && e[e.length - 1] === ">";
    }
    updateTextOffset(e, t) {
        t === $d7238066c5de7f1c$var$Dc.WordBoundary ? (this.privTextOffset = this.privRawText.indexOf(e, this.privNextSearchTextIndex), this.privTextOffset >= 0 && (this.privNextSearchTextIndex = this.privTextOffset + e.length, this.privIsSSML && this.withinXmlTag(this.privTextOffset) && !$d7238066c5de7f1c$var$QZ.isXmlTag(e) && this.updateTextOffset(e, t))) : (this.privSentenceOffset = this.privRawText.indexOf(e, this.privNextSearchSentenceIndex), this.privSentenceOffset >= 0 && (this.privNextSearchSentenceIndex = this.privSentenceOffset + e.length, this.privIsSSML && this.withinXmlTag(this.privSentenceOffset) && !$d7238066c5de7f1c$var$QZ.isXmlTag(e) && this.updateTextOffset(e, t)));
    }
    onComplete() {
        this.privIsSynthesizing && (this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !0, this.privAudioOutputStream.close(), this.privInTurn = !1, this.privTurnAudioDestination !== void 0 && (this.privTurnAudioDestination.close(), this.privTurnAudioDestination = void 0));
    }
    readAllAudioFromStream() {
        return $d7238066c5de7f1c$var$IS(this, void 0, void 0, function*() {
            if (this.privIsSynthesisEnded) {
                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                try {
                    yield this.privAudioOutputStream.read(this.privReceivedAudio);
                } catch  {
                    this.privReceivedAudio = new ArrayBuffer(0);
                }
            }
        });
    }
    /**
   * Check if current idx is in XML(SSML) tag
   * @param idx
   * @private
   */ withinXmlTag(e) {
        return this.privRawText.indexOf("<", e + 1) > this.privRawText.indexOf(">", e + 1);
    }
}
var $d7238066c5de7f1c$var$iI = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$YB {
    constructor(e, t, i, n){
        if (this.speakOverride = void 0, this.receiveMessageOverride = void 0, this.connectImplOverride = void 0, this.configConnectionOverride = void 0, this.privConnectionConfigurationPromise = void 0, !e) throw new $d7238066c5de7f1c$var$Zr("authentication");
        if (!t) throw new $d7238066c5de7f1c$var$Zr("connectionFactory");
        if (!i) throw new $d7238066c5de7f1c$var$Zr("synthesizerConfig");
        this.privAuthentication = e, this.privConnectionFactory = t, this.privSynthesizerConfig = i, this.privIsDisposed = !1, this.privSessionAudioDestination = n, this.privSynthesisTurn = new $d7238066c5de7f1c$var$QZ(), this.privConnectionEvents = new $d7238066c5de7f1c$var$sc(), this.privServiceEvents = new $d7238066c5de7f1c$var$sc(), this.privSynthesisContext = new $d7238066c5de7f1c$var$c0e(), this.privAgentConfig = new $d7238066c5de7f1c$var$jQ(), this.connectionEvents.attach((s)=>{
            if (s.name === "ConnectionClosedEvent") {
                const a = s;
                a.statusCode !== 1e3 && this.cancelSynthesisLocal($d7238066c5de7f1c$var$Zn.Error, a.statusCode === 1007 ? $d7238066c5de7f1c$var$vt.BadRequestParameters : $d7238066c5de7f1c$var$vt.ConnectionFailure, `${a.reason} websocket error code: ${a.statusCode}`);
            }
        });
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(e) {
        this.privActivityTemplate = e;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(e) {
        this.privAudioOutputFormat = e, this.privSynthesisTurn.audioOutputFormat = e, this.privSessionAudioDestination !== void 0 && (this.privSessionAudioDestination.format = e), this.synthesisContext !== void 0 && (this.synthesisContext.audioOutputFormat = e);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(e) {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            this.privIsDisposed = !0, this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.close(), this.privConnectionConfigurationPromise !== void 0 && (yield (yield this.privConnectionConfigurationPromise).dispose(e));
        });
    }
    connect() {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            yield this.connectImpl();
        });
    }
    sendNetworkMessage(e, t) {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            const i = typeof t == "string" ? $d7238066c5de7f1c$var$Tt.Text : $d7238066c5de7f1c$var$Tt.Binary, n = typeof t == "string" ? "application/json" : "";
            return (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$$n(i, e, this.privSynthesisTurn.requestId, n, t));
        });
    }
    Speak(e, t, i, n, s, a) {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            let o;
            if (t ? o = e : o = this.privSynthesizer.buildSsml(e), this.speakOverride !== void 0) return this.speakOverride(o, i, n, s);
            this.privSuccessCallback = n, this.privErrorCallback = s, this.privSynthesisTurn.startNewSynthesis(i, e, t, a);
            try {
                yield this.connectImpl();
                const g = yield this.fetchConnection();
                yield this.sendSynthesisContext(g), yield this.sendSsmlMessage(g, o, i), this.onSynthesisStarted(i), this.receiveMessage();
            } catch (g) {
                return this.cancelSynthesisLocal($d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.ConnectionFailure, g), Promise.reject(g);
            }
        });
    }
    stopSpeaking() {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            return yield this.connectImpl(), (yield this.fetchConnection()).send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
                action: "stop"
            })));
        });
    }
    // Cancels synthesis.
    cancelSynthesis(e, t, i, n) {
        const s = new $d7238066c5de7f1c$var$vi();
        s.setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[i]);
        const a = new $d7238066c5de7f1c$var$HB(e, $d7238066c5de7f1c$var$At.Canceled, void 0, n, s);
        if (this.onSynthesisCancelled(a), this.privSuccessCallback) try {
            this.privSuccessCallback(a);
        } catch  {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(e, t, i) {
        this.privSynthesisTurn.isSynthesizing && (this.privSynthesisTurn.onStopSynthesizing(), this.cancelSynthesis(this.privSynthesisTurn.requestId, e, t, i));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(e) {
        return !0;
    }
    receiveMessage() {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            try {
                const t = yield (yield this.fetchConnection()).read();
                if (this.receiveMessageOverride !== void 0) return this.receiveMessageOverride();
                if (this.privIsDisposed) return;
                if (!t) return this.privSynthesisTurn.isSynthesizing ? this.receiveMessage() : void 0;
                const i = $d7238066c5de7f1c$var$$n.fromConnectionMessage(t);
                if (i.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(i.path.toLowerCase()){
                    case "turn.start":
                        this.privSynthesisTurn.onServiceTurnStartResponse(i.textBody);
                        break;
                    case "response":
                        this.privSynthesisTurn.onServiceResponseMessage(i.textBody);
                        break;
                    case "audio":
                        this.privSynthesisTurn.streamId.toLowerCase() === i.streamId.toLowerCase() && i.binaryBody && (this.privSynthesisTurn.onAudioChunkReceived(i.binaryBody), this.onSynthesizing(i.binaryBody), this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.write(i.binaryBody));
                        break;
                    case "audio.metadata":
                        const n = $d7238066c5de7f1c$var$jK.fromJSON(i.textBody).Metadata;
                        for (const a of n)switch(a.Type){
                            case $d7238066c5de7f1c$var$Dc.WordBoundary:
                            case $d7238066c5de7f1c$var$Dc.SentenceBoundary:
                                this.privSynthesisTurn.onTextBoundaryEvent(a);
                                const o = new $d7238066c5de7f1c$var$KQ(a.Data.Offset, a.Data.Duration, a.Data.text.Text, a.Data.text.Length, a.Type === $d7238066c5de7f1c$var$Dc.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, a.Data.text.BoundaryType);
                                this.onWordBoundary(o);
                                break;
                            case $d7238066c5de7f1c$var$Dc.Bookmark:
                                const g = new $d7238066c5de7f1c$var$xQ(a.Data.Offset, a.Data.Bookmark);
                                this.onBookmarkReached(g);
                                break;
                            case $d7238066c5de7f1c$var$Dc.Viseme:
                                if (this.privSynthesisTurn.onVisemeMetadataReceived(a), a.Data.IsLastAnimation) {
                                    const l = new $d7238066c5de7f1c$var$FQ(a.Data.Offset, a.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                    this.onVisemeReceived(l);
                                }
                                break;
                            case $d7238066c5de7f1c$var$Dc.AvatarSignal:
                                this.onAvatarEvent(a);
                                break;
                            case $d7238066c5de7f1c$var$Dc.SessionEnd:
                                this.privSynthesisTurn.onSessionEnd(a);
                                break;
                        }
                        break;
                    case "turn.end":
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        let s;
                        try {
                            s = yield this.privSynthesisTurn.constructSynthesisResult(), this.privSuccessCallback && this.privSuccessCallback(s);
                        } catch (a) {
                            this.privErrorCallback && this.privErrorCallback(a);
                        }
                        this.onSynthesisCompleted(s);
                        break;
                    default:
                        this.processTypeSpecificMessages(i) || this.privServiceEvents && this.serviceEvents.onEvent(new $d7238066c5de7f1c$var$uK(i.path.toLowerCase(), i.textBody));
                }
                return this.receiveMessage();
            } catch  {}
        });
    }
    sendSynthesisContext(e) {
        this.setSynthesisContextSynthesisSection();
        const t = this.synthesisContext.toJSON();
        if (t) return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", t));
    }
    setSpeechConfigSynthesisSection() {}
    connectImpl(e = !1) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((i)=>i.state() === $d7238066c5de7f1c$var$ir.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.connectImpl()) : this.privConnectionPromise, ()=>(this.privConnectionId = null, this.privConnectionPromise = null, this.connectImpl()));
        this.privAuthFetchEventId = $d7238066c5de7f1c$var$Rn(), this.privConnectionId = $d7238066c5de7f1c$var$Rn(), this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const t = e ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        return this.privConnectionPromise = t.then((i)=>$d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
                this.privSynthesisTurn.onAuthCompleted(!1);
                const n = this.privConnectionFactory.create(this.privSynthesizerConfig, i, this.privConnectionId);
                n.events.attach((a)=>{
                    this.connectionEvents.onEvent(a);
                });
                const s = yield n.open();
                return s.statusCode === 200 ? (this.privSynthesisTurn.onConnectionEstablishCompleted(s.statusCode), Promise.resolve(n)) : s.statusCode === 403 && !e ? this.connectImpl(!0) : (this.privSynthesisTurn.onConnectionEstablishCompleted(s.statusCode), Promise.reject(`Unable to contact server. StatusCode: ${s.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint)} Reason: ${s.reason}`));
            }), (i)=>{
            throw this.privSynthesisTurn.onAuthCompleted(!0), new Error(i);
        }), this.privConnectionPromise.catch(()=>{}), this.privConnectionPromise;
    }
    sendSpeechServiceConfig(e, t) {
        if (t) return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", t));
    }
    sendSsmlMessage(e, t, i) {
        return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "ssml", i, "application/ssml+xml", t));
    }
    fetchConnection() {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            return this.privConnectionConfigurationPromise !== void 0 ? this.privConnectionConfigurationPromise.then((e)=>e.state() === $d7238066c5de7f1c$var$ir.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.fetchConnection()) : this.privConnectionConfigurationPromise, ()=>(this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $d7238066c5de7f1c$var$iI(this, void 0, void 0, function*() {
            const e = yield this.connectImpl();
            return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(e) : (this.setSpeechConfigSynthesisSection(), yield this.sendSpeechServiceConfig(e, this.privSynthesizerConfig.SpeechServiceConfig.serialize()), e);
        });
    }
    onAvatarEvent(e) {}
    onSynthesisStarted(e) {}
    onSynthesizing(e) {}
    onSynthesisCancelled(e) {}
    onSynthesisCompleted(e) {}
    onWordBoundary(e) {}
    onVisemeReceived(e) {}
    onBookmarkReached(e) {}
}
$d7238066c5de7f1c$var$YB.telemetryDataEnabled = !0;
class $d7238066c5de7f1c$var$a0e extends $d7238066c5de7f1c$var$YB {
    constructor(e, t, i, n, s){
        super(e, t, i, void 0), this.privAvatarSynthesizer = n, this.privSynthesizer = n, this.privAvatarConfig = s;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(void 0);
    }
    setSpeechConfigSynthesisSection() {
        var e, t, i, n, s, a, o, g, l, c, d, p, A, y, G, Z;
        this.privSynthesizerConfig.synthesisVideoSection = {
            format: {
                bitrate: (e = this.privAvatarConfig.videoFormat) === null || e === void 0 ? void 0 : e.bitrate,
                codec: (t = this.privAvatarConfig.videoFormat) === null || t === void 0 ? void 0 : t.codec,
                crop: {
                    bottomRight: {
                        x: (s = (n = (i = this.privAvatarConfig.videoFormat) === null || i === void 0 ? void 0 : i.cropRange) === null || n === void 0 ? void 0 : n.bottomRight) === null || s === void 0 ? void 0 : s.x,
                        y: (g = (o = (a = this.privAvatarConfig.videoFormat) === null || a === void 0 ? void 0 : a.cropRange) === null || o === void 0 ? void 0 : o.bottomRight) === null || g === void 0 ? void 0 : g.y
                    },
                    topLeft: {
                        x: (d = (c = (l = this.privAvatarConfig.videoFormat) === null || l === void 0 ? void 0 : l.cropRange) === null || c === void 0 ? void 0 : c.topLeft) === null || d === void 0 ? void 0 : d.x,
                        y: (y = (A = (p = this.privAvatarConfig.videoFormat) === null || p === void 0 ? void 0 : p.cropRange) === null || A === void 0 ? void 0 : A.topLeft) === null || y === void 0 ? void 0 : y.y
                    }
                },
                resolution: {
                    height: (G = this.privAvatarConfig.videoFormat) === null || G === void 0 ? void 0 : G.height,
                    width: (Z = this.privAvatarConfig.videoFormat) === null || Z === void 0 ? void 0 : Z.width
                }
            },
            protocol: {
                name: "WebRTC",
                webrtcConfig: {
                    clientDescription: btoa(this.privSynthesizerConfig.parameters.getProperty($d7238066c5de7f1c$var$T.TalkingAvatarService_WebRTC_SDP)),
                    iceServers: this.privAvatarSynthesizer.iceServers
                }
            },
            talkingAvatar: {
                background: {
                    color: this.privAvatarConfig.backgroundColor
                },
                character: this.privAvatarConfig.character,
                customized: this.privAvatarConfig.customized,
                style: this.privAvatarConfig.style
            }
        };
    }
    onAvatarEvent(e) {
        if (this.privAvatarSynthesizer.avatarEventReceived) {
            const t = new $d7238066c5de7f1c$var$zQ(e.Data.Offset, e.Data.Name);
            try {
                this.privAvatarSynthesizer.avatarEventReceived(this.privAvatarSynthesizer, t);
            } catch  {}
        }
    }
}
class $d7238066c5de7f1c$var$o0e extends $d7238066c5de7f1c$var$YB {
    constructor(e, t, i, n, s){
        super(e, t, i, s), this.privSpeechSynthesizer = n, this.privSynthesizer = n;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(e) {
        const t = new $d7238066c5de7f1c$var$Wy(new $d7238066c5de7f1c$var$HB(e, $d7238066c5de7f1c$var$At.SynthesizingAudioStarted));
        this.privSpeechSynthesizer.synthesisStarted && this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, t);
    }
    onSynthesizing(e) {
        if (this.privSpeechSynthesizer.synthesizing) try {
            const t = this.privSynthesisTurn.audioOutputFormat.addHeader(e), i = new $d7238066c5de7f1c$var$Wy(new $d7238066c5de7f1c$var$HB(this.privSynthesisTurn.requestId, $d7238066c5de7f1c$var$At.SynthesizingAudio, t));
            this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, i);
        } catch  {}
    }
    onSynthesisCancelled(e) {
        if (this.privSpeechSynthesizer.SynthesisCanceled) {
            const t = new $d7238066c5de7f1c$var$Wy(e);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, t);
            } catch  {}
        }
    }
    onSynthesisCompleted(e) {
        if (this.privSpeechSynthesizer.synthesisCompleted) try {
            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $d7238066c5de7f1c$var$Wy(e));
        } catch  {}
    }
    onWordBoundary(e) {
        if (this.privSpeechSynthesizer.wordBoundary) try {
            this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, e);
        } catch  {}
    }
    onVisemeReceived(e) {
        if (this.privSpeechSynthesizer.visemeReceived) try {
            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, e);
        } catch  {}
    }
    onBookmarkReached(e) {
        if (this.privSpeechSynthesizer.bookmarkReached) try {
            this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, e);
        } catch  {}
    }
}
class $d7238066c5de7f1c$var$g0e {
    constructor(e, t){
        let i = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Endpoint, void 0);
        if (!i) {
            const s = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Region, "westus"), a = $d7238066c5de7f1c$var$Rr.getHostSuffix(s);
            i = e.parameters.getProperty($d7238066c5de7f1c$var$T.SpeechServiceConnection_Host, `https://${s}.tts.speech${a}`);
        }
        this.privUri = `${i}/cognitiveservices/voices/list`;
        const n = $d7238066c5de7f1c$var$cu.requestOptions;
        this.privRestAdapter = new $d7238066c5de7f1c$var$SN(n), this.privAuthentication = t;
    }
    /**
   * Sends list voices request to endpoint.
   * @function
   * @public
   * @param connectionId - guid for connectionId
   * @returns {Promise<IRestResponse>} rest response to status request
   */ getVoicesList(e) {
        return this.privRestAdapter.setHeaders($d7238066c5de7f1c$var$Fi.ConnectionId, e), this.privAuthentication.fetch(e).then((t)=>(this.privRestAdapter.setHeaders(t.headerName, t.token), this.privRestAdapter.request($d7238066c5de7f1c$var$ah.Get, this.privUri)));
    }
}
var $d7238066c5de7f1c$var$RN;
(function(r) {
    r[r.Standard = 0] = "Standard", r[r.Custom = 1] = "Custom";
})($d7238066c5de7f1c$var$RN || ($d7238066c5de7f1c$var$RN = {}));
class $d7238066c5de7f1c$var$l0e {
    constructor(e, t){
        this.privSynthesisServiceType = $d7238066c5de7f1c$var$RN.Standard, this.avatarEnabled = !1, this.privSpeechServiceConfig = e || new $d7238066c5de7f1c$var$rV(new $d7238066c5de7f1c$var$aV(null)), this.privParameters = t;
    }
    get parameters() {
        return this.privParameters;
    }
    get synthesisServiceType() {
        return this.privSynthesisServiceType;
    }
    set synthesisServiceType(e) {
        this.privSynthesisServiceType = e;
    }
    set synthesisVideoSection(e) {
        this.privSpeechServiceConfig.Context.synthesis = {
            video: e
        };
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
}
class $d7238066c5de7f1c$var$c0e {
    constructor(){
        this.privContext = {};
    }
    /**
   * Adds a section to the synthesis.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */ setSection(e, t) {
        this.privContext[e] = t;
    }
    /**
   * Sets the audio output format for synthesis context generation.
   * @param format {AudioOutputFormatImpl} the output format
   */ set audioOutputFormat(e) {
        this.privAudioOutputFormat = e;
    }
    toJSON() {
        return JSON.stringify(this.privContext);
    }
    setSynthesisSection(e) {
        const t = this.buildSynthesisContext(e);
        this.setSection("synthesis", t);
    }
    buildSynthesisContext(e) {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!(e != null && e.bookmarkReached),
                    punctuationBoundaryEnabled: e == null ? void 0 : e.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestPunctuationBoundary, !!(e != null && e.wordBoundary)),
                    sentenceBoundaryEnabled: e == null ? void 0 : e.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestSentenceBoundary, !1),
                    sessionEndEnabled: !0,
                    visemeEnabled: !!(e != null && e.visemeReceived),
                    wordBoundaryEnabled: e == null ? void 0 : e.properties.getProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_RequestWordBoundary, !!(e != null && e.wordBoundary))
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: e == null ? void 0 : e.autoDetectSourceLanguage
            }
        };
    }
}
var $d7238066c5de7f1c$var$ZX = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$u0e extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privSpeakerRecognizer = s, this.privSpeakerAudioSource = i, this.recognizeSpeaker = (a)=>this.recognizeSpeakerOnce(a), this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    processTypeSpecificMessages(e) {
        let t = !1;
        const i = new $d7238066c5de7f1c$var$vi();
        switch(e.messageType === $d7238066c5de7f1c$var$Tt.Text && i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
            case "speaker.response":
                const s = JSON.parse(e.textBody);
                let a;
                s.status.statusCode.toLowerCase() !== "success" ? a = new $d7238066c5de7f1c$var$FS(s, $d7238066c5de7f1c$var$At.Canceled, $d7238066c5de7f1c$var$vt.ServiceError, s.status.reason) : a = new $d7238066c5de7f1c$var$FS(s, $d7238066c5de7f1c$var$At.RecognizedSpeaker), this.privResultDeferral && this.privResultDeferral.resolve(a), t = !0;
                break;
        }
        const n = new $d7238066c5de7f1c$var$Ui();
        return n.resolve(t), n.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        if (new $d7238066c5de7f1c$var$vi().setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]), this.privResultDeferral) {
            const o = new $d7238066c5de7f1c$var$FS({
                scenario: this.privSpeakerModel.scenario,
                status: {
                    statusCode: s,
                    reason: s
                }
            }, $d7238066c5de7f1c$var$At.Canceled, n, s);
            try {
                this.privResultDeferral.resolve(o);
            } catch (g) {
                this.privResultDeferral.reject(g);
            }
        }
    }
    recognizeSpeakerOnce(e) {
        return $d7238066c5de7f1c$var$ZX(this, void 0, void 0, function*() {
            this.privSpeakerModel = e, this.voiceProfileType = e.scenario, this.privResultDeferral || (this.privResultDeferral = new $d7238066c5de7f1c$var$Ui()), this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events), this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$T.Speech_SessionId, this.privRequestSession.sessionId);
            const t = this.connectImpl(), i = this.sendPreAudioMessages(this.extractSpeakerContext(e)), n = yield this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId), s = yield this.privSpeakerAudioSource.format, a = yield this.privSpeakerAudioSource.deviceInfo, o = new $d7238066c5de7f1c$var$jR(n, s.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(o, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: a
            };
            try {
                yield t, yield i;
            } catch (c) {
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.ConnectionFailure, c);
            }
            const g = new $d7238066c5de7f1c$var$zr(this.privRequestSession.sessionId);
            return this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, g), this.receiveMessage(), this.sendAudio(o).then(()=>{}, (c)=>{
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.RuntimeError, c);
            }), this.privResultDeferral.promise;
        });
    }
    sendPreAudioMessages(e) {
        return $d7238066c5de7f1c$var$ZX(this, void 0, void 0, function*() {
            const t = yield this.fetchConnection();
            yield this.sendSpeakerRecognition(t, e);
        });
    }
    sendSpeakerRecognition(e, t) {
        return $d7238066c5de7f1c$var$ZX(this, void 0, void 0, function*() {
            const i = JSON.stringify(t);
            return e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", i));
        });
    }
    extractSpeakerContext(e) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: e.profileIds,
            scenario: e.scenario
        };
    }
}
var $d7238066c5de7f1c$var$kg = function(r, e, t, i) {
    function n(s) {
        return s instanceof t ? s : new t(function(a) {
            a(s);
        });
    }
    return new (t || (t = Promise))(function(s, a) {
        function o(c) {
            try {
                l(i.next(c));
            } catch (d) {
                a(d);
            }
        }
        function g(c) {
            try {
                l(i.throw(c));
            } catch (d) {
                a(d);
            }
        }
        function l(c) {
            c.done ? s(c.value) : n(c.value).then(o, g);
        }
        l((i = i.apply(r, e || [])).next());
    });
};
class $d7238066c5de7f1c$var$I0e extends $d7238066c5de7f1c$var$ha {
    constructor(e, t, i, n, s){
        super(e, t, i, n, s), this.privDeferralMap = new $d7238066c5de7f1c$var$wme(), this.privSpeakerAudioSource = i, this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    set SpeakerAudioSource(e) {
        this.privSpeakerAudioSource = e;
    }
    processTypeSpecificMessages(e) {
        let t = !1;
        const i = new $d7238066c5de7f1c$var$vi();
        switch(e.messageType === $d7238066c5de7f1c$var$Tt.Text && i.setProperty($d7238066c5de7f1c$var$T.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()){
            case "speaker.profiles":
                const s = JSON.parse(e.textBody);
                switch(s.operation.toLowerCase()){
                    case "create":
                        this.handleCreateResponse(s, e.requestId);
                        break;
                    case "delete":
                    case "reset":
                        this.handleResultResponse(s, e.requestId);
                        break;
                    case "fetch":
                        const l = JSON.parse(e.textBody);
                        this.handleFetchResponse(l, e.requestId);
                        break;
                }
                t = !0;
                break;
            case "speaker.phrases":
                const a = JSON.parse(e.textBody);
                this.handlePhrasesResponse(a, e.requestId), t = !0;
                break;
            case "speaker.profile.enrollment":
                const o = JSON.parse(e.textBody), g = new $d7238066c5de7f1c$var$th(this.enrollmentReasonFrom(o.enrollment ? o.enrollment.enrollmentStatus : o.status.statusCode), o.enrollment ? JSON.stringify(o.enrollment) : void 0, o.status.reason);
                this.privDeferralMap.getId(e.requestId) && this.privDeferralMap.complete(e.requestId, g), this.privRequestSession.onSpeechEnded(), t = !0;
                break;
        }
        const n = new $d7238066c5de7f1c$var$Ui();
        return n.resolve(t), n.promise;
    }
    // Cancels recognition.
    cancelRecognition(e, t, i, n, s) {
        new $d7238066c5de7f1c$var$vi().setProperty($d7238066c5de7f1c$var$Ma, $d7238066c5de7f1c$var$vt[n]);
        const o = new $d7238066c5de7f1c$var$th($d7238066c5de7f1c$var$At.Canceled, s, s);
        this.privDeferralMap.getId(t) && this.privDeferralMap.complete(t, o);
    }
    createProfile(e, t) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            this.voiceProfileType = e.toString();
            const i = this.connectImpl();
            try {
                const n = new $d7238066c5de7f1c$var$Ui();
                return yield i, yield this.sendCreateProfile(n, e, t), this.receiveMessage(), n.promise;
            } catch (n) {
                throw n;
            }
        });
    }
    resetProfile(e) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.profileType.toString(), this.sendCommonRequest("reset", e.profileType, e);
        });
    }
    deleteProfile(e) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.profileType.toString(), this.sendCommonRequest("delete", e.profileType, e);
        });
    }
    retrieveEnrollmentResult(e) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.profileType.toString(), this.privExpectedProfileId = e.profileId, this.sendCommonRequest("fetch", e.profileType, e);
        });
    }
    getAllProfiles(e) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            return this.voiceProfileType = e.toString(), this.sendCommonRequest("fetch", e);
        });
    }
    getActivationPhrases(e, t) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            this.voiceProfileType = e.toString();
            const i = this.connectImpl();
            try {
                const n = new $d7238066c5de7f1c$var$Ui();
                return yield i, yield this.sendPhrasesRequest(n, e, t), this.receiveMessage(), n.promise;
            } catch (n) {
                throw n;
            }
        });
    }
    enrollProfile(e) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            this.voiceProfileType = e.profileType.toString();
            const t = new $d7238066c5de7f1c$var$Ui();
            this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events), this.privRecognizerConfig.parameters.setProperty($d7238066c5de7f1c$var$T.Speech_SessionId, this.privRequestSession.sessionId);
            const i = this.connectImpl(), n = this.sendPreAudioMessages(e, t), s = yield this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId), a = yield this.privSpeakerAudioSource.format, o = yield this.privSpeakerAudioSource.deviceInfo, g = new $d7238066c5de7f1c$var$jR(s, a.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(g, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: o
            };
            try {
                yield i, yield n;
            } catch (d) {
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.ConnectionFailure, d);
            }
            const l = new $d7238066c5de7f1c$var$zr(this.privRequestSession.sessionId);
            return this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, l), this.receiveMessage(), this.sendAudio(g).then(()=>{}, (d)=>{
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $d7238066c5de7f1c$var$Zn.Error, $d7238066c5de7f1c$var$vt.RuntimeError, d);
            }), t.promise;
        });
    }
    sendPreAudioMessages(e, t) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            const i = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, t), yield this.sendBaseRequest(i, "enroll", this.scenarioFrom(e.profileType), e);
        });
    }
    sendPhrasesRequest(e, t, i) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            const n = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, e);
            const s = this.scenarioFrom(t), a = {
                locale: i,
                scenario: s
            };
            return n.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(a)));
        });
    }
    sendCreateProfile(e, t, i) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            const n = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, e);
            const s = t === $d7238066c5de7f1c$var$iu.TextIndependentIdentification ? "TextIndependentIdentification" : t === $d7238066c5de7f1c$var$iu.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification", a = {
                locale: i,
                number: "1",
                scenario: s
            };
            return n.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(a)));
        });
    }
    sendCommonRequest(e, t, i) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            const n = this.connectImpl();
            try {
                const s = new $d7238066c5de7f1c$var$Ui();
                this.privRequestSession.onSpeechContext(), yield n;
                const a = yield this.fetchConnection();
                return this.privDeferralMap.add(this.privRequestSession.requestId, s), yield this.sendBaseRequest(a, e, this.scenarioFrom(t), i), this.receiveMessage(), s.promise;
            } catch (s) {
                throw s;
            }
        });
    }
    sendBaseRequest(e, t, i, n) {
        return $d7238066c5de7f1c$var$kg(this, void 0, void 0, function*() {
            const s = {
                scenario: i
            };
            return n ? s.profileIds = [
                n.profileId
            ] : s.maxPageSize = -1, e.send(new $d7238066c5de7f1c$var$$n($d7238066c5de7f1c$var$Tt.Text, `speaker.profile.${t}`, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(s)));
        });
    }
    extractSpeakerContext(e) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: e.profileIds,
            scenario: e.scenario
        };
    }
    handlePhrasesResponse(e, t) {
        if (this.privDeferralMap.getId(t)) {
            if (e.status.statusCode.toLowerCase() !== "success") {
                const i = $d7238066c5de7f1c$var$At.Canceled, n = new $d7238066c5de7f1c$var$AN(i, e.status.statusCode, e.passPhraseType, []);
                this.privDeferralMap.complete(t, n);
            } else if (e.phrases && e.phrases.length > 0) {
                const i = $d7238066c5de7f1c$var$At.EnrollingVoiceProfile, n = new $d7238066c5de7f1c$var$AN(i, e.status.statusCode, e.passPhraseType, e.phrases);
                this.privDeferralMap.complete(t, n);
            } else throw new Error("Voice Profile get activation phrases failed, no phrases received");
        } else throw new Error(`Voice Profile get activation phrases request for requestID ${t} not found`);
    }
    handleCreateResponse(e, t) {
        if (e.profiles && e.profiles.length > 0) {
            if (this.privDeferralMap.getId(t)) {
                const i = e.profiles.map((n)=>n.profileId);
                this.privDeferralMap.complete(t, i);
            } else throw new Error(`Voice Profile create request for requestID ${t} not found`);
        } else throw new Error("Voice Profile create failed, no profile id received");
    }
    handleResultResponse(e, t) {
        if (this.privDeferralMap.getId(t)) {
            const i = e.operation.toLowerCase() === "delete" ? $d7238066c5de7f1c$var$At.DeletedVoiceProfile : $d7238066c5de7f1c$var$At.ResetVoiceProfile, n = e.status.statusCode.toLowerCase() === "success" ? i : $d7238066c5de7f1c$var$At.Canceled, s = new $d7238066c5de7f1c$var$iV(n, `statusCode: ${e.status.statusCode}, errorDetails: ${e.status.reason}`);
            this.privDeferralMap.complete(t, s);
        } else throw new Error(`Voice Profile create request for requestID ${t} not found`);
    }
    handleFetchResponse(e, t) {
        if (this.privDeferralMap.getId(t) && e.profiles[0]) {
            if (this.privExpectedProfileId && e.profiles.length === 1 && e.profiles[0].profileId === this.privExpectedProfileId) {
                this.privExpectedProfileId = void 0;
                const i = e.profiles[0], n = new $d7238066c5de7f1c$var$th(this.enrollmentReasonFrom(i.enrollmentStatus), JSON.stringify(i), e.status.reason);
                this.privDeferralMap.complete(t, n);
            } else if (e.profiles.length > 0) {
                const i = e.profiles, n = [];
                for (const s of i)n.push(new $d7238066c5de7f1c$var$th(this.enrollmentReasonFrom(s.enrollmentStatus), JSON.stringify(s), e.status.reason));
                this.privDeferralMap.complete(t, n);
            }
        } else throw new Error(`Voice Profile fetch request for requestID ${t} not found`);
    }
    enrollmentReasonFrom(e) {
        switch(e.toLowerCase()){
            case "enrolled":
                return $d7238066c5de7f1c$var$At.EnrolledVoiceProfile;
            case "invalidlocale":
            case "invalidphrase":
            case "invalidaudioformat":
            case "invalidscenario":
            case "invalidprofilecount":
            case "invalidoperation":
            case "audiotooshort":
            case "audiotoolong":
            case "toomanyenrollments":
            case "storageconflict":
            case "profilenotfound":
            case "incompatibleprofiles":
            case "incompleteenrollment":
                return $d7238066c5de7f1c$var$At.Canceled;
            default:
                return $d7238066c5de7f1c$var$At.EnrollingVoiceProfile;
        }
    }
    scenarioFrom(e) {
        return e === $d7238066c5de7f1c$var$iu.TextIndependentIdentification ? "TextIndependentIdentification" : e === $d7238066c5de7f1c$var$iu.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    }
}
class $d7238066c5de7f1c$var$rV {
    constructor(e){
        this.context = e;
    }
    serialize() {
        return JSON.stringify(this, (e, t)=>{
            if (t && typeof t == "object" && !Array.isArray(t)) {
                const i = {};
                for(const n in t)Object.hasOwnProperty.call(t, n) && (i[n && n.charAt(0).toLowerCase() + n.substring(1)] = t[n]);
                return i;
            }
            return t;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(e) {
        this.recognition = e.toLowerCase();
    }
}
class $d7238066c5de7f1c$var$aV {
    constructor(e){
        this.system = new $d7238066c5de7f1c$var$d0e(), this.os = e;
    }
}
class $d7238066c5de7f1c$var$d0e {
    constructor(){
        const e = "1.33.1";
        this.name = "SpeechSDK", this.version = e, this.build = "JavaScript", this.lang = "JavaScript";
    }
}
class $d7238066c5de7f1c$var$e4 {
    constructor(e, t, i){
        this.platform = e, this.name = t, this.version = i;
    }
}
var $d7238066c5de7f1c$var$qA;
(function(r) {
    r.Bluetooth = "Bluetooth", r.Wired = "Wired", r.WiFi = "WiFi", r.Cellular = "Cellular", r.InBuilt = "InBuilt", r.Unknown = "Unknown";
})($d7238066c5de7f1c$var$qA || ($d7238066c5de7f1c$var$qA = {}));
var $d7238066c5de7f1c$var$PC;
(function(r) {
    r.Phone = "Phone", r.Speaker = "Speaker", r.Car = "Car", r.Headset = "Headset", r.Thermostat = "Thermostat", r.Microphones = "Microphones", r.Deskphone = "Deskphone", r.RemoteControl = "RemoteControl", r.Unknown = "Unknown", r.File = "File", r.Stream = "Stream";
})($d7238066c5de7f1c$var$PC || ($d7238066c5de7f1c$var$PC = {}));
const $d7238066c5de7f1c$var$ug = "OutputFormat", $d7238066c5de7f1c$var$Ma = "CancellationErrorCode", $d7238066c5de7f1c$var$GI = "ServiceProperties", $d7238066c5de7f1c$var$$K = "ForceDictation", $d7238066c5de7f1c$var$t4 = "OpenRange", $d7238066c5de7f1c$var$h0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    ActivityReceivedEventArgs: $d7238066c5de7f1c$var$VQ,
    AudioConfig: $d7238066c5de7f1c$var$XI,
    get AudioFormatTag () {
        return $d7238066c5de7f1c$var$Lt;
    },
    AudioInputStream: $d7238066c5de7f1c$var$lf,
    AudioOutputStream: $d7238066c5de7f1c$var$qR,
    AudioStreamFormat: $d7238066c5de7f1c$var$c0,
    AutoDetectSourceLanguageConfig: $d7238066c5de7f1c$var$qy,
    AutoDetectSourceLanguageResult: $d7238066c5de7f1c$var$DZ,
    AvatarConfig: $d7238066c5de7f1c$var$lAe,
    AvatarEventArgs: $d7238066c5de7f1c$var$zQ,
    AvatarSynthesizer: $d7238066c5de7f1c$var$cAe,
    AvatarVideoFormat: $d7238066c5de7f1c$var$EQ,
    AvatarWebRTCConnectionResult: $d7238066c5de7f1c$var$IAe,
    BaseAudioPlayer: $d7238066c5de7f1c$var$qme,
    BotFrameworkConfig: $d7238066c5de7f1c$var$Pme,
    CancellationDetails: $d7238066c5de7f1c$var$ZK,
    CancellationDetailsBase: $d7238066c5de7f1c$var$uf,
    get CancellationErrorCode () {
        return $d7238066c5de7f1c$var$vt;
    },
    get CancellationReason () {
        return $d7238066c5de7f1c$var$Zn;
    },
    Connection: $d7238066c5de7f1c$var$DC,
    ConnectionEventArgs: $d7238066c5de7f1c$var$pN,
    ConnectionMessage: $d7238066c5de7f1c$var$Dme,
    ConnectionMessageEventArgs: $d7238066c5de7f1c$var$mN,
    Conversation: $d7238066c5de7f1c$var$HQ,
    ConversationExpirationEventArgs: $d7238066c5de7f1c$var$XQ,
    ConversationParticipantsChangedEventArgs: $d7238066c5de7f1c$var$jl,
    ConversationTranscriber: $d7238066c5de7f1c$var$KK,
    ConversationTranscriptionCanceledEventArgs: $d7238066c5de7f1c$var$FK,
    ConversationTranscriptionEventArgs: $d7238066c5de7f1c$var$IN,
    ConversationTranscriptionResult: $d7238066c5de7f1c$var$zS,
    ConversationTranslationCanceledEventArgs: $d7238066c5de7f1c$var$YK,
    ConversationTranslationEventArgs: $d7238066c5de7f1c$var$MC,
    ConversationTranslationResult: $d7238066c5de7f1c$var$yN,
    ConversationTranslator: $d7238066c5de7f1c$var$nAe,
    Coordinate: $d7238066c5de7f1c$var$uAe,
    CustomCommandsConfig: $d7238066c5de7f1c$var$Qme,
    Diagnostics: $d7238066c5de7f1c$var$JQ,
    DialogServiceConfig: $d7238066c5de7f1c$var$ag,
    DialogServiceConnector: $d7238066c5de7f1c$var$Ome,
    IntentRecognitionCanceledEventArgs: $d7238066c5de7f1c$var$ZQ,
    IntentRecognitionEventArgs: $d7238066c5de7f1c$var$mA,
    IntentRecognitionResult: $d7238066c5de7f1c$var$gA,
    IntentRecognizer: $d7238066c5de7f1c$var$Ume,
    KeywordRecognitionModel: $d7238066c5de7f1c$var$zme,
    get LanguageIdMode () {
        return $d7238066c5de7f1c$var$WB;
    },
    LanguageUnderstandingModel: $d7238066c5de7f1c$var$SQ,
    get LogLevel () {
        return $d7238066c5de7f1c$var$Ys;
    },
    Meeting: $d7238066c5de7f1c$var$NQ,
    MeetingTranscriber: $d7238066c5de7f1c$var$aAe,
    MeetingTranscriptionCanceledEventArgs: $d7238066c5de7f1c$var$MQ,
    MeetingTranscriptionEventArgs: $d7238066c5de7f1c$var$kme,
    NoMatchDetails: $d7238066c5de7f1c$var$SK,
    get NoMatchReason () {
        return $d7238066c5de7f1c$var$LC;
    },
    get OutputFormat () {
        return $d7238066c5de7f1c$var$bi;
    },
    Participant: $d7238066c5de7f1c$var$If,
    get ParticipantChangedReason () {
        return $d7238066c5de7f1c$var$ig;
    },
    PhraseListGrammar: $d7238066c5de7f1c$var$RK,
    get ProfanityOption () {
        return $d7238066c5de7f1c$var$_C;
    },
    PronunciationAssessmentConfig: $d7238066c5de7f1c$var$TK,
    get PronunciationAssessmentGradingSystem () {
        return $d7238066c5de7f1c$var$XB;
    },
    get PronunciationAssessmentGranularity () {
        return $d7238066c5de7f1c$var$NB;
    },
    PronunciationAssessmentResult: $d7238066c5de7f1c$var$MK,
    PropertyCollection: $d7238066c5de7f1c$var$vi,
    get PropertyId () {
        return $d7238066c5de7f1c$var$T;
    },
    PullAudioInputStream: $d7238066c5de7f1c$var$CK,
    PullAudioInputStreamCallback: $d7238066c5de7f1c$var$vQ,
    PullAudioOutputStream: $d7238066c5de7f1c$var$cf,
    PushAudioInputStream: $d7238066c5de7f1c$var$hK,
    PushAudioOutputStream: $d7238066c5de7f1c$var$mK,
    PushAudioOutputStreamCallback: $d7238066c5de7f1c$var$bK,
    RecognitionEventArgs: $d7238066c5de7f1c$var$rc,
    RecognitionResult: $d7238066c5de7f1c$var$$R,
    Recognizer: $d7238066c5de7f1c$var$gl,
    get ResultReason () {
        return $d7238066c5de7f1c$var$At;
    },
    ServiceEventArgs: $d7238066c5de7f1c$var$RQ,
    get ServicePropertyChannel () {
        return $d7238066c5de7f1c$var$UZ;
    },
    SessionEventArgs: $d7238066c5de7f1c$var$zr,
    SourceLanguageConfig: $d7238066c5de7f1c$var$NK,
    SpeakerAudioDestination: $d7238066c5de7f1c$var$vN,
    SpeakerIdentificationModel: $d7238066c5de7f1c$var$HK,
    SpeakerRecognitionCancellationDetails: $d7238066c5de7f1c$var$LK,
    SpeakerRecognitionResult: $d7238066c5de7f1c$var$FS,
    get SpeakerRecognitionResultType () {
        return $d7238066c5de7f1c$var$XA;
    },
    SpeakerRecognizer: $d7238066c5de7f1c$var$eAe,
    SpeakerVerificationModel: $d7238066c5de7f1c$var$XK,
    SpeechConfig: $d7238066c5de7f1c$var$BK,
    SpeechConfigImpl: $d7238066c5de7f1c$var$eh,
    SpeechRecognitionCanceledEventArgs: $d7238066c5de7f1c$var$yK,
    SpeechRecognitionEventArgs: $d7238066c5de7f1c$var$fI,
    SpeechRecognitionResult: $d7238066c5de7f1c$var$no,
    SpeechRecognizer: $d7238066c5de7f1c$var$GK,
    SpeechSynthesisBookmarkEventArgs: $d7238066c5de7f1c$var$xQ,
    get SpeechSynthesisBoundaryType () {
        return $d7238066c5de7f1c$var$fN;
    },
    SpeechSynthesisEventArgs: $d7238066c5de7f1c$var$Wy,
    get SpeechSynthesisOutputFormat () {
        return $d7238066c5de7f1c$var$$t;
    },
    SpeechSynthesisResult: $d7238066c5de7f1c$var$HB,
    SpeechSynthesisVisemeEventArgs: $d7238066c5de7f1c$var$FQ,
    SpeechSynthesisWordBoundaryEventArgs: $d7238066c5de7f1c$var$KQ,
    SpeechSynthesizer: $d7238066c5de7f1c$var$xK,
    SpeechTranslationConfig: $d7238066c5de7f1c$var$fK,
    SpeechTranslationConfigImpl: $d7238066c5de7f1c$var$wy,
    SynthesisResult: $d7238066c5de7f1c$var$zC,
    SynthesisVoicesResult: $d7238066c5de7f1c$var$GN,
    Synthesizer: $d7238066c5de7f1c$var$df,
    TranslationRecognitionCanceledEventArgs: $d7238066c5de7f1c$var$CN,
    TranslationRecognitionEventArgs: $d7238066c5de7f1c$var$Vy,
    TranslationRecognitionResult: $d7238066c5de7f1c$var$aI,
    TranslationRecognizer: $d7238066c5de7f1c$var$tV,
    TranslationSynthesisEventArgs: $d7238066c5de7f1c$var$dN,
    TranslationSynthesisResult: $d7238066c5de7f1c$var$hN,
    Translations: $d7238066c5de7f1c$var$vK,
    TurnStatusReceivedEventArgs: $d7238066c5de7f1c$var$wQ,
    User: $d7238066c5de7f1c$var$rAe,
    VoiceInfo: $d7238066c5de7f1c$var$TQ,
    VoiceProfile: $d7238066c5de7f1c$var$WQ,
    VoiceProfileCancellationDetails: $d7238066c5de7f1c$var$WK,
    VoiceProfileClient: $d7238066c5de7f1c$var$$me,
    VoiceProfileEnrollmentCancellationDetails: $d7238066c5de7f1c$var$wK,
    VoiceProfileEnrollmentResult: $d7238066c5de7f1c$var$th,
    VoiceProfilePhraseResult: $d7238066c5de7f1c$var$AN,
    VoiceProfileResult: $d7238066c5de7f1c$var$iV,
    get VoiceProfileType () {
        return $d7238066c5de7f1c$var$iu;
    }
}, Symbol.toStringTag, {
    value: "Module"
})), $d7238066c5de7f1c$var$C0e = /* @__PURE__ */ $d7238066c5de7f1c$var$$he($d7238066c5de7f1c$var$h0e);
var $d7238066c5de7f1c$var$i4 = {
    exports: {}
};
(function(r) {
    function e(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    }
    r.exports = e, r.exports.__esModule = !0, r.exports.default = r.exports;
})($d7238066c5de7f1c$var$i4);
var $d7238066c5de7f1c$var$p0e = $d7238066c5de7f1c$var$i4.exports, $d7238066c5de7f1c$var$Cy = function(r) {
    return r && r.Math === Math && r;
}, $d7238066c5de7f1c$var$Ir = // eslint-disable-next-line es/no-global-this -- safe
$d7238066c5de7f1c$var$Cy(typeof globalThis == "object" && globalThis) || $d7238066c5de7f1c$var$Cy(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$d7238066c5de7f1c$var$Cy(typeof self == "object" && self) || $d7238066c5de7f1c$var$Cy(typeof $d7238066c5de7f1c$var$tS == "object" && $d7238066c5de7f1c$var$tS) || $d7238066c5de7f1c$var$Cy(typeof $d7238066c5de7f1c$var$tS == "object" && $d7238066c5de7f1c$var$tS) || // eslint-disable-next-line no-new-func -- fallback
/* @__PURE__ */ function() {
    return this;
}() || Function("return this")(), $d7238066c5de7f1c$var$Ig = function(r) {
    try {
        return !!r();
    } catch  {
        return !0;
    }
}, $d7238066c5de7f1c$var$m0e = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$oV = !$d7238066c5de7f1c$var$m0e(function() {
    var r = (function() {}).bind();
    return typeof r != "function" || r.hasOwnProperty("prototype");
}), $d7238066c5de7f1c$var$A0e = $d7238066c5de7f1c$var$oV, $d7238066c5de7f1c$var$n4 = Function.prototype, $d7238066c5de7f1c$var$RM = $d7238066c5de7f1c$var$n4.apply, $d7238066c5de7f1c$var$VM = $d7238066c5de7f1c$var$n4.call, $d7238066c5de7f1c$var$ex = typeof Reflect == "object" && Reflect.apply || ($d7238066c5de7f1c$var$A0e ? $d7238066c5de7f1c$var$VM.bind($d7238066c5de7f1c$var$RM) : function() {
    return $d7238066c5de7f1c$var$VM.apply($d7238066c5de7f1c$var$RM, arguments);
}), $d7238066c5de7f1c$var$s4 = $d7238066c5de7f1c$var$oV, $d7238066c5de7f1c$var$r4 = Function.prototype, $d7238066c5de7f1c$var$VN = $d7238066c5de7f1c$var$r4.call, $d7238066c5de7f1c$var$b0e = $d7238066c5de7f1c$var$s4 && $d7238066c5de7f1c$var$r4.bind.bind($d7238066c5de7f1c$var$VN, $d7238066c5de7f1c$var$VN), $d7238066c5de7f1c$var$Yo = $d7238066c5de7f1c$var$s4 ? $d7238066c5de7f1c$var$b0e : function(r) {
    return function() {
        return $d7238066c5de7f1c$var$VN.apply(r, arguments);
    };
}, $d7238066c5de7f1c$var$a4 = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$y0e = $d7238066c5de7f1c$var$a4({}.toString), $d7238066c5de7f1c$var$B0e = $d7238066c5de7f1c$var$a4("".slice), $d7238066c5de7f1c$var$gV = function(r) {
    return $d7238066c5de7f1c$var$B0e($d7238066c5de7f1c$var$y0e(r), 8, -1);
}, $d7238066c5de7f1c$var$f0e = $d7238066c5de7f1c$var$gV, $d7238066c5de7f1c$var$G0e = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$o4 = function(r) {
    if ($d7238066c5de7f1c$var$f0e(r) === "Function") return $d7238066c5de7f1c$var$G0e(r);
}, $d7238066c5de7f1c$var$RX = typeof document == "object" && document.all, $d7238066c5de7f1c$var$ma = typeof $d7238066c5de7f1c$var$RX > "u" && $d7238066c5de7f1c$var$RX !== void 0 ? function(r) {
    return typeof r == "function" || r === $d7238066c5de7f1c$var$RX;
} : function(r) {
    return typeof r == "function";
}, $d7238066c5de7f1c$var$tx = {}, $d7238066c5de7f1c$var$v0e = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$KI = !$d7238066c5de7f1c$var$v0e(function() {
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
}), $d7238066c5de7f1c$var$S0e = $d7238066c5de7f1c$var$oV, $d7238066c5de7f1c$var$dS = Function.prototype.call, $d7238066c5de7f1c$var$cl = $d7238066c5de7f1c$var$S0e ? $d7238066c5de7f1c$var$dS.bind($d7238066c5de7f1c$var$dS) : function() {
    return $d7238066c5de7f1c$var$dS.apply($d7238066c5de7f1c$var$dS, arguments);
}, $d7238066c5de7f1c$var$g4 = {}, $d7238066c5de7f1c$var$l4 = {}.propertyIsEnumerable, $d7238066c5de7f1c$var$c4 = Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$Z0e = $d7238066c5de7f1c$var$c4 && !$d7238066c5de7f1c$var$l4.call({
    1: 2
}, 1);
$d7238066c5de7f1c$var$g4.f = $d7238066c5de7f1c$var$Z0e ? function(e) {
    var t = $d7238066c5de7f1c$var$c4(this, e);
    return !!t && t.enumerable;
} : $d7238066c5de7f1c$var$l4;
var $d7238066c5de7f1c$var$Cf = function(r, e) {
    return {
        enumerable: !(r & 1),
        configurable: !(r & 2),
        writable: !(r & 4),
        value: e
    };
}, $d7238066c5de7f1c$var$R0e = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$V0e = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$w0e = $d7238066c5de7f1c$var$gV, $d7238066c5de7f1c$var$VX = Object, $d7238066c5de7f1c$var$W0e = $d7238066c5de7f1c$var$R0e("".split), $d7238066c5de7f1c$var$H0e = $d7238066c5de7f1c$var$V0e(function() {
    return !$d7238066c5de7f1c$var$VX("z").propertyIsEnumerable(0);
}) ? function(r) {
    return $d7238066c5de7f1c$var$w0e(r) === "String" ? $d7238066c5de7f1c$var$W0e(r, "") : $d7238066c5de7f1c$var$VX(r);
} : $d7238066c5de7f1c$var$VX, $d7238066c5de7f1c$var$lV = function(r) {
    return r == null;
}, $d7238066c5de7f1c$var$X0e = $d7238066c5de7f1c$var$lV, $d7238066c5de7f1c$var$N0e = TypeError, $d7238066c5de7f1c$var$cV = function(r) {
    if ($d7238066c5de7f1c$var$X0e(r)) throw new $d7238066c5de7f1c$var$N0e("Can't call method on " + r);
    return r;
}, $d7238066c5de7f1c$var$L0e = $d7238066c5de7f1c$var$H0e, $d7238066c5de7f1c$var$Y0e = $d7238066c5de7f1c$var$cV, $d7238066c5de7f1c$var$pf = function(r) {
    return $d7238066c5de7f1c$var$L0e($d7238066c5de7f1c$var$Y0e(r));
}, $d7238066c5de7f1c$var$K0e = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$ac = function(r) {
    return typeof r == "object" ? r !== null : $d7238066c5de7f1c$var$K0e(r);
}, $d7238066c5de7f1c$var$uV = {}, $d7238066c5de7f1c$var$wX = $d7238066c5de7f1c$var$uV, $d7238066c5de7f1c$var$WX = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$x0e = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$wM = function(r) {
    return $d7238066c5de7f1c$var$x0e(r) ? r : void 0;
}, $d7238066c5de7f1c$var$Ch = function(r, e) {
    return arguments.length < 2 ? $d7238066c5de7f1c$var$wM($d7238066c5de7f1c$var$wX[r]) || $d7238066c5de7f1c$var$wM($d7238066c5de7f1c$var$WX[r]) : $d7238066c5de7f1c$var$wX[r] && $d7238066c5de7f1c$var$wX[r][e] || $d7238066c5de7f1c$var$WX[r] && $d7238066c5de7f1c$var$WX[r][e];
}, $d7238066c5de7f1c$var$F0e = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$IV = $d7238066c5de7f1c$var$F0e({}.isPrototypeOf), $d7238066c5de7f1c$var$T0e = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$WM = $d7238066c5de7f1c$var$T0e.navigator, $d7238066c5de7f1c$var$HM = $d7238066c5de7f1c$var$WM && $d7238066c5de7f1c$var$WM.userAgent, $d7238066c5de7f1c$var$mf = $d7238066c5de7f1c$var$HM ? String($d7238066c5de7f1c$var$HM) : "", $d7238066c5de7f1c$var$u4 = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$HX = $d7238066c5de7f1c$var$mf, $d7238066c5de7f1c$var$XM = $d7238066c5de7f1c$var$u4.process, $d7238066c5de7f1c$var$NM = $d7238066c5de7f1c$var$u4.Deno, $d7238066c5de7f1c$var$LM = $d7238066c5de7f1c$var$XM && $d7238066c5de7f1c$var$XM.versions || $d7238066c5de7f1c$var$NM && $d7238066c5de7f1c$var$NM.version, $d7238066c5de7f1c$var$YM = $d7238066c5de7f1c$var$LM && $d7238066c5de7f1c$var$LM.v8, $d7238066c5de7f1c$var$_l, $d7238066c5de7f1c$var$OZ;
$d7238066c5de7f1c$var$YM && ($d7238066c5de7f1c$var$_l = $d7238066c5de7f1c$var$YM.split("."), $d7238066c5de7f1c$var$OZ = $d7238066c5de7f1c$var$_l[0] > 0 && $d7238066c5de7f1c$var$_l[0] < 4 ? 1 : +($d7238066c5de7f1c$var$_l[0] + $d7238066c5de7f1c$var$_l[1]));
!$d7238066c5de7f1c$var$OZ && $d7238066c5de7f1c$var$HX && ($d7238066c5de7f1c$var$_l = $d7238066c5de7f1c$var$HX.match(/Edge\/(\d+)/), (!$d7238066c5de7f1c$var$_l || $d7238066c5de7f1c$var$_l[1] >= 74) && ($d7238066c5de7f1c$var$_l = $d7238066c5de7f1c$var$HX.match(/Chrome\/(\d+)/), $d7238066c5de7f1c$var$_l && ($d7238066c5de7f1c$var$OZ = +$d7238066c5de7f1c$var$_l[1])));
var $d7238066c5de7f1c$var$I4 = $d7238066c5de7f1c$var$OZ, $d7238066c5de7f1c$var$KM = $d7238066c5de7f1c$var$I4, $d7238066c5de7f1c$var$M0e = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$z0e = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$k0e = $d7238066c5de7f1c$var$z0e.String, $d7238066c5de7f1c$var$d4 = !!Object.getOwnPropertySymbols && !$d7238066c5de7f1c$var$M0e(function() {
    var r = Symbol("symbol detection");
    return !$d7238066c5de7f1c$var$k0e(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $d7238066c5de7f1c$var$KM && $d7238066c5de7f1c$var$KM < 41;
}), $d7238066c5de7f1c$var$E0e = $d7238066c5de7f1c$var$d4, $d7238066c5de7f1c$var$h4 = $d7238066c5de7f1c$var$E0e && !Symbol.sham && typeof Symbol.iterator == "symbol", $d7238066c5de7f1c$var$J0e = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$U0e = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$D0e = $d7238066c5de7f1c$var$IV, $d7238066c5de7f1c$var$_0e = $d7238066c5de7f1c$var$h4, $d7238066c5de7f1c$var$P0e = Object, $d7238066c5de7f1c$var$C4 = $d7238066c5de7f1c$var$_0e ? function(r) {
    return typeof r == "symbol";
} : function(r) {
    var e = $d7238066c5de7f1c$var$J0e("Symbol");
    return $d7238066c5de7f1c$var$U0e(e) && $d7238066c5de7f1c$var$D0e(e.prototype, $d7238066c5de7f1c$var$P0e(r));
}, $d7238066c5de7f1c$var$Q0e = String, $d7238066c5de7f1c$var$dV = function(r) {
    try {
        return $d7238066c5de7f1c$var$Q0e(r);
    } catch  {
        return "Object";
    }
}, $d7238066c5de7f1c$var$O0e = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$j0e = $d7238066c5de7f1c$var$dV, $d7238066c5de7f1c$var$q0e = TypeError, $d7238066c5de7f1c$var$oc = function(r) {
    if ($d7238066c5de7f1c$var$O0e(r)) return r;
    throw new $d7238066c5de7f1c$var$q0e($d7238066c5de7f1c$var$j0e(r) + " is not a function");
}, $d7238066c5de7f1c$var$$0e = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$ebe = $d7238066c5de7f1c$var$lV, $d7238066c5de7f1c$var$ix = function(r, e) {
    var t = r[e];
    return $d7238066c5de7f1c$var$ebe(t) ? void 0 : $d7238066c5de7f1c$var$$0e(t);
}, $d7238066c5de7f1c$var$XX = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$NX = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$LX = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$tbe = TypeError, $d7238066c5de7f1c$var$ibe = function(r, e) {
    var t, i;
    if (e === "string" && $d7238066c5de7f1c$var$NX(t = r.toString) && !$d7238066c5de7f1c$var$LX(i = $d7238066c5de7f1c$var$XX(t, r)) || $d7238066c5de7f1c$var$NX(t = r.valueOf) && !$d7238066c5de7f1c$var$LX(i = $d7238066c5de7f1c$var$XX(t, r)) || e !== "string" && $d7238066c5de7f1c$var$NX(t = r.toString) && !$d7238066c5de7f1c$var$LX(i = $d7238066c5de7f1c$var$XX(t, r))) return i;
    throw new $d7238066c5de7f1c$var$tbe("Can't convert object to primitive value");
}, $d7238066c5de7f1c$var$p4 = {
    exports: {}
}, $d7238066c5de7f1c$var$nbe = !0, $d7238066c5de7f1c$var$xM = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$sbe = Object.defineProperty, $d7238066c5de7f1c$var$rbe = function(r, e) {
    try {
        $d7238066c5de7f1c$var$sbe($d7238066c5de7f1c$var$xM, r, {
            value: e,
            configurable: !0,
            writable: !0
        });
    } catch  {
        $d7238066c5de7f1c$var$xM[r] = e;
    }
    return e;
}, $d7238066c5de7f1c$var$abe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$obe = $d7238066c5de7f1c$var$rbe, $d7238066c5de7f1c$var$FM = "__core-js_shared__", $d7238066c5de7f1c$var$TM = $d7238066c5de7f1c$var$p4.exports = $d7238066c5de7f1c$var$abe[$d7238066c5de7f1c$var$FM] || $d7238066c5de7f1c$var$obe($d7238066c5de7f1c$var$FM, {});
($d7238066c5de7f1c$var$TM.versions || ($d7238066c5de7f1c$var$TM.versions = [])).push({
    version: "3.46.0",
    mode: "pure",
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: "https://github.com/zloirock/core-js/blob/v3.46.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $d7238066c5de7f1c$var$nx = $d7238066c5de7f1c$var$p4.exports, $d7238066c5de7f1c$var$MM = $d7238066c5de7f1c$var$nx, $d7238066c5de7f1c$var$m4 = function(r, e) {
    return $d7238066c5de7f1c$var$MM[r] || ($d7238066c5de7f1c$var$MM[r] = e || {});
}, $d7238066c5de7f1c$var$gbe = $d7238066c5de7f1c$var$cV, $d7238066c5de7f1c$var$lbe = Object, $d7238066c5de7f1c$var$A4 = function(r) {
    return $d7238066c5de7f1c$var$lbe($d7238066c5de7f1c$var$gbe(r));
}, $d7238066c5de7f1c$var$cbe = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$ube = $d7238066c5de7f1c$var$A4, $d7238066c5de7f1c$var$Ibe = $d7238066c5de7f1c$var$cbe({}.hasOwnProperty), $d7238066c5de7f1c$var$bu = Object.hasOwn || function(e, t) {
    return $d7238066c5de7f1c$var$Ibe($d7238066c5de7f1c$var$ube(e), t);
}, $d7238066c5de7f1c$var$dbe = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$hbe = 0, $d7238066c5de7f1c$var$Cbe = Math.random(), $d7238066c5de7f1c$var$pbe = $d7238066c5de7f1c$var$dbe(1.1.toString), $d7238066c5de7f1c$var$b4 = function(r) {
    return "Symbol(" + (r === void 0 ? "" : r) + ")_" + $d7238066c5de7f1c$var$pbe(++$d7238066c5de7f1c$var$hbe + $d7238066c5de7f1c$var$Cbe, 36);
}, $d7238066c5de7f1c$var$mbe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$Abe = $d7238066c5de7f1c$var$m4, $d7238066c5de7f1c$var$zM = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$bbe = $d7238066c5de7f1c$var$b4, $d7238066c5de7f1c$var$ybe = $d7238066c5de7f1c$var$d4, $d7238066c5de7f1c$var$Bbe = $d7238066c5de7f1c$var$h4, $d7238066c5de7f1c$var$AA = $d7238066c5de7f1c$var$mbe.Symbol, $d7238066c5de7f1c$var$YX = $d7238066c5de7f1c$var$Abe("wks"), $d7238066c5de7f1c$var$fbe = $d7238066c5de7f1c$var$Bbe ? $d7238066c5de7f1c$var$AA.for || $d7238066c5de7f1c$var$AA : $d7238066c5de7f1c$var$AA && $d7238066c5de7f1c$var$AA.withoutSetter || $d7238066c5de7f1c$var$bbe, $d7238066c5de7f1c$var$dg = function(r) {
    return $d7238066c5de7f1c$var$zM($d7238066c5de7f1c$var$YX, r) || ($d7238066c5de7f1c$var$YX[r] = $d7238066c5de7f1c$var$ybe && $d7238066c5de7f1c$var$zM($d7238066c5de7f1c$var$AA, r) ? $d7238066c5de7f1c$var$AA[r] : $d7238066c5de7f1c$var$fbe("Symbol." + r)), $d7238066c5de7f1c$var$YX[r];
}, $d7238066c5de7f1c$var$Gbe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$kM = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$EM = $d7238066c5de7f1c$var$C4, $d7238066c5de7f1c$var$vbe = $d7238066c5de7f1c$var$ix, $d7238066c5de7f1c$var$Sbe = $d7238066c5de7f1c$var$ibe, $d7238066c5de7f1c$var$Zbe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$Rbe = TypeError, $d7238066c5de7f1c$var$Vbe = $d7238066c5de7f1c$var$Zbe("toPrimitive"), $d7238066c5de7f1c$var$wbe = function(r, e) {
    if (!$d7238066c5de7f1c$var$kM(r) || $d7238066c5de7f1c$var$EM(r)) return r;
    var t = $d7238066c5de7f1c$var$vbe(r, $d7238066c5de7f1c$var$Vbe), i;
    if (t) {
        if (e === void 0 && (e = "default"), i = $d7238066c5de7f1c$var$Gbe(t, r, e), !$d7238066c5de7f1c$var$kM(i) || $d7238066c5de7f1c$var$EM(i)) return i;
        throw new $d7238066c5de7f1c$var$Rbe("Can't convert object to primitive value");
    }
    return e === void 0 && (e = "number"), $d7238066c5de7f1c$var$Sbe(r, e);
}, $d7238066c5de7f1c$var$Wbe = $d7238066c5de7f1c$var$wbe, $d7238066c5de7f1c$var$Hbe = $d7238066c5de7f1c$var$C4, $d7238066c5de7f1c$var$y4 = function(r) {
    var e = $d7238066c5de7f1c$var$Wbe(r, "string");
    return $d7238066c5de7f1c$var$Hbe(e) ? e : e + "";
}, $d7238066c5de7f1c$var$Xbe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$JM = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$wN = $d7238066c5de7f1c$var$Xbe.document, $d7238066c5de7f1c$var$Nbe = $d7238066c5de7f1c$var$JM($d7238066c5de7f1c$var$wN) && $d7238066c5de7f1c$var$JM($d7238066c5de7f1c$var$wN.createElement), $d7238066c5de7f1c$var$sx = function(r) {
    return $d7238066c5de7f1c$var$Nbe ? $d7238066c5de7f1c$var$wN.createElement(r) : {};
}, $d7238066c5de7f1c$var$Lbe = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$Ybe = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$Kbe = $d7238066c5de7f1c$var$sx, $d7238066c5de7f1c$var$B4 = !$d7238066c5de7f1c$var$Lbe && !$d7238066c5de7f1c$var$Ybe(function() {
    return Object.defineProperty($d7238066c5de7f1c$var$Kbe("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
}), $d7238066c5de7f1c$var$xbe = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$Fbe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$Tbe = $d7238066c5de7f1c$var$g4, $d7238066c5de7f1c$var$Mbe = $d7238066c5de7f1c$var$Cf, $d7238066c5de7f1c$var$zbe = $d7238066c5de7f1c$var$pf, $d7238066c5de7f1c$var$kbe = $d7238066c5de7f1c$var$y4, $d7238066c5de7f1c$var$Ebe = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$Jbe = $d7238066c5de7f1c$var$B4, $d7238066c5de7f1c$var$UM = Object.getOwnPropertyDescriptor;
$d7238066c5de7f1c$var$tx.f = $d7238066c5de7f1c$var$xbe ? $d7238066c5de7f1c$var$UM : function(e, t) {
    if (e = $d7238066c5de7f1c$var$zbe(e), t = $d7238066c5de7f1c$var$kbe(t), $d7238066c5de7f1c$var$Jbe) try {
        return $d7238066c5de7f1c$var$UM(e, t);
    } catch  {}
    if ($d7238066c5de7f1c$var$Ebe(e, t)) return $d7238066c5de7f1c$var$Mbe(!$d7238066c5de7f1c$var$Fbe($d7238066c5de7f1c$var$Tbe.f, e, t), e[t]);
};
var $d7238066c5de7f1c$var$Ube = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$Dbe = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$_be = /#|\.prototype\./, $d7238066c5de7f1c$var$Af = function(r, e) {
    var t = $d7238066c5de7f1c$var$Qbe[$d7238066c5de7f1c$var$Pbe(r)];
    return t === $d7238066c5de7f1c$var$jbe ? !0 : t === $d7238066c5de7f1c$var$Obe ? !1 : $d7238066c5de7f1c$var$Dbe(e) ? $d7238066c5de7f1c$var$Ube(e) : !!e;
}, $d7238066c5de7f1c$var$Pbe = $d7238066c5de7f1c$var$Af.normalize = function(r) {
    return String(r).replace($d7238066c5de7f1c$var$_be, ".").toLowerCase();
}, $d7238066c5de7f1c$var$Qbe = $d7238066c5de7f1c$var$Af.data = {}, $d7238066c5de7f1c$var$Obe = $d7238066c5de7f1c$var$Af.NATIVE = "N", $d7238066c5de7f1c$var$jbe = $d7238066c5de7f1c$var$Af.POLYFILL = "P", $d7238066c5de7f1c$var$f4 = $d7238066c5de7f1c$var$Af, $d7238066c5de7f1c$var$DM = $d7238066c5de7f1c$var$o4, $d7238066c5de7f1c$var$qbe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$$be = $d7238066c5de7f1c$var$oV, $d7238066c5de7f1c$var$eye = $d7238066c5de7f1c$var$DM($d7238066c5de7f1c$var$DM.bind), $d7238066c5de7f1c$var$hV = function(r, e) {
    return $d7238066c5de7f1c$var$qbe(r), e === void 0 ? r : $d7238066c5de7f1c$var$$be ? $d7238066c5de7f1c$var$eye(r, e) : function() {
        return r.apply(e, arguments);
    };
}, $d7238066c5de7f1c$var$ip = {}, $d7238066c5de7f1c$var$tye = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$iye = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$G4 = $d7238066c5de7f1c$var$tye && $d7238066c5de7f1c$var$iye(function() {
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: !1
    }).prototype !== 42;
}), $d7238066c5de7f1c$var$nye = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$sye = String, $d7238066c5de7f1c$var$rye = TypeError, $d7238066c5de7f1c$var$xI = function(r) {
    if ($d7238066c5de7f1c$var$nye(r)) return r;
    throw new $d7238066c5de7f1c$var$rye($d7238066c5de7f1c$var$sye(r) + " is not an object");
}, $d7238066c5de7f1c$var$aye = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$oye = $d7238066c5de7f1c$var$B4, $d7238066c5de7f1c$var$gye = $d7238066c5de7f1c$var$G4, $d7238066c5de7f1c$var$hS = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$_M = $d7238066c5de7f1c$var$y4, $d7238066c5de7f1c$var$lye = TypeError, $d7238066c5de7f1c$var$KX = Object.defineProperty, $d7238066c5de7f1c$var$cye = Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$xX = "enumerable", $d7238066c5de7f1c$var$FX = "configurable", $d7238066c5de7f1c$var$TX = "writable";
$d7238066c5de7f1c$var$ip.f = $d7238066c5de7f1c$var$aye ? $d7238066c5de7f1c$var$gye ? function(e, t, i) {
    if ($d7238066c5de7f1c$var$hS(e), t = $d7238066c5de7f1c$var$_M(t), $d7238066c5de7f1c$var$hS(i), typeof e == "function" && t === "prototype" && "value" in i && $d7238066c5de7f1c$var$TX in i && !i[$d7238066c5de7f1c$var$TX]) {
        var n = $d7238066c5de7f1c$var$cye(e, t);
        n && n[$d7238066c5de7f1c$var$TX] && (e[t] = i.value, i = {
            configurable: $d7238066c5de7f1c$var$FX in i ? i[$d7238066c5de7f1c$var$FX] : n[$d7238066c5de7f1c$var$FX],
            enumerable: $d7238066c5de7f1c$var$xX in i ? i[$d7238066c5de7f1c$var$xX] : n[$d7238066c5de7f1c$var$xX],
            writable: !1
        });
    }
    return $d7238066c5de7f1c$var$KX(e, t, i);
} : $d7238066c5de7f1c$var$KX : function(e, t, i) {
    if ($d7238066c5de7f1c$var$hS(e), t = $d7238066c5de7f1c$var$_M(t), $d7238066c5de7f1c$var$hS(i), $d7238066c5de7f1c$var$oye) try {
        return $d7238066c5de7f1c$var$KX(e, t, i);
    } catch  {}
    if ("get" in i || "set" in i) throw new $d7238066c5de7f1c$var$lye("Accessors not supported");
    return "value" in i && (e[t] = i.value), e;
};
var $d7238066c5de7f1c$var$uye = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$Iye = $d7238066c5de7f1c$var$ip, $d7238066c5de7f1c$var$dye = $d7238066c5de7f1c$var$Cf, $d7238066c5de7f1c$var$np = $d7238066c5de7f1c$var$uye ? function(r, e, t) {
    return $d7238066c5de7f1c$var$Iye.f(r, e, $d7238066c5de7f1c$var$dye(1, t));
} : function(r, e, t) {
    return r[e] = t, r;
}, $d7238066c5de7f1c$var$py = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$hye = $d7238066c5de7f1c$var$ex, $d7238066c5de7f1c$var$Cye = $d7238066c5de7f1c$var$o4, $d7238066c5de7f1c$var$pye = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$mye = $d7238066c5de7f1c$var$tx.f, $d7238066c5de7f1c$var$Aye = $d7238066c5de7f1c$var$f4, $d7238066c5de7f1c$var$$m = $d7238066c5de7f1c$var$uV, $d7238066c5de7f1c$var$bye = $d7238066c5de7f1c$var$hV, $d7238066c5de7f1c$var$eA = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$PM = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$yye = function(r) {
    var e = function(t, i, n) {
        if (this instanceof e) {
            switch(arguments.length){
                case 0:
                    return new r();
                case 1:
                    return new r(t);
                case 2:
                    return new r(t, i);
            }
            return new r(t, i, n);
        }
        return $d7238066c5de7f1c$var$hye(r, this, arguments);
    };
    return e.prototype = r.prototype, e;
}, $d7238066c5de7f1c$var$hg = function(r, e) {
    var t = r.target, i = r.global, n = r.stat, s = r.proto, a = i ? $d7238066c5de7f1c$var$py : n ? $d7238066c5de7f1c$var$py[t] : $d7238066c5de7f1c$var$py[t] && $d7238066c5de7f1c$var$py[t].prototype, o = i ? $d7238066c5de7f1c$var$$m : $d7238066c5de7f1c$var$$m[t] || $d7238066c5de7f1c$var$eA($d7238066c5de7f1c$var$$m, t, {})[t], g = o.prototype, l, c, d, p, A, y, G, Z, v;
    for(p in e)l = $d7238066c5de7f1c$var$Aye(i ? p : t + (n ? "." : "#") + p, r.forced), c = !l && a && $d7238066c5de7f1c$var$PM(a, p), y = o[p], c && (r.dontCallGetSet ? (v = $d7238066c5de7f1c$var$mye(a, p), G = v && v.value) : G = a[p]), A = c && G ? G : e[p], !(!l && !s && typeof y == typeof A) && (r.bind && c ? Z = $d7238066c5de7f1c$var$bye(A, $d7238066c5de7f1c$var$py) : r.wrap && c ? Z = $d7238066c5de7f1c$var$yye(A) : s && $d7238066c5de7f1c$var$pye(A) ? Z = $d7238066c5de7f1c$var$Cye(A) : Z = A, (r.sham || A && A.sham || y && y.sham) && $d7238066c5de7f1c$var$eA(Z, "sham", !0), $d7238066c5de7f1c$var$eA(o, p, Z), s && (d = t + "Prototype", $d7238066c5de7f1c$var$PM($d7238066c5de7f1c$var$$m, d) || $d7238066c5de7f1c$var$eA($d7238066c5de7f1c$var$$m, d, {}), $d7238066c5de7f1c$var$eA($d7238066c5de7f1c$var$$m[d], p, A), r.real && g && (l || !g[p]) && $d7238066c5de7f1c$var$eA(g, p, A)));
}, $d7238066c5de7f1c$var$Bye = $d7238066c5de7f1c$var$m4, $d7238066c5de7f1c$var$fye = $d7238066c5de7f1c$var$b4, $d7238066c5de7f1c$var$QM = $d7238066c5de7f1c$var$Bye("keys"), $d7238066c5de7f1c$var$rx = function(r) {
    return $d7238066c5de7f1c$var$QM[r] || ($d7238066c5de7f1c$var$QM[r] = $d7238066c5de7f1c$var$fye(r));
}, $d7238066c5de7f1c$var$Gye = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$vye = !$d7238066c5de7f1c$var$Gye(function() {
    function r() {}
    return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), $d7238066c5de7f1c$var$Sye = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$Zye = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$Rye = $d7238066c5de7f1c$var$A4, $d7238066c5de7f1c$var$Vye = $d7238066c5de7f1c$var$rx, $d7238066c5de7f1c$var$wye = $d7238066c5de7f1c$var$vye, $d7238066c5de7f1c$var$OM = $d7238066c5de7f1c$var$Vye("IE_PROTO"), $d7238066c5de7f1c$var$WN = Object, $d7238066c5de7f1c$var$Wye = $d7238066c5de7f1c$var$WN.prototype, $d7238066c5de7f1c$var$ax = $d7238066c5de7f1c$var$wye ? $d7238066c5de7f1c$var$WN.getPrototypeOf : function(r) {
    var e = $d7238066c5de7f1c$var$Rye(r);
    if ($d7238066c5de7f1c$var$Sye(e, $d7238066c5de7f1c$var$OM)) return e[$d7238066c5de7f1c$var$OM];
    var t = e.constructor;
    return $d7238066c5de7f1c$var$Zye(t) && e instanceof t ? t.prototype : e instanceof $d7238066c5de7f1c$var$WN ? $d7238066c5de7f1c$var$Wye : null;
}, $d7238066c5de7f1c$var$Hye = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$Xye = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$Nye = function(r, e, t) {
    try {
        return $d7238066c5de7f1c$var$Hye($d7238066c5de7f1c$var$Xye(Object.getOwnPropertyDescriptor(r, e)[t]));
    } catch  {}
}, $d7238066c5de7f1c$var$Lye = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$Yye = function(r) {
    return $d7238066c5de7f1c$var$Lye(r) || r === null;
}, $d7238066c5de7f1c$var$Kye = $d7238066c5de7f1c$var$Yye, $d7238066c5de7f1c$var$xye = String, $d7238066c5de7f1c$var$Fye = TypeError, $d7238066c5de7f1c$var$Tye = function(r) {
    if ($d7238066c5de7f1c$var$Kye(r)) return r;
    throw new $d7238066c5de7f1c$var$Fye("Can't set " + $d7238066c5de7f1c$var$xye(r) + " as a prototype");
}, $d7238066c5de7f1c$var$Mye = $d7238066c5de7f1c$var$Nye, $d7238066c5de7f1c$var$zye = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$kye = $d7238066c5de7f1c$var$cV, $d7238066c5de7f1c$var$Eye = $d7238066c5de7f1c$var$Tye, $d7238066c5de7f1c$var$Jye = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var r = !1, e = {}, t;
    try {
        t = $d7238066c5de7f1c$var$Mye(Object.prototype, "__proto__", "set"), t(e, []), r = e instanceof Array;
    } catch  {}
    return function(n, s) {
        return $d7238066c5de7f1c$var$kye(n), $d7238066c5de7f1c$var$Eye(s), $d7238066c5de7f1c$var$zye(n) && (r ? t(n, s) : n.__proto__ = s), n;
    };
}() : void 0), $d7238066c5de7f1c$var$v4 = {}, $d7238066c5de7f1c$var$Uye = Math.ceil, $d7238066c5de7f1c$var$Dye = Math.floor, $d7238066c5de7f1c$var$_ye = Math.trunc || function(e) {
    var t = +e;
    return (t > 0 ? $d7238066c5de7f1c$var$Dye : $d7238066c5de7f1c$var$Uye)(t);
}, $d7238066c5de7f1c$var$Pye = $d7238066c5de7f1c$var$_ye, $d7238066c5de7f1c$var$ox = function(r) {
    var e = +r;
    return e !== e || e === 0 ? 0 : $d7238066c5de7f1c$var$Pye(e);
}, $d7238066c5de7f1c$var$Qye = $d7238066c5de7f1c$var$ox, $d7238066c5de7f1c$var$Oye = Math.max, $d7238066c5de7f1c$var$jye = Math.min, $d7238066c5de7f1c$var$qye = function(r, e) {
    var t = $d7238066c5de7f1c$var$Qye(r);
    return t < 0 ? $d7238066c5de7f1c$var$Oye(t + e, 0) : $d7238066c5de7f1c$var$jye(t, e);
}, $d7238066c5de7f1c$var$$ye = $d7238066c5de7f1c$var$ox, $d7238066c5de7f1c$var$eBe = Math.min, $d7238066c5de7f1c$var$tBe = function(r) {
    var e = $d7238066c5de7f1c$var$$ye(r);
    return e > 0 ? $d7238066c5de7f1c$var$eBe(e, 9007199254740991) : 0;
}, $d7238066c5de7f1c$var$iBe = $d7238066c5de7f1c$var$tBe, $d7238066c5de7f1c$var$S4 = function(r) {
    return $d7238066c5de7f1c$var$iBe(r.length);
}, $d7238066c5de7f1c$var$nBe = $d7238066c5de7f1c$var$pf, $d7238066c5de7f1c$var$sBe = $d7238066c5de7f1c$var$qye, $d7238066c5de7f1c$var$rBe = $d7238066c5de7f1c$var$S4, $d7238066c5de7f1c$var$aBe = function(r) {
    return function(e, t, i) {
        var n = $d7238066c5de7f1c$var$nBe(e), s = $d7238066c5de7f1c$var$rBe(n);
        if (s === 0) return !r && -1;
        var a = $d7238066c5de7f1c$var$sBe(i, s), o;
        if (r && t !== t) {
            for(; s > a;)if (o = n[a++], o !== o) return !0;
        } else for(; s > a; a++)if ((r || a in n) && n[a] === t) return r || a || 0;
        return !r && -1;
    };
}, $d7238066c5de7f1c$var$oBe = {
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $d7238066c5de7f1c$var$aBe(!1)
}, $d7238066c5de7f1c$var$gx = {}, $d7238066c5de7f1c$var$gBe = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$MX = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$lBe = $d7238066c5de7f1c$var$pf, $d7238066c5de7f1c$var$cBe = $d7238066c5de7f1c$var$oBe.indexOf, $d7238066c5de7f1c$var$uBe = $d7238066c5de7f1c$var$gx, $d7238066c5de7f1c$var$jM = $d7238066c5de7f1c$var$gBe([].push), $d7238066c5de7f1c$var$Z4 = function(r, e) {
    var t = $d7238066c5de7f1c$var$lBe(r), i = 0, n = [], s;
    for(s in t)!$d7238066c5de7f1c$var$MX($d7238066c5de7f1c$var$uBe, s) && $d7238066c5de7f1c$var$MX(t, s) && $d7238066c5de7f1c$var$jM(n, s);
    for(; e.length > i;)$d7238066c5de7f1c$var$MX(t, s = e[i++]) && (~$d7238066c5de7f1c$var$cBe(n, s) || $d7238066c5de7f1c$var$jM(n, s));
    return n;
}, $d7238066c5de7f1c$var$lx = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
], $d7238066c5de7f1c$var$IBe = $d7238066c5de7f1c$var$Z4, $d7238066c5de7f1c$var$dBe = $d7238066c5de7f1c$var$lx, $d7238066c5de7f1c$var$hBe = $d7238066c5de7f1c$var$dBe.concat("length", "prototype");
$d7238066c5de7f1c$var$v4.f = Object.getOwnPropertyNames || function(e) {
    return $d7238066c5de7f1c$var$IBe(e, $d7238066c5de7f1c$var$hBe);
};
var $d7238066c5de7f1c$var$R4 = {};
$d7238066c5de7f1c$var$R4.f = Object.getOwnPropertySymbols;
var $d7238066c5de7f1c$var$CBe = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$pBe = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$mBe = $d7238066c5de7f1c$var$v4, $d7238066c5de7f1c$var$ABe = $d7238066c5de7f1c$var$R4, $d7238066c5de7f1c$var$bBe = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$yBe = $d7238066c5de7f1c$var$pBe([].concat), $d7238066c5de7f1c$var$BBe = $d7238066c5de7f1c$var$CBe("Reflect", "ownKeys") || function(e) {
    var t = $d7238066c5de7f1c$var$mBe.f($d7238066c5de7f1c$var$bBe(e)), i = $d7238066c5de7f1c$var$ABe.f;
    return i ? $d7238066c5de7f1c$var$yBe(t, i(e)) : t;
}, $d7238066c5de7f1c$var$qM = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$fBe = $d7238066c5de7f1c$var$BBe, $d7238066c5de7f1c$var$GBe = $d7238066c5de7f1c$var$tx, $d7238066c5de7f1c$var$vBe = $d7238066c5de7f1c$var$ip, $d7238066c5de7f1c$var$SBe = function(r, e, t) {
    for(var i = $d7238066c5de7f1c$var$fBe(e), n = $d7238066c5de7f1c$var$vBe.f, s = $d7238066c5de7f1c$var$GBe.f, a = 0; a < i.length; a++){
        var o = i[a];
        !$d7238066c5de7f1c$var$qM(r, o) && !(t && $d7238066c5de7f1c$var$qM(t, o)) && n(r, o, s(e, o));
    }
}, $d7238066c5de7f1c$var$V4 = {}, $d7238066c5de7f1c$var$ZBe = $d7238066c5de7f1c$var$Z4, $d7238066c5de7f1c$var$RBe = $d7238066c5de7f1c$var$lx, $d7238066c5de7f1c$var$VBe = Object.keys || function(e) {
    return $d7238066c5de7f1c$var$ZBe(e, $d7238066c5de7f1c$var$RBe);
}, $d7238066c5de7f1c$var$wBe = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$WBe = $d7238066c5de7f1c$var$G4, $d7238066c5de7f1c$var$HBe = $d7238066c5de7f1c$var$ip, $d7238066c5de7f1c$var$XBe = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$NBe = $d7238066c5de7f1c$var$pf, $d7238066c5de7f1c$var$LBe = $d7238066c5de7f1c$var$VBe;
$d7238066c5de7f1c$var$V4.f = $d7238066c5de7f1c$var$wBe && !$d7238066c5de7f1c$var$WBe ? Object.defineProperties : function(e, t) {
    $d7238066c5de7f1c$var$XBe(e);
    for(var i = $d7238066c5de7f1c$var$NBe(t), n = $d7238066c5de7f1c$var$LBe(t), s = n.length, a = 0, o; s > a;)$d7238066c5de7f1c$var$HBe.f(e, o = n[a++], i[o]);
    return e;
};
var $d7238066c5de7f1c$var$YBe = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$w4 = $d7238066c5de7f1c$var$YBe("document", "documentElement"), $d7238066c5de7f1c$var$KBe = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$xBe = $d7238066c5de7f1c$var$V4, $d7238066c5de7f1c$var$$M = $d7238066c5de7f1c$var$lx, $d7238066c5de7f1c$var$FBe = $d7238066c5de7f1c$var$gx, $d7238066c5de7f1c$var$TBe = $d7238066c5de7f1c$var$w4, $d7238066c5de7f1c$var$MBe = $d7238066c5de7f1c$var$sx, $d7238066c5de7f1c$var$zBe = $d7238066c5de7f1c$var$rx, $d7238066c5de7f1c$var$ez = ">", $d7238066c5de7f1c$var$tz = "<", $d7238066c5de7f1c$var$HN = "prototype", $d7238066c5de7f1c$var$XN = "script", $d7238066c5de7f1c$var$W4 = $d7238066c5de7f1c$var$zBe("IE_PROTO"), $d7238066c5de7f1c$var$zX = function() {}, $d7238066c5de7f1c$var$H4 = function(r) {
    return $d7238066c5de7f1c$var$tz + $d7238066c5de7f1c$var$XN + $d7238066c5de7f1c$var$ez + r + $d7238066c5de7f1c$var$tz + "/" + $d7238066c5de7f1c$var$XN + $d7238066c5de7f1c$var$ez;
}, $d7238066c5de7f1c$var$iz = function(r) {
    r.write($d7238066c5de7f1c$var$H4("")), r.close();
    var e = r.parentWindow.Object;
    return r = null, e;
}, $d7238066c5de7f1c$var$kBe = function() {
    var r = $d7238066c5de7f1c$var$MBe("iframe"), e = "java" + $d7238066c5de7f1c$var$XN + ":", t;
    return r.style.display = "none", $d7238066c5de7f1c$var$TBe.appendChild(r), r.src = String(e), t = r.contentWindow.document, t.open(), t.write($d7238066c5de7f1c$var$H4("document.F=Object")), t.close(), t.F;
}, $d7238066c5de7f1c$var$CS, $d7238066c5de7f1c$var$kS = function() {
    try {
        $d7238066c5de7f1c$var$CS = new ActiveXObject("htmlfile");
    } catch  {}
    $d7238066c5de7f1c$var$kS = typeof document < "u" ? document.domain && $d7238066c5de7f1c$var$CS ? $d7238066c5de7f1c$var$iz($d7238066c5de7f1c$var$CS) : $d7238066c5de7f1c$var$kBe() : $d7238066c5de7f1c$var$iz($d7238066c5de7f1c$var$CS);
    for(var r = $d7238066c5de7f1c$var$$M.length; r--;)delete $d7238066c5de7f1c$var$kS[$d7238066c5de7f1c$var$HN][$d7238066c5de7f1c$var$$M[r]];
    return $d7238066c5de7f1c$var$kS();
};
$d7238066c5de7f1c$var$FBe[$d7238066c5de7f1c$var$W4] = !0;
var $d7238066c5de7f1c$var$cx = Object.create || function(e, t) {
    var i;
    return e !== null ? ($d7238066c5de7f1c$var$zX[$d7238066c5de7f1c$var$HN] = $d7238066c5de7f1c$var$KBe(e), i = new $d7238066c5de7f1c$var$zX(), $d7238066c5de7f1c$var$zX[$d7238066c5de7f1c$var$HN] = null, i[$d7238066c5de7f1c$var$W4] = e) : i = $d7238066c5de7f1c$var$kS(), t === void 0 ? i : $d7238066c5de7f1c$var$xBe.f(i, t);
}, $d7238066c5de7f1c$var$EBe = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$JBe = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$UBe = function(r, e) {
    $d7238066c5de7f1c$var$EBe(e) && "cause" in e && $d7238066c5de7f1c$var$JBe(r, "cause", e.cause);
}, $d7238066c5de7f1c$var$DBe = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$X4 = Error, $d7238066c5de7f1c$var$_Be = $d7238066c5de7f1c$var$DBe("".replace), $d7238066c5de7f1c$var$PBe = function(r) {
    return String(new $d7238066c5de7f1c$var$X4(r).stack);
}("zxcasd"), $d7238066c5de7f1c$var$N4 = /\n\s*at [^:]*:[^\n]*/, $d7238066c5de7f1c$var$QBe = $d7238066c5de7f1c$var$N4.test($d7238066c5de7f1c$var$PBe), $d7238066c5de7f1c$var$OBe = function(r, e) {
    if ($d7238066c5de7f1c$var$QBe && typeof r == "string" && !$d7238066c5de7f1c$var$X4.prepareStackTrace) for(; e--;)r = $d7238066c5de7f1c$var$_Be(r, $d7238066c5de7f1c$var$N4, "");
    return r;
}, $d7238066c5de7f1c$var$jBe = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$qBe = $d7238066c5de7f1c$var$Cf, $d7238066c5de7f1c$var$$Be = !$d7238066c5de7f1c$var$jBe(function() {
    var r = new Error("a");
    return "stack" in r ? (Object.defineProperty(r, "stack", $d7238066c5de7f1c$var$qBe(1, 7)), r.stack !== 7) : !0;
}), $d7238066c5de7f1c$var$efe = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$tfe = $d7238066c5de7f1c$var$OBe, $d7238066c5de7f1c$var$ife = $d7238066c5de7f1c$var$$Be, $d7238066c5de7f1c$var$nz = Error.captureStackTrace, $d7238066c5de7f1c$var$nfe = function(r, e, t, i) {
    $d7238066c5de7f1c$var$ife && ($d7238066c5de7f1c$var$nz ? $d7238066c5de7f1c$var$nz(r, e) : $d7238066c5de7f1c$var$efe(r, "stack", $d7238066c5de7f1c$var$tfe(t, i)));
}, $d7238066c5de7f1c$var$u0 = {}, $d7238066c5de7f1c$var$sfe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$rfe = $d7238066c5de7f1c$var$u0, $d7238066c5de7f1c$var$afe = $d7238066c5de7f1c$var$sfe("iterator"), $d7238066c5de7f1c$var$ofe = Array.prototype, $d7238066c5de7f1c$var$gfe = function(r) {
    return r !== void 0 && ($d7238066c5de7f1c$var$rfe.Array === r || $d7238066c5de7f1c$var$ofe[$d7238066c5de7f1c$var$afe] === r);
}, $d7238066c5de7f1c$var$lfe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$cfe = $d7238066c5de7f1c$var$lfe("toStringTag"), $d7238066c5de7f1c$var$L4 = {};
$d7238066c5de7f1c$var$L4[$d7238066c5de7f1c$var$cfe] = "z";
var $d7238066c5de7f1c$var$ux = String($d7238066c5de7f1c$var$L4) === "[object z]", $d7238066c5de7f1c$var$ufe = $d7238066c5de7f1c$var$ux, $d7238066c5de7f1c$var$Ife = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$ES = $d7238066c5de7f1c$var$gV, $d7238066c5de7f1c$var$dfe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$hfe = $d7238066c5de7f1c$var$dfe("toStringTag"), $d7238066c5de7f1c$var$Cfe = Object, $d7238066c5de7f1c$var$pfe = $d7238066c5de7f1c$var$ES(/* @__PURE__ */ function() {
    return arguments;
}()) === "Arguments", $d7238066c5de7f1c$var$mfe = function(r, e) {
    try {
        return r[e];
    } catch  {}
}, $d7238066c5de7f1c$var$CV = $d7238066c5de7f1c$var$ufe ? $d7238066c5de7f1c$var$ES : function(r) {
    var e, t, i;
    return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = $d7238066c5de7f1c$var$mfe(e = $d7238066c5de7f1c$var$Cfe(r), $d7238066c5de7f1c$var$hfe)) == "string" ? t : $d7238066c5de7f1c$var$pfe ? $d7238066c5de7f1c$var$ES(e) : (i = $d7238066c5de7f1c$var$ES(e)) === "Object" && $d7238066c5de7f1c$var$Ife(e.callee) ? "Arguments" : i;
}, $d7238066c5de7f1c$var$Afe = $d7238066c5de7f1c$var$CV, $d7238066c5de7f1c$var$sz = $d7238066c5de7f1c$var$ix, $d7238066c5de7f1c$var$bfe = $d7238066c5de7f1c$var$lV, $d7238066c5de7f1c$var$yfe = $d7238066c5de7f1c$var$u0, $d7238066c5de7f1c$var$Bfe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$ffe = $d7238066c5de7f1c$var$Bfe("iterator"), $d7238066c5de7f1c$var$Y4 = function(r) {
    if (!$d7238066c5de7f1c$var$bfe(r)) return $d7238066c5de7f1c$var$sz(r, $d7238066c5de7f1c$var$ffe) || $d7238066c5de7f1c$var$sz(r, "@@iterator") || $d7238066c5de7f1c$var$yfe[$d7238066c5de7f1c$var$Afe(r)];
}, $d7238066c5de7f1c$var$Gfe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$vfe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$Sfe = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$Zfe = $d7238066c5de7f1c$var$dV, $d7238066c5de7f1c$var$Rfe = $d7238066c5de7f1c$var$Y4, $d7238066c5de7f1c$var$Vfe = TypeError, $d7238066c5de7f1c$var$wfe = function(r, e) {
    var t = arguments.length < 2 ? $d7238066c5de7f1c$var$Rfe(r) : e;
    if ($d7238066c5de7f1c$var$vfe(t)) return $d7238066c5de7f1c$var$Sfe($d7238066c5de7f1c$var$Gfe(t, r));
    throw new $d7238066c5de7f1c$var$Vfe($d7238066c5de7f1c$var$Zfe(r) + " is not iterable");
}, $d7238066c5de7f1c$var$Wfe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$rz = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$Hfe = $d7238066c5de7f1c$var$ix, $d7238066c5de7f1c$var$Xfe = function(r, e, t) {
    var i, n;
    $d7238066c5de7f1c$var$rz(r);
    try {
        if (i = $d7238066c5de7f1c$var$Hfe(r, "return"), !i) {
            if (e === "throw") throw t;
            return t;
        }
        i = $d7238066c5de7f1c$var$Wfe(i, r);
    } catch (s) {
        n = !0, i = s;
    }
    if (e === "throw") throw t;
    if (n) throw i;
    return $d7238066c5de7f1c$var$rz(i), t;
}, $d7238066c5de7f1c$var$Nfe = $d7238066c5de7f1c$var$hV, $d7238066c5de7f1c$var$Lfe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$Yfe = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$Kfe = $d7238066c5de7f1c$var$dV, $d7238066c5de7f1c$var$xfe = $d7238066c5de7f1c$var$gfe, $d7238066c5de7f1c$var$Ffe = $d7238066c5de7f1c$var$S4, $d7238066c5de7f1c$var$az = $d7238066c5de7f1c$var$IV, $d7238066c5de7f1c$var$Tfe = $d7238066c5de7f1c$var$wfe, $d7238066c5de7f1c$var$Mfe = $d7238066c5de7f1c$var$Y4, $d7238066c5de7f1c$var$oz = $d7238066c5de7f1c$var$Xfe, $d7238066c5de7f1c$var$zfe = TypeError, $d7238066c5de7f1c$var$JS = function(r, e) {
    this.stopped = r, this.result = e;
}, $d7238066c5de7f1c$var$gz = $d7238066c5de7f1c$var$JS.prototype, $d7238066c5de7f1c$var$bf = function(r, e, t) {
    var i = t && t.that, n = !!(t && t.AS_ENTRIES), s = !!(t && t.IS_RECORD), a = !!(t && t.IS_ITERATOR), o = !!(t && t.INTERRUPTED), g = $d7238066c5de7f1c$var$Nfe(e, i), l, c, d, p, A, y, G, Z = function(V) {
        return l && $d7238066c5de7f1c$var$oz(l, "normal"), new $d7238066c5de7f1c$var$JS(!0, V);
    }, v = function(V) {
        return n ? ($d7238066c5de7f1c$var$Yfe(V), o ? g(V[0], V[1], Z) : g(V[0], V[1])) : o ? g(V, Z) : g(V);
    };
    if (s) l = r.iterator;
    else if (a) l = r;
    else {
        if (c = $d7238066c5de7f1c$var$Mfe(r), !c) throw new $d7238066c5de7f1c$var$zfe($d7238066c5de7f1c$var$Kfe(r) + " is not iterable");
        if ($d7238066c5de7f1c$var$xfe(c)) {
            for(d = 0, p = $d7238066c5de7f1c$var$Ffe(r); p > d; d++)if (A = v(r[d]), A && $d7238066c5de7f1c$var$az($d7238066c5de7f1c$var$gz, A)) return A;
            return new $d7238066c5de7f1c$var$JS(!1);
        }
        l = $d7238066c5de7f1c$var$Tfe(r, c);
    }
    for(y = s ? r.next : l.next; !(G = $d7238066c5de7f1c$var$Lfe(y, l)).done;){
        try {
            A = v(G.value);
        } catch (V) {
            $d7238066c5de7f1c$var$oz(l, "throw", V);
        }
        if (typeof A == "object" && A && $d7238066c5de7f1c$var$az($d7238066c5de7f1c$var$gz, A)) return A;
    }
    return new $d7238066c5de7f1c$var$JS(!1);
}, $d7238066c5de7f1c$var$kfe = $d7238066c5de7f1c$var$CV, $d7238066c5de7f1c$var$Efe = String, $d7238066c5de7f1c$var$Ix = function(r) {
    if ($d7238066c5de7f1c$var$kfe(r) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $d7238066c5de7f1c$var$Efe(r);
}, $d7238066c5de7f1c$var$Jfe = $d7238066c5de7f1c$var$Ix, $d7238066c5de7f1c$var$Ufe = function(r, e) {
    return r === void 0 ? arguments.length < 2 ? "" : e : $d7238066c5de7f1c$var$Jfe(r);
}, $d7238066c5de7f1c$var$Dfe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$_fe = $d7238066c5de7f1c$var$IV, $d7238066c5de7f1c$var$Pfe = $d7238066c5de7f1c$var$ax, $d7238066c5de7f1c$var$jZ = $d7238066c5de7f1c$var$Jye, $d7238066c5de7f1c$var$Qfe = $d7238066c5de7f1c$var$SBe, $d7238066c5de7f1c$var$K4 = $d7238066c5de7f1c$var$cx, $d7238066c5de7f1c$var$kX = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$EX = $d7238066c5de7f1c$var$Cf, $d7238066c5de7f1c$var$Ofe = $d7238066c5de7f1c$var$UBe, $d7238066c5de7f1c$var$jfe = $d7238066c5de7f1c$var$nfe, $d7238066c5de7f1c$var$qfe = $d7238066c5de7f1c$var$bf, $d7238066c5de7f1c$var$$fe = $d7238066c5de7f1c$var$Ufe, $d7238066c5de7f1c$var$eGe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$tGe = $d7238066c5de7f1c$var$eGe("toStringTag"), $d7238066c5de7f1c$var$qZ = Error, $d7238066c5de7f1c$var$iGe = [].push, $d7238066c5de7f1c$var$$A = function(e, t) {
    var i = $d7238066c5de7f1c$var$_fe($d7238066c5de7f1c$var$JX, this), n;
    $d7238066c5de7f1c$var$jZ ? n = $d7238066c5de7f1c$var$jZ(new $d7238066c5de7f1c$var$qZ(), i ? $d7238066c5de7f1c$var$Pfe(this) : $d7238066c5de7f1c$var$JX) : (n = i ? this : $d7238066c5de7f1c$var$K4($d7238066c5de7f1c$var$JX), $d7238066c5de7f1c$var$kX(n, $d7238066c5de7f1c$var$tGe, "Error")), t !== void 0 && $d7238066c5de7f1c$var$kX(n, "message", $d7238066c5de7f1c$var$$fe(t)), $d7238066c5de7f1c$var$jfe(n, $d7238066c5de7f1c$var$$A, n.stack, 1), arguments.length > 2 && $d7238066c5de7f1c$var$Ofe(n, arguments[2]);
    var s = [];
    return $d7238066c5de7f1c$var$qfe(e, $d7238066c5de7f1c$var$iGe, {
        that: s
    }), $d7238066c5de7f1c$var$kX(n, "errors", s), n;
};
$d7238066c5de7f1c$var$jZ ? $d7238066c5de7f1c$var$jZ($d7238066c5de7f1c$var$$A, $d7238066c5de7f1c$var$qZ) : $d7238066c5de7f1c$var$Qfe($d7238066c5de7f1c$var$$A, $d7238066c5de7f1c$var$qZ, {
    name: !0
});
var $d7238066c5de7f1c$var$JX = $d7238066c5de7f1c$var$$A.prototype = $d7238066c5de7f1c$var$K4($d7238066c5de7f1c$var$qZ.prototype, {
    constructor: $d7238066c5de7f1c$var$EX(1, $d7238066c5de7f1c$var$$A),
    message: $d7238066c5de7f1c$var$EX(1, ""),
    name: $d7238066c5de7f1c$var$EX(1, "AggregateError")
});
$d7238066c5de7f1c$var$Dfe({
    global: !0
}, {
    AggregateError: $d7238066c5de7f1c$var$$A
});
var $d7238066c5de7f1c$var$nGe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$sGe = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$lz = $d7238066c5de7f1c$var$nGe.WeakMap, $d7238066c5de7f1c$var$rGe = $d7238066c5de7f1c$var$sGe($d7238066c5de7f1c$var$lz) && /native code/.test(String($d7238066c5de7f1c$var$lz)), $d7238066c5de7f1c$var$aGe = $d7238066c5de7f1c$var$rGe, $d7238066c5de7f1c$var$x4 = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$oGe = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$gGe = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$UX = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$DX = $d7238066c5de7f1c$var$nx, $d7238066c5de7f1c$var$lGe = $d7238066c5de7f1c$var$rx, $d7238066c5de7f1c$var$cGe = $d7238066c5de7f1c$var$gx, $d7238066c5de7f1c$var$cz = "Object already initialized", $d7238066c5de7f1c$var$NN = $d7238066c5de7f1c$var$x4.TypeError, $d7238066c5de7f1c$var$uGe = $d7238066c5de7f1c$var$x4.WeakMap, $d7238066c5de7f1c$var$$Z, $d7238066c5de7f1c$var$KB, $d7238066c5de7f1c$var$eR, $d7238066c5de7f1c$var$IGe = function(r) {
    return $d7238066c5de7f1c$var$eR(r) ? $d7238066c5de7f1c$var$KB(r) : $d7238066c5de7f1c$var$$Z(r, {});
}, $d7238066c5de7f1c$var$dGe = function(r) {
    return function(e) {
        var t;
        if (!$d7238066c5de7f1c$var$oGe(e) || (t = $d7238066c5de7f1c$var$KB(e)).type !== r) throw new $d7238066c5de7f1c$var$NN("Incompatible receiver, " + r + " required");
        return t;
    };
};
if ($d7238066c5de7f1c$var$aGe || $d7238066c5de7f1c$var$DX.state) {
    var $d7238066c5de7f1c$var$zc = $d7238066c5de7f1c$var$DX.state || ($d7238066c5de7f1c$var$DX.state = new $d7238066c5de7f1c$var$uGe());
    $d7238066c5de7f1c$var$zc.get = $d7238066c5de7f1c$var$zc.get, $d7238066c5de7f1c$var$zc.has = $d7238066c5de7f1c$var$zc.has, $d7238066c5de7f1c$var$zc.set = $d7238066c5de7f1c$var$zc.set, $d7238066c5de7f1c$var$$Z = function(r, e) {
        if ($d7238066c5de7f1c$var$zc.has(r)) throw new $d7238066c5de7f1c$var$NN($d7238066c5de7f1c$var$cz);
        return e.facade = r, $d7238066c5de7f1c$var$zc.set(r, e), e;
    }, $d7238066c5de7f1c$var$KB = function(r) {
        return $d7238066c5de7f1c$var$zc.get(r) || {};
    }, $d7238066c5de7f1c$var$eR = function(r) {
        return $d7238066c5de7f1c$var$zc.has(r);
    };
} else {
    var $d7238066c5de7f1c$var$tA = $d7238066c5de7f1c$var$lGe("state");
    $d7238066c5de7f1c$var$cGe[$d7238066c5de7f1c$var$tA] = !0, $d7238066c5de7f1c$var$$Z = function(r, e) {
        if ($d7238066c5de7f1c$var$UX(r, $d7238066c5de7f1c$var$tA)) throw new $d7238066c5de7f1c$var$NN($d7238066c5de7f1c$var$cz);
        return e.facade = r, $d7238066c5de7f1c$var$gGe(r, $d7238066c5de7f1c$var$tA, e), e;
    }, $d7238066c5de7f1c$var$KB = function(r) {
        return $d7238066c5de7f1c$var$UX(r, $d7238066c5de7f1c$var$tA) ? r[$d7238066c5de7f1c$var$tA] : {};
    }, $d7238066c5de7f1c$var$eR = function(r) {
        return $d7238066c5de7f1c$var$UX(r, $d7238066c5de7f1c$var$tA);
    };
}
var $d7238066c5de7f1c$var$dx = {
    set: $d7238066c5de7f1c$var$$Z,
    get: $d7238066c5de7f1c$var$KB,
    has: $d7238066c5de7f1c$var$eR,
    enforce: $d7238066c5de7f1c$var$IGe,
    getterFor: $d7238066c5de7f1c$var$dGe
}, $d7238066c5de7f1c$var$LN = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$hGe = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$F4 = Function.prototype, $d7238066c5de7f1c$var$CGe = $d7238066c5de7f1c$var$LN && Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$T4 = $d7238066c5de7f1c$var$hGe($d7238066c5de7f1c$var$F4, "name"), $d7238066c5de7f1c$var$pGe = $d7238066c5de7f1c$var$T4 && (function() {}).name === "something", $d7238066c5de7f1c$var$mGe = $d7238066c5de7f1c$var$T4 && (!$d7238066c5de7f1c$var$LN || $d7238066c5de7f1c$var$LN && $d7238066c5de7f1c$var$CGe($d7238066c5de7f1c$var$F4, "name").configurable), $d7238066c5de7f1c$var$AGe = {
    PROPER: $d7238066c5de7f1c$var$pGe,
    CONFIGURABLE: $d7238066c5de7f1c$var$mGe
}, $d7238066c5de7f1c$var$bGe = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$hx = function(r, e, t, i) {
    return i && i.enumerable ? r[e] = t : $d7238066c5de7f1c$var$bGe(r, e, t), r;
}, $d7238066c5de7f1c$var$yGe = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$BGe = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$fGe = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$GGe = $d7238066c5de7f1c$var$cx, $d7238066c5de7f1c$var$uz = $d7238066c5de7f1c$var$ax, $d7238066c5de7f1c$var$vGe = $d7238066c5de7f1c$var$hx, $d7238066c5de7f1c$var$SGe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$YN = $d7238066c5de7f1c$var$SGe("iterator"), $d7238066c5de7f1c$var$M4 = !1, $d7238066c5de7f1c$var$vI, $d7238066c5de7f1c$var$_X, $d7238066c5de7f1c$var$PX;
[].keys && ($d7238066c5de7f1c$var$PX = [].keys(), "next" in $d7238066c5de7f1c$var$PX ? ($d7238066c5de7f1c$var$_X = $d7238066c5de7f1c$var$uz($d7238066c5de7f1c$var$uz($d7238066c5de7f1c$var$PX)), $d7238066c5de7f1c$var$_X !== Object.prototype && ($d7238066c5de7f1c$var$vI = $d7238066c5de7f1c$var$_X)) : $d7238066c5de7f1c$var$M4 = !0);
var $d7238066c5de7f1c$var$ZGe = !$d7238066c5de7f1c$var$fGe($d7238066c5de7f1c$var$vI) || $d7238066c5de7f1c$var$yGe(function() {
    var r = {};
    return $d7238066c5de7f1c$var$vI[$d7238066c5de7f1c$var$YN].call(r) !== r;
});
$d7238066c5de7f1c$var$ZGe ? $d7238066c5de7f1c$var$vI = {} : $d7238066c5de7f1c$var$vI = $d7238066c5de7f1c$var$GGe($d7238066c5de7f1c$var$vI);
$d7238066c5de7f1c$var$BGe($d7238066c5de7f1c$var$vI[$d7238066c5de7f1c$var$YN]) || $d7238066c5de7f1c$var$vGe($d7238066c5de7f1c$var$vI, $d7238066c5de7f1c$var$YN, function() {
    return this;
});
var $d7238066c5de7f1c$var$z4 = {
    IteratorPrototype: $d7238066c5de7f1c$var$vI,
    BUGGY_SAFARI_ITERATORS: $d7238066c5de7f1c$var$M4
}, $d7238066c5de7f1c$var$RGe = $d7238066c5de7f1c$var$ux, $d7238066c5de7f1c$var$VGe = $d7238066c5de7f1c$var$CV, $d7238066c5de7f1c$var$wGe = $d7238066c5de7f1c$var$RGe ? ({}).toString : function() {
    return "[object " + $d7238066c5de7f1c$var$VGe(this) + "]";
}, $d7238066c5de7f1c$var$WGe = $d7238066c5de7f1c$var$ux, $d7238066c5de7f1c$var$HGe = $d7238066c5de7f1c$var$ip.f, $d7238066c5de7f1c$var$XGe = $d7238066c5de7f1c$var$np, $d7238066c5de7f1c$var$NGe = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$LGe = $d7238066c5de7f1c$var$wGe, $d7238066c5de7f1c$var$YGe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$Iz = $d7238066c5de7f1c$var$YGe("toStringTag"), $d7238066c5de7f1c$var$pV = function(r, e, t, i) {
    var n = t ? r : r && r.prototype;
    n && ($d7238066c5de7f1c$var$NGe(n, $d7238066c5de7f1c$var$Iz) || $d7238066c5de7f1c$var$HGe(n, $d7238066c5de7f1c$var$Iz, {
        configurable: !0,
        value: e
    }), i && !$d7238066c5de7f1c$var$WGe && $d7238066c5de7f1c$var$XGe(n, "toString", $d7238066c5de7f1c$var$LGe));
}, $d7238066c5de7f1c$var$KGe = $d7238066c5de7f1c$var$z4.IteratorPrototype, $d7238066c5de7f1c$var$xGe = $d7238066c5de7f1c$var$cx, $d7238066c5de7f1c$var$FGe = $d7238066c5de7f1c$var$Cf, $d7238066c5de7f1c$var$TGe = $d7238066c5de7f1c$var$pV, $d7238066c5de7f1c$var$MGe = $d7238066c5de7f1c$var$u0, $d7238066c5de7f1c$var$zGe = function() {
    return this;
}, $d7238066c5de7f1c$var$kGe = function(r, e, t, i) {
    var n = e + " Iterator";
    return r.prototype = $d7238066c5de7f1c$var$xGe($d7238066c5de7f1c$var$KGe, {
        next: $d7238066c5de7f1c$var$FGe(+!i, t)
    }), $d7238066c5de7f1c$var$TGe(r, n, !1, !0), $d7238066c5de7f1c$var$MGe[n] = $d7238066c5de7f1c$var$zGe, r;
}, $d7238066c5de7f1c$var$EGe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$JGe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$k4 = $d7238066c5de7f1c$var$AGe, $d7238066c5de7f1c$var$UGe = $d7238066c5de7f1c$var$kGe, $d7238066c5de7f1c$var$DGe = $d7238066c5de7f1c$var$ax, $d7238066c5de7f1c$var$_Ge = $d7238066c5de7f1c$var$pV, $d7238066c5de7f1c$var$dz = $d7238066c5de7f1c$var$hx, $d7238066c5de7f1c$var$PGe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$hz = $d7238066c5de7f1c$var$u0, $d7238066c5de7f1c$var$E4 = $d7238066c5de7f1c$var$z4, $d7238066c5de7f1c$var$QGe = $d7238066c5de7f1c$var$k4.PROPER;
$d7238066c5de7f1c$var$k4.CONFIGURABLE;
$d7238066c5de7f1c$var$E4.IteratorPrototype;
var $d7238066c5de7f1c$var$pS = $d7238066c5de7f1c$var$E4.BUGGY_SAFARI_ITERATORS, $d7238066c5de7f1c$var$QX = $d7238066c5de7f1c$var$PGe("iterator"), $d7238066c5de7f1c$var$Cz = "keys", $d7238066c5de7f1c$var$mS = "values", $d7238066c5de7f1c$var$pz = "entries", $d7238066c5de7f1c$var$OGe = function() {
    return this;
}, $d7238066c5de7f1c$var$J4 = function(r, e, t, i, n, s, a) {
    $d7238066c5de7f1c$var$UGe(t, e, i);
    var o = function(v) {
        if (v === n && p) return p;
        if (!$d7238066c5de7f1c$var$pS && v && v in c) return c[v];
        switch(v){
            case $d7238066c5de7f1c$var$Cz:
                return function() {
                    return new t(this, v);
                };
            case $d7238066c5de7f1c$var$mS:
                return function() {
                    return new t(this, v);
                };
            case $d7238066c5de7f1c$var$pz:
                return function() {
                    return new t(this, v);
                };
        }
        return function() {
            return new t(this);
        };
    }, g = e + " Iterator", l = !1, c = r.prototype, d = c[$d7238066c5de7f1c$var$QX] || c["@@iterator"] || n && c[n], p = !$d7238066c5de7f1c$var$pS && d || o(n), A = e === "Array" && c.entries || d, y, G, Z;
    if (A && (y = $d7238066c5de7f1c$var$DGe(A.call(new r())), y !== Object.prototype && y.next && ($d7238066c5de7f1c$var$_Ge(y, g, !0, !0), $d7238066c5de7f1c$var$hz[g] = $d7238066c5de7f1c$var$OGe)), $d7238066c5de7f1c$var$QGe && n === $d7238066c5de7f1c$var$mS && d && d.name !== $d7238066c5de7f1c$var$mS && (l = !0, p = function() {
        return $d7238066c5de7f1c$var$JGe(d, this);
    }), n) {
        if (G = {
            values: o($d7238066c5de7f1c$var$mS),
            keys: s ? p : o($d7238066c5de7f1c$var$Cz),
            entries: o($d7238066c5de7f1c$var$pz)
        }, a) for(Z in G)($d7238066c5de7f1c$var$pS || l || !(Z in c)) && $d7238066c5de7f1c$var$dz(c, Z, G[Z]);
        else $d7238066c5de7f1c$var$EGe({
            target: e,
            proto: !0,
            forced: $d7238066c5de7f1c$var$pS || l
        }, G);
    }
    return a && c[$d7238066c5de7f1c$var$QX] !== p && $d7238066c5de7f1c$var$dz(c, $d7238066c5de7f1c$var$QX, p, {}), $d7238066c5de7f1c$var$hz[e] = p, G;
}, $d7238066c5de7f1c$var$U4 = function(r, e) {
    return {
        value: r,
        done: e
    };
}, $d7238066c5de7f1c$var$jGe = $d7238066c5de7f1c$var$pf, $d7238066c5de7f1c$var$mz = $d7238066c5de7f1c$var$u0, $d7238066c5de7f1c$var$D4 = $d7238066c5de7f1c$var$dx;
$d7238066c5de7f1c$var$ip.f;
var $d7238066c5de7f1c$var$qGe = $d7238066c5de7f1c$var$J4, $d7238066c5de7f1c$var$AS = $d7238066c5de7f1c$var$U4, $d7238066c5de7f1c$var$_4 = "Array Iterator", $d7238066c5de7f1c$var$$Ge = $d7238066c5de7f1c$var$D4.set, $d7238066c5de7f1c$var$eve = $d7238066c5de7f1c$var$D4.getterFor($d7238066c5de7f1c$var$_4);
$d7238066c5de7f1c$var$qGe(Array, "Array", function(r, e) {
    $d7238066c5de7f1c$var$$Ge(this, {
        type: $d7238066c5de7f1c$var$_4,
        target: $d7238066c5de7f1c$var$jGe(r),
        // target
        index: 0,
        // next index
        kind: e
    });
}, function() {
    var r = $d7238066c5de7f1c$var$eve(this), e = r.target, t = r.index++;
    if (!e || t >= e.length) return r.target = null, $d7238066c5de7f1c$var$AS(void 0, !0);
    switch(r.kind){
        case "keys":
            return $d7238066c5de7f1c$var$AS(t, !1);
        case "values":
            return $d7238066c5de7f1c$var$AS(e[t], !1);
    }
    return $d7238066c5de7f1c$var$AS([
        t,
        e[t]
    ], !1);
}, "values");
$d7238066c5de7f1c$var$mz.Arguments = $d7238066c5de7f1c$var$mz.Array;
var $d7238066c5de7f1c$var$my = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$tve = $d7238066c5de7f1c$var$mf, $d7238066c5de7f1c$var$ive = $d7238066c5de7f1c$var$gV, $d7238066c5de7f1c$var$bS = function(r) {
    return $d7238066c5de7f1c$var$tve.slice(0, r.length) === r;
}, $d7238066c5de7f1c$var$P4 = function() {
    return $d7238066c5de7f1c$var$bS("Bun/") ? "BUN" : $d7238066c5de7f1c$var$bS("Cloudflare-Workers") ? "CLOUDFLARE" : $d7238066c5de7f1c$var$bS("Deno/") ? "DENO" : $d7238066c5de7f1c$var$bS("Node.js/") ? "NODE" : $d7238066c5de7f1c$var$my.Bun && typeof Bun.version == "string" ? "BUN" : $d7238066c5de7f1c$var$my.Deno && typeof Deno.version == "object" ? "DENO" : $d7238066c5de7f1c$var$ive($d7238066c5de7f1c$var$my.process) === "process" ? "NODE" : $d7238066c5de7f1c$var$my.window && $d7238066c5de7f1c$var$my.document ? "BROWSER" : "REST";
}(), $d7238066c5de7f1c$var$nve = $d7238066c5de7f1c$var$P4, $d7238066c5de7f1c$var$Cx = $d7238066c5de7f1c$var$nve === "NODE", $d7238066c5de7f1c$var$sve = $d7238066c5de7f1c$var$ip, $d7238066c5de7f1c$var$rve = function(r, e, t) {
    return $d7238066c5de7f1c$var$sve.f(r, e, t);
}, $d7238066c5de7f1c$var$ave = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$ove = $d7238066c5de7f1c$var$rve, $d7238066c5de7f1c$var$gve = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$lve = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$Az = $d7238066c5de7f1c$var$gve("species"), $d7238066c5de7f1c$var$cve = function(r) {
    var e = $d7238066c5de7f1c$var$ave(r);
    $d7238066c5de7f1c$var$lve && e && !e[$d7238066c5de7f1c$var$Az] && $d7238066c5de7f1c$var$ove(e, $d7238066c5de7f1c$var$Az, {
        configurable: !0,
        get: function() {
            return this;
        }
    });
}, $d7238066c5de7f1c$var$uve = $d7238066c5de7f1c$var$IV, $d7238066c5de7f1c$var$Ive = TypeError, $d7238066c5de7f1c$var$dve = function(r, e) {
    if ($d7238066c5de7f1c$var$uve(e, r)) return r;
    throw new $d7238066c5de7f1c$var$Ive("Incorrect invocation");
}, $d7238066c5de7f1c$var$hve = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$Cve = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$KN = $d7238066c5de7f1c$var$nx, $d7238066c5de7f1c$var$pve = $d7238066c5de7f1c$var$hve(Function.toString);
$d7238066c5de7f1c$var$Cve($d7238066c5de7f1c$var$KN.inspectSource) || ($d7238066c5de7f1c$var$KN.inspectSource = function(r) {
    return $d7238066c5de7f1c$var$pve(r);
});
var $d7238066c5de7f1c$var$Q4 = $d7238066c5de7f1c$var$KN.inspectSource, $d7238066c5de7f1c$var$mve = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$Ave = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$O4 = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$bve = $d7238066c5de7f1c$var$CV, $d7238066c5de7f1c$var$yve = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$Bve = $d7238066c5de7f1c$var$Q4, $d7238066c5de7f1c$var$j4 = function() {}, $d7238066c5de7f1c$var$q4 = $d7238066c5de7f1c$var$yve("Reflect", "construct"), $d7238066c5de7f1c$var$px = /^\s*(?:class|function)\b/, $d7238066c5de7f1c$var$fve = $d7238066c5de7f1c$var$mve($d7238066c5de7f1c$var$px.exec), $d7238066c5de7f1c$var$Gve = !$d7238066c5de7f1c$var$px.test($d7238066c5de7f1c$var$j4), $d7238066c5de7f1c$var$Ay = function(e) {
    if (!$d7238066c5de7f1c$var$O4(e)) return !1;
    try {
        return $d7238066c5de7f1c$var$q4($d7238066c5de7f1c$var$j4, [], e), !0;
    } catch  {
        return !1;
    }
}, $d7238066c5de7f1c$var$$4 = function(e) {
    if (!$d7238066c5de7f1c$var$O4(e)) return !1;
    switch($d7238066c5de7f1c$var$bve(e)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return !1;
    }
    try {
        return $d7238066c5de7f1c$var$Gve || !!$d7238066c5de7f1c$var$fve($d7238066c5de7f1c$var$px, $d7238066c5de7f1c$var$Bve(e));
    } catch  {
        return !0;
    }
};
$d7238066c5de7f1c$var$$4.sham = !0;
var $d7238066c5de7f1c$var$vve = !$d7238066c5de7f1c$var$q4 || $d7238066c5de7f1c$var$Ave(function() {
    var r;
    return $d7238066c5de7f1c$var$Ay($d7238066c5de7f1c$var$Ay.call) || !$d7238066c5de7f1c$var$Ay(Object) || !$d7238066c5de7f1c$var$Ay(function() {
        r = !0;
    }) || r;
}) ? $d7238066c5de7f1c$var$$4 : $d7238066c5de7f1c$var$Ay, $d7238066c5de7f1c$var$Sve = $d7238066c5de7f1c$var$vve, $d7238066c5de7f1c$var$Zve = $d7238066c5de7f1c$var$dV, $d7238066c5de7f1c$var$Rve = TypeError, $d7238066c5de7f1c$var$Vve = function(r) {
    if ($d7238066c5de7f1c$var$Sve(r)) return r;
    throw new $d7238066c5de7f1c$var$Rve($d7238066c5de7f1c$var$Zve(r) + " is not a constructor");
}, $d7238066c5de7f1c$var$bz = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$wve = $d7238066c5de7f1c$var$Vve, $d7238066c5de7f1c$var$Wve = $d7238066c5de7f1c$var$lV, $d7238066c5de7f1c$var$Hve = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$Xve = $d7238066c5de7f1c$var$Hve("species"), $d7238066c5de7f1c$var$eO = function(r, e) {
    var t = $d7238066c5de7f1c$var$bz(r).constructor, i;
    return t === void 0 || $d7238066c5de7f1c$var$Wve(i = $d7238066c5de7f1c$var$bz(t)[$d7238066c5de7f1c$var$Xve]) ? e : $d7238066c5de7f1c$var$wve(i);
}, $d7238066c5de7f1c$var$Nve = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$tO = $d7238066c5de7f1c$var$Nve([].slice), $d7238066c5de7f1c$var$Lve = TypeError, $d7238066c5de7f1c$var$Yve = function(r, e) {
    if (r < e) throw new $d7238066c5de7f1c$var$Lve("Not enough arguments");
    return r;
}, $d7238066c5de7f1c$var$Kve = $d7238066c5de7f1c$var$mf, $d7238066c5de7f1c$var$iO = /(?:ipad|iphone|ipod).*applewebkit/i.test($d7238066c5de7f1c$var$Kve), $d7238066c5de7f1c$var$og = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$xve = $d7238066c5de7f1c$var$ex, $d7238066c5de7f1c$var$Fve = $d7238066c5de7f1c$var$hV, $d7238066c5de7f1c$var$yz = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$Tve = $d7238066c5de7f1c$var$bu, $d7238066c5de7f1c$var$nO = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$Bz = $d7238066c5de7f1c$var$w4, $d7238066c5de7f1c$var$Mve = $d7238066c5de7f1c$var$tO, $d7238066c5de7f1c$var$fz = $d7238066c5de7f1c$var$sx, $d7238066c5de7f1c$var$zve = $d7238066c5de7f1c$var$Yve, $d7238066c5de7f1c$var$kve = $d7238066c5de7f1c$var$iO, $d7238066c5de7f1c$var$Eve = $d7238066c5de7f1c$var$Cx, $d7238066c5de7f1c$var$xN = $d7238066c5de7f1c$var$og.setImmediate, $d7238066c5de7f1c$var$Gz = $d7238066c5de7f1c$var$og.clearImmediate, $d7238066c5de7f1c$var$Jve = $d7238066c5de7f1c$var$og.process, $d7238066c5de7f1c$var$OX = $d7238066c5de7f1c$var$og.Dispatch, $d7238066c5de7f1c$var$Uve = $d7238066c5de7f1c$var$og.Function, $d7238066c5de7f1c$var$vz = $d7238066c5de7f1c$var$og.MessageChannel, $d7238066c5de7f1c$var$Dve = $d7238066c5de7f1c$var$og.String, $d7238066c5de7f1c$var$jX = 0, $d7238066c5de7f1c$var$eB = {}, $d7238066c5de7f1c$var$Sz = "onreadystatechange", $d7238066c5de7f1c$var$xB, $d7238066c5de7f1c$var$GC, $d7238066c5de7f1c$var$qX, $d7238066c5de7f1c$var$$X;
$d7238066c5de7f1c$var$nO(function() {
    $d7238066c5de7f1c$var$xB = $d7238066c5de7f1c$var$og.location;
});
var $d7238066c5de7f1c$var$mx = function(r) {
    if ($d7238066c5de7f1c$var$Tve($d7238066c5de7f1c$var$eB, r)) {
        var e = $d7238066c5de7f1c$var$eB[r];
        delete $d7238066c5de7f1c$var$eB[r], e();
    }
}, $d7238066c5de7f1c$var$e2 = function(r) {
    return function() {
        $d7238066c5de7f1c$var$mx(r);
    };
}, $d7238066c5de7f1c$var$Zz = function(r) {
    $d7238066c5de7f1c$var$mx(r.data);
}, $d7238066c5de7f1c$var$Rz = function(r) {
    $d7238066c5de7f1c$var$og.postMessage($d7238066c5de7f1c$var$Dve(r), $d7238066c5de7f1c$var$xB.protocol + "//" + $d7238066c5de7f1c$var$xB.host);
};
(!$d7238066c5de7f1c$var$xN || !$d7238066c5de7f1c$var$Gz) && ($d7238066c5de7f1c$var$xN = function(e) {
    $d7238066c5de7f1c$var$zve(arguments.length, 1);
    var t = $d7238066c5de7f1c$var$yz(e) ? e : $d7238066c5de7f1c$var$Uve(e), i = $d7238066c5de7f1c$var$Mve(arguments, 1);
    return $d7238066c5de7f1c$var$eB[++$d7238066c5de7f1c$var$jX] = function() {
        $d7238066c5de7f1c$var$xve(t, void 0, i);
    }, $d7238066c5de7f1c$var$GC($d7238066c5de7f1c$var$jX), $d7238066c5de7f1c$var$jX;
}, $d7238066c5de7f1c$var$Gz = function(e) {
    delete $d7238066c5de7f1c$var$eB[e];
}, $d7238066c5de7f1c$var$Eve ? $d7238066c5de7f1c$var$GC = function(r) {
    $d7238066c5de7f1c$var$Jve.nextTick($d7238066c5de7f1c$var$e2(r));
} : $d7238066c5de7f1c$var$OX && $d7238066c5de7f1c$var$OX.now ? $d7238066c5de7f1c$var$GC = function(r) {
    $d7238066c5de7f1c$var$OX.now($d7238066c5de7f1c$var$e2(r));
} : $d7238066c5de7f1c$var$vz && !$d7238066c5de7f1c$var$kve ? ($d7238066c5de7f1c$var$qX = new $d7238066c5de7f1c$var$vz(), $d7238066c5de7f1c$var$$X = $d7238066c5de7f1c$var$qX.port2, $d7238066c5de7f1c$var$qX.port1.onmessage = $d7238066c5de7f1c$var$Zz, $d7238066c5de7f1c$var$GC = $d7238066c5de7f1c$var$Fve($d7238066c5de7f1c$var$$X.postMessage, $d7238066c5de7f1c$var$$X)) : $d7238066c5de7f1c$var$og.addEventListener && $d7238066c5de7f1c$var$yz($d7238066c5de7f1c$var$og.postMessage) && !$d7238066c5de7f1c$var$og.importScripts && $d7238066c5de7f1c$var$xB && $d7238066c5de7f1c$var$xB.protocol !== "file:" && !$d7238066c5de7f1c$var$nO($d7238066c5de7f1c$var$Rz) ? ($d7238066c5de7f1c$var$GC = $d7238066c5de7f1c$var$Rz, $d7238066c5de7f1c$var$og.addEventListener("message", $d7238066c5de7f1c$var$Zz, !1)) : $d7238066c5de7f1c$var$Sz in $d7238066c5de7f1c$var$fz("script") ? $d7238066c5de7f1c$var$GC = function(r) {
    $d7238066c5de7f1c$var$Bz.appendChild($d7238066c5de7f1c$var$fz("script"))[$d7238066c5de7f1c$var$Sz] = function() {
        $d7238066c5de7f1c$var$Bz.removeChild(this), $d7238066c5de7f1c$var$mx(r);
    };
} : $d7238066c5de7f1c$var$GC = function(r) {
    setTimeout($d7238066c5de7f1c$var$e2(r), 0);
});
var $d7238066c5de7f1c$var$sO = {
    set: $d7238066c5de7f1c$var$xN
}, $d7238066c5de7f1c$var$Vz = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$_ve = $d7238066c5de7f1c$var$KI, $d7238066c5de7f1c$var$Pve = Object.getOwnPropertyDescriptor, $d7238066c5de7f1c$var$Qve = function(r) {
    if (!$d7238066c5de7f1c$var$_ve) return $d7238066c5de7f1c$var$Vz[r];
    var e = $d7238066c5de7f1c$var$Pve($d7238066c5de7f1c$var$Vz, r);
    return e && e.value;
}, $d7238066c5de7f1c$var$rO = function() {
    this.head = null, this.tail = null;
};
$d7238066c5de7f1c$var$rO.prototype = {
    add: function(r) {
        var e = {
            item: r,
            next: null
        }, t = this.tail;
        t ? t.next = e : this.head = e, this.tail = e;
    },
    get: function() {
        var r = this.head;
        if (r) {
            var e = this.head = r.next;
            return e === null && (this.tail = null), r.item;
        }
    }
};
var $d7238066c5de7f1c$var$aO = $d7238066c5de7f1c$var$rO, $d7238066c5de7f1c$var$Ove = $d7238066c5de7f1c$var$mf, $d7238066c5de7f1c$var$jve = /ipad|iphone|ipod/i.test($d7238066c5de7f1c$var$Ove) && typeof Pebble < "u", $d7238066c5de7f1c$var$qve = $d7238066c5de7f1c$var$mf, $d7238066c5de7f1c$var$$ve = /web0s(?!.*chrome)/i.test($d7238066c5de7f1c$var$qve), $d7238066c5de7f1c$var$e0 = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$eSe = $d7238066c5de7f1c$var$Qve, $d7238066c5de7f1c$var$wz = $d7238066c5de7f1c$var$hV, $d7238066c5de7f1c$var$t2 = $d7238066c5de7f1c$var$sO.set, $d7238066c5de7f1c$var$tSe = $d7238066c5de7f1c$var$aO, $d7238066c5de7f1c$var$iSe = $d7238066c5de7f1c$var$iO, $d7238066c5de7f1c$var$nSe = $d7238066c5de7f1c$var$jve, $d7238066c5de7f1c$var$sSe = $d7238066c5de7f1c$var$$ve, $d7238066c5de7f1c$var$i2 = $d7238066c5de7f1c$var$Cx, $d7238066c5de7f1c$var$Wz = $d7238066c5de7f1c$var$e0.MutationObserver || $d7238066c5de7f1c$var$e0.WebKitMutationObserver, $d7238066c5de7f1c$var$Hz = $d7238066c5de7f1c$var$e0.document, $d7238066c5de7f1c$var$Xz = $d7238066c5de7f1c$var$e0.process, $d7238066c5de7f1c$var$yS = $d7238066c5de7f1c$var$e0.Promise, $d7238066c5de7f1c$var$FN = $d7238066c5de7f1c$var$eSe("queueMicrotask"), $d7238066c5de7f1c$var$iA, $d7238066c5de7f1c$var$n2, $d7238066c5de7f1c$var$s2, $d7238066c5de7f1c$var$BS, $d7238066c5de7f1c$var$Nz;
if (!$d7238066c5de7f1c$var$FN) {
    var $d7238066c5de7f1c$var$fS = new $d7238066c5de7f1c$var$tSe(), $d7238066c5de7f1c$var$GS = function() {
        var r, e;
        for($d7238066c5de7f1c$var$i2 && (r = $d7238066c5de7f1c$var$Xz.domain) && r.exit(); e = $d7238066c5de7f1c$var$fS.get();)try {
            e();
        } catch (t) {
            throw $d7238066c5de7f1c$var$fS.head && $d7238066c5de7f1c$var$iA(), t;
        }
        r && r.enter();
    };
    !$d7238066c5de7f1c$var$iSe && !$d7238066c5de7f1c$var$i2 && !$d7238066c5de7f1c$var$sSe && $d7238066c5de7f1c$var$Wz && $d7238066c5de7f1c$var$Hz ? ($d7238066c5de7f1c$var$n2 = !0, $d7238066c5de7f1c$var$s2 = $d7238066c5de7f1c$var$Hz.createTextNode(""), new $d7238066c5de7f1c$var$Wz($d7238066c5de7f1c$var$GS).observe($d7238066c5de7f1c$var$s2, {
        characterData: !0
    }), $d7238066c5de7f1c$var$iA = function() {
        $d7238066c5de7f1c$var$s2.data = $d7238066c5de7f1c$var$n2 = !$d7238066c5de7f1c$var$n2;
    }) : !$d7238066c5de7f1c$var$nSe && $d7238066c5de7f1c$var$yS && $d7238066c5de7f1c$var$yS.resolve ? ($d7238066c5de7f1c$var$BS = $d7238066c5de7f1c$var$yS.resolve(void 0), $d7238066c5de7f1c$var$BS.constructor = $d7238066c5de7f1c$var$yS, $d7238066c5de7f1c$var$Nz = $d7238066c5de7f1c$var$wz($d7238066c5de7f1c$var$BS.then, $d7238066c5de7f1c$var$BS), $d7238066c5de7f1c$var$iA = function() {
        $d7238066c5de7f1c$var$Nz($d7238066c5de7f1c$var$GS);
    }) : $d7238066c5de7f1c$var$i2 ? $d7238066c5de7f1c$var$iA = function() {
        $d7238066c5de7f1c$var$Xz.nextTick($d7238066c5de7f1c$var$GS);
    } : ($d7238066c5de7f1c$var$t2 = $d7238066c5de7f1c$var$wz($d7238066c5de7f1c$var$t2, $d7238066c5de7f1c$var$e0), $d7238066c5de7f1c$var$iA = function() {
        $d7238066c5de7f1c$var$t2($d7238066c5de7f1c$var$GS);
    }), $d7238066c5de7f1c$var$FN = function(r) {
        $d7238066c5de7f1c$var$fS.head || $d7238066c5de7f1c$var$iA(), $d7238066c5de7f1c$var$fS.add(r);
    };
}
var $d7238066c5de7f1c$var$rSe = $d7238066c5de7f1c$var$FN, $d7238066c5de7f1c$var$aSe = function(r, e) {
    try {
        arguments.length === 1 ? console.error(r) : console.error(r, e);
    } catch  {}
}, $d7238066c5de7f1c$var$I0 = function(r) {
    try {
        return {
            error: !1,
            value: r()
        };
    } catch (e) {
        return {
            error: !0,
            value: e
        };
    }
}, $d7238066c5de7f1c$var$oSe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$d0 = $d7238066c5de7f1c$var$oSe.Promise, $d7238066c5de7f1c$var$gSe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$tB = $d7238066c5de7f1c$var$d0, $d7238066c5de7f1c$var$lSe = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$cSe = $d7238066c5de7f1c$var$f4, $d7238066c5de7f1c$var$uSe = $d7238066c5de7f1c$var$Q4, $d7238066c5de7f1c$var$ISe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$Lz = $d7238066c5de7f1c$var$P4, $d7238066c5de7f1c$var$r2 = $d7238066c5de7f1c$var$I4, $d7238066c5de7f1c$var$Yz = $d7238066c5de7f1c$var$tB && $d7238066c5de7f1c$var$tB.prototype, $d7238066c5de7f1c$var$dSe = $d7238066c5de7f1c$var$ISe("species"), $d7238066c5de7f1c$var$TN = !1, $d7238066c5de7f1c$var$oO = $d7238066c5de7f1c$var$lSe($d7238066c5de7f1c$var$gSe.PromiseRejectionEvent), $d7238066c5de7f1c$var$hSe = $d7238066c5de7f1c$var$cSe("Promise", function() {
    var r = $d7238066c5de7f1c$var$uSe($d7238066c5de7f1c$var$tB), e = r !== String($d7238066c5de7f1c$var$tB);
    if (!e && $d7238066c5de7f1c$var$r2 === 66 || !($d7238066c5de7f1c$var$Yz.catch && $d7238066c5de7f1c$var$Yz.finally)) return !0;
    if (!$d7238066c5de7f1c$var$r2 || $d7238066c5de7f1c$var$r2 < 51 || !/native code/.test(r)) {
        var t = new $d7238066c5de7f1c$var$tB(function(s) {
            s(1);
        }), i = function(s) {
            s(function() {}, function() {});
        }, n = t.constructor = {};
        if (n[$d7238066c5de7f1c$var$dSe] = i, $d7238066c5de7f1c$var$TN = t.then(function() {}) instanceof i, !$d7238066c5de7f1c$var$TN) return !0;
    }
    return !e && ($d7238066c5de7f1c$var$Lz === "BROWSER" || $d7238066c5de7f1c$var$Lz === "DENO") && !$d7238066c5de7f1c$var$oO;
}), $d7238066c5de7f1c$var$yf = {
    CONSTRUCTOR: $d7238066c5de7f1c$var$hSe,
    REJECTION_EVENT: $d7238066c5de7f1c$var$oO,
    SUBCLASSING: $d7238066c5de7f1c$var$TN
}, $d7238066c5de7f1c$var$yu = {}, $d7238066c5de7f1c$var$Kz = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$CSe = TypeError, $d7238066c5de7f1c$var$pSe = function(r) {
    var e, t;
    this.promise = new r(function(i, n) {
        if (e !== void 0 || t !== void 0) throw new $d7238066c5de7f1c$var$CSe("Bad Promise constructor");
        e = i, t = n;
    }), this.resolve = $d7238066c5de7f1c$var$Kz(e), this.reject = $d7238066c5de7f1c$var$Kz(t);
};
$d7238066c5de7f1c$var$yu.f = function(r) {
    return new $d7238066c5de7f1c$var$pSe(r);
};
var $d7238066c5de7f1c$var$mSe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$tR = $d7238066c5de7f1c$var$Cx, $d7238066c5de7f1c$var$ch = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$ASe = $d7238066c5de7f1c$var$uV, $d7238066c5de7f1c$var$Bf = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$bSe = $d7238066c5de7f1c$var$hx, $d7238066c5de7f1c$var$ySe = $d7238066c5de7f1c$var$pV, $d7238066c5de7f1c$var$BSe = $d7238066c5de7f1c$var$cve, $d7238066c5de7f1c$var$fSe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$MN = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$GSe = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$vSe = $d7238066c5de7f1c$var$dve, $d7238066c5de7f1c$var$SSe = $d7238066c5de7f1c$var$eO, $d7238066c5de7f1c$var$gO = $d7238066c5de7f1c$var$sO.set, $d7238066c5de7f1c$var$Ax = $d7238066c5de7f1c$var$rSe, $d7238066c5de7f1c$var$ZSe = $d7238066c5de7f1c$var$aSe, $d7238066c5de7f1c$var$RSe = $d7238066c5de7f1c$var$I0, $d7238066c5de7f1c$var$VSe = $d7238066c5de7f1c$var$aO, $d7238066c5de7f1c$var$lO = $d7238066c5de7f1c$var$dx, $d7238066c5de7f1c$var$zN = $d7238066c5de7f1c$var$d0, $d7238066c5de7f1c$var$bx = $d7238066c5de7f1c$var$yf, $d7238066c5de7f1c$var$cO = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$mV = "Promise", $d7238066c5de7f1c$var$uO = $d7238066c5de7f1c$var$bx.CONSTRUCTOR, $d7238066c5de7f1c$var$wSe = $d7238066c5de7f1c$var$bx.REJECTION_EVENT;
$d7238066c5de7f1c$var$bx.SUBCLASSING;
var $d7238066c5de7f1c$var$a2 = $d7238066c5de7f1c$var$lO.getterFor($d7238066c5de7f1c$var$mV), $d7238066c5de7f1c$var$WSe = $d7238066c5de7f1c$var$lO.set, $d7238066c5de7f1c$var$HSe = $d7238066c5de7f1c$var$zN && $d7238066c5de7f1c$var$zN.prototype, $d7238066c5de7f1c$var$bA = $d7238066c5de7f1c$var$zN, $d7238066c5de7f1c$var$o2 = $d7238066c5de7f1c$var$HSe, $d7238066c5de7f1c$var$IO = $d7238066c5de7f1c$var$ch.TypeError, $d7238066c5de7f1c$var$kN = $d7238066c5de7f1c$var$ch.document, $d7238066c5de7f1c$var$yx = $d7238066c5de7f1c$var$ch.process, $d7238066c5de7f1c$var$EN = $d7238066c5de7f1c$var$cO.f, $d7238066c5de7f1c$var$XSe = $d7238066c5de7f1c$var$EN, $d7238066c5de7f1c$var$NSe = !!($d7238066c5de7f1c$var$kN && $d7238066c5de7f1c$var$kN.createEvent && $d7238066c5de7f1c$var$ch.dispatchEvent), $d7238066c5de7f1c$var$dO = "unhandledrejection", $d7238066c5de7f1c$var$LSe = "rejectionhandled", $d7238066c5de7f1c$var$xz = 0, $d7238066c5de7f1c$var$hO = 1, $d7238066c5de7f1c$var$YSe = 2, $d7238066c5de7f1c$var$Bx = 1, $d7238066c5de7f1c$var$CO = 2, $d7238066c5de7f1c$var$vS, $d7238066c5de7f1c$var$Fz, $d7238066c5de7f1c$var$pO, $d7238066c5de7f1c$var$mO = function(r) {
    var e;
    return $d7238066c5de7f1c$var$GSe(r) && $d7238066c5de7f1c$var$MN(e = r.then) ? e : !1;
}, $d7238066c5de7f1c$var$AO = function(r, e) {
    var t = e.value, i = e.state === $d7238066c5de7f1c$var$hO, n = i ? r.ok : r.fail, s = r.resolve, a = r.reject, o = r.domain, g, l, c;
    try {
        n ? (i || (e.rejection === $d7238066c5de7f1c$var$CO && $d7238066c5de7f1c$var$xSe(e), e.rejection = $d7238066c5de7f1c$var$Bx), n === !0 ? g = t : (o && o.enter(), g = n(t), o && (o.exit(), c = !0)), g === r.promise ? a(new $d7238066c5de7f1c$var$IO("Promise-chain cycle")) : (l = $d7238066c5de7f1c$var$mO(g)) ? $d7238066c5de7f1c$var$Bf(l, g, s, a) : s(g)) : a(t);
    } catch (d) {
        o && !c && o.exit(), a(d);
    }
}, $d7238066c5de7f1c$var$bO = function(r, e) {
    r.notified || (r.notified = !0, $d7238066c5de7f1c$var$Ax(function() {
        for(var t = r.reactions, i; i = t.get();)$d7238066c5de7f1c$var$AO(i, r);
        r.notified = !1, e && !r.rejection && $d7238066c5de7f1c$var$KSe(r);
    }));
}, $d7238066c5de7f1c$var$yO = function(r, e, t) {
    var i, n;
    $d7238066c5de7f1c$var$NSe ? (i = $d7238066c5de7f1c$var$kN.createEvent("Event"), i.promise = e, i.reason = t, i.initEvent(r, !1, !0), $d7238066c5de7f1c$var$ch.dispatchEvent(i)) : i = {
        promise: e,
        reason: t
    }, !$d7238066c5de7f1c$var$wSe && (n = $d7238066c5de7f1c$var$ch["on" + r]) ? n(i) : r === $d7238066c5de7f1c$var$dO && $d7238066c5de7f1c$var$ZSe("Unhandled promise rejection", t);
}, $d7238066c5de7f1c$var$KSe = function(r) {
    $d7238066c5de7f1c$var$Bf($d7238066c5de7f1c$var$gO, $d7238066c5de7f1c$var$ch, function() {
        var e = r.facade, t = r.value, i = $d7238066c5de7f1c$var$Tz(r), n;
        if (i && (n = $d7238066c5de7f1c$var$RSe(function() {
            $d7238066c5de7f1c$var$tR ? $d7238066c5de7f1c$var$yx.emit("unhandledRejection", t, e) : $d7238066c5de7f1c$var$yO($d7238066c5de7f1c$var$dO, e, t);
        }), r.rejection = $d7238066c5de7f1c$var$tR || $d7238066c5de7f1c$var$Tz(r) ? $d7238066c5de7f1c$var$CO : $d7238066c5de7f1c$var$Bx, n.error)) throw n.value;
    });
}, $d7238066c5de7f1c$var$Tz = function(r) {
    return r.rejection !== $d7238066c5de7f1c$var$Bx && !r.parent;
}, $d7238066c5de7f1c$var$xSe = function(r) {
    $d7238066c5de7f1c$var$Bf($d7238066c5de7f1c$var$gO, $d7238066c5de7f1c$var$ch, function() {
        var e = r.facade;
        $d7238066c5de7f1c$var$tR ? $d7238066c5de7f1c$var$yx.emit("rejectionHandled", e) : $d7238066c5de7f1c$var$yO($d7238066c5de7f1c$var$LSe, e, r.value);
    });
}, $d7238066c5de7f1c$var$yA = function(r, e, t) {
    return function(i) {
        r(e, i, t);
    };
}, $d7238066c5de7f1c$var$LA = function(r, e, t) {
    r.done || (r.done = !0, t && (r = t), r.value = e, r.state = $d7238066c5de7f1c$var$YSe, $d7238066c5de7f1c$var$bO(r, !0));
}, $d7238066c5de7f1c$var$JN = function(r, e, t) {
    if (!r.done) {
        r.done = !0, t && (r = t);
        try {
            if (r.facade === e) throw new $d7238066c5de7f1c$var$IO("Promise can't be resolved itself");
            var i = $d7238066c5de7f1c$var$mO(e);
            i ? $d7238066c5de7f1c$var$Ax(function() {
                var n = {
                    done: !1
                };
                try {
                    $d7238066c5de7f1c$var$Bf(i, e, $d7238066c5de7f1c$var$yA($d7238066c5de7f1c$var$JN, n, r), $d7238066c5de7f1c$var$yA($d7238066c5de7f1c$var$LA, n, r));
                } catch (s) {
                    $d7238066c5de7f1c$var$LA(n, s, r);
                }
            }) : (r.value = e, r.state = $d7238066c5de7f1c$var$hO, $d7238066c5de7f1c$var$bO(r, !1));
        } catch (n) {
            $d7238066c5de7f1c$var$LA({
                done: !1
            }, n, r);
        }
    }
};
$d7238066c5de7f1c$var$uO && ($d7238066c5de7f1c$var$bA = function(e) {
    $d7238066c5de7f1c$var$vSe(this, $d7238066c5de7f1c$var$o2), $d7238066c5de7f1c$var$fSe(e), $d7238066c5de7f1c$var$Bf($d7238066c5de7f1c$var$vS, this);
    var t = $d7238066c5de7f1c$var$a2(this);
    try {
        e($d7238066c5de7f1c$var$yA($d7238066c5de7f1c$var$JN, t), $d7238066c5de7f1c$var$yA($d7238066c5de7f1c$var$LA, t));
    } catch (i) {
        $d7238066c5de7f1c$var$LA(t, i);
    }
}, $d7238066c5de7f1c$var$o2 = $d7238066c5de7f1c$var$bA.prototype, $d7238066c5de7f1c$var$vS = function(e) {
    $d7238066c5de7f1c$var$WSe(this, {
        type: $d7238066c5de7f1c$var$mV,
        done: !1,
        notified: !1,
        parent: !1,
        reactions: new $d7238066c5de7f1c$var$VSe(),
        rejection: !1,
        state: $d7238066c5de7f1c$var$xz,
        value: null
    });
}, $d7238066c5de7f1c$var$vS.prototype = $d7238066c5de7f1c$var$bSe($d7238066c5de7f1c$var$o2, "then", function(e, t) {
    var i = $d7238066c5de7f1c$var$a2(this), n = $d7238066c5de7f1c$var$EN($d7238066c5de7f1c$var$SSe(this, $d7238066c5de7f1c$var$bA));
    return i.parent = !0, n.ok = $d7238066c5de7f1c$var$MN(e) ? e : !0, n.fail = $d7238066c5de7f1c$var$MN(t) && t, n.domain = $d7238066c5de7f1c$var$tR ? $d7238066c5de7f1c$var$yx.domain : void 0, i.state === $d7238066c5de7f1c$var$xz ? i.reactions.add(n) : $d7238066c5de7f1c$var$Ax(function() {
        $d7238066c5de7f1c$var$AO(n, i);
    }), n.promise;
}), $d7238066c5de7f1c$var$Fz = function() {
    var r = new $d7238066c5de7f1c$var$vS(), e = $d7238066c5de7f1c$var$a2(r);
    this.promise = r, this.resolve = $d7238066c5de7f1c$var$yA($d7238066c5de7f1c$var$JN, e), this.reject = $d7238066c5de7f1c$var$yA($d7238066c5de7f1c$var$LA, e);
}, $d7238066c5de7f1c$var$cO.f = $d7238066c5de7f1c$var$EN = function(r) {
    return r === $d7238066c5de7f1c$var$bA || r === $d7238066c5de7f1c$var$pO ? new $d7238066c5de7f1c$var$Fz(r) : $d7238066c5de7f1c$var$XSe(r);
});
$d7238066c5de7f1c$var$mSe({
    global: !0,
    wrap: !0,
    forced: $d7238066c5de7f1c$var$uO
}, {
    Promise: $d7238066c5de7f1c$var$bA
});
$d7238066c5de7f1c$var$pO = $d7238066c5de7f1c$var$ASe.Promise;
$d7238066c5de7f1c$var$ySe($d7238066c5de7f1c$var$bA, $d7238066c5de7f1c$var$mV, !1, !0);
$d7238066c5de7f1c$var$BSe($d7238066c5de7f1c$var$mV);
var $d7238066c5de7f1c$var$FSe = $d7238066c5de7f1c$var$dg, $d7238066c5de7f1c$var$BO = $d7238066c5de7f1c$var$FSe("iterator"), $d7238066c5de7f1c$var$fO = !1;
try {
    var $d7238066c5de7f1c$var$TSe = 0, $d7238066c5de7f1c$var$Mz = {
        next: function() {
            return {
                done: !!$d7238066c5de7f1c$var$TSe++
            };
        },
        return: function() {
            $d7238066c5de7f1c$var$fO = !0;
        }
    };
    $d7238066c5de7f1c$var$Mz[$d7238066c5de7f1c$var$BO] = function() {
        return this;
    }, Array.from($d7238066c5de7f1c$var$Mz, function() {
        throw 2;
    });
} catch  {}
var $d7238066c5de7f1c$var$MSe = function(r, e) {
    try {
        if (!e && !$d7238066c5de7f1c$var$fO) return !1;
    } catch  {
        return !1;
    }
    var t = !1;
    try {
        var i = {};
        i[$d7238066c5de7f1c$var$BO] = function() {
            return {
                next: function() {
                    return {
                        done: t = !0
                    };
                }
            };
        }, r(i);
    } catch  {}
    return t;
}, $d7238066c5de7f1c$var$zSe = $d7238066c5de7f1c$var$d0, $d7238066c5de7f1c$var$kSe = $d7238066c5de7f1c$var$MSe, $d7238066c5de7f1c$var$ESe = $d7238066c5de7f1c$var$yf.CONSTRUCTOR, $d7238066c5de7f1c$var$AV = $d7238066c5de7f1c$var$ESe || !$d7238066c5de7f1c$var$kSe(function(r) {
    $d7238066c5de7f1c$var$zSe.all(r).then(void 0, function() {});
}), $d7238066c5de7f1c$var$JSe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$USe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$DSe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$_Se = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$PSe = $d7238066c5de7f1c$var$I0, $d7238066c5de7f1c$var$QSe = $d7238066c5de7f1c$var$bf, $d7238066c5de7f1c$var$OSe = $d7238066c5de7f1c$var$AV;
$d7238066c5de7f1c$var$JSe({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$OSe
}, {
    all: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$_Se.f(t), n = i.resolve, s = i.reject, a = $d7238066c5de7f1c$var$PSe(function() {
            var o = $d7238066c5de7f1c$var$DSe(t.resolve), g = [], l = 0, c = 1;
            $d7238066c5de7f1c$var$QSe(e, function(d) {
                var p = l++, A = !1;
                c++, $d7238066c5de7f1c$var$USe(o, t, d).then(function(y) {
                    A || (A = !0, g[p] = y, --c || n(g));
                }, s);
            }), --c || n(g);
        });
        return a.error && s(a.value), i.promise;
    }
});
var $d7238066c5de7f1c$var$jSe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$qSe = $d7238066c5de7f1c$var$yf.CONSTRUCTOR, $d7238066c5de7f1c$var$zz = $d7238066c5de7f1c$var$d0;
$d7238066c5de7f1c$var$zz && $d7238066c5de7f1c$var$zz.prototype;
$d7238066c5de7f1c$var$jSe({
    target: "Promise",
    proto: !0,
    forced: $d7238066c5de7f1c$var$qSe,
    real: !0
}, {
    catch: function(r) {
        return this.then(void 0, r);
    }
});
var $d7238066c5de7f1c$var$$Se = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$eZe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$tZe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$iZe = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$nZe = $d7238066c5de7f1c$var$I0, $d7238066c5de7f1c$var$sZe = $d7238066c5de7f1c$var$bf, $d7238066c5de7f1c$var$rZe = $d7238066c5de7f1c$var$AV;
$d7238066c5de7f1c$var$$Se({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$rZe
}, {
    race: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$iZe.f(t), n = i.reject, s = $d7238066c5de7f1c$var$nZe(function() {
            var a = $d7238066c5de7f1c$var$tZe(t.resolve);
            $d7238066c5de7f1c$var$sZe(e, function(o) {
                $d7238066c5de7f1c$var$eZe(a, t, o).then(i.resolve, n);
            });
        });
        return s.error && n(s.value), i.promise;
    }
});
var $d7238066c5de7f1c$var$aZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$oZe = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$gZe = $d7238066c5de7f1c$var$yf.CONSTRUCTOR;
$d7238066c5de7f1c$var$aZe({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$gZe
}, {
    reject: function(e) {
        var t = $d7238066c5de7f1c$var$oZe.f(this), i = t.reject;
        return i(e), t.promise;
    }
});
var $d7238066c5de7f1c$var$lZe = $d7238066c5de7f1c$var$xI, $d7238066c5de7f1c$var$cZe = $d7238066c5de7f1c$var$ac, $d7238066c5de7f1c$var$uZe = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$GO = function(r, e) {
    if ($d7238066c5de7f1c$var$lZe(r), $d7238066c5de7f1c$var$cZe(e) && e.constructor === r) return e;
    var t = $d7238066c5de7f1c$var$uZe.f(r), i = t.resolve;
    return i(e), t.promise;
}, $d7238066c5de7f1c$var$IZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$dZe = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$hZe = $d7238066c5de7f1c$var$nbe, $d7238066c5de7f1c$var$CZe = $d7238066c5de7f1c$var$d0, $d7238066c5de7f1c$var$pZe = $d7238066c5de7f1c$var$yf.CONSTRUCTOR, $d7238066c5de7f1c$var$mZe = $d7238066c5de7f1c$var$GO, $d7238066c5de7f1c$var$AZe = $d7238066c5de7f1c$var$dZe("Promise"), $d7238066c5de7f1c$var$bZe = !$d7238066c5de7f1c$var$pZe;
$d7238066c5de7f1c$var$IZe({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$hZe
}, {
    resolve: function(e) {
        return $d7238066c5de7f1c$var$mZe($d7238066c5de7f1c$var$bZe && this === $d7238066c5de7f1c$var$AZe ? $d7238066c5de7f1c$var$CZe : this, e);
    }
});
var $d7238066c5de7f1c$var$yZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$BZe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$fZe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$GZe = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$vZe = $d7238066c5de7f1c$var$I0, $d7238066c5de7f1c$var$SZe = $d7238066c5de7f1c$var$bf, $d7238066c5de7f1c$var$ZZe = $d7238066c5de7f1c$var$AV;
$d7238066c5de7f1c$var$yZe({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$ZZe
}, {
    allSettled: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$GZe.f(t), n = i.resolve, s = i.reject, a = $d7238066c5de7f1c$var$vZe(function() {
            var o = $d7238066c5de7f1c$var$fZe(t.resolve), g = [], l = 0, c = 1;
            $d7238066c5de7f1c$var$SZe(e, function(d) {
                var p = l++, A = !1;
                c++, $d7238066c5de7f1c$var$BZe(o, t, d).then(function(y) {
                    A || (A = !0, g[p] = {
                        status: "fulfilled",
                        value: y
                    }, --c || n(g));
                }, function(y) {
                    A || (A = !0, g[p] = {
                        status: "rejected",
                        reason: y
                    }, --c || n(g));
                });
            }), --c || n(g);
        });
        return a.error && s(a.value), i.promise;
    }
});
var $d7238066c5de7f1c$var$RZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$VZe = $d7238066c5de7f1c$var$cl, $d7238066c5de7f1c$var$wZe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$WZe = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$HZe = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$XZe = $d7238066c5de7f1c$var$I0, $d7238066c5de7f1c$var$NZe = $d7238066c5de7f1c$var$bf, $d7238066c5de7f1c$var$LZe = $d7238066c5de7f1c$var$AV, $d7238066c5de7f1c$var$kz = "No one promise resolved";
$d7238066c5de7f1c$var$RZe({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$LZe
}, {
    any: function(e) {
        var t = this, i = $d7238066c5de7f1c$var$WZe("AggregateError"), n = $d7238066c5de7f1c$var$HZe.f(t), s = n.resolve, a = n.reject, o = $d7238066c5de7f1c$var$XZe(function() {
            var g = $d7238066c5de7f1c$var$wZe(t.resolve), l = [], c = 0, d = 1, p = !1;
            $d7238066c5de7f1c$var$NZe(e, function(A) {
                var y = c++, G = !1;
                d++, $d7238066c5de7f1c$var$VZe(g, t, A).then(function(Z) {
                    G || p || (p = !0, s(Z));
                }, function(Z) {
                    G || p || (G = !0, l[y] = Z, --d || a(new i(l, $d7238066c5de7f1c$var$kz)));
                });
            }), --d || a(new i(l, $d7238066c5de7f1c$var$kz));
        });
        return o.error && a(o.value), n.promise;
    }
});
var $d7238066c5de7f1c$var$YZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$KZe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$xZe = $d7238066c5de7f1c$var$ex, $d7238066c5de7f1c$var$FZe = $d7238066c5de7f1c$var$tO, $d7238066c5de7f1c$var$TZe = $d7238066c5de7f1c$var$yu, $d7238066c5de7f1c$var$MZe = $d7238066c5de7f1c$var$oc, $d7238066c5de7f1c$var$vO = $d7238066c5de7f1c$var$I0, $d7238066c5de7f1c$var$g2 = $d7238066c5de7f1c$var$KZe.Promise, $d7238066c5de7f1c$var$Ez = !1, $d7238066c5de7f1c$var$zZe = !$d7238066c5de7f1c$var$g2 || !$d7238066c5de7f1c$var$g2.try || $d7238066c5de7f1c$var$vO(function() {
    $d7238066c5de7f1c$var$g2.try(function(r) {
        $d7238066c5de7f1c$var$Ez = r === 8;
    }, 8);
}).error || !$d7238066c5de7f1c$var$Ez;
$d7238066c5de7f1c$var$YZe({
    target: "Promise",
    stat: !0,
    forced: $d7238066c5de7f1c$var$zZe
}, {
    try: function(r) {
        var e = arguments.length > 1 ? $d7238066c5de7f1c$var$FZe(arguments, 1) : [], t = $d7238066c5de7f1c$var$TZe.f(this), i = $d7238066c5de7f1c$var$vO(function() {
            return $d7238066c5de7f1c$var$xZe($d7238066c5de7f1c$var$MZe(r), void 0, e);
        });
        return (i.error ? t.reject : t.resolve)(i.value), t.promise;
    }
});
var $d7238066c5de7f1c$var$kZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$EZe = $d7238066c5de7f1c$var$yu;
$d7238066c5de7f1c$var$kZe({
    target: "Promise",
    stat: !0
}, {
    withResolvers: function() {
        var e = $d7238066c5de7f1c$var$EZe.f(this);
        return {
            promise: e.promise,
            resolve: e.resolve,
            reject: e.reject
        };
    }
});
var $d7238066c5de7f1c$var$JZe = $d7238066c5de7f1c$var$hg, $d7238066c5de7f1c$var$UN = $d7238066c5de7f1c$var$d0, $d7238066c5de7f1c$var$UZe = $d7238066c5de7f1c$var$Ig, $d7238066c5de7f1c$var$DZe = $d7238066c5de7f1c$var$Ch, $d7238066c5de7f1c$var$_Ze = $d7238066c5de7f1c$var$ma, $d7238066c5de7f1c$var$PZe = $d7238066c5de7f1c$var$eO, $d7238066c5de7f1c$var$Jz = $d7238066c5de7f1c$var$GO, $d7238066c5de7f1c$var$QZe = $d7238066c5de7f1c$var$UN && $d7238066c5de7f1c$var$UN.prototype, $d7238066c5de7f1c$var$OZe = !!$d7238066c5de7f1c$var$UN && $d7238066c5de7f1c$var$UZe(function() {
    $d7238066c5de7f1c$var$QZe.finally.call({
        then: function() {}
    }, function() {});
});
$d7238066c5de7f1c$var$JZe({
    target: "Promise",
    proto: !0,
    real: !0,
    forced: $d7238066c5de7f1c$var$OZe
}, {
    finally: function(r) {
        var e = $d7238066c5de7f1c$var$PZe(this, $d7238066c5de7f1c$var$DZe("Promise")), t = $d7238066c5de7f1c$var$_Ze(r);
        return this.then(t ? function(i) {
            return $d7238066c5de7f1c$var$Jz(e, r()).then(function() {
                return i;
            });
        } : r, t ? function(i) {
            return $d7238066c5de7f1c$var$Jz(e, r()).then(function() {
                throw i;
            });
        } : r);
    }
});
var $d7238066c5de7f1c$var$fx = $d7238066c5de7f1c$var$Yo, $d7238066c5de7f1c$var$jZe = $d7238066c5de7f1c$var$ox, $d7238066c5de7f1c$var$qZe = $d7238066c5de7f1c$var$Ix, $d7238066c5de7f1c$var$$Ze = $d7238066c5de7f1c$var$cV, $d7238066c5de7f1c$var$eRe = $d7238066c5de7f1c$var$fx("".charAt), $d7238066c5de7f1c$var$Uz = $d7238066c5de7f1c$var$fx("".charCodeAt), $d7238066c5de7f1c$var$tRe = $d7238066c5de7f1c$var$fx("".slice), $d7238066c5de7f1c$var$iRe = function(r) {
    return function(e, t) {
        var i = $d7238066c5de7f1c$var$qZe($d7238066c5de7f1c$var$$Ze(e)), n = $d7238066c5de7f1c$var$jZe(t), s = i.length, a, o;
        return n < 0 || n >= s ? r ? "" : void 0 : (a = $d7238066c5de7f1c$var$Uz(i, n), a < 55296 || a > 56319 || n + 1 === s || (o = $d7238066c5de7f1c$var$Uz(i, n + 1)) < 56320 || o > 57343 ? r ? $d7238066c5de7f1c$var$eRe(i, n) : a : r ? $d7238066c5de7f1c$var$tRe(i, n, n + 2) : (a - 55296 << 10) + (o - 56320) + 65536);
    };
}, $d7238066c5de7f1c$var$nRe = {
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $d7238066c5de7f1c$var$iRe(!0)
}, $d7238066c5de7f1c$var$sRe = $d7238066c5de7f1c$var$nRe.charAt, $d7238066c5de7f1c$var$rRe = $d7238066c5de7f1c$var$Ix, $d7238066c5de7f1c$var$SO = $d7238066c5de7f1c$var$dx, $d7238066c5de7f1c$var$aRe = $d7238066c5de7f1c$var$J4, $d7238066c5de7f1c$var$Dz = $d7238066c5de7f1c$var$U4, $d7238066c5de7f1c$var$ZO = "String Iterator", $d7238066c5de7f1c$var$oRe = $d7238066c5de7f1c$var$SO.set, $d7238066c5de7f1c$var$gRe = $d7238066c5de7f1c$var$SO.getterFor($d7238066c5de7f1c$var$ZO);
$d7238066c5de7f1c$var$aRe(String, "String", function(r) {
    $d7238066c5de7f1c$var$oRe(this, {
        type: $d7238066c5de7f1c$var$ZO,
        string: $d7238066c5de7f1c$var$rRe(r),
        index: 0
    });
}, function() {
    var e = $d7238066c5de7f1c$var$gRe(this), t = e.string, i = e.index, n;
    return i >= t.length ? $d7238066c5de7f1c$var$Dz(void 0, !0) : (n = $d7238066c5de7f1c$var$sRe(t, i), e.index += n.length, $d7238066c5de7f1c$var$Dz(n, !1));
});
var $d7238066c5de7f1c$var$lRe = $d7238066c5de7f1c$var$uV, $d7238066c5de7f1c$var$cRe = $d7238066c5de7f1c$var$lRe.Promise, $d7238066c5de7f1c$var$uRe = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
}, $d7238066c5de7f1c$var$IRe = $d7238066c5de7f1c$var$uRe, $d7238066c5de7f1c$var$dRe = $d7238066c5de7f1c$var$Ir, $d7238066c5de7f1c$var$hRe = $d7238066c5de7f1c$var$pV, $d7238066c5de7f1c$var$_z = $d7238066c5de7f1c$var$u0;
for(var $d7238066c5de7f1c$var$l2 in $d7238066c5de7f1c$var$IRe)$d7238066c5de7f1c$var$hRe($d7238066c5de7f1c$var$dRe[$d7238066c5de7f1c$var$l2], $d7238066c5de7f1c$var$l2), $d7238066c5de7f1c$var$_z[$d7238066c5de7f1c$var$l2] = $d7238066c5de7f1c$var$_z.Array;
var $d7238066c5de7f1c$var$CRe = $d7238066c5de7f1c$var$cRe, $d7238066c5de7f1c$var$pRe = $d7238066c5de7f1c$var$CRe, $d7238066c5de7f1c$var$mRe = $d7238066c5de7f1c$var$pRe, $d7238066c5de7f1c$var$ARe = $d7238066c5de7f1c$var$p0e.default, $d7238066c5de7f1c$var$bRe = $d7238066c5de7f1c$var$ARe($d7238066c5de7f1c$var$mRe);
function $d7238066c5de7f1c$var$yRe() {
    var r = {};
    return r.promise = new $d7238066c5de7f1c$var$bRe.default(function(e, t) {
        r.resolve = e, r.reject = t;
    }), r;
}
var $d7238066c5de7f1c$var$BRe = $d7238066c5de7f1c$var$yRe;
(function(r) {
    var e = $d7238066c5de7f1c$var$C0e, t = $d7238066c5de7f1c$var$BRe;
    function i(ce) {
        Object.defineProperty(ce, "__esModule", {
            value: !0,
            configurable: !0
        });
    }
    function n(ce, $, te, Ge) {
        Object.defineProperty(ce, $, {
            get: te,
            set: Ge,
            enumerable: !0,
            configurable: !0
        });
    }
    function s(ce) {
        return ce && ce.__esModule ? ce.default : ce;
    }
    i(r.exports), n(r.exports, "default", ()=>pe), n(r.exports, "createSpeechRecognitionPonyfill", ()=>Y), n(r.exports, "createSpeechSynthesisPonyfill", ()=>O), n(r.exports, "fetchAuthorizationToken", ()=>he), n(r.exports, "SpeechSynthesisUtterance", ()=>z), n(r.exports, "SpeechSynthesis", ()=>_), n(r.exports, "SpeechGrammarList", ()=>G);
    function a(ce, $) {
        const te = {
            // @ts-ignore
            ...[].reduce.call(ce, (Ge, q, de)=>(Ge[de] = q, Ge), {}),
            ...$,
            length: ce.length,
            [Symbol.iterator]: ()=>[].slice.call(te)[Symbol.iterator]()
        };
        return te;
    }
    var o = {
        AudioConfig: e.AudioConfig,
        OutputFormat: e.OutputFormat,
        ResultReason: e.ResultReason,
        SpeechConfig: e.SpeechConfig,
        SpeechRecognizer: e.SpeechRecognizer,
        SpeechSynthesizer: e.SpeechSynthesizer
    };
    const { ResultReason: { RecognizingSpeech: g, RecognizedSpeech: l } } = o;
    function c(ce, { maxAlternatives: $ = 1 / 0, textNormalization: te = "display" } = {}) {
        if (ce.reason === g || ce.reason === l && !ce.json.NBest) {
            const Ge = [
                {
                    confidence: 0.5,
                    transcript: ce.text
                }
            ];
            return ce.reason === l && (Ge.isFinal = !0), Ge;
        } else if (ce.reason === l) return a((ce.json.NBest || []).slice(0, $).map(({ Confidence: q, Display: de, ITN: ge, Lexical: Ye, MaskedITN: Fe })=>({
                confidence: q,
                transcript: te === "itn" ? ge : te === "lexical" ? Ye : te === "maskeditn" ? Fe : de
            })), {
            isFinal: !0
        });
        return [];
    }
    function d() {
        let ce;
        const $ = [];
        return {
            push: (q)=>{
                if (ce) {
                    const { resolve: de } = ce;
                    ce = null, de(q);
                } else $.push(q);
            },
            shift: ()=>$.length ? Promise.resolve($.shift()) : (ce || (ce = s(t)())).promise
        };
    }
    function p(ce) {
        return typeof ce == "function" ? ce() : ce;
    }
    let A = !0;
    function y({ credentials: ce, looseEvents: $, ...te }) {
        if (!ce) throw new Error("web-speech-cognitive-services: Credentials must be specified.");
        return {
            ...te,
            fetchCredentials: async ()=>{
                const { authorizationToken: Ge, customVoiceHostname: q, region: de, speechRecognitionHostname: ge, speechSynthesisHostname: Ye, subscriptionKey: Fe } = await p(ce);
                if (!Ge && !Fe || Ge && Fe) throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
                if (!de && !(ge && Ye)) throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
                if (de && (q || ge || Ye)) throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
                if (Ge) {
                    if (typeof Ge != "string") throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
                } else if (typeof Fe != "string") throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
                return A && Fe && (console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead."), A = !1), {
                    region: de,
                    authorizationToken: Ge,
                    subscriptionKey: Fe,
                    customVoiceHostname: q,
                    speechRecognitionHostname: ge,
                    speechSynthesisHostname: Ye
                };
            },
            looseEvents: $
        };
    }
    class G {
        addFromString() {
            throw new Error("JSGF is not supported");
        }
        get phrases() {
            return this._phrases;
        }
        set phrases($) {
            if (Array.isArray($)) this._phrases = $;
            else if (typeof $ == "string") this._phrases = [
                $
            ];
            else throw new Error("The provided value is not an array or of type 'string'");
        }
        constructor(){
            this._phrases = [];
        }
    }
    function Z({ duration: ce, errorDetails: $, json: te, offset: Ge, properties: q, reason: de, resultId: ge, text: Ye }) {
        return {
            duration: ce,
            errorDetails: $,
            json: JSON.parse(te),
            offset: Ge,
            properties: q,
            reason: de,
            resultId: ge,
            text: Ye
        };
    }
    function v(ce) {
        const $ = new Int16Array(ce);
        return $.reduce((te, Ge)=>te + Math.abs(Ge), 0) / $.length;
    }
    function V(ce) {
        return (...$)=>new Promise((te, Ge)=>ce(...$, te, Ge));
    }
    function H(ce) {
        const $ = ce.attach, te = ce.attach.bind(ce);
        let Ge = !1, q = !1;
        return ce.attach = async ()=>{
            const de = await te();
            return {
                ...de,
                read: async ()=>{
                    const ge = await de.read();
                    return !Ge && v(ge.buffer) > 150 && (ce.events.onEvent({
                        name: "FirstAudibleChunk"
                    }), Ge = !0), q ? {
                        buffer: new ArrayBuffer(0),
                        isEnd: !0,
                        timeReceived: Date.now()
                    } : ge;
                }
            };
        }, {
            audioConfig: ce,
            pause: ()=>{
                q = !0;
            },
            unprepare: ()=>{
                ce.attach = $;
            }
        };
    }
    class N {
        constructor($, te){
            this.audioConfig = null, this.speechConfig = null, this.recognizer = null, this.enableTelemetry = !0, this.looseEvents = !1, this.textNormalization = "display", this.started = !1, this._autoStart = !1, this._passive = !1, this._continuous = !1, this._interimResults = !0, this._grammars = new G(), this._maxAlternatives = 1, this._debug = !1, this.onstart = ()=>{}, this.onend = ()=>{}, this.onpassivestart = ()=>{}, this.onpassiveend = ()=>{}, this.onaudiostart = ()=>{}, this.onaudioend = ()=>{}, this.onsoundstart = ()=>{}, this.onsoundend = ()=>{}, this.onspeechstart = ()=>{}, this.onspeechend = ()=>{}, this.onerror = (Te)=>{
                console.log("Error : ", Te);
            }, this.onabort = ()=>{
                this._debug && console.log("Recognition aborted");
            }, this.onresult = (Te)=>{
                this._debug && console.log("Result : ", Te);
            }, this.onpassiveresult = (Te)=>{
                this._debug && console.log("Passive Result : ", Te);
            }, this.onwakeup = ()=>{
                this._debug && console.log("Wake up !");
            }, this.start = ()=>{
                this._startOnce().catch((Te)=>{
                    new Error(`error : ${Te.message}
callstack : ${Te.stack}`);
                });
            }, this.abort = void 0, this.stop = void 0, this.initRecognizer = async (Te, ct, st)=>{
                const { authorizationToken: Xt, region: Mi = "westus", speechRecognitionHostname: Jn, subscriptionKey: Un } = await Te();
                Jn ? Xt ? (this.speechConfig = e.SpeechConfig.fromHost(new URL(`wss://${Jn}`)), this.speechConfig.authorizationToken = Xt) : this.speechConfig = e.SpeechConfig.fromHost(new URL(`wss://${Jn}`), Un) : Mi && (Xt || Un) && (this.speechConfig = Xt ? e.SpeechConfig.fromAuthorizationToken(Xt, Mi) : Un ? e.SpeechConfig.fromSubscription(Un, Mi) : null), this.speechConfig && (ct && this.speechConfig && (this.speechConfig.endpointId = ct), this.speechConfig.outputFormat = e.OutputFormat.Detailed, this.speechConfig.speechRecognitionLanguage = this._lang || "en-US", st && this.speechConfig.setProperty(e.PropertyId[e.PropertyId.Speech_SegmentationSilenceTimeoutMs], `${st}`), this._autoStart && this.start());
            }, this.createRecognizer = async ()=>{
                if (this.audioConfig && this.speechConfig) {
                    this.speechConfig.speechRecognitionLanguage = this._lang, this.recognizer = new e.SpeechRecognizer(this.speechConfig, this.audioConfig);
                    const { dynamicGrammar: Te } = this.recognizer.internalData;
                    this.referenceGrammars && this.referenceGrammars.length && Te.addReferenceGrammar(this.referenceGrammars);
                    const { phrases: ct } = this._grammars;
                    if (ct && ct.length) {
                        const st = e.PhraseListGrammar.fromRecognizer(this.recognizer);
                        ct.forEach((Xt)=>{
                            st.addPhrase(Xt);
                        });
                    }
                } else this.recognizer = null;
            }, this.changeLanguage = async (Te)=>{
                this.recognizer && this.audioConfig && this.speechConfig && Te && Te !== this._lang ? (await V(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this._lang = Te, this._continuous && this.start()) : this.recognizer = null;
            }, this.toggleContinuousPassiveToActive = async ()=>{
                this._continuous && this.recognizer && this.audioConfig && this.speechConfig && (this.started && await V(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this._continuous = !1, this._passive = !1, this.start());
            }, this.toggleContinuousActiveToPassive = async ()=>{
                !this._continuous && this.recognizer && this.audioConfig && this.speechConfig && (this.started && await V(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this._continuous = !0, this._passive = !0, this.start());
            }, this.processSendEvent = (Te, ct)=>{
                switch(this._debug && console.log("Speech Recognizer Event : type = ", Te, `
, data = `, ct), Te){
                    case "start":
                        this._passive ? this.onpassivestart && this.onpassivestart() : this.onstart && this.onstart(), this.started = !0;
                        break;
                    case "end":
                        this._passive ? this.onpassiveend && this.onpassiveend() : this.onend && this.onend(), this.started = !1;
                        break;
                    case "audiostart":
                        this.onaudiostart && this.onaudiostart();
                        break;
                    case "audioend":
                        this.onaudioend && this.onaudioend();
                        break;
                    case "soundstart":
                        this.onsoundstart && this.onsoundstart();
                        break;
                    case "soundend":
                        this.onsoundend && this.onsoundend();
                        break;
                    case "speechstart":
                        this.onspeechstart && this.onspeechstart();
                        break;
                    case "speechend":
                        this.onspeechend && this.onspeechend();
                        break;
                    case "error":
                        this.onerror && this.onerror(ct), this.started = !1;
                        break;
                    case "abort":
                        this.onabort && this.onabort(), this.started = !1;
                        break;
                    case "result":
                        this.onresult && this.onresult(ct.results);
                        break;
                    case "passiveresult":
                        this.onpassiveresult && this.onpassiveresult(ct.results);
                        break;
                    case "wakeup":
                        this.onwakeup && this.onwakeup();
                        break;
                }
            }, this._autoStart = !!(te != null && te.autoStart), this._passive = !!(te != null && te.passive), this._wakeWords = (te == null ? void 0 : te.wakeWords) || [], this._continuous = !!(te != null && te.continuous), this._interimResults = (te == null ? void 0 : te.interimResults) !== !1, this._lang = te != null && te.lang ? te.lang : typeof window < "u" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US", te != null && te.grammarsList && (this._grammars.phrases = te.grammarsList), this._debug = !!(te != null && te.debug) || !1;
            const { audioConfig: Ge = null, enableTelemetry: q = !0, fetchCredentials: de, looseEvents: ge, referenceGrammars: Ye, speechRecognitionEndpointId: Fe, textNormalization: Xe = "display" } = y($);
            if (this.enableTelemetry = q, this.looseEvents = !!ge, this.referenceGrammars = Ye, this.textNormalization = Xe, !Ge && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.");
            else try {
                this.audioConfig = Ge || e.AudioConfig.fromDefaultMicrophoneInput(), this.initRecognizer(de, Fe, te == null ? void 0 : te.timerBeforeSpeechEnd);
            } catch (Te) {
                console.warn(Te);
            }
        }
        get passive() {
            return this._passive;
        }
        set passive($) {
            this._passive = $;
        }
        get wakeWords() {
            return this._wakeWords;
        }
        set wakeWords($) {
            this._wakeWords = $;
        }
        get continuous() {
            return this._continuous;
        }
        set continuous($) {
            this._continuous = $;
        }
        get grammars() {
            return this._grammars;
        }
        set grammars($) {
            if ($ instanceof G) this._grammars = $;
            else throw new Error("The provided value is not of type 'SpeechGrammarList'");
        }
        get interimResults() {
            return this._interimResults;
        }
        set interimResults($) {
            this._interimResults = $;
        }
        get maxAlternatives() {
            return this._maxAlternatives;
        }
        set maxAlternatives($) {
            this._maxAlternatives = $;
        }
        get lang() {
            return this._lang;
        }
        set lang($) {
            this._lang = $;
        }
        async _startOnce() {
            var $;
            if (this.audioConfig && !this.started) {
                const { pause: te, unprepare: Ge } = H(this.audioConfig), q = d();
                let de = !1, ge = !1, Ye = "";
                const { detach: Fe } = this.audioConfig.events.attach((Xe)=>{
                    const { name: Te } = Xe;
                    Te === "AudioSourceReadyEvent" ? q.push({
                        audioSourceReady: {}
                    }) : Te === "AudioSourceOffEvent" ? q.push({
                        audioSourceOff: {}
                    }) : Te === "FirstAudibleChunk" && q.push({
                        firstAudibleChunk: {}
                    });
                });
                if (await this.createRecognizer(), this.recognizer) try {
                    this.recognizer.canceled = (st, { errorDetails: Xt, offset: Mi, reason: Jn, sessionId: Un })=>{
                        q.push({
                            canceled: {
                                errorDetails: Xt,
                                offset: Mi,
                                reason: Jn,
                                sessionId: Un
                            }
                        });
                    }, this.recognizer.recognized = (st, { offset: Xt, result: Mi, sessionId: Jn })=>{
                        q.push({
                            recognized: {
                                offset: Xt,
                                result: Z(Mi),
                                sessionId: Jn
                            }
                        });
                    }, this.recognizer.recognizing = (st, { offset: Xt, result: Mi, sessionId: Jn })=>{
                        q.push({
                            recognizing: {
                                offset: Xt,
                                result: Z(Mi),
                                sessionId: Jn
                            }
                        });
                    }, this.recognizer.sessionStarted = (st, { sessionId: Xt })=>{
                        q.push({
                            sessionStarted: {
                                sessionId: Xt
                            }
                        });
                    }, this.recognizer.sessionStopped = (st, { sessionId: Xt })=>{
                        q.push({
                            sessionStopped: {
                                sessionId: Xt
                            }
                        });
                    }, this.recognizer.speechStartDetected = (st, { offset: Xt, sessionId: Mi })=>{
                        q.push({
                            speechStartDetected: {
                                offset: Xt,
                                sessionId: Mi
                            }
                        });
                    }, this.recognizer.speechEndDetected = (st, { sessionId: Xt })=>{
                        q.push({
                            speechEndDetected: {
                                sessionId: Xt
                            }
                        });
                    }, await V(this.recognizer.startContinuousRecognitionAsync.bind(this.recognizer))(), this.abort = ()=>q.push({
                            abort: {}
                        }), this.stop = ()=>q.push({
                            stop: {}
                        });
                    let Xe = !1, Te = null, ct = [];
                    for(let st = 0; !Ye || Xe; st++){
                        const Xt = await q.shift(), { abort: Mi, audioSourceOff: Jn, audioSourceReady: Un, canceled: mn, firstAudibleChunk: Qs, recognized: Di, recognizing: kr, stop: oo } = Xt, za = mn && mn.errorDetails;
                        if (/Permission\sdenied/u.test(za || "")) {
                            Te = {
                                data: "not-allowed",
                                type: "error"
                            };
                            break;
                        }
                        if (st || this.processSendEvent("start"), za) {
                            /1006/u.test(za) ? (Xe || (this.processSendEvent("audiostart"), this.processSendEvent("audioend")), Te = {
                                data: "network",
                                type: "error"
                            }) : Te = {
                                data: "unknown",
                                type: "error"
                            };
                            break;
                        } else if (Mi || oo) Mi ? (Te = {
                            type: "abort"
                        }, Ye = "abort") : (te(), Ye = "stop"), Mi && this.recognizer.stopContinuousRecognitionAsync && await V(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                        else if (Un) this.processSendEvent("audiostart"), Xe = !0;
                        else if (Qs) this.processSendEvent("soundstart"), de = !0;
                        else if (Jn) {
                            ge && this.processSendEvent("speechend"), de && this.processSendEvent("soundend"), Xe && this.processSendEvent("audioend"), Xe = de = ge = !1;
                            break;
                        } else if (Ye !== "abort") {
                            if (Di && Di.result && Di.result.reason === e.ResultReason.NoMatch) Te = {
                                data: "no-speech",
                                type: "error"
                            };
                            else if (Di || kr) {
                                if (Xe || (this.processSendEvent("audiostart"), Xe = !0), de || (this.processSendEvent("soundstart"), de = !0), ge || (this.processSendEvent("speechstart"), ge = !0), Di) {
                                    const Dn = c(Di.result, {
                                        maxAlternatives: this.maxAlternatives,
                                        textNormalization: this.textNormalization
                                    }), Er = !!Dn[0].transcript;
                                    Er && (ct = [
                                        ...ct,
                                        ...Dn
                                    ], this._interimResults && (this.processSendEvent("result", {
                                        results: ct
                                    }), this._passive && this.processSendEvent("passiveresult", {
                                        results: Dn
                                    }))), this._continuous && Er ? Te = null : this._interimResults && (Te = {
                                        data: {
                                            results: ct
                                        },
                                        type: "result"
                                    }), !this._continuous && this.recognizer.stopContinuousRecognitionAsync && await V(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))(), this.looseEvents && Te && Er && (this.processSendEvent(Te.type, Te.data), Te = null);
                                } else if (kr) {
                                    const Dn = c(kr.result, {
                                        maxAlternatives: this.maxAlternatives,
                                        textNormalization: this.textNormalization
                                    });
                                    if (this._passive && this._wakeWords && this._wakeWords.length > 0) {
                                        if (Dn && Array.isArray(Dn) && Dn.length > 0 && Dn[0].transcript) {
                                            const { transcript: Er } = {
                                                ...Dn[0]
                                            };
                                            this._wakeWords.forEach((Cg)=>{
                                                Er.toLowerCase().includes(Cg.toLowerCase()) && this.processSendEvent("wakeup");
                                            });
                                        }
                                        this._interimResults && this.processSendEvent("passiveresult", {
                                            results: Dn
                                        });
                                    }
                                    this._interimResults && this.processSendEvent("result", {
                                        results: [
                                            ...ct,
                                            ...Dn
                                        ]
                                    });
                                }
                            }
                        }
                    }
                    ge && this.processSendEvent("speechend"), de && this.processSendEvent("soundend"), Xe && this.processSendEvent("audioend"), Te && (Te.type === "result" && (typeof Te.data == "string" || !(($ = Te.data) != null && $.results) || !Te.data.results.length) && (Te = {
                        data: "no-speech",
                        type: "error"
                    }), this.processSendEvent(Te.type, Te.data)), this.processSendEvent("end"), Fe && Fe();
                } catch (Xe) {
                    throw console.error(Xe), Xe;
                } finally{
                    Ge(), this.recognizer.close();
                }
            }
        }
    }
    const Y = (ce, $)=>({
            speechRecognition: new N(ce, $),
            SpeechGrammarList: G
        });
    class K extends EventTarget {
        constructor($){
            super(), this._lang = void 0, this._pitch = 1, this._rate = 1, this._voice = void 0, this._volume = 1, this.text = $;
        }
        get lang() {
            return this._lang;
        }
        set lang($) {
            this._lang = $;
        }
        get pitch() {
            return this._pitch;
        }
        set pitch($) {
            this._pitch = $;
        }
        get rate() {
            return this._rate;
        }
        set rate($) {
            this._rate = $;
        }
        get voice() {
            return this._voice;
        }
        set voice($) {
            this._voice = $;
        }
        get volume() {
            return this._volume;
        }
        set volume($) {
            this._volume = $;
        }
        onstart() {}
        onend() {}
        onerror($) {
            console.log($);
        }
        onsynthesisstart() {}
        onsynthesiscompleted() {}
        onboundary($) {
            console.log($);
        }
        onviseme($) {
            console.log($);
        }
        onmark($) {
            console.log($);
        }
    }
    var z = K;
    class M {
        constructor({ gender: $, lang: te, voiceURI: Ge }){
            this._default = !1, this._localService = !1, this._gender = $, this._lang = te, this._name = Ge, this._voiceURI = Ge;
        }
        get default() {
            return this._default;
        }
        get gender() {
            return this._gender;
        }
        get lang() {
            return this._lang;
        }
        get localService() {
            return this._localService;
        }
        get name() {
            return this._name;
        }
        get voiceURI() {
            return this._voiceURI;
        }
    }
    class _ {
        constructor($){
            this.speaking = !1, this.speakerAudioDestination = new e.SpeakerAudioDestination(), this.audioConfig = void 0, this.speechConfig = null, this.queue = [], this.canceled = !1, this.synth = null, this.synthesizing = !1, this.getVoices = ()=>[], this.onvoiceschanged = ()=>{
                console.log("Voices changed");
            };
            const { audioContext: te, fetchCredentials: Ge, ponyfill: q = {
                // @ts-ignore
                AudioContext: window.AudioContext || window.webkitAudioContext
            }, speechSynthesisDeploymentId: de } = y($);
            !te && !q.AudioContext ? console.warn("web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.") : (this.audioConfig = e.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination), this.initSpeechSynthesizer(Ge, de));
        }
        mute() {
            this.speakerAudioDestination && this.speakerAudioDestination.mute();
        }
        unmute() {
            this.speakerAudioDestination && this.speakerAudioDestination.unmute();
        }
        getVolume() {
            return this.speakerAudioDestination ? this.speakerAudioDestination.volume : -1;
        }
        setVolume($) {
            this.speakerAudioDestination && (this.speakerAudioDestination.volume = $);
        }
        // Asynchronous function that initializes the speech synthesizer class
        async initSpeechSynthesizer($, te) {
            const { speechSynthesisHostname: Ge, subscriptionKey: q, authorizationToken: de, region: ge } = await $();
            if (!de && !q) throw new Error("no subscription data : authorizationToken or subscriptionKey needed");
            if (te) {
                const Ye = Ge || `${ge}.customvoice.api.speech.microsoft.com`, Fe = `https://${encodeURI(Ye)}/api/texttospeech/v2.0/endpoints/${encodeURIComponent(te)}`;
                this.speechConfig = e.SpeechConfig.fromEndpoint(new URL(Fe), q);
            } else Ge ? this.speechConfig = e.SpeechConfig.fromHost(Ge, q) : this.speechConfig = de ? e.SpeechConfig.fromAuthorizationToken(de, ge) : e.SpeechConfig.fromSubscription(q, ge);
            this.synth = new e.SpeechSynthesizer(this.speechConfig, this.audioConfig), this.updateVoices();
        }
        // Function to recreate the synthesizer
        createSynthesizer($, te) {
            if (te ? this.audioConfig = e.AudioConfig.fromStreamOutput(te) : (this.speakerAudioDestination = new e.SpeakerAudioDestination(), this.audioConfig = e.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination)), this.speechConfig) {
                if ($) {
                    const Ge = this.speechConfig;
                    Ge.speechSynthesisVoiceName = $, this.synth = new e.SpeechSynthesizer(Ge, this.audioConfig);
                } else this.synth = new e.SpeechSynthesizer(this.speechConfig, this.audioConfig);
            }
        }
        // Cancel current synthesis
        cancel() {
            if (this.synthesizing) try {
                this.synth && !this.synth.privDisposed && this.synth.close(), this.queue = [];
            } catch ($) {
                console.warn($);
            }
            else if (this.speaking) try {
                this.speakerAudioDestination.pause(), this.speakerAudioDestination.onAudioEnd(this.speakerAudioDestination), this.speakerAudioDestination.close();
            } catch ($) {
                console.warn($);
            }
            this.queue = [], this.canceled = !0;
        }
        // Pause current synthesis
        pause() {
            this.speakerAudioDestination && this.speakerAudioDestination.pause();
        }
        // Resume current synthesis
        resume() {
            this.speakerAudioDestination && !this.canceled && this.speakerAudioDestination.resume();
        }
        /**
    * Add events listeners to the events received by the synthesizer if callbakcs are given in the utterance
    * @param {SpeechSynthesisUtterance} utterance
    */ linkEventsCallbacks($) {
            this.synth && (this.synth.synthesisStarted = ()=>{
                $.onsynthesisstart && $.onsynthesisstart(), this.synthesizing = !0;
            }, this.synth.synthesisCompleted = ()=>{
                $.onsynthesiscompleted && $.onsynthesiscompleted(), this.synthesizing = !1;
            }, this.synth.wordBoundary = (te, Ge)=>{
                !te && console.warn("No synthesizer");
                const q = {
                    boundaryType: Ge.boundaryType,
                    name: Ge.text,
                    elapsedTime: Ge.audioOffset,
                    duration: Ge.duration
                };
                $.onboundary && $.onboundary(q);
            }, this.synth.visemeReceived = (te, Ge)=>{
                !te && console.warn("No synthesizer");
                const q = {
                    boundaryType: "Viseme",
                    name: `${Ge.visemeId}`,
                    elapsedTime: Ge.audioOffset,
                    duration: 0
                };
                $.onboundary && $.onboundary(q), $.onviseme && $.onviseme(q);
            }, this.synth.bookmarkReached = (te, Ge)=>{
                !te && console.warn("No synthesizer");
                const q = {
                    boundaryType: "Mark",
                    name: Ge.text,
                    elapsedTime: Ge.audioOffset,
                    duration: 0
                };
                $.onmark && $.onmark(q);
            });
        }
        /**
    * Launch synthesis and play sound with the speech synthesizer
    * @param {SpeechSynthesisUtterance} utterance 
    */ speak($, te) {
            if (!($ instanceof z)) throw new Error("invalid utterance");
            this.queue.push($);
            const Ge = ()=>{
                if (this.queue.length && !this.speaking) {
                    const q = this.queue.shift();
                    if (q) {
                        const de = /<speak[\s\S]*?>/iu.test(q.text);
                        return q.voice && (q.voice.voiceURI || q.voice._name) ? this.createSynthesizer(q.voice.voiceURI || q.voice._name, te) : this.createSynthesizer(void 0, te), q.volume && (this.speakerAudioDestination.volume = q.volume), this.speakerAudioDestination.onAudioStart = ()=>{
                            this.speaking = !0, q.onstart && q.onstart();
                        }, this.speakerAudioDestination.onAudioEnd = ()=>{
                            this.speaking = !1, q.onend && q.onend(), Ge();
                        }, this.linkEventsCallbacks(q), de ? new Promise((ge)=>{
                            this.synth && this.synth.speakSsmlAsync(q.text, (Ye)=>{
                                Ye ? this.synth && this.synth.close() : ge(new Error("No synthesis result."));
                            }, (Ye)=>{
                                ge(new Error(`Synthesis failed : ${Ye}`));
                            });
                        }) : new Promise((ge)=>{
                            this.synth && this.synth.speakTextAsync(q.text, (Ye)=>{
                                Ye ? this.synth && this.synth.close() : ge(new Error("No synthesis result."));
                            }, (Ye)=>{
                                ge(new Error(`Synthesis failed : ${Ye}`));
                            });
                        });
                    }
                }
            };
            Ge(), this.canceled = !1;
        }
        /**
    * Launch synthesis without sound being played and call callback function with an ArrayBuffer after synthesis finished, containing the sound data
    * @param {SpeechSynthesisUtterance} utterance 
    * @param {Function} callback 
    */ synthesizeAndGetArrayData($, te) {
            if (!($ instanceof z)) throw new Error("invalid utterance");
            const Ge = /<speak[\s\S]*?>/iu.test($.text);
            if (this.speechConfig) {
                if ($.voice && ($.voice.voiceURI || $.voice._name)) {
                    const q = this.speechConfig;
                    q.speechSynthesisVoiceName = $.voice.voiceURI || $.voice._name, this.synth = new e.SpeechSynthesizer(q, null);
                } else this.synth = new e.SpeechSynthesizer(this.speechConfig, null);
            }
            this.linkEventsCallbacks($);
            try {
                Ge ? this.synth && this.synth.speakSsmlAsync($.text, (q)=>{
                    q && q.audioData ? (te(q.audioData), this.synth && this.synth.close()) : te(null);
                }, (q)=>{
                    console.error(q), te(null);
                }) : this.synth && this.synth.speakTextAsync($.text, (q)=>{
                    q && q.audioData ? (te(q.audioData), this.synth && this.synth.close()) : te(null);
                }, (q)=>{
                    console.error(q), te(null);
                });
            } catch (q) {
                console.error(q);
            }
        }
        // Asynchronous function that updates available voices
        async updateVoices() {
            const $ = this.synth ? await this.synth.getVoicesAsync() : null, te = $ == null ? void 0 : $.voices;
            if (Array.isArray(te)) {
                const Ge = te.map((q)=>new M({
                        // eslint-disable-next-line no-magic-numbers
                        gender: q.gender === 1 ? "Female" : q.gender === 2 ? "Male" : "Undefined",
                        lang: q.locale,
                        voiceURI: q.name
                    }));
                this.getVoices = ()=>Ge;
            } else console.warn("Failed to retrieve voices. 'voices' is not an array.");
            this.onvoiceschanged();
        }
    }
    const O = (ce)=>({
            speechSynthesis: new _(ce),
            SpeechSynthesisUtterance: z
        }), ie = "https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken";
    async function he({ region: ce, subscriptionKey: $ }) {
        if (!ce || !$) throw new Error("Region AND subscription must be provided");
        {
            const te = await fetch(ie.replace(/\{region\}/u, ce), {
                headers: {
                    "Ocp-Apim-Subscription-Key": $
                },
                method: "POST"
            });
            if (!te.ok) throw new Error(`Failed to fetch authorization token, server returned ${te.status}`);
            return te.text();
        }
    }
    function pe(ce, $) {
        return {
            ...Y(ce, $),
            ...O(ce)
        };
    }
})($d7238066c5de7f1c$var$pQ);
var $d7238066c5de7f1c$var$Pz = $d7238066c5de7f1c$var$pQ.exports;
const $d7238066c5de7f1c$var$fRe = ()=>{
    const r = $d7238066c5de7f1c$export$c7fe76dc325a276e((y)=>y.animationsLoaded), e = $d7238066c5de7f1c$export$c7fe76dc325a276e((y)=>y.characterState), t = $d7238066c5de7f1c$export$c7fe76dc325a276e((y)=>y.lipSyncManager), i = $d7238066c5de7f1c$var$ar((y)=>y.credentials), n = $d7238066c5de7f1c$var$ar((y)=>y.currentUtterance), s = $d7238066c5de7f1c$var$ar((y)=>y.textToSpeak), a = $d7238066c5de7f1c$var$ar((y)=>y.visemes), o = $d7238066c5de7f1c$var$ar((y)=>y.visemeIntensity), g = $d7238066c5de7f1c$var$ar((y)=>y.currentVisemeIndex), [l, c] = (0, $bxRTa.useState)(!1), [d, p] = (0, $bxRTa.useState)(!1), A = (0, $bxRTa.useMemo)(()=>i != null && i.region && (i.subscriptionKey || i.token) ? $d7238066c5de7f1c$var$Pz.createSpeechSynthesisPonyfill({
            credentials: {
                region: i.region,
                authorizationToken: i.token,
                subscriptionKey: i.subscriptionKey
            }
        }) : null, [
        i
    ]);
    return (0, $bxRTa.useEffect)(()=>{
        if (A) {
            const y = A.speechSynthesis.getVoices();
            y && Array.isArray(y) && y.length ? ($d7238066c5de7f1c$var$lM(y), c(!0)) : A.speechSynthesis.onvoiceschanged = ()=>{
                $d7238066c5de7f1c$var$lM(A.speechSynthesis.getVoices()), c(!0);
            };
        }
    }, [
        A
    ]), (0, $bxRTa.useEffect)(()=>{
        l && t && r && p(!0);
    }, [
        l,
        t,
        r
    ]), (0, $bxRTa.useEffect)(()=>{
        if (s) {
            const y = new $d7238066c5de7f1c$var$Pz.SpeechSynthesisUtterance(s);
            $d7238066c5de7f1c$export$361f43c8d19dc717(y);
        }
    }, [
        s
    ]), (0, $bxRTa.useEffect)(()=>{
        var y, G;
        n && d ? (n.onstart = ()=>{
            console.log("Start"), $d7238066c5de7f1c$export$83a16ee147243363($d7238066c5de7f1c$export$f2e6b371e93925c7.speaking);
        }, n.onend = ()=>{
            console.log("End"), $d7238066c5de7f1c$export$83a16ee147243363($d7238066c5de7f1c$export$f2e6b371e93925c7.idle);
        }, n.onboundary = ()=>{}, n.onviseme = (Z)=>{
            $d7238066c5de7f1c$export$a6f0d0f24e5dc19b(Z);
        }, (y = A == null ? void 0 : A.speechSynthesis) == null || y.speak(n, null)) : (G = A == null ? void 0 : A.speechSynthesis) == null || G.cancel();
    }, [
        n
    ]), (0, $bxRTa.useEffect)(()=>{
        t && (t.visemeIntensity = o);
    }, [
        o
    ]), (0, $bxRTa.useEffect)(()=>{
        if (a.length && t && e === $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking) {
            if (!t.isStarted && t.start(), a.length > 1 && g === 0) a.forEach((y)=>{
                const G = parseInt(y.name);
                if (!isNaN(G)) {
                    const Z = $d7238066c5de7f1c$var$gM.get(G);
                    Z && t.PlayVisemeAsync(Z, y.elapsedTime / 1e4);
                }
            });
            else for(let y = g + 1; y < a.length; y++){
                const G = a[y], Z = parseInt(G.name);
                if (!isNaN(Z)) {
                    const v = $d7238066c5de7f1c$var$gM.get(Z);
                    v && t.PlayVisemeAsync(v, G.elapsedTime / 1e4);
                }
            }
            $d7238066c5de7f1c$var$Bme(a.length - 1);
        }
    }, [
        e,
        a,
        t
    ]), (0, $bxRTa.useEffect)(()=>{
        e !== $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking && $d7238066c5de7f1c$export$1a9c534915c6839e();
    }, [
        e
    ]), null;
}, $d7238066c5de7f1c$var$GRe = ({ parentGpuTier: r, setIsGpuAvailable: e, children: t, tonemapping: i })=>{
    const n = $d7238066c5de7f1c$var$Wo((N)=>N.cameraPosition), s = $d7238066c5de7f1c$var$Wo((N)=>N.lookAt), a = $d7238066c5de7f1c$var$Wo((N)=>N.movable), [o] = (0, $bxRTa.useState)(r || $d7238066c5de7f1c$var$Rpe()), [g, l] = (0, $bxRTa.useState)(), [c, d] = (0, $bxRTa.useState)(null), [p, A] = (0, $bxRTa.useState)(void 0), y = (0, $bxRTa.useRef)(), G = (0, $bxRTa.useRef)(), Z = (0, $bxRTa.useRef)(), v = (N)=>{
        N.preventDefault(), N.stopPropagation();
    };
    (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$ame(G.current);
    }, [
        G.current
    ]), (0, $bxRTa.useEffect)(()=>{
        var N, Y, K, z;
        if (a) c == null || c.abort(), d(null);
        else {
            const M = new AbortController();
            d(M), (N = y.current) == null || N.addEventListener("wheel", v, {
                passive: !1,
                signal: M.signal
            }), (Y = y.current) == null || Y.addEventListener("pointerdown", v, {
                passive: !1,
                signal: M.signal
            }), (K = y.current) == null || K.addEventListener("pointermove", v, {
                passive: !1,
                signal: M.signal
            }), (z = y.current) == null || z.addEventListener("click", v, {
                passive: !1,
                signal: M.signal
            });
        }
    }, [
        a
    ]), (0, $bxRTa.useEffect)(()=>{
        Z != null && Z.current && s && n && Z.current.setLookAt(n.x, n.y, n.z, s.x, s.y, s.z, !0);
    }, [
        n,
        s
    ]), (0, $bxRTa.useEffect)(()=>{
        if (o) {
            if (o.type === "FALLBACK") l("medium");
            else switch(o.tier){
                case 0:
                case 1:
                    l("low");
                    break;
                case 2:
                    l("medium");
                    break;
                case 3:
                    l("high");
                    break;
                default:
                    l("low");
                    break;
            }
        }
    }, [
        o
    ]), (0, $bxRTa.useEffect)(()=>{
        switch(g){
            case "low":
                console.warn("Retorik React-Bodyengine-Three > GPU tier too low, no rendering available"), e(!1);
                break;
            case "medium":
                A([
                    0.8,
                    1
                ]), console.log(`Retorik React-Bodyengine-Three > GPU tier detected : ${g}`), e(!0);
                break;
            case "high":
                A([
                    1,
                    2
                ]), console.log(`Retorik React-Bodyengine-Three > GPU tier detected : ${g}`), e(!0);
                break;
        }
    }, [
        g
    ]);
    const [V] = (0, $bxRTa.useState)(new $1W96c.Scene()), H = (0, $bxRTa.useMemo)(()=>{
        if (V && g !== "low" && G.current && y.current) {
            const N = {
                antialias: g !== "medium",
                powerPreference: "high-performance",
                forceWebGL: !1,
                colorBufferType: g === "medium" ? $1W96c.UnsignedByteType : $1W96c.HalfFloatType
            }, Y = new $d7238066c5de7f1c$var$Due(N);
            return Y.setClearColor(new $1W96c.Color("#000000"), 0), Y.setPixelRatio(devicePixelRatio), Y.shadowMap.type = $1W96c.PCFSoftShadowMap, Y.setAnimationLoop(()=>{
                Y.render(V, G.current);
            }), Y;
        }
    }, [
        V,
        g,
        G.current,
        y.current
    ]);
    return p ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$jCe, {
        gl: H,
        dpr: p,
        ref: y,
        shadows: !0,
        scene: V
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$vRe, {
        renderer: H,
        tonemapping: i,
        processedTier: g,
        scene: V
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$jpe, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$fRe, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$mpe, {
        ref: G,
        makeDefault: !0,
        fov: 28
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$Bpe, {
        ref: Z
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, $bxRTa.Suspense), {
        fallback: null
    }, t)) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null);
}, $d7238066c5de7f1c$var$vRe = ({ renderer: r, tonemapping: e, processedTier: t, scene: i })=>{
    const { gl: n } = $d7238066c5de7f1c$var$gs(), [s] = (0, $bxRTa.useState)(new $1W96c.Vector3(-3, 2, 2)), [a] = (0, $bxRTa.useState)(new $1W96c.Vector3(0, 1, 0)), [o] = (0, $bxRTa.useState)(2), [g] = (0, $bxRTa.useState)(-0.001), [l] = (0, $bxRTa.useState)(0.6), c = (0, $bxRTa.useRef)();
    return (0, $bxRTa.useEffect)(()=>{
        !n || !r || (n.shadowMap.type = $1W96c.PCFSoftShadowMap, n.toneMapping = e, t !== "low" ? i.environmentIntensity = l : i.environmentIntensity = 1);
    }, [
        n,
        r,
        e
    ]), (0, $bxRTa.useEffect)(()=>{
        i.environmentIntensity = l;
    }, [
        l
    ]), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, t !== "low" && n && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("directionalLight", {
        ref: c,
        color: "white",
        position: s.toArray(),
        "target-position": a.toArray(),
        intensity: o,
        castShadow: !0,
        "shadow-mapSize-width": 1024,
        "shadow-mapSize-height": 1024,
        "shadow-bias": g
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("orthographicCamera", {
        attach: "shadow-camera",
        args: [
            -1,
            1,
            2,
            -0.5,
            2,
            8
        ]
    }))));
}, $d7238066c5de7f1c$var$ih = $d7238066c5de7f1c$var$l0()(()=>({
        currentAUs: null,
        currentGaze: null,
        currentHeadPose: null,
        lookAtCamera: !1
    })), $d7238066c5de7f1c$export$4e30b10203d50fb8 = (r)=>{
    $d7238066c5de7f1c$var$ih.setState({
        currentAUs: r
    });
}, $d7238066c5de7f1c$export$3bf029edb7af26ca = (r)=>{
    $d7238066c5de7f1c$var$ih.setState({
        currentGaze: r
    });
}, $d7238066c5de7f1c$export$bc06a1b48d31c5a3 = (r)=>{
    $d7238066c5de7f1c$var$ih.setState({
        currentHeadPose: r
    });
}, $d7238066c5de7f1c$export$c4b950f052e6bb5c = (r)=>{
    $d7238066c5de7f1c$var$ih.setState({
        lookAtCamera: r
    }), r ? $d7238066c5de7f1c$export$5466d9107c924e1f() : $d7238066c5de7f1c$export$75766fc1823cc42c();
}, $d7238066c5de7f1c$export$5466d9107c924e1f = (r)=>{
    const e = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().globalManager;
    if (r) e == null || e.lookAtAndKeep(r);
    else {
        const t = $d7238066c5de7f1c$var$Wo.getState().cameraRef;
        e == null || e.lookAtAndKeep(t);
    }
}, $d7238066c5de7f1c$export$75766fc1823cc42c = ()=>{
    var r;
    (r = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().globalManager) == null || r.releaseLookAt();
}, $d7238066c5de7f1c$var$RRe = ({ character: r, autoLookAt: e })=>{
    const t = $d7238066c5de7f1c$export$c7fe76dc325a276e((g)=>g.characterState), i = $d7238066c5de7f1c$var$ih((g)=>g.currentAUs), n = $d7238066c5de7f1c$var$ih((g)=>g.currentGaze), s = $d7238066c5de7f1c$var$ih((g)=>g.currentHeadPose), a = $d7238066c5de7f1c$var$ih((g)=>g.lookAtCamera), o = $d7238066c5de7f1c$var$Wo((g)=>g.cameraPosition);
    return $d7238066c5de7f1c$var$_R((g, l)=>{
        const c = {
            deltaTime: l,
            timestamp: g.clock.oldTime,
            AU: i,
            gaze: n,
            headPose: s,
            characterState: t,
            lookAt: a ? o : void 0
        };
        r.update(c);
    }), (0, $bxRTa.useEffect)(()=>{
        if (e) switch(t){
            case $d7238066c5de7f1c$export$f2e6b371e93925c7.idle:
            case $d7238066c5de7f1c$export$f2e6b371e93925c7.waiting:
                $d7238066c5de7f1c$export$c4b950f052e6bb5c(!1);
                break;
            case $d7238066c5de7f1c$export$f2e6b371e93925c7.listening:
            case $d7238066c5de7f1c$export$f2e6b371e93925c7.speaking:
                $d7238066c5de7f1c$export$c4b950f052e6bb5c(!0);
                break;
        }
        else $d7238066c5de7f1c$export$c4b950f052e6bb5c(!1);
    }, [
        t,
        e
    ]), (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$ime(r);
    }, [
        r
    ]), null;
}, $d7238066c5de7f1c$export$cb68cc2163cd3f1 = ({ url: r, type: e, animationsUrl: t, gender: i, speechSynthesis: n, camera: s, onLoadingCompleted: a, autoLookAt: o, breathing: g, disableAnimations: l, debug: c, enableBml: d, animationWeights: p, license: A, detectGpuData: y, environmentPreset: G = "apartment", tonemapping: Z = $1W96c.NeutralToneMapping })=>{
    const v = $d7238066c5de7f1c$export$c7fe76dc325a276e(($)=>$.animationsLoaded), V = $d7238066c5de7f1c$var$Wo(($)=>$.defaultPositions), H = $d7238066c5de7f1c$var$Wo(($)=>$.defaultDistances), [N, Y] = (0, $bxRTa.useState)(), [K, z] = (0, $bxRTa.useState)(null), [M, _] = (0, $bxRTa.useState)(), [O, ie] = (0, $bxRTa.useState)(!1), he = async ($)=>{
        let te = null;
        switch(e){
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.cc3:
                te = new $d7238066c5de7f1c$var$LIe(), _($d7238066c5de7f1c$var$Ry.cc3);
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.rpm:
                te = new $d7238066c5de7f1c$var$KIe(), _($d7238066c5de7f1c$var$Ry.rpm);
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avatarsdk:
                te = new $d7238066c5de7f1c$var$FIe(), _($d7238066c5de7f1c$var$Ry.avatarsdk);
                break;
            case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avaturn:
                te = new $d7238066c5de7f1c$var$xIe(), _($d7238066c5de7f1c$var$Ry.avaturn);
                break;
        }
        const Ge = await te.loadAsync($).catch((q)=>console.warn("Error loading character : ", q));
        if (Ge) {
            let q = null;
            const de = {
                mesh: Ge,
                onAnimationsLoaded: pe,
                animationsUrl: t,
                gender: i || "male",
                type: e,
                debug: c,
                enableBmlManager: !!d,
                animationWeights: p,
                license: A
            };
            switch(e){
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.cc3:
                    q = await $d7238066c5de7f1c$var$os.fromCharacterCreator(de);
                    break;
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.rpm:
                    q = await $d7238066c5de7f1c$var$os.fromReadyPlayerMe(de);
                    break;
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avatarsdk:
                    q = await $d7238066c5de7f1c$var$os.fromAvatarSDK(de);
                    break;
                case $d7238066c5de7f1c$export$4a5f7b09ca822d8c.avaturn:
                    q = await $d7238066c5de7f1c$var$os.fromAvaturn(de);
                    break;
            }
            q && z(q), q && q.traverse((ge)=>{
                ge.castShadow = !0, ge.receiveShadow = !0;
            });
        }
    }, pe = ()=>{
        $d7238066c5de7f1c$var$sM(!0);
    };
    (0, $bxRTa.useEffect)(()=>{
        var $, te;
        K && v && (g === !1 && ((te = ($ = K.animationManager) == null ? void 0 : $.disableBreathing) == null || te.call($)), O ? ($d7238066c5de7f1c$var$sme(K.getAllAnimationNames()), $d7238066c5de7f1c$var$rme(K.getAllAnimations()), setTimeout(()=>{
            a == null || a();
        }, 1e3)) : ce());
    }, [
        K,
        v,
        O
    ]), (0, $bxRTa.useEffect)(()=>{
        $d7238066c5de7f1c$var$sM(!1), N !== void 0 && (N ? he(r) : a == null || a());
    }, [
        r,
        N
    ]), (0, $bxRTa.useEffect)(()=>{
        if (O && H && V) {
            if (s) {
                const $ = $d7238066c5de7f1c$var$vme(s, H, V);
                $d7238066c5de7f1c$export$e5bf5ad244df1ebf($), $d7238066c5de7f1c$var$oM(s.lookAt ? V[s.lookAt] : V.lowerbelly), $d7238066c5de7f1c$export$545c1d117b311d16(!!s.movable);
            } else {
                const $ = V.mouth.clone();
                $.setComponent(2, H.farther), $d7238066c5de7f1c$export$e5bf5ad244df1ebf($), $d7238066c5de7f1c$var$oM(V.lowerbelly);
            }
        }
    }, [
        O,
        s,
        H,
        V
    ]), (0, $bxRTa.useEffect)(()=>{
        n && (n.credentials && $d7238066c5de7f1c$var$bme(n.credentials), n.voice && $d7238066c5de7f1c$export$f7fa6f9f21f4683c(n.voice));
    }, [
        n
    ]);
    const ce = ()=>{
        if (K && M) {
            try {
                const $ = new $1W96c.Box3().setFromObject(K), te = $.max, Ge = $.min, q = new $1W96c.Vector3((te.x + Ge.x) / 2, (te.y + Ge.y) / 2, (te.z + Ge.z) / 2);
                $d7238066c5de7f1c$var$ome(q);
                const de = Math.abs(te.x - Ge.x), ge = Math.abs(te.y - Ge.y), Ye = Math.abs(te.z - Ge.z);
                $d7238066c5de7f1c$var$nme({
                    x: de,
                    y: ge,
                    z: Ye
                });
                const Fe = (te.x + Ge.x) / 2, Xe = (te.z + Ge.z) / 2, Te = {
                    eye: new $1W96c.Vector3(Fe, te.y - ge / 16, Xe),
                    mouth: new $1W96c.Vector3(Fe, te.y - ge / 12, Xe),
                    neck: new $1W96c.Vector3(Fe, te.y - ge / 8, Xe),
                    clavicle: new $1W96c.Vector3(Fe, te.y - ge / 6, Xe),
                    torso: new $1W96c.Vector3(Fe, te.y - ge / 4, Xe),
                    belly: new $1W96c.Vector3(Fe, te.y - ge / 8 * 3, Xe),
                    lowerbelly: new $1W96c.Vector3(Fe, te.y - ge / 32 * 15, Xe),
                    hips: q,
                    higherthigh: new $1W96c.Vector3(Fe, Ge.y + ge / 32 * 15, Xe),
                    thigh: new $1W96c.Vector3(Fe, Ge.y + ge / 8 * 3, Xe),
                    knee: new $1W96c.Vector3(Fe, Ge.y + ge / 4, Xe),
                    leg: new $1W96c.Vector3(Fe, Ge.y + ge / 8, Xe),
                    feet: new $1W96c.Vector3(Fe, Ge.y, Xe)
                }, ct = (te.y - (Ge.y + ge / 7 * 2)) / 2 / Math.tan(25 * (Math.PI / 180)), st = {
                    veryclose: ct / 4,
                    closer: ct / 3,
                    close: ct / 2.5,
                    midclose: ct / 2,
                    medium: ct,
                    midfar: ct * 2,
                    far: ct * 2.5,
                    farther: ct * 3,
                    veryfar: ct * 4
                };
                $d7238066c5de7f1c$var$gme(Te), $d7238066c5de7f1c$var$lme(st);
            } catch ($) {
                console.warn($);
            }
            ie(!0);
        }
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$GRe, {
        parentGpuTier: y,
        setIsGpuAvailable: Y,
        tonemapping: Z
    }, N ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, K && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$RRe, {
        character: K,
        autoLookAt: !!o
    }), K && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d7238066c5de7f1c$var$Upe, {
        preset: G
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("primitive", {
        object: K,
        castShadow: !0,
        receiveShadow: !0
    }))) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null));
}, $d7238066c5de7f1c$var$VRe = {
    emotions: [],
    currentTopEmotion: $d7238066c5de7f1c$var$lK.Neutral,
    useTopEmotionOnly: !0,
    autoDecay: !1
}, $d7238066c5de7f1c$var$iB = $d7238066c5de7f1c$var$l0()(()=>$d7238066c5de7f1c$var$VRe), $d7238066c5de7f1c$export$7e5dc4bfb1d9b6a2 = (r)=>{
    if ($d7238066c5de7f1c$var$iB.setState({
        emotions: r || []
    }), r != null && r.length) {
        const e = r.reduce((t, i)=>t.value > i.value ? t : i);
        $d7238066c5de7f1c$var$iB.setState({
            currentTopEmotion: e.emotion
        });
    } else $d7238066c5de7f1c$var$iB.setState({
        currentTopEmotion: $d7238066c5de7f1c$var$lK.Neutral
    });
}, $d7238066c5de7f1c$export$bb16ea1cc7bbe090 = (r)=>{
    $d7238066c5de7f1c$var$iB.setState({
        useTopEmotionOnly: r
    });
}, $d7238066c5de7f1c$export$35e7ff73377d45eb = (r)=>{
    $d7238066c5de7f1c$var$iB.setState({
        autoDecay: r
    });
}, $d7238066c5de7f1c$export$45f49513892eb08f = (r)=>{
    const e = $d7238066c5de7f1c$export$c7fe76dc325a276e.getState().FACSManager;
    e == null || e.playFacialAnimation({
        ...r
    });
};

});
parcelRegister("1W96c", function(module, exports) {

$parcel$export(module.exports, "ShaderChunk", () => $169244187a3eb47b$export$955f9f2e84c43c8b);
$parcel$export(module.exports, "UniformsLib", () => $169244187a3eb47b$export$6643083551874bf5);
$parcel$export(module.exports, "ShaderLib", () => $169244187a3eb47b$export$bee4a7d47f8f5014);
$parcel$export(module.exports, "PMREMGenerator", () => $169244187a3eb47b$export$6add42717753e221);
$parcel$export(module.exports, "WebGLUtils", () => $169244187a3eb47b$export$ddaebcad857649a8);
$parcel$export(module.exports, "WebGLRenderer", () => $169244187a3eb47b$export$f6cc00ef28d7cf97);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => (parcelRequire("329ek")).AdditiveAnimationBlendMode);
$parcel$export(module.exports, "AlwaysStencilFunc", () => (parcelRequire("329ek")).AlwaysStencilFunc);
$parcel$export(module.exports, "AmbientLight", () => (parcelRequire("329ek")).AmbientLight);
$parcel$export(module.exports, "AnimationAction", () => (parcelRequire("329ek")).AnimationAction);
$parcel$export(module.exports, "AnimationClip", () => (parcelRequire("329ek")).AnimationClip);
$parcel$export(module.exports, "AnimationLoader", () => (parcelRequire("329ek")).AnimationLoader);
$parcel$export(module.exports, "AnimationMixer", () => (parcelRequire("329ek")).AnimationMixer);
$parcel$export(module.exports, "AnimationObjectGroup", () => (parcelRequire("329ek")).AnimationObjectGroup);
$parcel$export(module.exports, "AnimationUtils", () => (parcelRequire("329ek")).AnimationUtils);
$parcel$export(module.exports, "ArcCurve", () => (parcelRequire("329ek")).ArcCurve);
$parcel$export(module.exports, "ArrowHelper", () => (parcelRequire("329ek")).ArrowHelper);
$parcel$export(module.exports, "AttachedBindMode", () => (parcelRequire("329ek")).AttachedBindMode);
$parcel$export(module.exports, "Audio", () => (parcelRequire("329ek")).Audio);
$parcel$export(module.exports, "AudioAnalyser", () => (parcelRequire("329ek")).AudioAnalyser);
$parcel$export(module.exports, "AudioContext", () => (parcelRequire("329ek")).AudioContext);
$parcel$export(module.exports, "AudioListener", () => (parcelRequire("329ek")).AudioListener);
$parcel$export(module.exports, "AudioLoader", () => (parcelRequire("329ek")).AudioLoader);
$parcel$export(module.exports, "AxesHelper", () => (parcelRequire("329ek")).AxesHelper);
$parcel$export(module.exports, "BasicDepthPacking", () => (parcelRequire("329ek")).BasicDepthPacking);
$parcel$export(module.exports, "BasicShadowMap", () => (parcelRequire("329ek")).BasicShadowMap);
$parcel$export(module.exports, "BatchedMesh", () => (parcelRequire("329ek")).BatchedMesh);
$parcel$export(module.exports, "Bone", () => (parcelRequire("329ek")).Bone);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => (parcelRequire("329ek")).BooleanKeyframeTrack);
$parcel$export(module.exports, "Box2", () => (parcelRequire("329ek")).Box2);
$parcel$export(module.exports, "Box3", () => (parcelRequire("329ek")).Box3);
$parcel$export(module.exports, "Box3Helper", () => (parcelRequire("329ek")).Box3Helper);
$parcel$export(module.exports, "BoxHelper", () => (parcelRequire("329ek")).BoxHelper);
$parcel$export(module.exports, "BufferGeometryLoader", () => (parcelRequire("329ek")).BufferGeometryLoader);
$parcel$export(module.exports, "Cache", () => (parcelRequire("329ek")).Cache);
$parcel$export(module.exports, "Camera", () => (parcelRequire("329ek")).Camera);
$parcel$export(module.exports, "CameraHelper", () => (parcelRequire("329ek")).CameraHelper);
$parcel$export(module.exports, "CanvasTexture", () => (parcelRequire("329ek")).CanvasTexture);
$parcel$export(module.exports, "CapsuleGeometry", () => (parcelRequire("329ek")).CapsuleGeometry);
$parcel$export(module.exports, "CatmullRomCurve3", () => (parcelRequire("329ek")).CatmullRomCurve3);
$parcel$export(module.exports, "CircleGeometry", () => (parcelRequire("329ek")).CircleGeometry);
$parcel$export(module.exports, "Clock", () => (parcelRequire("329ek")).Clock);
$parcel$export(module.exports, "ColorKeyframeTrack", () => (parcelRequire("329ek")).ColorKeyframeTrack);
$parcel$export(module.exports, "CompressedArrayTexture", () => (parcelRequire("329ek")).CompressedArrayTexture);
$parcel$export(module.exports, "CompressedCubeTexture", () => (parcelRequire("329ek")).CompressedCubeTexture);
$parcel$export(module.exports, "CompressedTexture", () => (parcelRequire("329ek")).CompressedTexture);
$parcel$export(module.exports, "CompressedTextureLoader", () => (parcelRequire("329ek")).CompressedTextureLoader);
$parcel$export(module.exports, "ConeGeometry", () => (parcelRequire("329ek")).ConeGeometry);
$parcel$export(module.exports, "Controls", () => (parcelRequire("329ek")).Controls);
$parcel$export(module.exports, "CubeCamera", () => (parcelRequire("329ek")).CubeCamera);
$parcel$export(module.exports, "CubeTextureLoader", () => (parcelRequire("329ek")).CubeTextureLoader);
$parcel$export(module.exports, "CubicBezierCurve", () => (parcelRequire("329ek")).CubicBezierCurve);
$parcel$export(module.exports, "CubicBezierCurve3", () => (parcelRequire("329ek")).CubicBezierCurve3);
$parcel$export(module.exports, "CubicInterpolant", () => (parcelRequire("329ek")).CubicInterpolant);
$parcel$export(module.exports, "CullFaceFrontBack", () => (parcelRequire("329ek")).CullFaceFrontBack);
$parcel$export(module.exports, "Curve", () => (parcelRequire("329ek")).Curve);
$parcel$export(module.exports, "CurvePath", () => (parcelRequire("329ek")).CurvePath);
$parcel$export(module.exports, "CylinderGeometry", () => (parcelRequire("329ek")).CylinderGeometry);
$parcel$export(module.exports, "Cylindrical", () => (parcelRequire("329ek")).Cylindrical);
$parcel$export(module.exports, "DataTextureLoader", () => (parcelRequire("329ek")).DataTextureLoader);
$parcel$export(module.exports, "DataUtils", () => (parcelRequire("329ek")).DataUtils);
$parcel$export(module.exports, "DecrementStencilOp", () => (parcelRequire("329ek")).DecrementStencilOp);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => (parcelRequire("329ek")).DecrementWrapStencilOp);
$parcel$export(module.exports, "DefaultLoadingManager", () => (parcelRequire("329ek")).DefaultLoadingManager);
$parcel$export(module.exports, "DetachedBindMode", () => (parcelRequire("329ek")).DetachedBindMode);
$parcel$export(module.exports, "DirectionalLight", () => (parcelRequire("329ek")).DirectionalLight);
$parcel$export(module.exports, "DirectionalLightHelper", () => (parcelRequire("329ek")).DirectionalLightHelper);
$parcel$export(module.exports, "DiscreteInterpolant", () => (parcelRequire("329ek")).DiscreteInterpolant);
$parcel$export(module.exports, "DodecahedronGeometry", () => (parcelRequire("329ek")).DodecahedronGeometry);
$parcel$export(module.exports, "DynamicCopyUsage", () => (parcelRequire("329ek")).DynamicCopyUsage);
$parcel$export(module.exports, "DynamicDrawUsage", () => (parcelRequire("329ek")).DynamicDrawUsage);
$parcel$export(module.exports, "DynamicReadUsage", () => (parcelRequire("329ek")).DynamicReadUsage);
$parcel$export(module.exports, "EdgesGeometry", () => (parcelRequire("329ek")).EdgesGeometry);
$parcel$export(module.exports, "EllipseCurve", () => (parcelRequire("329ek")).EllipseCurve);
$parcel$export(module.exports, "EqualStencilFunc", () => (parcelRequire("329ek")).EqualStencilFunc);
$parcel$export(module.exports, "ExtrudeGeometry", () => (parcelRequire("329ek")).ExtrudeGeometry);
$parcel$export(module.exports, "FileLoader", () => (parcelRequire("329ek")).FileLoader);
$parcel$export(module.exports, "Float16BufferAttribute", () => (parcelRequire("329ek")).Float16BufferAttribute);
$parcel$export(module.exports, "Float32BufferAttribute", () => (parcelRequire("329ek")).Float32BufferAttribute);
$parcel$export(module.exports, "Fog", () => (parcelRequire("329ek")).Fog);
$parcel$export(module.exports, "FogExp2", () => (parcelRequire("329ek")).FogExp2);
$parcel$export(module.exports, "FramebufferTexture", () => (parcelRequire("329ek")).FramebufferTexture);
$parcel$export(module.exports, "FrustumArray", () => (parcelRequire("329ek")).FrustumArray);
$parcel$export(module.exports, "GLBufferAttribute", () => (parcelRequire("329ek")).GLBufferAttribute);
$parcel$export(module.exports, "GLSL1", () => (parcelRequire("329ek")).GLSL1);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => (parcelRequire("329ek")).GreaterEqualStencilFunc);
$parcel$export(module.exports, "GreaterStencilFunc", () => (parcelRequire("329ek")).GreaterStencilFunc);
$parcel$export(module.exports, "GridHelper", () => (parcelRequire("329ek")).GridHelper);
$parcel$export(module.exports, "Group", () => (parcelRequire("329ek")).Group);
$parcel$export(module.exports, "HemisphereLight", () => (parcelRequire("329ek")).HemisphereLight);
$parcel$export(module.exports, "HemisphereLightHelper", () => (parcelRequire("329ek")).HemisphereLightHelper);
$parcel$export(module.exports, "IcosahedronGeometry", () => (parcelRequire("329ek")).IcosahedronGeometry);
$parcel$export(module.exports, "ImageBitmapLoader", () => (parcelRequire("329ek")).ImageBitmapLoader);
$parcel$export(module.exports, "ImageLoader", () => (parcelRequire("329ek")).ImageLoader);
$parcel$export(module.exports, "ImageUtils", () => (parcelRequire("329ek")).ImageUtils);
$parcel$export(module.exports, "IncrementStencilOp", () => (parcelRequire("329ek")).IncrementStencilOp);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => (parcelRequire("329ek")).IncrementWrapStencilOp);
$parcel$export(module.exports, "InstancedBufferAttribute", () => (parcelRequire("329ek")).InstancedBufferAttribute);
$parcel$export(module.exports, "InstancedBufferGeometry", () => (parcelRequire("329ek")).InstancedBufferGeometry);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => (parcelRequire("329ek")).InstancedInterleavedBuffer);
$parcel$export(module.exports, "InstancedMesh", () => (parcelRequire("329ek")).InstancedMesh);
$parcel$export(module.exports, "Int16BufferAttribute", () => (parcelRequire("329ek")).Int16BufferAttribute);
$parcel$export(module.exports, "Int32BufferAttribute", () => (parcelRequire("329ek")).Int32BufferAttribute);
$parcel$export(module.exports, "Int8BufferAttribute", () => (parcelRequire("329ek")).Int8BufferAttribute);
$parcel$export(module.exports, "InterleavedBuffer", () => (parcelRequire("329ek")).InterleavedBuffer);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => (parcelRequire("329ek")).InterleavedBufferAttribute);
$parcel$export(module.exports, "Interpolant", () => (parcelRequire("329ek")).Interpolant);
$parcel$export(module.exports, "InterpolateDiscrete", () => (parcelRequire("329ek")).InterpolateDiscrete);
$parcel$export(module.exports, "InterpolateLinear", () => (parcelRequire("329ek")).InterpolateLinear);
$parcel$export(module.exports, "InterpolateSmooth", () => (parcelRequire("329ek")).InterpolateSmooth);
$parcel$export(module.exports, "InterpolationSamplingMode", () => (parcelRequire("329ek")).InterpolationSamplingMode);
$parcel$export(module.exports, "InterpolationSamplingType", () => (parcelRequire("329ek")).InterpolationSamplingType);
$parcel$export(module.exports, "InvertStencilOp", () => (parcelRequire("329ek")).InvertStencilOp);
$parcel$export(module.exports, "KeepStencilOp", () => (parcelRequire("329ek")).KeepStencilOp);
$parcel$export(module.exports, "KeyframeTrack", () => (parcelRequire("329ek")).KeyframeTrack);
$parcel$export(module.exports, "LOD", () => (parcelRequire("329ek")).LOD);
$parcel$export(module.exports, "LatheGeometry", () => (parcelRequire("329ek")).LatheGeometry);
$parcel$export(module.exports, "LessEqualStencilFunc", () => (parcelRequire("329ek")).LessEqualStencilFunc);
$parcel$export(module.exports, "LessStencilFunc", () => (parcelRequire("329ek")).LessStencilFunc);
$parcel$export(module.exports, "Light", () => (parcelRequire("329ek")).Light);
$parcel$export(module.exports, "LightProbe", () => (parcelRequire("329ek")).LightProbe);
$parcel$export(module.exports, "Line", () => (parcelRequire("329ek")).Line);
$parcel$export(module.exports, "Line3", () => (parcelRequire("329ek")).Line3);
$parcel$export(module.exports, "LineBasicMaterial", () => (parcelRequire("329ek")).LineBasicMaterial);
$parcel$export(module.exports, "LineCurve", () => (parcelRequire("329ek")).LineCurve);
$parcel$export(module.exports, "LineCurve3", () => (parcelRequire("329ek")).LineCurve3);
$parcel$export(module.exports, "LineDashedMaterial", () => (parcelRequire("329ek")).LineDashedMaterial);
$parcel$export(module.exports, "LineLoop", () => (parcelRequire("329ek")).LineLoop);
$parcel$export(module.exports, "LineSegments", () => (parcelRequire("329ek")).LineSegments);
$parcel$export(module.exports, "LinearInterpolant", () => (parcelRequire("329ek")).LinearInterpolant);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => (parcelRequire("329ek")).LinearMipMapLinearFilter);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => (parcelRequire("329ek")).LinearMipMapNearestFilter);
$parcel$export(module.exports, "Loader", () => (parcelRequire("329ek")).Loader);
$parcel$export(module.exports, "LoaderUtils", () => (parcelRequire("329ek")).LoaderUtils);
$parcel$export(module.exports, "LoadingManager", () => (parcelRequire("329ek")).LoadingManager);
$parcel$export(module.exports, "LoopOnce", () => (parcelRequire("329ek")).LoopOnce);
$parcel$export(module.exports, "LoopPingPong", () => (parcelRequire("329ek")).LoopPingPong);
$parcel$export(module.exports, "LoopRepeat", () => (parcelRequire("329ek")).LoopRepeat);
$parcel$export(module.exports, "MOUSE", () => (parcelRequire("329ek")).MOUSE);
$parcel$export(module.exports, "Material", () => (parcelRequire("329ek")).Material);
$parcel$export(module.exports, "MaterialLoader", () => (parcelRequire("329ek")).MaterialLoader);
$parcel$export(module.exports, "MathUtils", () => (parcelRequire("329ek")).MathUtils);
$parcel$export(module.exports, "Matrix2", () => (parcelRequire("329ek")).Matrix2);
$parcel$export(module.exports, "MeshLambertMaterial", () => (parcelRequire("329ek")).MeshLambertMaterial);
$parcel$export(module.exports, "MeshMatcapMaterial", () => (parcelRequire("329ek")).MeshMatcapMaterial);
$parcel$export(module.exports, "MeshNormalMaterial", () => (parcelRequire("329ek")).MeshNormalMaterial);
$parcel$export(module.exports, "MeshPhongMaterial", () => (parcelRequire("329ek")).MeshPhongMaterial);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => (parcelRequire("329ek")).MeshPhysicalMaterial);
$parcel$export(module.exports, "MeshStandardMaterial", () => (parcelRequire("329ek")).MeshStandardMaterial);
$parcel$export(module.exports, "MeshToonMaterial", () => (parcelRequire("329ek")).MeshToonMaterial);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => (parcelRequire("329ek")).NearestMipMapLinearFilter);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => (parcelRequire("329ek")).NearestMipMapNearestFilter);
$parcel$export(module.exports, "NeverStencilFunc", () => (parcelRequire("329ek")).NeverStencilFunc);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => (parcelRequire("329ek")).NormalAnimationBlendMode);
$parcel$export(module.exports, "NotEqualStencilFunc", () => (parcelRequire("329ek")).NotEqualStencilFunc);
$parcel$export(module.exports, "NumberKeyframeTrack", () => (parcelRequire("329ek")).NumberKeyframeTrack);
$parcel$export(module.exports, "Object3D", () => (parcelRequire("329ek")).Object3D);
$parcel$export(module.exports, "ObjectLoader", () => (parcelRequire("329ek")).ObjectLoader);
$parcel$export(module.exports, "OctahedronGeometry", () => (parcelRequire("329ek")).OctahedronGeometry);
$parcel$export(module.exports, "Path", () => (parcelRequire("329ek")).Path);
$parcel$export(module.exports, "PlaneHelper", () => (parcelRequire("329ek")).PlaneHelper);
$parcel$export(module.exports, "PointLight", () => (parcelRequire("329ek")).PointLight);
$parcel$export(module.exports, "PointLightHelper", () => (parcelRequire("329ek")).PointLightHelper);
$parcel$export(module.exports, "Points", () => (parcelRequire("329ek")).Points);
$parcel$export(module.exports, "PointsMaterial", () => (parcelRequire("329ek")).PointsMaterial);
$parcel$export(module.exports, "PolarGridHelper", () => (parcelRequire("329ek")).PolarGridHelper);
$parcel$export(module.exports, "PolyhedronGeometry", () => (parcelRequire("329ek")).PolyhedronGeometry);
$parcel$export(module.exports, "PositionalAudio", () => (parcelRequire("329ek")).PositionalAudio);
$parcel$export(module.exports, "PropertyBinding", () => (parcelRequire("329ek")).PropertyBinding);
$parcel$export(module.exports, "PropertyMixer", () => (parcelRequire("329ek")).PropertyMixer);
$parcel$export(module.exports, "QuadraticBezierCurve", () => (parcelRequire("329ek")).QuadraticBezierCurve);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => (parcelRequire("329ek")).QuadraticBezierCurve3);
$parcel$export(module.exports, "Quaternion", () => (parcelRequire("329ek")).Quaternion);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => (parcelRequire("329ek")).QuaternionKeyframeTrack);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => (parcelRequire("329ek")).QuaternionLinearInterpolant);
$parcel$export(module.exports, "RGBDepthPacking", () => (parcelRequire("329ek")).RGBDepthPacking);
$parcel$export(module.exports, "RGBIntegerFormat", () => (parcelRequire("329ek")).RGBIntegerFormat);
$parcel$export(module.exports, "RGDepthPacking", () => (parcelRequire("329ek")).RGDepthPacking);
$parcel$export(module.exports, "RawShaderMaterial", () => (parcelRequire("329ek")).RawShaderMaterial);
$parcel$export(module.exports, "Ray", () => (parcelRequire("329ek")).Ray);
$parcel$export(module.exports, "Raycaster", () => (parcelRequire("329ek")).Raycaster);
$parcel$export(module.exports, "RectAreaLight", () => (parcelRequire("329ek")).RectAreaLight);
$parcel$export(module.exports, "RenderTarget", () => (parcelRequire("329ek")).RenderTarget);
$parcel$export(module.exports, "RenderTarget3D", () => (parcelRequire("329ek")).RenderTarget3D);
$parcel$export(module.exports, "ReplaceStencilOp", () => (parcelRequire("329ek")).ReplaceStencilOp);
$parcel$export(module.exports, "RingGeometry", () => (parcelRequire("329ek")).RingGeometry);
$parcel$export(module.exports, "Scene", () => (parcelRequire("329ek")).Scene);
$parcel$export(module.exports, "ShadowMaterial", () => (parcelRequire("329ek")).ShadowMaterial);
$parcel$export(module.exports, "Shape", () => (parcelRequire("329ek")).Shape);
$parcel$export(module.exports, "ShapeGeometry", () => (parcelRequire("329ek")).ShapeGeometry);
$parcel$export(module.exports, "ShapePath", () => (parcelRequire("329ek")).ShapePath);
$parcel$export(module.exports, "ShapeUtils", () => (parcelRequire("329ek")).ShapeUtils);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("329ek")).Skeleton);
$parcel$export(module.exports, "SkeletonHelper", () => (parcelRequire("329ek")).SkeletonHelper);
$parcel$export(module.exports, "SkinnedMesh", () => (parcelRequire("329ek")).SkinnedMesh);
$parcel$export(module.exports, "Source", () => (parcelRequire("329ek")).Source);
$parcel$export(module.exports, "Sphere", () => (parcelRequire("329ek")).Sphere);
$parcel$export(module.exports, "SphereGeometry", () => (parcelRequire("329ek")).SphereGeometry);
$parcel$export(module.exports, "Spherical", () => (parcelRequire("329ek")).Spherical);
$parcel$export(module.exports, "SphericalHarmonics3", () => (parcelRequire("329ek")).SphericalHarmonics3);
$parcel$export(module.exports, "SplineCurve", () => (parcelRequire("329ek")).SplineCurve);
$parcel$export(module.exports, "SpotLight", () => (parcelRequire("329ek")).SpotLight);
$parcel$export(module.exports, "SpotLightHelper", () => (parcelRequire("329ek")).SpotLightHelper);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("329ek")).Sprite);
$parcel$export(module.exports, "SpriteMaterial", () => (parcelRequire("329ek")).SpriteMaterial);
$parcel$export(module.exports, "StaticCopyUsage", () => (parcelRequire("329ek")).StaticCopyUsage);
$parcel$export(module.exports, "StaticDrawUsage", () => (parcelRequire("329ek")).StaticDrawUsage);
$parcel$export(module.exports, "StaticReadUsage", () => (parcelRequire("329ek")).StaticReadUsage);
$parcel$export(module.exports, "StereoCamera", () => (parcelRequire("329ek")).StereoCamera);
$parcel$export(module.exports, "StreamCopyUsage", () => (parcelRequire("329ek")).StreamCopyUsage);
$parcel$export(module.exports, "StreamDrawUsage", () => (parcelRequire("329ek")).StreamDrawUsage);
$parcel$export(module.exports, "StreamReadUsage", () => (parcelRequire("329ek")).StreamReadUsage);
$parcel$export(module.exports, "StringKeyframeTrack", () => (parcelRequire("329ek")).StringKeyframeTrack);
$parcel$export(module.exports, "TOUCH", () => (parcelRequire("329ek")).TOUCH);
$parcel$export(module.exports, "TetrahedronGeometry", () => (parcelRequire("329ek")).TetrahedronGeometry);
$parcel$export(module.exports, "TextureLoader", () => (parcelRequire("329ek")).TextureLoader);
$parcel$export(module.exports, "TextureUtils", () => (parcelRequire("329ek")).TextureUtils);
$parcel$export(module.exports, "Timer", () => (parcelRequire("329ek")).Timer);
$parcel$export(module.exports, "TimestampQuery", () => (parcelRequire("329ek")).TimestampQuery);
$parcel$export(module.exports, "TorusGeometry", () => (parcelRequire("329ek")).TorusGeometry);
$parcel$export(module.exports, "TorusKnotGeometry", () => (parcelRequire("329ek")).TorusKnotGeometry);
$parcel$export(module.exports, "Triangle", () => (parcelRequire("329ek")).Triangle);
$parcel$export(module.exports, "TriangleFanDrawMode", () => (parcelRequire("329ek")).TriangleFanDrawMode);
$parcel$export(module.exports, "TriangleStripDrawMode", () => (parcelRequire("329ek")).TriangleStripDrawMode);
$parcel$export(module.exports, "TrianglesDrawMode", () => (parcelRequire("329ek")).TrianglesDrawMode);
$parcel$export(module.exports, "TubeGeometry", () => (parcelRequire("329ek")).TubeGeometry);
$parcel$export(module.exports, "UVMapping", () => (parcelRequire("329ek")).UVMapping);
$parcel$export(module.exports, "Uint8BufferAttribute", () => (parcelRequire("329ek")).Uint8BufferAttribute);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => (parcelRequire("329ek")).Uint8ClampedBufferAttribute);
$parcel$export(module.exports, "Uniform", () => (parcelRequire("329ek")).Uniform);
$parcel$export(module.exports, "UniformsGroup", () => (parcelRequire("329ek")).UniformsGroup);
$parcel$export(module.exports, "VectorKeyframeTrack", () => (parcelRequire("329ek")).VectorKeyframeTrack);
$parcel$export(module.exports, "VideoFrameTexture", () => (parcelRequire("329ek")).VideoFrameTexture);
$parcel$export(module.exports, "VideoTexture", () => (parcelRequire("329ek")).VideoTexture);
$parcel$export(module.exports, "WebGL3DRenderTarget", () => (parcelRequire("329ek")).WebGL3DRenderTarget);
$parcel$export(module.exports, "WebGLArrayRenderTarget", () => (parcelRequire("329ek")).WebGLArrayRenderTarget);
$parcel$export(module.exports, "WebGPUCoordinateSystem", () => (parcelRequire("329ek")).WebGPUCoordinateSystem);
$parcel$export(module.exports, "WireframeGeometry", () => (parcelRequire("329ek")).WireframeGeometry);
$parcel$export(module.exports, "WrapAroundEnding", () => (parcelRequire("329ek")).WrapAroundEnding);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => (parcelRequire("329ek")).ZeroCurvatureEnding);
$parcel$export(module.exports, "ZeroSlopeEnding", () => (parcelRequire("329ek")).ZeroSlopeEnding);
$parcel$export(module.exports, "ZeroStencilOp", () => (parcelRequire("329ek")).ZeroStencilOp);
$parcel$export(module.exports, "getConsoleFunction", () => (parcelRequire("329ek")).getConsoleFunction);
$parcel$export(module.exports, "setConsoleFunction", () => (parcelRequire("329ek")).setConsoleFunction);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => (parcelRequire("329ek")).ACESFilmicToneMapping);
$parcel$export(module.exports, "AddEquation", () => (parcelRequire("329ek")).AddEquation);
$parcel$export(module.exports, "AddOperation", () => (parcelRequire("329ek")).AddOperation);
$parcel$export(module.exports, "AdditiveBlending", () => (parcelRequire("329ek")).AdditiveBlending);
$parcel$export(module.exports, "AgXToneMapping", () => (parcelRequire("329ek")).AgXToneMapping);
$parcel$export(module.exports, "AlphaFormat", () => (parcelRequire("329ek")).AlphaFormat);
$parcel$export(module.exports, "AlwaysCompare", () => (parcelRequire("329ek")).AlwaysCompare);
$parcel$export(module.exports, "AlwaysDepth", () => (parcelRequire("329ek")).AlwaysDepth);
$parcel$export(module.exports, "ArrayCamera", () => (parcelRequire("329ek")).ArrayCamera);
$parcel$export(module.exports, "BackSide", () => (parcelRequire("329ek")).BackSide);
$parcel$export(module.exports, "BoxGeometry", () => (parcelRequire("329ek")).BoxGeometry);
$parcel$export(module.exports, "BufferAttribute", () => (parcelRequire("329ek")).BufferAttribute);
$parcel$export(module.exports, "BufferGeometry", () => (parcelRequire("329ek")).BufferGeometry);
$parcel$export(module.exports, "ByteType", () => (parcelRequire("329ek")).ByteType);
$parcel$export(module.exports, "CineonToneMapping", () => (parcelRequire("329ek")).CineonToneMapping);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => (parcelRequire("329ek")).ClampToEdgeWrapping);
$parcel$export(module.exports, "Color", () => (parcelRequire("329ek")).Color);
$parcel$export(module.exports, "ColorManagement", () => (parcelRequire("329ek")).ColorManagement);
$parcel$export(module.exports, "ConstantAlphaFactor", () => (parcelRequire("329ek")).ConstantAlphaFactor);
$parcel$export(module.exports, "ConstantColorFactor", () => (parcelRequire("329ek")).ConstantColorFactor);
$parcel$export(module.exports, "CubeReflectionMapping", () => (parcelRequire("329ek")).CubeReflectionMapping);
$parcel$export(module.exports, "CubeRefractionMapping", () => (parcelRequire("329ek")).CubeRefractionMapping);
$parcel$export(module.exports, "CubeTexture", () => (parcelRequire("329ek")).CubeTexture);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => (parcelRequire("329ek")).CubeUVReflectionMapping);
$parcel$export(module.exports, "CullFaceBack", () => (parcelRequire("329ek")).CullFaceBack);
$parcel$export(module.exports, "CullFaceFront", () => (parcelRequire("329ek")).CullFaceFront);
$parcel$export(module.exports, "CullFaceNone", () => (parcelRequire("329ek")).CullFaceNone);
$parcel$export(module.exports, "CustomBlending", () => (parcelRequire("329ek")).CustomBlending);
$parcel$export(module.exports, "CustomToneMapping", () => (parcelRequire("329ek")).CustomToneMapping);
$parcel$export(module.exports, "Data3DTexture", () => (parcelRequire("329ek")).Data3DTexture);
$parcel$export(module.exports, "DataArrayTexture", () => (parcelRequire("329ek")).DataArrayTexture);
$parcel$export(module.exports, "DataTexture", () => (parcelRequire("329ek")).DataTexture);
$parcel$export(module.exports, "DepthFormat", () => (parcelRequire("329ek")).DepthFormat);
$parcel$export(module.exports, "DepthStencilFormat", () => (parcelRequire("329ek")).DepthStencilFormat);
$parcel$export(module.exports, "DepthTexture", () => (parcelRequire("329ek")).DepthTexture);
$parcel$export(module.exports, "DoubleSide", () => (parcelRequire("329ek")).DoubleSide);
$parcel$export(module.exports, "DstAlphaFactor", () => (parcelRequire("329ek")).DstAlphaFactor);
$parcel$export(module.exports, "DstColorFactor", () => (parcelRequire("329ek")).DstColorFactor);
$parcel$export(module.exports, "EqualCompare", () => (parcelRequire("329ek")).EqualCompare);
$parcel$export(module.exports, "EqualDepth", () => (parcelRequire("329ek")).EqualDepth);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => (parcelRequire("329ek")).EquirectangularReflectionMapping);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => (parcelRequire("329ek")).EquirectangularRefractionMapping);
$parcel$export(module.exports, "Euler", () => (parcelRequire("329ek")).Euler);
$parcel$export(module.exports, "EventDispatcher", () => (parcelRequire("329ek")).EventDispatcher);
$parcel$export(module.exports, "ExternalTexture", () => (parcelRequire("329ek")).ExternalTexture);
$parcel$export(module.exports, "FloatType", () => (parcelRequire("329ek")).FloatType);
$parcel$export(module.exports, "FrontSide", () => (parcelRequire("329ek")).FrontSide);
$parcel$export(module.exports, "Frustum", () => (parcelRequire("329ek")).Frustum);
$parcel$export(module.exports, "GLSL3", () => (parcelRequire("329ek")).GLSL3);
$parcel$export(module.exports, "GreaterCompare", () => (parcelRequire("329ek")).GreaterCompare);
$parcel$export(module.exports, "GreaterDepth", () => (parcelRequire("329ek")).GreaterDepth);
$parcel$export(module.exports, "GreaterEqualCompare", () => (parcelRequire("329ek")).GreaterEqualCompare);
$parcel$export(module.exports, "GreaterEqualDepth", () => (parcelRequire("329ek")).GreaterEqualDepth);
$parcel$export(module.exports, "HalfFloatType", () => (parcelRequire("329ek")).HalfFloatType);
$parcel$export(module.exports, "IntType", () => (parcelRequire("329ek")).IntType);
$parcel$export(module.exports, "Layers", () => (parcelRequire("329ek")).Layers);
$parcel$export(module.exports, "LessCompare", () => (parcelRequire("329ek")).LessCompare);
$parcel$export(module.exports, "LessDepth", () => (parcelRequire("329ek")).LessDepth);
$parcel$export(module.exports, "LessEqualCompare", () => (parcelRequire("329ek")).LessEqualCompare);
$parcel$export(module.exports, "LessEqualDepth", () => (parcelRequire("329ek")).LessEqualDepth);
$parcel$export(module.exports, "LinearFilter", () => (parcelRequire("329ek")).LinearFilter);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => (parcelRequire("329ek")).LinearMipmapLinearFilter);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => (parcelRequire("329ek")).LinearMipmapNearestFilter);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => (parcelRequire("329ek")).LinearSRGBColorSpace);
$parcel$export(module.exports, "LinearToneMapping", () => (parcelRequire("329ek")).LinearToneMapping);
$parcel$export(module.exports, "LinearTransfer", () => (parcelRequire("329ek")).LinearTransfer);
$parcel$export(module.exports, "Matrix3", () => (parcelRequire("329ek")).Matrix3);
$parcel$export(module.exports, "Matrix4", () => (parcelRequire("329ek")).Matrix4);
$parcel$export(module.exports, "MaxEquation", () => (parcelRequire("329ek")).MaxEquation);
$parcel$export(module.exports, "Mesh", () => (parcelRequire("329ek")).Mesh);
$parcel$export(module.exports, "MeshBasicMaterial", () => (parcelRequire("329ek")).MeshBasicMaterial);
$parcel$export(module.exports, "MeshDepthMaterial", () => (parcelRequire("329ek")).MeshDepthMaterial);
$parcel$export(module.exports, "MeshDistanceMaterial", () => (parcelRequire("329ek")).MeshDistanceMaterial);
$parcel$export(module.exports, "MinEquation", () => (parcelRequire("329ek")).MinEquation);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => (parcelRequire("329ek")).MirroredRepeatWrapping);
$parcel$export(module.exports, "MixOperation", () => (parcelRequire("329ek")).MixOperation);
$parcel$export(module.exports, "MultiplyBlending", () => (parcelRequire("329ek")).MultiplyBlending);
$parcel$export(module.exports, "MultiplyOperation", () => (parcelRequire("329ek")).MultiplyOperation);
$parcel$export(module.exports, "NearestFilter", () => (parcelRequire("329ek")).NearestFilter);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => (parcelRequire("329ek")).NearestMipmapLinearFilter);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => (parcelRequire("329ek")).NearestMipmapNearestFilter);
$parcel$export(module.exports, "NeutralToneMapping", () => (parcelRequire("329ek")).NeutralToneMapping);
$parcel$export(module.exports, "NeverCompare", () => (parcelRequire("329ek")).NeverCompare);
$parcel$export(module.exports, "NeverDepth", () => (parcelRequire("329ek")).NeverDepth);
$parcel$export(module.exports, "NoBlending", () => (parcelRequire("329ek")).NoBlending);
$parcel$export(module.exports, "NoColorSpace", () => (parcelRequire("329ek")).NoColorSpace);
$parcel$export(module.exports, "NoToneMapping", () => (parcelRequire("329ek")).NoToneMapping);
$parcel$export(module.exports, "NormalBlending", () => (parcelRequire("329ek")).NormalBlending);
$parcel$export(module.exports, "NotEqualCompare", () => (parcelRequire("329ek")).NotEqualCompare);
$parcel$export(module.exports, "NotEqualDepth", () => (parcelRequire("329ek")).NotEqualDepth);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => (parcelRequire("329ek")).ObjectSpaceNormalMap);
$parcel$export(module.exports, "OneFactor", () => (parcelRequire("329ek")).OneFactor);
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", () => (parcelRequire("329ek")).OneMinusConstantAlphaFactor);
$parcel$export(module.exports, "OneMinusConstantColorFactor", () => (parcelRequire("329ek")).OneMinusConstantColorFactor);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => (parcelRequire("329ek")).OneMinusDstAlphaFactor);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => (parcelRequire("329ek")).OneMinusDstColorFactor);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => (parcelRequire("329ek")).OneMinusSrcAlphaFactor);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => (parcelRequire("329ek")).OneMinusSrcColorFactor);
$parcel$export(module.exports, "OrthographicCamera", () => (parcelRequire("329ek")).OrthographicCamera);
$parcel$export(module.exports, "PCFShadowMap", () => (parcelRequire("329ek")).PCFShadowMap);
$parcel$export(module.exports, "PCFSoftShadowMap", () => (parcelRequire("329ek")).PCFSoftShadowMap);
$parcel$export(module.exports, "PerspectiveCamera", () => (parcelRequire("329ek")).PerspectiveCamera);
$parcel$export(module.exports, "Plane", () => (parcelRequire("329ek")).Plane);
$parcel$export(module.exports, "PlaneGeometry", () => (parcelRequire("329ek")).PlaneGeometry);
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", () => (parcelRequire("329ek")).RED_GREEN_RGTC2_Format);
$parcel$export(module.exports, "RED_RGTC1_Format", () => (parcelRequire("329ek")).RED_RGTC1_Format);
$parcel$export(module.exports, "REVISION", () => (parcelRequire("329ek")).REVISION);
$parcel$export(module.exports, "RGBADepthPacking", () => (parcelRequire("329ek")).RGBADepthPacking);
$parcel$export(module.exports, "RGBAFormat", () => (parcelRequire("329ek")).RGBAFormat);
$parcel$export(module.exports, "RGBAIntegerFormat", () => (parcelRequire("329ek")).RGBAIntegerFormat);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => (parcelRequire("329ek")).RGBA_ASTC_10x8_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => (parcelRequire("329ek")).RGBA_ASTC_12x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => (parcelRequire("329ek")).RGBA_ASTC_12x12_Format);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => (parcelRequire("329ek")).RGBA_ASTC_4x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => (parcelRequire("329ek")).RGBA_ASTC_5x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_5x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_6x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => (parcelRequire("329ek")).RGBA_ASTC_6x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => (parcelRequire("329ek")).RGBA_ASTC_8x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => (parcelRequire("329ek")).RGBA_ASTC_8x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => (parcelRequire("329ek")).RGBA_ASTC_8x8_Format);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => (parcelRequire("329ek")).RGBA_BPTC_Format);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => (parcelRequire("329ek")).RGBA_ETC2_EAC_Format);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => (parcelRequire("329ek")).RGBA_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => (parcelRequire("329ek")).RGBA_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => (parcelRequire("329ek")).RGBA_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => (parcelRequire("329ek")).RGBA_S3TC_DXT3_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => (parcelRequire("329ek")).RGBA_S3TC_DXT5_Format);
$parcel$export(module.exports, "RGBFormat", () => (parcelRequire("329ek")).RGBFormat);
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", () => (parcelRequire("329ek")).RGB_BPTC_SIGNED_Format);
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", () => (parcelRequire("329ek")).RGB_BPTC_UNSIGNED_Format);
$parcel$export(module.exports, "RGB_ETC1_Format", () => (parcelRequire("329ek")).RGB_ETC1_Format);
$parcel$export(module.exports, "RGB_ETC2_Format", () => (parcelRequire("329ek")).RGB_ETC2_Format);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => (parcelRequire("329ek")).RGB_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => (parcelRequire("329ek")).RGB_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => (parcelRequire("329ek")).RGB_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGFormat", () => (parcelRequire("329ek")).RGFormat);
$parcel$export(module.exports, "RGIntegerFormat", () => (parcelRequire("329ek")).RGIntegerFormat);
$parcel$export(module.exports, "RedFormat", () => (parcelRequire("329ek")).RedFormat);
$parcel$export(module.exports, "RedIntegerFormat", () => (parcelRequire("329ek")).RedIntegerFormat);
$parcel$export(module.exports, "ReinhardToneMapping", () => (parcelRequire("329ek")).ReinhardToneMapping);
$parcel$export(module.exports, "RepeatWrapping", () => (parcelRequire("329ek")).RepeatWrapping);
$parcel$export(module.exports, "ReverseSubtractEquation", () => (parcelRequire("329ek")).ReverseSubtractEquation);
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", () => (parcelRequire("329ek")).SIGNED_RED_GREEN_RGTC2_Format);
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", () => (parcelRequire("329ek")).SIGNED_RED_RGTC1_Format);
$parcel$export(module.exports, "SRGBColorSpace", () => (parcelRequire("329ek")).SRGBColorSpace);
$parcel$export(module.exports, "SRGBTransfer", () => (parcelRequire("329ek")).SRGBTransfer);
$parcel$export(module.exports, "ShaderMaterial", () => (parcelRequire("329ek")).ShaderMaterial);
$parcel$export(module.exports, "ShortType", () => (parcelRequire("329ek")).ShortType);
$parcel$export(module.exports, "SrcAlphaFactor", () => (parcelRequire("329ek")).SrcAlphaFactor);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => (parcelRequire("329ek")).SrcAlphaSaturateFactor);
$parcel$export(module.exports, "SrcColorFactor", () => (parcelRequire("329ek")).SrcColorFactor);
$parcel$export(module.exports, "SubtractEquation", () => (parcelRequire("329ek")).SubtractEquation);
$parcel$export(module.exports, "SubtractiveBlending", () => (parcelRequire("329ek")).SubtractiveBlending);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => (parcelRequire("329ek")).TangentSpaceNormalMap);
$parcel$export(module.exports, "Texture", () => (parcelRequire("329ek")).Texture);
$parcel$export(module.exports, "Uint16BufferAttribute", () => (parcelRequire("329ek")).Uint16BufferAttribute);
$parcel$export(module.exports, "Uint32BufferAttribute", () => (parcelRequire("329ek")).Uint32BufferAttribute);
$parcel$export(module.exports, "UniformsUtils", () => (parcelRequire("329ek")).UniformsUtils);
$parcel$export(module.exports, "UnsignedByteType", () => (parcelRequire("329ek")).UnsignedByteType);
$parcel$export(module.exports, "UnsignedInt101111Type", () => (parcelRequire("329ek")).UnsignedInt101111Type);
$parcel$export(module.exports, "UnsignedInt248Type", () => (parcelRequire("329ek")).UnsignedInt248Type);
$parcel$export(module.exports, "UnsignedInt5999Type", () => (parcelRequire("329ek")).UnsignedInt5999Type);
$parcel$export(module.exports, "UnsignedIntType", () => (parcelRequire("329ek")).UnsignedIntType);
$parcel$export(module.exports, "UnsignedShort4444Type", () => (parcelRequire("329ek")).UnsignedShort4444Type);
$parcel$export(module.exports, "UnsignedShort5551Type", () => (parcelRequire("329ek")).UnsignedShort5551Type);
$parcel$export(module.exports, "UnsignedShortType", () => (parcelRequire("329ek")).UnsignedShortType);
$parcel$export(module.exports, "VSMShadowMap", () => (parcelRequire("329ek")).VSMShadowMap);
$parcel$export(module.exports, "Vector2", () => (parcelRequire("329ek")).Vector2);
$parcel$export(module.exports, "Vector3", () => (parcelRequire("329ek")).Vector3);
$parcel$export(module.exports, "Vector4", () => (parcelRequire("329ek")).Vector4);
$parcel$export(module.exports, "WebGLCoordinateSystem", () => (parcelRequire("329ek")).WebGLCoordinateSystem);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => (parcelRequire("329ek")).WebGLCubeRenderTarget);
$parcel$export(module.exports, "WebGLRenderTarget", () => (parcelRequire("329ek")).WebGLRenderTarget);
$parcel$export(module.exports, "WebXRController", () => (parcelRequire("329ek")).WebXRController);
$parcel$export(module.exports, "ZeroFactor", () => (parcelRequire("329ek")).ZeroFactor);
$parcel$export(module.exports, "createCanvasElement", () => (parcelRequire("329ek")).createCanvasElement);
$parcel$export(module.exports, "error", () => (parcelRequire("329ek")).error);
$parcel$export(module.exports, "log", () => (parcelRequire("329ek")).log);
$parcel$export(module.exports, "warn", () => (parcelRequire("329ek")).warn);
$parcel$export(module.exports, "warnOnce", () => (parcelRequire("329ek")).warnOnce);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $329ek = parcelRequire("329ek");
function $169244187a3eb47b$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $169244187a3eb47b$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $169244187a3eb47b$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $169244187a3eb47b$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $169244187a3eb47b$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $169244187a3eb47b$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $169244187a3eb47b$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $169244187a3eb47b$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $169244187a3eb47b$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $169244187a3eb47b$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $169244187a3eb47b$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $169244187a3eb47b$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $169244187a3eb47b$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $169244187a3eb47b$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $169244187a3eb47b$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $169244187a3eb47b$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $169244187a3eb47b$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $169244187a3eb47b$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $169244187a3eb47b$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $169244187a3eb47b$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $169244187a3eb47b$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $169244187a3eb47b$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $169244187a3eb47b$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $169244187a3eb47b$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $169244187a3eb47b$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $169244187a3eb47b$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $169244187a3eb47b$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $169244187a3eb47b$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $169244187a3eb47b$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $169244187a3eb47b$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $169244187a3eb47b$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $169244187a3eb47b$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $169244187a3eb47b$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $169244187a3eb47b$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $169244187a3eb47b$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $169244187a3eb47b$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $169244187a3eb47b$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $169244187a3eb47b$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $169244187a3eb47b$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $169244187a3eb47b$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $169244187a3eb47b$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $169244187a3eb47b$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $169244187a3eb47b$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $169244187a3eb47b$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $169244187a3eb47b$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $169244187a3eb47b$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $169244187a3eb47b$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $169244187a3eb47b$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $169244187a3eb47b$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $169244187a3eb47b$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $169244187a3eb47b$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $169244187a3eb47b$var$lights_physical_pars_fragment = "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 uv = vec2( roughness, dotNV );\n\treturn texture2D( dfgLUT, uv ).rg;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = DFGApprox( vec3(0.0, 0.0, 1.0), vec3(sqrt(1.0 - dotNV * dotNV), 0.0, dotNV), material.roughness );\n\tvec2 dfgL = DFGApprox( vec3(0.0, 0.0, 1.0), vec3(sqrt(1.0 - dotNL * dotNL), 0.0, dotNL), material.roughness );\n\tvec3 FssEss_V = material.specularColor * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColor * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColor + ( 1.0 - material.specularColor ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $169244187a3eb47b$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $169244187a3eb47b$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $169244187a3eb47b$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $169244187a3eb47b$var$logdepthbuf_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $169244187a3eb47b$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $169244187a3eb47b$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $169244187a3eb47b$var$logdepthbuf_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $169244187a3eb47b$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $169244187a3eb47b$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $169244187a3eb47b$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $169244187a3eb47b$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $169244187a3eb47b$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $169244187a3eb47b$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $169244187a3eb47b$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $169244187a3eb47b$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $169244187a3eb47b$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $169244187a3eb47b$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $169244187a3eb47b$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $169244187a3eb47b$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $169244187a3eb47b$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $169244187a3eb47b$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $169244187a3eb47b$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $169244187a3eb47b$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $169244187a3eb47b$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $169244187a3eb47b$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $169244187a3eb47b$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $169244187a3eb47b$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $169244187a3eb47b$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $169244187a3eb47b$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $169244187a3eb47b$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $169244187a3eb47b$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $169244187a3eb47b$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $169244187a3eb47b$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $169244187a3eb47b$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $169244187a3eb47b$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $169244187a3eb47b$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $169244187a3eb47b$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\tfloat depth = unpackRGBAToDepth( texture2D( depths, uv ) );\n\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\treturn step( depth, compare );\n\t\t#else\n\t\t\treturn step( compare, depth );\n\t\t#endif\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow( sampler2D shadow, vec2 uv, float compare ) {\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\tfloat hard_shadow = step( distribution.x, compare );\n\t\t#else\n\t\t\tfloat hard_shadow = step( compare, distribution.x );\n\t\t#endif\n\t\tif ( hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $169244187a3eb47b$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $169244187a3eb47b$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $169244187a3eb47b$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $169244187a3eb47b$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $169244187a3eb47b$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $169244187a3eb47b$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $169244187a3eb47b$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $169244187a3eb47b$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $169244187a3eb47b$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $169244187a3eb47b$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $169244187a3eb47b$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $169244187a3eb47b$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $169244187a3eb47b$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $169244187a3eb47b$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $169244187a3eb47b$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $169244187a3eb47b$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $169244187a3eb47b$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $169244187a3eb47b$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $169244187a3eb47b$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $169244187a3eb47b$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $169244187a3eb47b$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $169244187a3eb47b$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $169244187a3eb47b$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $169244187a3eb47b$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $169244187a3eb47b$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $169244187a3eb47b$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $169244187a3eb47b$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $169244187a3eb47b$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $169244187a3eb47b$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $169244187a3eb47b$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $169244187a3eb47b$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $169244187a3eb47b$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $169244187a3eb47b$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $169244187a3eb47b$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $169244187a3eb47b$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $169244187a3eb47b$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $169244187a3eb47b$export$955f9f2e84c43c8b = {
    alphahash_fragment: $169244187a3eb47b$var$alphahash_fragment,
    alphahash_pars_fragment: $169244187a3eb47b$var$alphahash_pars_fragment,
    alphamap_fragment: $169244187a3eb47b$var$alphamap_fragment,
    alphamap_pars_fragment: $169244187a3eb47b$var$alphamap_pars_fragment,
    alphatest_fragment: $169244187a3eb47b$var$alphatest_fragment,
    alphatest_pars_fragment: $169244187a3eb47b$var$alphatest_pars_fragment,
    aomap_fragment: $169244187a3eb47b$var$aomap_fragment,
    aomap_pars_fragment: $169244187a3eb47b$var$aomap_pars_fragment,
    batching_pars_vertex: $169244187a3eb47b$var$batching_pars_vertex,
    batching_vertex: $169244187a3eb47b$var$batching_vertex,
    begin_vertex: $169244187a3eb47b$var$begin_vertex,
    beginnormal_vertex: $169244187a3eb47b$var$beginnormal_vertex,
    bsdfs: $169244187a3eb47b$var$bsdfs,
    iridescence_fragment: $169244187a3eb47b$var$iridescence_fragment,
    bumpmap_pars_fragment: $169244187a3eb47b$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $169244187a3eb47b$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $169244187a3eb47b$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $169244187a3eb47b$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $169244187a3eb47b$var$clipping_planes_vertex,
    color_fragment: $169244187a3eb47b$var$color_fragment,
    color_pars_fragment: $169244187a3eb47b$var$color_pars_fragment,
    color_pars_vertex: $169244187a3eb47b$var$color_pars_vertex,
    color_vertex: $169244187a3eb47b$var$color_vertex,
    common: $169244187a3eb47b$var$common,
    cube_uv_reflection_fragment: $169244187a3eb47b$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $169244187a3eb47b$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $169244187a3eb47b$var$displacementmap_pars_vertex,
    displacementmap_vertex: $169244187a3eb47b$var$displacementmap_vertex,
    emissivemap_fragment: $169244187a3eb47b$var$emissivemap_fragment,
    emissivemap_pars_fragment: $169244187a3eb47b$var$emissivemap_pars_fragment,
    colorspace_fragment: $169244187a3eb47b$var$colorspace_fragment,
    colorspace_pars_fragment: $169244187a3eb47b$var$colorspace_pars_fragment,
    envmap_fragment: $169244187a3eb47b$var$envmap_fragment,
    envmap_common_pars_fragment: $169244187a3eb47b$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $169244187a3eb47b$var$envmap_pars_fragment,
    envmap_pars_vertex: $169244187a3eb47b$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $169244187a3eb47b$var$envmap_physical_pars_fragment,
    envmap_vertex: $169244187a3eb47b$var$envmap_vertex,
    fog_vertex: $169244187a3eb47b$var$fog_vertex,
    fog_pars_vertex: $169244187a3eb47b$var$fog_pars_vertex,
    fog_fragment: $169244187a3eb47b$var$fog_fragment,
    fog_pars_fragment: $169244187a3eb47b$var$fog_pars_fragment,
    gradientmap_pars_fragment: $169244187a3eb47b$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $169244187a3eb47b$var$lightmap_pars_fragment,
    lights_lambert_fragment: $169244187a3eb47b$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $169244187a3eb47b$var$lights_lambert_pars_fragment,
    lights_pars_begin: $169244187a3eb47b$var$lights_pars_begin,
    lights_toon_fragment: $169244187a3eb47b$var$lights_toon_fragment,
    lights_toon_pars_fragment: $169244187a3eb47b$var$lights_toon_pars_fragment,
    lights_phong_fragment: $169244187a3eb47b$var$lights_phong_fragment,
    lights_phong_pars_fragment: $169244187a3eb47b$var$lights_phong_pars_fragment,
    lights_physical_fragment: $169244187a3eb47b$var$lights_physical_fragment,
    lights_physical_pars_fragment: $169244187a3eb47b$var$lights_physical_pars_fragment,
    lights_fragment_begin: $169244187a3eb47b$var$lights_fragment_begin,
    lights_fragment_maps: $169244187a3eb47b$var$lights_fragment_maps,
    lights_fragment_end: $169244187a3eb47b$var$lights_fragment_end,
    logdepthbuf_fragment: $169244187a3eb47b$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $169244187a3eb47b$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $169244187a3eb47b$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $169244187a3eb47b$var$logdepthbuf_vertex,
    map_fragment: $169244187a3eb47b$var$map_fragment,
    map_pars_fragment: $169244187a3eb47b$var$map_pars_fragment,
    map_particle_fragment: $169244187a3eb47b$var$map_particle_fragment,
    map_particle_pars_fragment: $169244187a3eb47b$var$map_particle_pars_fragment,
    metalnessmap_fragment: $169244187a3eb47b$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $169244187a3eb47b$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $169244187a3eb47b$var$morphinstance_vertex,
    morphcolor_vertex: $169244187a3eb47b$var$morphcolor_vertex,
    morphnormal_vertex: $169244187a3eb47b$var$morphnormal_vertex,
    morphtarget_pars_vertex: $169244187a3eb47b$var$morphtarget_pars_vertex,
    morphtarget_vertex: $169244187a3eb47b$var$morphtarget_vertex,
    normal_fragment_begin: $169244187a3eb47b$var$normal_fragment_begin,
    normal_fragment_maps: $169244187a3eb47b$var$normal_fragment_maps,
    normal_pars_fragment: $169244187a3eb47b$var$normal_pars_fragment,
    normal_pars_vertex: $169244187a3eb47b$var$normal_pars_vertex,
    normal_vertex: $169244187a3eb47b$var$normal_vertex,
    normalmap_pars_fragment: $169244187a3eb47b$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $169244187a3eb47b$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $169244187a3eb47b$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $169244187a3eb47b$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $169244187a3eb47b$var$iridescence_pars_fragment,
    opaque_fragment: $169244187a3eb47b$var$opaque_fragment,
    packing: $169244187a3eb47b$var$packing,
    premultiplied_alpha_fragment: $169244187a3eb47b$var$premultiplied_alpha_fragment,
    project_vertex: $169244187a3eb47b$var$project_vertex,
    dithering_fragment: $169244187a3eb47b$var$dithering_fragment,
    dithering_pars_fragment: $169244187a3eb47b$var$dithering_pars_fragment,
    roughnessmap_fragment: $169244187a3eb47b$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $169244187a3eb47b$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $169244187a3eb47b$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $169244187a3eb47b$var$shadowmap_pars_vertex,
    shadowmap_vertex: $169244187a3eb47b$var$shadowmap_vertex,
    shadowmask_pars_fragment: $169244187a3eb47b$var$shadowmask_pars_fragment,
    skinbase_vertex: $169244187a3eb47b$var$skinbase_vertex,
    skinning_pars_vertex: $169244187a3eb47b$var$skinning_pars_vertex,
    skinning_vertex: $169244187a3eb47b$var$skinning_vertex,
    skinnormal_vertex: $169244187a3eb47b$var$skinnormal_vertex,
    specularmap_fragment: $169244187a3eb47b$var$specularmap_fragment,
    specularmap_pars_fragment: $169244187a3eb47b$var$specularmap_pars_fragment,
    tonemapping_fragment: $169244187a3eb47b$var$tonemapping_fragment,
    tonemapping_pars_fragment: $169244187a3eb47b$var$tonemapping_pars_fragment,
    transmission_fragment: $169244187a3eb47b$var$transmission_fragment,
    transmission_pars_fragment: $169244187a3eb47b$var$transmission_pars_fragment,
    uv_pars_fragment: $169244187a3eb47b$var$uv_pars_fragment,
    uv_pars_vertex: $169244187a3eb47b$var$uv_pars_vertex,
    uv_vertex: $169244187a3eb47b$var$uv_vertex,
    worldpos_vertex: $169244187a3eb47b$var$worldpos_vertex,
    background_vert: $169244187a3eb47b$var$vertex$h,
    background_frag: $169244187a3eb47b$var$fragment$h,
    backgroundCube_vert: $169244187a3eb47b$var$vertex$g,
    backgroundCube_frag: $169244187a3eb47b$var$fragment$g,
    cube_vert: $169244187a3eb47b$var$vertex$f,
    cube_frag: $169244187a3eb47b$var$fragment$f,
    depth_vert: $169244187a3eb47b$var$vertex$e,
    depth_frag: $169244187a3eb47b$var$fragment$e,
    distanceRGBA_vert: $169244187a3eb47b$var$vertex$d,
    distanceRGBA_frag: $169244187a3eb47b$var$fragment$d,
    equirect_vert: $169244187a3eb47b$var$vertex$c,
    equirect_frag: $169244187a3eb47b$var$fragment$c,
    linedashed_vert: $169244187a3eb47b$var$vertex$b,
    linedashed_frag: $169244187a3eb47b$var$fragment$b,
    meshbasic_vert: $169244187a3eb47b$var$vertex$a,
    meshbasic_frag: $169244187a3eb47b$var$fragment$a,
    meshlambert_vert: $169244187a3eb47b$var$vertex$9,
    meshlambert_frag: $169244187a3eb47b$var$fragment$9,
    meshmatcap_vert: $169244187a3eb47b$var$vertex$8,
    meshmatcap_frag: $169244187a3eb47b$var$fragment$8,
    meshnormal_vert: $169244187a3eb47b$var$vertex$7,
    meshnormal_frag: $169244187a3eb47b$var$fragment$7,
    meshphong_vert: $169244187a3eb47b$var$vertex$6,
    meshphong_frag: $169244187a3eb47b$var$fragment$6,
    meshphysical_vert: $169244187a3eb47b$var$vertex$5,
    meshphysical_frag: $169244187a3eb47b$var$fragment$5,
    meshtoon_vert: $169244187a3eb47b$var$vertex$4,
    meshtoon_frag: $169244187a3eb47b$var$fragment$4,
    points_vert: $169244187a3eb47b$var$vertex$3,
    points_frag: $169244187a3eb47b$var$fragment$3,
    shadow_vert: $169244187a3eb47b$var$vertex$2,
    shadow_frag: $169244187a3eb47b$var$fragment$2,
    sprite_vert: $169244187a3eb47b$var$vertex$1,
    sprite_frag: $169244187a3eb47b$var$fragment$1
};
// Uniforms library for shared webgl shaders
const $169244187a3eb47b$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        },
        dfgLUT: {
            value: null
        } // DFG LUT for physically-based rendering
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $329ek.Vector2)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $329ek.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $329ek.Vector2)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $169244187a3eb47b$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.specularmap,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.fog
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.specularmap,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.specularmap,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.envmap,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.roughnessmap,
            $169244187a3eb47b$export$6643083551874bf5.metalnessmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.aomap,
            $169244187a3eb47b$export$6643083551874bf5.lightmap,
            $169244187a3eb47b$export$6643083551874bf5.emissivemap,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.gradientmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            $169244187a3eb47b$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.points,
            $169244187a3eb47b$export$6643083551874bf5.fog
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.bumpmap,
            $169244187a3eb47b$export$6643083551874bf5.normalmap,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.sprite,
            $169244187a3eb47b$export$6643083551874bf5.fog
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.common,
            $169244187a3eb47b$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $329ek.Vector3)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
            $169244187a3eb47b$export$6643083551874bf5.lights,
            $169244187a3eb47b$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $329ek.Color)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.shadow_frag
    }
};
$169244187a3eb47b$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $329ek.mergeUniforms)([
        $169244187a3eb47b$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $329ek.Vector2)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $329ek.Vector2)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $329ek.Color)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $329ek.Color)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $329ek.Vector2)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $329ek.Matrix3)()
            }
        }
    ]),
    vertexShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $169244187a3eb47b$export$955f9f2e84c43c8b.meshphysical_frag
};
const $169244187a3eb47b$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $169244187a3eb47b$var$_e1$1 = /*@__PURE__*/ new (0, $329ek.Euler)();
const $169244187a3eb47b$var$_m1$1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
function $169244187a3eb47b$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $329ek.Color)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $329ek.CubeUVReflectionMapping))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $329ek.Mesh)(new (0, $329ek.BoxGeometry)(1, 1, 1), new (0, $329ek.ShaderMaterial)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $329ek.cloneUniforms)($169244187a3eb47b$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $169244187a3eb47b$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $169244187a3eb47b$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $329ek.BackSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $169244187a3eb47b$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $169244187a3eb47b$var$_e1$1.x *= -1;
            $169244187a3eb47b$var$_e1$1.y *= -1;
            $169244187a3eb47b$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $169244187a3eb47b$var$_e1$1.y *= -1;
                $169244187a3eb47b$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($169244187a3eb47b$var$_m1$1.makeRotationFromEuler($169244187a3eb47b$var$_e1$1));
            boxMesh.material.toneMapped = (0, $329ek.ColorManagement).getTransfer(background.colorSpace) !== (0, $329ek.SRGBTransfer);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(2, 2), new (0, $329ek.ShaderMaterial)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $329ek.cloneUniforms)($169244187a3eb47b$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $169244187a3eb47b$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $169244187a3eb47b$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $329ek.FrontSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $329ek.ColorManagement).getTransfer(background.colorSpace) !== (0, $329ek.SRGBTransfer);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($169244187a3eb47b$var$_rgb, (0, $329ek.getUnlitUniformColorSpace)(renderer));
        state.buffers.color.setClear($169244187a3eb47b$var$_rgb.r, $169244187a3eb47b$var$_rgb.g, $169244187a3eb47b$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $329ek.IntType);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $169244187a3eb47b$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $169244187a3eb47b$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $329ek.RGBAFormat) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $329ek.HalfFloatType) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $329ek.UnsignedByteType) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $329ek.FloatType) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        (0, $329ek.warn)('WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reversedDepthBuffer = parameters.reversedDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reversedDepthBuffer: reversedDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $169244187a3eb47b$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $329ek.Plane)(), viewNormalMatrix = new (0, $329ek.Matrix3)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $169244187a3eb47b$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $329ek.EquirectangularReflectionMapping)) texture.mapping = (0, $329ek.CubeReflectionMapping);
        else if (mapping === (0, $329ek.EquirectangularRefractionMapping)) texture.mapping = (0, $329ek.CubeRefractionMapping);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $329ek.EquirectangularReflectionMapping) || mapping === (0, $329ek.EquirectangularRefractionMapping)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, $329ek.WebGLCubeRenderTarget)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $169244187a3eb47b$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const $169244187a3eb47b$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const $169244187a3eb47b$var$MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const $169244187a3eb47b$var$GGX_SAMPLES = 256;
const $169244187a3eb47b$var$_flatCamera = /*@__PURE__*/ new (0, $329ek.OrthographicCamera)();
const $169244187a3eb47b$var$_clearColor = /*@__PURE__*/ new (0, $329ek.Color)();
let $169244187a3eb47b$var$_oldTarget = null;
let $169244187a3eb47b$var$_oldActiveCubeFace = 0;
let $169244187a3eb47b$var$_oldActiveMipmapLevel = 0;
let $169244187a3eb47b$var$_oldXrEnabled = false;
const $169244187a3eb47b$var$_origin = /*@__PURE__*/ new (0, $329ek.Vector3)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class $169244187a3eb47b$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._backgroundBox = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._blurMaterial = null;
        this._ggxMaterial = null;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $169244187a3eb47b$var$_origin } = options;
        $169244187a3eb47b$var$_oldTarget = this._renderer.getRenderTarget();
        $169244187a3eb47b$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $169244187a3eb47b$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $169244187a3eb47b$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $169244187a3eb47b$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $169244187a3eb47b$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($169244187a3eb47b$var$_oldTarget, $169244187a3eb47b$var$_oldActiveCubeFace, $169244187a3eb47b$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $169244187a3eb47b$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $169244187a3eb47b$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $329ek.CubeReflectionMapping) || texture.mapping === (0, $329ek.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $169244187a3eb47b$var$_oldTarget = this._renderer.getRenderTarget();
        $169244187a3eb47b$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $169244187a3eb47b$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $169244187a3eb47b$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $329ek.LinearFilter),
            minFilter: (0, $329ek.LinearFilter),
            generateMipmaps: false,
            type: (0, $329ek.HalfFloatType),
            format: (0, $329ek.RGBAFormat),
            colorSpace: (0, $329ek.LinearSRGBColorSpace),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $169244187a3eb47b$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $169244187a3eb47b$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $169244187a3eb47b$var$_createPlanes(_lodMax));
            this._blurMaterial = $169244187a3eb47b$var$_getBlurShader(_lodMax, width, height);
            this._ggxMaterial = $169244187a3eb47b$var$_getGGXShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const mesh = new (0, $329ek.Mesh)(new (0, $329ek.BufferGeometry)(), material);
        this._renderer.compile(mesh, $169244187a3eb47b$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $329ek.PerspectiveCamera)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($169244187a3eb47b$var$_clearColor);
        renderer.toneMapping = (0, $329ek.NoToneMapping);
        renderer.autoClear = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        if (reversedDepthBuffer) {
            renderer.setRenderTarget(cubeUVRenderTarget);
            renderer.clearDepth();
            renderer.setRenderTarget(null);
        }
        if (this._backgroundBox === null) this._backgroundBox = new (0, $329ek.Mesh)(new (0, $329ek.BoxGeometry)(), new (0, $329ek.MeshBasicMaterial)({
            name: 'PMREM.Background',
            side: (0, $329ek.BackSide),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($169244187a3eb47b$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $169244187a3eb47b$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $329ek.CubeReflectionMapping) || texture.mapping === (0, $329ek.CubeRefractionMapping);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $169244187a3eb47b$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $169244187a3eb47b$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $169244187a3eb47b$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $169244187a3eb47b$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = ggxMaterial.uniforms;
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.05 + targetRoughness * 0.95;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax: _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $169244187a3eb47b$var$LOD_MIN ? lodOut - _lodMax + $169244187a3eb47b$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        ggxUniforms['envMap'].value = cubeUVRenderTarget.texture;
        ggxUniforms['roughness'].value = adjustedRoughness;
        ggxUniforms['mipInt'].value = _lodMax - lodIn; // Sample from input LOD
        $169244187a3eb47b$var$_setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, $169244187a3eb47b$var$_flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        ggxUniforms['envMap'].value = pingPongRenderTarget.texture;
        ggxUniforms['roughness'].value = 0.0; // Direct copy
        ggxUniforms['mipInt'].value = _lodMax - lodOut; // Read from the level we just wrote
        $169244187a3eb47b$var$_setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, $169244187a3eb47b$var$_flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, $329ek.error)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $169244187a3eb47b$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $169244187a3eb47b$var$MAX_SAMPLES;
        if (samples > $169244187a3eb47b$var$MAX_SAMPLES) (0, $329ek.warn)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$169244187a3eb47b$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $169244187a3eb47b$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $169244187a3eb47b$var$LOD_MIN ? lodOut - _lodMax + $169244187a3eb47b$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $169244187a3eb47b$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $169244187a3eb47b$var$_flatCamera);
    }
}
function $169244187a3eb47b$var$_createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $169244187a3eb47b$var$LOD_MIN + 1 + $169244187a3eb47b$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $169244187a3eb47b$var$LOD_MIN) sigma = $169244187a3eb47b$var$EXTRA_LOD_SIGMA[i - lodMax + $169244187a3eb47b$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $329ek.BufferGeometry)();
        planes.setAttribute('position', new (0, $329ek.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, $329ek.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $329ek.BufferAttribute)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, $329ek.Mesh)(planes, null));
        if (lod > $169244187a3eb47b$var$LOD_MIN) lod--;
    }
    return {
        lodMeshes: lodMeshes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $169244187a3eb47b$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $329ek.WebGLRenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $329ek.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $169244187a3eb47b$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $169244187a3eb47b$var$_getGGXShader(lodMax, width, height) {
    const shaderMaterial = new (0, $329ek.ShaderMaterial)({
        name: 'PMREMGGXConvolution',
        defines: {
            'GGX_SAMPLES': $169244187a3eb47b$var$GGX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'roughness': {
                value: 0.0
            },
            'mipInt': {
                value: 0
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 3.2: Transform view direction to hemisphere configuration
				vec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));

				// Section 4.1: Orthonormal basis
				float lensq = Vh.x * Vh.x + Vh.y * Vh.y;
				vec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(Vh, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + Vh.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $169244187a3eb47b$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($169244187a3eb47b$var$MAX_SAMPLES);
    const poleAxis = new (0, $329ek.Vector3)(0, 1, 0);
    const shaderMaterial = new (0, $329ek.ShaderMaterial)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $169244187a3eb47b$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $169244187a3eb47b$var$_getEquirectMaterial() {
    return new (0, $329ek.ShaderMaterial)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $169244187a3eb47b$var$_getCubemapMaterial() {
    return new (0, $329ek.ShaderMaterial)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $169244187a3eb47b$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $329ek.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $169244187a3eb47b$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $169244187a3eb47b$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $329ek.EquirectangularReflectionMapping) || mapping === (0, $329ek.EquirectangularRefractionMapping);
            const isCubeMap = mapping === (0, $329ek.CubeReflectionMapping) || mapping === (0, $329ek.CubeRefractionMapping);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $169244187a3eb47b$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $169244187a3eb47b$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        const extension = gl.getExtension(name);
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $329ek.warnOnce)('WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $169244187a3eb47b$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, $329ek.arrayNeedsUint32)(indices) ? (0, $329ek.Uint32BufferAttribute) : (0, $329ek.Uint16BufferAttribute))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $169244187a3eb47b$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $169244187a3eb47b$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                (0, $329ek.error)('WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $169244187a3eb47b$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $329ek.Vector4)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $329ek.DataArrayTexture)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $329ek.FloatType);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $329ek.Vector2)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $169244187a3eb47b$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $169244187a3eb47b$var$emptyTexture = /*@__PURE__*/ new (0, $329ek.Texture)();
const $169244187a3eb47b$var$emptyShadowTexture = /*@__PURE__*/ new (0, $329ek.DepthTexture)(1, 1);
const $169244187a3eb47b$var$emptyArrayTexture = /*@__PURE__*/ new (0, $329ek.DataArrayTexture)();
const $169244187a3eb47b$var$empty3dTexture = /*@__PURE__*/ new (0, $329ek.Data3DTexture)();
const $169244187a3eb47b$var$emptyCubeTexture = /*@__PURE__*/ new (0, $329ek.CubeTexture)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $169244187a3eb47b$var$arrayCacheF32 = [];
const $169244187a3eb47b$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $169244187a3eb47b$var$mat4array = new Float32Array(16);
const $169244187a3eb47b$var$mat3array = new Float32Array(9);
const $169244187a3eb47b$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $169244187a3eb47b$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $169244187a3eb47b$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $169244187a3eb47b$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $169244187a3eb47b$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $169244187a3eb47b$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $169244187a3eb47b$var$allocTexUnits(textures, n) {
    let r = $169244187a3eb47b$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $169244187a3eb47b$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $169244187a3eb47b$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $169244187a3eb47b$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $169244187a3eb47b$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, elements)) return;
        $169244187a3eb47b$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $169244187a3eb47b$var$mat2array);
        $169244187a3eb47b$var$copyArray(cache, elements);
    }
}
function $169244187a3eb47b$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, elements)) return;
        $169244187a3eb47b$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $169244187a3eb47b$var$mat3array);
        $169244187a3eb47b$var$copyArray(cache, elements);
    }
}
function $169244187a3eb47b$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, elements)) return;
        $169244187a3eb47b$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $169244187a3eb47b$var$mat4array);
        $169244187a3eb47b$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $169244187a3eb47b$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $169244187a3eb47b$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $169244187a3eb47b$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $169244187a3eb47b$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
function $169244187a3eb47b$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($169244187a3eb47b$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $169244187a3eb47b$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $169244187a3eb47b$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $169244187a3eb47b$var$emptyShadowTexture.compareFunction = (0, $329ek.LessEqualCompare); // #28670
        emptyTexture2D = $169244187a3eb47b$var$emptyShadowTexture;
    } else emptyTexture2D = $169244187a3eb47b$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $169244187a3eb47b$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $169244187a3eb47b$var$empty3dTexture, unit);
}
function $169244187a3eb47b$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $169244187a3eb47b$var$emptyCubeTexture, unit);
}
function $169244187a3eb47b$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $169244187a3eb47b$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $169244187a3eb47b$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $169244187a3eb47b$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $169244187a3eb47b$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $169244187a3eb47b$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $169244187a3eb47b$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $169244187a3eb47b$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $169244187a3eb47b$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $169244187a3eb47b$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $169244187a3eb47b$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $169244187a3eb47b$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $169244187a3eb47b$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $169244187a3eb47b$var$setValueV4i; // _VEC4
        case 0x1405:
            return $169244187a3eb47b$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $169244187a3eb47b$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $169244187a3eb47b$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $169244187a3eb47b$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $169244187a3eb47b$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $169244187a3eb47b$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $169244187a3eb47b$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $169244187a3eb47b$var$setValueT2DArray1;
    }
}
// Array of scalars
function $169244187a3eb47b$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $169244187a3eb47b$var$setValueV2fArray(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $169244187a3eb47b$var$setValueV3fArray(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $169244187a3eb47b$var$setValueV4fArray(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $169244187a3eb47b$var$setValueM2Array(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $169244187a3eb47b$var$setValueM3Array(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $169244187a3eb47b$var$setValueM4Array(gl, v) {
    const data = $169244187a3eb47b$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $169244187a3eb47b$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $169244187a3eb47b$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $169244187a3eb47b$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $169244187a3eb47b$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $169244187a3eb47b$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $169244187a3eb47b$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $169244187a3eb47b$var$emptyTexture, units[i]);
}
function $169244187a3eb47b$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $169244187a3eb47b$var$empty3dTexture, units[i]);
}
function $169244187a3eb47b$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $169244187a3eb47b$var$emptyCubeTexture, units[i]);
}
function $169244187a3eb47b$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $169244187a3eb47b$var$allocTexUnits(textures, n);
    if (!$169244187a3eb47b$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $169244187a3eb47b$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $169244187a3eb47b$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $169244187a3eb47b$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $169244187a3eb47b$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $169244187a3eb47b$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $169244187a3eb47b$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $169244187a3eb47b$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $169244187a3eb47b$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $169244187a3eb47b$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $169244187a3eb47b$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $169244187a3eb47b$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $169244187a3eb47b$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $169244187a3eb47b$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $169244187a3eb47b$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $169244187a3eb47b$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $169244187a3eb47b$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $169244187a3eb47b$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $169244187a3eb47b$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $169244187a3eb47b$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $169244187a3eb47b$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $169244187a3eb47b$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $169244187a3eb47b$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $169244187a3eb47b$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $169244187a3eb47b$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $169244187a3eb47b$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $169244187a3eb47b$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $169244187a3eb47b$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $169244187a3eb47b$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $169244187a3eb47b$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $169244187a3eb47b$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $169244187a3eb47b$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $169244187a3eb47b$var$RePathPart.exec(path), matchEnd = $169244187a3eb47b$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $169244187a3eb47b$var$addUniform(container, subscript === undefined ? new $169244187a3eb47b$var$SingleUniform(id, activeInfo, addr) : new $169244187a3eb47b$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $169244187a3eb47b$var$StructuredUniform(id);
                $169244187a3eb47b$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $169244187a3eb47b$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $169244187a3eb47b$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $169244187a3eb47b$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $169244187a3eb47b$var$COMPLETION_STATUS_KHR = 0x91B1;
let $169244187a3eb47b$var$programIdCount = 0;
function $169244187a3eb47b$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $169244187a3eb47b$var$_m0 = /*@__PURE__*/ new (0, $329ek.Matrix3)();
function $169244187a3eb47b$var$getEncodingComponents(colorSpace) {
    (0, $329ek.ColorManagement)._getMatrix($169244187a3eb47b$var$_m0, (0, $329ek.ColorManagement).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$169244187a3eb47b$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $329ek.ColorManagement).getTransfer(colorSpace)){
        case 0, $329ek.LinearTransfer:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $329ek.SRGBTransfer:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            (0, $329ek.warn)('WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $169244187a3eb47b$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
    const errors = shaderInfoLog.trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $169244187a3eb47b$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $169244187a3eb47b$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $169244187a3eb47b$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
function $169244187a3eb47b$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case 0, $329ek.LinearToneMapping:
            toneMappingName = 'Linear';
            break;
        case 0, $329ek.ReinhardToneMapping:
            toneMappingName = 'Reinhard';
            break;
        case 0, $329ek.CineonToneMapping:
            toneMappingName = 'Cineon';
            break;
        case 0, $329ek.ACESFilmicToneMapping:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $329ek.AgXToneMapping:
            toneMappingName = 'AgX';
            break;
        case 0, $329ek.NeutralToneMapping:
            toneMappingName = 'Neutral';
            break;
        case 0, $329ek.CustomToneMapping:
            toneMappingName = 'Custom';
            break;
        default:
            (0, $329ek.warn)('WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $169244187a3eb47b$var$_v0 = /*@__PURE__*/ new (0, $329ek.Vector3)();
function $169244187a3eb47b$var$getLuminanceFunction() {
    (0, $329ek.ColorManagement).getLuminanceCoefficients($169244187a3eb47b$var$_v0);
    const r = $169244187a3eb47b$var$_v0.x.toFixed(4);
    const g = $169244187a3eb47b$var$_v0.y.toFixed(4);
    const b = $169244187a3eb47b$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $169244187a3eb47b$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
}
function $169244187a3eb47b$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $169244187a3eb47b$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // log( 'WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $169244187a3eb47b$var$filterEmptyLine(string) {
    return string !== '';
}
function $169244187a3eb47b$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $169244187a3eb47b$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $169244187a3eb47b$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $169244187a3eb47b$var$resolveIncludes(string) {
    return string.replace($169244187a3eb47b$var$includePattern, $169244187a3eb47b$var$includeReplacer);
}
const $169244187a3eb47b$var$shaderChunkMap = new Map();
function $169244187a3eb47b$var$includeReplacer(match, include) {
    let string = $169244187a3eb47b$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $169244187a3eb47b$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $169244187a3eb47b$export$955f9f2e84c43c8b[newInclude];
            (0, $329ek.warn)('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $169244187a3eb47b$var$resolveIncludes(string);
}
// Unroll Loops
const $169244187a3eb47b$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $169244187a3eb47b$var$unrollLoops(string) {
    return string.replace($169244187a3eb47b$var$unrollLoopPattern, $169244187a3eb47b$var$loopReplacer);
}
function $169244187a3eb47b$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $169244187a3eb47b$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $169244187a3eb47b$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $329ek.PCFShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $329ek.PCFSoftShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $329ek.VSMShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $169244187a3eb47b$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $329ek.CubeReflectionMapping:
        case 0, $329ek.CubeRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $329ek.CubeUVReflectionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $169244187a3eb47b$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $329ek.CubeRefractionMapping:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $169244187a3eb47b$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $329ek.MultiplyOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $329ek.MixOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $329ek.AddOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $169244187a3eb47b$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $169244187a3eb47b$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $169244187a3eb47b$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $169244187a3eb47b$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $169244187a3eb47b$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $169244187a3eb47b$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $169244187a3eb47b$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $169244187a3eb47b$var$generateVertexExtensions(parameters);
    const customDefines = $169244187a3eb47b$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $169244187a3eb47b$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $169244187a3eb47b$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $329ek.NoToneMapping) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $329ek.NoToneMapping) ? $169244187a3eb47b$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $329ek.NoToneMapping) ? $169244187a3eb47b$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $169244187a3eb47b$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $169244187a3eb47b$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $169244187a3eb47b$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($169244187a3eb47b$var$filterEmptyLine).join('\n');
    }
    vertexShader = $169244187a3eb47b$var$resolveIncludes(vertexShader);
    vertexShader = $169244187a3eb47b$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $169244187a3eb47b$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $169244187a3eb47b$var$resolveIncludes(fragmentShader);
    fragmentShader = $169244187a3eb47b$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $169244187a3eb47b$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $169244187a3eb47b$var$unrollLoops(vertexShader);
    fragmentShader = $169244187a3eb47b$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $329ek.GLSL3) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $329ek.GLSL3) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // log( '*VERTEX*', vertexGlsl );
    // log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $169244187a3eb47b$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $169244187a3eb47b$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programInfoLog = gl.getProgramInfoLog(program) || '';
            const vertexShaderInfoLog = gl.getShaderInfoLog(glVertexShader) || '';
            const fragmentShaderInfoLog = gl.getShaderInfoLog(glFragmentShader) || '';
            const programLog = programInfoLog.trim();
            const vertexLog = vertexShaderInfoLog.trim();
            const fragmentLog = fragmentShaderInfoLog.trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $169244187a3eb47b$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $169244187a3eb47b$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, $329ek.error)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, $329ek.warn)('WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $169244187a3eb47b$var$WebGLUniforms(gl, program);
        cachedAttributes = $169244187a3eb47b$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $169244187a3eb47b$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $169244187a3eb47b$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $169244187a3eb47b$var$_id = 0;
class $169244187a3eb47b$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $169244187a3eb47b$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $169244187a3eb47b$var$WebGLShaderStage {
    constructor(code){
        this.id = $169244187a3eb47b$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $169244187a3eb47b$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $329ek.Layers)();
    const _customShaders = new $169244187a3eb47b$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $329ek.CubeUVReflectionMapping) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) (0, $329ek.warn)('WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $169244187a3eb47b$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $329ek.NoToneMapping);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $329ek.LinearSRGBColorSpace),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $329ek.ObjectSpaceNormalMap),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $329ek.TangentSpaceNormalMap),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $329ek.NormalBlending) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true && material.wireframe === false,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reversedDepthBuffer: reversedDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $329ek.ColorManagement).getTransfer(material.map.colorSpace) === (0, $329ek.SRGBTransfer),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $329ek.ColorManagement).getTransfer(material.emissiveMap.colorSpace) === (0, $329ek.SRGBTransfer),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $329ek.DoubleSide),
            flipSided: material.side === (0, $329ek.BackSide),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        if (parameters.gradientMap) _programLayers.enable(22);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reversedDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $169244187a3eb47b$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $329ek.UniformsUtils).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $169244187a3eb47b$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $169244187a3eb47b$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $169244187a3eb47b$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $169244187a3eb47b$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $169244187a3eb47b$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $169244187a3eb47b$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $169244187a3eb47b$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $169244187a3eb47b$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $169244187a3eb47b$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $169244187a3eb47b$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $329ek.Vector3)(),
                        color: new (0, $329ek.Color)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $329ek.Vector3)(),
                        direction: new (0, $329ek.Vector3)(),
                        color: new (0, $329ek.Color)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $329ek.Vector3)(),
                        color: new (0, $329ek.Color)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $329ek.Vector3)(),
                        skyColor: new (0, $329ek.Color)(),
                        groundColor: new (0, $329ek.Color)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $329ek.Color)(),
                        position: new (0, $329ek.Vector3)(),
                        halfWidth: new (0, $329ek.Vector3)(),
                        halfHeight: new (0, $329ek.Vector3)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $169244187a3eb47b$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $329ek.Vector2)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $329ek.Vector2)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $329ek.Vector2)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $169244187a3eb47b$var$nextVersion = 0;
function $169244187a3eb47b$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $169244187a3eb47b$var$WebGLLights(extensions) {
    const cache = new $169244187a3eb47b$var$UniformsCache();
    const shadowCache = $169244187a3eb47b$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $329ek.Vector3)());
    const vector3 = new (0, $329ek.Vector3)();
    const matrix4 = new (0, $329ek.Matrix4)();
    const matrix42 = new (0, $329ek.Matrix4)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($169244187a3eb47b$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $169244187a3eb47b$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $169244187a3eb47b$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $169244187a3eb47b$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $169244187a3eb47b$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $169244187a3eb47b$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $169244187a3eb47b$var$WebGLRenderState(extensions) {
    const lights = new $169244187a3eb47b$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $169244187a3eb47b$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $169244187a3eb47b$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $169244187a3eb47b$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $169244187a3eb47b$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $169244187a3eb47b$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $169244187a3eb47b$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $329ek.Frustum)();
    const _shadowMapSize = new (0, $329ek.Vector2)(), _viewportSize = new (0, $329ek.Vector2)(), _viewport = new (0, $329ek.Vector4)(), _depthMaterial = new (0, $329ek.MeshDepthMaterial)({
        depthPacking: (0, $329ek.RGBADepthPacking)
    }), _distanceMaterial = new (0, $329ek.MeshDistanceMaterial)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $329ek.FrontSide)]: (0, $329ek.BackSide),
        [(0, $329ek.BackSide)]: (0, $329ek.FrontSide),
        [(0, $329ek.DoubleSide)]: (0, $329ek.DoubleSide)
    };
    const shadowMaterialVertical = new (0, $329ek.ShaderMaterial)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $329ek.Vector2)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $169244187a3eb47b$var$vertex,
        fragmentShader: $169244187a3eb47b$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $329ek.BufferGeometry)();
    fullScreenTri.setAttribute('position', new (0, $329ek.BufferAttribute)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $329ek.Mesh)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $329ek.PCFShadowMap);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $329ek.NoBlending));
        if (_state.buffers.depth.getReversed() === true) _state.buffers.color.setClear(0, 0, 0, 0);
        else _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== (0, $329ek.VSMShadowMap) && this.type === (0, $329ek.VSMShadowMap);
        const fromVSM = _previousType === (0, $329ek.VSMShadowMap) && this.type !== (0, $329ek.VSMShadowMap);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                (0, $329ek.warn)('WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== (0, $329ek.VSMShadowMap) ? {
                    minFilter: (0, $329ek.NearestFilter),
                    magFilter: (0, $329ek.NearestFilter)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $329ek.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $329ek.VSMShadowMap)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $329ek.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $329ek.VSMShadowMap)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $329ek.VSMShadowMap)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $169244187a3eb47b$var$reversedFuncs = {
    [(0, $329ek.NeverDepth)]: (0, $329ek.AlwaysDepth),
    [(0, $329ek.LessDepth)]: (0, $329ek.GreaterDepth),
    [(0, $329ek.EqualDepth)]: (0, $329ek.NotEqualDepth),
    [(0, $329ek.LessEqualDepth)]: (0, $329ek.GreaterEqualDepth),
    [(0, $329ek.AlwaysDepth)]: (0, $329ek.NeverDepth),
    [(0, $329ek.GreaterDepth)]: (0, $329ek.LessDepth),
    [(0, $329ek.NotEqualDepth)]: (0, $329ek.EqualDepth),
    [(0, $329ek.GreaterEqualDepth)]: (0, $329ek.LessEqualDepth)
};
function $169244187a3eb47b$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $329ek.Vector4)();
        let currentColorMask = null;
        const currentColorClear = new (0, $329ek.Vector4)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = $169244187a3eb47b$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $329ek.NeverDepth:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $329ek.AlwaysDepth:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $329ek.LessDepth:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $329ek.LessEqualDepth:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $329ek.EqualDepth:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $329ek.GreaterEqualDepth:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $329ek.GreaterDepth:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $329ek.NotEqualDepth:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $329ek.Color)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $329ek.Vector4)().fromArray(scissorParam);
    const currentViewport = new (0, $329ek.Vector4)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $329ek.LessEqualDepth));
    setFlipSided(false);
    setCullFace((0, $329ek.CullFaceBack));
    enable(gl.CULL_FACE);
    setBlending((0, $329ek.NoBlending));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $329ek.AddEquation)]: gl.FUNC_ADD,
        [(0, $329ek.SubtractEquation)]: gl.FUNC_SUBTRACT,
        [(0, $329ek.ReverseSubtractEquation)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $329ek.MinEquation] = gl.MIN;
    equationToGL[0, $329ek.MaxEquation] = gl.MAX;
    const factorToGL = {
        [(0, $329ek.ZeroFactor)]: gl.ZERO,
        [(0, $329ek.OneFactor)]: gl.ONE,
        [(0, $329ek.SrcColorFactor)]: gl.SRC_COLOR,
        [(0, $329ek.SrcAlphaFactor)]: gl.SRC_ALPHA,
        [(0, $329ek.SrcAlphaSaturateFactor)]: gl.SRC_ALPHA_SATURATE,
        [(0, $329ek.DstColorFactor)]: gl.DST_COLOR,
        [(0, $329ek.DstAlphaFactor)]: gl.DST_ALPHA,
        [(0, $329ek.OneMinusSrcColorFactor)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $329ek.OneMinusSrcAlphaFactor)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $329ek.OneMinusDstColorFactor)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $329ek.OneMinusDstAlphaFactor)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $329ek.ConstantColorFactor)]: gl.CONSTANT_COLOR,
        [(0, $329ek.OneMinusConstantColorFactor)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $329ek.ConstantAlphaFactor)]: gl.CONSTANT_ALPHA,
        [(0, $329ek.OneMinusConstantAlphaFactor)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $329ek.NoBlending)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $329ek.CustomBlending)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $329ek.AddEquation) || currentBlendEquationAlpha !== (0, $329ek.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $329ek.AddEquation);
                    currentBlendEquationAlpha = (0, $329ek.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $329ek.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $329ek.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $329ek.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $329ek.MultiplyBlending:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, $329ek.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $329ek.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $329ek.AdditiveBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $329ek.SubtractiveBlending:
                        (0, $329ek.error)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $329ek.MultiplyBlending:
                        (0, $329ek.error)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, $329ek.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $329ek.DoubleSide) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $329ek.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $329ek.NormalBlending) && material.transparent === false ? setBlending((0, $329ek.NoBlending)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $329ek.CullFaceNone)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $329ek.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $329ek.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (error) {
            error('WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $329ek.Color)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $169244187a3eb47b$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $329ek.Vector2)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $329ek.createElementNS)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                (0, $329ek.warn)('WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) (0, $329ek.warn)('WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            (0, $329ek.warn)('WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
            if (glType === _gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = _gl.R11F_G11F_B10F;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $329ek.LinearTransfer) : (0, $329ek.ColorManagement).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $329ek.SRGBTransfer) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $329ek.UnsignedIntType) || depthType === (0, $329ek.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $329ek.FloatType)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $329ek.UnsignedShortType)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                (0, $329ek.warn)('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $329ek.UnsignedIntType) || depthType === (0, $329ek.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $329ek.FloatType)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $329ek.UnsignedShortType)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $329ek.NearestFilter) && texture.minFilter !== (0, $329ek.LinearFilter)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) (0, $329ek.warn)('WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.isExternalTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) (0, $329ek.warn)('WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) (0, $329ek.warn)('WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $329ek.RepeatWrapping)]: _gl.REPEAT,
        [(0, $329ek.ClampToEdgeWrapping)]: _gl.CLAMP_TO_EDGE,
        [(0, $329ek.MirroredRepeatWrapping)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $329ek.NearestFilter)]: _gl.NEAREST,
        [(0, $329ek.NearestMipmapNearestFilter)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $329ek.NearestMipmapLinearFilter)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $329ek.LinearFilter)]: _gl.LINEAR,
        [(0, $329ek.LinearMipmapNearestFilter)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $329ek.LinearMipmapLinearFilter)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $329ek.NeverCompare)]: _gl.NEVER,
        [(0, $329ek.AlwaysCompare)]: _gl.ALWAYS,
        [(0, $329ek.LessCompare)]: _gl.LESS,
        [(0, $329ek.LessEqualCompare)]: _gl.LEQUAL,
        [(0, $329ek.EqualCompare)]: _gl.EQUAL,
        [(0, $329ek.GreaterEqualCompare)]: _gl.GEQUAL,
        [(0, $329ek.GreaterCompare)]: _gl.GREATER,
        [(0, $329ek.NotEqualCompare)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $329ek.FloatType) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $329ek.LinearFilter) || texture.magFilter === (0, $329ek.LinearMipmapNearestFilter) || texture.magFilter === (0, $329ek.NearestMipmapLinearFilter) || texture.magFilter === (0, $329ek.LinearMipmapLinearFilter) || texture.minFilter === (0, $329ek.LinearFilter) || texture.minFilter === (0, $329ek.LinearMipmapNearestFilter) || texture.minFilter === (0, $329ek.NearestMipmapLinearFilter) || texture.minFilter === (0, $329ek.LinearMipmapLinearFilter))) (0, $329ek.warn)('WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $329ek.NearestFilter)) return;
            if (texture.minFilter !== (0, $329ek.NearestMipmapLinearFilter) && texture.minFilter !== (0, $329ek.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, $329ek.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        const componentStride = 4; // only RGBA supported
        const updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                const previousEnd = previousRange.start + previousRange.count;
                const currentRow = getRow(range.start, image.width, componentStride);
                const previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const pixelStart = Math.floor(range.start / componentStride);
                const pixelCount = Math.ceil(range.count / componentStride);
                const x = pixelStart % image.width;
                const y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                const width = pixelCount;
                const height = 1;
                _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $329ek.ColorManagement).getPrimaries((0, $329ek.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $329ek.NoColorSpace) ? null : (0, $329ek.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $329ek.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $329ek.DepthStencilFormat), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $329ek.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $329ek.getByteLength)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else (0, $329ek.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $329ek.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $329ek.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $329ek.getByteLength)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $329ek.ColorManagement).getPrimaries((0, $329ek.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $329ek.NoColorSpace) ? null : (0, $329ek.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $329ek.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $329ek.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $329ek.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $329ek.DepthFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $329ek.DepthStencilFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget);
            else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                let glTextureType = _gl.TEXTURE_2D;
                if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                state.bindTexture(glTextureType, attachmentProperties.__webglTexture);
                setTextureParameters(glTextureType, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, glTextureType, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(glTextureType);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $329ek.LinearSRGBColorSpace) && colorSpace !== (0, $329ek.NoColorSpace)) {
            // sRGB
            if ((0, $329ek.ColorManagement).getTransfer(colorSpace) === (0, $329ek.SRGBTransfer)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $329ek.RGBAFormat) || type !== (0, $329ek.UnsignedByteType)) (0, $329ek.warn)('WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else (0, $329ek.error)('WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $169244187a3eb47b$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $329ek.NoColorSpace)) {
        let extension;
        const transfer = (0, $329ek.ColorManagement).getTransfer(colorSpace);
        if (p === (0, $329ek.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, $329ek.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $329ek.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $329ek.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $329ek.UnsignedInt101111Type)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, $329ek.ByteType)) return gl.BYTE;
        if (p === (0, $329ek.ShortType)) return gl.SHORT;
        if (p === (0, $329ek.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, $329ek.IntType)) return gl.INT;
        if (p === (0, $329ek.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, $329ek.FloatType)) return gl.FLOAT;
        if (p === (0, $329ek.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, $329ek.AlphaFormat)) return gl.ALPHA;
        if (p === (0, $329ek.RGBFormat)) return gl.RGB;
        if (p === (0, $329ek.RGBAFormat)) return gl.RGBA;
        if (p === (0, $329ek.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, $329ek.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $329ek.RedFormat)) return gl.RED;
        if (p === (0, $329ek.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, $329ek.RGFormat)) return gl.RG;
        if (p === (0, $329ek.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, $329ek.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $329ek.RGB_S3TC_DXT1_Format) || p === (0, $329ek.RGBA_S3TC_DXT1_Format) || p === (0, $329ek.RGBA_S3TC_DXT3_Format) || p === (0, $329ek.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, $329ek.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $329ek.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $329ek.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $329ek.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $329ek.RGB_PVRTC_4BPPV1_Format) || p === (0, $329ek.RGB_PVRTC_2BPPV1_Format) || p === (0, $329ek.RGBA_PVRTC_4BPPV1_Format) || p === (0, $329ek.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $329ek.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $329ek.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $329ek.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $329ek.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $329ek.RGB_ETC1_Format) || p === (0, $329ek.RGB_ETC2_Format) || p === (0, $329ek.RGBA_ETC2_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $329ek.RGB_ETC1_Format) || p === (0, $329ek.RGB_ETC2_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $329ek.RGBA_ETC2_EAC_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $329ek.RGBA_ASTC_4x4_Format) || p === (0, $329ek.RGBA_ASTC_5x4_Format) || p === (0, $329ek.RGBA_ASTC_5x5_Format) || p === (0, $329ek.RGBA_ASTC_6x5_Format) || p === (0, $329ek.RGBA_ASTC_6x6_Format) || p === (0, $329ek.RGBA_ASTC_8x5_Format) || p === (0, $329ek.RGBA_ASTC_8x6_Format) || p === (0, $329ek.RGBA_ASTC_8x8_Format) || p === (0, $329ek.RGBA_ASTC_10x5_Format) || p === (0, $329ek.RGBA_ASTC_10x6_Format) || p === (0, $329ek.RGBA_ASTC_10x8_Format) || p === (0, $329ek.RGBA_ASTC_10x10_Format) || p === (0, $329ek.RGBA_ASTC_12x10_Format) || p === (0, $329ek.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $329ek.RGBA_ASTC_4x4_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $329ek.RGBA_ASTC_5x4_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $329ek.RGBA_ASTC_5x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_6x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_6x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_8x8_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x5_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x6_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x8_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $329ek.RGBA_ASTC_10x10_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $329ek.RGBA_ASTC_12x10_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $329ek.RGBA_ASTC_12x12_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $329ek.RGBA_BPTC_Format) || p === (0, $329ek.RGB_BPTC_SIGNED_Format) || p === (0, $329ek.RGB_BPTC_UNSIGNED_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $329ek.RGBA_BPTC_Format)) return transfer === (0, $329ek.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $329ek.RGB_BPTC_SIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $329ek.RGB_BPTC_UNSIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $329ek.RED_RGTC1_Format) || p === (0, $329ek.SIGNED_RED_RGTC1_Format) || p === (0, $329ek.RED_GREEN_RGTC2_Format) || p === (0, $329ek.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $329ek.RED_RGTC1_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $329ek.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $329ek.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $329ek.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $329ek.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $169244187a3eb47b$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $169244187a3eb47b$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class $169244187a3eb47b$var$WebXRDepthSensing {
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * An opaque texture representing the depth of the user's environment.
		 *
		 * @type {?ExternalTexture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    /**
	 * Inits the depth sensing module
	 *
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $329ek.ExternalTexture)(depthData.texture);
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $329ek.ShaderMaterial)({
                    vertexShader: $169244187a3eb47b$var$_occlusion_vertex,
                    fragmentShader: $169244187a3eb47b$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $329ek.Mesh)(new (0, $329ek.PlaneGeometry)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?ExternalTexture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class $169244187a3eb47b$var$WebXRManager extends (0, $329ek.EventDispatcher) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        const depthSensing = new $169244187a3eb47b$var$WebXRDepthSensing();
        const cameraAccessTextures = {};
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $329ek.Vector2)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $329ek.PerspectiveCamera)();
        cameraL.viewport = new (0, $329ek.Vector4)();
        const cameraR = new (0, $329ek.PerspectiveCamera)();
        cameraR.viewport = new (0, $329ek.Vector4)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $329ek.ArrayCamera)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $329ek.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $329ek.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $329ek.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            for(const key in cameraAccessTextures)delete cameraAccessTextures[key];
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) (0, $329ek.warn)('WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) (0, $329ek.warn)('WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * This is an `XRProjectionLayer` when the targeted XR device supports the
		 * WebXR Layers API, or an `XRWebGLLayer` otherwise.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * Creates a new binding if needed and the browser is
		 * capable of doing so.
		 *
		 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
		 */ this.getBinding = function() {
            if (glBinding === null && supportsGlBinding) glBinding = new XRWebGLBinding(session, gl);
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const supportsLayers = supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!supportsLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $329ek.WebGLRenderTarget)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $329ek.RGBAFormat),
                        type: (0, $329ek.UnsignedByteType),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $329ek.DepthStencilFormat) : (0, $329ek.DepthFormat);
                        depthType = attributes.stencil ? (0, $329ek.UnsignedInt248Type) : (0, $329ek.UnsignedIntType);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = this.getBinding();
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $329ek.WebGLRenderTarget)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $329ek.RGBAFormat),
                        type: (0, $329ek.UnsignedByteType),
                        depthTexture: new (0, $329ek.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * See {@link WebXRDepthSensing#getDepthTexture}.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $329ek.Vector3)();
        const cameraRPos = new (0, $329ek.Vector3)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set `cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            // inherit camera layers and enable eye layers (1 = left, 2 = right)
            cameraXR.layers.mask = camera.layers.mask | 6;
            cameraL.layers.mask = cameraXR.layers.mask & 3;
            cameraR.layers.mask = cameraXR.layers.mask & 5;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $329ek.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number|undefined} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * See {@link WebXRDepthSensing#getMesh}.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        /**
		 * Retrieves an opaque texture from the view-aligned {@link XRCamera}.
		 * Only available during the current animation loop.
		 *
		 * @param {XRCamera} xrCamera - The camera to query.
		 * @return {?Texture} An opaque texture representing the current raw camera frame.
		 */ this.getCameraTexture = function(xrCamera) {
            return cameraAccessTextures[xrCamera];
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $329ek.PerspectiveCamera)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $329ek.Vector4)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && supportsGlBinding) {
                    glBinding = scope.getBinding();
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(depthData, session.renderState);
                }
                const cameraAccessEnabled = enabledFeatures && enabledFeatures.includes('camera-access');
                if (cameraAccessEnabled && supportsGlBinding) {
                    renderer.state.unbindTexture();
                    glBinding = scope.getBinding();
                    for(let i = 0; i < views.length; i++){
                        const camera = views[i].camera;
                        if (camera) {
                            let cameraTex = cameraAccessTextures[camera];
                            if (!cameraTex) {
                                cameraTex = new (0, $329ek.ExternalTexture)();
                                cameraAccessTextures[camera] = cameraTex;
                            }
                            const glTexture = glBinding.getCameraImage(camera);
                            cameraTex.sourceTexture = glTexture;
                        }
                    }
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $169244187a3eb47b$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $169244187a3eb47b$var$_e1 = /*@__PURE__*/ new (0, $329ek.Euler)();
const $169244187a3eb47b$var$_m1 = /*@__PURE__*/ new (0, $329ek.Matrix4)();
function $169244187a3eb47b$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $329ek.getUnlitUniformColorSpace)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $329ek.BackSide)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $329ek.BackSide)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $169244187a3eb47b$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $169244187a3eb47b$var$_e1.x *= -1;
            $169244187a3eb47b$var$_e1.y *= -1;
            $169244187a3eb47b$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $169244187a3eb47b$var$_e1.y *= -1;
                $169244187a3eb47b$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($169244187a3eb47b$var$_m1.makeRotationFromEuler($169244187a3eb47b$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $329ek.BackSide)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $169244187a3eb47b$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        (0, $329ek.error)('WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) (0, $329ek.warn)('WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else (0, $329ek.warn)('WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 32x32
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const $169244187a3eb47b$var$DATA = new Uint16Array([
    0x2cd9,
    0x3b64,
    0x2d0e,
    0x3b43,
    0x2e20,
    0x3aa7,
    0x3061,
    0x39fb,
    0x325e,
    0x397c,
    0x3454,
    0x3908,
    0x357d,
    0x3893,
    0x3698,
    0x381e,
    0x379d,
    0x375b,
    0x3845,
    0x3689,
    0x38af,
    0x35ca,
    0x390d,
    0x351e,
    0x395f,
    0x3484,
    0x39a8,
    0x33f9,
    0x39e6,
    0x330a,
    0x3a1c,
    0x3239,
    0x3a4b,
    0x3183,
    0x3a73,
    0x30e5,
    0x3a95,
    0x305b,
    0x3ab1,
    0x2fc6,
    0x3ac9,
    0x2ef7,
    0x3ade,
    0x2e43,
    0x3aee,
    0x2da7,
    0x3afc,
    0x2d1f,
    0x3b07,
    0x2ca9,
    0x3b10,
    0x2c42,
    0x3b17,
    0x2bd1,
    0x3b1c,
    0x2b34,
    0x3b1f,
    0x2aaa,
    0x3b22,
    0x2a31,
    0x3b23,
    0x29c7,
    0x3b23,
    0x2968,
    0x32d4,
    0x3a4b,
    0x32dc,
    0x3a45,
    0x3308,
    0x3a26,
    0x3378,
    0x39d0,
    0x3425,
    0x394a,
    0x34c9,
    0x38be,
    0x359c,
    0x383e,
    0x3688,
    0x3796,
    0x3778,
    0x36c4,
    0x382f,
    0x3603,
    0x3898,
    0x3553,
    0x38f7,
    0x34b3,
    0x394b,
    0x3424,
    0x3994,
    0x334c,
    0x39d3,
    0x326c,
    0x3a08,
    0x31a9,
    0x3a35,
    0x30fe,
    0x3a5a,
    0x306a,
    0x3a78,
    0x2fd1,
    0x3a90,
    0x2ef1,
    0x3aa2,
    0x2e2e,
    0x3ab0,
    0x2d86,
    0x3aba,
    0x2cf3,
    0x3ac1,
    0x2c74,
    0x3ac4,
    0x2c05,
    0x3ac4,
    0x2b49,
    0x3ac2,
    0x2aa1,
    0x3abd,
    0x2a0c,
    0x3ab7,
    0x298b,
    0x3aaf,
    0x2918,
    0x3aa6,
    0x28b3,
    0x3a9b,
    0x285a,
    0x3559,
    0x3954,
    0x355a,
    0x3951,
    0x3566,
    0x3944,
    0x3582,
    0x391e,
    0x35b6,
    0x38d3,
    0x360a,
    0x386a,
    0x3684,
    0x37ed,
    0x3720,
    0x370d,
    0x37d3,
    0x3641,
    0x3847,
    0x3588,
    0x38a3,
    0x34e2,
    0x38fa,
    0x344d,
    0x3948,
    0x3391,
    0x398d,
    0x32a6,
    0x39c8,
    0x31d6,
    0x39fa,
    0x3121,
    0x3a22,
    0x3082,
    0x3a43,
    0x2ff0,
    0x3a5c,
    0x2f01,
    0x3a6f,
    0x2e32,
    0x3a7c,
    0x2d7e,
    0x3a84,
    0x2ce2,
    0x3a87,
    0x2c5b,
    0x3a87,
    0x2bcc,
    0x3a83,
    0x2b00,
    0x3a7b,
    0x2a4e,
    0x3a71,
    0x29b3,
    0x3a66,
    0x292c,
    0x3a58,
    0x28b4,
    0x3a4b,
    0x284b,
    0x3a3d,
    0x27dc,
    0x3a2e,
    0x2739,
    0x3709,
    0x387c,
    0x370a,
    0x387b,
    0x3710,
    0x3874,
    0x3720,
    0x385f,
    0x373d,
    0x3834,
    0x376a,
    0x37e1,
    0x37ac,
    0x3732,
    0x3805,
    0x3675,
    0x383f,
    0x35bc,
    0x3883,
    0x3511,
    0x38cb,
    0x3476,
    0x3912,
    0x33d8,
    0x3955,
    0x32e2,
    0x3991,
    0x3208,
    0x39c6,
    0x3149,
    0x39f1,
    0x30a1,
    0x3a15,
    0x300f,
    0x3a30,
    0x2f21,
    0x3a44,
    0x2e45,
    0x3a51,
    0x2d87,
    0x3a59,
    0x2ce2,
    0x3a5b,
    0x2c53,
    0x3a58,
    0x2bb0,
    0x3a52,
    0x2ada,
    0x3a49,
    0x2a1f,
    0x3a40,
    0x297d,
    0x3a34,
    0x28f0,
    0x3a25,
    0x2874,
    0x3a13,
    0x2807,
    0x3a00,
    0x274e,
    0x39eb,
    0x26a6,
    0x39d5,
    0x2611,
    0x3840,
    0x3780,
    0x3840,
    0x377e,
    0x3842,
    0x3776,
    0x3846,
    0x375e,
    0x384f,
    0x372a,
    0x385b,
    0x36d3,
    0x386c,
    0x3659,
    0x3885,
    0x35c7,
    0x38a8,
    0x352d,
    0x38d4,
    0x3497,
    0x3906,
    0x340c,
    0x393b,
    0x331a,
    0x3970,
    0x323a,
    0x39a0,
    0x3172,
    0x39cb,
    0x30c3,
    0x39ef,
    0x302a,
    0x3a0c,
    0x2f4a,
    0x3a21,
    0x2e63,
    0x3a2f,
    0x2d9b,
    0x3a37,
    0x2ced,
    0x3a39,
    0x2c57,
    0x3a37,
    0x2baa,
    0x3a34,
    0x2ac9,
    0x3a2c,
    0x2a05,
    0x3a20,
    0x295d,
    0x3a11,
    0x28ca,
    0x39ff,
    0x2849,
    0x39eb,
    0x27b2,
    0x39d5,
    0x26ed,
    0x39be,
    0x2640,
    0x39a5,
    0x25aa,
    0x398b,
    0x2523,
    0x38e2,
    0x363b,
    0x38e2,
    0x363b,
    0x38e3,
    0x3635,
    0x38e6,
    0x3626,
    0x38ea,
    0x3606,
    0x38f0,
    0x35cd,
    0x38f8,
    0x3579,
    0x3903,
    0x350e,
    0x3915,
    0x3495,
    0x392d,
    0x3418,
    0x394c,
    0x3340,
    0x3970,
    0x3261,
    0x3995,
    0x3197,
    0x39b8,
    0x30e4,
    0x39d8,
    0x3046,
    0x39f3,
    0x2f76,
    0x3a08,
    0x2e86,
    0x3a16,
    0x2db5,
    0x3a1e,
    0x2cff,
    0x3a22,
    0x2c61,
    0x3a24,
    0x2bb3,
    0x3a20,
    0x2ac7,
    0x3a17,
    0x29fc,
    0x3a0a,
    0x294c,
    0x39fa,
    0x28b2,
    0x39e7,
    0x282e,
    0x39d1,
    0x2773,
    0x39b9,
    0x26a9,
    0x399f,
    0x25fa,
    0x3985,
    0x255f,
    0x3968,
    0x24d6,
    0x394a,
    0x245d,
    0x396e,
    0x3524,
    0x396e,
    0x3524,
    0x396e,
    0x3520,
    0x396f,
    0x3517,
    0x3971,
    0x3502,
    0x3973,
    0x34dd,
    0x3975,
    0x34a5,
    0x3978,
    0x3458,
    0x397e,
    0x33f9,
    0x3987,
    0x3332,
    0x3997,
    0x326b,
    0x39aa,
    0x31ac,
    0x39c0,
    0x30fb,
    0x39d7,
    0x305c,
    0x39eb,
    0x2f9e,
    0x39fc,
    0x2ea7,
    0x3a07,
    0x2dcf,
    0x3a0f,
    0x2d13,
    0x3a16,
    0x2c70,
    0x3a17,
    0x2bc4,
    0x3a14,
    0x2ad0,
    0x3a0a,
    0x29fc,
    0x39fd,
    0x2945,
    0x39ed,
    0x28a6,
    0x39d9,
    0x281d,
    0x39c2,
    0x274a,
    0x39a9,
    0x267c,
    0x398e,
    0x25c7,
    0x3971,
    0x2528,
    0x3952,
    0x249e,
    0x3931,
    0x2425,
    0x3910,
    0x2374,
    0x39e5,
    0x3436,
    0x39e5,
    0x3435,
    0x39e5,
    0x3434,
    0x39e5,
    0x342e,
    0x39e5,
    0x3420,
    0x39e5,
    0x3408,
    0x39e3,
    0x33c4,
    0x39e1,
    0x3359,
    0x39df,
    0x32d3,
    0x39de,
    0x323a,
    0x39e1,
    0x319a,
    0x39e7,
    0x30fb,
    0x39f0,
    0x3065,
    0x39f9,
    0x2fb6,
    0x3a02,
    0x2ec0,
    0x3a08,
    0x2de6,
    0x3a0d,
    0x2d26,
    0x3a12,
    0x2c7e,
    0x3a13,
    0x2bda,
    0x3a0e,
    0x2adc,
    0x3a05,
    0x2a02,
    0x39f8,
    0x2945,
    0x39e7,
    0x28a1,
    0x39d3,
    0x2813,
    0x39bc,
    0x2730,
    0x39a2,
    0x265c,
    0x3985,
    0x25a3,
    0x3966,
    0x2501,
    0x3945,
    0x2475,
    0x3923,
    0x23f3,
    0x3901,
    0x231c,
    0x38dd,
    0x225e,
    0x3a4b,
    0x32d6,
    0x3a4a,
    0x32d6,
    0x3a4a,
    0x32d4,
    0x3a4a,
    0x32cc,
    0x3a48,
    0x32bb,
    0x3a47,
    0x329d,
    0x3a43,
    0x326b,
    0x3a3d,
    0x3222,
    0x3a36,
    0x31c2,
    0x3a2e,
    0x314f,
    0x3a28,
    0x30d2,
    0x3a23,
    0x3052,
    0x3a20,
    0x2fab,
    0x3a1e,
    0x2ec2,
    0x3a1b,
    0x2def,
    0x3a19,
    0x2d31,
    0x3a1a,
    0x2c89,
    0x3a18,
    0x2beb,
    0x3a11,
    0x2aea,
    0x3a07,
    0x2a0a,
    0x39fa,
    0x2948,
    0x39e9,
    0x28a1,
    0x39d4,
    0x280f,
    0x39bd,
    0x2721,
    0x39a2,
    0x2647,
    0x3985,
    0x258b,
    0x3964,
    0x24e5,
    0x3942,
    0x2455,
    0x391f,
    0x23b3,
    0x38fb,
    0x22d8,
    0x38d4,
    0x2219,
    0x38ad,
    0x2172,
    0x3aa0,
    0x3180,
    0x3aa0,
    0x3180,
    0x3aa0,
    0x317f,
    0x3a9f,
    0x317b,
    0x3a9d,
    0x3170,
    0x3a99,
    0x315d,
    0x3a95,
    0x313d,
    0x3a8d,
    0x310c,
    0x3a82,
    0x30ca,
    0x3a76,
    0x3077,
    0x3a69,
    0x3019,
    0x3a5c,
    0x2f68,
    0x3a4f,
    0x2e9e,
    0x3a42,
    0x2dde,
    0x3a37,
    0x2d2b,
    0x3a30,
    0x2c89,
    0x3a29,
    0x2bef,
    0x3a1f,
    0x2af0,
    0x3a12,
    0x2a0f,
    0x3a03,
    0x294a,
    0x39f1,
    0x28a0,
    0x39dc,
    0x280c,
    0x39c5,
    0x2717,
    0x39a9,
    0x2638,
    0x398b,
    0x2578,
    0x396a,
    0x24d0,
    0x3947,
    0x243f,
    0x3923,
    0x2380,
    0x38fc,
    0x22a4,
    0x38d4,
    0x21e4,
    0x38ac,
    0x213c,
    0x3883,
    0x20a8,
    0x3ae8,
    0x3062,
    0x3ae8,
    0x3062,
    0x3ae7,
    0x3061,
    0x3ae6,
    0x305f,
    0x3ae4,
    0x305a,
    0x3ae0,
    0x304f,
    0x3ada,
    0x303b,
    0x3ad1,
    0x301b,
    0x3ac5,
    0x2fdd,
    0x3ab6,
    0x2f6a,
    0x3aa4,
    0x2ede,
    0x3a91,
    0x2e45,
    0x3a7c,
    0x2da5,
    0x3a67,
    0x2d0a,
    0x3a57,
    0x2c77,
    0x3a48,
    0x2bdc,
    0x3a38,
    0x2ae5,
    0x3a27,
    0x2a0a,
    0x3a16,
    0x2947,
    0x3a02,
    0x289d,
    0x39eb,
    0x2808,
    0x39d3,
    0x270d,
    0x39b6,
    0x262b,
    0x3997,
    0x256a,
    0x3976,
    0x24bf,
    0x3952,
    0x242b,
    0x392d,
    0x2358,
    0x3904,
    0x227a,
    0x38db,
    0x21b8,
    0x38b2,
    0x2110,
    0x3887,
    0x207d,
    0x385b,
    0x1ff6,
    0x3b23,
    0x2ee8,
    0x3b23,
    0x2ee8,
    0x3b22,
    0x2ee8,
    0x3b21,
    0x2ee7,
    0x3b1f,
    0x2ee3,
    0x3b1a,
    0x2ed6,
    0x3b14,
    0x2ec1,
    0x3b0b,
    0x2e99,
    0x3afe,
    0x2e60,
    0x3aee,
    0x2e12,
    0x3ad8,
    0x2dad,
    0x3ac1,
    0x2d3d,
    0x3aa5,
    0x2cc3,
    0x3a8b,
    0x2c48,
    0x3a76,
    0x2ba2,
    0x3a60,
    0x2ac0,
    0x3a49,
    0x29f2,
    0x3a32,
    0x2938,
    0x3a1b,
    0x2893,
    0x3a02,
    0x27ff,
    0x39e8,
    0x26ff,
    0x39ca,
    0x261e,
    0x39aa,
    0x255b,
    0x3988,
    0x24b0,
    0x3964,
    0x241c,
    0x393d,
    0x2336,
    0x3913,
    0x2257,
    0x38e9,
    0x2195,
    0x38be,
    0x20eb,
    0x3891,
    0x2059,
    0x3864,
    0x1fae,
    0x3837,
    0x1ecd,
    0x3b54,
    0x2d61,
    0x3b54,
    0x2d61,
    0x3b53,
    0x2d61,
    0x3b52,
    0x2d62,
    0x3b4f,
    0x2d61,
    0x3b4b,
    0x2d5c,
    0x3b45,
    0x2d51,
    0x3b3b,
    0x2d3d,
    0x3b2e,
    0x2d1a,
    0x3b1d,
    0x2ce7,
    0x3b06,
    0x2ca3,
    0x3aeb,
    0x2c52,
    0x3acb,
    0x2bee,
    0x3ab0,
    0x2b31,
    0x3a94,
    0x2a74,
    0x3a77,
    0x29bf,
    0x3a5a,
    0x2915,
    0x3a3f,
    0x287a,
    0x3a22,
    0x27de,
    0x3a05,
    0x26e4,
    0x39e5,
    0x2609,
    0x39c3,
    0x2547,
    0x39a0,
    0x249f,
    0x397b,
    0x240c,
    0x3953,
    0x2314,
    0x3928,
    0x2238,
    0x38fd,
    0x2175,
    0x38d0,
    0x20cb,
    0x38a2,
    0x2038,
    0x3873,
    0x1f71,
    0x3844,
    0x1e90,
    0x3815,
    0x1dce,
    0x3b7c,
    0x2c22,
    0x3b7c,
    0x2c22,
    0x3b7b,
    0x2c23,
    0x3b7a,
    0x2c25,
    0x3b77,
    0x2c27,
    0x3b73,
    0x2c26,
    0x3b6d,
    0x2c23,
    0x3b64,
    0x2c1a,
    0x3b57,
    0x2c07,
    0x3b46,
    0x2bd1,
    0x3b2e,
    0x2b79,
    0x3b0f,
    0x2b07,
    0x3aef,
    0x2a86,
    0x3ad1,
    0x29f8,
    0x3ab0,
    0x2967,
    0x3a8e,
    0x28d7,
    0x3a6d,
    0x284e,
    0x3a4c,
    0x279f,
    0x3a2b,
    0x26b7,
    0x3a08,
    0x25e5,
    0x39e4,
    0x252c,
    0x39be,
    0x2488,
    0x3998,
    0x23f0,
    0x396f,
    0x22f2,
    0x3943,
    0x2215,
    0x3917,
    0x2155,
    0x38e8,
    0x20ae,
    0x38b9,
    0x201c,
    0x3888,
    0x1f38,
    0x3857,
    0x1e5a,
    0x3826,
    0x1d9a,
    0x37eb,
    0x1cf0,
    0x3b9c,
    0x2a43,
    0x3b9c,
    0x2a43,
    0x3b9b,
    0x2a46,
    0x3b9a,
    0x2a4a,
    0x3b98,
    0x2a50,
    0x3b93,
    0x2a54,
    0x3b8e,
    0x2a59,
    0x3b85,
    0x2a56,
    0x3b79,
    0x2a45,
    0x3b67,
    0x2a24,
    0x3b4f,
    0x29ee,
    0x3b2f,
    0x29a4,
    0x3b10,
    0x294b,
    0x3aef,
    0x28e5,
    0x3ac9,
    0x2877,
    0x3aa4,
    0x2809,
    0x3a7e,
    0x2739,
    0x3a59,
    0x266d,
    0x3a34,
    0x25af,
    0x3a0c,
    0x2503,
    0x39e4,
    0x2468,
    0x39bb,
    0x23bb,
    0x3990,
    0x22c6,
    0x3963,
    0x21f0,
    0x3936,
    0x2133,
    0x3906,
    0x208f,
    0x38d5,
    0x1ffd,
    0x38a3,
    0x1f04,
    0x3870,
    0x1e28,
    0x383d,
    0x1d69,
    0x380b,
    0x1cc3,
    0x37b0,
    0x1c32,
    0x3bb5,
    0x28aa,
    0x3bb5,
    0x28ab,
    0x3bb5,
    0x28ad,
    0x3bb4,
    0x28b2,
    0x3bb2,
    0x28b9,
    0x3bae,
    0x28c2,
    0x3ba8,
    0x28ca,
    0x3ba0,
    0x28d1,
    0x3b94,
    0x28cd,
    0x3b83,
    0x28c1,
    0x3b6a,
    0x28a3,
    0x3b4b,
    0x2876,
    0x3b2d,
    0x283d,
    0x3b09,
    0x27ea,
    0x3ae1,
    0x274b,
    0x3ab9,
    0x26a6,
    0x3a8f,
    0x25fe,
    0x3a67,
    0x255d,
    0x3a3d,
    0x24c5,
    0x3a11,
    0x2439,
    0x39e6,
    0x2371,
    0x39b9,
    0x228d,
    0x398a,
    0x21c1,
    0x395a,
    0x210b,
    0x3929,
    0x206c,
    0x38f7,
    0x1fc1,
    0x38c3,
    0x1ecb,
    0x388f,
    0x1df6,
    0x385a,
    0x1d3a,
    0x3825,
    0x1c99,
    0x37e1,
    0x1c08,
    0x3779,
    0x1b1b,
    0x3bc9,
    0x26d3,
    0x3bc9,
    0x26d4,
    0x3bc9,
    0x26d9,
    0x3bc8,
    0x26e3,
    0x3bc6,
    0x26ef,
    0x3bc2,
    0x2705,
    0x3bbd,
    0x271a,
    0x3bb6,
    0x2731,
    0x3baa,
    0x273c,
    0x3b9a,
    0x273d,
    0x3b81,
    0x2726,
    0x3b65,
    0x26f7,
    0x3b46,
    0x26af,
    0x3b20,
    0x2650,
    0x3af7,
    0x25e1,
    0x3acd,
    0x256a,
    0x3aa1,
    0x24eb,
    0x3a75,
    0x246f,
    0x3a46,
    0x23ee,
    0x3a17,
    0x230d,
    0x39e9,
    0x223e,
    0x39b7,
    0x2183,
    0x3985,
    0x20d8,
    0x3953,
    0x2043,
    0x391e,
    0x1f7a,
    0x38e9,
    0x1e8d,
    0x38b3,
    0x1dbf,
    0x387c,
    0x1d0b,
    0x3845,
    0x1c6c,
    0x380e,
    0x1bc4,
    0x37b0,
    0x1ad2,
    0x3745,
    0x19fd,
    0x3bd9,
    0x24e4,
    0x3bd9,
    0x24e5,
    0x3bd9,
    0x24e8,
    0x3bd8,
    0x24f2,
    0x3bd5,
    0x24fe,
    0x3bd2,
    0x2512,
    0x3bce,
    0x252b,
    0x3bc6,
    0x2544,
    0x3bbc,
    0x255a,
    0x3bac,
    0x256b,
    0x3b93,
    0x2569,
    0x3b7a,
    0x2557,
    0x3b5b,
    0x252f,
    0x3b34,
    0x24f7,
    0x3b0c,
    0x24ad,
    0x3adf,
    0x2458,
    0x3ab1,
    0x23f8,
    0x3a82,
    0x233f,
    0x3a4f,
    0x2286,
    0x3a1e,
    0x21d5,
    0x39eb,
    0x2130,
    0x39b6,
    0x2098,
    0x3982,
    0x200e,
    0x394b,
    0x1f25,
    0x3914,
    0x1e45,
    0x38dc,
    0x1d83,
    0x38a3,
    0x1cd6,
    0x386b,
    0x1c3d,
    0x3831,
    0x1b71,
    0x37f2,
    0x1a87,
    0x3782,
    0x19bc,
    0x3714,
    0x1909,
    0x3be5,
    0x22d8,
    0x3be5,
    0x22d9,
    0x3be4,
    0x22df,
    0x3be4,
    0x22ef,
    0x3be1,
    0x2305,
    0x3bde,
    0x232a,
    0x3bda,
    0x2358,
    0x3bd4,
    0x2392,
    0x3bcb,
    0x23ca,
    0x3bbb,
    0x23f4,
    0x3ba3,
    0x2405,
    0x3b8c,
    0x2405,
    0x3b6c,
    0x23ec,
    0x3b47,
    0x23ae,
    0x3b1d,
    0x2353,
    0x3af0,
    0x22e2,
    0x3ac0,
    0x2261,
    0x3a8e,
    0x21d9,
    0x3a5a,
    0x214e,
    0x3a26,
    0x20c7,
    0x39ee,
    0x2045,
    0x39b7,
    0x1f97,
    0x397f,
    0x1eba,
    0x3945,
    0x1df0,
    0x390b,
    0x1d3a,
    0x38d0,
    0x1c9a,
    0x3895,
    0x1c0a,
    0x385a,
    0x1b18,
    0x381f,
    0x1a39,
    0x37c9,
    0x1975,
    0x3756,
    0x18cc,
    0x36e6,
    0x1836,
    0x3bed,
    0x20a8,
    0x3bed,
    0x20a9,
    0x3bed,
    0x20ae,
    0x3bed,
    0x20bb,
    0x3beb,
    0x20cf,
    0x3be8,
    0x20ef,
    0x3be4,
    0x2119,
    0x3bde,
    0x214f,
    0x3bd6,
    0x2189,
    0x3bc6,
    0x21b8,
    0x3bb1,
    0x21de,
    0x3b9a,
    0x21f2,
    0x3b7b,
    0x21f2,
    0x3b57,
    0x21d8,
    0x3b2d,
    0x21a4,
    0x3b00,
    0x215f,
    0x3acf,
    0x2108,
    0x3a99,
    0x20a8,
    0x3a64,
    0x2043,
    0x3a2c,
    0x1fba,
    0x39f2,
    0x1ef3,
    0x39b8,
    0x1e36,
    0x397c,
    0x1d86,
    0x3940,
    0x1ce5,
    0x3903,
    0x1c52,
    0x38c6,
    0x1b9e,
    0x3888,
    0x1ab3,
    0x384a,
    0x19e4,
    0x380e,
    0x192b,
    0x37a3,
    0x188b,
    0x372d,
    0x17f7,
    0x36ba,
    0x1701,
    0x3bf4,
    0x1e23,
    0x3bf4,
    0x1e25,
    0x3bf4,
    0x1e2d,
    0x3bf3,
    0x1e41,
    0x3bf1,
    0x1e64,
    0x3bef,
    0x1e9c,
    0x3beb,
    0x1ee1,
    0x3be6,
    0x1f40,
    0x3bde,
    0x1fa7,
    0x3bce,
    0x2001,
    0x3bbd,
    0x202f,
    0x3ba6,
    0x204e,
    0x3b88,
    0x205f,
    0x3b64,
    0x205b,
    0x3b3b,
    0x2044,
    0x3b0e,
    0x201f,
    0x3adb,
    0x1fcf,
    0x3aa6,
    0x1f4e,
    0x3a6e,
    0x1ec1,
    0x3a33,
    0x1e2b,
    0x39f7,
    0x1d95,
    0x39ba,
    0x1d06,
    0x397b,
    0x1c7d,
    0x393c,
    0x1bfc,
    0x38fc,
    0x1b13,
    0x38bc,
    0x1a40,
    0x387c,
    0x1983,
    0x383c,
    0x18da,
    0x37fa,
    0x1842,
    0x377f,
    0x177f,
    0x3706,
    0x1695,
    0x3691,
    0x15c8,
    0x3bf8,
    0x1bca,
    0x3bf8,
    0x1bcc,
    0x3bf8,
    0x1bd8,
    0x3bf8,
    0x1bf7,
    0x3bf6,
    0x1c1b,
    0x3bf4,
    0x1c45,
    0x3bf1,
    0x1c83,
    0x3bec,
    0x1cce,
    0x3be4,
    0x1d21,
    0x3bd5,
    0x1d78,
    0x3bc5,
    0x1dd1,
    0x3bb0,
    0x1e17,
    0x3b93,
    0x1e4a,
    0x3b70,
    0x1e5f,
    0x3b48,
    0x1e57,
    0x3b1b,
    0x1e35,
    0x3ae7,
    0x1df6,
    0x3ab2,
    0x1da4,
    0x3a77,
    0x1d44,
    0x3a3a,
    0x1cdb,
    0x39fc,
    0x1c6e,
    0x39bb,
    0x1c03,
    0x397a,
    0x1b35,
    0x3938,
    0x1a72,
    0x38f5,
    0x19bb,
    0x38b3,
    0x1914,
    0x3870,
    0x187d,
    0x382e,
    0x17eb,
    0x37db,
    0x16f9,
    0x375c,
    0x1621,
    0x36e1,
    0x1565,
    0x3669,
    0x14be,
    0x3bfb,
    0x18b9,
    0x3bfb,
    0x18ba,
    0x3bfb,
    0x18c3,
    0x3bfb,
    0x18da,
    0x3bf9,
    0x190a,
    0x3bf7,
    0x1948,
    0x3bf5,
    0x19ac,
    0x3bf0,
    0x1a20,
    0x3be9,
    0x1ab3,
    0x3bdb,
    0x1b49,
    0x3bcd,
    0x1be6,
    0x3bb7,
    0x1c34,
    0x3b9c,
    0x1c6d,
    0x3b7a,
    0x1c8e,
    0x3b54,
    0x1c9e,
    0x3b26,
    0x1c96,
    0x3af2,
    0x1c75,
    0x3abc,
    0x1c47,
    0x3a80,
    0x1c09,
    0x3a42,
    0x1b85,
    0x3a01,
    0x1aec,
    0x39be,
    0x1a50,
    0x397a,
    0x19b5,
    0x3935,
    0x1921,
    0x38f0,
    0x1895,
    0x38aa,
    0x1814,
    0x3866,
    0x173a,
    0x3821,
    0x1665,
    0x37be,
    0x15a4,
    0x373c,
    0x14f9,
    0x36be,
    0x1460,
    0x3644,
    0x13b3,
    0x3bfd,
    0x156b,
    0x3bfd,
    0x156c,
    0x3bfd,
    0x1578,
    0x3bfd,
    0x1598,
    0x3bfc,
    0x15dd,
    0x3bfa,
    0x163c,
    0x3bf7,
    0x16cb,
    0x3bf3,
    0x177b,
    0x3beb,
    0x1833,
    0x3be0,
    0x18ad,
    0x3bd2,
    0x192e,
    0x3bbd,
    0x19a6,
    0x3ba4,
    0x1a0c,
    0x3b83,
    0x1a5a,
    0x3b5d,
    0x1a8c,
    0x3b30,
    0x1a9b,
    0x3afd,
    0x1a86,
    0x3ac6,
    0x1a5c,
    0x3a89,
    0x1a11,
    0x3a49,
    0x19b7,
    0x3a06,
    0x194f,
    0x39c1,
    0x18e3,
    0x397a,
    0x1873,
    0x3933,
    0x1805,
    0x38eb,
    0x173a,
    0x38a3,
    0x1676,
    0x385c,
    0x15bf,
    0x3816,
    0x1519,
    0x37a2,
    0x1482,
    0x371d,
    0x13f7,
    0x369c,
    0x1306,
    0x3620,
    0x1231,
    0x3bff,
    0x11cb,
    0x3bff,
    0x11cd,
    0x3bfe,
    0x11dd,
    0x3bfe,
    0x1219,
    0x3bfd,
    0x126b,
    0x3bfb,
    0x12e9,
    0x3bf9,
    0x13c5,
    0x3bf5,
    0x1460,
    0x3bee,
    0x150f,
    0x3be3,
    0x15c9,
    0x3bd6,
    0x168a,
    0x3bc3,
    0x174f,
    0x3baa,
    0x1806,
    0x3b8b,
    0x184f,
    0x3b66,
    0x1888,
    0x3b39,
    0x18a6,
    0x3b07,
    0x18ad,
    0x3acf,
    0x189c,
    0x3a92,
    0x1876,
    0x3a50,
    0x1840,
    0x3a0c,
    0x17fd,
    0x39c4,
    0x176a,
    0x397b,
    0x16ce,
    0x3931,
    0x1634,
    0x38e6,
    0x1599,
    0x389c,
    0x1508,
    0x3852,
    0x147f,
    0x380a,
    0x1401,
    0x3788,
    0x131c,
    0x36ff,
    0x124a,
    0x367c,
    0x1190,
    0x35fe,
    0x10ea,
    0x3bff,
    0x0daa,
    0x3bff,
    0x0dad,
    0x3bff,
    0x0dc0,
    0x3bff,
    0x0e0e,
    0x3bfe,
    0x0e87,
    0x3bfc,
    0x0f14,
    0x3bfb,
    0x1029,
    0x3bf7,
    0x10d1,
    0x3bf0,
    0x11d3,
    0x3be6,
    0x12c9,
    0x3bd9,
    0x13fc,
    0x3bc7,
    0x1499,
    0x3bb0,
    0x152a,
    0x3b92,
    0x15ab,
    0x3b6e,
    0x1615,
    0x3b42,
    0x165a,
    0x3b10,
    0x1681,
    0x3ad8,
    0x1683,
    0x3a9a,
    0x1665,
    0x3a57,
    0x1629,
    0x3a11,
    0x15dd,
    0x39c8,
    0x1580,
    0x397c,
    0x1518,
    0x3930,
    0x14ae,
    0x38e3,
    0x1441,
    0x3896,
    0x13b1,
    0x384a,
    0x12e9,
    0x37ff,
    0x122f,
    0x376f,
    0x1182,
    0x36e3,
    0x10e5,
    0x365e,
    0x1057,
    0x35de,
    0x0fac,
    0x3c00,
    0x08ea,
    0x3c00,
    0x08ed,
    0x3c00,
    0x0902,
    0x3c00,
    0x0961,
    0x3bff,
    0x09f3,
    0x3bfd,
    0x0abc,
    0x3bfb,
    0x0c1f,
    0x3bf8,
    0x0d15,
    0x3bf1,
    0x0e5b,
    0x3be8,
    0x0fb4,
    0x3bdc,
    0x10b0,
    0x3bcb,
    0x1190,
    0x3bb5,
    0x126c,
    0x3b97,
    0x132c,
    0x3b74,
    0x13de,
    0x3b4a,
    0x1432,
    0x3b18,
    0x145e,
    0x3ae0,
    0x1472,
    0x3aa2,
    0x146f,
    0x3a5f,
    0x1456,
    0x3a17,
    0x142e,
    0x39cc,
    0x13ee,
    0x397e,
    0x136b,
    0x392f,
    0x12e1,
    0x38df,
    0x124f,
    0x3890,
    0x11bd,
    0x3842,
    0x1131,
    0x37eb,
    0x10ac,
    0x3757,
    0x102e,
    0x36c9,
    0x0f76,
    0x3640,
    0x0ea3,
    0x35bf,
    0x0de4,
    0x3c00,
    0x039b,
    0x3c00,
    0x039d,
    0x3c00,
    0x03b2,
    0x3c00,
    0x041c,
    0x3bff,
    0x04be,
    0x3bfd,
    0x05d6,
    0x3bfc,
    0x0764,
    0x3bf8,
    0x08e2,
    0x3bf2,
    0x0a67,
    0x3bea,
    0x0c1b,
    0x3bde,
    0x0d41,
    0x3bcd,
    0x0e5f,
    0x3bb8,
    0x0f8c,
    0x3b9c,
    0x1057,
    0x3b7a,
    0x10e5,
    0x3b51,
    0x1155,
    0x3b20,
    0x11a5,
    0x3ae8,
    0x11da,
    0x3aaa,
    0x11ef,
    0x3a66,
    0x11e5,
    0x3a1d,
    0x11c1,
    0x39d0,
    0x1185,
    0x3980,
    0x113b,
    0x392e,
    0x10e5,
    0x38dc,
    0x1087,
    0x388b,
    0x1028,
    0x383b,
    0x0f94,
    0x37d9,
    0x0edb,
    0x3741,
    0x0e2c,
    0x36af,
    0x0d89,
    0x3625,
    0x0cf2,
    0x35a1,
    0x0c69,
    0x3c00,
    0x0107,
    0x3c00,
    0x0108,
    0x3c00,
    0x0110,
    0x3c00,
    0x0145,
    0x3bff,
    0x0197,
    0x3bfe,
    0x0224,
    0x3bfc,
    0x030c,
    0x3bf8,
    0x0478,
    0x3bf3,
    0x062c,
    0x3beb,
    0x0833,
    0x3be0,
    0x0979,
    0x3bd0,
    0x0aeb,
    0x3bbc,
    0x0c3d,
    0x3ba0,
    0x0d01,
    0x3b80,
    0x0dbd,
    0x3b57,
    0x0e69,
    0x3b27,
    0x0eeb,
    0x3af0,
    0x0f53,
    0x3ab1,
    0x0f8a,
    0x3a6c,
    0x0f9f,
    0x3a22,
    0x0f8b,
    0x39d4,
    0x0f5b,
    0x3982,
    0x0f0f,
    0x392f,
    0x0eac,
    0x38da,
    0x0e3d,
    0x3886,
    0x0dc9,
    0x3834,
    0x0d51,
    0x37c7,
    0x0cd9,
    0x372c,
    0x0c65,
    0x3697,
    0x0bef,
    0x360a,
    0x0b20,
    0x3585,
    0x0a62,
    0x3c00,
    0x0031,
    0x3c00,
    0x0031,
    0x3c00,
    0x0034,
    0x3c00,
    0x004b,
    0x3bff,
    0x006f,
    0x3bfe,
    0x00c9,
    0x3bfc,
    0x011b,
    0x3bf9,
    0x0207,
    0x3bf4,
    0x02d6,
    0x3bec,
    0x0415,
    0x3be1,
    0x0587,
    0x3bd2,
    0x0703,
    0x3bbf,
    0x087d,
    0x3ba5,
    0x096a,
    0x3b85,
    0x0a59,
    0x3b5d,
    0x0b32,
    0x3b2e,
    0x0bee,
    0x3af7,
    0x0c44,
    0x3ab8,
    0x0c7c,
    0x3a73,
    0x0c9c,
    0x3a28,
    0x0ca4,
    0x39d8,
    0x0c98,
    0x3985,
    0x0c77,
    0x392f,
    0x0c4a,
    0x38d9,
    0x0c10,
    0x3882,
    0x0ba0,
    0x382e,
    0x0b14,
    0x37b6,
    0x0a84,
    0x3717,
    0x09f5,
    0x3680,
    0x0969,
    0x35f0,
    0x08e6,
    0x356a,
    0x086a,
    0x3c00,
    0x0004,
    0x3c00,
    0x0004,
    0x3c00,
    0x0004,
    0x3c00,
    0x000d,
    0x3bff,
    0x0021,
    0x3bfe,
    0x003b,
    0x3bfd,
    0x0070,
    0x3bf9,
    0x00c7,
    0x3bf4,
    0x012e,
    0x3bed,
    0x01c8,
    0x3be3,
    0x0274,
    0x3bd4,
    0x033b,
    0x3bc1,
    0x043a,
    0x3ba8,
    0x0534,
    0x3b89,
    0x0641,
    0x3b62,
    0x073b,
    0x3b34,
    0x0815,
    0x3afd,
    0x087c,
    0x3abf,
    0x08d0,
    0x3a7a,
    0x090a,
    0x3a2e,
    0x092c,
    0x39dd,
    0x0936,
    0x3988,
    0x0928,
    0x3930,
    0x0907,
    0x38d7,
    0x08d7,
    0x387f,
    0x089b,
    0x3828,
    0x0855,
    0x37a7,
    0x080b,
    0x3704,
    0x077b,
    0x366a,
    0x06e1,
    0x35d8,
    0x0649,
    0x3550,
    0x05b8,
    0x3c00,
    0x0000,
    0x3c00,
    0x0000,
    0x3c00,
    0x0000,
    0x3c00,
    0x0003,
    0x3bff,
    0x0012,
    0x3bfe,
    0x001a,
    0x3bfd,
    0x0035,
    0x3bfa,
    0x0050,
    0x3bf4,
    0x0061,
    0x3bed,
    0x00a5,
    0x3be4,
    0x00ee,
    0x3bd6,
    0x0146,
    0x3bc3,
    0x01ab,
    0x3bab,
    0x0211,
    0x3b8d,
    0x028e,
    0x3b67,
    0x0303,
    0x3b39,
    0x0375,
    0x3b04,
    0x03e2,
    0x3ac6,
    0x0441,
    0x3a80,
    0x0492,
    0x3a34,
    0x04cd,
    0x39e1,
    0x04f2,
    0x398b,
    0x0504,
    0x3931,
    0x0502,
    0x38d6,
    0x04ec,
    0x387c,
    0x04c7,
    0x3822,
    0x0496,
    0x3798,
    0x045c,
    0x36f2,
    0x041a,
    0x3655,
    0x03d5,
    0x35c1,
    0x038e,
    0x3537,
    0x0347
]);
let $169244187a3eb47b$var$lut = null;
function $169244187a3eb47b$var$getDFGLUT() {
    if ($169244187a3eb47b$var$lut === null) {
        $169244187a3eb47b$var$lut = new (0, $329ek.DataTexture)($169244187a3eb47b$var$DATA, 32, 32, (0, $329ek.RGFormat), (0, $329ek.HalfFloatType));
        $169244187a3eb47b$var$lut.minFilter = (0, $329ek.LinearFilter);
        $169244187a3eb47b$var$lut.magFilter = (0, $329ek.LinearFilter);
        $169244187a3eb47b$var$lut.wrapS = (0, $329ek.ClampToEdgeWrapping);
        $169244187a3eb47b$var$lut.wrapT = (0, $329ek.ClampToEdgeWrapping);
        $169244187a3eb47b$var$lut.generateMipmaps = false;
        $169244187a3eb47b$var$lut.needsUpdate = true;
    }
    return $169244187a3eb47b$var$lut;
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class $169244187a3eb47b$export$f6cc00ef28d7cf97 {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas: canvas = (0, $329ek.createCanvasElement)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reversedDepthBuffer: reversedDepthBuffer = false } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const INTEGER_FORMATS = new Set([
            (0, $329ek.RGBAIntegerFormat),
            (0, $329ek.RGIntegerFormat),
            (0, $329ek.RedIntegerFormat)
        ]);
        const UNSIGNED_TYPES = new Set([
            (0, $329ek.UnsignedByteType),
            (0, $329ek.UnsignedIntType),
            (0, $329ek.UnsignedShortType),
            (0, $329ek.UnsignedInt248Type),
            (0, $329ek.UnsignedShort4444Type),
            (0, $329ek.UnsignedShort5551Type)
        ]);
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        /**
		 * A canvas where the renderer draws its output.This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link - it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $329ek.NoToneMapping);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, $329ek.SRGBColorSpace);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $329ek.Vector4)();
        const _currentScissor = new (0, $329ek.Vector4)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $329ek.Color)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $329ek.Vector4)(0, 0, _width, _height);
        const _scissor = new (0, $329ek.Vector4)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $329ek.Frustum)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new (0, $329ek.Matrix4)();
        const _vector3 = new (0, $329ek.Vector3)();
        const _vector4 = new (0, $329ek.Vector4)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $329ek.REVISION)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            error('WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $169244187a3eb47b$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $169244187a3eb47b$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $169244187a3eb47b$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $169244187a3eb47b$var$WebGLState(_gl, extensions);
            if (capabilities.reversedDepthBuffer && reversedDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $169244187a3eb47b$var$WebGLInfo(_gl);
            properties = new $169244187a3eb47b$var$WebGLProperties();
            textures = new $169244187a3eb47b$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $169244187a3eb47b$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $169244187a3eb47b$var$WebGLCubeUVMaps(_this);
            attributes = new $169244187a3eb47b$var$WebGLAttributes(_gl);
            bindingStates = new $169244187a3eb47b$var$WebGLBindingStates(_gl, attributes);
            geometries = new $169244187a3eb47b$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $169244187a3eb47b$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $169244187a3eb47b$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $169244187a3eb47b$var$WebGLClipping(properties);
            programCache = new $169244187a3eb47b$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $169244187a3eb47b$var$WebGLMaterials(_this, properties);
            renderLists = new $169244187a3eb47b$var$WebGLRenderLists();
            renderStates = new $169244187a3eb47b$var$WebGLRenderStates(extensions);
            background = new $169244187a3eb47b$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $169244187a3eb47b$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $169244187a3eb47b$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $169244187a3eb47b$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $169244187a3eb47b$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $169244187a3eb47b$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                (0, $329ek.warn)('WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = INTEGER_FORMATS.has(targetFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = UNSIGNED_TYPES.has(targetType);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            (0, $329ek.log)('WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            (0, $329ek.log)('WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            (0, $329ek.error)('WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $329ek.warnOnce)('WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $329ek.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $329ek.BackSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $329ek.FrontSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $329ek.DoubleSide);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $169244187a3eb47b$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        /**
		 * Applications are advised to always define the animation loop
		 * with this method and not manually with `requestAnimationFrame()`
		 * for best compatibility.
		 *
		 * @param {?onAnimationCallback} callback - The application's animation loop.
		 */ this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                (0, $329ek.error)('WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix, (0, $329ek.WebGLCoordinateSystem), camera.reversedDepth);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const { opaque: opaqueObjects, transmissive: transmissiveObjects, transparent: transparentObjects } = currentRenderList;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $329ek.WebGLRenderTarget)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $329ek.HalfFloatType) : (0, $329ek.UnsignedByteType),
                minFilter: (0, $329ek.LinearMipmapLinearFilter),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $329ek.ColorManagement).workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            const currentActiveCubeFace = _this.getActiveCubeFace();
            const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $329ek.NoToneMapping);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const { object: object, geometry: geometry, material: material, group: group } = renderItem;
                    if (material.side === (0, $329ek.DoubleSide) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $329ek.BackSide);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const { object: object, geometry: geometry, group: group } = renderItem;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $329ek.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $329ek.BackSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $329ek.FrontSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $329ek.DoubleSide);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $169244187a3eb47b$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $329ek.LinearSRGBColorSpace);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $329ek.NoToneMapping);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reversedDepthBuffer = state.buffers.depth.getReversed();
                if (reversedDepthBuffer && camera.reversedDepth !== true) {
                    camera._reversedDepth = true;
                    camera.updateProjectionMatrix();
                }
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            // Set DFG LUT for physically-based materials
            if (m_uniforms.dfgLUT !== undefined) m_uniforms.dfgLUT.value = $169244187a3eb47b$var$getDFGLUT();
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $169244187a3eb47b$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $169244187a3eb47b$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const layer = activeCubeFace;
                for(let i = 0; i < renderTarget.textures.length; i++){
                    const textureProperties = properties.get(renderTarget.textures[i]);
                    _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, textureProperties.__webglTexture, activeMipmapLevel, layer);
                }
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                (0, $329ek.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        (0, $329ek.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        (0, $329ek.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        // when using MRT, select the correct color buffer for the subsequent read command
                        if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $329ek.probeAsync)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=null] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $329ek.warnOnce)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $329ek.WebGLCoordinateSystem;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, $329ek.ColorManagement)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $329ek.ColorManagement)._getUnpackColorSpace();
    }
}

});
parcelRegister("329ek", function(module, exports) {

$parcel$export(module.exports, "REVISION", () => $2358b7e4ec07df88$export$3545e07a80636437);
$parcel$export(module.exports, "MOUSE", () => $2358b7e4ec07df88$export$7177b3e430c2d7ca);
$parcel$export(module.exports, "TOUCH", () => $2358b7e4ec07df88$export$d46bd3ead7cc759b);
$parcel$export(module.exports, "CullFaceNone", () => $2358b7e4ec07df88$export$3237e1f2c1ea1f44);
$parcel$export(module.exports, "CullFaceBack", () => $2358b7e4ec07df88$export$b9a7b4fc5cb15f9b);
$parcel$export(module.exports, "CullFaceFront", () => $2358b7e4ec07df88$export$b8058bcc7037d3f3);
$parcel$export(module.exports, "CullFaceFrontBack", () => $2358b7e4ec07df88$export$f24be24dcddeac0d);
$parcel$export(module.exports, "BasicShadowMap", () => $2358b7e4ec07df88$export$346307dbae2b7447);
$parcel$export(module.exports, "PCFShadowMap", () => $2358b7e4ec07df88$export$5813f879eee7cd88);
$parcel$export(module.exports, "PCFSoftShadowMap", () => $2358b7e4ec07df88$export$a47c4b43a1be34f0);
$parcel$export(module.exports, "VSMShadowMap", () => $2358b7e4ec07df88$export$896ae1ade6c829c4);
$parcel$export(module.exports, "FrontSide", () => $2358b7e4ec07df88$export$2ede184fc2998901);
$parcel$export(module.exports, "BackSide", () => $2358b7e4ec07df88$export$d9f0486e75b5ace);
$parcel$export(module.exports, "DoubleSide", () => $2358b7e4ec07df88$export$3b296b6f144d5b03);
$parcel$export(module.exports, "NoBlending", () => $2358b7e4ec07df88$export$63b8d6b580fc65ba);
$parcel$export(module.exports, "NormalBlending", () => $2358b7e4ec07df88$export$5b29a26d96ee6af0);
$parcel$export(module.exports, "AdditiveBlending", () => $2358b7e4ec07df88$export$777d8f9551c2216b);
$parcel$export(module.exports, "SubtractiveBlending", () => $2358b7e4ec07df88$export$cdfa06f868e2e467);
$parcel$export(module.exports, "MultiplyBlending", () => $2358b7e4ec07df88$export$4138e1c684b46a20);
$parcel$export(module.exports, "CustomBlending", () => $2358b7e4ec07df88$export$eda4864c68df1fa2);
$parcel$export(module.exports, "AddEquation", () => $2358b7e4ec07df88$export$20183a0484ce21a0);
$parcel$export(module.exports, "SubtractEquation", () => $2358b7e4ec07df88$export$73e0df5177988548);
$parcel$export(module.exports, "ReverseSubtractEquation", () => $2358b7e4ec07df88$export$28e582859cbec660);
$parcel$export(module.exports, "MinEquation", () => $2358b7e4ec07df88$export$c8c1508da8d0600c);
$parcel$export(module.exports, "MaxEquation", () => $2358b7e4ec07df88$export$99948c02fb51055f);
$parcel$export(module.exports, "ZeroFactor", () => $2358b7e4ec07df88$export$2110f05edf778d3d);
$parcel$export(module.exports, "OneFactor", () => $2358b7e4ec07df88$export$8805bad65e24940e);
$parcel$export(module.exports, "SrcColorFactor", () => $2358b7e4ec07df88$export$7fbe15b28d28cf52);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => $2358b7e4ec07df88$export$947829af9f2c17f6);
$parcel$export(module.exports, "SrcAlphaFactor", () => $2358b7e4ec07df88$export$d5773124e86cf28c);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => $2358b7e4ec07df88$export$11d468cc7f19e971);
$parcel$export(module.exports, "DstAlphaFactor", () => $2358b7e4ec07df88$export$a78aed1ca2a87192);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => $2358b7e4ec07df88$export$5d0fe17fd8773bac);
$parcel$export(module.exports, "DstColorFactor", () => $2358b7e4ec07df88$export$ef5f2dd8ffac5574);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => $2358b7e4ec07df88$export$56b85b2686ab16);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => $2358b7e4ec07df88$export$c05e2a1fc8609506);
$parcel$export(module.exports, "ConstantColorFactor", () => $2358b7e4ec07df88$export$7dd8f434fd59075);
$parcel$export(module.exports, "OneMinusConstantColorFactor", () => $2358b7e4ec07df88$export$99c8d898a9afbcee);
$parcel$export(module.exports, "ConstantAlphaFactor", () => $2358b7e4ec07df88$export$310cd2be38d13b56);
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", () => $2358b7e4ec07df88$export$db77b8fbcf45dbf4);
$parcel$export(module.exports, "NeverDepth", () => $2358b7e4ec07df88$export$69025ce147cee220);
$parcel$export(module.exports, "AlwaysDepth", () => $2358b7e4ec07df88$export$7182eb52ea3b3f04);
$parcel$export(module.exports, "LessDepth", () => $2358b7e4ec07df88$export$eedccec66ab7ebe);
$parcel$export(module.exports, "LessEqualDepth", () => $2358b7e4ec07df88$export$296f78a0b892f81a);
$parcel$export(module.exports, "EqualDepth", () => $2358b7e4ec07df88$export$a60d398fc7b7590e);
$parcel$export(module.exports, "GreaterEqualDepth", () => $2358b7e4ec07df88$export$7d7234c1240a1fc4);
$parcel$export(module.exports, "GreaterDepth", () => $2358b7e4ec07df88$export$c5e2c52991f30937);
$parcel$export(module.exports, "NotEqualDepth", () => $2358b7e4ec07df88$export$2f843afa843d8916);
$parcel$export(module.exports, "MultiplyOperation", () => $2358b7e4ec07df88$export$e50ac29801f1774d);
$parcel$export(module.exports, "MixOperation", () => $2358b7e4ec07df88$export$9f9d94f963c85479);
$parcel$export(module.exports, "AddOperation", () => $2358b7e4ec07df88$export$e641dc52bc3494aa);
$parcel$export(module.exports, "NoToneMapping", () => $2358b7e4ec07df88$export$9fcb6b4294603b2);
$parcel$export(module.exports, "LinearToneMapping", () => $2358b7e4ec07df88$export$98f52c2a46c598ca);
$parcel$export(module.exports, "ReinhardToneMapping", () => $2358b7e4ec07df88$export$74b25e54b3bcd548);
$parcel$export(module.exports, "CineonToneMapping", () => $2358b7e4ec07df88$export$932b3dd283d4a366);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => $2358b7e4ec07df88$export$a0d98fe6d7e4af64);
$parcel$export(module.exports, "CustomToneMapping", () => $2358b7e4ec07df88$export$2c7b09c1e9abfb5e);
$parcel$export(module.exports, "AgXToneMapping", () => $2358b7e4ec07df88$export$212d53a513a325b2);
$parcel$export(module.exports, "NeutralToneMapping", () => $2358b7e4ec07df88$export$f2863e1668a8e317);
$parcel$export(module.exports, "AttachedBindMode", () => $2358b7e4ec07df88$export$2595a3798997538);
$parcel$export(module.exports, "DetachedBindMode", () => $2358b7e4ec07df88$export$d7e7dc2e114517a0);
$parcel$export(module.exports, "UVMapping", () => $2358b7e4ec07df88$export$1beec6768cbb3d2d);
$parcel$export(module.exports, "CubeReflectionMapping", () => $2358b7e4ec07df88$export$8759762a6477f2c4);
$parcel$export(module.exports, "CubeRefractionMapping", () => $2358b7e4ec07df88$export$dc59f8aed047f61d);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => $2358b7e4ec07df88$export$d64030b316d3b087);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => $2358b7e4ec07df88$export$ee99d97d46898098);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => $2358b7e4ec07df88$export$dbf3e70ff37af79);
$parcel$export(module.exports, "RepeatWrapping", () => $2358b7e4ec07df88$export$533346c8e8dac0f5);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => $2358b7e4ec07df88$export$9d9334239a5a5e06);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => $2358b7e4ec07df88$export$c7e7c00b14f51a4f);
$parcel$export(module.exports, "NearestFilter", () => $2358b7e4ec07df88$export$727aa5ec3fe39bf0);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => $2358b7e4ec07df88$export$d129e38cf6feaa8c);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => $2358b7e4ec07df88$export$14a4936464a36496);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => $2358b7e4ec07df88$export$d2327c1afe5bfdf2);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => $2358b7e4ec07df88$export$cbc5b7f5647595d8);
$parcel$export(module.exports, "LinearFilter", () => $2358b7e4ec07df88$export$8a72f490b25c56c8);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => $2358b7e4ec07df88$export$19a719f377145a13);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => $2358b7e4ec07df88$export$dbe96bee3fe9dbf0);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => $2358b7e4ec07df88$export$5d8599b6a933fb1b);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => $2358b7e4ec07df88$export$90d80f1e3506775f);
$parcel$export(module.exports, "UnsignedByteType", () => $2358b7e4ec07df88$export$2e8ce08d3f6f5e10);
$parcel$export(module.exports, "ByteType", () => $2358b7e4ec07df88$export$545fce0311a9796a);
$parcel$export(module.exports, "ShortType", () => $2358b7e4ec07df88$export$88572337f312435f);
$parcel$export(module.exports, "UnsignedShortType", () => $2358b7e4ec07df88$export$c63dc51868b06a9d);
$parcel$export(module.exports, "IntType", () => $2358b7e4ec07df88$export$5c612977753abe2);
$parcel$export(module.exports, "UnsignedIntType", () => $2358b7e4ec07df88$export$c3c7fc4518ebba96);
$parcel$export(module.exports, "FloatType", () => $2358b7e4ec07df88$export$f6d331659b644596);
$parcel$export(module.exports, "HalfFloatType", () => $2358b7e4ec07df88$export$2697304443f382bc);
$parcel$export(module.exports, "UnsignedShort4444Type", () => $2358b7e4ec07df88$export$b3969b01faf587f2);
$parcel$export(module.exports, "UnsignedShort5551Type", () => $2358b7e4ec07df88$export$18886f8ae33e90de);
$parcel$export(module.exports, "UnsignedInt248Type", () => $2358b7e4ec07df88$export$6c8ea339bfab1301);
$parcel$export(module.exports, "UnsignedInt5999Type", () => $2358b7e4ec07df88$export$5a4c329b7e2092d3);
$parcel$export(module.exports, "UnsignedInt101111Type", () => $2358b7e4ec07df88$export$f240f067f72abe41);
$parcel$export(module.exports, "AlphaFormat", () => $2358b7e4ec07df88$export$988473390501ed4b);
$parcel$export(module.exports, "RGBFormat", () => $2358b7e4ec07df88$export$7c67423a5ee6f5eb);
$parcel$export(module.exports, "RGBAFormat", () => $2358b7e4ec07df88$export$3f8bb04b555a363c);
$parcel$export(module.exports, "DepthFormat", () => $2358b7e4ec07df88$export$c1b6b5136be58045);
$parcel$export(module.exports, "DepthStencilFormat", () => $2358b7e4ec07df88$export$1e113ac2d0905829);
$parcel$export(module.exports, "RedFormat", () => $2358b7e4ec07df88$export$4e041a7967d15c4b);
$parcel$export(module.exports, "RedIntegerFormat", () => $2358b7e4ec07df88$export$aa92e870a709d190);
$parcel$export(module.exports, "RGFormat", () => $2358b7e4ec07df88$export$6cdf0b461c7ce8a0);
$parcel$export(module.exports, "RGIntegerFormat", () => $2358b7e4ec07df88$export$1ba1c45f9f77d4d7);
$parcel$export(module.exports, "RGBIntegerFormat", () => $2358b7e4ec07df88$export$d1fd40c11bfa798e);
$parcel$export(module.exports, "RGBAIntegerFormat", () => $2358b7e4ec07df88$export$c200e7d26f592f21);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => $2358b7e4ec07df88$export$21d1799c6d552fc0);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => $2358b7e4ec07df88$export$afa304c3e981b668);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => $2358b7e4ec07df88$export$d2a1a68024a3e56c);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => $2358b7e4ec07df88$export$9a79c424327dacf9);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => $2358b7e4ec07df88$export$19ada9bbb1af3573);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => $2358b7e4ec07df88$export$d0f0355bb3d948e4);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => $2358b7e4ec07df88$export$b82296714358084c);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => $2358b7e4ec07df88$export$b71692456c47b6c3);
$parcel$export(module.exports, "RGB_ETC1_Format", () => $2358b7e4ec07df88$export$6ab91af2d757aee7);
$parcel$export(module.exports, "RGB_ETC2_Format", () => $2358b7e4ec07df88$export$7800993ef8106a6a);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => $2358b7e4ec07df88$export$23ed8300a860e7d8);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => $2358b7e4ec07df88$export$dc5570b4a2b92d48);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => $2358b7e4ec07df88$export$68880cd325f8b2fb);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => $2358b7e4ec07df88$export$7d2c0be323373d95);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => $2358b7e4ec07df88$export$22b52da301fc3a3e);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => $2358b7e4ec07df88$export$c009e2cb4a66485e);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => $2358b7e4ec07df88$export$118fff5afa255b63);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => $2358b7e4ec07df88$export$120713c829ae0667);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => $2358b7e4ec07df88$export$c79eeabbf53313e9);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => $2358b7e4ec07df88$export$443cf6567cdd6424);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => $2358b7e4ec07df88$export$6573984fc9840780);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => $2358b7e4ec07df88$export$e7aee563f30091de);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => $2358b7e4ec07df88$export$2eb8634622ddeab7);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => $2358b7e4ec07df88$export$202b1ce7b5d25742);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => $2358b7e4ec07df88$export$18ab77abd087e467);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => $2358b7e4ec07df88$export$ce40b115e188bc81);
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", () => $2358b7e4ec07df88$export$d279c5c4bac5121e);
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", () => $2358b7e4ec07df88$export$cde52d17225fdbd3);
$parcel$export(module.exports, "RED_RGTC1_Format", () => $2358b7e4ec07df88$export$b1688df4c4c21670);
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", () => $2358b7e4ec07df88$export$fc15e5d8261eed58);
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", () => $2358b7e4ec07df88$export$d220f6ade8463a0f);
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $2358b7e4ec07df88$export$768646d09dc1b6ef);
$parcel$export(module.exports, "LoopOnce", () => $2358b7e4ec07df88$export$d62fdc9d1b1cccad);
$parcel$export(module.exports, "LoopRepeat", () => $2358b7e4ec07df88$export$dfaf4422ce096e29);
$parcel$export(module.exports, "LoopPingPong", () => $2358b7e4ec07df88$export$f8f6f2041b78e210);
$parcel$export(module.exports, "InterpolateDiscrete", () => $2358b7e4ec07df88$export$995b32462a65e855);
$parcel$export(module.exports, "InterpolateLinear", () => $2358b7e4ec07df88$export$30fac1aace31cf4d);
$parcel$export(module.exports, "InterpolateSmooth", () => $2358b7e4ec07df88$export$198b11ff4c72bb30);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => $2358b7e4ec07df88$export$7f795934b84ab523);
$parcel$export(module.exports, "ZeroSlopeEnding", () => $2358b7e4ec07df88$export$24a4ccb5099273b5);
$parcel$export(module.exports, "WrapAroundEnding", () => $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => $2358b7e4ec07df88$export$d875e029ef558d3);
$parcel$export(module.exports, "TrianglesDrawMode", () => $2358b7e4ec07df88$export$4c28c87c2dc84758);
$parcel$export(module.exports, "TriangleStripDrawMode", () => $2358b7e4ec07df88$export$b23a071aa286eb29);
$parcel$export(module.exports, "TriangleFanDrawMode", () => $2358b7e4ec07df88$export$f0d8293634f88842);
$parcel$export(module.exports, "BasicDepthPacking", () => $2358b7e4ec07df88$export$deeb383078690b50);
$parcel$export(module.exports, "RGBADepthPacking", () => $2358b7e4ec07df88$export$8f910f4c4f73df11);
$parcel$export(module.exports, "RGBDepthPacking", () => $2358b7e4ec07df88$export$be2e2ddbc3983173);
$parcel$export(module.exports, "RGDepthPacking", () => $2358b7e4ec07df88$export$1a54198784742f80);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => $2358b7e4ec07df88$export$2852a58ebdac27b8);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => $2358b7e4ec07df88$export$9990ad26f9db5b2c);
$parcel$export(module.exports, "NoColorSpace", () => $2358b7e4ec07df88$export$bfcb490c2dd3db51);
$parcel$export(module.exports, "SRGBColorSpace", () => $2358b7e4ec07df88$export$561f394b24edfcaa);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => $2358b7e4ec07df88$export$42429b3acfb233a4);
$parcel$export(module.exports, "LinearTransfer", () => $2358b7e4ec07df88$export$f197347d588c1b4a);
$parcel$export(module.exports, "SRGBTransfer", () => $2358b7e4ec07df88$export$8d0a61916cc26abb);
$parcel$export(module.exports, "ZeroStencilOp", () => $2358b7e4ec07df88$export$69433f11f42d5527);
$parcel$export(module.exports, "KeepStencilOp", () => $2358b7e4ec07df88$export$9f542ae4b5baca34);
$parcel$export(module.exports, "ReplaceStencilOp", () => $2358b7e4ec07df88$export$8a4f28336ef203d3);
$parcel$export(module.exports, "IncrementStencilOp", () => $2358b7e4ec07df88$export$2928c0231297c036);
$parcel$export(module.exports, "DecrementStencilOp", () => $2358b7e4ec07df88$export$c0e9611c8a15f9a8);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => $2358b7e4ec07df88$export$9c2c08927385dcc4);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => $2358b7e4ec07df88$export$7c74ea00fa1315e6);
$parcel$export(module.exports, "InvertStencilOp", () => $2358b7e4ec07df88$export$22e2e5726612443);
$parcel$export(module.exports, "NeverStencilFunc", () => $2358b7e4ec07df88$export$1343870698229224);
$parcel$export(module.exports, "LessStencilFunc", () => $2358b7e4ec07df88$export$8e1d8ed281997fa6);
$parcel$export(module.exports, "EqualStencilFunc", () => $2358b7e4ec07df88$export$55648a1cde8329a7);
$parcel$export(module.exports, "LessEqualStencilFunc", () => $2358b7e4ec07df88$export$2dff107857e6aca2);
$parcel$export(module.exports, "GreaterStencilFunc", () => $2358b7e4ec07df88$export$6f93765ab2f451a2);
$parcel$export(module.exports, "NotEqualStencilFunc", () => $2358b7e4ec07df88$export$6f3fb2d2440f2b76);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => $2358b7e4ec07df88$export$4119cf7b4c98fd5a);
$parcel$export(module.exports, "AlwaysStencilFunc", () => $2358b7e4ec07df88$export$14cf96713ddd97a8);
$parcel$export(module.exports, "NeverCompare", () => $2358b7e4ec07df88$export$d9e2d19a747baaab);
$parcel$export(module.exports, "LessCompare", () => $2358b7e4ec07df88$export$36bcf49c713b3eb7);
$parcel$export(module.exports, "EqualCompare", () => $2358b7e4ec07df88$export$66f28d946fc6a0d5);
$parcel$export(module.exports, "LessEqualCompare", () => $2358b7e4ec07df88$export$64eea11eb407ddf1);
$parcel$export(module.exports, "GreaterCompare", () => $2358b7e4ec07df88$export$155af022118f3a38);
$parcel$export(module.exports, "NotEqualCompare", () => $2358b7e4ec07df88$export$67ab95dde6bed156);
$parcel$export(module.exports, "GreaterEqualCompare", () => $2358b7e4ec07df88$export$1cdcb70d53d65f61);
$parcel$export(module.exports, "AlwaysCompare", () => $2358b7e4ec07df88$export$187b73a3e352c145);
$parcel$export(module.exports, "StaticDrawUsage", () => $2358b7e4ec07df88$export$763e8360f4d7f77d);
$parcel$export(module.exports, "DynamicDrawUsage", () => $2358b7e4ec07df88$export$8505d14ac8546ca);
$parcel$export(module.exports, "StreamDrawUsage", () => $2358b7e4ec07df88$export$721e63549e51d81e);
$parcel$export(module.exports, "StaticReadUsage", () => $2358b7e4ec07df88$export$415731dc4f48e299);
$parcel$export(module.exports, "DynamicReadUsage", () => $2358b7e4ec07df88$export$9e809946455f13bc);
$parcel$export(module.exports, "StreamReadUsage", () => $2358b7e4ec07df88$export$2ed9499a35b5f832);
$parcel$export(module.exports, "StaticCopyUsage", () => $2358b7e4ec07df88$export$32ab2503ea19469a);
$parcel$export(module.exports, "DynamicCopyUsage", () => $2358b7e4ec07df88$export$ab4022c2c3f86315);
$parcel$export(module.exports, "StreamCopyUsage", () => $2358b7e4ec07df88$export$ba7f1db36a76a970);
$parcel$export(module.exports, "GLSL1", () => $2358b7e4ec07df88$export$43600cc67fabd9f);
$parcel$export(module.exports, "GLSL3", () => $2358b7e4ec07df88$export$f63012db5506e7dd);
$parcel$export(module.exports, "WebGLCoordinateSystem", () => $2358b7e4ec07df88$export$5a0e9190d10875d3);
$parcel$export(module.exports, "WebGPUCoordinateSystem", () => $2358b7e4ec07df88$export$cc83beedcb9be9ac);
$parcel$export(module.exports, "TimestampQuery", () => $2358b7e4ec07df88$export$f97db56e2b647801);
$parcel$export(module.exports, "InterpolationSamplingType", () => $2358b7e4ec07df88$export$ff3764a6b1cf3544);
$parcel$export(module.exports, "InterpolationSamplingMode", () => $2358b7e4ec07df88$export$599d2e4c2d7b2a01);
$parcel$export(module.exports, "arrayNeedsUint32", () => $2358b7e4ec07df88$export$bc6f937da07eae17);
$parcel$export(module.exports, "createElementNS", () => $2358b7e4ec07df88$export$7094a064528c7fee);
$parcel$export(module.exports, "createCanvasElement", () => $2358b7e4ec07df88$export$1033a2df66368859);
$parcel$export(module.exports, "setConsoleFunction", () => $2358b7e4ec07df88$export$702823ffb42fb3aa);
$parcel$export(module.exports, "getConsoleFunction", () => $2358b7e4ec07df88$export$fa86edd994bb169f);
$parcel$export(module.exports, "log", () => $2358b7e4ec07df88$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "warn", () => $2358b7e4ec07df88$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $2358b7e4ec07df88$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "warnOnce", () => $2358b7e4ec07df88$export$5b28268982f175ba);
$parcel$export(module.exports, "probeAsync", () => $2358b7e4ec07df88$export$d43f91ebeafb2c7);
$parcel$export(module.exports, "EventDispatcher", () => $2358b7e4ec07df88$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "RAD2DEG", () => $2358b7e4ec07df88$export$914076c8150813e5);
$parcel$export(module.exports, "MathUtils", () => $2358b7e4ec07df88$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Vector2", () => $2358b7e4ec07df88$export$c977b3e384af9ae1);
$parcel$export(module.exports, "Quaternion", () => $2358b7e4ec07df88$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "Vector3", () => $2358b7e4ec07df88$export$64b5c384219d3699);
$parcel$export(module.exports, "Matrix3", () => $2358b7e4ec07df88$export$8ff26dafa08918);
$parcel$export(module.exports, "ColorManagement", () => $2358b7e4ec07df88$export$5e6fd513f44698c);
$parcel$export(module.exports, "ImageUtils", () => $2358b7e4ec07df88$export$698882cf06df44aa);
$parcel$export(module.exports, "Source", () => $2358b7e4ec07df88$export$1d2df86270c81ecb);
$parcel$export(module.exports, "Texture", () => $2358b7e4ec07df88$export$5431306cf43de24a);
$parcel$export(module.exports, "Vector4", () => $2358b7e4ec07df88$export$fa7daccca11cdbe3);
$parcel$export(module.exports, "RenderTarget", () => $2358b7e4ec07df88$export$efcb1f8bf367cbfb);
$parcel$export(module.exports, "WebGLRenderTarget", () => $2358b7e4ec07df88$export$3c052beb2e51e23f);
$parcel$export(module.exports, "DataArrayTexture", () => $2358b7e4ec07df88$export$dfac6c8e811406a3);
$parcel$export(module.exports, "WebGLArrayRenderTarget", () => $2358b7e4ec07df88$export$c77a02c11ed180c7);
$parcel$export(module.exports, "Data3DTexture", () => $2358b7e4ec07df88$export$d7a3086320f856db);
$parcel$export(module.exports, "WebGL3DRenderTarget", () => $2358b7e4ec07df88$export$7ee06591009639df);
$parcel$export(module.exports, "Box3", () => $2358b7e4ec07df88$export$6f7d5a9418ab2aa3);
$parcel$export(module.exports, "Sphere", () => $2358b7e4ec07df88$export$805e8b72413ccaba);
$parcel$export(module.exports, "Ray", () => $2358b7e4ec07df88$export$a186db52eed6d40e);
$parcel$export(module.exports, "Matrix4", () => $2358b7e4ec07df88$export$2ae72fc923e5eb5);
$parcel$export(module.exports, "Euler", () => $2358b7e4ec07df88$export$d93cc409a0768c5f);
$parcel$export(module.exports, "Layers", () => $2358b7e4ec07df88$export$89312ce47c0ca777);
$parcel$export(module.exports, "Object3D", () => $2358b7e4ec07df88$export$e4dd07dff30cc924);
$parcel$export(module.exports, "Triangle", () => $2358b7e4ec07df88$export$5a465592bfe74b48);
$parcel$export(module.exports, "Color", () => $2358b7e4ec07df88$export$892596cec99bc70e);
$parcel$export(module.exports, "Material", () => $2358b7e4ec07df88$export$a2d8b23205c25948);
$parcel$export(module.exports, "MeshBasicMaterial", () => $2358b7e4ec07df88$export$55cbcc9b622fe1f5);
$parcel$export(module.exports, "DataUtils", () => $2358b7e4ec07df88$export$11ce8b759162cc80);
$parcel$export(module.exports, "BufferAttribute", () => $2358b7e4ec07df88$export$8dea267bd6bde117);
$parcel$export(module.exports, "Int8BufferAttribute", () => $2358b7e4ec07df88$export$f9ff2d6a20248cbf);
$parcel$export(module.exports, "Uint8BufferAttribute", () => $2358b7e4ec07df88$export$cacc90cf35d11cdd);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => $2358b7e4ec07df88$export$baaa85a1a812c157);
$parcel$export(module.exports, "Int16BufferAttribute", () => $2358b7e4ec07df88$export$2b755a102ccdcefe);
$parcel$export(module.exports, "Uint16BufferAttribute", () => $2358b7e4ec07df88$export$640a853f68025f2e);
$parcel$export(module.exports, "Int32BufferAttribute", () => $2358b7e4ec07df88$export$46b369aed2968a0a);
$parcel$export(module.exports, "Uint32BufferAttribute", () => $2358b7e4ec07df88$export$7eb8c9fa25cd5bd6);
$parcel$export(module.exports, "Float16BufferAttribute", () => $2358b7e4ec07df88$export$dbd3698c64958d69);
$parcel$export(module.exports, "Float32BufferAttribute", () => $2358b7e4ec07df88$export$cbe7a62641830ebd);
$parcel$export(module.exports, "BufferGeometry", () => $2358b7e4ec07df88$export$b7be63a67df8959);
$parcel$export(module.exports, "Mesh", () => $2358b7e4ec07df88$export$e176487c05830cc5);
$parcel$export(module.exports, "BoxGeometry", () => $2358b7e4ec07df88$export$33e43285f7406bd5);
$parcel$export(module.exports, "cloneUniforms", () => $2358b7e4ec07df88$export$acda854380553452);
$parcel$export(module.exports, "mergeUniforms", () => $2358b7e4ec07df88$export$8916ce6879271f43);
$parcel$export(module.exports, "getUnlitUniformColorSpace", () => $2358b7e4ec07df88$export$a630742c640528c1);
$parcel$export(module.exports, "UniformsUtils", () => $2358b7e4ec07df88$export$d8ecdf8615bfea69);
$parcel$export(module.exports, "ShaderMaterial", () => $2358b7e4ec07df88$export$83c7d75d550a8b0d);
$parcel$export(module.exports, "Camera", () => $2358b7e4ec07df88$export$79f141de891a5fed);
$parcel$export(module.exports, "PerspectiveCamera", () => $2358b7e4ec07df88$export$74e4ae24825f68d7);
$parcel$export(module.exports, "CubeCamera", () => $2358b7e4ec07df88$export$d0cdd0bd804995de);
$parcel$export(module.exports, "CubeTexture", () => $2358b7e4ec07df88$export$ee2e5a18258a4049);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => $2358b7e4ec07df88$export$ac386671d651941e);
$parcel$export(module.exports, "Group", () => $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "WebXRController", () => $2358b7e4ec07df88$export$cb626c57dcc48b9f);
$parcel$export(module.exports, "FogExp2", () => $2358b7e4ec07df88$export$6f1519f023b8d0f6);
$parcel$export(module.exports, "Fog", () => $2358b7e4ec07df88$export$3c890837b09508d4);
$parcel$export(module.exports, "Scene", () => $2358b7e4ec07df88$export$38af1803e3442a7f);
$parcel$export(module.exports, "InterleavedBuffer", () => $2358b7e4ec07df88$export$3d5cd879f108f53f);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => $2358b7e4ec07df88$export$920b6d07334599c7);
$parcel$export(module.exports, "SpriteMaterial", () => $2358b7e4ec07df88$export$5ec7dd1c6994bf8e);
$parcel$export(module.exports, "Sprite", () => $2358b7e4ec07df88$export$3075603db8e6204c);
$parcel$export(module.exports, "LOD", () => $2358b7e4ec07df88$export$112e7237be0c5f30);
$parcel$export(module.exports, "SkinnedMesh", () => $2358b7e4ec07df88$export$b303577035157ecf);
$parcel$export(module.exports, "Bone", () => $2358b7e4ec07df88$export$b127726e56765aa4);
$parcel$export(module.exports, "DataTexture", () => $2358b7e4ec07df88$export$b691f601014eabe1);
$parcel$export(module.exports, "Skeleton", () => $2358b7e4ec07df88$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InstancedBufferAttribute", () => $2358b7e4ec07df88$export$32ea87a8b54d744a);
$parcel$export(module.exports, "InstancedMesh", () => $2358b7e4ec07df88$export$f3c979c331175ad7);
$parcel$export(module.exports, "Plane", () => $2358b7e4ec07df88$export$7ff5ac152ef991b0);
$parcel$export(module.exports, "Frustum", () => $2358b7e4ec07df88$export$35efe6f4c85463d2);
$parcel$export(module.exports, "FrustumArray", () => $2358b7e4ec07df88$export$2d7d04327620499c);
$parcel$export(module.exports, "BatchedMesh", () => $2358b7e4ec07df88$export$6e01c5ee52ed8f7b);
$parcel$export(module.exports, "LineBasicMaterial", () => $2358b7e4ec07df88$export$fbaaa33907730a0c);
$parcel$export(module.exports, "Line", () => $2358b7e4ec07df88$export$17d680238e50603e);
$parcel$export(module.exports, "LineSegments", () => $2358b7e4ec07df88$export$ff1ed10fedfdd604);
$parcel$export(module.exports, "LineLoop", () => $2358b7e4ec07df88$export$f85a24d745e4f17d);
$parcel$export(module.exports, "PointsMaterial", () => $2358b7e4ec07df88$export$a178c45366ce5d6b);
$parcel$export(module.exports, "Points", () => $2358b7e4ec07df88$export$1c787534cb11aa3e);
$parcel$export(module.exports, "VideoTexture", () => $2358b7e4ec07df88$export$6e09d1edf8d5a25c);
$parcel$export(module.exports, "VideoFrameTexture", () => $2358b7e4ec07df88$export$68498d200b825382);
$parcel$export(module.exports, "FramebufferTexture", () => $2358b7e4ec07df88$export$9270d786f73ce6fe);
$parcel$export(module.exports, "CompressedTexture", () => $2358b7e4ec07df88$export$3466bac9141a5cc4);
$parcel$export(module.exports, "CompressedArrayTexture", () => $2358b7e4ec07df88$export$5fe6b8e34b274fcb);
$parcel$export(module.exports, "CompressedCubeTexture", () => $2358b7e4ec07df88$export$d80173634de65bff);
$parcel$export(module.exports, "CanvasTexture", () => $2358b7e4ec07df88$export$f7189e49152d1c13);
$parcel$export(module.exports, "DepthTexture", () => $2358b7e4ec07df88$export$fc830aa069cc8c2f);
$parcel$export(module.exports, "ExternalTexture", () => $2358b7e4ec07df88$export$cd10147cacf16ab2);
$parcel$export(module.exports, "CapsuleGeometry", () => $2358b7e4ec07df88$export$41680e8551036033);
$parcel$export(module.exports, "CircleGeometry", () => $2358b7e4ec07df88$export$d5c0e8d607467193);
$parcel$export(module.exports, "CylinderGeometry", () => $2358b7e4ec07df88$export$68f745719dbe5198);
$parcel$export(module.exports, "ConeGeometry", () => $2358b7e4ec07df88$export$a7a48974f285c9b3);
$parcel$export(module.exports, "PolyhedronGeometry", () => $2358b7e4ec07df88$export$60e57a7d3f20ff65);
$parcel$export(module.exports, "DodecahedronGeometry", () => $2358b7e4ec07df88$export$c0babfeb8708fc9c);
$parcel$export(module.exports, "EdgesGeometry", () => $2358b7e4ec07df88$export$4730b1542707547f);
$parcel$export(module.exports, "Curve", () => $2358b7e4ec07df88$export$b0e83c3ef8d2db1);
$parcel$export(module.exports, "EllipseCurve", () => $2358b7e4ec07df88$export$3f87a931616cde04);
$parcel$export(module.exports, "ArcCurve", () => $2358b7e4ec07df88$export$b1eedc9aab6300e8);
$parcel$export(module.exports, "CatmullRomCurve3", () => $2358b7e4ec07df88$export$b9146b27c24b744c);
$parcel$export(module.exports, "CubicBezierCurve", () => $2358b7e4ec07df88$export$e36650d36468bb39);
$parcel$export(module.exports, "CubicBezierCurve3", () => $2358b7e4ec07df88$export$13d5f1c9525f246c);
$parcel$export(module.exports, "LineCurve", () => $2358b7e4ec07df88$export$ab2e07e76531a47e);
$parcel$export(module.exports, "LineCurve3", () => $2358b7e4ec07df88$export$1fdfd9d9cf487600);
$parcel$export(module.exports, "QuadraticBezierCurve", () => $2358b7e4ec07df88$export$5938c4ee491a43ad);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => $2358b7e4ec07df88$export$bf3f4c7e459f90fc);
$parcel$export(module.exports, "SplineCurve", () => $2358b7e4ec07df88$export$d3bdd77da77afc1b);
$parcel$export(module.exports, "CurvePath", () => $2358b7e4ec07df88$export$4aaf9b66af1bbf2c);
$parcel$export(module.exports, "Path", () => $2358b7e4ec07df88$export$4b2950bdac9b6ee9);
$parcel$export(module.exports, "Shape", () => $2358b7e4ec07df88$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "ShapeUtils", () => $2358b7e4ec07df88$export$96bdf6d9c66d7ba8);
$parcel$export(module.exports, "ExtrudeGeometry", () => $2358b7e4ec07df88$export$598697a1efa63ca7);
$parcel$export(module.exports, "IcosahedronGeometry", () => $2358b7e4ec07df88$export$9567cc828c9535da);
$parcel$export(module.exports, "LatheGeometry", () => $2358b7e4ec07df88$export$6d839803fcd1882c);
$parcel$export(module.exports, "OctahedronGeometry", () => $2358b7e4ec07df88$export$1954e2b809fe361e);
$parcel$export(module.exports, "PlaneGeometry", () => $2358b7e4ec07df88$export$967d831af31f69ce);
$parcel$export(module.exports, "RingGeometry", () => $2358b7e4ec07df88$export$68cb731f50f614af);
$parcel$export(module.exports, "ShapeGeometry", () => $2358b7e4ec07df88$export$57a29a1c803e9065);
$parcel$export(module.exports, "SphereGeometry", () => $2358b7e4ec07df88$export$1b417fc3b307a251);
$parcel$export(module.exports, "TetrahedronGeometry", () => $2358b7e4ec07df88$export$fb3f7adc68bd6e02);
$parcel$export(module.exports, "TorusGeometry", () => $2358b7e4ec07df88$export$a2312a2a1fa56495);
$parcel$export(module.exports, "TorusKnotGeometry", () => $2358b7e4ec07df88$export$77e9bfadfb9ab8c8);
$parcel$export(module.exports, "TubeGeometry", () => $2358b7e4ec07df88$export$7897d9d48904490c);
$parcel$export(module.exports, "WireframeGeometry", () => $2358b7e4ec07df88$export$4b739da06d24892b);
$parcel$export(module.exports, "ShadowMaterial", () => $2358b7e4ec07df88$export$e8564da406055a3);
$parcel$export(module.exports, "RawShaderMaterial", () => $2358b7e4ec07df88$export$21c421a2e1df9d22);
$parcel$export(module.exports, "MeshStandardMaterial", () => $2358b7e4ec07df88$export$f2980790215acccd);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => $2358b7e4ec07df88$export$28d04986c4269c9f);
$parcel$export(module.exports, "MeshPhongMaterial", () => $2358b7e4ec07df88$export$24c72f71cbaf0678);
$parcel$export(module.exports, "MeshToonMaterial", () => $2358b7e4ec07df88$export$df893cf97e765622);
$parcel$export(module.exports, "MeshNormalMaterial", () => $2358b7e4ec07df88$export$bfe8c0a091f41ae7);
$parcel$export(module.exports, "MeshLambertMaterial", () => $2358b7e4ec07df88$export$5023a9a8114806b8);
$parcel$export(module.exports, "MeshDepthMaterial", () => $2358b7e4ec07df88$export$2698c22ec13825db);
$parcel$export(module.exports, "MeshDistanceMaterial", () => $2358b7e4ec07df88$export$33e187ed002f2a19);
$parcel$export(module.exports, "MeshMatcapMaterial", () => $2358b7e4ec07df88$export$6f5fef6235ec12ee);
$parcel$export(module.exports, "LineDashedMaterial", () => $2358b7e4ec07df88$export$327886a3efaeaebe);
$parcel$export(module.exports, "AnimationUtils", () => $2358b7e4ec07df88$export$7ee8caa573e71ad1);
$parcel$export(module.exports, "Interpolant", () => $2358b7e4ec07df88$export$b558baee9c0f72d3);
$parcel$export(module.exports, "CubicInterpolant", () => $2358b7e4ec07df88$export$3646682e7a3959);
$parcel$export(module.exports, "LinearInterpolant", () => $2358b7e4ec07df88$export$a8e6009059f51e1a);
$parcel$export(module.exports, "DiscreteInterpolant", () => $2358b7e4ec07df88$export$fb9758ef7ef8d5cc);
$parcel$export(module.exports, "KeyframeTrack", () => $2358b7e4ec07df88$export$b0e479f45b7006d6);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => $2358b7e4ec07df88$export$d3a344b98cf0b775);
$parcel$export(module.exports, "ColorKeyframeTrack", () => $2358b7e4ec07df88$export$83444c5d885347d8);
$parcel$export(module.exports, "NumberKeyframeTrack", () => $2358b7e4ec07df88$export$d45f0d1a4d9a9314);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => $2358b7e4ec07df88$export$2db1cfb7923d931e);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => $2358b7e4ec07df88$export$b8043f12b5aafbd7);
$parcel$export(module.exports, "StringKeyframeTrack", () => $2358b7e4ec07df88$export$6ce41d4f3a8df9cd);
$parcel$export(module.exports, "VectorKeyframeTrack", () => $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff);
$parcel$export(module.exports, "AnimationClip", () => $2358b7e4ec07df88$export$d942c706bf23829c);
$parcel$export(module.exports, "Cache", () => $2358b7e4ec07df88$export$94affb487e701bf2);
$parcel$export(module.exports, "LoadingManager", () => $2358b7e4ec07df88$export$99cc795e99919eed);
$parcel$export(module.exports, "DefaultLoadingManager", () => $2358b7e4ec07df88$export$b033c3f9a95c6a16);
$parcel$export(module.exports, "Loader", () => $2358b7e4ec07df88$export$3b0d6d7590275603);
$parcel$export(module.exports, "FileLoader", () => $2358b7e4ec07df88$export$98435a25b5cf7b2b);
$parcel$export(module.exports, "AnimationLoader", () => $2358b7e4ec07df88$export$29711c7e14f61db);
$parcel$export(module.exports, "CompressedTextureLoader", () => $2358b7e4ec07df88$export$bd73ce947a280350);
$parcel$export(module.exports, "ImageLoader", () => $2358b7e4ec07df88$export$8905ce1c7a2464a1);
$parcel$export(module.exports, "CubeTextureLoader", () => $2358b7e4ec07df88$export$2ec114afc2cf6308);
$parcel$export(module.exports, "DataTextureLoader", () => $2358b7e4ec07df88$export$792d8a18f2c55855);
$parcel$export(module.exports, "TextureLoader", () => $2358b7e4ec07df88$export$fd1bfc71f64c538c);
$parcel$export(module.exports, "Light", () => $2358b7e4ec07df88$export$6ecadb6ed240d696);
$parcel$export(module.exports, "HemisphereLight", () => $2358b7e4ec07df88$export$8d474f55edbb9624);
$parcel$export(module.exports, "SpotLight", () => $2358b7e4ec07df88$export$81495cbb73897362);
$parcel$export(module.exports, "PointLight", () => $2358b7e4ec07df88$export$4c9c1cb3f0b6f455);
$parcel$export(module.exports, "OrthographicCamera", () => $2358b7e4ec07df88$export$9ebf355ee4ed261b);
$parcel$export(module.exports, "DirectionalLight", () => $2358b7e4ec07df88$export$3fea33cc9972c868);
$parcel$export(module.exports, "AmbientLight", () => $2358b7e4ec07df88$export$af279bfef9ec2c96);
$parcel$export(module.exports, "RectAreaLight", () => $2358b7e4ec07df88$export$61db2d908bbd2429);
$parcel$export(module.exports, "SphericalHarmonics3", () => $2358b7e4ec07df88$export$ba61ce607e1f405a);
$parcel$export(module.exports, "LightProbe", () => $2358b7e4ec07df88$export$e7ef036e309b38d2);
$parcel$export(module.exports, "MaterialLoader", () => $2358b7e4ec07df88$export$3bd6d323353dcf96);
$parcel$export(module.exports, "LoaderUtils", () => $2358b7e4ec07df88$export$b5d2dc08d867e41a);
$parcel$export(module.exports, "InstancedBufferGeometry", () => $2358b7e4ec07df88$export$231f009cbe414146);
$parcel$export(module.exports, "BufferGeometryLoader", () => $2358b7e4ec07df88$export$dc275bb96327833a);
$parcel$export(module.exports, "ObjectLoader", () => $2358b7e4ec07df88$export$40110c8505c5ad19);
$parcel$export(module.exports, "ImageBitmapLoader", () => $2358b7e4ec07df88$export$52286b55c4a9b51f);
$parcel$export(module.exports, "AudioContext", () => $2358b7e4ec07df88$export$fcbc63750ec2a81f);
$parcel$export(module.exports, "AudioLoader", () => $2358b7e4ec07df88$export$d8d5fccfbf47714e);
$parcel$export(module.exports, "StereoCamera", () => $2358b7e4ec07df88$export$bc7f73a1065bee0c);
$parcel$export(module.exports, "ArrayCamera", () => $2358b7e4ec07df88$export$56b937d9e5581166);
$parcel$export(module.exports, "Clock", () => $2358b7e4ec07df88$export$9735c82c4bae3302);
$parcel$export(module.exports, "AudioListener", () => $2358b7e4ec07df88$export$8a1b810c6fde8951);
$parcel$export(module.exports, "Audio", () => $2358b7e4ec07df88$export$153755f98d9861de);
$parcel$export(module.exports, "PositionalAudio", () => $2358b7e4ec07df88$export$4b3e397ef1832507);
$parcel$export(module.exports, "AudioAnalyser", () => $2358b7e4ec07df88$export$d47da1ef3d382827);
$parcel$export(module.exports, "PropertyMixer", () => $2358b7e4ec07df88$export$dfe0af1ca1acb78a);
$parcel$export(module.exports, "PropertyBinding", () => $2358b7e4ec07df88$export$7bf70fcf9f891893);
$parcel$export(module.exports, "AnimationObjectGroup", () => $2358b7e4ec07df88$export$30619c2afd3f34db);
$parcel$export(module.exports, "AnimationAction", () => $2358b7e4ec07df88$export$6946940a69e799e);
$parcel$export(module.exports, "AnimationMixer", () => $2358b7e4ec07df88$export$fbd77e5aefaa0102);
$parcel$export(module.exports, "RenderTarget3D", () => $2358b7e4ec07df88$export$6b116d2fdfef087c);
$parcel$export(module.exports, "Uniform", () => $2358b7e4ec07df88$export$2947cebfe91c02f8);
$parcel$export(module.exports, "UniformsGroup", () => $2358b7e4ec07df88$export$c412d5ffe1f79209);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => $2358b7e4ec07df88$export$25ec0e1af1389358);
$parcel$export(module.exports, "GLBufferAttribute", () => $2358b7e4ec07df88$export$6b7339ae8dbddf73);
$parcel$export(module.exports, "Raycaster", () => $2358b7e4ec07df88$export$8b7aaceff00bd2f);
$parcel$export(module.exports, "Timer", () => $2358b7e4ec07df88$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "Spherical", () => $2358b7e4ec07df88$export$d712cd887b4a00f7);
$parcel$export(module.exports, "Cylindrical", () => $2358b7e4ec07df88$export$287165bb2177f4fd);
$parcel$export(module.exports, "Matrix2", () => $2358b7e4ec07df88$export$cbcc6560bf79fb38);
$parcel$export(module.exports, "Box2", () => $2358b7e4ec07df88$export$60f553fa130f08b0);
$parcel$export(module.exports, "Line3", () => $2358b7e4ec07df88$export$e0ba6359f1954fd3);
$parcel$export(module.exports, "SpotLightHelper", () => $2358b7e4ec07df88$export$4b14638ffdd81e68);
$parcel$export(module.exports, "SkeletonHelper", () => $2358b7e4ec07df88$export$5277df3c9e732259);
$parcel$export(module.exports, "PointLightHelper", () => $2358b7e4ec07df88$export$9a9291685b9e4023);
$parcel$export(module.exports, "HemisphereLightHelper", () => $2358b7e4ec07df88$export$8dca15f13f4f8172);
$parcel$export(module.exports, "GridHelper", () => $2358b7e4ec07df88$export$3875d39926561055);
$parcel$export(module.exports, "PolarGridHelper", () => $2358b7e4ec07df88$export$361430a10f533cd3);
$parcel$export(module.exports, "DirectionalLightHelper", () => $2358b7e4ec07df88$export$f8e434dc14203e7d);
$parcel$export(module.exports, "CameraHelper", () => $2358b7e4ec07df88$export$ed8e93f853cd795);
$parcel$export(module.exports, "BoxHelper", () => $2358b7e4ec07df88$export$38a664cc862a6a9d);
$parcel$export(module.exports, "Box3Helper", () => $2358b7e4ec07df88$export$ce39f4bb96c9a290);
$parcel$export(module.exports, "PlaneHelper", () => $2358b7e4ec07df88$export$a34fe8156c66e5d7);
$parcel$export(module.exports, "ArrowHelper", () => $2358b7e4ec07df88$export$a3008e7bd8d2cbe7);
$parcel$export(module.exports, "AxesHelper", () => $2358b7e4ec07df88$export$6c8303f35b8578fd);
$parcel$export(module.exports, "ShapePath", () => $2358b7e4ec07df88$export$148534a3c727230b);
$parcel$export(module.exports, "Controls", () => $2358b7e4ec07df88$export$c7c44baae9d9f25f);
$parcel$export(module.exports, "getByteLength", () => $2358b7e4ec07df88$export$cc8c3b705bb8e6e2);
$parcel$export(module.exports, "TextureUtils", () => $2358b7e4ec07df88$export$ec276d39f33d4b7);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $2358b7e4ec07df88$export$3545e07a80636437 = '181';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const $2358b7e4ec07df88$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const $2358b7e4ec07df88$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$eda4864c68df1fa2 = 5;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d129e38cf6feaa8c = 1004;
const $2358b7e4ec07df88$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d2327c1afe5bfdf2 = 1005;
const $2358b7e4ec07df88$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$19a719f377145a13 = 1007;
const $2358b7e4ec07df88$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5d8599b6a933fb1b = 1008;
const $2358b7e4ec07df88$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5a4c329b7e2092d3 = 35902;
/**
 * An unsigned int 10_11_11 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f240f067f72abe41 = 35899;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$3f8bb04b555a363c = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$23ed8300a860e7d8 = 37496;
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$198b11ff4c72bb30 = 2302;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$f0d8293634f88842 = 2;
/**
 * Basic depth packing.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$deeb383078690b50 = 3200;
/**
 * A depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8f910f4c4f73df11 = 3201;
/**
 * A depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$be2e2ddbc3983173 = 3202;
/**
 * A depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$8d0a61916cc26abb = 'srgb';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const $2358b7e4ec07df88$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const $2358b7e4ec07df88$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const $2358b7e4ec07df88$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ const $2358b7e4ec07df88$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ const $2358b7e4ec07df88$export$599d2e4c2d7b2a01 = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FIRST - Flat interpolation using the first vertex.
 * @property {string} EITHER - Flat interpolation using either vertex.
 */ function $2358b7e4ec07df88$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $2358b7e4ec07df88$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $2358b7e4ec07df88$var$getTypedArray(type, buffer) {
    return new $2358b7e4ec07df88$var$TYPED_ARRAYS[type](buffer);
}
function $2358b7e4ec07df88$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $2358b7e4ec07df88$export$1033a2df66368859() {
    const canvas = $2358b7e4ec07df88$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $2358b7e4ec07df88$var$_cache = {};
let $2358b7e4ec07df88$var$_setConsoleFunction = null;
function $2358b7e4ec07df88$export$702823ffb42fb3aa(fn) {
    $2358b7e4ec07df88$var$_setConsoleFunction = fn;
}
function $2358b7e4ec07df88$export$fa86edd994bb169f() {
    return $2358b7e4ec07df88$var$_setConsoleFunction;
}
function $2358b7e4ec07df88$export$bef1f36f5486a6a3(...params) {
    const message = 'THREE.' + params.shift();
    if ($2358b7e4ec07df88$var$_setConsoleFunction) $2358b7e4ec07df88$var$_setConsoleFunction('log', message, ...params);
    else console.log(message, ...params);
}
function $2358b7e4ec07df88$export$c106dd0671a0fc2d(...params) {
    const message = 'THREE.' + params.shift();
    if ($2358b7e4ec07df88$var$_setConsoleFunction) $2358b7e4ec07df88$var$_setConsoleFunction('warn', message, ...params);
    else console.warn(message, ...params);
}
function $2358b7e4ec07df88$export$a3bc9b8ed74fc(...params) {
    const message = 'THREE.' + params.shift();
    if ($2358b7e4ec07df88$var$_setConsoleFunction) $2358b7e4ec07df88$var$_setConsoleFunction('error', message, ...params);
    else console.error(message, ...params);
}
function $2358b7e4ec07df88$export$5b28268982f175ba(...params) {
    const message = params.join(' ');
    if (message in $2358b7e4ec07df88$var$_cache) return;
    $2358b7e4ec07df88$var$_cache[message] = true;
    $2358b7e4ec07df88$export$c106dd0671a0fc2d(...params);
}
function $2358b7e4ec07df88$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js](https://github.com/mrdoob/eventdispatcher.js/)
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $2358b7e4ec07df88$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $2358b7e4ec07df88$var$_seed = 1234567;
const $2358b7e4ec07df88$var$DEG2RAD = Math.PI / 180;
const $2358b7e4ec07df88$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $2358b7e4ec07df88$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $2358b7e4ec07df88$var$_lut[d0 & 0xff] + $2358b7e4ec07df88$var$_lut[d0 >> 8 & 0xff] + $2358b7e4ec07df88$var$_lut[d0 >> 16 & 0xff] + $2358b7e4ec07df88$var$_lut[d0 >> 24 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d1 & 0xff] + $2358b7e4ec07df88$var$_lut[d1 >> 8 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d1 >> 16 & 0x0f | 0x40] + $2358b7e4ec07df88$var$_lut[d1 >> 24 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d2 & 0x3f | 0x80] + $2358b7e4ec07df88$var$_lut[d2 >> 8 & 0xff] + '-' + $2358b7e4ec07df88$var$_lut[d2 >> 16 & 0xff] + $2358b7e4ec07df88$var$_lut[d2 >> 24 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 >> 8 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 >> 16 & 0xff] + $2358b7e4ec07df88$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $2358b7e4ec07df88$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $2358b7e4ec07df88$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $2358b7e4ec07df88$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $2358b7e4ec07df88$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $2358b7e4ec07df88$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $2358b7e4ec07df88$var$damp(x, y, lambda, dt) {
    return $2358b7e4ec07df88$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $2358b7e4ec07df88$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($2358b7e4ec07df88$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $2358b7e4ec07df88$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $2358b7e4ec07df88$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $2358b7e4ec07df88$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $2358b7e4ec07df88$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $2358b7e4ec07df88$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $2358b7e4ec07df88$var$seededRandom(s) {
    if (s !== undefined) $2358b7e4ec07df88$var$_seed = s;
    // Mulberry32 generator
    let t = $2358b7e4ec07df88$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $2358b7e4ec07df88$var$degToRad(degrees) {
    return degrees * $2358b7e4ec07df88$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $2358b7e4ec07df88$var$radToDeg(radians) {
    return radians * $2358b7e4ec07df88$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $2358b7e4ec07df88$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $2358b7e4ec07df88$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $2358b7e4ec07df88$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $2358b7e4ec07df88$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $2358b7e4ec07df88$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $2358b7e4ec07df88$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const $2358b7e4ec07df88$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $2358b7e4ec07df88$var$DEG2RAD,
    RAD2DEG: $2358b7e4ec07df88$export$914076c8150813e5,
    /**
	 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $2358b7e4ec07df88$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $2358b7e4ec07df88$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $2358b7e4ec07df88$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $2358b7e4ec07df88$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $2358b7e4ec07df88$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $2358b7e4ec07df88$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $2358b7e4ec07df88$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $2358b7e4ec07df88$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $2358b7e4ec07df88$var$smoothstep,
    /**
	 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $2358b7e4ec07df88$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $2358b7e4ec07df88$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $2358b7e4ec07df88$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $2358b7e4ec07df88$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $2358b7e4ec07df88$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $2358b7e4ec07df88$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $2358b7e4ec07df88$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $2358b7e4ec07df88$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $2358b7e4ec07df88$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $2358b7e4ec07df88$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $2358b7e4ec07df88$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $2358b7e4ec07df88$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $2358b7e4ec07df88$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $2358b7e4ec07df88$export$c977b3e384af9ae1 {
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$c977b3e384af9ae1.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $2358b7e4ec07df88$var$clamp(this.x, min.x, max.x);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $2358b7e4ec07df88$var$clamp(this.x, minVal, maxVal);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($2358b7e4ec07df88$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($2358b7e4ec07df88$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $2358b7e4ec07df88$export$23d6a54f0bbc85a3 {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        let x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t <= 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t >= 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let dot = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1;
            if (dot < 0) {
                x1 = -x1;
                y1 = -y1;
                z1 = -z1;
                w1 = -w1;
                dot = -dot;
            }
            let s = 1 - t;
            if (dot < 0.9995) {
                // slerp
                const theta = Math.acos(dot);
                const sin = Math.sin(theta);
                s = Math.sin(s * theta) / sin;
                t = Math.sin(t * theta) / sin;
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
            } else {
                // for small angles, lerp then normalize
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                $2358b7e4ec07df88$export$c106dd0671a0fc2d('Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($2358b7e4ec07df88$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        if (t <= 0) return this;
        if (t >= 1) return this.copy(qb); // copy calls _onChangeCallback()
        let x = qb._x, y = qb._y, z = qb._z, w = qb._w;
        let dot = this.dot(qb);
        if (dot < 0) {
            x = -x;
            y = -y;
            z = -z;
            w = -w;
            dot = -dot;
        }
        let s = 1 - t;
        if (dot < 0.9995) {
            // slerp
            const theta = Math.acos(dot);
            const sin = Math.sin(theta);
            s = Math.sin(s * theta) / sin;
            t = Math.sin(t * theta) / sin;
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this._onChangeCallback();
        } else {
            // for small angles, lerp then normalize
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this.normalize(); // normalize calls _onChangeCallback()
        }
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $2358b7e4ec07df88$export$64b5c384219d3699 {
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$64b5c384219d3699.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($2358b7e4ec07df88$var$_quaternion$4.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($2358b7e4ec07df88$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $2358b7e4ec07df88$var$clamp(this.x, min.x, max.x);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, min.y, max.y);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $2358b7e4ec07df88$var$clamp(this.x, minVal, maxVal);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, minVal, maxVal);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($2358b7e4ec07df88$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $2358b7e4ec07df88$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($2358b7e4ec07df88$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($2358b7e4ec07df88$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($2358b7e4ec07df88$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $2358b7e4ec07df88$var$_vector$c = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $2358b7e4ec07df88$export$8ff26dafa08918 {
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$8ff26dafa08918.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($2358b7e4ec07df88$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($2358b7e4ec07df88$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($2358b7e4ec07df88$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $2358b7e4ec07df88$var$_m3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918();
const $2358b7e4ec07df88$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $2358b7e4ec07df88$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $2358b7e4ec07df88$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $2358b7e4ec07df88$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $2358b7e4ec07df88$export$8d0a61916cc26abb) {
                color.r = $2358b7e4ec07df88$var$SRGBToLinear(color.r);
                color.g = $2358b7e4ec07df88$var$SRGBToLinear(color.g);
                color.b = $2358b7e4ec07df88$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $2358b7e4ec07df88$export$8d0a61916cc26abb) {
                color.r = $2358b7e4ec07df88$var$LinearToSRGB(color.r);
                color.g = $2358b7e4ec07df88$var$LinearToSRGB(color.g);
                color.b = $2358b7e4ec07df88$var$LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $2358b7e4ec07df88$export$bfcb490c2dd3db51) return $2358b7e4ec07df88$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getToneMappingMode: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.toneMappingMode || 'standard';
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(color, targetColorSpace) {
            $2358b7e4ec07df88$export$5b28268982f175ba('ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            $2358b7e4ec07df88$export$5b28268982f175ba('ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$2358b7e4ec07df88$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $2358b7e4ec07df88$export$f197347d588c1b4a,
            toXYZ: $2358b7e4ec07df88$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $2358b7e4ec07df88$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $2358b7e4ec07df88$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $2358b7e4ec07df88$export$561f394b24edfcaa
            }
        },
        [$2358b7e4ec07df88$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $2358b7e4ec07df88$export$8d0a61916cc26abb,
            toXYZ: $2358b7e4ec07df88$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $2358b7e4ec07df88$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $2358b7e4ec07df88$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $2358b7e4ec07df88$export$5e6fd513f44698c = /*@__PURE__*/ $2358b7e4ec07df88$var$createColorManagement();
function $2358b7e4ec07df88$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $2358b7e4ec07df88$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $2358b7e4ec07df88$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($2358b7e4ec07df88$var$_canvas === undefined) $2358b7e4ec07df88$var$_canvas = $2358b7e4ec07df88$export$7094a064528c7fee('canvas');
            $2358b7e4ec07df88$var$_canvas.width = image.width;
            $2358b7e4ec07df88$var$_canvas.height = image.height;
            const context = $2358b7e4ec07df88$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $2358b7e4ec07df88$var$_canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $2358b7e4ec07df88$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $2358b7e4ec07df88$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($2358b7e4ec07df88$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $2358b7e4ec07df88$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $2358b7e4ec07df88$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class $2358b7e4ec07df88$export$1d2df86270c81ecb {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Returns the dimensions of the source into the given target vector.
	 *
	 * @param {(Vector2|Vector3)} target - The target object the result is written into.
	 * @return {(Vector2|Vector3)} The dimensions of the source.
	 */ getSize(target) {
        const data = this.data;
        if (typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight, 0);
        else if (data instanceof VideoFrame) target.set(data.displayHeight, data.displayWidth, 0);
        else if (data !== null) target.set(data.width, data.height, data.depth || 0);
        else target.set(0, 0, 0);
        return target;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($2358b7e4ec07df88$var$serializeImage(data[i].image));
                else url.push($2358b7e4ec07df88$var$serializeImage(data[i]));
            } else // texture
            url = $2358b7e4ec07df88$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $2358b7e4ec07df88$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $2358b7e4ec07df88$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $2358b7e4ec07df88$var$_textureId = 0;
const $2358b7e4ec07df88$var$_tempVec3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$5431306cf43de24a extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $2358b7e4ec07df88$export$9d9334239a5a5e06, wrapT = $2358b7e4ec07df88$export$9d9334239a5a5e06, magFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8, minFilter = $2358b7e4ec07df88$export$5d8599b6a933fb1b, format = $2358b7e4ec07df88$export$3f8bb04b555a363c, type = $2358b7e4ec07df88$export$2e8ce08d3f6f5e10, anisotropy = $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $2358b7e4ec07df88$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $2358b7e4ec07df88$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default 0
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $2358b7e4ec07df88$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
    /**
	 * The width of the texture in pixels.
	 */ get width() {
        return this.source.getSize($2358b7e4ec07df88$var$_tempVec3).x;
    }
    /**
	 * The height of the texture in pixels.
	 */ get height() {
        return this.source.getSize($2358b7e4ec07df88$var$_tempVec3).y;
    }
    /**
	 * The depth of the texture in pixels.
	 */ get depth() {
        return this.source.getSize($2358b7e4ec07df88$var$_tempVec3).z;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ setValues(values) {
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Texture.setValues(): parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Texture.setValues(): property '${key}' does not exist.`);
                continue;
            }
            if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.7,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $2358b7e4ec07df88$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $2358b7e4ec07df88$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $2358b7e4ec07df88$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $2358b7e4ec07df88$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $2358b7e4ec07df88$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $2358b7e4ec07df88$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $2358b7e4ec07df88$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_MAPPING = $2358b7e4ec07df88$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $2358b7e4ec07df88$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $2358b7e4ec07df88$export$fa7daccca11cdbe3 {
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $2358b7e4ec07df88$var$clamp(this.x, min.x, max.x);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, min.y, max.y);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, min.z, max.z);
        this.w = $2358b7e4ec07df88$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $2358b7e4ec07df88$var$clamp(this.x, minVal, maxVal);
        this.y = $2358b7e4ec07df88$var$clamp(this.y, minVal, maxVal);
        this.z = $2358b7e4ec07df88$var$clamp(this.z, minVal, maxVal);
        this.w = $2358b7e4ec07df88$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($2358b7e4ec07df88$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$efcb1f8bf367cbfb extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 * @property {number} [depth=1] - The texture depth.
	 * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $2358b7e4ec07df88$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: options.depth
        };
        const texture = new $2358b7e4ec07df88$export$5431306cf43de24a(image);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.multiview = options.multiview;
    }
    _setTextureOptions(options = {}) {
        const values = {
            minFilter: $2358b7e4ec07df88$export$8a72f490b25c56c8,
            generateMipmaps: false,
            flipY: false,
            internalFormat: null
        };
        if (options.mapping !== undefined) values.mapping = options.mapping;
        if (options.wrapS !== undefined) values.wrapS = options.wrapS;
        if (options.wrapT !== undefined) values.wrapT = options.wrapT;
        if (options.wrapR !== undefined) values.wrapR = options.wrapR;
        if (options.magFilter !== undefined) values.magFilter = options.magFilter;
        if (options.minFilter !== undefined) values.minFilter = options.minFilter;
        if (options.format !== undefined) values.format = options.format;
        if (options.type !== undefined) values.type = options.type;
        if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
        if (options.flipY !== undefined) values.flipY = options.flipY;
        if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
        for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            texture.setValues(values);
        }
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
                if (this.textures[i].isData3DTexture !== true) // TODO: Reconsider setting isArrayTexture flag here and in the ctor of Texture.
                // Maybe a method `isArrayTexture()` or just a getter could replace a flag since
                // both are evaluated on each call?
                this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $2358b7e4ec07df88$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class $2358b7e4ec07df88$export$3c052beb2e51e23f extends $2358b7e4ec07df88$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$dfac6c8e811406a3 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $2358b7e4ec07df88$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $2358b7e4ec07df88$export$c77a02c11ed180c7 extends $2358b7e4ec07df88$export$3c052beb2e51e23f {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$dfac6c8e811406a3(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$d7a3086320f856db extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $2358b7e4ec07df88$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $2358b7e4ec07df88$export$7ee06591009639df extends $2358b7e4ec07df88$export$3c052beb2e51e23f {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $2358b7e4ec07df88$export$6f7d5a9418ab2aa3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $2358b7e4ec07df88$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $2358b7e4ec07df88$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($2358b7e4ec07df88$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($2358b7e4ec07df88$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $2358b7e4ec07df88$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $2358b7e4ec07df88$var$_vector$b);
                else $2358b7e4ec07df88$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $2358b7e4ec07df88$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($2358b7e4ec07df88$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $2358b7e4ec07df88$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $2358b7e4ec07df88$var$_box$4.copy(geometry.boundingBox);
                }
                $2358b7e4ec07df88$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($2358b7e4ec07df88$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $2358b7e4ec07df88$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $2358b7e4ec07df88$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($2358b7e4ec07df88$var$_center);
        $2358b7e4ec07df88$var$_extents.subVectors(this.max, $2358b7e4ec07df88$var$_center);
        // translate triangle to aabb origin
        $2358b7e4ec07df88$var$_v0$2.subVectors(triangle.a, $2358b7e4ec07df88$var$_center);
        $2358b7e4ec07df88$var$_v1$7.subVectors(triangle.b, $2358b7e4ec07df88$var$_center);
        $2358b7e4ec07df88$var$_v2$4.subVectors(triangle.c, $2358b7e4ec07df88$var$_center);
        // compute edge vectors for triangle
        $2358b7e4ec07df88$var$_f0.subVectors($2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v0$2);
        $2358b7e4ec07df88$var$_f1.subVectors($2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_v1$7);
        $2358b7e4ec07df88$var$_f2.subVectors($2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$2358b7e4ec07df88$var$_f0.z,
            $2358b7e4ec07df88$var$_f0.y,
            0,
            -$2358b7e4ec07df88$var$_f1.z,
            $2358b7e4ec07df88$var$_f1.y,
            0,
            -$2358b7e4ec07df88$var$_f2.z,
            $2358b7e4ec07df88$var$_f2.y,
            $2358b7e4ec07df88$var$_f0.z,
            0,
            -$2358b7e4ec07df88$var$_f0.x,
            $2358b7e4ec07df88$var$_f1.z,
            0,
            -$2358b7e4ec07df88$var$_f1.x,
            $2358b7e4ec07df88$var$_f2.z,
            0,
            -$2358b7e4ec07df88$var$_f2.x,
            -$2358b7e4ec07df88$var$_f0.y,
            $2358b7e4ec07df88$var$_f0.x,
            0,
            -$2358b7e4ec07df88$var$_f1.y,
            $2358b7e4ec07df88$var$_f1.x,
            0,
            -$2358b7e4ec07df88$var$_f2.y,
            $2358b7e4ec07df88$var$_f2.x,
            0
        ];
        if (!$2358b7e4ec07df88$var$satForAxes(axes, $2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$2358b7e4ec07df88$var$satForAxes(axes, $2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $2358b7e4ec07df88$var$_triangleNormal.crossVectors($2358b7e4ec07df88$var$_f0, $2358b7e4ec07df88$var$_f1);
        axes = [
            $2358b7e4ec07df88$var$_triangleNormal.x,
            $2358b7e4ec07df88$var$_triangleNormal.y,
            $2358b7e4ec07df88$var$_triangleNormal.z
        ];
        return $2358b7e4ec07df88$var$satForAxes(axes, $2358b7e4ec07df88$var$_v0$2, $2358b7e4ec07df88$var$_v1$7, $2358b7e4ec07df88$var$_v2$4, $2358b7e4ec07df88$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $2358b7e4ec07df88$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($2358b7e4ec07df88$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $2358b7e4ec07df88$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $2358b7e4ec07df88$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $2358b7e4ec07df88$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $2358b7e4ec07df88$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $2358b7e4ec07df88$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $2358b7e4ec07df88$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $2358b7e4ec07df88$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $2358b7e4ec07df88$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($2358b7e4ec07df88$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
    }
}
const $2358b7e4ec07df88$var$_points = [
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(),
    /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699()
];
const $2358b7e4ec07df88$var$_vector$b = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_box$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $2358b7e4ec07df88$var$_v0$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v1$7 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
// triangle edge vectors
const $2358b7e4ec07df88$var$_f0 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_f1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_f2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_center = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_extents = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_triangleNormal = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_testAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
function $2358b7e4ec07df88$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $2358b7e4ec07df88$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($2358b7e4ec07df88$var$_testAxis.x) + extents.y * Math.abs($2358b7e4ec07df88$var$_testAxis.y) + extents.z * Math.abs($2358b7e4ec07df88$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($2358b7e4ec07df88$var$_testAxis);
        const p1 = v1.dot($2358b7e4ec07df88$var$_testAxis);
        const p2 = v2.dot($2358b7e4ec07df88$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $2358b7e4ec07df88$var$_box$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_v1$6 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $2358b7e4ec07df88$export$805e8b72413ccaba {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $2358b7e4ec07df88$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $2358b7e4ec07df88$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $2358b7e4ec07df88$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $2358b7e4ec07df88$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($2358b7e4ec07df88$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $2358b7e4ec07df88$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($2358b7e4ec07df88$var$_v1$6.copy(sphere.center).add($2358b7e4ec07df88$var$_v2$3));
            this.expandByPoint($2358b7e4ec07df88$var$_v1$6.copy(sphere.center).sub($2358b7e4ec07df88$var$_v2$3));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Box3} A reference to this bounding sphere.
	 */ fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
    }
}
const $2358b7e4ec07df88$var$_vector$a = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_segCenter = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_segDir = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_diff = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_edge1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_edge2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_normal$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $2358b7e4ec07df88$export$a186db52eed6d40e {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $2358b7e4ec07df88$export$64b5c384219d3699(), direction = new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $2358b7e4ec07df88$var$_vector$a));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $2358b7e4ec07df88$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $2358b7e4ec07df88$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $2358b7e4ec07df88$var$_vector$a.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $2358b7e4ec07df88$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $2358b7e4ec07df88$var$_segDir.copy(v1).sub(v0).normalize();
        $2358b7e4ec07df88$var$_diff.copy(this.origin).sub($2358b7e4ec07df88$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($2358b7e4ec07df88$var$_segDir);
        const b0 = $2358b7e4ec07df88$var$_diff.dot(this.direction);
        const b1 = -$2358b7e4ec07df88$var$_diff.dot($2358b7e4ec07df88$var$_segDir);
        const c = $2358b7e4ec07df88$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($2358b7e4ec07df88$var$_segCenter).addScaledVector($2358b7e4ec07df88$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $2358b7e4ec07df88$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $2358b7e4ec07df88$var$_vector$a.dot(this.direction);
        const d2 = $2358b7e4ec07df88$var$_vector$a.dot($2358b7e4ec07df88$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        if (sphere.radius < 0) return false; // handle empty spheres, see #31187
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $2358b7e4ec07df88$var$_vector$a) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $2358b7e4ec07df88$var$_edge1.subVectors(b, a);
        $2358b7e4ec07df88$var$_edge2.subVectors(c, a);
        $2358b7e4ec07df88$var$_normal$1.crossVectors($2358b7e4ec07df88$var$_edge1, $2358b7e4ec07df88$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($2358b7e4ec07df88$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $2358b7e4ec07df88$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($2358b7e4ec07df88$var$_edge2.crossVectors($2358b7e4ec07df88$var$_diff, $2358b7e4ec07df88$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($2358b7e4ec07df88$var$_edge1.cross($2358b7e4ec07df88$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $2358b7e4ec07df88$var$_diff.dot($2358b7e4ec07df88$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial](https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices)
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $2358b7e4ec07df88$export$2ae72fc923e5eb5 {
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $2358b7e4ec07df88$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $2358b7e4ec07df88$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $2358b7e4ec07df88$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($2358b7e4ec07df88$var$_zero, q, $2358b7e4ec07df88$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $2358b7e4ec07df88$var$_z.subVectors(eye, target);
        if ($2358b7e4ec07df88$var$_z.lengthSq() === 0) // eye and target are in the same position
        $2358b7e4ec07df88$var$_z.z = 1;
        $2358b7e4ec07df88$var$_z.normalize();
        $2358b7e4ec07df88$var$_x.crossVectors(up, $2358b7e4ec07df88$var$_z);
        if ($2358b7e4ec07df88$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $2358b7e4ec07df88$var$_z.x += 0.0001;
            else $2358b7e4ec07df88$var$_z.z += 0.0001;
            $2358b7e4ec07df88$var$_z.normalize();
            $2358b7e4ec07df88$var$_x.crossVectors(up, $2358b7e4ec07df88$var$_z);
        }
        $2358b7e4ec07df88$var$_x.normalize();
        $2358b7e4ec07df88$var$_y.crossVectors($2358b7e4ec07df88$var$_z, $2358b7e4ec07df88$var$_x);
        te[0] = $2358b7e4ec07df88$var$_x.x;
        te[4] = $2358b7e4ec07df88$var$_y.x;
        te[8] = $2358b7e4ec07df88$var$_z.x;
        te[1] = $2358b7e4ec07df88$var$_x.y;
        te[5] = $2358b7e4ec07df88$var$_y.y;
        te[9] = $2358b7e4ec07df88$var$_z.y;
        te[2] = $2358b7e4ec07df88$var$_x.z;
        te[6] = $2358b7e4ec07df88$var$_y.z;
        te[10] = $2358b7e4ec07df88$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $2358b7e4ec07df88$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $2358b7e4ec07df88$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $2358b7e4ec07df88$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $2358b7e4ec07df88$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $2358b7e4ec07df88$var$_m1$2.elements[0] *= invSX;
        $2358b7e4ec07df88$var$_m1$2.elements[1] *= invSX;
        $2358b7e4ec07df88$var$_m1$2.elements[2] *= invSX;
        $2358b7e4ec07df88$var$_m1$2.elements[4] *= invSY;
        $2358b7e4ec07df88$var$_m1$2.elements[5] *= invSY;
        $2358b7e4ec07df88$var$_m1$2.elements[6] *= invSY;
        $2358b7e4ec07df88$var$_m1$2.elements[8] *= invSZ;
        $2358b7e4ec07df88$var$_m1$2.elements[9] *= invSZ;
        $2358b7e4ec07df88$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($2358b7e4ec07df88$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = near / (far - near);
            d = far * near / (far - near);
        } else {
            if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
                c = -(far + near) / (far - near);
                d = -2 * far * near / (far - near);
            } else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
                c = -far / (far - near);
                d = -far * near / (far - near);
            } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 / (right - left);
        const y = 2 / (top - bottom);
        const a = -(right + left) / (right - left);
        const b = -(top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = 1 / (far - near);
            d = far / (far - near);
        } else {
            if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
                c = -2 / (far - near);
                d = -(far + near) / (far - near);
            } else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
                c = -1 / (far - near);
                d = -near / (far - near);
            } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = 0;
        te[12] = a;
        te[1] = 0;
        te[5] = y;
        te[9] = 0;
        te[13] = b;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $2358b7e4ec07df88$var$_v1$5 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_m1$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_zero = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 0);
const $2358b7e4ec07df88$var$_one = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(1, 1, 1);
const $2358b7e4ec07df88$var$_x = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_y = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_z = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_matrix$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_quaternion$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $2358b7e4ec07df88$export$d93cc409a0768c5f {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $2358b7e4ec07df88$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($2358b7e4ec07df88$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$2358b7e4ec07df88$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($2358b7e4ec07df88$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$2358b7e4ec07df88$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($2358b7e4ec07df88$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$2358b7e4ec07df88$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                $2358b7e4ec07df88$export$c106dd0671a0fc2d('Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $2358b7e4ec07df88$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($2358b7e4ec07df88$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $2358b7e4ec07df88$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($2358b7e4ec07df88$var$_quaternion$3, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $2358b7e4ec07df88$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class $2358b7e4ec07df88$export$89312ce47c0ca777 {
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
}
let $2358b7e4ec07df88$var$_object3DId = 0;
const $2358b7e4ec07df88$var$_v1$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_q1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_m1$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_target = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_position$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_scale$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_xAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(1, 0, 0);
const $2358b7e4ec07df88$var$_yAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0);
const $2358b7e4ec07df88$var$_zAxis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $2358b7e4ec07df88$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$e4dd07dff30cc924 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const rotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        const quaternion = new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
        const scale = new $2358b7e4ec07df88$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $2358b7e4ec07df88$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $2358b7e4ec07df88$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $2358b7e4ec07df88$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $2358b7e4ec07df88$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($2358b7e4ec07df88$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $2358b7e4ec07df88$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($2358b7e4ec07df88$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($2358b7e4ec07df88$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($2358b7e4ec07df88$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($2358b7e4ec07df88$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $2358b7e4ec07df88$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($2358b7e4ec07df88$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($2358b7e4ec07df88$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($2358b7e4ec07df88$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($2358b7e4ec07df88$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($2358b7e4ec07df88$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $2358b7e4ec07df88$var$_target.copy(x);
        else $2358b7e4ec07df88$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $2358b7e4ec07df88$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $2358b7e4ec07df88$var$_m1$1.lookAt($2358b7e4ec07df88$var$_position$3, $2358b7e4ec07df88$var$_target, this.up);
        else $2358b7e4ec07df88$var$_m1$1.lookAt($2358b7e4ec07df88$var$_target, $2358b7e4ec07df88$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($2358b7e4ec07df88$var$_m1$1);
        if (parent) {
            $2358b7e4ec07df88$var$_m1$1.extractRotation(parent.matrixWorld);
            $2358b7e4ec07df88$var$_q1.setFromRotationMatrix($2358b7e4ec07df88$var$_m1$1);
            this.quaternion.premultiply($2358b7e4ec07df88$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($2358b7e4ec07df88$var$_addedEvent);
            $2358b7e4ec07df88$var$_childaddedEvent.child = object;
            this.dispatchEvent($2358b7e4ec07df88$var$_childaddedEvent);
            $2358b7e4ec07df88$var$_childaddedEvent.child = null;
        } else $2358b7e4ec07df88$export$a3bc9b8ed74fc('Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($2358b7e4ec07df88$var$_removedEvent);
            $2358b7e4ec07df88$var$_childremovedEvent.child = object;
            this.dispatchEvent($2358b7e4ec07df88$var$_childremovedEvent);
            $2358b7e4ec07df88$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $2358b7e4ec07df88$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $2358b7e4ec07df88$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($2358b7e4ec07df88$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($2358b7e4ec07df88$var$_addedEvent);
        $2358b7e4ec07df88$var$_childaddedEvent.child = object;
        this.dispatchEvent($2358b7e4ec07df88$var$_childaddedEvent);
        $2358b7e4ec07df88$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position$3, target, $2358b7e4ec07df88$var$_scale$2);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position$3, $2358b7e4ec07df88$var$_quaternion$2, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.7,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.geometryInfo = this._geometryInfo.map((info)=>({
                    ...info,
                    boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                    boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                }));
            object.instanceInfo = this._instanceInfo.map((info)=>({
                    ...info
                }));
            object.availableInstanceIds = this._availableInstanceIds.slice();
            object.availableGeometryIds = this._availableGeometryIds.slice();
            object.nextIndexStart = this._nextIndexStart;
            object.nextVertexStart = this._nextVertexStart;
            object.geometryCount = this._geometryCount;
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            object.indirectTexture = this._indirectTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
            if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $2358b7e4ec07df88$var$_v0$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v1$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v3$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vab = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vac = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vbc = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vap = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vbp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vcp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v40 = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_v41 = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_v42 = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $2358b7e4ec07df88$export$5a465592bfe74b48 {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $2358b7e4ec07df88$export$64b5c384219d3699(), b = new $2358b7e4ec07df88$export$64b5c384219d3699(), c = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $2358b7e4ec07df88$var$_v0$1.subVectors(a, b);
        target.cross($2358b7e4ec07df88$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $2358b7e4ec07df88$var$_v0$1.subVectors(c, a);
        $2358b7e4ec07df88$var$_v1$3.subVectors(b, a);
        $2358b7e4ec07df88$var$_v2$2.subVectors(point, a);
        const dot00 = $2358b7e4ec07df88$var$_v0$1.dot($2358b7e4ec07df88$var$_v0$1);
        const dot01 = $2358b7e4ec07df88$var$_v0$1.dot($2358b7e4ec07df88$var$_v1$3);
        const dot02 = $2358b7e4ec07df88$var$_v0$1.dot($2358b7e4ec07df88$var$_v2$2);
        const dot11 = $2358b7e4ec07df88$var$_v1$3.dot($2358b7e4ec07df88$var$_v1$3);
        const dot12 = $2358b7e4ec07df88$var$_v1$3.dot($2358b7e4ec07df88$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $2358b7e4ec07df88$var$_v3$2) === null) return false;
        return $2358b7e4ec07df88$var$_v3$2.x >= 0 && $2358b7e4ec07df88$var$_v3$2.y >= 0 && $2358b7e4ec07df88$var$_v3$2.x + $2358b7e4ec07df88$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $2358b7e4ec07df88$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $2358b7e4ec07df88$var$_v3$2.x);
        target.addScaledVector(v2, $2358b7e4ec07df88$var$_v3$2.y);
        target.addScaledVector(v3, $2358b7e4ec07df88$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $2358b7e4ec07df88$var$_v40.setScalar(0);
        $2358b7e4ec07df88$var$_v41.setScalar(0);
        $2358b7e4ec07df88$var$_v42.setScalar(0);
        $2358b7e4ec07df88$var$_v40.fromBufferAttribute(attr, i1);
        $2358b7e4ec07df88$var$_v41.fromBufferAttribute(attr, i2);
        $2358b7e4ec07df88$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($2358b7e4ec07df88$var$_v40, barycoord.x);
        target.addScaledVector($2358b7e4ec07df88$var$_v41, barycoord.y);
        target.addScaledVector($2358b7e4ec07df88$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $2358b7e4ec07df88$var$_v0$1.subVectors(c, b);
        $2358b7e4ec07df88$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $2358b7e4ec07df88$var$_v0$1.cross($2358b7e4ec07df88$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $2358b7e4ec07df88$var$_v0$1.subVectors(this.c, this.b);
        $2358b7e4ec07df88$var$_v1$3.subVectors(this.a, this.b);
        return $2358b7e4ec07df88$var$_v0$1.cross($2358b7e4ec07df88$var$_v1$3).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $2358b7e4ec07df88$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $2358b7e4ec07df88$var$_vab.subVectors(b, a);
        $2358b7e4ec07df88$var$_vac.subVectors(c, a);
        $2358b7e4ec07df88$var$_vap.subVectors(p, a);
        const d1 = $2358b7e4ec07df88$var$_vab.dot($2358b7e4ec07df88$var$_vap);
        const d2 = $2358b7e4ec07df88$var$_vac.dot($2358b7e4ec07df88$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $2358b7e4ec07df88$var$_vbp.subVectors(p, b);
        const d3 = $2358b7e4ec07df88$var$_vab.dot($2358b7e4ec07df88$var$_vbp);
        const d4 = $2358b7e4ec07df88$var$_vac.dot($2358b7e4ec07df88$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($2358b7e4ec07df88$var$_vab, v);
        }
        $2358b7e4ec07df88$var$_vcp.subVectors(p, c);
        const d5 = $2358b7e4ec07df88$var$_vab.dot($2358b7e4ec07df88$var$_vcp);
        const d6 = $2358b7e4ec07df88$var$_vac.dot($2358b7e4ec07df88$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($2358b7e4ec07df88$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $2358b7e4ec07df88$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($2358b7e4ec07df88$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($2358b7e4ec07df88$var$_vab, v).addScaledVector($2358b7e4ec07df88$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $2358b7e4ec07df88$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $2358b7e4ec07df88$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $2358b7e4ec07df88$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $2358b7e4ec07df88$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $2358b7e4ec07df88$export$892596cec99bc70e {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $2358b7e4ec07df88$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $2358b7e4ec07df88$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $2358b7e4ec07df88$var$euclideanModulo(h, 1);
        s = $2358b7e4ec07df88$var$clamp(s, 0, 1);
        l = $2358b7e4ec07df88$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $2358b7e4ec07df88$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $2358b7e4ec07df88$var$hue2rgb(q, p, h);
            this.b = $2358b7e4ec07df88$var$hue2rgb(q, p, h - 1 / 3);
        }
        $2358b7e4ec07df88$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        // color keywords
        const hex = $2358b7e4ec07df88$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        $2358b7e4ec07df88$export$c106dd0671a0fc2d('Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $2358b7e4ec07df88$var$SRGBToLinear(color.r);
        this.g = $2358b7e4ec07df88$var$SRGBToLinear(color.g);
        this.b = $2358b7e4ec07df88$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $2358b7e4ec07df88$var$LinearToSRGB(color.r);
        this.g = $2358b7e4ec07df88$var$LinearToSRGB(color.g);
        this.b = $2358b7e4ec07df88$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        return Math.round($2358b7e4ec07df88$var$clamp($2358b7e4ec07df88$var$_color.r * 255, 0, 255)) * 65536 + Math.round($2358b7e4ec07df88$var$clamp($2358b7e4ec07df88$var$_color.g * 255, 0, 255)) * 256 + Math.round($2358b7e4ec07df88$var$clamp($2358b7e4ec07df88$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        const r = $2358b7e4ec07df88$var$_color.r, g = $2358b7e4ec07df88$var$_color.g, b = $2358b7e4ec07df88$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace) {
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        target.r = $2358b7e4ec07df88$var$_color.r;
        target.g = $2358b7e4ec07df88$var$_color.g;
        target.b = $2358b7e4ec07df88$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa) {
        $2358b7e4ec07df88$export$5e6fd513f44698c.workingToColorSpace($2358b7e4ec07df88$var$_color.copy(this), colorSpace);
        const r = $2358b7e4ec07df88$var$_color.r, g = $2358b7e4ec07df88$var$_color.g, b = $2358b7e4ec07df88$var$_color.b;
        if (colorSpace !== $2358b7e4ec07df88$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($2358b7e4ec07df88$var$_hslA);
        return this.setHSL($2358b7e4ec07df88$var$_hslA.h + h, $2358b7e4ec07df88$var$_hslA.s + s, $2358b7e4ec07df88$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($2358b7e4ec07df88$var$_hslA);
        color.getHSL($2358b7e4ec07df88$var$_hslB);
        const h = $2358b7e4ec07df88$var$lerp($2358b7e4ec07df88$var$_hslA.h, $2358b7e4ec07df88$var$_hslB.h, alpha);
        const s = $2358b7e4ec07df88$var$lerp($2358b7e4ec07df88$var$_hslA.s, $2358b7e4ec07df88$var$_hslB.s, alpha);
        const l = $2358b7e4ec07df88$var$lerp($2358b7e4ec07df88$var$_hslA.l, $2358b7e4ec07df88$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $2358b7e4ec07df88$var$_color = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $2358b7e4ec07df88$export$892596cec99bc70e.NAMES = $2358b7e4ec07df88$var$_colorKeywords;
let $2358b7e4ec07df88$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$a2d8b23205c25948 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $2358b7e4ec07df88$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $2358b7e4ec07df88$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $2358b7e4ec07df88$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $2358b7e4ec07df88$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = $2358b7e4ec07df88$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $2358b7e4ec07df88$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $2358b7e4ec07df88$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $2358b7e4ec07df88$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $2358b7e4ec07df88$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $2358b7e4ec07df88$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $2358b7e4ec07df88$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d(`Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.7,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.sheenColorMap && this.sheenColorMap.isTexture) data.sheenColorMap = this.sheenColorMap.toJSON(meta).uuid;
        if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) data.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(meta).uuid;
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $2358b7e4ec07df88$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $2358b7e4ec07df88$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $2358b7e4ec07df88$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $2358b7e4ec07df88$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $2358b7e4ec07df88$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $2358b7e4ec07df88$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $2358b7e4ec07df88$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $2358b7e4ec07df88$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $2358b7e4ec07df88$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $2358b7e4ec07df88$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshBasicMaterial
 */ class $2358b7e4ec07df88$export$55cbcc9b622fe1f5 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $2358b7e4ec07df88$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $2358b7e4ec07df88$var$_tables = /*@__PURE__*/ $2358b7e4ec07df88$var$_generateTables();
function $2358b7e4ec07df88$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $2358b7e4ec07df88$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) $2358b7e4ec07df88$export$c106dd0671a0fc2d('DataUtils.toHalfFloat(): Value out of range.');
    val = $2358b7e4ec07df88$var$clamp(val, -65504, 65504);
    $2358b7e4ec07df88$var$_tables.floatView[0] = val;
    const f = $2358b7e4ec07df88$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $2358b7e4ec07df88$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $2358b7e4ec07df88$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $2358b7e4ec07df88$var$fromHalfFloat(val) {
    const m = val >> 10;
    $2358b7e4ec07df88$var$_tables.uint32View[0] = $2358b7e4ec07df88$var$_tables.mantissaTable[$2358b7e4ec07df88$var$_tables.offsetTable[m] + (val & 0x3ff)] + $2358b7e4ec07df88$var$_tables.exponentTable[m];
    return $2358b7e4ec07df88$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $2358b7e4ec07df88$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $2358b7e4ec07df88$var$fromHalfFloat(val);
    }
}
const $2358b7e4ec07df88$var$_vector$9 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vector2$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
let $2358b7e4ec07df88$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $2358b7e4ec07df88$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $2358b7e4ec07df88$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector2$1.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $2358b7e4ec07df88$var$_vector2$1.x, $2358b7e4ec07df88$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$9.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$9.x, $2358b7e4ec07df88$var$_vector$9.y, $2358b7e4ec07df88$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $2358b7e4ec07df88$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $2358b7e4ec07df88$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $2358b7e4ec07df88$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $2358b7e4ec07df88$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $2358b7e4ec07df88$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $2358b7e4ec07df88$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $2358b7e4ec07df88$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $2358b7e4ec07df88$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $2358b7e4ec07df88$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $2358b7e4ec07df88$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
            w = $2358b7e4ec07df88$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $2358b7e4ec07df88$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$f9ff2d6a20248cbf extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$cacc90cf35d11cdd extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$baaa85a1a812c157 extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$2b755a102ccdcefe extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$640a853f68025f2e extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$46b369aed2968a0a extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$7eb8c9fa25cd5bd6 extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$dbd3698c64958d69 extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $2358b7e4ec07df88$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $2358b7e4ec07df88$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $2358b7e4ec07df88$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $2358b7e4ec07df88$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $2358b7e4ec07df88$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $2358b7e4ec07df88$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $2358b7e4ec07df88$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $2358b7e4ec07df88$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $2358b7e4ec07df88$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $2358b7e4ec07df88$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $2358b7e4ec07df88$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $2358b7e4ec07df88$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
        }
        this.array[index + 0] = $2358b7e4ec07df88$var$toHalfFloat(x);
        this.array[index + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
        }
        this.array[index + 0] = $2358b7e4ec07df88$var$toHalfFloat(x);
        this.array[index + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        this.array[index + 2] = $2358b7e4ec07df88$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
            w = $2358b7e4ec07df88$var$normalize(w, this.array);
        }
        this.array[index + 0] = $2358b7e4ec07df88$var$toHalfFloat(x);
        this.array[index + 1] = $2358b7e4ec07df88$var$toHalfFloat(y);
        this.array[index + 2] = $2358b7e4ec07df88$var$toHalfFloat(z);
        this.array[index + 3] = $2358b7e4ec07df88$var$toHalfFloat(w);
        return this;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$cbe7a62641830ebd extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $2358b7e4ec07df88$var$_id$1 = 0;
const $2358b7e4ec07df88$var$_m1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_obj = /*@__PURE__*/ new $2358b7e4ec07df88$export$e4dd07dff30cc924();
const $2358b7e4ec07df88$var$_offset = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_box$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_boxMorphTargets = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_vector$8 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$b7be63a67df8959 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()?, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new ($2358b7e4ec07df88$export$bc6f937da07eae17(index) ? $2358b7e4ec07df88$export$7eb8c9fa25cd5bd6 : $2358b7e4ec07df88$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $2358b7e4ec07df88$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        $2358b7e4ec07df88$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        $2358b7e4ec07df88$var$_m1.makeRotationX(angle);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        $2358b7e4ec07df88$var$_m1.makeRotationY(angle);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        $2358b7e4ec07df88$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        $2358b7e4ec07df88$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        $2358b7e4ec07df88$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($2358b7e4ec07df88$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        $2358b7e4ec07df88$var$_obj.lookAt(vector);
        $2358b7e4ec07df88$var$_obj.updateMatrix();
        this.applyMatrix4($2358b7e4ec07df88$var$_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($2358b7e4ec07df88$var$_offset).negate();
        this.translate($2358b7e4ec07df88$var$_offset.x, $2358b7e4ec07df88$var$_offset.y, $2358b7e4ec07df88$var$_offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) $2358b7e4ec07df88$export$c106dd0671a0fc2d('BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $2358b7e4ec07df88$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $2358b7e4ec07df88$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $2358b7e4ec07df88$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $2358b7e4ec07df88$var$_vector$8.addVectors(this.boundingBox.min, $2358b7e4ec07df88$var$_box$2.min);
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                    $2358b7e4ec07df88$var$_vector$8.addVectors(this.boundingBox.max, $2358b7e4ec07df88$var$_box$2.max);
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_box$2.min);
                    this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $2358b7e4ec07df88$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $2358b7e4ec07df88$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $2358b7e4ec07df88$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $2358b7e4ec07df88$var$_vector$8.addVectors($2358b7e4ec07df88$var$_box$2.min, $2358b7e4ec07df88$var$_boxMorphTargets.min);
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                    $2358b7e4ec07df88$var$_vector$8.addVectors($2358b7e4ec07df88$var$_box$2.max, $2358b7e4ec07df88$var$_boxMorphTargets.max);
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_vector$8);
                } else {
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_boxMorphTargets.min);
                    $2358b7e4ec07df88$var$_box$2.expandByPoint($2358b7e4ec07df88$var$_boxMorphTargets.max);
                }
            }
            $2358b7e4ec07df88$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $2358b7e4ec07df88$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($2358b7e4ec07df88$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $2358b7e4ec07df88$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $2358b7e4ec07df88$var$_offset.fromBufferAttribute(position, j);
                        $2358b7e4ec07df88$var$_vector$8.add($2358b7e4ec07df88$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($2358b7e4ec07df88$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $2358b7e4ec07df88$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $2358b7e4ec07df88$export$64b5c384219d3699();
            tan2[i] = new $2358b7e4ec07df88$export$64b5c384219d3699();
        }
        const vA = new $2358b7e4ec07df88$export$64b5c384219d3699(), vB = new $2358b7e4ec07df88$export$64b5c384219d3699(), vC = new $2358b7e4ec07df88$export$64b5c384219d3699(), uvA = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), uvB = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), uvC = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), sdir = new $2358b7e4ec07df88$export$64b5c384219d3699(), tdir = new $2358b7e4ec07df88$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $2358b7e4ec07df88$export$64b5c384219d3699(), tmp2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const n = new $2358b7e4ec07df88$export$64b5c384219d3699(), n2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $2358b7e4ec07df88$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $2358b7e4ec07df88$export$64b5c384219d3699(), pB = new $2358b7e4ec07df88$export$64b5c384219d3699(), pC = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const nA = new $2358b7e4ec07df88$export$64b5c384219d3699(), nB = new $2358b7e4ec07df88$export$64b5c384219d3699(), nC = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const cb = new $2358b7e4ec07df88$export$64b5c384219d3699(), ab = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $2358b7e4ec07df88$var$_vector$8.fromBufferAttribute(normals, i);
            $2358b7e4ec07df88$var$_vector$8.normalize();
            normals.setXYZ(i, $2358b7e4ec07df88$var$_vector$8.x, $2358b7e4ec07df88$var$_vector$8.y, $2358b7e4ec07df88$var$_vector$8.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $2358b7e4ec07df88$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $2358b7e4ec07df88$var$_inverseMatrix$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
const $2358b7e4ec07df88$var$_sphere$6 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_sphereHitAt = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vA$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vB$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vC$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_tempA = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_morphA = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_intersectionPoint = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_intersectionPointWorld = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$e176487c05830cc5 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $2358b7e4ec07df88$export$b7be63a67df8959(), material = new $2358b7e4ec07df88$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $2358b7e4ec07df88$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $2358b7e4ec07df88$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $2358b7e4ec07df88$var$_morphA.addScaledVector($2358b7e4ec07df88$var$_tempA, influence);
                else $2358b7e4ec07df88$var$_morphA.addScaledVector($2358b7e4ec07df88$var$_tempA.sub(target), influence);
            }
            target.add($2358b7e4ec07df88$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$6.copy(geometry.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $2358b7e4ec07df88$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($2358b7e4ec07df88$var$_sphere$6.containsPoint($2358b7e4ec07df88$var$_ray$3.origin) === false) {
            if ($2358b7e4ec07df88$var$_ray$3.intersectSphere($2358b7e4ec07df88$var$_sphere$6, $2358b7e4ec07df88$var$_sphereHitAt) === null) return;
            if ($2358b7e4ec07df88$var$_ray$3.origin.distanceToSquared($2358b7e4ec07df88$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $2358b7e4ec07df88$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray$3.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($2358b7e4ec07df88$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $2358b7e4ec07df88$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $2358b7e4ec07df88$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $2358b7e4ec07df88$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $2358b7e4ec07df88$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $2358b7e4ec07df88$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $2358b7e4ec07df88$var$_intersectionPointWorld.copy(point);
    $2358b7e4ec07df88$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $2358b7e4ec07df88$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $2358b7e4ec07df88$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $2358b7e4ec07df88$var$_vA$1);
    object.getVertexPosition(b, $2358b7e4ec07df88$var$_vB$1);
    object.getVertexPosition(c, $2358b7e4ec07df88$var$_vC$1);
    const intersection = $2358b7e4ec07df88$var$checkIntersection$1(object, material, raycaster, ray, $2358b7e4ec07df88$var$_vA$1, $2358b7e4ec07df88$var$_vB$1, $2358b7e4ec07df88$var$_vC$1, $2358b7e4ec07df88$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $2358b7e4ec07df88$export$64b5c384219d3699();
        $2358b7e4ec07df88$export$5a465592bfe74b48.getBarycoord($2358b7e4ec07df88$var$_intersectionPoint, $2358b7e4ec07df88$var$_vA$1, $2358b7e4ec07df88$var$_vB$1, $2358b7e4ec07df88$var$_vC$1, barycoord);
        if (uv) intersection.uv = $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $2358b7e4ec07df88$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $2358b7e4ec07df88$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $2358b7e4ec07df88$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $2358b7e4ec07df88$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $2358b7e4ec07df88$export$5a465592bfe74b48.getNormal($2358b7e4ec07df88$var$_vA$1, $2358b7e4ec07df88$var$_vB$1, $2358b7e4ec07df88$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#BoxGeometry
 */ class $2358b7e4ec07df88$export$33e43285f7406bd5 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Provides utility functions for managing uniforms.
 *
 * @module UniformsUtils
 */ /**
 * Clones the given uniform definitions by performing a deep-copy. That means
 * if the value of a uniform refers to an object like a Vector3 or Texture,
 * the cloned uniform will refer to a new object reference.
 *
 * @param {Object} src - An object representing uniform definitions.
 * @return {Object} The cloned uniforms.
 */ function $2358b7e4ec07df88$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    $2358b7e4ec07df88$export$c106dd0671a0fc2d('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
/**
 * Merges the given uniform definitions into a single object. Since the
 * method internally uses cloneUniforms(), it performs a deep-copy when
 * producing the merged uniform definitions.
 *
 * @param {Array} uniforms - An array of objects containing uniform definitions.
 * @return {Object} The merged uniforms.
 */ function $2358b7e4ec07df88$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $2358b7e4ec07df88$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $2358b7e4ec07df88$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $2358b7e4ec07df88$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $2358b7e4ec07df88$export$d8ecdf8615bfea69 = {
    clone: $2358b7e4ec07df88$export$acda854380553452,
    merge: $2358b7e4ec07df88$export$8916ce6879271f43
};
var $2358b7e4ec07df88$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $2358b7e4ec07df88$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized](https://en.wikipedia.org/wiki/Normalized_loop).
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$83c7d75d550a8b0d extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = $2358b7e4ec07df88$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = $2358b7e4ec07df88$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Define whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation)
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $2358b7e4ec07df88$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $2358b7e4ec07df88$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$79f141de891a5fed extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3;
        this._reversedDepth = false;
    }
    /**
	 * The flag that indicates whether the camera uses a reversed depth buffer.
	 *
	 * @type {boolean}
	 * @default false
	 */ get reversedDepth() {
        return this._reversedDepth;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_v3$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_minTarget = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_maxTarget = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection](https://en.wikipedia.org/wiki/Perspective_(graphical)).
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $2358b7e4ec07df88$export$74e4ae24825f68d7 extends $2358b7e4ec07df88$export$79f141de891a5fed {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $2358b7e4ec07df88$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($2358b7e4ec07df88$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $2358b7e4ec07df88$export$914076c8150813e5 * 2 * Math.atan(Math.tan($2358b7e4ec07df88$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $2358b7e4ec07df88$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($2358b7e4ec07df88$var$_v3$1.x, $2358b7e4ec07df88$var$_v3$1.y).multiplyScalar(-distance / $2358b7e4ec07df88$var$_v3$1.z);
        $2358b7e4ec07df88$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($2358b7e4ec07df88$var$_v3$1.x, $2358b7e4ec07df88$var$_v3$1.y).multiplyScalar(-distance / $2358b7e4ec07df88$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $2358b7e4ec07df88$var$_minTarget, $2358b7e4ec07df88$var$_maxTarget);
        return target.subVectors($2358b7e4ec07df88$var$_maxTarget, $2358b7e4ec07df88$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($2358b7e4ec07df88$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $2358b7e4ec07df88$var$fov = -90; // negative fov is not an error
const $2358b7e4ec07df88$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$d0cdd0bd804995de extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $2358b7e4ec07df88$export$74e4ae24825f68d7($2358b7e4ec07df88$var$fov, $2358b7e4ec07df88$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$ee2e5a18258a4049 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = $2358b7e4ec07df88$export$8759762a6477f2c4, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $2358b7e4ec07df88$export$ac386671d651941e extends $2358b7e4ec07df88$export$3c052beb2e51e23f {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$ee2e5a18258a4049(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $2358b7e4ec07df88$export$33e43285f7406bd5(5, 5, 5);
        const material = new $2358b7e4ec07df88$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $2358b7e4ec07df88$export$acda854380553452(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $2358b7e4ec07df88$export$d9f0486e75b5ace,
            blending: $2358b7e4ec07df88$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $2358b7e4ec07df88$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $2358b7e4ec07df88$export$5d8599b6a933fb1b) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
        const camera = new $2358b7e4ec07df88$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $2358b7e4ec07df88$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class $2358b7e4ec07df88$export$cb626c57dcc48b9f {
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $2358b7e4ec07df88$export$64b5c384219d3699();
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($2358b7e4ec07df88$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $2358b7e4ec07df88$export$6f1519f023b8d0f6 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $2358b7e4ec07df88$export$3c890837b09508d4 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$38af1803e3442a7f extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics](https://blog.tojicode.com/2011/05/interleaved-array-basics.html)
 */ class $2358b7e4ec07df88$export$3d5cd879f108f53f {
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $2358b7e4ec07df88$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $2358b7e4ec07df88$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $2358b7e4ec07df88$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $2358b7e4ec07df88$var$_vector$7 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class $2358b7e4ec07df88$export$920b6d07334599c7 {
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$7.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$7.applyMatrix4(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$7.x, $2358b7e4ec07df88$var$_vector$7.y, $2358b7e4ec07df88$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$7.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$7.applyNormalMatrix(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$7.x, $2358b7e4ec07df88$var$_vector$7.y, $2358b7e4ec07df88$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $2358b7e4ec07df88$var$_vector$7.fromBufferAttribute(this, i);
            $2358b7e4ec07df88$var$_vector$7.transformDirection(m);
            this.setXYZ(i, $2358b7e4ec07df88$var$_vector$7.x, $2358b7e4ec07df88$var$_vector$7.y, $2358b7e4ec07df88$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $2358b7e4ec07df88$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $2358b7e4ec07df88$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $2358b7e4ec07df88$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $2358b7e4ec07df88$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $2358b7e4ec07df88$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $2358b7e4ec07df88$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $2358b7e4ec07df88$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $2358b7e4ec07df88$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $2358b7e4ec07df88$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $2358b7e4ec07df88$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $2358b7e4ec07df88$var$normalize(x, this.array);
            y = $2358b7e4ec07df88$var$normalize(y, this.array);
            z = $2358b7e4ec07df88$var$normalize(z, this.array);
            w = $2358b7e4ec07df88$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            $2358b7e4ec07df88$export$bef1f36f5486a6a3('InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $2358b7e4ec07df88$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $2358b7e4ec07df88$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            $2358b7e4ec07df88$export$bef1f36f5486a6a3('InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$5ec7dd1c6994bf8e extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $2358b7e4ec07df88$var$_geometry;
const $2358b7e4ec07df88$var$_intersectPoint = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_worldScale = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_mvPosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_alignedPosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_rotatedPosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_viewWorldMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_vA = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vB = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vC = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_uvA = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_uvB = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
const $2358b7e4ec07df88$var$_uvC = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$3075603db8e6204c extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
	 */ constructor(material = new $2358b7e4ec07df88$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($2358b7e4ec07df88$var$_geometry === undefined) {
            $2358b7e4ec07df88$var$_geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $2358b7e4ec07df88$export$3d5cd879f108f53f(float32Array, 5);
            $2358b7e4ec07df88$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $2358b7e4ec07df88$var$_geometry.setAttribute('position', new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $2358b7e4ec07df88$var$_geometry.setAttribute('uv', new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $2358b7e4ec07df88$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {(SpriteMaterial|SpriteNodeMaterial)}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) $2358b7e4ec07df88$export$a3bc9b8ed74fc('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $2358b7e4ec07df88$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $2358b7e4ec07df88$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $2358b7e4ec07df88$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $2358b7e4ec07df88$var$_worldScale.multiplyScalar(-$2358b7e4ec07df88$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vA.set(-0.5, -0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
        $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vB.set(0.5, -0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
        $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vC.set(0.5, 0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
        $2358b7e4ec07df88$var$_uvA.set(0, 0);
        $2358b7e4ec07df88$var$_uvB.set(1, 0);
        $2358b7e4ec07df88$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($2358b7e4ec07df88$var$_vA, $2358b7e4ec07df88$var$_vB, $2358b7e4ec07df88$var$_vC, false, $2358b7e4ec07df88$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $2358b7e4ec07df88$var$transformVertex($2358b7e4ec07df88$var$_vB.set(-0.5, 0.5, 0), $2358b7e4ec07df88$var$_mvPosition, center, $2358b7e4ec07df88$var$_worldScale, sin, cos);
            $2358b7e4ec07df88$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($2358b7e4ec07df88$var$_vA, $2358b7e4ec07df88$var$_vC, $2358b7e4ec07df88$var$_vB, false, $2358b7e4ec07df88$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $2358b7e4ec07df88$var$_intersectPoint.clone(),
            uv: $2358b7e4ec07df88$export$5a465592bfe74b48.getInterpolation($2358b7e4ec07df88$var$_intersectPoint, $2358b7e4ec07df88$var$_vA, $2358b7e4ec07df88$var$_vB, $2358b7e4ec07df88$var$_vC, $2358b7e4ec07df88$var$_uvA, $2358b7e4ec07df88$var$_uvB, $2358b7e4ec07df88$var$_uvC, new $2358b7e4ec07df88$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $2358b7e4ec07df88$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $2358b7e4ec07df88$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $2358b7e4ec07df88$var$_rotatedPosition.x = cos * $2358b7e4ec07df88$var$_alignedPosition.x - sin * $2358b7e4ec07df88$var$_alignedPosition.y;
        $2358b7e4ec07df88$var$_rotatedPosition.y = sin * $2358b7e4ec07df88$var$_alignedPosition.x + cos * $2358b7e4ec07df88$var$_alignedPosition.y;
    } else $2358b7e4ec07df88$var$_rotatedPosition.copy($2358b7e4ec07df88$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $2358b7e4ec07df88$var$_rotatedPosition.x;
    vertexPosition.y += $2358b7e4ec07df88$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($2358b7e4ec07df88$var$_viewWorldMatrix);
}
const $2358b7e4ec07df88$var$_v1$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$112e7237be0c5f30 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {?Object3D} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $2358b7e4ec07df88$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $2358b7e4ec07df88$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $2358b7e4ec07df88$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $2358b7e4ec07df88$var$_v1$2.distanceTo($2358b7e4ec07df88$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $2358b7e4ec07df88$var$_basePosition = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_skinIndex = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_skinWeight = /*@__PURE__*/ new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
const $2358b7e4ec07df88$var$_vector3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_matrix4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_vertex = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_sphere$5 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_inverseMatrix$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 * @demo scenes/bones-browser.html
 */ class $2358b7e4ec07df88$export$b303577035157ecf extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $2358b7e4ec07df88$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $2358b7e4ec07df88$var$_vertex);
            this.boundingBox.expandByPoint($2358b7e4ec07df88$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $2358b7e4ec07df88$var$_vertex);
            this.boundingSphere.expandByPoint($2358b7e4ec07df88$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$5.copy(this.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $2358b7e4ec07df88$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray$2.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($2358b7e4ec07df88$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $2358b7e4ec07df88$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $2358b7e4ec07df88$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $2358b7e4ec07df88$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $2358b7e4ec07df88$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else $2358b7e4ec07df88$export$c106dd0671a0fc2d('SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $2358b7e4ec07df88$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $2358b7e4ec07df88$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $2358b7e4ec07df88$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $2358b7e4ec07df88$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $2358b7e4ec07df88$var$_skinIndex.getComponent(i);
                $2358b7e4ec07df88$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($2358b7e4ec07df88$var$_vector3.copy($2358b7e4ec07df88$var$_basePosition).applyMatrix4($2358b7e4ec07df88$var$_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$b127726e56765aa4 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$b691f601014eabe1 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const $2358b7e4ec07df88$var$_offsetMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_identityMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $2358b7e4ec07df88$export$8f31e4c4a37b8e9c {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $2358b7e4ec07df88$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $2358b7e4ec07df88$var$_identityMatrix;
            $2358b7e4ec07df88$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $2358b7e4ec07df88$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(boneMatrices, size, size, $2358b7e4ec07df88$export$3f8bb04b555a363c, $2358b7e4ec07df88$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                $2358b7e4ec07df88$export$c106dd0671a0fc2d('Skeleton: No bone found with UUID:', uuid);
                bone = new $2358b7e4ec07df88$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $2358b7e4ec07df88$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class $2358b7e4ec07df88$export$32ea87a8b54d744a extends $2358b7e4ec07df88$export$8dea267bd6bde117 {
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $2358b7e4ec07df88$var$_instanceLocalMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_instanceWorldMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_instanceIntersects = [];
const $2358b7e4ec07df88$var$_box3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_identity = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_mesh$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$e176487c05830cc5();
const $2358b7e4ec07df88$var$_sphere$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $2358b7e4ec07df88$export$f3c979c331175ad7 extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $2358b7e4ec07df88$var$_identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            $2358b7e4ec07df88$var$_box3.copy(geometry.boundingBox).applyMatrix4($2358b7e4ec07df88$var$_instanceLocalMatrix);
            this.boundingBox.union($2358b7e4ec07df88$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            $2358b7e4ec07df88$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($2358b7e4ec07df88$var$_instanceLocalMatrix);
            this.boundingSphere.union($2358b7e4ec07df88$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $2358b7e4ec07df88$var$_mesh$1.geometry = this.geometry;
        $2358b7e4ec07df88$var$_mesh$1.material = this.material;
        if ($2358b7e4ec07df88$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$4.copy(this.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            $2358b7e4ec07df88$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $2358b7e4ec07df88$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $2358b7e4ec07df88$var$_mesh$1.matrixWorld = $2358b7e4ec07df88$var$_instanceWorldMatrix;
            $2358b7e4ec07df88$var$_mesh$1.raycast(raycaster, $2358b7e4ec07df88$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $2358b7e4ec07df88$var$_instanceIntersects.length; i < l; i++){
                const intersect = $2358b7e4ec07df88$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $2358b7e4ec07df88$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $2358b7e4ec07df88$export$4e041a7967d15c4b, $2358b7e4ec07df88$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const $2358b7e4ec07df88$var$_vector1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vector2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_normalMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form](http://mathworld.wolfram.com/HessianNormalForm.html)
 * by a unit length normal vector and a constant.
 */ class $2358b7e4ec07df88$export$7ff5ac152ef991b0 {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $2358b7e4ec07df88$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $2358b7e4ec07df88$var$_vector1.subVectors(c, b).cross($2358b7e4ec07df88$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta($2358b7e4ec07df88$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $2358b7e4ec07df88$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($2358b7e4ec07df88$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_sphere$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_defaultSpriteCenter = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0.5);
const $2358b7e4ec07df88$var$_vector$6 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $2358b7e4ec07df88$export$35efe6f4c85463d2 {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p1 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p2 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p3 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p4 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0(), p5 = new $2358b7e4ec07df88$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3, reversedDepth = false) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        if (reversedDepth) {
            planes[4].setComponents(me2, me6, me10, me14).normalize(); // far
            planes[5].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // near
        } else {
            planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // far
            if (coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize(); // near
            else if (coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize(); // near
            else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        }
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $2358b7e4ec07df88$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $2358b7e4ec07df88$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($2358b7e4ec07df88$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $2358b7e4ec07df88$var$_sphere$3.center.set(0, 0, 0);
        const offset = $2358b7e4ec07df88$var$_defaultSpriteCenter.distanceTo(sprite.center);
        $2358b7e4ec07df88$var$_sphere$3.radius = 0.7071067811865476 + offset;
        $2358b7e4ec07df88$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($2358b7e4ec07df88$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $2358b7e4ec07df88$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $2358b7e4ec07df88$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $2358b7e4ec07df88$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($2358b7e4ec07df88$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_projScreenMatrix$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_frustum$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$35efe6f4c85463d2();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ class $2358b7e4ec07df88$export$2d7d04327620499c {
    /**
	 * Constructs a new frustum array.
	 *
	 */ constructor(){
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = $2358b7e4ec07df88$export$5a0e9190d10875d3;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ intersectsObject(object, cameraArray) {
        if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$2, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ intersectsSprite(sprite, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$2, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ intersectsSphere(sphere, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$2, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ intersectsBox(box, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$2, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ containsPoint(point, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $2358b7e4ec07df88$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $2358b7e4ec07df88$var$_frustum$1.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$2, camera.coordinateSystem, camera.reversedDepth);
            if ($2358b7e4ec07df88$var$_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$2d7d04327620499c();
    }
}
function $2358b7e4ec07df88$var$ascIdSort(a, b) {
    return a - b;
}
function $2358b7e4ec07df88$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $2358b7e4ec07df88$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $2358b7e4ec07df88$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $2358b7e4ec07df88$var$_matrix$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_whiteColor = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e(1, 1, 1);
const $2358b7e4ec07df88$var$_frustum = /*@__PURE__*/ new $2358b7e4ec07df88$export$35efe6f4c85463d2();
const $2358b7e4ec07df88$var$_frustumArray = /*@__PURE__*/ new $2358b7e4ec07df88$export$2d7d04327620499c();
const $2358b7e4ec07df88$var$_box$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
const $2358b7e4ec07df88$var$_sphere$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_vector$5 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_forward$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_temp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_renderList = /*@__PURE__*/ new $2358b7e4ec07df88$var$MultiDrawRenderList();
const $2358b7e4ec07df88$var$_mesh = /*@__PURE__*/ new $2358b7e4ec07df88$export$e176487c05830cc5();
const $2358b7e4ec07df88$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $2358b7e4ec07df88$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $2358b7e4ec07df88$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $2358b7e4ec07df88$export$6e01c5ee52ed8f7b extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $2358b7e4ec07df88$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(matricesArray, size, size, $2358b7e4ec07df88$export$3f8bb04b555a363c, $2358b7e4ec07df88$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(indirectArray, size, size, $2358b7e4ec07df88$export$aa92e870a709d190, $2358b7e4ec07df88$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $2358b7e4ec07df88$export$b691f601014eabe1(colorsArray, size, size, $2358b7e4ec07df88$export$3f8bb04b555a363c, $2358b7e4ec07df88$export$f6d331659b644596);
        colorsTexture.colorSpace = $2358b7e4ec07df88$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $2358b7e4ec07df88$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $2358b7e4ec07df88$var$_box$1).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
            boundingBox.union($2358b7e4ec07df88$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_sphere$2).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
            boundingSphere.union($2358b7e4ec07df88$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($2358b7e4ec07df88$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $2358b7e4ec07df88$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $2358b7e4ec07df88$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($2358b7e4ec07df88$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $2358b7e4ec07df88$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in [name] to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {?Box3} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($2358b7e4ec07df88$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {?Sphere} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $2358b7e4ec07df88$var$_box$1);
            $2358b7e4ec07df88$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $2358b7e4ec07df88$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($2358b7e4ec07df88$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($2358b7e4ec07df88$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length - 1){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $2358b7e4ec07df88$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $2358b7e4ec07df88$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $2358b7e4ec07df88$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $2358b7e4ec07df88$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $2358b7e4ec07df88$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $2358b7e4ec07df88$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$2358b7e4ec07df88$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $2358b7e4ec07df88$var$_mesh.material = this.material;
        $2358b7e4ec07df88$var$_mesh.geometry.index = batchGeometry.index;
        $2358b7e4ec07df88$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($2358b7e4ec07df88$var$_mesh.geometry.boundingBox === null) $2358b7e4ec07df88$var$_mesh.geometry.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
        if ($2358b7e4ec07df88$var$_mesh.geometry.boundingSphere === null) $2358b7e4ec07df88$var$_mesh.geometry.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $2358b7e4ec07df88$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $2358b7e4ec07df88$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $2358b7e4ec07df88$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_mesh.geometry.boundingSphere);
            $2358b7e4ec07df88$var$_mesh.raycast(raycaster, $2358b7e4ec07df88$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $2358b7e4ec07df88$var$_batchIntersects.length; j < l; j++){
                const intersect = $2358b7e4ec07df88$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $2358b7e4ec07df88$var$_batchIntersects.length = 0;
        }
        $2358b7e4ec07df88$var$_mesh.material = null;
        $2358b7e4ec07df88$var$_mesh.geometry.index = null;
        $2358b7e4ec07df88$var$_mesh.geometry.attributes = {};
        $2358b7e4ec07df88$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._availableInstanceIds = source._availableInstanceIds.slice();
        this._availableGeometryIds = source._availableGeometryIds.slice();
        this._nextIndexStart = source._nextIndexStart;
        this._nextVertexStart = source._nextVertexStart;
        this._geometryCount = source._geometryCount;
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._indirectTexture = source._indirectTexture.clone();
        this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        const frustum = camera.isArrayCamera ? $2358b7e4ec07df88$var$_frustumArray : $2358b7e4ec07df88$var$_frustum;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled && !camera.isArrayCamera) {
            $2358b7e4ec07df88$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $2358b7e4ec07df88$var$_frustum.setFromProjectionMatrix($2358b7e4ec07df88$var$_matrix$1, camera.coordinateSystem, camera.reversedDepth);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $2358b7e4ec07df88$var$_matrix$1.copy(this.matrixWorld).invert();
            $2358b7e4ec07df88$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
            $2358b7e4ec07df88$var$_forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($2358b7e4ec07df88$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_sphere$2).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !frustum.intersectsSphere($2358b7e4ec07df88$var$_sphere$2, camera);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $2358b7e4ec07df88$var$_temp.subVectors($2358b7e4ec07df88$var$_sphere$2.center, $2358b7e4ec07df88$var$_vector$5).dot($2358b7e4ec07df88$var$_forward$1);
                    $2358b7e4ec07df88$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $2358b7e4ec07df88$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $2358b7e4ec07df88$var$sortTransparent : $2358b7e4ec07df88$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $2358b7e4ec07df88$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $2358b7e4ec07df88$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $2358b7e4ec07df88$var$_sphere$2).applyMatrix4($2358b7e4ec07df88$var$_matrix$1);
                    culled = !frustum.intersectsSphere($2358b7e4ec07df88$var$_sphere$2, camera);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$fbaaa33907730a0c extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $2358b7e4ec07df88$var$_vStart = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_vEnd = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_inverseMatrix$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
const $2358b7e4ec07df88$var$_sphere$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_intersectPointOnRay = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_intersectPointOnSegment = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$17d680238e50603e extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $2358b7e4ec07df88$export$b7be63a67df8959(), material = new $2358b7e4ec07df88$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $2358b7e4ec07df88$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $2358b7e4ec07df88$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $2358b7e4ec07df88$var$_vStart.distanceTo($2358b7e4ec07df88$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $2358b7e4ec07df88$export$cbe7a62641830ebd(lineDistances, 1));
        } else $2358b7e4ec07df88$export$c106dd0671a0fc2d('Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere$1.copy(geometry.boundingSphere);
        $2358b7e4ec07df88$var$_sphere$1.applyMatrix4(matrixWorld);
        $2358b7e4ec07df88$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere$1) === false) return;
        //
        $2358b7e4ec07df88$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray$1.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $2358b7e4ec07df88$var$checkIntersection(this, raycaster, $2358b7e4ec07df88$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $2358b7e4ec07df88$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $2358b7e4ec07df88$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $2358b7e4ec07df88$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($2358b7e4ec07df88$var$_vStart, $2358b7e4ec07df88$var$_vEnd, $2358b7e4ec07df88$var$_intersectPointOnRay, $2358b7e4ec07df88$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $2358b7e4ec07df88$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($2358b7e4ec07df88$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $2358b7e4ec07df88$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $2358b7e4ec07df88$var$_start = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_end = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $2358b7e4ec07df88$export$ff1ed10fedfdd604 extends $2358b7e4ec07df88$export$17d680238e50603e {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $2358b7e4ec07df88$var$_start.fromBufferAttribute(positionAttribute, i);
                $2358b7e4ec07df88$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $2358b7e4ec07df88$var$_start.distanceTo($2358b7e4ec07df88$var$_end);
            }
            geometry.setAttribute('lineDistance', new $2358b7e4ec07df88$export$cbe7a62641830ebd(lineDistances, 1));
        } else $2358b7e4ec07df88$export$c106dd0671a0fc2d('LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $2358b7e4ec07df88$export$f85a24d745e4f17d extends $2358b7e4ec07df88$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$a178c45366ce5d6b extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete).
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $2358b7e4ec07df88$var$_inverseMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_ray = /*@__PURE__*/ new $2358b7e4ec07df88$export$a186db52eed6d40e();
const $2358b7e4ec07df88$var$_sphere = /*@__PURE__*/ new $2358b7e4ec07df88$export$805e8b72413ccaba();
const $2358b7e4ec07df88$var$_position$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$1c787534cb11aa3e extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $2358b7e4ec07df88$export$b7be63a67df8959(), material = new $2358b7e4ec07df88$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $2358b7e4ec07df88$var$_sphere.copy(geometry.boundingSphere);
        $2358b7e4ec07df88$var$_sphere.applyMatrix4(matrixWorld);
        $2358b7e4ec07df88$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($2358b7e4ec07df88$var$_sphere) === false) return;
        //
        $2358b7e4ec07df88$var$_inverseMatrix.copy(matrixWorld).invert();
        $2358b7e4ec07df88$var$_ray.copy(raycaster.ray).applyMatrix4($2358b7e4ec07df88$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $2358b7e4ec07df88$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $2358b7e4ec07df88$var$testPoint($2358b7e4ec07df88$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $2358b7e4ec07df88$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $2358b7e4ec07df88$var$testPoint($2358b7e4ec07df88$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $2358b7e4ec07df88$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $2358b7e4ec07df88$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $2358b7e4ec07df88$export$64b5c384219d3699();
        $2358b7e4ec07df88$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: When using video textures with {@link WebGPURenderer}, {@link Texture#colorSpace} must be
 * set to THREE.SRGBColorSpace.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$6e09d1edf8d5a25c extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {HTMLVideoElement} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8, minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The video frame request callback identifier, which is a positive integer.
		 *
		 * Value of 0 represents no scheduled rVFC.
		 *
		 * @private
		 * @type {number}
		 */ this._requestVideoFrameCallbackId = 0;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            scope._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) this._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    dispose() {
        if (this._requestVideoFrameCallbackId !== 0) {
            this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId);
            this._requestVideoFrameCallbackId = 0;
        }
        super.dispose();
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class $2358b7e4ec07df88$export$68498d200b825382 extends $2358b7e4ec07df88$export$6e09d1edf8d5a25c {
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$9270d786f73ce6fe extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} [width] - The width of the texture.
	 * @param {number} [height] - The height of the texture.
	 */ constructor(width, height){
        super({
            width: width,
            height: height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$3466bac9141a5cc4 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $2358b7e4ec07df88$export$5fe6b8e34b274fcb extends $2358b7e4ec07df88$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $2358b7e4ec07df88$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $2358b7e4ec07df88$export$d80173634de65bff extends $2358b7e4ec07df88$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $2358b7e4ec07df88$export$8759762a6477f2c4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$f7189e49152d1c13 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$fc830aa069cc8c2f extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(width, height, type = $2358b7e4ec07df88$export$c3c7fc4518ebba96, mapping, wrapS, wrapT, magFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, minFilter = $2358b7e4ec07df88$export$727aa5ec3fe39bf0, anisotropy, format = $2358b7e4ec07df88$export$c1b6b5136be58045, depth = 1){
        if (format !== $2358b7e4ec07df88$export$c1b6b5136be58045 && format !== $2358b7e4ec07df88$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        const image = {
            width: width,
            height: height,
            depth: depth
        };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new $2358b7e4ec07df88$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * Represents a texture created externally with the same renderer context.
 *
 * This may be a texture from a protected media stream, device camera feed,
 * or other data feeds like a depth sensor.
 *
 * Note that this class is only supported in {@link WebGLRenderer}, and in
 * the {@link WebGPURenderer} WebGPU backend.
 *
 * @augments Texture
 */ class $2358b7e4ec07df88$export$cd10147cacf16ab2 extends $2358b7e4ec07df88$export$5431306cf43de24a {
    /**
	 * Creates a new raw texture.
	 *
	 * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
	 */ constructor(sourceTexture = null){
        super();
        /**
		 * The external source texture.
		 *
		 * @type {?(WebGLTexture|GPUTexture)}
		 * @default null
		 */ this.sourceTexture = sourceTexture;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isExternalTexture = true;
    }
    copy(source) {
        super.copy(source);
        this.sourceTexture = source.sourceTexture;
        return this;
    }
}
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CapsuleGeometry
 */ class $2358b7e4ec07df88$export$41680e8551036033 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [height=1] - Height of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build each cap.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule. Must be an integer >= 3.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the middle section. Must be an integer >= 1.
	 */ constructor(radius = 1, height = 1, capSegments = 4, radialSegments = 8, heightSegments = 1){
        super();
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const halfHeight = height / 2;
        const capArcLength = Math.PI / 2 * radius;
        const cylinderPartLength = height;
        const totalArcLength = 2 * capArcLength + cylinderPartLength;
        const numVerticalSegments = capSegments * 2 + heightSegments;
        const verticesPerRow = radialSegments + 1;
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // generate vertices, normals, and uvs
        for(let iy = 0; iy <= numVerticalSegments; iy++){
            let currentArcLength = 0;
            let profileY = 0;
            let profileRadius = 0;
            let normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                const segmentProgress = iy / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                const segmentProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress * cylinderPartLength;
            } else {
                // top cap
                const segmentProgress = (iy - capSegments - heightSegments) / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle);
                profileRadius = radius * Math.cos(angle);
                normalYComponent = radius * Math.sin(angle);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress * capArcLength;
            }
            const v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            let uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(let ix = 0; ix <= radialSegments; ix++){
                const u = ix / radialSegments;
                const theta = u * Math.PI * 2;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                const prevIndexRow = (iy - 1) * verticesPerRow;
                for(let ix = 0; ix < radialSegments; ix++){
                    const i1 = prevIndexRow + ix;
                    const i2 = prevIndexRow + ix + 1;
                    const i3 = iy * verticesPerRow + ix;
                    const i4 = iy * verticesPerRow + ix + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$41680e8551036033(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CircleGeometry
 */ class $2358b7e4ec07df88$export$d5c0e8d607467193 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CylinderGeometry
 */ class $2358b7e4ec07df88$export$68f745719dbe5198 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 * @demo scenes/geometry-browser.html#ConeGeometry
 */ class $2358b7e4ec07df88$export$a7a48974f285c9b3 extends $2358b7e4ec07df88$export$68f745719dbe5198 {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $2358b7e4ec07df88$export$60e57a7d3f20ff65 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const b = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const c = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const b = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const c = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const centroid = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const uvA = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            const uvB = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            const uvC = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#DodecahedronGeometry
 */ class $2358b7e4ec07df88$export$c0babfeb8708fc9c extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $2358b7e4ec07df88$var$_v0 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v1$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_normal = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_triangle = /*@__PURE__*/ new $2358b7e4ec07df88$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $2358b7e4ec07df88$export$4730b1542707547f extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($2358b7e4ec07df88$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $2358b7e4ec07df88$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $2358b7e4ec07df88$var$_triangle.getNormal($2358b7e4ec07df88$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $2358b7e4ec07df88$var$_triangle[vertKeys[j]];
                    const v1 = $2358b7e4ec07df88$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($2358b7e4ec07df88$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $2358b7e4ec07df88$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $2358b7e4ec07df88$var$_v0.fromBufferAttribute(positionAttr, index0);
                $2358b7e4ec07df88$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($2358b7e4ec07df88$var$_v0.x, $2358b7e4ec07df88$var$_v0.y, $2358b7e4ec07df88$var$_v0.z);
                vertices.push($2358b7e4ec07df88$var$_v1$1.x, $2358b7e4ec07df88$var$_v1$1.y, $2358b7e4ec07df88$var$_v1$1.z);
            }
            this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        $2358b7e4ec07df88$export$c106dd0671a0fc2d('Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $2358b7e4ec07df88$export$c977b3e384af9ae1() : new $2358b7e4ec07df88$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const mat = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $2358b7e4ec07df88$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $2358b7e4ec07df88$export$64b5c384219d3699();
        binormals[0] = new $2358b7e4ec07df88$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($2358b7e4ec07df88$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($2358b7e4ec07df88$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$3f87a931616cde04 extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $2358b7e4ec07df88$export$b1eedc9aab6300e8 extends $2358b7e4ec07df88$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $2358b7e4ec07df88$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $2358b7e4ec07df88$var$tmp = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$px = /*@__PURE__*/ new $2358b7e4ec07df88$var$CubicPoly();
const $2358b7e4ec07df88$var$py = /*@__PURE__*/ new $2358b7e4ec07df88$var$CubicPoly();
const $2358b7e4ec07df88$var$pz = /*@__PURE__*/ new $2358b7e4ec07df88$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$b9146b27c24b744c extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $2358b7e4ec07df88$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $2358b7e4ec07df88$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $2358b7e4ec07df88$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $2358b7e4ec07df88$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $2358b7e4ec07df88$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $2358b7e4ec07df88$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $2358b7e4ec07df88$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $2358b7e4ec07df88$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $2358b7e4ec07df88$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $2358b7e4ec07df88$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($2358b7e4ec07df88$var$px.calc(weight), $2358b7e4ec07df88$var$py.calc(weight), $2358b7e4ec07df88$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $2358b7e4ec07df88$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Interpolations contains spline and Bézier functions internally used by concrete curve classes.
 *
 * Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 *
 * @module Interpolations
 */ /**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $2358b7e4ec07df88$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $2358b7e4ec07df88$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $2358b7e4ec07df88$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $2358b7e4ec07df88$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $2358b7e4ec07df88$var$QuadraticBezier(t, p0, p1, p2) {
    return $2358b7e4ec07df88$var$QuadraticBezierP0(t, p0) + $2358b7e4ec07df88$var$QuadraticBezierP1(t, p1) + $2358b7e4ec07df88$var$QuadraticBezierP2(t, p2);
}
//
function $2358b7e4ec07df88$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $2358b7e4ec07df88$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $2358b7e4ec07df88$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $2358b7e4ec07df88$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $2358b7e4ec07df88$var$CubicBezier(t, p0, p1, p2, p3) {
    return $2358b7e4ec07df88$var$CubicBezierP0(t, p0) + $2358b7e4ec07df88$var$CubicBezierP1(t, p1) + $2358b7e4ec07df88$var$CubicBezierP2(t, p2) + $2358b7e4ec07df88$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$e36650d36468bb39 extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v1 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v2 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v3 = new $2358b7e4ec07df88$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($2358b7e4ec07df88$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $2358b7e4ec07df88$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$13d5f1c9525f246c extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v1 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v2 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v3 = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($2358b7e4ec07df88$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $2358b7e4ec07df88$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $2358b7e4ec07df88$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$ab2e07e76531a47e extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v2 = new $2358b7e4ec07df88$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$1fdfd9d9cf487600 extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v2 = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$5938c4ee491a43ad extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v1 = new $2358b7e4ec07df88$export$c977b3e384af9ae1(), v2 = new $2358b7e4ec07df88$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($2358b7e4ec07df88$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $2358b7e4ec07df88$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$bf3f4c7e459f90fc extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v1 = new $2358b7e4ec07df88$export$64b5c384219d3699(), v2 = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($2358b7e4ec07df88$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $2358b7e4ec07df88$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $2358b7e4ec07df88$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$d3bdd77da77afc1b extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $2358b7e4ec07df88$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($2358b7e4ec07df88$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $2358b7e4ec07df88$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $2358b7e4ec07df88$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $2358b7e4ec07df88$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $2358b7e4ec07df88$export$b9146b27c24b744c,
    CubicBezierCurve: $2358b7e4ec07df88$export$e36650d36468bb39,
    CubicBezierCurve3: $2358b7e4ec07df88$export$13d5f1c9525f246c,
    EllipseCurve: $2358b7e4ec07df88$export$3f87a931616cde04,
    LineCurve: $2358b7e4ec07df88$export$ab2e07e76531a47e,
    LineCurve3: $2358b7e4ec07df88$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $2358b7e4ec07df88$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $2358b7e4ec07df88$export$bf3f4c7e459f90fc,
    SplineCurve: $2358b7e4ec07df88$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $2358b7e4ec07df88$export$4aaf9b66af1bbf2c extends $2358b7e4ec07df88$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $2358b7e4ec07df88$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $2358b7e4ec07df88$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $2358b7e4ec07df88$export$4b2950bdac9b6ee9 extends $2358b7e4ec07df88$export$4aaf9b66af1bbf2c {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $2358b7e4ec07df88$export$ab2e07e76531a47e(this.currentPoint.clone(), new $2358b7e4ec07df88$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $2358b7e4ec07df88$export$5938c4ee491a43ad(this.currentPoint.clone(), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aCPx, aCPy), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $2358b7e4ec07df88$export$e36650d36468bb39(this.currentPoint.clone(), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aCP1x, aCP1y), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aCP2x, aCP2y), new $2358b7e4ec07df88$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $2358b7e4ec07df88$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $2358b7e4ec07df88$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $2358b7e4ec07df88$export$6428a7f2611ef1fa extends $2358b7e4ec07df88$export$4b2950bdac9b6ee9 {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $2358b7e4ec07df88$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.2
// https://github.com/mapbox/earcut/tree/v3.0.2
function $2358b7e4ec07df88$var$earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $2358b7e4ec07df88$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $2358b7e4ec07df88$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $2358b7e4ec07df88$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $2358b7e4ec07df88$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $2358b7e4ec07df88$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $2358b7e4ec07df88$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $2358b7e4ec07df88$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $2358b7e4ec07df88$var$equals(last, last.next)) {
        $2358b7e4ec07df88$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $2358b7e4ec07df88$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($2358b7e4ec07df88$var$equals(p, p.next) || $2358b7e4ec07df88$var$area(p.prev, p, p.next) === 0)) {
            $2358b7e4ec07df88$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $2358b7e4ec07df88$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $2358b7e4ec07df88$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $2358b7e4ec07df88$var$isEarHashed(ear, minX, minY, invSize) : $2358b7e4ec07df88$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $2358b7e4ec07df88$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $2358b7e4ec07df88$var$earcutLinked($2358b7e4ec07df88$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $2358b7e4ec07df88$var$cureLocalIntersections($2358b7e4ec07df88$var$filterPoints(ear), triangles);
                $2358b7e4ec07df88$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $2358b7e4ec07df88$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $2358b7e4ec07df88$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($2358b7e4ec07df88$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $2358b7e4ec07df88$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $2358b7e4ec07df88$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($2358b7e4ec07df88$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $2358b7e4ec07df88$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $2358b7e4ec07df88$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $2358b7e4ec07df88$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $2358b7e4ec07df88$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $2358b7e4ec07df88$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $2358b7e4ec07df88$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $2358b7e4ec07df88$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$2358b7e4ec07df88$var$equals(a, b) && $2358b7e4ec07df88$var$intersects(a, p, p.next, b) && $2358b7e4ec07df88$var$locallyInside(a, b) && $2358b7e4ec07df88$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $2358b7e4ec07df88$var$removeNode(p);
            $2358b7e4ec07df88$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $2358b7e4ec07df88$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $2358b7e4ec07df88$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $2358b7e4ec07df88$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $2358b7e4ec07df88$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $2358b7e4ec07df88$var$filterPoints(a, a.next);
                c = $2358b7e4ec07df88$var$filterPoints(c, c.next);
                // run earcut on each half
                $2358b7e4ec07df88$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $2358b7e4ec07df88$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $2358b7e4ec07df88$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $2358b7e4ec07df88$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($2358b7e4ec07df88$var$getLeftmost(list));
    }
    queue.sort($2358b7e4ec07df88$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $2358b7e4ec07df88$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $2358b7e4ec07df88$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $2358b7e4ec07df88$var$eliminateHole(hole, outerNode) {
    const bridge = $2358b7e4ec07df88$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $2358b7e4ec07df88$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $2358b7e4ec07df88$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $2358b7e4ec07df88$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $2358b7e4ec07df88$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($2358b7e4ec07df88$var$equals(hole, p)) return p;
    do {
        if ($2358b7e4ec07df88$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $2358b7e4ec07df88$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($2358b7e4ec07df88$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $2358b7e4ec07df88$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $2358b7e4ec07df88$var$sectorContainsSector(m, p) {
    return $2358b7e4ec07df88$var$area(m.prev, m, p.prev) < 0 && $2358b7e4ec07df88$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $2358b7e4ec07df88$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $2358b7e4ec07df88$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $2358b7e4ec07df88$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $2358b7e4ec07df88$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $2358b7e4ec07df88$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $2358b7e4ec07df88$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $2358b7e4ec07df88$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $2358b7e4ec07df88$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $2358b7e4ec07df88$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $2358b7e4ec07df88$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$2358b7e4ec07df88$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($2358b7e4ec07df88$var$locallyInside(a, b) && $2358b7e4ec07df88$var$locallyInside(b, a) && $2358b7e4ec07df88$var$middleInside(a, b) && // locally visible
    ($2358b7e4ec07df88$var$area(a.prev, a, b.prev) || $2358b7e4ec07df88$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $2358b7e4ec07df88$var$equals(a, b) && $2358b7e4ec07df88$var$area(a.prev, a, a.next) > 0 && $2358b7e4ec07df88$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $2358b7e4ec07df88$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $2358b7e4ec07df88$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $2358b7e4ec07df88$var$intersects(p1, q1, p2, q2) {
    const o1 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p1, q1, p2));
    const o2 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p1, q1, q2));
    const o3 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p2, q2, p1));
    const o4 = $2358b7e4ec07df88$var$sign($2358b7e4ec07df88$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $2358b7e4ec07df88$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $2358b7e4ec07df88$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $2358b7e4ec07df88$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $2358b7e4ec07df88$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $2358b7e4ec07df88$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $2358b7e4ec07df88$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $2358b7e4ec07df88$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $2358b7e4ec07df88$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $2358b7e4ec07df88$var$locallyInside(a, b) {
    return $2358b7e4ec07df88$var$area(a.prev, a, a.next) < 0 ? $2358b7e4ec07df88$var$area(a, b, a.next) >= 0 && $2358b7e4ec07df88$var$area(a, a.prev, b) >= 0 : $2358b7e4ec07df88$var$area(a, b, a.prev) < 0 || $2358b7e4ec07df88$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $2358b7e4ec07df88$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $2358b7e4ec07df88$var$splitPolygon(a, b) {
    const a2 = $2358b7e4ec07df88$var$createNode(a.i, a.x, a.y), b2 = $2358b7e4ec07df88$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $2358b7e4ec07df88$var$insertNode(i, x, y, last) {
    const p = $2358b7e4ec07df88$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $2358b7e4ec07df88$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $2358b7e4ec07df88$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $2358b7e4ec07df88$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
/**
 * An implementation of the earcut polygon triangulation algorithm.
 * The code is a port of [mapbox/earcut](https://github.com/mapbox/earcut).
 *
 * @see https://github.com/mapbox/earcut
 */ class $2358b7e4ec07df88$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return $2358b7e4ec07df88$var$earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $2358b7e4ec07df88$var$removeDupEndPts(contour);
        $2358b7e4ec07df88$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($2358b7e4ec07df88$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $2358b7e4ec07df88$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $2358b7e4ec07df88$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $2358b7e4ec07df88$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $2358b7e4ec07df88$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ExtrudeGeometry
 */ class $2358b7e4ec07df88$export$598697a1efa63ca7 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new $2358b7e4ec07df88$export$6428a7f2611ef1fa([
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(-0.5, 0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(-0.5, -0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $2358b7e4ec07df88$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $2358b7e4ec07df88$export$64b5c384219d3699();
                normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
                position2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) $2358b7e4ec07df88$export$a3bc9b8ed74fc('ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $2358b7e4ec07df88$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $2358b7e4ec07df88$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            let faces;
            if (bevelSegments === 0) faces = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.triangulateShape(contour, holes);
            else {
                const contractedContourVertices = [];
                const expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(let b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    const t = b / bevelSegments;
                    const z = bevelThickness * Math.cos(t * Math.PI / 2);
                    const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(let i = 0, il = contour.length; i < il; i++){
                        const vert = scalePt2(contour[i], contourMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(let h = 0, hl = numHoles; h < hl; h++){
                        const ahole = holes[h];
                        oneHoleMovements = holesMovements[h];
                        const oneHoleVertices = [];
                        for(let i = 0, il = ahole.length; i < il; i++){
                            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                            v(vert.x, vert.y, -z);
                            if (t === 0) oneHoleVertices.push(vert);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $2358b7e4ec07df88$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $2358b7e4ec07df88$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $2358b7e4ec07df88$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $2358b7e4ec07df88$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(a_x, a_y),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(b_x, b_y),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $2358b7e4ec07df88$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $2358b7e4ec07df88$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#IcosahedronGeometry
 */ class $2358b7e4ec07df88$export$9567cc828c9535da extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$9567cc828c9535da(data.radius, data.detail);
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#LatheGeometry
 */ class $2358b7e4ec07df88$export$6d839803fcd1882c extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, -0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, 0),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $2358b7e4ec07df88$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const curNormal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const prevNormal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#OctahedronGeometry
 */ class $2358b7e4ec07df88$export$1954e2b809fe361e extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#PlaneGeometry
 */ class $2358b7e4ec07df88$export$967d831af31f69ce extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#RingGeometry
 */ class $2358b7e4ec07df88$export$68cb731f50f614af extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ShapeGeometry
 */ class $2358b7e4ec07df88$export$57a29a1c803e9065 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $2358b7e4ec07df88$export$6428a7f2611ef1fa([
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0, 0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(-0.5, -0.5),
        new $2358b7e4ec07df88$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $2358b7e4ec07df88$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $2358b7e4ec07df88$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $2358b7e4ec07df88$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#SphereGeometry
 */ class $2358b7e4ec07df88$export$1b417fc3b307a251 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#TetrahedronGeometry
 */ class $2358b7e4ec07df88$export$fb3f7adc68bd6e02 extends $2358b7e4ec07df88$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusGeometry
 */ class $2358b7e4ec07df88$export$a2312a2a1fa56495 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusKnotGeometry
 */ class $2358b7e4ec07df88$export$77e9bfadfb9ab8c8 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const P1 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const P2 = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const B = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const T = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const N = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $2358b7e4ec07df88$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TubeGeometry
 */ class $2358b7e4ec07df88$export$7897d9d48904490c extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $2358b7e4ec07df88$export$bf3f4c7e459f90fc(new $2358b7e4ec07df88$export$64b5c384219d3699(-1, -1, 0), new $2358b7e4ec07df88$export$64b5c384219d3699(-1, 1, 0), new $2358b7e4ec07df88$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const normal = new $2358b7e4ec07df88$export$64b5c384219d3699();
        const uv = new $2358b7e4ec07df88$export$c977b3e384af9ae1();
        let P = new $2358b7e4ec07df88$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $2358b7e4ec07df88$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $2358b7e4ec07df88$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $2358b7e4ec07df88$export$7897d9d48904490c(new $2358b7e4ec07df88$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $2358b7e4ec07df88$export$4b739da06d24892b extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $2358b7e4ec07df88$export$64b5c384219d3699();
            const end = new $2358b7e4ec07df88$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($2358b7e4ec07df88$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($2358b7e4ec07df88$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $2358b7e4ec07df88$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $2358b7e4ec07df88$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $2358b7e4ec07df88$export$33e43285f7406bd5,
    CapsuleGeometry: $2358b7e4ec07df88$export$41680e8551036033,
    CircleGeometry: $2358b7e4ec07df88$export$d5c0e8d607467193,
    ConeGeometry: $2358b7e4ec07df88$export$a7a48974f285c9b3,
    CylinderGeometry: $2358b7e4ec07df88$export$68f745719dbe5198,
    DodecahedronGeometry: $2358b7e4ec07df88$export$c0babfeb8708fc9c,
    EdgesGeometry: $2358b7e4ec07df88$export$4730b1542707547f,
    ExtrudeGeometry: $2358b7e4ec07df88$export$598697a1efa63ca7,
    IcosahedronGeometry: $2358b7e4ec07df88$export$9567cc828c9535da,
    LatheGeometry: $2358b7e4ec07df88$export$6d839803fcd1882c,
    OctahedronGeometry: $2358b7e4ec07df88$export$1954e2b809fe361e,
    PlaneGeometry: $2358b7e4ec07df88$export$967d831af31f69ce,
    PolyhedronGeometry: $2358b7e4ec07df88$export$60e57a7d3f20ff65,
    RingGeometry: $2358b7e4ec07df88$export$68cb731f50f614af,
    ShapeGeometry: $2358b7e4ec07df88$export$57a29a1c803e9065,
    SphereGeometry: $2358b7e4ec07df88$export$1b417fc3b307a251,
    TetrahedronGeometry: $2358b7e4ec07df88$export$fb3f7adc68bd6e02,
    TorusGeometry: $2358b7e4ec07df88$export$a2312a2a1fa56495,
    TorusKnotGeometry: $2358b7e4ec07df88$export$77e9bfadfb9ab8c8,
    TubeGeometry: $2358b7e4ec07df88$export$7897d9d48904490c,
    WireframeGeometry: $2358b7e4ec07df88$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$e8564da406055a3 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class $2358b7e4ec07df88$export$21c421a2e1df9d22 extends $2358b7e4ec07df88$export$83c7d75d550a8b0d {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity](https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/),
 * [Unreal](https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/) and
 * [3D Studio Max](http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017).
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset](https://www.marmoset.co):
 *
 * - [Basic Theory of Physically Based Rendering](https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/)
 * - [Physically Based Rendering and You Can Too](https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/)
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney](https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf)
 * (pdf), by Brent Burley.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshStandardMaterial
 */ class $2358b7e4ec07df88$export$f2980790215acccd extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 * @demo scenes/material-browser.html#MeshPhysicalMaterial
 */ class $2358b7e4ec07df88$export$28d04986c4269c9f extends $2358b7e4ec07df88$export$f2980790215acccd {
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $2358b7e4ec07df88$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new $2358b7e4ec07df88$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new $2358b7e4ec07df88$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    /**
	 * The anisotropy strength, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong](https://en.wikipedia.org/wiki/Blinn-Phong_shading_model)
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshPhongMaterial
 */ class $2358b7e4ec07df88$export$24c72f71cbaf0678 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new $2358b7e4ec07df88$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $2358b7e4ec07df88$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshToonMaterial
 */ class $2358b7e4ec07df88$export$df893cf97e765622 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshNormalMaterial
 */ class $2358b7e4ec07df88$export$bfe8c0a091f41ae7 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian](https://en.wikipedia.org/wiki/Lambertian_reflectance)
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshLambertMaterial
 */ class $2358b7e4ec07df88$export$5023a9a8114806b8 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $2358b7e4ec07df88$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $2358b7e4ec07df88$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $2358b7e4ec07df88$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshDepthMaterial
 */ class $2358b7e4ec07df88$export$2698c22ec13825db extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = $2358b7e4ec07df88$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do not cast shadows.
 *
 * @augments Material
 */ class $2358b7e4ec07df88$export$33e187ed002f2a19 extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshMatcapMaterial
 */ class $2358b7e4ec07df88$export$6f5fef6235ec12ee extends $2358b7e4ec07df88$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $2358b7e4ec07df88$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class $2358b7e4ec07df88$export$327886a3efaeaebe extends $2358b7e4ec07df88$export$fbaaa33907730a0c {
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $2358b7e4ec07df88$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} object - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $2358b7e4ec07df88$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $2358b7e4ec07df88$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $2358b7e4ec07df88$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $2358b7e4ec07df88$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $2358b7e4ec07df88$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $2358b7e4ec07df88$var$convertArray(times, track.times.constructor);
        track.values = $2358b7e4ec07df88$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $2358b7e4ec07df88$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $2358b7e4ec07df88$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $2358b7e4ec07df88$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $2358b7e4ec07df88$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$7ee8caa573e71ad1 {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return $2358b7e4ec07df88$var$convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return $2358b7e4ec07df88$var$isTypedArray(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return $2358b7e4ec07df88$var$getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return $2358b7e4ec07df88$var$sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        $2358b7e4ec07df88$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return $2358b7e4ec07df88$var$subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return $2358b7e4ec07df88$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$3646682e7a3959 extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $2358b7e4ec07df88$export$7f795934b84ab523,
            endingEnd: $2358b7e4ec07df88$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $2358b7e4ec07df88$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $2358b7e4ec07df88$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$a8e6009059f51e1a extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$fb9758ef7ef8d5cc extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
/**
 * Represents s a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number|string|boolean>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $2358b7e4ec07df88$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $2358b7e4ec07df88$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $2358b7e4ec07df88$var$convertArray(track.times, Array),
                'values': $2358b7e4ec07df88$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new $2358b7e4ec07df88$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $2358b7e4ec07df88$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new $2358b7e4ec07df88$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $2358b7e4ec07df88$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $2358b7e4ec07df88$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $2358b7e4ec07df88$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $2358b7e4ec07df88$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $2358b7e4ec07df88$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $2358b7e4ec07df88$export$198b11ff4c72bb30;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($2358b7e4ec07df88$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $2358b7e4ec07df88$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default ''
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateLinear
 */ $2358b7e4ec07df88$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $2358b7e4ec07df88$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$d3a344b98cf0b775 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<boolean>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'bool'
 */ $2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $2358b7e4ec07df88$export$995b32462a65e855;
$2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$2358b7e4ec07df88$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$83444c5d885347d8 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'color'
 */ $2358b7e4ec07df88$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$d45f0d1a4d9a9314 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'number'
 */ $2358b7e4ec07df88$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $2358b7e4ec07df88$export$2db1cfb7923d931e extends $2358b7e4ec07df88$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$2358b7e4ec07df88$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$b8043f12b5aafbd7 extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $2358b7e4ec07df88$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'quaternion'
 */ $2358b7e4ec07df88$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$2358b7e4ec07df88$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$6ce41d4f3a8df9cd extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<string>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'string'
 */ $2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $2358b7e4ec07df88$export$995b32462a65e855;
$2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$2358b7e4ec07df88$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff extends $2358b7e4ec07df88$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'vector'
 */ $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class $2358b7e4ec07df88$export$d942c706bf23829c {
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        /**
		 * An object that can be used to store custom data about the animation clip.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($2358b7e4ec07df88$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        clip.userData = JSON.parse(json.userData || '{}');
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode,
            'userData': JSON.stringify(clip.userData)
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($2358b7e4ec07df88$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $2358b7e4ec07df88$var$getKeyframeOrder(times);
            times = $2358b7e4ec07df88$var$sortedArray(times, 1, order);
            values = $2358b7e4ec07df88$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $2358b7e4ec07df88$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bones>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        $2358b7e4ec07df88$export$c106dd0671a0fc2d('AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $2358b7e4ec07df88$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $2358b7e4ec07df88$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($2358b7e4ec07df88$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($2358b7e4ec07df88$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($2358b7e4ec07df88$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        const clip = new this.constructor(this.name, this.duration, tracks, this.blendMode);
        clip.userData = JSON.parse(JSON.stringify(this.userData));
        return clip;
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $2358b7e4ec07df88$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $2358b7e4ec07df88$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $2358b7e4ec07df88$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $2358b7e4ec07df88$export$83444c5d885347d8;
        case 'quaternion':
            return $2358b7e4ec07df88$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $2358b7e4ec07df88$export$d3a344b98cf0b775;
        case 'string':
            return $2358b7e4ec07df88$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $2358b7e4ec07df88$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $2358b7e4ec07df88$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $2358b7e4ec07df88$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const $2358b7e4ec07df88$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        // log( 'Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        // log( 'Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class $2358b7e4ec07df88$export$99cc795e99919eed {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * Used for aborting ongoing requests in loaders using this manager.
		 *
		 * @private
		 * @type {AbortController | null}
		 */ this._abortController = null;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
        /**
		 * Can be used to abort ongoing loading requests in loaders using this manager.
		 * The abort only works if the loaders implement {@link Loader#abort} and `AbortSignal.any()`
		 * is supported in the browser.
		 *
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.abort = function() {
            this.abortController.abort();
            this._abortController = null;
            return this;
        };
    }
    // TODO: Revert this back to a single member variable once this issue has been fixed
    // https://github.com/cloudflare/workerd/issues/3657
    /**
	 * Used for aborting ongoing requests in loaders using this manager.
	 *
	 * @type {AbortController}
	 */ get abortController() {
        if (!this._abortController) this._abortController = new AbortController();
        return this._abortController;
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const $2358b7e4ec07df88$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $2358b7e4ec07df88$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $2358b7e4ec07df88$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @abstract
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @abstract
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    /**
	 * This method can be implemented in loaders for aborting ongoing requests.
	 *
	 * @abstract
	 * @return {Loader} A reference to this instance.
	 */ abort() {
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $2358b7e4ec07df88$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $2358b7e4ec07df88$var$loading = {};
class $2358b7e4ec07df88$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$98435a25b5cf7b2b extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type. Valid values can be found
		 * [here](hhttps://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#mimetype)
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $2358b7e4ec07df88$export$94affb487e701bf2.get(`file:${url}`);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($2358b7e4ec07df88$var$loading[url] !== undefined) {
            $2358b7e4ec07df88$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $2358b7e4ec07df88$var$loading[url] = [];
        $2358b7e4ec07df88$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin',
            signal: typeof AbortSignal.any === 'function' ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) $2358b7e4ec07df88$export$c106dd0671a0fc2d('FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $2358b7e4ec07df88$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $2358b7e4ec07df88$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $2358b7e4ec07df88$export$94affb487e701bf2.add(`file:${url}`, data);
            const callbacks = $2358b7e4ec07df88$var$loading[url];
            delete $2358b7e4ec07df88$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $2358b7e4ec07df88$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $2358b7e4ec07df88$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {FileLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$29711c7e14f61db extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $2358b7e4ec07df88$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $2358b7e4ec07df88$export$bd73ce947a280350 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $2358b7e4ec07df88$export$3466bac9141a5cc4();
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
const $2358b7e4ec07df88$var$_loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639).
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$8905ce1c7a2464a1 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $2358b7e4ec07df88$export$94affb487e701bf2.get(`image:${url}`);
        if (cached !== undefined) {
            if (cached.complete === true) {
                scope.manager.itemStart(url);
                setTimeout(function() {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                }, 0);
            } else {
                let arr = $2358b7e4ec07df88$var$_loading.get(cached);
                if (arr === undefined) {
                    arr = [];
                    $2358b7e4ec07df88$var$_loading.set(cached, arr);
                }
                arr.push({
                    onLoad: onLoad,
                    onError: onError
                });
            }
            return cached;
        }
        const image = $2358b7e4ec07df88$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            if (onLoad) onLoad(this);
            //
            const callbacks = $2358b7e4ec07df88$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(this);
            }
            $2358b7e4ec07df88$var$_loading.delete(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            $2358b7e4ec07df88$export$94affb487e701bf2.remove(`image:${url}`);
            //
            const callbacks = $2358b7e4ec07df88$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(event);
            }
            $2358b7e4ec07df88$var$_loading.delete(this);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        $2358b7e4ec07df88$export$94affb487e701bf2.add(`image:${url}`, image);
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$2ec114afc2cf6308 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new $2358b7e4ec07df88$export$ee2e5a18258a4049();
        texture.colorSpace = $2358b7e4ec07df88$export$561f394b24edfcaa;
        const loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $2358b7e4ec07df88$export$792d8a18f2c55855 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $2358b7e4ec07df88$export$b691f601014eabe1();
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $2358b7e4ec07df88$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $2358b7e4ec07df88$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $2358b7e4ec07df88$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $2358b7e4ec07df88$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $2358b7e4ec07df88$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $2358b7e4ec07df88$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145).
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$fd1bfc71f64c538c extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new $2358b7e4ec07df88$export$5431306cf43de24a();
        const loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$6ecadb6ed240d696 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$8d474f55edbb9624 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $2358b7e4ec07df88$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $2358b7e4ec07df88$var$_projScreenMatrix$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_lightPositionWorld$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_lookTarget$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `PCFSoftShadowMap` and
		 * and it is recommended to increase softness by decreasing the shadow map size instead.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $2358b7e4ec07df88$export$c977b3e384af9ae1(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = $2358b7e4ec07df88$export$2e8ce08d3f6f5e10;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $2358b7e4ec07df88$export$35efe6f4c85463d2();
        this._frameExtents = new $2358b7e4ec07df88$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $2358b7e4ec07df88$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($2358b7e4ec07df88$var$_lightPositionWorld$1);
        $2358b7e4ec07df88$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($2358b7e4ec07df88$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $2358b7e4ec07df88$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix$1, shadowCamera.coordinateSystem, shadowCamera.reversedDepth);
        if (shadowCamera.reversedDepth) shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        else shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($2358b7e4ec07df88$var$_projScreenMatrix$1);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $2358b7e4ec07df88$var$SpotLightShadow extends $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $2358b7e4ec07df88$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $2358b7e4ec07df88$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height * this.aspect;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$81495cbb73897362 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $2358b7e4ec07df88$var$SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $2358b7e4ec07df88$var$_projScreenMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_lightPositionWorld = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_lookTarget = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $2358b7e4ec07df88$var$PointLightShadow extends $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $2358b7e4ec07df88$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
        this._frameExtents = new $2358b7e4ec07df88$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $2358b7e4ec07df88$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $2358b7e4ec07df88$export$64b5c384219d3699(1, 0, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(-1, 0, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 1),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, -1),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 1, 0),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 1),
            new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 * @param {number} [viewportIndex=0] - The viewport index.
	 */ updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $2358b7e4ec07df88$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($2358b7e4ec07df88$var$_lightPositionWorld);
        $2358b7e4ec07df88$var$_lookTarget.copy(camera.position);
        $2358b7e4ec07df88$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($2358b7e4ec07df88$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$2358b7e4ec07df88$var$_lightPositionWorld.x, -$2358b7e4ec07df88$var$_lightPositionWorld.y, -$2358b7e4ec07df88$var$_lightPositionWorld.z);
        $2358b7e4ec07df88$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($2358b7e4ec07df88$var$_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$4c9c1cb3f0b6f455 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $2358b7e4ec07df88$var$PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
/**
 * Camera that uses [orthographic projection](https://en.wikipedia.org/wiki/Orthographic_projection).
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $2358b7e4ec07df88$export$9ebf355ee4ed261b extends $2358b7e4ec07df88$export$79f141de891a5fed {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $2358b7e4ec07df88$var$DirectionalLightShadow extends $2358b7e4ec07df88$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $2358b7e4ec07df88$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$3fea33cc9972c868 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($2358b7e4ec07df88$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $2358b7e4ec07df88$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$af279bfef9ec2c96 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$61db2d908bbd2429 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $2358b7e4ec07df88$export$ba61ce607e1f405a {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $2358b7e4ec07df88$export$64b5c384219d3699());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $2358b7e4ec07df88$export$e7ef036e309b38d2 extends $2358b7e4ec07df88$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $2358b7e4ec07df88$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    /**
	 * Deserializes the light prove from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized light probe.
	 * @return {LightProbe} A reference to this light probe.
	 */ fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$3bd6d323353dcf96 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $2358b7e4ec07df88$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $2358b7e4ec07df88$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $2358b7e4ec07df88$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return $2358b7e4ec07df88$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $2358b7e4ec07df88$export$e8564da406055a3,
            SpriteMaterial: $2358b7e4ec07df88$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $2358b7e4ec07df88$export$21c421a2e1df9d22,
            ShaderMaterial: $2358b7e4ec07df88$export$83c7d75d550a8b0d,
            PointsMaterial: $2358b7e4ec07df88$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $2358b7e4ec07df88$export$28d04986c4269c9f,
            MeshStandardMaterial: $2358b7e4ec07df88$export$f2980790215acccd,
            MeshPhongMaterial: $2358b7e4ec07df88$export$24c72f71cbaf0678,
            MeshToonMaterial: $2358b7e4ec07df88$export$df893cf97e765622,
            MeshNormalMaterial: $2358b7e4ec07df88$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $2358b7e4ec07df88$export$5023a9a8114806b8,
            MeshDepthMaterial: $2358b7e4ec07df88$export$2698c22ec13825db,
            MeshDistanceMaterial: $2358b7e4ec07df88$export$33e187ed002f2a19,
            MeshBasicMaterial: $2358b7e4ec07df88$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $2358b7e4ec07df88$export$6f5fef6235ec12ee,
            LineDashedMaterial: $2358b7e4ec07df88$export$327886a3efaeaebe,
            LineBasicMaterial: $2358b7e4ec07df88$export$fbaaa33907730a0c,
            Material: $2358b7e4ec07df88$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
/**
 * A class with loader utility functions.
 */ class $2358b7e4ec07df88$export$b5d2dc08d867e41a {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class $2358b7e4ec07df88$export$231f009cbe414146 extends $2358b7e4ec07df88$export$b7be63a67df8959 {
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$dc275bb96327833a extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $2358b7e4ec07df88$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $2358b7e4ec07df88$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $2358b7e4ec07df88$export$231f009cbe414146() : new $2358b7e4ec07df88$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $2358b7e4ec07df88$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $2358b7e4ec07df88$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $2358b7e4ec07df88$export$32ea87a8b54d744a : $2358b7e4ec07df88$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $2358b7e4ec07df88$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $2358b7e4ec07df88$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $2358b7e4ec07df88$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) geometry.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba().fromJSON(boundingSphere);
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format](https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4).
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$40110c8505c5ad19 extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $2358b7e4ec07df88$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                error('ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                $2358b7e4ec07df88$export$a3bc9b8ed74fc('ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $2358b7e4ec07df88$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $2358b7e4ec07df88$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $2358b7e4ec07df88$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $2358b7e4ec07df88$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $2358b7e4ec07df88$var$Geometries) geometry = $2358b7e4ec07df88$var$Geometries[data.type].fromJSON(data, shapes);
                        else $2358b7e4ec07df88$export$c106dd0671a0fc2d(`ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $2358b7e4ec07df88$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $2358b7e4ec07df88$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $2358b7e4ec07df88$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $2358b7e4ec07df88$export$99cc795e99919eed(onLoad);
            loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $2358b7e4ec07df88$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $2358b7e4ec07df88$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $2358b7e4ec07df88$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $2358b7e4ec07df88$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $2358b7e4ec07df88$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $2358b7e4ec07df88$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $2358b7e4ec07df88$export$b691f601014eabe1();
                else texture = new $2358b7e4ec07df88$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $2358b7e4ec07df88$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $2358b7e4ec07df88$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $2358b7e4ec07df88$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $2358b7e4ec07df88$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $2358b7e4ec07df88$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $2358b7e4ec07df88$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $2358b7e4ec07df88$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $2358b7e4ec07df88$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $2358b7e4ec07df88$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $2358b7e4ec07df88$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $2358b7e4ec07df88$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $2358b7e4ec07df88$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $2358b7e4ec07df88$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $2358b7e4ec07df88$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $2358b7e4ec07df88$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $2358b7e4ec07df88$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $2358b7e4ec07df88$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $2358b7e4ec07df88$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $2358b7e4ec07df88$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $2358b7e4ec07df88$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $2358b7e4ec07df88$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $2358b7e4ec07df88$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $2358b7e4ec07df88$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._geometryInfo = data.geometryInfo.map((info)=>{
                    let box = null;
                    let sphere = null;
                    if (info.boundingBox !== undefined) box = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3().fromJSON(info.boundingBox);
                    if (info.boundingSphere !== undefined) sphere = new $2358b7e4ec07df88$export$805e8b72413ccaba().fromJSON(info.boundingSphere);
                    return {
                        ...info,
                        boundingBox: box,
                        boundingSphere: sphere
                    };
                });
                object._instanceInfo = data.instanceInfo;
                object._availableInstanceIds = data._availableInstanceIds;
                object._availableGeometryIds = data._availableGeometryIds;
                object._nextIndexStart = data.nextIndexStart;
                object._nextVertexStart = data.nextVertexStart;
                object._geometryCount = data.geometryCount;
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                object._indirectTexture = getTexture(data.indirectTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                if (data.boundingSphere !== undefined) object.boundingSphere = new $2358b7e4ec07df88$export$805e8b72413ccaba().fromJSON(data.boundingSphere);
                if (data.boundingBox !== undefined) object.boundingBox = new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3().fromJSON(data.boundingBox);
                break;
            case 'LOD':
                object = new $2358b7e4ec07df88$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $2358b7e4ec07df88$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $2358b7e4ec07df88$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $2358b7e4ec07df88$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $2358b7e4ec07df88$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $2358b7e4ec07df88$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $2358b7e4ec07df88$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $2358b7e4ec07df88$export$b127726e56765aa4();
                break;
            default:
                object = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) $2358b7e4ec07df88$export$c106dd0671a0fc2d('ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $2358b7e4ec07df88$export$e4dd07dff30cc924();
            }
        });
    }
}
const $2358b7e4ec07df88$var$TEXTURE_MAPPING = {
    UVMapping: $2358b7e4ec07df88$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $2358b7e4ec07df88$export$8759762a6477f2c4,
    CubeRefractionMapping: $2358b7e4ec07df88$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $2358b7e4ec07df88$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $2358b7e4ec07df88$export$ee99d97d46898098,
    CubeUVReflectionMapping: $2358b7e4ec07df88$export$dbf3e70ff37af79
};
const $2358b7e4ec07df88$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $2358b7e4ec07df88$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $2358b7e4ec07df88$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $2358b7e4ec07df88$export$c7e7c00b14f51a4f
};
const $2358b7e4ec07df88$var$TEXTURE_FILTER = {
    NearestFilter: $2358b7e4ec07df88$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $2358b7e4ec07df88$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $2358b7e4ec07df88$export$d2327c1afe5bfdf2,
    LinearFilter: $2358b7e4ec07df88$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $2358b7e4ec07df88$export$19a719f377145a13,
    LinearMipmapLinearFilter: $2358b7e4ec07df88$export$5d8599b6a933fb1b
};
const $2358b7e4ec07df88$var$_errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap).
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * They needs these configuration on bitmap creation unlike regular images need them on uploading to GPU.
 *
 * You need to set the equivalent options via {@link ImageBitmapLoader#setOptions} instead.
 *
 * Also note that unlike {@link FileLoader}, this loader avoids multiple concurrent requests to the same URL only if `Cache` is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$52286b55c4a9b51f extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') $2358b7e4ec07df88$export$c106dd0671a0fc2d('ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') $2358b7e4ec07df88$export$c106dd0671a0fc2d('ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap).
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $2358b7e4ec07df88$export$94affb487e701bf2.get(`image-bitmap:${url}`);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    // check if there is an error for the cached promise
                    if ($2358b7e4ec07df88$var$_errorMap.has(cached) === true) {
                        if (onError) onError($2358b7e4ec07df88$var$_errorMap.get(cached));
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    } else {
                        if (onLoad) onLoad(imageBitmap);
                        scope.manager.itemEnd(url);
                        return imageBitmap;
                    }
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetchOptions.signal = typeof AbortSignal.any === 'function' ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $2358b7e4ec07df88$export$94affb487e701bf2.add(`image-bitmap:${url}`, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $2358b7e4ec07df88$var$_errorMap.set(promise, e);
            $2358b7e4ec07df88$export$94affb487e701bf2.remove(`image-bitmap:${url}`);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $2358b7e4ec07df88$export$94affb487e701bf2.add(`image-bitmap:${url}`, promise);
        scope.manager.itemStart(url);
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {ImageBitmapLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
let $2358b7e4ec07df88$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if ($2358b7e4ec07df88$var$_context === undefined) $2358b7e4ec07df88$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $2358b7e4ec07df88$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $2358b7e4ec07df88$var$_context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class $2358b7e4ec07df88$export$d8d5fccfbf47714e extends $2358b7e4ec07df88$export$3b0d6d7590275603 {
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $2358b7e4ec07df88$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $2358b7e4ec07df88$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else $2358b7e4ec07df88$export$a3bc9b8ed74fc(e);
            scope.manager.itemError(url);
        }
    }
}
const $2358b7e4ec07df88$var$_eyeRight = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_eyeLeft = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_projectionMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph](https://en.wikipedia.org/wiki/Anaglyph_3D) or
 * [Parallax Barrier](https://en.wikipedia.org/wiki/parallax_barrier).
 */ class $2358b7e4ec07df88$export$bc7f73a1065bee0c {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $2358b7e4ec07df88$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $2358b7e4ec07df88$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $2358b7e4ec07df88$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($2358b7e4ec07df88$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $2358b7e4ec07df88$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $2358b7e4ec07df88$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $2358b7e4ec07df88$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $2358b7e4ec07df88$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($2358b7e4ec07df88$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $2358b7e4ec07df88$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $2358b7e4ec07df88$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($2358b7e4ec07df88$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($2358b7e4ec07df88$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($2358b7e4ec07df88$var$_eyeRight);
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $2358b7e4ec07df88$export$56b937d9e5581166 extends $2358b7e4ec07df88$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
    }
}
/**
 * Class for keeping track of time.
 */ class $2358b7e4ec07df88$export$9735c82c4bae3302 {
    /**
	 * Constructs a new clock.
	 *
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
    }
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = performance.now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
const $2358b7e4ec07df88$var$_position$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_scale$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_forward = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_up = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$8a1b810c6fde8951 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $2358b7e4ec07df88$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._clock = new $2358b7e4ec07df88$export$9735c82c4bae3302();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position$1, $2358b7e4ec07df88$var$_quaternion$1, $2358b7e4ec07df88$var$_scale$1);
        // the initial forward and up directions must be orthogonal
        $2358b7e4ec07df88$var$_forward.set(0, 0, -1).applyQuaternion($2358b7e4ec07df88$var$_quaternion$1);
        $2358b7e4ec07df88$var$_up.set(0, 1, 0).applyQuaternion($2358b7e4ec07df88$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($2358b7e4ec07df88$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($2358b7e4ec07df88$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($2358b7e4ec07df88$var$_forward.x, endTime);
            listener.forwardY.linearRampToValueAtTime($2358b7e4ec07df88$var$_forward.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_forward.z, endTime);
            listener.upX.linearRampToValueAtTime($2358b7e4ec07df88$var$_up.x, endTime);
            listener.upY.linearRampToValueAtTime($2358b7e4ec07df88$var$_up.y, endTime);
            listener.upZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_up.z, endTime);
        } else {
            listener.setPosition($2358b7e4ec07df88$var$_position$1.x, $2358b7e4ec07df88$var$_position$1.y, $2358b7e4ec07df88$var$_position$1.z);
            listener.setOrientation($2358b7e4ec07df88$var$_forward.x, $2358b7e4ec07df88$var$_forward.y, $2358b7e4ec07df88$var$_forward.z, $2358b7e4ec07df88$var$_up.x, $2358b7e4ec07df88$var$_up.y, $2358b7e4ec07df88$var$_up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API](https://www.w3.org/TR/webaudio-1.1/).
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$153755f98d9861de extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $2358b7e4ec07df88$var$_position = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_quaternion = /*@__PURE__*/ new $2358b7e4ec07df88$export$23d6a54f0bbc85a3();
const $2358b7e4ec07df88$var$_scale = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_orientation = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $2358b7e4ec07df88$export$4b3e397ef1832507 extends $2358b7e4ec07df88$export$153755f98d9861de {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec](https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype)
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($2358b7e4ec07df88$var$_position, $2358b7e4ec07df88$var$_quaternion, $2358b7e4ec07df88$var$_scale);
        $2358b7e4ec07df88$var$_orientation.set(0, 0, 1).applyQuaternion($2358b7e4ec07df88$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($2358b7e4ec07df88$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($2358b7e4ec07df88$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($2358b7e4ec07df88$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($2358b7e4ec07df88$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($2358b7e4ec07df88$var$_orientation.z, endTime);
        } else {
            panner.setPosition($2358b7e4ec07df88$var$_position.x, $2358b7e4ec07df88$var$_position.y, $2358b7e4ec07df88$var$_position.z);
            panner.setOrientation($2358b7e4ec07df88$var$_orientation.x, $2358b7e4ec07df88$var$_orientation.y, $2358b7e4ec07df88$var$_orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $2358b7e4ec07df88$export$d47da1ef3d382827 {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class $2358b7e4ec07df88$export$dfe0af1ca1acb78a {
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $2358b7e4ec07df88$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $2358b7e4ec07df88$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $2358b7e4ec07df88$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $2358b7e4ec07df88$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $2358b7e4ec07df88$var$_reservedRe = new RegExp('[' + $2358b7e4ec07df88$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $2358b7e4ec07df88$var$_wordChar = '[^' + $2358b7e4ec07df88$var$_RESERVED_CHARS_RE + ']';
const $2358b7e4ec07df88$var$_wordCharOrDot = '[^' + $2358b7e4ec07df88$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $2358b7e4ec07df88$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $2358b7e4ec07df88$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $2358b7e4ec07df88$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $2358b7e4ec07df88$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $2358b7e4ec07df88$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $2358b7e4ec07df88$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $2358b7e4ec07df88$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $2358b7e4ec07df88$var$_wordChar);
const $2358b7e4ec07df88$var$_trackRe = new RegExp("^" + $2358b7e4ec07df88$var$_directoryRe + $2358b7e4ec07df88$var$_nodeRe + $2358b7e4ec07df88$var$_objectRe + $2358b7e4ec07df88$var$_propertyRe + '$');
const $2358b7e4ec07df88$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $2358b7e4ec07df88$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $2358b7e4ec07df88$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class $2358b7e4ec07df88$export$7bf70fcf9f891893 {
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || $2358b7e4ec07df88$export$7bf70fcf9f891893.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = $2358b7e4ec07df88$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $2358b7e4ec07df88$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $2358b7e4ec07df88$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($2358b7e4ec07df88$var$_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = $2358b7e4ec07df88$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($2358b7e4ec07df88$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $2358b7e4ec07df88$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    $2358b7e4ec07df88$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$2358b7e4ec07df88$export$7bf70fcf9f891893.Composite = $2358b7e4ec07df88$var$Composite;
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_direct,
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_array,
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$2358b7e4ec07df88$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_direct,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_array,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $2358b7e4ec07df88$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class $2358b7e4ec07df88$export$30619c2afd3f34db {
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $2358b7e4ec07df88$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $2358b7e4ec07df88$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $2358b7e4ec07df88$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) $2358b7e4ec07df88$export$a3bc9b8ed74fc("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $2358b7e4ec07df88$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class $2358b7e4ec07df88$export$6946940a69e799e {
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $2358b7e4ec07df88$export$7f795934b84ab523,
            endingEnd: $2358b7e4ec07df88$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $2358b7e4ec07df88$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $2358b7e4ec07df88$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $2358b7e4ec07df88$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $2358b7e4ec07df88$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $2358b7e4ec07df88$export$24a4ccb5099273b5;
            settings.endingEnd = $2358b7e4ec07df88$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $2358b7e4ec07df88$export$24a4ccb5099273b5 : $2358b7e4ec07df88$export$7f795934b84ab523;
            else settings.endingStart = $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $2358b7e4ec07df88$export$24a4ccb5099273b5 : $2358b7e4ec07df88$export$7f795934b84ab523;
            else settings.endingEnd = $2358b7e4ec07df88$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $2358b7e4ec07df88$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class $2358b7e4ec07df88$export$fbd77e5aefaa0102 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $2358b7e4ec07df88$export$dfe0af1ca1acb78a($2358b7e4ec07df88$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $2358b7e4ec07df88$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $2358b7e4ec07df88$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $2358b7e4ec07df88$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $2358b7e4ec07df88$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $2358b7e4ec07df88$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $2358b7e4ec07df88$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class $2358b7e4ec07df88$export$6b116d2fdfef087c extends $2358b7e4ec07df88$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $2358b7e4ec07df88$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class $2358b7e4ec07df88$export$2947cebfe91c02f8 {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new $2358b7e4ec07df88$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $2358b7e4ec07df88$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$c412d5ffe1f79209 extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $2358b7e4ec07df88$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $2358b7e4ec07df88$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class $2358b7e4ec07df88$export$25ec0e1af1389358 extends $2358b7e4ec07df88$export$3d5cd879f108f53f {
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class $2358b7e4ec07df88$export$6b7339ae8dbddf73 {
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(buffer, type, itemSize, elementSize, count, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
}
const $2358b7e4ec07df88$var$_matrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class $2358b7e4ec07df88$export$8b7aaceff00bd2f {
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $2358b7e4ec07df88$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $2358b7e4ec07df88$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else $2358b7e4ec07df88$export$a3bc9b8ed74fc('Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        $2358b7e4ec07df88$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($2358b7e4ec07df88$var$_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        $2358b7e4ec07df88$var$intersect(object, this, intersects, recursive);
        intersects.sort($2358b7e4ec07df88$var$ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$2358b7e4ec07df88$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($2358b7e4ec07df88$var$ascSort);
        return intersects;
    }
}
function $2358b7e4ec07df88$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $2358b7e4ec07df88$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$2358b7e4ec07df88$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class is an alternative to {@link Clock} with a different API design and behavior.
 * The goal is to avoid the conceptual flaws that became apparent in `Clock` over time.
 *
 * - `Timer` has an `update()` method that updates its internal state. That makes it possible to
 * call `getDelta()` and `getElapsed()` multiple times per simulation step without getting different values.
 * - The class can make use of the Page Visibility API to avoid large time delta values when the app
 * is inactive (e.g. tab switched or browser hidden).
 *
 * ```js
 * const timer = new Timer();
 * timer.connect( document ); // use Page Visibility API
 * ```
 */ class $2358b7e4ec07df88$export$c57e9b2d8b9e4de {
    /**
	 * Constructs a new timer.
	 */ constructor(){
        this._previousTime = 0;
        this._currentTime = 0;
        this._startTime = performance.now();
        this._delta = 0;
        this._elapsed = 0;
        this._timescale = 1;
        this._document = null;
        this._pageVisibilityHandler = null;
    }
    /**
	 * Connect the timer to the given document.Calling this method is not mandatory to
	 * use the timer but enables the usage of the Page Visibility API to avoid large time
	 * delta values.
	 *
	 * @param {Document} document - The document.
	 */ connect(document1) {
        this._document = document1;
        // use Page Visibility API to avoid large time delta values
        if (document1.hidden !== undefined) {
            this._pageVisibilityHandler = $2358b7e4ec07df88$var$handleVisibilityChange.bind(this);
            document1.addEventListener('visibilitychange', this._pageVisibilityHandler, false);
        }
    }
    /**
	 * Disconnects the timer from the DOM and also disables the usage of the Page Visibility API.
	 */ disconnect() {
        if (this._pageVisibilityHandler !== null) {
            this._document.removeEventListener('visibilitychange', this._pageVisibilityHandler);
            this._pageVisibilityHandler = null;
        }
        this._document = null;
    }
    /**
	 * Returns the time delta in seconds.
	 *
	 * @return {number} The time delta in second.
	 */ getDelta() {
        return this._delta / 1000;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time in second.
	 */ getElapsed() {
        return this._elapsed / 1000;
    }
    /**
	 * Returns the timescale.
	 *
	 * @return {number} The timescale.
	 */ getTimescale() {
        return this._timescale;
    }
    /**
	 * Sets the given timescale which scale the time delta computation
	 * in `update()`.
	 *
	 * @param {number} timescale - The timescale to set.
	 * @return {Timer} A reference to this timer.
	 */ setTimescale(timescale) {
        this._timescale = timescale;
        return this;
    }
    /**
	 * Resets the time computation for the current simulation step.
	 *
	 * @return {Timer} A reference to this timer.
	 */ reset() {
        this._currentTime = performance.now() - this._startTime;
        return this;
    }
    /**
	 * Can be used to free all internal resources. Usually called when
	 * the timer instance isn't required anymore.
	 */ dispose() {
        this.disconnect();
    }
    /**
	 * Updates the internal state of the timer. This method should be called
	 * once per simulation step and before you perform queries against the timer
	 * (e.g. via `getDelta()`).
	 *
	 * @param {number} timestamp - The current time in milliseconds. Can be obtained
	 * from the `requestAnimationFrame` callback argument. If not provided, the current
	 * time will be determined with `performance.now`.
	 * @return {Timer} A reference to this timer.
	 */ update(timestamp) {
        if (this._pageVisibilityHandler !== null && this._document.hidden === true) this._delta = 0;
        else {
            this._previousTime = this._currentTime;
            this._currentTime = (timestamp !== undefined ? timestamp : performance.now()) - this._startTime;
            this._delta = (this._currentTime - this._previousTime) * this._timescale;
            this._elapsed += this._delta; // _elapsed is the accumulation of all previous deltas
        }
        return this;
    }
}
function $2358b7e4ec07df88$var$handleVisibilityChange() {
    if (this._document.hidden === false) this.reset();
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates](https://en.wikipedia.org/wiki/Spherical_coordinate_system).
 */ class $2358b7e4ec07df88$export$d712cd887b4a00f7 {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $2358b7e4ec07df88$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The y value.
	 * @param {number} z - The z value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($2358b7e4ec07df88$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates](https://en.wikipedia.org/wiki/Cylindrical_coordinate_system).
 */ class $2358b7e4ec07df88$export$287165bb2177f4fd {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $2358b7e4ec07df88$export$cbcc6560bf79fb38 {
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $2358b7e4ec07df88$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $2358b7e4ec07df88$var$_vector$4 = /*@__PURE__*/ new $2358b7e4ec07df88$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $2358b7e4ec07df88$export$60f553fa130f08b0 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $2358b7e4ec07df88$export$c977b3e384af9ae1(Infinity, Infinity), max = new $2358b7e4ec07df88$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $2358b7e4ec07df88$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $2358b7e4ec07df88$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $2358b7e4ec07df88$var$_startP = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_startEnd = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_d1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_d2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_r = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_c1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_c2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $2358b7e4ec07df88$export$e0ba6359f1954fd3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $2358b7e4ec07df88$export$64b5c384219d3699(), end = new $2358b7e4ec07df88$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $2358b7e4ec07df88$var$_startP.subVectors(point, this.start);
        $2358b7e4ec07df88$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $2358b7e4ec07df88$var$_startEnd.dot($2358b7e4ec07df88$var$_startEnd);
        const startEnd_startP = $2358b7e4ec07df88$var$_startEnd.dot($2358b7e4ec07df88$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $2358b7e4ec07df88$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closest point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns the closest squared distance between this line segment and the given one.
	 *
	 * @param {Line3} line - The line segment to compute the closest squared distance to.
	 * @param {Vector3} [c1] - The closest point on this line segment.
	 * @param {Vector3} [c2] - The closest point on the given line segment.
	 * @return {number} The squared distance between this line segment and the given one.
	 */ distanceSqToLine3(line, c1 = $2358b7e4ec07df88$var$_c1, c2 = $2358b7e4ec07df88$var$_c2) {
        // from Real-Time Collision Detection by Christer Ericson, chapter 5.1.9
        // Computes closest points C1 and C2 of S1(s)=P1+s*(Q1-P1) and
        // S2(t)=P2+t*(Q2-P2), returning s and t. Function result is squared
        // distance between between S1(s) and S2(t)
        const EPSILON = 1e-8 * 1e-8; // must be squared since we compare squared length
        let s, t;
        const p1 = this.start;
        const p2 = line.start;
        const q1 = this.end;
        const q2 = line.end;
        $2358b7e4ec07df88$var$_d1.subVectors(q1, p1); // Direction vector of segment S1
        $2358b7e4ec07df88$var$_d2.subVectors(q2, p2); // Direction vector of segment S2
        $2358b7e4ec07df88$var$_r.subVectors(p1, p2);
        const a = $2358b7e4ec07df88$var$_d1.dot($2358b7e4ec07df88$var$_d1); // Squared length of segment S1, always nonnegative
        const e = $2358b7e4ec07df88$var$_d2.dot($2358b7e4ec07df88$var$_d2); // Squared length of segment S2, always nonnegative
        const f = $2358b7e4ec07df88$var$_d2.dot($2358b7e4ec07df88$var$_r);
        // Check if either or both segments degenerate into points
        if (a <= EPSILON && e <= EPSILON) {
            // Both segments degenerate into points
            c1.copy(p1);
            c2.copy(p2);
            c1.sub(c2);
            return c1.dot(c1);
        }
        if (a <= EPSILON) {
            // First segment degenerates into a point
            s = 0;
            t = f / e; // s = 0 => t = (b*s + f) / e = f / e
            t = $2358b7e4ec07df88$var$clamp(t, 0, 1);
        } else {
            const c = $2358b7e4ec07df88$var$_d1.dot($2358b7e4ec07df88$var$_r);
            if (e <= EPSILON) {
                // Second segment degenerates into a point
                t = 0;
                s = $2358b7e4ec07df88$var$clamp(-c / a, 0, 1); // t = 0 => s = (b*t - c) / a = -c / a
            } else {
                // The general nondegenerate case starts here
                const b = $2358b7e4ec07df88$var$_d1.dot($2358b7e4ec07df88$var$_d2);
                const denom = a * e - b * b; // Always nonnegative
                // If segments not parallel, compute closest point on L1 to L2 and
                // clamp to segment S1. Else pick arbitrary s (here 0)
                if (denom !== 0) s = $2358b7e4ec07df88$var$clamp((b * f - c * e) / denom, 0, 1);
                else s = 0;
                // Compute point on L2 closest to S1(s) using
                // t = Dot((P1 + D1*s) - P2,D2) / Dot(D2,D2) = (b*s + f) / e
                t = (b * s + f) / e;
                // If t in [0,1] done. Else clamp t, recompute s for the new value
                // of t using s = Dot((P2 + D2*t) - P1,D1) / Dot(D1,D1)= (t*b - c) / a
                // and clamp s to [0, 1]
                if (t < 0) {
                    t = 0.;
                    s = $2358b7e4ec07df88$var$clamp(-c / a, 0, 1);
                } else if (t > 1) {
                    t = 1;
                    s = $2358b7e4ec07df88$var$clamp((b - c) / a, 0, 1);
                }
            }
        }
        c1.copy(p1).add($2358b7e4ec07df88$var$_d1.multiplyScalar(s));
        c2.copy(p2).add($2358b7e4ec07df88$var$_d2.multiplyScalar(t));
        c1.sub(c2);
        return c1.dot(c1);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $2358b7e4ec07df88$var$_vector$3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$4b14638ffdd81e68 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $2358b7e4ec07df88$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $2358b7e4ec07df88$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($2358b7e4ec07df88$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $2358b7e4ec07df88$var$_vector$2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_boneMatrix = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
const $2358b7e4ec07df88$var$_matrixWorldInv = /*@__PURE__*/ new $2358b7e4ec07df88$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$5277df3c9e732259 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new skeleton helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $2358b7e4ec07df88$var$getBoneList(object);
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(0, 0, 0);
                colors.push(0, 0, 0);
            }
        }
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
        // colors
        const color1 = new $2358b7e4ec07df88$export$892596cec99bc70e(0x0000ff);
        const color2 = new $2358b7e4ec07df88$export$892596cec99bc70e(0x00ff00);
        this.setColors(color1, color2);
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $2358b7e4ec07df88$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $2358b7e4ec07df88$var$_boneMatrix.multiplyMatrices($2358b7e4ec07df88$var$_matrixWorldInv, bone.matrixWorld);
                $2358b7e4ec07df88$var$_vector$2.setFromMatrixPosition($2358b7e4ec07df88$var$_boneMatrix);
                position.setXYZ(j, $2358b7e4ec07df88$var$_vector$2.x, $2358b7e4ec07df88$var$_vector$2.y, $2358b7e4ec07df88$var$_vector$2.z);
                $2358b7e4ec07df88$var$_boneMatrix.multiplyMatrices($2358b7e4ec07df88$var$_matrixWorldInv, bone.parent.matrixWorld);
                $2358b7e4ec07df88$var$_vector$2.setFromMatrixPosition($2358b7e4ec07df88$var$_boneMatrix);
                position.setXYZ(j + 1, $2358b7e4ec07df88$var$_vector$2.x, $2358b7e4ec07df88$var$_vector$2.y, $2358b7e4ec07df88$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} color1 - The first line color for each bone.
	 * @param {Color} color2 - The second line color for each bone.
	 * @return {SkeletonHelper} A reference to this helper.
	 */ setColors(color1, color2) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        for(let i = 0; i < colorAttribute.count; i += 2){
            colorAttribute.setXYZ(i, color1.r, color1.g, color1.b);
            colorAttribute.setXYZ(i + 1, color2.r, color2.g, color2.b);
        }
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $2358b7e4ec07df88$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$2358b7e4ec07df88$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $2358b7e4ec07df88$export$9a9291685b9e4023 extends $2358b7e4ec07df88$export$e176487c05830cc5 {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $2358b7e4ec07df88$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $2358b7e4ec07df88$var$_vector$1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_color1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e();
const $2358b7e4ec07df88$var$_color2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$8dca15f13f4f8172 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $2358b7e4ec07df88$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$8dea267bd6bde117(colors, 3));
        this.add(new $2358b7e4ec07df88$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $2358b7e4ec07df88$var$_color1.copy(this.light.color);
            $2358b7e4ec07df88$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $2358b7e4ec07df88$var$_color1 : $2358b7e4ec07df88$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($2358b7e4ec07df88$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$3875d39926561055 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $2358b7e4ec07df88$export$892596cec99bc70e(color1);
        color2 = new $2358b7e4ec07df88$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$361430a10f533cd3 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $2358b7e4ec07df88$export$892596cec99bc70e(color1);
        color2 = new $2358b7e4ec07df88$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $2358b7e4ec07df88$var$_v1 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v2 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_v3 = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$f8e434dc14203e7d extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $2358b7e4ec07df88$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $2358b7e4ec07df88$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $2358b7e4ec07df88$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $2358b7e4ec07df88$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $2358b7e4ec07df88$var$_v3.subVectors($2358b7e4ec07df88$var$_v2, $2358b7e4ec07df88$var$_v1);
        this.lightPlane.lookAt($2358b7e4ec07df88$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($2358b7e4ec07df88$var$_v2);
        this.targetLine.scale.z = $2358b7e4ec07df88$var$_v3.length();
    }
}
const $2358b7e4ec07df88$var$_vector = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
const $2358b7e4ec07df88$var$_camera = /*@__PURE__*/ new $2358b7e4ec07df88$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example](https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html).
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$ed8e93f853cd795 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $2358b7e4ec07df88$export$892596cec99bc70e(0xff0000);
        const colorUp = new $2358b7e4ec07df88$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $2358b7e4ec07df88$export$892596cec99bc70e(0xffffff);
        const colorCross = new $2358b7e4ec07df88$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 * @return {CameraHelper} A reference to this helper.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        let nearZ, farZ;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $2358b7e4ec07df88$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        if (this.camera.reversedDepth === true) {
            nearZ = 1;
            farZ = 0;
        } else {
            if (this.camera.coordinateSystem === $2358b7e4ec07df88$export$5a0e9190d10875d3) {
                nearZ = -1;
                farZ = 1;
            } else if (this.camera.coordinateSystem === $2358b7e4ec07df88$export$cc83beedcb9be9ac) {
                nearZ = 0;
                farZ = 1;
            } else throw new Error('THREE.CameraHelper.update(): Invalid coordinate system: ' + this.camera.coordinateSystem);
        }
        // center / target
        $2358b7e4ec07df88$var$setPoint('c', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, 0, nearZ);
        $2358b7e4ec07df88$var$setPoint('t', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, 0, farZ);
        // near
        $2358b7e4ec07df88$var$setPoint('n1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, -h, nearZ);
        $2358b7e4ec07df88$var$setPoint('n2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, -h, nearZ);
        $2358b7e4ec07df88$var$setPoint('n3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, h, nearZ);
        $2358b7e4ec07df88$var$setPoint('n4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, h, nearZ);
        // far
        $2358b7e4ec07df88$var$setPoint('f1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, -h, farZ);
        $2358b7e4ec07df88$var$setPoint('f2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, -h, farZ);
        $2358b7e4ec07df88$var$setPoint('f3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, h, farZ);
        $2358b7e4ec07df88$var$setPoint('f4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, h, farZ);
        // up
        $2358b7e4ec07df88$var$setPoint('u1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w * 0.7, h * 1.1, nearZ);
        $2358b7e4ec07df88$var$setPoint('u2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w * 0.7, h * 1.1, nearZ);
        $2358b7e4ec07df88$var$setPoint('u3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, h * 2, nearZ);
        // cross
        $2358b7e4ec07df88$var$setPoint('cf1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, 0, farZ);
        $2358b7e4ec07df88$var$setPoint('cf2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, 0, farZ);
        $2358b7e4ec07df88$var$setPoint('cf3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, -h, farZ);
        $2358b7e4ec07df88$var$setPoint('cf4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, h, farZ);
        $2358b7e4ec07df88$var$setPoint('cn1', pointMap, geometry, $2358b7e4ec07df88$var$_camera, -w, 0, nearZ);
        $2358b7e4ec07df88$var$setPoint('cn2', pointMap, geometry, $2358b7e4ec07df88$var$_camera, w, 0, nearZ);
        $2358b7e4ec07df88$var$setPoint('cn3', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, -h, nearZ);
        $2358b7e4ec07df88$var$setPoint('cn4', pointMap, geometry, $2358b7e4ec07df88$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $2358b7e4ec07df88$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $2358b7e4ec07df88$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $2358b7e4ec07df88$var$_vector.x, $2358b7e4ec07df88$var$_vector.y, $2358b7e4ec07df88$var$_vector.z);
    }
}
const $2358b7e4ec07df88$var$_box = /*@__PURE__*/ new $2358b7e4ec07df88$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$38a664cc862a6a9d extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $2358b7e4ec07df88$var$_box.setFromObject(this.object);
        if ($2358b7e4ec07df88$var$_box.isEmpty()) return;
        const min = $2358b7e4ec07df88$var$_box.min;
        const max = $2358b7e4ec07df88$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$ce39f4bb96c9a290 extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setIndex(new $2358b7e4ec07df88$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $2358b7e4ec07df88$export$a34fe8156c66e5d7 extends $2358b7e4ec07df88$export$17d680238e50603e {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $2358b7e4ec07df88$export$e176487c05830cc5(geometry2, new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $2358b7e4ec07df88$var$_axis = /*@__PURE__*/ new $2358b7e4ec07df88$export$64b5c384219d3699();
let $2358b7e4ec07df88$var$_lineGeometry, $2358b7e4ec07df88$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $2358b7e4ec07df88$export$a3008e7bd8d2cbe7 extends $2358b7e4ec07df88$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 1), origin = new $2358b7e4ec07df88$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($2358b7e4ec07df88$var$_lineGeometry === undefined) {
            $2358b7e4ec07df88$var$_lineGeometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
            $2358b7e4ec07df88$var$_lineGeometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $2358b7e4ec07df88$var$_coneGeometry = new $2358b7e4ec07df88$export$a7a48974f285c9b3(0.5, 1, 5, 1);
            $2358b7e4ec07df88$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $2358b7e4ec07df88$export$17d680238e50603e($2358b7e4ec07df88$var$_lineGeometry, new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $2358b7e4ec07df88$export$e176487c05830cc5($2358b7e4ec07df88$var$_coneGeometry, new $2358b7e4ec07df88$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $2358b7e4ec07df88$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($2358b7e4ec07df88$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $2358b7e4ec07df88$export$6c8303f35b8578fd extends $2358b7e4ec07df88$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $2358b7e4ec07df88$export$b7be63a67df8959();
        geometry.setAttribute('position', new $2358b7e4ec07df88$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $2358b7e4ec07df88$export$cbe7a62641830ebd(colors, 3));
        const material = new $2358b7e4ec07df88$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $2358b7e4ec07df88$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $2358b7e4ec07df88$export$148534a3c727230b {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $2358b7e4ec07df88$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $2358b7e4ec07df88$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $2358b7e4ec07df88$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $2358b7e4ec07df88$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $2358b7e4ec07df88$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $2358b7e4ec07df88$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $2358b7e4ec07df88$export$c7c44baae9d9f25f extends $2358b7e4ec07df88$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            $2358b7e4ec07df88$export$c106dd0671a0fc2d('Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $2358b7e4ec07df88$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $2358b7e4ec07df88$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $2358b7e4ec07df88$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $2358b7e4ec07df88$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $2358b7e4ec07df88$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $2358b7e4ec07df88$export$988473390501ed4b:
            return width * height;
        case $2358b7e4ec07df88$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $2358b7e4ec07df88$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $2358b7e4ec07df88$export$21d1799c6d552fc0:
        case $2358b7e4ec07df88$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $2358b7e4ec07df88$export$d2a1a68024a3e56c:
        case $2358b7e4ec07df88$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $2358b7e4ec07df88$export$d0f0355bb3d948e4:
        case $2358b7e4ec07df88$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $2358b7e4ec07df88$export$19ada9bbb1af3573:
        case $2358b7e4ec07df88$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $2358b7e4ec07df88$export$6ab91af2d757aee7:
        case $2358b7e4ec07df88$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $2358b7e4ec07df88$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $2358b7e4ec07df88$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $2358b7e4ec07df88$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $2358b7e4ec07df88$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $2358b7e4ec07df88$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $2358b7e4ec07df88$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $2358b7e4ec07df88$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $2358b7e4ec07df88$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $2358b7e4ec07df88$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $2358b7e4ec07df88$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $2358b7e4ec07df88$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $2358b7e4ec07df88$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $2358b7e4ec07df88$export$ce40b115e188bc81:
        case $2358b7e4ec07df88$export$d279c5c4bac5121e:
        case $2358b7e4ec07df88$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $2358b7e4ec07df88$export$b1688df4c4c21670:
        case $2358b7e4ec07df88$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $2358b7e4ec07df88$export$d220f6ade8463a0f:
        case $2358b7e4ec07df88$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $2358b7e4ec07df88$var$getTextureTypeByteLength(type) {
    switch(type){
        case $2358b7e4ec07df88$export$2e8ce08d3f6f5e10:
        case $2358b7e4ec07df88$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $2358b7e4ec07df88$export$c63dc51868b06a9d:
        case $2358b7e4ec07df88$export$88572337f312435f:
        case $2358b7e4ec07df88$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $2358b7e4ec07df88$export$b3969b01faf587f2:
        case $2358b7e4ec07df88$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $2358b7e4ec07df88$export$c3c7fc4518ebba96:
        case $2358b7e4ec07df88$export$5c612977753abe2:
        case $2358b7e4ec07df88$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $2358b7e4ec07df88$export$5a4c329b7e2092d3:
        case $2358b7e4ec07df88$export$f240f067f72abe41:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $2358b7e4ec07df88$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $2358b7e4ec07df88$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $2358b7e4ec07df88$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $2358b7e4ec07df88$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $2358b7e4ec07df88$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $2358b7e4ec07df88$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) $2358b7e4ec07df88$export$c106dd0671a0fc2d('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $2358b7e4ec07df88$export$3545e07a80636437;
}

});


parcelRegister("kdDvg", function(module, exports) {
module.exports = "data:text/javascript;base64,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";

});

parcelRegister("9HfWD", function(module, exports) {
module.exports = "data:text/javascript;base64,LyogSW1wbGVtZW50YXRpb24gb2YgdGhlIEF1ZGlvV29ya2xldFByb2Nlc3Nvcg0KIGh0dHBzOi8vd2ViYXVkaW8uZ2l0aHViLmlvL3dlYi1hdWRpby1hcGkvI2F1ZGlvd29ya2xldA0KIFRoaXMgZmlsZSB3aWxsIGJlIGxvYWRlZCBvbmx5IGluIHJlY2VudCBicm93c2VycyB0aGF0IHN1cHBvcnRzIEF1ZGlvIHdvcmtsZXQgaXQgaXMNCiBjdXJyZW50bHkgaW4ganMgYmVjYXVzZSBpdCBuZWVkcyB0byBiZSBpbiBlczYgKi8NCmNsYXNzIFNwZWVjaFByb2Nlc3NvciBleHRlbmRzIEF1ZGlvV29ya2xldFByb2Nlc3NvciB7DQogIGNvbnN0cnVjdG9yKG9wdGlvbnMpIHsNCiAgICAvLyBUaGUgc3VwZXIgY29uc3RydWN0b3IgY2FsbCBpcyByZXF1aXJlZC4NCiAgICBzdXBlcihvcHRpb25zKTsNCiAgfQ0KDQogIHByb2Nlc3MoaW5wdXRzLCBvdXRwdXRzKSB7DQogICAgY29uc3QgaW5wdXQgPSBpbnB1dHNbMF07DQogICAgY29uc3Qgb3V0cHV0ID0gW107IC8vIE1ha2Ugc3VyZSBvdXRwdXQgYXJyYXkgY2FuIGJlIGFzc2lnbmVkIHRvDQogICAgZm9yIChsZXQgY2hhbm5lbCA9IDA7IGNoYW5uZWwgPCBpbnB1dC5sZW5ndGg7IGNoYW5uZWwgKz0gMSkgew0KICAgICAgb3V0cHV0W2NoYW5uZWxdID0gaW5wdXRbY2hhbm5lbF07DQogICAgfQ0KICAgIHRoaXMucG9ydC5wb3N0TWVzc2FnZShvdXRwdXRbMF0pOw0KICAgIHJldHVybiB0cnVlOw0KICB9DQp9DQoNCnJlZ2lzdGVyUHJvY2Vzc29yKCdzcGVlY2gtcHJvY2Vzc29yJywgU3BlZWNoUHJvY2Vzc29yKTsNCg==";

});


var $4b1b1b031f67a12b$exports = {};
$parcel$extendImportMap({
    "77Gze": "background.bf75fd73.webp",
    "6NCfb": "HistoryList.5c11a4f3.js",
    "9GKrX": "LanguageChoice.a2dfbb35.js",
    "k0VAd": "AttachmentDetail.253dab6b.js",
    "iTlMv": "FullScreenImage.6773264b.js",
    "aSHJY": "Weather.7cbaf988.js",
    "hvc5r": "Weather.28afdebc.js",
    "dqy4I": "CustomView.9d836ea7.js",
    "dDfpQ": "Emergency.f9c161bf.js",
    "fboBS": "LittleWeatherContainer.c7c7f3a4.js",
    "lBnLP": "NewsContainer.88842538.js",
    "1B7Z5": "speech-processor.78d4fc77.js",
    "cby9Y": "ThreeJsWrapper.a9cae081.js",
    "bVNjP": "SpiritEngineWrapper.7b2f2c2b.js",
    "6cK4D": "layers.760a0456.png",
    "h4HcL": "layers-2x.b7b89169.png",
    "cenFb": "marker-icon.3f7d3721.png"
});


var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
var $84b6f0871d6ab47a$export$882461b6382ed46c;
var $84b6f0871d6ab47a$export$757ceba2d55c277e;
'use strict';

var $aRBoq = parcelRequire("aRBoq");
var $84b6f0871d6ab47a$var$i;
$84b6f0871d6ab47a$export$882461b6382ed46c = $aRBoq.createRoot;
$84b6f0871d6ab47a$export$757ceba2d55c277e = $aRBoq.hydrateRoot;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9qyYE = parcelRequire("9qyYE");

var $4xGiN = parcelRequire("4xGiN");

var $2eBYD = parcelRequire("2eBYD");

var $6HxxJ = parcelRequire("6HxxJ");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $bWQ72 = parcelRequire("bWQ72");

var $hdMz2 = parcelRequire("hdMz2");

var $9P0Ec = parcelRequire("9P0Ec");

var $bxRTa = parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $2eBYD = parcelRequire("2eBYD");

var $6HxxJ = parcelRequire("6HxxJ");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $bWQ72 = parcelRequire("bWQ72");
const $2a260f07721a6a05$var$ExternalHooksHandler = ({ instanceId: instanceId })=>{
    const askedForKioskParametersOpening = (0, $4xGiN.useUtilsStore)((state)=>state.askedForKioskParametersOpening);
    const unlockClickedButton = (0, $4xGiN.useUtilsStore)((state)=>state.unlockClickedButton);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const retorikEvent = (0, $4xGiN.useUtilsStore)((state)=>state.retorikEvent);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const currentValue = (0, $6HxxJ.useAdaptiveCardStore)((state)=>state.currentValue);
    const values = (0, $6HxxJ.useAdaptiveCardStore)((state)=>state.values);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const isTactile = (0, $9JLpC.useViewStore)((state)=>state.isTactile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const muted = (0, $giKuE.useSpeechStore)((state)=>state.muted);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const sendBoxRef = (0, $7SHCs.useRetorikStore)((state)=>state.sendBoxRef);
    const conversationId = (0, $bWQ72.useActivityStore)((state)=>state.conversationId);
    const retrievingConversation = (0, $bWQ72.useActivityStore)((state)=>state.retrievingConversation);
    const askedForKioskParametersOpeningRef = (0, $bxRTa.useRef)(askedForKioskParametersOpening);
    const unlockClickedButtonRef = (0, $bxRTa.useRef)(unlockClickedButton);
    const currentSubViewRef = (0, $bxRTa.useRef)(currentSubView);
    const retorikEventRef = (0, $bxRTa.useRef)(retorikEvent);
    const localeRef = (0, $bxRTa.useRef)(locale);
    const isRTLRef = (0, $bxRTa.useRef)(isRTL);
    const translationRef = (0, $bxRTa.useRef)(translation);
    const currentValueRef = (0, $bxRTa.useRef)(currentValue);
    const valuesRef = (0, $bxRTa.useRef)(values);
    const isMobileRef = (0, $bxRTa.useRef)(isMobile);
    const isWidgetRef = (0, $bxRTa.useRef)(isWidget);
    const isTactileRef = (0, $bxRTa.useRef)(isTactile);
    const themeColorsRef = (0, $bxRTa.useRef)(themeColors);
    const activeRecognitionStateRef = (0, $bxRTa.useRef)(activeRecognitionState);
    const modeRef = (0, $bxRTa.useRef)(mode);
    const mutedRef = (0, $bxRTa.useRef)(muted);
    const loaderClosedRef = (0, $bxRTa.useRef)(loaderClosed);
    const configurationRef = (0, $bxRTa.useRef)(configuration);
    const isUsedOnBorneRef = (0, $bxRTa.useRef)(undefined);
    const inputHintBehaviourRef = (0, $bxRTa.useRef)(undefined);
    const enableDocumentPrintingRef = (0, $bxRTa.useRef)(false);
    const sendBoxRefRef = (0, $bxRTa.useRef)(sendBoxRef);
    const conversationIdRef = (0, $bxRTa.useRef)(conversationId);
    const retrievingConversationRef = (0, $bxRTa.useRef)(retrievingConversation);
    const eventDispatch = (name, value)=>{
        document.dispatchEvent(new CustomEvent(name, {
            detail: {
                instanceId: instanceId,
                value: value
            }
        }));
    };
    (0, $bxRTa.useEffect)(()=>{
        askedForKioskParametersOpeningRef.current = askedForKioskParametersOpening;
        eventDispatch('retorik_askedForKioskParametersOpening', askedForKioskParametersOpening);
    }, [
        askedForKioskParametersOpening
    ]);
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButtonRef.current = unlockClickedButton;
        eventDispatch('retorik_unlockClickedButton', unlockClickedButton);
    }, [
        unlockClickedButton
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentSubViewRef.current = currentSubView;
        eventDispatch('retorik_currentSubView', currentSubView);
    }, [
        currentSubView
    ]);
    (0, $bxRTa.useEffect)(()=>{
        retorikEventRef.current = retorikEvent;
        eventDispatch('retorik_retorikEvent', retorikEvent);
    }, [
        retorikEvent
    ]);
    (0, $bxRTa.useEffect)(()=>{
        localeRef.current = locale;
        eventDispatch('retorik_locale', locale);
    }, [
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isRTLRef.current = isRTL;
        eventDispatch('retorik_isRTL', isRTL);
    }, [
        isRTL
    ]);
    (0, $bxRTa.useEffect)(()=>{
        translationRef.current = translation;
        eventDispatch('retorik_translation', translation);
    }, [
        translation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentValueRef.current = currentValue;
        eventDispatch('retorik_currentValue', currentValue);
    }, [
        currentValue
    ]);
    (0, $bxRTa.useEffect)(()=>{
        valuesRef.current = values;
        eventDispatch('retorik_values', values);
    }, [
        values
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isMobileRef.current = isMobile;
        eventDispatch('retorik_isMobile', isMobile);
    }, [
        isMobile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isWidgetRef.current = isWidget;
        eventDispatch('retorik_isWidget', isWidget);
    }, [
        isWidget
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isTactileRef.current = isTactile;
        eventDispatch('retorik_isTactile', isTactile);
    }, [
        isTactile
    ]);
    (0, $bxRTa.useEffect)(()=>{
        themeColorsRef.current = themeColors;
        eventDispatch('retorik_themeColors', themeColors);
    }, [
        themeColors
    ]);
    (0, $bxRTa.useEffect)(()=>{
        activeRecognitionStateRef.current = activeRecognitionState;
        eventDispatch('retorik_activeRecognitionState', activeRecognitionState);
    }, [
        activeRecognitionState
    ]);
    (0, $bxRTa.useEffect)(()=>{
        modeRef.current = mode;
        eventDispatch('retorik_mode', mode);
    }, [
        mode
    ]);
    (0, $bxRTa.useEffect)(()=>{
        mutedRef.current = muted;
        eventDispatch('retorik_muted', muted);
    }, [
        muted
    ]);
    (0, $bxRTa.useEffect)(()=>{
        loaderClosedRef.current = loaderClosed;
        eventDispatch('retorik_loaderClosed', loaderClosed);
    }, [
        loaderClosed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        configurationRef.current = configuration;
        eventDispatch('retorik_configuration', configuration);
    }, [
        configuration
    ]);
    (0, $bxRTa.useEffect)(()=>{
        sendBoxRefRef.current = sendBoxRef;
        eventDispatch('retorik_sendBoxRef', sendBoxRef);
    }, [
        sendBoxRef
    ]);
    (0, $bxRTa.useEffect)(()=>{
        isUsedOnBorneRef.current = configuration.isUsedOnBorne;
        eventDispatch('retorik_isUsedOnBorne', configuration.isUsedOnBorne);
    }, [
        configuration.isUsedOnBorne
    ]);
    (0, $bxRTa.useEffect)(()=>{
        inputHintBehaviourRef.current = configuration.speechRecognitionOptions?.inputHintBehaviour;
        eventDispatch('retorik_inputHintBehaviour', configuration.speechRecognitionOptions?.inputHintBehaviour);
    }, [
        configuration.speechRecognitionOptions?.inputHintBehaviour
    ]);
    (0, $bxRTa.useEffect)(()=>{
        enableDocumentPrintingRef.current = configuration.enableDocumentPrinting;
        eventDispatch('retorik_enableDocumentPrinting', configuration.enableDocumentPrinting);
    }, [
        configuration.enableDocumentPrinting
    ]);
    (0, $bxRTa.useEffect)(()=>{
        conversationIdRef.current = conversationId;
        eventDispatch('retorik_conversationId', conversationId);
    }, [
        conversationId
    ]);
    (0, $bxRTa.useEffect)(()=>{
        retrievingConversationRef.current = retrievingConversation;
        eventDispatch('retorik_retrievingConversation', retrievingConversation);
    }, [
        retrievingConversation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        document.addEventListener('retorik_call_askedForKioskParametersOpening', ()=>eventDispatch('retorik_askedForKioskParametersOpening', askedForKioskParametersOpeningRef.current));
        document.addEventListener('retorik_call_unlockClickedButton', ()=>eventDispatch('retorik_unlockClickedButton', unlockClickedButtonRef.current));
        document.addEventListener('retorik_call_currentSubView', ()=>eventDispatch('retorik_currentSubView', currentSubViewRef.current));
        document.addEventListener('retorik_call_retorikEvent', ()=>eventDispatch('retorik_retorikEvent', retorikEventRef.current));
        document.addEventListener('retorik_call_locale', ()=>eventDispatch('retorik_locale', localeRef.current));
        document.addEventListener('retorik_call_isRTL', ()=>eventDispatch('retorik_isRTL', isRTLRef.current));
        document.addEventListener('retorik_call_translation', ()=>eventDispatch('retorik_translation', translationRef.current));
        document.addEventListener('retorik_call_currentValue', ()=>eventDispatch('retorik_currentValue', currentValueRef.current));
        document.addEventListener('retorik_call_values', ()=>eventDispatch('retorik_values', valuesRef.current));
        document.addEventListener('retorik_call_isMobile', ()=>eventDispatch('retorik_isMobile', isMobileRef.current));
        document.addEventListener('retorik_call_isWidget', ()=>eventDispatch('retorik_isWidget', isWidgetRef.current));
        document.addEventListener('retorik_call_isTactile', ()=>eventDispatch('retorik_isTactile', isTactileRef.current));
        document.addEventListener('retorik_call_themeColors', ()=>eventDispatch('retorik_themeColors', themeColorsRef.current));
        document.addEventListener('retorik_call_activeRecognitionState', ()=>eventDispatch('retorik_activeRecognitionState', activeRecognitionStateRef.current));
        document.addEventListener('retorik_call_mode', ()=>eventDispatch('retorik_mode', modeRef.current));
        document.addEventListener('retorik_call_muted', ()=>eventDispatch('retorik_muted', mutedRef.current));
        document.addEventListener('retorik_call_loaderClosed', ()=>eventDispatch('retorik_loaderClosed', loaderClosedRef.current));
        document.addEventListener('retorik_call_configuration', ()=>eventDispatch('retorik_configuration', configurationRef.current));
        document.addEventListener('retorik_call_sendBoxRef', ()=>eventDispatch('retorik_sendBoxRef', sendBoxRefRef.current));
        document.addEventListener('retorik_call_isUsedOnBorne', ()=>eventDispatch('retorik_isUsedOnBorne', isUsedOnBorneRef.current));
        document.addEventListener('retorik_call_inputHintBehaviour', ()=>eventDispatch('retorik_inputHintBehaviour', inputHintBehaviourRef.current));
        document.addEventListener('retorik_call_enableDocumentPrinting', ()=>eventDispatch('retorik_enableDocumentPrinting', enableDocumentPrintingRef.current));
        document.addEventListener('retorik_call_conversationId', ()=>eventDispatch('retorik_conversationId', conversationIdRef.current));
        document.addEventListener('retorik_call_retrievingConversation', ()=>eventDispatch('retorik_retrievingConversation', retrievingConversationRef.current));
        return ()=>{
            document.removeEventListener('retorik_call_askedForKioskParametersOpening', ()=>eventDispatch('retorik_askedForKioskParametersOpening', askedForKioskParametersOpeningRef.current));
            document.removeEventListener('retorik_call_unlockClickedButton', ()=>eventDispatch('retorik_unlockClickedButton', unlockClickedButtonRef.current));
            document.removeEventListener('retorik_call_currentSubView', ()=>eventDispatch('retorik_currentSubView', currentSubViewRef.current));
            document.removeEventListener('retorik_call_retorikEvent', ()=>eventDispatch('retorik_retorikEvent', retorikEventRef.current));
            document.removeEventListener('retorik_call_locale', ()=>eventDispatch('retorik_locale', localeRef.current));
            document.removeEventListener('retorik_call_isRTL', ()=>eventDispatch('retorik_isRTL', isRTLRef.current));
            document.removeEventListener('retorik_call_translation', ()=>eventDispatch('retorik_translation', translationRef.current));
            document.removeEventListener('retorik_call_currentValue', ()=>eventDispatch('retorik_currentValue', currentValueRef.current));
            document.removeEventListener('retorik_call_values', ()=>eventDispatch('retorik_values', valuesRef.current));
            document.removeEventListener('retorik_call_isMobile', ()=>eventDispatch('retorik_isMobile', isMobileRef.current));
            document.removeEventListener('retorik_call_isWidget', ()=>eventDispatch('retorik_isWidget', isWidgetRef.current));
            document.removeEventListener('retorik_call_isTactile', ()=>eventDispatch('retorik_isTactile', isTactileRef.current));
            document.removeEventListener('retorik_call_themeColors', ()=>eventDispatch('retorik_themeColors', themeColorsRef.current));
            document.removeEventListener('retorik_call_activeRecognitionState', ()=>eventDispatch('retorik_activeRecognitionState', activeRecognitionStateRef.current));
            document.removeEventListener('retorik_call_mode', ()=>eventDispatch('retorik_mode', modeRef.current));
            document.removeEventListener('retorik_call_muted', ()=>eventDispatch('retorik_muted', mutedRef.current));
            document.removeEventListener('retorik_call_loaderClosed', ()=>eventDispatch('retorik_loaderClosed', loaderClosedRef.current));
            document.removeEventListener('retorik_call_configuration', ()=>eventDispatch('retorik_configuration', configurationRef.current));
            document.removeEventListener('retorik_call_sendBoxRef', ()=>eventDispatch('retorik_sendBoxRef', sendBoxRefRef.current));
            document.removeEventListener('retorik_call_isUsedOnBorne', ()=>eventDispatch('retorik_isUsedOnBorne', isUsedOnBorneRef.current));
            document.removeEventListener('retorik_call_inputHintBehaviour', ()=>eventDispatch('retorik_inputHintBehaviour', inputHintBehaviourRef.current));
            document.removeEventListener('retorik_call_enableDocumentPrinting', ()=>eventDispatch('retorik_enableDocumentPrinting', enableDocumentPrintingRef.current));
            document.removeEventListener('retorik_call_conversationId', ()=>eventDispatch('retorik_conversationId', conversationIdRef.current));
            document.removeEventListener('retorik_call_retrievingConversation', ()=>eventDispatch('retorik_retrievingConversation', retrievingConversationRef.current));
        };
    }, []);
    return null;
};
var $2a260f07721a6a05$export$2e2bcd8739ae039 = $2a260f07721a6a05$var$ExternalHooksHandler;


const $bd43c48bdb8caf5f$var$GlobalProvider = ({ instanceId: instanceId, children: children })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9qyYE.default), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4xGiN.default), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2eBYD.default), {
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6HxxJ.default), {
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $giKuE.default), {
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7SHCs.default), {
                            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9JLpC.default), {
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bWQ72.default), {
                                    children: /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $hdMz2.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9P0Ec.default), {
                                                instanceId: instanceId
                                            }),
                                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2a260f07721a6a05$export$2e2bcd8739ae039), {
                                                instanceId: instanceId
                                            }),
                                            children
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
var $bd43c48bdb8caf5f$export$2e2bcd8739ae039 = $bd43c48bdb8caf5f$var$GlobalProvider;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $aRBoq = parcelRequire("aRBoq");
var $cdcf57c966d5787f$export$83d89fbfd8236492;
var $cdcf57c966d5787f$export$80e7718417253a51;
var $cdcf57c966d5787f$export$eb3a06aef9e6ee51;
var $cdcf57c966d5787f$export$307591e98609eddd;
var $cdcf57c966d5787f$export$b23711c915539651;
var $cdcf57c966d5787f$export$7020a3240b287705;
'use strict';
var $cdcf57c966d5787f$var$l, $cdcf57c966d5787f$var$s;

$cdcf57c966d5787f$var$l = (parcelRequire("i2BIy"));

$cdcf57c966d5787f$var$s = (parcelRequire("3TORS"));
$cdcf57c966d5787f$export$83d89fbfd8236492 = $cdcf57c966d5787f$var$l.version;
$cdcf57c966d5787f$export$80e7718417253a51 = $cdcf57c966d5787f$var$l.renderToString;
$cdcf57c966d5787f$export$eb3a06aef9e6ee51 = $cdcf57c966d5787f$var$l.renderToStaticMarkup;
$cdcf57c966d5787f$export$307591e98609eddd = $cdcf57c966d5787f$var$l.renderToNodeStream;
$cdcf57c966d5787f$export$b23711c915539651 = $cdcf57c966d5787f$var$l.renderToStaticNodeStream;
$cdcf57c966d5787f$export$7020a3240b287705 = $cdcf57c966d5787f$var$s.renderToReadableStream;



var $2ARZ1 = parcelRequire("2ARZ1");
var $d3b255846a013166$var$f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $d3b255846a013166$var$p(e, r) {
    return e(r = {
        exports: {}
    }, r.exports), r.exports;
}
var $d3b255846a013166$var$d = $d3b255846a013166$var$p(function(e) {
    !function(r) {
        var t = function(e, r, n) {
            if (!u(r) || s(r) || f(r) || p(r) || i(r)) return r;
            var o, a = 0, c = 0;
            if (l(r)) for(o = [], c = r.length; a < c; a++)o.push(t(e, r[a], n));
            else for(var d in o = {}, r)Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
            return o;
        }, n = function(e) {
            return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(e, r) {
                return r ? r.toUpperCase() : "";
            })).substr(0, 1).toLowerCase() + e.substr(1);
        }, o = function(e) {
            var r = n(e);
            return r.substr(0, 1).toUpperCase() + r.substr(1);
        }, a = function(e, r) {
            return (function(e, r) {
                var t = (r = r || {}).separator || "_", n = r.split || /(?=[A-Z])/;
                return e.split(n).join(t);
            })(e, r).toLowerCase();
        }, c = Object.prototype.toString, i = function(e) {
            return "function" == typeof e;
        }, u = function(e) {
            return e === Object(e);
        }, l = function(e) {
            return "[object Array]" == c.call(e);
        }, s = function(e) {
            return "[object Date]" == c.call(e);
        }, f = function(e) {
            return "[object RegExp]" == c.call(e);
        }, p = function(e) {
            return "[object Boolean]" == c.call(e);
        }, d = function(e) {
            return (e -= 0) == e;
        }, y = function(e, r) {
            var t = r && "process" in r ? r.process : r;
            return "function" != typeof t ? e : function(r, n) {
                return t(r, e, n);
            };
        }, h = {
            camelize: n,
            decamelize: a,
            pascalize: o,
            depascalize: a,
            camelizeKeys: function(e, r) {
                return t(y(n, r), e);
            },
            decamelizeKeys: function(e, r) {
                return t(y(a, r), e, r);
            },
            pascalizeKeys: function(e, r) {
                return t(y(o, r), e);
            },
            depascalizeKeys: function() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = h : r.humps = h;
    }($d3b255846a013166$var$f);
}).decamelize;
var $d3b255846a013166$var$y = function(e) {
    if (Array.isArray(e)) return e;
};
var $d3b255846a013166$var$h = function(e, r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var t = [], n = !0, o = !1, a = void 0;
        try {
            for(var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0);
        } catch (e) {
            o = !0, a = e;
        } finally{
            try {
                n || null == i.return || i.return();
            } finally{
                if (o) throw a;
            }
        }
        return t;
    }
};
var $d3b255846a013166$var$v = function(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
};
var $d3b255846a013166$var$m = function(e, r) {
    if (e) {
        if ("string" == typeof e) return $d3b255846a013166$var$v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d3b255846a013166$var$v(e, r) : void 0;
    }
};
var $d3b255846a013166$var$b = function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var $d3b255846a013166$var$g = function(e, r) {
    return $d3b255846a013166$var$y(e) || $d3b255846a013166$var$h(e, r) || $d3b255846a013166$var$m(e, r) || $d3b255846a013166$var$b();
}, $d3b255846a013166$var$S = $d3b255846a013166$var$p(function(e) {
    function r() {
        return e.exports = r = Object.assign || function(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = arguments[r];
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }
            return e;
        }, r.apply(this, arguments);
    }
    e.exports = r;
});
var $d3b255846a013166$var$w = function(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
};
var $d3b255846a013166$var$O = function(e, r) {
    if (null == e) return {};
    var t, n, o = $d3b255846a013166$var$w(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
};
var $d3b255846a013166$var$j = (0, $bxRTa.createContext)(null);
function $d3b255846a013166$var$x(r) {
    var t = r.children, n = void 0 === t ? "" : t, o = $d3b255846a013166$var$O(r, [
        "children"
    ]);
    return "string" != typeof n && (n = (0, $cdcf57c966d5787f$export$80e7718417253a51)(n)), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement("template", $d3b255846a013166$var$S({}, o, {
        dangerouslySetInnerHTML: {
            __html: n
        }
    }));
}
function $d3b255846a013166$var$z(e) {
    var r = e.root, t = e.children;
    return (0, $aRBoq.createPortal)(void 0 === t ? null : t, r);
}
function $d3b255846a013166$var$E(n) {
    var i = (0, $bxRTa.forwardRef)(function(o, i) {
        var u, l, s = o.mode, f = void 0 === s ? "open" : s, p = o.delegatesFocus, d = void 0 !== p && p, y = o.styleSheets, h = void 0 === y ? [] : y, v = o.ssr, m = void 0 !== v && v, b = o.children, w = $d3b255846a013166$var$O(o, [
            "mode",
            "delegatesFocus",
            "styleSheets",
            "ssr",
            "children"
        ]), E = (l = (0, $bxRTa.useRef)((u = i) && u.current), (0, $bxRTa.useEffect)(function() {
            u && (u.current = l.current);
        }, [
            u
        ]), l), T = (0, $bxRTa.useState)(null), A = $d3b255846a013166$var$g(T, 2), C = A[0], P = A[1], F = "node_".concat(f).concat(d);
        return (0, $bxRTa.useLayoutEffect)(function() {
            if (E.current) try {
                if ("function" == typeof i && i(E.current), m) {
                    var e = E.current.shadowRoot;
                    return void P(e);
                }
                var r = E.current.attachShadow({
                    mode: f,
                    delegatesFocus: d
                });
                h.length > 0 && (r.adoptedStyleSheets = h), P(r);
            } catch (e) {
                !function(e) {
                    var r = e.error, t = e.styleSheets, n = e.root;
                    switch(r.name){
                        case "NotSupportedError":
                            t.length > 0 && (n.adoptedStyleSheets = t);
                            break;
                        default:
                            throw r;
                    }
                }({
                    error: e,
                    styleSheets: h,
                    root: C
                });
            }
        }, [
            i,
            E,
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement(n.tag, $d3b255846a013166$var$S({
            key: F,
            ref: E
        }, w), (C || m) && (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d3b255846a013166$var$j.Provider, {
            value: C
        }, m ? (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d3b255846a013166$var$x, {
            shadowroot: f,
            shadowrootmode: f
        }, n.render({
            root: C,
            ssr: m,
            children: b
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).createElement($d3b255846a013166$var$z, {
            root: C
        }, n.render({
            root: C,
            ssr: m,
            children: b
        })))));
    });
    return i.propTypes = {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOf([
            "open",
            "closed"
        ]),
        delegatesFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        styleSheets: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).instanceOf(globalThis.CSSStyleSheet)),
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
    }, i;
}
$d3b255846a013166$var$x.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
    ])
}, $d3b255846a013166$var$z.propTypes = {
    root: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2ARZ1))).node
};
var $d3b255846a013166$var$T = new Map;
function $d3b255846a013166$export$64d45095031fa749() {
    return (0, $bxRTa.useContext)($d3b255846a013166$var$j);
}
function $d3b255846a013166$export$7865d0c7f908de6b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e) {
        return e.children;
    };
    return new Proxy(e, {
        get: function(e, n) {
            var o = $d3b255846a013166$var$d(n, {
                separator: "-"
            }), a = "".concat(r, "-").concat(o);
            return $d3b255846a013166$var$T.has(a) || $d3b255846a013166$var$T.set(a, $d3b255846a013166$var$E({
                tag: o,
                render: t
            })), $d3b255846a013166$var$T.get(a);
        }
    });
}
var $d3b255846a013166$var$P = $d3b255846a013166$export$7865d0c7f908de6b();
var $d3b255846a013166$export$2e2bcd8739ae039 = $d3b255846a013166$var$P;



var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");
var $6db77bfdd410248b$exports = {};
$6db77bfdd410248b$exports = "*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border:0 solid}:before,:after{--tw-content:\"\"}html,:host{-webkit-text-size-adjust:100%;tab-size:4;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent;font-family:Calibri,sans-serif;line-height:1.5}body{line-height:inherit;margin:0}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-feature-settings:normal;font-variation-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-feature-settings:inherit;font-variation-settings:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:#0000;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.rf-pointer-events-none{pointer-events:none}.rf-pointer-events-auto{pointer-events:auto}.rf-visible{visibility:visible}.rf-invisible{visibility:hidden}.rf-fixed{position:fixed}.rf-absolute{position:absolute}.rf-relative{position:relative}.-rf-left-6{left:-1.5rem}.-rf-top-2{top:-.5rem}.-rf-top-4{top:-1rem}.-rf-top-6{top:-1.5rem}.-rf-top-\\[1\\.15rem\\]{top:-1.15rem}.rf-bottom-0{bottom:0}.rf-bottom-1{bottom:.25rem}.rf-bottom-1\\/4{bottom:25%}.rf-bottom-10{bottom:2.5rem}.rf-bottom-2{bottom:.5rem}.rf-bottom-4{bottom:1rem}.rf-bottom-8{bottom:2rem}.rf-bottom-\\[calc\\(100\\%\\+2rem\\)\\]{bottom:calc(100% + 2rem)}.rf-left-0{left:0}.rf-left-1{left:.25rem}.rf-left-1\\/2{left:50%}.rf-left-12{left:3rem}.rf-left-2{left:.5rem}.rf-left-4{left:1rem}.rf-left-8{left:2rem}.rf-left-\\[calc\\(100\\%\\+1rem\\)\\]{left:calc(100% + 1rem)}.rf-left-\\[calc\\(50\\%-3rem\\)\\]{left:calc(50% - 3rem)}.rf-right-0{right:0}.rf-right-1{right:.25rem}.rf-right-10{right:2.5rem}.rf-right-12{right:3rem}.rf-right-2{right:.5rem}.rf-right-3{right:.75rem}.rf-right-4{right:1rem}.rf-right-6{right:1.5rem}.rf-right-8{right:2rem}.rf-right-9{right:2.25rem}.rf-right-\\[calc\\(100\\%\\+1rem\\)\\]{right:calc(100% + 1rem)}.rf-top-0{top:0}.rf-top-1{top:.25rem}.rf-top-1\\/2{top:50%}.rf-top-1\\/3{top:33.3333%}.rf-top-110{top:110%}.rf-top-2{top:.5rem}.rf-top-4{top:1rem}.rf-top-8{top:2rem}.rf-top-\\[0\\.125rem\\]{top:.125rem}.rf-top-\\[calc\\(100\\%\\+1rem\\)\\]{top:calc(100% + 1rem)}.rf-top-\\[calc\\(50\\%-3rem\\)\\]{top:calc(50% - 3rem)}.rf-z-\\[10\\]{z-index:10}.rf-z-\\[15\\]{z-index:15}.rf-z-\\[1\\]{z-index:1}.rf-z-\\[20\\]{z-index:20}.rf-z-\\[25\\]{z-index:25}.rf-z-\\[2\\]{z-index:2}.rf-z-\\[5\\]{z-index:5}.rf-z-agent{z-index:1}.rf-z-background{z-index:0}.rf-z-chatbot{z-index:10}.rf-z-detailedPOI{z-index:31}.rf-z-dropdown{z-index:30}.rf-z-exitwidget{z-index:55}.rf-z-list{z-index:30}.rf-z-menu{z-index:40}.rf-z-modal{z-index:50}.rf-z-overlay{z-index:40}.rf-z-ui{z-index:20}.rf-z-util{z-index:2}.rf-col-span-2{grid-column:span 2/span 2}.rf-col-span-3{grid-column:span 3/span 3}.rf-col-span-4{grid-column:span 4/span 4}.rf-col-span-full{grid-column:1/-1}.rf-col-start-1{grid-column-start:1}.rf-col-start-3{grid-column-start:3}.rf-col-start-4{grid-column-start:4}.rf-col-start-5{grid-column-start:5}.rf-col-end-13{grid-column-end:13}.rf-col-end-2{grid-column-end:2}.rf-col-end-9{grid-column-end:9}.rf-row-span-1{grid-row:span 1/span 1}.rf-row-span-2{grid-row:span 2/span 2}.rf-row-span-full{grid-row:1/-1}.rf-row-start-1{grid-row-start:1}.rf-row-start-12{grid-row-start:12}.rf-row-end-13{grid-row-end:13}.rf-row-end-3{grid-row-end:3}.rf-float-right{float:right}.rf-m-0{margin:0}.rf-m-4{margin:1rem}.rf-m-auto{margin:auto}.-rf-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.-rf-mx-8{margin-left:-2rem;margin-right:-2rem}.rf-mx-0{margin-left:0;margin-right:0}.rf-mx-2{margin-left:.5rem;margin-right:.5rem}.rf-mx-3{margin-left:.75rem;margin-right:.75rem}.rf-mx-4{margin-left:1rem;margin-right:1rem}.rf-mx-8{margin-left:2rem;margin-right:2rem}.rf-mx-auto{margin-left:auto;margin-right:auto}.rf-my-1{margin-top:.25rem;margin-bottom:.25rem}.rf-my-2{margin-top:.5rem;margin-bottom:.5rem}.rf-my-4{margin-top:1rem;margin-bottom:1rem}.rf-my-auto{margin-top:auto;margin-bottom:auto}.-rf-mb-4{margin-bottom:-1rem}.rf-mb-0{margin-bottom:0}.rf-mb-1{margin-bottom:.25rem}.rf-mb-12{margin-bottom:3rem}.rf-mb-16{margin-bottom:4rem}.rf-mb-2{margin-bottom:.5rem}.rf-mb-26{margin-bottom:6.5rem}.rf-mb-28{margin-bottom:7rem}.rf-mb-3{margin-bottom:.75rem}.rf-mb-30{margin-bottom:7.5rem}.rf-mb-4{margin-bottom:1rem}.rf-mb-5{margin-bottom:1.25rem}.rf-mb-6{margin-bottom:1.5rem}.rf-mb-8{margin-bottom:2rem}.rf-ml-1{margin-left:.25rem}.rf-ml-2{margin-left:.5rem}.rf-ml-4{margin-left:1rem}.rf-ml-6{margin-left:1.5rem}.rf-mr-1{margin-right:.25rem}.rf-mr-2{margin-right:.5rem}.rf-mr-3{margin-right:.75rem}.rf-mr-4{margin-right:1rem}.rf-mr-5{margin-right:1.25rem}.rf-mt-1{margin-top:.25rem}.rf-mt-10{margin-top:2.5rem}.rf-mt-2{margin-top:.5rem}.rf-mt-4{margin-top:1rem}.rf-mt-5{margin-top:1.25rem}.rf-mt-8{margin-top:2rem}.rf-mt-\\[0\\.2rem\\]{margin-top:.2rem}.rf-mt-auto{margin-top:auto}.rf-box-border{box-sizing:border-box}.rf-line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-inline{display:inline}.rf-flex{display:flex}.rf-grid{display:grid}.rf-hidden{display:none}.rf-aspect-\\[4\\/3\\]{aspect-ratio:4/3}.rf-aspect-square{aspect-ratio:1}.rf-aspect-video{aspect-ratio:16/9}.rf-h-0{height:0}.rf-h-1\\/2{height:50%}.rf-h-1\\/3{height:33.3333%}.rf-h-10{height:2.5rem}.rf-h-12{height:3rem}.rf-h-14{height:3.5rem}.rf-h-16{height:4rem}.rf-h-18{height:4.5rem}.rf-h-2{height:.5rem}.rf-h-2\\/3{height:66.6667%}.rf-h-2\\/5{height:40%}.rf-h-24{height:6rem}.rf-h-3{height:.75rem}.rf-h-3\\/10{height:30%}.rf-h-32{height:8rem}.rf-h-36{height:9rem}.rf-h-4{height:1rem}.rf-h-48{height:12rem}.rf-h-5{height:1.25rem}.rf-h-6{height:1.5rem}.rf-h-7{height:1.75rem}.rf-h-8{height:2rem}.rf-h-9{height:2.25rem}.rf-h-\\[0\\.875rem\\]{height:.875rem}.rf-h-\\[1\\.25rem\\]{height:1.25rem}.rf-h-\\[35\\%\\]{height:35%}.rf-h-\\[50\\%\\]{height:50%}.rf-h-\\[calc\\(50vw-3rem\\)\\]{height:calc(50vw - 3rem)}.rf-h-fit{height:fit-content}.rf-h-full{height:100%}.rf-h-max{height:max-content}.rf-h-screen{height:100vh}.rf-max-h-12{max-height:3rem}.rf-max-h-16{max-height:4rem}.rf-max-h-20{max-height:5rem}.rf-max-h-28{max-height:7rem}.rf-max-h-4\\/5{max-height:80%}.rf-max-h-48{max-height:12rem}.rf-max-h-6{max-height:1.5rem}.rf-max-h-8{max-height:2rem}.rf-max-h-80{max-height:20rem}.rf-max-h-full{max-height:100%}.rf-max-h-qrcode{max-height:120px}.rf-max-h-qrcodelarge{max-height:200px}.rf-max-h-screen{max-height:100vh}.rf-min-h-12{min-height:3rem}.rf-min-h-14{min-height:3.5rem}.rf-min-h-16{min-height:4rem}.rf-min-h-2\\/5{min-height:40%}.rf-min-h-6{min-height:1.5rem}.rf-min-h-8{min-height:2rem}.rf-min-h-9{min-height:2.25rem}.rf-min-h-fit{min-height:fit-content}.rf-min-h-full{min-height:100%}.rf-min-h-inherit{min-height:inherit}.rf-w-0{width:0}.rf-w-1\\/2{width:50%}.rf-w-1\\/3{width:33.3333%}.rf-w-1\\/4{width:25%}.rf-w-10{width:2.5rem}.rf-w-12{width:3rem}.rf-w-16{width:4rem}.rf-w-18{width:4.5rem}.rf-w-2{width:.5rem}.rf-w-2\\/3{width:66.6667%}.rf-w-20{width:5rem}.rf-w-24{width:6rem}.rf-w-3{width:.75rem}.rf-w-3\\/20{width:15%}.rf-w-3\\/4{width:75%}.rf-w-3\\/5{width:60%}.rf-w-32{width:8rem}.rf-w-36{width:9rem}.rf-w-4{width:1rem}.rf-w-48{width:12rem}.rf-w-5{width:1.25rem}.rf-w-6{width:1.5rem}.rf-w-7{width:1.75rem}.rf-w-8{width:2rem}.rf-w-9{width:2.25rem}.rf-w-\\[45\\%\\]{width:45%}.rf-w-\\[90\\%\\]{width:90%}.rf-w-\\[calc\\(100\\%-4rem\\)\\]{width:calc(100% - 4rem)}.rf-w-fit{width:fit-content}.rf-w-full{width:100%}.rf-w-max{width:max-content}.rf-w-screen{width:100vw}.rf-min-w-12{min-width:3rem}.rf-min-w-24{min-width:6rem}.rf-min-w-3\\/20{min-width:15%}.rf-min-w-6{min-width:1.5rem}.rf-min-w-7{min-width:1.75rem}.rf-min-w-\\[45\\%\\]{min-width:45%}.rf-min-w-full{min-width:100%}.rf-max-w-1\\/2{max-width:50%}.rf-max-w-16{max-width:4rem}.rf-max-w-3\\/20{max-width:15%}.rf-max-w-6{max-width:1.5rem}.rf-max-w-7\\/10{max-width:70%}.rf-max-w-\\[100vw\\]{max-width:100vw}.rf-max-w-\\[45\\%\\]{max-width:45%}.rf-max-w-\\[500px\\]{max-width:500px}.rf-max-w-\\[75\\%\\]{max-width:75%}.rf-max-w-\\[calc\\(100\\%-2rem\\)\\]{max-width:calc(100% - 2rem)}.rf-max-w-full{max-width:100%}.rf-max-w-none{max-width:none}.rf-flex-1{flex:1}.rf-flex-\\[0_0_40\\%\\]{flex:0 0 40%}.rf-flex-\\[2_1_0\\%\\]{flex:2}.rf-flex-\\[4_1_0\\%\\]{flex:4}.rf-border-collapse{border-collapse:collapse}.rf-origin-center{transform-origin:50%}.-rf-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.-rf-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.-rf-translate-y-full{--tw-translate-y:-100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf--translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-translate-x-1{--tw-translate-x:.25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-translate-x-5{--tw-translate-x:1.25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-0{--tw-rotate:0deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-scale-0{--tw-scale-x:0;--tw-scale-y:0;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}@keyframes rf-blink{0%,to{opacity:.2}50%{opacity:1}}.rf-animate-blink{animation:1.4s infinite both rf-blink}@keyframes rf-fadeIn{0%{opacity:0}to{opacity:1}}.rf-animate-fadeIn{animation:.5s .2s backwards rf-fadeIn}@keyframes rf-hScroll{0%{transform:translate(0)}to{transform:translate(calc(-100% - 2rem))}}.rf-animate-hScroll{animation:20s linear infinite rf-hScroll}@keyframes rf-loader{0%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 1.5rem 0 -.3rem var(--rf-color-loader-animation)}80%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}to{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}}.rf-animate-loader{animation:1.8s ease-in-out -.16s infinite both rf-loader}.rf-animate-loaderFadeIn{animation:2s rf-fadeIn}@keyframes rf-fadeOut{0%{opacity:1}to{opacity:0}}.rf-animate-loaderFadeOut{animation:1s rf-fadeOut}@keyframes rf-loaderMedium{0%{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}40%{box-shadow:0 .75rem 0 -.25rem var(--rf-color-loader-animation)}80%{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}to{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}}.rf-animate-loaderMedium{animation:1.8s ease-in-out -.16s infinite both rf-loaderMedium}@keyframes rf-loaderMini{0%{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 .5rem 0 -.1rem var(--rf-color-loader-animation)}80%{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}to{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}}.rf-animate-loaderMini{animation:1.8s ease-in-out -.16s infinite both rf-loaderMini}@keyframes rf-slideBottom{0%{opacity:0;transform:translate(0)translateY(20px)}to{opacity:1;transform:translate(0)translateY(0)}}.rf-animate-slideBottom{animation:.5s .2s backwards rf-slideBottom}@keyframes rf-spin{to{transform:rotate(360deg)}}.rf-animate-spin{animation:1s linear infinite rf-spin}.rf-cursor-pointer{cursor:pointer}.rf-select-none{user-select:none}.rf-resize-none{resize:none}.rf-scroll-pb-4{scroll-padding-bottom:1rem}.rf-grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.rf-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.rf-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.rf-grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.rf-grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.rf-grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.rf-grid-cols-\\[repeat\\(2\\,30\\%\\)\\]{grid-template-columns:repeat(2,30%)}.rf-grid-cols-\\[repeat\\(2\\,45\\%\\)\\]{grid-template-columns:repeat(2,45%)}.rf-grid-cols-\\[repeat\\(3\\,31\\%\\)\\]{grid-template-columns:repeat(3,31%)}.rf-grid-cols-headerContainer{grid-template-columns:5rem 1rem 1fr 1fr}.rf-grid-cols-printingPreview{grid-template-columns:minmax(0,1fr) 3rem}.rf-grid-cols-routes{grid-template-columns:repeat(3,max-content)}.rf-grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.rf-grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.rf-grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.rf-grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.rf-grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.rf-grid-rows-container{grid-template-rows:repeat(12,minmax(0,1fr))}.rf-grid-rows-headerContainer{grid-template-rows:repeat(2,minmax(0,1fr))}.rf-flex-row{flex-direction:row}.rf-flex-col{flex-direction:column}.rf-flex-col-reverse{flex-direction:column-reverse}.rf-flex-wrap{flex-wrap:wrap}.rf-flex-nowrap{flex-wrap:nowrap}.rf-content-around{align-content:space-around}.rf-items-start{align-items:flex-start}.rf-items-end{align-items:flex-end}.rf-items-center{align-items:center}.rf-justify-start{justify-content:flex-start}.rf-justify-end{justify-content:flex-end}.rf-justify-center{justify-content:center}.rf-justify-between{justify-content:space-between}.rf-justify-around{justify-content:space-around}.rf-justify-evenly{justify-content:space-evenly}.rf-gap-1{gap:.25rem}.rf-gap-12{gap:3rem}.rf-gap-2{gap:.5rem}.rf-gap-3{gap:.75rem}.rf-gap-4{gap:1rem}.rf-gap-5{gap:1.25rem}.rf-gap-6{gap:1.5rem}.rf-gap-8{gap:2rem}.rf-gap-9{gap:2.25rem}.rf-gap-\\[10\\%\\]{gap:10%}.rf-gap-x-\\[3\\.5\\%\\]{column-gap:3.5%}.rf-divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse:0;border-right-width:calc(1px*var(--tw-divide-x-reverse));border-left-width:calc(1px*calc(1 - var(--tw-divide-x-reverse)))}.rf-self-auto{align-self:auto}.rf-self-start{align-self:flex-start}.rf-self-end{align-self:flex-end}.rf-self-center{align-self:center}.rf-justify-self-start{justify-self:start}.rf-justify-self-end{justify-self:end}.rf-justify-self-center{justify-self:center}.rf-overflow-hidden{overflow:hidden}.rf-overflow-clip{overflow:clip}.rf-overflow-y-auto{overflow-y:auto}.rf-overflow-x-hidden{overflow-x:hidden}.rf-overflow-y-hidden{overflow-y:hidden}.rf-overflow-y-clip{overflow-y:clip}.rf-overflow-x-visible{overflow-x:visible}.rf-overflow-y-visible{overflow-y:visible}.rf-overflow-x-scroll{overflow-x:scroll}.rf-overflow-y-scroll{overflow-y:scroll}.rf-truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.rf-whitespace-nowrap{white-space:nowrap}.rf-whitespace-break-spaces{white-space:break-spaces}.rf-rounded{border-radius:.3125rem}.rf-rounded-6{border-radius:1.5rem}.rf-rounded-8{border-radius:2rem}.rf-rounded-\\[20px\\]{border-radius:20px}.rf-rounded-half{border-radius:50%}.rf-rounded-lg{border-radius:.5rem}.rf-rounded-max{border-radius:100%}.rf-rounded-b{border-bottom-right-radius:.3125rem;border-bottom-left-radius:.3125rem}.rf-rounded-b-4{border-bottom-right-radius:1rem;border-bottom-left-radius:1rem}.rf-rounded-b-lg{border-bottom-right-radius:.5rem;border-bottom-left-radius:.5rem}.rf-rounded-l-lg{border-top-left-radius:.5rem;border-bottom-left-radius:.5rem}.rf-rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.rf-rounded-tl-4{border-top-left-radius:1rem}.rf-rounded-tr-4{border-top-right-radius:1rem}.rf-border{border-width:1px}.rf-border-0{border-width:0}.rf-border-2{border-width:2px}.rf-border-y{border-top-width:1px;border-bottom-width:1px}.rf-border-b{border-bottom-width:1px}.rf-border-b-2{border-bottom-width:2px}.rf-border-l{border-left-width:1px}.rf-border-r{border-right-width:1px}.rf-border-t{border-top-width:1px}.rf-border-t-0{border-top-width:0}.rf-border-none{border-style:none}.rf-border-\\[\\#00000029\\]{border-color:#00000029}.rf-border-\\[\\#1999B1\\]{--tw-border-opacity:1;border-color:rgb(25 153 177/var(--tw-border-opacity,1))}.rf-border-\\[\\#707070\\]{--tw-border-opacity:1;border-color:rgb(112 112 112/var(--tw-border-opacity,1))}.rf-border-\\[\\#8B8888\\]{--tw-border-opacity:1;border-color:rgb(139 136 136/var(--tw-border-opacity,1))}.rf-border-\\[\\#9FA2AA\\]{--tw-border-opacity:1;border-color:rgb(159 162 170/var(--tw-border-opacity,1))}.rf-border-\\[\\#C7C6C6\\]{--tw-border-opacity:1;border-color:rgb(199 198 198/var(--tw-border-opacity,1))}.rf-border-\\[\\#F0F0F0\\]{--tw-border-opacity:1;border-color:rgb(240 240 240/var(--tw-border-opacity,1))}.rf-border-black{border-color:var(--rf-color-black)}.rf-border-cardButtonBorderDefault{border-color:var(--rf-color-cardButtonBorderDefault)}.rf-border-cardButtonBorderHover{border-color:var(--rf-color-cardButtonBorderHover)}.rf-border-cardFrameBorder{border-color:var(--rf-color-cardFrameBorder)}.rf-border-formInputButtonBorderDefault{border-color:var(--rf-color-formInputButtonBorderDefault)}.rf-border-formInputButtonBorderHover{border-color:var(--rf-color-formInputButtonBorderHover)}.rf-border-formInputRadioCheckboxCheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-border-formInputRadioCheckboxUncheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder)}.rf-border-gray{--tw-border-opacity:1;border-color:rgb(128 128 128/var(--tw-border-opacity,1))}.rf-border-lightgray{--tw-border-opacity:1;border-color:rgb(129 129 129/var(--tw-border-opacity,1))}.rf-border-menuBorder{--tw-border-opacity:1;border-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-primary{border-color:var(--rf-color-primary)}.rf-border-secondary{border-color:var(--rf-color-secondary)}.rf-border-templateCheckboxBorder{--tw-border-opacity:1;border-color:rgb(112 112 112/var(--tw-border-opacity,1))}.rf-border-textBoxBorder{--tw-border-opacity:1;border-color:rgb(190 190 190/var(--tw-border-opacity,1))}.rf-border-textModePanelBackgroundBot{border-color:var(--rf-color-textModePanelBackgroundBot)}.rf-border-textModePanelBackgroundUser{border-color:var(--rf-color-textModePanelBackgroundUser)}.rf-border-trueblack{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity,1))}.rf-border-truewhite{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity,1))}.rf-border-x-primary{border-left-color:var(--rf-color-primary);border-right-color:var(--rf-color-primary)}.rf-border-y-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity,1));border-bottom-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-b-\\[\\#C4C5C8\\]{--tw-border-opacity:1;border-bottom-color:rgb(196 197 200/var(--tw-border-opacity,1))}.rf-border-b-black{border-bottom-color:var(--rf-color-black)}.rf-border-b-menuBorder{--tw-border-opacity:1;border-bottom-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-b-silver{--tw-border-opacity:1;border-bottom-color:rgb(192 192 192/var(--tw-border-opacity,1))}.rf-border-b-transparent{border-bottom-color:#0000}.rf-border-l-menuBorder{--tw-border-opacity:1;border-left-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-border-r-\\[\\#8B8888\\]{--tw-border-opacity:1;border-right-color:rgb(139 136 136/var(--tw-border-opacity,1))}.rf-border-r-silver{--tw-border-opacity:1;border-right-color:rgb(192 192 192/var(--tw-border-opacity,1))}.rf-border-t-\\[\\#8B8888\\]{--tw-border-opacity:1;border-top-color:rgb(139 136 136/var(--tw-border-opacity,1))}.rf-border-t-\\[\\#CBC9C9\\]{--tw-border-opacity:1;border-top-color:rgb(203 201 201/var(--tw-border-opacity,1))}.rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity,1))}.rf-bg-\\[\\#00000050\\]{background-color:#00000050}.rf-bg-\\[\\#000000B3\\]{background-color:#000000b3}.rf-bg-\\[\\#121212F2\\]{background-color:#121212f2}.rf-bg-\\[\\#1999B1\\]{--tw-bg-opacity:1;background-color:rgb(25 153 177/var(--tw-bg-opacity,1))}.rf-bg-\\[\\#F0F0F0\\]{--tw-bg-opacity:1;background-color:rgb(240 240 240/var(--tw-bg-opacity,1))}.rf-bg-\\[\\#F8F8F8\\]{--tw-bg-opacity:1;background-color:rgb(248 248 248/var(--tw-bg-opacity,1))}.rf-bg-black{background-color:var(--rf-color-black)}.rf-bg-blue-500{--tw-bg-opacity:1;background-color:rgb(59 130 246/var(--tw-bg-opacity,1))}.rf-bg-cardButtonBackgroundDefault{background-color:var(--rf-color-cardButtonBackgroundDefault)}.rf-bg-cardButtonBackgroundHover{background-color:var(--rf-color-cardButtonBackgroundHover)}.rf-bg-cardFrameBackground{background-color:var(--rf-color-cardFrameBackground)}.rf-bg-formInputButtonBackgroundDefault{background-color:var(--rf-color-formInputButtonBackgroundDefault)}.rf-bg-formInputButtonBackgroundHover{background-color:var(--rf-color-formInputButtonBackgroundHover)}.rf-bg-formInputRadioCheckboxUncheckedBackground{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-bg-gray{--tw-bg-opacity:1;background-color:rgb(128 128 128/var(--tw-bg-opacity,1))}.rf-bg-primary{background-color:var(--rf-color-primary)}.rf-bg-red-600{--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity,1))}.rf-bg-secondary{background-color:var(--rf-color-secondary)}.rf-bg-silver{--tw-bg-opacity:1;background-color:rgb(192 192 192/var(--tw-bg-opacity,1))}.rf-bg-templateBackground{--tw-bg-opacity:1;background-color:rgb(241 241 241/var(--tw-bg-opacity,1))}.rf-bg-templateEmptyCard{--tw-bg-opacity:1;background-color:rgb(232 231 231/var(--tw-bg-opacity,1))}.rf-bg-textModePanelBackgroundBot{background-color:var(--rf-color-textModePanelBackgroundBot)}.rf-bg-textModePanelBackgroundUser{background-color:var(--rf-color-textModePanelBackgroundUser)}.rf-bg-transparent{background-color:#0000}.rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.rf-bg-vocalModeSubtitlesBackground{background-color:var(--rf-color-vocalModeSubtitlesBackground)}.rf-bg-white{--tw-bg-opacity:1;background-color:rgb(247 243 246/var(--tw-bg-opacity,1))}.rf-bg-opacity-30{--tw-bg-opacity:.3}.rf-bg-opacity-50{--tw-bg-opacity:.5}.rf-bg-opacity-80{--tw-bg-opacity:.8}.rf-object-cover{object-fit:cover}.rf-p-0{padding:0}.rf-p-1{padding:.25rem}.rf-p-2{padding:.5rem}.rf-p-3{padding:.75rem}.rf-p-4{padding:1rem}.rf-p-\\[25px\\]{padding:25px}.rf-p-\\[7px_12px\\]{padding:7px 12px}.rf-px-1{padding-left:.25rem;padding-right:.25rem}.rf-px-16{padding-left:4rem;padding-right:4rem}.rf-px-2{padding-left:.5rem;padding-right:.5rem}.rf-px-3{padding-left:.75rem;padding-right:.75rem}.rf-px-4{padding-left:1rem;padding-right:1rem}.rf-px-48{padding-left:12rem;padding-right:12rem}.rf-px-5,.rf-px-6{padding-left:1.5rem;padding-right:1.5rem}.rf-px-8{padding-left:2rem;padding-right:2rem}.rf-py-0{padding-top:0;padding-bottom:0}.rf-py-1{padding-top:.25rem;padding-bottom:.25rem}.rf-py-12{padding-top:3rem;padding-bottom:3rem}.rf-py-16{padding-top:4rem;padding-bottom:4rem}.rf-py-2{padding-top:.5rem;padding-bottom:.5rem}.rf-py-3{padding-top:.75rem;padding-bottom:.75rem}.rf-py-4{padding-top:1rem;padding-bottom:1rem}.rf-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.rf-py-8{padding-top:2rem;padding-bottom:2rem}.rf-pb-10{padding-bottom:2.5rem}.rf-pb-12{padding-bottom:3rem}.rf-pb-14{padding-bottom:3.5rem}.rf-pb-2{padding-bottom:.5rem}.rf-pb-24{padding-bottom:6rem}.rf-pb-3{padding-bottom:.75rem}.rf-pb-4{padding-bottom:1rem}.rf-pb-5,.rf-pb-6{padding-bottom:1.5rem}.rf-pb-8{padding-bottom:2rem}.rf-pb-\\[15vh\\]{padding-bottom:15vh}.rf-pl-0{padding-left:0}.rf-pl-1{padding-left:.25rem}.rf-pl-2{padding-left:.5rem}.rf-pl-4{padding-left:1rem}.rf-pl-6{padding-left:1.5rem}.rf-pl-8{padding-left:2rem}.rf-pr-1{padding-right:.25rem}.rf-pr-2{padding-right:.5rem}.rf-pr-4{padding-right:1rem}.rf-pr-6{padding-right:1.5rem}.rf-pt-1{padding-top:.25rem}.rf-pt-11\\/20{padding-top:55%}.rf-pt-12{padding-top:3rem}.rf-pt-14{padding-top:3.5rem}.rf-pt-2{padding-top:.5rem}.rf-pt-24{padding-top:6rem}.rf-pt-3{padding-top:.75rem}.rf-pt-4{padding-top:1rem}.rf-pt-40{padding-top:10rem}.rf-pt-6{padding-top:1.5rem}.rf-pt-8{padding-top:2rem}.rf-pt-\\[25vh\\]{padding-top:25vh}.rf-pt-\\[26vh\\]{padding-top:26vh}.rf-text-left{text-align:left}.rf-text-center{text-align:center}.rf-text-right{text-align:right}.rf-text-justify{text-align:justify}.rf-font-default{font-family:Calibri,sans-serif}.rf-text-2xl{font-size:1.5rem;line-height:2rem}.rf-text-3xl{font-size:1.875rem;line-height:2.25rem}.rf-text-4xl{font-size:2.25rem;line-height:2.5rem}.rf-text-5xl{font-size:3rem;line-height:1}.rf-text-6xl{font-size:3.75rem;line-height:1}.rf-text-7xl{font-size:4.5rem;line-height:1}.rf-text-8xl{font-size:6rem;line-height:1}.rf-text-\\[0\\.5rem\\]{font-size:.5rem}.rf-text-arabic{font-size:1.125rem;line-height:1.15rem}.rf-text-base{font-size:1rem;line-height:1.5rem}.rf-text-basecustom{font-size:1rem;line-height:1.3rem}.rf-text-lgcustom{font-size:1.125rem;line-height:1.5rem}.rf-text-sm{font-size:.875rem;line-height:1.25rem}.rf-text-sm\\/4{font-size:.875rem;line-height:1rem}.rf-text-xl{font-size:1.25rem;line-height:1.75rem}.rf-text-xs{font-size:.75rem;line-height:1rem}.rf-text-xsl{font-size:.7rem;line-height:1rem}.rf-text-xsm{font-size:.6rem}.rf-font-bold{font-weight:600}.rf-font-light{font-weight:200}.rf-font-medium{font-weight:300}.rf-font-semibold{font-weight:400}.rf-uppercase{text-transform:uppercase}.rf-capitalize{text-transform:capitalize}.rf-normal-case{text-transform:none}.rf-italic{font-style:italic}.rf-leading-4{line-height:1rem}.rf-text-\\[\\#1999B1\\]{--tw-text-opacity:1;color:rgb(25 153 177/var(--tw-text-opacity,1))}.rf-text-\\[\\#575F6B\\]{--tw-text-opacity:1;color:rgb(87 95 107/var(--tw-text-opacity,1))}.rf-text-\\[\\#9A9A9A\\]{--tw-text-opacity:1;color:rgb(154 154 154/var(--tw-text-opacity,1))}.rf-text-\\[\\#A4A7AF\\]{--tw-text-opacity:1;color:rgb(164 167 175/var(--tw-text-opacity,1))}.rf-text-black{color:var(--rf-color-black)}.rf-text-cardButtonTextDefault{color:var(--rf-color-cardButtonTextDefault)}.rf-text-cardFrameText{color:var(--rf-color-cardFrameText)}.rf-text-formInputButtonTextDefault{color:var(--rf-color-formInputButtonTextDefault)}.rf-text-formInputButtonTextHover{color:var(--rf-color-formInputButtonTextHover)}.rf-text-formInputRadioCheckboxUncheckedBackground{color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-text-formInputTextDefault{color:var(--rf-color-formInputTextDefault)}.rf-text-gray{--tw-text-opacity:1;color:rgb(128 128 128/var(--tw-text-opacity,1))}.rf-text-lightgray{--tw-text-opacity:1;color:rgb(129 129 129/var(--tw-text-opacity,1))}.rf-text-primary{color:var(--rf-color-primary)}.rf-text-secondary{color:var(--rf-color-secondary)}.rf-text-textModePanelConversationBot{color:var(--rf-color-textModePanelConversationBot)}.rf-text-textModePanelConversationUser{color:var(--rf-color-textModePanelConversationUser)}.rf-text-trueblack{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity,1))}.rf-text-truewhite{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.rf-text-vocalModeSubtitlesText{color:var(--rf-color-vocalModeSubtitlesText)}.rf-text-white{--tw-text-opacity:1;color:rgb(247 243 246/var(--tw-text-opacity,1))}.rf-underline{text-decoration-line:underline}.rf-shadow-\\[-3px_-3px_10px_\\#00000099\\]{--tw-shadow:-3px -3px 10px #0009;--tw-shadow-colored:-3px -3px 10px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_15px_0_silver\\]{--tw-shadow:0 0 15px 0 silver;--tw-shadow-colored:0 0 15px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_20px_1px_\\#A4A7AF80\\]{--tw-shadow:0 0 20px 1px #a4a7af80;--tw-shadow-colored:0 0 20px 1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_3px_6px_\\#00000029\\]{--tw-shadow:0 0 3px 6px #00000029;--tw-shadow-colored:0 0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#00000029\\]{--tw-shadow:0 3px 6px #00000029;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#606267\\]{--tw-shadow:0 3px 6px #606267;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_6px_6px_\\#00000029\\]{--tw-shadow:0 6px 6px #00000029;--tw-shadow-colored:0 6px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[20px_3px_20px_\\#00000029\\]{--tw-shadow:20px 3px 20px #00000029;--tw-shadow-colored:20px 3px 20px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[3px_3px_16px_\\#00000029\\]{--tw-shadow:3px 3px 16px #00000029;--tw-shadow-colored:3px 3px 16px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[3px_3px_6px_\\#00000029\\]{--tw-shadow:3px 3px 6px #00000029;--tw-shadow-colored:3px 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[inset_0_0_6px_\\#0000003B\\]{--tw-shadow:inset 0 0 6px #0000003b;--tw-shadow-colored:inset 0 0 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[inset_0_12px_12px_-12px_\\#00000029\\,inset_0_-12px_12px_-12px_\\#00000029\\]{--tw-shadow:inset 0 12px 12px -12px #00000029,inset 0 -12px 12px -12px #00000029;--tw-shadow-colored:inset 0 12px 12px -12px var(--tw-shadow-color),inset 0 -12px 12px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-outline-none{outline-offset:2px;outline:2px solid #0000}.rf-blur-background{--tw-blur:blur(var(--rf-blur-background));filter:var(--tw-blur)var(--tw-brightness)var(--tw-contrast)var(--tw-grayscale)var(--tw-hue-rotate)var(--tw-invert)var(--tw-saturate)var(--tw-sepia)var(--tw-drop-shadow)}.rf-filter{filter:var(--tw-blur)var(--tw-brightness)var(--tw-contrast)var(--tw-grayscale)var(--tw-hue-rotate)var(--tw-invert)var(--tw-saturate)var(--tw-sepia)var(--tw-drop-shadow)}.rf-transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-transition-transform{transition-property:transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-text-shadow-black{text-shadow:2px 0 5px #000,-2px 0 5px #000,0 2px 5px #000,0 -2px 5px #000}.rf-capitalize-first:first-letter{text-transform:uppercase}ol{padding-left:2rem;list-style-type:decimal}ul{padding-left:2rem;list-style-type:disc}#retorik-container.rf-portrait:not(.rf-large) .ac-image{max-width:100px}.rf-glass-background,#retorik-container.portrait .portrait\\:rf-glass-background{background-color:var(--rf-color-black);--tw-bg-opacity:.62;--tw-backdrop-blur:blur(8px);backdrop-filter:var(--tw-backdrop-blur)var(--tw-backdrop-brightness)var(--tw-backdrop-contrast)var(--tw-backdrop-grayscale)var(--tw-backdrop-hue-rotate)var(--tw-backdrop-invert)var(--tw-backdrop-opacity)var(--tw-backdrop-saturate)var(--tw-backdrop-sepia)}.rf-loader-bouncing-bot{aspect-ratio:2;--_g:no-repeat radial-gradient(circle closest-side,var(--rf-color-textModePanelConversationBot)90%,transparent);background:var(--_g)0% 50%,var(--_g)50% 50%,var(--_g)100% 50%;background-size:33.3333% 50%}@keyframes rf-loaderBouncing{20%{background-position:0 0,50%,100%}40%{background-position:0 100%,50% 0,100%}60%{background-position:0%,50% 100%,100% 0}80%{background-position:0%,50%,100% 100%}}.rf-loader-bouncing-bot{animation:1s linear infinite rf-loaderBouncing}.rf-loader-bouncing-white{aspect-ratio:2;--_g:no-repeat radial-gradient(circle closest-side,#fff 90%,transparent);background:var(--_g)0% 50%,var(--_g)50% 50%,var(--_g)100% 50%;background-size:33.3333% 50%;animation:1s linear infinite rf-loaderBouncing}@keyframes rf-loaderPulsation{0%{transform:scale(1)}50%{transform:scale(1.1)}to{transform:scale(1)}}.rf-loader-pulsation{animation:2s cubic-bezier(.65,0,.34,1) infinite rf-loaderPulsation}.rf-loader-pulsation:before{content:\"\";background-color:var(--rf-color-secondary);z-index:-1;border-radius:50%;width:100%;height:100%;position:absolute}@keyframes rf-loaderRipple{0%{opacity:1;transform:scale(.75)}to{opacity:0;transform:scale(1.5)}}.rf-loader-pulsation:before{animation:2.4s cubic-bezier(.65,0,.34,1) .4s infinite rf-loaderRipple}.rf-loader-pulsation:after{content:\"\";background-color:var(--rf-color-secondary);z-index:-1;border-radius:50%;width:100%;height:100%;animation:2.4s cubic-bezier(.65,0,.34,1) infinite rf-loaderRipple;position:absolute}.rf-loader:before{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loader;display:block;position:absolute;right:1.5rem}.rf-loader:after{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out infinite both rf-loader;display:block;position:absolute;left:1.5rem}.rf-loader-medium:before{content:\"\";border-radius:50%;width:1rem;height:1rem;animation:1.8s ease-in-out -.32s infinite both rf-loaderMedium;display:block;position:absolute;right:1rem}.rf-loader-medium:after{content:\"\";border-radius:50%;width:1rem;height:1rem;animation:1.8s ease-in-out infinite both rf-loaderMedium;display:block;position:absolute;left:1rem}.rf-loader-mini:before{content:\"\";border-radius:50%;width:.5rem;height:.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loaderMini;display:block;position:absolute;right:.5rem}.rf-loader-mini:after{content:\"\";border-radius:50%;width:.5rem;height:.5rem;animation:1.8s ease-in-out infinite both rf-loaderMini;display:block;position:absolute;left:.5rem}.rf-loader-microphone:before,.rf-loader-microphone:after{content:\"\";--tw-border-opacity:1;border:6px solid #0000;border-top-color:rgb(128 128 128/var(--tw-border-opacity,1));border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone:before{z-index:2;animation:1s linear infinite rf-spin}.rf-loader-microphone:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity,1))}.rf-loader-microphone-primary:before,.rf-loader-microphone-primary:after{content:\"\";border:6px solid #0000;border-top-color:var(--rf-color-primary);border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone-primary:before{z-index:2;animation:1s linear infinite rf-spin}.rf-loader-microphone-primary:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity,1))}.rf-loader-microphone-secondary:before,.rf-loader-microphone-secondary:after{content:\"\";border:6px solid #0000;border-top-color:var(--rf-color-secondary);border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone-secondary:before{z-index:2;animation:1s linear infinite rf-spin}.rf-loader-microphone-secondary:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity,1))}.rf-loader-counter{border-width:8px;border-color:var(--rf-color-primary);border-radius:50%;position:relative}@keyframes rf-loaderCounter{0%{clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}25%{clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}50%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}75%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}to{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}}.rf-loader-counter:before{border-width:10px;border-color:var(--rf-color-cardFrameBackground);content:\"\";animation:rf-loaderCounter;animation-duration:var(--duration);border-radius:50%;animation-timing-function:linear;position:absolute;inset:-9px;transform:rotate(45deg)}.rf-touch-action-none{touch-action:none}.rf-unselectable{user-select:none;-webkit-touch-callout:none}.rf-title-extralarge-bold-size-auto{font-size:2.25rem;font-weight:600;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-bold-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-bold-size-auto{font-size:3.75rem;line-height:1}.rf-title-extralarge-size-auto{font-size:2.25rem;font-weight:400;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-title-large-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-large-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-size-auto{font-size:3rem;line-height:1}.rf-title-large-bold-size-auto{font-size:1.875rem;font-weight:600;line-height:2.25rem}#retorik-container.rf-large .rf-title-large-bold-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-bold-size-auto{font-size:3rem;line-height:1}.rf-title-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-title-bold-size-auto{font-size:1.5rem;font-weight:600;line-height:2rem}#retorik-container.rf-large .rf-title-bold-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-bold-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-subtitle-size-auto{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-subtitle-size-auto{font-size:1.25rem;line-height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-subtitle-size-auto{font-size:1.5rem;line-height:2rem}.rf-text-extralarge-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large .rf-text-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-text-verylarge-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-verylarge-size-auto{font-size:3.75rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-verylarge-size-auto{font-size:4.5rem;line-height:1}.rf-text-large-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-large-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-text-large-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-text-medium-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .rf-text-medium-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-size-auto{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-text-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-text-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-small-size-auto{font-size:.875rem;line-height:1rem}#retorik-container.rf-large .rf-text-small-size-auto{font-size:1rem;line-height:1.1rem}.rf-text-extra-small-size-auto{font-size:.6rem;line-height:.75rem}#retorik-container.rf-large .rf-text-extra-small-size-auto{font-size:.875rem;line-height:1rem}.rf-small-size-auto{font-size:.6rem}#retorik-container.rf-large .rf-small-size-auto{font-size:.75rem;line-height:1rem}#retorik-container.rf-large.rf-portrait .rf-small-size-auto{font-size:.875rem;line-height:1.25rem}.rf-line-clamp-unknown{hyphens:auto;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-1{hyphens:auto;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{hyphens:auto;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-3{hyphens:auto;-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-4{hyphens:auto;-webkit-line-clamp:4;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-5{hyphens:auto;-webkit-line-clamp:5;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-6{hyphens:auto;-webkit-line-clamp:6;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-7{hyphens:auto;-webkit-line-clamp:7;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-8{hyphens:auto;-webkit-line-clamp:8;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-9{hyphens:auto;-webkit-line-clamp:9;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-10{hyphens:auto;-webkit-line-clamp:10;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-overflow-wrap{overflow-wrap:anywhere}.rf-height-fill-available{height:stretch}.rf-width-fill-available{width:stretch}.rf-animation-delay-2{animation-delay:.2s}.rf-animation-delay-4{animation-delay:.4s}.rf-scrollbar-thin{scrollbar-width:thin;scrollbar-color:var(--rf-color-secondary)transparent}.rf-scrollbar-thin::-webkit-scrollbar{width:.2rem;height:.2rem;margin:.25rem 0}.rf-scrollbar-thin::-webkit-scrollbar-thumb{background-color:var(--rf-color-secondary);border-radius:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:2rem;height:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar-thumb{background-color:var(--rf-color-primary);border-radius:2rem}.rf-scrollbar-hidden{scrollbar-width:none}.rf-scrollbar-hidden::-webkit-scrollbar{display:none}.rf-opacity-gradient-b{-webkit-mask-image:linear-gradient(#000 50%,#0000 100%)}.rf-opacity-gradient-b-thin{-webkit-mask-image:linear-gradient(#797676 84%,#0000 100%)}.rf-opacity-gradient-l{-webkit-mask-image:linear-gradient(270deg,#000 75%,gray 80%,#0000 85%)}.rf-opacity-gradient-l-thin{-webkit-mask-image:linear-gradient(270deg,#000 90%,gray 95%,#0000 100%)}.rf-opacity-gradient-r{-webkit-mask-image:linear-gradient(90deg,#000 75%,gray 80%,#0000 85%)}.rf-opacity-gradient-r-thin{-webkit-mask-image:linear-gradient(90deg,#000 90%,gray 95%,#0000 100%)}.rf-opacity-gradient-h{-webkit-mask-image:linear-gradient(90deg,#0000 0%,6%,#000,94%,#0000 100%)}.rf-card-button{border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button{padding:.5rem 1rem}.rf-card-button:hover{cursor:pointer;border-color:var(--rf-color-cardButtonBorderHover);background-color:var(--rf-color-cardButtonBackgroundHover);color:var(--rf-color-cardButtonTextHover)}.rf-card-button-clicked{background-color:var(--rf-color-cardButtonBackgroundDefault);border-width:1px;border-color:#0000;padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .rf-card-button-clicked{padding-top:.5rem;padding-bottom:.5rem}.rf-card-button-positive{border-width:1px;border-color:var(--rf-color-cardFrameBackground);background-color:var(--rf-color-cardButtonTextDefault);color:var(--rf-color-cardFrameBackground);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-positive{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-positive{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-positive{padding:.5rem 1rem}.rf-card-button-positive:hover{cursor:pointer;border-color:var(--rf-color-cardButtonTextDefault);background-color:var(--rf-color-cardFrameBackground);color:var(--rf-color-cardButtonTextDefault)}.rf-card-button-destructive{--tw-border-opacity:1;border-width:1px;border-color:rgb(220 38 38/var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity,1));--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1));border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-destructive{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-destructive{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-destructive{padding:.5rem 1rem}.rf-card-button-destructive:hover{cursor:pointer;--tw-border-opacity:1;border-color:rgb(220 38 38/var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));--tw-text-opacity:1;color:rgb(220 38 38/var(--tw-text-opacity,1))}.rf-card-button-secondary{border-width:1px;border-color:var(--rf-color-secondary);color:var(--rf-color-secondary);background-color:#0000;border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-secondary{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-secondary{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-secondary{padding:.5rem 1rem}.rf-card-button-secondary:hover{cursor:pointer;border-color:var(--rf-color-secondary);background-color:var(--rf-color-secondary);--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.rf-card-button-discover{border-width:1px;border-color:var(--rf-color-cardButtonDiscoverBorderDefault);background-color:var(--rf-color-cardButtonDiscoverBackgroundDefault);color:var(--rf-color-cardButtonDiscoverTextDefault);border-radius:.3125rem;padding:.5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-discover{padding-top:.75rem;padding-bottom:.75rem}.rf-card-button-discover:hover{cursor:pointer;border-color:var(--rf-color-cardButtonDiscoverBorderHover);background-color:var(--rf-color-cardButtonDiscoverBackgroundHover);color:var(--rf-color-cardButtonDiscoverTextHover)}.rf-card-button-history{cursor:default;border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-history{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-history{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-history{padding:.5rem 1rem}.rf-card-button-mini,.rf-card-button-mini-selected,.rf-card-button-mini-disabled{background-color:var(--rf-color-cardFrameBackground);border-width:1px;border-radius:.3125rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-mini,#retorik-container.rf-large .rf-card-button-mini-selected,#retorik-container.rf-large .rf-card-button-mini-disabled{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-mini,#retorik-container.rf-large.rf-portrait .rf-card-button-mini-selected,#retorik-container.rf-large.rf-portrait .rf-card-button-mini-disabled{font-size:1.125rem;line-height:1.5rem}.rf-card-button-mini{border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardFrameBackground);color:var(--rf-color-cardButtonTextDefault)}.rf-card-button-mini:hover{cursor:pointer;border-color:var(--rf-color-cardButtonBorderHover);background-color:var(--rf-color-cardFrameBackground);color:var(--rf-color-cardButtonTextHover)}.rf-card-button-mini-selected{border-color:var(--rf-color-cardFrameBackground);background-color:var(--rf-color-cardButtonBorderDefault);color:var(--rf-color-cardFrameBackground)}.lf-player-container{align-items:flex-end;width:100%;height:100%;display:flex;overflow:hidden}.rf-input-label{text-overflow:ellipsis;color:var(--rf-color-formInputTextDefault);margin-top:.1rem;margin-left:.75rem;overflow-x:hidden}#retorik-container.rf-large .rf-input-label{margin-top:.25rem}#retorik-container.rf-large.rf-portrait .rf-input-label{margin-top:.2rem}.rf-radio-custom{appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:50%;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}.rf-radio-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}#retorik-container.rf-large .rf-radio-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom{width:2rem;min-width:2rem;height:2rem}.rf-radio-custom:before{content:\"\";--tw-scale-x:0;--tw-scale-y:0;width:.5rem;height:.5rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y));background-color:var(--rf-color-formInputRadioCheckboxCheckedItem);border-radius:50%;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}#retorik-container.rf-large .rf-radio-custom:before{width:.75rem;height:.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom:before{width:1rem;height:1rem}.rf-radio-custom:checked:before{--tw-scale-x:1;--tw-scale-y:1;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-input-hidden{appearance:none;margin:0}.rf-checkbox-custom{appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}#retorik-container.rf-large .rf-checkbox-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-checkbox-custom{width:2rem;min-width:2rem;height:2rem}.rf-checkbox-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.rf-toggle-custom{appearance:none;background-color:var(--rf-color-black);border-radius:1.5rem;width:3rem;min-width:3rem;height:1.5rem;margin:0;position:relative}.rf-toggle-custom:checked{background-color:var(--rf-color-primary)}#retorik-container.rf-large .rf-toggle-custom{border-radius:1.75rem;width:3.5rem;min-width:3.5rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom{border-radius:2rem;width:4rem;min-width:4rem;height:2rem}.rf-toggle-custom:before{content:\"\";--tw-translate-x:0px;width:1rem;height:1rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-radius:50%;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1);position:absolute;top:.25rem;left:.25rem}#retorik-container.rf-large .rf-toggle-custom:before{width:1.25rem;height:1.25rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:before{width:1.5rem;height:1.5rem}.rf-toggle-custom:checked:before{--tw-translate-x:1.5rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large .rf-toggle-custom:checked:before{--tw-translate-x:1.75rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:checked:before{--tw-translate-x:2rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-select-custom{appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;margin:0;padding:1rem}.rf-select-custom:hover{cursor:pointer}.rf-select-custom:focus-visible{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-slider-custom{-webkit-appearance:none;-moz-appearance:none;outline-offset:2px;border-radius:.5rem;outline:2px solid #0000;width:100%;height:.25rem;display:block;position:relative}.rf-slider-custom::-webkit-slider-runnable-track{-webkit-appearance:none}.rf-slider-custom::-moz-track{-moz-appearance:none}.rf-slider-custom::-ms-track{appearance:none}.rf-slider-custom::-webkit-slider-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-webkit-slider-thumb:hover{cursor:pointer}.rf-slider-custom::-moz-range-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-moz-range-thumb:hover{cursor:pointer}.rf-slider-custom::-ms-thumb{appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-ms-thumb:hover{cursor:pointer}.rf-likert-custom{cursor:pointer;outline-offset:2px;-webkit-text-stroke-width:1px;-webkit-text-stroke-color:white;background-color:#0000;border-style:none;outline:2px solid #0000}.svgButtonMenu>svg *{fill:var(--fill)}.webchat__css-custom-properties{width:100%;height:100%}.placeholder\\:rf-text-black::placeholder{color:var(--rf-color-black)}.placeholder\\:rf-opacity-100::placeholder{opacity:1}.hover\\:rf-cursor-pointer:hover{cursor:pointer}.hover\\:rf-border-truewhite:hover{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity,1))}.hover\\:rf-bg-\\[\\#1999B1\\]:hover{--tw-bg-opacity:1;background-color:rgb(25 153 177/var(--tw-bg-opacity,1))}.hover\\:rf-bg-formInputRadioCheckboxCheckedBackground:hover{background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.hover\\:rf-bg-transparent:hover{background-color:#0000}.hover\\:rf-bg-truewhite:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.hover\\:rf-text-\\[\\#1999B1\\]:hover{--tw-text-opacity:1;color:rgb(25 153 177/var(--tw-text-opacity,1))}.hover\\:rf-text-formInputRadioCheckboxCheckedItem:hover{color:var(--rf-color-formInputRadioCheckboxCheckedItem)}.hover\\:rf-text-truewhite:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.hover\\:rf-shadow-\\[inset_0_0_12px_\\#00000029\\]:hover{--tw-shadow:inset 0 0 12px #00000029;--tw-shadow-colored:inset 0 0 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}#retorik-container.rf-portrait .vertical\\:rf-col-span-full{grid-column:1/-1}#retorik-container.rf-portrait .vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-portrait .vertical\\:rf-row-end-13{grid-row-end:13}#retorik-container.rf-portrait .vertical\\:rf-w-5\\/6{width:83.3333%}#retorik-container.rf-portrait .vertical\\:rf-w-9\\/10{width:90%}#retorik-container.rf-portrait .vertical\\:rf-w-full{width:100%}#retorik-container.rf-portrait .vertical\\:rf-flex-col{flex-direction:column}#retorik-container.rf-portrait .vertical\\:rf-items-center{align-items:center}#retorik-container.rf-portrait .vertical\\:rf-overflow-x-auto{overflow-x:auto}#retorik-container.rf-portrait .vertical\\:rf-border-r-0{border-right-width:0}#retorik-container.rf-portrait .vertical\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-absolute{position:absolute}#retorik-container.rf-large .large\\:rf-left-4{left:1rem}#retorik-container.rf-large .large\\:rf-top-8{top:2rem}#retorik-container.rf-large .large\\:rf-m-8{margin:2rem}#retorik-container.rf-large .large\\:rf-my-0{margin-top:0;margin-bottom:0}#retorik-container.rf-large .large\\:rf-my-3{margin-top:.75rem;margin-bottom:.75rem}#retorik-container.rf-large .large\\:rf-mb-0{margin-bottom:0}#retorik-container.rf-large .large\\:rf-mb-4{margin-bottom:1rem}#retorik-container.rf-large .large\\:rf-mb-6{margin-bottom:1.5rem}#retorik-container.rf-large .large\\:rf-ml-0{margin-left:0}#retorik-container.rf-large .large\\:rf-ml-4{margin-left:1rem}#retorik-container.rf-large .large\\:rf-ml-8{margin-left:2rem}#retorik-container.rf-large .large\\:rf-mr-3{margin-right:.75rem}#retorik-container.rf-large .large\\:rf-mr-30{margin-right:7.5rem}#retorik-container.rf-large .large\\:rf-mt-0{margin-top:0}#retorik-container.rf-large .large\\:rf-mt-20{margin-top:5rem}#retorik-container.rf-large .large\\:rf-mt-3{margin-top:.75rem}#retorik-container.rf-large .large\\:rf-mt-\\[20vh\\]{margin-top:20vh}#retorik-container.rf-large .large\\:rf-block{display:block}#retorik-container.rf-large .large\\:rf-flex{display:flex}#retorik-container.rf-large .large\\:rf-hidden{display:none}#retorik-container.rf-large .large\\:rf-aspect-video{aspect-ratio:16/9}#retorik-container.rf-large .large\\:rf-h-10{height:2.5rem}#retorik-container.rf-large .large\\:rf-h-16{height:4rem}#retorik-container.rf-large .large\\:rf-h-20{height:5rem}#retorik-container.rf-large .large\\:rf-h-3\\/5{height:60%}#retorik-container.rf-large .large\\:rf-h-4{height:1rem}#retorik-container.rf-large .large\\:rf-h-5{height:1.25rem}#retorik-container.rf-large .large\\:rf-h-6{height:1.5rem}#retorik-container.rf-large .large\\:rf-h-8{height:2rem}#retorik-container.rf-large .large\\:rf-h-\\[1\\.3rem\\]{height:1.3rem}#retorik-container.rf-large .large\\:rf-h-\\[60vh\\]{height:60vh}#retorik-container.rf-large .large\\:rf-h-auto{height:auto}#retorik-container.rf-large .large\\:rf-h-full{height:100%}#retorik-container.rf-large .large\\:rf-max-h-28{max-height:7rem}#retorik-container.rf-large .large\\:rf-max-h-\\[2\\.3rem\\]{max-height:2.3rem}#retorik-container.rf-large .large\\:rf-min-h-\\[2\\.3rem\\]{min-height:2.3rem}#retorik-container.rf-large .large\\:rf-w-1\\/8{width:12.5%}#retorik-container.rf-large .large\\:rf-w-14{width:3.5rem}#retorik-container.rf-large .large\\:rf-w-16{width:4rem}#retorik-container.rf-large .large\\:rf-w-4{width:1rem}#retorik-container.rf-large .large\\:rf-w-5{width:1.25rem}#retorik-container.rf-large .large\\:rf-w-6{width:1.5rem}#retorik-container.rf-large .large\\:rf-w-8{width:2rem}#retorik-container.rf-large .large\\:rf-w-fit{width:fit-content}#retorik-container.rf-large .large\\:rf-w-full{width:100%}#retorik-container.rf-large .large\\:rf-min-w-1\\/2{min-width:50%}#retorik-container.rf-large .large\\:rf-min-w-1\\/8{min-width:12.5%}#retorik-container.rf-large .large\\:rf-min-w-16{min-width:4rem}#retorik-container.rf-large .large\\:rf-min-w-8{min-width:2rem}#retorik-container.rf-large .large\\:rf-max-w-1\\/8{max-width:12.5%}#retorik-container.rf-large .large\\:rf-max-w-\\[12rem\\]{max-width:12rem}#retorik-container.rf-large .large\\:rf-max-w-full{max-width:100%}#retorik-container.rf-large .large\\:rf-grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}#retorik-container.rf-large .large\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large .large\\:rf-flex-col{flex-direction:column}#retorik-container.rf-large .large\\:rf-items-baseline{align-items:baseline}#retorik-container.rf-large .large\\:rf-justify-start{justify-content:flex-start}#retorik-container.rf-large .large\\:rf-gap-1{gap:.25rem}#retorik-container.rf-large .large\\:rf-gap-3{gap:.75rem}#retorik-container.rf-large .large\\:rf-gap-4{gap:1rem}#retorik-container.rf-large .large\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large .large\\:rf-overflow-y-scroll{overflow-y:scroll}#retorik-container.rf-large .large\\:rf-border-t-0{border-top-width:0}#retorik-container.rf-large .large\\:rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}#retorik-container.rf-large .large\\:rf-p-4{padding:1rem}#retorik-container.rf-large .large\\:rf-p-\\[25px\\]{padding:25px}#retorik-container.rf-large .large\\:rf-p-min1{padding:.1rem}#retorik-container.rf-large .large\\:rf-px-0{padding-left:0;padding-right:0}#retorik-container.rf-large .large\\:rf-px-16{padding-left:4rem;padding-right:4rem}#retorik-container.rf-large .large\\:rf-px-4{padding-left:1rem;padding-right:1rem}#retorik-container.rf-large .large\\:rf-px-5,#retorik-container.rf-large .large\\:rf-px-6{padding-left:1.5rem;padding-right:1.5rem}#retorik-container.rf-large .large\\:rf-px-8{padding-left:2rem;padding-right:2rem}#retorik-container.rf-large .large\\:rf-py-0{padding-top:0;padding-bottom:0}#retorik-container.rf-large .large\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-py-2{padding-top:.5rem;padding-bottom:.5rem}#retorik-container.rf-large .large\\:rf-py-3{padding-top:.75rem;padding-bottom:.75rem}#retorik-container.rf-large .large\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large .large\\:rf-pb-16{padding-bottom:4rem}#retorik-container.rf-large .large\\:rf-pl-12{padding-left:3rem}#retorik-container.rf-large .large\\:rf-pl-4{padding-left:1rem}#retorik-container.rf-large .large\\:rf-pr-12{padding-right:3rem}#retorik-container.rf-large .large\\:rf-pr-4{padding-right:1rem}#retorik-container.rf-large .large\\:rf-pt-16{padding-top:4rem}#retorik-container.rf-large .large\\:rf-text-5xl{font-size:3rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-6xl{font-size:3.75rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-base{font-size:1rem;line-height:1.5rem}#retorik-container.rf-large .large\\:rf-text-basecustom{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .large\\:rf-text-sm{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .large\\:rf-uppercase{text-transform:uppercase}#retorik-container.rf-tactile .tactile\\:rf-h-4{height:1rem}#retorik-container.rf-tactile .tactile\\:rf-h-6{height:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-w-6{width:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-pt-1\\/5{padding-top:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-absolute{position:absolute}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-left-4{left:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-right-9{right:2.25rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-top-4{top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-2{grid-column-start:2}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-end-8{grid-column-end:8}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-ml-1\\/5{margin-left:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mr-1\\/5{margin-right:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-4{margin-top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[20vh\\]{margin-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[25vh\\]{margin-top:25vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-block{display:block}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-hidden{display:none}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-1\\/2{height:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-14{height:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-24{height:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-5{height:1.25rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-6{height:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-\\[50vh\\]{height:50vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-11\\/12{max-height:91.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-36{max-height:9rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-\\[18vh\\]{max-height:18vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-\\[30vh\\]{max-height:30vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-h-10{min-height:2.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-1\\/2{width:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-14{width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-16{width:4rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-24{width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-3\\/5{width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-6{width:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-full{width:100%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-14{min-width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-24{min-width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-3\\/5{min-width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-2\\/3{max-width:66.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-\\[45\\%\\]{max-width:45%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-\\[60\\%\\]{max-width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-flex-col{flex-direction:column}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-justify-center{justify-content:center}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-gap-4{gap:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-self-start{align-self:flex-start}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t{border-top-width:1px}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity,1))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-5{padding-top:1.5rem;padding-bottom:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pl-0{padding-left:0}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-48{padding-top:12rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-8{padding-top:2rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[16\\.67\\%\\]{padding-top:16.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[20vh\\]{padding-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-text-basecustomuppercase{font-size:1rem;line-height:1.1rem}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-mt-0{margin-top:0}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-flex{display:flex}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-hidden{display:none}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-col-start-3{grid-column-start:3}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-col-start-4{grid-column-start:4}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:-rf-mt-4{margin-top:-1rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-ml-1\\/5{margin-left:20%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-mr-40{margin-right:10rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-h-full{height:100%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-w-\\[48\\%\\]{width:48%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-w-\\[calc\\(80\\%-10rem\\)\\]{width:calc(80% - 10rem)}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-min-w-\\[48\\%\\]{min-width:48%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-max-w-\\[calc\\(\\(80\\%-10rem\\)\\*0\\.75\\)\\]{max-width:calc(60% - 7.5rem)}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:-rf-translate-x-1\\/4{--tw-translate-x:-25%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-flex-col-reverse{flex-direction:column-reverse}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-items-start{align-items:flex-start}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-justify-start{justify-content:flex-start}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-justify-center{justify-content:center}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-self-end{align-self:flex-end}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-justify-self-start{justify-self:start}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pb-2{padding-bottom:.5rem}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pl-1\\/5{padding-left:20%}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pl-\\[calc\\(50\\%-2\\.5rem\\)\\]{padding-left:calc(50% - 2.5rem)}#retorik-container.rf-large:not(.rf-portrait) .landscape-retorik\\:rf-pr-40{padding-right:10rem}#retorik-container.rf-mobile .mobile\\:rf-px-4{padding-left:1rem;padding-right:1rem}#retorik-container.rf-tablet .tablet\\:rf-w-28{width:7rem}#retorik-container.rf-tablet .tablet\\:rf-pl-12{padding-left:3rem}#retorik-container.rf-tablet .tablet\\:rf-pr-24{padding-right:6rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-h-10{height:2.5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-h-20{height:5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-min-h-20{min-height:5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-w-40{width:10rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-p-5{padding:1.5rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-pl-32{padding-left:8rem}#retorik-container.rf-large.rf-portrait:not(.rf-tablet) .borne\\:rf-pr-56{padding-right:14rem}.ltr\\:rf-left-1:where([dir=ltr],[dir=ltr] *){left:.25rem}.ltr\\:rf-col-start-1:where([dir=ltr],[dir=ltr] *){grid-column-start:1}.ltr\\:rf-ml-4:where([dir=ltr],[dir=ltr] *){margin-left:1rem}.ltr\\:rf-self-end:where([dir=ltr],[dir=ltr] *){align-self:flex-end}.ltr\\:rf-pr-2:where([dir=ltr],[dir=ltr] *){padding-right:.5rem}.ltr\\:rf-text-left:where([dir=ltr],[dir=ltr] *){text-align:left}.ltr\\:rf-text-right:where([dir=ltr],[dir=ltr] *){text-align:right}.rtl\\:rf-right-1:where([dir=rtl],[dir=rtl] *){right:.25rem}.rtl\\:rf-col-end-1:where([dir=rtl],[dir=rtl] *){grid-column-end:1}.rtl\\:rf-mr-4:where([dir=rtl],[dir=rtl] *){margin-right:1rem}.rtl\\:rf-self-start:where([dir=rtl],[dir=rtl] *){align-self:flex-start}.rtl\\:rf-pl-2:where([dir=rtl],[dir=rtl] *){padding-left:.5rem}.rtl\\:rf-text-left:where([dir=rtl],[dir=rtl] *){text-align:left}.rtl\\:rf-text-right:where([dir=rtl],[dir=rtl] *){text-align:right}";


var $5bf62910dd3e016b$exports = {};
$5bf62910dd3e016b$exports = ".leaflet-pane,.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile-container,.leaflet-pane>svg,.leaflet-pane>canvas,.leaflet-zoom-box,.leaflet-image-layer,.leaflet-layer{position:absolute;top:0;left:0}.leaflet-container{overflow:hidden}.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow{user-select:none;-webkit-user-drag:none}.leaflet-tile::selection{background:0 0}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{-webkit-transform-origin:0 0;width:1600px;height:1600px}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer,.leaflet-container .leaflet-tile{width:auto;padding:0;max-width:none!important;max-height:none!important}.leaflet-container img.leaflet-tile{mix-blend-mode:plus-lighter}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom;touch-action:none;touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{-ms-touch-action:none;touch-action:none}.leaflet-container{-webkit-tap-highlight-color:transparent}.leaflet-container a{-webkit-tap-highlight-color:#33b5e566}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{box-sizing:border-box;z-index:800;width:0;height:0}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{z-index:800;pointer-events:visiblePainted;pointer-events:auto;position:relative}.leaflet-top,.leaflet-bottom{z-index:1000;pointer-events:none;position:absolute}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup{opacity:0;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{transform-origin:0 0}svg.leaflet-zoom-animated{will-change:transform}.leaflet-zoom-anim .leaflet-zoom-animated{-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);-moz-transition:-moz-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-zoom-anim .leaflet-tile,.leaflet-pan-anim .leaflet-tile{transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-popup-pane,.leaflet-control{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-image-layer,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-marker-icon.leaflet-interactive,.leaflet-image-layer.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container{outline-offset:1px;background:#ddd}.leaflet-container a{color:#0078a8}.leaflet-zoom-box{background:#ffffff80;border:2px dotted #38f}.leaflet-container{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:.75rem;line-height:1.5}.leaflet-bar{border-radius:4px;box-shadow:0 1px 5px #000000a6}.leaflet-bar a{text-align:center;color:#000;background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;text-decoration:none;display:block}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover,.leaflet-bar a:focus{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom:none;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.leaflet-bar a.leaflet-disabled{cursor:default;color:#bbb;background-color:#f4f4f4}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.leaflet-touch .leaflet-bar a:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{text-indent:1px;font:700 18px Lucida Console,Monaco,monospace}.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}.leaflet-control-layers{background:#fff;border-radius:5px;box-shadow:0 1px 5px #0006}.leaflet-control-layers-toggle{background-image:url(layers.760a0456.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(layers-2x.b7b89169.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{color:#333;background:#fff;padding:6px 10px 6px 6px}.leaflet-control-layers-scrollbar{padding-right:5px;overflow:hidden scroll}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{font-size:1.08333em;display:block}.leaflet-control-layers-separator{border-top:1px solid #ddd;height:0;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(marker-icon.3f7d3721.png)}.leaflet-container .leaflet-control-attribution{background:#fffc;margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{color:#333;padding:0 5px;line-height:1.4}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover,.leaflet-control-attribution a:focus{text-decoration:underline}.leaflet-attribution-flag{width:1em;height:.6669em;vertical-align:baseline!important;display:inline!important}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{white-space:nowrap;box-sizing:border-box;text-shadow:1px 1px #fff;background:#fffc;border:2px solid #777;border-top:none;padding:2px 5px 1px;line-height:1.1}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{box-shadow:none}.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{background-clip:padding-box;border:2px solid #0003}.leaflet-popup{text-align:center;margin-bottom:20px;position:absolute}.leaflet-popup-content-wrapper{text-align:left;border-radius:12px;padding:1px}.leaflet-popup-content{min-height:1px;margin:13px 24px 13px 20px;font-size:1.08333em;line-height:1.3}.leaflet-popup-content p{margin:1.3em 0}.leaflet-popup-tip-container{pointer-events:none;width:40px;height:20px;margin-top:-1px;margin-left:-20px;position:absolute;left:50%;overflow:hidden}.leaflet-popup-tip{pointer-events:auto;width:17px;height:17px;margin:-10px auto 0;padding:1px;transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{color:#333;background:#fff;box-shadow:0 3px 14px #0006}.leaflet-container a.leaflet-popup-close-button{text-align:center;color:#757575;background:0 0;border:none;width:24px;height:24px;font:16px/24px Tahoma,Verdana,sans-serif;text-decoration:none;position:absolute;top:0;right:0}.leaflet-container a.leaflet-popup-close-button:hover,.leaflet-container a.leaflet-popup-close-button:focus{color:#585858}.leaflet-popup-scrolled{overflow:auto}.leaflet-oldie .leaflet-popup-content-wrapper{-ms-zoom:1}.leaflet-oldie .leaflet-popup-tip{-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";width:24px;filter:progid:DXImageTransform.Microsoft.Matrix(M11=.707107,M12=.707107,M21=-.707107,M22=.707107);margin:0 auto}.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{color:#222;white-space:nowrap;user-select:none;pointer-events:none;background-color:#fff;border:1px solid #fff;border-radius:3px;padding:6px;position:absolute;box-shadow:0 1px 3px #0006}.leaflet-tooltip.leaflet-interactive{cursor:pointer;pointer-events:auto}.leaflet-tooltip-top:before,.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{pointer-events:none;content:\"\";background:0 0;border:6px solid #0000;position:absolute}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{margin-left:-6px;left:50%}.leaflet-tooltip-top:before{border-top-color:#fff;margin-bottom:-12px;bottom:0}.leaflet-tooltip-bottom:before{border-bottom-color:#fff;margin-top:-12px;margin-left:-6px;top:0}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{margin-top:-6px;top:50%}.leaflet-tooltip-left:before{border-left-color:#fff;margin-right:-12px;right:0}.leaflet-tooltip-right:before{border-right-color:#fff;margin-left:-12px;left:0}@media print{.leaflet-control{-webkit-print-color-adjust:exact;print-color-adjust:exact}}";



var $717Zc = parcelRequire("717Zc");

var $2jBaP = parcelRequire("2jBaP");

var $eyNRs = parcelRequire("eyNRs");
const $3b22c72029a66628$var$DefaultIcon = (0, (/*@__PURE__*/$parcel$interopDefault($2jBaP))).icon({
    iconUrl: `${(0, $717Zc.imageFiles).mapArrival}`,
    shadowUrl: (0, $eyNRs.markerShadow),
    iconSize: [
        32,
        41
    ],
    iconAnchor: [
        10,
        41
    ]
});
(0, (/*@__PURE__*/$parcel$interopDefault($2jBaP))).Marker.prototype.options.icon = $3b22c72029a66628$var$DefaultIcon;
const $3b22c72029a66628$var$ShadowRoot = ({ children: children })=>{
    const visibility = (0, $9JLpC.useViewStore)((state)=>state.visibility);
    const customScripts = (0, $7SHCs.useRetorikStore)((state)=>state.customScripts);
    const customCSS = (0, $7SHCs.useRetorikStore)((state)=>state.customCSS);
    const [alreadyAppliedCustomScripts, setAlreadyAppliedCustomScripts] = (0, $bxRTa.useState)([]);
    const shadowRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        if (shadowRef?.current) customScripts.forEach((customScript)=>{
            if (!alreadyAppliedCustomScripts.includes(customScript)) {
                // Add the URL of the script to the already processed ones to prevent duplicate injection
                setAlreadyAppliedCustomScripts((current)=>[
                        ...current,
                        customScript
                    ]);
                // Create a script element and inject it in the shadowroot
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.src = customScript;
                scriptElement.onload = ()=>{
                    console.log(`Retorik Framework > custom script loaded from ${customScript}`);
                };
                shadowRef.current?.appendChild(scriptElement);
            }
        });
    }, [
        customScripts
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $d3b255846a013166$export$2e2bcd8739ae039).div, {
        id: "retorik-shadow",
        ref: shadowRef,
        className: "rf-w-full rf-h-full",
        style: {
            position: 'relative',
            overscrollBehaviorY: 'contain',
            touchAction: 'pan-x pan-y',
            visibility: visibility
        },
        children: [
            children,
            /*#__PURE__*/ (0, $fl9nK.jsx)("style", {
                type: "text/css",
                children: `${$6db77bfdd410248b$exports}`
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("style", {
                type: "text/css",
                children: `${$5bf62910dd3e016b$exports}`
            }),
            customCSS.map((css, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsx)("link", {
                    rel: "stylesheet",
                    href: css
                }, key);
            })
        ]
    });
};
var $3b22c72029a66628$export$2e2bcd8739ae039 = $3b22c72029a66628$var$ShadowRoot;



var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $8h6ET = parcelRequire("8h6ET");
const $6b7b10b90b820580$export$284b58786299e6c5 = async ({ configurationData: configurationData, baseAddress: baseAddress })=>{
    if (configurationData) {
        if (typeof configurationData.userConsent === 'boolean') return {
            displayGDPR: false,
            userConsent: configurationData.userConsent
        };
        else return {
            displayGDPR: true,
            data: configurationData
        };
    } else {
        const fullAddress = `${baseAddress}api/gdpr/settings`;
        const response = await fetch(fullAddress).then((res)=>res.json()).catch((error)=>{
            console.warn(error);
            return undefined;
        });
        if (response) {
            // Format response data to get a GDPR-type object
            const responseToData = {
                title: {},
                message: {},
                link: {},
                linkURL: undefined,
                buttonAccept: {},
                buttonRefuse: {},
                messageAccepted: {},
                messageRefused: {}
            };
            for(const locale in response.localizationContainer){
                // Title
                response.localizationContainer[locale]?.ConsentTitle && (responseToData.title[locale] = response.localizationContainer[locale]?.ConsentTitle);
                // Message
                response.localizationContainer[locale]?.ConsentBody && (responseToData.message[locale] = response.localizationContainer[locale]?.ConsentBody);
                // Link
                response.localizationContainer[locale]?.PrivacyStatementTitle && (responseToData.link[locale] = response.localizationContainer[locale]?.PrivacyStatementTitle);
                // Message accepted
                response.localizationContainer[locale]?.ConsentAknowledgementAccepted && (responseToData.messageAccepted[locale] = response.localizationContainer[locale]?.ConsentAknowledgementAccepted);
                // Message refused
                response.localizationContainer[locale]?.ConsentAknowledgementRefused && (responseToData.messageRefused[locale] = response.localizationContainer[locale]?.ConsentAknowledgementRefused);
            }
            // LinkURl is the same for all languages
            responseToData.linkURL = response.privacyStatementUrl;
            return {
                displayGDPR: response.enableConsent,
                data: responseToData
            };
        }
    }
    return {
        displayGDPR: false,
        userConsent: false
    };
};
const $6b7b10b90b820580$export$5e05ceb0f0c2d3f = async ({ configurationData: configurationData, baseAddress: baseAddress })=>{
    if (configurationData) {
        if (typeof configurationData.userConsent === 'boolean') return {
            displayGDPR: false,
            userConsent: configurationData.userConsent
        };
        else return {
            displayGDPR: true,
            data: configurationData
        };
    } else {
        const fullAddress = `${baseAddress}api/gdpr/settings`;
        const response = await fetch(fullAddress).then((res)=>res.json()).catch((error)=>{
            console.warn(error);
            return undefined;
        });
        if (response) {
            // Format response data to get a GDPR-type object
            const responseToData = {
                title: {},
                message: {},
                link: {},
                linkURL: undefined,
                buttonAccept: {},
                buttonRefuse: {},
                messageAccepted: {},
                messageRefused: {}
            };
            // Title
            response.consentTitle && (responseToData.title = response.consentTitle);
            // Message
            response?.consentBody && (responseToData.message = response?.consentBody);
            // Link
            response?.privacyStatementTitle && (responseToData.link = response?.privacyStatementTitle);
            // Message accepted
            response?.consentAknowledgementAccepted && (responseToData.messageAccepted = response?.consentAknowledgementAccepted);
            // Message refused
            response?.consentAknowledgementRefused && (responseToData.messageRefused = response?.consentAknowledgementRefused);
            // LinkURl is the same for all languages
            responseToData.linkURL = response.privacyStatementUrl;
            return {
                displayGDPR: response.enableConsent,
                data: responseToData
            };
        }
    }
    return {
        displayGDPR: false,
        userConsent: false
    };
};



var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");
const $af55b6b5b4f24adb$var$getRetorikConfigs = async (props, baseAddress)=>{
    const retorikProps = {
        ...props
    };
    let res = null;
    const fullAddress = `${baseAddress}api/integration/framework`;
    try {
        const response = await fetch(fullAddress);
        const json = await response.json();
        res = $af55b6b5b4f24adb$var$processJson(json, retorikProps, baseAddress);
    } catch (error) {
        console.log(error);
    }
    return res;
};
const $af55b6b5b4f24adb$var$getAddressWithoutTenant = (address, tenant)=>{
    if (tenant && address.indexOf(`/${tenant}`)) address = address.replace(`/${tenant}`, '');
    if (address.endsWith('/')) return address.slice(0, -1);
    return address;
};
var $130716087dbfbbd5$exports = {};
$130716087dbfbbd5$exports = $parcel$resolve("77Gze");



const $af55b6b5b4f24adb$var$processJson = (json, retorikProps, baseAddress)=>{
    if (json) {
        // Get full address for backgrounds & logo
        let logo, background, newsBackground, personnage;
        if (json.personnage) {
            if (json.personnage.indexOf('http') === -1) personnage = `${0, $kdMEA.CDNCharactersAddress}/${json.personnage}`;
            else personnage = json.personnage;
        } else personnage = `${0, $kdMEA.CDNCharactersAddress}/long-shot/zahra`;
        const addressWithoutTenant = $af55b6b5b4f24adb$var$getAddressWithoutTenant(baseAddress, retorikProps.addressData.tenant);
        if (json.logo) logo = `${addressWithoutTenant}${json.logo}`;
        if (json.background?.length) background = `${addressWithoutTenant}${json.background}`;
        else background = new URL($130716087dbfbbd5$exports);
        if (json.newsBackground?.length) newsBackground = `${addressWithoutTenant}${json.newsBackground}`;
        else newsBackground = new URL($130716087dbfbbd5$exports);
        // Handle size & height : string or number
        let size = json.agentSize || undefined;
        if (json.agentSize && !isNaN(+json.agentSize)) size = +json.agentSize // convert to int
        ;
        let height = json.agentHeight || undefined;
        if (json.agentHeight && !isNaN(+json.agentHeight)) height = +json.agentHeight // convert to int
        ;
        // For widget
        // Handle size & height : string or number
        let sizeWidget = json.agentSizeWidget || json.agentSize || undefined;
        if (json.agentSizeWidget && !isNaN(+json.agentSizeWidget)) sizeWidget = +json.agentSizeWidget // convert to int
        ;
        let heightWidget = json.agentHeightWidget || json.agentHeight || undefined;
        if (json.agentHeightWidget && !isNaN(+json.agentHeightWidget)) heightWidget = +json.agentHeightWidget // convert to int
        ;
        // Process token endpoint from manual configuration and incoming data
        let tokenEndpoint = '';
        if (retorikProps.addressData?.directline?.tokenEndpoint) tokenEndpoint = retorikProps.addressData.directline.tokenEndpoint;
        else if (retorikProps.addressData?.baseURI?.includes((0, $kdMEA.webchatTokenRetrievalAddress))) tokenEndpoint = retorikProps.addressData.baseURI;
        else if (json.directLine_tokenEndpoint) tokenEndpoint = json.directLine_tokenEndpoint;
        else tokenEndpoint = `${baseAddress}${0, $kdMEA.webchatTokenRetrievalAddress}`;
        // Prevent passive speech recognition if no name was given for the character.
        // Used for retrocompatibility since v2.0.4
        if (!json.characterName && json.speechRecognitionOptions) json.speechRecognitionOptions.enableContinuousRecognitionOnAllDevices = false, json.speechRecognitionOptions.enableContinuousRecognitionOn = undefined;
        const props = {
            config: {
                fullSize: undefined,
                isUsedOnBorne: undefined,
                locales: {
                    getDefaultFromBrowser: undefined
                },
                position: {
                    searchForLocation: json.detectLocation,
                    latitude: undefined,
                    longitude: undefined,
                    city: undefined,
                    country: undefined
                },
                subtitles: json.subtitles,
                subtitlesPosition: json.subtitlesPosition,
                logo: json.logo ? {
                    src: logo
                } : undefined,
                answerpanel: undefined,
                skipWelcome: json.skipWelcome,
                preventExpectedInputHint: json.preventExpectedInputHint,
                pagination: undefined,
                remote: undefined,
                languageChoiceBottom: undefined,
                companyName: json.companyName,
                companyNameLocalized: json.companyNameLocalized,
                subCompanyMessage: json.subCompanyMessage,
                subCompanyMessageLocalized: json.subCompanyMessageLocalized,
                loaderInformationTexts: {
                    text: {
                        top: json.textModeHomeTitle,
                        bottom: json.textModeHomeSubtitle
                    },
                    vocal: {
                        top: json.voiceModeHomeTitle,
                        bottom: json.voiceModeHomeSubtitle
                    }
                },
                loaderInformationTextsLocalized: {
                    text: {
                        top: json.textModeHomeTitleLocalized,
                        bottom: json.textModeHomeSubtitleLocalized
                    },
                    vocal: {
                        top: json.voiceModeHomeTitleLocalized,
                        bottom: json.voiceModeHomeSubtitleLocalized
                    }
                },
                hideRetorikLogo: json.hideRetorikLogo,
                baseMenu: undefined,
                customMenu: undefined,
                subMenu: undefined,
                menu: json.menu,
                hideMenu: json.hideMenu,
                hideControls: json.hideControls,
                doNotDetectDeviceFromUserAgent: json.doNotDetectDeviceFromUserAgent,
                enableConversationCookie: json.enableConversationCookie,
                conversationCookieMaxAge: json.conversationCookieMaxAge,
                enableTelemetry: json.enableTelemetry,
                allowSwitchLayout: json.allowSwitchLayout,
                forceMobileView: json.forceMobileFullScreenLayout,
                enableSpeechCaching: json.enableSpeechCaching,
                speechRecognitionOptions: {
                    timerBeforeSpeechEnd: json.speechRecognitionOptions?.timerBeforeSpeechEnd,
                    enableActivationSound: json.speechRecognitionOptions?.enableActivationSound,
                    enableContinuousRecognitionOnAllDevices: json.speechRecognitionOptions?.enableContinuousRecognitionOnAllDevices,
                    enableContinuousRecognitionOn: json.speechRecognitionOptions?.enableContinuousRecognitionOn,
                    wakeWords: json.speechRecognitionOptions?.wakeWords,
                    grammars: json.speechRecognitionOptions?.grammars,
                    inputHintBehaviour: json.speechRecognitionOptions?.inputHintBehaviour
                },
                speechSynthesisOptions: json.speechSynthesisOptions,
                enableDocumentPrinting: undefined,
                disableSpeechMode: json.disableSpeechMode,
                disableSound: json.disableSound,
                timerForFilterSelectionListMode: undefined,
                // Pattern != null means not null nor undefined
                useOldRemote: json.useOldRemote != null ? json.useOldRemote : true,
                preventVirtualKeyboard: undefined,
                channelData: json.channelData
            },
            viewsConfig: {
                homeRoute: 'home',
                webcamRotation: undefined,
                views: {
                    home: {
                        background: {
                            style: 'image',
                            image: background,
                            video: undefined,
                            webcam: undefined
                        }
                    },
                    news: {
                        intervalInSeconds: json.newsConfig?.intervalInSeconds || 2,
                        loop: true,
                        openingVideo: json.newsConfig?.openingVideo,
                        endingVideo: json.newsConfig?.endingVideo,
                        background: {
                            style: 'image',
                            image: newsBackground,
                            video: undefined,
                            webcam: undefined
                        },
                        showMenu: undefined,
                        bannerTitle: json.newsConfig?.bannerTitle,
                        bannerTitleLocalized: json.newsConfig?.bannerTitleLocalized,
                        removeTitleFromTextToSpeak: json.newsConfig?.removeTitleFromTextToSpeak,
                        removeSubtitleFromTextToSpeak: json.newsConfig?.removeSubtitleFromTextToSpeak,
                        bannerPosition: json.newsConfig?.bannerPosition,
                        mediaPosition: json.newsConfig?.mediaPosition
                    }
                }
            },
            chatbotData: {
                size: size,
                height: height
            },
            chatbotDataWidget: {
                size: sizeWidget,
                height: heightWidget
            },
            agentData: {
                url: personnage,
                name: json.characterName,
                animationsUrl: json.animationsUrl || undefined
            },
            ponyfillFactoryCredentials: {
                region: json.voiceCredentialsRegion,
                subscriptionKey: json.voiceCredentialsSubscriptionKey,
                speechRecognitionHostnamesRecord: json.speechRecognizerHosts,
                speechRecognitionHostname: undefined,
                speechSynthesisHostname: json.speechSynthesizerHost
            },
            addressData: {
                ...retorikProps.addressData,
                directline: {
                    tokenEndpoint: tokenEndpoint,
                    address: retorikProps.addressData?.directline?.address || json.directLine_address || (0, $kdMEA.defaultDirectLineAddress)
                }
            },
            userData: retorikProps.userData,
            customVoice: {
                voice: json.voice,
                gender: undefined
            },
            colors: {
                theme: json.colorSettings.theme,
                primary: json.colorSettings.primary,
                secondary: json.colorSettings.secondary,
                black: json.colorSettings.black,
                whereToEatColor: json.colorSettings.whereToEatColor,
                whereToSleepColor: json.colorSettings.whereToSleepColor,
                tobeSeenColor: json.colorSettings.tobeSeenColor,
                tobeDoneColor: json.colorSettings.tobeDoneColor,
                localProductsColor: json.colorSettings.localProductsColor,
                servicesColor: json.colorSettings.servicesColor,
                companyName: json.colorSettings.companyName,
                agendaColor: json.colorSettings.agendaColor,
                occupantColor: json.colorSettings.occupantColor,
                loader: {
                    animation: json.colorSettings.loader?.animation,
                    background: json.colorSettings.loader?.background,
                    text: json.colorSettings.loader?.text,
                    toggle: {
                        text: json.colorSettings.loader?.toggle?.text,
                        background: json.colorSettings.loader?.toggle?.background
                    },
                    button: {
                        background: {
                            default: json.colorSettings.loader?.button?.background?.default,
                            hover: json.colorSettings.loader?.button?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.loader?.button?.border?.default,
                            hover: json.colorSettings.loader?.button?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.loader?.button?.text?.default,
                            hover: json.colorSettings.loader?.button?.text?.hover
                        }
                    }
                },
                card: {
                    frame: {
                        background: json.colorSettings.card?.frame?.background,
                        border: json.colorSettings.card?.frame?.border,
                        text: json.colorSettings.card?.frame?.text
                    },
                    button: {
                        background: {
                            default: json.colorSettings.card?.button?.background?.default,
                            hover: json.colorSettings.card?.button?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.card?.button?.border?.default,
                            hover: json.colorSettings.card?.button?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.card?.button?.text?.default,
                            hover: json.colorSettings.card?.button?.text?.hover
                        }
                    },
                    discoverButton: {
                        background: {
                            default: json.colorSettings.card?.discoverButton?.background?.default,
                            hover: json.colorSettings.card?.discoverButton?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.card?.discoverButton?.border?.default,
                            hover: json.colorSettings.card?.discoverButton?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.card?.discoverButton?.text?.default,
                            hover: json.colorSettings.card?.discoverButton?.text?.hover
                        }
                    }
                },
                textMode: {
                    panel: {
                        background: json.colorSettings.textMode?.panel?.background,
                        border: json.colorSettings.textMode?.panel?.border,
                        conversationUser: json.colorSettings.textMode?.panel?.conversationUser,
                        conversationBot: json.colorSettings.textMode?.panel?.conversationBot,
                        backgroundUser: json.colorSettings.textMode?.panel?.backgroundUser,
                        backgroundBot: json.colorSettings.textMode?.panel?.backgroundBot
                    }
                },
                vocalMode: {
                    subtitles: {
                        text: json.colorSettings.vocalMode?.subtitles?.text,
                        background: json.colorSettings.vocalMode?.subtitles?.background
                    }
                },
                formInput: {
                    text: {
                        default: json.colorSettings.formInput?.inputText?.default,
                        hover: json.colorSettings.formInput?.inputText?.hover
                    },
                    inputRadioCheckbox: {
                        unchecked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.background,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.border
                        },
                        checked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.background,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.border,
                            item: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.item
                        }
                    },
                    inputButton: {
                        background: {
                            default: json.colorSettings.formInput?.inputButton?.background?.default,
                            hover: json.colorSettings.formInput?.inputButton?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.formInput?.inputButton?.border?.default,
                            hover: json.colorSettings.formInput?.inputButton?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.formInput?.inputButton?.text?.default,
                            hover: json.colorSettings.formInput?.inputButton?.text?.hover
                        }
                    },
                    likert: {
                        default: json.colorSettings.formInput?.likert?.default,
                        hover: json.colorSettings.formInput?.likert?.hover
                    }
                }
            },
            defaultMode: json.disableSpeechMode ? (0, $2rYkD.Mode).text : json.defaultMode,
            skipLoader: json.skipLoader,
            // Language data
            defaultCulture: json.defaultCulture,
            supportedCultures: json.supportedCultures,
            // Other data
            disableHistory: json.disableHistory,
            customScripts: json.customScripts,
            customCSS: json.customCSS,
            features: json.features
        };
        return props;
    }
    return null;
};
var $af55b6b5b4f24adb$export$2e2bcd8739ae039 = $af55b6b5b4f24adb$var$getRetorikConfigs;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $fP0xm = parcelRequire("fP0xm");

var $aibZy = parcelRequire("aibZy");


var $Zrrxd = parcelRequire("Zrrxd");






var $aF5fn = parcelRequire("aF5fn");
(0, $aF5fn.displayWorkerWarning)();
(0, $fP0xm.default).GlobalWorkerOptions.workerSrc = 'pdf.worker.js';


var $fP0xm = parcelRequire("fP0xm");
var $1654af9fd29b2334$exports = {};
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $1654af9fd29b2334$exports = root.pdfjsWorker = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WorkerTask = exports.WorkerMessageHandler = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _primitives = __w_pdfjs_require__(4);
                var _pdf_manager = __w_pdfjs_require__(6);
                var _annotation = __w_pdfjs_require__(10);
                var _cleanup_helper = __w_pdfjs_require__(68);
                var _writer = __w_pdfjs_require__(73);
                var _message_handler = __w_pdfjs_require__(104);
                var _worker_stream = __w_pdfjs_require__(105);
                var _struct_tree = __w_pdfjs_require__(72);
                class WorkerTask {
                    constructor(name){
                        this.name = name;
                        this.terminated = false;
                        this._capability = new _util.PromiseCapability();
                    }
                    get finished() {
                        return this._capability.promise;
                    }
                    finish() {
                        this._capability.resolve();
                    }
                    terminate() {
                        this.terminated = true;
                    }
                    ensureNotTerminated() {
                        if (this.terminated) throw new Error("Worker task was terminated");
                    }
                }
                exports.WorkerTask = WorkerTask;
                class WorkerMessageHandler {
                    static setup(handler, port) {
                        let testMessageProcessed = false;
                        handler.on("test", function(data) {
                            if (testMessageProcessed) return;
                            testMessageProcessed = true;
                            handler.send("test", data instanceof Uint8Array);
                        });
                        handler.on("configure", function(data) {
                            (0, _util.setVerbosityLevel)(data.verbosity);
                        });
                        handler.on("GetDocRequest", function(data) {
                            return WorkerMessageHandler.createDocumentHandler(data, port);
                        });
                    }
                    static createDocumentHandler(docParams, port) {
                        let pdfManager;
                        let terminated = false;
                        let cancelXHRs = null;
                        const WorkerTasks = new Set();
                        const verbosity = (0, _util.getVerbosityLevel)();
                        const { docId: docId, apiVersion: apiVersion } = docParams;
                        const workerVersion = '3.11.174';
                        if (apiVersion !== workerVersion) throw new Error(`The API version "${apiVersion}" does not match ` + `the Worker version "${workerVersion}".`);
                        const enumerableProperties = [];
                        for(const property in [])enumerableProperties.push(property);
                        if (enumerableProperties.length) throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + enumerableProperties.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
                        const workerHandlerName = docId + "_worker";
                        let handler = new _message_handler.MessageHandler(workerHandlerName, docId, port);
                        function ensureNotTerminated() {
                            if (terminated) throw new Error("Worker was terminated");
                        }
                        function startWorkerTask(task) {
                            WorkerTasks.add(task);
                        }
                        function finishWorkerTask(task) {
                            task.finish();
                            WorkerTasks.delete(task);
                        }
                        async function loadDocument(recoveryMode) {
                            await pdfManager.ensureDoc("checkHeader");
                            await pdfManager.ensureDoc("parseStartXRef");
                            await pdfManager.ensureDoc("parse", [
                                recoveryMode
                            ]);
                            await pdfManager.ensureDoc("checkFirstPage", [
                                recoveryMode
                            ]);
                            await pdfManager.ensureDoc("checkLastPage", [
                                recoveryMode
                            ]);
                            const isPureXfa = await pdfManager.ensureDoc("isPureXfa");
                            if (isPureXfa) {
                                const task = new WorkerTask("loadXfaFonts");
                                startWorkerTask(task);
                                await Promise.all([
                                    pdfManager.loadXfaFonts(handler, task).catch((reason)=>{}).then(()=>finishWorkerTask(task)),
                                    pdfManager.loadXfaImages()
                                ]);
                            }
                            const [numPages, fingerprints] = await Promise.all([
                                pdfManager.ensureDoc("numPages"),
                                pdfManager.ensureDoc("fingerprints")
                            ]);
                            const htmlForXfa = isPureXfa ? await pdfManager.ensureDoc("htmlForXfa") : null;
                            return {
                                numPages: numPages,
                                fingerprints: fingerprints,
                                htmlForXfa: htmlForXfa
                            };
                        }
                        function getPdfManager({ data: data, password: password, disableAutoFetch: disableAutoFetch, rangeChunkSize: rangeChunkSize, length: length, docBaseUrl: docBaseUrl, enableXfa: enableXfa, evaluatorOptions: evaluatorOptions }) {
                            const pdfManagerArgs = {
                                source: null,
                                disableAutoFetch: disableAutoFetch,
                                docBaseUrl: docBaseUrl,
                                docId: docId,
                                enableXfa: enableXfa,
                                evaluatorOptions: evaluatorOptions,
                                handler: handler,
                                length: length,
                                password: password,
                                rangeChunkSize: rangeChunkSize
                            };
                            const pdfManagerCapability = new _util.PromiseCapability();
                            let newPdfManager;
                            if (data) {
                                try {
                                    pdfManagerArgs.source = data;
                                    newPdfManager = new _pdf_manager.LocalPdfManager(pdfManagerArgs);
                                    pdfManagerCapability.resolve(newPdfManager);
                                } catch (ex) {
                                    pdfManagerCapability.reject(ex);
                                }
                                return pdfManagerCapability.promise;
                            }
                            let pdfStream, cachedChunks = [];
                            try {
                                pdfStream = new _worker_stream.PDFWorkerStream(handler);
                            } catch (ex) {
                                pdfManagerCapability.reject(ex);
                                return pdfManagerCapability.promise;
                            }
                            const fullRequest = pdfStream.getFullReader();
                            fullRequest.headersReady.then(function() {
                                if (!fullRequest.isRangeSupported) return;
                                pdfManagerArgs.source = pdfStream;
                                pdfManagerArgs.length = fullRequest.contentLength;
                                pdfManagerArgs.disableAutoFetch ||= fullRequest.isStreamingSupported;
                                newPdfManager = new _pdf_manager.NetworkPdfManager(pdfManagerArgs);
                                for (const chunk of cachedChunks)newPdfManager.sendProgressiveData(chunk);
                                cachedChunks = [];
                                pdfManagerCapability.resolve(newPdfManager);
                                cancelXHRs = null;
                            }).catch(function(reason) {
                                pdfManagerCapability.reject(reason);
                                cancelXHRs = null;
                            });
                            let loaded = 0;
                            const flushChunks = function() {
                                const pdfFile = (0, _core_utils.arrayBuffersToBytes)(cachedChunks);
                                if (length && pdfFile.length !== length) (0, _util.warn)("reported HTTP length is different from actual");
                                try {
                                    pdfManagerArgs.source = pdfFile;
                                    newPdfManager = new _pdf_manager.LocalPdfManager(pdfManagerArgs);
                                    pdfManagerCapability.resolve(newPdfManager);
                                } catch (ex) {
                                    pdfManagerCapability.reject(ex);
                                }
                                cachedChunks = [];
                            };
                            new Promise(function(resolve, reject) {
                                const readChunk = function({ value: value, done: done }) {
                                    try {
                                        ensureNotTerminated();
                                        if (done) {
                                            if (!newPdfManager) flushChunks();
                                            cancelXHRs = null;
                                            return;
                                        }
                                        loaded += value.byteLength;
                                        if (!fullRequest.isStreamingSupported) handler.send("DocProgress", {
                                            loaded: loaded,
                                            total: Math.max(loaded, fullRequest.contentLength || 0)
                                        });
                                        if (newPdfManager) newPdfManager.sendProgressiveData(value);
                                        else cachedChunks.push(value);
                                        fullRequest.read().then(readChunk, reject);
                                    } catch (e) {
                                        reject(e);
                                    }
                                };
                                fullRequest.read().then(readChunk, reject);
                            }).catch(function(e) {
                                pdfManagerCapability.reject(e);
                                cancelXHRs = null;
                            });
                            cancelXHRs = function(reason) {
                                pdfStream.cancelAllRequests(reason);
                            };
                            return pdfManagerCapability.promise;
                        }
                        function setupDoc(data) {
                            function onSuccess(doc) {
                                ensureNotTerminated();
                                handler.send("GetDoc", {
                                    pdfInfo: doc
                                });
                            }
                            function onFailure(ex) {
                                ensureNotTerminated();
                                if (ex instanceof _util.PasswordException) {
                                    const task = new WorkerTask(`PasswordException: response ${ex.code}`);
                                    startWorkerTask(task);
                                    handler.sendWithPromise("PasswordRequest", ex).then(function({ password: password }) {
                                        finishWorkerTask(task);
                                        pdfManager.updatePassword(password);
                                        pdfManagerReady();
                                    }).catch(function() {
                                        finishWorkerTask(task);
                                        handler.send("DocException", ex);
                                    });
                                } else if (ex instanceof _util.InvalidPDFException || ex instanceof _util.MissingPDFException || ex instanceof _util.UnexpectedResponseException || ex instanceof _util.UnknownErrorException) handler.send("DocException", ex);
                                else handler.send("DocException", new _util.UnknownErrorException(ex.message, ex.toString()));
                            }
                            function pdfManagerReady() {
                                ensureNotTerminated();
                                loadDocument(false).then(onSuccess, function(reason) {
                                    ensureNotTerminated();
                                    if (!(reason instanceof _core_utils.XRefParseException)) {
                                        onFailure(reason);
                                        return;
                                    }
                                    pdfManager.requestLoadedStream().then(function() {
                                        ensureNotTerminated();
                                        loadDocument(true).then(onSuccess, onFailure);
                                    });
                                });
                            }
                            ensureNotTerminated();
                            getPdfManager(data).then(function(newPdfManager) {
                                if (terminated) {
                                    newPdfManager.terminate(new _util.AbortException("Worker was terminated."));
                                    throw new Error("Worker was terminated");
                                }
                                pdfManager = newPdfManager;
                                pdfManager.requestLoadedStream(true).then((stream)=>{
                                    handler.send("DataLoaded", {
                                        length: stream.bytes.byteLength
                                    });
                                });
                            }).then(pdfManagerReady, onFailure);
                        }
                        handler.on("GetPage", function(data) {
                            return pdfManager.getPage(data.pageIndex).then(function(page) {
                                return Promise.all([
                                    pdfManager.ensure(page, "rotate"),
                                    pdfManager.ensure(page, "ref"),
                                    pdfManager.ensure(page, "userUnit"),
                                    pdfManager.ensure(page, "view")
                                ]).then(function([rotate, ref, userUnit, view]) {
                                    return {
                                        rotate: rotate,
                                        ref: ref,
                                        userUnit: userUnit,
                                        view: view
                                    };
                                });
                            });
                        });
                        handler.on("GetPageIndex", function(data) {
                            const pageRef = _primitives.Ref.get(data.num, data.gen);
                            return pdfManager.ensureCatalog("getPageIndex", [
                                pageRef
                            ]);
                        });
                        handler.on("GetDestinations", function(data) {
                            return pdfManager.ensureCatalog("destinations");
                        });
                        handler.on("GetDestination", function(data) {
                            return pdfManager.ensureCatalog("getDestination", [
                                data.id
                            ]);
                        });
                        handler.on("GetPageLabels", function(data) {
                            return pdfManager.ensureCatalog("pageLabels");
                        });
                        handler.on("GetPageLayout", function(data) {
                            return pdfManager.ensureCatalog("pageLayout");
                        });
                        handler.on("GetPageMode", function(data) {
                            return pdfManager.ensureCatalog("pageMode");
                        });
                        handler.on("GetViewerPreferences", function(data) {
                            return pdfManager.ensureCatalog("viewerPreferences");
                        });
                        handler.on("GetOpenAction", function(data) {
                            return pdfManager.ensureCatalog("openAction");
                        });
                        handler.on("GetAttachments", function(data) {
                            return pdfManager.ensureCatalog("attachments");
                        });
                        handler.on("GetDocJSActions", function(data) {
                            return pdfManager.ensureCatalog("jsActions");
                        });
                        handler.on("GetPageJSActions", function({ pageIndex: pageIndex }) {
                            return pdfManager.getPage(pageIndex).then(function(page) {
                                return pdfManager.ensure(page, "jsActions");
                            });
                        });
                        handler.on("GetOutline", function(data) {
                            return pdfManager.ensureCatalog("documentOutline");
                        });
                        handler.on("GetOptionalContentConfig", function(data) {
                            return pdfManager.ensureCatalog("optionalContentConfig");
                        });
                        handler.on("GetPermissions", function(data) {
                            return pdfManager.ensureCatalog("permissions");
                        });
                        handler.on("GetMetadata", function(data) {
                            return Promise.all([
                                pdfManager.ensureDoc("documentInfo"),
                                pdfManager.ensureCatalog("metadata")
                            ]);
                        });
                        handler.on("GetMarkInfo", function(data) {
                            return pdfManager.ensureCatalog("markInfo");
                        });
                        handler.on("GetData", function(data) {
                            return pdfManager.requestLoadedStream().then(function(stream) {
                                return stream.bytes;
                            });
                        });
                        handler.on("GetAnnotations", function({ pageIndex: pageIndex, intent: intent }) {
                            return pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`GetAnnotations: page ${pageIndex}`);
                                startWorkerTask(task);
                                return page.getAnnotationsData(handler, task, intent).then((data)=>{
                                    finishWorkerTask(task);
                                    return data;
                                }, (reason)=>{
                                    finishWorkerTask(task);
                                    throw reason;
                                });
                            });
                        });
                        handler.on("GetFieldObjects", function(data) {
                            return pdfManager.ensureDoc("fieldObjects");
                        });
                        handler.on("HasJSActions", function(data) {
                            return pdfManager.ensureDoc("hasJSActions");
                        });
                        handler.on("GetCalculationOrderIds", function(data) {
                            return pdfManager.ensureDoc("calculationOrderIds");
                        });
                        handler.on("SaveDocument", async function({ isPureXfa: isPureXfa, numPages: numPages, annotationStorage: annotationStorage, filename: filename }) {
                            const globalPromises = [
                                pdfManager.requestLoadedStream(),
                                pdfManager.ensureCatalog("acroForm"),
                                pdfManager.ensureCatalog("acroFormRef"),
                                pdfManager.ensureDoc("startXRef"),
                                pdfManager.ensureDoc("xref"),
                                pdfManager.ensureDoc("linearization"),
                                pdfManager.ensureCatalog("structTreeRoot")
                            ];
                            const promises = [];
                            const newAnnotationsByPage = !isPureXfa ? (0, _core_utils.getNewAnnotationsMap)(annotationStorage) : null;
                            const [stream, acroForm, acroFormRef, startXRef, xref, linearization, _structTreeRoot] = await Promise.all(globalPromises);
                            const catalogRef = xref.trailer.getRaw("Root") || null;
                            let structTreeRoot;
                            if (newAnnotationsByPage) {
                                if (!_structTreeRoot) {
                                    if (await _struct_tree.StructTreeRoot.canCreateStructureTree({
                                        catalogRef: catalogRef,
                                        pdfManager: pdfManager,
                                        newAnnotationsByPage: newAnnotationsByPage
                                    })) structTreeRoot = null;
                                } else if (await _structTreeRoot.canUpdateStructTree({
                                    pdfManager: pdfManager,
                                    newAnnotationsByPage: newAnnotationsByPage
                                })) structTreeRoot = _structTreeRoot;
                                const imagePromises = _annotation.AnnotationFactory.generateImages(annotationStorage.values(), xref, pdfManager.evaluatorOptions.isOffscreenCanvasSupported);
                                const newAnnotationPromises = structTreeRoot === undefined ? promises : [];
                                for (const [pageIndex, annotations] of newAnnotationsByPage)newAnnotationPromises.push(pdfManager.getPage(pageIndex).then((page)=>{
                                    const task = new WorkerTask(`Save (editor): page ${pageIndex}`);
                                    return page.saveNewAnnotations(handler, task, annotations, imagePromises).finally(function() {
                                        finishWorkerTask(task);
                                    });
                                }));
                                if (structTreeRoot === null) promises.push(Promise.all(newAnnotationPromises).then(async (newRefs)=>{
                                    await _struct_tree.StructTreeRoot.createStructureTree({
                                        newAnnotationsByPage: newAnnotationsByPage,
                                        xref: xref,
                                        catalogRef: catalogRef,
                                        pdfManager: pdfManager,
                                        newRefs: newRefs
                                    });
                                    return newRefs;
                                }));
                                else if (structTreeRoot) promises.push(Promise.all(newAnnotationPromises).then(async (newRefs)=>{
                                    await structTreeRoot.updateStructureTree({
                                        newAnnotationsByPage: newAnnotationsByPage,
                                        pdfManager: pdfManager,
                                        newRefs: newRefs
                                    });
                                    return newRefs;
                                }));
                            }
                            if (isPureXfa) promises.push(pdfManager.serializeXfaData(annotationStorage));
                            else for(let pageIndex = 0; pageIndex < numPages; pageIndex++)promises.push(pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`Save: page ${pageIndex}`);
                                return page.save(handler, task, annotationStorage).finally(function() {
                                    finishWorkerTask(task);
                                });
                            }));
                            const refs = await Promise.all(promises);
                            let newRefs = [];
                            let xfaData = null;
                            if (isPureXfa) {
                                xfaData = refs[0];
                                if (!xfaData) return stream.bytes;
                            } else {
                                newRefs = refs.flat(2);
                                if (newRefs.length === 0) return stream.bytes;
                            }
                            const needAppearances = acroFormRef && acroForm instanceof _primitives.Dict && newRefs.some((ref)=>ref.needAppearances);
                            const xfa = acroForm instanceof _primitives.Dict && acroForm.get("XFA") || null;
                            let xfaDatasetsRef = null;
                            let hasXfaDatasetsEntry = false;
                            if (Array.isArray(xfa)) {
                                for(let i = 0, ii = xfa.length; i < ii; i += 2)if (xfa[i] === "datasets") {
                                    xfaDatasetsRef = xfa[i + 1];
                                    hasXfaDatasetsEntry = true;
                                }
                                if (xfaDatasetsRef === null) xfaDatasetsRef = xref.getNewTemporaryRef();
                            } else if (xfa) (0, _util.warn)("Unsupported XFA type.");
                            let newXrefInfo = Object.create(null);
                            if (xref.trailer) {
                                const infoObj = Object.create(null);
                                const xrefInfo = xref.trailer.get("Info") || null;
                                if (xrefInfo instanceof _primitives.Dict) xrefInfo.forEach((key, value)=>{
                                    if (typeof value === "string") infoObj[key] = (0, _util.stringToPDFString)(value);
                                });
                                newXrefInfo = {
                                    rootRef: catalogRef,
                                    encryptRef: xref.trailer.getRaw("Encrypt") || null,
                                    newRef: xref.getNewTemporaryRef(),
                                    infoRef: xref.trailer.getRaw("Info") || null,
                                    info: infoObj,
                                    fileIds: xref.trailer.get("ID") || null,
                                    startXRef: linearization ? startXRef : xref.lastXRefStreamPos ?? startXRef,
                                    filename: filename
                                };
                            }
                            return (0, _writer.incrementalUpdate)({
                                originalData: stream.bytes,
                                xrefInfo: newXrefInfo,
                                newRefs: newRefs,
                                xref: xref,
                                hasXfa: !!xfa,
                                xfaDatasetsRef: xfaDatasetsRef,
                                hasXfaDatasetsEntry: hasXfaDatasetsEntry,
                                needAppearances: needAppearances,
                                acroFormRef: acroFormRef,
                                acroForm: acroForm,
                                xfaData: xfaData
                            }).finally(()=>{
                                xref.resetNewTemporaryRef();
                            });
                        });
                        handler.on("GetOperatorList", function(data, sink) {
                            const pageIndex = data.pageIndex;
                            pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`GetOperatorList: page ${pageIndex}`);
                                startWorkerTask(task);
                                const start = verbosity >= _util.VerbosityLevel.INFOS ? Date.now() : 0;
                                page.getOperatorList({
                                    handler: handler,
                                    sink: sink,
                                    task: task,
                                    intent: data.intent,
                                    cacheKey: data.cacheKey,
                                    annotationStorage: data.annotationStorage
                                }).then(function(operatorListInfo) {
                                    finishWorkerTask(task);
                                    if (start) (0, _util.info)(`page=${pageIndex + 1} - getOperatorList: time=` + `${Date.now() - start}ms, len=${operatorListInfo.length}`);
                                    sink.close();
                                }, function(reason) {
                                    finishWorkerTask(task);
                                    if (task.terminated) return;
                                    sink.error(reason);
                                });
                            });
                        });
                        handler.on("GetTextContent", function(data, sink) {
                            const { pageIndex: pageIndex, includeMarkedContent: includeMarkedContent, disableNormalization: disableNormalization } = data;
                            pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask("GetTextContent: page " + pageIndex);
                                startWorkerTask(task);
                                const start = verbosity >= _util.VerbosityLevel.INFOS ? Date.now() : 0;
                                page.extractTextContent({
                                    handler: handler,
                                    task: task,
                                    sink: sink,
                                    includeMarkedContent: includeMarkedContent,
                                    disableNormalization: disableNormalization
                                }).then(function() {
                                    finishWorkerTask(task);
                                    if (start) (0, _util.info)(`page=${pageIndex + 1} - getTextContent: time=` + `${Date.now() - start}ms`);
                                    sink.close();
                                }, function(reason) {
                                    finishWorkerTask(task);
                                    if (task.terminated) return;
                                    sink.error(reason);
                                });
                            });
                        });
                        handler.on("GetStructTree", function(data) {
                            return pdfManager.getPage(data.pageIndex).then(function(page) {
                                return pdfManager.ensure(page, "getStructTree");
                            });
                        });
                        handler.on("FontFallback", function(data) {
                            return pdfManager.fontFallback(data.id, handler);
                        });
                        handler.on("Cleanup", function(data) {
                            return pdfManager.cleanup(true);
                        });
                        handler.on("Terminate", function(data) {
                            terminated = true;
                            const waitOn = [];
                            if (pdfManager) {
                                pdfManager.terminate(new _util.AbortException("Worker was terminated."));
                                const cleanupPromise = pdfManager.cleanup();
                                waitOn.push(cleanupPromise);
                                pdfManager = null;
                            } else (0, _cleanup_helper.clearGlobalCaches)();
                            if (cancelXHRs) cancelXHRs(new _util.AbortException("Worker was terminated."));
                            for (const task of WorkerTasks){
                                waitOn.push(task.finished);
                                task.terminate();
                            }
                            return Promise.all(waitOn).then(function() {
                                handler.destroy();
                                handler = null;
                            });
                        });
                        handler.on("Ready", function(data) {
                            setupDoc(docParams);
                            docParams = null;
                        });
                        return workerHandlerName;
                    }
                    static initializeFromPort(port) {
                        const handler = new _message_handler.MessageHandler("worker", "main", port);
                        WorkerMessageHandler.setup(handler, port);
                        handler.send("ready", null);
                    }
                }
                exports.WorkerMessageHandler = WorkerMessageHandler;
                function isMessagePort(maybePort) {
                    return typeof maybePort.postMessage === "function" && "onmessage" in maybePort;
                }
                if (typeof window === "undefined" && !_util.isNodeJS && typeof self !== "undefined" && isMessagePort(self)) WorkerMessageHandler.initializeFromPort(self);
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = false;
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xEF") {
                        let encoding;
                        if (str[0] === "\xFE" && str[1] === "\xFF") encoding = "utf-16be";
                        else if (str[0] === "\xFF" && str[1] === "\xFE") encoding = "utf-16le";
                        else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XRefParseException = exports.XRefEntryException = exports.ParserEOFException = exports.PDF_VERSION_REGEXP = exports.MissingDataException = void 0;
                exports.arrayBuffersToBytes = arrayBuffersToBytes;
                exports.collectActions = collectActions;
                exports.encodeToXmlString = encodeToXmlString;
                exports.escapePDFName = escapePDFName;
                exports.escapeString = escapeString;
                exports.getInheritableProperty = getInheritableProperty;
                exports.getLookupTableFactory = getLookupTableFactory;
                exports.getNewAnnotationsMap = getNewAnnotationsMap;
                exports.getRotationMatrix = getRotationMatrix;
                exports.isAscii = isAscii;
                exports.isWhiteSpace = isWhiteSpace;
                exports.log2 = log2;
                exports.numberToString = numberToString;
                exports.parseXFAPath = parseXFAPath;
                exports.readInt8 = readInt8;
                exports.readUint16 = readUint16;
                exports.readUint32 = readUint32;
                exports.recoverJsURL = recoverJsURL;
                exports.stringToUTF16HexString = stringToUTF16HexString;
                exports.stringToUTF16String = stringToUTF16String;
                exports.toRomanNumerals = toRomanNumerals;
                exports.validateCSSFont = validateCSSFont;
                exports.validateFontName = validateFontName;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                const PDF_VERSION_REGEXP = /^[1-9]\.\d$/;
                exports.PDF_VERSION_REGEXP = PDF_VERSION_REGEXP;
                function getLookupTableFactory(initializer) {
                    let lookup;
                    return function() {
                        if (initializer) {
                            lookup = Object.create(null);
                            initializer(lookup);
                            initializer = null;
                        }
                        return lookup;
                    };
                }
                class MissingDataException extends _util.BaseException {
                    constructor(begin, end){
                        super(`Missing data [${begin}, ${end})`, "MissingDataException");
                        this.begin = begin;
                        this.end = end;
                    }
                }
                exports.MissingDataException = MissingDataException;
                class ParserEOFException extends _util.BaseException {
                    constructor(msg){
                        super(msg, "ParserEOFException");
                    }
                }
                exports.ParserEOFException = ParserEOFException;
                class XRefEntryException extends _util.BaseException {
                    constructor(msg){
                        super(msg, "XRefEntryException");
                    }
                }
                exports.XRefEntryException = XRefEntryException;
                class XRefParseException extends _util.BaseException {
                    constructor(msg){
                        super(msg, "XRefParseException");
                    }
                }
                exports.XRefParseException = XRefParseException;
                function arrayBuffersToBytes(arr) {
                    const length = arr.length;
                    if (length === 0) return new Uint8Array(0);
                    if (length === 1) return new Uint8Array(arr[0]);
                    let dataLength = 0;
                    for(let i = 0; i < length; i++)dataLength += arr[i].byteLength;
                    const data = new Uint8Array(dataLength);
                    let pos = 0;
                    for(let i = 0; i < length; i++){
                        const item = new Uint8Array(arr[i]);
                        data.set(item, pos);
                        pos += item.byteLength;
                    }
                    return data;
                }
                function getInheritableProperty({ dict: dict, key: key, getArray: getArray = false, stopWhenFound: stopWhenFound = true }) {
                    let values;
                    const visited = new _primitives.RefSet();
                    while(dict instanceof _primitives.Dict && !(dict.objId && visited.has(dict.objId))){
                        if (dict.objId) visited.put(dict.objId);
                        const value = getArray ? dict.getArray(key) : dict.get(key);
                        if (value !== undefined) {
                            if (stopWhenFound) return value;
                            (values ||= []).push(value);
                        }
                        dict = dict.get("Parent");
                    }
                    return values;
                }
                const ROMAN_NUMBER_MAP = [
                    "",
                    "C",
                    "CC",
                    "CCC",
                    "CD",
                    "D",
                    "DC",
                    "DCC",
                    "DCCC",
                    "CM",
                    "",
                    "X",
                    "XX",
                    "XXX",
                    "XL",
                    "L",
                    "LX",
                    "LXX",
                    "LXXX",
                    "XC",
                    "",
                    "I",
                    "II",
                    "III",
                    "IV",
                    "V",
                    "VI",
                    "VII",
                    "VIII",
                    "IX"
                ];
                function toRomanNumerals(number, lowerCase = false) {
                    (0, _util.assert)(Number.isInteger(number) && number > 0, "The number should be a positive integer.");
                    const romanBuf = [];
                    let pos;
                    while(number >= 1000){
                        number -= 1000;
                        romanBuf.push("M");
                    }
                    pos = number / 100 | 0;
                    number %= 100;
                    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
                    pos = number / 10 | 0;
                    number %= 10;
                    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
                    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
                    const romanStr = romanBuf.join("");
                    return lowerCase ? romanStr.toLowerCase() : romanStr;
                }
                function log2(x) {
                    if (x <= 0) return 0;
                    return Math.ceil(Math.log2(x));
                }
                function readInt8(data, offset) {
                    return data[offset] << 24 >> 24;
                }
                function readUint16(data, offset) {
                    return data[offset] << 8 | data[offset + 1];
                }
                function readUint32(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
                }
                function isWhiteSpace(ch) {
                    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
                }
                function parseXFAPath(path) {
                    const positionPattern = /(.+)\[(\d+)\]$/;
                    return path.split(".").map((component)=>{
                        const m = component.match(positionPattern);
                        if (m) return {
                            name: m[1],
                            pos: parseInt(m[2], 10)
                        };
                        return {
                            name: component,
                            pos: 0
                        };
                    });
                }
                function escapePDFName(str) {
                    const buffer = [];
                    let start = 0;
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        if (char < 0x21 || char > 0x7e || char === 0x23 || char === 0x28 || char === 0x29 || char === 0x3c || char === 0x3e || char === 0x5b || char === 0x5d || char === 0x7b || char === 0x7d || char === 0x2f || char === 0x25) {
                            if (start < i) buffer.push(str.substring(start, i));
                            buffer.push(`#${char.toString(16)}`);
                            start = i + 1;
                        }
                    }
                    if (buffer.length === 0) return str;
                    if (start < str.length) buffer.push(str.substring(start, str.length));
                    return buffer.join("");
                }
                function escapeString(str) {
                    return str.replaceAll(/([()\\\n\r])/g, (match)=>{
                        if (match === "\n") return "\\n";
                        else if (match === "\r") return "\\r";
                        return `\\${match}`;
                    });
                }
                function _collectJS(entry, xref, list, parents) {
                    if (!entry) return;
                    let parent = null;
                    if (entry instanceof _primitives.Ref) {
                        if (parents.has(entry)) return;
                        parent = entry;
                        parents.put(parent);
                        entry = xref.fetch(entry);
                    }
                    if (Array.isArray(entry)) for (const element of entry)_collectJS(element, xref, list, parents);
                    else if (entry instanceof _primitives.Dict) {
                        if ((0, _primitives.isName)(entry.get("S"), "JavaScript")) {
                            const js = entry.get("JS");
                            let code;
                            if (js instanceof _base_stream.BaseStream) code = js.getString();
                            else if (typeof js === "string") code = js;
                            code &&= (0, _util.stringToPDFString)(code).replaceAll("\x00", "");
                            if (code) list.push(code);
                        }
                        _collectJS(entry.getRaw("Next"), xref, list, parents);
                    }
                    if (parent) parents.remove(parent);
                }
                function collectActions(xref, dict, eventType) {
                    const actions = Object.create(null);
                    const additionalActionsDicts = getInheritableProperty({
                        dict: dict,
                        key: "AA",
                        stopWhenFound: false
                    });
                    if (additionalActionsDicts) for(let i = additionalActionsDicts.length - 1; i >= 0; i--){
                        const additionalActions = additionalActionsDicts[i];
                        if (!(additionalActions instanceof _primitives.Dict)) continue;
                        for (const key of additionalActions.getKeys()){
                            const action = eventType[key];
                            if (!action) continue;
                            const actionDict = additionalActions.getRaw(key);
                            const parents = new _primitives.RefSet();
                            const list = [];
                            _collectJS(actionDict, xref, list, parents);
                            if (list.length > 0) actions[action] = list;
                        }
                    }
                    if (dict.has("A")) {
                        const actionDict = dict.get("A");
                        const parents = new _primitives.RefSet();
                        const list = [];
                        _collectJS(actionDict, xref, list, parents);
                        if (list.length > 0) actions.Action = list;
                    }
                    return (0, _util.objectSize)(actions) > 0 ? actions : null;
                }
                const XMLEntities = {
                    0x3c: "&lt;",
                    0x3e: "&gt;",
                    0x26: "&amp;",
                    0x22: "&quot;",
                    0x27: "&apos;"
                };
                function encodeToXmlString(str) {
                    const buffer = [];
                    let start = 0;
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.codePointAt(i);
                        if (0x20 <= char && char <= 0x7e) {
                            const entity = XMLEntities[char];
                            if (entity) {
                                if (start < i) buffer.push(str.substring(start, i));
                                buffer.push(entity);
                                start = i + 1;
                            }
                        } else {
                            if (start < i) buffer.push(str.substring(start, i));
                            buffer.push(`&#x${char.toString(16).toUpperCase()};`);
                            if (char > 0xd7ff && (char < 0xe000 || char > 0xfffd)) i++;
                            start = i + 1;
                        }
                    }
                    if (buffer.length === 0) return str;
                    if (start < str.length) buffer.push(str.substring(start, str.length));
                    return buffer.join("");
                }
                function validateFontName(fontFamily, mustWarn = false) {
                    const m = /^("|').*("|')$/.exec(fontFamily);
                    if (m && m[1] === m[2]) {
                        const re = new RegExp(`[^\\\\]${m[1]}`);
                        if (re.test(fontFamily.slice(1, -1))) {
                            if (mustWarn) (0, _util.warn)(`FontFamily contains unescaped ${m[1]}: ${fontFamily}.`);
                            return false;
                        }
                    } else {
                        for (const ident of fontFamily.split(/[ \t]+/))if (/^(\d|(-(\d|-)))/.test(ident) || !/^[\w-\\]+$/.test(ident)) {
                            if (mustWarn) (0, _util.warn)(`FontFamily contains invalid <custom-ident>: ${fontFamily}.`);
                            return false;
                        }
                    }
                    return true;
                }
                function validateCSSFont(cssFontInfo) {
                    const DEFAULT_CSS_FONT_OBLIQUE = "14";
                    const DEFAULT_CSS_FONT_WEIGHT = "400";
                    const CSS_FONT_WEIGHT_VALUES = new Set([
                        "100",
                        "200",
                        "300",
                        "400",
                        "500",
                        "600",
                        "700",
                        "800",
                        "900",
                        "1000",
                        "normal",
                        "bold",
                        "bolder",
                        "lighter"
                    ]);
                    const { fontFamily: fontFamily, fontWeight: fontWeight, italicAngle: italicAngle } = cssFontInfo;
                    if (!validateFontName(fontFamily, true)) return false;
                    const weight = fontWeight ? fontWeight.toString() : "";
                    cssFontInfo.fontWeight = CSS_FONT_WEIGHT_VALUES.has(weight) ? weight : DEFAULT_CSS_FONT_WEIGHT;
                    const angle = parseFloat(italicAngle);
                    cssFontInfo.italicAngle = isNaN(angle) || angle < -90 || angle > 90 ? DEFAULT_CSS_FONT_OBLIQUE : italicAngle.toString();
                    return true;
                }
                function recoverJsURL(str) {
                    const URL_OPEN_METHODS = [
                        "app.launchURL",
                        "window.open",
                        "xfa.host.gotoURL"
                    ];
                    const regex = new RegExp("^\\s*(" + URL_OPEN_METHODS.join("|").replaceAll(".", "\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i");
                    const jsUrl = regex.exec(str);
                    if (jsUrl?.[2]) {
                        const url = jsUrl[2];
                        let newWindow = false;
                        if (jsUrl[3] === "true" && jsUrl[1] === "app.launchURL") newWindow = true;
                        return {
                            url: url,
                            newWindow: newWindow
                        };
                    }
                    return null;
                }
                function numberToString(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const roundedValue = Math.round(value * 100);
                    if (roundedValue % 100 === 0) return (roundedValue / 100).toString();
                    if (roundedValue % 10 === 0) return value.toFixed(1);
                    return value.toFixed(2);
                }
                function getNewAnnotationsMap(annotationStorage) {
                    if (!annotationStorage) return null;
                    const newAnnotationsByPage = new Map();
                    for (const [key, value] of annotationStorage){
                        if (!key.startsWith(_util.AnnotationEditorPrefix)) continue;
                        let annotations = newAnnotationsByPage.get(value.pageIndex);
                        if (!annotations) {
                            annotations = [];
                            newAnnotationsByPage.set(value.pageIndex, annotations);
                        }
                        annotations.push(value);
                    }
                    return newAnnotationsByPage.size > 0 ? newAnnotationsByPage : null;
                }
                function isAscii(str) {
                    return /^[\x00-\x7F]*$/.test(str);
                }
                function stringToUTF16HexString(str) {
                    const buf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        buf.push((char >> 8 & 0xff).toString(16).padStart(2, "0"), (char & 0xff).toString(16).padStart(2, "0"));
                    }
                    return buf.join("");
                }
                function stringToUTF16String(str, bigEndian = false) {
                    const buf = [];
                    if (bigEndian) buf.push("\xFE\xFF");
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        buf.push(String.fromCharCode(char >> 8 & 0xff), String.fromCharCode(char & 0xff));
                    }
                    return buf.join("");
                }
                function getRotationMatrix(rotation, width, height) {
                    switch(rotation){
                        case 90:
                            return [
                                0,
                                1,
                                -1,
                                0,
                                width,
                                0
                            ];
                        case 180:
                            return [
                                -1,
                                0,
                                0,
                                -1,
                                width,
                                height
                            ];
                        case 270:
                            return [
                                0,
                                -1,
                                1,
                                0,
                                0,
                                height
                            ];
                        default:
                            throw new Error("Invalid rotation");
                    }
                }
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RefSetCache = exports.RefSet = exports.Ref = exports.Name = exports.EOF = exports.Dict = exports.Cmd = exports.CIRCULAR_REF = void 0;
                exports.clearPrimitiveCaches = clearPrimitiveCaches;
                exports.isCmd = isCmd;
                exports.isDict = isDict;
                exports.isName = isName;
                exports.isRefsEqual = isRefsEqual;
                var _util = __w_pdfjs_require__(2);
                const CIRCULAR_REF = Symbol("CIRCULAR_REF");
                exports.CIRCULAR_REF = CIRCULAR_REF;
                const EOF = Symbol("EOF");
                exports.EOF = EOF;
                let CmdCache = Object.create(null);
                let NameCache = Object.create(null);
                let RefCache = Object.create(null);
                function clearPrimitiveCaches() {
                    CmdCache = Object.create(null);
                    NameCache = Object.create(null);
                    RefCache = Object.create(null);
                }
                class Name {
                    constructor(name){
                        this.name = name;
                    }
                    static get(name) {
                        return NameCache[name] ||= new Name(name);
                    }
                }
                exports.Name = Name;
                class Cmd {
                    constructor(cmd){
                        this.cmd = cmd;
                    }
                    static get(cmd) {
                        return CmdCache[cmd] ||= new Cmd(cmd);
                    }
                }
                exports.Cmd = Cmd;
                const nonSerializable = function nonSerializableClosure() {
                    return nonSerializable;
                };
                class Dict {
                    constructor(xref = null){
                        this._map = Object.create(null);
                        this.xref = xref;
                        this.objId = null;
                        this.suppressEncryption = false;
                        this.__nonSerializable__ = nonSerializable;
                    }
                    assignXref(newXref) {
                        this.xref = newXref;
                    }
                    get size() {
                        return Object.keys(this._map).length;
                    }
                    get(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) return this.xref.fetch(value, this.suppressEncryption);
                        return value;
                    }
                    async getAsync(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) return this.xref.fetchAsync(value, this.suppressEncryption);
                        return value;
                    }
                    getArray(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) value = this.xref.fetch(value, this.suppressEncryption);
                        if (Array.isArray(value)) {
                            value = value.slice();
                            for(let i = 0, ii = value.length; i < ii; i++)if (value[i] instanceof Ref && this.xref) value[i] = this.xref.fetch(value[i], this.suppressEncryption);
                        }
                        return value;
                    }
                    getRaw(key) {
                        return this._map[key];
                    }
                    getKeys() {
                        return Object.keys(this._map);
                    }
                    getRawValues() {
                        return Object.values(this._map);
                    }
                    set(key, value) {
                        this._map[key] = value;
                    }
                    has(key) {
                        return this._map[key] !== undefined;
                    }
                    forEach(callback) {
                        for(const key in this._map)callback(key, this.get(key));
                    }
                    static get empty() {
                        const emptyDict = new Dict(null);
                        emptyDict.set = (key, value)=>{
                            (0, _util.unreachable)("Should not call `set` on the empty dictionary.");
                        };
                        return (0, _util.shadow)(this, "empty", emptyDict);
                    }
                    static merge({ xref: xref, dictArray: dictArray, mergeSubDicts: mergeSubDicts = false }) {
                        const mergedDict = new Dict(xref), properties = new Map();
                        for (const dict of dictArray){
                            if (!(dict instanceof Dict)) continue;
                            for (const [key, value] of Object.entries(dict._map)){
                                let property = properties.get(key);
                                if (property === undefined) {
                                    property = [];
                                    properties.set(key, property);
                                } else if (!mergeSubDicts || !(value instanceof Dict)) continue;
                                property.push(value);
                            }
                        }
                        for (const [name, values] of properties){
                            if (values.length === 1 || !(values[0] instanceof Dict)) {
                                mergedDict._map[name] = values[0];
                                continue;
                            }
                            const subDict = new Dict(xref);
                            for (const dict of values){
                                for (const [key, value] of Object.entries(dict._map))if (subDict._map[key] === undefined) subDict._map[key] = value;
                            }
                            if (subDict.size > 0) mergedDict._map[name] = subDict;
                        }
                        properties.clear();
                        return mergedDict.size > 0 ? mergedDict : Dict.empty;
                    }
                    clone() {
                        const dict = new Dict(this.xref);
                        for (const key of this.getKeys())dict.set(key, this.getRaw(key));
                        return dict;
                    }
                }
                exports.Dict = Dict;
                class Ref {
                    constructor(num, gen){
                        this.num = num;
                        this.gen = gen;
                    }
                    toString() {
                        if (this.gen === 0) return `${this.num}R`;
                        return `${this.num}R${this.gen}`;
                    }
                    static fromString(str) {
                        const ref = RefCache[str];
                        if (ref) return ref;
                        const m = /^(\d+)R(\d*)$/.exec(str);
                        if (!m || m[1] === "0") return null;
                        return RefCache[str] = new Ref(parseInt(m[1]), !m[2] ? 0 : parseInt(m[2]));
                    }
                    static get(num, gen) {
                        const key = gen === 0 ? `${num}R` : `${num}R${gen}`;
                        return RefCache[key] ||= new Ref(num, gen);
                    }
                }
                exports.Ref = Ref;
                class RefSet {
                    constructor(parent = null){
                        this._set = new Set(parent?._set);
                    }
                    has(ref) {
                        return this._set.has(ref.toString());
                    }
                    put(ref) {
                        this._set.add(ref.toString());
                    }
                    remove(ref) {
                        this._set.delete(ref.toString());
                    }
                    [Symbol.iterator]() {
                        return this._set.values();
                    }
                    clear() {
                        this._set.clear();
                    }
                }
                exports.RefSet = RefSet;
                class RefSetCache {
                    constructor(){
                        this._map = new Map();
                    }
                    get size() {
                        return this._map.size;
                    }
                    get(ref) {
                        return this._map.get(ref.toString());
                    }
                    has(ref) {
                        return this._map.has(ref.toString());
                    }
                    put(ref, obj) {
                        this._map.set(ref.toString(), obj);
                    }
                    putAlias(ref, aliasRef) {
                        this._map.set(ref.toString(), this.get(aliasRef));
                    }
                    [Symbol.iterator]() {
                        return this._map.values();
                    }
                    clear() {
                        this._map.clear();
                    }
                }
                exports.RefSetCache = RefSetCache;
                function isName(v, name) {
                    return v instanceof Name && (name === undefined || v.name === name);
                }
                function isCmd(v, cmd) {
                    return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
                }
                function isDict(v, type) {
                    return v instanceof Dict && (type === undefined || isName(v.get("Type"), type));
                }
                function isRefsEqual(v1, v2) {
                    return v1.num === v2.num && v1.gen === v2.gen;
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStream = void 0;
                var _util = __w_pdfjs_require__(2);
                class BaseStream {
                    constructor(){
                        if (this.constructor === BaseStream) (0, _util.unreachable)("Cannot initialize BaseStream.");
                    }
                    get length() {
                        (0, _util.unreachable)("Abstract getter `length` accessed");
                    }
                    get isEmpty() {
                        (0, _util.unreachable)("Abstract getter `isEmpty` accessed");
                    }
                    get isDataLoaded() {
                        return (0, _util.shadow)(this, "isDataLoaded", true);
                    }
                    getByte() {
                        (0, _util.unreachable)("Abstract method `getByte` called");
                    }
                    getBytes(length) {
                        (0, _util.unreachable)("Abstract method `getBytes` called");
                    }
                    peekByte() {
                        const peekedByte = this.getByte();
                        if (peekedByte !== -1) this.pos--;
                        return peekedByte;
                    }
                    peekBytes(length) {
                        const bytes = this.getBytes(length);
                        this.pos -= bytes.length;
                        return bytes;
                    }
                    getUint16() {
                        const b0 = this.getByte();
                        const b1 = this.getByte();
                        if (b0 === -1 || b1 === -1) return -1;
                        return (b0 << 8) + b1;
                    }
                    getInt32() {
                        const b0 = this.getByte();
                        const b1 = this.getByte();
                        const b2 = this.getByte();
                        const b3 = this.getByte();
                        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                    }
                    getByteRange(begin, end) {
                        (0, _util.unreachable)("Abstract method `getByteRange` called");
                    }
                    getString(length) {
                        return (0, _util.bytesToString)(this.getBytes(length));
                    }
                    skip(n) {
                        this.pos += n || 1;
                    }
                    reset() {
                        (0, _util.unreachable)("Abstract method `reset` called");
                    }
                    moveStart() {
                        (0, _util.unreachable)("Abstract method `moveStart` called");
                    }
                    makeSubStream(start, length, dict = null) {
                        (0, _util.unreachable)("Abstract method `makeSubStream` called");
                    }
                    getBaseStreams() {
                        return null;
                    }
                }
                exports.BaseStream = BaseStream;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NetworkPdfManager = exports.LocalPdfManager = void 0;
                var _util = __w_pdfjs_require__(2);
                var _chunked_stream = __w_pdfjs_require__(7);
                var _core_utils = __w_pdfjs_require__(3);
                var _document = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(8);
                function parseDocBaseUrl(url) {
                    if (url) {
                        const absoluteUrl = (0, _util.createValidAbsoluteUrl)(url);
                        if (absoluteUrl) return absoluteUrl.href;
                        (0, _util.warn)(`Invalid absolute docBaseUrl: "${url}".`);
                    }
                    return null;
                }
                class BasePdfManager {
                    constructor(args){
                        if (this.constructor === BasePdfManager) (0, _util.unreachable)("Cannot initialize BasePdfManager.");
                        this._docBaseUrl = parseDocBaseUrl(args.docBaseUrl);
                        this._docId = args.docId;
                        this._password = args.password;
                        this.enableXfa = args.enableXfa;
                        args.evaluatorOptions.isOffscreenCanvasSupported &&= _util.FeatureTest.isOffscreenCanvasSupported;
                        this.evaluatorOptions = args.evaluatorOptions;
                    }
                    get docId() {
                        return this._docId;
                    }
                    get password() {
                        return this._password;
                    }
                    get docBaseUrl() {
                        return this._docBaseUrl;
                    }
                    get catalog() {
                        return this.pdfDocument.catalog;
                    }
                    ensureDoc(prop, args) {
                        return this.ensure(this.pdfDocument, prop, args);
                    }
                    ensureXRef(prop, args) {
                        return this.ensure(this.pdfDocument.xref, prop, args);
                    }
                    ensureCatalog(prop, args) {
                        return this.ensure(this.pdfDocument.catalog, prop, args);
                    }
                    getPage(pageIndex) {
                        return this.pdfDocument.getPage(pageIndex);
                    }
                    fontFallback(id, handler) {
                        return this.pdfDocument.fontFallback(id, handler);
                    }
                    loadXfaFonts(handler, task) {
                        return this.pdfDocument.loadXfaFonts(handler, task);
                    }
                    loadXfaImages() {
                        return this.pdfDocument.loadXfaImages();
                    }
                    serializeXfaData(annotationStorage) {
                        return this.pdfDocument.serializeXfaData(annotationStorage);
                    }
                    cleanup(manuallyTriggered = false) {
                        return this.pdfDocument.cleanup(manuallyTriggered);
                    }
                    async ensure(obj, prop, args) {
                        (0, _util.unreachable)("Abstract method `ensure` called");
                    }
                    requestRange(begin, end) {
                        (0, _util.unreachable)("Abstract method `requestRange` called");
                    }
                    requestLoadedStream(noFetch = false) {
                        (0, _util.unreachable)("Abstract method `requestLoadedStream` called");
                    }
                    sendProgressiveData(chunk) {
                        (0, _util.unreachable)("Abstract method `sendProgressiveData` called");
                    }
                    updatePassword(password) {
                        this._password = password;
                    }
                    terminate(reason) {
                        (0, _util.unreachable)("Abstract method `terminate` called");
                    }
                }
                class LocalPdfManager extends BasePdfManager {
                    constructor(args){
                        super(args);
                        const stream = new _stream.Stream(args.source);
                        this.pdfDocument = new _document.PDFDocument(this, stream);
                        this._loadedStreamPromise = Promise.resolve(stream);
                    }
                    async ensure(obj, prop, args) {
                        const value = obj[prop];
                        if (typeof value === "function") return value.apply(obj, args);
                        return value;
                    }
                    requestRange(begin, end) {
                        return Promise.resolve();
                    }
                    requestLoadedStream(noFetch = false) {
                        return this._loadedStreamPromise;
                    }
                    terminate(reason) {}
                }
                exports.LocalPdfManager = LocalPdfManager;
                class NetworkPdfManager extends BasePdfManager {
                    constructor(args){
                        super(args);
                        this.streamManager = new _chunked_stream.ChunkedStreamManager(args.source, {
                            msgHandler: args.handler,
                            length: args.length,
                            disableAutoFetch: args.disableAutoFetch,
                            rangeChunkSize: args.rangeChunkSize
                        });
                        this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
                    }
                    async ensure(obj, prop, args) {
                        try {
                            const value = obj[prop];
                            if (typeof value === "function") return value.apply(obj, args);
                            return value;
                        } catch (ex) {
                            if (!(ex instanceof _core_utils.MissingDataException)) throw ex;
                            await this.requestRange(ex.begin, ex.end);
                            return this.ensure(obj, prop, args);
                        }
                    }
                    requestRange(begin, end) {
                        return this.streamManager.requestRange(begin, end);
                    }
                    requestLoadedStream(noFetch = false) {
                        return this.streamManager.requestAllChunks(noFetch);
                    }
                    sendProgressiveData(chunk) {
                        this.streamManager.onReceiveData({
                            chunk: chunk
                        });
                    }
                    terminate(reason) {
                        this.streamManager.abort(reason);
                    }
                }
                exports.NetworkPdfManager = NetworkPdfManager;
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ChunkedStreamManager = exports.ChunkedStream = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                var _stream = __w_pdfjs_require__(8);
                class ChunkedStream extends _stream.Stream {
                    constructor(length, chunkSize, manager){
                        super(new Uint8Array(length), 0, length, null);
                        this.chunkSize = chunkSize;
                        this._loadedChunks = new Set();
                        this.numChunks = Math.ceil(length / chunkSize);
                        this.manager = manager;
                        this.progressiveDataLength = 0;
                        this.lastSuccessfulEnsureByteChunk = -1;
                    }
                    getMissingChunks() {
                        const chunks = [];
                        for(let chunk = 0, n = this.numChunks; chunk < n; ++chunk)if (!this._loadedChunks.has(chunk)) chunks.push(chunk);
                        return chunks;
                    }
                    get numChunksLoaded() {
                        return this._loadedChunks.size;
                    }
                    get isDataLoaded() {
                        return this.numChunksLoaded === this.numChunks;
                    }
                    onReceiveData(begin, chunk) {
                        const chunkSize = this.chunkSize;
                        if (begin % chunkSize !== 0) throw new Error(`Bad begin offset: ${begin}`);
                        const end = begin + chunk.byteLength;
                        if (end % chunkSize !== 0 && end !== this.bytes.length) throw new Error(`Bad end offset: ${end}`);
                        this.bytes.set(new Uint8Array(chunk), begin);
                        const beginChunk = Math.floor(begin / chunkSize);
                        const endChunk = Math.floor((end - 1) / chunkSize) + 1;
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk)this._loadedChunks.add(curChunk);
                    }
                    onReceiveProgressiveData(data) {
                        let position = this.progressiveDataLength;
                        const beginChunk = Math.floor(position / this.chunkSize);
                        this.bytes.set(new Uint8Array(data), position);
                        position += data.byteLength;
                        this.progressiveDataLength = position;
                        const endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk)this._loadedChunks.add(curChunk);
                    }
                    ensureByte(pos) {
                        if (pos < this.progressiveDataLength) return;
                        const chunk = Math.floor(pos / this.chunkSize);
                        if (chunk > this.numChunks) return;
                        if (chunk === this.lastSuccessfulEnsureByteChunk) return;
                        if (!this._loadedChunks.has(chunk)) throw new _core_utils.MissingDataException(pos, pos + 1);
                        this.lastSuccessfulEnsureByteChunk = chunk;
                    }
                    ensureRange(begin, end) {
                        if (begin >= end) return;
                        if (end <= this.progressiveDataLength) return;
                        const beginChunk = Math.floor(begin / this.chunkSize);
                        if (beginChunk > this.numChunks) return;
                        const endChunk = Math.min(Math.floor((end - 1) / this.chunkSize) + 1, this.numChunks);
                        for(let chunk = beginChunk; chunk < endChunk; ++chunk){
                            if (!this._loadedChunks.has(chunk)) throw new _core_utils.MissingDataException(begin, end);
                        }
                    }
                    nextEmptyChunk(beginChunk) {
                        const numChunks = this.numChunks;
                        for(let i = 0; i < numChunks; ++i){
                            const chunk = (beginChunk + i) % numChunks;
                            if (!this._loadedChunks.has(chunk)) return chunk;
                        }
                        return null;
                    }
                    hasChunk(chunk) {
                        return this._loadedChunks.has(chunk);
                    }
                    getByte() {
                        const pos = this.pos;
                        if (pos >= this.end) return -1;
                        if (pos >= this.progressiveDataLength) this.ensureByte(pos);
                        return this.bytes[this.pos++];
                    }
                    getBytes(length) {
                        const bytes = this.bytes;
                        const pos = this.pos;
                        const strEnd = this.end;
                        if (!length) {
                            if (strEnd > this.progressiveDataLength) this.ensureRange(pos, strEnd);
                            return bytes.subarray(pos, strEnd);
                        }
                        let end = pos + length;
                        if (end > strEnd) end = strEnd;
                        if (end > this.progressiveDataLength) this.ensureRange(pos, end);
                        this.pos = end;
                        return bytes.subarray(pos, end);
                    }
                    getByteRange(begin, end) {
                        if (begin < 0) begin = 0;
                        if (end > this.end) end = this.end;
                        if (end > this.progressiveDataLength) this.ensureRange(begin, end);
                        return this.bytes.subarray(begin, end);
                    }
                    makeSubStream(start, length, dict = null) {
                        if (length) {
                            if (start + length > this.progressiveDataLength) this.ensureRange(start, start + length);
                        } else if (start >= this.progressiveDataLength) this.ensureByte(start);
                        function ChunkedStreamSubstream() {}
                        ChunkedStreamSubstream.prototype = Object.create(this);
                        ChunkedStreamSubstream.prototype.getMissingChunks = function() {
                            const chunkSize = this.chunkSize;
                            const beginChunk = Math.floor(this.start / chunkSize);
                            const endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
                            const missingChunks = [];
                            for(let chunk = beginChunk; chunk < endChunk; ++chunk)if (!this._loadedChunks.has(chunk)) missingChunks.push(chunk);
                            return missingChunks;
                        };
                        Object.defineProperty(ChunkedStreamSubstream.prototype, "isDataLoaded", {
                            get () {
                                if (this.numChunksLoaded === this.numChunks) return true;
                                return this.getMissingChunks().length === 0;
                            },
                            configurable: true
                        });
                        const subStream = new ChunkedStreamSubstream();
                        subStream.pos = subStream.start = start;
                        subStream.end = start + length || this.end;
                        subStream.dict = dict;
                        return subStream;
                    }
                    getBaseStreams() {
                        return [
                            this
                        ];
                    }
                }
                exports.ChunkedStream = ChunkedStream;
                class ChunkedStreamManager {
                    constructor(pdfNetworkStream, args){
                        this.length = args.length;
                        this.chunkSize = args.rangeChunkSize;
                        this.stream = new ChunkedStream(this.length, this.chunkSize, this);
                        this.pdfNetworkStream = pdfNetworkStream;
                        this.disableAutoFetch = args.disableAutoFetch;
                        this.msgHandler = args.msgHandler;
                        this.currRequestId = 0;
                        this._chunksNeededByRequest = new Map();
                        this._requestsByChunk = new Map();
                        this._promisesByRequest = new Map();
                        this.progressiveDataLength = 0;
                        this.aborted = false;
                        this._loadedStreamCapability = new _util.PromiseCapability();
                    }
                    sendRequest(begin, end) {
                        const rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
                        if (!rangeReader.isStreamingSupported) rangeReader.onProgress = this.onProgress.bind(this);
                        let chunks = [], loaded = 0;
                        return new Promise((resolve, reject)=>{
                            const readChunk = ({ value: value, done: done })=>{
                                try {
                                    if (done) {
                                        const chunkData = (0, _core_utils.arrayBuffersToBytes)(chunks);
                                        chunks = null;
                                        resolve(chunkData);
                                        return;
                                    }
                                    loaded += value.byteLength;
                                    if (rangeReader.isStreamingSupported) this.onProgress({
                                        loaded: loaded
                                    });
                                    chunks.push(value);
                                    rangeReader.read().then(readChunk, reject);
                                } catch (e) {
                                    reject(e);
                                }
                            };
                            rangeReader.read().then(readChunk, reject);
                        }).then((data)=>{
                            if (this.aborted) return;
                            this.onReceiveData({
                                chunk: data,
                                begin: begin
                            });
                        });
                    }
                    requestAllChunks(noFetch = false) {
                        if (!noFetch) {
                            const missingChunks = this.stream.getMissingChunks();
                            this._requestChunks(missingChunks);
                        }
                        return this._loadedStreamCapability.promise;
                    }
                    _requestChunks(chunks) {
                        const requestId = this.currRequestId++;
                        const chunksNeeded = new Set();
                        this._chunksNeededByRequest.set(requestId, chunksNeeded);
                        for (const chunk of chunks)if (!this.stream.hasChunk(chunk)) chunksNeeded.add(chunk);
                        if (chunksNeeded.size === 0) return Promise.resolve();
                        const capability = new _util.PromiseCapability();
                        this._promisesByRequest.set(requestId, capability);
                        const chunksToRequest = [];
                        for (const chunk of chunksNeeded){
                            let requestIds = this._requestsByChunk.get(chunk);
                            if (!requestIds) {
                                requestIds = [];
                                this._requestsByChunk.set(chunk, requestIds);
                                chunksToRequest.push(chunk);
                            }
                            requestIds.push(requestId);
                        }
                        if (chunksToRequest.length > 0) {
                            const groupedChunksToRequest = this.groupChunks(chunksToRequest);
                            for (const groupedChunk of groupedChunksToRequest){
                                const begin = groupedChunk.beginChunk * this.chunkSize;
                                const end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
                                this.sendRequest(begin, end).catch(capability.reject);
                            }
                        }
                        return capability.promise.catch((reason)=>{
                            if (this.aborted) return;
                            throw reason;
                        });
                    }
                    getStream() {
                        return this.stream;
                    }
                    requestRange(begin, end) {
                        end = Math.min(end, this.length);
                        const beginChunk = this.getBeginChunk(begin);
                        const endChunk = this.getEndChunk(end);
                        const chunks = [];
                        for(let chunk = beginChunk; chunk < endChunk; ++chunk)chunks.push(chunk);
                        return this._requestChunks(chunks);
                    }
                    requestRanges(ranges = []) {
                        const chunksToRequest = [];
                        for (const range of ranges){
                            const beginChunk = this.getBeginChunk(range.begin);
                            const endChunk = this.getEndChunk(range.end);
                            for(let chunk = beginChunk; chunk < endChunk; ++chunk)if (!chunksToRequest.includes(chunk)) chunksToRequest.push(chunk);
                        }
                        chunksToRequest.sort(function(a, b) {
                            return a - b;
                        });
                        return this._requestChunks(chunksToRequest);
                    }
                    groupChunks(chunks) {
                        const groupedChunks = [];
                        let beginChunk = -1;
                        let prevChunk = -1;
                        for(let i = 0, ii = chunks.length; i < ii; ++i){
                            const chunk = chunks[i];
                            if (beginChunk < 0) beginChunk = chunk;
                            if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
                                groupedChunks.push({
                                    beginChunk: beginChunk,
                                    endChunk: prevChunk + 1
                                });
                                beginChunk = chunk;
                            }
                            if (i + 1 === chunks.length) groupedChunks.push({
                                beginChunk: beginChunk,
                                endChunk: chunk + 1
                            });
                            prevChunk = chunk;
                        }
                        return groupedChunks;
                    }
                    onProgress(args) {
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize + args.loaded,
                            total: this.length
                        });
                    }
                    onReceiveData(args) {
                        const chunk = args.chunk;
                        const isProgressive = args.begin === undefined;
                        const begin = isProgressive ? this.progressiveDataLength : args.begin;
                        const end = begin + chunk.byteLength;
                        const beginChunk = Math.floor(begin / this.chunkSize);
                        const endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
                        if (isProgressive) {
                            this.stream.onReceiveProgressiveData(chunk);
                            this.progressiveDataLength = end;
                        } else this.stream.onReceiveData(begin, chunk);
                        if (this.stream.isDataLoaded) this._loadedStreamCapability.resolve(this.stream);
                        const loadedRequests = [];
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk){
                            const requestIds = this._requestsByChunk.get(curChunk);
                            if (!requestIds) continue;
                            this._requestsByChunk.delete(curChunk);
                            for (const requestId of requestIds){
                                const chunksNeeded = this._chunksNeededByRequest.get(requestId);
                                if (chunksNeeded.has(curChunk)) chunksNeeded.delete(curChunk);
                                if (chunksNeeded.size > 0) continue;
                                loadedRequests.push(requestId);
                            }
                        }
                        if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                            let nextEmptyChunk;
                            if (this.stream.numChunksLoaded === 1) {
                                const lastChunk = this.stream.numChunks - 1;
                                if (!this.stream.hasChunk(lastChunk)) nextEmptyChunk = lastChunk;
                            } else nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
                            if (Number.isInteger(nextEmptyChunk)) this._requestChunks([
                                nextEmptyChunk
                            ]);
                        }
                        for (const requestId of loadedRequests){
                            const capability = this._promisesByRequest.get(requestId);
                            this._promisesByRequest.delete(requestId);
                            capability.resolve();
                        }
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize,
                            total: this.length
                        });
                    }
                    onError(err) {
                        this._loadedStreamCapability.reject(err);
                    }
                    getBeginChunk(begin) {
                        return Math.floor(begin / this.chunkSize);
                    }
                    getEndChunk(end) {
                        return Math.floor((end - 1) / this.chunkSize) + 1;
                    }
                    abort(reason) {
                        this.aborted = true;
                        this.pdfNetworkStream?.cancelAllRequests(reason);
                        for (const capability of this._promisesByRequest.values())capability.reject(reason);
                    }
                }
                exports.ChunkedStreamManager = ChunkedStreamManager;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StringStream = exports.Stream = exports.NullStream = void 0;
                var _base_stream = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(2);
                class Stream extends _base_stream.BaseStream {
                    constructor(arrayBuffer, start, length, dict){
                        super();
                        this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
                        this.start = start || 0;
                        this.pos = this.start;
                        this.end = start + length || this.bytes.length;
                        this.dict = dict;
                    }
                    get length() {
                        return this.end - this.start;
                    }
                    get isEmpty() {
                        return this.length === 0;
                    }
                    getByte() {
                        if (this.pos >= this.end) return -1;
                        return this.bytes[this.pos++];
                    }
                    getBytes(length) {
                        const bytes = this.bytes;
                        const pos = this.pos;
                        const strEnd = this.end;
                        if (!length) return bytes.subarray(pos, strEnd);
                        let end = pos + length;
                        if (end > strEnd) end = strEnd;
                        this.pos = end;
                        return bytes.subarray(pos, end);
                    }
                    getByteRange(begin, end) {
                        if (begin < 0) begin = 0;
                        if (end > this.end) end = this.end;
                        return this.bytes.subarray(begin, end);
                    }
                    reset() {
                        this.pos = this.start;
                    }
                    moveStart() {
                        this.start = this.pos;
                    }
                    makeSubStream(start, length, dict = null) {
                        return new Stream(this.bytes.buffer, start, length, dict);
                    }
                }
                exports.Stream = Stream;
                class StringStream extends Stream {
                    constructor(str){
                        super((0, _util.stringToBytes)(str));
                    }
                }
                exports.StringStream = StringStream;
                class NullStream extends Stream {
                    constructor(){
                        super(new Uint8Array(0));
                    }
                }
                exports.NullStream = NullStream;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Page = exports.PDFDocument = void 0;
                var _util = __w_pdfjs_require__(2);
                var _annotation = __w_pdfjs_require__(10);
                var _core_utils = __w_pdfjs_require__(3);
                var _primitives = __w_pdfjs_require__(4);
                var _xfa_fonts = __w_pdfjs_require__(51);
                var _base_stream = __w_pdfjs_require__(5);
                var _crypto = __w_pdfjs_require__(74);
                var _catalog = __w_pdfjs_require__(66);
                var _cleanup_helper = __w_pdfjs_require__(68);
                var _dataset_reader = __w_pdfjs_require__(102);
                var _parser = __w_pdfjs_require__(16);
                var _stream = __w_pdfjs_require__(8);
                var _object_loader = __w_pdfjs_require__(76);
                var _operator_list = __w_pdfjs_require__(64);
                var _evaluator = __w_pdfjs_require__(13);
                var _decode_stream = __w_pdfjs_require__(18);
                var _struct_tree = __w_pdfjs_require__(72);
                var _writer = __w_pdfjs_require__(73);
                var _factory = __w_pdfjs_require__(77);
                var _xref = __w_pdfjs_require__(103);
                const DEFAULT_USER_UNIT = 1.0;
                const LETTER_SIZE_MEDIABOX = [
                    0,
                    0,
                    612,
                    792
                ];
                class Page {
                    constructor({ pdfManager: pdfManager, xref: xref, pageIndex: pageIndex, pageDict: pageDict, ref: ref, globalIdFactory: globalIdFactory, fontCache: fontCache, builtInCMapCache: builtInCMapCache, standardFontDataCache: standardFontDataCache, globalImageCache: globalImageCache, systemFontCache: systemFontCache, nonBlendModesSet: nonBlendModesSet, xfaFactory: xfaFactory }){
                        this.pdfManager = pdfManager;
                        this.pageIndex = pageIndex;
                        this.pageDict = pageDict;
                        this.xref = xref;
                        this.ref = ref;
                        this.fontCache = fontCache;
                        this.builtInCMapCache = builtInCMapCache;
                        this.standardFontDataCache = standardFontDataCache;
                        this.globalImageCache = globalImageCache;
                        this.systemFontCache = systemFontCache;
                        this.nonBlendModesSet = nonBlendModesSet;
                        this.evaluatorOptions = pdfManager.evaluatorOptions;
                        this.resourcesPromise = null;
                        this.xfaFactory = xfaFactory;
                        const idCounters = {
                            obj: 0
                        };
                        this._localIdFactory = class extends globalIdFactory {
                            static createObjId() {
                                return `p${pageIndex}_${++idCounters.obj}`;
                            }
                            static getPageObjId() {
                                return `p${ref.toString()}`;
                            }
                        };
                    }
                    _getInheritableProperty(key, getArray = false) {
                        const value = (0, _core_utils.getInheritableProperty)({
                            dict: this.pageDict,
                            key: key,
                            getArray: getArray,
                            stopWhenFound: false
                        });
                        if (!Array.isArray(value)) return value;
                        if (value.length === 1 || !(value[0] instanceof _primitives.Dict)) return value[0];
                        return _primitives.Dict.merge({
                            xref: this.xref,
                            dictArray: value
                        });
                    }
                    get content() {
                        return this.pageDict.getArray("Contents");
                    }
                    get resources() {
                        const resources = this._getInheritableProperty("Resources");
                        return (0, _util.shadow)(this, "resources", resources instanceof _primitives.Dict ? resources : _primitives.Dict.empty);
                    }
                    _getBoundingBox(name) {
                        if (this.xfaData) return this.xfaData.bbox;
                        let box = this._getInheritableProperty(name, true);
                        if (Array.isArray(box) && box.length === 4) {
                            box = _util.Util.normalizeRect(box);
                            if (box[2] - box[0] > 0 && box[3] - box[1] > 0) return box;
                            (0, _util.warn)(`Empty, or invalid, /${name} entry.`);
                        }
                        return null;
                    }
                    get mediaBox() {
                        return (0, _util.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || LETTER_SIZE_MEDIABOX);
                    }
                    get cropBox() {
                        return (0, _util.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
                    }
                    get userUnit() {
                        let obj = this.pageDict.get("UserUnit");
                        if (typeof obj !== "number" || obj <= 0) obj = DEFAULT_USER_UNIT;
                        return (0, _util.shadow)(this, "userUnit", obj);
                    }
                    get view() {
                        const { cropBox: cropBox, mediaBox: mediaBox } = this;
                        if (cropBox !== mediaBox && !(0, _util.isArrayEqual)(cropBox, mediaBox)) {
                            const box = _util.Util.intersect(cropBox, mediaBox);
                            if (box && box[2] - box[0] > 0 && box[3] - box[1] > 0) return (0, _util.shadow)(this, "view", box);
                            (0, _util.warn)("Empty /CropBox and /MediaBox intersection.");
                        }
                        return (0, _util.shadow)(this, "view", mediaBox);
                    }
                    get rotate() {
                        let rotate = this._getInheritableProperty("Rotate") || 0;
                        if (rotate % 90 !== 0) rotate = 0;
                        else if (rotate >= 360) rotate %= 360;
                        else if (rotate < 0) rotate = (rotate % 360 + 360) % 360;
                        return (0, _util.shadow)(this, "rotate", rotate);
                    }
                    _onSubStreamError(reason, objId) {
                        if (this.evaluatorOptions.ignoreErrors) {
                            (0, _util.warn)(`getContentStream - ignoring sub-stream (${objId}): "${reason}".`);
                            return;
                        }
                        throw reason;
                    }
                    getContentStream() {
                        return this.pdfManager.ensure(this, "content").then((content)=>{
                            if (content instanceof _base_stream.BaseStream) return content;
                            if (Array.isArray(content)) return new _decode_stream.StreamsSequenceStream(content, this._onSubStreamError.bind(this));
                            return new _stream.NullStream();
                        });
                    }
                    get xfaData() {
                        return (0, _util.shadow)(this, "xfaData", this.xfaFactory ? {
                            bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
                        } : null);
                    }
                    #replaceIdByRef(annotations, deletedAnnotations, existingAnnotations) {
                        for (const annotation of annotations)if (annotation.id) {
                            const ref = _primitives.Ref.fromString(annotation.id);
                            if (!ref) {
                                (0, _util.warn)(`A non-linked annotation cannot be modified: ${annotation.id}`);
                                continue;
                            }
                            if (annotation.deleted) {
                                deletedAnnotations.put(ref);
                                continue;
                            }
                            existingAnnotations?.put(ref);
                            annotation.ref = ref;
                            delete annotation.id;
                        }
                    }
                    async saveNewAnnotations(handler, task, annotations, imagePromises) {
                        if (this.xfaFactory) throw new Error("XFA: Cannot save new annotations.");
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        const deletedAnnotations = new _primitives.RefSet();
                        const existingAnnotations = new _primitives.RefSet();
                        this.#replaceIdByRef(annotations, deletedAnnotations, existingAnnotations);
                        const pageDict = this.pageDict;
                        const annotationsArray = this.annotations.filter((a)=>!(a instanceof _primitives.Ref && deletedAnnotations.has(a)));
                        const newData = await _annotation.AnnotationFactory.saveNewAnnotations(partialEvaluator, task, annotations, imagePromises);
                        for (const { ref: ref } of newData.annotations)if (ref instanceof _primitives.Ref && !existingAnnotations.has(ref)) annotationsArray.push(ref);
                        const savedDict = pageDict.get("Annots");
                        pageDict.set("Annots", annotationsArray);
                        const buffer = [];
                        await (0, _writer.writeObject)(this.ref, pageDict, buffer, this.xref);
                        if (savedDict) pageDict.set("Annots", savedDict);
                        const objects = newData.dependencies;
                        objects.push({
                            ref: this.ref,
                            data: buffer.join("")
                        }, ...newData.annotations);
                        return objects;
                    }
                    save(handler, task, annotationStorage) {
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        return this._parsedAnnotations.then(function(annotations) {
                            const newRefsPromises = [];
                            for (const annotation of annotations){
                                if (!annotation.mustBePrinted(annotationStorage)) continue;
                                newRefsPromises.push(annotation.save(partialEvaluator, task, annotationStorage).catch(function(reason) {
                                    (0, _util.warn)("save - ignoring annotation data during " + `"${task.name}" task: "${reason}".`);
                                    return null;
                                }));
                            }
                            return Promise.all(newRefsPromises).then(function(newRefs) {
                                return newRefs.filter((newRef)=>!!newRef);
                            });
                        });
                    }
                    loadResources(keys) {
                        if (!this.resourcesPromise) this.resourcesPromise = this.pdfManager.ensure(this, "resources");
                        return this.resourcesPromise.then(()=>{
                            const objectLoader = new _object_loader.ObjectLoader(this.resources, keys, this.xref);
                            return objectLoader.load();
                        });
                    }
                    getOperatorList({ handler: handler, sink: sink, task: task, intent: intent, cacheKey: cacheKey, annotationStorage: annotationStorage = null }) {
                        const contentStreamPromise = this.getContentStream();
                        const resourcesPromise = this.loadResources([
                            "ColorSpace",
                            "ExtGState",
                            "Font",
                            "Pattern",
                            "Properties",
                            "Shading",
                            "XObject"
                        ]);
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        const newAnnotationsByPage = !this.xfaFactory ? (0, _core_utils.getNewAnnotationsMap)(annotationStorage) : null;
                        let deletedAnnotations = null;
                        let newAnnotationsPromise = Promise.resolve(null);
                        if (newAnnotationsByPage) {
                            const newAnnotations = newAnnotationsByPage.get(this.pageIndex);
                            if (newAnnotations) {
                                const annotationGlobalsPromise = this.pdfManager.ensureDoc("annotationGlobals");
                                let imagePromises;
                                const missingBitmaps = new Set();
                                for (const { bitmapId: bitmapId, bitmap: bitmap } of newAnnotations)if (bitmapId && !bitmap && !missingBitmaps.has(bitmapId)) missingBitmaps.add(bitmapId);
                                const { isOffscreenCanvasSupported: isOffscreenCanvasSupported } = this.evaluatorOptions;
                                if (missingBitmaps.size > 0) {
                                    const annotationWithBitmaps = newAnnotations.slice();
                                    for (const [key, annotation] of annotationStorage){
                                        if (!key.startsWith(_util.AnnotationEditorPrefix)) continue;
                                        if (annotation.bitmap && missingBitmaps.has(annotation.bitmapId)) annotationWithBitmaps.push(annotation);
                                    }
                                    imagePromises = _annotation.AnnotationFactory.generateImages(annotationWithBitmaps, this.xref, isOffscreenCanvasSupported);
                                } else imagePromises = _annotation.AnnotationFactory.generateImages(newAnnotations, this.xref, isOffscreenCanvasSupported);
                                deletedAnnotations = new _primitives.RefSet();
                                this.#replaceIdByRef(newAnnotations, deletedAnnotations, null);
                                newAnnotationsPromise = annotationGlobalsPromise.then((annotationGlobals)=>{
                                    if (!annotationGlobals) return null;
                                    return _annotation.AnnotationFactory.printNewAnnotations(annotationGlobals, partialEvaluator, task, newAnnotations, imagePromises);
                                });
                            }
                        }
                        const dataPromises = Promise.all([
                            contentStreamPromise,
                            resourcesPromise
                        ]);
                        const pageListPromise = dataPromises.then(([contentStream])=>{
                            const opList = new _operator_list.OperatorList(intent, sink);
                            handler.send("StartRenderPage", {
                                transparency: partialEvaluator.hasBlendModes(this.resources, this.nonBlendModesSet),
                                pageIndex: this.pageIndex,
                                cacheKey: cacheKey
                            });
                            return partialEvaluator.getOperatorList({
                                stream: contentStream,
                                task: task,
                                resources: this.resources,
                                operatorList: opList
                            }).then(function() {
                                return opList;
                            });
                        });
                        return Promise.all([
                            pageListPromise,
                            this._parsedAnnotations,
                            newAnnotationsPromise
                        ]).then(function([pageOpList, annotations, newAnnotations]) {
                            if (newAnnotations) {
                                annotations = annotations.filter((a)=>!(a.ref && deletedAnnotations.has(a.ref)));
                                for(let i = 0, ii = newAnnotations.length; i < ii; i++){
                                    const newAnnotation = newAnnotations[i];
                                    if (newAnnotation.refToReplace) {
                                        const j = annotations.findIndex((a)=>a.ref && (0, _primitives.isRefsEqual)(a.ref, newAnnotation.refToReplace));
                                        if (j >= 0) {
                                            annotations.splice(j, 1, newAnnotation);
                                            newAnnotations.splice(i--, 1);
                                            ii--;
                                        }
                                    }
                                }
                                annotations = annotations.concat(newAnnotations);
                            }
                            if (annotations.length === 0 || intent & _util.RenderingIntentFlag.ANNOTATIONS_DISABLE) {
                                pageOpList.flush(true);
                                return {
                                    length: pageOpList.totalLength
                                };
                            }
                            const renderForms = !!(intent & _util.RenderingIntentFlag.ANNOTATIONS_FORMS), intentAny = !!(intent & _util.RenderingIntentFlag.ANY), intentDisplay = !!(intent & _util.RenderingIntentFlag.DISPLAY), intentPrint = !!(intent & _util.RenderingIntentFlag.PRINT);
                            const opListPromises = [];
                            for (const annotation of annotations)if (intentAny || intentDisplay && annotation.mustBeViewed(annotationStorage, renderForms) || intentPrint && annotation.mustBePrinted(annotationStorage)) opListPromises.push(annotation.getOperatorList(partialEvaluator, task, intent, renderForms, annotationStorage).catch(function(reason) {
                                (0, _util.warn)("getOperatorList - ignoring annotation data during " + `"${task.name}" task: "${reason}".`);
                                return {
                                    opList: null,
                                    separateForm: false,
                                    separateCanvas: false
                                };
                            }));
                            return Promise.all(opListPromises).then(function(opLists) {
                                let form = false, canvas = false;
                                for (const { opList: opList, separateForm: separateForm, separateCanvas: separateCanvas } of opLists){
                                    pageOpList.addOpList(opList);
                                    form ||= separateForm;
                                    canvas ||= separateCanvas;
                                }
                                pageOpList.flush(true, {
                                    form: form,
                                    canvas: canvas
                                });
                                return {
                                    length: pageOpList.totalLength
                                };
                            });
                        });
                    }
                    extractTextContent({ handler: handler, task: task, includeMarkedContent: includeMarkedContent, disableNormalization: disableNormalization, sink: sink }) {
                        const contentStreamPromise = this.getContentStream();
                        const resourcesPromise = this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ]);
                        const dataPromises = Promise.all([
                            contentStreamPromise,
                            resourcesPromise
                        ]);
                        return dataPromises.then(([contentStream])=>{
                            const partialEvaluator = new _evaluator.PartialEvaluator({
                                xref: this.xref,
                                handler: handler,
                                pageIndex: this.pageIndex,
                                idFactory: this._localIdFactory,
                                fontCache: this.fontCache,
                                builtInCMapCache: this.builtInCMapCache,
                                standardFontDataCache: this.standardFontDataCache,
                                globalImageCache: this.globalImageCache,
                                systemFontCache: this.systemFontCache,
                                options: this.evaluatorOptions
                            });
                            return partialEvaluator.getTextContent({
                                stream: contentStream,
                                task: task,
                                resources: this.resources,
                                includeMarkedContent: includeMarkedContent,
                                disableNormalization: disableNormalization,
                                sink: sink,
                                viewBox: this.view
                            });
                        });
                    }
                    async getStructTree() {
                        const structTreeRoot = await this.pdfManager.ensureCatalog("structTreeRoot");
                        if (!structTreeRoot) return null;
                        await this._parsedAnnotations;
                        const structTree = await this.pdfManager.ensure(this, "_parseStructTree", [
                            structTreeRoot
                        ]);
                        return structTree.serializable;
                    }
                    _parseStructTree(structTreeRoot) {
                        const tree = new _struct_tree.StructTreePage(structTreeRoot, this.pageDict);
                        tree.parse(this.ref);
                        return tree;
                    }
                    async getAnnotationsData(handler, task, intent) {
                        const annotations = await this._parsedAnnotations;
                        if (annotations.length === 0) return annotations;
                        const annotationsData = [], textContentPromises = [];
                        let partialEvaluator;
                        const intentAny = !!(intent & _util.RenderingIntentFlag.ANY), intentDisplay = !!(intent & _util.RenderingIntentFlag.DISPLAY), intentPrint = !!(intent & _util.RenderingIntentFlag.PRINT);
                        for (const annotation of annotations){
                            const isVisible = intentAny || intentDisplay && annotation.viewable;
                            if (isVisible || intentPrint && annotation.printable) annotationsData.push(annotation.data);
                            if (annotation.hasTextContent && isVisible) {
                                partialEvaluator ||= new _evaluator.PartialEvaluator({
                                    xref: this.xref,
                                    handler: handler,
                                    pageIndex: this.pageIndex,
                                    idFactory: this._localIdFactory,
                                    fontCache: this.fontCache,
                                    builtInCMapCache: this.builtInCMapCache,
                                    standardFontDataCache: this.standardFontDataCache,
                                    globalImageCache: this.globalImageCache,
                                    systemFontCache: this.systemFontCache,
                                    options: this.evaluatorOptions
                                });
                                textContentPromises.push(annotation.extractTextContent(partialEvaluator, task, [
                                    -Infinity,
                                    -Infinity,
                                    Infinity,
                                    Infinity
                                ]).catch(function(reason) {
                                    (0, _util.warn)(`getAnnotationsData - ignoring textContent during "${task.name}" task: "${reason}".`);
                                }));
                            }
                        }
                        await Promise.all(textContentPromises);
                        return annotationsData;
                    }
                    get annotations() {
                        const annots = this._getInheritableProperty("Annots");
                        return (0, _util.shadow)(this, "annotations", Array.isArray(annots) ? annots : []);
                    }
                    get _parsedAnnotations() {
                        const promise = this.pdfManager.ensure(this, "annotations").then(async (annots)=>{
                            if (annots.length === 0) return annots;
                            const annotationGlobals = await this.pdfManager.ensureDoc("annotationGlobals");
                            if (!annotationGlobals) return [];
                            const annotationPromises = [];
                            for (const annotationRef of annots)annotationPromises.push(_annotation.AnnotationFactory.create(this.xref, annotationRef, annotationGlobals, this._localIdFactory, false, this.ref).catch(function(reason) {
                                (0, _util.warn)(`_parsedAnnotations: "${reason}".`);
                                return null;
                            }));
                            const sortedAnnotations = [];
                            let popupAnnotations;
                            for (const annotation of (await Promise.all(annotationPromises))){
                                if (!annotation) continue;
                                if (annotation instanceof _annotation.PopupAnnotation) {
                                    (popupAnnotations ||= []).push(annotation);
                                    continue;
                                }
                                sortedAnnotations.push(annotation);
                            }
                            if (popupAnnotations) sortedAnnotations.push(...popupAnnotations);
                            return sortedAnnotations;
                        });
                        return (0, _util.shadow)(this, "_parsedAnnotations", promise);
                    }
                    get jsActions() {
                        const actions = (0, _core_utils.collectActions)(this.xref, this.pageDict, _util.PageActionEventType);
                        return (0, _util.shadow)(this, "jsActions", actions);
                    }
                }
                exports.Page = Page;
                const PDF_HEADER_SIGNATURE = new Uint8Array([
                    0x25,
                    0x50,
                    0x44,
                    0x46,
                    0x2d
                ]);
                const STARTXREF_SIGNATURE = new Uint8Array([
                    0x73,
                    0x74,
                    0x61,
                    0x72,
                    0x74,
                    0x78,
                    0x72,
                    0x65,
                    0x66
                ]);
                const ENDOBJ_SIGNATURE = new Uint8Array([
                    0x65,
                    0x6e,
                    0x64,
                    0x6f,
                    0x62,
                    0x6a
                ]);
                const FINGERPRINT_FIRST_BYTES = 1024;
                const EMPTY_FINGERPRINT = "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00";
                function find(stream, signature, limit = 1024, backwards = false) {
                    const signatureLength = signature.length;
                    const scanBytes = stream.peekBytes(limit);
                    const scanLength = scanBytes.length - signatureLength;
                    if (scanLength <= 0) return false;
                    if (backwards) {
                        const signatureEnd = signatureLength - 1;
                        let pos = scanBytes.length - 1;
                        while(pos >= signatureEnd){
                            let j = 0;
                            while(j < signatureLength && scanBytes[pos - j] === signature[signatureEnd - j])j++;
                            if (j >= signatureLength) {
                                stream.pos += pos - signatureEnd;
                                return true;
                            }
                            pos--;
                        }
                    } else {
                        let pos = 0;
                        while(pos <= scanLength){
                            let j = 0;
                            while(j < signatureLength && scanBytes[pos + j] === signature[j])j++;
                            if (j >= signatureLength) {
                                stream.pos += pos;
                                return true;
                            }
                            pos++;
                        }
                    }
                    return false;
                }
                class PDFDocument {
                    constructor(pdfManager, stream){
                        if (stream.length <= 0) throw new _util.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
                        this.pdfManager = pdfManager;
                        this.stream = stream;
                        this.xref = new _xref.XRef(stream, pdfManager);
                        this._pagePromises = new Map();
                        this._version = null;
                        const idCounters = {
                            font: 0
                        };
                        this._globalIdFactory = class {
                            static getDocId() {
                                return `g_${pdfManager.docId}`;
                            }
                            static createFontId() {
                                return `f${++idCounters.font}`;
                            }
                            static createObjId() {
                                (0, _util.unreachable)("Abstract method `createObjId` called.");
                            }
                            static getPageObjId() {
                                (0, _util.unreachable)("Abstract method `getPageObjId` called.");
                            }
                        };
                    }
                    parse(recoveryMode) {
                        this.xref.parse(recoveryMode);
                        this.catalog = new _catalog.Catalog(this.pdfManager, this.xref);
                    }
                    get linearization() {
                        let linearization = null;
                        try {
                            linearization = _parser.Linearization.create(this.stream);
                        } catch (err) {
                            if (err instanceof _core_utils.MissingDataException) throw err;
                            (0, _util.info)(err);
                        }
                        return (0, _util.shadow)(this, "linearization", linearization);
                    }
                    get startXRef() {
                        const stream = this.stream;
                        let startXRef = 0;
                        if (this.linearization) {
                            stream.reset();
                            if (find(stream, ENDOBJ_SIGNATURE)) startXRef = stream.pos + 6 - stream.start;
                        } else {
                            const step = 1024;
                            const startXRefLength = STARTXREF_SIGNATURE.length;
                            let found = false, pos = stream.end;
                            while(!found && pos > 0){
                                pos -= step - startXRefLength;
                                if (pos < 0) pos = 0;
                                stream.pos = pos;
                                found = find(stream, STARTXREF_SIGNATURE, step, true);
                            }
                            if (found) {
                                stream.skip(9);
                                let ch;
                                do ch = stream.getByte();
                                while ((0, _core_utils.isWhiteSpace)(ch));
                                let str = "";
                                while(ch >= 0x20 && ch <= 0x39){
                                    str += String.fromCharCode(ch);
                                    ch = stream.getByte();
                                }
                                startXRef = parseInt(str, 10);
                                if (isNaN(startXRef)) startXRef = 0;
                            }
                        }
                        return (0, _util.shadow)(this, "startXRef", startXRef);
                    }
                    checkHeader() {
                        const stream = this.stream;
                        stream.reset();
                        if (!find(stream, PDF_HEADER_SIGNATURE)) return;
                        stream.moveStart();
                        stream.skip(PDF_HEADER_SIGNATURE.length);
                        let version = "", ch;
                        while((ch = stream.getByte()) > 0x20 && version.length < 7)version += String.fromCharCode(ch);
                        if (_core_utils.PDF_VERSION_REGEXP.test(version)) this._version = version;
                        else (0, _util.warn)(`Invalid PDF header version: ${version}`);
                    }
                    parseStartXRef() {
                        this.xref.setStartXRef(this.startXRef);
                    }
                    get numPages() {
                        let num = 0;
                        if (this.catalog.hasActualNumPages) num = this.catalog.numPages;
                        else if (this.xfaFactory) num = this.xfaFactory.getNumPages();
                        else if (this.linearization) num = this.linearization.numPages;
                        else num = this.catalog.numPages;
                        return (0, _util.shadow)(this, "numPages", num);
                    }
                    _hasOnlyDocumentSignatures(fields, recursionDepth = 0) {
                        const RECURSION_LIMIT = 10;
                        if (!Array.isArray(fields)) return false;
                        return fields.every((field)=>{
                            field = this.xref.fetchIfRef(field);
                            if (!(field instanceof _primitives.Dict)) return false;
                            if (field.has("Kids")) {
                                if (++recursionDepth > RECURSION_LIMIT) {
                                    (0, _util.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached");
                                    return false;
                                }
                                return this._hasOnlyDocumentSignatures(field.get("Kids"), recursionDepth);
                            }
                            const isSignature = (0, _primitives.isName)(field.get("FT"), "Sig");
                            const rectangle = field.get("Rect");
                            const isInvisible = Array.isArray(rectangle) && rectangle.every((value)=>value === 0);
                            return isSignature && isInvisible;
                        });
                    }
                    get _xfaStreams() {
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm) return null;
                        const xfa = acroForm.get("XFA");
                        const entries = {
                            "xdp:xdp": "",
                            template: "",
                            datasets: "",
                            config: "",
                            connectionSet: "",
                            localeSet: "",
                            stylesheet: "",
                            "/xdp:xdp": ""
                        };
                        if (xfa instanceof _base_stream.BaseStream && !xfa.isEmpty) {
                            entries["xdp:xdp"] = xfa;
                            return entries;
                        }
                        if (!Array.isArray(xfa) || xfa.length === 0) return null;
                        for(let i = 0, ii = xfa.length; i < ii; i += 2){
                            let name;
                            if (i === 0) name = "xdp:xdp";
                            else if (i === ii - 2) name = "/xdp:xdp";
                            else name = xfa[i];
                            if (!entries.hasOwnProperty(name)) continue;
                            const data = this.xref.fetchIfRef(xfa[i + 1]);
                            if (!(data instanceof _base_stream.BaseStream) || data.isEmpty) continue;
                            entries[name] = data;
                        }
                        return entries;
                    }
                    get xfaDatasets() {
                        const streams = this._xfaStreams;
                        if (!streams) return (0, _util.shadow)(this, "xfaDatasets", null);
                        for (const key of [
                            "datasets",
                            "xdp:xdp"
                        ]){
                            const stream = streams[key];
                            if (!stream) continue;
                            try {
                                const str = (0, _util.stringToUTF8String)(stream.getString());
                                const data = {
                                    [key]: str
                                };
                                return (0, _util.shadow)(this, "xfaDatasets", new _dataset_reader.DatasetReader(data));
                            } catch  {
                                (0, _util.warn)("XFA - Invalid utf-8 string.");
                                break;
                            }
                        }
                        return (0, _util.shadow)(this, "xfaDatasets", null);
                    }
                    get xfaData() {
                        const streams = this._xfaStreams;
                        if (!streams) return null;
                        const data = Object.create(null);
                        for (const [key, stream] of Object.entries(streams)){
                            if (!stream) continue;
                            try {
                                data[key] = (0, _util.stringToUTF8String)(stream.getString());
                            } catch  {
                                (0, _util.warn)("XFA - Invalid utf-8 string.");
                                return null;
                            }
                        }
                        return data;
                    }
                    get xfaFactory() {
                        let data;
                        if (this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm) data = this.xfaData;
                        return (0, _util.shadow)(this, "xfaFactory", data ? new _factory.XFAFactory(data) : null);
                    }
                    get isPureXfa() {
                        return this.xfaFactory ? this.xfaFactory.isValid() : false;
                    }
                    get htmlForXfa() {
                        return this.xfaFactory ? this.xfaFactory.getPages() : null;
                    }
                    async loadXfaImages() {
                        const xfaImagesDict = await this.pdfManager.ensureCatalog("xfaImages");
                        if (!xfaImagesDict) return;
                        const keys = xfaImagesDict.getKeys();
                        const objectLoader = new _object_loader.ObjectLoader(xfaImagesDict, keys, this.xref);
                        await objectLoader.load();
                        const xfaImages = new Map();
                        for (const key of keys){
                            const stream = xfaImagesDict.get(key);
                            if (stream instanceof _base_stream.BaseStream) xfaImages.set(key, stream.getBytes());
                        }
                        this.xfaFactory.setImages(xfaImages);
                    }
                    async loadXfaFonts(handler, task) {
                        const acroForm = await this.pdfManager.ensureCatalog("acroForm");
                        if (!acroForm) return;
                        const resources = await acroForm.getAsync("DR");
                        if (!(resources instanceof _primitives.Dict)) return;
                        const objectLoader = new _object_loader.ObjectLoader(resources, [
                            "Font"
                        ], this.xref);
                        await objectLoader.load();
                        const fontRes = resources.get("Font");
                        if (!(fontRes instanceof _primitives.Dict)) return;
                        const options = Object.assign(Object.create(null), this.pdfManager.evaluatorOptions);
                        options.useSystemFonts = false;
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: -1,
                            idFactory: this._globalIdFactory,
                            fontCache: this.catalog.fontCache,
                            builtInCMapCache: this.catalog.builtInCMapCache,
                            standardFontDataCache: this.catalog.standardFontDataCache,
                            options: options
                        });
                        const operatorList = new _operator_list.OperatorList();
                        const pdfFonts = [];
                        const initialState = {
                            get font () {
                                return pdfFonts.at(-1);
                            },
                            set font (font){
                                pdfFonts.push(font);
                            },
                            clone () {
                                return this;
                            }
                        };
                        const fonts = new Map();
                        fontRes.forEach((fontName, font1)=>{
                            fonts.set(fontName, font1);
                        });
                        const promises = [];
                        for (const [fontName, font1] of fonts){
                            const descriptor = font1.get("FontDescriptor");
                            if (!(descriptor instanceof _primitives.Dict)) continue;
                            let fontFamily = descriptor.get("FontFamily");
                            fontFamily = fontFamily.replaceAll(/[ ]+(\d)/g, "$1");
                            const fontWeight = descriptor.get("FontWeight");
                            const italicAngle = -descriptor.get("ItalicAngle");
                            const cssFontInfo = {
                                fontFamily: fontFamily,
                                fontWeight: fontWeight,
                                italicAngle: italicAngle
                            };
                            if (!(0, _core_utils.validateCSSFont)(cssFontInfo)) continue;
                            promises.push(partialEvaluator.handleSetFont(resources, [
                                _primitives.Name.get(fontName),
                                1
                            ], null, operatorList, task, initialState, null, cssFontInfo).catch(function(reason) {
                                (0, _util.warn)(`loadXfaFonts: "${reason}".`);
                                return null;
                            }));
                        }
                        await Promise.all(promises);
                        const missingFonts = this.xfaFactory.setFonts(pdfFonts);
                        if (!missingFonts) return;
                        options.ignoreErrors = true;
                        promises.length = 0;
                        pdfFonts.length = 0;
                        const reallyMissingFonts = new Set();
                        for (const missing of missingFonts)if (!(0, _xfa_fonts.getXfaFontName)(`${missing}-Regular`)) reallyMissingFonts.add(missing);
                        if (reallyMissingFonts.size) missingFonts.push("PdfJS-Fallback");
                        for (const missing of missingFonts){
                            if (reallyMissingFonts.has(missing)) continue;
                            for (const fontInfo of [
                                {
                                    name: "Regular",
                                    fontWeight: 400,
                                    italicAngle: 0
                                },
                                {
                                    name: "Bold",
                                    fontWeight: 700,
                                    italicAngle: 0
                                },
                                {
                                    name: "Italic",
                                    fontWeight: 400,
                                    italicAngle: 12
                                },
                                {
                                    name: "BoldItalic",
                                    fontWeight: 700,
                                    italicAngle: 12
                                }
                            ]){
                                const name = `${missing}-${fontInfo.name}`;
                                const dict = (0, _xfa_fonts.getXfaFontDict)(name);
                                promises.push(partialEvaluator.handleSetFont(resources, [
                                    _primitives.Name.get(name),
                                    1
                                ], null, operatorList, task, initialState, dict, {
                                    fontFamily: missing,
                                    fontWeight: fontInfo.fontWeight,
                                    italicAngle: fontInfo.italicAngle
                                }).catch(function(reason) {
                                    (0, _util.warn)(`loadXfaFonts: "${reason}".`);
                                    return null;
                                }));
                            }
                        }
                        await Promise.all(promises);
                        this.xfaFactory.appendFonts(pdfFonts, reallyMissingFonts);
                    }
                    async serializeXfaData(annotationStorage) {
                        return this.xfaFactory ? this.xfaFactory.serializeData(annotationStorage) : null;
                    }
                    get version() {
                        return this.catalog.version || this._version;
                    }
                    get formInfo() {
                        const formInfo = {
                            hasFields: false,
                            hasAcroForm: false,
                            hasXfa: false,
                            hasSignatures: false
                        };
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm) return (0, _util.shadow)(this, "formInfo", formInfo);
                        try {
                            const fields = acroForm.get("Fields");
                            const hasFields = Array.isArray(fields) && fields.length > 0;
                            formInfo.hasFields = hasFields;
                            const xfa = acroForm.get("XFA");
                            formInfo.hasXfa = Array.isArray(xfa) && xfa.length > 0 || xfa instanceof _base_stream.BaseStream && !xfa.isEmpty;
                            const sigFlags = acroForm.get("SigFlags");
                            const hasSignatures = !!(sigFlags & 0x1);
                            const hasOnlyDocumentSignatures = hasSignatures && this._hasOnlyDocumentSignatures(fields);
                            formInfo.hasAcroForm = hasFields && !hasOnlyDocumentSignatures;
                            formInfo.hasSignatures = hasSignatures;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Cannot fetch form information: "${ex}".`);
                        }
                        return (0, _util.shadow)(this, "formInfo", formInfo);
                    }
                    get documentInfo() {
                        const docInfo = {
                            PDFFormatVersion: this.version,
                            Language: this.catalog.lang,
                            EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                            IsLinearized: !!this.linearization,
                            IsAcroFormPresent: this.formInfo.hasAcroForm,
                            IsXFAPresent: this.formInfo.hasXfa,
                            IsCollectionPresent: !!this.catalog.collection,
                            IsSignaturesPresent: this.formInfo.hasSignatures
                        };
                        let infoDict;
                        try {
                            infoDict = this.xref.trailer.get("Info");
                        } catch (err) {
                            if (err instanceof _core_utils.MissingDataException) throw err;
                            (0, _util.info)("The document information dictionary is invalid.");
                        }
                        if (!(infoDict instanceof _primitives.Dict)) return (0, _util.shadow)(this, "documentInfo", docInfo);
                        for (const key of infoDict.getKeys()){
                            const value = infoDict.get(key);
                            switch(key){
                                case "Title":
                                case "Author":
                                case "Subject":
                                case "Keywords":
                                case "Creator":
                                case "Producer":
                                case "CreationDate":
                                case "ModDate":
                                    if (typeof value === "string") {
                                        docInfo[key] = (0, _util.stringToPDFString)(value);
                                        continue;
                                    }
                                    break;
                                case "Trapped":
                                    if (value instanceof _primitives.Name) {
                                        docInfo[key] = value;
                                        continue;
                                    }
                                    break;
                                default:
                                    let customValue;
                                    switch(typeof value){
                                        case "string":
                                            customValue = (0, _util.stringToPDFString)(value);
                                            break;
                                        case "number":
                                        case "boolean":
                                            customValue = value;
                                            break;
                                        default:
                                            if (value instanceof _primitives.Name) customValue = value;
                                            break;
                                    }
                                    if (customValue === undefined) {
                                        (0, _util.warn)(`Bad value, for custom key "${key}", in Info: ${value}.`);
                                        continue;
                                    }
                                    if (!docInfo.Custom) docInfo.Custom = Object.create(null);
                                    docInfo.Custom[key] = customValue;
                                    continue;
                            }
                            (0, _util.warn)(`Bad value, for key "${key}", in Info: ${value}.`);
                        }
                        return (0, _util.shadow)(this, "documentInfo", docInfo);
                    }
                    get fingerprints() {
                        function validate(data) {
                            return typeof data === "string" && data.length > 0 && data !== EMPTY_FINGERPRINT;
                        }
                        function hexString(hash) {
                            const buf = [];
                            for (const num of hash){
                                const hex = num.toString(16);
                                buf.push(hex.padStart(2, "0"));
                            }
                            return buf.join("");
                        }
                        const idArray = this.xref.trailer.get("ID");
                        let hashOriginal, hashModified;
                        if (Array.isArray(idArray) && validate(idArray[0])) {
                            hashOriginal = (0, _util.stringToBytes)(idArray[0]);
                            if (idArray[1] !== idArray[0] && validate(idArray[1])) hashModified = (0, _util.stringToBytes)(idArray[1]);
                        } else hashOriginal = (0, _crypto.calculateMD5)(this.stream.getByteRange(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
                        return (0, _util.shadow)(this, "fingerprints", [
                            hexString(hashOriginal),
                            hashModified ? hexString(hashModified) : null
                        ]);
                    }
                    async _getLinearizationPage(pageIndex) {
                        const { catalog: catalog, linearization: linearization, xref: xref } = this;
                        const ref = _primitives.Ref.get(linearization.objectNumberFirst, 0);
                        try {
                            const obj = await xref.fetchAsync(ref);
                            if (obj instanceof _primitives.Dict) {
                                let type = obj.getRaw("Type");
                                if (type instanceof _primitives.Ref) type = await xref.fetchAsync(type);
                                if ((0, _primitives.isName)(type, "Page") || !obj.has("Type") && !obj.has("Kids")) {
                                    if (!catalog.pageKidsCountCache.has(ref)) catalog.pageKidsCountCache.put(ref, 1);
                                    if (!catalog.pageIndexCache.has(ref)) catalog.pageIndexCache.put(ref, 0);
                                    return [
                                        obj,
                                        ref
                                    ];
                                }
                            }
                            throw new _util.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
                        } catch (reason) {
                            (0, _util.warn)(`_getLinearizationPage: "${reason.message}".`);
                            return catalog.getPageDict(pageIndex);
                        }
                    }
                    getPage(pageIndex) {
                        const cachedPromise = this._pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const { catalog: catalog, linearization: linearization, xfaFactory: xfaFactory } = this;
                        let promise;
                        if (xfaFactory) promise = Promise.resolve([
                            _primitives.Dict.empty,
                            null
                        ]);
                        else if (linearization?.pageFirst === pageIndex) promise = this._getLinearizationPage(pageIndex);
                        else promise = catalog.getPageDict(pageIndex);
                        promise = promise.then(([pageDict, ref])=>{
                            return new Page({
                                pdfManager: this.pdfManager,
                                xref: this.xref,
                                pageIndex: pageIndex,
                                pageDict: pageDict,
                                ref: ref,
                                globalIdFactory: this._globalIdFactory,
                                fontCache: catalog.fontCache,
                                builtInCMapCache: catalog.builtInCMapCache,
                                standardFontDataCache: catalog.standardFontDataCache,
                                globalImageCache: catalog.globalImageCache,
                                systemFontCache: catalog.systemFontCache,
                                nonBlendModesSet: catalog.nonBlendModesSet,
                                xfaFactory: xfaFactory
                            });
                        });
                        this._pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    async checkFirstPage(recoveryMode = false) {
                        if (recoveryMode) return;
                        try {
                            await this.getPage(0);
                        } catch (reason) {
                            if (reason instanceof _core_utils.XRefEntryException) {
                                this._pagePromises.delete(0);
                                await this.cleanup();
                                throw new _core_utils.XRefParseException();
                            }
                        }
                    }
                    async checkLastPage(recoveryMode = false) {
                        const { catalog: catalog, pdfManager: pdfManager } = this;
                        catalog.setActualNumPages();
                        let numPages;
                        try {
                            await Promise.all([
                                pdfManager.ensureDoc("xfaFactory"),
                                pdfManager.ensureDoc("linearization"),
                                pdfManager.ensureCatalog("numPages")
                            ]);
                            if (this.xfaFactory) return;
                            else if (this.linearization) numPages = this.linearization.numPages;
                            else numPages = catalog.numPages;
                            if (!Number.isInteger(numPages)) throw new _util.FormatError("Page count is not an integer.");
                            else if (numPages <= 1) return;
                            await this.getPage(numPages - 1);
                        } catch (reason) {
                            this._pagePromises.delete(numPages - 1);
                            await this.cleanup();
                            if (reason instanceof _core_utils.XRefEntryException && !recoveryMode) throw new _core_utils.XRefParseException();
                            (0, _util.warn)(`checkLastPage - invalid /Pages tree /Count: ${numPages}.`);
                            let pagesTree;
                            try {
                                pagesTree = await catalog.getAllPageDicts(recoveryMode);
                            } catch (reasonAll) {
                                if (reasonAll instanceof _core_utils.XRefEntryException && !recoveryMode) throw new _core_utils.XRefParseException();
                                catalog.setActualNumPages(1);
                                return;
                            }
                            for (const [pageIndex, [pageDict, ref]] of pagesTree){
                                let promise;
                                if (pageDict instanceof Error) {
                                    promise = Promise.reject(pageDict);
                                    promise.catch(()=>{});
                                } else promise = Promise.resolve(new Page({
                                    pdfManager: pdfManager,
                                    xref: this.xref,
                                    pageIndex: pageIndex,
                                    pageDict: pageDict,
                                    ref: ref,
                                    globalIdFactory: this._globalIdFactory,
                                    fontCache: catalog.fontCache,
                                    builtInCMapCache: catalog.builtInCMapCache,
                                    standardFontDataCache: catalog.standardFontDataCache,
                                    globalImageCache: catalog.globalImageCache,
                                    systemFontCache: catalog.systemFontCache,
                                    nonBlendModesSet: catalog.nonBlendModesSet,
                                    xfaFactory: null
                                }));
                                this._pagePromises.set(pageIndex, promise);
                            }
                            catalog.setActualNumPages(pagesTree.size);
                        }
                    }
                    fontFallback(id, handler) {
                        return this.catalog.fontFallback(id, handler);
                    }
                    async cleanup(manuallyTriggered = false) {
                        return this.catalog ? this.catalog.cleanup(manuallyTriggered) : (0, _cleanup_helper.clearGlobalCaches)();
                    }
                    #collectFieldObjects(name, fieldRef, promises, annotationGlobals) {
                        const field = this.xref.fetchIfRef(fieldRef);
                        if (field.has("T")) {
                            const partName = (0, _util.stringToPDFString)(field.get("T"));
                            name = name === "" ? partName : `${name}.${partName}`;
                        }
                        if (!promises.has(name)) promises.set(name, []);
                        promises.get(name).push(_annotation.AnnotationFactory.create(this.xref, fieldRef, annotationGlobals, this._localIdFactory, true, null).then((annotation)=>annotation?.getFieldObject()).catch(function(reason) {
                            (0, _util.warn)(`#collectFieldObjects: "${reason}".`);
                            return null;
                        }));
                        if (field.has("Kids")) for (const kid of field.get("Kids"))this.#collectFieldObjects(name, kid, promises, annotationGlobals);
                    }
                    get fieldObjects() {
                        if (!this.formInfo.hasFields) return (0, _util.shadow)(this, "fieldObjects", Promise.resolve(null));
                        const promise = this.pdfManager.ensureDoc("annotationGlobals").then(async (annotationGlobals)=>{
                            if (!annotationGlobals) return null;
                            const allFields = Object.create(null);
                            const fieldPromises = new Map();
                            for (const fieldRef of this.catalog.acroForm.get("Fields"))this.#collectFieldObjects("", fieldRef, fieldPromises, annotationGlobals);
                            const allPromises = [];
                            for (const [name, promises] of fieldPromises)allPromises.push(Promise.all(promises).then((fields)=>{
                                fields = fields.filter((field)=>!!field);
                                if (fields.length > 0) allFields[name] = fields;
                            }));
                            await Promise.all(allPromises);
                            return allFields;
                        });
                        return (0, _util.shadow)(this, "fieldObjects", promise);
                    }
                    get hasJSActions() {
                        const promise = this.pdfManager.ensureDoc("_parseHasJSActions");
                        return (0, _util.shadow)(this, "hasJSActions", promise);
                    }
                    async _parseHasJSActions() {
                        const [catalogJsActions, fieldObjects] = await Promise.all([
                            this.pdfManager.ensureCatalog("jsActions"),
                            this.pdfManager.ensureDoc("fieldObjects")
                        ]);
                        if (catalogJsActions) return true;
                        if (fieldObjects) return Object.values(fieldObjects).some((fieldObject)=>fieldObject.some((object)=>object.actions !== null));
                        return false;
                    }
                    get calculationOrderIds() {
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm?.has("CO")) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        const calculationOrder = acroForm.get("CO");
                        if (!Array.isArray(calculationOrder) || calculationOrder.length === 0) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        const ids = [];
                        for (const id of calculationOrder)if (id instanceof _primitives.Ref) ids.push(id.toString());
                        if (ids.length === 0) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        return (0, _util.shadow)(this, "calculationOrderIds", ids);
                    }
                    get annotationGlobals() {
                        return (0, _util.shadow)(this, "annotationGlobals", _annotation.AnnotationFactory.createGlobals(this.pdfManager));
                    }
                }
                exports.PDFDocument = PDFDocument;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PopupAnnotation = exports.MarkupAnnotation = exports.AnnotationFactory = exports.AnnotationBorderStyle = exports.Annotation = void 0;
                exports.getQuadPoints = getQuadPoints;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _default_appearance = __w_pdfjs_require__(11);
                var _primitives = __w_pdfjs_require__(4);
                var _stream = __w_pdfjs_require__(8);
                var _base_stream = __w_pdfjs_require__(5);
                var _bidi = __w_pdfjs_require__(60);
                var _catalog = __w_pdfjs_require__(66);
                var _colorspace = __w_pdfjs_require__(12);
                var _file_spec = __w_pdfjs_require__(69);
                var _jpeg_stream = __w_pdfjs_require__(26);
                var _object_loader = __w_pdfjs_require__(76);
                var _operator_list = __w_pdfjs_require__(64);
                var _writer = __w_pdfjs_require__(73);
                var _factory = __w_pdfjs_require__(77);
                class AnnotationFactory {
                    static createGlobals(pdfManager) {
                        return Promise.all([
                            pdfManager.ensureCatalog("acroForm"),
                            pdfManager.ensureDoc("xfaDatasets"),
                            pdfManager.ensureCatalog("structTreeRoot"),
                            pdfManager.ensureCatalog("baseUrl"),
                            pdfManager.ensureCatalog("attachments")
                        ]).then(([acroForm, xfaDatasets, structTreeRoot, baseUrl, attachments])=>{
                            return {
                                pdfManager: pdfManager,
                                acroForm: acroForm instanceof _primitives.Dict ? acroForm : _primitives.Dict.empty,
                                xfaDatasets: xfaDatasets,
                                structTreeRoot: structTreeRoot,
                                baseUrl: baseUrl,
                                attachments: attachments
                            };
                        }, (reason)=>{
                            (0, _util.warn)(`createGlobals: "${reason}".`);
                            return null;
                        });
                    }
                    static async create(xref, ref, annotationGlobals, idFactory, collectFields, pageRef) {
                        const pageIndex = collectFields ? await this._getPageIndex(xref, ref, annotationGlobals.pdfManager) : null;
                        return annotationGlobals.pdfManager.ensure(this, "_create", [
                            xref,
                            ref,
                            annotationGlobals,
                            idFactory,
                            collectFields,
                            pageIndex,
                            pageRef
                        ]);
                    }
                    static _create(xref, ref, annotationGlobals, idFactory, collectFields = false, pageIndex = null, pageRef = null) {
                        const dict = xref.fetchIfRef(ref);
                        if (!(dict instanceof _primitives.Dict)) return undefined;
                        const { acroForm: acroForm, pdfManager: pdfManager } = annotationGlobals;
                        const id = ref instanceof _primitives.Ref ? ref.toString() : `annot_${idFactory.createObjId()}`;
                        let subtype = dict.get("Subtype");
                        subtype = subtype instanceof _primitives.Name ? subtype.name : null;
                        const parameters = {
                            xref: xref,
                            ref: ref,
                            dict: dict,
                            subtype: subtype,
                            id: id,
                            annotationGlobals: annotationGlobals,
                            collectFields: collectFields,
                            needAppearances: !collectFields && acroForm.get("NeedAppearances") === true,
                            pageIndex: pageIndex,
                            evaluatorOptions: pdfManager.evaluatorOptions,
                            pageRef: pageRef
                        };
                        switch(subtype){
                            case "Link":
                                return new LinkAnnotation(parameters);
                            case "Text":
                                return new TextAnnotation(parameters);
                            case "Widget":
                                let fieldType = (0, _core_utils.getInheritableProperty)({
                                    dict: dict,
                                    key: "FT"
                                });
                                fieldType = fieldType instanceof _primitives.Name ? fieldType.name : null;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotation(parameters);
                                    case "Btn":
                                        return new ButtonWidgetAnnotation(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotation(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotation(parameters);
                                }
                                (0, _util.warn)(`Unimplemented widget field type "${fieldType}", ` + "falling back to base field type.");
                                return new WidgetAnnotation(parameters);
                            case "Popup":
                                return new PopupAnnotation(parameters);
                            case "FreeText":
                                return new FreeTextAnnotation(parameters);
                            case "Line":
                                return new LineAnnotation(parameters);
                            case "Square":
                                return new SquareAnnotation(parameters);
                            case "Circle":
                                return new CircleAnnotation(parameters);
                            case "PolyLine":
                                return new PolylineAnnotation(parameters);
                            case "Polygon":
                                return new PolygonAnnotation(parameters);
                            case "Caret":
                                return new CaretAnnotation(parameters);
                            case "Ink":
                                return new InkAnnotation(parameters);
                            case "Highlight":
                                return new HighlightAnnotation(parameters);
                            case "Underline":
                                return new UnderlineAnnotation(parameters);
                            case "Squiggly":
                                return new SquigglyAnnotation(parameters);
                            case "StrikeOut":
                                return new StrikeOutAnnotation(parameters);
                            case "Stamp":
                                return new StampAnnotation(parameters);
                            case "FileAttachment":
                                return new FileAttachmentAnnotation(parameters);
                            default:
                                if (!collectFields) {
                                    if (!subtype) (0, _util.warn)("Annotation is missing the required /Subtype.");
                                    else (0, _util.warn)(`Unimplemented annotation type "${subtype}", ` + "falling back to base annotation.");
                                }
                                return new Annotation(parameters);
                        }
                    }
                    static async _getPageIndex(xref, ref, pdfManager) {
                        try {
                            const annotDict = await xref.fetchIfRefAsync(ref);
                            if (!(annotDict instanceof _primitives.Dict)) return -1;
                            const pageRef = annotDict.getRaw("P");
                            if (pageRef instanceof _primitives.Ref) try {
                                const pageIndex = await pdfManager.ensureCatalog("getPageIndex", [
                                    pageRef
                                ]);
                                return pageIndex;
                            } catch (ex) {
                                (0, _util.info)(`_getPageIndex -- not a valid page reference: "${ex}".`);
                            }
                            if (annotDict.has("Kids")) return -1;
                            const numPages = await pdfManager.ensureDoc("numPages");
                            for(let pageIndex = 0; pageIndex < numPages; pageIndex++){
                                const page = await pdfManager.getPage(pageIndex);
                                const annotations = await pdfManager.ensure(page, "annotations");
                                for (const annotRef of annotations){
                                    if (annotRef instanceof _primitives.Ref && (0, _primitives.isRefsEqual)(annotRef, ref)) return pageIndex;
                                }
                            }
                        } catch (ex) {
                            (0, _util.warn)(`_getPageIndex: "${ex}".`);
                        }
                        return -1;
                    }
                    static generateImages(annotations, xref, isOffscreenCanvasSupported) {
                        if (!isOffscreenCanvasSupported) {
                            (0, _util.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images.");
                            return null;
                        }
                        let imagePromises;
                        for (const { bitmapId: bitmapId, bitmap: bitmap } of annotations){
                            if (!bitmap) continue;
                            imagePromises ||= new Map();
                            imagePromises.set(bitmapId, StampAnnotation.createImage(bitmap, xref));
                        }
                        return imagePromises;
                    }
                    static async saveNewAnnotations(evaluator, task, annotations, imagePromises) {
                        const xref = evaluator.xref;
                        let baseFontRef;
                        const dependencies = [];
                        const promises = [];
                        const { isOffscreenCanvasSupported: isOffscreenCanvasSupported } = evaluator.options;
                        for (const annotation of annotations){
                            if (annotation.deleted) continue;
                            switch(annotation.annotationType){
                                case _util.AnnotationEditorType.FREETEXT:
                                    if (!baseFontRef) {
                                        const baseFont = new _primitives.Dict(xref);
                                        baseFont.set("BaseFont", _primitives.Name.get("Helvetica"));
                                        baseFont.set("Type", _primitives.Name.get("Font"));
                                        baseFont.set("Subtype", _primitives.Name.get("Type1"));
                                        baseFont.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                                        const buffer = [];
                                        baseFontRef = xref.getNewTemporaryRef();
                                        await (0, _writer.writeObject)(baseFontRef, baseFont, buffer, xref);
                                        dependencies.push({
                                            ref: baseFontRef,
                                            data: buffer.join("")
                                        });
                                    }
                                    promises.push(FreeTextAnnotation.createNewAnnotation(xref, annotation, dependencies, {
                                        evaluator: evaluator,
                                        task: task,
                                        baseFontRef: baseFontRef
                                    }));
                                    break;
                                case _util.AnnotationEditorType.INK:
                                    promises.push(InkAnnotation.createNewAnnotation(xref, annotation, dependencies));
                                    break;
                                case _util.AnnotationEditorType.STAMP:
                                    if (!isOffscreenCanvasSupported) break;
                                    const image = await imagePromises.get(annotation.bitmapId);
                                    if (image.imageStream) {
                                        const { imageStream: imageStream, smaskStream: smaskStream } = image;
                                        const buffer = [];
                                        if (smaskStream) {
                                            const smaskRef = xref.getNewTemporaryRef();
                                            await (0, _writer.writeObject)(smaskRef, smaskStream, buffer, xref);
                                            dependencies.push({
                                                ref: smaskRef,
                                                data: buffer.join("")
                                            });
                                            imageStream.dict.set("SMask", smaskRef);
                                            buffer.length = 0;
                                        }
                                        const imageRef = image.imageRef = xref.getNewTemporaryRef();
                                        await (0, _writer.writeObject)(imageRef, imageStream, buffer, xref);
                                        dependencies.push({
                                            ref: imageRef,
                                            data: buffer.join("")
                                        });
                                        image.imageStream = image.smaskStream = null;
                                    }
                                    promises.push(StampAnnotation.createNewAnnotation(xref, annotation, dependencies, {
                                        image: image
                                    }));
                                    break;
                            }
                        }
                        return {
                            annotations: await Promise.all(promises),
                            dependencies: dependencies
                        };
                    }
                    static async printNewAnnotations(annotationGlobals, evaluator, task, annotations, imagePromises) {
                        if (!annotations) return null;
                        const { options: options, xref: xref } = evaluator;
                        const promises = [];
                        for (const annotation of annotations){
                            if (annotation.deleted) continue;
                            switch(annotation.annotationType){
                                case _util.AnnotationEditorType.FREETEXT:
                                    promises.push(FreeTextAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                                        evaluator: evaluator,
                                        task: task,
                                        evaluatorOptions: options
                                    }));
                                    break;
                                case _util.AnnotationEditorType.INK:
                                    promises.push(InkAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                                        evaluatorOptions: options
                                    }));
                                    break;
                                case _util.AnnotationEditorType.STAMP:
                                    if (!options.isOffscreenCanvasSupported) break;
                                    const image = await imagePromises.get(annotation.bitmapId);
                                    if (image.imageStream) {
                                        const { imageStream: imageStream, smaskStream: smaskStream } = image;
                                        if (smaskStream) imageStream.dict.set("SMask", smaskStream);
                                        image.imageRef = new _jpeg_stream.JpegStream(imageStream, imageStream.length);
                                        image.imageStream = image.smaskStream = null;
                                    }
                                    promises.push(StampAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                                        image: image,
                                        evaluatorOptions: options
                                    }));
                                    break;
                            }
                        }
                        return Promise.all(promises);
                    }
                }
                exports.AnnotationFactory = AnnotationFactory;
                function getRgbColor(color, defaultColor = new Uint8ClampedArray(3)) {
                    if (!Array.isArray(color)) return defaultColor;
                    const rgbColor = defaultColor || new Uint8ClampedArray(3);
                    switch(color.length){
                        case 0:
                            return null;
                        case 1:
                            _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        case 3:
                            _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        case 4:
                            _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        default:
                            return defaultColor;
                    }
                }
                function getPdfColorArray(color) {
                    return Array.from(color, (c)=>c / 255);
                }
                function getQuadPoints(dict, rect) {
                    const quadPoints = dict.getArray("QuadPoints");
                    if (!Array.isArray(quadPoints) || quadPoints.length === 0 || quadPoints.length % 8 > 0) return null;
                    const quadPointsLists = [];
                    for(let i = 0, ii = quadPoints.length / 8; i < ii; i++){
                        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                        for(let j = i * 8, jj = i * 8 + 8; j < jj; j += 2){
                            const x = quadPoints[j];
                            const y = quadPoints[j + 1];
                            minX = Math.min(x, minX);
                            maxX = Math.max(x, maxX);
                            minY = Math.min(y, minY);
                            maxY = Math.max(y, maxY);
                        }
                        if (rect !== null && (minX < rect[0] || maxX > rect[2] || minY < rect[1] || maxY > rect[3])) return null;
                        quadPointsLists.push([
                            {
                                x: minX,
                                y: maxY
                            },
                            {
                                x: maxX,
                                y: maxY
                            },
                            {
                                x: minX,
                                y: minY
                            },
                            {
                                x: maxX,
                                y: minY
                            }
                        ]);
                    }
                    return quadPointsLists;
                }
                function getTransformMatrix(rect, bbox, matrix) {
                    const [minX, minY, maxX, maxY] = _util.Util.getAxialAlignedBoundingBox(bbox, matrix);
                    if (minX === maxX || minY === maxY) return [
                        1,
                        0,
                        0,
                        1,
                        rect[0],
                        rect[1]
                    ];
                    const xRatio = (rect[2] - rect[0]) / (maxX - minX);
                    const yRatio = (rect[3] - rect[1]) / (maxY - minY);
                    return [
                        xRatio,
                        0,
                        0,
                        yRatio,
                        rect[0] - minX * xRatio,
                        rect[1] - minY * yRatio
                    ];
                }
                class Annotation {
                    constructor(params){
                        const { dict: dict, xref: xref, annotationGlobals: annotationGlobals } = params;
                        this.setTitle(dict.get("T"));
                        this.setContents(dict.get("Contents"));
                        this.setModificationDate(dict.get("M"));
                        this.setFlags(dict.get("F"));
                        this.setRectangle(dict.getArray("Rect"));
                        this.setColor(dict.getArray("C"));
                        this.setBorderStyle(dict);
                        this.setAppearance(dict);
                        this.setOptionalContent(dict);
                        const MK = dict.get("MK");
                        this.setBorderAndBackgroundColors(MK);
                        this.setRotation(MK, dict);
                        this.ref = params.ref instanceof _primitives.Ref ? params.ref : null;
                        this._streams = [];
                        if (this.appearance) this._streams.push(this.appearance);
                        const isLocked = !!(this.flags & _util.AnnotationFlag.LOCKED);
                        const isContentLocked = !!(this.flags & _util.AnnotationFlag.LOCKEDCONTENTS);
                        if (annotationGlobals.structTreeRoot) {
                            let structParent = dict.get("StructParent");
                            structParent = Number.isInteger(structParent) && structParent >= 0 ? structParent : -1;
                            annotationGlobals.structTreeRoot.addAnnotationIdToPage(params.pageRef, structParent);
                        }
                        this.data = {
                            annotationFlags: this.flags,
                            borderStyle: this.borderStyle,
                            color: this.color,
                            backgroundColor: this.backgroundColor,
                            borderColor: this.borderColor,
                            rotation: this.rotation,
                            contentsObj: this._contents,
                            hasAppearance: !!this.appearance,
                            id: params.id,
                            modificationDate: this.modificationDate,
                            rect: this.rectangle,
                            subtype: params.subtype,
                            hasOwnCanvas: false,
                            noRotate: !!(this.flags & _util.AnnotationFlag.NOROTATE),
                            noHTML: isLocked && isContentLocked
                        };
                        if (params.collectFields) {
                            const kids = dict.get("Kids");
                            if (Array.isArray(kids)) {
                                const kidIds = [];
                                for (const kid of kids)if (kid instanceof _primitives.Ref) kidIds.push(kid.toString());
                                if (kidIds.length !== 0) this.data.kidIds = kidIds;
                            }
                            this.data.actions = (0, _core_utils.collectActions)(xref, dict, _util.AnnotationActionEventType);
                            this.data.fieldName = this._constructFieldName(dict);
                            this.data.pageIndex = params.pageIndex;
                        }
                        this._isOffscreenCanvasSupported = params.evaluatorOptions.isOffscreenCanvasSupported;
                        this._fallbackFontDict = null;
                        this._needAppearances = false;
                    }
                    _hasFlag(flags, flag) {
                        return !!(flags & flag);
                    }
                    _isViewable(flags) {
                        return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.NOVIEW);
                    }
                    _isPrintable(flags) {
                        return this._hasFlag(flags, _util.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN) && !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(annotationStorage, _renderForms) {
                        const noView = annotationStorage?.get(this.data.id)?.noView;
                        if (noView !== undefined) return !noView;
                        return this.viewable && !this._hasFlag(this.flags, _util.AnnotationFlag.HIDDEN);
                    }
                    mustBePrinted(annotationStorage) {
                        const noPrint = annotationStorage?.get(this.data.id)?.noPrint;
                        if (noPrint !== undefined) return !noPrint;
                        return this.printable;
                    }
                    get viewable() {
                        if (this.data.quadPoints === null) return false;
                        if (this.flags === 0) return true;
                        return this._isViewable(this.flags);
                    }
                    get printable() {
                        if (this.data.quadPoints === null) return false;
                        if (this.flags === 0) return false;
                        return this._isPrintable(this.flags);
                    }
                    _parseStringHelper(data) {
                        const str = typeof data === "string" ? (0, _util.stringToPDFString)(data) : "";
                        const dir = str && (0, _bidi.bidi)(str).dir === "rtl" ? "rtl" : "ltr";
                        return {
                            str: str,
                            dir: dir
                        };
                    }
                    setDefaultAppearance(params) {
                        const { dict: dict, annotationGlobals: annotationGlobals } = params;
                        const defaultAppearance = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DA"
                        }) || annotationGlobals.acroForm.get("DA");
                        this._defaultAppearance = typeof defaultAppearance === "string" ? defaultAppearance : "";
                        this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance);
                    }
                    setTitle(title) {
                        this._title = this._parseStringHelper(title);
                    }
                    setContents(contents) {
                        this._contents = this._parseStringHelper(contents);
                    }
                    setModificationDate(modificationDate) {
                        this.modificationDate = typeof modificationDate === "string" ? modificationDate : null;
                    }
                    setFlags(flags) {
                        this.flags = Number.isInteger(flags) && flags > 0 ? flags : 0;
                    }
                    hasFlag(flag) {
                        return this._hasFlag(this.flags, flag);
                    }
                    setRectangle(rectangle) {
                        this.rectangle = Array.isArray(rectangle) && rectangle.length === 4 ? _util.Util.normalizeRect(rectangle) : [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    setColor(color) {
                        this.color = getRgbColor(color);
                    }
                    setLineEndings(lineEndings) {
                        this.lineEndings = [
                            "None",
                            "None"
                        ];
                        if (Array.isArray(lineEndings) && lineEndings.length === 2) for(let i = 0; i < 2; i++){
                            const obj = lineEndings[i];
                            if (obj instanceof _primitives.Name) switch(obj.name){
                                case "None":
                                    continue;
                                case "Square":
                                case "Circle":
                                case "Diamond":
                                case "OpenArrow":
                                case "ClosedArrow":
                                case "Butt":
                                case "ROpenArrow":
                                case "RClosedArrow":
                                case "Slash":
                                    this.lineEndings[i] = obj.name;
                                    continue;
                            }
                            (0, _util.warn)(`Ignoring invalid lineEnding: ${obj}`);
                        }
                    }
                    setRotation(mk, dict) {
                        this.rotation = 0;
                        let angle = mk instanceof _primitives.Dict ? mk.get("R") || 0 : dict.get("Rotate") || 0;
                        if (Number.isInteger(angle) && angle !== 0) {
                            angle %= 360;
                            if (angle < 0) angle += 360;
                            if (angle % 90 === 0) this.rotation = angle;
                        }
                    }
                    setBorderAndBackgroundColors(mk) {
                        if (mk instanceof _primitives.Dict) {
                            this.borderColor = getRgbColor(mk.getArray("BC"), null);
                            this.backgroundColor = getRgbColor(mk.getArray("BG"), null);
                        } else this.borderColor = this.backgroundColor = null;
                    }
                    setBorderStyle(borderStyle) {
                        this.borderStyle = new AnnotationBorderStyle();
                        if (!(borderStyle instanceof _primitives.Dict)) return;
                        if (borderStyle.has("BS")) {
                            const dict = borderStyle.get("BS");
                            const dictType = dict.get("Type");
                            if (!dictType || (0, _primitives.isName)(dictType, "Border")) {
                                this.borderStyle.setWidth(dict.get("W"), this.rectangle);
                                this.borderStyle.setStyle(dict.get("S"));
                                this.borderStyle.setDashArray(dict.getArray("D"));
                            }
                        } else if (borderStyle.has("Border")) {
                            const array = borderStyle.getArray("Border");
                            if (Array.isArray(array) && array.length >= 3) {
                                this.borderStyle.setHorizontalCornerRadius(array[0]);
                                this.borderStyle.setVerticalCornerRadius(array[1]);
                                this.borderStyle.setWidth(array[2], this.rectangle);
                                if (array.length === 4) this.borderStyle.setDashArray(array[3], true);
                            }
                        } else this.borderStyle.setWidth(0);
                    }
                    setAppearance(dict) {
                        this.appearance = null;
                        const appearanceStates = dict.get("AP");
                        if (!(appearanceStates instanceof _primitives.Dict)) return;
                        const normalAppearanceState = appearanceStates.get("N");
                        if (normalAppearanceState instanceof _base_stream.BaseStream) {
                            this.appearance = normalAppearanceState;
                            return;
                        }
                        if (!(normalAppearanceState instanceof _primitives.Dict)) return;
                        const as = dict.get("AS");
                        if (!(as instanceof _primitives.Name) || !normalAppearanceState.has(as.name)) return;
                        const appearance = normalAppearanceState.get(as.name);
                        if (appearance instanceof _base_stream.BaseStream) this.appearance = appearance;
                    }
                    setOptionalContent(dict) {
                        this.oc = null;
                        const oc = dict.get("OC");
                        if (oc instanceof _primitives.Name) (0, _util.warn)("setOptionalContent: Support for /Name-entry is not implemented.");
                        else if (oc instanceof _primitives.Dict) this.oc = oc;
                    }
                    loadResources(keys, appearance) {
                        return appearance.dict.getAsync("Resources").then((resources)=>{
                            if (!resources) return undefined;
                            const objectLoader = new _object_loader.ObjectLoader(resources, keys, resources.xref);
                            return objectLoader.load().then(function() {
                                return resources;
                            });
                        });
                    }
                    async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                        const data = this.data;
                        let appearance = this.appearance;
                        const isUsingOwnCanvas = !!(this.data.hasOwnCanvas && intent & _util.RenderingIntentFlag.DISPLAY);
                        if (!appearance) {
                            if (!isUsingOwnCanvas) return {
                                opList: new _operator_list.OperatorList(),
                                separateForm: false,
                                separateCanvas: false
                            };
                            appearance = new _stream.StringStream("");
                            appearance.dict = new _primitives.Dict();
                        }
                        const appearanceDict = appearance.dict;
                        const resources = await this.loadResources([
                            "ExtGState",
                            "ColorSpace",
                            "Pattern",
                            "Shading",
                            "XObject",
                            "Font"
                        ], appearance);
                        const bbox = appearanceDict.getArray("BBox") || [
                            0,
                            0,
                            1,
                            1
                        ];
                        const matrix = appearanceDict.getArray("Matrix") || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        const transform = getTransformMatrix(data.rect, bbox, matrix);
                        const opList = new _operator_list.OperatorList();
                        let optionalContent;
                        if (this.oc) optionalContent = await evaluator.parseMarkedContentProps(this.oc, null);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        opList.addOp(_util.OPS.beginAnnotation, [
                            data.id,
                            data.rect,
                            transform,
                            matrix,
                            isUsingOwnCanvas
                        ]);
                        await evaluator.getOperatorList({
                            stream: appearance,
                            task: task,
                            resources: resources,
                            operatorList: opList,
                            fallbackFontDict: this._fallbackFontDict
                        });
                        opList.addOp(_util.OPS.endAnnotation, []);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.endMarkedContent, []);
                        this.reset();
                        return {
                            opList: opList,
                            separateForm: false,
                            separateCanvas: isUsingOwnCanvas
                        };
                    }
                    async save(evaluator, task, annotationStorage) {
                        return null;
                    }
                    get hasTextContent() {
                        return false;
                    }
                    async extractTextContent(evaluator, task, viewBox) {
                        if (!this.appearance) return;
                        const resources = await this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ], this.appearance);
                        const text = [];
                        const buffer = [];
                        let firstPosition = null;
                        const sink = {
                            desiredSize: Math.Infinity,
                            ready: true,
                            enqueue (chunk, size) {
                                for (const item of chunk.items){
                                    if (item.str === undefined) continue;
                                    firstPosition ||= item.transform.slice(-2);
                                    buffer.push(item.str);
                                    if (item.hasEOL) {
                                        text.push(buffer.join(""));
                                        buffer.length = 0;
                                    }
                                }
                            }
                        };
                        await evaluator.getTextContent({
                            stream: this.appearance,
                            task: task,
                            resources: resources,
                            includeMarkedContent: true,
                            sink: sink,
                            viewBox: viewBox
                        });
                        this.reset();
                        if (buffer.length) text.push(buffer.join(""));
                        if (text.length > 1 || text[0]) {
                            const appearanceDict = this.appearance.dict;
                            const bbox = appearanceDict.getArray("BBox") || [
                                0,
                                0,
                                1,
                                1
                            ];
                            const matrix = appearanceDict.getArray("Matrix") || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                            const rect = this.data.rect;
                            const transform = getTransformMatrix(rect, bbox, matrix);
                            transform[4] -= rect[0];
                            transform[5] -= rect[1];
                            firstPosition = _util.Util.applyTransform(firstPosition, transform);
                            firstPosition = _util.Util.applyTransform(firstPosition, matrix);
                            this.data.textPosition = firstPosition;
                            this.data.textContent = text;
                        }
                    }
                    getFieldObject() {
                        if (this.data.kidIds) return {
                            id: this.data.id,
                            actions: this.data.actions,
                            name: this.data.fieldName,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            type: "",
                            kidIds: this.data.kidIds,
                            page: this.data.pageIndex,
                            rotation: this.rotation
                        };
                        return null;
                    }
                    reset() {
                        for (const stream of this._streams)stream.reset();
                    }
                    _constructFieldName(dict) {
                        if (!dict.has("T") && !dict.has("Parent")) {
                            (0, _util.warn)("Unknown field name, falling back to empty field name.");
                            return "";
                        }
                        if (!dict.has("Parent")) return (0, _util.stringToPDFString)(dict.get("T"));
                        const fieldName = [];
                        if (dict.has("T")) fieldName.unshift((0, _util.stringToPDFString)(dict.get("T")));
                        let loopDict = dict;
                        const visited = new _primitives.RefSet();
                        if (dict.objId) visited.put(dict.objId);
                        while(loopDict.has("Parent")){
                            loopDict = loopDict.get("Parent");
                            if (!(loopDict instanceof _primitives.Dict) || loopDict.objId && visited.has(loopDict.objId)) break;
                            if (loopDict.objId) visited.put(loopDict.objId);
                            if (loopDict.has("T")) fieldName.unshift((0, _util.stringToPDFString)(loopDict.get("T")));
                        }
                        return fieldName.join(".");
                    }
                }
                exports.Annotation = Annotation;
                class AnnotationBorderStyle {
                    constructor(){
                        this.width = 1;
                        this.style = _util.AnnotationBorderStyleType.SOLID;
                        this.dashArray = [
                            3
                        ];
                        this.horizontalCornerRadius = 0;
                        this.verticalCornerRadius = 0;
                    }
                    setWidth(width, rect = [
                        0,
                        0,
                        0,
                        0
                    ]) {
                        if (width instanceof _primitives.Name) {
                            this.width = 0;
                            return;
                        }
                        if (typeof width === "number") {
                            if (width > 0) {
                                const maxWidth = (rect[2] - rect[0]) / 2;
                                const maxHeight = (rect[3] - rect[1]) / 2;
                                if (maxWidth > 0 && maxHeight > 0 && (width > maxWidth || width > maxHeight)) {
                                    (0, _util.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${width}`);
                                    width = 1;
                                }
                            }
                            this.width = width;
                        }
                    }
                    setStyle(style) {
                        if (!(style instanceof _primitives.Name)) return;
                        switch(style.name){
                            case "S":
                                this.style = _util.AnnotationBorderStyleType.SOLID;
                                break;
                            case "D":
                                this.style = _util.AnnotationBorderStyleType.DASHED;
                                break;
                            case "B":
                                this.style = _util.AnnotationBorderStyleType.BEVELED;
                                break;
                            case "I":
                                this.style = _util.AnnotationBorderStyleType.INSET;
                                break;
                            case "U":
                                this.style = _util.AnnotationBorderStyleType.UNDERLINE;
                                break;
                            default:
                                break;
                        }
                    }
                    setDashArray(dashArray, forceStyle = false) {
                        if (Array.isArray(dashArray) && dashArray.length > 0) {
                            let isValid = true;
                            let allZeros = true;
                            for (const element of dashArray){
                                const validNumber = +element >= 0;
                                if (!validNumber) {
                                    isValid = false;
                                    break;
                                } else if (element > 0) allZeros = false;
                            }
                            if (isValid && !allZeros) {
                                this.dashArray = dashArray;
                                if (forceStyle) this.setStyle(_primitives.Name.get("D"));
                            } else this.width = 0;
                        } else if (dashArray) this.width = 0;
                    }
                    setHorizontalCornerRadius(radius) {
                        if (Number.isInteger(radius)) this.horizontalCornerRadius = radius;
                    }
                    setVerticalCornerRadius(radius) {
                        if (Number.isInteger(radius)) this.verticalCornerRadius = radius;
                    }
                }
                exports.AnnotationBorderStyle = AnnotationBorderStyle;
                class MarkupAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict } = params;
                        if (dict.has("IRT")) {
                            const rawIRT = dict.getRaw("IRT");
                            this.data.inReplyTo = rawIRT instanceof _primitives.Ref ? rawIRT.toString() : null;
                            const rt = dict.get("RT");
                            this.data.replyType = rt instanceof _primitives.Name ? rt.name : _util.AnnotationReplyType.REPLY;
                        }
                        let popupRef = null;
                        if (this.data.replyType === _util.AnnotationReplyType.GROUP) {
                            const parent = dict.get("IRT");
                            this.setTitle(parent.get("T"));
                            this.data.titleObj = this._title;
                            this.setContents(parent.get("Contents"));
                            this.data.contentsObj = this._contents;
                            if (!parent.has("CreationDate")) this.data.creationDate = null;
                            else {
                                this.setCreationDate(parent.get("CreationDate"));
                                this.data.creationDate = this.creationDate;
                            }
                            if (!parent.has("M")) this.data.modificationDate = null;
                            else {
                                this.setModificationDate(parent.get("M"));
                                this.data.modificationDate = this.modificationDate;
                            }
                            popupRef = parent.getRaw("Popup");
                            if (!parent.has("C")) this.data.color = null;
                            else {
                                this.setColor(parent.getArray("C"));
                                this.data.color = this.color;
                            }
                        } else {
                            this.data.titleObj = this._title;
                            this.setCreationDate(dict.get("CreationDate"));
                            this.data.creationDate = this.creationDate;
                            popupRef = dict.getRaw("Popup");
                            if (!dict.has("C")) this.data.color = null;
                        }
                        this.data.popupRef = popupRef instanceof _primitives.Ref ? popupRef.toString() : null;
                        if (dict.has("RC")) this.data.richText = _factory.XFAFactory.getRichTextAsHtml(dict.get("RC"));
                    }
                    setCreationDate(creationDate) {
                        this.creationDate = typeof creationDate === "string" ? creationDate : null;
                    }
                    _setDefaultAppearance({ xref: xref, extra: extra, strokeColor: strokeColor, fillColor: fillColor, blendMode: blendMode, strokeAlpha: strokeAlpha, fillAlpha: fillAlpha, pointsCallback: pointsCallback }) {
                        let minX = Number.MAX_VALUE;
                        let minY = Number.MAX_VALUE;
                        let maxX = Number.MIN_VALUE;
                        let maxY = Number.MIN_VALUE;
                        const buffer = [
                            "q"
                        ];
                        if (extra) buffer.push(extra);
                        if (strokeColor) buffer.push(`${strokeColor[0]} ${strokeColor[1]} ${strokeColor[2]} RG`);
                        if (fillColor) buffer.push(`${fillColor[0]} ${fillColor[1]} ${fillColor[2]} rg`);
                        let pointsArray = this.data.quadPoints;
                        if (!pointsArray) pointsArray = [
                            [
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[1]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[1]
                                }
                            ]
                        ];
                        for (const points of pointsArray){
                            const [mX, MX, mY, MY] = pointsCallback(buffer, points);
                            minX = Math.min(minX, mX);
                            maxX = Math.max(maxX, MX);
                            minY = Math.min(minY, mY);
                            maxY = Math.max(maxY, MY);
                        }
                        buffer.push("Q");
                        const formDict = new _primitives.Dict(xref);
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        const appearanceStream = new _stream.StringStream(buffer.join(" "));
                        appearanceStream.dict = appearanceStreamDict;
                        formDict.set("Fm0", appearanceStream);
                        const gsDict = new _primitives.Dict(xref);
                        if (blendMode) gsDict.set("BM", _primitives.Name.get(blendMode));
                        if (typeof strokeAlpha === "number") gsDict.set("CA", strokeAlpha);
                        if (typeof fillAlpha === "number") gsDict.set("ca", fillAlpha);
                        const stateDict = new _primitives.Dict(xref);
                        stateDict.set("GS0", gsDict);
                        const resources = new _primitives.Dict(xref);
                        resources.set("ExtGState", stateDict);
                        resources.set("XObject", formDict);
                        const appearanceDict = new _primitives.Dict(xref);
                        appearanceDict.set("Resources", resources);
                        const bbox = this.data.rect = [
                            minX,
                            minY,
                            maxX,
                            maxY
                        ];
                        appearanceDict.set("BBox", bbox);
                        this.appearance = new _stream.StringStream("/GS0 gs /Fm0 Do");
                        this.appearance.dict = appearanceDict;
                        this._streams.push(this.appearance, appearanceStream);
                    }
                    static async createNewAnnotation(xref, annotation, dependencies, params) {
                        const annotationRef = annotation.ref ||= xref.getNewTemporaryRef();
                        const ap = await this.createNewAppearanceStream(annotation, xref, params);
                        const buffer = [];
                        let annotationDict;
                        if (ap) {
                            const apRef = xref.getNewTemporaryRef();
                            annotationDict = this.createNewDict(annotation, xref, {
                                apRef: apRef
                            });
                            await (0, _writer.writeObject)(apRef, ap, buffer, xref);
                            dependencies.push({
                                ref: apRef,
                                data: buffer.join("")
                            });
                        } else annotationDict = this.createNewDict(annotation, xref, {});
                        if (Number.isInteger(annotation.parentTreeId)) annotationDict.set("StructParent", annotation.parentTreeId);
                        buffer.length = 0;
                        await (0, _writer.writeObject)(annotationRef, annotationDict, buffer, xref);
                        return {
                            ref: annotationRef,
                            data: buffer.join("")
                        };
                    }
                    static async createNewPrintAnnotation(annotationGlobals, xref, annotation, params) {
                        const ap = await this.createNewAppearanceStream(annotation, xref, params);
                        const annotationDict = this.createNewDict(annotation, xref, {
                            ap: ap
                        });
                        const newAnnotation = new this.prototype.constructor({
                            dict: annotationDict,
                            xref: xref,
                            annotationGlobals: annotationGlobals,
                            evaluatorOptions: params.evaluatorOptions
                        });
                        if (annotation.ref) newAnnotation.ref = newAnnotation.refToReplace = annotation.ref;
                        return newAnnotation;
                    }
                }
                exports.MarkupAnnotation = MarkupAnnotation;
                class WidgetAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref, annotationGlobals: annotationGlobals } = params;
                        const data = this.data;
                        this._needAppearances = params.needAppearances;
                        data.annotationType = _util.AnnotationType.WIDGET;
                        if (data.fieldName === undefined) data.fieldName = this._constructFieldName(dict);
                        if (data.actions === undefined) data.actions = (0, _core_utils.collectActions)(xref, dict, _util.AnnotationActionEventType);
                        let fieldValue = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "V",
                            getArray: true
                        });
                        data.fieldValue = this._decodeFormValue(fieldValue);
                        const defaultFieldValue = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DV",
                            getArray: true
                        });
                        data.defaultFieldValue = this._decodeFormValue(defaultFieldValue);
                        if (fieldValue === undefined && annotationGlobals.xfaDatasets) {
                            const path = this._title.str;
                            if (path) {
                                this._hasValueFromXFA = true;
                                data.fieldValue = fieldValue = annotationGlobals.xfaDatasets.getValue(path);
                            }
                        }
                        if (fieldValue === undefined && data.defaultFieldValue !== null) data.fieldValue = data.defaultFieldValue;
                        data.alternativeText = (0, _util.stringToPDFString)(dict.get("TU") || "");
                        this.setDefaultAppearance(params);
                        data.hasAppearance ||= this._needAppearances && data.fieldValue !== undefined && data.fieldValue !== null;
                        const fieldType = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "FT"
                        });
                        data.fieldType = fieldType instanceof _primitives.Name ? fieldType.name : null;
                        const localResources = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DR"
                        });
                        const acroFormResources = annotationGlobals.acroForm.get("DR");
                        const appearanceResources = this.appearance?.dict.get("Resources");
                        this._fieldResources = {
                            localResources: localResources,
                            acroFormResources: acroFormResources,
                            appearanceResources: appearanceResources,
                            mergedResources: _primitives.Dict.merge({
                                xref: xref,
                                dictArray: [
                                    localResources,
                                    appearanceResources,
                                    acroFormResources
                                ],
                                mergeSubDicts: true
                            })
                        };
                        data.fieldFlags = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Ff"
                        });
                        if (!Number.isInteger(data.fieldFlags) || data.fieldFlags < 0) data.fieldFlags = 0;
                        data.readOnly = this.hasFieldFlag(_util.AnnotationFieldFlag.READONLY);
                        data.required = this.hasFieldFlag(_util.AnnotationFieldFlag.REQUIRED);
                        data.hidden = this._hasFlag(data.annotationFlags, _util.AnnotationFlag.HIDDEN) || this._hasFlag(data.annotationFlags, _util.AnnotationFlag.NOVIEW);
                    }
                    _decodeFormValue(formValue) {
                        if (Array.isArray(formValue)) return formValue.filter((item)=>typeof item === "string").map((item)=>(0, _util.stringToPDFString)(item));
                        else if (formValue instanceof _primitives.Name) return (0, _util.stringToPDFString)(formValue.name);
                        else if (typeof formValue === "string") return (0, _util.stringToPDFString)(formValue);
                        return null;
                    }
                    hasFieldFlag(flag) {
                        return !!(this.data.fieldFlags & flag);
                    }
                    _isViewable(flags) {
                        return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(annotationStorage, renderForms) {
                        if (renderForms) return this.viewable;
                        return super.mustBeViewed(annotationStorage, renderForms) && !this._hasFlag(this.flags, _util.AnnotationFlag.NOVIEW);
                    }
                    getRotationMatrix(annotationStorage) {
                        let rotation = annotationStorage?.get(this.data.id)?.rotation;
                        if (rotation === undefined) rotation = this.rotation;
                        if (rotation === 0) return _util.IDENTITY_MATRIX;
                        const width = this.data.rect[2] - this.data.rect[0];
                        const height = this.data.rect[3] - this.data.rect[1];
                        return (0, _core_utils.getRotationMatrix)(rotation, width, height);
                    }
                    getBorderAndBackgroundAppearances(annotationStorage) {
                        let rotation = annotationStorage?.get(this.data.id)?.rotation;
                        if (rotation === undefined) rotation = this.rotation;
                        if (!this.backgroundColor && !this.borderColor) return "";
                        const width = this.data.rect[2] - this.data.rect[0];
                        const height = this.data.rect[3] - this.data.rect[1];
                        const rect = rotation === 0 || rotation === 180 ? `0 0 ${width} ${height} re` : `0 0 ${height} ${width} re`;
                        let str = "";
                        if (this.backgroundColor) str = `${(0, _default_appearance.getPdfColor)(this.backgroundColor, true)} ${rect} f `;
                        if (this.borderColor) {
                            const borderWidth = this.borderStyle.width || 1;
                            str += `${borderWidth} w ${(0, _default_appearance.getPdfColor)(this.borderColor, false)} ${rect} S `;
                        }
                        return str;
                    }
                    async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                        if (renderForms && !(this instanceof SignatureWidgetAnnotation) && !this.data.noHTML && !this.data.hasOwnCanvas) return {
                            opList: new _operator_list.OperatorList(),
                            separateForm: true,
                            separateCanvas: false
                        };
                        if (!this._hasText) return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                        const content = await this._getAppearance(evaluator, task, intent, annotationStorage);
                        if (this.appearance && content === null) return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                        const opList = new _operator_list.OperatorList();
                        if (!this._defaultAppearance || content === null) return {
                            opList: opList,
                            separateForm: false,
                            separateCanvas: false
                        };
                        const isUsingOwnCanvas = !!(this.data.hasOwnCanvas && intent & _util.RenderingIntentFlag.DISPLAY);
                        const matrix = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        const bbox = [
                            0,
                            0,
                            this.data.rect[2] - this.data.rect[0],
                            this.data.rect[3] - this.data.rect[1]
                        ];
                        const transform = getTransformMatrix(this.data.rect, bbox, matrix);
                        let optionalContent;
                        if (this.oc) optionalContent = await evaluator.parseMarkedContentProps(this.oc, null);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        opList.addOp(_util.OPS.beginAnnotation, [
                            this.data.id,
                            this.data.rect,
                            transform,
                            this.getRotationMatrix(annotationStorage),
                            isUsingOwnCanvas
                        ]);
                        const stream = new _stream.StringStream(content);
                        await evaluator.getOperatorList({
                            stream: stream,
                            task: task,
                            resources: this._fieldResources.mergedResources,
                            operatorList: opList
                        });
                        opList.addOp(_util.OPS.endAnnotation, []);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.endMarkedContent, []);
                        return {
                            opList: opList,
                            separateForm: false,
                            separateCanvas: isUsingOwnCanvas
                        };
                    }
                    _getMKDict(rotation) {
                        const mk = new _primitives.Dict(null);
                        if (rotation) mk.set("R", rotation);
                        if (this.borderColor) mk.set("BC", getPdfColorArray(this.borderColor));
                        if (this.backgroundColor) mk.set("BG", getPdfColorArray(this.backgroundColor));
                        return mk.size > 0 ? mk : null;
                    }
                    amendSavedDict(annotationStorage, dict) {}
                    async save(evaluator, task, annotationStorage) {
                        const storageEntry = annotationStorage?.get(this.data.id);
                        let value = storageEntry?.value, rotation = storageEntry?.rotation;
                        if (value === this.data.fieldValue || value === undefined) {
                            if (!this._hasValueFromXFA && rotation === undefined) return null;
                            value ||= this.data.fieldValue;
                        }
                        if (rotation === undefined && !this._hasValueFromXFA && Array.isArray(value) && Array.isArray(this.data.fieldValue) && value.length === this.data.fieldValue.length && value.every((x, i)=>x === this.data.fieldValue[i])) return null;
                        if (rotation === undefined) rotation = this.rotation;
                        let appearance = null;
                        if (!this._needAppearances) {
                            appearance = await this._getAppearance(evaluator, task, _util.RenderingIntentFlag.SAVE, annotationStorage);
                            if (appearance === null) return null;
                        }
                        let needAppearances = false;
                        if (appearance?.needAppearances) {
                            needAppearances = true;
                            appearance = null;
                        }
                        const { xref: xref } = evaluator;
                        const originalDict = xref.fetchIfRef(this.ref);
                        if (!(originalDict instanceof _primitives.Dict)) return null;
                        const dict = new _primitives.Dict(xref);
                        for (const key of originalDict.getKeys())if (key !== "AP") dict.set(key, originalDict.getRaw(key));
                        const xfa = {
                            path: this.data.fieldName,
                            value: value
                        };
                        const encoder = (val)=>{
                            return (0, _core_utils.isAscii)(val) ? val : (0, _core_utils.stringToUTF16String)(val, true);
                        };
                        dict.set("V", Array.isArray(value) ? value.map(encoder) : encoder(value));
                        this.amendSavedDict(annotationStorage, dict);
                        const maybeMK = this._getMKDict(rotation);
                        if (maybeMK) dict.set("MK", maybeMK);
                        const buffer = [];
                        const changes = [
                            {
                                ref: this.ref,
                                data: "",
                                xfa: xfa,
                                needAppearances: needAppearances
                            }
                        ];
                        if (appearance !== null) {
                            const newRef = xref.getNewTemporaryRef();
                            const AP = new _primitives.Dict(xref);
                            dict.set("AP", AP);
                            AP.set("N", newRef);
                            const resources = this._getSaveFieldResources(xref);
                            const appearanceStream = new _stream.StringStream(appearance);
                            const appearanceDict = appearanceStream.dict = new _primitives.Dict(xref);
                            appearanceDict.set("Subtype", _primitives.Name.get("Form"));
                            appearanceDict.set("Resources", resources);
                            appearanceDict.set("BBox", [
                                0,
                                0,
                                this.data.rect[2] - this.data.rect[0],
                                this.data.rect[3] - this.data.rect[1]
                            ]);
                            const rotationMatrix = this.getRotationMatrix(annotationStorage);
                            if (rotationMatrix !== _util.IDENTITY_MATRIX) appearanceDict.set("Matrix", rotationMatrix);
                            await (0, _writer.writeObject)(newRef, appearanceStream, buffer, xref);
                            changes.push({
                                ref: newRef,
                                data: buffer.join(""),
                                xfa: null,
                                needAppearances: false
                            });
                            buffer.length = 0;
                        }
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        await (0, _writer.writeObject)(this.ref, dict, buffer, xref);
                        changes[0].data = buffer.join("");
                        return changes;
                    }
                    async _getAppearance(evaluator, task, intent, annotationStorage) {
                        const isPassword = this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD);
                        if (isPassword) return null;
                        const storageEntry = annotationStorage?.get(this.data.id);
                        let value, rotation;
                        if (storageEntry) {
                            value = storageEntry.formattedValue || storageEntry.value;
                            rotation = storageEntry.rotation;
                        }
                        if (rotation === undefined && value === undefined && !this._needAppearances) {
                            if (!this._hasValueFromXFA || this.appearance) return null;
                        }
                        const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                        if (value === undefined) {
                            value = this.data.fieldValue;
                            if (!value) return `/Tx BMC q ${colors}Q EMC`;
                        }
                        if (Array.isArray(value) && value.length === 1) value = value[0];
                        (0, _util.assert)(typeof value === "string", "Expected `value` to be a string.");
                        value = value.trim();
                        if (this.data.combo) {
                            const option = this.data.options.find(({ exportValue: exportValue })=>value === exportValue);
                            value = option?.displayValue || value;
                        }
                        if (value === "") return `/Tx BMC q ${colors}Q EMC`;
                        if (rotation === undefined) rotation = this.rotation;
                        let lineCount = -1;
                        let lines;
                        if (this.data.multiLine) {
                            lines = value.split(/\r\n?|\n/).map((line)=>line.normalize("NFC"));
                            lineCount = lines.length;
                        } else lines = [
                            value.replace(/\r\n?|\n/, "").normalize("NFC")
                        ];
                        const defaultPadding = 1;
                        const defaultHPadding = 2;
                        let totalHeight = this.data.rect[3] - this.data.rect[1];
                        let totalWidth = this.data.rect[2] - this.data.rect[0];
                        if (rotation === 90 || rotation === 270) [totalWidth, totalHeight] = [
                            totalHeight,
                            totalWidth
                        ];
                        if (!this._defaultAppearance) this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                        let font1 = await WidgetAnnotation._getFontData(evaluator, task, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                        let defaultAppearance, fontSize, lineHeight;
                        const encodedLines = [];
                        let encodingError = false;
                        for (const line of lines){
                            const encodedString = font1.encodeString(line);
                            if (encodedString.length > 1) encodingError = true;
                            encodedLines.push(encodedString.join(""));
                        }
                        if (encodingError && intent & _util.RenderingIntentFlag.SAVE) return {
                            needAppearances: true
                        };
                        if (encodingError && this._isOffscreenCanvasSupported) {
                            const fontFamily = this.data.comb ? "monospace" : "sans-serif";
                            const fakeUnicodeFont = new _default_appearance.FakeUnicodeFont(evaluator.xref, fontFamily);
                            const resources = fakeUnicodeFont.createFontResources(lines.join(""));
                            const newFont = resources.getRaw("Font");
                            if (this._fieldResources.mergedResources.has("Font")) {
                                const oldFont = this._fieldResources.mergedResources.get("Font");
                                for (const key of newFont.getKeys())oldFont.set(key, newFont.getRaw(key));
                            } else this._fieldResources.mergedResources.set("Font", newFont);
                            const fontName = fakeUnicodeFont.fontName.name;
                            font1 = await WidgetAnnotation._getFontData(evaluator, task, {
                                fontName: fontName,
                                fontSize: 0
                            }, resources);
                            for(let i = 0, ii = encodedLines.length; i < ii; i++)encodedLines[i] = (0, _core_utils.stringToUTF16String)(lines[i]);
                            const savedDefaultAppearance = Object.assign(Object.create(null), this.data.defaultAppearanceData);
                            this.data.defaultAppearanceData.fontSize = 0;
                            this.data.defaultAppearanceData.fontName = fontName;
                            [defaultAppearance, fontSize, lineHeight] = this._computeFontSize(totalHeight - 2 * defaultPadding, totalWidth - 2 * defaultHPadding, value, font1, lineCount);
                            this.data.defaultAppearanceData = savedDefaultAppearance;
                        } else {
                            if (!this._isOffscreenCanvasSupported) (0, _util.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly.");
                            [defaultAppearance, fontSize, lineHeight] = this._computeFontSize(totalHeight - 2 * defaultPadding, totalWidth - 2 * defaultHPadding, value, font1, lineCount);
                        }
                        let descent = font1.descent;
                        if (isNaN(descent)) descent = _util.BASELINE_FACTOR * lineHeight;
                        else descent = Math.max(_util.BASELINE_FACTOR * lineHeight, Math.abs(descent) * fontSize);
                        const defaultVPadding = Math.min(Math.floor((totalHeight - fontSize) / 2), defaultPadding);
                        const alignment = this.data.textAlignment;
                        if (this.data.multiLine) return this._getMultilineAppearance(defaultAppearance, encodedLines, font1, fontSize, totalWidth, totalHeight, alignment, defaultHPadding, defaultVPadding, descent, lineHeight, annotationStorage);
                        if (this.data.comb) return this._getCombAppearance(defaultAppearance, font1, encodedLines[0], fontSize, totalWidth, totalHeight, defaultHPadding, defaultVPadding, descent, lineHeight, annotationStorage);
                        const bottomPadding = defaultVPadding + descent;
                        if (alignment === 0 || alignment > 2) return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 ${(0, _core_utils.numberToString)(defaultHPadding)} ${(0, _core_utils.numberToString)(bottomPadding)} Tm (${(0, _core_utils.escapeString)(encodedLines[0])}) Tj` + " ET Q EMC";
                        const prevInfo = {
                            shift: 0
                        };
                        const renderedText = this._renderText(encodedLines[0], font1, fontSize, totalWidth, alignment, prevInfo, defaultHPadding, bottomPadding);
                        return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 0 0 Tm ${renderedText}` + " ET Q EMC";
                    }
                    static async _getFontData(evaluator, task, appearanceData, resources) {
                        const operatorList = new _operator_list.OperatorList();
                        const initialState = {
                            font: null,
                            clone () {
                                return this;
                            }
                        };
                        const { fontName: fontName, fontSize: fontSize } = appearanceData;
                        await evaluator.handleSetFont(resources, [
                            fontName && _primitives.Name.get(fontName),
                            fontSize
                        ], null, operatorList, task, initialState, null);
                        return initialState.font;
                    }
                    _getTextWidth(text, font1) {
                        return font1.charsToGlyphs(text).reduce((width, glyph)=>width + glyph.width, 0) / 1000;
                    }
                    _computeFontSize(height, width, text, font1, lineCount) {
                        let { fontSize: fontSize } = this.data.defaultAppearanceData;
                        let lineHeight = (fontSize || 12) * _util.LINE_FACTOR, numberOfLines = Math.round(height / lineHeight);
                        if (!fontSize) {
                            const roundWithTwoDigits = (x)=>Math.floor(x * 100) / 100;
                            if (lineCount === -1) {
                                const textWidth = this._getTextWidth(text, font1);
                                fontSize = roundWithTwoDigits(Math.min(height / _util.LINE_FACTOR, textWidth > width ? width / textWidth : Infinity));
                                numberOfLines = 1;
                            } else {
                                const lines = text.split(/\r\n?|\n/);
                                const cachedLines = [];
                                for (const line of lines){
                                    const encoded = font1.encodeString(line).join("");
                                    const glyphs = font1.charsToGlyphs(encoded);
                                    const positions = font1.getCharPositions(encoded);
                                    cachedLines.push({
                                        line: encoded,
                                        glyphs: glyphs,
                                        positions: positions
                                    });
                                }
                                const isTooBig = (fsize)=>{
                                    let totalHeight = 0;
                                    for (const cache of cachedLines){
                                        const chunks = this._splitLine(null, font1, fsize, width, cache);
                                        totalHeight += chunks.length * fsize;
                                        if (totalHeight > height) return true;
                                    }
                                    return false;
                                };
                                numberOfLines = Math.max(numberOfLines, lineCount);
                                while(true){
                                    lineHeight = height / numberOfLines;
                                    fontSize = roundWithTwoDigits(lineHeight / _util.LINE_FACTOR);
                                    if (isTooBig(fontSize)) {
                                        numberOfLines++;
                                        continue;
                                    }
                                    break;
                                }
                            }
                            const { fontName: fontName, fontColor: fontColor } = this.data.defaultAppearanceData;
                            this._defaultAppearance = (0, _default_appearance.createDefaultAppearance)({
                                fontSize: fontSize,
                                fontName: fontName,
                                fontColor: fontColor
                            });
                        }
                        return [
                            this._defaultAppearance,
                            fontSize,
                            height / numberOfLines
                        ];
                    }
                    _renderText(text, font1, fontSize, totalWidth, alignment, prevInfo, hPadding, vPadding) {
                        let shift;
                        if (alignment === 1) {
                            const width = this._getTextWidth(text, font1) * fontSize;
                            shift = (totalWidth - width) / 2;
                        } else if (alignment === 2) {
                            const width = this._getTextWidth(text, font1) * fontSize;
                            shift = totalWidth - width - hPadding;
                        } else shift = hPadding;
                        const shiftStr = (0, _core_utils.numberToString)(shift - prevInfo.shift);
                        prevInfo.shift = shift;
                        vPadding = (0, _core_utils.numberToString)(vPadding);
                        return `${shiftStr} ${vPadding} Td (${(0, _core_utils.escapeString)(text)}) Tj`;
                    }
                    _getSaveFieldResources(xref) {
                        const { localResources: localResources, appearanceResources: appearanceResources, acroFormResources: acroFormResources } = this._fieldResources;
                        const fontName = this.data.defaultAppearanceData?.fontName;
                        if (!fontName) return localResources || _primitives.Dict.empty;
                        for (const resources of [
                            localResources,
                            appearanceResources
                        ])if (resources instanceof _primitives.Dict) {
                            const localFont = resources.get("Font");
                            if (localFont instanceof _primitives.Dict && localFont.has(fontName)) return resources;
                        }
                        if (acroFormResources instanceof _primitives.Dict) {
                            const acroFormFont = acroFormResources.get("Font");
                            if (acroFormFont instanceof _primitives.Dict && acroFormFont.has(fontName)) {
                                const subFontDict = new _primitives.Dict(xref);
                                subFontDict.set(fontName, acroFormFont.getRaw(fontName));
                                const subResourcesDict = new _primitives.Dict(xref);
                                subResourcesDict.set("Font", subFontDict);
                                return _primitives.Dict.merge({
                                    xref: xref,
                                    dictArray: [
                                        subResourcesDict,
                                        localResources
                                    ],
                                    mergeSubDicts: true
                                });
                            }
                        }
                        return localResources || _primitives.Dict.empty;
                    }
                    getFieldObject() {
                        return null;
                    }
                }
                class TextWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML;
                        this._hasText = true;
                        const dict = params.dict;
                        if (typeof this.data.fieldValue !== "string") this.data.fieldValue = "";
                        let alignment = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Q"
                        });
                        if (!Number.isInteger(alignment) || alignment < 0 || alignment > 2) alignment = null;
                        this.data.textAlignment = alignment;
                        let maximumLength = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "MaxLen"
                        });
                        if (!Number.isInteger(maximumLength) || maximumLength < 0) maximumLength = 0;
                        this.data.maxLen = maximumLength;
                        this.data.multiLine = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE);
                        this.data.comb = this.hasFieldFlag(_util.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(_util.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0;
                        this.data.doNotScroll = this.hasFieldFlag(_util.AnnotationFieldFlag.DONOTSCROLL);
                    }
                    get hasTextContent() {
                        return !!this.appearance && !this._needAppearances;
                    }
                    _getCombAppearance(defaultAppearance, font1, text, fontSize, width, height, hPadding, vPadding, descent, lineHeight, annotationStorage) {
                        const combWidth = width / this.data.maxLen;
                        const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                        const buf = [];
                        const positions = font1.getCharPositions(text);
                        for (const [start, end] of positions)buf.push(`(${(0, _core_utils.escapeString)(text.substring(start, end))}) Tj`);
                        const renderedComb = buf.join(` ${(0, _core_utils.numberToString)(combWidth)} 0 Td `);
                        return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 ${(0, _core_utils.numberToString)(hPadding)} ${(0, _core_utils.numberToString)(vPadding + descent)} Tm ${renderedComb}` + " ET Q EMC";
                    }
                    _getMultilineAppearance(defaultAppearance, lines, font1, fontSize, width, height, alignment, hPadding, vPadding, descent, lineHeight, annotationStorage) {
                        const buf = [];
                        const totalWidth = width - 2 * hPadding;
                        const prevInfo = {
                            shift: 0
                        };
                        for(let i = 0, ii = lines.length; i < ii; i++){
                            const line = lines[i];
                            const chunks = this._splitLine(line, font1, fontSize, totalWidth);
                            for(let j = 0, jj = chunks.length; j < jj; j++){
                                const chunk = chunks[j];
                                const vShift = i === 0 && j === 0 ? -vPadding - (lineHeight - descent) : -lineHeight;
                                buf.push(this._renderText(chunk, font1, fontSize, width, alignment, prevInfo, hPadding, vShift));
                            }
                        }
                        const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                        const renderedText = buf.join("\n");
                        return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 0 ${(0, _core_utils.numberToString)(height)} Tm ${renderedText}` + " ET Q EMC";
                    }
                    _splitLine(line, font1, fontSize, width, cache = {}) {
                        line = cache.line || line;
                        const glyphs = cache.glyphs || font1.charsToGlyphs(line);
                        if (glyphs.length <= 1) return [
                            line
                        ];
                        const positions = cache.positions || font1.getCharPositions(line);
                        const scale = fontSize / 1000;
                        const chunks = [];
                        let lastSpacePosInStringStart = -1, lastSpacePosInStringEnd = -1, lastSpacePos = -1, startChunk = 0, currentWidth = 0;
                        for(let i = 0, ii = glyphs.length; i < ii; i++){
                            const [start, end] = positions[i];
                            const glyph = glyphs[i];
                            const glyphWidth = glyph.width * scale;
                            if (glyph.unicode === " ") {
                                if (currentWidth + glyphWidth > width) {
                                    chunks.push(line.substring(startChunk, start));
                                    startChunk = start;
                                    currentWidth = glyphWidth;
                                    lastSpacePosInStringStart = -1;
                                    lastSpacePos = -1;
                                } else {
                                    currentWidth += glyphWidth;
                                    lastSpacePosInStringStart = start;
                                    lastSpacePosInStringEnd = end;
                                    lastSpacePos = i;
                                }
                            } else if (currentWidth + glyphWidth > width) {
                                if (lastSpacePosInStringStart !== -1) {
                                    chunks.push(line.substring(startChunk, lastSpacePosInStringEnd));
                                    startChunk = lastSpacePosInStringEnd;
                                    i = lastSpacePos + 1;
                                    lastSpacePosInStringStart = -1;
                                    currentWidth = 0;
                                } else {
                                    chunks.push(line.substring(startChunk, start));
                                    startChunk = start;
                                    currentWidth = glyphWidth;
                                }
                            } else currentWidth += glyphWidth;
                        }
                        if (startChunk < line.length) chunks.push(line.substring(startChunk, line.length));
                        return chunks;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue,
                            defaultValue: this.data.defaultFieldValue || "",
                            multiline: this.data.multiLine,
                            password: this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD),
                            charLimit: this.data.maxLen,
                            comb: this.data.comb,
                            editable: !this.data.readOnly,
                            hidden: this.data.hidden,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: "text"
                        };
                    }
                }
                class ButtonWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.checkedAppearance = null;
                        this.uncheckedAppearance = null;
                        this.data.checkBox = !this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.radioButton = this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.pushButton = this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.isTooltipOnly = false;
                        if (this.data.checkBox) this._processCheckBox(params);
                        else if (this.data.radioButton) this._processRadioButton(params);
                        else if (this.data.pushButton) {
                            this.data.hasOwnCanvas = true;
                            this._processPushButton(params);
                        } else (0, _util.warn)("Invalid field flags for button widget annotation");
                    }
                    async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                        if (this.data.pushButton) return super.getOperatorList(evaluator, task, intent, false, annotationStorage);
                        let value = null;
                        let rotation = null;
                        if (annotationStorage) {
                            const storageEntry = annotationStorage.get(this.data.id);
                            value = storageEntry ? storageEntry.value : null;
                            rotation = storageEntry ? storageEntry.rotation : null;
                        }
                        if (value === null && this.appearance) return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                        if (value === null || value === undefined) value = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue;
                        const appearance = value ? this.checkedAppearance : this.uncheckedAppearance;
                        if (appearance) {
                            const savedAppearance = this.appearance;
                            const savedMatrix = appearance.dict.getArray("Matrix") || _util.IDENTITY_MATRIX;
                            if (rotation) appearance.dict.set("Matrix", this.getRotationMatrix(annotationStorage));
                            this.appearance = appearance;
                            const operatorList = super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                            this.appearance = savedAppearance;
                            appearance.dict.set("Matrix", savedMatrix);
                            return operatorList;
                        }
                        return {
                            opList: new _operator_list.OperatorList(),
                            separateForm: false,
                            separateCanvas: false
                        };
                    }
                    async save(evaluator, task, annotationStorage) {
                        if (this.data.checkBox) return this._saveCheckbox(evaluator, task, annotationStorage);
                        if (this.data.radioButton) return this._saveRadioButton(evaluator, task, annotationStorage);
                        return null;
                    }
                    async _saveCheckbox(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        let rotation = storageEntry?.rotation, value = storageEntry?.value;
                        if (rotation === undefined) {
                            if (value === undefined) return null;
                            const defaultValue = this.data.fieldValue === this.data.exportValue;
                            if (defaultValue === value) return null;
                        }
                        const dict = evaluator.xref.fetchIfRef(this.ref);
                        if (!(dict instanceof _primitives.Dict)) return null;
                        if (rotation === undefined) rotation = this.rotation;
                        if (value === undefined) value = this.data.fieldValue === this.data.exportValue;
                        const xfa = {
                            path: this.data.fieldName,
                            value: value ? this.data.exportValue : ""
                        };
                        const name = _primitives.Name.get(value ? this.data.exportValue : "Off");
                        dict.set("V", name);
                        dict.set("AS", name);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        const maybeMK = this._getMKDict(rotation);
                        if (maybeMK) dict.set("MK", maybeMK);
                        const buffer = [];
                        await (0, _writer.writeObject)(this.ref, dict, buffer, evaluator.xref);
                        return [
                            {
                                ref: this.ref,
                                data: buffer.join(""),
                                xfa: xfa
                            }
                        ];
                    }
                    async _saveRadioButton(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        let rotation = storageEntry?.rotation, value = storageEntry?.value;
                        if (rotation === undefined) {
                            if (value === undefined) return null;
                            const defaultValue = this.data.fieldValue === this.data.buttonValue;
                            if (defaultValue === value) return null;
                        }
                        const dict = evaluator.xref.fetchIfRef(this.ref);
                        if (!(dict instanceof _primitives.Dict)) return null;
                        if (value === undefined) value = this.data.fieldValue === this.data.buttonValue;
                        if (rotation === undefined) rotation = this.rotation;
                        const xfa = {
                            path: this.data.fieldName,
                            value: value ? this.data.buttonValue : ""
                        };
                        const name = _primitives.Name.get(value ? this.data.buttonValue : "Off");
                        const buffer = [];
                        let parentData = null;
                        if (value) {
                            if (this.parent instanceof _primitives.Ref) {
                                const parent = evaluator.xref.fetch(this.parent);
                                parent.set("V", name);
                                await (0, _writer.writeObject)(this.parent, parent, buffer, evaluator.xref);
                                parentData = buffer.join("");
                                buffer.length = 0;
                            } else if (this.parent instanceof _primitives.Dict) this.parent.set("V", name);
                        }
                        dict.set("AS", name);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        const maybeMK = this._getMKDict(rotation);
                        if (maybeMK) dict.set("MK", maybeMK);
                        await (0, _writer.writeObject)(this.ref, dict, buffer, evaluator.xref);
                        const newRefs = [
                            {
                                ref: this.ref,
                                data: buffer.join(""),
                                xfa: xfa
                            }
                        ];
                        if (parentData) newRefs.push({
                            ref: this.parent,
                            data: parentData,
                            xfa: null
                        });
                        return newRefs;
                    }
                    _getDefaultCheckedAppearance(params, type) {
                        const width = this.data.rect[2] - this.data.rect[0];
                        const height = this.data.rect[3] - this.data.rect[1];
                        const bbox = [
                            0,
                            0,
                            width,
                            height
                        ];
                        const FONT_RATIO = 0.8;
                        const fontSize = Math.min(width, height) * FONT_RATIO;
                        let metrics, char;
                        if (type === "check") {
                            metrics = {
                                width: 0.755 * fontSize,
                                height: 0.705 * fontSize
                            };
                            char = "\x33";
                        } else if (type === "disc") {
                            metrics = {
                                width: 0.791 * fontSize,
                                height: 0.705 * fontSize
                            };
                            char = "\x6C";
                        } else (0, _util.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${type}`);
                        const xShift = (0, _core_utils.numberToString)((width - metrics.width) / 2);
                        const yShift = (0, _core_utils.numberToString)((height - metrics.height) / 2);
                        const appearance = `q BT /PdfJsZaDb ${fontSize} Tf 0 g ${xShift} ${yShift} Td (${char}) Tj ET Q`;
                        const appearanceStreamDict = new _primitives.Dict(params.xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", bbox);
                        appearanceStreamDict.set("Matrix", [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]);
                        appearanceStreamDict.set("Length", appearance.length);
                        const resources = new _primitives.Dict(params.xref);
                        const font1 = new _primitives.Dict(params.xref);
                        font1.set("PdfJsZaDb", this.fallbackFontDict);
                        resources.set("Font", font1);
                        appearanceStreamDict.set("Resources", resources);
                        this.checkedAppearance = new _stream.StringStream(appearance);
                        this.checkedAppearance.dict = appearanceStreamDict;
                        this._streams.push(this.checkedAppearance);
                    }
                    _processCheckBox(params) {
                        const customAppearance = params.dict.get("AP");
                        if (!(customAppearance instanceof _primitives.Dict)) return;
                        const normalAppearance = customAppearance.get("N");
                        if (!(normalAppearance instanceof _primitives.Dict)) return;
                        const asValue = this._decodeFormValue(params.dict.get("AS"));
                        if (typeof asValue === "string") this.data.fieldValue = asValue;
                        const yes = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes";
                        const exportValues = normalAppearance.getKeys();
                        if (exportValues.length === 0) exportValues.push("Off", yes);
                        else if (exportValues.length === 1) {
                            if (exportValues[0] === "Off") exportValues.push(yes);
                            else exportValues.unshift("Off");
                        } else if (exportValues.includes(yes)) {
                            exportValues.length = 0;
                            exportValues.push("Off", yes);
                        } else {
                            const otherYes = exportValues.find((v)=>v !== "Off");
                            exportValues.length = 0;
                            exportValues.push("Off", otherYes);
                        }
                        if (!exportValues.includes(this.data.fieldValue)) this.data.fieldValue = "Off";
                        this.data.exportValue = exportValues[1];
                        const checkedAppearance = normalAppearance.get(this.data.exportValue);
                        this.checkedAppearance = checkedAppearance instanceof _base_stream.BaseStream ? checkedAppearance : null;
                        const uncheckedAppearance = normalAppearance.get("Off");
                        this.uncheckedAppearance = uncheckedAppearance instanceof _base_stream.BaseStream ? uncheckedAppearance : null;
                        if (this.checkedAppearance) this._streams.push(this.checkedAppearance);
                        else this._getDefaultCheckedAppearance(params, "check");
                        if (this.uncheckedAppearance) this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                        if (this.data.defaultFieldValue === null) this.data.defaultFieldValue = "Off";
                    }
                    _processRadioButton(params) {
                        this.data.fieldValue = this.data.buttonValue = null;
                        const fieldParent = params.dict.get("Parent");
                        if (fieldParent instanceof _primitives.Dict) {
                            this.parent = params.dict.getRaw("Parent");
                            const fieldParentValue = fieldParent.get("V");
                            if (fieldParentValue instanceof _primitives.Name) this.data.fieldValue = this._decodeFormValue(fieldParentValue);
                        }
                        const appearanceStates = params.dict.get("AP");
                        if (!(appearanceStates instanceof _primitives.Dict)) return;
                        const normalAppearance = appearanceStates.get("N");
                        if (!(normalAppearance instanceof _primitives.Dict)) return;
                        for (const key of normalAppearance.getKeys())if (key !== "Off") {
                            this.data.buttonValue = this._decodeFormValue(key);
                            break;
                        }
                        const checkedAppearance = normalAppearance.get(this.data.buttonValue);
                        this.checkedAppearance = checkedAppearance instanceof _base_stream.BaseStream ? checkedAppearance : null;
                        const uncheckedAppearance = normalAppearance.get("Off");
                        this.uncheckedAppearance = uncheckedAppearance instanceof _base_stream.BaseStream ? uncheckedAppearance : null;
                        if (this.checkedAppearance) this._streams.push(this.checkedAppearance);
                        else this._getDefaultCheckedAppearance(params, "disc");
                        if (this.uncheckedAppearance) this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                        if (this.data.defaultFieldValue === null) this.data.defaultFieldValue = "Off";
                    }
                    _processPushButton(params) {
                        const { dict: dict, annotationGlobals: annotationGlobals } = params;
                        if (!dict.has("A") && !dict.has("AA") && !this.data.alternativeText) {
                            (0, _util.warn)("Push buttons without action dictionaries are not supported");
                            return;
                        }
                        this.data.isTooltipOnly = !dict.has("A") && !dict.has("AA");
                        _catalog.Catalog.parseDestDictionary({
                            destDict: dict,
                            resultObj: this.data,
                            docBaseUrl: annotationGlobals.baseUrl,
                            docAttachments: annotationGlobals.attachments
                        });
                    }
                    getFieldObject() {
                        let type = "button";
                        let exportValues;
                        if (this.data.checkBox) {
                            type = "checkbox";
                            exportValues = this.data.exportValue;
                        } else if (this.data.radioButton) {
                            type = "radiobutton";
                            exportValues = this.data.buttonValue;
                        }
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue || "Off",
                            defaultValue: this.data.defaultFieldValue,
                            exportValues: exportValues,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: type
                        };
                    }
                    get fallbackFontDict() {
                        const dict = new _primitives.Dict();
                        dict.set("BaseFont", _primitives.Name.get("ZapfDingbats"));
                        dict.set("Type", _primitives.Name.get("FallbackType"));
                        dict.set("Subtype", _primitives.Name.get("FallbackType"));
                        dict.set("Encoding", _primitives.Name.get("ZapfDingbatsEncoding"));
                        return (0, _util.shadow)(this, "fallbackFontDict", dict);
                    }
                }
                class ChoiceWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.indices = dict.getArray("I");
                        this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0;
                        this.data.options = [];
                        const options = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Opt"
                        });
                        if (Array.isArray(options)) for(let i = 0, ii = options.length; i < ii; i++){
                            const option = xref.fetchIfRef(options[i]);
                            const isOptionArray = Array.isArray(option);
                            this.data.options[i] = {
                                exportValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[0]) : option),
                                displayValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[1]) : option)
                            };
                        }
                        if (!this.hasIndices) {
                            if (typeof this.data.fieldValue === "string") this.data.fieldValue = [
                                this.data.fieldValue
                            ];
                            else if (!this.data.fieldValue) this.data.fieldValue = [];
                        } else {
                            this.data.fieldValue = [];
                            const ii = this.data.options.length;
                            for (const i of this.indices)if (Number.isInteger(i) && i >= 0 && i < ii) this.data.fieldValue.push(this.data.options[i].exportValue);
                        }
                        this.data.combo = this.hasFieldFlag(_util.AnnotationFieldFlag.COMBO);
                        this.data.multiSelect = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTISELECT);
                        this._hasText = true;
                    }
                    getFieldObject() {
                        const type = this.data.combo ? "combobox" : "listbox";
                        const value = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
                        return {
                            id: this.data.id,
                            value: value,
                            defaultValue: this.data.defaultFieldValue,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            numItems: this.data.fieldValue.length,
                            multipleSelection: this.data.multiSelect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            items: this.data.options,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: type
                        };
                    }
                    amendSavedDict(annotationStorage, dict) {
                        if (!this.hasIndices) return;
                        let values = annotationStorage?.get(this.data.id)?.value;
                        if (!Array.isArray(values)) values = [
                            values
                        ];
                        const indices = [];
                        const { options: options } = this.data;
                        for(let i = 0, j = 0, ii = options.length; i < ii; i++)if (options[i].exportValue === values[j]) {
                            indices.push(i);
                            j += 1;
                        }
                        dict.set("I", indices);
                    }
                    async _getAppearance(evaluator, task, intent, annotationStorage) {
                        if (this.data.combo) return super._getAppearance(evaluator, task, intent, annotationStorage);
                        let exportedValue, rotation;
                        const storageEntry = annotationStorage?.get(this.data.id);
                        if (storageEntry) {
                            rotation = storageEntry.rotation;
                            exportedValue = storageEntry.value;
                        }
                        if (rotation === undefined && exportedValue === undefined && !this._needAppearances) return null;
                        if (exportedValue === undefined) exportedValue = this.data.fieldValue;
                        else if (!Array.isArray(exportedValue)) exportedValue = [
                            exportedValue
                        ];
                        const defaultPadding = 1;
                        const defaultHPadding = 2;
                        let totalHeight = this.data.rect[3] - this.data.rect[1];
                        let totalWidth = this.data.rect[2] - this.data.rect[0];
                        if (rotation === 90 || rotation === 270) [totalWidth, totalHeight] = [
                            totalHeight,
                            totalWidth
                        ];
                        const lineCount = this.data.options.length;
                        const valueIndices = [];
                        for(let i = 0; i < lineCount; i++){
                            const { exportValue: exportValue } = this.data.options[i];
                            if (exportedValue.includes(exportValue)) valueIndices.push(i);
                        }
                        if (!this._defaultAppearance) this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                        const font1 = await WidgetAnnotation._getFontData(evaluator, task, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                        let defaultAppearance;
                        let { fontSize: fontSize } = this.data.defaultAppearanceData;
                        if (!fontSize) {
                            const lineHeight = (totalHeight - defaultPadding) / lineCount;
                            let lineWidth = -1;
                            let value;
                            for (const { displayValue: displayValue } of this.data.options){
                                const width = this._getTextWidth(displayValue, font1);
                                if (width > lineWidth) {
                                    lineWidth = width;
                                    value = displayValue;
                                }
                            }
                            [defaultAppearance, fontSize] = this._computeFontSize(lineHeight, totalWidth - 2 * defaultHPadding, value, font1, -1);
                        } else defaultAppearance = this._defaultAppearance;
                        const lineHeight = fontSize * _util.LINE_FACTOR;
                        const vPadding = (lineHeight - fontSize) / 2;
                        const numberOfVisibleLines = Math.floor(totalHeight / lineHeight);
                        let firstIndex = 0;
                        if (valueIndices.length > 0) {
                            const minIndex = Math.min(...valueIndices);
                            const maxIndex = Math.max(...valueIndices);
                            firstIndex = Math.max(0, maxIndex - numberOfVisibleLines + 1);
                            if (firstIndex > minIndex) firstIndex = minIndex;
                        }
                        const end = Math.min(firstIndex + numberOfVisibleLines + 1, lineCount);
                        const buf = [
                            "/Tx BMC q",
                            `1 1 ${totalWidth} ${totalHeight} re W n`
                        ];
                        if (valueIndices.length) {
                            buf.push("0.600006 0.756866 0.854904 rg");
                            for (const index of valueIndices)if (firstIndex <= index && index < end) buf.push(`1 ${totalHeight - (index - firstIndex + 1) * lineHeight} ${totalWidth} ${lineHeight} re f`);
                        }
                        buf.push("BT", defaultAppearance, `1 0 0 1 0 ${totalHeight} Tm`);
                        const prevInfo = {
                            shift: 0
                        };
                        for(let i = firstIndex; i < end; i++){
                            const { displayValue: displayValue } = this.data.options[i];
                            const vpadding = i === firstIndex ? vPadding : 0;
                            buf.push(this._renderText(displayValue, font1, fontSize, totalWidth, 0, prevInfo, defaultHPadding, -lineHeight + vpadding));
                        }
                        buf.push("ET Q EMC");
                        return buf.join("\n");
                    }
                }
                class SignatureWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.data.fieldValue = null;
                        this.data.hasOwnCanvas = this.data.noRotate;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: null,
                            page: this.data.pageIndex,
                            type: "signature"
                        };
                    }
                }
                class TextAnnotation extends MarkupAnnotation {
                    constructor(params){
                        const DEFAULT_ICON_SIZE = 22;
                        super(params);
                        this.data.noRotate = true;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const { dict: dict } = params;
                        this.data.annotationType = _util.AnnotationType.TEXT;
                        if (this.data.hasAppearance) this.data.name = "NoIcon";
                        else {
                            this.data.rect[1] = this.data.rect[3] - DEFAULT_ICON_SIZE;
                            this.data.rect[2] = this.data.rect[0] + DEFAULT_ICON_SIZE;
                            this.data.name = dict.has("Name") ? dict.get("Name").name : "Note";
                        }
                        if (dict.has("State")) {
                            this.data.state = dict.get("State") || null;
                            this.data.stateModel = dict.get("StateModel") || null;
                        } else {
                            this.data.state = null;
                            this.data.stateModel = null;
                        }
                    }
                }
                class LinkAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, annotationGlobals: annotationGlobals } = params;
                        this.data.annotationType = _util.AnnotationType.LINK;
                        const quadPoints = getQuadPoints(dict, this.rectangle);
                        if (quadPoints) this.data.quadPoints = quadPoints;
                        this.data.borderColor ||= this.data.color;
                        _catalog.Catalog.parseDestDictionary({
                            destDict: dict,
                            resultObj: this.data,
                            docBaseUrl: annotationGlobals.baseUrl,
                            docAttachments: annotationGlobals.attachments
                        });
                    }
                }
                class PopupAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict } = params;
                        this.data.annotationType = _util.AnnotationType.POPUP;
                        if (this.data.rect[0] === this.data.rect[2] || this.data.rect[1] === this.data.rect[3]) this.data.rect = null;
                        let parentItem = dict.get("Parent");
                        if (!parentItem) {
                            (0, _util.warn)("Popup annotation has a missing or invalid parent annotation.");
                            return;
                        }
                        const parentRect = parentItem.getArray("Rect");
                        this.data.parentRect = Array.isArray(parentRect) && parentRect.length === 4 ? _util.Util.normalizeRect(parentRect) : null;
                        const rt = parentItem.get("RT");
                        if ((0, _primitives.isName)(rt, _util.AnnotationReplyType.GROUP)) parentItem = parentItem.get("IRT");
                        if (!parentItem.has("M")) this.data.modificationDate = null;
                        else {
                            this.setModificationDate(parentItem.get("M"));
                            this.data.modificationDate = this.modificationDate;
                        }
                        if (!parentItem.has("C")) this.data.color = null;
                        else {
                            this.setColor(parentItem.getArray("C"));
                            this.data.color = this.color;
                        }
                        if (!this.viewable) {
                            const parentFlags = parentItem.get("F");
                            if (this._isViewable(parentFlags)) this.setFlags(parentFlags);
                        }
                        this.setTitle(parentItem.get("T"));
                        this.data.titleObj = this._title;
                        this.setContents(parentItem.get("Contents"));
                        this.data.contentsObj = this._contents;
                        if (parentItem.has("RC")) this.data.richText = _factory.XFAFactory.getRichTextAsHtml(parentItem.get("RC"));
                        this.data.open = !!dict.get("Open");
                    }
                }
                exports.PopupAnnotation = PopupAnnotation;
                class FreeTextAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.hasOwnCanvas = true;
                        const { evaluatorOptions: evaluatorOptions, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.FREETEXT;
                        this.setDefaultAppearance(params);
                        if (this.appearance) {
                            const { fontColor: fontColor, fontSize: fontSize } = (0, _default_appearance.parseAppearanceStream)(this.appearance, evaluatorOptions, xref);
                            this.data.defaultAppearanceData.fontColor = fontColor;
                            this.data.defaultAppearanceData.fontSize = fontSize || 10;
                        } else if (this._isOffscreenCanvasSupported) {
                            const strokeAlpha = params.dict.get("CA");
                            const fakeUnicodeFont = new _default_appearance.FakeUnicodeFont(xref, "sans-serif");
                            this.data.defaultAppearanceData.fontSize ||= 10;
                            const { fontColor: fontColor, fontSize: fontSize } = this.data.defaultAppearanceData;
                            this.appearance = fakeUnicodeFont.createAppearance(this._contents.str, this.rectangle, this.rotation, fontSize, fontColor, strokeAlpha);
                            this._streams.push(this.appearance, _default_appearance.FakeUnicodeFont.toUnicodeStream);
                        } else (0, _util.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
                    }
                    get hasTextContent() {
                        return !!this.appearance;
                    }
                    static createNewDict(annotation, xref, { apRef: apRef, ap: ap }) {
                        const { color: color, fontSize: fontSize, rect: rect, rotation: rotation, user: user, value: value } = annotation;
                        const freetext = new _primitives.Dict(xref);
                        freetext.set("Type", _primitives.Name.get("Annot"));
                        freetext.set("Subtype", _primitives.Name.get("FreeText"));
                        freetext.set("CreationDate", `D:${(0, _util.getModificationDate)()}`);
                        freetext.set("Rect", rect);
                        const da = `/Helv ${fontSize} Tf ${(0, _default_appearance.getPdfColor)(color, true)}`;
                        freetext.set("DA", da);
                        freetext.set("Contents", (0, _core_utils.isAscii)(value) ? value : (0, _core_utils.stringToUTF16String)(value, true));
                        freetext.set("F", 4);
                        freetext.set("Border", [
                            0,
                            0,
                            0
                        ]);
                        freetext.set("Rotate", rotation);
                        if (user) freetext.set("T", (0, _core_utils.isAscii)(user) ? user : (0, _core_utils.stringToUTF16String)(user, true));
                        if (apRef || ap) {
                            const n = new _primitives.Dict(xref);
                            freetext.set("AP", n);
                            if (apRef) n.set("N", apRef);
                            else n.set("N", ap);
                        }
                        return freetext;
                    }
                    static async createNewAppearanceStream(annotation, xref, params) {
                        const { baseFontRef: baseFontRef, evaluator: evaluator, task: task } = params;
                        const { color: color, fontSize: fontSize, rect: rect, rotation: rotation, value: value } = annotation;
                        const resources = new _primitives.Dict(xref);
                        const font1 = new _primitives.Dict(xref);
                        if (baseFontRef) font1.set("Helv", baseFontRef);
                        else {
                            const baseFont = new _primitives.Dict(xref);
                            baseFont.set("BaseFont", _primitives.Name.get("Helvetica"));
                            baseFont.set("Type", _primitives.Name.get("Font"));
                            baseFont.set("Subtype", _primitives.Name.get("Type1"));
                            baseFont.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                            font1.set("Helv", baseFont);
                        }
                        resources.set("Font", font1);
                        const helv = await WidgetAnnotation._getFontData(evaluator, task, {
                            fontName: "Helv",
                            fontSize: fontSize
                        }, resources);
                        const [x1, y1, x2, y2] = rect;
                        let w = x2 - x1;
                        let h = y2 - y1;
                        if (rotation % 180 !== 0) [w, h] = [
                            h,
                            w
                        ];
                        const lines = value.split("\n");
                        const scale = fontSize / 1000;
                        let totalWidth = -Infinity;
                        const encodedLines = [];
                        for (let line of lines){
                            const encoded = helv.encodeString(line);
                            if (encoded.length > 1) return null;
                            line = encoded.join("");
                            encodedLines.push(line);
                            let lineWidth = 0;
                            const glyphs = helv.charsToGlyphs(line);
                            for (const glyph of glyphs)lineWidth += glyph.width * scale;
                            totalWidth = Math.max(totalWidth, lineWidth);
                        }
                        let hscale = 1;
                        if (totalWidth > w) hscale = w / totalWidth;
                        let vscale = 1;
                        const lineHeight = _util.LINE_FACTOR * fontSize;
                        const lineAscent = (_util.LINE_FACTOR - _util.LINE_DESCENT_FACTOR) * fontSize;
                        const totalHeight = lineHeight * lines.length;
                        if (totalHeight > h) vscale = h / totalHeight;
                        const fscale = Math.min(hscale, vscale);
                        const newFontSize = fontSize * fscale;
                        let firstPoint, clipBox, matrix;
                        switch(rotation){
                            case 0:
                                matrix = [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                                clipBox = [
                                    rect[0],
                                    rect[1],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    rect[0],
                                    rect[3] - lineAscent
                                ];
                                break;
                            case 90:
                                matrix = [
                                    0,
                                    1,
                                    -1,
                                    0
                                ];
                                clipBox = [
                                    rect[1],
                                    -rect[2],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    rect[1],
                                    -rect[0] - lineAscent
                                ];
                                break;
                            case 180:
                                matrix = [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                                clipBox = [
                                    -rect[2],
                                    -rect[3],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    -rect[2],
                                    -rect[1] - lineAscent
                                ];
                                break;
                            case 270:
                                matrix = [
                                    0,
                                    -1,
                                    1,
                                    0
                                ];
                                clipBox = [
                                    -rect[3],
                                    rect[0],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    -rect[3],
                                    rect[2] - lineAscent
                                ];
                                break;
                        }
                        const buffer = [
                            "q",
                            `${matrix.join(" ")} 0 0 cm`,
                            `${clipBox.join(" ")} re W n`,
                            `BT`,
                            `${(0, _default_appearance.getPdfColor)(color, true)}`,
                            `0 Tc /Helv ${(0, _core_utils.numberToString)(newFontSize)} Tf`
                        ];
                        buffer.push(`${firstPoint.join(" ")} Td (${(0, _core_utils.escapeString)(encodedLines[0])}) Tj`);
                        const vShift = (0, _core_utils.numberToString)(lineHeight);
                        for(let i = 1, ii = encodedLines.length; i < ii; i++){
                            const line = encodedLines[i];
                            buffer.push(`0 -${vShift} Td (${(0, _core_utils.escapeString)(line)}) Tj`);
                        }
                        buffer.push("ET", "Q");
                        const appearance = buffer.join("\n");
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", rect);
                        appearanceStreamDict.set("Resources", resources);
                        appearanceStreamDict.set("Matrix", [
                            1,
                            0,
                            0,
                            1,
                            -rect[0],
                            -rect[1]
                        ]);
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                class LineAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.LINE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const lineCoordinates = dict.getArray("L");
                        this.data.lineCoordinates = _util.Util.normalizeRect(lineCoordinates);
                        this.setLineEndings(dict.getArray("LE"));
                        this.data.lineEndings = this.lineEndings;
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const interiorColor = getRgbColor(dict.getArray("IC"), null);
                            const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                this.data.lineCoordinates[0] - borderAdjust,
                                this.data.lineCoordinates[1] - borderAdjust,
                                this.data.lineCoordinates[2] + borderAdjust,
                                this.data.lineCoordinates[3] + borderAdjust
                            ];
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    buffer.push(`${lineCoordinates[0]} ${lineCoordinates[1]} m`, `${lineCoordinates[2]} ${lineCoordinates[3]} l`, "S");
                                    return [
                                        points[0].x - borderWidth,
                                        points[1].x + borderWidth,
                                        points[3].y - borderWidth,
                                        points[1].y + borderWidth
                                    ];
                                }
                            });
                        }
                    }
                }
                class SquareAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.SQUARE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const interiorColor = getRgbColor(dict.getArray("IC"), null);
                            const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            if (this.borderStyle.width === 0 && !fillColor) return;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const x = points[2].x + this.borderStyle.width / 2;
                                    const y = points[2].y + this.borderStyle.width / 2;
                                    const width = points[3].x - points[2].x - this.borderStyle.width;
                                    const height = points[1].y - points[3].y - this.borderStyle.width;
                                    buffer.push(`${x} ${y} ${width} ${height} re`);
                                    if (fillColor) buffer.push("B");
                                    else buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class CircleAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.CIRCLE;
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const interiorColor = getRgbColor(dict.getArray("IC"), null);
                            const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            if (this.borderStyle.width === 0 && !fillColor) return;
                            const controlPointsDistance = 4 / 3 * Math.tan(Math.PI / 8);
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const x0 = points[0].x + this.borderStyle.width / 2;
                                    const y0 = points[0].y - this.borderStyle.width / 2;
                                    const x1 = points[3].x - this.borderStyle.width / 2;
                                    const y1 = points[3].y + this.borderStyle.width / 2;
                                    const xMid = x0 + (x1 - x0) / 2;
                                    const yMid = y0 + (y1 - y0) / 2;
                                    const xOffset = (x1 - x0) / 2 * controlPointsDistance;
                                    const yOffset = (y1 - y0) / 2 * controlPointsDistance;
                                    buffer.push(`${xMid} ${y1} m`, `${xMid + xOffset} ${y1} ${x1} ${yMid + yOffset} ${x1} ${yMid} c`, `${x1} ${yMid - yOffset} ${xMid + xOffset} ${y0} ${xMid} ${y0} c`, `${xMid - xOffset} ${y0} ${x0} ${yMid - yOffset} ${x0} ${yMid} c`, `${x0} ${yMid + yOffset} ${xMid - xOffset} ${y1} ${xMid} ${y1} c`, "h");
                                    if (fillColor) buffer.push("B");
                                    else buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolylineAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.POLYLINE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        this.data.vertices = [];
                        if (!(this instanceof PolygonAnnotation)) {
                            this.setLineEndings(dict.getArray("LE"));
                            this.data.lineEndings = this.lineEndings;
                        }
                        const rawVertices = dict.getArray("Vertices");
                        if (!Array.isArray(rawVertices)) return;
                        for(let i = 0, ii = rawVertices.length; i < ii; i += 2)this.data.vertices.push({
                            x: rawVertices[i],
                            y: rawVertices[i + 1]
                        });
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            for (const vertex of this.data.vertices){
                                bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                                bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                                bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                                bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                            }
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                strokeAlpha: strokeAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const vertices = this.data.vertices;
                                    for(let i = 0, ii = vertices.length; i < ii; i++)buffer.push(`${vertices[i].x} ${vertices[i].y} ${i === 0 ? "m" : "l"}`);
                                    buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolygonAnnotation extends PolylineAnnotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.POLYGON;
                    }
                }
                class CaretAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.CARET;
                    }
                }
                class InkAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.INK;
                        this.data.inkLists = [];
                        const rawInkLists = dict.getArray("InkList");
                        if (!Array.isArray(rawInkLists)) return;
                        for(let i = 0, ii = rawInkLists.length; i < ii; ++i){
                            this.data.inkLists.push([]);
                            for(let j = 0, jj = rawInkLists[i].length; j < jj; j += 2)this.data.inkLists[i].push({
                                x: xref.fetchIfRef(rawInkLists[i][j]),
                                y: xref.fetchIfRef(rawInkLists[i][j + 1])
                            });
                        }
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            for (const inkLists of this.data.inkLists)for (const vertex of inkLists){
                                bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                                bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                                bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                                bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                            }
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                strokeAlpha: strokeAlpha,
                                pointsCallback: (buffer, points)=>{
                                    for (const inkList of this.data.inkLists){
                                        for(let i = 0, ii = inkList.length; i < ii; i++)buffer.push(`${inkList[i].x} ${inkList[i].y} ${i === 0 ? "m" : "l"}`);
                                        buffer.push("S");
                                    }
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                    static createNewDict(annotation, xref, { apRef: apRef, ap: ap }) {
                        const { color: color, opacity: opacity, paths: paths, rect: rect, rotation: rotation, thickness: thickness } = annotation;
                        const ink = new _primitives.Dict(xref);
                        ink.set("Type", _primitives.Name.get("Annot"));
                        ink.set("Subtype", _primitives.Name.get("Ink"));
                        ink.set("CreationDate", `D:${(0, _util.getModificationDate)()}`);
                        ink.set("Rect", rect);
                        ink.set("InkList", paths.map((p)=>p.points));
                        ink.set("F", 4);
                        ink.set("Rotate", rotation);
                        const bs = new _primitives.Dict(xref);
                        ink.set("BS", bs);
                        bs.set("W", thickness);
                        ink.set("C", Array.from(color, (c)=>c / 255));
                        ink.set("CA", opacity);
                        const n = new _primitives.Dict(xref);
                        ink.set("AP", n);
                        if (apRef) n.set("N", apRef);
                        else n.set("N", ap);
                        return ink;
                    }
                    static async createNewAppearanceStream(annotation, xref, params) {
                        const { color: color, rect: rect, paths: paths, thickness: thickness, opacity: opacity } = annotation;
                        const appearanceBuffer = [
                            `${thickness} w 1 J 1 j`,
                            `${(0, _default_appearance.getPdfColor)(color, false)}`
                        ];
                        if (opacity !== 1) appearanceBuffer.push("/R0 gs");
                        const buffer = [];
                        for (const { bezier: bezier } of paths){
                            buffer.length = 0;
                            buffer.push(`${(0, _core_utils.numberToString)(bezier[0])} ${(0, _core_utils.numberToString)(bezier[1])} m`);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const curve = bezier.slice(i, i + 6).map(_core_utils.numberToString).join(" ");
                                buffer.push(`${curve} c`);
                            }
                            buffer.push("S");
                            appearanceBuffer.push(buffer.join("\n"));
                        }
                        const appearance = appearanceBuffer.join("\n");
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", rect);
                        appearanceStreamDict.set("Length", appearance.length);
                        if (opacity !== 1) {
                            const resources = new _primitives.Dict(xref);
                            const extGState = new _primitives.Dict(xref);
                            const r0 = new _primitives.Dict(xref);
                            r0.set("CA", opacity);
                            r0.set("Type", _primitives.Name.get("ExtGState"));
                            extGState.set("R0", r0);
                            resources.set("ExtGState", extGState);
                            appearanceStreamDict.set("Resources", resources);
                        }
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                class HighlightAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.HIGHLIGHT;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            const resources = this.appearance?.dict.get("Resources");
                            if (!this.appearance || !resources?.has("ExtGState")) {
                                if (this.appearance) (0, _util.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                                const fillColor = this.color ? getPdfColorArray(this.color) : [
                                    1,
                                    1,
                                    0
                                ];
                                const fillAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    fillColor: fillColor,
                                    blendMode: "Multiply",
                                    fillAlpha: fillAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${points[0].x} ${points[0].y} m`, `${points[1].x} ${points[1].y} l`, `${points[3].x} ${points[3].y} l`, `${points[2].x} ${points[2].y} l`, "f");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class UnderlineAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.UNDERLINE;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    extra: "[] 0 d 0.571 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${points[2].x} ${points[2].y + 1.3} m`, `${points[3].x} ${points[3].y + 1.3} l`, "S");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class SquigglyAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.SQUIGGLY;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        const dy = (points[0].y - points[2].y) / 6;
                                        let shift = dy;
                                        let x = points[2].x;
                                        const y = points[2].y;
                                        const xEnd = points[3].x;
                                        buffer.push(`${x} ${y + shift} m`);
                                        do {
                                            x += 2;
                                            shift = shift === 0 ? dy : 0;
                                            buffer.push(`${x} ${y + shift} l`);
                                        }while (x < xEnd);
                                        buffer.push("S");
                                        return [
                                            points[2].x,
                                            xEnd,
                                            y - 2 * dy,
                                            y + 2 * dy
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class StrikeOutAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.STRIKEOUT;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${(points[0].x + points[2].x) / 2} ` + `${(points[0].y + points[2].y) / 2} m`, `${(points[1].x + points[3].x) / 2} ` + `${(points[1].y + points[3].y) / 2} l`, "S");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class StampAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.STAMP;
                        this.data.hasOwnCanvas = this.data.noRotate;
                    }
                    static async createImage(bitmap, xref) {
                        const { width: width, height: height } = bitmap;
                        const canvas = new OffscreenCanvas(width, height);
                        const ctx = canvas.getContext("2d", {
                            alpha: true
                        });
                        ctx.drawImage(bitmap, 0, 0);
                        const data = ctx.getImageData(0, 0, width, height).data;
                        const buf32 = new Uint32Array(data.buffer);
                        const hasAlpha = buf32.some(_util.FeatureTest.isLittleEndian ? (x)=>x >>> 24 !== 0xff : (x)=>(x & 0xff) !== 0xff);
                        if (hasAlpha) {
                            ctx.fillStyle = "white";
                            ctx.fillRect(0, 0, width, height);
                            ctx.drawImage(bitmap, 0, 0);
                        }
                        const jpegBufferPromise = canvas.convertToBlob({
                            type: "image/jpeg",
                            quality: 1
                        }).then((blob)=>{
                            return blob.arrayBuffer();
                        });
                        const xobjectName = _primitives.Name.get("XObject");
                        const imageName = _primitives.Name.get("Image");
                        const image = new _primitives.Dict(xref);
                        image.set("Type", xobjectName);
                        image.set("Subtype", imageName);
                        image.set("BitsPerComponent", 8);
                        image.set("ColorSpace", _primitives.Name.get("DeviceRGB"));
                        image.set("Filter", _primitives.Name.get("DCTDecode"));
                        image.set("BBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        image.set("Width", width);
                        image.set("Height", height);
                        let smaskStream = null;
                        if (hasAlpha) {
                            const alphaBuffer = new Uint8Array(buf32.length);
                            if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = buf32.length; i < ii; i++)alphaBuffer[i] = buf32[i] >>> 24;
                            else for(let i = 0, ii = buf32.length; i < ii; i++)alphaBuffer[i] = buf32[i] & 0xff;
                            const smask = new _primitives.Dict(xref);
                            smask.set("Type", xobjectName);
                            smask.set("Subtype", imageName);
                            smask.set("BitsPerComponent", 8);
                            smask.set("ColorSpace", _primitives.Name.get("DeviceGray"));
                            smask.set("Width", width);
                            smask.set("Height", height);
                            smaskStream = new _stream.Stream(alphaBuffer, 0, 0, smask);
                        }
                        const imageStream = new _stream.Stream(await jpegBufferPromise, 0, 0, image);
                        return {
                            imageStream: imageStream,
                            smaskStream: smaskStream,
                            width: width,
                            height: height
                        };
                    }
                    static createNewDict(annotation, xref, { apRef: apRef, ap: ap }) {
                        const { rect: rect, rotation: rotation, user: user } = annotation;
                        const stamp = new _primitives.Dict(xref);
                        stamp.set("Type", _primitives.Name.get("Annot"));
                        stamp.set("Subtype", _primitives.Name.get("Stamp"));
                        stamp.set("CreationDate", `D:${(0, _util.getModificationDate)()}`);
                        stamp.set("Rect", rect);
                        stamp.set("F", 4);
                        stamp.set("Border", [
                            0,
                            0,
                            0
                        ]);
                        stamp.set("Rotate", rotation);
                        if (user) stamp.set("T", (0, _core_utils.isAscii)(user) ? user : (0, _core_utils.stringToUTF16String)(user, true));
                        if (apRef || ap) {
                            const n = new _primitives.Dict(xref);
                            stamp.set("AP", n);
                            if (apRef) n.set("N", apRef);
                            else n.set("N", ap);
                        }
                        return stamp;
                    }
                    static async createNewAppearanceStream(annotation, xref, params) {
                        const { rotation: rotation } = annotation;
                        const { imageRef: imageRef, width: width, height: height } = params.image;
                        const resources = new _primitives.Dict(xref);
                        const xobject = new _primitives.Dict(xref);
                        resources.set("XObject", xobject);
                        xobject.set("Im0", imageRef);
                        const appearance = `q ${width} 0 0 ${height} 0 0 cm /Im0 Do Q`;
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        appearanceStreamDict.set("Resources", resources);
                        if (rotation) {
                            const matrix = (0, _core_utils.getRotationMatrix)(rotation, width, height);
                            appearanceStreamDict.set("Matrix", matrix);
                        }
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                class FileAttachmentAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        const file = new _file_spec.FileSpec(dict.get("FS"), xref);
                        this.data.annotationType = _util.AnnotationType.FILEATTACHMENT;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        this.data.file = file.serializable;
                        const name = dict.get("Name");
                        this.data.name = name instanceof _primitives.Name ? (0, _util.stringToPDFString)(name.name) : "PushPin";
                        const fillAlpha = dict.get("ca");
                        this.data.fillAlpha = typeof fillAlpha === "number" && fillAlpha >= 0 && fillAlpha <= 1 ? fillAlpha : null;
                    }
                }
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FakeUnicodeFont = void 0;
                exports.createDefaultAppearance = createDefaultAppearance;
                exports.getPdfColor = getPdfColor;
                exports.parseAppearanceStream = parseAppearanceStream;
                exports.parseDefaultAppearance = parseDefaultAppearance;
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                var _colorspace = __w_pdfjs_require__(12);
                var _evaluator = __w_pdfjs_require__(13);
                var _image_utils = __w_pdfjs_require__(59);
                var _function = __w_pdfjs_require__(57);
                var _stream = __w_pdfjs_require__(8);
                class DefaultAppearanceEvaluator extends _evaluator.EvaluatorPreprocessor {
                    constructor(str){
                        super(new _stream.StringStream(str));
                    }
                    parse() {
                        const operation = {
                            fn: 0,
                            args: []
                        };
                        const result = {
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3)
                        };
                        try {
                            while(true){
                                operation.args.length = 0;
                                if (!this.read(operation)) break;
                                if (this.savedStatesDepth !== 0) continue;
                                const { fn: fn, args: args } = operation;
                                switch(fn | 0){
                                    case _util.OPS.setFont:
                                        const [fontName, fontSize] = args;
                                        if (fontName instanceof _primitives.Name) result.fontName = fontName.name;
                                        if (typeof fontSize === "number" && fontSize > 0) result.fontSize = fontSize;
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillGray:
                                        _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                }
                            }
                        } catch (reason) {
                            (0, _util.warn)(`parseDefaultAppearance - ignoring errors: "${reason}".`);
                        }
                        return result;
                    }
                }
                function parseDefaultAppearance(str) {
                    return new DefaultAppearanceEvaluator(str).parse();
                }
                class AppearanceStreamEvaluator extends _evaluator.EvaluatorPreprocessor {
                    constructor(stream, evaluatorOptions, xref){
                        super(stream);
                        this.stream = stream;
                        this.evaluatorOptions = evaluatorOptions;
                        this.xref = xref;
                        this.resources = stream.dict?.get("Resources");
                    }
                    parse() {
                        const operation = {
                            fn: 0,
                            args: []
                        };
                        let result = {
                            scaleFactor: 1,
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3),
                            fillColorSpace: _colorspace.ColorSpace.singletons.gray
                        };
                        let breakLoop = false;
                        const stack = [];
                        try {
                            while(true){
                                operation.args.length = 0;
                                if (breakLoop || !this.read(operation)) break;
                                const { fn: fn, args: args } = operation;
                                switch(fn | 0){
                                    case _util.OPS.save:
                                        stack.push({
                                            scaleFactor: result.scaleFactor,
                                            fontSize: result.fontSize,
                                            fontName: result.fontName,
                                            fontColor: result.fontColor.slice(),
                                            fillColorSpace: result.fillColorSpace
                                        });
                                        break;
                                    case _util.OPS.restore:
                                        result = stack.pop() || result;
                                        break;
                                    case _util.OPS.setTextMatrix:
                                        result.scaleFactor *= Math.hypot(args[0], args[1]);
                                        break;
                                    case _util.OPS.setFont:
                                        const [fontName, fontSize] = args;
                                        if (fontName instanceof _primitives.Name) result.fontName = fontName.name;
                                        if (typeof fontSize === "number" && fontSize > 0) result.fontSize = fontSize * result.scaleFactor;
                                        break;
                                    case _util.OPS.setFillColorSpace:
                                        result.fillColorSpace = _colorspace.ColorSpace.parse({
                                            cs: args[0],
                                            xref: this.xref,
                                            resources: this.resources,
                                            pdfFunctionFactory: this._pdfFunctionFactory,
                                            localColorSpaceCache: this._localColorSpaceCache
                                        });
                                        break;
                                    case _util.OPS.setFillColor:
                                        const cs = result.fillColorSpace;
                                        cs.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillGray:
                                        _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.showText:
                                    case _util.OPS.showSpacedText:
                                    case _util.OPS.nextLineShowText:
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        breakLoop = true;
                                        break;
                                }
                            }
                        } catch (reason) {
                            (0, _util.warn)(`parseAppearanceStream - ignoring errors: "${reason}".`);
                        }
                        this.stream.reset();
                        delete result.scaleFactor;
                        delete result.fillColorSpace;
                        return result;
                    }
                    get _localColorSpaceCache() {
                        return (0, _util.shadow)(this, "_localColorSpaceCache", new _image_utils.LocalColorSpaceCache());
                    }
                    get _pdfFunctionFactory() {
                        const pdfFunctionFactory = new _function.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.evaluatorOptions.isEvalSupported
                        });
                        return (0, _util.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                    }
                }
                function parseAppearanceStream(stream, evaluatorOptions, xref) {
                    return new AppearanceStreamEvaluator(stream, evaluatorOptions, xref).parse();
                }
                function getPdfColor(color, isFill) {
                    if (color[0] === color[1] && color[1] === color[2]) {
                        const gray = color[0] / 255;
                        return `${(0, _core_utils.numberToString)(gray)} ${isFill ? "g" : "G"}`;
                    }
                    return Array.from(color, (c)=>(0, _core_utils.numberToString)(c / 255)).join(" ") + ` ${isFill ? "rg" : "RG"}`;
                }
                function createDefaultAppearance({ fontSize: fontSize, fontName: fontName, fontColor: fontColor }) {
                    return `/${(0, _core_utils.escapePDFName)(fontName)} ${fontSize} Tf ${getPdfColor(fontColor, true)}`;
                }
                class FakeUnicodeFont {
                    constructor(xref, fontFamily){
                        this.xref = xref;
                        this.widths = null;
                        this.firstChar = Infinity;
                        this.lastChar = -Infinity;
                        this.fontFamily = fontFamily;
                        const canvas = new OffscreenCanvas(1, 1);
                        this.ctxMeasure = canvas.getContext("2d");
                        if (!FakeUnicodeFont._fontNameId) FakeUnicodeFont._fontNameId = 1;
                        this.fontName = _primitives.Name.get(`InvalidPDFjsFont_${fontFamily}_${FakeUnicodeFont._fontNameId++}`);
                    }
                    get toUnicodeRef() {
                        if (!FakeUnicodeFont._toUnicodeRef) {
                            const toUnicode = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`;
                            const toUnicodeStream = FakeUnicodeFont.toUnicodeStream = new _stream.StringStream(toUnicode);
                            const toUnicodeDict = new _primitives.Dict(this.xref);
                            toUnicodeStream.dict = toUnicodeDict;
                            toUnicodeDict.set("Length", toUnicode.length);
                            FakeUnicodeFont._toUnicodeRef = this.xref.getNewPersistentRef(toUnicodeStream);
                        }
                        return FakeUnicodeFont._toUnicodeRef;
                    }
                    get fontDescriptorRef() {
                        if (!FakeUnicodeFont._fontDescriptorRef) {
                            const fontDescriptor = new _primitives.Dict(this.xref);
                            fontDescriptor.set("Type", _primitives.Name.get("FontDescriptor"));
                            fontDescriptor.set("FontName", this.fontName);
                            fontDescriptor.set("FontFamily", "MyriadPro Regular");
                            fontDescriptor.set("FontBBox", [
                                0,
                                0,
                                0,
                                0
                            ]);
                            fontDescriptor.set("FontStretch", _primitives.Name.get("Normal"));
                            fontDescriptor.set("FontWeight", 400);
                            fontDescriptor.set("ItalicAngle", 0);
                            FakeUnicodeFont._fontDescriptorRef = this.xref.getNewPersistentRef(fontDescriptor);
                        }
                        return FakeUnicodeFont._fontDescriptorRef;
                    }
                    get descendantFontRef() {
                        const descendantFont = new _primitives.Dict(this.xref);
                        descendantFont.set("BaseFont", this.fontName);
                        descendantFont.set("Type", _primitives.Name.get("Font"));
                        descendantFont.set("Subtype", _primitives.Name.get("CIDFontType0"));
                        descendantFont.set("CIDToGIDMap", _primitives.Name.get("Identity"));
                        descendantFont.set("FirstChar", this.firstChar);
                        descendantFont.set("LastChar", this.lastChar);
                        descendantFont.set("FontDescriptor", this.fontDescriptorRef);
                        descendantFont.set("DW", 1000);
                        const widths = [];
                        const chars = [
                            ...this.widths.entries()
                        ].sort();
                        let currentChar = null;
                        let currentWidths = null;
                        for (const [char, width] of chars){
                            if (!currentChar) {
                                currentChar = char;
                                currentWidths = [
                                    width
                                ];
                                continue;
                            }
                            if (char === currentChar + currentWidths.length) currentWidths.push(width);
                            else {
                                widths.push(currentChar, currentWidths);
                                currentChar = char;
                                currentWidths = [
                                    width
                                ];
                            }
                        }
                        if (currentChar) widths.push(currentChar, currentWidths);
                        descendantFont.set("W", widths);
                        const cidSystemInfo = new _primitives.Dict(this.xref);
                        cidSystemInfo.set("Ordering", "Identity");
                        cidSystemInfo.set("Registry", "Adobe");
                        cidSystemInfo.set("Supplement", 0);
                        descendantFont.set("CIDSystemInfo", cidSystemInfo);
                        return this.xref.getNewPersistentRef(descendantFont);
                    }
                    get baseFontRef() {
                        const baseFont = new _primitives.Dict(this.xref);
                        baseFont.set("BaseFont", this.fontName);
                        baseFont.set("Type", _primitives.Name.get("Font"));
                        baseFont.set("Subtype", _primitives.Name.get("Type0"));
                        baseFont.set("Encoding", _primitives.Name.get("Identity-H"));
                        baseFont.set("DescendantFonts", [
                            this.descendantFontRef
                        ]);
                        baseFont.set("ToUnicode", this.toUnicodeRef);
                        return this.xref.getNewPersistentRef(baseFont);
                    }
                    get resources() {
                        const resources = new _primitives.Dict(this.xref);
                        const font1 = new _primitives.Dict(this.xref);
                        font1.set(this.fontName.name, this.baseFontRef);
                        resources.set("Font", font1);
                        return resources;
                    }
                    _createContext() {
                        this.widths = new Map();
                        this.ctxMeasure.font = `1000px ${this.fontFamily}`;
                        return this.ctxMeasure;
                    }
                    createFontResources(text) {
                        const ctx = this._createContext();
                        for (const line of text.split(/\r\n?|\n/))for (const char of line.split("")){
                            const code = char.charCodeAt(0);
                            if (this.widths.has(code)) continue;
                            const metrics = ctx.measureText(char);
                            const width = Math.ceil(metrics.width);
                            this.widths.set(code, width);
                            this.firstChar = Math.min(code, this.firstChar);
                            this.lastChar = Math.max(code, this.lastChar);
                        }
                        return this.resources;
                    }
                    createAppearance(text, rect, rotation, fontSize, bgColor, strokeAlpha) {
                        const ctx = this._createContext();
                        const lines = [];
                        let maxWidth = -Infinity;
                        for (const line of text.split(/\r\n?|\n/)){
                            lines.push(line);
                            const lineWidth = ctx.measureText(line).width;
                            maxWidth = Math.max(maxWidth, lineWidth);
                            for (const char of line.split("")){
                                const code = char.charCodeAt(0);
                                let width = this.widths.get(code);
                                if (width === undefined) {
                                    const metrics = ctx.measureText(char);
                                    width = Math.ceil(metrics.width);
                                    this.widths.set(code, width);
                                    this.firstChar = Math.min(code, this.firstChar);
                                    this.lastChar = Math.max(code, this.lastChar);
                                }
                            }
                        }
                        maxWidth *= fontSize / 1000;
                        const [x1, y1, x2, y2] = rect;
                        let w = x2 - x1;
                        let h = y2 - y1;
                        if (rotation % 180 !== 0) [w, h] = [
                            h,
                            w
                        ];
                        let hscale = 1;
                        if (maxWidth > w) hscale = w / maxWidth;
                        let vscale = 1;
                        const lineHeight = _util.LINE_FACTOR * fontSize;
                        const lineDescent = _util.LINE_DESCENT_FACTOR * fontSize;
                        const maxHeight = lineHeight * lines.length;
                        if (maxHeight > h) vscale = h / maxHeight;
                        const fscale = Math.min(hscale, vscale);
                        const newFontSize = fontSize * fscale;
                        const buffer = [
                            "q",
                            `0 0 ${(0, _core_utils.numberToString)(w)} ${(0, _core_utils.numberToString)(h)} re W n`,
                            `BT`,
                            `1 0 0 1 0 ${(0, _core_utils.numberToString)(h + lineDescent)} Tm 0 Tc ${getPdfColor(bgColor, true)}`,
                            `/${this.fontName.name} ${(0, _core_utils.numberToString)(newFontSize)} Tf`
                        ];
                        const { resources: resources } = this;
                        strokeAlpha = typeof strokeAlpha === "number" && strokeAlpha >= 0 && strokeAlpha <= 1 ? strokeAlpha : 1;
                        if (strokeAlpha !== 1) {
                            buffer.push("/R0 gs");
                            const extGState = new _primitives.Dict(this.xref);
                            const r0 = new _primitives.Dict(this.xref);
                            r0.set("ca", strokeAlpha);
                            r0.set("CA", strokeAlpha);
                            r0.set("Type", _primitives.Name.get("ExtGState"));
                            extGState.set("R0", r0);
                            resources.set("ExtGState", extGState);
                        }
                        const vShift = (0, _core_utils.numberToString)(lineHeight);
                        for (const line of lines)buffer.push(`0 -${vShift} Td <${(0, _core_utils.stringToUTF16HexString)(line)}> Tj`);
                        buffer.push("ET", "Q");
                        const appearance = buffer.join("\n");
                        const appearanceStreamDict = new _primitives.Dict(this.xref);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", [
                            0,
                            0,
                            w,
                            h
                        ]);
                        appearanceStreamDict.set("Length", appearance.length);
                        appearanceStreamDict.set("Resources", resources);
                        if (rotation) {
                            const matrix = (0, _core_utils.getRotationMatrix)(rotation, w, h);
                            appearanceStreamDict.set("Matrix", matrix);
                        }
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                exports.FakeUnicodeFont = FakeUnicodeFont;
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorSpace = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(3);
                function resizeRgbImage(src, dest, w1, h1, w2, h2, alpha01) {
                    const COMPONENTS = 3;
                    alpha01 = alpha01 !== 1 ? 0 : alpha01;
                    const xRatio = w1 / w2;
                    const yRatio = h1 / h2;
                    let newIndex = 0, oldIndex;
                    const xScaled = new Uint16Array(w2);
                    const w1Scanline = w1 * COMPONENTS;
                    for(let i = 0; i < w2; i++)xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
                    for(let i = 0; i < h2; i++){
                        const py = Math.floor(i * yRatio) * w1Scanline;
                        for(let j = 0; j < w2; j++){
                            oldIndex = py + xScaled[j];
                            dest[newIndex++] = src[oldIndex++];
                            dest[newIndex++] = src[oldIndex++];
                            dest[newIndex++] = src[oldIndex++];
                            newIndex += alpha01;
                        }
                    }
                }
                class ColorSpace {
                    constructor(name, numComps){
                        if (this.constructor === ColorSpace) (0, _util.unreachable)("Cannot initialize ColorSpace.");
                        this.name = name;
                        this.numComps = numComps;
                    }
                    getRgb(src, srcOffset) {
                        const rgb = new Uint8ClampedArray(3);
                        this.getRgbItem(src, srcOffset, rgb, 0);
                        return rgb;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        (0, _util.unreachable)("Should not call ColorSpace.getRgbItem");
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        (0, _util.unreachable)("Should not call ColorSpace.getRgbBuffer");
                    }
                    getOutputLength(inputLength, alpha01) {
                        (0, _util.unreachable)("Should not call ColorSpace.getOutputLength");
                    }
                    isPassthrough(bits) {
                        return false;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
                    }
                    fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
                        const count = originalWidth * originalHeight;
                        let rgbBuf = null;
                        const numComponentColors = 1 << bpc;
                        const needsResizing = originalHeight !== height || originalWidth !== width;
                        if (this.isPassthrough(bpc)) rgbBuf = comps;
                        else if (this.numComps === 1 && count > numComponentColors && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                            const allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
                            for(let i = 0; i < numComponentColors; i++)allColors[i] = i;
                            const colorMap = new Uint8ClampedArray(numComponentColors * 3);
                            this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
                            if (!needsResizing) {
                                let destPos = 0;
                                for(let i = 0; i < count; ++i){
                                    const key = comps[i] * 3;
                                    dest[destPos++] = colorMap[key];
                                    dest[destPos++] = colorMap[key + 1];
                                    dest[destPos++] = colorMap[key + 2];
                                    destPos += alpha01;
                                }
                            } else {
                                rgbBuf = new Uint8Array(count * 3);
                                let rgbPos = 0;
                                for(let i = 0; i < count; ++i){
                                    const key = comps[i] * 3;
                                    rgbBuf[rgbPos++] = colorMap[key];
                                    rgbBuf[rgbPos++] = colorMap[key + 1];
                                    rgbBuf[rgbPos++] = colorMap[key + 2];
                                }
                            }
                        } else if (!needsResizing) this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
                        else {
                            rgbBuf = new Uint8ClampedArray(count * 3);
                            this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
                        }
                        if (rgbBuf) {
                            if (needsResizing) resizeRgbImage(rgbBuf, dest, originalWidth, originalHeight, width, height, alpha01);
                            else {
                                let destPos = 0, rgbPos = 0;
                                for(let i = 0, ii = width * actualHeight; i < ii; i++){
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    destPos += alpha01;
                                }
                            }
                        }
                    }
                    get usesZeroToOneRange() {
                        return (0, _util.shadow)(this, "usesZeroToOneRange", true);
                    }
                    static _cache(cacheKey, xref, localColorSpaceCache, parsedColorSpace) {
                        if (!localColorSpaceCache) throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
                        if (!parsedColorSpace) throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
                        let csName, csRef;
                        if (cacheKey instanceof _primitives.Ref) {
                            csRef = cacheKey;
                            cacheKey = xref.fetch(cacheKey);
                        }
                        if (cacheKey instanceof _primitives.Name) csName = cacheKey.name;
                        if (csName || csRef) localColorSpaceCache.set(csName, csRef, parsedColorSpace);
                    }
                    static getCached(cacheKey, xref, localColorSpaceCache) {
                        if (!localColorSpaceCache) throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
                        if (cacheKey instanceof _primitives.Ref) {
                            const localColorSpace = localColorSpaceCache.getByRef(cacheKey);
                            if (localColorSpace) return localColorSpace;
                            try {
                                cacheKey = xref.fetch(cacheKey);
                            } catch (ex) {
                                if (ex instanceof _core_utils.MissingDataException) throw ex;
                            }
                        }
                        if (cacheKey instanceof _primitives.Name) {
                            const localColorSpace = localColorSpaceCache.getByName(cacheKey.name);
                            if (localColorSpace) return localColorSpace;
                        }
                        return null;
                    }
                    static async parseAsync({ cs: cs, xref: xref, resources: resources = null, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }) {
                        const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                        this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                        return parsedColorSpace;
                    }
                    static parse({ cs: cs, xref: xref, resources: resources = null, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }) {
                        const cachedColorSpace = this.getCached(cs, xref, localColorSpaceCache);
                        if (cachedColorSpace) return cachedColorSpace;
                        const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                        this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                        return parsedColorSpace;
                    }
                    static _parse(cs, xref, resources = null, pdfFunctionFactory) {
                        cs = xref.fetchIfRef(cs);
                        if (cs instanceof _primitives.Name) switch(cs.name){
                            case "G":
                            case "DeviceGray":
                                return this.singletons.gray;
                            case "RGB":
                            case "DeviceRGB":
                                return this.singletons.rgb;
                            case "CMYK":
                            case "DeviceCMYK":
                                return this.singletons.cmyk;
                            case "Pattern":
                                return new PatternCS(null);
                            default:
                                if (resources instanceof _primitives.Dict) {
                                    const colorSpaces = resources.get("ColorSpace");
                                    if (colorSpaces instanceof _primitives.Dict) {
                                        const resourcesCS = colorSpaces.get(cs.name);
                                        if (resourcesCS) {
                                            if (resourcesCS instanceof _primitives.Name) return this._parse(resourcesCS, xref, resources, pdfFunctionFactory);
                                            cs = resourcesCS;
                                            break;
                                        }
                                    }
                                }
                                throw new _util.FormatError(`Unrecognized ColorSpace: ${cs.name}`);
                        }
                        if (Array.isArray(cs)) {
                            const mode = xref.fetchIfRef(cs[0]).name;
                            let params, numComps, baseCS, whitePoint, blackPoint, gamma;
                            switch(mode){
                                case "G":
                                case "DeviceGray":
                                    return this.singletons.gray;
                                case "RGB":
                                case "DeviceRGB":
                                    return this.singletons.rgb;
                                case "CMYK":
                                case "DeviceCMYK":
                                    return this.singletons.cmyk;
                                case "CalGray":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    gamma = params.get("Gamma");
                                    return new CalGrayCS(whitePoint, blackPoint, gamma);
                                case "CalRGB":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    gamma = params.getArray("Gamma");
                                    const matrix = params.getArray("Matrix");
                                    return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
                                case "ICCBased":
                                    const stream = xref.fetchIfRef(cs[1]);
                                    const dict = stream.dict;
                                    numComps = dict.get("N");
                                    const alt = dict.get("Alternate");
                                    if (alt) {
                                        const altCS = this._parse(alt, xref, resources, pdfFunctionFactory);
                                        if (altCS.numComps === numComps) return altCS;
                                        (0, _util.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                                    }
                                    if (numComps === 1) return this.singletons.gray;
                                    else if (numComps === 3) return this.singletons.rgb;
                                    else if (numComps === 4) return this.singletons.cmyk;
                                    break;
                                case "Pattern":
                                    baseCS = cs[1] || null;
                                    if (baseCS) baseCS = this._parse(baseCS, xref, resources, pdfFunctionFactory);
                                    return new PatternCS(baseCS);
                                case "I":
                                case "Indexed":
                                    baseCS = this._parse(cs[1], xref, resources, pdfFunctionFactory);
                                    const hiVal = xref.fetchIfRef(cs[2]) + 1;
                                    const lookup = xref.fetchIfRef(cs[3]);
                                    return new IndexedCS(baseCS, hiVal, lookup);
                                case "Separation":
                                case "DeviceN":
                                    const name = xref.fetchIfRef(cs[1]);
                                    numComps = Array.isArray(name) ? name.length : 1;
                                    baseCS = this._parse(cs[2], xref, resources, pdfFunctionFactory);
                                    const tintFn = pdfFunctionFactory.create(cs[3]);
                                    return new AlternateCS(numComps, baseCS, tintFn);
                                case "Lab":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    const range = params.getArray("Range");
                                    return new LabCS(whitePoint, blackPoint, range);
                                default:
                                    throw new _util.FormatError(`Unimplemented ColorSpace object: ${mode}`);
                            }
                        }
                        throw new _util.FormatError(`Unrecognized ColorSpace object: ${cs}`);
                    }
                    static isDefaultDecode(decode, numComps) {
                        if (!Array.isArray(decode)) return true;
                        if (numComps * 2 !== decode.length) {
                            (0, _util.warn)("The decode map is not the correct length");
                            return true;
                        }
                        for(let i = 0, ii = decode.length; i < ii; i += 2){
                            if (decode[i] !== 0 || decode[i + 1] !== 1) return false;
                        }
                        return true;
                    }
                    static get singletons() {
                        return (0, _util.shadow)(this, "singletons", {
                            get gray () {
                                return (0, _util.shadow)(this, "gray", new DeviceGrayCS());
                            },
                            get rgb () {
                                return (0, _util.shadow)(this, "rgb", new DeviceRgbCS());
                            },
                            get cmyk () {
                                return (0, _util.shadow)(this, "cmyk", new DeviceCmykCS());
                            }
                        });
                    }
                }
                exports.ColorSpace = ColorSpace;
                class AlternateCS extends ColorSpace {
                    constructor(numComps, base, tintFn){
                        super("Alternate", numComps);
                        this.base = base;
                        this.tintFn = tintFn;
                        this.tmpBuf = new Float32Array(base.numComps);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const tmpBuf = this.tmpBuf;
                        this.tintFn(src, srcOffset, tmpBuf, 0);
                        this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const tintFn = this.tintFn;
                        const base = this.base;
                        const scale = 1 / ((1 << bits) - 1);
                        const baseNumComps = base.numComps;
                        const usesZeroToOneRange = base.usesZeroToOneRange;
                        const isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
                        let pos = isPassthrough ? destOffset : 0;
                        const baseBuf = isPassthrough ? dest : new Uint8ClampedArray(baseNumComps * count);
                        const numComps = this.numComps;
                        const scaled = new Float32Array(numComps);
                        const tinted = new Float32Array(baseNumComps);
                        let i, j;
                        for(i = 0; i < count; i++){
                            for(j = 0; j < numComps; j++)scaled[j] = src[srcOffset++] * scale;
                            tintFn(scaled, 0, tinted, 0);
                            if (usesZeroToOneRange) for(j = 0; j < baseNumComps; j++)baseBuf[pos++] = tinted[j] * 255;
                            else {
                                base.getRgbItem(tinted, 0, baseBuf, pos);
                                pos += baseNumComps;
                            }
                        }
                        if (!isPassthrough) base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
                    }
                    getOutputLength(inputLength, alpha01) {
                        return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
                    }
                }
                class PatternCS extends ColorSpace {
                    constructor(baseCS){
                        super("Pattern", null);
                        this.base = baseCS;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        (0, _util.unreachable)("Should not call PatternCS.isDefaultDecode");
                    }
                }
                class IndexedCS extends ColorSpace {
                    constructor(base, highVal, lookup){
                        super("Indexed", 1);
                        this.base = base;
                        this.highVal = highVal;
                        const length = base.numComps * highVal;
                        this.lookup = new Uint8Array(length);
                        if (lookup instanceof _base_stream.BaseStream) {
                            const bytes = lookup.getBytes(length);
                            this.lookup.set(bytes);
                        } else if (typeof lookup === "string") for(let i = 0; i < length; ++i)this.lookup[i] = lookup.charCodeAt(i) & 0xff;
                        else throw new _util.FormatError(`IndexedCS - unrecognized lookup table: ${lookup}`);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const numComps = this.base.numComps;
                        const start = src[srcOffset] * numComps;
                        this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const base = this.base;
                        const numComps = base.numComps;
                        const outputDelta = base.getOutputLength(numComps, alpha01);
                        const lookup = this.lookup;
                        for(let i = 0; i < count; ++i){
                            const lookupPos = src[srcOffset++] * numComps;
                            base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
                            destOffset += outputDelta;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        if (!Array.isArray(decodeMap)) return true;
                        if (decodeMap.length !== 2) {
                            (0, _util.warn)("Decode map length is not correct");
                            return true;
                        }
                        if (!Number.isInteger(bpc) || bpc < 1) {
                            (0, _util.warn)("Bits per component is not correct");
                            return true;
                        }
                        return decodeMap[0] === 0 && decodeMap[1] === (1 << bpc) - 1;
                    }
                }
                class DeviceGrayCS extends ColorSpace {
                    constructor(){
                        super("DeviceGray", 1);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const c = src[srcOffset] * 255;
                        dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 255 / ((1 << bits) - 1);
                        let j = srcOffset, q = destOffset;
                        for(let i = 0; i < count; ++i){
                            const c = scale * src[j++];
                            dest[q++] = c;
                            dest[q++] = c;
                            dest[q++] = c;
                            q += alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01);
                    }
                }
                class DeviceRgbCS extends ColorSpace {
                    constructor(){
                        super("DeviceRGB", 3);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        dest[destOffset] = src[srcOffset] * 255;
                        dest[destOffset + 1] = src[srcOffset + 1] * 255;
                        dest[destOffset + 2] = src[srcOffset + 2] * 255;
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        if (bits === 8 && alpha01 === 0) {
                            dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
                            return;
                        }
                        const scale = 255 / ((1 << bits) - 1);
                        let j = srcOffset, q = destOffset;
                        for(let i = 0; i < count; ++i){
                            dest[q++] = scale * src[j++];
                            dest[q++] = scale * src[j++];
                            dest[q++] = scale * src[j++];
                            q += alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                    isPassthrough(bits) {
                        return bits === 8;
                    }
                }
                class DeviceCmykCS extends ColorSpace {
                    constructor(){
                        super("DeviceCMYK", 4);
                    }
                    #toRgb(src, srcOffset, srcScale, dest, destOffset) {
                        const c = src[srcOffset] * srcScale;
                        const m = src[srcOffset + 1] * srcScale;
                        const y = src[srcOffset + 2] * srcScale;
                        const k = src[srcOffset + 3] * srcScale;
                        dest[destOffset] = 255 + c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747);
                        dest[destOffset + 1] = 255 + c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578);
                        dest[destOffset + 2] = 255 + c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, 1, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 1 / ((1 << bits) - 1);
                        for(let i = 0; i < count; i++){
                            this.#toRgb(src, srcOffset, scale, dest, destOffset);
                            srcOffset += 4;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength / 4 * (3 + alpha01) | 0;
                    }
                }
                class CalGrayCS extends ColorSpace {
                    constructor(whitePoint, blackPoint, gamma){
                        super("CalGray", 1);
                        if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space CalGray");
                        [this.XW, this.YW, this.ZW] = whitePoint;
                        [this.XB, this.YB, this.ZB] = blackPoint || [
                            0,
                            0,
                            0
                        ];
                        this.G = gamma || 1;
                        if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new _util.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                        if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                            (0, _util.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`);
                            this.XB = this.YB = this.ZB = 0;
                        }
                        if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) (0, _util.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ` + `ZB: ${this.ZB}, only default values are supported.`);
                        if (this.G < 1) {
                            (0, _util.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`);
                            this.G = 1;
                        }
                    }
                    #toRgb(src, srcOffset, dest, destOffset, scale) {
                        const A = src[srcOffset] * scale;
                        const AG = A ** this.G;
                        const L = this.YW * AG;
                        const val = Math.max(295.8 * L ** 0.3333333333333333 - 40.8, 0);
                        dest[destOffset] = val;
                        dest[destOffset + 1] = val;
                        dest[destOffset + 2] = val;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, dest, destOffset, 1);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 1 / ((1 << bits) - 1);
                        for(let i = 0; i < count; ++i){
                            this.#toRgb(src, srcOffset, dest, destOffset, scale);
                            srcOffset += 1;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01);
                    }
                }
                class CalRGBCS extends ColorSpace {
                    static #BRADFORD_SCALE_MATRIX = new Float32Array([
                        0.8951,
                        0.2664,
                        -0.1614,
                        -0.7502,
                        1.7135,
                        0.0367,
                        0.0389,
                        -0.0685,
                        1.0296
                    ]);
                    static #BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([
                        0.9869929,
                        -0.1470543,
                        0.1599627,
                        0.4323053,
                        0.5183603,
                        0.0492912,
                        -0.0085287,
                        0.0400428,
                        0.9684867
                    ]);
                    static #SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([
                        3.2404542,
                        -1.5371385,
                        -0.4985314,
                        -0.969266,
                        1.8760108,
                        0.0415560,
                        0.0556434,
                        -0.2040259,
                        1.0572252
                    ]);
                    static #FLAT_WHITEPOINT_MATRIX = new Float32Array([
                        1,
                        1,
                        1
                    ]);
                    static #tempNormalizeMatrix = new Float32Array(3);
                    static #tempConvertMatrix1 = new Float32Array(3);
                    static #tempConvertMatrix2 = new Float32Array(3);
                    static #DECODE_L_CONSTANT = (24 / 116) ** 3 / 8.0;
                    constructor(whitePoint, blackPoint, gamma, matrix){
                        super("CalRGB", 3);
                        if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space CalRGB");
                        const [XW, YW, ZW] = this.whitePoint = whitePoint;
                        const [XB, YB, ZB] = this.blackPoint = blackPoint || new Float32Array(3);
                        [this.GR, this.GG, this.GB] = gamma || new Float32Array([
                            1,
                            1,
                            1
                        ]);
                        [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = matrix || new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]);
                        if (XW < 0 || ZW < 0 || YW !== 1) throw new _util.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                        if (XB < 0 || YB < 0 || ZB < 0) {
                            (0, _util.info)(`Invalid BlackPoint for ${this.name} [${XB}, ${YB}, ${ZB}], ` + "falling back to default.");
                            this.blackPoint = new Float32Array(3);
                        }
                        if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
                            (0, _util.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ` + `${this.name}, falling back to default.`);
                            this.GR = this.GG = this.GB = 1;
                        }
                    }
                    #matrixProduct(a, b, result) {
                        result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
                        result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
                        result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
                    }
                    #toFlat(sourceWhitePoint, LMS, result) {
                        result[0] = LMS[0] * 1 / sourceWhitePoint[0];
                        result[1] = LMS[1] * 1 / sourceWhitePoint[1];
                        result[2] = LMS[2] * 1 / sourceWhitePoint[2];
                    }
                    #toD65(sourceWhitePoint, LMS, result) {
                        const D65X = 0.95047;
                        const D65Y = 1;
                        const D65Z = 1.08883;
                        result[0] = LMS[0] * D65X / sourceWhitePoint[0];
                        result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
                        result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
                    }
                    #sRGBTransferFunction(color) {
                        if (color <= 0.0031308) return this.#adjustToRange(0, 1, 12.92 * color);
                        if (color >= 0.99554525) return 1;
                        return this.#adjustToRange(0, 1, 1.055 * color ** (1 / 2.4) - 0.055);
                    }
                    #adjustToRange(min, max, value) {
                        return Math.max(min, Math.min(max, value));
                    }
                    #decodeL(L) {
                        if (L < 0) return -this.#decodeL(-L);
                        if (L > 8.0) return ((L + 16) / 116) ** 3;
                        return L * CalRGBCS.#DECODE_L_CONSTANT;
                    }
                    #compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
                        if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
                            result[0] = XYZ_Flat[0];
                            result[1] = XYZ_Flat[1];
                            result[2] = XYZ_Flat[2];
                            return;
                        }
                        const zeroDecodeL = this.#decodeL(0);
                        const X_DST = zeroDecodeL;
                        const X_SRC = this.#decodeL(sourceBlackPoint[0]);
                        const Y_DST = zeroDecodeL;
                        const Y_SRC = this.#decodeL(sourceBlackPoint[1]);
                        const Z_DST = zeroDecodeL;
                        const Z_SRC = this.#decodeL(sourceBlackPoint[2]);
                        const X_Scale = (1 - X_DST) / (1 - X_SRC);
                        const X_Offset = 1 - X_Scale;
                        const Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
                        const Y_Offset = 1 - Y_Scale;
                        const Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
                        const Z_Offset = 1 - Z_Scale;
                        result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
                        result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
                        result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
                    }
                    #normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
                        if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
                            result[0] = XYZ_In[0];
                            result[1] = XYZ_In[1];
                            result[2] = XYZ_In[2];
                            return;
                        }
                        const LMS = result;
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                        const LMS_Flat = CalRGBCS.#tempNormalizeMatrix;
                        this.#toFlat(sourceWhitePoint, LMS, LMS_Flat);
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
                    }
                    #normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
                        const LMS = result;
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                        const LMS_D65 = CalRGBCS.#tempNormalizeMatrix;
                        this.#toD65(sourceWhitePoint, LMS, LMS_D65);
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
                    }
                    #toRgb(src, srcOffset, dest, destOffset, scale) {
                        const A = this.#adjustToRange(0, 1, src[srcOffset] * scale);
                        const B = this.#adjustToRange(0, 1, src[srcOffset + 1] * scale);
                        const C = this.#adjustToRange(0, 1, src[srcOffset + 2] * scale);
                        const AGR = A === 1 ? 1 : A ** this.GR;
                        const BGG = B === 1 ? 1 : B ** this.GG;
                        const CGB = C === 1 ? 1 : C ** this.GB;
                        const X = this.MXA * AGR + this.MXB * BGG + this.MXC * CGB;
                        const Y = this.MYA * AGR + this.MYB * BGG + this.MYC * CGB;
                        const Z = this.MZA * AGR + this.MZB * BGG + this.MZC * CGB;
                        const XYZ = CalRGBCS.#tempConvertMatrix1;
                        XYZ[0] = X;
                        XYZ[1] = Y;
                        XYZ[2] = Z;
                        const XYZ_Flat = CalRGBCS.#tempConvertMatrix2;
                        this.#normalizeWhitePointToFlat(this.whitePoint, XYZ, XYZ_Flat);
                        const XYZ_Black = CalRGBCS.#tempConvertMatrix1;
                        this.#compensateBlackPoint(this.blackPoint, XYZ_Flat, XYZ_Black);
                        const XYZ_D65 = CalRGBCS.#tempConvertMatrix2;
                        this.#normalizeWhitePointToD65(CalRGBCS.#FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
                        const SRGB = CalRGBCS.#tempConvertMatrix1;
                        this.#matrixProduct(CalRGBCS.#SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
                        dest[destOffset] = this.#sRGBTransferFunction(SRGB[0]) * 255;
                        dest[destOffset + 1] = this.#sRGBTransferFunction(SRGB[1]) * 255;
                        dest[destOffset + 2] = this.#sRGBTransferFunction(SRGB[2]) * 255;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, dest, destOffset, 1);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 1 / ((1 << bits) - 1);
                        for(let i = 0; i < count; ++i){
                            this.#toRgb(src, srcOffset, dest, destOffset, scale);
                            srcOffset += 3;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                }
                class LabCS extends ColorSpace {
                    constructor(whitePoint, blackPoint, range){
                        super("Lab", 3);
                        if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space Lab");
                        [this.XW, this.YW, this.ZW] = whitePoint;
                        [this.amin, this.amax, this.bmin, this.bmax] = range || [
                            -100,
                            100,
                            -100,
                            100
                        ];
                        [this.XB, this.YB, this.ZB] = blackPoint || [
                            0,
                            0,
                            0
                        ];
                        if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new _util.FormatError("Invalid WhitePoint components, no fallback available");
                        if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                            (0, _util.info)("Invalid BlackPoint, falling back to default");
                            this.XB = this.YB = this.ZB = 0;
                        }
                        if (this.amin > this.amax || this.bmin > this.bmax) {
                            (0, _util.info)("Invalid Range, falling back to defaults");
                            this.amin = -100;
                            this.amax = 100;
                            this.bmin = -100;
                            this.bmax = 100;
                        }
                    }
                    #fn_g(x) {
                        return x >= 6 / 29 ? x ** 3 : 108 / 841 * (x - 4 / 29);
                    }
                    #decode(value, high1, low2, high2) {
                        return low2 + value * (high2 - low2) / high1;
                    }
                    #toRgb(src, srcOffset, maxVal, dest, destOffset) {
                        let Ls = src[srcOffset];
                        let as = src[srcOffset + 1];
                        let bs = src[srcOffset + 2];
                        if (maxVal !== false) {
                            Ls = this.#decode(Ls, maxVal, 0, 100);
                            as = this.#decode(as, maxVal, this.amin, this.amax);
                            bs = this.#decode(bs, maxVal, this.bmin, this.bmax);
                        }
                        if (as > this.amax) as = this.amax;
                        else if (as < this.amin) as = this.amin;
                        if (bs > this.bmax) bs = this.bmax;
                        else if (bs < this.bmin) bs = this.bmin;
                        const M = (Ls + 16) / 116;
                        const L = M + as / 500;
                        const N = M - bs / 200;
                        const X = this.XW * this.#fn_g(L);
                        const Y = this.YW * this.#fn_g(M);
                        const Z = this.ZW * this.#fn_g(N);
                        let r, g, b;
                        if (this.ZW < 1) {
                            r = X * 3.1339 + Y * -1.617 + Z * -0.4906;
                            g = X * -0.9785 + Y * 1.916 + Z * 0.0333;
                            b = X * 0.072 + Y * -0.229 + Z * 1.4057;
                        } else {
                            r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
                            g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
                            b = X * 0.0557 + Y * -0.204 + Z * 1.057;
                        }
                        dest[destOffset] = Math.sqrt(r) * 255;
                        dest[destOffset + 1] = Math.sqrt(g) * 255;
                        dest[destOffset + 2] = Math.sqrt(b) * 255;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, false, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const maxVal = (1 << bits) - 1;
                        for(let i = 0; i < count; i++){
                            this.#toRgb(src, srcOffset, maxVal, dest, destOffset);
                            srcOffset += 3;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        return true;
                    }
                    get usesZeroToOneRange() {
                        return (0, _util.shadow)(this, "usesZeroToOneRange", false);
                    }
                }
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PartialEvaluator = exports.EvaluatorPreprocessor = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cmap = __w_pdfjs_require__(14);
                var _primitives = __w_pdfjs_require__(4);
                var _fonts = __w_pdfjs_require__(34);
                var _encodings = __w_pdfjs_require__(37);
                var _standard_fonts = __w_pdfjs_require__(41);
                var _pattern = __w_pdfjs_require__(50);
                var _xfa_fonts = __w_pdfjs_require__(51);
                var _to_unicode_map = __w_pdfjs_require__(42);
                var _function = __w_pdfjs_require__(57);
                var _parser = __w_pdfjs_require__(16);
                var _image_utils = __w_pdfjs_require__(59);
                var _stream = __w_pdfjs_require__(8);
                var _base_stream = __w_pdfjs_require__(5);
                var _bidi = __w_pdfjs_require__(60);
                var _colorspace = __w_pdfjs_require__(12);
                var _decode_stream = __w_pdfjs_require__(18);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _font_substitutions = __w_pdfjs_require__(61);
                var _glyphlist = __w_pdfjs_require__(39);
                var _metrics = __w_pdfjs_require__(45);
                var _unicode = __w_pdfjs_require__(40);
                var _image_resizer = __w_pdfjs_require__(62);
                var _murmurhash = __w_pdfjs_require__(63);
                var _operator_list = __w_pdfjs_require__(64);
                var _image = __w_pdfjs_require__(65);
                const DefaultPartialEvaluatorOptions = Object.freeze({
                    maxImageSize: -1,
                    disableFontFace: false,
                    ignoreErrors: false,
                    isEvalSupported: true,
                    isOffscreenCanvasSupported: false,
                    canvasMaxAreaInBytes: -1,
                    fontExtraProperties: false,
                    useSystemFonts: true,
                    cMapUrl: null,
                    standardFontDataUrl: null
                });
                const PatternType = {
                    TILING: 1,
                    SHADING: 2
                };
                const TEXT_CHUNK_BATCH_SIZE = 10;
                const deferred = Promise.resolve();
                function normalizeBlendMode(value, parsingArray = false) {
                    if (Array.isArray(value)) {
                        for (const val of value){
                            const maybeBM = normalizeBlendMode(val, true);
                            if (maybeBM) return maybeBM;
                        }
                        (0, _util.warn)(`Unsupported blend mode Array: ${value}`);
                        return "source-over";
                    }
                    if (!(value instanceof _primitives.Name)) {
                        if (parsingArray) return null;
                        return "source-over";
                    }
                    switch(value.name){
                        case "Normal":
                        case "Compatible":
                            return "source-over";
                        case "Multiply":
                            return "multiply";
                        case "Screen":
                            return "screen";
                        case "Overlay":
                            return "overlay";
                        case "Darken":
                            return "darken";
                        case "Lighten":
                            return "lighten";
                        case "ColorDodge":
                            return "color-dodge";
                        case "ColorBurn":
                            return "color-burn";
                        case "HardLight":
                            return "hard-light";
                        case "SoftLight":
                            return "soft-light";
                        case "Difference":
                            return "difference";
                        case "Exclusion":
                            return "exclusion";
                        case "Hue":
                            return "hue";
                        case "Saturation":
                            return "saturation";
                        case "Color":
                            return "color";
                        case "Luminosity":
                            return "luminosity";
                    }
                    if (parsingArray) return null;
                    (0, _util.warn)(`Unsupported blend mode: ${value.name}`);
                    return "source-over";
                }
                function incrementCachedImageMaskCount(data) {
                    if (data.fn === _util.OPS.paintImageMaskXObject && data.args[0]?.count > 0) data.args[0].count++;
                }
                class TimeSlotManager {
                    static TIME_SLOT_DURATION_MS = 20;
                    static CHECK_TIME_EVERY = 100;
                    constructor(){
                        this.reset();
                    }
                    check() {
                        if (++this.checked < TimeSlotManager.CHECK_TIME_EVERY) return false;
                        this.checked = 0;
                        return this.endTime <= Date.now();
                    }
                    reset() {
                        this.endTime = Date.now() + TimeSlotManager.TIME_SLOT_DURATION_MS;
                        this.checked = 0;
                    }
                }
                class PartialEvaluator {
                    constructor({ xref: xref, handler: handler, pageIndex: pageIndex, idFactory: idFactory, fontCache: fontCache, builtInCMapCache: builtInCMapCache, standardFontDataCache: standardFontDataCache, globalImageCache: globalImageCache, systemFontCache: systemFontCache, options: options = null }){
                        this.xref = xref;
                        this.handler = handler;
                        this.pageIndex = pageIndex;
                        this.idFactory = idFactory;
                        this.fontCache = fontCache;
                        this.builtInCMapCache = builtInCMapCache;
                        this.standardFontDataCache = standardFontDataCache;
                        this.globalImageCache = globalImageCache;
                        this.systemFontCache = systemFontCache;
                        this.options = options || DefaultPartialEvaluatorOptions;
                        this.parsingType3Font = false;
                        this._regionalImageCache = new _image_utils.RegionalImageCache();
                        this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this);
                        _image_resizer.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
                    }
                    get _pdfFunctionFactory() {
                        const pdfFunctionFactory = new _function.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.options.isEvalSupported
                        });
                        return (0, _util.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                    }
                    clone(newOptions = null) {
                        const newEvaluator = Object.create(this);
                        newEvaluator.options = Object.assign(Object.create(null), this.options, newOptions);
                        return newEvaluator;
                    }
                    hasBlendModes(resources, nonBlendModesSet) {
                        if (!(resources instanceof _primitives.Dict)) return false;
                        if (resources.objId && nonBlendModesSet.has(resources.objId)) return false;
                        const processed = new _primitives.RefSet(nonBlendModesSet);
                        if (resources.objId) processed.put(resources.objId);
                        const nodes = [
                            resources
                        ], xref = this.xref;
                        while(nodes.length){
                            const node = nodes.shift();
                            const graphicStates = node.get("ExtGState");
                            if (graphicStates instanceof _primitives.Dict) for (let graphicState of graphicStates.getRawValues()){
                                if (graphicState instanceof _primitives.Ref) {
                                    if (processed.has(graphicState)) continue;
                                    try {
                                        graphicState = xref.fetch(graphicState);
                                    } catch (ex) {
                                        processed.put(graphicState);
                                        (0, _util.info)(`hasBlendModes - ignoring ExtGState: "${ex}".`);
                                        continue;
                                    }
                                }
                                if (!(graphicState instanceof _primitives.Dict)) continue;
                                if (graphicState.objId) processed.put(graphicState.objId);
                                const bm = graphicState.get("BM");
                                if (bm instanceof _primitives.Name) {
                                    if (bm.name !== "Normal") return true;
                                    continue;
                                }
                                if (bm !== undefined && Array.isArray(bm)) for (const element of bm){
                                    if (element instanceof _primitives.Name && element.name !== "Normal") return true;
                                }
                            }
                            const xObjects = node.get("XObject");
                            if (!(xObjects instanceof _primitives.Dict)) continue;
                            for (let xObject of xObjects.getRawValues()){
                                if (xObject instanceof _primitives.Ref) {
                                    if (processed.has(xObject)) continue;
                                    try {
                                        xObject = xref.fetch(xObject);
                                    } catch (ex) {
                                        processed.put(xObject);
                                        (0, _util.info)(`hasBlendModes - ignoring XObject: "${ex}".`);
                                        continue;
                                    }
                                }
                                if (!(xObject instanceof _base_stream.BaseStream)) continue;
                                if (xObject.dict.objId) processed.put(xObject.dict.objId);
                                const xResources = xObject.dict.get("Resources");
                                if (!(xResources instanceof _primitives.Dict)) continue;
                                if (xResources.objId && processed.has(xResources.objId)) continue;
                                nodes.push(xResources);
                                if (xResources.objId) processed.put(xResources.objId);
                            }
                        }
                        for (const ref of processed)nonBlendModesSet.put(ref);
                        return false;
                    }
                    async fetchBuiltInCMap(name) {
                        const cachedData = this.builtInCMapCache.get(name);
                        if (cachedData) return cachedData;
                        let data;
                        if (this.options.cMapUrl !== null) {
                            const url = `${this.options.cMapUrl}${name}.bcmap`;
                            const response = await fetch(url);
                            if (!response.ok) throw new Error(`fetchBuiltInCMap: failed to fetch file "${url}" with "${response.statusText}".`);
                            data = {
                                cMapData: new Uint8Array(await response.arrayBuffer()),
                                compressionType: _util.CMapCompressionType.BINARY
                            };
                        } else data = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                            name: name
                        });
                        if (data.compressionType !== _util.CMapCompressionType.NONE) this.builtInCMapCache.set(name, data);
                        return data;
                    }
                    async fetchStandardFontData(name) {
                        const cachedData = this.standardFontDataCache.get(name);
                        if (cachedData) return new _stream.Stream(cachedData);
                        if (this.options.useSystemFonts && name !== "Symbol" && name !== "ZapfDingbats") return null;
                        const standardFontNameToFileName = (0, _standard_fonts.getFontNameToFileMap)(), filename = standardFontNameToFileName[name];
                        let data;
                        if (this.options.standardFontDataUrl !== null) {
                            const url = `${this.options.standardFontDataUrl}${filename}`;
                            const response = await fetch(url);
                            if (!response.ok) (0, _util.warn)(`fetchStandardFontData: failed to fetch file "${url}" with "${response.statusText}".`);
                            else data = await response.arrayBuffer();
                        } else try {
                            data = await this.handler.sendWithPromise("FetchStandardFontData", {
                                filename: filename
                            });
                        } catch (e) {
                            (0, _util.warn)(`fetchStandardFontData: failed to fetch file "${filename}" with "${e}".`);
                        }
                        if (!data) return null;
                        this.standardFontDataCache.set(name, data);
                        return new _stream.Stream(data);
                    }
                    async buildFormXObject(resources, xobj, smask, operatorList, task, initialState, localColorSpaceCache) {
                        const dict = xobj.dict;
                        const matrix = dict.getArray("Matrix");
                        let bbox = dict.getArray("BBox");
                        bbox = Array.isArray(bbox) && bbox.length === 4 ? _util.Util.normalizeRect(bbox) : null;
                        let optionalContent, groupOptions;
                        if (dict.has("OC")) optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                        if (optionalContent !== undefined) operatorList.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        const group = dict.get("Group");
                        if (group) {
                            groupOptions = {
                                matrix: matrix,
                                bbox: bbox,
                                smask: smask,
                                isolated: false,
                                knockout: false
                            };
                            const groupSubtype = group.get("S");
                            let colorSpace = null;
                            if ((0, _primitives.isName)(groupSubtype, "Transparency")) {
                                groupOptions.isolated = group.get("I") || false;
                                groupOptions.knockout = group.get("K") || false;
                                if (group.has("CS")) {
                                    const cs = group.getRaw("CS");
                                    const cachedColorSpace = _colorspace.ColorSpace.getCached(cs, this.xref, localColorSpaceCache);
                                    if (cachedColorSpace) colorSpace = cachedColorSpace;
                                    else colorSpace = await this.parseColorSpace({
                                        cs: cs,
                                        resources: resources,
                                        localColorSpaceCache: localColorSpaceCache
                                    });
                                }
                            }
                            if (smask?.backdrop) {
                                colorSpace ||= _colorspace.ColorSpace.singletons.rgb;
                                smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
                            }
                            operatorList.addOp(_util.OPS.beginGroup, [
                                groupOptions
                            ]);
                        }
                        const args = group ? [
                            matrix,
                            null
                        ] : [
                            matrix,
                            bbox
                        ];
                        operatorList.addOp(_util.OPS.paintFormXObjectBegin, args);
                        return this.getOperatorList({
                            stream: xobj,
                            task: task,
                            resources: dict.get("Resources") || resources,
                            operatorList: operatorList,
                            initialState: initialState
                        }).then(function() {
                            operatorList.addOp(_util.OPS.paintFormXObjectEnd, []);
                            if (group) operatorList.addOp(_util.OPS.endGroup, [
                                groupOptions
                            ]);
                            if (optionalContent !== undefined) operatorList.addOp(_util.OPS.endMarkedContent, []);
                        });
                    }
                    _sendImgData(objId, imgData, cacheGlobally = false) {
                        const transfers = imgData ? [
                            imgData.bitmap || imgData.data.buffer
                        ] : null;
                        if (this.parsingType3Font || cacheGlobally) return this.handler.send("commonobj", [
                            objId,
                            "Image",
                            imgData
                        ], transfers);
                        return this.handler.send("obj", [
                            objId,
                            this.pageIndex,
                            "Image",
                            imgData
                        ], transfers);
                    }
                    async buildPaintImageXObject({ resources: resources, image: image, isInline: isInline = false, operatorList: operatorList, cacheKey: cacheKey, localImageCache: localImageCache, localColorSpaceCache: localColorSpaceCache }) {
                        const dict = image.dict;
                        const imageRef = dict.objId;
                        const w = dict.get("W", "Width");
                        const h = dict.get("H", "Height");
                        if (!(w && typeof w === "number") || !(h && typeof h === "number")) {
                            (0, _util.warn)("Image dimensions are missing, or not numbers.");
                            return;
                        }
                        const maxImageSize = this.options.maxImageSize;
                        if (maxImageSize !== -1 && w * h > maxImageSize) {
                            const msg = "Image exceeded maximum allowed size and was removed.";
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(msg);
                                return;
                            }
                            throw new Error(msg);
                        }
                        let optionalContent;
                        if (dict.has("OC")) optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                        const imageMask = dict.get("IM", "ImageMask") || false;
                        let imgData, args;
                        if (imageMask) {
                            const interpolate = dict.get("I", "Interpolate");
                            const bitStrideLength = w + 7 >> 3;
                            const imgArray = image.getBytes(bitStrideLength * h);
                            const decode = dict.getArray("D", "Decode");
                            if (this.parsingType3Font) {
                                imgData = _image.PDFImage.createRawMask({
                                    imgArray: imgArray,
                                    width: w,
                                    height: h,
                                    imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                                    inverseDecode: decode?.[0] > 0,
                                    interpolate: interpolate
                                });
                                imgData.cached = !!cacheKey;
                                args = [
                                    imgData
                                ];
                                operatorList.addImageOps(_util.OPS.paintImageMaskXObject, args, optionalContent);
                                if (cacheKey) {
                                    const cacheData = {
                                        fn: _util.OPS.paintImageMaskXObject,
                                        args: args,
                                        optionalContent: optionalContent
                                    };
                                    localImageCache.set(cacheKey, imageRef, cacheData);
                                    if (imageRef) this._regionalImageCache.set(null, imageRef, cacheData);
                                }
                                return;
                            }
                            imgData = await _image.PDFImage.createMask({
                                imgArray: imgArray,
                                width: w,
                                height: h,
                                imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                                inverseDecode: decode?.[0] > 0,
                                interpolate: interpolate,
                                isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                            });
                            if (imgData.isSingleOpaquePixel) {
                                operatorList.addImageOps(_util.OPS.paintSolidColorImageMask, [], optionalContent);
                                if (cacheKey) {
                                    const cacheData = {
                                        fn: _util.OPS.paintSolidColorImageMask,
                                        args: [],
                                        optionalContent: optionalContent
                                    };
                                    localImageCache.set(cacheKey, imageRef, cacheData);
                                    if (imageRef) this._regionalImageCache.set(null, imageRef, cacheData);
                                }
                                return;
                            }
                            const objId = `mask_${this.idFactory.createObjId()}`;
                            operatorList.addDependency(objId);
                            this._sendImgData(objId, imgData);
                            args = [
                                {
                                    data: objId,
                                    width: imgData.width,
                                    height: imgData.height,
                                    interpolate: imgData.interpolate,
                                    count: 1
                                }
                            ];
                            operatorList.addImageOps(_util.OPS.paintImageMaskXObject, args, optionalContent);
                            if (cacheKey) {
                                const cacheData = {
                                    fn: _util.OPS.paintImageMaskXObject,
                                    args: args,
                                    optionalContent: optionalContent
                                };
                                localImageCache.set(cacheKey, imageRef, cacheData);
                                if (imageRef) this._regionalImageCache.set(null, imageRef, cacheData);
                            }
                            return;
                        }
                        const SMALL_IMAGE_DIMENSIONS = 200;
                        if (isInline && !dict.has("SMask") && !dict.has("Mask") && w + h < SMALL_IMAGE_DIMENSIONS) {
                            const imageObj = new _image.PDFImage({
                                xref: this.xref,
                                res: resources,
                                image: image,
                                isInline: isInline,
                                pdfFunctionFactory: this._pdfFunctionFactory,
                                localColorSpaceCache: localColorSpaceCache
                            });
                            imgData = await imageObj.createImageData(true, false);
                            operatorList.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported;
                            operatorList.addImageOps(_util.OPS.paintInlineImageXObject, [
                                imgData
                            ], optionalContent);
                            return;
                        }
                        let objId = `img_${this.idFactory.createObjId()}`, cacheGlobally = false;
                        if (this.parsingType3Font) objId = `${this.idFactory.getDocId()}_type3_${objId}`;
                        else if (imageRef) {
                            cacheGlobally = this.globalImageCache.shouldCache(imageRef, this.pageIndex);
                            if (cacheGlobally) objId = `${this.idFactory.getDocId()}_${objId}`;
                        }
                        operatorList.addDependency(objId);
                        args = [
                            objId,
                            w,
                            h
                        ];
                        _image.PDFImage.buildImage({
                            xref: this.xref,
                            res: resources,
                            image: image,
                            isInline: isInline,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        }).then(async (imageObj)=>{
                            imgData = await imageObj.createImageData(false, this.options.isOffscreenCanvasSupported);
                            if (cacheKey && imageRef && cacheGlobally) {
                                const length = imgData.bitmap ? imgData.width * imgData.height * 4 : imgData.data.length;
                                this.globalImageCache.addByteSize(imageRef, length);
                            }
                            return this._sendImgData(objId, imgData, cacheGlobally);
                        }).catch((reason)=>{
                            (0, _util.warn)(`Unable to decode image "${objId}": "${reason}".`);
                            return this._sendImgData(objId, null, cacheGlobally);
                        });
                        operatorList.addImageOps(_util.OPS.paintImageXObject, args, optionalContent);
                        if (cacheKey) {
                            const cacheData = {
                                fn: _util.OPS.paintImageXObject,
                                args: args,
                                optionalContent: optionalContent
                            };
                            localImageCache.set(cacheKey, imageRef, cacheData);
                            if (imageRef) {
                                this._regionalImageCache.set(null, imageRef, cacheData);
                                if (cacheGlobally) {
                                    (0, _util.assert)(!isInline, "Cannot cache an inline image globally.");
                                    this.globalImageCache.setData(imageRef, {
                                        objId: objId,
                                        fn: _util.OPS.paintImageXObject,
                                        args: args,
                                        optionalContent: optionalContent,
                                        byteSize: 0
                                    });
                                }
                            }
                        }
                    }
                    handleSMask(smask, resources, operatorList, task, stateManager, localColorSpaceCache) {
                        const smaskContent = smask.get("G");
                        const smaskOptions = {
                            subtype: smask.get("S").name,
                            backdrop: smask.get("BC")
                        };
                        const transferObj = smask.get("TR");
                        if ((0, _function.isPDFFunction)(transferObj)) {
                            const transferFn = this._pdfFunctionFactory.create(transferObj);
                            const transferMap = new Uint8Array(256);
                            const tmp = new Float32Array(1);
                            for(let i = 0; i < 256; i++){
                                tmp[0] = i / 255;
                                transferFn(tmp, 0, tmp, 0);
                                transferMap[i] = tmp[0] * 255 | 0;
                            }
                            smaskOptions.transferMap = transferMap;
                        }
                        return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone(), localColorSpaceCache);
                    }
                    handleTransferFunction(tr) {
                        let transferArray;
                        if (Array.isArray(tr)) transferArray = tr;
                        else if ((0, _function.isPDFFunction)(tr)) transferArray = [
                            tr
                        ];
                        else return null;
                        const transferMaps = [];
                        let numFns = 0, numEffectfulFns = 0;
                        for (const entry of transferArray){
                            const transferObj = this.xref.fetchIfRef(entry);
                            numFns++;
                            if ((0, _primitives.isName)(transferObj, "Identity")) {
                                transferMaps.push(null);
                                continue;
                            } else if (!(0, _function.isPDFFunction)(transferObj)) return null;
                            const transferFn = this._pdfFunctionFactory.create(transferObj);
                            const transferMap = new Uint8Array(256), tmp = new Float32Array(1);
                            for(let j = 0; j < 256; j++){
                                tmp[0] = j / 255;
                                transferFn(tmp, 0, tmp, 0);
                                transferMap[j] = tmp[0] * 255 | 0;
                            }
                            transferMaps.push(transferMap);
                            numEffectfulFns++;
                        }
                        if (!(numFns === 1 || numFns === 4)) return null;
                        if (numEffectfulFns === 0) return null;
                        return transferMaps;
                    }
                    handleTilingType(fn, color, resources, pattern, patternDict, operatorList, task, localTilingPatternCache) {
                        const tilingOpList = new _operator_list.OperatorList();
                        const patternResources = _primitives.Dict.merge({
                            xref: this.xref,
                            dictArray: [
                                patternDict.get("Resources"),
                                resources
                            ]
                        });
                        return this.getOperatorList({
                            stream: pattern,
                            task: task,
                            resources: patternResources,
                            operatorList: tilingOpList
                        }).then(function() {
                            const operatorListIR = tilingOpList.getIR();
                            const tilingPatternIR = (0, _pattern.getTilingPatternIR)(operatorListIR, patternDict, color);
                            operatorList.addDependencies(tilingOpList.dependencies);
                            operatorList.addOp(fn, tilingPatternIR);
                            if (patternDict.objId) localTilingPatternCache.set(null, patternDict.objId, {
                                operatorListIR: operatorListIR,
                                dict: patternDict
                            });
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`handleTilingType - ignoring pattern: "${reason}".`);
                                return;
                            }
                            throw reason;
                        });
                    }
                    handleSetFont(resources, fontArgs, fontRef, operatorList, task, state, fallbackFontDict = null, cssFontInfo = null) {
                        const fontName = fontArgs?.[0] instanceof _primitives.Name ? fontArgs[0].name : null;
                        return this.loadFont(fontName, fontRef, resources, fallbackFontDict, cssFontInfo).then((translated)=>{
                            if (!translated.font.isType3Font) return translated;
                            return translated.loadType3Data(this, resources, task).then(function() {
                                operatorList.addDependencies(translated.type3Dependencies);
                                return translated;
                            }).catch((reason)=>{
                                return new TranslatedFont({
                                    loadedName: "g_font_error",
                                    font: new _fonts.ErrorFont(`Type3 font load error: ${reason}`),
                                    dict: translated.font,
                                    evaluatorOptions: this.options
                                });
                            });
                        }).then((translated)=>{
                            state.font = translated.font;
                            translated.send(this.handler);
                            return translated.loadedName;
                        });
                    }
                    handleText(chars, state) {
                        const font1 = state.font;
                        const glyphs = font1.charsToGlyphs(chars);
                        if (font1.data) {
                            const isAddToPathSet = !!(state.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                            if (isAddToPathSet || state.fillColorSpace.name === "Pattern" || font1.disableFontFace || this.options.disableFontFace) PartialEvaluator.buildFontPaths(font1, glyphs, this.handler, this.options);
                        }
                        return glyphs;
                    }
                    ensureStateFont(state) {
                        if (state.font) return;
                        const reason = new _util.FormatError("Missing setFont (Tf) operator before text rendering operator.");
                        if (this.options.ignoreErrors) {
                            (0, _util.warn)(`ensureStateFont: "${reason}".`);
                            return;
                        }
                        throw reason;
                    }
                    async setGState({ resources: resources, gState: gState, operatorList: operatorList, cacheKey: cacheKey, task: task, stateManager: stateManager, localGStateCache: localGStateCache, localColorSpaceCache: localColorSpaceCache }) {
                        const gStateRef = gState.objId;
                        let isSimpleGState = true;
                        const gStateObj = [];
                        let promise = Promise.resolve();
                        for (const key of gState.getKeys()){
                            const value = gState.get(key);
                            switch(key){
                                case "Type":
                                    break;
                                case "LW":
                                case "LC":
                                case "LJ":
                                case "ML":
                                case "D":
                                case "RI":
                                case "FL":
                                case "CA":
                                case "ca":
                                    gStateObj.push([
                                        key,
                                        value
                                    ]);
                                    break;
                                case "Font":
                                    isSimpleGState = false;
                                    promise = promise.then(()=>{
                                        return this.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function(loadedName) {
                                            operatorList.addDependency(loadedName);
                                            gStateObj.push([
                                                key,
                                                [
                                                    loadedName,
                                                    value[1]
                                                ]
                                            ]);
                                        });
                                    });
                                    break;
                                case "BM":
                                    gStateObj.push([
                                        key,
                                        normalizeBlendMode(value)
                                    ]);
                                    break;
                                case "SMask":
                                    if ((0, _primitives.isName)(value, "None")) {
                                        gStateObj.push([
                                            key,
                                            false
                                        ]);
                                        break;
                                    }
                                    if (value instanceof _primitives.Dict) {
                                        isSimpleGState = false;
                                        promise = promise.then(()=>{
                                            return this.handleSMask(value, resources, operatorList, task, stateManager, localColorSpaceCache);
                                        });
                                        gStateObj.push([
                                            key,
                                            true
                                        ]);
                                    } else (0, _util.warn)("Unsupported SMask type");
                                    break;
                                case "TR":
                                    const transferMaps = this.handleTransferFunction(value);
                                    gStateObj.push([
                                        key,
                                        transferMaps
                                    ]);
                                    break;
                                case "OP":
                                case "op":
                                case "OPM":
                                case "BG":
                                case "BG2":
                                case "UCR":
                                case "UCR2":
                                case "TR2":
                                case "HT":
                                case "SM":
                                case "SA":
                                case "AIS":
                                case "TK":
                                    (0, _util.info)("graphic state operator " + key);
                                    break;
                                default:
                                    (0, _util.info)("Unknown graphic state operator " + key);
                                    break;
                            }
                        }
                        return promise.then(function() {
                            if (gStateObj.length > 0) operatorList.addOp(_util.OPS.setGState, [
                                gStateObj
                            ]);
                            if (isSimpleGState) localGStateCache.set(cacheKey, gStateRef, gStateObj);
                        });
                    }
                    loadFont(fontName, font1, resources, fallbackFontDict = null, cssFontInfo = null) {
                        const errorFont = async ()=>{
                            return new TranslatedFont({
                                loadedName: "g_font_error",
                                font: new _fonts.ErrorFont(`Font "${fontName}" is not available.`),
                                dict: font1,
                                evaluatorOptions: this.options
                            });
                        };
                        let fontRef;
                        if (font1) {
                            if (font1 instanceof _primitives.Ref) fontRef = font1;
                        } else {
                            const fontRes = resources.get("Font");
                            if (fontRes) fontRef = fontRes.getRaw(fontName);
                        }
                        if (fontRef) {
                            if (this.parsingType3Font && this.type3FontRefs.has(fontRef)) return errorFont();
                            if (this.fontCache.has(fontRef)) return this.fontCache.get(fontRef);
                            font1 = this.xref.fetchIfRef(fontRef);
                        }
                        if (!(font1 instanceof _primitives.Dict)) {
                            if (!this.options.ignoreErrors && !this.parsingType3Font) {
                                (0, _util.warn)(`Font "${fontName}" is not available.`);
                                return errorFont();
                            }
                            (0, _util.warn)(`Font "${fontName}" is not available -- attempting to fallback to a default font.`);
                            font1 = fallbackFontDict || PartialEvaluator.fallbackFontDict;
                        }
                        if (font1.cacheKey && this.fontCache.has(font1.cacheKey)) return this.fontCache.get(font1.cacheKey);
                        const fontCapability = new _util.PromiseCapability();
                        let preEvaluatedFont;
                        try {
                            preEvaluatedFont = this.preEvaluateFont(font1);
                            preEvaluatedFont.cssFontInfo = cssFontInfo;
                        } catch (reason) {
                            (0, _util.warn)(`loadFont - preEvaluateFont failed: "${reason}".`);
                            return errorFont();
                        }
                        const { descriptor: descriptor, hash: hash } = preEvaluatedFont;
                        const fontRefIsRef = fontRef instanceof _primitives.Ref;
                        let fontID;
                        if (hash && descriptor instanceof _primitives.Dict) {
                            const fontAliases = descriptor.fontAliases ||= Object.create(null);
                            if (fontAliases[hash]) {
                                const aliasFontRef = fontAliases[hash].aliasRef;
                                if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
                                    this.fontCache.putAlias(fontRef, aliasFontRef);
                                    return this.fontCache.get(fontRef);
                                }
                            } else fontAliases[hash] = {
                                fontID: this.idFactory.createFontId()
                            };
                            if (fontRefIsRef) fontAliases[hash].aliasRef = fontRef;
                            fontID = fontAliases[hash].fontID;
                        } else fontID = this.idFactory.createFontId();
                        (0, _util.assert)(fontID?.startsWith("f"), 'The "fontID" must be (correctly) defined.');
                        if (fontRefIsRef) this.fontCache.put(fontRef, fontCapability.promise);
                        else {
                            font1.cacheKey = `cacheKey_${fontID}`;
                            this.fontCache.put(font1.cacheKey, fontCapability.promise);
                        }
                        font1.loadedName = `${this.idFactory.getDocId()}_${fontID}`;
                        this.translateFont(preEvaluatedFont).then((translatedFont)=>{
                            fontCapability.resolve(new TranslatedFont({
                                loadedName: font1.loadedName,
                                font: translatedFont,
                                dict: font1,
                                evaluatorOptions: this.options
                            }));
                        }).catch((reason)=>{
                            (0, _util.warn)(`loadFont - translateFont failed: "${reason}".`);
                            fontCapability.resolve(new TranslatedFont({
                                loadedName: font1.loadedName,
                                font: new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason),
                                dict: font1,
                                evaluatorOptions: this.options
                            }));
                        });
                        return fontCapability.promise;
                    }
                    buildPath(operatorList, fn, args, parsingText = false) {
                        const lastIndex = operatorList.length - 1;
                        if (!args) args = [];
                        if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util.OPS.constructPath) {
                            if (parsingText) {
                                (0, _util.warn)(`Encountered path operator "${fn}" inside of a text object.`);
                                operatorList.addOp(_util.OPS.save, null);
                            }
                            let minMax;
                            switch(fn){
                                case _util.OPS.rectangle:
                                    const x = args[0] + args[2];
                                    const y = args[1] + args[3];
                                    minMax = [
                                        Math.min(args[0], x),
                                        Math.max(args[0], x),
                                        Math.min(args[1], y),
                                        Math.max(args[1], y)
                                    ];
                                    break;
                                case _util.OPS.moveTo:
                                case _util.OPS.lineTo:
                                    minMax = [
                                        args[0],
                                        args[0],
                                        args[1],
                                        args[1]
                                    ];
                                    break;
                                default:
                                    minMax = [
                                        Infinity,
                                        -Infinity,
                                        Infinity,
                                        -Infinity
                                    ];
                                    break;
                            }
                            operatorList.addOp(_util.OPS.constructPath, [
                                [
                                    fn
                                ],
                                args,
                                minMax
                            ]);
                            if (parsingText) operatorList.addOp(_util.OPS.restore, null);
                        } else {
                            const opArgs = operatorList.argsArray[lastIndex];
                            opArgs[0].push(fn);
                            opArgs[1].push(...args);
                            const minMax = opArgs[2];
                            switch(fn){
                                case _util.OPS.rectangle:
                                    const x = args[0] + args[2];
                                    const y = args[1] + args[3];
                                    minMax[0] = Math.min(minMax[0], args[0], x);
                                    minMax[1] = Math.max(minMax[1], args[0], x);
                                    minMax[2] = Math.min(minMax[2], args[1], y);
                                    minMax[3] = Math.max(minMax[3], args[1], y);
                                    break;
                                case _util.OPS.moveTo:
                                case _util.OPS.lineTo:
                                    minMax[0] = Math.min(minMax[0], args[0]);
                                    minMax[1] = Math.max(minMax[1], args[0]);
                                    minMax[2] = Math.min(minMax[2], args[1]);
                                    minMax[3] = Math.max(minMax[3], args[1]);
                                    break;
                            }
                        }
                    }
                    parseColorSpace({ cs: cs, resources: resources, localColorSpaceCache: localColorSpaceCache }) {
                        return _colorspace.ColorSpace.parseAsync({
                            cs: cs,
                            xref: this.xref,
                            resources: resources,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`parseColorSpace - ignoring ColorSpace: "${reason}".`);
                                return null;
                            }
                            throw reason;
                        });
                    }
                    parseShading({ shading: shading, resources: resources, localColorSpaceCache: localColorSpaceCache, localShadingPatternCache: localShadingPatternCache }) {
                        let id = localShadingPatternCache.get(shading);
                        if (!id) {
                            var shadingFill = _pattern.Pattern.parseShading(shading, this.xref, resources, this._pdfFunctionFactory, localColorSpaceCache);
                            const patternIR = shadingFill.getIR();
                            id = `pattern_${this.idFactory.createObjId()}`;
                            if (this.parsingType3Font) id = `${this.idFactory.getDocId()}_type3_${id}`;
                            localShadingPatternCache.set(shading, id);
                            if (this.parsingType3Font) this.handler.send("commonobj", [
                                id,
                                "Pattern",
                                patternIR
                            ]);
                            else this.handler.send("obj", [
                                id,
                                this.pageIndex,
                                "Pattern",
                                patternIR
                            ]);
                        }
                        return id;
                    }
                    handleColorN(operatorList, fn, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache) {
                        const patternName = args.pop();
                        if (patternName instanceof _primitives.Name) {
                            const rawPattern = patterns.getRaw(patternName.name);
                            const localTilingPattern = rawPattern instanceof _primitives.Ref && localTilingPatternCache.getByRef(rawPattern);
                            if (localTilingPattern) try {
                                const color = cs.base ? cs.base.getRgb(args, 0) : null;
                                const tilingPatternIR = (0, _pattern.getTilingPatternIR)(localTilingPattern.operatorListIR, localTilingPattern.dict, color);
                                operatorList.addOp(fn, tilingPatternIR);
                                return undefined;
                            } catch  {}
                            const pattern = this.xref.fetchIfRef(rawPattern);
                            if (pattern) {
                                const dict = pattern instanceof _base_stream.BaseStream ? pattern.dict : pattern;
                                const typeNum = dict.get("PatternType");
                                if (typeNum === PatternType.TILING) {
                                    const color = cs.base ? cs.base.getRgb(args, 0) : null;
                                    return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task, localTilingPatternCache);
                                } else if (typeNum === PatternType.SHADING) {
                                    const shading = dict.get("Shading");
                                    const matrix = dict.getArray("Matrix");
                                    const objId = this.parseShading({
                                        shading: shading,
                                        resources: resources,
                                        localColorSpaceCache: localColorSpaceCache,
                                        localShadingPatternCache: localShadingPatternCache
                                    });
                                    operatorList.addOp(fn, [
                                        "Shading",
                                        objId,
                                        matrix
                                    ]);
                                    return undefined;
                                }
                                throw new _util.FormatError(`Unknown PatternType: ${typeNum}`);
                            }
                        }
                        throw new _util.FormatError(`Unknown PatternName: ${patternName}`);
                    }
                    _parseVisibilityExpression(array, nestingCounter, currentResult) {
                        const MAX_NESTING = 10;
                        if (++nestingCounter > MAX_NESTING) {
                            (0, _util.warn)("Visibility expression is too deeply nested");
                            return;
                        }
                        const length = array.length;
                        const operator = this.xref.fetchIfRef(array[0]);
                        if (length < 2 || !(operator instanceof _primitives.Name)) {
                            (0, _util.warn)("Invalid visibility expression");
                            return;
                        }
                        switch(operator.name){
                            case "And":
                            case "Or":
                            case "Not":
                                currentResult.push(operator.name);
                                break;
                            default:
                                (0, _util.warn)(`Invalid operator ${operator.name} in visibility expression`);
                                return;
                        }
                        for(let i = 1; i < length; i++){
                            const raw = array[i];
                            const object = this.xref.fetchIfRef(raw);
                            if (Array.isArray(object)) {
                                const nestedResult = [];
                                currentResult.push(nestedResult);
                                this._parseVisibilityExpression(object, nestingCounter, nestedResult);
                            } else if (raw instanceof _primitives.Ref) currentResult.push(raw.toString());
                        }
                    }
                    async parseMarkedContentProps(contentProperties, resources) {
                        let optionalContent;
                        if (contentProperties instanceof _primitives.Name) {
                            const properties = resources.get("Properties");
                            optionalContent = properties.get(contentProperties.name);
                        } else if (contentProperties instanceof _primitives.Dict) optionalContent = contentProperties;
                        else throw new _util.FormatError("Optional content properties malformed.");
                        const optionalContentType = optionalContent.get("Type")?.name;
                        if (optionalContentType === "OCG") return {
                            type: optionalContentType,
                            id: optionalContent.objId
                        };
                        else if (optionalContentType === "OCMD") {
                            const expression = optionalContent.get("VE");
                            if (Array.isArray(expression)) {
                                const result = [];
                                this._parseVisibilityExpression(expression, 0, result);
                                if (result.length > 0) return {
                                    type: "OCMD",
                                    expression: result
                                };
                            }
                            const optionalContentGroups = optionalContent.get("OCGs");
                            if (Array.isArray(optionalContentGroups) || optionalContentGroups instanceof _primitives.Dict) {
                                const groupIds = [];
                                if (Array.isArray(optionalContentGroups)) for (const ocg of optionalContentGroups)groupIds.push(ocg.toString());
                                else groupIds.push(optionalContentGroups.objId);
                                return {
                                    type: optionalContentType,
                                    ids: groupIds,
                                    policy: optionalContent.get("P") instanceof _primitives.Name ? optionalContent.get("P").name : null,
                                    expression: null
                                };
                            } else if (optionalContentGroups instanceof _primitives.Ref) return {
                                type: optionalContentType,
                                id: optionalContentGroups.toString()
                            };
                        }
                        return null;
                    }
                    getOperatorList({ stream: stream, task: task, resources: resources, operatorList: operatorList, initialState: initialState = null, fallbackFontDict: fallbackFontDict = null }) {
                        resources ||= _primitives.Dict.empty;
                        initialState ||= new EvalState();
                        if (!operatorList) throw new Error('getOperatorList: missing "operatorList" parameter');
                        const self1 = this;
                        const xref = this.xref;
                        let parsingText = false;
                        const localImageCache = new _image_utils.LocalImageCache();
                        const localColorSpaceCache = new _image_utils.LocalColorSpaceCache();
                        const localGStateCache = new _image_utils.LocalGStateCache();
                        const localTilingPatternCache = new _image_utils.LocalTilingPatternCache();
                        const localShadingPatternCache = new Map();
                        const xobjs = resources.get("XObject") || _primitives.Dict.empty;
                        const patterns = resources.get("Pattern") || _primitives.Dict.empty;
                        const stateManager = new StateManager(initialState);
                        const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                        const timeSlotManager = new TimeSlotManager();
                        function closePendingRestoreOPS(argument) {
                            for(let i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++)operatorList.addOp(_util.OPS.restore, []);
                        }
                        return new Promise(function promiseBody(resolve, reject) {
                            const next = function(promise) {
                                Promise.all([
                                    promise,
                                    operatorList.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(resolve, reject);
                                    } catch (ex) {
                                        reject(ex);
                                    }
                                }, reject);
                            };
                            task.ensureNotTerminated();
                            timeSlotManager.reset();
                            const operation = {};
                            let stop, i, ii, cs, name, isValidName;
                            while(!(stop = timeSlotManager.check())){
                                operation.args = null;
                                if (!preprocessor.read(operation)) break;
                                let args = operation.args;
                                let fn = operation.fn;
                                switch(fn | 0){
                                    case _util.OPS.paintXObject:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName) {
                                            const localImage = localImageCache.getByName(name);
                                            if (localImage) {
                                                operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                                incrementCachedImageMaskCount(localImage);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(resolveXObject, rejectXObject) {
                                            if (!isValidName) throw new _util.FormatError("XObject must be referred to by name.");
                                            let xobj = xobjs.getRaw(name);
                                            if (xobj instanceof _primitives.Ref) {
                                                const localImage = localImageCache.getByRef(xobj) || self1._regionalImageCache.getByRef(xobj);
                                                if (localImage) {
                                                    operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                                    incrementCachedImageMaskCount(localImage);
                                                    resolveXObject();
                                                    return;
                                                }
                                                const globalImage = self1.globalImageCache.getData(xobj, self1.pageIndex);
                                                if (globalImage) {
                                                    operatorList.addDependency(globalImage.objId);
                                                    operatorList.addImageOps(globalImage.fn, globalImage.args, globalImage.optionalContent);
                                                    resolveXObject();
                                                    return;
                                                }
                                                xobj = xref.fetch(xobj);
                                            }
                                            if (!(xobj instanceof _base_stream.BaseStream)) throw new _util.FormatError("XObject should be a stream");
                                            const type = xobj.dict.get("Subtype");
                                            if (!(type instanceof _primitives.Name)) throw new _util.FormatError("XObject should have a Name subtype");
                                            if (type.name === "Form") {
                                                stateManager.save();
                                                self1.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone(), localColorSpaceCache).then(function() {
                                                    stateManager.restore();
                                                    resolveXObject();
                                                }, rejectXObject);
                                                return;
                                            } else if (type.name === "Image") {
                                                self1.buildPaintImageXObject({
                                                    resources: resources,
                                                    image: xobj,
                                                    operatorList: operatorList,
                                                    cacheKey: name,
                                                    localImageCache: localImageCache,
                                                    localColorSpaceCache: localColorSpaceCache
                                                }).then(resolveXObject, rejectXObject);
                                                return;
                                            } else if (type.name === "PS") (0, _util.info)("Ignored XObject subtype PS");
                                            else throw new _util.FormatError(`Unhandled XObject subtype ${type.name}`);
                                            resolveXObject();
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getOperatorList - ignoring XObject: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.setFont:
                                        var fontSize = args[1];
                                        next(self1.handleSetFont(resources, args, null, operatorList, task, stateManager.state, fallbackFontDict).then(function(loadedName) {
                                            operatorList.addDependency(loadedName);
                                            operatorList.addOp(_util.OPS.setFont, [
                                                loadedName,
                                                fontSize
                                            ]);
                                        }));
                                        return;
                                    case _util.OPS.beginText:
                                        parsingText = true;
                                        break;
                                    case _util.OPS.endText:
                                        parsingText = false;
                                        break;
                                    case _util.OPS.endInlineImage:
                                        var cacheKey = args[0].cacheKey;
                                        if (cacheKey) {
                                            const localImage = localImageCache.getByName(cacheKey);
                                            if (localImage) {
                                                operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                                incrementCachedImageMaskCount(localImage);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(self1.buildPaintImageXObject({
                                            resources: resources,
                                            image: args[0],
                                            isInline: true,
                                            operatorList: operatorList,
                                            cacheKey: cacheKey,
                                            localImageCache: localImageCache,
                                            localColorSpaceCache: localColorSpaceCache
                                        }));
                                        return;
                                    case _util.OPS.showText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        break;
                                    case _util.OPS.showSpacedText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        var combinedGlyphs = [];
                                        var state = stateManager.state;
                                        for (const arrItem of args[0]){
                                            if (typeof arrItem === "string") combinedGlyphs.push(...self1.handleText(arrItem, state));
                                            else if (typeof arrItem === "number") combinedGlyphs.push(arrItem);
                                        }
                                        args[0] = combinedGlyphs;
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.nextLineShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        operatorList.addOp(_util.OPS.nextLine);
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        operatorList.addOp(_util.OPS.nextLine);
                                        operatorList.addOp(_util.OPS.setWordSpacing, [
                                            args.shift()
                                        ]);
                                        operatorList.addOp(_util.OPS.setCharSpacing, [
                                            args.shift()
                                        ]);
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.setTextRenderingMode:
                                        stateManager.state.textRenderingMode = args[0];
                                        break;
                                    case _util.OPS.setFillColorSpace:
                                        {
                                            const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                                            if (cachedColorSpace) {
                                                stateManager.state.fillColorSpace = cachedColorSpace;
                                                continue;
                                            }
                                            next(self1.parseColorSpace({
                                                cs: args[0],
                                                resources: resources,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(function(colorSpace) {
                                                if (colorSpace) stateManager.state.fillColorSpace = colorSpace;
                                            }));
                                            return;
                                        }
                                    case _util.OPS.setStrokeColorSpace:
                                        {
                                            const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                                            if (cachedColorSpace) {
                                                stateManager.state.strokeColorSpace = cachedColorSpace;
                                                continue;
                                            }
                                            next(self1.parseColorSpace({
                                                cs: args[0],
                                                resources: resources,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(function(colorSpace) {
                                                if (colorSpace) stateManager.state.strokeColorSpace = colorSpace;
                                            }));
                                            return;
                                        }
                                    case _util.OPS.setFillColor:
                                        cs = stateManager.state.fillColorSpace;
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeColor:
                                        cs = stateManager.state.strokeColorSpace;
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillGray:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                                        args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeGray:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                                        args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                                        args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeCMYKColor:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                                        args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
                                        args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                                        break;
                                    case _util.OPS.setStrokeRGBColor:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
                                        args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                                        break;
                                    case _util.OPS.setFillColorN:
                                        cs = stateManager.state.fillColorSpace;
                                        if (cs.name === "Pattern") {
                                            next(self1.handleColorN(operatorList, _util.OPS.setFillColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                                            return;
                                        }
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeColorN:
                                        cs = stateManager.state.strokeColorSpace;
                                        if (cs.name === "Pattern") {
                                            next(self1.handleColorN(operatorList, _util.OPS.setStrokeColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                                            return;
                                        }
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.shadingFill:
                                        var shadingRes = resources.get("Shading");
                                        if (!shadingRes) throw new _util.FormatError("No shading resource found");
                                        var shading = shadingRes.get(args[0].name);
                                        if (!shading) throw new _util.FormatError("No shading object found");
                                        const patternId = self1.parseShading({
                                            shading: shading,
                                            resources: resources,
                                            localColorSpaceCache: localColorSpaceCache,
                                            localShadingPatternCache: localShadingPatternCache
                                        });
                                        args = [
                                            patternId
                                        ];
                                        fn = _util.OPS.shadingFill;
                                        break;
                                    case _util.OPS.setGState:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName) {
                                            const localGStateObj = localGStateCache.getByName(name);
                                            if (localGStateObj) {
                                                if (localGStateObj.length > 0) operatorList.addOp(_util.OPS.setGState, [
                                                    localGStateObj
                                                ]);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(resolveGState, rejectGState) {
                                            if (!isValidName) throw new _util.FormatError("GState must be referred to by name.");
                                            const extGState = resources.get("ExtGState");
                                            if (!(extGState instanceof _primitives.Dict)) throw new _util.FormatError("ExtGState should be a dictionary.");
                                            const gState = extGState.get(name);
                                            if (!(gState instanceof _primitives.Dict)) throw new _util.FormatError("GState should be a dictionary.");
                                            self1.setGState({
                                                resources: resources,
                                                gState: gState,
                                                operatorList: operatorList,
                                                cacheKey: name,
                                                task: task,
                                                stateManager: stateManager,
                                                localGStateCache: localGStateCache,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(resolveGState, rejectGState);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getOperatorList - ignoring ExtGState: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.moveTo:
                                    case _util.OPS.lineTo:
                                    case _util.OPS.curveTo:
                                    case _util.OPS.curveTo2:
                                    case _util.OPS.curveTo3:
                                    case _util.OPS.closePath:
                                    case _util.OPS.rectangle:
                                        self1.buildPath(operatorList, fn, args, parsingText);
                                        continue;
                                    case _util.OPS.markPoint:
                                    case _util.OPS.markPointProps:
                                    case _util.OPS.beginCompat:
                                    case _util.OPS.endCompat:
                                        continue;
                                    case _util.OPS.beginMarkedContentProps:
                                        if (!(args[0] instanceof _primitives.Name)) {
                                            (0, _util.warn)(`Expected name for beginMarkedContentProps arg0=${args[0]}`);
                                            continue;
                                        }
                                        if (args[0].name === "OC") {
                                            next(self1.parseMarkedContentProps(args[1], resources).then((data)=>{
                                                operatorList.addOp(_util.OPS.beginMarkedContentProps, [
                                                    "OC",
                                                    data
                                                ]);
                                            }).catch((reason)=>{
                                                if (reason instanceof _util.AbortException) return;
                                                if (self1.options.ignoreErrors) {
                                                    (0, _util.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${reason}".`);
                                                    return;
                                                }
                                                throw reason;
                                            }));
                                            return;
                                        }
                                        args = [
                                            args[0].name,
                                            args[1] instanceof _primitives.Dict ? args[1].get("MCID") : null
                                        ];
                                        break;
                                    case _util.OPS.beginMarkedContent:
                                    case _util.OPS.endMarkedContent:
                                    default:
                                        if (args !== null) {
                                            for(i = 0, ii = args.length; i < ii; i++){
                                                if (args[i] instanceof _primitives.Dict) break;
                                            }
                                            if (i < ii) {
                                                (0, _util.warn)("getOperatorList - ignoring operator: " + fn);
                                                continue;
                                            }
                                        }
                                }
                                operatorList.addOp(fn, args);
                            }
                            if (stop) {
                                next(deferred);
                                return;
                            }
                            closePendingRestoreOPS();
                            resolve();
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`getOperatorList - ignoring errors during "${task.name}" ` + `task: "${reason}".`);
                                closePendingRestoreOPS();
                                return;
                            }
                            throw reason;
                        });
                    }
                    getTextContent({ stream: stream, task: task, resources: resources, stateManager: stateManager = null, includeMarkedContent: includeMarkedContent = false, sink: sink, seenStyles: seenStyles = new Set(), viewBox: viewBox, markedContentData: markedContentData = null, disableNormalization: disableNormalization = false }) {
                        resources ||= _primitives.Dict.empty;
                        stateManager ||= new StateManager(new TextState());
                        if (includeMarkedContent) markedContentData ||= {
                            level: 0
                        };
                        const textContent = {
                            items: [],
                            styles: Object.create(null)
                        };
                        const textContentItem = {
                            initialized: false,
                            str: [],
                            totalWidth: 0,
                            totalHeight: 0,
                            width: 0,
                            height: 0,
                            vertical: false,
                            prevTransform: null,
                            textAdvanceScale: 0,
                            spaceInFlowMin: 0,
                            spaceInFlowMax: 0,
                            trackingSpaceMin: Infinity,
                            negativeSpaceMax: -Infinity,
                            notASpace: -Infinity,
                            transform: null,
                            fontName: null,
                            hasEOL: false
                        };
                        const twoLastChars = [
                            " ",
                            " "
                        ];
                        let twoLastCharsPos = 0;
                        function saveLastChar(char) {
                            const nextPos = (twoLastCharsPos + 1) % 2;
                            const ret = twoLastChars[twoLastCharsPos] !== " " && twoLastChars[nextPos] === " ";
                            twoLastChars[twoLastCharsPos] = char;
                            twoLastCharsPos = nextPos;
                            return ret;
                        }
                        function shouldAddWhitepsace() {
                            return twoLastChars[twoLastCharsPos] !== " " && twoLastChars[(twoLastCharsPos + 1) % 2] === " ";
                        }
                        function resetLastChars() {
                            twoLastChars[0] = twoLastChars[1] = " ";
                            twoLastCharsPos = 0;
                        }
                        const TRACKING_SPACE_FACTOR = 0.102;
                        const NOT_A_SPACE_FACTOR = 0.03;
                        const NEGATIVE_SPACE_FACTOR = -0.2;
                        const SPACE_IN_FLOW_MIN_FACTOR = 0.102;
                        const SPACE_IN_FLOW_MAX_FACTOR = 0.6;
                        const VERTICAL_SHIFT_RATIO = 0.25;
                        const self1 = this;
                        const xref = this.xref;
                        const showSpacedTextBuffer = [];
                        let xobjs = null;
                        const emptyXObjectCache = new _image_utils.LocalImageCache();
                        const emptyGStateCache = new _image_utils.LocalGStateCache();
                        const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                        let textState;
                        function pushWhitespace({ width: width = 0, height: height = 0, transform: transform = textContentItem.prevTransform, fontName: fontName = textContentItem.fontName }) {
                            textContent.items.push({
                                str: " ",
                                dir: "ltr",
                                width: width,
                                height: height,
                                transform: transform,
                                fontName: fontName,
                                hasEOL: false
                            });
                        }
                        function getCurrentTextTransform() {
                            const font1 = textState.font;
                            const tsm = [
                                textState.fontSize * textState.textHScale,
                                0,
                                0,
                                textState.fontSize,
                                0,
                                textState.textRise
                            ];
                            if (font1.isType3Font && (textState.fontSize <= 1 || font1.isCharBBox) && !(0, _util.isArrayEqual)(textState.fontMatrix, _util.FONT_IDENTITY_MATRIX)) {
                                const glyphHeight = font1.bbox[3] - font1.bbox[1];
                                if (glyphHeight > 0) tsm[3] *= glyphHeight * textState.fontMatrix[3];
                            }
                            return _util.Util.transform(textState.ctm, _util.Util.transform(textState.textMatrix, tsm));
                        }
                        function ensureTextContentItem() {
                            if (textContentItem.initialized) return textContentItem;
                            const { font: font1, loadedName: loadedName } = textState;
                            if (!seenStyles.has(loadedName)) {
                                seenStyles.add(loadedName);
                                textContent.styles[loadedName] = {
                                    fontFamily: font1.fallbackName,
                                    ascent: font1.ascent,
                                    descent: font1.descent,
                                    vertical: font1.vertical
                                };
                            }
                            textContentItem.fontName = loadedName;
                            const trm = textContentItem.transform = getCurrentTextTransform();
                            if (!font1.vertical) {
                                textContentItem.width = textContentItem.totalWidth = 0;
                                textContentItem.height = textContentItem.totalHeight = Math.hypot(trm[2], trm[3]);
                                textContentItem.vertical = false;
                            } else {
                                textContentItem.width = textContentItem.totalWidth = Math.hypot(trm[0], trm[1]);
                                textContentItem.height = textContentItem.totalHeight = 0;
                                textContentItem.vertical = true;
                            }
                            const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                            const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                            textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
                            const { fontSize: fontSize } = textState;
                            textContentItem.trackingSpaceMin = fontSize * TRACKING_SPACE_FACTOR;
                            textContentItem.notASpace = fontSize * NOT_A_SPACE_FACTOR;
                            textContentItem.negativeSpaceMax = fontSize * NEGATIVE_SPACE_FACTOR;
                            textContentItem.spaceInFlowMin = fontSize * SPACE_IN_FLOW_MIN_FACTOR;
                            textContentItem.spaceInFlowMax = fontSize * SPACE_IN_FLOW_MAX_FACTOR;
                            textContentItem.hasEOL = false;
                            textContentItem.initialized = true;
                            return textContentItem;
                        }
                        function updateAdvanceScale() {
                            if (!textContentItem.initialized) return;
                            const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                            const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                            const scaleFactor = scaleCtmX * scaleLineX;
                            if (scaleFactor === textContentItem.textAdvanceScale) return;
                            if (!textContentItem.vertical) {
                                textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                                textContentItem.width = 0;
                            } else {
                                textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                                textContentItem.height = 0;
                            }
                            textContentItem.textAdvanceScale = scaleFactor;
                        }
                        function runBidiTransform(textChunk) {
                            let text = textChunk.str.join("");
                            if (!disableNormalization) text = (0, _util.normalizeUnicode)(text);
                            const bidiResult = (0, _bidi.bidi)(text, -1, textChunk.vertical);
                            return {
                                str: bidiResult.str,
                                dir: bidiResult.dir,
                                width: Math.abs(textChunk.totalWidth),
                                height: Math.abs(textChunk.totalHeight),
                                transform: textChunk.transform,
                                fontName: textChunk.fontName,
                                hasEOL: textChunk.hasEOL
                            };
                        }
                        function handleSetFont(fontName, fontRef) {
                            return self1.loadFont(fontName, fontRef, resources).then(function(translated) {
                                if (!translated.font.isType3Font) return translated;
                                return translated.loadType3Data(self1, resources, task).catch(function() {}).then(function() {
                                    return translated;
                                });
                            }).then(function(translated) {
                                textState.loadedName = translated.loadedName;
                                textState.font = translated.font;
                                textState.fontMatrix = translated.font.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                            });
                        }
                        function applyInverseRotation(x, y, matrix) {
                            const scale = Math.hypot(matrix[0], matrix[1]);
                            return [
                                (matrix[0] * x + matrix[1] * y) / scale,
                                (matrix[2] * x + matrix[3] * y) / scale
                            ];
                        }
                        function compareWithLastPosition(glyphWidth) {
                            const currentTransform = getCurrentTextTransform();
                            let posX = currentTransform[4];
                            let posY = currentTransform[5];
                            if (textState.font?.vertical) {
                                if (posX < viewBox[0] || posX > viewBox[2] || posY + glyphWidth < viewBox[1] || posY > viewBox[3]) return false;
                            } else if (posX + glyphWidth < viewBox[0] || posX > viewBox[2] || posY < viewBox[1] || posY > viewBox[3]) return false;
                            if (!textState.font || !textContentItem.prevTransform) return true;
                            let lastPosX = textContentItem.prevTransform[4];
                            let lastPosY = textContentItem.prevTransform[5];
                            if (lastPosX === posX && lastPosY === posY) return true;
                            let rotate = -1;
                            if (currentTransform[0] && currentTransform[1] === 0 && currentTransform[2] === 0) rotate = currentTransform[0] > 0 ? 0 : 180;
                            else if (currentTransform[1] && currentTransform[0] === 0 && currentTransform[3] === 0) rotate = currentTransform[1] > 0 ? 90 : 270;
                            switch(rotate){
                                case 0:
                                    break;
                                case 90:
                                    [posX, posY] = [
                                        posY,
                                        posX
                                    ];
                                    [lastPosX, lastPosY] = [
                                        lastPosY,
                                        lastPosX
                                    ];
                                    break;
                                case 180:
                                    [posX, posY, lastPosX, lastPosY] = [
                                        -posX,
                                        -posY,
                                        -lastPosX,
                                        -lastPosY
                                    ];
                                    break;
                                case 270:
                                    [posX, posY] = [
                                        -posY,
                                        -posX
                                    ];
                                    [lastPosX, lastPosY] = [
                                        -lastPosY,
                                        -lastPosX
                                    ];
                                    break;
                                default:
                                    [posX, posY] = applyInverseRotation(posX, posY, currentTransform);
                                    [lastPosX, lastPosY] = applyInverseRotation(lastPosX, lastPosY, textContentItem.prevTransform);
                            }
                            if (textState.font.vertical) {
                                const advanceY = (lastPosY - posY) / textContentItem.textAdvanceScale;
                                const advanceX = posX - lastPosX;
                                const textOrientation = Math.sign(textContentItem.height);
                                if (advanceY < textOrientation * textContentItem.negativeSpaceMax) {
                                    if (Math.abs(advanceX) > 0.5 * textContentItem.width) {
                                        appendEOL();
                                        return true;
                                    }
                                    resetLastChars();
                                    flushTextContentItem();
                                    return true;
                                }
                                if (Math.abs(advanceX) > textContentItem.width) {
                                    appendEOL();
                                    return true;
                                }
                                if (advanceY <= textOrientation * textContentItem.notASpace) resetLastChars();
                                if (advanceY <= textOrientation * textContentItem.trackingSpaceMin) {
                                    if (shouldAddWhitepsace()) {
                                        resetLastChars();
                                        flushTextContentItem();
                                        pushWhitespace({
                                            height: Math.abs(advanceY)
                                        });
                                    } else textContentItem.height += advanceY;
                                } else if (!addFakeSpaces(advanceY, textContentItem.prevTransform, textOrientation)) {
                                    if (textContentItem.str.length === 0) {
                                        resetLastChars();
                                        pushWhitespace({
                                            height: Math.abs(advanceY)
                                        });
                                    } else textContentItem.height += advanceY;
                                }
                                if (Math.abs(advanceX) > textContentItem.width * VERTICAL_SHIFT_RATIO) flushTextContentItem();
                                return true;
                            }
                            const advanceX = (posX - lastPosX) / textContentItem.textAdvanceScale;
                            const advanceY = posY - lastPosY;
                            const textOrientation = Math.sign(textContentItem.width);
                            if (advanceX < textOrientation * textContentItem.negativeSpaceMax) {
                                if (Math.abs(advanceY) > 0.5 * textContentItem.height) {
                                    appendEOL();
                                    return true;
                                }
                                resetLastChars();
                                flushTextContentItem();
                                return true;
                            }
                            if (Math.abs(advanceY) > textContentItem.height) {
                                appendEOL();
                                return true;
                            }
                            if (advanceX <= textOrientation * textContentItem.notASpace) resetLastChars();
                            if (advanceX <= textOrientation * textContentItem.trackingSpaceMin) {
                                if (shouldAddWhitepsace()) {
                                    resetLastChars();
                                    flushTextContentItem();
                                    pushWhitespace({
                                        width: Math.abs(advanceX)
                                    });
                                } else textContentItem.width += advanceX;
                            } else if (!addFakeSpaces(advanceX, textContentItem.prevTransform, textOrientation)) {
                                if (textContentItem.str.length === 0) {
                                    resetLastChars();
                                    pushWhitespace({
                                        width: Math.abs(advanceX)
                                    });
                                } else textContentItem.width += advanceX;
                            }
                            if (Math.abs(advanceY) > textContentItem.height * VERTICAL_SHIFT_RATIO) flushTextContentItem();
                            return true;
                        }
                        function buildTextContentItem({ chars: chars, extraSpacing: extraSpacing }) {
                            const font1 = textState.font;
                            if (!chars) {
                                const charSpacing = textState.charSpacing + extraSpacing;
                                if (charSpacing) {
                                    if (!font1.vertical) textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, -charSpacing);
                                }
                                return;
                            }
                            const glyphs = font1.charsToGlyphs(chars);
                            const scale = textState.fontMatrix[0] * textState.fontSize;
                            for(let i = 0, ii = glyphs.length; i < ii; i++){
                                const glyph = glyphs[i];
                                const { category: category } = glyph;
                                if (category.isInvisibleFormatMark) continue;
                                let charSpacing = textState.charSpacing + (i + 1 === ii ? extraSpacing : 0);
                                let glyphWidth = glyph.width;
                                if (font1.vertical) glyphWidth = glyph.vmetric ? glyph.vmetric[0] : -glyphWidth;
                                let scaledDim = glyphWidth * scale;
                                if (category.isWhitespace) {
                                    if (!font1.vertical) {
                                        charSpacing += scaledDim + textState.wordSpacing;
                                        textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    } else {
                                        charSpacing += -scaledDim + textState.wordSpacing;
                                        textState.translateTextMatrix(0, -charSpacing);
                                    }
                                    saveLastChar(" ");
                                    continue;
                                }
                                if (!category.isZeroWidthDiacritic && !compareWithLastPosition(scaledDim)) {
                                    if (!font1.vertical) textState.translateTextMatrix(scaledDim * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, scaledDim);
                                    continue;
                                }
                                const textChunk = ensureTextContentItem();
                                if (category.isZeroWidthDiacritic) scaledDim = 0;
                                if (!font1.vertical) {
                                    scaledDim *= textState.textHScale;
                                    textState.translateTextMatrix(scaledDim, 0);
                                    textChunk.width += scaledDim;
                                } else {
                                    textState.translateTextMatrix(0, scaledDim);
                                    scaledDim = Math.abs(scaledDim);
                                    textChunk.height += scaledDim;
                                }
                                if (scaledDim) textChunk.prevTransform = getCurrentTextTransform();
                                const glyphUnicode = glyph.unicode;
                                if (saveLastChar(glyphUnicode)) textChunk.str.push(" ");
                                textChunk.str.push(glyphUnicode);
                                if (charSpacing) {
                                    if (!font1.vertical) textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, -charSpacing);
                                }
                            }
                        }
                        function appendEOL() {
                            resetLastChars();
                            if (textContentItem.initialized) {
                                textContentItem.hasEOL = true;
                                flushTextContentItem();
                            } else textContent.items.push({
                                str: "",
                                dir: "ltr",
                                width: 0,
                                height: 0,
                                transform: getCurrentTextTransform(),
                                fontName: textState.loadedName,
                                hasEOL: true
                            });
                        }
                        function addFakeSpaces(width, transf, textOrientation) {
                            if (textOrientation * textContentItem.spaceInFlowMin <= width && width <= textOrientation * textContentItem.spaceInFlowMax) {
                                if (textContentItem.initialized) {
                                    resetLastChars();
                                    textContentItem.str.push(" ");
                                }
                                return false;
                            }
                            const fontName = textContentItem.fontName;
                            let height = 0;
                            if (textContentItem.vertical) {
                                height = width;
                                width = 0;
                            }
                            flushTextContentItem();
                            resetLastChars();
                            pushWhitespace({
                                width: Math.abs(width),
                                height: Math.abs(height),
                                transform: transf || getCurrentTextTransform(),
                                fontName: fontName
                            });
                            return true;
                        }
                        function flushTextContentItem() {
                            if (!textContentItem.initialized || !textContentItem.str) return;
                            if (!textContentItem.vertical) textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                            else textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                            textContent.items.push(runBidiTransform(textContentItem));
                            textContentItem.initialized = false;
                            textContentItem.str.length = 0;
                        }
                        function enqueueChunk(batch = false) {
                            const length = textContent.items.length;
                            if (length === 0) return;
                            if (batch && length < TEXT_CHUNK_BATCH_SIZE) return;
                            sink.enqueue(textContent, length);
                            textContent.items = [];
                            textContent.styles = Object.create(null);
                        }
                        const timeSlotManager = new TimeSlotManager();
                        return new Promise(function promiseBody(resolve, reject) {
                            const next = function(promise) {
                                enqueueChunk(true);
                                Promise.all([
                                    promise,
                                    sink.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(resolve, reject);
                                    } catch (ex) {
                                        reject(ex);
                                    }
                                }, reject);
                            };
                            task.ensureNotTerminated();
                            timeSlotManager.reset();
                            const operation = {};
                            let stop, args = [];
                            while(!(stop = timeSlotManager.check())){
                                args.length = 0;
                                operation.args = args;
                                if (!preprocessor.read(operation)) break;
                                const previousState = textState;
                                textState = stateManager.state;
                                const fn = operation.fn;
                                args = operation.args;
                                switch(fn | 0){
                                    case _util.OPS.setFont:
                                        var fontNameArg = args[0].name, fontSizeArg = args[1];
                                        if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) break;
                                        flushTextContentItem();
                                        textState.fontName = fontNameArg;
                                        textState.fontSize = fontSizeArg;
                                        next(handleSetFont(fontNameArg, null));
                                        return;
                                    case _util.OPS.setTextRise:
                                        textState.textRise = args[0];
                                        break;
                                    case _util.OPS.setHScale:
                                        textState.textHScale = args[0] / 100;
                                        break;
                                    case _util.OPS.setLeading:
                                        textState.leading = args[0];
                                        break;
                                    case _util.OPS.moveText:
                                        textState.translateTextLineMatrix(args[0], args[1]);
                                        textState.textMatrix = textState.textLineMatrix.slice();
                                        break;
                                    case _util.OPS.setLeadingMoveText:
                                        textState.leading = -args[1];
                                        textState.translateTextLineMatrix(args[0], args[1]);
                                        textState.textMatrix = textState.textLineMatrix.slice();
                                        break;
                                    case _util.OPS.nextLine:
                                        textState.carriageReturn();
                                        break;
                                    case _util.OPS.setTextMatrix:
                                        textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                        textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                        updateAdvanceScale();
                                        break;
                                    case _util.OPS.setCharSpacing:
                                        textState.charSpacing = args[0];
                                        break;
                                    case _util.OPS.setWordSpacing:
                                        textState.wordSpacing = args[0];
                                        break;
                                    case _util.OPS.beginText:
                                        textState.textMatrix = _util.IDENTITY_MATRIX.slice();
                                        textState.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                                        break;
                                    case _util.OPS.showSpacedText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        const spaceFactor = (textState.font.vertical ? 1 : -1) * textState.fontSize / 1000;
                                        const elements = args[0];
                                        for(let i = 0, ii = elements.length; i < ii; i++){
                                            const item = elements[i];
                                            if (typeof item === "string") showSpacedTextBuffer.push(item);
                                            else if (typeof item === "number" && item !== 0) {
                                                const str = showSpacedTextBuffer.join("");
                                                showSpacedTextBuffer.length = 0;
                                                buildTextContentItem({
                                                    chars: str,
                                                    extraSpacing: item * spaceFactor
                                                });
                                            }
                                        }
                                        if (showSpacedTextBuffer.length > 0) {
                                            const str = showSpacedTextBuffer.join("");
                                            showSpacedTextBuffer.length = 0;
                                            buildTextContentItem({
                                                chars: str,
                                                extraSpacing: 0
                                            });
                                        }
                                        break;
                                    case _util.OPS.showText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        buildTextContentItem({
                                            chars: args[0],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case _util.OPS.nextLineShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        textState.carriageReturn();
                                        buildTextContentItem({
                                            chars: args[0],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        textState.wordSpacing = args[0];
                                        textState.charSpacing = args[1];
                                        textState.carriageReturn();
                                        buildTextContentItem({
                                            chars: args[2],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case _util.OPS.paintXObject:
                                        flushTextContentItem();
                                        if (!xobjs) xobjs = resources.get("XObject") || _primitives.Dict.empty;
                                        var isValidName = args[0] instanceof _primitives.Name;
                                        var name = args[0].name;
                                        if (isValidName && emptyXObjectCache.getByName(name)) break;
                                        next(new Promise(function(resolveXObject, rejectXObject) {
                                            if (!isValidName) throw new _util.FormatError("XObject must be referred to by name.");
                                            let xobj = xobjs.getRaw(name);
                                            if (xobj instanceof _primitives.Ref) {
                                                if (emptyXObjectCache.getByRef(xobj)) {
                                                    resolveXObject();
                                                    return;
                                                }
                                                const globalImage = self1.globalImageCache.getData(xobj, self1.pageIndex);
                                                if (globalImage) {
                                                    resolveXObject();
                                                    return;
                                                }
                                                xobj = xref.fetch(xobj);
                                            }
                                            if (!(xobj instanceof _base_stream.BaseStream)) throw new _util.FormatError("XObject should be a stream");
                                            const type = xobj.dict.get("Subtype");
                                            if (!(type instanceof _primitives.Name)) throw new _util.FormatError("XObject should have a Name subtype");
                                            if (type.name !== "Form") {
                                                emptyXObjectCache.set(name, xobj.dict.objId, true);
                                                resolveXObject();
                                                return;
                                            }
                                            const currentState = stateManager.state.clone();
                                            const xObjStateManager = new StateManager(currentState);
                                            const matrix = xobj.dict.getArray("Matrix");
                                            if (Array.isArray(matrix) && matrix.length === 6) xObjStateManager.transform(matrix);
                                            enqueueChunk();
                                            const sinkWrapper = {
                                                enqueueInvoked: false,
                                                enqueue (chunk, size) {
                                                    this.enqueueInvoked = true;
                                                    sink.enqueue(chunk, size);
                                                },
                                                get desiredSize () {
                                                    return sink.desiredSize;
                                                },
                                                get ready () {
                                                    return sink.ready;
                                                }
                                            };
                                            self1.getTextContent({
                                                stream: xobj,
                                                task: task,
                                                resources: xobj.dict.get("Resources") || resources,
                                                stateManager: xObjStateManager,
                                                includeMarkedContent: includeMarkedContent,
                                                sink: sinkWrapper,
                                                seenStyles: seenStyles,
                                                viewBox: viewBox,
                                                markedContentData: markedContentData,
                                                disableNormalization: disableNormalization
                                            }).then(function() {
                                                if (!sinkWrapper.enqueueInvoked) emptyXObjectCache.set(name, xobj.dict.objId, true);
                                                resolveXObject();
                                            }, rejectXObject);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getTextContent - ignoring XObject: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.setGState:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName && emptyGStateCache.getByName(name)) break;
                                        next(new Promise(function(resolveGState, rejectGState) {
                                            if (!isValidName) throw new _util.FormatError("GState must be referred to by name.");
                                            const extGState = resources.get("ExtGState");
                                            if (!(extGState instanceof _primitives.Dict)) throw new _util.FormatError("ExtGState should be a dictionary.");
                                            const gState = extGState.get(name);
                                            if (!(gState instanceof _primitives.Dict)) throw new _util.FormatError("GState should be a dictionary.");
                                            const gStateFont = gState.get("Font");
                                            if (!gStateFont) {
                                                emptyGStateCache.set(name, gState.objId, true);
                                                resolveGState();
                                                return;
                                            }
                                            flushTextContentItem();
                                            textState.fontName = null;
                                            textState.fontSize = gStateFont[1];
                                            handleSetFont(null, gStateFont[0]).then(resolveGState, rejectGState);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getTextContent - ignoring ExtGState: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.beginMarkedContent:
                                        flushTextContentItem();
                                        if (includeMarkedContent) {
                                            markedContentData.level++;
                                            textContent.items.push({
                                                type: "beginMarkedContent",
                                                tag: args[0] instanceof _primitives.Name ? args[0].name : null
                                            });
                                        }
                                        break;
                                    case _util.OPS.beginMarkedContentProps:
                                        flushTextContentItem();
                                        if (includeMarkedContent) {
                                            markedContentData.level++;
                                            let mcid = null;
                                            if (args[1] instanceof _primitives.Dict) mcid = args[1].get("MCID");
                                            textContent.items.push({
                                                type: "beginMarkedContentProps",
                                                id: Number.isInteger(mcid) ? `${self1.idFactory.getPageObjId()}_mc${mcid}` : null,
                                                tag: args[0] instanceof _primitives.Name ? args[0].name : null
                                            });
                                        }
                                        break;
                                    case _util.OPS.endMarkedContent:
                                        flushTextContentItem();
                                        if (includeMarkedContent) {
                                            if (markedContentData.level === 0) break;
                                            markedContentData.level--;
                                            textContent.items.push({
                                                type: "endMarkedContent"
                                            });
                                        }
                                        break;
                                    case _util.OPS.restore:
                                        if (previousState && (previousState.font !== textState.font || previousState.fontSize !== textState.fontSize || previousState.fontName !== textState.fontName)) flushTextContentItem();
                                        break;
                                }
                                if (textContent.items.length >= sink.desiredSize) {
                                    stop = true;
                                    break;
                                }
                            }
                            if (stop) {
                                next(deferred);
                                return;
                            }
                            flushTextContentItem();
                            enqueueChunk();
                            resolve();
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`getTextContent - ignoring errors during "${task.name}" ` + `task: "${reason}".`);
                                flushTextContentItem();
                                enqueueChunk();
                                return;
                            }
                            throw reason;
                        });
                    }
                    extractDataStructures(dict, baseDict, properties) {
                        const xref = this.xref;
                        let cidToGidBytes;
                        const toUnicodePromise = this.readToUnicode(properties.toUnicode || dict.get("ToUnicode") || baseDict.get("ToUnicode"));
                        if (properties.composite) {
                            const cidSystemInfo = dict.get("CIDSystemInfo");
                            if (cidSystemInfo instanceof _primitives.Dict) properties.cidSystemInfo = {
                                registry: (0, _util.stringToPDFString)(cidSystemInfo.get("Registry")),
                                ordering: (0, _util.stringToPDFString)(cidSystemInfo.get("Ordering")),
                                supplement: cidSystemInfo.get("Supplement")
                            };
                            try {
                                const cidToGidMap = dict.get("CIDToGIDMap");
                                if (cidToGidMap instanceof _base_stream.BaseStream) cidToGidBytes = cidToGidMap.getBytes();
                            } catch (ex) {
                                if (!this.options.ignoreErrors) throw ex;
                                (0, _util.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${ex}".`);
                            }
                        }
                        const differences = [];
                        let baseEncodingName = null;
                        let encoding;
                        if (dict.has("Encoding")) {
                            encoding = dict.get("Encoding");
                            if (encoding instanceof _primitives.Dict) {
                                baseEncodingName = encoding.get("BaseEncoding");
                                baseEncodingName = baseEncodingName instanceof _primitives.Name ? baseEncodingName.name : null;
                                if (encoding.has("Differences")) {
                                    const diffEncoding = encoding.get("Differences");
                                    let index = 0;
                                    for (const entry of diffEncoding){
                                        const data = xref.fetchIfRef(entry);
                                        if (typeof data === "number") index = data;
                                        else if (data instanceof _primitives.Name) differences[index++] = data.name;
                                        else throw new _util.FormatError(`Invalid entry in 'Differences' array: ${data}`);
                                    }
                                }
                            } else if (encoding instanceof _primitives.Name) baseEncodingName = encoding.name;
                            else {
                                const msg = "Encoding is not a Name nor a Dict";
                                if (!this.options.ignoreErrors) throw new _util.FormatError(msg);
                                (0, _util.warn)(msg);
                            }
                            if (baseEncodingName !== "MacRomanEncoding" && baseEncodingName !== "MacExpertEncoding" && baseEncodingName !== "WinAnsiEncoding") baseEncodingName = null;
                        }
                        const nonEmbeddedFont = !properties.file || properties.isInternalFont, isSymbolsFontName = (0, _standard_fonts.getSymbolsFonts)()[properties.name];
                        if (baseEncodingName && nonEmbeddedFont && isSymbolsFontName) baseEncodingName = null;
                        if (baseEncodingName) properties.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                        else {
                            const isSymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Symbolic);
                            const isNonsymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Nonsymbolic);
                            encoding = _encodings.StandardEncoding;
                            if (properties.type === "TrueType" && !isNonsymbolicFont) encoding = _encodings.WinAnsiEncoding;
                            if (isSymbolicFont || isSymbolsFontName) {
                                encoding = _encodings.MacRomanEncoding;
                                if (nonEmbeddedFont) {
                                    if (/Symbol/i.test(properties.name)) encoding = _encodings.SymbolSetEncoding;
                                    else if (/Dingbats/i.test(properties.name)) encoding = _encodings.ZapfDingbatsEncoding;
                                    else if (/Wingdings/i.test(properties.name)) encoding = _encodings.WinAnsiEncoding;
                                }
                            }
                            properties.defaultEncoding = encoding;
                        }
                        properties.differences = differences;
                        properties.baseEncodingName = baseEncodingName;
                        properties.hasEncoding = !!baseEncodingName || differences.length > 0;
                        properties.dict = dict;
                        return toUnicodePromise.then((readToUnicode)=>{
                            properties.toUnicode = readToUnicode;
                            return this.buildToUnicode(properties);
                        }).then((builtToUnicode)=>{
                            properties.toUnicode = builtToUnicode;
                            if (cidToGidBytes) properties.cidToGidMap = this.readCidToGidMap(cidToGidBytes, builtToUnicode);
                            return properties;
                        });
                    }
                    _simpleFontToUnicode(properties, forceGlyphs = false) {
                        (0, _util.assert)(!properties.composite, "Must be a simple font.");
                        const toUnicode = [];
                        const encoding = properties.defaultEncoding.slice();
                        const baseEncodingName = properties.baseEncodingName;
                        const differences = properties.differences;
                        for(const charcode in differences){
                            const glyphName = differences[charcode];
                            if (glyphName === ".notdef") continue;
                            encoding[charcode] = glyphName;
                        }
                        const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                        for(const charcode in encoding){
                            let glyphName = encoding[charcode];
                            if (glyphName === "") continue;
                            let unicode = glyphsUnicodeMap[glyphName];
                            if (unicode !== undefined) {
                                toUnicode[charcode] = String.fromCharCode(unicode);
                                continue;
                            }
                            let code = 0;
                            switch(glyphName[0]){
                                case "G":
                                    if (glyphName.length === 3) code = parseInt(glyphName.substring(1), 16);
                                    break;
                                case "g":
                                    if (glyphName.length === 5) code = parseInt(glyphName.substring(1), 16);
                                    break;
                                case "C":
                                case "c":
                                    if (glyphName.length >= 3 && glyphName.length <= 4) {
                                        const codeStr = glyphName.substring(1);
                                        if (forceGlyphs) {
                                            code = parseInt(codeStr, 16);
                                            break;
                                        }
                                        code = +codeStr;
                                        if (Number.isNaN(code) && Number.isInteger(parseInt(codeStr, 16))) return this._simpleFontToUnicode(properties, true);
                                    }
                                    break;
                                case "u":
                                    unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                                    if (unicode !== -1) code = unicode;
                                    break;
                                default:
                                    switch(glyphName){
                                        case "f_h":
                                        case "f_t":
                                        case "T_h":
                                            toUnicode[charcode] = glyphName.replaceAll("_", "");
                                            continue;
                                    }
                                    break;
                            }
                            if (code > 0 && code <= 0x10ffff && Number.isInteger(code)) {
                                if (baseEncodingName && code === +charcode) {
                                    const baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                                    if (baseEncoding && (glyphName = baseEncoding[charcode])) {
                                        toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                                        continue;
                                    }
                                }
                                toUnicode[charcode] = String.fromCodePoint(code);
                            }
                        }
                        return toUnicode;
                    }
                    async buildToUnicode(properties) {
                        properties.hasIncludedToUnicodeMap = properties.toUnicode?.length > 0;
                        if (properties.hasIncludedToUnicodeMap) {
                            if (!properties.composite && properties.hasEncoding) properties.fallbackToUnicode = this._simpleFontToUnicode(properties);
                            return properties.toUnicode;
                        }
                        if (!properties.composite) return new _to_unicode_map.ToUnicodeMap(this._simpleFontToUnicode(properties));
                        if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof _cmap.IdentityCMap) || properties.cidSystemInfo.registry === "Adobe" && (properties.cidSystemInfo.ordering === "GB1" || properties.cidSystemInfo.ordering === "CNS1" || properties.cidSystemInfo.ordering === "Japan1" || properties.cidSystemInfo.ordering === "Korea1"))) {
                            const { registry: registry, ordering: ordering } = properties.cidSystemInfo;
                            const ucs2CMapName = _primitives.Name.get(`${registry}-${ordering}-UCS2`);
                            const ucs2CMap = await _cmap.CMapFactory.create({
                                encoding: ucs2CMapName,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            const toUnicode = [], buf = [];
                            properties.cMap.forEach(function(charcode, cid) {
                                if (cid > 0xffff) throw new _util.FormatError("Max size of CID is 65,535");
                                const ucs2 = ucs2CMap.lookup(cid);
                                if (ucs2) {
                                    buf.length = 0;
                                    for(let i = 0, ii = ucs2.length; i < ii; i += 2)buf.push((ucs2.charCodeAt(i) << 8) + ucs2.charCodeAt(i + 1));
                                    toUnicode[charcode] = String.fromCharCode(...buf);
                                }
                            });
                            return new _to_unicode_map.ToUnicodeMap(toUnicode);
                        }
                        return new _to_unicode_map.IdentityToUnicodeMap(properties.firstChar, properties.lastChar);
                    }
                    readToUnicode(cmapObj) {
                        if (!cmapObj) return Promise.resolve(null);
                        if (cmapObj instanceof _primitives.Name) return _cmap.CMapFactory.create({
                            encoding: cmapObj,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(cmap) {
                            if (cmap instanceof _cmap.IdentityCMap) return new _to_unicode_map.IdentityToUnicodeMap(0, 0xffff);
                            return new _to_unicode_map.ToUnicodeMap(cmap.getMap());
                        });
                        else if (cmapObj instanceof _base_stream.BaseStream) return _cmap.CMapFactory.create({
                            encoding: cmapObj,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(cmap) {
                            if (cmap instanceof _cmap.IdentityCMap) return new _to_unicode_map.IdentityToUnicodeMap(0, 0xffff);
                            const map = new Array(cmap.length);
                            cmap.forEach(function(charCode, token) {
                                if (typeof token === "number") {
                                    map[charCode] = String.fromCodePoint(token);
                                    return;
                                }
                                const str = [];
                                for(let k = 0; k < token.length; k += 2){
                                    const w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                                    if ((w1 & 0xf800) !== 0xd800) {
                                        str.push(w1);
                                        continue;
                                    }
                                    k += 2;
                                    const w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                                    str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
                                }
                                map[charCode] = String.fromCodePoint(...str);
                            });
                            return new _to_unicode_map.ToUnicodeMap(map);
                        }, (reason)=>{
                            if (reason instanceof _util.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`readToUnicode - ignoring ToUnicode data: "${reason}".`);
                                return null;
                            }
                            throw reason;
                        });
                        return Promise.resolve(null);
                    }
                    readCidToGidMap(glyphsData, toUnicode) {
                        const result = [];
                        for(let j = 0, jj = glyphsData.length; j < jj; j++){
                            const glyphID = glyphsData[j++] << 8 | glyphsData[j];
                            const code = j >> 1;
                            if (glyphID === 0 && !toUnicode.has(code)) continue;
                            result[code] = glyphID;
                        }
                        return result;
                    }
                    extractWidths(dict, descriptor, properties) {
                        const xref = this.xref;
                        let glyphsWidths = [];
                        let defaultWidth = 0;
                        const glyphsVMetrics = [];
                        let defaultVMetrics;
                        let i, ii, j, jj, start, code, widths;
                        if (properties.composite) {
                            defaultWidth = dict.has("DW") ? dict.get("DW") : 1000;
                            widths = dict.get("W");
                            if (widths) for(i = 0, ii = widths.length; i < ii; i++){
                                start = xref.fetchIfRef(widths[i++]);
                                code = xref.fetchIfRef(widths[i]);
                                if (Array.isArray(code)) for(j = 0, jj = code.length; j < jj; j++)glyphsWidths[start++] = xref.fetchIfRef(code[j]);
                                else {
                                    const width = xref.fetchIfRef(widths[++i]);
                                    for(j = start; j <= code; j++)glyphsWidths[j] = width;
                                }
                            }
                            if (properties.vertical) {
                                let vmetrics = dict.getArray("DW2") || [
                                    880,
                                    -1000
                                ];
                                defaultVMetrics = [
                                    vmetrics[1],
                                    defaultWidth * 0.5,
                                    vmetrics[0]
                                ];
                                vmetrics = dict.get("W2");
                                if (vmetrics) for(i = 0, ii = vmetrics.length; i < ii; i++){
                                    start = xref.fetchIfRef(vmetrics[i++]);
                                    code = xref.fetchIfRef(vmetrics[i]);
                                    if (Array.isArray(code)) for(j = 0, jj = code.length; j < jj; j++)glyphsVMetrics[start++] = [
                                        xref.fetchIfRef(code[j++]),
                                        xref.fetchIfRef(code[j++]),
                                        xref.fetchIfRef(code[j])
                                    ];
                                    else {
                                        const vmetric = [
                                            xref.fetchIfRef(vmetrics[++i]),
                                            xref.fetchIfRef(vmetrics[++i]),
                                            xref.fetchIfRef(vmetrics[++i])
                                        ];
                                        for(j = start; j <= code; j++)glyphsVMetrics[j] = vmetric;
                                    }
                                }
                            }
                        } else {
                            const firstChar = properties.firstChar;
                            widths = dict.get("Widths");
                            if (widths) {
                                j = firstChar;
                                for(i = 0, ii = widths.length; i < ii; i++)glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
                                defaultWidth = parseFloat(descriptor.get("MissingWidth")) || 0;
                            } else {
                                const baseFontName = dict.get("BaseFont");
                                if (baseFontName instanceof _primitives.Name) {
                                    const metrics = this.getBaseFontMetrics(baseFontName.name);
                                    glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
                                    defaultWidth = metrics.defaultWidth;
                                }
                            }
                        }
                        let isMonospace = true;
                        let firstWidth = defaultWidth;
                        for(const glyph in glyphsWidths){
                            const glyphWidth = glyphsWidths[glyph];
                            if (!glyphWidth) continue;
                            if (!firstWidth) {
                                firstWidth = glyphWidth;
                                continue;
                            }
                            if (firstWidth !== glyphWidth) {
                                isMonospace = false;
                                break;
                            }
                        }
                        if (isMonospace) properties.flags |= _fonts_utils.FontFlags.FixedPitch;
                        else properties.flags &= ~_fonts_utils.FontFlags.FixedPitch;
                        properties.defaultWidth = defaultWidth;
                        properties.widths = glyphsWidths;
                        properties.defaultVMetrics = defaultVMetrics;
                        properties.vmetrics = glyphsVMetrics;
                    }
                    isSerifFont(baseFontName) {
                        const fontNameWoStyle = baseFontName.split("-")[0];
                        return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || /serif/gi.test(fontNameWoStyle);
                    }
                    getBaseFontMetrics(name) {
                        let defaultWidth = 0;
                        let widths = Object.create(null);
                        let monospace = false;
                        const stdFontMap = (0, _standard_fonts.getStdFontMap)();
                        let lookupName = stdFontMap[name] || name;
                        const Metrics = (0, _metrics.getMetrics)();
                        if (!(lookupName in Metrics)) lookupName = this.isSerifFont(name) ? "Times-Roman" : "Helvetica";
                        const glyphWidths = Metrics[lookupName];
                        if (typeof glyphWidths === "number") {
                            defaultWidth = glyphWidths;
                            monospace = true;
                        } else widths = glyphWidths();
                        return {
                            defaultWidth: defaultWidth,
                            monospace: monospace,
                            widths: widths
                        };
                    }
                    buildCharCodeToWidth(widthsByGlyphName, properties) {
                        const widths = Object.create(null);
                        const differences = properties.differences;
                        const encoding = properties.defaultEncoding;
                        for(let charCode = 0; charCode < 256; charCode++){
                            if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
                                widths[charCode] = widthsByGlyphName[differences[charCode]];
                                continue;
                            }
                            if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
                                widths[charCode] = widthsByGlyphName[encoding[charCode]];
                                continue;
                            }
                        }
                        return widths;
                    }
                    preEvaluateFont(dict) {
                        const baseDict = dict;
                        let type = dict.get("Subtype");
                        if (!(type instanceof _primitives.Name)) throw new _util.FormatError("invalid font Subtype");
                        let composite = false;
                        let hash, toUnicode;
                        if (type.name === "Type0") {
                            const df = dict.get("DescendantFonts");
                            if (!df) throw new _util.FormatError("Descendant fonts are not specified");
                            dict = Array.isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
                            if (!(dict instanceof _primitives.Dict)) throw new _util.FormatError("Descendant font is not a dictionary.");
                            type = dict.get("Subtype");
                            if (!(type instanceof _primitives.Name)) throw new _util.FormatError("invalid font Subtype");
                            composite = true;
                        }
                        const firstChar = dict.get("FirstChar") || 0, lastChar = dict.get("LastChar") || (composite ? 0xffff : 0xff);
                        const descriptor = dict.get("FontDescriptor");
                        if (descriptor) {
                            hash = new _murmurhash.MurmurHash3_64();
                            const encoding = baseDict.getRaw("Encoding");
                            if (encoding instanceof _primitives.Name) hash.update(encoding.name);
                            else if (encoding instanceof _primitives.Ref) hash.update(encoding.toString());
                            else if (encoding instanceof _primitives.Dict) for (const entry of encoding.getRawValues()){
                                if (entry instanceof _primitives.Name) hash.update(entry.name);
                                else if (entry instanceof _primitives.Ref) hash.update(entry.toString());
                                else if (Array.isArray(entry)) {
                                    const diffLength = entry.length, diffBuf = new Array(diffLength);
                                    for(let j = 0; j < diffLength; j++){
                                        const diffEntry = entry[j];
                                        if (diffEntry instanceof _primitives.Name) diffBuf[j] = diffEntry.name;
                                        else if (typeof diffEntry === "number" || diffEntry instanceof _primitives.Ref) diffBuf[j] = diffEntry.toString();
                                    }
                                    hash.update(diffBuf.join());
                                }
                            }
                            hash.update(`${firstChar}-${lastChar}`);
                            toUnicode = dict.get("ToUnicode") || baseDict.get("ToUnicode");
                            if (toUnicode instanceof _base_stream.BaseStream) {
                                const stream = toUnicode.str || toUnicode;
                                const uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
                                hash.update(uint8array);
                            } else if (toUnicode instanceof _primitives.Name) hash.update(toUnicode.name);
                            const widths = dict.get("Widths") || baseDict.get("Widths");
                            if (Array.isArray(widths)) {
                                const widthsBuf = [];
                                for (const entry of widths)if (typeof entry === "number" || entry instanceof _primitives.Ref) widthsBuf.push(entry.toString());
                                hash.update(widthsBuf.join());
                            }
                            if (composite) {
                                hash.update("compositeFont");
                                const compositeWidths = dict.get("W") || baseDict.get("W");
                                if (Array.isArray(compositeWidths)) {
                                    const widthsBuf = [];
                                    for (const entry of compositeWidths){
                                        if (typeof entry === "number" || entry instanceof _primitives.Ref) widthsBuf.push(entry.toString());
                                        else if (Array.isArray(entry)) {
                                            const subWidthsBuf = [];
                                            for (const element of entry)if (typeof element === "number" || element instanceof _primitives.Ref) subWidthsBuf.push(element.toString());
                                            widthsBuf.push(`[${subWidthsBuf.join()}]`);
                                        }
                                    }
                                    hash.update(widthsBuf.join());
                                }
                                const cidToGidMap = dict.getRaw("CIDToGIDMap") || baseDict.getRaw("CIDToGIDMap");
                                if (cidToGidMap instanceof _primitives.Name) hash.update(cidToGidMap.name);
                                else if (cidToGidMap instanceof _primitives.Ref) hash.update(cidToGidMap.toString());
                                else if (cidToGidMap instanceof _base_stream.BaseStream) hash.update(cidToGidMap.peekBytes());
                            }
                        }
                        return {
                            descriptor: descriptor,
                            dict: dict,
                            baseDict: baseDict,
                            composite: composite,
                            type: type.name,
                            firstChar: firstChar,
                            lastChar: lastChar,
                            toUnicode: toUnicode,
                            hash: hash ? hash.hexdigest() : ""
                        };
                    }
                    async translateFont({ descriptor: descriptor, dict: dict, baseDict: baseDict, composite: composite, type: type, firstChar: firstChar, lastChar: lastChar, toUnicode: toUnicode, cssFontInfo: cssFontInfo }) {
                        const isType3Font = type === "Type3";
                        let properties;
                        if (!descriptor) {
                            if (isType3Font) {
                                descriptor = new _primitives.Dict(null);
                                descriptor.set("FontName", _primitives.Name.get(type));
                                descriptor.set("FontBBox", dict.getArray("FontBBox") || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            } else {
                                let baseFontName = dict.get("BaseFont");
                                if (!(baseFontName instanceof _primitives.Name)) throw new _util.FormatError("Base font is not specified");
                                baseFontName = baseFontName.name.replaceAll(/[,_]/g, "-");
                                const metrics = this.getBaseFontMetrics(baseFontName);
                                const fontNameWoStyle = baseFontName.split("-")[0];
                                const flags = (this.isSerifFont(fontNameWoStyle) ? _fonts_utils.FontFlags.Serif : 0) | (metrics.monospace ? _fonts_utils.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts_utils.FontFlags.Symbolic : _fonts_utils.FontFlags.Nonsymbolic);
                                properties = {
                                    type: type,
                                    name: baseFontName,
                                    loadedName: baseDict.loadedName,
                                    systemFontInfo: null,
                                    widths: metrics.widths,
                                    defaultWidth: metrics.defaultWidth,
                                    isSimulatedFlags: true,
                                    flags: flags,
                                    firstChar: firstChar,
                                    lastChar: lastChar,
                                    toUnicode: toUnicode,
                                    xHeight: 0,
                                    capHeight: 0,
                                    italicAngle: 0,
                                    isType3Font: isType3Font
                                };
                                const widths = dict.get("Widths");
                                const standardFontName = (0, _standard_fonts.getStandardFontName)(baseFontName);
                                let file = null;
                                if (standardFontName) {
                                    file = await this.fetchStandardFontData(standardFontName);
                                    properties.isInternalFont = !!file;
                                }
                                if (!properties.isInternalFont && this.options.useSystemFonts) properties.systemFontInfo = (0, _font_substitutions.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, baseFontName, standardFontName);
                                return this.extractDataStructures(dict, dict, properties).then((newProperties)=>{
                                    if (widths) {
                                        const glyphWidths = [];
                                        let j = firstChar;
                                        for (const width of widths)glyphWidths[j++] = this.xref.fetchIfRef(width);
                                        newProperties.widths = glyphWidths;
                                    } else newProperties.widths = this.buildCharCodeToWidth(metrics.widths, newProperties);
                                    return new _fonts.Font(baseFontName, file, newProperties);
                                });
                            }
                        }
                        let fontName = descriptor.get("FontName");
                        let baseFont = dict.get("BaseFont");
                        if (typeof fontName === "string") fontName = _primitives.Name.get(fontName);
                        if (typeof baseFont === "string") baseFont = _primitives.Name.get(baseFont);
                        const fontNameStr = fontName?.name;
                        const baseFontStr = baseFont?.name;
                        if (!isType3Font && fontNameStr !== baseFontStr) {
                            (0, _util.info)(`The FontDescriptor's FontName is "${fontNameStr}" but ` + `should be the same as the Font's BaseFont "${baseFontStr}".`);
                            if (fontNameStr && baseFontStr && (baseFontStr.startsWith(fontNameStr) || !(0, _standard_fonts.isKnownFontName)(fontNameStr) && (0, _standard_fonts.isKnownFontName)(baseFontStr))) fontName = null;
                        }
                        fontName ||= baseFont;
                        if (!(fontName instanceof _primitives.Name)) throw new _util.FormatError("invalid font name");
                        let fontFile, subtype, length1, length2, length3;
                        try {
                            fontFile = descriptor.get("FontFile", "FontFile2", "FontFile3");
                        } catch (ex) {
                            if (!this.options.ignoreErrors) throw ex;
                            (0, _util.warn)(`translateFont - fetching "${fontName.name}" font file: "${ex}".`);
                            fontFile = new _stream.NullStream();
                        }
                        let isInternalFont = false;
                        let glyphScaleFactors = null;
                        let systemFontInfo = null;
                        if (fontFile) {
                            if (fontFile.dict) {
                                const subtypeEntry = fontFile.dict.get("Subtype");
                                if (subtypeEntry instanceof _primitives.Name) subtype = subtypeEntry.name;
                                length1 = fontFile.dict.get("Length1");
                                length2 = fontFile.dict.get("Length2");
                                length3 = fontFile.dict.get("Length3");
                            }
                        } else if (cssFontInfo) {
                            const standardFontName = (0, _xfa_fonts.getXfaFontName)(fontName.name);
                            if (standardFontName) {
                                cssFontInfo.fontFamily = `${cssFontInfo.fontFamily}-PdfJS-XFA`;
                                cssFontInfo.metrics = standardFontName.metrics || null;
                                glyphScaleFactors = standardFontName.factors || null;
                                fontFile = await this.fetchStandardFontData(standardFontName.name);
                                isInternalFont = !!fontFile;
                                baseDict = dict = (0, _xfa_fonts.getXfaFontDict)(fontName.name);
                                composite = true;
                            }
                        } else if (!isType3Font) {
                            const standardFontName = (0, _standard_fonts.getStandardFontName)(fontName.name);
                            if (standardFontName) {
                                fontFile = await this.fetchStandardFontData(standardFontName);
                                isInternalFont = !!fontFile;
                            }
                            if (!isInternalFont && this.options.useSystemFonts) systemFontInfo = (0, _font_substitutions.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, fontName.name, standardFontName);
                        }
                        properties = {
                            type: type,
                            name: fontName.name,
                            subtype: subtype,
                            file: fontFile,
                            length1: length1,
                            length2: length2,
                            length3: length3,
                            isInternalFont: isInternalFont,
                            loadedName: baseDict.loadedName,
                            composite: composite,
                            fixedPitch: false,
                            fontMatrix: dict.getArray("FontMatrix") || _util.FONT_IDENTITY_MATRIX,
                            firstChar: firstChar,
                            lastChar: lastChar,
                            toUnicode: toUnicode,
                            bbox: descriptor.getArray("FontBBox") || dict.getArray("FontBBox"),
                            ascent: descriptor.get("Ascent"),
                            descent: descriptor.get("Descent"),
                            xHeight: descriptor.get("XHeight") || 0,
                            capHeight: descriptor.get("CapHeight") || 0,
                            flags: descriptor.get("Flags"),
                            italicAngle: descriptor.get("ItalicAngle") || 0,
                            isType3Font: isType3Font,
                            cssFontInfo: cssFontInfo,
                            scaleFactors: glyphScaleFactors,
                            systemFontInfo: systemFontInfo
                        };
                        if (composite) {
                            const cidEncoding = baseDict.get("Encoding");
                            if (cidEncoding instanceof _primitives.Name) properties.cidEncoding = cidEncoding.name;
                            const cMap = await _cmap.CMapFactory.create({
                                encoding: cidEncoding,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            properties.cMap = cMap;
                            properties.vertical = properties.cMap.vertical;
                        }
                        return this.extractDataStructures(dict, baseDict, properties).then((newProperties)=>{
                            this.extractWidths(dict, descriptor, newProperties);
                            return new _fonts.Font(fontName.name, fontFile, newProperties);
                        });
                    }
                    static buildFontPaths(font1, glyphs, handler, evaluatorOptions) {
                        function buildPath(fontChar) {
                            const glyphName = `${font1.loadedName}_path_${fontChar}`;
                            try {
                                if (font1.renderer.hasBuiltPath(fontChar)) return;
                                handler.send("commonobj", [
                                    glyphName,
                                    "FontPath",
                                    font1.renderer.getPathJs(fontChar)
                                ]);
                            } catch (reason) {
                                if (evaluatorOptions.ignoreErrors) {
                                    (0, _util.warn)(`buildFontPaths - ignoring ${glyphName} glyph: "${reason}".`);
                                    return;
                                }
                                throw reason;
                            }
                        }
                        for (const glyph of glyphs){
                            buildPath(glyph.fontChar);
                            const accent = glyph.accent;
                            if (accent?.fontChar) buildPath(accent.fontChar);
                        }
                    }
                    static get fallbackFontDict() {
                        const dict = new _primitives.Dict();
                        dict.set("BaseFont", _primitives.Name.get("Helvetica"));
                        dict.set("Type", _primitives.Name.get("FallbackType"));
                        dict.set("Subtype", _primitives.Name.get("FallbackType"));
                        dict.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                        return (0, _util.shadow)(this, "fallbackFontDict", dict);
                    }
                }
                exports.PartialEvaluator = PartialEvaluator;
                class TranslatedFont {
                    constructor({ loadedName: loadedName, font: font1, dict: dict, evaluatorOptions: evaluatorOptions }){
                        this.loadedName = loadedName;
                        this.font = font1;
                        this.dict = dict;
                        this._evaluatorOptions = evaluatorOptions || DefaultPartialEvaluatorOptions;
                        this.type3Loaded = null;
                        this.type3Dependencies = font1.isType3Font ? new Set() : null;
                        this.sent = false;
                    }
                    send(handler) {
                        if (this.sent) return;
                        this.sent = true;
                        handler.send("commonobj", [
                            this.loadedName,
                            "Font",
                            this.font.exportData(this._evaluatorOptions.fontExtraProperties)
                        ]);
                    }
                    fallback(handler) {
                        if (!this.font.data) return;
                        this.font.disableFontFace = true;
                        PartialEvaluator.buildFontPaths(this.font, this.font.glyphCacheValues, handler, this._evaluatorOptions);
                    }
                    loadType3Data(evaluator, resources, task) {
                        if (this.type3Loaded) return this.type3Loaded;
                        if (!this.font.isType3Font) throw new Error("Must be a Type3 font.");
                        const type3Evaluator = evaluator.clone({
                            ignoreErrors: false
                        });
                        type3Evaluator.parsingType3Font = true;
                        const type3FontRefs = new _primitives.RefSet(evaluator.type3FontRefs);
                        if (this.dict.objId && !type3FontRefs.has(this.dict.objId)) type3FontRefs.put(this.dict.objId);
                        type3Evaluator.type3FontRefs = type3FontRefs;
                        const translatedFont = this.font, type3Dependencies = this.type3Dependencies;
                        let loadCharProcsPromise = Promise.resolve();
                        const charProcs = this.dict.get("CharProcs");
                        const fontResources = this.dict.get("Resources") || resources;
                        const charProcOperatorList = Object.create(null);
                        const fontBBox = _util.Util.normalizeRect(translatedFont.bbox || [
                            0,
                            0,
                            0,
                            0
                        ]), width = fontBBox[2] - fontBBox[0], height = fontBBox[3] - fontBBox[1];
                        const fontBBoxSize = Math.hypot(width, height);
                        for (const key of charProcs.getKeys())loadCharProcsPromise = loadCharProcsPromise.then(()=>{
                            const glyphStream = charProcs.get(key);
                            const operatorList = new _operator_list.OperatorList();
                            return type3Evaluator.getOperatorList({
                                stream: glyphStream,
                                task: task,
                                resources: fontResources,
                                operatorList: operatorList
                            }).then(()=>{
                                if (operatorList.fnArray[0] === _util.OPS.setCharWidthAndBounds) this._removeType3ColorOperators(operatorList, fontBBoxSize);
                                charProcOperatorList[key] = operatorList.getIR();
                                for (const dependency of operatorList.dependencies)type3Dependencies.add(dependency);
                            }).catch(function(reason) {
                                (0, _util.warn)(`Type3 font resource "${key}" is not available.`);
                                const dummyOperatorList = new _operator_list.OperatorList();
                                charProcOperatorList[key] = dummyOperatorList.getIR();
                            });
                        });
                        this.type3Loaded = loadCharProcsPromise.then(()=>{
                            translatedFont.charProcOperatorList = charProcOperatorList;
                            if (this._bbox) {
                                translatedFont.isCharBBox = true;
                                translatedFont.bbox = this._bbox;
                            }
                        });
                        return this.type3Loaded;
                    }
                    _removeType3ColorOperators(operatorList, fontBBoxSize = NaN) {
                        const charBBox = _util.Util.normalizeRect(operatorList.argsArray[0].slice(2)), width = charBBox[2] - charBBox[0], height = charBBox[3] - charBBox[1];
                        const charBBoxSize = Math.hypot(width, height);
                        if (width === 0 || height === 0) {
                            operatorList.fnArray.splice(0, 1);
                            operatorList.argsArray.splice(0, 1);
                        } else if (fontBBoxSize === 0 || Math.round(charBBoxSize / fontBBoxSize) >= 10) {
                            if (!this._bbox) this._bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            this._bbox[0] = Math.min(this._bbox[0], charBBox[0]);
                            this._bbox[1] = Math.min(this._bbox[1], charBBox[1]);
                            this._bbox[2] = Math.max(this._bbox[2], charBBox[2]);
                            this._bbox[3] = Math.max(this._bbox[3], charBBox[3]);
                        }
                        let i = 0, ii = operatorList.length;
                        while(i < ii){
                            switch(operatorList.fnArray[i]){
                                case _util.OPS.setCharWidthAndBounds:
                                    break;
                                case _util.OPS.setStrokeColorSpace:
                                case _util.OPS.setFillColorSpace:
                                case _util.OPS.setStrokeColor:
                                case _util.OPS.setStrokeColorN:
                                case _util.OPS.setFillColor:
                                case _util.OPS.setFillColorN:
                                case _util.OPS.setStrokeGray:
                                case _util.OPS.setFillGray:
                                case _util.OPS.setStrokeRGBColor:
                                case _util.OPS.setFillRGBColor:
                                case _util.OPS.setStrokeCMYKColor:
                                case _util.OPS.setFillCMYKColor:
                                case _util.OPS.shadingFill:
                                case _util.OPS.setRenderingIntent:
                                    operatorList.fnArray.splice(i, 1);
                                    operatorList.argsArray.splice(i, 1);
                                    ii--;
                                    continue;
                                case _util.OPS.setGState:
                                    const [gStateObj] = operatorList.argsArray[i];
                                    let j = 0, jj = gStateObj.length;
                                    while(j < jj){
                                        const [gStateKey] = gStateObj[j];
                                        switch(gStateKey){
                                            case "TR":
                                            case "TR2":
                                            case "HT":
                                            case "BG":
                                            case "BG2":
                                            case "UCR":
                                            case "UCR2":
                                                gStateObj.splice(j, 1);
                                                jj--;
                                                continue;
                                        }
                                        j++;
                                    }
                                    break;
                            }
                            i++;
                        }
                    }
                }
                class StateManager {
                    constructor(initialState = new EvalState()){
                        this.state = initialState;
                        this.stateStack = [];
                    }
                    save() {
                        const old = this.state;
                        this.stateStack.push(this.state);
                        this.state = old.clone();
                    }
                    restore() {
                        const prev = this.stateStack.pop();
                        if (prev) this.state = prev;
                    }
                    transform(args) {
                        this.state.ctm = _util.Util.transform(this.state.ctm, args);
                    }
                }
                class TextState {
                    constructor(){
                        this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
                        this.fontName = null;
                        this.fontSize = 0;
                        this.loadedName = null;
                        this.font = null;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.textMatrix = _util.IDENTITY_MATRIX.slice();
                        this.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.leading = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const m = this.textMatrix;
                        m[0] = a;
                        m[1] = b;
                        m[2] = c;
                        m[3] = d;
                        m[4] = e;
                        m[5] = f;
                    }
                    setTextLineMatrix(a, b, c, d, e, f) {
                        const m = this.textLineMatrix;
                        m[0] = a;
                        m[1] = b;
                        m[2] = c;
                        m[3] = d;
                        m[4] = e;
                        m[5] = f;
                    }
                    translateTextMatrix(x, y) {
                        const m = this.textMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                    }
                    translateTextLineMatrix(x, y) {
                        const m = this.textLineMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                    }
                    carriageReturn() {
                        this.translateTextLineMatrix(0, -this.leading);
                        this.textMatrix = this.textLineMatrix.slice();
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.textMatrix = this.textMatrix.slice();
                        clone.textLineMatrix = this.textLineMatrix.slice();
                        clone.fontMatrix = this.fontMatrix.slice();
                        return clone;
                    }
                }
                class EvalState {
                    constructor(){
                        this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
                        this.font = null;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                        this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                    }
                    clone() {
                        return Object.create(this);
                    }
                }
                class EvaluatorPreprocessor {
                    static get opMap() {
                        return (0, _util.shadow)(this, "opMap", {
                            w: {
                                id: _util.OPS.setLineWidth,
                                numArgs: 1,
                                variableArgs: false
                            },
                            J: {
                                id: _util.OPS.setLineCap,
                                numArgs: 1,
                                variableArgs: false
                            },
                            j: {
                                id: _util.OPS.setLineJoin,
                                numArgs: 1,
                                variableArgs: false
                            },
                            M: {
                                id: _util.OPS.setMiterLimit,
                                numArgs: 1,
                                variableArgs: false
                            },
                            d: {
                                id: _util.OPS.setDash,
                                numArgs: 2,
                                variableArgs: false
                            },
                            ri: {
                                id: _util.OPS.setRenderingIntent,
                                numArgs: 1,
                                variableArgs: false
                            },
                            i: {
                                id: _util.OPS.setFlatness,
                                numArgs: 1,
                                variableArgs: false
                            },
                            gs: {
                                id: _util.OPS.setGState,
                                numArgs: 1,
                                variableArgs: false
                            },
                            q: {
                                id: _util.OPS.save,
                                numArgs: 0,
                                variableArgs: false
                            },
                            Q: {
                                id: _util.OPS.restore,
                                numArgs: 0,
                                variableArgs: false
                            },
                            cm: {
                                id: _util.OPS.transform,
                                numArgs: 6,
                                variableArgs: false
                            },
                            m: {
                                id: _util.OPS.moveTo,
                                numArgs: 2,
                                variableArgs: false
                            },
                            l: {
                                id: _util.OPS.lineTo,
                                numArgs: 2,
                                variableArgs: false
                            },
                            c: {
                                id: _util.OPS.curveTo,
                                numArgs: 6,
                                variableArgs: false
                            },
                            v: {
                                id: _util.OPS.curveTo2,
                                numArgs: 4,
                                variableArgs: false
                            },
                            y: {
                                id: _util.OPS.curveTo3,
                                numArgs: 4,
                                variableArgs: false
                            },
                            h: {
                                id: _util.OPS.closePath,
                                numArgs: 0,
                                variableArgs: false
                            },
                            re: {
                                id: _util.OPS.rectangle,
                                numArgs: 4,
                                variableArgs: false
                            },
                            S: {
                                id: _util.OPS.stroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            s: {
                                id: _util.OPS.closeStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            f: {
                                id: _util.OPS.fill,
                                numArgs: 0,
                                variableArgs: false
                            },
                            F: {
                                id: _util.OPS.fill,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "f*": {
                                id: _util.OPS.eoFill,
                                numArgs: 0,
                                variableArgs: false
                            },
                            B: {
                                id: _util.OPS.fillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "B*": {
                                id: _util.OPS.eoFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            b: {
                                id: _util.OPS.closeFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "b*": {
                                id: _util.OPS.closeEOFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            n: {
                                id: _util.OPS.endPath,
                                numArgs: 0,
                                variableArgs: false
                            },
                            W: {
                                id: _util.OPS.clip,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "W*": {
                                id: _util.OPS.eoClip,
                                numArgs: 0,
                                variableArgs: false
                            },
                            BT: {
                                id: _util.OPS.beginText,
                                numArgs: 0,
                                variableArgs: false
                            },
                            ET: {
                                id: _util.OPS.endText,
                                numArgs: 0,
                                variableArgs: false
                            },
                            Tc: {
                                id: _util.OPS.setCharSpacing,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Tw: {
                                id: _util.OPS.setWordSpacing,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Tz: {
                                id: _util.OPS.setHScale,
                                numArgs: 1,
                                variableArgs: false
                            },
                            TL: {
                                id: _util.OPS.setLeading,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Tf: {
                                id: _util.OPS.setFont,
                                numArgs: 2,
                                variableArgs: false
                            },
                            Tr: {
                                id: _util.OPS.setTextRenderingMode,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Ts: {
                                id: _util.OPS.setTextRise,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Td: {
                                id: _util.OPS.moveText,
                                numArgs: 2,
                                variableArgs: false
                            },
                            TD: {
                                id: _util.OPS.setLeadingMoveText,
                                numArgs: 2,
                                variableArgs: false
                            },
                            Tm: {
                                id: _util.OPS.setTextMatrix,
                                numArgs: 6,
                                variableArgs: false
                            },
                            "T*": {
                                id: _util.OPS.nextLine,
                                numArgs: 0,
                                variableArgs: false
                            },
                            Tj: {
                                id: _util.OPS.showText,
                                numArgs: 1,
                                variableArgs: false
                            },
                            TJ: {
                                id: _util.OPS.showSpacedText,
                                numArgs: 1,
                                variableArgs: false
                            },
                            "'": {
                                id: _util.OPS.nextLineShowText,
                                numArgs: 1,
                                variableArgs: false
                            },
                            '"': {
                                id: _util.OPS.nextLineSetSpacingShowText,
                                numArgs: 3,
                                variableArgs: false
                            },
                            d0: {
                                id: _util.OPS.setCharWidth,
                                numArgs: 2,
                                variableArgs: false
                            },
                            d1: {
                                id: _util.OPS.setCharWidthAndBounds,
                                numArgs: 6,
                                variableArgs: false
                            },
                            CS: {
                                id: _util.OPS.setStrokeColorSpace,
                                numArgs: 1,
                                variableArgs: false
                            },
                            cs: {
                                id: _util.OPS.setFillColorSpace,
                                numArgs: 1,
                                variableArgs: false
                            },
                            SC: {
                                id: _util.OPS.setStrokeColor,
                                numArgs: 4,
                                variableArgs: true
                            },
                            SCN: {
                                id: _util.OPS.setStrokeColorN,
                                numArgs: 33,
                                variableArgs: true
                            },
                            sc: {
                                id: _util.OPS.setFillColor,
                                numArgs: 4,
                                variableArgs: true
                            },
                            scn: {
                                id: _util.OPS.setFillColorN,
                                numArgs: 33,
                                variableArgs: true
                            },
                            G: {
                                id: _util.OPS.setStrokeGray,
                                numArgs: 1,
                                variableArgs: false
                            },
                            g: {
                                id: _util.OPS.setFillGray,
                                numArgs: 1,
                                variableArgs: false
                            },
                            RG: {
                                id: _util.OPS.setStrokeRGBColor,
                                numArgs: 3,
                                variableArgs: false
                            },
                            rg: {
                                id: _util.OPS.setFillRGBColor,
                                numArgs: 3,
                                variableArgs: false
                            },
                            K: {
                                id: _util.OPS.setStrokeCMYKColor,
                                numArgs: 4,
                                variableArgs: false
                            },
                            k: {
                                id: _util.OPS.setFillCMYKColor,
                                numArgs: 4,
                                variableArgs: false
                            },
                            sh: {
                                id: _util.OPS.shadingFill,
                                numArgs: 1,
                                variableArgs: false
                            },
                            BI: {
                                id: _util.OPS.beginInlineImage,
                                numArgs: 0,
                                variableArgs: false
                            },
                            ID: {
                                id: _util.OPS.beginImageData,
                                numArgs: 0,
                                variableArgs: false
                            },
                            EI: {
                                id: _util.OPS.endInlineImage,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Do: {
                                id: _util.OPS.paintXObject,
                                numArgs: 1,
                                variableArgs: false
                            },
                            MP: {
                                id: _util.OPS.markPoint,
                                numArgs: 1,
                                variableArgs: false
                            },
                            DP: {
                                id: _util.OPS.markPointProps,
                                numArgs: 2,
                                variableArgs: false
                            },
                            BMC: {
                                id: _util.OPS.beginMarkedContent,
                                numArgs: 1,
                                variableArgs: false
                            },
                            BDC: {
                                id: _util.OPS.beginMarkedContentProps,
                                numArgs: 2,
                                variableArgs: false
                            },
                            EMC: {
                                id: _util.OPS.endMarkedContent,
                                numArgs: 0,
                                variableArgs: false
                            },
                            BX: {
                                id: _util.OPS.beginCompat,
                                numArgs: 0,
                                variableArgs: false
                            },
                            EX: {
                                id: _util.OPS.endCompat,
                                numArgs: 0,
                                variableArgs: false
                            },
                            BM: null,
                            BD: null,
                            true: null,
                            fa: null,
                            fal: null,
                            fals: null,
                            false: null,
                            nu: null,
                            nul: null,
                            null: null
                        });
                    }
                    static MAX_INVALID_PATH_OPS = 10;
                    constructor(stream, xref, stateManager = new StateManager()){
                        this.parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream, EvaluatorPreprocessor.opMap),
                            xref: xref
                        });
                        this.stateManager = stateManager;
                        this.nonProcessedArgs = [];
                        this._isPathOp = false;
                        this._numInvalidPathOPS = 0;
                    }
                    get savedStatesDepth() {
                        return this.stateManager.stateStack.length;
                    }
                    read(operation) {
                        let args = operation.args;
                        while(true){
                            const obj = this.parser.getObj();
                            if (obj instanceof _primitives.Cmd) {
                                const cmd = obj.cmd;
                                const opSpec = EvaluatorPreprocessor.opMap[cmd];
                                if (!opSpec) {
                                    (0, _util.warn)(`Unknown command "${cmd}".`);
                                    continue;
                                }
                                const fn = opSpec.id;
                                const numArgs = opSpec.numArgs;
                                let argsLength = args !== null ? args.length : 0;
                                if (!this._isPathOp) this._numInvalidPathOPS = 0;
                                this._isPathOp = fn >= _util.OPS.moveTo && fn <= _util.OPS.endPath;
                                if (!opSpec.variableArgs) {
                                    if (argsLength !== numArgs) {
                                        const nonProcessedArgs = this.nonProcessedArgs;
                                        while(argsLength > numArgs){
                                            nonProcessedArgs.push(args.shift());
                                            argsLength--;
                                        }
                                        while(argsLength < numArgs && nonProcessedArgs.length !== 0){
                                            if (args === null) args = [];
                                            args.unshift(nonProcessedArgs.pop());
                                            argsLength++;
                                        }
                                    }
                                    if (argsLength < numArgs) {
                                        const partialMsg = `command ${cmd}: expected ${numArgs} args, ` + `but received ${argsLength} args.`;
                                        if (this._isPathOp && ++this._numInvalidPathOPS > EvaluatorPreprocessor.MAX_INVALID_PATH_OPS) throw new _util.FormatError(`Invalid ${partialMsg}`);
                                        (0, _util.warn)(`Skipping ${partialMsg}`);
                                        if (args !== null) args.length = 0;
                                        continue;
                                    }
                                } else if (argsLength > numArgs) (0, _util.info)(`Command ${cmd}: expected [0, ${numArgs}] args, ` + `but received ${argsLength} args.`);
                                this.preprocessCommand(fn, args);
                                operation.fn = fn;
                                operation.args = args;
                                return true;
                            }
                            if (obj === _primitives.EOF) return false;
                            if (obj !== null) {
                                if (args === null) args = [];
                                args.push(obj);
                                if (args.length > 33) throw new _util.FormatError("Too many arguments");
                            }
                        }
                    }
                    preprocessCommand(fn, args) {
                        switch(fn | 0){
                            case _util.OPS.save:
                                this.stateManager.save();
                                break;
                            case _util.OPS.restore:
                                this.stateManager.restore();
                                break;
                            case _util.OPS.transform:
                                this.stateManager.transform(args);
                                break;
                        }
                    }
                }
                exports.EvaluatorPreprocessor = EvaluatorPreprocessor;
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.IdentityCMap = exports.CMapFactory = exports.CMap = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                var _binary_cmap = __w_pdfjs_require__(15);
                var _parser = __w_pdfjs_require__(16);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                const BUILT_IN_CMAPS = [
                    "Adobe-GB1-UCS2",
                    "Adobe-CNS1-UCS2",
                    "Adobe-Japan1-UCS2",
                    "Adobe-Korea1-UCS2",
                    "78-EUC-H",
                    "78-EUC-V",
                    "78-H",
                    "78-RKSJ-H",
                    "78-RKSJ-V",
                    "78-V",
                    "78ms-RKSJ-H",
                    "78ms-RKSJ-V",
                    "83pv-RKSJ-H",
                    "90ms-RKSJ-H",
                    "90ms-RKSJ-V",
                    "90msp-RKSJ-H",
                    "90msp-RKSJ-V",
                    "90pv-RKSJ-H",
                    "90pv-RKSJ-V",
                    "Add-H",
                    "Add-RKSJ-H",
                    "Add-RKSJ-V",
                    "Add-V",
                    "Adobe-CNS1-0",
                    "Adobe-CNS1-1",
                    "Adobe-CNS1-2",
                    "Adobe-CNS1-3",
                    "Adobe-CNS1-4",
                    "Adobe-CNS1-5",
                    "Adobe-CNS1-6",
                    "Adobe-GB1-0",
                    "Adobe-GB1-1",
                    "Adobe-GB1-2",
                    "Adobe-GB1-3",
                    "Adobe-GB1-4",
                    "Adobe-GB1-5",
                    "Adobe-Japan1-0",
                    "Adobe-Japan1-1",
                    "Adobe-Japan1-2",
                    "Adobe-Japan1-3",
                    "Adobe-Japan1-4",
                    "Adobe-Japan1-5",
                    "Adobe-Japan1-6",
                    "Adobe-Korea1-0",
                    "Adobe-Korea1-1",
                    "Adobe-Korea1-2",
                    "B5-H",
                    "B5-V",
                    "B5pc-H",
                    "B5pc-V",
                    "CNS-EUC-H",
                    "CNS-EUC-V",
                    "CNS1-H",
                    "CNS1-V",
                    "CNS2-H",
                    "CNS2-V",
                    "ETHK-B5-H",
                    "ETHK-B5-V",
                    "ETen-B5-H",
                    "ETen-B5-V",
                    "ETenms-B5-H",
                    "ETenms-B5-V",
                    "EUC-H",
                    "EUC-V",
                    "Ext-H",
                    "Ext-RKSJ-H",
                    "Ext-RKSJ-V",
                    "Ext-V",
                    "GB-EUC-H",
                    "GB-EUC-V",
                    "GB-H",
                    "GB-V",
                    "GBK-EUC-H",
                    "GBK-EUC-V",
                    "GBK2K-H",
                    "GBK2K-V",
                    "GBKp-EUC-H",
                    "GBKp-EUC-V",
                    "GBT-EUC-H",
                    "GBT-EUC-V",
                    "GBT-H",
                    "GBT-V",
                    "GBTpc-EUC-H",
                    "GBTpc-EUC-V",
                    "GBpc-EUC-H",
                    "GBpc-EUC-V",
                    "H",
                    "HKdla-B5-H",
                    "HKdla-B5-V",
                    "HKdlb-B5-H",
                    "HKdlb-B5-V",
                    "HKgccs-B5-H",
                    "HKgccs-B5-V",
                    "HKm314-B5-H",
                    "HKm314-B5-V",
                    "HKm471-B5-H",
                    "HKm471-B5-V",
                    "HKscs-B5-H",
                    "HKscs-B5-V",
                    "Hankaku",
                    "Hiragana",
                    "KSC-EUC-H",
                    "KSC-EUC-V",
                    "KSC-H",
                    "KSC-Johab-H",
                    "KSC-Johab-V",
                    "KSC-V",
                    "KSCms-UHC-H",
                    "KSCms-UHC-HW-H",
                    "KSCms-UHC-HW-V",
                    "KSCms-UHC-V",
                    "KSCpc-EUC-H",
                    "KSCpc-EUC-V",
                    "Katakana",
                    "NWP-H",
                    "NWP-V",
                    "RKSJ-H",
                    "RKSJ-V",
                    "Roman",
                    "UniCNS-UCS2-H",
                    "UniCNS-UCS2-V",
                    "UniCNS-UTF16-H",
                    "UniCNS-UTF16-V",
                    "UniCNS-UTF32-H",
                    "UniCNS-UTF32-V",
                    "UniCNS-UTF8-H",
                    "UniCNS-UTF8-V",
                    "UniGB-UCS2-H",
                    "UniGB-UCS2-V",
                    "UniGB-UTF16-H",
                    "UniGB-UTF16-V",
                    "UniGB-UTF32-H",
                    "UniGB-UTF32-V",
                    "UniGB-UTF8-H",
                    "UniGB-UTF8-V",
                    "UniJIS-UCS2-H",
                    "UniJIS-UCS2-HW-H",
                    "UniJIS-UCS2-HW-V",
                    "UniJIS-UCS2-V",
                    "UniJIS-UTF16-H",
                    "UniJIS-UTF16-V",
                    "UniJIS-UTF32-H",
                    "UniJIS-UTF32-V",
                    "UniJIS-UTF8-H",
                    "UniJIS-UTF8-V",
                    "UniJIS2004-UTF16-H",
                    "UniJIS2004-UTF16-V",
                    "UniJIS2004-UTF32-H",
                    "UniJIS2004-UTF32-V",
                    "UniJIS2004-UTF8-H",
                    "UniJIS2004-UTF8-V",
                    "UniJISPro-UCS2-HW-V",
                    "UniJISPro-UCS2-V",
                    "UniJISPro-UTF8-V",
                    "UniJISX0213-UTF32-H",
                    "UniJISX0213-UTF32-V",
                    "UniJISX02132004-UTF32-H",
                    "UniJISX02132004-UTF32-V",
                    "UniKS-UCS2-H",
                    "UniKS-UCS2-V",
                    "UniKS-UTF16-H",
                    "UniKS-UTF16-V",
                    "UniKS-UTF32-H",
                    "UniKS-UTF32-V",
                    "UniKS-UTF8-H",
                    "UniKS-UTF8-V",
                    "V",
                    "WP-Symbol"
                ];
                const MAX_MAP_RANGE = 2 ** 24 - 1;
                class CMap {
                    constructor(builtInCMap = false){
                        this.codespaceRanges = [
                            [],
                            [],
                            [],
                            []
                        ];
                        this.numCodespaceRanges = 0;
                        this._map = [];
                        this.name = "";
                        this.vertical = false;
                        this.useCMap = null;
                        this.builtInCMap = builtInCMap;
                    }
                    addCodespaceRange(n, low, high) {
                        this.codespaceRanges[n - 1].push(low, high);
                        this.numCodespaceRanges++;
                    }
                    mapCidRange(low, high, dstLow) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
                        while(low <= high)this._map[low++] = dstLow++;
                    }
                    mapBfRange(low, high, dstLow) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
                        const lastByte = dstLow.length - 1;
                        while(low <= high){
                            this._map[low++] = dstLow;
                            const nextCharCode = dstLow.charCodeAt(lastByte) + 1;
                            if (nextCharCode > 0xff) {
                                dstLow = dstLow.substring(0, lastByte - 1) + String.fromCharCode(dstLow.charCodeAt(lastByte - 1) + 1) + "\x00";
                                continue;
                            }
                            dstLow = dstLow.substring(0, lastByte) + String.fromCharCode(nextCharCode);
                        }
                    }
                    mapBfRangeToArray(low, high, array) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
                        const ii = array.length;
                        let i = 0;
                        while(low <= high && i < ii){
                            this._map[low] = array[i++];
                            ++low;
                        }
                    }
                    mapOne(src, dst) {
                        this._map[src] = dst;
                    }
                    lookup(code) {
                        return this._map[code];
                    }
                    contains(code) {
                        return this._map[code] !== undefined;
                    }
                    forEach(callback) {
                        const map = this._map;
                        const length = map.length;
                        if (length <= 0x10000) {
                            for(let i = 0; i < length; i++)if (map[i] !== undefined) callback(i, map[i]);
                        } else for(const i in map)callback(i, map[i]);
                    }
                    charCodeOf(value) {
                        const map = this._map;
                        if (map.length <= 0x10000) return map.indexOf(value);
                        for(const charCode in map){
                            if (map[charCode] === value) return charCode | 0;
                        }
                        return -1;
                    }
                    getMap() {
                        return this._map;
                    }
                    readCharCode(str, offset, out) {
                        let c = 0;
                        const codespaceRanges = this.codespaceRanges;
                        for(let n = 0, nn = codespaceRanges.length; n < nn; n++){
                            c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
                            const codespaceRange = codespaceRanges[n];
                            for(let k = 0, kk = codespaceRange.length; k < kk;){
                                const low = codespaceRange[k++];
                                const high = codespaceRange[k++];
                                if (c >= low && c <= high) {
                                    out.charcode = c;
                                    out.length = n + 1;
                                    return;
                                }
                            }
                        }
                        out.charcode = 0;
                        out.length = 1;
                    }
                    getCharCodeLength(charCode) {
                        const codespaceRanges = this.codespaceRanges;
                        for(let n = 0, nn = codespaceRanges.length; n < nn; n++){
                            const codespaceRange = codespaceRanges[n];
                            for(let k = 0, kk = codespaceRange.length; k < kk;){
                                const low = codespaceRange[k++];
                                const high = codespaceRange[k++];
                                if (charCode >= low && charCode <= high) return n + 1;
                            }
                        }
                        return 1;
                    }
                    get length() {
                        return this._map.length;
                    }
                    get isIdentityCMap() {
                        if (!(this.name === "Identity-H" || this.name === "Identity-V")) return false;
                        if (this._map.length !== 0x10000) return false;
                        for(let i = 0; i < 0x10000; i++){
                            if (this._map[i] !== i) return false;
                        }
                        return true;
                    }
                }
                exports.CMap = CMap;
                class IdentityCMap extends CMap {
                    constructor(vertical, n){
                        super();
                        this.vertical = vertical;
                        this.addCodespaceRange(n, 0, 0xffff);
                    }
                    mapCidRange(low, high, dstLow) {
                        (0, _util.unreachable)("should not call mapCidRange");
                    }
                    mapBfRange(low, high, dstLow) {
                        (0, _util.unreachable)("should not call mapBfRange");
                    }
                    mapBfRangeToArray(low, high, array) {
                        (0, _util.unreachable)("should not call mapBfRangeToArray");
                    }
                    mapOne(src, dst) {
                        (0, _util.unreachable)("should not call mapCidOne");
                    }
                    lookup(code) {
                        return Number.isInteger(code) && code <= 0xffff ? code : undefined;
                    }
                    contains(code) {
                        return Number.isInteger(code) && code <= 0xffff;
                    }
                    forEach(callback) {
                        for(let i = 0; i <= 0xffff; i++)callback(i, i);
                    }
                    charCodeOf(value) {
                        return Number.isInteger(value) && value <= 0xffff ? value : -1;
                    }
                    getMap() {
                        const map = new Array(0x10000);
                        for(let i = 0; i <= 0xffff; i++)map[i] = i;
                        return map;
                    }
                    get length() {
                        return 0x10000;
                    }
                    get isIdentityCMap() {
                        (0, _util.unreachable)("should not access .isIdentityCMap");
                    }
                }
                exports.IdentityCMap = IdentityCMap;
                function strToInt(str) {
                    let a = 0;
                    for(let i = 0; i < str.length; i++)a = a << 8 | str.charCodeAt(i);
                    return a >>> 0;
                }
                function expectString(obj) {
                    if (typeof obj !== "string") throw new _util.FormatError("Malformed CMap: expected string.");
                }
                function expectInt(obj) {
                    if (!Number.isInteger(obj)) throw new _util.FormatError("Malformed CMap: expected int.");
                }
                function parseBfChar(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endbfchar")) return;
                        expectString(obj);
                        const src = strToInt(obj);
                        obj = lexer.getObj();
                        expectString(obj);
                        const dst = obj;
                        cMap.mapOne(src, dst);
                    }
                }
                function parseBfRange(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endbfrange")) return;
                        expectString(obj);
                        const low = strToInt(obj);
                        obj = lexer.getObj();
                        expectString(obj);
                        const high = strToInt(obj);
                        obj = lexer.getObj();
                        if (Number.isInteger(obj) || typeof obj === "string") {
                            const dstLow = Number.isInteger(obj) ? String.fromCharCode(obj) : obj;
                            cMap.mapBfRange(low, high, dstLow);
                        } else if ((0, _primitives.isCmd)(obj, "[")) {
                            obj = lexer.getObj();
                            const array = [];
                            while(!(0, _primitives.isCmd)(obj, "]") && obj !== _primitives.EOF){
                                array.push(obj);
                                obj = lexer.getObj();
                            }
                            cMap.mapBfRangeToArray(low, high, array);
                        } else break;
                    }
                    throw new _util.FormatError("Invalid bf range.");
                }
                function parseCidChar(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endcidchar")) return;
                        expectString(obj);
                        const src = strToInt(obj);
                        obj = lexer.getObj();
                        expectInt(obj);
                        const dst = obj;
                        cMap.mapOne(src, dst);
                    }
                }
                function parseCidRange(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endcidrange")) return;
                        expectString(obj);
                        const low = strToInt(obj);
                        obj = lexer.getObj();
                        expectString(obj);
                        const high = strToInt(obj);
                        obj = lexer.getObj();
                        expectInt(obj);
                        const dstLow = obj;
                        cMap.mapCidRange(low, high, dstLow);
                    }
                }
                function parseCodespaceRange(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endcodespacerange")) return;
                        if (typeof obj !== "string") break;
                        const low = strToInt(obj);
                        obj = lexer.getObj();
                        if (typeof obj !== "string") break;
                        const high = strToInt(obj);
                        cMap.addCodespaceRange(obj.length, low, high);
                    }
                    throw new _util.FormatError("Invalid codespace range.");
                }
                function parseWMode(cMap, lexer) {
                    const obj = lexer.getObj();
                    if (Number.isInteger(obj)) cMap.vertical = !!obj;
                }
                function parseCMapName(cMap, lexer) {
                    const obj = lexer.getObj();
                    if (obj instanceof _primitives.Name) cMap.name = obj.name;
                }
                async function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
                    let previous, embeddedUseCMap;
                    objLoop: while(true)try {
                        const obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        else if (obj instanceof _primitives.Name) {
                            if (obj.name === "WMode") parseWMode(cMap, lexer);
                            else if (obj.name === "CMapName") parseCMapName(cMap, lexer);
                            previous = obj;
                        } else if (obj instanceof _primitives.Cmd) switch(obj.cmd){
                            case "endcmap":
                                break objLoop;
                            case "usecmap":
                                if (previous instanceof _primitives.Name) embeddedUseCMap = previous.name;
                                break;
                            case "begincodespacerange":
                                parseCodespaceRange(cMap, lexer);
                                break;
                            case "beginbfchar":
                                parseBfChar(cMap, lexer);
                                break;
                            case "begincidchar":
                                parseCidChar(cMap, lexer);
                                break;
                            case "beginbfrange":
                                parseBfRange(cMap, lexer);
                                break;
                            case "begincidrange":
                                parseCidRange(cMap, lexer);
                                break;
                        }
                    } catch (ex) {
                        if (ex instanceof _core_utils.MissingDataException) throw ex;
                        (0, _util.warn)("Invalid cMap data: " + ex);
                        continue;
                    }
                    if (!useCMap && embeddedUseCMap) useCMap = embeddedUseCMap;
                    if (useCMap) return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                    return cMap;
                }
                async function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
                    cMap.useCMap = await createBuiltInCMap(useCMap, fetchBuiltInCMap);
                    if (cMap.numCodespaceRanges === 0) {
                        const useCodespaceRanges = cMap.useCMap.codespaceRanges;
                        for(let i = 0; i < useCodespaceRanges.length; i++)cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
                        cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
                    }
                    cMap.useCMap.forEach(function(key, value) {
                        if (!cMap.contains(key)) cMap.mapOne(key, cMap.useCMap.lookup(key));
                    });
                    return cMap;
                }
                async function createBuiltInCMap(name, fetchBuiltInCMap) {
                    if (name === "Identity-H") return new IdentityCMap(false, 2);
                    else if (name === "Identity-V") return new IdentityCMap(true, 2);
                    if (!BUILT_IN_CMAPS.includes(name)) throw new Error("Unknown CMap name: " + name);
                    if (!fetchBuiltInCMap) throw new Error("Built-in CMap parameters are not provided.");
                    const { cMapData: cMapData, compressionType: compressionType } = await fetchBuiltInCMap(name);
                    const cMap = new CMap(true);
                    if (compressionType === _util.CMapCompressionType.BINARY) return new _binary_cmap.BinaryCMapReader().process(cMapData, cMap, (useCMap)=>{
                        return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                    });
                    if (compressionType === _util.CMapCompressionType.NONE) {
                        const lexer = new _parser.Lexer(new _stream.Stream(cMapData));
                        return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
                    }
                    throw new Error(`Invalid CMap "compressionType" value: ${compressionType}`);
                }
                class CMapFactory {
                    static async create({ encoding: encoding, fetchBuiltInCMap: fetchBuiltInCMap, useCMap: useCMap }) {
                        if (encoding instanceof _primitives.Name) return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
                        else if (encoding instanceof _base_stream.BaseStream) {
                            const parsedCMap = await parseCMap(new CMap(), new _parser.Lexer(encoding), fetchBuiltInCMap, useCMap);
                            if (parsedCMap.isIdentityCMap) return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
                            return parsedCMap;
                        }
                        throw new Error("Encoding required.");
                    }
                }
                exports.CMapFactory = CMapFactory;
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BinaryCMapReader = void 0;
                var _util = __w_pdfjs_require__(2);
                function hexToInt(a, size) {
                    let n = 0;
                    for(let i = 0; i <= size; i++)n = n << 8 | a[i];
                    return n >>> 0;
                }
                function hexToStr(a, size) {
                    if (size === 1) return String.fromCharCode(a[0], a[1]);
                    if (size === 3) return String.fromCharCode(a[0], a[1], a[2], a[3]);
                    return String.fromCharCode(...a.subarray(0, size + 1));
                }
                function addHex(a, b, size) {
                    let c = 0;
                    for(let i = size; i >= 0; i--){
                        c += a[i] + b[i];
                        a[i] = c & 255;
                        c >>= 8;
                    }
                }
                function incHex(a, size) {
                    let c = 1;
                    for(let i = size; i >= 0 && c > 0; i--){
                        c += a[i];
                        a[i] = c & 255;
                        c >>= 8;
                    }
                }
                const MAX_NUM_SIZE = 16;
                const MAX_ENCODED_NUM_SIZE = 19;
                class BinaryCMapStream {
                    constructor(data){
                        this.buffer = data;
                        this.pos = 0;
                        this.end = data.length;
                        this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
                    }
                    readByte() {
                        if (this.pos >= this.end) return -1;
                        return this.buffer[this.pos++];
                    }
                    readNumber() {
                        let n = 0;
                        let last;
                        do {
                            const b = this.readByte();
                            if (b < 0) throw new _util.FormatError("unexpected EOF in bcmap");
                            last = !(b & 0x80);
                            n = n << 7 | b & 0x7f;
                        }while (!last);
                        return n;
                    }
                    readSigned() {
                        const n = this.readNumber();
                        return n & 1 ? ~(n >>> 1) : n >>> 1;
                    }
                    readHex(num, size) {
                        num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
                        this.pos += size + 1;
                    }
                    readHexNumber(num, size) {
                        let last;
                        const stack = this.tmpBuf;
                        let sp = 0;
                        do {
                            const b = this.readByte();
                            if (b < 0) throw new _util.FormatError("unexpected EOF in bcmap");
                            last = !(b & 0x80);
                            stack[sp++] = b & 0x7f;
                        }while (!last);
                        let i = size, buffer = 0, bufferSize = 0;
                        while(i >= 0){
                            while(bufferSize < 8 && stack.length > 0){
                                buffer |= stack[--sp] << bufferSize;
                                bufferSize += 7;
                            }
                            num[i] = buffer & 255;
                            i--;
                            buffer >>= 8;
                            bufferSize -= 8;
                        }
                    }
                    readHexSigned(num, size) {
                        this.readHexNumber(num, size);
                        const sign = num[size] & 1 ? 255 : 0;
                        let c = 0;
                        for(let i = 0; i <= size; i++){
                            c = (c & 1) << 8 | num[i];
                            num[i] = c >> 1 ^ sign;
                        }
                    }
                    readString() {
                        const len = this.readNumber(), buf = new Array(len);
                        for(let i = 0; i < len; i++)buf[i] = this.readNumber();
                        return String.fromCharCode(...buf);
                    }
                }
                class BinaryCMapReader {
                    async process(data, cMap, extend) {
                        const stream = new BinaryCMapStream(data);
                        const header = stream.readByte();
                        cMap.vertical = !!(header & 1);
                        let useCMap = null;
                        const start = new Uint8Array(MAX_NUM_SIZE);
                        const end = new Uint8Array(MAX_NUM_SIZE);
                        const char = new Uint8Array(MAX_NUM_SIZE);
                        const charCode = new Uint8Array(MAX_NUM_SIZE);
                        const tmp = new Uint8Array(MAX_NUM_SIZE);
                        let code;
                        let b;
                        while((b = stream.readByte()) >= 0){
                            const type = b >> 5;
                            if (type === 7) {
                                switch(b & 0x1f){
                                    case 0:
                                        stream.readString();
                                        break;
                                    case 1:
                                        useCMap = stream.readString();
                                        break;
                                }
                                continue;
                            }
                            const sequence = !!(b & 0x10);
                            const dataSize = b & 15;
                            if (dataSize + 1 > MAX_NUM_SIZE) throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                            const ucs2DataSize = 1;
                            const subitemsCount = stream.readNumber();
                            switch(type){
                                case 0:
                                    stream.readHex(start, dataSize);
                                    stream.readHexNumber(end, dataSize);
                                    addHex(end, start, dataSize);
                                    cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, dataSize);
                                        stream.readHexNumber(start, dataSize);
                                        addHex(start, end, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                                    }
                                    break;
                                case 1:
                                    stream.readHex(start, dataSize);
                                    stream.readHexNumber(end, dataSize);
                                    addHex(end, start, dataSize);
                                    stream.readNumber();
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, dataSize);
                                        stream.readHexNumber(start, dataSize);
                                        addHex(start, end, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        stream.readNumber();
                                    }
                                    break;
                                case 2:
                                    stream.readHex(char, dataSize);
                                    code = stream.readNumber();
                                    cMap.mapOne(hexToInt(char, dataSize), code);
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(char, dataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(tmp, dataSize);
                                            addHex(char, tmp, dataSize);
                                        }
                                        code = stream.readSigned() + (code + 1);
                                        cMap.mapOne(hexToInt(char, dataSize), code);
                                    }
                                    break;
                                case 3:
                                    stream.readHex(start, dataSize);
                                    stream.readHexNumber(end, dataSize);
                                    addHex(end, start, dataSize);
                                    code = stream.readNumber();
                                    cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, dataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(start, dataSize);
                                            addHex(start, end, dataSize);
                                        } else start.set(end);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        code = stream.readNumber();
                                        cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                                    }
                                    break;
                                case 4:
                                    stream.readHex(char, ucs2DataSize);
                                    stream.readHex(charCode, dataSize);
                                    cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(char, ucs2DataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(tmp, ucs2DataSize);
                                            addHex(char, tmp, ucs2DataSize);
                                        }
                                        incHex(charCode, dataSize);
                                        stream.readHexSigned(tmp, dataSize);
                                        addHex(charCode, tmp, dataSize);
                                        cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                                    }
                                    break;
                                case 5:
                                    stream.readHex(start, ucs2DataSize);
                                    stream.readHexNumber(end, ucs2DataSize);
                                    addHex(end, start, ucs2DataSize);
                                    stream.readHex(charCode, dataSize);
                                    cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, ucs2DataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(start, ucs2DataSize);
                                            addHex(start, end, ucs2DataSize);
                                        } else start.set(end);
                                        stream.readHexNumber(end, ucs2DataSize);
                                        addHex(end, start, ucs2DataSize);
                                        stream.readHex(charCode, dataSize);
                                        cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                                    }
                                    break;
                                default:
                                    throw new Error(`BinaryCMapReader.process - unknown type: ${type}`);
                            }
                        }
                        if (useCMap) return extend(useCMap);
                        return cMap;
                    }
                }
                exports.BinaryCMapReader = BinaryCMapReader;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Parser = exports.Linearization = exports.Lexer = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _ascii_85_stream = __w_pdfjs_require__(17);
                var _ascii_hex_stream = __w_pdfjs_require__(19);
                var _ccitt_stream = __w_pdfjs_require__(20);
                var _flate_stream = __w_pdfjs_require__(22);
                var _jbig2_stream = __w_pdfjs_require__(23);
                var _jpeg_stream = __w_pdfjs_require__(26);
                var _jpx_stream = __w_pdfjs_require__(29);
                var _lzw_stream = __w_pdfjs_require__(31);
                var _predictor_stream = __w_pdfjs_require__(32);
                var _run_length_stream = __w_pdfjs_require__(33);
                const MAX_LENGTH_TO_CACHE = 1000;
                function getInlineImageCacheKey(bytes) {
                    const strBuf = [], ii = bytes.length;
                    let i = 0;
                    while(i < ii - 1)strBuf.push(bytes[i++] << 8 | bytes[i++]);
                    if (i < ii) strBuf.push(bytes[i]);
                    return ii + "_" + String.fromCharCode.apply(null, strBuf);
                }
                class Parser {
                    constructor({ lexer: lexer, xref: xref, allowStreams: allowStreams = false, recoveryMode: recoveryMode = false }){
                        this.lexer = lexer;
                        this.xref = xref;
                        this.allowStreams = allowStreams;
                        this.recoveryMode = recoveryMode;
                        this.imageCache = Object.create(null);
                        this._imageId = 0;
                        this.refill();
                    }
                    refill() {
                        this.buf1 = this.lexer.getObj();
                        this.buf2 = this.lexer.getObj();
                    }
                    shift() {
                        if (this.buf2 instanceof _primitives.Cmd && this.buf2.cmd === "ID") {
                            this.buf1 = this.buf2;
                            this.buf2 = null;
                        } else {
                            this.buf1 = this.buf2;
                            this.buf2 = this.lexer.getObj();
                        }
                    }
                    tryShift() {
                        try {
                            this.shift();
                            return true;
                        } catch (e) {
                            if (e instanceof _core_utils.MissingDataException) throw e;
                            return false;
                        }
                    }
                    getObj(cipherTransform = null) {
                        const buf1 = this.buf1;
                        this.shift();
                        if (buf1 instanceof _primitives.Cmd) switch(buf1.cmd){
                            case "BI":
                                return this.makeInlineImage(cipherTransform);
                            case "[":
                                const array = [];
                                while(!(0, _primitives.isCmd)(this.buf1, "]") && this.buf1 !== _primitives.EOF)array.push(this.getObj(cipherTransform));
                                if (this.buf1 === _primitives.EOF) {
                                    if (this.recoveryMode) return array;
                                    throw new _core_utils.ParserEOFException("End of file inside array.");
                                }
                                this.shift();
                                return array;
                            case "<<":
                                const dict = new _primitives.Dict(this.xref);
                                while(!(0, _primitives.isCmd)(this.buf1, ">>") && this.buf1 !== _primitives.EOF){
                                    if (!(this.buf1 instanceof _primitives.Name)) {
                                        (0, _util.info)("Malformed dictionary: key must be a name object");
                                        this.shift();
                                        continue;
                                    }
                                    const key = this.buf1.name;
                                    this.shift();
                                    if (this.buf1 === _primitives.EOF) break;
                                    dict.set(key, this.getObj(cipherTransform));
                                }
                                if (this.buf1 === _primitives.EOF) {
                                    if (this.recoveryMode) return dict;
                                    throw new _core_utils.ParserEOFException("End of file inside dictionary.");
                                }
                                if ((0, _primitives.isCmd)(this.buf2, "stream")) return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
                                this.shift();
                                return dict;
                            default:
                                return buf1;
                        }
                        if (Number.isInteger(buf1)) {
                            if (Number.isInteger(this.buf1) && (0, _primitives.isCmd)(this.buf2, "R")) {
                                const ref = _primitives.Ref.get(buf1, this.buf1);
                                this.shift();
                                this.shift();
                                return ref;
                            }
                            return buf1;
                        }
                        if (typeof buf1 === "string") {
                            if (cipherTransform) return cipherTransform.decryptString(buf1);
                            return buf1;
                        }
                        return buf1;
                    }
                    findDefaultInlineStreamEnd(stream) {
                        const E = 0x45, I = 0x49, SPACE = 0x20, LF = 0xa, CR = 0xd, NUL = 0x0;
                        const { knownCommands: knownCommands } = this.lexer, startPos = stream.pos, n = 15;
                        let state = 0, ch, maybeEIPos;
                        while((ch = stream.getByte()) !== -1){
                            if (state === 0) state = ch === E ? 1 : 0;
                            else if (state === 1) state = ch === I ? 2 : 0;
                            else if (ch === SPACE || ch === LF || ch === CR) {
                                maybeEIPos = stream.pos;
                                const followingBytes = stream.peekBytes(n);
                                const ii = followingBytes.length;
                                if (ii === 0) break;
                                for(let i = 0; i < ii; i++){
                                    ch = followingBytes[i];
                                    if (ch === NUL && followingBytes[i + 1] !== NUL) continue;
                                    if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7f)) {
                                        state = 0;
                                        break;
                                    }
                                }
                                if (state !== 2) continue;
                                if (!knownCommands) {
                                    (0, _util.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                                    continue;
                                }
                                const tmpLexer = new Lexer(new _stream.Stream(followingBytes.slice()), knownCommands);
                                tmpLexer._hexStringWarn = ()=>{};
                                let numArgs = 0;
                                while(true){
                                    const nextObj = tmpLexer.getObj();
                                    if (nextObj === _primitives.EOF) {
                                        state = 0;
                                        break;
                                    }
                                    if (nextObj instanceof _primitives.Cmd) {
                                        const knownCommand = knownCommands[nextObj.cmd];
                                        if (!knownCommand) {
                                            state = 0;
                                            break;
                                        } else if (knownCommand.variableArgs ? numArgs <= knownCommand.numArgs : numArgs === knownCommand.numArgs) break;
                                        numArgs = 0;
                                        continue;
                                    }
                                    numArgs++;
                                }
                                if (state === 2) break;
                            } else state = 0;
                        }
                        if (ch === -1) {
                            (0, _util.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker");
                            if (maybeEIPos) {
                                (0, _util.warn)('... trying to recover by using the last "EI" occurrence.');
                                stream.skip(-(stream.pos - maybeEIPos));
                            }
                        }
                        let endOffset = 4;
                        stream.skip(-endOffset);
                        ch = stream.peekByte();
                        stream.skip(endOffset);
                        if (!(0, _core_utils.isWhiteSpace)(ch)) endOffset--;
                        return stream.pos - endOffset - startPos;
                    }
                    findDCTDecodeInlineStreamEnd(stream) {
                        const startPos = stream.pos;
                        let foundEOI = false, b, markerLength;
                        while((b = stream.getByte()) !== -1){
                            if (b !== 0xff) continue;
                            switch(stream.getByte()){
                                case 0x00:
                                    break;
                                case 0xff:
                                    stream.skip(-1);
                                    break;
                                case 0xd9:
                                    foundEOI = true;
                                    break;
                                case 0xc0:
                                case 0xc1:
                                case 0xc2:
                                case 0xc3:
                                case 0xc5:
                                case 0xc6:
                                case 0xc7:
                                case 0xc9:
                                case 0xca:
                                case 0xcb:
                                case 0xcd:
                                case 0xce:
                                case 0xcf:
                                case 0xc4:
                                case 0xcc:
                                case 0xda:
                                case 0xdb:
                                case 0xdc:
                                case 0xdd:
                                case 0xde:
                                case 0xdf:
                                case 0xe0:
                                case 0xe1:
                                case 0xe2:
                                case 0xe3:
                                case 0xe4:
                                case 0xe5:
                                case 0xe6:
                                case 0xe7:
                                case 0xe8:
                                case 0xe9:
                                case 0xea:
                                case 0xeb:
                                case 0xec:
                                case 0xed:
                                case 0xee:
                                case 0xef:
                                case 0xfe:
                                    markerLength = stream.getUint16();
                                    if (markerLength > 2) stream.skip(markerLength - 2);
                                    else stream.skip(-2);
                                    break;
                            }
                            if (foundEOI) break;
                        }
                        const length = stream.pos - startPos;
                        if (b === -1) {
                            (0, _util.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    findASCII85DecodeInlineStreamEnd(stream) {
                        const TILDE = 0x7e, GT = 0x3e;
                        const startPos = stream.pos;
                        let ch;
                        while((ch = stream.getByte()) !== -1)if (ch === TILDE) {
                            const tildePos = stream.pos;
                            ch = stream.peekByte();
                            while((0, _core_utils.isWhiteSpace)(ch)){
                                stream.skip();
                                ch = stream.peekByte();
                            }
                            if (ch === GT) {
                                stream.skip();
                                break;
                            }
                            if (stream.pos > tildePos) {
                                const maybeEI = stream.peekBytes(2);
                                if (maybeEI[0] === 0x45 && maybeEI[1] === 0x49) break;
                            }
                        }
                        const length = stream.pos - startPos;
                        if (ch === -1) {
                            (0, _util.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    findASCIIHexDecodeInlineStreamEnd(stream) {
                        const GT = 0x3e;
                        const startPos = stream.pos;
                        let ch;
                        while((ch = stream.getByte()) !== -1){
                            if (ch === GT) break;
                        }
                        const length = stream.pos - startPos;
                        if (ch === -1) {
                            (0, _util.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    inlineStreamSkipEI(stream) {
                        const E = 0x45, I = 0x49;
                        let state = 0, ch;
                        while((ch = stream.getByte()) !== -1){
                            if (state === 0) state = ch === E ? 1 : 0;
                            else if (state === 1) state = ch === I ? 2 : 0;
                            else if (state === 2) break;
                        }
                    }
                    makeInlineImage(cipherTransform) {
                        const lexer = this.lexer;
                        const stream = lexer.stream;
                        const dictMap = Object.create(null);
                        let dictLength;
                        while(!(0, _primitives.isCmd)(this.buf1, "ID") && this.buf1 !== _primitives.EOF){
                            if (!(this.buf1 instanceof _primitives.Name)) throw new _util.FormatError("Dictionary key must be a name object");
                            const key = this.buf1.name;
                            this.shift();
                            if (this.buf1 === _primitives.EOF) break;
                            dictMap[key] = this.getObj(cipherTransform);
                        }
                        if (lexer.beginInlineImagePos !== -1) dictLength = stream.pos - lexer.beginInlineImagePos;
                        const filter = this.xref.fetchIfRef(dictMap.F || dictMap.Filter);
                        let filterName;
                        if (filter instanceof _primitives.Name) filterName = filter.name;
                        else if (Array.isArray(filter)) {
                            const filterZero = this.xref.fetchIfRef(filter[0]);
                            if (filterZero instanceof _primitives.Name) filterName = filterZero.name;
                        }
                        const startPos = stream.pos;
                        let length;
                        switch(filterName){
                            case "DCT":
                            case "DCTDecode":
                                length = this.findDCTDecodeInlineStreamEnd(stream);
                                break;
                            case "A85":
                            case "ASCII85Decode":
                                length = this.findASCII85DecodeInlineStreamEnd(stream);
                                break;
                            case "AHx":
                            case "ASCIIHexDecode":
                                length = this.findASCIIHexDecodeInlineStreamEnd(stream);
                                break;
                            default:
                                length = this.findDefaultInlineStreamEnd(stream);
                        }
                        let cacheKey;
                        if (length < MAX_LENGTH_TO_CACHE && dictLength > 0) {
                            const initialStreamPos = stream.pos;
                            stream.pos = lexer.beginInlineImagePos;
                            cacheKey = getInlineImageCacheKey(stream.getBytes(dictLength + length));
                            stream.pos = initialStreamPos;
                            const cacheEntry = this.imageCache[cacheKey];
                            if (cacheEntry !== undefined) {
                                this.buf2 = _primitives.Cmd.get("EI");
                                this.shift();
                                cacheEntry.reset();
                                return cacheEntry;
                            }
                        }
                        const dict = new _primitives.Dict(this.xref);
                        for(const key in dictMap)dict.set(key, dictMap[key]);
                        let imageStream = stream.makeSubStream(startPos, length, dict);
                        if (cipherTransform) imageStream = cipherTransform.createStream(imageStream, length);
                        imageStream = this.filter(imageStream, dict, length);
                        imageStream.dict = dict;
                        if (cacheKey !== undefined) {
                            imageStream.cacheKey = `inline_img_${++this._imageId}`;
                            this.imageCache[cacheKey] = imageStream;
                        }
                        this.buf2 = _primitives.Cmd.get("EI");
                        this.shift();
                        return imageStream;
                    }
                    _findStreamLength(startPos, signature) {
                        const { stream: stream } = this.lexer;
                        stream.pos = startPos;
                        const SCAN_BLOCK_LENGTH = 2048;
                        const signatureLength = signature.length;
                        while(stream.pos < stream.end){
                            const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                            const scanLength = scanBytes.length - signatureLength;
                            if (scanLength <= 0) break;
                            let pos = 0;
                            while(pos < scanLength){
                                let j = 0;
                                while(j < signatureLength && scanBytes[pos + j] === signature[j])j++;
                                if (j >= signatureLength) {
                                    stream.pos += pos;
                                    return stream.pos - startPos;
                                }
                                pos++;
                            }
                            stream.pos += scanLength;
                        }
                        return -1;
                    }
                    makeStream(dict, cipherTransform) {
                        const lexer = this.lexer;
                        let stream = lexer.stream;
                        lexer.skipToNextLine();
                        const startPos = stream.pos - 1;
                        let length = dict.get("Length");
                        if (!Number.isInteger(length)) {
                            (0, _util.info)(`Bad length "${length && length.toString()}" in stream.`);
                            length = 0;
                        }
                        stream.pos = startPos + length;
                        lexer.nextChar();
                        if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, "endstream")) this.shift();
                        else {
                            const ENDSTREAM_SIGNATURE = new Uint8Array([
                                0x65,
                                0x6e,
                                0x64,
                                0x73,
                                0x74,
                                0x72,
                                0x65,
                                0x61,
                                0x6d
                            ]);
                            let actualLength = this._findStreamLength(startPos, ENDSTREAM_SIGNATURE);
                            if (actualLength < 0) {
                                const MAX_TRUNCATION = 1;
                                for(let i = 1; i <= MAX_TRUNCATION; i++){
                                    const end = ENDSTREAM_SIGNATURE.length - i;
                                    const TRUNCATED_SIGNATURE = ENDSTREAM_SIGNATURE.slice(0, end);
                                    const maybeLength = this._findStreamLength(startPos, TRUNCATED_SIGNATURE);
                                    if (maybeLength >= 0) {
                                        const lastByte = stream.peekBytes(end + 1)[end];
                                        if (!(0, _core_utils.isWhiteSpace)(lastByte)) break;
                                        (0, _util.info)(`Found "${(0, _util.bytesToString)(TRUNCATED_SIGNATURE)}" when ` + "searching for endstream command.");
                                        actualLength = maybeLength;
                                        break;
                                    }
                                }
                                if (actualLength < 0) throw new _util.FormatError("Missing endstream command.");
                            }
                            length = actualLength;
                            lexer.nextChar();
                            this.shift();
                            this.shift();
                        }
                        this.shift();
                        stream = stream.makeSubStream(startPos, length, dict);
                        if (cipherTransform) stream = cipherTransform.createStream(stream, length);
                        stream = this.filter(stream, dict, length);
                        stream.dict = dict;
                        return stream;
                    }
                    filter(stream, dict, length) {
                        let filter = dict.get("F", "Filter");
                        let params = dict.get("DP", "DecodeParms");
                        if (filter instanceof _primitives.Name) {
                            if (Array.isArray(params)) (0, _util.warn)("/DecodeParms should not be an Array, when /Filter is a Name.");
                            return this.makeFilter(stream, filter.name, length, params);
                        }
                        let maybeLength = length;
                        if (Array.isArray(filter)) {
                            const filterArray = filter;
                            const paramsArray = params;
                            for(let i = 0, ii = filterArray.length; i < ii; ++i){
                                filter = this.xref.fetchIfRef(filterArray[i]);
                                if (!(filter instanceof _primitives.Name)) throw new _util.FormatError(`Bad filter name "${filter}"`);
                                params = null;
                                if (Array.isArray(paramsArray) && i in paramsArray) params = this.xref.fetchIfRef(paramsArray[i]);
                                stream = this.makeFilter(stream, filter.name, maybeLength, params);
                                maybeLength = null;
                            }
                        }
                        return stream;
                    }
                    makeFilter(stream, name, maybeLength, params) {
                        if (maybeLength === 0) {
                            (0, _util.warn)(`Empty "${name}" stream.`);
                            return new _stream.NullStream();
                        }
                        try {
                            switch(name){
                                case "Fl":
                                case "FlateDecode":
                                    if (params) return new _predictor_stream.PredictorStream(new _flate_stream.FlateStream(stream, maybeLength), maybeLength, params);
                                    return new _flate_stream.FlateStream(stream, maybeLength);
                                case "LZW":
                                case "LZWDecode":
                                    let earlyChange = 1;
                                    if (params) {
                                        if (params.has("EarlyChange")) earlyChange = params.get("EarlyChange");
                                        return new _predictor_stream.PredictorStream(new _lzw_stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
                                    }
                                    return new _lzw_stream.LZWStream(stream, maybeLength, earlyChange);
                                case "DCT":
                                case "DCTDecode":
                                    return new _jpeg_stream.JpegStream(stream, maybeLength, params);
                                case "JPX":
                                case "JPXDecode":
                                    return new _jpx_stream.JpxStream(stream, maybeLength, params);
                                case "A85":
                                case "ASCII85Decode":
                                    return new _ascii_85_stream.Ascii85Stream(stream, maybeLength);
                                case "AHx":
                                case "ASCIIHexDecode":
                                    return new _ascii_hex_stream.AsciiHexStream(stream, maybeLength);
                                case "CCF":
                                case "CCITTFaxDecode":
                                    return new _ccitt_stream.CCITTFaxStream(stream, maybeLength, params);
                                case "RL":
                                case "RunLengthDecode":
                                    return new _run_length_stream.RunLengthStream(stream, maybeLength);
                                case "JBIG2Decode":
                                    return new _jbig2_stream.Jbig2Stream(stream, maybeLength, params);
                            }
                            (0, _util.warn)(`Filter "${name}" is not supported.`);
                            return stream;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Invalid stream: "${ex}"`);
                            return new _stream.NullStream();
                        }
                    }
                }
                exports.Parser = Parser;
                const specialChars = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                function toHexDigit(ch) {
                    if (ch >= 0x30 && ch <= 0x39) return ch & 0x0f;
                    if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) return (ch & 0x0f) + 9;
                    return -1;
                }
                class Lexer {
                    constructor(stream, knownCommands = null){
                        this.stream = stream;
                        this.nextChar();
                        this.strBuf = [];
                        this.knownCommands = knownCommands;
                        this._hexStringNumWarn = 0;
                        this.beginInlineImagePos = -1;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    peekChar() {
                        return this.stream.peekByte();
                    }
                    getNumber() {
                        let ch = this.currentChar;
                        let eNotation = false;
                        let divideBy = 0;
                        let sign = 1;
                        if (ch === 0x2d) {
                            sign = -1;
                            ch = this.nextChar();
                            if (ch === 0x2d) ch = this.nextChar();
                        } else if (ch === 0x2b) ch = this.nextChar();
                        if (ch === 0x0a || ch === 0x0d) do ch = this.nextChar();
                        while (ch === 0x0a || ch === 0x0d);
                        if (ch === 0x2e) {
                            divideBy = 10;
                            ch = this.nextChar();
                        }
                        if (ch < 0x30 || ch > 0x39) {
                            const msg = `Invalid number: ${String.fromCharCode(ch)} (charCode ${ch})`;
                            if ((0, _core_utils.isWhiteSpace)(ch) || ch === -1) {
                                (0, _util.info)(`Lexer.getNumber - "${msg}".`);
                                return 0;
                            }
                            throw new _util.FormatError(msg);
                        }
                        let baseValue = ch - 0x30;
                        let powerValue = 0;
                        let powerValueSign = 1;
                        while((ch = this.nextChar()) >= 0){
                            if (ch >= 0x30 && ch <= 0x39) {
                                const currentDigit = ch - 0x30;
                                if (eNotation) powerValue = powerValue * 10 + currentDigit;
                                else {
                                    if (divideBy !== 0) divideBy *= 10;
                                    baseValue = baseValue * 10 + currentDigit;
                                }
                            } else if (ch === 0x2e) {
                                if (divideBy === 0) divideBy = 1;
                                else break;
                            } else if (ch === 0x2d) (0, _util.warn)("Badly formatted number: minus sign in the middle");
                            else if (ch === 0x45 || ch === 0x65) {
                                ch = this.peekChar();
                                if (ch === 0x2b || ch === 0x2d) {
                                    powerValueSign = ch === 0x2d ? -1 : 1;
                                    this.nextChar();
                                } else if (ch < 0x30 || ch > 0x39) break;
                                eNotation = true;
                            } else break;
                        }
                        if (divideBy !== 0) baseValue /= divideBy;
                        if (eNotation) baseValue *= 10 ** (powerValueSign * powerValue);
                        return sign * baseValue;
                    }
                    getString() {
                        let numParen = 1;
                        let done = false;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        let ch = this.nextChar();
                        while(true){
                            let charBuffered = false;
                            switch(ch | 0){
                                case -1:
                                    (0, _util.warn)("Unterminated string");
                                    done = true;
                                    break;
                                case 0x28:
                                    ++numParen;
                                    strBuf.push("(");
                                    break;
                                case 0x29:
                                    if (--numParen === 0) {
                                        this.nextChar();
                                        done = true;
                                    } else strBuf.push(")");
                                    break;
                                case 0x5c:
                                    ch = this.nextChar();
                                    switch(ch){
                                        case -1:
                                            (0, _util.warn)("Unterminated string");
                                            done = true;
                                            break;
                                        case 0x6e:
                                            strBuf.push("\n");
                                            break;
                                        case 0x72:
                                            strBuf.push("\r");
                                            break;
                                        case 0x74:
                                            strBuf.push("\t");
                                            break;
                                        case 0x62:
                                            strBuf.push("\b");
                                            break;
                                        case 0x66:
                                            strBuf.push("\f");
                                            break;
                                        case 0x5c:
                                        case 0x28:
                                        case 0x29:
                                            strBuf.push(String.fromCharCode(ch));
                                            break;
                                        case 0x30:
                                        case 0x31:
                                        case 0x32:
                                        case 0x33:
                                        case 0x34:
                                        case 0x35:
                                        case 0x36:
                                        case 0x37:
                                            let x = ch & 0x0f;
                                            ch = this.nextChar();
                                            charBuffered = true;
                                            if (ch >= 0x30 && ch <= 0x37) {
                                                x = (x << 3) + (ch & 0x0f);
                                                ch = this.nextChar();
                                                if (ch >= 0x30 && ch <= 0x37) {
                                                    charBuffered = false;
                                                    x = (x << 3) + (ch & 0x0f);
                                                }
                                            }
                                            strBuf.push(String.fromCharCode(x));
                                            break;
                                        case 0x0d:
                                            if (this.peekChar() === 0x0a) this.nextChar();
                                            break;
                                        case 0x0a:
                                            break;
                                        default:
                                            strBuf.push(String.fromCharCode(ch));
                                            break;
                                    }
                                    break;
                                default:
                                    strBuf.push(String.fromCharCode(ch));
                                    break;
                            }
                            if (done) break;
                            if (!charBuffered) ch = this.nextChar();
                        }
                        return strBuf.join("");
                    }
                    getName() {
                        let ch, previousCh;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        while((ch = this.nextChar()) >= 0 && !specialChars[ch])if (ch === 0x23) {
                            ch = this.nextChar();
                            if (specialChars[ch]) {
                                (0, _util.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");
                                strBuf.push("#");
                                break;
                            }
                            const x = toHexDigit(ch);
                            if (x !== -1) {
                                previousCh = ch;
                                ch = this.nextChar();
                                const x2 = toHexDigit(ch);
                                if (x2 === -1) {
                                    (0, _util.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(ch)}) ` + "in hexadecimal number.");
                                    strBuf.push("#", String.fromCharCode(previousCh));
                                    if (specialChars[ch]) break;
                                    strBuf.push(String.fromCharCode(ch));
                                    continue;
                                }
                                strBuf.push(String.fromCharCode(x << 4 | x2));
                            } else strBuf.push("#", String.fromCharCode(ch));
                        } else strBuf.push(String.fromCharCode(ch));
                        if (strBuf.length > 127) (0, _util.warn)(`Name token is longer than allowed by the spec: ${strBuf.length}`);
                        return _primitives.Name.get(strBuf.join(""));
                    }
                    _hexStringWarn(ch) {
                        const MAX_HEX_STRING_NUM_WARN = 5;
                        if (this._hexStringNumWarn++ === MAX_HEX_STRING_NUM_WARN) {
                            (0, _util.warn)("getHexString - ignoring additional invalid characters.");
                            return;
                        }
                        if (this._hexStringNumWarn > MAX_HEX_STRING_NUM_WARN) return;
                        (0, _util.warn)(`getHexString - ignoring invalid character: ${ch}`);
                    }
                    getHexString() {
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        let ch = this.currentChar;
                        let isFirstHex = true;
                        let firstDigit, secondDigit;
                        this._hexStringNumWarn = 0;
                        while(true){
                            if (ch < 0) {
                                (0, _util.warn)("Unterminated hex string");
                                break;
                            } else if (ch === 0x3e) {
                                this.nextChar();
                                break;
                            } else if (specialChars[ch] === 1) {
                                ch = this.nextChar();
                                continue;
                            } else {
                                if (isFirstHex) {
                                    firstDigit = toHexDigit(ch);
                                    if (firstDigit === -1) {
                                        this._hexStringWarn(ch);
                                        ch = this.nextChar();
                                        continue;
                                    }
                                } else {
                                    secondDigit = toHexDigit(ch);
                                    if (secondDigit === -1) {
                                        this._hexStringWarn(ch);
                                        ch = this.nextChar();
                                        continue;
                                    }
                                    strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
                                }
                                isFirstHex = !isFirstHex;
                                ch = this.nextChar();
                            }
                        }
                        return strBuf.join("");
                    }
                    getObj() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch < 0) return _primitives.EOF;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (specialChars[ch] !== 1) break;
                            ch = this.nextChar();
                        }
                        switch(ch | 0){
                            case 0x30:
                            case 0x31:
                            case 0x32:
                            case 0x33:
                            case 0x34:
                            case 0x35:
                            case 0x36:
                            case 0x37:
                            case 0x38:
                            case 0x39:
                            case 0x2b:
                            case 0x2d:
                            case 0x2e:
                                return this.getNumber();
                            case 0x28:
                                return this.getString();
                            case 0x2f:
                                return this.getName();
                            case 0x5b:
                                this.nextChar();
                                return _primitives.Cmd.get("[");
                            case 0x5d:
                                this.nextChar();
                                return _primitives.Cmd.get("]");
                            case 0x3c:
                                ch = this.nextChar();
                                if (ch === 0x3c) {
                                    this.nextChar();
                                    return _primitives.Cmd.get("<<");
                                }
                                return this.getHexString();
                            case 0x3e:
                                ch = this.nextChar();
                                if (ch === 0x3e) {
                                    this.nextChar();
                                    return _primitives.Cmd.get(">>");
                                }
                                return _primitives.Cmd.get(">");
                            case 0x7b:
                                this.nextChar();
                                return _primitives.Cmd.get("{");
                            case 0x7d:
                                this.nextChar();
                                return _primitives.Cmd.get("}");
                            case 0x29:
                                this.nextChar();
                                throw new _util.FormatError(`Illegal character: ${ch}`);
                        }
                        let str = String.fromCharCode(ch);
                        if (ch < 0x20 || ch > 0x7f) {
                            const nextCh = this.peekChar();
                            if (nextCh >= 0x20 && nextCh <= 0x7f) {
                                this.nextChar();
                                return _primitives.Cmd.get(str);
                            }
                        }
                        const knownCommands = this.knownCommands;
                        let knownCommandFound = knownCommands?.[str] !== undefined;
                        while((ch = this.nextChar()) >= 0 && !specialChars[ch]){
                            const possibleCommand = str + String.fromCharCode(ch);
                            if (knownCommandFound && knownCommands[possibleCommand] === undefined) break;
                            if (str.length === 128) throw new _util.FormatError(`Command token too long: ${str.length}`);
                            str = possibleCommand;
                            knownCommandFound = knownCommands?.[str] !== undefined;
                        }
                        if (str === "true") return true;
                        if (str === "false") return false;
                        if (str === "null") return null;
                        if (str === "BI") this.beginInlineImagePos = this.stream.pos;
                        return _primitives.Cmd.get(str);
                    }
                    skipToNextLine() {
                        let ch = this.currentChar;
                        while(ch >= 0){
                            if (ch === 0x0d) {
                                ch = this.nextChar();
                                if (ch === 0x0a) this.nextChar();
                                break;
                            } else if (ch === 0x0a) {
                                this.nextChar();
                                break;
                            }
                            ch = this.nextChar();
                        }
                    }
                }
                exports.Lexer = Lexer;
                class Linearization {
                    static create(stream) {
                        function getInt(linDict, name, allowZeroValue = false) {
                            const obj = linDict.get(name);
                            if (Number.isInteger(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) return obj;
                            throw new Error(`The "${name}" parameter in the linearization ` + "dictionary is invalid.");
                        }
                        function getHints(linDict) {
                            const hints = linDict.get("H");
                            let hintsLength;
                            if (Array.isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
                                for(let index = 0; index < hintsLength; index++){
                                    const hint = hints[index];
                                    if (!(Number.isInteger(hint) && hint > 0)) throw new Error(`Hint (${index}) in the linearization dictionary is invalid.`);
                                }
                                return hints;
                            }
                            throw new Error("Hint array in the linearization dictionary is invalid.");
                        }
                        const parser = new Parser({
                            lexer: new Lexer(stream),
                            xref: null
                        });
                        const obj1 = parser.getObj();
                        const obj2 = parser.getObj();
                        const obj3 = parser.getObj();
                        const linDict = parser.getObj();
                        let obj, length;
                        if (!(Number.isInteger(obj1) && Number.isInteger(obj2) && (0, _primitives.isCmd)(obj3, "obj") && linDict instanceof _primitives.Dict && typeof (obj = linDict.get("Linearized")) === "number" && obj > 0)) return null;
                        else if ((length = getInt(linDict, "L")) !== stream.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                        return {
                            length: length,
                            hints: getHints(linDict),
                            objectNumberFirst: getInt(linDict, "O"),
                            endFirst: getInt(linDict, "E"),
                            numPages: getInt(linDict, "N"),
                            mainXRefEntriesOffset: getInt(linDict, "T"),
                            pageFirst: linDict.has("P") ? getInt(linDict, "P", true) : 0
                        };
                    }
                }
                exports.Linearization = Linearization;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Ascii85Stream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _core_utils = __w_pdfjs_require__(3);
                class Ascii85Stream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        if (maybeLength) maybeLength *= 0.8;
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.input = new Uint8Array(5);
                    }
                    readBlock() {
                        const TILDA_CHAR = 0x7e;
                        const Z_LOWER_CHAR = 0x7a;
                        const EOF = -1;
                        const str = this.str;
                        let c = str.getByte();
                        while((0, _core_utils.isWhiteSpace)(c))c = str.getByte();
                        if (c === EOF || c === TILDA_CHAR) {
                            this.eof = true;
                            return;
                        }
                        const bufferLength = this.bufferLength;
                        let buffer, i;
                        if (c === Z_LOWER_CHAR) {
                            buffer = this.ensureBuffer(bufferLength + 4);
                            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
                            this.bufferLength += 4;
                        } else {
                            const input = this.input;
                            input[0] = c;
                            for(i = 1; i < 5; ++i){
                                c = str.getByte();
                                while((0, _core_utils.isWhiteSpace)(c))c = str.getByte();
                                input[i] = c;
                                if (c === EOF || c === TILDA_CHAR) break;
                            }
                            buffer = this.ensureBuffer(bufferLength + i - 1);
                            this.bufferLength += i - 1;
                            if (i < 5) {
                                for(; i < 5; ++i)input[i] = 117;
                                this.eof = true;
                            }
                            let t = 0;
                            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
                            for(i = 3; i >= 0; --i){
                                buffer[bufferLength + i] = t & 0xff;
                                t >>= 8;
                            }
                        }
                    }
                }
                exports.Ascii85Stream = Ascii85Stream;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamsSequenceStream = exports.DecodeStream = void 0;
                var _base_stream = __w_pdfjs_require__(5);
                var _stream = __w_pdfjs_require__(8);
                const emptyBuffer = new Uint8Array(0);
                class DecodeStream extends _base_stream.BaseStream {
                    constructor(maybeMinBufferLength){
                        super();
                        this._rawMinBufferLength = maybeMinBufferLength || 0;
                        this.pos = 0;
                        this.bufferLength = 0;
                        this.eof = false;
                        this.buffer = emptyBuffer;
                        this.minBufferLength = 512;
                        if (maybeMinBufferLength) while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
                    }
                    get isEmpty() {
                        while(!this.eof && this.bufferLength === 0)this.readBlock();
                        return this.bufferLength === 0;
                    }
                    ensureBuffer(requested) {
                        const buffer = this.buffer;
                        if (requested <= buffer.byteLength) return buffer;
                        let size = this.minBufferLength;
                        while(size < requested)size *= 2;
                        const buffer2 = new Uint8Array(size);
                        buffer2.set(buffer);
                        return this.buffer = buffer2;
                    }
                    getByte() {
                        const pos = this.pos;
                        while(this.bufferLength <= pos){
                            if (this.eof) return -1;
                            this.readBlock();
                        }
                        return this.buffer[this.pos++];
                    }
                    getBytes(length) {
                        const pos = this.pos;
                        let end;
                        if (length) {
                            this.ensureBuffer(pos + length);
                            end = pos + length;
                            while(!this.eof && this.bufferLength < end)this.readBlock();
                            const bufEnd = this.bufferLength;
                            if (end > bufEnd) end = bufEnd;
                        } else {
                            while(!this.eof)this.readBlock();
                            end = this.bufferLength;
                        }
                        this.pos = end;
                        return this.buffer.subarray(pos, end);
                    }
                    reset() {
                        this.pos = 0;
                    }
                    makeSubStream(start, length, dict = null) {
                        if (length === undefined) while(!this.eof)this.readBlock();
                        else {
                            const end = start + length;
                            while(this.bufferLength <= end && !this.eof)this.readBlock();
                        }
                        return new _stream.Stream(this.buffer, start, length, dict);
                    }
                    getBaseStreams() {
                        return this.str ? this.str.getBaseStreams() : null;
                    }
                }
                exports.DecodeStream = DecodeStream;
                class StreamsSequenceStream extends DecodeStream {
                    constructor(streams, onError = null){
                        let maybeLength = 0;
                        for (const stream of streams)maybeLength += stream instanceof DecodeStream ? stream._rawMinBufferLength : stream.length;
                        super(maybeLength);
                        this.streams = streams;
                        this._onError = onError;
                    }
                    readBlock() {
                        const streams = this.streams;
                        if (streams.length === 0) {
                            this.eof = true;
                            return;
                        }
                        const stream = streams.shift();
                        let chunk;
                        try {
                            chunk = stream.getBytes();
                        } catch (reason) {
                            if (this._onError) {
                                this._onError(reason, stream.dict?.objId);
                                return;
                            }
                            throw reason;
                        }
                        const bufferLength = this.bufferLength;
                        const newLength = bufferLength + chunk.length;
                        const buffer = this.ensureBuffer(newLength);
                        buffer.set(chunk, bufferLength);
                        this.bufferLength = newLength;
                    }
                    getBaseStreams() {
                        const baseStreamsBuf = [];
                        for (const stream of this.streams){
                            const baseStreams = stream.getBaseStreams();
                            if (baseStreams) baseStreamsBuf.push(...baseStreams);
                        }
                        return baseStreamsBuf.length > 0 ? baseStreamsBuf : null;
                    }
                }
                exports.StreamsSequenceStream = StreamsSequenceStream;
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AsciiHexStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                class AsciiHexStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        if (maybeLength) maybeLength *= 0.5;
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.firstDigit = -1;
                    }
                    readBlock() {
                        const UPSTREAM_BLOCK_SIZE = 8000;
                        const bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
                        if (!bytes.length) {
                            this.eof = true;
                            return;
                        }
                        const maxDecodeLength = bytes.length + 1 >> 1;
                        const buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
                        let bufferLength = this.bufferLength;
                        let firstDigit = this.firstDigit;
                        for (const ch of bytes){
                            let digit;
                            if (ch >= 0x30 && ch <= 0x39) digit = ch & 0x0f;
                            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) digit = (ch & 0x0f) + 9;
                            else if (ch === 0x3e) {
                                this.eof = true;
                                break;
                            } else continue;
                            if (firstDigit < 0) firstDigit = digit;
                            else {
                                buffer[bufferLength++] = firstDigit << 4 | digit;
                                firstDigit = -1;
                            }
                        }
                        if (firstDigit >= 0 && this.eof) {
                            buffer[bufferLength++] = firstDigit << 4;
                            firstDigit = -1;
                        }
                        this.firstDigit = firstDigit;
                        this.bufferLength = bufferLength;
                    }
                }
                exports.AsciiHexStream = AsciiHexStream;
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CCITTFaxStream = void 0;
                var _ccitt = __w_pdfjs_require__(21);
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                class CCITTFaxStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, params){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        if (!(params instanceof _primitives.Dict)) params = _primitives.Dict.empty;
                        const source = {
                            next () {
                                return str.getByte();
                            }
                        };
                        this.ccittFaxDecoder = new _ccitt.CCITTFaxDecoder(source, {
                            K: params.get("K"),
                            EndOfLine: params.get("EndOfLine"),
                            EncodedByteAlign: params.get("EncodedByteAlign"),
                            Columns: params.get("Columns"),
                            Rows: params.get("Rows"),
                            EndOfBlock: params.get("EndOfBlock"),
                            BlackIs1: params.get("BlackIs1")
                        });
                    }
                    readBlock() {
                        while(!this.eof){
                            const c = this.ccittFaxDecoder.readNextChar();
                            if (c === -1) {
                                this.eof = true;
                                return;
                            }
                            this.ensureBuffer(this.bufferLength + 1);
                            this.buffer[this.bufferLength++] = c;
                        }
                    }
                }
                exports.CCITTFaxStream = CCITTFaxStream;
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CCITTFaxDecoder = void 0;
                var _util = __w_pdfjs_require__(2);
                const ccittEOL = -2;
                const ccittEOF = -1;
                const twoDimPass = 0;
                const twoDimHoriz = 1;
                const twoDimVert0 = 2;
                const twoDimVertR1 = 3;
                const twoDimVertL1 = 4;
                const twoDimVertR2 = 5;
                const twoDimVertL2 = 6;
                const twoDimVertR3 = 7;
                const twoDimVertL3 = 8;
                const twoDimTable = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        7,
                        twoDimVertL3
                    ],
                    [
                        7,
                        twoDimVertR3
                    ],
                    [
                        6,
                        twoDimVertL2
                    ],
                    [
                        6,
                        twoDimVertL2
                    ],
                    [
                        6,
                        twoDimVertR2
                    ],
                    [
                        6,
                        twoDimVertR2
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ]
                ];
                const whiteTable1 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ]
                ];
                const whiteTable2 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        9,
                        1472
                    ],
                    [
                        9,
                        1536
                    ],
                    [
                        9,
                        1600
                    ],
                    [
                        9,
                        1728
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        9,
                        704
                    ],
                    [
                        9,
                        768
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        9,
                        832
                    ],
                    [
                        9,
                        896
                    ],
                    [
                        9,
                        960
                    ],
                    [
                        9,
                        1024
                    ],
                    [
                        9,
                        1088
                    ],
                    [
                        9,
                        1152
                    ],
                    [
                        9,
                        1216
                    ],
                    [
                        9,
                        1280
                    ],
                    [
                        9,
                        1344
                    ],
                    [
                        9,
                        1408
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ]
                ];
                const blackTable1 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        13,
                        640
                    ],
                    [
                        13,
                        704
                    ],
                    [
                        13,
                        768
                    ],
                    [
                        13,
                        832
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        13,
                        1280
                    ],
                    [
                        13,
                        1344
                    ],
                    [
                        13,
                        1408
                    ],
                    [
                        13,
                        1472
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        13,
                        1536
                    ],
                    [
                        13,
                        1600
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        13,
                        1664
                    ],
                    [
                        13,
                        1728
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        13,
                        512
                    ],
                    [
                        13,
                        576
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        13,
                        896
                    ],
                    [
                        13,
                        960
                    ],
                    [
                        13,
                        1024
                    ],
                    [
                        13,
                        1088
                    ],
                    [
                        13,
                        1152
                    ],
                    [
                        13,
                        1216
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ]
                ];
                const blackTable2 = [
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        12,
                        50
                    ],
                    [
                        12,
                        51
                    ],
                    [
                        12,
                        44
                    ],
                    [
                        12,
                        45
                    ],
                    [
                        12,
                        46
                    ],
                    [
                        12,
                        47
                    ],
                    [
                        12,
                        57
                    ],
                    [
                        12,
                        58
                    ],
                    [
                        12,
                        61
                    ],
                    [
                        12,
                        256
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        12,
                        48
                    ],
                    [
                        12,
                        49
                    ],
                    [
                        12,
                        62
                    ],
                    [
                        12,
                        63
                    ],
                    [
                        12,
                        30
                    ],
                    [
                        12,
                        31
                    ],
                    [
                        12,
                        32
                    ],
                    [
                        12,
                        33
                    ],
                    [
                        12,
                        40
                    ],
                    [
                        12,
                        41
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        12,
                        128
                    ],
                    [
                        12,
                        192
                    ],
                    [
                        12,
                        26
                    ],
                    [
                        12,
                        27
                    ],
                    [
                        12,
                        28
                    ],
                    [
                        12,
                        29
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        12,
                        34
                    ],
                    [
                        12,
                        35
                    ],
                    [
                        12,
                        36
                    ],
                    [
                        12,
                        37
                    ],
                    [
                        12,
                        38
                    ],
                    [
                        12,
                        39
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        12,
                        42
                    ],
                    [
                        12,
                        43
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ]
                ];
                const blackTable3 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        6,
                        9
                    ],
                    [
                        6,
                        8
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ]
                ];
                class CCITTFaxDecoder {
                    constructor(source, options = {}){
                        if (!source || typeof source.next !== "function") throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
                        this.source = source;
                        this.eof = false;
                        this.encoding = options.K || 0;
                        this.eoline = options.EndOfLine || false;
                        this.byteAlign = options.EncodedByteAlign || false;
                        this.columns = options.Columns || 1728;
                        this.rows = options.Rows || 0;
                        this.eoblock = options.EndOfBlock ?? true;
                        this.black = options.BlackIs1 || false;
                        this.codingLine = new Uint32Array(this.columns + 1);
                        this.refLine = new Uint32Array(this.columns + 2);
                        this.codingLine[0] = this.columns;
                        this.codingPos = 0;
                        this.row = 0;
                        this.nextLine2D = this.encoding < 0;
                        this.inputBits = 0;
                        this.inputBuf = 0;
                        this.outputBits = 0;
                        this.rowsDone = false;
                        let code1;
                        while((code1 = this._lookBits(12)) === 0)this._eatBits(1);
                        if (code1 === 1) this._eatBits(12);
                        if (this.encoding > 0) {
                            this.nextLine2D = !this._lookBits(1);
                            this._eatBits(1);
                        }
                    }
                    readNextChar() {
                        if (this.eof) return -1;
                        const refLine = this.refLine;
                        const codingLine = this.codingLine;
                        const columns = this.columns;
                        let refPos, blackPixels, bits, i;
                        if (this.outputBits === 0) {
                            if (this.rowsDone) this.eof = true;
                            if (this.eof) return -1;
                            this.err = false;
                            let code1, code2, code3;
                            if (this.nextLine2D) {
                                for(i = 0; codingLine[i] < columns; ++i)refLine[i] = codingLine[i];
                                refLine[i++] = columns;
                                refLine[i] = columns;
                                codingLine[0] = 0;
                                this.codingPos = 0;
                                refPos = 0;
                                blackPixels = 0;
                                while(codingLine[this.codingPos] < columns){
                                    code1 = this._getTwoDimCode();
                                    switch(code1){
                                        case twoDimPass:
                                            this._addPixels(refLine[refPos + 1], blackPixels);
                                            if (refLine[refPos + 1] < columns) refPos += 2;
                                            break;
                                        case twoDimHoriz:
                                            code1 = code2 = 0;
                                            if (blackPixels) {
                                                do code1 += code3 = this._getBlackCode();
                                                while (code3 >= 64);
                                                do code2 += code3 = this._getWhiteCode();
                                                while (code3 >= 64);
                                            } else {
                                                do code1 += code3 = this._getWhiteCode();
                                                while (code3 >= 64);
                                                do code2 += code3 = this._getBlackCode();
                                                while (code3 >= 64);
                                            }
                                            this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                                            if (codingLine[this.codingPos] < columns) this._addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
                                            while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            break;
                                        case twoDimVertR3:
                                            this._addPixels(refLine[refPos] + 3, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertR2:
                                            this._addPixels(refLine[refPos] + 2, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertR1:
                                            this._addPixels(refLine[refPos] + 1, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVert0:
                                            this._addPixels(refLine[refPos], blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL3:
                                            this._addPixelsNeg(refLine[refPos] - 3, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL2:
                                            this._addPixelsNeg(refLine[refPos] - 2, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL1:
                                            this._addPixelsNeg(refLine[refPos] - 1, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case ccittEOF:
                                            this._addPixels(columns, 0);
                                            this.eof = true;
                                            break;
                                        default:
                                            (0, _util.info)("bad 2d code");
                                            this._addPixels(columns, 0);
                                            this.err = true;
                                    }
                                }
                            } else {
                                codingLine[0] = 0;
                                this.codingPos = 0;
                                blackPixels = 0;
                                while(codingLine[this.codingPos] < columns){
                                    code1 = 0;
                                    if (blackPixels) do code1 += code3 = this._getBlackCode();
                                    while (code3 >= 64);
                                    else do code1 += code3 = this._getWhiteCode();
                                    while (code3 >= 64);
                                    this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                                    blackPixels ^= 1;
                                }
                            }
                            let gotEOL = false;
                            if (this.byteAlign) this.inputBits &= -8;
                            if (!this.eoblock && this.row === this.rows - 1) this.rowsDone = true;
                            else {
                                code1 = this._lookBits(12);
                                if (this.eoline) while(code1 !== ccittEOF && code1 !== 1){
                                    this._eatBits(1);
                                    code1 = this._lookBits(12);
                                }
                                else while(code1 === 0){
                                    this._eatBits(1);
                                    code1 = this._lookBits(12);
                                }
                                if (code1 === 1) {
                                    this._eatBits(12);
                                    gotEOL = true;
                                } else if (code1 === ccittEOF) this.eof = true;
                            }
                            if (!this.eof && this.encoding > 0 && !this.rowsDone) {
                                this.nextLine2D = !this._lookBits(1);
                                this._eatBits(1);
                            }
                            if (this.eoblock && gotEOL && this.byteAlign) {
                                code1 = this._lookBits(12);
                                if (code1 === 1) {
                                    this._eatBits(12);
                                    if (this.encoding > 0) {
                                        this._lookBits(1);
                                        this._eatBits(1);
                                    }
                                    if (this.encoding >= 0) for(i = 0; i < 4; ++i){
                                        code1 = this._lookBits(12);
                                        if (code1 !== 1) (0, _util.info)("bad rtc code: " + code1);
                                        this._eatBits(12);
                                        if (this.encoding > 0) {
                                            this._lookBits(1);
                                            this._eatBits(1);
                                        }
                                    }
                                    this.eof = true;
                                }
                            } else if (this.err && this.eoline) {
                                while(true){
                                    code1 = this._lookBits(13);
                                    if (code1 === ccittEOF) {
                                        this.eof = true;
                                        return -1;
                                    }
                                    if (code1 >> 1 === 1) break;
                                    this._eatBits(1);
                                }
                                this._eatBits(12);
                                if (this.encoding > 0) {
                                    this._eatBits(1);
                                    this.nextLine2D = !(code1 & 1);
                                }
                            }
                            this.outputBits = codingLine[0] > 0 ? codingLine[this.codingPos = 0] : codingLine[this.codingPos = 1];
                            this.row++;
                        }
                        let c;
                        if (this.outputBits >= 8) {
                            c = this.codingPos & 1 ? 0 : 0xff;
                            this.outputBits -= 8;
                            if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
                                this.codingPos++;
                                this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                            }
                        } else {
                            bits = 8;
                            c = 0;
                            do {
                                if (typeof this.outputBits !== "number") throw new _util.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                                if (this.outputBits > bits) {
                                    c <<= bits;
                                    if (!(this.codingPos & 1)) c |= 0xff >> 8 - bits;
                                    this.outputBits -= bits;
                                    bits = 0;
                                } else {
                                    c <<= this.outputBits;
                                    if (!(this.codingPos & 1)) c |= 0xff >> 8 - this.outputBits;
                                    bits -= this.outputBits;
                                    this.outputBits = 0;
                                    if (codingLine[this.codingPos] < columns) {
                                        this.codingPos++;
                                        this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                                    } else if (bits > 0) {
                                        c <<= bits;
                                        bits = 0;
                                    }
                                }
                            }while (bits);
                        }
                        if (this.black) c ^= 0xff;
                        return c;
                    }
                    _addPixels(a1, blackPixels) {
                        const codingLine = this.codingLine;
                        let codingPos = this.codingPos;
                        if (a1 > codingLine[codingPos]) {
                            if (a1 > this.columns) {
                                (0, _util.info)("row is wrong length");
                                this.err = true;
                                a1 = this.columns;
                            }
                            if (codingPos & 1 ^ blackPixels) ++codingPos;
                            codingLine[codingPos] = a1;
                        }
                        this.codingPos = codingPos;
                    }
                    _addPixelsNeg(a1, blackPixels) {
                        const codingLine = this.codingLine;
                        let codingPos = this.codingPos;
                        if (a1 > codingLine[codingPos]) {
                            if (a1 > this.columns) {
                                (0, _util.info)("row is wrong length");
                                this.err = true;
                                a1 = this.columns;
                            }
                            if (codingPos & 1 ^ blackPixels) ++codingPos;
                            codingLine[codingPos] = a1;
                        } else if (a1 < codingLine[codingPos]) {
                            if (a1 < 0) {
                                (0, _util.info)("invalid code");
                                this.err = true;
                                a1 = 0;
                            }
                            while(codingPos > 0 && a1 < codingLine[codingPos - 1])--codingPos;
                            codingLine[codingPos] = a1;
                        }
                        this.codingPos = codingPos;
                    }
                    _findTableCode(start, end, table, limit) {
                        const limitValue = limit || 0;
                        for(let i = start; i <= end; ++i){
                            let code = this._lookBits(i);
                            if (code === ccittEOF) return [
                                true,
                                1,
                                false
                            ];
                            if (i < end) code <<= end - i;
                            if (!limitValue || code >= limitValue) {
                                const p = table[code - limitValue];
                                if (p[0] === i) {
                                    this._eatBits(i);
                                    return [
                                        true,
                                        p[1],
                                        true
                                    ];
                                }
                            }
                        }
                        return [
                            false,
                            0,
                            false
                        ];
                    }
                    _getTwoDimCode() {
                        let code = 0;
                        let p;
                        if (this.eoblock) {
                            code = this._lookBits(7);
                            p = twoDimTable[code];
                            if (p?.[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            const result = this._findTableCode(1, 7, twoDimTable);
                            if (result[0] && result[2]) return result[1];
                        }
                        (0, _util.info)("Bad two dim code");
                        return ccittEOF;
                    }
                    _getWhiteCode() {
                        let code = 0;
                        let p;
                        if (this.eoblock) {
                            code = this._lookBits(12);
                            if (code === ccittEOF) return 1;
                            p = code >> 5 === 0 ? whiteTable1[code] : whiteTable2[code >> 3];
                            if (p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            let result = this._findTableCode(1, 9, whiteTable2);
                            if (result[0]) return result[1];
                            result = this._findTableCode(11, 12, whiteTable1);
                            if (result[0]) return result[1];
                        }
                        (0, _util.info)("bad white code");
                        this._eatBits(1);
                        return 1;
                    }
                    _getBlackCode() {
                        let code, p;
                        if (this.eoblock) {
                            code = this._lookBits(13);
                            if (code === ccittEOF) return 1;
                            if (code >> 7 === 0) p = blackTable1[code];
                            else if (code >> 9 === 0 && code >> 7 !== 0) p = blackTable2[(code >> 1) - 64];
                            else p = blackTable3[code >> 7];
                            if (p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            let result = this._findTableCode(2, 6, blackTable3);
                            if (result[0]) return result[1];
                            result = this._findTableCode(7, 12, blackTable2, 64);
                            if (result[0]) return result[1];
                            result = this._findTableCode(10, 13, blackTable1);
                            if (result[0]) return result[1];
                        }
                        (0, _util.info)("bad black code");
                        this._eatBits(1);
                        return 1;
                    }
                    _lookBits(n) {
                        let c;
                        while(this.inputBits < n){
                            if ((c = this.source.next()) === -1) {
                                if (this.inputBits === 0) return ccittEOF;
                                return this.inputBuf << n - this.inputBits & 0xffff >> 16 - n;
                            }
                            this.inputBuf = this.inputBuf << 8 | c;
                            this.inputBits += 8;
                        }
                        return this.inputBuf >> this.inputBits - n & 0xffff >> 16 - n;
                    }
                    _eatBits(n) {
                        if ((this.inputBits -= n) < 0) this.inputBits = 0;
                    }
                }
                exports.CCITTFaxDecoder = CCITTFaxDecoder;
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FlateStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _util = __w_pdfjs_require__(2);
                const codeLenCodeMap = new Int32Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                const lengthDecode = new Int32Array([
                    0x00003,
                    0x00004,
                    0x00005,
                    0x00006,
                    0x00007,
                    0x00008,
                    0x00009,
                    0x0000a,
                    0x1000b,
                    0x1000d,
                    0x1000f,
                    0x10011,
                    0x20013,
                    0x20017,
                    0x2001b,
                    0x2001f,
                    0x30023,
                    0x3002b,
                    0x30033,
                    0x3003b,
                    0x40043,
                    0x40053,
                    0x40063,
                    0x40073,
                    0x50083,
                    0x500a3,
                    0x500c3,
                    0x500e3,
                    0x00102,
                    0x00102,
                    0x00102
                ]);
                const distDecode = new Int32Array([
                    0x00001,
                    0x00002,
                    0x00003,
                    0x00004,
                    0x10005,
                    0x10007,
                    0x20009,
                    0x2000d,
                    0x30011,
                    0x30019,
                    0x40021,
                    0x40031,
                    0x50041,
                    0x50061,
                    0x60081,
                    0x600c1,
                    0x70101,
                    0x70181,
                    0x80201,
                    0x80301,
                    0x90401,
                    0x90601,
                    0xa0801,
                    0xa0c01,
                    0xb1001,
                    0xb1801,
                    0xc2001,
                    0xc3001,
                    0xd4001,
                    0xd6001
                ]);
                const fixedLitCodeTab = [
                    new Int32Array([
                        0x70100,
                        0x80050,
                        0x80010,
                        0x80118,
                        0x70110,
                        0x80070,
                        0x80030,
                        0x900c0,
                        0x70108,
                        0x80060,
                        0x80020,
                        0x900a0,
                        0x80000,
                        0x80080,
                        0x80040,
                        0x900e0,
                        0x70104,
                        0x80058,
                        0x80018,
                        0x90090,
                        0x70114,
                        0x80078,
                        0x80038,
                        0x900d0,
                        0x7010c,
                        0x80068,
                        0x80028,
                        0x900b0,
                        0x80008,
                        0x80088,
                        0x80048,
                        0x900f0,
                        0x70102,
                        0x80054,
                        0x80014,
                        0x8011c,
                        0x70112,
                        0x80074,
                        0x80034,
                        0x900c8,
                        0x7010a,
                        0x80064,
                        0x80024,
                        0x900a8,
                        0x80004,
                        0x80084,
                        0x80044,
                        0x900e8,
                        0x70106,
                        0x8005c,
                        0x8001c,
                        0x90098,
                        0x70116,
                        0x8007c,
                        0x8003c,
                        0x900d8,
                        0x7010e,
                        0x8006c,
                        0x8002c,
                        0x900b8,
                        0x8000c,
                        0x8008c,
                        0x8004c,
                        0x900f8,
                        0x70101,
                        0x80052,
                        0x80012,
                        0x8011a,
                        0x70111,
                        0x80072,
                        0x80032,
                        0x900c4,
                        0x70109,
                        0x80062,
                        0x80022,
                        0x900a4,
                        0x80002,
                        0x80082,
                        0x80042,
                        0x900e4,
                        0x70105,
                        0x8005a,
                        0x8001a,
                        0x90094,
                        0x70115,
                        0x8007a,
                        0x8003a,
                        0x900d4,
                        0x7010d,
                        0x8006a,
                        0x8002a,
                        0x900b4,
                        0x8000a,
                        0x8008a,
                        0x8004a,
                        0x900f4,
                        0x70103,
                        0x80056,
                        0x80016,
                        0x8011e,
                        0x70113,
                        0x80076,
                        0x80036,
                        0x900cc,
                        0x7010b,
                        0x80066,
                        0x80026,
                        0x900ac,
                        0x80006,
                        0x80086,
                        0x80046,
                        0x900ec,
                        0x70107,
                        0x8005e,
                        0x8001e,
                        0x9009c,
                        0x70117,
                        0x8007e,
                        0x8003e,
                        0x900dc,
                        0x7010f,
                        0x8006e,
                        0x8002e,
                        0x900bc,
                        0x8000e,
                        0x8008e,
                        0x8004e,
                        0x900fc,
                        0x70100,
                        0x80051,
                        0x80011,
                        0x80119,
                        0x70110,
                        0x80071,
                        0x80031,
                        0x900c2,
                        0x70108,
                        0x80061,
                        0x80021,
                        0x900a2,
                        0x80001,
                        0x80081,
                        0x80041,
                        0x900e2,
                        0x70104,
                        0x80059,
                        0x80019,
                        0x90092,
                        0x70114,
                        0x80079,
                        0x80039,
                        0x900d2,
                        0x7010c,
                        0x80069,
                        0x80029,
                        0x900b2,
                        0x80009,
                        0x80089,
                        0x80049,
                        0x900f2,
                        0x70102,
                        0x80055,
                        0x80015,
                        0x8011d,
                        0x70112,
                        0x80075,
                        0x80035,
                        0x900ca,
                        0x7010a,
                        0x80065,
                        0x80025,
                        0x900aa,
                        0x80005,
                        0x80085,
                        0x80045,
                        0x900ea,
                        0x70106,
                        0x8005d,
                        0x8001d,
                        0x9009a,
                        0x70116,
                        0x8007d,
                        0x8003d,
                        0x900da,
                        0x7010e,
                        0x8006d,
                        0x8002d,
                        0x900ba,
                        0x8000d,
                        0x8008d,
                        0x8004d,
                        0x900fa,
                        0x70101,
                        0x80053,
                        0x80013,
                        0x8011b,
                        0x70111,
                        0x80073,
                        0x80033,
                        0x900c6,
                        0x70109,
                        0x80063,
                        0x80023,
                        0x900a6,
                        0x80003,
                        0x80083,
                        0x80043,
                        0x900e6,
                        0x70105,
                        0x8005b,
                        0x8001b,
                        0x90096,
                        0x70115,
                        0x8007b,
                        0x8003b,
                        0x900d6,
                        0x7010d,
                        0x8006b,
                        0x8002b,
                        0x900b6,
                        0x8000b,
                        0x8008b,
                        0x8004b,
                        0x900f6,
                        0x70103,
                        0x80057,
                        0x80017,
                        0x8011f,
                        0x70113,
                        0x80077,
                        0x80037,
                        0x900ce,
                        0x7010b,
                        0x80067,
                        0x80027,
                        0x900ae,
                        0x80007,
                        0x80087,
                        0x80047,
                        0x900ee,
                        0x70107,
                        0x8005f,
                        0x8001f,
                        0x9009e,
                        0x70117,
                        0x8007f,
                        0x8003f,
                        0x900de,
                        0x7010f,
                        0x8006f,
                        0x8002f,
                        0x900be,
                        0x8000f,
                        0x8008f,
                        0x8004f,
                        0x900fe,
                        0x70100,
                        0x80050,
                        0x80010,
                        0x80118,
                        0x70110,
                        0x80070,
                        0x80030,
                        0x900c1,
                        0x70108,
                        0x80060,
                        0x80020,
                        0x900a1,
                        0x80000,
                        0x80080,
                        0x80040,
                        0x900e1,
                        0x70104,
                        0x80058,
                        0x80018,
                        0x90091,
                        0x70114,
                        0x80078,
                        0x80038,
                        0x900d1,
                        0x7010c,
                        0x80068,
                        0x80028,
                        0x900b1,
                        0x80008,
                        0x80088,
                        0x80048,
                        0x900f1,
                        0x70102,
                        0x80054,
                        0x80014,
                        0x8011c,
                        0x70112,
                        0x80074,
                        0x80034,
                        0x900c9,
                        0x7010a,
                        0x80064,
                        0x80024,
                        0x900a9,
                        0x80004,
                        0x80084,
                        0x80044,
                        0x900e9,
                        0x70106,
                        0x8005c,
                        0x8001c,
                        0x90099,
                        0x70116,
                        0x8007c,
                        0x8003c,
                        0x900d9,
                        0x7010e,
                        0x8006c,
                        0x8002c,
                        0x900b9,
                        0x8000c,
                        0x8008c,
                        0x8004c,
                        0x900f9,
                        0x70101,
                        0x80052,
                        0x80012,
                        0x8011a,
                        0x70111,
                        0x80072,
                        0x80032,
                        0x900c5,
                        0x70109,
                        0x80062,
                        0x80022,
                        0x900a5,
                        0x80002,
                        0x80082,
                        0x80042,
                        0x900e5,
                        0x70105,
                        0x8005a,
                        0x8001a,
                        0x90095,
                        0x70115,
                        0x8007a,
                        0x8003a,
                        0x900d5,
                        0x7010d,
                        0x8006a,
                        0x8002a,
                        0x900b5,
                        0x8000a,
                        0x8008a,
                        0x8004a,
                        0x900f5,
                        0x70103,
                        0x80056,
                        0x80016,
                        0x8011e,
                        0x70113,
                        0x80076,
                        0x80036,
                        0x900cd,
                        0x7010b,
                        0x80066,
                        0x80026,
                        0x900ad,
                        0x80006,
                        0x80086,
                        0x80046,
                        0x900ed,
                        0x70107,
                        0x8005e,
                        0x8001e,
                        0x9009d,
                        0x70117,
                        0x8007e,
                        0x8003e,
                        0x900dd,
                        0x7010f,
                        0x8006e,
                        0x8002e,
                        0x900bd,
                        0x8000e,
                        0x8008e,
                        0x8004e,
                        0x900fd,
                        0x70100,
                        0x80051,
                        0x80011,
                        0x80119,
                        0x70110,
                        0x80071,
                        0x80031,
                        0x900c3,
                        0x70108,
                        0x80061,
                        0x80021,
                        0x900a3,
                        0x80001,
                        0x80081,
                        0x80041,
                        0x900e3,
                        0x70104,
                        0x80059,
                        0x80019,
                        0x90093,
                        0x70114,
                        0x80079,
                        0x80039,
                        0x900d3,
                        0x7010c,
                        0x80069,
                        0x80029,
                        0x900b3,
                        0x80009,
                        0x80089,
                        0x80049,
                        0x900f3,
                        0x70102,
                        0x80055,
                        0x80015,
                        0x8011d,
                        0x70112,
                        0x80075,
                        0x80035,
                        0x900cb,
                        0x7010a,
                        0x80065,
                        0x80025,
                        0x900ab,
                        0x80005,
                        0x80085,
                        0x80045,
                        0x900eb,
                        0x70106,
                        0x8005d,
                        0x8001d,
                        0x9009b,
                        0x70116,
                        0x8007d,
                        0x8003d,
                        0x900db,
                        0x7010e,
                        0x8006d,
                        0x8002d,
                        0x900bb,
                        0x8000d,
                        0x8008d,
                        0x8004d,
                        0x900fb,
                        0x70101,
                        0x80053,
                        0x80013,
                        0x8011b,
                        0x70111,
                        0x80073,
                        0x80033,
                        0x900c7,
                        0x70109,
                        0x80063,
                        0x80023,
                        0x900a7,
                        0x80003,
                        0x80083,
                        0x80043,
                        0x900e7,
                        0x70105,
                        0x8005b,
                        0x8001b,
                        0x90097,
                        0x70115,
                        0x8007b,
                        0x8003b,
                        0x900d7,
                        0x7010d,
                        0x8006b,
                        0x8002b,
                        0x900b7,
                        0x8000b,
                        0x8008b,
                        0x8004b,
                        0x900f7,
                        0x70103,
                        0x80057,
                        0x80017,
                        0x8011f,
                        0x70113,
                        0x80077,
                        0x80037,
                        0x900cf,
                        0x7010b,
                        0x80067,
                        0x80027,
                        0x900af,
                        0x80007,
                        0x80087,
                        0x80047,
                        0x900ef,
                        0x70107,
                        0x8005f,
                        0x8001f,
                        0x9009f,
                        0x70117,
                        0x8007f,
                        0x8003f,
                        0x900df,
                        0x7010f,
                        0x8006f,
                        0x8002f,
                        0x900bf,
                        0x8000f,
                        0x8008f,
                        0x8004f,
                        0x900ff
                    ]),
                    9
                ];
                const fixedDistCodeTab = [
                    new Int32Array([
                        0x50000,
                        0x50010,
                        0x50008,
                        0x50018,
                        0x50004,
                        0x50014,
                        0x5000c,
                        0x5001c,
                        0x50002,
                        0x50012,
                        0x5000a,
                        0x5001a,
                        0x50006,
                        0x50016,
                        0x5000e,
                        0x00000,
                        0x50001,
                        0x50011,
                        0x50009,
                        0x50019,
                        0x50005,
                        0x50015,
                        0x5000d,
                        0x5001d,
                        0x50003,
                        0x50013,
                        0x5000b,
                        0x5001b,
                        0x50007,
                        0x50017,
                        0x5000f,
                        0x00000
                    ]),
                    5
                ];
                class FlateStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        const cmf = str.getByte();
                        const flg = str.getByte();
                        if (cmf === -1 || flg === -1) throw new _util.FormatError(`Invalid header in flate stream: ${cmf}, ${flg}`);
                        if ((cmf & 0x0f) !== 0x08) throw new _util.FormatError(`Unknown compression method in flate stream: ${cmf}, ${flg}`);
                        if (((cmf << 8) + flg) % 31 !== 0) throw new _util.FormatError(`Bad FCHECK in flate stream: ${cmf}, ${flg}`);
                        if (flg & 0x20) throw new _util.FormatError(`FDICT bit set in flate stream: ${cmf}, ${flg}`);
                        this.codeSize = 0;
                        this.codeBuf = 0;
                    }
                    getBits(bits) {
                        const str = this.str;
                        let codeSize = this.codeSize;
                        let codeBuf = this.codeBuf;
                        let b;
                        while(codeSize < bits){
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad encoding in flate stream");
                            codeBuf |= b << codeSize;
                            codeSize += 8;
                        }
                        b = codeBuf & (1 << bits) - 1;
                        this.codeBuf = codeBuf >> bits;
                        this.codeSize = codeSize -= bits;
                        return b;
                    }
                    getCode(table) {
                        const str = this.str;
                        const codes = table[0];
                        const maxLen = table[1];
                        let codeSize = this.codeSize;
                        let codeBuf = this.codeBuf;
                        let b;
                        while(codeSize < maxLen){
                            if ((b = str.getByte()) === -1) break;
                            codeBuf |= b << codeSize;
                            codeSize += 8;
                        }
                        const code = codes[codeBuf & (1 << maxLen) - 1];
                        const codeLen = code >> 16;
                        const codeVal = code & 0xffff;
                        if (codeLen < 1 || codeSize < codeLen) throw new _util.FormatError("Bad encoding in flate stream");
                        this.codeBuf = codeBuf >> codeLen;
                        this.codeSize = codeSize - codeLen;
                        return codeVal;
                    }
                    generateHuffmanTable(lengths) {
                        const n = lengths.length;
                        let maxLen = 0;
                        let i;
                        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
                        const size = 1 << maxLen;
                        const codes = new Int32Array(size);
                        for(let len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
                            for(let val = 0; val < n; ++val)if (lengths[val] === len) {
                                let code2 = 0;
                                let t = code;
                                for(i = 0; i < len; ++i){
                                    code2 = code2 << 1 | t & 1;
                                    t >>= 1;
                                }
                                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                                ++code;
                            }
                        }
                        return [
                            codes,
                            maxLen
                        ];
                    }
                    readBlock() {
                        let buffer, len;
                        const str = this.str;
                        let hdr = this.getBits(3);
                        if (hdr & 1) this.eof = true;
                        hdr >>= 1;
                        if (hdr === 0) {
                            let b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            let blockLen = b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            blockLen |= b << 8;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            let check = b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            check |= b << 8;
                            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) throw new _util.FormatError("Bad uncompressed block length in flate stream");
                            this.codeBuf = 0;
                            this.codeSize = 0;
                            const bufferLength = this.bufferLength, end = bufferLength + blockLen;
                            buffer = this.ensureBuffer(end);
                            this.bufferLength = end;
                            if (blockLen === 0) {
                                if (str.peekByte() === -1) this.eof = true;
                            } else {
                                const block = str.getBytes(blockLen);
                                buffer.set(block, bufferLength);
                                if (block.length < blockLen) this.eof = true;
                            }
                            return;
                        }
                        let litCodeTable;
                        let distCodeTable;
                        if (hdr === 1) {
                            litCodeTable = fixedLitCodeTab;
                            distCodeTable = fixedDistCodeTab;
                        } else if (hdr === 2) {
                            const numLitCodes = this.getBits(5) + 257;
                            const numDistCodes = this.getBits(5) + 1;
                            const numCodeLenCodes = this.getBits(4) + 4;
                            const codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
                            let i;
                            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
                            const codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
                            len = 0;
                            i = 0;
                            const codes = numLitCodes + numDistCodes;
                            const codeLengths = new Uint8Array(codes);
                            let bitsLength, bitsOffset, what;
                            while(i < codes){
                                const code = this.getCode(codeLenCodeTab);
                                if (code === 16) {
                                    bitsLength = 2;
                                    bitsOffset = 3;
                                    what = len;
                                } else if (code === 17) {
                                    bitsLength = 3;
                                    bitsOffset = 3;
                                    what = len = 0;
                                } else if (code === 18) {
                                    bitsLength = 7;
                                    bitsOffset = 11;
                                    what = len = 0;
                                } else {
                                    codeLengths[i++] = len = code;
                                    continue;
                                }
                                let repeatLength = this.getBits(bitsLength) + bitsOffset;
                                while(repeatLength-- > 0)codeLengths[i++] = what;
                            }
                            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
                            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
                        } else throw new _util.FormatError("Unknown block type in flate stream");
                        buffer = this.buffer;
                        let limit = buffer ? buffer.length : 0;
                        let pos = this.bufferLength;
                        while(true){
                            let code1 = this.getCode(litCodeTable);
                            if (code1 < 256) {
                                if (pos + 1 >= limit) {
                                    buffer = this.ensureBuffer(pos + 1);
                                    limit = buffer.length;
                                }
                                buffer[pos++] = code1;
                                continue;
                            }
                            if (code1 === 256) {
                                this.bufferLength = pos;
                                return;
                            }
                            code1 -= 257;
                            code1 = lengthDecode[code1];
                            let code2 = code1 >> 16;
                            if (code2 > 0) code2 = this.getBits(code2);
                            len = (code1 & 0xffff) + code2;
                            code1 = this.getCode(distCodeTable);
                            code1 = distDecode[code1];
                            code2 = code1 >> 16;
                            if (code2 > 0) code2 = this.getBits(code2);
                            const dist = (code1 & 0xffff) + code2;
                            if (pos + len >= limit) {
                                buffer = this.ensureBuffer(pos + len);
                                limit = buffer.length;
                            }
                            for(let k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
                        }
                    }
                }
                exports.FlateStream = FlateStream;
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Jbig2Stream = void 0;
                var _base_stream = __w_pdfjs_require__(5);
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                var _jbig = __w_pdfjs_require__(24);
                var _util = __w_pdfjs_require__(2);
                class Jbig2Stream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jbig2Image = new _jbig.Jbig2Image();
                        const chunks = [];
                        if (this.params instanceof _primitives.Dict) {
                            const globalsStream = this.params.get("JBIG2Globals");
                            if (globalsStream instanceof _base_stream.BaseStream) {
                                const globals = globalsStream.getBytes();
                                chunks.push({
                                    data: globals,
                                    start: 0,
                                    end: globals.length
                                });
                            }
                        }
                        chunks.push({
                            data: this.bytes,
                            start: 0,
                            end: this.bytes.length
                        });
                        const data = jbig2Image.parseChunks(chunks);
                        const dataLength = data.length;
                        for(let i = 0; i < dataLength; i++)data[i] ^= 0xff;
                        this.buffer = data;
                        this.bufferLength = dataLength;
                        this.eof = true;
                    }
                }
                exports.Jbig2Stream = Jbig2Stream;
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Jbig2Image = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _arithmetic_decoder = __w_pdfjs_require__(25);
                var _ccitt = __w_pdfjs_require__(21);
                class Jbig2Error extends _util.BaseException {
                    constructor(msg){
                        super(`JBIG2 error: ${msg}`, "Jbig2Error");
                    }
                }
                class ContextCache {
                    getContexts(id) {
                        if (id in this) return this[id];
                        return this[id] = new Int8Array(65536);
                    }
                }
                class DecodingContext {
                    constructor(data, start, end){
                        this.data = data;
                        this.start = start;
                        this.end = end;
                    }
                    get decoder() {
                        const decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
                        return (0, _util.shadow)(this, "decoder", decoder);
                    }
                    get contextCache() {
                        const cache = new ContextCache();
                        return (0, _util.shadow)(this, "contextCache", cache);
                    }
                }
                const MAX_INT_32 = 2 ** 31 - 1;
                const MIN_INT_32 = -(2 ** 31);
                function decodeInteger(contextCache, procedure, decoder) {
                    const contexts = contextCache.getContexts(procedure);
                    let prev = 1;
                    function readBits(length) {
                        let v = 0;
                        for(let i = 0; i < length; i++){
                            const bit = decoder.readBit(contexts, prev);
                            prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
                            v = v << 1 | bit;
                        }
                        return v >>> 0;
                    }
                    const sign = readBits(1);
                    const value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
                    let signedValue;
                    if (sign === 0) signedValue = value;
                    else if (value > 0) signedValue = -value;
                    if (signedValue >= MIN_INT_32 && signedValue <= MAX_INT_32) return signedValue;
                    return null;
                }
                function decodeIAID(contextCache, decoder, codeLength) {
                    const contexts = contextCache.getContexts("IAID");
                    let prev = 1;
                    for(let i = 0; i < codeLength; i++){
                        const bit = decoder.readBit(contexts, prev);
                        prev = prev << 1 | bit;
                    }
                    if (codeLength < 31) return prev & (1 << codeLength) - 1;
                    return prev & 0x7fffffff;
                }
                const SegmentTypes = [
                    "SymbolDictionary",
                    null,
                    null,
                    null,
                    "IntermediateTextRegion",
                    null,
                    "ImmediateTextRegion",
                    "ImmediateLosslessTextRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "PatternDictionary",
                    null,
                    null,
                    null,
                    "IntermediateHalftoneRegion",
                    null,
                    "ImmediateHalftoneRegion",
                    "ImmediateLosslessHalftoneRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "IntermediateGenericRegion",
                    null,
                    "ImmediateGenericRegion",
                    "ImmediateLosslessGenericRegion",
                    "IntermediateGenericRefinementRegion",
                    null,
                    "ImmediateGenericRefinementRegion",
                    "ImmediateLosslessGenericRefinementRegion",
                    null,
                    null,
                    null,
                    null,
                    "PageInformation",
                    "EndOfPage",
                    "EndOfStripe",
                    "EndOfFile",
                    "Profiles",
                    "Tables",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "Extension"
                ];
                const CodingTemplates = [
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: 2,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -3,
                            y: -1
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ]
                ];
                const RefinementTemplates = [
                    {
                        coding: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: -1,
                                y: 1
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    },
                    {
                        coding: [
                            {
                                x: -1,
                                y: -1
                            },
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    }
                ];
                const ReusedContexts = [
                    0x9b25,
                    0x0795,
                    0x00e5,
                    0x0195
                ];
                const RefinementReusedContexts = [
                    0x0020,
                    0x0008
                ];
                function decodeBitmapTemplate0(width, height, decodingContext) {
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GB");
                    const bitmap = [];
                    let contextLabel, i, j, pixel, row, row1, row2;
                    const OLD_PIXEL_MASK = 0x7bf7;
                    for(i = 0; i < height; i++){
                        row = bitmap[i] = new Uint8Array(width);
                        row1 = i < 1 ? row : bitmap[i - 1];
                        row2 = i < 2 ? row : bitmap[i - 2];
                        contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
                        for(j = 0; j < width; j++){
                            row[j] = pixel = decoder.readBit(contexts, contextLabel);
                            contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
                    if (mmr) {
                        const input = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                        return decodeMMRBitmap(input, width, height, false);
                    }
                    if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) return decodeBitmapTemplate0(width, height, decodingContext);
                    const useskip = !!skip;
                    const template = CodingTemplates[templateIndex].concat(at);
                    template.sort(function(a, b) {
                        return a.y - b.y || a.x - b.x;
                    });
                    const templateLength = template.length;
                    const templateX = new Int8Array(templateLength);
                    const templateY = new Int8Array(templateLength);
                    const changingTemplateEntries = [];
                    let reuseMask = 0, minX = 0, maxX = 0, minY = 0;
                    let c, k;
                    for(k = 0; k < templateLength; k++){
                        templateX[k] = template[k].x;
                        templateY[k] = template[k].y;
                        minX = Math.min(minX, template[k].x);
                        maxX = Math.max(maxX, template[k].x);
                        minY = Math.min(minY, template[k].y);
                        if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) reuseMask |= 1 << templateLength - 1 - k;
                        else changingTemplateEntries.push(k);
                    }
                    const changingEntriesLength = changingTemplateEntries.length;
                    const changingTemplateX = new Int8Array(changingEntriesLength);
                    const changingTemplateY = new Int8Array(changingEntriesLength);
                    const changingTemplateBit = new Uint16Array(changingEntriesLength);
                    for(c = 0; c < changingEntriesLength; c++){
                        k = changingTemplateEntries[c];
                        changingTemplateX[c] = template[k].x;
                        changingTemplateY[c] = template[k].y;
                        changingTemplateBit[c] = 1 << templateLength - 1 - k;
                    }
                    const sbb_left = -minX;
                    const sbb_top = -minY;
                    const sbb_right = width - maxX;
                    const pseudoPixelContext = ReusedContexts[templateIndex];
                    let row = new Uint8Array(width);
                    const bitmap = [];
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GB");
                    let ltp = 0, j, i0, j0, contextLabel = 0, bit, shift;
                    for(let i = 0; i < height; i++){
                        if (prediction) {
                            const sltp = decoder.readBit(contexts, pseudoPixelContext);
                            ltp ^= sltp;
                            if (ltp) {
                                bitmap.push(row);
                                continue;
                            }
                        }
                        row = new Uint8Array(row);
                        bitmap.push(row);
                        for(j = 0; j < width; j++){
                            if (useskip && skip[i][j]) {
                                row[j] = 0;
                                continue;
                            }
                            if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
                                contextLabel = contextLabel << 1 & reuseMask;
                                for(k = 0; k < changingEntriesLength; k++){
                                    i0 = i + changingTemplateY[k];
                                    j0 = j + changingTemplateX[k];
                                    bit = bitmap[i0][j0];
                                    if (bit) {
                                        bit = changingTemplateBit[k];
                                        contextLabel |= bit;
                                    }
                                }
                            } else {
                                contextLabel = 0;
                                shift = templateLength - 1;
                                for(k = 0; k < templateLength; k++, shift--){
                                    j0 = j + templateX[k];
                                    if (j0 >= 0 && j0 < width) {
                                        i0 = i + templateY[k];
                                        if (i0 >= 0) {
                                            bit = bitmap[i0][j0];
                                            if (bit) contextLabel |= bit << shift;
                                        }
                                    }
                                }
                            }
                            const pixel = decoder.readBit(contexts, contextLabel);
                            row[j] = pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
                    let codingTemplate = RefinementTemplates[templateIndex].coding;
                    if (templateIndex === 0) codingTemplate = codingTemplate.concat([
                        at[0]
                    ]);
                    const codingTemplateLength = codingTemplate.length;
                    const codingTemplateX = new Int32Array(codingTemplateLength);
                    const codingTemplateY = new Int32Array(codingTemplateLength);
                    let k;
                    for(k = 0; k < codingTemplateLength; k++){
                        codingTemplateX[k] = codingTemplate[k].x;
                        codingTemplateY[k] = codingTemplate[k].y;
                    }
                    let referenceTemplate = RefinementTemplates[templateIndex].reference;
                    if (templateIndex === 0) referenceTemplate = referenceTemplate.concat([
                        at[1]
                    ]);
                    const referenceTemplateLength = referenceTemplate.length;
                    const referenceTemplateX = new Int32Array(referenceTemplateLength);
                    const referenceTemplateY = new Int32Array(referenceTemplateLength);
                    for(k = 0; k < referenceTemplateLength; k++){
                        referenceTemplateX[k] = referenceTemplate[k].x;
                        referenceTemplateY[k] = referenceTemplate[k].y;
                    }
                    const referenceWidth = referenceBitmap[0].length;
                    const referenceHeight = referenceBitmap.length;
                    const pseudoPixelContext = RefinementReusedContexts[templateIndex];
                    const bitmap = [];
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GR");
                    let ltp = 0;
                    for(let i = 0; i < height; i++){
                        if (prediction) {
                            const sltp = decoder.readBit(contexts, pseudoPixelContext);
                            ltp ^= sltp;
                            if (ltp) throw new Jbig2Error("prediction is not supported");
                        }
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        for(let j = 0; j < width; j++){
                            let i0, j0;
                            let contextLabel = 0;
                            for(k = 0; k < codingTemplateLength; k++){
                                i0 = i + codingTemplateY[k];
                                j0 = j + codingTemplateX[k];
                                if (i0 < 0 || j0 < 0 || j0 >= width) contextLabel <<= 1;
                                else contextLabel = contextLabel << 1 | bitmap[i0][j0];
                            }
                            for(k = 0; k < referenceTemplateLength; k++){
                                i0 = i + referenceTemplateY[k] - offsetY;
                                j0 = j + referenceTemplateX[k] - offsetX;
                                if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) contextLabel <<= 1;
                                else contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
                            }
                            const pixel = decoder.readBit(contexts, contextLabel);
                            row[j] = pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext, huffmanInput) {
                    if (huffman && refinement) throw new Jbig2Error("symbol refinement with Huffman is not supported");
                    const newSymbols = [];
                    let currentHeight = 0;
                    let symbolCodeLength = (0, _core_utils.log2)(symbols.length + numberOfNewSymbols);
                    const decoder = decodingContext.decoder;
                    const contextCache = decodingContext.contextCache;
                    let tableB1, symbolWidths;
                    if (huffman) {
                        tableB1 = getStandardTable(1);
                        symbolWidths = [];
                        symbolCodeLength = Math.max(symbolCodeLength, 1);
                    }
                    while(newSymbols.length < numberOfNewSymbols){
                        const deltaHeight = huffman ? huffmanTables.tableDeltaHeight.decode(huffmanInput) : decodeInteger(contextCache, "IADH", decoder);
                        currentHeight += deltaHeight;
                        let currentWidth = 0, totalWidth = 0;
                        const firstSymbol = huffman ? symbolWidths.length : 0;
                        while(true){
                            const deltaWidth = huffman ? huffmanTables.tableDeltaWidth.decode(huffmanInput) : decodeInteger(contextCache, "IADW", decoder);
                            if (deltaWidth === null) break;
                            currentWidth += deltaWidth;
                            totalWidth += currentWidth;
                            let bitmap;
                            if (refinement) {
                                const numberOfInstances = decodeInteger(contextCache, "IAAI", decoder);
                                if (numberOfInstances > 1) bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, 0, huffmanInput);
                                else {
                                    const symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
                                    const rdx = decodeInteger(contextCache, "IARDX", decoder);
                                    const rdy = decodeInteger(contextCache, "IARDY", decoder);
                                    const symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
                                    bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
                                }
                                newSymbols.push(bitmap);
                            } else if (huffman) symbolWidths.push(currentWidth);
                            else {
                                bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
                                newSymbols.push(bitmap);
                            }
                        }
                        if (huffman && !refinement) {
                            const bitmapSize = huffmanTables.tableBitmapSize.decode(huffmanInput);
                            huffmanInput.byteAlign();
                            let collectiveBitmap;
                            if (bitmapSize === 0) collectiveBitmap = readUncompressedBitmap(huffmanInput, totalWidth, currentHeight);
                            else {
                                const originalEnd = huffmanInput.end;
                                const bitmapEnd = huffmanInput.position + bitmapSize;
                                huffmanInput.end = bitmapEnd;
                                collectiveBitmap = decodeMMRBitmap(huffmanInput, totalWidth, currentHeight, false);
                                huffmanInput.end = originalEnd;
                                huffmanInput.position = bitmapEnd;
                            }
                            const numberOfSymbolsDecoded = symbolWidths.length;
                            if (firstSymbol === numberOfSymbolsDecoded - 1) newSymbols.push(collectiveBitmap);
                            else {
                                let i, y, xMin = 0, xMax, bitmapWidth, symbolBitmap;
                                for(i = firstSymbol; i < numberOfSymbolsDecoded; i++){
                                    bitmapWidth = symbolWidths[i];
                                    xMax = xMin + bitmapWidth;
                                    symbolBitmap = [];
                                    for(y = 0; y < currentHeight; y++)symbolBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                                    newSymbols.push(symbolBitmap);
                                    xMin = xMax;
                                }
                            }
                        }
                    }
                    const exportedSymbols = [], flags = [];
                    let currentFlag = false, i, ii;
                    const totalSymbolsLength = symbols.length + numberOfNewSymbols;
                    while(flags.length < totalSymbolsLength){
                        let runLength = huffman ? tableB1.decode(huffmanInput) : decodeInteger(contextCache, "IAEX", decoder);
                        while(runLength--)flags.push(currentFlag);
                        currentFlag = !currentFlag;
                    }
                    for(i = 0, ii = symbols.length; i < ii; i++)if (flags[i]) exportedSymbols.push(symbols[i]);
                    for(let j = 0; j < numberOfNewSymbols; i++, j++)if (flags[i]) exportedSymbols.push(newSymbols[j]);
                    return exportedSymbols;
                }
                function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, logStripSize, huffmanInput) {
                    if (huffman && refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                    const bitmap = [];
                    let i, row;
                    for(i = 0; i < height; i++){
                        row = new Uint8Array(width);
                        if (defaultPixelValue) for(let j = 0; j < width; j++)row[j] = defaultPixelValue;
                        bitmap.push(row);
                    }
                    const decoder = decodingContext.decoder;
                    const contextCache = decodingContext.contextCache;
                    let stripT = huffman ? -huffmanTables.tableDeltaT.decode(huffmanInput) : -decodeInteger(contextCache, "IADT", decoder);
                    let firstS = 0;
                    i = 0;
                    while(i < numberOfSymbolInstances){
                        const deltaT = huffman ? huffmanTables.tableDeltaT.decode(huffmanInput) : decodeInteger(contextCache, "IADT", decoder);
                        stripT += deltaT;
                        const deltaFirstS = huffman ? huffmanTables.tableFirstS.decode(huffmanInput) : decodeInteger(contextCache, "IAFS", decoder);
                        firstS += deltaFirstS;
                        let currentS = firstS;
                        do {
                            let currentT = 0;
                            if (stripSize > 1) currentT = huffman ? huffmanInput.readBits(logStripSize) : decodeInteger(contextCache, "IAIT", decoder);
                            const t = stripSize * stripT + currentT;
                            const symbolId = huffman ? huffmanTables.symbolIDTable.decode(huffmanInput) : decodeIAID(contextCache, decoder, symbolCodeLength);
                            const applyRefinement = refinement && (huffman ? huffmanInput.readBit() : decodeInteger(contextCache, "IARI", decoder));
                            let symbolBitmap = inputSymbols[symbolId];
                            let symbolWidth = symbolBitmap[0].length;
                            let symbolHeight = symbolBitmap.length;
                            if (applyRefinement) {
                                const rdw = decodeInteger(contextCache, "IARDW", decoder);
                                const rdh = decodeInteger(contextCache, "IARDH", decoder);
                                const rdx = decodeInteger(contextCache, "IARDX", decoder);
                                const rdy = decodeInteger(contextCache, "IARDY", decoder);
                                symbolWidth += rdw;
                                symbolHeight += rdh;
                                symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
                            }
                            const offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight - 1);
                            const offsetS = currentS - (referenceCorner & 2 ? symbolWidth - 1 : 0);
                            let s2, t2, symbolRow;
                            if (transposed) {
                                for(s2 = 0; s2 < symbolHeight; s2++){
                                    row = bitmap[offsetS + s2];
                                    if (!row) continue;
                                    symbolRow = symbolBitmap[s2];
                                    const maxWidth = Math.min(width - offsetT, symbolWidth);
                                    switch(combinationOperator){
                                        case 0:
                                            for(t2 = 0; t2 < maxWidth; t2++)row[offsetT + t2] |= symbolRow[t2];
                                            break;
                                        case 2:
                                            for(t2 = 0; t2 < maxWidth; t2++)row[offsetT + t2] ^= symbolRow[t2];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                                    }
                                }
                                currentS += symbolHeight - 1;
                            } else {
                                for(t2 = 0; t2 < symbolHeight; t2++){
                                    row = bitmap[offsetT + t2];
                                    if (!row) continue;
                                    symbolRow = symbolBitmap[t2];
                                    switch(combinationOperator){
                                        case 0:
                                            for(s2 = 0; s2 < symbolWidth; s2++)row[offsetS + s2] |= symbolRow[s2];
                                            break;
                                        case 2:
                                            for(s2 = 0; s2 < symbolWidth; s2++)row[offsetS + s2] ^= symbolRow[s2];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                                    }
                                }
                                currentS += symbolWidth - 1;
                            }
                            i++;
                            const deltaS = huffman ? huffmanTables.tableDeltaS.decode(huffmanInput) : decodeInteger(contextCache, "IADS", decoder);
                            if (deltaS === null) break;
                            currentS += deltaS + dsOffset;
                        }while (true);
                    }
                    return bitmap;
                }
                function decodePatternDictionary(mmr, patternWidth, patternHeight, maxPatternIndex, template, decodingContext) {
                    const at = [];
                    if (!mmr) {
                        at.push({
                            x: -patternWidth,
                            y: 0
                        });
                        if (template === 0) at.push({
                            x: -3,
                            y: -1
                        }, {
                            x: 2,
                            y: -2
                        }, {
                            x: -2,
                            y: -2
                        });
                    }
                    const collectiveWidth = (maxPatternIndex + 1) * patternWidth;
                    const collectiveBitmap = decodeBitmap(mmr, collectiveWidth, patternHeight, template, false, null, at, decodingContext);
                    const patterns = [];
                    for(let i = 0; i <= maxPatternIndex; i++){
                        const patternBitmap = [];
                        const xMin = patternWidth * i;
                        const xMax = xMin + patternWidth;
                        for(let y = 0; y < patternHeight; y++)patternBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                        patterns.push(patternBitmap);
                    }
                    return patterns;
                }
                function decodeHalftoneRegion(mmr, patterns, template, regionWidth, regionHeight, defaultPixelValue, enableSkip, combinationOperator, gridWidth, gridHeight, gridOffsetX, gridOffsetY, gridVectorX, gridVectorY, decodingContext) {
                    const skip = null;
                    if (enableSkip) throw new Jbig2Error("skip is not supported");
                    if (combinationOperator !== 0) throw new Jbig2Error(`operator "${combinationOperator}" is not supported in halftone region`);
                    const regionBitmap = [];
                    let i, j, row;
                    for(i = 0; i < regionHeight; i++){
                        row = new Uint8Array(regionWidth);
                        if (defaultPixelValue) for(j = 0; j < regionWidth; j++)row[j] = defaultPixelValue;
                        regionBitmap.push(row);
                    }
                    const numberOfPatterns = patterns.length;
                    const pattern0 = patterns[0];
                    const patternWidth = pattern0[0].length, patternHeight = pattern0.length;
                    const bitsPerValue = (0, _core_utils.log2)(numberOfPatterns);
                    const at = [];
                    if (!mmr) {
                        at.push({
                            x: template <= 1 ? 3 : 2,
                            y: -1
                        });
                        if (template === 0) at.push({
                            x: -3,
                            y: -1
                        }, {
                            x: 2,
                            y: -2
                        }, {
                            x: -2,
                            y: -2
                        });
                    }
                    const grayScaleBitPlanes = [];
                    let mmrInput, bitmap;
                    if (mmr) mmrInput = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                    for(i = bitsPerValue - 1; i >= 0; i--){
                        if (mmr) bitmap = decodeMMRBitmap(mmrInput, gridWidth, gridHeight, true);
                        else bitmap = decodeBitmap(false, gridWidth, gridHeight, template, false, skip, at, decodingContext);
                        grayScaleBitPlanes[i] = bitmap;
                    }
                    let mg, ng, bit, patternIndex, patternBitmap, x, y, patternRow, regionRow;
                    for(mg = 0; mg < gridHeight; mg++)for(ng = 0; ng < gridWidth; ng++){
                        bit = 0;
                        patternIndex = 0;
                        for(j = bitsPerValue - 1; j >= 0; j--){
                            bit ^= grayScaleBitPlanes[j][mg][ng];
                            patternIndex |= bit << j;
                        }
                        patternBitmap = patterns[patternIndex];
                        x = gridOffsetX + mg * gridVectorY + ng * gridVectorX >> 8;
                        y = gridOffsetY + mg * gridVectorX - ng * gridVectorY >> 8;
                        if (x >= 0 && x + patternWidth <= regionWidth && y >= 0 && y + patternHeight <= regionHeight) for(i = 0; i < patternHeight; i++){
                            regionRow = regionBitmap[y + i];
                            patternRow = patternBitmap[i];
                            for(j = 0; j < patternWidth; j++)regionRow[x + j] |= patternRow[j];
                        }
                        else {
                            let regionX, regionY;
                            for(i = 0; i < patternHeight; i++){
                                regionY = y + i;
                                if (regionY < 0 || regionY >= regionHeight) continue;
                                regionRow = regionBitmap[regionY];
                                patternRow = patternBitmap[i];
                                for(j = 0; j < patternWidth; j++){
                                    regionX = x + j;
                                    if (regionX >= 0 && regionX < regionWidth) regionRow[regionX] |= patternRow[j];
                                }
                            }
                        }
                    }
                    return regionBitmap;
                }
                function readSegmentHeader(data, start) {
                    const segmentHeader = {};
                    segmentHeader.number = (0, _core_utils.readUint32)(data, start);
                    const flags = data[start + 4];
                    const segmentType = flags & 0x3f;
                    if (!SegmentTypes[segmentType]) throw new Jbig2Error("invalid segment type: " + segmentType);
                    segmentHeader.type = segmentType;
                    segmentHeader.typeName = SegmentTypes[segmentType];
                    segmentHeader.deferredNonRetain = !!(flags & 0x80);
                    const pageAssociationFieldSize = !!(flags & 0x40);
                    const referredFlags = data[start + 5];
                    let referredToCount = referredFlags >> 5 & 7;
                    const retainBits = [
                        referredFlags & 31
                    ];
                    let position = start + 6;
                    if (referredFlags === 7) {
                        referredToCount = (0, _core_utils.readUint32)(data, position - 1) & 0x1fffffff;
                        position += 3;
                        let bytes = referredToCount + 7 >> 3;
                        retainBits[0] = data[position++];
                        while(--bytes > 0)retainBits.push(data[position++]);
                    } else if (referredFlags === 5 || referredFlags === 6) throw new Jbig2Error("invalid referred-to flags");
                    segmentHeader.retainBits = retainBits;
                    let referredToSegmentNumberSize = 4;
                    if (segmentHeader.number <= 256) referredToSegmentNumberSize = 1;
                    else if (segmentHeader.number <= 65536) referredToSegmentNumberSize = 2;
                    const referredTo = [];
                    let i, ii;
                    for(i = 0; i < referredToCount; i++){
                        let number;
                        if (referredToSegmentNumberSize === 1) number = data[position];
                        else if (referredToSegmentNumberSize === 2) number = (0, _core_utils.readUint16)(data, position);
                        else number = (0, _core_utils.readUint32)(data, position);
                        referredTo.push(number);
                        position += referredToSegmentNumberSize;
                    }
                    segmentHeader.referredTo = referredTo;
                    if (!pageAssociationFieldSize) segmentHeader.pageAssociation = data[position++];
                    else {
                        segmentHeader.pageAssociation = (0, _core_utils.readUint32)(data, position);
                        position += 4;
                    }
                    segmentHeader.length = (0, _core_utils.readUint32)(data, position);
                    position += 4;
                    if (segmentHeader.length === 0xffffffff) {
                        if (segmentType === 38) {
                            const genericRegionInfo = readRegionSegmentInformation(data, position);
                            const genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
                            const genericRegionMmr = !!(genericRegionSegmentFlags & 1);
                            const searchPatternLength = 6;
                            const searchPattern = new Uint8Array(searchPatternLength);
                            if (!genericRegionMmr) {
                                searchPattern[0] = 0xff;
                                searchPattern[1] = 0xac;
                            }
                            searchPattern[2] = genericRegionInfo.height >>> 24 & 0xff;
                            searchPattern[3] = genericRegionInfo.height >> 16 & 0xff;
                            searchPattern[4] = genericRegionInfo.height >> 8 & 0xff;
                            searchPattern[5] = genericRegionInfo.height & 0xff;
                            for(i = position, ii = data.length; i < ii; i++){
                                let j = 0;
                                while(j < searchPatternLength && searchPattern[j] === data[i + j])j++;
                                if (j === searchPatternLength) {
                                    segmentHeader.length = i + searchPatternLength;
                                    break;
                                }
                            }
                            if (segmentHeader.length === 0xffffffff) throw new Jbig2Error("segment end was not found");
                        } else throw new Jbig2Error("invalid unknown segment length");
                    }
                    segmentHeader.headerEnd = position;
                    return segmentHeader;
                }
                function readSegments(header, data, start, end) {
                    const segments = [];
                    let position = start;
                    while(position < end){
                        const segmentHeader = readSegmentHeader(data, position);
                        position = segmentHeader.headerEnd;
                        const segment = {
                            header: segmentHeader,
                            data: data
                        };
                        if (!header.randomAccess) {
                            segment.start = position;
                            position += segmentHeader.length;
                            segment.end = position;
                        }
                        segments.push(segment);
                        if (segmentHeader.type === 51) break;
                    }
                    if (header.randomAccess) for(let i = 0, ii = segments.length; i < ii; i++){
                        segments[i].start = position;
                        position += segments[i].header.length;
                        segments[i].end = position;
                    }
                    return segments;
                }
                function readRegionSegmentInformation(data, start) {
                    return {
                        width: (0, _core_utils.readUint32)(data, start),
                        height: (0, _core_utils.readUint32)(data, start + 4),
                        x: (0, _core_utils.readUint32)(data, start + 8),
                        y: (0, _core_utils.readUint32)(data, start + 12),
                        combinationOperator: data[start + 16] & 7
                    };
                }
                const RegionSegmentInformationFieldLength = 17;
                function processSegment(segment, visitor) {
                    const header = segment.header;
                    const data = segment.data, end = segment.end;
                    let position = segment.start;
                    let args, at, i, atLength;
                    switch(header.type){
                        case 0:
                            const dictionary = {};
                            const dictionaryFlags = (0, _core_utils.readUint16)(data, position);
                            dictionary.huffman = !!(dictionaryFlags & 1);
                            dictionary.refinement = !!(dictionaryFlags & 2);
                            dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
                            dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
                            dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
                            dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
                            dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
                            dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
                            dictionary.template = dictionaryFlags >> 10 & 3;
                            dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
                            position += 2;
                            if (!dictionary.huffman) {
                                atLength = dictionary.template === 0 ? 4 : 1;
                                at = [];
                                for(i = 0; i < atLength; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                dictionary.at = at;
                            }
                            if (dictionary.refinement && !dictionary.refinementTemplate) {
                                at = [];
                                for(i = 0; i < 2; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                dictionary.refinementAt = at;
                            }
                            dictionary.numberOfExportedSymbols = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            dictionary.numberOfNewSymbols = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                dictionary,
                                header.number,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 6:
                        case 7:
                            const textRegion = {};
                            textRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const textRegionSegmentFlags = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            textRegion.huffman = !!(textRegionSegmentFlags & 1);
                            textRegion.refinement = !!(textRegionSegmentFlags & 2);
                            textRegion.logStripSize = textRegionSegmentFlags >> 2 & 3;
                            textRegion.stripSize = 1 << textRegion.logStripSize;
                            textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
                            textRegion.transposed = !!(textRegionSegmentFlags & 64);
                            textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
                            textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
                            textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
                            textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
                            if (textRegion.huffman) {
                                const textRegionHuffmanFlags = (0, _core_utils.readUint16)(data, position);
                                position += 2;
                                textRegion.huffmanFS = textRegionHuffmanFlags & 3;
                                textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
                                textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
                                textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
                                textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
                                textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
                                textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
                                textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 0x4000);
                            }
                            if (textRegion.refinement && !textRegion.refinementTemplate) {
                                at = [];
                                for(i = 0; i < 2; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                textRegion.refinementAt = at;
                            }
                            textRegion.numberOfSymbolInstances = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                textRegion,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 16:
                            const patternDictionary = {};
                            const patternDictionaryFlags = data[position++];
                            patternDictionary.mmr = !!(patternDictionaryFlags & 1);
                            patternDictionary.template = patternDictionaryFlags >> 1 & 3;
                            patternDictionary.patternWidth = data[position++];
                            patternDictionary.patternHeight = data[position++];
                            patternDictionary.maxPatternIndex = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                patternDictionary,
                                header.number,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 22:
                        case 23:
                            const halftoneRegion = {};
                            halftoneRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const halftoneRegionFlags = data[position++];
                            halftoneRegion.mmr = !!(halftoneRegionFlags & 1);
                            halftoneRegion.template = halftoneRegionFlags >> 1 & 3;
                            halftoneRegion.enableSkip = !!(halftoneRegionFlags & 8);
                            halftoneRegion.combinationOperator = halftoneRegionFlags >> 4 & 7;
                            halftoneRegion.defaultPixelValue = halftoneRegionFlags >> 7 & 1;
                            halftoneRegion.gridWidth = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            halftoneRegion.gridHeight = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            halftoneRegion.gridOffsetX = (0, _core_utils.readUint32)(data, position) & 0xffffffff;
                            position += 4;
                            halftoneRegion.gridOffsetY = (0, _core_utils.readUint32)(data, position) & 0xffffffff;
                            position += 4;
                            halftoneRegion.gridVectorX = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            halftoneRegion.gridVectorY = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            args = [
                                halftoneRegion,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 38:
                        case 39:
                            const genericRegion = {};
                            genericRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const genericRegionSegmentFlags = data[position++];
                            genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
                            genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
                            genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
                            if (!genericRegion.mmr) {
                                atLength = genericRegion.template === 0 ? 4 : 1;
                                at = [];
                                for(i = 0; i < atLength; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                genericRegion.at = at;
                            }
                            args = [
                                genericRegion,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 48:
                            const pageInfo = {
                                width: (0, _core_utils.readUint32)(data, position),
                                height: (0, _core_utils.readUint32)(data, position + 4),
                                resolutionX: (0, _core_utils.readUint32)(data, position + 8),
                                resolutionY: (0, _core_utils.readUint32)(data, position + 12)
                            };
                            if (pageInfo.height === 0xffffffff) delete pageInfo.height;
                            const pageSegmentFlags = data[position + 16];
                            (0, _core_utils.readUint16)(data, position + 17);
                            pageInfo.lossless = !!(pageSegmentFlags & 1);
                            pageInfo.refinement = !!(pageSegmentFlags & 2);
                            pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
                            pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
                            pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
                            pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
                            args = [
                                pageInfo
                            ];
                            break;
                        case 49:
                            break;
                        case 50:
                            break;
                        case 51:
                            break;
                        case 53:
                            args = [
                                header.number,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 62:
                            break;
                        default:
                            throw new Jbig2Error(`segment type ${header.typeName}(${header.type}) is not implemented`);
                    }
                    const callbackName = "on" + header.typeName;
                    if (callbackName in visitor) visitor[callbackName].apply(visitor, args);
                }
                function processSegments(segments, visitor) {
                    for(let i = 0, ii = segments.length; i < ii; i++)processSegment(segments[i], visitor);
                }
                function parseJbig2Chunks(chunks) {
                    const visitor = new SimpleSegmentVisitor();
                    for(let i = 0, ii = chunks.length; i < ii; i++){
                        const chunk = chunks[i];
                        const segments = readSegments({}, chunk.data, chunk.start, chunk.end);
                        processSegments(segments, visitor);
                    }
                    return visitor.buffer;
                }
                function parseJbig2(data) {
                    throw new Error("Not implemented: parseJbig2");
                }
                class SimpleSegmentVisitor {
                    onPageInformation(info) {
                        this.currentPageInfo = info;
                        const rowSize = info.width + 7 >> 3;
                        const buffer = new Uint8ClampedArray(rowSize * info.height);
                        if (info.defaultPixelValue) buffer.fill(0xff);
                        this.buffer = buffer;
                    }
                    drawBitmap(regionInfo, bitmap) {
                        const pageInfo = this.currentPageInfo;
                        const width = regionInfo.width, height = regionInfo.height;
                        const rowSize = pageInfo.width + 7 >> 3;
                        const combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
                        const buffer = this.buffer;
                        const mask0 = 128 >> (regionInfo.x & 7);
                        let offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
                        let i, j, mask, offset;
                        switch(combinationOperator){
                            case 0:
                                for(i = 0; i < height; i++){
                                    mask = mask0;
                                    offset = offset0;
                                    for(j = 0; j < width; j++){
                                        if (bitmap[i][j]) buffer[offset] |= mask;
                                        mask >>= 1;
                                        if (!mask) {
                                            mask = 128;
                                            offset++;
                                        }
                                    }
                                    offset0 += rowSize;
                                }
                                break;
                            case 2:
                                for(i = 0; i < height; i++){
                                    mask = mask0;
                                    offset = offset0;
                                    for(j = 0; j < width; j++){
                                        if (bitmap[i][j]) buffer[offset] ^= mask;
                                        mask >>= 1;
                                        if (!mask) {
                                            mask = 128;
                                            offset++;
                                        }
                                    }
                                    offset0 += rowSize;
                                }
                                break;
                            default:
                                throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                        }
                    }
                    onImmediateGenericRegion(region, data, start, end) {
                        const regionInfo = region.info;
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessGenericRegion() {
                        this.onImmediateGenericRegion(...arguments);
                    }
                    onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
                        let huffmanTables, huffmanInput;
                        if (dictionary.huffman) {
                            huffmanTables = getSymbolDictionaryHuffmanTables(dictionary, referredSegments, this.customTables);
                            huffmanInput = new Reader(data, start, end);
                        }
                        let symbols = this.symbols;
                        if (!symbols) this.symbols = symbols = {};
                        const inputSymbols = [];
                        for (const referredSegment of referredSegments){
                            const referredSymbols = symbols[referredSegment];
                            if (referredSymbols) inputSymbols.push(...referredSymbols);
                        }
                        const decodingContext = new DecodingContext(data, start, end);
                        symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext, huffmanInput);
                    }
                    onImmediateTextRegion(region, referredSegments, data, start, end) {
                        const regionInfo = region.info;
                        let huffmanTables, huffmanInput;
                        const symbols = this.symbols;
                        const inputSymbols = [];
                        for (const referredSegment of referredSegments){
                            const referredSymbols = symbols[referredSegment];
                            if (referredSymbols) inputSymbols.push(...referredSymbols);
                        }
                        const symbolCodeLength = (0, _core_utils.log2)(inputSymbols.length);
                        if (region.huffman) {
                            huffmanInput = new Reader(data, start, end);
                            huffmanTables = getTextRegionHuffmanTables(region, referredSegments, this.customTables, inputSymbols.length, huffmanInput);
                        }
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext, region.logStripSize, huffmanInput);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessTextRegion() {
                        this.onImmediateTextRegion(...arguments);
                    }
                    onPatternDictionary(dictionary, currentSegment, data, start, end) {
                        let patterns = this.patterns;
                        if (!patterns) this.patterns = patterns = {};
                        const decodingContext = new DecodingContext(data, start, end);
                        patterns[currentSegment] = decodePatternDictionary(dictionary.mmr, dictionary.patternWidth, dictionary.patternHeight, dictionary.maxPatternIndex, dictionary.template, decodingContext);
                    }
                    onImmediateHalftoneRegion(region, referredSegments, data, start, end) {
                        const patterns = this.patterns[referredSegments[0]];
                        const regionInfo = region.info;
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeHalftoneRegion(region.mmr, patterns, region.template, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.enableSkip, region.combinationOperator, region.gridWidth, region.gridHeight, region.gridOffsetX, region.gridOffsetY, region.gridVectorX, region.gridVectorY, decodingContext);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessHalftoneRegion() {
                        this.onImmediateHalftoneRegion(...arguments);
                    }
                    onTables(currentSegment, data, start, end) {
                        let customTables = this.customTables;
                        if (!customTables) this.customTables = customTables = {};
                        customTables[currentSegment] = decodeTablesSegment(data, start, end);
                    }
                }
                class HuffmanLine {
                    constructor(lineData){
                        if (lineData.length === 2) {
                            this.isOOB = true;
                            this.rangeLow = 0;
                            this.prefixLength = lineData[0];
                            this.rangeLength = 0;
                            this.prefixCode = lineData[1];
                            this.isLowerRange = false;
                        } else {
                            this.isOOB = false;
                            this.rangeLow = lineData[0];
                            this.prefixLength = lineData[1];
                            this.rangeLength = lineData[2];
                            this.prefixCode = lineData[3];
                            this.isLowerRange = lineData[4] === "lower";
                        }
                    }
                }
                class HuffmanTreeNode {
                    constructor(line){
                        this.children = [];
                        if (line) {
                            this.isLeaf = true;
                            this.rangeLength = line.rangeLength;
                            this.rangeLow = line.rangeLow;
                            this.isLowerRange = line.isLowerRange;
                            this.isOOB = line.isOOB;
                        } else this.isLeaf = false;
                    }
                    buildTree(line, shift) {
                        const bit = line.prefixCode >> shift & 1;
                        if (shift <= 0) this.children[bit] = new HuffmanTreeNode(line);
                        else {
                            let node = this.children[bit];
                            if (!node) this.children[bit] = node = new HuffmanTreeNode(null);
                            node.buildTree(line, shift - 1);
                        }
                    }
                    decodeNode(reader) {
                        if (this.isLeaf) {
                            if (this.isOOB) return null;
                            const htOffset = reader.readBits(this.rangeLength);
                            return this.rangeLow + (this.isLowerRange ? -htOffset : htOffset);
                        }
                        const node = this.children[reader.readBit()];
                        if (!node) throw new Jbig2Error("invalid Huffman data");
                        return node.decodeNode(reader);
                    }
                }
                class HuffmanTable {
                    constructor(lines, prefixCodesDone){
                        if (!prefixCodesDone) this.assignPrefixCodes(lines);
                        this.rootNode = new HuffmanTreeNode(null);
                        for(let i = 0, ii = lines.length; i < ii; i++){
                            const line = lines[i];
                            if (line.prefixLength > 0) this.rootNode.buildTree(line, line.prefixLength - 1);
                        }
                    }
                    decode(reader) {
                        return this.rootNode.decodeNode(reader);
                    }
                    assignPrefixCodes(lines) {
                        const linesLength = lines.length;
                        let prefixLengthMax = 0;
                        for(let i = 0; i < linesLength; i++)prefixLengthMax = Math.max(prefixLengthMax, lines[i].prefixLength);
                        const histogram = new Uint32Array(prefixLengthMax + 1);
                        for(let i = 0; i < linesLength; i++)histogram[lines[i].prefixLength]++;
                        let currentLength = 1, firstCode = 0, currentCode, currentTemp, line;
                        histogram[0] = 0;
                        while(currentLength <= prefixLengthMax){
                            firstCode = firstCode + histogram[currentLength - 1] << 1;
                            currentCode = firstCode;
                            currentTemp = 0;
                            while(currentTemp < linesLength){
                                line = lines[currentTemp];
                                if (line.prefixLength === currentLength) {
                                    line.prefixCode = currentCode;
                                    currentCode++;
                                }
                                currentTemp++;
                            }
                            currentLength++;
                        }
                    }
                }
                function decodeTablesSegment(data, start, end) {
                    const flags = data[start];
                    const lowestValue = (0, _core_utils.readUint32)(data, start + 1) & 0xffffffff;
                    const highestValue = (0, _core_utils.readUint32)(data, start + 5) & 0xffffffff;
                    const reader = new Reader(data, start + 9, end);
                    const prefixSizeBits = (flags >> 1 & 7) + 1;
                    const rangeSizeBits = (flags >> 4 & 7) + 1;
                    const lines = [];
                    let prefixLength, rangeLength, currentRangeLow = lowestValue;
                    do {
                        prefixLength = reader.readBits(prefixSizeBits);
                        rangeLength = reader.readBits(rangeSizeBits);
                        lines.push(new HuffmanLine([
                            currentRangeLow,
                            prefixLength,
                            rangeLength,
                            0
                        ]));
                        currentRangeLow += 1 << rangeLength;
                    }while (currentRangeLow < highestValue);
                    prefixLength = reader.readBits(prefixSizeBits);
                    lines.push(new HuffmanLine([
                        lowestValue - 1,
                        prefixLength,
                        32,
                        0,
                        "lower"
                    ]));
                    prefixLength = reader.readBits(prefixSizeBits);
                    lines.push(new HuffmanLine([
                        highestValue,
                        prefixLength,
                        32,
                        0
                    ]));
                    if (flags & 1) {
                        prefixLength = reader.readBits(prefixSizeBits);
                        lines.push(new HuffmanLine([
                            prefixLength,
                            0
                        ]));
                    }
                    return new HuffmanTable(lines, false);
                }
                const standardTablesCache = {};
                function getStandardTable(number) {
                    let table = standardTablesCache[number];
                    if (table) return table;
                    let lines;
                    switch(number){
                        case 1:
                            lines = [
                                [
                                    0,
                                    1,
                                    4,
                                    0x0
                                ],
                                [
                                    16,
                                    2,
                                    8,
                                    0x2
                                ],
                                [
                                    272,
                                    3,
                                    16,
                                    0x6
                                ],
                                [
                                    65808,
                                    3,
                                    32,
                                    0x7
                                ]
                            ];
                            break;
                        case 2:
                            lines = [
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    75,
                                    6,
                                    32,
                                    0x3e
                                ],
                                [
                                    6,
                                    0x3f
                                ]
                            ];
                            break;
                        case 3:
                            lines = [
                                [
                                    -256,
                                    8,
                                    8,
                                    0xfe
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    -257,
                                    8,
                                    32,
                                    0xff,
                                    "lower"
                                ],
                                [
                                    75,
                                    7,
                                    32,
                                    0x7e
                                ],
                                [
                                    6,
                                    0x3e
                                ]
                            ];
                            break;
                        case 4:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    76,
                                    5,
                                    32,
                                    0x1f
                                ]
                            ];
                            break;
                        case 5:
                            lines = [
                                [
                                    -255,
                                    7,
                                    8,
                                    0x7e
                                ],
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    -256,
                                    7,
                                    32,
                                    0x7f,
                                    "lower"
                                ],
                                [
                                    76,
                                    6,
                                    32,
                                    0x3e
                                ]
                            ];
                            break;
                        case 6:
                            lines = [
                                [
                                    -2048,
                                    5,
                                    10,
                                    0x1c
                                ],
                                [
                                    -1024,
                                    4,
                                    9,
                                    0x8
                                ],
                                [
                                    -512,
                                    4,
                                    8,
                                    0x9
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    0xa
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    0x1d
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    0x1e
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    0,
                                    2,
                                    7,
                                    0x0
                                ],
                                [
                                    128,
                                    3,
                                    7,
                                    0x2
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    0x3
                                ],
                                [
                                    512,
                                    4,
                                    9,
                                    0xc
                                ],
                                [
                                    1024,
                                    4,
                                    10,
                                    0xd
                                ],
                                [
                                    -2049,
                                    6,
                                    32,
                                    0x3e,
                                    "lower"
                                ],
                                [
                                    2048,
                                    6,
                                    32,
                                    0x3f
                                ]
                            ];
                            break;
                        case 7:
                            lines = [
                                [
                                    -1024,
                                    4,
                                    9,
                                    0x8
                                ],
                                [
                                    -512,
                                    3,
                                    8,
                                    0x0
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    0x9
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    0x1a
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    0x1b
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    0xa
                                ],
                                [
                                    0,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    32,
                                    5,
                                    5,
                                    0x1c
                                ],
                                [
                                    64,
                                    5,
                                    6,
                                    0x1d
                                ],
                                [
                                    128,
                                    4,
                                    7,
                                    0xc
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    0x1
                                ],
                                [
                                    512,
                                    3,
                                    9,
                                    0x2
                                ],
                                [
                                    1024,
                                    3,
                                    10,
                                    0x3
                                ],
                                [
                                    -1025,
                                    5,
                                    32,
                                    0x1e,
                                    "lower"
                                ],
                                [
                                    2048,
                                    5,
                                    32,
                                    0x1f
                                ]
                            ];
                            break;
                        case 8:
                            lines = [
                                [
                                    -15,
                                    8,
                                    3,
                                    0xfc
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    0x1fc
                                ],
                                [
                                    -5,
                                    8,
                                    1,
                                    0xfd
                                ],
                                [
                                    -3,
                                    9,
                                    0,
                                    0x1fd
                                ],
                                [
                                    -2,
                                    7,
                                    0,
                                    0x7c
                                ],
                                [
                                    -1,
                                    4,
                                    0,
                                    0xa
                                ],
                                [
                                    0,
                                    2,
                                    1,
                                    0x0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    0x1a
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    0x3a
                                ],
                                [
                                    4,
                                    3,
                                    4,
                                    0x4
                                ],
                                [
                                    20,
                                    6,
                                    1,
                                    0x3b
                                ],
                                [
                                    22,
                                    4,
                                    4,
                                    0xb
                                ],
                                [
                                    38,
                                    4,
                                    5,
                                    0xc
                                ],
                                [
                                    70,
                                    5,
                                    6,
                                    0x1b
                                ],
                                [
                                    134,
                                    5,
                                    7,
                                    0x1c
                                ],
                                [
                                    262,
                                    6,
                                    7,
                                    0x3c
                                ],
                                [
                                    390,
                                    7,
                                    8,
                                    0x7d
                                ],
                                [
                                    646,
                                    6,
                                    10,
                                    0x3d
                                ],
                                [
                                    -16,
                                    9,
                                    32,
                                    0x1fe,
                                    "lower"
                                ],
                                [
                                    1670,
                                    9,
                                    32,
                                    0x1ff
                                ],
                                [
                                    2,
                                    0x1
                                ]
                            ];
                            break;
                        case 9:
                            lines = [
                                [
                                    -31,
                                    8,
                                    4,
                                    0xfc
                                ],
                                [
                                    -15,
                                    9,
                                    2,
                                    0x1fc
                                ],
                                [
                                    -11,
                                    8,
                                    2,
                                    0xfd
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    0x1fd
                                ],
                                [
                                    -5,
                                    7,
                                    1,
                                    0x7c
                                ],
                                [
                                    -3,
                                    4,
                                    1,
                                    0xa
                                ],
                                [
                                    -1,
                                    3,
                                    1,
                                    0x2
                                ],
                                [
                                    1,
                                    3,
                                    1,
                                    0x3
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    0x1a
                                ],
                                [
                                    5,
                                    6,
                                    1,
                                    0x3a
                                ],
                                [
                                    7,
                                    3,
                                    5,
                                    0x4
                                ],
                                [
                                    39,
                                    6,
                                    2,
                                    0x3b
                                ],
                                [
                                    43,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    75,
                                    4,
                                    6,
                                    0xc
                                ],
                                [
                                    139,
                                    5,
                                    7,
                                    0x1b
                                ],
                                [
                                    267,
                                    5,
                                    8,
                                    0x1c
                                ],
                                [
                                    523,
                                    6,
                                    8,
                                    0x3c
                                ],
                                [
                                    779,
                                    7,
                                    9,
                                    0x7d
                                ],
                                [
                                    1291,
                                    6,
                                    11,
                                    0x3d
                                ],
                                [
                                    -32,
                                    9,
                                    32,
                                    0x1fe,
                                    "lower"
                                ],
                                [
                                    3339,
                                    9,
                                    32,
                                    0x1ff
                                ],
                                [
                                    2,
                                    0x0
                                ]
                            ];
                            break;
                        case 10:
                            lines = [
                                [
                                    -21,
                                    7,
                                    4,
                                    0x7a
                                ],
                                [
                                    -5,
                                    8,
                                    0,
                                    0xfc
                                ],
                                [
                                    -4,
                                    7,
                                    0,
                                    0x7b
                                ],
                                [
                                    -3,
                                    5,
                                    0,
                                    0x18
                                ],
                                [
                                    -2,
                                    2,
                                    2,
                                    0x0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    0x19
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    0x36
                                ],
                                [
                                    4,
                                    7,
                                    0,
                                    0x7c
                                ],
                                [
                                    5,
                                    8,
                                    0,
                                    0xfd
                                ],
                                [
                                    6,
                                    2,
                                    6,
                                    0x1
                                ],
                                [
                                    70,
                                    5,
                                    5,
                                    0x1a
                                ],
                                [
                                    102,
                                    6,
                                    5,
                                    0x37
                                ],
                                [
                                    134,
                                    6,
                                    6,
                                    0x38
                                ],
                                [
                                    198,
                                    6,
                                    7,
                                    0x39
                                ],
                                [
                                    326,
                                    6,
                                    8,
                                    0x3a
                                ],
                                [
                                    582,
                                    6,
                                    9,
                                    0x3b
                                ],
                                [
                                    1094,
                                    6,
                                    10,
                                    0x3c
                                ],
                                [
                                    2118,
                                    7,
                                    11,
                                    0x7d
                                ],
                                [
                                    -22,
                                    8,
                                    32,
                                    0xfe,
                                    "lower"
                                ],
                                [
                                    4166,
                                    8,
                                    32,
                                    0xff
                                ],
                                [
                                    2,
                                    0x2
                                ]
                            ];
                            break;
                        case 11:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    1,
                                    0x2
                                ],
                                [
                                    4,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    0xd
                                ],
                                [
                                    7,
                                    5,
                                    1,
                                    0x1c
                                ],
                                [
                                    9,
                                    5,
                                    2,
                                    0x1d
                                ],
                                [
                                    13,
                                    6,
                                    2,
                                    0x3c
                                ],
                                [
                                    17,
                                    7,
                                    2,
                                    0x7a
                                ],
                                [
                                    21,
                                    7,
                                    3,
                                    0x7b
                                ],
                                [
                                    29,
                                    7,
                                    4,
                                    0x7c
                                ],
                                [
                                    45,
                                    7,
                                    5,
                                    0x7d
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    0x7e
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        case 12:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    1,
                                    0x6
                                ],
                                [
                                    5,
                                    5,
                                    0,
                                    0x1c
                                ],
                                [
                                    6,
                                    5,
                                    1,
                                    0x1d
                                ],
                                [
                                    8,
                                    6,
                                    1,
                                    0x3c
                                ],
                                [
                                    10,
                                    7,
                                    0,
                                    0x7a
                                ],
                                [
                                    11,
                                    7,
                                    1,
                                    0x7b
                                ],
                                [
                                    13,
                                    7,
                                    2,
                                    0x7c
                                ],
                                [
                                    17,
                                    7,
                                    3,
                                    0x7d
                                ],
                                [
                                    25,
                                    7,
                                    4,
                                    0x7e
                                ],
                                [
                                    41,
                                    8,
                                    5,
                                    0xfe
                                ],
                                [
                                    73,
                                    8,
                                    32,
                                    0xff
                                ]
                            ];
                            break;
                        case 13:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    3,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    4,
                                    5,
                                    0,
                                    0x1c
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    0xd
                                ],
                                [
                                    7,
                                    3,
                                    3,
                                    0x5
                                ],
                                [
                                    15,
                                    6,
                                    1,
                                    0x3a
                                ],
                                [
                                    17,
                                    6,
                                    2,
                                    0x3b
                                ],
                                [
                                    21,
                                    6,
                                    3,
                                    0x3c
                                ],
                                [
                                    29,
                                    6,
                                    4,
                                    0x3d
                                ],
                                [
                                    45,
                                    6,
                                    5,
                                    0x3e
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    0x7e
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        case 14:
                            lines = [
                                [
                                    -2,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    0x5
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x7
                                ]
                            ];
                            break;
                        case 15:
                            lines = [
                                [
                                    -24,
                                    7,
                                    4,
                                    0x7c
                                ],
                                [
                                    -8,
                                    6,
                                    2,
                                    0x3c
                                ],
                                [
                                    -4,
                                    5,
                                    1,
                                    0x1c
                                ],
                                [
                                    -2,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    0x5
                                ],
                                [
                                    2,
                                    4,
                                    0,
                                    0xd
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    0x1d
                                ],
                                [
                                    5,
                                    6,
                                    2,
                                    0x3d
                                ],
                                [
                                    9,
                                    7,
                                    4,
                                    0x7d
                                ],
                                [
                                    -25,
                                    7,
                                    32,
                                    0x7e,
                                    "lower"
                                ],
                                [
                                    25,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        default:
                            throw new Jbig2Error(`standard table B.${number} does not exist`);
                    }
                    for(let i = 0, ii = lines.length; i < ii; i++)lines[i] = new HuffmanLine(lines[i]);
                    table = new HuffmanTable(lines, true);
                    standardTablesCache[number] = table;
                    return table;
                }
                class Reader {
                    constructor(data, start, end){
                        this.data = data;
                        this.start = start;
                        this.end = end;
                        this.position = start;
                        this.shift = -1;
                        this.currentByte = 0;
                    }
                    readBit() {
                        if (this.shift < 0) {
                            if (this.position >= this.end) throw new Jbig2Error("end of data while reading bit");
                            this.currentByte = this.data[this.position++];
                            this.shift = 7;
                        }
                        const bit = this.currentByte >> this.shift & 1;
                        this.shift--;
                        return bit;
                    }
                    readBits(numBits) {
                        let result = 0, i;
                        for(i = numBits - 1; i >= 0; i--)result |= this.readBit() << i;
                        return result;
                    }
                    byteAlign() {
                        this.shift = -1;
                    }
                    next() {
                        if (this.position >= this.end) return -1;
                        return this.data[this.position++];
                    }
                }
                function getCustomHuffmanTable(index, referredTo, customTables) {
                    let currentIndex = 0;
                    for(let i = 0, ii = referredTo.length; i < ii; i++){
                        const table = customTables[referredTo[i]];
                        if (table) {
                            if (index === currentIndex) return table;
                            currentIndex++;
                        }
                    }
                    throw new Jbig2Error("can't find custom Huffman table");
                }
                function getTextRegionHuffmanTables(textRegion, referredTo, customTables, numberOfSymbols, reader) {
                    const codes = [];
                    for(let i = 0; i <= 34; i++){
                        const codeLength = reader.readBits(4);
                        codes.push(new HuffmanLine([
                            i,
                            codeLength,
                            0,
                            0
                        ]));
                    }
                    const runCodesTable = new HuffmanTable(codes, false);
                    codes.length = 0;
                    for(let i = 0; i < numberOfSymbols;){
                        const codeLength = runCodesTable.decode(reader);
                        if (codeLength >= 32) {
                            let repeatedLength, numberOfRepeats, j;
                            switch(codeLength){
                                case 32:
                                    if (i === 0) throw new Jbig2Error("no previous value in symbol ID table");
                                    numberOfRepeats = reader.readBits(2) + 3;
                                    repeatedLength = codes[i - 1].prefixLength;
                                    break;
                                case 33:
                                    numberOfRepeats = reader.readBits(3) + 3;
                                    repeatedLength = 0;
                                    break;
                                case 34:
                                    numberOfRepeats = reader.readBits(7) + 11;
                                    repeatedLength = 0;
                                    break;
                                default:
                                    throw new Jbig2Error("invalid code length in symbol ID table");
                            }
                            for(j = 0; j < numberOfRepeats; j++){
                                codes.push(new HuffmanLine([
                                    i,
                                    repeatedLength,
                                    0,
                                    0
                                ]));
                                i++;
                            }
                        } else {
                            codes.push(new HuffmanLine([
                                i,
                                codeLength,
                                0,
                                0
                            ]));
                            i++;
                        }
                    }
                    reader.byteAlign();
                    const symbolIDTable = new HuffmanTable(codes, false);
                    let customIndex = 0, tableFirstS, tableDeltaS, tableDeltaT;
                    switch(textRegion.huffmanFS){
                        case 0:
                        case 1:
                            tableFirstS = getStandardTable(textRegion.huffmanFS + 6);
                            break;
                        case 3:
                            tableFirstS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman FS selector");
                    }
                    switch(textRegion.huffmanDS){
                        case 0:
                        case 1:
                        case 2:
                            tableDeltaS = getStandardTable(textRegion.huffmanDS + 8);
                            break;
                        case 3:
                            tableDeltaS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DS selector");
                    }
                    switch(textRegion.huffmanDT){
                        case 0:
                        case 1:
                        case 2:
                            tableDeltaT = getStandardTable(textRegion.huffmanDT + 11);
                            break;
                        case 3:
                            tableDeltaT = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DT selector");
                    }
                    if (textRegion.refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                    return {
                        symbolIDTable: symbolIDTable,
                        tableFirstS: tableFirstS,
                        tableDeltaS: tableDeltaS,
                        tableDeltaT: tableDeltaT
                    };
                }
                function getSymbolDictionaryHuffmanTables(dictionary, referredTo, customTables) {
                    let customIndex = 0, tableDeltaHeight, tableDeltaWidth;
                    switch(dictionary.huffmanDHSelector){
                        case 0:
                        case 1:
                            tableDeltaHeight = getStandardTable(dictionary.huffmanDHSelector + 4);
                            break;
                        case 3:
                            tableDeltaHeight = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DH selector");
                    }
                    switch(dictionary.huffmanDWSelector){
                        case 0:
                        case 1:
                            tableDeltaWidth = getStandardTable(dictionary.huffmanDWSelector + 2);
                            break;
                        case 3:
                            tableDeltaWidth = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DW selector");
                    }
                    let tableBitmapSize, tableAggregateInstances;
                    if (dictionary.bitmapSizeSelector) {
                        tableBitmapSize = getCustomHuffmanTable(customIndex, referredTo, customTables);
                        customIndex++;
                    } else tableBitmapSize = getStandardTable(1);
                    if (dictionary.aggregationInstancesSelector) tableAggregateInstances = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    else tableAggregateInstances = getStandardTable(1);
                    return {
                        tableDeltaHeight: tableDeltaHeight,
                        tableDeltaWidth: tableDeltaWidth,
                        tableBitmapSize: tableBitmapSize,
                        tableAggregateInstances: tableAggregateInstances
                    };
                }
                function readUncompressedBitmap(reader, width, height) {
                    const bitmap = [];
                    for(let y = 0; y < height; y++){
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        for(let x = 0; x < width; x++)row[x] = reader.readBit();
                        reader.byteAlign();
                    }
                    return bitmap;
                }
                function decodeMMRBitmap(input, width, height, endOfBlock) {
                    const params = {
                        K: -1,
                        Columns: width,
                        Rows: height,
                        BlackIs1: true,
                        EndOfBlock: endOfBlock
                    };
                    const decoder = new _ccitt.CCITTFaxDecoder(input, params);
                    const bitmap = [];
                    let currentByte, eof = false;
                    for(let y = 0; y < height; y++){
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        let shift = -1;
                        for(let x = 0; x < width; x++){
                            if (shift < 0) {
                                currentByte = decoder.readNextChar();
                                if (currentByte === -1) {
                                    currentByte = 0;
                                    eof = true;
                                }
                                shift = 7;
                            }
                            row[x] = currentByte >> shift & 1;
                            shift--;
                        }
                    }
                    if (endOfBlock && !eof) {
                        const lookForEOFLimit = 5;
                        for(let i = 0; i < lookForEOFLimit; i++){
                            if (decoder.readNextChar() === -1) break;
                        }
                    }
                    return bitmap;
                }
                class Jbig2Image {
                    parseChunks(chunks) {
                        return parseJbig2Chunks(chunks);
                    }
                    parse(data) {
                        throw new Error("Not implemented: Jbig2Image.parse");
                    }
                }
                exports.Jbig2Image = Jbig2Image;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ArithmeticDecoder = void 0;
                const QeTable = [
                    {
                        qe: 0x5601,
                        nmps: 1,
                        nlps: 1,
                        switchFlag: 1
                    },
                    {
                        qe: 0x3401,
                        nmps: 2,
                        nlps: 6,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1801,
                        nmps: 3,
                        nlps: 9,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0ac1,
                        nmps: 4,
                        nlps: 12,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0521,
                        nmps: 5,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0221,
                        nmps: 38,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 7,
                        nlps: 6,
                        switchFlag: 1
                    },
                    {
                        qe: 0x5401,
                        nmps: 8,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x4801,
                        nmps: 9,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3801,
                        nmps: 10,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3001,
                        nmps: 11,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2401,
                        nmps: 12,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1c01,
                        nmps: 13,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1601,
                        nmps: 29,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 15,
                        nlps: 14,
                        switchFlag: 1
                    },
                    {
                        qe: 0x5401,
                        nmps: 16,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5101,
                        nmps: 17,
                        nlps: 15,
                        switchFlag: 0
                    },
                    {
                        qe: 0x4801,
                        nmps: 18,
                        nlps: 16,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3801,
                        nmps: 19,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3401,
                        nmps: 20,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3001,
                        nmps: 21,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2801,
                        nmps: 22,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2401,
                        nmps: 23,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2201,
                        nmps: 24,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1c01,
                        nmps: 25,
                        nlps: 22,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1801,
                        nmps: 26,
                        nlps: 23,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1601,
                        nmps: 27,
                        nlps: 24,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1401,
                        nmps: 28,
                        nlps: 25,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1201,
                        nmps: 29,
                        nlps: 26,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1101,
                        nmps: 30,
                        nlps: 27,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0ac1,
                        nmps: 31,
                        nlps: 28,
                        switchFlag: 0
                    },
                    {
                        qe: 0x09c1,
                        nmps: 32,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 0x08a1,
                        nmps: 33,
                        nlps: 30,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0521,
                        nmps: 34,
                        nlps: 31,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0441,
                        nmps: 35,
                        nlps: 32,
                        switchFlag: 0
                    },
                    {
                        qe: 0x02a1,
                        nmps: 36,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0221,
                        nmps: 37,
                        nlps: 34,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0141,
                        nmps: 38,
                        nlps: 35,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0111,
                        nmps: 39,
                        nlps: 36,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0085,
                        nmps: 40,
                        nlps: 37,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0049,
                        nmps: 41,
                        nlps: 38,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0025,
                        nmps: 42,
                        nlps: 39,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0015,
                        nmps: 43,
                        nlps: 40,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0009,
                        nmps: 44,
                        nlps: 41,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0005,
                        nmps: 45,
                        nlps: 42,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0001,
                        nmps: 45,
                        nlps: 43,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 46,
                        nlps: 46,
                        switchFlag: 0
                    }
                ];
                class ArithmeticDecoder {
                    constructor(data, start, end){
                        this.data = data;
                        this.bp = start;
                        this.dataEnd = end;
                        this.chigh = data[start];
                        this.clow = 0;
                        this.byteIn();
                        this.chigh = this.chigh << 7 & 0xffff | this.clow >> 9 & 0x7f;
                        this.clow = this.clow << 7 & 0xffff;
                        this.ct -= 7;
                        this.a = 0x8000;
                    }
                    byteIn() {
                        const data = this.data;
                        let bp = this.bp;
                        if (data[bp] === 0xff) {
                            if (data[bp + 1] > 0x8f) {
                                this.clow += 0xff00;
                                this.ct = 8;
                            } else {
                                bp++;
                                this.clow += data[bp] << 9;
                                this.ct = 7;
                                this.bp = bp;
                            }
                        } else {
                            bp++;
                            this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xff00;
                            this.ct = 8;
                            this.bp = bp;
                        }
                        if (this.clow > 0xffff) {
                            this.chigh += this.clow >> 16;
                            this.clow &= 0xffff;
                        }
                    }
                    readBit(contexts, pos) {
                        let cx_index = contexts[pos] >> 1, cx_mps = contexts[pos] & 1;
                        const qeTableIcx = QeTable[cx_index];
                        const qeIcx = qeTableIcx.qe;
                        let d;
                        let a = this.a - qeIcx;
                        if (this.chigh < qeIcx) {
                            if (a < qeIcx) {
                                a = qeIcx;
                                d = cx_mps;
                                cx_index = qeTableIcx.nmps;
                            } else {
                                a = qeIcx;
                                d = 1 ^ cx_mps;
                                if (qeTableIcx.switchFlag === 1) cx_mps = d;
                                cx_index = qeTableIcx.nlps;
                            }
                        } else {
                            this.chigh -= qeIcx;
                            if ((a & 0x8000) !== 0) {
                                this.a = a;
                                return cx_mps;
                            }
                            if (a < qeIcx) {
                                d = 1 ^ cx_mps;
                                if (qeTableIcx.switchFlag === 1) cx_mps = d;
                                cx_index = qeTableIcx.nlps;
                            } else {
                                d = cx_mps;
                                cx_index = qeTableIcx.nmps;
                            }
                        }
                        do {
                            if (this.ct === 0) this.byteIn();
                            a <<= 1;
                            this.chigh = this.chigh << 1 & 0xffff | this.clow >> 15 & 1;
                            this.clow = this.clow << 1 & 0xffff;
                            this.ct--;
                        }while ((a & 0x8000) === 0);
                        this.a = a;
                        contexts[pos] = cx_index << 1 | cx_mps;
                        return d;
                    }
                }
                exports.ArithmeticDecoder = ArithmeticDecoder;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpegStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                var _jpg = __w_pdfjs_require__(27);
                var _util = __w_pdfjs_require__(2);
                class JpegStream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        let ch;
                        while((ch = stream.getByte()) !== -1)if (ch === 0xff) {
                            stream.skip(-1);
                            break;
                        }
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jpegOptions = {
                            decodeTransform: undefined,
                            colorTransform: undefined
                        };
                        const decodeArr = this.dict.getArray("D", "Decode");
                        if ((this.forceRGBA || this.forceRGB) && Array.isArray(decodeArr)) {
                            const bitsPerComponent = this.dict.get("BPC", "BitsPerComponent") || 8;
                            const decodeArrLength = decodeArr.length;
                            const transform = new Int32Array(decodeArrLength);
                            let transformNeeded = false;
                            const maxValue = (1 << bitsPerComponent) - 1;
                            for(let i = 0; i < decodeArrLength; i += 2){
                                transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
                                transform[i + 1] = decodeArr[i] * maxValue | 0;
                                if (transform[i] !== 256 || transform[i + 1] !== 0) transformNeeded = true;
                            }
                            if (transformNeeded) jpegOptions.decodeTransform = transform;
                        }
                        if (this.params instanceof _primitives.Dict) {
                            const colorTransform = this.params.get("ColorTransform");
                            if (Number.isInteger(colorTransform)) jpegOptions.colorTransform = colorTransform;
                        }
                        const jpegImage = new _jpg.JpegImage(jpegOptions);
                        jpegImage.parse(this.bytes);
                        const data = jpegImage.getData({
                            width: this.drawWidth,
                            height: this.drawHeight,
                            forceRGBA: this.forceRGBA,
                            forceRGB: this.forceRGB,
                            isSourcePDF: true
                        });
                        this.buffer = data;
                        this.bufferLength = data.length;
                        this.eof = true;
                    }
                }
                exports.JpegStream = JpegStream;
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpegImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _image_utils = __w_pdfjs_require__(28);
                var _core_utils = __w_pdfjs_require__(3);
                class JpegError extends _util.BaseException {
                    constructor(msg){
                        super(`JPEG error: ${msg}`, "JpegError");
                    }
                }
                class DNLMarkerError extends _util.BaseException {
                    constructor(message, scanLines){
                        super(message, "DNLMarkerError");
                        this.scanLines = scanLines;
                    }
                }
                class EOIMarkerError extends _util.BaseException {
                    constructor(msg){
                        super(msg, "EOIMarkerError");
                    }
                }
                const dctZigZag = new Uint8Array([
                    0,
                    1,
                    8,
                    16,
                    9,
                    2,
                    3,
                    10,
                    17,
                    24,
                    32,
                    25,
                    18,
                    11,
                    4,
                    5,
                    12,
                    19,
                    26,
                    33,
                    40,
                    48,
                    41,
                    34,
                    27,
                    20,
                    13,
                    6,
                    7,
                    14,
                    21,
                    28,
                    35,
                    42,
                    49,
                    56,
                    57,
                    50,
                    43,
                    36,
                    29,
                    22,
                    15,
                    23,
                    30,
                    37,
                    44,
                    51,
                    58,
                    59,
                    52,
                    45,
                    38,
                    31,
                    39,
                    46,
                    53,
                    60,
                    61,
                    54,
                    47,
                    55,
                    62,
                    63
                ]);
                const dctCos1 = 4017;
                const dctSin1 = 799;
                const dctCos3 = 3406;
                const dctSin3 = 2276;
                const dctCos6 = 1567;
                const dctSin6 = 3784;
                const dctSqrt2 = 5793;
                const dctSqrt1d2 = 2896;
                function buildHuffmanTable(codeLengths, values) {
                    let k = 0, i, j, length = 16;
                    while(length > 0 && !codeLengths[length - 1])length--;
                    const code = [
                        {
                            children: [],
                            index: 0
                        }
                    ];
                    let p = code[0], q;
                    for(i = 0; i < length; i++){
                        for(j = 0; j < codeLengths[i]; j++){
                            p = code.pop();
                            p.children[p.index] = values[k];
                            while(p.index > 0)p = code.pop();
                            p.index++;
                            code.push(p);
                            while(code.length <= i){
                                code.push(q = {
                                    children: [],
                                    index: 0
                                });
                                p.children[p.index] = q.children;
                                p = q;
                            }
                            k++;
                        }
                        if (i + 1 < length) {
                            code.push(q = {
                                children: [],
                                index: 0
                            });
                            p.children[p.index] = q.children;
                            p = q;
                        }
                    }
                    return code[0].children;
                }
                function getBlockBufferOffset(component, row, col) {
                    return 64 * ((component.blocksPerLine + 1) * row + col);
                }
                function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive, parseDNLMarker = false) {
                    const mcusPerLine = frame.mcusPerLine;
                    const progressive = frame.progressive;
                    const startOffset = offset;
                    let bitsData = 0, bitsCount = 0;
                    function readBit() {
                        if (bitsCount > 0) {
                            bitsCount--;
                            return bitsData >> bitsCount & 1;
                        }
                        bitsData = data[offset++];
                        if (bitsData === 0xff) {
                            const nextByte = data[offset++];
                            if (nextByte) {
                                if (nextByte === 0xdc && parseDNLMarker) {
                                    offset += 2;
                                    const scanLines = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    if (scanLines > 0 && scanLines !== frame.scanLines) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", scanLines);
                                } else if (nextByte === 0xd9) {
                                    if (parseDNLMarker) {
                                        const maybeScanLines = blockRow * (frame.precision === 8 ? 8 : 0);
                                        if (maybeScanLines > 0 && Math.round(frame.scanLines / maybeScanLines) >= 5) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", maybeScanLines);
                                    }
                                    throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
                                }
                                throw new JpegError(`unexpected marker ${(bitsData << 8 | nextByte).toString(16)}`);
                            }
                        }
                        bitsCount = 7;
                        return bitsData >>> 7;
                    }
                    function decodeHuffman(tree) {
                        let node = tree;
                        while(true){
                            node = node[readBit()];
                            switch(typeof node){
                                case "number":
                                    return node;
                                case "object":
                                    continue;
                            }
                            throw new JpegError("invalid huffman sequence");
                        }
                    }
                    function receive(length) {
                        let n = 0;
                        while(length > 0){
                            n = n << 1 | readBit();
                            length--;
                        }
                        return n;
                    }
                    function receiveAndExtend(length) {
                        if (length === 1) return readBit() === 1 ? 1 : -1;
                        const n = receive(length);
                        if (n >= 1 << length - 1) return n;
                        return n + (-1 << length) + 1;
                    }
                    function decodeBaseline(component, blockOffset) {
                        const t = decodeHuffman(component.huffmanTableDC);
                        const diff = t === 0 ? 0 : receiveAndExtend(t);
                        component.blockData[blockOffset] = component.pred += diff;
                        let k = 1;
                        while(k < 64){
                            const rs = decodeHuffman(component.huffmanTableAC);
                            const s = rs & 15, r = rs >> 4;
                            if (s === 0) {
                                if (r < 15) break;
                                k += 16;
                                continue;
                            }
                            k += r;
                            const z = dctZigZag[k];
                            component.blockData[blockOffset + z] = receiveAndExtend(s);
                            k++;
                        }
                    }
                    function decodeDCFirst(component, blockOffset) {
                        const t = decodeHuffman(component.huffmanTableDC);
                        const diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
                        component.blockData[blockOffset] = component.pred += diff;
                    }
                    function decodeDCSuccessive(component, blockOffset) {
                        component.blockData[blockOffset] |= readBit() << successive;
                    }
                    let eobrun = 0;
                    function decodeACFirst(component, blockOffset) {
                        if (eobrun > 0) {
                            eobrun--;
                            return;
                        }
                        let k = spectralStart;
                        const e = spectralEnd;
                        while(k <= e){
                            const rs = decodeHuffman(component.huffmanTableAC);
                            const s = rs & 15, r = rs >> 4;
                            if (s === 0) {
                                if (r < 15) {
                                    eobrun = receive(r) + (1 << r) - 1;
                                    break;
                                }
                                k += 16;
                                continue;
                            }
                            k += r;
                            const z = dctZigZag[k];
                            component.blockData[blockOffset + z] = receiveAndExtend(s) * (1 << successive);
                            k++;
                        }
                    }
                    let successiveACState = 0, successiveACNextValue;
                    function decodeACSuccessive(component, blockOffset) {
                        let k = spectralStart;
                        const e = spectralEnd;
                        let r = 0;
                        let s;
                        let rs;
                        while(k <= e){
                            const offsetZ = blockOffset + dctZigZag[k];
                            const sign = component.blockData[offsetZ] < 0 ? -1 : 1;
                            switch(successiveACState){
                                case 0:
                                    rs = decodeHuffman(component.huffmanTableAC);
                                    s = rs & 15;
                                    r = rs >> 4;
                                    if (s === 0) {
                                        if (r < 15) {
                                            eobrun = receive(r) + (1 << r);
                                            successiveACState = 4;
                                        } else {
                                            r = 16;
                                            successiveACState = 1;
                                        }
                                    } else {
                                        if (s !== 1) throw new JpegError("invalid ACn encoding");
                                        successiveACNextValue = receiveAndExtend(s);
                                        successiveACState = r ? 2 : 3;
                                    }
                                    continue;
                                case 1:
                                case 2:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    else {
                                        r--;
                                        if (r === 0) successiveACState = successiveACState === 2 ? 3 : 0;
                                    }
                                    break;
                                case 3:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    else {
                                        component.blockData[offsetZ] = successiveACNextValue << successive;
                                        successiveACState = 0;
                                    }
                                    break;
                                case 4:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    break;
                            }
                            k++;
                        }
                        if (successiveACState === 4) {
                            eobrun--;
                            if (eobrun === 0) successiveACState = 0;
                        }
                    }
                    let blockRow = 0;
                    function decodeMcu(component, decode, mcu, row, col) {
                        const mcuRow = mcu / mcusPerLine | 0;
                        const mcuCol = mcu % mcusPerLine;
                        blockRow = mcuRow * component.v + row;
                        const blockCol = mcuCol * component.h + col;
                        const blockOffset = getBlockBufferOffset(component, blockRow, blockCol);
                        decode(component, blockOffset);
                    }
                    function decodeBlock(component, decode, mcu) {
                        blockRow = mcu / component.blocksPerLine | 0;
                        const blockCol = mcu % component.blocksPerLine;
                        const blockOffset = getBlockBufferOffset(component, blockRow, blockCol);
                        decode(component, blockOffset);
                    }
                    const componentsLength = components.length;
                    let component, i, j, k, n;
                    let decodeFn;
                    if (progressive) {
                        if (spectralStart === 0) decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
                        else decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
                    } else decodeFn = decodeBaseline;
                    let mcu = 0, fileMarker;
                    const mcuExpected = componentsLength === 1 ? components[0].blocksPerLine * components[0].blocksPerColumn : mcusPerLine * frame.mcusPerColumn;
                    let h, v;
                    while(mcu <= mcuExpected){
                        const mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
                        if (mcuToRead > 0) {
                            for(i = 0; i < componentsLength; i++)components[i].pred = 0;
                            eobrun = 0;
                            if (componentsLength === 1) {
                                component = components[0];
                                for(n = 0; n < mcuToRead; n++){
                                    decodeBlock(component, decodeFn, mcu);
                                    mcu++;
                                }
                            } else for(n = 0; n < mcuToRead; n++){
                                for(i = 0; i < componentsLength; i++){
                                    component = components[i];
                                    h = component.h;
                                    v = component.v;
                                    for(j = 0; j < v; j++)for(k = 0; k < h; k++)decodeMcu(component, decodeFn, mcu, j, k);
                                }
                                mcu++;
                            }
                        }
                        bitsCount = 0;
                        fileMarker = findNextFileMarker(data, offset);
                        if (!fileMarker) break;
                        if (fileMarker.invalid) {
                            const partialMsg = mcuToRead > 0 ? "unexpected" : "excessive";
                            (0, _util.warn)(`decodeScan - ${partialMsg} MCU data, current marker is: ${fileMarker.invalid}`);
                            offset = fileMarker.offset;
                        }
                        if (fileMarker.marker >= 0xffd0 && fileMarker.marker <= 0xffd7) offset += 2;
                        else break;
                    }
                    return offset - startOffset;
                }
                function quantizeAndInverse(component, blockBufferOffset, p) {
                    const qt = component.quantizationTable, blockData = component.blockData;
                    let v0, v1, v2, v3, v4, v5, v6, v7;
                    let p0, p1, p2, p3, p4, p5, p6, p7;
                    let t;
                    if (!qt) throw new JpegError("missing required Quantization Table.");
                    for(let row = 0; row < 64; row += 8){
                        p0 = blockData[blockBufferOffset + row];
                        p1 = blockData[blockBufferOffset + row + 1];
                        p2 = blockData[blockBufferOffset + row + 2];
                        p3 = blockData[blockBufferOffset + row + 3];
                        p4 = blockData[blockBufferOffset + row + 4];
                        p5 = blockData[blockBufferOffset + row + 5];
                        p6 = blockData[blockBufferOffset + row + 6];
                        p7 = blockData[blockBufferOffset + row + 7];
                        p0 *= qt[row];
                        if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                            t = dctSqrt2 * p0 + 512 >> 10;
                            p[row] = t;
                            p[row + 1] = t;
                            p[row + 2] = t;
                            p[row + 3] = t;
                            p[row + 4] = t;
                            p[row + 5] = t;
                            p[row + 6] = t;
                            p[row + 7] = t;
                            continue;
                        }
                        p1 *= qt[row + 1];
                        p2 *= qt[row + 2];
                        p3 *= qt[row + 3];
                        p4 *= qt[row + 4];
                        p5 *= qt[row + 5];
                        p6 *= qt[row + 6];
                        p7 *= qt[row + 7];
                        v0 = dctSqrt2 * p0 + 128 >> 8;
                        v1 = dctSqrt2 * p4 + 128 >> 8;
                        v2 = p2;
                        v3 = p6;
                        v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
                        v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
                        v5 = p3 << 4;
                        v6 = p5 << 4;
                        v0 = v0 + v1 + 1 >> 1;
                        v1 = v0 - v1;
                        t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
                        v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
                        v3 = t;
                        v4 = v4 + v6 + 1 >> 1;
                        v6 = v4 - v6;
                        v7 = v7 + v5 + 1 >> 1;
                        v5 = v7 - v5;
                        v0 = v0 + v3 + 1 >> 1;
                        v3 = v0 - v3;
                        v1 = v1 + v2 + 1 >> 1;
                        v2 = v1 - v2;
                        t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                        v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                        v7 = t;
                        t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                        v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                        v6 = t;
                        p[row] = v0 + v7;
                        p[row + 7] = v0 - v7;
                        p[row + 1] = v1 + v6;
                        p[row + 6] = v1 - v6;
                        p[row + 2] = v2 + v5;
                        p[row + 5] = v2 - v5;
                        p[row + 3] = v3 + v4;
                        p[row + 4] = v3 - v4;
                    }
                    for(let col = 0; col < 8; ++col){
                        p0 = p[col];
                        p1 = p[col + 8];
                        p2 = p[col + 16];
                        p3 = p[col + 24];
                        p4 = p[col + 32];
                        p5 = p[col + 40];
                        p6 = p[col + 48];
                        p7 = p[col + 56];
                        if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                            t = dctSqrt2 * p0 + 8192 >> 14;
                            if (t < -2040) t = 0;
                            else if (t >= 2024) t = 255;
                            else t = t + 2056 >> 4;
                            blockData[blockBufferOffset + col] = t;
                            blockData[blockBufferOffset + col + 8] = t;
                            blockData[blockBufferOffset + col + 16] = t;
                            blockData[blockBufferOffset + col + 24] = t;
                            blockData[blockBufferOffset + col + 32] = t;
                            blockData[blockBufferOffset + col + 40] = t;
                            blockData[blockBufferOffset + col + 48] = t;
                            blockData[blockBufferOffset + col + 56] = t;
                            continue;
                        }
                        v0 = dctSqrt2 * p0 + 2048 >> 12;
                        v1 = dctSqrt2 * p4 + 2048 >> 12;
                        v2 = p2;
                        v3 = p6;
                        v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
                        v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
                        v5 = p3;
                        v6 = p5;
                        v0 = (v0 + v1 + 1 >> 1) + 4112;
                        v1 = v0 - v1;
                        t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
                        v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
                        v3 = t;
                        v4 = v4 + v6 + 1 >> 1;
                        v6 = v4 - v6;
                        v7 = v7 + v5 + 1 >> 1;
                        v5 = v7 - v5;
                        v0 = v0 + v3 + 1 >> 1;
                        v3 = v0 - v3;
                        v1 = v1 + v2 + 1 >> 1;
                        v2 = v1 - v2;
                        t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                        v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                        v7 = t;
                        t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                        v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                        v6 = t;
                        p0 = v0 + v7;
                        p7 = v0 - v7;
                        p1 = v1 + v6;
                        p6 = v1 - v6;
                        p2 = v2 + v5;
                        p5 = v2 - v5;
                        p3 = v3 + v4;
                        p4 = v3 - v4;
                        if (p0 < 16) p0 = 0;
                        else if (p0 >= 4080) p0 = 255;
                        else p0 >>= 4;
                        if (p1 < 16) p1 = 0;
                        else if (p1 >= 4080) p1 = 255;
                        else p1 >>= 4;
                        if (p2 < 16) p2 = 0;
                        else if (p2 >= 4080) p2 = 255;
                        else p2 >>= 4;
                        if (p3 < 16) p3 = 0;
                        else if (p3 >= 4080) p3 = 255;
                        else p3 >>= 4;
                        if (p4 < 16) p4 = 0;
                        else if (p4 >= 4080) p4 = 255;
                        else p4 >>= 4;
                        if (p5 < 16) p5 = 0;
                        else if (p5 >= 4080) p5 = 255;
                        else p5 >>= 4;
                        if (p6 < 16) p6 = 0;
                        else if (p6 >= 4080) p6 = 255;
                        else p6 >>= 4;
                        if (p7 < 16) p7 = 0;
                        else if (p7 >= 4080) p7 = 255;
                        else p7 >>= 4;
                        blockData[blockBufferOffset + col] = p0;
                        blockData[blockBufferOffset + col + 8] = p1;
                        blockData[blockBufferOffset + col + 16] = p2;
                        blockData[blockBufferOffset + col + 24] = p3;
                        blockData[blockBufferOffset + col + 32] = p4;
                        blockData[blockBufferOffset + col + 40] = p5;
                        blockData[blockBufferOffset + col + 48] = p6;
                        blockData[blockBufferOffset + col + 56] = p7;
                    }
                }
                function buildComponentData(frame, component) {
                    const blocksPerLine = component.blocksPerLine;
                    const blocksPerColumn = component.blocksPerColumn;
                    const computationBuffer = new Int16Array(64);
                    for(let blockRow = 0; blockRow < blocksPerColumn; blockRow++)for(let blockCol = 0; blockCol < blocksPerLine; blockCol++){
                        const offset = getBlockBufferOffset(component, blockRow, blockCol);
                        quantizeAndInverse(component, offset, computationBuffer);
                    }
                    return component.blockData;
                }
                function findNextFileMarker(data, currentPos, startPos = currentPos) {
                    const maxPos = data.length - 1;
                    let newPos = startPos < currentPos ? startPos : currentPos;
                    if (currentPos >= maxPos) return null;
                    const currentMarker = (0, _core_utils.readUint16)(data, currentPos);
                    if (currentMarker >= 0xffc0 && currentMarker <= 0xfffe) return {
                        invalid: null,
                        marker: currentMarker,
                        offset: currentPos
                    };
                    let newMarker = (0, _core_utils.readUint16)(data, newPos);
                    while(!(newMarker >= 0xffc0 && newMarker <= 0xfffe)){
                        if (++newPos >= maxPos) return null;
                        newMarker = (0, _core_utils.readUint16)(data, newPos);
                    }
                    return {
                        invalid: currentMarker.toString(16),
                        marker: newMarker,
                        offset: newPos
                    };
                }
                class JpegImage {
                    constructor({ decodeTransform: decodeTransform = null, colorTransform: colorTransform = -1 } = {}){
                        this._decodeTransform = decodeTransform;
                        this._colorTransform = colorTransform;
                    }
                    parse(data, { dnlScanLines: dnlScanLines = null } = {}) {
                        function readDataBlock() {
                            const length = (0, _core_utils.readUint16)(data, offset);
                            offset += 2;
                            let endOffset = offset + length - 2;
                            const fileMarker = findNextFileMarker(data, endOffset, offset);
                            if (fileMarker?.invalid) {
                                (0, _util.warn)("readDataBlock - incorrect length, current marker is: " + fileMarker.invalid);
                                endOffset = fileMarker.offset;
                            }
                            const array = data.subarray(offset, endOffset);
                            offset += array.length;
                            return array;
                        }
                        function prepareComponents(frame) {
                            const mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
                            const mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
                            for (const component of frame.components){
                                const blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
                                const blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
                                const blocksPerLineForMcu = mcusPerLine * component.h;
                                const blocksPerColumnForMcu = mcusPerColumn * component.v;
                                const blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
                                component.blockData = new Int16Array(blocksBufferSize);
                                component.blocksPerLine = blocksPerLine;
                                component.blocksPerColumn = blocksPerColumn;
                            }
                            frame.mcusPerLine = mcusPerLine;
                            frame.mcusPerColumn = mcusPerColumn;
                        }
                        let offset = 0;
                        let jfif = null;
                        let adobe = null;
                        let frame, resetInterval;
                        let numSOSMarkers = 0;
                        const quantizationTables = [];
                        const huffmanTablesAC = [], huffmanTablesDC = [];
                        let fileMarker = (0, _core_utils.readUint16)(data, offset);
                        offset += 2;
                        if (fileMarker !== 0xffd8) throw new JpegError("SOI not found");
                        fileMarker = (0, _core_utils.readUint16)(data, offset);
                        offset += 2;
                        markerLoop: while(fileMarker !== 0xffd9){
                            let i, j, l;
                            switch(fileMarker){
                                case 0xffe0:
                                case 0xffe1:
                                case 0xffe2:
                                case 0xffe3:
                                case 0xffe4:
                                case 0xffe5:
                                case 0xffe6:
                                case 0xffe7:
                                case 0xffe8:
                                case 0xffe9:
                                case 0xffea:
                                case 0xffeb:
                                case 0xffec:
                                case 0xffed:
                                case 0xffee:
                                case 0xffef:
                                case 0xfffe:
                                    const appData = readDataBlock();
                                    if (fileMarker === 0xffe0) {
                                        if (appData[0] === 0x4a && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) jfif = {
                                            version: {
                                                major: appData[5],
                                                minor: appData[6]
                                            },
                                            densityUnits: appData[7],
                                            xDensity: appData[8] << 8 | appData[9],
                                            yDensity: appData[10] << 8 | appData[11],
                                            thumbWidth: appData[12],
                                            thumbHeight: appData[13],
                                            thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                                        };
                                    }
                                    if (fileMarker === 0xffee) {
                                        if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6f && appData[3] === 0x62 && appData[4] === 0x65) adobe = {
                                            version: appData[5] << 8 | appData[6],
                                            flags0: appData[7] << 8 | appData[8],
                                            flags1: appData[9] << 8 | appData[10],
                                            transformCode: appData[11]
                                        };
                                    }
                                    break;
                                case 0xffdb:
                                    const quantizationTablesLength = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    const quantizationTablesEnd = quantizationTablesLength + offset - 2;
                                    let z;
                                    while(offset < quantizationTablesEnd){
                                        const quantizationTableSpec = data[offset++];
                                        const tableData = new Uint16Array(64);
                                        if (quantizationTableSpec >> 4 === 0) for(j = 0; j < 64; j++){
                                            z = dctZigZag[j];
                                            tableData[z] = data[offset++];
                                        }
                                        else if (quantizationTableSpec >> 4 === 1) for(j = 0; j < 64; j++){
                                            z = dctZigZag[j];
                                            tableData[z] = (0, _core_utils.readUint16)(data, offset);
                                            offset += 2;
                                        }
                                        else throw new JpegError("DQT - invalid table spec");
                                        quantizationTables[quantizationTableSpec & 15] = tableData;
                                    }
                                    break;
                                case 0xffc0:
                                case 0xffc1:
                                case 0xffc2:
                                    if (frame) throw new JpegError("Only single frame JPEGs supported");
                                    offset += 2;
                                    frame = {};
                                    frame.extended = fileMarker === 0xffc1;
                                    frame.progressive = fileMarker === 0xffc2;
                                    frame.precision = data[offset++];
                                    const sofScanLines = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    frame.scanLines = dnlScanLines || sofScanLines;
                                    frame.samplesPerLine = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    frame.components = [];
                                    frame.componentIds = {};
                                    const componentsCount = data[offset++];
                                    let maxH = 0, maxV = 0;
                                    for(i = 0; i < componentsCount; i++){
                                        const componentId = data[offset];
                                        const h = data[offset + 1] >> 4;
                                        const v = data[offset + 1] & 15;
                                        if (maxH < h) maxH = h;
                                        if (maxV < v) maxV = v;
                                        const qId = data[offset + 2];
                                        l = frame.components.push({
                                            h: h,
                                            v: v,
                                            quantizationId: qId,
                                            quantizationTable: null
                                        });
                                        frame.componentIds[componentId] = l - 1;
                                        offset += 3;
                                    }
                                    frame.maxH = maxH;
                                    frame.maxV = maxV;
                                    prepareComponents(frame);
                                    break;
                                case 0xffc4:
                                    const huffmanLength = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    for(i = 2; i < huffmanLength;){
                                        const huffmanTableSpec = data[offset++];
                                        const codeLengths = new Uint8Array(16);
                                        let codeLengthSum = 0;
                                        for(j = 0; j < 16; j++, offset++)codeLengthSum += codeLengths[j] = data[offset];
                                        const huffmanValues = new Uint8Array(codeLengthSum);
                                        for(j = 0; j < codeLengthSum; j++, offset++)huffmanValues[j] = data[offset];
                                        i += 17 + codeLengthSum;
                                        (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                                    }
                                    break;
                                case 0xffdd:
                                    offset += 2;
                                    resetInterval = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    break;
                                case 0xffda:
                                    const parseDNLMarker = ++numSOSMarkers === 1 && !dnlScanLines;
                                    offset += 2;
                                    const selectorsCount = data[offset++], components = [];
                                    for(i = 0; i < selectorsCount; i++){
                                        const index = data[offset++];
                                        const componentIndex = frame.componentIds[index];
                                        const component = frame.components[componentIndex];
                                        component.index = index;
                                        const tableSpec = data[offset++];
                                        component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
                                        component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
                                        components.push(component);
                                    }
                                    const spectralStart = data[offset++], spectralEnd = data[offset++], successiveApproximation = data[offset++];
                                    try {
                                        const processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15, parseDNLMarker);
                                        offset += processed;
                                    } catch (ex) {
                                        if (ex instanceof DNLMarkerError) {
                                            (0, _util.warn)(`${ex.message} -- attempting to re-parse the JPEG image.`);
                                            return this.parse(data, {
                                                dnlScanLines: ex.scanLines
                                            });
                                        } else if (ex instanceof EOIMarkerError) {
                                            (0, _util.warn)(`${ex.message} -- ignoring the rest of the image data.`);
                                            break markerLoop;
                                        }
                                        throw ex;
                                    }
                                    break;
                                case 0xffdc:
                                    offset += 4;
                                    break;
                                case 0xffff:
                                    if (data[offset] !== 0xff) offset--;
                                    break;
                                default:
                                    const nextFileMarker = findNextFileMarker(data, offset - 2, offset - 3);
                                    if (nextFileMarker?.invalid) {
                                        (0, _util.warn)("JpegImage.parse - unexpected data, current marker is: " + nextFileMarker.invalid);
                                        offset = nextFileMarker.offset;
                                        break;
                                    }
                                    if (!nextFileMarker || offset >= data.length - 1) {
                                        (0, _util.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                                        break markerLoop;
                                    }
                                    throw new JpegError("JpegImage.parse - unknown marker: " + fileMarker.toString(16));
                            }
                            fileMarker = (0, _core_utils.readUint16)(data, offset);
                            offset += 2;
                        }
                        this.width = frame.samplesPerLine;
                        this.height = frame.scanLines;
                        this.jfif = jfif;
                        this.adobe = adobe;
                        this.components = [];
                        for (const component of frame.components){
                            const quantizationTable = quantizationTables[component.quantizationId];
                            if (quantizationTable) component.quantizationTable = quantizationTable;
                            this.components.push({
                                index: component.index,
                                output: buildComponentData(frame, component),
                                scaleX: component.h / frame.maxH,
                                scaleY: component.v / frame.maxV,
                                blocksPerLine: component.blocksPerLine,
                                blocksPerColumn: component.blocksPerColumn
                            });
                        }
                        this.numComponents = this.components.length;
                        return undefined;
                    }
                    _getLinearizedBlockData(width, height, isSourcePDF = false) {
                        const scaleX = this.width / width, scaleY = this.height / height;
                        let component, componentScaleX, componentScaleY, blocksPerScanline;
                        let x, y, i, j, k;
                        let index;
                        let offset = 0;
                        let output;
                        const numComponents = this.components.length;
                        const dataLength = width * height * numComponents;
                        const data = new Uint8ClampedArray(dataLength);
                        const xScaleBlockOffset = new Uint32Array(width);
                        const mask3LSB = 0xfffffff8;
                        let lastComponentScaleX;
                        for(i = 0; i < numComponents; i++){
                            component = this.components[i];
                            componentScaleX = component.scaleX * scaleX;
                            componentScaleY = component.scaleY * scaleY;
                            offset = i;
                            output = component.output;
                            blocksPerScanline = component.blocksPerLine + 1 << 3;
                            if (componentScaleX !== lastComponentScaleX) {
                                for(x = 0; x < width; x++){
                                    j = 0 | x * componentScaleX;
                                    xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
                                }
                                lastComponentScaleX = componentScaleX;
                            }
                            for(y = 0; y < height; y++){
                                j = 0 | y * componentScaleY;
                                index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
                                for(x = 0; x < width; x++){
                                    data[offset] = output[index + xScaleBlockOffset[x]];
                                    offset += numComponents;
                                }
                            }
                        }
                        let transform = this._decodeTransform;
                        if (!isSourcePDF && numComponents === 4 && !transform) transform = new Int32Array([
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255
                        ]);
                        if (transform) {
                            for(i = 0; i < dataLength;)for(j = 0, k = 0; j < numComponents; j++, i++, k += 2)data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
                        }
                        return data;
                    }
                    get _isColorConversionNeeded() {
                        if (this.adobe) return !!this.adobe.transformCode;
                        if (this.numComponents === 3) {
                            if (this._colorTransform === 0) return false;
                            else if (this.components[0].index === 0x52 && this.components[1].index === 0x47 && this.components[2].index === 0x42) return false;
                            return true;
                        }
                        if (this._colorTransform === 1) return true;
                        return false;
                    }
                    _convertYccToRgb(data) {
                        let Y, Cb, Cr;
                        for(let i = 0, length = data.length; i < length; i += 3){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            data[i] = Y - 179.456 + 1.402 * Cr;
                            data[i + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                            data[i + 2] = Y - 226.816 + 1.772 * Cb;
                        }
                        return data;
                    }
                    _convertYccToRgba(data, out) {
                        for(let i = 0, j = 0, length = data.length; i < length; i += 3, j += 4){
                            const Y = data[i];
                            const Cb = data[i + 1];
                            const Cr = data[i + 2];
                            out[j] = Y - 179.456 + 1.402 * Cr;
                            out[j + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                            out[j + 2] = Y - 226.816 + 1.772 * Cb;
                            out[j + 3] = 255;
                        }
                        return out;
                    }
                    _convertYcckToRgb(data) {
                        let Y, Cb, Cr, k;
                        let offset = 0;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            k = data[i + 3];
                            data[offset++] = -122.67195406894 + Cb * (-0.0000660635669420364 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
                            data[offset++] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
                            data[offset++] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-0.0000153496057440975 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
                        }
                        return data.subarray(0, offset);
                    }
                    _convertYcckToRgba(data) {
                        for(let i = 0, length = data.length; i < length; i += 4){
                            const Y = data[i];
                            const Cb = data[i + 1];
                            const Cr = data[i + 2];
                            const k = data[i + 3];
                            data[i] = -122.67195406894 + Cb * (-0.0000660635669420364 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
                            data[i + 1] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
                            data[i + 2] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-0.0000153496057440975 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
                            data[i + 3] = 255;
                        }
                        return data;
                    }
                    _convertYcckToCmyk(data) {
                        let Y, Cb, Cr;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            data[i] = 434.456 - Y - 1.402 * Cr;
                            data[i + 1] = 119.541 - Y + 0.344 * Cb + 0.714 * Cr;
                            data[i + 2] = 481.816 - Y - 1.772 * Cb;
                        }
                        return data;
                    }
                    _convertCmykToRgb(data) {
                        let c, m, y, k;
                        let offset = 0;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            c = data[i];
                            m = data[i + 1];
                            y = data[i + 2];
                            k = data[i + 3];
                            data[offset++] = 255 + c * (-0.00006747147073602441 * c + 0.0008379262121013727 * m + 0.0002894718188643294 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (0.000026374107616089405 * m - 0.00008626949158638572 * y - 0.0002748769067499491 * k - 0.02155688794978967) + y * (-0.00003878099212869363 * y - 0.0003267808279485286 * k + 0.0686742238595345) - k * (0.0003361971776183937 * k + 0.7430659151342254);
                            data[offset++] = 255 + c * (0.00013596372813588848 * c + 0.000924537132573585 * m + 0.00010567359618683593 * y + 0.0004791864687436512 * k - 0.3109689587515875) + m * (-0.00023545346108370344 * m + 0.0002702845253534714 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (0.00006834815998235662 * y + 0.00015168452363460973 * k - 0.09751927774728933) - k * (0.0003189131175883281 * k + 0.7364883807733168);
                            data[offset++] = 255 + c * (0.000013598650411385307 * c + 0.00012423956175490851 * m + 0.0004751985097583589 * y - 0.0000036729317476630422 * k - 0.05562186980264034) + m * (0.00016141380598724676 * m + 0.0009692239130725186 * y + 0.0007782692450036253 * k - 0.44015232367526463) + y * (5.068882914068769e-7 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (0.0003435319965105553 * k + 0.7063770186160144);
                        }
                        return data.subarray(0, offset);
                    }
                    _convertCmykToRgba(data) {
                        for(let i = 0, length = data.length; i < length; i += 4){
                            const c = data[i];
                            const m = data[i + 1];
                            const y = data[i + 2];
                            const k = data[i + 3];
                            data[i] = 255 + c * (-0.00006747147073602441 * c + 0.0008379262121013727 * m + 0.0002894718188643294 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (0.000026374107616089405 * m - 0.00008626949158638572 * y - 0.0002748769067499491 * k - 0.02155688794978967) + y * (-0.00003878099212869363 * y - 0.0003267808279485286 * k + 0.0686742238595345) - k * (0.0003361971776183937 * k + 0.7430659151342254);
                            data[i + 1] = 255 + c * (0.00013596372813588848 * c + 0.000924537132573585 * m + 0.00010567359618683593 * y + 0.0004791864687436512 * k - 0.3109689587515875) + m * (-0.00023545346108370344 * m + 0.0002702845253534714 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (0.00006834815998235662 * y + 0.00015168452363460973 * k - 0.09751927774728933) - k * (0.0003189131175883281 * k + 0.7364883807733168);
                            data[i + 2] = 255 + c * (0.000013598650411385307 * c + 0.00012423956175490851 * m + 0.0004751985097583589 * y - 0.0000036729317476630422 * k - 0.05562186980264034) + m * (0.00016141380598724676 * m + 0.0009692239130725186 * y + 0.0007782692450036253 * k - 0.44015232367526463) + y * (5.068882914068769e-7 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (0.0003435319965105553 * k + 0.7063770186160144);
                            data[i + 3] = 255;
                        }
                        return data;
                    }
                    getData({ width: width, height: height, forceRGBA: forceRGBA = false, forceRGB: forceRGB = false, isSourcePDF: isSourcePDF = false }) {
                        if (this.numComponents > 4) throw new JpegError("Unsupported color mode");
                        const data = this._getLinearizedBlockData(width, height, isSourcePDF);
                        if (this.numComponents === 1 && (forceRGBA || forceRGB)) {
                            const len = data.length * (forceRGBA ? 4 : 3);
                            const rgbaData = new Uint8ClampedArray(len);
                            let offset = 0;
                            if (forceRGBA) (0, _image_utils.grayToRGBA)(data, new Uint32Array(rgbaData.buffer));
                            else for (const grayColor of data){
                                rgbaData[offset++] = grayColor;
                                rgbaData[offset++] = grayColor;
                                rgbaData[offset++] = grayColor;
                            }
                            return rgbaData;
                        } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                            if (forceRGBA) {
                                const rgbaData = new Uint8ClampedArray(data.length / 3 * 4);
                                return this._convertYccToRgba(data, rgbaData);
                            }
                            return this._convertYccToRgb(data);
                        } else if (this.numComponents === 4) {
                            if (this._isColorConversionNeeded) {
                                if (forceRGBA) return this._convertYcckToRgba(data);
                                if (forceRGB) return this._convertYcckToRgb(data);
                                return this._convertYcckToCmyk(data);
                            } else if (forceRGBA) return this._convertCmykToRgba(data);
                            else if (forceRGB) return this._convertCmykToRgb(data);
                        }
                        return data;
                    }
                }
                exports.JpegImage = JpegImage;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(2);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpxStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _jpx = __w_pdfjs_require__(30);
                var _util = __w_pdfjs_require__(2);
                class JpxStream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jpxImage = new _jpx.JpxImage();
                        jpxImage.parse(this.bytes);
                        const width = jpxImage.width;
                        const height = jpxImage.height;
                        const componentsCount = jpxImage.componentsCount;
                        const tileCount = jpxImage.tiles.length;
                        if (tileCount === 1) this.buffer = jpxImage.tiles[0].items;
                        else {
                            const data = new Uint8ClampedArray(width * height * componentsCount);
                            for(let k = 0; k < tileCount; k++){
                                const tileComponents = jpxImage.tiles[k];
                                const tileWidth = tileComponents.width;
                                const tileHeight = tileComponents.height;
                                const tileLeft = tileComponents.left;
                                const tileTop = tileComponents.top;
                                const src = tileComponents.items;
                                let srcPosition = 0;
                                let dataPosition = (width * tileTop + tileLeft) * componentsCount;
                                const imgRowSize = width * componentsCount;
                                const tileRowSize = tileWidth * componentsCount;
                                for(let j = 0; j < tileHeight; j++){
                                    const rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
                                    data.set(rowBytes, dataPosition);
                                    srcPosition += tileRowSize;
                                    dataPosition += imgRowSize;
                                }
                            }
                            this.buffer = data;
                        }
                        this.bufferLength = this.buffer.length;
                        this.eof = true;
                    }
                }
                exports.JpxStream = JpxStream;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpxImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _arithmetic_decoder = __w_pdfjs_require__(25);
                class JpxError extends _util.BaseException {
                    constructor(msg){
                        super(`JPX error: ${msg}`, "JpxError");
                    }
                }
                const SubbandsGainLog2 = {
                    LL: 0,
                    LH: 1,
                    HL: 1,
                    HH: 2
                };
                class JpxImage {
                    constructor(){
                        this.failOnCorruptedImage = false;
                    }
                    parse(data) {
                        const head = (0, _core_utils.readUint16)(data, 0);
                        if (head === 0xff4f) {
                            this.parseCodestream(data, 0, data.length);
                            return;
                        }
                        const length = data.length;
                        let position = 0;
                        while(position < length){
                            let headerSize = 8;
                            let lbox = (0, _core_utils.readUint32)(data, position);
                            const tbox = (0, _core_utils.readUint32)(data, position + 4);
                            position += headerSize;
                            if (lbox === 1) {
                                lbox = (0, _core_utils.readUint32)(data, position) * 4294967296 + (0, _core_utils.readUint32)(data, position + 4);
                                position += 8;
                                headerSize += 8;
                            }
                            if (lbox === 0) lbox = length - position + headerSize;
                            if (lbox < headerSize) throw new JpxError("Invalid box field size");
                            const dataLength = lbox - headerSize;
                            let jumpDataLength = true;
                            switch(tbox){
                                case 0x6a703268:
                                    jumpDataLength = false;
                                    break;
                                case 0x636f6c72:
                                    const method = data[position];
                                    if (method === 1) {
                                        const colorspace = (0, _core_utils.readUint32)(data, position + 3);
                                        switch(colorspace){
                                            case 16:
                                            case 17:
                                            case 18:
                                                break;
                                            default:
                                                (0, _util.warn)("Unknown colorspace " + colorspace);
                                                break;
                                        }
                                    } else if (method === 2) (0, _util.info)("ICC profile not supported");
                                    break;
                                case 0x6a703263:
                                    this.parseCodestream(data, position, position + dataLength);
                                    break;
                                case 0x6a502020:
                                    if ((0, _core_utils.readUint32)(data, position) !== 0x0d0a870a) (0, _util.warn)("Invalid JP2 signature");
                                    break;
                                case 0x6a501a1a:
                                case 0x66747970:
                                case 0x72726571:
                                case 0x72657320:
                                case 0x69686472:
                                    break;
                                default:
                                    const headerType = String.fromCharCode(tbox >> 24 & 0xff, tbox >> 16 & 0xff, tbox >> 8 & 0xff, tbox & 0xff);
                                    (0, _util.warn)(`Unsupported header type ${tbox} (${headerType}).`);
                                    break;
                            }
                            if (jumpDataLength) position += dataLength;
                        }
                    }
                    parseImageProperties(stream) {
                        let newByte = stream.getByte();
                        while(newByte >= 0){
                            const oldByte = newByte;
                            newByte = stream.getByte();
                            const code = oldByte << 8 | newByte;
                            if (code === 0xff51) {
                                stream.skip(4);
                                const Xsiz = stream.getInt32() >>> 0;
                                const Ysiz = stream.getInt32() >>> 0;
                                const XOsiz = stream.getInt32() >>> 0;
                                const YOsiz = stream.getInt32() >>> 0;
                                stream.skip(16);
                                const Csiz = stream.getUint16();
                                this.width = Xsiz - XOsiz;
                                this.height = Ysiz - YOsiz;
                                this.componentsCount = Csiz;
                                this.bitsPerComponent = 8;
                                return;
                            }
                        }
                        throw new JpxError("No size marker found in JPX stream");
                    }
                    parseCodestream(data, start, end) {
                        const context = {};
                        let doNotRecover = false;
                        try {
                            let position = start;
                            while(position + 1 < end){
                                const code = (0, _core_utils.readUint16)(data, position);
                                position += 2;
                                let length = 0, j, sqcd, spqcds, spqcdSize, scalarExpounded, tile;
                                switch(code){
                                    case 0xff4f:
                                        context.mainHeader = true;
                                        break;
                                    case 0xffd9:
                                        break;
                                    case 0xff51:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const siz = {};
                                        siz.Xsiz = (0, _core_utils.readUint32)(data, position + 4);
                                        siz.Ysiz = (0, _core_utils.readUint32)(data, position + 8);
                                        siz.XOsiz = (0, _core_utils.readUint32)(data, position + 12);
                                        siz.YOsiz = (0, _core_utils.readUint32)(data, position + 16);
                                        siz.XTsiz = (0, _core_utils.readUint32)(data, position + 20);
                                        siz.YTsiz = (0, _core_utils.readUint32)(data, position + 24);
                                        siz.XTOsiz = (0, _core_utils.readUint32)(data, position + 28);
                                        siz.YTOsiz = (0, _core_utils.readUint32)(data, position + 32);
                                        const componentsCount = (0, _core_utils.readUint16)(data, position + 36);
                                        siz.Csiz = componentsCount;
                                        const components = [];
                                        j = position + 38;
                                        for(let i = 0; i < componentsCount; i++){
                                            const component = {
                                                precision: (data[j] & 0x7f) + 1,
                                                isSigned: !!(data[j] & 0x80),
                                                XRsiz: data[j + 1],
                                                YRsiz: data[j + 2]
                                            };
                                            j += 3;
                                            calculateComponentDimensions(component, siz);
                                            components.push(component);
                                        }
                                        context.SIZ = siz;
                                        context.components = components;
                                        calculateTileGrids(context, components);
                                        context.QCC = [];
                                        context.COC = [];
                                        break;
                                    case 0xff5c:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const qcd = {};
                                        j = position + 2;
                                        sqcd = data[j++];
                                        switch(sqcd & 0x1f){
                                            case 0:
                                                spqcdSize = 8;
                                                scalarExpounded = true;
                                                break;
                                            case 1:
                                                spqcdSize = 16;
                                                scalarExpounded = false;
                                                break;
                                            case 2:
                                                spqcdSize = 16;
                                                scalarExpounded = true;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + sqcd);
                                        }
                                        qcd.noQuantization = spqcdSize === 8;
                                        qcd.scalarExpounded = scalarExpounded;
                                        qcd.guardBits = sqcd >> 5;
                                        spqcds = [];
                                        while(j < length + position){
                                            const spqcd = {};
                                            if (spqcdSize === 8) {
                                                spqcd.epsilon = data[j++] >> 3;
                                                spqcd.mu = 0;
                                            } else {
                                                spqcd.epsilon = data[j] >> 3;
                                                spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                                                j += 2;
                                            }
                                            spqcds.push(spqcd);
                                        }
                                        qcd.SPqcds = spqcds;
                                        if (context.mainHeader) context.QCD = qcd;
                                        else {
                                            context.currentTile.QCD = qcd;
                                            context.currentTile.QCC = [];
                                        }
                                        break;
                                    case 0xff5d:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const qcc = {};
                                        j = position + 2;
                                        let cqcc;
                                        if (context.SIZ.Csiz < 257) cqcc = data[j++];
                                        else {
                                            cqcc = (0, _core_utils.readUint16)(data, j);
                                            j += 2;
                                        }
                                        sqcd = data[j++];
                                        switch(sqcd & 0x1f){
                                            case 0:
                                                spqcdSize = 8;
                                                scalarExpounded = true;
                                                break;
                                            case 1:
                                                spqcdSize = 16;
                                                scalarExpounded = false;
                                                break;
                                            case 2:
                                                spqcdSize = 16;
                                                scalarExpounded = true;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + sqcd);
                                        }
                                        qcc.noQuantization = spqcdSize === 8;
                                        qcc.scalarExpounded = scalarExpounded;
                                        qcc.guardBits = sqcd >> 5;
                                        spqcds = [];
                                        while(j < length + position){
                                            const spqcd = {};
                                            if (spqcdSize === 8) {
                                                spqcd.epsilon = data[j++] >> 3;
                                                spqcd.mu = 0;
                                            } else {
                                                spqcd.epsilon = data[j] >> 3;
                                                spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                                                j += 2;
                                            }
                                            spqcds.push(spqcd);
                                        }
                                        qcc.SPqcds = spqcds;
                                        if (context.mainHeader) context.QCC[cqcc] = qcc;
                                        else context.currentTile.QCC[cqcc] = qcc;
                                        break;
                                    case 0xff52:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const cod = {};
                                        j = position + 2;
                                        const scod = data[j++];
                                        cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
                                        cod.sopMarkerUsed = !!(scod & 2);
                                        cod.ephMarkerUsed = !!(scod & 4);
                                        cod.progressionOrder = data[j++];
                                        cod.layersCount = (0, _core_utils.readUint16)(data, j);
                                        j += 2;
                                        cod.multipleComponentTransform = data[j++];
                                        cod.decompositionLevelsCount = data[j++];
                                        cod.xcb = (data[j++] & 0xf) + 2;
                                        cod.ycb = (data[j++] & 0xf) + 2;
                                        const blockStyle = data[j++];
                                        cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
                                        cod.resetContextProbabilities = !!(blockStyle & 2);
                                        cod.terminationOnEachCodingPass = !!(blockStyle & 4);
                                        cod.verticallyStripe = !!(blockStyle & 8);
                                        cod.predictableTermination = !!(blockStyle & 16);
                                        cod.segmentationSymbolUsed = !!(blockStyle & 32);
                                        cod.reversibleTransformation = data[j++];
                                        if (cod.entropyCoderWithCustomPrecincts) {
                                            const precinctsSizes = [];
                                            while(j < length + position){
                                                const precinctsSize = data[j++];
                                                precinctsSizes.push({
                                                    PPx: precinctsSize & 0xf,
                                                    PPy: precinctsSize >> 4
                                                });
                                            }
                                            cod.precinctsSizes = precinctsSizes;
                                        }
                                        const unsupported = [];
                                        if (cod.selectiveArithmeticCodingBypass) unsupported.push("selectiveArithmeticCodingBypass");
                                        if (cod.terminationOnEachCodingPass) unsupported.push("terminationOnEachCodingPass");
                                        if (cod.verticallyStripe) unsupported.push("verticallyStripe");
                                        if (cod.predictableTermination) unsupported.push("predictableTermination");
                                        if (unsupported.length > 0) {
                                            doNotRecover = true;
                                            (0, _util.warn)(`JPX: Unsupported COD options (${unsupported.join(", ")}).`);
                                        }
                                        if (context.mainHeader) context.COD = cod;
                                        else {
                                            context.currentTile.COD = cod;
                                            context.currentTile.COC = [];
                                        }
                                        break;
                                    case 0xff90:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        tile = {};
                                        tile.index = (0, _core_utils.readUint16)(data, position + 2);
                                        tile.length = (0, _core_utils.readUint32)(data, position + 4);
                                        tile.dataEnd = tile.length + position - 2;
                                        tile.partIndex = data[position + 8];
                                        tile.partsCount = data[position + 9];
                                        context.mainHeader = false;
                                        if (tile.partIndex === 0) {
                                            tile.COD = context.COD;
                                            tile.COC = context.COC.slice(0);
                                            tile.QCD = context.QCD;
                                            tile.QCC = context.QCC.slice(0);
                                        }
                                        context.currentTile = tile;
                                        break;
                                    case 0xff93:
                                        tile = context.currentTile;
                                        if (tile.partIndex === 0) {
                                            initializeTile(context, tile.index);
                                            buildPackets(context);
                                        }
                                        length = tile.dataEnd - position;
                                        parseTilePackets(context, data, position, length);
                                        break;
                                    case 0xff53:
                                        (0, _util.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                                    case 0xff55:
                                    case 0xff57:
                                    case 0xff58:
                                    case 0xff64:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        break;
                                    default:
                                        throw new Error("Unknown codestream code: " + code.toString(16));
                                }
                                position += length;
                            }
                        } catch (e) {
                            if (doNotRecover || this.failOnCorruptedImage) throw new JpxError(e.message);
                            else (0, _util.warn)(`JPX: Trying to recover from: "${e.message}".`);
                        }
                        this.tiles = transformComponents(context);
                        this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
                        this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
                        this.componentsCount = context.SIZ.Csiz;
                    }
                }
                exports.JpxImage = JpxImage;
                function calculateComponentDimensions(component, siz) {
                    component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
                    component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
                    component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
                    component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
                    component.width = component.x1 - component.x0;
                    component.height = component.y1 - component.y0;
                }
                function calculateTileGrids(context, components) {
                    const siz = context.SIZ;
                    const tiles = [];
                    let tile;
                    const numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
                    const numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
                    for(let q = 0; q < numYtiles; q++)for(let p = 0; p < numXtiles; p++){
                        tile = {};
                        tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
                        tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
                        tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
                        tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
                        tile.width = tile.tx1 - tile.tx0;
                        tile.height = tile.ty1 - tile.ty0;
                        tile.components = [];
                        tiles.push(tile);
                    }
                    context.tiles = tiles;
                    const componentsCount = siz.Csiz;
                    for(let i = 0, ii = componentsCount; i < ii; i++){
                        const component = components[i];
                        for(let j = 0, jj = tiles.length; j < jj; j++){
                            const tileComponent = {};
                            tile = tiles[j];
                            tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
                            tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
                            tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
                            tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
                            tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
                            tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
                            tile.components[i] = tileComponent;
                        }
                    }
                }
                function getBlocksDimensions(context, component, r) {
                    const codOrCoc = component.codingStyleParameters;
                    const result = {};
                    if (!codOrCoc.entropyCoderWithCustomPrecincts) {
                        result.PPx = 15;
                        result.PPy = 15;
                    } else {
                        result.PPx = codOrCoc.precinctsSizes[r].PPx;
                        result.PPy = codOrCoc.precinctsSizes[r].PPy;
                    }
                    result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
                    result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
                    return result;
                }
                function buildPrecincts(context, resolution, dimensions) {
                    const precinctWidth = 1 << dimensions.PPx;
                    const precinctHeight = 1 << dimensions.PPy;
                    const isZeroRes = resolution.resLevel === 0;
                    const precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
                    const precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
                    const numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
                    const numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
                    const numprecincts = numprecinctswide * numprecinctshigh;
                    resolution.precinctParameters = {
                        precinctWidth: precinctWidth,
                        precinctHeight: precinctHeight,
                        numprecinctswide: numprecinctswide,
                        numprecinctshigh: numprecinctshigh,
                        numprecincts: numprecincts,
                        precinctWidthInSubband: precinctWidthInSubband,
                        precinctHeightInSubband: precinctHeightInSubband
                    };
                }
                function buildCodeblocks(context, subband, dimensions) {
                    const xcb_ = dimensions.xcb_;
                    const ycb_ = dimensions.ycb_;
                    const codeblockWidth = 1 << xcb_;
                    const codeblockHeight = 1 << ycb_;
                    const cbx0 = subband.tbx0 >> xcb_;
                    const cby0 = subband.tby0 >> ycb_;
                    const cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
                    const cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
                    const precinctParameters = subband.resolution.precinctParameters;
                    const codeblocks = [];
                    const precincts = [];
                    let i, j, codeblock, precinctNumber;
                    for(j = cby0; j < cby1; j++)for(i = cbx0; i < cbx1; i++){
                        codeblock = {
                            cbx: i,
                            cby: j,
                            tbx0: codeblockWidth * i,
                            tby0: codeblockHeight * j,
                            tbx1: codeblockWidth * (i + 1),
                            tby1: codeblockHeight * (j + 1)
                        };
                        codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
                        codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
                        codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
                        codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
                        const pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
                        const pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
                        precinctNumber = pi + pj * precinctParameters.numprecinctswide;
                        codeblock.precinctNumber = precinctNumber;
                        codeblock.subbandType = subband.type;
                        codeblock.Lblock = 3;
                        if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) continue;
                        codeblocks.push(codeblock);
                        let precinct = precincts[precinctNumber];
                        if (precinct !== undefined) {
                            if (i < precinct.cbxMin) precinct.cbxMin = i;
                            else if (i > precinct.cbxMax) precinct.cbxMax = i;
                            if (j < precinct.cbyMin) precinct.cbxMin = j;
                            else if (j > precinct.cbyMax) precinct.cbyMax = j;
                        } else precincts[precinctNumber] = precinct = {
                            cbxMin: i,
                            cbyMin: j,
                            cbxMax: i,
                            cbyMax: j
                        };
                        codeblock.precinct = precinct;
                    }
                    subband.codeblockParameters = {
                        codeblockWidth: xcb_,
                        codeblockHeight: ycb_,
                        numcodeblockwide: cbx1 - cbx0 + 1,
                        numcodeblockhigh: cby1 - cby0 + 1
                    };
                    subband.codeblocks = codeblocks;
                    subband.precincts = precincts;
                }
                function createPacket(resolution, precinctNumber, layerNumber) {
                    const precinctCodeblocks = [];
                    const subbands = resolution.subbands;
                    for(let i = 0, ii = subbands.length; i < ii; i++){
                        const subband = subbands[i];
                        const codeblocks = subband.codeblocks;
                        for(let j = 0, jj = codeblocks.length; j < jj; j++){
                            const codeblock = codeblocks[j];
                            if (codeblock.precinctNumber !== precinctNumber) continue;
                            precinctCodeblocks.push(codeblock);
                        }
                    }
                    return {
                        layerNumber: layerNumber,
                        codeblocks: precinctCodeblocks
                    };
                }
                function LayerResolutionComponentPositionIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let maxDecompositionLevelsCount = 0;
                    for(let q = 0; q < componentsCount; q++)maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                    let l = 0, r = 0, i = 0, k = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; l < layersCount; l++){
                            for(; r <= maxDecompositionLevelsCount; r++){
                                for(; i < componentsCount; i++){
                                    const component = tile.components[i];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    for(; k < numprecincts;){
                                        const packet = createPacket(resolution, k, l);
                                        k++;
                                        return packet;
                                    }
                                    k = 0;
                                }
                                i = 0;
                            }
                            r = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionLayerComponentPositionIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let maxDecompositionLevelsCount = 0;
                    for(let q = 0; q < componentsCount; q++)maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                    let r = 0, l = 0, i = 0, k = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; r <= maxDecompositionLevelsCount; r++){
                            for(; l < layersCount; l++){
                                for(; i < componentsCount; i++){
                                    const component = tile.components[i];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    for(; k < numprecincts;){
                                        const packet = createPacket(resolution, k, l);
                                        k++;
                                        return packet;
                                    }
                                    k = 0;
                                }
                                i = 0;
                            }
                            l = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionPositionComponentLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let l, r, c, p;
                    let maxDecompositionLevelsCount = 0;
                    for(c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
                    }
                    const maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
                    for(r = 0; r <= maxDecompositionLevelsCount; ++r){
                        let maxNumPrecincts = 0;
                        for(c = 0; c < componentsCount; ++c){
                            const resolutions = tile.components[c].resolutions;
                            if (r < resolutions.length) maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
                        }
                        maxNumPrecinctsInLevel[r] = maxNumPrecincts;
                    }
                    l = 0;
                    r = 0;
                    c = 0;
                    p = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; r <= maxDecompositionLevelsCount; r++){
                            for(; p < maxNumPrecinctsInLevel[r]; p++){
                                for(; c < componentsCount; c++){
                                    const component = tile.components[c];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    if (p >= numprecincts) continue;
                                    for(; l < layersCount;){
                                        const packet = createPacket(resolution, p, l);
                                        l++;
                                        return packet;
                                    }
                                    l = 0;
                                }
                                c = 0;
                            }
                            p = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function PositionComponentResolutionLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    const precinctsSizes = getPrecinctSizesInImageScale(tile);
                    const precinctsIterationSizes = precinctsSizes;
                    let l = 0, r = 0, c = 0, px = 0, py = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; py < precinctsIterationSizes.maxNumHigh; py++){
                            for(; px < precinctsIterationSizes.maxNumWide; px++){
                                for(; c < componentsCount; c++){
                                    const component = tile.components[c];
                                    const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                                    for(; r <= decompositionLevelsCount; r++){
                                        const resolution = component.resolutions[r];
                                        const sizeInImageScale = precinctsSizes.components[c].resolutions[r];
                                        const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                                        if (k === null) continue;
                                        for(; l < layersCount;){
                                            const packet = createPacket(resolution, k, l);
                                            l++;
                                            return packet;
                                        }
                                        l = 0;
                                    }
                                    r = 0;
                                }
                                c = 0;
                            }
                            px = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ComponentPositionResolutionLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    const precinctsSizes = getPrecinctSizesInImageScale(tile);
                    let l = 0, r = 0, c = 0, px = 0, py = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; c < componentsCount; ++c){
                            const component = tile.components[c];
                            const precinctsIterationSizes = precinctsSizes.components[c];
                            const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                            for(; py < precinctsIterationSizes.maxNumHigh; py++){
                                for(; px < precinctsIterationSizes.maxNumWide; px++){
                                    for(; r <= decompositionLevelsCount; r++){
                                        const resolution = component.resolutions[r];
                                        const sizeInImageScale = precinctsIterationSizes.resolutions[r];
                                        const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                                        if (k === null) continue;
                                        for(; l < layersCount;){
                                            const packet = createPacket(resolution, k, l);
                                            l++;
                                            return packet;
                                        }
                                        l = 0;
                                    }
                                    r = 0;
                                }
                                px = 0;
                            }
                            py = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
                    const posX = pxIndex * precinctIterationSizes.minWidth;
                    const posY = pyIndex * precinctIterationSizes.minHeight;
                    if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) return null;
                    const startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
                    return posX / sizeInImageScale.height + startPrecinctRowIndex;
                }
                function getPrecinctSizesInImageScale(tile) {
                    const componentsCount = tile.components.length;
                    let minWidth = Number.MAX_VALUE;
                    let minHeight = Number.MAX_VALUE;
                    let maxNumWide = 0;
                    let maxNumHigh = 0;
                    const sizePerComponent = new Array(componentsCount);
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        const sizePerResolution = new Array(decompositionLevelsCount + 1);
                        let minWidthCurrentComponent = Number.MAX_VALUE;
                        let minHeightCurrentComponent = Number.MAX_VALUE;
                        let maxNumWideCurrentComponent = 0;
                        let maxNumHighCurrentComponent = 0;
                        let scale = 1;
                        for(let r = decompositionLevelsCount; r >= 0; --r){
                            const resolution = component.resolutions[r];
                            const widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
                            const heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
                            minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
                            minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
                            maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
                            maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
                            sizePerResolution[r] = {
                                width: widthCurrentResolution,
                                height: heightCurrentResolution
                            };
                            scale <<= 1;
                        }
                        minWidth = Math.min(minWidth, minWidthCurrentComponent);
                        minHeight = Math.min(minHeight, minHeightCurrentComponent);
                        maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
                        maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
                        sizePerComponent[c] = {
                            resolutions: sizePerResolution,
                            minWidth: minWidthCurrentComponent,
                            minHeight: minHeightCurrentComponent,
                            maxNumWide: maxNumWideCurrentComponent,
                            maxNumHigh: maxNumHighCurrentComponent
                        };
                    }
                    return {
                        components: sizePerComponent,
                        minWidth: minWidth,
                        minHeight: minHeight,
                        maxNumWide: maxNumWide,
                        maxNumHigh: maxNumHigh
                    };
                }
                function buildPackets(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const componentsCount = siz.Csiz;
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        const resolutions = [];
                        const subbands = [];
                        for(let r = 0; r <= decompositionLevelsCount; r++){
                            const blocksDimensions = getBlocksDimensions(context, component, r);
                            const resolution = {};
                            const scale = 1 << decompositionLevelsCount - r;
                            resolution.trx0 = Math.ceil(component.tcx0 / scale);
                            resolution.try0 = Math.ceil(component.tcy0 / scale);
                            resolution.trx1 = Math.ceil(component.tcx1 / scale);
                            resolution.try1 = Math.ceil(component.tcy1 / scale);
                            resolution.resLevel = r;
                            buildPrecincts(context, resolution, blocksDimensions);
                            resolutions.push(resolution);
                            let subband;
                            if (r === 0) {
                                subband = {};
                                subband.type = "LL";
                                subband.tbx0 = Math.ceil(component.tcx0 / scale);
                                subband.tby0 = Math.ceil(component.tcy0 / scale);
                                subband.tbx1 = Math.ceil(component.tcx1 / scale);
                                subband.tby1 = Math.ceil(component.tcy1 / scale);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolution.subbands = [
                                    subband
                                ];
                            } else {
                                const bscale = 1 << decompositionLevelsCount - r + 1;
                                const resolutionSubbands = [];
                                subband = {};
                                subband.type = "HL";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                subband = {};
                                subband.type = "LH";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                subband = {};
                                subband.type = "HH";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                resolution.subbands = resolutionSubbands;
                            }
                        }
                        component.resolutions = resolutions;
                        component.subbands = subbands;
                    }
                    const progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
                    switch(progressionOrder){
                        case 0:
                            tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
                            break;
                        case 1:
                            tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
                            break;
                        case 2:
                            tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
                            break;
                        case 3:
                            tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
                            break;
                        case 4:
                            tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
                            break;
                        default:
                            throw new JpxError(`Unsupported progression order ${progressionOrder}`);
                    }
                }
                function parseTilePackets(context, data, offset, dataLength) {
                    let position = 0;
                    let buffer, bufferSize = 0, skipNextBit = false;
                    function readBits(count) {
                        while(bufferSize < count){
                            const b = data[offset + position];
                            position++;
                            if (skipNextBit) {
                                buffer = buffer << 7 | b;
                                bufferSize += 7;
                                skipNextBit = false;
                            } else {
                                buffer = buffer << 8 | b;
                                bufferSize += 8;
                            }
                            if (b === 0xff) skipNextBit = true;
                        }
                        bufferSize -= count;
                        return buffer >>> bufferSize & (1 << count) - 1;
                    }
                    function skipMarkerIfEqual(value) {
                        if (data[offset + position - 1] === 0xff && data[offset + position] === value) {
                            skipBytes(1);
                            return true;
                        } else if (data[offset + position] === 0xff && data[offset + position + 1] === value) {
                            skipBytes(2);
                            return true;
                        }
                        return false;
                    }
                    function skipBytes(count) {
                        position += count;
                    }
                    function alignToByte() {
                        bufferSize = 0;
                        if (skipNextBit) {
                            position++;
                            skipNextBit = false;
                        }
                    }
                    function readCodingpasses() {
                        if (readBits(1) === 0) return 1;
                        if (readBits(1) === 0) return 2;
                        let value = readBits(2);
                        if (value < 3) return value + 3;
                        value = readBits(5);
                        if (value < 31) return value + 6;
                        value = readBits(7);
                        return value + 37;
                    }
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const sopMarkerUsed = context.COD.sopMarkerUsed;
                    const ephMarkerUsed = context.COD.ephMarkerUsed;
                    const packetsIterator = tile.packetsIterator;
                    while(position < dataLength){
                        alignToByte();
                        if (sopMarkerUsed && skipMarkerIfEqual(0x91)) skipBytes(4);
                        const packet = packetsIterator.nextPacket();
                        if (!readBits(1)) continue;
                        const layerNumber = packet.layerNumber, queue = [];
                        let codeblock;
                        for(let i = 0, ii = packet.codeblocks.length; i < ii; i++){
                            codeblock = packet.codeblocks[i];
                            let precinct = codeblock.precinct;
                            const codeblockColumn = codeblock.cbx - precinct.cbxMin;
                            const codeblockRow = codeblock.cby - precinct.cbyMin;
                            let codeblockIncluded = false;
                            let firstTimeInclusion = false;
                            let valueReady, zeroBitPlanesTree;
                            if (codeblock.included !== undefined) codeblockIncluded = !!readBits(1);
                            else {
                                precinct = codeblock.precinct;
                                let inclusionTree;
                                if (precinct.inclusionTree !== undefined) inclusionTree = precinct.inclusionTree;
                                else {
                                    const width = precinct.cbxMax - precinct.cbxMin + 1;
                                    const height = precinct.cbyMax - precinct.cbyMin + 1;
                                    inclusionTree = new InclusionTree(width, height, layerNumber);
                                    zeroBitPlanesTree = new TagTree(width, height);
                                    precinct.inclusionTree = inclusionTree;
                                    precinct.zeroBitPlanesTree = zeroBitPlanesTree;
                                    for(let l = 0; l < layerNumber; l++){
                                        if (readBits(1) !== 0) throw new JpxError("Invalid tag tree");
                                    }
                                }
                                if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
                                    while(true)if (readBits(1)) {
                                        valueReady = !inclusionTree.nextLevel();
                                        if (valueReady) {
                                            codeblock.included = true;
                                            codeblockIncluded = firstTimeInclusion = true;
                                            break;
                                        }
                                    } else {
                                        inclusionTree.incrementValue(layerNumber);
                                        break;
                                    }
                                }
                            }
                            if (!codeblockIncluded) continue;
                            if (firstTimeInclusion) {
                                zeroBitPlanesTree = precinct.zeroBitPlanesTree;
                                zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
                                while(true)if (readBits(1)) {
                                    valueReady = !zeroBitPlanesTree.nextLevel();
                                    if (valueReady) break;
                                } else zeroBitPlanesTree.incrementValue();
                                codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
                            }
                            const codingpasses = readCodingpasses();
                            while(readBits(1))codeblock.Lblock++;
                            const codingpassesLog2 = (0, _core_utils.log2)(codingpasses);
                            const bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
                            const codedDataLength = readBits(bits);
                            queue.push({
                                codeblock: codeblock,
                                codingpasses: codingpasses,
                                dataLength: codedDataLength
                            });
                        }
                        alignToByte();
                        if (ephMarkerUsed) skipMarkerIfEqual(0x92);
                        while(queue.length > 0){
                            const packetItem = queue.shift();
                            codeblock = packetItem.codeblock;
                            if (codeblock.data === undefined) codeblock.data = [];
                            codeblock.data.push({
                                data: data,
                                start: offset + position,
                                end: offset + position + packetItem.dataLength,
                                codingpasses: packetItem.codingpasses
                            });
                            position += packetItem.dataLength;
                        }
                    }
                    return position;
                }
                function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed, resetContextProbabilities) {
                    const x0 = subband.tbx0;
                    const y0 = subband.tby0;
                    const width = subband.tbx1 - subband.tbx0;
                    const codeblocks = subband.codeblocks;
                    const right = subband.type.charAt(0) === "H" ? 1 : 0;
                    const bottom = subband.type.charAt(1) === "H" ? levelWidth : 0;
                    for(let i = 0, ii = codeblocks.length; i < ii; ++i){
                        const codeblock = codeblocks[i];
                        const blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
                        const blockHeight = codeblock.tby1_ - codeblock.tby0_;
                        if (blockWidth === 0 || blockHeight === 0) continue;
                        if (codeblock.data === undefined) continue;
                        const bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
                        let currentCodingpassType = 2;
                        const data = codeblock.data;
                        let totalLength = 0, codingpasses = 0;
                        let j, jj, dataItem;
                        for(j = 0, jj = data.length; j < jj; j++){
                            dataItem = data[j];
                            totalLength += dataItem.end - dataItem.start;
                            codingpasses += dataItem.codingpasses;
                        }
                        const encodedData = new Uint8Array(totalLength);
                        let position = 0;
                        for(j = 0, jj = data.length; j < jj; j++){
                            dataItem = data[j];
                            const chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
                            encodedData.set(chunk, position);
                            position += chunk.length;
                        }
                        const decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
                        bitModel.setDecoder(decoder);
                        for(j = 0; j < codingpasses; j++){
                            switch(currentCodingpassType){
                                case 0:
                                    bitModel.runSignificancePropagationPass();
                                    break;
                                case 1:
                                    bitModel.runMagnitudeRefinementPass();
                                    break;
                                case 2:
                                    bitModel.runCleanupPass();
                                    if (segmentationSymbolUsed) bitModel.checkSegmentationSymbol();
                                    break;
                            }
                            if (resetContextProbabilities) bitModel.reset();
                            currentCodingpassType = (currentCodingpassType + 1) % 3;
                        }
                        let offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
                        const sign = bitModel.coefficentsSign;
                        const magnitude = bitModel.coefficentsMagnitude;
                        const bitsDecoded = bitModel.bitsDecoded;
                        const magnitudeCorrection = reversible ? 0 : 0.5;
                        let k, n, nb;
                        position = 0;
                        const interleave = subband.type !== "LL";
                        for(j = 0; j < blockHeight; j++){
                            const row = offset / width | 0;
                            const levelOffset = 2 * row * (levelWidth - width) + right + bottom;
                            for(k = 0; k < blockWidth; k++){
                                n = magnitude[position];
                                if (n !== 0) {
                                    n = (n + magnitudeCorrection) * delta;
                                    if (sign[position] !== 0) n = -n;
                                    nb = bitsDecoded[position];
                                    const pos = interleave ? levelOffset + (offset << 1) : offset;
                                    coefficients[pos] = reversible && nb >= mb ? n : n * (1 << mb - nb);
                                }
                                offset++;
                                position++;
                            }
                            offset += width - blockWidth;
                        }
                    }
                }
                function transformTile(context, tile, c) {
                    const component = tile.components[c];
                    const codingStyleParameters = component.codingStyleParameters;
                    const quantizationParameters = component.quantizationParameters;
                    const decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
                    const spqcds = quantizationParameters.SPqcds;
                    const scalarExpounded = quantizationParameters.scalarExpounded;
                    const guardBits = quantizationParameters.guardBits;
                    const segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
                    const resetContextProbabilities = codingStyleParameters.resetContextProbabilities;
                    const precision = context.components[c].precision;
                    const reversible = codingStyleParameters.reversibleTransformation;
                    const transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
                    const subbandCoefficients = [];
                    let b = 0;
                    for(let i = 0; i <= decompositionLevelsCount; i++){
                        const resolution = component.resolutions[i];
                        const width = resolution.trx1 - resolution.trx0;
                        const height = resolution.try1 - resolution.try0;
                        const coefficients = new Float32Array(width * height);
                        for(let j = 0, jj = resolution.subbands.length; j < jj; j++){
                            let mu, epsilon;
                            if (!scalarExpounded) {
                                mu = spqcds[0].mu;
                                epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
                            } else {
                                mu = spqcds[b].mu;
                                epsilon = spqcds[b].epsilon;
                                b++;
                            }
                            const subband = resolution.subbands[j];
                            const gainLog2 = SubbandsGainLog2[subband.type];
                            const delta = reversible ? 1 : 2 ** (precision + gainLog2 - epsilon) * (1 + mu / 2048);
                            const mb = guardBits + epsilon - 1;
                            copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed, resetContextProbabilities);
                        }
                        subbandCoefficients.push({
                            width: width,
                            height: height,
                            items: coefficients
                        });
                    }
                    const result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
                    return {
                        left: component.tcx0,
                        top: component.tcy0,
                        width: result.width,
                        height: result.height,
                        items: result.items
                    };
                }
                function transformComponents(context) {
                    const siz = context.SIZ;
                    const components = context.components;
                    const componentsCount = siz.Csiz;
                    const resultImages = [];
                    for(let i = 0, ii = context.tiles.length; i < ii; i++){
                        const tile = context.tiles[i];
                        const transformedTiles = [];
                        for(let c = 0; c < componentsCount; c++)transformedTiles[c] = transformTile(context, tile, c);
                        const tile0 = transformedTiles[0];
                        const out = new Uint8ClampedArray(tile0.items.length * componentsCount);
                        const result = {
                            left: tile0.left,
                            top: tile0.top,
                            width: tile0.width,
                            height: tile0.height,
                            items: out
                        };
                        let shift, offset;
                        let pos = 0, j, jj, y0, y1, y2;
                        if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
                            const fourComponents = componentsCount === 4;
                            const y0items = transformedTiles[0].items;
                            const y1items = transformedTiles[1].items;
                            const y2items = transformedTiles[2].items;
                            const y3items = fourComponents ? transformedTiles[3].items : null;
                            shift = components[0].precision - 8;
                            offset = (128 << shift) + 0.5;
                            const component0 = tile.components[0];
                            const alpha01 = componentsCount - 3;
                            jj = y0items.length;
                            if (!component0.codingStyleParameters.reversibleTransformation) for(j = 0; j < jj; j++, pos += alpha01){
                                y0 = y0items[j] + offset;
                                y1 = y1items[j];
                                y2 = y2items[j];
                                out[pos++] = y0 + 1.402 * y2 >> shift;
                                out[pos++] = y0 - 0.34413 * y1 - 0.71414 * y2 >> shift;
                                out[pos++] = y0 + 1.772 * y1 >> shift;
                            }
                            else for(j = 0; j < jj; j++, pos += alpha01){
                                y0 = y0items[j] + offset;
                                y1 = y1items[j];
                                y2 = y2items[j];
                                const g = y0 - (y2 + y1 >> 2);
                                out[pos++] = g + y2 >> shift;
                                out[pos++] = g >> shift;
                                out[pos++] = g + y1 >> shift;
                            }
                            if (fourComponents) for(j = 0, pos = 3; j < jj; j++, pos += 4)out[pos] = y3items[j] + offset >> shift;
                        } else for(let c = 0; c < componentsCount; c++){
                            const items = transformedTiles[c].items;
                            shift = components[c].precision - 8;
                            offset = (128 << shift) + 0.5;
                            for(pos = c, j = 0, jj = items.length; j < jj; j++){
                                out[pos] = items[j] + offset >> shift;
                                pos += componentsCount;
                            }
                        }
                        resultImages.push(result);
                    }
                    return resultImages;
                }
                function initializeTile(context, tileIndex) {
                    const siz = context.SIZ;
                    const componentsCount = siz.Csiz;
                    const tile = context.tiles[tileIndex];
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
                        component.quantizationParameters = qcdOrQcc;
                        const codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
                        component.codingStyleParameters = codOrCoc;
                    }
                    tile.codingStyleDefaultParameters = context.currentTile.COD;
                }
                class TagTree {
                    constructor(width, height){
                        const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                        this.levels = [];
                        for(let i = 0; i < levelsLength; i++){
                            const level = {
                                width: width,
                                height: height,
                                items: []
                            };
                            this.levels.push(level);
                            width = Math.ceil(width / 2);
                            height = Math.ceil(height / 2);
                        }
                    }
                    reset(i, j) {
                        let currentLevel = 0, value = 0, level;
                        while(currentLevel < this.levels.length){
                            level = this.levels[currentLevel];
                            const index = i + j * level.width;
                            if (level.items[index] !== undefined) {
                                value = level.items[index];
                                break;
                            }
                            level.index = index;
                            i >>= 1;
                            j >>= 1;
                            currentLevel++;
                        }
                        currentLevel--;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        this.currentLevel = currentLevel;
                        delete this.value;
                    }
                    incrementValue() {
                        const level = this.levels[this.currentLevel];
                        level.items[level.index]++;
                    }
                    nextLevel() {
                        let currentLevel = this.currentLevel;
                        let level = this.levels[currentLevel];
                        const value = level.items[level.index];
                        currentLevel--;
                        if (currentLevel < 0) {
                            this.value = value;
                            return false;
                        }
                        this.currentLevel = currentLevel;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        return true;
                    }
                }
                class InclusionTree {
                    constructor(width, height, defaultValue){
                        const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                        this.levels = [];
                        for(let i = 0; i < levelsLength; i++){
                            const items = new Uint8Array(width * height);
                            for(let j = 0, jj = items.length; j < jj; j++)items[j] = defaultValue;
                            const level = {
                                width: width,
                                height: height,
                                items: items
                            };
                            this.levels.push(level);
                            width = Math.ceil(width / 2);
                            height = Math.ceil(height / 2);
                        }
                    }
                    reset(i, j, stopValue) {
                        let currentLevel = 0;
                        while(currentLevel < this.levels.length){
                            const level = this.levels[currentLevel];
                            const index = i + j * level.width;
                            level.index = index;
                            const value = level.items[index];
                            if (value === 0xff) break;
                            if (value > stopValue) {
                                this.currentLevel = currentLevel;
                                this.propagateValues();
                                return false;
                            }
                            i >>= 1;
                            j >>= 1;
                            currentLevel++;
                        }
                        this.currentLevel = currentLevel - 1;
                        return true;
                    }
                    incrementValue(stopValue) {
                        const level = this.levels[this.currentLevel];
                        level.items[level.index] = stopValue + 1;
                        this.propagateValues();
                    }
                    propagateValues() {
                        let levelIndex = this.currentLevel;
                        let level = this.levels[levelIndex];
                        const currentValue = level.items[level.index];
                        while(--levelIndex >= 0){
                            level = this.levels[levelIndex];
                            level.items[level.index] = currentValue;
                        }
                    }
                    nextLevel() {
                        let currentLevel = this.currentLevel;
                        let level = this.levels[currentLevel];
                        const value = level.items[level.index];
                        level.items[level.index] = 0xff;
                        currentLevel--;
                        if (currentLevel < 0) return false;
                        this.currentLevel = currentLevel;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        return true;
                    }
                }
                class BitModel {
                    static UNIFORM_CONTEXT = 17;
                    static RUNLENGTH_CONTEXT = 18;
                    static LLAndLHContextsLabel = new Uint8Array([
                        0,
                        5,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8
                    ]);
                    static HLContextLabel = new Uint8Array([
                        0,
                        3,
                        4,
                        0,
                        5,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8
                    ]);
                    static HHContextLabel = new Uint8Array([
                        0,
                        1,
                        2,
                        0,
                        1,
                        2,
                        2,
                        0,
                        2,
                        2,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        4,
                        5,
                        0,
                        4,
                        5,
                        5,
                        0,
                        5,
                        5,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        6,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8
                    ]);
                    constructor(width, height, subband, zeroBitPlanes, mb){
                        this.width = width;
                        this.height = height;
                        let contextLabelTable;
                        if (subband === "HH") contextLabelTable = BitModel.HHContextLabel;
                        else if (subband === "HL") contextLabelTable = BitModel.HLContextLabel;
                        else contextLabelTable = BitModel.LLAndLHContextsLabel;
                        this.contextLabelTable = contextLabelTable;
                        const coefficientCount = width * height;
                        this.neighborsSignificance = new Uint8Array(coefficientCount);
                        this.coefficentsSign = new Uint8Array(coefficientCount);
                        let coefficentsMagnitude;
                        if (mb > 14) coefficentsMagnitude = new Uint32Array(coefficientCount);
                        else if (mb > 6) coefficentsMagnitude = new Uint16Array(coefficientCount);
                        else coefficentsMagnitude = new Uint8Array(coefficientCount);
                        this.coefficentsMagnitude = coefficentsMagnitude;
                        this.processingFlags = new Uint8Array(coefficientCount);
                        const bitsDecoded = new Uint8Array(coefficientCount);
                        if (zeroBitPlanes !== 0) for(let i = 0; i < coefficientCount; i++)bitsDecoded[i] = zeroBitPlanes;
                        this.bitsDecoded = bitsDecoded;
                        this.reset();
                    }
                    setDecoder(decoder) {
                        this.decoder = decoder;
                    }
                    reset() {
                        this.contexts = new Int8Array(19);
                        this.contexts[0] = 8;
                        this.contexts[BitModel.UNIFORM_CONTEXT] = 92;
                        this.contexts[BitModel.RUNLENGTH_CONTEXT] = 6;
                    }
                    setNeighborsSignificance(row, column, index) {
                        const neighborsSignificance = this.neighborsSignificance;
                        const width = this.width, height = this.height;
                        const left = column > 0;
                        const right = column + 1 < width;
                        let i;
                        if (row > 0) {
                            i = index - width;
                            if (left) neighborsSignificance[i - 1] += 0x10;
                            if (right) neighborsSignificance[i + 1] += 0x10;
                            neighborsSignificance[i] += 0x04;
                        }
                        if (row + 1 < height) {
                            i = index + width;
                            if (left) neighborsSignificance[i - 1] += 0x10;
                            if (right) neighborsSignificance[i + 1] += 0x10;
                            neighborsSignificance[i] += 0x04;
                        }
                        if (left) neighborsSignificance[index - 1] += 0x01;
                        if (right) neighborsSignificance[index + 1] += 0x01;
                        neighborsSignificance[index] |= 0x80;
                    }
                    runSignificancePropagationPass() {
                        const decoder = this.decoder;
                        const width = this.width, height = this.height;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const coefficentsSign = this.coefficentsSign;
                        const neighborsSignificance = this.neighborsSignificance;
                        const processingFlags = this.processingFlags;
                        const contexts = this.contexts;
                        const labels = this.contextLabelTable;
                        const bitsDecoded = this.bitsDecoded;
                        const processedInverseMask = -2;
                        const processedMask = 1;
                        const firstMagnitudeBitMask = 2;
                        for(let i0 = 0; i0 < height; i0 += 4)for(let j = 0; j < width; j++){
                            let index = i0 * width + j;
                            for(let i1 = 0; i1 < 4; i1++, index += width){
                                const i = i0 + i1;
                                if (i >= height) break;
                                processingFlags[index] &= processedInverseMask;
                                if (coefficentsMagnitude[index] || !neighborsSignificance[index]) continue;
                                const contextLabel = labels[neighborsSignificance[index]];
                                const decision = decoder.readBit(contexts, contextLabel);
                                if (decision) {
                                    const sign = this.decodeSignBit(i, j, index);
                                    coefficentsSign[index] = sign;
                                    coefficentsMagnitude[index] = 1;
                                    this.setNeighborsSignificance(i, j, index);
                                    processingFlags[index] |= firstMagnitudeBitMask;
                                }
                                bitsDecoded[index]++;
                                processingFlags[index] |= processedMask;
                            }
                        }
                    }
                    decodeSignBit(row, column, index) {
                        const width = this.width, height = this.height;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const coefficentsSign = this.coefficentsSign;
                        let contribution, sign0, sign1, significance1;
                        let contextLabel, decoded;
                        significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
                        if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
                            sign1 = coefficentsSign[index + 1];
                            if (significance1) {
                                sign0 = coefficentsSign[index - 1];
                                contribution = 1 - sign1 - sign0;
                            } else contribution = 1 - sign1 - sign1;
                        } else if (significance1) {
                            sign0 = coefficentsSign[index - 1];
                            contribution = 1 - sign0 - sign0;
                        } else contribution = 0;
                        const horizontalContribution = 3 * contribution;
                        significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
                        if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
                            sign1 = coefficentsSign[index + width];
                            if (significance1) {
                                sign0 = coefficentsSign[index - width];
                                contribution = 1 - sign1 - sign0 + horizontalContribution;
                            } else contribution = 1 - sign1 - sign1 + horizontalContribution;
                        } else if (significance1) {
                            sign0 = coefficentsSign[index - width];
                            contribution = 1 - sign0 - sign0 + horizontalContribution;
                        } else contribution = horizontalContribution;
                        if (contribution >= 0) {
                            contextLabel = 9 + contribution;
                            decoded = this.decoder.readBit(this.contexts, contextLabel);
                        } else {
                            contextLabel = 9 - contribution;
                            decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
                        }
                        return decoded;
                    }
                    runMagnitudeRefinementPass() {
                        const decoder = this.decoder;
                        const width = this.width, height = this.height;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const neighborsSignificance = this.neighborsSignificance;
                        const contexts = this.contexts;
                        const bitsDecoded = this.bitsDecoded;
                        const processingFlags = this.processingFlags;
                        const processedMask = 1;
                        const firstMagnitudeBitMask = 2;
                        const length = width * height;
                        const width4 = width * 4;
                        for(let index0 = 0, indexNext; index0 < length; index0 = indexNext){
                            indexNext = Math.min(length, index0 + width4);
                            for(let j = 0; j < width; j++)for(let index = index0 + j; index < indexNext; index += width){
                                if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) continue;
                                let contextLabel = 16;
                                if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
                                    processingFlags[index] ^= firstMagnitudeBitMask;
                                    const significance = neighborsSignificance[index] & 127;
                                    contextLabel = significance === 0 ? 15 : 14;
                                }
                                const bit = decoder.readBit(contexts, contextLabel);
                                coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
                                bitsDecoded[index]++;
                                processingFlags[index] |= processedMask;
                            }
                        }
                    }
                    runCleanupPass() {
                        const decoder = this.decoder;
                        const width = this.width, height = this.height;
                        const neighborsSignificance = this.neighborsSignificance;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const coefficentsSign = this.coefficentsSign;
                        const contexts = this.contexts;
                        const labels = this.contextLabelTable;
                        const bitsDecoded = this.bitsDecoded;
                        const processingFlags = this.processingFlags;
                        const processedMask = 1;
                        const firstMagnitudeBitMask = 2;
                        const oneRowDown = width;
                        const twoRowsDown = width * 2;
                        const threeRowsDown = width * 3;
                        let iNext;
                        for(let i0 = 0; i0 < height; i0 = iNext){
                            iNext = Math.min(i0 + 4, height);
                            const indexBase = i0 * width;
                            const checkAllEmpty = i0 + 3 < height;
                            for(let j = 0; j < width; j++){
                                const index0 = indexBase + j;
                                const allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
                                let i1 = 0, index = index0;
                                let i = i0, sign;
                                if (allEmpty) {
                                    const hasSignificantCoefficent = decoder.readBit(contexts, BitModel.RUNLENGTH_CONTEXT);
                                    if (!hasSignificantCoefficent) {
                                        bitsDecoded[index0]++;
                                        bitsDecoded[index0 + oneRowDown]++;
                                        bitsDecoded[index0 + twoRowsDown]++;
                                        bitsDecoded[index0 + threeRowsDown]++;
                                        continue;
                                    }
                                    i1 = decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT);
                                    if (i1 !== 0) {
                                        i = i0 + i1;
                                        index += i1 * width;
                                    }
                                    sign = this.decodeSignBit(i, j, index);
                                    coefficentsSign[index] = sign;
                                    coefficentsMagnitude[index] = 1;
                                    this.setNeighborsSignificance(i, j, index);
                                    processingFlags[index] |= firstMagnitudeBitMask;
                                    index = index0;
                                    for(let i2 = i0; i2 <= i; i2++, index += width)bitsDecoded[index]++;
                                    i1++;
                                }
                                for(i = i0 + i1; i < iNext; i++, index += width){
                                    if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) continue;
                                    const contextLabel = labels[neighborsSignificance[index]];
                                    const decision = decoder.readBit(contexts, contextLabel);
                                    if (decision === 1) {
                                        sign = this.decodeSignBit(i, j, index);
                                        coefficentsSign[index] = sign;
                                        coefficentsMagnitude[index] = 1;
                                        this.setNeighborsSignificance(i, j, index);
                                        processingFlags[index] |= firstMagnitudeBitMask;
                                    }
                                    bitsDecoded[index]++;
                                }
                            }
                        }
                    }
                    checkSegmentationSymbol() {
                        const decoder = this.decoder;
                        const contexts = this.contexts;
                        const symbol = decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT);
                        if (symbol !== 0xa) throw new JpxError("Invalid segmentation symbol");
                    }
                }
                class Transform {
                    constructor(){
                        if (this.constructor === Transform) (0, _util.unreachable)("Cannot initialize Transform.");
                    }
                    calculate(subbands, u0, v0) {
                        let ll = subbands[0];
                        for(let i = 1, ii = subbands.length; i < ii; i++)ll = this.iterate(ll, subbands[i], u0, v0);
                        return ll;
                    }
                    extend(buffer, offset, size) {
                        let i1 = offset - 1, j1 = offset + 1;
                        let i2 = offset + size - 2, j2 = offset + size;
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1] = buffer[j1];
                        buffer[j2] = buffer[i2];
                    }
                    filter(x, offset, length) {
                        (0, _util.unreachable)("Abstract method `filter` called");
                    }
                    iterate(ll, hl_lh_hh, u0, v0) {
                        const llWidth = ll.width, llHeight = ll.height;
                        let llItems = ll.items;
                        const width = hl_lh_hh.width;
                        const height = hl_lh_hh.height;
                        const items = hl_lh_hh.items;
                        let i, j, k, l, u, v;
                        for(k = 0, i = 0; i < llHeight; i++){
                            l = i * 2 * width;
                            for(j = 0; j < llWidth; j++, k++, l += 2)items[l] = llItems[k];
                        }
                        llItems = ll.items = null;
                        const bufferPadding = 4;
                        const rowBuffer = new Float32Array(width + 2 * bufferPadding);
                        if (width === 1) {
                            if ((u0 & 1) !== 0) for(v = 0, k = 0; v < height; v++, k += width)items[k] *= 0.5;
                        } else for(v = 0, k = 0; v < height; v++, k += width){
                            rowBuffer.set(items.subarray(k, k + width), bufferPadding);
                            this.extend(rowBuffer, bufferPadding, width);
                            this.filter(rowBuffer, bufferPadding, width);
                            items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
                        }
                        let numBuffers = 16;
                        const colBuffers = [];
                        for(i = 0; i < numBuffers; i++)colBuffers.push(new Float32Array(height + 2 * bufferPadding));
                        let b, currentBuffer = 0;
                        ll = bufferPadding + height;
                        if (height === 1) {
                            if ((v0 & 1) !== 0) for(u = 0; u < width; u++)items[u] *= 0.5;
                        } else for(u = 0; u < width; u++){
                            if (currentBuffer === 0) {
                                numBuffers = Math.min(width - u, numBuffers);
                                for(k = u, l = bufferPadding; l < ll; k += width, l++)for(b = 0; b < numBuffers; b++)colBuffers[b][l] = items[k + b];
                                currentBuffer = numBuffers;
                            }
                            currentBuffer--;
                            const buffer = colBuffers[currentBuffer];
                            this.extend(buffer, bufferPadding, height);
                            this.filter(buffer, bufferPadding, height);
                            if (currentBuffer === 0) {
                                k = u - numBuffers + 1;
                                for(l = bufferPadding; l < ll; k += width, l++)for(b = 0; b < numBuffers; b++)items[k + b] = colBuffers[b][l];
                            }
                        }
                        return {
                            width: width,
                            height: height,
                            items: items
                        };
                    }
                }
                class IrreversibleTransform extends Transform {
                    filter(x, offset, length) {
                        const len = length >> 1;
                        offset |= 0;
                        let j, n, current, next;
                        const alpha = -1.586134342059924;
                        const beta = -0.052980118572961;
                        const gamma = 0.882911075530934;
                        const delta = 0.443506852043971;
                        const K = 1.230174104914001;
                        const K_ = 1 / K;
                        j = offset - 3;
                        for(n = len + 4; n--; j += 2)x[j] *= K_;
                        j = offset - 2;
                        current = delta * x[j - 1];
                        for(n = len + 3; n--; j += 2){
                            next = delta * x[j + 1];
                            x[j] = K * x[j] - current - next;
                            if (n--) {
                                j += 2;
                                current = delta * x[j + 1];
                                x[j] = K * x[j] - current - next;
                            } else break;
                        }
                        j = offset - 1;
                        current = gamma * x[j - 1];
                        for(n = len + 2; n--; j += 2){
                            next = gamma * x[j + 1];
                            x[j] -= current + next;
                            if (n--) {
                                j += 2;
                                current = gamma * x[j + 1];
                                x[j] -= current + next;
                            } else break;
                        }
                        j = offset;
                        current = beta * x[j - 1];
                        for(n = len + 1; n--; j += 2){
                            next = beta * x[j + 1];
                            x[j] -= current + next;
                            if (n--) {
                                j += 2;
                                current = beta * x[j + 1];
                                x[j] -= current + next;
                            } else break;
                        }
                        if (len !== 0) {
                            j = offset + 1;
                            current = alpha * x[j - 1];
                            for(n = len; n--; j += 2){
                                next = alpha * x[j + 1];
                                x[j] -= current + next;
                                if (n--) {
                                    j += 2;
                                    current = alpha * x[j + 1];
                                    x[j] -= current + next;
                                } else break;
                            }
                        }
                    }
                }
                class ReversibleTransform extends Transform {
                    filter(x, offset, length) {
                        const len = length >> 1;
                        offset |= 0;
                        let j, n;
                        for(j = offset, n = len + 1; n--; j += 2)x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
                        for(j = offset + 1, n = len; n--; j += 2)x[j] += x[j - 1] + x[j + 1] >> 1;
                    }
                }
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LZWStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                class LZWStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, earlyChange){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.cachedData = 0;
                        this.bitsCached = 0;
                        const maxLzwDictionarySize = 4096;
                        const lzwState = {
                            earlyChange: earlyChange,
                            codeLength: 9,
                            nextCode: 258,
                            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
                            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
                            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
                            currentSequence: new Uint8Array(maxLzwDictionarySize),
                            currentSequenceLength: 0
                        };
                        for(let i = 0; i < 256; ++i){
                            lzwState.dictionaryValues[i] = i;
                            lzwState.dictionaryLengths[i] = 1;
                        }
                        this.lzwState = lzwState;
                    }
                    readBits(n) {
                        let bitsCached = this.bitsCached;
                        let cachedData = this.cachedData;
                        while(bitsCached < n){
                            const c = this.str.getByte();
                            if (c === -1) {
                                this.eof = true;
                                return null;
                            }
                            cachedData = cachedData << 8 | c;
                            bitsCached += 8;
                        }
                        this.bitsCached = bitsCached -= n;
                        this.cachedData = cachedData;
                        this.lastCode = null;
                        return cachedData >>> bitsCached & (1 << n) - 1;
                    }
                    readBlock() {
                        const blockSize = 512, decodedSizeDelta = blockSize;
                        let estimatedDecodedSize = blockSize * 2;
                        let i, j, q;
                        const lzwState = this.lzwState;
                        if (!lzwState) return;
                        const earlyChange = lzwState.earlyChange;
                        let nextCode = lzwState.nextCode;
                        const dictionaryValues = lzwState.dictionaryValues;
                        const dictionaryLengths = lzwState.dictionaryLengths;
                        const dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
                        let codeLength = lzwState.codeLength;
                        let prevCode = lzwState.prevCode;
                        const currentSequence = lzwState.currentSequence;
                        let currentSequenceLength = lzwState.currentSequenceLength;
                        let decodedLength = 0;
                        let currentBufferLength = this.bufferLength;
                        let buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                        for(i = 0; i < blockSize; i++){
                            const code = this.readBits(codeLength);
                            const hasPrev = currentSequenceLength > 0;
                            if (code < 256) {
                                currentSequence[0] = code;
                                currentSequenceLength = 1;
                            } else if (code >= 258) {
                                if (code < nextCode) {
                                    currentSequenceLength = dictionaryLengths[code];
                                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                                        currentSequence[j] = dictionaryValues[q];
                                        q = dictionaryPrevCodes[q];
                                    }
                                } else currentSequence[currentSequenceLength++] = currentSequence[0];
                            } else if (code === 256) {
                                codeLength = 9;
                                nextCode = 258;
                                currentSequenceLength = 0;
                                continue;
                            } else {
                                this.eof = true;
                                delete this.lzwState;
                                break;
                            }
                            if (hasPrev) {
                                dictionaryPrevCodes[nextCode] = prevCode;
                                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                                dictionaryValues[nextCode] = currentSequence[0];
                                nextCode++;
                                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
                            }
                            prevCode = code;
                            decodedLength += currentSequenceLength;
                            if (estimatedDecodedSize < decodedLength) {
                                do estimatedDecodedSize += decodedSizeDelta;
                                while (estimatedDecodedSize < decodedLength);
                                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                            }
                            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
                        }
                        lzwState.nextCode = nextCode;
                        lzwState.codeLength = codeLength;
                        lzwState.prevCode = prevCode;
                        lzwState.currentSequenceLength = currentSequenceLength;
                        this.bufferLength = currentBufferLength;
                    }
                }
                exports.LZWStream = LZWStream;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PredictorStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                var _util = __w_pdfjs_require__(2);
                class PredictorStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, params){
                        super(maybeLength);
                        if (!(params instanceof _primitives.Dict)) return str;
                        const predictor = this.predictor = params.get("Predictor") || 1;
                        if (predictor <= 1) return str;
                        if (predictor !== 2 && (predictor < 10 || predictor > 15)) throw new _util.FormatError(`Unsupported predictor: ${predictor}`);
                        this.readBlock = predictor === 2 ? this.readBlockTiff : this.readBlockPng;
                        this.str = str;
                        this.dict = str.dict;
                        const colors = this.colors = params.get("Colors") || 1;
                        const bits = this.bits = params.get("BPC", "BitsPerComponent") || 8;
                        const columns = this.columns = params.get("Columns") || 1;
                        this.pixBytes = colors * bits + 7 >> 3;
                        this.rowBytes = columns * colors * bits + 7 >> 3;
                        return this;
                    }
                    readBlockTiff() {
                        const rowBytes = this.rowBytes;
                        const bufferLength = this.bufferLength;
                        const buffer = this.ensureBuffer(bufferLength + rowBytes);
                        const bits = this.bits;
                        const colors = this.colors;
                        const rawBytes = this.str.getBytes(rowBytes);
                        this.eof = !rawBytes.length;
                        if (this.eof) return;
                        let inbuf = 0, outbuf = 0;
                        let inbits = 0, outbits = 0;
                        let pos = bufferLength;
                        let i;
                        if (bits === 1 && colors === 1) for(i = 0; i < rowBytes; ++i){
                            let c = rawBytes[i] ^ inbuf;
                            c ^= c >> 1;
                            c ^= c >> 2;
                            c ^= c >> 4;
                            inbuf = (c & 1) << 7;
                            buffer[pos++] = c;
                        }
                        else if (bits === 8) {
                            for(i = 0; i < colors; ++i)buffer[pos++] = rawBytes[i];
                            for(; i < rowBytes; ++i){
                                buffer[pos] = buffer[pos - colors] + rawBytes[i];
                                pos++;
                            }
                        } else if (bits === 16) {
                            const bytesPerPixel = colors * 2;
                            for(i = 0; i < bytesPerPixel; ++i)buffer[pos++] = rawBytes[i];
                            for(; i < rowBytes; i += 2){
                                const sum = ((rawBytes[i] & 0xff) << 8) + (rawBytes[i + 1] & 0xff) + ((buffer[pos - bytesPerPixel] & 0xff) << 8) + (buffer[pos - bytesPerPixel + 1] & 0xff);
                                buffer[pos++] = sum >> 8 & 0xff;
                                buffer[pos++] = sum & 0xff;
                            }
                        } else {
                            const compArray = new Uint8Array(colors + 1);
                            const bitMask = (1 << bits) - 1;
                            let j = 0, k = bufferLength;
                            const columns = this.columns;
                            for(i = 0; i < columns; ++i)for(let kk = 0; kk < colors; ++kk){
                                if (inbits < bits) {
                                    inbuf = inbuf << 8 | rawBytes[j++] & 0xff;
                                    inbits += 8;
                                }
                                compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
                                inbits -= bits;
                                outbuf = outbuf << bits | compArray[kk];
                                outbits += bits;
                                if (outbits >= 8) {
                                    buffer[k++] = outbuf >> outbits - 8 & 0xff;
                                    outbits -= 8;
                                }
                            }
                            if (outbits > 0) buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
                        }
                        this.bufferLength += rowBytes;
                    }
                    readBlockPng() {
                        const rowBytes = this.rowBytes;
                        const pixBytes = this.pixBytes;
                        const predictor = this.str.getByte();
                        const rawBytes = this.str.getBytes(rowBytes);
                        this.eof = !rawBytes.length;
                        if (this.eof) return;
                        const bufferLength = this.bufferLength;
                        const buffer = this.ensureBuffer(bufferLength + rowBytes);
                        let prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
                        if (prevRow.length === 0) prevRow = new Uint8Array(rowBytes);
                        let i, j = bufferLength, up, c;
                        switch(predictor){
                            case 0:
                                for(i = 0; i < rowBytes; ++i)buffer[j++] = rawBytes[i];
                                break;
                            case 1:
                                for(i = 0; i < pixBytes; ++i)buffer[j++] = rawBytes[i];
                                for(; i < rowBytes; ++i){
                                    buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xff;
                                    j++;
                                }
                                break;
                            case 2:
                                for(i = 0; i < rowBytes; ++i)buffer[j++] = prevRow[i] + rawBytes[i] & 0xff;
                                break;
                            case 3:
                                for(i = 0; i < pixBytes; ++i)buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
                                for(; i < rowBytes; ++i){
                                    buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xff;
                                    j++;
                                }
                                break;
                            case 4:
                                for(i = 0; i < pixBytes; ++i){
                                    up = prevRow[i];
                                    c = rawBytes[i];
                                    buffer[j++] = up + c;
                                }
                                for(; i < rowBytes; ++i){
                                    up = prevRow[i];
                                    const upLeft = prevRow[i - pixBytes];
                                    const left = buffer[j - pixBytes];
                                    const p = left + up - upLeft;
                                    let pa = p - left;
                                    if (pa < 0) pa = -pa;
                                    let pb = p - up;
                                    if (pb < 0) pb = -pb;
                                    let pc = p - upLeft;
                                    if (pc < 0) pc = -pc;
                                    c = rawBytes[i];
                                    if (pa <= pb && pa <= pc) buffer[j++] = left + c;
                                    else if (pb <= pc) buffer[j++] = up + c;
                                    else buffer[j++] = upLeft + c;
                                }
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported predictor: ${predictor}`);
                        }
                        this.bufferLength += rowBytes;
                    }
                }
                exports.PredictorStream = PredictorStream;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RunLengthStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                class RunLengthStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                    }
                    readBlock() {
                        const repeatHeader = this.str.getBytes(2);
                        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
                            this.eof = true;
                            return;
                        }
                        let buffer;
                        let bufferLength = this.bufferLength;
                        let n = repeatHeader[0];
                        if (n < 128) {
                            buffer = this.ensureBuffer(bufferLength + n + 1);
                            buffer[bufferLength++] = repeatHeader[1];
                            if (n > 0) {
                                const source = this.str.getBytes(n);
                                buffer.set(source, bufferLength);
                                bufferLength += n;
                            }
                        } else {
                            n = 257 - n;
                            const b = repeatHeader[1];
                            buffer = this.ensureBuffer(bufferLength + n + 1);
                            for(let i = 0; i < n; i++)buffer[bufferLength++] = b;
                        }
                        this.bufferLength = bufferLength;
                    }
                }
                exports.RunLengthStream = RunLengthStream;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Font = exports.ErrorFont = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _unicode = __w_pdfjs_require__(40);
                var _glyphlist = __w_pdfjs_require__(39);
                var _encodings = __w_pdfjs_require__(37);
                var _standard_fonts = __w_pdfjs_require__(41);
                var _to_unicode_map = __w_pdfjs_require__(42);
                var _cff_font = __w_pdfjs_require__(43);
                var _font_renderer = __w_pdfjs_require__(44);
                var _metrics = __w_pdfjs_require__(45);
                var _glyf = __w_pdfjs_require__(46);
                var _cmap = __w_pdfjs_require__(14);
                var _opentype_file_builder = __w_pdfjs_require__(47);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _type1_font = __w_pdfjs_require__(48);
                const PRIVATE_USE_AREAS = [
                    [
                        0xe000,
                        0xf8ff
                    ],
                    [
                        0x100000,
                        0x10fffd
                    ]
                ];
                const PDF_GLYPH_SPACE_UNITS = 1000;
                const EXPORT_DATA_PROPERTIES = [
                    "ascent",
                    "bbox",
                    "black",
                    "bold",
                    "charProcOperatorList",
                    "composite",
                    "cssFontInfo",
                    "data",
                    "defaultVMetrics",
                    "defaultWidth",
                    "descent",
                    "fallbackName",
                    "fontMatrix",
                    "isInvalidPDFjsFont",
                    "isType3Font",
                    "italic",
                    "loadedName",
                    "mimetype",
                    "missingFile",
                    "name",
                    "remeasure",
                    "subtype",
                    "systemFontInfo",
                    "type",
                    "vertical"
                ];
                const EXPORT_DATA_EXTRA_PROPERTIES = [
                    "cMap",
                    "defaultEncoding",
                    "differences",
                    "isMonospace",
                    "isSerifFont",
                    "isSymbolicFont",
                    "seacMap",
                    "toFontChar",
                    "toUnicode",
                    "vmetrics",
                    "widths"
                ];
                function adjustWidths(properties) {
                    if (!properties.fontMatrix) return;
                    if (properties.fontMatrix[0] === _util.FONT_IDENTITY_MATRIX[0]) return;
                    const scale = 0.001 / properties.fontMatrix[0];
                    const glyphsWidths = properties.widths;
                    for(const glyph in glyphsWidths)glyphsWidths[glyph] *= scale;
                    properties.defaultWidth *= scale;
                }
                function adjustTrueTypeToUnicode(properties, isSymbolicFont, nameRecords) {
                    if (properties.isInternalFont) return;
                    if (properties.hasIncludedToUnicodeMap) return;
                    if (properties.hasEncoding) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    if (!isSymbolicFont) return;
                    if (nameRecords.length === 0) return;
                    if (properties.defaultEncoding === _encodings.WinAnsiEncoding) return;
                    for (const r of nameRecords){
                        if (!isWinNameRecord(r)) return;
                    }
                    const encoding = _encodings.WinAnsiEncoding;
                    const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    for(const charCode in encoding){
                        const glyphName = encoding[charCode];
                        if (glyphName === "") continue;
                        const unicode = glyphsUnicodeMap[glyphName];
                        if (unicode === undefined) continue;
                        toUnicode[charCode] = String.fromCharCode(unicode);
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                function adjustType1ToUnicode(properties, builtInEncoding) {
                    if (properties.isInternalFont) return;
                    if (properties.hasIncludedToUnicodeMap) return;
                    if (builtInEncoding === properties.defaultEncoding) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    for(const charCode in builtInEncoding){
                        if (properties.hasEncoding) {
                            if (properties.baseEncodingName || properties.differences[charCode] !== undefined) continue;
                        }
                        const glyphName = builtInEncoding[charCode];
                        const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                        if (unicode !== -1) toUnicode[charCode] = String.fromCharCode(unicode);
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                function amendFallbackToUnicode(properties) {
                    if (!properties.fallbackToUnicode) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    const toUnicode = [];
                    for(const charCode in properties.fallbackToUnicode){
                        if (properties.toUnicode.has(charCode)) continue;
                        toUnicode[charCode] = properties.fallbackToUnicode[charCode];
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                class Glyph {
                    constructor(originalCharCode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont){
                        this.originalCharCode = originalCharCode;
                        this.fontChar = fontChar;
                        this.unicode = unicode;
                        this.accent = accent;
                        this.width = width;
                        this.vmetric = vmetric;
                        this.operatorListId = operatorListId;
                        this.isSpace = isSpace;
                        this.isInFont = isInFont;
                    }
                    get category() {
                        return (0, _util.shadow)(this, "category", (0, _unicode.getCharUnicodeCategory)(this.unicode), true);
                    }
                }
                function int16(b0, b1) {
                    return (b0 << 8) + b1;
                }
                function writeSignedInt16(bytes, index, value) {
                    bytes[index + 1] = value;
                    bytes[index] = value >>> 8;
                }
                function signedInt16(b0, b1) {
                    const value = (b0 << 8) + b1;
                    return value & 32768 ? value - 0x10000 : value;
                }
                function int32(b0, b1, b2, b3) {
                    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                }
                function string16(value) {
                    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
                }
                function safeString16(value) {
                    if (value > 0x7fff) value = 0x7fff;
                    else if (value < -32768) value = -32768;
                    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
                }
                function isTrueTypeFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _core_utils.readUint32)(header, 0) === 0x00010000 || (0, _util.bytesToString)(header) === "true";
                }
                function isTrueTypeCollectionFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _util.bytesToString)(header) === "ttcf";
                }
                function isOpenTypeFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _util.bytesToString)(header) === "OTTO";
                }
                function isType1File(file) {
                    const header = file.peekBytes(2);
                    if (header[0] === 0x25 && header[1] === 0x21) return true;
                    if (header[0] === 0x80 && header[1] === 0x01) return true;
                    return false;
                }
                function isCFFFile(file) {
                    const header = file.peekBytes(4);
                    if (header[0] >= 1 && header[3] >= 1 && header[3] <= 4) return true;
                    return false;
                }
                function getFontFileType(file, { type: type, subtype: subtype, composite: composite }) {
                    let fileType, fileSubtype;
                    if (isTrueTypeFile(file) || isTrueTypeCollectionFile(file)) fileType = composite ? "CIDFontType2" : "TrueType";
                    else if (isOpenTypeFile(file)) fileType = composite ? "CIDFontType2" : "OpenType";
                    else if (isType1File(file)) {
                        if (composite) fileType = "CIDFontType0";
                        else fileType = type === "MMType1" ? "MMType1" : "Type1";
                    } else if (isCFFFile(file)) {
                        if (composite) {
                            fileType = "CIDFontType0";
                            fileSubtype = "CIDFontType0C";
                        } else {
                            fileType = type === "MMType1" ? "MMType1" : "Type1";
                            fileSubtype = "Type1C";
                        }
                    } else {
                        (0, _util.warn)("getFontFileType: Unable to detect correct font file Type/Subtype.");
                        fileType = type;
                        fileSubtype = subtype;
                    }
                    return [
                        fileType,
                        fileSubtype
                    ];
                }
                function applyStandardFontGlyphMap(map, glyphMap) {
                    for(const charCode in glyphMap)map[+charCode] = glyphMap[charCode];
                }
                function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
                    const toFontChar = [];
                    let unicode;
                    for(let i = 0, ii = encoding.length; i < ii; i++){
                        unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
                        if (unicode !== -1) toFontChar[i] = unicode;
                    }
                    for(const charCode in differences){
                        unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
                        if (unicode !== -1) toFontChar[+charCode] = unicode;
                    }
                    return toFontChar;
                }
                function isMacNameRecord(r) {
                    return r.platform === 1 && r.encoding === 0 && r.language === 0;
                }
                function isWinNameRecord(r) {
                    return r.platform === 3 && r.encoding === 1 && r.language === 0x409;
                }
                function convertCidString(charCode, cid, shouldThrow = false) {
                    switch(cid.length){
                        case 1:
                            return cid.charCodeAt(0);
                        case 2:
                            return cid.charCodeAt(0) << 8 | cid.charCodeAt(1);
                    }
                    const msg = `Unsupported CID string (charCode ${charCode}): "${cid}".`;
                    if (shouldThrow) throw new _util.FormatError(msg);
                    (0, _util.warn)(msg);
                    return cid;
                }
                function adjustMapping(charCodeToGlyphId, hasGlyph, newGlyphZeroId, toUnicode) {
                    const newMap = Object.create(null);
                    const toUnicodeExtraMap = new Map();
                    const toFontChar = [];
                    const usedGlyphIds = new Set();
                    let privateUseAreaIndex = 0;
                    const privateUseOffetStart = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                    let nextAvailableFontCharCode = privateUseOffetStart;
                    let privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                    const isInPrivateArea = (code)=>PRIVATE_USE_AREAS[0][0] <= code && code <= PRIVATE_USE_AREAS[0][1] || PRIVATE_USE_AREAS[1][0] <= code && code <= PRIVATE_USE_AREAS[1][1];
                    for(let originalCharCode in charCodeToGlyphId){
                        originalCharCode |= 0;
                        let glyphId = charCodeToGlyphId[originalCharCode];
                        if (!hasGlyph(glyphId)) continue;
                        if (nextAvailableFontCharCode > privateUseOffetEnd) {
                            privateUseAreaIndex++;
                            if (privateUseAreaIndex >= PRIVATE_USE_AREAS.length) {
                                (0, _util.warn)("Ran out of space in font private use area.");
                                break;
                            }
                            nextAvailableFontCharCode = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                            privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                        }
                        const fontCharCode = nextAvailableFontCharCode++;
                        if (glyphId === 0) glyphId = newGlyphZeroId;
                        let unicode = toUnicode.get(originalCharCode);
                        if (typeof unicode === "string") unicode = unicode.codePointAt(0);
                        if (unicode && !isInPrivateArea(unicode) && !usedGlyphIds.has(glyphId)) {
                            toUnicodeExtraMap.set(unicode, glyphId);
                            usedGlyphIds.add(glyphId);
                        }
                        newMap[fontCharCode] = glyphId;
                        toFontChar[originalCharCode] = fontCharCode;
                    }
                    return {
                        toFontChar: toFontChar,
                        charCodeToGlyphId: newMap,
                        toUnicodeExtraMap: toUnicodeExtraMap,
                        nextAvailableFontCharCode: nextAvailableFontCharCode
                    };
                }
                function getRanges(glyphs, toUnicodeExtraMap, numGlyphs) {
                    const codes = [];
                    for(const charCode in glyphs){
                        if (glyphs[charCode] >= numGlyphs) continue;
                        codes.push({
                            fontCharCode: charCode | 0,
                            glyphId: glyphs[charCode]
                        });
                    }
                    if (toUnicodeExtraMap) for (const [unicode, glyphId] of toUnicodeExtraMap){
                        if (glyphId >= numGlyphs) continue;
                        codes.push({
                            fontCharCode: unicode,
                            glyphId: glyphId
                        });
                    }
                    if (codes.length === 0) codes.push({
                        fontCharCode: 0,
                        glyphId: 0
                    });
                    codes.sort(function fontGetRangesSort(a, b) {
                        return a.fontCharCode - b.fontCharCode;
                    });
                    const ranges = [];
                    const length = codes.length;
                    for(let n = 0; n < length;){
                        const start = codes[n].fontCharCode;
                        const codeIndices = [
                            codes[n].glyphId
                        ];
                        ++n;
                        let end = start;
                        while(n < length && end + 1 === codes[n].fontCharCode){
                            codeIndices.push(codes[n].glyphId);
                            ++end;
                            ++n;
                            if (end === 0xffff) break;
                        }
                        ranges.push([
                            start,
                            end,
                            codeIndices
                        ]);
                    }
                    return ranges;
                }
                function createCmapTable(glyphs, toUnicodeExtraMap, numGlyphs) {
                    const ranges = getRanges(glyphs, toUnicodeExtraMap, numGlyphs);
                    const numTables = ranges.at(-1)[1] > 0xffff ? 2 : 1;
                    let cmap = "\x00\x00" + string16(numTables) + "\x00\x03" + "\x00\x01" + (0, _util.string32)(4 + numTables * 8);
                    let i, ii, j, jj;
                    for(i = ranges.length - 1; i >= 0; --i){
                        if (ranges[i][0] <= 0xffff) break;
                    }
                    const bmpLength = i + 1;
                    if (ranges[i][0] < 0xffff && ranges[i][1] === 0xffff) ranges[i][1] = 0xfffe;
                    const trailingRangesCount = ranges[i][1] < 0xffff ? 1 : 0;
                    const segCount = bmpLength + trailingRangesCount;
                    const searchParams = _opentype_file_builder.OpenTypeFileBuilder.getSearchParams(segCount, 2);
                    let startCount = "";
                    let endCount = "";
                    let idDeltas = "";
                    let idRangeOffsets = "";
                    let glyphsIds = "";
                    let bias = 0;
                    let range, start, end, codes;
                    for(i = 0, ii = bmpLength; i < ii; i++){
                        range = ranges[i];
                        start = range[0];
                        end = range[1];
                        startCount += string16(start);
                        endCount += string16(end);
                        codes = range[2];
                        let contiguous = true;
                        for(j = 1, jj = codes.length; j < jj; ++j)if (codes[j] !== codes[j - 1] + 1) {
                            contiguous = false;
                            break;
                        }
                        if (!contiguous) {
                            const offset = (segCount - i) * 2 + bias * 2;
                            bias += end - start + 1;
                            idDeltas += string16(0);
                            idRangeOffsets += string16(offset);
                            for(j = 0, jj = codes.length; j < jj; ++j)glyphsIds += string16(codes[j]);
                        } else {
                            const startCode = codes[0];
                            idDeltas += string16(startCode - start & 0xffff);
                            idRangeOffsets += string16(0);
                        }
                    }
                    if (trailingRangesCount > 0) {
                        endCount += "\xFF\xFF";
                        startCount += "\xFF\xFF";
                        idDeltas += "\x00\x01";
                        idRangeOffsets += "\x00\x00";
                    }
                    const format314 = "\x00\x00" + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + "\x00\x00" + startCount + idDeltas + idRangeOffsets + glyphsIds;
                    let format31012 = "";
                    let header31012 = "";
                    if (numTables > 1) {
                        cmap += "\0\x03\0\n" + (0, _util.string32)(4 + numTables * 8 + 4 + format314.length);
                        format31012 = "";
                        for(i = 0, ii = ranges.length; i < ii; i++){
                            range = ranges[i];
                            start = range[0];
                            codes = range[2];
                            let code = codes[0];
                            for(j = 1, jj = codes.length; j < jj; ++j)if (codes[j] !== codes[j - 1] + 1) {
                                end = range[0] + j - 1;
                                format31012 += (0, _util.string32)(start) + (0, _util.string32)(end) + (0, _util.string32)(code);
                                start = end + 1;
                                code = codes[j];
                            }
                            format31012 += (0, _util.string32)(start) + (0, _util.string32)(range[1]) + (0, _util.string32)(code);
                        }
                        header31012 = "\0\f\0\0" + (0, _util.string32)(format31012.length + 16) + "\x00\x00\x00\x00" + (0, _util.string32)(format31012.length / 12);
                    }
                    return cmap + "\x00\x04" + string16(format314.length + 4) + format314 + header31012 + format31012;
                }
                function validateOS2Table(os2, file) {
                    file.pos = (file.start || 0) + os2.offset;
                    const version = file.getUint16();
                    file.skip(60);
                    const selection = file.getUint16();
                    if (version < 4 && selection & 0x0300) return false;
                    const firstChar = file.getUint16();
                    const lastChar = file.getUint16();
                    if (firstChar > lastChar) return false;
                    file.skip(6);
                    const usWinAscent = file.getUint16();
                    if (usWinAscent === 0) return false;
                    os2.data[8] = os2.data[9] = 0;
                    return true;
                }
                function createOS2Table(properties, charstrings, override) {
                    override ||= {
                        unitsPerEm: 0,
                        yMax: 0,
                        yMin: 0,
                        ascent: 0,
                        descent: 0
                    };
                    let ulUnicodeRange1 = 0;
                    let ulUnicodeRange2 = 0;
                    let ulUnicodeRange3 = 0;
                    let ulUnicodeRange4 = 0;
                    let firstCharIndex = null;
                    let lastCharIndex = 0;
                    let position = -1;
                    if (charstrings) {
                        for(let code in charstrings){
                            code |= 0;
                            if (firstCharIndex > code || !firstCharIndex) firstCharIndex = code;
                            if (lastCharIndex < code) lastCharIndex = code;
                            position = (0, _unicode.getUnicodeRangeFor)(code, position);
                            if (position < 32) ulUnicodeRange1 |= 1 << position;
                            else if (position < 64) ulUnicodeRange2 |= 1 << position - 32;
                            else if (position < 96) ulUnicodeRange3 |= 1 << position - 64;
                            else if (position < 123) ulUnicodeRange4 |= 1 << position - 96;
                            else throw new _util.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
                        }
                        if (lastCharIndex > 0xffff) lastCharIndex = 0xffff;
                    } else {
                        firstCharIndex = 0;
                        lastCharIndex = 255;
                    }
                    const bbox = properties.bbox || [
                        0,
                        0,
                        0,
                        0
                    ];
                    const unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
                    const scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
                    const typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
                    let typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
                    if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) typoDescent = -typoDescent;
                    const winAscent = override.yMax || typoAscent;
                    const winDescent = -override.yMin || -typoDescent;
                    return "\0\x03\x02$\x01\xf4\0\x05\0\0\x02\x8a\x02\xbb\0\0\0\x8c\x02\x8a\x02\xbb\0\0\x01\xdf\x001\x01\x02\0\0\0\0\x06" + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + "\x00\x00\x00\x00\x00\x00" + (0, _util.string32)(ulUnicodeRange1) + (0, _util.string32)(ulUnicodeRange2) + (0, _util.string32)(ulUnicodeRange3) + (0, _util.string32)(ulUnicodeRange4) + "\x2A\x32\x31\x2A" + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + "\x00\x64" + string16(winAscent) + string16(winDescent) + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + "\x00\x03";
                }
                function createPostTable(properties) {
                    const angle = Math.floor(properties.italicAngle * 2 ** 16);
                    return "\x00\x03\x00\x00" + (0, _util.string32)(angle) + "\x00\x00" + "\x00\x00" + (0, _util.string32)(properties.fixedPitch ? 1 : 0) + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + "\x00\x00\x00\x00";
                }
                function createPostscriptName(name) {
                    return name.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
                }
                function createNameTable(name, proto) {
                    if (!proto) proto = [
                        [],
                        []
                    ];
                    const strings = [
                        proto[0][0] || "Original licence",
                        proto[0][1] || name,
                        proto[0][2] || "Unknown",
                        proto[0][3] || "uniqueID",
                        proto[0][4] || name,
                        proto[0][5] || "Version 0.11",
                        proto[0][6] || createPostscriptName(name),
                        proto[0][7] || "Unknown",
                        proto[0][8] || "Unknown",
                        proto[0][9] || "Unknown"
                    ];
                    const stringsUnicode = [];
                    let i, ii, j, jj, str;
                    for(i = 0, ii = strings.length; i < ii; i++){
                        str = proto[1][i] || strings[i];
                        const strBufUnicode = [];
                        for(j = 0, jj = str.length; j < jj; j++)strBufUnicode.push(string16(str.charCodeAt(j)));
                        stringsUnicode.push(strBufUnicode.join(""));
                    }
                    const names = [
                        strings,
                        stringsUnicode
                    ];
                    const platforms = [
                        "\x00\x01",
                        "\x00\x03"
                    ];
                    const encodings = [
                        "\x00\x00",
                        "\x00\x01"
                    ];
                    const languages = [
                        "\x00\x00",
                        "\x04\x09"
                    ];
                    const namesRecordCount = strings.length * platforms.length;
                    let nameTable = "\x00\x00" + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
                    let strOffset = 0;
                    for(i = 0, ii = platforms.length; i < ii; i++){
                        const strs = names[i];
                        for(j = 0, jj = strs.length; j < jj; j++){
                            str = strs[j];
                            const nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
                            nameTable += nameRecord;
                            strOffset += str.length;
                        }
                    }
                    nameTable += strings.join("") + stringsUnicode.join("");
                    return nameTable;
                }
                class Font {
                    constructor(name, file, properties){
                        this.name = name;
                        this.psName = null;
                        this.mimetype = null;
                        this.disableFontFace = false;
                        this.loadedName = properties.loadedName;
                        this.isType3Font = properties.isType3Font;
                        this.missingFile = false;
                        this.cssFontInfo = properties.cssFontInfo;
                        this._charsCache = Object.create(null);
                        this._glyphCache = Object.create(null);
                        let isSerifFont = !!(properties.flags & _fonts_utils.FontFlags.Serif);
                        if (!isSerifFont && !properties.isSimulatedFlags) {
                            const baseName = name.replaceAll(/[,_]/g, "-").split("-")[0], serifFonts = (0, _standard_fonts.getSerifFonts)();
                            for (const namePart of baseName.split("+"))if (serifFonts[namePart]) {
                                isSerifFont = true;
                                break;
                            }
                        }
                        this.isSerifFont = isSerifFont;
                        this.isSymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Symbolic);
                        this.isMonospace = !!(properties.flags & _fonts_utils.FontFlags.FixedPitch);
                        let { type: type, subtype: subtype } = properties;
                        this.type = type;
                        this.subtype = subtype;
                        this.systemFontInfo = properties.systemFontInfo;
                        const matches = name.match(/^InvalidPDFjsFont_(.*)_\d+$/);
                        this.isInvalidPDFjsFont = !!matches;
                        if (this.isInvalidPDFjsFont) this.fallbackName = matches[1];
                        else if (this.isMonospace) this.fallbackName = "monospace";
                        else if (this.isSerifFont) this.fallbackName = "serif";
                        else this.fallbackName = "sans-serif";
                        if (this.systemFontInfo?.guessFallback) {
                            this.systemFontInfo.guessFallback = false;
                            this.systemFontInfo.css += `,${this.fallbackName}`;
                        }
                        this.differences = properties.differences;
                        this.widths = properties.widths;
                        this.defaultWidth = properties.defaultWidth;
                        this.composite = properties.composite;
                        this.cMap = properties.cMap;
                        this.capHeight = properties.capHeight / PDF_GLYPH_SPACE_UNITS;
                        this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
                        this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
                        this.lineHeight = this.ascent - this.descent;
                        this.fontMatrix = properties.fontMatrix;
                        this.bbox = properties.bbox;
                        this.defaultEncoding = properties.defaultEncoding;
                        this.toUnicode = properties.toUnicode;
                        this.toFontChar = [];
                        if (properties.type === "Type3") {
                            for(let charCode = 0; charCode < 256; charCode++)this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
                            return;
                        }
                        this.cidEncoding = properties.cidEncoding || "";
                        this.vertical = !!properties.vertical;
                        if (this.vertical) {
                            this.vmetrics = properties.vmetrics;
                            this.defaultVMetrics = properties.defaultVMetrics;
                        }
                        if (!file || file.isEmpty) {
                            if (file) (0, _util.warn)('Font file is empty in "' + name + '" (' + this.loadedName + ")");
                            this.fallbackToSystemFont(properties);
                            return;
                        }
                        [type, subtype] = getFontFileType(file, properties);
                        if (type !== this.type || subtype !== this.subtype) (0, _util.info)("Inconsistent font file Type/SubType, expected: " + `${this.type}/${this.subtype} but found: ${type}/${subtype}.`);
                        let data;
                        try {
                            switch(type){
                                case "MMType1":
                                    (0, _util.info)("MMType1 font (" + name + "), falling back to Type1.");
                                case "Type1":
                                case "CIDFontType0":
                                    this.mimetype = "font/opentype";
                                    const cff = subtype === "Type1C" || subtype === "CIDFontType0C" ? new _cff_font.CFFFont(file, properties) : new _type1_font.Type1Font(name, file, properties);
                                    adjustWidths(properties);
                                    data = this.convert(name, cff, properties);
                                    break;
                                case "OpenType":
                                case "TrueType":
                                case "CIDFontType2":
                                    this.mimetype = "font/opentype";
                                    data = this.checkAndRepair(name, file, properties);
                                    if (this.isOpenType) {
                                        adjustWidths(properties);
                                        type = "OpenType";
                                    }
                                    break;
                                default:
                                    throw new _util.FormatError(`Font ${type} is not supported`);
                            }
                        } catch (e) {
                            (0, _util.warn)(e);
                            this.fallbackToSystemFont(properties);
                            return;
                        }
                        amendFallbackToUnicode(properties);
                        this.data = data;
                        this.type = type;
                        this.subtype = subtype;
                        this.fontMatrix = properties.fontMatrix;
                        this.widths = properties.widths;
                        this.defaultWidth = properties.defaultWidth;
                        this.toUnicode = properties.toUnicode;
                        this.seacMap = properties.seacMap;
                    }
                    get renderer() {
                        const renderer = _font_renderer.FontRendererFactory.create(this, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        return (0, _util.shadow)(this, "renderer", renderer);
                    }
                    exportData(extraProperties = false) {
                        const exportDataProperties = extraProperties ? [
                            ...EXPORT_DATA_PROPERTIES,
                            ...EXPORT_DATA_EXTRA_PROPERTIES
                        ] : EXPORT_DATA_PROPERTIES;
                        const data = Object.create(null);
                        let property, value;
                        for (property of exportDataProperties){
                            value = this[property];
                            if (value !== undefined) data[property] = value;
                        }
                        return data;
                    }
                    fallbackToSystemFont(properties) {
                        this.missingFile = true;
                        const { name: name, type: type } = this;
                        let fontName = (0, _fonts_utils.normalizeFontName)(name);
                        const stdFontMap = (0, _standard_fonts.getStdFontMap)(), nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
                        const isStandardFont = !!stdFontMap[fontName];
                        const isMappedToStandardFont = !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
                        fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
                        const fontBasicMetricsMap = (0, _metrics.getFontBasicMetrics)();
                        const metrics = fontBasicMetricsMap[fontName];
                        if (metrics) {
                            if (isNaN(this.ascent)) this.ascent = metrics.ascent / PDF_GLYPH_SPACE_UNITS;
                            if (isNaN(this.descent)) this.descent = metrics.descent / PDF_GLYPH_SPACE_UNITS;
                            if (isNaN(this.capHeight)) this.capHeight = metrics.capHeight / PDF_GLYPH_SPACE_UNITS;
                        }
                        this.bold = /bold/gi.test(fontName);
                        this.italic = /oblique|italic/gi.test(fontName);
                        this.black = /Black/g.test(name);
                        const isNarrow = /Narrow/g.test(name);
                        this.remeasure = (!isStandardFont || isNarrow) && Object.keys(this.widths).length > 0;
                        if ((isStandardFont || isMappedToStandardFont) && type === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                            const cidToGidMap = properties.cidToGidMap;
                            const map = [];
                            applyStandardFontGlyphMap(map, (0, _standard_fonts.getGlyphMapForStandardFonts)());
                            if (/Arial-?Black/i.test(name)) applyStandardFontGlyphMap(map, (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)());
                            else if (/Calibri/i.test(name)) applyStandardFontGlyphMap(map, (0, _standard_fonts.getSupplementalGlyphMapForCalibri)());
                            if (cidToGidMap) {
                                for(const charCode in map){
                                    const cid = map[charCode];
                                    if (cidToGidMap[cid] !== undefined) map[+charCode] = cidToGidMap[cid];
                                }
                                if (cidToGidMap.length !== this.toUnicode.length && properties.hasIncludedToUnicodeMap && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                    const cid = map[charCode];
                                    if (cidToGidMap[cid] === undefined) map[+charCode] = unicodeCharCode;
                                });
                            }
                            if (!(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                map[+charCode] = unicodeCharCode;
                            });
                            this.toFontChar = map;
                            this.toUnicode = new _to_unicode_map.ToUnicodeMap(map);
                        } else if (/Symbol/i.test(fontName)) this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                        else if (/Dingbats/i.test(fontName)) this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
                        else if (isStandardFont) {
                            const map = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                            if (type === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                map[+charCode] = unicodeCharCode;
                            });
                            this.toFontChar = map;
                        } else {
                            const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const map = [];
                            this.toUnicode.forEach((charCode, unicodeCharCode)=>{
                                if (!this.composite) {
                                    const glyphName = this.differences[charCode] || this.defaultEncoding[charCode];
                                    const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                                    if (unicode !== -1) unicodeCharCode = unicode;
                                }
                                map[+charCode] = unicodeCharCode;
                            });
                            if (this.composite && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                                if (/Tahoma|Verdana/i.test(name)) applyStandardFontGlyphMap(map, (0, _standard_fonts.getGlyphMapForStandardFonts)());
                            }
                            this.toFontChar = map;
                        }
                        amendFallbackToUnicode(properties);
                        this.loadedName = fontName.split("-")[0];
                    }
                    checkAndRepair(name, font1, properties) {
                        const VALID_TABLES = [
                            "OS/2",
                            "cmap",
                            "head",
                            "hhea",
                            "hmtx",
                            "maxp",
                            "name",
                            "post",
                            "loca",
                            "glyf",
                            "fpgm",
                            "prep",
                            "cvt ",
                            "CFF "
                        ];
                        function readTables(file, numTables) {
                            const tables = Object.create(null);
                            tables["OS/2"] = null;
                            tables.cmap = null;
                            tables.head = null;
                            tables.hhea = null;
                            tables.hmtx = null;
                            tables.maxp = null;
                            tables.name = null;
                            tables.post = null;
                            for(let i = 0; i < numTables; i++){
                                const table = readTableEntry(file);
                                if (!VALID_TABLES.includes(table.tag)) continue;
                                if (table.length === 0) continue;
                                tables[table.tag] = table;
                            }
                            return tables;
                        }
                        function readTableEntry(file) {
                            const tag = file.getString(4);
                            const checksum = file.getInt32() >>> 0;
                            const offset = file.getInt32() >>> 0;
                            const length = file.getInt32() >>> 0;
                            const previousPosition = file.pos;
                            file.pos = file.start || 0;
                            file.skip(offset);
                            const data = file.getBytes(length);
                            file.pos = previousPosition;
                            if (tag === "head") {
                                data[8] = data[9] = data[10] = data[11] = 0;
                                data[17] |= 0x20;
                            }
                            return {
                                tag: tag,
                                checksum: checksum,
                                length: length,
                                offset: offset,
                                data: data
                            };
                        }
                        function readOpenTypeHeader(ttf) {
                            return {
                                version: ttf.getString(4),
                                numTables: ttf.getUint16(),
                                searchRange: ttf.getUint16(),
                                entrySelector: ttf.getUint16(),
                                rangeShift: ttf.getUint16()
                            };
                        }
                        function readTrueTypeCollectionHeader(ttc) {
                            const ttcTag = ttc.getString(4);
                            (0, _util.assert)(ttcTag === "ttcf", "Must be a TrueType Collection font.");
                            const majorVersion = ttc.getUint16();
                            const minorVersion = ttc.getUint16();
                            const numFonts = ttc.getInt32() >>> 0;
                            const offsetTable = [];
                            for(let i = 0; i < numFonts; i++)offsetTable.push(ttc.getInt32() >>> 0);
                            const header = {
                                ttcTag: ttcTag,
                                majorVersion: majorVersion,
                                minorVersion: minorVersion,
                                numFonts: numFonts,
                                offsetTable: offsetTable
                            };
                            switch(majorVersion){
                                case 1:
                                    return header;
                                case 2:
                                    header.dsigTag = ttc.getInt32() >>> 0;
                                    header.dsigLength = ttc.getInt32() >>> 0;
                                    header.dsigOffset = ttc.getInt32() >>> 0;
                                    return header;
                            }
                            throw new _util.FormatError(`Invalid TrueType Collection majorVersion: ${majorVersion}.`);
                        }
                        function readTrueTypeCollectionData(ttc, fontName) {
                            const { numFonts: numFonts, offsetTable: offsetTable } = readTrueTypeCollectionHeader(ttc);
                            const fontNameParts = fontName.split("+");
                            let fallbackData;
                            for(let i = 0; i < numFonts; i++){
                                ttc.pos = (ttc.start || 0) + offsetTable[i];
                                const potentialHeader = readOpenTypeHeader(ttc);
                                const potentialTables = readTables(ttc, potentialHeader.numTables);
                                if (!potentialTables.name) throw new _util.FormatError('TrueType Collection font must contain a "name" table.');
                                const [nameTable] = readNameTable(potentialTables.name);
                                for(let j = 0, jj = nameTable.length; j < jj; j++)for(let k = 0, kk = nameTable[j].length; k < kk; k++){
                                    const nameEntry = nameTable[j][k]?.replaceAll(/\s/g, "");
                                    if (!nameEntry) continue;
                                    if (nameEntry === fontName) return {
                                        header: potentialHeader,
                                        tables: potentialTables
                                    };
                                    if (fontNameParts.length < 2) continue;
                                    for (const part of fontNameParts)if (nameEntry === part) fallbackData = {
                                        name: part,
                                        header: potentialHeader,
                                        tables: potentialTables
                                    };
                                }
                            }
                            if (fallbackData) {
                                (0, _util.warn)(`TrueType Collection does not contain "${fontName}" font, ` + `falling back to "${fallbackData.name}" font instead.`);
                                return {
                                    header: fallbackData.header,
                                    tables: fallbackData.tables
                                };
                            }
                            throw new _util.FormatError(`TrueType Collection does not contain "${fontName}" font.`);
                        }
                        function readCmapTable(cmap, file, isSymbolicFont, hasEncoding) {
                            if (!cmap) {
                                (0, _util.warn)("No cmap table available.");
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            let segment;
                            let start = (file.start || 0) + cmap.offset;
                            file.pos = start;
                            file.skip(2);
                            const numTables = file.getUint16();
                            let potentialTable;
                            let canBreak = false;
                            for(let i = 0; i < numTables; i++){
                                const platformId = file.getUint16();
                                const encodingId = file.getUint16();
                                const offset = file.getInt32() >>> 0;
                                let useTable = false;
                                if (potentialTable?.platformId === platformId && potentialTable?.encodingId === encodingId) continue;
                                if (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 3)) useTable = true;
                                else if (platformId === 1 && encodingId === 0) useTable = true;
                                else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
                                    useTable = true;
                                    if (!isSymbolicFont) canBreak = true;
                                } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
                                    useTable = true;
                                    let correctlySorted = true;
                                    if (i < numTables - 1) {
                                        const nextBytes = file.peekBytes(2), nextPlatformId = int16(nextBytes[0], nextBytes[1]);
                                        if (nextPlatformId < platformId) correctlySorted = false;
                                    }
                                    if (correctlySorted) canBreak = true;
                                }
                                if (useTable) potentialTable = {
                                    platformId: platformId,
                                    encodingId: encodingId,
                                    offset: offset
                                };
                                if (canBreak) break;
                            }
                            if (potentialTable) file.pos = start + potentialTable.offset;
                            if (!potentialTable || file.peekByte() === -1) {
                                (0, _util.warn)("Could not find a preferred cmap table.");
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            const format = file.getUint16();
                            let hasShortCmap = false;
                            const mappings = [];
                            let j, glyphId;
                            if (format === 0) {
                                file.skip(4);
                                for(j = 0; j < 256; j++){
                                    const index = file.getByte();
                                    if (!index) continue;
                                    mappings.push({
                                        charCode: j,
                                        glyphId: index
                                    });
                                }
                                hasShortCmap = true;
                            } else if (format === 2) {
                                file.skip(4);
                                const subHeaderKeys = [];
                                let maxSubHeaderKey = 0;
                                for(let i = 0; i < 256; i++){
                                    const subHeaderKey = file.getUint16() >> 3;
                                    subHeaderKeys.push(subHeaderKey);
                                    maxSubHeaderKey = Math.max(subHeaderKey, maxSubHeaderKey);
                                }
                                const subHeaders = [];
                                for(let i = 0; i <= maxSubHeaderKey; i++)subHeaders.push({
                                    firstCode: file.getUint16(),
                                    entryCount: file.getUint16(),
                                    idDelta: signedInt16(file.getByte(), file.getByte()),
                                    idRangePos: file.pos + file.getUint16()
                                });
                                for(let i = 0; i < 256; i++)if (subHeaderKeys[i] === 0) {
                                    file.pos = subHeaders[0].idRangePos + 2 * i;
                                    glyphId = file.getUint16();
                                    mappings.push({
                                        charCode: i,
                                        glyphId: glyphId
                                    });
                                } else {
                                    const s = subHeaders[subHeaderKeys[i]];
                                    for(j = 0; j < s.entryCount; j++){
                                        const charCode = (i << 8) + j + s.firstCode;
                                        file.pos = s.idRangePos + 2 * j;
                                        glyphId = file.getUint16();
                                        if (glyphId !== 0) glyphId = (glyphId + s.idDelta) % 65536;
                                        mappings.push({
                                            charCode: charCode,
                                            glyphId: glyphId
                                        });
                                    }
                                }
                            } else if (format === 4) {
                                file.skip(4);
                                const segCount = file.getUint16() >> 1;
                                file.skip(6);
                                const segments = [];
                                let segIndex;
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments.push({
                                    end: file.getUint16()
                                });
                                file.skip(2);
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments[segIndex].start = file.getUint16();
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments[segIndex].delta = file.getUint16();
                                let offsetsCount = 0, offsetIndex;
                                for(segIndex = 0; segIndex < segCount; segIndex++){
                                    segment = segments[segIndex];
                                    const rangeOffset = file.getUint16();
                                    if (!rangeOffset) {
                                        segment.offsetIndex = -1;
                                        continue;
                                    }
                                    offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
                                    segment.offsetIndex = offsetIndex;
                                    offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
                                }
                                const offsets = [];
                                for(j = 0; j < offsetsCount; j++)offsets.push(file.getUint16());
                                for(segIndex = 0; segIndex < segCount; segIndex++){
                                    segment = segments[segIndex];
                                    start = segment.start;
                                    const end = segment.end;
                                    const delta = segment.delta;
                                    offsetIndex = segment.offsetIndex;
                                    for(j = start; j <= end; j++){
                                        if (j === 0xffff) continue;
                                        glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
                                        glyphId = glyphId + delta & 0xffff;
                                        mappings.push({
                                            charCode: j,
                                            glyphId: glyphId
                                        });
                                    }
                                }
                            } else if (format === 6) {
                                file.skip(4);
                                const firstCode = file.getUint16();
                                const entryCount = file.getUint16();
                                for(j = 0; j < entryCount; j++){
                                    glyphId = file.getUint16();
                                    const charCode = firstCode + j;
                                    mappings.push({
                                        charCode: charCode,
                                        glyphId: glyphId
                                    });
                                }
                            } else if (format === 12) {
                                file.skip(10);
                                const nGroups = file.getInt32() >>> 0;
                                for(j = 0; j < nGroups; j++){
                                    const startCharCode = file.getInt32() >>> 0;
                                    const endCharCode = file.getInt32() >>> 0;
                                    let glyphCode = file.getInt32() >>> 0;
                                    for(let charCode = startCharCode; charCode <= endCharCode; charCode++)mappings.push({
                                        charCode: charCode,
                                        glyphId: glyphCode++
                                    });
                                }
                            } else {
                                (0, _util.warn)("cmap table has unsupported format: " + format);
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            mappings.sort(function(a, b) {
                                return a.charCode - b.charCode;
                            });
                            for(let i = 1; i < mappings.length; i++)if (mappings[i - 1].charCode === mappings[i].charCode) {
                                mappings.splice(i, 1);
                                i--;
                            }
                            return {
                                platformId: potentialTable.platformId,
                                encodingId: potentialTable.encodingId,
                                mappings: mappings,
                                hasShortCmap: hasShortCmap
                            };
                        }
                        function sanitizeMetrics(file, header, metrics, headTable, numGlyphs, dupFirstEntry) {
                            if (!header) {
                                if (metrics) metrics.data = null;
                                return;
                            }
                            file.pos = (file.start || 0) + header.offset;
                            file.pos += 4;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            const caretOffset = file.getUint16();
                            file.pos += 8;
                            file.pos += 2;
                            let numOfMetrics = file.getUint16();
                            if (caretOffset !== 0) {
                                const macStyle = int16(headTable.data[44], headTable.data[45]);
                                if (!(macStyle & 2)) {
                                    header.data[22] = 0;
                                    header.data[23] = 0;
                                }
                            }
                            if (numOfMetrics > numGlyphs) {
                                (0, _util.info)(`The numOfMetrics (${numOfMetrics}) should not be ` + `greater than the numGlyphs (${numGlyphs}).`);
                                numOfMetrics = numGlyphs;
                                header.data[34] = (numOfMetrics & 0xff00) >> 8;
                                header.data[35] = numOfMetrics & 0x00ff;
                            }
                            const numOfSidebearings = numGlyphs - numOfMetrics;
                            const numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
                            if (numMissing > 0) {
                                const entries = new Uint8Array(metrics.length + numMissing * 2);
                                entries.set(metrics.data);
                                if (dupFirstEntry) {
                                    entries[metrics.length] = metrics.data[2];
                                    entries[metrics.length + 1] = metrics.data[3];
                                }
                                metrics.data = entries;
                            }
                        }
                        function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
                            const glyphProfile = {
                                length: 0,
                                sizeOfInstructions: 0
                            };
                            if (sourceStart < 0 || sourceStart >= source.length || sourceEnd > source.length || sourceEnd - sourceStart <= 12) return glyphProfile;
                            const glyf = source.subarray(sourceStart, sourceEnd);
                            const xMin = signedInt16(glyf[2], glyf[3]);
                            const yMin = signedInt16(glyf[4], glyf[5]);
                            const xMax = signedInt16(glyf[6], glyf[7]);
                            const yMax = signedInt16(glyf[8], glyf[9]);
                            if (xMin > xMax) {
                                writeSignedInt16(glyf, 2, xMax);
                                writeSignedInt16(glyf, 6, xMin);
                            }
                            if (yMin > yMax) {
                                writeSignedInt16(glyf, 4, yMax);
                                writeSignedInt16(glyf, 8, yMin);
                            }
                            const contoursCount = signedInt16(glyf[0], glyf[1]);
                            if (contoursCount < 0) {
                                if (contoursCount < -1) return glyphProfile;
                                dest.set(glyf, destStart);
                                glyphProfile.length = glyf.length;
                                return glyphProfile;
                            }
                            let i, j = 10, flagsCount = 0;
                            for(i = 0; i < contoursCount; i++){
                                const endPoint = glyf[j] << 8 | glyf[j + 1];
                                flagsCount = endPoint + 1;
                                j += 2;
                            }
                            const instructionsStart = j;
                            const instructionsLength = glyf[j] << 8 | glyf[j + 1];
                            glyphProfile.sizeOfInstructions = instructionsLength;
                            j += 2 + instructionsLength;
                            const instructionsEnd = j;
                            let coordinatesLength = 0;
                            for(i = 0; i < flagsCount; i++){
                                const flag = glyf[j++];
                                if (flag & 0xc0) glyf[j - 1] = flag & 0x3f;
                                let xLength = 2;
                                if (flag & 2) xLength = 1;
                                else if (flag & 16) xLength = 0;
                                let yLength = 2;
                                if (flag & 4) yLength = 1;
                                else if (flag & 32) yLength = 0;
                                const xyLength = xLength + yLength;
                                coordinatesLength += xyLength;
                                if (flag & 8) {
                                    const repeat = glyf[j++];
                                    if (repeat === 0) glyf[j - 1] ^= 8;
                                    i += repeat;
                                    coordinatesLength += repeat * xyLength;
                                }
                            }
                            if (coordinatesLength === 0) return glyphProfile;
                            let glyphDataLength = j + coordinatesLength;
                            if (glyphDataLength > glyf.length) return glyphProfile;
                            if (!hintsValid && instructionsLength > 0) {
                                dest.set(glyf.subarray(0, instructionsStart), destStart);
                                dest.set([
                                    0,
                                    0
                                ], destStart + instructionsStart);
                                dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
                                glyphDataLength -= instructionsLength;
                                if (glyf.length - glyphDataLength > 3) glyphDataLength = glyphDataLength + 3 & -4;
                                glyphProfile.length = glyphDataLength;
                                return glyphProfile;
                            }
                            if (glyf.length - glyphDataLength > 3) {
                                glyphDataLength = glyphDataLength + 3 & -4;
                                dest.set(glyf.subarray(0, glyphDataLength), destStart);
                                glyphProfile.length = glyphDataLength;
                                return glyphProfile;
                            }
                            dest.set(glyf, destStart);
                            glyphProfile.length = glyf.length;
                            return glyphProfile;
                        }
                        function sanitizeHead(head, numGlyphs, locaLength) {
                            const data = head.data;
                            const version = int32(data[0], data[1], data[2], data[3]);
                            if (version >> 16 !== 1) {
                                (0, _util.info)("Attempting to fix invalid version in head table: " + version);
                                data[0] = 0;
                                data[1] = 1;
                                data[2] = 0;
                                data[3] = 0;
                            }
                            const indexToLocFormat = int16(data[50], data[51]);
                            if (indexToLocFormat < 0 || indexToLocFormat > 1) {
                                (0, _util.info)("Attempting to fix invalid indexToLocFormat in head table: " + indexToLocFormat);
                                const numGlyphsPlusOne = numGlyphs + 1;
                                if (locaLength === numGlyphsPlusOne << 1) {
                                    data[50] = 0;
                                    data[51] = 0;
                                } else if (locaLength === numGlyphsPlusOne << 2) {
                                    data[50] = 0;
                                    data[51] = 1;
                                } else throw new _util.FormatError("Could not fix indexToLocFormat: " + indexToLocFormat);
                            }
                        }
                        function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions) {
                            let itemSize, itemDecode, itemEncode;
                            if (isGlyphLocationsLong) {
                                itemSize = 4;
                                itemDecode = function fontItemDecodeLong(data, offset) {
                                    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
                                };
                                itemEncode = function fontItemEncodeLong(data, offset, value) {
                                    data[offset] = value >>> 24 & 0xff;
                                    data[offset + 1] = value >> 16 & 0xff;
                                    data[offset + 2] = value >> 8 & 0xff;
                                    data[offset + 3] = value & 0xff;
                                };
                            } else {
                                itemSize = 2;
                                itemDecode = function fontItemDecode(data, offset) {
                                    return data[offset] << 9 | data[offset + 1] << 1;
                                };
                                itemEncode = function fontItemEncode(data, offset, value) {
                                    data[offset] = value >> 9 & 0xff;
                                    data[offset + 1] = value >> 1 & 0xff;
                                };
                            }
                            const numGlyphsOut = dupFirstEntry ? numGlyphs + 1 : numGlyphs;
                            const locaDataSize = itemSize * (1 + numGlyphsOut);
                            const locaData = new Uint8Array(locaDataSize);
                            locaData.set(loca.data.subarray(0, locaDataSize));
                            loca.data = locaData;
                            const oldGlyfData = glyf.data;
                            const oldGlyfDataLength = oldGlyfData.length;
                            const newGlyfData = new Uint8Array(oldGlyfDataLength);
                            let i, j;
                            const locaEntries = [];
                            for(i = 0, j = 0; i < numGlyphs + 1; i++, j += itemSize){
                                let offset = itemDecode(locaData, j);
                                if (offset > oldGlyfDataLength) offset = oldGlyfDataLength;
                                locaEntries.push({
                                    index: i,
                                    offset: offset,
                                    endOffset: 0
                                });
                            }
                            locaEntries.sort((a, b)=>{
                                return a.offset - b.offset;
                            });
                            for(i = 0; i < numGlyphs; i++)locaEntries[i].endOffset = locaEntries[i + 1].offset;
                            locaEntries.sort((a, b)=>{
                                return a.index - b.index;
                            });
                            for(i = 0; i < numGlyphs; i++){
                                const { offset: offset, endOffset: endOffset } = locaEntries[i];
                                if (offset !== 0 || endOffset !== 0) break;
                                const nextOffset = locaEntries[i + 1].offset;
                                if (nextOffset === 0) continue;
                                locaEntries[i].endOffset = nextOffset;
                                break;
                            }
                            const missingGlyphs = Object.create(null);
                            let writeOffset = 0;
                            itemEncode(locaData, 0, writeOffset);
                            for(i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize){
                                const glyphProfile = sanitizeGlyph(oldGlyfData, locaEntries[i].offset, locaEntries[i].endOffset, newGlyfData, writeOffset, hintsValid);
                                const newLength = glyphProfile.length;
                                if (newLength === 0) missingGlyphs[i] = true;
                                if (glyphProfile.sizeOfInstructions > maxSizeOfInstructions) maxSizeOfInstructions = glyphProfile.sizeOfInstructions;
                                writeOffset += newLength;
                                itemEncode(locaData, j, writeOffset);
                            }
                            if (writeOffset === 0) {
                                const simpleGlyph = new Uint8Array([
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    49,
                                    0
                                ]);
                                for(i = 0, j = itemSize; i < numGlyphsOut; i++, j += itemSize)itemEncode(locaData, j, simpleGlyph.length);
                                glyf.data = simpleGlyph;
                            } else if (dupFirstEntry) {
                                const firstEntryLength = itemDecode(locaData, itemSize);
                                if (newGlyfData.length > firstEntryLength + writeOffset) glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
                                else {
                                    glyf.data = new Uint8Array(firstEntryLength + writeOffset);
                                    glyf.data.set(newGlyfData.subarray(0, writeOffset));
                                }
                                glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
                                itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
                            } else glyf.data = newGlyfData.subarray(0, writeOffset);
                            return {
                                missingGlyphs: missingGlyphs,
                                maxSizeOfInstructions: maxSizeOfInstructions
                            };
                        }
                        function readPostScriptTable(post, propertiesObj, maxpNumGlyphs) {
                            const start = (font1.start || 0) + post.offset;
                            font1.pos = start;
                            const length = post.length, end = start + length;
                            const version = font1.getInt32();
                            font1.skip(28);
                            let glyphNames;
                            let valid = true;
                            let i;
                            switch(version){
                                case 0x00010000:
                                    glyphNames = _fonts_utils.MacStandardGlyphOrdering;
                                    break;
                                case 0x00020000:
                                    const numGlyphs = font1.getUint16();
                                    if (numGlyphs !== maxpNumGlyphs) {
                                        valid = false;
                                        break;
                                    }
                                    const glyphNameIndexes = [];
                                    for(i = 0; i < numGlyphs; ++i){
                                        const index = font1.getUint16();
                                        if (index >= 32768) {
                                            valid = false;
                                            break;
                                        }
                                        glyphNameIndexes.push(index);
                                    }
                                    if (!valid) break;
                                    const customNames = [], strBuf = [];
                                    while(font1.pos < end){
                                        const stringLength = font1.getByte();
                                        strBuf.length = stringLength;
                                        for(i = 0; i < stringLength; ++i)strBuf[i] = String.fromCharCode(font1.getByte());
                                        customNames.push(strBuf.join(""));
                                    }
                                    glyphNames = [];
                                    for(i = 0; i < numGlyphs; ++i){
                                        const j = glyphNameIndexes[i];
                                        if (j < 258) {
                                            glyphNames.push(_fonts_utils.MacStandardGlyphOrdering[j]);
                                            continue;
                                        }
                                        glyphNames.push(customNames[j - 258]);
                                    }
                                    break;
                                case 0x00030000:
                                    break;
                                default:
                                    (0, _util.warn)("Unknown/unsupported post table version " + version);
                                    valid = false;
                                    if (propertiesObj.defaultEncoding) glyphNames = propertiesObj.defaultEncoding;
                                    break;
                            }
                            propertiesObj.glyphNames = glyphNames;
                            return valid;
                        }
                        function readNameTable(nameTable) {
                            const start = (font1.start || 0) + nameTable.offset;
                            font1.pos = start;
                            const names = [
                                [],
                                []
                            ], records = [];
                            const length = nameTable.length, end = start + length;
                            const format = font1.getUint16();
                            const FORMAT_0_HEADER_LENGTH = 6;
                            if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) return [
                                names,
                                records
                            ];
                            const numRecords = font1.getUint16();
                            const stringsStart = font1.getUint16();
                            const NAME_RECORD_LENGTH = 12;
                            let i, ii;
                            for(i = 0; i < numRecords && font1.pos + NAME_RECORD_LENGTH <= end; i++){
                                const r = {
                                    platform: font1.getUint16(),
                                    encoding: font1.getUint16(),
                                    language: font1.getUint16(),
                                    name: font1.getUint16(),
                                    length: font1.getUint16(),
                                    offset: font1.getUint16()
                                };
                                if (isMacNameRecord(r) || isWinNameRecord(r)) records.push(r);
                            }
                            for(i = 0, ii = records.length; i < ii; i++){
                                const record = records[i];
                                if (record.length <= 0) continue;
                                const pos = start + stringsStart + record.offset;
                                if (pos + record.length > end) continue;
                                font1.pos = pos;
                                const nameIndex = record.name;
                                if (record.encoding) {
                                    let str = "";
                                    for(let j = 0, jj = record.length; j < jj; j += 2)str += String.fromCharCode(font1.getUint16());
                                    names[1][nameIndex] = str;
                                } else names[0][nameIndex] = font1.getString(record.length);
                            }
                            return [
                                names,
                                records
                            ];
                        }
                        const TTOpsStackDeltas = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -2,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            -5,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            1,
                            -1,
                            -999,
                            0,
                            1,
                            0,
                            -1,
                            -2,
                            0,
                            -1,
                            -2,
                            -1,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            0,
                            -999,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -2,
                            -999,
                            -2,
                            -2,
                            -999,
                            0,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            0,
                            -2,
                            0,
                            0,
                            0,
                            -2,
                            -1,
                            -1,
                            1,
                            1,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -999,
                            -999,
                            -999,
                            -999,
                            -999,
                            -1,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -999,
                            -2,
                            -2,
                            0,
                            0,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -2
                        ];
                        function sanitizeTTProgram(table, ttContext) {
                            let data = table.data;
                            let i = 0, j, n, b, funcId, pc, lastEndf = 0, lastDeff = 0;
                            const stack = [];
                            const callstack = [];
                            const functionsCalled = [];
                            let tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
                            let inFDEF = false, ifLevel = 0, inELSE = 0;
                            for(let ii = data.length; i < ii;){
                                const op = data[i++];
                                if (op === 0x40) {
                                    n = data[i++];
                                    if (inFDEF || inELSE) i += n;
                                    else for(j = 0; j < n; j++)stack.push(data[i++]);
                                } else if (op === 0x41) {
                                    n = data[i++];
                                    if (inFDEF || inELSE) i += n * 2;
                                    else for(j = 0; j < n; j++){
                                        b = data[i++];
                                        stack.push(b << 8 | data[i++]);
                                    }
                                } else if ((op & 0xf8) === 0xb0) {
                                    n = op - 0xb0 + 1;
                                    if (inFDEF || inELSE) i += n;
                                    else for(j = 0; j < n; j++)stack.push(data[i++]);
                                } else if ((op & 0xf8) === 0xb8) {
                                    n = op - 0xb8 + 1;
                                    if (inFDEF || inELSE) i += n * 2;
                                    else for(j = 0; j < n; j++){
                                        b = data[i++];
                                        stack.push(b << 8 | data[i++]);
                                    }
                                } else if (op === 0x2b && !tooComplexToFollowFunctions) {
                                    if (!inFDEF && !inELSE) {
                                        funcId = stack.at(-1);
                                        if (isNaN(funcId)) (0, _util.info)("TT: CALL empty stack (or invalid entry).");
                                        else {
                                            ttContext.functionsUsed[funcId] = true;
                                            if (funcId in ttContext.functionsStackDeltas) {
                                                const newStackLength = stack.length + ttContext.functionsStackDeltas[funcId];
                                                if (newStackLength < 0) {
                                                    (0, _util.warn)("TT: CALL invalid functions stack delta.");
                                                    ttContext.hintsValid = false;
                                                    return;
                                                }
                                                stack.length = newStackLength;
                                            } else if (funcId in ttContext.functionsDefined && !functionsCalled.includes(funcId)) {
                                                callstack.push({
                                                    data: data,
                                                    i: i,
                                                    stackTop: stack.length - 1
                                                });
                                                functionsCalled.push(funcId);
                                                pc = ttContext.functionsDefined[funcId];
                                                if (!pc) {
                                                    (0, _util.warn)("TT: CALL non-existent function");
                                                    ttContext.hintsValid = false;
                                                    return;
                                                }
                                                data = pc.data;
                                                i = pc.i;
                                            }
                                        }
                                    }
                                } else if (op === 0x2c && !tooComplexToFollowFunctions) {
                                    if (inFDEF || inELSE) {
                                        (0, _util.warn)("TT: nested FDEFs not allowed");
                                        tooComplexToFollowFunctions = true;
                                    }
                                    inFDEF = true;
                                    lastDeff = i;
                                    funcId = stack.pop();
                                    ttContext.functionsDefined[funcId] = {
                                        data: data,
                                        i: i
                                    };
                                } else if (op === 0x2d) {
                                    if (inFDEF) {
                                        inFDEF = false;
                                        lastEndf = i;
                                    } else {
                                        pc = callstack.pop();
                                        if (!pc) {
                                            (0, _util.warn)("TT: ENDF bad stack");
                                            ttContext.hintsValid = false;
                                            return;
                                        }
                                        funcId = functionsCalled.pop();
                                        data = pc.data;
                                        i = pc.i;
                                        ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
                                    }
                                } else if (op === 0x89) {
                                    if (inFDEF || inELSE) {
                                        (0, _util.warn)("TT: nested IDEFs not allowed");
                                        tooComplexToFollowFunctions = true;
                                    }
                                    inFDEF = true;
                                    lastDeff = i;
                                } else if (op === 0x58) ++ifLevel;
                                else if (op === 0x1b) inELSE = ifLevel;
                                else if (op === 0x59) {
                                    if (inELSE === ifLevel) inELSE = 0;
                                    --ifLevel;
                                } else if (op === 0x1c) {
                                    if (!inFDEF && !inELSE) {
                                        const offset = stack.at(-1);
                                        if (offset > 0) i += offset - 1;
                                    }
                                }
                                if (!inFDEF && !inELSE) {
                                    let stackDelta = 0;
                                    if (op <= 0x8e) stackDelta = TTOpsStackDeltas[op];
                                    else if (op >= 0xc0 && op <= 0xdf) stackDelta = -1;
                                    else if (op >= 0xe0) stackDelta = -2;
                                    if (op >= 0x71 && op <= 0x75) {
                                        n = stack.pop();
                                        if (!isNaN(n)) stackDelta = -n * 2;
                                    }
                                    while(stackDelta < 0 && stack.length > 0){
                                        stack.pop();
                                        stackDelta++;
                                    }
                                    while(stackDelta > 0){
                                        stack.push(NaN);
                                        stackDelta--;
                                    }
                                }
                            }
                            ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
                            const content = [
                                data
                            ];
                            if (i > data.length) content.push(new Uint8Array(i - data.length));
                            if (lastDeff > lastEndf) {
                                (0, _util.warn)("TT: complementing a missing function tail");
                                content.push(new Uint8Array([
                                    0x22,
                                    0x2d
                                ]));
                            }
                            foldTTTable(table, content);
                        }
                        function checkInvalidFunctions(ttContext, maxFunctionDefs) {
                            if (ttContext.tooComplexToFollowFunctions) return;
                            if (ttContext.functionsDefined.length > maxFunctionDefs) {
                                (0, _util.warn)("TT: more functions defined than expected");
                                ttContext.hintsValid = false;
                                return;
                            }
                            for(let j = 0, jj = ttContext.functionsUsed.length; j < jj; j++){
                                if (j > maxFunctionDefs) {
                                    (0, _util.warn)("TT: invalid function id: " + j);
                                    ttContext.hintsValid = false;
                                    return;
                                }
                                if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
                                    (0, _util.warn)("TT: undefined function: " + j);
                                    ttContext.hintsValid = false;
                                    return;
                                }
                            }
                        }
                        function foldTTTable(table, content) {
                            if (content.length > 1) {
                                let newLength = 0;
                                let j, jj;
                                for(j = 0, jj = content.length; j < jj; j++)newLength += content[j].length;
                                newLength = newLength + 3 & -4;
                                const result = new Uint8Array(newLength);
                                let pos = 0;
                                for(j = 0, jj = content.length; j < jj; j++){
                                    result.set(content[j], pos);
                                    pos += content[j].length;
                                }
                                table.data = result;
                                table.length = newLength;
                            }
                        }
                        function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
                            const ttContext = {
                                functionsDefined: [],
                                functionsUsed: [],
                                functionsStackDeltas: [],
                                tooComplexToFollowFunctions: false,
                                hintsValid: true
                            };
                            if (fpgm) sanitizeTTProgram(fpgm, ttContext);
                            if (prep) sanitizeTTProgram(prep, ttContext);
                            if (fpgm) checkInvalidFunctions(ttContext, maxFunctionDefs);
                            if (cvt && cvt.length & 1) {
                                const cvtData = new Uint8Array(cvt.length + 1);
                                cvtData.set(cvt.data);
                                cvt.data = cvtData;
                            }
                            return ttContext.hintsValid;
                        }
                        font1 = new _stream.Stream(new Uint8Array(font1.getBytes()));
                        let header, tables;
                        if (isTrueTypeCollectionFile(font1)) {
                            const ttcData = readTrueTypeCollectionData(font1, this.name);
                            header = ttcData.header;
                            tables = ttcData.tables;
                        } else {
                            header = readOpenTypeHeader(font1);
                            tables = readTables(font1, header.numTables);
                        }
                        let cff, cffFile;
                        const isTrueType = !tables["CFF "];
                        if (!isTrueType) {
                            const isComposite = properties.composite && (properties.cidToGidMap?.length > 0 || !(properties.cMap instanceof _cmap.IdentityCMap));
                            if (header.version === "OTTO" && !isComposite || !tables.head || !tables.hhea || !tables.maxp || !tables.post) {
                                cffFile = new _stream.Stream(tables["CFF "].data);
                                cff = new _cff_font.CFFFont(cffFile, properties);
                                adjustWidths(properties);
                                return this.convert(name, cff, properties);
                            }
                            delete tables.glyf;
                            delete tables.loca;
                            delete tables.fpgm;
                            delete tables.prep;
                            delete tables["cvt "];
                            this.isOpenType = true;
                        } else {
                            if (!tables.loca) throw new _util.FormatError('Required "loca" table is not found');
                            if (!tables.glyf) {
                                (0, _util.warn)('Required "glyf" table is not found -- trying to recover.');
                                tables.glyf = {
                                    tag: "glyf",
                                    data: new Uint8Array(0)
                                };
                            }
                            this.isOpenType = false;
                        }
                        if (!tables.maxp) throw new _util.FormatError('Required "maxp" table is not found');
                        font1.pos = (font1.start || 0) + tables.maxp.offset;
                        const version = font1.getInt32();
                        const numGlyphs = font1.getUint16();
                        if (properties.scaleFactors?.length === numGlyphs && isTrueType) {
                            const { scaleFactors: scaleFactors } = properties;
                            const isGlyphLocationsLong = int16(tables.head.data[50], tables.head.data[51]);
                            const glyphs = new _glyf.GlyfTable({
                                glyfTable: tables.glyf.data,
                                isGlyphLocationsLong: isGlyphLocationsLong,
                                locaTable: tables.loca.data,
                                numGlyphs: numGlyphs
                            });
                            glyphs.scale(scaleFactors);
                            const { glyf: glyf, loca: loca, isLocationLong: isLocationLong } = glyphs.write();
                            tables.glyf.data = glyf;
                            tables.loca.data = loca;
                            if (isLocationLong !== !!isGlyphLocationsLong) {
                                tables.head.data[50] = 0;
                                tables.head.data[51] = isLocationLong ? 1 : 0;
                            }
                            const metrics = tables.hmtx.data;
                            for(let i = 0; i < numGlyphs; i++){
                                const j = 4 * i;
                                const advanceWidth = Math.round(scaleFactors[i] * int16(metrics[j], metrics[j + 1]));
                                metrics[j] = advanceWidth >> 8 & 0xff;
                                metrics[j + 1] = advanceWidth & 0xff;
                                const lsb = Math.round(scaleFactors[i] * signedInt16(metrics[j + 2], metrics[j + 3]));
                                writeSignedInt16(metrics, j + 2, lsb);
                            }
                        }
                        let numGlyphsOut = numGlyphs + 1;
                        let dupFirstEntry = true;
                        if (numGlyphsOut > 0xffff) {
                            dupFirstEntry = false;
                            numGlyphsOut = numGlyphs;
                            (0, _util.warn)("Not enough space in glyfs to duplicate first glyph.");
                        }
                        let maxFunctionDefs = 0;
                        let maxSizeOfInstructions = 0;
                        if (version >= 0x00010000 && tables.maxp.length >= 22) {
                            font1.pos += 8;
                            const maxZones = font1.getUint16();
                            if (maxZones > 2) {
                                tables.maxp.data[14] = 0;
                                tables.maxp.data[15] = 2;
                            }
                            font1.pos += 4;
                            maxFunctionDefs = font1.getUint16();
                            font1.pos += 4;
                            maxSizeOfInstructions = font1.getUint16();
                        }
                        tables.maxp.data[4] = numGlyphsOut >> 8;
                        tables.maxp.data[5] = numGlyphsOut & 255;
                        const hintsValid = sanitizeTTPrograms(tables.fpgm, tables.prep, tables["cvt "], maxFunctionDefs);
                        if (!hintsValid) {
                            delete tables.fpgm;
                            delete tables.prep;
                            delete tables["cvt "];
                        }
                        sanitizeMetrics(font1, tables.hhea, tables.hmtx, tables.head, numGlyphsOut, dupFirstEntry);
                        if (!tables.head) throw new _util.FormatError('Required "head" table is not found');
                        sanitizeHead(tables.head, numGlyphs, isTrueType ? tables.loca.length : 0);
                        let missingGlyphs = Object.create(null);
                        if (isTrueType) {
                            const isGlyphLocationsLong = int16(tables.head.data[50], tables.head.data[51]);
                            const glyphsInfo = sanitizeGlyphLocations(tables.loca, tables.glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions);
                            missingGlyphs = glyphsInfo.missingGlyphs;
                            if (version >= 0x00010000 && tables.maxp.length >= 22) {
                                tables.maxp.data[26] = glyphsInfo.maxSizeOfInstructions >> 8;
                                tables.maxp.data[27] = glyphsInfo.maxSizeOfInstructions & 255;
                            }
                        }
                        if (!tables.hhea) throw new _util.FormatError('Required "hhea" table is not found');
                        if (tables.hhea.data[10] === 0 && tables.hhea.data[11] === 0) {
                            tables.hhea.data[10] = 0xff;
                            tables.hhea.data[11] = 0xff;
                        }
                        const metricsOverride = {
                            unitsPerEm: int16(tables.head.data[18], tables.head.data[19]),
                            yMax: signedInt16(tables.head.data[42], tables.head.data[43]),
                            yMin: signedInt16(tables.head.data[38], tables.head.data[39]),
                            ascent: signedInt16(tables.hhea.data[4], tables.hhea.data[5]),
                            descent: signedInt16(tables.hhea.data[6], tables.hhea.data[7]),
                            lineGap: signedInt16(tables.hhea.data[8], tables.hhea.data[9])
                        };
                        this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
                        this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
                        this.lineGap = metricsOverride.lineGap / metricsOverride.unitsPerEm;
                        if (this.cssFontInfo?.lineHeight) {
                            this.lineHeight = this.cssFontInfo.metrics.lineHeight;
                            this.lineGap = this.cssFontInfo.metrics.lineGap;
                        } else this.lineHeight = this.ascent - this.descent + this.lineGap;
                        if (tables.post) readPostScriptTable(tables.post, properties, numGlyphs);
                        tables.post = {
                            tag: "post",
                            data: createPostTable(properties)
                        };
                        const charCodeToGlyphId = [];
                        function hasGlyph(glyphId) {
                            return !missingGlyphs[glyphId];
                        }
                        if (properties.composite) {
                            const cidToGidMap = properties.cidToGidMap || [];
                            const isCidToGidMapEmpty = cidToGidMap.length === 0;
                            properties.cMap.forEach(function(charCode, cid) {
                                if (typeof cid === "string") cid = convertCidString(charCode, cid, true);
                                if (cid > 0xffff) throw new _util.FormatError("Max size of CID is 65,535");
                                let glyphId = -1;
                                if (isCidToGidMapEmpty) glyphId = cid;
                                else if (cidToGidMap[cid] !== undefined) glyphId = cidToGidMap[cid];
                                if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) charCodeToGlyphId[charCode] = glyphId;
                            });
                        } else {
                            const cmapTable = readCmapTable(tables.cmap, font1, this.isSymbolicFont, properties.hasEncoding);
                            const cmapPlatformId = cmapTable.platformId;
                            const cmapEncodingId = cmapTable.encodingId;
                            const cmapMappings = cmapTable.mappings;
                            let baseEncoding = [], forcePostTable = false;
                            if (properties.hasEncoding && (properties.baseEncodingName === "MacRomanEncoding" || properties.baseEncodingName === "WinAnsiEncoding")) baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                            if (properties.hasEncoding && !this.isSymbolicFont && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0)) {
                                const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                                for(let charCode = 0; charCode < 256; charCode++){
                                    let glyphName;
                                    if (this.differences[charCode] !== undefined) glyphName = this.differences[charCode];
                                    else if (baseEncoding.length && baseEncoding[charCode] !== "") glyphName = baseEncoding[charCode];
                                    else glyphName = _encodings.StandardEncoding[charCode];
                                    if (!glyphName) continue;
                                    const standardGlyphName = (0, _fonts_utils.recoverGlyphName)(glyphName, glyphsUnicodeMap);
                                    let unicodeOrCharCode;
                                    if (cmapPlatformId === 3 && cmapEncodingId === 1) unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
                                    else if (cmapPlatformId === 1 && cmapEncodingId === 0) unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
                                    if (unicodeOrCharCode === undefined) {
                                        if (!properties.glyphNames && properties.hasIncludedToUnicodeMap && !(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) {
                                            const unicode = this.toUnicode.get(charCode);
                                            if (unicode) unicodeOrCharCode = unicode.codePointAt(0);
                                        }
                                        if (unicodeOrCharCode === undefined) continue;
                                    }
                                    for (const mapping of cmapMappings){
                                        if (mapping.charCode !== unicodeOrCharCode) continue;
                                        charCodeToGlyphId[charCode] = mapping.glyphId;
                                        break;
                                    }
                                }
                            } else if (cmapPlatformId === 0) {
                                for (const mapping of cmapMappings)charCodeToGlyphId[mapping.charCode] = mapping.glyphId;
                                forcePostTable = true;
                            } else for (const mapping of cmapMappings){
                                let charCode = mapping.charCode;
                                if (cmapPlatformId === 3 && charCode >= 0xf000 && charCode <= 0xf0ff) charCode &= 0xff;
                                charCodeToGlyphId[charCode] = mapping.glyphId;
                            }
                            if (properties.glyphNames && (baseEncoding.length || this.differences.length)) for(let i = 0; i < 256; ++i){
                                if (!forcePostTable && charCodeToGlyphId[i] !== undefined) continue;
                                const glyphName = this.differences[i] || baseEncoding[i];
                                if (!glyphName) continue;
                                const glyphId = properties.glyphNames.indexOf(glyphName);
                                if (glyphId > 0 && hasGlyph(glyphId)) charCodeToGlyphId[i] = glyphId;
                            }
                        }
                        if (charCodeToGlyphId.length === 0) charCodeToGlyphId[0] = 0;
                        let glyphZeroId = numGlyphsOut - 1;
                        if (!dupFirstEntry) glyphZeroId = 0;
                        if (!properties.cssFontInfo) {
                            const newMapping = adjustMapping(charCodeToGlyphId, hasGlyph, glyphZeroId, this.toUnicode);
                            this.toFontChar = newMapping.toFontChar;
                            tables.cmap = {
                                tag: "cmap",
                                data: createCmapTable(newMapping.charCodeToGlyphId, newMapping.toUnicodeExtraMap, numGlyphsOut)
                            };
                            if (!tables["OS/2"] || !validateOS2Table(tables["OS/2"], font1)) tables["OS/2"] = {
                                tag: "OS/2",
                                data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
                            };
                        }
                        if (!isTrueType) try {
                            cffFile = new _stream.Stream(tables["CFF "].data);
                            const parser = new _cff_parser.CFFParser(cffFile, properties, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                            cff = parser.parse();
                            cff.duplicateFirstGlyph();
                            const compiler = new _cff_parser.CFFCompiler(cff);
                            tables["CFF "].data = compiler.compile();
                        } catch  {
                            (0, _util.warn)("Failed to compile font " + properties.loadedName);
                        }
                        if (!tables.name) tables.name = {
                            tag: "name",
                            data: createNameTable(this.name)
                        };
                        else {
                            const [namePrototype, nameRecords] = readNameTable(tables.name);
                            tables.name.data = createNameTable(name, namePrototype);
                            this.psName = namePrototype[0][6] || null;
                            if (!properties.composite) adjustTrueTypeToUnicode(properties, this.isSymbolicFont, nameRecords);
                        }
                        const builder = new _opentype_file_builder.OpenTypeFileBuilder(header.version);
                        for(const tableTag in tables)builder.addTable(tableTag, tables[tableTag].data);
                        return builder.toArray();
                    }
                    convert(fontName, font1, properties) {
                        properties.fixedPitch = false;
                        if (properties.builtInEncoding) adjustType1ToUnicode(properties, properties.builtInEncoding);
                        let glyphZeroId = 1;
                        if (font1 instanceof _cff_font.CFFFont) glyphZeroId = font1.numGlyphs - 1;
                        const mapping = font1.getGlyphMapping(properties);
                        let newMapping = null;
                        let newCharCodeToGlyphId = mapping;
                        let toUnicodeExtraMap = null;
                        if (!properties.cssFontInfo) {
                            newMapping = adjustMapping(mapping, font1.hasGlyphId.bind(font1), glyphZeroId, this.toUnicode);
                            this.toFontChar = newMapping.toFontChar;
                            newCharCodeToGlyphId = newMapping.charCodeToGlyphId;
                            toUnicodeExtraMap = newMapping.toUnicodeExtraMap;
                        }
                        const numGlyphs = font1.numGlyphs;
                        function getCharCodes(charCodeToGlyphId, glyphId) {
                            let charCodes = null;
                            for(const charCode in charCodeToGlyphId)if (glyphId === charCodeToGlyphId[charCode]) (charCodes ||= []).push(charCode | 0);
                            return charCodes;
                        }
                        function createCharCode(charCodeToGlyphId, glyphId) {
                            for(const charCode in charCodeToGlyphId){
                                if (glyphId === charCodeToGlyphId[charCode]) return charCode | 0;
                            }
                            newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
                            return newMapping.nextAvailableFontCharCode++;
                        }
                        const seacs = font1.seacs;
                        if (newMapping && _fonts_utils.SEAC_ANALYSIS_ENABLED && seacs?.length) {
                            const matrix = properties.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                            const charset = font1.getCharset();
                            const seacMap = Object.create(null);
                            for(let glyphId in seacs){
                                glyphId |= 0;
                                const seac = seacs[glyphId];
                                const baseGlyphName = _encodings.StandardEncoding[seac[2]];
                                const accentGlyphName = _encodings.StandardEncoding[seac[3]];
                                const baseGlyphId = charset.indexOf(baseGlyphName);
                                const accentGlyphId = charset.indexOf(accentGlyphName);
                                if (baseGlyphId < 0 || accentGlyphId < 0) continue;
                                const accentOffset = {
                                    x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
                                    y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
                                };
                                const charCodes = getCharCodes(mapping, glyphId);
                                if (!charCodes) continue;
                                for (const charCode of charCodes){
                                    const charCodeToGlyphId = newMapping.charCodeToGlyphId;
                                    const baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
                                    const accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
                                    seacMap[charCode] = {
                                        baseFontCharCode: baseFontCharCode,
                                        accentFontCharCode: accentFontCharCode,
                                        accentOffset: accentOffset
                                    };
                                }
                            }
                            properties.seacMap = seacMap;
                        }
                        const unitsPerEm = 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
                        const builder = new _opentype_file_builder.OpenTypeFileBuilder("\x4F\x54\x54\x4F");
                        builder.addTable("CFF ", font1.data);
                        builder.addTable("OS/2", createOS2Table(properties, newCharCodeToGlyphId));
                        builder.addTable("cmap", createCmapTable(newCharCodeToGlyphId, toUnicodeExtraMap, numGlyphs));
                        builder.addTable("head", "\0\x01\0\0\0\0\x10\0\0\0\0\0_\x0f<\xf5\0\0" + safeString16(unitsPerEm) + "\x00\x00\x00\x00\x9e\x0b\x7e\x27" + "\x00\x00\x00\x00\x9e\x0b\x7e\x27" + "\x00\x00" + safeString16(properties.descent) + "\x0F\xFF" + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + "\x00\x11" + "\x00\x00" + "\x00\x00" + "\x00\x00");
                        builder.addTable("hhea", "\x00\x01\x00\x00" + safeString16(properties.ascent) + safeString16(properties.descent) + "\x00\x00" + "\xFF\xFF" + "\x00\x00" + "\x00\x00" + "\x00\x00" + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + string16(numGlyphs));
                        builder.addTable("hmtx", function fontFieldsHmtx() {
                            const charstrings = font1.charstrings;
                            const cffWidths = font1.cff ? font1.cff.widths : null;
                            let hmtx = "\x00\x00\x00\x00";
                            for(let i = 1, ii = numGlyphs; i < ii; i++){
                                let width = 0;
                                if (charstrings) {
                                    const charstring = charstrings[i - 1];
                                    width = "width" in charstring ? charstring.width : 0;
                                } else if (cffWidths) width = Math.ceil(cffWidths[i] || 0);
                                hmtx += string16(width) + string16(0);
                            }
                            return hmtx;
                        }());
                        builder.addTable("maxp", "\x00\x00\x50\x00" + string16(numGlyphs));
                        builder.addTable("name", createNameTable(fontName));
                        builder.addTable("post", createPostTable(properties));
                        return builder.toArray();
                    }
                    get spaceWidth() {
                        const possibleSpaceReplacements = [
                            "space",
                            "minus",
                            "one",
                            "i",
                            "I"
                        ];
                        let width;
                        for (const glyphName of possibleSpaceReplacements){
                            if (glyphName in this.widths) {
                                width = this.widths[glyphName];
                                break;
                            }
                            const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const glyphUnicode = glyphsUnicodeMap[glyphName];
                            let charcode = 0;
                            if (this.composite && this.cMap.contains(glyphUnicode)) {
                                charcode = this.cMap.lookup(glyphUnicode);
                                if (typeof charcode === "string") charcode = convertCidString(glyphUnicode, charcode);
                            }
                            if (!charcode && this.toUnicode) charcode = this.toUnicode.charCodeOf(glyphUnicode);
                            if (charcode <= 0) charcode = glyphUnicode;
                            width = this.widths[charcode];
                            if (width) break;
                        }
                        return (0, _util.shadow)(this, "spaceWidth", width || this.defaultWidth);
                    }
                    _charToGlyph(charcode, isSpace = false) {
                        let glyph = this._glyphCache[charcode];
                        if (glyph?.isSpace === isSpace) return glyph;
                        let fontCharCode, width, operatorListId;
                        let widthCode = charcode;
                        if (this.cMap?.contains(charcode)) {
                            widthCode = this.cMap.lookup(charcode);
                            if (typeof widthCode === "string") widthCode = convertCidString(charcode, widthCode);
                        }
                        width = this.widths[widthCode];
                        if (typeof width !== "number") width = this.defaultWidth;
                        const vmetric = this.vmetrics?.[widthCode];
                        let unicode = this.toUnicode.get(charcode) || charcode;
                        if (typeof unicode === "number") unicode = String.fromCharCode(unicode);
                        let isInFont = this.toFontChar[charcode] !== undefined;
                        fontCharCode = this.toFontChar[charcode] || charcode;
                        if (this.missingFile) {
                            const glyphName = this.differences[charcode] || this.defaultEncoding[charcode];
                            if ((glyphName === ".notdef" || glyphName === "") && this.type === "Type1") fontCharCode = 0x20;
                            fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
                        }
                        if (this.isType3Font) operatorListId = fontCharCode;
                        let accent = null;
                        if (this.seacMap?.[charcode]) {
                            isInFont = true;
                            const seac = this.seacMap[charcode];
                            fontCharCode = seac.baseFontCharCode;
                            accent = {
                                fontChar: String.fromCodePoint(seac.accentFontCharCode),
                                offset: seac.accentOffset
                            };
                        }
                        let fontChar = "";
                        if (typeof fontCharCode === "number") {
                            if (fontCharCode <= 0x10ffff) fontChar = String.fromCodePoint(fontCharCode);
                            else (0, _util.warn)(`charToGlyph - invalid fontCharCode: ${fontCharCode}`);
                        }
                        glyph = new Glyph(charcode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
                        return this._glyphCache[charcode] = glyph;
                    }
                    charsToGlyphs(chars) {
                        let glyphs = this._charsCache[chars];
                        if (glyphs) return glyphs;
                        glyphs = [];
                        if (this.cMap) {
                            const c = Object.create(null), ii = chars.length;
                            let i = 0;
                            while(i < ii){
                                this.cMap.readCharCode(chars, i, c);
                                const { charcode: charcode, length: length } = c;
                                i += length;
                                const glyph = this._charToGlyph(charcode, length === 1 && chars.charCodeAt(i - 1) === 0x20);
                                glyphs.push(glyph);
                            }
                        } else for(let i = 0, ii = chars.length; i < ii; ++i){
                            const charcode = chars.charCodeAt(i);
                            const glyph = this._charToGlyph(charcode, charcode === 0x20);
                            glyphs.push(glyph);
                        }
                        return this._charsCache[chars] = glyphs;
                    }
                    getCharPositions(chars) {
                        const positions = [];
                        if (this.cMap) {
                            const c = Object.create(null);
                            let i = 0;
                            while(i < chars.length){
                                this.cMap.readCharCode(chars, i, c);
                                const length = c.length;
                                positions.push([
                                    i,
                                    i + length
                                ]);
                                i += length;
                            }
                        } else for(let i = 0, ii = chars.length; i < ii; ++i)positions.push([
                            i,
                            i + 1
                        ]);
                        return positions;
                    }
                    get glyphCacheValues() {
                        return Object.values(this._glyphCache);
                    }
                    encodeString(str) {
                        const buffers = [];
                        const currentBuf = [];
                        const hasCurrentBufErrors = ()=>buffers.length % 2 === 1;
                        const getCharCode = this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap ? (unicode)=>this.toUnicode.charCodeOf(unicode) : (unicode)=>this.toUnicode.charCodeOf(String.fromCodePoint(unicode));
                        for(let i = 0, ii = str.length; i < ii; i++){
                            const unicode = str.codePointAt(i);
                            if (unicode > 0xd7ff && (unicode < 0xe000 || unicode > 0xfffd)) i++;
                            if (this.toUnicode) {
                                const charCode = getCharCode(unicode);
                                if (charCode !== -1) {
                                    if (hasCurrentBufErrors()) {
                                        buffers.push(currentBuf.join(""));
                                        currentBuf.length = 0;
                                    }
                                    const charCodeLength = this.cMap ? this.cMap.getCharCodeLength(charCode) : 1;
                                    for(let j = charCodeLength - 1; j >= 0; j--)currentBuf.push(String.fromCharCode(charCode >> 8 * j & 0xff));
                                    continue;
                                }
                            }
                            if (!hasCurrentBufErrors()) {
                                buffers.push(currentBuf.join(""));
                                currentBuf.length = 0;
                            }
                            currentBuf.push(String.fromCodePoint(unicode));
                        }
                        buffers.push(currentBuf.join(""));
                        return buffers;
                    }
                }
                exports.Font = Font;
                class ErrorFont {
                    constructor(error){
                        this.error = error;
                        this.loadedName = "g_font_error";
                        this.missingFile = true;
                    }
                    charsToGlyphs() {
                        return [];
                    }
                    encodeString(chars) {
                        return [
                            chars
                        ];
                    }
                    exportData(extraProperties = false) {
                        return {
                            error: this.error
                        };
                    }
                }
                exports.ErrorFont = ErrorFont;
            /***/ },
            /* 35 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CFFTopDict = exports.CFFStrings = exports.CFFStandardStrings = exports.CFFPrivateDict = exports.CFFParser = exports.CFFIndex = exports.CFFHeader = exports.CFFFDSelect = exports.CFFCompiler = exports.CFFCharset = exports.CFF = void 0;
                var _util = __w_pdfjs_require__(2);
                var _charsets = __w_pdfjs_require__(36);
                var _encodings = __w_pdfjs_require__(37);
                const MAX_SUBR_NESTING = 10;
                const CFFStandardStrings = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall",
                    "001.000",
                    "001.001",
                    "001.002",
                    "001.003",
                    "Black",
                    "Bold",
                    "Book",
                    "Light",
                    "Medium",
                    "Regular",
                    "Roman",
                    "Semibold"
                ];
                exports.CFFStandardStrings = CFFStandardStrings;
                const NUM_STANDARD_CFF_STRINGS = 391;
                const CharstringValidationData = [
                    null,
                    {
                        id: "hstem",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    null,
                    {
                        id: "vstem",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    {
                        id: "vmoveto",
                        min: 1,
                        stackClearing: true
                    },
                    {
                        id: "rlineto",
                        min: 2,
                        resetStack: true
                    },
                    {
                        id: "hlineto",
                        min: 1,
                        resetStack: true
                    },
                    {
                        id: "vlineto",
                        min: 1,
                        resetStack: true
                    },
                    {
                        id: "rrcurveto",
                        min: 6,
                        resetStack: true
                    },
                    null,
                    {
                        id: "callsubr",
                        min: 1,
                        undefStack: true
                    },
                    {
                        id: "return",
                        min: 0,
                        undefStack: true
                    },
                    null,
                    null,
                    {
                        id: "endchar",
                        min: 0,
                        stackClearing: true
                    },
                    null,
                    null,
                    null,
                    {
                        id: "hstemhm",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    {
                        id: "hintmask",
                        min: 0,
                        stackClearing: true
                    },
                    {
                        id: "cntrmask",
                        min: 0,
                        stackClearing: true
                    },
                    {
                        id: "rmoveto",
                        min: 2,
                        stackClearing: true
                    },
                    {
                        id: "hmoveto",
                        min: 1,
                        stackClearing: true
                    },
                    {
                        id: "vstemhm",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    {
                        id: "rcurveline",
                        min: 8,
                        resetStack: true
                    },
                    {
                        id: "rlinecurve",
                        min: 8,
                        resetStack: true
                    },
                    {
                        id: "vvcurveto",
                        min: 4,
                        resetStack: true
                    },
                    {
                        id: "hhcurveto",
                        min: 4,
                        resetStack: true
                    },
                    null,
                    {
                        id: "callgsubr",
                        min: 1,
                        undefStack: true
                    },
                    {
                        id: "vhcurveto",
                        min: 4,
                        resetStack: true
                    },
                    {
                        id: "hvcurveto",
                        min: 4,
                        resetStack: true
                    }
                ];
                const CharstringValidationData12 = [
                    null,
                    null,
                    null,
                    {
                        id: "and",
                        min: 2,
                        stackDelta: -1
                    },
                    {
                        id: "or",
                        min: 2,
                        stackDelta: -1
                    },
                    {
                        id: "not",
                        min: 1,
                        stackDelta: 0
                    },
                    null,
                    null,
                    null,
                    {
                        id: "abs",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "add",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] + stack[index - 1];
                        }
                    },
                    {
                        id: "sub",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] - stack[index - 1];
                        }
                    },
                    {
                        id: "div",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] / stack[index - 1];
                        }
                    },
                    null,
                    {
                        id: "neg",
                        min: 1,
                        stackDelta: 0,
                        stackFn (stack, index) {
                            stack[index - 1] = -stack[index - 1];
                        }
                    },
                    {
                        id: "eq",
                        min: 2,
                        stackDelta: -1
                    },
                    null,
                    null,
                    {
                        id: "drop",
                        min: 1,
                        stackDelta: -1
                    },
                    null,
                    {
                        id: "put",
                        min: 2,
                        stackDelta: -2
                    },
                    {
                        id: "get",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "ifelse",
                        min: 4,
                        stackDelta: -3
                    },
                    {
                        id: "random",
                        min: 0,
                        stackDelta: 1
                    },
                    {
                        id: "mul",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] * stack[index - 1];
                        }
                    },
                    null,
                    {
                        id: "sqrt",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "dup",
                        min: 1,
                        stackDelta: 1
                    },
                    {
                        id: "exch",
                        min: 2,
                        stackDelta: 0
                    },
                    {
                        id: "index",
                        min: 2,
                        stackDelta: 0
                    },
                    {
                        id: "roll",
                        min: 3,
                        stackDelta: -2
                    },
                    null,
                    null,
                    null,
                    {
                        id: "hflex",
                        min: 7,
                        resetStack: true
                    },
                    {
                        id: "flex",
                        min: 13,
                        resetStack: true
                    },
                    {
                        id: "hflex1",
                        min: 9,
                        resetStack: true
                    },
                    {
                        id: "flex1",
                        min: 11,
                        resetStack: true
                    }
                ];
                class CFFParser {
                    constructor(file, properties, seacAnalysisEnabled){
                        this.bytes = file.getBytes();
                        this.properties = properties;
                        this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                    }
                    parse() {
                        const properties = this.properties;
                        const cff = new CFF();
                        this.cff = cff;
                        const header = this.parseHeader();
                        const nameIndex = this.parseIndex(header.endPos);
                        const topDictIndex = this.parseIndex(nameIndex.endPos);
                        const stringIndex = this.parseIndex(topDictIndex.endPos);
                        const globalSubrIndex = this.parseIndex(stringIndex.endPos);
                        const topDictParsed = this.parseDict(topDictIndex.obj.get(0));
                        const topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
                        cff.header = header.obj;
                        cff.names = this.parseNameIndex(nameIndex.obj);
                        cff.strings = this.parseStringIndex(stringIndex.obj);
                        cff.topDict = topDict;
                        cff.globalSubrIndex = globalSubrIndex.obj;
                        this.parsePrivateDict(cff.topDict);
                        cff.isCIDFont = topDict.hasName("ROS");
                        const charStringOffset = topDict.getByName("CharStrings");
                        const charStringIndex = this.parseIndex(charStringOffset).obj;
                        const fontMatrix = topDict.getByName("FontMatrix");
                        if (fontMatrix) properties.fontMatrix = fontMatrix;
                        const fontBBox = topDict.getByName("FontBBox");
                        if (fontBBox) {
                            properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                            properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                            properties.ascentScaled = true;
                        }
                        let charset, encoding;
                        if (cff.isCIDFont) {
                            const fdArrayIndex = this.parseIndex(topDict.getByName("FDArray")).obj;
                            for(let i = 0, ii = fdArrayIndex.count; i < ii; ++i){
                                const dictRaw = fdArrayIndex.get(i);
                                const fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
                                this.parsePrivateDict(fontDict);
                                cff.fdArray.push(fontDict);
                            }
                            encoding = null;
                            charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, true);
                            cff.fdSelect = this.parseFDSelect(topDict.getByName("FDSelect"), charStringIndex.count);
                        } else {
                            charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, false);
                            encoding = this.parseEncoding(topDict.getByName("Encoding"), properties, cff.strings, charset.charset);
                        }
                        cff.charset = charset;
                        cff.encoding = encoding;
                        const charStringsAndSeacs = this.parseCharStrings({
                            charStrings: charStringIndex,
                            localSubrIndex: topDict.privateDict.subrsIndex,
                            globalSubrIndex: globalSubrIndex.obj,
                            fdSelect: cff.fdSelect,
                            fdArray: cff.fdArray,
                            privateDict: topDict.privateDict
                        });
                        cff.charStrings = charStringsAndSeacs.charStrings;
                        cff.seacs = charStringsAndSeacs.seacs;
                        cff.widths = charStringsAndSeacs.widths;
                        return cff;
                    }
                    parseHeader() {
                        let bytes = this.bytes;
                        const bytesLength = bytes.length;
                        let offset = 0;
                        while(offset < bytesLength && bytes[offset] !== 1)++offset;
                        if (offset >= bytesLength) throw new _util.FormatError("Invalid CFF header");
                        if (offset !== 0) {
                            (0, _util.info)("cff data is shifted");
                            bytes = bytes.subarray(offset);
                            this.bytes = bytes;
                        }
                        const major = bytes[0];
                        const minor = bytes[1];
                        const hdrSize = bytes[2];
                        const offSize = bytes[3];
                        const header = new CFFHeader(major, minor, hdrSize, offSize);
                        return {
                            obj: header,
                            endPos: hdrSize
                        };
                    }
                    parseDict(dict) {
                        let pos = 0;
                        function parseOperand() {
                            let value = dict[pos++];
                            if (value === 30) return parseFloatOperand();
                            else if (value === 28) {
                                value = dict[pos++];
                                value = (value << 24 | dict[pos++] << 16) >> 16;
                                return value;
                            } else if (value === 29) {
                                value = dict[pos++];
                                value = value << 8 | dict[pos++];
                                value = value << 8 | dict[pos++];
                                value = value << 8 | dict[pos++];
                                return value;
                            } else if (value >= 32 && value <= 246) return value - 139;
                            else if (value >= 247 && value <= 250) return (value - 247) * 256 + dict[pos++] + 108;
                            else if (value >= 251 && value <= 254) return -((value - 251) * 256) - dict[pos++] - 108;
                            (0, _util.warn)('CFFParser_parseDict: "' + value + '" is a reserved command.');
                            return NaN;
                        }
                        function parseFloatOperand() {
                            let str = "";
                            const eof = 15;
                            const lookup = [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                ".",
                                "E",
                                "E-",
                                null,
                                "-"
                            ];
                            const length = dict.length;
                            while(pos < length){
                                const b = dict[pos++];
                                const b1 = b >> 4;
                                const b2 = b & 15;
                                if (b1 === eof) break;
                                str += lookup[b1];
                                if (b2 === eof) break;
                                str += lookup[b2];
                            }
                            return parseFloat(str);
                        }
                        let operands = [];
                        const entries = [];
                        pos = 0;
                        const end = dict.length;
                        while(pos < end){
                            let b = dict[pos];
                            if (b <= 21) {
                                if (b === 12) b = b << 8 | dict[++pos];
                                entries.push([
                                    b,
                                    operands
                                ]);
                                operands = [];
                                ++pos;
                            } else operands.push(parseOperand());
                        }
                        return entries;
                    }
                    parseIndex(pos) {
                        const cffIndex = new CFFIndex();
                        const bytes = this.bytes;
                        const count = bytes[pos++] << 8 | bytes[pos++];
                        const offsets = [];
                        let end = pos;
                        let i, ii;
                        if (count !== 0) {
                            const offsetSize = bytes[pos++];
                            const startPos = pos + (count + 1) * offsetSize - 1;
                            for(i = 0, ii = count + 1; i < ii; ++i){
                                let offset = 0;
                                for(let j = 0; j < offsetSize; ++j){
                                    offset <<= 8;
                                    offset += bytes[pos++];
                                }
                                offsets.push(startPos + offset);
                            }
                            end = offsets[count];
                        }
                        for(i = 0, ii = offsets.length - 1; i < ii; ++i){
                            const offsetStart = offsets[i];
                            const offsetEnd = offsets[i + 1];
                            cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
                        }
                        return {
                            obj: cffIndex,
                            endPos: end
                        };
                    }
                    parseNameIndex(index) {
                        const names = [];
                        for(let i = 0, ii = index.count; i < ii; ++i){
                            const name = index.get(i);
                            names.push((0, _util.bytesToString)(name));
                        }
                        return names;
                    }
                    parseStringIndex(index) {
                        const strings = new CFFStrings();
                        for(let i = 0, ii = index.count; i < ii; ++i){
                            const data = index.get(i);
                            strings.add((0, _util.bytesToString)(data));
                        }
                        return strings;
                    }
                    createDict(Type, dict, strings) {
                        const cffDict = new Type(strings);
                        for (const [key, value] of dict)cffDict.setByKey(key, value);
                        return cffDict;
                    }
                    parseCharString(state, data, localSubrIndex, globalSubrIndex) {
                        if (!data || state.callDepth > MAX_SUBR_NESTING) return false;
                        let stackSize = state.stackSize;
                        const stack = state.stack;
                        let length = data.length;
                        for(let j = 0; j < length;){
                            const value = data[j++];
                            let validationCommand = null;
                            if (value === 12) {
                                const q = data[j++];
                                if (q === 0) {
                                    data[j - 2] = 139;
                                    data[j - 1] = 22;
                                    stackSize = 0;
                                } else validationCommand = CharstringValidationData12[q];
                            } else if (value === 28) {
                                stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
                                j += 2;
                                stackSize++;
                            } else if (value === 14) {
                                if (stackSize >= 4) {
                                    stackSize -= 4;
                                    if (this.seacAnalysisEnabled) {
                                        state.seac = stack.slice(stackSize, stackSize + 4);
                                        return false;
                                    }
                                }
                                validationCommand = CharstringValidationData[value];
                            } else if (value >= 32 && value <= 246) {
                                stack[stackSize] = value - 139;
                                stackSize++;
                            } else if (value >= 247 && value <= 254) {
                                stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
                                j++;
                                stackSize++;
                            } else if (value === 255) {
                                stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
                                j += 4;
                                stackSize++;
                            } else if (value === 19 || value === 20) {
                                state.hints += stackSize >> 1;
                                if (state.hints === 0) {
                                    data.copyWithin(j - 1, j, -1);
                                    j -= 1;
                                    length -= 1;
                                    continue;
                                }
                                j += state.hints + 7 >> 3;
                                stackSize %= 2;
                                validationCommand = CharstringValidationData[value];
                            } else if (value === 10 || value === 29) {
                                const subrsIndex = value === 10 ? localSubrIndex : globalSubrIndex;
                                if (!subrsIndex) {
                                    validationCommand = CharstringValidationData[value];
                                    (0, _util.warn)("Missing subrsIndex for " + validationCommand.id);
                                    return false;
                                }
                                let bias = 32768;
                                if (subrsIndex.count < 1240) bias = 107;
                                else if (subrsIndex.count < 33900) bias = 1131;
                                const subrNumber = stack[--stackSize] + bias;
                                if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
                                    validationCommand = CharstringValidationData[value];
                                    (0, _util.warn)("Out of bounds subrIndex for " + validationCommand.id);
                                    return false;
                                }
                                state.stackSize = stackSize;
                                state.callDepth++;
                                const valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
                                if (!valid) return false;
                                state.callDepth--;
                                stackSize = state.stackSize;
                                continue;
                            } else if (value === 11) {
                                state.stackSize = stackSize;
                                return true;
                            } else if (value === 0 && j === data.length) {
                                data[j - 1] = 14;
                                validationCommand = CharstringValidationData[14];
                            } else if (value === 9) {
                                data.copyWithin(j - 1, j, -1);
                                j -= 1;
                                length -= 1;
                                continue;
                            } else validationCommand = CharstringValidationData[value];
                            if (validationCommand) {
                                if (validationCommand.stem) {
                                    state.hints += stackSize >> 1;
                                    if (value === 3 || value === 23) state.hasVStems = true;
                                    else if (state.hasVStems && (value === 1 || value === 18)) {
                                        (0, _util.warn)("CFF stem hints are in wrong order");
                                        data[j - 1] = value === 1 ? 3 : 23;
                                    }
                                }
                                if ("min" in validationCommand) {
                                    if (!state.undefStack && stackSize < validationCommand.min) {
                                        (0, _util.warn)("Not enough parameters for " + validationCommand.id + "; actual: " + stackSize + ", expected: " + validationCommand.min);
                                        if (stackSize === 0) {
                                            data[j - 1] = 14;
                                            return true;
                                        }
                                        return false;
                                    }
                                }
                                if (state.firstStackClearing && validationCommand.stackClearing) {
                                    state.firstStackClearing = false;
                                    stackSize -= validationCommand.min;
                                    if (stackSize >= 2 && validationCommand.stem) stackSize %= 2;
                                    else if (stackSize > 1) (0, _util.warn)("Found too many parameters for stack-clearing command");
                                    if (stackSize > 0) state.width = stack[stackSize - 1];
                                }
                                if ("stackDelta" in validationCommand) {
                                    if ("stackFn" in validationCommand) validationCommand.stackFn(stack, stackSize);
                                    stackSize += validationCommand.stackDelta;
                                } else if (validationCommand.stackClearing) stackSize = 0;
                                else if (validationCommand.resetStack) {
                                    stackSize = 0;
                                    state.undefStack = false;
                                } else if (validationCommand.undefStack) {
                                    stackSize = 0;
                                    state.undefStack = true;
                                    state.firstStackClearing = false;
                                }
                            }
                        }
                        if (length < data.length) data.fill(14, length);
                        state.stackSize = stackSize;
                        return true;
                    }
                    parseCharStrings({ charStrings: charStrings, localSubrIndex: localSubrIndex, globalSubrIndex: globalSubrIndex, fdSelect: fdSelect, fdArray: fdArray, privateDict: privateDict }) {
                        const seacs = [];
                        const widths = [];
                        const count = charStrings.count;
                        for(let i = 0; i < count; i++){
                            const charstring = charStrings.get(i);
                            const state = {
                                callDepth: 0,
                                stackSize: 0,
                                stack: [],
                                undefStack: true,
                                hints: 0,
                                firstStackClearing: true,
                                seac: null,
                                width: null,
                                hasVStems: false
                            };
                            let valid = true;
                            let localSubrToUse = null;
                            let privateDictToUse = privateDict;
                            if (fdSelect && fdArray.length) {
                                const fdIndex = fdSelect.getFDIndex(i);
                                if (fdIndex === -1) {
                                    (0, _util.warn)("Glyph index is not in fd select.");
                                    valid = false;
                                }
                                if (fdIndex >= fdArray.length) {
                                    (0, _util.warn)("Invalid fd index for glyph index.");
                                    valid = false;
                                }
                                if (valid) {
                                    privateDictToUse = fdArray[fdIndex].privateDict;
                                    localSubrToUse = privateDictToUse.subrsIndex;
                                }
                            } else if (localSubrIndex) localSubrToUse = localSubrIndex;
                            if (valid) valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
                            if (state.width !== null) {
                                const nominalWidth = privateDictToUse.getByName("nominalWidthX");
                                widths[i] = nominalWidth + state.width;
                            } else {
                                const defaultWidth = privateDictToUse.getByName("defaultWidthX");
                                widths[i] = defaultWidth;
                            }
                            if (state.seac !== null) seacs[i] = state.seac;
                            if (!valid) charStrings.set(i, new Uint8Array([
                                14
                            ]));
                        }
                        return {
                            charStrings: charStrings,
                            seacs: seacs,
                            widths: widths
                        };
                    }
                    emptyPrivateDictionary(parentDict) {
                        const privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
                        parentDict.setByKey(18, [
                            0,
                            0
                        ]);
                        parentDict.privateDict = privateDict;
                    }
                    parsePrivateDict(parentDict) {
                        if (!parentDict.hasName("Private")) {
                            this.emptyPrivateDictionary(parentDict);
                            return;
                        }
                        const privateOffset = parentDict.getByName("Private");
                        if (!Array.isArray(privateOffset) || privateOffset.length !== 2) {
                            parentDict.removeByName("Private");
                            return;
                        }
                        const size = privateOffset[0];
                        const offset = privateOffset[1];
                        if (size === 0 || offset >= this.bytes.length) {
                            this.emptyPrivateDictionary(parentDict);
                            return;
                        }
                        const privateDictEnd = offset + size;
                        const dictData = this.bytes.subarray(offset, privateDictEnd);
                        const dict = this.parseDict(dictData);
                        const privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
                        parentDict.privateDict = privateDict;
                        if (privateDict.getByName("ExpansionFactor") === 0) privateDict.setByName("ExpansionFactor", 0.06);
                        if (!privateDict.getByName("Subrs")) return;
                        const subrsOffset = privateDict.getByName("Subrs");
                        const relativeOffset = offset + subrsOffset;
                        if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
                            this.emptyPrivateDictionary(parentDict);
                            return;
                        }
                        const subrsIndex = this.parseIndex(relativeOffset);
                        privateDict.subrsIndex = subrsIndex.obj;
                    }
                    parseCharsets(pos, length, strings, cid) {
                        if (pos === 0) return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
                        else if (pos === 1) return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
                        else if (pos === 2) return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
                        const bytes = this.bytes;
                        const start = pos;
                        const format = bytes[pos++];
                        const charset = [
                            cid ? 0 : ".notdef"
                        ];
                        let id, count, i;
                        length -= 1;
                        switch(format){
                            case 0:
                                for(i = 0; i < length; i++){
                                    id = bytes[pos++] << 8 | bytes[pos++];
                                    charset.push(cid ? id : strings.get(id));
                                }
                                break;
                            case 1:
                                while(charset.length <= length){
                                    id = bytes[pos++] << 8 | bytes[pos++];
                                    count = bytes[pos++];
                                    for(i = 0; i <= count; i++)charset.push(cid ? id++ : strings.get(id++));
                                }
                                break;
                            case 2:
                                while(charset.length <= length){
                                    id = bytes[pos++] << 8 | bytes[pos++];
                                    count = bytes[pos++] << 8 | bytes[pos++];
                                    for(i = 0; i <= count; i++)charset.push(cid ? id++ : strings.get(id++));
                                }
                                break;
                            default:
                                throw new _util.FormatError("Unknown charset format");
                        }
                        const end = pos;
                        const raw = bytes.subarray(start, end);
                        return new CFFCharset(false, format, charset, raw);
                    }
                    parseEncoding(pos, properties, strings, charset) {
                        const encoding = Object.create(null);
                        const bytes = this.bytes;
                        let predefined = false;
                        let format, i, ii;
                        let raw = null;
                        function readSupplement() {
                            const supplementsCount = bytes[pos++];
                            for(i = 0; i < supplementsCount; i++){
                                const code = bytes[pos++];
                                const sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
                                encoding[code] = charset.indexOf(strings.get(sid));
                            }
                        }
                        if (pos === 0 || pos === 1) {
                            predefined = true;
                            format = pos;
                            const baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
                            for(i = 0, ii = charset.length; i < ii; i++){
                                const index = baseEncoding.indexOf(charset[i]);
                                if (index !== -1) encoding[index] = i;
                            }
                        } else {
                            const dataStart = pos;
                            format = bytes[pos++];
                            switch(format & 0x7f){
                                case 0:
                                    const glyphsCount = bytes[pos++];
                                    for(i = 1; i <= glyphsCount; i++)encoding[bytes[pos++]] = i;
                                    break;
                                case 1:
                                    const rangesCount = bytes[pos++];
                                    let gid = 1;
                                    for(i = 0; i < rangesCount; i++){
                                        const start = bytes[pos++];
                                        const left = bytes[pos++];
                                        for(let j = start; j <= start + left; j++)encoding[j] = gid++;
                                    }
                                    break;
                                default:
                                    throw new _util.FormatError(`Unknown encoding format: ${format} in CFF`);
                            }
                            const dataEnd = pos;
                            if (format & 0x80) {
                                bytes[dataStart] &= 0x7f;
                                readSupplement();
                            }
                            raw = bytes.subarray(dataStart, dataEnd);
                        }
                        format &= 0x7f;
                        return new CFFEncoding(predefined, format, encoding, raw);
                    }
                    parseFDSelect(pos, length) {
                        const bytes = this.bytes;
                        const format = bytes[pos++];
                        const fdSelect = [];
                        let i;
                        switch(format){
                            case 0:
                                for(i = 0; i < length; ++i){
                                    const id = bytes[pos++];
                                    fdSelect.push(id);
                                }
                                break;
                            case 3:
                                const rangesCount = bytes[pos++] << 8 | bytes[pos++];
                                for(i = 0; i < rangesCount; ++i){
                                    let first = bytes[pos++] << 8 | bytes[pos++];
                                    if (i === 0 && first !== 0) {
                                        (0, _util.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover.");
                                        first = 0;
                                    }
                                    const fdIndex = bytes[pos++];
                                    const next = bytes[pos] << 8 | bytes[pos + 1];
                                    for(let j = first; j < next; ++j)fdSelect.push(fdIndex);
                                }
                                pos += 2;
                                break;
                            default:
                                throw new _util.FormatError(`parseFDSelect: Unknown format "${format}".`);
                        }
                        if (fdSelect.length !== length) throw new _util.FormatError("parseFDSelect: Invalid font data.");
                        return new CFFFDSelect(format, fdSelect);
                    }
                }
                exports.CFFParser = CFFParser;
                class CFF {
                    constructor(){
                        this.header = null;
                        this.names = [];
                        this.topDict = null;
                        this.strings = new CFFStrings();
                        this.globalSubrIndex = null;
                        this.encoding = null;
                        this.charset = null;
                        this.charStrings = null;
                        this.fdArray = [];
                        this.fdSelect = null;
                        this.isCIDFont = false;
                    }
                    duplicateFirstGlyph() {
                        if (this.charStrings.count >= 65535) {
                            (0, _util.warn)("Not enough space in charstrings to duplicate first glyph.");
                            return;
                        }
                        const glyphZero = this.charStrings.get(0);
                        this.charStrings.add(glyphZero);
                        if (this.isCIDFont) this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
                    }
                    hasGlyphId(id) {
                        if (id < 0 || id >= this.charStrings.count) return false;
                        const glyph = this.charStrings.get(id);
                        return glyph.length > 0;
                    }
                }
                exports.CFF = CFF;
                class CFFHeader {
                    constructor(major, minor, hdrSize, offSize){
                        this.major = major;
                        this.minor = minor;
                        this.hdrSize = hdrSize;
                        this.offSize = offSize;
                    }
                }
                exports.CFFHeader = CFFHeader;
                class CFFStrings {
                    constructor(){
                        this.strings = [];
                    }
                    get(index) {
                        if (index >= 0 && index <= NUM_STANDARD_CFF_STRINGS - 1) return CFFStandardStrings[index];
                        if (index - NUM_STANDARD_CFF_STRINGS <= this.strings.length) return this.strings[index - NUM_STANDARD_CFF_STRINGS];
                        return CFFStandardStrings[0];
                    }
                    getSID(str) {
                        let index = CFFStandardStrings.indexOf(str);
                        if (index !== -1) return index;
                        index = this.strings.indexOf(str);
                        if (index !== -1) return index + NUM_STANDARD_CFF_STRINGS;
                        return -1;
                    }
                    add(value) {
                        this.strings.push(value);
                    }
                    get count() {
                        return this.strings.length;
                    }
                }
                exports.CFFStrings = CFFStrings;
                class CFFIndex {
                    constructor(){
                        this.objects = [];
                        this.length = 0;
                    }
                    add(data) {
                        this.length += data.length;
                        this.objects.push(data);
                    }
                    set(index, data) {
                        this.length += data.length - this.objects[index].length;
                        this.objects[index] = data;
                    }
                    get(index) {
                        return this.objects[index];
                    }
                    get count() {
                        return this.objects.length;
                    }
                }
                exports.CFFIndex = CFFIndex;
                class CFFDict {
                    constructor(tables, strings){
                        this.keyToNameMap = tables.keyToNameMap;
                        this.nameToKeyMap = tables.nameToKeyMap;
                        this.defaults = tables.defaults;
                        this.types = tables.types;
                        this.opcodes = tables.opcodes;
                        this.order = tables.order;
                        this.strings = strings;
                        this.values = Object.create(null);
                    }
                    setByKey(key, value) {
                        if (!(key in this.keyToNameMap)) return false;
                        if (value.length === 0) return true;
                        for (const val of value)if (isNaN(val)) {
                            (0, _util.warn)(`Invalid CFFDict value: "${value}" for key "${key}".`);
                            return true;
                        }
                        const type = this.types[key];
                        if (type === "num" || type === "sid" || type === "offset") value = value[0];
                        this.values[key] = value;
                        return true;
                    }
                    setByName(name, value) {
                        if (!(name in this.nameToKeyMap)) throw new _util.FormatError(`Invalid dictionary name "${name}"`);
                        this.values[this.nameToKeyMap[name]] = value;
                    }
                    hasName(name) {
                        return this.nameToKeyMap[name] in this.values;
                    }
                    getByName(name) {
                        if (!(name in this.nameToKeyMap)) throw new _util.FormatError(`Invalid dictionary name ${name}"`);
                        const key = this.nameToKeyMap[name];
                        if (!(key in this.values)) return this.defaults[key];
                        return this.values[key];
                    }
                    removeByName(name) {
                        delete this.values[this.nameToKeyMap[name]];
                    }
                    static createTables(layout) {
                        const tables = {
                            keyToNameMap: {},
                            nameToKeyMap: {},
                            defaults: {},
                            types: {},
                            opcodes: {},
                            order: []
                        };
                        for (const entry of layout){
                            const key = Array.isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
                            tables.keyToNameMap[key] = entry[1];
                            tables.nameToKeyMap[entry[1]] = key;
                            tables.types[key] = entry[2];
                            tables.defaults[key] = entry[3];
                            tables.opcodes[key] = Array.isArray(entry[0]) ? entry[0] : [
                                entry[0]
                            ];
                            tables.order.push(key);
                        }
                        return tables;
                    }
                }
                const CFFTopDictLayout = [
                    [
                        [
                            12,
                            30
                        ],
                        "ROS",
                        [
                            "sid",
                            "sid",
                            "num"
                        ],
                        null
                    ],
                    [
                        [
                            12,
                            20
                        ],
                        "SyntheticBase",
                        "num",
                        null
                    ],
                    [
                        0,
                        "version",
                        "sid",
                        null
                    ],
                    [
                        1,
                        "Notice",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            0
                        ],
                        "Copyright",
                        "sid",
                        null
                    ],
                    [
                        2,
                        "FullName",
                        "sid",
                        null
                    ],
                    [
                        3,
                        "FamilyName",
                        "sid",
                        null
                    ],
                    [
                        4,
                        "Weight",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            1
                        ],
                        "isFixedPitch",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            2
                        ],
                        "ItalicAngle",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            3
                        ],
                        "UnderlinePosition",
                        "num",
                        -100
                    ],
                    [
                        [
                            12,
                            4
                        ],
                        "UnderlineThickness",
                        "num",
                        50
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        "PaintType",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            6
                        ],
                        "CharstringType",
                        "num",
                        2
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        "FontMatrix",
                        [
                            "num",
                            "num",
                            "num",
                            "num",
                            "num",
                            "num"
                        ],
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        13,
                        "UniqueID",
                        "num",
                        null
                    ],
                    [
                        5,
                        "FontBBox",
                        [
                            "num",
                            "num",
                            "num",
                            "num"
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            8
                        ],
                        "StrokeWidth",
                        "num",
                        0
                    ],
                    [
                        14,
                        "XUID",
                        "array",
                        null
                    ],
                    [
                        15,
                        "charset",
                        "offset",
                        0
                    ],
                    [
                        16,
                        "Encoding",
                        "offset",
                        0
                    ],
                    [
                        17,
                        "CharStrings",
                        "offset",
                        0
                    ],
                    [
                        18,
                        "Private",
                        [
                            "offset",
                            "offset"
                        ],
                        null
                    ],
                    [
                        [
                            12,
                            21
                        ],
                        "PostScript",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            22
                        ],
                        "BaseFontName",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            23
                        ],
                        "BaseFontBlend",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            31
                        ],
                        "CIDFontVersion",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            32
                        ],
                        "CIDFontRevision",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            33
                        ],
                        "CIDFontType",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            34
                        ],
                        "CIDCount",
                        "num",
                        8720
                    ],
                    [
                        [
                            12,
                            35
                        ],
                        "UIDBase",
                        "num",
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        "FDSelect",
                        "offset",
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        "FDArray",
                        "offset",
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        "FontName",
                        "sid",
                        null
                    ]
                ];
                class CFFTopDict extends CFFDict {
                    static get tables() {
                        return (0, _util.shadow)(this, "tables", this.createTables(CFFTopDictLayout));
                    }
                    constructor(strings){
                        super(CFFTopDict.tables, strings);
                        this.privateDict = null;
                    }
                }
                exports.CFFTopDict = CFFTopDict;
                const CFFPrivateDictLayout = [
                    [
                        6,
                        "BlueValues",
                        "delta",
                        null
                    ],
                    [
                        7,
                        "OtherBlues",
                        "delta",
                        null
                    ],
                    [
                        8,
                        "FamilyBlues",
                        "delta",
                        null
                    ],
                    [
                        9,
                        "FamilyOtherBlues",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            9
                        ],
                        "BlueScale",
                        "num",
                        0.039625
                    ],
                    [
                        [
                            12,
                            10
                        ],
                        "BlueShift",
                        "num",
                        7
                    ],
                    [
                        [
                            12,
                            11
                        ],
                        "BlueFuzz",
                        "num",
                        1
                    ],
                    [
                        10,
                        "StdHW",
                        "num",
                        null
                    ],
                    [
                        11,
                        "StdVW",
                        "num",
                        null
                    ],
                    [
                        [
                            12,
                            12
                        ],
                        "StemSnapH",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            13
                        ],
                        "StemSnapV",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            14
                        ],
                        "ForceBold",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            17
                        ],
                        "LanguageGroup",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            18
                        ],
                        "ExpansionFactor",
                        "num",
                        0.06
                    ],
                    [
                        [
                            12,
                            19
                        ],
                        "initialRandomSeed",
                        "num",
                        0
                    ],
                    [
                        20,
                        "defaultWidthX",
                        "num",
                        0
                    ],
                    [
                        21,
                        "nominalWidthX",
                        "num",
                        0
                    ],
                    [
                        19,
                        "Subrs",
                        "offset",
                        null
                    ]
                ];
                class CFFPrivateDict extends CFFDict {
                    static get tables() {
                        return (0, _util.shadow)(this, "tables", this.createTables(CFFPrivateDictLayout));
                    }
                    constructor(strings){
                        super(CFFPrivateDict.tables, strings);
                        this.subrsIndex = null;
                    }
                }
                exports.CFFPrivateDict = CFFPrivateDict;
                const CFFCharsetPredefinedTypes = {
                    ISO_ADOBE: 0,
                    EXPERT: 1,
                    EXPERT_SUBSET: 2
                };
                class CFFCharset {
                    constructor(predefined, format, charset, raw){
                        this.predefined = predefined;
                        this.format = format;
                        this.charset = charset;
                        this.raw = raw;
                    }
                }
                exports.CFFCharset = CFFCharset;
                class CFFEncoding {
                    constructor(predefined, format, encoding, raw){
                        this.predefined = predefined;
                        this.format = format;
                        this.encoding = encoding;
                        this.raw = raw;
                    }
                }
                class CFFFDSelect {
                    constructor(format, fdSelect){
                        this.format = format;
                        this.fdSelect = fdSelect;
                    }
                    getFDIndex(glyphIndex) {
                        if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) return -1;
                        return this.fdSelect[glyphIndex];
                    }
                }
                exports.CFFFDSelect = CFFFDSelect;
                class CFFOffsetTracker {
                    constructor(){
                        this.offsets = Object.create(null);
                    }
                    isTracking(key) {
                        return key in this.offsets;
                    }
                    track(key, location) {
                        if (key in this.offsets) throw new _util.FormatError(`Already tracking location of ${key}`);
                        this.offsets[key] = location;
                    }
                    offset(value) {
                        for(const key in this.offsets)this.offsets[key] += value;
                    }
                    setEntryLocation(key, values, output) {
                        if (!(key in this.offsets)) throw new _util.FormatError(`Not tracking location of ${key}`);
                        const data = output.data;
                        const dataOffset = this.offsets[key];
                        const size = 5;
                        for(let i = 0, ii = values.length; i < ii; ++i){
                            const offset0 = i * size + dataOffset;
                            const offset1 = offset0 + 1;
                            const offset2 = offset0 + 2;
                            const offset3 = offset0 + 3;
                            const offset4 = offset0 + 4;
                            if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) throw new _util.FormatError("writing to an offset that is not empty");
                            const value = values[i];
                            data[offset0] = 0x1d;
                            data[offset1] = value >> 24 & 0xff;
                            data[offset2] = value >> 16 & 0xff;
                            data[offset3] = value >> 8 & 0xff;
                            data[offset4] = value & 0xff;
                        }
                    }
                }
                class CFFCompiler {
                    constructor(cff){
                        this.cff = cff;
                    }
                    compile() {
                        const cff = this.cff;
                        const output = {
                            data: [],
                            length: 0,
                            add (data) {
                                try {
                                    this.data.push(...data);
                                } catch  {
                                    this.data = this.data.concat(data);
                                }
                                this.length = this.data.length;
                            }
                        };
                        const header = this.compileHeader(cff.header);
                        output.add(header);
                        const nameIndex = this.compileNameIndex(cff.names);
                        output.add(nameIndex);
                        if (cff.isCIDFont) {
                            if (cff.topDict.hasName("FontMatrix")) {
                                const base = cff.topDict.getByName("FontMatrix");
                                cff.topDict.removeByName("FontMatrix");
                                for (const subDict of cff.fdArray){
                                    let matrix = base.slice(0);
                                    if (subDict.hasName("FontMatrix")) matrix = _util.Util.transform(matrix, subDict.getByName("FontMatrix"));
                                    subDict.setByName("FontMatrix", matrix);
                                }
                            }
                        }
                        const xuid = cff.topDict.getByName("XUID");
                        if (xuid?.length > 16) cff.topDict.removeByName("XUID");
                        cff.topDict.setByName("charset", 0);
                        let compiled = this.compileTopDicts([
                            cff.topDict
                        ], output.length, cff.isCIDFont);
                        output.add(compiled.output);
                        const topDictTracker = compiled.trackers[0];
                        const stringIndex = this.compileStringIndex(cff.strings.strings);
                        output.add(stringIndex);
                        const globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
                        output.add(globalSubrIndex);
                        if (cff.encoding && cff.topDict.hasName("Encoding")) {
                            if (cff.encoding.predefined) topDictTracker.setEntryLocation("Encoding", [
                                cff.encoding.format
                            ], output);
                            else {
                                const encoding = this.compileEncoding(cff.encoding);
                                topDictTracker.setEntryLocation("Encoding", [
                                    output.length
                                ], output);
                                output.add(encoding);
                            }
                        }
                        const charset = this.compileCharset(cff.charset, cff.charStrings.count, cff.strings, cff.isCIDFont);
                        topDictTracker.setEntryLocation("charset", [
                            output.length
                        ], output);
                        output.add(charset);
                        const charStrings = this.compileCharStrings(cff.charStrings);
                        topDictTracker.setEntryLocation("CharStrings", [
                            output.length
                        ], output);
                        output.add(charStrings);
                        if (cff.isCIDFont) {
                            topDictTracker.setEntryLocation("FDSelect", [
                                output.length
                            ], output);
                            const fdSelect = this.compileFDSelect(cff.fdSelect);
                            output.add(fdSelect);
                            compiled = this.compileTopDicts(cff.fdArray, output.length, true);
                            topDictTracker.setEntryLocation("FDArray", [
                                output.length
                            ], output);
                            output.add(compiled.output);
                            const fontDictTrackers = compiled.trackers;
                            this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
                        }
                        this.compilePrivateDicts([
                            cff.topDict
                        ], [
                            topDictTracker
                        ], output);
                        output.add([
                            0
                        ]);
                        return output.data;
                    }
                    encodeNumber(value) {
                        if (Number.isInteger(value)) return this.encodeInteger(value);
                        return this.encodeFloat(value);
                    }
                    static get EncodeFloatRegExp() {
                        return (0, _util.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
                    }
                    encodeFloat(num) {
                        let value = num.toString();
                        const m = CFFCompiler.EncodeFloatRegExp.exec(value);
                        if (m) {
                            const epsilon = parseFloat("1e" + ((m[2] ? +m[2] : 0) + m[1].length));
                            value = (Math.round(num * epsilon) / epsilon).toString();
                        }
                        let nibbles = "";
                        let i, ii;
                        for(i = 0, ii = value.length; i < ii; ++i){
                            const a = value[i];
                            if (a === "e") nibbles += value[++i] === "-" ? "c" : "b";
                            else if (a === ".") nibbles += "a";
                            else if (a === "-") nibbles += "e";
                            else nibbles += a;
                        }
                        nibbles += nibbles.length & 1 ? "f" : "ff";
                        const out = [
                            30
                        ];
                        for(i = 0, ii = nibbles.length; i < ii; i += 2)out.push(parseInt(nibbles.substring(i, i + 2), 16));
                        return out;
                    }
                    encodeInteger(value) {
                        let code;
                        if (value >= -107 && value <= 107) code = [
                            value + 139
                        ];
                        else if (value >= 108 && value <= 1131) {
                            value -= 108;
                            code = [
                                (value >> 8) + 247,
                                value & 0xff
                            ];
                        } else if (value >= -1131 && value <= -108) {
                            value = -value - 108;
                            code = [
                                (value >> 8) + 251,
                                value & 0xff
                            ];
                        } else if (value >= -32768 && value <= 32767) code = [
                            0x1c,
                            value >> 8 & 0xff,
                            value & 0xff
                        ];
                        else code = [
                            0x1d,
                            value >> 24 & 0xff,
                            value >> 16 & 0xff,
                            value >> 8 & 0xff,
                            value & 0xff
                        ];
                        return code;
                    }
                    compileHeader(header) {
                        return [
                            header.major,
                            header.minor,
                            4,
                            header.offSize
                        ];
                    }
                    compileNameIndex(names) {
                        const nameIndex = new CFFIndex();
                        for (const name of names){
                            const length = Math.min(name.length, 127);
                            let sanitizedName = new Array(length);
                            for(let j = 0; j < length; j++){
                                let char = name[j];
                                if (char < "!" || char > "~" || char === "[" || char === "]" || char === "(" || char === ")" || char === "{" || char === "}" || char === "<" || char === ">" || char === "/" || char === "%") char = "_";
                                sanitizedName[j] = char;
                            }
                            sanitizedName = sanitizedName.join("");
                            if (sanitizedName === "") sanitizedName = "Bad_Font_Name";
                            nameIndex.add((0, _util.stringToBytes)(sanitizedName));
                        }
                        return this.compileIndex(nameIndex);
                    }
                    compileTopDicts(dicts, length, removeCidKeys) {
                        const fontDictTrackers = [];
                        let fdArrayIndex = new CFFIndex();
                        for (const fontDict of dicts){
                            if (removeCidKeys) {
                                fontDict.removeByName("CIDFontVersion");
                                fontDict.removeByName("CIDFontRevision");
                                fontDict.removeByName("CIDFontType");
                                fontDict.removeByName("CIDCount");
                                fontDict.removeByName("UIDBase");
                            }
                            const fontDictTracker = new CFFOffsetTracker();
                            const fontDictData = this.compileDict(fontDict, fontDictTracker);
                            fontDictTrackers.push(fontDictTracker);
                            fdArrayIndex.add(fontDictData);
                            fontDictTracker.offset(length);
                        }
                        fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
                        return {
                            trackers: fontDictTrackers,
                            output: fdArrayIndex
                        };
                    }
                    compilePrivateDicts(dicts, trackers, output) {
                        for(let i = 0, ii = dicts.length; i < ii; ++i){
                            const fontDict = dicts[i];
                            const privateDict = fontDict.privateDict;
                            if (!privateDict || !fontDict.hasName("Private")) throw new _util.FormatError("There must be a private dictionary.");
                            const privateDictTracker = new CFFOffsetTracker();
                            const privateDictData = this.compileDict(privateDict, privateDictTracker);
                            let outputLength = output.length;
                            privateDictTracker.offset(outputLength);
                            if (!privateDictData.length) outputLength = 0;
                            trackers[i].setEntryLocation("Private", [
                                privateDictData.length,
                                outputLength
                            ], output);
                            output.add(privateDictData);
                            if (privateDict.subrsIndex && privateDict.hasName("Subrs")) {
                                const subrs = this.compileIndex(privateDict.subrsIndex);
                                privateDictTracker.setEntryLocation("Subrs", [
                                    privateDictData.length
                                ], output);
                                output.add(subrs);
                            }
                        }
                    }
                    compileDict(dict, offsetTracker) {
                        const out = [];
                        for (const key of dict.order){
                            if (!(key in dict.values)) continue;
                            let values = dict.values[key];
                            let types = dict.types[key];
                            if (!Array.isArray(types)) types = [
                                types
                            ];
                            if (!Array.isArray(values)) values = [
                                values
                            ];
                            if (values.length === 0) continue;
                            for(let j = 0, jj = types.length; j < jj; ++j){
                                const type = types[j];
                                const value = values[j];
                                switch(type){
                                    case "num":
                                    case "sid":
                                        out.push(...this.encodeNumber(value));
                                        break;
                                    case "offset":
                                        const name = dict.keyToNameMap[key];
                                        if (!offsetTracker.isTracking(name)) offsetTracker.track(name, out.length);
                                        out.push(0x1d, 0, 0, 0, 0);
                                        break;
                                    case "array":
                                    case "delta":
                                        out.push(...this.encodeNumber(value));
                                        for(let k = 1, kk = values.length; k < kk; ++k)out.push(...this.encodeNumber(values[k]));
                                        break;
                                    default:
                                        throw new _util.FormatError(`Unknown data type of ${type}`);
                                }
                            }
                            out.push(...dict.opcodes[key]);
                        }
                        return out;
                    }
                    compileStringIndex(strings) {
                        const stringIndex = new CFFIndex();
                        for (const string of strings)stringIndex.add((0, _util.stringToBytes)(string));
                        return this.compileIndex(stringIndex);
                    }
                    compileCharStrings(charStrings) {
                        const charStringsIndex = new CFFIndex();
                        for(let i = 0; i < charStrings.count; i++){
                            const glyph = charStrings.get(i);
                            if (glyph.length === 0) {
                                charStringsIndex.add(new Uint8Array([
                                    0x8b,
                                    0x0e
                                ]));
                                continue;
                            }
                            charStringsIndex.add(glyph);
                        }
                        return this.compileIndex(charStringsIndex);
                    }
                    compileCharset(charset, numGlyphs, strings, isCIDFont) {
                        let out;
                        const numGlyphsLessNotDef = numGlyphs - 1;
                        if (isCIDFont) out = new Uint8Array([
                            2,
                            0,
                            0,
                            numGlyphsLessNotDef >> 8 & 0xff,
                            numGlyphsLessNotDef & 0xff
                        ]);
                        else {
                            const length = 1 + numGlyphsLessNotDef * 2;
                            out = new Uint8Array(length);
                            out[0] = 0;
                            let charsetIndex = 0;
                            const numCharsets = charset.charset.length;
                            let warned = false;
                            for(let i = 1; i < out.length; i += 2){
                                let sid = 0;
                                if (charsetIndex < numCharsets) {
                                    const name = charset.charset[charsetIndex++];
                                    sid = strings.getSID(name);
                                    if (sid === -1) {
                                        sid = 0;
                                        if (!warned) {
                                            warned = true;
                                            (0, _util.warn)(`Couldn't find ${name} in CFF strings`);
                                        }
                                    }
                                }
                                out[i] = sid >> 8 & 0xff;
                                out[i + 1] = sid & 0xff;
                            }
                        }
                        return this.compileTypedArray(out);
                    }
                    compileEncoding(encoding) {
                        return this.compileTypedArray(encoding.raw);
                    }
                    compileFDSelect(fdSelect) {
                        const format = fdSelect.format;
                        let out, i;
                        switch(format){
                            case 0:
                                out = new Uint8Array(1 + fdSelect.fdSelect.length);
                                out[0] = format;
                                for(i = 0; i < fdSelect.fdSelect.length; i++)out[i + 1] = fdSelect.fdSelect[i];
                                break;
                            case 3:
                                const start = 0;
                                let lastFD = fdSelect.fdSelect[0];
                                const ranges = [
                                    format,
                                    0,
                                    0,
                                    start >> 8 & 0xff,
                                    start & 0xff,
                                    lastFD
                                ];
                                for(i = 1; i < fdSelect.fdSelect.length; i++){
                                    const currentFD = fdSelect.fdSelect[i];
                                    if (currentFD !== lastFD) {
                                        ranges.push(i >> 8 & 0xff, i & 0xff, currentFD);
                                        lastFD = currentFD;
                                    }
                                }
                                const numRanges = (ranges.length - 3) / 3;
                                ranges[1] = numRanges >> 8 & 0xff;
                                ranges[2] = numRanges & 0xff;
                                ranges.push(i >> 8 & 0xff, i & 0xff);
                                out = new Uint8Array(ranges);
                                break;
                        }
                        return this.compileTypedArray(out);
                    }
                    compileTypedArray(data) {
                        return Array.from(data);
                    }
                    compileIndex(index, trackers = []) {
                        const objects = index.objects;
                        const count = objects.length;
                        if (count === 0) return [
                            0,
                            0
                        ];
                        const data = [
                            count >> 8 & 0xff,
                            count & 0xff
                        ];
                        let lastOffset = 1, i;
                        for(i = 0; i < count; ++i)lastOffset += objects[i].length;
                        let offsetSize;
                        if (lastOffset < 0x100) offsetSize = 1;
                        else if (lastOffset < 0x10000) offsetSize = 2;
                        else if (lastOffset < 0x1000000) offsetSize = 3;
                        else offsetSize = 4;
                        data.push(offsetSize);
                        let relativeOffset = 1;
                        for(i = 0; i < count + 1; i++){
                            if (offsetSize === 1) data.push(relativeOffset & 0xff);
                            else if (offsetSize === 2) data.push(relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            else if (offsetSize === 3) data.push(relativeOffset >> 16 & 0xff, relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            else data.push(relativeOffset >>> 24 & 0xff, relativeOffset >> 16 & 0xff, relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            if (objects[i]) relativeOffset += objects[i].length;
                        }
                        for(i = 0; i < count; i++){
                            if (trackers[i]) trackers[i].offset(data.length);
                            data.push(...objects[i]);
                        }
                        return data;
                    }
                }
                exports.CFFCompiler = CFFCompiler;
            /***/ },
            /* 36 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ISOAdobeCharset = exports.ExpertSubsetCharset = exports.ExpertCharset = void 0;
                const ISOAdobeCharset = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron"
                ];
                exports.ISOAdobeCharset = ISOAdobeCharset;
                const ExpertCharset = [
                    ".notdef",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                exports.ExpertCharset = ExpertCharset;
                const ExpertSubsetCharset = [
                    ".notdef",
                    "space",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "hyphensuperior",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "centoldstyle",
                    "figuredash",
                    "hypheninferior",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior"
                ];
                exports.ExpertSubsetCharset = ExpertSubsetCharset;
            /***/ },
            /* 37 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ZapfDingbatsEncoding = exports.WinAnsiEncoding = exports.SymbolSetEncoding = exports.StandardEncoding = exports.MacRomanEncoding = exports.ExpertEncoding = void 0;
                exports.getEncoding = getEncoding;
                const ExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "",
                    "",
                    "",
                    "isuperior",
                    "",
                    "",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "",
                    "",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "",
                    "",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "",
                    "Dotaccentsmall",
                    "",
                    "",
                    "Macronsmall",
                    "",
                    "",
                    "figuredash",
                    "hypheninferior",
                    "",
                    "",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                exports.ExpertEncoding = ExpertEncoding;
                const MacExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "centoldstyle",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "",
                    "threequartersemdash",
                    "",
                    "questionsmall",
                    "",
                    "",
                    "",
                    "",
                    "Ethsmall",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hypheninferior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "asuperior",
                    "centsuperior",
                    "",
                    "",
                    "",
                    "",
                    "Aacutesmall",
                    "Agravesmall",
                    "Acircumflexsmall",
                    "Adieresissmall",
                    "Atildesmall",
                    "Aringsmall",
                    "Ccedillasmall",
                    "Eacutesmall",
                    "Egravesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Iacutesmall",
                    "Igravesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ntildesmall",
                    "Oacutesmall",
                    "Ogravesmall",
                    "Ocircumflexsmall",
                    "Odieresissmall",
                    "Otildesmall",
                    "Uacutesmall",
                    "Ugravesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "",
                    "eightsuperior",
                    "fourinferior",
                    "threeinferior",
                    "sixinferior",
                    "eightinferior",
                    "seveninferior",
                    "Scaronsmall",
                    "",
                    "centinferior",
                    "twoinferior",
                    "",
                    "Dieresissmall",
                    "",
                    "Caronsmall",
                    "osuperior",
                    "fiveinferior",
                    "",
                    "commainferior",
                    "periodinferior",
                    "Yacutesmall",
                    "",
                    "dollarinferior",
                    "",
                    "",
                    "Thornsmall",
                    "",
                    "nineinferior",
                    "zeroinferior",
                    "Zcaronsmall",
                    "AEsmall",
                    "Oslashsmall",
                    "questiondownsmall",
                    "oneinferior",
                    "Lslashsmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "OEsmall",
                    "figuredash",
                    "hyphensuperior",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "",
                    "Ydieresissmall",
                    "",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "ninesuperior",
                    "zerosuperior",
                    "",
                    "esuperior",
                    "rsuperior",
                    "tsuperior",
                    "",
                    "",
                    "isuperior",
                    "ssuperior",
                    "dsuperior",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "lsuperior",
                    "Ogoneksmall",
                    "Brevesmall",
                    "Macronsmall",
                    "bsuperior",
                    "nsuperior",
                    "msuperior",
                    "commasuperior",
                    "periodsuperior",
                    "Dotaccentsmall",
                    "Ringsmall",
                    "",
                    "",
                    "",
                    ""
                ];
                const MacRomanEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "space",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron"
                ];
                exports.MacRomanEncoding = MacRomanEncoding;
                const StandardEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "",
                    "questiondown",
                    "",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "",
                    "ring",
                    "cedilla",
                    "",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "AE",
                    "",
                    "ordfeminine",
                    "",
                    "",
                    "",
                    "",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ae",
                    "",
                    "",
                    "",
                    "dotlessi",
                    "",
                    "",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "",
                    "",
                    "",
                    ""
                ];
                exports.StandardEncoding = StandardEncoding;
                const WinAnsiEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "bullet",
                    "Euro",
                    "bullet",
                    "quotesinglbase",
                    "florin",
                    "quotedblbase",
                    "ellipsis",
                    "dagger",
                    "daggerdbl",
                    "circumflex",
                    "perthousand",
                    "Scaron",
                    "guilsinglleft",
                    "OE",
                    "bullet",
                    "Zcaron",
                    "bullet",
                    "bullet",
                    "quoteleft",
                    "quoteright",
                    "quotedblleft",
                    "quotedblright",
                    "bullet",
                    "endash",
                    "emdash",
                    "tilde",
                    "trademark",
                    "scaron",
                    "guilsinglright",
                    "oe",
                    "bullet",
                    "zcaron",
                    "Ydieresis",
                    "space",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "currency",
                    "yen",
                    "brokenbar",
                    "section",
                    "dieresis",
                    "copyright",
                    "ordfeminine",
                    "guillemotleft",
                    "logicalnot",
                    "hyphen",
                    "registered",
                    "macron",
                    "degree",
                    "plusminus",
                    "twosuperior",
                    "threesuperior",
                    "acute",
                    "mu",
                    "paragraph",
                    "periodcentered",
                    "cedilla",
                    "onesuperior",
                    "ordmasculine",
                    "guillemotright",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondown",
                    "Agrave",
                    "Aacute",
                    "Acircumflex",
                    "Atilde",
                    "Adieresis",
                    "Aring",
                    "AE",
                    "Ccedilla",
                    "Egrave",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Igrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Eth",
                    "Ntilde",
                    "Ograve",
                    "Oacute",
                    "Ocircumflex",
                    "Otilde",
                    "Odieresis",
                    "multiply",
                    "Oslash",
                    "Ugrave",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Yacute",
                    "Thorn",
                    "germandbls",
                    "agrave",
                    "aacute",
                    "acircumflex",
                    "atilde",
                    "adieresis",
                    "aring",
                    "ae",
                    "ccedilla",
                    "egrave",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "igrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "eth",
                    "ntilde",
                    "ograve",
                    "oacute",
                    "ocircumflex",
                    "otilde",
                    "odieresis",
                    "divide",
                    "oslash",
                    "ugrave",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "yacute",
                    "thorn",
                    "ydieresis"
                ];
                exports.WinAnsiEncoding = WinAnsiEncoding;
                const SymbolSetEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "universal",
                    "numbersign",
                    "existential",
                    "percent",
                    "ampersand",
                    "suchthat",
                    "parenleft",
                    "parenright",
                    "asteriskmath",
                    "plus",
                    "comma",
                    "minus",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "congruent",
                    "Alpha",
                    "Beta",
                    "Chi",
                    "Delta",
                    "Epsilon",
                    "Phi",
                    "Gamma",
                    "Eta",
                    "Iota",
                    "theta1",
                    "Kappa",
                    "Lambda",
                    "Mu",
                    "Nu",
                    "Omicron",
                    "Pi",
                    "Theta",
                    "Rho",
                    "Sigma",
                    "Tau",
                    "Upsilon",
                    "sigma1",
                    "Omega",
                    "Xi",
                    "Psi",
                    "Zeta",
                    "bracketleft",
                    "therefore",
                    "bracketright",
                    "perpendicular",
                    "underscore",
                    "radicalex",
                    "alpha",
                    "beta",
                    "chi",
                    "delta",
                    "epsilon",
                    "phi",
                    "gamma",
                    "eta",
                    "iota",
                    "phi1",
                    "kappa",
                    "lambda",
                    "mu",
                    "nu",
                    "omicron",
                    "pi",
                    "theta",
                    "rho",
                    "sigma",
                    "tau",
                    "upsilon",
                    "omega1",
                    "omega",
                    "xi",
                    "psi",
                    "zeta",
                    "braceleft",
                    "bar",
                    "braceright",
                    "similar",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Euro",
                    "Upsilon1",
                    "minute",
                    "lessequal",
                    "fraction",
                    "infinity",
                    "florin",
                    "club",
                    "diamond",
                    "heart",
                    "spade",
                    "arrowboth",
                    "arrowleft",
                    "arrowup",
                    "arrowright",
                    "arrowdown",
                    "degree",
                    "plusminus",
                    "second",
                    "greaterequal",
                    "multiply",
                    "proportional",
                    "partialdiff",
                    "bullet",
                    "divide",
                    "notequal",
                    "equivalence",
                    "approxequal",
                    "ellipsis",
                    "arrowvertex",
                    "arrowhorizex",
                    "carriagereturn",
                    "aleph",
                    "Ifraktur",
                    "Rfraktur",
                    "weierstrass",
                    "circlemultiply",
                    "circleplus",
                    "emptyset",
                    "intersection",
                    "union",
                    "propersuperset",
                    "reflexsuperset",
                    "notsubset",
                    "propersubset",
                    "reflexsubset",
                    "element",
                    "notelement",
                    "angle",
                    "gradient",
                    "registerserif",
                    "copyrightserif",
                    "trademarkserif",
                    "product",
                    "radical",
                    "dotmath",
                    "logicalnot",
                    "logicaland",
                    "logicalor",
                    "arrowdblboth",
                    "arrowdblleft",
                    "arrowdblup",
                    "arrowdblright",
                    "arrowdbldown",
                    "lozenge",
                    "angleleft",
                    "registersans",
                    "copyrightsans",
                    "trademarksans",
                    "summation",
                    "parenlefttp",
                    "parenleftex",
                    "parenleftbt",
                    "bracketlefttp",
                    "bracketleftex",
                    "bracketleftbt",
                    "bracelefttp",
                    "braceleftmid",
                    "braceleftbt",
                    "braceex",
                    "",
                    "angleright",
                    "integral",
                    "integraltp",
                    "integralex",
                    "integralbt",
                    "parenrighttp",
                    "parenrightex",
                    "parenrightbt",
                    "bracketrighttp",
                    "bracketrightex",
                    "bracketrightbt",
                    "bracerighttp",
                    "bracerightmid",
                    "bracerightbt",
                    ""
                ];
                exports.SymbolSetEncoding = SymbolSetEncoding;
                const ZapfDingbatsEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "a1",
                    "a2",
                    "a202",
                    "a3",
                    "a4",
                    "a5",
                    "a119",
                    "a118",
                    "a117",
                    "a11",
                    "a12",
                    "a13",
                    "a14",
                    "a15",
                    "a16",
                    "a105",
                    "a17",
                    "a18",
                    "a19",
                    "a20",
                    "a21",
                    "a22",
                    "a23",
                    "a24",
                    "a25",
                    "a26",
                    "a27",
                    "a28",
                    "a6",
                    "a7",
                    "a8",
                    "a9",
                    "a10",
                    "a29",
                    "a30",
                    "a31",
                    "a32",
                    "a33",
                    "a34",
                    "a35",
                    "a36",
                    "a37",
                    "a38",
                    "a39",
                    "a40",
                    "a41",
                    "a42",
                    "a43",
                    "a44",
                    "a45",
                    "a46",
                    "a47",
                    "a48",
                    "a49",
                    "a50",
                    "a51",
                    "a52",
                    "a53",
                    "a54",
                    "a55",
                    "a56",
                    "a57",
                    "a58",
                    "a59",
                    "a60",
                    "a61",
                    "a62",
                    "a63",
                    "a64",
                    "a65",
                    "a66",
                    "a67",
                    "a68",
                    "a69",
                    "a70",
                    "a71",
                    "a72",
                    "a73",
                    "a74",
                    "a203",
                    "a75",
                    "a204",
                    "a76",
                    "a77",
                    "a78",
                    "a79",
                    "a81",
                    "a82",
                    "a83",
                    "a84",
                    "a97",
                    "a98",
                    "a99",
                    "a100",
                    "",
                    "a89",
                    "a90",
                    "a93",
                    "a94",
                    "a91",
                    "a92",
                    "a205",
                    "a85",
                    "a206",
                    "a86",
                    "a87",
                    "a88",
                    "a95",
                    "a96",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "a101",
                    "a102",
                    "a103",
                    "a104",
                    "a106",
                    "a107",
                    "a108",
                    "a112",
                    "a111",
                    "a110",
                    "a109",
                    "a120",
                    "a121",
                    "a122",
                    "a123",
                    "a124",
                    "a125",
                    "a126",
                    "a127",
                    "a128",
                    "a129",
                    "a130",
                    "a131",
                    "a132",
                    "a133",
                    "a134",
                    "a135",
                    "a136",
                    "a137",
                    "a138",
                    "a139",
                    "a140",
                    "a141",
                    "a142",
                    "a143",
                    "a144",
                    "a145",
                    "a146",
                    "a147",
                    "a148",
                    "a149",
                    "a150",
                    "a151",
                    "a152",
                    "a153",
                    "a154",
                    "a155",
                    "a156",
                    "a157",
                    "a158",
                    "a159",
                    "a160",
                    "a161",
                    "a163",
                    "a164",
                    "a196",
                    "a165",
                    "a192",
                    "a166",
                    "a167",
                    "a168",
                    "a169",
                    "a170",
                    "a171",
                    "a172",
                    "a173",
                    "a162",
                    "a174",
                    "a175",
                    "a176",
                    "a177",
                    "a178",
                    "a179",
                    "a193",
                    "a180",
                    "a199",
                    "a181",
                    "a200",
                    "a182",
                    "",
                    "a201",
                    "a183",
                    "a184",
                    "a197",
                    "a185",
                    "a194",
                    "a198",
                    "a186",
                    "a195",
                    "a187",
                    "a188",
                    "a189",
                    "a190",
                    "a191",
                    ""
                ];
                exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
                function getEncoding(encodingName) {
                    switch(encodingName){
                        case "WinAnsiEncoding":
                            return WinAnsiEncoding;
                        case "StandardEncoding":
                            return StandardEncoding;
                        case "MacRomanEncoding":
                            return MacRomanEncoding;
                        case "SymbolSetEncoding":
                            return SymbolSetEncoding;
                        case "ZapfDingbatsEncoding":
                            return ZapfDingbatsEncoding;
                        case "ExpertEncoding":
                            return ExpertEncoding;
                        case "MacExpertEncoding":
                            return MacExpertEncoding;
                        default:
                            return null;
                    }
                }
            /***/ },
            /* 38 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SEAC_ANALYSIS_ENABLED = exports.MacStandardGlyphOrdering = exports.FontFlags = void 0;
                exports.normalizeFontName = normalizeFontName;
                exports.recoverGlyphName = recoverGlyphName;
                exports.type1FontGlyphMapping = type1FontGlyphMapping;
                var _encodings = __w_pdfjs_require__(37);
                var _glyphlist = __w_pdfjs_require__(39);
                var _unicode = __w_pdfjs_require__(40);
                var _util = __w_pdfjs_require__(2);
                const SEAC_ANALYSIS_ENABLED = true;
                exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
                const FontFlags = {
                    FixedPitch: 1,
                    Serif: 2,
                    Symbolic: 4,
                    Script: 8,
                    Nonsymbolic: 32,
                    Italic: 64,
                    AllCap: 65536,
                    SmallCap: 131072,
                    ForceBold: 262144
                };
                exports.FontFlags = FontFlags;
                const MacStandardGlyphOrdering = [
                    ".notdef",
                    ".null",
                    "nonmarkingreturn",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "nonbreakingspace",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "Lslash",
                    "lslash",
                    "Scaron",
                    "scaron",
                    "Zcaron",
                    "zcaron",
                    "brokenbar",
                    "Eth",
                    "eth",
                    "Yacute",
                    "yacute",
                    "Thorn",
                    "thorn",
                    "minus",
                    "multiply",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "onehalf",
                    "onequarter",
                    "threequarters",
                    "franc",
                    "Gbreve",
                    "gbreve",
                    "Idotaccent",
                    "Scedilla",
                    "scedilla",
                    "Cacute",
                    "cacute",
                    "Ccaron",
                    "ccaron",
                    "dcroat"
                ];
                exports.MacStandardGlyphOrdering = MacStandardGlyphOrdering;
                function recoverGlyphName(name, glyphsUnicodeMap) {
                    if (glyphsUnicodeMap[name] !== undefined) return name;
                    const unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
                    if (unicode !== -1) for(const key in glyphsUnicodeMap){
                        if (glyphsUnicodeMap[key] === unicode) return key;
                    }
                    (0, _util.info)("Unable to recover a standard glyph name for: " + name);
                    return name;
                }
                function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
                    const charCodeToGlyphId = Object.create(null);
                    let glyphId, charCode, baseEncoding;
                    const isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
                    if (properties.isInternalFont) {
                        baseEncoding = builtInEncoding;
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                        }
                    } else if (properties.baseEncodingName) {
                        baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                        }
                    } else if (isSymbolicFont) for(charCode in builtInEncoding)charCodeToGlyphId[charCode] = builtInEncoding[charCode];
                    else {
                        baseEncoding = _encodings.StandardEncoding;
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                        }
                    }
                    const differences = properties.differences;
                    let glyphsUnicodeMap;
                    if (differences) for(charCode in differences){
                        const glyphName = differences[charCode];
                        glyphId = glyphNames.indexOf(glyphName);
                        if (glyphId === -1) {
                            if (!glyphsUnicodeMap) glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
                            if (standardGlyphName !== glyphName) glyphId = glyphNames.indexOf(standardGlyphName);
                        }
                        charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                    }
                    return charCodeToGlyphId;
                }
                function normalizeFontName(name) {
                    return name.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
                }
            /***/ },
            /* 39 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getGlyphsUnicode = exports.getDingbatsGlyphsUnicode = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                const getGlyphsUnicode = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.A = 0x0041;
                    t.AE = 0x00c6;
                    t.AEacute = 0x01fc;
                    t.AEmacron = 0x01e2;
                    t.AEsmall = 0xf7e6;
                    t.Aacute = 0x00c1;
                    t.Aacutesmall = 0xf7e1;
                    t.Abreve = 0x0102;
                    t.Abreveacute = 0x1eae;
                    t.Abrevecyrillic = 0x04d0;
                    t.Abrevedotbelow = 0x1eb6;
                    t.Abrevegrave = 0x1eb0;
                    t.Abrevehookabove = 0x1eb2;
                    t.Abrevetilde = 0x1eb4;
                    t.Acaron = 0x01cd;
                    t.Acircle = 0x24b6;
                    t.Acircumflex = 0x00c2;
                    t.Acircumflexacute = 0x1ea4;
                    t.Acircumflexdotbelow = 0x1eac;
                    t.Acircumflexgrave = 0x1ea6;
                    t.Acircumflexhookabove = 0x1ea8;
                    t.Acircumflexsmall = 0xf7e2;
                    t.Acircumflextilde = 0x1eaa;
                    t.Acute = 0xf6c9;
                    t.Acutesmall = 0xf7b4;
                    t.Acyrillic = 0x0410;
                    t.Adblgrave = 0x0200;
                    t.Adieresis = 0x00c4;
                    t.Adieresiscyrillic = 0x04d2;
                    t.Adieresismacron = 0x01de;
                    t.Adieresissmall = 0xf7e4;
                    t.Adotbelow = 0x1ea0;
                    t.Adotmacron = 0x01e0;
                    t.Agrave = 0x00c0;
                    t.Agravesmall = 0xf7e0;
                    t.Ahookabove = 0x1ea2;
                    t.Aiecyrillic = 0x04d4;
                    t.Ainvertedbreve = 0x0202;
                    t.Alpha = 0x0391;
                    t.Alphatonos = 0x0386;
                    t.Amacron = 0x0100;
                    t.Amonospace = 0xff21;
                    t.Aogonek = 0x0104;
                    t.Aring = 0x00c5;
                    t.Aringacute = 0x01fa;
                    t.Aringbelow = 0x1e00;
                    t.Aringsmall = 0xf7e5;
                    t.Asmall = 0xf761;
                    t.Atilde = 0x00c3;
                    t.Atildesmall = 0xf7e3;
                    t.Aybarmenian = 0x0531;
                    t.B = 0x0042;
                    t.Bcircle = 0x24b7;
                    t.Bdotaccent = 0x1e02;
                    t.Bdotbelow = 0x1e04;
                    t.Becyrillic = 0x0411;
                    t.Benarmenian = 0x0532;
                    t.Beta = 0x0392;
                    t.Bhook = 0x0181;
                    t.Blinebelow = 0x1e06;
                    t.Bmonospace = 0xff22;
                    t.Brevesmall = 0xf6f4;
                    t.Bsmall = 0xf762;
                    t.Btopbar = 0x0182;
                    t.C = 0x0043;
                    t.Caarmenian = 0x053e;
                    t.Cacute = 0x0106;
                    t.Caron = 0xf6ca;
                    t.Caronsmall = 0xf6f5;
                    t.Ccaron = 0x010c;
                    t.Ccedilla = 0x00c7;
                    t.Ccedillaacute = 0x1e08;
                    t.Ccedillasmall = 0xf7e7;
                    t.Ccircle = 0x24b8;
                    t.Ccircumflex = 0x0108;
                    t.Cdot = 0x010a;
                    t.Cdotaccent = 0x010a;
                    t.Cedillasmall = 0xf7b8;
                    t.Chaarmenian = 0x0549;
                    t.Cheabkhasiancyrillic = 0x04bc;
                    t.Checyrillic = 0x0427;
                    t.Chedescenderabkhasiancyrillic = 0x04be;
                    t.Chedescendercyrillic = 0x04b6;
                    t.Chedieresiscyrillic = 0x04f4;
                    t.Cheharmenian = 0x0543;
                    t.Chekhakassiancyrillic = 0x04cb;
                    t.Cheverticalstrokecyrillic = 0x04b8;
                    t.Chi = 0x03a7;
                    t.Chook = 0x0187;
                    t.Circumflexsmall = 0xf6f6;
                    t.Cmonospace = 0xff23;
                    t.Coarmenian = 0x0551;
                    t.Csmall = 0xf763;
                    t.D = 0x0044;
                    t.DZ = 0x01f1;
                    t.DZcaron = 0x01c4;
                    t.Daarmenian = 0x0534;
                    t.Dafrican = 0x0189;
                    t.Dcaron = 0x010e;
                    t.Dcedilla = 0x1e10;
                    t.Dcircle = 0x24b9;
                    t.Dcircumflexbelow = 0x1e12;
                    t.Dcroat = 0x0110;
                    t.Ddotaccent = 0x1e0a;
                    t.Ddotbelow = 0x1e0c;
                    t.Decyrillic = 0x0414;
                    t.Deicoptic = 0x03ee;
                    t.Delta = 0x2206;
                    t.Deltagreek = 0x0394;
                    t.Dhook = 0x018a;
                    t.Dieresis = 0xf6cb;
                    t.DieresisAcute = 0xf6cc;
                    t.DieresisGrave = 0xf6cd;
                    t.Dieresissmall = 0xf7a8;
                    t.Digammagreek = 0x03dc;
                    t.Djecyrillic = 0x0402;
                    t.Dlinebelow = 0x1e0e;
                    t.Dmonospace = 0xff24;
                    t.Dotaccentsmall = 0xf6f7;
                    t.Dslash = 0x0110;
                    t.Dsmall = 0xf764;
                    t.Dtopbar = 0x018b;
                    t.Dz = 0x01f2;
                    t.Dzcaron = 0x01c5;
                    t.Dzeabkhasiancyrillic = 0x04e0;
                    t.Dzecyrillic = 0x0405;
                    t.Dzhecyrillic = 0x040f;
                    t.E = 0x0045;
                    t.Eacute = 0x00c9;
                    t.Eacutesmall = 0xf7e9;
                    t.Ebreve = 0x0114;
                    t.Ecaron = 0x011a;
                    t.Ecedillabreve = 0x1e1c;
                    t.Echarmenian = 0x0535;
                    t.Ecircle = 0x24ba;
                    t.Ecircumflex = 0x00ca;
                    t.Ecircumflexacute = 0x1ebe;
                    t.Ecircumflexbelow = 0x1e18;
                    t.Ecircumflexdotbelow = 0x1ec6;
                    t.Ecircumflexgrave = 0x1ec0;
                    t.Ecircumflexhookabove = 0x1ec2;
                    t.Ecircumflexsmall = 0xf7ea;
                    t.Ecircumflextilde = 0x1ec4;
                    t.Ecyrillic = 0x0404;
                    t.Edblgrave = 0x0204;
                    t.Edieresis = 0x00cb;
                    t.Edieresissmall = 0xf7eb;
                    t.Edot = 0x0116;
                    t.Edotaccent = 0x0116;
                    t.Edotbelow = 0x1eb8;
                    t.Efcyrillic = 0x0424;
                    t.Egrave = 0x00c8;
                    t.Egravesmall = 0xf7e8;
                    t.Eharmenian = 0x0537;
                    t.Ehookabove = 0x1eba;
                    t.Eightroman = 0x2167;
                    t.Einvertedbreve = 0x0206;
                    t.Eiotifiedcyrillic = 0x0464;
                    t.Elcyrillic = 0x041b;
                    t.Elevenroman = 0x216a;
                    t.Emacron = 0x0112;
                    t.Emacronacute = 0x1e16;
                    t.Emacrongrave = 0x1e14;
                    t.Emcyrillic = 0x041c;
                    t.Emonospace = 0xff25;
                    t.Encyrillic = 0x041d;
                    t.Endescendercyrillic = 0x04a2;
                    t.Eng = 0x014a;
                    t.Enghecyrillic = 0x04a4;
                    t.Enhookcyrillic = 0x04c7;
                    t.Eogonek = 0x0118;
                    t.Eopen = 0x0190;
                    t.Epsilon = 0x0395;
                    t.Epsilontonos = 0x0388;
                    t.Ercyrillic = 0x0420;
                    t.Ereversed = 0x018e;
                    t.Ereversedcyrillic = 0x042d;
                    t.Escyrillic = 0x0421;
                    t.Esdescendercyrillic = 0x04aa;
                    t.Esh = 0x01a9;
                    t.Esmall = 0xf765;
                    t.Eta = 0x0397;
                    t.Etarmenian = 0x0538;
                    t.Etatonos = 0x0389;
                    t.Eth = 0x00d0;
                    t.Ethsmall = 0xf7f0;
                    t.Etilde = 0x1ebc;
                    t.Etildebelow = 0x1e1a;
                    t.Euro = 0x20ac;
                    t.Ezh = 0x01b7;
                    t.Ezhcaron = 0x01ee;
                    t.Ezhreversed = 0x01b8;
                    t.F = 0x0046;
                    t.Fcircle = 0x24bb;
                    t.Fdotaccent = 0x1e1e;
                    t.Feharmenian = 0x0556;
                    t.Feicoptic = 0x03e4;
                    t.Fhook = 0x0191;
                    t.Fitacyrillic = 0x0472;
                    t.Fiveroman = 0x2164;
                    t.Fmonospace = 0xff26;
                    t.Fourroman = 0x2163;
                    t.Fsmall = 0xf766;
                    t.G = 0x0047;
                    t.GBsquare = 0x3387;
                    t.Gacute = 0x01f4;
                    t.Gamma = 0x0393;
                    t.Gammaafrican = 0x0194;
                    t.Gangiacoptic = 0x03ea;
                    t.Gbreve = 0x011e;
                    t.Gcaron = 0x01e6;
                    t.Gcedilla = 0x0122;
                    t.Gcircle = 0x24bc;
                    t.Gcircumflex = 0x011c;
                    t.Gcommaaccent = 0x0122;
                    t.Gdot = 0x0120;
                    t.Gdotaccent = 0x0120;
                    t.Gecyrillic = 0x0413;
                    t.Ghadarmenian = 0x0542;
                    t.Ghemiddlehookcyrillic = 0x0494;
                    t.Ghestrokecyrillic = 0x0492;
                    t.Gheupturncyrillic = 0x0490;
                    t.Ghook = 0x0193;
                    t.Gimarmenian = 0x0533;
                    t.Gjecyrillic = 0x0403;
                    t.Gmacron = 0x1e20;
                    t.Gmonospace = 0xff27;
                    t.Grave = 0xf6ce;
                    t.Gravesmall = 0xf760;
                    t.Gsmall = 0xf767;
                    t.Gsmallhook = 0x029b;
                    t.Gstroke = 0x01e4;
                    t.H = 0x0048;
                    t.H18533 = 0x25cf;
                    t.H18543 = 0x25aa;
                    t.H18551 = 0x25ab;
                    t.H22073 = 0x25a1;
                    t.HPsquare = 0x33cb;
                    t.Haabkhasiancyrillic = 0x04a8;
                    t.Hadescendercyrillic = 0x04b2;
                    t.Hardsigncyrillic = 0x042a;
                    t.Hbar = 0x0126;
                    t.Hbrevebelow = 0x1e2a;
                    t.Hcedilla = 0x1e28;
                    t.Hcircle = 0x24bd;
                    t.Hcircumflex = 0x0124;
                    t.Hdieresis = 0x1e26;
                    t.Hdotaccent = 0x1e22;
                    t.Hdotbelow = 0x1e24;
                    t.Hmonospace = 0xff28;
                    t.Hoarmenian = 0x0540;
                    t.Horicoptic = 0x03e8;
                    t.Hsmall = 0xf768;
                    t.Hungarumlaut = 0xf6cf;
                    t.Hungarumlautsmall = 0xf6f8;
                    t.Hzsquare = 0x3390;
                    t.I = 0x0049;
                    t.IAcyrillic = 0x042f;
                    t.IJ = 0x0132;
                    t.IUcyrillic = 0x042e;
                    t.Iacute = 0x00cd;
                    t.Iacutesmall = 0xf7ed;
                    t.Ibreve = 0x012c;
                    t.Icaron = 0x01cf;
                    t.Icircle = 0x24be;
                    t.Icircumflex = 0x00ce;
                    t.Icircumflexsmall = 0xf7ee;
                    t.Icyrillic = 0x0406;
                    t.Idblgrave = 0x0208;
                    t.Idieresis = 0x00cf;
                    t.Idieresisacute = 0x1e2e;
                    t.Idieresiscyrillic = 0x04e4;
                    t.Idieresissmall = 0xf7ef;
                    t.Idot = 0x0130;
                    t.Idotaccent = 0x0130;
                    t.Idotbelow = 0x1eca;
                    t.Iebrevecyrillic = 0x04d6;
                    t.Iecyrillic = 0x0415;
                    t.Ifraktur = 0x2111;
                    t.Igrave = 0x00cc;
                    t.Igravesmall = 0xf7ec;
                    t.Ihookabove = 0x1ec8;
                    t.Iicyrillic = 0x0418;
                    t.Iinvertedbreve = 0x020a;
                    t.Iishortcyrillic = 0x0419;
                    t.Imacron = 0x012a;
                    t.Imacroncyrillic = 0x04e2;
                    t.Imonospace = 0xff29;
                    t.Iniarmenian = 0x053b;
                    t.Iocyrillic = 0x0401;
                    t.Iogonek = 0x012e;
                    t.Iota = 0x0399;
                    t.Iotaafrican = 0x0196;
                    t.Iotadieresis = 0x03aa;
                    t.Iotatonos = 0x038a;
                    t.Ismall = 0xf769;
                    t.Istroke = 0x0197;
                    t.Itilde = 0x0128;
                    t.Itildebelow = 0x1e2c;
                    t.Izhitsacyrillic = 0x0474;
                    t.Izhitsadblgravecyrillic = 0x0476;
                    t.J = 0x004a;
                    t.Jaarmenian = 0x0541;
                    t.Jcircle = 0x24bf;
                    t.Jcircumflex = 0x0134;
                    t.Jecyrillic = 0x0408;
                    t.Jheharmenian = 0x054b;
                    t.Jmonospace = 0xff2a;
                    t.Jsmall = 0xf76a;
                    t.K = 0x004b;
                    t.KBsquare = 0x3385;
                    t.KKsquare = 0x33cd;
                    t.Kabashkircyrillic = 0x04a0;
                    t.Kacute = 0x1e30;
                    t.Kacyrillic = 0x041a;
                    t.Kadescendercyrillic = 0x049a;
                    t.Kahookcyrillic = 0x04c3;
                    t.Kappa = 0x039a;
                    t.Kastrokecyrillic = 0x049e;
                    t.Kaverticalstrokecyrillic = 0x049c;
                    t.Kcaron = 0x01e8;
                    t.Kcedilla = 0x0136;
                    t.Kcircle = 0x24c0;
                    t.Kcommaaccent = 0x0136;
                    t.Kdotbelow = 0x1e32;
                    t.Keharmenian = 0x0554;
                    t.Kenarmenian = 0x053f;
                    t.Khacyrillic = 0x0425;
                    t.Kheicoptic = 0x03e6;
                    t.Khook = 0x0198;
                    t.Kjecyrillic = 0x040c;
                    t.Klinebelow = 0x1e34;
                    t.Kmonospace = 0xff2b;
                    t.Koppacyrillic = 0x0480;
                    t.Koppagreek = 0x03de;
                    t.Ksicyrillic = 0x046e;
                    t.Ksmall = 0xf76b;
                    t.L = 0x004c;
                    t.LJ = 0x01c7;
                    t.LL = 0xf6bf;
                    t.Lacute = 0x0139;
                    t.Lambda = 0x039b;
                    t.Lcaron = 0x013d;
                    t.Lcedilla = 0x013b;
                    t.Lcircle = 0x24c1;
                    t.Lcircumflexbelow = 0x1e3c;
                    t.Lcommaaccent = 0x013b;
                    t.Ldot = 0x013f;
                    t.Ldotaccent = 0x013f;
                    t.Ldotbelow = 0x1e36;
                    t.Ldotbelowmacron = 0x1e38;
                    t.Liwnarmenian = 0x053c;
                    t.Lj = 0x01c8;
                    t.Ljecyrillic = 0x0409;
                    t.Llinebelow = 0x1e3a;
                    t.Lmonospace = 0xff2c;
                    t.Lslash = 0x0141;
                    t.Lslashsmall = 0xf6f9;
                    t.Lsmall = 0xf76c;
                    t.M = 0x004d;
                    t.MBsquare = 0x3386;
                    t.Macron = 0xf6d0;
                    t.Macronsmall = 0xf7af;
                    t.Macute = 0x1e3e;
                    t.Mcircle = 0x24c2;
                    t.Mdotaccent = 0x1e40;
                    t.Mdotbelow = 0x1e42;
                    t.Menarmenian = 0x0544;
                    t.Mmonospace = 0xff2d;
                    t.Msmall = 0xf76d;
                    t.Mturned = 0x019c;
                    t.Mu = 0x039c;
                    t.N = 0x004e;
                    t.NJ = 0x01ca;
                    t.Nacute = 0x0143;
                    t.Ncaron = 0x0147;
                    t.Ncedilla = 0x0145;
                    t.Ncircle = 0x24c3;
                    t.Ncircumflexbelow = 0x1e4a;
                    t.Ncommaaccent = 0x0145;
                    t.Ndotaccent = 0x1e44;
                    t.Ndotbelow = 0x1e46;
                    t.Nhookleft = 0x019d;
                    t.Nineroman = 0x2168;
                    t.Nj = 0x01cb;
                    t.Njecyrillic = 0x040a;
                    t.Nlinebelow = 0x1e48;
                    t.Nmonospace = 0xff2e;
                    t.Nowarmenian = 0x0546;
                    t.Nsmall = 0xf76e;
                    t.Ntilde = 0x00d1;
                    t.Ntildesmall = 0xf7f1;
                    t.Nu = 0x039d;
                    t.O = 0x004f;
                    t.OE = 0x0152;
                    t.OEsmall = 0xf6fa;
                    t.Oacute = 0x00d3;
                    t.Oacutesmall = 0xf7f3;
                    t.Obarredcyrillic = 0x04e8;
                    t.Obarreddieresiscyrillic = 0x04ea;
                    t.Obreve = 0x014e;
                    t.Ocaron = 0x01d1;
                    t.Ocenteredtilde = 0x019f;
                    t.Ocircle = 0x24c4;
                    t.Ocircumflex = 0x00d4;
                    t.Ocircumflexacute = 0x1ed0;
                    t.Ocircumflexdotbelow = 0x1ed8;
                    t.Ocircumflexgrave = 0x1ed2;
                    t.Ocircumflexhookabove = 0x1ed4;
                    t.Ocircumflexsmall = 0xf7f4;
                    t.Ocircumflextilde = 0x1ed6;
                    t.Ocyrillic = 0x041e;
                    t.Odblacute = 0x0150;
                    t.Odblgrave = 0x020c;
                    t.Odieresis = 0x00d6;
                    t.Odieresiscyrillic = 0x04e6;
                    t.Odieresissmall = 0xf7f6;
                    t.Odotbelow = 0x1ecc;
                    t.Ogoneksmall = 0xf6fb;
                    t.Ograve = 0x00d2;
                    t.Ogravesmall = 0xf7f2;
                    t.Oharmenian = 0x0555;
                    t.Ohm = 0x2126;
                    t.Ohookabove = 0x1ece;
                    t.Ohorn = 0x01a0;
                    t.Ohornacute = 0x1eda;
                    t.Ohorndotbelow = 0x1ee2;
                    t.Ohorngrave = 0x1edc;
                    t.Ohornhookabove = 0x1ede;
                    t.Ohorntilde = 0x1ee0;
                    t.Ohungarumlaut = 0x0150;
                    t.Oi = 0x01a2;
                    t.Oinvertedbreve = 0x020e;
                    t.Omacron = 0x014c;
                    t.Omacronacute = 0x1e52;
                    t.Omacrongrave = 0x1e50;
                    t.Omega = 0x2126;
                    t.Omegacyrillic = 0x0460;
                    t.Omegagreek = 0x03a9;
                    t.Omegaroundcyrillic = 0x047a;
                    t.Omegatitlocyrillic = 0x047c;
                    t.Omegatonos = 0x038f;
                    t.Omicron = 0x039f;
                    t.Omicrontonos = 0x038c;
                    t.Omonospace = 0xff2f;
                    t.Oneroman = 0x2160;
                    t.Oogonek = 0x01ea;
                    t.Oogonekmacron = 0x01ec;
                    t.Oopen = 0x0186;
                    t.Oslash = 0x00d8;
                    t.Oslashacute = 0x01fe;
                    t.Oslashsmall = 0xf7f8;
                    t.Osmall = 0xf76f;
                    t.Ostrokeacute = 0x01fe;
                    t.Otcyrillic = 0x047e;
                    t.Otilde = 0x00d5;
                    t.Otildeacute = 0x1e4c;
                    t.Otildedieresis = 0x1e4e;
                    t.Otildesmall = 0xf7f5;
                    t.P = 0x0050;
                    t.Pacute = 0x1e54;
                    t.Pcircle = 0x24c5;
                    t.Pdotaccent = 0x1e56;
                    t.Pecyrillic = 0x041f;
                    t.Peharmenian = 0x054a;
                    t.Pemiddlehookcyrillic = 0x04a6;
                    t.Phi = 0x03a6;
                    t.Phook = 0x01a4;
                    t.Pi = 0x03a0;
                    t.Piwrarmenian = 0x0553;
                    t.Pmonospace = 0xff30;
                    t.Psi = 0x03a8;
                    t.Psicyrillic = 0x0470;
                    t.Psmall = 0xf770;
                    t.Q = 0x0051;
                    t.Qcircle = 0x24c6;
                    t.Qmonospace = 0xff31;
                    t.Qsmall = 0xf771;
                    t.R = 0x0052;
                    t.Raarmenian = 0x054c;
                    t.Racute = 0x0154;
                    t.Rcaron = 0x0158;
                    t.Rcedilla = 0x0156;
                    t.Rcircle = 0x24c7;
                    t.Rcommaaccent = 0x0156;
                    t.Rdblgrave = 0x0210;
                    t.Rdotaccent = 0x1e58;
                    t.Rdotbelow = 0x1e5a;
                    t.Rdotbelowmacron = 0x1e5c;
                    t.Reharmenian = 0x0550;
                    t.Rfraktur = 0x211c;
                    t.Rho = 0x03a1;
                    t.Ringsmall = 0xf6fc;
                    t.Rinvertedbreve = 0x0212;
                    t.Rlinebelow = 0x1e5e;
                    t.Rmonospace = 0xff32;
                    t.Rsmall = 0xf772;
                    t.Rsmallinverted = 0x0281;
                    t.Rsmallinvertedsuperior = 0x02b6;
                    t.S = 0x0053;
                    t.SF010000 = 0x250c;
                    t.SF020000 = 0x2514;
                    t.SF030000 = 0x2510;
                    t.SF040000 = 0x2518;
                    t.SF050000 = 0x253c;
                    t.SF060000 = 0x252c;
                    t.SF070000 = 0x2534;
                    t.SF080000 = 0x251c;
                    t.SF090000 = 0x2524;
                    t.SF100000 = 0x2500;
                    t.SF110000 = 0x2502;
                    t.SF190000 = 0x2561;
                    t.SF200000 = 0x2562;
                    t.SF210000 = 0x2556;
                    t.SF220000 = 0x2555;
                    t.SF230000 = 0x2563;
                    t.SF240000 = 0x2551;
                    t.SF250000 = 0x2557;
                    t.SF260000 = 0x255d;
                    t.SF270000 = 0x255c;
                    t.SF280000 = 0x255b;
                    t.SF360000 = 0x255e;
                    t.SF370000 = 0x255f;
                    t.SF380000 = 0x255a;
                    t.SF390000 = 0x2554;
                    t.SF400000 = 0x2569;
                    t.SF410000 = 0x2566;
                    t.SF420000 = 0x2560;
                    t.SF430000 = 0x2550;
                    t.SF440000 = 0x256c;
                    t.SF450000 = 0x2567;
                    t.SF460000 = 0x2568;
                    t.SF470000 = 0x2564;
                    t.SF480000 = 0x2565;
                    t.SF490000 = 0x2559;
                    t.SF500000 = 0x2558;
                    t.SF510000 = 0x2552;
                    t.SF520000 = 0x2553;
                    t.SF530000 = 0x256b;
                    t.SF540000 = 0x256a;
                    t.Sacute = 0x015a;
                    t.Sacutedotaccent = 0x1e64;
                    t.Sampigreek = 0x03e0;
                    t.Scaron = 0x0160;
                    t.Scarondotaccent = 0x1e66;
                    t.Scaronsmall = 0xf6fd;
                    t.Scedilla = 0x015e;
                    t.Schwa = 0x018f;
                    t.Schwacyrillic = 0x04d8;
                    t.Schwadieresiscyrillic = 0x04da;
                    t.Scircle = 0x24c8;
                    t.Scircumflex = 0x015c;
                    t.Scommaaccent = 0x0218;
                    t.Sdotaccent = 0x1e60;
                    t.Sdotbelow = 0x1e62;
                    t.Sdotbelowdotaccent = 0x1e68;
                    t.Seharmenian = 0x054d;
                    t.Sevenroman = 0x2166;
                    t.Shaarmenian = 0x0547;
                    t.Shacyrillic = 0x0428;
                    t.Shchacyrillic = 0x0429;
                    t.Sheicoptic = 0x03e2;
                    t.Shhacyrillic = 0x04ba;
                    t.Shimacoptic = 0x03ec;
                    t.Sigma = 0x03a3;
                    t.Sixroman = 0x2165;
                    t.Smonospace = 0xff33;
                    t.Softsigncyrillic = 0x042c;
                    t.Ssmall = 0xf773;
                    t.Stigmagreek = 0x03da;
                    t.T = 0x0054;
                    t.Tau = 0x03a4;
                    t.Tbar = 0x0166;
                    t.Tcaron = 0x0164;
                    t.Tcedilla = 0x0162;
                    t.Tcircle = 0x24c9;
                    t.Tcircumflexbelow = 0x1e70;
                    t.Tcommaaccent = 0x0162;
                    t.Tdotaccent = 0x1e6a;
                    t.Tdotbelow = 0x1e6c;
                    t.Tecyrillic = 0x0422;
                    t.Tedescendercyrillic = 0x04ac;
                    t.Tenroman = 0x2169;
                    t.Tetsecyrillic = 0x04b4;
                    t.Theta = 0x0398;
                    t.Thook = 0x01ac;
                    t.Thorn = 0x00de;
                    t.Thornsmall = 0xf7fe;
                    t.Threeroman = 0x2162;
                    t.Tildesmall = 0xf6fe;
                    t.Tiwnarmenian = 0x054f;
                    t.Tlinebelow = 0x1e6e;
                    t.Tmonospace = 0xff34;
                    t.Toarmenian = 0x0539;
                    t.Tonefive = 0x01bc;
                    t.Tonesix = 0x0184;
                    t.Tonetwo = 0x01a7;
                    t.Tretroflexhook = 0x01ae;
                    t.Tsecyrillic = 0x0426;
                    t.Tshecyrillic = 0x040b;
                    t.Tsmall = 0xf774;
                    t.Twelveroman = 0x216b;
                    t.Tworoman = 0x2161;
                    t.U = 0x0055;
                    t.Uacute = 0x00da;
                    t.Uacutesmall = 0xf7fa;
                    t.Ubreve = 0x016c;
                    t.Ucaron = 0x01d3;
                    t.Ucircle = 0x24ca;
                    t.Ucircumflex = 0x00db;
                    t.Ucircumflexbelow = 0x1e76;
                    t.Ucircumflexsmall = 0xf7fb;
                    t.Ucyrillic = 0x0423;
                    t.Udblacute = 0x0170;
                    t.Udblgrave = 0x0214;
                    t.Udieresis = 0x00dc;
                    t.Udieresisacute = 0x01d7;
                    t.Udieresisbelow = 0x1e72;
                    t.Udieresiscaron = 0x01d9;
                    t.Udieresiscyrillic = 0x04f0;
                    t.Udieresisgrave = 0x01db;
                    t.Udieresismacron = 0x01d5;
                    t.Udieresissmall = 0xf7fc;
                    t.Udotbelow = 0x1ee4;
                    t.Ugrave = 0x00d9;
                    t.Ugravesmall = 0xf7f9;
                    t.Uhookabove = 0x1ee6;
                    t.Uhorn = 0x01af;
                    t.Uhornacute = 0x1ee8;
                    t.Uhorndotbelow = 0x1ef0;
                    t.Uhorngrave = 0x1eea;
                    t.Uhornhookabove = 0x1eec;
                    t.Uhorntilde = 0x1eee;
                    t.Uhungarumlaut = 0x0170;
                    t.Uhungarumlautcyrillic = 0x04f2;
                    t.Uinvertedbreve = 0x0216;
                    t.Ukcyrillic = 0x0478;
                    t.Umacron = 0x016a;
                    t.Umacroncyrillic = 0x04ee;
                    t.Umacrondieresis = 0x1e7a;
                    t.Umonospace = 0xff35;
                    t.Uogonek = 0x0172;
                    t.Upsilon = 0x03a5;
                    t.Upsilon1 = 0x03d2;
                    t.Upsilonacutehooksymbolgreek = 0x03d3;
                    t.Upsilonafrican = 0x01b1;
                    t.Upsilondieresis = 0x03ab;
                    t.Upsilondieresishooksymbolgreek = 0x03d4;
                    t.Upsilonhooksymbol = 0x03d2;
                    t.Upsilontonos = 0x038e;
                    t.Uring = 0x016e;
                    t.Ushortcyrillic = 0x040e;
                    t.Usmall = 0xf775;
                    t.Ustraightcyrillic = 0x04ae;
                    t.Ustraightstrokecyrillic = 0x04b0;
                    t.Utilde = 0x0168;
                    t.Utildeacute = 0x1e78;
                    t.Utildebelow = 0x1e74;
                    t.V = 0x0056;
                    t.Vcircle = 0x24cb;
                    t.Vdotbelow = 0x1e7e;
                    t.Vecyrillic = 0x0412;
                    t.Vewarmenian = 0x054e;
                    t.Vhook = 0x01b2;
                    t.Vmonospace = 0xff36;
                    t.Voarmenian = 0x0548;
                    t.Vsmall = 0xf776;
                    t.Vtilde = 0x1e7c;
                    t.W = 0x0057;
                    t.Wacute = 0x1e82;
                    t.Wcircle = 0x24cc;
                    t.Wcircumflex = 0x0174;
                    t.Wdieresis = 0x1e84;
                    t.Wdotaccent = 0x1e86;
                    t.Wdotbelow = 0x1e88;
                    t.Wgrave = 0x1e80;
                    t.Wmonospace = 0xff37;
                    t.Wsmall = 0xf777;
                    t.X = 0x0058;
                    t.Xcircle = 0x24cd;
                    t.Xdieresis = 0x1e8c;
                    t.Xdotaccent = 0x1e8a;
                    t.Xeharmenian = 0x053d;
                    t.Xi = 0x039e;
                    t.Xmonospace = 0xff38;
                    t.Xsmall = 0xf778;
                    t.Y = 0x0059;
                    t.Yacute = 0x00dd;
                    t.Yacutesmall = 0xf7fd;
                    t.Yatcyrillic = 0x0462;
                    t.Ycircle = 0x24ce;
                    t.Ycircumflex = 0x0176;
                    t.Ydieresis = 0x0178;
                    t.Ydieresissmall = 0xf7ff;
                    t.Ydotaccent = 0x1e8e;
                    t.Ydotbelow = 0x1ef4;
                    t.Yericyrillic = 0x042b;
                    t.Yerudieresiscyrillic = 0x04f8;
                    t.Ygrave = 0x1ef2;
                    t.Yhook = 0x01b3;
                    t.Yhookabove = 0x1ef6;
                    t.Yiarmenian = 0x0545;
                    t.Yicyrillic = 0x0407;
                    t.Yiwnarmenian = 0x0552;
                    t.Ymonospace = 0xff39;
                    t.Ysmall = 0xf779;
                    t.Ytilde = 0x1ef8;
                    t.Yusbigcyrillic = 0x046a;
                    t.Yusbigiotifiedcyrillic = 0x046c;
                    t.Yuslittlecyrillic = 0x0466;
                    t.Yuslittleiotifiedcyrillic = 0x0468;
                    t.Z = 0x005a;
                    t.Zaarmenian = 0x0536;
                    t.Zacute = 0x0179;
                    t.Zcaron = 0x017d;
                    t.Zcaronsmall = 0xf6ff;
                    t.Zcircle = 0x24cf;
                    t.Zcircumflex = 0x1e90;
                    t.Zdot = 0x017b;
                    t.Zdotaccent = 0x017b;
                    t.Zdotbelow = 0x1e92;
                    t.Zecyrillic = 0x0417;
                    t.Zedescendercyrillic = 0x0498;
                    t.Zedieresiscyrillic = 0x04de;
                    t.Zeta = 0x0396;
                    t.Zhearmenian = 0x053a;
                    t.Zhebrevecyrillic = 0x04c1;
                    t.Zhecyrillic = 0x0416;
                    t.Zhedescendercyrillic = 0x0496;
                    t.Zhedieresiscyrillic = 0x04dc;
                    t.Zlinebelow = 0x1e94;
                    t.Zmonospace = 0xff3a;
                    t.Zsmall = 0xf77a;
                    t.Zstroke = 0x01b5;
                    t.a = 0x0061;
                    t.aabengali = 0x0986;
                    t.aacute = 0x00e1;
                    t.aadeva = 0x0906;
                    t.aagujarati = 0x0a86;
                    t.aagurmukhi = 0x0a06;
                    t.aamatragurmukhi = 0x0a3e;
                    t.aarusquare = 0x3303;
                    t.aavowelsignbengali = 0x09be;
                    t.aavowelsigndeva = 0x093e;
                    t.aavowelsigngujarati = 0x0abe;
                    t.abbreviationmarkarmenian = 0x055f;
                    t.abbreviationsigndeva = 0x0970;
                    t.abengali = 0x0985;
                    t.abopomofo = 0x311a;
                    t.abreve = 0x0103;
                    t.abreveacute = 0x1eaf;
                    t.abrevecyrillic = 0x04d1;
                    t.abrevedotbelow = 0x1eb7;
                    t.abrevegrave = 0x1eb1;
                    t.abrevehookabove = 0x1eb3;
                    t.abrevetilde = 0x1eb5;
                    t.acaron = 0x01ce;
                    t.acircle = 0x24d0;
                    t.acircumflex = 0x00e2;
                    t.acircumflexacute = 0x1ea5;
                    t.acircumflexdotbelow = 0x1ead;
                    t.acircumflexgrave = 0x1ea7;
                    t.acircumflexhookabove = 0x1ea9;
                    t.acircumflextilde = 0x1eab;
                    t.acute = 0x00b4;
                    t.acutebelowcmb = 0x0317;
                    t.acutecmb = 0x0301;
                    t.acutecomb = 0x0301;
                    t.acutedeva = 0x0954;
                    t.acutelowmod = 0x02cf;
                    t.acutetonecmb = 0x0341;
                    t.acyrillic = 0x0430;
                    t.adblgrave = 0x0201;
                    t.addakgurmukhi = 0x0a71;
                    t.adeva = 0x0905;
                    t.adieresis = 0x00e4;
                    t.adieresiscyrillic = 0x04d3;
                    t.adieresismacron = 0x01df;
                    t.adotbelow = 0x1ea1;
                    t.adotmacron = 0x01e1;
                    t.ae = 0x00e6;
                    t.aeacute = 0x01fd;
                    t.aekorean = 0x3150;
                    t.aemacron = 0x01e3;
                    t.afii00208 = 0x2015;
                    t.afii08941 = 0x20a4;
                    t.afii10017 = 0x0410;
                    t.afii10018 = 0x0411;
                    t.afii10019 = 0x0412;
                    t.afii10020 = 0x0413;
                    t.afii10021 = 0x0414;
                    t.afii10022 = 0x0415;
                    t.afii10023 = 0x0401;
                    t.afii10024 = 0x0416;
                    t.afii10025 = 0x0417;
                    t.afii10026 = 0x0418;
                    t.afii10027 = 0x0419;
                    t.afii10028 = 0x041a;
                    t.afii10029 = 0x041b;
                    t.afii10030 = 0x041c;
                    t.afii10031 = 0x041d;
                    t.afii10032 = 0x041e;
                    t.afii10033 = 0x041f;
                    t.afii10034 = 0x0420;
                    t.afii10035 = 0x0421;
                    t.afii10036 = 0x0422;
                    t.afii10037 = 0x0423;
                    t.afii10038 = 0x0424;
                    t.afii10039 = 0x0425;
                    t.afii10040 = 0x0426;
                    t.afii10041 = 0x0427;
                    t.afii10042 = 0x0428;
                    t.afii10043 = 0x0429;
                    t.afii10044 = 0x042a;
                    t.afii10045 = 0x042b;
                    t.afii10046 = 0x042c;
                    t.afii10047 = 0x042d;
                    t.afii10048 = 0x042e;
                    t.afii10049 = 0x042f;
                    t.afii10050 = 0x0490;
                    t.afii10051 = 0x0402;
                    t.afii10052 = 0x0403;
                    t.afii10053 = 0x0404;
                    t.afii10054 = 0x0405;
                    t.afii10055 = 0x0406;
                    t.afii10056 = 0x0407;
                    t.afii10057 = 0x0408;
                    t.afii10058 = 0x0409;
                    t.afii10059 = 0x040a;
                    t.afii10060 = 0x040b;
                    t.afii10061 = 0x040c;
                    t.afii10062 = 0x040e;
                    t.afii10063 = 0xf6c4;
                    t.afii10064 = 0xf6c5;
                    t.afii10065 = 0x0430;
                    t.afii10066 = 0x0431;
                    t.afii10067 = 0x0432;
                    t.afii10068 = 0x0433;
                    t.afii10069 = 0x0434;
                    t.afii10070 = 0x0435;
                    t.afii10071 = 0x0451;
                    t.afii10072 = 0x0436;
                    t.afii10073 = 0x0437;
                    t.afii10074 = 0x0438;
                    t.afii10075 = 0x0439;
                    t.afii10076 = 0x043a;
                    t.afii10077 = 0x043b;
                    t.afii10078 = 0x043c;
                    t.afii10079 = 0x043d;
                    t.afii10080 = 0x043e;
                    t.afii10081 = 0x043f;
                    t.afii10082 = 0x0440;
                    t.afii10083 = 0x0441;
                    t.afii10084 = 0x0442;
                    t.afii10085 = 0x0443;
                    t.afii10086 = 0x0444;
                    t.afii10087 = 0x0445;
                    t.afii10088 = 0x0446;
                    t.afii10089 = 0x0447;
                    t.afii10090 = 0x0448;
                    t.afii10091 = 0x0449;
                    t.afii10092 = 0x044a;
                    t.afii10093 = 0x044b;
                    t.afii10094 = 0x044c;
                    t.afii10095 = 0x044d;
                    t.afii10096 = 0x044e;
                    t.afii10097 = 0x044f;
                    t.afii10098 = 0x0491;
                    t.afii10099 = 0x0452;
                    t.afii10100 = 0x0453;
                    t.afii10101 = 0x0454;
                    t.afii10102 = 0x0455;
                    t.afii10103 = 0x0456;
                    t.afii10104 = 0x0457;
                    t.afii10105 = 0x0458;
                    t.afii10106 = 0x0459;
                    t.afii10107 = 0x045a;
                    t.afii10108 = 0x045b;
                    t.afii10109 = 0x045c;
                    t.afii10110 = 0x045e;
                    t.afii10145 = 0x040f;
                    t.afii10146 = 0x0462;
                    t.afii10147 = 0x0472;
                    t.afii10148 = 0x0474;
                    t.afii10192 = 0xf6c6;
                    t.afii10193 = 0x045f;
                    t.afii10194 = 0x0463;
                    t.afii10195 = 0x0473;
                    t.afii10196 = 0x0475;
                    t.afii10831 = 0xf6c7;
                    t.afii10832 = 0xf6c8;
                    t.afii10846 = 0x04d9;
                    t.afii299 = 0x200e;
                    t.afii300 = 0x200f;
                    t.afii301 = 0x200d;
                    t.afii57381 = 0x066a;
                    t.afii57388 = 0x060c;
                    t.afii57392 = 0x0660;
                    t.afii57393 = 0x0661;
                    t.afii57394 = 0x0662;
                    t.afii57395 = 0x0663;
                    t.afii57396 = 0x0664;
                    t.afii57397 = 0x0665;
                    t.afii57398 = 0x0666;
                    t.afii57399 = 0x0667;
                    t.afii57400 = 0x0668;
                    t.afii57401 = 0x0669;
                    t.afii57403 = 0x061b;
                    t.afii57407 = 0x061f;
                    t.afii57409 = 0x0621;
                    t.afii57410 = 0x0622;
                    t.afii57411 = 0x0623;
                    t.afii57412 = 0x0624;
                    t.afii57413 = 0x0625;
                    t.afii57414 = 0x0626;
                    t.afii57415 = 0x0627;
                    t.afii57416 = 0x0628;
                    t.afii57417 = 0x0629;
                    t.afii57418 = 0x062a;
                    t.afii57419 = 0x062b;
                    t.afii57420 = 0x062c;
                    t.afii57421 = 0x062d;
                    t.afii57422 = 0x062e;
                    t.afii57423 = 0x062f;
                    t.afii57424 = 0x0630;
                    t.afii57425 = 0x0631;
                    t.afii57426 = 0x0632;
                    t.afii57427 = 0x0633;
                    t.afii57428 = 0x0634;
                    t.afii57429 = 0x0635;
                    t.afii57430 = 0x0636;
                    t.afii57431 = 0x0637;
                    t.afii57432 = 0x0638;
                    t.afii57433 = 0x0639;
                    t.afii57434 = 0x063a;
                    t.afii57440 = 0x0640;
                    t.afii57441 = 0x0641;
                    t.afii57442 = 0x0642;
                    t.afii57443 = 0x0643;
                    t.afii57444 = 0x0644;
                    t.afii57445 = 0x0645;
                    t.afii57446 = 0x0646;
                    t.afii57448 = 0x0648;
                    t.afii57449 = 0x0649;
                    t.afii57450 = 0x064a;
                    t.afii57451 = 0x064b;
                    t.afii57452 = 0x064c;
                    t.afii57453 = 0x064d;
                    t.afii57454 = 0x064e;
                    t.afii57455 = 0x064f;
                    t.afii57456 = 0x0650;
                    t.afii57457 = 0x0651;
                    t.afii57458 = 0x0652;
                    t.afii57470 = 0x0647;
                    t.afii57505 = 0x06a4;
                    t.afii57506 = 0x067e;
                    t.afii57507 = 0x0686;
                    t.afii57508 = 0x0698;
                    t.afii57509 = 0x06af;
                    t.afii57511 = 0x0679;
                    t.afii57512 = 0x0688;
                    t.afii57513 = 0x0691;
                    t.afii57514 = 0x06ba;
                    t.afii57519 = 0x06d2;
                    t.afii57534 = 0x06d5;
                    t.afii57636 = 0x20aa;
                    t.afii57645 = 0x05be;
                    t.afii57658 = 0x05c3;
                    t.afii57664 = 0x05d0;
                    t.afii57665 = 0x05d1;
                    t.afii57666 = 0x05d2;
                    t.afii57667 = 0x05d3;
                    t.afii57668 = 0x05d4;
                    t.afii57669 = 0x05d5;
                    t.afii57670 = 0x05d6;
                    t.afii57671 = 0x05d7;
                    t.afii57672 = 0x05d8;
                    t.afii57673 = 0x05d9;
                    t.afii57674 = 0x05da;
                    t.afii57675 = 0x05db;
                    t.afii57676 = 0x05dc;
                    t.afii57677 = 0x05dd;
                    t.afii57678 = 0x05de;
                    t.afii57679 = 0x05df;
                    t.afii57680 = 0x05e0;
                    t.afii57681 = 0x05e1;
                    t.afii57682 = 0x05e2;
                    t.afii57683 = 0x05e3;
                    t.afii57684 = 0x05e4;
                    t.afii57685 = 0x05e5;
                    t.afii57686 = 0x05e6;
                    t.afii57687 = 0x05e7;
                    t.afii57688 = 0x05e8;
                    t.afii57689 = 0x05e9;
                    t.afii57690 = 0x05ea;
                    t.afii57694 = 0xfb2a;
                    t.afii57695 = 0xfb2b;
                    t.afii57700 = 0xfb4b;
                    t.afii57705 = 0xfb1f;
                    t.afii57716 = 0x05f0;
                    t.afii57717 = 0x05f1;
                    t.afii57718 = 0x05f2;
                    t.afii57723 = 0xfb35;
                    t.afii57793 = 0x05b4;
                    t.afii57794 = 0x05b5;
                    t.afii57795 = 0x05b6;
                    t.afii57796 = 0x05bb;
                    t.afii57797 = 0x05b8;
                    t.afii57798 = 0x05b7;
                    t.afii57799 = 0x05b0;
                    t.afii57800 = 0x05b2;
                    t.afii57801 = 0x05b1;
                    t.afii57802 = 0x05b3;
                    t.afii57803 = 0x05c2;
                    t.afii57804 = 0x05c1;
                    t.afii57806 = 0x05b9;
                    t.afii57807 = 0x05bc;
                    t.afii57839 = 0x05bd;
                    t.afii57841 = 0x05bf;
                    t.afii57842 = 0x05c0;
                    t.afii57929 = 0x02bc;
                    t.afii61248 = 0x2105;
                    t.afii61289 = 0x2113;
                    t.afii61352 = 0x2116;
                    t.afii61573 = 0x202c;
                    t.afii61574 = 0x202d;
                    t.afii61575 = 0x202e;
                    t.afii61664 = 0x200c;
                    t.afii63167 = 0x066d;
                    t.afii64937 = 0x02bd;
                    t.agrave = 0x00e0;
                    t.agujarati = 0x0a85;
                    t.agurmukhi = 0x0a05;
                    t.ahiragana = 0x3042;
                    t.ahookabove = 0x1ea3;
                    t.aibengali = 0x0990;
                    t.aibopomofo = 0x311e;
                    t.aideva = 0x0910;
                    t.aiecyrillic = 0x04d5;
                    t.aigujarati = 0x0a90;
                    t.aigurmukhi = 0x0a10;
                    t.aimatragurmukhi = 0x0a48;
                    t.ainarabic = 0x0639;
                    t.ainfinalarabic = 0xfeca;
                    t.aininitialarabic = 0xfecb;
                    t.ainmedialarabic = 0xfecc;
                    t.ainvertedbreve = 0x0203;
                    t.aivowelsignbengali = 0x09c8;
                    t.aivowelsigndeva = 0x0948;
                    t.aivowelsigngujarati = 0x0ac8;
                    t.akatakana = 0x30a2;
                    t.akatakanahalfwidth = 0xff71;
                    t.akorean = 0x314f;
                    t.alef = 0x05d0;
                    t.alefarabic = 0x0627;
                    t.alefdageshhebrew = 0xfb30;
                    t.aleffinalarabic = 0xfe8e;
                    t.alefhamzaabovearabic = 0x0623;
                    t.alefhamzaabovefinalarabic = 0xfe84;
                    t.alefhamzabelowarabic = 0x0625;
                    t.alefhamzabelowfinalarabic = 0xfe88;
                    t.alefhebrew = 0x05d0;
                    t.aleflamedhebrew = 0xfb4f;
                    t.alefmaddaabovearabic = 0x0622;
                    t.alefmaddaabovefinalarabic = 0xfe82;
                    t.alefmaksuraarabic = 0x0649;
                    t.alefmaksurafinalarabic = 0xfef0;
                    t.alefmaksurainitialarabic = 0xfef3;
                    t.alefmaksuramedialarabic = 0xfef4;
                    t.alefpatahhebrew = 0xfb2e;
                    t.alefqamatshebrew = 0xfb2f;
                    t.aleph = 0x2135;
                    t.allequal = 0x224c;
                    t.alpha = 0x03b1;
                    t.alphatonos = 0x03ac;
                    t.amacron = 0x0101;
                    t.amonospace = 0xff41;
                    t.ampersand = 0x0026;
                    t.ampersandmonospace = 0xff06;
                    t.ampersandsmall = 0xf726;
                    t.amsquare = 0x33c2;
                    t.anbopomofo = 0x3122;
                    t.angbopomofo = 0x3124;
                    t.angbracketleft = 0x3008;
                    t.angbracketright = 0x3009;
                    t.angkhankhuthai = 0x0e5a;
                    t.angle = 0x2220;
                    t.anglebracketleft = 0x3008;
                    t.anglebracketleftvertical = 0xfe3f;
                    t.anglebracketright = 0x3009;
                    t.anglebracketrightvertical = 0xfe40;
                    t.angleleft = 0x2329;
                    t.angleright = 0x232a;
                    t.angstrom = 0x212b;
                    t.anoteleia = 0x0387;
                    t.anudattadeva = 0x0952;
                    t.anusvarabengali = 0x0982;
                    t.anusvaradeva = 0x0902;
                    t.anusvaragujarati = 0x0a82;
                    t.aogonek = 0x0105;
                    t.apaatosquare = 0x3300;
                    t.aparen = 0x249c;
                    t.apostrophearmenian = 0x055a;
                    t.apostrophemod = 0x02bc;
                    t.apple = 0xf8ff;
                    t.approaches = 0x2250;
                    t.approxequal = 0x2248;
                    t.approxequalorimage = 0x2252;
                    t.approximatelyequal = 0x2245;
                    t.araeaekorean = 0x318e;
                    t.araeakorean = 0x318d;
                    t.arc = 0x2312;
                    t.arighthalfring = 0x1e9a;
                    t.aring = 0x00e5;
                    t.aringacute = 0x01fb;
                    t.aringbelow = 0x1e01;
                    t.arrowboth = 0x2194;
                    t.arrowdashdown = 0x21e3;
                    t.arrowdashleft = 0x21e0;
                    t.arrowdashright = 0x21e2;
                    t.arrowdashup = 0x21e1;
                    t.arrowdblboth = 0x21d4;
                    t.arrowdbldown = 0x21d3;
                    t.arrowdblleft = 0x21d0;
                    t.arrowdblright = 0x21d2;
                    t.arrowdblup = 0x21d1;
                    t.arrowdown = 0x2193;
                    t.arrowdownleft = 0x2199;
                    t.arrowdownright = 0x2198;
                    t.arrowdownwhite = 0x21e9;
                    t.arrowheaddownmod = 0x02c5;
                    t.arrowheadleftmod = 0x02c2;
                    t.arrowheadrightmod = 0x02c3;
                    t.arrowheadupmod = 0x02c4;
                    t.arrowhorizex = 0xf8e7;
                    t.arrowleft = 0x2190;
                    t.arrowleftdbl = 0x21d0;
                    t.arrowleftdblstroke = 0x21cd;
                    t.arrowleftoverright = 0x21c6;
                    t.arrowleftwhite = 0x21e6;
                    t.arrowright = 0x2192;
                    t.arrowrightdblstroke = 0x21cf;
                    t.arrowrightheavy = 0x279e;
                    t.arrowrightoverleft = 0x21c4;
                    t.arrowrightwhite = 0x21e8;
                    t.arrowtableft = 0x21e4;
                    t.arrowtabright = 0x21e5;
                    t.arrowup = 0x2191;
                    t.arrowupdn = 0x2195;
                    t.arrowupdnbse = 0x21a8;
                    t.arrowupdownbase = 0x21a8;
                    t.arrowupleft = 0x2196;
                    t.arrowupleftofdown = 0x21c5;
                    t.arrowupright = 0x2197;
                    t.arrowupwhite = 0x21e7;
                    t.arrowvertex = 0xf8e6;
                    t.asciicircum = 0x005e;
                    t.asciicircummonospace = 0xff3e;
                    t.asciitilde = 0x007e;
                    t.asciitildemonospace = 0xff5e;
                    t.ascript = 0x0251;
                    t.ascriptturned = 0x0252;
                    t.asmallhiragana = 0x3041;
                    t.asmallkatakana = 0x30a1;
                    t.asmallkatakanahalfwidth = 0xff67;
                    t.asterisk = 0x002a;
                    t.asteriskaltonearabic = 0x066d;
                    t.asteriskarabic = 0x066d;
                    t.asteriskmath = 0x2217;
                    t.asteriskmonospace = 0xff0a;
                    t.asterisksmall = 0xfe61;
                    t.asterism = 0x2042;
                    t.asuperior = 0xf6e9;
                    t.asymptoticallyequal = 0x2243;
                    t.at = 0x0040;
                    t.atilde = 0x00e3;
                    t.atmonospace = 0xff20;
                    t.atsmall = 0xfe6b;
                    t.aturned = 0x0250;
                    t.aubengali = 0x0994;
                    t.aubopomofo = 0x3120;
                    t.audeva = 0x0914;
                    t.augujarati = 0x0a94;
                    t.augurmukhi = 0x0a14;
                    t.aulengthmarkbengali = 0x09d7;
                    t.aumatragurmukhi = 0x0a4c;
                    t.auvowelsignbengali = 0x09cc;
                    t.auvowelsigndeva = 0x094c;
                    t.auvowelsigngujarati = 0x0acc;
                    t.avagrahadeva = 0x093d;
                    t.aybarmenian = 0x0561;
                    t.ayin = 0x05e2;
                    t.ayinaltonehebrew = 0xfb20;
                    t.ayinhebrew = 0x05e2;
                    t.b = 0x0062;
                    t.babengali = 0x09ac;
                    t.backslash = 0x005c;
                    t.backslashmonospace = 0xff3c;
                    t.badeva = 0x092c;
                    t.bagujarati = 0x0aac;
                    t.bagurmukhi = 0x0a2c;
                    t.bahiragana = 0x3070;
                    t.bahtthai = 0x0e3f;
                    t.bakatakana = 0x30d0;
                    t.bar = 0x007c;
                    t.barmonospace = 0xff5c;
                    t.bbopomofo = 0x3105;
                    t.bcircle = 0x24d1;
                    t.bdotaccent = 0x1e03;
                    t.bdotbelow = 0x1e05;
                    t.beamedsixteenthnotes = 0x266c;
                    t.because = 0x2235;
                    t.becyrillic = 0x0431;
                    t.beharabic = 0x0628;
                    t.behfinalarabic = 0xfe90;
                    t.behinitialarabic = 0xfe91;
                    t.behiragana = 0x3079;
                    t.behmedialarabic = 0xfe92;
                    t.behmeeminitialarabic = 0xfc9f;
                    t.behmeemisolatedarabic = 0xfc08;
                    t.behnoonfinalarabic = 0xfc6d;
                    t.bekatakana = 0x30d9;
                    t.benarmenian = 0x0562;
                    t.bet = 0x05d1;
                    t.beta = 0x03b2;
                    t.betasymbolgreek = 0x03d0;
                    t.betdagesh = 0xfb31;
                    t.betdageshhebrew = 0xfb31;
                    t.bethebrew = 0x05d1;
                    t.betrafehebrew = 0xfb4c;
                    t.bhabengali = 0x09ad;
                    t.bhadeva = 0x092d;
                    t.bhagujarati = 0x0aad;
                    t.bhagurmukhi = 0x0a2d;
                    t.bhook = 0x0253;
                    t.bihiragana = 0x3073;
                    t.bikatakana = 0x30d3;
                    t.bilabialclick = 0x0298;
                    t.bindigurmukhi = 0x0a02;
                    t.birusquare = 0x3331;
                    t.blackcircle = 0x25cf;
                    t.blackdiamond = 0x25c6;
                    t.blackdownpointingtriangle = 0x25bc;
                    t.blackleftpointingpointer = 0x25c4;
                    t.blackleftpointingtriangle = 0x25c0;
                    t.blacklenticularbracketleft = 0x3010;
                    t.blacklenticularbracketleftvertical = 0xfe3b;
                    t.blacklenticularbracketright = 0x3011;
                    t.blacklenticularbracketrightvertical = 0xfe3c;
                    t.blacklowerlefttriangle = 0x25e3;
                    t.blacklowerrighttriangle = 0x25e2;
                    t.blackrectangle = 0x25ac;
                    t.blackrightpointingpointer = 0x25ba;
                    t.blackrightpointingtriangle = 0x25b6;
                    t.blacksmallsquare = 0x25aa;
                    t.blacksmilingface = 0x263b;
                    t.blacksquare = 0x25a0;
                    t.blackstar = 0x2605;
                    t.blackupperlefttriangle = 0x25e4;
                    t.blackupperrighttriangle = 0x25e5;
                    t.blackuppointingsmalltriangle = 0x25b4;
                    t.blackuppointingtriangle = 0x25b2;
                    t.blank = 0x2423;
                    t.blinebelow = 0x1e07;
                    t.block = 0x2588;
                    t.bmonospace = 0xff42;
                    t.bobaimaithai = 0x0e1a;
                    t.bohiragana = 0x307c;
                    t.bokatakana = 0x30dc;
                    t.bparen = 0x249d;
                    t.bqsquare = 0x33c3;
                    t.braceex = 0xf8f4;
                    t.braceleft = 0x007b;
                    t.braceleftbt = 0xf8f3;
                    t.braceleftmid = 0xf8f2;
                    t.braceleftmonospace = 0xff5b;
                    t.braceleftsmall = 0xfe5b;
                    t.bracelefttp = 0xf8f1;
                    t.braceleftvertical = 0xfe37;
                    t.braceright = 0x007d;
                    t.bracerightbt = 0xf8fe;
                    t.bracerightmid = 0xf8fd;
                    t.bracerightmonospace = 0xff5d;
                    t.bracerightsmall = 0xfe5c;
                    t.bracerighttp = 0xf8fc;
                    t.bracerightvertical = 0xfe38;
                    t.bracketleft = 0x005b;
                    t.bracketleftbt = 0xf8f0;
                    t.bracketleftex = 0xf8ef;
                    t.bracketleftmonospace = 0xff3b;
                    t.bracketlefttp = 0xf8ee;
                    t.bracketright = 0x005d;
                    t.bracketrightbt = 0xf8fb;
                    t.bracketrightex = 0xf8fa;
                    t.bracketrightmonospace = 0xff3d;
                    t.bracketrighttp = 0xf8f9;
                    t.breve = 0x02d8;
                    t.brevebelowcmb = 0x032e;
                    t.brevecmb = 0x0306;
                    t.breveinvertedbelowcmb = 0x032f;
                    t.breveinvertedcmb = 0x0311;
                    t.breveinverteddoublecmb = 0x0361;
                    t.bridgebelowcmb = 0x032a;
                    t.bridgeinvertedbelowcmb = 0x033a;
                    t.brokenbar = 0x00a6;
                    t.bstroke = 0x0180;
                    t.bsuperior = 0xf6ea;
                    t.btopbar = 0x0183;
                    t.buhiragana = 0x3076;
                    t.bukatakana = 0x30d6;
                    t.bullet = 0x2022;
                    t.bulletinverse = 0x25d8;
                    t.bulletoperator = 0x2219;
                    t.bullseye = 0x25ce;
                    t.c = 0x0063;
                    t.caarmenian = 0x056e;
                    t.cabengali = 0x099a;
                    t.cacute = 0x0107;
                    t.cadeva = 0x091a;
                    t.cagujarati = 0x0a9a;
                    t.cagurmukhi = 0x0a1a;
                    t.calsquare = 0x3388;
                    t.candrabindubengali = 0x0981;
                    t.candrabinducmb = 0x0310;
                    t.candrabindudeva = 0x0901;
                    t.candrabindugujarati = 0x0a81;
                    t.capslock = 0x21ea;
                    t.careof = 0x2105;
                    t.caron = 0x02c7;
                    t.caronbelowcmb = 0x032c;
                    t.caroncmb = 0x030c;
                    t.carriagereturn = 0x21b5;
                    t.cbopomofo = 0x3118;
                    t.ccaron = 0x010d;
                    t.ccedilla = 0x00e7;
                    t.ccedillaacute = 0x1e09;
                    t.ccircle = 0x24d2;
                    t.ccircumflex = 0x0109;
                    t.ccurl = 0x0255;
                    t.cdot = 0x010b;
                    t.cdotaccent = 0x010b;
                    t.cdsquare = 0x33c5;
                    t.cedilla = 0x00b8;
                    t.cedillacmb = 0x0327;
                    t.cent = 0x00a2;
                    t.centigrade = 0x2103;
                    t.centinferior = 0xf6df;
                    t.centmonospace = 0xffe0;
                    t.centoldstyle = 0xf7a2;
                    t.centsuperior = 0xf6e0;
                    t.chaarmenian = 0x0579;
                    t.chabengali = 0x099b;
                    t.chadeva = 0x091b;
                    t.chagujarati = 0x0a9b;
                    t.chagurmukhi = 0x0a1b;
                    t.chbopomofo = 0x3114;
                    t.cheabkhasiancyrillic = 0x04bd;
                    t.checkmark = 0x2713;
                    t.checyrillic = 0x0447;
                    t.chedescenderabkhasiancyrillic = 0x04bf;
                    t.chedescendercyrillic = 0x04b7;
                    t.chedieresiscyrillic = 0x04f5;
                    t.cheharmenian = 0x0573;
                    t.chekhakassiancyrillic = 0x04cc;
                    t.cheverticalstrokecyrillic = 0x04b9;
                    t.chi = 0x03c7;
                    t.chieuchacirclekorean = 0x3277;
                    t.chieuchaparenkorean = 0x3217;
                    t.chieuchcirclekorean = 0x3269;
                    t.chieuchkorean = 0x314a;
                    t.chieuchparenkorean = 0x3209;
                    t.chochangthai = 0x0e0a;
                    t.chochanthai = 0x0e08;
                    t.chochingthai = 0x0e09;
                    t.chochoethai = 0x0e0c;
                    t.chook = 0x0188;
                    t.cieucacirclekorean = 0x3276;
                    t.cieucaparenkorean = 0x3216;
                    t.cieuccirclekorean = 0x3268;
                    t.cieuckorean = 0x3148;
                    t.cieucparenkorean = 0x3208;
                    t.cieucuparenkorean = 0x321c;
                    t.circle = 0x25cb;
                    t.circlecopyrt = 0x00a9;
                    t.circlemultiply = 0x2297;
                    t.circleot = 0x2299;
                    t.circleplus = 0x2295;
                    t.circlepostalmark = 0x3036;
                    t.circlewithlefthalfblack = 0x25d0;
                    t.circlewithrighthalfblack = 0x25d1;
                    t.circumflex = 0x02c6;
                    t.circumflexbelowcmb = 0x032d;
                    t.circumflexcmb = 0x0302;
                    t.clear = 0x2327;
                    t.clickalveolar = 0x01c2;
                    t.clickdental = 0x01c0;
                    t.clicklateral = 0x01c1;
                    t.clickretroflex = 0x01c3;
                    t.club = 0x2663;
                    t.clubsuitblack = 0x2663;
                    t.clubsuitwhite = 0x2667;
                    t.cmcubedsquare = 0x33a4;
                    t.cmonospace = 0xff43;
                    t.cmsquaredsquare = 0x33a0;
                    t.coarmenian = 0x0581;
                    t.colon = 0x003a;
                    t.colonmonetary = 0x20a1;
                    t.colonmonospace = 0xff1a;
                    t.colonsign = 0x20a1;
                    t.colonsmall = 0xfe55;
                    t.colontriangularhalfmod = 0x02d1;
                    t.colontriangularmod = 0x02d0;
                    t.comma = 0x002c;
                    t.commaabovecmb = 0x0313;
                    t.commaaboverightcmb = 0x0315;
                    t.commaaccent = 0xf6c3;
                    t.commaarabic = 0x060c;
                    t.commaarmenian = 0x055d;
                    t.commainferior = 0xf6e1;
                    t.commamonospace = 0xff0c;
                    t.commareversedabovecmb = 0x0314;
                    t.commareversedmod = 0x02bd;
                    t.commasmall = 0xfe50;
                    t.commasuperior = 0xf6e2;
                    t.commaturnedabovecmb = 0x0312;
                    t.commaturnedmod = 0x02bb;
                    t.compass = 0x263c;
                    t.congruent = 0x2245;
                    t.contourintegral = 0x222e;
                    t.control = 0x2303;
                    t.controlACK = 0x0006;
                    t.controlBEL = 0x0007;
                    t.controlBS = 0x0008;
                    t.controlCAN = 0x0018;
                    t.controlCR = 0x000d;
                    t.controlDC1 = 0x0011;
                    t.controlDC2 = 0x0012;
                    t.controlDC3 = 0x0013;
                    t.controlDC4 = 0x0014;
                    t.controlDEL = 0x007f;
                    t.controlDLE = 0x0010;
                    t.controlEM = 0x0019;
                    t.controlENQ = 0x0005;
                    t.controlEOT = 0x0004;
                    t.controlESC = 0x001b;
                    t.controlETB = 0x0017;
                    t.controlETX = 0x0003;
                    t.controlFF = 0x000c;
                    t.controlFS = 0x001c;
                    t.controlGS = 0x001d;
                    t.controlHT = 0x0009;
                    t.controlLF = 0x000a;
                    t.controlNAK = 0x0015;
                    t.controlNULL = 0x0000;
                    t.controlRS = 0x001e;
                    t.controlSI = 0x000f;
                    t.controlSO = 0x000e;
                    t.controlSOT = 0x0002;
                    t.controlSTX = 0x0001;
                    t.controlSUB = 0x001a;
                    t.controlSYN = 0x0016;
                    t.controlUS = 0x001f;
                    t.controlVT = 0x000b;
                    t.copyright = 0x00a9;
                    t.copyrightsans = 0xf8e9;
                    t.copyrightserif = 0xf6d9;
                    t.cornerbracketleft = 0x300c;
                    t.cornerbracketlefthalfwidth = 0xff62;
                    t.cornerbracketleftvertical = 0xfe41;
                    t.cornerbracketright = 0x300d;
                    t.cornerbracketrighthalfwidth = 0xff63;
                    t.cornerbracketrightvertical = 0xfe42;
                    t.corporationsquare = 0x337f;
                    t.cosquare = 0x33c7;
                    t.coverkgsquare = 0x33c6;
                    t.cparen = 0x249e;
                    t.cruzeiro = 0x20a2;
                    t.cstretched = 0x0297;
                    t.curlyand = 0x22cf;
                    t.curlyor = 0x22ce;
                    t.currency = 0x00a4;
                    t.cyrBreve = 0xf6d1;
                    t.cyrFlex = 0xf6d2;
                    t.cyrbreve = 0xf6d4;
                    t.cyrflex = 0xf6d5;
                    t.d = 0x0064;
                    t.daarmenian = 0x0564;
                    t.dabengali = 0x09a6;
                    t.dadarabic = 0x0636;
                    t.dadeva = 0x0926;
                    t.dadfinalarabic = 0xfebe;
                    t.dadinitialarabic = 0xfebf;
                    t.dadmedialarabic = 0xfec0;
                    t.dagesh = 0x05bc;
                    t.dageshhebrew = 0x05bc;
                    t.dagger = 0x2020;
                    t.daggerdbl = 0x2021;
                    t.dagujarati = 0x0aa6;
                    t.dagurmukhi = 0x0a26;
                    t.dahiragana = 0x3060;
                    t.dakatakana = 0x30c0;
                    t.dalarabic = 0x062f;
                    t.dalet = 0x05d3;
                    t.daletdagesh = 0xfb33;
                    t.daletdageshhebrew = 0xfb33;
                    t.dalethebrew = 0x05d3;
                    t.dalfinalarabic = 0xfeaa;
                    t.dammaarabic = 0x064f;
                    t.dammalowarabic = 0x064f;
                    t.dammatanaltonearabic = 0x064c;
                    t.dammatanarabic = 0x064c;
                    t.danda = 0x0964;
                    t.dargahebrew = 0x05a7;
                    t.dargalefthebrew = 0x05a7;
                    t.dasiapneumatacyrilliccmb = 0x0485;
                    t.dblGrave = 0xf6d3;
                    t.dblanglebracketleft = 0x300a;
                    t.dblanglebracketleftvertical = 0xfe3d;
                    t.dblanglebracketright = 0x300b;
                    t.dblanglebracketrightvertical = 0xfe3e;
                    t.dblarchinvertedbelowcmb = 0x032b;
                    t.dblarrowleft = 0x21d4;
                    t.dblarrowright = 0x21d2;
                    t.dbldanda = 0x0965;
                    t.dblgrave = 0xf6d6;
                    t.dblgravecmb = 0x030f;
                    t.dblintegral = 0x222c;
                    t.dbllowline = 0x2017;
                    t.dbllowlinecmb = 0x0333;
                    t.dbloverlinecmb = 0x033f;
                    t.dblprimemod = 0x02ba;
                    t.dblverticalbar = 0x2016;
                    t.dblverticallineabovecmb = 0x030e;
                    t.dbopomofo = 0x3109;
                    t.dbsquare = 0x33c8;
                    t.dcaron = 0x010f;
                    t.dcedilla = 0x1e11;
                    t.dcircle = 0x24d3;
                    t.dcircumflexbelow = 0x1e13;
                    t.dcroat = 0x0111;
                    t.ddabengali = 0x09a1;
                    t.ddadeva = 0x0921;
                    t.ddagujarati = 0x0aa1;
                    t.ddagurmukhi = 0x0a21;
                    t.ddalarabic = 0x0688;
                    t.ddalfinalarabic = 0xfb89;
                    t.dddhadeva = 0x095c;
                    t.ddhabengali = 0x09a2;
                    t.ddhadeva = 0x0922;
                    t.ddhagujarati = 0x0aa2;
                    t.ddhagurmukhi = 0x0a22;
                    t.ddotaccent = 0x1e0b;
                    t.ddotbelow = 0x1e0d;
                    t.decimalseparatorarabic = 0x066b;
                    t.decimalseparatorpersian = 0x066b;
                    t.decyrillic = 0x0434;
                    t.degree = 0x00b0;
                    t.dehihebrew = 0x05ad;
                    t.dehiragana = 0x3067;
                    t.deicoptic = 0x03ef;
                    t.dekatakana = 0x30c7;
                    t.deleteleft = 0x232b;
                    t.deleteright = 0x2326;
                    t.delta = 0x03b4;
                    t.deltaturned = 0x018d;
                    t.denominatorminusonenumeratorbengali = 0x09f8;
                    t.dezh = 0x02a4;
                    t.dhabengali = 0x09a7;
                    t.dhadeva = 0x0927;
                    t.dhagujarati = 0x0aa7;
                    t.dhagurmukhi = 0x0a27;
                    t.dhook = 0x0257;
                    t.dialytikatonos = 0x0385;
                    t.dialytikatonoscmb = 0x0344;
                    t.diamond = 0x2666;
                    t.diamondsuitwhite = 0x2662;
                    t.dieresis = 0x00a8;
                    t.dieresisacute = 0xf6d7;
                    t.dieresisbelowcmb = 0x0324;
                    t.dieresiscmb = 0x0308;
                    t.dieresisgrave = 0xf6d8;
                    t.dieresistonos = 0x0385;
                    t.dihiragana = 0x3062;
                    t.dikatakana = 0x30c2;
                    t.dittomark = 0x3003;
                    t.divide = 0x00f7;
                    t.divides = 0x2223;
                    t.divisionslash = 0x2215;
                    t.djecyrillic = 0x0452;
                    t.dkshade = 0x2593;
                    t.dlinebelow = 0x1e0f;
                    t.dlsquare = 0x3397;
                    t.dmacron = 0x0111;
                    t.dmonospace = 0xff44;
                    t.dnblock = 0x2584;
                    t.dochadathai = 0x0e0e;
                    t.dodekthai = 0x0e14;
                    t.dohiragana = 0x3069;
                    t.dokatakana = 0x30c9;
                    t.dollar = 0x0024;
                    t.dollarinferior = 0xf6e3;
                    t.dollarmonospace = 0xff04;
                    t.dollaroldstyle = 0xf724;
                    t.dollarsmall = 0xfe69;
                    t.dollarsuperior = 0xf6e4;
                    t.dong = 0x20ab;
                    t.dorusquare = 0x3326;
                    t.dotaccent = 0x02d9;
                    t.dotaccentcmb = 0x0307;
                    t.dotbelowcmb = 0x0323;
                    t.dotbelowcomb = 0x0323;
                    t.dotkatakana = 0x30fb;
                    t.dotlessi = 0x0131;
                    t.dotlessj = 0xf6be;
                    t.dotlessjstrokehook = 0x0284;
                    t.dotmath = 0x22c5;
                    t.dottedcircle = 0x25cc;
                    t.doubleyodpatah = 0xfb1f;
                    t.doubleyodpatahhebrew = 0xfb1f;
                    t.downtackbelowcmb = 0x031e;
                    t.downtackmod = 0x02d5;
                    t.dparen = 0x249f;
                    t.dsuperior = 0xf6eb;
                    t.dtail = 0x0256;
                    t.dtopbar = 0x018c;
                    t.duhiragana = 0x3065;
                    t.dukatakana = 0x30c5;
                    t.dz = 0x01f3;
                    t.dzaltone = 0x02a3;
                    t.dzcaron = 0x01c6;
                    t.dzcurl = 0x02a5;
                    t.dzeabkhasiancyrillic = 0x04e1;
                    t.dzecyrillic = 0x0455;
                    t.dzhecyrillic = 0x045f;
                    t.e = 0x0065;
                    t.eacute = 0x00e9;
                    t.earth = 0x2641;
                    t.ebengali = 0x098f;
                    t.ebopomofo = 0x311c;
                    t.ebreve = 0x0115;
                    t.ecandradeva = 0x090d;
                    t.ecandragujarati = 0x0a8d;
                    t.ecandravowelsigndeva = 0x0945;
                    t.ecandravowelsigngujarati = 0x0ac5;
                    t.ecaron = 0x011b;
                    t.ecedillabreve = 0x1e1d;
                    t.echarmenian = 0x0565;
                    t.echyiwnarmenian = 0x0587;
                    t.ecircle = 0x24d4;
                    t.ecircumflex = 0x00ea;
                    t.ecircumflexacute = 0x1ebf;
                    t.ecircumflexbelow = 0x1e19;
                    t.ecircumflexdotbelow = 0x1ec7;
                    t.ecircumflexgrave = 0x1ec1;
                    t.ecircumflexhookabove = 0x1ec3;
                    t.ecircumflextilde = 0x1ec5;
                    t.ecyrillic = 0x0454;
                    t.edblgrave = 0x0205;
                    t.edeva = 0x090f;
                    t.edieresis = 0x00eb;
                    t.edot = 0x0117;
                    t.edotaccent = 0x0117;
                    t.edotbelow = 0x1eb9;
                    t.eegurmukhi = 0x0a0f;
                    t.eematragurmukhi = 0x0a47;
                    t.efcyrillic = 0x0444;
                    t.egrave = 0x00e8;
                    t.egujarati = 0x0a8f;
                    t.eharmenian = 0x0567;
                    t.ehbopomofo = 0x311d;
                    t.ehiragana = 0x3048;
                    t.ehookabove = 0x1ebb;
                    t.eibopomofo = 0x311f;
                    t.eight = 0x0038;
                    t.eightarabic = 0x0668;
                    t.eightbengali = 0x09ee;
                    t.eightcircle = 0x2467;
                    t.eightcircleinversesansserif = 0x2791;
                    t.eightdeva = 0x096e;
                    t.eighteencircle = 0x2471;
                    t.eighteenparen = 0x2485;
                    t.eighteenperiod = 0x2499;
                    t.eightgujarati = 0x0aee;
                    t.eightgurmukhi = 0x0a6e;
                    t.eighthackarabic = 0x0668;
                    t.eighthangzhou = 0x3028;
                    t.eighthnotebeamed = 0x266b;
                    t.eightideographicparen = 0x3227;
                    t.eightinferior = 0x2088;
                    t.eightmonospace = 0xff18;
                    t.eightoldstyle = 0xf738;
                    t.eightparen = 0x247b;
                    t.eightperiod = 0x248f;
                    t.eightpersian = 0x06f8;
                    t.eightroman = 0x2177;
                    t.eightsuperior = 0x2078;
                    t.eightthai = 0x0e58;
                    t.einvertedbreve = 0x0207;
                    t.eiotifiedcyrillic = 0x0465;
                    t.ekatakana = 0x30a8;
                    t.ekatakanahalfwidth = 0xff74;
                    t.ekonkargurmukhi = 0x0a74;
                    t.ekorean = 0x3154;
                    t.elcyrillic = 0x043b;
                    t.element = 0x2208;
                    t.elevencircle = 0x246a;
                    t.elevenparen = 0x247e;
                    t.elevenperiod = 0x2492;
                    t.elevenroman = 0x217a;
                    t.ellipsis = 0x2026;
                    t.ellipsisvertical = 0x22ee;
                    t.emacron = 0x0113;
                    t.emacronacute = 0x1e17;
                    t.emacrongrave = 0x1e15;
                    t.emcyrillic = 0x043c;
                    t.emdash = 0x2014;
                    t.emdashvertical = 0xfe31;
                    t.emonospace = 0xff45;
                    t.emphasismarkarmenian = 0x055b;
                    t.emptyset = 0x2205;
                    t.enbopomofo = 0x3123;
                    t.encyrillic = 0x043d;
                    t.endash = 0x2013;
                    t.endashvertical = 0xfe32;
                    t.endescendercyrillic = 0x04a3;
                    t.eng = 0x014b;
                    t.engbopomofo = 0x3125;
                    t.enghecyrillic = 0x04a5;
                    t.enhookcyrillic = 0x04c8;
                    t.enspace = 0x2002;
                    t.eogonek = 0x0119;
                    t.eokorean = 0x3153;
                    t.eopen = 0x025b;
                    t.eopenclosed = 0x029a;
                    t.eopenreversed = 0x025c;
                    t.eopenreversedclosed = 0x025e;
                    t.eopenreversedhook = 0x025d;
                    t.eparen = 0x24a0;
                    t.epsilon = 0x03b5;
                    t.epsilontonos = 0x03ad;
                    t.equal = 0x003d;
                    t.equalmonospace = 0xff1d;
                    t.equalsmall = 0xfe66;
                    t.equalsuperior = 0x207c;
                    t.equivalence = 0x2261;
                    t.erbopomofo = 0x3126;
                    t.ercyrillic = 0x0440;
                    t.ereversed = 0x0258;
                    t.ereversedcyrillic = 0x044d;
                    t.escyrillic = 0x0441;
                    t.esdescendercyrillic = 0x04ab;
                    t.esh = 0x0283;
                    t.eshcurl = 0x0286;
                    t.eshortdeva = 0x090e;
                    t.eshortvowelsigndeva = 0x0946;
                    t.eshreversedloop = 0x01aa;
                    t.eshsquatreversed = 0x0285;
                    t.esmallhiragana = 0x3047;
                    t.esmallkatakana = 0x30a7;
                    t.esmallkatakanahalfwidth = 0xff6a;
                    t.estimated = 0x212e;
                    t.esuperior = 0xf6ec;
                    t.eta = 0x03b7;
                    t.etarmenian = 0x0568;
                    t.etatonos = 0x03ae;
                    t.eth = 0x00f0;
                    t.etilde = 0x1ebd;
                    t.etildebelow = 0x1e1b;
                    t.etnahtafoukhhebrew = 0x0591;
                    t.etnahtafoukhlefthebrew = 0x0591;
                    t.etnahtahebrew = 0x0591;
                    t.etnahtalefthebrew = 0x0591;
                    t.eturned = 0x01dd;
                    t.eukorean = 0x3161;
                    t.euro = 0x20ac;
                    t.evowelsignbengali = 0x09c7;
                    t.evowelsigndeva = 0x0947;
                    t.evowelsigngujarati = 0x0ac7;
                    t.exclam = 0x0021;
                    t.exclamarmenian = 0x055c;
                    t.exclamdbl = 0x203c;
                    t.exclamdown = 0x00a1;
                    t.exclamdownsmall = 0xf7a1;
                    t.exclammonospace = 0xff01;
                    t.exclamsmall = 0xf721;
                    t.existential = 0x2203;
                    t.ezh = 0x0292;
                    t.ezhcaron = 0x01ef;
                    t.ezhcurl = 0x0293;
                    t.ezhreversed = 0x01b9;
                    t.ezhtail = 0x01ba;
                    t.f = 0x0066;
                    t.fadeva = 0x095e;
                    t.fagurmukhi = 0x0a5e;
                    t.fahrenheit = 0x2109;
                    t.fathaarabic = 0x064e;
                    t.fathalowarabic = 0x064e;
                    t.fathatanarabic = 0x064b;
                    t.fbopomofo = 0x3108;
                    t.fcircle = 0x24d5;
                    t.fdotaccent = 0x1e1f;
                    t.feharabic = 0x0641;
                    t.feharmenian = 0x0586;
                    t.fehfinalarabic = 0xfed2;
                    t.fehinitialarabic = 0xfed3;
                    t.fehmedialarabic = 0xfed4;
                    t.feicoptic = 0x03e5;
                    t.female = 0x2640;
                    t.ff = 0xfb00;
                    t.f_f = 0xfb00;
                    t.ffi = 0xfb03;
                    t.f_f_i = 0xfb03;
                    t.ffl = 0xfb04;
                    t.f_f_l = 0xfb04;
                    t.fi = 0xfb01;
                    t.f_i = 0xfb01;
                    t.fifteencircle = 0x246e;
                    t.fifteenparen = 0x2482;
                    t.fifteenperiod = 0x2496;
                    t.figuredash = 0x2012;
                    t.filledbox = 0x25a0;
                    t.filledrect = 0x25ac;
                    t.finalkaf = 0x05da;
                    t.finalkafdagesh = 0xfb3a;
                    t.finalkafdageshhebrew = 0xfb3a;
                    t.finalkafhebrew = 0x05da;
                    t.finalmem = 0x05dd;
                    t.finalmemhebrew = 0x05dd;
                    t.finalnun = 0x05df;
                    t.finalnunhebrew = 0x05df;
                    t.finalpe = 0x05e3;
                    t.finalpehebrew = 0x05e3;
                    t.finaltsadi = 0x05e5;
                    t.finaltsadihebrew = 0x05e5;
                    t.firsttonechinese = 0x02c9;
                    t.fisheye = 0x25c9;
                    t.fitacyrillic = 0x0473;
                    t.five = 0x0035;
                    t.fivearabic = 0x0665;
                    t.fivebengali = 0x09eb;
                    t.fivecircle = 0x2464;
                    t.fivecircleinversesansserif = 0x278e;
                    t.fivedeva = 0x096b;
                    t.fiveeighths = 0x215d;
                    t.fivegujarati = 0x0aeb;
                    t.fivegurmukhi = 0x0a6b;
                    t.fivehackarabic = 0x0665;
                    t.fivehangzhou = 0x3025;
                    t.fiveideographicparen = 0x3224;
                    t.fiveinferior = 0x2085;
                    t.fivemonospace = 0xff15;
                    t.fiveoldstyle = 0xf735;
                    t.fiveparen = 0x2478;
                    t.fiveperiod = 0x248c;
                    t.fivepersian = 0x06f5;
                    t.fiveroman = 0x2174;
                    t.fivesuperior = 0x2075;
                    t.fivethai = 0x0e55;
                    t.fl = 0xfb02;
                    t.f_l = 0xfb02;
                    t.florin = 0x0192;
                    t.fmonospace = 0xff46;
                    t.fmsquare = 0x3399;
                    t.fofanthai = 0x0e1f;
                    t.fofathai = 0x0e1d;
                    t.fongmanthai = 0x0e4f;
                    t.forall = 0x2200;
                    t.four = 0x0034;
                    t.fourarabic = 0x0664;
                    t.fourbengali = 0x09ea;
                    t.fourcircle = 0x2463;
                    t.fourcircleinversesansserif = 0x278d;
                    t.fourdeva = 0x096a;
                    t.fourgujarati = 0x0aea;
                    t.fourgurmukhi = 0x0a6a;
                    t.fourhackarabic = 0x0664;
                    t.fourhangzhou = 0x3024;
                    t.fourideographicparen = 0x3223;
                    t.fourinferior = 0x2084;
                    t.fourmonospace = 0xff14;
                    t.fournumeratorbengali = 0x09f7;
                    t.fouroldstyle = 0xf734;
                    t.fourparen = 0x2477;
                    t.fourperiod = 0x248b;
                    t.fourpersian = 0x06f4;
                    t.fourroman = 0x2173;
                    t.foursuperior = 0x2074;
                    t.fourteencircle = 0x246d;
                    t.fourteenparen = 0x2481;
                    t.fourteenperiod = 0x2495;
                    t.fourthai = 0x0e54;
                    t.fourthtonechinese = 0x02cb;
                    t.fparen = 0x24a1;
                    t.fraction = 0x2044;
                    t.franc = 0x20a3;
                    t.g = 0x0067;
                    t.gabengali = 0x0997;
                    t.gacute = 0x01f5;
                    t.gadeva = 0x0917;
                    t.gafarabic = 0x06af;
                    t.gaffinalarabic = 0xfb93;
                    t.gafinitialarabic = 0xfb94;
                    t.gafmedialarabic = 0xfb95;
                    t.gagujarati = 0x0a97;
                    t.gagurmukhi = 0x0a17;
                    t.gahiragana = 0x304c;
                    t.gakatakana = 0x30ac;
                    t.gamma = 0x03b3;
                    t.gammalatinsmall = 0x0263;
                    t.gammasuperior = 0x02e0;
                    t.gangiacoptic = 0x03eb;
                    t.gbopomofo = 0x310d;
                    t.gbreve = 0x011f;
                    t.gcaron = 0x01e7;
                    t.gcedilla = 0x0123;
                    t.gcircle = 0x24d6;
                    t.gcircumflex = 0x011d;
                    t.gcommaaccent = 0x0123;
                    t.gdot = 0x0121;
                    t.gdotaccent = 0x0121;
                    t.gecyrillic = 0x0433;
                    t.gehiragana = 0x3052;
                    t.gekatakana = 0x30b2;
                    t.geometricallyequal = 0x2251;
                    t.gereshaccenthebrew = 0x059c;
                    t.gereshhebrew = 0x05f3;
                    t.gereshmuqdamhebrew = 0x059d;
                    t.germandbls = 0x00df;
                    t.gershayimaccenthebrew = 0x059e;
                    t.gershayimhebrew = 0x05f4;
                    t.getamark = 0x3013;
                    t.ghabengali = 0x0998;
                    t.ghadarmenian = 0x0572;
                    t.ghadeva = 0x0918;
                    t.ghagujarati = 0x0a98;
                    t.ghagurmukhi = 0x0a18;
                    t.ghainarabic = 0x063a;
                    t.ghainfinalarabic = 0xfece;
                    t.ghaininitialarabic = 0xfecf;
                    t.ghainmedialarabic = 0xfed0;
                    t.ghemiddlehookcyrillic = 0x0495;
                    t.ghestrokecyrillic = 0x0493;
                    t.gheupturncyrillic = 0x0491;
                    t.ghhadeva = 0x095a;
                    t.ghhagurmukhi = 0x0a5a;
                    t.ghook = 0x0260;
                    t.ghzsquare = 0x3393;
                    t.gihiragana = 0x304e;
                    t.gikatakana = 0x30ae;
                    t.gimarmenian = 0x0563;
                    t.gimel = 0x05d2;
                    t.gimeldagesh = 0xfb32;
                    t.gimeldageshhebrew = 0xfb32;
                    t.gimelhebrew = 0x05d2;
                    t.gjecyrillic = 0x0453;
                    t.glottalinvertedstroke = 0x01be;
                    t.glottalstop = 0x0294;
                    t.glottalstopinverted = 0x0296;
                    t.glottalstopmod = 0x02c0;
                    t.glottalstopreversed = 0x0295;
                    t.glottalstopreversedmod = 0x02c1;
                    t.glottalstopreversedsuperior = 0x02e4;
                    t.glottalstopstroke = 0x02a1;
                    t.glottalstopstrokereversed = 0x02a2;
                    t.gmacron = 0x1e21;
                    t.gmonospace = 0xff47;
                    t.gohiragana = 0x3054;
                    t.gokatakana = 0x30b4;
                    t.gparen = 0x24a2;
                    t.gpasquare = 0x33ac;
                    t.gradient = 0x2207;
                    t.grave = 0x0060;
                    t.gravebelowcmb = 0x0316;
                    t.gravecmb = 0x0300;
                    t.gravecomb = 0x0300;
                    t.gravedeva = 0x0953;
                    t.gravelowmod = 0x02ce;
                    t.gravemonospace = 0xff40;
                    t.gravetonecmb = 0x0340;
                    t.greater = 0x003e;
                    t.greaterequal = 0x2265;
                    t.greaterequalorless = 0x22db;
                    t.greatermonospace = 0xff1e;
                    t.greaterorequivalent = 0x2273;
                    t.greaterorless = 0x2277;
                    t.greateroverequal = 0x2267;
                    t.greatersmall = 0xfe65;
                    t.gscript = 0x0261;
                    t.gstroke = 0x01e5;
                    t.guhiragana = 0x3050;
                    t.guillemotleft = 0x00ab;
                    t.guillemotright = 0x00bb;
                    t.guilsinglleft = 0x2039;
                    t.guilsinglright = 0x203a;
                    t.gukatakana = 0x30b0;
                    t.guramusquare = 0x3318;
                    t.gysquare = 0x33c9;
                    t.h = 0x0068;
                    t.haabkhasiancyrillic = 0x04a9;
                    t.haaltonearabic = 0x06c1;
                    t.habengali = 0x09b9;
                    t.hadescendercyrillic = 0x04b3;
                    t.hadeva = 0x0939;
                    t.hagujarati = 0x0ab9;
                    t.hagurmukhi = 0x0a39;
                    t.haharabic = 0x062d;
                    t.hahfinalarabic = 0xfea2;
                    t.hahinitialarabic = 0xfea3;
                    t.hahiragana = 0x306f;
                    t.hahmedialarabic = 0xfea4;
                    t.haitusquare = 0x332a;
                    t.hakatakana = 0x30cf;
                    t.hakatakanahalfwidth = 0xff8a;
                    t.halantgurmukhi = 0x0a4d;
                    t.hamzaarabic = 0x0621;
                    t.hamzalowarabic = 0x0621;
                    t.hangulfiller = 0x3164;
                    t.hardsigncyrillic = 0x044a;
                    t.harpoonleftbarbup = 0x21bc;
                    t.harpoonrightbarbup = 0x21c0;
                    t.hasquare = 0x33ca;
                    t.hatafpatah = 0x05b2;
                    t.hatafpatah16 = 0x05b2;
                    t.hatafpatah23 = 0x05b2;
                    t.hatafpatah2f = 0x05b2;
                    t.hatafpatahhebrew = 0x05b2;
                    t.hatafpatahnarrowhebrew = 0x05b2;
                    t.hatafpatahquarterhebrew = 0x05b2;
                    t.hatafpatahwidehebrew = 0x05b2;
                    t.hatafqamats = 0x05b3;
                    t.hatafqamats1b = 0x05b3;
                    t.hatafqamats28 = 0x05b3;
                    t.hatafqamats34 = 0x05b3;
                    t.hatafqamatshebrew = 0x05b3;
                    t.hatafqamatsnarrowhebrew = 0x05b3;
                    t.hatafqamatsquarterhebrew = 0x05b3;
                    t.hatafqamatswidehebrew = 0x05b3;
                    t.hatafsegol = 0x05b1;
                    t.hatafsegol17 = 0x05b1;
                    t.hatafsegol24 = 0x05b1;
                    t.hatafsegol30 = 0x05b1;
                    t.hatafsegolhebrew = 0x05b1;
                    t.hatafsegolnarrowhebrew = 0x05b1;
                    t.hatafsegolquarterhebrew = 0x05b1;
                    t.hatafsegolwidehebrew = 0x05b1;
                    t.hbar = 0x0127;
                    t.hbopomofo = 0x310f;
                    t.hbrevebelow = 0x1e2b;
                    t.hcedilla = 0x1e29;
                    t.hcircle = 0x24d7;
                    t.hcircumflex = 0x0125;
                    t.hdieresis = 0x1e27;
                    t.hdotaccent = 0x1e23;
                    t.hdotbelow = 0x1e25;
                    t.he = 0x05d4;
                    t.heart = 0x2665;
                    t.heartsuitblack = 0x2665;
                    t.heartsuitwhite = 0x2661;
                    t.hedagesh = 0xfb34;
                    t.hedageshhebrew = 0xfb34;
                    t.hehaltonearabic = 0x06c1;
                    t.heharabic = 0x0647;
                    t.hehebrew = 0x05d4;
                    t.hehfinalaltonearabic = 0xfba7;
                    t.hehfinalalttwoarabic = 0xfeea;
                    t.hehfinalarabic = 0xfeea;
                    t.hehhamzaabovefinalarabic = 0xfba5;
                    t.hehhamzaaboveisolatedarabic = 0xfba4;
                    t.hehinitialaltonearabic = 0xfba8;
                    t.hehinitialarabic = 0xfeeb;
                    t.hehiragana = 0x3078;
                    t.hehmedialaltonearabic = 0xfba9;
                    t.hehmedialarabic = 0xfeec;
                    t.heiseierasquare = 0x337b;
                    t.hekatakana = 0x30d8;
                    t.hekatakanahalfwidth = 0xff8d;
                    t.hekutaarusquare = 0x3336;
                    t.henghook = 0x0267;
                    t.herutusquare = 0x3339;
                    t.het = 0x05d7;
                    t.hethebrew = 0x05d7;
                    t.hhook = 0x0266;
                    t.hhooksuperior = 0x02b1;
                    t.hieuhacirclekorean = 0x327b;
                    t.hieuhaparenkorean = 0x321b;
                    t.hieuhcirclekorean = 0x326d;
                    t.hieuhkorean = 0x314e;
                    t.hieuhparenkorean = 0x320d;
                    t.hihiragana = 0x3072;
                    t.hikatakana = 0x30d2;
                    t.hikatakanahalfwidth = 0xff8b;
                    t.hiriq = 0x05b4;
                    t.hiriq14 = 0x05b4;
                    t.hiriq21 = 0x05b4;
                    t.hiriq2d = 0x05b4;
                    t.hiriqhebrew = 0x05b4;
                    t.hiriqnarrowhebrew = 0x05b4;
                    t.hiriqquarterhebrew = 0x05b4;
                    t.hiriqwidehebrew = 0x05b4;
                    t.hlinebelow = 0x1e96;
                    t.hmonospace = 0xff48;
                    t.hoarmenian = 0x0570;
                    t.hohipthai = 0x0e2b;
                    t.hohiragana = 0x307b;
                    t.hokatakana = 0x30db;
                    t.hokatakanahalfwidth = 0xff8e;
                    t.holam = 0x05b9;
                    t.holam19 = 0x05b9;
                    t.holam26 = 0x05b9;
                    t.holam32 = 0x05b9;
                    t.holamhebrew = 0x05b9;
                    t.holamnarrowhebrew = 0x05b9;
                    t.holamquarterhebrew = 0x05b9;
                    t.holamwidehebrew = 0x05b9;
                    t.honokhukthai = 0x0e2e;
                    t.hookabovecomb = 0x0309;
                    t.hookcmb = 0x0309;
                    t.hookpalatalizedbelowcmb = 0x0321;
                    t.hookretroflexbelowcmb = 0x0322;
                    t.hoonsquare = 0x3342;
                    t.horicoptic = 0x03e9;
                    t.horizontalbar = 0x2015;
                    t.horncmb = 0x031b;
                    t.hotsprings = 0x2668;
                    t.house = 0x2302;
                    t.hparen = 0x24a3;
                    t.hsuperior = 0x02b0;
                    t.hturned = 0x0265;
                    t.huhiragana = 0x3075;
                    t.huiitosquare = 0x3333;
                    t.hukatakana = 0x30d5;
                    t.hukatakanahalfwidth = 0xff8c;
                    t.hungarumlaut = 0x02dd;
                    t.hungarumlautcmb = 0x030b;
                    t.hv = 0x0195;
                    t.hyphen = 0x002d;
                    t.hypheninferior = 0xf6e5;
                    t.hyphenmonospace = 0xff0d;
                    t.hyphensmall = 0xfe63;
                    t.hyphensuperior = 0xf6e6;
                    t.hyphentwo = 0x2010;
                    t.i = 0x0069;
                    t.iacute = 0x00ed;
                    t.iacyrillic = 0x044f;
                    t.ibengali = 0x0987;
                    t.ibopomofo = 0x3127;
                    t.ibreve = 0x012d;
                    t.icaron = 0x01d0;
                    t.icircle = 0x24d8;
                    t.icircumflex = 0x00ee;
                    t.icyrillic = 0x0456;
                    t.idblgrave = 0x0209;
                    t.ideographearthcircle = 0x328f;
                    t.ideographfirecircle = 0x328b;
                    t.ideographicallianceparen = 0x323f;
                    t.ideographiccallparen = 0x323a;
                    t.ideographiccentrecircle = 0x32a5;
                    t.ideographicclose = 0x3006;
                    t.ideographiccomma = 0x3001;
                    t.ideographiccommaleft = 0xff64;
                    t.ideographiccongratulationparen = 0x3237;
                    t.ideographiccorrectcircle = 0x32a3;
                    t.ideographicearthparen = 0x322f;
                    t.ideographicenterpriseparen = 0x323d;
                    t.ideographicexcellentcircle = 0x329d;
                    t.ideographicfestivalparen = 0x3240;
                    t.ideographicfinancialcircle = 0x3296;
                    t.ideographicfinancialparen = 0x3236;
                    t.ideographicfireparen = 0x322b;
                    t.ideographichaveparen = 0x3232;
                    t.ideographichighcircle = 0x32a4;
                    t.ideographiciterationmark = 0x3005;
                    t.ideographiclaborcircle = 0x3298;
                    t.ideographiclaborparen = 0x3238;
                    t.ideographicleftcircle = 0x32a7;
                    t.ideographiclowcircle = 0x32a6;
                    t.ideographicmedicinecircle = 0x32a9;
                    t.ideographicmetalparen = 0x322e;
                    t.ideographicmoonparen = 0x322a;
                    t.ideographicnameparen = 0x3234;
                    t.ideographicperiod = 0x3002;
                    t.ideographicprintcircle = 0x329e;
                    t.ideographicreachparen = 0x3243;
                    t.ideographicrepresentparen = 0x3239;
                    t.ideographicresourceparen = 0x323e;
                    t.ideographicrightcircle = 0x32a8;
                    t.ideographicsecretcircle = 0x3299;
                    t.ideographicselfparen = 0x3242;
                    t.ideographicsocietyparen = 0x3233;
                    t.ideographicspace = 0x3000;
                    t.ideographicspecialparen = 0x3235;
                    t.ideographicstockparen = 0x3231;
                    t.ideographicstudyparen = 0x323b;
                    t.ideographicsunparen = 0x3230;
                    t.ideographicsuperviseparen = 0x323c;
                    t.ideographicwaterparen = 0x322c;
                    t.ideographicwoodparen = 0x322d;
                    t.ideographiczero = 0x3007;
                    t.ideographmetalcircle = 0x328e;
                    t.ideographmooncircle = 0x328a;
                    t.ideographnamecircle = 0x3294;
                    t.ideographsuncircle = 0x3290;
                    t.ideographwatercircle = 0x328c;
                    t.ideographwoodcircle = 0x328d;
                    t.ideva = 0x0907;
                    t.idieresis = 0x00ef;
                    t.idieresisacute = 0x1e2f;
                    t.idieresiscyrillic = 0x04e5;
                    t.idotbelow = 0x1ecb;
                    t.iebrevecyrillic = 0x04d7;
                    t.iecyrillic = 0x0435;
                    t.ieungacirclekorean = 0x3275;
                    t.ieungaparenkorean = 0x3215;
                    t.ieungcirclekorean = 0x3267;
                    t.ieungkorean = 0x3147;
                    t.ieungparenkorean = 0x3207;
                    t.igrave = 0x00ec;
                    t.igujarati = 0x0a87;
                    t.igurmukhi = 0x0a07;
                    t.ihiragana = 0x3044;
                    t.ihookabove = 0x1ec9;
                    t.iibengali = 0x0988;
                    t.iicyrillic = 0x0438;
                    t.iideva = 0x0908;
                    t.iigujarati = 0x0a88;
                    t.iigurmukhi = 0x0a08;
                    t.iimatragurmukhi = 0x0a40;
                    t.iinvertedbreve = 0x020b;
                    t.iishortcyrillic = 0x0439;
                    t.iivowelsignbengali = 0x09c0;
                    t.iivowelsigndeva = 0x0940;
                    t.iivowelsigngujarati = 0x0ac0;
                    t.ij = 0x0133;
                    t.ikatakana = 0x30a4;
                    t.ikatakanahalfwidth = 0xff72;
                    t.ikorean = 0x3163;
                    t.ilde = 0x02dc;
                    t.iluyhebrew = 0x05ac;
                    t.imacron = 0x012b;
                    t.imacroncyrillic = 0x04e3;
                    t.imageorapproximatelyequal = 0x2253;
                    t.imatragurmukhi = 0x0a3f;
                    t.imonospace = 0xff49;
                    t.increment = 0x2206;
                    t.infinity = 0x221e;
                    t.iniarmenian = 0x056b;
                    t.integral = 0x222b;
                    t.integralbottom = 0x2321;
                    t.integralbt = 0x2321;
                    t.integralex = 0xf8f5;
                    t.integraltop = 0x2320;
                    t.integraltp = 0x2320;
                    t.intersection = 0x2229;
                    t.intisquare = 0x3305;
                    t.invbullet = 0x25d8;
                    t.invcircle = 0x25d9;
                    t.invsmileface = 0x263b;
                    t.iocyrillic = 0x0451;
                    t.iogonek = 0x012f;
                    t.iota = 0x03b9;
                    t.iotadieresis = 0x03ca;
                    t.iotadieresistonos = 0x0390;
                    t.iotalatin = 0x0269;
                    t.iotatonos = 0x03af;
                    t.iparen = 0x24a4;
                    t.irigurmukhi = 0x0a72;
                    t.ismallhiragana = 0x3043;
                    t.ismallkatakana = 0x30a3;
                    t.ismallkatakanahalfwidth = 0xff68;
                    t.issharbengali = 0x09fa;
                    t.istroke = 0x0268;
                    t.isuperior = 0xf6ed;
                    t.iterationhiragana = 0x309d;
                    t.iterationkatakana = 0x30fd;
                    t.itilde = 0x0129;
                    t.itildebelow = 0x1e2d;
                    t.iubopomofo = 0x3129;
                    t.iucyrillic = 0x044e;
                    t.ivowelsignbengali = 0x09bf;
                    t.ivowelsigndeva = 0x093f;
                    t.ivowelsigngujarati = 0x0abf;
                    t.izhitsacyrillic = 0x0475;
                    t.izhitsadblgravecyrillic = 0x0477;
                    t.j = 0x006a;
                    t.jaarmenian = 0x0571;
                    t.jabengali = 0x099c;
                    t.jadeva = 0x091c;
                    t.jagujarati = 0x0a9c;
                    t.jagurmukhi = 0x0a1c;
                    t.jbopomofo = 0x3110;
                    t.jcaron = 0x01f0;
                    t.jcircle = 0x24d9;
                    t.jcircumflex = 0x0135;
                    t.jcrossedtail = 0x029d;
                    t.jdotlessstroke = 0x025f;
                    t.jecyrillic = 0x0458;
                    t.jeemarabic = 0x062c;
                    t.jeemfinalarabic = 0xfe9e;
                    t.jeeminitialarabic = 0xfe9f;
                    t.jeemmedialarabic = 0xfea0;
                    t.jeharabic = 0x0698;
                    t.jehfinalarabic = 0xfb8b;
                    t.jhabengali = 0x099d;
                    t.jhadeva = 0x091d;
                    t.jhagujarati = 0x0a9d;
                    t.jhagurmukhi = 0x0a1d;
                    t.jheharmenian = 0x057b;
                    t.jis = 0x3004;
                    t.jmonospace = 0xff4a;
                    t.jparen = 0x24a5;
                    t.jsuperior = 0x02b2;
                    t.k = 0x006b;
                    t.kabashkircyrillic = 0x04a1;
                    t.kabengali = 0x0995;
                    t.kacute = 0x1e31;
                    t.kacyrillic = 0x043a;
                    t.kadescendercyrillic = 0x049b;
                    t.kadeva = 0x0915;
                    t.kaf = 0x05db;
                    t.kafarabic = 0x0643;
                    t.kafdagesh = 0xfb3b;
                    t.kafdageshhebrew = 0xfb3b;
                    t.kaffinalarabic = 0xfeda;
                    t.kafhebrew = 0x05db;
                    t.kafinitialarabic = 0xfedb;
                    t.kafmedialarabic = 0xfedc;
                    t.kafrafehebrew = 0xfb4d;
                    t.kagujarati = 0x0a95;
                    t.kagurmukhi = 0x0a15;
                    t.kahiragana = 0x304b;
                    t.kahookcyrillic = 0x04c4;
                    t.kakatakana = 0x30ab;
                    t.kakatakanahalfwidth = 0xff76;
                    t.kappa = 0x03ba;
                    t.kappasymbolgreek = 0x03f0;
                    t.kapyeounmieumkorean = 0x3171;
                    t.kapyeounphieuphkorean = 0x3184;
                    t.kapyeounpieupkorean = 0x3178;
                    t.kapyeounssangpieupkorean = 0x3179;
                    t.karoriisquare = 0x330d;
                    t.kashidaautoarabic = 0x0640;
                    t.kashidaautonosidebearingarabic = 0x0640;
                    t.kasmallkatakana = 0x30f5;
                    t.kasquare = 0x3384;
                    t.kasraarabic = 0x0650;
                    t.kasratanarabic = 0x064d;
                    t.kastrokecyrillic = 0x049f;
                    t.katahiraprolongmarkhalfwidth = 0xff70;
                    t.kaverticalstrokecyrillic = 0x049d;
                    t.kbopomofo = 0x310e;
                    t.kcalsquare = 0x3389;
                    t.kcaron = 0x01e9;
                    t.kcedilla = 0x0137;
                    t.kcircle = 0x24da;
                    t.kcommaaccent = 0x0137;
                    t.kdotbelow = 0x1e33;
                    t.keharmenian = 0x0584;
                    t.kehiragana = 0x3051;
                    t.kekatakana = 0x30b1;
                    t.kekatakanahalfwidth = 0xff79;
                    t.kenarmenian = 0x056f;
                    t.kesmallkatakana = 0x30f6;
                    t.kgreenlandic = 0x0138;
                    t.khabengali = 0x0996;
                    t.khacyrillic = 0x0445;
                    t.khadeva = 0x0916;
                    t.khagujarati = 0x0a96;
                    t.khagurmukhi = 0x0a16;
                    t.khaharabic = 0x062e;
                    t.khahfinalarabic = 0xfea6;
                    t.khahinitialarabic = 0xfea7;
                    t.khahmedialarabic = 0xfea8;
                    t.kheicoptic = 0x03e7;
                    t.khhadeva = 0x0959;
                    t.khhagurmukhi = 0x0a59;
                    t.khieukhacirclekorean = 0x3278;
                    t.khieukhaparenkorean = 0x3218;
                    t.khieukhcirclekorean = 0x326a;
                    t.khieukhkorean = 0x314b;
                    t.khieukhparenkorean = 0x320a;
                    t.khokhaithai = 0x0e02;
                    t.khokhonthai = 0x0e05;
                    t.khokhuatthai = 0x0e03;
                    t.khokhwaithai = 0x0e04;
                    t.khomutthai = 0x0e5b;
                    t.khook = 0x0199;
                    t.khorakhangthai = 0x0e06;
                    t.khzsquare = 0x3391;
                    t.kihiragana = 0x304d;
                    t.kikatakana = 0x30ad;
                    t.kikatakanahalfwidth = 0xff77;
                    t.kiroguramusquare = 0x3315;
                    t.kiromeetorusquare = 0x3316;
                    t.kirosquare = 0x3314;
                    t.kiyeokacirclekorean = 0x326e;
                    t.kiyeokaparenkorean = 0x320e;
                    t.kiyeokcirclekorean = 0x3260;
                    t.kiyeokkorean = 0x3131;
                    t.kiyeokparenkorean = 0x3200;
                    t.kiyeoksioskorean = 0x3133;
                    t.kjecyrillic = 0x045c;
                    t.klinebelow = 0x1e35;
                    t.klsquare = 0x3398;
                    t.kmcubedsquare = 0x33a6;
                    t.kmonospace = 0xff4b;
                    t.kmsquaredsquare = 0x33a2;
                    t.kohiragana = 0x3053;
                    t.kohmsquare = 0x33c0;
                    t.kokaithai = 0x0e01;
                    t.kokatakana = 0x30b3;
                    t.kokatakanahalfwidth = 0xff7a;
                    t.kooposquare = 0x331e;
                    t.koppacyrillic = 0x0481;
                    t.koreanstandardsymbol = 0x327f;
                    t.koroniscmb = 0x0343;
                    t.kparen = 0x24a6;
                    t.kpasquare = 0x33aa;
                    t.ksicyrillic = 0x046f;
                    t.ktsquare = 0x33cf;
                    t.kturned = 0x029e;
                    t.kuhiragana = 0x304f;
                    t.kukatakana = 0x30af;
                    t.kukatakanahalfwidth = 0xff78;
                    t.kvsquare = 0x33b8;
                    t.kwsquare = 0x33be;
                    t.l = 0x006c;
                    t.labengali = 0x09b2;
                    t.lacute = 0x013a;
                    t.ladeva = 0x0932;
                    t.lagujarati = 0x0ab2;
                    t.lagurmukhi = 0x0a32;
                    t.lakkhangyaothai = 0x0e45;
                    t.lamaleffinalarabic = 0xfefc;
                    t.lamalefhamzaabovefinalarabic = 0xfef8;
                    t.lamalefhamzaaboveisolatedarabic = 0xfef7;
                    t.lamalefhamzabelowfinalarabic = 0xfefa;
                    t.lamalefhamzabelowisolatedarabic = 0xfef9;
                    t.lamalefisolatedarabic = 0xfefb;
                    t.lamalefmaddaabovefinalarabic = 0xfef6;
                    t.lamalefmaddaaboveisolatedarabic = 0xfef5;
                    t.lamarabic = 0x0644;
                    t.lambda = 0x03bb;
                    t.lambdastroke = 0x019b;
                    t.lamed = 0x05dc;
                    t.lameddagesh = 0xfb3c;
                    t.lameddageshhebrew = 0xfb3c;
                    t.lamedhebrew = 0x05dc;
                    t.lamfinalarabic = 0xfede;
                    t.lamhahinitialarabic = 0xfcca;
                    t.laminitialarabic = 0xfedf;
                    t.lamjeeminitialarabic = 0xfcc9;
                    t.lamkhahinitialarabic = 0xfccb;
                    t.lamlamhehisolatedarabic = 0xfdf2;
                    t.lammedialarabic = 0xfee0;
                    t.lammeemhahinitialarabic = 0xfd88;
                    t.lammeeminitialarabic = 0xfccc;
                    t.largecircle = 0x25ef;
                    t.lbar = 0x019a;
                    t.lbelt = 0x026c;
                    t.lbopomofo = 0x310c;
                    t.lcaron = 0x013e;
                    t.lcedilla = 0x013c;
                    t.lcircle = 0x24db;
                    t.lcircumflexbelow = 0x1e3d;
                    t.lcommaaccent = 0x013c;
                    t.ldot = 0x0140;
                    t.ldotaccent = 0x0140;
                    t.ldotbelow = 0x1e37;
                    t.ldotbelowmacron = 0x1e39;
                    t.leftangleabovecmb = 0x031a;
                    t.lefttackbelowcmb = 0x0318;
                    t.less = 0x003c;
                    t.lessequal = 0x2264;
                    t.lessequalorgreater = 0x22da;
                    t.lessmonospace = 0xff1c;
                    t.lessorequivalent = 0x2272;
                    t.lessorgreater = 0x2276;
                    t.lessoverequal = 0x2266;
                    t.lesssmall = 0xfe64;
                    t.lezh = 0x026e;
                    t.lfblock = 0x258c;
                    t.lhookretroflex = 0x026d;
                    t.lira = 0x20a4;
                    t.liwnarmenian = 0x056c;
                    t.lj = 0x01c9;
                    t.ljecyrillic = 0x0459;
                    t.ll = 0xf6c0;
                    t.lladeva = 0x0933;
                    t.llagujarati = 0x0ab3;
                    t.llinebelow = 0x1e3b;
                    t.llladeva = 0x0934;
                    t.llvocalicbengali = 0x09e1;
                    t.llvocalicdeva = 0x0961;
                    t.llvocalicvowelsignbengali = 0x09e3;
                    t.llvocalicvowelsigndeva = 0x0963;
                    t.lmiddletilde = 0x026b;
                    t.lmonospace = 0xff4c;
                    t.lmsquare = 0x33d0;
                    t.lochulathai = 0x0e2c;
                    t.logicaland = 0x2227;
                    t.logicalnot = 0x00ac;
                    t.logicalnotreversed = 0x2310;
                    t.logicalor = 0x2228;
                    t.lolingthai = 0x0e25;
                    t.longs = 0x017f;
                    t.lowlinecenterline = 0xfe4e;
                    t.lowlinecmb = 0x0332;
                    t.lowlinedashed = 0xfe4d;
                    t.lozenge = 0x25ca;
                    t.lparen = 0x24a7;
                    t.lslash = 0x0142;
                    t.lsquare = 0x2113;
                    t.lsuperior = 0xf6ee;
                    t.ltshade = 0x2591;
                    t.luthai = 0x0e26;
                    t.lvocalicbengali = 0x098c;
                    t.lvocalicdeva = 0x090c;
                    t.lvocalicvowelsignbengali = 0x09e2;
                    t.lvocalicvowelsigndeva = 0x0962;
                    t.lxsquare = 0x33d3;
                    t.m = 0x006d;
                    t.mabengali = 0x09ae;
                    t.macron = 0x00af;
                    t.macronbelowcmb = 0x0331;
                    t.macroncmb = 0x0304;
                    t.macronlowmod = 0x02cd;
                    t.macronmonospace = 0xffe3;
                    t.macute = 0x1e3f;
                    t.madeva = 0x092e;
                    t.magujarati = 0x0aae;
                    t.magurmukhi = 0x0a2e;
                    t.mahapakhhebrew = 0x05a4;
                    t.mahapakhlefthebrew = 0x05a4;
                    t.mahiragana = 0x307e;
                    t.maichattawalowleftthai = 0xf895;
                    t.maichattawalowrightthai = 0xf894;
                    t.maichattawathai = 0x0e4b;
                    t.maichattawaupperleftthai = 0xf893;
                    t.maieklowleftthai = 0xf88c;
                    t.maieklowrightthai = 0xf88b;
                    t.maiekthai = 0x0e48;
                    t.maiekupperleftthai = 0xf88a;
                    t.maihanakatleftthai = 0xf884;
                    t.maihanakatthai = 0x0e31;
                    t.maitaikhuleftthai = 0xf889;
                    t.maitaikhuthai = 0x0e47;
                    t.maitholowleftthai = 0xf88f;
                    t.maitholowrightthai = 0xf88e;
                    t.maithothai = 0x0e49;
                    t.maithoupperleftthai = 0xf88d;
                    t.maitrilowleftthai = 0xf892;
                    t.maitrilowrightthai = 0xf891;
                    t.maitrithai = 0x0e4a;
                    t.maitriupperleftthai = 0xf890;
                    t.maiyamokthai = 0x0e46;
                    t.makatakana = 0x30de;
                    t.makatakanahalfwidth = 0xff8f;
                    t.male = 0x2642;
                    t.mansyonsquare = 0x3347;
                    t.maqafhebrew = 0x05be;
                    t.mars = 0x2642;
                    t.masoracirclehebrew = 0x05af;
                    t.masquare = 0x3383;
                    t.mbopomofo = 0x3107;
                    t.mbsquare = 0x33d4;
                    t.mcircle = 0x24dc;
                    t.mcubedsquare = 0x33a5;
                    t.mdotaccent = 0x1e41;
                    t.mdotbelow = 0x1e43;
                    t.meemarabic = 0x0645;
                    t.meemfinalarabic = 0xfee2;
                    t.meeminitialarabic = 0xfee3;
                    t.meemmedialarabic = 0xfee4;
                    t.meemmeeminitialarabic = 0xfcd1;
                    t.meemmeemisolatedarabic = 0xfc48;
                    t.meetorusquare = 0x334d;
                    t.mehiragana = 0x3081;
                    t.meizierasquare = 0x337e;
                    t.mekatakana = 0x30e1;
                    t.mekatakanahalfwidth = 0xff92;
                    t.mem = 0x05de;
                    t.memdagesh = 0xfb3e;
                    t.memdageshhebrew = 0xfb3e;
                    t.memhebrew = 0x05de;
                    t.menarmenian = 0x0574;
                    t.merkhahebrew = 0x05a5;
                    t.merkhakefulahebrew = 0x05a6;
                    t.merkhakefulalefthebrew = 0x05a6;
                    t.merkhalefthebrew = 0x05a5;
                    t.mhook = 0x0271;
                    t.mhzsquare = 0x3392;
                    t.middledotkatakanahalfwidth = 0xff65;
                    t.middot = 0x00b7;
                    t.mieumacirclekorean = 0x3272;
                    t.mieumaparenkorean = 0x3212;
                    t.mieumcirclekorean = 0x3264;
                    t.mieumkorean = 0x3141;
                    t.mieumpansioskorean = 0x3170;
                    t.mieumparenkorean = 0x3204;
                    t.mieumpieupkorean = 0x316e;
                    t.mieumsioskorean = 0x316f;
                    t.mihiragana = 0x307f;
                    t.mikatakana = 0x30df;
                    t.mikatakanahalfwidth = 0xff90;
                    t.minus = 0x2212;
                    t.minusbelowcmb = 0x0320;
                    t.minuscircle = 0x2296;
                    t.minusmod = 0x02d7;
                    t.minusplus = 0x2213;
                    t.minute = 0x2032;
                    t.miribaarusquare = 0x334a;
                    t.mirisquare = 0x3349;
                    t.mlonglegturned = 0x0270;
                    t.mlsquare = 0x3396;
                    t.mmcubedsquare = 0x33a3;
                    t.mmonospace = 0xff4d;
                    t.mmsquaredsquare = 0x339f;
                    t.mohiragana = 0x3082;
                    t.mohmsquare = 0x33c1;
                    t.mokatakana = 0x30e2;
                    t.mokatakanahalfwidth = 0xff93;
                    t.molsquare = 0x33d6;
                    t.momathai = 0x0e21;
                    t.moverssquare = 0x33a7;
                    t.moverssquaredsquare = 0x33a8;
                    t.mparen = 0x24a8;
                    t.mpasquare = 0x33ab;
                    t.mssquare = 0x33b3;
                    t.msuperior = 0xf6ef;
                    t.mturned = 0x026f;
                    t.mu = 0x00b5;
                    t.mu1 = 0x00b5;
                    t.muasquare = 0x3382;
                    t.muchgreater = 0x226b;
                    t.muchless = 0x226a;
                    t.mufsquare = 0x338c;
                    t.mugreek = 0x03bc;
                    t.mugsquare = 0x338d;
                    t.muhiragana = 0x3080;
                    t.mukatakana = 0x30e0;
                    t.mukatakanahalfwidth = 0xff91;
                    t.mulsquare = 0x3395;
                    t.multiply = 0x00d7;
                    t.mumsquare = 0x339b;
                    t.munahhebrew = 0x05a3;
                    t.munahlefthebrew = 0x05a3;
                    t.musicalnote = 0x266a;
                    t.musicalnotedbl = 0x266b;
                    t.musicflatsign = 0x266d;
                    t.musicsharpsign = 0x266f;
                    t.mussquare = 0x33b2;
                    t.muvsquare = 0x33b6;
                    t.muwsquare = 0x33bc;
                    t.mvmegasquare = 0x33b9;
                    t.mvsquare = 0x33b7;
                    t.mwmegasquare = 0x33bf;
                    t.mwsquare = 0x33bd;
                    t.n = 0x006e;
                    t.nabengali = 0x09a8;
                    t.nabla = 0x2207;
                    t.nacute = 0x0144;
                    t.nadeva = 0x0928;
                    t.nagujarati = 0x0aa8;
                    t.nagurmukhi = 0x0a28;
                    t.nahiragana = 0x306a;
                    t.nakatakana = 0x30ca;
                    t.nakatakanahalfwidth = 0xff85;
                    t.napostrophe = 0x0149;
                    t.nasquare = 0x3381;
                    t.nbopomofo = 0x310b;
                    t.nbspace = 0x00a0;
                    t.ncaron = 0x0148;
                    t.ncedilla = 0x0146;
                    t.ncircle = 0x24dd;
                    t.ncircumflexbelow = 0x1e4b;
                    t.ncommaaccent = 0x0146;
                    t.ndotaccent = 0x1e45;
                    t.ndotbelow = 0x1e47;
                    t.nehiragana = 0x306d;
                    t.nekatakana = 0x30cd;
                    t.nekatakanahalfwidth = 0xff88;
                    t.newsheqelsign = 0x20aa;
                    t.nfsquare = 0x338b;
                    t.ngabengali = 0x0999;
                    t.ngadeva = 0x0919;
                    t.ngagujarati = 0x0a99;
                    t.ngagurmukhi = 0x0a19;
                    t.ngonguthai = 0x0e07;
                    t.nhiragana = 0x3093;
                    t.nhookleft = 0x0272;
                    t.nhookretroflex = 0x0273;
                    t.nieunacirclekorean = 0x326f;
                    t.nieunaparenkorean = 0x320f;
                    t.nieuncieuckorean = 0x3135;
                    t.nieuncirclekorean = 0x3261;
                    t.nieunhieuhkorean = 0x3136;
                    t.nieunkorean = 0x3134;
                    t.nieunpansioskorean = 0x3168;
                    t.nieunparenkorean = 0x3201;
                    t.nieunsioskorean = 0x3167;
                    t.nieuntikeutkorean = 0x3166;
                    t.nihiragana = 0x306b;
                    t.nikatakana = 0x30cb;
                    t.nikatakanahalfwidth = 0xff86;
                    t.nikhahitleftthai = 0xf899;
                    t.nikhahitthai = 0x0e4d;
                    t.nine = 0x0039;
                    t.ninearabic = 0x0669;
                    t.ninebengali = 0x09ef;
                    t.ninecircle = 0x2468;
                    t.ninecircleinversesansserif = 0x2792;
                    t.ninedeva = 0x096f;
                    t.ninegujarati = 0x0aef;
                    t.ninegurmukhi = 0x0a6f;
                    t.ninehackarabic = 0x0669;
                    t.ninehangzhou = 0x3029;
                    t.nineideographicparen = 0x3228;
                    t.nineinferior = 0x2089;
                    t.ninemonospace = 0xff19;
                    t.nineoldstyle = 0xf739;
                    t.nineparen = 0x247c;
                    t.nineperiod = 0x2490;
                    t.ninepersian = 0x06f9;
                    t.nineroman = 0x2178;
                    t.ninesuperior = 0x2079;
                    t.nineteencircle = 0x2472;
                    t.nineteenparen = 0x2486;
                    t.nineteenperiod = 0x249a;
                    t.ninethai = 0x0e59;
                    t.nj = 0x01cc;
                    t.njecyrillic = 0x045a;
                    t.nkatakana = 0x30f3;
                    t.nkatakanahalfwidth = 0xff9d;
                    t.nlegrightlong = 0x019e;
                    t.nlinebelow = 0x1e49;
                    t.nmonospace = 0xff4e;
                    t.nmsquare = 0x339a;
                    t.nnabengali = 0x09a3;
                    t.nnadeva = 0x0923;
                    t.nnagujarati = 0x0aa3;
                    t.nnagurmukhi = 0x0a23;
                    t.nnnadeva = 0x0929;
                    t.nohiragana = 0x306e;
                    t.nokatakana = 0x30ce;
                    t.nokatakanahalfwidth = 0xff89;
                    t.nonbreakingspace = 0x00a0;
                    t.nonenthai = 0x0e13;
                    t.nonuthai = 0x0e19;
                    t.noonarabic = 0x0646;
                    t.noonfinalarabic = 0xfee6;
                    t.noonghunnaarabic = 0x06ba;
                    t.noonghunnafinalarabic = 0xfb9f;
                    t.nooninitialarabic = 0xfee7;
                    t.noonjeeminitialarabic = 0xfcd2;
                    t.noonjeemisolatedarabic = 0xfc4b;
                    t.noonmedialarabic = 0xfee8;
                    t.noonmeeminitialarabic = 0xfcd5;
                    t.noonmeemisolatedarabic = 0xfc4e;
                    t.noonnoonfinalarabic = 0xfc8d;
                    t.notcontains = 0x220c;
                    t.notelement = 0x2209;
                    t.notelementof = 0x2209;
                    t.notequal = 0x2260;
                    t.notgreater = 0x226f;
                    t.notgreaternorequal = 0x2271;
                    t.notgreaternorless = 0x2279;
                    t.notidentical = 0x2262;
                    t.notless = 0x226e;
                    t.notlessnorequal = 0x2270;
                    t.notparallel = 0x2226;
                    t.notprecedes = 0x2280;
                    t.notsubset = 0x2284;
                    t.notsucceeds = 0x2281;
                    t.notsuperset = 0x2285;
                    t.nowarmenian = 0x0576;
                    t.nparen = 0x24a9;
                    t.nssquare = 0x33b1;
                    t.nsuperior = 0x207f;
                    t.ntilde = 0x00f1;
                    t.nu = 0x03bd;
                    t.nuhiragana = 0x306c;
                    t.nukatakana = 0x30cc;
                    t.nukatakanahalfwidth = 0xff87;
                    t.nuktabengali = 0x09bc;
                    t.nuktadeva = 0x093c;
                    t.nuktagujarati = 0x0abc;
                    t.nuktagurmukhi = 0x0a3c;
                    t.numbersign = 0x0023;
                    t.numbersignmonospace = 0xff03;
                    t.numbersignsmall = 0xfe5f;
                    t.numeralsigngreek = 0x0374;
                    t.numeralsignlowergreek = 0x0375;
                    t.numero = 0x2116;
                    t.nun = 0x05e0;
                    t.nundagesh = 0xfb40;
                    t.nundageshhebrew = 0xfb40;
                    t.nunhebrew = 0x05e0;
                    t.nvsquare = 0x33b5;
                    t.nwsquare = 0x33bb;
                    t.nyabengali = 0x099e;
                    t.nyadeva = 0x091e;
                    t.nyagujarati = 0x0a9e;
                    t.nyagurmukhi = 0x0a1e;
                    t.o = 0x006f;
                    t.oacute = 0x00f3;
                    t.oangthai = 0x0e2d;
                    t.obarred = 0x0275;
                    t.obarredcyrillic = 0x04e9;
                    t.obarreddieresiscyrillic = 0x04eb;
                    t.obengali = 0x0993;
                    t.obopomofo = 0x311b;
                    t.obreve = 0x014f;
                    t.ocandradeva = 0x0911;
                    t.ocandragujarati = 0x0a91;
                    t.ocandravowelsigndeva = 0x0949;
                    t.ocandravowelsigngujarati = 0x0ac9;
                    t.ocaron = 0x01d2;
                    t.ocircle = 0x24de;
                    t.ocircumflex = 0x00f4;
                    t.ocircumflexacute = 0x1ed1;
                    t.ocircumflexdotbelow = 0x1ed9;
                    t.ocircumflexgrave = 0x1ed3;
                    t.ocircumflexhookabove = 0x1ed5;
                    t.ocircumflextilde = 0x1ed7;
                    t.ocyrillic = 0x043e;
                    t.odblacute = 0x0151;
                    t.odblgrave = 0x020d;
                    t.odeva = 0x0913;
                    t.odieresis = 0x00f6;
                    t.odieresiscyrillic = 0x04e7;
                    t.odotbelow = 0x1ecd;
                    t.oe = 0x0153;
                    t.oekorean = 0x315a;
                    t.ogonek = 0x02db;
                    t.ogonekcmb = 0x0328;
                    t.ograve = 0x00f2;
                    t.ogujarati = 0x0a93;
                    t.oharmenian = 0x0585;
                    t.ohiragana = 0x304a;
                    t.ohookabove = 0x1ecf;
                    t.ohorn = 0x01a1;
                    t.ohornacute = 0x1edb;
                    t.ohorndotbelow = 0x1ee3;
                    t.ohorngrave = 0x1edd;
                    t.ohornhookabove = 0x1edf;
                    t.ohorntilde = 0x1ee1;
                    t.ohungarumlaut = 0x0151;
                    t.oi = 0x01a3;
                    t.oinvertedbreve = 0x020f;
                    t.okatakana = 0x30aa;
                    t.okatakanahalfwidth = 0xff75;
                    t.okorean = 0x3157;
                    t.olehebrew = 0x05ab;
                    t.omacron = 0x014d;
                    t.omacronacute = 0x1e53;
                    t.omacrongrave = 0x1e51;
                    t.omdeva = 0x0950;
                    t.omega = 0x03c9;
                    t.omega1 = 0x03d6;
                    t.omegacyrillic = 0x0461;
                    t.omegalatinclosed = 0x0277;
                    t.omegaroundcyrillic = 0x047b;
                    t.omegatitlocyrillic = 0x047d;
                    t.omegatonos = 0x03ce;
                    t.omgujarati = 0x0ad0;
                    t.omicron = 0x03bf;
                    t.omicrontonos = 0x03cc;
                    t.omonospace = 0xff4f;
                    t.one = 0x0031;
                    t.onearabic = 0x0661;
                    t.onebengali = 0x09e7;
                    t.onecircle = 0x2460;
                    t.onecircleinversesansserif = 0x278a;
                    t.onedeva = 0x0967;
                    t.onedotenleader = 0x2024;
                    t.oneeighth = 0x215b;
                    t.onefitted = 0xf6dc;
                    t.onegujarati = 0x0ae7;
                    t.onegurmukhi = 0x0a67;
                    t.onehackarabic = 0x0661;
                    t.onehalf = 0x00bd;
                    t.onehangzhou = 0x3021;
                    t.oneideographicparen = 0x3220;
                    t.oneinferior = 0x2081;
                    t.onemonospace = 0xff11;
                    t.onenumeratorbengali = 0x09f4;
                    t.oneoldstyle = 0xf731;
                    t.oneparen = 0x2474;
                    t.oneperiod = 0x2488;
                    t.onepersian = 0x06f1;
                    t.onequarter = 0x00bc;
                    t.oneroman = 0x2170;
                    t.onesuperior = 0x00b9;
                    t.onethai = 0x0e51;
                    t.onethird = 0x2153;
                    t.oogonek = 0x01eb;
                    t.oogonekmacron = 0x01ed;
                    t.oogurmukhi = 0x0a13;
                    t.oomatragurmukhi = 0x0a4b;
                    t.oopen = 0x0254;
                    t.oparen = 0x24aa;
                    t.openbullet = 0x25e6;
                    t.option = 0x2325;
                    t.ordfeminine = 0x00aa;
                    t.ordmasculine = 0x00ba;
                    t.orthogonal = 0x221f;
                    t.oshortdeva = 0x0912;
                    t.oshortvowelsigndeva = 0x094a;
                    t.oslash = 0x00f8;
                    t.oslashacute = 0x01ff;
                    t.osmallhiragana = 0x3049;
                    t.osmallkatakana = 0x30a9;
                    t.osmallkatakanahalfwidth = 0xff6b;
                    t.ostrokeacute = 0x01ff;
                    t.osuperior = 0xf6f0;
                    t.otcyrillic = 0x047f;
                    t.otilde = 0x00f5;
                    t.otildeacute = 0x1e4d;
                    t.otildedieresis = 0x1e4f;
                    t.oubopomofo = 0x3121;
                    t.overline = 0x203e;
                    t.overlinecenterline = 0xfe4a;
                    t.overlinecmb = 0x0305;
                    t.overlinedashed = 0xfe49;
                    t.overlinedblwavy = 0xfe4c;
                    t.overlinewavy = 0xfe4b;
                    t.overscore = 0x00af;
                    t.ovowelsignbengali = 0x09cb;
                    t.ovowelsigndeva = 0x094b;
                    t.ovowelsigngujarati = 0x0acb;
                    t.p = 0x0070;
                    t.paampssquare = 0x3380;
                    t.paasentosquare = 0x332b;
                    t.pabengali = 0x09aa;
                    t.pacute = 0x1e55;
                    t.padeva = 0x092a;
                    t.pagedown = 0x21df;
                    t.pageup = 0x21de;
                    t.pagujarati = 0x0aaa;
                    t.pagurmukhi = 0x0a2a;
                    t.pahiragana = 0x3071;
                    t.paiyannoithai = 0x0e2f;
                    t.pakatakana = 0x30d1;
                    t.palatalizationcyrilliccmb = 0x0484;
                    t.palochkacyrillic = 0x04c0;
                    t.pansioskorean = 0x317f;
                    t.paragraph = 0x00b6;
                    t.parallel = 0x2225;
                    t.parenleft = 0x0028;
                    t.parenleftaltonearabic = 0xfd3e;
                    t.parenleftbt = 0xf8ed;
                    t.parenleftex = 0xf8ec;
                    t.parenleftinferior = 0x208d;
                    t.parenleftmonospace = 0xff08;
                    t.parenleftsmall = 0xfe59;
                    t.parenleftsuperior = 0x207d;
                    t.parenlefttp = 0xf8eb;
                    t.parenleftvertical = 0xfe35;
                    t.parenright = 0x0029;
                    t.parenrightaltonearabic = 0xfd3f;
                    t.parenrightbt = 0xf8f8;
                    t.parenrightex = 0xf8f7;
                    t.parenrightinferior = 0x208e;
                    t.parenrightmonospace = 0xff09;
                    t.parenrightsmall = 0xfe5a;
                    t.parenrightsuperior = 0x207e;
                    t.parenrighttp = 0xf8f6;
                    t.parenrightvertical = 0xfe36;
                    t.partialdiff = 0x2202;
                    t.paseqhebrew = 0x05c0;
                    t.pashtahebrew = 0x0599;
                    t.pasquare = 0x33a9;
                    t.patah = 0x05b7;
                    t.patah11 = 0x05b7;
                    t.patah1d = 0x05b7;
                    t.patah2a = 0x05b7;
                    t.patahhebrew = 0x05b7;
                    t.patahnarrowhebrew = 0x05b7;
                    t.patahquarterhebrew = 0x05b7;
                    t.patahwidehebrew = 0x05b7;
                    t.pazerhebrew = 0x05a1;
                    t.pbopomofo = 0x3106;
                    t.pcircle = 0x24df;
                    t.pdotaccent = 0x1e57;
                    t.pe = 0x05e4;
                    t.pecyrillic = 0x043f;
                    t.pedagesh = 0xfb44;
                    t.pedageshhebrew = 0xfb44;
                    t.peezisquare = 0x333b;
                    t.pefinaldageshhebrew = 0xfb43;
                    t.peharabic = 0x067e;
                    t.peharmenian = 0x057a;
                    t.pehebrew = 0x05e4;
                    t.pehfinalarabic = 0xfb57;
                    t.pehinitialarabic = 0xfb58;
                    t.pehiragana = 0x307a;
                    t.pehmedialarabic = 0xfb59;
                    t.pekatakana = 0x30da;
                    t.pemiddlehookcyrillic = 0x04a7;
                    t.perafehebrew = 0xfb4e;
                    t.percent = 0x0025;
                    t.percentarabic = 0x066a;
                    t.percentmonospace = 0xff05;
                    t.percentsmall = 0xfe6a;
                    t.period = 0x002e;
                    t.periodarmenian = 0x0589;
                    t.periodcentered = 0x00b7;
                    t.periodhalfwidth = 0xff61;
                    t.periodinferior = 0xf6e7;
                    t.periodmonospace = 0xff0e;
                    t.periodsmall = 0xfe52;
                    t.periodsuperior = 0xf6e8;
                    t.perispomenigreekcmb = 0x0342;
                    t.perpendicular = 0x22a5;
                    t.perthousand = 0x2030;
                    t.peseta = 0x20a7;
                    t.pfsquare = 0x338a;
                    t.phabengali = 0x09ab;
                    t.phadeva = 0x092b;
                    t.phagujarati = 0x0aab;
                    t.phagurmukhi = 0x0a2b;
                    t.phi = 0x03c6;
                    t.phi1 = 0x03d5;
                    t.phieuphacirclekorean = 0x327a;
                    t.phieuphaparenkorean = 0x321a;
                    t.phieuphcirclekorean = 0x326c;
                    t.phieuphkorean = 0x314d;
                    t.phieuphparenkorean = 0x320c;
                    t.philatin = 0x0278;
                    t.phinthuthai = 0x0e3a;
                    t.phisymbolgreek = 0x03d5;
                    t.phook = 0x01a5;
                    t.phophanthai = 0x0e1e;
                    t.phophungthai = 0x0e1c;
                    t.phosamphaothai = 0x0e20;
                    t.pi = 0x03c0;
                    t.pieupacirclekorean = 0x3273;
                    t.pieupaparenkorean = 0x3213;
                    t.pieupcieuckorean = 0x3176;
                    t.pieupcirclekorean = 0x3265;
                    t.pieupkiyeokkorean = 0x3172;
                    t.pieupkorean = 0x3142;
                    t.pieupparenkorean = 0x3205;
                    t.pieupsioskiyeokkorean = 0x3174;
                    t.pieupsioskorean = 0x3144;
                    t.pieupsiostikeutkorean = 0x3175;
                    t.pieupthieuthkorean = 0x3177;
                    t.pieuptikeutkorean = 0x3173;
                    t.pihiragana = 0x3074;
                    t.pikatakana = 0x30d4;
                    t.pisymbolgreek = 0x03d6;
                    t.piwrarmenian = 0x0583;
                    t.planckover2pi = 0x210f;
                    t.planckover2pi1 = 0x210f;
                    t.plus = 0x002b;
                    t.plusbelowcmb = 0x031f;
                    t.pluscircle = 0x2295;
                    t.plusminus = 0x00b1;
                    t.plusmod = 0x02d6;
                    t.plusmonospace = 0xff0b;
                    t.plussmall = 0xfe62;
                    t.plussuperior = 0x207a;
                    t.pmonospace = 0xff50;
                    t.pmsquare = 0x33d8;
                    t.pohiragana = 0x307d;
                    t.pointingindexdownwhite = 0x261f;
                    t.pointingindexleftwhite = 0x261c;
                    t.pointingindexrightwhite = 0x261e;
                    t.pointingindexupwhite = 0x261d;
                    t.pokatakana = 0x30dd;
                    t.poplathai = 0x0e1b;
                    t.postalmark = 0x3012;
                    t.postalmarkface = 0x3020;
                    t.pparen = 0x24ab;
                    t.precedes = 0x227a;
                    t.prescription = 0x211e;
                    t.primemod = 0x02b9;
                    t.primereversed = 0x2035;
                    t.product = 0x220f;
                    t.projective = 0x2305;
                    t.prolongedkana = 0x30fc;
                    t.propellor = 0x2318;
                    t.propersubset = 0x2282;
                    t.propersuperset = 0x2283;
                    t.proportion = 0x2237;
                    t.proportional = 0x221d;
                    t.psi = 0x03c8;
                    t.psicyrillic = 0x0471;
                    t.psilipneumatacyrilliccmb = 0x0486;
                    t.pssquare = 0x33b0;
                    t.puhiragana = 0x3077;
                    t.pukatakana = 0x30d7;
                    t.pvsquare = 0x33b4;
                    t.pwsquare = 0x33ba;
                    t.q = 0x0071;
                    t.qadeva = 0x0958;
                    t.qadmahebrew = 0x05a8;
                    t.qafarabic = 0x0642;
                    t.qaffinalarabic = 0xfed6;
                    t.qafinitialarabic = 0xfed7;
                    t.qafmedialarabic = 0xfed8;
                    t.qamats = 0x05b8;
                    t.qamats10 = 0x05b8;
                    t.qamats1a = 0x05b8;
                    t.qamats1c = 0x05b8;
                    t.qamats27 = 0x05b8;
                    t.qamats29 = 0x05b8;
                    t.qamats33 = 0x05b8;
                    t.qamatsde = 0x05b8;
                    t.qamatshebrew = 0x05b8;
                    t.qamatsnarrowhebrew = 0x05b8;
                    t.qamatsqatanhebrew = 0x05b8;
                    t.qamatsqatannarrowhebrew = 0x05b8;
                    t.qamatsqatanquarterhebrew = 0x05b8;
                    t.qamatsqatanwidehebrew = 0x05b8;
                    t.qamatsquarterhebrew = 0x05b8;
                    t.qamatswidehebrew = 0x05b8;
                    t.qarneyparahebrew = 0x059f;
                    t.qbopomofo = 0x3111;
                    t.qcircle = 0x24e0;
                    t.qhook = 0x02a0;
                    t.qmonospace = 0xff51;
                    t.qof = 0x05e7;
                    t.qofdagesh = 0xfb47;
                    t.qofdageshhebrew = 0xfb47;
                    t.qofhebrew = 0x05e7;
                    t.qparen = 0x24ac;
                    t.quarternote = 0x2669;
                    t.qubuts = 0x05bb;
                    t.qubuts18 = 0x05bb;
                    t.qubuts25 = 0x05bb;
                    t.qubuts31 = 0x05bb;
                    t.qubutshebrew = 0x05bb;
                    t.qubutsnarrowhebrew = 0x05bb;
                    t.qubutsquarterhebrew = 0x05bb;
                    t.qubutswidehebrew = 0x05bb;
                    t.question = 0x003f;
                    t.questionarabic = 0x061f;
                    t.questionarmenian = 0x055e;
                    t.questiondown = 0x00bf;
                    t.questiondownsmall = 0xf7bf;
                    t.questiongreek = 0x037e;
                    t.questionmonospace = 0xff1f;
                    t.questionsmall = 0xf73f;
                    t.quotedbl = 0x0022;
                    t.quotedblbase = 0x201e;
                    t.quotedblleft = 0x201c;
                    t.quotedblmonospace = 0xff02;
                    t.quotedblprime = 0x301e;
                    t.quotedblprimereversed = 0x301d;
                    t.quotedblright = 0x201d;
                    t.quoteleft = 0x2018;
                    t.quoteleftreversed = 0x201b;
                    t.quotereversed = 0x201b;
                    t.quoteright = 0x2019;
                    t.quoterightn = 0x0149;
                    t.quotesinglbase = 0x201a;
                    t.quotesingle = 0x0027;
                    t.quotesinglemonospace = 0xff07;
                    t.r = 0x0072;
                    t.raarmenian = 0x057c;
                    t.rabengali = 0x09b0;
                    t.racute = 0x0155;
                    t.radeva = 0x0930;
                    t.radical = 0x221a;
                    t.radicalex = 0xf8e5;
                    t.radoverssquare = 0x33ae;
                    t.radoverssquaredsquare = 0x33af;
                    t.radsquare = 0x33ad;
                    t.rafe = 0x05bf;
                    t.rafehebrew = 0x05bf;
                    t.ragujarati = 0x0ab0;
                    t.ragurmukhi = 0x0a30;
                    t.rahiragana = 0x3089;
                    t.rakatakana = 0x30e9;
                    t.rakatakanahalfwidth = 0xff97;
                    t.ralowerdiagonalbengali = 0x09f1;
                    t.ramiddlediagonalbengali = 0x09f0;
                    t.ramshorn = 0x0264;
                    t.ratio = 0x2236;
                    t.rbopomofo = 0x3116;
                    t.rcaron = 0x0159;
                    t.rcedilla = 0x0157;
                    t.rcircle = 0x24e1;
                    t.rcommaaccent = 0x0157;
                    t.rdblgrave = 0x0211;
                    t.rdotaccent = 0x1e59;
                    t.rdotbelow = 0x1e5b;
                    t.rdotbelowmacron = 0x1e5d;
                    t.referencemark = 0x203b;
                    t.reflexsubset = 0x2286;
                    t.reflexsuperset = 0x2287;
                    t.registered = 0x00ae;
                    t.registersans = 0xf8e8;
                    t.registerserif = 0xf6da;
                    t.reharabic = 0x0631;
                    t.reharmenian = 0x0580;
                    t.rehfinalarabic = 0xfeae;
                    t.rehiragana = 0x308c;
                    t.rekatakana = 0x30ec;
                    t.rekatakanahalfwidth = 0xff9a;
                    t.resh = 0x05e8;
                    t.reshdageshhebrew = 0xfb48;
                    t.reshhebrew = 0x05e8;
                    t.reversedtilde = 0x223d;
                    t.reviahebrew = 0x0597;
                    t.reviamugrashhebrew = 0x0597;
                    t.revlogicalnot = 0x2310;
                    t.rfishhook = 0x027e;
                    t.rfishhookreversed = 0x027f;
                    t.rhabengali = 0x09dd;
                    t.rhadeva = 0x095d;
                    t.rho = 0x03c1;
                    t.rhook = 0x027d;
                    t.rhookturned = 0x027b;
                    t.rhookturnedsuperior = 0x02b5;
                    t.rhosymbolgreek = 0x03f1;
                    t.rhotichookmod = 0x02de;
                    t.rieulacirclekorean = 0x3271;
                    t.rieulaparenkorean = 0x3211;
                    t.rieulcirclekorean = 0x3263;
                    t.rieulhieuhkorean = 0x3140;
                    t.rieulkiyeokkorean = 0x313a;
                    t.rieulkiyeoksioskorean = 0x3169;
                    t.rieulkorean = 0x3139;
                    t.rieulmieumkorean = 0x313b;
                    t.rieulpansioskorean = 0x316c;
                    t.rieulparenkorean = 0x3203;
                    t.rieulphieuphkorean = 0x313f;
                    t.rieulpieupkorean = 0x313c;
                    t.rieulpieupsioskorean = 0x316b;
                    t.rieulsioskorean = 0x313d;
                    t.rieulthieuthkorean = 0x313e;
                    t.rieultikeutkorean = 0x316a;
                    t.rieulyeorinhieuhkorean = 0x316d;
                    t.rightangle = 0x221f;
                    t.righttackbelowcmb = 0x0319;
                    t.righttriangle = 0x22bf;
                    t.rihiragana = 0x308a;
                    t.rikatakana = 0x30ea;
                    t.rikatakanahalfwidth = 0xff98;
                    t.ring = 0x02da;
                    t.ringbelowcmb = 0x0325;
                    t.ringcmb = 0x030a;
                    t.ringhalfleft = 0x02bf;
                    t.ringhalfleftarmenian = 0x0559;
                    t.ringhalfleftbelowcmb = 0x031c;
                    t.ringhalfleftcentered = 0x02d3;
                    t.ringhalfright = 0x02be;
                    t.ringhalfrightbelowcmb = 0x0339;
                    t.ringhalfrightcentered = 0x02d2;
                    t.rinvertedbreve = 0x0213;
                    t.rittorusquare = 0x3351;
                    t.rlinebelow = 0x1e5f;
                    t.rlongleg = 0x027c;
                    t.rlonglegturned = 0x027a;
                    t.rmonospace = 0xff52;
                    t.rohiragana = 0x308d;
                    t.rokatakana = 0x30ed;
                    t.rokatakanahalfwidth = 0xff9b;
                    t.roruathai = 0x0e23;
                    t.rparen = 0x24ad;
                    t.rrabengali = 0x09dc;
                    t.rradeva = 0x0931;
                    t.rragurmukhi = 0x0a5c;
                    t.rreharabic = 0x0691;
                    t.rrehfinalarabic = 0xfb8d;
                    t.rrvocalicbengali = 0x09e0;
                    t.rrvocalicdeva = 0x0960;
                    t.rrvocalicgujarati = 0x0ae0;
                    t.rrvocalicvowelsignbengali = 0x09c4;
                    t.rrvocalicvowelsigndeva = 0x0944;
                    t.rrvocalicvowelsigngujarati = 0x0ac4;
                    t.rsuperior = 0xf6f1;
                    t.rtblock = 0x2590;
                    t.rturned = 0x0279;
                    t.rturnedsuperior = 0x02b4;
                    t.ruhiragana = 0x308b;
                    t.rukatakana = 0x30eb;
                    t.rukatakanahalfwidth = 0xff99;
                    t.rupeemarkbengali = 0x09f2;
                    t.rupeesignbengali = 0x09f3;
                    t.rupiah = 0xf6dd;
                    t.ruthai = 0x0e24;
                    t.rvocalicbengali = 0x098b;
                    t.rvocalicdeva = 0x090b;
                    t.rvocalicgujarati = 0x0a8b;
                    t.rvocalicvowelsignbengali = 0x09c3;
                    t.rvocalicvowelsigndeva = 0x0943;
                    t.rvocalicvowelsigngujarati = 0x0ac3;
                    t.s = 0x0073;
                    t.sabengali = 0x09b8;
                    t.sacute = 0x015b;
                    t.sacutedotaccent = 0x1e65;
                    t.sadarabic = 0x0635;
                    t.sadeva = 0x0938;
                    t.sadfinalarabic = 0xfeba;
                    t.sadinitialarabic = 0xfebb;
                    t.sadmedialarabic = 0xfebc;
                    t.sagujarati = 0x0ab8;
                    t.sagurmukhi = 0x0a38;
                    t.sahiragana = 0x3055;
                    t.sakatakana = 0x30b5;
                    t.sakatakanahalfwidth = 0xff7b;
                    t.sallallahoualayhewasallamarabic = 0xfdfa;
                    t.samekh = 0x05e1;
                    t.samekhdagesh = 0xfb41;
                    t.samekhdageshhebrew = 0xfb41;
                    t.samekhhebrew = 0x05e1;
                    t.saraaathai = 0x0e32;
                    t.saraaethai = 0x0e41;
                    t.saraaimaimalaithai = 0x0e44;
                    t.saraaimaimuanthai = 0x0e43;
                    t.saraamthai = 0x0e33;
                    t.saraathai = 0x0e30;
                    t.saraethai = 0x0e40;
                    t.saraiileftthai = 0xf886;
                    t.saraiithai = 0x0e35;
                    t.saraileftthai = 0xf885;
                    t.saraithai = 0x0e34;
                    t.saraothai = 0x0e42;
                    t.saraueeleftthai = 0xf888;
                    t.saraueethai = 0x0e37;
                    t.saraueleftthai = 0xf887;
                    t.sarauethai = 0x0e36;
                    t.sarauthai = 0x0e38;
                    t.sarauuthai = 0x0e39;
                    t.sbopomofo = 0x3119;
                    t.scaron = 0x0161;
                    t.scarondotaccent = 0x1e67;
                    t.scedilla = 0x015f;
                    t.schwa = 0x0259;
                    t.schwacyrillic = 0x04d9;
                    t.schwadieresiscyrillic = 0x04db;
                    t.schwahook = 0x025a;
                    t.scircle = 0x24e2;
                    t.scircumflex = 0x015d;
                    t.scommaaccent = 0x0219;
                    t.sdotaccent = 0x1e61;
                    t.sdotbelow = 0x1e63;
                    t.sdotbelowdotaccent = 0x1e69;
                    t.seagullbelowcmb = 0x033c;
                    t.second = 0x2033;
                    t.secondtonechinese = 0x02ca;
                    t.section = 0x00a7;
                    t.seenarabic = 0x0633;
                    t.seenfinalarabic = 0xfeb2;
                    t.seeninitialarabic = 0xfeb3;
                    t.seenmedialarabic = 0xfeb4;
                    t.segol = 0x05b6;
                    t.segol13 = 0x05b6;
                    t.segol1f = 0x05b6;
                    t.segol2c = 0x05b6;
                    t.segolhebrew = 0x05b6;
                    t.segolnarrowhebrew = 0x05b6;
                    t.segolquarterhebrew = 0x05b6;
                    t.segoltahebrew = 0x0592;
                    t.segolwidehebrew = 0x05b6;
                    t.seharmenian = 0x057d;
                    t.sehiragana = 0x305b;
                    t.sekatakana = 0x30bb;
                    t.sekatakanahalfwidth = 0xff7e;
                    t.semicolon = 0x003b;
                    t.semicolonarabic = 0x061b;
                    t.semicolonmonospace = 0xff1b;
                    t.semicolonsmall = 0xfe54;
                    t.semivoicedmarkkana = 0x309c;
                    t.semivoicedmarkkanahalfwidth = 0xff9f;
                    t.sentisquare = 0x3322;
                    t.sentosquare = 0x3323;
                    t.seven = 0x0037;
                    t.sevenarabic = 0x0667;
                    t.sevenbengali = 0x09ed;
                    t.sevencircle = 0x2466;
                    t.sevencircleinversesansserif = 0x2790;
                    t.sevendeva = 0x096d;
                    t.seveneighths = 0x215e;
                    t.sevengujarati = 0x0aed;
                    t.sevengurmukhi = 0x0a6d;
                    t.sevenhackarabic = 0x0667;
                    t.sevenhangzhou = 0x3027;
                    t.sevenideographicparen = 0x3226;
                    t.seveninferior = 0x2087;
                    t.sevenmonospace = 0xff17;
                    t.sevenoldstyle = 0xf737;
                    t.sevenparen = 0x247a;
                    t.sevenperiod = 0x248e;
                    t.sevenpersian = 0x06f7;
                    t.sevenroman = 0x2176;
                    t.sevensuperior = 0x2077;
                    t.seventeencircle = 0x2470;
                    t.seventeenparen = 0x2484;
                    t.seventeenperiod = 0x2498;
                    t.seventhai = 0x0e57;
                    t.sfthyphen = 0x00ad;
                    t.shaarmenian = 0x0577;
                    t.shabengali = 0x09b6;
                    t.shacyrillic = 0x0448;
                    t.shaddaarabic = 0x0651;
                    t.shaddadammaarabic = 0xfc61;
                    t.shaddadammatanarabic = 0xfc5e;
                    t.shaddafathaarabic = 0xfc60;
                    t.shaddakasraarabic = 0xfc62;
                    t.shaddakasratanarabic = 0xfc5f;
                    t.shade = 0x2592;
                    t.shadedark = 0x2593;
                    t.shadelight = 0x2591;
                    t.shademedium = 0x2592;
                    t.shadeva = 0x0936;
                    t.shagujarati = 0x0ab6;
                    t.shagurmukhi = 0x0a36;
                    t.shalshelethebrew = 0x0593;
                    t.shbopomofo = 0x3115;
                    t.shchacyrillic = 0x0449;
                    t.sheenarabic = 0x0634;
                    t.sheenfinalarabic = 0xfeb6;
                    t.sheeninitialarabic = 0xfeb7;
                    t.sheenmedialarabic = 0xfeb8;
                    t.sheicoptic = 0x03e3;
                    t.sheqel = 0x20aa;
                    t.sheqelhebrew = 0x20aa;
                    t.sheva = 0x05b0;
                    t.sheva115 = 0x05b0;
                    t.sheva15 = 0x05b0;
                    t.sheva22 = 0x05b0;
                    t.sheva2e = 0x05b0;
                    t.shevahebrew = 0x05b0;
                    t.shevanarrowhebrew = 0x05b0;
                    t.shevaquarterhebrew = 0x05b0;
                    t.shevawidehebrew = 0x05b0;
                    t.shhacyrillic = 0x04bb;
                    t.shimacoptic = 0x03ed;
                    t.shin = 0x05e9;
                    t.shindagesh = 0xfb49;
                    t.shindageshhebrew = 0xfb49;
                    t.shindageshshindot = 0xfb2c;
                    t.shindageshshindothebrew = 0xfb2c;
                    t.shindageshsindot = 0xfb2d;
                    t.shindageshsindothebrew = 0xfb2d;
                    t.shindothebrew = 0x05c1;
                    t.shinhebrew = 0x05e9;
                    t.shinshindot = 0xfb2a;
                    t.shinshindothebrew = 0xfb2a;
                    t.shinsindot = 0xfb2b;
                    t.shinsindothebrew = 0xfb2b;
                    t.shook = 0x0282;
                    t.sigma = 0x03c3;
                    t.sigma1 = 0x03c2;
                    t.sigmafinal = 0x03c2;
                    t.sigmalunatesymbolgreek = 0x03f2;
                    t.sihiragana = 0x3057;
                    t.sikatakana = 0x30b7;
                    t.sikatakanahalfwidth = 0xff7c;
                    t.siluqhebrew = 0x05bd;
                    t.siluqlefthebrew = 0x05bd;
                    t.similar = 0x223c;
                    t.sindothebrew = 0x05c2;
                    t.siosacirclekorean = 0x3274;
                    t.siosaparenkorean = 0x3214;
                    t.sioscieuckorean = 0x317e;
                    t.sioscirclekorean = 0x3266;
                    t.sioskiyeokkorean = 0x317a;
                    t.sioskorean = 0x3145;
                    t.siosnieunkorean = 0x317b;
                    t.siosparenkorean = 0x3206;
                    t.siospieupkorean = 0x317d;
                    t.siostikeutkorean = 0x317c;
                    t.six = 0x0036;
                    t.sixarabic = 0x0666;
                    t.sixbengali = 0x09ec;
                    t.sixcircle = 0x2465;
                    t.sixcircleinversesansserif = 0x278f;
                    t.sixdeva = 0x096c;
                    t.sixgujarati = 0x0aec;
                    t.sixgurmukhi = 0x0a6c;
                    t.sixhackarabic = 0x0666;
                    t.sixhangzhou = 0x3026;
                    t.sixideographicparen = 0x3225;
                    t.sixinferior = 0x2086;
                    t.sixmonospace = 0xff16;
                    t.sixoldstyle = 0xf736;
                    t.sixparen = 0x2479;
                    t.sixperiod = 0x248d;
                    t.sixpersian = 0x06f6;
                    t.sixroman = 0x2175;
                    t.sixsuperior = 0x2076;
                    t.sixteencircle = 0x246f;
                    t.sixteencurrencydenominatorbengali = 0x09f9;
                    t.sixteenparen = 0x2483;
                    t.sixteenperiod = 0x2497;
                    t.sixthai = 0x0e56;
                    t.slash = 0x002f;
                    t.slashmonospace = 0xff0f;
                    t.slong = 0x017f;
                    t.slongdotaccent = 0x1e9b;
                    t.smileface = 0x263a;
                    t.smonospace = 0xff53;
                    t.sofpasuqhebrew = 0x05c3;
                    t.softhyphen = 0x00ad;
                    t.softsigncyrillic = 0x044c;
                    t.sohiragana = 0x305d;
                    t.sokatakana = 0x30bd;
                    t.sokatakanahalfwidth = 0xff7f;
                    t.soliduslongoverlaycmb = 0x0338;
                    t.solidusshortoverlaycmb = 0x0337;
                    t.sorusithai = 0x0e29;
                    t.sosalathai = 0x0e28;
                    t.sosothai = 0x0e0b;
                    t.sosuathai = 0x0e2a;
                    t.space = 0x0020;
                    t.spacehackarabic = 0x0020;
                    t.spade = 0x2660;
                    t.spadesuitblack = 0x2660;
                    t.spadesuitwhite = 0x2664;
                    t.sparen = 0x24ae;
                    t.squarebelowcmb = 0x033b;
                    t.squarecc = 0x33c4;
                    t.squarecm = 0x339d;
                    t.squarediagonalcrosshatchfill = 0x25a9;
                    t.squarehorizontalfill = 0x25a4;
                    t.squarekg = 0x338f;
                    t.squarekm = 0x339e;
                    t.squarekmcapital = 0x33ce;
                    t.squareln = 0x33d1;
                    t.squarelog = 0x33d2;
                    t.squaremg = 0x338e;
                    t.squaremil = 0x33d5;
                    t.squaremm = 0x339c;
                    t.squaremsquared = 0x33a1;
                    t.squareorthogonalcrosshatchfill = 0x25a6;
                    t.squareupperlefttolowerrightfill = 0x25a7;
                    t.squareupperrighttolowerleftfill = 0x25a8;
                    t.squareverticalfill = 0x25a5;
                    t.squarewhitewithsmallblack = 0x25a3;
                    t.srsquare = 0x33db;
                    t.ssabengali = 0x09b7;
                    t.ssadeva = 0x0937;
                    t.ssagujarati = 0x0ab7;
                    t.ssangcieuckorean = 0x3149;
                    t.ssanghieuhkorean = 0x3185;
                    t.ssangieungkorean = 0x3180;
                    t.ssangkiyeokkorean = 0x3132;
                    t.ssangnieunkorean = 0x3165;
                    t.ssangpieupkorean = 0x3143;
                    t.ssangsioskorean = 0x3146;
                    t.ssangtikeutkorean = 0x3138;
                    t.ssuperior = 0xf6f2;
                    t.sterling = 0x00a3;
                    t.sterlingmonospace = 0xffe1;
                    t.strokelongoverlaycmb = 0x0336;
                    t.strokeshortoverlaycmb = 0x0335;
                    t.subset = 0x2282;
                    t.subsetnotequal = 0x228a;
                    t.subsetorequal = 0x2286;
                    t.succeeds = 0x227b;
                    t.suchthat = 0x220b;
                    t.suhiragana = 0x3059;
                    t.sukatakana = 0x30b9;
                    t.sukatakanahalfwidth = 0xff7d;
                    t.sukunarabic = 0x0652;
                    t.summation = 0x2211;
                    t.sun = 0x263c;
                    t.superset = 0x2283;
                    t.supersetnotequal = 0x228b;
                    t.supersetorequal = 0x2287;
                    t.svsquare = 0x33dc;
                    t.syouwaerasquare = 0x337c;
                    t.t = 0x0074;
                    t.tabengali = 0x09a4;
                    t.tackdown = 0x22a4;
                    t.tackleft = 0x22a3;
                    t.tadeva = 0x0924;
                    t.tagujarati = 0x0aa4;
                    t.tagurmukhi = 0x0a24;
                    t.taharabic = 0x0637;
                    t.tahfinalarabic = 0xfec2;
                    t.tahinitialarabic = 0xfec3;
                    t.tahiragana = 0x305f;
                    t.tahmedialarabic = 0xfec4;
                    t.taisyouerasquare = 0x337d;
                    t.takatakana = 0x30bf;
                    t.takatakanahalfwidth = 0xff80;
                    t.tatweelarabic = 0x0640;
                    t.tau = 0x03c4;
                    t.tav = 0x05ea;
                    t.tavdages = 0xfb4a;
                    t.tavdagesh = 0xfb4a;
                    t.tavdageshhebrew = 0xfb4a;
                    t.tavhebrew = 0x05ea;
                    t.tbar = 0x0167;
                    t.tbopomofo = 0x310a;
                    t.tcaron = 0x0165;
                    t.tccurl = 0x02a8;
                    t.tcedilla = 0x0163;
                    t.tcheharabic = 0x0686;
                    t.tchehfinalarabic = 0xfb7b;
                    t.tchehinitialarabic = 0xfb7c;
                    t.tchehmedialarabic = 0xfb7d;
                    t.tcircle = 0x24e3;
                    t.tcircumflexbelow = 0x1e71;
                    t.tcommaaccent = 0x0163;
                    t.tdieresis = 0x1e97;
                    t.tdotaccent = 0x1e6b;
                    t.tdotbelow = 0x1e6d;
                    t.tecyrillic = 0x0442;
                    t.tedescendercyrillic = 0x04ad;
                    t.teharabic = 0x062a;
                    t.tehfinalarabic = 0xfe96;
                    t.tehhahinitialarabic = 0xfca2;
                    t.tehhahisolatedarabic = 0xfc0c;
                    t.tehinitialarabic = 0xfe97;
                    t.tehiragana = 0x3066;
                    t.tehjeeminitialarabic = 0xfca1;
                    t.tehjeemisolatedarabic = 0xfc0b;
                    t.tehmarbutaarabic = 0x0629;
                    t.tehmarbutafinalarabic = 0xfe94;
                    t.tehmedialarabic = 0xfe98;
                    t.tehmeeminitialarabic = 0xfca4;
                    t.tehmeemisolatedarabic = 0xfc0e;
                    t.tehnoonfinalarabic = 0xfc73;
                    t.tekatakana = 0x30c6;
                    t.tekatakanahalfwidth = 0xff83;
                    t.telephone = 0x2121;
                    t.telephoneblack = 0x260e;
                    t.telishagedolahebrew = 0x05a0;
                    t.telishaqetanahebrew = 0x05a9;
                    t.tencircle = 0x2469;
                    t.tenideographicparen = 0x3229;
                    t.tenparen = 0x247d;
                    t.tenperiod = 0x2491;
                    t.tenroman = 0x2179;
                    t.tesh = 0x02a7;
                    t.tet = 0x05d8;
                    t.tetdagesh = 0xfb38;
                    t.tetdageshhebrew = 0xfb38;
                    t.tethebrew = 0x05d8;
                    t.tetsecyrillic = 0x04b5;
                    t.tevirhebrew = 0x059b;
                    t.tevirlefthebrew = 0x059b;
                    t.thabengali = 0x09a5;
                    t.thadeva = 0x0925;
                    t.thagujarati = 0x0aa5;
                    t.thagurmukhi = 0x0a25;
                    t.thalarabic = 0x0630;
                    t.thalfinalarabic = 0xfeac;
                    t.thanthakhatlowleftthai = 0xf898;
                    t.thanthakhatlowrightthai = 0xf897;
                    t.thanthakhatthai = 0x0e4c;
                    t.thanthakhatupperleftthai = 0xf896;
                    t.theharabic = 0x062b;
                    t.thehfinalarabic = 0xfe9a;
                    t.thehinitialarabic = 0xfe9b;
                    t.thehmedialarabic = 0xfe9c;
                    t.thereexists = 0x2203;
                    t.therefore = 0x2234;
                    t.theta = 0x03b8;
                    t.theta1 = 0x03d1;
                    t.thetasymbolgreek = 0x03d1;
                    t.thieuthacirclekorean = 0x3279;
                    t.thieuthaparenkorean = 0x3219;
                    t.thieuthcirclekorean = 0x326b;
                    t.thieuthkorean = 0x314c;
                    t.thieuthparenkorean = 0x320b;
                    t.thirteencircle = 0x246c;
                    t.thirteenparen = 0x2480;
                    t.thirteenperiod = 0x2494;
                    t.thonangmonthothai = 0x0e11;
                    t.thook = 0x01ad;
                    t.thophuthaothai = 0x0e12;
                    t.thorn = 0x00fe;
                    t.thothahanthai = 0x0e17;
                    t.thothanthai = 0x0e10;
                    t.thothongthai = 0x0e18;
                    t.thothungthai = 0x0e16;
                    t.thousandcyrillic = 0x0482;
                    t.thousandsseparatorarabic = 0x066c;
                    t.thousandsseparatorpersian = 0x066c;
                    t.three = 0x0033;
                    t.threearabic = 0x0663;
                    t.threebengali = 0x09e9;
                    t.threecircle = 0x2462;
                    t.threecircleinversesansserif = 0x278c;
                    t.threedeva = 0x0969;
                    t.threeeighths = 0x215c;
                    t.threegujarati = 0x0ae9;
                    t.threegurmukhi = 0x0a69;
                    t.threehackarabic = 0x0663;
                    t.threehangzhou = 0x3023;
                    t.threeideographicparen = 0x3222;
                    t.threeinferior = 0x2083;
                    t.threemonospace = 0xff13;
                    t.threenumeratorbengali = 0x09f6;
                    t.threeoldstyle = 0xf733;
                    t.threeparen = 0x2476;
                    t.threeperiod = 0x248a;
                    t.threepersian = 0x06f3;
                    t.threequarters = 0x00be;
                    t.threequartersemdash = 0xf6de;
                    t.threeroman = 0x2172;
                    t.threesuperior = 0x00b3;
                    t.threethai = 0x0e53;
                    t.thzsquare = 0x3394;
                    t.tihiragana = 0x3061;
                    t.tikatakana = 0x30c1;
                    t.tikatakanahalfwidth = 0xff81;
                    t.tikeutacirclekorean = 0x3270;
                    t.tikeutaparenkorean = 0x3210;
                    t.tikeutcirclekorean = 0x3262;
                    t.tikeutkorean = 0x3137;
                    t.tikeutparenkorean = 0x3202;
                    t.tilde = 0x02dc;
                    t.tildebelowcmb = 0x0330;
                    t.tildecmb = 0x0303;
                    t.tildecomb = 0x0303;
                    t.tildedoublecmb = 0x0360;
                    t.tildeoperator = 0x223c;
                    t.tildeoverlaycmb = 0x0334;
                    t.tildeverticalcmb = 0x033e;
                    t.timescircle = 0x2297;
                    t.tipehahebrew = 0x0596;
                    t.tipehalefthebrew = 0x0596;
                    t.tippigurmukhi = 0x0a70;
                    t.titlocyrilliccmb = 0x0483;
                    t.tiwnarmenian = 0x057f;
                    t.tlinebelow = 0x1e6f;
                    t.tmonospace = 0xff54;
                    t.toarmenian = 0x0569;
                    t.tohiragana = 0x3068;
                    t.tokatakana = 0x30c8;
                    t.tokatakanahalfwidth = 0xff84;
                    t.tonebarextrahighmod = 0x02e5;
                    t.tonebarextralowmod = 0x02e9;
                    t.tonebarhighmod = 0x02e6;
                    t.tonebarlowmod = 0x02e8;
                    t.tonebarmidmod = 0x02e7;
                    t.tonefive = 0x01bd;
                    t.tonesix = 0x0185;
                    t.tonetwo = 0x01a8;
                    t.tonos = 0x0384;
                    t.tonsquare = 0x3327;
                    t.topatakthai = 0x0e0f;
                    t.tortoiseshellbracketleft = 0x3014;
                    t.tortoiseshellbracketleftsmall = 0xfe5d;
                    t.tortoiseshellbracketleftvertical = 0xfe39;
                    t.tortoiseshellbracketright = 0x3015;
                    t.tortoiseshellbracketrightsmall = 0xfe5e;
                    t.tortoiseshellbracketrightvertical = 0xfe3a;
                    t.totaothai = 0x0e15;
                    t.tpalatalhook = 0x01ab;
                    t.tparen = 0x24af;
                    t.trademark = 0x2122;
                    t.trademarksans = 0xf8ea;
                    t.trademarkserif = 0xf6db;
                    t.tretroflexhook = 0x0288;
                    t.triagdn = 0x25bc;
                    t.triaglf = 0x25c4;
                    t.triagrt = 0x25ba;
                    t.triagup = 0x25b2;
                    t.ts = 0x02a6;
                    t.tsadi = 0x05e6;
                    t.tsadidagesh = 0xfb46;
                    t.tsadidageshhebrew = 0xfb46;
                    t.tsadihebrew = 0x05e6;
                    t.tsecyrillic = 0x0446;
                    t.tsere = 0x05b5;
                    t.tsere12 = 0x05b5;
                    t.tsere1e = 0x05b5;
                    t.tsere2b = 0x05b5;
                    t.tserehebrew = 0x05b5;
                    t.tserenarrowhebrew = 0x05b5;
                    t.tserequarterhebrew = 0x05b5;
                    t.tserewidehebrew = 0x05b5;
                    t.tshecyrillic = 0x045b;
                    t.tsuperior = 0xf6f3;
                    t.ttabengali = 0x099f;
                    t.ttadeva = 0x091f;
                    t.ttagujarati = 0x0a9f;
                    t.ttagurmukhi = 0x0a1f;
                    t.tteharabic = 0x0679;
                    t.ttehfinalarabic = 0xfb67;
                    t.ttehinitialarabic = 0xfb68;
                    t.ttehmedialarabic = 0xfb69;
                    t.tthabengali = 0x09a0;
                    t.tthadeva = 0x0920;
                    t.tthagujarati = 0x0aa0;
                    t.tthagurmukhi = 0x0a20;
                    t.tturned = 0x0287;
                    t.tuhiragana = 0x3064;
                    t.tukatakana = 0x30c4;
                    t.tukatakanahalfwidth = 0xff82;
                    t.tusmallhiragana = 0x3063;
                    t.tusmallkatakana = 0x30c3;
                    t.tusmallkatakanahalfwidth = 0xff6f;
                    t.twelvecircle = 0x246b;
                    t.twelveparen = 0x247f;
                    t.twelveperiod = 0x2493;
                    t.twelveroman = 0x217b;
                    t.twentycircle = 0x2473;
                    t.twentyhangzhou = 0x5344;
                    t.twentyparen = 0x2487;
                    t.twentyperiod = 0x249b;
                    t.two = 0x0032;
                    t.twoarabic = 0x0662;
                    t.twobengali = 0x09e8;
                    t.twocircle = 0x2461;
                    t.twocircleinversesansserif = 0x278b;
                    t.twodeva = 0x0968;
                    t.twodotenleader = 0x2025;
                    t.twodotleader = 0x2025;
                    t.twodotleadervertical = 0xfe30;
                    t.twogujarati = 0x0ae8;
                    t.twogurmukhi = 0x0a68;
                    t.twohackarabic = 0x0662;
                    t.twohangzhou = 0x3022;
                    t.twoideographicparen = 0x3221;
                    t.twoinferior = 0x2082;
                    t.twomonospace = 0xff12;
                    t.twonumeratorbengali = 0x09f5;
                    t.twooldstyle = 0xf732;
                    t.twoparen = 0x2475;
                    t.twoperiod = 0x2489;
                    t.twopersian = 0x06f2;
                    t.tworoman = 0x2171;
                    t.twostroke = 0x01bb;
                    t.twosuperior = 0x00b2;
                    t.twothai = 0x0e52;
                    t.twothirds = 0x2154;
                    t.u = 0x0075;
                    t.uacute = 0x00fa;
                    t.ubar = 0x0289;
                    t.ubengali = 0x0989;
                    t.ubopomofo = 0x3128;
                    t.ubreve = 0x016d;
                    t.ucaron = 0x01d4;
                    t.ucircle = 0x24e4;
                    t.ucircumflex = 0x00fb;
                    t.ucircumflexbelow = 0x1e77;
                    t.ucyrillic = 0x0443;
                    t.udattadeva = 0x0951;
                    t.udblacute = 0x0171;
                    t.udblgrave = 0x0215;
                    t.udeva = 0x0909;
                    t.udieresis = 0x00fc;
                    t.udieresisacute = 0x01d8;
                    t.udieresisbelow = 0x1e73;
                    t.udieresiscaron = 0x01da;
                    t.udieresiscyrillic = 0x04f1;
                    t.udieresisgrave = 0x01dc;
                    t.udieresismacron = 0x01d6;
                    t.udotbelow = 0x1ee5;
                    t.ugrave = 0x00f9;
                    t.ugujarati = 0x0a89;
                    t.ugurmukhi = 0x0a09;
                    t.uhiragana = 0x3046;
                    t.uhookabove = 0x1ee7;
                    t.uhorn = 0x01b0;
                    t.uhornacute = 0x1ee9;
                    t.uhorndotbelow = 0x1ef1;
                    t.uhorngrave = 0x1eeb;
                    t.uhornhookabove = 0x1eed;
                    t.uhorntilde = 0x1eef;
                    t.uhungarumlaut = 0x0171;
                    t.uhungarumlautcyrillic = 0x04f3;
                    t.uinvertedbreve = 0x0217;
                    t.ukatakana = 0x30a6;
                    t.ukatakanahalfwidth = 0xff73;
                    t.ukcyrillic = 0x0479;
                    t.ukorean = 0x315c;
                    t.umacron = 0x016b;
                    t.umacroncyrillic = 0x04ef;
                    t.umacrondieresis = 0x1e7b;
                    t.umatragurmukhi = 0x0a41;
                    t.umonospace = 0xff55;
                    t.underscore = 0x005f;
                    t.underscoredbl = 0x2017;
                    t.underscoremonospace = 0xff3f;
                    t.underscorevertical = 0xfe33;
                    t.underscorewavy = 0xfe4f;
                    t.union = 0x222a;
                    t.universal = 0x2200;
                    t.uogonek = 0x0173;
                    t.uparen = 0x24b0;
                    t.upblock = 0x2580;
                    t.upperdothebrew = 0x05c4;
                    t.upsilon = 0x03c5;
                    t.upsilondieresis = 0x03cb;
                    t.upsilondieresistonos = 0x03b0;
                    t.upsilonlatin = 0x028a;
                    t.upsilontonos = 0x03cd;
                    t.uptackbelowcmb = 0x031d;
                    t.uptackmod = 0x02d4;
                    t.uragurmukhi = 0x0a73;
                    t.uring = 0x016f;
                    t.ushortcyrillic = 0x045e;
                    t.usmallhiragana = 0x3045;
                    t.usmallkatakana = 0x30a5;
                    t.usmallkatakanahalfwidth = 0xff69;
                    t.ustraightcyrillic = 0x04af;
                    t.ustraightstrokecyrillic = 0x04b1;
                    t.utilde = 0x0169;
                    t.utildeacute = 0x1e79;
                    t.utildebelow = 0x1e75;
                    t.uubengali = 0x098a;
                    t.uudeva = 0x090a;
                    t.uugujarati = 0x0a8a;
                    t.uugurmukhi = 0x0a0a;
                    t.uumatragurmukhi = 0x0a42;
                    t.uuvowelsignbengali = 0x09c2;
                    t.uuvowelsigndeva = 0x0942;
                    t.uuvowelsigngujarati = 0x0ac2;
                    t.uvowelsignbengali = 0x09c1;
                    t.uvowelsigndeva = 0x0941;
                    t.uvowelsigngujarati = 0x0ac1;
                    t.v = 0x0076;
                    t.vadeva = 0x0935;
                    t.vagujarati = 0x0ab5;
                    t.vagurmukhi = 0x0a35;
                    t.vakatakana = 0x30f7;
                    t.vav = 0x05d5;
                    t.vavdagesh = 0xfb35;
                    t.vavdagesh65 = 0xfb35;
                    t.vavdageshhebrew = 0xfb35;
                    t.vavhebrew = 0x05d5;
                    t.vavholam = 0xfb4b;
                    t.vavholamhebrew = 0xfb4b;
                    t.vavvavhebrew = 0x05f0;
                    t.vavyodhebrew = 0x05f1;
                    t.vcircle = 0x24e5;
                    t.vdotbelow = 0x1e7f;
                    t.vecyrillic = 0x0432;
                    t.veharabic = 0x06a4;
                    t.vehfinalarabic = 0xfb6b;
                    t.vehinitialarabic = 0xfb6c;
                    t.vehmedialarabic = 0xfb6d;
                    t.vekatakana = 0x30f9;
                    t.venus = 0x2640;
                    t.verticalbar = 0x007c;
                    t.verticallineabovecmb = 0x030d;
                    t.verticallinebelowcmb = 0x0329;
                    t.verticallinelowmod = 0x02cc;
                    t.verticallinemod = 0x02c8;
                    t.vewarmenian = 0x057e;
                    t.vhook = 0x028b;
                    t.vikatakana = 0x30f8;
                    t.viramabengali = 0x09cd;
                    t.viramadeva = 0x094d;
                    t.viramagujarati = 0x0acd;
                    t.visargabengali = 0x0983;
                    t.visargadeva = 0x0903;
                    t.visargagujarati = 0x0a83;
                    t.vmonospace = 0xff56;
                    t.voarmenian = 0x0578;
                    t.voicediterationhiragana = 0x309e;
                    t.voicediterationkatakana = 0x30fe;
                    t.voicedmarkkana = 0x309b;
                    t.voicedmarkkanahalfwidth = 0xff9e;
                    t.vokatakana = 0x30fa;
                    t.vparen = 0x24b1;
                    t.vtilde = 0x1e7d;
                    t.vturned = 0x028c;
                    t.vuhiragana = 0x3094;
                    t.vukatakana = 0x30f4;
                    t.w = 0x0077;
                    t.wacute = 0x1e83;
                    t.waekorean = 0x3159;
                    t.wahiragana = 0x308f;
                    t.wakatakana = 0x30ef;
                    t.wakatakanahalfwidth = 0xff9c;
                    t.wakorean = 0x3158;
                    t.wasmallhiragana = 0x308e;
                    t.wasmallkatakana = 0x30ee;
                    t.wattosquare = 0x3357;
                    t.wavedash = 0x301c;
                    t.wavyunderscorevertical = 0xfe34;
                    t.wawarabic = 0x0648;
                    t.wawfinalarabic = 0xfeee;
                    t.wawhamzaabovearabic = 0x0624;
                    t.wawhamzaabovefinalarabic = 0xfe86;
                    t.wbsquare = 0x33dd;
                    t.wcircle = 0x24e6;
                    t.wcircumflex = 0x0175;
                    t.wdieresis = 0x1e85;
                    t.wdotaccent = 0x1e87;
                    t.wdotbelow = 0x1e89;
                    t.wehiragana = 0x3091;
                    t.weierstrass = 0x2118;
                    t.wekatakana = 0x30f1;
                    t.wekorean = 0x315e;
                    t.weokorean = 0x315d;
                    t.wgrave = 0x1e81;
                    t.whitebullet = 0x25e6;
                    t.whitecircle = 0x25cb;
                    t.whitecircleinverse = 0x25d9;
                    t.whitecornerbracketleft = 0x300e;
                    t.whitecornerbracketleftvertical = 0xfe43;
                    t.whitecornerbracketright = 0x300f;
                    t.whitecornerbracketrightvertical = 0xfe44;
                    t.whitediamond = 0x25c7;
                    t.whitediamondcontainingblacksmalldiamond = 0x25c8;
                    t.whitedownpointingsmalltriangle = 0x25bf;
                    t.whitedownpointingtriangle = 0x25bd;
                    t.whiteleftpointingsmalltriangle = 0x25c3;
                    t.whiteleftpointingtriangle = 0x25c1;
                    t.whitelenticularbracketleft = 0x3016;
                    t.whitelenticularbracketright = 0x3017;
                    t.whiterightpointingsmalltriangle = 0x25b9;
                    t.whiterightpointingtriangle = 0x25b7;
                    t.whitesmallsquare = 0x25ab;
                    t.whitesmilingface = 0x263a;
                    t.whitesquare = 0x25a1;
                    t.whitestar = 0x2606;
                    t.whitetelephone = 0x260f;
                    t.whitetortoiseshellbracketleft = 0x3018;
                    t.whitetortoiseshellbracketright = 0x3019;
                    t.whiteuppointingsmalltriangle = 0x25b5;
                    t.whiteuppointingtriangle = 0x25b3;
                    t.wihiragana = 0x3090;
                    t.wikatakana = 0x30f0;
                    t.wikorean = 0x315f;
                    t.wmonospace = 0xff57;
                    t.wohiragana = 0x3092;
                    t.wokatakana = 0x30f2;
                    t.wokatakanahalfwidth = 0xff66;
                    t.won = 0x20a9;
                    t.wonmonospace = 0xffe6;
                    t.wowaenthai = 0x0e27;
                    t.wparen = 0x24b2;
                    t.wring = 0x1e98;
                    t.wsuperior = 0x02b7;
                    t.wturned = 0x028d;
                    t.wynn = 0x01bf;
                    t.x = 0x0078;
                    t.xabovecmb = 0x033d;
                    t.xbopomofo = 0x3112;
                    t.xcircle = 0x24e7;
                    t.xdieresis = 0x1e8d;
                    t.xdotaccent = 0x1e8b;
                    t.xeharmenian = 0x056d;
                    t.xi = 0x03be;
                    t.xmonospace = 0xff58;
                    t.xparen = 0x24b3;
                    t.xsuperior = 0x02e3;
                    t.y = 0x0079;
                    t.yaadosquare = 0x334e;
                    t.yabengali = 0x09af;
                    t.yacute = 0x00fd;
                    t.yadeva = 0x092f;
                    t.yaekorean = 0x3152;
                    t.yagujarati = 0x0aaf;
                    t.yagurmukhi = 0x0a2f;
                    t.yahiragana = 0x3084;
                    t.yakatakana = 0x30e4;
                    t.yakatakanahalfwidth = 0xff94;
                    t.yakorean = 0x3151;
                    t.yamakkanthai = 0x0e4e;
                    t.yasmallhiragana = 0x3083;
                    t.yasmallkatakana = 0x30e3;
                    t.yasmallkatakanahalfwidth = 0xff6c;
                    t.yatcyrillic = 0x0463;
                    t.ycircle = 0x24e8;
                    t.ycircumflex = 0x0177;
                    t.ydieresis = 0x00ff;
                    t.ydotaccent = 0x1e8f;
                    t.ydotbelow = 0x1ef5;
                    t.yeharabic = 0x064a;
                    t.yehbarreearabic = 0x06d2;
                    t.yehbarreefinalarabic = 0xfbaf;
                    t.yehfinalarabic = 0xfef2;
                    t.yehhamzaabovearabic = 0x0626;
                    t.yehhamzaabovefinalarabic = 0xfe8a;
                    t.yehhamzaaboveinitialarabic = 0xfe8b;
                    t.yehhamzaabovemedialarabic = 0xfe8c;
                    t.yehinitialarabic = 0xfef3;
                    t.yehmedialarabic = 0xfef4;
                    t.yehmeeminitialarabic = 0xfcdd;
                    t.yehmeemisolatedarabic = 0xfc58;
                    t.yehnoonfinalarabic = 0xfc94;
                    t.yehthreedotsbelowarabic = 0x06d1;
                    t.yekorean = 0x3156;
                    t.yen = 0x00a5;
                    t.yenmonospace = 0xffe5;
                    t.yeokorean = 0x3155;
                    t.yeorinhieuhkorean = 0x3186;
                    t.yerahbenyomohebrew = 0x05aa;
                    t.yerahbenyomolefthebrew = 0x05aa;
                    t.yericyrillic = 0x044b;
                    t.yerudieresiscyrillic = 0x04f9;
                    t.yesieungkorean = 0x3181;
                    t.yesieungpansioskorean = 0x3183;
                    t.yesieungsioskorean = 0x3182;
                    t.yetivhebrew = 0x059a;
                    t.ygrave = 0x1ef3;
                    t.yhook = 0x01b4;
                    t.yhookabove = 0x1ef7;
                    t.yiarmenian = 0x0575;
                    t.yicyrillic = 0x0457;
                    t.yikorean = 0x3162;
                    t.yinyang = 0x262f;
                    t.yiwnarmenian = 0x0582;
                    t.ymonospace = 0xff59;
                    t.yod = 0x05d9;
                    t.yoddagesh = 0xfb39;
                    t.yoddageshhebrew = 0xfb39;
                    t.yodhebrew = 0x05d9;
                    t.yodyodhebrew = 0x05f2;
                    t.yodyodpatahhebrew = 0xfb1f;
                    t.yohiragana = 0x3088;
                    t.yoikorean = 0x3189;
                    t.yokatakana = 0x30e8;
                    t.yokatakanahalfwidth = 0xff96;
                    t.yokorean = 0x315b;
                    t.yosmallhiragana = 0x3087;
                    t.yosmallkatakana = 0x30e7;
                    t.yosmallkatakanahalfwidth = 0xff6e;
                    t.yotgreek = 0x03f3;
                    t.yoyaekorean = 0x3188;
                    t.yoyakorean = 0x3187;
                    t.yoyakthai = 0x0e22;
                    t.yoyingthai = 0x0e0d;
                    t.yparen = 0x24b4;
                    t.ypogegrammeni = 0x037a;
                    t.ypogegrammenigreekcmb = 0x0345;
                    t.yr = 0x01a6;
                    t.yring = 0x1e99;
                    t.ysuperior = 0x02b8;
                    t.ytilde = 0x1ef9;
                    t.yturned = 0x028e;
                    t.yuhiragana = 0x3086;
                    t.yuikorean = 0x318c;
                    t.yukatakana = 0x30e6;
                    t.yukatakanahalfwidth = 0xff95;
                    t.yukorean = 0x3160;
                    t.yusbigcyrillic = 0x046b;
                    t.yusbigiotifiedcyrillic = 0x046d;
                    t.yuslittlecyrillic = 0x0467;
                    t.yuslittleiotifiedcyrillic = 0x0469;
                    t.yusmallhiragana = 0x3085;
                    t.yusmallkatakana = 0x30e5;
                    t.yusmallkatakanahalfwidth = 0xff6d;
                    t.yuyekorean = 0x318b;
                    t.yuyeokorean = 0x318a;
                    t.yyabengali = 0x09df;
                    t.yyadeva = 0x095f;
                    t.z = 0x007a;
                    t.zaarmenian = 0x0566;
                    t.zacute = 0x017a;
                    t.zadeva = 0x095b;
                    t.zagurmukhi = 0x0a5b;
                    t.zaharabic = 0x0638;
                    t.zahfinalarabic = 0xfec6;
                    t.zahinitialarabic = 0xfec7;
                    t.zahiragana = 0x3056;
                    t.zahmedialarabic = 0xfec8;
                    t.zainarabic = 0x0632;
                    t.zainfinalarabic = 0xfeb0;
                    t.zakatakana = 0x30b6;
                    t.zaqefgadolhebrew = 0x0595;
                    t.zaqefqatanhebrew = 0x0594;
                    t.zarqahebrew = 0x0598;
                    t.zayin = 0x05d6;
                    t.zayindagesh = 0xfb36;
                    t.zayindageshhebrew = 0xfb36;
                    t.zayinhebrew = 0x05d6;
                    t.zbopomofo = 0x3117;
                    t.zcaron = 0x017e;
                    t.zcircle = 0x24e9;
                    t.zcircumflex = 0x1e91;
                    t.zcurl = 0x0291;
                    t.zdot = 0x017c;
                    t.zdotaccent = 0x017c;
                    t.zdotbelow = 0x1e93;
                    t.zecyrillic = 0x0437;
                    t.zedescendercyrillic = 0x0499;
                    t.zedieresiscyrillic = 0x04df;
                    t.zehiragana = 0x305c;
                    t.zekatakana = 0x30bc;
                    t.zero = 0x0030;
                    t.zeroarabic = 0x0660;
                    t.zerobengali = 0x09e6;
                    t.zerodeva = 0x0966;
                    t.zerogujarati = 0x0ae6;
                    t.zerogurmukhi = 0x0a66;
                    t.zerohackarabic = 0x0660;
                    t.zeroinferior = 0x2080;
                    t.zeromonospace = 0xff10;
                    t.zerooldstyle = 0xf730;
                    t.zeropersian = 0x06f0;
                    t.zerosuperior = 0x2070;
                    t.zerothai = 0x0e50;
                    t.zerowidthjoiner = 0xfeff;
                    t.zerowidthnonjoiner = 0x200c;
                    t.zerowidthspace = 0x200b;
                    t.zeta = 0x03b6;
                    t.zhbopomofo = 0x3113;
                    t.zhearmenian = 0x056a;
                    t.zhebrevecyrillic = 0x04c2;
                    t.zhecyrillic = 0x0436;
                    t.zhedescendercyrillic = 0x0497;
                    t.zhedieresiscyrillic = 0x04dd;
                    t.zihiragana = 0x3058;
                    t.zikatakana = 0x30b8;
                    t.zinorhebrew = 0x05ae;
                    t.zlinebelow = 0x1e95;
                    t.zmonospace = 0xff5a;
                    t.zohiragana = 0x305e;
                    t.zokatakana = 0x30be;
                    t.zparen = 0x24b5;
                    t.zretroflexhook = 0x0290;
                    t.zstroke = 0x01b6;
                    t.zuhiragana = 0x305a;
                    t.zukatakana = 0x30ba;
                    t[".notdef"] = 0x0000;
                    t.angbracketleftbig = 0x2329;
                    t.angbracketleftBig = 0x2329;
                    t.angbracketleftbigg = 0x2329;
                    t.angbracketleftBigg = 0x2329;
                    t.angbracketrightBig = 0x232a;
                    t.angbracketrightbig = 0x232a;
                    t.angbracketrightBigg = 0x232a;
                    t.angbracketrightbigg = 0x232a;
                    t.arrowhookleft = 0x21aa;
                    t.arrowhookright = 0x21a9;
                    t.arrowlefttophalf = 0x21bc;
                    t.arrowleftbothalf = 0x21bd;
                    t.arrownortheast = 0x2197;
                    t.arrownorthwest = 0x2196;
                    t.arrowrighttophalf = 0x21c0;
                    t.arrowrightbothalf = 0x21c1;
                    t.arrowsoutheast = 0x2198;
                    t.arrowsouthwest = 0x2199;
                    t.backslashbig = 0x2216;
                    t.backslashBig = 0x2216;
                    t.backslashBigg = 0x2216;
                    t.backslashbigg = 0x2216;
                    t.bardbl = 0x2016;
                    t.bracehtipdownleft = 0xfe37;
                    t.bracehtipdownright = 0xfe37;
                    t.bracehtipupleft = 0xfe38;
                    t.bracehtipupright = 0xfe38;
                    t.braceleftBig = 0x007b;
                    t.braceleftbig = 0x007b;
                    t.braceleftbigg = 0x007b;
                    t.braceleftBigg = 0x007b;
                    t.bracerightBig = 0x007d;
                    t.bracerightbig = 0x007d;
                    t.bracerightbigg = 0x007d;
                    t.bracerightBigg = 0x007d;
                    t.bracketleftbig = 0x005b;
                    t.bracketleftBig = 0x005b;
                    t.bracketleftbigg = 0x005b;
                    t.bracketleftBigg = 0x005b;
                    t.bracketrightBig = 0x005d;
                    t.bracketrightbig = 0x005d;
                    t.bracketrightbigg = 0x005d;
                    t.bracketrightBigg = 0x005d;
                    t.ceilingleftbig = 0x2308;
                    t.ceilingleftBig = 0x2308;
                    t.ceilingleftBigg = 0x2308;
                    t.ceilingleftbigg = 0x2308;
                    t.ceilingrightbig = 0x2309;
                    t.ceilingrightBig = 0x2309;
                    t.ceilingrightbigg = 0x2309;
                    t.ceilingrightBigg = 0x2309;
                    t.circledotdisplay = 0x2299;
                    t.circledottext = 0x2299;
                    t.circlemultiplydisplay = 0x2297;
                    t.circlemultiplytext = 0x2297;
                    t.circleplusdisplay = 0x2295;
                    t.circleplustext = 0x2295;
                    t.contintegraldisplay = 0x222e;
                    t.contintegraltext = 0x222e;
                    t.coproductdisplay = 0x2210;
                    t.coproducttext = 0x2210;
                    t.floorleftBig = 0x230a;
                    t.floorleftbig = 0x230a;
                    t.floorleftbigg = 0x230a;
                    t.floorleftBigg = 0x230a;
                    t.floorrightbig = 0x230b;
                    t.floorrightBig = 0x230b;
                    t.floorrightBigg = 0x230b;
                    t.floorrightbigg = 0x230b;
                    t.hatwide = 0x0302;
                    t.hatwider = 0x0302;
                    t.hatwidest = 0x0302;
                    t.intercal = 0x1d40;
                    t.integraldisplay = 0x222b;
                    t.integraltext = 0x222b;
                    t.intersectiondisplay = 0x22c2;
                    t.intersectiontext = 0x22c2;
                    t.logicalanddisplay = 0x2227;
                    t.logicalandtext = 0x2227;
                    t.logicalordisplay = 0x2228;
                    t.logicalortext = 0x2228;
                    t.parenleftBig = 0x0028;
                    t.parenleftbig = 0x0028;
                    t.parenleftBigg = 0x0028;
                    t.parenleftbigg = 0x0028;
                    t.parenrightBig = 0x0029;
                    t.parenrightbig = 0x0029;
                    t.parenrightBigg = 0x0029;
                    t.parenrightbigg = 0x0029;
                    t.prime = 0x2032;
                    t.productdisplay = 0x220f;
                    t.producttext = 0x220f;
                    t.radicalbig = 0x221a;
                    t.radicalBig = 0x221a;
                    t.radicalBigg = 0x221a;
                    t.radicalbigg = 0x221a;
                    t.radicalbt = 0x221a;
                    t.radicaltp = 0x221a;
                    t.radicalvertex = 0x221a;
                    t.slashbig = 0x002f;
                    t.slashBig = 0x002f;
                    t.slashBigg = 0x002f;
                    t.slashbigg = 0x002f;
                    t.summationdisplay = 0x2211;
                    t.summationtext = 0x2211;
                    t.tildewide = 0x02dc;
                    t.tildewider = 0x02dc;
                    t.tildewidest = 0x02dc;
                    t.uniondisplay = 0x22c3;
                    t.unionmultidisplay = 0x228e;
                    t.unionmultitext = 0x228e;
                    t.unionsqdisplay = 0x2294;
                    t.unionsqtext = 0x2294;
                    t.uniontext = 0x22c3;
                    t.vextenddouble = 0x2225;
                    t.vextendsingle = 0x2223;
                });
                exports.getGlyphsUnicode = getGlyphsUnicode;
                const getDingbatsGlyphsUnicode = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.space = 0x0020;
                    t.a1 = 0x2701;
                    t.a2 = 0x2702;
                    t.a202 = 0x2703;
                    t.a3 = 0x2704;
                    t.a4 = 0x260e;
                    t.a5 = 0x2706;
                    t.a119 = 0x2707;
                    t.a118 = 0x2708;
                    t.a117 = 0x2709;
                    t.a11 = 0x261b;
                    t.a12 = 0x261e;
                    t.a13 = 0x270c;
                    t.a14 = 0x270d;
                    t.a15 = 0x270e;
                    t.a16 = 0x270f;
                    t.a105 = 0x2710;
                    t.a17 = 0x2711;
                    t.a18 = 0x2712;
                    t.a19 = 0x2713;
                    t.a20 = 0x2714;
                    t.a21 = 0x2715;
                    t.a22 = 0x2716;
                    t.a23 = 0x2717;
                    t.a24 = 0x2718;
                    t.a25 = 0x2719;
                    t.a26 = 0x271a;
                    t.a27 = 0x271b;
                    t.a28 = 0x271c;
                    t.a6 = 0x271d;
                    t.a7 = 0x271e;
                    t.a8 = 0x271f;
                    t.a9 = 0x2720;
                    t.a10 = 0x2721;
                    t.a29 = 0x2722;
                    t.a30 = 0x2723;
                    t.a31 = 0x2724;
                    t.a32 = 0x2725;
                    t.a33 = 0x2726;
                    t.a34 = 0x2727;
                    t.a35 = 0x2605;
                    t.a36 = 0x2729;
                    t.a37 = 0x272a;
                    t.a38 = 0x272b;
                    t.a39 = 0x272c;
                    t.a40 = 0x272d;
                    t.a41 = 0x272e;
                    t.a42 = 0x272f;
                    t.a43 = 0x2730;
                    t.a44 = 0x2731;
                    t.a45 = 0x2732;
                    t.a46 = 0x2733;
                    t.a47 = 0x2734;
                    t.a48 = 0x2735;
                    t.a49 = 0x2736;
                    t.a50 = 0x2737;
                    t.a51 = 0x2738;
                    t.a52 = 0x2739;
                    t.a53 = 0x273a;
                    t.a54 = 0x273b;
                    t.a55 = 0x273c;
                    t.a56 = 0x273d;
                    t.a57 = 0x273e;
                    t.a58 = 0x273f;
                    t.a59 = 0x2740;
                    t.a60 = 0x2741;
                    t.a61 = 0x2742;
                    t.a62 = 0x2743;
                    t.a63 = 0x2744;
                    t.a64 = 0x2745;
                    t.a65 = 0x2746;
                    t.a66 = 0x2747;
                    t.a67 = 0x2748;
                    t.a68 = 0x2749;
                    t.a69 = 0x274a;
                    t.a70 = 0x274b;
                    t.a71 = 0x25cf;
                    t.a72 = 0x274d;
                    t.a73 = 0x25a0;
                    t.a74 = 0x274f;
                    t.a203 = 0x2750;
                    t.a75 = 0x2751;
                    t.a204 = 0x2752;
                    t.a76 = 0x25b2;
                    t.a77 = 0x25bc;
                    t.a78 = 0x25c6;
                    t.a79 = 0x2756;
                    t.a81 = 0x25d7;
                    t.a82 = 0x2758;
                    t.a83 = 0x2759;
                    t.a84 = 0x275a;
                    t.a97 = 0x275b;
                    t.a98 = 0x275c;
                    t.a99 = 0x275d;
                    t.a100 = 0x275e;
                    t.a101 = 0x2761;
                    t.a102 = 0x2762;
                    t.a103 = 0x2763;
                    t.a104 = 0x2764;
                    t.a106 = 0x2765;
                    t.a107 = 0x2766;
                    t.a108 = 0x2767;
                    t.a112 = 0x2663;
                    t.a111 = 0x2666;
                    t.a110 = 0x2665;
                    t.a109 = 0x2660;
                    t.a120 = 0x2460;
                    t.a121 = 0x2461;
                    t.a122 = 0x2462;
                    t.a123 = 0x2463;
                    t.a124 = 0x2464;
                    t.a125 = 0x2465;
                    t.a126 = 0x2466;
                    t.a127 = 0x2467;
                    t.a128 = 0x2468;
                    t.a129 = 0x2469;
                    t.a130 = 0x2776;
                    t.a131 = 0x2777;
                    t.a132 = 0x2778;
                    t.a133 = 0x2779;
                    t.a134 = 0x277a;
                    t.a135 = 0x277b;
                    t.a136 = 0x277c;
                    t.a137 = 0x277d;
                    t.a138 = 0x277e;
                    t.a139 = 0x277f;
                    t.a140 = 0x2780;
                    t.a141 = 0x2781;
                    t.a142 = 0x2782;
                    t.a143 = 0x2783;
                    t.a144 = 0x2784;
                    t.a145 = 0x2785;
                    t.a146 = 0x2786;
                    t.a147 = 0x2787;
                    t.a148 = 0x2788;
                    t.a149 = 0x2789;
                    t.a150 = 0x278a;
                    t.a151 = 0x278b;
                    t.a152 = 0x278c;
                    t.a153 = 0x278d;
                    t.a154 = 0x278e;
                    t.a155 = 0x278f;
                    t.a156 = 0x2790;
                    t.a157 = 0x2791;
                    t.a158 = 0x2792;
                    t.a159 = 0x2793;
                    t.a160 = 0x2794;
                    t.a161 = 0x2192;
                    t.a163 = 0x2194;
                    t.a164 = 0x2195;
                    t.a196 = 0x2798;
                    t.a165 = 0x2799;
                    t.a192 = 0x279a;
                    t.a166 = 0x279b;
                    t.a167 = 0x279c;
                    t.a168 = 0x279d;
                    t.a169 = 0x279e;
                    t.a170 = 0x279f;
                    t.a171 = 0x27a0;
                    t.a172 = 0x27a1;
                    t.a173 = 0x27a2;
                    t.a162 = 0x27a3;
                    t.a174 = 0x27a4;
                    t.a175 = 0x27a5;
                    t.a176 = 0x27a6;
                    t.a177 = 0x27a7;
                    t.a178 = 0x27a8;
                    t.a179 = 0x27a9;
                    t.a193 = 0x27aa;
                    t.a180 = 0x27ab;
                    t.a199 = 0x27ac;
                    t.a181 = 0x27ad;
                    t.a200 = 0x27ae;
                    t.a182 = 0x27af;
                    t.a201 = 0x27b1;
                    t.a183 = 0x27b2;
                    t.a184 = 0x27b3;
                    t.a197 = 0x27b4;
                    t.a185 = 0x27b5;
                    t.a194 = 0x27b6;
                    t.a198 = 0x27b7;
                    t.a186 = 0x27b8;
                    t.a195 = 0x27b9;
                    t.a187 = 0x27ba;
                    t.a188 = 0x27bb;
                    t.a189 = 0x27bc;
                    t.a190 = 0x27bd;
                    t.a191 = 0x27be;
                    t.a89 = 0x2768;
                    t.a90 = 0x2769;
                    t.a93 = 0x276a;
                    t.a94 = 0x276b;
                    t.a91 = 0x276c;
                    t.a92 = 0x276d;
                    t.a205 = 0x276e;
                    t.a85 = 0x276f;
                    t.a206 = 0x2770;
                    t.a86 = 0x2771;
                    t.a87 = 0x2772;
                    t.a88 = 0x2773;
                    t.a95 = 0x2774;
                    t.a96 = 0x2775;
                    t[".notdef"] = 0x0000;
                });
                exports.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;
            /***/ },
            /* 40 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearUnicodeCaches = clearUnicodeCaches;
                exports.getCharUnicodeCategory = getCharUnicodeCategory;
                exports.getUnicodeForGlyph = getUnicodeForGlyph;
                exports.getUnicodeRangeFor = getUnicodeRangeFor;
                exports.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
                var _core_utils = __w_pdfjs_require__(3);
                const getSpecialPUASymbols = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[63721] = 0x00a9;
                    t[63193] = 0x00a9;
                    t[63720] = 0x00ae;
                    t[63194] = 0x00ae;
                    t[63722] = 0x2122;
                    t[63195] = 0x2122;
                    t[63729] = 0x23a7;
                    t[63730] = 0x23a8;
                    t[63731] = 0x23a9;
                    t[63740] = 0x23ab;
                    t[63741] = 0x23ac;
                    t[63742] = 0x23ad;
                    t[63726] = 0x23a1;
                    t[63727] = 0x23a2;
                    t[63728] = 0x23a3;
                    t[63737] = 0x23a4;
                    t[63738] = 0x23a5;
                    t[63739] = 0x23a6;
                    t[63723] = 0x239b;
                    t[63724] = 0x239c;
                    t[63725] = 0x239d;
                    t[63734] = 0x239e;
                    t[63735] = 0x239f;
                    t[63736] = 0x23a0;
                });
                function mapSpecialUnicodeValues(code) {
                    if (code >= 0xfff0 && code <= 0xffff) return 0;
                    else if (code >= 0xf600 && code <= 0xf8ff) return getSpecialPUASymbols()[code] || code;
                    else if (code === 0x00ad) return 0x002d;
                    return code;
                }
                function getUnicodeForGlyph(name, glyphsUnicodeMap) {
                    let unicode = glyphsUnicodeMap[name];
                    if (unicode !== undefined) return unicode;
                    if (!name) return -1;
                    if (name[0] === "u") {
                        const nameLen = name.length;
                        let hexStr;
                        if (nameLen === 7 && name[1] === "n" && name[2] === "i") hexStr = name.substring(3);
                        else if (nameLen >= 5 && nameLen <= 7) hexStr = name.substring(1);
                        else return -1;
                        if (hexStr === hexStr.toUpperCase()) {
                            unicode = parseInt(hexStr, 16);
                            if (unicode >= 0) return unicode;
                        }
                    }
                    return -1;
                }
                const UnicodeRanges = [
                    [
                        0x0000,
                        0x007f
                    ],
                    [
                        0x0080,
                        0x00ff
                    ],
                    [
                        0x0100,
                        0x017f
                    ],
                    [
                        0x0180,
                        0x024f
                    ],
                    [
                        0x0250,
                        0x02af,
                        0x1d00,
                        0x1d7f,
                        0x1d80,
                        0x1dbf
                    ],
                    [
                        0x02b0,
                        0x02ff,
                        0xa700,
                        0xa71f
                    ],
                    [
                        0x0300,
                        0x036f,
                        0x1dc0,
                        0x1dff
                    ],
                    [
                        0x0370,
                        0x03ff
                    ],
                    [
                        0x2c80,
                        0x2cff
                    ],
                    [
                        0x0400,
                        0x04ff,
                        0x0500,
                        0x052f,
                        0x2de0,
                        0x2dff,
                        0xa640,
                        0xa69f
                    ],
                    [
                        0x0530,
                        0x058f
                    ],
                    [
                        0x0590,
                        0x05ff
                    ],
                    [
                        0xa500,
                        0xa63f
                    ],
                    [
                        0x0600,
                        0x06ff,
                        0x0750,
                        0x077f
                    ],
                    [
                        0x07c0,
                        0x07ff
                    ],
                    [
                        0x0900,
                        0x097f
                    ],
                    [
                        0x0980,
                        0x09ff
                    ],
                    [
                        0x0a00,
                        0x0a7f
                    ],
                    [
                        0x0a80,
                        0x0aff
                    ],
                    [
                        0x0b00,
                        0x0b7f
                    ],
                    [
                        0x0b80,
                        0x0bff
                    ],
                    [
                        0x0c00,
                        0x0c7f
                    ],
                    [
                        0x0c80,
                        0x0cff
                    ],
                    [
                        0x0d00,
                        0x0d7f
                    ],
                    [
                        0x0e00,
                        0x0e7f
                    ],
                    [
                        0x0e80,
                        0x0eff
                    ],
                    [
                        0x10a0,
                        0x10ff,
                        0x2d00,
                        0x2d2f
                    ],
                    [
                        0x1b00,
                        0x1b7f
                    ],
                    [
                        0x1100,
                        0x11ff
                    ],
                    [
                        0x1e00,
                        0x1eff,
                        0x2c60,
                        0x2c7f,
                        0xa720,
                        0xa7ff
                    ],
                    [
                        0x1f00,
                        0x1fff
                    ],
                    [
                        0x2000,
                        0x206f,
                        0x2e00,
                        0x2e7f
                    ],
                    [
                        0x2070,
                        0x209f
                    ],
                    [
                        0x20a0,
                        0x20cf
                    ],
                    [
                        0x20d0,
                        0x20ff
                    ],
                    [
                        0x2100,
                        0x214f
                    ],
                    [
                        0x2150,
                        0x218f
                    ],
                    [
                        0x2190,
                        0x21ff,
                        0x27f0,
                        0x27ff,
                        0x2900,
                        0x297f,
                        0x2b00,
                        0x2bff
                    ],
                    [
                        0x2200,
                        0x22ff,
                        0x2a00,
                        0x2aff,
                        0x27c0,
                        0x27ef,
                        0x2980,
                        0x29ff
                    ],
                    [
                        0x2300,
                        0x23ff
                    ],
                    [
                        0x2400,
                        0x243f
                    ],
                    [
                        0x2440,
                        0x245f
                    ],
                    [
                        0x2460,
                        0x24ff
                    ],
                    [
                        0x2500,
                        0x257f
                    ],
                    [
                        0x2580,
                        0x259f
                    ],
                    [
                        0x25a0,
                        0x25ff
                    ],
                    [
                        0x2600,
                        0x26ff
                    ],
                    [
                        0x2700,
                        0x27bf
                    ],
                    [
                        0x3000,
                        0x303f
                    ],
                    [
                        0x3040,
                        0x309f
                    ],
                    [
                        0x30a0,
                        0x30ff,
                        0x31f0,
                        0x31ff
                    ],
                    [
                        0x3100,
                        0x312f,
                        0x31a0,
                        0x31bf
                    ],
                    [
                        0x3130,
                        0x318f
                    ],
                    [
                        0xa840,
                        0xa87f
                    ],
                    [
                        0x3200,
                        0x32ff
                    ],
                    [
                        0x3300,
                        0x33ff
                    ],
                    [
                        0xac00,
                        0xd7af
                    ],
                    [
                        0xd800,
                        0xdfff
                    ],
                    [
                        0x10900,
                        0x1091f
                    ],
                    [
                        0x4e00,
                        0x9fff,
                        0x2e80,
                        0x2eff,
                        0x2f00,
                        0x2fdf,
                        0x2ff0,
                        0x2fff,
                        0x3400,
                        0x4dbf,
                        0x20000,
                        0x2a6df,
                        0x3190,
                        0x319f
                    ],
                    [
                        0xe000,
                        0xf8ff
                    ],
                    [
                        0x31c0,
                        0x31ef,
                        0xf900,
                        0xfaff,
                        0x2f800,
                        0x2fa1f
                    ],
                    [
                        0xfb00,
                        0xfb4f
                    ],
                    [
                        0xfb50,
                        0xfdff
                    ],
                    [
                        0xfe20,
                        0xfe2f
                    ],
                    [
                        0xfe10,
                        0xfe1f
                    ],
                    [
                        0xfe50,
                        0xfe6f
                    ],
                    [
                        0xfe70,
                        0xfeff
                    ],
                    [
                        0xff00,
                        0xffef
                    ],
                    [
                        0xfff0,
                        0xffff
                    ],
                    [
                        0x0f00,
                        0x0fff
                    ],
                    [
                        0x0700,
                        0x074f
                    ],
                    [
                        0x0780,
                        0x07bf
                    ],
                    [
                        0x0d80,
                        0x0dff
                    ],
                    [
                        0x1000,
                        0x109f
                    ],
                    [
                        0x1200,
                        0x137f,
                        0x1380,
                        0x139f,
                        0x2d80,
                        0x2ddf
                    ],
                    [
                        0x13a0,
                        0x13ff
                    ],
                    [
                        0x1400,
                        0x167f
                    ],
                    [
                        0x1680,
                        0x169f
                    ],
                    [
                        0x16a0,
                        0x16ff
                    ],
                    [
                        0x1780,
                        0x17ff
                    ],
                    [
                        0x1800,
                        0x18af
                    ],
                    [
                        0x2800,
                        0x28ff
                    ],
                    [
                        0xa000,
                        0xa48f
                    ],
                    [
                        0x1700,
                        0x171f,
                        0x1720,
                        0x173f,
                        0x1740,
                        0x175f,
                        0x1760,
                        0x177f
                    ],
                    [
                        0x10300,
                        0x1032f
                    ],
                    [
                        0x10330,
                        0x1034f
                    ],
                    [
                        0x10400,
                        0x1044f
                    ],
                    [
                        0x1d000,
                        0x1d0ff,
                        0x1d100,
                        0x1d1ff,
                        0x1d200,
                        0x1d24f
                    ],
                    [
                        0x1d400,
                        0x1d7ff
                    ],
                    [
                        0xff000,
                        0xffffd
                    ],
                    [
                        0xfe00,
                        0xfe0f,
                        0xe0100,
                        0xe01ef
                    ],
                    [
                        0xe0000,
                        0xe007f
                    ],
                    [
                        0x1900,
                        0x194f
                    ],
                    [
                        0x1950,
                        0x197f
                    ],
                    [
                        0x1980,
                        0x19df
                    ],
                    [
                        0x1a00,
                        0x1a1f
                    ],
                    [
                        0x2c00,
                        0x2c5f
                    ],
                    [
                        0x2d30,
                        0x2d7f
                    ],
                    [
                        0x4dc0,
                        0x4dff
                    ],
                    [
                        0xa800,
                        0xa82f
                    ],
                    [
                        0x10000,
                        0x1007f,
                        0x10080,
                        0x100ff,
                        0x10100,
                        0x1013f
                    ],
                    [
                        0x10140,
                        0x1018f
                    ],
                    [
                        0x10380,
                        0x1039f
                    ],
                    [
                        0x103a0,
                        0x103df
                    ],
                    [
                        0x10450,
                        0x1047f
                    ],
                    [
                        0x10480,
                        0x104af
                    ],
                    [
                        0x10800,
                        0x1083f
                    ],
                    [
                        0x10a00,
                        0x10a5f
                    ],
                    [
                        0x1d300,
                        0x1d35f
                    ],
                    [
                        0x12000,
                        0x123ff,
                        0x12400,
                        0x1247f
                    ],
                    [
                        0x1d360,
                        0x1d37f
                    ],
                    [
                        0x1b80,
                        0x1bbf
                    ],
                    [
                        0x1c00,
                        0x1c4f
                    ],
                    [
                        0x1c50,
                        0x1c7f
                    ],
                    [
                        0xa880,
                        0xa8df
                    ],
                    [
                        0xa900,
                        0xa92f
                    ],
                    [
                        0xa930,
                        0xa95f
                    ],
                    [
                        0xaa00,
                        0xaa5f
                    ],
                    [
                        0x10190,
                        0x101cf
                    ],
                    [
                        0x101d0,
                        0x101ff
                    ],
                    [
                        0x102a0,
                        0x102df,
                        0x10280,
                        0x1029f,
                        0x10920,
                        0x1093f
                    ],
                    [
                        0x1f030,
                        0x1f09f,
                        0x1f000,
                        0x1f02f
                    ]
                ];
                function getUnicodeRangeFor(value, lastPosition = -1) {
                    if (lastPosition !== -1) {
                        const range = UnicodeRanges[lastPosition];
                        for(let i = 0, ii = range.length; i < ii; i += 2){
                            if (value >= range[i] && value <= range[i + 1]) return lastPosition;
                        }
                    }
                    for(let i = 0, ii = UnicodeRanges.length; i < ii; i++){
                        const range = UnicodeRanges[i];
                        for(let j = 0, jj = range.length; j < jj; j += 2){
                            if (value >= range[j] && value <= range[j + 1]) return i;
                        }
                    }
                    return -1;
                }
                const SpecialCharRegExp = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u");
                const CategoryCache = new Map();
                function getCharUnicodeCategory(char) {
                    const cachedCategory = CategoryCache.get(char);
                    if (cachedCategory) return cachedCategory;
                    const groups = char.match(SpecialCharRegExp);
                    const category = {
                        isWhitespace: !!groups?.[1],
                        isZeroWidthDiacritic: !!groups?.[2],
                        isInvisibleFormatMark: !!groups?.[3]
                    };
                    CategoryCache.set(char, category);
                    return category;
                }
                function clearUnicodeCaches() {
                    CategoryCache.clear();
                }
            /***/ },
            /* 41 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getSerifFonts = exports.getNonStdFontMap = exports.getGlyphMapForStandardFonts = exports.getFontNameToFileMap = void 0;
                exports.getStandardFontName = getStandardFontName;
                exports.getSymbolsFonts = exports.getSupplementalGlyphMapForCalibri = exports.getSupplementalGlyphMapForArialBlack = exports.getStdFontMap = void 0;
                exports.isKnownFontName = isKnownFontName;
                var _core_utils = __w_pdfjs_require__(3);
                var _fonts_utils = __w_pdfjs_require__(38);
                const getStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["Times-Roman"] = "Times-Roman";
                    t.Helvetica = "Helvetica";
                    t.Courier = "Courier";
                    t.Symbol = "Symbol";
                    t["Times-Bold"] = "Times-Bold";
                    t["Helvetica-Bold"] = "Helvetica-Bold";
                    t["Courier-Bold"] = "Courier-Bold";
                    t.ZapfDingbats = "ZapfDingbats";
                    t["Times-Italic"] = "Times-Italic";
                    t["Helvetica-Oblique"] = "Helvetica-Oblique";
                    t["Courier-Oblique"] = "Courier-Oblique";
                    t["Times-BoldItalic"] = "Times-BoldItalic";
                    t["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
                    t["Courier-BoldOblique"] = "Courier-BoldOblique";
                    t.ArialNarrow = "Helvetica";
                    t["ArialNarrow-Bold"] = "Helvetica-Bold";
                    t["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialNarrow-Italic"] = "Helvetica-Oblique";
                    t.ArialBlack = "Helvetica";
                    t["ArialBlack-Bold"] = "Helvetica-Bold";
                    t["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialBlack-Italic"] = "Helvetica-Oblique";
                    t["Arial-Black"] = "Helvetica";
                    t["Arial-Black-Bold"] = "Helvetica-Bold";
                    t["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-Black-Italic"] = "Helvetica-Oblique";
                    t.Arial = "Helvetica";
                    t["Arial-Bold"] = "Helvetica-Bold";
                    t["Arial-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-Italic"] = "Helvetica-Oblique";
                    t.ArialMT = "Helvetica";
                    t["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
                    t["Arial-BoldMT"] = "Helvetica-Bold";
                    t["Arial-ItalicMT"] = "Helvetica-Oblique";
                    t["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-BoldMT-Bold"] = "Helvetica-Bold";
                    t["Arial-ItalicMT-Italic"] = "Helvetica-Oblique";
                    t.ArialUnicodeMS = "Helvetica";
                    t["ArialUnicodeMS-Bold"] = "Helvetica-Bold";
                    t["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialUnicodeMS-Italic"] = "Helvetica-Oblique";
                    t["Courier-BoldItalic"] = "Courier-BoldOblique";
                    t["Courier-Italic"] = "Courier-Oblique";
                    t.CourierNew = "Courier";
                    t["CourierNew-Bold"] = "Courier-Bold";
                    t["CourierNew-BoldItalic"] = "Courier-BoldOblique";
                    t["CourierNew-Italic"] = "Courier-Oblique";
                    t["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
                    t["CourierNewPS-BoldMT"] = "Courier-Bold";
                    t["CourierNewPS-ItalicMT"] = "Courier-Oblique";
                    t.CourierNewPSMT = "Courier";
                    t["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Helvetica-Italic"] = "Helvetica-Oblique";
                    t["Symbol-Bold"] = "Symbol";
                    t["Symbol-BoldItalic"] = "Symbol";
                    t["Symbol-Italic"] = "Symbol";
                    t.TimesNewRoman = "Times-Roman";
                    t["TimesNewRoman-Bold"] = "Times-Bold";
                    t["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRoman-Italic"] = "Times-Italic";
                    t.TimesNewRomanPS = "Times-Roman";
                    t["TimesNewRomanPS-Bold"] = "Times-Bold";
                    t["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
                    t["TimesNewRomanPS-BoldMT"] = "Times-Bold";
                    t["TimesNewRomanPS-Italic"] = "Times-Italic";
                    t["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
                    t.TimesNewRomanPSMT = "Times-Roman";
                    t["TimesNewRomanPSMT-Bold"] = "Times-Bold";
                    t["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRomanPSMT-Italic"] = "Times-Italic";
                });
                exports.getStdFontMap = getStdFontMap;
                const getFontNameToFileMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = "FoxitFixed.pfb";
                    t["Courier-Bold"] = "FoxitFixedBold.pfb";
                    t["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb";
                    t["Courier-Oblique"] = "FoxitFixedItalic.pfb";
                    t.Helvetica = "LiberationSans-Regular.ttf";
                    t["Helvetica-Bold"] = "LiberationSans-Bold.ttf";
                    t["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf";
                    t["Helvetica-Oblique"] = "LiberationSans-Italic.ttf";
                    t["Times-Roman"] = "FoxitSerif.pfb";
                    t["Times-Bold"] = "FoxitSerifBold.pfb";
                    t["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb";
                    t["Times-Italic"] = "FoxitSerifItalic.pfb";
                    t.Symbol = "FoxitSymbol.pfb";
                    t.ZapfDingbats = "FoxitDingbats.pfb";
                    t["LiberationSans-Regular"] = "LiberationSans-Regular.ttf";
                    t["LiberationSans-Bold"] = "LiberationSans-Bold.ttf";
                    t["LiberationSans-Italic"] = "LiberationSans-Italic.ttf";
                    t["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
                });
                exports.getFontNameToFileMap = getFontNameToFileMap;
                const getNonStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Calibri = "Helvetica";
                    t["Calibri-Bold"] = "Helvetica-Bold";
                    t["Calibri-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Calibri-Italic"] = "Helvetica-Oblique";
                    t.CenturyGothic = "Helvetica";
                    t["CenturyGothic-Bold"] = "Helvetica-Bold";
                    t["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
                    t["CenturyGothic-Italic"] = "Helvetica-Oblique";
                    t.ComicSansMS = "Comic Sans MS";
                    t["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
                    t["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
                    t["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
                    t.Impact = "Helvetica";
                    t["ItcSymbol-Bold"] = "Helvetica-Bold";
                    t["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ItcSymbol-Book"] = "Helvetica";
                    t["ItcSymbol-BookItalic"] = "Helvetica-Oblique";
                    t["ItcSymbol-Medium"] = "Helvetica";
                    t["ItcSymbol-MediumItalic"] = "Helvetica-Oblique";
                    t.LucidaConsole = "Courier";
                    t["LucidaConsole-Bold"] = "Courier-Bold";
                    t["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
                    t["LucidaConsole-Italic"] = "Courier-Oblique";
                    t["LucidaSans-Demi"] = "Helvetica-Bold";
                    t["MS-Gothic"] = "MS Gothic";
                    t["MS-Gothic-Bold"] = "MS Gothic-Bold";
                    t["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
                    t["MS-Gothic-Italic"] = "MS Gothic-Italic";
                    t["MS-Mincho"] = "MS Mincho";
                    t["MS-Mincho-Bold"] = "MS Mincho-Bold";
                    t["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
                    t["MS-Mincho-Italic"] = "MS Mincho-Italic";
                    t["MS-PGothic"] = "MS PGothic";
                    t["MS-PGothic-Bold"] = "MS PGothic-Bold";
                    t["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
                    t["MS-PGothic-Italic"] = "MS PGothic-Italic";
                    t["MS-PMincho"] = "MS PMincho";
                    t["MS-PMincho-Bold"] = "MS PMincho-Bold";
                    t["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
                    t["MS-PMincho-Italic"] = "MS PMincho-Italic";
                    t.NuptialScript = "Times-Italic";
                    t.SegoeUISymbol = "Helvetica";
                });
                exports.getNonStdFontMap = getNonStdFontMap;
                const getSerifFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["Adobe Jenson"] = true;
                    t["Adobe Text"] = true;
                    t.Albertus = true;
                    t.Aldus = true;
                    t.Alexandria = true;
                    t.Algerian = true;
                    t["American Typewriter"] = true;
                    t.Antiqua = true;
                    t.Apex = true;
                    t.Arno = true;
                    t.Aster = true;
                    t.Aurora = true;
                    t.Baskerville = true;
                    t.Bell = true;
                    t.Bembo = true;
                    t["Bembo Schoolbook"] = true;
                    t.Benguiat = true;
                    t["Berkeley Old Style"] = true;
                    t["Bernhard Modern"] = true;
                    t["Berthold City"] = true;
                    t.Bodoni = true;
                    t["Bauer Bodoni"] = true;
                    t["Book Antiqua"] = true;
                    t.Bookman = true;
                    t["Bordeaux Roman"] = true;
                    t["Californian FB"] = true;
                    t.Calisto = true;
                    t.Calvert = true;
                    t.Capitals = true;
                    t.Cambria = true;
                    t.Cartier = true;
                    t.Caslon = true;
                    t.Catull = true;
                    t.Centaur = true;
                    t["Century Old Style"] = true;
                    t["Century Schoolbook"] = true;
                    t.Chaparral = true;
                    t["Charis SIL"] = true;
                    t.Cheltenham = true;
                    t["Cholla Slab"] = true;
                    t.Clarendon = true;
                    t.Clearface = true;
                    t.Cochin = true;
                    t.Colonna = true;
                    t["Computer Modern"] = true;
                    t["Concrete Roman"] = true;
                    t.Constantia = true;
                    t["Cooper Black"] = true;
                    t.Corona = true;
                    t.Ecotype = true;
                    t.Egyptienne = true;
                    t.Elephant = true;
                    t.Excelsior = true;
                    t.Fairfield = true;
                    t["FF Scala"] = true;
                    t.Folkard = true;
                    t.Footlight = true;
                    t.FreeSerif = true;
                    t["Friz Quadrata"] = true;
                    t.Garamond = true;
                    t.Gentium = true;
                    t.Georgia = true;
                    t.Gloucester = true;
                    t["Goudy Old Style"] = true;
                    t["Goudy Schoolbook"] = true;
                    t["Goudy Pro Font"] = true;
                    t.Granjon = true;
                    t["Guardian Egyptian"] = true;
                    t.Heather = true;
                    t.Hercules = true;
                    t["High Tower Text"] = true;
                    t.Hiroshige = true;
                    t["Hoefler Text"] = true;
                    t["Humana Serif"] = true;
                    t.Imprint = true;
                    t["Ionic No. 5"] = true;
                    t.Janson = true;
                    t.Joanna = true;
                    t.Korinna = true;
                    t.Lexicon = true;
                    t.LiberationSerif = true;
                    t["Liberation Serif"] = true;
                    t["Linux Libertine"] = true;
                    t.Literaturnaya = true;
                    t.Lucida = true;
                    t["Lucida Bright"] = true;
                    t.Melior = true;
                    t.Memphis = true;
                    t.Miller = true;
                    t.Minion = true;
                    t.Modern = true;
                    t["Mona Lisa"] = true;
                    t["Mrs Eaves"] = true;
                    t["MS Serif"] = true;
                    t["Museo Slab"] = true;
                    t["New York"] = true;
                    t["Nimbus Roman"] = true;
                    t["NPS Rawlinson Roadway"] = true;
                    t.NuptialScript = true;
                    t.Palatino = true;
                    t.Perpetua = true;
                    t.Plantin = true;
                    t["Plantin Schoolbook"] = true;
                    t.Playbill = true;
                    t["Poor Richard"] = true;
                    t["Rawlinson Roadway"] = true;
                    t.Renault = true;
                    t.Requiem = true;
                    t.Rockwell = true;
                    t.Roman = true;
                    t["Rotis Serif"] = true;
                    t.Sabon = true;
                    t.Scala = true;
                    t.Seagull = true;
                    t.Sistina = true;
                    t.Souvenir = true;
                    t.STIX = true;
                    t["Stone Informal"] = true;
                    t["Stone Serif"] = true;
                    t.Sylfaen = true;
                    t.Times = true;
                    t.Trajan = true;
                    t["Trinit\xe9"] = true;
                    t["Trump Mediaeval"] = true;
                    t.Utopia = true;
                    t["Vale Type"] = true;
                    t["Bitstream Vera"] = true;
                    t["Vera Serif"] = true;
                    t.Versailles = true;
                    t.Wanted = true;
                    t.Weiss = true;
                    t["Wide Latin"] = true;
                    t.Windsor = true;
                    t.XITS = true;
                });
                exports.getSerifFonts = getSerifFonts;
                const getSymbolsFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Dingbats = true;
                    t.Symbol = true;
                    t.ZapfDingbats = true;
                    t.Wingdings = true;
                    t["Wingdings-Bold"] = true;
                    t["Wingdings-Regular"] = true;
                });
                exports.getSymbolsFonts = getSymbolsFonts;
                const getGlyphMapForStandardFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[2] = 10;
                    t[3] = 32;
                    t[4] = 33;
                    t[5] = 34;
                    t[6] = 35;
                    t[7] = 36;
                    t[8] = 37;
                    t[9] = 38;
                    t[10] = 39;
                    t[11] = 40;
                    t[12] = 41;
                    t[13] = 42;
                    t[14] = 43;
                    t[15] = 44;
                    t[16] = 45;
                    t[17] = 46;
                    t[18] = 47;
                    t[19] = 48;
                    t[20] = 49;
                    t[21] = 50;
                    t[22] = 51;
                    t[23] = 52;
                    t[24] = 53;
                    t[25] = 54;
                    t[26] = 55;
                    t[27] = 56;
                    t[28] = 57;
                    t[29] = 58;
                    t[30] = 894;
                    t[31] = 60;
                    t[32] = 61;
                    t[33] = 62;
                    t[34] = 63;
                    t[35] = 64;
                    t[36] = 65;
                    t[37] = 66;
                    t[38] = 67;
                    t[39] = 68;
                    t[40] = 69;
                    t[41] = 70;
                    t[42] = 71;
                    t[43] = 72;
                    t[44] = 73;
                    t[45] = 74;
                    t[46] = 75;
                    t[47] = 76;
                    t[48] = 77;
                    t[49] = 78;
                    t[50] = 79;
                    t[51] = 80;
                    t[52] = 81;
                    t[53] = 82;
                    t[54] = 83;
                    t[55] = 84;
                    t[56] = 85;
                    t[57] = 86;
                    t[58] = 87;
                    t[59] = 88;
                    t[60] = 89;
                    t[61] = 90;
                    t[62] = 91;
                    t[63] = 92;
                    t[64] = 93;
                    t[65] = 94;
                    t[66] = 95;
                    t[67] = 96;
                    t[68] = 97;
                    t[69] = 98;
                    t[70] = 99;
                    t[71] = 100;
                    t[72] = 101;
                    t[73] = 102;
                    t[74] = 103;
                    t[75] = 104;
                    t[76] = 105;
                    t[77] = 106;
                    t[78] = 107;
                    t[79] = 108;
                    t[80] = 109;
                    t[81] = 110;
                    t[82] = 111;
                    t[83] = 112;
                    t[84] = 113;
                    t[85] = 114;
                    t[86] = 115;
                    t[87] = 116;
                    t[88] = 117;
                    t[89] = 118;
                    t[90] = 119;
                    t[91] = 120;
                    t[92] = 121;
                    t[93] = 122;
                    t[94] = 123;
                    t[95] = 124;
                    t[96] = 125;
                    t[97] = 126;
                    t[98] = 196;
                    t[99] = 197;
                    t[100] = 199;
                    t[101] = 201;
                    t[102] = 209;
                    t[103] = 214;
                    t[104] = 220;
                    t[105] = 225;
                    t[106] = 224;
                    t[107] = 226;
                    t[108] = 228;
                    t[109] = 227;
                    t[110] = 229;
                    t[111] = 231;
                    t[112] = 233;
                    t[113] = 232;
                    t[114] = 234;
                    t[115] = 235;
                    t[116] = 237;
                    t[117] = 236;
                    t[118] = 238;
                    t[119] = 239;
                    t[120] = 241;
                    t[121] = 243;
                    t[122] = 242;
                    t[123] = 244;
                    t[124] = 246;
                    t[125] = 245;
                    t[126] = 250;
                    t[127] = 249;
                    t[128] = 251;
                    t[129] = 252;
                    t[130] = 8224;
                    t[131] = 176;
                    t[132] = 162;
                    t[133] = 163;
                    t[134] = 167;
                    t[135] = 8226;
                    t[136] = 182;
                    t[137] = 223;
                    t[138] = 174;
                    t[139] = 169;
                    t[140] = 8482;
                    t[141] = 180;
                    t[142] = 168;
                    t[143] = 8800;
                    t[144] = 198;
                    t[145] = 216;
                    t[146] = 8734;
                    t[147] = 177;
                    t[148] = 8804;
                    t[149] = 8805;
                    t[150] = 165;
                    t[151] = 181;
                    t[152] = 8706;
                    t[153] = 8721;
                    t[154] = 8719;
                    t[156] = 8747;
                    t[157] = 170;
                    t[158] = 186;
                    t[159] = 8486;
                    t[160] = 230;
                    t[161] = 248;
                    t[162] = 191;
                    t[163] = 161;
                    t[164] = 172;
                    t[165] = 8730;
                    t[166] = 402;
                    t[167] = 8776;
                    t[168] = 8710;
                    t[169] = 171;
                    t[170] = 187;
                    t[171] = 8230;
                    t[179] = 8220;
                    t[180] = 8221;
                    t[181] = 8216;
                    t[182] = 8217;
                    t[200] = 193;
                    t[203] = 205;
                    t[207] = 211;
                    t[210] = 218;
                    t[223] = 711;
                    t[224] = 321;
                    t[225] = 322;
                    t[226] = 352;
                    t[227] = 353;
                    t[228] = 381;
                    t[229] = 382;
                    t[233] = 221;
                    t[234] = 253;
                    t[252] = 263;
                    t[253] = 268;
                    t[254] = 269;
                    t[258] = 258;
                    t[260] = 260;
                    t[261] = 261;
                    t[265] = 280;
                    t[266] = 281;
                    t[267] = 282;
                    t[268] = 283;
                    t[269] = 313;
                    t[275] = 323;
                    t[276] = 324;
                    t[278] = 328;
                    t[283] = 344;
                    t[284] = 345;
                    t[285] = 346;
                    t[286] = 347;
                    t[292] = 367;
                    t[295] = 377;
                    t[296] = 378;
                    t[298] = 380;
                    t[305] = 963;
                    t[306] = 964;
                    t[307] = 966;
                    t[308] = 8215;
                    t[309] = 8252;
                    t[310] = 8319;
                    t[311] = 8359;
                    t[312] = 8592;
                    t[313] = 8593;
                    t[337] = 9552;
                    t[493] = 1039;
                    t[494] = 1040;
                    t[672] = 1488;
                    t[673] = 1489;
                    t[674] = 1490;
                    t[675] = 1491;
                    t[676] = 1492;
                    t[677] = 1493;
                    t[678] = 1494;
                    t[679] = 1495;
                    t[680] = 1496;
                    t[681] = 1497;
                    t[682] = 1498;
                    t[683] = 1499;
                    t[684] = 1500;
                    t[685] = 1501;
                    t[686] = 1502;
                    t[687] = 1503;
                    t[688] = 1504;
                    t[689] = 1505;
                    t[690] = 1506;
                    t[691] = 1507;
                    t[692] = 1508;
                    t[693] = 1509;
                    t[694] = 1510;
                    t[695] = 1511;
                    t[696] = 1512;
                    t[697] = 1513;
                    t[698] = 1514;
                    t[705] = 1524;
                    t[706] = 8362;
                    t[710] = 64288;
                    t[711] = 64298;
                    t[759] = 1617;
                    t[761] = 1776;
                    t[763] = 1778;
                    t[775] = 1652;
                    t[777] = 1764;
                    t[778] = 1780;
                    t[779] = 1781;
                    t[780] = 1782;
                    t[782] = 771;
                    t[783] = 64726;
                    t[786] = 8363;
                    t[788] = 8532;
                    t[790] = 768;
                    t[791] = 769;
                    t[792] = 768;
                    t[795] = 803;
                    t[797] = 64336;
                    t[798] = 64337;
                    t[799] = 64342;
                    t[800] = 64343;
                    t[801] = 64344;
                    t[802] = 64345;
                    t[803] = 64362;
                    t[804] = 64363;
                    t[805] = 64364;
                    t[2424] = 7821;
                    t[2425] = 7822;
                    t[2426] = 7823;
                    t[2427] = 7824;
                    t[2428] = 7825;
                    t[2429] = 7826;
                    t[2430] = 7827;
                    t[2433] = 7682;
                    t[2678] = 8045;
                    t[2679] = 8046;
                    t[2830] = 1552;
                    t[2838] = 686;
                    t[2840] = 751;
                    t[2842] = 753;
                    t[2843] = 754;
                    t[2844] = 755;
                    t[2846] = 757;
                    t[2856] = 767;
                    t[2857] = 848;
                    t[2858] = 849;
                    t[2862] = 853;
                    t[2863] = 854;
                    t[2864] = 855;
                    t[2865] = 861;
                    t[2866] = 862;
                    t[2906] = 7460;
                    t[2908] = 7462;
                    t[2909] = 7463;
                    t[2910] = 7464;
                    t[2912] = 7466;
                    t[2913] = 7467;
                    t[2914] = 7468;
                    t[2916] = 7470;
                    t[2917] = 7471;
                    t[2918] = 7472;
                    t[2920] = 7474;
                    t[2921] = 7475;
                    t[2922] = 7476;
                    t[2924] = 7478;
                    t[2925] = 7479;
                    t[2926] = 7480;
                    t[2928] = 7482;
                    t[2929] = 7483;
                    t[2930] = 7484;
                    t[2932] = 7486;
                    t[2933] = 7487;
                    t[2934] = 7488;
                    t[2936] = 7490;
                    t[2937] = 7491;
                    t[2938] = 7492;
                    t[2940] = 7494;
                    t[2941] = 7495;
                    t[2942] = 7496;
                    t[2944] = 7498;
                    t[2946] = 7500;
                    t[2948] = 7502;
                    t[2950] = 7504;
                    t[2951] = 7505;
                    t[2952] = 7506;
                    t[2954] = 7508;
                    t[2955] = 7509;
                    t[2956] = 7510;
                    t[2958] = 7512;
                    t[2959] = 7513;
                    t[2960] = 7514;
                    t[2962] = 7516;
                    t[2963] = 7517;
                    t[2964] = 7518;
                    t[2966] = 7520;
                    t[2967] = 7521;
                    t[2968] = 7522;
                    t[2970] = 7524;
                    t[2971] = 7525;
                    t[2972] = 7526;
                    t[2974] = 7528;
                    t[2975] = 7529;
                    t[2976] = 7530;
                    t[2978] = 1537;
                    t[2979] = 1538;
                    t[2980] = 1539;
                    t[2982] = 1549;
                    t[2983] = 1551;
                    t[2984] = 1552;
                    t[2986] = 1554;
                    t[2987] = 1555;
                    t[2988] = 1556;
                    t[2990] = 1623;
                    t[2991] = 1624;
                    t[2995] = 1775;
                    t[2999] = 1791;
                    t[3002] = 64290;
                    t[3003] = 64291;
                    t[3004] = 64292;
                    t[3006] = 64294;
                    t[3007] = 64295;
                    t[3008] = 64296;
                    t[3011] = 1900;
                    t[3014] = 8223;
                    t[3015] = 8244;
                    t[3017] = 7532;
                    t[3018] = 7533;
                    t[3019] = 7534;
                    t[3075] = 7590;
                    t[3076] = 7591;
                    t[3079] = 7594;
                    t[3080] = 7595;
                    t[3083] = 7598;
                    t[3084] = 7599;
                    t[3087] = 7602;
                    t[3088] = 7603;
                    t[3091] = 7606;
                    t[3092] = 7607;
                    t[3095] = 7610;
                    t[3096] = 7611;
                    t[3099] = 7614;
                    t[3100] = 7615;
                    t[3103] = 7618;
                    t[3104] = 7619;
                    t[3107] = 8337;
                    t[3108] = 8338;
                    t[3116] = 1884;
                    t[3119] = 1885;
                    t[3120] = 1885;
                    t[3123] = 1886;
                    t[3124] = 1886;
                    t[3127] = 1887;
                    t[3128] = 1887;
                    t[3131] = 1888;
                    t[3132] = 1888;
                    t[3135] = 1889;
                    t[3136] = 1889;
                    t[3139] = 1890;
                    t[3140] = 1890;
                    t[3143] = 1891;
                    t[3144] = 1891;
                    t[3147] = 1892;
                    t[3148] = 1892;
                    t[3153] = 580;
                    t[3154] = 581;
                    t[3157] = 584;
                    t[3158] = 585;
                    t[3161] = 588;
                    t[3162] = 589;
                    t[3165] = 891;
                    t[3166] = 892;
                    t[3169] = 1274;
                    t[3170] = 1275;
                    t[3173] = 1278;
                    t[3174] = 1279;
                    t[3181] = 7622;
                    t[3182] = 7623;
                    t[3282] = 11799;
                    t[3316] = 578;
                    t[3379] = 42785;
                    t[3393] = 1159;
                    t[3416] = 8377;
                });
                exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
                const getSupplementalGlyphMapForArialBlack = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[227] = 322;
                    t[264] = 261;
                    t[291] = 346;
                });
                exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;
                const getSupplementalGlyphMapForCalibri = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[1] = 32;
                    t[4] = 65;
                    t[5] = 192;
                    t[6] = 193;
                    t[9] = 196;
                    t[17] = 66;
                    t[18] = 67;
                    t[21] = 268;
                    t[24] = 68;
                    t[28] = 69;
                    t[29] = 200;
                    t[30] = 201;
                    t[32] = 282;
                    t[38] = 70;
                    t[39] = 71;
                    t[44] = 72;
                    t[47] = 73;
                    t[48] = 204;
                    t[49] = 205;
                    t[58] = 74;
                    t[60] = 75;
                    t[62] = 76;
                    t[68] = 77;
                    t[69] = 78;
                    t[75] = 79;
                    t[76] = 210;
                    t[80] = 214;
                    t[87] = 80;
                    t[89] = 81;
                    t[90] = 82;
                    t[92] = 344;
                    t[94] = 83;
                    t[97] = 352;
                    t[100] = 84;
                    t[104] = 85;
                    t[109] = 220;
                    t[115] = 86;
                    t[116] = 87;
                    t[121] = 88;
                    t[122] = 89;
                    t[124] = 221;
                    t[127] = 90;
                    t[129] = 381;
                    t[258] = 97;
                    t[259] = 224;
                    t[260] = 225;
                    t[263] = 228;
                    t[268] = 261;
                    t[271] = 98;
                    t[272] = 99;
                    t[273] = 263;
                    t[275] = 269;
                    t[282] = 100;
                    t[286] = 101;
                    t[287] = 232;
                    t[288] = 233;
                    t[290] = 283;
                    t[295] = 281;
                    t[296] = 102;
                    t[336] = 103;
                    t[346] = 104;
                    t[349] = 105;
                    t[350] = 236;
                    t[351] = 237;
                    t[361] = 106;
                    t[364] = 107;
                    t[367] = 108;
                    t[371] = 322;
                    t[373] = 109;
                    t[374] = 110;
                    t[381] = 111;
                    t[382] = 242;
                    t[383] = 243;
                    t[386] = 246;
                    t[393] = 112;
                    t[395] = 113;
                    t[396] = 114;
                    t[398] = 345;
                    t[400] = 115;
                    t[401] = 347;
                    t[403] = 353;
                    t[410] = 116;
                    t[437] = 117;
                    t[442] = 252;
                    t[448] = 118;
                    t[449] = 119;
                    t[454] = 120;
                    t[455] = 121;
                    t[457] = 253;
                    t[460] = 122;
                    t[462] = 382;
                    t[463] = 380;
                    t[853] = 44;
                    t[855] = 58;
                    t[856] = 46;
                    t[876] = 47;
                    t[878] = 45;
                    t[882] = 45;
                    t[894] = 40;
                    t[895] = 41;
                    t[896] = 91;
                    t[897] = 93;
                    t[923] = 64;
                    t[1004] = 48;
                    t[1005] = 49;
                    t[1006] = 50;
                    t[1007] = 51;
                    t[1008] = 52;
                    t[1009] = 53;
                    t[1010] = 54;
                    t[1011] = 55;
                    t[1012] = 56;
                    t[1013] = 57;
                    t[1081] = 37;
                    t[1085] = 43;
                    t[1086] = 45;
                });
                exports.getSupplementalGlyphMapForCalibri = getSupplementalGlyphMapForCalibri;
                function getStandardFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    const stdFontMap = getStdFontMap();
                    return stdFontMap[fontName];
                }
                function isKnownFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    return !!(getStdFontMap()[fontName] || getNonStdFontMap()[fontName] || getSerifFonts()[fontName] || getSymbolsFonts()[fontName]);
                }
            /***/ },
            /* 42 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ToUnicodeMap = exports.IdentityToUnicodeMap = void 0;
                var _util = __w_pdfjs_require__(2);
                class ToUnicodeMap {
                    constructor(cmap = []){
                        this._map = cmap;
                    }
                    get length() {
                        return this._map.length;
                    }
                    forEach(callback) {
                        for(const charCode in this._map)callback(charCode, this._map[charCode].charCodeAt(0));
                    }
                    has(i) {
                        return this._map[i] !== undefined;
                    }
                    get(i) {
                        return this._map[i];
                    }
                    charCodeOf(value) {
                        const map = this._map;
                        if (map.length <= 0x10000) return map.indexOf(value);
                        for(const charCode in map){
                            if (map[charCode] === value) return charCode | 0;
                        }
                        return -1;
                    }
                    amend(map) {
                        for(const charCode in map)this._map[charCode] = map[charCode];
                    }
                }
                exports.ToUnicodeMap = ToUnicodeMap;
                class IdentityToUnicodeMap {
                    constructor(firstChar, lastChar){
                        this.firstChar = firstChar;
                        this.lastChar = lastChar;
                    }
                    get length() {
                        return this.lastChar + 1 - this.firstChar;
                    }
                    forEach(callback) {
                        for(let i = this.firstChar, ii = this.lastChar; i <= ii; i++)callback(i, i);
                    }
                    has(i) {
                        return this.firstChar <= i && i <= this.lastChar;
                    }
                    get(i) {
                        if (this.firstChar <= i && i <= this.lastChar) return String.fromCharCode(i);
                        return undefined;
                    }
                    charCodeOf(v) {
                        return Number.isInteger(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
                    }
                    amend(map) {
                        (0, _util.unreachable)("Should not call amend()");
                    }
                }
                exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
            /***/ },
            /* 43 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CFFFont = void 0;
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _util = __w_pdfjs_require__(2);
                class CFFFont {
                    constructor(file, properties){
                        this.properties = properties;
                        const parser = new _cff_parser.CFFParser(file, properties, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        this.cff = parser.parse();
                        this.cff.duplicateFirstGlyph();
                        const compiler = new _cff_parser.CFFCompiler(this.cff);
                        this.seacs = this.cff.seacs;
                        try {
                            this.data = compiler.compile();
                        } catch  {
                            (0, _util.warn)("Failed to compile font " + properties.loadedName);
                            this.data = file;
                        }
                        this._createBuiltInEncoding();
                    }
                    get numGlyphs() {
                        return this.cff.charStrings.count;
                    }
                    getCharset() {
                        return this.cff.charset.charset;
                    }
                    getGlyphMapping() {
                        const cff = this.cff;
                        const properties = this.properties;
                        const { cidToGidMap: cidToGidMap, cMap: cMap } = properties;
                        const charsets = cff.charset.charset;
                        let charCodeToGlyphId;
                        let glyphId;
                        if (properties.composite) {
                            let invCidToGidMap;
                            if (cidToGidMap?.length > 0) {
                                invCidToGidMap = Object.create(null);
                                for(let i = 0, ii = cidToGidMap.length; i < ii; i++){
                                    const gid = cidToGidMap[i];
                                    if (gid !== undefined) invCidToGidMap[gid] = i;
                                }
                            }
                            charCodeToGlyphId = Object.create(null);
                            let charCode;
                            if (cff.isCIDFont) for(glyphId = 0; glyphId < charsets.length; glyphId++){
                                const cid = charsets[glyphId];
                                charCode = cMap.charCodeOf(cid);
                                if (invCidToGidMap?.[charCode] !== undefined) charCode = invCidToGidMap[charCode];
                                charCodeToGlyphId[charCode] = glyphId;
                            }
                            else for(glyphId = 0; glyphId < cff.charStrings.count; glyphId++){
                                charCode = cMap.charCodeOf(glyphId);
                                charCodeToGlyphId[charCode] = glyphId;
                            }
                            return charCodeToGlyphId;
                        }
                        let encoding = cff.encoding ? cff.encoding.encoding : null;
                        if (properties.isInternalFont) encoding = properties.defaultEncoding;
                        charCodeToGlyphId = (0, _fonts_utils.type1FontGlyphMapping)(properties, encoding, charsets);
                        return charCodeToGlyphId;
                    }
                    hasGlyphId(id) {
                        return this.cff.hasGlyphId(id);
                    }
                    _createBuiltInEncoding() {
                        const { charset: charset, encoding: encoding } = this.cff;
                        if (!charset || !encoding) return;
                        const charsets = charset.charset, encodings = encoding.encoding;
                        const map = [];
                        for(const charCode in encodings){
                            const glyphId = encodings[charCode];
                            if (glyphId >= 0) {
                                const glyphName = charsets[glyphId];
                                if (glyphName) map[charCode] = glyphName;
                            }
                        }
                        if (map.length > 0) this.properties.builtInEncoding = map;
                    }
                }
                exports.CFFFont = CFFFont;
            /***/ },
            /* 44 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontRendererFactory = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cff_parser = __w_pdfjs_require__(35);
                var _glyphlist = __w_pdfjs_require__(39);
                var _encodings = __w_pdfjs_require__(37);
                var _stream = __w_pdfjs_require__(8);
                function getUint32(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
                }
                function getUint16(data, offset) {
                    return data[offset] << 8 | data[offset + 1];
                }
                function getInt16(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16) >> 16;
                }
                function getInt8(data, offset) {
                    return data[offset] << 24 >> 24;
                }
                function getFloat214(data, offset) {
                    return getInt16(data, offset) / 16384;
                }
                function getSubroutineBias(subrs) {
                    const numSubrs = subrs.length;
                    let bias = 32768;
                    if (numSubrs < 1240) bias = 107;
                    else if (numSubrs < 33900) bias = 1131;
                    return bias;
                }
                function parseCmap(data, start, end) {
                    const offset = getUint16(data, start + 2) === 1 ? getUint32(data, start + 8) : getUint32(data, start + 16);
                    const format = getUint16(data, start + offset);
                    let ranges, p, i;
                    if (format === 4) {
                        getUint16(data, start + offset + 2);
                        const segCount = getUint16(data, start + offset + 6) >> 1;
                        p = start + offset + 14;
                        ranges = [];
                        for(i = 0; i < segCount; i++, p += 2)ranges[i] = {
                            end: getUint16(data, p)
                        };
                        p += 2;
                        for(i = 0; i < segCount; i++, p += 2)ranges[i].start = getUint16(data, p);
                        for(i = 0; i < segCount; i++, p += 2)ranges[i].idDelta = getUint16(data, p);
                        for(i = 0; i < segCount; i++, p += 2){
                            let idOffset = getUint16(data, p);
                            if (idOffset === 0) continue;
                            ranges[i].ids = [];
                            for(let j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++){
                                ranges[i].ids[j] = getUint16(data, p + idOffset);
                                idOffset += 2;
                            }
                        }
                        return ranges;
                    } else if (format === 12) {
                        const groups = getUint32(data, start + offset + 12);
                        p = start + offset + 16;
                        ranges = [];
                        for(i = 0; i < groups; i++){
                            start = getUint32(data, p);
                            ranges.push({
                                start: start,
                                end: getUint32(data, p + 4),
                                idDelta: getUint32(data, p + 8) - start
                            });
                            p += 12;
                        }
                        return ranges;
                    }
                    throw new _util.FormatError(`unsupported cmap: ${format}`);
                }
                function parseCff(data, start, end, seacAnalysisEnabled) {
                    const properties = {};
                    const parser = new _cff_parser.CFFParser(new _stream.Stream(data, start, end - start), properties, seacAnalysisEnabled);
                    const cff = parser.parse();
                    return {
                        glyphs: cff.charStrings.objects,
                        subrs: cff.topDict.privateDict?.subrsIndex?.objects,
                        gsubrs: cff.globalSubrIndex?.objects,
                        isCFFCIDFont: cff.isCIDFont,
                        fdSelect: cff.fdSelect,
                        fdArray: cff.fdArray
                    };
                }
                function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
                    let itemSize, itemDecode;
                    if (isGlyphLocationsLong) {
                        itemSize = 4;
                        itemDecode = getUint32;
                    } else {
                        itemSize = 2;
                        itemDecode = (data, offset)=>2 * getUint16(data, offset);
                    }
                    const glyphs = [];
                    let startOffset = itemDecode(loca, 0);
                    for(let j = itemSize; j < loca.length; j += itemSize){
                        const endOffset = itemDecode(loca, j);
                        glyphs.push(glyf.subarray(startOffset, endOffset));
                        startOffset = endOffset;
                    }
                    return glyphs;
                }
                function lookupCmap(ranges, unicode) {
                    const code = unicode.codePointAt(0);
                    let gid = 0, l = 0, r = ranges.length - 1;
                    while(l < r){
                        const c = l + r + 1 >> 1;
                        if (code < ranges[c].start) r = c - 1;
                        else l = c;
                    }
                    if (ranges[l].start <= code && code <= ranges[l].end) gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xffff;
                    return {
                        charCode: code,
                        glyphId: gid
                    };
                }
                function compileGlyf(code, cmds, font1) {
                    function moveTo(x, y) {
                        cmds.push({
                            cmd: "moveTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function lineTo(x, y) {
                        cmds.push({
                            cmd: "lineTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function quadraticCurveTo(xa, ya, x, y) {
                        cmds.push({
                            cmd: "quadraticCurveTo",
                            args: [
                                xa,
                                ya,
                                x,
                                y
                            ]
                        });
                    }
                    let i = 0;
                    const numberOfContours = getInt16(code, i);
                    let flags;
                    let x = 0, y = 0;
                    i += 10;
                    if (numberOfContours < 0) do {
                        flags = getUint16(code, i);
                        const glyphIndex = getUint16(code, i + 2);
                        i += 4;
                        let arg1, arg2;
                        if (flags & 0x01) {
                            if (flags & 0x02) {
                                arg1 = getInt16(code, i);
                                arg2 = getInt16(code, i + 2);
                            } else {
                                arg1 = getUint16(code, i);
                                arg2 = getUint16(code, i + 2);
                            }
                            i += 4;
                        } else if (flags & 0x02) {
                            arg1 = getInt8(code, i++);
                            arg2 = getInt8(code, i++);
                        } else {
                            arg1 = code[i++];
                            arg2 = code[i++];
                        }
                        if (flags & 0x02) {
                            x = arg1;
                            y = arg2;
                        } else {
                            x = 0;
                            y = 0;
                        }
                        let scaleX = 1, scaleY = 1, scale01 = 0, scale10 = 0;
                        if (flags & 0x08) {
                            scaleX = scaleY = getFloat214(code, i);
                            i += 2;
                        } else if (flags & 0x40) {
                            scaleX = getFloat214(code, i);
                            scaleY = getFloat214(code, i + 2);
                            i += 4;
                        } else if (flags & 0x80) {
                            scaleX = getFloat214(code, i);
                            scale01 = getFloat214(code, i + 2);
                            scale10 = getFloat214(code, i + 4);
                            scaleY = getFloat214(code, i + 6);
                            i += 8;
                        }
                        const subglyph = font1.glyphs[glyphIndex];
                        if (subglyph) {
                            cmds.push({
                                cmd: "save"
                            }, {
                                cmd: "transform",
                                args: [
                                    scaleX,
                                    scale01,
                                    scale10,
                                    scaleY,
                                    x,
                                    y
                                ]
                            });
                            flags;
                            compileGlyf(subglyph, cmds, font1);
                            cmds.push({
                                cmd: "restore"
                            });
                        }
                    }while (flags & 0x20);
                    else {
                        const endPtsOfContours = [];
                        let j, jj;
                        for(j = 0; j < numberOfContours; j++){
                            endPtsOfContours.push(getUint16(code, i));
                            i += 2;
                        }
                        const instructionLength = getUint16(code, i);
                        i += 2 + instructionLength;
                        const numberOfPoints = endPtsOfContours.at(-1) + 1;
                        const points = [];
                        while(points.length < numberOfPoints){
                            flags = code[i++];
                            let repeat = 1;
                            if (flags & 0x08) repeat += code[i++];
                            while(repeat-- > 0)points.push({
                                flags: flags
                            });
                        }
                        for(j = 0; j < numberOfPoints; j++){
                            switch(points[j].flags & 0x12){
                                case 0x00:
                                    x += getInt16(code, i);
                                    i += 2;
                                    break;
                                case 0x02:
                                    x -= code[i++];
                                    break;
                                case 0x12:
                                    x += code[i++];
                                    break;
                            }
                            points[j].x = x;
                        }
                        for(j = 0; j < numberOfPoints; j++){
                            switch(points[j].flags & 0x24){
                                case 0x00:
                                    y += getInt16(code, i);
                                    i += 2;
                                    break;
                                case 0x04:
                                    y -= code[i++];
                                    break;
                                case 0x24:
                                    y += code[i++];
                                    break;
                            }
                            points[j].y = y;
                        }
                        let startPoint = 0;
                        for(i = 0; i < numberOfContours; i++){
                            const endPoint = endPtsOfContours[i];
                            const contour = points.slice(startPoint, endPoint + 1);
                            if (contour[0].flags & 1) contour.push(contour[0]);
                            else if (contour.at(-1).flags & 1) contour.unshift(contour.at(-1));
                            else {
                                const p = {
                                    flags: 1,
                                    x: (contour[0].x + contour.at(-1).x) / 2,
                                    y: (contour[0].y + contour.at(-1).y) / 2
                                };
                                contour.unshift(p);
                                contour.push(p);
                            }
                            moveTo(contour[0].x, contour[0].y);
                            for(j = 1, jj = contour.length; j < jj; j++){
                                if (contour[j].flags & 1) lineTo(contour[j].x, contour[j].y);
                                else if (contour[j + 1].flags & 1) {
                                    quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
                                    j++;
                                } else quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
                            }
                            startPoint = endPoint + 1;
                        }
                    }
                }
                function compileCharString(charStringCode, cmds, font1, glyphId) {
                    function moveTo(x, y) {
                        cmds.push({
                            cmd: "moveTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function lineTo(x, y) {
                        cmds.push({
                            cmd: "lineTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function bezierCurveTo(x1, y1, x2, y2, x, y) {
                        cmds.push({
                            cmd: "bezierCurveTo",
                            args: [
                                x1,
                                y1,
                                x2,
                                y2,
                                x,
                                y
                            ]
                        });
                    }
                    const stack = [];
                    let x = 0, y = 0;
                    let stems = 0;
                    function parse(code) {
                        let i = 0;
                        while(i < code.length){
                            let stackClean = false;
                            let v = code[i++];
                            let xa, xb, ya, yb, y1, y2, y3, n, subrCode;
                            switch(v){
                                case 1:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 3:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 4:
                                    y += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 5:
                                    while(stack.length > 0){
                                        x += stack.shift();
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 6:
                                    while(stack.length > 0){
                                        x += stack.shift();
                                        lineTo(x, y);
                                        if (stack.length === 0) break;
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 7:
                                    while(stack.length > 0){
                                        y += stack.shift();
                                        lineTo(x, y);
                                        if (stack.length === 0) break;
                                        x += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 8:
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 10:
                                    n = stack.pop();
                                    subrCode = null;
                                    if (font1.isCFFCIDFont) {
                                        const fdIndex = font1.fdSelect.getFDIndex(glyphId);
                                        if (fdIndex >= 0 && fdIndex < font1.fdArray.length) {
                                            const fontDict = font1.fdArray[fdIndex];
                                            let subrs;
                                            if (fontDict.privateDict?.subrsIndex) subrs = fontDict.privateDict.subrsIndex.objects;
                                            if (subrs) {
                                                n += getSubroutineBias(subrs);
                                                subrCode = subrs[n];
                                            }
                                        } else (0, _util.warn)("Invalid fd index for glyph index.");
                                    } else subrCode = font1.subrs[n + font1.subrsBias];
                                    if (subrCode) parse(subrCode);
                                    break;
                                case 11:
                                    return;
                                case 12:
                                    v = code[i++];
                                    switch(v){
                                        case 34:
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            y1 = y + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y, xb, y1, x, y1);
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y1, xb, y, x, y);
                                            break;
                                        case 35:
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            stack.pop();
                                            break;
                                        case 36:
                                            xa = x + stack.shift();
                                            y1 = y + stack.shift();
                                            xb = xa + stack.shift();
                                            y2 = y1 + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y1, xb, y2, x, y2);
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            y3 = y2 + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y2, xb, y3, x, y);
                                            break;
                                        case 37:
                                            const x0 = x, y0 = y;
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb;
                                            y = yb;
                                            if (Math.abs(x - x0) > Math.abs(y - y0)) x += stack.shift();
                                            else y += stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            break;
                                        default:
                                            throw new _util.FormatError(`unknown operator: 12 ${v}`);
                                    }
                                    break;
                                case 14:
                                    if (stack.length >= 4) {
                                        const achar = stack.pop();
                                        const bchar = stack.pop();
                                        y = stack.pop();
                                        x = stack.pop();
                                        cmds.push({
                                            cmd: "save"
                                        }, {
                                            cmd: "translate",
                                            args: [
                                                x,
                                                y
                                            ]
                                        });
                                        let cmap = lookupCmap(font1.cmap, String.fromCharCode(font1.glyphNameMap[_encodings.StandardEncoding[achar]]));
                                        compileCharString(font1.glyphs[cmap.glyphId], cmds, font1, cmap.glyphId);
                                        cmds.push({
                                            cmd: "restore"
                                        });
                                        cmap = lookupCmap(font1.cmap, String.fromCharCode(font1.glyphNameMap[_encodings.StandardEncoding[bchar]]));
                                        compileCharString(font1.glyphs[cmap.glyphId], cmds, font1, cmap.glyphId);
                                    }
                                    return;
                                case 18:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 19:
                                    stems += stack.length >> 1;
                                    i += stems + 7 >> 3;
                                    stackClean = true;
                                    break;
                                case 20:
                                    stems += stack.length >> 1;
                                    i += stems + 7 >> 3;
                                    stackClean = true;
                                    break;
                                case 21:
                                    y += stack.pop();
                                    x += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 22:
                                    x += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 23:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 24:
                                    while(stack.length > 2){
                                        xa = x + stack.shift();
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    x += stack.shift();
                                    y += stack.shift();
                                    lineTo(x, y);
                                    break;
                                case 25:
                                    while(stack.length > 6){
                                        x += stack.shift();
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    xa = x + stack.shift();
                                    ya = y + stack.shift();
                                    xb = xa + stack.shift();
                                    yb = ya + stack.shift();
                                    x = xb + stack.shift();
                                    y = yb + stack.shift();
                                    bezierCurveTo(xa, ya, xb, yb, x, y);
                                    break;
                                case 26:
                                    if (stack.length % 2) x += stack.shift();
                                    while(stack.length > 0){
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb;
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 27:
                                    if (stack.length % 2) y += stack.shift();
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb;
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 28:
                                    stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
                                    i += 2;
                                    break;
                                case 29:
                                    n = stack.pop() + font1.gsubrsBias;
                                    subrCode = font1.gsubrs[n];
                                    if (subrCode) parse(subrCode);
                                    break;
                                case 30:
                                    while(stack.length > 0){
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                        if (stack.length === 0) break;
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        y = yb + stack.shift();
                                        x = xb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 31:
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        y = yb + stack.shift();
                                        x = xb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                        if (stack.length === 0) break;
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                default:
                                    if (v < 32) throw new _util.FormatError(`unknown operator: ${v}`);
                                    if (v < 247) stack.push(v - 139);
                                    else if (v < 251) stack.push((v - 247) * 256 + code[i++] + 108);
                                    else if (v < 255) stack.push(-(v - 251) * 256 - code[i++] - 108);
                                    else {
                                        stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
                                        i += 4;
                                    }
                                    break;
                            }
                            if (stackClean) stack.length = 0;
                        }
                    }
                    parse(charStringCode);
                }
                const NOOP = [];
                class CompiledFont {
                    constructor(fontMatrix){
                        if (this.constructor === CompiledFont) (0, _util.unreachable)("Cannot initialize CompiledFont.");
                        this.fontMatrix = fontMatrix;
                        this.compiledGlyphs = Object.create(null);
                        this.compiledCharCodeToGlyphId = Object.create(null);
                    }
                    getPathJs(unicode) {
                        const { charCode: charCode, glyphId: glyphId } = lookupCmap(this.cmap, unicode);
                        let fn = this.compiledGlyphs[glyphId];
                        if (!fn) try {
                            fn = this.compileGlyph(this.glyphs[glyphId], glyphId);
                            this.compiledGlyphs[glyphId] = fn;
                        } catch (ex) {
                            this.compiledGlyphs[glyphId] = NOOP;
                            if (this.compiledCharCodeToGlyphId[charCode] === undefined) this.compiledCharCodeToGlyphId[charCode] = glyphId;
                            throw ex;
                        }
                        if (this.compiledCharCodeToGlyphId[charCode] === undefined) this.compiledCharCodeToGlyphId[charCode] = glyphId;
                        return fn;
                    }
                    compileGlyph(code, glyphId) {
                        if (!code || code.length === 0 || code[0] === 14) return NOOP;
                        let fontMatrix = this.fontMatrix;
                        if (this.isCFFCIDFont) {
                            const fdIndex = this.fdSelect.getFDIndex(glyphId);
                            if (fdIndex >= 0 && fdIndex < this.fdArray.length) {
                                const fontDict = this.fdArray[fdIndex];
                                fontMatrix = fontDict.getByName("FontMatrix") || _util.FONT_IDENTITY_MATRIX;
                            } else (0, _util.warn)("Invalid fd index for glyph index.");
                        }
                        const cmds = [
                            {
                                cmd: "save"
                            },
                            {
                                cmd: "transform",
                                args: fontMatrix.slice()
                            },
                            {
                                cmd: "scale",
                                args: [
                                    "size",
                                    "-size"
                                ]
                            }
                        ];
                        this.compileGlyphImpl(code, cmds, glyphId);
                        cmds.push({
                            cmd: "restore"
                        });
                        return cmds;
                    }
                    compileGlyphImpl() {
                        (0, _util.unreachable)("Children classes should implement this.");
                    }
                    hasBuiltPath(unicode) {
                        const { charCode: charCode, glyphId: glyphId } = lookupCmap(this.cmap, unicode);
                        return this.compiledGlyphs[glyphId] !== undefined && this.compiledCharCodeToGlyphId[charCode] !== undefined;
                    }
                }
                class TrueTypeCompiled extends CompiledFont {
                    constructor(glyphs, cmap, fontMatrix){
                        super(fontMatrix || [
                            0.000488,
                            0,
                            0,
                            0.000488,
                            0,
                            0
                        ]);
                        this.glyphs = glyphs;
                        this.cmap = cmap;
                    }
                    compileGlyphImpl(code, cmds) {
                        compileGlyf(code, cmds, this);
                    }
                }
                class Type2Compiled extends CompiledFont {
                    constructor(cffInfo, cmap, fontMatrix, glyphNameMap){
                        super(fontMatrix || [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]);
                        this.glyphs = cffInfo.glyphs;
                        this.gsubrs = cffInfo.gsubrs || [];
                        this.subrs = cffInfo.subrs || [];
                        this.cmap = cmap;
                        this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
                        this.gsubrsBias = getSubroutineBias(this.gsubrs);
                        this.subrsBias = getSubroutineBias(this.subrs);
                        this.isCFFCIDFont = cffInfo.isCFFCIDFont;
                        this.fdSelect = cffInfo.fdSelect;
                        this.fdArray = cffInfo.fdArray;
                    }
                    compileGlyphImpl(code, cmds, glyphId) {
                        compileCharString(code, cmds, this, glyphId);
                    }
                }
                class FontRendererFactory {
                    static create(font1, seacAnalysisEnabled) {
                        const data = new Uint8Array(font1.data);
                        let cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
                        const numTables = getUint16(data, 4);
                        for(let i = 0, p = 12; i < numTables; i++, p += 16){
                            const tag = (0, _util.bytesToString)(data.subarray(p, p + 4));
                            const offset = getUint32(data, p + 8);
                            const length = getUint32(data, p + 12);
                            switch(tag){
                                case "cmap":
                                    cmap = parseCmap(data, offset, offset + length);
                                    break;
                                case "glyf":
                                    glyf = data.subarray(offset, offset + length);
                                    break;
                                case "loca":
                                    loca = data.subarray(offset, offset + length);
                                    break;
                                case "head":
                                    unitsPerEm = getUint16(data, offset + 18);
                                    indexToLocFormat = getUint16(data, offset + 50);
                                    break;
                                case "CFF ":
                                    cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
                                    break;
                            }
                        }
                        if (glyf) {
                            const fontMatrix = !unitsPerEm ? font1.fontMatrix : [
                                1 / unitsPerEm,
                                0,
                                0,
                                1 / unitsPerEm,
                                0,
                                0
                            ];
                            return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
                        }
                        return new Type2Compiled(cff, cmap, font1.fontMatrix, font1.glyphNameMap);
                    }
                }
                exports.FontRendererFactory = FontRendererFactory;
            /***/ },
            /* 45 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getMetrics = exports.getFontBasicMetrics = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                const getMetrics = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = 600;
                    t["Courier-Bold"] = 600;
                    t["Courier-BoldOblique"] = 600;
                    t["Courier-Oblique"] = 600;
                    t.Helvetica = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 278;
                        t.quotedbl = 355;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 667;
                        t.quoteright = 222;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 556;
                        t.at = 1015;
                        t.A = 667;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 500;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 278;
                        t.backslash = 278;
                        t.bracketright = 278;
                        t.asciicircum = 469;
                        t.underscore = 556;
                        t.quoteleft = 222;
                        t.a = 556;
                        t.b = 556;
                        t.c = 500;
                        t.d = 556;
                        t.e = 556;
                        t.f = 278;
                        t.g = 556;
                        t.h = 556;
                        t.i = 222;
                        t.j = 222;
                        t.k = 500;
                        t.l = 222;
                        t.m = 833;
                        t.n = 556;
                        t.o = 556;
                        t.p = 556;
                        t.q = 556;
                        t.r = 333;
                        t.s = 500;
                        t.t = 278;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 500;
                        t.braceleft = 334;
                        t.bar = 260;
                        t.braceright = 334;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 191;
                        t.quotedblleft = 333;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 537;
                        t.bullet = 350;
                        t.quotesinglbase = 222;
                        t.quotedblbase = 333;
                        t.quotedblright = 333;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 556;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 222;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 556;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 667;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 500;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 500;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 222;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 500;
                        t.scedilla = 500;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 556;
                        t.Amacron = 667;
                        t.rcaron = 333;
                        t.ccedilla = 500;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 643;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 584;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 500;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 260;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 333;
                        t.omacron = 556;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 222;
                        t.tcaron = 317;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 222;
                        t.Oacute = 778;
                        t.oacute = 556;
                        t.amacron = 556;
                        t.sacute = 500;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 556;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 299;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 556;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 556;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 556;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 556;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 556;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 556;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 500;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 584;
                        t.odieresis = 556;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 556;
                        t.eth = 556;
                        t.zcaron = 500;
                        t.ncommaaccent = 556;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 333;
                        t.quotedbl = 474;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 722;
                        t.quoteright = 278;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 611;
                        t.at = 975;
                        t.A = 722;
                        t.B = 722;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 556;
                        t.K = 722;
                        t.L = 611;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 584;
                        t.underscore = 556;
                        t.quoteleft = 278;
                        t.a = 556;
                        t.b = 611;
                        t.c = 556;
                        t.d = 611;
                        t.e = 556;
                        t.f = 333;
                        t.g = 611;
                        t.h = 611;
                        t.i = 278;
                        t.j = 278;
                        t.k = 556;
                        t.l = 278;
                        t.m = 889;
                        t.n = 611;
                        t.o = 611;
                        t.p = 611;
                        t.q = 611;
                        t.r = 389;
                        t.s = 556;
                        t.t = 333;
                        t.u = 611;
                        t.v = 556;
                        t.w = 778;
                        t.x = 556;
                        t.y = 556;
                        t.z = 500;
                        t.braceleft = 389;
                        t.bar = 280;
                        t.braceright = 389;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 238;
                        t.quotedblleft = 500;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 611;
                        t.fl = 611;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 556;
                        t.bullet = 350;
                        t.quotesinglbase = 278;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 611;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 611;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 722;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 556;
                        t.scommaaccent = 556;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 611;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 556;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 556;
                        t.scedilla = 556;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 611;
                        t.acircumflex = 556;
                        t.Amacron = 722;
                        t.rcaron = 389;
                        t.ccedilla = 556;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 743;
                        t.Umacron = 722;
                        t.uring = 611;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 584;
                        t.uacute = 611;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 556;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 556;
                        t.nacute = 611;
                        t.umacron = 611;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 280;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 611;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 389;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 611;
                        t.amacron = 556;
                        t.sacute = 556;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 611;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 611;
                        t.igrave = 278;
                        t.ohungarumlaut = 611;
                        t.Eogonek = 667;
                        t.dcroat = 611;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 400;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 611;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 611;
                        t.ntilde = 611;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 611;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 611;
                        t.Ccaron = 722;
                        t.ugrave = 611;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 611;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 556;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 611;
                        t.tcommaaccent = 333;
                        t.logicalnot = 584;
                        t.odieresis = 611;
                        t.udieresis = 611;
                        t.notequal = 549;
                        t.gcommaaccent = 611;
                        t.eth = 611;
                        t.zcaron = 500;
                        t.ncommaaccent = 611;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-BoldOblique"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 333;
                        t.quotedbl = 474;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 722;
                        t.quoteright = 278;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 611;
                        t.at = 975;
                        t.A = 722;
                        t.B = 722;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 556;
                        t.K = 722;
                        t.L = 611;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 584;
                        t.underscore = 556;
                        t.quoteleft = 278;
                        t.a = 556;
                        t.b = 611;
                        t.c = 556;
                        t.d = 611;
                        t.e = 556;
                        t.f = 333;
                        t.g = 611;
                        t.h = 611;
                        t.i = 278;
                        t.j = 278;
                        t.k = 556;
                        t.l = 278;
                        t.m = 889;
                        t.n = 611;
                        t.o = 611;
                        t.p = 611;
                        t.q = 611;
                        t.r = 389;
                        t.s = 556;
                        t.t = 333;
                        t.u = 611;
                        t.v = 556;
                        t.w = 778;
                        t.x = 556;
                        t.y = 556;
                        t.z = 500;
                        t.braceleft = 389;
                        t.bar = 280;
                        t.braceright = 389;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 238;
                        t.quotedblleft = 500;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 611;
                        t.fl = 611;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 556;
                        t.bullet = 350;
                        t.quotesinglbase = 278;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 611;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 611;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 722;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 556;
                        t.scommaaccent = 556;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 611;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 556;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 556;
                        t.scedilla = 556;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 611;
                        t.acircumflex = 556;
                        t.Amacron = 722;
                        t.rcaron = 389;
                        t.ccedilla = 556;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 743;
                        t.Umacron = 722;
                        t.uring = 611;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 584;
                        t.uacute = 611;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 556;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 556;
                        t.nacute = 611;
                        t.umacron = 611;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 280;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 611;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 389;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 611;
                        t.amacron = 556;
                        t.sacute = 556;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 611;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 611;
                        t.igrave = 278;
                        t.ohungarumlaut = 611;
                        t.Eogonek = 667;
                        t.dcroat = 611;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 400;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 611;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 611;
                        t.ntilde = 611;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 611;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 611;
                        t.Ccaron = 722;
                        t.ugrave = 611;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 611;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 556;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 611;
                        t.tcommaaccent = 333;
                        t.logicalnot = 584;
                        t.odieresis = 611;
                        t.udieresis = 611;
                        t.notequal = 549;
                        t.gcommaaccent = 611;
                        t.eth = 611;
                        t.zcaron = 500;
                        t.ncommaaccent = 611;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-Oblique"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 278;
                        t.quotedbl = 355;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 667;
                        t.quoteright = 222;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 556;
                        t.at = 1015;
                        t.A = 667;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 500;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 278;
                        t.backslash = 278;
                        t.bracketright = 278;
                        t.asciicircum = 469;
                        t.underscore = 556;
                        t.quoteleft = 222;
                        t.a = 556;
                        t.b = 556;
                        t.c = 500;
                        t.d = 556;
                        t.e = 556;
                        t.f = 278;
                        t.g = 556;
                        t.h = 556;
                        t.i = 222;
                        t.j = 222;
                        t.k = 500;
                        t.l = 222;
                        t.m = 833;
                        t.n = 556;
                        t.o = 556;
                        t.p = 556;
                        t.q = 556;
                        t.r = 333;
                        t.s = 500;
                        t.t = 278;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 500;
                        t.braceleft = 334;
                        t.bar = 260;
                        t.braceright = 334;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 191;
                        t.quotedblleft = 333;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 537;
                        t.bullet = 350;
                        t.quotesinglbase = 222;
                        t.quotedblbase = 333;
                        t.quotedblright = 333;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 556;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 222;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 556;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 667;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 500;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 500;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 222;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 500;
                        t.scedilla = 500;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 556;
                        t.Amacron = 667;
                        t.rcaron = 333;
                        t.ccedilla = 500;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 643;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 584;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 500;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 260;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 333;
                        t.omacron = 556;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 222;
                        t.tcaron = 317;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 222;
                        t.Oacute = 778;
                        t.oacute = 556;
                        t.amacron = 556;
                        t.sacute = 500;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 556;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 299;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 556;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 556;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 556;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 556;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 556;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 556;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 500;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 584;
                        t.odieresis = 556;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 556;
                        t.eth = 556;
                        t.zcaron = 500;
                        t.ncommaaccent = 556;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t.Symbol = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.universal = 713;
                        t.numbersign = 500;
                        t.existential = 549;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.suchthat = 439;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asteriskmath = 500;
                        t.plus = 549;
                        t.comma = 250;
                        t.minus = 549;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 549;
                        t.equal = 549;
                        t.greater = 549;
                        t.question = 444;
                        t.congruent = 549;
                        t.Alpha = 722;
                        t.Beta = 667;
                        t.Chi = 722;
                        t.Delta = 612;
                        t.Epsilon = 611;
                        t.Phi = 763;
                        t.Gamma = 603;
                        t.Eta = 722;
                        t.Iota = 333;
                        t.theta1 = 631;
                        t.Kappa = 722;
                        t.Lambda = 686;
                        t.Mu = 889;
                        t.Nu = 722;
                        t.Omicron = 722;
                        t.Pi = 768;
                        t.Theta = 741;
                        t.Rho = 556;
                        t.Sigma = 592;
                        t.Tau = 611;
                        t.Upsilon = 690;
                        t.sigma1 = 439;
                        t.Omega = 768;
                        t.Xi = 645;
                        t.Psi = 795;
                        t.Zeta = 611;
                        t.bracketleft = 333;
                        t.therefore = 863;
                        t.bracketright = 333;
                        t.perpendicular = 658;
                        t.underscore = 500;
                        t.radicalex = 500;
                        t.alpha = 631;
                        t.beta = 549;
                        t.chi = 549;
                        t.delta = 494;
                        t.epsilon = 439;
                        t.phi = 521;
                        t.gamma = 411;
                        t.eta = 603;
                        t.iota = 329;
                        t.phi1 = 603;
                        t.kappa = 549;
                        t.lambda = 549;
                        t.mu = 576;
                        t.nu = 521;
                        t.omicron = 549;
                        t.pi = 549;
                        t.theta = 521;
                        t.rho = 549;
                        t.sigma = 603;
                        t.tau = 439;
                        t.upsilon = 576;
                        t.omega1 = 713;
                        t.omega = 686;
                        t.xi = 493;
                        t.psi = 686;
                        t.zeta = 494;
                        t.braceleft = 480;
                        t.bar = 200;
                        t.braceright = 480;
                        t.similar = 549;
                        t.Euro = 750;
                        t.Upsilon1 = 620;
                        t.minute = 247;
                        t.lessequal = 549;
                        t.fraction = 167;
                        t.infinity = 713;
                        t.florin = 500;
                        t.club = 753;
                        t.diamond = 753;
                        t.heart = 753;
                        t.spade = 753;
                        t.arrowboth = 1042;
                        t.arrowleft = 987;
                        t.arrowup = 603;
                        t.arrowright = 987;
                        t.arrowdown = 603;
                        t.degree = 400;
                        t.plusminus = 549;
                        t.second = 411;
                        t.greaterequal = 549;
                        t.multiply = 549;
                        t.proportional = 713;
                        t.partialdiff = 494;
                        t.bullet = 460;
                        t.divide = 549;
                        t.notequal = 549;
                        t.equivalence = 549;
                        t.approxequal = 549;
                        t.ellipsis = 1000;
                        t.arrowvertex = 603;
                        t.arrowhorizex = 1000;
                        t.carriagereturn = 658;
                        t.aleph = 823;
                        t.Ifraktur = 686;
                        t.Rfraktur = 795;
                        t.weierstrass = 987;
                        t.circlemultiply = 768;
                        t.circleplus = 768;
                        t.emptyset = 823;
                        t.intersection = 768;
                        t.union = 768;
                        t.propersuperset = 713;
                        t.reflexsuperset = 713;
                        t.notsubset = 713;
                        t.propersubset = 713;
                        t.reflexsubset = 713;
                        t.element = 713;
                        t.notelement = 713;
                        t.angle = 768;
                        t.gradient = 713;
                        t.registerserif = 790;
                        t.copyrightserif = 790;
                        t.trademarkserif = 890;
                        t.product = 823;
                        t.radical = 549;
                        t.dotmath = 250;
                        t.logicalnot = 713;
                        t.logicaland = 603;
                        t.logicalor = 603;
                        t.arrowdblboth = 1042;
                        t.arrowdblleft = 987;
                        t.arrowdblup = 603;
                        t.arrowdblright = 987;
                        t.arrowdbldown = 603;
                        t.lozenge = 494;
                        t.angleleft = 329;
                        t.registersans = 790;
                        t.copyrightsans = 790;
                        t.trademarksans = 786;
                        t.summation = 713;
                        t.parenlefttp = 384;
                        t.parenleftex = 384;
                        t.parenleftbt = 384;
                        t.bracketlefttp = 384;
                        t.bracketleftex = 384;
                        t.bracketleftbt = 384;
                        t.bracelefttp = 494;
                        t.braceleftmid = 494;
                        t.braceleftbt = 494;
                        t.braceex = 494;
                        t.angleright = 329;
                        t.integral = 274;
                        t.integraltp = 686;
                        t.integralex = 686;
                        t.integralbt = 686;
                        t.parenrighttp = 384;
                        t.parenrightex = 384;
                        t.parenrightbt = 384;
                        t.bracketrighttp = 384;
                        t.bracketrightex = 384;
                        t.bracketrightbt = 384;
                        t.bracerighttp = 494;
                        t.bracerightmid = 494;
                        t.bracerightbt = 494;
                        t.apple = 790;
                    });
                    t["Times-Roman"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 408;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 564;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 564;
                        t.equal = 564;
                        t.greater = 564;
                        t.question = 444;
                        t.at = 921;
                        t.A = 722;
                        t.B = 667;
                        t.C = 667;
                        t.D = 722;
                        t.E = 611;
                        t.F = 556;
                        t.G = 722;
                        t.H = 722;
                        t.I = 333;
                        t.J = 389;
                        t.K = 722;
                        t.L = 611;
                        t.M = 889;
                        t.N = 722;
                        t.O = 722;
                        t.P = 556;
                        t.Q = 722;
                        t.R = 667;
                        t.S = 556;
                        t.T = 611;
                        t.U = 722;
                        t.V = 722;
                        t.W = 944;
                        t.X = 722;
                        t.Y = 722;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 469;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 444;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 500;
                        t.i = 278;
                        t.j = 278;
                        t.k = 500;
                        t.l = 278;
                        t.m = 778;
                        t.n = 500;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 333;
                        t.s = 389;
                        t.t = 278;
                        t.u = 500;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 444;
                        t.braceleft = 480;
                        t.bar = 200;
                        t.braceright = 480;
                        t.asciitilde = 541;
                        t.exclamdown = 333;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 180;
                        t.quotedblleft = 444;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 453;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 444;
                        t.quotedblright = 444;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 444;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 889;
                        t.ordfeminine = 276;
                        t.Lslash = 611;
                        t.Oslash = 722;
                        t.OE = 889;
                        t.ordmasculine = 310;
                        t.ae = 667;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 500;
                        t.Idieresis = 333;
                        t.eacute = 444;
                        t.abreve = 444;
                        t.uhungarumlaut = 500;
                        t.ecaron = 444;
                        t.Ydieresis = 722;
                        t.divide = 564;
                        t.Yacute = 722;
                        t.Acircumflex = 722;
                        t.aacute = 444;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 444;
                        t.Uacute = 722;
                        t.uogonek = 500;
                        t.Edieresis = 611;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 760;
                        t.Emacron = 611;
                        t.ccaron = 444;
                        t.aring = 444;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 444;
                        t.Tcommaaccent = 611;
                        t.Cacute = 667;
                        t.atilde = 444;
                        t.Edotaccent = 611;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 667;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 500;
                        t.acircumflex = 444;
                        t.Amacron = 722;
                        t.rcaron = 333;
                        t.ccedilla = 444;
                        t.Zdotaccent = 611;
                        t.Thorn = 556;
                        t.Omacron = 722;
                        t.Racute = 667;
                        t.Sacute = 556;
                        t.dcaron = 588;
                        t.Umacron = 722;
                        t.uring = 500;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 564;
                        t.uacute = 500;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 611;
                        t.adieresis = 444;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 500;
                        t.umacron = 500;
                        t.Ncaron = 722;
                        t.Iacute = 333;
                        t.plusminus = 564;
                        t.brokenbar = 200;
                        t.registered = 760;
                        t.Gbreve = 722;
                        t.Idotaccent = 333;
                        t.summation = 600;
                        t.Egrave = 611;
                        t.racute = 333;
                        t.omacron = 500;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 326;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 444;
                        t.zacute = 444;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 444;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 500;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 611;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 344;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 980;
                        t.edotaccent = 444;
                        t.Igrave = 333;
                        t.Imacron = 333;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 500;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 611;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 500;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 667;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 722;
                        t.zdotaccent = 444;
                        t.Ecaron = 611;
                        t.Iogonek = 333;
                        t.kcommaaccent = 500;
                        t.minus = 564;
                        t.Icircumflex = 333;
                        t.ncaron = 500;
                        t.tcommaaccent = 278;
                        t.logicalnot = 564;
                        t.odieresis = 500;
                        t.udieresis = 500;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 444;
                        t.ncommaaccent = 500;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 555;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 1000;
                        t.ampersand = 833;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 570;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 570;
                        t.equal = 570;
                        t.greater = 570;
                        t.question = 500;
                        t.at = 930;
                        t.A = 722;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 778;
                        t.I = 389;
                        t.J = 500;
                        t.K = 778;
                        t.L = 667;
                        t.M = 944;
                        t.N = 722;
                        t.O = 778;
                        t.P = 611;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 556;
                        t.T = 667;
                        t.U = 722;
                        t.V = 722;
                        t.W = 1000;
                        t.X = 722;
                        t.Y = 722;
                        t.Z = 667;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 581;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 556;
                        t.c = 444;
                        t.d = 556;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 556;
                        t.i = 278;
                        t.j = 333;
                        t.k = 556;
                        t.l = 278;
                        t.m = 833;
                        t.n = 556;
                        t.o = 500;
                        t.p = 556;
                        t.q = 556;
                        t.r = 444;
                        t.s = 389;
                        t.t = 333;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 444;
                        t.braceleft = 394;
                        t.bar = 220;
                        t.braceright = 394;
                        t.asciitilde = 520;
                        t.exclamdown = 333;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 278;
                        t.quotedblleft = 500;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 540;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 300;
                        t.Lslash = 667;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 330;
                        t.ae = 722;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 556;
                        t.Idieresis = 389;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 556;
                        t.ecaron = 444;
                        t.Ydieresis = 722;
                        t.divide = 570;
                        t.Yacute = 722;
                        t.Acircumflex = 722;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 747;
                        t.Emacron = 667;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 667;
                        t.Cacute = 722;
                        t.atilde = 500;
                        t.Edotaccent = 667;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 500;
                        t.Amacron = 722;
                        t.rcaron = 444;
                        t.ccedilla = 444;
                        t.Zdotaccent = 667;
                        t.Thorn = 611;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 556;
                        t.dcaron = 672;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 300;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 570;
                        t.uacute = 556;
                        t.Tcaron = 667;
                        t.partialdiff = 494;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 389;
                        t.plusminus = 570;
                        t.brokenbar = 220;
                        t.registered = 747;
                        t.Gbreve = 778;
                        t.Idotaccent = 389;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 444;
                        t.omacron = 500;
                        t.Zacute = 667;
                        t.Zcaron = 667;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 416;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 444;
                        t.zacute = 444;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 300;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 394;
                        t.Kcommaaccent = 778;
                        t.Lacute = 667;
                        t.trademark = 1000;
                        t.edotaccent = 444;
                        t.Igrave = 389;
                        t.Imacron = 389;
                        t.Lcaron = 667;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 444;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 667;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 444;
                        t.Ecaron = 667;
                        t.Iogonek = 389;
                        t.kcommaaccent = 556;
                        t.minus = 570;
                        t.Icircumflex = 389;
                        t.ncaron = 556;
                        t.tcommaaccent = 333;
                        t.logicalnot = 570;
                        t.odieresis = 500;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 444;
                        t.ncommaaccent = 556;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-BoldItalic"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 389;
                        t.quotedbl = 555;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 570;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 570;
                        t.equal = 570;
                        t.greater = 570;
                        t.question = 500;
                        t.at = 832;
                        t.A = 667;
                        t.B = 667;
                        t.C = 667;
                        t.D = 722;
                        t.E = 667;
                        t.F = 667;
                        t.G = 722;
                        t.H = 778;
                        t.I = 389;
                        t.J = 500;
                        t.K = 667;
                        t.L = 611;
                        t.M = 889;
                        t.N = 722;
                        t.O = 722;
                        t.P = 611;
                        t.Q = 722;
                        t.R = 667;
                        t.S = 556;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 889;
                        t.X = 667;
                        t.Y = 611;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 570;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 556;
                        t.i = 278;
                        t.j = 278;
                        t.k = 500;
                        t.l = 278;
                        t.m = 778;
                        t.n = 556;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 389;
                        t.s = 389;
                        t.t = 278;
                        t.u = 556;
                        t.v = 444;
                        t.w = 667;
                        t.x = 500;
                        t.y = 444;
                        t.z = 389;
                        t.braceleft = 348;
                        t.bar = 220;
                        t.braceright = 348;
                        t.asciitilde = 570;
                        t.exclamdown = 389;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 278;
                        t.quotedblleft = 500;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 500;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 944;
                        t.ordfeminine = 266;
                        t.Lslash = 611;
                        t.Oslash = 722;
                        t.OE = 944;
                        t.ordmasculine = 300;
                        t.ae = 722;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 500;
                        t.Idieresis = 389;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 556;
                        t.ecaron = 444;
                        t.Ydieresis = 611;
                        t.divide = 570;
                        t.Yacute = 611;
                        t.Acircumflex = 667;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 444;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 747;
                        t.Emacron = 667;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 611;
                        t.Cacute = 667;
                        t.atilde = 500;
                        t.Edotaccent = 667;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 667;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 556;
                        t.acircumflex = 500;
                        t.Amacron = 667;
                        t.rcaron = 389;
                        t.ccedilla = 444;
                        t.Zdotaccent = 611;
                        t.Thorn = 611;
                        t.Omacron = 722;
                        t.Racute = 667;
                        t.Sacute = 556;
                        t.dcaron = 608;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 570;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 444;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 389;
                        t.plusminus = 570;
                        t.brokenbar = 220;
                        t.registered = 747;
                        t.Gbreve = 722;
                        t.Idotaccent = 389;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 500;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 366;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 444;
                        t.zacute = 389;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 576;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 667;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 382;
                        t.Kcommaaccent = 667;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 444;
                        t.Igrave = 389;
                        t.Imacron = 389;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 556;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 667;
                        t.Lcommaaccent = 611;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 722;
                        t.zdotaccent = 389;
                        t.Ecaron = 667;
                        t.Iogonek = 389;
                        t.kcommaaccent = 500;
                        t.minus = 606;
                        t.Icircumflex = 389;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 606;
                        t.odieresis = 500;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 389;
                        t.ncommaaccent = 556;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-Italic"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 420;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 675;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 675;
                        t.equal = 675;
                        t.greater = 675;
                        t.question = 500;
                        t.at = 920;
                        t.A = 611;
                        t.B = 611;
                        t.C = 667;
                        t.D = 722;
                        t.E = 611;
                        t.F = 611;
                        t.G = 722;
                        t.H = 722;
                        t.I = 333;
                        t.J = 444;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 667;
                        t.O = 722;
                        t.P = 611;
                        t.Q = 722;
                        t.R = 611;
                        t.S = 500;
                        t.T = 556;
                        t.U = 722;
                        t.V = 611;
                        t.W = 833;
                        t.X = 611;
                        t.Y = 556;
                        t.Z = 556;
                        t.bracketleft = 389;
                        t.backslash = 278;
                        t.bracketright = 389;
                        t.asciicircum = 422;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 278;
                        t.g = 500;
                        t.h = 500;
                        t.i = 278;
                        t.j = 278;
                        t.k = 444;
                        t.l = 278;
                        t.m = 722;
                        t.n = 500;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 389;
                        t.s = 389;
                        t.t = 278;
                        t.u = 500;
                        t.v = 444;
                        t.w = 667;
                        t.x = 444;
                        t.y = 444;
                        t.z = 389;
                        t.braceleft = 400;
                        t.bar = 275;
                        t.braceright = 400;
                        t.asciitilde = 541;
                        t.exclamdown = 389;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 214;
                        t.quotedblleft = 556;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 523;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 556;
                        t.quotedblright = 556;
                        t.guillemotright = 500;
                        t.ellipsis = 889;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 889;
                        t.AE = 889;
                        t.ordfeminine = 276;
                        t.Lslash = 556;
                        t.Oslash = 722;
                        t.OE = 944;
                        t.ordmasculine = 310;
                        t.ae = 667;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 667;
                        t.germandbls = 500;
                        t.Idieresis = 333;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 500;
                        t.ecaron = 444;
                        t.Ydieresis = 556;
                        t.divide = 675;
                        t.Yacute = 556;
                        t.Acircumflex = 611;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 444;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 500;
                        t.Edieresis = 611;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 760;
                        t.Emacron = 611;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 667;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 556;
                        t.Cacute = 667;
                        t.atilde = 500;
                        t.Edotaccent = 611;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 611;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 500;
                        t.acircumflex = 500;
                        t.Amacron = 611;
                        t.rcaron = 389;
                        t.ccedilla = 444;
                        t.Zdotaccent = 556;
                        t.Thorn = 611;
                        t.Omacron = 722;
                        t.Racute = 611;
                        t.Sacute = 500;
                        t.dcaron = 544;
                        t.Umacron = 722;
                        t.uring = 500;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 611;
                        t.Abreve = 611;
                        t.multiply = 675;
                        t.uacute = 500;
                        t.Tcaron = 556;
                        t.partialdiff = 476;
                        t.ydieresis = 444;
                        t.Nacute = 667;
                        t.icircumflex = 278;
                        t.Ecircumflex = 611;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 500;
                        t.umacron = 500;
                        t.Ncaron = 667;
                        t.Iacute = 333;
                        t.plusminus = 675;
                        t.brokenbar = 275;
                        t.registered = 760;
                        t.Gbreve = 722;
                        t.Idotaccent = 333;
                        t.summation = 600;
                        t.Egrave = 611;
                        t.racute = 389;
                        t.omacron = 500;
                        t.Zacute = 556;
                        t.Zcaron = 556;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 300;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 611;
                        t.Adieresis = 611;
                        t.egrave = 444;
                        t.zacute = 389;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 500;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 611;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 500;
                        t.lcaron = 300;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 980;
                        t.edotaccent = 444;
                        t.Igrave = 333;
                        t.Imacron = 333;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 500;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 611;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 500;
                        t.Scommaaccent = 500;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 500;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 667;
                        t.otilde = 500;
                        t.Rcommaaccent = 611;
                        t.Lcommaaccent = 556;
                        t.Atilde = 611;
                        t.Aogonek = 611;
                        t.Aring = 611;
                        t.Otilde = 722;
                        t.zdotaccent = 389;
                        t.Ecaron = 611;
                        t.Iogonek = 333;
                        t.kcommaaccent = 444;
                        t.minus = 675;
                        t.Icircumflex = 333;
                        t.ncaron = 500;
                        t.tcommaaccent = 278;
                        t.logicalnot = 675;
                        t.odieresis = 500;
                        t.udieresis = 500;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 389;
                        t.ncommaaccent = 500;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t.ZapfDingbats = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.a1 = 974;
                        t.a2 = 961;
                        t.a202 = 974;
                        t.a3 = 980;
                        t.a4 = 719;
                        t.a5 = 789;
                        t.a119 = 790;
                        t.a118 = 791;
                        t.a117 = 690;
                        t.a11 = 960;
                        t.a12 = 939;
                        t.a13 = 549;
                        t.a14 = 855;
                        t.a15 = 911;
                        t.a16 = 933;
                        t.a105 = 911;
                        t.a17 = 945;
                        t.a18 = 974;
                        t.a19 = 755;
                        t.a20 = 846;
                        t.a21 = 762;
                        t.a22 = 761;
                        t.a23 = 571;
                        t.a24 = 677;
                        t.a25 = 763;
                        t.a26 = 760;
                        t.a27 = 759;
                        t.a28 = 754;
                        t.a6 = 494;
                        t.a7 = 552;
                        t.a8 = 537;
                        t.a9 = 577;
                        t.a10 = 692;
                        t.a29 = 786;
                        t.a30 = 788;
                        t.a31 = 788;
                        t.a32 = 790;
                        t.a33 = 793;
                        t.a34 = 794;
                        t.a35 = 816;
                        t.a36 = 823;
                        t.a37 = 789;
                        t.a38 = 841;
                        t.a39 = 823;
                        t.a40 = 833;
                        t.a41 = 816;
                        t.a42 = 831;
                        t.a43 = 923;
                        t.a44 = 744;
                        t.a45 = 723;
                        t.a46 = 749;
                        t.a47 = 790;
                        t.a48 = 792;
                        t.a49 = 695;
                        t.a50 = 776;
                        t.a51 = 768;
                        t.a52 = 792;
                        t.a53 = 759;
                        t.a54 = 707;
                        t.a55 = 708;
                        t.a56 = 682;
                        t.a57 = 701;
                        t.a58 = 826;
                        t.a59 = 815;
                        t.a60 = 789;
                        t.a61 = 789;
                        t.a62 = 707;
                        t.a63 = 687;
                        t.a64 = 696;
                        t.a65 = 689;
                        t.a66 = 786;
                        t.a67 = 787;
                        t.a68 = 713;
                        t.a69 = 791;
                        t.a70 = 785;
                        t.a71 = 791;
                        t.a72 = 873;
                        t.a73 = 761;
                        t.a74 = 762;
                        t.a203 = 762;
                        t.a75 = 759;
                        t.a204 = 759;
                        t.a76 = 892;
                        t.a77 = 892;
                        t.a78 = 788;
                        t.a79 = 784;
                        t.a81 = 438;
                        t.a82 = 138;
                        t.a83 = 277;
                        t.a84 = 415;
                        t.a97 = 392;
                        t.a98 = 392;
                        t.a99 = 668;
                        t.a100 = 668;
                        t.a89 = 390;
                        t.a90 = 390;
                        t.a93 = 317;
                        t.a94 = 317;
                        t.a91 = 276;
                        t.a92 = 276;
                        t.a205 = 509;
                        t.a85 = 509;
                        t.a206 = 410;
                        t.a86 = 410;
                        t.a87 = 234;
                        t.a88 = 234;
                        t.a95 = 334;
                        t.a96 = 334;
                        t.a101 = 732;
                        t.a102 = 544;
                        t.a103 = 544;
                        t.a104 = 910;
                        t.a106 = 667;
                        t.a107 = 760;
                        t.a108 = 760;
                        t.a112 = 776;
                        t.a111 = 595;
                        t.a110 = 694;
                        t.a109 = 626;
                        t.a120 = 788;
                        t.a121 = 788;
                        t.a122 = 788;
                        t.a123 = 788;
                        t.a124 = 788;
                        t.a125 = 788;
                        t.a126 = 788;
                        t.a127 = 788;
                        t.a128 = 788;
                        t.a129 = 788;
                        t.a130 = 788;
                        t.a131 = 788;
                        t.a132 = 788;
                        t.a133 = 788;
                        t.a134 = 788;
                        t.a135 = 788;
                        t.a136 = 788;
                        t.a137 = 788;
                        t.a138 = 788;
                        t.a139 = 788;
                        t.a140 = 788;
                        t.a141 = 788;
                        t.a142 = 788;
                        t.a143 = 788;
                        t.a144 = 788;
                        t.a145 = 788;
                        t.a146 = 788;
                        t.a147 = 788;
                        t.a148 = 788;
                        t.a149 = 788;
                        t.a150 = 788;
                        t.a151 = 788;
                        t.a152 = 788;
                        t.a153 = 788;
                        t.a154 = 788;
                        t.a155 = 788;
                        t.a156 = 788;
                        t.a157 = 788;
                        t.a158 = 788;
                        t.a159 = 788;
                        t.a160 = 894;
                        t.a161 = 838;
                        t.a163 = 1016;
                        t.a164 = 458;
                        t.a196 = 748;
                        t.a165 = 924;
                        t.a192 = 748;
                        t.a166 = 918;
                        t.a167 = 927;
                        t.a168 = 928;
                        t.a169 = 928;
                        t.a170 = 834;
                        t.a171 = 873;
                        t.a172 = 828;
                        t.a173 = 924;
                        t.a162 = 924;
                        t.a174 = 917;
                        t.a175 = 930;
                        t.a176 = 931;
                        t.a177 = 463;
                        t.a178 = 883;
                        t.a179 = 836;
                        t.a193 = 836;
                        t.a180 = 867;
                        t.a199 = 867;
                        t.a181 = 696;
                        t.a200 = 696;
                        t.a182 = 874;
                        t.a201 = 874;
                        t.a183 = 760;
                        t.a184 = 946;
                        t.a197 = 771;
                        t.a185 = 865;
                        t.a194 = 771;
                        t.a198 = 888;
                        t.a186 = 967;
                        t.a195 = 888;
                        t.a187 = 831;
                        t.a188 = 873;
                        t.a189 = 927;
                        t.a190 = 970;
                        t.a191 = 918;
                    });
                });
                exports.getMetrics = getMetrics;
                const getFontBasicMetrics = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: -426
                    };
                    t["Courier-Bold"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 439
                    };
                    t["Courier-Oblique"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 426
                    };
                    t["Courier-BoldOblique"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 426
                    };
                    t.Helvetica = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 523
                    };
                    t["Helvetica-Bold"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 532
                    };
                    t["Helvetica-Oblique"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 523
                    };
                    t["Helvetica-BoldOblique"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 532
                    };
                    t["Times-Roman"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 662,
                        xHeight: 450
                    };
                    t["Times-Bold"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 676,
                        xHeight: 461
                    };
                    t["Times-Italic"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 653,
                        xHeight: 441
                    };
                    t["Times-BoldItalic"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 669,
                        xHeight: 462
                    };
                    t.Symbol = {
                        ascent: Math.NaN,
                        descent: Math.NaN,
                        capHeight: Math.NaN,
                        xHeight: Math.NaN
                    };
                    t.ZapfDingbats = {
                        ascent: Math.NaN,
                        descent: Math.NaN,
                        capHeight: Math.NaN,
                        xHeight: Math.NaN
                    };
                });
                exports.getFontBasicMetrics = getFontBasicMetrics;
            /***/ },
            /* 46 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlyfTable = void 0;
                const ON_CURVE_POINT = 1;
                const X_SHORT_VECTOR = 2;
                const Y_SHORT_VECTOR = 4;
                const REPEAT_FLAG = 8;
                const X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR = 16;
                const Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR = 32;
                const OVERLAP_SIMPLE = 64;
                const ARG_1_AND_2_ARE_WORDS = 1;
                const ARGS_ARE_XY_VALUES = 2;
                const WE_HAVE_A_SCALE = 8;
                const MORE_COMPONENTS = 32;
                const WE_HAVE_AN_X_AND_Y_SCALE = 64;
                const WE_HAVE_A_TWO_BY_TWO = 128;
                const WE_HAVE_INSTRUCTIONS = 256;
                class GlyfTable {
                    constructor({ glyfTable: glyfTable, isGlyphLocationsLong: isGlyphLocationsLong, locaTable: locaTable, numGlyphs: numGlyphs }){
                        this.glyphs = [];
                        const loca = new DataView(locaTable.buffer, locaTable.byteOffset, locaTable.byteLength);
                        const glyf = new DataView(glyfTable.buffer, glyfTable.byteOffset, glyfTable.byteLength);
                        const offsetSize = isGlyphLocationsLong ? 4 : 2;
                        let prev = isGlyphLocationsLong ? loca.getUint32(0) : 2 * loca.getUint16(0);
                        let pos = 0;
                        for(let i = 0; i < numGlyphs; i++){
                            pos += offsetSize;
                            const next = isGlyphLocationsLong ? loca.getUint32(pos) : 2 * loca.getUint16(pos);
                            if (next === prev) {
                                this.glyphs.push(new Glyph({}));
                                continue;
                            }
                            const glyph = Glyph.parse(prev, glyf);
                            this.glyphs.push(glyph);
                            prev = next;
                        }
                    }
                    getSize() {
                        return this.glyphs.reduce((a, g)=>{
                            const size = g.getSize();
                            return a + (size + 3 & -4);
                        }, 0);
                    }
                    write() {
                        const totalSize = this.getSize();
                        const glyfTable = new DataView(new ArrayBuffer(totalSize));
                        const isLocationLong = totalSize > 0x1fffe;
                        const offsetSize = isLocationLong ? 4 : 2;
                        const locaTable = new DataView(new ArrayBuffer((this.glyphs.length + 1) * offsetSize));
                        if (isLocationLong) locaTable.setUint32(0, 0);
                        else locaTable.setUint16(0, 0);
                        let pos = 0;
                        let locaIndex = 0;
                        for (const glyph of this.glyphs){
                            pos += glyph.write(pos, glyfTable);
                            pos = pos + 3 & -4;
                            locaIndex += offsetSize;
                            if (isLocationLong) locaTable.setUint32(locaIndex, pos);
                            else locaTable.setUint16(locaIndex, pos >> 1);
                        }
                        return {
                            isLocationLong: isLocationLong,
                            loca: new Uint8Array(locaTable.buffer),
                            glyf: new Uint8Array(glyfTable.buffer)
                        };
                    }
                    scale(factors) {
                        for(let i = 0, ii = this.glyphs.length; i < ii; i++)this.glyphs[i].scale(factors[i]);
                    }
                }
                exports.GlyfTable = GlyfTable;
                class Glyph {
                    constructor({ header: header = null, simple: simple = null, composites: composites = null }){
                        this.header = header;
                        this.simple = simple;
                        this.composites = composites;
                    }
                    static parse(pos, glyf) {
                        const [read, header] = GlyphHeader.parse(pos, glyf);
                        pos += read;
                        if (header.numberOfContours < 0) {
                            const composites = [];
                            while(true){
                                const [n, composite] = CompositeGlyph.parse(pos, glyf);
                                pos += n;
                                composites.push(composite);
                                if (!(composite.flags & MORE_COMPONENTS)) break;
                            }
                            return new Glyph({
                                header: header,
                                composites: composites
                            });
                        }
                        const simple = SimpleGlyph.parse(pos, glyf, header.numberOfContours);
                        return new Glyph({
                            header: header,
                            simple: simple
                        });
                    }
                    getSize() {
                        if (!this.header) return 0;
                        const size = this.simple ? this.simple.getSize() : this.composites.reduce((a, c)=>a + c.getSize(), 0);
                        return this.header.getSize() + size;
                    }
                    write(pos, buf) {
                        if (!this.header) return 0;
                        const spos = pos;
                        pos += this.header.write(pos, buf);
                        if (this.simple) pos += this.simple.write(pos, buf);
                        else for (const composite of this.composites)pos += composite.write(pos, buf);
                        return pos - spos;
                    }
                    scale(factor) {
                        if (!this.header) return;
                        const xMiddle = (this.header.xMin + this.header.xMax) / 2;
                        this.header.scale(xMiddle, factor);
                        if (this.simple) this.simple.scale(xMiddle, factor);
                        else for (const composite of this.composites)composite.scale(xMiddle, factor);
                    }
                }
                class GlyphHeader {
                    constructor({ numberOfContours: numberOfContours, xMin: xMin, yMin: yMin, xMax: xMax, yMax: yMax }){
                        this.numberOfContours = numberOfContours;
                        this.xMin = xMin;
                        this.yMin = yMin;
                        this.xMax = xMax;
                        this.yMax = yMax;
                    }
                    static parse(pos, glyf) {
                        return [
                            10,
                            new GlyphHeader({
                                numberOfContours: glyf.getInt16(pos),
                                xMin: glyf.getInt16(pos + 2),
                                yMin: glyf.getInt16(pos + 4),
                                xMax: glyf.getInt16(pos + 6),
                                yMax: glyf.getInt16(pos + 8)
                            })
                        ];
                    }
                    getSize() {
                        return 10;
                    }
                    write(pos, buf) {
                        buf.setInt16(pos, this.numberOfContours);
                        buf.setInt16(pos + 2, this.xMin);
                        buf.setInt16(pos + 4, this.yMin);
                        buf.setInt16(pos + 6, this.xMax);
                        buf.setInt16(pos + 8, this.yMax);
                        return 10;
                    }
                    scale(x, factor) {
                        this.xMin = Math.round(x + (this.xMin - x) * factor);
                        this.xMax = Math.round(x + (this.xMax - x) * factor);
                    }
                }
                class Contour {
                    constructor({ flags: flags, xCoordinates: xCoordinates, yCoordinates: yCoordinates }){
                        this.xCoordinates = xCoordinates;
                        this.yCoordinates = yCoordinates;
                        this.flags = flags;
                    }
                }
                class SimpleGlyph {
                    constructor({ contours: contours, instructions: instructions }){
                        this.contours = contours;
                        this.instructions = instructions;
                    }
                    static parse(pos, glyf, numberOfContours) {
                        const endPtsOfContours = [];
                        for(let i = 0; i < numberOfContours; i++){
                            const endPt = glyf.getUint16(pos);
                            pos += 2;
                            endPtsOfContours.push(endPt);
                        }
                        const numberOfPt = endPtsOfContours[numberOfContours - 1] + 1;
                        const instructionLength = glyf.getUint16(pos);
                        pos += 2;
                        const instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                        pos += instructionLength;
                        const flags = [];
                        for(let i = 0; i < numberOfPt; pos++, i++){
                            let flag = glyf.getUint8(pos);
                            flags.push(flag);
                            if (flag & REPEAT_FLAG) {
                                const count = glyf.getUint8(++pos);
                                flag ^= REPEAT_FLAG;
                                for(let m = 0; m < count; m++)flags.push(flag);
                                i += count;
                            }
                        }
                        const allXCoordinates = [];
                        let xCoordinates = [];
                        let yCoordinates = [];
                        let pointFlags = [];
                        const contours = [];
                        let endPtsOfContoursIndex = 0;
                        let lastCoordinate = 0;
                        for(let i = 0; i < numberOfPt; i++){
                            const flag = flags[i];
                            if (flag & X_SHORT_VECTOR) {
                                const x = glyf.getUint8(pos++);
                                lastCoordinate += flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR ? x : -x;
                                xCoordinates.push(lastCoordinate);
                            } else if (flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR) xCoordinates.push(lastCoordinate);
                            else {
                                lastCoordinate += glyf.getInt16(pos);
                                pos += 2;
                                xCoordinates.push(lastCoordinate);
                            }
                            if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                                endPtsOfContoursIndex++;
                                allXCoordinates.push(xCoordinates);
                                xCoordinates = [];
                            }
                        }
                        lastCoordinate = 0;
                        endPtsOfContoursIndex = 0;
                        for(let i = 0; i < numberOfPt; i++){
                            const flag = flags[i];
                            if (flag & Y_SHORT_VECTOR) {
                                const y = glyf.getUint8(pos++);
                                lastCoordinate += flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR ? y : -y;
                                yCoordinates.push(lastCoordinate);
                            } else if (flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR) yCoordinates.push(lastCoordinate);
                            else {
                                lastCoordinate += glyf.getInt16(pos);
                                pos += 2;
                                yCoordinates.push(lastCoordinate);
                            }
                            pointFlags.push(flag & ON_CURVE_POINT | flag & OVERLAP_SIMPLE);
                            if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                                xCoordinates = allXCoordinates[endPtsOfContoursIndex];
                                endPtsOfContoursIndex++;
                                contours.push(new Contour({
                                    flags: pointFlags,
                                    xCoordinates: xCoordinates,
                                    yCoordinates: yCoordinates
                                }));
                                yCoordinates = [];
                                pointFlags = [];
                            }
                        }
                        return new SimpleGlyph({
                            contours: contours,
                            instructions: instructions
                        });
                    }
                    getSize() {
                        let size = this.contours.length * 2 + 2 + this.instructions.length;
                        let lastX = 0;
                        let lastY = 0;
                        for (const contour of this.contours){
                            size += contour.flags.length;
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++){
                                const x = contour.xCoordinates[i];
                                const y = contour.yCoordinates[i];
                                let abs = Math.abs(x - lastX);
                                if (abs > 255) size += 2;
                                else if (abs > 0) size += 1;
                                lastX = x;
                                abs = Math.abs(y - lastY);
                                if (abs > 255) size += 2;
                                else if (abs > 0) size += 1;
                                lastY = y;
                            }
                        }
                        return size;
                    }
                    write(pos, buf) {
                        const spos = pos;
                        const xCoordinates = [];
                        const yCoordinates = [];
                        const flags = [];
                        let lastX = 0;
                        let lastY = 0;
                        for (const contour of this.contours){
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++){
                                let flag = contour.flags[i];
                                const x = contour.xCoordinates[i];
                                let delta = x - lastX;
                                if (delta === 0) {
                                    flag |= X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR;
                                    xCoordinates.push(0);
                                } else {
                                    const abs = Math.abs(delta);
                                    if (abs <= 255) {
                                        flag |= delta >= 0 ? X_SHORT_VECTOR | X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR : X_SHORT_VECTOR;
                                        xCoordinates.push(abs);
                                    } else xCoordinates.push(delta);
                                }
                                lastX = x;
                                const y = contour.yCoordinates[i];
                                delta = y - lastY;
                                if (delta === 0) {
                                    flag |= Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR;
                                    yCoordinates.push(0);
                                } else {
                                    const abs = Math.abs(delta);
                                    if (abs <= 255) {
                                        flag |= delta >= 0 ? Y_SHORT_VECTOR | Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR : Y_SHORT_VECTOR;
                                        yCoordinates.push(abs);
                                    } else yCoordinates.push(delta);
                                }
                                lastY = y;
                                flags.push(flag);
                            }
                            buf.setUint16(pos, xCoordinates.length - 1);
                            pos += 2;
                        }
                        buf.setUint16(pos, this.instructions.length);
                        pos += 2;
                        if (this.instructions.length) {
                            new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                            pos += this.instructions.length;
                        }
                        for (const flag of flags)buf.setUint8(pos++, flag);
                        for(let i = 0, ii = xCoordinates.length; i < ii; i++){
                            const x = xCoordinates[i];
                            const flag = flags[i];
                            if (flag & X_SHORT_VECTOR) buf.setUint8(pos++, x);
                            else if (!(flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR)) {
                                buf.setInt16(pos, x);
                                pos += 2;
                            }
                        }
                        for(let i = 0, ii = yCoordinates.length; i < ii; i++){
                            const y = yCoordinates[i];
                            const flag = flags[i];
                            if (flag & Y_SHORT_VECTOR) buf.setUint8(pos++, y);
                            else if (!(flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR)) {
                                buf.setInt16(pos, y);
                                pos += 2;
                            }
                        }
                        return pos - spos;
                    }
                    scale(x, factor) {
                        for (const contour of this.contours){
                            if (contour.xCoordinates.length === 0) continue;
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++)contour.xCoordinates[i] = Math.round(x + (contour.xCoordinates[i] - x) * factor);
                        }
                    }
                }
                class CompositeGlyph {
                    constructor({ flags: flags, glyphIndex: glyphIndex, argument1: argument1, argument2: argument2, transf: transf, instructions: instructions }){
                        this.flags = flags;
                        this.glyphIndex = glyphIndex;
                        this.argument1 = argument1;
                        this.argument2 = argument2;
                        this.transf = transf;
                        this.instructions = instructions;
                    }
                    static parse(pos, glyf) {
                        const spos = pos;
                        const transf = [];
                        let flags = glyf.getUint16(pos);
                        const glyphIndex = glyf.getUint16(pos + 2);
                        pos += 4;
                        let argument1, argument2;
                        if (flags & ARG_1_AND_2_ARE_WORDS) {
                            if (flags & ARGS_ARE_XY_VALUES) {
                                argument1 = glyf.getInt16(pos);
                                argument2 = glyf.getInt16(pos + 2);
                            } else {
                                argument1 = glyf.getUint16(pos);
                                argument2 = glyf.getUint16(pos + 2);
                            }
                            pos += 4;
                            flags ^= ARG_1_AND_2_ARE_WORDS;
                        } else {
                            if (flags & ARGS_ARE_XY_VALUES) {
                                argument1 = glyf.getInt8(pos);
                                argument2 = glyf.getInt8(pos + 1);
                            } else {
                                argument1 = glyf.getUint8(pos);
                                argument2 = glyf.getUint8(pos + 1);
                            }
                            pos += 2;
                        }
                        if (flags & WE_HAVE_A_SCALE) {
                            transf.push(glyf.getUint16(pos));
                            pos += 2;
                        } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                            transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2));
                            pos += 4;
                        } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                            transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2), glyf.getUint16(pos + 4), glyf.getUint16(pos + 6));
                            pos += 8;
                        }
                        let instructions = null;
                        if (flags & WE_HAVE_INSTRUCTIONS) {
                            const instructionLength = glyf.getUint16(pos);
                            pos += 2;
                            instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                            pos += instructionLength;
                        }
                        return [
                            pos - spos,
                            new CompositeGlyph({
                                flags: flags,
                                glyphIndex: glyphIndex,
                                argument1: argument1,
                                argument2: argument2,
                                transf: transf,
                                instructions: instructions
                            })
                        ];
                    }
                    getSize() {
                        let size = 4 + this.transf.length * 2;
                        if (this.flags & WE_HAVE_INSTRUCTIONS) size += 2 + this.instructions.length;
                        size += 2;
                        if (this.flags & 2) {
                            if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) size += 2;
                        } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) size += 2;
                        return size;
                    }
                    write(pos, buf) {
                        const spos = pos;
                        if (this.flags & ARGS_ARE_XY_VALUES) {
                            if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) this.flags |= ARG_1_AND_2_ARE_WORDS;
                        } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) this.flags |= ARG_1_AND_2_ARE_WORDS;
                        buf.setUint16(pos, this.flags);
                        buf.setUint16(pos + 2, this.glyphIndex);
                        pos += 4;
                        if (this.flags & ARG_1_AND_2_ARE_WORDS) {
                            if (this.flags & ARGS_ARE_XY_VALUES) {
                                buf.setInt16(pos, this.argument1);
                                buf.setInt16(pos + 2, this.argument2);
                            } else {
                                buf.setUint16(pos, this.argument1);
                                buf.setUint16(pos + 2, this.argument2);
                            }
                            pos += 4;
                        } else {
                            buf.setUint8(pos, this.argument1);
                            buf.setUint8(pos + 1, this.argument2);
                            pos += 2;
                        }
                        if (this.flags & WE_HAVE_INSTRUCTIONS) {
                            buf.setUint16(pos, this.instructions.length);
                            pos += 2;
                            if (this.instructions.length) {
                                new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                                pos += this.instructions.length;
                            }
                        }
                        return pos - spos;
                    }
                    scale(x, factor) {}
                }
            /***/ },
            /* 47 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OpenTypeFileBuilder = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                function writeInt16(dest, offset, num) {
                    dest[offset] = num >> 8 & 0xff;
                    dest[offset + 1] = num & 0xff;
                }
                function writeInt32(dest, offset, num) {
                    dest[offset] = num >> 24 & 0xff;
                    dest[offset + 1] = num >> 16 & 0xff;
                    dest[offset + 2] = num >> 8 & 0xff;
                    dest[offset + 3] = num & 0xff;
                }
                function writeData(dest, offset, data) {
                    if (data instanceof Uint8Array) dest.set(data, offset);
                    else if (typeof data === "string") for(let i = 0, ii = data.length; i < ii; i++)dest[offset++] = data.charCodeAt(i) & 0xff;
                    else for (const num of data)dest[offset++] = num & 0xff;
                }
                const OTF_HEADER_SIZE = 12;
                const OTF_TABLE_ENTRY_SIZE = 16;
                class OpenTypeFileBuilder {
                    constructor(sfnt){
                        this.sfnt = sfnt;
                        this.tables = Object.create(null);
                    }
                    static getSearchParams(entriesCount, entrySize) {
                        let maxPower2 = 1, log2 = 0;
                        while((maxPower2 ^ entriesCount) > maxPower2){
                            maxPower2 <<= 1;
                            log2++;
                        }
                        const searchRange = maxPower2 * entrySize;
                        return {
                            range: searchRange,
                            entry: log2,
                            rangeShift: entrySize * entriesCount - searchRange
                        };
                    }
                    toArray() {
                        let sfnt = this.sfnt;
                        const tables = this.tables;
                        const tablesNames = Object.keys(tables);
                        tablesNames.sort();
                        const numTables = tablesNames.length;
                        let i, j, jj, table, tableName;
                        let offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
                        const tableOffsets = [
                            offset
                        ];
                        for(i = 0; i < numTables; i++){
                            table = tables[tablesNames[i]];
                            const paddedLength = (table.length + 3 & -4) >>> 0;
                            offset += paddedLength;
                            tableOffsets.push(offset);
                        }
                        const file = new Uint8Array(offset);
                        for(i = 0; i < numTables; i++){
                            table = tables[tablesNames[i]];
                            writeData(file, tableOffsets[i], table);
                        }
                        if (sfnt === "true") sfnt = (0, _util.string32)(0x00010000);
                        file[0] = sfnt.charCodeAt(0) & 0xff;
                        file[1] = sfnt.charCodeAt(1) & 0xff;
                        file[2] = sfnt.charCodeAt(2) & 0xff;
                        file[3] = sfnt.charCodeAt(3) & 0xff;
                        writeInt16(file, 4, numTables);
                        const searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
                        writeInt16(file, 6, searchParams.range);
                        writeInt16(file, 8, searchParams.entry);
                        writeInt16(file, 10, searchParams.rangeShift);
                        offset = OTF_HEADER_SIZE;
                        for(i = 0; i < numTables; i++){
                            tableName = tablesNames[i];
                            file[offset] = tableName.charCodeAt(0) & 0xff;
                            file[offset + 1] = tableName.charCodeAt(1) & 0xff;
                            file[offset + 2] = tableName.charCodeAt(2) & 0xff;
                            file[offset + 3] = tableName.charCodeAt(3) & 0xff;
                            let checksum = 0;
                            for(j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4){
                                const quad = (0, _core_utils.readUint32)(file, j);
                                checksum = checksum + quad >>> 0;
                            }
                            writeInt32(file, offset + 4, checksum);
                            writeInt32(file, offset + 8, tableOffsets[i]);
                            writeInt32(file, offset + 12, tables[tableName].length);
                            offset += OTF_TABLE_ENTRY_SIZE;
                        }
                        return file;
                    }
                    addTable(tag, data) {
                        if (tag in this.tables) throw new Error("Table " + tag + " already exists");
                        this.tables[tag] = data;
                    }
                }
                exports.OpenTypeFileBuilder = OpenTypeFileBuilder;
            /***/ },
            /* 48 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Type1Font = void 0;
                var _cff_parser = __w_pdfjs_require__(35);
                var _util = __w_pdfjs_require__(2);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _type1_parser = __w_pdfjs_require__(49);
                function findBlock(streamBytes, signature, startIndex) {
                    const streamBytesLength = streamBytes.length;
                    const signatureLength = signature.length;
                    const scanLength = streamBytesLength - signatureLength;
                    let i = startIndex, found = false;
                    while(i < scanLength){
                        let j = 0;
                        while(j < signatureLength && streamBytes[i + j] === signature[j])j++;
                        if (j >= signatureLength) {
                            i += j;
                            while(i < streamBytesLength && (0, _core_utils.isWhiteSpace)(streamBytes[i]))i++;
                            found = true;
                            break;
                        }
                        i++;
                    }
                    return {
                        found: found,
                        length: i
                    };
                }
                function getHeaderBlock(stream, suggestedLength) {
                    const EEXEC_SIGNATURE = [
                        0x65,
                        0x65,
                        0x78,
                        0x65,
                        0x63
                    ];
                    const streamStartPos = stream.pos;
                    let headerBytes, headerBytesLength, block;
                    try {
                        headerBytes = stream.getBytes(suggestedLength);
                        headerBytesLength = headerBytes.length;
                    } catch  {}
                    if (headerBytesLength === suggestedLength) {
                        block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
                        if (block.found && block.length === suggestedLength) return {
                            stream: new _stream.Stream(headerBytes),
                            length: suggestedLength
                        };
                    }
                    (0, _util.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
                    stream.pos = streamStartPos;
                    const SCAN_BLOCK_LENGTH = 2048;
                    let actualLength;
                    while(true){
                        const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                        block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
                        if (block.length === 0) break;
                        stream.pos += block.length;
                        if (block.found) {
                            actualLength = stream.pos - streamStartPos;
                            break;
                        }
                    }
                    stream.pos = streamStartPos;
                    if (actualLength) return {
                        stream: new _stream.Stream(stream.getBytes(actualLength)),
                        length: actualLength
                    };
                    (0, _util.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
                    return {
                        stream: new _stream.Stream(stream.getBytes(suggestedLength)),
                        length: suggestedLength
                    };
                }
                function getEexecBlock(stream, suggestedLength) {
                    const eexecBytes = stream.getBytes();
                    if (eexecBytes.length === 0) throw new _util.FormatError("getEexecBlock - no font program found.");
                    return {
                        stream: new _stream.Stream(eexecBytes),
                        length: eexecBytes.length
                    };
                }
                class Type1Font {
                    constructor(name, file, properties){
                        const PFB_HEADER_SIZE = 6;
                        let headerBlockLength = properties.length1;
                        let eexecBlockLength = properties.length2;
                        let pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
                        const pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
                        if (pfbHeaderPresent) {
                            file.skip(PFB_HEADER_SIZE);
                            headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                        }
                        const headerBlock = getHeaderBlock(file, headerBlockLength);
                        const headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        headerBlockParser.extractFontHeader(properties);
                        if (pfbHeaderPresent) {
                            pfbHeader = file.getBytes(PFB_HEADER_SIZE);
                            eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                        }
                        const eexecBlock = getEexecBlock(file, eexecBlockLength);
                        const eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        const data = eexecBlockParser.extractFontProgram(properties);
                        for(const key in data.properties)properties[key] = data.properties[key];
                        const charstrings = data.charstrings;
                        const type2Charstrings = this.getType2Charstrings(charstrings);
                        const subrs = this.getType2Subrs(data.subrs);
                        this.charstrings = charstrings;
                        this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
                        this.seacs = this.getSeacs(data.charstrings);
                    }
                    get numGlyphs() {
                        return this.charstrings.length + 1;
                    }
                    getCharset() {
                        const charset = [
                            ".notdef"
                        ];
                        for (const { glyphName: glyphName } of this.charstrings)charset.push(glyphName);
                        return charset;
                    }
                    getGlyphMapping(properties) {
                        const charstrings = this.charstrings;
                        if (properties.composite) {
                            const charCodeToGlyphId = Object.create(null);
                            for(let glyphId = 0, charstringsLen = charstrings.length; glyphId < charstringsLen; glyphId++){
                                const charCode = properties.cMap.charCodeOf(glyphId);
                                charCodeToGlyphId[charCode] = glyphId + 1;
                            }
                            return charCodeToGlyphId;
                        }
                        const glyphNames = [
                            ".notdef"
                        ];
                        let builtInEncoding, glyphId;
                        for(glyphId = 0; glyphId < charstrings.length; glyphId++)glyphNames.push(charstrings[glyphId].glyphName);
                        const encoding = properties.builtInEncoding;
                        if (encoding) {
                            builtInEncoding = Object.create(null);
                            for(const charCode in encoding){
                                glyphId = glyphNames.indexOf(encoding[charCode]);
                                if (glyphId >= 0) builtInEncoding[charCode] = glyphId;
                            }
                        }
                        return (0, _fonts_utils.type1FontGlyphMapping)(properties, builtInEncoding, glyphNames);
                    }
                    hasGlyphId(id) {
                        if (id < 0 || id >= this.numGlyphs) return false;
                        if (id === 0) return true;
                        const glyph = this.charstrings[id - 1];
                        return glyph.charstring.length > 0;
                    }
                    getSeacs(charstrings) {
                        const seacMap = [];
                        for(let i = 0, ii = charstrings.length; i < ii; i++){
                            const charstring = charstrings[i];
                            if (charstring.seac) seacMap[i + 1] = charstring.seac;
                        }
                        return seacMap;
                    }
                    getType2Charstrings(type1Charstrings) {
                        const type2Charstrings = [];
                        for (const type1Charstring of type1Charstrings)type2Charstrings.push(type1Charstring.charstring);
                        return type2Charstrings;
                    }
                    getType2Subrs(type1Subrs) {
                        let bias = 0;
                        const count = type1Subrs.length;
                        if (count < 1133) bias = 107;
                        else if (count < 33769) bias = 1131;
                        else bias = 32768;
                        const type2Subrs = [];
                        let i;
                        for(i = 0; i < bias; i++)type2Subrs.push([
                            0x0b
                        ]);
                        for(i = 0; i < count; i++)type2Subrs.push(type1Subrs[i]);
                        return type2Subrs;
                    }
                    wrap(name, glyphs, charstrings, subrs, properties) {
                        const cff = new _cff_parser.CFF();
                        cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
                        cff.names = [
                            name
                        ];
                        const topDict = new _cff_parser.CFFTopDict();
                        topDict.setByName("version", 391);
                        topDict.setByName("Notice", 392);
                        topDict.setByName("FullName", 393);
                        topDict.setByName("FamilyName", 394);
                        topDict.setByName("Weight", 395);
                        topDict.setByName("Encoding", null);
                        topDict.setByName("FontMatrix", properties.fontMatrix);
                        topDict.setByName("FontBBox", properties.bbox);
                        topDict.setByName("charset", null);
                        topDict.setByName("CharStrings", null);
                        topDict.setByName("Private", null);
                        cff.topDict = topDict;
                        const strings = new _cff_parser.CFFStrings();
                        strings.add("Version 0.11");
                        strings.add("See original notice");
                        strings.add(name);
                        strings.add(name);
                        strings.add("Medium");
                        cff.strings = strings;
                        cff.globalSubrIndex = new _cff_parser.CFFIndex();
                        const count = glyphs.length;
                        const charsetArray = [
                            ".notdef"
                        ];
                        let i, ii;
                        for(i = 0; i < count; i++){
                            const glyphName = charstrings[i].glyphName;
                            const index = _cff_parser.CFFStandardStrings.indexOf(glyphName);
                            if (index === -1) strings.add(glyphName);
                            charsetArray.push(glyphName);
                        }
                        cff.charset = new _cff_parser.CFFCharset(false, 0, charsetArray);
                        const charStringsIndex = new _cff_parser.CFFIndex();
                        charStringsIndex.add([
                            0x8b,
                            0x0e
                        ]);
                        for(i = 0; i < count; i++)charStringsIndex.add(glyphs[i]);
                        cff.charStrings = charStringsIndex;
                        const privateDict = new _cff_parser.CFFPrivateDict();
                        privateDict.setByName("Subrs", null);
                        const fields = [
                            "BlueValues",
                            "OtherBlues",
                            "FamilyBlues",
                            "FamilyOtherBlues",
                            "StemSnapH",
                            "StemSnapV",
                            "BlueShift",
                            "BlueFuzz",
                            "BlueScale",
                            "LanguageGroup",
                            "ExpansionFactor",
                            "ForceBold",
                            "StdHW",
                            "StdVW"
                        ];
                        for(i = 0, ii = fields.length; i < ii; i++){
                            const field = fields[i];
                            if (!(field in properties.privateData)) continue;
                            const value = properties.privateData[field];
                            if (Array.isArray(value)) for(let j = value.length - 1; j > 0; j--)value[j] -= value[j - 1];
                            privateDict.setByName(field, value);
                        }
                        cff.topDict.privateDict = privateDict;
                        const subrIndex = new _cff_parser.CFFIndex();
                        for(i = 0, ii = subrs.length; i < ii; i++)subrIndex.add(subrs[i]);
                        privateDict.subrsIndex = subrIndex;
                        const compiler = new _cff_parser.CFFCompiler(cff);
                        return compiler.compile();
                    }
                }
                exports.Type1Font = Type1Font;
            /***/ },
            /* 49 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Type1Parser = void 0;
                var _encodings = __w_pdfjs_require__(37);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _util = __w_pdfjs_require__(2);
                const HINTING_ENABLED = false;
                const COMMAND_MAP = {
                    hstem: [
                        1
                    ],
                    vstem: [
                        3
                    ],
                    vmoveto: [
                        4
                    ],
                    rlineto: [
                        5
                    ],
                    hlineto: [
                        6
                    ],
                    vlineto: [
                        7
                    ],
                    rrcurveto: [
                        8
                    ],
                    callsubr: [
                        10
                    ],
                    flex: [
                        12,
                        35
                    ],
                    drop: [
                        12,
                        18
                    ],
                    endchar: [
                        14
                    ],
                    rmoveto: [
                        21
                    ],
                    hmoveto: [
                        22
                    ],
                    vhcurveto: [
                        30
                    ],
                    hvcurveto: [
                        31
                    ]
                };
                class Type1CharString {
                    constructor(){
                        this.width = 0;
                        this.lsb = 0;
                        this.flexing = false;
                        this.output = [];
                        this.stack = [];
                    }
                    convert(encoded, subrs, seacAnalysisEnabled) {
                        const count = encoded.length;
                        let error = false;
                        let wx, sbx, subrNumber;
                        for(let i = 0; i < count; i++){
                            let value = encoded[i];
                            if (value < 32) {
                                if (value === 12) value = (value << 8) + encoded[++i];
                                switch(value){
                                    case 1:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.hstem);
                                        break;
                                    case 3:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.vstem);
                                        break;
                                    case 4:
                                        if (this.flexing) {
                                            if (this.stack.length < 1) {
                                                error = true;
                                                break;
                                            }
                                            const dy = this.stack.pop();
                                            this.stack.push(0, dy);
                                            break;
                                        }
                                        error = this.executeCommand(1, COMMAND_MAP.vmoveto);
                                        break;
                                    case 5:
                                        error = this.executeCommand(2, COMMAND_MAP.rlineto);
                                        break;
                                    case 6:
                                        error = this.executeCommand(1, COMMAND_MAP.hlineto);
                                        break;
                                    case 7:
                                        error = this.executeCommand(1, COMMAND_MAP.vlineto);
                                        break;
                                    case 8:
                                        error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
                                        break;
                                    case 9:
                                        this.stack = [];
                                        break;
                                    case 10:
                                        if (this.stack.length < 1) {
                                            error = true;
                                            break;
                                        }
                                        subrNumber = this.stack.pop();
                                        if (!subrs[subrNumber]) {
                                            error = true;
                                            break;
                                        }
                                        error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
                                        break;
                                    case 11:
                                        return error;
                                    case 13:
                                        if (this.stack.length < 2) {
                                            error = true;
                                            break;
                                        }
                                        wx = this.stack.pop();
                                        sbx = this.stack.pop();
                                        this.lsb = sbx;
                                        this.width = wx;
                                        this.stack.push(wx, sbx);
                                        error = this.executeCommand(2, COMMAND_MAP.hmoveto);
                                        break;
                                    case 14:
                                        this.output.push(COMMAND_MAP.endchar[0]);
                                        break;
                                    case 21:
                                        if (this.flexing) break;
                                        error = this.executeCommand(2, COMMAND_MAP.rmoveto);
                                        break;
                                    case 22:
                                        if (this.flexing) {
                                            this.stack.push(0);
                                            break;
                                        }
                                        error = this.executeCommand(1, COMMAND_MAP.hmoveto);
                                        break;
                                    case 30:
                                        error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
                                        break;
                                    case 31:
                                        error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
                                        break;
                                    case 3072:
                                        this.stack = [];
                                        break;
                                    case 3073:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.vstem);
                                        break;
                                    case 3074:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.hstem);
                                        break;
                                    case 3078:
                                        if (seacAnalysisEnabled) {
                                            const asb = this.stack.at(-5);
                                            this.seac = this.stack.splice(-4, 4);
                                            this.seac[0] += this.lsb - asb;
                                            error = this.executeCommand(0, COMMAND_MAP.endchar);
                                        } else error = this.executeCommand(4, COMMAND_MAP.endchar);
                                        break;
                                    case 3079:
                                        if (this.stack.length < 4) {
                                            error = true;
                                            break;
                                        }
                                        this.stack.pop();
                                        wx = this.stack.pop();
                                        const sby = this.stack.pop();
                                        sbx = this.stack.pop();
                                        this.lsb = sbx;
                                        this.width = wx;
                                        this.stack.push(wx, sbx, sby);
                                        error = this.executeCommand(3, COMMAND_MAP.rmoveto);
                                        break;
                                    case 3084:
                                        if (this.stack.length < 2) {
                                            error = true;
                                            break;
                                        }
                                        const num2 = this.stack.pop();
                                        const num1 = this.stack.pop();
                                        this.stack.push(num1 / num2);
                                        break;
                                    case 3088:
                                        if (this.stack.length < 2) {
                                            error = true;
                                            break;
                                        }
                                        subrNumber = this.stack.pop();
                                        const numArgs = this.stack.pop();
                                        if (subrNumber === 0 && numArgs === 3) {
                                            const flexArgs = this.stack.splice(-17, 17);
                                            this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
                                            error = this.executeCommand(13, COMMAND_MAP.flex, true);
                                            this.flexing = false;
                                            this.stack.push(flexArgs[15], flexArgs[16]);
                                        } else if (subrNumber === 1 && numArgs === 0) this.flexing = true;
                                        break;
                                    case 3089:
                                        break;
                                    case 3105:
                                        this.stack = [];
                                        break;
                                    default:
                                        (0, _util.warn)('Unknown type 1 charstring command of "' + value + '"');
                                        break;
                                }
                                if (error) break;
                                continue;
                            } else if (value <= 246) value -= 139;
                            else if (value <= 250) value = (value - 247) * 256 + encoded[++i] + 108;
                            else if (value <= 254) value = -((value - 251) * 256) - encoded[++i] - 108;
                            else value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
                            this.stack.push(value);
                        }
                        return error;
                    }
                    executeCommand(howManyArgs, command, keepStack) {
                        const stackLength = this.stack.length;
                        if (howManyArgs > stackLength) return true;
                        const start = stackLength - howManyArgs;
                        for(let i = start; i < stackLength; i++){
                            let value = this.stack[i];
                            if (Number.isInteger(value)) this.output.push(28, value >> 8 & 0xff, value & 0xff);
                            else {
                                value = 65536 * value | 0;
                                this.output.push(255, value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                            }
                        }
                        this.output.push(...command);
                        if (keepStack) this.stack.splice(start, howManyArgs);
                        else this.stack.length = 0;
                        return false;
                    }
                }
                const EEXEC_ENCRYPT_KEY = 55665;
                const CHAR_STRS_ENCRYPT_KEY = 4330;
                function isHexDigit(code) {
                    return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
                }
                function decrypt(data, key, discardNumber) {
                    if (discardNumber >= data.length) return new Uint8Array(0);
                    const c1 = 52845, c2 = 22719;
                    let r = key | 0, i, j;
                    for(i = 0; i < discardNumber; i++)r = (data[i] + r) * c1 + c2 & 65535;
                    const count = data.length - discardNumber;
                    const decrypted = new Uint8Array(count);
                    for(i = discardNumber, j = 0; j < count; i++, j++){
                        const value = data[i];
                        decrypted[j] = value ^ r >> 8;
                        r = (value + r) * c1 + c2 & 65535;
                    }
                    return decrypted;
                }
                function decryptAscii(data, key, discardNumber) {
                    const c1 = 52845, c2 = 22719;
                    let r = key | 0;
                    const count = data.length, maybeLength = count >>> 1;
                    const decrypted = new Uint8Array(maybeLength);
                    let i, j;
                    for(i = 0, j = 0; i < count; i++){
                        const digit1 = data[i];
                        if (!isHexDigit(digit1)) continue;
                        i++;
                        let digit2;
                        while(i < count && !isHexDigit(digit2 = data[i]))i++;
                        if (i < count) {
                            const value = parseInt(String.fromCharCode(digit1, digit2), 16);
                            decrypted[j++] = value ^ r >> 8;
                            r = (value + r) * c1 + c2 & 65535;
                        }
                    }
                    return decrypted.slice(discardNumber, j);
                }
                function isSpecial(c) {
                    return c === 0x2f || c === 0x5b || c === 0x5d || c === 0x7b || c === 0x7d || c === 0x28 || c === 0x29;
                }
                class Type1Parser {
                    constructor(stream, encrypted, seacAnalysisEnabled){
                        if (encrypted) {
                            const data = stream.getBytes();
                            const isBinary = !((isHexDigit(data[0]) || (0, _core_utils.isWhiteSpace)(data[0])) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]) && isHexDigit(data[4]) && isHexDigit(data[5]) && isHexDigit(data[6]) && isHexDigit(data[7]));
                            stream = new _stream.Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
                        }
                        this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                        this.stream = stream;
                        this.nextChar();
                    }
                    readNumberArray() {
                        this.getToken();
                        const array = [];
                        while(true){
                            const token = this.getToken();
                            if (token === null || token === "]" || token === "}") break;
                            array.push(parseFloat(token || 0));
                        }
                        return array;
                    }
                    readNumber() {
                        const token = this.getToken();
                        return parseFloat(token || 0);
                    }
                    readInt() {
                        const token = this.getToken();
                        return parseInt(token || 0, 10) | 0;
                    }
                    readBoolean() {
                        const token = this.getToken();
                        return token === "true" ? 1 : 0;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    prevChar() {
                        this.stream.skip(-2);
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch === -1) return null;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (!(0, _core_utils.isWhiteSpace)(ch)) break;
                            ch = this.nextChar();
                        }
                        if (isSpecial(ch)) {
                            this.nextChar();
                            return String.fromCharCode(ch);
                        }
                        let token = "";
                        do {
                            token += String.fromCharCode(ch);
                            ch = this.nextChar();
                        }while (ch >= 0 && !(0, _core_utils.isWhiteSpace)(ch) && !isSpecial(ch));
                        return token;
                    }
                    readCharStrings(bytes, lenIV) {
                        if (lenIV === -1) return bytes;
                        return decrypt(bytes, CHAR_STRS_ENCRYPT_KEY, lenIV);
                    }
                    extractFontProgram(properties) {
                        const stream = this.stream;
                        const subrs = [], charstrings = [];
                        const privateData = Object.create(null);
                        privateData.lenIV = 4;
                        const program = {
                            subrs: [],
                            charstrings: [],
                            properties: {
                                privateData: privateData
                            }
                        };
                        let token, length, data, lenIV;
                        while((token = this.getToken()) !== null){
                            if (token !== "/") continue;
                            token = this.getToken();
                            switch(token){
                                case "CharStrings":
                                    this.getToken();
                                    this.getToken();
                                    this.getToken();
                                    this.getToken();
                                    while(true){
                                        token = this.getToken();
                                        if (token === null || token === "end") break;
                                        if (token !== "/") continue;
                                        const glyph = this.getToken();
                                        length = this.readInt();
                                        this.getToken();
                                        data = length > 0 ? stream.getBytes(length) : new Uint8Array(0);
                                        lenIV = program.properties.privateData.lenIV;
                                        const encoded = this.readCharStrings(data, lenIV);
                                        this.nextChar();
                                        token = this.getToken();
                                        if (token === "noaccess") this.getToken();
                                        else if (token === "/") this.prevChar();
                                        charstrings.push({
                                            glyph: glyph,
                                            encoded: encoded
                                        });
                                    }
                                    break;
                                case "Subrs":
                                    this.readInt();
                                    this.getToken();
                                    while(this.getToken() === "dup"){
                                        const index = this.readInt();
                                        length = this.readInt();
                                        this.getToken();
                                        data = length > 0 ? stream.getBytes(length) : new Uint8Array(0);
                                        lenIV = program.properties.privateData.lenIV;
                                        const encoded = this.readCharStrings(data, lenIV);
                                        this.nextChar();
                                        token = this.getToken();
                                        if (token === "noaccess") this.getToken();
                                        subrs[index] = encoded;
                                    }
                                    break;
                                case "BlueValues":
                                case "OtherBlues":
                                case "FamilyBlues":
                                case "FamilyOtherBlues":
                                    const blueArray = this.readNumberArray();
                                    if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) program.properties.privateData[token] = blueArray;
                                    break;
                                case "StemSnapH":
                                case "StemSnapV":
                                    program.properties.privateData[token] = this.readNumberArray();
                                    break;
                                case "StdHW":
                                case "StdVW":
                                    program.properties.privateData[token] = this.readNumberArray()[0];
                                    break;
                                case "BlueShift":
                                case "lenIV":
                                case "BlueFuzz":
                                case "BlueScale":
                                case "LanguageGroup":
                                    program.properties.privateData[token] = this.readNumber();
                                    break;
                                case "ExpansionFactor":
                                    program.properties.privateData[token] = this.readNumber() || 0.06;
                                    break;
                                case "ForceBold":
                                    program.properties.privateData[token] = this.readBoolean();
                                    break;
                            }
                        }
                        for (const { encoded: encoded, glyph: glyph } of charstrings){
                            const charString = new Type1CharString();
                            const error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
                            let output = charString.output;
                            if (error) output = [
                                14
                            ];
                            const charStringObject = {
                                glyphName: glyph,
                                charstring: output,
                                width: charString.width,
                                lsb: charString.lsb,
                                seac: charString.seac
                            };
                            if (glyph === ".notdef") program.charstrings.unshift(charStringObject);
                            else program.charstrings.push(charStringObject);
                            if (properties.builtInEncoding) {
                                const index = properties.builtInEncoding.indexOf(glyph);
                                if (index > -1 && properties.widths[index] === undefined && index >= properties.firstChar && index <= properties.lastChar) properties.widths[index] = charString.width;
                            }
                        }
                        return program;
                    }
                    extractFontHeader(properties) {
                        let token;
                        while((token = this.getToken()) !== null){
                            if (token !== "/") continue;
                            token = this.getToken();
                            switch(token){
                                case "FontMatrix":
                                    const matrix = this.readNumberArray();
                                    properties.fontMatrix = matrix;
                                    break;
                                case "Encoding":
                                    const encodingArg = this.getToken();
                                    let encoding;
                                    if (!/^\d+$/.test(encodingArg)) encoding = (0, _encodings.getEncoding)(encodingArg);
                                    else {
                                        encoding = [];
                                        const size = parseInt(encodingArg, 10) | 0;
                                        this.getToken();
                                        for(let j = 0; j < size; j++){
                                            token = this.getToken();
                                            while(token !== "dup" && token !== "def"){
                                                token = this.getToken();
                                                if (token === null) return;
                                            }
                                            if (token === "def") break;
                                            const index = this.readInt();
                                            this.getToken();
                                            const glyph = this.getToken();
                                            encoding[index] = glyph;
                                            this.getToken();
                                        }
                                    }
                                    properties.builtInEncoding = encoding;
                                    break;
                                case "FontBBox":
                                    const fontBBox = this.readNumberArray();
                                    properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                                    properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                                    properties.ascentScaled = true;
                                    break;
                            }
                        }
                    }
                }
                exports.Type1Parser = Type1Parser;
            /***/ },
            /* 50 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Pattern = void 0;
                exports.clearPatternCaches = clearPatternCaches;
                exports.getTilingPatternIR = getTilingPatternIR;
                var _util = __w_pdfjs_require__(2);
                var _base_stream = __w_pdfjs_require__(5);
                var _colorspace = __w_pdfjs_require__(12);
                var _core_utils = __w_pdfjs_require__(3);
                const ShadingType = {
                    FUNCTION_BASED: 1,
                    AXIAL: 2,
                    RADIAL: 3,
                    FREE_FORM_MESH: 4,
                    LATTICE_FORM_MESH: 5,
                    COONS_PATCH_MESH: 6,
                    TENSOR_PATCH_MESH: 7
                };
                class Pattern {
                    constructor(){
                        (0, _util.unreachable)("Cannot initialize Pattern.");
                    }
                    static parseShading(shading, xref, res, pdfFunctionFactory, localColorSpaceCache) {
                        const dict = shading instanceof _base_stream.BaseStream ? shading.dict : shading;
                        const type = dict.get("ShadingType");
                        try {
                            switch(type){
                                case ShadingType.AXIAL:
                                case ShadingType.RADIAL:
                                    return new RadialAxialShading(dict, xref, res, pdfFunctionFactory, localColorSpaceCache);
                                case ShadingType.FREE_FORM_MESH:
                                case ShadingType.LATTICE_FORM_MESH:
                                case ShadingType.COONS_PATCH_MESH:
                                case ShadingType.TENSOR_PATCH_MESH:
                                    return new MeshShading(shading, xref, res, pdfFunctionFactory, localColorSpaceCache);
                                default:
                                    throw new _util.FormatError("Unsupported ShadingType: " + type);
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(ex);
                            return new DummyShading();
                        }
                    }
                }
                exports.Pattern = Pattern;
                class BaseShading {
                    static SMALL_NUMBER = 1e-6;
                    constructor(){
                        if (this.constructor === BaseShading) (0, _util.unreachable)("Cannot initialize BaseShading.");
                    }
                    getIR() {
                        (0, _util.unreachable)("Abstract method `getIR` called.");
                    }
                }
                class RadialAxialShading extends BaseShading {
                    constructor(dict, xref, resources, pdfFunctionFactory, localColorSpaceCache){
                        super();
                        this.coordsArr = dict.getArray("Coords");
                        this.shadingType = dict.get("ShadingType");
                        const cs = _colorspace.ColorSpace.parse({
                            cs: dict.getRaw("CS") || dict.getRaw("ColorSpace"),
                            xref: xref,
                            resources: resources,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        const bbox = dict.getArray("BBox");
                        this.bbox = Array.isArray(bbox) && bbox.length === 4 ? _util.Util.normalizeRect(bbox) : null;
                        let t0 = 0.0, t1 = 1.0;
                        if (dict.has("Domain")) {
                            const domainArr = dict.getArray("Domain");
                            t0 = domainArr[0];
                            t1 = domainArr[1];
                        }
                        let extendStart = false, extendEnd = false;
                        if (dict.has("Extend")) {
                            const extendArr = dict.getArray("Extend");
                            extendStart = extendArr[0];
                            extendEnd = extendArr[1];
                        }
                        if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
                            const [x1, y1, r1, x2, y2, r2] = this.coordsArr;
                            const distance = Math.hypot(x1 - x2, y1 - y2);
                            if (r1 <= r2 + distance && r2 <= r1 + distance) (0, _util.warn)("Unsupported radial gradient.");
                        }
                        this.extendStart = extendStart;
                        this.extendEnd = extendEnd;
                        const fnObj = dict.getRaw("Function");
                        const fn = pdfFunctionFactory.createFromArray(fnObj);
                        const NUMBER_OF_SAMPLES = 840;
                        const step = (t1 - t0) / NUMBER_OF_SAMPLES;
                        const colorStops = this.colorStops = [];
                        if (t0 >= t1 || step <= 0) {
                            (0, _util.info)("Bad shading domain.");
                            return;
                        }
                        const color = new Float32Array(cs.numComps), ratio = new Float32Array(1);
                        let rgbColor;
                        let iBase = 0;
                        ratio[0] = t0;
                        fn(ratio, 0, color, 0);
                        let rgbBase = cs.getRgb(color, 0);
                        const cssColorBase = _util.Util.makeHexColor(rgbBase[0], rgbBase[1], rgbBase[2]);
                        colorStops.push([
                            0,
                            cssColorBase
                        ]);
                        let iPrev = 1;
                        ratio[0] = t0 + step;
                        fn(ratio, 0, color, 0);
                        let rgbPrev = cs.getRgb(color, 0);
                        let maxSlopeR = rgbPrev[0] - rgbBase[0] + 1;
                        let maxSlopeG = rgbPrev[1] - rgbBase[1] + 1;
                        let maxSlopeB = rgbPrev[2] - rgbBase[2] + 1;
                        let minSlopeR = rgbPrev[0] - rgbBase[0] - 1;
                        let minSlopeG = rgbPrev[1] - rgbBase[1] - 1;
                        let minSlopeB = rgbPrev[2] - rgbBase[2] - 1;
                        for(let i = 2; i < NUMBER_OF_SAMPLES; i++){
                            ratio[0] = t0 + i * step;
                            fn(ratio, 0, color, 0);
                            rgbColor = cs.getRgb(color, 0);
                            const run = i - iBase;
                            maxSlopeR = Math.min(maxSlopeR, (rgbColor[0] - rgbBase[0] + 1) / run);
                            maxSlopeG = Math.min(maxSlopeG, (rgbColor[1] - rgbBase[1] + 1) / run);
                            maxSlopeB = Math.min(maxSlopeB, (rgbColor[2] - rgbBase[2] + 1) / run);
                            minSlopeR = Math.max(minSlopeR, (rgbColor[0] - rgbBase[0] - 1) / run);
                            minSlopeG = Math.max(minSlopeG, (rgbColor[1] - rgbBase[1] - 1) / run);
                            minSlopeB = Math.max(minSlopeB, (rgbColor[2] - rgbBase[2] - 1) / run);
                            const slopesExist = minSlopeR <= maxSlopeR && minSlopeG <= maxSlopeG && minSlopeB <= maxSlopeB;
                            if (!slopesExist) {
                                const cssColor = _util.Util.makeHexColor(rgbPrev[0], rgbPrev[1], rgbPrev[2]);
                                colorStops.push([
                                    iPrev / NUMBER_OF_SAMPLES,
                                    cssColor
                                ]);
                                maxSlopeR = rgbColor[0] - rgbPrev[0] + 1;
                                maxSlopeG = rgbColor[1] - rgbPrev[1] + 1;
                                maxSlopeB = rgbColor[2] - rgbPrev[2] + 1;
                                minSlopeR = rgbColor[0] - rgbPrev[0] - 1;
                                minSlopeG = rgbColor[1] - rgbPrev[1] - 1;
                                minSlopeB = rgbColor[2] - rgbPrev[2] - 1;
                                iBase = iPrev;
                                rgbBase = rgbPrev;
                            }
                            iPrev = i;
                            rgbPrev = rgbColor;
                        }
                        const cssColor = _util.Util.makeHexColor(rgbPrev[0], rgbPrev[1], rgbPrev[2]);
                        colorStops.push([
                            1,
                            cssColor
                        ]);
                        let background = "transparent";
                        if (dict.has("Background")) {
                            rgbColor = cs.getRgb(dict.get("Background"), 0);
                            background = _util.Util.makeHexColor(rgbColor[0], rgbColor[1], rgbColor[2]);
                        }
                        if (!extendStart) {
                            colorStops.unshift([
                                0,
                                background
                            ]);
                            colorStops[1][0] += BaseShading.SMALL_NUMBER;
                        }
                        if (!extendEnd) {
                            colorStops.at(-1)[0] -= BaseShading.SMALL_NUMBER;
                            colorStops.push([
                                1,
                                background
                            ]);
                        }
                        this.colorStops = colorStops;
                    }
                    getIR() {
                        const coordsArr = this.coordsArr;
                        const shadingType = this.shadingType;
                        let type, p0, p1, r0, r1;
                        if (shadingType === ShadingType.AXIAL) {
                            p0 = [
                                coordsArr[0],
                                coordsArr[1]
                            ];
                            p1 = [
                                coordsArr[2],
                                coordsArr[3]
                            ];
                            r0 = null;
                            r1 = null;
                            type = "axial";
                        } else if (shadingType === ShadingType.RADIAL) {
                            p0 = [
                                coordsArr[0],
                                coordsArr[1]
                            ];
                            p1 = [
                                coordsArr[3],
                                coordsArr[4]
                            ];
                            r0 = coordsArr[2];
                            r1 = coordsArr[5];
                            type = "radial";
                        } else (0, _util.unreachable)(`getPattern type unknown: ${shadingType}`);
                        return [
                            "RadialAxial",
                            type,
                            this.bbox,
                            this.colorStops,
                            p0,
                            p1,
                            r0,
                            r1
                        ];
                    }
                }
                class MeshStreamReader {
                    constructor(stream, context){
                        this.stream = stream;
                        this.context = context;
                        this.buffer = 0;
                        this.bufferLength = 0;
                        const numComps = context.numComps;
                        this.tmpCompsBuf = new Float32Array(numComps);
                        const csNumComps = context.colorSpace.numComps;
                        this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
                    }
                    get hasData() {
                        if (this.stream.end) return this.stream.pos < this.stream.end;
                        if (this.bufferLength > 0) return true;
                        const nextByte = this.stream.getByte();
                        if (nextByte < 0) return false;
                        this.buffer = nextByte;
                        this.bufferLength = 8;
                        return true;
                    }
                    readBits(n) {
                        let buffer = this.buffer;
                        let bufferLength = this.bufferLength;
                        if (n === 32) {
                            if (bufferLength === 0) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                            buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                            const nextByte = this.stream.getByte();
                            this.buffer = nextByte & (1 << bufferLength) - 1;
                            return (buffer << 8 - bufferLength | (nextByte & 0xff) >> bufferLength) >>> 0;
                        }
                        if (n === 8 && bufferLength === 0) return this.stream.getByte();
                        while(bufferLength < n){
                            buffer = buffer << 8 | this.stream.getByte();
                            bufferLength += 8;
                        }
                        bufferLength -= n;
                        this.bufferLength = bufferLength;
                        this.buffer = buffer & (1 << bufferLength) - 1;
                        return buffer >> bufferLength;
                    }
                    align() {
                        this.buffer = 0;
                        this.bufferLength = 0;
                    }
                    readFlag() {
                        return this.readBits(this.context.bitsPerFlag);
                    }
                    readCoordinate() {
                        const bitsPerCoordinate = this.context.bitsPerCoordinate;
                        const xi = this.readBits(bitsPerCoordinate);
                        const yi = this.readBits(bitsPerCoordinate);
                        const decode = this.context.decode;
                        const scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
                        return [
                            xi * scale * (decode[1] - decode[0]) + decode[0],
                            yi * scale * (decode[3] - decode[2]) + decode[2]
                        ];
                    }
                    readComponents() {
                        const numComps = this.context.numComps;
                        const bitsPerComponent = this.context.bitsPerComponent;
                        const scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
                        const decode = this.context.decode;
                        const components = this.tmpCompsBuf;
                        for(let i = 0, j = 4; i < numComps; i++, j += 2){
                            const ci = this.readBits(bitsPerComponent);
                            components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
                        }
                        const color = this.tmpCsCompsBuf;
                        if (this.context.colorFn) this.context.colorFn(components, 0, color, 0);
                        return this.context.colorSpace.getRgb(color, 0);
                    }
                }
                let bCache = Object.create(null);
                function buildB(count) {
                    const lut = [];
                    for(let i = 0; i <= count; i++){
                        const t = i / count, t_ = 1 - t;
                        lut.push(new Float32Array([
                            t_ ** 3,
                            3 * t * t_ ** 2,
                            3 * t ** 2 * t_,
                            t ** 3
                        ]));
                    }
                    return lut;
                }
                function getB(count) {
                    return bCache[count] ||= buildB(count);
                }
                function clearPatternCaches() {
                    bCache = Object.create(null);
                }
                class MeshShading extends BaseShading {
                    static MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
                    static MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
                    static TRIANGLE_DENSITY = 20;
                    constructor(stream, xref, resources, pdfFunctionFactory, localColorSpaceCache){
                        super();
                        if (!(stream instanceof _base_stream.BaseStream)) throw new _util.FormatError("Mesh data is not a stream");
                        const dict = stream.dict;
                        this.shadingType = dict.get("ShadingType");
                        const bbox = dict.getArray("BBox");
                        this.bbox = Array.isArray(bbox) && bbox.length === 4 ? _util.Util.normalizeRect(bbox) : null;
                        const cs = _colorspace.ColorSpace.parse({
                            cs: dict.getRaw("CS") || dict.getRaw("ColorSpace"),
                            xref: xref,
                            resources: resources,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        this.background = dict.has("Background") ? cs.getRgb(dict.get("Background"), 0) : null;
                        const fnObj = dict.getRaw("Function");
                        const fn = fnObj ? pdfFunctionFactory.createFromArray(fnObj) : null;
                        this.coords = [];
                        this.colors = [];
                        this.figures = [];
                        const decodeContext = {
                            bitsPerCoordinate: dict.get("BitsPerCoordinate"),
                            bitsPerComponent: dict.get("BitsPerComponent"),
                            bitsPerFlag: dict.get("BitsPerFlag"),
                            decode: dict.getArray("Decode"),
                            colorFn: fn,
                            colorSpace: cs,
                            numComps: fn ? 1 : cs.numComps
                        };
                        const reader = new MeshStreamReader(stream, decodeContext);
                        let patchMesh = false;
                        switch(this.shadingType){
                            case ShadingType.FREE_FORM_MESH:
                                this._decodeType4Shading(reader);
                                break;
                            case ShadingType.LATTICE_FORM_MESH:
                                const verticesPerRow = dict.get("VerticesPerRow") | 0;
                                if (verticesPerRow < 2) throw new _util.FormatError("Invalid VerticesPerRow");
                                this._decodeType5Shading(reader, verticesPerRow);
                                break;
                            case ShadingType.COONS_PATCH_MESH:
                                this._decodeType6Shading(reader);
                                patchMesh = true;
                                break;
                            case ShadingType.TENSOR_PATCH_MESH:
                                this._decodeType7Shading(reader);
                                patchMesh = true;
                                break;
                            default:
                                (0, _util.unreachable)("Unsupported mesh type.");
                                break;
                        }
                        if (patchMesh) {
                            this._updateBounds();
                            for(let i = 0, ii = this.figures.length; i < ii; i++)this._buildFigureFromPatch(i);
                        }
                        this._updateBounds();
                        this._packData();
                    }
                    _decodeType4Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const operators = [];
                        const ps = [];
                        let verticesLeft = 0;
                        while(reader.hasData){
                            const f = reader.readFlag();
                            const coord = reader.readCoordinate();
                            const color = reader.readComponents();
                            if (verticesLeft === 0) {
                                if (!(0 <= f && f <= 2)) throw new _util.FormatError("Unknown type4 flag");
                                switch(f){
                                    case 0:
                                        verticesLeft = 3;
                                        break;
                                    case 1:
                                        ps.push(ps.at(-2), ps.at(-1));
                                        verticesLeft = 1;
                                        break;
                                    case 2:
                                        ps.push(ps.at(-3), ps.at(-1));
                                        verticesLeft = 1;
                                        break;
                                }
                                operators.push(f);
                            }
                            ps.push(coords.length);
                            coords.push(coord);
                            colors.push(color);
                            verticesLeft--;
                            reader.align();
                        }
                        this.figures.push({
                            type: "triangles",
                            coords: new Int32Array(ps),
                            colors: new Int32Array(ps)
                        });
                    }
                    _decodeType5Shading(reader, verticesPerRow) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = [];
                        while(reader.hasData){
                            const coord = reader.readCoordinate();
                            const color = reader.readComponents();
                            ps.push(coords.length);
                            coords.push(coord);
                            colors.push(color);
                        }
                        this.figures.push({
                            type: "lattice",
                            coords: new Int32Array(ps),
                            colors: new Int32Array(ps),
                            verticesPerRow: verticesPerRow
                        });
                    }
                    _decodeType6Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = new Int32Array(16);
                        const cs = new Int32Array(4);
                        while(reader.hasData){
                            const f = reader.readFlag();
                            if (!(0 <= f && f <= 3)) throw new _util.FormatError("Unknown type6 flag");
                            const pi = coords.length;
                            for(let i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++)coords.push(reader.readCoordinate());
                            const ci = colors.length;
                            for(let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++)colors.push(reader.readComponents());
                            let tmp1, tmp2, tmp3, tmp4;
                            switch(f){
                                case 0:
                                    ps[12] = pi + 3;
                                    ps[13] = pi + 4;
                                    ps[14] = pi + 5;
                                    ps[15] = pi + 6;
                                    ps[8] = pi + 2;
                                    ps[11] = pi + 7;
                                    ps[4] = pi + 1;
                                    ps[7] = pi + 8;
                                    ps[0] = pi;
                                    ps[1] = pi + 11;
                                    ps[2] = pi + 10;
                                    ps[3] = pi + 9;
                                    cs[2] = ci + 1;
                                    cs[3] = ci + 2;
                                    cs[0] = ci;
                                    cs[1] = ci + 3;
                                    break;
                                case 1:
                                    tmp1 = ps[12];
                                    tmp2 = ps[13];
                                    tmp3 = ps[14];
                                    tmp4 = ps[15];
                                    ps[12] = tmp4;
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = tmp3;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[2];
                                    tmp2 = cs[3];
                                    cs[2] = tmp2;
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 2:
                                    tmp1 = ps[15];
                                    tmp2 = ps[11];
                                    ps[12] = ps[3];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[7];
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[3];
                                    cs[2] = cs[1];
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 3:
                                    ps[12] = ps[0];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[1];
                                    ps[11] = pi + 3;
                                    ps[4] = ps[2];
                                    ps[7] = pi + 4;
                                    ps[0] = ps[3];
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    cs[2] = cs[0];
                                    cs[3] = ci;
                                    cs[0] = cs[1];
                                    cs[1] = ci + 1;
                                    break;
                            }
                            ps[5] = coords.length;
                            coords.push([
                                (-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9,
                                (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9
                            ]);
                            ps[6] = coords.length;
                            coords.push([
                                (-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9,
                                (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9
                            ]);
                            ps[9] = coords.length;
                            coords.push([
                                (-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9,
                                (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9
                            ]);
                            ps[10] = coords.length;
                            coords.push([
                                (-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9,
                                (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9
                            ]);
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(ps),
                                colors: new Int32Array(cs)
                            });
                        }
                    }
                    _decodeType7Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = new Int32Array(16);
                        const cs = new Int32Array(4);
                        while(reader.hasData){
                            const f = reader.readFlag();
                            if (!(0 <= f && f <= 3)) throw new _util.FormatError("Unknown type7 flag");
                            const pi = coords.length;
                            for(let i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++)coords.push(reader.readCoordinate());
                            const ci = colors.length;
                            for(let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++)colors.push(reader.readComponents());
                            let tmp1, tmp2, tmp3, tmp4;
                            switch(f){
                                case 0:
                                    ps[12] = pi + 3;
                                    ps[13] = pi + 4;
                                    ps[14] = pi + 5;
                                    ps[15] = pi + 6;
                                    ps[8] = pi + 2;
                                    ps[9] = pi + 13;
                                    ps[10] = pi + 14;
                                    ps[11] = pi + 7;
                                    ps[4] = pi + 1;
                                    ps[5] = pi + 12;
                                    ps[6] = pi + 15;
                                    ps[7] = pi + 8;
                                    ps[0] = pi;
                                    ps[1] = pi + 11;
                                    ps[2] = pi + 10;
                                    ps[3] = pi + 9;
                                    cs[2] = ci + 1;
                                    cs[3] = ci + 2;
                                    cs[0] = ci;
                                    cs[1] = ci + 3;
                                    break;
                                case 1:
                                    tmp1 = ps[12];
                                    tmp2 = ps[13];
                                    tmp3 = ps[14];
                                    tmp4 = ps[15];
                                    ps[12] = tmp4;
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = tmp3;
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[2];
                                    tmp2 = cs[3];
                                    cs[2] = tmp2;
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 2:
                                    tmp1 = ps[15];
                                    tmp2 = ps[11];
                                    ps[12] = ps[3];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[7];
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[3];
                                    cs[2] = cs[1];
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 3:
                                    ps[12] = ps[0];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[1];
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = ps[2];
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = ps[3];
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    cs[2] = cs[0];
                                    cs[3] = ci;
                                    cs[0] = cs[1];
                                    cs[1] = ci + 1;
                                    break;
                            }
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(ps),
                                colors: new Int32Array(cs)
                            });
                        }
                    }
                    _buildFigureFromPatch(index) {
                        const figure = this.figures[index];
                        (0, _util.assert)(figure.type === "patch", "Unexpected patch mesh figure");
                        const coords = this.coords, colors = this.colors;
                        const pi = figure.coords;
                        const ci = figure.colors;
                        const figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                        const figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                        const figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                        const figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                        let splitXBy = Math.ceil((figureMaxX - figureMinX) * MeshShading.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
                        splitXBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
                        let splitYBy = Math.ceil((figureMaxY - figureMinY) * MeshShading.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
                        splitYBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
                        const verticesPerRow = splitXBy + 1;
                        const figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
                        const figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
                        let k = 0;
                        const cl = new Uint8Array(3), cr = new Uint8Array(3);
                        const c0 = colors[ci[0]], c1 = colors[ci[1]], c2 = colors[ci[2]], c3 = colors[ci[3]];
                        const bRow = getB(splitYBy), bCol = getB(splitXBy);
                        for(let row = 0; row <= splitYBy; row++){
                            cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
                            cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
                            cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
                            cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
                            cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
                            cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
                            for(let col = 0; col <= splitXBy; col++, k++){
                                if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) continue;
                                let x = 0, y = 0;
                                let q = 0;
                                for(let i = 0; i <= 3; i++)for(let j = 0; j <= 3; j++, q++){
                                    const m = bRow[row][i] * bCol[col][j];
                                    x += coords[pi[q]][0] * m;
                                    y += coords[pi[q]][1] * m;
                                }
                                figureCoords[k] = coords.length;
                                coords.push([
                                    x,
                                    y
                                ]);
                                figureColors[k] = colors.length;
                                const newColor = new Uint8Array(3);
                                newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
                                newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
                                newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
                                colors.push(newColor);
                            }
                        }
                        figureCoords[0] = pi[0];
                        figureColors[0] = ci[0];
                        figureCoords[splitXBy] = pi[3];
                        figureColors[splitXBy] = ci[1];
                        figureCoords[verticesPerRow * splitYBy] = pi[12];
                        figureColors[verticesPerRow * splitYBy] = ci[2];
                        figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
                        figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
                        this.figures[index] = {
                            type: "lattice",
                            coords: figureCoords,
                            colors: figureColors,
                            verticesPerRow: verticesPerRow
                        };
                    }
                    _updateBounds() {
                        let minX = this.coords[0][0], minY = this.coords[0][1], maxX = minX, maxY = minY;
                        for(let i = 1, ii = this.coords.length; i < ii; i++){
                            const x = this.coords[i][0], y = this.coords[i][1];
                            minX = minX > x ? x : minX;
                            minY = minY > y ? y : minY;
                            maxX = maxX < x ? x : maxX;
                            maxY = maxY < y ? y : maxY;
                        }
                        this.bounds = [
                            minX,
                            minY,
                            maxX,
                            maxY
                        ];
                    }
                    _packData() {
                        let i, ii, j, jj;
                        const coords = this.coords;
                        const coordsPacked = new Float32Array(coords.length * 2);
                        for(i = 0, j = 0, ii = coords.length; i < ii; i++){
                            const xy = coords[i];
                            coordsPacked[j++] = xy[0];
                            coordsPacked[j++] = xy[1];
                        }
                        this.coords = coordsPacked;
                        const colors = this.colors;
                        const colorsPacked = new Uint8Array(colors.length * 3);
                        for(i = 0, j = 0, ii = colors.length; i < ii; i++){
                            const c = colors[i];
                            colorsPacked[j++] = c[0];
                            colorsPacked[j++] = c[1];
                            colorsPacked[j++] = c[2];
                        }
                        this.colors = colorsPacked;
                        const figures = this.figures;
                        for(i = 0, ii = figures.length; i < ii; i++){
                            const figure = figures[i], ps = figure.coords, cs = figure.colors;
                            for(j = 0, jj = ps.length; j < jj; j++){
                                ps[j] *= 2;
                                cs[j] *= 3;
                            }
                        }
                    }
                    getIR() {
                        return [
                            "Mesh",
                            this.shadingType,
                            this.coords,
                            this.colors,
                            this.figures,
                            this.bounds,
                            this.bbox,
                            this.background
                        ];
                    }
                }
                class DummyShading extends BaseShading {
                    getIR() {
                        return [
                            "Dummy"
                        ];
                    }
                }
                function getTilingPatternIR(operatorList, dict, color) {
                    const matrix = dict.getArray("Matrix");
                    const bbox = _util.Util.normalizeRect(dict.getArray("BBox"));
                    const xstep = dict.get("XStep");
                    const ystep = dict.get("YStep");
                    const paintType = dict.get("PaintType");
                    const tilingType = dict.get("TilingType");
                    if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) throw new _util.FormatError(`Invalid getTilingPatternIR /BBox array: [${bbox}].`);
                    return [
                        "TilingPattern",
                        color,
                        operatorList,
                        matrix,
                        bbox,
                        xstep,
                        ystep,
                        paintType,
                        tilingType
                    ];
                }
            /***/ },
            /* 51 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getXfaFontDict = getXfaFontDict;
                exports.getXfaFontName = getXfaFontName;
                var _calibri_factors = __w_pdfjs_require__(52);
                var _primitives = __w_pdfjs_require__(4);
                var _helvetica_factors = __w_pdfjs_require__(53);
                var _liberationsans_widths = __w_pdfjs_require__(54);
                var _myriadpro_factors = __w_pdfjs_require__(55);
                var _segoeui_factors = __w_pdfjs_require__(56);
                var _core_utils = __w_pdfjs_require__(3);
                var _fonts_utils = __w_pdfjs_require__(38);
                const getXFAFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["MyriadPro-Regular"] = t["PdfJS-Fallback-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _myriadpro_factors.MyriadProRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _myriadpro_factors.MyriadProRegularMetrics
                    };
                    t["MyriadPro-Bold"] = t["PdfJS-Fallback-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _myriadpro_factors.MyriadProBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _myriadpro_factors.MyriadProBoldMetrics
                    };
                    t["MyriadPro-It"] = t["MyriadPro-Italic"] = t["PdfJS-Fallback-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _myriadpro_factors.MyriadProItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _myriadpro_factors.MyriadProItalicMetrics
                    };
                    t["MyriadPro-BoldIt"] = t["MyriadPro-BoldItalic"] = t["PdfJS-Fallback-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _myriadpro_factors.MyriadProBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _myriadpro_factors.MyriadProBoldItalicMetrics
                    };
                    t.ArialMT = t.Arial = t["Arial-Regular"] = {
                        name: "LiberationSans-Regular",
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping
                    };
                    t["Arial-BoldMT"] = t["Arial-Bold"] = {
                        name: "LiberationSans-Bold",
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping
                    };
                    t["Arial-ItalicMT"] = t["Arial-Italic"] = {
                        name: "LiberationSans-Italic",
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping
                    };
                    t["Arial-BoldItalicMT"] = t["Arial-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping
                    };
                    t["Calibri-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _calibri_factors.CalibriRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _calibri_factors.CalibriRegularMetrics
                    };
                    t["Calibri-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _calibri_factors.CalibriBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _calibri_factors.CalibriBoldMetrics
                    };
                    t["Calibri-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _calibri_factors.CalibriItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _calibri_factors.CalibriItalicMetrics
                    };
                    t["Calibri-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _calibri_factors.CalibriBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _calibri_factors.CalibriBoldItalicMetrics
                    };
                    t["Segoeui-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _segoeui_factors.SegoeuiRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _segoeui_factors.SegoeuiRegularMetrics
                    };
                    t["Segoeui-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _segoeui_factors.SegoeuiBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _segoeui_factors.SegoeuiBoldMetrics
                    };
                    t["Segoeui-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _segoeui_factors.SegoeuiItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _segoeui_factors.SegoeuiItalicMetrics
                    };
                    t["Segoeui-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _segoeui_factors.SegoeuiBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _segoeui_factors.SegoeuiBoldItalicMetrics
                    };
                    t["Helvetica-Regular"] = t.Helvetica = {
                        name: "LiberationSans-Regular",
                        factors: _helvetica_factors.HelveticaRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _helvetica_factors.HelveticaRegularMetrics
                    };
                    t["Helvetica-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _helvetica_factors.HelveticaBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _helvetica_factors.HelveticaBoldMetrics
                    };
                    t["Helvetica-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _helvetica_factors.HelveticaItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _helvetica_factors.HelveticaItalicMetrics
                    };
                    t["Helvetica-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _helvetica_factors.HelveticaBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _helvetica_factors.HelveticaBoldItalicMetrics
                    };
                });
                function getXfaFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    const fontMap = getXFAFontMap();
                    return fontMap[fontName];
                }
                function getXfaFontWidths(name) {
                    const info = getXfaFontName(name);
                    if (!info) return null;
                    const { baseWidths: baseWidths, baseMapping: baseMapping, factors: factors } = info;
                    const rescaledBaseWidths = !factors ? baseWidths : baseWidths.map((w, i)=>w * factors[i]);
                    let currentCode = -2;
                    let currentArray;
                    const newWidths = [];
                    for (const [unicode, glyphIndex] of baseMapping.map((charUnicode, index)=>[
                            charUnicode,
                            index
                        ]).sort(([unicode1], [unicode2])=>unicode1 - unicode2)){
                        if (unicode === -1) continue;
                        if (unicode === currentCode + 1) {
                            currentArray.push(rescaledBaseWidths[glyphIndex]);
                            currentCode += 1;
                        } else {
                            currentCode = unicode;
                            currentArray = [
                                rescaledBaseWidths[glyphIndex]
                            ];
                            newWidths.push(unicode, currentArray);
                        }
                    }
                    return newWidths;
                }
                function getXfaFontDict(name) {
                    const widths = getXfaFontWidths(name);
                    const dict = new _primitives.Dict(null);
                    dict.set("BaseFont", _primitives.Name.get(name));
                    dict.set("Type", _primitives.Name.get("Font"));
                    dict.set("Subtype", _primitives.Name.get("CIDFontType2"));
                    dict.set("Encoding", _primitives.Name.get("Identity-H"));
                    dict.set("CIDToGIDMap", _primitives.Name.get("Identity"));
                    dict.set("W", widths);
                    dict.set("FirstChar", widths[0]);
                    dict.set("LastChar", widths.at(-2) + widths.at(-1).length - 1);
                    const descriptor = new _primitives.Dict(null);
                    dict.set("FontDescriptor", descriptor);
                    const systemInfo = new _primitives.Dict(null);
                    systemInfo.set("Ordering", "Identity");
                    systemInfo.set("Registry", "Adobe");
                    systemInfo.set("Supplement", 0);
                    dict.set("CIDSystemInfo", systemInfo);
                    return dict;
                }
            /***/ },
            /* 52 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CalibriRegularMetrics = exports.CalibriRegularFactors = exports.CalibriItalicMetrics = exports.CalibriItalicFactors = exports.CalibriBoldMetrics = exports.CalibriBoldItalicMetrics = exports.CalibriBoldItalicFactors = exports.CalibriBoldFactors = void 0;
                const CalibriBoldFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    0.97801,
                    0.92482,
                    0.89552,
                    0.91133,
                    0.81988,
                    0.97566,
                    0.98152,
                    0.93548,
                    0.93548,
                    1.2798,
                    0.85284,
                    0.92794,
                    1,
                    0.96134,
                    1.54657,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.82845,
                    0.82845,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.75859,
                    0.92138,
                    0.83908,
                    0.7762,
                    0.73293,
                    0.87289,
                    0.73133,
                    0.7514,
                    0.81921,
                    0.87356,
                    0.95958,
                    0.59526,
                    0.75727,
                    0.69225,
                    1.04924,
                    0.9121,
                    0.86943,
                    0.79795,
                    0.88198,
                    0.77958,
                    0.70864,
                    0.81055,
                    0.90399,
                    0.88653,
                    0.96017,
                    0.82577,
                    0.77892,
                    0.78257,
                    0.97507,
                    1.54657,
                    0.97507,
                    0.85284,
                    0.89552,
                    0.90176,
                    0.88762,
                    0.8785,
                    0.75241,
                    0.8785,
                    0.90518,
                    0.95015,
                    0.77618,
                    0.8785,
                    0.88401,
                    0.91916,
                    0.86304,
                    0.88401,
                    0.91488,
                    0.8785,
                    0.8801,
                    0.8785,
                    0.8785,
                    0.91343,
                    0.7173,
                    1.04106,
                    0.8785,
                    0.85075,
                    0.95794,
                    0.82616,
                    0.85162,
                    0.79492,
                    0.88331,
                    1.69808,
                    0.88331,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.7801,
                    0.89552,
                    1.24487,
                    1.13254,
                    1.12401,
                    0.96839,
                    0.85284,
                    0.68787,
                    0.70645,
                    0.85592,
                    0.90747,
                    1.01466,
                    1.0088,
                    0.90323,
                    1,
                    1.07463,
                    1,
                    0.91056,
                    0.75806,
                    1.19118,
                    0.96839,
                    0.78864,
                    0.82845,
                    0.84133,
                    0.75859,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.77539,
                    0.73293,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.88506,
                    0.9121,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.85284,
                    0.87508,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.77892,
                    0.79795,
                    0.90807,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.8715,
                    0.75241,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.8785,
                    0.8785,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.90747,
                    0.89049,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.85162,
                    0.8785,
                    0.85162,
                    0.83908,
                    0.88762,
                    0.83908,
                    0.88762,
                    0.83908,
                    0.88762,
                    0.73293,
                    0.75241,
                    0.73293,
                    0.75241,
                    0.73293,
                    0.75241,
                    0.73293,
                    0.75241,
                    0.87289,
                    0.83016,
                    0.88506,
                    0.93125,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.81921,
                    0.77618,
                    0.81921,
                    0.77618,
                    0.81921,
                    0.77618,
                    1,
                    1,
                    0.87356,
                    0.8785,
                    0.91075,
                    0.89608,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.76229,
                    0.90167,
                    0.59526,
                    0.91916,
                    1,
                    1,
                    0.86304,
                    0.69225,
                    0.88401,
                    1,
                    1,
                    0.70424,
                    0.79468,
                    0.91926,
                    0.88175,
                    0.70823,
                    0.94903,
                    0.9121,
                    0.8785,
                    1,
                    1,
                    0.9121,
                    0.8785,
                    0.87802,
                    0.88656,
                    0.8785,
                    0.86943,
                    0.8801,
                    0.86943,
                    0.8801,
                    0.86943,
                    0.8801,
                    0.87402,
                    0.89291,
                    0.77958,
                    0.91343,
                    1,
                    1,
                    0.77958,
                    0.91343,
                    0.70864,
                    0.7173,
                    0.70864,
                    0.7173,
                    0.70864,
                    0.7173,
                    0.70864,
                    0.7173,
                    1,
                    1,
                    0.81055,
                    0.75841,
                    0.81055,
                    1.06452,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.96017,
                    0.95794,
                    0.77892,
                    0.85162,
                    0.77892,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.9297,
                    0.56892,
                    0.83908,
                    0.88762,
                    0.77539,
                    0.8715,
                    0.87508,
                    0.89049,
                    1,
                    1,
                    0.81055,
                    1.04106,
                    1.20528,
                    1.20528,
                    1,
                    1.15543,
                    0.70674,
                    0.98387,
                    0.94721,
                    1.33431,
                    1.45894,
                    0.95161,
                    1.06303,
                    0.83908,
                    0.80352,
                    0.57184,
                    0.6965,
                    0.56289,
                    0.82001,
                    0.56029,
                    0.81235,
                    1.02988,
                    0.83908,
                    0.7762,
                    0.68156,
                    0.80367,
                    0.73133,
                    0.78257,
                    0.87356,
                    0.86943,
                    0.95958,
                    0.75727,
                    0.89019,
                    1.04924,
                    0.9121,
                    0.7648,
                    0.86943,
                    0.87356,
                    0.79795,
                    0.78275,
                    0.81055,
                    0.77892,
                    0.9762,
                    0.82577,
                    0.99819,
                    0.84896,
                    0.95958,
                    0.77892,
                    0.96108,
                    1.01407,
                    0.89049,
                    1.02988,
                    0.94211,
                    0.96108,
                    0.8936,
                    0.84021,
                    0.87842,
                    0.96399,
                    0.79109,
                    0.89049,
                    1.00813,
                    1.02988,
                    0.86077,
                    0.87445,
                    0.92099,
                    0.84723,
                    0.86513,
                    0.8801,
                    0.75638,
                    0.85714,
                    0.78216,
                    0.79586,
                    0.87965,
                    0.94211,
                    0.97747,
                    0.78287,
                    0.97926,
                    0.84971,
                    1.02988,
                    0.94211,
                    0.8801,
                    0.94211,
                    0.84971,
                    0.73133,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90264,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90518,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90548,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96017,
                    0.95794,
                    0.96017,
                    0.95794,
                    0.96017,
                    0.95794,
                    0.77892,
                    0.85162,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90363,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.87012,
                    0.87012,
                    0.87012,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.71143,
                    1.06152,
                    1,
                    1,
                    1.03372,
                    1.03372,
                    0.97171,
                    1.4956,
                    2.2807,
                    0.93835,
                    0.83406,
                    0.91133,
                    0.84107,
                    0.91133,
                    1,
                    1,
                    1,
                    0.72021,
                    1,
                    1.23108,
                    0.83489,
                    0.88525,
                    0.88525,
                    0.81499,
                    0.90527,
                    1.81055,
                    0.90527,
                    1.81055,
                    1.31006,
                    1.53711,
                    0.94434,
                    1.08696,
                    1,
                    0.95018,
                    0.77192,
                    0.85284,
                    0.90747,
                    1.17534,
                    0.69825,
                    0.9716,
                    1.37077,
                    0.90747,
                    0.90747,
                    0.85356,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.08004,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90727,
                    0.90727,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriBoldFactors = CalibriBoldFactors;
                const CalibriBoldMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriBoldMetrics = CalibriBoldMetrics;
                const CalibriBoldItalicFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    0.97801,
                    0.92482,
                    0.89552,
                    0.91133,
                    0.81988,
                    0.97566,
                    0.98152,
                    0.93548,
                    0.93548,
                    1.2798,
                    0.85284,
                    0.92794,
                    1,
                    0.96134,
                    1.56239,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.82845,
                    0.82845,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.75859,
                    0.92138,
                    0.83908,
                    0.7762,
                    0.71805,
                    0.87289,
                    0.73133,
                    0.7514,
                    0.81921,
                    0.87356,
                    0.95958,
                    0.59526,
                    0.75727,
                    0.69225,
                    1.04924,
                    0.90872,
                    0.85938,
                    0.79795,
                    0.87068,
                    0.77958,
                    0.69766,
                    0.81055,
                    0.90399,
                    0.88653,
                    0.96068,
                    0.82577,
                    0.77892,
                    0.78257,
                    0.97507,
                    1.529,
                    0.97507,
                    0.85284,
                    0.89552,
                    0.90176,
                    0.94908,
                    0.86411,
                    0.74012,
                    0.86411,
                    0.88323,
                    0.95015,
                    0.86411,
                    0.86331,
                    0.88401,
                    0.91916,
                    0.86304,
                    0.88401,
                    0.9039,
                    0.86331,
                    0.86331,
                    0.86411,
                    0.86411,
                    0.90464,
                    0.70852,
                    1.04106,
                    0.86331,
                    0.84372,
                    0.95794,
                    0.82616,
                    0.84548,
                    0.79492,
                    0.88331,
                    1.69808,
                    0.88331,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.7801,
                    0.89552,
                    1.24487,
                    1.13254,
                    1.19129,
                    0.96839,
                    0.85284,
                    0.68787,
                    0.70645,
                    0.85592,
                    0.90747,
                    1.01466,
                    1.0088,
                    0.90323,
                    1,
                    1.07463,
                    1,
                    0.91056,
                    0.75806,
                    1.19118,
                    0.96839,
                    0.78864,
                    0.82845,
                    0.84133,
                    0.75859,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.77539,
                    0.71805,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.88506,
                    0.90872,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85284,
                    0.87068,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.77892,
                    0.79795,
                    0.90807,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.85887,
                    0.74012,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.8785,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.90747,
                    0.89049,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.84548,
                    0.86411,
                    0.84548,
                    0.83908,
                    0.94908,
                    0.83908,
                    0.94908,
                    0.83908,
                    0.94908,
                    0.71805,
                    0.74012,
                    0.71805,
                    0.74012,
                    0.71805,
                    0.74012,
                    0.71805,
                    0.74012,
                    0.87289,
                    0.79538,
                    0.88506,
                    0.92726,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.81921,
                    0.86411,
                    0.81921,
                    0.86411,
                    0.81921,
                    0.86411,
                    1,
                    1,
                    0.87356,
                    0.86331,
                    0.91075,
                    0.8777,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.76467,
                    0.90167,
                    0.59526,
                    0.91916,
                    1,
                    1,
                    0.86304,
                    0.69225,
                    0.88401,
                    1,
                    1,
                    0.70424,
                    0.77312,
                    0.91926,
                    0.88175,
                    0.70823,
                    0.94903,
                    0.90872,
                    0.86331,
                    1,
                    1,
                    0.90872,
                    0.86331,
                    0.86906,
                    0.88116,
                    0.86331,
                    0.85938,
                    0.86331,
                    0.85938,
                    0.86331,
                    0.85938,
                    0.86331,
                    0.87402,
                    0.86549,
                    0.77958,
                    0.90464,
                    1,
                    1,
                    0.77958,
                    0.90464,
                    0.69766,
                    0.70852,
                    0.69766,
                    0.70852,
                    0.69766,
                    0.70852,
                    0.69766,
                    0.70852,
                    1,
                    1,
                    0.81055,
                    0.75841,
                    0.81055,
                    1.06452,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.96068,
                    0.95794,
                    0.77892,
                    0.84548,
                    0.77892,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.9297,
                    0.56892,
                    0.83908,
                    0.94908,
                    0.77539,
                    0.85887,
                    0.87068,
                    0.89049,
                    1,
                    1,
                    0.81055,
                    1.04106,
                    1.20528,
                    1.20528,
                    1,
                    1.15543,
                    0.70088,
                    0.98387,
                    0.94721,
                    1.33431,
                    1.45894,
                    0.95161,
                    1.48387,
                    0.83908,
                    0.80352,
                    0.57118,
                    0.6965,
                    0.56347,
                    0.79179,
                    0.55853,
                    0.80346,
                    1.02988,
                    0.83908,
                    0.7762,
                    0.67174,
                    0.86036,
                    0.73133,
                    0.78257,
                    0.87356,
                    0.86441,
                    0.95958,
                    0.75727,
                    0.89019,
                    1.04924,
                    0.90872,
                    0.74889,
                    0.85938,
                    0.87891,
                    0.79795,
                    0.7957,
                    0.81055,
                    0.77892,
                    0.97447,
                    0.82577,
                    0.97466,
                    0.87179,
                    0.95958,
                    0.77892,
                    0.94252,
                    0.95612,
                    0.8753,
                    1.02988,
                    0.92733,
                    0.94252,
                    0.87411,
                    0.84021,
                    0.8728,
                    0.95612,
                    0.74081,
                    0.8753,
                    1.02189,
                    1.02988,
                    0.84814,
                    0.87445,
                    0.91822,
                    0.84723,
                    0.85668,
                    0.86331,
                    0.81344,
                    0.87581,
                    0.76422,
                    0.82046,
                    0.96057,
                    0.92733,
                    0.99375,
                    0.78022,
                    0.95452,
                    0.86015,
                    1.02988,
                    0.92733,
                    0.86331,
                    0.92733,
                    0.86015,
                    0.73133,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90631,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.88323,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.85174,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96068,
                    0.95794,
                    0.96068,
                    0.95794,
                    0.96068,
                    0.95794,
                    0.77892,
                    0.84548,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90363,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.89807,
                    0.87012,
                    0.87012,
                    0.87012,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.71094,
                    1.06152,
                    1,
                    1,
                    1.03372,
                    1.03372,
                    0.97171,
                    1.4956,
                    2.2807,
                    0.92972,
                    0.83406,
                    0.91133,
                    0.83326,
                    0.91133,
                    1,
                    1,
                    1,
                    0.72021,
                    1,
                    1.23108,
                    0.83489,
                    0.88525,
                    0.88525,
                    0.81499,
                    0.90616,
                    1.81055,
                    0.90527,
                    1.81055,
                    1.3107,
                    1.53711,
                    0.94434,
                    1.08696,
                    1,
                    0.95018,
                    0.77192,
                    0.85284,
                    0.90747,
                    1.17534,
                    0.69825,
                    0.9716,
                    1.37077,
                    0.90747,
                    0.90747,
                    0.85356,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.08004,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90727,
                    0.90727,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriBoldItalicFactors = CalibriBoldItalicFactors;
                const CalibriBoldItalicMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriBoldItalicMetrics = CalibriBoldItalicMetrics;
                const CalibriItalicFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    1.17223,
                    1.1293,
                    0.89552,
                    0.91133,
                    0.80395,
                    1.02269,
                    1.15601,
                    0.91056,
                    0.91056,
                    1.2798,
                    0.85284,
                    0.89807,
                    1,
                    0.90861,
                    1.39543,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.96309,
                    0.96309,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.83319,
                    0.88071,
                    0.8675,
                    0.81552,
                    0.72346,
                    0.85193,
                    0.73206,
                    0.7522,
                    0.81105,
                    0.86275,
                    0.90685,
                    0.6377,
                    0.77892,
                    0.75593,
                    1.02638,
                    0.89249,
                    0.84118,
                    0.77452,
                    0.85374,
                    0.75186,
                    0.67789,
                    0.79776,
                    0.88844,
                    0.85066,
                    0.94309,
                    0.77818,
                    0.7306,
                    0.76659,
                    1.10369,
                    1.38313,
                    1.10369,
                    1.06139,
                    0.89552,
                    0.8739,
                    0.9245,
                    0.9245,
                    0.83203,
                    0.9245,
                    0.85865,
                    1.09842,
                    0.9245,
                    0.9245,
                    1.03297,
                    1.07692,
                    0.90918,
                    1.03297,
                    0.94959,
                    0.9245,
                    0.92274,
                    0.9245,
                    0.9245,
                    1.02933,
                    0.77832,
                    1.20562,
                    0.9245,
                    0.8916,
                    0.98986,
                    0.86621,
                    0.89453,
                    0.79004,
                    0.94152,
                    1.77256,
                    0.94152,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.91729,
                    0.89552,
                    1.17889,
                    1.13254,
                    1.16359,
                    0.92098,
                    0.85284,
                    0.68787,
                    0.71353,
                    0.84737,
                    0.90747,
                    1.0088,
                    1.0044,
                    0.87683,
                    1,
                    1.09091,
                    1,
                    0.92229,
                    0.739,
                    1.15642,
                    0.92098,
                    0.76288,
                    0.80504,
                    0.80972,
                    0.75859,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.76318,
                    0.72346,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.86477,
                    0.89249,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.85284,
                    0.84557,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.7306,
                    0.77452,
                    0.86331,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.84843,
                    0.83203,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.94469,
                    0.9245,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.90747,
                    0.86651,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.89453,
                    0.9245,
                    0.89453,
                    0.8675,
                    0.9245,
                    0.8675,
                    0.9245,
                    0.8675,
                    0.9245,
                    0.72346,
                    0.83203,
                    0.72346,
                    0.83203,
                    0.72346,
                    0.83203,
                    0.72346,
                    0.83203,
                    0.85193,
                    0.8875,
                    0.86477,
                    0.99034,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.81105,
                    0.9245,
                    0.81105,
                    0.9245,
                    0.81105,
                    0.9245,
                    1,
                    1,
                    0.86275,
                    0.9245,
                    0.90872,
                    0.93591,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    1.03297,
                    0.90685,
                    0.82601,
                    0.77896,
                    1.05611,
                    0.6377,
                    1.07692,
                    1,
                    1,
                    0.90918,
                    0.75593,
                    1.03297,
                    1,
                    1,
                    0.76032,
                    0.9375,
                    0.98156,
                    0.93407,
                    0.77261,
                    1.11429,
                    0.89249,
                    0.9245,
                    1,
                    1,
                    0.89249,
                    0.9245,
                    0.92534,
                    0.86698,
                    0.9245,
                    0.84118,
                    0.92274,
                    0.84118,
                    0.92274,
                    0.84118,
                    0.92274,
                    0.8667,
                    0.86291,
                    0.75186,
                    1.02933,
                    1,
                    1,
                    0.75186,
                    1.02933,
                    0.67789,
                    0.77832,
                    0.67789,
                    0.77832,
                    0.67789,
                    0.77832,
                    0.67789,
                    0.77832,
                    1,
                    1,
                    0.79776,
                    0.97655,
                    0.79776,
                    1.23023,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.94309,
                    0.98986,
                    0.7306,
                    0.89453,
                    0.7306,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    1.09231,
                    0.54873,
                    0.8675,
                    0.9245,
                    0.76318,
                    0.84843,
                    0.84557,
                    0.86651,
                    1,
                    1,
                    0.79776,
                    1.20562,
                    1.18622,
                    1.18622,
                    1,
                    1.1437,
                    0.67009,
                    0.96334,
                    0.93695,
                    1.35191,
                    1.40909,
                    0.95161,
                    1.48387,
                    0.8675,
                    0.90861,
                    0.6192,
                    0.7363,
                    0.64824,
                    0.82411,
                    0.56321,
                    0.85696,
                    1.23516,
                    0.8675,
                    0.81552,
                    0.7286,
                    0.84134,
                    0.73206,
                    0.76659,
                    0.86275,
                    0.84369,
                    0.90685,
                    0.77892,
                    0.85871,
                    1.02638,
                    0.89249,
                    0.75828,
                    0.84118,
                    0.85984,
                    0.77452,
                    0.76466,
                    0.79776,
                    0.7306,
                    0.90782,
                    0.77818,
                    0.903,
                    0.87291,
                    0.90685,
                    0.7306,
                    0.99058,
                    1.03667,
                    0.94635,
                    1.23516,
                    0.9849,
                    0.99058,
                    0.92393,
                    0.8916,
                    0.942,
                    1.03667,
                    0.75026,
                    0.94635,
                    1.0297,
                    1.23516,
                    0.90918,
                    0.94048,
                    0.98217,
                    0.89746,
                    0.84153,
                    0.92274,
                    0.82507,
                    0.88832,
                    0.84438,
                    0.88178,
                    1.03525,
                    0.9849,
                    1.00225,
                    0.78086,
                    0.97248,
                    0.89404,
                    1.23516,
                    0.9849,
                    0.92274,
                    0.9849,
                    0.89404,
                    0.73206,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.89693,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.85865,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90933,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94309,
                    0.98986,
                    0.94309,
                    0.98986,
                    0.94309,
                    0.98986,
                    0.7306,
                    0.89453,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90186,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.2566,
                    1.2566,
                    1.2566,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.68994,
                    1.03809,
                    1,
                    1,
                    1.0176,
                    1.0176,
                    1.11523,
                    1.4956,
                    2.01462,
                    0.97858,
                    0.82616,
                    0.91133,
                    0.83437,
                    0.91133,
                    1,
                    1,
                    1,
                    0.70508,
                    1,
                    1.23108,
                    0.79801,
                    0.84426,
                    0.84426,
                    0.774,
                    0.90572,
                    1.81055,
                    0.90749,
                    1.81055,
                    1.28809,
                    1.55469,
                    0.94434,
                    1.07806,
                    1,
                    0.97094,
                    0.7589,
                    0.85284,
                    0.90747,
                    1.19658,
                    0.69825,
                    0.97622,
                    1.33512,
                    0.90747,
                    0.90747,
                    0.85284,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.0336,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriItalicFactors = CalibriItalicFactors;
                const CalibriItalicMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriItalicMetrics = CalibriItalicMetrics;
                const CalibriRegularFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    1.17223,
                    1.1293,
                    0.89552,
                    0.91133,
                    0.80395,
                    1.02269,
                    1.15601,
                    0.91056,
                    0.91056,
                    1.2798,
                    0.85284,
                    0.89807,
                    1,
                    0.90861,
                    1.39016,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.96309,
                    0.96309,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.83319,
                    0.88071,
                    0.8675,
                    0.81552,
                    0.73834,
                    0.85193,
                    0.73206,
                    0.7522,
                    0.81105,
                    0.86275,
                    0.90685,
                    0.6377,
                    0.77892,
                    0.75593,
                    1.02638,
                    0.89385,
                    0.85122,
                    0.77452,
                    0.86503,
                    0.75186,
                    0.68887,
                    0.79776,
                    0.88844,
                    0.85066,
                    0.94258,
                    0.77818,
                    0.7306,
                    0.76659,
                    1.10369,
                    1.39016,
                    1.10369,
                    1.06139,
                    0.89552,
                    0.8739,
                    0.86128,
                    0.94469,
                    0.8457,
                    0.94469,
                    0.89464,
                    1.09842,
                    0.84636,
                    0.94469,
                    1.03297,
                    1.07692,
                    0.90918,
                    1.03297,
                    0.95897,
                    0.94469,
                    0.9482,
                    0.94469,
                    0.94469,
                    1.04692,
                    0.78223,
                    1.20562,
                    0.94469,
                    0.90332,
                    0.98986,
                    0.86621,
                    0.90527,
                    0.79004,
                    0.94152,
                    1.77256,
                    0.94152,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.91729,
                    0.89552,
                    1.17889,
                    1.13254,
                    1.08707,
                    0.92098,
                    0.85284,
                    0.68787,
                    0.71353,
                    0.84737,
                    0.90747,
                    1.0088,
                    1.0044,
                    0.87683,
                    1,
                    1.09091,
                    1,
                    0.92229,
                    0.739,
                    1.15642,
                    0.92098,
                    0.76288,
                    0.80504,
                    0.80972,
                    0.75859,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.76318,
                    0.73834,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.86477,
                    0.89385,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85284,
                    0.85311,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.7306,
                    0.77452,
                    0.86331,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.8693,
                    0.8457,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.94469,
                    0.94469,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.90747,
                    0.86651,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.90527,
                    0.94469,
                    0.90527,
                    0.8675,
                    0.86128,
                    0.8675,
                    0.86128,
                    0.8675,
                    0.86128,
                    0.73834,
                    0.8457,
                    0.73834,
                    0.8457,
                    0.73834,
                    0.8457,
                    0.73834,
                    0.8457,
                    0.85193,
                    0.92454,
                    0.86477,
                    0.9921,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.81105,
                    0.84636,
                    0.81105,
                    0.84636,
                    0.81105,
                    0.84636,
                    1,
                    1,
                    0.86275,
                    0.94469,
                    0.90872,
                    0.95786,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    1.03297,
                    0.90685,
                    0.82601,
                    0.77741,
                    1.05611,
                    0.6377,
                    1.07692,
                    1,
                    1,
                    0.90918,
                    0.75593,
                    1.03297,
                    1,
                    1,
                    0.76032,
                    0.90452,
                    0.98156,
                    1.11842,
                    0.77261,
                    1.11429,
                    0.89385,
                    0.94469,
                    1,
                    1,
                    0.89385,
                    0.94469,
                    0.95877,
                    0.86901,
                    0.94469,
                    0.85122,
                    0.9482,
                    0.85122,
                    0.9482,
                    0.85122,
                    0.9482,
                    0.8667,
                    0.90016,
                    0.75186,
                    1.04692,
                    1,
                    1,
                    0.75186,
                    1.04692,
                    0.68887,
                    0.78223,
                    0.68887,
                    0.78223,
                    0.68887,
                    0.78223,
                    0.68887,
                    0.78223,
                    1,
                    1,
                    0.79776,
                    0.92188,
                    0.79776,
                    1.23023,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.94258,
                    0.98986,
                    0.7306,
                    0.90527,
                    0.7306,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    1.09231,
                    0.54873,
                    0.8675,
                    0.86128,
                    0.76318,
                    0.8693,
                    0.85311,
                    0.86651,
                    1,
                    1,
                    0.79776,
                    1.20562,
                    1.18622,
                    1.18622,
                    1,
                    1.1437,
                    0.67742,
                    0.96334,
                    0.93695,
                    1.35191,
                    1.40909,
                    0.95161,
                    1.48387,
                    0.86686,
                    0.90861,
                    0.62267,
                    0.74359,
                    0.65649,
                    0.85498,
                    0.56963,
                    0.88254,
                    1.23516,
                    0.8675,
                    0.81552,
                    0.75443,
                    0.84503,
                    0.73206,
                    0.76659,
                    0.86275,
                    0.85122,
                    0.90685,
                    0.77892,
                    0.85746,
                    1.02638,
                    0.89385,
                    0.75657,
                    0.85122,
                    0.86275,
                    0.77452,
                    0.74171,
                    0.79776,
                    0.7306,
                    0.95165,
                    0.77818,
                    0.89772,
                    0.88831,
                    0.90685,
                    0.7306,
                    0.98142,
                    1.02191,
                    0.96576,
                    1.23516,
                    0.99018,
                    0.98142,
                    0.9236,
                    0.89258,
                    0.94035,
                    1.02191,
                    0.78848,
                    0.96576,
                    0.9561,
                    1.23516,
                    0.90918,
                    0.92578,
                    0.95424,
                    0.89746,
                    0.83969,
                    0.9482,
                    0.80113,
                    0.89442,
                    0.85208,
                    0.86155,
                    0.98022,
                    0.99018,
                    1.00452,
                    0.81209,
                    0.99247,
                    0.89181,
                    1.23516,
                    0.99018,
                    0.9482,
                    0.99018,
                    0.89181,
                    0.73206,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.88844,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.89464,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96766,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94258,
                    0.98986,
                    0.94258,
                    0.98986,
                    0.94258,
                    0.98986,
                    0.7306,
                    0.90527,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90186,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.2566,
                    1.2566,
                    1.2566,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.69043,
                    1.03809,
                    1,
                    1,
                    1.0176,
                    1.0176,
                    1.11523,
                    1.4956,
                    2.01462,
                    0.99331,
                    0.82616,
                    0.91133,
                    0.84286,
                    0.91133,
                    1,
                    1,
                    1,
                    0.70508,
                    1,
                    1.23108,
                    0.79801,
                    0.84426,
                    0.84426,
                    0.774,
                    0.90527,
                    1.81055,
                    0.90527,
                    1.81055,
                    1.28809,
                    1.55469,
                    0.94434,
                    1.07806,
                    1,
                    0.97094,
                    0.7589,
                    0.85284,
                    0.90747,
                    1.19658,
                    0.69825,
                    0.97622,
                    1.33512,
                    0.90747,
                    0.90747,
                    0.85356,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.0336,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    1,
                    1,
                    1,
                    1.07185,
                    0.99413,
                    0.96334,
                    1.08065,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriRegularFactors = CalibriRegularFactors;
                const CalibriRegularMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriRegularMetrics = CalibriRegularMetrics;
            /***/ },
            /* 53 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HelveticaRegularMetrics = exports.HelveticaRegularFactors = exports.HelveticaItalicMetrics = exports.HelveticaItalicFactors = exports.HelveticaBoldMetrics = exports.HelveticaBoldItalicMetrics = exports.HelveticaBoldItalicFactors = exports.HelveticaBoldFactors = void 0;
                const HelveticaBoldFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    0.99998,
                    0.99974,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99977,
                    1.00087,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    1.00026,
                    0.9999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    0.99973,
                    0.99977,
                    1.00026,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99998,
                    1.0006,
                    0.99998,
                    1.00003,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.0006,
                    0.99982,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99959,
                    0.99973,
                    0.99998,
                    1.00026,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99973,
                    1,
                    0.99959,
                    1.00077,
                    0.99959,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00077,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99973,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.06409,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    1.03374,
                    0.99977,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00042,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.03828,
                    1.00026,
                    0.99999,
                    1.00026,
                    1.0006,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.9993,
                    0.9998,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1,
                    1.00016,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    1.00026,
                    0.8121,
                    1.00026,
                    0.99998,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.0006,
                    0.99973,
                    0.99977,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1.00034,
                    0.99977,
                    1,
                    0.99997,
                    1.00026,
                    1.00078,
                    1.00036,
                    0.99973,
                    1.00013,
                    1.0006,
                    0.99977,
                    0.99977,
                    0.99988,
                    0.85148,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    0.99977,
                    1.00001,
                    0.99999,
                    0.99977,
                    1.00069,
                    1.00022,
                    0.99977,
                    1.00001,
                    0.99984,
                    1.00026,
                    1.00001,
                    1.00024,
                    1.00001,
                    0.9999,
                    1,
                    1.0006,
                    1.00001,
                    1.00041,
                    0.99962,
                    1.00026,
                    1.0006,
                    0.99995,
                    1.00041,
                    0.99942,
                    0.99973,
                    0.99927,
                    1.00082,
                    0.99902,
                    1.00026,
                    1.00087,
                    1.0006,
                    1.00069,
                    0.99973,
                    0.99867,
                    0.99973,
                    0.9993,
                    1.00026,
                    1.00049,
                    1.00056,
                    1,
                    0.99988,
                    0.99935,
                    0.99995,
                    0.99954,
                    1.00055,
                    0.99945,
                    1.00032,
                    1.0006,
                    0.99995,
                    1.00026,
                    0.99995,
                    1.00032,
                    1.00001,
                    1.00008,
                    0.99971,
                    1.00019,
                    0.9994,
                    1.00001,
                    1.0006,
                    1.00044,
                    0.99973,
                    1.00023,
                    1.00047,
                    1,
                    0.99942,
                    0.99561,
                    0.99989,
                    1.00035,
                    0.99977,
                    1.00035,
                    0.99977,
                    1.00019,
                    0.99944,
                    1.00001,
                    1.00021,
                    0.99926,
                    1.00035,
                    1.00035,
                    0.99942,
                    1.00048,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99989,
                    1.00057,
                    1.00001,
                    0.99936,
                    1.00052,
                    1.00012,
                    0.99996,
                    1.00043,
                    1,
                    1.00035,
                    0.9994,
                    0.99976,
                    1.00035,
                    0.99973,
                    1.00052,
                    1.00041,
                    1.00119,
                    1.00037,
                    0.99973,
                    1.00002,
                    0.99986,
                    1.00041,
                    1.00041,
                    0.99902,
                    0.9996,
                    1.00034,
                    0.99999,
                    1.00026,
                    0.99999,
                    1.00026,
                    0.99973,
                    1.00052,
                    0.99973,
                    1,
                    0.99973,
                    1.00041,
                    1.00075,
                    0.9994,
                    1.0003,
                    0.99999,
                    1,
                    1.00041,
                    0.99955,
                    1,
                    0.99915,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.00119,
                    0.99955,
                    0.99973,
                    1.0006,
                    0.99911,
                    1.0006,
                    1.00026,
                    0.99972,
                    1.00026,
                    0.99902,
                    1.00041,
                    0.99973,
                    0.99999,
                    1,
                    1,
                    1.00038,
                    1.0005,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00106,
                    0.99999,
                    0.99998,
                    0.99998,
                    0.99999,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1.00023,
                    0.99973,
                    0.99971,
                    1.00047,
                    1.00023,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99972,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    1.00031,
                    1.00015,
                    1,
                    0.99561,
                    1.00027,
                    1.00031,
                    1.00031,
                    0.99915,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99972,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaBoldFactors = HelveticaBoldFactors;
                const HelveticaBoldMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.HelveticaBoldMetrics = HelveticaBoldMetrics;
                const HelveticaBoldItalicFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    0.99998,
                    0.99974,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99977,
                    1.00087,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    1.00026,
                    0.9999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    0.99973,
                    0.99977,
                    1.00026,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99998,
                    1.0006,
                    0.99998,
                    1.00003,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.0006,
                    0.99982,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99959,
                    0.99973,
                    0.99998,
                    1.00026,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99973,
                    1,
                    0.99959,
                    1.00077,
                    0.99959,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00077,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99973,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.06409,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    1.0044,
                    0.99977,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99971,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.01011,
                    1.00026,
                    0.99999,
                    1.00026,
                    1.0006,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.9993,
                    0.9998,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1,
                    1.00016,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    1.00026,
                    0.8121,
                    1.00026,
                    0.99998,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.0006,
                    0.99973,
                    0.99977,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99977,
                    1,
                    1,
                    1.00026,
                    0.99969,
                    0.99972,
                    0.99981,
                    0.9998,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    0.91155,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    0.99977,
                    1.00001,
                    0.99999,
                    0.99977,
                    0.99966,
                    1.00022,
                    1.00032,
                    1.00001,
                    0.99944,
                    1.00026,
                    1.00001,
                    0.99968,
                    1.00001,
                    1.00047,
                    1,
                    1.0006,
                    1.00001,
                    0.99981,
                    1.00101,
                    1.00026,
                    1.0006,
                    0.99948,
                    0.99981,
                    1.00064,
                    0.99973,
                    0.99942,
                    1.00101,
                    1.00061,
                    1.00026,
                    1.00069,
                    1.0006,
                    1.00014,
                    0.99973,
                    1.01322,
                    0.99973,
                    1.00065,
                    1.00026,
                    1.00012,
                    0.99923,
                    1,
                    1.00064,
                    1.00076,
                    0.99948,
                    1.00055,
                    1.00063,
                    1.00007,
                    0.99943,
                    1.0006,
                    0.99948,
                    1.00026,
                    0.99948,
                    0.99943,
                    1.00001,
                    1.00001,
                    1.00029,
                    1.00038,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99978,
                    1.00001,
                    1.00057,
                    0.99989,
                    0.99967,
                    0.99964,
                    0.99967,
                    0.99977,
                    0.99999,
                    0.99977,
                    1.00038,
                    0.99977,
                    1.00001,
                    0.99973,
                    1.00066,
                    0.99967,
                    0.99967,
                    1.00041,
                    0.99998,
                    0.99999,
                    0.99977,
                    1.00022,
                    0.99967,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99964,
                    1.00031,
                    1.00001,
                    0.99999,
                    0.99999,
                    1,
                    1.00023,
                    1,
                    1,
                    0.99999,
                    1.00035,
                    1.00001,
                    0.99999,
                    0.99973,
                    0.99977,
                    0.99999,
                    1.00058,
                    0.99973,
                    0.99973,
                    0.99955,
                    0.9995,
                    1.00026,
                    1.00026,
                    1.00032,
                    0.99989,
                    1.00034,
                    0.99999,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.45998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00001,
                    0.99999,
                    0.99982,
                    0.99994,
                    0.99996,
                    1,
                    1.00042,
                    1.00044,
                    1.00029,
                    1.00023,
                    0.99973,
                    0.99973,
                    1.00026,
                    0.99949,
                    1.00002,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99975,
                    1.00026,
                    1.00026,
                    1.00032,
                    0.98685,
                    0.99973,
                    1.00026,
                    1,
                    1,
                    0.99966,
                    1.00044,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00106,
                    0.99999,
                    0.99998,
                    0.99998,
                    0.99999,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99971,
                    0.99978,
                    1,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00098,
                    1,
                    1,
                    1,
                    1.00049,
                    1,
                    1,
                    0.99972,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    1.00031,
                    1.00015,
                    1,
                    0.99561,
                    1.00027,
                    1.00031,
                    1.00031,
                    0.99915,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99972,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaBoldItalicFactors = HelveticaBoldItalicFactors;
                const HelveticaBoldItalicMetrics = {
                    lineHeight: 1.35,
                    lineGap: 0.2
                };
                exports.HelveticaBoldItalicMetrics = HelveticaBoldItalicMetrics;
                const HelveticaItalicFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.00006,
                    0.99973,
                    0.99973,
                    0.99982,
                    1.00001,
                    1.00043,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    0.99973,
                    0.99987,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    1,
                    1.00001,
                    0.99973,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99949,
                    0.99973,
                    0.99998,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99924,
                    0.99924,
                    1,
                    0.99924,
                    0.99999,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.0006,
                    0.99973,
                    1,
                    0.99977,
                    1,
                    1,
                    1,
                    1.00005,
                    1.0009,
                    1.00005,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0009,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.9998,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.06409,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    1,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1.0288,
                    0.99977,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99924,
                    1.0006,
                    1.0006,
                    0.99946,
                    1.00034,
                    1,
                    0.99924,
                    1.00001,
                    1,
                    1,
                    0.99973,
                    0.99924,
                    0.99973,
                    0.99924,
                    0.99973,
                    1.06311,
                    0.99973,
                    1.00024,
                    0.99973,
                    0.99924,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.00041,
                    0.9998,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1,
                    1.00016,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    1.00026,
                    0.89547,
                    1.00026,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    0.99924,
                    0.99973,
                    1.00001,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1.00001,
                    1,
                    1.00054,
                    0.99977,
                    1.00084,
                    1.00007,
                    0.99973,
                    1.00013,
                    0.99924,
                    1.00001,
                    1.00001,
                    0.99945,
                    0.91221,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    1.00001,
                    1.00001,
                    0.99999,
                    0.99977,
                    0.99933,
                    1.00022,
                    1.00054,
                    1.00001,
                    1.00065,
                    1.00026,
                    1.00001,
                    1.0001,
                    1.00001,
                    1.00052,
                    1,
                    1.0006,
                    1.00001,
                    0.99945,
                    0.99897,
                    0.99968,
                    0.99924,
                    1.00036,
                    0.99945,
                    0.99949,
                    1,
                    1.0006,
                    0.99897,
                    0.99918,
                    0.99968,
                    0.99911,
                    0.99924,
                    1,
                    0.99962,
                    1.01487,
                    1,
                    1.0005,
                    0.99973,
                    1.00012,
                    1.00043,
                    1,
                    0.99995,
                    0.99994,
                    1.00036,
                    0.99947,
                    1.00019,
                    1.00063,
                    1.00025,
                    0.99924,
                    1.00036,
                    0.99973,
                    1.00036,
                    1.00025,
                    1.00001,
                    1.00001,
                    1.00027,
                    1.0001,
                    1.00068,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    1.00008,
                    0.99957,
                    0.99972,
                    0.9994,
                    0.99954,
                    0.99975,
                    1.00051,
                    1.00001,
                    1.00019,
                    1.00001,
                    1.0001,
                    0.99986,
                    1.00001,
                    1.00001,
                    1.00038,
                    0.99954,
                    0.99954,
                    0.9994,
                    1.00066,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00054,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99975,
                    1.0001,
                    1.00001,
                    0.99993,
                    0.9995,
                    0.99955,
                    1.00016,
                    0.99978,
                    0.99974,
                    1.00019,
                    1.00022,
                    0.99955,
                    1.00053,
                    0.99973,
                    1.00089,
                    1.00005,
                    0.99967,
                    1.00048,
                    0.99973,
                    1.00002,
                    1.00034,
                    0.99973,
                    0.99973,
                    0.99964,
                    1.00006,
                    1.00066,
                    0.99947,
                    0.99973,
                    0.98894,
                    0.99973,
                    1,
                    0.44898,
                    1,
                    0.99946,
                    1,
                    1.00039,
                    1.00082,
                    0.99991,
                    0.99991,
                    0.99985,
                    1.00022,
                    1.00023,
                    1.00061,
                    1.00006,
                    0.99966,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00019,
                    1.0008,
                    1,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99983,
                    1.00044,
                    0.99973,
                    0.99964,
                    0.98332,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99962,
                    0.99895,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00267,
                    0.99999,
                    0.99998,
                    0.99998,
                    1,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1.00023,
                    0.99973,
                    1.00423,
                    0.99925,
                    0.99999,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00049,
                    1,
                    1.00245,
                    1,
                    1,
                    1,
                    1,
                    0.96329,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    0.8254,
                    1.00015,
                    1,
                    1.00035,
                    1.00027,
                    1.00031,
                    1.00031,
                    1.00003,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.95317,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaItalicFactors = HelveticaItalicFactors;
                const HelveticaItalicMetrics = {
                    lineHeight: 1.35,
                    lineGap: 0.2
                };
                exports.HelveticaItalicMetrics = HelveticaItalicMetrics;
                const HelveticaRegularFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.00006,
                    0.99973,
                    0.99973,
                    0.99982,
                    1.00001,
                    1.00043,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    0.99973,
                    0.99987,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    1,
                    1.00001,
                    0.99973,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99949,
                    0.99973,
                    0.99998,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99924,
                    0.99924,
                    1,
                    0.99924,
                    0.99999,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.0006,
                    0.99973,
                    1,
                    0.99977,
                    1,
                    1,
                    1,
                    1.00005,
                    1.0009,
                    1.00005,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0009,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.9998,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.06409,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    1,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1.04596,
                    0.99977,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99924,
                    1.0006,
                    1.0006,
                    1.00019,
                    1.00034,
                    1,
                    0.99924,
                    1.00001,
                    1,
                    1,
                    0.99973,
                    0.99924,
                    0.99973,
                    0.99924,
                    0.99973,
                    1.02572,
                    0.99973,
                    1.00005,
                    0.99973,
                    0.99924,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99999,
                    0.9998,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1,
                    1.00016,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    1.00026,
                    0.84533,
                    1.00026,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    0.99924,
                    0.99973,
                    1.00001,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99928,
                    1,
                    0.99977,
                    1.00013,
                    1.00055,
                    0.99947,
                    0.99945,
                    0.99941,
                    0.99924,
                    1.00001,
                    1.00001,
                    1.0004,
                    0.91621,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    1.00001,
                    1.00005,
                    0.99999,
                    0.99977,
                    1.00015,
                    1.00022,
                    0.99977,
                    1.00001,
                    0.99973,
                    1.00026,
                    1.00001,
                    1.00019,
                    1.00001,
                    0.99946,
                    1,
                    1.0006,
                    1.00001,
                    0.99978,
                    1.00045,
                    0.99973,
                    0.99924,
                    1.00023,
                    0.99978,
                    0.99966,
                    1,
                    1.00065,
                    1.00045,
                    1.00019,
                    0.99973,
                    0.99973,
                    0.99924,
                    1,
                    1,
                    0.96499,
                    1,
                    1.00055,
                    0.99973,
                    1.00008,
                    1.00027,
                    1,
                    0.9997,
                    0.99995,
                    1.00023,
                    0.99933,
                    1.00019,
                    1.00015,
                    1.00031,
                    0.99924,
                    1.00023,
                    0.99973,
                    1.00023,
                    1.00031,
                    1.00001,
                    0.99928,
                    1.00029,
                    1.00092,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    0.99988,
                    0.99975,
                    1,
                    1.00082,
                    0.99561,
                    0.9996,
                    1.00035,
                    1.00001,
                    0.99962,
                    1.00001,
                    1.00092,
                    0.99964,
                    1.00001,
                    0.99963,
                    0.99999,
                    1.00035,
                    1.00035,
                    1.00082,
                    0.99962,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.9996,
                    0.99967,
                    1.00001,
                    1.00034,
                    1.00074,
                    1.00054,
                    1.00053,
                    1.00063,
                    0.99971,
                    0.99962,
                    1.00035,
                    0.99975,
                    0.99977,
                    0.99973,
                    1.00043,
                    0.99953,
                    1.0007,
                    0.99915,
                    0.99973,
                    1.00008,
                    0.99892,
                    1.00073,
                    1.00073,
                    1.00114,
                    0.99915,
                    1.00073,
                    0.99955,
                    0.99973,
                    1.00092,
                    0.99973,
                    1,
                    0.99998,
                    1,
                    1.0003,
                    1,
                    1.00043,
                    1.00001,
                    0.99969,
                    1.0003,
                    1,
                    1.00035,
                    1.00001,
                    0.9995,
                    1,
                    1.00092,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0007,
                    0.9995,
                    1,
                    0.99924,
                    1.0006,
                    0.99924,
                    0.99972,
                    1.00062,
                    0.99973,
                    1.00114,
                    1.00073,
                    1,
                    0.99955,
                    1,
                    1,
                    1.00047,
                    0.99968,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00267,
                    0.99999,
                    0.99998,
                    0.99998,
                    1,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1.00023,
                    0.99973,
                    0.99971,
                    0.99925,
                    1.00023,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96329,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    0.8254,
                    1.00015,
                    1,
                    1.00035,
                    1.00027,
                    1.00031,
                    1.00031,
                    0.99915,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.95317,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaRegularFactors = HelveticaRegularFactors;
                const HelveticaRegularMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.HelveticaRegularMetrics = HelveticaRegularMetrics;
            /***/ },
            /* 54 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LiberationSansRegularWidths = exports.LiberationSansRegularMapping = exports.LiberationSansItalicWidths = exports.LiberationSansItalicMapping = exports.LiberationSansBoldWidths = exports.LiberationSansBoldMapping = exports.LiberationSansBoldItalicWidths = exports.LiberationSansBoldItalicMapping = void 0;
                const LiberationSansBoldWidths = [
                    365,
                    0,
                    333,
                    278,
                    333,
                    474,
                    556,
                    556,
                    889,
                    722,
                    238,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    584,
                    584,
                    584,
                    611,
                    975,
                    722,
                    722,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    556,
                    722,
                    611,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    333,
                    278,
                    333,
                    584,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    556,
                    333,
                    611,
                    611,
                    278,
                    278,
                    556,
                    278,
                    889,
                    611,
                    611,
                    611,
                    611,
                    389,
                    556,
                    333,
                    611,
                    556,
                    778,
                    556,
                    556,
                    500,
                    389,
                    280,
                    389,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    280,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    556,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    549,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    611,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    719,
                    722,
                    611,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    722,
                    611,
                    722,
                    611,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    785,
                    556,
                    556,
                    278,
                    722,
                    556,
                    556,
                    611,
                    278,
                    611,
                    278,
                    611,
                    385,
                    611,
                    479,
                    611,
                    278,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    708,
                    723,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    1000,
                    944,
                    722,
                    389,
                    722,
                    389,
                    722,
                    389,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    611,
                    333,
                    611,
                    479,
                    611,
                    333,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    944,
                    778,
                    667,
                    556,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    278,
                    556,
                    722,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    556,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    465,
                    722,
                    333,
                    853,
                    906,
                    474,
                    825,
                    927,
                    838,
                    278,
                    722,
                    722,
                    601,
                    719,
                    667,
                    611,
                    722,
                    778,
                    278,
                    722,
                    667,
                    833,
                    722,
                    644,
                    778,
                    722,
                    667,
                    600,
                    611,
                    667,
                    821,
                    667,
                    809,
                    802,
                    278,
                    667,
                    615,
                    451,
                    611,
                    278,
                    582,
                    615,
                    610,
                    556,
                    606,
                    475,
                    460,
                    611,
                    541,
                    278,
                    558,
                    556,
                    612,
                    556,
                    445,
                    611,
                    766,
                    619,
                    520,
                    684,
                    446,
                    582,
                    715,
                    576,
                    753,
                    845,
                    278,
                    582,
                    611,
                    582,
                    845,
                    667,
                    669,
                    885,
                    567,
                    711,
                    667,
                    278,
                    276,
                    556,
                    1094,
                    1062,
                    875,
                    610,
                    722,
                    622,
                    719,
                    722,
                    719,
                    722,
                    567,
                    712,
                    667,
                    904,
                    626,
                    719,
                    719,
                    610,
                    702,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    622,
                    854,
                    667,
                    730,
                    703,
                    1005,
                    1019,
                    870,
                    979,
                    719,
                    711,
                    1031,
                    719,
                    556,
                    618,
                    615,
                    417,
                    635,
                    556,
                    709,
                    497,
                    615,
                    615,
                    500,
                    635,
                    740,
                    604,
                    611,
                    604,
                    611,
                    556,
                    490,
                    556,
                    875,
                    556,
                    615,
                    581,
                    833,
                    844,
                    729,
                    854,
                    615,
                    552,
                    854,
                    583,
                    556,
                    556,
                    611,
                    417,
                    552,
                    556,
                    278,
                    281,
                    278,
                    969,
                    906,
                    611,
                    500,
                    615,
                    556,
                    604,
                    778,
                    611,
                    487,
                    447,
                    944,
                    778,
                    944,
                    778,
                    944,
                    778,
                    667,
                    556,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    278,
                    278,
                    278,
                    278,
                    500,
                    500,
                    500,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    240,
                    479,
                    333,
                    333,
                    604,
                    333,
                    167,
                    396,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    489,
                    1115,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1000,
                    500,
                    1000,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    722,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    611,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333
                ];
                exports.LiberationSansBoldWidths = LiberationSansBoldWidths;
                const LiberationSansBoldMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansBoldMapping = LiberationSansBoldMapping;
                const LiberationSansBoldItalicWidths = [
                    365,
                    0,
                    333,
                    278,
                    333,
                    474,
                    556,
                    556,
                    889,
                    722,
                    238,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    584,
                    584,
                    584,
                    611,
                    975,
                    722,
                    722,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    556,
                    722,
                    611,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    333,
                    278,
                    333,
                    584,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    556,
                    333,
                    611,
                    611,
                    278,
                    278,
                    556,
                    278,
                    889,
                    611,
                    611,
                    611,
                    611,
                    389,
                    556,
                    333,
                    611,
                    556,
                    778,
                    556,
                    556,
                    500,
                    389,
                    280,
                    389,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    280,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    556,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    549,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    611,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    740,
                    722,
                    611,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    722,
                    611,
                    722,
                    611,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    782,
                    556,
                    556,
                    278,
                    722,
                    556,
                    556,
                    611,
                    278,
                    611,
                    278,
                    611,
                    396,
                    611,
                    479,
                    611,
                    278,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    708,
                    723,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    1000,
                    944,
                    722,
                    389,
                    722,
                    389,
                    722,
                    389,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    611,
                    333,
                    611,
                    479,
                    611,
                    333,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    944,
                    778,
                    667,
                    556,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    278,
                    556,
                    722,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    556,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    722,
                    333,
                    854,
                    906,
                    473,
                    844,
                    930,
                    847,
                    278,
                    722,
                    722,
                    610,
                    671,
                    667,
                    611,
                    722,
                    778,
                    278,
                    722,
                    667,
                    833,
                    722,
                    657,
                    778,
                    718,
                    667,
                    590,
                    611,
                    667,
                    822,
                    667,
                    829,
                    781,
                    278,
                    667,
                    620,
                    479,
                    611,
                    278,
                    591,
                    620,
                    621,
                    556,
                    610,
                    479,
                    492,
                    611,
                    558,
                    278,
                    566,
                    556,
                    603,
                    556,
                    450,
                    611,
                    712,
                    605,
                    532,
                    664,
                    409,
                    591,
                    704,
                    578,
                    773,
                    834,
                    278,
                    591,
                    611,
                    591,
                    834,
                    667,
                    667,
                    886,
                    614,
                    719,
                    667,
                    278,
                    278,
                    556,
                    1094,
                    1042,
                    854,
                    622,
                    719,
                    677,
                    719,
                    722,
                    708,
                    722,
                    614,
                    722,
                    667,
                    927,
                    643,
                    719,
                    719,
                    615,
                    687,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    677,
                    781,
                    667,
                    729,
                    708,
                    979,
                    989,
                    854,
                    1000,
                    708,
                    719,
                    1042,
                    729,
                    556,
                    619,
                    604,
                    534,
                    618,
                    556,
                    736,
                    510,
                    611,
                    611,
                    507,
                    622,
                    740,
                    604,
                    611,
                    611,
                    611,
                    556,
                    889,
                    556,
                    885,
                    556,
                    646,
                    583,
                    889,
                    935,
                    707,
                    854,
                    594,
                    552,
                    865,
                    589,
                    556,
                    556,
                    611,
                    469,
                    563,
                    556,
                    278,
                    278,
                    278,
                    969,
                    906,
                    611,
                    507,
                    619,
                    556,
                    611,
                    778,
                    611,
                    575,
                    467,
                    944,
                    778,
                    944,
                    778,
                    944,
                    778,
                    667,
                    556,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    278,
                    278,
                    278,
                    278,
                    500,
                    500,
                    500,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    240,
                    479,
                    333,
                    333,
                    604,
                    333,
                    167,
                    396,
                    556,
                    556,
                    1104,
                    556,
                    885,
                    516,
                    1146,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    999,
                    500,
                    1000,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    722,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    611,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333
                ];
                exports.LiberationSansBoldItalicWidths = LiberationSansBoldItalicWidths;
                const LiberationSansBoldItalicMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansBoldItalicMapping = LiberationSansBoldItalicMapping;
                const LiberationSansItalicWidths = [
                    365,
                    0,
                    333,
                    278,
                    278,
                    355,
                    556,
                    556,
                    889,
                    667,
                    191,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    584,
                    584,
                    584,
                    556,
                    1015,
                    667,
                    667,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    500,
                    667,
                    556,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    278,
                    278,
                    278,
                    469,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    278,
                    556,
                    556,
                    222,
                    222,
                    500,
                    222,
                    833,
                    556,
                    556,
                    556,
                    556,
                    333,
                    500,
                    278,
                    556,
                    500,
                    722,
                    500,
                    500,
                    500,
                    334,
                    260,
                    334,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    260,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    537,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    500,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    549,
                    611,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    500,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    625,
                    722,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    722,
                    556,
                    722,
                    556,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    222,
                    278,
                    278,
                    733,
                    444,
                    500,
                    222,
                    667,
                    500,
                    500,
                    556,
                    222,
                    556,
                    222,
                    556,
                    281,
                    556,
                    400,
                    556,
                    222,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    615,
                    723,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    1000,
                    944,
                    722,
                    333,
                    722,
                    333,
                    722,
                    333,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    611,
                    278,
                    611,
                    354,
                    611,
                    278,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    944,
                    722,
                    667,
                    500,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    222,
                    556,
                    667,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    500,
                    611,
                    278,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    667,
                    278,
                    789,
                    846,
                    389,
                    794,
                    865,
                    775,
                    222,
                    667,
                    667,
                    570,
                    671,
                    667,
                    611,
                    722,
                    778,
                    278,
                    667,
                    667,
                    833,
                    722,
                    648,
                    778,
                    725,
                    667,
                    600,
                    611,
                    667,
                    837,
                    667,
                    831,
                    761,
                    278,
                    667,
                    570,
                    439,
                    555,
                    222,
                    550,
                    570,
                    571,
                    500,
                    556,
                    439,
                    463,
                    555,
                    542,
                    222,
                    500,
                    492,
                    548,
                    500,
                    447,
                    556,
                    670,
                    573,
                    486,
                    603,
                    374,
                    550,
                    652,
                    546,
                    728,
                    779,
                    222,
                    550,
                    556,
                    550,
                    779,
                    667,
                    667,
                    843,
                    544,
                    708,
                    667,
                    278,
                    278,
                    500,
                    1066,
                    982,
                    844,
                    589,
                    715,
                    639,
                    724,
                    667,
                    651,
                    667,
                    544,
                    704,
                    667,
                    917,
                    614,
                    715,
                    715,
                    589,
                    686,
                    833,
                    722,
                    778,
                    725,
                    667,
                    722,
                    611,
                    639,
                    795,
                    667,
                    727,
                    673,
                    920,
                    923,
                    805,
                    886,
                    651,
                    694,
                    1022,
                    682,
                    556,
                    562,
                    522,
                    493,
                    553,
                    556,
                    688,
                    465,
                    556,
                    556,
                    472,
                    564,
                    686,
                    550,
                    556,
                    556,
                    556,
                    500,
                    833,
                    500,
                    835,
                    500,
                    572,
                    518,
                    830,
                    851,
                    621,
                    736,
                    526,
                    492,
                    752,
                    534,
                    556,
                    556,
                    556,
                    378,
                    496,
                    500,
                    222,
                    222,
                    222,
                    910,
                    828,
                    556,
                    472,
                    565,
                    500,
                    556,
                    778,
                    556,
                    492,
                    339,
                    944,
                    722,
                    944,
                    722,
                    944,
                    722,
                    667,
                    500,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    222,
                    222,
                    222,
                    222,
                    333,
                    333,
                    333,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    188,
                    354,
                    333,
                    333,
                    500,
                    333,
                    167,
                    365,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    323,
                    1083,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1000,
                    500,
                    998,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    719,
                    274,
                    549,
                    549,
                    584,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    500,
                    500,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285
                ];
                exports.LiberationSansItalicWidths = LiberationSansItalicWidths;
                const LiberationSansItalicMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansItalicMapping = LiberationSansItalicMapping;
                const LiberationSansRegularWidths = [
                    365,
                    0,
                    333,
                    278,
                    278,
                    355,
                    556,
                    556,
                    889,
                    667,
                    191,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    584,
                    584,
                    584,
                    556,
                    1015,
                    667,
                    667,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    500,
                    667,
                    556,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    278,
                    278,
                    278,
                    469,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    278,
                    556,
                    556,
                    222,
                    222,
                    500,
                    222,
                    833,
                    556,
                    556,
                    556,
                    556,
                    333,
                    500,
                    278,
                    556,
                    500,
                    722,
                    500,
                    500,
                    500,
                    334,
                    260,
                    334,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    260,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    537,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    500,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    549,
                    611,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    500,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    615,
                    722,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    722,
                    556,
                    722,
                    556,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    222,
                    278,
                    278,
                    735,
                    444,
                    500,
                    222,
                    667,
                    500,
                    500,
                    556,
                    222,
                    556,
                    222,
                    556,
                    292,
                    556,
                    334,
                    556,
                    222,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    604,
                    723,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    1000,
                    944,
                    722,
                    333,
                    722,
                    333,
                    722,
                    333,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    611,
                    278,
                    611,
                    375,
                    611,
                    278,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    944,
                    722,
                    667,
                    500,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    222,
                    556,
                    667,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    500,
                    611,
                    278,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    667,
                    278,
                    784,
                    838,
                    384,
                    774,
                    855,
                    752,
                    222,
                    667,
                    667,
                    551,
                    668,
                    667,
                    611,
                    722,
                    778,
                    278,
                    667,
                    668,
                    833,
                    722,
                    650,
                    778,
                    722,
                    667,
                    618,
                    611,
                    667,
                    798,
                    667,
                    835,
                    748,
                    278,
                    667,
                    578,
                    446,
                    556,
                    222,
                    547,
                    578,
                    575,
                    500,
                    557,
                    446,
                    441,
                    556,
                    556,
                    222,
                    500,
                    500,
                    576,
                    500,
                    448,
                    556,
                    690,
                    569,
                    482,
                    617,
                    395,
                    547,
                    648,
                    525,
                    713,
                    781,
                    222,
                    547,
                    556,
                    547,
                    781,
                    667,
                    667,
                    865,
                    542,
                    719,
                    667,
                    278,
                    278,
                    500,
                    1057,
                    1010,
                    854,
                    583,
                    722,
                    635,
                    719,
                    667,
                    656,
                    667,
                    542,
                    677,
                    667,
                    923,
                    604,
                    719,
                    719,
                    583,
                    656,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    635,
                    760,
                    667,
                    740,
                    667,
                    917,
                    938,
                    792,
                    885,
                    656,
                    719,
                    1010,
                    722,
                    556,
                    573,
                    531,
                    365,
                    583,
                    556,
                    669,
                    458,
                    559,
                    559,
                    438,
                    583,
                    688,
                    552,
                    556,
                    542,
                    556,
                    500,
                    458,
                    500,
                    823,
                    500,
                    573,
                    521,
                    802,
                    823,
                    625,
                    719,
                    521,
                    510,
                    750,
                    542,
                    556,
                    556,
                    556,
                    365,
                    510,
                    500,
                    222,
                    278,
                    222,
                    906,
                    812,
                    556,
                    438,
                    559,
                    500,
                    552,
                    778,
                    556,
                    489,
                    411,
                    944,
                    722,
                    944,
                    722,
                    944,
                    722,
                    667,
                    500,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    222,
                    222,
                    222,
                    222,
                    333,
                    333,
                    333,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    188,
                    354,
                    333,
                    333,
                    500,
                    333,
                    167,
                    365,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    323,
                    1073,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1000,
                    500,
                    1000,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    719,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    500,
                    500,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285
                ];
                exports.LiberationSansRegularWidths = LiberationSansRegularWidths;
                const LiberationSansRegularMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansRegularMapping = LiberationSansRegularMapping;
            /***/ },
            /* 55 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MyriadProRegularMetrics = exports.MyriadProRegularFactors = exports.MyriadProItalicMetrics = exports.MyriadProItalicFactors = exports.MyriadProBoldMetrics = exports.MyriadProBoldItalicMetrics = exports.MyriadProBoldItalicFactors = exports.MyriadProBoldFactors = void 0;
                const MyriadProBoldFactors = [
                    1.36898,
                    1,
                    1,
                    0.72706,
                    0.80479,
                    0.83734,
                    0.98894,
                    0.99793,
                    0.9897,
                    0.93884,
                    0.86209,
                    0.94292,
                    0.94292,
                    1.16661,
                    1.02058,
                    0.93582,
                    0.96694,
                    0.93582,
                    1.19137,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.78076,
                    0.78076,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.72851,
                    0.78966,
                    0.90838,
                    0.83637,
                    0.82391,
                    0.96376,
                    0.80061,
                    0.86275,
                    0.8768,
                    0.95407,
                    1.0258,
                    0.73901,
                    0.85022,
                    0.83655,
                    1.0156,
                    0.95546,
                    0.92179,
                    0.87107,
                    0.92179,
                    0.82114,
                    0.8096,
                    0.89713,
                    0.94438,
                    0.95353,
                    0.94083,
                    0.91905,
                    0.90406,
                    0.9446,
                    0.94292,
                    1.18777,
                    0.94292,
                    1.02058,
                    0.89903,
                    0.90088,
                    0.94938,
                    0.97898,
                    0.81093,
                    0.97571,
                    0.94938,
                    1.024,
                    0.9577,
                    0.95933,
                    0.98621,
                    1.0474,
                    0.97455,
                    0.98981,
                    0.9672,
                    0.95933,
                    0.9446,
                    0.97898,
                    0.97407,
                    0.97646,
                    0.78036,
                    1.10208,
                    0.95442,
                    0.95298,
                    0.97579,
                    0.9332,
                    0.94039,
                    0.938,
                    0.80687,
                    1.01149,
                    0.80687,
                    1.02058,
                    0.80479,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    1.01149,
                    1.00872,
                    0.90088,
                    0.91882,
                    1.0213,
                    0.8361,
                    1.02058,
                    0.62295,
                    0.54324,
                    0.89022,
                    1.08595,
                    1,
                    1,
                    0.90088,
                    1,
                    0.97455,
                    0.93582,
                    0.90088,
                    1,
                    1.05686,
                    0.8361,
                    0.99642,
                    0.99642,
                    0.99642,
                    0.72851,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.868,
                    0.82391,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    0.97484,
                    0.95546,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    1.02058,
                    0.92179,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.90406,
                    0.86958,
                    0.98225,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.9031,
                    0.81093,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.93969,
                    0.95933,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    1.08595,
                    0.9446,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.94039,
                    0.97898,
                    0.94039,
                    0.90838,
                    0.94938,
                    0.90838,
                    0.94938,
                    0.90838,
                    0.94938,
                    0.82391,
                    0.81093,
                    0.82391,
                    0.81093,
                    0.82391,
                    0.81093,
                    0.82391,
                    0.81093,
                    0.96376,
                    0.84313,
                    0.97484,
                    0.97571,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.8768,
                    0.9577,
                    0.8768,
                    0.9577,
                    0.8768,
                    0.9577,
                    1,
                    1,
                    0.95407,
                    0.95933,
                    0.97069,
                    0.95933,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    0.887,
                    1.01591,
                    0.73901,
                    1.0474,
                    1,
                    1,
                    0.97455,
                    0.83655,
                    0.98981,
                    1,
                    1,
                    0.83655,
                    0.73977,
                    0.83655,
                    0.73903,
                    0.84638,
                    1.033,
                    0.95546,
                    0.95933,
                    1,
                    1,
                    0.95546,
                    0.95933,
                    0.8271,
                    0.95417,
                    0.95933,
                    0.92179,
                    0.9446,
                    0.92179,
                    0.9446,
                    0.92179,
                    0.9446,
                    0.936,
                    0.91964,
                    0.82114,
                    0.97646,
                    1,
                    1,
                    0.82114,
                    0.97646,
                    0.8096,
                    0.78036,
                    0.8096,
                    0.78036,
                    1,
                    1,
                    0.8096,
                    0.78036,
                    1,
                    1,
                    0.89713,
                    0.77452,
                    0.89713,
                    1.10208,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94083,
                    0.97579,
                    0.90406,
                    0.94039,
                    0.90406,
                    0.9446,
                    0.938,
                    0.9446,
                    0.938,
                    0.9446,
                    0.938,
                    1,
                    0.99793,
                    0.90838,
                    0.94938,
                    0.868,
                    0.9031,
                    0.92179,
                    0.9446,
                    1,
                    1,
                    0.89713,
                    1.10208,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90989,
                    0.9358,
                    0.91945,
                    0.83181,
                    0.75261,
                    0.87992,
                    0.82976,
                    0.96034,
                    0.83689,
                    0.97268,
                    1.0078,
                    0.90838,
                    0.83637,
                    0.8019,
                    0.90157,
                    0.80061,
                    0.9446,
                    0.95407,
                    0.92436,
                    1.0258,
                    0.85022,
                    0.97153,
                    1.0156,
                    0.95546,
                    0.89192,
                    0.92179,
                    0.92361,
                    0.87107,
                    0.96318,
                    0.89713,
                    0.93704,
                    0.95638,
                    0.91905,
                    0.91709,
                    0.92796,
                    1.0258,
                    0.93704,
                    0.94836,
                    1.0373,
                    0.95933,
                    1.0078,
                    0.95871,
                    0.94836,
                    0.96174,
                    0.92601,
                    0.9498,
                    0.98607,
                    0.95776,
                    0.95933,
                    1.05453,
                    1.0078,
                    0.98275,
                    0.9314,
                    0.95617,
                    0.91701,
                    1.05993,
                    0.9446,
                    0.78367,
                    0.9553,
                    1,
                    0.86832,
                    1.0128,
                    0.95871,
                    0.99394,
                    0.87548,
                    0.96361,
                    0.86774,
                    1.0078,
                    0.95871,
                    0.9446,
                    0.95871,
                    0.86774,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94083,
                    0.97579,
                    0.94083,
                    0.97579,
                    0.94083,
                    0.97579,
                    0.90406,
                    0.94039,
                    0.96694,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.93582,
                    0.93582,
                    0.93582,
                    1,
                    0.908,
                    0.908,
                    0.918,
                    0.94219,
                    0.94219,
                    0.96544,
                    1,
                    1.285,
                    1,
                    1,
                    0.81079,
                    0.81079,
                    1,
                    1,
                    0.74854,
                    1,
                    1,
                    1,
                    1,
                    0.99793,
                    1,
                    1,
                    1,
                    0.65,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.17173,
                    1,
                    0.80535,
                    0.76169,
                    1.02058,
                    1.0732,
                    1.05486,
                    1,
                    1,
                    1.30692,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.16161,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProBoldFactors = MyriadProBoldFactors;
                const MyriadProBoldMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProBoldMetrics = MyriadProBoldMetrics;
                const MyriadProBoldItalicFactors = [
                    1.36898,
                    1,
                    1,
                    0.66227,
                    0.80779,
                    0.81625,
                    0.97276,
                    0.97276,
                    0.97733,
                    0.92222,
                    0.83266,
                    0.94292,
                    0.94292,
                    1.16148,
                    1.02058,
                    0.93582,
                    0.96694,
                    0.93582,
                    1.17337,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.78076,
                    0.78076,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.71541,
                    0.76813,
                    0.85576,
                    0.80591,
                    0.80729,
                    0.94299,
                    0.77512,
                    0.83655,
                    0.86523,
                    0.92222,
                    0.98621,
                    0.71743,
                    0.81698,
                    0.79726,
                    0.98558,
                    0.92222,
                    0.90637,
                    0.83809,
                    0.90637,
                    0.80729,
                    0.76463,
                    0.86275,
                    0.90699,
                    0.91605,
                    0.9154,
                    0.85308,
                    0.85458,
                    0.90531,
                    0.94292,
                    1.21296,
                    0.94292,
                    1.02058,
                    0.89903,
                    1.18616,
                    0.99613,
                    0.91677,
                    0.78216,
                    0.91677,
                    0.90083,
                    0.98796,
                    0.9135,
                    0.92168,
                    0.95381,
                    0.98981,
                    0.95298,
                    0.95381,
                    0.93459,
                    0.92168,
                    0.91513,
                    0.92004,
                    0.91677,
                    0.95077,
                    0.748,
                    1.04502,
                    0.91677,
                    0.92061,
                    0.94236,
                    0.89544,
                    0.89364,
                    0.9,
                    0.80687,
                    0.8578,
                    0.80687,
                    1.02058,
                    0.80779,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.8578,
                    0.99973,
                    1.18616,
                    0.91339,
                    1.08074,
                    0.82891,
                    1.02058,
                    0.55509,
                    0.71526,
                    0.89022,
                    1.08595,
                    1,
                    1,
                    1.18616,
                    1,
                    0.96736,
                    0.93582,
                    1.18616,
                    1,
                    1.04864,
                    0.82711,
                    0.99043,
                    0.99043,
                    0.99043,
                    0.71541,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.845,
                    0.80729,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.95961,
                    0.92222,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    1.02058,
                    0.90251,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.85458,
                    0.83659,
                    0.94951,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.85811,
                    0.78216,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.9135,
                    0.92168,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.91513,
                    1.08595,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.89364,
                    0.92332,
                    0.89364,
                    0.85576,
                    0.99613,
                    0.85576,
                    0.99613,
                    0.85576,
                    0.99613,
                    0.80729,
                    0.78216,
                    0.80729,
                    0.78216,
                    0.80729,
                    0.78216,
                    0.80729,
                    0.78216,
                    0.94299,
                    0.76783,
                    0.95961,
                    0.91677,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.86523,
                    0.9135,
                    0.86523,
                    0.9135,
                    0.86523,
                    0.9135,
                    1,
                    1,
                    0.92222,
                    0.92168,
                    0.92222,
                    0.92168,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.86036,
                    0.97096,
                    0.71743,
                    0.98981,
                    1,
                    1,
                    0.95298,
                    0.79726,
                    0.95381,
                    1,
                    1,
                    0.79726,
                    0.6894,
                    0.79726,
                    0.74321,
                    0.81691,
                    1.0006,
                    0.92222,
                    0.92168,
                    1,
                    1,
                    0.92222,
                    0.92168,
                    0.79464,
                    0.92098,
                    0.92168,
                    0.90637,
                    0.91513,
                    0.90637,
                    0.91513,
                    0.90637,
                    0.91513,
                    0.909,
                    0.87514,
                    0.80729,
                    0.95077,
                    1,
                    1,
                    0.80729,
                    0.95077,
                    0.76463,
                    0.748,
                    0.76463,
                    0.748,
                    1,
                    1,
                    0.76463,
                    0.748,
                    1,
                    1,
                    0.86275,
                    0.72651,
                    0.86275,
                    1.04502,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.9154,
                    0.94236,
                    0.85458,
                    0.89364,
                    0.85458,
                    0.90531,
                    0.9,
                    0.90531,
                    0.9,
                    0.90531,
                    0.9,
                    1,
                    0.97276,
                    0.85576,
                    0.99613,
                    0.845,
                    0.85811,
                    0.90251,
                    0.91677,
                    1,
                    1,
                    0.86275,
                    1.04502,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.00899,
                    1.30628,
                    0.85576,
                    0.80178,
                    0.66862,
                    0.7927,
                    0.69323,
                    0.88127,
                    0.72459,
                    0.89711,
                    0.95381,
                    0.85576,
                    0.80591,
                    0.7805,
                    0.94729,
                    0.77512,
                    0.90531,
                    0.92222,
                    0.90637,
                    0.98621,
                    0.81698,
                    0.92655,
                    0.98558,
                    0.92222,
                    0.85359,
                    0.90637,
                    0.90976,
                    0.83809,
                    0.94523,
                    0.86275,
                    0.83509,
                    0.93157,
                    0.85308,
                    0.83392,
                    0.92346,
                    0.98621,
                    0.83509,
                    0.92886,
                    0.91324,
                    0.92168,
                    0.95381,
                    0.90646,
                    0.92886,
                    0.90557,
                    0.86847,
                    0.90276,
                    0.91324,
                    0.86842,
                    0.92168,
                    0.99531,
                    0.95381,
                    0.9224,
                    0.85408,
                    0.92699,
                    0.86847,
                    1.0051,
                    0.91513,
                    0.80487,
                    0.93481,
                    1,
                    0.88159,
                    1.05214,
                    0.90646,
                    0.97355,
                    0.81539,
                    0.89398,
                    0.85923,
                    0.95381,
                    0.90646,
                    0.91513,
                    0.90646,
                    0.85923,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.9154,
                    0.94236,
                    0.9154,
                    0.94236,
                    0.9154,
                    0.94236,
                    0.85458,
                    0.89364,
                    0.96694,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.91782,
                    0.91782,
                    0.91782,
                    1,
                    0.896,
                    0.896,
                    0.896,
                    0.9332,
                    0.9332,
                    0.95973,
                    1,
                    1.26,
                    1,
                    1,
                    0.80479,
                    0.80178,
                    1,
                    1,
                    0.85633,
                    1,
                    1,
                    1,
                    1,
                    0.97276,
                    1,
                    1,
                    1,
                    0.698,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.14542,
                    1,
                    0.79199,
                    0.78694,
                    1.02058,
                    1.03493,
                    1.05486,
                    1,
                    1,
                    1.23026,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.20006,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProBoldItalicFactors = MyriadProBoldItalicFactors;
                const MyriadProBoldItalicMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProBoldItalicMetrics = MyriadProBoldItalicMetrics;
                const MyriadProItalicFactors = [
                    1.36898,
                    1,
                    1,
                    0.65507,
                    0.84943,
                    0.85639,
                    0.88465,
                    0.88465,
                    0.86936,
                    0.88307,
                    0.86948,
                    0.85283,
                    0.85283,
                    1.06383,
                    1.02058,
                    0.75945,
                    0.9219,
                    0.75945,
                    1.17337,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.75945,
                    0.75945,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.69046,
                    0.70926,
                    0.85158,
                    0.77812,
                    0.76852,
                    0.89591,
                    0.70466,
                    0.76125,
                    0.80094,
                    0.86822,
                    0.83864,
                    0.728,
                    0.77212,
                    0.79475,
                    0.93637,
                    0.87514,
                    0.8588,
                    0.76013,
                    0.8588,
                    0.72421,
                    0.69866,
                    0.77598,
                    0.85991,
                    0.80811,
                    0.87832,
                    0.78112,
                    0.77512,
                    0.8562,
                    1.0222,
                    1.18417,
                    1.0222,
                    1.27014,
                    0.89903,
                    1.15012,
                    0.93859,
                    0.94399,
                    0.846,
                    0.94399,
                    0.81453,
                    1.0186,
                    0.94219,
                    0.96017,
                    1.03075,
                    1.02175,
                    0.912,
                    1.03075,
                    0.96998,
                    0.96017,
                    0.93859,
                    0.94399,
                    0.94399,
                    0.95493,
                    0.746,
                    1.12658,
                    0.94578,
                    0.91,
                    0.979,
                    0.882,
                    0.882,
                    0.83,
                    0.85034,
                    0.83537,
                    0.85034,
                    1.02058,
                    0.70869,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.83537,
                    0.90083,
                    1.15012,
                    0.9161,
                    0.94565,
                    0.73541,
                    1.02058,
                    0.53609,
                    0.69353,
                    0.79519,
                    1.08595,
                    1,
                    1,
                    1.15012,
                    1,
                    0.91974,
                    0.75945,
                    1.15012,
                    1,
                    0.9446,
                    0.73361,
                    0.9005,
                    0.9005,
                    0.9005,
                    0.62864,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.773,
                    0.76852,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.90561,
                    0.87514,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    1.02058,
                    0.85751,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.77512,
                    0.76013,
                    0.88075,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.8075,
                    0.846,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.82424,
                    0.82424,
                    0.82424,
                    0.82424,
                    0.9278,
                    0.96017,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    1.08595,
                    0.8562,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.882,
                    0.94578,
                    0.882,
                    0.85158,
                    0.93859,
                    0.85158,
                    0.93859,
                    0.85158,
                    0.93859,
                    0.76852,
                    0.846,
                    0.76852,
                    0.846,
                    0.76852,
                    0.846,
                    0.76852,
                    0.846,
                    0.89591,
                    0.8544,
                    0.90561,
                    0.94399,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.80094,
                    0.94219,
                    0.80094,
                    0.94219,
                    0.80094,
                    0.94219,
                    1,
                    1,
                    0.86822,
                    0.96017,
                    0.86822,
                    0.96017,
                    0.83864,
                    0.82424,
                    0.83864,
                    0.82424,
                    0.83864,
                    0.82424,
                    0.83864,
                    1.03075,
                    0.83864,
                    0.82424,
                    0.81402,
                    1.02738,
                    0.728,
                    1.02175,
                    1,
                    1,
                    0.912,
                    0.79475,
                    1.03075,
                    1,
                    1,
                    0.79475,
                    0.83911,
                    0.79475,
                    0.66266,
                    0.80553,
                    1.06676,
                    0.87514,
                    0.96017,
                    1,
                    1,
                    0.87514,
                    0.96017,
                    0.86865,
                    0.87396,
                    0.96017,
                    0.8588,
                    0.93859,
                    0.8588,
                    0.93859,
                    0.8588,
                    0.93859,
                    0.867,
                    0.84759,
                    0.72421,
                    0.95493,
                    1,
                    1,
                    0.72421,
                    0.95493,
                    0.69866,
                    0.746,
                    0.69866,
                    0.746,
                    1,
                    1,
                    0.69866,
                    0.746,
                    1,
                    1,
                    0.77598,
                    0.88417,
                    0.77598,
                    1.12658,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.87832,
                    0.979,
                    0.77512,
                    0.882,
                    0.77512,
                    0.8562,
                    0.83,
                    0.8562,
                    0.83,
                    0.8562,
                    0.83,
                    1,
                    0.88465,
                    0.85158,
                    0.93859,
                    0.773,
                    0.8075,
                    0.85751,
                    0.8562,
                    1,
                    1,
                    0.77598,
                    1.12658,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15313,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.08106,
                    1.03901,
                    0.85158,
                    0.77025,
                    0.62264,
                    0.7646,
                    0.65351,
                    0.86026,
                    0.69461,
                    0.89947,
                    1.03075,
                    0.85158,
                    0.77812,
                    0.76449,
                    0.88836,
                    0.70466,
                    0.8562,
                    0.86822,
                    0.8588,
                    0.83864,
                    0.77212,
                    0.85308,
                    0.93637,
                    0.87514,
                    0.82352,
                    0.8588,
                    0.85701,
                    0.76013,
                    0.89058,
                    0.77598,
                    0.8156,
                    0.82565,
                    0.78112,
                    0.77899,
                    0.89386,
                    0.83864,
                    0.8156,
                    0.9486,
                    0.92388,
                    0.96186,
                    1.03075,
                    0.91123,
                    0.9486,
                    0.93298,
                    0.878,
                    0.93942,
                    0.92388,
                    0.84596,
                    0.96186,
                    0.95119,
                    1.03075,
                    0.922,
                    0.88787,
                    0.95829,
                    0.88,
                    0.93559,
                    0.93859,
                    0.78815,
                    0.93758,
                    1,
                    0.89217,
                    1.03737,
                    0.91123,
                    0.93969,
                    0.77487,
                    0.85769,
                    0.86799,
                    1.03075,
                    0.91123,
                    0.93859,
                    0.91123,
                    0.86799,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.87832,
                    0.979,
                    0.87832,
                    0.979,
                    0.87832,
                    0.979,
                    0.77512,
                    0.882,
                    0.9219,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.87321,
                    0.87321,
                    0.87321,
                    1,
                    1.027,
                    1.027,
                    1.027,
                    0.86847,
                    0.86847,
                    0.79121,
                    1,
                    1.124,
                    1,
                    1,
                    0.73572,
                    0.73572,
                    1,
                    1,
                    0.85034,
                    1,
                    1,
                    1,
                    1,
                    0.88465,
                    1,
                    1,
                    1,
                    0.669,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.04828,
                    1,
                    0.74948,
                    0.75187,
                    1.02058,
                    0.98391,
                    1.02119,
                    1,
                    1,
                    1.06233,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05233,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProItalicFactors = MyriadProItalicFactors;
                const MyriadProItalicMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProItalicMetrics = MyriadProItalicMetrics;
                const MyriadProRegularFactors = [
                    1.36898,
                    1,
                    1,
                    0.76305,
                    0.82784,
                    0.94935,
                    0.89364,
                    0.92241,
                    0.89073,
                    0.90706,
                    0.98472,
                    0.85283,
                    0.85283,
                    1.0664,
                    1.02058,
                    0.74505,
                    0.9219,
                    0.74505,
                    1.23456,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.74505,
                    0.74505,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.73002,
                    0.72601,
                    0.91755,
                    0.8126,
                    0.80314,
                    0.92222,
                    0.73764,
                    0.79726,
                    0.83051,
                    0.90284,
                    0.86023,
                    0.74,
                    0.8126,
                    0.84869,
                    0.96518,
                    0.91115,
                    0.8858,
                    0.79761,
                    0.8858,
                    0.74498,
                    0.73914,
                    0.81363,
                    0.89591,
                    0.83659,
                    0.89633,
                    0.85608,
                    0.8111,
                    0.90531,
                    1.0222,
                    1.22736,
                    1.0222,
                    1.27014,
                    0.89903,
                    0.90088,
                    0.86667,
                    1.0231,
                    0.896,
                    1.01411,
                    0.90083,
                    1.05099,
                    1.00512,
                    0.99793,
                    1.05326,
                    1.09377,
                    0.938,
                    1.06226,
                    1.00119,
                    0.99793,
                    0.98714,
                    1.0231,
                    1.01231,
                    0.98196,
                    0.792,
                    1.19137,
                    0.99074,
                    0.962,
                    1.01915,
                    0.926,
                    0.942,
                    0.856,
                    0.85034,
                    0.92006,
                    0.85034,
                    1.02058,
                    0.69067,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92006,
                    0.9332,
                    0.90088,
                    0.91882,
                    0.93484,
                    0.75339,
                    1.02058,
                    0.56866,
                    0.54324,
                    0.79519,
                    1.08595,
                    1,
                    1,
                    0.90088,
                    1,
                    0.95325,
                    0.74505,
                    0.90088,
                    1,
                    0.97198,
                    0.75339,
                    0.91009,
                    0.91009,
                    0.91009,
                    0.66466,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.788,
                    0.80314,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.92915,
                    0.91115,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    1.02058,
                    0.8858,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.8111,
                    0.79611,
                    0.89713,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86936,
                    0.896,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.84224,
                    0.84224,
                    0.84224,
                    0.84224,
                    0.97276,
                    0.99793,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.98714,
                    1.08595,
                    0.89876,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.942,
                    1.0231,
                    0.942,
                    0.91755,
                    0.86667,
                    0.91755,
                    0.86667,
                    0.91755,
                    0.86667,
                    0.80314,
                    0.896,
                    0.80314,
                    0.896,
                    0.80314,
                    0.896,
                    0.80314,
                    0.896,
                    0.92222,
                    0.93372,
                    0.92915,
                    1.01411,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.83051,
                    1.00512,
                    0.83051,
                    1.00512,
                    0.83051,
                    1.00512,
                    1,
                    1,
                    0.90284,
                    0.99793,
                    0.90976,
                    0.99793,
                    0.86023,
                    0.84224,
                    0.86023,
                    0.84224,
                    0.86023,
                    0.84224,
                    0.86023,
                    1.05326,
                    0.86023,
                    0.84224,
                    0.82873,
                    1.07469,
                    0.74,
                    1.09377,
                    1,
                    1,
                    0.938,
                    0.84869,
                    1.06226,
                    1,
                    1,
                    0.84869,
                    0.83704,
                    0.84869,
                    0.81441,
                    0.85588,
                    1.08927,
                    0.91115,
                    0.99793,
                    1,
                    1,
                    0.91115,
                    0.99793,
                    0.91887,
                    0.90991,
                    0.99793,
                    0.8858,
                    0.98714,
                    0.8858,
                    0.98714,
                    0.8858,
                    0.98714,
                    0.894,
                    0.91434,
                    0.74498,
                    0.98196,
                    1,
                    1,
                    0.74498,
                    0.98196,
                    0.73914,
                    0.792,
                    0.73914,
                    0.792,
                    1,
                    1,
                    0.73914,
                    0.792,
                    1,
                    1,
                    0.81363,
                    0.904,
                    0.81363,
                    1.19137,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89633,
                    1.01915,
                    0.8111,
                    0.942,
                    0.8111,
                    0.90531,
                    0.856,
                    0.90531,
                    0.856,
                    0.90531,
                    0.856,
                    1,
                    0.92241,
                    0.91755,
                    0.86667,
                    0.788,
                    0.86936,
                    0.8858,
                    0.89876,
                    1,
                    1,
                    0.81363,
                    1.19137,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90388,
                    1.03901,
                    0.92138,
                    0.78105,
                    0.7154,
                    0.86169,
                    0.80513,
                    0.94007,
                    0.82528,
                    0.98612,
                    1.06226,
                    0.91755,
                    0.8126,
                    0.81884,
                    0.92819,
                    0.73764,
                    0.90531,
                    0.90284,
                    0.8858,
                    0.86023,
                    0.8126,
                    0.91172,
                    0.96518,
                    0.91115,
                    0.83089,
                    0.8858,
                    0.87791,
                    0.79761,
                    0.89297,
                    0.81363,
                    0.88157,
                    0.89992,
                    0.85608,
                    0.81992,
                    0.94307,
                    0.86023,
                    0.88157,
                    0.95308,
                    0.98699,
                    0.99793,
                    1.06226,
                    0.95817,
                    0.95308,
                    0.97358,
                    0.928,
                    0.98088,
                    0.98699,
                    0.92761,
                    0.99793,
                    0.96017,
                    1.06226,
                    0.986,
                    0.944,
                    0.95978,
                    0.938,
                    0.96705,
                    0.98714,
                    0.80442,
                    0.98972,
                    1,
                    0.89762,
                    1.04552,
                    0.95817,
                    0.99007,
                    0.87064,
                    0.91879,
                    0.88888,
                    1.06226,
                    0.95817,
                    0.98714,
                    0.95817,
                    0.88888,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.89633,
                    1.01915,
                    0.89633,
                    1.01915,
                    0.89633,
                    1.01915,
                    0.8111,
                    0.942,
                    0.9219,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.93173,
                    0.93173,
                    0.93173,
                    1,
                    1.06304,
                    1.06304,
                    1.06904,
                    0.89903,
                    0.89903,
                    0.80549,
                    1,
                    1.156,
                    1,
                    1,
                    0.76575,
                    0.76575,
                    1,
                    1,
                    0.72458,
                    1,
                    1,
                    1,
                    1,
                    0.92241,
                    1,
                    1,
                    1,
                    0.619,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.07257,
                    1,
                    0.74705,
                    0.71119,
                    1.02058,
                    1.024,
                    1.02119,
                    1,
                    1,
                    1.1536,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05638,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProRegularFactors = MyriadProRegularFactors;
                const MyriadProRegularMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProRegularMetrics = MyriadProRegularMetrics;
            /***/ },
            /* 56 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SegoeuiRegularMetrics = exports.SegoeuiRegularFactors = exports.SegoeuiItalicMetrics = exports.SegoeuiItalicFactors = exports.SegoeuiBoldMetrics = exports.SegoeuiBoldItalicMetrics = exports.SegoeuiBoldItalicFactors = exports.SegoeuiBoldFactors = void 0;
                const SegoeuiBoldFactors = [
                    1.76738,
                    1,
                    1,
                    0.99297,
                    0.9824,
                    1.04016,
                    1.06497,
                    1.03424,
                    0.97529,
                    1.17647,
                    1.23203,
                    1.1085,
                    1.1085,
                    1.16939,
                    1.2107,
                    0.9754,
                    1.21408,
                    0.9754,
                    1.59578,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    0.81378,
                    0.81378,
                    1.2107,
                    1.2107,
                    1.2107,
                    0.71703,
                    0.97847,
                    0.97363,
                    0.88776,
                    0.8641,
                    1.02096,
                    0.79795,
                    0.85132,
                    0.914,
                    1.06085,
                    1.1406,
                    0.8007,
                    0.89858,
                    0.83693,
                    1.14889,
                    1.09398,
                    0.97489,
                    0.92094,
                    0.97489,
                    0.90399,
                    0.84041,
                    0.95923,
                    1.00135,
                    1,
                    1.06467,
                    0.98243,
                    0.90996,
                    0.99361,
                    1.1085,
                    1.56942,
                    1.1085,
                    1.2107,
                    0.74627,
                    0.94282,
                    0.96752,
                    1.01519,
                    0.86304,
                    1.01359,
                    0.97278,
                    1.15103,
                    1.01359,
                    0.98561,
                    1.02285,
                    1.02285,
                    1.00527,
                    1.02285,
                    1.0302,
                    0.99041,
                    1.0008,
                    1.01519,
                    1.01359,
                    1.02258,
                    0.79104,
                    1.16862,
                    0.99041,
                    0.97454,
                    1.02511,
                    0.99298,
                    0.96752,
                    0.95801,
                    0.94856,
                    1.16579,
                    0.94856,
                    1.2107,
                    0.9824,
                    1.03424,
                    1.03424,
                    1,
                    1.03424,
                    1.16579,
                    0.8727,
                    1.3871,
                    1.18622,
                    1.10818,
                    1.04478,
                    1.2107,
                    1.18622,
                    0.75155,
                    0.94994,
                    1.28826,
                    1.21408,
                    1.21408,
                    0.91056,
                    1,
                    0.91572,
                    0.9754,
                    0.64663,
                    1.18328,
                    1.24866,
                    1.04478,
                    1.14169,
                    1.15749,
                    1.17389,
                    0.71703,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.93506,
                    0.8641,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.02096,
                    1.09398,
                    0.97426,
                    0.97426,
                    0.97426,
                    0.97426,
                    0.97426,
                    1.2107,
                    0.97489,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    0.90996,
                    0.92094,
                    1.02798,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.93136,
                    0.86304,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.02285,
                    0.97122,
                    0.99041,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.28826,
                    1.0008,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.96752,
                    1.01519,
                    0.96752,
                    0.97363,
                    0.96752,
                    0.97363,
                    0.96752,
                    0.97363,
                    0.96752,
                    0.8641,
                    0.86304,
                    0.8641,
                    0.86304,
                    0.8641,
                    0.86304,
                    0.8641,
                    0.86304,
                    1.02096,
                    1.03057,
                    1.02096,
                    1.03517,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.914,
                    1.01359,
                    0.914,
                    1.01359,
                    0.914,
                    1.01359,
                    1,
                    1,
                    1.06085,
                    0.98561,
                    1.06085,
                    1.00879,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    0.97138,
                    1.08692,
                    0.8007,
                    1.02285,
                    1,
                    1,
                    1.00527,
                    0.83693,
                    1.02285,
                    1,
                    1,
                    0.83693,
                    0.9455,
                    0.83693,
                    0.90418,
                    0.83693,
                    1.13005,
                    1.09398,
                    0.99041,
                    1,
                    1,
                    1.09398,
                    0.99041,
                    0.96692,
                    1.09251,
                    0.99041,
                    0.97489,
                    1.0008,
                    0.97489,
                    1.0008,
                    0.97489,
                    1.0008,
                    0.93994,
                    0.97931,
                    0.90399,
                    1.02258,
                    1,
                    1,
                    0.90399,
                    1.02258,
                    0.84041,
                    0.79104,
                    0.84041,
                    0.79104,
                    0.84041,
                    0.79104,
                    0.84041,
                    0.79104,
                    1,
                    1,
                    0.95923,
                    1.07034,
                    0.95923,
                    1.16862,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.06467,
                    1.02511,
                    0.90996,
                    0.96752,
                    0.90996,
                    0.99361,
                    0.95801,
                    0.99361,
                    0.95801,
                    0.99361,
                    0.95801,
                    1.07733,
                    1.03424,
                    0.97363,
                    0.96752,
                    0.93506,
                    0.93136,
                    0.97489,
                    1.0008,
                    1,
                    1,
                    0.95923,
                    1.16862,
                    1.15103,
                    1.15103,
                    1.01173,
                    1.03959,
                    0.75953,
                    0.81378,
                    0.79912,
                    1.15103,
                    1.21994,
                    0.95161,
                    0.87815,
                    1.01149,
                    0.81525,
                    0.7676,
                    0.98167,
                    1.01134,
                    1.02546,
                    0.84097,
                    1.03089,
                    1.18102,
                    0.97363,
                    0.88776,
                    0.85134,
                    0.97826,
                    0.79795,
                    0.99361,
                    1.06085,
                    0.97489,
                    1.1406,
                    0.89858,
                    1.0388,
                    1.14889,
                    1.09398,
                    0.86039,
                    0.97489,
                    1.0595,
                    0.92094,
                    0.94793,
                    0.95923,
                    0.90996,
                    0.99346,
                    0.98243,
                    1.02112,
                    0.95493,
                    1.1406,
                    0.90996,
                    1.03574,
                    1.02597,
                    1.0008,
                    1.18102,
                    1.06628,
                    1.03574,
                    1.0192,
                    1.01932,
                    1.00886,
                    0.97531,
                    1.0106,
                    1.0008,
                    1.13189,
                    1.18102,
                    1.02277,
                    0.98683,
                    1.0016,
                    0.99561,
                    1.07237,
                    1.0008,
                    0.90434,
                    0.99921,
                    0.93803,
                    0.8965,
                    1.23085,
                    1.06628,
                    1.04983,
                    0.96268,
                    1.0499,
                    0.98439,
                    1.18102,
                    1.06628,
                    1.0008,
                    1.06628,
                    0.98439,
                    0.79795,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.09466,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.97278,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.02065,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06467,
                    1.02511,
                    1.06467,
                    1.02511,
                    1.06467,
                    1.02511,
                    0.90996,
                    0.96752,
                    1,
                    1.21408,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    1.04394,
                    1.04394,
                    1.04394,
                    1.04394,
                    0.98633,
                    0.98633,
                    0.98633,
                    0.73047,
                    0.73047,
                    1.20642,
                    0.91211,
                    1.25635,
                    1.222,
                    1.02956,
                    1.03372,
                    1.03372,
                    0.96039,
                    1.24633,
                    1,
                    1.12454,
                    0.93503,
                    1.03424,
                    1.19687,
                    1.03424,
                    1,
                    1,
                    1,
                    0.771,
                    1,
                    1,
                    1.15749,
                    1.15749,
                    1.15749,
                    1.10948,
                    0.86279,
                    0.94434,
                    0.86279,
                    0.94434,
                    0.86182,
                    1,
                    1,
                    1.16897,
                    1,
                    0.96085,
                    0.90137,
                    1.2107,
                    1.18416,
                    1.13973,
                    0.69825,
                    0.9716,
                    2.10339,
                    1.29004,
                    1.29004,
                    1.21172,
                    1.29004,
                    1.29004,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.18874,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.09193,
                    1.09193,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiBoldFactors = SegoeuiBoldFactors;
                const SegoeuiBoldMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiBoldMetrics = SegoeuiBoldMetrics;
                const SegoeuiBoldItalicFactors = [
                    1.76738,
                    1,
                    1,
                    0.98946,
                    1.03959,
                    1.04016,
                    1.02809,
                    1.036,
                    0.97639,
                    1.10953,
                    1.23203,
                    1.11144,
                    1.11144,
                    1.16939,
                    1.21237,
                    0.9754,
                    1.21261,
                    0.9754,
                    1.59754,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    0.81378,
                    0.81378,
                    1.21237,
                    1.21237,
                    1.21237,
                    0.73541,
                    0.97847,
                    0.97363,
                    0.89723,
                    0.87897,
                    1.0426,
                    0.79429,
                    0.85292,
                    0.91149,
                    1.05815,
                    1.1406,
                    0.79631,
                    0.90128,
                    0.83853,
                    1.04396,
                    1.10615,
                    0.97552,
                    0.94436,
                    0.97552,
                    0.88641,
                    0.80527,
                    0.96083,
                    1.00135,
                    1,
                    1.06777,
                    0.9817,
                    0.91142,
                    0.99361,
                    1.11144,
                    1.57293,
                    1.11144,
                    1.21237,
                    0.74627,
                    1.31818,
                    1.06585,
                    0.97042,
                    0.83055,
                    0.97042,
                    0.93503,
                    1.1261,
                    0.97042,
                    0.97922,
                    1.14236,
                    0.94552,
                    1.01054,
                    1.14236,
                    1.02471,
                    0.97922,
                    0.94165,
                    0.97042,
                    0.97042,
                    1.0276,
                    0.78929,
                    1.1261,
                    0.97922,
                    0.95874,
                    1.02197,
                    0.98507,
                    0.96752,
                    0.97168,
                    0.95107,
                    1.16579,
                    0.95107,
                    1.21237,
                    1.03959,
                    1.036,
                    1.036,
                    1,
                    1.036,
                    1.16579,
                    0.87357,
                    1.31818,
                    1.18754,
                    1.26781,
                    1.05356,
                    1.21237,
                    1.18622,
                    0.79487,
                    0.94994,
                    1.29004,
                    1.24047,
                    1.24047,
                    1.31818,
                    1,
                    0.91484,
                    0.9754,
                    1.31818,
                    1.1349,
                    1.24866,
                    1.05356,
                    1.13934,
                    1.15574,
                    1.17389,
                    0.73541,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.94385,
                    0.87897,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.0426,
                    1.10615,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    1.21237,
                    0.97552,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    0.91142,
                    0.94436,
                    0.98721,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    0.96705,
                    0.83055,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    0.93125,
                    0.97922,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.94165,
                    1.29004,
                    0.94165,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.96752,
                    0.97042,
                    0.96752,
                    0.97363,
                    1.06585,
                    0.97363,
                    1.06585,
                    0.97363,
                    1.06585,
                    0.87897,
                    0.83055,
                    0.87897,
                    0.83055,
                    0.87897,
                    0.83055,
                    0.87897,
                    0.83055,
                    1.0426,
                    1.0033,
                    1.0426,
                    0.97042,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.91149,
                    0.97042,
                    0.91149,
                    0.97042,
                    0.91149,
                    0.97042,
                    1,
                    1,
                    1.05815,
                    0.97922,
                    1.05815,
                    0.97922,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    0.97441,
                    1.04302,
                    0.79631,
                    1.01582,
                    1,
                    1,
                    1.01054,
                    0.83853,
                    1.14236,
                    1,
                    1,
                    0.83853,
                    1.09125,
                    0.83853,
                    0.90418,
                    0.83853,
                    1.19508,
                    1.10615,
                    0.97922,
                    1,
                    1,
                    1.10615,
                    0.97922,
                    1.01034,
                    1.10466,
                    0.97922,
                    0.97552,
                    0.94165,
                    0.97552,
                    0.94165,
                    0.97552,
                    0.94165,
                    0.91602,
                    0.91981,
                    0.88641,
                    1.0276,
                    1,
                    1,
                    0.88641,
                    1.0276,
                    0.80527,
                    0.78929,
                    0.80527,
                    0.78929,
                    0.80527,
                    0.78929,
                    0.80527,
                    0.78929,
                    1,
                    1,
                    0.96083,
                    1.05403,
                    0.95923,
                    1.16862,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.06777,
                    1.02197,
                    0.91142,
                    0.96752,
                    0.91142,
                    0.99361,
                    0.97168,
                    0.99361,
                    0.97168,
                    0.99361,
                    0.97168,
                    1.23199,
                    1.036,
                    0.97363,
                    1.06585,
                    0.94385,
                    0.96705,
                    0.97552,
                    0.94165,
                    1,
                    1,
                    0.96083,
                    1.1261,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    0.95161,
                    1.27126,
                    1.00811,
                    0.83284,
                    0.77702,
                    0.99137,
                    0.95253,
                    1.0347,
                    0.86142,
                    1.07205,
                    1.14236,
                    0.97363,
                    0.89723,
                    0.86869,
                    1.09818,
                    0.79429,
                    0.99361,
                    1.05815,
                    0.97552,
                    1.1406,
                    0.90128,
                    1.06662,
                    1.04396,
                    1.10615,
                    0.84918,
                    0.97552,
                    1.04694,
                    0.94436,
                    0.98015,
                    0.96083,
                    0.91142,
                    1.00356,
                    0.9817,
                    1.01945,
                    0.98999,
                    1.1406,
                    0.91142,
                    1.04961,
                    0.9898,
                    1.00639,
                    1.14236,
                    1.07514,
                    1.04961,
                    0.99607,
                    1.02897,
                    1.008,
                    0.9898,
                    0.95134,
                    1.00639,
                    1.11121,
                    1.14236,
                    1.00518,
                    0.97981,
                    1.02186,
                    1,
                    1.08578,
                    0.94165,
                    0.99314,
                    0.98387,
                    0.93028,
                    0.93377,
                    1.35125,
                    1.07514,
                    1.10687,
                    0.93491,
                    1.04232,
                    1.00351,
                    1.14236,
                    1.07514,
                    0.94165,
                    1.07514,
                    1.00351,
                    0.79429,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.09097,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.93503,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96609,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06777,
                    1.02197,
                    1.06777,
                    1.02197,
                    1.06777,
                    1.02197,
                    0.91142,
                    0.96752,
                    1,
                    1.21261,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    1.04745,
                    1.04745,
                    1.04745,
                    1.04394,
                    0.98633,
                    0.98633,
                    0.98633,
                    0.72959,
                    0.72959,
                    1.20502,
                    0.91406,
                    1.26514,
                    1.222,
                    1.02956,
                    1.03372,
                    1.03372,
                    0.96039,
                    1.24633,
                    1,
                    1.09125,
                    0.93327,
                    1.03336,
                    1.16541,
                    1.036,
                    1,
                    1,
                    1,
                    0.771,
                    1,
                    1,
                    1.15574,
                    1.15574,
                    1.15574,
                    1.15574,
                    0.86364,
                    0.94434,
                    0.86279,
                    0.94434,
                    0.86224,
                    1,
                    1,
                    1.16798,
                    1,
                    0.96085,
                    0.90068,
                    1.21237,
                    1.18416,
                    1.13904,
                    0.69825,
                    0.9716,
                    2.10339,
                    1.29004,
                    1.29004,
                    1.21339,
                    1.29004,
                    1.29004,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.18775,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.13269,
                    1.13269,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiBoldItalicFactors = SegoeuiBoldItalicFactors;
                const SegoeuiBoldItalicMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiBoldItalicMetrics = SegoeuiBoldItalicMetrics;
                const SegoeuiItalicFactors = [
                    1.76738,
                    1,
                    1,
                    0.98946,
                    1.14763,
                    1.05365,
                    1.06234,
                    0.96927,
                    0.92586,
                    1.15373,
                    1.18414,
                    0.91349,
                    0.91349,
                    1.07403,
                    1.17308,
                    0.78383,
                    1.20088,
                    0.78383,
                    1.42531,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.78383,
                    0.78383,
                    1.17308,
                    1.17308,
                    1.17308,
                    0.77349,
                    0.94565,
                    0.94729,
                    0.85944,
                    0.88506,
                    0.9858,
                    0.74817,
                    0.80016,
                    0.88449,
                    0.98039,
                    0.95782,
                    0.69238,
                    0.89898,
                    0.83231,
                    0.98183,
                    1.03989,
                    0.96924,
                    0.86237,
                    0.96924,
                    0.80595,
                    0.74524,
                    0.86091,
                    0.95402,
                    0.94143,
                    0.98448,
                    0.8858,
                    0.83089,
                    0.93285,
                    1.0949,
                    1.39016,
                    1.0949,
                    1.45994,
                    0.74627,
                    1.04839,
                    0.97454,
                    0.97454,
                    0.87207,
                    0.97454,
                    0.87533,
                    1.06151,
                    0.97454,
                    1.00176,
                    1.16484,
                    1.08132,
                    0.98047,
                    1.16484,
                    1.02989,
                    1.01054,
                    0.96225,
                    0.97454,
                    0.97454,
                    1.06598,
                    0.79004,
                    1.16344,
                    1.00351,
                    0.94629,
                    0.9973,
                    0.91016,
                    0.96777,
                    0.9043,
                    0.91082,
                    0.92481,
                    0.91082,
                    1.17308,
                    0.95748,
                    0.96927,
                    0.96927,
                    1,
                    0.96927,
                    0.92481,
                    0.80597,
                    1.04839,
                    1.23393,
                    1.1781,
                    0.9245,
                    1.17308,
                    1.20808,
                    0.63218,
                    0.94261,
                    1.24822,
                    1.09971,
                    1.09971,
                    1.04839,
                    1,
                    0.85273,
                    0.78032,
                    1.04839,
                    1.09971,
                    1.22326,
                    0.9245,
                    1.09836,
                    1.13525,
                    1.15222,
                    0.70424,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.85498,
                    0.88506,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.9858,
                    1.03989,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    1.17308,
                    0.96924,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.83089,
                    0.86237,
                    0.88409,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.92916,
                    0.87207,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.93146,
                    0.93146,
                    0.93146,
                    0.93146,
                    0.93854,
                    1.01054,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.96225,
                    1.24822,
                    0.8761,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    0.96777,
                    0.97454,
                    0.96777,
                    0.94729,
                    0.97454,
                    0.94729,
                    0.97454,
                    0.94729,
                    0.97454,
                    0.88506,
                    0.87207,
                    0.88506,
                    0.87207,
                    0.88506,
                    0.87207,
                    0.88506,
                    0.87207,
                    0.9858,
                    0.95391,
                    0.9858,
                    0.97454,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.88449,
                    0.97454,
                    0.88449,
                    0.97454,
                    0.88449,
                    0.97454,
                    1,
                    1,
                    0.98039,
                    1.00176,
                    0.98039,
                    1.00176,
                    0.95782,
                    0.93146,
                    0.95782,
                    0.93146,
                    0.95782,
                    0.93146,
                    0.95782,
                    1.16484,
                    0.95782,
                    0.93146,
                    0.84421,
                    1.12761,
                    0.69238,
                    1.08132,
                    1,
                    1,
                    0.98047,
                    0.83231,
                    1.16484,
                    1,
                    1,
                    0.84723,
                    1.04861,
                    0.84723,
                    0.78755,
                    0.83231,
                    1.23736,
                    1.03989,
                    1.01054,
                    1,
                    1,
                    1.03989,
                    1.01054,
                    0.9857,
                    1.03849,
                    1.01054,
                    0.96924,
                    0.96225,
                    0.96924,
                    0.96225,
                    0.96924,
                    0.96225,
                    0.92383,
                    0.90171,
                    0.80595,
                    1.06598,
                    1,
                    1,
                    0.80595,
                    1.06598,
                    0.74524,
                    0.79004,
                    0.74524,
                    0.79004,
                    0.74524,
                    0.79004,
                    0.74524,
                    0.79004,
                    1,
                    1,
                    0.86091,
                    1.02759,
                    0.85771,
                    1.16344,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.98448,
                    0.9973,
                    0.83089,
                    0.96777,
                    0.83089,
                    0.93285,
                    0.9043,
                    0.93285,
                    0.9043,
                    0.93285,
                    0.9043,
                    1.31868,
                    0.96927,
                    0.94729,
                    0.97454,
                    0.85498,
                    0.92916,
                    0.96924,
                    0.8761,
                    1,
                    1,
                    0.86091,
                    1.16344,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    0.81965,
                    0.81965,
                    0.94729,
                    0.78032,
                    0.71022,
                    0.90883,
                    0.84171,
                    0.99877,
                    0.77596,
                    1.05734,
                    1.2,
                    0.94729,
                    0.85944,
                    0.82791,
                    0.9607,
                    0.74817,
                    0.93285,
                    0.98039,
                    0.96924,
                    0.95782,
                    0.89898,
                    0.98316,
                    0.98183,
                    1.03989,
                    0.78614,
                    0.96924,
                    0.97642,
                    0.86237,
                    0.86075,
                    0.86091,
                    0.83089,
                    0.90082,
                    0.8858,
                    0.97296,
                    1.01284,
                    0.95782,
                    0.83089,
                    1.0976,
                    1.04,
                    1.03342,
                    1.2,
                    1.0675,
                    1.0976,
                    0.98205,
                    1.03809,
                    1.05097,
                    1.04,
                    0.95364,
                    1.03342,
                    1.05401,
                    1.2,
                    1.02148,
                    1.0119,
                    1.04724,
                    1.0127,
                    1.02732,
                    0.96225,
                    0.8965,
                    0.97783,
                    0.93574,
                    0.94818,
                    1.30679,
                    1.0675,
                    1.11826,
                    0.99821,
                    1.0557,
                    1.0326,
                    1.2,
                    1.0675,
                    0.96225,
                    1.0675,
                    1.0326,
                    0.74817,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03754,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.87533,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98705,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98448,
                    0.9973,
                    0.98448,
                    0.9973,
                    0.98448,
                    0.9973,
                    0.83089,
                    0.96777,
                    1,
                    1.20088,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    0.94945,
                    0.94945,
                    0.94945,
                    0.94945,
                    1.12317,
                    1.12317,
                    1.12317,
                    0.67603,
                    0.67603,
                    1.15621,
                    0.73584,
                    1.21191,
                    1.22135,
                    1.06483,
                    0.94868,
                    0.94868,
                    0.95996,
                    1.24633,
                    1,
                    1.07497,
                    0.87709,
                    0.96927,
                    1.01473,
                    0.96927,
                    1,
                    1,
                    1,
                    0.77295,
                    1,
                    1,
                    1.09836,
                    1.09836,
                    1.09836,
                    1.01522,
                    0.86321,
                    0.94434,
                    0.8649,
                    0.94434,
                    0.86182,
                    1,
                    1,
                    1.083,
                    1,
                    0.91578,
                    0.86438,
                    1.17308,
                    1.18416,
                    1.14589,
                    0.69825,
                    0.97622,
                    1.96791,
                    1.24822,
                    1.24822,
                    1.17308,
                    1.24822,
                    1.24822,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.17984,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.10742,
                    1.10742,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiItalicFactors = SegoeuiItalicFactors;
                const SegoeuiItalicMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiItalicMetrics = SegoeuiItalicMetrics;
                const SegoeuiRegularFactors = [
                    1.76738,
                    1,
                    1,
                    0.98594,
                    1.02285,
                    1.10454,
                    1.06234,
                    0.96927,
                    0.92037,
                    1.19985,
                    1.2046,
                    0.90616,
                    0.90616,
                    1.07152,
                    1.1714,
                    0.78032,
                    1.20088,
                    0.78032,
                    1.40246,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.78032,
                    0.78032,
                    1.1714,
                    1.1714,
                    1.1714,
                    0.80597,
                    0.94084,
                    0.96706,
                    0.85944,
                    0.85734,
                    0.97093,
                    0.75842,
                    0.79936,
                    0.88198,
                    0.9831,
                    0.95782,
                    0.71387,
                    0.86969,
                    0.84636,
                    1.07796,
                    1.03584,
                    0.96924,
                    0.83968,
                    0.96924,
                    0.82826,
                    0.79649,
                    0.85771,
                    0.95132,
                    0.93119,
                    0.98965,
                    0.88433,
                    0.8287,
                    0.93365,
                    1.08612,
                    1.3638,
                    1.08612,
                    1.45786,
                    0.74627,
                    0.80499,
                    0.91484,
                    1.05707,
                    0.92383,
                    1.05882,
                    0.9403,
                    1.12654,
                    1.05882,
                    1.01756,
                    1.09011,
                    1.09011,
                    0.99414,
                    1.09011,
                    1.034,
                    1.01756,
                    1.05356,
                    1.05707,
                    1.05882,
                    1.04399,
                    0.84863,
                    1.21968,
                    1.01756,
                    0.95801,
                    1.00068,
                    0.91797,
                    0.96777,
                    0.9043,
                    0.90351,
                    0.92105,
                    0.90351,
                    1.1714,
                    0.85337,
                    0.96927,
                    0.96927,
                    0.99912,
                    0.96927,
                    0.92105,
                    0.80597,
                    1.2434,
                    1.20808,
                    1.05937,
                    0.90957,
                    1.1714,
                    1.20808,
                    0.75155,
                    0.94261,
                    1.24644,
                    1.09971,
                    1.09971,
                    0.84751,
                    1,
                    0.85273,
                    0.78032,
                    0.61584,
                    1.05425,
                    1.17914,
                    0.90957,
                    1.08665,
                    1.11593,
                    1.14169,
                    0.73381,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.86035,
                    0.85734,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.97093,
                    1.03584,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    1.1714,
                    0.96924,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.8287,
                    0.83968,
                    0.89049,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.93575,
                    0.92383,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.8717,
                    0.8717,
                    0.8717,
                    0.8717,
                    1.00527,
                    1.01756,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.24644,
                    0.95923,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    0.96777,
                    1.05707,
                    0.96777,
                    0.96706,
                    0.91484,
                    0.96706,
                    0.91484,
                    0.96706,
                    0.91484,
                    0.85734,
                    0.92383,
                    0.85734,
                    0.92383,
                    0.85734,
                    0.92383,
                    0.85734,
                    0.92383,
                    0.97093,
                    1.0969,
                    0.97093,
                    1.05882,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.88198,
                    1.05882,
                    0.88198,
                    1.05882,
                    0.88198,
                    1.05882,
                    1,
                    1,
                    0.9831,
                    1.01756,
                    0.9831,
                    1.01756,
                    0.95782,
                    0.8717,
                    0.95782,
                    0.8717,
                    0.95782,
                    0.8717,
                    0.95782,
                    1.09011,
                    0.95782,
                    0.8717,
                    0.84784,
                    1.11551,
                    0.71387,
                    1.09011,
                    1,
                    1,
                    0.99414,
                    0.84636,
                    1.09011,
                    1,
                    1,
                    0.84636,
                    1.0536,
                    0.84636,
                    0.94298,
                    0.84636,
                    1.23297,
                    1.03584,
                    1.01756,
                    1,
                    1,
                    1.03584,
                    1.01756,
                    1.00323,
                    1.03444,
                    1.01756,
                    0.96924,
                    1.05356,
                    0.96924,
                    1.05356,
                    0.96924,
                    1.05356,
                    0.93066,
                    0.98293,
                    0.82826,
                    1.04399,
                    1,
                    1,
                    0.82826,
                    1.04399,
                    0.79649,
                    0.84863,
                    0.79649,
                    0.84863,
                    0.79649,
                    0.84863,
                    0.79649,
                    0.84863,
                    1,
                    1,
                    0.85771,
                    1.17318,
                    0.85771,
                    1.21968,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.98965,
                    1.00068,
                    0.8287,
                    0.96777,
                    0.8287,
                    0.93365,
                    0.9043,
                    0.93365,
                    0.9043,
                    0.93365,
                    0.9043,
                    1.08571,
                    0.96927,
                    0.96706,
                    0.91484,
                    0.86035,
                    0.93575,
                    0.96924,
                    0.95923,
                    1,
                    1,
                    0.85771,
                    1.21968,
                    1.11437,
                    1.11437,
                    0.93109,
                    0.91202,
                    0.60411,
                    0.84164,
                    0.55572,
                    1.01173,
                    0.97361,
                    0.81818,
                    0.81818,
                    0.96635,
                    0.78032,
                    0.72727,
                    0.92366,
                    0.98601,
                    1.03405,
                    0.77968,
                    1.09799,
                    1.2,
                    0.96706,
                    0.85944,
                    0.85638,
                    0.96491,
                    0.75842,
                    0.93365,
                    0.9831,
                    0.96924,
                    0.95782,
                    0.86969,
                    0.94152,
                    1.07796,
                    1.03584,
                    0.78437,
                    0.96924,
                    0.98715,
                    0.83968,
                    0.83491,
                    0.85771,
                    0.8287,
                    0.94492,
                    0.88433,
                    0.9287,
                    1.0098,
                    0.95782,
                    0.8287,
                    1.0625,
                    0.98248,
                    1.03424,
                    1.2,
                    1.01071,
                    1.0625,
                    0.95246,
                    1.03809,
                    1.04912,
                    0.98248,
                    1.00221,
                    1.03424,
                    1.05443,
                    1.2,
                    1.04785,
                    0.99609,
                    1.00169,
                    1.05176,
                    0.99346,
                    1.05356,
                    0.9087,
                    1.03004,
                    0.95542,
                    0.93117,
                    1.23362,
                    1.01071,
                    1.07831,
                    1.02512,
                    1.05205,
                    1.03502,
                    1.2,
                    1.01071,
                    1.05356,
                    1.01071,
                    1.03502,
                    0.75842,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03719,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.9403,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.04021,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98965,
                    1.00068,
                    0.98965,
                    1.00068,
                    0.98965,
                    1.00068,
                    0.8287,
                    0.96777,
                    1,
                    1.20088,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.13196,
                    1.13196,
                    1.13196,
                    0.67428,
                    0.67428,
                    1.16039,
                    0.73291,
                    1.20996,
                    1.22135,
                    1.06483,
                    0.94868,
                    0.94868,
                    0.95996,
                    1.24633,
                    1,
                    1.07497,
                    0.87796,
                    0.96927,
                    1.01518,
                    0.96927,
                    1,
                    1,
                    1,
                    0.77295,
                    1,
                    1,
                    1.10539,
                    1.10539,
                    1.11358,
                    1.06967,
                    0.86279,
                    0.94434,
                    0.86279,
                    0.94434,
                    0.86182,
                    1,
                    1,
                    1.083,
                    1,
                    0.91578,
                    0.86507,
                    1.1714,
                    1.18416,
                    1.14589,
                    0.69825,
                    0.97622,
                    1.9697,
                    1.24822,
                    1.24822,
                    1.17238,
                    1.24822,
                    1.24822,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.18083,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.10938,
                    1.10938,
                    1,
                    1,
                    1,
                    1.05425,
                    1.09971,
                    1.09971,
                    1.09971,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiRegularFactors = SegoeuiRegularFactors;
                const SegoeuiRegularMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiRegularMetrics = SegoeuiRegularMetrics;
            /***/ },
            /* 57 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PostScriptEvaluator = exports.PostScriptCompiler = exports.PDFFunctionFactory = void 0;
                exports.isPDFFunction = isPDFFunction;
                var _primitives = __w_pdfjs_require__(4);
                var _util = __w_pdfjs_require__(2);
                var _ps_parser = __w_pdfjs_require__(58);
                var _base_stream = __w_pdfjs_require__(5);
                var _image_utils = __w_pdfjs_require__(59);
                class PDFFunctionFactory {
                    constructor({ xref: xref, isEvalSupported: isEvalSupported = true }){
                        this.xref = xref;
                        this.isEvalSupported = isEvalSupported !== false;
                    }
                    create(fn) {
                        const cachedFunction = this.getCached(fn);
                        if (cachedFunction) return cachedFunction;
                        const parsedFunction = PDFFunction.parse({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fn: fn instanceof _primitives.Ref ? this.xref.fetch(fn) : fn
                        });
                        this._cache(fn, parsedFunction);
                        return parsedFunction;
                    }
                    createFromArray(fnObj) {
                        const cachedFunction = this.getCached(fnObj);
                        if (cachedFunction) return cachedFunction;
                        const parsedFunction = PDFFunction.parseArray({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fnObj: fnObj instanceof _primitives.Ref ? this.xref.fetch(fnObj) : fnObj
                        });
                        this._cache(fnObj, parsedFunction);
                        return parsedFunction;
                    }
                    getCached(cacheKey) {
                        let fnRef;
                        if (cacheKey instanceof _primitives.Ref) fnRef = cacheKey;
                        else if (cacheKey instanceof _primitives.Dict) fnRef = cacheKey.objId;
                        else if (cacheKey instanceof _base_stream.BaseStream) fnRef = cacheKey.dict?.objId;
                        if (fnRef) {
                            const localFunction = this._localFunctionCache.getByRef(fnRef);
                            if (localFunction) return localFunction;
                        }
                        return null;
                    }
                    _cache(cacheKey, parsedFunction) {
                        if (!parsedFunction) throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
                        let fnRef;
                        if (cacheKey instanceof _primitives.Ref) fnRef = cacheKey;
                        else if (cacheKey instanceof _primitives.Dict) fnRef = cacheKey.objId;
                        else if (cacheKey instanceof _base_stream.BaseStream) fnRef = cacheKey.dict?.objId;
                        if (fnRef) this._localFunctionCache.set(null, fnRef, parsedFunction);
                    }
                    get _localFunctionCache() {
                        return (0, _util.shadow)(this, "_localFunctionCache", new _image_utils.LocalFunctionCache());
                    }
                }
                exports.PDFFunctionFactory = PDFFunctionFactory;
                function toNumberArray(arr) {
                    if (!Array.isArray(arr)) return null;
                    const length = arr.length;
                    for(let i = 0; i < length; i++)if (typeof arr[i] !== "number") {
                        const result = new Array(length);
                        for(let j = 0; j < length; j++)result[j] = +arr[j];
                        return result;
                    }
                    return arr;
                }
                class PDFFunction {
                    static getSampleArray(size, outputSize, bps, stream) {
                        let i, ii;
                        let length = 1;
                        for(i = 0, ii = size.length; i < ii; i++)length *= size[i];
                        length *= outputSize;
                        const array = new Array(length);
                        let codeSize = 0;
                        let codeBuf = 0;
                        const sampleMul = 1.0 / (2.0 ** bps - 1);
                        const strBytes = stream.getBytes((length * bps + 7) / 8);
                        let strIdx = 0;
                        for(i = 0; i < length; i++){
                            while(codeSize < bps){
                                codeBuf <<= 8;
                                codeBuf |= strBytes[strIdx++];
                                codeSize += 8;
                            }
                            codeSize -= bps;
                            array[i] = (codeBuf >> codeSize) * sampleMul;
                            codeBuf &= (1 << codeSize) - 1;
                        }
                        return array;
                    }
                    static parse({ xref: xref, isEvalSupported: isEvalSupported, fn: fn }) {
                        const dict = fn.dict || fn;
                        const typeNum = dict.get("FunctionType");
                        switch(typeNum){
                            case 0:
                                return this.constructSampled({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    fn: fn,
                                    dict: dict
                                });
                            case 1:
                                break;
                            case 2:
                                return this.constructInterpolated({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    dict: dict
                                });
                            case 3:
                                return this.constructStiched({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    dict: dict
                                });
                            case 4:
                                return this.constructPostScript({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    fn: fn,
                                    dict: dict
                                });
                        }
                        throw new _util.FormatError("Unknown type of function");
                    }
                    static parseArray({ xref: xref, isEvalSupported: isEvalSupported, fnObj: fnObj }) {
                        if (!Array.isArray(fnObj)) return this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: fnObj
                        });
                        const fnArray = [];
                        for (const fn of fnObj)fnArray.push(this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: xref.fetchIfRef(fn)
                        }));
                        return function(src, srcOffset, dest, destOffset) {
                            for(let i = 0, ii = fnArray.length; i < ii; i++)fnArray[i](src, srcOffset, dest, destOffset + i);
                        };
                    }
                    static constructSampled({ xref: xref, isEvalSupported: isEvalSupported, fn: fn, dict: dict }) {
                        function toMultiArray(arr) {
                            const inputLength = arr.length;
                            const out = [];
                            let index = 0;
                            for(let i = 0; i < inputLength; i += 2)out[index++] = [
                                arr[i],
                                arr[i + 1]
                            ];
                            return out;
                        }
                        function interpolate(x, xmin, xmax, ymin, ymax) {
                            return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
                        }
                        let domain = toNumberArray(dict.getArray("Domain"));
                        let range = toNumberArray(dict.getArray("Range"));
                        if (!domain || !range) throw new _util.FormatError("No domain or range");
                        const inputSize = domain.length / 2;
                        const outputSize = range.length / 2;
                        domain = toMultiArray(domain);
                        range = toMultiArray(range);
                        const size = toNumberArray(dict.getArray("Size"));
                        const bps = dict.get("BitsPerSample");
                        const order = dict.get("Order") || 1;
                        if (order !== 1) (0, _util.info)("No support for cubic spline interpolation: " + order);
                        let encode = toNumberArray(dict.getArray("Encode"));
                        if (!encode) {
                            encode = [];
                            for(let i = 0; i < inputSize; ++i)encode.push([
                                0,
                                size[i] - 1
                            ]);
                        } else encode = toMultiArray(encode);
                        let decode = toNumberArray(dict.getArray("Decode"));
                        decode = !decode ? range : toMultiArray(decode);
                        const samples = this.getSampleArray(size, outputSize, bps, fn);
                        return function constructSampledFn(src, srcOffset, dest, destOffset) {
                            const cubeVertices = 1 << inputSize;
                            const cubeN = new Float64Array(cubeVertices);
                            const cubeVertex = new Uint32Array(cubeVertices);
                            let i, j;
                            for(j = 0; j < cubeVertices; j++)cubeN[j] = 1;
                            let k = outputSize, pos = 1;
                            for(i = 0; i < inputSize; ++i){
                                const domain_2i = domain[i][0];
                                const domain_2i_1 = domain[i][1];
                                const xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
                                let e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
                                const size_i = size[i];
                                e = Math.min(Math.max(e, 0), size_i - 1);
                                const e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
                                const n0 = e0 + 1 - e;
                                const n1 = e - e0;
                                const offset0 = e0 * k;
                                const offset1 = offset0 + k;
                                for(j = 0; j < cubeVertices; j++)if (j & pos) {
                                    cubeN[j] *= n1;
                                    cubeVertex[j] += offset1;
                                } else {
                                    cubeN[j] *= n0;
                                    cubeVertex[j] += offset0;
                                }
                                k *= size_i;
                                pos <<= 1;
                            }
                            for(j = 0; j < outputSize; ++j){
                                let rj = 0;
                                for(i = 0; i < cubeVertices; i++)rj += samples[cubeVertex[i] + j] * cubeN[i];
                                rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
                                dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
                            }
                        };
                    }
                    static constructInterpolated({ xref: xref, isEvalSupported: isEvalSupported, dict: dict }) {
                        const c0 = toNumberArray(dict.getArray("C0")) || [
                            0
                        ];
                        const c1 = toNumberArray(dict.getArray("C1")) || [
                            1
                        ];
                        const n = dict.get("N");
                        const diff = [];
                        for(let i = 0, ii = c0.length; i < ii; ++i)diff.push(c1[i] - c0[i]);
                        const length = diff.length;
                        return function constructInterpolatedFn(src, srcOffset, dest, destOffset) {
                            const x = n === 1 ? src[srcOffset] : src[srcOffset] ** n;
                            for(let j = 0; j < length; ++j)dest[destOffset + j] = c0[j] + x * diff[j];
                        };
                    }
                    static constructStiched({ xref: xref, isEvalSupported: isEvalSupported, dict: dict }) {
                        const domain = toNumberArray(dict.getArray("Domain"));
                        if (!domain) throw new _util.FormatError("No domain");
                        const inputSize = domain.length / 2;
                        if (inputSize !== 1) throw new _util.FormatError("Bad domain for stiched function");
                        const fns = [];
                        for (const fn of dict.get("Functions"))fns.push(this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: xref.fetchIfRef(fn)
                        }));
                        const bounds = toNumberArray(dict.getArray("Bounds"));
                        const encode = toNumberArray(dict.getArray("Encode"));
                        const tmpBuf = new Float32Array(1);
                        return function constructStichedFn(src, srcOffset, dest, destOffset) {
                            const clip = function constructStichedFromIRClip(v, min, max) {
                                if (v > max) v = max;
                                else if (v < min) v = min;
                                return v;
                            };
                            const v = clip(src[srcOffset], domain[0], domain[1]);
                            const length = bounds.length;
                            let i;
                            for(i = 0; i < length; ++i){
                                if (v < bounds[i]) break;
                            }
                            let dmin = domain[0];
                            if (i > 0) dmin = bounds[i - 1];
                            let dmax = domain[1];
                            if (i < bounds.length) dmax = bounds[i];
                            const rmin = encode[2 * i];
                            const rmax = encode[2 * i + 1];
                            tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
                            fns[i](tmpBuf, 0, dest, destOffset);
                        };
                    }
                    static constructPostScript({ xref: xref, isEvalSupported: isEvalSupported, fn: fn, dict: dict }) {
                        const domain = toNumberArray(dict.getArray("Domain"));
                        const range = toNumberArray(dict.getArray("Range"));
                        if (!domain) throw new _util.FormatError("No domain.");
                        if (!range) throw new _util.FormatError("No range.");
                        const lexer = new _ps_parser.PostScriptLexer(fn);
                        const parser = new _ps_parser.PostScriptParser(lexer);
                        const code = parser.parse();
                        if (isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const compiled = new PostScriptCompiler().compile(code, domain, range);
                            if (compiled) return new Function("src", "srcOffset", "dest", "destOffset", compiled);
                        }
                        (0, _util.info)("Unable to compile PS function");
                        const numOutputs = range.length >> 1;
                        const numInputs = domain.length >> 1;
                        const evaluator = new PostScriptEvaluator(code);
                        const cache = Object.create(null);
                        const MAX_CACHE_SIZE = 8192;
                        let cache_available = MAX_CACHE_SIZE;
                        const tmpBuf = new Float32Array(numInputs);
                        return function constructPostScriptFn(src, srcOffset, dest, destOffset) {
                            let i, value;
                            let key = "";
                            const input = tmpBuf;
                            for(i = 0; i < numInputs; i++){
                                value = src[srcOffset + i];
                                input[i] = value;
                                key += value + "_";
                            }
                            const cachedValue = cache[key];
                            if (cachedValue !== undefined) {
                                dest.set(cachedValue, destOffset);
                                return;
                            }
                            const output = new Float32Array(numOutputs);
                            const stack = evaluator.execute(input);
                            const stackIndex = stack.length - numOutputs;
                            for(i = 0; i < numOutputs; i++){
                                value = stack[stackIndex + i];
                                let bound = range[i * 2];
                                if (value < bound) value = bound;
                                else {
                                    bound = range[i * 2 + 1];
                                    if (value > bound) value = bound;
                                }
                                output[i] = value;
                            }
                            if (cache_available > 0) {
                                cache_available--;
                                cache[key] = output;
                            }
                            dest.set(output, destOffset);
                        };
                    }
                }
                function isPDFFunction(v) {
                    let fnDict;
                    if (v instanceof _primitives.Dict) fnDict = v;
                    else if (v instanceof _base_stream.BaseStream) fnDict = v.dict;
                    else return false;
                    return fnDict.has("FunctionType");
                }
                class PostScriptStack {
                    static MAX_STACK_SIZE = 100;
                    constructor(initialStack){
                        this.stack = initialStack ? Array.from(initialStack) : [];
                    }
                    push(value) {
                        if (this.stack.length >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        this.stack.push(value);
                    }
                    pop() {
                        if (this.stack.length <= 0) throw new Error("PostScript function stack underflow.");
                        return this.stack.pop();
                    }
                    copy(n) {
                        if (this.stack.length + n >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        const stack = this.stack;
                        for(let i = stack.length - n, j = n - 1; j >= 0; j--, i++)stack.push(stack[i]);
                    }
                    index(n) {
                        this.push(this.stack[this.stack.length - n - 1]);
                    }
                    roll(n, p) {
                        const stack = this.stack;
                        const l = stack.length - n;
                        const r = stack.length - 1;
                        const c = l + (p - Math.floor(p / n) * n);
                        for(let i = l, j = r; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                        for(let i = l, j = c - 1; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                        for(let i = c, j = r; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                    }
                }
                class PostScriptEvaluator {
                    constructor(operators){
                        this.operators = operators;
                    }
                    execute(initialStack) {
                        const stack = new PostScriptStack(initialStack);
                        let counter = 0;
                        const operators = this.operators;
                        const length = operators.length;
                        let operator, a, b;
                        while(counter < length){
                            operator = operators[counter++];
                            if (typeof operator === "number") {
                                stack.push(operator);
                                continue;
                            }
                            switch(operator){
                                case "jz":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (!a) counter = b;
                                    break;
                                case "j":
                                    a = stack.pop();
                                    counter = a;
                                    break;
                                case "abs":
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case "add":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case "and":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (typeof a === "boolean" && typeof b === "boolean") stack.push(a && b);
                                    else stack.push(a & b);
                                    break;
                                case "atan":
                                    b = stack.pop();
                                    a = stack.pop();
                                    a = Math.atan2(a, b) / Math.PI * 180;
                                    if (a < 0) a += 360;
                                    stack.push(a);
                                    break;
                                case "bitshift":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (a > 0) stack.push(a << b);
                                    else stack.push(a >> b);
                                    break;
                                case "ceiling":
                                    a = stack.pop();
                                    stack.push(Math.ceil(a));
                                    break;
                                case "copy":
                                    a = stack.pop();
                                    stack.copy(a);
                                    break;
                                case "cos":
                                    a = stack.pop();
                                    stack.push(Math.cos(a % 360 / 180 * Math.PI));
                                    break;
                                case "cvi":
                                    a = stack.pop() | 0;
                                    stack.push(a);
                                    break;
                                case "cvr":
                                    break;
                                case "div":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case "dup":
                                    stack.copy(1);
                                    break;
                                case "eq":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a === b);
                                    break;
                                case "exch":
                                    stack.roll(2, 1);
                                    break;
                                case "exp":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a ** b);
                                    break;
                                case "false":
                                    stack.push(false);
                                    break;
                                case "floor":
                                    a = stack.pop();
                                    stack.push(Math.floor(a));
                                    break;
                                case "ge":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a >= b);
                                    break;
                                case "gt":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a > b);
                                    break;
                                case "idiv":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a / b | 0);
                                    break;
                                case "index":
                                    a = stack.pop();
                                    stack.index(a);
                                    break;
                                case "le":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a <= b);
                                    break;
                                case "ln":
                                    a = stack.pop();
                                    stack.push(Math.log(a));
                                    break;
                                case "log":
                                    a = stack.pop();
                                    stack.push(Math.log10(a));
                                    break;
                                case "lt":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a < b);
                                    break;
                                case "mod":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a % b);
                                    break;
                                case "mul":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case "ne":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a !== b);
                                    break;
                                case "neg":
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case "not":
                                    a = stack.pop();
                                    if (typeof a === "boolean") stack.push(!a);
                                    else stack.push(~a);
                                    break;
                                case "or":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (typeof a === "boolean" && typeof b === "boolean") stack.push(a || b);
                                    else stack.push(a | b);
                                    break;
                                case "pop":
                                    stack.pop();
                                    break;
                                case "roll":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.roll(a, b);
                                    break;
                                case "round":
                                    a = stack.pop();
                                    stack.push(Math.round(a));
                                    break;
                                case "sin":
                                    a = stack.pop();
                                    stack.push(Math.sin(a % 360 / 180 * Math.PI));
                                    break;
                                case "sqrt":
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case "sub":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case "true":
                                    stack.push(true);
                                    break;
                                case "truncate":
                                    a = stack.pop();
                                    a = a < 0 ? Math.ceil(a) : Math.floor(a);
                                    stack.push(a);
                                    break;
                                case "xor":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (typeof a === "boolean" && typeof b === "boolean") stack.push(a !== b);
                                    else stack.push(a ^ b);
                                    break;
                                default:
                                    throw new _util.FormatError(`Unknown operator ${operator}`);
                            }
                        }
                        return stack.stack;
                    }
                }
                exports.PostScriptEvaluator = PostScriptEvaluator;
                class AstNode {
                    constructor(type){
                        this.type = type;
                    }
                    visit(visitor) {
                        (0, _util.unreachable)("abstract method");
                    }
                }
                class AstArgument extends AstNode {
                    constructor(index, min, max){
                        super("args");
                        this.index = index;
                        this.min = min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitArgument(this);
                    }
                }
                class AstLiteral extends AstNode {
                    constructor(number){
                        super("literal");
                        this.number = number;
                        this.min = number;
                        this.max = number;
                    }
                    visit(visitor) {
                        visitor.visitLiteral(this);
                    }
                }
                class AstBinaryOperation extends AstNode {
                    constructor(op, arg1, arg2, min, max){
                        super("binary");
                        this.op = op;
                        this.arg1 = arg1;
                        this.arg2 = arg2;
                        this.min = min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitBinaryOperation(this);
                    }
                }
                class AstMin extends AstNode {
                    constructor(arg, max){
                        super("max");
                        this.arg = arg;
                        this.min = arg.min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitMin(this);
                    }
                }
                class AstVariable extends AstNode {
                    constructor(index, min, max){
                        super("var");
                        this.index = index;
                        this.min = min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitVariable(this);
                    }
                }
                class AstVariableDefinition extends AstNode {
                    constructor(variable, arg){
                        super("definition");
                        this.variable = variable;
                        this.arg = arg;
                    }
                    visit(visitor) {
                        visitor.visitVariableDefinition(this);
                    }
                }
                class ExpressionBuilderVisitor {
                    constructor(){
                        this.parts = [];
                    }
                    visitArgument(arg) {
                        this.parts.push("Math.max(", arg.min, ", Math.min(", arg.max, ", src[srcOffset + ", arg.index, "]))");
                    }
                    visitVariable(variable) {
                        this.parts.push("v", variable.index);
                    }
                    visitLiteral(literal) {
                        this.parts.push(literal.number);
                    }
                    visitBinaryOperation(operation) {
                        this.parts.push("(");
                        operation.arg1.visit(this);
                        this.parts.push(" ", operation.op, " ");
                        operation.arg2.visit(this);
                        this.parts.push(")");
                    }
                    visitVariableDefinition(definition) {
                        this.parts.push("var ");
                        definition.variable.visit(this);
                        this.parts.push(" = ");
                        definition.arg.visit(this);
                        this.parts.push(";");
                    }
                    visitMin(max) {
                        this.parts.push("Math.min(");
                        max.arg.visit(this);
                        this.parts.push(", ", max.max, ")");
                    }
                    toString() {
                        return this.parts.join("");
                    }
                }
                function buildAddOperation(num1, num2) {
                    if (num2.type === "literal" && num2.number === 0) return num1;
                    if (num1.type === "literal" && num1.number === 0) return num2;
                    if (num2.type === "literal" && num1.type === "literal") return new AstLiteral(num1.number + num2.number);
                    return new AstBinaryOperation("+", num1, num2, num1.min + num2.min, num1.max + num2.max);
                }
                function buildMulOperation(num1, num2) {
                    if (num2.type === "literal") {
                        if (num2.number === 0) return new AstLiteral(0);
                        else if (num2.number === 1) return num1;
                        else if (num1.type === "literal") return new AstLiteral(num1.number * num2.number);
                    }
                    if (num1.type === "literal") {
                        if (num1.number === 0) return new AstLiteral(0);
                        else if (num1.number === 1) return num2;
                    }
                    const min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                    const max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                    return new AstBinaryOperation("*", num1, num2, min, max);
                }
                function buildSubOperation(num1, num2) {
                    if (num2.type === "literal") {
                        if (num2.number === 0) return num1;
                        else if (num1.type === "literal") return new AstLiteral(num1.number - num2.number);
                    }
                    if (num2.type === "binary" && num2.op === "-" && num1.type === "literal" && num1.number === 1 && num2.arg1.type === "literal" && num2.arg1.number === 1) return num2.arg2;
                    return new AstBinaryOperation("-", num1, num2, num1.min - num2.max, num1.max - num2.min);
                }
                function buildMinOperation(num1, max) {
                    if (num1.min >= max) return new AstLiteral(max);
                    else if (num1.max <= max) return num1;
                    return new AstMin(num1, max);
                }
                class PostScriptCompiler {
                    compile(code, domain, range) {
                        const stack = [];
                        const instructions = [];
                        const inputSize = domain.length >> 1, outputSize = range.length >> 1;
                        let lastRegister = 0;
                        let n, j;
                        let num1, num2, ast1, ast2, tmpVar, item;
                        for(let i = 0; i < inputSize; i++)stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
                        for(let i = 0, ii = code.length; i < ii; i++){
                            item = code[i];
                            if (typeof item === "number") {
                                stack.push(new AstLiteral(item));
                                continue;
                            }
                            switch(item){
                                case "add":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    stack.push(buildAddOperation(num1, num2));
                                    break;
                                case "cvr":
                                    if (stack.length < 1) return null;
                                    break;
                                case "mul":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    stack.push(buildMulOperation(num1, num2));
                                    break;
                                case "sub":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    stack.push(buildSubOperation(num1, num2));
                                    break;
                                case "exch":
                                    if (stack.length < 2) return null;
                                    ast1 = stack.pop();
                                    ast2 = stack.pop();
                                    stack.push(ast1, ast2);
                                    break;
                                case "pop":
                                    if (stack.length < 1) return null;
                                    stack.pop();
                                    break;
                                case "index":
                                    if (stack.length < 1) return null;
                                    num1 = stack.pop();
                                    if (num1.type !== "literal") return null;
                                    n = num1.number;
                                    if (n < 0 || !Number.isInteger(n) || stack.length < n) return null;
                                    ast1 = stack[stack.length - n - 1];
                                    if (ast1.type === "literal" || ast1.type === "var") {
                                        stack.push(ast1);
                                        break;
                                    }
                                    tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                                    stack[stack.length - n - 1] = tmpVar;
                                    stack.push(tmpVar);
                                    instructions.push(new AstVariableDefinition(tmpVar, ast1));
                                    break;
                                case "dup":
                                    if (stack.length < 1) return null;
                                    if (typeof code[i + 1] === "number" && code[i + 2] === "gt" && code[i + 3] === i + 7 && code[i + 4] === "jz" && code[i + 5] === "pop" && code[i + 6] === code[i + 1]) {
                                        num1 = stack.pop();
                                        stack.push(buildMinOperation(num1, code[i + 1]));
                                        i += 6;
                                        break;
                                    }
                                    ast1 = stack.at(-1);
                                    if (ast1.type === "literal" || ast1.type === "var") {
                                        stack.push(ast1);
                                        break;
                                    }
                                    tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                                    stack[stack.length - 1] = tmpVar;
                                    stack.push(tmpVar);
                                    instructions.push(new AstVariableDefinition(tmpVar, ast1));
                                    break;
                                case "roll":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    if (num2.type !== "literal" || num1.type !== "literal") return null;
                                    j = num2.number;
                                    n = num1.number;
                                    if (n <= 0 || !Number.isInteger(n) || !Number.isInteger(j) || stack.length < n) return null;
                                    j = (j % n + n) % n;
                                    if (j === 0) break;
                                    stack.push(...stack.splice(stack.length - n, n - j));
                                    break;
                                default:
                                    return null;
                            }
                        }
                        if (stack.length !== outputSize) return null;
                        const result = [];
                        for (const instruction of instructions){
                            const statementBuilder = new ExpressionBuilderVisitor();
                            instruction.visit(statementBuilder);
                            result.push(statementBuilder.toString());
                        }
                        for(let i = 0, ii = stack.length; i < ii; i++){
                            const expr = stack[i], statementBuilder = new ExpressionBuilderVisitor();
                            expr.visit(statementBuilder);
                            const min = range[i * 2], max = range[i * 2 + 1];
                            const out = [
                                statementBuilder.toString()
                            ];
                            if (min > expr.min) {
                                out.unshift("Math.max(", min, ", ");
                                out.push(")");
                            }
                            if (max < expr.max) {
                                out.unshift("Math.min(", max, ", ");
                                out.push(")");
                            }
                            out.unshift("dest[destOffset + ", i, "] = ");
                            out.push(";");
                            result.push(out.join(""));
                        }
                        return result.join("\n");
                    }
                }
                exports.PostScriptCompiler = PostScriptCompiler;
            /***/ },
            /* 58 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PostScriptParser = exports.PostScriptLexer = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                class PostScriptParser {
                    constructor(lexer){
                        this.lexer = lexer;
                        this.operators = [];
                        this.token = null;
                        this.prev = null;
                    }
                    nextToken() {
                        this.prev = this.token;
                        this.token = this.lexer.getToken();
                    }
                    accept(type) {
                        if (this.token.type === type) {
                            this.nextToken();
                            return true;
                        }
                        return false;
                    }
                    expect(type) {
                        if (this.accept(type)) return true;
                        throw new _util.FormatError(`Unexpected symbol: found ${this.token.type} expected ${type}.`);
                    }
                    parse() {
                        this.nextToken();
                        this.expect(PostScriptTokenTypes.LBRACE);
                        this.parseBlock();
                        this.expect(PostScriptTokenTypes.RBRACE);
                        return this.operators;
                    }
                    parseBlock() {
                        while(true){
                            if (this.accept(PostScriptTokenTypes.NUMBER)) this.operators.push(this.prev.value);
                            else if (this.accept(PostScriptTokenTypes.OPERATOR)) this.operators.push(this.prev.value);
                            else if (this.accept(PostScriptTokenTypes.LBRACE)) this.parseCondition();
                            else return;
                        }
                    }
                    parseCondition() {
                        const conditionLocation = this.operators.length;
                        this.operators.push(null, null);
                        this.parseBlock();
                        this.expect(PostScriptTokenTypes.RBRACE);
                        if (this.accept(PostScriptTokenTypes.IF)) {
                            this.operators[conditionLocation] = this.operators.length;
                            this.operators[conditionLocation + 1] = "jz";
                        } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
                            const jumpLocation = this.operators.length;
                            this.operators.push(null, null);
                            const endOfTrue = this.operators.length;
                            this.parseBlock();
                            this.expect(PostScriptTokenTypes.RBRACE);
                            this.expect(PostScriptTokenTypes.IFELSE);
                            this.operators[jumpLocation] = this.operators.length;
                            this.operators[jumpLocation + 1] = "j";
                            this.operators[conditionLocation] = endOfTrue;
                            this.operators[conditionLocation + 1] = "jz";
                        } else throw new _util.FormatError("PS Function: error parsing conditional.");
                    }
                }
                exports.PostScriptParser = PostScriptParser;
                const PostScriptTokenTypes = {
                    LBRACE: 0,
                    RBRACE: 1,
                    NUMBER: 2,
                    OPERATOR: 3,
                    IF: 4,
                    IFELSE: 5
                };
                class PostScriptToken {
                    static get opCache() {
                        return (0, _util.shadow)(this, "opCache", Object.create(null));
                    }
                    constructor(type, value){
                        this.type = type;
                        this.value = value;
                    }
                    static getOperator(op) {
                        return PostScriptToken.opCache[op] ||= new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
                    }
                    static get LBRACE() {
                        return (0, _util.shadow)(this, "LBRACE", new PostScriptToken(PostScriptTokenTypes.LBRACE, "{"));
                    }
                    static get RBRACE() {
                        return (0, _util.shadow)(this, "RBRACE", new PostScriptToken(PostScriptTokenTypes.RBRACE, "}"));
                    }
                    static get IF() {
                        return (0, _util.shadow)(this, "IF", new PostScriptToken(PostScriptTokenTypes.IF, "IF"));
                    }
                    static get IFELSE() {
                        return (0, _util.shadow)(this, "IFELSE", new PostScriptToken(PostScriptTokenTypes.IFELSE, "IFELSE"));
                    }
                }
                class PostScriptLexer {
                    constructor(stream){
                        this.stream = stream;
                        this.nextChar();
                        this.strBuf = [];
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch < 0) return _primitives.EOF;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (!(0, _core_utils.isWhiteSpace)(ch)) break;
                            ch = this.nextChar();
                        }
                        switch(ch | 0){
                            case 0x30:
                            case 0x31:
                            case 0x32:
                            case 0x33:
                            case 0x34:
                            case 0x35:
                            case 0x36:
                            case 0x37:
                            case 0x38:
                            case 0x39:
                            case 0x2b:
                            case 0x2d:
                            case 0x2e:
                                return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
                            case 0x7b:
                                this.nextChar();
                                return PostScriptToken.LBRACE;
                            case 0x7d:
                                this.nextChar();
                                return PostScriptToken.RBRACE;
                        }
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        strBuf[0] = String.fromCharCode(ch);
                        while((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5a || ch >= 0x61 && ch <= 0x7a))strBuf.push(String.fromCharCode(ch));
                        const str = strBuf.join("");
                        switch(str.toLowerCase()){
                            case "if":
                                return PostScriptToken.IF;
                            case "ifelse":
                                return PostScriptToken.IFELSE;
                            default:
                                return PostScriptToken.getOperator(str);
                        }
                    }
                    getNumber() {
                        let ch = this.currentChar;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        strBuf[0] = String.fromCharCode(ch);
                        while((ch = this.nextChar()) >= 0){
                            if (ch >= 0x30 && ch <= 0x39 || ch === 0x2d || ch === 0x2e) strBuf.push(String.fromCharCode(ch));
                            else break;
                        }
                        const value = parseFloat(strBuf.join(""));
                        if (isNaN(value)) throw new _util.FormatError(`Invalid floating point number: ${value}`);
                        return value;
                    }
                }
                exports.PostScriptLexer = PostScriptLexer;
            /***/ },
            /* 59 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RegionalImageCache = exports.LocalTilingPatternCache = exports.LocalImageCache = exports.LocalGStateCache = exports.LocalFunctionCache = exports.LocalColorSpaceCache = exports.GlobalImageCache = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                class BaseLocalCache {
                    constructor(options){
                        if (this.constructor === BaseLocalCache) (0, _util.unreachable)("Cannot initialize BaseLocalCache.");
                        this._onlyRefs = options?.onlyRefs === true;
                        if (!this._onlyRefs) {
                            this._nameRefMap = new Map();
                            this._imageMap = new Map();
                        }
                        this._imageCache = new _primitives.RefSetCache();
                    }
                    getByName(name) {
                        if (this._onlyRefs) (0, _util.unreachable)("Should not call `getByName` method.");
                        const ref = this._nameRefMap.get(name);
                        if (ref) return this.getByRef(ref);
                        return this._imageMap.get(name) || null;
                    }
                    getByRef(ref) {
                        return this._imageCache.get(ref) || null;
                    }
                    set(name, ref, data) {
                        (0, _util.unreachable)("Abstract method `set` called.");
                    }
                }
                class LocalImageCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalImageCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalImageCache = LocalImageCache;
                class LocalColorSpaceCache extends BaseLocalCache {
                    set(name = null, ref = null, data) {
                        if (typeof name !== "string" && !ref) throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            if (name !== null) this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalColorSpaceCache = LocalColorSpaceCache;
                class LocalFunctionCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('LocalFunctionCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.LocalFunctionCache = LocalFunctionCache;
                class LocalGStateCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalGStateCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalGStateCache = LocalGStateCache;
                class LocalTilingPatternCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.LocalTilingPatternCache = LocalTilingPatternCache;
                class RegionalImageCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('RegionalImageCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.RegionalImageCache = RegionalImageCache;
                class GlobalImageCache {
                    static NUM_PAGES_THRESHOLD = 2;
                    static MIN_IMAGES_TO_CACHE = 10;
                    static MAX_BYTE_SIZE = 5 * _util.MAX_IMAGE_SIZE_TO_CACHE;
                    constructor(){
                        this._refCache = new _primitives.RefSetCache();
                        this._imageCache = new _primitives.RefSetCache();
                    }
                    get _byteSize() {
                        let byteSize = 0;
                        for (const imageData of this._imageCache)byteSize += imageData.byteSize;
                        return byteSize;
                    }
                    get _cacheLimitReached() {
                        if (this._imageCache.size < GlobalImageCache.MIN_IMAGES_TO_CACHE) return false;
                        if (this._byteSize < GlobalImageCache.MAX_BYTE_SIZE) return false;
                        return true;
                    }
                    shouldCache(ref, pageIndex) {
                        let pageIndexSet = this._refCache.get(ref);
                        if (!pageIndexSet) {
                            pageIndexSet = new Set();
                            this._refCache.put(ref, pageIndexSet);
                        }
                        pageIndexSet.add(pageIndex);
                        if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return false;
                        if (!this._imageCache.has(ref) && this._cacheLimitReached) return false;
                        return true;
                    }
                    addByteSize(ref, byteSize) {
                        const imageData = this._imageCache.get(ref);
                        if (!imageData) return;
                        if (imageData.byteSize) return;
                        imageData.byteSize = byteSize;
                    }
                    getData(ref, pageIndex) {
                        const pageIndexSet = this._refCache.get(ref);
                        if (!pageIndexSet) return null;
                        if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return null;
                        const imageData = this._imageCache.get(ref);
                        if (!imageData) return null;
                        pageIndexSet.add(pageIndex);
                        return imageData;
                    }
                    setData(ref, data) {
                        if (!this._refCache.has(ref)) throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
                        if (this._imageCache.has(ref)) return;
                        if (this._cacheLimitReached) {
                            (0, _util.warn)("GlobalImageCache.setData - cache limit reached.");
                            return;
                        }
                        this._imageCache.put(ref, data);
                    }
                    clear(onlyData = false) {
                        if (!onlyData) this._refCache.clear();
                        this._imageCache.clear();
                    }
                }
                exports.GlobalImageCache = GlobalImageCache;
            /***/ },
            /* 60 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.bidi = bidi;
                var _util = __w_pdfjs_require__(2);
                const baseTypes = [
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "S",
                    "B",
                    "S",
                    "WS",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "B",
                    "B",
                    "S",
                    "WS",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ES",
                    "CS",
                    "ES",
                    "CS",
                    "CS",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "CS",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "CS",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "BN",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "EN",
                    "EN",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "EN",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L"
                ];
                const arabicTypes = [
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ON",
                    "ON",
                    "AL",
                    "ET",
                    "ET",
                    "AL",
                    "CS",
                    "AL",
                    "ON",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ET",
                    "AN",
                    "AN",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL"
                ];
                function isOdd(i) {
                    return (i & 1) !== 0;
                }
                function isEven(i) {
                    return (i & 1) === 0;
                }
                function findUnequal(arr, start, value) {
                    let j, jj;
                    for(j = start, jj = arr.length; j < jj; ++j){
                        if (arr[j] !== value) return j;
                    }
                    return j;
                }
                function setValues(arr, start, end, value) {
                    for(let j = start; j < end; ++j)arr[j] = value;
                }
                function reverseValues(arr, start, end) {
                    for(let i = start, j = end - 1; i < j; ++i, --j){
                        const temp = arr[i];
                        arr[i] = arr[j];
                        arr[j] = temp;
                    }
                }
                function createBidiText(str, isLTR, vertical = false) {
                    let dir = "ltr";
                    if (vertical) dir = "ttb";
                    else if (!isLTR) dir = "rtl";
                    return {
                        str: str,
                        dir: dir
                    };
                }
                const chars = [];
                const types = [];
                function bidi(str, startLevel = -1, vertical = false) {
                    let isLTR = true;
                    const strLength = str.length;
                    if (strLength === 0 || vertical) return createBidiText(str, isLTR, vertical);
                    chars.length = strLength;
                    types.length = strLength;
                    let numBidi = 0;
                    let i, ii;
                    for(i = 0; i < strLength; ++i){
                        chars[i] = str.charAt(i);
                        const charCode = str.charCodeAt(i);
                        let charType = "L";
                        if (charCode <= 0x00ff) charType = baseTypes[charCode];
                        else if (0x0590 <= charCode && charCode <= 0x05f4) charType = "R";
                        else if (0x0600 <= charCode && charCode <= 0x06ff) {
                            charType = arabicTypes[charCode & 0xff];
                            if (!charType) (0, _util.warn)("Bidi: invalid Unicode character " + charCode.toString(16));
                        } else if (0x0700 <= charCode && charCode <= 0x08ac || 0xfb50 <= charCode && charCode <= 0xfdff || 0xfe70 <= charCode && charCode <= 0xfeff) charType = "AL";
                        if (charType === "R" || charType === "AL" || charType === "AN") numBidi++;
                        types[i] = charType;
                    }
                    if (numBidi === 0) {
                        isLTR = true;
                        return createBidiText(str, isLTR);
                    }
                    if (startLevel === -1) {
                        if (numBidi / strLength < 0.3 && strLength > 4) {
                            isLTR = true;
                            startLevel = 0;
                        } else {
                            isLTR = false;
                            startLevel = 1;
                        }
                    }
                    const levels = [];
                    for(i = 0; i < strLength; ++i)levels[i] = startLevel;
                    const e = isOdd(startLevel) ? "R" : "L";
                    const sor = e;
                    const eor = sor;
                    let lastType = sor;
                    for(i = 0; i < strLength; ++i)if (types[i] === "NSM") types[i] = lastType;
                    else lastType = types[i];
                    lastType = sor;
                    let t;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "EN") types[i] = lastType === "AL" ? "AN" : "EN";
                        else if (t === "R" || t === "L" || t === "AL") lastType = t;
                    }
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "AL") types[i] = "R";
                    }
                    for(i = 1; i < strLength - 1; ++i){
                        if (types[i] === "ES" && types[i - 1] === "EN" && types[i + 1] === "EN") types[i] = "EN";
                        if (types[i] === "CS" && (types[i - 1] === "EN" || types[i - 1] === "AN") && types[i + 1] === types[i - 1]) types[i] = types[i - 1];
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "EN") {
                        for(let j = i - 1; j >= 0; --j){
                            if (types[j] !== "ET") break;
                            types[j] = "EN";
                        }
                        for(let j = i + 1; j < strLength; ++j){
                            if (types[j] !== "ET") break;
                            types[j] = "EN";
                        }
                    }
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "WS" || t === "ES" || t === "ET" || t === "CS") types[i] = "ON";
                    }
                    lastType = sor;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "EN") types[i] = lastType === "L" ? "L" : "EN";
                        else if (t === "R" || t === "L") lastType = t;
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "ON") {
                        const end = findUnequal(types, i + 1, "ON");
                        let before = sor;
                        if (i > 0) before = types[i - 1];
                        let after = eor;
                        if (end + 1 < strLength) after = types[end + 1];
                        if (before !== "L") before = "R";
                        if (after !== "L") after = "R";
                        if (before === after) setValues(types, i, end, before);
                        i = end - 1;
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "ON") types[i] = e;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (isEven(levels[i])) {
                            if (t === "R") levels[i] += 1;
                            else if (t === "AN" || t === "EN") levels[i] += 2;
                        } else if (t === "L" || t === "AN" || t === "EN") levels[i] += 1;
                    }
                    let highestLevel = -1;
                    let lowestOddLevel = 99;
                    let level;
                    for(i = 0, ii = levels.length; i < ii; ++i){
                        level = levels[i];
                        if (highestLevel < level) highestLevel = level;
                        if (lowestOddLevel > level && isOdd(level)) lowestOddLevel = level;
                    }
                    for(level = highestLevel; level >= lowestOddLevel; --level){
                        let start = -1;
                        for(i = 0, ii = levels.length; i < ii; ++i){
                            if (levels[i] < level) {
                                if (start >= 0) {
                                    reverseValues(chars, start, i);
                                    start = -1;
                                }
                            } else if (start < 0) start = i;
                        }
                        if (start >= 0) reverseValues(chars, start, levels.length);
                    }
                    for(i = 0, ii = chars.length; i < ii; ++i){
                        const ch = chars[i];
                        if (ch === "<" || ch === ">") chars[i] = "";
                    }
                    return createBidiText(chars.join(""), isLTR);
                }
            /***/ },
            /* 61 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFontSubstitution = getFontSubstitution;
                var _fonts_utils = __w_pdfjs_require__(38);
                var _core_utils = __w_pdfjs_require__(3);
                const NORMAL = {
                    style: "normal",
                    weight: "normal"
                };
                const BOLD = {
                    style: "normal",
                    weight: "bold"
                };
                const ITALIC = {
                    style: "italic",
                    weight: "normal"
                };
                const BOLDITALIC = {
                    style: "italic",
                    weight: "bold"
                };
                const substitutionMap = new Map([
                    [
                        "Times-Roman",
                        {
                            local: [
                                "Times New Roman",
                                "Times-Roman",
                                "Times",
                                "Liberation Serif",
                                "Nimbus Roman",
                                "Nimbus Roman L",
                                "Tinos",
                                "Thorndale",
                                "TeX Gyre Termes",
                                "FreeSerif",
                                "DejaVu Serif",
                                "Bitstream Vera Serif",
                                "Ubuntu"
                            ],
                            style: NORMAL,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-Bold",
                        {
                            alias: "Times-Roman",
                            style: BOLD,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-Italic",
                        {
                            alias: "Times-Roman",
                            style: ITALIC,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-BoldItalic",
                        {
                            alias: "Times-Roman",
                            style: BOLDITALIC,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Helvetica",
                        {
                            local: [
                                "Helvetica",
                                "Helvetica Neue",
                                "Arial",
                                "Arial Nova",
                                "Liberation Sans",
                                "Arimo",
                                "Nimbus Sans",
                                "Nimbus Sans L",
                                "A030",
                                "TeX Gyre Heros",
                                "FreeSans",
                                "DejaVu Sans",
                                "Albany",
                                "Bitstream Vera Sans",
                                "Arial Unicode MS",
                                "Microsoft Sans Serif",
                                "Apple Symbols",
                                "Cantarell"
                            ],
                            path: "LiberationSans-Regular.ttf",
                            style: NORMAL,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-Bold",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-Bold.ttf",
                            style: BOLD,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-Oblique",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-Italic.ttf",
                            style: ITALIC,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-BoldOblique",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-BoldItalic.ttf",
                            style: BOLDITALIC,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Courier",
                        {
                            local: [
                                "Courier",
                                "Courier New",
                                "Liberation Mono",
                                "Nimbus Mono",
                                "Nimbus Mono L",
                                "Cousine",
                                "Cumberland",
                                "TeX Gyre Cursor",
                                "FreeMono"
                            ],
                            style: NORMAL,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-Bold",
                        {
                            alias: "Courier",
                            style: BOLD,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-Oblique",
                        {
                            alias: "Courier",
                            style: ITALIC,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-BoldOblique",
                        {
                            alias: "Courier",
                            style: BOLDITALIC,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "ArialBlack",
                        {
                            local: [
                                "Arial Black"
                            ],
                            style: {
                                style: "normal",
                                weight: "900"
                            },
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "ArialBlack-Bold",
                        {
                            alias: "ArialBlack"
                        }
                    ],
                    [
                        "ArialBlack-Italic",
                        {
                            alias: "ArialBlack",
                            style: {
                                style: "italic",
                                weight: "900"
                            },
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "ArialBlack-BoldItalic",
                        {
                            alias: "ArialBlack-Italic"
                        }
                    ],
                    [
                        "ArialNarrow",
                        {
                            local: [
                                "Arial Narrow",
                                "Liberation Sans Narrow",
                                "Helvetica Condensed",
                                "Nimbus Sans Narrow",
                                "TeX Gyre Heros Cn"
                            ],
                            style: NORMAL,
                            fallback: "Helvetica"
                        }
                    ],
                    [
                        "ArialNarrow-Bold",
                        {
                            alias: "ArialNarrow",
                            style: BOLD,
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "ArialNarrow-Italic",
                        {
                            alias: "ArialNarrow",
                            style: ITALIC,
                            fallback: "Helvetica-Oblique"
                        }
                    ],
                    [
                        "ArialNarrow-BoldItalic",
                        {
                            alias: "ArialNarrow",
                            style: BOLDITALIC,
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "Calibri",
                        {
                            local: [
                                "Calibri",
                                "Carlito"
                            ],
                            style: NORMAL,
                            fallback: "Helvetica"
                        }
                    ],
                    [
                        "Calibri-Bold",
                        {
                            alias: "Calibri",
                            style: BOLD,
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "Calibri-Italic",
                        {
                            alias: "Calibri",
                            style: ITALIC,
                            fallback: "Helvetica-Oblique"
                        }
                    ],
                    [
                        "Calibri-BoldItalic",
                        {
                            alias: "Calibri",
                            style: BOLDITALIC,
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "Wingdings",
                        {
                            local: [
                                "Wingdings",
                                "URW Dingbats"
                            ],
                            style: NORMAL
                        }
                    ],
                    [
                        "Wingdings-Regular",
                        {
                            alias: "Wingdings"
                        }
                    ],
                    [
                        "Wingdings-Bold",
                        {
                            alias: "Wingdings"
                        }
                    ]
                ]);
                const fontAliases = new Map([
                    [
                        "Arial-Black",
                        "ArialBlack"
                    ]
                ]);
                function getStyleToAppend(style) {
                    switch(style){
                        case BOLD:
                            return "Bold";
                        case ITALIC:
                            return "Italic";
                        case BOLDITALIC:
                            return "Bold Italic";
                        default:
                            if (style?.weight === "bold") return "Bold";
                            if (style?.style === "italic") return "Italic";
                    }
                    return "";
                }
                function generateFont({ alias: alias, local: local, path: path, fallback: fallback, style: style, ultimate: ultimate }, src, localFontPath, useFallback = true, usePath = true, append = "") {
                    const result = {
                        style: null,
                        ultimate: null
                    };
                    if (local) {
                        const extra = append ? ` ${append}` : "";
                        for (const name of local)src.push(`local(${name}${extra})`);
                    }
                    if (alias) {
                        const substitution = substitutionMap.get(alias);
                        const aliasAppend = append || getStyleToAppend(style);
                        Object.assign(result, generateFont(substitution, src, localFontPath, useFallback && !fallback, usePath && !path, aliasAppend));
                    }
                    if (style) result.style = style;
                    if (ultimate) result.ultimate = ultimate;
                    if (useFallback && fallback) {
                        const fallbackInfo = substitutionMap.get(fallback);
                        const { ultimate: fallbackUltimate } = generateFont(fallbackInfo, src, localFontPath, useFallback, usePath && !path, append);
                        result.ultimate ||= fallbackUltimate;
                    }
                    if (usePath && path && localFontPath) src.push(`url(${localFontPath}${path})`);
                    return result;
                }
                function getFontSubstitution(systemFontCache, idFactory, localFontPath, baseFontName, standardFontName) {
                    baseFontName = (0, _fonts_utils.normalizeFontName)(baseFontName);
                    const key = baseFontName;
                    let substitutionInfo = systemFontCache.get(key);
                    if (substitutionInfo) return substitutionInfo;
                    let substitution = substitutionMap.get(baseFontName);
                    if (!substitution) {
                        for (const [alias, subst] of fontAliases)if (baseFontName.startsWith(alias)) {
                            baseFontName = `${subst}${baseFontName.substring(alias.length)}`;
                            substitution = substitutionMap.get(baseFontName);
                            break;
                        }
                    }
                    let mustAddBaseFont = false;
                    if (!substitution) {
                        substitution = substitutionMap.get(standardFontName);
                        mustAddBaseFont = true;
                    }
                    const loadedName = `${idFactory.getDocId()}_s${idFactory.createFontId()}`;
                    if (!substitution) {
                        if (!(0, _core_utils.validateFontName)(baseFontName)) {
                            systemFontCache.set(key, null);
                            return null;
                        }
                        const bold = /bold/gi.test(baseFontName);
                        const italic = /oblique|italic/gi.test(baseFontName);
                        const style = bold && italic && BOLDITALIC || bold && BOLD || italic && ITALIC || NORMAL;
                        substitutionInfo = {
                            css: loadedName,
                            guessFallback: true,
                            loadedName: loadedName,
                            baseFontName: baseFontName,
                            src: `local(${baseFontName})`,
                            style: style
                        };
                        systemFontCache.set(key, substitutionInfo);
                        return substitutionInfo;
                    }
                    const src = [];
                    if (mustAddBaseFont && (0, _core_utils.validateFontName)(baseFontName)) src.push(`local(${baseFontName})`);
                    const { style: style, ultimate: ultimate } = generateFont(substitution, src, localFontPath);
                    const guessFallback = ultimate === null;
                    const fallback = guessFallback ? "" : `,${ultimate}`;
                    substitutionInfo = {
                        css: `${loadedName}${fallback}`,
                        guessFallback: guessFallback,
                        loadedName: loadedName,
                        baseFontName: baseFontName,
                        src: src.join(","),
                        style: style
                    };
                    systemFontCache.set(key, substitutionInfo);
                    return substitutionInfo;
                }
            /***/ },
            /* 62 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ImageResizer = void 0;
                var _util = __w_pdfjs_require__(2);
                const MIN_IMAGE_DIM = 2048;
                const MAX_IMAGE_DIM = 65537;
                const MAX_ERROR = 128;
                class ImageResizer {
                    constructor(imgData, isMask){
                        this._imgData = imgData;
                        this._isMask = isMask;
                    }
                    static needsToBeResized(width, height) {
                        if (width <= this._goodSquareLength && height <= this._goodSquareLength) return false;
                        const { MAX_DIM: MAX_DIM } = this;
                        if (width > MAX_DIM || height > MAX_DIM) return true;
                        const area = width * height;
                        if (this._hasMaxArea) return area > this.MAX_AREA;
                        if (area < this._goodSquareLength ** 2) return false;
                        if (this._areGoodDims(width, height)) {
                            this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(width * height)));
                            return false;
                        }
                        this._goodSquareLength = this._guessMax(this._goodSquareLength, MAX_DIM, MAX_ERROR, 0);
                        const maxArea = this.MAX_AREA = this._goodSquareLength ** 2;
                        return area > maxArea;
                    }
                    static get MAX_DIM() {
                        return (0, _util.shadow)(this, "MAX_DIM", this._guessMax(MIN_IMAGE_DIM, MAX_IMAGE_DIM, 0, 1));
                    }
                    static get MAX_AREA() {
                        this._hasMaxArea = true;
                        return (0, _util.shadow)(this, "MAX_AREA", this._guessMax(ImageResizer._goodSquareLength, this.MAX_DIM, MAX_ERROR, 0) ** 2);
                    }
                    static set MAX_AREA(area) {
                        if (area >= 0) {
                            this._hasMaxArea = true;
                            (0, _util.shadow)(this, "MAX_AREA", area);
                        }
                    }
                    static setMaxArea(area) {
                        if (!this._hasMaxArea) this.MAX_AREA = area >> 2;
                    }
                    static _areGoodDims(width, height) {
                        try {
                            const canvas = new OffscreenCanvas(width, height);
                            const ctx = canvas.getContext("2d");
                            ctx.fillRect(0, 0, 1, 1);
                            const opacity = ctx.getImageData(0, 0, 1, 1).data[3];
                            canvas.width = canvas.height = 1;
                            return opacity !== 0;
                        } catch  {
                            return false;
                        }
                    }
                    static _guessMax(start, end, tolerance, defaultHeight) {
                        while(start + tolerance + 1 < end){
                            const middle = Math.floor((start + end) / 2);
                            const height = defaultHeight || middle;
                            if (this._areGoodDims(middle, height)) start = middle;
                            else end = middle;
                        }
                        return start;
                    }
                    static async createImage(imgData, isMask = false) {
                        return new ImageResizer(imgData, isMask)._createImage();
                    }
                    async _createImage() {
                        const data = this._encodeBMP();
                        const blob = new Blob([
                            data.buffer
                        ], {
                            type: "image/bmp"
                        });
                        const bitmapPromise = createImageBitmap(blob);
                        const { MAX_AREA: MAX_AREA, MAX_DIM: MAX_DIM } = ImageResizer;
                        const { _imgData: imgData } = this;
                        const { width: width, height: height } = imgData;
                        const minFactor = Math.max(width / MAX_DIM, height / MAX_DIM, Math.sqrt(width * height / MAX_AREA));
                        const firstFactor = Math.max(minFactor, 2);
                        const factor = Math.round(10 * (minFactor + 1.25)) / 10 / firstFactor;
                        const N = Math.floor(Math.log2(factor));
                        const steps = new Array(N + 2).fill(2);
                        steps[0] = firstFactor;
                        steps.splice(-1, 1, factor / (1 << N));
                        let newWidth = width;
                        let newHeight = height;
                        let bitmap = await bitmapPromise;
                        for (const step of steps){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            newWidth = Math.floor(newWidth / step) - 1;
                            newHeight = Math.floor(newHeight / step) - 1;
                            const canvas = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = canvas.transferToImageBitmap();
                        }
                        imgData.data = null;
                        imgData.bitmap = bitmap;
                        imgData.width = newWidth;
                        imgData.height = newHeight;
                        return imgData;
                    }
                    _encodeBMP() {
                        const { width: width, height: height, kind: kind } = this._imgData;
                        let data = this._imgData.data;
                        let bitPerPixel;
                        let colorTable = new Uint8Array(0);
                        let maskTable = colorTable;
                        let compression = 0;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                {
                                    bitPerPixel = 1;
                                    colorTable = new Uint8Array(this._isMask ? [
                                        255,
                                        255,
                                        255,
                                        255,
                                        0,
                                        0,
                                        0,
                                        0
                                    ] : [
                                        0,
                                        0,
                                        0,
                                        0,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]);
                                    const rowLen = width + 7 >> 3;
                                    const rowSize = rowLen + 3 & -4;
                                    if (rowLen !== rowSize) {
                                        const newData = new Uint8Array(rowSize * height);
                                        let k = 0;
                                        for(let i = 0, ii = height * rowLen; i < ii; i += rowLen, k += rowSize)newData.set(data.subarray(i, i + rowLen), k);
                                        data = newData;
                                    }
                                    break;
                                }
                            case _util.ImageKind.RGB_24BPP:
                                bitPerPixel = 24;
                                if (width & 3) {
                                    const rowLen = 3 * width;
                                    const rowSize = rowLen + 3 & -4;
                                    const extraLen = rowSize - rowLen;
                                    const newData = new Uint8Array(rowSize * height);
                                    let k = 0;
                                    for(let i = 0, ii = height * rowLen; i < ii; i += rowLen){
                                        const row = data.subarray(i, i + rowLen);
                                        for(let j = 0; j < rowLen; j += 3){
                                            newData[k++] = row[j + 2];
                                            newData[k++] = row[j + 1];
                                            newData[k++] = row[j];
                                        }
                                        k += extraLen;
                                    }
                                    data = newData;
                                } else for(let i = 0, ii = data.length; i < ii; i += 3){
                                    const tmp = data[i];
                                    data[i] = data[i + 2];
                                    data[i + 2] = tmp;
                                }
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                bitPerPixel = 32;
                                compression = 3;
                                maskTable = new Uint8Array(68);
                                const view = new DataView(maskTable.buffer);
                                if (_util.FeatureTest.isLittleEndian) {
                                    view.setUint32(0, 0x000000ff, true);
                                    view.setUint32(4, 0x0000ff00, true);
                                    view.setUint32(8, 0x00ff0000, true);
                                    view.setUint32(12, 0xff000000, true);
                                } else {
                                    view.setUint32(0, 0xff000000, true);
                                    view.setUint32(4, 0x00ff0000, true);
                                    view.setUint32(8, 0x0000ff00, true);
                                    view.setUint32(12, 0x000000ff, true);
                                }
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        let i = 0;
                        const headerLength = 40 + maskTable.length;
                        const fileLength = 14 + headerLength + colorTable.length + data.length;
                        const bmpData = new Uint8Array(fileLength);
                        const view1 = new DataView(bmpData.buffer);
                        view1.setUint16(i, 0x4d42, true);
                        i += 2;
                        view1.setUint32(i, fileLength, true);
                        i += 4;
                        view1.setUint32(i, 0, true);
                        i += 4;
                        view1.setUint32(i, 14 + headerLength + colorTable.length, true);
                        i += 4;
                        view1.setUint32(i, headerLength, true);
                        i += 4;
                        view1.setInt32(i, width, true);
                        i += 4;
                        view1.setInt32(i, -height, true);
                        i += 4;
                        view1.setUint16(i, 1, true);
                        i += 2;
                        view1.setUint16(i, bitPerPixel, true);
                        i += 2;
                        view1.setUint32(i, compression, true);
                        i += 4;
                        view1.setUint32(i, 0, true);
                        i += 4;
                        view1.setInt32(i, 0, true);
                        i += 4;
                        view1.setInt32(i, 0, true);
                        i += 4;
                        view1.setUint32(i, colorTable.length / 4, true);
                        i += 4;
                        view1.setUint32(i, 0, true);
                        i += 4;
                        bmpData.set(maskTable, i);
                        i += maskTable.length;
                        bmpData.set(colorTable, i);
                        i += colorTable.length;
                        bmpData.set(data, i);
                        return bmpData;
                    }
                }
                exports.ImageResizer = ImageResizer;
                ImageResizer._goodSquareLength = MIN_IMAGE_DIM;
            /***/ },
            /* 63 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(2);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 64 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OperatorList = void 0;
                var _util = __w_pdfjs_require__(2);
                function addState(parentState, pattern, checkFn, iterateFn, processFn) {
                    let state = parentState;
                    for(let i = 0, ii = pattern.length - 1; i < ii; i++){
                        const item = pattern[i];
                        state = state[item] ||= [];
                    }
                    state[pattern.at(-1)] = {
                        checkFn: checkFn,
                        iterateFn: iterateFn,
                        processFn: processFn
                    };
                }
                const InitialState = [];
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintInlineImageXObject,
                    _util.OPS.restore
                ], null, function iterateInlineImageGroup(context, i) {
                    const fnArray = context.fnArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            return fnArray[i] === _util.OPS.transform;
                        case 2:
                            return fnArray[i] === _util.OPS.paintInlineImageXObject;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateInlineImageGroup - invalid pos: ${pos}`);
                }, function foundInlineImageGroup(context, i) {
                    const MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
                    const MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
                    const MAX_WIDTH = 1000;
                    const IMAGE_PADDING = 1;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIIXO = curr - 1;
                    const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
                    if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) return i - (i - iFirstSave) % 4;
                    let maxX = 0;
                    const map = [];
                    let maxLineHeight = 0;
                    let currentX = IMAGE_PADDING, currentY = IMAGE_PADDING;
                    for(let q = 0; q < count; q++){
                        const transform = argsArray[iFirstTransform + (q << 2)];
                        const img = argsArray[iFirstPIIXO + (q << 2)][0];
                        if (currentX + img.width > MAX_WIDTH) {
                            maxX = Math.max(maxX, currentX);
                            currentY += maxLineHeight + 2 * IMAGE_PADDING;
                            currentX = 0;
                            maxLineHeight = 0;
                        }
                        map.push({
                            transform: transform,
                            x: currentX,
                            y: currentY,
                            w: img.width,
                            h: img.height
                        });
                        currentX += img.width + 2 * IMAGE_PADDING;
                        maxLineHeight = Math.max(maxLineHeight, img.height);
                    }
                    const imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
                    const imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
                    const imgData = new Uint8Array(imgWidth * imgHeight * 4);
                    const imgRowSize = imgWidth << 2;
                    for(let q = 0; q < count; q++){
                        const data = argsArray[iFirstPIIXO + (q << 2)][0].data;
                        const rowSize = map[q].w << 2;
                        let dataOffset = 0;
                        let offset = map[q].x + map[q].y * imgWidth << 2;
                        imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
                        for(let k = 0, kk = map[q].h; k < kk; k++){
                            imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
                            dataOffset += rowSize;
                            offset += imgRowSize;
                        }
                        imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
                        while(offset >= 0){
                            data[offset - 4] = data[offset];
                            data[offset - 3] = data[offset + 1];
                            data[offset - 2] = data[offset + 2];
                            data[offset - 1] = data[offset + 3];
                            data[offset + rowSize] = data[offset + rowSize - 4];
                            data[offset + rowSize + 1] = data[offset + rowSize - 3];
                            data[offset + rowSize + 2] = data[offset + rowSize - 2];
                            data[offset + rowSize + 3] = data[offset + rowSize - 1];
                            offset -= imgRowSize;
                        }
                    }
                    const img = {
                        width: imgWidth,
                        height: imgHeight
                    };
                    if (context.isOffscreenCanvasSupported) {
                        const canvas = new OffscreenCanvas(imgWidth, imgHeight);
                        const ctx = canvas.getContext("2d");
                        ctx.putImageData(new ImageData(new Uint8ClampedArray(imgData.buffer), imgWidth, imgHeight), 0, 0);
                        img.bitmap = canvas.transferToImageBitmap();
                        img.data = null;
                    } else {
                        img.kind = _util.ImageKind.RGBA_32BPP;
                        img.data = imgData;
                    }
                    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintInlineImageXObjectGroup);
                    argsArray.splice(iFirstSave, count * 4, [
                        img,
                        map
                    ]);
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintImageMaskXObject,
                    _util.OPS.restore
                ], null, function iterateImageMaskGroup(context, i) {
                    const fnArray = context.fnArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            return fnArray[i] === _util.OPS.transform;
                        case 2:
                            return fnArray[i] === _util.OPS.paintImageMaskXObject;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateImageMaskGroup - invalid pos: ${pos}`);
                }, function foundImageMaskGroup(context, i) {
                    const MIN_IMAGES_IN_MASKS_BLOCK = 10;
                    const MAX_IMAGES_IN_MASKS_BLOCK = 100;
                    const MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIMXO = curr - 1;
                    let count = Math.floor((i - iFirstSave) / 4);
                    if (count < MIN_IMAGES_IN_MASKS_BLOCK) return i - (i - iFirstSave) % 4;
                    let isSameImage = false;
                    let iTransform, transformArgs;
                    const firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
                    const firstTransformArg0 = argsArray[iFirstTransform][0], firstTransformArg1 = argsArray[iFirstTransform][1], firstTransformArg2 = argsArray[iFirstTransform][2], firstTransformArg3 = argsArray[iFirstTransform][3];
                    if (firstTransformArg1 === firstTransformArg2) {
                        isSameImage = true;
                        iTransform = iFirstTransform + 4;
                        let iPIMXO = iFirstPIMXO + 4;
                        for(let q = 1; q < count; q++, iTransform += 4, iPIMXO += 4){
                            transformArgs = argsArray[iTransform];
                            if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== firstTransformArg1 || transformArgs[2] !== firstTransformArg2 || transformArgs[3] !== firstTransformArg3) {
                                if (q < MIN_IMAGES_IN_MASKS_BLOCK) isSameImage = false;
                                else count = q;
                                break;
                            }
                        }
                    }
                    if (isSameImage) {
                        count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
                        const positions = new Float32Array(count * 2);
                        iTransform = iFirstTransform;
                        for(let q = 0; q < count; q++, iTransform += 4){
                            transformArgs = argsArray[iTransform];
                            positions[q << 1] = transformArgs[4];
                            positions[(q << 1) + 1] = transformArgs[5];
                        }
                        fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectRepeat);
                        argsArray.splice(iFirstSave, count * 4, [
                            firstPIMXOArg0,
                            firstTransformArg0,
                            firstTransformArg1,
                            firstTransformArg2,
                            firstTransformArg3,
                            positions
                        ]);
                    } else {
                        count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
                        const images = [];
                        for(let q = 0; q < count; q++){
                            transformArgs = argsArray[iFirstTransform + (q << 2)];
                            const maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
                            images.push({
                                data: maskParams.data,
                                width: maskParams.width,
                                height: maskParams.height,
                                interpolate: maskParams.interpolate,
                                count: maskParams.count,
                                transform: transformArgs
                            });
                        }
                        fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectGroup);
                        argsArray.splice(iFirstSave, count * 4, [
                            images
                        ]);
                    }
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintImageXObject,
                    _util.OPS.restore
                ], function(context) {
                    const argsArray = context.argsArray;
                    const iFirstTransform = context.iCurr - 2;
                    return argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0;
                }, function iterateImageGroup(context, i) {
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            if (fnArray[i] !== _util.OPS.transform) return false;
                            const iFirstTransform = context.iCurr - 2;
                            const firstTransformArg0 = argsArray[iFirstTransform][0];
                            const firstTransformArg3 = argsArray[iFirstTransform][3];
                            if (argsArray[i][0] !== firstTransformArg0 || argsArray[i][1] !== 0 || argsArray[i][2] !== 0 || argsArray[i][3] !== firstTransformArg3) return false;
                            return true;
                        case 2:
                            if (fnArray[i] !== _util.OPS.paintImageXObject) return false;
                            const iFirstPIXO = context.iCurr - 1;
                            const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                            if (argsArray[i][0] !== firstPIXOArg0) return false;
                            return true;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateImageGroup - invalid pos: ${pos}`);
                }, function(context, i) {
                    const MIN_IMAGES_IN_BLOCK = 3;
                    const MAX_IMAGES_IN_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIXO = curr - 1;
                    const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                    const firstTransformArg0 = argsArray[iFirstTransform][0];
                    const firstTransformArg3 = argsArray[iFirstTransform][3];
                    const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_BLOCK);
                    if (count < MIN_IMAGES_IN_BLOCK) return i - (i - iFirstSave) % 4;
                    const positions = new Float32Array(count * 2);
                    let iTransform = iFirstTransform;
                    for(let q = 0; q < count; q++, iTransform += 4){
                        const transformArgs = argsArray[iTransform];
                        positions[q << 1] = transformArgs[4];
                        positions[(q << 1) + 1] = transformArgs[5];
                    }
                    const args = [
                        firstPIXOArg0,
                        firstTransformArg0,
                        firstTransformArg3,
                        positions
                    ];
                    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageXObjectRepeat);
                    argsArray.splice(iFirstSave, count * 4, args);
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.beginText,
                    _util.OPS.setFont,
                    _util.OPS.setTextMatrix,
                    _util.OPS.showText,
                    _util.OPS.endText
                ], null, function iterateShowTextGroup(context, i) {
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const iFirstSave = context.iCurr - 4;
                    const pos = (i - iFirstSave) % 5;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.beginText;
                        case 1:
                            return fnArray[i] === _util.OPS.setFont;
                        case 2:
                            return fnArray[i] === _util.OPS.setTextMatrix;
                        case 3:
                            if (fnArray[i] !== _util.OPS.showText) return false;
                            const iFirstSetFont = context.iCurr - 3;
                            const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                            const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                            if (argsArray[i][0] !== firstSetFontArg0 || argsArray[i][1] !== firstSetFontArg1) return false;
                            return true;
                        case 4:
                            return fnArray[i] === _util.OPS.endText;
                    }
                    throw new Error(`iterateShowTextGroup - invalid pos: ${pos}`);
                }, function(context, i) {
                    const MIN_CHARS_IN_BLOCK = 3;
                    const MAX_CHARS_IN_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstBeginText = curr - 4;
                    const iFirstSetFont = curr - 3;
                    const iFirstSetTextMatrix = curr - 2;
                    const iFirstShowText = curr - 1;
                    const iFirstEndText = curr;
                    const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                    const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                    let count = Math.min(Math.floor((i - iFirstBeginText) / 5), MAX_CHARS_IN_BLOCK);
                    if (count < MIN_CHARS_IN_BLOCK) return i - (i - iFirstBeginText) % 5;
                    let iFirst = iFirstBeginText;
                    if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
                        count++;
                        iFirst -= 5;
                    }
                    let iEndText = iFirst + 4;
                    for(let q = 1; q < count; q++){
                        fnArray.splice(iEndText, 3);
                        argsArray.splice(iEndText, 3);
                        iEndText += 2;
                    }
                    return iEndText + 1;
                });
                class NullOptimizer {
                    constructor(queue){
                        this.queue = queue;
                    }
                    _optimize() {}
                    push(fn, args) {
                        this.queue.fnArray.push(fn);
                        this.queue.argsArray.push(args);
                        this._optimize();
                    }
                    flush() {}
                    reset() {}
                }
                class QueueOptimizer extends NullOptimizer {
                    constructor(queue){
                        super(queue);
                        this.state = null;
                        this.context = {
                            iCurr: 0,
                            fnArray: queue.fnArray,
                            argsArray: queue.argsArray,
                            isOffscreenCanvasSupported: false
                        };
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                    set isOffscreenCanvasSupported(value) {
                        this.context.isOffscreenCanvasSupported = value;
                    }
                    _optimize() {
                        const fnArray = this.queue.fnArray;
                        let i = this.lastProcessed, ii = fnArray.length;
                        let state = this.state;
                        let match = this.match;
                        if (!state && !match && i + 1 === ii && !InitialState[fnArray[i]]) {
                            this.lastProcessed = ii;
                            return;
                        }
                        const context = this.context;
                        while(i < ii){
                            if (match) {
                                const iterate = (0, match.iterateFn)(context, i);
                                if (iterate) {
                                    i++;
                                    continue;
                                }
                                i = (0, match.processFn)(context, i + 1);
                                ii = fnArray.length;
                                match = null;
                                state = null;
                                if (i >= ii) break;
                            }
                            state = (state || InitialState)[fnArray[i]];
                            if (!state || Array.isArray(state)) {
                                i++;
                                continue;
                            }
                            context.iCurr = i;
                            i++;
                            if (state.checkFn && !(0, state.checkFn)(context)) {
                                state = null;
                                continue;
                            }
                            match = state;
                            state = null;
                        }
                        this.state = state;
                        this.match = match;
                        this.lastProcessed = i;
                    }
                    flush() {
                        while(this.match){
                            const length = this.queue.fnArray.length;
                            this.lastProcessed = (0, this.match.processFn)(this.context, length);
                            this.match = null;
                            this.state = null;
                            this._optimize();
                        }
                    }
                    reset() {
                        this.state = null;
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                }
                class OperatorList {
                    static CHUNK_SIZE = 1000;
                    static CHUNK_SIZE_ABOUT = this.CHUNK_SIZE - 5;
                    constructor(intent = 0, streamSink){
                        this._streamSink = streamSink;
                        this.fnArray = [];
                        this.argsArray = [];
                        this.optimizer = streamSink && !(intent & _util.RenderingIntentFlag.OPLIST) ? new QueueOptimizer(this) : new NullOptimizer(this);
                        this.dependencies = new Set();
                        this._totalLength = 0;
                        this.weight = 0;
                        this._resolved = streamSink ? null : Promise.resolve();
                    }
                    set isOffscreenCanvasSupported(value) {
                        this.optimizer.isOffscreenCanvasSupported = value;
                    }
                    get length() {
                        return this.argsArray.length;
                    }
                    get ready() {
                        return this._resolved || this._streamSink.ready;
                    }
                    get totalLength() {
                        return this._totalLength + this.length;
                    }
                    addOp(fn, args) {
                        this.optimizer.push(fn, args);
                        this.weight++;
                        if (this._streamSink) {
                            if (this.weight >= OperatorList.CHUNK_SIZE) this.flush();
                            else if (this.weight >= OperatorList.CHUNK_SIZE_ABOUT && (fn === _util.OPS.restore || fn === _util.OPS.endText)) this.flush();
                        }
                    }
                    addImageOps(fn, args, optionalContent) {
                        if (optionalContent !== undefined) this.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        this.addOp(fn, args);
                        if (optionalContent !== undefined) this.addOp(_util.OPS.endMarkedContent, []);
                    }
                    addDependency(dependency) {
                        if (this.dependencies.has(dependency)) return;
                        this.dependencies.add(dependency);
                        this.addOp(_util.OPS.dependency, [
                            dependency
                        ]);
                    }
                    addDependencies(dependencies) {
                        for (const dependency of dependencies)this.addDependency(dependency);
                    }
                    addOpList(opList) {
                        if (!(opList instanceof OperatorList)) {
                            (0, _util.warn)('addOpList - ignoring invalid "opList" parameter.');
                            return;
                        }
                        for (const dependency of opList.dependencies)this.dependencies.add(dependency);
                        for(let i = 0, ii = opList.length; i < ii; i++)this.addOp(opList.fnArray[i], opList.argsArray[i]);
                    }
                    getIR() {
                        return {
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            length: this.length
                        };
                    }
                    get _transfers() {
                        const transfers = [];
                        const { fnArray: fnArray, argsArray: argsArray, length: length } = this;
                        for(let i = 0; i < length; i++)switch(fnArray[i]){
                            case _util.OPS.paintInlineImageXObject:
                            case _util.OPS.paintInlineImageXObjectGroup:
                            case _util.OPS.paintImageMaskXObject:
                                const arg = argsArray[i][0];
                                if (!arg.cached && arg.data?.buffer instanceof ArrayBuffer) transfers.push(arg.data.buffer);
                                break;
                        }
                        return transfers;
                    }
                    flush(lastChunk = false, separateAnnots = null) {
                        this.optimizer.flush();
                        const length = this.length;
                        this._totalLength += length;
                        this._streamSink.enqueue({
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            lastChunk: lastChunk,
                            separateAnnots: separateAnnots,
                            length: length
                        }, 1, this._transfers);
                        this.dependencies.clear();
                        this.fnArray.length = 0;
                        this.argsArray.length = 0;
                        this.weight = 0;
                        this.optimizer.reset();
                    }
                }
                exports.OperatorList = OperatorList;
            /***/ },
            /* 65 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _image_utils = __w_pdfjs_require__(28);
                var _base_stream = __w_pdfjs_require__(5);
                var _colorspace = __w_pdfjs_require__(12);
                var _decode_stream = __w_pdfjs_require__(18);
                var _image_resizer = __w_pdfjs_require__(62);
                var _jpeg_stream = __w_pdfjs_require__(26);
                var _jpx = __w_pdfjs_require__(30);
                var _primitives = __w_pdfjs_require__(4);
                function decodeAndClamp(value, addend, coefficient, max) {
                    value = addend + value * coefficient;
                    if (value < 0) value = 0;
                    else if (value > max) value = max;
                    return value;
                }
                function resizeImageMask(src, bpc, w1, h1, w2, h2) {
                    const length = w2 * h2;
                    let dest;
                    if (bpc <= 8) dest = new Uint8Array(length);
                    else if (bpc <= 16) dest = new Uint16Array(length);
                    else dest = new Uint32Array(length);
                    const xRatio = w1 / w2;
                    const yRatio = h1 / h2;
                    let i, j, py, newIndex = 0, oldIndex;
                    const xScaled = new Uint16Array(w2);
                    const w1Scanline = w1;
                    for(i = 0; i < w2; i++)xScaled[i] = Math.floor(i * xRatio);
                    for(i = 0; i < h2; i++){
                        py = Math.floor(i * yRatio) * w1Scanline;
                        for(j = 0; j < w2; j++){
                            oldIndex = py + xScaled[j];
                            dest[newIndex++] = src[oldIndex];
                        }
                    }
                    return dest;
                }
                class PDFImage {
                    constructor({ xref: xref, res: res, image: image, isInline: isInline = false, smask: smask = null, mask: mask = null, isMask: isMask = false, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }){
                        this.image = image;
                        const dict = image.dict;
                        const filter = dict.get("F", "Filter");
                        let filterName;
                        if (filter instanceof _primitives.Name) filterName = filter.name;
                        else if (Array.isArray(filter)) {
                            const filterZero = xref.fetchIfRef(filter[0]);
                            if (filterZero instanceof _primitives.Name) filterName = filterZero.name;
                        }
                        switch(filterName){
                            case "JPXDecode":
                                const jpxImage = new _jpx.JpxImage();
                                jpxImage.parseImageProperties(image.stream);
                                image.stream.reset();
                                image.width = jpxImage.width;
                                image.height = jpxImage.height;
                                image.bitsPerComponent = jpxImage.bitsPerComponent;
                                image.numComps = jpxImage.componentsCount;
                                break;
                            case "JBIG2Decode":
                                image.bitsPerComponent = 1;
                                image.numComps = 1;
                                break;
                        }
                        let width = dict.get("W", "Width");
                        let height = dict.get("H", "Height");
                        if (Number.isInteger(image.width) && image.width > 0 && Number.isInteger(image.height) && image.height > 0 && (image.width !== width || image.height !== height)) {
                            (0, _util.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary.");
                            width = image.width;
                            height = image.height;
                        }
                        if (width < 1 || height < 1) throw new _util.FormatError(`Invalid image width: ${width} or height: ${height}`);
                        this.width = width;
                        this.height = height;
                        this.interpolate = dict.get("I", "Interpolate");
                        this.imageMask = dict.get("IM", "ImageMask") || false;
                        this.matte = dict.get("Matte") || false;
                        let bitsPerComponent = image.bitsPerComponent;
                        if (!bitsPerComponent) {
                            bitsPerComponent = dict.get("BPC", "BitsPerComponent");
                            if (!bitsPerComponent) {
                                if (this.imageMask) bitsPerComponent = 1;
                                else throw new _util.FormatError(`Bits per component missing in image: ${this.imageMask}`);
                            }
                        }
                        this.bpc = bitsPerComponent;
                        if (!this.imageMask) {
                            let colorSpace = dict.getRaw("CS") || dict.getRaw("ColorSpace");
                            if (!colorSpace) {
                                (0, _util.info)("JPX images (which do not require color spaces)");
                                switch(image.numComps){
                                    case 1:
                                        colorSpace = _primitives.Name.get("DeviceGray");
                                        break;
                                    case 3:
                                        colorSpace = _primitives.Name.get("DeviceRGB");
                                        break;
                                    case 4:
                                        colorSpace = _primitives.Name.get("DeviceCMYK");
                                        break;
                                    default:
                                        throw new Error(`JPX images with ${image.numComps} color components not supported.`);
                                }
                            }
                            this.colorSpace = _colorspace.ColorSpace.parse({
                                cs: colorSpace,
                                xref: xref,
                                resources: isInline ? res : null,
                                pdfFunctionFactory: pdfFunctionFactory,
                                localColorSpaceCache: localColorSpaceCache
                            });
                            this.numComps = this.colorSpace.numComps;
                        }
                        this.decode = dict.getArray("D", "Decode");
                        this.needsDecode = false;
                        if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, bitsPerComponent) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
                            this.needsDecode = true;
                            const max = (1 << bitsPerComponent) - 1;
                            this.decodeCoefficients = [];
                            this.decodeAddends = [];
                            const isIndexed = this.colorSpace?.name === "Indexed";
                            for(let i = 0, j = 0; i < this.decode.length; i += 2, ++j){
                                const dmin = this.decode[i];
                                const dmax = this.decode[i + 1];
                                this.decodeCoefficients[j] = isIndexed ? (dmax - dmin) / max : dmax - dmin;
                                this.decodeAddends[j] = isIndexed ? dmin : max * dmin;
                            }
                        }
                        if (smask) this.smask = new PDFImage({
                            xref: xref,
                            res: res,
                            image: smask,
                            isInline: isInline,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        else if (mask) {
                            if (mask instanceof _base_stream.BaseStream) {
                                const maskDict = mask.dict, imageMask = maskDict.get("IM", "ImageMask");
                                if (!imageMask) (0, _util.warn)("Ignoring /Mask in image without /ImageMask.");
                                else this.mask = new PDFImage({
                                    xref: xref,
                                    res: res,
                                    image: mask,
                                    isInline: isInline,
                                    isMask: true,
                                    pdfFunctionFactory: pdfFunctionFactory,
                                    localColorSpaceCache: localColorSpaceCache
                                });
                            } else this.mask = mask;
                        }
                    }
                    static async buildImage({ xref: xref, res: res, image: image, isInline: isInline = false, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }) {
                        const imageData = image;
                        let smaskData = null;
                        let maskData = null;
                        const smask = image.dict.get("SMask");
                        const mask = image.dict.get("Mask");
                        if (smask) {
                            if (smask instanceof _base_stream.BaseStream) smaskData = smask;
                            else (0, _util.warn)("Unsupported /SMask format.");
                        } else if (mask) {
                            if (mask instanceof _base_stream.BaseStream || Array.isArray(mask)) maskData = mask;
                            else (0, _util.warn)("Unsupported /Mask format.");
                        }
                        return new PDFImage({
                            xref: xref,
                            res: res,
                            image: imageData,
                            isInline: isInline,
                            smask: smaskData,
                            mask: maskData,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                    }
                    static createRawMask({ imgArray: imgArray, width: width, height: height, imageIsFromDecodeStream: imageIsFromDecodeStream, inverseDecode: inverseDecode, interpolate: interpolate }) {
                        const computedLength = (width + 7 >> 3) * height;
                        const actualLength = imgArray.byteLength;
                        const haveFullData = computedLength === actualLength;
                        let data, i;
                        if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) data = imgArray;
                        else if (!inverseDecode) data = new Uint8Array(imgArray);
                        else {
                            data = new Uint8Array(computedLength);
                            data.set(imgArray);
                            data.fill(0xff, actualLength);
                        }
                        if (inverseDecode) for(i = 0; i < actualLength; i++)data[i] ^= 0xff;
                        return {
                            data: data,
                            width: width,
                            height: height,
                            interpolate: interpolate
                        };
                    }
                    static async createMask({ imgArray: imgArray, width: width, height: height, imageIsFromDecodeStream: imageIsFromDecodeStream, inverseDecode: inverseDecode, interpolate: interpolate, isOffscreenCanvasSupported: isOffscreenCanvasSupported = false }) {
                        const isSingleOpaquePixel = width === 1 && height === 1 && inverseDecode === (imgArray.length === 0 || !!(imgArray[0] & 128));
                        if (isSingleOpaquePixel) return {
                            isSingleOpaquePixel: isSingleOpaquePixel
                        };
                        if (isOffscreenCanvasSupported) {
                            if (_image_resizer.ImageResizer.needsToBeResized(width, height)) {
                                const data = new Uint8ClampedArray(width * height * 4);
                                (0, _image_utils.convertBlackAndWhiteToRGBA)({
                                    src: imgArray,
                                    dest: data,
                                    width: width,
                                    height: height,
                                    nonBlackColor: 0,
                                    inverseDecode: inverseDecode
                                });
                                return _image_resizer.ImageResizer.createImage({
                                    kind: _util.ImageKind.RGBA_32BPP,
                                    data: data,
                                    width: width,
                                    height: height,
                                    interpolate: interpolate
                                });
                            }
                            const canvas = new OffscreenCanvas(width, height);
                            const ctx = canvas.getContext("2d");
                            const imgData = ctx.createImageData(width, height);
                            (0, _image_utils.convertBlackAndWhiteToRGBA)({
                                src: imgArray,
                                dest: imgData.data,
                                width: width,
                                height: height,
                                nonBlackColor: 0,
                                inverseDecode: inverseDecode
                            });
                            ctx.putImageData(imgData, 0, 0);
                            const bitmap = canvas.transferToImageBitmap();
                            return {
                                data: null,
                                width: width,
                                height: height,
                                interpolate: interpolate,
                                bitmap: bitmap
                            };
                        }
                        return this.createRawMask({
                            imgArray: imgArray,
                            width: width,
                            height: height,
                            inverseDecode: inverseDecode,
                            imageIsFromDecodeStream: imageIsFromDecodeStream,
                            interpolate: interpolate
                        });
                    }
                    get drawWidth() {
                        return Math.max(this.width, this.smask?.width || 0, this.mask?.width || 0);
                    }
                    get drawHeight() {
                        return Math.max(this.height, this.smask?.height || 0, this.mask?.height || 0);
                    }
                    decodeBuffer(buffer) {
                        const bpc = this.bpc;
                        const numComps = this.numComps;
                        const decodeAddends = this.decodeAddends;
                        const decodeCoefficients = this.decodeCoefficients;
                        const max = (1 << bpc) - 1;
                        let i, ii;
                        if (bpc === 1) {
                            for(i = 0, ii = buffer.length; i < ii; i++)buffer[i] = +!buffer[i];
                            return;
                        }
                        let index = 0;
                        for(i = 0, ii = this.width * this.height; i < ii; i++)for(let j = 0; j < numComps; j++){
                            buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
                            index++;
                        }
                    }
                    getComponents(buffer) {
                        const bpc = this.bpc;
                        if (bpc === 8) return buffer;
                        const width = this.width;
                        const height = this.height;
                        const numComps = this.numComps;
                        const length = width * height * numComps;
                        let bufferPos = 0;
                        let output;
                        if (bpc <= 8) output = new Uint8Array(length);
                        else if (bpc <= 16) output = new Uint16Array(length);
                        else output = new Uint32Array(length);
                        const rowComps = width * numComps;
                        const max = (1 << bpc) - 1;
                        let i = 0, ii, buf;
                        if (bpc === 1) {
                            let mask, loop1End, loop2End;
                            for(let j = 0; j < height; j++){
                                loop1End = i + (rowComps & -8);
                                loop2End = i + rowComps;
                                while(i < loop1End){
                                    buf = buffer[bufferPos++];
                                    output[i] = buf >> 7 & 1;
                                    output[i + 1] = buf >> 6 & 1;
                                    output[i + 2] = buf >> 5 & 1;
                                    output[i + 3] = buf >> 4 & 1;
                                    output[i + 4] = buf >> 3 & 1;
                                    output[i + 5] = buf >> 2 & 1;
                                    output[i + 6] = buf >> 1 & 1;
                                    output[i + 7] = buf & 1;
                                    i += 8;
                                }
                                if (i < loop2End) {
                                    buf = buffer[bufferPos++];
                                    mask = 128;
                                    while(i < loop2End){
                                        output[i++] = +!!(buf & mask);
                                        mask >>= 1;
                                    }
                                }
                            }
                        } else {
                            let bits = 0;
                            buf = 0;
                            for(i = 0, ii = length; i < ii; ++i){
                                if (i % rowComps === 0) {
                                    buf = 0;
                                    bits = 0;
                                }
                                while(bits < bpc){
                                    buf = buf << 8 | buffer[bufferPos++];
                                    bits += 8;
                                }
                                const remainingBits = bits - bpc;
                                let value = buf >> remainingBits;
                                if (value < 0) value = 0;
                                else if (value > max) value = max;
                                output[i] = value;
                                buf &= (1 << remainingBits) - 1;
                                bits = remainingBits;
                            }
                        }
                        return output;
                    }
                    fillOpacity(rgbaBuf, width, height, actualHeight, image) {
                        const smask = this.smask;
                        const mask = this.mask;
                        let alphaBuf, sw, sh, i, ii, j;
                        if (smask) {
                            sw = smask.width;
                            sh = smask.height;
                            alphaBuf = new Uint8ClampedArray(sw * sh);
                            smask.fillGrayBuffer(alphaBuf);
                            if (sw !== width || sh !== height) alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
                        } else if (mask) {
                            if (mask instanceof PDFImage) {
                                sw = mask.width;
                                sh = mask.height;
                                alphaBuf = new Uint8ClampedArray(sw * sh);
                                mask.numComps = 1;
                                mask.fillGrayBuffer(alphaBuf);
                                for(i = 0, ii = sw * sh; i < ii; ++i)alphaBuf[i] = 255 - alphaBuf[i];
                                if (sw !== width || sh !== height) alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
                            } else if (Array.isArray(mask)) {
                                alphaBuf = new Uint8ClampedArray(width * height);
                                const numComps = this.numComps;
                                for(i = 0, ii = width * height; i < ii; ++i){
                                    let opacity = 0;
                                    const imageOffset = i * numComps;
                                    for(j = 0; j < numComps; ++j){
                                        const color = image[imageOffset + j];
                                        const maskOffset = j * 2;
                                        if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
                                            opacity = 255;
                                            break;
                                        }
                                    }
                                    alphaBuf[i] = opacity;
                                }
                            } else throw new _util.FormatError("Unknown mask format.");
                        }
                        if (alphaBuf) for(i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4)rgbaBuf[j] = alphaBuf[i];
                        else for(i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4)rgbaBuf[j] = 255;
                    }
                    undoPreblend(buffer, width, height) {
                        const matte = this.smask?.matte;
                        if (!matte) return;
                        const matteRgb = this.colorSpace.getRgb(matte, 0);
                        const matteR = matteRgb[0];
                        const matteG = matteRgb[1];
                        const matteB = matteRgb[2];
                        const length = width * height * 4;
                        for(let i = 0; i < length; i += 4){
                            const alpha = buffer[i + 3];
                            if (alpha === 0) {
                                buffer[i] = 255;
                                buffer[i + 1] = 255;
                                buffer[i + 2] = 255;
                                continue;
                            }
                            const k = 255 / alpha;
                            buffer[i] = (buffer[i] - matteR) * k + matteR;
                            buffer[i + 1] = (buffer[i + 1] - matteG) * k + matteG;
                            buffer[i + 2] = (buffer[i + 2] - matteB) * k + matteB;
                        }
                    }
                    async createImageData(forceRGBA = false, isOffscreenCanvasSupported = false) {
                        const drawWidth = this.drawWidth;
                        const drawHeight = this.drawHeight;
                        const imgData = {
                            width: drawWidth,
                            height: drawHeight,
                            interpolate: this.interpolate,
                            kind: 0,
                            data: null
                        };
                        const numComps = this.numComps;
                        const originalWidth = this.width;
                        const originalHeight = this.height;
                        const bpc = this.bpc;
                        const rowBytes = originalWidth * numComps * bpc + 7 >> 3;
                        const mustBeResized = isOffscreenCanvasSupported && _image_resizer.ImageResizer.needsToBeResized(drawWidth, drawHeight);
                        if (!forceRGBA) {
                            let kind;
                            if (this.colorSpace.name === "DeviceGray" && bpc === 1) kind = _util.ImageKind.GRAYSCALE_1BPP;
                            else if (this.colorSpace.name === "DeviceRGB" && bpc === 8 && !this.needsDecode) kind = _util.ImageKind.RGB_24BPP;
                            if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
                                const data = this.getImageBytes(originalHeight * rowBytes, {});
                                if (isOffscreenCanvasSupported) {
                                    if (mustBeResized) return _image_resizer.ImageResizer.createImage({
                                        data: data,
                                        kind: kind,
                                        width: drawWidth,
                                        height: drawHeight,
                                        interpolate: this.interpolate
                                    }, this.needsDecode);
                                    return this.createBitmap(kind, originalWidth, originalHeight, data);
                                }
                                imgData.kind = kind;
                                imgData.data = data;
                                if (this.needsDecode) {
                                    (0, _util.assert)(kind === _util.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                                    const buffer = imgData.data;
                                    for(let i = 0, ii = buffer.length; i < ii; i++)buffer[i] ^= 0xff;
                                }
                                return imgData;
                            }
                            if (this.image instanceof _jpeg_stream.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                                let imageLength = originalHeight * rowBytes;
                                if (isOffscreenCanvasSupported && !mustBeResized) {
                                    let isHandled = false;
                                    switch(this.colorSpace.name){
                                        case "DeviceGray":
                                            imageLength *= 4;
                                            isHandled = true;
                                            break;
                                        case "DeviceRGB":
                                            imageLength = imageLength / 3 * 4;
                                            isHandled = true;
                                            break;
                                        case "DeviceCMYK":
                                            isHandled = true;
                                            break;
                                    }
                                    if (isHandled) {
                                        const rgba = this.getImageBytes(imageLength, {
                                            drawWidth: drawWidth,
                                            drawHeight: drawHeight,
                                            forceRGBA: true
                                        });
                                        return this.createBitmap(_util.ImageKind.RGBA_32BPP, drawWidth, drawHeight, rgba);
                                    }
                                } else switch(this.colorSpace.name){
                                    case "DeviceGray":
                                        imageLength *= 3;
                                    case "DeviceRGB":
                                    case "DeviceCMYK":
                                        imgData.kind = _util.ImageKind.RGB_24BPP;
                                        imgData.data = this.getImageBytes(imageLength, {
                                            drawWidth: drawWidth,
                                            drawHeight: drawHeight,
                                            forceRGB: true
                                        });
                                        if (mustBeResized) return _image_resizer.ImageResizer.createImage(imgData);
                                        return imgData;
                                }
                            }
                        }
                        const imgArray = this.getImageBytes(originalHeight * rowBytes, {
                            internal: true
                        });
                        const actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
                        const comps = this.getComponents(imgArray);
                        let alpha01, maybeUndoPreblend;
                        let canvas, ctx, canvasImgData, data;
                        if (isOffscreenCanvasSupported && !mustBeResized) {
                            canvas = new OffscreenCanvas(drawWidth, drawHeight);
                            ctx = canvas.getContext("2d");
                            canvasImgData = ctx.createImageData(drawWidth, drawHeight);
                            data = canvasImgData.data;
                        }
                        imgData.kind = _util.ImageKind.RGBA_32BPP;
                        if (!forceRGBA && !this.smask && !this.mask) {
                            if (!isOffscreenCanvasSupported || mustBeResized) {
                                imgData.kind = _util.ImageKind.RGB_24BPP;
                                data = new Uint8ClampedArray(drawWidth * drawHeight * 3);
                                alpha01 = 0;
                            } else {
                                const arr = new Uint32Array(data.buffer);
                                arr.fill(_util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff);
                                alpha01 = 1;
                            }
                            maybeUndoPreblend = false;
                        } else {
                            if (!isOffscreenCanvasSupported || mustBeResized) data = new Uint8ClampedArray(drawWidth * drawHeight * 4);
                            alpha01 = 1;
                            maybeUndoPreblend = true;
                            this.fillOpacity(data, drawWidth, drawHeight, actualHeight, comps);
                        }
                        if (this.needsDecode) this.decodeBuffer(comps);
                        this.colorSpace.fillRgb(data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
                        if (maybeUndoPreblend) this.undoPreblend(data, drawWidth, actualHeight);
                        if (isOffscreenCanvasSupported && !mustBeResized) {
                            ctx.putImageData(canvasImgData, 0, 0);
                            const bitmap = canvas.transferToImageBitmap();
                            return {
                                data: null,
                                width: drawWidth,
                                height: drawHeight,
                                bitmap: bitmap,
                                interpolate: this.interpolate
                            };
                        }
                        imgData.data = data;
                        if (mustBeResized) return _image_resizer.ImageResizer.createImage(imgData);
                        return imgData;
                    }
                    fillGrayBuffer(buffer) {
                        const numComps = this.numComps;
                        if (numComps !== 1) throw new _util.FormatError(`Reading gray scale from a color image: ${numComps}`);
                        const width = this.width;
                        const height = this.height;
                        const bpc = this.bpc;
                        const rowBytes = width * numComps * bpc + 7 >> 3;
                        const imgArray = this.getImageBytes(height * rowBytes, {
                            internal: true
                        });
                        const comps = this.getComponents(imgArray);
                        let i, length;
                        if (bpc === 1) {
                            length = width * height;
                            if (this.needsDecode) for(i = 0; i < length; ++i)buffer[i] = comps[i] - 1 & 255;
                            else for(i = 0; i < length; ++i)buffer[i] = -comps[i] & 255;
                            return;
                        }
                        if (this.needsDecode) this.decodeBuffer(comps);
                        length = width * height;
                        const scale = 255 / ((1 << bpc) - 1);
                        for(i = 0; i < length; ++i)buffer[i] = scale * comps[i];
                    }
                    createBitmap(kind, width, height, src) {
                        const canvas = new OffscreenCanvas(width, height);
                        const ctx = canvas.getContext("2d");
                        let imgData;
                        if (kind === _util.ImageKind.RGBA_32BPP) imgData = new ImageData(src, width, height);
                        else {
                            imgData = ctx.createImageData(width, height);
                            (0, _image_utils.convertToRGBA)({
                                kind: kind,
                                src: src,
                                dest: new Uint32Array(imgData.data.buffer),
                                width: width,
                                height: height,
                                inverseDecode: this.needsDecode
                            });
                        }
                        ctx.putImageData(imgData, 0, 0);
                        const bitmap = canvas.transferToImageBitmap();
                        return {
                            data: null,
                            width: width,
                            height: height,
                            bitmap: bitmap,
                            interpolate: this.interpolate
                        };
                    }
                    getImageBytes(length, { drawWidth: drawWidth, drawHeight: drawHeight, forceRGBA: forceRGBA = false, forceRGB: forceRGB = false, internal: internal = false }) {
                        this.image.reset();
                        this.image.drawWidth = drawWidth || this.width;
                        this.image.drawHeight = drawHeight || this.height;
                        this.image.forceRGBA = !!forceRGBA;
                        this.image.forceRGB = !!forceRGB;
                        const imageBytes = this.image.getBytes(length);
                        if (internal || this.image instanceof _decode_stream.DecodeStream) return imageBytes;
                        (0, _util.assert)(imageBytes instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.');
                        return new Uint8Array(imageBytes);
                    }
                }
                exports.PDFImage = PDFImage;
            /***/ },
            /* 66 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Catalog = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _name_number_tree = __w_pdfjs_require__(67);
                var _base_stream = __w_pdfjs_require__(5);
                var _cleanup_helper = __w_pdfjs_require__(68);
                var _colorspace = __w_pdfjs_require__(12);
                var _file_spec = __w_pdfjs_require__(69);
                var _image_utils = __w_pdfjs_require__(59);
                var _metadata_parser = __w_pdfjs_require__(70);
                var _struct_tree = __w_pdfjs_require__(72);
                function fetchDestination(dest) {
                    if (dest instanceof _primitives.Dict) dest = dest.get("D");
                    return Array.isArray(dest) ? dest : null;
                }
                class Catalog {
                    constructor(pdfManager, xref){
                        this.pdfManager = pdfManager;
                        this.xref = xref;
                        this._catDict = xref.getCatalogObj();
                        if (!(this._catDict instanceof _primitives.Dict)) throw new _util.FormatError("Catalog object is not a dictionary.");
                        this.toplevelPagesDict;
                        this._actualNumPages = null;
                        this.fontCache = new _primitives.RefSetCache();
                        this.builtInCMapCache = new Map();
                        this.standardFontDataCache = new Map();
                        this.globalImageCache = new _image_utils.GlobalImageCache();
                        this.pageKidsCountCache = new _primitives.RefSetCache();
                        this.pageIndexCache = new _primitives.RefSetCache();
                        this.nonBlendModesSet = new _primitives.RefSet();
                        this.systemFontCache = new Map();
                    }
                    cloneDict() {
                        return this._catDict.clone();
                    }
                    get version() {
                        const version = this._catDict.get("Version");
                        if (version instanceof _primitives.Name) {
                            if (_core_utils.PDF_VERSION_REGEXP.test(version.name)) return (0, _util.shadow)(this, "version", version.name);
                            (0, _util.warn)(`Invalid PDF catalog version: ${version.name}`);
                        }
                        return (0, _util.shadow)(this, "version", null);
                    }
                    get lang() {
                        const lang = this._catDict.get("Lang");
                        return (0, _util.shadow)(this, "lang", typeof lang === "string" ? (0, _util.stringToPDFString)(lang) : null);
                    }
                    get needsRendering() {
                        const needsRendering = this._catDict.get("NeedsRendering");
                        return (0, _util.shadow)(this, "needsRendering", typeof needsRendering === "boolean" ? needsRendering : false);
                    }
                    get collection() {
                        let collection = null;
                        try {
                            const obj = this._catDict.get("Collection");
                            if (obj instanceof _primitives.Dict && obj.size > 0) collection = obj;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)("Cannot fetch Collection entry; assuming no collection is present.");
                        }
                        return (0, _util.shadow)(this, "collection", collection);
                    }
                    get acroForm() {
                        let acroForm = null;
                        try {
                            const obj = this._catDict.get("AcroForm");
                            if (obj instanceof _primitives.Dict && obj.size > 0) acroForm = obj;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
                        }
                        return (0, _util.shadow)(this, "acroForm", acroForm);
                    }
                    get acroFormRef() {
                        const value = this._catDict.getRaw("AcroForm");
                        return (0, _util.shadow)(this, "acroFormRef", value instanceof _primitives.Ref ? value : null);
                    }
                    get metadata() {
                        const streamRef = this._catDict.getRaw("Metadata");
                        if (!(streamRef instanceof _primitives.Ref)) return (0, _util.shadow)(this, "metadata", null);
                        let metadata = null;
                        try {
                            const stream = this.xref.fetch(streamRef, !this.xref.encrypt?.encryptMetadata);
                            if (stream instanceof _base_stream.BaseStream && stream.dict instanceof _primitives.Dict) {
                                const type = stream.dict.get("Type");
                                const subtype = stream.dict.get("Subtype");
                                if ((0, _primitives.isName)(type, "Metadata") && (0, _primitives.isName)(subtype, "XML")) {
                                    const data = (0, _util.stringToUTF8String)(stream.getString());
                                    if (data) metadata = new _metadata_parser.MetadataParser(data).serializable;
                                }
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)(`Skipping invalid Metadata: "${ex}".`);
                        }
                        return (0, _util.shadow)(this, "metadata", metadata);
                    }
                    get markInfo() {
                        let markInfo = null;
                        try {
                            markInfo = this._readMarkInfo();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read mark info.");
                        }
                        return (0, _util.shadow)(this, "markInfo", markInfo);
                    }
                    _readMarkInfo() {
                        const obj = this._catDict.get("MarkInfo");
                        if (!(obj instanceof _primitives.Dict)) return null;
                        const markInfo = {
                            Marked: false,
                            UserProperties: false,
                            Suspects: false
                        };
                        for(const key in markInfo){
                            const value = obj.get(key);
                            if (typeof value === "boolean") markInfo[key] = value;
                        }
                        return markInfo;
                    }
                    get structTreeRoot() {
                        let structTree = null;
                        try {
                            structTree = this._readStructTreeRoot();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable read to structTreeRoot info.");
                        }
                        return (0, _util.shadow)(this, "structTreeRoot", structTree);
                    }
                    _readStructTreeRoot() {
                        const rawObj = this._catDict.getRaw("StructTreeRoot");
                        const obj = this.xref.fetchIfRef(rawObj);
                        if (!(obj instanceof _primitives.Dict)) return null;
                        const root = new _struct_tree.StructTreeRoot(obj, rawObj);
                        root.init();
                        return root;
                    }
                    get toplevelPagesDict() {
                        const pagesObj = this._catDict.get("Pages");
                        if (!(pagesObj instanceof _primitives.Dict)) throw new _util.FormatError("Invalid top-level pages dictionary.");
                        return (0, _util.shadow)(this, "toplevelPagesDict", pagesObj);
                    }
                    get documentOutline() {
                        let obj = null;
                        try {
                            obj = this._readDocumentOutline();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read document outline.");
                        }
                        return (0, _util.shadow)(this, "documentOutline", obj);
                    }
                    _readDocumentOutline() {
                        let obj = this._catDict.get("Outlines");
                        if (!(obj instanceof _primitives.Dict)) return null;
                        obj = obj.getRaw("First");
                        if (!(obj instanceof _primitives.Ref)) return null;
                        const root = {
                            items: []
                        };
                        const queue = [
                            {
                                obj: obj,
                                parent: root
                            }
                        ];
                        const processed = new _primitives.RefSet();
                        processed.put(obj);
                        const xref = this.xref, blackColor = new Uint8ClampedArray(3);
                        while(queue.length > 0){
                            const i = queue.shift();
                            const outlineDict = xref.fetchIfRef(i.obj);
                            if (outlineDict === null) continue;
                            if (!outlineDict.has("Title")) throw new _util.FormatError("Invalid outline item encountered.");
                            const data = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: outlineDict,
                                resultObj: data,
                                docBaseUrl: this.baseUrl,
                                docAttachments: this.attachments
                            });
                            const title = outlineDict.get("Title");
                            const flags = outlineDict.get("F") || 0;
                            const color = outlineDict.getArray("C");
                            const count = outlineDict.get("Count");
                            let rgbColor = blackColor;
                            if (Array.isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
                            const outlineItem = {
                                action: data.action,
                                attachment: data.attachment,
                                dest: data.dest,
                                url: data.url,
                                unsafeUrl: data.unsafeUrl,
                                newWindow: data.newWindow,
                                setOCGState: data.setOCGState,
                                title: (0, _util.stringToPDFString)(title),
                                color: rgbColor,
                                count: Number.isInteger(count) ? count : undefined,
                                bold: !!(flags & 2),
                                italic: !!(flags & 1),
                                items: []
                            };
                            i.parent.items.push(outlineItem);
                            obj = outlineDict.getRaw("First");
                            if (obj instanceof _primitives.Ref && !processed.has(obj)) {
                                queue.push({
                                    obj: obj,
                                    parent: outlineItem
                                });
                                processed.put(obj);
                            }
                            obj = outlineDict.getRaw("Next");
                            if (obj instanceof _primitives.Ref && !processed.has(obj)) {
                                queue.push({
                                    obj: obj,
                                    parent: i.parent
                                });
                                processed.put(obj);
                            }
                        }
                        return root.items.length > 0 ? root.items : null;
                    }
                    get permissions() {
                        let permissions = null;
                        try {
                            permissions = this._readPermissions();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read permissions.");
                        }
                        return (0, _util.shadow)(this, "permissions", permissions);
                    }
                    _readPermissions() {
                        const encrypt = this.xref.trailer.get("Encrypt");
                        if (!(encrypt instanceof _primitives.Dict)) return null;
                        let flags = encrypt.get("P");
                        if (typeof flags !== "number") return null;
                        flags += 2 ** 32;
                        const permissions = [];
                        for(const key in _util.PermissionFlag){
                            const value = _util.PermissionFlag[key];
                            if (flags & value) permissions.push(value);
                        }
                        return permissions;
                    }
                    get optionalContentConfig() {
                        let config = null;
                        try {
                            const properties = this._catDict.get("OCProperties");
                            if (!properties) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const defaultConfig = properties.get("D");
                            if (!defaultConfig) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const groupsData = properties.get("OCGs");
                            if (!Array.isArray(groupsData)) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const groups = [];
                            const groupRefs = [];
                            for (const groupRef of groupsData){
                                if (!(groupRef instanceof _primitives.Ref)) continue;
                                groupRefs.push(groupRef);
                                const group = this.xref.fetchIfRef(groupRef);
                                groups.push({
                                    id: groupRef.toString(),
                                    name: typeof group.get("Name") === "string" ? (0, _util.stringToPDFString)(group.get("Name")) : null,
                                    intent: typeof group.get("Intent") === "string" ? (0, _util.stringToPDFString)(group.get("Intent")) : null
                                });
                            }
                            config = this._readOptionalContentConfig(defaultConfig, groupRefs);
                            config.groups = groups;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Unable to read optional content config: ${ex}`);
                        }
                        return (0, _util.shadow)(this, "optionalContentConfig", config);
                    }
                    _readOptionalContentConfig(config, contentGroupRefs) {
                        function parseOnOff(refs) {
                            const onParsed = [];
                            if (Array.isArray(refs)) for (const value of refs){
                                if (!(value instanceof _primitives.Ref)) continue;
                                if (contentGroupRefs.includes(value)) onParsed.push(value.toString());
                            }
                            return onParsed;
                        }
                        function parseOrder(refs, nestedLevels = 0) {
                            if (!Array.isArray(refs)) return null;
                            const order = [];
                            for (const value of refs){
                                if (value instanceof _primitives.Ref && contentGroupRefs.includes(value)) {
                                    parsedOrderRefs.put(value);
                                    order.push(value.toString());
                                    continue;
                                }
                                const nestedOrder = parseNestedOrder(value, nestedLevels);
                                if (nestedOrder) order.push(nestedOrder);
                            }
                            if (nestedLevels > 0) return order;
                            const hiddenGroups = [];
                            for (const groupRef of contentGroupRefs){
                                if (parsedOrderRefs.has(groupRef)) continue;
                                hiddenGroups.push(groupRef.toString());
                            }
                            if (hiddenGroups.length) order.push({
                                name: null,
                                order: hiddenGroups
                            });
                            return order;
                        }
                        function parseNestedOrder(ref, nestedLevels) {
                            if (++nestedLevels > MAX_NESTED_LEVELS) {
                                (0, _util.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS.");
                                return null;
                            }
                            const value = xref.fetchIfRef(ref);
                            if (!Array.isArray(value)) return null;
                            const nestedName = xref.fetchIfRef(value[0]);
                            if (typeof nestedName !== "string") return null;
                            const nestedOrder = parseOrder(value.slice(1), nestedLevels);
                            if (!nestedOrder || !nestedOrder.length) return null;
                            return {
                                name: (0, _util.stringToPDFString)(nestedName),
                                order: nestedOrder
                            };
                        }
                        const xref = this.xref, parsedOrderRefs = new _primitives.RefSet(), MAX_NESTED_LEVELS = 10;
                        return {
                            name: typeof config.get("Name") === "string" ? (0, _util.stringToPDFString)(config.get("Name")) : null,
                            creator: typeof config.get("Creator") === "string" ? (0, _util.stringToPDFString)(config.get("Creator")) : null,
                            baseState: config.get("BaseState") instanceof _primitives.Name ? config.get("BaseState").name : null,
                            on: parseOnOff(config.get("ON")),
                            off: parseOnOff(config.get("OFF")),
                            order: parseOrder(config.get("Order")),
                            groups: null
                        };
                    }
                    setActualNumPages(num = null) {
                        this._actualNumPages = num;
                    }
                    get hasActualNumPages() {
                        return this._actualNumPages !== null;
                    }
                    get _pagesCount() {
                        const obj = this.toplevelPagesDict.get("Count");
                        if (!Number.isInteger(obj)) throw new _util.FormatError("Page count in top-level pages dictionary is not an integer.");
                        return (0, _util.shadow)(this, "_pagesCount", obj);
                    }
                    get numPages() {
                        return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
                    }
                    get destinations() {
                        const obj = this._readDests(), dests = Object.create(null);
                        if (obj instanceof _name_number_tree.NameTree) for (const [key, value] of obj.getAll()){
                            const dest = fetchDestination(value);
                            if (dest) dests[(0, _util.stringToPDFString)(key)] = dest;
                        }
                        else if (obj instanceof _primitives.Dict) obj.forEach(function(key, value) {
                            const dest = fetchDestination(value);
                            if (dest) dests[key] = dest;
                        });
                        return (0, _util.shadow)(this, "destinations", dests);
                    }
                    getDestination(id) {
                        const obj = this._readDests();
                        if (obj instanceof _name_number_tree.NameTree) {
                            const dest = fetchDestination(obj.get(id));
                            if (dest) return dest;
                            const allDest = this.destinations[id];
                            if (allDest) {
                                (0, _util.warn)(`Found "${id}" at an incorrect position in the NameTree.`);
                                return allDest;
                            }
                        } else if (obj instanceof _primitives.Dict) {
                            const dest = fetchDestination(obj.get(id));
                            if (dest) return dest;
                        }
                        return null;
                    }
                    _readDests() {
                        const obj = this._catDict.get("Names");
                        if (obj?.has("Dests")) return new _name_number_tree.NameTree(obj.getRaw("Dests"), this.xref);
                        else if (this._catDict.has("Dests")) return this._catDict.get("Dests");
                        return undefined;
                    }
                    get pageLabels() {
                        let obj = null;
                        try {
                            obj = this._readPageLabels();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read page labels.");
                        }
                        return (0, _util.shadow)(this, "pageLabels", obj);
                    }
                    _readPageLabels() {
                        const obj = this._catDict.getRaw("PageLabels");
                        if (!obj) return null;
                        const pageLabels = new Array(this.numPages);
                        let style = null, prefix = "";
                        const numberTree = new _name_number_tree.NumberTree(obj, this.xref);
                        const nums = numberTree.getAll();
                        let currentLabel = "", currentIndex = 1;
                        for(let i = 0, ii = this.numPages; i < ii; i++){
                            const labelDict = nums.get(i);
                            if (labelDict !== undefined) {
                                if (!(labelDict instanceof _primitives.Dict)) throw new _util.FormatError("PageLabel is not a dictionary.");
                                if (labelDict.has("Type") && !(0, _primitives.isName)(labelDict.get("Type"), "PageLabel")) throw new _util.FormatError("Invalid type in PageLabel dictionary.");
                                if (labelDict.has("S")) {
                                    const s = labelDict.get("S");
                                    if (!(s instanceof _primitives.Name)) throw new _util.FormatError("Invalid style in PageLabel dictionary.");
                                    style = s.name;
                                } else style = null;
                                if (labelDict.has("P")) {
                                    const p = labelDict.get("P");
                                    if (typeof p !== "string") throw new _util.FormatError("Invalid prefix in PageLabel dictionary.");
                                    prefix = (0, _util.stringToPDFString)(p);
                                } else prefix = "";
                                if (labelDict.has("St")) {
                                    const st = labelDict.get("St");
                                    if (!(Number.isInteger(st) && st >= 1)) throw new _util.FormatError("Invalid start in PageLabel dictionary.");
                                    currentIndex = st;
                                } else currentIndex = 1;
                            }
                            switch(style){
                                case "D":
                                    currentLabel = currentIndex;
                                    break;
                                case "R":
                                case "r":
                                    currentLabel = (0, _core_utils.toRomanNumerals)(currentIndex, style === "r");
                                    break;
                                case "A":
                                case "a":
                                    const LIMIT = 26;
                                    const A_UPPER_CASE = 0x41, A_LOWER_CASE = 0x61;
                                    const baseCharCode = style === "a" ? A_LOWER_CASE : A_UPPER_CASE;
                                    const letterIndex = currentIndex - 1;
                                    const character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
                                    currentLabel = character.repeat(Math.floor(letterIndex / LIMIT) + 1);
                                    break;
                                default:
                                    if (style) throw new _util.FormatError(`Invalid style "${style}" in PageLabel dictionary.`);
                                    currentLabel = "";
                            }
                            pageLabels[i] = prefix + currentLabel;
                            currentIndex++;
                        }
                        return pageLabels;
                    }
                    get pageLayout() {
                        const obj = this._catDict.get("PageLayout");
                        let pageLayout = "";
                        if (obj instanceof _primitives.Name) switch(obj.name){
                            case "SinglePage":
                            case "OneColumn":
                            case "TwoColumnLeft":
                            case "TwoColumnRight":
                            case "TwoPageLeft":
                            case "TwoPageRight":
                                pageLayout = obj.name;
                        }
                        return (0, _util.shadow)(this, "pageLayout", pageLayout);
                    }
                    get pageMode() {
                        const obj = this._catDict.get("PageMode");
                        let pageMode = "UseNone";
                        if (obj instanceof _primitives.Name) switch(obj.name){
                            case "UseNone":
                            case "UseOutlines":
                            case "UseThumbs":
                            case "FullScreen":
                            case "UseOC":
                            case "UseAttachments":
                                pageMode = obj.name;
                        }
                        return (0, _util.shadow)(this, "pageMode", pageMode);
                    }
                    get viewerPreferences() {
                        const obj = this._catDict.get("ViewerPreferences");
                        if (!(obj instanceof _primitives.Dict)) return (0, _util.shadow)(this, "viewerPreferences", null);
                        let prefs = null;
                        for (const key of obj.getKeys()){
                            const value = obj.get(key);
                            let prefValue;
                            switch(key){
                                case "HideToolbar":
                                case "HideMenubar":
                                case "HideWindowUI":
                                case "FitWindow":
                                case "CenterWindow":
                                case "DisplayDocTitle":
                                case "PickTrayByPDFSize":
                                    if (typeof value === "boolean") prefValue = value;
                                    break;
                                case "NonFullScreenPageMode":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "UseNone":
                                        case "UseOutlines":
                                        case "UseThumbs":
                                        case "UseOC":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "UseNone";
                                    }
                                    break;
                                case "Direction":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "L2R":
                                        case "R2L":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "L2R";
                                    }
                                    break;
                                case "ViewArea":
                                case "ViewClip":
                                case "PrintArea":
                                case "PrintClip":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "MediaBox":
                                        case "CropBox":
                                        case "BleedBox":
                                        case "TrimBox":
                                        case "ArtBox":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "CropBox";
                                    }
                                    break;
                                case "PrintScaling":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "None":
                                        case "AppDefault":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "AppDefault";
                                    }
                                    break;
                                case "Duplex":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "Simplex":
                                        case "DuplexFlipShortEdge":
                                        case "DuplexFlipLongEdge":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "None";
                                    }
                                    break;
                                case "PrintPageRange":
                                    if (Array.isArray(value) && value.length % 2 === 0) {
                                        const isValid = value.every((page, i, arr)=>{
                                            return Number.isInteger(page) && page > 0 && (i === 0 || page >= arr[i - 1]) && page <= this.numPages;
                                        });
                                        if (isValid) prefValue = value;
                                    }
                                    break;
                                case "NumCopies":
                                    if (Number.isInteger(value) && value > 0) prefValue = value;
                                    break;
                                default:
                                    (0, _util.warn)(`Ignoring non-standard key in ViewerPreferences: ${key}.`);
                                    continue;
                            }
                            if (prefValue === undefined) {
                                (0, _util.warn)(`Bad value, for key "${key}", in ViewerPreferences: ${value}.`);
                                continue;
                            }
                            if (!prefs) prefs = Object.create(null);
                            prefs[key] = prefValue;
                        }
                        return (0, _util.shadow)(this, "viewerPreferences", prefs);
                    }
                    get openAction() {
                        const obj = this._catDict.get("OpenAction");
                        const openAction = Object.create(null);
                        if (obj instanceof _primitives.Dict) {
                            const destDict = new _primitives.Dict(this.xref);
                            destDict.set("A", obj);
                            const resultObj = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: destDict,
                                resultObj: resultObj
                            });
                            if (Array.isArray(resultObj.dest)) openAction.dest = resultObj.dest;
                            else if (resultObj.action) openAction.action = resultObj.action;
                        } else if (Array.isArray(obj)) openAction.dest = obj;
                        return (0, _util.shadow)(this, "openAction", (0, _util.objectSize)(openAction) > 0 ? openAction : null);
                    }
                    get attachments() {
                        const obj = this._catDict.get("Names");
                        let attachments = null;
                        if (obj instanceof _primitives.Dict && obj.has("EmbeddedFiles")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("EmbeddedFiles"), this.xref);
                            for (const [key, value] of nameTree.getAll()){
                                const fs = new _file_spec.FileSpec(value, this.xref);
                                if (!attachments) attachments = Object.create(null);
                                attachments[(0, _util.stringToPDFString)(key)] = fs.serializable;
                            }
                        }
                        return (0, _util.shadow)(this, "attachments", attachments);
                    }
                    get xfaImages() {
                        const obj = this._catDict.get("Names");
                        let xfaImages = null;
                        if (obj instanceof _primitives.Dict && obj.has("XFAImages")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("XFAImages"), this.xref);
                            for (const [key, value] of nameTree.getAll()){
                                if (!xfaImages) xfaImages = new _primitives.Dict(this.xref);
                                xfaImages.set((0, _util.stringToPDFString)(key), value);
                            }
                        }
                        return (0, _util.shadow)(this, "xfaImages", xfaImages);
                    }
                    _collectJavaScript() {
                        const obj = this._catDict.get("Names");
                        let javaScript = null;
                        function appendIfJavaScriptDict(name, jsDict) {
                            if (!(jsDict instanceof _primitives.Dict)) return;
                            if (!(0, _primitives.isName)(jsDict.get("S"), "JavaScript")) return;
                            let js = jsDict.get("JS");
                            if (js instanceof _base_stream.BaseStream) js = js.getString();
                            else if (typeof js !== "string") return;
                            js = (0, _util.stringToPDFString)(js).replaceAll("\x00", "");
                            if (js) (javaScript ||= new Map()).set(name, js);
                        }
                        if (obj instanceof _primitives.Dict && obj.has("JavaScript")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("JavaScript"), this.xref);
                            for (const [key, value] of nameTree.getAll())appendIfJavaScriptDict((0, _util.stringToPDFString)(key), value);
                        }
                        const openAction = this._catDict.get("OpenAction");
                        if (openAction) appendIfJavaScriptDict("OpenAction", openAction);
                        return javaScript;
                    }
                    get jsActions() {
                        const javaScript = this._collectJavaScript();
                        let actions = (0, _core_utils.collectActions)(this.xref, this._catDict, _util.DocumentActionEventType);
                        if (javaScript) {
                            actions ||= Object.create(null);
                            for (const [key, val] of javaScript)if (key in actions) actions[key].push(val);
                            else actions[key] = [
                                val
                            ];
                        }
                        return (0, _util.shadow)(this, "jsActions", actions);
                    }
                    async fontFallback(id, handler) {
                        const translatedFonts = await Promise.all(this.fontCache);
                        for (const translatedFont of translatedFonts)if (translatedFont.loadedName === id) {
                            translatedFont.fallback(handler);
                            return;
                        }
                    }
                    async cleanup(manuallyTriggered = false) {
                        (0, _cleanup_helper.clearGlobalCaches)();
                        this.globalImageCache.clear(manuallyTriggered);
                        this.pageKidsCountCache.clear();
                        this.pageIndexCache.clear();
                        this.nonBlendModesSet.clear();
                        const translatedFonts = await Promise.all(this.fontCache);
                        for (const { dict: dict } of translatedFonts)delete dict.cacheKey;
                        this.fontCache.clear();
                        this.builtInCMapCache.clear();
                        this.standardFontDataCache.clear();
                        this.systemFontCache.clear();
                    }
                    async getPageDict(pageIndex) {
                        const nodesToVisit = [
                            this.toplevelPagesDict
                        ];
                        const visitedNodes = new _primitives.RefSet();
                        const pagesRef = this._catDict.getRaw("Pages");
                        if (pagesRef instanceof _primitives.Ref) visitedNodes.put(pagesRef);
                        const xref = this.xref, pageKidsCountCache = this.pageKidsCountCache, pageIndexCache = this.pageIndexCache;
                        let currentPageIndex = 0;
                        while(nodesToVisit.length){
                            const currentNode = nodesToVisit.pop();
                            if (currentNode instanceof _primitives.Ref) {
                                const count = pageKidsCountCache.get(currentNode);
                                if (count >= 0 && currentPageIndex + count <= pageIndex) {
                                    currentPageIndex += count;
                                    continue;
                                }
                                if (visitedNodes.has(currentNode)) throw new _util.FormatError("Pages tree contains circular reference.");
                                visitedNodes.put(currentNode);
                                const obj = await xref.fetchAsync(currentNode);
                                if (obj instanceof _primitives.Dict) {
                                    let type = obj.getRaw("Type");
                                    if (type instanceof _primitives.Ref) type = await xref.fetchAsync(type);
                                    if ((0, _primitives.isName)(type, "Page") || !obj.has("Kids")) {
                                        if (!pageKidsCountCache.has(currentNode)) pageKidsCountCache.put(currentNode, 1);
                                        if (!pageIndexCache.has(currentNode)) pageIndexCache.put(currentNode, currentPageIndex);
                                        if (currentPageIndex === pageIndex) return [
                                            obj,
                                            currentNode
                                        ];
                                        currentPageIndex++;
                                        continue;
                                    }
                                }
                                nodesToVisit.push(obj);
                                continue;
                            }
                            if (!(currentNode instanceof _primitives.Dict)) throw new _util.FormatError("Page dictionary kid reference points to wrong type of object.");
                            const { objId: objId } = currentNode;
                            let count = currentNode.getRaw("Count");
                            if (count instanceof _primitives.Ref) count = await xref.fetchAsync(count);
                            if (Number.isInteger(count) && count >= 0) {
                                if (objId && !pageKidsCountCache.has(objId)) pageKidsCountCache.put(objId, count);
                                if (currentPageIndex + count <= pageIndex) {
                                    currentPageIndex += count;
                                    continue;
                                }
                            }
                            let kids = currentNode.getRaw("Kids");
                            if (kids instanceof _primitives.Ref) kids = await xref.fetchAsync(kids);
                            if (!Array.isArray(kids)) {
                                let type = currentNode.getRaw("Type");
                                if (type instanceof _primitives.Ref) type = await xref.fetchAsync(type);
                                if ((0, _primitives.isName)(type, "Page") || !currentNode.has("Kids")) {
                                    if (currentPageIndex === pageIndex) return [
                                        currentNode,
                                        null
                                    ];
                                    currentPageIndex++;
                                    continue;
                                }
                                throw new _util.FormatError("Page dictionary kids object is not an array.");
                            }
                            for(let last = kids.length - 1; last >= 0; last--)nodesToVisit.push(kids[last]);
                        }
                        throw new Error(`Page index ${pageIndex} not found.`);
                    }
                    async getAllPageDicts(recoveryMode = false) {
                        const { ignoreErrors: ignoreErrors } = this.pdfManager.evaluatorOptions;
                        const queue = [
                            {
                                currentNode: this.toplevelPagesDict,
                                posInKids: 0
                            }
                        ];
                        const visitedNodes = new _primitives.RefSet();
                        const pagesRef = this._catDict.getRaw("Pages");
                        if (pagesRef instanceof _primitives.Ref) visitedNodes.put(pagesRef);
                        const map = new Map(), xref = this.xref, pageIndexCache = this.pageIndexCache;
                        let pageIndex = 0;
                        function addPageDict(pageDict, pageRef) {
                            if (pageRef && !pageIndexCache.has(pageRef)) pageIndexCache.put(pageRef, pageIndex);
                            map.set(pageIndex++, [
                                pageDict,
                                pageRef
                            ]);
                        }
                        function addPageError(error) {
                            if (error instanceof _core_utils.XRefEntryException && !recoveryMode) throw error;
                            if (recoveryMode && ignoreErrors && pageIndex === 0) {
                                (0, _util.warn)(`getAllPageDicts - Skipping invalid first page: "${error}".`);
                                error = _primitives.Dict.empty;
                            }
                            map.set(pageIndex++, [
                                error,
                                null
                            ]);
                        }
                        while(queue.length > 0){
                            const queueItem = queue.at(-1);
                            const { currentNode: currentNode, posInKids: posInKids } = queueItem;
                            let kids = currentNode.getRaw("Kids");
                            if (kids instanceof _primitives.Ref) try {
                                kids = await xref.fetchAsync(kids);
                            } catch (ex) {
                                addPageError(ex);
                                break;
                            }
                            if (!Array.isArray(kids)) {
                                addPageError(new _util.FormatError("Page dictionary kids object is not an array."));
                                break;
                            }
                            if (posInKids >= kids.length) {
                                queue.pop();
                                continue;
                            }
                            const kidObj = kids[posInKids];
                            let obj;
                            if (kidObj instanceof _primitives.Ref) {
                                if (visitedNodes.has(kidObj)) {
                                    addPageError(new _util.FormatError("Pages tree contains circular reference."));
                                    break;
                                }
                                visitedNodes.put(kidObj);
                                try {
                                    obj = await xref.fetchAsync(kidObj);
                                } catch (ex) {
                                    addPageError(ex);
                                    break;
                                }
                            } else obj = kidObj;
                            if (!(obj instanceof _primitives.Dict)) {
                                addPageError(new _util.FormatError("Page dictionary kid reference points to wrong type of object."));
                                break;
                            }
                            let type = obj.getRaw("Type");
                            if (type instanceof _primitives.Ref) try {
                                type = await xref.fetchAsync(type);
                            } catch (ex) {
                                addPageError(ex);
                                break;
                            }
                            if ((0, _primitives.isName)(type, "Page") || !obj.has("Kids")) addPageDict(obj, kidObj instanceof _primitives.Ref ? kidObj : null);
                            else queue.push({
                                currentNode: obj,
                                posInKids: 0
                            });
                            queueItem.posInKids++;
                        }
                        return map;
                    }
                    getPageIndex(pageRef) {
                        const cachedPageIndex = this.pageIndexCache.get(pageRef);
                        if (cachedPageIndex !== undefined) return Promise.resolve(cachedPageIndex);
                        const xref = this.xref;
                        function pagesBeforeRef(kidRef) {
                            let total = 0, parentRef;
                            return xref.fetchAsync(kidRef).then(function(node) {
                                if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node, "Page") && !(node instanceof _primitives.Dict && !node.has("Type") && node.has("Contents"))) throw new _util.FormatError("The reference does not point to a /Page dictionary.");
                                if (!node) return null;
                                if (!(node instanceof _primitives.Dict)) throw new _util.FormatError("Node must be a dictionary.");
                                parentRef = node.getRaw("Parent");
                                return node.getAsync("Parent");
                            }).then(function(parent) {
                                if (!parent) return null;
                                if (!(parent instanceof _primitives.Dict)) throw new _util.FormatError("Parent must be a dictionary.");
                                return parent.getAsync("Kids");
                            }).then(function(kids) {
                                if (!kids) return null;
                                const kidPromises = [];
                                let found = false;
                                for (const kid of kids){
                                    if (!(kid instanceof _primitives.Ref)) throw new _util.FormatError("Kid must be a reference.");
                                    if ((0, _primitives.isRefsEqual)(kid, kidRef)) {
                                        found = true;
                                        break;
                                    }
                                    kidPromises.push(xref.fetchAsync(kid).then(function(obj) {
                                        if (!(obj instanceof _primitives.Dict)) throw new _util.FormatError("Kid node must be a dictionary.");
                                        if (obj.has("Count")) total += obj.get("Count");
                                        else total++;
                                    }));
                                }
                                if (!found) throw new _util.FormatError("Kid reference not found in parent's kids.");
                                return Promise.all(kidPromises).then(function() {
                                    return [
                                        total,
                                        parentRef
                                    ];
                                });
                            });
                        }
                        let total = 0;
                        const next = (ref)=>pagesBeforeRef(ref).then((args)=>{
                                if (!args) {
                                    this.pageIndexCache.put(pageRef, total);
                                    return total;
                                }
                                const [count, parentRef] = args;
                                total += count;
                                return next(parentRef);
                            });
                        return next(pageRef);
                    }
                    get baseUrl() {
                        const uri = this._catDict.get("URI");
                        if (uri instanceof _primitives.Dict) {
                            const base = uri.get("Base");
                            if (typeof base === "string") {
                                const absoluteUrl = (0, _util.createValidAbsoluteUrl)(base, null, {
                                    tryConvertEncoding: true
                                });
                                if (absoluteUrl) return (0, _util.shadow)(this, "baseUrl", absoluteUrl.href);
                            }
                        }
                        return (0, _util.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
                    }
                    static parseDestDictionary({ destDict: destDict, resultObj: resultObj, docBaseUrl: docBaseUrl = null, docAttachments: docAttachments = null }) {
                        if (!(destDict instanceof _primitives.Dict)) {
                            (0, _util.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                            return;
                        }
                        let action = destDict.get("A"), url, dest;
                        if (!(action instanceof _primitives.Dict)) {
                            if (destDict.has("Dest")) action = destDict.get("Dest");
                            else {
                                action = destDict.get("AA");
                                if (action instanceof _primitives.Dict) {
                                    if (action.has("D")) action = action.get("D");
                                    else if (action.has("U")) action = action.get("U");
                                }
                            }
                        }
                        if (action instanceof _primitives.Dict) {
                            const actionType = action.get("S");
                            if (!(actionType instanceof _primitives.Name)) {
                                (0, _util.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                                return;
                            }
                            const actionName = actionType.name;
                            switch(actionName){
                                case "ResetForm":
                                    const flags = action.get("Flags");
                                    const include = ((typeof flags === "number" ? flags : 0) & 1) === 0;
                                    const fields = [];
                                    const refs = [];
                                    for (const obj of action.get("Fields") || []){
                                        if (obj instanceof _primitives.Ref) refs.push(obj.toString());
                                        else if (typeof obj === "string") fields.push((0, _util.stringToPDFString)(obj));
                                    }
                                    resultObj.resetForm = {
                                        fields: fields,
                                        refs: refs,
                                        include: include
                                    };
                                    break;
                                case "URI":
                                    url = action.get("URI");
                                    if (url instanceof _primitives.Name) url = "/" + url.name;
                                    break;
                                case "GoTo":
                                    dest = action.get("D");
                                    break;
                                case "Launch":
                                case "GoToR":
                                    const urlDict = action.get("F");
                                    if (urlDict instanceof _primitives.Dict) url = urlDict.get("F") || null;
                                    else if (typeof urlDict === "string") url = urlDict;
                                    let remoteDest = action.get("D");
                                    if (remoteDest) {
                                        if (remoteDest instanceof _primitives.Name) remoteDest = remoteDest.name;
                                        if (typeof url === "string") {
                                            const baseUrl = url.split("#")[0];
                                            if (typeof remoteDest === "string") url = baseUrl + "#" + remoteDest;
                                            else if (Array.isArray(remoteDest)) url = baseUrl + "#" + JSON.stringify(remoteDest);
                                        }
                                    }
                                    const newWindow = action.get("NewWindow");
                                    if (typeof newWindow === "boolean") resultObj.newWindow = newWindow;
                                    break;
                                case "GoToE":
                                    const target = action.get("T");
                                    let attachment;
                                    if (docAttachments && target instanceof _primitives.Dict) {
                                        const relationship = target.get("R");
                                        const name = target.get("N");
                                        if ((0, _primitives.isName)(relationship, "C") && typeof name === "string") attachment = docAttachments[(0, _util.stringToPDFString)(name)];
                                    }
                                    if (attachment) resultObj.attachment = attachment;
                                    else (0, _util.warn)(`parseDestDictionary - unimplemented "GoToE" action.`);
                                    break;
                                case "Named":
                                    const namedAction = action.get("N");
                                    if (namedAction instanceof _primitives.Name) resultObj.action = namedAction.name;
                                    break;
                                case "SetOCGState":
                                    const state = action.get("State");
                                    const preserveRB = action.get("PreserveRB");
                                    if (!Array.isArray(state) || state.length === 0) break;
                                    const stateArr = [];
                                    for (const elem of state){
                                        if (elem instanceof _primitives.Name) switch(elem.name){
                                            case "ON":
                                            case "OFF":
                                            case "Toggle":
                                                stateArr.push(elem.name);
                                                break;
                                        }
                                        else if (elem instanceof _primitives.Ref) stateArr.push(elem.toString());
                                    }
                                    if (stateArr.length !== state.length) break;
                                    resultObj.setOCGState = {
                                        state: stateArr,
                                        preserveRB: typeof preserveRB === "boolean" ? preserveRB : true
                                    };
                                    break;
                                case "JavaScript":
                                    const jsAction = action.get("JS");
                                    let js;
                                    if (jsAction instanceof _base_stream.BaseStream) js = jsAction.getString();
                                    else if (typeof jsAction === "string") js = jsAction;
                                    const jsURL = js && (0, _core_utils.recoverJsURL)((0, _util.stringToPDFString)(js));
                                    if (jsURL) {
                                        url = jsURL.url;
                                        resultObj.newWindow = jsURL.newWindow;
                                        break;
                                    }
                                default:
                                    if (actionName === "JavaScript" || actionName === "SubmitForm") break;
                                    (0, _util.warn)(`parseDestDictionary - unsupported action: "${actionName}".`);
                                    break;
                            }
                        } else if (destDict.has("Dest")) dest = destDict.get("Dest");
                        if (typeof url === "string") {
                            const absoluteUrl = (0, _util.createValidAbsoluteUrl)(url, docBaseUrl, {
                                addDefaultProtocol: true,
                                tryConvertEncoding: true
                            });
                            if (absoluteUrl) resultObj.url = absoluteUrl.href;
                            resultObj.unsafeUrl = url;
                        }
                        if (dest) {
                            if (dest instanceof _primitives.Name) dest = dest.name;
                            if (typeof dest === "string") resultObj.dest = (0, _util.stringToPDFString)(dest);
                            else if (Array.isArray(dest)) resultObj.dest = dest;
                        }
                    }
                }
                exports.Catalog = Catalog;
            /***/ },
            /* 67 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NumberTree = exports.NameTree = void 0;
                var _primitives = __w_pdfjs_require__(4);
                var _util = __w_pdfjs_require__(2);
                class NameOrNumberTree {
                    constructor(root, xref, type){
                        if (this.constructor === NameOrNumberTree) (0, _util.unreachable)("Cannot initialize NameOrNumberTree.");
                        this.root = root;
                        this.xref = xref;
                        this._type = type;
                    }
                    getAll() {
                        const map = new Map();
                        if (!this.root) return map;
                        const xref = this.xref;
                        const processed = new _primitives.RefSet();
                        processed.put(this.root);
                        const queue = [
                            this.root
                        ];
                        while(queue.length > 0){
                            const obj = xref.fetchIfRef(queue.shift());
                            if (!(obj instanceof _primitives.Dict)) continue;
                            if (obj.has("Kids")) {
                                const kids = obj.get("Kids");
                                if (!Array.isArray(kids)) continue;
                                for (const kid of kids){
                                    if (processed.has(kid)) throw new _util.FormatError(`Duplicate entry in "${this._type}" tree.`);
                                    queue.push(kid);
                                    processed.put(kid);
                                }
                                continue;
                            }
                            const entries = obj.get(this._type);
                            if (!Array.isArray(entries)) continue;
                            for(let i = 0, ii = entries.length; i < ii; i += 2)map.set(xref.fetchIfRef(entries[i]), xref.fetchIfRef(entries[i + 1]));
                        }
                        return map;
                    }
                    get(key) {
                        if (!this.root) return null;
                        const xref = this.xref;
                        let kidsOrEntries = xref.fetchIfRef(this.root);
                        let loopCount = 0;
                        const MAX_LEVELS = 10;
                        while(kidsOrEntries.has("Kids")){
                            if (++loopCount > MAX_LEVELS) {
                                (0, _util.warn)(`Search depth limit reached for "${this._type}" tree.`);
                                return null;
                            }
                            const kids = kidsOrEntries.get("Kids");
                            if (!Array.isArray(kids)) return null;
                            let l = 0, r = kids.length - 1;
                            while(l <= r){
                                const m = l + r >> 1;
                                const kid = xref.fetchIfRef(kids[m]);
                                const limits = kid.get("Limits");
                                if (key < xref.fetchIfRef(limits[0])) r = m - 1;
                                else if (key > xref.fetchIfRef(limits[1])) l = m + 1;
                                else {
                                    kidsOrEntries = kid;
                                    break;
                                }
                            }
                            if (l > r) return null;
                        }
                        const entries = kidsOrEntries.get(this._type);
                        if (Array.isArray(entries)) {
                            let l = 0, r = entries.length - 2;
                            while(l <= r){
                                const tmp = l + r >> 1, m = tmp + (tmp & 1);
                                const currentKey = xref.fetchIfRef(entries[m]);
                                if (key < currentKey) r = m - 2;
                                else if (key > currentKey) l = m + 2;
                                else return xref.fetchIfRef(entries[m + 1]);
                            }
                        }
                        return null;
                    }
                }
                class NameTree extends NameOrNumberTree {
                    constructor(root, xref){
                        super(root, xref, "Names");
                    }
                }
                exports.NameTree = NameTree;
                class NumberTree extends NameOrNumberTree {
                    constructor(root, xref){
                        super(root, xref, "Nums");
                    }
                }
                exports.NumberTree = NumberTree;
            /***/ },
            /* 68 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearGlobalCaches = clearGlobalCaches;
                var _pattern = __w_pdfjs_require__(50);
                var _primitives = __w_pdfjs_require__(4);
                var _unicode = __w_pdfjs_require__(40);
                function clearGlobalCaches() {
                    (0, _pattern.clearPatternCaches)();
                    (0, _primitives.clearPrimitiveCaches)();
                    (0, _unicode.clearUnicodeCaches)();
                }
            /***/ },
            /* 69 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FileSpec = void 0;
                var _util = __w_pdfjs_require__(2);
                var _base_stream = __w_pdfjs_require__(5);
                var _primitives = __w_pdfjs_require__(4);
                function pickPlatformItem(dict) {
                    if (dict.has("UF")) return dict.get("UF");
                    else if (dict.has("F")) return dict.get("F");
                    else if (dict.has("Unix")) return dict.get("Unix");
                    else if (dict.has("Mac")) return dict.get("Mac");
                    else if (dict.has("DOS")) return dict.get("DOS");
                    return null;
                }
                class FileSpec {
                    constructor(root, xref){
                        if (!(root instanceof _primitives.Dict)) return;
                        this.xref = xref;
                        this.root = root;
                        if (root.has("FS")) this.fs = root.get("FS");
                        this.description = root.has("Desc") ? (0, _util.stringToPDFString)(root.get("Desc")) : "";
                        if (root.has("RF")) (0, _util.warn)("Related file specifications are not supported");
                        this.contentAvailable = true;
                        if (!root.has("EF")) {
                            this.contentAvailable = false;
                            (0, _util.warn)("Non-embedded file specifications are not supported");
                        }
                    }
                    get filename() {
                        if (!this._filename && this.root) {
                            const filename = pickPlatformItem(this.root) || "unnamed";
                            this._filename = (0, _util.stringToPDFString)(filename).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
                        }
                        return this._filename;
                    }
                    get content() {
                        if (!this.contentAvailable) return null;
                        if (!this.contentRef && this.root) this.contentRef = pickPlatformItem(this.root.get("EF"));
                        let content = null;
                        if (this.contentRef) {
                            const fileObj = this.xref.fetchIfRef(this.contentRef);
                            if (fileObj instanceof _base_stream.BaseStream) content = fileObj.getBytes();
                            else (0, _util.warn)("Embedded file specification points to non-existing/invalid content");
                        } else (0, _util.warn)("Embedded file specification does not have a content");
                        return content;
                    }
                    get serializable() {
                        return {
                            filename: this.filename,
                            content: this.content
                        };
                    }
                }
                exports.FileSpec = FileSpec;
            /***/ },
            /* 70 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MetadataParser = void 0;
                var _xml_parser = __w_pdfjs_require__(71);
                class MetadataParser {
                    constructor(data){
                        data = this._repair(data);
                        const parser = new _xml_parser.SimpleXMLParser({
                            lowerCaseName: true
                        });
                        const xmlDocument = parser.parseFromString(data);
                        this._metadataMap = new Map();
                        this._data = data;
                        if (xmlDocument) this._parse(xmlDocument);
                    }
                    _repair(data) {
                        return data.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(all, codes) {
                            const bytes = codes.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(code, d1, d2, d3) {
                                return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
                            }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(str, name) {
                                switch(name){
                                    case "amp":
                                        return "&";
                                    case "apos":
                                        return "'";
                                    case "gt":
                                        return ">";
                                    case "lt":
                                        return "<";
                                    case "quot":
                                        return '"';
                                }
                                throw new Error(`_repair: ${name} isn't defined.`);
                            });
                            const charBuf = [
                                ">"
                            ];
                            for(let i = 0, ii = bytes.length; i < ii; i += 2){
                                const code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
                                if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) charBuf.push(String.fromCharCode(code));
                                else charBuf.push("&#x" + (0x10000 + code).toString(16).substring(1) + ";");
                            }
                            return charBuf.join("");
                        });
                    }
                    _getSequence(entry) {
                        const name = entry.nodeName;
                        if (name !== "rdf:bag" && name !== "rdf:seq" && name !== "rdf:alt") return null;
                        return entry.childNodes.filter((node)=>node.nodeName === "rdf:li");
                    }
                    _parseArray(entry) {
                        if (!entry.hasChildNodes()) return;
                        const [seqNode] = entry.childNodes;
                        const sequence = this._getSequence(seqNode) || [];
                        this._metadataMap.set(entry.nodeName, sequence.map((node)=>node.textContent.trim()));
                    }
                    _parse(xmlDocument) {
                        let rdf = xmlDocument.documentElement;
                        if (rdf.nodeName !== "rdf:rdf") {
                            rdf = rdf.firstChild;
                            while(rdf && rdf.nodeName !== "rdf:rdf")rdf = rdf.nextSibling;
                        }
                        if (!rdf || rdf.nodeName !== "rdf:rdf" || !rdf.hasChildNodes()) return;
                        for (const desc of rdf.childNodes){
                            if (desc.nodeName !== "rdf:description") continue;
                            for (const entry of desc.childNodes){
                                const name = entry.nodeName;
                                switch(name){
                                    case "#text":
                                        continue;
                                    case "dc:creator":
                                    case "dc:subject":
                                        this._parseArray(entry);
                                        continue;
                                }
                                this._metadataMap.set(name, entry.textContent.trim());
                            }
                        }
                    }
                    get serializable() {
                        return {
                            parsedData: this._metadataMap,
                            rawData: this._data
                        };
                    }
                }
                exports.MetadataParser = MetadataParser;
            /***/ },
            /* 71 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XMLParserErrorCode = exports.XMLParserBase = exports.SimpleXMLParser = exports.SimpleDOMNode = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                const XMLParserErrorCode = {
                    NoError: 0,
                    EndOfDocument: -1,
                    UnterminatedCdat: -2,
                    UnterminatedXmlDeclaration: -3,
                    UnterminatedDoctypeDeclaration: -4,
                    UnterminatedComment: -5,
                    MalformedElement: -6,
                    OutOfMemory: -7,
                    UnterminatedAttributeValue: -8,
                    UnterminatedElement: -9,
                    ElementNeverBegun: -10
                };
                exports.XMLParserErrorCode = XMLParserErrorCode;
                function isWhitespace(s, index) {
                    const ch = s[index];
                    return ch === " " || ch === "\n" || ch === "\r" || ch === "\t";
                }
                function isWhitespaceString(s) {
                    for(let i = 0, ii = s.length; i < ii; i++){
                        if (!isWhitespace(s, i)) return false;
                    }
                    return true;
                }
                class XMLParserBase {
                    _resolveEntities(s) {
                        return s.replaceAll(/&([^;]+);/g, (all, entity)=>{
                            if (entity.substring(0, 2) === "#x") return String.fromCodePoint(parseInt(entity.substring(2), 16));
                            else if (entity.substring(0, 1) === "#") return String.fromCodePoint(parseInt(entity.substring(1), 10));
                            switch(entity){
                                case "lt":
                                    return "<";
                                case "gt":
                                    return ">";
                                case "amp":
                                    return "&";
                                case "quot":
                                    return '"';
                                case "apos":
                                    return "'";
                            }
                            return this.onResolveEntity(entity);
                        });
                    }
                    _parseContent(s, start) {
                        const attributes = [];
                        let pos = start;
                        function skipWs() {
                            while(pos < s.length && isWhitespace(s, pos))++pos;
                        }
                        while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "/")++pos;
                        const name = s.substring(start, pos);
                        skipWs();
                        while(pos < s.length && s[pos] !== ">" && s[pos] !== "/" && s[pos] !== "?"){
                            skipWs();
                            let attrName = "", attrValue = "";
                            while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== "="){
                                attrName += s[pos];
                                ++pos;
                            }
                            skipWs();
                            if (s[pos] !== "=") return null;
                            ++pos;
                            skipWs();
                            const attrEndChar = s[pos];
                            if (attrEndChar !== '"' && attrEndChar !== "'") return null;
                            const attrEndIndex = s.indexOf(attrEndChar, ++pos);
                            if (attrEndIndex < 0) return null;
                            attrValue = s.substring(pos, attrEndIndex);
                            attributes.push({
                                name: attrName,
                                value: this._resolveEntities(attrValue)
                            });
                            pos = attrEndIndex + 1;
                            skipWs();
                        }
                        return {
                            name: name,
                            attributes: attributes,
                            parsed: pos - start
                        };
                    }
                    _parseProcessingInstruction(s, start) {
                        let pos = start;
                        function skipWs() {
                            while(pos < s.length && isWhitespace(s, pos))++pos;
                        }
                        while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "?" && s[pos] !== "/")++pos;
                        const name = s.substring(start, pos);
                        skipWs();
                        const attrStart = pos;
                        while(pos < s.length && (s[pos] !== "?" || s[pos + 1] !== ">"))++pos;
                        const value = s.substring(attrStart, pos);
                        return {
                            name: name,
                            value: value,
                            parsed: pos - start
                        };
                    }
                    parseXml(s) {
                        let i = 0;
                        while(i < s.length){
                            const ch = s[i];
                            let j = i;
                            if (ch === "<") {
                                ++j;
                                const ch2 = s[j];
                                let q;
                                switch(ch2){
                                    case "/":
                                        ++j;
                                        q = s.indexOf(">", j);
                                        if (q < 0) {
                                            this.onError(XMLParserErrorCode.UnterminatedElement);
                                            return;
                                        }
                                        this.onEndElement(s.substring(j, q));
                                        j = q + 1;
                                        break;
                                    case "?":
                                        ++j;
                                        const pi = this._parseProcessingInstruction(s, j);
                                        if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== "?>") {
                                            this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                                            return;
                                        }
                                        this.onPi(pi.name, pi.value);
                                        j += pi.parsed + 2;
                                        break;
                                    case "!":
                                        if (s.substring(j + 1, j + 3) === "--") {
                                            q = s.indexOf("-->", j + 3);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedComment);
                                                return;
                                            }
                                            this.onComment(s.substring(j + 3, q));
                                            j = q + 3;
                                        } else if (s.substring(j + 1, j + 8) === "[CDATA[") {
                                            q = s.indexOf("]]>", j + 8);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedCdat);
                                                return;
                                            }
                                            this.onCdata(s.substring(j + 8, q));
                                            j = q + 3;
                                        } else if (s.substring(j + 1, j + 8) === "DOCTYPE") {
                                            const q2 = s.indexOf("[", j + 8);
                                            let complexDoctype = false;
                                            q = s.indexOf(">", j + 8);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                                return;
                                            }
                                            if (q2 > 0 && q > q2) {
                                                q = s.indexOf("]>", j + 8);
                                                if (q < 0) {
                                                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                                    return;
                                                }
                                                complexDoctype = true;
                                            }
                                            const doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                                            this.onDoctype(doctypeContent);
                                            j = q + (complexDoctype ? 2 : 1);
                                        } else {
                                            this.onError(XMLParserErrorCode.MalformedElement);
                                            return;
                                        }
                                        break;
                                    default:
                                        const content = this._parseContent(s, j);
                                        if (content === null) {
                                            this.onError(XMLParserErrorCode.MalformedElement);
                                            return;
                                        }
                                        let isClosed = false;
                                        if (s.substring(j + content.parsed, j + content.parsed + 2) === "/>") isClosed = true;
                                        else if (s.substring(j + content.parsed, j + content.parsed + 1) !== ">") {
                                            this.onError(XMLParserErrorCode.UnterminatedElement);
                                            return;
                                        }
                                        this.onBeginElement(content.name, content.attributes, isClosed);
                                        j += content.parsed + (isClosed ? 2 : 1);
                                        break;
                                }
                            } else {
                                while(j < s.length && s[j] !== "<")j++;
                                const text = s.substring(i, j);
                                this.onText(this._resolveEntities(text));
                            }
                            i = j;
                        }
                    }
                    onResolveEntity(name) {
                        return `&${name};`;
                    }
                    onPi(name, value) {}
                    onComment(text) {}
                    onCdata(text) {}
                    onDoctype(doctypeContent) {}
                    onText(text) {}
                    onBeginElement(name, attributes, isEmpty) {}
                    onEndElement(name) {}
                    onError(code) {}
                }
                exports.XMLParserBase = XMLParserBase;
                class SimpleDOMNode {
                    constructor(nodeName, nodeValue){
                        this.nodeName = nodeName;
                        this.nodeValue = nodeValue;
                        Object.defineProperty(this, "parentNode", {
                            value: null,
                            writable: true
                        });
                    }
                    get firstChild() {
                        return this.childNodes?.[0];
                    }
                    get nextSibling() {
                        const childNodes = this.parentNode.childNodes;
                        if (!childNodes) return undefined;
                        const index = childNodes.indexOf(this);
                        if (index === -1) return undefined;
                        return childNodes[index + 1];
                    }
                    get textContent() {
                        if (!this.childNodes) return this.nodeValue || "";
                        return this.childNodes.map(function(child) {
                            return child.textContent;
                        }).join("");
                    }
                    get children() {
                        return this.childNodes || [];
                    }
                    hasChildNodes() {
                        return this.childNodes?.length > 0;
                    }
                    searchNode(paths, pos) {
                        if (pos >= paths.length) return this;
                        const component = paths[pos];
                        if (component.name.startsWith("#") && pos < paths.length - 1) return this.searchNode(paths, pos + 1);
                        const stack = [];
                        let node = this;
                        while(true){
                            if (component.name === node.nodeName) {
                                if (component.pos === 0) {
                                    const res = node.searchNode(paths, pos + 1);
                                    if (res !== null) return res;
                                } else if (stack.length === 0) return null;
                                else {
                                    const [parent] = stack.pop();
                                    let siblingPos = 0;
                                    for (const child of parent.childNodes)if (component.name === child.nodeName) {
                                        if (siblingPos === component.pos) return child.searchNode(paths, pos + 1);
                                        siblingPos++;
                                    }
                                    return node.searchNode(paths, pos + 1);
                                }
                            }
                            if (node.childNodes?.length > 0) {
                                stack.push([
                                    node,
                                    0
                                ]);
                                node = node.childNodes[0];
                            } else if (stack.length === 0) return null;
                            else {
                                while(stack.length !== 0){
                                    const [parent, currentPos] = stack.pop();
                                    const newPos = currentPos + 1;
                                    if (newPos < parent.childNodes.length) {
                                        stack.push([
                                            parent,
                                            newPos
                                        ]);
                                        node = parent.childNodes[newPos];
                                        break;
                                    }
                                }
                                if (stack.length === 0) return null;
                            }
                        }
                    }
                    dump(buffer) {
                        if (this.nodeName === "#text") {
                            buffer.push((0, _core_utils.encodeToXmlString)(this.nodeValue));
                            return;
                        }
                        buffer.push(`<${this.nodeName}`);
                        if (this.attributes) for (const attribute of this.attributes)buffer.push(` ${attribute.name}="${(0, _core_utils.encodeToXmlString)(attribute.value)}"`);
                        if (this.hasChildNodes()) {
                            buffer.push(">");
                            for (const child of this.childNodes)child.dump(buffer);
                            buffer.push(`</${this.nodeName}>`);
                        } else if (this.nodeValue) buffer.push(`>${(0, _core_utils.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`);
                        else buffer.push("/>");
                    }
                }
                exports.SimpleDOMNode = SimpleDOMNode;
                class SimpleXMLParser extends XMLParserBase {
                    constructor({ hasAttributes: hasAttributes = false, lowerCaseName: lowerCaseName = false }){
                        super();
                        this._currentFragment = null;
                        this._stack = null;
                        this._errorCode = XMLParserErrorCode.NoError;
                        this._hasAttributes = hasAttributes;
                        this._lowerCaseName = lowerCaseName;
                    }
                    parseFromString(data) {
                        this._currentFragment = [];
                        this._stack = [];
                        this._errorCode = XMLParserErrorCode.NoError;
                        this.parseXml(data);
                        if (this._errorCode !== XMLParserErrorCode.NoError) return undefined;
                        const [documentElement] = this._currentFragment;
                        if (!documentElement) return undefined;
                        return {
                            documentElement: documentElement
                        };
                    }
                    onText(text) {
                        if (isWhitespaceString(text)) return;
                        const node = new SimpleDOMNode("#text", text);
                        this._currentFragment.push(node);
                    }
                    onCdata(text) {
                        const node = new SimpleDOMNode("#text", text);
                        this._currentFragment.push(node);
                    }
                    onBeginElement(name, attributes, isEmpty) {
                        if (this._lowerCaseName) name = name.toLowerCase();
                        const node = new SimpleDOMNode(name);
                        node.childNodes = [];
                        if (this._hasAttributes) node.attributes = attributes;
                        this._currentFragment.push(node);
                        if (isEmpty) return;
                        this._stack.push(this._currentFragment);
                        this._currentFragment = node.childNodes;
                    }
                    onEndElement(name) {
                        this._currentFragment = this._stack.pop() || [];
                        const lastElement = this._currentFragment.at(-1);
                        if (!lastElement) return null;
                        for (const childNode of lastElement.childNodes)childNode.parentNode = lastElement;
                        return lastElement;
                    }
                    onError(code) {
                        this._errorCode = code;
                    }
                }
                exports.SimpleXMLParser = SimpleXMLParser;
            /***/ },
            /* 72 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StructTreeRoot = exports.StructTreePage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _name_number_tree = __w_pdfjs_require__(67);
                var _writer = __w_pdfjs_require__(73);
                const MAX_DEPTH = 40;
                const StructElementType = {
                    PAGE_CONTENT: 1,
                    STREAM_CONTENT: 2,
                    OBJECT: 3,
                    ANNOTATION: 4,
                    ELEMENT: 5
                };
                class StructTreeRoot {
                    constructor(rootDict, rootRef){
                        this.dict = rootDict;
                        this.ref = rootRef instanceof _primitives.Ref ? rootRef : null;
                        this.roleMap = new Map();
                        this.structParentIds = null;
                    }
                    init() {
                        this.readRoleMap();
                    }
                    #addIdToPage(pageRef, id, type) {
                        if (!(pageRef instanceof _primitives.Ref) || id < 0) return;
                        this.structParentIds ||= new _primitives.RefSetCache();
                        let ids = this.structParentIds.get(pageRef);
                        if (!ids) {
                            ids = [];
                            this.structParentIds.put(pageRef, ids);
                        }
                        ids.push([
                            id,
                            type
                        ]);
                    }
                    addAnnotationIdToPage(pageRef, id) {
                        this.#addIdToPage(pageRef, id, StructElementType.ANNOTATION);
                    }
                    readRoleMap() {
                        const roleMapDict = this.dict.get("RoleMap");
                        if (!(roleMapDict instanceof _primitives.Dict)) return;
                        roleMapDict.forEach((key, value)=>{
                            if (!(value instanceof _primitives.Name)) return;
                            this.roleMap.set(key, value.name);
                        });
                    }
                    static async canCreateStructureTree({ catalogRef: catalogRef, pdfManager: pdfManager, newAnnotationsByPage: newAnnotationsByPage }) {
                        if (!(catalogRef instanceof _primitives.Ref)) {
                            (0, _util.warn)("Cannot save the struct tree: no catalog reference.");
                            return false;
                        }
                        let nextKey = 0;
                        let hasNothingToUpdate = true;
                        for (const [pageIndex, elements] of newAnnotationsByPage){
                            const { ref: pageRef } = await pdfManager.getPage(pageIndex);
                            if (!(pageRef instanceof _primitives.Ref)) {
                                (0, _util.warn)(`Cannot save the struct tree: page ${pageIndex} has no ref.`);
                                hasNothingToUpdate = true;
                                break;
                            }
                            for (const element of elements)if (element.accessibilityData?.type) {
                                element.parentTreeId = nextKey++;
                                hasNothingToUpdate = false;
                            }
                        }
                        if (hasNothingToUpdate) {
                            for (const elements of newAnnotationsByPage.values())for (const element of elements)delete element.parentTreeId;
                            return false;
                        }
                        return true;
                    }
                    static async createStructureTree({ newAnnotationsByPage: newAnnotationsByPage, xref: xref, catalogRef: catalogRef, pdfManager: pdfManager, newRefs: newRefs }) {
                        const root = pdfManager.catalog.cloneDict();
                        const structTreeRootRef = xref.getNewTemporaryRef();
                        root.set("StructTreeRoot", structTreeRootRef);
                        const buffer = [];
                        await (0, _writer.writeObject)(catalogRef, root, buffer, xref);
                        newRefs.push({
                            ref: catalogRef,
                            data: buffer.join("")
                        });
                        const structTreeRoot = new _primitives.Dict(xref);
                        structTreeRoot.set("Type", _primitives.Name.get("StructTreeRoot"));
                        const parentTreeRef = xref.getNewTemporaryRef();
                        structTreeRoot.set("ParentTree", parentTreeRef);
                        const kids = [];
                        structTreeRoot.set("K", kids);
                        const parentTree = new _primitives.Dict(xref);
                        const nums = [];
                        parentTree.set("Nums", nums);
                        const nextKey = await this.#writeKids({
                            newAnnotationsByPage: newAnnotationsByPage,
                            structTreeRootRef: structTreeRootRef,
                            kids: kids,
                            nums: nums,
                            xref: xref,
                            pdfManager: pdfManager,
                            newRefs: newRefs,
                            buffer: buffer
                        });
                        structTreeRoot.set("ParentTreeNextKey", nextKey);
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentTreeRef, parentTree, buffer, xref);
                        newRefs.push({
                            ref: parentTreeRef,
                            data: buffer.join("")
                        });
                        buffer.length = 0;
                        await (0, _writer.writeObject)(structTreeRootRef, structTreeRoot, buffer, xref);
                        newRefs.push({
                            ref: structTreeRootRef,
                            data: buffer.join("")
                        });
                    }
                    async canUpdateStructTree({ pdfManager: pdfManager, newAnnotationsByPage: newAnnotationsByPage }) {
                        if (!this.ref) {
                            (0, _util.warn)("Cannot update the struct tree: no root reference.");
                            return false;
                        }
                        let nextKey = this.dict.get("ParentTreeNextKey");
                        if (!Number.isInteger(nextKey) || nextKey < 0) {
                            (0, _util.warn)("Cannot update the struct tree: invalid next key.");
                            return false;
                        }
                        const parentTree = this.dict.get("ParentTree");
                        if (!(parentTree instanceof _primitives.Dict)) {
                            (0, _util.warn)("Cannot update the struct tree: ParentTree isn't a dict.");
                            return false;
                        }
                        const nums = parentTree.get("Nums");
                        if (!Array.isArray(nums)) {
                            (0, _util.warn)("Cannot update the struct tree: nums isn't an array.");
                            return false;
                        }
                        const { numPages: numPages } = pdfManager.catalog;
                        for (const pageIndex of newAnnotationsByPage.keys()){
                            const { pageDict: pageDict, ref: pageRef } = await pdfManager.getPage(pageIndex);
                            if (!(pageRef instanceof _primitives.Ref)) {
                                (0, _util.warn)(`Cannot save the struct tree: page ${pageIndex} has no ref.`);
                                return false;
                            }
                            const id = pageDict.get("StructParents");
                            if (!Number.isInteger(id) || id < 0 || id >= numPages) {
                                (0, _util.warn)(`Cannot save the struct tree: page ${pageIndex} has no id.`);
                                return false;
                            }
                        }
                        let hasNothingToUpdate = true;
                        for (const [pageIndex, elements] of newAnnotationsByPage){
                            const { pageDict: pageDict } = await pdfManager.getPage(pageIndex);
                            StructTreeRoot.#collectParents({
                                elements: elements,
                                xref: this.dict.xref,
                                pageDict: pageDict,
                                parentTree: parentTree
                            });
                            for (const element of elements)if (element.accessibilityData?.type) {
                                element.parentTreeId = nextKey++;
                                hasNothingToUpdate = false;
                            }
                        }
                        if (hasNothingToUpdate) {
                            for (const elements of newAnnotationsByPage.values())for (const element of elements){
                                delete element.parentTreeId;
                                delete element.structTreeParent;
                            }
                            return false;
                        }
                        return true;
                    }
                    async updateStructureTree({ newAnnotationsByPage: newAnnotationsByPage, pdfManager: pdfManager, newRefs: newRefs }) {
                        const xref = this.dict.xref;
                        const structTreeRoot = this.dict.clone();
                        const structTreeRootRef = this.ref;
                        let parentTreeRef = structTreeRoot.getRaw("ParentTree");
                        let parentTree;
                        if (parentTreeRef instanceof _primitives.Ref) parentTree = xref.fetch(parentTreeRef);
                        else {
                            parentTree = parentTreeRef;
                            parentTreeRef = xref.getNewTemporaryRef();
                            structTreeRoot.set("ParentTree", parentTreeRef);
                        }
                        parentTree = parentTree.clone();
                        let nums = parentTree.getRaw("Nums");
                        let numsRef = null;
                        if (nums instanceof _primitives.Ref) {
                            numsRef = nums;
                            nums = xref.fetch(numsRef);
                        }
                        nums = nums.slice();
                        if (!numsRef) parentTree.set("Nums", nums);
                        let kids = structTreeRoot.getRaw("K");
                        let kidsRef = null;
                        if (kids instanceof _primitives.Ref) {
                            kidsRef = kids;
                            kids = xref.fetch(kidsRef);
                        } else {
                            kidsRef = xref.getNewTemporaryRef();
                            structTreeRoot.set("K", kidsRef);
                        }
                        kids = Array.isArray(kids) ? kids.slice() : [
                            kids
                        ];
                        const buffer = [];
                        const newNextkey = await StructTreeRoot.#writeKids({
                            newAnnotationsByPage: newAnnotationsByPage,
                            structTreeRootRef: structTreeRootRef,
                            kids: kids,
                            nums: nums,
                            xref: xref,
                            pdfManager: pdfManager,
                            newRefs: newRefs,
                            buffer: buffer
                        });
                        structTreeRoot.set("ParentTreeNextKey", newNextkey);
                        buffer.length = 0;
                        await (0, _writer.writeObject)(kidsRef, kids, buffer, xref);
                        newRefs.push({
                            ref: kidsRef,
                            data: buffer.join("")
                        });
                        if (numsRef) {
                            buffer.length = 0;
                            await (0, _writer.writeObject)(numsRef, nums, buffer, xref);
                            newRefs.push({
                                ref: numsRef,
                                data: buffer.join("")
                            });
                        }
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentTreeRef, parentTree, buffer, xref);
                        newRefs.push({
                            ref: parentTreeRef,
                            data: buffer.join("")
                        });
                        buffer.length = 0;
                        await (0, _writer.writeObject)(structTreeRootRef, structTreeRoot, buffer, xref);
                        newRefs.push({
                            ref: structTreeRootRef,
                            data: buffer.join("")
                        });
                    }
                    static async #writeKids({ newAnnotationsByPage: newAnnotationsByPage, structTreeRootRef: structTreeRootRef, kids: kids, nums: nums, xref: xref, pdfManager: pdfManager, newRefs: newRefs, buffer: buffer }) {
                        const objr = _primitives.Name.get("OBJR");
                        let nextKey = -Infinity;
                        for (const [pageIndex, elements] of newAnnotationsByPage){
                            const { ref: pageRef } = await pdfManager.getPage(pageIndex);
                            for (const { accessibilityData: { type: type, title: title, lang: lang, alt: alt, expanded: expanded, actualText: actualText }, ref: ref, parentTreeId: parentTreeId, structTreeParent: structTreeParent } of elements){
                                nextKey = Math.max(nextKey, parentTreeId);
                                const tagRef = xref.getNewTemporaryRef();
                                const tagDict = new _primitives.Dict(xref);
                                tagDict.set("S", _primitives.Name.get(type));
                                if (title) tagDict.set("T", title);
                                if (lang) tagDict.set("Lang", lang);
                                if (alt) tagDict.set("Alt", alt);
                                if (expanded) tagDict.set("E", expanded);
                                if (actualText) tagDict.set("ActualText", actualText);
                                if (structTreeParent) await this.#updateParentTag({
                                    structTreeParent: structTreeParent,
                                    tagDict: tagDict,
                                    newTagRef: tagRef,
                                    fallbackRef: structTreeRootRef,
                                    xref: xref,
                                    newRefs: newRefs,
                                    buffer: buffer
                                });
                                else tagDict.set("P", structTreeRootRef);
                                const objDict = new _primitives.Dict(xref);
                                tagDict.set("K", objDict);
                                objDict.set("Type", objr);
                                objDict.set("Pg", pageRef);
                                objDict.set("Obj", ref);
                                buffer.length = 0;
                                await (0, _writer.writeObject)(tagRef, tagDict, buffer, xref);
                                newRefs.push({
                                    ref: tagRef,
                                    data: buffer.join("")
                                });
                                nums.push(parentTreeId, tagRef);
                                kids.push(tagRef);
                            }
                        }
                        return nextKey + 1;
                    }
                    static #collectParents({ elements: elements, xref: xref, pageDict: pageDict, parentTree: parentTree }) {
                        const idToElement = new Map();
                        for (const element of elements)if (element.structTreeParentId) {
                            const id = parseInt(element.structTreeParentId.split("_mc")[1], 10);
                            idToElement.set(id, element);
                        }
                        const id = pageDict.get("StructParents");
                        const numberTree = new _name_number_tree.NumberTree(parentTree, xref);
                        const parentArray = numberTree.get(id);
                        if (!Array.isArray(parentArray)) return;
                        const updateElement = (kid, pageKid, kidRef)=>{
                            const element = idToElement.get(kid);
                            if (element) {
                                const parentRef = pageKid.getRaw("P");
                                const parentDict = xref.fetchIfRef(parentRef);
                                if (parentRef instanceof _primitives.Ref && parentDict instanceof _primitives.Dict) element.structTreeParent = {
                                    ref: kidRef,
                                    dict: pageKid
                                };
                                return true;
                            }
                            return false;
                        };
                        for (const kidRef of parentArray){
                            if (!(kidRef instanceof _primitives.Ref)) continue;
                            const pageKid = xref.fetch(kidRef);
                            const k = pageKid.get("K");
                            if (Number.isInteger(k)) {
                                updateElement(k, pageKid, kidRef);
                                continue;
                            }
                            if (!Array.isArray(k)) continue;
                            for (let kid of k){
                                kid = xref.fetchIfRef(kid);
                                if (Number.isInteger(kid) && updateElement(kid, pageKid, kidRef)) break;
                            }
                        }
                    }
                    static async #updateParentTag({ structTreeParent: { ref: ref, dict: dict }, tagDict: tagDict, newTagRef: newTagRef, fallbackRef: fallbackRef, xref: xref, newRefs: newRefs, buffer: buffer }) {
                        const parentRef = dict.getRaw("P");
                        let parentDict = xref.fetchIfRef(parentRef);
                        tagDict.set("P", parentRef);
                        let saveParentDict = false;
                        let parentKids;
                        let parentKidsRef = parentDict.getRaw("K");
                        if (!(parentKidsRef instanceof _primitives.Ref)) {
                            parentKids = parentKidsRef;
                            parentKidsRef = xref.getNewTemporaryRef();
                            parentDict = parentDict.clone();
                            parentDict.set("K", parentKidsRef);
                            saveParentDict = true;
                        } else parentKids = xref.fetch(parentKidsRef);
                        if (Array.isArray(parentKids)) {
                            const index = parentKids.indexOf(ref);
                            if (index >= 0) {
                                parentKids = parentKids.slice();
                                parentKids.splice(index + 1, 0, newTagRef);
                            } else {
                                (0, _util.warn)("Cannot update the struct tree: parent kid not found.");
                                tagDict.set("P", fallbackRef);
                                return;
                            }
                        } else if (parentKids instanceof _primitives.Dict) {
                            parentKids = [
                                parentKidsRef,
                                newTagRef
                            ];
                            parentKidsRef = xref.getNewTemporaryRef();
                            parentDict.set("K", parentKidsRef);
                            saveParentDict = true;
                        }
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentKidsRef, parentKids, buffer, xref);
                        newRefs.push({
                            ref: parentKidsRef,
                            data: buffer.join("")
                        });
                        if (!saveParentDict) return;
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentRef, parentDict, buffer, xref);
                        newRefs.push({
                            ref: parentRef,
                            data: buffer.join("")
                        });
                    }
                }
                exports.StructTreeRoot = StructTreeRoot;
                class StructElementNode {
                    constructor(tree, dict){
                        this.tree = tree;
                        this.dict = dict;
                        this.kids = [];
                        this.parseKids();
                    }
                    get role() {
                        const nameObj = this.dict.get("S");
                        const name = nameObj instanceof _primitives.Name ? nameObj.name : "";
                        const { root: root } = this.tree;
                        if (root.roleMap.has(name)) return root.roleMap.get(name);
                        return name;
                    }
                    parseKids() {
                        let pageObjId = null;
                        const objRef = this.dict.getRaw("Pg");
                        if (objRef instanceof _primitives.Ref) pageObjId = objRef.toString();
                        const kids = this.dict.get("K");
                        if (Array.isArray(kids)) for (const kid of kids){
                            const element = this.parseKid(pageObjId, kid);
                            if (element) this.kids.push(element);
                        }
                        else {
                            const element = this.parseKid(pageObjId, kids);
                            if (element) this.kids.push(element);
                        }
                    }
                    parseKid(pageObjId, kid) {
                        if (Number.isInteger(kid)) {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            return new StructElement({
                                type: StructElementType.PAGE_CONTENT,
                                mcid: kid,
                                pageObjId: pageObjId
                            });
                        }
                        let kidDict = null;
                        if (kid instanceof _primitives.Ref) kidDict = this.dict.xref.fetch(kid);
                        else if (kid instanceof _primitives.Dict) kidDict = kid;
                        if (!kidDict) return null;
                        const pageRef = kidDict.getRaw("Pg");
                        if (pageRef instanceof _primitives.Ref) pageObjId = pageRef.toString();
                        const type = kidDict.get("Type") instanceof _primitives.Name ? kidDict.get("Type").name : null;
                        if (type === "MCR") {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            const kidRef = kidDict.getRaw("Stm");
                            return new StructElement({
                                type: StructElementType.STREAM_CONTENT,
                                refObjId: kidRef instanceof _primitives.Ref ? kidRef.toString() : null,
                                pageObjId: pageObjId,
                                mcid: kidDict.get("MCID")
                            });
                        }
                        if (type === "OBJR") {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            const kidRef = kidDict.getRaw("Obj");
                            return new StructElement({
                                type: StructElementType.OBJECT,
                                refObjId: kidRef instanceof _primitives.Ref ? kidRef.toString() : null,
                                pageObjId: pageObjId
                            });
                        }
                        return new StructElement({
                            type: StructElementType.ELEMENT,
                            dict: kidDict
                        });
                    }
                }
                class StructElement {
                    constructor({ type: type, dict: dict = null, mcid: mcid = null, pageObjId: pageObjId = null, refObjId: refObjId = null }){
                        this.type = type;
                        this.dict = dict;
                        this.mcid = mcid;
                        this.pageObjId = pageObjId;
                        this.refObjId = refObjId;
                        this.parentNode = null;
                    }
                }
                class StructTreePage {
                    constructor(structTreeRoot, pageDict){
                        this.root = structTreeRoot;
                        this.rootDict = structTreeRoot ? structTreeRoot.dict : null;
                        this.pageDict = pageDict;
                        this.nodes = [];
                    }
                    parse(pageRef) {
                        if (!this.root || !this.rootDict) return;
                        const parentTree = this.rootDict.get("ParentTree");
                        if (!parentTree) return;
                        const id = this.pageDict.get("StructParents");
                        const ids = pageRef instanceof _primitives.Ref && this.root.structParentIds?.get(pageRef);
                        if (!Number.isInteger(id) && !ids) return;
                        const map = new Map();
                        const numberTree = new _name_number_tree.NumberTree(parentTree, this.rootDict.xref);
                        if (Number.isInteger(id)) {
                            const parentArray = numberTree.get(id);
                            if (Array.isArray(parentArray)) {
                                for (const ref of parentArray)if (ref instanceof _primitives.Ref) this.addNode(this.rootDict.xref.fetch(ref), map);
                            }
                        }
                        if (!ids) return;
                        for (const [elemId, type] of ids){
                            const obj = numberTree.get(elemId);
                            if (obj) {
                                const elem = this.addNode(this.rootDict.xref.fetchIfRef(obj), map);
                                if (elem?.kids?.length === 1 && elem.kids[0].type === StructElementType.OBJECT) elem.kids[0].type = type;
                            }
                        }
                    }
                    addNode(dict, map, level = 0) {
                        if (level > MAX_DEPTH) {
                            (0, _util.warn)("StructTree MAX_DEPTH reached.");
                            return null;
                        }
                        if (map.has(dict)) return map.get(dict);
                        const element = new StructElementNode(this, dict);
                        map.set(dict, element);
                        const parent = dict.get("P");
                        if (!parent || (0, _primitives.isName)(parent.get("Type"), "StructTreeRoot")) {
                            if (!this.addTopLevelNode(dict, element)) map.delete(dict);
                            return element;
                        }
                        const parentNode = this.addNode(parent, map, level + 1);
                        if (!parentNode) return element;
                        let save = false;
                        for (const kid of parentNode.kids)if (kid.type === StructElementType.ELEMENT && kid.dict === dict) {
                            kid.parentNode = element;
                            save = true;
                        }
                        if (!save) map.delete(dict);
                        return element;
                    }
                    addTopLevelNode(dict, element) {
                        const obj = this.rootDict.get("K");
                        if (!obj) return false;
                        if (obj instanceof _primitives.Dict) {
                            if (obj.objId !== dict.objId) return false;
                            this.nodes[0] = element;
                            return true;
                        }
                        if (!Array.isArray(obj)) return true;
                        let save = false;
                        for(let i = 0; i < obj.length; i++){
                            const kidRef = obj[i];
                            if (kidRef?.toString() === dict.objId) {
                                this.nodes[i] = element;
                                save = true;
                            }
                        }
                        return save;
                    }
                    get serializable() {
                        function nodeToSerializable(node, parent, level = 0) {
                            if (level > MAX_DEPTH) {
                                (0, _util.warn)("StructTree too deep to be fully serialized.");
                                return;
                            }
                            const obj = Object.create(null);
                            obj.role = node.role;
                            obj.children = [];
                            parent.children.push(obj);
                            const alt = node.dict.get("Alt");
                            if (typeof alt === "string") obj.alt = (0, _util.stringToPDFString)(alt);
                            const lang = node.dict.get("Lang");
                            if (typeof lang === "string") obj.lang = (0, _util.stringToPDFString)(lang);
                            for (const kid of node.kids){
                                const kidElement = kid.type === StructElementType.ELEMENT ? kid.parentNode : null;
                                if (kidElement) {
                                    nodeToSerializable(kidElement, obj, level + 1);
                                    continue;
                                } else if (kid.type === StructElementType.PAGE_CONTENT || kid.type === StructElementType.STREAM_CONTENT) obj.children.push({
                                    type: "content",
                                    id: `p${kid.pageObjId}_mc${kid.mcid}`
                                });
                                else if (kid.type === StructElementType.OBJECT) obj.children.push({
                                    type: "object",
                                    id: kid.refObjId
                                });
                                else if (kid.type === StructElementType.ANNOTATION) obj.children.push({
                                    type: "annotation",
                                    id: `${_util.AnnotationPrefix}${kid.refObjId}`
                                });
                            }
                        }
                        const root = Object.create(null);
                        root.children = [];
                        root.role = "Root";
                        for (const child of this.nodes){
                            if (!child) continue;
                            nodeToSerializable(child, root);
                        }
                        return root;
                    }
                }
                exports.StructTreePage = StructTreePage;
            /***/ },
            /* 73 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.incrementalUpdate = incrementalUpdate;
                exports.writeDict = writeDict;
                exports.writeObject = writeObject;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                var _xml_parser = __w_pdfjs_require__(71);
                var _base_stream = __w_pdfjs_require__(5);
                var _crypto = __w_pdfjs_require__(74);
                async function writeObject(ref, obj, buffer, { encrypt: encrypt = null }) {
                    const transform = encrypt?.createCipherTransform(ref.num, ref.gen);
                    buffer.push(`${ref.num} ${ref.gen} obj\n`);
                    if (obj instanceof _primitives.Dict) await writeDict(obj, buffer, transform);
                    else if (obj instanceof _base_stream.BaseStream) await writeStream(obj, buffer, transform);
                    else if (Array.isArray(obj)) await writeArray(obj, buffer, transform);
                    buffer.push("\nendobj\n");
                }
                async function writeDict(dict, buffer, transform) {
                    buffer.push("<<");
                    for (const key of dict.getKeys()){
                        buffer.push(` /${(0, _core_utils.escapePDFName)(key)} `);
                        await writeValue(dict.getRaw(key), buffer, transform);
                    }
                    buffer.push(">>");
                }
                async function writeStream(stream, buffer, transform) {
                    let string = stream.getString();
                    const { dict: dict } = stream;
                    const [filter, params] = await Promise.all([
                        dict.getAsync("Filter"),
                        dict.getAsync("DecodeParms")
                    ]);
                    const filterZero = Array.isArray(filter) ? await dict.xref.fetchIfRefAsync(filter[0]) : filter;
                    const isFilterZeroFlateDecode = (0, _primitives.isName)(filterZero, "FlateDecode");
                    const MIN_LENGTH_FOR_COMPRESSING = 256;
                    if (typeof CompressionStream !== "undefined" && (string.length >= MIN_LENGTH_FOR_COMPRESSING || isFilterZeroFlateDecode)) try {
                        const byteArray = (0, _util.stringToBytes)(string);
                        const cs = new CompressionStream("deflate");
                        const writer = cs.writable.getWriter();
                        writer.write(byteArray);
                        writer.close();
                        const buf = await new Response(cs.readable).arrayBuffer();
                        string = (0, _util.bytesToString)(new Uint8Array(buf));
                        let newFilter, newParams;
                        if (!filter) newFilter = _primitives.Name.get("FlateDecode");
                        else if (!isFilterZeroFlateDecode) {
                            newFilter = Array.isArray(filter) ? [
                                _primitives.Name.get("FlateDecode"),
                                ...filter
                            ] : [
                                _primitives.Name.get("FlateDecode"),
                                filter
                            ];
                            if (params) newParams = Array.isArray(params) ? [
                                null,
                                ...params
                            ] : [
                                null,
                                params
                            ];
                        }
                        if (newFilter) dict.set("Filter", newFilter);
                        if (newParams) dict.set("DecodeParms", newParams);
                    } catch (ex) {
                        (0, _util.info)(`writeStream - cannot compress data: "${ex}".`);
                    }
                    if (transform) string = transform.encryptString(string);
                    dict.set("Length", string.length);
                    await writeDict(dict, buffer, transform);
                    buffer.push(" stream\n", string, "\nendstream");
                }
                async function writeArray(array, buffer, transform) {
                    buffer.push("[");
                    let first = true;
                    for (const val of array){
                        if (!first) buffer.push(" ");
                        else first = false;
                        await writeValue(val, buffer, transform);
                    }
                    buffer.push("]");
                }
                async function writeValue(value, buffer, transform) {
                    if (value instanceof _primitives.Name) buffer.push(`/${(0, _core_utils.escapePDFName)(value.name)}`);
                    else if (value instanceof _primitives.Ref) buffer.push(`${value.num} ${value.gen} R`);
                    else if (Array.isArray(value)) await writeArray(value, buffer, transform);
                    else if (typeof value === "string") {
                        if (transform) value = transform.encryptString(value);
                        buffer.push(`(${(0, _core_utils.escapeString)(value)})`);
                    } else if (typeof value === "number") buffer.push((0, _core_utils.numberToString)(value));
                    else if (typeof value === "boolean") buffer.push(value.toString());
                    else if (value instanceof _primitives.Dict) await writeDict(value, buffer, transform);
                    else if (value instanceof _base_stream.BaseStream) await writeStream(value, buffer, transform);
                    else if (value === null) buffer.push("null");
                    else (0, _util.warn)(`Unhandled value in writer: ${typeof value}, please file a bug.`);
                }
                function writeInt(number, size, offset, buffer) {
                    for(let i = size + offset - 1; i > offset - 1; i--){
                        buffer[i] = number & 0xff;
                        number >>= 8;
                    }
                    return offset + size;
                }
                function writeString(string, offset, buffer) {
                    for(let i = 0, len = string.length; i < len; i++)buffer[offset + i] = string.charCodeAt(i) & 0xff;
                }
                function computeMD5(filesize, xrefInfo) {
                    const time = Math.floor(Date.now() / 1000);
                    const filename = xrefInfo.filename || "";
                    const md5Buffer = [
                        time.toString(),
                        filename,
                        filesize.toString()
                    ];
                    let md5BufferLen = md5Buffer.reduce((a, str)=>a + str.length, 0);
                    for (const value of Object.values(xrefInfo.info)){
                        md5Buffer.push(value);
                        md5BufferLen += value.length;
                    }
                    const array = new Uint8Array(md5BufferLen);
                    let offset = 0;
                    for (const str of md5Buffer){
                        writeString(str, offset, array);
                        offset += str.length;
                    }
                    return (0, _util.bytesToString)((0, _crypto.calculateMD5)(array));
                }
                function writeXFADataForAcroform(str, newRefs) {
                    const xml = new _xml_parser.SimpleXMLParser({
                        hasAttributes: true
                    }).parseFromString(str);
                    for (const { xfa: xfa } of newRefs){
                        if (!xfa) continue;
                        const { path: path, value: value } = xfa;
                        if (!path) continue;
                        const nodePath = (0, _core_utils.parseXFAPath)(path);
                        let node = xml.documentElement.searchNode(nodePath, 0);
                        if (!node && nodePath.length > 1) node = xml.documentElement.searchNode([
                            nodePath.at(-1)
                        ], 0);
                        if (node) node.childNodes = Array.isArray(value) ? value.map((val)=>new _xml_parser.SimpleDOMNode("value", val)) : [
                            new _xml_parser.SimpleDOMNode("#text", value)
                        ];
                        else (0, _util.warn)(`Node not found for path: ${path}`);
                    }
                    const buffer = [];
                    xml.documentElement.dump(buffer);
                    return buffer.join("");
                }
                async function updateAcroform({ xref: xref, acroForm: acroForm, acroFormRef: acroFormRef, hasXfa: hasXfa, hasXfaDatasetsEntry: hasXfaDatasetsEntry, xfaDatasetsRef: xfaDatasetsRef, needAppearances: needAppearances, newRefs: newRefs }) {
                    if (hasXfa && !hasXfaDatasetsEntry && !xfaDatasetsRef) (0, _util.warn)("XFA - Cannot save it");
                    if (!needAppearances && (!hasXfa || !xfaDatasetsRef || hasXfaDatasetsEntry)) return;
                    const dict = acroForm.clone();
                    if (hasXfa && !hasXfaDatasetsEntry) {
                        const newXfa = acroForm.get("XFA").slice();
                        newXfa.splice(2, 0, "datasets");
                        newXfa.splice(3, 0, xfaDatasetsRef);
                        dict.set("XFA", newXfa);
                    }
                    if (needAppearances) dict.set("NeedAppearances", true);
                    const buffer = [];
                    await writeObject(acroFormRef, dict, buffer, xref);
                    newRefs.push({
                        ref: acroFormRef,
                        data: buffer.join("")
                    });
                }
                function updateXFA({ xfaData: xfaData, xfaDatasetsRef: xfaDatasetsRef, newRefs: newRefs, xref: xref }) {
                    if (xfaData === null) {
                        const datasets = xref.fetchIfRef(xfaDatasetsRef);
                        xfaData = writeXFADataForAcroform(datasets.getString(), newRefs);
                    }
                    const encrypt = xref.encrypt;
                    if (encrypt) {
                        const transform = encrypt.createCipherTransform(xfaDatasetsRef.num, xfaDatasetsRef.gen);
                        xfaData = transform.encryptString(xfaData);
                    }
                    const data = `${xfaDatasetsRef.num} ${xfaDatasetsRef.gen} obj\n` + `<< /Type /EmbeddedFile /Length ${xfaData.length}>>\nstream\n` + xfaData + "\nendstream\nendobj\n";
                    newRefs.push({
                        ref: xfaDatasetsRef,
                        data: data
                    });
                }
                async function incrementalUpdate({ originalData: originalData, xrefInfo: xrefInfo, newRefs: newRefs, xref: xref = null, hasXfa: hasXfa = false, xfaDatasetsRef: xfaDatasetsRef = null, hasXfaDatasetsEntry: hasXfaDatasetsEntry = false, needAppearances: needAppearances, acroFormRef: acroFormRef = null, acroForm: acroForm = null, xfaData: xfaData = null }) {
                    await updateAcroform({
                        xref: xref,
                        acroForm: acroForm,
                        acroFormRef: acroFormRef,
                        hasXfa: hasXfa,
                        hasXfaDatasetsEntry: hasXfaDatasetsEntry,
                        xfaDatasetsRef: xfaDatasetsRef,
                        needAppearances: needAppearances,
                        newRefs: newRefs
                    });
                    if (hasXfa) updateXFA({
                        xfaData: xfaData,
                        xfaDatasetsRef: xfaDatasetsRef,
                        newRefs: newRefs,
                        xref: xref
                    });
                    const newXref = new _primitives.Dict(null);
                    const refForXrefTable = xrefInfo.newRef;
                    let buffer, baseOffset;
                    const lastByte = originalData.at(-1);
                    if (lastByte === 0x0a || lastByte === 0x0d) {
                        buffer = [];
                        baseOffset = originalData.length;
                    } else {
                        buffer = [
                            "\n"
                        ];
                        baseOffset = originalData.length + 1;
                    }
                    newXref.set("Size", refForXrefTable.num + 1);
                    newXref.set("Prev", xrefInfo.startXRef);
                    newXref.set("Type", _primitives.Name.get("XRef"));
                    if (xrefInfo.rootRef !== null) newXref.set("Root", xrefInfo.rootRef);
                    if (xrefInfo.infoRef !== null) newXref.set("Info", xrefInfo.infoRef);
                    if (xrefInfo.encryptRef !== null) newXref.set("Encrypt", xrefInfo.encryptRef);
                    newRefs.push({
                        ref: refForXrefTable,
                        data: ""
                    });
                    newRefs = newRefs.sort((a, b)=>{
                        return a.ref.num - b.ref.num;
                    });
                    const xrefTableData = [
                        [
                            0,
                            1,
                            0xffff
                        ]
                    ];
                    const indexes = [
                        0,
                        1
                    ];
                    let maxOffset = 0;
                    for (const { ref: ref, data: data } of newRefs){
                        maxOffset = Math.max(maxOffset, baseOffset);
                        xrefTableData.push([
                            1,
                            baseOffset,
                            Math.min(ref.gen, 0xffff)
                        ]);
                        baseOffset += data.length;
                        indexes.push(ref.num, 1);
                        buffer.push(data);
                    }
                    newXref.set("Index", indexes);
                    if (Array.isArray(xrefInfo.fileIds) && xrefInfo.fileIds.length > 0) {
                        const md5 = computeMD5(baseOffset, xrefInfo);
                        newXref.set("ID", [
                            xrefInfo.fileIds[0],
                            md5
                        ]);
                    }
                    const offsetSize = Math.ceil(Math.log2(maxOffset) / 8);
                    const sizes = [
                        1,
                        offsetSize,
                        2
                    ];
                    const structSize = sizes[0] + sizes[1] + sizes[2];
                    const tableLength = structSize * xrefTableData.length;
                    newXref.set("W", sizes);
                    newXref.set("Length", tableLength);
                    buffer.push(`${refForXrefTable.num} ${refForXrefTable.gen} obj\n`);
                    await writeDict(newXref, buffer, null);
                    buffer.push(" stream\n");
                    const bufferLen = buffer.reduce((a, str)=>a + str.length, 0);
                    const footer = `\nendstream\nendobj\nstartxref\n${baseOffset}\n%%EOF\n`;
                    const array = new Uint8Array(originalData.length + bufferLen + tableLength + footer.length);
                    array.set(originalData);
                    let offset = originalData.length;
                    for (const str of buffer){
                        writeString(str, offset, array);
                        offset += str.length;
                    }
                    for (const [type, objOffset, gen] of xrefTableData){
                        offset = writeInt(type, sizes[0], offset, array);
                        offset = writeInt(objOffset, sizes[1], offset, array);
                        offset = writeInt(gen, sizes[2], offset, array);
                    }
                    writeString(footer, offset, array);
                    return array;
                }
            /***/ },
            /* 74 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.calculateSHA256 = exports.calculateMD5 = exports.PDF20 = exports.PDF17 = exports.CipherTransformFactory = exports.ARCFourCipher = exports.AES256Cipher = exports.AES128Cipher = void 0;
                exports.calculateSHA384 = calculateSHA384;
                exports.calculateSHA512 = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _decrypt_stream = __w_pdfjs_require__(75);
                class ARCFourCipher {
                    constructor(key){
                        this.a = 0;
                        this.b = 0;
                        const s = new Uint8Array(256);
                        const keyLength = key.length;
                        for(let i = 0; i < 256; ++i)s[i] = i;
                        for(let i = 0, j = 0; i < 256; ++i){
                            const tmp = s[i];
                            j = j + tmp + key[i % keyLength] & 0xff;
                            s[i] = s[j];
                            s[j] = tmp;
                        }
                        this.s = s;
                    }
                    encryptBlock(data) {
                        let a = this.a, b = this.b;
                        const s = this.s;
                        const n = data.length;
                        const output = new Uint8Array(n);
                        for(let i = 0; i < n; ++i){
                            a = a + 1 & 0xff;
                            const tmp = s[a];
                            b = b + tmp & 0xff;
                            const tmp2 = s[b];
                            s[a] = tmp2;
                            s[b] = tmp;
                            output[i] = data[i] ^ s[tmp + tmp2 & 0xff];
                        }
                        this.a = a;
                        this.b = b;
                        return output;
                    }
                    decryptBlock(data) {
                        return this.encryptBlock(data);
                    }
                    encrypt(data) {
                        return this.encryptBlock(data);
                    }
                }
                exports.ARCFourCipher = ARCFourCipher;
                const calculateMD5 = function calculateMD5Closure() {
                    const r = new Uint8Array([
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21
                    ]);
                    const k = new Int32Array([
                        -680876936,
                        -389564586,
                        606105819,
                        -1044525330,
                        -176418897,
                        1200080426,
                        -1473231341,
                        -45705983,
                        1770035416,
                        -1958414417,
                        -42063,
                        -1990404162,
                        1804603682,
                        -40341101,
                        -1502002290,
                        1236535329,
                        -165796510,
                        -1069501632,
                        643717713,
                        -373897302,
                        -701558691,
                        38016083,
                        -660478335,
                        -405537848,
                        568446438,
                        -1019803690,
                        -187363961,
                        1163531501,
                        -1444681467,
                        -51403784,
                        1735328473,
                        -1926607734,
                        -378558,
                        -2022574463,
                        1839030562,
                        -35309556,
                        -1530992060,
                        1272893353,
                        -155497632,
                        -1094730640,
                        681279174,
                        -358537222,
                        -722521979,
                        76029189,
                        -640364487,
                        -421815835,
                        530742520,
                        -995338651,
                        -198630844,
                        1126891415,
                        -1416354905,
                        -57434055,
                        1700485571,
                        -1894986606,
                        -1051523,
                        -2054922799,
                        1873313359,
                        -30611744,
                        -1560198380,
                        1309151649,
                        -145523070,
                        -1120210379,
                        718787259,
                        -343485551
                    ]);
                    function hash(data, offset, length) {
                        let h0 = 1732584193, h1 = -271733879, h2 = -1732584194, h3 = 271733878;
                        const paddedLength = length + 72 & -64;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 8;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = length << 3 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        const w = new Int32Array(16);
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j, i += 4)w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
                            let a = h0, b = h1, c = h2, d = h3, f, g;
                            for(j = 0; j < 64; ++j){
                                if (j < 16) {
                                    f = b & c | ~b & d;
                                    g = j;
                                } else if (j < 32) {
                                    f = d & b | ~d & c;
                                    g = 5 * j + 1 & 15;
                                } else if (j < 48) {
                                    f = b ^ c ^ d;
                                    g = 3 * j + 5 & 15;
                                } else {
                                    f = c ^ (b | ~d);
                                    g = 7 * j & 15;
                                }
                                const tmp = d, rotateArg = a + f + k[j] + w[g] | 0, rotate = r[j];
                                d = c;
                                c = b;
                                b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
                                a = tmp;
                            }
                            h0 = h0 + a | 0;
                            h1 = h1 + b | 0;
                            h2 = h2 + c | 0;
                            h3 = h3 + d | 0;
                        }
                        return new Uint8Array([
                            h0 & 0xFF,
                            h0 >> 8 & 0xFF,
                            h0 >> 16 & 0xFF,
                            h0 >>> 24 & 0xFF,
                            h1 & 0xFF,
                            h1 >> 8 & 0xFF,
                            h1 >> 16 & 0xFF,
                            h1 >>> 24 & 0xFF,
                            h2 & 0xFF,
                            h2 >> 8 & 0xFF,
                            h2 >> 16 & 0xFF,
                            h2 >>> 24 & 0xFF,
                            h3 & 0xFF,
                            h3 >> 8 & 0xFF,
                            h3 >> 16 & 0xFF,
                            h3 >>> 24 & 0xFF
                        ]);
                    }
                    return hash;
                }();
                exports.calculateMD5 = calculateMD5;
                class Word64 {
                    constructor(highInteger, lowInteger){
                        this.high = highInteger | 0;
                        this.low = lowInteger | 0;
                    }
                    and(word) {
                        this.high &= word.high;
                        this.low &= word.low;
                    }
                    xor(word) {
                        this.high ^= word.high;
                        this.low ^= word.low;
                    }
                    or(word) {
                        this.high |= word.high;
                        this.low |= word.low;
                    }
                    shiftRight(places) {
                        if (places >= 32) {
                            this.low = this.high >>> places - 32 | 0;
                            this.high = 0;
                        } else {
                            this.low = this.low >>> places | this.high << 32 - places;
                            this.high = this.high >>> places | 0;
                        }
                    }
                    shiftLeft(places) {
                        if (places >= 32) {
                            this.high = this.low << places - 32;
                            this.low = 0;
                        } else {
                            this.high = this.high << places | this.low >>> 32 - places;
                            this.low <<= places;
                        }
                    }
                    rotateRight(places) {
                        let low, high;
                        if (places & 32) {
                            high = this.low;
                            low = this.high;
                        } else {
                            low = this.low;
                            high = this.high;
                        }
                        places &= 31;
                        this.low = low >>> places | high << 32 - places;
                        this.high = high >>> places | low << 32 - places;
                    }
                    not() {
                        this.high = ~this.high;
                        this.low = ~this.low;
                    }
                    add(word) {
                        const lowAdd = (this.low >>> 0) + (word.low >>> 0);
                        let highAdd = (this.high >>> 0) + (word.high >>> 0);
                        if (lowAdd > 0xffffffff) highAdd += 1;
                        this.low = lowAdd | 0;
                        this.high = highAdd | 0;
                    }
                    copyTo(bytes, offset) {
                        bytes[offset] = this.high >>> 24 & 0xff;
                        bytes[offset + 1] = this.high >> 16 & 0xff;
                        bytes[offset + 2] = this.high >> 8 & 0xff;
                        bytes[offset + 3] = this.high & 0xff;
                        bytes[offset + 4] = this.low >>> 24 & 0xff;
                        bytes[offset + 5] = this.low >> 16 & 0xff;
                        bytes[offset + 6] = this.low >> 8 & 0xff;
                        bytes[offset + 7] = this.low & 0xff;
                    }
                    assign(word) {
                        this.high = word.high;
                        this.low = word.low;
                    }
                }
                const calculateSHA256 = function calculateSHA256Closure() {
                    function rotr(x, n) {
                        return x >>> n | x << 32 - n;
                    }
                    function ch(x, y, z) {
                        return x & y ^ ~x & z;
                    }
                    function maj(x, y, z) {
                        return x & y ^ x & z ^ y & z;
                    }
                    function sigma(x) {
                        return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
                    }
                    function sigmaPrime(x) {
                        return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
                    }
                    function littleSigma(x) {
                        return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
                    }
                    function littleSigmaPrime(x) {
                        return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
                    }
                    const k = [
                        0x428a2f98,
                        0x71374491,
                        0xb5c0fbcf,
                        0xe9b5dba5,
                        0x3956c25b,
                        0x59f111f1,
                        0x923f82a4,
                        0xab1c5ed5,
                        0xd807aa98,
                        0x12835b01,
                        0x243185be,
                        0x550c7dc3,
                        0x72be5d74,
                        0x80deb1fe,
                        0x9bdc06a7,
                        0xc19bf174,
                        0xe49b69c1,
                        0xefbe4786,
                        0x0fc19dc6,
                        0x240ca1cc,
                        0x2de92c6f,
                        0x4a7484aa,
                        0x5cb0a9dc,
                        0x76f988da,
                        0x983e5152,
                        0xa831c66d,
                        0xb00327c8,
                        0xbf597fc7,
                        0xc6e00bf3,
                        0xd5a79147,
                        0x06ca6351,
                        0x14292967,
                        0x27b70a85,
                        0x2e1b2138,
                        0x4d2c6dfc,
                        0x53380d13,
                        0x650a7354,
                        0x766a0abb,
                        0x81c2c92e,
                        0x92722c85,
                        0xa2bfe8a1,
                        0xa81a664b,
                        0xc24b8b70,
                        0xc76c51a3,
                        0xd192e819,
                        0xd6990624,
                        0xf40e3585,
                        0x106aa070,
                        0x19a4c116,
                        0x1e376c08,
                        0x2748774c,
                        0x34b0bcb5,
                        0x391c0cb3,
                        0x4ed8aa4a,
                        0x5b9cca4f,
                        0x682e6ff3,
                        0x748f82ee,
                        0x78a5636f,
                        0x84c87814,
                        0x8cc70208,
                        0x90befffa,
                        0xa4506ceb,
                        0xbef9a3f7,
                        0xc67178f2
                    ];
                    function hash(data, offset, length) {
                        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a, h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
                        const paddedLength = Math.ceil((length + 9) / 64) * 64;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 8;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length << 3 & 0xff;
                        const w = new Uint32Array(64);
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j){
                                w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                                i += 4;
                            }
                            for(j = 16; j < 64; ++j)w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
                            let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, t1, t2;
                            for(j = 0; j < 64; ++j){
                                t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
                                t2 = sigma(a) + maj(a, b, c);
                                h = g;
                                g = f;
                                f = e;
                                e = d + t1 | 0;
                                d = c;
                                c = b;
                                b = a;
                                a = t1 + t2 | 0;
                            }
                            h0 = h0 + a | 0;
                            h1 = h1 + b | 0;
                            h2 = h2 + c | 0;
                            h3 = h3 + d | 0;
                            h4 = h4 + e | 0;
                            h5 = h5 + f | 0;
                            h6 = h6 + g | 0;
                            h7 = h7 + h | 0;
                        }
                        return new Uint8Array([
                            h0 >> 24 & 0xFF,
                            h0 >> 16 & 0xFF,
                            h0 >> 8 & 0xFF,
                            h0 & 0xFF,
                            h1 >> 24 & 0xFF,
                            h1 >> 16 & 0xFF,
                            h1 >> 8 & 0xFF,
                            h1 & 0xFF,
                            h2 >> 24 & 0xFF,
                            h2 >> 16 & 0xFF,
                            h2 >> 8 & 0xFF,
                            h2 & 0xFF,
                            h3 >> 24 & 0xFF,
                            h3 >> 16 & 0xFF,
                            h3 >> 8 & 0xFF,
                            h3 & 0xFF,
                            h4 >> 24 & 0xFF,
                            h4 >> 16 & 0xFF,
                            h4 >> 8 & 0xFF,
                            h4 & 0xFF,
                            h5 >> 24 & 0xFF,
                            h5 >> 16 & 0xFF,
                            h5 >> 8 & 0xFF,
                            h5 & 0xFF,
                            h6 >> 24 & 0xFF,
                            h6 >> 16 & 0xFF,
                            h6 >> 8 & 0xFF,
                            h6 & 0xFF,
                            h7 >> 24 & 0xFF,
                            h7 >> 16 & 0xFF,
                            h7 >> 8 & 0xFF,
                            h7 & 0xFF
                        ]);
                    }
                    return hash;
                }();
                exports.calculateSHA256 = calculateSHA256;
                const calculateSHA512 = function calculateSHA512Closure() {
                    function ch(result, x, y, z, tmp) {
                        result.assign(x);
                        result.and(y);
                        tmp.assign(x);
                        tmp.not();
                        tmp.and(z);
                        result.xor(tmp);
                    }
                    function maj(result, x, y, z, tmp) {
                        result.assign(x);
                        result.and(y);
                        tmp.assign(x);
                        tmp.and(z);
                        result.xor(tmp);
                        tmp.assign(y);
                        tmp.and(z);
                        result.xor(tmp);
                    }
                    function sigma(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(28);
                        tmp.assign(x);
                        tmp.rotateRight(34);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.rotateRight(39);
                        result.xor(tmp);
                    }
                    function sigmaPrime(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(14);
                        tmp.assign(x);
                        tmp.rotateRight(18);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.rotateRight(41);
                        result.xor(tmp);
                    }
                    function littleSigma(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(1);
                        tmp.assign(x);
                        tmp.rotateRight(8);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.shiftRight(7);
                        result.xor(tmp);
                    }
                    function littleSigmaPrime(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(19);
                        tmp.assign(x);
                        tmp.rotateRight(61);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.shiftRight(6);
                        result.xor(tmp);
                    }
                    const k = [
                        new Word64(0x428a2f98, 0xd728ae22),
                        new Word64(0x71374491, 0x23ef65cd),
                        new Word64(0xb5c0fbcf, 0xec4d3b2f),
                        new Word64(0xe9b5dba5, 0x8189dbbc),
                        new Word64(0x3956c25b, 0xf348b538),
                        new Word64(0x59f111f1, 0xb605d019),
                        new Word64(0x923f82a4, 0xaf194f9b),
                        new Word64(0xab1c5ed5, 0xda6d8118),
                        new Word64(0xd807aa98, 0xa3030242),
                        new Word64(0x12835b01, 0x45706fbe),
                        new Word64(0x243185be, 0x4ee4b28c),
                        new Word64(0x550c7dc3, 0xd5ffb4e2),
                        new Word64(0x72be5d74, 0xf27b896f),
                        new Word64(0x80deb1fe, 0x3b1696b1),
                        new Word64(0x9bdc06a7, 0x25c71235),
                        new Word64(0xc19bf174, 0xcf692694),
                        new Word64(0xe49b69c1, 0x9ef14ad2),
                        new Word64(0xefbe4786, 0x384f25e3),
                        new Word64(0x0fc19dc6, 0x8b8cd5b5),
                        new Word64(0x240ca1cc, 0x77ac9c65),
                        new Word64(0x2de92c6f, 0x592b0275),
                        new Word64(0x4a7484aa, 0x6ea6e483),
                        new Word64(0x5cb0a9dc, 0xbd41fbd4),
                        new Word64(0x76f988da, 0x831153b5),
                        new Word64(0x983e5152, 0xee66dfab),
                        new Word64(0xa831c66d, 0x2db43210),
                        new Word64(0xb00327c8, 0x98fb213f),
                        new Word64(0xbf597fc7, 0xbeef0ee4),
                        new Word64(0xc6e00bf3, 0x3da88fc2),
                        new Word64(0xd5a79147, 0x930aa725),
                        new Word64(0x06ca6351, 0xe003826f),
                        new Word64(0x14292967, 0x0a0e6e70),
                        new Word64(0x27b70a85, 0x46d22ffc),
                        new Word64(0x2e1b2138, 0x5c26c926),
                        new Word64(0x4d2c6dfc, 0x5ac42aed),
                        new Word64(0x53380d13, 0x9d95b3df),
                        new Word64(0x650a7354, 0x8baf63de),
                        new Word64(0x766a0abb, 0x3c77b2a8),
                        new Word64(0x81c2c92e, 0x47edaee6),
                        new Word64(0x92722c85, 0x1482353b),
                        new Word64(0xa2bfe8a1, 0x4cf10364),
                        new Word64(0xa81a664b, 0xbc423001),
                        new Word64(0xc24b8b70, 0xd0f89791),
                        new Word64(0xc76c51a3, 0x0654be30),
                        new Word64(0xd192e819, 0xd6ef5218),
                        new Word64(0xd6990624, 0x5565a910),
                        new Word64(0xf40e3585, 0x5771202a),
                        new Word64(0x106aa070, 0x32bbd1b8),
                        new Word64(0x19a4c116, 0xb8d2d0c8),
                        new Word64(0x1e376c08, 0x5141ab53),
                        new Word64(0x2748774c, 0xdf8eeb99),
                        new Word64(0x34b0bcb5, 0xe19b48a8),
                        new Word64(0x391c0cb3, 0xc5c95a63),
                        new Word64(0x4ed8aa4a, 0xe3418acb),
                        new Word64(0x5b9cca4f, 0x7763e373),
                        new Word64(0x682e6ff3, 0xd6b2b8a3),
                        new Word64(0x748f82ee, 0x5defb2fc),
                        new Word64(0x78a5636f, 0x43172f60),
                        new Word64(0x84c87814, 0xa1f0ab72),
                        new Word64(0x8cc70208, 0x1a6439ec),
                        new Word64(0x90befffa, 0x23631e28),
                        new Word64(0xa4506ceb, 0xde82bde9),
                        new Word64(0xbef9a3f7, 0xb2c67915),
                        new Word64(0xc67178f2, 0xe372532b),
                        new Word64(0xca273ece, 0xea26619c),
                        new Word64(0xd186b8c7, 0x21c0c207),
                        new Word64(0xeada7dd6, 0xcde0eb1e),
                        new Word64(0xf57d4f7f, 0xee6ed178),
                        new Word64(0x06f067aa, 0x72176fba),
                        new Word64(0x0a637dc5, 0xa2c898a6),
                        new Word64(0x113f9804, 0xbef90dae),
                        new Word64(0x1b710b35, 0x131c471b),
                        new Word64(0x28db77f5, 0x23047d84),
                        new Word64(0x32caab7b, 0x40c72493),
                        new Word64(0x3c9ebe0a, 0x15c9bebc),
                        new Word64(0x431d67c4, 0x9c100d4c),
                        new Word64(0x4cc5d4be, 0xcb3e42b6),
                        new Word64(0x597f299c, 0xfc657e2a),
                        new Word64(0x5fcb6fab, 0x3ad6faec),
                        new Word64(0x6c44198c, 0x4a475817)
                    ];
                    function hash(data, offset, length, mode384 = false) {
                        let h0, h1, h2, h3, h4, h5, h6, h7;
                        if (!mode384) {
                            h0 = new Word64(0x6a09e667, 0xf3bcc908);
                            h1 = new Word64(0xbb67ae85, 0x84caa73b);
                            h2 = new Word64(0x3c6ef372, 0xfe94f82b);
                            h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
                            h4 = new Word64(0x510e527f, 0xade682d1);
                            h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
                            h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
                            h7 = new Word64(0x5be0cd19, 0x137e2179);
                        } else {
                            h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
                            h1 = new Word64(0x629a292a, 0x367cd507);
                            h2 = new Word64(0x9159015a, 0x3070dd17);
                            h3 = new Word64(0x152fecd8, 0xf70e5939);
                            h4 = new Word64(0x67332667, 0xffc00b31);
                            h5 = new Word64(0x8eb44a87, 0x68581511);
                            h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
                            h7 = new Word64(0x47b5481d, 0xbefa4fa4);
                        }
                        const paddedLength = Math.ceil((length + 17) / 128) * 128;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 16;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length << 3 & 0xff;
                        const w = new Array(80);
                        for(i = 0; i < 80; i++)w[i] = new Word64(0, 0);
                        let a = new Word64(0, 0), b = new Word64(0, 0), c = new Word64(0, 0);
                        let d = new Word64(0, 0), e = new Word64(0, 0), f = new Word64(0, 0);
                        let g = new Word64(0, 0), h = new Word64(0, 0);
                        const t1 = new Word64(0, 0), t2 = new Word64(0, 0);
                        const tmp1 = new Word64(0, 0), tmp2 = new Word64(0, 0);
                        let tmp3;
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j){
                                w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                                w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
                                i += 8;
                            }
                            for(j = 16; j < 80; ++j){
                                tmp3 = w[j];
                                littleSigmaPrime(tmp3, w[j - 2], tmp2);
                                tmp3.add(w[j - 7]);
                                littleSigma(tmp1, w[j - 15], tmp2);
                                tmp3.add(tmp1);
                                tmp3.add(w[j - 16]);
                            }
                            a.assign(h0);
                            b.assign(h1);
                            c.assign(h2);
                            d.assign(h3);
                            e.assign(h4);
                            f.assign(h5);
                            g.assign(h6);
                            h.assign(h7);
                            for(j = 0; j < 80; ++j){
                                t1.assign(h);
                                sigmaPrime(tmp1, e, tmp2);
                                t1.add(tmp1);
                                ch(tmp1, e, f, g, tmp2);
                                t1.add(tmp1);
                                t1.add(k[j]);
                                t1.add(w[j]);
                                sigma(t2, a, tmp2);
                                maj(tmp1, a, b, c, tmp2);
                                t2.add(tmp1);
                                tmp3 = h;
                                h = g;
                                g = f;
                                f = e;
                                d.add(t1);
                                e = d;
                                d = c;
                                c = b;
                                b = a;
                                tmp3.assign(t1);
                                tmp3.add(t2);
                                a = tmp3;
                            }
                            h0.add(a);
                            h1.add(b);
                            h2.add(c);
                            h3.add(d);
                            h4.add(e);
                            h5.add(f);
                            h6.add(g);
                            h7.add(h);
                        }
                        let result;
                        if (!mode384) {
                            result = new Uint8Array(64);
                            h0.copyTo(result, 0);
                            h1.copyTo(result, 8);
                            h2.copyTo(result, 16);
                            h3.copyTo(result, 24);
                            h4.copyTo(result, 32);
                            h5.copyTo(result, 40);
                            h6.copyTo(result, 48);
                            h7.copyTo(result, 56);
                        } else {
                            result = new Uint8Array(48);
                            h0.copyTo(result, 0);
                            h1.copyTo(result, 8);
                            h2.copyTo(result, 16);
                            h3.copyTo(result, 24);
                            h4.copyTo(result, 32);
                            h5.copyTo(result, 40);
                        }
                        return result;
                    }
                    return hash;
                }();
                exports.calculateSHA512 = calculateSHA512;
                function calculateSHA384(data, offset, length) {
                    return calculateSHA512(data, offset, length, true);
                }
                class NullCipher {
                    decryptBlock(data) {
                        return data;
                    }
                    encrypt(data) {
                        return data;
                    }
                }
                class AESBaseCipher {
                    constructor(){
                        if (this.constructor === AESBaseCipher) (0, _util.unreachable)("Cannot initialize AESBaseCipher.");
                        this._s = new Uint8Array([
                            0x63,
                            0x7c,
                            0x77,
                            0x7b,
                            0xf2,
                            0x6b,
                            0x6f,
                            0xc5,
                            0x30,
                            0x01,
                            0x67,
                            0x2b,
                            0xfe,
                            0xd7,
                            0xab,
                            0x76,
                            0xca,
                            0x82,
                            0xc9,
                            0x7d,
                            0xfa,
                            0x59,
                            0x47,
                            0xf0,
                            0xad,
                            0xd4,
                            0xa2,
                            0xaf,
                            0x9c,
                            0xa4,
                            0x72,
                            0xc0,
                            0xb7,
                            0xfd,
                            0x93,
                            0x26,
                            0x36,
                            0x3f,
                            0xf7,
                            0xcc,
                            0x34,
                            0xa5,
                            0xe5,
                            0xf1,
                            0x71,
                            0xd8,
                            0x31,
                            0x15,
                            0x04,
                            0xc7,
                            0x23,
                            0xc3,
                            0x18,
                            0x96,
                            0x05,
                            0x9a,
                            0x07,
                            0x12,
                            0x80,
                            0xe2,
                            0xeb,
                            0x27,
                            0xb2,
                            0x75,
                            0x09,
                            0x83,
                            0x2c,
                            0x1a,
                            0x1b,
                            0x6e,
                            0x5a,
                            0xa0,
                            0x52,
                            0x3b,
                            0xd6,
                            0xb3,
                            0x29,
                            0xe3,
                            0x2f,
                            0x84,
                            0x53,
                            0xd1,
                            0x00,
                            0xed,
                            0x20,
                            0xfc,
                            0xb1,
                            0x5b,
                            0x6a,
                            0xcb,
                            0xbe,
                            0x39,
                            0x4a,
                            0x4c,
                            0x58,
                            0xcf,
                            0xd0,
                            0xef,
                            0xaa,
                            0xfb,
                            0x43,
                            0x4d,
                            0x33,
                            0x85,
                            0x45,
                            0xf9,
                            0x02,
                            0x7f,
                            0x50,
                            0x3c,
                            0x9f,
                            0xa8,
                            0x51,
                            0xa3,
                            0x40,
                            0x8f,
                            0x92,
                            0x9d,
                            0x38,
                            0xf5,
                            0xbc,
                            0xb6,
                            0xda,
                            0x21,
                            0x10,
                            0xff,
                            0xf3,
                            0xd2,
                            0xcd,
                            0x0c,
                            0x13,
                            0xec,
                            0x5f,
                            0x97,
                            0x44,
                            0x17,
                            0xc4,
                            0xa7,
                            0x7e,
                            0x3d,
                            0x64,
                            0x5d,
                            0x19,
                            0x73,
                            0x60,
                            0x81,
                            0x4f,
                            0xdc,
                            0x22,
                            0x2a,
                            0x90,
                            0x88,
                            0x46,
                            0xee,
                            0xb8,
                            0x14,
                            0xde,
                            0x5e,
                            0x0b,
                            0xdb,
                            0xe0,
                            0x32,
                            0x3a,
                            0x0a,
                            0x49,
                            0x06,
                            0x24,
                            0x5c,
                            0xc2,
                            0xd3,
                            0xac,
                            0x62,
                            0x91,
                            0x95,
                            0xe4,
                            0x79,
                            0xe7,
                            0xc8,
                            0x37,
                            0x6d,
                            0x8d,
                            0xd5,
                            0x4e,
                            0xa9,
                            0x6c,
                            0x56,
                            0xf4,
                            0xea,
                            0x65,
                            0x7a,
                            0xae,
                            0x08,
                            0xba,
                            0x78,
                            0x25,
                            0x2e,
                            0x1c,
                            0xa6,
                            0xb4,
                            0xc6,
                            0xe8,
                            0xdd,
                            0x74,
                            0x1f,
                            0x4b,
                            0xbd,
                            0x8b,
                            0x8a,
                            0x70,
                            0x3e,
                            0xb5,
                            0x66,
                            0x48,
                            0x03,
                            0xf6,
                            0x0e,
                            0x61,
                            0x35,
                            0x57,
                            0xb9,
                            0x86,
                            0xc1,
                            0x1d,
                            0x9e,
                            0xe1,
                            0xf8,
                            0x98,
                            0x11,
                            0x69,
                            0xd9,
                            0x8e,
                            0x94,
                            0x9b,
                            0x1e,
                            0x87,
                            0xe9,
                            0xce,
                            0x55,
                            0x28,
                            0xdf,
                            0x8c,
                            0xa1,
                            0x89,
                            0x0d,
                            0xbf,
                            0xe6,
                            0x42,
                            0x68,
                            0x41,
                            0x99,
                            0x2d,
                            0x0f,
                            0xb0,
                            0x54,
                            0xbb,
                            0x16
                        ]);
                        this._inv_s = new Uint8Array([
                            0x52,
                            0x09,
                            0x6a,
                            0xd5,
                            0x30,
                            0x36,
                            0xa5,
                            0x38,
                            0xbf,
                            0x40,
                            0xa3,
                            0x9e,
                            0x81,
                            0xf3,
                            0xd7,
                            0xfb,
                            0x7c,
                            0xe3,
                            0x39,
                            0x82,
                            0x9b,
                            0x2f,
                            0xff,
                            0x87,
                            0x34,
                            0x8e,
                            0x43,
                            0x44,
                            0xc4,
                            0xde,
                            0xe9,
                            0xcb,
                            0x54,
                            0x7b,
                            0x94,
                            0x32,
                            0xa6,
                            0xc2,
                            0x23,
                            0x3d,
                            0xee,
                            0x4c,
                            0x95,
                            0x0b,
                            0x42,
                            0xfa,
                            0xc3,
                            0x4e,
                            0x08,
                            0x2e,
                            0xa1,
                            0x66,
                            0x28,
                            0xd9,
                            0x24,
                            0xb2,
                            0x76,
                            0x5b,
                            0xa2,
                            0x49,
                            0x6d,
                            0x8b,
                            0xd1,
                            0x25,
                            0x72,
                            0xf8,
                            0xf6,
                            0x64,
                            0x86,
                            0x68,
                            0x98,
                            0x16,
                            0xd4,
                            0xa4,
                            0x5c,
                            0xcc,
                            0x5d,
                            0x65,
                            0xb6,
                            0x92,
                            0x6c,
                            0x70,
                            0x48,
                            0x50,
                            0xfd,
                            0xed,
                            0xb9,
                            0xda,
                            0x5e,
                            0x15,
                            0x46,
                            0x57,
                            0xa7,
                            0x8d,
                            0x9d,
                            0x84,
                            0x90,
                            0xd8,
                            0xab,
                            0x00,
                            0x8c,
                            0xbc,
                            0xd3,
                            0x0a,
                            0xf7,
                            0xe4,
                            0x58,
                            0x05,
                            0xb8,
                            0xb3,
                            0x45,
                            0x06,
                            0xd0,
                            0x2c,
                            0x1e,
                            0x8f,
                            0xca,
                            0x3f,
                            0x0f,
                            0x02,
                            0xc1,
                            0xaf,
                            0xbd,
                            0x03,
                            0x01,
                            0x13,
                            0x8a,
                            0x6b,
                            0x3a,
                            0x91,
                            0x11,
                            0x41,
                            0x4f,
                            0x67,
                            0xdc,
                            0xea,
                            0x97,
                            0xf2,
                            0xcf,
                            0xce,
                            0xf0,
                            0xb4,
                            0xe6,
                            0x73,
                            0x96,
                            0xac,
                            0x74,
                            0x22,
                            0xe7,
                            0xad,
                            0x35,
                            0x85,
                            0xe2,
                            0xf9,
                            0x37,
                            0xe8,
                            0x1c,
                            0x75,
                            0xdf,
                            0x6e,
                            0x47,
                            0xf1,
                            0x1a,
                            0x71,
                            0x1d,
                            0x29,
                            0xc5,
                            0x89,
                            0x6f,
                            0xb7,
                            0x62,
                            0x0e,
                            0xaa,
                            0x18,
                            0xbe,
                            0x1b,
                            0xfc,
                            0x56,
                            0x3e,
                            0x4b,
                            0xc6,
                            0xd2,
                            0x79,
                            0x20,
                            0x9a,
                            0xdb,
                            0xc0,
                            0xfe,
                            0x78,
                            0xcd,
                            0x5a,
                            0xf4,
                            0x1f,
                            0xdd,
                            0xa8,
                            0x33,
                            0x88,
                            0x07,
                            0xc7,
                            0x31,
                            0xb1,
                            0x12,
                            0x10,
                            0x59,
                            0x27,
                            0x80,
                            0xec,
                            0x5f,
                            0x60,
                            0x51,
                            0x7f,
                            0xa9,
                            0x19,
                            0xb5,
                            0x4a,
                            0x0d,
                            0x2d,
                            0xe5,
                            0x7a,
                            0x9f,
                            0x93,
                            0xc9,
                            0x9c,
                            0xef,
                            0xa0,
                            0xe0,
                            0x3b,
                            0x4d,
                            0xae,
                            0x2a,
                            0xf5,
                            0xb0,
                            0xc8,
                            0xeb,
                            0xbb,
                            0x3c,
                            0x83,
                            0x53,
                            0x99,
                            0x61,
                            0x17,
                            0x2b,
                            0x04,
                            0x7e,
                            0xba,
                            0x77,
                            0xd6,
                            0x26,
                            0xe1,
                            0x69,
                            0x14,
                            0x63,
                            0x55,
                            0x21,
                            0x0c,
                            0x7d
                        ]);
                        this._mix = new Uint32Array([
                            0x00000000,
                            0x0e090d0b,
                            0x1c121a16,
                            0x121b171d,
                            0x3824342c,
                            0x362d3927,
                            0x24362e3a,
                            0x2a3f2331,
                            0x70486858,
                            0x7e416553,
                            0x6c5a724e,
                            0x62537f45,
                            0x486c5c74,
                            0x4665517f,
                            0x547e4662,
                            0x5a774b69,
                            0xe090d0b0,
                            0xee99ddbb,
                            0xfc82caa6,
                            0xf28bc7ad,
                            0xd8b4e49c,
                            0xd6bde997,
                            0xc4a6fe8a,
                            0xcaaff381,
                            0x90d8b8e8,
                            0x9ed1b5e3,
                            0x8ccaa2fe,
                            0x82c3aff5,
                            0xa8fc8cc4,
                            0xa6f581cf,
                            0xb4ee96d2,
                            0xbae79bd9,
                            0xdb3bbb7b,
                            0xd532b670,
                            0xc729a16d,
                            0xc920ac66,
                            0xe31f8f57,
                            0xed16825c,
                            0xff0d9541,
                            0xf104984a,
                            0xab73d323,
                            0xa57ade28,
                            0xb761c935,
                            0xb968c43e,
                            0x9357e70f,
                            0x9d5eea04,
                            0x8f45fd19,
                            0x814cf012,
                            0x3bab6bcb,
                            0x35a266c0,
                            0x27b971dd,
                            0x29b07cd6,
                            0x038f5fe7,
                            0x0d8652ec,
                            0x1f9d45f1,
                            0x119448fa,
                            0x4be30393,
                            0x45ea0e98,
                            0x57f11985,
                            0x59f8148e,
                            0x73c737bf,
                            0x7dce3ab4,
                            0x6fd52da9,
                            0x61dc20a2,
                            0xad766df6,
                            0xa37f60fd,
                            0xb16477e0,
                            0xbf6d7aeb,
                            0x955259da,
                            0x9b5b54d1,
                            0x894043cc,
                            0x87494ec7,
                            0xdd3e05ae,
                            0xd33708a5,
                            0xc12c1fb8,
                            0xcf2512b3,
                            0xe51a3182,
                            0xeb133c89,
                            0xf9082b94,
                            0xf701269f,
                            0x4de6bd46,
                            0x43efb04d,
                            0x51f4a750,
                            0x5ffdaa5b,
                            0x75c2896a,
                            0x7bcb8461,
                            0x69d0937c,
                            0x67d99e77,
                            0x3daed51e,
                            0x33a7d815,
                            0x21bccf08,
                            0x2fb5c203,
                            0x058ae132,
                            0x0b83ec39,
                            0x1998fb24,
                            0x1791f62f,
                            0x764dd68d,
                            0x7844db86,
                            0x6a5fcc9b,
                            0x6456c190,
                            0x4e69e2a1,
                            0x4060efaa,
                            0x527bf8b7,
                            0x5c72f5bc,
                            0x0605bed5,
                            0x080cb3de,
                            0x1a17a4c3,
                            0x141ea9c8,
                            0x3e218af9,
                            0x302887f2,
                            0x223390ef,
                            0x2c3a9de4,
                            0x96dd063d,
                            0x98d40b36,
                            0x8acf1c2b,
                            0x84c61120,
                            0xaef93211,
                            0xa0f03f1a,
                            0xb2eb2807,
                            0xbce2250c,
                            0xe6956e65,
                            0xe89c636e,
                            0xfa877473,
                            0xf48e7978,
                            0xdeb15a49,
                            0xd0b85742,
                            0xc2a3405f,
                            0xccaa4d54,
                            0x41ecdaf7,
                            0x4fe5d7fc,
                            0x5dfec0e1,
                            0x53f7cdea,
                            0x79c8eedb,
                            0x77c1e3d0,
                            0x65daf4cd,
                            0x6bd3f9c6,
                            0x31a4b2af,
                            0x3fadbfa4,
                            0x2db6a8b9,
                            0x23bfa5b2,
                            0x09808683,
                            0x07898b88,
                            0x15929c95,
                            0x1b9b919e,
                            0xa17c0a47,
                            0xaf75074c,
                            0xbd6e1051,
                            0xb3671d5a,
                            0x99583e6b,
                            0x97513360,
                            0x854a247d,
                            0x8b432976,
                            0xd134621f,
                            0xdf3d6f14,
                            0xcd267809,
                            0xc32f7502,
                            0xe9105633,
                            0xe7195b38,
                            0xf5024c25,
                            0xfb0b412e,
                            0x9ad7618c,
                            0x94de6c87,
                            0x86c57b9a,
                            0x88cc7691,
                            0xa2f355a0,
                            0xacfa58ab,
                            0xbee14fb6,
                            0xb0e842bd,
                            0xea9f09d4,
                            0xe49604df,
                            0xf68d13c2,
                            0xf8841ec9,
                            0xd2bb3df8,
                            0xdcb230f3,
                            0xcea927ee,
                            0xc0a02ae5,
                            0x7a47b13c,
                            0x744ebc37,
                            0x6655ab2a,
                            0x685ca621,
                            0x42638510,
                            0x4c6a881b,
                            0x5e719f06,
                            0x5078920d,
                            0x0a0fd964,
                            0x0406d46f,
                            0x161dc372,
                            0x1814ce79,
                            0x322bed48,
                            0x3c22e043,
                            0x2e39f75e,
                            0x2030fa55,
                            0xec9ab701,
                            0xe293ba0a,
                            0xf088ad17,
                            0xfe81a01c,
                            0xd4be832d,
                            0xdab78e26,
                            0xc8ac993b,
                            0xc6a59430,
                            0x9cd2df59,
                            0x92dbd252,
                            0x80c0c54f,
                            0x8ec9c844,
                            0xa4f6eb75,
                            0xaaffe67e,
                            0xb8e4f163,
                            0xb6edfc68,
                            0x0c0a67b1,
                            0x02036aba,
                            0x10187da7,
                            0x1e1170ac,
                            0x342e539d,
                            0x3a275e96,
                            0x283c498b,
                            0x26354480,
                            0x7c420fe9,
                            0x724b02e2,
                            0x605015ff,
                            0x6e5918f4,
                            0x44663bc5,
                            0x4a6f36ce,
                            0x587421d3,
                            0x567d2cd8,
                            0x37a10c7a,
                            0x39a80171,
                            0x2bb3166c,
                            0x25ba1b67,
                            0x0f853856,
                            0x018c355d,
                            0x13972240,
                            0x1d9e2f4b,
                            0x47e96422,
                            0x49e06929,
                            0x5bfb7e34,
                            0x55f2733f,
                            0x7fcd500e,
                            0x71c45d05,
                            0x63df4a18,
                            0x6dd64713,
                            0xd731dcca,
                            0xd938d1c1,
                            0xcb23c6dc,
                            0xc52acbd7,
                            0xef15e8e6,
                            0xe11ce5ed,
                            0xf307f2f0,
                            0xfd0efffb,
                            0xa779b492,
                            0xa970b999,
                            0xbb6bae84,
                            0xb562a38f,
                            0x9f5d80be,
                            0x91548db5,
                            0x834f9aa8,
                            0x8d4697a3
                        ]);
                        this._mixCol = new Uint8Array(256);
                        for(let i = 0; i < 256; i++)this._mixCol[i] = i < 128 ? i << 1 : i << 1 ^ 0x1b;
                        this.buffer = new Uint8Array(16);
                        this.bufferPosition = 0;
                    }
                    _expandKey(cipherKey) {
                        (0, _util.unreachable)("Cannot call `_expandKey` on the base class");
                    }
                    _decrypt(input, key) {
                        let t, u, v;
                        const state = new Uint8Array(16);
                        state.set(input);
                        for(let j = 0, k = this._keySize; j < 16; ++j, ++k)state[j] ^= key[k];
                        for(let i = this._cyclesOfRepetition - 1; i >= 1; --i){
                            t = state[13];
                            state[13] = state[9];
                            state[9] = state[5];
                            state[5] = state[1];
                            state[1] = t;
                            t = state[14];
                            u = state[10];
                            state[14] = state[6];
                            state[10] = state[2];
                            state[6] = t;
                            state[2] = u;
                            t = state[15];
                            u = state[11];
                            v = state[7];
                            state[15] = state[3];
                            state[11] = t;
                            state[7] = u;
                            state[3] = v;
                            for(let j = 0; j < 16; ++j)state[j] = this._inv_s[state[j]];
                            for(let j = 0, k = i * 16; j < 16; ++j, ++k)state[j] ^= key[k];
                            for(let j = 0; j < 16; j += 4){
                                const s0 = this._mix[state[j]];
                                const s1 = this._mix[state[j + 1]];
                                const s2 = this._mix[state[j + 2]];
                                const s3 = this._mix[state[j + 3]];
                                t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
                                state[j] = t >>> 24 & 0xff;
                                state[j + 1] = t >> 16 & 0xff;
                                state[j + 2] = t >> 8 & 0xff;
                                state[j + 3] = t & 0xff;
                            }
                        }
                        t = state[13];
                        state[13] = state[9];
                        state[9] = state[5];
                        state[5] = state[1];
                        state[1] = t;
                        t = state[14];
                        u = state[10];
                        state[14] = state[6];
                        state[10] = state[2];
                        state[6] = t;
                        state[2] = u;
                        t = state[15];
                        u = state[11];
                        v = state[7];
                        state[15] = state[3];
                        state[11] = t;
                        state[7] = u;
                        state[3] = v;
                        for(let j = 0; j < 16; ++j){
                            state[j] = this._inv_s[state[j]];
                            state[j] ^= key[j];
                        }
                        return state;
                    }
                    _encrypt(input, key) {
                        const s = this._s;
                        let t, u, v;
                        const state = new Uint8Array(16);
                        state.set(input);
                        for(let j = 0; j < 16; ++j)state[j] ^= key[j];
                        for(let i = 1; i < this._cyclesOfRepetition; i++){
                            for(let j = 0; j < 16; ++j)state[j] = s[state[j]];
                            v = state[1];
                            state[1] = state[5];
                            state[5] = state[9];
                            state[9] = state[13];
                            state[13] = v;
                            v = state[2];
                            u = state[6];
                            state[2] = state[10];
                            state[6] = state[14];
                            state[10] = v;
                            state[14] = u;
                            v = state[3];
                            u = state[7];
                            t = state[11];
                            state[3] = state[15];
                            state[7] = v;
                            state[11] = u;
                            state[15] = t;
                            for(let j = 0; j < 16; j += 4){
                                const s0 = state[j + 0];
                                const s1 = state[j + 1];
                                const s2 = state[j + 2];
                                const s3 = state[j + 3];
                                t = s0 ^ s1 ^ s2 ^ s3;
                                state[j + 0] ^= t ^ this._mixCol[s0 ^ s1];
                                state[j + 1] ^= t ^ this._mixCol[s1 ^ s2];
                                state[j + 2] ^= t ^ this._mixCol[s2 ^ s3];
                                state[j + 3] ^= t ^ this._mixCol[s3 ^ s0];
                            }
                            for(let j = 0, k = i * 16; j < 16; ++j, ++k)state[j] ^= key[k];
                        }
                        for(let j = 0; j < 16; ++j)state[j] = s[state[j]];
                        v = state[1];
                        state[1] = state[5];
                        state[5] = state[9];
                        state[9] = state[13];
                        state[13] = v;
                        v = state[2];
                        u = state[6];
                        state[2] = state[10];
                        state[6] = state[14];
                        state[10] = v;
                        state[14] = u;
                        v = state[3];
                        u = state[7];
                        t = state[11];
                        state[3] = state[15];
                        state[7] = v;
                        state[11] = u;
                        state[15] = t;
                        for(let j = 0, k = this._keySize; j < 16; ++j, ++k)state[j] ^= key[k];
                        return state;
                    }
                    _decryptBlock2(data, finalize) {
                        const sourceLength = data.length;
                        let buffer = this.buffer, bufferLength = this.bufferPosition;
                        const result = [];
                        let iv = this.iv;
                        for(let i = 0; i < sourceLength; ++i){
                            buffer[bufferLength] = data[i];
                            ++bufferLength;
                            if (bufferLength < 16) continue;
                            const plain = this._decrypt(buffer, this._key);
                            for(let j = 0; j < 16; ++j)plain[j] ^= iv[j];
                            iv = buffer;
                            result.push(plain);
                            buffer = new Uint8Array(16);
                            bufferLength = 0;
                        }
                        this.buffer = buffer;
                        this.bufferLength = bufferLength;
                        this.iv = iv;
                        if (result.length === 0) return new Uint8Array(0);
                        let outputLength = 16 * result.length;
                        if (finalize) {
                            const lastBlock = result.at(-1);
                            let psLen = lastBlock[15];
                            if (psLen <= 16) {
                                for(let i = 15, ii = 16 - psLen; i >= ii; --i)if (lastBlock[i] !== psLen) {
                                    psLen = 0;
                                    break;
                                }
                                outputLength -= psLen;
                                result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
                            }
                        }
                        const output = new Uint8Array(outputLength);
                        for(let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16)output.set(result[i], j);
                        return output;
                    }
                    decryptBlock(data, finalize, iv = null) {
                        const sourceLength = data.length;
                        const buffer = this.buffer;
                        let bufferLength = this.bufferPosition;
                        if (iv) this.iv = iv;
                        else {
                            for(let i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength)buffer[bufferLength] = data[i];
                            if (bufferLength < 16) {
                                this.bufferLength = bufferLength;
                                return new Uint8Array(0);
                            }
                            this.iv = buffer;
                            data = data.subarray(16);
                        }
                        this.buffer = new Uint8Array(16);
                        this.bufferLength = 0;
                        this.decryptBlock = this._decryptBlock2;
                        return this.decryptBlock(data, finalize);
                    }
                    encrypt(data, iv) {
                        const sourceLength = data.length;
                        let buffer = this.buffer, bufferLength = this.bufferPosition;
                        const result = [];
                        if (!iv) iv = new Uint8Array(16);
                        for(let i = 0; i < sourceLength; ++i){
                            buffer[bufferLength] = data[i];
                            ++bufferLength;
                            if (bufferLength < 16) continue;
                            for(let j = 0; j < 16; ++j)buffer[j] ^= iv[j];
                            const cipher = this._encrypt(buffer, this._key);
                            iv = cipher;
                            result.push(cipher);
                            buffer = new Uint8Array(16);
                            bufferLength = 0;
                        }
                        this.buffer = buffer;
                        this.bufferLength = bufferLength;
                        this.iv = iv;
                        if (result.length === 0) return new Uint8Array(0);
                        const outputLength = 16 * result.length;
                        const output = new Uint8Array(outputLength);
                        for(let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16)output.set(result[i], j);
                        return output;
                    }
                }
                class AES128Cipher extends AESBaseCipher {
                    constructor(key){
                        super();
                        this._cyclesOfRepetition = 10;
                        this._keySize = 160;
                        this._rcon = new Uint8Array([
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d
                        ]);
                        this._key = this._expandKey(key);
                    }
                    _expandKey(cipherKey) {
                        const b = 176;
                        const s = this._s;
                        const rcon = this._rcon;
                        const result = new Uint8Array(b);
                        result.set(cipherKey);
                        for(let j = 16, i = 1; j < b; ++i){
                            let t1 = result[j - 3];
                            let t2 = result[j - 2];
                            let t3 = result[j - 1];
                            let t4 = result[j - 4];
                            t1 = s[t1];
                            t2 = s[t2];
                            t3 = s[t3];
                            t4 = s[t4];
                            t1 ^= rcon[i];
                            for(let n = 0; n < 4; ++n){
                                result[j] = t1 ^= result[j - 16];
                                j++;
                                result[j] = t2 ^= result[j - 16];
                                j++;
                                result[j] = t3 ^= result[j - 16];
                                j++;
                                result[j] = t4 ^= result[j - 16];
                                j++;
                            }
                        }
                        return result;
                    }
                }
                exports.AES128Cipher = AES128Cipher;
                class AES256Cipher extends AESBaseCipher {
                    constructor(key){
                        super();
                        this._cyclesOfRepetition = 14;
                        this._keySize = 224;
                        this._key = this._expandKey(key);
                    }
                    _expandKey(cipherKey) {
                        const b = 240;
                        const s = this._s;
                        const result = new Uint8Array(b);
                        result.set(cipherKey);
                        let r = 1;
                        let t1, t2, t3, t4;
                        for(let j = 32, i = 1; j < b; ++i){
                            if (j % 32 === 16) {
                                t1 = s[t1];
                                t2 = s[t2];
                                t3 = s[t3];
                                t4 = s[t4];
                            } else if (j % 32 === 0) {
                                t1 = result[j - 3];
                                t2 = result[j - 2];
                                t3 = result[j - 1];
                                t4 = result[j - 4];
                                t1 = s[t1];
                                t2 = s[t2];
                                t3 = s[t3];
                                t4 = s[t4];
                                t1 ^= r;
                                if ((r <<= 1) >= 256) r = (r ^ 0x1b) & 0xff;
                            }
                            for(let n = 0; n < 4; ++n){
                                result[j] = t1 ^= result[j - 32];
                                j++;
                                result[j] = t2 ^= result[j - 32];
                                j++;
                                result[j] = t3 ^= result[j - 32];
                                j++;
                                result[j] = t4 ^= result[j - 32];
                                j++;
                            }
                        }
                        return result;
                    }
                }
                exports.AES256Cipher = AES256Cipher;
                class PDF17 {
                    checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerValidationSalt, password.length);
                        hashData.set(userBytes, password.length + ownerValidationSalt.length);
                        const result = calculateSHA256(hashData, 0, hashData.length);
                        return (0, _util.isArrayEqual)(result, ownerPassword);
                    }
                    checkUserPassword(password, userValidationSalt, userPassword) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userValidationSalt, password.length);
                        const result = calculateSHA256(hashData, 0, hashData.length);
                        return (0, _util.isArrayEqual)(result, userPassword);
                    }
                    getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerKeySalt, password.length);
                        hashData.set(userBytes, password.length + ownerKeySalt.length);
                        const key = calculateSHA256(hashData, 0, hashData.length);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                    }
                    getUserKey(password, userKeySalt, userEncryption) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userKeySalt, password.length);
                        const key = calculateSHA256(hashData, 0, hashData.length);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                    }
                }
                exports.PDF17 = PDF17;
                class PDF20 {
                    _hash(password, input, userBytes) {
                        let k = calculateSHA256(input, 0, input.length).subarray(0, 32);
                        let e = [
                            0
                        ];
                        let i = 0;
                        while(i < 64 || e.at(-1) > i - 32){
                            const combinedLength = password.length + k.length + userBytes.length, combinedArray = new Uint8Array(combinedLength);
                            let writeOffset = 0;
                            combinedArray.set(password, writeOffset);
                            writeOffset += password.length;
                            combinedArray.set(k, writeOffset);
                            writeOffset += k.length;
                            combinedArray.set(userBytes, writeOffset);
                            const k1 = new Uint8Array(combinedLength * 64);
                            for(let j = 0, pos = 0; j < 64; j++, pos += combinedLength)k1.set(combinedArray, pos);
                            const cipher = new AES128Cipher(k.subarray(0, 16));
                            e = cipher.encrypt(k1, k.subarray(16, 32));
                            const remainder = e.slice(0, 16).reduce((a, b)=>a + b, 0) % 3;
                            if (remainder === 0) k = calculateSHA256(e, 0, e.length);
                            else if (remainder === 1) k = calculateSHA384(e, 0, e.length);
                            else if (remainder === 2) k = calculateSHA512(e, 0, e.length);
                            i++;
                        }
                        return k.subarray(0, 32);
                    }
                    checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerValidationSalt, password.length);
                        hashData.set(userBytes, password.length + ownerValidationSalt.length);
                        const result = this._hash(password, hashData, userBytes);
                        return (0, _util.isArrayEqual)(result, ownerPassword);
                    }
                    checkUserPassword(password, userValidationSalt, userPassword) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userValidationSalt, password.length);
                        const result = this._hash(password, hashData, []);
                        return (0, _util.isArrayEqual)(result, userPassword);
                    }
                    getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerKeySalt, password.length);
                        hashData.set(userBytes, password.length + ownerKeySalt.length);
                        const key = this._hash(password, hashData, userBytes);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                    }
                    getUserKey(password, userKeySalt, userEncryption) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userKeySalt, password.length);
                        const key = this._hash(password, hashData, []);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                    }
                }
                exports.PDF20 = PDF20;
                class CipherTransform {
                    constructor(stringCipherConstructor, streamCipherConstructor){
                        this.StringCipherConstructor = stringCipherConstructor;
                        this.StreamCipherConstructor = streamCipherConstructor;
                    }
                    createStream(stream, length) {
                        const cipher = new this.StreamCipherConstructor();
                        return new _decrypt_stream.DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
                            return cipher.decryptBlock(data, finalize);
                        });
                    }
                    decryptString(s) {
                        const cipher = new this.StringCipherConstructor();
                        let data = (0, _util.stringToBytes)(s);
                        data = cipher.decryptBlock(data, true);
                        return (0, _util.bytesToString)(data);
                    }
                    encryptString(s) {
                        const cipher = new this.StringCipherConstructor();
                        if (cipher instanceof AESBaseCipher) {
                            const strLen = s.length;
                            const pad = 16 - strLen % 16;
                            s += String.fromCharCode(pad).repeat(pad);
                            const iv = new Uint8Array(16);
                            if (typeof crypto !== "undefined") crypto.getRandomValues(iv);
                            else for(let i = 0; i < 16; i++)iv[i] = Math.floor(256 * Math.random());
                            let data = (0, _util.stringToBytes)(s);
                            data = cipher.encrypt(data, iv);
                            const buf = new Uint8Array(16 + data.length);
                            buf.set(iv);
                            buf.set(data, 16);
                            return (0, _util.bytesToString)(buf);
                        }
                        let data = (0, _util.stringToBytes)(s);
                        data = cipher.encrypt(data);
                        return (0, _util.bytesToString)(data);
                    }
                }
                class CipherTransformFactory {
                    static #defaultPasswordBytes = new Uint8Array([
                        0x28,
                        0xbf,
                        0x4e,
                        0x5e,
                        0x4e,
                        0x75,
                        0x8a,
                        0x41,
                        0x64,
                        0x00,
                        0x4e,
                        0x56,
                        0xff,
                        0xfa,
                        0x01,
                        0x08,
                        0x2e,
                        0x2e,
                        0x00,
                        0xb6,
                        0xd0,
                        0x68,
                        0x3e,
                        0x80,
                        0x2f,
                        0x0c,
                        0xa9,
                        0xfe,
                        0x64,
                        0x53,
                        0x69,
                        0x7a
                    ]);
                    #createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
                        if (password) {
                            const passwordLength = Math.min(127, password.length);
                            password = password.subarray(0, passwordLength);
                        } else password = [];
                        const pdfAlgorithm = revision === 6 ? new PDF20() : new PDF17();
                        if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
                        else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
                        return null;
                    }
                    #prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
                        const hashDataSize = 40 + ownerPassword.length + fileId.length;
                        const hashData = new Uint8Array(hashDataSize);
                        let i = 0, j, n;
                        if (password) {
                            n = Math.min(32, password.length);
                            for(; i < n; ++i)hashData[i] = password[i];
                        }
                        j = 0;
                        while(i < 32)hashData[i++] = CipherTransformFactory.#defaultPasswordBytes[j++];
                        for(j = 0, n = ownerPassword.length; j < n; ++j)hashData[i++] = ownerPassword[j];
                        hashData[i++] = flags & 0xff;
                        hashData[i++] = flags >> 8 & 0xff;
                        hashData[i++] = flags >> 16 & 0xff;
                        hashData[i++] = flags >>> 24 & 0xff;
                        for(j = 0, n = fileId.length; j < n; ++j)hashData[i++] = fileId[j];
                        if (revision >= 4 && !encryptMetadata) {
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                        }
                        let hash = calculateMD5(hashData, 0, i);
                        const keyLengthInBytes = keyLength >> 3;
                        if (revision >= 3) for(j = 0; j < 50; ++j)hash = calculateMD5(hash, 0, keyLengthInBytes);
                        const encryptionKey = hash.subarray(0, keyLengthInBytes);
                        let cipher, checkData;
                        if (revision >= 3) {
                            for(i = 0; i < 32; ++i)hashData[i] = CipherTransformFactory.#defaultPasswordBytes[i];
                            for(j = 0, n = fileId.length; j < n; ++j)hashData[i++] = fileId[j];
                            cipher = new ARCFourCipher(encryptionKey);
                            checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
                            n = encryptionKey.length;
                            const derivedKey = new Uint8Array(n);
                            for(j = 1; j <= 19; ++j){
                                for(let k = 0; k < n; ++k)derivedKey[k] = encryptionKey[k] ^ j;
                                cipher = new ARCFourCipher(derivedKey);
                                checkData = cipher.encryptBlock(checkData);
                            }
                            for(j = 0, n = checkData.length; j < n; ++j){
                                if (userPassword[j] !== checkData[j]) return null;
                            }
                        } else {
                            cipher = new ARCFourCipher(encryptionKey);
                            checkData = cipher.encryptBlock(CipherTransformFactory.#defaultPasswordBytes);
                            for(j = 0, n = checkData.length; j < n; ++j){
                                if (userPassword[j] !== checkData[j]) return null;
                            }
                        }
                        return encryptionKey;
                    }
                    #decodeUserPassword(password, ownerPassword, revision, keyLength) {
                        const hashData = new Uint8Array(32);
                        let i = 0;
                        const n = Math.min(32, password.length);
                        for(; i < n; ++i)hashData[i] = password[i];
                        let j = 0;
                        while(i < 32)hashData[i++] = CipherTransformFactory.#defaultPasswordBytes[j++];
                        let hash = calculateMD5(hashData, 0, i);
                        const keyLengthInBytes = keyLength >> 3;
                        if (revision >= 3) for(j = 0; j < 50; ++j)hash = calculateMD5(hash, 0, hash.length);
                        let cipher, userPassword;
                        if (revision >= 3) {
                            userPassword = ownerPassword;
                            const derivedKey = new Uint8Array(keyLengthInBytes);
                            for(j = 19; j >= 0; j--){
                                for(let k = 0; k < keyLengthInBytes; ++k)derivedKey[k] = hash[k] ^ j;
                                cipher = new ARCFourCipher(derivedKey);
                                userPassword = cipher.encryptBlock(userPassword);
                            }
                        } else {
                            cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
                            userPassword = cipher.encryptBlock(ownerPassword);
                        }
                        return userPassword;
                    }
                    #buildObjectKey(num, gen, encryptionKey, isAes = false) {
                        const key = new Uint8Array(encryptionKey.length + 9);
                        const n = encryptionKey.length;
                        let i;
                        for(i = 0; i < n; ++i)key[i] = encryptionKey[i];
                        key[i++] = num & 0xff;
                        key[i++] = num >> 8 & 0xff;
                        key[i++] = num >> 16 & 0xff;
                        key[i++] = gen & 0xff;
                        key[i++] = gen >> 8 & 0xff;
                        if (isAes) {
                            key[i++] = 0x73;
                            key[i++] = 0x41;
                            key[i++] = 0x6c;
                            key[i++] = 0x54;
                        }
                        const hash = calculateMD5(key, 0, i);
                        return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
                    }
                    #buildCipherConstructor(cf, name, num, gen, key) {
                        if (!(name instanceof _primitives.Name)) throw new _util.FormatError("Invalid crypt filter name.");
                        const self1 = this;
                        const cryptFilter = cf.get(name.name);
                        const cfm = cryptFilter?.get("CFM");
                        if (!cfm || cfm.name === "None") return function() {
                            return new NullCipher();
                        };
                        if (cfm.name === "V2") return function() {
                            return new ARCFourCipher(self1.#buildObjectKey(num, gen, key, false));
                        };
                        if (cfm.name === "AESV2") return function() {
                            return new AES128Cipher(self1.#buildObjectKey(num, gen, key, true));
                        };
                        if (cfm.name === "AESV3") return function() {
                            return new AES256Cipher(key);
                        };
                        throw new _util.FormatError("Unknown crypto method");
                    }
                    constructor(dict, fileId, password){
                        const filter = dict.get("Filter");
                        if (!(0, _primitives.isName)(filter, "Standard")) throw new _util.FormatError("unknown encryption method");
                        this.filterName = filter.name;
                        this.dict = dict;
                        const algorithm = dict.get("V");
                        if (!Number.isInteger(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) throw new _util.FormatError("unsupported encryption algorithm");
                        this.algorithm = algorithm;
                        let keyLength = dict.get("Length");
                        if (!keyLength) {
                            if (algorithm <= 3) keyLength = 40;
                            else {
                                const cfDict = dict.get("CF");
                                const streamCryptoName = dict.get("StmF");
                                if (cfDict instanceof _primitives.Dict && streamCryptoName instanceof _primitives.Name) {
                                    cfDict.suppressEncryption = true;
                                    const handlerDict = cfDict.get(streamCryptoName.name);
                                    keyLength = handlerDict?.get("Length") || 128;
                                    if (keyLength < 40) keyLength <<= 3;
                                }
                            }
                        }
                        if (!Number.isInteger(keyLength) || keyLength < 40 || keyLength % 8 !== 0) throw new _util.FormatError("invalid key length");
                        const ownerBytes = (0, _util.stringToBytes)(dict.get("O")), userBytes = (0, _util.stringToBytes)(dict.get("U"));
                        const ownerPassword = ownerBytes.subarray(0, 32);
                        const userPassword = userBytes.subarray(0, 32);
                        const flags = dict.get("P");
                        const revision = dict.get("R");
                        const encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get("EncryptMetadata") !== false;
                        this.encryptMetadata = encryptMetadata;
                        const fileIdBytes = (0, _util.stringToBytes)(fileId);
                        let passwordBytes;
                        if (password) {
                            if (revision === 6) try {
                                password = (0, _util.utf8StringToString)(password);
                            } catch  {
                                (0, _util.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                            }
                            passwordBytes = (0, _util.stringToBytes)(password);
                        }
                        let encryptionKey;
                        if (algorithm !== 5) encryptionKey = this.#prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                        else {
                            const ownerValidationSalt = ownerBytes.subarray(32, 40);
                            const ownerKeySalt = ownerBytes.subarray(40, 48);
                            const uBytes = userBytes.subarray(0, 48);
                            const userValidationSalt = userBytes.subarray(32, 40);
                            const userKeySalt = userBytes.subarray(40, 48);
                            const ownerEncryption = (0, _util.stringToBytes)(dict.get("OE"));
                            const userEncryption = (0, _util.stringToBytes)(dict.get("UE"));
                            const perms = (0, _util.stringToBytes)(dict.get("Perms"));
                            encryptionKey = this.#createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
                        }
                        if (!encryptionKey && !password) throw new _util.PasswordException("No password given", _util.PasswordResponses.NEED_PASSWORD);
                        else if (!encryptionKey && password) {
                            const decodedPassword = this.#decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
                            encryptionKey = this.#prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                        }
                        if (!encryptionKey) throw new _util.PasswordException("Incorrect Password", _util.PasswordResponses.INCORRECT_PASSWORD);
                        this.encryptionKey = encryptionKey;
                        if (algorithm >= 4) {
                            const cf = dict.get("CF");
                            if (cf instanceof _primitives.Dict) cf.suppressEncryption = true;
                            this.cf = cf;
                            this.stmf = dict.get("StmF") || _primitives.Name.get("Identity");
                            this.strf = dict.get("StrF") || _primitives.Name.get("Identity");
                            this.eff = dict.get("EFF") || this.stmf;
                        }
                    }
                    createCipherTransform(num, gen) {
                        if (this.algorithm === 4 || this.algorithm === 5) return new CipherTransform(this.#buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey), this.#buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey));
                        const key = this.#buildObjectKey(num, gen, this.encryptionKey, false);
                        const cipherConstructor = function() {
                            return new ARCFourCipher(key);
                        };
                        return new CipherTransform(cipherConstructor, cipherConstructor);
                    }
                }
                exports.CipherTransformFactory = CipherTransformFactory;
            /***/ },
            /* 75 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DecryptStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                const chunkSize = 512;
                class DecryptStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, decrypt){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.decrypt = decrypt;
                        this.nextChunk = null;
                        this.initialized = false;
                    }
                    readBlock() {
                        let chunk;
                        if (this.initialized) chunk = this.nextChunk;
                        else {
                            chunk = this.str.getBytes(chunkSize);
                            this.initialized = true;
                        }
                        if (!chunk || chunk.length === 0) {
                            this.eof = true;
                            return;
                        }
                        this.nextChunk = this.str.getBytes(chunkSize);
                        const hasMoreData = this.nextChunk?.length > 0;
                        const decrypt = this.decrypt;
                        chunk = decrypt(chunk, !hasMoreData);
                        const bufferLength = this.bufferLength, newLength = bufferLength + chunk.length, buffer = this.ensureBuffer(newLength);
                        buffer.set(chunk, bufferLength);
                        this.bufferLength = newLength;
                    }
                }
                exports.DecryptStream = DecryptStream;
            /***/ },
            /* 76 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ObjectLoader = void 0;
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                function mayHaveChildren(value) {
                    return value instanceof _primitives.Ref || value instanceof _primitives.Dict || value instanceof _base_stream.BaseStream || Array.isArray(value);
                }
                function addChildren(node, nodesToVisit) {
                    if (node instanceof _primitives.Dict) node = node.getRawValues();
                    else if (node instanceof _base_stream.BaseStream) node = node.dict.getRawValues();
                    else if (!Array.isArray(node)) return;
                    for (const rawValue of node)if (mayHaveChildren(rawValue)) nodesToVisit.push(rawValue);
                }
                class ObjectLoader {
                    constructor(dict, keys, xref){
                        this.dict = dict;
                        this.keys = keys;
                        this.xref = xref;
                        this.refSet = null;
                    }
                    async load() {
                        if (this.xref.stream.isDataLoaded) return undefined;
                        const { keys: keys, dict: dict } = this;
                        this.refSet = new _primitives.RefSet();
                        const nodesToVisit = [];
                        for (const key of keys){
                            const rawValue = dict.getRaw(key);
                            if (rawValue !== undefined) nodesToVisit.push(rawValue);
                        }
                        return this._walk(nodesToVisit);
                    }
                    async _walk(nodesToVisit) {
                        const nodesToRevisit = [];
                        const pendingRequests = [];
                        while(nodesToVisit.length){
                            let currentNode = nodesToVisit.pop();
                            if (currentNode instanceof _primitives.Ref) {
                                if (this.refSet.has(currentNode)) continue;
                                try {
                                    this.refSet.put(currentNode);
                                    currentNode = this.xref.fetch(currentNode);
                                } catch (ex) {
                                    if (!(ex instanceof _core_utils.MissingDataException)) {
                                        (0, _util.warn)(`ObjectLoader._walk - requesting all data: "${ex}".`);
                                        this.refSet = null;
                                        const { manager: manager } = this.xref.stream;
                                        return manager.requestAllChunks();
                                    }
                                    nodesToRevisit.push(currentNode);
                                    pendingRequests.push({
                                        begin: ex.begin,
                                        end: ex.end
                                    });
                                }
                            }
                            if (currentNode instanceof _base_stream.BaseStream) {
                                const baseStreams = currentNode.getBaseStreams();
                                if (baseStreams) {
                                    let foundMissingData = false;
                                    for (const stream of baseStreams){
                                        if (stream.isDataLoaded) continue;
                                        foundMissingData = true;
                                        pendingRequests.push({
                                            begin: stream.start,
                                            end: stream.end
                                        });
                                    }
                                    if (foundMissingData) nodesToRevisit.push(currentNode);
                                }
                            }
                            addChildren(currentNode, nodesToVisit);
                        }
                        if (pendingRequests.length) {
                            await this.xref.stream.manager.requestRanges(pendingRequests);
                            for (const node of nodesToRevisit)if (node instanceof _primitives.Ref) this.refSet.remove(node);
                            return this._walk(nodesToRevisit);
                        }
                        this.refSet = null;
                        return undefined;
                    }
                }
                exports.ObjectLoader = ObjectLoader;
            /***/ },
            /* 77 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XFAFactory = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _bind = __w_pdfjs_require__(79);
                var _data = __w_pdfjs_require__(89);
                var _fonts = __w_pdfjs_require__(85);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                var _parser = __w_pdfjs_require__(90);
                var _xhtml = __w_pdfjs_require__(100);
                class XFAFactory {
                    constructor(data){
                        try {
                            this.root = new _parser.XFAParser().parse(XFAFactory._createDocument(data));
                            const binder = new _bind.Binder(this.root);
                            this.form = binder.bind();
                            this.dataHandler = new _data.DataHandler(this.root, binder.getData());
                            this.form[_symbol_utils.$globalData].template = this.form;
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during parsing and binding: ${e}`);
                        }
                    }
                    isValid() {
                        return this.root && this.form;
                    }
                    _createPagesHelper() {
                        const iterator = this.form[_symbol_utils.$toPages]();
                        return new Promise((resolve, reject)=>{
                            const nextIteration = ()=>{
                                try {
                                    const value = iterator.next();
                                    if (value.done) resolve(value.value);
                                    else setTimeout(nextIteration, 0);
                                } catch (e) {
                                    reject(e);
                                }
                            };
                            setTimeout(nextIteration, 0);
                        });
                    }
                    async _createPages() {
                        try {
                            this.pages = await this._createPagesHelper();
                            this.dims = this.pages.children.map((c)=>{
                                const { width: width, height: height } = c.attributes.style;
                                return [
                                    0,
                                    0,
                                    parseInt(width),
                                    parseInt(height)
                                ];
                            });
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during layout: ${e}`);
                        }
                    }
                    getBoundingBox(pageIndex) {
                        return this.dims[pageIndex];
                    }
                    async getNumPages() {
                        if (!this.pages) await this._createPages();
                        return this.dims.length;
                    }
                    setImages(images) {
                        this.form[_symbol_utils.$globalData].images = images;
                    }
                    setFonts(fonts) {
                        this.form[_symbol_utils.$globalData].fontFinder = new _fonts.FontFinder(fonts);
                        const missingFonts = [];
                        for (let typeface of this.form[_symbol_utils.$globalData].usedTypefaces){
                            typeface = (0, _utils.stripQuotes)(typeface);
                            const font1 = this.form[_symbol_utils.$globalData].fontFinder.find(typeface);
                            if (!font1) missingFonts.push(typeface);
                        }
                        if (missingFonts.length > 0) return missingFonts;
                        return null;
                    }
                    appendFonts(fonts, reallyMissingFonts) {
                        this.form[_symbol_utils.$globalData].fontFinder.add(fonts, reallyMissingFonts);
                    }
                    async getPages() {
                        if (!this.pages) await this._createPages();
                        const pages = this.pages;
                        this.pages = null;
                        return pages;
                    }
                    serializeData(storage) {
                        return this.dataHandler.serialize(storage);
                    }
                    static _createDocument(data) {
                        if (!data["/xdp:xdp"]) return data["xdp:xdp"];
                        return Object.values(data).join("");
                    }
                    static getRichTextAsHtml(rc) {
                        if (!rc || typeof rc !== "string") return null;
                        try {
                            let root = new _parser.XFAParser(_xhtml.XhtmlNamespace, true).parse(rc);
                            if (![
                                "body",
                                "xhtml"
                            ].includes(root[_symbol_utils.$nodeName])) {
                                const newRoot = _xhtml.XhtmlNamespace.body({});
                                newRoot[_symbol_utils.$appendChild](root);
                                root = newRoot;
                            }
                            const result = root[_symbol_utils.$toHTML]();
                            if (!result.success) return null;
                            const { html: html } = result;
                            const { attributes: attributes } = html;
                            if (attributes) {
                                if (attributes.class) attributes.class = attributes.class.filter((attr)=>!attr.startsWith("xfa"));
                                attributes.dir = "auto";
                            }
                            return {
                                html: html,
                                str: root[_symbol_utils.$text]()
                            };
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during parsing of rich text: ${e}`);
                        }
                        return null;
                    }
                }
                exports.XFAFactory = XFAFactory;
            /***/ },
            /* 78 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.$uid = exports.$toStyle = exports.$toString = exports.$toPages = exports.$toHTML = exports.$text = exports.$tabIndex = exports.$setValue = exports.$setSetAttributes = exports.$setId = exports.$searchNode = exports.$root = exports.$resolvePrototypes = exports.$removeChild = exports.$pushPara = exports.$pushGlyphs = exports.$popPara = exports.$onText = exports.$onChildCheck = exports.$onChild = exports.$nsAttributes = exports.$nodeName = exports.$namespaceId = exports.$lastAttribute = exports.$isUsable = exports.$isTransparent = exports.$isThereMoreWidth = exports.$isSplittable = exports.$isNsAgnostic = exports.$isDescendent = exports.$isDataValue = exports.$isCDATAXml = exports.$isBindable = exports.$insertAt = exports.$indexOf = exports.$ids = exports.$hasSettableValue = exports.$globalData = exports.$getTemplateRoot = exports.$getSubformParent = exports.$getRealChildrenByNameIt = exports.$getParent = exports.$getNextPage = exports.$getExtra = exports.$getDataValue = exports.$getContainedChildren = exports.$getChildrenByNameIt = exports.$getChildrenByName = exports.$getChildrenByClass = exports.$getChildren = exports.$getAvailableSpace = exports.$getAttributes = exports.$getAttributeIt = exports.$flushHTML = exports.$finalize = exports.$extra = exports.$dump = exports.$data = exports.$content = exports.$consumed = exports.$clone = exports.$cleanup = exports.$cleanPage = exports.$clean = exports.$childrenToHTML = exports.$appendChild = exports.$addHTML = exports.$acceptWhitespace = void 0;
                const $acceptWhitespace = Symbol();
                exports.$acceptWhitespace = $acceptWhitespace;
                const $addHTML = Symbol();
                exports.$addHTML = $addHTML;
                const $appendChild = Symbol();
                exports.$appendChild = $appendChild;
                const $childrenToHTML = Symbol();
                exports.$childrenToHTML = $childrenToHTML;
                const $clean = Symbol();
                exports.$clean = $clean;
                const $cleanPage = Symbol();
                exports.$cleanPage = $cleanPage;
                const $cleanup = Symbol();
                exports.$cleanup = $cleanup;
                const $clone = Symbol();
                exports.$clone = $clone;
                const $consumed = Symbol();
                exports.$consumed = $consumed;
                const $content = Symbol("content");
                exports.$content = $content;
                const $data = Symbol("data");
                exports.$data = $data;
                const $dump = Symbol();
                exports.$dump = $dump;
                const $extra = Symbol("extra");
                exports.$extra = $extra;
                const $finalize = Symbol();
                exports.$finalize = $finalize;
                const $flushHTML = Symbol();
                exports.$flushHTML = $flushHTML;
                const $getAttributeIt = Symbol();
                exports.$getAttributeIt = $getAttributeIt;
                const $getAttributes = Symbol();
                exports.$getAttributes = $getAttributes;
                const $getAvailableSpace = Symbol();
                exports.$getAvailableSpace = $getAvailableSpace;
                const $getChildrenByClass = Symbol();
                exports.$getChildrenByClass = $getChildrenByClass;
                const $getChildrenByName = Symbol();
                exports.$getChildrenByName = $getChildrenByName;
                const $getChildrenByNameIt = Symbol();
                exports.$getChildrenByNameIt = $getChildrenByNameIt;
                const $getDataValue = Symbol();
                exports.$getDataValue = $getDataValue;
                const $getExtra = Symbol();
                exports.$getExtra = $getExtra;
                const $getRealChildrenByNameIt = Symbol();
                exports.$getRealChildrenByNameIt = $getRealChildrenByNameIt;
                const $getChildren = Symbol();
                exports.$getChildren = $getChildren;
                const $getContainedChildren = Symbol();
                exports.$getContainedChildren = $getContainedChildren;
                const $getNextPage = Symbol();
                exports.$getNextPage = $getNextPage;
                const $getSubformParent = Symbol();
                exports.$getSubformParent = $getSubformParent;
                const $getParent = Symbol();
                exports.$getParent = $getParent;
                const $getTemplateRoot = Symbol();
                exports.$getTemplateRoot = $getTemplateRoot;
                const $globalData = Symbol();
                exports.$globalData = $globalData;
                const $hasSettableValue = Symbol();
                exports.$hasSettableValue = $hasSettableValue;
                const $ids = Symbol();
                exports.$ids = $ids;
                const $indexOf = Symbol();
                exports.$indexOf = $indexOf;
                const $insertAt = Symbol();
                exports.$insertAt = $insertAt;
                const $isCDATAXml = Symbol();
                exports.$isCDATAXml = $isCDATAXml;
                const $isBindable = Symbol();
                exports.$isBindable = $isBindable;
                const $isDataValue = Symbol();
                exports.$isDataValue = $isDataValue;
                const $isDescendent = Symbol();
                exports.$isDescendent = $isDescendent;
                const $isNsAgnostic = Symbol();
                exports.$isNsAgnostic = $isNsAgnostic;
                const $isSplittable = Symbol();
                exports.$isSplittable = $isSplittable;
                const $isThereMoreWidth = Symbol();
                exports.$isThereMoreWidth = $isThereMoreWidth;
                const $isTransparent = Symbol();
                exports.$isTransparent = $isTransparent;
                const $isUsable = Symbol();
                exports.$isUsable = $isUsable;
                const $lastAttribute = Symbol();
                exports.$lastAttribute = $lastAttribute;
                const $namespaceId = Symbol("namespaceId");
                exports.$namespaceId = $namespaceId;
                const $nodeName = Symbol("nodeName");
                exports.$nodeName = $nodeName;
                const $nsAttributes = Symbol();
                exports.$nsAttributes = $nsAttributes;
                const $onChild = Symbol();
                exports.$onChild = $onChild;
                const $onChildCheck = Symbol();
                exports.$onChildCheck = $onChildCheck;
                const $onText = Symbol();
                exports.$onText = $onText;
                const $pushGlyphs = Symbol();
                exports.$pushGlyphs = $pushGlyphs;
                const $popPara = Symbol();
                exports.$popPara = $popPara;
                const $pushPara = Symbol();
                exports.$pushPara = $pushPara;
                const $removeChild = Symbol();
                exports.$removeChild = $removeChild;
                const $root = Symbol("root");
                exports.$root = $root;
                const $resolvePrototypes = Symbol();
                exports.$resolvePrototypes = $resolvePrototypes;
                const $searchNode = Symbol();
                exports.$searchNode = $searchNode;
                const $setId = Symbol();
                exports.$setId = $setId;
                const $setSetAttributes = Symbol();
                exports.$setSetAttributes = $setSetAttributes;
                const $setValue = Symbol();
                exports.$setValue = $setValue;
                const $tabIndex = Symbol();
                exports.$tabIndex = $tabIndex;
                const $text = Symbol();
                exports.$text = $text;
                const $toPages = Symbol();
                exports.$toPages = $toPages;
                const $toHTML = Symbol();
                exports.$toHTML = $toHTML;
                const $toString = Symbol();
                exports.$toString = $toString;
                const $toStyle = Symbol();
                exports.$toStyle = $toStyle;
                const $uid = Symbol("uid");
                exports.$uid = $uid;
            /***/ },
            /* 79 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Binder = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _template = __w_pdfjs_require__(80);
                var _som = __w_pdfjs_require__(88);
                var _xfa_object = __w_pdfjs_require__(87);
                var _namespaces = __w_pdfjs_require__(81);
                var _util = __w_pdfjs_require__(2);
                const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
                function createText(content) {
                    const node = new _template.Text({});
                    node[_symbol_utils.$content] = content;
                    return node;
                }
                class Binder {
                    constructor(root){
                        this.root = root;
                        this.datasets = root.datasets;
                        this.data = root.datasets?.data || new _xfa_object.XmlObject(_namespaces.NamespaceIds.datasets.id, "data");
                        this.emptyMerge = this.data[_symbol_utils.$getChildren]().length === 0;
                        this.root.form = this.form = root.template[_symbol_utils.$clone]();
                    }
                    _isConsumeData() {
                        return !this.emptyMerge && this._mergeMode;
                    }
                    _isMatchTemplate() {
                        return !this._isConsumeData();
                    }
                    bind() {
                        this._bindElement(this.form, this.data);
                        return this.form;
                    }
                    getData() {
                        return this.data;
                    }
                    _bindValue(formNode, data, picture) {
                        formNode[_symbol_utils.$data] = data;
                        if (formNode[_symbol_utils.$hasSettableValue]()) {
                            if (data[_symbol_utils.$isDataValue]()) {
                                const value = data[_symbol_utils.$getDataValue]();
                                formNode[_symbol_utils.$setValue](createText(value));
                            } else if (formNode instanceof _template.Field && formNode.ui?.choiceList?.open === "multiSelect") {
                                const value = data[_symbol_utils.$getChildren]().map((child)=>child[_symbol_utils.$content].trim()).join("\n");
                                formNode[_symbol_utils.$setValue](createText(value));
                            } else if (this._isConsumeData()) (0, _util.warn)(`XFA - Nodes haven't the same type.`);
                        } else if (!data[_symbol_utils.$isDataValue]() || this._isMatchTemplate()) this._bindElement(formNode, data);
                        else (0, _util.warn)(`XFA - Nodes haven't the same type.`);
                    }
                    _findDataByNameToConsume(name, isValue, dataNode, global) {
                        if (!name) return null;
                        let generator, match;
                        for(let i = 0; i < 3; i++){
                            generator = dataNode[_symbol_utils.$getRealChildrenByNameIt](name, false, true);
                            while(true){
                                match = generator.next().value;
                                if (!match) break;
                                if (isValue === match[_symbol_utils.$isDataValue]()) return match;
                            }
                            if (dataNode[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.datasets.id && dataNode[_symbol_utils.$nodeName] === "data") break;
                            dataNode = dataNode[_symbol_utils.$getParent]();
                        }
                        if (!global) return null;
                        generator = this.data[_symbol_utils.$getRealChildrenByNameIt](name, true, false);
                        match = generator.next().value;
                        if (match) return match;
                        generator = this.data[_symbol_utils.$getAttributeIt](name, true);
                        match = generator.next().value;
                        if (match?.[_symbol_utils.$isDataValue]()) return match;
                        return null;
                    }
                    _setProperties(formNode, dataNode) {
                        if (!formNode.hasOwnProperty("setProperty")) return;
                        for (const { ref: ref, target: target, connection: connection } of formNode.setProperty.children){
                            if (connection) continue;
                            if (!ref) continue;
                            const nodes = (0, _som.searchNode)(this.root, dataNode, ref, false, false);
                            if (!nodes) {
                                (0, _util.warn)(`XFA - Invalid reference: ${ref}.`);
                                continue;
                            }
                            const [node] = nodes;
                            if (!node[_symbol_utils.$isDescendent](this.data)) {
                                (0, _util.warn)(`XFA - Invalid node: must be a data node.`);
                                continue;
                            }
                            const targetNodes = (0, _som.searchNode)(this.root, formNode, target, false, false);
                            if (!targetNodes) {
                                (0, _util.warn)(`XFA - Invalid target: ${target}.`);
                                continue;
                            }
                            const [targetNode] = targetNodes;
                            if (!targetNode[_symbol_utils.$isDescendent](formNode)) {
                                (0, _util.warn)(`XFA - Invalid target: must be a property or subproperty.`);
                                continue;
                            }
                            const targetParent = targetNode[_symbol_utils.$getParent]();
                            if (targetNode instanceof _template.SetProperty || targetParent instanceof _template.SetProperty) {
                                (0, _util.warn)(`XFA - Invalid target: cannot be a setProperty or one of its properties.`);
                                continue;
                            }
                            if (targetNode instanceof _template.BindItems || targetParent instanceof _template.BindItems) {
                                (0, _util.warn)(`XFA - Invalid target: cannot be a bindItems or one of its properties.`);
                                continue;
                            }
                            const content = node[_symbol_utils.$text]();
                            const name = targetNode[_symbol_utils.$nodeName];
                            if (targetNode instanceof _xfa_object.XFAAttribute) {
                                const attrs = Object.create(null);
                                attrs[name] = content;
                                const obj = Reflect.construct(Object.getPrototypeOf(targetParent).constructor, [
                                    attrs
                                ]);
                                targetParent[name] = obj[name];
                                continue;
                            }
                            if (!targetNode.hasOwnProperty(_symbol_utils.$content)) {
                                (0, _util.warn)(`XFA - Invalid node to use in setProperty`);
                                continue;
                            }
                            targetNode[_symbol_utils.$data] = node;
                            targetNode[_symbol_utils.$content] = content;
                            targetNode[_symbol_utils.$finalize]();
                        }
                    }
                    _bindItems(formNode, dataNode) {
                        if (!formNode.hasOwnProperty("items") || !formNode.hasOwnProperty("bindItems") || formNode.bindItems.isEmpty()) return;
                        for (const item of formNode.items.children)formNode[_symbol_utils.$removeChild](item);
                        formNode.items.clear();
                        const labels = new _template.Items({});
                        const values = new _template.Items({});
                        formNode[_symbol_utils.$appendChild](labels);
                        formNode.items.push(labels);
                        formNode[_symbol_utils.$appendChild](values);
                        formNode.items.push(values);
                        for (const { ref: ref, labelRef: labelRef, valueRef: valueRef, connection: connection } of formNode.bindItems.children){
                            if (connection) continue;
                            if (!ref) continue;
                            const nodes = (0, _som.searchNode)(this.root, dataNode, ref, false, false);
                            if (!nodes) {
                                (0, _util.warn)(`XFA - Invalid reference: ${ref}.`);
                                continue;
                            }
                            for (const node of nodes){
                                if (!node[_symbol_utils.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid ref (${ref}): must be a datasets child.`);
                                    continue;
                                }
                                const labelNodes = (0, _som.searchNode)(this.root, node, labelRef, true, false);
                                if (!labelNodes) {
                                    (0, _util.warn)(`XFA - Invalid label: ${labelRef}.`);
                                    continue;
                                }
                                const [labelNode] = labelNodes;
                                if (!labelNode[_symbol_utils.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid label: must be a datasets child.`);
                                    continue;
                                }
                                const valueNodes = (0, _som.searchNode)(this.root, node, valueRef, true, false);
                                if (!valueNodes) {
                                    (0, _util.warn)(`XFA - Invalid value: ${valueRef}.`);
                                    continue;
                                }
                                const [valueNode] = valueNodes;
                                if (!valueNode[_symbol_utils.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid value: must be a datasets child.`);
                                    continue;
                                }
                                const label = createText(labelNode[_symbol_utils.$text]());
                                const value = createText(valueNode[_symbol_utils.$text]());
                                labels[_symbol_utils.$appendChild](label);
                                labels.text.push(label);
                                values[_symbol_utils.$appendChild](value);
                                values.text.push(value);
                            }
                        }
                    }
                    _bindOccurrences(formNode, matches, picture) {
                        let baseClone;
                        if (matches.length > 1) {
                            baseClone = formNode[_symbol_utils.$clone]();
                            baseClone[_symbol_utils.$removeChild](baseClone.occur);
                            baseClone.occur = null;
                        }
                        this._bindValue(formNode, matches[0], picture);
                        this._setProperties(formNode, matches[0]);
                        this._bindItems(formNode, matches[0]);
                        if (matches.length === 1) return;
                        const parent = formNode[_symbol_utils.$getParent]();
                        const name = formNode[_symbol_utils.$nodeName];
                        const pos = parent[_symbol_utils.$indexOf](formNode);
                        for(let i = 1, ii = matches.length; i < ii; i++){
                            const match = matches[i];
                            const clone = baseClone[_symbol_utils.$clone]();
                            parent[name].push(clone);
                            parent[_symbol_utils.$insertAt](pos + i, clone);
                            this._bindValue(clone, match, picture);
                            this._setProperties(clone, match);
                            this._bindItems(clone, match);
                        }
                    }
                    _createOccurrences(formNode) {
                        if (!this.emptyMerge) return;
                        const { occur: occur } = formNode;
                        if (!occur || occur.initial <= 1) return;
                        const parent = formNode[_symbol_utils.$getParent]();
                        const name = formNode[_symbol_utils.$nodeName];
                        if (!(parent[name] instanceof _xfa_object.XFAObjectArray)) return;
                        let currentNumber;
                        if (formNode.name) currentNumber = parent[name].children.filter((e)=>e.name === formNode.name).length;
                        else currentNumber = parent[name].children.length;
                        const pos = parent[_symbol_utils.$indexOf](formNode) + 1;
                        const ii = occur.initial - currentNumber;
                        if (ii) {
                            const nodeClone = formNode[_symbol_utils.$clone]();
                            nodeClone[_symbol_utils.$removeChild](nodeClone.occur);
                            nodeClone.occur = null;
                            parent[name].push(nodeClone);
                            parent[_symbol_utils.$insertAt](pos, nodeClone);
                            for(let i = 1; i < ii; i++){
                                const clone = nodeClone[_symbol_utils.$clone]();
                                parent[name].push(clone);
                                parent[_symbol_utils.$insertAt](pos + i, clone);
                            }
                        }
                    }
                    _getOccurInfo(formNode) {
                        const { name: name, occur: occur } = formNode;
                        if (!occur || !name) return [
                            1,
                            1
                        ];
                        const max = occur.max === -1 ? Infinity : occur.max;
                        return [
                            occur.min,
                            max
                        ];
                    }
                    _setAndBind(formNode, dataNode) {
                        this._setProperties(formNode, dataNode);
                        this._bindItems(formNode, dataNode);
                        this._bindElement(formNode, dataNode);
                    }
                    _bindElement(formNode, dataNode) {
                        const uselessNodes = [];
                        this._createOccurrences(formNode);
                        for (const child of formNode[_symbol_utils.$getChildren]()){
                            if (child[_symbol_utils.$data]) continue;
                            if (this._mergeMode === undefined && child[_symbol_utils.$nodeName] === "subform") {
                                this._mergeMode = child.mergeMode === "consumeData";
                                const dataChildren = dataNode[_symbol_utils.$getChildren]();
                                if (dataChildren.length > 0) this._bindOccurrences(child, [
                                    dataChildren[0]
                                ], null);
                                else if (this.emptyMerge) {
                                    const nsId = dataNode[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : dataNode[_symbol_utils.$namespaceId];
                                    const dataChild = child[_symbol_utils.$data] = new _xfa_object.XmlObject(nsId, child.name || "root");
                                    dataNode[_symbol_utils.$appendChild](dataChild);
                                    this._bindElement(child, dataChild);
                                }
                                continue;
                            }
                            if (!child[_symbol_utils.$isBindable]()) continue;
                            let global = false;
                            let picture = null;
                            let ref = null;
                            let match = null;
                            if (child.bind) {
                                switch(child.bind.match){
                                    case "none":
                                        this._setAndBind(child, dataNode);
                                        continue;
                                    case "global":
                                        global = true;
                                        break;
                                    case "dataRef":
                                        if (!child.bind.ref) {
                                            (0, _util.warn)(`XFA - ref is empty in node ${child[_symbol_utils.$nodeName]}.`);
                                            this._setAndBind(child, dataNode);
                                            continue;
                                        }
                                        ref = child.bind.ref;
                                        break;
                                    default:
                                        break;
                                }
                                if (child.bind.picture) picture = child.bind.picture[_symbol_utils.$content];
                            }
                            const [min, max] = this._getOccurInfo(child);
                            if (ref) {
                                match = (0, _som.searchNode)(this.root, dataNode, ref, true, false);
                                if (match === null) {
                                    match = (0, _som.createDataNode)(this.data, dataNode, ref);
                                    if (!match) continue;
                                    if (this._isConsumeData()) match[_symbol_utils.$consumed] = true;
                                    this._setAndBind(child, match);
                                    continue;
                                } else {
                                    if (this._isConsumeData()) match = match.filter((node)=>!node[_symbol_utils.$consumed]);
                                    if (match.length > max) match = match.slice(0, max);
                                    else if (match.length === 0) match = null;
                                    if (match && this._isConsumeData()) match.forEach((node)=>{
                                        node[_symbol_utils.$consumed] = true;
                                    });
                                }
                            } else {
                                if (!child.name) {
                                    this._setAndBind(child, dataNode);
                                    continue;
                                }
                                if (this._isConsumeData()) {
                                    const matches = [];
                                    while(matches.length < max){
                                        const found = this._findDataByNameToConsume(child.name, child[_symbol_utils.$hasSettableValue](), dataNode, global);
                                        if (!found) break;
                                        found[_symbol_utils.$consumed] = true;
                                        matches.push(found);
                                    }
                                    match = matches.length > 0 ? matches : null;
                                } else {
                                    match = dataNode[_symbol_utils.$getRealChildrenByNameIt](child.name, false, this.emptyMerge).next().value;
                                    if (!match) {
                                        if (min === 0) {
                                            uselessNodes.push(child);
                                            continue;
                                        }
                                        const nsId = dataNode[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : dataNode[_symbol_utils.$namespaceId];
                                        match = child[_symbol_utils.$data] = new _xfa_object.XmlObject(nsId, child.name);
                                        if (this.emptyMerge) match[_symbol_utils.$consumed] = true;
                                        dataNode[_symbol_utils.$appendChild](match);
                                        this._setAndBind(child, match);
                                        continue;
                                    }
                                    if (this.emptyMerge) match[_symbol_utils.$consumed] = true;
                                    match = [
                                        match
                                    ];
                                }
                            }
                            if (match) this._bindOccurrences(child, match, picture);
                            else if (min > 0) this._setAndBind(child, dataNode);
                            else uselessNodes.push(child);
                        }
                        uselessNodes.forEach((node)=>node[_symbol_utils.$getParent]()[_symbol_utils.$removeChild](node));
                    }
                }
                exports.Binder = Binder;
            /***/ },
            /* 80 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Value = exports.Text = exports.TemplateNamespace = exports.Template = exports.SetProperty = exports.Items = exports.Field = exports.BindItems = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(81);
                var _layout = __w_pdfjs_require__(82);
                var _html_utils = __w_pdfjs_require__(83);
                var _xfa_object = __w_pdfjs_require__(87);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                var _fonts = __w_pdfjs_require__(85);
                var _core_utils = __w_pdfjs_require__(3);
                var _som = __w_pdfjs_require__(88);
                const TEMPLATE_NS_ID = _namespaces.NamespaceIds.template.id;
                const SVG_NS = "http://www.w3.org/2000/svg";
                const MAX_ATTEMPTS_FOR_LRTB_LAYOUT = 2;
                const MAX_EMPTY_PAGES = 3;
                const DEFAULT_TAB_INDEX = 5000;
                const HEADING_PATTERN = /^H(\d+)$/;
                const MIMES = new Set([
                    "image/gif",
                    "image/jpeg",
                    "image/jpg",
                    "image/pjpeg",
                    "image/png",
                    "image/apng",
                    "image/x-png",
                    "image/bmp",
                    "image/x-ms-bmp",
                    "image/tiff",
                    "image/tif",
                    "application/octet-stream"
                ]);
                const IMAGES_HEADERS = [
                    [
                        [
                            0x42,
                            0x4d
                        ],
                        "image/bmp"
                    ],
                    [
                        [
                            0xff,
                            0xd8,
                            0xff
                        ],
                        "image/jpeg"
                    ],
                    [
                        [
                            0x49,
                            0x49,
                            0x2a,
                            0x00
                        ],
                        "image/tiff"
                    ],
                    [
                        [
                            0x4d,
                            0x4d,
                            0x00,
                            0x2a
                        ],
                        "image/tiff"
                    ],
                    [
                        [
                            0x47,
                            0x49,
                            0x46,
                            0x38,
                            0x39,
                            0x61
                        ],
                        "image/gif"
                    ],
                    [
                        [
                            0x89,
                            0x50,
                            0x4e,
                            0x47,
                            0x0d,
                            0x0a,
                            0x1a,
                            0x0a
                        ],
                        "image/png"
                    ]
                ];
                function getBorderDims(node) {
                    if (!node || !node.border) return {
                        w: 0,
                        h: 0
                    };
                    const borderExtra = node.border[_symbol_utils.$getExtra]();
                    if (!borderExtra) return {
                        w: 0,
                        h: 0
                    };
                    return {
                        w: borderExtra.widths[0] + borderExtra.widths[2] + borderExtra.insets[0] + borderExtra.insets[2],
                        h: borderExtra.widths[1] + borderExtra.widths[3] + borderExtra.insets[1] + borderExtra.insets[3]
                    };
                }
                function hasMargin(node) {
                    return node.margin && (node.margin.topInset || node.margin.rightInset || node.margin.bottomInset || node.margin.leftInset);
                }
                function _setValue(templateNode, value) {
                    if (!templateNode.value) {
                        const nodeValue = new Value({});
                        templateNode[_symbol_utils.$appendChild](nodeValue);
                        templateNode.value = nodeValue;
                    }
                    templateNode.value[_symbol_utils.$setValue](value);
                }
                function* getContainedChildren(node) {
                    for (const child of node[_symbol_utils.$getChildren]()){
                        if (child instanceof SubformSet) {
                            yield* child[_symbol_utils.$getContainedChildren]();
                            continue;
                        }
                        yield child;
                    }
                }
                function isRequired(node) {
                    return node.validate?.nullTest === "error";
                }
                function setTabIndex(node) {
                    while(node){
                        if (!node.traversal) {
                            node[_symbol_utils.$tabIndex] = node[_symbol_utils.$getParent]()[_symbol_utils.$tabIndex];
                            return;
                        }
                        if (node[_symbol_utils.$tabIndex]) return;
                        let next = null;
                        for (const child of node.traversal[_symbol_utils.$getChildren]())if (child.operation === "next") {
                            next = child;
                            break;
                        }
                        if (!next || !next.ref) {
                            node[_symbol_utils.$tabIndex] = node[_symbol_utils.$getParent]()[_symbol_utils.$tabIndex];
                            return;
                        }
                        const root = node[_symbol_utils.$getTemplateRoot]();
                        node[_symbol_utils.$tabIndex] = ++root[_symbol_utils.$tabIndex];
                        const ref = root[_symbol_utils.$searchNode](next.ref, node);
                        if (!ref) return;
                        node = ref[0];
                    }
                }
                function applyAssist(obj, attributes) {
                    const assist = obj.assist;
                    if (assist) {
                        const assistTitle = assist[_symbol_utils.$toHTML]();
                        if (assistTitle) attributes.title = assistTitle;
                        const role = assist.role;
                        const match = role.match(HEADING_PATTERN);
                        if (match) {
                            const ariaRole = "heading";
                            const ariaLevel = match[1];
                            attributes.role = ariaRole;
                            attributes["aria-level"] = ariaLevel;
                        }
                    }
                    if (obj.layout === "table") attributes.role = "table";
                    else if (obj.layout === "row") attributes.role = "row";
                    else {
                        const parent = obj[_symbol_utils.$getParent]();
                        if (parent.layout === "row") attributes.role = parent.assist?.role === "TH" ? "columnheader" : "cell";
                    }
                }
                function ariaLabel(obj) {
                    if (!obj.assist) return null;
                    const assist = obj.assist;
                    if (assist.speak && assist.speak[_symbol_utils.$content] !== "") return assist.speak[_symbol_utils.$content];
                    if (assist.toolTip) return assist.toolTip[_symbol_utils.$content];
                    return null;
                }
                function valueToHtml(value) {
                    return _utils.HTMLResult.success({
                        name: "div",
                        attributes: {
                            class: [
                                "xfaRich"
                            ],
                            style: Object.create(null)
                        },
                        children: [
                            {
                                name: "span",
                                attributes: {
                                    style: Object.create(null)
                                },
                                value: value
                            }
                        ]
                    });
                }
                function setFirstUnsplittable(node) {
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    if (root[_symbol_utils.$extra].firstUnsplittable === null) {
                        root[_symbol_utils.$extra].firstUnsplittable = node;
                        root[_symbol_utils.$extra].noLayoutFailure = true;
                    }
                }
                function unsetFirstUnsplittable(node) {
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    if (root[_symbol_utils.$extra].firstUnsplittable === node) root[_symbol_utils.$extra].noLayoutFailure = false;
                }
                function handleBreak(node) {
                    if (node[_symbol_utils.$extra]) return false;
                    node[_symbol_utils.$extra] = Object.create(null);
                    if (node.targetType === "auto") return false;
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    let target = null;
                    if (node.target) {
                        target = root[_symbol_utils.$searchNode](node.target, node[_symbol_utils.$getParent]());
                        if (!target) return false;
                        target = target[0];
                    }
                    const { currentPageArea: currentPageArea, currentContentArea: currentContentArea } = root[_symbol_utils.$extra];
                    if (node.targetType === "pageArea") {
                        if (!(target instanceof PageArea)) target = null;
                        if (node.startNew) {
                            node[_symbol_utils.$extra].target = target || currentPageArea;
                            return true;
                        } else if (target && target !== currentPageArea) {
                            node[_symbol_utils.$extra].target = target;
                            return true;
                        }
                        return false;
                    }
                    if (!(target instanceof ContentArea)) target = null;
                    const pageArea = target && target[_symbol_utils.$getParent]();
                    let index;
                    let nextPageArea = pageArea;
                    if (node.startNew) {
                        if (target) {
                            const contentAreas = pageArea.contentArea.children;
                            const indexForCurrent = contentAreas.indexOf(currentContentArea);
                            const indexForTarget = contentAreas.indexOf(target);
                            if (indexForCurrent !== -1 && indexForCurrent < indexForTarget) nextPageArea = null;
                            index = indexForTarget - 1;
                        } else index = currentPageArea.contentArea.children.indexOf(currentContentArea);
                    } else if (target && target !== currentContentArea) {
                        const contentAreas = pageArea.contentArea.children;
                        index = contentAreas.indexOf(target) - 1;
                        nextPageArea = pageArea === currentPageArea ? null : pageArea;
                    } else return false;
                    node[_symbol_utils.$extra].target = nextPageArea;
                    node[_symbol_utils.$extra].index = index;
                    return true;
                }
                function handleOverflow(node, extraNode, space) {
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    const saved = root[_symbol_utils.$extra].noLayoutFailure;
                    const savedMethod = extraNode[_symbol_utils.$getSubformParent];
                    extraNode[_symbol_utils.$getSubformParent] = ()=>node;
                    root[_symbol_utils.$extra].noLayoutFailure = true;
                    const res = extraNode[_symbol_utils.$toHTML](space);
                    node[_symbol_utils.$addHTML](res.html, res.bbox);
                    root[_symbol_utils.$extra].noLayoutFailure = saved;
                    extraNode[_symbol_utils.$getSubformParent] = savedMethod;
                }
                class AppearanceFilter extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "appearanceFilter");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Arc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "arc", true);
                        this.circular = (0, _utils.getInteger)({
                            data: attributes.circular,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.startAngle = (0, _utils.getFloat)({
                            data: attributes.startAngle,
                            defaultValue: 0,
                            validate: (x)=>true
                        });
                        this.sweepAngle = (0, _utils.getFloat)({
                            data: attributes.sweepAngle,
                            defaultValue: 360,
                            validate: (x)=>true
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.edge = null;
                        this.fill = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        const edge = this.edge || new Edge({});
                        const edgeStyle = edge[_symbol_utils.$toStyle]();
                        const style = Object.create(null);
                        if (this.fill?.presence === "visible") Object.assign(style, this.fill[_symbol_utils.$toStyle]());
                        else style.fill = "transparent";
                        style.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                        style.stroke = edgeStyle.color;
                        let arc;
                        const attributes = {
                            xmlns: SVG_NS,
                            style: {
                                width: "100%",
                                height: "100%",
                                overflow: "visible"
                            }
                        };
                        if (this.sweepAngle === 360) arc = {
                            name: "ellipse",
                            attributes: {
                                xmlns: SVG_NS,
                                cx: "50%",
                                cy: "50%",
                                rx: "50%",
                                ry: "50%",
                                style: style
                            }
                        };
                        else {
                            const startAngle = this.startAngle * Math.PI / 180;
                            const sweepAngle = this.sweepAngle * Math.PI / 180;
                            const largeArc = this.sweepAngle > 180 ? 1 : 0;
                            const [x1, y1, x2, y2] = [
                                50 * (1 + Math.cos(startAngle)),
                                50 * (1 - Math.sin(startAngle)),
                                50 * (1 + Math.cos(startAngle + sweepAngle)),
                                50 * (1 - Math.sin(startAngle + sweepAngle))
                            ];
                            arc = {
                                name: "path",
                                attributes: {
                                    xmlns: SVG_NS,
                                    d: `M ${x1} ${y1} A 50 50 0 ${largeArc} 0 ${x2} ${y2}`,
                                    vectorEffect: "non-scaling-stroke",
                                    style: style
                                }
                            };
                            Object.assign(attributes, {
                                viewBox: "0 0 100 100",
                                preserveAspectRatio: "none"
                            });
                        }
                        const svg = {
                            name: "svg",
                            children: [
                                arc
                            ],
                            attributes: attributes
                        };
                        const parent = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class Area extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "area", true);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_symbol_utils.$isTransparent]() {
                        return true;
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        const [x, y, w, h] = bbox;
                        this[_symbol_utils.$extra].width = Math.max(this[_symbol_utils.$extra].width, x + w);
                        this[_symbol_utils.$extra].height = Math.max(this[_symbol_utils.$extra].height, y + h);
                        this[_symbol_utils.$extra].children.push(html);
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return this[_symbol_utils.$extra].availableSpace;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "position");
                        const attributes = {
                            style: style,
                            id: this[_symbol_utils.$uid],
                            class: [
                                "xfaArea"
                            ]
                        };
                        if ((0, _html_utils.isPrintOnly)(this)) attributes.class.push("xfaPrintOnly");
                        if (this.name) attributes.xfaName = this.name;
                        const children = [];
                        this[_symbol_utils.$extra] = {
                            children: children,
                            width: 0,
                            height: 0,
                            availableSpace: availableSpace
                        };
                        const result = this[_symbol_utils.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "exclGroup",
                                "subform",
                                "subformSet"
                            ]),
                            include: true
                        });
                        if (!result.success) {
                            if (result.isBreak()) return result;
                            delete this[_symbol_utils.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        style.width = (0, _html_utils.measureToString)(this[_symbol_utils.$extra].width);
                        style.height = (0, _html_utils.measureToString)(this[_symbol_utils.$extra].height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        const bbox = [
                            this.x,
                            this.y,
                            this[_symbol_utils.$extra].width,
                            this[_symbol_utils.$extra].height
                        ];
                        delete this[_symbol_utils.$extra];
                        return _utils.HTMLResult.success(html, bbox);
                    }
                }
                class Assist extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "assist", true);
                        this.id = attributes.id || "";
                        this.role = attributes.role || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.speak = null;
                        this.toolTip = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        return this.toolTip?.[_symbol_utils.$content] || null;
                    }
                }
                class Barcode extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "barcode", true);
                        this.charEncoding = (0, _utils.getKeyword)({
                            data: attributes.charEncoding ? attributes.charEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (k)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(k) || k.match(/iso-8859-\d{2}/)
                        });
                        this.checksum = (0, _utils.getStringOption)(attributes.checksum, [
                            "none",
                            "1mod10",
                            "1mod10_1mod11",
                            "2mod10",
                            "auto"
                        ]);
                        this.dataColumnCount = (0, _utils.getInteger)({
                            data: attributes.dataColumnCount,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.dataLength = (0, _utils.getInteger)({
                            data: attributes.dataLength,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.dataPrep = (0, _utils.getStringOption)(attributes.dataPrep, [
                            "none",
                            "flateCompress"
                        ]);
                        this.dataRowCount = (0, _utils.getInteger)({
                            data: attributes.dataRowCount,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.endChar = attributes.endChar || "";
                        this.errorCorrectionLevel = (0, _utils.getInteger)({
                            data: attributes.errorCorrectionLevel,
                            defaultValue: -1,
                            validate: (x)=>x >= 0 && x <= 8
                        });
                        this.id = attributes.id || "";
                        this.moduleHeight = (0, _utils.getMeasurement)(attributes.moduleHeight, "5mm");
                        this.moduleWidth = (0, _utils.getMeasurement)(attributes.moduleWidth, "0.25mm");
                        this.printCheckDigit = (0, _utils.getInteger)({
                            data: attributes.printCheckDigit,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.rowColumnRatio = (0, _utils.getRatio)(attributes.rowColumnRatio);
                        this.startChar = attributes.startChar || "";
                        this.textLocation = (0, _utils.getStringOption)(attributes.textLocation, [
                            "below",
                            "above",
                            "aboveEmbedded",
                            "belowEmbedded",
                            "none"
                        ]);
                        this.truncate = (0, _utils.getInteger)({
                            data: attributes.truncate,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.type = (0, _utils.getStringOption)(attributes.type ? attributes.type.toLowerCase() : "", [
                            "aztec",
                            "codabar",
                            "code2of5industrial",
                            "code2of5interleaved",
                            "code2of5matrix",
                            "code2of5standard",
                            "code3of9",
                            "code3of9extended",
                            "code11",
                            "code49",
                            "code93",
                            "code128",
                            "code128a",
                            "code128b",
                            "code128c",
                            "code128sscc",
                            "datamatrix",
                            "ean8",
                            "ean8add2",
                            "ean8add5",
                            "ean13",
                            "ean13add2",
                            "ean13add5",
                            "ean13pwcd",
                            "fim",
                            "logmars",
                            "maxicode",
                            "msi",
                            "pdf417",
                            "pdf417macro",
                            "plessey",
                            "postauscust2",
                            "postauscust3",
                            "postausreplypaid",
                            "postausstandard",
                            "postukrm4scc",
                            "postusdpbc",
                            "postusimb",
                            "postusstandard",
                            "postus5zip",
                            "qrcode",
                            "rfid",
                            "rss14",
                            "rss14expanded",
                            "rss14limited",
                            "rss14stacked",
                            "rss14stackedomni",
                            "rss14truncated",
                            "telepen",
                            "ucc128",
                            "ucc128random",
                            "ucc128sscc",
                            "upca",
                            "upcaadd2",
                            "upcaadd5",
                            "upcapwcd",
                            "upce",
                            "upceadd2",
                            "upceadd5",
                            "upcean2",
                            "upcean5",
                            "upsmaxicode"
                        ]);
                        this.upsMode = (0, _utils.getStringOption)(attributes.upsMode, [
                            "usCarrier",
                            "internationalCarrier",
                            "secureSymbol",
                            "standardSymbol"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.wideNarrowRatio = (0, _utils.getRatio)(attributes.wideNarrowRatio);
                        this.encrypt = null;
                        this.extras = null;
                    }
                }
                class Bind extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bind", true);
                        this.match = (0, _utils.getStringOption)(attributes.match, [
                            "once",
                            "dataRef",
                            "global",
                            "none"
                        ]);
                        this.ref = attributes.ref || "";
                        this.picture = null;
                    }
                }
                class BindItems extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bindItems");
                        this.connection = attributes.connection || "";
                        this.labelRef = attributes.labelRef || "";
                        this.ref = attributes.ref || "";
                        this.valueRef = attributes.valueRef || "";
                    }
                }
                exports.BindItems = BindItems;
                class Bookend extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bookend");
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class BooleanElement extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "boolean");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] === 1 ? "1" : "0");
                    }
                }
                class Border extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "border", true);
                        this.break = (0, _utils.getStringOption)(attributes.break, [
                            "close",
                            "open"
                        ]);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.corner = new _xfa_object.XFAObjectArray(4);
                        this.edge = new _xfa_object.XFAObjectArray(4);
                        this.extras = null;
                        this.fill = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$getExtra]() {
                        if (!this[_symbol_utils.$extra]) {
                            const edges = this.edge.children.slice();
                            if (edges.length < 4) {
                                const defaultEdge = edges.at(-1) || new Edge({});
                                for(let i = edges.length; i < 4; i++)edges.push(defaultEdge);
                            }
                            const widths = edges.map((edge)=>edge.thickness);
                            const insets = [
                                0,
                                0,
                                0,
                                0
                            ];
                            if (this.margin) {
                                insets[0] = this.margin.topInset;
                                insets[1] = this.margin.rightInset;
                                insets[2] = this.margin.bottomInset;
                                insets[3] = this.margin.leftInset;
                            }
                            this[_symbol_utils.$extra] = {
                                widths: widths,
                                insets: insets,
                                edges: edges
                            };
                        }
                        return this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$toStyle]() {
                        const { edges: edges } = this[_symbol_utils.$getExtra]();
                        const edgeStyles = edges.map((node)=>{
                            const style = node[_symbol_utils.$toStyle]();
                            style.color ||= "#000000";
                            return style;
                        });
                        const style = Object.create(null);
                        if (this.margin) Object.assign(style, this.margin[_symbol_utils.$toStyle]());
                        if (this.fill?.presence === "visible") Object.assign(style, this.fill[_symbol_utils.$toStyle]());
                        if (this.corner.children.some((node)=>node.radius !== 0)) {
                            const cornerStyles = this.corner.children.map((node)=>node[_symbol_utils.$toStyle]());
                            if (cornerStyles.length === 2 || cornerStyles.length === 3) {
                                const last = cornerStyles.at(-1);
                                for(let i = cornerStyles.length; i < 4; i++)cornerStyles.push(last);
                            }
                            style.borderRadius = cornerStyles.map((s)=>s.radius).join(" ");
                        }
                        switch(this.presence){
                            case "invisible":
                            case "hidden":
                                style.borderStyle = "";
                                break;
                            case "inactive":
                                style.borderStyle = "none";
                                break;
                            default:
                                style.borderStyle = edgeStyles.map((s)=>s.style).join(" ");
                                break;
                        }
                        style.borderWidth = edgeStyles.map((s)=>s.width).join(" ");
                        style.borderColor = edgeStyles.map((s)=>s.color).join(" ");
                        return style;
                    }
                }
                class Break extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "break", true);
                        this.after = (0, _utils.getStringOption)(attributes.after, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.afterTarget = attributes.afterTarget || "";
                        this.before = (0, _utils.getStringOption)(attributes.before, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.beforeTarget = attributes.beforeTarget || "";
                        this.bookendLeader = attributes.bookendLeader || "";
                        this.bookendTrailer = attributes.bookendTrailer || "";
                        this.id = attributes.id || "";
                        this.overflowLeader = attributes.overflowLeader || "";
                        this.overflowTarget = attributes.overflowTarget || "";
                        this.overflowTrailer = attributes.overflowTrailer || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class BreakAfter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "breakAfter", true);
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.target = attributes.target || "";
                        this.targetType = (0, _utils.getStringOption)(attributes.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.script = null;
                    }
                }
                class BreakBefore extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "breakBefore", true);
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.target = attributes.target || "";
                        this.targetType = (0, _utils.getStringOption)(attributes.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.script = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        this[_symbol_utils.$extra] = {};
                        return _utils.HTMLResult.FAILURE;
                    }
                }
                class Button extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "button", true);
                        this.highlight = (0, _utils.getStringOption)(attributes.highlight, [
                            "inverted",
                            "none",
                            "outline",
                            "push"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const parent = this[_symbol_utils.$getParent]();
                        const grandpa = parent[_symbol_utils.$getParent]();
                        const htmlButton = {
                            name: "button",
                            attributes: {
                                id: this[_symbol_utils.$uid],
                                class: [
                                    "xfaButton"
                                ],
                                style: {}
                            },
                            children: []
                        };
                        for (const event of grandpa.event.children){
                            if (event.activity !== "click" || !event.script) continue;
                            const jsURL = (0, _core_utils.recoverJsURL)(event.script[_symbol_utils.$content]);
                            if (!jsURL) continue;
                            const href = (0, _html_utils.fixURL)(jsURL.url);
                            if (!href) continue;
                            htmlButton.children.push({
                                name: "a",
                                attributes: {
                                    id: "link" + this[_symbol_utils.$uid],
                                    href: href,
                                    newWindow: jsURL.newWindow,
                                    class: [
                                        "xfaLink"
                                    ],
                                    style: {}
                                },
                                children: []
                            });
                        }
                        return _utils.HTMLResult.success(htmlButton);
                    }
                }
                class Calculate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "calculate", true);
                        this.id = attributes.id || "";
                        this.override = (0, _utils.getStringOption)(attributes.override, [
                            "disabled",
                            "error",
                            "ignore",
                            "warning"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.script = null;
                    }
                }
                class Caption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "caption", true);
                        this.id = attributes.id || "";
                        this.placement = (0, _utils.getStringOption)(attributes.placement, [
                            "left",
                            "bottom",
                            "inline",
                            "right",
                            "top"
                        ]);
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.reserve = Math.ceil((0, _utils.getMeasurement)(attributes.reserve));
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.font = null;
                        this.margin = null;
                        this.para = null;
                        this.value = null;
                    }
                    [_symbol_utils.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_symbol_utils.$getExtra](availableSpace) {
                        if (!this[_symbol_utils.$extra]) {
                            let { width: width, height: height } = availableSpace;
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    width = this.reserve <= 0 ? width : this.reserve;
                                    break;
                                case "top":
                                case "bottom":
                                    height = this.reserve <= 0 ? height : this.reserve;
                                    break;
                            }
                            this[_symbol_utils.$extra] = (0, _html_utils.layoutNode)(this, {
                                width: width,
                                height: height
                            });
                        }
                        return this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (!this.value) return _utils.HTMLResult.EMPTY;
                        this[_symbol_utils.$pushPara]();
                        const value = this.value[_symbol_utils.$toHTML](availableSpace).html;
                        if (!value) {
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.EMPTY;
                        }
                        const savedReserve = this.reserve;
                        if (this.reserve <= 0) {
                            const { w: w, h: h } = this[_symbol_utils.$getExtra](availableSpace);
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    this.reserve = w;
                                    break;
                                case "top":
                                case "bottom":
                                    this.reserve = h;
                                    break;
                            }
                        }
                        const children = [];
                        if (typeof value === "string") children.push({
                            name: "#text",
                            value: value
                        });
                        else children.push(value);
                        const style = (0, _html_utils.toStyle)(this, "font", "margin", "visibility");
                        switch(this.placement){
                            case "left":
                            case "right":
                                if (this.reserve > 0) style.width = (0, _html_utils.measureToString)(this.reserve);
                                break;
                            case "top":
                            case "bottom":
                                if (this.reserve > 0) style.height = (0, _html_utils.measureToString)(this.reserve);
                                break;
                        }
                        (0, _html_utils.setPara)(this, null, value);
                        this[_symbol_utils.$popPara]();
                        this.reserve = savedReserve;
                        return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: style,
                                class: [
                                    "xfaCaption"
                                ]
                            },
                            children: children
                        });
                    }
                }
                class Certificate extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "certificate");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Certificates extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "certificates", true);
                        this.credentialServerPolicy = (0, _utils.getStringOption)(attributes.credentialServerPolicy, [
                            "optional",
                            "required"
                        ]);
                        this.id = attributes.id || "";
                        this.url = attributes.url || "";
                        this.urlPolicy = attributes.urlPolicy || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encryption = null;
                        this.issuers = null;
                        this.keyUsage = null;
                        this.oids = null;
                        this.signing = null;
                        this.subjectDNs = null;
                    }
                }
                class CheckButton extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "checkButton", true);
                        this.id = attributes.id || "";
                        this.mark = (0, _utils.getStringOption)(attributes.mark, [
                            "default",
                            "check",
                            "circle",
                            "cross",
                            "diamond",
                            "square",
                            "star"
                        ]);
                        this.shape = (0, _utils.getStringOption)(attributes.shape, [
                            "square",
                            "round"
                        ]);
                        this.size = (0, _utils.getMeasurement)(attributes.size, "10pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)("margin");
                        const size = (0, _html_utils.measureToString)(this.size);
                        style.width = style.height = size;
                        let type;
                        let className;
                        let groupId;
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const items = field.items.children.length && field.items.children[0][_symbol_utils.$toHTML]().html || [];
                        const exportedValue = {
                            on: (items[0] !== undefined ? items[0] : "on").toString(),
                            off: (items[1] !== undefined ? items[1] : "off").toString()
                        };
                        const value = field.value?.[_symbol_utils.$text]() || "off";
                        const checked = value === exportedValue.on || undefined;
                        const container = field[_symbol_utils.$getSubformParent]();
                        const fieldId = field[_symbol_utils.$uid];
                        let dataId;
                        if (container instanceof ExclGroup) {
                            groupId = container[_symbol_utils.$uid];
                            type = "radio";
                            className = "xfaRadio";
                            dataId = container[_symbol_utils.$data]?.[_symbol_utils.$uid] || container[_symbol_utils.$uid];
                        } else {
                            type = "checkbox";
                            className = "xfaCheckbox";
                            dataId = field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid];
                        }
                        const input = {
                            name: "input",
                            attributes: {
                                class: [
                                    className
                                ],
                                style: style,
                                fieldId: fieldId,
                                dataId: dataId,
                                type: type,
                                checked: checked,
                                xfaOn: exportedValue.on,
                                xfaOff: exportedValue.off,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (groupId) input.attributes.name = groupId;
                        if (isRequired(field)) {
                            input.attributes["aria-required"] = true;
                            input.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                input
                            ]
                        });
                    }
                }
                class ChoiceList extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "choiceList", true);
                        this.commitOn = (0, _utils.getStringOption)(attributes.commitOn, [
                            "select",
                            "exit"
                        ]);
                        this.id = attributes.id || "";
                        this.open = (0, _utils.getStringOption)(attributes.open, [
                            "userControl",
                            "always",
                            "multiSelect",
                            "onEntry"
                        ]);
                        this.textEntry = (0, _utils.getInteger)({
                            data: attributes.textEntry,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "margin");
                        const ui = this[_symbol_utils.$getParent]();
                        const field = ui[_symbol_utils.$getParent]();
                        const fontSize = field.font?.size || 10;
                        const optionStyle = {
                            fontSize: `calc(${fontSize}px * var(--scale-factor))`
                        };
                        const children = [];
                        if (field.items.children.length > 0) {
                            const items = field.items;
                            let displayedIndex = 0;
                            let saveIndex = 0;
                            if (items.children.length === 2) {
                                displayedIndex = items.children[0].save;
                                saveIndex = 1 - displayedIndex;
                            }
                            const displayed = items.children[displayedIndex][_symbol_utils.$toHTML]().html;
                            const values = items.children[saveIndex][_symbol_utils.$toHTML]().html;
                            let selected = false;
                            const value = field.value?.[_symbol_utils.$text]() || "";
                            for(let i = 0, ii = displayed.length; i < ii; i++){
                                const option = {
                                    name: "option",
                                    attributes: {
                                        value: values[i] || displayed[i],
                                        style: optionStyle
                                    },
                                    value: displayed[i]
                                };
                                if (values[i] === value) option.attributes.selected = selected = true;
                                children.push(option);
                            }
                            if (!selected) children.splice(0, 0, {
                                name: "option",
                                attributes: {
                                    hidden: true,
                                    selected: true
                                },
                                value: " "
                            });
                        }
                        const selectAttributes = {
                            class: [
                                "xfaSelect"
                            ],
                            fieldId: field[_symbol_utils.$uid],
                            dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                            style: style,
                            "aria-label": ariaLabel(field),
                            "aria-required": false
                        };
                        if (isRequired(field)) {
                            selectAttributes["aria-required"] = true;
                            selectAttributes.required = true;
                        }
                        if (this.open === "multiSelect") selectAttributes.multiple = true;
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                {
                                    name: "select",
                                    children: children,
                                    attributes: selectAttributes
                                }
                            ]
                        });
                    }
                }
                class Color extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "color", true);
                        this.cSpace = (0, _utils.getStringOption)(attributes.cSpace, [
                            "SRGB"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.value = attributes.value ? (0, _utils.getColor)(attributes.value) : "";
                        this.extras = null;
                    }
                    [_symbol_utils.$hasSettableValue]() {
                        return false;
                    }
                    [_symbol_utils.$toStyle]() {
                        return this.value ? _util.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
                    }
                }
                class Comb extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "comb");
                        this.id = attributes.id || "";
                        this.numberOfCells = (0, _utils.getInteger)({
                            data: attributes.numberOfCells,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Connect extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "connect", true);
                        this.connection = attributes.connection || "";
                        this.id = attributes.id || "";
                        this.ref = attributes.ref || "";
                        this.usage = (0, _utils.getStringOption)(attributes.usage, [
                            "exportAndImport",
                            "exportOnly",
                            "importOnly"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.picture = null;
                    }
                }
                class ContentArea extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "contentArea", true);
                        this.h = (0, _utils.getMeasurement)(attributes.h);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = (0, _utils.getMeasurement)(attributes.w);
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const left = (0, _html_utils.measureToString)(this.x);
                        const top = (0, _html_utils.measureToString)(this.y);
                        const style = {
                            left: left,
                            top: top,
                            width: (0, _html_utils.measureToString)(this.w),
                            height: (0, _html_utils.measureToString)(this.h)
                        };
                        const classNames = [
                            "xfaContentarea"
                        ];
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        return _utils.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {
                                style: style,
                                class: classNames,
                                id: this[_symbol_utils.$uid]
                            }
                        });
                    }
                }
                class Corner extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "corner", true);
                        this.id = attributes.id || "";
                        this.inverted = (0, _utils.getInteger)({
                            data: attributes.inverted,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.join = (0, _utils.getStringOption)(attributes.join, [
                            "square",
                            "round"
                        ]);
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.radius = (0, _utils.getMeasurement)(attributes.radius);
                        this.stroke = (0, _utils.getStringOption)(attributes.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, _utils.getMeasurement)(attributes.thickness, "0.5pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "visibility");
                        style.radius = (0, _html_utils.measureToString)(this.join === "square" ? 0 : this.radius);
                        return style;
                    }
                }
                class DateElement extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "date");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const date = this[_symbol_utils.$content].trim();
                        this[_symbol_utils.$content] = date ? new Date(date) : null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class DateTime extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "dateTime");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const date = this[_symbol_utils.$content].trim();
                        this[_symbol_utils.$content] = date ? new Date(date) : null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class DateTimeEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "dateTimeEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.picker = (0, _utils.getStringOption)(attributes.picker, [
                            "host",
                            "none"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: field[_symbol_utils.$uid],
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (isRequired(field)) {
                            html.attributes["aria-required"] = true;
                            html.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Decimal extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "decimal");
                        this.fracDigits = (0, _utils.getInteger)({
                            data: attributes.fracDigits,
                            defaultValue: 2,
                            validate: (x)=>true
                        });
                        this.id = attributes.id || "";
                        this.leadDigits = (0, _utils.getInteger)({
                            data: attributes.leadDigits,
                            defaultValue: -1,
                            validate: (x)=>true
                        });
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const number = parseFloat(this[_symbol_utils.$content].trim());
                        this[_symbol_utils.$content] = isNaN(number) ? null : number;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class DefaultUi extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "defaultUi", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class Desc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "desc", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class DigestMethod extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "digestMethod", [
                            "",
                            "SHA1",
                            "SHA256",
                            "SHA512",
                            "RIPEMD160"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class DigestMethods extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "digestMethods", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.digestMethod = new _xfa_object.XFAObjectArray();
                    }
                }
                class Draw extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "draw", true);
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.rotate = (0, _utils.getInteger)({
                            data: attributes.rotate,
                            defaultValue: 0,
                            validate: (x)=>x % 90 === 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.border = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.value = null;
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (this.presence === "hidden" || this.presence === "inactive") return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        this[_symbol_utils.$pushPara]();
                        const savedW = this.w;
                        const savedH = this.h;
                        const { w: w, h: h, isBroken: isBroken } = (0, _html_utils.layoutNode)(this, availableSpace);
                        if (w && this.w === "") {
                            if (isBroken && this[_symbol_utils.$getSubformParent]()[_symbol_utils.$isThereMoreWidth]()) {
                                this[_symbol_utils.$popPara]();
                                return _utils.HTMLResult.FAILURE;
                            }
                            this.w = w;
                        }
                        if (h && this.h === "") this.h = h;
                        setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                            this.w = savedW;
                            this.h = savedH;
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const style = (0, _html_utils.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
                        (0, _html_utils.setMinMaxDimensions)(this, style);
                        if (style.margin) {
                            style.padding = style.margin;
                            delete style.margin;
                        }
                        const classNames = [
                            "xfaDraw"
                        ];
                        if (this.font) classNames.push("xfaFont");
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        const attributes = {
                            style: style,
                            id: this[_symbol_utils.$uid],
                            class: classNames
                        };
                        if (this.name) attributes.xfaName = this.name;
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: []
                        };
                        applyAssist(this, attributes);
                        const bbox = (0, _html_utils.computeBbox)(this, html, availableSpace);
                        const value = this.value ? this.value[_symbol_utils.$toHTML](availableSpace).html : null;
                        if (value === null) {
                            this.w = savedW;
                            this.h = savedH;
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        html.children.push(value);
                        (0, _html_utils.setPara)(this, style, value);
                        this.w = savedW;
                        this.h = savedH;
                        this[_symbol_utils.$popPara]();
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                class Edge extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "edge", true);
                        this.cap = (0, _utils.getStringOption)(attributes.cap, [
                            "square",
                            "butt",
                            "round"
                        ]);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.stroke = (0, _utils.getStringOption)(attributes.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, _utils.getMeasurement)(attributes.thickness, "0.5pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "visibility");
                        Object.assign(style, {
                            linecap: this.cap,
                            width: (0, _html_utils.measureToString)(this.thickness),
                            color: this.color ? this.color[_symbol_utils.$toStyle]() : "#000000",
                            style: ""
                        });
                        if (this.presence !== "visible") style.style = "none";
                        else switch(this.stroke){
                            case "solid":
                                style.style = "solid";
                                break;
                            case "dashDot":
                                style.style = "dashed";
                                break;
                            case "dashDotDot":
                                style.style = "dashed";
                                break;
                            case "dashed":
                                style.style = "dashed";
                                break;
                            case "dotted":
                                style.style = "dotted";
                                break;
                            case "embossed":
                                style.style = "ridge";
                                break;
                            case "etched":
                                style.style = "groove";
                                break;
                            case "lowered":
                                style.style = "inset";
                                break;
                            case "raised":
                                style.style = "outset";
                                break;
                        }
                        return style;
                    }
                }
                class Encoding extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encoding", [
                            "adbe.x509.rsa_sha1",
                            "adbe.pkcs7.detached",
                            "adbe.pkcs7.sha1"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Encodings extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encodings", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encoding = new _xfa_object.XFAObjectArray();
                    }
                }
                class Encrypt extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encrypt", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = null;
                    }
                }
                class EncryptData extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptData", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "encrypt",
                            "decrypt"
                        ]);
                        this.target = attributes.target || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Encryption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryption", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class EncryptionMethod extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptionMethod", [
                            "",
                            "AES256-CBC",
                            "TRIPLEDES-CBC",
                            "AES128-CBC",
                            "AES192-CBC"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class EncryptionMethods extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptionMethods", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encryptionMethod = new _xfa_object.XFAObjectArray();
                    }
                }
                class Event extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "event", true);
                        this.activity = (0, _utils.getStringOption)(attributes.activity, [
                            "click",
                            "change",
                            "docClose",
                            "docReady",
                            "enter",
                            "exit",
                            "full",
                            "indexChange",
                            "initialize",
                            "mouseDown",
                            "mouseEnter",
                            "mouseExit",
                            "mouseUp",
                            "postExecute",
                            "postOpen",
                            "postPrint",
                            "postSave",
                            "postSign",
                            "postSubmit",
                            "preExecute",
                            "preOpen",
                            "prePrint",
                            "preSave",
                            "preSign",
                            "preSubmit",
                            "ready",
                            "validationState"
                        ]);
                        this.id = attributes.id || "";
                        this.listen = (0, _utils.getStringOption)(attributes.listen, [
                            "refOnly",
                            "refAndDescendents"
                        ]);
                        this.name = attributes.name || "";
                        this.ref = attributes.ref || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.encryptData = null;
                        this.execute = null;
                        this.script = null;
                        this.signData = null;
                        this.submit = null;
                    }
                }
                class ExData extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exData");
                        this.contentType = attributes.contentType || "";
                        this.href = attributes.href || "";
                        this.id = attributes.id || "";
                        this.maxLength = (0, _utils.getInteger)({
                            data: attributes.maxLength,
                            defaultValue: -1,
                            validate: (x)=>x >= -1
                        });
                        this.name = attributes.name || "";
                        this.rid = attributes.rid || "";
                        this.transferEncoding = (0, _utils.getStringOption)(attributes.transferEncoding, [
                            "none",
                            "base64",
                            "package"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$isCDATAXml]() {
                        return this.contentType === "text/html";
                    }
                    [_symbol_utils.$onChild](child) {
                        if (this.contentType === "text/html" && child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                            this[_symbol_utils.$content] = child;
                            return true;
                        }
                        if (this.contentType === "text/xml") {
                            this[_symbol_utils.$content] = child;
                            return true;
                        }
                        return false;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (this.contentType !== "text/html" || !this[_symbol_utils.$content]) return _utils.HTMLResult.EMPTY;
                        return this[_symbol_utils.$content][_symbol_utils.$toHTML](availableSpace);
                    }
                }
                class ExObject extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exObject", true);
                        this.archive = attributes.archive || "";
                        this.classId = attributes.classId || "";
                        this.codeBase = attributes.codeBase || "";
                        this.codeType = attributes.codeType || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class ExclGroup extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exclGroup", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = attributes.accessKey || "";
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.layout = (0, _utils.getStringOption)(attributes.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$hasSettableValue]() {
                        return true;
                    }
                    [_symbol_utils.$setValue](value) {
                        for (const field of this.field.children){
                            if (!field.value) {
                                const nodeValue = new Value({});
                                field[_symbol_utils.$appendChild](nodeValue);
                                field.value = nodeValue;
                            }
                            field.value[_symbol_utils.$setValue](value);
                        }
                    }
                    [_symbol_utils.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine > 0 || this[_symbol_utils.$getParent]()[_symbol_utils.$isThereMoreWidth]();
                    }
                    [_symbol_utils.$isSplittable]() {
                        const parent = this[_symbol_utils.$getSubformParent]();
                        if (!parent[_symbol_utils.$isSplittable]()) return false;
                        if (this[_symbol_utils.$extra]._isSplittable !== undefined) return this[_symbol_utils.$extra]._isSplittable;
                        if (this.layout === "position" || this.layout.includes("row")) {
                            this[_symbol_utils.$extra]._isSplittable = false;
                            return false;
                        }
                        if (parent.layout?.endsWith("-tb") && parent[_symbol_utils.$extra].numberInLine !== 0) return false;
                        this[_symbol_utils.$extra]._isSplittable = true;
                        return true;
                    }
                    [_symbol_utils.$flushHTML]() {
                        return (0, _layout.flushHTML)(this);
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        (0, _layout.addHTML)(this, html, bbox);
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return (0, _layout.getAvailableSpace)(this);
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const children = [];
                        const attributes = {
                            id: this[_symbol_utils.$uid],
                            class: []
                        };
                        (0, _html_utils.setAccess)(this, attributes.class);
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = Object.create(null);
                        Object.assign(this[_symbol_utils.$extra], {
                            children: children,
                            attributes: attributes,
                            attempt: 0,
                            line: null,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || Infinity, availableSpace.width),
                                height: Math.min(this.h || Infinity, availableSpace.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const isSplittable = this[_symbol_utils.$isSplittable]();
                        if (!isSplittable) setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) return _utils.HTMLResult.FAILURE;
                        const filter = new Set([
                            "field"
                        ]);
                        if (this.layout.includes("row")) {
                            const columnWidths = this[_symbol_utils.$getSubformParent]().columnWidths;
                            if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                                this[_symbol_utils.$extra].columnWidths = columnWidths;
                                this[_symbol_utils.$extra].currentColumn = 0;
                            }
                        }
                        const style = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                        const classNames = [
                            "xfaExclgroup"
                        ];
                        const cl = (0, _html_utils.layoutClass)(this);
                        if (cl) classNames.push(cl);
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        attributes.style = style;
                        attributes.class = classNames;
                        if (this.name) attributes.xfaName = this.name;
                        this[_symbol_utils.$pushPara]();
                        const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                        const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                        for(; this[_symbol_utils.$extra].attempt < maxRun; this[_symbol_utils.$extra].attempt++){
                            if (isLrTb && this[_symbol_utils.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) this[_symbol_utils.$extra].numberInLine = 0;
                            const result = this[_symbol_utils.$childrenToHTML]({
                                filter: filter,
                                include: true
                            });
                            if (result.success) break;
                            if (result.isBreak()) {
                                this[_symbol_utils.$popPara]();
                                return result;
                            }
                            if (isLrTb && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine === 0 && !this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                                this[_symbol_utils.$extra].attempt = maxRun;
                                break;
                            }
                        }
                        this[_symbol_utils.$popPara]();
                        if (!isSplittable) unsetFirstUnsplittable(this);
                        if (this[_symbol_utils.$extra].attempt === maxRun) {
                            if (!isSplittable) delete this[_symbol_utils.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        const width = Math.max(this[_symbol_utils.$extra].width + marginH, this.w || 0);
                        const height = Math.max(this[_symbol_utils.$extra].height + marginV, this.h || 0);
                        const bbox = [
                            this.x,
                            this.y,
                            width,
                            height
                        ];
                        if (this.w === "") style.width = (0, _html_utils.measureToString)(width);
                        if (this.h === "") style.height = (0, _html_utils.measureToString)(height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        applyAssist(this, attributes);
                        delete this[_symbol_utils.$extra];
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                class Execute extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "execute");
                        this.connection = attributes.connection || "";
                        this.executeType = (0, _utils.getStringOption)(attributes.executeType, [
                            "import",
                            "remerge"
                        ]);
                        this.id = attributes.id || "";
                        this.runAt = (0, _utils.getStringOption)(attributes.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Extras extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "extras", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.extras = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class Field extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "field", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = attributes.accessKey || "";
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.rotate = (0, _utils.getInteger)({
                            data: attributes.rotate,
                            defaultValue: 0,
                            validate: (x)=>x % 90 === 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.format = null;
                        this.items = new _xfa_object.XFAObjectArray(2);
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.validate = null;
                        this.value = null;
                        this.bindItems = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (!this.ui) {
                            this.ui = new Ui({});
                            this.ui[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                            this[_symbol_utils.$appendChild](this.ui);
                            let node;
                            switch(this.items.children.length){
                                case 0:
                                    node = new TextEdit({});
                                    this.ui.textEdit = node;
                                    break;
                                case 1:
                                    node = new CheckButton({});
                                    this.ui.checkButton = node;
                                    break;
                                case 2:
                                    node = new ChoiceList({});
                                    this.ui.choiceList = node;
                                    break;
                            }
                            this.ui[_symbol_utils.$appendChild](node);
                        }
                        if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return _utils.HTMLResult.EMPTY;
                        if (this.caption) delete this.caption[_symbol_utils.$extra];
                        this[_symbol_utils.$pushPara]();
                        const caption = this.caption ? this.caption[_symbol_utils.$toHTML](availableSpace).html : null;
                        const savedW = this.w;
                        const savedH = this.h;
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        let borderDims = null;
                        if (this.w === "" || this.h === "") {
                            let width = null;
                            let height = null;
                            let uiW = 0;
                            let uiH = 0;
                            if (this.ui.checkButton) uiW = uiH = this.ui.checkButton.size;
                            else {
                                const { w: w, h: h } = (0, _html_utils.layoutNode)(this, availableSpace);
                                if (w !== null) {
                                    uiW = w;
                                    uiH = h;
                                } else uiH = (0, _fonts.getMetrics)(this.font, true).lineNoGap;
                            }
                            borderDims = getBorderDims(this.ui[_symbol_utils.$getExtra]());
                            uiW += borderDims.w;
                            uiH += borderDims.h;
                            if (this.caption) {
                                const { w: w, h: h, isBroken: isBroken } = this.caption[_symbol_utils.$getExtra](availableSpace);
                                if (isBroken && this[_symbol_utils.$getSubformParent]()[_symbol_utils.$isThereMoreWidth]()) {
                                    this[_symbol_utils.$popPara]();
                                    return _utils.HTMLResult.FAILURE;
                                }
                                width = w;
                                height = h;
                                switch(this.caption.placement){
                                    case "left":
                                    case "right":
                                    case "inline":
                                        width += uiW;
                                        break;
                                    case "top":
                                    case "bottom":
                                        height += uiH;
                                        break;
                                }
                            } else {
                                width = uiW;
                                height = uiH;
                            }
                            if (width && this.w === "") {
                                width += marginH;
                                this.w = Math.min(this.maxW <= 0 ? Infinity : this.maxW, this.minW + 1 < width ? width : this.minW);
                            }
                            if (height && this.h === "") {
                                height += marginV;
                                this.h = Math.min(this.maxH <= 0 ? Infinity : this.maxH, this.minH + 1 < height ? height : this.minH);
                            }
                        }
                        this[_symbol_utils.$popPara]();
                        (0, _html_utils.fixDimensions)(this);
                        setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                            this.w = savedW;
                            this.h = savedH;
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const style = (0, _html_utils.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
                        (0, _html_utils.setMinMaxDimensions)(this, style);
                        const classNames = [
                            "xfaField"
                        ];
                        if (this.font) classNames.push("xfaFont");
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        const attributes = {
                            style: style,
                            id: this[_symbol_utils.$uid],
                            class: classNames
                        };
                        if (style.margin) {
                            style.padding = style.margin;
                            delete style.margin;
                        }
                        (0, _html_utils.setAccess)(this, classNames);
                        if (this.name) attributes.xfaName = this.name;
                        const children = [];
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        applyAssist(this, attributes);
                        const borderStyle = this.border ? this.border[_symbol_utils.$toStyle]() : null;
                        const bbox = (0, _html_utils.computeBbox)(this, html, availableSpace);
                        const ui = this.ui[_symbol_utils.$toHTML]().html;
                        if (!ui) {
                            Object.assign(style, borderStyle);
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        if (this[_symbol_utils.$tabIndex]) {
                            if (ui.children?.[0]) ui.children[0].attributes.tabindex = this[_symbol_utils.$tabIndex];
                            else ui.attributes.tabindex = this[_symbol_utils.$tabIndex];
                        }
                        if (!ui.attributes.style) ui.attributes.style = Object.create(null);
                        let aElement = null;
                        if (this.ui.button) {
                            if (ui.children.length === 1) [aElement] = ui.children.splice(0, 1);
                            Object.assign(ui.attributes.style, borderStyle);
                        } else Object.assign(style, borderStyle);
                        children.push(ui);
                        if (this.value) {
                            if (this.ui.imageEdit) ui.children.push(this.value[_symbol_utils.$toHTML]().html);
                            else if (!this.ui.button) {
                                let value = "";
                                if (this.value.exData) value = this.value.exData[_symbol_utils.$text]();
                                else if (this.value.text) value = this.value.text[_symbol_utils.$getExtra]();
                                else {
                                    const htmlValue = this.value[_symbol_utils.$toHTML]().html;
                                    if (htmlValue !== null) value = htmlValue.children[0].value;
                                }
                                if (this.ui.textEdit && this.value.text?.maxChars) ui.children[0].attributes.maxLength = this.value.text.maxChars;
                                if (value) {
                                    if (this.ui.numericEdit) {
                                        value = parseFloat(value);
                                        value = isNaN(value) ? "" : value.toString();
                                    }
                                    if (ui.children[0].name === "textarea") ui.children[0].attributes.textContent = value;
                                    else ui.children[0].attributes.value = value;
                                }
                            }
                        }
                        if (!this.ui.imageEdit && ui.children?.[0] && this.h) {
                            borderDims = borderDims || getBorderDims(this.ui[_symbol_utils.$getExtra]());
                            let captionHeight = 0;
                            if (this.caption && [
                                "top",
                                "bottom"
                            ].includes(this.caption.placement)) {
                                captionHeight = this.caption.reserve;
                                if (captionHeight <= 0) captionHeight = this.caption[_symbol_utils.$getExtra](availableSpace).h;
                                const inputHeight = this.h - captionHeight - marginV - borderDims.h;
                                ui.children[0].attributes.style.height = (0, _html_utils.measureToString)(inputHeight);
                            } else ui.children[0].attributes.style.height = "100%";
                        }
                        if (aElement) ui.children.push(aElement);
                        if (!caption) {
                            if (ui.attributes.class) ui.attributes.class.push("xfaLeft");
                            this.w = savedW;
                            this.h = savedH;
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        if (this.ui.button) {
                            if (style.padding) delete style.padding;
                            if (caption.name === "div") caption.name = "span";
                            ui.children.push(caption);
                            return _utils.HTMLResult.success(html, bbox);
                        } else if (this.ui.checkButton) caption.attributes.class[0] = "xfaCaptionForCheckButton";
                        if (!ui.attributes.class) ui.attributes.class = [];
                        ui.children.splice(0, 0, caption);
                        switch(this.caption.placement){
                            case "left":
                                ui.attributes.class.push("xfaLeft");
                                break;
                            case "right":
                                ui.attributes.class.push("xfaRight");
                                break;
                            case "top":
                                ui.attributes.class.push("xfaTop");
                                break;
                            case "bottom":
                                ui.attributes.class.push("xfaBottom");
                                break;
                            case "inline":
                                ui.attributes.class.push("xfaLeft");
                                break;
                        }
                        this.w = savedW;
                        this.h = savedH;
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                exports.Field = Field;
                class Fill extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "fill", true);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                        this.linear = null;
                        this.pattern = null;
                        this.radial = null;
                        this.solid = null;
                        this.stipple = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const parent = this[_symbol_utils.$getParent]();
                        const grandpa = parent[_symbol_utils.$getParent]();
                        const ggrandpa = grandpa[_symbol_utils.$getParent]();
                        const style = Object.create(null);
                        let propName = "color";
                        let altPropName = propName;
                        if (parent instanceof Border) {
                            propName = "background-color";
                            altPropName = "background";
                            if (ggrandpa instanceof Ui) style.backgroundColor = "white";
                        }
                        if (parent instanceof Rectangle || parent instanceof Arc) {
                            propName = altPropName = "fill";
                            style.fill = "white";
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "extras" || name === "color") continue;
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            const color = obj[_symbol_utils.$toStyle](this.color);
                            if (color) style[color.startsWith("#") ? propName : altPropName] = color;
                            return style;
                        }
                        if (this.color?.value) {
                            const color = this.color[_symbol_utils.$toStyle]();
                            style[color.startsWith("#") ? propName : altPropName] = color;
                        }
                        return style;
                    }
                }
                class Filter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "filter", true);
                        this.addRevocationInfo = (0, _utils.getStringOption)(attributes.addRevocationInfo, [
                            "",
                            "required",
                            "optional",
                            "none"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.version = (0, _utils.getInteger)({
                            data: this.version,
                            defaultValue: 5,
                            validate: (x)=>x >= 1 && x <= 5
                        });
                        this.appearanceFilter = null;
                        this.certificates = null;
                        this.digestMethods = null;
                        this.encodings = null;
                        this.encryptionMethods = null;
                        this.handler = null;
                        this.lockDocument = null;
                        this.mdp = null;
                        this.reasons = null;
                        this.timeStamp = null;
                    }
                }
                class Float extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "float");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const number = parseFloat(this[_symbol_utils.$content].trim());
                        this[_symbol_utils.$content] = isNaN(number) ? null : number;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class Font extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "font", true);
                        this.baselineShift = (0, _utils.getMeasurement)(attributes.baselineShift);
                        this.fontHorizontalScale = (0, _utils.getFloat)({
                            data: attributes.fontHorizontalScale,
                            defaultValue: 100,
                            validate: (x)=>x >= 0
                        });
                        this.fontVerticalScale = (0, _utils.getFloat)({
                            data: attributes.fontVerticalScale,
                            defaultValue: 100,
                            validate: (x)=>x >= 0
                        });
                        this.id = attributes.id || "";
                        this.kerningMode = (0, _utils.getStringOption)(attributes.kerningMode, [
                            "none",
                            "pair"
                        ]);
                        this.letterSpacing = (0, _utils.getMeasurement)(attributes.letterSpacing, "0");
                        this.lineThrough = (0, _utils.getInteger)({
                            data: attributes.lineThrough,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.lineThroughPeriod = (0, _utils.getStringOption)(attributes.lineThroughPeriod, [
                            "all",
                            "word"
                        ]);
                        this.overline = (0, _utils.getInteger)({
                            data: attributes.overline,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.overlinePeriod = (0, _utils.getStringOption)(attributes.overlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.posture = (0, _utils.getStringOption)(attributes.posture, [
                            "normal",
                            "italic"
                        ]);
                        this.size = (0, _utils.getMeasurement)(attributes.size, "10pt");
                        this.typeface = attributes.typeface || "Courier";
                        this.underline = (0, _utils.getInteger)({
                            data: attributes.underline,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.underlinePeriod = (0, _utils.getStringOption)(attributes.underlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.weight = (0, _utils.getStringOption)(attributes.weight, [
                            "normal",
                            "bold"
                        ]);
                        this.extras = null;
                        this.fill = null;
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        this[_symbol_utils.$globalData].usedTypefaces.add(this.typeface);
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "fill");
                        const color = style.color;
                        if (color) {
                            if (color === "#000000") delete style.color;
                            else if (!color.startsWith("#")) {
                                style.background = color;
                                style.backgroundClip = "text";
                                style.color = "transparent";
                            }
                        }
                        if (this.baselineShift) style.verticalAlign = (0, _html_utils.measureToString)(this.baselineShift);
                        style.fontKerning = this.kerningMode === "none" ? "none" : "normal";
                        style.letterSpacing = (0, _html_utils.measureToString)(this.letterSpacing);
                        if (this.lineThrough !== 0) {
                            style.textDecoration = "line-through";
                            if (this.lineThrough === 2) style.textDecorationStyle = "double";
                        }
                        if (this.overline !== 0) {
                            style.textDecoration = "overline";
                            if (this.overline === 2) style.textDecorationStyle = "double";
                        }
                        style.fontStyle = this.posture;
                        style.fontSize = (0, _html_utils.measureToString)(0.99 * this.size);
                        (0, _html_utils.setFontFamily)(this, this, this[_symbol_utils.$globalData].fontFinder, style);
                        if (this.underline !== 0) {
                            style.textDecoration = "underline";
                            if (this.underline === 2) style.textDecorationStyle = "double";
                        }
                        style.fontWeight = this.weight;
                        return style;
                    }
                }
                class Format extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "format", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.picture = null;
                    }
                }
                class Handler extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "handler");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Hyphenation extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "hyphenation");
                        this.excludeAllCaps = (0, _utils.getInteger)({
                            data: attributes.excludeAllCaps,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.excludeInitialCap = (0, _utils.getInteger)({
                            data: attributes.excludeInitialCap,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hyphenate = (0, _utils.getInteger)({
                            data: attributes.hyphenate,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.id = attributes.id || "";
                        this.pushCharacterCount = (0, _utils.getInteger)({
                            data: attributes.pushCharacterCount,
                            defaultValue: 3,
                            validate: (x)=>x >= 0
                        });
                        this.remainCharacterCount = (0, _utils.getInteger)({
                            data: attributes.remainCharacterCount,
                            defaultValue: 3,
                            validate: (x)=>x >= 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.wordCharacterCount = (0, _utils.getInteger)({
                            data: attributes.wordCharacterCount,
                            defaultValue: 7,
                            validate: (x)=>x >= 0
                        });
                    }
                }
                class Image extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "image");
                        this.aspect = (0, _utils.getStringOption)(attributes.aspect, [
                            "fit",
                            "actual",
                            "height",
                            "none",
                            "width"
                        ]);
                        this.contentType = attributes.contentType || "";
                        this.href = attributes.href || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.transferEncoding = (0, _utils.getStringOption)(attributes.transferEncoding, [
                            "base64",
                            "none",
                            "package"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$toHTML]() {
                        if (this.contentType && !MIMES.has(this.contentType.toLowerCase())) return _utils.HTMLResult.EMPTY;
                        let buffer = this[_symbol_utils.$globalData].images && this[_symbol_utils.$globalData].images.get(this.href);
                        if (!buffer && (this.href || !this[_symbol_utils.$content])) return _utils.HTMLResult.EMPTY;
                        if (!buffer && this.transferEncoding === "base64") buffer = (0, _util.stringToBytes)(atob(this[_symbol_utils.$content]));
                        if (!buffer) return _utils.HTMLResult.EMPTY;
                        if (!this.contentType) {
                            for (const [header, type] of IMAGES_HEADERS)if (buffer.length > header.length && header.every((x, i)=>x === buffer[i])) {
                                this.contentType = type;
                                break;
                            }
                            if (!this.contentType) return _utils.HTMLResult.EMPTY;
                        }
                        const blob = new Blob([
                            buffer
                        ], {
                            type: this.contentType
                        });
                        let style;
                        switch(this.aspect){
                            case "fit":
                            case "actual":
                                break;
                            case "height":
                                style = {
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "none":
                                style = {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "width":
                                style = {
                                    width: "100%",
                                    objectFit: "fill"
                                };
                                break;
                        }
                        const parent = this[_symbol_utils.$getParent]();
                        return _utils.HTMLResult.success({
                            name: "img",
                            attributes: {
                                class: [
                                    "xfaImage"
                                ],
                                style: style,
                                src: URL.createObjectURL(blob),
                                alt: parent ? ariaLabel(parent[_symbol_utils.$getParent]()) : null
                            }
                        });
                    }
                }
                class ImageEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "imageEdit", true);
                        this.data = (0, _utils.getStringOption)(attributes.data, [
                            "link",
                            "embed"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (this.data === "embed") return _utils.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {}
                        });
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                class Integer extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "integer");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const number = parseInt(this[_symbol_utils.$content].trim(), 10);
                        this[_symbol_utils.$content] = isNaN(number) ? null : number;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class Issuers extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "issuers", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class Items extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "items", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.ref = attributes.ref || "";
                        this.save = (0, _utils.getInteger)({
                            data: attributes.save,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$toHTML]() {
                        const output = [];
                        for (const child of this[_symbol_utils.$getChildren]())output.push(child[_symbol_utils.$text]());
                        return _utils.HTMLResult.success(output);
                    }
                }
                exports.Items = Items;
                class Keep extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "keep", true);
                        this.id = attributes.id || "";
                        const options = [
                            "none",
                            "contentArea",
                            "pageArea"
                        ];
                        this.intact = (0, _utils.getStringOption)(attributes.intact, options);
                        this.next = (0, _utils.getStringOption)(attributes.next, options);
                        this.previous = (0, _utils.getStringOption)(attributes.previous, options);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class KeyUsage extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "keyUsage");
                        const options = [
                            "",
                            "yes",
                            "no"
                        ];
                        this.crlSign = (0, _utils.getStringOption)(attributes.crlSign, options);
                        this.dataEncipherment = (0, _utils.getStringOption)(attributes.dataEncipherment, options);
                        this.decipherOnly = (0, _utils.getStringOption)(attributes.decipherOnly, options);
                        this.digitalSignature = (0, _utils.getStringOption)(attributes.digitalSignature, options);
                        this.encipherOnly = (0, _utils.getStringOption)(attributes.encipherOnly, options);
                        this.id = attributes.id || "";
                        this.keyAgreement = (0, _utils.getStringOption)(attributes.keyAgreement, options);
                        this.keyCertSign = (0, _utils.getStringOption)(attributes.keyCertSign, options);
                        this.keyEncipherment = (0, _utils.getStringOption)(attributes.keyEncipherment, options);
                        this.nonRepudiation = (0, _utils.getStringOption)(attributes.nonRepudiation, options);
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Line extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "line", true);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.slope = (0, _utils.getStringOption)(attributes.slope, [
                            "\\",
                            "/"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.edge = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        const parent = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const edge = this.edge || new Edge({});
                        const edgeStyle = edge[_symbol_utils.$toStyle]();
                        const style = Object.create(null);
                        const thickness = edge.presence === "visible" ? edge.thickness : 0;
                        style.strokeWidth = (0, _html_utils.measureToString)(thickness);
                        style.stroke = edgeStyle.color;
                        let x1, y1, x2, y2;
                        let width = "100%";
                        let height = "100%";
                        if (parent.w <= thickness) {
                            [x1, y1, x2, y2] = [
                                "50%",
                                0,
                                "50%",
                                "100%"
                            ];
                            width = style.strokeWidth;
                        } else if (parent.h <= thickness) {
                            [x1, y1, x2, y2] = [
                                0,
                                "50%",
                                "100%",
                                "50%"
                            ];
                            height = style.strokeWidth;
                        } else if (this.slope === "\\") [x1, y1, x2, y2] = [
                            0,
                            0,
                            "100%",
                            "100%"
                        ];
                        else [x1, y1, x2, y2] = [
                            0,
                            "100%",
                            "100%",
                            0
                        ];
                        const line = {
                            name: "line",
                            attributes: {
                                xmlns: SVG_NS,
                                x1: x1,
                                y1: y1,
                                x2: x2,
                                y2: y2,
                                style: style
                            }
                        };
                        const svg = {
                            name: "svg",
                            children: [
                                line
                            ],
                            attributes: {
                                xmlns: SVG_NS,
                                width: width,
                                height: height,
                                style: {
                                    overflow: "visible"
                                }
                            }
                        };
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class Linear extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "linear", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "toRight",
                            "toBottom",
                            "toLeft",
                            "toTop"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                        const transf = this.type.replace(/([RBLT])/, " $1").toLowerCase();
                        const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                        return `linear-gradient(${transf}, ${startColor}, ${endColor})`;
                    }
                }
                class LockDocument extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "lockDocument");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = (0, _utils.getStringOption)(this[_symbol_utils.$content], [
                            "auto",
                            "0",
                            "1"
                        ]);
                    }
                }
                class Manifest extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "manifest", true);
                        this.action = (0, _utils.getStringOption)(attributes.action, [
                            "include",
                            "all",
                            "exclude"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.ref = new _xfa_object.XFAObjectArray();
                    }
                }
                class Margin extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "margin", true);
                        this.bottomInset = (0, _utils.getMeasurement)(attributes.bottomInset, "0");
                        this.id = attributes.id || "";
                        this.leftInset = (0, _utils.getMeasurement)(attributes.leftInset, "0");
                        this.rightInset = (0, _utils.getMeasurement)(attributes.rightInset, "0");
                        this.topInset = (0, _utils.getMeasurement)(attributes.topInset, "0");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        return {
                            margin: (0, _html_utils.measureToString)(this.topInset) + " " + (0, _html_utils.measureToString)(this.rightInset) + " " + (0, _html_utils.measureToString)(this.bottomInset) + " " + (0, _html_utils.measureToString)(this.leftInset)
                        };
                    }
                }
                class Mdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "mdp");
                        this.id = attributes.id || "";
                        this.permissions = (0, _utils.getInteger)({
                            data: attributes.permissions,
                            defaultValue: 2,
                            validate: (x)=>x === 1 || x === 3
                        });
                        this.signatureType = (0, _utils.getStringOption)(attributes.signatureType, [
                            "filler",
                            "author"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Medium extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "medium");
                        this.id = attributes.id || "";
                        this.imagingBBox = (0, _utils.getBBox)(attributes.imagingBBox);
                        this.long = (0, _utils.getMeasurement)(attributes.long);
                        this.orientation = (0, _utils.getStringOption)(attributes.orientation, [
                            "portrait",
                            "landscape"
                        ]);
                        this.short = (0, _utils.getMeasurement)(attributes.short);
                        this.stock = attributes.stock || "";
                        this.trayIn = (0, _utils.getStringOption)(attributes.trayIn, [
                            "auto",
                            "delegate",
                            "pageFront"
                        ]);
                        this.trayOut = (0, _utils.getStringOption)(attributes.trayOut, [
                            "auto",
                            "delegate"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Message extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "message", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.text = new _xfa_object.XFAObjectArray();
                    }
                }
                class NumericEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "numericEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: field[_symbol_utils.$uid],
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (isRequired(field)) {
                            html.attributes["aria-required"] = true;
                            html.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Occur extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "occur", true);
                        this.id = attributes.id || "";
                        this.initial = attributes.initial !== "" ? (0, _utils.getInteger)({
                            data: attributes.initial,
                            defaultValue: "",
                            validate: (x)=>true
                        }) : "";
                        this.max = attributes.max !== "" ? (0, _utils.getInteger)({
                            data: attributes.max,
                            defaultValue: 1,
                            validate: (x)=>true
                        }) : "";
                        this.min = attributes.min !== "" ? (0, _utils.getInteger)({
                            data: attributes.min,
                            defaultValue: 1,
                            validate: (x)=>true
                        }) : "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$clean]() {
                        const parent = this[_symbol_utils.$getParent]();
                        const originalMin = this.min;
                        if (this.min === "") this.min = parent instanceof PageArea || parent instanceof PageSet ? 0 : 1;
                        if (this.max === "") {
                            if (originalMin === "") this.max = parent instanceof PageArea || parent instanceof PageSet ? -1 : 1;
                            else this.max = this.min;
                        }
                        if (this.max !== -1 && this.max < this.min) this.max = this.min;
                        if (this.initial === "") this.initial = parent instanceof Template ? 1 : this.min;
                    }
                }
                class Oid extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "oid");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Oids extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "oids", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.oid = new _xfa_object.XFAObjectArray();
                    }
                }
                class Overflow extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "overflow");
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.target = attributes.target || "";
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$getExtra]() {
                        if (!this[_symbol_utils.$extra]) {
                            const parent = this[_symbol_utils.$getParent]();
                            const root = this[_symbol_utils.$getTemplateRoot]();
                            const target = root[_symbol_utils.$searchNode](this.target, parent);
                            const leader = root[_symbol_utils.$searchNode](this.leader, parent);
                            const trailer = root[_symbol_utils.$searchNode](this.trailer, parent);
                            this[_symbol_utils.$extra] = {
                                target: target?.[0] || null,
                                leader: leader?.[0] || null,
                                trailer: trailer?.[0] || null,
                                addLeader: false,
                                addTrailer: false
                            };
                        }
                        return this[_symbol_utils.$extra];
                    }
                }
                class PageArea extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pageArea", true);
                        this.blankOrNotBlank = (0, _utils.getStringOption)(attributes.blankOrNotBlank, [
                            "any",
                            "blank",
                            "notBlank"
                        ]);
                        this.id = attributes.id || "";
                        this.initialNumber = (0, _utils.getInteger)({
                            data: attributes.initialNumber,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.name = attributes.name || "";
                        this.numbered = (0, _utils.getInteger)({
                            data: attributes.numbered,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.oddOrEven = (0, _utils.getStringOption)(attributes.oddOrEven, [
                            "any",
                            "even",
                            "odd"
                        ]);
                        this.pagePosition = (0, _utils.getStringOption)(attributes.pagePosition, [
                            "any",
                            "first",
                            "last",
                            "only",
                            "rest"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.desc = null;
                        this.extras = null;
                        this.medium = null;
                        this.occur = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.contentArea = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isUsable]() {
                        if (!this[_symbol_utils.$extra]) {
                            this[_symbol_utils.$extra] = {
                                numberOfUse: 0
                            };
                            return true;
                        }
                        return !this.occur || this.occur.max === -1 || this[_symbol_utils.$extra].numberOfUse < this.occur.max;
                    }
                    [_symbol_utils.$cleanPage]() {
                        delete this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$getNextPage]() {
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = {
                            numberOfUse: 0
                        };
                        const parent = this[_symbol_utils.$getParent]();
                        if (parent.relation === "orderedOccurrence") {
                            if (this[_symbol_utils.$isUsable]()) {
                                this[_symbol_utils.$extra].numberOfUse += 1;
                                return this;
                            }
                        }
                        return parent[_symbol_utils.$getNextPage]();
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return this[_symbol_utils.$extra].space || {
                            width: 0,
                            height: 0
                        };
                    }
                    [_symbol_utils.$toHTML]() {
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = {
                            numberOfUse: 1
                        };
                        const children = [];
                        this[_symbol_utils.$extra].children = children;
                        const style = Object.create(null);
                        if (this.medium && this.medium.short && this.medium.long) {
                            style.width = (0, _html_utils.measureToString)(this.medium.short);
                            style.height = (0, _html_utils.measureToString)(this.medium.long);
                            this[_symbol_utils.$extra].space = {
                                width: this.medium.short,
                                height: this.medium.long
                            };
                            if (this.medium.orientation === "landscape") {
                                const x = style.width;
                                style.width = style.height;
                                style.height = x;
                                this[_symbol_utils.$extra].space = {
                                    width: this.medium.long,
                                    height: this.medium.short
                                };
                            }
                        } else (0, _util.warn)("XFA - No medium specified in pageArea: please file a bug.");
                        this[_symbol_utils.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "subform"
                            ]),
                            include: true
                        });
                        this[_symbol_utils.$childrenToHTML]({
                            filter: new Set([
                                "contentArea"
                            ]),
                            include: true
                        });
                        return _utils.HTMLResult.success({
                            name: "div",
                            children: children,
                            attributes: {
                                class: [
                                    "xfaPage"
                                ],
                                id: this[_symbol_utils.$uid],
                                style: style,
                                xfaName: this.name
                            }
                        });
                    }
                }
                class PageSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pageSet", true);
                        this.duplexImposition = (0, _utils.getStringOption)(attributes.duplexImposition, [
                            "longEdge",
                            "shortEdge"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relation = (0, _utils.getStringOption)(attributes.relation, [
                            "orderedOccurrence",
                            "duplexPaginated",
                            "simplexPaginated"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.occur = null;
                        this.pageArea = new _xfa_object.XFAObjectArray();
                        this.pageSet = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$cleanPage]() {
                        for (const page of this.pageArea.children)page[_symbol_utils.$cleanPage]();
                        for (const page of this.pageSet.children)page[_symbol_utils.$cleanPage]();
                    }
                    [_symbol_utils.$isUsable]() {
                        return !this.occur || this.occur.max === -1 || this[_symbol_utils.$extra].numberOfUse < this.occur.max;
                    }
                    [_symbol_utils.$getNextPage]() {
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = {
                            numberOfUse: 1,
                            pageIndex: -1,
                            pageSetIndex: -1
                        };
                        if (this.relation === "orderedOccurrence") {
                            if (this[_symbol_utils.$extra].pageIndex + 1 < this.pageArea.children.length) {
                                this[_symbol_utils.$extra].pageIndex += 1;
                                const pageArea = this.pageArea.children[this[_symbol_utils.$extra].pageIndex];
                                return pageArea[_symbol_utils.$getNextPage]();
                            }
                            if (this[_symbol_utils.$extra].pageSetIndex + 1 < this.pageSet.children.length) {
                                this[_symbol_utils.$extra].pageSetIndex += 1;
                                return this.pageSet.children[this[_symbol_utils.$extra].pageSetIndex][_symbol_utils.$getNextPage]();
                            }
                            if (this[_symbol_utils.$isUsable]()) {
                                this[_symbol_utils.$extra].numberOfUse += 1;
                                this[_symbol_utils.$extra].pageIndex = -1;
                                this[_symbol_utils.$extra].pageSetIndex = -1;
                                return this[_symbol_utils.$getNextPage]();
                            }
                            const parent = this[_symbol_utils.$getParent]();
                            if (parent instanceof PageSet) return parent[_symbol_utils.$getNextPage]();
                            this[_symbol_utils.$cleanPage]();
                            return this[_symbol_utils.$getNextPage]();
                        }
                        const pageNumber = this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].pageNumber;
                        const parity = pageNumber % 2 === 0 ? "even" : "odd";
                        const position = pageNumber === 0 ? "first" : "rest";
                        let page = this.pageArea.children.find((p)=>p.oddOrEven === parity && p.pagePosition === position);
                        if (page) return page;
                        page = this.pageArea.children.find((p)=>p.oddOrEven === "any" && p.pagePosition === position);
                        if (page) return page;
                        page = this.pageArea.children.find((p)=>p.oddOrEven === "any" && p.pagePosition === "any");
                        if (page) return page;
                        return this.pageArea.children[0];
                    }
                }
                class Para extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "para", true);
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.lineHeight = attributes.lineHeight ? (0, _utils.getMeasurement)(attributes.lineHeight, "0pt") : "";
                        this.marginLeft = attributes.marginLeft ? (0, _utils.getMeasurement)(attributes.marginLeft, "0pt") : "";
                        this.marginRight = attributes.marginRight ? (0, _utils.getMeasurement)(attributes.marginRight, "0pt") : "";
                        this.orphans = (0, _utils.getInteger)({
                            data: attributes.orphans,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.preserve = attributes.preserve || "";
                        this.radixOffset = attributes.radixOffset ? (0, _utils.getMeasurement)(attributes.radixOffset, "0pt") : "";
                        this.spaceAbove = attributes.spaceAbove ? (0, _utils.getMeasurement)(attributes.spaceAbove, "0pt") : "";
                        this.spaceBelow = attributes.spaceBelow ? (0, _utils.getMeasurement)(attributes.spaceBelow, "0pt") : "";
                        this.tabDefault = attributes.tabDefault ? (0, _utils.getMeasurement)(this.tabDefault) : "";
                        this.tabStops = (attributes.tabStops || "").trim().split(/\s+/).map((x, i)=>i % 2 === 1 ? (0, _utils.getMeasurement)(x) : x);
                        this.textIndent = attributes.textIndent ? (0, _utils.getMeasurement)(attributes.textIndent, "0pt") : "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.vAlign = (0, _utils.getStringOption)(attributes.vAlign, [
                            "top",
                            "bottom",
                            "middle"
                        ]);
                        this.widows = (0, _utils.getInteger)({
                            data: attributes.widows,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.hyphenation = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "hAlign");
                        if (this.marginLeft !== "") style.paddingLeft = (0, _html_utils.measureToString)(this.marginLeft);
                        if (this.marginRight !== "") style.paddingight = (0, _html_utils.measureToString)(this.marginRight);
                        if (this.spaceAbove !== "") style.paddingTop = (0, _html_utils.measureToString)(this.spaceAbove);
                        if (this.spaceBelow !== "") style.paddingBottom = (0, _html_utils.measureToString)(this.spaceBelow);
                        if (this.textIndent !== "") {
                            style.textIndent = (0, _html_utils.measureToString)(this.textIndent);
                            (0, _html_utils.fixTextIndent)(style);
                        }
                        if (this.lineHeight > 0) style.lineHeight = (0, _html_utils.measureToString)(this.lineHeight);
                        if (this.tabDefault !== "") style.tabSize = (0, _html_utils.measureToString)(this.tabDefault);
                        this.tabStops.length;
                        if (this.hyphenatation) Object.assign(style, this.hyphenatation[_symbol_utils.$toStyle]());
                        return style;
                    }
                }
                class PasswordEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "passwordEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.passwordChar = attributes.passwordChar || "*";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                }
                class Pattern extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pattern", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "crossHatch",
                            "crossDiagonal",
                            "diagonalLeft",
                            "diagonalRight",
                            "horizontal",
                            "vertical"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                        const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                        const width = 5;
                        const cmd = "repeating-linear-gradient";
                        const colors = `${startColor},${startColor} ${width}px,${endColor} ${width}px,${endColor} ${2 * width}px`;
                        switch(this.type){
                            case "crossHatch":
                                return `${cmd}(to top,${colors}) ${cmd}(to right,${colors})`;
                            case "crossDiagonal":
                                return `${cmd}(45deg,${colors}) ${cmd}(-45deg,${colors})`;
                            case "diagonalLeft":
                                return `${cmd}(45deg,${colors})`;
                            case "diagonalRight":
                                return `${cmd}(-45deg,${colors})`;
                            case "horizontal":
                                return `${cmd}(to top,${colors})`;
                            case "vertical":
                                return `${cmd}(to right,${colors})`;
                        }
                        return "";
                    }
                }
                class Picture extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "picture");
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Proto extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "proto", true);
                        this.appearanceFilter = new _xfa_object.XFAObjectArray();
                        this.arc = new _xfa_object.XFAObjectArray();
                        this.area = new _xfa_object.XFAObjectArray();
                        this.assist = new _xfa_object.XFAObjectArray();
                        this.barcode = new _xfa_object.XFAObjectArray();
                        this.bindItems = new _xfa_object.XFAObjectArray();
                        this.bookend = new _xfa_object.XFAObjectArray();
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.border = new _xfa_object.XFAObjectArray();
                        this.break = new _xfa_object.XFAObjectArray();
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.button = new _xfa_object.XFAObjectArray();
                        this.calculate = new _xfa_object.XFAObjectArray();
                        this.caption = new _xfa_object.XFAObjectArray();
                        this.certificate = new _xfa_object.XFAObjectArray();
                        this.certificates = new _xfa_object.XFAObjectArray();
                        this.checkButton = new _xfa_object.XFAObjectArray();
                        this.choiceList = new _xfa_object.XFAObjectArray();
                        this.color = new _xfa_object.XFAObjectArray();
                        this.comb = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.contentArea = new _xfa_object.XFAObjectArray();
                        this.corner = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.dateTimeEdit = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.defaultUi = new _xfa_object.XFAObjectArray();
                        this.desc = new _xfa_object.XFAObjectArray();
                        this.digestMethod = new _xfa_object.XFAObjectArray();
                        this.digestMethods = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.edge = new _xfa_object.XFAObjectArray();
                        this.encoding = new _xfa_object.XFAObjectArray();
                        this.encodings = new _xfa_object.XFAObjectArray();
                        this.encrypt = new _xfa_object.XFAObjectArray();
                        this.encryptData = new _xfa_object.XFAObjectArray();
                        this.encryption = new _xfa_object.XFAObjectArray();
                        this.encryptionMethod = new _xfa_object.XFAObjectArray();
                        this.encryptionMethods = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.execute = new _xfa_object.XFAObjectArray();
                        this.extras = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.fill = new _xfa_object.XFAObjectArray();
                        this.filter = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.font = new _xfa_object.XFAObjectArray();
                        this.format = new _xfa_object.XFAObjectArray();
                        this.handler = new _xfa_object.XFAObjectArray();
                        this.hyphenation = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.imageEdit = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.issuers = new _xfa_object.XFAObjectArray();
                        this.items = new _xfa_object.XFAObjectArray();
                        this.keep = new _xfa_object.XFAObjectArray();
                        this.keyUsage = new _xfa_object.XFAObjectArray();
                        this.line = new _xfa_object.XFAObjectArray();
                        this.linear = new _xfa_object.XFAObjectArray();
                        this.lockDocument = new _xfa_object.XFAObjectArray();
                        this.manifest = new _xfa_object.XFAObjectArray();
                        this.margin = new _xfa_object.XFAObjectArray();
                        this.mdp = new _xfa_object.XFAObjectArray();
                        this.medium = new _xfa_object.XFAObjectArray();
                        this.message = new _xfa_object.XFAObjectArray();
                        this.numericEdit = new _xfa_object.XFAObjectArray();
                        this.occur = new _xfa_object.XFAObjectArray();
                        this.oid = new _xfa_object.XFAObjectArray();
                        this.oids = new _xfa_object.XFAObjectArray();
                        this.overflow = new _xfa_object.XFAObjectArray();
                        this.pageArea = new _xfa_object.XFAObjectArray();
                        this.pageSet = new _xfa_object.XFAObjectArray();
                        this.para = new _xfa_object.XFAObjectArray();
                        this.passwordEdit = new _xfa_object.XFAObjectArray();
                        this.pattern = new _xfa_object.XFAObjectArray();
                        this.picture = new _xfa_object.XFAObjectArray();
                        this.radial = new _xfa_object.XFAObjectArray();
                        this.reason = new _xfa_object.XFAObjectArray();
                        this.reasons = new _xfa_object.XFAObjectArray();
                        this.rectangle = new _xfa_object.XFAObjectArray();
                        this.ref = new _xfa_object.XFAObjectArray();
                        this.script = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                        this.signData = new _xfa_object.XFAObjectArray();
                        this.signature = new _xfa_object.XFAObjectArray();
                        this.signing = new _xfa_object.XFAObjectArray();
                        this.solid = new _xfa_object.XFAObjectArray();
                        this.speak = new _xfa_object.XFAObjectArray();
                        this.stipple = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                        this.subjectDN = new _xfa_object.XFAObjectArray();
                        this.subjectDNs = new _xfa_object.XFAObjectArray();
                        this.submit = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.textEdit = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                        this.timeStamp = new _xfa_object.XFAObjectArray();
                        this.toolTip = new _xfa_object.XFAObjectArray();
                        this.traversal = new _xfa_object.XFAObjectArray();
                        this.traverse = new _xfa_object.XFAObjectArray();
                        this.ui = new _xfa_object.XFAObjectArray();
                        this.validate = new _xfa_object.XFAObjectArray();
                        this.value = new _xfa_object.XFAObjectArray();
                        this.variables = new _xfa_object.XFAObjectArray();
                    }
                }
                class Radial extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "radial", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "toEdge",
                            "toCenter"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                        const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                        const colors = this.type === "toEdge" ? `${startColor},${endColor}` : `${endColor},${startColor}`;
                        return `radial-gradient(circle at center, ${colors})`;
                    }
                }
                class Reason extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "reason");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Reasons extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "reasons", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.reason = new _xfa_object.XFAObjectArray();
                    }
                }
                class Rectangle extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "rectangle", true);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.corner = new _xfa_object.XFAObjectArray(4);
                        this.edge = new _xfa_object.XFAObjectArray(4);
                        this.fill = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        const edge = this.edge.children.length ? this.edge.children[0] : new Edge({});
                        const edgeStyle = edge[_symbol_utils.$toStyle]();
                        const style = Object.create(null);
                        if (this.fill?.presence === "visible") Object.assign(style, this.fill[_symbol_utils.$toStyle]());
                        else style.fill = "transparent";
                        style.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                        style.stroke = edgeStyle.color;
                        const corner = this.corner.children.length ? this.corner.children[0] : new Corner({});
                        const cornerStyle = corner[_symbol_utils.$toStyle]();
                        const rect = {
                            name: "rect",
                            attributes: {
                                xmlns: SVG_NS,
                                width: "100%",
                                height: "100%",
                                x: 0,
                                y: 0,
                                rx: cornerStyle.radius,
                                ry: cornerStyle.radius,
                                style: style
                            }
                        };
                        const svg = {
                            name: "svg",
                            children: [
                                rect
                            ],
                            attributes: {
                                xmlns: SVG_NS,
                                style: {
                                    overflow: "visible"
                                },
                                width: "100%",
                                height: "100%"
                            }
                        };
                        const parent = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class RefElement extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "ref");
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Script extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "script");
                        this.binding = attributes.binding || "";
                        this.contentType = attributes.contentType || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.runAt = (0, _utils.getStringOption)(attributes.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SetProperty extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "setProperty");
                        this.connection = attributes.connection || "";
                        this.ref = attributes.ref || "";
                        this.target = attributes.target || "";
                    }
                }
                exports.SetProperty = SetProperty;
                class SignData extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signData", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "sign",
                            "clear",
                            "verify"
                        ]);
                        this.ref = attributes.ref || "";
                        this.target = attributes.target || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Signature extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signature", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "PDF1.3",
                            "PDF1.6"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.filter = null;
                        this.manifest = null;
                        this.margin = null;
                    }
                }
                class Signing extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signing", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class Solid extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "solid", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        return startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                    }
                }
                class Speak extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "speak");
                        this.disable = (0, _utils.getInteger)({
                            data: attributes.disable,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.id = attributes.id || "";
                        this.priority = (0, _utils.getStringOption)(attributes.priority, [
                            "custom",
                            "caption",
                            "name",
                            "toolTip"
                        ]);
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Stipple extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "stipple", true);
                        this.id = attributes.id || "";
                        this.rate = (0, _utils.getInteger)({
                            data: attributes.rate,
                            defaultValue: 50,
                            validate: (x)=>x >= 0 && x <= 100
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](bgColor) {
                        const alpha = this.rate / 100;
                        return _util.Util.makeHexColor(Math.round(bgColor.value.r * (1 - alpha) + this.value.r * alpha), Math.round(bgColor.value.g * (1 - alpha) + this.value.g * alpha), Math.round(bgColor.value.b * (1 - alpha) + this.value.b * alpha));
                    }
                }
                class Subform extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subform", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.allowMacro = (0, _utils.getInteger)({
                            data: attributes.allowMacro,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.columnWidths = (attributes.columnWidths || "").trim().split(/\s+/).map((x)=>x === "-1" ? -1 : (0, _utils.getMeasurement)(x));
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.layout = (0, _utils.getStringOption)(attributes.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.mergeMode = (0, _utils.getStringOption)(attributes.mergeMode, [
                            "consumeData",
                            "matchTemplate"
                        ]);
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.restoreState = (0, _utils.getStringOption)(attributes.restoreState, [
                            "manual",
                            "auto"
                        ]);
                        this.scope = (0, _utils.getStringOption)(attributes.scope, [
                            "name",
                            "none"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.bookend = null;
                        this.border = null;
                        this.break = null;
                        this.calculate = null;
                        this.desc = null;
                        this.extras = null;
                        this.keep = null;
                        this.margin = null;
                        this.occur = null;
                        this.overflow = null;
                        this.pageSet = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.variables = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.proto = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$getSubformParent]() {
                        const parent = this[_symbol_utils.$getParent]();
                        if (parent instanceof SubformSet) return parent[_symbol_utils.$getSubformParent]();
                        return parent;
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine > 0 || this[_symbol_utils.$getParent]()[_symbol_utils.$isThereMoreWidth]();
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_symbol_utils.$flushHTML]() {
                        return (0, _layout.flushHTML)(this);
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        (0, _layout.addHTML)(this, html, bbox);
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return (0, _layout.getAvailableSpace)(this);
                    }
                    [_symbol_utils.$isSplittable]() {
                        const parent = this[_symbol_utils.$getSubformParent]();
                        if (!parent[_symbol_utils.$isSplittable]()) return false;
                        if (this[_symbol_utils.$extra]._isSplittable !== undefined) return this[_symbol_utils.$extra]._isSplittable;
                        if (this.layout === "position" || this.layout.includes("row")) {
                            this[_symbol_utils.$extra]._isSplittable = false;
                            return false;
                        }
                        if (this.keep && this.keep.intact !== "none") {
                            this[_symbol_utils.$extra]._isSplittable = false;
                            return false;
                        }
                        if (parent.layout?.endsWith("-tb") && parent[_symbol_utils.$extra].numberInLine !== 0) return false;
                        this[_symbol_utils.$extra]._isSplittable = true;
                        return true;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (this.break) {
                            if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                                const node = new BreakAfter({
                                    targetType: this.break.after,
                                    target: this.break.afterTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                node[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                                this[_symbol_utils.$appendChild](node);
                                this.breakAfter.push(node);
                            }
                            if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                                const node = new BreakBefore({
                                    targetType: this.break.before,
                                    target: this.break.beforeTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                node[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                                this[_symbol_utils.$appendChild](node);
                                this.breakBefore.push(node);
                            }
                            if (this.break.overflowTarget !== "") {
                                const node = new Overflow({
                                    target: this.break.overflowTarget,
                                    leader: this.break.overflowLeader,
                                    trailer: this.break.overflowTrailer
                                });
                                node[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                                this[_symbol_utils.$appendChild](node);
                                this.overflow.push(node);
                            }
                            this[_symbol_utils.$removeChild](this.break);
                            this.break = null;
                        }
                        if (this.presence === "hidden" || this.presence === "inactive") return _utils.HTMLResult.EMPTY;
                        if (this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) (0, _util.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");
                        if (this.breakBefore.children.length >= 1) {
                            const breakBefore = this.breakBefore.children[0];
                            if (handleBreak(breakBefore)) return _utils.HTMLResult.breakNode(breakBefore);
                        }
                        if (this[_symbol_utils.$extra]?.afterBreakAfter) return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const children = [];
                        const attributes = {
                            id: this[_symbol_utils.$uid],
                            class: []
                        };
                        (0, _html_utils.setAccess)(this, attributes.class);
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = Object.create(null);
                        Object.assign(this[_symbol_utils.$extra], {
                            children: children,
                            line: null,
                            attributes: attributes,
                            attempt: 0,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || Infinity, availableSpace.width),
                                height: Math.min(this.h || Infinity, availableSpace.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const root = this[_symbol_utils.$getTemplateRoot]();
                        const savedNoLayoutFailure = root[_symbol_utils.$extra].noLayoutFailure;
                        const isSplittable = this[_symbol_utils.$isSplittable]();
                        if (!isSplittable) setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) return _utils.HTMLResult.FAILURE;
                        const filter = new Set([
                            "area",
                            "draw",
                            "exclGroup",
                            "field",
                            "subform",
                            "subformSet"
                        ]);
                        if (this.layout.includes("row")) {
                            const columnWidths = this[_symbol_utils.$getSubformParent]().columnWidths;
                            if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                                this[_symbol_utils.$extra].columnWidths = columnWidths;
                                this[_symbol_utils.$extra].currentColumn = 0;
                            }
                        }
                        const style = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                        const classNames = [
                            "xfaSubform"
                        ];
                        const cl = (0, _html_utils.layoutClass)(this);
                        if (cl) classNames.push(cl);
                        attributes.style = style;
                        attributes.class = classNames;
                        if (this.name) attributes.xfaName = this.name;
                        if (this.overflow) {
                            const overflowExtra = this.overflow[_symbol_utils.$getExtra]();
                            if (overflowExtra.addLeader) {
                                overflowExtra.addLeader = false;
                                handleOverflow(this, overflowExtra.leader, availableSpace);
                            }
                        }
                        this[_symbol_utils.$pushPara]();
                        const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                        const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                        for(; this[_symbol_utils.$extra].attempt < maxRun; this[_symbol_utils.$extra].attempt++){
                            if (isLrTb && this[_symbol_utils.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) this[_symbol_utils.$extra].numberInLine = 0;
                            const result = this[_symbol_utils.$childrenToHTML]({
                                filter: filter,
                                include: true
                            });
                            if (result.success) break;
                            if (result.isBreak()) {
                                this[_symbol_utils.$popPara]();
                                return result;
                            }
                            if (isLrTb && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine === 0 && !root[_symbol_utils.$extra].noLayoutFailure) {
                                this[_symbol_utils.$extra].attempt = maxRun;
                                break;
                            }
                        }
                        this[_symbol_utils.$popPara]();
                        if (!isSplittable) unsetFirstUnsplittable(this);
                        root[_symbol_utils.$extra].noLayoutFailure = savedNoLayoutFailure;
                        if (this[_symbol_utils.$extra].attempt === maxRun) {
                            if (this.overflow) this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].overflowNode = this.overflow;
                            if (!isSplittable) delete this[_symbol_utils.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        if (this.overflow) {
                            const overflowExtra = this.overflow[_symbol_utils.$getExtra]();
                            if (overflowExtra.addTrailer) {
                                overflowExtra.addTrailer = false;
                                handleOverflow(this, overflowExtra.trailer, availableSpace);
                            }
                        }
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        const width = Math.max(this[_symbol_utils.$extra].width + marginH, this.w || 0);
                        const height = Math.max(this[_symbol_utils.$extra].height + marginV, this.h || 0);
                        const bbox = [
                            this.x,
                            this.y,
                            width,
                            height
                        ];
                        if (this.w === "") style.width = (0, _html_utils.measureToString)(width);
                        if (this.h === "") style.height = (0, _html_utils.measureToString)(height);
                        if ((style.width === "0px" || style.height === "0px") && children.length === 0) return _utils.HTMLResult.EMPTY;
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        applyAssist(this, attributes);
                        const result = _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        if (this.breakAfter.children.length >= 1) {
                            const breakAfter = this.breakAfter.children[0];
                            if (handleBreak(breakAfter)) {
                                this[_symbol_utils.$extra].afterBreakAfter = result;
                                return _utils.HTMLResult.breakNode(breakAfter);
                            }
                        }
                        delete this[_symbol_utils.$extra];
                        return result;
                    }
                }
                class SubformSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subformSet", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relation = (0, _utils.getStringOption)(attributes.relation, [
                            "ordered",
                            "choice",
                            "unordered"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.bookend = null;
                        this.break = null;
                        this.desc = null;
                        this.extras = null;
                        this.occur = null;
                        this.overflow = null;
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_symbol_utils.$getSubformParent]() {
                        let parent = this[_symbol_utils.$getParent]();
                        while(!(parent instanceof Subform))parent = parent[_symbol_utils.$getParent]();
                        return parent;
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                }
                class SubjectDN extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subjectDN");
                        this.delimiter = attributes.delimiter || ",";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = new Map(this[_symbol_utils.$content].split(this.delimiter).map((kv)=>{
                            kv = kv.split("=", 2);
                            kv[0] = kv[0].trim();
                            return kv;
                        }));
                    }
                }
                class SubjectDNs extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subjectDNs", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.subjectDN = new _xfa_object.XFAObjectArray();
                    }
                }
                class Submit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "submit", true);
                        this.embedPDF = (0, _utils.getInteger)({
                            data: attributes.embedPDF,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.format = (0, _utils.getStringOption)(attributes.format, [
                            "xdp",
                            "formdata",
                            "pdf",
                            "urlencoded",
                            "xfd",
                            "xml"
                        ]);
                        this.id = attributes.id || "";
                        this.target = attributes.target || "";
                        this.textEncoding = (0, _utils.getKeyword)({
                            data: attributes.textEncoding ? attributes.textEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (k)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(k) || k.match(/iso-8859-\d{2}/)
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.xdpContent = attributes.xdpContent || "";
                        this.encrypt = null;
                        this.encryptData = new _xfa_object.XFAObjectArray();
                        this.signData = new _xfa_object.XFAObjectArray();
                    }
                }
                class Template extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "template", true);
                        this.baseProfile = (0, _utils.getStringOption)(attributes.baseProfile, [
                            "full",
                            "interactiveForms"
                        ]);
                        this.extras = null;
                        this.subform = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$finalize]() {
                        if (this.subform.children.length === 0) (0, _util.warn)("XFA - No subforms in template node.");
                        if (this.subform.children.length >= 2) (0, _util.warn)("XFA - Several subforms in template node: please file a bug.");
                        this[_symbol_utils.$tabIndex] = DEFAULT_TAB_INDEX;
                    }
                    [_symbol_utils.$isSplittable]() {
                        return true;
                    }
                    [_symbol_utils.$searchNode](expr, container) {
                        if (expr.startsWith("#")) return [
                            this[_symbol_utils.$ids].get(expr.slice(1))
                        ];
                        return (0, _som.searchNode)(this, container, expr, true, true);
                    }
                    *[_symbol_utils.$toPages]() {
                        if (!this.subform.children.length) return _utils.HTMLResult.success({
                            name: "div",
                            children: []
                        });
                        this[_symbol_utils.$extra] = {
                            overflowNode: null,
                            firstUnsplittable: null,
                            currentContentArea: null,
                            currentPageArea: null,
                            noLayoutFailure: false,
                            pageNumber: 1,
                            pagePosition: "first",
                            oddOrEven: "odd",
                            blankOrNotBlank: "nonBlank",
                            paraStack: []
                        };
                        const root = this.subform.children[0];
                        root.pageSet[_symbol_utils.$cleanPage]();
                        const pageAreas = root.pageSet.pageArea.children;
                        const mainHtml = {
                            name: "div",
                            children: []
                        };
                        let pageArea = null;
                        let breakBefore = null;
                        let breakBeforeTarget = null;
                        if (root.breakBefore.children.length >= 1) {
                            breakBefore = root.breakBefore.children[0];
                            breakBeforeTarget = breakBefore.target;
                        } else if (root.subform.children.length >= 1 && root.subform.children[0].breakBefore.children.length >= 1) {
                            breakBefore = root.subform.children[0].breakBefore.children[0];
                            breakBeforeTarget = breakBefore.target;
                        } else if (root.break?.beforeTarget) {
                            breakBefore = root.break;
                            breakBeforeTarget = breakBefore.beforeTarget;
                        } else if (root.subform.children.length >= 1 && root.subform.children[0].break?.beforeTarget) {
                            breakBefore = root.subform.children[0].break;
                            breakBeforeTarget = breakBefore.beforeTarget;
                        }
                        if (breakBefore) {
                            const target = this[_symbol_utils.$searchNode](breakBeforeTarget, breakBefore[_symbol_utils.$getParent]());
                            if (target instanceof PageArea) {
                                pageArea = target;
                                breakBefore[_symbol_utils.$extra] = {};
                            }
                        }
                        if (!pageArea) pageArea = pageAreas[0];
                        pageArea[_symbol_utils.$extra] = {
                            numberOfUse: 1
                        };
                        const pageAreaParent = pageArea[_symbol_utils.$getParent]();
                        pageAreaParent[_symbol_utils.$extra] = {
                            numberOfUse: 1,
                            pageIndex: pageAreaParent.pageArea.children.indexOf(pageArea),
                            pageSetIndex: 0
                        };
                        let targetPageArea;
                        let leader = null;
                        let trailer = null;
                        let hasSomething = true;
                        let hasSomethingCounter = 0;
                        let startIndex = 0;
                        while(true){
                            if (!hasSomething) {
                                mainHtml.children.pop();
                                if (++hasSomethingCounter === MAX_EMPTY_PAGES) {
                                    (0, _util.warn)("XFA - Something goes wrong: please file a bug.");
                                    return mainHtml;
                                }
                            } else hasSomethingCounter = 0;
                            targetPageArea = null;
                            this[_symbol_utils.$extra].currentPageArea = pageArea;
                            const page = pageArea[_symbol_utils.$toHTML]().html;
                            mainHtml.children.push(page);
                            if (leader) {
                                this[_symbol_utils.$extra].noLayoutFailure = true;
                                page.children.push(leader[_symbol_utils.$toHTML](pageArea[_symbol_utils.$extra].space).html);
                                leader = null;
                            }
                            if (trailer) {
                                this[_symbol_utils.$extra].noLayoutFailure = true;
                                page.children.push(trailer[_symbol_utils.$toHTML](pageArea[_symbol_utils.$extra].space).html);
                                trailer = null;
                            }
                            const contentAreas = pageArea.contentArea.children;
                            const htmlContentAreas = page.children.filter((node)=>node.attributes.class.includes("xfaContentarea"));
                            hasSomething = false;
                            this[_symbol_utils.$extra].firstUnsplittable = null;
                            this[_symbol_utils.$extra].noLayoutFailure = false;
                            const flush = (index)=>{
                                const html = root[_symbol_utils.$flushHTML]();
                                if (html) {
                                    hasSomething ||= html.children?.length > 0;
                                    htmlContentAreas[index].children.push(html);
                                }
                            };
                            for(let i = startIndex, ii = contentAreas.length; i < ii; i++){
                                const contentArea = this[_symbol_utils.$extra].currentContentArea = contentAreas[i];
                                const space = {
                                    width: contentArea.w,
                                    height: contentArea.h
                                };
                                startIndex = 0;
                                if (leader) {
                                    htmlContentAreas[i].children.push(leader[_symbol_utils.$toHTML](space).html);
                                    leader = null;
                                }
                                if (trailer) {
                                    htmlContentAreas[i].children.push(trailer[_symbol_utils.$toHTML](space).html);
                                    trailer = null;
                                }
                                const html = root[_symbol_utils.$toHTML](space);
                                if (html.success) {
                                    if (html.html) {
                                        hasSomething ||= html.html.children?.length > 0;
                                        htmlContentAreas[i].children.push(html.html);
                                    } else if (!hasSomething && mainHtml.children.length > 1) mainHtml.children.pop();
                                    return mainHtml;
                                }
                                if (html.isBreak()) {
                                    const node = html.breakNode;
                                    flush(i);
                                    if (node.targetType === "auto") continue;
                                    if (node.leader) {
                                        leader = this[_symbol_utils.$searchNode](node.leader, node[_symbol_utils.$getParent]());
                                        leader = leader ? leader[0] : null;
                                    }
                                    if (node.trailer) {
                                        trailer = this[_symbol_utils.$searchNode](node.trailer, node[_symbol_utils.$getParent]());
                                        trailer = trailer ? trailer[0] : null;
                                    }
                                    if (node.targetType === "pageArea") {
                                        targetPageArea = node[_symbol_utils.$extra].target;
                                        i = Infinity;
                                    } else if (!node[_symbol_utils.$extra].target) i = node[_symbol_utils.$extra].index;
                                    else {
                                        targetPageArea = node[_symbol_utils.$extra].target;
                                        startIndex = node[_symbol_utils.$extra].index + 1;
                                        i = Infinity;
                                    }
                                    continue;
                                }
                                if (this[_symbol_utils.$extra].overflowNode) {
                                    const node = this[_symbol_utils.$extra].overflowNode;
                                    this[_symbol_utils.$extra].overflowNode = null;
                                    const overflowExtra = node[_symbol_utils.$getExtra]();
                                    const target = overflowExtra.target;
                                    overflowExtra.addLeader = overflowExtra.leader !== null;
                                    overflowExtra.addTrailer = overflowExtra.trailer !== null;
                                    flush(i);
                                    const currentIndex = i;
                                    i = Infinity;
                                    if (target instanceof PageArea) targetPageArea = target;
                                    else if (target instanceof ContentArea) {
                                        const index = contentAreas.indexOf(target);
                                        if (index !== -1) {
                                            if (index > currentIndex) i = index - 1;
                                            else startIndex = index;
                                        } else {
                                            targetPageArea = target[_symbol_utils.$getParent]();
                                            startIndex = targetPageArea.contentArea.children.indexOf(target);
                                        }
                                    }
                                    continue;
                                }
                                flush(i);
                            }
                            this[_symbol_utils.$extra].pageNumber += 1;
                            if (targetPageArea) {
                                if (targetPageArea[_symbol_utils.$isUsable]()) targetPageArea[_symbol_utils.$extra].numberOfUse += 1;
                                else targetPageArea = null;
                            }
                            pageArea = targetPageArea || pageArea[_symbol_utils.$getNextPage]();
                            yield null;
                        }
                    }
                }
                exports.Template = Template;
                class Text extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "text");
                        this.id = attributes.id || "";
                        this.maxChars = (0, _utils.getInteger)({
                            data: attributes.maxChars,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.name = attributes.name || "";
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$acceptWhitespace]() {
                        return true;
                    }
                    [_symbol_utils.$onChild](child) {
                        if (child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                            this[_symbol_utils.$content] = child;
                            return true;
                        }
                        (0, _util.warn)(`XFA - Invalid content in Text: ${child[_symbol_utils.$nodeName]}.`);
                        return false;
                    }
                    [_symbol_utils.$onText](str) {
                        if (this[_symbol_utils.$content] instanceof _xfa_object.XFAObject) return;
                        super[_symbol_utils.$onText](str);
                    }
                    [_symbol_utils.$finalize]() {
                        if (typeof this[_symbol_utils.$content] === "string") this[_symbol_utils.$content] = this[_symbol_utils.$content].replaceAll("\r\n", "\n");
                    }
                    [_symbol_utils.$getExtra]() {
                        if (typeof this[_symbol_utils.$content] === "string") return this[_symbol_utils.$content].split(/[\u2029\u2028\n]/).reduce((acc, line)=>{
                            if (line) acc.push(line);
                            return acc;
                        }, []).join("\n");
                        return this[_symbol_utils.$content][_symbol_utils.$text]();
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (typeof this[_symbol_utils.$content] === "string") {
                            const html = valueToHtml(this[_symbol_utils.$content]).html;
                            if (this[_symbol_utils.$content].includes("\u2029")) {
                                html.name = "div";
                                html.children = [];
                                this[_symbol_utils.$content].split("\u2029").map((para)=>para.split(/[\u2028\n]/).reduce((acc, line)=>{
                                        acc.push({
                                            name: "span",
                                            value: line
                                        }, {
                                            name: "br"
                                        });
                                        return acc;
                                    }, [])).forEach((lines)=>{
                                    html.children.push({
                                        name: "p",
                                        children: lines
                                    });
                                });
                            } else if (/[\u2028\n]/.test(this[_symbol_utils.$content])) {
                                html.name = "div";
                                html.children = [];
                                this[_symbol_utils.$content].split(/[\u2028\n]/).forEach((line)=>{
                                    html.children.push({
                                        name: "span",
                                        value: line
                                    }, {
                                        name: "br"
                                    });
                                });
                            }
                            return _utils.HTMLResult.success(html);
                        }
                        return this[_symbol_utils.$content][_symbol_utils.$toHTML](availableSpace);
                    }
                }
                exports.Text = Text;
                class TextEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "textEdit", true);
                        this.allowRichText = (0, _utils.getInteger)({
                            data: attributes.allowRichText,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.multiLine = (0, _utils.getInteger)({
                            data: attributes.multiLine,
                            defaultValue: "",
                            validate: (x)=>x === 0 || x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.vScrollPolicy = (0, _utils.getStringOption)(attributes.vScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        let html;
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        if (this.multiLine === "") this.multiLine = field instanceof Draw ? 1 : 0;
                        if (this.multiLine === 1) html = {
                            name: "textarea",
                            attributes: {
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                fieldId: field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        else html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                fieldId: field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (isRequired(field)) {
                            html.attributes["aria-required"] = true;
                            html.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Time extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "time");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const date = this[_symbol_utils.$content].trim();
                        this[_symbol_utils.$content] = date ? new Date(date) : null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class TimeStamp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "timeStamp");
                        this.id = attributes.id || "";
                        this.server = attributes.server || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class ToolTip extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "toolTip");
                        this.id = attributes.id || "";
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Traversal extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "traversal", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.traverse = new _xfa_object.XFAObjectArray();
                    }
                }
                class Traverse extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "traverse", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "next",
                            "back",
                            "down",
                            "first",
                            "left",
                            "right",
                            "up"
                        ]);
                        this.ref = attributes.ref || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.script = null;
                    }
                    get name() {
                        return this.operation;
                    }
                    [_symbol_utils.$isTransparent]() {
                        return false;
                    }
                }
                class Ui extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "ui", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.picture = null;
                        this.barcode = null;
                        this.button = null;
                        this.checkButton = null;
                        this.choiceList = null;
                        this.dateTimeEdit = null;
                        this.defaultUi = null;
                        this.imageEdit = null;
                        this.numericEdit = null;
                        this.passwordEdit = null;
                        this.signature = null;
                        this.textEdit = null;
                    }
                    [_symbol_utils.$getExtra]() {
                        if (this[_symbol_utils.$extra] === undefined) {
                            for (const name of Object.getOwnPropertyNames(this)){
                                if (name === "extras" || name === "picture") continue;
                                const obj = this[name];
                                if (!(obj instanceof _xfa_object.XFAObject)) continue;
                                this[_symbol_utils.$extra] = obj;
                                return obj;
                            }
                            this[_symbol_utils.$extra] = null;
                        }
                        return this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const obj = this[_symbol_utils.$getExtra]();
                        if (obj) return obj[_symbol_utils.$toHTML](availableSpace);
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                class Validate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "validate", true);
                        this.formatTest = (0, _utils.getStringOption)(attributes.formatTest, [
                            "warning",
                            "disabled",
                            "error"
                        ]);
                        this.id = attributes.id || "";
                        this.nullTest = (0, _utils.getStringOption)(attributes.nullTest, [
                            "disabled",
                            "error",
                            "warning"
                        ]);
                        this.scriptTest = (0, _utils.getStringOption)(attributes.scriptTest, [
                            "error",
                            "disabled",
                            "warning"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.picture = null;
                        this.script = null;
                    }
                }
                class Value extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "value", true);
                        this.id = attributes.id || "";
                        this.override = (0, _utils.getInteger)({
                            data: attributes.override,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.arc = null;
                        this.boolean = null;
                        this.date = null;
                        this.dateTime = null;
                        this.decimal = null;
                        this.exData = null;
                        this.float = null;
                        this.image = null;
                        this.integer = null;
                        this.line = null;
                        this.rectangle = null;
                        this.text = null;
                        this.time = null;
                    }
                    [_symbol_utils.$setValue](value) {
                        const parent = this[_symbol_utils.$getParent]();
                        if (parent instanceof Field) {
                            if (parent.ui?.imageEdit) {
                                if (!this.image) {
                                    this.image = new Image({});
                                    this[_symbol_utils.$appendChild](this.image);
                                }
                                this.image[_symbol_utils.$content] = value[_symbol_utils.$content];
                                return;
                            }
                        }
                        const valueName = value[_symbol_utils.$nodeName];
                        if (this[valueName] !== null) {
                            this[valueName][_symbol_utils.$content] = value[_symbol_utils.$content];
                            return;
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            const obj = this[name];
                            if (obj instanceof _xfa_object.XFAObject) {
                                this[name] = null;
                                this[_symbol_utils.$removeChild](obj);
                            }
                        }
                        this[value[_symbol_utils.$nodeName]] = value;
                        this[_symbol_utils.$appendChild](value);
                    }
                    [_symbol_utils.$text]() {
                        if (this.exData) {
                            if (typeof this.exData[_symbol_utils.$content] === "string") return this.exData[_symbol_utils.$content].trim();
                            return this.exData[_symbol_utils.$content][_symbol_utils.$text]().trim();
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "image") continue;
                            const obj = this[name];
                            if (obj instanceof _xfa_object.XFAObject) return (obj[_symbol_utils.$content] || "").toString().trim();
                        }
                        return null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        for (const name of Object.getOwnPropertyNames(this)){
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            return obj[_symbol_utils.$toHTML](availableSpace);
                        }
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                exports.Value = Value;
                class Variables extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "variables", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.manifest = new _xfa_object.XFAObjectArray();
                        this.script = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isTransparent]() {
                        return true;
                    }
                }
                class TemplateNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (TemplateNamespace.hasOwnProperty(name)) {
                            const node = TemplateNamespace[name](attributes);
                            node[_symbol_utils.$setSetAttributes](attributes);
                            return node;
                        }
                        return undefined;
                    }
                    static appearanceFilter(attrs) {
                        return new AppearanceFilter(attrs);
                    }
                    static arc(attrs) {
                        return new Arc(attrs);
                    }
                    static area(attrs) {
                        return new Area(attrs);
                    }
                    static assist(attrs) {
                        return new Assist(attrs);
                    }
                    static barcode(attrs) {
                        return new Barcode(attrs);
                    }
                    static bind(attrs) {
                        return new Bind(attrs);
                    }
                    static bindItems(attrs) {
                        return new BindItems(attrs);
                    }
                    static bookend(attrs) {
                        return new Bookend(attrs);
                    }
                    static boolean(attrs) {
                        return new BooleanElement(attrs);
                    }
                    static border(attrs) {
                        return new Border(attrs);
                    }
                    static break(attrs) {
                        return new Break(attrs);
                    }
                    static breakAfter(attrs) {
                        return new BreakAfter(attrs);
                    }
                    static breakBefore(attrs) {
                        return new BreakBefore(attrs);
                    }
                    static button(attrs) {
                        return new Button(attrs);
                    }
                    static calculate(attrs) {
                        return new Calculate(attrs);
                    }
                    static caption(attrs) {
                        return new Caption(attrs);
                    }
                    static certificate(attrs) {
                        return new Certificate(attrs);
                    }
                    static certificates(attrs) {
                        return new Certificates(attrs);
                    }
                    static checkButton(attrs) {
                        return new CheckButton(attrs);
                    }
                    static choiceList(attrs) {
                        return new ChoiceList(attrs);
                    }
                    static color(attrs) {
                        return new Color(attrs);
                    }
                    static comb(attrs) {
                        return new Comb(attrs);
                    }
                    static connect(attrs) {
                        return new Connect(attrs);
                    }
                    static contentArea(attrs) {
                        return new ContentArea(attrs);
                    }
                    static corner(attrs) {
                        return new Corner(attrs);
                    }
                    static date(attrs) {
                        return new DateElement(attrs);
                    }
                    static dateTime(attrs) {
                        return new DateTime(attrs);
                    }
                    static dateTimeEdit(attrs) {
                        return new DateTimeEdit(attrs);
                    }
                    static decimal(attrs) {
                        return new Decimal(attrs);
                    }
                    static defaultUi(attrs) {
                        return new DefaultUi(attrs);
                    }
                    static desc(attrs) {
                        return new Desc(attrs);
                    }
                    static digestMethod(attrs) {
                        return new DigestMethod(attrs);
                    }
                    static digestMethods(attrs) {
                        return new DigestMethods(attrs);
                    }
                    static draw(attrs) {
                        return new Draw(attrs);
                    }
                    static edge(attrs) {
                        return new Edge(attrs);
                    }
                    static encoding(attrs) {
                        return new Encoding(attrs);
                    }
                    static encodings(attrs) {
                        return new Encodings(attrs);
                    }
                    static encrypt(attrs) {
                        return new Encrypt(attrs);
                    }
                    static encryptData(attrs) {
                        return new EncryptData(attrs);
                    }
                    static encryption(attrs) {
                        return new Encryption(attrs);
                    }
                    static encryptionMethod(attrs) {
                        return new EncryptionMethod(attrs);
                    }
                    static encryptionMethods(attrs) {
                        return new EncryptionMethods(attrs);
                    }
                    static event(attrs) {
                        return new Event(attrs);
                    }
                    static exData(attrs) {
                        return new ExData(attrs);
                    }
                    static exObject(attrs) {
                        return new ExObject(attrs);
                    }
                    static exclGroup(attrs) {
                        return new ExclGroup(attrs);
                    }
                    static execute(attrs) {
                        return new Execute(attrs);
                    }
                    static extras(attrs) {
                        return new Extras(attrs);
                    }
                    static field(attrs) {
                        return new Field(attrs);
                    }
                    static fill(attrs) {
                        return new Fill(attrs);
                    }
                    static filter(attrs) {
                        return new Filter(attrs);
                    }
                    static float(attrs) {
                        return new Float(attrs);
                    }
                    static font(attrs) {
                        return new Font(attrs);
                    }
                    static format(attrs) {
                        return new Format(attrs);
                    }
                    static handler(attrs) {
                        return new Handler(attrs);
                    }
                    static hyphenation(attrs) {
                        return new Hyphenation(attrs);
                    }
                    static image(attrs) {
                        return new Image(attrs);
                    }
                    static imageEdit(attrs) {
                        return new ImageEdit(attrs);
                    }
                    static integer(attrs) {
                        return new Integer(attrs);
                    }
                    static issuers(attrs) {
                        return new Issuers(attrs);
                    }
                    static items(attrs) {
                        return new Items(attrs);
                    }
                    static keep(attrs) {
                        return new Keep(attrs);
                    }
                    static keyUsage(attrs) {
                        return new KeyUsage(attrs);
                    }
                    static line(attrs) {
                        return new Line(attrs);
                    }
                    static linear(attrs) {
                        return new Linear(attrs);
                    }
                    static lockDocument(attrs) {
                        return new LockDocument(attrs);
                    }
                    static manifest(attrs) {
                        return new Manifest(attrs);
                    }
                    static margin(attrs) {
                        return new Margin(attrs);
                    }
                    static mdp(attrs) {
                        return new Mdp(attrs);
                    }
                    static medium(attrs) {
                        return new Medium(attrs);
                    }
                    static message(attrs) {
                        return new Message(attrs);
                    }
                    static numericEdit(attrs) {
                        return new NumericEdit(attrs);
                    }
                    static occur(attrs) {
                        return new Occur(attrs);
                    }
                    static oid(attrs) {
                        return new Oid(attrs);
                    }
                    static oids(attrs) {
                        return new Oids(attrs);
                    }
                    static overflow(attrs) {
                        return new Overflow(attrs);
                    }
                    static pageArea(attrs) {
                        return new PageArea(attrs);
                    }
                    static pageSet(attrs) {
                        return new PageSet(attrs);
                    }
                    static para(attrs) {
                        return new Para(attrs);
                    }
                    static passwordEdit(attrs) {
                        return new PasswordEdit(attrs);
                    }
                    static pattern(attrs) {
                        return new Pattern(attrs);
                    }
                    static picture(attrs) {
                        return new Picture(attrs);
                    }
                    static proto(attrs) {
                        return new Proto(attrs);
                    }
                    static radial(attrs) {
                        return new Radial(attrs);
                    }
                    static reason(attrs) {
                        return new Reason(attrs);
                    }
                    static reasons(attrs) {
                        return new Reasons(attrs);
                    }
                    static rectangle(attrs) {
                        return new Rectangle(attrs);
                    }
                    static ref(attrs) {
                        return new RefElement(attrs);
                    }
                    static script(attrs) {
                        return new Script(attrs);
                    }
                    static setProperty(attrs) {
                        return new SetProperty(attrs);
                    }
                    static signData(attrs) {
                        return new SignData(attrs);
                    }
                    static signature(attrs) {
                        return new Signature(attrs);
                    }
                    static signing(attrs) {
                        return new Signing(attrs);
                    }
                    static solid(attrs) {
                        return new Solid(attrs);
                    }
                    static speak(attrs) {
                        return new Speak(attrs);
                    }
                    static stipple(attrs) {
                        return new Stipple(attrs);
                    }
                    static subform(attrs) {
                        return new Subform(attrs);
                    }
                    static subformSet(attrs) {
                        return new SubformSet(attrs);
                    }
                    static subjectDN(attrs) {
                        return new SubjectDN(attrs);
                    }
                    static subjectDNs(attrs) {
                        return new SubjectDNs(attrs);
                    }
                    static submit(attrs) {
                        return new Submit(attrs);
                    }
                    static template(attrs) {
                        return new Template(attrs);
                    }
                    static text(attrs) {
                        return new Text(attrs);
                    }
                    static textEdit(attrs) {
                        return new TextEdit(attrs);
                    }
                    static time(attrs) {
                        return new Time(attrs);
                    }
                    static timeStamp(attrs) {
                        return new TimeStamp(attrs);
                    }
                    static toolTip(attrs) {
                        return new ToolTip(attrs);
                    }
                    static traversal(attrs) {
                        return new Traversal(attrs);
                    }
                    static traverse(attrs) {
                        return new Traverse(attrs);
                    }
                    static ui(attrs) {
                        return new Ui(attrs);
                    }
                    static validate(attrs) {
                        return new Validate(attrs);
                    }
                    static value(attrs) {
                        return new Value(attrs);
                    }
                    static variables(attrs) {
                        return new Variables(attrs);
                    }
                }
                exports.TemplateNamespace = TemplateNamespace;
            /***/ },
            /* 81 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NamespaceIds = exports.$buildXFAObject = void 0;
                const $buildXFAObject = Symbol();
                exports.$buildXFAObject = $buildXFAObject;
                const NamespaceIds = {
                    config: {
                        id: 0,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xci/")
                    },
                    connectionSet: {
                        id: 1,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
                    },
                    datasets: {
                        id: 2,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-data/")
                    },
                    form: {
                        id: 3,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-form/")
                    },
                    localeSet: {
                        id: 4,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
                    },
                    pdf: {
                        id: 5,
                        check: (ns)=>ns === "http://ns.adobe.com/xdp/pdf/"
                    },
                    signature: {
                        id: 6,
                        check: (ns)=>ns === "http://www.w3.org/2000/09/xmldsig#"
                    },
                    sourceSet: {
                        id: 7,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-source-set/")
                    },
                    stylesheet: {
                        id: 8,
                        check: (ns)=>ns === "http://www.w3.org/1999/XSL/Transform"
                    },
                    template: {
                        id: 9,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-template/")
                    },
                    xdc: {
                        id: 10,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xdc/")
                    },
                    xdp: {
                        id: 11,
                        check: (ns)=>ns === "http://ns.adobe.com/xdp/"
                    },
                    xfdf: {
                        id: 12,
                        check: (ns)=>ns === "http://ns.adobe.com/xfdf/"
                    },
                    xhtml: {
                        id: 13,
                        check: (ns)=>ns === "http://www.w3.org/1999/xhtml"
                    },
                    xmpmeta: {
                        id: 14,
                        check: (ns)=>ns === "http://ns.adobe.com/xmpmeta/"
                    }
                };
                exports.NamespaceIds = NamespaceIds;
            /***/ },
            /* 82 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addHTML = addHTML;
                exports.checkDimensions = checkDimensions;
                exports.flushHTML = flushHTML;
                exports.getAvailableSpace = getAvailableSpace;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _html_utils = __w_pdfjs_require__(83);
                function createLine(node, children) {
                    return {
                        name: "div",
                        attributes: {
                            class: [
                                node.layout === "lr-tb" ? "xfaLr" : "xfaRl"
                            ]
                        },
                        children: children
                    };
                }
                function flushHTML(node) {
                    if (!node[_symbol_utils.$extra]) return null;
                    const attributes = node[_symbol_utils.$extra].attributes;
                    const html = {
                        name: "div",
                        attributes: attributes,
                        children: node[_symbol_utils.$extra].children
                    };
                    if (node[_symbol_utils.$extra].failingNode) {
                        const htmlFromFailing = node[_symbol_utils.$extra].failingNode[_symbol_utils.$flushHTML]();
                        if (htmlFromFailing) {
                            if (node.layout.endsWith("-tb")) html.children.push(createLine(node, [
                                htmlFromFailing
                            ]));
                            else html.children.push(htmlFromFailing);
                        }
                    }
                    if (html.children.length === 0) return null;
                    return html;
                }
                function addHTML(node, html, bbox) {
                    const extra = node[_symbol_utils.$extra];
                    const availableSpace = extra.availableSpace;
                    const [x, y, w, h] = bbox;
                    switch(node.layout){
                        case "position":
                            extra.width = Math.max(extra.width, x + w);
                            extra.height = Math.max(extra.height, y + h);
                            extra.children.push(html);
                            break;
                        case "lr-tb":
                        case "rl-tb":
                            if (!extra.line || extra.attempt === 1) {
                                extra.line = createLine(node, []);
                                extra.children.push(extra.line);
                                extra.numberInLine = 0;
                            }
                            extra.numberInLine += 1;
                            extra.line.children.push(html);
                            if (extra.attempt === 0) {
                                extra.currentWidth += w;
                                extra.height = Math.max(extra.height, extra.prevHeight + h);
                            } else {
                                extra.currentWidth = w;
                                extra.prevHeight = extra.height;
                                extra.height += h;
                                extra.attempt = 0;
                            }
                            extra.width = Math.max(extra.width, extra.currentWidth);
                            break;
                        case "rl-row":
                        case "row":
                            {
                                extra.children.push(html);
                                extra.width += w;
                                extra.height = Math.max(extra.height, h);
                                const height = (0, _html_utils.measureToString)(extra.height);
                                for (const child of extra.children)child.attributes.style.height = height;
                                break;
                            }
                        case "table":
                            extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                            extra.height += h;
                            extra.children.push(html);
                            break;
                        case "tb":
                            extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                            extra.height += h;
                            extra.children.push(html);
                            break;
                    }
                }
                function getAvailableSpace(node) {
                    const availableSpace = node[_symbol_utils.$extra].availableSpace;
                    const marginV = node.margin ? node.margin.topInset + node.margin.bottomInset : 0;
                    const marginH = node.margin ? node.margin.leftInset + node.margin.rightInset : 0;
                    switch(node.layout){
                        case "lr-tb":
                        case "rl-tb":
                            if (node[_symbol_utils.$extra].attempt === 0) return {
                                width: availableSpace.width - marginH - node[_symbol_utils.$extra].currentWidth,
                                height: availableSpace.height - marginV - node[_symbol_utils.$extra].prevHeight
                            };
                            return {
                                width: availableSpace.width - marginH,
                                height: availableSpace.height - marginV - node[_symbol_utils.$extra].height
                            };
                        case "rl-row":
                        case "row":
                            const width = node[_symbol_utils.$extra].columnWidths.slice(node[_symbol_utils.$extra].currentColumn).reduce((a, x)=>a + x);
                            return {
                                width: width,
                                height: availableSpace.height - marginH
                            };
                        case "table":
                        case "tb":
                            return {
                                width: availableSpace.width - marginH,
                                height: availableSpace.height - marginV - node[_symbol_utils.$extra].height
                            };
                        case "position":
                        default:
                            return availableSpace;
                    }
                }
                function getTransformedBBox(node) {
                    let w = node.w === "" ? NaN : node.w;
                    let h = node.h === "" ? NaN : node.h;
                    let [centerX, centerY] = [
                        0,
                        0
                    ];
                    switch(node.anchorType || ""){
                        case "bottomCenter":
                            [centerX, centerY] = [
                                w / 2,
                                h
                            ];
                            break;
                        case "bottomLeft":
                            [centerX, centerY] = [
                                0,
                                h
                            ];
                            break;
                        case "bottomRight":
                            [centerX, centerY] = [
                                w,
                                h
                            ];
                            break;
                        case "middleCenter":
                            [centerX, centerY] = [
                                w / 2,
                                h / 2
                            ];
                            break;
                        case "middleLeft":
                            [centerX, centerY] = [
                                0,
                                h / 2
                            ];
                            break;
                        case "middleRight":
                            [centerX, centerY] = [
                                w,
                                h / 2
                            ];
                            break;
                        case "topCenter":
                            [centerX, centerY] = [
                                w / 2,
                                0
                            ];
                            break;
                        case "topRight":
                            [centerX, centerY] = [
                                w,
                                0
                            ];
                            break;
                    }
                    let x, y;
                    switch(node.rotate || 0){
                        case 0:
                            [x, y] = [
                                -centerX,
                                -centerY
                            ];
                            break;
                        case 90:
                            [x, y] = [
                                -centerY,
                                centerX
                            ];
                            [w, h] = [
                                h,
                                -w
                            ];
                            break;
                        case 180:
                            [x, y] = [
                                centerX,
                                centerY
                            ];
                            [w, h] = [
                                -w,
                                -h
                            ];
                            break;
                        case 270:
                            [x, y] = [
                                centerY,
                                -centerX
                            ];
                            [w, h] = [
                                -h,
                                w
                            ];
                            break;
                    }
                    return [
                        node.x + x + Math.min(0, w),
                        node.y + y + Math.min(0, h),
                        Math.abs(w),
                        Math.abs(h)
                    ];
                }
                function checkDimensions(node, space) {
                    if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].firstUnsplittable === null) return true;
                    if (node.w === 0 || node.h === 0) return true;
                    const ERROR = 2;
                    const parent = node[_symbol_utils.$getSubformParent]();
                    const attempt = parent[_symbol_utils.$extra]?.attempt || 0;
                    const [, y, w, h] = getTransformedBBox(node);
                    switch(parent.layout){
                        case "lr-tb":
                        case "rl-tb":
                            if (attempt === 0) {
                                if (!node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                                    if (node.h !== "" && Math.round(h - space.height) > ERROR) return false;
                                    if (node.w !== "") {
                                        if (Math.round(w - space.width) <= ERROR) return true;
                                        if (parent[_symbol_utils.$extra].numberInLine === 0) return space.height > ERROR;
                                        return false;
                                    }
                                    return space.width > ERROR;
                                }
                                if (node.w !== "") return Math.round(w - space.width) <= ERROR;
                                return space.width > ERROR;
                            }
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h !== "" && Math.round(h - space.height) > ERROR) return false;
                            if (node.w === "" || Math.round(w - space.width) <= ERROR) return space.height > ERROR;
                            if (parent[_symbol_utils.$isThereMoreWidth]()) return false;
                            return space.height > ERROR;
                        case "table":
                        case "tb":
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h !== "" && !node[_symbol_utils.$isSplittable]()) return Math.round(h - space.height) <= ERROR;
                            if (node.w === "" || Math.round(w - space.width) <= ERROR) return space.height > ERROR;
                            if (parent[_symbol_utils.$isThereMoreWidth]()) return false;
                            return space.height > ERROR;
                        case "position":
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h === "" || Math.round(h + y - space.height) <= ERROR) return true;
                            const area = node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].currentContentArea;
                            return h + y > area.h;
                        case "rl-row":
                        case "row":
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h !== "") return Math.round(h - space.height) <= ERROR;
                            return true;
                        default:
                            return true;
                    }
                }
            /***/ },
            /* 83 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.computeBbox = computeBbox;
                exports.createWrapper = createWrapper;
                exports.fixDimensions = fixDimensions;
                exports.fixTextIndent = fixTextIndent;
                exports.fixURL = fixURL;
                exports.isPrintOnly = isPrintOnly;
                exports.layoutClass = layoutClass;
                exports.layoutNode = layoutNode;
                exports.measureToString = measureToString;
                exports.setAccess = setAccess;
                exports.setFontFamily = setFontFamily;
                exports.setMinMaxDimensions = setMinMaxDimensions;
                exports.setPara = setPara;
                exports.toStyle = toStyle;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _util = __w_pdfjs_require__(2);
                var _utils = __w_pdfjs_require__(84);
                var _fonts = __w_pdfjs_require__(85);
                var _text = __w_pdfjs_require__(86);
                var _xfa_object = __w_pdfjs_require__(87);
                function measureToString(m) {
                    if (typeof m === "string") return "0px";
                    return Number.isInteger(m) ? `${m}px` : `${m.toFixed(2)}px`;
                }
                const converters = {
                    anchorType (node, style) {
                        const parent = node[_symbol_utils.$getSubformParent]();
                        if (!parent || parent.layout && parent.layout !== "position") return;
                        if (!("transform" in style)) style.transform = "";
                        switch(node.anchorType){
                            case "bottomCenter":
                                style.transform += "translate(-50%, -100%)";
                                break;
                            case "bottomLeft":
                                style.transform += "translate(0,-100%)";
                                break;
                            case "bottomRight":
                                style.transform += "translate(-100%,-100%)";
                                break;
                            case "middleCenter":
                                style.transform += "translate(-50%,-50%)";
                                break;
                            case "middleLeft":
                                style.transform += "translate(0,-50%)";
                                break;
                            case "middleRight":
                                style.transform += "translate(-100%,-50%)";
                                break;
                            case "topCenter":
                                style.transform += "translate(-50%,0)";
                                break;
                            case "topRight":
                                style.transform += "translate(-100%,0)";
                                break;
                        }
                    },
                    dimensions (node, style) {
                        const parent = node[_symbol_utils.$getSubformParent]();
                        let width = node.w;
                        const height = node.h;
                        if (parent.layout?.includes("row")) {
                            const extra = parent[_symbol_utils.$extra];
                            const colSpan = node.colSpan;
                            let w;
                            if (colSpan === -1) {
                                w = extra.columnWidths.slice(extra.currentColumn).reduce((a, x)=>a + x, 0);
                                extra.currentColumn = 0;
                            } else {
                                w = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, x)=>a + x, 0);
                                extra.currentColumn = (extra.currentColumn + node.colSpan) % extra.columnWidths.length;
                            }
                            if (!isNaN(w)) width = node.w = w;
                        }
                        style.width = width !== "" ? measureToString(width) : "auto";
                        style.height = height !== "" ? measureToString(height) : "auto";
                    },
                    position (node, style) {
                        const parent = node[_symbol_utils.$getSubformParent]();
                        if (parent?.layout && parent.layout !== "position") return;
                        style.position = "absolute";
                        style.left = measureToString(node.x);
                        style.top = measureToString(node.y);
                    },
                    rotate (node, style) {
                        if (node.rotate) {
                            if (!("transform" in style)) style.transform = "";
                            style.transform += `rotate(-${node.rotate}deg)`;
                            style.transformOrigin = "top left";
                        }
                    },
                    presence (node, style) {
                        switch(node.presence){
                            case "invisible":
                                style.visibility = "hidden";
                                break;
                            case "hidden":
                            case "inactive":
                                style.display = "none";
                                break;
                        }
                    },
                    hAlign (node, style) {
                        if (node[_symbol_utils.$nodeName] === "para") switch(node.hAlign){
                            case "justifyAll":
                                style.textAlign = "justify-all";
                                break;
                            case "radix":
                                style.textAlign = "left";
                                break;
                            default:
                                style.textAlign = node.hAlign;
                        }
                        else switch(node.hAlign){
                            case "left":
                                style.alignSelf = "start";
                                break;
                            case "center":
                                style.alignSelf = "center";
                                break;
                            case "right":
                                style.alignSelf = "end";
                                break;
                        }
                    },
                    margin (node, style) {
                        if (node.margin) style.margin = node.margin[_symbol_utils.$toStyle]().margin;
                    }
                };
                function setMinMaxDimensions(node, style) {
                    const parent = node[_symbol_utils.$getSubformParent]();
                    if (parent.layout === "position") {
                        if (node.minW > 0) style.minWidth = measureToString(node.minW);
                        if (node.maxW > 0) style.maxWidth = measureToString(node.maxW);
                        if (node.minH > 0) style.minHeight = measureToString(node.minH);
                        if (node.maxH > 0) style.maxHeight = measureToString(node.maxH);
                    }
                }
                function layoutText(text, xfaFont, margin, lineHeight, fontFinder, width) {
                    const measure = new _text.TextMeasure(xfaFont, margin, lineHeight, fontFinder);
                    if (typeof text === "string") measure.addString(text);
                    else text[_symbol_utils.$pushGlyphs](measure);
                    return measure.compute(width);
                }
                function layoutNode(node, availableSpace) {
                    let height = null;
                    let width = null;
                    let isBroken = false;
                    if ((!node.w || !node.h) && node.value) {
                        let marginH = 0;
                        let marginV = 0;
                        if (node.margin) {
                            marginH = node.margin.leftInset + node.margin.rightInset;
                            marginV = node.margin.topInset + node.margin.bottomInset;
                        }
                        let lineHeight = null;
                        let margin = null;
                        if (node.para) {
                            margin = Object.create(null);
                            lineHeight = node.para.lineHeight === "" ? null : node.para.lineHeight;
                            margin.top = node.para.spaceAbove === "" ? 0 : node.para.spaceAbove;
                            margin.bottom = node.para.spaceBelow === "" ? 0 : node.para.spaceBelow;
                            margin.left = node.para.marginLeft === "" ? 0 : node.para.marginLeft;
                            margin.right = node.para.marginRight === "" ? 0 : node.para.marginRight;
                        }
                        let font1 = node.font;
                        if (!font1) {
                            const root = node[_symbol_utils.$getTemplateRoot]();
                            let parent = node[_symbol_utils.$getParent]();
                            while(parent && parent !== root){
                                if (parent.font) {
                                    font1 = parent.font;
                                    break;
                                }
                                parent = parent[_symbol_utils.$getParent]();
                            }
                        }
                        const maxWidth = (node.w || availableSpace.width) - marginH;
                        const fontFinder = node[_symbol_utils.$globalData].fontFinder;
                        if (node.value.exData && node.value.exData[_symbol_utils.$content] && node.value.exData.contentType === "text/html") {
                            const res = layoutText(node.value.exData[_symbol_utils.$content], font1, margin, lineHeight, fontFinder, maxWidth);
                            width = res.width;
                            height = res.height;
                            isBroken = res.isBroken;
                        } else {
                            const text = node.value[_symbol_utils.$text]();
                            if (text) {
                                const res = layoutText(text, font1, margin, lineHeight, fontFinder, maxWidth);
                                width = res.width;
                                height = res.height;
                                isBroken = res.isBroken;
                            }
                        }
                        if (width !== null && !node.w) width += marginH;
                        if (height !== null && !node.h) height += marginV;
                    }
                    return {
                        w: width,
                        h: height,
                        isBroken: isBroken
                    };
                }
                function computeBbox(node, html, availableSpace) {
                    let bbox;
                    if (node.w !== "" && node.h !== "") bbox = [
                        node.x,
                        node.y,
                        node.w,
                        node.h
                    ];
                    else {
                        if (!availableSpace) return null;
                        let width = node.w;
                        if (width === "") {
                            if (node.maxW === 0) {
                                const parent = node[_symbol_utils.$getSubformParent]();
                                width = parent.layout === "position" && parent.w !== "" ? 0 : node.minW;
                            } else width = Math.min(node.maxW, availableSpace.width);
                            html.attributes.style.width = measureToString(width);
                        }
                        let height = node.h;
                        if (height === "") {
                            if (node.maxH === 0) {
                                const parent = node[_symbol_utils.$getSubformParent]();
                                height = parent.layout === "position" && parent.h !== "" ? 0 : node.minH;
                            } else height = Math.min(node.maxH, availableSpace.height);
                            html.attributes.style.height = measureToString(height);
                        }
                        bbox = [
                            node.x,
                            node.y,
                            width,
                            height
                        ];
                    }
                    return bbox;
                }
                function fixDimensions(node) {
                    const parent = node[_symbol_utils.$getSubformParent]();
                    if (parent.layout?.includes("row")) {
                        const extra = parent[_symbol_utils.$extra];
                        const colSpan = node.colSpan;
                        let width;
                        if (colSpan === -1) width = extra.columnWidths.slice(extra.currentColumn).reduce((a, w)=>a + w, 0);
                        else width = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, w)=>a + w, 0);
                        if (!isNaN(width)) node.w = width;
                    }
                    if (parent.layout && parent.layout !== "position") node.x = node.y = 0;
                    if (node.layout === "table") {
                        if (node.w === "" && Array.isArray(node.columnWidths)) node.w = node.columnWidths.reduce((a, x)=>a + x, 0);
                    }
                }
                function layoutClass(node) {
                    switch(node.layout){
                        case "position":
                            return "xfaPosition";
                        case "lr-tb":
                            return "xfaLrTb";
                        case "rl-row":
                            return "xfaRlRow";
                        case "rl-tb":
                            return "xfaRlTb";
                        case "row":
                            return "xfaRow";
                        case "table":
                            return "xfaTable";
                        case "tb":
                            return "xfaTb";
                        default:
                            return "xfaPosition";
                    }
                }
                function toStyle(node, ...names) {
                    const style = Object.create(null);
                    for (const name of names){
                        const value = node[name];
                        if (value === null) continue;
                        if (converters.hasOwnProperty(name)) {
                            converters[name](node, style);
                            continue;
                        }
                        if (value instanceof _xfa_object.XFAObject) {
                            const newStyle = value[_symbol_utils.$toStyle]();
                            if (newStyle) Object.assign(style, newStyle);
                            else (0, _util.warn)(`(DEBUG) - XFA - style for ${name} not implemented yet`);
                        }
                    }
                    return style;
                }
                function createWrapper(node, html) {
                    const { attributes: attributes } = html;
                    const { style: style } = attributes;
                    const wrapper = {
                        name: "div",
                        attributes: {
                            class: [
                                "xfaWrapper"
                            ],
                            style: Object.create(null)
                        },
                        children: []
                    };
                    attributes.class.push("xfaWrapped");
                    if (node.border) {
                        const { widths: widths, insets: insets } = node.border[_symbol_utils.$extra];
                        let width, height;
                        let top = insets[0];
                        let left = insets[3];
                        const insetsH = insets[0] + insets[2];
                        const insetsW = insets[1] + insets[3];
                        switch(node.border.hand){
                            case "even":
                                top -= widths[0] / 2;
                                left -= widths[3] / 2;
                                width = `calc(100% + ${(widths[1] + widths[3]) / 2 - insetsW}px)`;
                                height = `calc(100% + ${(widths[0] + widths[2]) / 2 - insetsH}px)`;
                                break;
                            case "left":
                                top -= widths[0];
                                left -= widths[3];
                                width = `calc(100% + ${widths[1] + widths[3] - insetsW}px)`;
                                height = `calc(100% + ${widths[0] + widths[2] - insetsH}px)`;
                                break;
                            case "right":
                                width = insetsW ? `calc(100% - ${insetsW}px)` : "100%";
                                height = insetsH ? `calc(100% - ${insetsH}px)` : "100%";
                                break;
                        }
                        const classNames = [
                            "xfaBorder"
                        ];
                        if (isPrintOnly(node.border)) classNames.push("xfaPrintOnly");
                        const border = {
                            name: "div",
                            attributes: {
                                class: classNames,
                                style: {
                                    top: `${top}px`,
                                    left: `${left}px`,
                                    width: width,
                                    height: height
                                }
                            },
                            children: []
                        };
                        for (const key of [
                            "border",
                            "borderWidth",
                            "borderColor",
                            "borderRadius",
                            "borderStyle"
                        ])if (style[key] !== undefined) {
                            border.attributes.style[key] = style[key];
                            delete style[key];
                        }
                        wrapper.children.push(border, html);
                    } else wrapper.children.push(html);
                    for (const key of [
                        "background",
                        "backgroundClip",
                        "top",
                        "left",
                        "width",
                        "height",
                        "minWidth",
                        "minHeight",
                        "maxWidth",
                        "maxHeight",
                        "transform",
                        "transformOrigin",
                        "visibility"
                    ])if (style[key] !== undefined) {
                        wrapper.attributes.style[key] = style[key];
                        delete style[key];
                    }
                    wrapper.attributes.style.position = style.position === "absolute" ? "absolute" : "relative";
                    delete style.position;
                    if (style.alignSelf) {
                        wrapper.attributes.style.alignSelf = style.alignSelf;
                        delete style.alignSelf;
                    }
                    return wrapper;
                }
                function fixTextIndent(styles) {
                    const indent = (0, _utils.getMeasurement)(styles.textIndent, "0px");
                    if (indent >= 0) return;
                    const align = styles.textAlign === "right" ? "right" : "left";
                    const name = "padding" + (align === "left" ? "Left" : "Right");
                    const padding = (0, _utils.getMeasurement)(styles[name], "0px");
                    styles[name] = `${padding - indent}px`;
                }
                function setAccess(node, classNames) {
                    switch(node.access){
                        case "nonInteractive":
                            classNames.push("xfaNonInteractive");
                            break;
                        case "readOnly":
                            classNames.push("xfaReadOnly");
                            break;
                        case "protected":
                            classNames.push("xfaDisabled");
                            break;
                    }
                }
                function isPrintOnly(node) {
                    return node.relevant.length > 0 && !node.relevant[0].excluded && node.relevant[0].viewname === "print";
                }
                function getCurrentPara(node) {
                    const stack = node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack;
                    return stack.length ? stack.at(-1) : null;
                }
                function setPara(node, nodeStyle, value) {
                    if (value.attributes.class?.includes("xfaRich")) {
                        if (nodeStyle) {
                            if (node.h === "") nodeStyle.height = "auto";
                            if (node.w === "") nodeStyle.width = "auto";
                        }
                        const para = getCurrentPara(node);
                        if (para) {
                            const valueStyle = value.attributes.style;
                            valueStyle.display = "flex";
                            valueStyle.flexDirection = "column";
                            switch(para.vAlign){
                                case "top":
                                    valueStyle.justifyContent = "start";
                                    break;
                                case "bottom":
                                    valueStyle.justifyContent = "end";
                                    break;
                                case "middle":
                                    valueStyle.justifyContent = "center";
                                    break;
                            }
                            const paraStyle = para[_symbol_utils.$toStyle]();
                            for (const [key, val] of Object.entries(paraStyle))if (!(key in valueStyle)) valueStyle[key] = val;
                        }
                    }
                }
                function setFontFamily(xfaFont, node, fontFinder, style) {
                    if (!fontFinder) {
                        delete style.fontFamily;
                        return;
                    }
                    const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                    style.fontFamily = `"${name}"`;
                    const typeface = fontFinder.find(name);
                    if (typeface) {
                        const { fontFamily: fontFamily } = typeface.regular.cssFontInfo;
                        if (fontFamily !== name) style.fontFamily = `"${fontFamily}"`;
                        const para = getCurrentPara(node);
                        if (para && para.lineHeight !== "") return;
                        if (style.lineHeight) return;
                        const pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                        if (pdfFont) style.lineHeight = Math.max(1.2, pdfFont.lineHeight);
                    }
                }
                function fixURL(str) {
                    const absoluteUrl = (0, _util.createValidAbsoluteUrl)(str, null, {
                        addDefaultProtocol: true,
                        tryConvertEncoding: true
                    });
                    return absoluteUrl ? absoluteUrl.href : null;
                }
            /***/ },
            /* 84 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HTMLResult = void 0;
                exports.getBBox = getBBox;
                exports.getColor = getColor;
                exports.getFloat = getFloat;
                exports.getInteger = getInteger;
                exports.getKeyword = getKeyword;
                exports.getMeasurement = getMeasurement;
                exports.getRatio = getRatio;
                exports.getRelevant = getRelevant;
                exports.getStringOption = getStringOption;
                exports.stripQuotes = stripQuotes;
                var _util = __w_pdfjs_require__(2);
                const dimConverters = {
                    pt: (x)=>x,
                    cm: (x)=>x / 2.54 * 72,
                    mm: (x)=>x / 25.4 * 72,
                    in: (x)=>x * 72,
                    px: (x)=>x
                };
                const measurementPattern = /([+-]?\d+\.?\d*)(.*)/;
                function stripQuotes(str) {
                    if (str.startsWith("'") || str.startsWith('"')) return str.slice(1, -1);
                    return str;
                }
                function getInteger({ data: data, defaultValue: defaultValue, validate: validate }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    const n = parseInt(data, 10);
                    if (!isNaN(n) && validate(n)) return n;
                    return defaultValue;
                }
                function getFloat({ data: data, defaultValue: defaultValue, validate: validate }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    const n = parseFloat(data);
                    if (!isNaN(n) && validate(n)) return n;
                    return defaultValue;
                }
                function getKeyword({ data: data, defaultValue: defaultValue, validate: validate }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    if (validate(data)) return data;
                    return defaultValue;
                }
                function getStringOption(data, options) {
                    return getKeyword({
                        data: data,
                        defaultValue: options[0],
                        validate: (k)=>options.includes(k)
                    });
                }
                function getMeasurement(str, def = "0") {
                    def ||= "0";
                    if (!str) return getMeasurement(def);
                    const match = str.trim().match(measurementPattern);
                    if (!match) return getMeasurement(def);
                    const [, valueStr, unit] = match;
                    const value = parseFloat(valueStr);
                    if (isNaN(value)) return getMeasurement(def);
                    if (value === 0) return 0;
                    const conv = dimConverters[unit];
                    if (conv) return conv(value);
                    return value;
                }
                function getRatio(data) {
                    if (!data) return {
                        num: 1,
                        den: 1
                    };
                    const ratio = data.trim().split(/\s*:\s*/).map((x)=>parseFloat(x)).filter((x)=>!isNaN(x));
                    if (ratio.length === 1) ratio.push(1);
                    if (ratio.length === 0) return {
                        num: 1,
                        den: 1
                    };
                    const [num, den] = ratio;
                    return {
                        num: num,
                        den: den
                    };
                }
                function getRelevant(data) {
                    if (!data) return [];
                    return data.trim().split(/\s+/).map((e)=>{
                        return {
                            excluded: e[0] === "-",
                            viewname: e.substring(1)
                        };
                    });
                }
                function getColor(data, def = [
                    0,
                    0,
                    0
                ]) {
                    let [r, g, b] = def;
                    if (!data) return {
                        r: r,
                        g: g,
                        b: b
                    };
                    const color = data.trim().split(/\s*,\s*/).map((c)=>Math.min(Math.max(0, parseInt(c.trim(), 10)), 255)).map((c)=>isNaN(c) ? 0 : c);
                    if (color.length < 3) return {
                        r: r,
                        g: g,
                        b: b
                    };
                    [r, g, b] = color;
                    return {
                        r: r,
                        g: g,
                        b: b
                    };
                }
                function getBBox(data) {
                    const def = -1;
                    if (!data) return {
                        x: def,
                        y: def,
                        width: def,
                        height: def
                    };
                    const bbox = data.trim().split(/\s*,\s*/).map((m)=>getMeasurement(m, "-1"));
                    if (bbox.length < 4 || bbox[2] < 0 || bbox[3] < 0) return {
                        x: def,
                        y: def,
                        width: def,
                        height: def
                    };
                    const [x, y, width, height] = bbox;
                    return {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                }
                class HTMLResult {
                    static get FAILURE() {
                        return (0, _util.shadow)(this, "FAILURE", new HTMLResult(false, null, null, null));
                    }
                    static get EMPTY() {
                        return (0, _util.shadow)(this, "EMPTY", new HTMLResult(true, null, null, null));
                    }
                    constructor(success, html, bbox, breakNode){
                        this.success = success;
                        this.html = html;
                        this.bbox = bbox;
                        this.breakNode = breakNode;
                    }
                    isBreak() {
                        return !!this.breakNode;
                    }
                    static breakNode(node) {
                        return new HTMLResult(false, null, null, node);
                    }
                    static success(html, bbox = null) {
                        return new HTMLResult(true, html, bbox, null);
                    }
                }
                exports.HTMLResult = HTMLResult;
            /***/ },
            /* 85 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontFinder = void 0;
                exports.getMetrics = getMetrics;
                exports.selectFont = selectFont;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                class FontFinder {
                    constructor(pdfFonts){
                        this.fonts = new Map();
                        this.cache = new Map();
                        this.warned = new Set();
                        this.defaultFont = null;
                        this.add(pdfFonts);
                    }
                    add(pdfFonts, reallyMissingFonts = null) {
                        for (const pdfFont of pdfFonts)this.addPdfFont(pdfFont);
                        for (const pdfFont of this.fonts.values())if (!pdfFont.regular) pdfFont.regular = pdfFont.italic || pdfFont.bold || pdfFont.bolditalic;
                        if (!reallyMissingFonts || reallyMissingFonts.size === 0) return;
                        const myriad = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
                        for (const missing of reallyMissingFonts)this.fonts.set(missing, myriad);
                    }
                    addPdfFont(pdfFont) {
                        const cssFontInfo = pdfFont.cssFontInfo;
                        const name = cssFontInfo.fontFamily;
                        let font1 = this.fonts.get(name);
                        if (!font1) {
                            font1 = Object.create(null);
                            this.fonts.set(name, font1);
                            if (!this.defaultFont) this.defaultFont = font1;
                        }
                        let property = "";
                        const fontWeight = parseFloat(cssFontInfo.fontWeight);
                        if (parseFloat(cssFontInfo.italicAngle) !== 0) property = fontWeight >= 700 ? "bolditalic" : "italic";
                        else if (fontWeight >= 700) property = "bold";
                        if (!property) {
                            if (pdfFont.name.includes("Bold") || pdfFont.psName?.includes("Bold")) property = "bold";
                            if (pdfFont.name.includes("Italic") || pdfFont.name.endsWith("It") || pdfFont.psName?.includes("Italic") || pdfFont.psName?.endsWith("It")) property += "italic";
                        }
                        if (!property) property = "regular";
                        font1[property] = pdfFont;
                    }
                    getDefault() {
                        return this.defaultFont;
                    }
                    find(fontName, mustWarn = true) {
                        let font1 = this.fonts.get(fontName) || this.cache.get(fontName);
                        if (font1) return font1;
                        const pattern = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
                        let name = fontName.replaceAll(pattern, "");
                        font1 = this.fonts.get(name);
                        if (font1) {
                            this.cache.set(fontName, font1);
                            return font1;
                        }
                        name = name.toLowerCase();
                        const maybe = [];
                        for (const [family, pdfFont] of this.fonts.entries())if (family.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        if (maybe.length === 0) {
                            for (const [, pdfFont] of this.fonts.entries())if (pdfFont.regular.name?.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length === 0) {
                            name = name.replaceAll(/psmt|mt/gi, "");
                            for (const [family, pdfFont] of this.fonts.entries())if (family.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length === 0) {
                            for (const pdfFont of this.fonts.values())if (pdfFont.regular.name?.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length >= 1) {
                            if (maybe.length !== 1 && mustWarn) (0, _util.warn)(`XFA - Too many choices to guess the correct font: ${fontName}`);
                            this.cache.set(fontName, maybe[0]);
                            return maybe[0];
                        }
                        if (mustWarn && !this.warned.has(fontName)) {
                            this.warned.add(fontName);
                            (0, _util.warn)(`XFA - Cannot find the font: ${fontName}`);
                        }
                        return null;
                    }
                }
                exports.FontFinder = FontFinder;
                function selectFont(xfaFont, typeface) {
                    if (xfaFont.posture === "italic") {
                        if (xfaFont.weight === "bold") return typeface.bolditalic;
                        return typeface.italic;
                    } else if (xfaFont.weight === "bold") return typeface.bold;
                    return typeface.regular;
                }
                function getMetrics(xfaFont, real = false) {
                    let pdfFont = null;
                    if (xfaFont) {
                        const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                        const typeface = xfaFont[_symbol_utils.$globalData].fontFinder.find(name);
                        pdfFont = selectFont(xfaFont, typeface);
                    }
                    if (!pdfFont) return {
                        lineHeight: 12,
                        lineGap: 2,
                        lineNoGap: 10
                    };
                    const size = xfaFont.size || 10;
                    const lineHeight = pdfFont.lineHeight ? Math.max(real ? 0 : 1.2, pdfFont.lineHeight) : 1.2;
                    const lineGap = pdfFont.lineGap === undefined ? 0.2 : pdfFont.lineGap;
                    return {
                        lineHeight: lineHeight * size,
                        lineGap: lineGap * size,
                        lineNoGap: Math.max(1, lineHeight - lineGap) * size
                    };
                }
            /***/ },
            /* 86 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextMeasure = void 0;
                var _fonts = __w_pdfjs_require__(85);
                const WIDTH_FACTOR = 1.02;
                class FontInfo {
                    constructor(xfaFont, margin, lineHeight, fontFinder){
                        this.lineHeight = lineHeight;
                        this.paraMargin = margin || {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                        };
                        if (!xfaFont) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                            return;
                        }
                        this.xfaFont = {
                            typeface: xfaFont.typeface,
                            posture: xfaFont.posture,
                            weight: xfaFont.weight,
                            size: xfaFont.size,
                            letterSpacing: xfaFont.letterSpacing
                        };
                        const typeface = fontFinder.find(xfaFont.typeface);
                        if (!typeface) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                            return;
                        }
                        this.pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                        if (!this.pdfFont) [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                    }
                    defaultFont(fontFinder) {
                        const font1 = fontFinder.find("Helvetica", false) || fontFinder.find("Myriad Pro", false) || fontFinder.find("Arial", false) || fontFinder.getDefault();
                        if (font1?.regular) {
                            const pdfFont = font1.regular;
                            const info = pdfFont.cssFontInfo;
                            const xfaFont = {
                                typeface: info.fontFamily,
                                posture: "normal",
                                weight: "normal",
                                size: 10,
                                letterSpacing: 0
                            };
                            return [
                                pdfFont,
                                xfaFont
                            ];
                        }
                        const xfaFont = {
                            typeface: "Courier",
                            posture: "normal",
                            weight: "normal",
                            size: 10,
                            letterSpacing: 0
                        };
                        return [
                            null,
                            xfaFont
                        ];
                    }
                }
                class FontSelector {
                    constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder){
                        this.fontFinder = fontFinder;
                        this.stack = [
                            new FontInfo(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder)
                        ];
                    }
                    pushData(xfaFont, margin, lineHeight) {
                        const lastFont = this.stack.at(-1);
                        for (const name of [
                            "typeface",
                            "posture",
                            "weight",
                            "size",
                            "letterSpacing"
                        ])if (!xfaFont[name]) xfaFont[name] = lastFont.xfaFont[name];
                        for (const name of [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ])if (isNaN(margin[name])) margin[name] = lastFont.paraMargin[name];
                        const fontInfo = new FontInfo(xfaFont, margin, lineHeight || lastFont.lineHeight, this.fontFinder);
                        if (!fontInfo.pdfFont) fontInfo.pdfFont = lastFont.pdfFont;
                        this.stack.push(fontInfo);
                    }
                    popFont() {
                        this.stack.pop();
                    }
                    topFont() {
                        return this.stack.at(-1);
                    }
                }
                class TextMeasure {
                    constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts){
                        this.glyphs = [];
                        this.fontSelector = new FontSelector(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts);
                        this.extraHeight = 0;
                    }
                    pushData(xfaFont, margin, lineHeight) {
                        this.fontSelector.pushData(xfaFont, margin, lineHeight);
                    }
                    popFont(xfaFont) {
                        return this.fontSelector.popFont();
                    }
                    addPara() {
                        const lastFont = this.fontSelector.topFont();
                        this.extraHeight += lastFont.paraMargin.top + lastFont.paraMargin.bottom;
                    }
                    addString(str) {
                        if (!str) return;
                        const lastFont = this.fontSelector.topFont();
                        const fontSize = lastFont.xfaFont.size;
                        if (lastFont.pdfFont) {
                            const letterSpacing = lastFont.xfaFont.letterSpacing;
                            const pdfFont = lastFont.pdfFont;
                            const fontLineHeight = pdfFont.lineHeight || 1.2;
                            const lineHeight = lastFont.lineHeight || Math.max(1.2, fontLineHeight) * fontSize;
                            const lineGap = pdfFont.lineGap === undefined ? 0.2 : pdfFont.lineGap;
                            const noGap = fontLineHeight - lineGap;
                            const firstLineHeight = Math.max(1, noGap) * fontSize;
                            const scale = fontSize / 1000;
                            const fallbackWidth = pdfFont.defaultWidth || pdfFont.charsToGlyphs(" ")[0].width;
                            for (const line of str.split(/[\u2029\n]/)){
                                const encodedLine = pdfFont.encodeString(line).join("");
                                const glyphs = pdfFont.charsToGlyphs(encodedLine);
                                for (const glyph of glyphs){
                                    const width = glyph.width || fallbackWidth;
                                    this.glyphs.push([
                                        width * scale + letterSpacing,
                                        lineHeight,
                                        firstLineHeight,
                                        glyph.unicode,
                                        false
                                    ]);
                                }
                                this.glyphs.push([
                                    0,
                                    0,
                                    0,
                                    "\n",
                                    true
                                ]);
                            }
                            this.glyphs.pop();
                            return;
                        }
                        for (const line of str.split(/[\u2029\n]/)){
                            for (const char of line.split(""))this.glyphs.push([
                                fontSize,
                                1.2 * fontSize,
                                fontSize,
                                char,
                                false
                            ]);
                            this.glyphs.push([
                                0,
                                0,
                                0,
                                "\n",
                                true
                            ]);
                        }
                        this.glyphs.pop();
                    }
                    compute(maxWidth) {
                        let lastSpacePos = -1, lastSpaceWidth = 0, width = 0, height = 0, currentLineWidth = 0, currentLineHeight = 0;
                        let isBroken = false;
                        let isFirstLine = true;
                        for(let i = 0, ii = this.glyphs.length; i < ii; i++){
                            const [glyphWidth, lineHeight, firstLineHeight, char, isEOL] = this.glyphs[i];
                            const isSpace = char === " ";
                            const glyphHeight = isFirstLine ? firstLineHeight : lineHeight;
                            if (isEOL) {
                                width = Math.max(width, currentLineWidth);
                                currentLineWidth = 0;
                                height += currentLineHeight;
                                currentLineHeight = glyphHeight;
                                lastSpacePos = -1;
                                lastSpaceWidth = 0;
                                isFirstLine = false;
                                continue;
                            }
                            if (isSpace) {
                                if (currentLineWidth + glyphWidth > maxWidth) {
                                    width = Math.max(width, currentLineWidth);
                                    currentLineWidth = 0;
                                    height += currentLineHeight;
                                    currentLineHeight = glyphHeight;
                                    lastSpacePos = -1;
                                    lastSpaceWidth = 0;
                                    isBroken = true;
                                    isFirstLine = false;
                                } else {
                                    currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                                    lastSpaceWidth = currentLineWidth;
                                    currentLineWidth += glyphWidth;
                                    lastSpacePos = i;
                                }
                                continue;
                            }
                            if (currentLineWidth + glyphWidth > maxWidth) {
                                height += currentLineHeight;
                                currentLineHeight = glyphHeight;
                                if (lastSpacePos !== -1) {
                                    i = lastSpacePos;
                                    width = Math.max(width, lastSpaceWidth);
                                    currentLineWidth = 0;
                                    lastSpacePos = -1;
                                    lastSpaceWidth = 0;
                                } else {
                                    width = Math.max(width, currentLineWidth);
                                    currentLineWidth = glyphWidth;
                                }
                                isBroken = true;
                                isFirstLine = false;
                                continue;
                            }
                            currentLineWidth += glyphWidth;
                            currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                        }
                        width = Math.max(width, currentLineWidth);
                        height += currentLineHeight + this.extraHeight;
                        return {
                            width: WIDTH_FACTOR * width,
                            height: height,
                            isBroken: isBroken
                        };
                    }
                }
                exports.TextMeasure = TextMeasure;
            /***/ },
            /* 87 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XmlObject = exports.XFAObjectArray = exports.XFAObject = exports.XFAAttribute = exports.StringObject = exports.OptionObject = exports.Option10 = exports.Option01 = exports.IntegerObject = exports.ContentObject = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _namespaces = __w_pdfjs_require__(81);
                var _som = __w_pdfjs_require__(88);
                const _applyPrototype = Symbol();
                const _attributes = Symbol();
                const _attributeNames = Symbol();
                const _children = Symbol("_children");
                const _cloneAttribute = Symbol();
                const _dataValue = Symbol();
                const _defaultValue = Symbol();
                const _filteredChildrenGenerator = Symbol();
                const _getPrototype = Symbol();
                const _getUnsetAttributes = Symbol();
                const _hasChildren = Symbol();
                const _max = Symbol();
                const _options = Symbol();
                const _parent = Symbol("parent");
                const _resolvePrototypesHelper = Symbol();
                const _setAttributes = Symbol();
                const _validator = Symbol();
                let uid = 0;
                const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
                class XFAObject {
                    constructor(nsId, name, hasChildren = false){
                        this[_symbol_utils.$namespaceId] = nsId;
                        this[_symbol_utils.$nodeName] = name;
                        this[_hasChildren] = hasChildren;
                        this[_parent] = null;
                        this[_children] = [];
                        this[_symbol_utils.$uid] = `${name}${uid++}`;
                        this[_symbol_utils.$globalData] = null;
                    }
                    get isXFAObject() {
                        return true;
                    }
                    get isXFAObjectArray() {
                        return false;
                    }
                    createNodes(path) {
                        let root = this, node = null;
                        for (const { name: name, index: index } of path){
                            for(let i = 0, ii = isFinite(index) ? index : 0; i <= ii; i++){
                                const nsId = root[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : root[_symbol_utils.$namespaceId];
                                node = new XmlObject(nsId, name);
                                root[_symbol_utils.$appendChild](node);
                            }
                            root = node;
                        }
                        return node;
                    }
                    [_symbol_utils.$onChild](child) {
                        if (!this[_hasChildren] || !this[_symbol_utils.$onChildCheck](child)) return false;
                        const name = child[_symbol_utils.$nodeName];
                        const node = this[name];
                        if (node instanceof XFAObjectArray) {
                            if (node.push(child)) {
                                this[_symbol_utils.$appendChild](child);
                                return true;
                            }
                        } else {
                            if (node !== null) this[_symbol_utils.$removeChild](node);
                            this[name] = child;
                            this[_symbol_utils.$appendChild](child);
                            return true;
                        }
                        let id = "";
                        if (this.id) id = ` (id: ${this.id})`;
                        else if (this.name) id = ` (name: ${this.name} ${this.h.value})`;
                        (0, _util.warn)(`XFA - node "${this[_symbol_utils.$nodeName]}"${id} has already enough "${name}"!`);
                        return false;
                    }
                    [_symbol_utils.$onChildCheck](child) {
                        return this.hasOwnProperty(child[_symbol_utils.$nodeName]) && child[_symbol_utils.$namespaceId] === this[_symbol_utils.$namespaceId];
                    }
                    [_symbol_utils.$isNsAgnostic]() {
                        return false;
                    }
                    [_symbol_utils.$acceptWhitespace]() {
                        return false;
                    }
                    [_symbol_utils.$isCDATAXml]() {
                        return false;
                    }
                    [_symbol_utils.$isBindable]() {
                        return false;
                    }
                    [_symbol_utils.$popPara]() {
                        if (this.para) this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack.pop();
                    }
                    [_symbol_utils.$pushPara]() {
                        this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack.push(this.para);
                    }
                    [_symbol_utils.$setId](ids) {
                        if (this.id && this[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.template.id) ids.set(this.id, this);
                    }
                    [_symbol_utils.$getTemplateRoot]() {
                        return this[_symbol_utils.$globalData].template;
                    }
                    [_symbol_utils.$isSplittable]() {
                        return false;
                    }
                    [_symbol_utils.$isThereMoreWidth]() {
                        return false;
                    }
                    [_symbol_utils.$appendChild](child) {
                        child[_parent] = this;
                        this[_children].push(child);
                        if (!child[_symbol_utils.$globalData] && this[_symbol_utils.$globalData]) child[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                    }
                    [_symbol_utils.$removeChild](child) {
                        const i = this[_children].indexOf(child);
                        this[_children].splice(i, 1);
                    }
                    [_symbol_utils.$hasSettableValue]() {
                        return this.hasOwnProperty("value");
                    }
                    [_symbol_utils.$setValue](_) {}
                    [_symbol_utils.$onText](_) {}
                    [_symbol_utils.$finalize]() {}
                    [_symbol_utils.$clean](builder) {
                        delete this[_hasChildren];
                        if (this[_symbol_utils.$cleanup]) {
                            builder.clean(this[_symbol_utils.$cleanup]);
                            delete this[_symbol_utils.$cleanup];
                        }
                    }
                    [_symbol_utils.$indexOf](child) {
                        return this[_children].indexOf(child);
                    }
                    [_symbol_utils.$insertAt](i, child) {
                        child[_parent] = this;
                        this[_children].splice(i, 0, child);
                        if (!child[_symbol_utils.$globalData] && this[_symbol_utils.$globalData]) child[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                    }
                    [_symbol_utils.$isTransparent]() {
                        return !this.name;
                    }
                    [_symbol_utils.$lastAttribute]() {
                        return "";
                    }
                    [_symbol_utils.$text]() {
                        if (this[_children].length === 0) return this[_symbol_utils.$content];
                        return this[_children].map((c)=>c[_symbol_utils.$text]()).join("");
                    }
                    get [_attributeNames]() {
                        const proto = Object.getPrototypeOf(this);
                        if (!proto._attributes) {
                            const attributes = proto._attributes = new Set();
                            for (const name of Object.getOwnPropertyNames(this)){
                                if (this[name] === null || this[name] instanceof XFAObject || this[name] instanceof XFAObjectArray) break;
                                attributes.add(name);
                            }
                        }
                        return (0, _util.shadow)(this, _attributeNames, proto._attributes);
                    }
                    [_symbol_utils.$isDescendent](parent) {
                        let node = this;
                        while(node){
                            if (node === parent) return true;
                            node = node[_symbol_utils.$getParent]();
                        }
                        return false;
                    }
                    [_symbol_utils.$getParent]() {
                        return this[_parent];
                    }
                    [_symbol_utils.$getSubformParent]() {
                        return this[_symbol_utils.$getParent]();
                    }
                    [_symbol_utils.$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[name];
                    }
                    [_symbol_utils.$dump]() {
                        const dumped = Object.create(null);
                        if (this[_symbol_utils.$content]) dumped.$content = this[_symbol_utils.$content];
                        for (const name of Object.getOwnPropertyNames(this)){
                            const value = this[name];
                            if (value === null) continue;
                            if (value instanceof XFAObject) dumped[name] = value[_symbol_utils.$dump]();
                            else if (value instanceof XFAObjectArray) {
                                if (!value.isEmpty()) dumped[name] = value.dump();
                            } else dumped[name] = value;
                        }
                        return dumped;
                    }
                    [_symbol_utils.$toStyle]() {
                        return null;
                    }
                    [_symbol_utils.$toHTML]() {
                        return _utils.HTMLResult.EMPTY;
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        for (const node of this[_symbol_utils.$getChildren]())yield node;
                    }
                    *[_filteredChildrenGenerator](filter, include) {
                        for (const node of this[_symbol_utils.$getContainedChildren]())if (!filter || include === filter.has(node[_symbol_utils.$nodeName])) {
                            const availableSpace = this[_symbol_utils.$getAvailableSpace]();
                            const res = node[_symbol_utils.$toHTML](availableSpace);
                            if (!res.success) this[_symbol_utils.$extra].failingNode = node;
                            yield res;
                        }
                    }
                    [_symbol_utils.$flushHTML]() {
                        return null;
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        this[_symbol_utils.$extra].children.push(html);
                    }
                    [_symbol_utils.$getAvailableSpace]() {}
                    [_symbol_utils.$childrenToHTML]({ filter: filter = null, include: include = true }) {
                        if (!this[_symbol_utils.$extra].generator) this[_symbol_utils.$extra].generator = this[_filteredChildrenGenerator](filter, include);
                        else {
                            const availableSpace = this[_symbol_utils.$getAvailableSpace]();
                            const res = this[_symbol_utils.$extra].failingNode[_symbol_utils.$toHTML](availableSpace);
                            if (!res.success) return res;
                            if (res.html) this[_symbol_utils.$addHTML](res.html, res.bbox);
                            delete this[_symbol_utils.$extra].failingNode;
                        }
                        while(true){
                            const gen = this[_symbol_utils.$extra].generator.next();
                            if (gen.done) break;
                            const res = gen.value;
                            if (!res.success) return res;
                            if (res.html) this[_symbol_utils.$addHTML](res.html, res.bbox);
                        }
                        this[_symbol_utils.$extra].generator = null;
                        return _utils.HTMLResult.EMPTY;
                    }
                    [_symbol_utils.$setSetAttributes](attributes) {
                        this[_setAttributes] = new Set(Object.keys(attributes));
                    }
                    [_getUnsetAttributes](protoAttributes) {
                        const allAttr = this[_attributeNames];
                        const setAttr = this[_setAttributes];
                        return [
                            ...protoAttributes
                        ].filter((x)=>allAttr.has(x) && !setAttr.has(x));
                    }
                    [_symbol_utils.$resolvePrototypes](ids, ancestors = new Set()) {
                        for (const child of this[_children])child[_resolvePrototypesHelper](ids, ancestors);
                    }
                    [_resolvePrototypesHelper](ids, ancestors) {
                        const proto = this[_getPrototype](ids, ancestors);
                        if (proto) this[_applyPrototype](proto, ids, ancestors);
                        else this[_symbol_utils.$resolvePrototypes](ids, ancestors);
                    }
                    [_getPrototype](ids, ancestors) {
                        const { use: use, usehref: usehref } = this;
                        if (!use && !usehref) return null;
                        let proto = null;
                        let somExpression = null;
                        let id = null;
                        let ref = use;
                        if (usehref) {
                            ref = usehref;
                            if (usehref.startsWith("#som(") && usehref.endsWith(")")) somExpression = usehref.slice(5, -1);
                            else if (usehref.startsWith(".#som(") && usehref.endsWith(")")) somExpression = usehref.slice(6, -1);
                            else if (usehref.startsWith("#")) id = usehref.slice(1);
                            else if (usehref.startsWith(".#")) id = usehref.slice(2);
                        } else if (use.startsWith("#")) id = use.slice(1);
                        else somExpression = use;
                        this.use = this.usehref = "";
                        if (id) proto = ids.get(id);
                        else {
                            proto = (0, _som.searchNode)(ids.get(_symbol_utils.$root), this, somExpression, true, false);
                            if (proto) proto = proto[0];
                        }
                        if (!proto) {
                            (0, _util.warn)(`XFA - Invalid prototype reference: ${ref}.`);
                            return null;
                        }
                        if (proto[_symbol_utils.$nodeName] !== this[_symbol_utils.$nodeName]) {
                            (0, _util.warn)(`XFA - Incompatible prototype: ${proto[_symbol_utils.$nodeName]} !== ${this[_symbol_utils.$nodeName]}.`);
                            return null;
                        }
                        if (ancestors.has(proto)) {
                            (0, _util.warn)(`XFA - Cycle detected in prototypes use.`);
                            return null;
                        }
                        ancestors.add(proto);
                        const protoProto = proto[_getPrototype](ids, ancestors);
                        if (protoProto) proto[_applyPrototype](protoProto, ids, ancestors);
                        proto[_symbol_utils.$resolvePrototypes](ids, ancestors);
                        ancestors.delete(proto);
                        return proto;
                    }
                    [_applyPrototype](proto, ids, ancestors) {
                        if (ancestors.has(proto)) {
                            (0, _util.warn)(`XFA - Cycle detected in prototypes use.`);
                            return;
                        }
                        if (!this[_symbol_utils.$content] && proto[_symbol_utils.$content]) this[_symbol_utils.$content] = proto[_symbol_utils.$content];
                        const newAncestors = new Set(ancestors);
                        newAncestors.add(proto);
                        for (const unsetAttrName of this[_getUnsetAttributes](proto[_setAttributes])){
                            this[unsetAttrName] = proto[unsetAttrName];
                            if (this[_setAttributes]) this[_setAttributes].add(unsetAttrName);
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (this[_attributeNames].has(name)) continue;
                            const value = this[name];
                            const protoValue = proto[name];
                            if (value instanceof XFAObjectArray) {
                                for (const child of value[_children])child[_resolvePrototypesHelper](ids, ancestors);
                                for(let i = value[_children].length, ii = protoValue[_children].length; i < ii; i++){
                                    const child = proto[_children][i][_symbol_utils.$clone]();
                                    if (value.push(child)) {
                                        child[_parent] = this;
                                        this[_children].push(child);
                                        child[_resolvePrototypesHelper](ids, ancestors);
                                    } else break;
                                }
                                continue;
                            }
                            if (value !== null) {
                                value[_symbol_utils.$resolvePrototypes](ids, ancestors);
                                if (protoValue) value[_applyPrototype](protoValue, ids, ancestors);
                                continue;
                            }
                            if (protoValue !== null) {
                                const child = protoValue[_symbol_utils.$clone]();
                                child[_parent] = this;
                                this[name] = child;
                                this[_children].push(child);
                                child[_resolvePrototypesHelper](ids, ancestors);
                            }
                        }
                    }
                    static [_cloneAttribute](obj) {
                        if (Array.isArray(obj)) return obj.map((x)=>XFAObject[_cloneAttribute](x));
                        if (typeof obj === "object" && obj !== null) return Object.assign({}, obj);
                        return obj;
                    }
                    [_symbol_utils.$clone]() {
                        const clone = Object.create(Object.getPrototypeOf(this));
                        for (const $symbol of Object.getOwnPropertySymbols(this))try {
                            clone[$symbol] = this[$symbol];
                        } catch  {
                            (0, _util.shadow)(clone, $symbol, this[$symbol]);
                        }
                        clone[_symbol_utils.$uid] = `${clone[_symbol_utils.$nodeName]}${uid++}`;
                        clone[_children] = [];
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (this[_attributeNames].has(name)) {
                                clone[name] = XFAObject[_cloneAttribute](this[name]);
                                continue;
                            }
                            const value = this[name];
                            clone[name] = value instanceof XFAObjectArray ? new XFAObjectArray(value[_max]) : null;
                        }
                        for (const child of this[_children]){
                            const name = child[_symbol_utils.$nodeName];
                            const clonedChild = child[_symbol_utils.$clone]();
                            clone[_children].push(clonedChild);
                            clonedChild[_parent] = clone;
                            if (clone[name] === null) clone[name] = clonedChild;
                            else clone[name][_children].push(clonedChild);
                        }
                        return clone;
                    }
                    [_symbol_utils.$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[_children].filter((c)=>c[_symbol_utils.$nodeName] === name);
                    }
                    [_symbol_utils.$getChildrenByClass](name) {
                        return this[name];
                    }
                    [_symbol_utils.$getChildrenByName](name, allTransparent, first = true) {
                        return Array.from(this[_symbol_utils.$getChildrenByNameIt](name, allTransparent, first));
                    }
                    *[_symbol_utils.$getChildrenByNameIt](name, allTransparent, first = true) {
                        if (name === "parent") {
                            yield this[_parent];
                            return;
                        }
                        for (const child of this[_children]){
                            if (child[_symbol_utils.$nodeName] === name) yield child;
                            if (child.name === name) yield child;
                            if (allTransparent || child[_symbol_utils.$isTransparent]()) yield* child[_symbol_utils.$getChildrenByNameIt](name, allTransparent, false);
                        }
                        if (first && this[_attributeNames].has(name)) yield new XFAAttribute(this, name, this[name]);
                    }
                }
                exports.XFAObject = XFAObject;
                class XFAObjectArray {
                    constructor(max = Infinity){
                        this[_max] = max;
                        this[_children] = [];
                    }
                    get isXFAObject() {
                        return false;
                    }
                    get isXFAObjectArray() {
                        return true;
                    }
                    push(child) {
                        const len = this[_children].length;
                        if (len <= this[_max]) {
                            this[_children].push(child);
                            return true;
                        }
                        (0, _util.warn)(`XFA - node "${child[_symbol_utils.$nodeName]}" accepts no more than ${this[_max]} children`);
                        return false;
                    }
                    isEmpty() {
                        return this[_children].length === 0;
                    }
                    dump() {
                        return this[_children].length === 1 ? this[_children][0][_symbol_utils.$dump]() : this[_children].map((x)=>x[_symbol_utils.$dump]());
                    }
                    [_symbol_utils.$clone]() {
                        const clone = new XFAObjectArray(this[_max]);
                        clone[_children] = this[_children].map((c)=>c[_symbol_utils.$clone]());
                        return clone;
                    }
                    get children() {
                        return this[_children];
                    }
                    clear() {
                        this[_children].length = 0;
                    }
                }
                exports.XFAObjectArray = XFAObjectArray;
                class XFAAttribute {
                    constructor(node, name, value){
                        this[_parent] = node;
                        this[_symbol_utils.$nodeName] = name;
                        this[_symbol_utils.$content] = value;
                        this[_symbol_utils.$consumed] = false;
                        this[_symbol_utils.$uid] = `attribute${uid++}`;
                    }
                    [_symbol_utils.$getParent]() {
                        return this[_parent];
                    }
                    [_symbol_utils.$isDataValue]() {
                        return true;
                    }
                    [_symbol_utils.$getDataValue]() {
                        return this[_symbol_utils.$content].trim();
                    }
                    [_symbol_utils.$setValue](value) {
                        value = value.value || "";
                        this[_symbol_utils.$content] = value.toString();
                    }
                    [_symbol_utils.$text]() {
                        return this[_symbol_utils.$content];
                    }
                    [_symbol_utils.$isDescendent](parent) {
                        return this[_parent] === parent || this[_parent][_symbol_utils.$isDescendent](parent);
                    }
                }
                exports.XFAAttribute = XFAAttribute;
                class XmlObject extends XFAObject {
                    constructor(nsId, name, attributes = {}){
                        super(nsId, name);
                        this[_symbol_utils.$content] = "";
                        this[_dataValue] = null;
                        if (name !== "#text") {
                            const map = new Map();
                            this[_attributes] = map;
                            for (const [attrName, value] of Object.entries(attributes))map.set(attrName, new XFAAttribute(this, attrName, value));
                            if (attributes.hasOwnProperty(_symbol_utils.$nsAttributes)) {
                                const dataNode = attributes[_symbol_utils.$nsAttributes].xfa.dataNode;
                                if (dataNode !== undefined) {
                                    if (dataNode === "dataGroup") this[_dataValue] = false;
                                    else if (dataNode === "dataValue") this[_dataValue] = true;
                                }
                            }
                        }
                        this[_symbol_utils.$consumed] = false;
                    }
                    [_symbol_utils.$toString](buf) {
                        const tagName = this[_symbol_utils.$nodeName];
                        if (tagName === "#text") {
                            buf.push((0, _core_utils.encodeToXmlString)(this[_symbol_utils.$content]));
                            return;
                        }
                        const utf8TagName = (0, _util.utf8StringToString)(tagName);
                        const prefix = this[_symbol_utils.$namespaceId] === NS_DATASETS ? "xfa:" : "";
                        buf.push(`<${prefix}${utf8TagName}`);
                        for (const [name, value] of this[_attributes].entries()){
                            const utf8Name = (0, _util.utf8StringToString)(name);
                            buf.push(` ${utf8Name}="${(0, _core_utils.encodeToXmlString)(value[_symbol_utils.$content])}"`);
                        }
                        if (this[_dataValue] !== null) {
                            if (this[_dataValue]) buf.push(` xfa:dataNode="dataValue"`);
                            else buf.push(` xfa:dataNode="dataGroup"`);
                        }
                        if (!this[_symbol_utils.$content] && this[_children].length === 0) {
                            buf.push("/>");
                            return;
                        }
                        buf.push(">");
                        if (this[_symbol_utils.$content]) {
                            if (typeof this[_symbol_utils.$content] === "string") buf.push((0, _core_utils.encodeToXmlString)(this[_symbol_utils.$content]));
                            else this[_symbol_utils.$content][_symbol_utils.$toString](buf);
                        } else for (const child of this[_children])child[_symbol_utils.$toString](buf);
                        buf.push(`</${prefix}${utf8TagName}>`);
                    }
                    [_symbol_utils.$onChild](child) {
                        if (this[_symbol_utils.$content]) {
                            const node = new XmlObject(this[_symbol_utils.$namespaceId], "#text");
                            this[_symbol_utils.$appendChild](node);
                            node[_symbol_utils.$content] = this[_symbol_utils.$content];
                            this[_symbol_utils.$content] = "";
                        }
                        this[_symbol_utils.$appendChild](child);
                        return true;
                    }
                    [_symbol_utils.$onText](str) {
                        this[_symbol_utils.$content] += str;
                    }
                    [_symbol_utils.$finalize]() {
                        if (this[_symbol_utils.$content] && this[_children].length > 0) {
                            const node = new XmlObject(this[_symbol_utils.$namespaceId], "#text");
                            this[_symbol_utils.$appendChild](node);
                            node[_symbol_utils.$content] = this[_symbol_utils.$content];
                            delete this[_symbol_utils.$content];
                        }
                    }
                    [_symbol_utils.$toHTML]() {
                        if (this[_symbol_utils.$nodeName] === "#text") return _utils.HTMLResult.success({
                            name: "#text",
                            value: this[_symbol_utils.$content]
                        });
                        return _utils.HTMLResult.EMPTY;
                    }
                    [_symbol_utils.$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[_children].filter((c)=>c[_symbol_utils.$nodeName] === name);
                    }
                    [_symbol_utils.$getAttributes]() {
                        return this[_attributes];
                    }
                    [_symbol_utils.$getChildrenByClass](name) {
                        const value = this[_attributes].get(name);
                        if (value !== undefined) return value;
                        return this[_symbol_utils.$getChildren](name);
                    }
                    *[_symbol_utils.$getChildrenByNameIt](name, allTransparent) {
                        const value = this[_attributes].get(name);
                        if (value) yield value;
                        for (const child of this[_children]){
                            if (child[_symbol_utils.$nodeName] === name) yield child;
                            if (allTransparent) yield* child[_symbol_utils.$getChildrenByNameIt](name, allTransparent);
                        }
                    }
                    *[_symbol_utils.$getAttributeIt](name, skipConsumed) {
                        const value = this[_attributes].get(name);
                        if (value && (!skipConsumed || !value[_symbol_utils.$consumed])) yield value;
                        for (const child of this[_children])yield* child[_symbol_utils.$getAttributeIt](name, skipConsumed);
                    }
                    *[_symbol_utils.$getRealChildrenByNameIt](name, allTransparent, skipConsumed) {
                        for (const child of this[_children]){
                            if (child[_symbol_utils.$nodeName] === name && (!skipConsumed || !child[_symbol_utils.$consumed])) yield child;
                            if (allTransparent) yield* child[_symbol_utils.$getRealChildrenByNameIt](name, allTransparent, skipConsumed);
                        }
                    }
                    [_symbol_utils.$isDataValue]() {
                        if (this[_dataValue] === null) return this[_children].length === 0 || this[_children][0][_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id;
                        return this[_dataValue];
                    }
                    [_symbol_utils.$getDataValue]() {
                        if (this[_dataValue] === null) {
                            if (this[_children].length === 0) return this[_symbol_utils.$content].trim();
                            if (this[_children][0][_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) return this[_children][0][_symbol_utils.$text]().trim();
                            return null;
                        }
                        return this[_symbol_utils.$content].trim();
                    }
                    [_symbol_utils.$setValue](value) {
                        value = value.value || "";
                        this[_symbol_utils.$content] = value.toString();
                    }
                    [_symbol_utils.$dump](hasNS = false) {
                        const dumped = Object.create(null);
                        if (hasNS) dumped.$ns = this[_symbol_utils.$namespaceId];
                        if (this[_symbol_utils.$content]) dumped.$content = this[_symbol_utils.$content];
                        dumped.$name = this[_symbol_utils.$nodeName];
                        dumped.children = [];
                        for (const child of this[_children])dumped.children.push(child[_symbol_utils.$dump](hasNS));
                        dumped.attributes = Object.create(null);
                        for (const [name, value] of this[_attributes])dumped.attributes[name] = value[_symbol_utils.$content];
                        return dumped;
                    }
                }
                exports.XmlObject = XmlObject;
                class ContentObject extends XFAObject {
                    constructor(nsId, name){
                        super(nsId, name);
                        this[_symbol_utils.$content] = "";
                    }
                    [_symbol_utils.$onText](text) {
                        this[_symbol_utils.$content] += text;
                    }
                    [_symbol_utils.$finalize]() {}
                }
                exports.ContentObject = ContentObject;
                class OptionObject extends ContentObject {
                    constructor(nsId, name, options){
                        super(nsId, name);
                        this[_options] = options;
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = (0, _utils.getKeyword)({
                            data: this[_symbol_utils.$content],
                            defaultValue: this[_options][0],
                            validate: (k)=>this[_options].includes(k)
                        });
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        delete this[_options];
                    }
                }
                exports.OptionObject = OptionObject;
                class StringObject extends ContentObject {
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                    }
                }
                exports.StringObject = StringObject;
                class IntegerObject extends ContentObject {
                    constructor(nsId, name, defaultValue, validator){
                        super(nsId, name);
                        this[_defaultValue] = defaultValue;
                        this[_validator] = validator;
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = (0, _utils.getInteger)({
                            data: this[_symbol_utils.$content],
                            defaultValue: this[_defaultValue],
                            validate: this[_validator]
                        });
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        delete this[_defaultValue];
                        delete this[_validator];
                    }
                }
                exports.IntegerObject = IntegerObject;
                class Option01 extends IntegerObject {
                    constructor(nsId, name){
                        super(nsId, name, 0, (n)=>n === 1);
                    }
                }
                exports.Option01 = Option01;
                class Option10 extends IntegerObject {
                    constructor(nsId, name){
                        super(nsId, name, 1, (n)=>n === 0);
                    }
                }
                exports.Option10 = Option10;
            /***/ },
            /* 88 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createDataNode = createDataNode;
                exports.searchNode = searchNode;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _util = __w_pdfjs_require__(2);
                const namePattern = /^[^.[]+/;
                const indexPattern = /^[^\]]+/;
                const operators = {
                    dot: 0,
                    dotDot: 1,
                    dotHash: 2,
                    dotBracket: 3,
                    dotParen: 4
                };
                const shortcuts = new Map([
                    [
                        "$data",
                        (root, current)=>root.datasets ? root.datasets.data : root
                    ],
                    [
                        "$record",
                        (root, current)=>(root.datasets ? root.datasets.data : root)[_symbol_utils.$getChildren]()[0]
                    ],
                    [
                        "$template",
                        (root, current)=>root.template
                    ],
                    [
                        "$connectionSet",
                        (root, current)=>root.connectionSet
                    ],
                    [
                        "$form",
                        (root, current)=>root.form
                    ],
                    [
                        "$layout",
                        (root, current)=>root.layout
                    ],
                    [
                        "$host",
                        (root, current)=>root.host
                    ],
                    [
                        "$dataWindow",
                        (root, current)=>root.dataWindow
                    ],
                    [
                        "$event",
                        (root, current)=>root.event
                    ],
                    [
                        "!",
                        (root, current)=>root.datasets
                    ],
                    [
                        "$xfa",
                        (root, current)=>root
                    ],
                    [
                        "xfa",
                        (root, current)=>root
                    ],
                    [
                        "$",
                        (root, current)=>current
                    ]
                ]);
                const somCache = new WeakMap();
                function parseIndex(index) {
                    index = index.trim();
                    if (index === "*") return Infinity;
                    return parseInt(index, 10) || 0;
                }
                function parseExpression(expr, dotDotAllowed, noExpr = true) {
                    let match = expr.match(namePattern);
                    if (!match) return null;
                    let [name] = match;
                    const parsed = [
                        {
                            name: name,
                            cacheName: "." + name,
                            index: 0,
                            js: null,
                            formCalc: null,
                            operator: operators.dot
                        }
                    ];
                    let pos = name.length;
                    while(pos < expr.length){
                        const spos = pos;
                        const char = expr.charAt(pos++);
                        if (char === "[") {
                            match = expr.slice(pos).match(indexPattern);
                            if (!match) {
                                (0, _util.warn)("XFA - Invalid index in SOM expression");
                                return null;
                            }
                            parsed.at(-1).index = parseIndex(match[0]);
                            pos += match[0].length + 1;
                            continue;
                        }
                        let operator;
                        switch(expr.charAt(pos)){
                            case ".":
                                if (!dotDotAllowed) return null;
                                pos++;
                                operator = operators.dotDot;
                                break;
                            case "#":
                                pos++;
                                operator = operators.dotHash;
                                break;
                            case "[":
                                if (noExpr) {
                                    (0, _util.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now.");
                                    return null;
                                }
                                operator = operators.dotBracket;
                                break;
                            case "(":
                                if (noExpr) {
                                    (0, _util.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now.");
                                    return null;
                                }
                                operator = operators.dotParen;
                                break;
                            default:
                                operator = operators.dot;
                                break;
                        }
                        match = expr.slice(pos).match(namePattern);
                        if (!match) break;
                        [name] = match;
                        pos += name.length;
                        parsed.push({
                            name: name,
                            cacheName: expr.slice(spos, pos),
                            operator: operator,
                            index: 0,
                            js: null,
                            formCalc: null
                        });
                    }
                    return parsed;
                }
                function searchNode(root, container, expr, dotDotAllowed = true, useCache = true) {
                    const parsed = parseExpression(expr, dotDotAllowed);
                    if (!parsed) return null;
                    const fn = shortcuts.get(parsed[0].name);
                    let i = 0;
                    let isQualified;
                    if (fn) {
                        isQualified = true;
                        root = [
                            fn(root, container)
                        ];
                        i = 1;
                    } else {
                        isQualified = container === null;
                        root = [
                            container || root
                        ];
                    }
                    for(let ii = parsed.length; i < ii; i++){
                        const { name: name, cacheName: cacheName, operator: operator, index: index } = parsed[i];
                        const nodes = [];
                        for (const node of root){
                            if (!node.isXFAObject) continue;
                            let children, cached;
                            if (useCache) {
                                cached = somCache.get(node);
                                if (!cached) {
                                    cached = new Map();
                                    somCache.set(node, cached);
                                }
                                children = cached.get(cacheName);
                            }
                            if (!children) {
                                switch(operator){
                                    case operators.dot:
                                        children = node[_symbol_utils.$getChildrenByName](name, false);
                                        break;
                                    case operators.dotDot:
                                        children = node[_symbol_utils.$getChildrenByName](name, true);
                                        break;
                                    case operators.dotHash:
                                        children = node[_symbol_utils.$getChildrenByClass](name);
                                        children = children.isXFAObjectArray ? children.children : [
                                            children
                                        ];
                                        break;
                                    default:
                                        break;
                                }
                                if (useCache) cached.set(cacheName, children);
                            }
                            if (children.length > 0) nodes.push(children);
                        }
                        if (nodes.length === 0 && !isQualified && i === 0) {
                            const parent = container[_symbol_utils.$getParent]();
                            container = parent;
                            if (!container) return null;
                            i = -1;
                            root = [
                                container
                            ];
                            continue;
                        }
                        root = isFinite(index) ? nodes.filter((node)=>index < node.length).map((node)=>node[index]) : nodes.flat();
                    }
                    if (root.length === 0) return null;
                    return root;
                }
                function createDataNode(root, container, expr) {
                    const parsed = parseExpression(expr);
                    if (!parsed) return null;
                    if (parsed.some((x)=>x.operator === operators.dotDot)) return null;
                    const fn = shortcuts.get(parsed[0].name);
                    let i = 0;
                    if (fn) {
                        root = fn(root, container);
                        i = 1;
                    } else root = container || root;
                    for(let ii = parsed.length; i < ii; i++){
                        const { name: name, operator: operator, index: index } = parsed[i];
                        if (!isFinite(index)) {
                            parsed[i].index = 0;
                            return root.createNodes(parsed.slice(i));
                        }
                        let children;
                        switch(operator){
                            case operators.dot:
                                children = root[_symbol_utils.$getChildrenByName](name, false);
                                break;
                            case operators.dotDot:
                                children = root[_symbol_utils.$getChildrenByName](name, true);
                                break;
                            case operators.dotHash:
                                children = root[_symbol_utils.$getChildrenByClass](name);
                                children = children.isXFAObjectArray ? children.children : [
                                    children
                                ];
                                break;
                            default:
                                break;
                        }
                        if (children.length === 0) return root.createNodes(parsed.slice(i));
                        if (index < children.length) {
                            const child = children[index];
                            if (!child.isXFAObject) {
                                (0, _util.warn)(`XFA - Cannot create a node.`);
                                return null;
                            }
                            root = child;
                        } else {
                            parsed[i].index = index - children.length;
                            return root.createNodes(parsed.slice(i));
                        }
                    }
                    return null;
                }
            /***/ },
            /* 89 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DataHandler = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                class DataHandler {
                    constructor(root, data){
                        this.data = data;
                        this.dataset = root.datasets || null;
                    }
                    serialize(storage) {
                        const stack = [
                            [
                                -1,
                                this.data[_symbol_utils.$getChildren]()
                            ]
                        ];
                        while(stack.length > 0){
                            const last = stack.at(-1);
                            const [i, children] = last;
                            if (i + 1 === children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = children[++last[0]];
                            const storageEntry = storage.get(child[_symbol_utils.$uid]);
                            if (storageEntry) child[_symbol_utils.$setValue](storageEntry);
                            else {
                                const attributes = child[_symbol_utils.$getAttributes]();
                                for (const value of attributes.values()){
                                    const entry = storage.get(value[_symbol_utils.$uid]);
                                    if (entry) {
                                        value[_symbol_utils.$setValue](entry);
                                        break;
                                    }
                                }
                            }
                            const nodes = child[_symbol_utils.$getChildren]();
                            if (nodes.length > 0) stack.push([
                                -1,
                                nodes
                            ]);
                        }
                        const buf = [
                            `<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">`
                        ];
                        if (this.dataset) {
                            for (const child of this.dataset[_symbol_utils.$getChildren]())if (child[_symbol_utils.$nodeName] !== "data") child[_symbol_utils.$toString](buf);
                        }
                        this.data[_symbol_utils.$toString](buf);
                        buf.push("</xfa:datasets>");
                        return buf.join("");
                    }
                }
                exports.DataHandler = DataHandler;
            /***/ },
            /* 90 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XFAParser = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _xml_parser = __w_pdfjs_require__(71);
                var _builder = __w_pdfjs_require__(91);
                var _util = __w_pdfjs_require__(2);
                class XFAParser extends _xml_parser.XMLParserBase {
                    constructor(rootNameSpace = null, richText = false){
                        super();
                        this._builder = new _builder.Builder(rootNameSpace);
                        this._stack = [];
                        this._globalData = {
                            usedTypefaces: new Set()
                        };
                        this._ids = new Map();
                        this._current = this._builder.buildRoot(this._ids);
                        this._errorCode = _xml_parser.XMLParserErrorCode.NoError;
                        this._whiteRegex = /^\s+$/;
                        this._nbsps = /\xa0+/g;
                        this._richText = richText;
                    }
                    parse(data) {
                        this.parseXml(data);
                        if (this._errorCode !== _xml_parser.XMLParserErrorCode.NoError) return undefined;
                        this._current[_symbol_utils.$finalize]();
                        return this._current.element;
                    }
                    onText(text) {
                        text = text.replace(this._nbsps, (match)=>match.slice(1) + " ");
                        if (this._richText || this._current[_symbol_utils.$acceptWhitespace]()) {
                            this._current[_symbol_utils.$onText](text, this._richText);
                            return;
                        }
                        if (this._whiteRegex.test(text)) return;
                        this._current[_symbol_utils.$onText](text.trim());
                    }
                    onCdata(text) {
                        this._current[_symbol_utils.$onText](text);
                    }
                    _mkAttributes(attributes, tagName) {
                        let namespace = null;
                        let prefixes = null;
                        const attributeObj = Object.create({});
                        for (const { name: name, value: value } of attributes){
                            if (name === "xmlns") {
                                if (!namespace) namespace = value;
                                else (0, _util.warn)(`XFA - multiple namespace definition in <${tagName}>`);
                            } else if (name.startsWith("xmlns:")) {
                                const prefix = name.substring(6);
                                if (!prefixes) prefixes = [];
                                prefixes.push({
                                    prefix: prefix,
                                    value: value
                                });
                            } else {
                                const i = name.indexOf(":");
                                if (i === -1) attributeObj[name] = value;
                                else {
                                    let nsAttrs = attributeObj[_symbol_utils.$nsAttributes];
                                    if (!nsAttrs) nsAttrs = attributeObj[_symbol_utils.$nsAttributes] = Object.create(null);
                                    const [ns, attrName] = [
                                        name.slice(0, i),
                                        name.slice(i + 1)
                                    ];
                                    const attrs = nsAttrs[ns] ||= Object.create(null);
                                    attrs[attrName] = value;
                                }
                            }
                        }
                        return [
                            namespace,
                            prefixes,
                            attributeObj
                        ];
                    }
                    _getNameAndPrefix(name, nsAgnostic) {
                        const i = name.indexOf(":");
                        if (i === -1) return [
                            name,
                            null
                        ];
                        return [
                            name.substring(i + 1),
                            nsAgnostic ? "" : name.substring(0, i)
                        ];
                    }
                    onBeginElement(tagName, attributes, isEmpty) {
                        const [namespace, prefixes, attributesObj] = this._mkAttributes(attributes, tagName);
                        const [name, nsPrefix] = this._getNameAndPrefix(tagName, this._builder.isNsAgnostic());
                        const node = this._builder.build({
                            nsPrefix: nsPrefix,
                            name: name,
                            attributes: attributesObj,
                            namespace: namespace,
                            prefixes: prefixes
                        });
                        node[_symbol_utils.$globalData] = this._globalData;
                        if (isEmpty) {
                            node[_symbol_utils.$finalize]();
                            if (this._current[_symbol_utils.$onChild](node)) node[_symbol_utils.$setId](this._ids);
                            node[_symbol_utils.$clean](this._builder);
                            return;
                        }
                        this._stack.push(this._current);
                        this._current = node;
                    }
                    onEndElement(name) {
                        const node = this._current;
                        if (node[_symbol_utils.$isCDATAXml]() && typeof node[_symbol_utils.$content] === "string") {
                            const parser = new XFAParser();
                            parser._globalData = this._globalData;
                            const root = parser.parse(node[_symbol_utils.$content]);
                            node[_symbol_utils.$content] = null;
                            node[_symbol_utils.$onChild](root);
                        }
                        node[_symbol_utils.$finalize]();
                        this._current = this._stack.pop();
                        if (this._current[_symbol_utils.$onChild](node)) node[_symbol_utils.$setId](this._ids);
                        node[_symbol_utils.$clean](this._builder);
                    }
                    onError(code) {
                        this._errorCode = code;
                    }
                }
                exports.XFAParser = XFAParser;
            /***/ },
            /* 91 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Builder = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _symbol_utils = __w_pdfjs_require__(78);
                var _setup = __w_pdfjs_require__(92);
                var _template = __w_pdfjs_require__(80);
                var _unknown = __w_pdfjs_require__(101);
                var _util = __w_pdfjs_require__(2);
                var _xfa_object = __w_pdfjs_require__(87);
                class Root extends _xfa_object.XFAObject {
                    constructor(ids){
                        super(-1, "root", Object.create(null));
                        this.element = null;
                        this[_symbol_utils.$ids] = ids;
                    }
                    [_symbol_utils.$onChild](child) {
                        this.element = child;
                        return true;
                    }
                    [_symbol_utils.$finalize]() {
                        super[_symbol_utils.$finalize]();
                        if (this.element.template instanceof _template.Template) {
                            this[_symbol_utils.$ids].set(_symbol_utils.$root, this.element);
                            this.element.template[_symbol_utils.$resolvePrototypes](this[_symbol_utils.$ids]);
                            this.element.template[_symbol_utils.$ids] = this[_symbol_utils.$ids];
                        }
                    }
                }
                class Empty extends _xfa_object.XFAObject {
                    constructor(){
                        super(-1, "", Object.create(null));
                    }
                    [_symbol_utils.$onChild](_) {
                        return false;
                    }
                }
                class Builder {
                    constructor(rootNameSpace = null){
                        this._namespaceStack = [];
                        this._nsAgnosticLevel = 0;
                        this._namespacePrefixes = new Map();
                        this._namespaces = new Map();
                        this._nextNsId = Math.max(...Object.values(_namespaces.NamespaceIds).map(({ id: id })=>id));
                        this._currentNamespace = rootNameSpace || new _unknown.UnknownNamespace(++this._nextNsId);
                    }
                    buildRoot(ids) {
                        return new Root(ids);
                    }
                    build({ nsPrefix: nsPrefix, name: name, attributes: attributes, namespace: namespace, prefixes: prefixes }) {
                        const hasNamespaceDef = namespace !== null;
                        if (hasNamespaceDef) {
                            this._namespaceStack.push(this._currentNamespace);
                            this._currentNamespace = this._searchNamespace(namespace);
                        }
                        if (prefixes) this._addNamespacePrefix(prefixes);
                        if (attributes.hasOwnProperty(_symbol_utils.$nsAttributes)) {
                            const dataTemplate = _setup.NamespaceSetUp.datasets;
                            const nsAttrs = attributes[_symbol_utils.$nsAttributes];
                            let xfaAttrs = null;
                            for (const [ns, attrs] of Object.entries(nsAttrs)){
                                const nsToUse = this._getNamespaceToUse(ns);
                                if (nsToUse === dataTemplate) {
                                    xfaAttrs = {
                                        xfa: attrs
                                    };
                                    break;
                                }
                            }
                            if (xfaAttrs) attributes[_symbol_utils.$nsAttributes] = xfaAttrs;
                            else delete attributes[_symbol_utils.$nsAttributes];
                        }
                        const namespaceToUse = this._getNamespaceToUse(nsPrefix);
                        const node = namespaceToUse?.[_namespaces.$buildXFAObject](name, attributes) || new Empty();
                        if (node[_symbol_utils.$isNsAgnostic]()) this._nsAgnosticLevel++;
                        if (hasNamespaceDef || prefixes || node[_symbol_utils.$isNsAgnostic]()) node[_symbol_utils.$cleanup] = {
                            hasNamespace: hasNamespaceDef,
                            prefixes: prefixes,
                            nsAgnostic: node[_symbol_utils.$isNsAgnostic]()
                        };
                        return node;
                    }
                    isNsAgnostic() {
                        return this._nsAgnosticLevel > 0;
                    }
                    _searchNamespace(nsName) {
                        let ns = this._namespaces.get(nsName);
                        if (ns) return ns;
                        for (const [name, { check: check }] of Object.entries(_namespaces.NamespaceIds))if (check(nsName)) {
                            ns = _setup.NamespaceSetUp[name];
                            if (ns) {
                                this._namespaces.set(nsName, ns);
                                return ns;
                            }
                            break;
                        }
                        ns = new _unknown.UnknownNamespace(++this._nextNsId);
                        this._namespaces.set(nsName, ns);
                        return ns;
                    }
                    _addNamespacePrefix(prefixes) {
                        for (const { prefix: prefix, value: value } of prefixes){
                            const namespace = this._searchNamespace(value);
                            let prefixStack = this._namespacePrefixes.get(prefix);
                            if (!prefixStack) {
                                prefixStack = [];
                                this._namespacePrefixes.set(prefix, prefixStack);
                            }
                            prefixStack.push(namespace);
                        }
                    }
                    _getNamespaceToUse(prefix) {
                        if (!prefix) return this._currentNamespace;
                        const prefixStack = this._namespacePrefixes.get(prefix);
                        if (prefixStack?.length > 0) return prefixStack.at(-1);
                        (0, _util.warn)(`Unknown namespace prefix: ${prefix}.`);
                        return null;
                    }
                    clean(data) {
                        const { hasNamespace: hasNamespace, prefixes: prefixes, nsAgnostic: nsAgnostic } = data;
                        if (hasNamespace) this._currentNamespace = this._namespaceStack.pop();
                        if (prefixes) prefixes.forEach(({ prefix: prefix })=>{
                            this._namespacePrefixes.get(prefix).pop();
                        });
                        if (nsAgnostic) this._nsAgnosticLevel--;
                    }
                }
                exports.Builder = Builder;
            /***/ },
            /* 92 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NamespaceSetUp = void 0;
                var _config = __w_pdfjs_require__(93);
                var _connection_set = __w_pdfjs_require__(94);
                var _datasets = __w_pdfjs_require__(95);
                var _locale_set = __w_pdfjs_require__(96);
                var _signature = __w_pdfjs_require__(97);
                var _stylesheet = __w_pdfjs_require__(98);
                var _template = __w_pdfjs_require__(80);
                var _xdp = __w_pdfjs_require__(99);
                var _xhtml = __w_pdfjs_require__(100);
                const NamespaceSetUp = {
                    config: _config.ConfigNamespace,
                    connection: _connection_set.ConnectionSetNamespace,
                    datasets: _datasets.DatasetsNamespace,
                    localeSet: _locale_set.LocaleSetNamespace,
                    signature: _signature.SignatureNamespace,
                    stylesheet: _stylesheet.StylesheetNamespace,
                    template: _template.TemplateNamespace,
                    xdp: _xdp.XdpNamespace,
                    xhtml: _xhtml.XhtmlNamespace
                };
                exports.NamespaceSetUp = NamespaceSetUp;
            /***/ },
            /* 93 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ConfigNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _symbol_utils = __w_pdfjs_require__(78);
                var _xfa_object = __w_pdfjs_require__(87);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                const CONFIG_NS_ID = _namespaces.NamespaceIds.config.id;
                class Acrobat extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "acrobat", true);
                        this.acrobat7 = null;
                        this.autoSave = null;
                        this.common = null;
                        this.validate = null;
                        this.validateApprovalSignatures = null;
                        this.submitUrl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Acrobat7 extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "acrobat7", true);
                        this.dynamicRender = null;
                    }
                }
                class ADBE_JSConsole extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ADBE_JSConsole", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class ADBE_JSDebugger extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ADBE_JSDebugger", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class AddSilentPrint extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "addSilentPrint");
                    }
                }
                class AddViewerPreferences extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "addViewerPreferences");
                    }
                }
                class AdjustData extends _xfa_object.Option10 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "adjustData");
                    }
                }
                class AdobeExtensionLevel extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "adobeExtensionLevel", 0, (n)=>n >= 1 && n <= 8);
                    }
                }
                class Agent extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "agent", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.common = new _xfa_object.XFAObjectArray();
                    }
                }
                class AlwaysEmbed extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "alwaysEmbed");
                    }
                }
                class Amd extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "amd");
                    }
                }
                class Area extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "area");
                        this.level = (0, _utils.getInteger)({
                            data: attributes.level,
                            defaultValue: 0,
                            validate: (n)=>n >= 1 && n <= 3
                        });
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "",
                            "barcode",
                            "coreinit",
                            "deviceDriver",
                            "font",
                            "general",
                            "layout",
                            "merge",
                            "script",
                            "signature",
                            "sourceSet",
                            "templateCache"
                        ]);
                    }
                }
                class Attributes extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "attributes", [
                            "preserve",
                            "delegate",
                            "ignore"
                        ]);
                    }
                }
                class AutoSave extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "autoSave", [
                            "disabled",
                            "enabled"
                        ]);
                    }
                }
                class Base extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "base");
                    }
                }
                class BatchOutput extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "batchOutput");
                        this.format = (0, _utils.getStringOption)(attributes.format, [
                            "none",
                            "concat",
                            "zip",
                            "zipCompress"
                        ]);
                    }
                }
                class BehaviorOverride extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "behaviorOverride");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = new Map(this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>x.includes(":")).map((x)=>x.split(":", 2)));
                    }
                }
                class Cache extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "cache", true);
                        this.templateCache = null;
                    }
                }
                class Change extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "change");
                    }
                }
                class Common extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "common", true);
                        this.data = null;
                        this.locale = null;
                        this.localeSet = null;
                        this.messaging = null;
                        this.suppressBanner = null;
                        this.template = null;
                        this.validationMessaging = null;
                        this.versionControl = null;
                        this.log = new _xfa_object.XFAObjectArray();
                    }
                }
                class Compress extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compress");
                        this.scope = (0, _utils.getStringOption)(attributes.scope, [
                            "imageOnly",
                            "document"
                        ]);
                    }
                }
                class CompressLogicalStructure extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compressLogicalStructure");
                    }
                }
                class CompressObjectStream extends _xfa_object.Option10 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compressObjectStream");
                    }
                }
                class Compression extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compression", true);
                        this.compressLogicalStructure = null;
                        this.compressObjectStream = null;
                        this.level = null;
                        this.type = null;
                    }
                }
                class Config extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "config", true);
                        this.acrobat = null;
                        this.present = null;
                        this.trace = null;
                        this.agent = new _xfa_object.XFAObjectArray();
                    }
                }
                class Conformance extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "conformance", [
                            "A",
                            "B"
                        ]);
                    }
                }
                class ContentCopy extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "contentCopy");
                    }
                }
                class Copies extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "copies", 1, (n)=>n >= 1);
                    }
                }
                class Creator extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "creator");
                    }
                }
                class CurrentPage extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "currentPage", 0, (n)=>n >= 0);
                    }
                }
                class Data extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "data", true);
                        this.adjustData = null;
                        this.attributes = null;
                        this.incrementalLoad = null;
                        this.outputXSL = null;
                        this.range = null;
                        this.record = null;
                        this.startNode = null;
                        this.uri = null;
                        this.window = null;
                        this.xsl = null;
                        this.excludeNS = new _xfa_object.XFAObjectArray();
                        this.transform = new _xfa_object.XFAObjectArray();
                    }
                }
                class Debug extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "debug", true);
                        this.uri = null;
                    }
                }
                class DefaultTypeface extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "defaultTypeface");
                        this.writingScript = (0, _utils.getStringOption)(attributes.writingScript, [
                            "*",
                            "Arabic",
                            "Cyrillic",
                            "EastEuropeanRoman",
                            "Greek",
                            "Hebrew",
                            "Japanese",
                            "Korean",
                            "Roman",
                            "SimplifiedChinese",
                            "Thai",
                            "TraditionalChinese",
                            "Vietnamese"
                        ]);
                    }
                }
                class Destination extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "destination", [
                            "pdf",
                            "pcl",
                            "ps",
                            "webClient",
                            "zpl"
                        ]);
                    }
                }
                class DocumentAssembly extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "documentAssembly");
                    }
                }
                class Driver extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "driver", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class DuplexOption extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "duplexOption", [
                            "simplex",
                            "duplexFlipLongEdge",
                            "duplexFlipShortEdge"
                        ]);
                    }
                }
                class DynamicRender extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "dynamicRender", [
                            "forbidden",
                            "required"
                        ]);
                    }
                }
                class Embed extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "embed");
                    }
                }
                class Encrypt extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encrypt");
                    }
                }
                class Encryption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encryption", true);
                        this.encrypt = null;
                        this.encryptionLevel = null;
                        this.permissions = null;
                    }
                }
                class EncryptionLevel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encryptionLevel", [
                            "40bit",
                            "128bit"
                        ]);
                    }
                }
                class Enforce extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "enforce");
                    }
                }
                class Equate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "equate");
                        this.force = (0, _utils.getInteger)({
                            data: attributes.force,
                            defaultValue: 1,
                            validate: (n)=>n === 0
                        });
                        this.from = attributes.from || "";
                        this.to = attributes.to || "";
                    }
                }
                class EquateRange extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "equateRange");
                        this.from = attributes.from || "";
                        this.to = attributes.to || "";
                        this._unicodeRange = attributes.unicodeRange || "";
                    }
                    get unicodeRange() {
                        const ranges = [];
                        const unicodeRegex = /U\+([0-9a-fA-F]+)/;
                        const unicodeRange = this._unicodeRange;
                        for (let range of unicodeRange.split(",").map((x)=>x.trim()).filter((x)=>!!x)){
                            range = range.split("-", 2).map((x)=>{
                                const found = x.match(unicodeRegex);
                                if (!found) return 0;
                                return parseInt(found[1], 16);
                            });
                            if (range.length === 1) range.push(range[0]);
                            ranges.push(range);
                        }
                        return (0, _util.shadow)(this, "unicodeRange", ranges);
                    }
                }
                class Exclude extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "exclude");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>x && [
                                "calculate",
                                "close",
                                "enter",
                                "exit",
                                "initialize",
                                "ready",
                                "validate"
                            ].includes(x));
                    }
                }
                class ExcludeNS extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "excludeNS");
                    }
                }
                class FlipLabel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "flipLabel", [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class FontInfo extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "fontInfo", true);
                        this.embed = null;
                        this.map = null;
                        this.subsetBelow = null;
                        this.alwaysEmbed = new _xfa_object.XFAObjectArray();
                        this.defaultTypeface = new _xfa_object.XFAObjectArray();
                        this.neverEmbed = new _xfa_object.XFAObjectArray();
                    }
                }
                class FormFieldFilling extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "formFieldFilling");
                    }
                }
                class GroupParent extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "groupParent");
                    }
                }
                class IfEmpty extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ifEmpty", [
                            "dataValue",
                            "dataGroup",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class IncludeXDPContent extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "includeXDPContent");
                    }
                }
                class IncrementalLoad extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "incrementalLoad", [
                            "none",
                            "forwardOnly"
                        ]);
                    }
                }
                class IncrementalMerge extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "incrementalMerge");
                    }
                }
                class Interactive extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "interactive");
                    }
                }
                class Jog extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "jog", [
                            "usePrinterSetting",
                            "none",
                            "pageSet"
                        ]);
                    }
                }
                class LabelPrinter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "labelPrinter", true);
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "zpl",
                            "dpl",
                            "ipl",
                            "tcpl"
                        ]);
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Layout extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "layout", [
                            "paginate",
                            "panel"
                        ]);
                    }
                }
                class Level extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "level", 0, (n)=>n > 0);
                    }
                }
                class Linearized extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "linearized");
                    }
                }
                class Locale extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "locale");
                    }
                }
                class LocaleSet extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "localeSet");
                    }
                }
                class Log extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "log", true);
                        this.mode = null;
                        this.threshold = null;
                        this.to = null;
                        this.uri = null;
                    }
                }
                class MapElement extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "map", true);
                        this.equate = new _xfa_object.XFAObjectArray();
                        this.equateRange = new _xfa_object.XFAObjectArray();
                    }
                }
                class MediumInfo extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "mediumInfo", true);
                        this.map = null;
                    }
                }
                class Message extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "message", true);
                        this.msgId = null;
                        this.severity = null;
                    }
                }
                class Messaging extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "messaging", true);
                        this.message = new _xfa_object.XFAObjectArray();
                    }
                }
                class Mode extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "mode", [
                            "append",
                            "overwrite"
                        ]);
                    }
                }
                class ModifyAnnots extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "modifyAnnots");
                    }
                }
                class MsgId extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "msgId", 1, (n)=>n >= 1);
                    }
                }
                class NameAttr extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "nameAttr");
                    }
                }
                class NeverEmbed extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "neverEmbed");
                    }
                }
                class NumberOfCopies extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "numberOfCopies", null, (n)=>n >= 2 && n <= 5);
                    }
                }
                class OpenAction extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "openAction", true);
                        this.destination = null;
                    }
                }
                class Output extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "output", true);
                        this.to = null;
                        this.type = null;
                        this.uri = null;
                    }
                }
                class OutputBin extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "outputBin");
                    }
                }
                class OutputXSL extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "outputXSL", true);
                        this.uri = null;
                    }
                }
                class Overprint extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "overprint", [
                            "none",
                            "both",
                            "draw",
                            "field"
                        ]);
                    }
                }
                class Packets extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "packets");
                    }
                    [_symbol_utils.$finalize]() {
                        if (this[_symbol_utils.$content] === "*") return;
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>[
                                "config",
                                "datasets",
                                "template",
                                "xfdf",
                                "xslt"
                            ].includes(x));
                    }
                }
                class PageOffset extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pageOffset");
                        this.x = (0, _utils.getInteger)({
                            data: attributes.x,
                            defaultValue: "useXDCSetting",
                            validate: (n)=>true
                        });
                        this.y = (0, _utils.getInteger)({
                            data: attributes.y,
                            defaultValue: "useXDCSetting",
                            validate: (n)=>true
                        });
                    }
                }
                class PageRange extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pageRange");
                    }
                    [_symbol_utils.$finalize]() {
                        const numbers = this[_symbol_utils.$content].trim().split(/\s+/).map((x)=>parseInt(x, 10));
                        const ranges = [];
                        for(let i = 0, ii = numbers.length; i < ii; i += 2)ranges.push(numbers.slice(i, i + 2));
                        this[_symbol_utils.$content] = ranges;
                    }
                }
                class Pagination extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pagination", [
                            "simplex",
                            "duplexShortEdge",
                            "duplexLongEdge"
                        ]);
                    }
                }
                class PaginationOverride extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "paginationOverride", [
                            "none",
                            "forceDuplex",
                            "forceDuplexLongEdge",
                            "forceDuplexShortEdge",
                            "forceSimplex"
                        ]);
                    }
                }
                class Part extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "part", 1, (n)=>false);
                    }
                }
                class Pcl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pcl", true);
                        this.name = attributes.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.pageOffset = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Pdf extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pdf", true);
                        this.name = attributes.name || "";
                        this.adobeExtensionLevel = null;
                        this.batchOutput = null;
                        this.compression = null;
                        this.creator = null;
                        this.encryption = null;
                        this.fontInfo = null;
                        this.interactive = null;
                        this.linearized = null;
                        this.openAction = null;
                        this.pdfa = null;
                        this.producer = null;
                        this.renderPolicy = null;
                        this.scriptModel = null;
                        this.silentPrint = null;
                        this.submitFormat = null;
                        this.tagged = null;
                        this.version = null;
                        this.viewerPreferences = null;
                        this.xdc = null;
                    }
                }
                class Pdfa extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pdfa", true);
                        this.amd = null;
                        this.conformance = null;
                        this.includeXDPContent = null;
                        this.part = null;
                    }
                }
                class Permissions extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "permissions", true);
                        this.accessibleContent = null;
                        this.change = null;
                        this.contentCopy = null;
                        this.documentAssembly = null;
                        this.formFieldFilling = null;
                        this.modifyAnnots = null;
                        this.plaintextMetadata = null;
                        this.print = null;
                        this.printHighQuality = null;
                    }
                }
                class PickTrayByPDFSize extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pickTrayByPDFSize");
                    }
                }
                class Picture extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "picture");
                    }
                }
                class PlaintextMetadata extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "plaintextMetadata");
                    }
                }
                class Presence extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "presence", [
                            "preserve",
                            "dissolve",
                            "dissolveStructure",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class Present extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "present", true);
                        this.behaviorOverride = null;
                        this.cache = null;
                        this.common = null;
                        this.copies = null;
                        this.destination = null;
                        this.incrementalMerge = null;
                        this.layout = null;
                        this.output = null;
                        this.overprint = null;
                        this.pagination = null;
                        this.paginationOverride = null;
                        this.script = null;
                        this.validate = null;
                        this.xdp = null;
                        this.driver = new _xfa_object.XFAObjectArray();
                        this.labelPrinter = new _xfa_object.XFAObjectArray();
                        this.pcl = new _xfa_object.XFAObjectArray();
                        this.pdf = new _xfa_object.XFAObjectArray();
                        this.ps = new _xfa_object.XFAObjectArray();
                        this.submitUrl = new _xfa_object.XFAObjectArray();
                        this.webClient = new _xfa_object.XFAObjectArray();
                        this.zpl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Print extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "print");
                    }
                }
                class PrintHighQuality extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printHighQuality");
                    }
                }
                class PrintScaling extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printScaling", [
                            "appdefault",
                            "noScaling"
                        ]);
                    }
                }
                class PrinterName extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printerName");
                    }
                }
                class Producer extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "producer");
                    }
                }
                class Ps extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ps", true);
                        this.name = attributes.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Range extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "range");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s*,\s*/, 2).map((range)=>range.split("-").map((x)=>parseInt(x.trim(), 10))).filter((range)=>range.every((x)=>!isNaN(x))).map((range)=>{
                            if (range.length === 1) range.push(range[0]);
                            return range;
                        });
                    }
                }
                class Record extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "record");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                        const n = parseInt(this[_symbol_utils.$content], 10);
                        if (!isNaN(n) && n >= 0) this[_symbol_utils.$content] = n;
                    }
                }
                class Relevant extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "relevant");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/);
                    }
                }
                class Rename extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "rename");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                        if (this[_symbol_utils.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[_symbol_utils.$content])) (0, _util.warn)("XFA - Rename: invalid XFA name");
                    }
                }
                class RenderPolicy extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "renderPolicy", [
                            "server",
                            "client"
                        ]);
                    }
                }
                class RunScripts extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "runScripts", [
                            "both",
                            "client",
                            "none",
                            "server"
                        ]);
                    }
                }
                class Script extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "script", true);
                        this.currentPage = null;
                        this.exclude = null;
                        this.runScripts = null;
                    }
                }
                class ScriptModel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "scriptModel", [
                            "XFA",
                            "none"
                        ]);
                    }
                }
                class Severity extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "severity", [
                            "ignore",
                            "error",
                            "information",
                            "trace",
                            "warning"
                        ]);
                    }
                }
                class SilentPrint extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "silentPrint", true);
                        this.addSilentPrint = null;
                        this.printerName = null;
                    }
                }
                class Staple extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "staple");
                        this.mode = (0, _utils.getStringOption)(attributes.mode, [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class StartNode extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "startNode");
                    }
                }
                class StartPage extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "startPage", 0, (n)=>true);
                    }
                }
                class SubmitFormat extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "submitFormat", [
                            "html",
                            "delegate",
                            "fdf",
                            "xml",
                            "pdf"
                        ]);
                    }
                }
                class SubmitUrl extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "submitUrl");
                    }
                }
                class SubsetBelow extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "subsetBelow", 100, (n)=>n >= 0 && n <= 100);
                    }
                }
                class SuppressBanner extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "suppressBanner");
                    }
                }
                class Tagged extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "tagged");
                    }
                }
                class Template extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "template", true);
                        this.base = null;
                        this.relevant = null;
                        this.startPage = null;
                        this.uri = null;
                        this.xsl = null;
                    }
                }
                class Threshold extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "threshold", [
                            "trace",
                            "error",
                            "information",
                            "warning"
                        ]);
                    }
                }
                class To extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "to", [
                            "null",
                            "memory",
                            "stderr",
                            "stdout",
                            "system",
                            "uri"
                        ]);
                    }
                }
                class TemplateCache extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "templateCache");
                        this.maxEntries = (0, _utils.getInteger)({
                            data: attributes.maxEntries,
                            defaultValue: 5,
                            validate: (n)=>n >= 0
                        });
                    }
                }
                class Trace extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "trace", true);
                        this.area = new _xfa_object.XFAObjectArray();
                    }
                }
                class Transform extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "transform", true);
                        this.groupParent = null;
                        this.ifEmpty = null;
                        this.nameAttr = null;
                        this.picture = null;
                        this.presence = null;
                        this.rename = null;
                        this.whitespace = null;
                    }
                }
                class Type extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "type", [
                            "none",
                            "ascii85",
                            "asciiHex",
                            "ccittfax",
                            "flate",
                            "lzw",
                            "runLength",
                            "native",
                            "xdp",
                            "mergedXDP"
                        ]);
                    }
                }
                class Uri extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "uri");
                    }
                }
                class Validate extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validate", [
                            "preSubmit",
                            "prePrint",
                            "preExecute",
                            "preSave"
                        ]);
                    }
                }
                class ValidateApprovalSignatures extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validateApprovalSignatures");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>[
                                "docReady",
                                "postSign"
                            ].includes(x));
                    }
                }
                class ValidationMessaging extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validationMessaging", [
                            "allMessagesIndividually",
                            "allMessagesTogether",
                            "firstMessageOnly",
                            "noMessages"
                        ]);
                    }
                }
                class Version extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "version", [
                            "1.7",
                            "1.6",
                            "1.5",
                            "1.4",
                            "1.3",
                            "1.2"
                        ]);
                    }
                }
                class VersionControl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "VersionControl");
                        this.outputBelow = (0, _utils.getStringOption)(attributes.outputBelow, [
                            "warn",
                            "error",
                            "update"
                        ]);
                        this.sourceAbove = (0, _utils.getStringOption)(attributes.sourceAbove, [
                            "warn",
                            "error"
                        ]);
                        this.sourceBelow = (0, _utils.getStringOption)(attributes.sourceBelow, [
                            "update",
                            "maintain"
                        ]);
                    }
                }
                class ViewerPreferences extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "viewerPreferences", true);
                        this.ADBE_JSConsole = null;
                        this.ADBE_JSDebugger = null;
                        this.addViewerPreferences = null;
                        this.duplexOption = null;
                        this.enforce = null;
                        this.numberOfCopies = null;
                        this.pageRange = null;
                        this.pickTrayByPDFSize = null;
                        this.printScaling = null;
                    }
                }
                class WebClient extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "webClient", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Whitespace extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "whitespace", [
                            "preserve",
                            "ltrim",
                            "normalize",
                            "rtrim",
                            "trim"
                        ]);
                    }
                }
                class Window extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "window");
                    }
                    [_symbol_utils.$finalize]() {
                        const pair = this[_symbol_utils.$content].trim().split(/\s*,\s*/, 2).map((x)=>parseInt(x, 10));
                        if (pair.some((x)=>isNaN(x))) {
                            this[_symbol_utils.$content] = [
                                0,
                                0
                            ];
                            return;
                        }
                        if (pair.length === 1) pair.push(pair[0]);
                        this[_symbol_utils.$content] = pair;
                    }
                }
                class Xdc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xdc", true);
                        this.uri = new _xfa_object.XFAObjectArray();
                        this.xsl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Xdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xdp", true);
                        this.packets = null;
                    }
                }
                class Xsl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xsl", true);
                        this.debug = null;
                        this.uri = null;
                    }
                }
                class Zpl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "zpl", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class ConfigNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (ConfigNamespace.hasOwnProperty(name)) return ConfigNamespace[name](attributes);
                        return undefined;
                    }
                    static acrobat(attrs) {
                        return new Acrobat(attrs);
                    }
                    static acrobat7(attrs) {
                        return new Acrobat7(attrs);
                    }
                    static ADBE_JSConsole(attrs) {
                        return new ADBE_JSConsole(attrs);
                    }
                    static ADBE_JSDebugger(attrs) {
                        return new ADBE_JSDebugger(attrs);
                    }
                    static addSilentPrint(attrs) {
                        return new AddSilentPrint(attrs);
                    }
                    static addViewerPreferences(attrs) {
                        return new AddViewerPreferences(attrs);
                    }
                    static adjustData(attrs) {
                        return new AdjustData(attrs);
                    }
                    static adobeExtensionLevel(attrs) {
                        return new AdobeExtensionLevel(attrs);
                    }
                    static agent(attrs) {
                        return new Agent(attrs);
                    }
                    static alwaysEmbed(attrs) {
                        return new AlwaysEmbed(attrs);
                    }
                    static amd(attrs) {
                        return new Amd(attrs);
                    }
                    static area(attrs) {
                        return new Area(attrs);
                    }
                    static attributes(attrs) {
                        return new Attributes(attrs);
                    }
                    static autoSave(attrs) {
                        return new AutoSave(attrs);
                    }
                    static base(attrs) {
                        return new Base(attrs);
                    }
                    static batchOutput(attrs) {
                        return new BatchOutput(attrs);
                    }
                    static behaviorOverride(attrs) {
                        return new BehaviorOverride(attrs);
                    }
                    static cache(attrs) {
                        return new Cache(attrs);
                    }
                    static change(attrs) {
                        return new Change(attrs);
                    }
                    static common(attrs) {
                        return new Common(attrs);
                    }
                    static compress(attrs) {
                        return new Compress(attrs);
                    }
                    static compressLogicalStructure(attrs) {
                        return new CompressLogicalStructure(attrs);
                    }
                    static compressObjectStream(attrs) {
                        return new CompressObjectStream(attrs);
                    }
                    static compression(attrs) {
                        return new Compression(attrs);
                    }
                    static config(attrs) {
                        return new Config(attrs);
                    }
                    static conformance(attrs) {
                        return new Conformance(attrs);
                    }
                    static contentCopy(attrs) {
                        return new ContentCopy(attrs);
                    }
                    static copies(attrs) {
                        return new Copies(attrs);
                    }
                    static creator(attrs) {
                        return new Creator(attrs);
                    }
                    static currentPage(attrs) {
                        return new CurrentPage(attrs);
                    }
                    static data(attrs) {
                        return new Data(attrs);
                    }
                    static debug(attrs) {
                        return new Debug(attrs);
                    }
                    static defaultTypeface(attrs) {
                        return new DefaultTypeface(attrs);
                    }
                    static destination(attrs) {
                        return new Destination(attrs);
                    }
                    static documentAssembly(attrs) {
                        return new DocumentAssembly(attrs);
                    }
                    static driver(attrs) {
                        return new Driver(attrs);
                    }
                    static duplexOption(attrs) {
                        return new DuplexOption(attrs);
                    }
                    static dynamicRender(attrs) {
                        return new DynamicRender(attrs);
                    }
                    static embed(attrs) {
                        return new Embed(attrs);
                    }
                    static encrypt(attrs) {
                        return new Encrypt(attrs);
                    }
                    static encryption(attrs) {
                        return new Encryption(attrs);
                    }
                    static encryptionLevel(attrs) {
                        return new EncryptionLevel(attrs);
                    }
                    static enforce(attrs) {
                        return new Enforce(attrs);
                    }
                    static equate(attrs) {
                        return new Equate(attrs);
                    }
                    static equateRange(attrs) {
                        return new EquateRange(attrs);
                    }
                    static exclude(attrs) {
                        return new Exclude(attrs);
                    }
                    static excludeNS(attrs) {
                        return new ExcludeNS(attrs);
                    }
                    static flipLabel(attrs) {
                        return new FlipLabel(attrs);
                    }
                    static fontInfo(attrs) {
                        return new FontInfo(attrs);
                    }
                    static formFieldFilling(attrs) {
                        return new FormFieldFilling(attrs);
                    }
                    static groupParent(attrs) {
                        return new GroupParent(attrs);
                    }
                    static ifEmpty(attrs) {
                        return new IfEmpty(attrs);
                    }
                    static includeXDPContent(attrs) {
                        return new IncludeXDPContent(attrs);
                    }
                    static incrementalLoad(attrs) {
                        return new IncrementalLoad(attrs);
                    }
                    static incrementalMerge(attrs) {
                        return new IncrementalMerge(attrs);
                    }
                    static interactive(attrs) {
                        return new Interactive(attrs);
                    }
                    static jog(attrs) {
                        return new Jog(attrs);
                    }
                    static labelPrinter(attrs) {
                        return new LabelPrinter(attrs);
                    }
                    static layout(attrs) {
                        return new Layout(attrs);
                    }
                    static level(attrs) {
                        return new Level(attrs);
                    }
                    static linearized(attrs) {
                        return new Linearized(attrs);
                    }
                    static locale(attrs) {
                        return new Locale(attrs);
                    }
                    static localeSet(attrs) {
                        return new LocaleSet(attrs);
                    }
                    static log(attrs) {
                        return new Log(attrs);
                    }
                    static map(attrs) {
                        return new MapElement(attrs);
                    }
                    static mediumInfo(attrs) {
                        return new MediumInfo(attrs);
                    }
                    static message(attrs) {
                        return new Message(attrs);
                    }
                    static messaging(attrs) {
                        return new Messaging(attrs);
                    }
                    static mode(attrs) {
                        return new Mode(attrs);
                    }
                    static modifyAnnots(attrs) {
                        return new ModifyAnnots(attrs);
                    }
                    static msgId(attrs) {
                        return new MsgId(attrs);
                    }
                    static nameAttr(attrs) {
                        return new NameAttr(attrs);
                    }
                    static neverEmbed(attrs) {
                        return new NeverEmbed(attrs);
                    }
                    static numberOfCopies(attrs) {
                        return new NumberOfCopies(attrs);
                    }
                    static openAction(attrs) {
                        return new OpenAction(attrs);
                    }
                    static output(attrs) {
                        return new Output(attrs);
                    }
                    static outputBin(attrs) {
                        return new OutputBin(attrs);
                    }
                    static outputXSL(attrs) {
                        return new OutputXSL(attrs);
                    }
                    static overprint(attrs) {
                        return new Overprint(attrs);
                    }
                    static packets(attrs) {
                        return new Packets(attrs);
                    }
                    static pageOffset(attrs) {
                        return new PageOffset(attrs);
                    }
                    static pageRange(attrs) {
                        return new PageRange(attrs);
                    }
                    static pagination(attrs) {
                        return new Pagination(attrs);
                    }
                    static paginationOverride(attrs) {
                        return new PaginationOverride(attrs);
                    }
                    static part(attrs) {
                        return new Part(attrs);
                    }
                    static pcl(attrs) {
                        return new Pcl(attrs);
                    }
                    static pdf(attrs) {
                        return new Pdf(attrs);
                    }
                    static pdfa(attrs) {
                        return new Pdfa(attrs);
                    }
                    static permissions(attrs) {
                        return new Permissions(attrs);
                    }
                    static pickTrayByPDFSize(attrs) {
                        return new PickTrayByPDFSize(attrs);
                    }
                    static picture(attrs) {
                        return new Picture(attrs);
                    }
                    static plaintextMetadata(attrs) {
                        return new PlaintextMetadata(attrs);
                    }
                    static presence(attrs) {
                        return new Presence(attrs);
                    }
                    static present(attrs) {
                        return new Present(attrs);
                    }
                    static print(attrs) {
                        return new Print(attrs);
                    }
                    static printHighQuality(attrs) {
                        return new PrintHighQuality(attrs);
                    }
                    static printScaling(attrs) {
                        return new PrintScaling(attrs);
                    }
                    static printerName(attrs) {
                        return new PrinterName(attrs);
                    }
                    static producer(attrs) {
                        return new Producer(attrs);
                    }
                    static ps(attrs) {
                        return new Ps(attrs);
                    }
                    static range(attrs) {
                        return new Range(attrs);
                    }
                    static record(attrs) {
                        return new Record(attrs);
                    }
                    static relevant(attrs) {
                        return new Relevant(attrs);
                    }
                    static rename(attrs) {
                        return new Rename(attrs);
                    }
                    static renderPolicy(attrs) {
                        return new RenderPolicy(attrs);
                    }
                    static runScripts(attrs) {
                        return new RunScripts(attrs);
                    }
                    static script(attrs) {
                        return new Script(attrs);
                    }
                    static scriptModel(attrs) {
                        return new ScriptModel(attrs);
                    }
                    static severity(attrs) {
                        return new Severity(attrs);
                    }
                    static silentPrint(attrs) {
                        return new SilentPrint(attrs);
                    }
                    static staple(attrs) {
                        return new Staple(attrs);
                    }
                    static startNode(attrs) {
                        return new StartNode(attrs);
                    }
                    static startPage(attrs) {
                        return new StartPage(attrs);
                    }
                    static submitFormat(attrs) {
                        return new SubmitFormat(attrs);
                    }
                    static submitUrl(attrs) {
                        return new SubmitUrl(attrs);
                    }
                    static subsetBelow(attrs) {
                        return new SubsetBelow(attrs);
                    }
                    static suppressBanner(attrs) {
                        return new SuppressBanner(attrs);
                    }
                    static tagged(attrs) {
                        return new Tagged(attrs);
                    }
                    static template(attrs) {
                        return new Template(attrs);
                    }
                    static templateCache(attrs) {
                        return new TemplateCache(attrs);
                    }
                    static threshold(attrs) {
                        return new Threshold(attrs);
                    }
                    static to(attrs) {
                        return new To(attrs);
                    }
                    static trace(attrs) {
                        return new Trace(attrs);
                    }
                    static transform(attrs) {
                        return new Transform(attrs);
                    }
                    static type(attrs) {
                        return new Type(attrs);
                    }
                    static uri(attrs) {
                        return new Uri(attrs);
                    }
                    static validate(attrs) {
                        return new Validate(attrs);
                    }
                    static validateApprovalSignatures(attrs) {
                        return new ValidateApprovalSignatures(attrs);
                    }
                    static validationMessaging(attrs) {
                        return new ValidationMessaging(attrs);
                    }
                    static version(attrs) {
                        return new Version(attrs);
                    }
                    static versionControl(attrs) {
                        return new VersionControl(attrs);
                    }
                    static viewerPreferences(attrs) {
                        return new ViewerPreferences(attrs);
                    }
                    static webClient(attrs) {
                        return new WebClient(attrs);
                    }
                    static whitespace(attrs) {
                        return new Whitespace(attrs);
                    }
                    static window(attrs) {
                        return new Window(attrs);
                    }
                    static xdc(attrs) {
                        return new Xdc(attrs);
                    }
                    static xdp(attrs) {
                        return new Xdp(attrs);
                    }
                    static xsl(attrs) {
                        return new Xsl(attrs);
                    }
                    static zpl(attrs) {
                        return new Zpl(attrs);
                    }
                }
                exports.ConfigNamespace = ConfigNamespace;
            /***/ },
            /* 94 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ConnectionSetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const CONNECTION_SET_NS_ID = _namespaces.NamespaceIds.connectionSet.id;
                class ConnectionSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "connectionSet", true);
                        this.wsdlConnection = new _xfa_object.XFAObjectArray();
                        this.xmlConnection = new _xfa_object.XFAObjectArray();
                        this.xsdConnection = new _xfa_object.XFAObjectArray();
                    }
                }
                class EffectiveInputPolicy extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "effectiveInputPolicy");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class EffectiveOutputPolicy extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "effectiveOutputPolicy");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Operation extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "operation");
                        this.id = attributes.id || "";
                        this.input = attributes.input || "";
                        this.name = attributes.name || "";
                        this.output = attributes.output || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class RootElement extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "rootElement");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SoapAction extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "soapAction");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SoapAddress extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "soapAddress");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Uri extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "uri");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class WsdlAddress extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "wsdlAddress");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class WsdlConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "wsdlConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.effectiveInputPolicy = null;
                        this.effectiveOutputPolicy = null;
                        this.operation = null;
                        this.soapAction = null;
                        this.soapAddress = null;
                        this.wsdlAddress = null;
                    }
                }
                class XmlConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "xmlConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.uri = null;
                    }
                }
                class XsdConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "xsdConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.rootElement = null;
                        this.uri = null;
                    }
                }
                class ConnectionSetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (ConnectionSetNamespace.hasOwnProperty(name)) return ConnectionSetNamespace[name](attributes);
                        return undefined;
                    }
                    static connectionSet(attrs) {
                        return new ConnectionSet(attrs);
                    }
                    static effectiveInputPolicy(attrs) {
                        return new EffectiveInputPolicy(attrs);
                    }
                    static effectiveOutputPolicy(attrs) {
                        return new EffectiveOutputPolicy(attrs);
                    }
                    static operation(attrs) {
                        return new Operation(attrs);
                    }
                    static rootElement(attrs) {
                        return new RootElement(attrs);
                    }
                    static soapAction(attrs) {
                        return new SoapAction(attrs);
                    }
                    static soapAddress(attrs) {
                        return new SoapAddress(attrs);
                    }
                    static uri(attrs) {
                        return new Uri(attrs);
                    }
                    static wsdlAddress(attrs) {
                        return new WsdlAddress(attrs);
                    }
                    static wsdlConnection(attrs) {
                        return new WsdlConnection(attrs);
                    }
                    static xmlConnection(attrs) {
                        return new XmlConnection(attrs);
                    }
                    static xsdConnection(attrs) {
                        return new XsdConnection(attrs);
                    }
                }
                exports.ConnectionSetNamespace = ConnectionSetNamespace;
            /***/ },
            /* 95 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DatasetsNamespace = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const DATASETS_NS_ID = _namespaces.NamespaceIds.datasets.id;
                class Data extends _xfa_object.XmlObject {
                    constructor(attributes){
                        super(DATASETS_NS_ID, "data", attributes);
                    }
                    [_symbol_utils.$isNsAgnostic]() {
                        return true;
                    }
                }
                class Datasets extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(DATASETS_NS_ID, "datasets", true);
                        this.data = null;
                        this.Signature = null;
                    }
                    [_symbol_utils.$onChild](child) {
                        const name = child[_symbol_utils.$nodeName];
                        if (name === "data" && child[_symbol_utils.$namespaceId] === DATASETS_NS_ID || name === "Signature" && child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.signature.id) this[name] = child;
                        this[_symbol_utils.$appendChild](child);
                    }
                }
                class DatasetsNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (DatasetsNamespace.hasOwnProperty(name)) return DatasetsNamespace[name](attributes);
                        return undefined;
                    }
                    static datasets(attributes) {
                        return new Datasets(attributes);
                    }
                    static data(attributes) {
                        return new Data(attributes);
                    }
                }
                exports.DatasetsNamespace = DatasetsNamespace;
            /***/ },
            /* 96 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LocaleSetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                var _utils = __w_pdfjs_require__(84);
                const LOCALE_SET_NS_ID = _namespaces.NamespaceIds.localeSet.id;
                class CalendarSymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "calendarSymbols", true);
                        this.name = "gregorian";
                        this.dayNames = new _xfa_object.XFAObjectArray(2);
                        this.eraNames = null;
                        this.meridiemNames = null;
                        this.monthNames = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class CurrencySymbol extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "currencySymbol");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "symbol",
                            "isoname",
                            "decimal"
                        ]);
                    }
                }
                class CurrencySymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "currencySymbols", true);
                        this.currencySymbol = new _xfa_object.XFAObjectArray(3);
                    }
                }
                class DatePattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "datePattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class DatePatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "datePatterns", true);
                        this.datePattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class DateTimeSymbols extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "dateTimeSymbols");
                    }
                }
                class Day extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "day");
                    }
                }
                class DayNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "dayNames", true);
                        this.abbr = (0, _utils.getInteger)({
                            data: attributes.abbr,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.day = new _xfa_object.XFAObjectArray(7);
                    }
                }
                class Era extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "era");
                    }
                }
                class EraNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "eraNames", true);
                        this.era = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class Locale extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "locale", true);
                        this.desc = attributes.desc || "";
                        this.name = "isoname";
                        this.calendarSymbols = null;
                        this.currencySymbols = null;
                        this.datePatterns = null;
                        this.dateTimeSymbols = null;
                        this.numberPatterns = null;
                        this.numberSymbols = null;
                        this.timePatterns = null;
                        this.typeFaces = null;
                    }
                }
                class LocaleSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "localeSet", true);
                        this.locale = new _xfa_object.XFAObjectArray();
                    }
                }
                class Meridiem extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "meridiem");
                    }
                }
                class MeridiemNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "meridiemNames", true);
                        this.meridiem = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class Month extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "month");
                    }
                }
                class MonthNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "monthNames", true);
                        this.abbr = (0, _utils.getInteger)({
                            data: attributes.abbr,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.month = new _xfa_object.XFAObjectArray(12);
                    }
                }
                class NumberPattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberPattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class NumberPatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberPatterns", true);
                        this.numberPattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class NumberSymbol extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberSymbol");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "decimal",
                            "grouping",
                            "percent",
                            "minus",
                            "zero"
                        ]);
                    }
                }
                class NumberSymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberSymbols", true);
                        this.numberSymbol = new _xfa_object.XFAObjectArray(5);
                    }
                }
                class TimePattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "timePattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class TimePatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "timePatterns", true);
                        this.timePattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class TypeFace extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "typeFace", true);
                        this.name = attributes.name | "";
                    }
                }
                class TypeFaces extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "typeFaces", true);
                        this.typeFace = new _xfa_object.XFAObjectArray();
                    }
                }
                class LocaleSetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (LocaleSetNamespace.hasOwnProperty(name)) return LocaleSetNamespace[name](attributes);
                        return undefined;
                    }
                    static calendarSymbols(attrs) {
                        return new CalendarSymbols(attrs);
                    }
                    static currencySymbol(attrs) {
                        return new CurrencySymbol(attrs);
                    }
                    static currencySymbols(attrs) {
                        return new CurrencySymbols(attrs);
                    }
                    static datePattern(attrs) {
                        return new DatePattern(attrs);
                    }
                    static datePatterns(attrs) {
                        return new DatePatterns(attrs);
                    }
                    static dateTimeSymbols(attrs) {
                        return new DateTimeSymbols(attrs);
                    }
                    static day(attrs) {
                        return new Day(attrs);
                    }
                    static dayNames(attrs) {
                        return new DayNames(attrs);
                    }
                    static era(attrs) {
                        return new Era(attrs);
                    }
                    static eraNames(attrs) {
                        return new EraNames(attrs);
                    }
                    static locale(attrs) {
                        return new Locale(attrs);
                    }
                    static localeSet(attrs) {
                        return new LocaleSet(attrs);
                    }
                    static meridiem(attrs) {
                        return new Meridiem(attrs);
                    }
                    static meridiemNames(attrs) {
                        return new MeridiemNames(attrs);
                    }
                    static month(attrs) {
                        return new Month(attrs);
                    }
                    static monthNames(attrs) {
                        return new MonthNames(attrs);
                    }
                    static numberPattern(attrs) {
                        return new NumberPattern(attrs);
                    }
                    static numberPatterns(attrs) {
                        return new NumberPatterns(attrs);
                    }
                    static numberSymbol(attrs) {
                        return new NumberSymbol(attrs);
                    }
                    static numberSymbols(attrs) {
                        return new NumberSymbols(attrs);
                    }
                    static timePattern(attrs) {
                        return new TimePattern(attrs);
                    }
                    static timePatterns(attrs) {
                        return new TimePatterns(attrs);
                    }
                    static typeFace(attrs) {
                        return new TypeFace(attrs);
                    }
                    static typeFaces(attrs) {
                        return new TypeFaces(attrs);
                    }
                }
                exports.LocaleSetNamespace = LocaleSetNamespace;
            /***/ },
            /* 97 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SignatureNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const SIGNATURE_NS_ID = _namespaces.NamespaceIds.signature.id;
                class Signature extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(SIGNATURE_NS_ID, "signature", true);
                    }
                }
                class SignatureNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (SignatureNamespace.hasOwnProperty(name)) return SignatureNamespace[name](attributes);
                        return undefined;
                    }
                    static signature(attributes) {
                        return new Signature(attributes);
                    }
                }
                exports.SignatureNamespace = SignatureNamespace;
            /***/ },
            /* 98 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StylesheetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const STYLESHEET_NS_ID = _namespaces.NamespaceIds.stylesheet.id;
                class Stylesheet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(STYLESHEET_NS_ID, "stylesheet", true);
                    }
                }
                class StylesheetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (StylesheetNamespace.hasOwnProperty(name)) return StylesheetNamespace[name](attributes);
                        return undefined;
                    }
                    static stylesheet(attributes) {
                        return new Stylesheet(attributes);
                    }
                }
                exports.StylesheetNamespace = StylesheetNamespace;
            /***/ },
            /* 99 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XdpNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _symbol_utils = __w_pdfjs_require__(78);
                var _xfa_object = __w_pdfjs_require__(87);
                const XDP_NS_ID = _namespaces.NamespaceIds.xdp.id;
                class Xdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(XDP_NS_ID, "xdp", true);
                        this.uuid = attributes.uuid || "";
                        this.timeStamp = attributes.timeStamp || "";
                        this.config = null;
                        this.connectionSet = null;
                        this.datasets = null;
                        this.localeSet = null;
                        this.stylesheet = new _xfa_object.XFAObjectArray();
                        this.template = null;
                    }
                    [_symbol_utils.$onChildCheck](child) {
                        const ns = _namespaces.NamespaceIds[child[_symbol_utils.$nodeName]];
                        return ns && child[_symbol_utils.$namespaceId] === ns.id;
                    }
                }
                class XdpNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (XdpNamespace.hasOwnProperty(name)) return XdpNamespace[name](attributes);
                        return undefined;
                    }
                    static xdp(attributes) {
                        return new Xdp(attributes);
                    }
                }
                exports.XdpNamespace = XdpNamespace;
            /***/ },
            /* 100 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XhtmlNamespace = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(81);
                var _html_utils = __w_pdfjs_require__(83);
                var _utils = __w_pdfjs_require__(84);
                var _xfa_object = __w_pdfjs_require__(87);
                const XHTML_NS_ID = _namespaces.NamespaceIds.xhtml.id;
                const $richText = Symbol();
                const VALID_STYLES = new Set([
                    "color",
                    "font",
                    "font-family",
                    "font-size",
                    "font-stretch",
                    "font-style",
                    "font-weight",
                    "margin",
                    "margin-bottom",
                    "margin-left",
                    "margin-right",
                    "margin-top",
                    "letter-spacing",
                    "line-height",
                    "orphans",
                    "page-break-after",
                    "page-break-before",
                    "page-break-inside",
                    "tab-interval",
                    "tab-stop",
                    "text-align",
                    "text-decoration",
                    "text-indent",
                    "vertical-align",
                    "widows",
                    "kerning-mode",
                    "xfa-font-horizontal-scale",
                    "xfa-font-vertical-scale",
                    "xfa-spacerun",
                    "xfa-tab-stops"
                ]);
                const StyleMapping = new Map([
                    [
                        "page-break-after",
                        "breakAfter"
                    ],
                    [
                        "page-break-before",
                        "breakBefore"
                    ],
                    [
                        "page-break-inside",
                        "breakInside"
                    ],
                    [
                        "kerning-mode",
                        (value)=>value === "none" ? "none" : "normal"
                    ],
                    [
                        "xfa-font-horizontal-scale",
                        (value)=>`scaleX(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-font-vertical-scale",
                        (value)=>`scaleY(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-spacerun",
                        ""
                    ],
                    [
                        "xfa-tab-stops",
                        ""
                    ],
                    [
                        "font-size",
                        (value, original)=>{
                            value = original.fontSize = (0, _utils.getMeasurement)(value);
                            return (0, _html_utils.measureToString)(0.99 * value);
                        }
                    ],
                    [
                        "letter-spacing",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "line-height",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-bottom",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-left",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-right",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-top",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "text-indent",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "font-family",
                        (value)=>value
                    ],
                    [
                        "vertical-align",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ]
                ]);
                const spacesRegExp = /\s+/g;
                const crlfRegExp = /[\r\n]+/g;
                const crlfForRichTextRegExp = /\r\n?/g;
                function mapStyle(styleStr, node, richText) {
                    const style = Object.create(null);
                    if (!styleStr) return style;
                    const original = Object.create(null);
                    for (const [key, value] of styleStr.split(";").map((s)=>s.split(":", 2))){
                        const mapping = StyleMapping.get(key);
                        if (mapping === "") continue;
                        let newValue = value;
                        if (mapping) newValue = typeof mapping === "string" ? mapping : mapping(value, original);
                        if (key.endsWith("scale")) style.transform = style.transform ? `${style[key]} ${newValue}` : newValue;
                        else style[key.replaceAll(/-([a-zA-Z])/g, (_, x)=>x.toUpperCase())] = newValue;
                    }
                    if (style.fontFamily) (0, _html_utils.setFontFamily)({
                        typeface: style.fontFamily,
                        weight: style.fontWeight || "normal",
                        posture: style.fontStyle || "normal",
                        size: original.fontSize || 0
                    }, node, node[_symbol_utils.$globalData].fontFinder, style);
                    if (richText && style.verticalAlign && style.verticalAlign !== "0px" && style.fontSize) {
                        const SUB_SUPER_SCRIPT_FACTOR = 0.583;
                        const VERTICAL_FACTOR = 0.333;
                        const fontSize = (0, _utils.getMeasurement)(style.fontSize);
                        style.fontSize = (0, _html_utils.measureToString)(fontSize * SUB_SUPER_SCRIPT_FACTOR);
                        style.verticalAlign = (0, _html_utils.measureToString)(Math.sign((0, _utils.getMeasurement)(style.verticalAlign)) * fontSize * VERTICAL_FACTOR);
                    }
                    if (richText && style.fontSize) style.fontSize = `calc(${style.fontSize} * var(--scale-factor))`;
                    (0, _html_utils.fixTextIndent)(style);
                    return style;
                }
                function checkStyle(node) {
                    if (!node.style) return "";
                    return node.style.trim().split(/\s*;\s*/).filter((s)=>!!s).map((s)=>s.split(/\s*:\s*/, 2)).filter(([key, value])=>{
                        if (key === "font-family") node[_symbol_utils.$globalData].usedTypefaces.add(value);
                        return VALID_STYLES.has(key);
                    }).map((kv)=>kv.join(":")).join(";");
                }
                const NoWhites = new Set([
                    "body",
                    "html"
                ]);
                class XhtmlObject extends _xfa_object.XmlObject {
                    constructor(attributes, name){
                        super(XHTML_NS_ID, name);
                        this[$richText] = false;
                        this.style = attributes.style || "";
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        this.style = checkStyle(this);
                    }
                    [_symbol_utils.$acceptWhitespace]() {
                        return !NoWhites.has(this[_symbol_utils.$nodeName]);
                    }
                    [_symbol_utils.$onText](str, richText = false) {
                        if (!richText) {
                            str = str.replaceAll(crlfRegExp, "");
                            if (!this.style.includes("xfa-spacerun:yes")) str = str.replaceAll(spacesRegExp, " ");
                        } else this[$richText] = true;
                        if (str) this[_symbol_utils.$content] += str;
                    }
                    [_symbol_utils.$pushGlyphs](measure, mustPop = true) {
                        const xfaFont = Object.create(null);
                        const margin = {
                            top: NaN,
                            bottom: NaN,
                            left: NaN,
                            right: NaN
                        };
                        let lineHeight = null;
                        for (const [key, value] of this.style.split(";").map((s)=>s.split(":", 2)))switch(key){
                            case "font-family":
                                xfaFont.typeface = (0, _utils.stripQuotes)(value);
                                break;
                            case "font-size":
                                xfaFont.size = (0, _utils.getMeasurement)(value);
                                break;
                            case "font-weight":
                                xfaFont.weight = value;
                                break;
                            case "font-style":
                                xfaFont.posture = value;
                                break;
                            case "letter-spacing":
                                xfaFont.letterSpacing = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin":
                                const values = value.split(/ \t/).map((x)=>(0, _utils.getMeasurement)(x));
                                switch(values.length){
                                    case 1:
                                        margin.top = margin.bottom = margin.left = margin.right = values[0];
                                        break;
                                    case 2:
                                        margin.top = margin.bottom = values[0];
                                        margin.left = margin.right = values[1];
                                        break;
                                    case 3:
                                        margin.top = values[0];
                                        margin.bottom = values[2];
                                        margin.left = margin.right = values[1];
                                        break;
                                    case 4:
                                        margin.top = values[0];
                                        margin.left = values[1];
                                        margin.bottom = values[2];
                                        margin.right = values[3];
                                        break;
                                }
                                break;
                            case "margin-top":
                                margin.top = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-bottom":
                                margin.bottom = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-left":
                                margin.left = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-right":
                                margin.right = (0, _utils.getMeasurement)(value);
                                break;
                            case "line-height":
                                lineHeight = (0, _utils.getMeasurement)(value);
                                break;
                        }
                        measure.pushData(xfaFont, margin, lineHeight);
                        if (this[_symbol_utils.$content]) measure.addString(this[_symbol_utils.$content]);
                        else for (const child of this[_symbol_utils.$getChildren]()){
                            if (child[_symbol_utils.$nodeName] === "#text") {
                                measure.addString(child[_symbol_utils.$content]);
                                continue;
                            }
                            child[_symbol_utils.$pushGlyphs](measure);
                        }
                        if (mustPop) measure.popFont();
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const children = [];
                        this[_symbol_utils.$extra] = {
                            children: children
                        };
                        this[_symbol_utils.$childrenToHTML]({});
                        if (children.length === 0 && !this[_symbol_utils.$content]) return _utils.HTMLResult.EMPTY;
                        let value;
                        if (this[$richText]) value = this[_symbol_utils.$content] ? this[_symbol_utils.$content].replaceAll(crlfForRichTextRegExp, "\n") : undefined;
                        else value = this[_symbol_utils.$content] || undefined;
                        return _utils.HTMLResult.success({
                            name: this[_symbol_utils.$nodeName],
                            attributes: {
                                href: this.href,
                                style: mapStyle(this.style, this, this[$richText])
                            },
                            children: children,
                            value: value
                        });
                    }
                }
                class A extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "a");
                        this.href = (0, _html_utils.fixURL)(attributes.href) || "";
                    }
                }
                class B extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "b");
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        measure.pushFont({
                            weight: "bold"
                        });
                        super[_symbol_utils.$pushGlyphs](measure);
                        measure.popFont();
                    }
                }
                class Body extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "body");
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const res = super[_symbol_utils.$toHTML](availableSpace);
                        const { html: html } = res;
                        if (!html) return _utils.HTMLResult.EMPTY;
                        html.name = "div";
                        html.attributes.class = [
                            "xfaRich"
                        ];
                        return res;
                    }
                }
                class Br extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "br");
                    }
                    [_symbol_utils.$text]() {
                        return "\n";
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        measure.addString("\n");
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return _utils.HTMLResult.success({
                            name: "br"
                        });
                    }
                }
                class Html extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "html");
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const children = [];
                        this[_symbol_utils.$extra] = {
                            children: children
                        };
                        this[_symbol_utils.$childrenToHTML]({});
                        if (children.length === 0) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            value: this[_symbol_utils.$content] || ""
                        });
                        if (children.length === 1) {
                            const child = children[0];
                            if (child.attributes?.class.includes("xfaRich")) return _utils.HTMLResult.success(child);
                        }
                        return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            children: children
                        });
                    }
                }
                class I extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "i");
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        measure.pushFont({
                            posture: "italic"
                        });
                        super[_symbol_utils.$pushGlyphs](measure);
                        measure.popFont();
                    }
                }
                class Li extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "li");
                    }
                }
                class Ol extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "ol");
                    }
                }
                class P extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "p");
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        super[_symbol_utils.$pushGlyphs](measure, false);
                        measure.addString("\n");
                        measure.addPara();
                        measure.popFont();
                    }
                    [_symbol_utils.$text]() {
                        const siblings = this[_symbol_utils.$getParent]()[_symbol_utils.$getChildren]();
                        if (siblings.at(-1) === this) return super[_symbol_utils.$text]();
                        return super[_symbol_utils.$text]() + "\n";
                    }
                }
                class Span extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "span");
                    }
                }
                class Sub extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "sub");
                    }
                }
                class Sup extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "sup");
                    }
                }
                class Ul extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "ul");
                    }
                }
                class XhtmlNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (XhtmlNamespace.hasOwnProperty(name)) return XhtmlNamespace[name](attributes);
                        return undefined;
                    }
                    static a(attributes) {
                        return new A(attributes);
                    }
                    static b(attributes) {
                        return new B(attributes);
                    }
                    static body(attributes) {
                        return new Body(attributes);
                    }
                    static br(attributes) {
                        return new Br(attributes);
                    }
                    static html(attributes) {
                        return new Html(attributes);
                    }
                    static i(attributes) {
                        return new I(attributes);
                    }
                    static li(attributes) {
                        return new Li(attributes);
                    }
                    static ol(attributes) {
                        return new Ol(attributes);
                    }
                    static p(attributes) {
                        return new P(attributes);
                    }
                    static span(attributes) {
                        return new Span(attributes);
                    }
                    static sub(attributes) {
                        return new Sub(attributes);
                    }
                    static sup(attributes) {
                        return new Sup(attributes);
                    }
                    static ul(attributes) {
                        return new Ul(attributes);
                    }
                }
                exports.XhtmlNamespace = XhtmlNamespace;
            /***/ },
            /* 101 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.UnknownNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                class UnknownNamespace {
                    constructor(nsId){
                        this.namespaceId = nsId;
                    }
                    [_namespaces.$buildXFAObject](name, attributes) {
                        return new _xfa_object.XmlObject(this.namespaceId, name, attributes);
                    }
                }
                exports.UnknownNamespace = UnknownNamespace;
            /***/ },
            /* 102 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DatasetReader = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _xml_parser = __w_pdfjs_require__(71);
                function decodeString(str) {
                    try {
                        return (0, _util.stringToUTF8String)(str);
                    } catch (ex) {
                        (0, _util.warn)(`UTF-8 decoding failed: "${ex}".`);
                        return str;
                    }
                }
                class DatasetXMLParser extends _xml_parser.SimpleXMLParser {
                    constructor(options){
                        super(options);
                        this.node = null;
                    }
                    onEndElement(name) {
                        const node = super.onEndElement(name);
                        if (node && name === "xfa:datasets") {
                            this.node = node;
                            throw new Error("Aborting DatasetXMLParser.");
                        }
                    }
                }
                class DatasetReader {
                    constructor(data){
                        if (data.datasets) this.node = new _xml_parser.SimpleXMLParser({
                            hasAttributes: true
                        }).parseFromString(data.datasets).documentElement;
                        else {
                            const parser = new DatasetXMLParser({
                                hasAttributes: true
                            });
                            try {
                                parser.parseFromString(data["xdp:xdp"]);
                            } catch  {}
                            this.node = parser.node;
                        }
                    }
                    getValue(path) {
                        if (!this.node || !path) return "";
                        const node = this.node.searchNode((0, _core_utils.parseXFAPath)(path), 0);
                        if (!node) return "";
                        const first = node.firstChild;
                        if (first?.nodeName === "value") return node.children.map((child)=>decodeString(child.textContent));
                        return decodeString(node.textContent);
                    }
                }
                exports.DatasetReader = DatasetReader;
            /***/ },
            /* 103 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XRef = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _parser = __w_pdfjs_require__(16);
                var _core_utils = __w_pdfjs_require__(3);
                var _base_stream = __w_pdfjs_require__(5);
                var _crypto = __w_pdfjs_require__(74);
                class XRef {
                    #firstXRefStmPos = null;
                    constructor(stream, pdfManager){
                        this.stream = stream;
                        this.pdfManager = pdfManager;
                        this.entries = [];
                        this._xrefStms = new Set();
                        this._cacheMap = new Map();
                        this._pendingRefs = new _primitives.RefSet();
                        this._newPersistentRefNum = null;
                        this._newTemporaryRefNum = null;
                    }
                    getNewPersistentRef(obj) {
                        if (this._newPersistentRefNum === null) this._newPersistentRefNum = this.entries.length || 1;
                        const num = this._newPersistentRefNum++;
                        this._cacheMap.set(num, obj);
                        return _primitives.Ref.get(num, 0);
                    }
                    getNewTemporaryRef() {
                        if (this._newTemporaryRefNum === null) this._newTemporaryRefNum = this.entries.length || 1;
                        return _primitives.Ref.get(this._newTemporaryRefNum++, 0);
                    }
                    resetNewTemporaryRef() {
                        this._newTemporaryRefNum = null;
                    }
                    setStartXRef(startXRef) {
                        this.startXRefQueue = [
                            startXRef
                        ];
                    }
                    parse(recoveryMode = false) {
                        let trailerDict;
                        if (!recoveryMode) trailerDict = this.readXRef();
                        else {
                            (0, _util.warn)("Indexing all PDF objects");
                            trailerDict = this.indexObjects();
                        }
                        trailerDict.assignXref(this);
                        this.trailer = trailerDict;
                        let encrypt;
                        try {
                            encrypt = trailerDict.get("Encrypt");
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Encrypt" reference: "${ex}".`);
                        }
                        if (encrypt instanceof _primitives.Dict) {
                            const ids = trailerDict.get("ID");
                            const fileId = ids?.length ? ids[0] : "";
                            encrypt.suppressEncryption = true;
                            this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
                        }
                        let root;
                        try {
                            root = trailerDict.get("Root");
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Root" reference: "${ex}".`);
                        }
                        if (root instanceof _primitives.Dict) try {
                            const pages = root.get("Pages");
                            if (pages instanceof _primitives.Dict) {
                                this.root = root;
                                return;
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Pages" reference: "${ex}".`);
                        }
                        if (!recoveryMode) throw new _core_utils.XRefParseException();
                        throw new _util.InvalidPDFException("Invalid Root reference.");
                    }
                    processXRefTable(parser) {
                        if (!("tableState" in this)) this.tableState = {
                            entryNum: 0,
                            streamPos: parser.lexer.stream.pos,
                            parserBuf1: parser.buf1,
                            parserBuf2: parser.buf2
                        };
                        const obj = this.readXRefTable(parser);
                        if (!(0, _primitives.isCmd)(obj, "trailer")) throw new _util.FormatError("Invalid XRef table: could not find trailer dictionary");
                        let dict = parser.getObj();
                        if (!(dict instanceof _primitives.Dict) && dict.dict) dict = dict.dict;
                        if (!(dict instanceof _primitives.Dict)) throw new _util.FormatError("Invalid XRef table: could not parse trailer dictionary");
                        delete this.tableState;
                        return dict;
                    }
                    readXRefTable(parser) {
                        const stream = parser.lexer.stream;
                        const tableState = this.tableState;
                        stream.pos = tableState.streamPos;
                        parser.buf1 = tableState.parserBuf1;
                        parser.buf2 = tableState.parserBuf2;
                        let obj;
                        while(true){
                            if (!("firstEntryNum" in tableState) || !("entryCount" in tableState)) {
                                if ((0, _primitives.isCmd)(obj = parser.getObj(), "trailer")) break;
                                tableState.firstEntryNum = obj;
                                tableState.entryCount = parser.getObj();
                            }
                            let first = tableState.firstEntryNum;
                            const count = tableState.entryCount;
                            if (!Number.isInteger(first) || !Number.isInteger(count)) throw new _util.FormatError("Invalid XRef table: wrong types in subsection header");
                            for(let i = tableState.entryNum; i < count; i++){
                                tableState.streamPos = stream.pos;
                                tableState.entryNum = i;
                                tableState.parserBuf1 = parser.buf1;
                                tableState.parserBuf2 = parser.buf2;
                                const entry = {};
                                entry.offset = parser.getObj();
                                entry.gen = parser.getObj();
                                const type = parser.getObj();
                                if (type instanceof _primitives.Cmd) switch(type.cmd){
                                    case "f":
                                        entry.free = true;
                                        break;
                                    case "n":
                                        entry.uncompressed = true;
                                        break;
                                }
                                if (!Number.isInteger(entry.offset) || !Number.isInteger(entry.gen) || !(entry.free || entry.uncompressed)) throw new _util.FormatError(`Invalid entry in XRef subsection: ${first}, ${count}`);
                                if (i === 0 && entry.free && first === 1) first = 0;
                                if (!this.entries[i + first]) this.entries[i + first] = entry;
                            }
                            tableState.entryNum = 0;
                            tableState.streamPos = stream.pos;
                            tableState.parserBuf1 = parser.buf1;
                            tableState.parserBuf2 = parser.buf2;
                            delete tableState.firstEntryNum;
                            delete tableState.entryCount;
                        }
                        if (this.entries[0] && !this.entries[0].free) throw new _util.FormatError("Invalid XRef table: unexpected first object");
                        return obj;
                    }
                    processXRefStream(stream) {
                        if (!("streamState" in this)) {
                            const streamParameters = stream.dict;
                            const byteWidths = streamParameters.get("W");
                            let range = streamParameters.get("Index");
                            if (!range) range = [
                                0,
                                streamParameters.get("Size")
                            ];
                            this.streamState = {
                                entryRanges: range,
                                byteWidths: byteWidths,
                                entryNum: 0,
                                streamPos: stream.pos
                            };
                        }
                        this.readXRefStream(stream);
                        delete this.streamState;
                        return stream.dict;
                    }
                    readXRefStream(stream) {
                        const streamState = this.streamState;
                        stream.pos = streamState.streamPos;
                        const [typeFieldWidth, offsetFieldWidth, generationFieldWidth] = streamState.byteWidths;
                        const entryRanges = streamState.entryRanges;
                        while(entryRanges.length > 0){
                            const [first, n] = entryRanges;
                            if (!Number.isInteger(first) || !Number.isInteger(n)) throw new _util.FormatError(`Invalid XRef range fields: ${first}, ${n}`);
                            if (!Number.isInteger(typeFieldWidth) || !Number.isInteger(offsetFieldWidth) || !Number.isInteger(generationFieldWidth)) throw new _util.FormatError(`Invalid XRef entry fields length: ${first}, ${n}`);
                            for(let i = streamState.entryNum; i < n; ++i){
                                streamState.entryNum = i;
                                streamState.streamPos = stream.pos;
                                let type = 0, offset = 0, generation = 0;
                                for(let j = 0; j < typeFieldWidth; ++j){
                                    const typeByte = stream.getByte();
                                    if (typeByte === -1) throw new _util.FormatError("Invalid XRef byteWidths 'type'.");
                                    type = type << 8 | typeByte;
                                }
                                if (typeFieldWidth === 0) type = 1;
                                for(let j = 0; j < offsetFieldWidth; ++j){
                                    const offsetByte = stream.getByte();
                                    if (offsetByte === -1) throw new _util.FormatError("Invalid XRef byteWidths 'offset'.");
                                    offset = offset << 8 | offsetByte;
                                }
                                for(let j = 0; j < generationFieldWidth; ++j){
                                    const generationByte = stream.getByte();
                                    if (generationByte === -1) throw new _util.FormatError("Invalid XRef byteWidths 'generation'.");
                                    generation = generation << 8 | generationByte;
                                }
                                const entry = {};
                                entry.offset = offset;
                                entry.gen = generation;
                                switch(type){
                                    case 0:
                                        entry.free = true;
                                        break;
                                    case 1:
                                        entry.uncompressed = true;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new _util.FormatError(`Invalid XRef entry type: ${type}`);
                                }
                                if (!this.entries[first + i]) this.entries[first + i] = entry;
                            }
                            streamState.entryNum = 0;
                            streamState.streamPos = stream.pos;
                            entryRanges.splice(0, 2);
                        }
                    }
                    indexObjects() {
                        const TAB = 0x9, LF = 0xa, CR = 0xd, SPACE = 0x20;
                        const PERCENT = 0x25, LT = 0x3c;
                        function readToken(data, offset) {
                            let token = "", ch = data[offset];
                            while(ch !== LF && ch !== CR && ch !== LT){
                                if (++offset >= data.length) break;
                                token += String.fromCharCode(ch);
                                ch = data[offset];
                            }
                            return token;
                        }
                        function skipUntil(data, offset, what) {
                            const length = what.length, dataLength = data.length;
                            let skipped = 0;
                            while(offset < dataLength){
                                let i = 0;
                                while(i < length && data[offset + i] === what[i])++i;
                                if (i >= length) break;
                                offset++;
                                skipped++;
                            }
                            return skipped;
                        }
                        const gEndobjRegExp = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g;
                        const gStartxrefRegExp = /\b(startxref|\d+\s+\d+\s+obj)\b/g;
                        const objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
                        const trailerBytes = new Uint8Array([
                            116,
                            114,
                            97,
                            105,
                            108,
                            101,
                            114
                        ]);
                        const startxrefBytes = new Uint8Array([
                            115,
                            116,
                            97,
                            114,
                            116,
                            120,
                            114,
                            101,
                            102
                        ]);
                        const xrefBytes = new Uint8Array([
                            47,
                            88,
                            82,
                            101,
                            102
                        ]);
                        this.entries.length = 0;
                        this._cacheMap.clear();
                        const stream = this.stream;
                        stream.pos = 0;
                        const buffer = stream.getBytes(), bufferStr = (0, _util.bytesToString)(buffer), length = buffer.length;
                        let position = stream.start;
                        const trailers = [], xrefStms = [];
                        while(position < length){
                            let ch = buffer[position];
                            if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
                                ++position;
                                continue;
                            }
                            if (ch === PERCENT) {
                                do {
                                    ++position;
                                    if (position >= length) break;
                                    ch = buffer[position];
                                }while (ch !== LF && ch !== CR);
                                continue;
                            }
                            const token = readToken(buffer, position);
                            let m;
                            if (token.startsWith("xref") && (token.length === 4 || /\s/.test(token[4]))) {
                                position += skipUntil(buffer, position, trailerBytes);
                                trailers.push(position);
                                position += skipUntil(buffer, position, startxrefBytes);
                            } else if (m = objRegExp.exec(token)) {
                                const num = m[1] | 0, gen = m[2] | 0;
                                const startPos = position + token.length;
                                let contentLength, updateEntries = false;
                                if (!this.entries[num]) updateEntries = true;
                                else if (this.entries[num].gen === gen) try {
                                    const parser = new _parser.Parser({
                                        lexer: new _parser.Lexer(stream.makeSubStream(startPos))
                                    });
                                    parser.getObj();
                                    updateEntries = true;
                                } catch (ex) {
                                    if (ex instanceof _core_utils.ParserEOFException) (0, _util.warn)(`indexObjects -- checking object (${token}): "${ex}".`);
                                    else updateEntries = true;
                                }
                                if (updateEntries) this.entries[num] = {
                                    offset: position - stream.start,
                                    gen: gen,
                                    uncompressed: true
                                };
                                gEndobjRegExp.lastIndex = startPos;
                                const match = gEndobjRegExp.exec(bufferStr);
                                if (match) {
                                    const endPos = gEndobjRegExp.lastIndex + 1;
                                    contentLength = endPos - position;
                                    if (match[1] !== "endobj") {
                                        (0, _util.warn)(`indexObjects: Found "${match[1]}" inside of another "obj", ` + 'caused by missing "endobj" -- trying to recover.');
                                        contentLength -= match[1].length + 1;
                                    }
                                } else contentLength = length - position;
                                const content = buffer.subarray(position, position + contentLength);
                                const xrefTagOffset = skipUntil(content, 0, xrefBytes);
                                if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
                                    xrefStms.push(position - stream.start);
                                    this._xrefStms.add(position - stream.start);
                                }
                                position += contentLength;
                            } else if (token.startsWith("trailer") && (token.length === 7 || /\s/.test(token[7]))) {
                                trailers.push(position);
                                const startPos = position + token.length;
                                let contentLength;
                                gStartxrefRegExp.lastIndex = startPos;
                                const match = gStartxrefRegExp.exec(bufferStr);
                                if (match) {
                                    const endPos = gStartxrefRegExp.lastIndex + 1;
                                    contentLength = endPos - position;
                                    if (match[1] !== "startxref") {
                                        (0, _util.warn)(`indexObjects: Found "${match[1]}" after "trailer", ` + 'caused by missing "startxref" -- trying to recover.');
                                        contentLength -= match[1].length + 1;
                                    }
                                } else contentLength = length - position;
                                position += contentLength;
                            } else position += token.length + 1;
                        }
                        for (const xrefStm of xrefStms){
                            this.startXRefQueue.push(xrefStm);
                            this.readXRef(true);
                        }
                        const trailerDicts = [];
                        let isEncrypted = false;
                        for (const trailer of trailers){
                            stream.pos = trailer;
                            const parser = new _parser.Parser({
                                lexer: new _parser.Lexer(stream),
                                xref: this,
                                allowStreams: true,
                                recoveryMode: true
                            });
                            const obj = parser.getObj();
                            if (!(0, _primitives.isCmd)(obj, "trailer")) continue;
                            const dict = parser.getObj();
                            if (!(dict instanceof _primitives.Dict)) continue;
                            trailerDicts.push(dict);
                            if (dict.has("Encrypt")) isEncrypted = true;
                        }
                        let trailerDict, trailerError;
                        for (const dict of [
                            ...trailerDicts,
                            "genFallback",
                            ...trailerDicts
                        ]){
                            if (dict === "genFallback") {
                                if (!trailerError) break;
                                this._generationFallback = true;
                                continue;
                            }
                            let validPagesDict = false;
                            try {
                                const rootDict = dict.get("Root");
                                if (!(rootDict instanceof _primitives.Dict)) continue;
                                const pagesDict = rootDict.get("Pages");
                                if (!(pagesDict instanceof _primitives.Dict)) continue;
                                const pagesCount = pagesDict.get("Count");
                                if (Number.isInteger(pagesCount)) validPagesDict = true;
                            } catch (ex) {
                                trailerError = ex;
                                continue;
                            }
                            if (validPagesDict && (!isEncrypted || dict.has("Encrypt")) && dict.has("ID")) return dict;
                            trailerDict = dict;
                        }
                        if (trailerDict) return trailerDict;
                        if (this.topDict) return this.topDict;
                        throw new _util.InvalidPDFException("Invalid PDF structure.");
                    }
                    readXRef(recoveryMode = false) {
                        const stream = this.stream;
                        const startXRefParsedCache = new Set();
                        while(this.startXRefQueue.length){
                            try {
                                const startXRef = this.startXRefQueue[0];
                                if (startXRefParsedCache.has(startXRef)) {
                                    (0, _util.warn)("readXRef - skipping XRef table since it was already parsed.");
                                    this.startXRefQueue.shift();
                                    continue;
                                }
                                startXRefParsedCache.add(startXRef);
                                stream.pos = startXRef + stream.start;
                                const parser = new _parser.Parser({
                                    lexer: new _parser.Lexer(stream),
                                    xref: this,
                                    allowStreams: true
                                });
                                let obj = parser.getObj();
                                let dict;
                                if ((0, _primitives.isCmd)(obj, "xref")) {
                                    dict = this.processXRefTable(parser);
                                    if (!this.topDict) this.topDict = dict;
                                    obj = dict.get("XRefStm");
                                    if (Number.isInteger(obj) && !this._xrefStms.has(obj)) {
                                        this._xrefStms.add(obj);
                                        this.startXRefQueue.push(obj);
                                        this.#firstXRefStmPos ??= obj;
                                    }
                                } else if (Number.isInteger(obj)) {
                                    if (!Number.isInteger(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), "obj") || !((obj = parser.getObj()) instanceof _base_stream.BaseStream)) throw new _util.FormatError("Invalid XRef stream");
                                    dict = this.processXRefStream(obj);
                                    if (!this.topDict) this.topDict = dict;
                                    if (!dict) throw new _util.FormatError("Failed to read XRef stream");
                                } else throw new _util.FormatError("Invalid XRef stream header");
                                obj = dict.get("Prev");
                                if (Number.isInteger(obj)) this.startXRefQueue.push(obj);
                                else if (obj instanceof _primitives.Ref) this.startXRefQueue.push(obj.num);
                            } catch (e) {
                                if (e instanceof _core_utils.MissingDataException) throw e;
                                (0, _util.info)("(while reading XRef): " + e);
                            }
                            this.startXRefQueue.shift();
                        }
                        if (this.topDict) return this.topDict;
                        if (recoveryMode) return undefined;
                        throw new _core_utils.XRefParseException();
                    }
                    get lastXRefStreamPos() {
                        return this.#firstXRefStmPos ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
                    }
                    getEntry(i) {
                        const xrefEntry = this.entries[i];
                        if (xrefEntry && !xrefEntry.free && xrefEntry.offset) return xrefEntry;
                        return null;
                    }
                    fetchIfRef(obj, suppressEncryption = false) {
                        if (obj instanceof _primitives.Ref) return this.fetch(obj, suppressEncryption);
                        return obj;
                    }
                    fetch(ref, suppressEncryption = false) {
                        if (!(ref instanceof _primitives.Ref)) throw new Error("ref object is not a reference");
                        const num = ref.num;
                        const cacheEntry = this._cacheMap.get(num);
                        if (cacheEntry !== undefined) {
                            if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) cacheEntry.objId = ref.toString();
                            return cacheEntry;
                        }
                        let xrefEntry = this.getEntry(num);
                        if (xrefEntry === null) {
                            this._cacheMap.set(num, xrefEntry);
                            return xrefEntry;
                        }
                        if (this._pendingRefs.has(ref)) {
                            this._pendingRefs.remove(ref);
                            (0, _util.warn)(`Ignoring circular reference: ${ref}.`);
                            return _primitives.CIRCULAR_REF;
                        }
                        this._pendingRefs.put(ref);
                        try {
                            xrefEntry = xrefEntry.uncompressed ? this.fetchUncompressed(ref, xrefEntry, suppressEncryption) : this.fetchCompressed(ref, xrefEntry, suppressEncryption);
                            this._pendingRefs.remove(ref);
                        } catch (ex) {
                            this._pendingRefs.remove(ref);
                            throw ex;
                        }
                        if (xrefEntry instanceof _primitives.Dict) xrefEntry.objId = ref.toString();
                        else if (xrefEntry instanceof _base_stream.BaseStream) xrefEntry.dict.objId = ref.toString();
                        return xrefEntry;
                    }
                    fetchUncompressed(ref, xrefEntry, suppressEncryption = false) {
                        const gen = ref.gen;
                        let num = ref.num;
                        if (xrefEntry.gen !== gen) {
                            const msg = `Inconsistent generation in XRef: ${ref}`;
                            if (this._generationFallback && xrefEntry.gen < gen) {
                                (0, _util.warn)(msg);
                                return this.fetchUncompressed(_primitives.Ref.get(num, xrefEntry.gen), xrefEntry, suppressEncryption);
                            }
                            throw new _core_utils.XRefEntryException(msg);
                        }
                        const stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
                        const parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream),
                            xref: this,
                            allowStreams: true
                        });
                        const obj1 = parser.getObj();
                        const obj2 = parser.getObj();
                        const obj3 = parser.getObj();
                        if (obj1 !== num || obj2 !== gen || !(obj3 instanceof _primitives.Cmd)) throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref}`);
                        if (obj3.cmd !== "obj") {
                            if (obj3.cmd.startsWith("obj")) {
                                num = parseInt(obj3.cmd.substring(3), 10);
                                if (!Number.isNaN(num)) return num;
                            }
                            throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref}`);
                        }
                        xrefEntry = this.encrypt && !suppressEncryption ? parser.getObj(this.encrypt.createCipherTransform(num, gen)) : parser.getObj();
                        if (!(xrefEntry instanceof _base_stream.BaseStream)) this._cacheMap.set(num, xrefEntry);
                        return xrefEntry;
                    }
                    fetchCompressed(ref, xrefEntry, suppressEncryption = false) {
                        const tableOffset = xrefEntry.offset;
                        const stream = this.fetch(_primitives.Ref.get(tableOffset, 0));
                        if (!(stream instanceof _base_stream.BaseStream)) throw new _util.FormatError("bad ObjStm stream");
                        const first = stream.dict.get("First");
                        const n = stream.dict.get("N");
                        if (!Number.isInteger(first) || !Number.isInteger(n)) throw new _util.FormatError("invalid first and n parameters for ObjStm stream");
                        let parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream),
                            xref: this,
                            allowStreams: true
                        });
                        const nums = new Array(n);
                        const offsets = new Array(n);
                        for(let i = 0; i < n; ++i){
                            const num = parser.getObj();
                            if (!Number.isInteger(num)) throw new _util.FormatError(`invalid object number in the ObjStm stream: ${num}`);
                            const offset = parser.getObj();
                            if (!Number.isInteger(offset)) throw new _util.FormatError(`invalid object offset in the ObjStm stream: ${offset}`);
                            nums[i] = num;
                            offsets[i] = offset;
                        }
                        const start = (stream.start || 0) + first;
                        const entries = new Array(n);
                        for(let i = 0; i < n; ++i){
                            const length = i < n - 1 ? offsets[i + 1] - offsets[i] : undefined;
                            if (length < 0) throw new _util.FormatError("Invalid offset in the ObjStm stream.");
                            parser = new _parser.Parser({
                                lexer: new _parser.Lexer(stream.makeSubStream(start + offsets[i], length, stream.dict)),
                                xref: this,
                                allowStreams: true
                            });
                            const obj = parser.getObj();
                            entries[i] = obj;
                            if (obj instanceof _base_stream.BaseStream) continue;
                            const num = nums[i], entry = this.entries[num];
                            if (entry && entry.offset === tableOffset && entry.gen === i) this._cacheMap.set(num, obj);
                        }
                        xrefEntry = entries[xrefEntry.gen];
                        if (xrefEntry === undefined) throw new _core_utils.XRefEntryException(`Bad (compressed) XRef entry: ${ref}`);
                        return xrefEntry;
                    }
                    async fetchIfRefAsync(obj, suppressEncryption) {
                        if (obj instanceof _primitives.Ref) return this.fetchAsync(obj, suppressEncryption);
                        return obj;
                    }
                    async fetchAsync(ref, suppressEncryption) {
                        try {
                            return this.fetch(ref, suppressEncryption);
                        } catch (ex) {
                            if (!(ex instanceof _core_utils.MissingDataException)) throw ex;
                            await this.pdfManager.requestRange(ex.begin, ex.end);
                            return this.fetchAsync(ref, suppressEncryption);
                        }
                    }
                    getCatalogObj() {
                        return this.root;
                    }
                }
                exports.XRef = XRef;
            /***/ },
            /* 104 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(2);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self1 = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self1.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 105 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFWorkerStream = void 0;
                var _util = __w_pdfjs_require__(2);
                class PDFWorkerStream {
                    constructor(msgHandler){
                        this._msgHandler = msgHandler;
                        this._contentLength = null;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFWorkerStream = PDFWorkerStream;
                class PDFWorkerStreamReader {
                    constructor(msgHandler){
                        this._msgHandler = msgHandler;
                        this.onProgress = null;
                        this._contentLength = null;
                        this._isRangeSupported = false;
                        this._isStreamingSupported = false;
                        const readableStream = this._msgHandler.sendWithStream("GetReader");
                        this._reader = readableStream.getReader();
                        this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((data)=>{
                            this._isStreamingSupported = data.isStreamingSupported;
                            this._isRangeSupported = data.isRangeSupported;
                            this._contentLength = data.contentLength;
                        });
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    async read() {
                        const { value: value, done: done } = await this._reader.read();
                        if (done) return {
                            value: undefined,
                            done: true
                        };
                        return {
                            value: value.buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader.cancel(reason);
                    }
                }
                class PDFWorkerStreamRangeReader {
                    constructor(begin, end, msgHandler){
                        this._msgHandler = msgHandler;
                        this.onProgress = null;
                        const readableStream = this._msgHandler.sendWithStream("GetRangeReader", {
                            begin: begin,
                            end: end
                        });
                        this._reader = readableStream.getReader();
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        const { value: value, done: done } = await this._reader.read();
                        if (done) return {
                            value: undefined,
                            done: true
                        };
                        return {
                            value: value.buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader.cancel(reason);
                    }
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "WorkerMessageHandler", {
                enumerable: true,
                get: function() {
                    return _worker.WorkerMessageHandler;
                }
            });
            var _worker = __w_pdfjs_require__(1);
            const pdfjsVersion = '3.11.174';
            const pdfjsBuild = 'ce8716743';
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});



var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $8h6ET = parcelRequire("8h6ET");

var $drUL7 = parcelRequire("drUL7");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

const $76a68eb0f2535c39$export$f23ef6cb462a47f7 = (element)=>{
    const div = document.createElement('div');
    div.style.width = '100%';
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(div);
    root.render(element);
    return div;
};



var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $drUL7 = parcelRequire("drUL7");
parcelRequire("6hiCI");
var $28u6w = parcelRequire("28u6w");

var $bxRTa = parcelRequire("bxRTa");

var $eO5xw = parcelRequire("eO5xw");
const $cff17df49c38af05$var$md = new (0, $28u6w.default)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    linkify: false,
    typographer: true,
    quotes: `""''`
});
const $cff17df49c38af05$var$getSizeFromEnum = (size)=>{
    switch(size){
        case (0, $drUL7.TextSize).Small:
            return 'rf-small-size-auto';
        case (0, $drUL7.TextSize).Medium:
            return 'rf-text-medium-size-auto';
        case (0, $drUL7.TextSize).Large:
            return 'rf-text-large-size-auto';
        case (0, $drUL7.TextSize).ExtraLarge:
            return 'rf-text-extralarge-size-auto';
        case (0, $drUL7.TextSize).Default:
        default:
            return 'rf-text-size-auto';
    }
};
const $cff17df49c38af05$var$TextBlock = ({ text: text, isTitle: isTitle, isSubtitle: isSubtitle, size: size, weight: weight, horizontalAlignment: horizontalAlignment, wrap: wrap, maxLines: maxLines })=>{
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        if (text) {
            // Text size
            let styleToApply = isTitle ? 'rf-title-size-auto' : isSubtitle ? 'rf-subtitle-size-auto' : size ? $cff17df49c38af05$var$getSizeFromEnum(size) : 'rf-text-size-auto';
            // Text horizontal alignment
            if (horizontalAlignment) switch(horizontalAlignment){
                case 1:
                    styleToApply += ' rf-text-center';
                    break;
                case 2:
                    styleToApply += ' ltr:rf-text-right rtl:rf-text-left';
                    break;
                case 0:
                default:
                    styleToApply += ' ltr:rf-text-left rtl:rf-text-right';
                    break;
            }
            else styleToApply += ' ltr:rf-text-left rtl:rf-text-right';
            // Wrap ?
            wrap ? (isTitle || isSubtitle) && (styleToApply += ' rf-line-clamp-2') : styleToApply += ' rf-truncate';
            // Max lines ? If this is a title it has already been set to 2 lines if wrap is not false
            !isTitle && maxLines && maxLines > 0 && maxLines <= 10 && (styleToApply += ` rf-line-clamp-${maxLines}`);
            switch(weight){
                case (0, $drUL7.TextWeight).Lighter:
                    styleToApply += ' rf-font-light';
                    break;
                case (0, $drUL7.TextWeight).Bolder:
                    styleToApply += ' rf-font-bold';
                    break;
                case (0, $drUL7.TextWeight).Default:
                default:
                    break;
            }
            setStyle(styleToApply);
        }
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-text-cardFrameText ${style}`,
        dangerouslySetInnerHTML: {
            __html: text ? (0, $eO5xw.capitalizeFirstLetter)($cff17df49c38af05$var$md.render(text)) : '\u00a0'
        }
    });
};
var $cff17df49c38af05$export$2e2bcd8739ae039 = $cff17df49c38af05$var$TextBlock;



var $drUL7 = parcelRequire("drUL7");
class $1737244c1bf4b35d$export$92739f4310a31a0d extends (0, $6XfIC.TextBlock) {
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            let isTitle = false;
            let isSubtitle = false;
            if (this.size && this.size === (0, $drUL7.TextSize).Large) isTitle = true;
            else if (this.size && this.size === (0, $drUL7.TextSize).Medium) isSubtitle = true;
            const props = {
                text: this.text,
                isTitle: isTitle,
                isSubtitle: isSubtitle,
                size: this.size,
                weight: this.weight,
                horizontalAlignment: this.horizontalAlignment,
                wrap: this.wrap,
                maxLines: this.maxLines
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cff17df49c38af05$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $9e498129f110ea70$var$InputToggle = ({ id: id, title: title, valueOn: valueOn, defaultValue: defaultValue })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [on, setOn] = (0, $bxRTa.useState)(values.get(id) || defaultValue === valueOn);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.addCurrentToggleId)(id, defaultValue === valueOn);
    }, []);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent's handleChange method
   *  - set on state to its opposite
   */ const handleToggle = ()=>{
        console.log('Toggle Change : ', id);
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            (0, $9P0Ec.setToggleValue)(id, !on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-text-size-auto rf-text-white",
        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
            className: "rf-flex rf-flex-row rf-items-start",
            children: [
                /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                    type: "checkbox",
                    onChange: handleToggle,
                    className: "rf-toggle-custom",
                    checked: on
                }),
                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-input-label rf-mx-2",
                    children: (0, $eO5xw.capitalizeFirstLetter)(title || id)
                })
            ]
        })
    });
};
var $9e498129f110ea70$export$2e2bcd8739ae039 = $9e498129f110ea70$var$InputToggle;


class $081e22222a7bb1e5$export$c99bfd6b0ed44fbd extends (0, $6XfIC.ToggleInput) {
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.defaultValue || this.valueOff, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9e498129f110ea70$export$2e2bcd8739ae039), {
                id: this.id,
                title: this.title,
                valueOn: this.valueOn,
                defaultValue: this.defaultValue || this.valueOff
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e1a09104fc6ecb2a$var$extendStatics = function(d, b) {
    $e1a09104fc6ecb2a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e1a09104fc6ecb2a$var$extendStatics(d, b);
};
function $e1a09104fc6ecb2a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e1a09104fc6ecb2a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e1a09104fc6ecb2a$export$18ce0697a983be9b = function() {
    $e1a09104fc6ecb2a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e1a09104fc6ecb2a$export$18ce0697a983be9b.apply(this, arguments);
};
function $e1a09104fc6ecb2a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e1a09104fc6ecb2a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e1a09104fc6ecb2a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e1a09104fc6ecb2a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e1a09104fc6ecb2a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e1a09104fc6ecb2a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e1a09104fc6ecb2a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e1a09104fc6ecb2a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e1a09104fc6ecb2a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e1a09104fc6ecb2a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e1a09104fc6ecb2a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e1a09104fc6ecb2a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e1a09104fc6ecb2a$export$45d3717a4c69092e(o, m, p);
}
function $e1a09104fc6ecb2a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e1a09104fc6ecb2a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e1a09104fc6ecb2a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e1a09104fc6ecb2a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e1a09104fc6ecb2a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e1a09104fc6ecb2a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e1a09104fc6ecb2a$export$10c90e4f7922046c(v) {
    return this instanceof $e1a09104fc6ecb2a$export$10c90e4f7922046c ? (this.v = v, this) : new $e1a09104fc6ecb2a$export$10c90e4f7922046c(v);
}
function $e1a09104fc6ecb2a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e1a09104fc6ecb2a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e1a09104fc6ecb2a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e1a09104fc6ecb2a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e1a09104fc6ecb2a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e1a09104fc6ecb2a$export$19a8beecd37a4c45 === "function" ? $e1a09104fc6ecb2a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e1a09104fc6ecb2a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e1a09104fc6ecb2a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e1a09104fc6ecb2a$var$ownKeys = function(o) {
    $e1a09104fc6ecb2a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e1a09104fc6ecb2a$var$ownKeys(o);
};
function $e1a09104fc6ecb2a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e1a09104fc6ecb2a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e1a09104fc6ecb2a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e1a09104fc6ecb2a$var$__setModuleDefault(result, mod);
    return result;
}
function $e1a09104fc6ecb2a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e1a09104fc6ecb2a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e1a09104fc6ecb2a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e1a09104fc6ecb2a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e1a09104fc6ecb2a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e1a09104fc6ecb2a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e1a09104fc6ecb2a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e1a09104fc6ecb2a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e1a09104fc6ecb2a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e1a09104fc6ecb2a$export$2e2bcd8739ae039 = {
    __extends: $e1a09104fc6ecb2a$export$a8ba968b8961cb8a,
    __assign: $e1a09104fc6ecb2a$export$18ce0697a983be9b,
    __rest: $e1a09104fc6ecb2a$export$3c9a16f847548506,
    __decorate: $e1a09104fc6ecb2a$export$29e00dfd3077644b,
    __param: $e1a09104fc6ecb2a$export$d5ad3fd78186038f,
    __esDecorate: $e1a09104fc6ecb2a$export$3a84e1ae4e97e9b0,
    __runInitializers: $e1a09104fc6ecb2a$export$d831c04e792af3d,
    __propKey: $e1a09104fc6ecb2a$export$6a2a36740a146cb8,
    __setFunctionName: $e1a09104fc6ecb2a$export$d1a06452d3489bc7,
    __metadata: $e1a09104fc6ecb2a$export$f1db080c865becb9,
    __awaiter: $e1a09104fc6ecb2a$export$1050f835b63b671e,
    __generator: $e1a09104fc6ecb2a$export$67ebef60e6f28a6,
    __createBinding: $e1a09104fc6ecb2a$export$45d3717a4c69092e,
    __exportStar: $e1a09104fc6ecb2a$export$f33643c0debef087,
    __values: $e1a09104fc6ecb2a$export$19a8beecd37a4c45,
    __read: $e1a09104fc6ecb2a$export$8d051b38c9118094,
    __spread: $e1a09104fc6ecb2a$export$afc72e2116322959,
    __spreadArrays: $e1a09104fc6ecb2a$export$6388937ca91ccae8,
    __spreadArray: $e1a09104fc6ecb2a$export$1216008129fb82ed,
    __await: $e1a09104fc6ecb2a$export$10c90e4f7922046c,
    __asyncGenerator: $e1a09104fc6ecb2a$export$e427f37a30a4de9b,
    __asyncDelegator: $e1a09104fc6ecb2a$export$bbd80228419bb833,
    __asyncValues: $e1a09104fc6ecb2a$export$e3b29a3d6162315f,
    __makeTemplateObject: $e1a09104fc6ecb2a$export$4fb47efe1390b86f,
    __importStar: $e1a09104fc6ecb2a$export$c21735bcef00d192,
    __importDefault: $e1a09104fc6ecb2a$export$da59b14a69baef04,
    __classPrivateFieldGet: $e1a09104fc6ecb2a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e1a09104fc6ecb2a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e1a09104fc6ecb2a$export$81fdc39f203e4e04,
    __addDisposableResource: $e1a09104fc6ecb2a$export$88ac25d8e944e405,
    __disposeResources: $e1a09104fc6ecb2a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e1a09104fc6ecb2a$export$889dfb5d17574b0b
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $680es = parcelRequire("680es");
var $but28 = parcelRequire("but28");

var $kpSTr = parcelRequire("kpSTr");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("l9TTE");
var $fEfdX = parcelRequire("fEfdX");
/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $7e56bbb0bd2a2061$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $7e56bbb0bd2a2061$var$InputDate = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue })=>{
    const locale = (0, $680es.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [year, setYear] = (0, $bxRTa.useState)(new Date().getFullYear());
    const [month, setMonth] = (0, $bxRTa.useState)(new Date().getMonth() + 1);
    const [day, setDay] = (0, $bxRTa.useState)(new Date().getDate());
    const [maxYear, setMaxYear] = (0, $bxRTa.useState)(0);
    const [minYear, setMinYear] = (0, $bxRTa.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $bxRTa.useState)(12);
    const [minMonth, setMinMonth] = (0, $bxRTa.useState)(1);
    const [maxDay, setMaxDay] = (0, $bxRTa.useState)(31);
    const [minDay, setMinDay] = (0, $bxRTa.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $bxRTa.useState)(undefined);
    const [updatingDate, setUpdatingDate] = (0, $bxRTa.useState)(false);
    const [dayWheel, setDayWheel] = (0, $bxRTa.useState)(0);
    const [monthWheel, setMonthWheel] = (0, $bxRTa.useState)(0);
    const [yearWheel, setYearWheel] = (0, $bxRTa.useState)(0);
    const days = (0, $bxRTa.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $7e56bbb0bd2a2061$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On days state change :
   *  - set day state if current day is higher than days
   */ (0, $bxRTa.useEffect)(()=>{
        day && days && day > days && setDay(days);
    }, [
        days
    ]);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $bxRTa.useEffect)(()=>{
        const dateAsArray = (0, $kpSTr.getDateAsArray)(values.get(id) || defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if a day / month / year change is needed to keep the date a proper one
   *  - for example on february, there are either 28 or 29 days depending on the year
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingDate state to true to prevent concurrent modification, update, and set updatingdate back to false to release lock
   */ (0, $bxRTa.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingDate && day && month && year) {
            let updating = false;
            let dateAsString = `${year}-${month}-${day}`;
            const date = new Date(dateAsString);
            if (minValue && minValueAsDate && date < minValueAsDate) {
                dateAsString = minValue;
                updating = true;
            } else if (maxValue && maxValueAsDate && date > maxValueAsDate) {
                dateAsString = maxValue;
                updating = true;
            }
            // Save date
            (0, $9P0Ec.setValue)(id, dateAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingDate(true);
                const dateAsArray = dateAsString.split('-');
                setYear(parseInt(dateAsArray[0]));
                setMonth(parseInt(dateAsArray[1]));
                setDay(parseInt(dateAsArray[2]));
                setUpdatingDate(false);
            }
        }
    }, [
        day,
        month,
        year
    ]);
    /**
   * On dayWheel change, if dayWheel !== 0 :
   *  - try to update the day state
   *  - reset dayWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (dayWheel !== 0 && day && days) {
            if (dayWheel > 0) day + 1 > days ? setDay(1) : setDay((day)=>day + 1);
            else day - 1 > 0 ? setDay((day)=>day - 1) : setDay(days);
            // Reset dayWheel
            setDayWheel(0);
        }
    }, [
        dayWheel
    ]);
    /**
   * On monthWheel change, if monthWheel !== 0 :
   *  - try to update the month state
   *  - reset monthWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (monthWheel !== 0 && month) {
            if (monthWheel > 0) month + 1 > 12 ? setMonth(1) : setMonth((month)=>month + 1);
            else month - 1 > 0 ? setMonth((month)=>month - 1) : setMonth(12);
            // Reset monthWheel
            setMonthWheel(0);
        }
    }, [
        monthWheel
    ]);
    /**
   * On yearWheel change, if yearWheel !== 0 :
   *  - try to update the year state
   *  - reset yearWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (yearWheel !== 0 && year && minYear && maxYear) {
            if (yearWheel > 0) year !== maxYear && setYear((year)=>year + 1);
            else year !== minYear && setYear((year)=>year - 1);
            // Reset yearWheel
            setYearWheel(0);
        }
    }, [
        yearWheel
    ]);
    /**
   * On wheel event on day / month / year part :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - call wheel state depending on the type, that will trigger the related day / month / year state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'day':
                setDayWheel(delta);
                break;
            case 'month':
                setMonthWheel(delta);
                break;
            case 'year':
                setYearWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a day / month / year :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set chosen day / month / year if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'day':
                day && setDay(value);
                break;
            case 'month':
                month && value !== -1 && setMonth(value);
                break;
            case 'year':
                year && value !== -1 && setYear(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: 'linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                type: "date",
                className: "rf-hidden"
            }),
            year && month && day && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "day",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth && day === minDay ? -1 : day === 1 ? days || 1 : day - 1, 'day'),
                                children: year === minYear && month === minMonth && day === minDay ? '\u2800' : day === 1 ? `${days}` : `${day - 1}`
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: day
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth && day === maxDay ? -1 : day === days ? 1 : day + 1, 'day'),
                                children: year === maxYear && month === maxMonth && day === maxDay ? '\u2800' : day === days ? '1' : `${day + 1}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "month",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth ? -1 : month === 1 ? 12 : month - 1, 'month'),
                                children: year === minYear && month === minMonth ? '\u2800' : month === 1 ? `${(0, $eO5xw.capitalizeFirstLetter)((0, $kpSTr.getMonthAsString)(12, locale))}` : `${(0, $eO5xw.capitalizeFirstLetter)((0, $kpSTr.getMonthAsString)(month - 1, locale))}`
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: `${(0, $eO5xw.capitalizeFirstLetter)((0, $kpSTr.getMonthAsString)(month, locale))}`
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth ? -1 : month === 12 ? 1 : month + 1, 'month'),
                                children: year === maxYear && month === maxMonth ? '\u2800' : month === 12 ? `${(0, $eO5xw.capitalizeFirstLetter)((0, $kpSTr.getMonthAsString)(1, locale))}` : `${(0, $eO5xw.capitalizeFirstLetter)((0, $kpSTr.getMonthAsString)(month + 1, locale))}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "year",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear ? -1 : year - 1, 'year'),
                                children: year === minYear ? '\u2800' : year - 1
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: year
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear ? -1 : year + 1, 'year'),
                                children: year === maxYear ? '\u2800' : year + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7e56bbb0bd2a2061$export$2e2bcd8739ae039 = $7e56bbb0bd2a2061$var$InputDate;



var $f9SqX = parcelRequire("f9SqX");

var $drUL7 = parcelRequire("drUL7");
class $8c9a3349b8312469$export$a9633577dcb92569 extends (0, $6XfIC.DateInput) {
    static{
        // Add custom property to schema
        this.calendarProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'calendar', false);
    }
    // Calendar property accessors
    get calendar() {
        return !!this.getValue($8c9a3349b8312469$export$a9633577dcb92569.calendarProperty);
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            return this.id ? this.calendar ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f9SqX.default), {
                id: this.id,
                defaultValue: this.defaultValue,
                maxValue: this.max,
                minValue: this.min
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7e56bbb0bd2a2061$export$2e2bcd8739ae039), {
                id: this.id,
                defaultValue: this.defaultValue,
                maxValue: this.max,
                minValue: this.min
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($8c9a3349b8312469$export$a9633577dcb92569.calendarProperty)
], $8c9a3349b8312469$export$a9633577dcb92569.prototype, "calendar", null);



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $2rYkD = parcelRequire("2rYkD");

var $fEfdX = parcelRequire("fEfdX");
const $fda5f12a9973a178$var$InputTime = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [hour, setHour] = (0, $bxRTa.useState)(12);
    const [minute, setMinute] = (0, $bxRTa.useState)(0);
    const [maxHour, setMaxHour] = (0, $bxRTa.useState)(23);
    const [minHour, setMinHour] = (0, $bxRTa.useState)(0);
    const [maxMinute, setMaxMinute] = (0, $bxRTa.useState)(59);
    const [minMinute, setMinMinute] = (0, $bxRTa.useState)(0);
    const [updatingTime, setUpdatingTime] = (0, $bxRTa.useState)(false);
    const [hourWheel, setHourWheel] = (0, $bxRTa.useState)(0);
    const [minuteWheel, setMinuteWheel] = (0, $bxRTa.useState)(0);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On component mount :
   *  - set hour / minute from localStorage value if there is one, or defaultValue, or 12:00 if no other data
   *  - set maxHour and maxMinute states if maxValue prop is set
   *  - set minHour and minMinute states if minValue prop is set
   */ (0, $bxRTa.useEffect)(()=>{
        // Set hour and minute from localstorage or defaultvalue if one of those is set
        const timeFromLocalStorage = values.get(id) || defaultValue;
        const timeAsArray = timeFromLocalStorage ? timeFromLocalStorage.split(':') : [];
        if (timeAsArray.length === 2) {
            !isNaN(parseInt(timeAsArray[0])) && setHour(parseInt(timeAsArray[0]));
            !isNaN(parseInt(timeAsArray[1])) && setMinute(parseInt(timeAsArray[1]));
        }
        // Set min and max times
        if (maxValue) {
            const maxTimeAsArray = maxValue.split(':');
            setMaxHour(parseInt(maxTimeAsArray[0]));
            setMaxMinute(parseInt(maxTimeAsArray[1]));
        }
        if (minValue) {
            const minTimeAsArray = minValue.split(':');
            setMinHour(parseInt(minTimeAsArray[0]));
            setMinMinute(parseInt(minTimeAsArray[1]));
        }
    }, []);
    /**
   * On hour / minute state change :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingTime state to true to prevent concurrent modification, update, and set updatingTime back to false to release lock
   */ (0, $bxRTa.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingTime && hour !== undefined && minute !== undefined) {
            let updating = false;
            // Deal with hours and minutes lower than 10 : add a '0' before to keep 2-characters length for each
            const tempHour = hour < 10 ? `0${hour}` : hour;
            const tempMinute = minute < 10 ? `0${minute}` : minute;
            let timeAsString = `${tempHour}:${tempMinute}`;
            // Check if the time is lower than the minimal value if given, or greater than the maximal one if given
            if (minValue && (hour < minHour || hour === minHour && minute < minMinute)) {
                timeAsString = minValue;
                updating = true;
            } else if (maxValue && (hour > maxHour || hour === maxHour && minute > maxMinute)) {
                timeAsString = maxValue;
                updating = true;
            }
            // Save time
            (0, $9P0Ec.setValue)(id, timeAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingTime(true);
                const timeAsArray = timeAsString.split(':');
                setHour(parseInt(timeAsArray[0]));
                setMinute(parseInt(timeAsArray[1]));
                setUpdatingTime(false);
            }
        }
    }, [
        hour,
        minute
    ]);
    /**
   * On hourWheel change, if hourWheel !== 0 :
   *  - try to update the hour state
   *  - reset hourWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (hourWheel !== 0 && hour !== undefined) {
            if (hourWheel > 0) hour + 1 > 23 ? setHour(0) : setHour((hour)=>hour + 1);
            else hour - 1 < 0 ? setHour(23) : setHour((hour)=>hour - 1);
            // Reset dayWheel
            setHourWheel(0);
        }
    }, [
        hourWheel
    ]);
    /**
   * On minuteWheel change, if minuteWheel !== 0 :
   *  - try to update the minute state
   *  - reset minuteWheel state to 0
   */ (0, $bxRTa.useEffect)(()=>{
        if (minuteWheel !== 0 && minute !== undefined) {
            if (minuteWheel > 0) minute + 1 > 59 ? setMinute(0) : setMinute((minute)=>minute + 1);
            else minute - 1 < 0 ? setMinute(59) : setMinute((minute)=>minute - 1);
            // Reset monthWheel
            setMinuteWheel(0);
        }
    }, [
        minuteWheel
    ]);
    /**
   * On wheel event on hour / minute part :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call wheel state depending on the type, that will trigger the related hour / minute state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'hour':
                setHourWheel(delta);
                break;
            case 'minute':
                setMinuteWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a hour / minute :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set chosen hour / minute if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) switch(type){
            case 'hour':
                hour !== undefined && value !== -1 && setHour(value);
                break;
            case 'minute':
                minute !== undefined && value !== -1 && setMinute(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        dir: "ltr" /*To keep the time in the right direction, as it reads HH:MM universally*/ ,
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: 'linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                type: "time",
                className: "rf-hidden"
            }),
            hour !== undefined && minute !== undefined && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pr-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "hour",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour ? -1 : hour === 0 ? 23 : hour - 1, 'hour'),
                                children: minValue && hour === minHour ? '\u2800' : hour === 0 ? '23' : hour < 11 ? `0${hour - 1}` : hour - 1
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: hour < 10 ? `0${hour}` : hour
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour ? -1 : hour === 23 ? 0 : hour + 1, 'hour'),
                                children: maxValue && hour === maxHour ? '\u2800' : hour === 23 ? '00' : hour < 9 ? `0${hour + 1}` : hour + 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center rf-py-1",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: '\u2800'
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-text-primary",
                                children: ":"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: '\u2800'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fEfdX.default), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pl-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "minute",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour && minute === minMinute ? -1 : minute === 0 ? 59 : minute - 1, 'minute'),
                                children: minValue && hour === minHour && minute === minMinute ? '\u2800' : minute === 0 ? '59' : minute < 11 ? `0${minute - 1}` : minute - 1
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: minute < 10 ? `0${minute}` : minute
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour && minute === maxMinute ? -1 : minute === 59 ? 0 : minute + 1, 'minute'),
                                children: maxValue && hour === maxHour && minute === maxMinute ? '\u2800' : minute < 9 ? `0${minute + 1}` : minute === 59 ? '00' : minute + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fda5f12a9973a178$export$2e2bcd8739ae039 = $fda5f12a9973a178$var$InputTime;


class $7186f765e3370ce8$export$27dc9c3aadf0815c extends (0, $6XfIC.TimeInput) {
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.defaultValue || undefined, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $fda5f12a9973a178$export$2e2bcd8739ae039), {
                id: this.id,
                defaultValue: this.defaultValue,
                maxValue: this.max,
                minValue: this.min
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $139d6d494ef941ff$var$Radio = ({ id: id, choices: choices, split: split })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || '');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(value);
            (0, $9P0Ec.setValue)(id, value);
        }
    };
    return display && display.length > 0 ? split ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                            })
                        ]
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                            })
                        ]
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-radio-custom",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("label", {
                        htmlFor: `radio-${key}`,
                        className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $139d6d494ef941ff$export$2e2bcd8739ae039 = $139d6d494ef941ff$var$Radio;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $ee499ba1a4538846$var$RadioAsButton = ({ id: id, choices: choices })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || '');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(value);
            (0, $9P0Ec.setValue)(id, value);
        }
    };
    return display?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${choice.value === chosen ? 'rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover' : 'rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault'} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $ee499ba1a4538846$export$2e2bcd8739ae039 = $ee499ba1a4538846$var$RadioAsButton;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $517WC = parcelRequire("517WC");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("kMAJU");
var $kA2rN = parcelRequire("kA2rN");
const $b9c2f2df8863a08d$var$Checkbox = ({ id: id, choices: choices, split: split })=>{
    const themeColors = (0, $517WC.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || []);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $bxRTa.useEffect)(()=>{
        (0, $9P0Ec.setValue)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display?.length ? split ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 ltr:rf-pr-2 rtl:rf-pl-2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
                                    className: "rf-absolute ltr:rf-left-1 rtl:rf-right-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                    className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
                                    className: "rf-absolute ltr:rf-left-1 rtl:rf-right-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                    className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-col rf-items-start rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-relative rf-mb-3",
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                    className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                            type: "checkbox",
                            value: choice.value,
                            checked: chosen.includes(choice.value),
                            onChange: ()=>handleChange(choice.value),
                            className: "rf-checkbox-custom"
                        }),
                        chosen.includes(choice.value) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $kA2rN.default), {
                            className: "rf-absolute ltr:rf-left-1 rtl:rf-right-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                            color: themeColors.formInput.inputRadioCheckbox.checked.item
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                            className: "rf-input-label rf-mx-2 rf-max-w-[calc(100%-2rem)]",
                            children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                        })
                    ]
                })
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $b9c2f2df8863a08d$export$2e2bcd8739ae039 = $b9c2f2df8863a08d$var$Checkbox;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $945b84087e337d98$var$CheckboxAsButton = ({ id: id, choices: choices })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || []);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $bxRTa.useEffect)(()=>{
        (0, $9P0Ec.setValue)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${chosen.includes(choice.value) ? 'rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover' : 'rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault'} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                        type: "checkbox",
                        value: choice.value,
                        checked: chosen.includes(choice.value),
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $945b84087e337d98$export$2e2bcd8739ae039 = $945b84087e337d98$var$CheckboxAsButton;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $gxeI6 = parcelRequire("gxeI6");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hNqlv");
var $1NaGJ = parcelRequire("1NaGJ");
const $6acb6a669ff438f0$var$Select = ({ id: id, choices: choices, placeholder: placeholder })=>{
    const translation = (0, $gxeI6.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [open, setOpen] = (0, $bxRTa.useState)(false);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || null);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $bxRTa.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call :
   *  - set open state to its contrary
   */ const toggleOpen = ()=>{
        setOpen(!open);
    };
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with choice value
   *  - call parent's handleSelect method
   *  - call toggleOpen method
   * @param choice : Choice
   */ const handleChange = (choice)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(choice);
            (0, $9P0Ec.setValue)(id, choice);
            toggleOpen();
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-formInputTextDefault",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                onClick: toggleOpen,
                className: `rf-w-full rf-flex rf-flex-row rf-justify-between rf-items-center rf-p-4 rf-border-2 rf-rounded ${open ? 'rf-border-formInputRadioCheckboxCheckedBorder' : 'rf-border-formInputRadioCheckboxUncheckedBorder'} rf-bg-formInputRadioCheckboxUncheckedBackground`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-truncate",
                        children: chosen?.title || placeholder || translation.inputs.choose
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-2",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1NaGJ.default), {
                            className: "rf-h-full"
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $fl9nK.jsx)("ul", {
                className: "rf-mt-1 rf-max-h-48 rf-pl-0 rf-w-full rf-rounded rf-border-2 rf-border-formInputRadioCheckboxUncheckedBorder rf-bg-formInputRadioCheckboxUncheckedBackground rf-overflow-y-scroll rf-scrollbar-thin",
                style: {
                    listStyle: 'none'
                },
                children: display.map((choice, key)=>{
                    return /*#__PURE__*/ (0, $fl9nK.jsx)("li", {
                        onClick: ()=>handleChange(choice),
                        className: "rf-px-4 rf-py-2 hover:rf-text-formInputRadioCheckboxCheckedItem hover:rf-bg-formInputRadioCheckboxCheckedBackground",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $6acb6a669ff438f0$export$2e2bcd8739ae039 = $6acb6a669ff438f0$var$Select;



var $drUL7 = parcelRequire("drUL7");
class $6fd633cb7bc51693$export$3d2f970ec3b98a50 extends $drUL7.ChoiceSetInput {
    static{
        this.JsonTypeName = 'ChoiceSetClass';
    }
    getJsonTypeName() {
        return $6fd633cb7bc51693$export$3d2f970ec3b98a50.JsonTypeName;
    }
    static{
        // Add custom preperties to schema
        this.splitProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'split', false);
    }
    static{
        this.displayAsButtonProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'asButtons', false);
    }
    // Split property accessors
    get split() {
        return !!this.getValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.splitProperty);
    }
    set split(value) {
        if (this.split !== value) {
            this.setValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.splitProperty, value);
            this.updateLayout();
        }
    }
    // AsButtons property accessors
    get asButtons() {
        return !!this.getValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.displayAsButtonProperty);
    }
    set asButtons(value) {
        if (this.asButtons !== value) {
            this.setValue($6fd633cb7bc51693$export$3d2f970ec3b98a50.displayAsButtonProperty, value);
            this.updateLayout();
        }
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            // Return empty fragment if no id provided
            if (!this.id) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
            // Check if we use checkboxes, radio buttons or select input
            let inputType = 'select';
            if (this.asButtons) inputType = this.isMultiSelect ? 'checkboxbuttons' : 'radiobuttons';
            else if (!this.isCompact) inputType = this.isMultiSelect ? 'checkbox' : 'radio';
            switch(inputType){
                case 'select':
                    break;
                case 'checkbox':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b9c2f2df8863a08d$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices,
                        split: this.split
                    });
                case 'radio':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $139d6d494ef941ff$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices,
                        split: this.split
                    });
                case 'checkboxbuttons':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $945b84087e337d98$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices
                    });
                case 'radiobuttons':
                    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ee499ba1a4538846$export$2e2bcd8739ae039), {
                        id: this.id,
                        choices: this.choices
                    });
            }
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6acb6a669ff438f0$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choices,
                placeholder: this.placeholder
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($6fd633cb7bc51693$export$3d2f970ec3b98a50.splitProperty)
], $6fd633cb7bc51693$export$3d2f970ec3b98a50.prototype, "split", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($6fd633cb7bc51693$export$3d2f970ec3b98a50.displayAsButtonProperty)
], $6fd633cb7bc51693$export$3d2f970ec3b98a50.prototype, "asButtons", null);




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $517WC = parcelRequire("517WC");
var $but28 = parcelRequire("but28");

var $2rYkD = parcelRequire("2rYkD");
/**
 * Default data if not given in props :
 *  - defaultEmoji = default displayed object
 */ const $1e42b81147f2f33c$var$defaultEmoji = "\uD83D\uDFCA";
// emoji examples ['🟊', '♠', '✺', 'Ϙ', '◎', '₱', '😔', '😐', '😀']
const $1e42b81147f2f33c$var$Likert = ({ id: id, ratingMin: ratingMin, ratingMax: ratingMax, emojis: emojis, strokeColor: strokeColor })=>{
    const themeColors = (0, $517WC.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [data, setData] = (0, $bxRTa.useState)([]);
    const [rating, setRating] = (0, $bxRTa.useState)(values.get(id) || ratingMin || 0);
    const [hover, setHover] = (0, $bxRTa.useState)(0);
    const hoverColor = strokeColor || themeColors.formInput.likert.hover;
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On component mount :
   *  - create array of Dataset to be mapped for display
   *  - set stroke color if given in props
   */ (0, $bxRTa.useEffect)(()=>{
        const min = ratingMin || 0;
        const range = min <= 0 ? Math.abs(min) + ratingMax + 1 : ratingMax;
        let dataArray = [];
        // If there are as many emojis as values, let's use them all
        if (emojis.length === range) for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[i],
                value: min + i
            }
        ];
        else for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[0] || $1e42b81147f2f33c$var$defaultEmoji,
                value: min + i
            }
        ];
        setData(dataArray);
    }, []);
    /**
   * On element click :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent function from props with the value retrieved
   *  - set rating
   */ const handleClick = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            (0, $9P0Ec.setValue)(id, value);
            setRating(value);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-my-4 rf-flex rf-flex-row rf-flex-nowrap rf-justify-center rf-items-center rf-title-large-size-auto",
        children: data.map((tuple, index)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-px-1 rf-likert-custom",
                style: {
                    color: tuple.value <= (hover || rating) ? hoverColor : themeColors.formInput.likert.default
                },
                onClick: ()=>handleClick(tuple.value),
                onMouseEnter: ()=>setHover(tuple.value),
                onMouseLeave: ()=>setHover(rating),
                children: tuple.emoji
            }, index);
        })
    });
};
var $1e42b81147f2f33c$export$2e2bcd8739ae039 = $1e42b81147f2f33c$var$Likert;



var $drUL7 = parcelRequire("drUL7");
class $38ef32f553c0c76d$export$527d02f4ea70b77 extends $drUL7.Input {
    static{
        this.JsonTypeName = 'Retorik.Likert';
    }
    getJsonTypeName() {
        return $38ef32f553c0c76d$export$527d02f4ea70b77.JsonTypeName;
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static{
        this.ratingMinProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'ratingMin', 1);
    }
    static{
        this.ratingMaxProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'ratingMax', 5);
    }
    static{
        this.emojisProperty = new $drUL7.StringArrayProperty($drUL7.Versions.v1_0, 'emojis', []);
    }
    static{
        this.strokeColorProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'strokeColor', true);
    }
    // ratingMin property accessors
    get ratingMin() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMinProperty) || '';
    }
    set ratingMin(val) {
        if (this.ratingMin !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMinProperty, val);
    }
    // ratingMax property accessors
    get ratingMax() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMaxProperty) || '';
    }
    set ratingMax(val) {
        if (this.ratingMax !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMaxProperty, val);
    }
    // emojis property accessors
    get emojis() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.emojisProperty) || '';
    }
    set emojis(val) {
        if (this.emojis !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.emojisProperty, val);
    }
    // strokeColor property accessors
    get strokeColor() {
        return this.getValue($38ef32f553c0c76d$export$527d02f4ea70b77.strokeColorProperty) || '';
    }
    set strokeColor(val) {
        if (this.strokeColor !== val) this.setValue($38ef32f553c0c76d$export$527d02f4ea70b77.strokeColorProperty, val);
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.ratingMin, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1e42b81147f2f33c$export$2e2bcd8739ae039), {
                id: this.id,
                ratingMin: this.ratingMin,
                ratingMax: this.ratingMax,
                emojis: this.emojis,
                strokeColor: this.strokeColor
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMinProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "ratingMin", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.ratingMaxProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "ratingMax", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.emojisProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "emojis", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($38ef32f553c0c76d$export$527d02f4ea70b77.strokeColorProperty)
], $38ef32f553c0c76d$export$527d02f4ea70b77.prototype, "strokeColor", null);




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");


var $drUL7 = parcelRequire("drUL7");
class $39d8560fb4e8ec95$export$fce58f7f7dbd3025 extends $drUL7.SerializableObject {
    static{
        this.JsonTypeName = 'ChoiceWithUrl';
    }
    getJsonTypeName() {
        return $39d8560fb4e8ec95$export$fce58f7f7dbd3025.JsonTypeName;
    }
    getSchemaKey() {
        return $39d8560fb4e8ec95$export$fce58f7f7dbd3025.JsonTypeName;
    }
    static{
        this.titleProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'title', true);
    }
    static{
        this.valueProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'value', true);
    }
    static{
        // Add url property to schema
        this.urlProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'url', true);
    }
    get title() {
        return this.getValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.titleProperty) || '';
    }
    set title(val) {
        if (this.title !== val) this.setValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.titleProperty, val);
    }
    get value() {
        return this.getValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.valueProperty) || '';
    }
    set value(val) {
        if (this.value !== val) this.setValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.valueProperty, val);
    }
    get url() {
        return this.getValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.urlProperty) || '';
    }
    set url(val) {
        if (this.url !== val) this.setValue($39d8560fb4e8ec95$export$fce58f7f7dbd3025.urlProperty, val);
    }
    constructor(title, value, url){
        super();
        this.title = title || '';
        this.value = value || '';
        this.url = url || '';
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($39d8560fb4e8ec95$export$fce58f7f7dbd3025.titleProperty)
], $39d8560fb4e8ec95$export$fce58f7f7dbd3025.prototype, "title", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($39d8560fb4e8ec95$export$fce58f7f7dbd3025.valueProperty)
], $39d8560fb4e8ec95$export$fce58f7f7dbd3025.prototype, "value", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($39d8560fb4e8ec95$export$fce58f7f7dbd3025.urlProperty)
], $39d8560fb4e8ec95$export$fce58f7f7dbd3025.prototype, "url", null);



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $92da696b1705d533$var$MultiSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || []);
    const [overflow, setOverflow] = (0, $bxRTa.useState)(false);
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
                } else {
                    setOverflow(false);
                    setStyle('rf-grid rf-grid-rows-2 rf-grid-cols-3');
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
            } else {
                setOverflow(false);
                setStyle('rf-grid rf-grid-rows-1 rf-grid-cols-2');
            }
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $bxRTa.useEffect)(()=>{
        (0, $9P0Ec.setValue)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-h-fit rf-flex rf-flex-col rf-items-start ${overflow && 'rf-flex-[0_0_40%]'}`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${chosen.includes(choice.value) ? 'rf-border-primary' : 'rf-border-formInputRadioCheckboxUncheckedBorder'} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "checkbox",
                                value: choice.value,
                                checked: chosen.includes(choice.value),
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-mt-2 rf-w-full rf-line-clamp-2",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $92da696b1705d533$export$2e2bcd8739ae039 = $92da696b1705d533$var$MultiSelect;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $but28 = parcelRequire("but28");

var $eO5xw = parcelRequire("eO5xw");

var $2rYkD = parcelRequire("2rYkD");
const $d7223387b45ac98b$var$MonoSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions })=>{
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [display, setDisplay] = (0, $bxRTa.useState)([]);
    const [chosen, setChosen] = (0, $bxRTa.useState)(values.get(id) || '');
    const [overflow, setOverflow] = (0, $bxRTa.useState)(false);
    const [style, setStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $bxRTa.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
                } else {
                    setOverflow(false);
                    setStyle(`rf-grid ${choices.length > 3 && 'rf-grid-rows-2'} rf-grid-cols-3`);
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle('rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4');
            } else {
                setOverflow(false);
                setStyle('rf-grid rf-grid-rows-1 rf-grid-cols-2');
            }
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setChosen(value);
            (0, $9P0Ec.setValue)(id, value);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-h-fit rf-flex rf-flex-col rf-items-start ${overflow && 'rf-flex-[0_0_40%]'}`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${choice.value === chosen ? 'rf-border-primary' : 'rf-border-formInputRadioCheckboxUncheckedBorder'} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-pt-2 rf-w-full rf-line-clamp-2",
                        children: (0, $eO5xw.capitalizeFirstLetter)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $d7223387b45ac98b$export$2e2bcd8739ae039 = $d7223387b45ac98b$var$MonoSelect;


class $4997b971855cf4c9$export$97d8aa00da3f172d extends $drUL7.Input {
    static{
        this.JsonTypeName = 'Retorik.ImageChoiceSet';
    }
    getJsonTypeName() {
        return $4997b971855cf4c9$export$97d8aa00da3f172d.JsonTypeName;
    }
    static{
        // Add custom preperties to schema
        this.isMultiSelectProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'isMultiSelect', false);
    }
    static{
        this.smallImagesProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'smallImages', false);
    }
    static{
        this.showCaptionsProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'showCaptions', false);
    }
    static{
        this.choicesWithUrlProperty = new $drUL7.SerializableObjectCollectionProperty($drUL7.Versions.v1_0, 'choicesWithUrl', (0, $39d8560fb4e8ec95$export$fce58f7f7dbd3025));
    }
    // multiSelect property accessors
    get isMultiSelect() {
        return !!this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.isMultiSelectProperty);
    }
    set isMultiSelect(value) {
        if (this.isMultiSelect !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.isMultiSelectProperty, value);
            this.updateLayout();
        }
    }
    // smallImages property accessors
    get smallImages() {
        return !!this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.smallImagesProperty);
    }
    set smallImages(value) {
        if (this.smallImages !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.smallImagesProperty, value);
            this.updateLayout();
        }
    }
    // showCaptions property accessors
    get showCaptions() {
        return !!this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.showCaptionsProperty);
    }
    set showCaptions(value) {
        if (this.smallImages !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.showCaptionsProperty, value);
            this.updateLayout();
        }
    }
    // choicesWithUrl property accessors
    get choicesWithUrl() {
        return this.getValue($4997b971855cf4c9$export$97d8aa00da3f172d.choicesWithUrlProperty) || [];
    }
    set choicesWithUrl(value) {
        if (this.choicesWithUrl !== value) {
            this.setValue($4997b971855cf4c9$export$97d8aa00da3f172d.choicesWithUrlProperty, value);
            this.updateLayout();
        }
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            if (!this.id) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
            if (this.isMultiSelect) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $92da696b1705d533$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choicesWithUrl,
                smallImages: this.smallImages,
                showCaptions: this.showCaptions
            });
            else return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d7223387b45ac98b$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choicesWithUrl,
                smallImages: this.smallImages,
                showCaptions: this.showCaptions
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.isMultiSelectProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "isMultiSelect", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.smallImagesProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "smallImages", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.showCaptionsProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "showCaptions", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($4997b971855cf4c9$export$97d8aa00da3f172d.choicesWithUrlProperty)
], $4997b971855cf4c9$export$97d8aa00da3f172d.prototype, "choicesWithUrl", null);




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $517WC = parcelRequire("517WC");
var $but28 = parcelRequire("but28");

var $2rYkD = parcelRequire("2rYkD");
const $3f3e72b3ff6623ef$var$Slider = ({ id: id, minValue: minValue, maxValue: maxValue, minLabel: minLabel, maxLabel: maxLabel })=>{
    const themeColors = (0, $517WC.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const values = (0, $but28.default)();
    const [sliderValue, setSliderValue] = (0, $bxRTa.useState)(values.get(id) || ((minValue || 0) + (maxValue || 100)) / 2);
    const [sliderStyle, setSliderStyle] = (0, $bxRTa.useState)(`linear-gradient(to right, ${themeColors.primary} ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%, #7878805C ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%)`);
    (0, $bxRTa.useEffect)(()=>{
        currentSubView !== (0, $2rYkD.CurrentSubView).history && (0, $9P0Ec.setCurrentId)(id);
    }, []);
    /**
   * On slider value change :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set sliderValue state
   *  - call parent function with event value
   * @param e : changeEvent
   */ const handleChange = (e)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            setSliderValue(e.target.value);
            (0, $9P0Ec.setValue)(id, e.target.value);
        }
    };
    /**
   * On value input in slider :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - get value as percentage
   *  - set the slider color depending on the percentage obtained
   * @param e : inputEvent
   */ const handleOnInput = (e)=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) {
            // Value as percentage, we substract minValue up and down to get the right percentage if minValue !== 0
            const valPourcentage = (e.target.value - (minValue || 0)) / (e.target.max - (minValue || 0)) * 100;
            setSliderStyle(`linear-gradient(to right, ${themeColors.primary} ${valPourcentage}%, #7878805C ${valPourcentage}%)`);
        }
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        dir: "ltr" /* To maintain the correct sliding direction */ ,
        className: `rf-w-full rf-px-6 rf-pt-14 ${minLabel || maxLabel ? 'rf-pb-5' : 'rf-pb-14'} rf-rounded-lg rf-text-size-auto rf-text-white`,
        style: {
            background: 'rgba(0, 0, 0, 0.5)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("input", {
                style: {
                    background: sliderStyle
                },
                onInput: handleOnInput,
                onChange: handleChange,
                value: sliderValue,
                type: "range",
                min: minValue || 0,
                max: maxValue || 100,
                className: "rf-slider-custom"
            }),
            (minLabel || maxLabel) && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-mt-5 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    minLabel && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: minLabel
                    }),
                    maxLabel && (minLabel ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        children: maxLabel
                    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: '\u2800'
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                children: maxLabel
                            })
                        ]
                    }))
                ]
            })
        ]
    });
};
var $3f3e72b3ff6623ef$export$2e2bcd8739ae039 = $3f3e72b3ff6623ef$var$Slider;



var $drUL7 = parcelRequire("drUL7");
class $e93900429d4fd801$export$7f21b8f94f2ce32b extends $drUL7.Input {
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static{
        this.JsonTypeName = 'Retorik.Slider';
    }
    getJsonTypeName() {
        return $e93900429d4fd801$export$7f21b8f94f2ce32b.JsonTypeName;
    }
    static{
        // Add custom properties to schema
        this.minValueProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'minValue');
    }
    static{
        this.maxValueProperty = new $drUL7.NumProperty($drUL7.Versions.v1_0, 'maxValue');
    }
    static{
        this.minLabelProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'minLabel', true);
    }
    static{
        this.maxLabelProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'maxLabel', true);
    }
    // minValue property accessors
    get minValue() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minValueProperty);
    }
    set minValue(value) {
        if (this.minValue !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minValueProperty, value);
            this.updateLayout();
        }
    }
    // maxValue property accessors
    get maxValue() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxValueProperty);
    }
    set maxValue(value) {
        if (this.maxValue !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxValueProperty, value);
            this.updateLayout();
        }
    }
    // minLabel property accessors
    get minLabel() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minLabelProperty);
    }
    set minLabel(value) {
        if (this.minLabel !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.minLabelProperty, value);
            this.updateLayout();
        }
    }
    // maxLabel property accessors
    get maxLabel() {
        return this.getValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxLabelProperty);
    }
    set maxLabel(value) {
        if (this.maxLabel !== value) {
            this.setValue($e93900429d4fd801$export$7f21b8f94f2ce32b.maxLabelProperty, value);
            this.updateLayout();
        }
    }
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this._value = this.minValue && this.maxValue ? Math.floor((this.minValue + this.maxValue) / 2) : 50, this.renderReact = ()=>{
            return this.id ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3f3e72b3ff6623ef$export$2e2bcd8739ae039), {
                id: this.id,
                minValue: this.minValue,
                maxValue: this.maxValue,
                minLabel: this.minLabel,
                maxLabel: this.maxLabel
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.minValueProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "minValue", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.maxValueProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "maxValue", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.minLabelProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "minLabel", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($e93900429d4fd801$export$7f21b8f94f2ce32b.maxLabelProperty)
], $e93900429d4fd801$export$7f21b8f94f2ce32b.prototype, "maxLabel", null);



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $6XfIC = parcelRequire("6XfIC");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
const $cd7931881ca77004$var$FactSet = ({ facts: facts })=>{
    return facts?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-w-full rf-text-cardFrameText rf-text-size-auto",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("table", {
            className: "rf-border-0 rf-border-none rf-border-collapse rf-overflow-hidden rf-box-border",
            children: facts.map((fact, key)=>{
                return /*#__PURE__*/ (0, $fl9nK.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("td", {
                            className: "rf-font-bold",
                            children: fact.name
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("td", {
                            className: "rf-px-2",
                            children: fact.value
                        })
                    ]
                }, key);
            })
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $cd7931881ca77004$export$2e2bcd8739ae039 = $cd7931881ca77004$var$FactSet;


class $0629d53df50be9f5$export$18920f1d621863a4 extends (0, $6XfIC.FactSet) {
    internalRender() {
        const element = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    constructor(...args){
        super(...args), this.renderReact = ()=>{
            const props = {
                facts: this.facts
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cd7931881ca77004$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7QU6k = parcelRequire("7QU6k");

var $drUL7 = parcelRequire("drUL7");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $f6Xnj = parcelRequire("f6Xnj");
var $4Zu5g = parcelRequire("4Zu5g");
var $6AR3O = parcelRequire("6AR3O");
var $ftSpM = parcelRequire("ftSpM");
var $h0xwd = parcelRequire("h0xwd");
var $5OuKI = parcelRequire("5OuKI");
var $680es = parcelRequire("680es");
var $517WC = parcelRequire("517WC");
var $gxeI6 = parcelRequire("gxeI6");
var $7xSOB = parcelRequire("7xSOB");

var $2rYkD = parcelRequire("2rYkD");

var $clTWB = parcelRequire("clTWB");

var $eO5xw = parcelRequire("eO5xw");
parcelRequire("hNqlv");
var $4QFhT = parcelRequire("4QFhT");
var $dH58k = parcelRequire("dH58k");
parcelRequire("kMAJU");
var $d5ZYc = parcelRequire("d5ZYc");

var $iEJNQ = parcelRequire("iEJNQ");

var $85RVQ = parcelRequire("85RVQ");

var $8e5cw = parcelRequire("8e5cw");

var $7fviB = parcelRequire("7fviB");
const $b79efe63fcf3e678$var$ActionButton = ({ text: text, fullWidth: fullWidth, position: position, display: display, adaptiveStyle: adaptiveStyle, urlToOpen: urlToOpen, data: data })=>{
    const locale = (0, $680es.default)();
    const isRTL = (0, $h0xwd.default)();
    const translation = (0, $gxeI6.default)();
    const currentSubView = (0, $f6Xnj.default)();
    const unlockClickedButton = (0, $7xSOB.default)();
    const isUsedOnBorne = (0, $5OuKI.default)();
    const enableDocumentPrinting = (0, $6AR3O.default)();
    const isMobile = (0, $ftSpM.default)();
    const themeColors = (0, $517WC.default)();
    const currentValue = (0, $4Zu5g.default)();
    const [style, setStyle] = (0, $bxRTa.useState)();
    const [clicked, setClicked] = (0, $bxRTa.useState)(false);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const [qrCodeData, setQrCodeData] = (0, $bxRTa.useState)();
    const [textToDisplay, setTextToDisplay] = (0, $bxRTa.useState)();
    const [triedToValidateWithoutValue, setTriedToValidateWithoutValue] = (0, $bxRTa.useState)(false);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.card.button.text.default
    };
    const defaultText = (0, $bxRTa.useMemo)(()=>{
        return text || (urlToOpen ? translation.link.goto : translation.common.submit);
    }, [
        text,
        locale
    ]);
    const setQrCodeDataAsync = async ()=>{
        if (urlToOpen) {
            const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($7QU6k))).toDataURL(encodeURI(urlToOpen));
            setQrCodeData(qrCodeString);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(defaultText, locale));
    }, [
        defaultText,
        translation,
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (triedToValidateWithoutValue && currentValue) {
            const values = Object.values(currentValue);
            if (!values.find((value)=>Array.isArray(value) && !value.length)) setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(defaultText, locale));
        }
    }, [
        triedToValidateWithoutValue,
        currentValue
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (urlToOpen && isUsedOnBorne) setQrCodeDataAsync();
    }, [
        urlToOpen,
        isUsedOnBorne
    ]);
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton && setClicked(false);
    }, [
        unlockClickedButton
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // Set width : full or fit
        let temp = fullWidth ? 'rf-w-full' : 'rf-w-fit';
        // Set position if not in full width
        if (!fullWidth && position) switch(position){
            case 'right':
                temp += ' rf-float-right';
                break;
            case 'center':
                temp += ' rf-mx-auto';
                break;
            case 'left':
            default:
                break;
        }
        setStyle(temp);
    }, []);
    const handleOpenPreview = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history) urlToOpen && (0, $9P0Ec.setModalFullscreenContent)(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $7fviB.default), {
            url: urlToOpen,
            printingAllowed: !!enableDocumentPrinting
        }));
    };
    const handleClick = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history && !clicked) {
            if (urlToOpen) window.open(urlToOpen, '_blank', 'noopener noreferrer');
            else {
                if (data) {
                    if (data.type) {
                        if (data.type.toLowerCase() === 'message') data.text && (0, $9P0Ec.sendMessage)(data.text);
                        else if (data.type.toLowerCase() === 'event') (0, $9P0Ec.sendEvent)(data.name, data.value);
                    } else {
                        if (typeof data === 'string') (0, $9P0Ec.sendMessage)(data);
                        else if (typeof data === 'object') (0, $9P0Ec.sendMessage)(undefined, data);
                    }
                } else if (currentValue) {
                    const values = Object.values(currentValue);
                    // Check if a value is an empty array. If so, break the process
                    if (values.find((value)=>Array.isArray(value) && !value.length)) {
                        setTriedToValidateWithoutValue(true);
                        setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(translation.inputs.noaction, locale));
                        return;
                    } else (0, $9P0Ec.sendMessage)(undefined, currentValue);
                } else {
                    setTriedToValidateWithoutValue(true);
                    setTextToDisplay((0, $eO5xw.capitalizeFirstLetter)(translation.inputs.noaction, locale));
                    return;
                }
                setClicked(true);
                setHover(false);
                (0, $9P0Ec.lockClickedButton)();
            }
        }
    };
    const handleEnter = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history && !clicked) setHover(true);
    };
    const handleLeave = ()=>{
        if (currentSubView !== (0, $2rYkD.CurrentSubView).history && !clicked) setHover(false);
    };
    return urlToOpen && isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center rf-text-cardButtonTextDefault",
        children: [
            urlToOpen.length > 4 && urlToOpen.substring(urlToOpen.length - 4) === '.pdf' && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-pb-6 rf-flex rf-justify-start rf-text-primary rf-underline rf-italic rf-text-sm",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                    className: "rf-cursor-pointer",
                    onClick: handleOpenPreview,
                    children: translation.link.buttontext
                })
            }),
            qrCodeData ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8e5cw.default), {
                        src: qrCodeData
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-mt-2 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d5ZYc.default), {
                                className: `rf-absolute rf-top-[0.125rem] ${isRTL ? 'rf-right-6' : '-rf-left-6'} rf-h-4`
                            }),
                            (0, $clTWB.getTextToDisplayOnLink)({
                                translation: translation,
                                isUsedOnBorne: isUsedOnBorne,
                                data: {
                                    url: urlToOpen,
                                    download: true
                                }
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-6 rf-h-6",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $85RVQ.default), {
                    color: "gray",
                    loaderColor: themeColors.primary,
                    backgroundColor: "transparent"
                })
            })
        ]
    }) : text && display.toLowerCase() === 'link' ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-mt-2 rf-flex rf-justify-start rf-items-center rf-text-cardButtonTextDefault ${currentSubView !== (0, $2rYkD.CurrentSubView).history && 'rf-cursor-pointer'}`,
        onPointerEnter: handleEnter,
        onPointerLeave: handleLeave,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-h-6 rf-w-6 rf-rounded ${hover ? 'rf-bg-cardButtonBackgroundHover' : 'rf-bg-cardButtonBackgroundDefault'}`,
                children: clicked && !urlToOpen ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-2 rf-h-2",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                            size: (0, $2rYkD.AnimationSize).small
                        })
                    })
                }) : isRTL ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4QFhT.default), {
                    className: `rf-h-6 rf-p-1 rf-border rf-rounded ${hover ? 'rf-border-cardButtonBorderHover' : 'rf-border-cardButtonBorderDefault'}`,
                    color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dH58k.default), {
                    className: `rf-h-6 rf-p-1 rf-border rf-rounded ${hover ? 'rf-border-cardButtonBorderHover' : 'rf-border-cardButtonBorderDefault'}`,
                    color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `${isRTL ? 'rf-mr-4' : 'rf-ml-4'}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(text, locale)
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `rf-relative ${currentSubView !== (0, $2rYkD.CurrentSubView).history ? clicked ? 'rf-card-button-clicked' : adaptiveStyle === (0, $drUL7.ActionStyle).Positive ? 'rf-card-button-positive' : adaptiveStyle === (0, $drUL7.ActionStyle).Destructive ? 'rf-card-button-destructive' : 'rf-card-button' : 'rf-card-button-history'} rf-mt-2 ${fullWidth ? 'rf-text-center' : 'rf-text-left'} ${style}`,
        onClick: handleClick,
        children: clicked && !urlToOpen ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: `rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center ${fullWidth ? '' : isRTL ? 'rf-pr-6 large:rf-pr-12' : 'rf-pl-6 large:rf-pl-12'}`,
            style: {
                ...animationColor
            },
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {
                    size: isMobile ? (0, $2rYkD.AnimationSize).medium : (0, $2rYkD.AnimationSize).large
                })
            })
        }) : textToDisplay
    });
};
var $b79efe63fcf3e678$export$2e2bcd8739ae039 = $b79efe63fcf3e678$var$ActionButton;


class $743025c3e54add91$export$ea4365d42c3e8532 extends $drUL7.SubmitAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($743025c3e54add91$export$ea4365d42c3e8532.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($743025c3e54add91$export$ea4365d42c3e8532.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($743025c3e54add91$export$ea4365d42c3e8532.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($743025c3e54add91$export$ea4365d42c3e8532.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($743025c3e54add91$export$ea4365d42c3e8532.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($743025c3e54add91$export$ea4365d42c3e8532.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display,
                data: this.data
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($743025c3e54add91$export$ea4365d42c3e8532.fullWidthProperty)
], $743025c3e54add91$export$ea4365d42c3e8532.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($743025c3e54add91$export$ea4365d42c3e8532.positionProperty)
], $743025c3e54add91$export$ea4365d42c3e8532.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($743025c3e54add91$export$ea4365d42c3e8532.displayProperty)
], $743025c3e54add91$export$ea4365d42c3e8532.prototype, "display", null);




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

class $cd782299940c1973$export$3226295bbd9dad06 extends $drUL7.OpenUrlAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($cd782299940c1973$export$3226295bbd9dad06.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($cd782299940c1973$export$3226295bbd9dad06.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($cd782299940c1973$export$3226295bbd9dad06.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($cd782299940c1973$export$3226295bbd9dad06.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($cd782299940c1973$export$3226295bbd9dad06.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($cd782299940c1973$export$3226295bbd9dad06.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display,
                urlToOpen: this.url
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($cd782299940c1973$export$3226295bbd9dad06.fullWidthProperty)
], $cd782299940c1973$export$3226295bbd9dad06.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($cd782299940c1973$export$3226295bbd9dad06.positionProperty)
], $cd782299940c1973$export$3226295bbd9dad06.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($cd782299940c1973$export$3226295bbd9dad06.displayProperty)
], $cd782299940c1973$export$3226295bbd9dad06.prototype, "display", null);




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

class $55672a0bfe73e837$export$17915a7271c45b27 extends $drUL7.ShowCardAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($55672a0bfe73e837$export$17915a7271c45b27.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($55672a0bfe73e837$export$17915a7271c45b27.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($55672a0bfe73e837$export$17915a7271c45b27.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($55672a0bfe73e837$export$17915a7271c45b27.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($55672a0bfe73e837$export$17915a7271c45b27.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($55672a0bfe73e837$export$17915a7271c45b27.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($55672a0bfe73e837$export$17915a7271c45b27.fullWidthProperty)
], $55672a0bfe73e837$export$17915a7271c45b27.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($55672a0bfe73e837$export$17915a7271c45b27.positionProperty)
], $55672a0bfe73e837$export$17915a7271c45b27.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($55672a0bfe73e837$export$17915a7271c45b27.displayProperty)
], $55672a0bfe73e837$export$17915a7271c45b27.prototype, "display", null);




var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $drUL7 = parcelRequire("drUL7");

class $ff9197427901ee79$export$e4bbccd75e2f23fc extends $drUL7.ToggleVisibilityAction {
    static{
        this.fullWidthProperty = new $drUL7.BoolProperty($drUL7.Versions.v1_0, 'fullWidth', false);
    }
    static{
        this.positionProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'position', true, undefined, 'left');
    }
    static{
        this.displayProperty = new $drUL7.StringProperty($drUL7.Versions.v1_0, 'display', true, undefined, 'button');
    }
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($ff9197427901ee79$export$e4bbccd75e2f23fc.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($ff9197427901ee79$export$e4bbccd75e2f23fc.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($ff9197427901ee79$export$e4bbccd75e2f23fc.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($ff9197427901ee79$export$e4bbccd75e2f23fc.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($ff9197427901ee79$export$e4bbccd75e2f23fc.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($ff9197427901ee79$export$e4bbccd75e2f23fc.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $76a68eb0f2535c39$export$f23ef6cb462a47f7)(this.renderReact());
    }
    constructor(...args){
        super(...args), this.internalRenderedElement = document.createElement('div'), this.renderReact = ()=>{
            const props = {
                text: this.title,
                adaptiveStyle: this.style,
                fullWidth: this.fullWidth,
                position: this.position,
                display: this.display
            };
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b79efe63fcf3e678$export$2e2bcd8739ae039), {
                ...props
            });
        };
    }
}
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($ff9197427901ee79$export$e4bbccd75e2f23fc.fullWidthProperty)
], $ff9197427901ee79$export$e4bbccd75e2f23fc.prototype, "fullWidth", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($ff9197427901ee79$export$e4bbccd75e2f23fc.positionProperty)
], $ff9197427901ee79$export$e4bbccd75e2f23fc.prototype, "position", null);
(0, $e1a09104fc6ecb2a$export$29e00dfd3077644b)([
    $drUL7.property($ff9197427901ee79$export$e4bbccd75e2f23fc.displayProperty)
], $ff9197427901ee79$export$e4bbccd75e2f23fc.prototype, "display", null);


const $9ef4e35797212449$export$6108075486421829 = ()=>{
    // Override existing elements
    $drUL7.GlobalRegistry.elements.register('TextBlock', (0, $1737244c1bf4b35d$export$92739f4310a31a0d));
    $drUL7.GlobalRegistry.elements.register('Input.Toggle', (0, $081e22222a7bb1e5$export$c99bfd6b0ed44fbd));
    $drUL7.GlobalRegistry.elements.register('Input.Date', (0, $8c9a3349b8312469$export$a9633577dcb92569));
    $drUL7.GlobalRegistry.elements.register('Input.Time', (0, $7186f765e3370ce8$export$27dc9c3aadf0815c));
    $drUL7.GlobalRegistry.elements.register('Input.ChoiceSet', (0, $6fd633cb7bc51693$export$3d2f970ec3b98a50));
    $drUL7.GlobalRegistry.elements.register('FactSet', (0, $0629d53df50be9f5$export$18920f1d621863a4));
    // Register new elements
    $drUL7.GlobalRegistry.elements.register('Retorik.ImageChoiceSet', (0, $4997b971855cf4c9$export$97d8aa00da3f172d));
    $drUL7.GlobalRegistry.elements.register('Retorik.Likert', (0, $38ef32f553c0c76d$export$527d02f4ea70b77));
    $drUL7.GlobalRegistry.elements.register('Retorik.Slider', (0, $e93900429d4fd801$export$7f21b8f94f2ce32b));
    // Override existing actions
    $drUL7.GlobalRegistry.actions.register('Action.Submit', (0, $743025c3e54add91$export$ea4365d42c3e8532));
    $drUL7.GlobalRegistry.actions.register('Action.OpenUrl', (0, $cd782299940c1973$export$3226295bbd9dad06));
    $drUL7.GlobalRegistry.actions.register('Action.ShowCard', (0, $55672a0bfe73e837$export$17915a7271c45b27));
    $drUL7.GlobalRegistry.actions.register('Action.ToggleVisibility', (0, $ff9197427901ee79$export$e4bbccd75e2f23fc));
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $ab68c110ac6d1f16$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $4ea6937c26364827$export$a4ad2735b021c132 = '1.9.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cdf3d274d518d8a9$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $cdf3d274d518d8a9$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($cdf3d274d518d8a9$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($cdf3d274d518d8a9$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $cdf3d274d518d8a9$export$7fc0d8c3ab188c4c = $cdf3d274d518d8a9$export$a5733a4d26a1ec61((0, $4ea6937c26364827$export$a4ad2735b021c132));


var $cb65aacd6001f05d$var$major = (0, $4ea6937c26364827$export$a4ad2735b021c132).split('.')[0];
var $cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $cb65aacd6001f05d$var$major);
var $cb65aacd6001f05d$var$_global = (0, $ab68c110ac6d1f16$export$5c524ddf7208c00c);
function $cb65aacd6001f05d$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $4ea6937c26364827$export$a4ad2735b021c132)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $4ea6937c26364827$export$a4ad2735b021c132)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $4ea6937c26364827$export$a4ad2735b021c132));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $4ea6937c26364827$export$a4ad2735b021c132) + ".");
    return true;
}
function $cb65aacd6001f05d$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $cdf3d274d518d8a9$export$7fc0d8c3ab188c4c)(globalVersion)) return;
    return (_b = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $cb65aacd6001f05d$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $4ea6937c26364827$export$a4ad2735b021c132) + ".");
    var api = $cb65aacd6001f05d$var$_global[$cb65aacd6001f05d$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}


var $15342f087d708314$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $15342f087d708314$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $15342f087d708314$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $15342f087d708314$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $15342f087d708314$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $15342f087d708314$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $15342f087d708314$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $15342f087d708314$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $15342f087d708314$var$logProxy(funcName, namespace, args) {
    var logger = (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $15342f087d708314$var$__spreadArray([], $15342f087d708314$var$__read(args), false));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $3a4c386570d64094$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($3a4c386570d64094$export$b7d7b4c0f3c95263 || ($3a4c386570d64094$export$b7d7b4c0f3c95263 = {}));


function $991a5e37aa3ab931$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).NONE) maxLevel = (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).NONE;
    else if (maxLevel > (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).ALL) maxLevel = (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).ERROR),
        warn: _filterFunc('warn', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).WARN),
        info: _filterFunc('info', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).INFO),
        debug: _filterFunc('debug', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).DEBUG),
        verbose: _filterFunc('verbose', (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).VERBOSE)
    };
}




var $91fa7e10f60a5297$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $91fa7e10f60a5297$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $91fa7e10f60a5297$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $91fa7e10f60a5297$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $91fa7e10f60a5297$var$__spreadArray([], $91fa7e10f60a5297$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)('diag');
            var newLogger = (0, $991a5e37aa3ab931$export$9a9cc475abb19689)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $3a4c386570d64094$export$b7d7b4c0f3c95263).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $cb65aacd6001f05d$export$d586ae880b433238)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($91fa7e10f60a5297$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $15342f087d708314$export$b4bccc12f5b13129)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4de9a0bcf3d630bc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $4de9a0bcf3d630bc$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $4de9a0bcf3d630bc$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $4de9a0bcf3d630bc$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $4de9a0bcf3d630bc$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $4b9ec98449e85b40$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');


var $6435a4ae4b78a9aa$var$diag = (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance();
function $6435a4ae4b78a9aa$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $4de9a0bcf3d630bc$export$b8c511fa1a5f4987)(new Map(Object.entries(entries)));
}
function $6435a4ae4b78a9aa$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $6435a4ae4b78a9aa$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $4b9ec98449e85b40$export$92dd2fe8ddb5cb7),
        toString: function() {
            return str;
        }
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $a50b1446b3c4bd0a$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $a50b1446b3c4bd0a$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc = new $a50b1446b3c4bd0a$var$BaseContext();









/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $4be02e1161967f43$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($4be02e1161967f43$export$94df7a7a96a92f7b || ($4be02e1161967f43$export$94df7a7a96a92f7b = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d03364baa5302116$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($d03364baa5302116$export$4da4ea8145910e8b || ($d03364baa5302116$export$4da4ea8145910e8b = {}));


/**
 * An enumeration of status codes.
 */ var $873e79d0391b734f$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($873e79d0391b734f$export$1e28dd9b5d01db83 || ($873e79d0391b734f$export$1e28dd9b5d01db83 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $974e5505212bea35$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($974e5505212bea35$export$bf9049ad2b0883ff || ($974e5505212bea35$export$bf9049ad2b0883ff = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9c9f5532a1cced84$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $9c9f5532a1cced84$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $9c9f5532a1cced84$export$8591e4c852b66703 = {
    traceId: $9c9f5532a1cced84$export$22be96e88d95e128,
    spanId: $9c9f5532a1cced84$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $974e5505212bea35$export$bf9049ad2b0883ff).NONE
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $c6fe789a2f964f1e$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $9c9f5532a1cced84$export$8591e4c852b66703);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();


var $a89fc3550e8ac673$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $a89fc3550e8ac673$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $a89fc3550e8ac673$export$29dd34cf1269f6da(traceId) {
    return $a89fc3550e8ac673$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $9c9f5532a1cced84$export$22be96e88d95e128);
}
function $a89fc3550e8ac673$export$8e51c6d8f0586aff(spanId) {
    return $a89fc3550e8ac673$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $9c9f5532a1cced84$export$55cc39fb0d4bb4c0);
}
function $a89fc3550e8ac673$export$e4373b9a2c09216c(spanContext) {
    return $a89fc3550e8ac673$export$29dd34cf1269f6da(spanContext.traceId) && $a89fc3550e8ac673$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $a89fc3550e8ac673$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)(spanContext);
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $214efc9333dd7c65$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $214efc9333dd7c65$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $214efc9333dd7c65$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $214efc9333dd7c65$var$__spreadArray([
            thisArg
        ], $214efc9333dd7c65$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();




var $f78ae9f272172c4f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f78ae9f272172c4f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f78ae9f272172c4f$var$API_NAME = 'context';
var $f78ae9f272172c4f$var$NOOP_CONTEXT_MANAGER = new (0, $214efc9333dd7c65$export$a27e5df35d1539a6)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $f78ae9f272172c4f$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $cb65aacd6001f05d$export$d586ae880b433238)($f78ae9f272172c4f$var$API_NAME, contextManager, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $f78ae9f272172c4f$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $f78ae9f272172c4f$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($f78ae9f272172c4f$var$API_NAME) || $f78ae9f272172c4f$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($f78ae9f272172c4f$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    };
    return ContextAPI;
}();


var $e8248f70bfae46d0$export$a078c61943f9dbbe = (0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $83ffbea8f4ffb90a$export$c042e7c2f59bc046 = (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59cde47689e48f33$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $59cde47689e48f33$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $59cde47689e48f33$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $59cde47689e48f33$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $59cde47689e48f33$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $59cde47689e48f33$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $59cde47689e48f33$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $59cde47689e48f33$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $59cde47689e48f33$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $59cde47689e48f33$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $59cde47689e48f33$export$b556ba0f560c45b = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($59cde47689e48f33$export$834a616d1cf278b);
var $59cde47689e48f33$export$df09a35db160df98 = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($59cde47689e48f33$export$834a616d1cf278b);
var $59cde47689e48f33$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($59cde47689e48f33$export$834a616d1cf278b);
var $59cde47689e48f33$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($59cde47689e48f33$export$834a616d1cf278b);
var $59cde47689e48f33$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $59cde47689e48f33$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($59cde47689e48f33$export$a5a3e7829c289482);
var $59cde47689e48f33$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($59cde47689e48f33$export$a5a3e7829c289482);
var $59cde47689e48f33$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $59cde47689e48f33$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($59cde47689e48f33$export$a5a3e7829c289482);
var $59cde47689e48f33$export$65e277d35235a01f = new $59cde47689e48f33$export$c23c6f85dd4fc1e9();
var $59cde47689e48f33$export$e6d19fe5233efc54 = new $59cde47689e48f33$export$b556ba0f560c45b();
var $59cde47689e48f33$export$dd01300aacbcec1c = new $59cde47689e48f33$export$b7f4a3c7ea16c24();
var $59cde47689e48f33$export$689c32a6a552e1a6 = new $59cde47689e48f33$export$ef064c3e0426c607();
var $59cde47689e48f33$export$2f189cd99d2b7429 = new $59cde47689e48f33$export$df09a35db160df98();
var $59cde47689e48f33$export$163422b94c3edbcb = new $59cde47689e48f33$export$7a7e4b169d5c93a8();
var $59cde47689e48f33$export$ea67e3c6ff624776 = new $59cde47689e48f33$export$6990a2f90809ffc1();
var $59cde47689e48f33$export$5b8be9ab17b673b3 = new $59cde47689e48f33$export$3ec3555bc6f693a4();
function $59cde47689e48f33$export$bc3a498ccbb5c2b5() {
    return $59cde47689e48f33$export$65e277d35235a01f;
}


/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $9a9fe8e6a3e425da$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $59cde47689e48f33$export$65e277d35235a01f;
    };
    return NoopMeterProvider;
}();
var $9a9fe8e6a3e425da$export$d21fe83355c56e18 = new $9a9fe8e6a3e425da$export$51c513ea08316108();




var $a1d106e73864165d$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $a1d106e73864165d$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $cb65aacd6001f05d$export$d586ae880b433238)($a1d106e73864165d$var$API_NAME, provider, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($a1d106e73864165d$var$API_NAME) || (0, $9a9fe8e6a3e425da$export$d21fe83355c56e18);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($a1d106e73864165d$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    };
    return MetricsAPI;
}();


var $33f59e57c604672a$export$b0c5c2fac8144e54 = (0, $a1d106e73864165d$export$1339f6eb6111c638).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $892f4a4d90464324$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d10b952398cf50ca$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $d10b952398cf50ca$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/**
 * Baggage key
 */ var $a9b1d6be0fbb4573$var$BAGGAGE_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry Baggage Key');
function $a9b1d6be0fbb4573$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($a9b1d6be0fbb4573$var$BAGGAGE_KEY) || undefined;
}
function $a9b1d6be0fbb4573$export$120a1756099436ee() {
    return $a9b1d6be0fbb4573$export$f3bffa0b5dd10d1e((0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance().active());
}
function $a9b1d6be0fbb4573$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($a9b1d6be0fbb4573$var$BAGGAGE_KEY, baggage);
}
function $a9b1d6be0fbb4573$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($a9b1d6be0fbb4573$var$BAGGAGE_KEY);
}




var $b514db26be7b5f30$var$API_NAME = 'propagation';
var $b514db26be7b5f30$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $892f4a4d90464324$export$8356c7eb3af7963b)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $b514db26be7b5f30$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $6435a4ae4b78a9aa$export$1034a425c7384452);
        this.getBaggage = (0, $a9b1d6be0fbb4573$export$f3bffa0b5dd10d1e);
        this.getActiveBaggage = (0, $a9b1d6be0fbb4573$export$120a1756099436ee);
        this.setBaggage = (0, $a9b1d6be0fbb4573$export$adc9ca19eab3f500);
        this.deleteBaggage = (0, $a9b1d6be0fbb4573$export$4ca3a8a743c9f633);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $cb65aacd6001f05d$export$d586ae880b433238)($b514db26be7b5f30$var$API_NAME, propagator, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $d10b952398cf50ca$export$f70f1d111fccf1c1);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $d10b952398cf50ca$export$a0f575f55f38720a);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($b514db26be7b5f30$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($b514db26be7b5f30$var$API_NAME) || $b514db26be7b5f30$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();


var $c76b4b4057b01033$export$3e49040daa9dba20 = (0, $b514db26be7b5f30$export$471eda0a6213cac9).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/**
 * span key
 */ var $131eed9e3bc823e4$var$SPAN_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry Context Key SPAN');
function $131eed9e3bc823e4$export$246e04ba06066af1(context) {
    return context.getValue($131eed9e3bc823e4$var$SPAN_KEY) || undefined;
}
function $131eed9e3bc823e4$export$1be426a8e585c83e() {
    return $131eed9e3bc823e4$export$246e04ba06066af1((0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance().active());
}
function $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($131eed9e3bc823e4$var$SPAN_KEY, span);
}
function $131eed9e3bc823e4$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($131eed9e3bc823e4$var$SPAN_KEY);
}
function $131eed9e3bc823e4$export$c90bf5428c14cdb1(context, spanContext) {
    return $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8(context, new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)(spanContext));
}
function $131eed9e3bc823e4$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $131eed9e3bc823e4$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}




var $8382ff7c95656cd7$var$contextApi = (0, $f78ae9f272172c4f$export$4148866f0a453927).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $8382ff7c95656cd7$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $8382ff7c95656cd7$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)();
        var parentFromContext = context && (0, $131eed9e3bc823e4$export$1a635f8f0b912781)(context);
        if ($8382ff7c95656cd7$var$isSpanContext(parentFromContext) && (0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(parentFromContext)) return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)(parentFromContext);
        else return new (0, $c6fe789a2f964f1e$export$972d28f7c6a8c6c7)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $8382ff7c95656cd7$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8)(parentContext, span);
        return $8382ff7c95656cd7$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $8382ff7c95656cd7$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}


var $570c3749fe6786e1$var$NOOP_TRACER = new (0, $8382ff7c95656cd7$export$714c1036cabcd223)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $570c3749fe6786e1$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $570c3749fe6786e1$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $15a573b8ffe13d1f$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $8382ff7c95656cd7$export$714c1036cabcd223)();
    };
    return NoopTracerProvider;
}();


var $281ea616e9eb9c84$var$NOOP_TRACER_PROVIDER = new (0, $15a573b8ffe13d1f$export$87d8e93756f9e86e)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $281ea616e9eb9c84$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $570c3749fe6786e1$export$df2c38268c6bb6b3)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $281ea616e9eb9c84$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();





var $ab4d31e36b2e74b9$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $ab4d31e36b2e74b9$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $281ea616e9eb9c84$export$4137aabcb4254962)();
        this.wrapSpanContext = (0, $a89fc3550e8ac673$export$c19cc0f1911bdb85);
        this.isSpanContextValid = (0, $a89fc3550e8ac673$export$e4373b9a2c09216c);
        this.deleteSpan = (0, $131eed9e3bc823e4$export$a6bbfe9a17f7941c);
        this.getSpan = (0, $131eed9e3bc823e4$export$246e04ba06066af1);
        this.getActiveSpan = (0, $131eed9e3bc823e4$export$1be426a8e585c83e);
        this.getSpanContext = (0, $131eed9e3bc823e4$export$1a635f8f0b912781);
        this.setSpan = (0, $131eed9e3bc823e4$export$8ab2f2e6ee8ed0a8);
        this.setSpanContext = (0, $131eed9e3bc823e4$export$c90bf5428c14cdb1);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $cb65aacd6001f05d$export$d586ae880b433238)($ab4d31e36b2e74b9$var$API_NAME, this._proxyTracerProvider, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $cb65aacd6001f05d$export$a4e55266d2135a7f)($ab4d31e36b2e74b9$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $cb65aacd6001f05d$export$d42ac835f38d1fb2)($ab4d31e36b2e74b9$var$API_NAME, (0, $91fa7e10f60a5297$export$5c8937ffc688cfd3).instance());
        this._proxyTracerProvider = new (0, $281ea616e9eb9c84$export$4137aabcb4254962)();
    };
    return TraceAPI;
}();


var $a1569335aa614ed8$export$357889f174732d38 = (0, $ab4d31e36b2e74b9$export$2cccde6fcc7b568a).getInstance();


var // Default export.
$00524e035e1e9c07$export$2e2bcd8739ae039 = {
    context: (0, $e8248f70bfae46d0$export$a078c61943f9dbbe),
    diag: (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046),
    metrics: (0, $33f59e57c604672a$export$b0c5c2fac8144e54),
    propagation: (0, $c76b4b4057b01033$export$3e49040daa9dba20),
    trace: (0, $a1569335aa614ed8$export$357889f174732d38)
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d760faa28735d56a$export$a756c21bf453f1b5 {
    _delegate;
    constructor(_delegate){
        this._delegate = _delegate;
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ export(items, resultCallback) {
        this._delegate.export(items, resultCallback);
    }
    forceFlush() {
        return this._delegate.forceFlush();
    }
    shutdown() {
        return this._delegate.shutdown();
    }
}


function $f997fc8cbaa9a43a$export$edd172c6c83c39cc(resource) {
    return {
        attributes: $f997fc8cbaa9a43a$export$b6255b619acd6709(resource.attributes),
        droppedAttributesCount: 0
    };
}
function $f997fc8cbaa9a43a$export$5a2377b8e90dd1bf(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function $f997fc8cbaa9a43a$export$b6255b619acd6709(attributes) {
    return Object.keys(attributes).map((key)=>$f997fc8cbaa9a43a$export$155f69accf533147(key, attributes[key]));
}
function $f997fc8cbaa9a43a$export$155f69accf533147(key, value) {
    return {
        key: key,
        value: $f997fc8cbaa9a43a$export$9544ab3c60b2d8ce(value)
    };
}
function $f997fc8cbaa9a43a$export$9544ab3c60b2d8ce(value) {
    const t = typeof value;
    if (t === 'string') return {
        stringValue: value
    };
    if (t === 'number') {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === 'boolean') return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($f997fc8cbaa9a43a$export$9544ab3c60b2d8ce)
        }
    };
    if (t === 'object' && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(([k, v])=>$f997fc8cbaa9a43a$export$155f69accf533147(k, v))
        }
    };
    return {};
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $02b2267f7388e0c4$export$b22daef4119238cd = performance;


const $bd29e81cd70a2732$var$NANOSECOND_DIGITS = 9;
const $bd29e81cd70a2732$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $bd29e81cd70a2732$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $bd29e81cd70a2732$var$NANOSECOND_DIGITS_IN_MILLIS);
const $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS = Math.pow(10, $bd29e81cd70a2732$var$NANOSECOND_DIGITS);
function $bd29e81cd70a2732$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $bd29e81cd70a2732$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $bd29e81cd70a2732$export$e752b05e58096a2f() {
    let timeOrigin = (0, $02b2267f7388e0c4$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== 'number') {
        const perf = (0, $02b2267f7388e0c4$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $bd29e81cd70a2732$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $bd29e81cd70a2732$export$e7ec5c82995537b1($bd29e81cd70a2732$export$e752b05e58096a2f());
    const now = $bd29e81cd70a2732$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $02b2267f7388e0c4$export$b22daef4119238cd).now());
    return $bd29e81cd70a2732$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $bd29e81cd70a2732$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($bd29e81cd70a2732$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $bd29e81cd70a2732$export$e752b05e58096a2f()) return $bd29e81cd70a2732$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $bd29e81cd70a2732$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $bd29e81cd70a2732$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $bd29e81cd70a2732$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $bd29e81cd70a2732$export$973c1c4fad6103e(time) {
    const precision = $bd29e81cd70a2732$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $bd29e81cd70a2732$export$2d91441ae30ebcfc(time) {
    return time[0] * $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS + time[1];
}
function $bd29e81cd70a2732$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $bd29e81cd70a2732$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $bd29e81cd70a2732$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $bd29e81cd70a2732$export$a5e58227c317ebb9(value) {
    return $bd29e81cd70a2732$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $bd29e81cd70a2732$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $bd29e81cd70a2732$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $583ea382cfa01d2c$var$intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    // a-f
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    // A-F
    return charCode - 55;
}
function $583ea382cfa01d2c$export$f7e0d8803cecbdc0(hexStr) {
    const buf = new Uint8Array(hexStr.length / 2);
    let offset = 0;
    for(let i = 0; i < hexStr.length; i += 2){
        const hi = $583ea382cfa01d2c$var$intValue(hexStr.charCodeAt(i));
        const lo = $583ea382cfa01d2c$var$intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}


function $1e4cc20e2041671a$export$93fd2c60d7ab39e5(hrTime) {
    const NANOSECONDS = BigInt(1000000000);
    return BigInt(hrTime[0]) * NANOSECONDS + BigInt(hrTime[1]);
}
function $1e4cc20e2041671a$export$25fa08d6f84e69de(value) {
    const low = Number(BigInt.asUintN(32, value));
    const high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function $1e4cc20e2041671a$export$9aa1c44d160043e3(hrTime) {
    const nanos = $1e4cc20e2041671a$export$93fd2c60d7ab39e5(hrTime);
    return $1e4cc20e2041671a$export$25fa08d6f84e69de(nanos);
}
function $1e4cc20e2041671a$export$91e61e5f118af2ed(hrTime) {
    const nanos = $1e4cc20e2041671a$export$93fd2c60d7ab39e5(hrTime);
    return nanos.toString();
}
const $1e4cc20e2041671a$var$encodeTimestamp = typeof BigInt !== 'undefined' ? $1e4cc20e2041671a$export$91e61e5f118af2ed : (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc);
function $1e4cc20e2041671a$var$identity(value) {
    return value;
}
function $1e4cc20e2041671a$var$optionalHexToBinary(str) {
    if (str === undefined) return undefined;
    return (0, $583ea382cfa01d2c$export$f7e0d8803cecbdc0)(str);
}
const $1e4cc20e2041671a$var$DEFAULT_ENCODER = {
    encodeHrTime: $1e4cc20e2041671a$export$9aa1c44d160043e3,
    encodeSpanContext: (0, $583ea382cfa01d2c$export$f7e0d8803cecbdc0),
    encodeOptionalSpanContext: $1e4cc20e2041671a$var$optionalHexToBinary
};
function $1e4cc20e2041671a$export$2d50162b78680823(options) {
    if (options === undefined) return $1e4cc20e2041671a$var$DEFAULT_ENCODER;
    const useLongBits = options.useLongBits ?? true;
    const useHex = options.useHex ?? false;
    return {
        encodeHrTime: useLongBits ? $1e4cc20e2041671a$export$9aa1c44d160043e3 : $1e4cc20e2041671a$var$encodeTimestamp,
        encodeSpanContext: useHex ? $1e4cc20e2041671a$var$identity : (0, $583ea382cfa01d2c$export$f7e0d8803cecbdc0),
        encodeOptionalSpanContext: useHex ? $1e4cc20e2041671a$var$identity : $1e4cc20e2041671a$var$optionalHexToBinary
    };
}


function $ef1583dc7b078b5f$export$8c81c8011901e012(span, encoder) {
    const ctx = span.spanContext();
    const status = span.status;
    const parentSpanId = span.parentSpanContext?.spanId ? encoder.encodeSpanContext(span.parentSpanContext?.spanId) : undefined;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: parentSpanId,
        traceState: ctx.traceState?.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: (0, $f997fc8cbaa9a43a$export$b6255b619acd6709)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map((event)=>$ef1583dc7b078b5f$export$c0221297e49388cc(event, encoder)),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map((link)=>$ef1583dc7b078b5f$export$d40a678c50e6f4f2(link, encoder)),
        droppedLinksCount: span.droppedLinksCount
    };
}
function $ef1583dc7b078b5f$export$d40a678c50e6f4f2(link, encoder) {
    return {
        attributes: link.attributes ? (0, $f997fc8cbaa9a43a$export$b6255b619acd6709)(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: link.context.traceState?.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0
    };
}
function $ef1583dc7b078b5f$export$c0221297e49388cc(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? (0, $f997fc8cbaa9a43a$export$b6255b619acd6709)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}
function $ef1583dc7b078b5f$export$4bd5e67fadfa9fe0(spans, options) {
    const encoder = (0, $1e4cc20e2041671a$export$2d50162b78680823)(options);
    return {
        resourceSpans: $ef1583dc7b078b5f$var$spanRecordsToResourceSpans(spans, encoder)
    };
}
function $ef1583dc7b078b5f$var$createResourceMap(readableSpans) {
    const resourceMap = new Map();
    for (const record of readableSpans){
        let ilsMap = resourceMap.get(record.resource);
        if (!ilsMap) {
            ilsMap = new Map();
            resourceMap.set(record.resource, ilsMap);
        }
        // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
        const instrumentationScopeKey = `${record.instrumentationScope.name}@${record.instrumentationScope.version || ''}:${record.instrumentationScope.schemaUrl || ''}`;
        let records = ilsMap.get(instrumentationScopeKey);
        if (!records) {
            records = [];
            ilsMap.set(instrumentationScopeKey, records);
        }
        records.push(record);
    }
    return resourceMap;
}
function $ef1583dc7b078b5f$var$spanRecordsToResourceSpans(readableSpans, encoder) {
    const resourceMap = $ef1583dc7b078b5f$var$createResourceMap(readableSpans);
    const out = [];
    const entryIterator = resourceMap.entries();
    let entry = entryIterator.next();
    while(!entry.done){
        const [resource, ilmMap] = entry.value;
        const scopeResourceSpans = [];
        const ilmIterator = ilmMap.values();
        let ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            const scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                const spans = scopeSpans.map((readableSpan)=>$ef1583dc7b078b5f$export$8c81c8011901e012(readableSpan, encoder));
                scopeResourceSpans.push({
                    scope: (0, $f997fc8cbaa9a43a$export$5a2377b8e90dd1bf)(scopeSpans[0].instrumentationScope),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationScope.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        // TODO SDK types don't provide resource schema URL at this time
        const transformedSpans = {
            resource: (0, $f997fc8cbaa9a43a$export$edd172c6c83c39cc)(resource),
            scopeSpans: scopeResourceSpans,
            schemaUrl: undefined
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}


const $09e9215285e32b8e$export$dfba2b8376f2d3f5 = {
    serializeRequest: (arg)=>{
        const request = (0, $ef1583dc7b078b5f$export$4bd5e67fadfa9fe0)(arg, {
            useHex: true,
            useLongBits: false
        });
        const encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: (arg)=>{
        const decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ac78d7cba247b951$var$MAX_ATTEMPTS = 5;
const $ac78d7cba247b951$var$INITIAL_BACKOFF = 1000;
const $ac78d7cba247b951$var$MAX_BACKOFF = 5000;
const $ac78d7cba247b951$var$BACKOFF_MULTIPLIER = 1.5;
const $ac78d7cba247b951$var$JITTER = 0.2;
/**
 * Get a pseudo-random jitter that falls in the range of [-JITTER, +JITTER]
 */ function $ac78d7cba247b951$var$getJitter() {
    return Math.random() * (2 * $ac78d7cba247b951$var$JITTER) - $ac78d7cba247b951$var$JITTER;
}
class $ac78d7cba247b951$var$RetryingTransport {
    _transport;
    constructor(_transport){
        this._transport = _transport;
    }
    retry(data, timeoutMillis, inMillis) {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    }
    async send(data, timeoutMillis) {
        const deadline = Date.now() + timeoutMillis;
        let result = await this._transport.send(data, timeoutMillis);
        let attempts = $ac78d7cba247b951$var$MAX_ATTEMPTS;
        let nextBackoff = $ac78d7cba247b951$var$INITIAL_BACKOFF;
        while(result.status === 'retryable' && attempts > 0){
            attempts--;
            // use maximum of computed backoff and 0 to avoid negative timeouts
            const backoff = Math.max(Math.min(nextBackoff, $ac78d7cba247b951$var$MAX_BACKOFF) + $ac78d7cba247b951$var$getJitter(), 0);
            nextBackoff = nextBackoff * $ac78d7cba247b951$var$BACKOFF_MULTIPLIER;
            const retryInMillis = result.retryInMillis ?? backoff;
            // return when expected retry time is after the export deadline.
            const remainingTimeoutMillis = deadline - Date.now();
            if (retryInMillis > remainingTimeoutMillis) return result;
            result = await this.retry(data, remainingTimeoutMillis, retryInMillis);
        }
        return result;
    }
    shutdown() {
        return this._transport.shutdown();
    }
}
function $ac78d7cba247b951$export$2a8528aedd03b24e(options) {
    return new $ac78d7cba247b951$var$RetryingTransport(options.transport);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $16602b3eace45b8b$export$bc409a649b31360b(statusCode) {
    const retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function $16602b3eace45b8b$export$4e009558974ad065(retryAfter) {
    if (retryAfter == null) return undefined;
    const seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    const delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}


class $cb09ba48eefe1474$var$XhrTransport {
    _parameters;
    constructor(_parameters){
        this._parameters = _parameters;
    }
    send(data, timeoutMillis) {
        return new Promise((resolve)=>{
            const xhr = new XMLHttpRequest();
            xhr.timeout = timeoutMillis;
            xhr.open('POST', this._parameters.url);
            const headers = this._parameters.headers();
            Object.entries(headers).forEach(([k, v])=>{
                xhr.setRequestHeader(k, v);
            });
            xhr.ontimeout = (_)=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request timed out')
                });
            };
            xhr.onreadystatechange = ()=>{
                if (xhr.status >= 200 && xhr.status <= 299) {
                    (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('XHR success');
                    resolve({
                        status: 'success'
                    });
                } else if (xhr.status && (0, $16602b3eace45b8b$export$bc409a649b31360b)(xhr.status)) resolve({
                    status: 'retryable',
                    retryInMillis: (0, $16602b3eace45b8b$export$4e009558974ad065)(xhr.getResponseHeader('Retry-After'))
                });
                else if (xhr.status !== 0) resolve({
                    status: 'failure',
                    error: new Error('XHR request failed with non-retryable status')
                });
            };
            xhr.onabort = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request aborted')
                });
            };
            xhr.onerror = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request errored')
                });
            };
            xhr.send(data);
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $cb09ba48eefe1474$export$8ab960d599ca0ecc(parameters) {
    return new $cb09ba48eefe1474$var$XhrTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $e365c701f3b23db0$var$SendBeaconTransport {
    _params;
    constructor(_params){
        this._params = _params;
    }
    send(data) {
        return new Promise((resolve)=>{
            if (navigator.sendBeacon(this._params.url, new Blob([
                data
            ], {
                type: this._params.blobType
            }))) {
                // no way to signal retry, treat everything as success
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('SendBeacon success');
                resolve({
                    status: 'success'
                });
            } else resolve({
                status: 'failure',
                error: new Error('SendBeacon failed')
            });
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $e365c701f3b23db0$export$ef075750bfec2f31(parameters) {
    return new $e365c701f3b23db0$var$SendBeaconTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $7975234183610ba3$var$BoundedQueueExportPromiseHandler {
    _concurrencyLimit;
    _sendingPromises = [];
    /**
     * @param concurrencyLimit maximum promises allowed in a queue at the same time.
     */ constructor(concurrencyLimit){
        this._concurrencyLimit = concurrencyLimit;
    }
    pushPromise(promise) {
        if (this.hasReachedLimit()) throw new Error('Concurrency Limit reached');
        this._sendingPromises.push(promise);
        const popPromise = ()=>{
            const index = this._sendingPromises.indexOf(promise);
            this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    }
    hasReachedLimit() {
        return this._sendingPromises.length >= this._concurrencyLimit;
    }
    async awaitAll() {
        await Promise.all(this._sendingPromises);
    }
}
function $7975234183610ba3$export$1de3d1a6b8cb6545(options) {
    return new $7975234183610ba3$var$BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($34c176c5ab8c4038$export$ee0fe4df4ef0f3a1 || ($34c176c5ab8c4038$export$ee0fe4df4ef0f3a1 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for handling error
 */ class $781829fe643e04c6$export$26c718c16cda30c6 extends Error {
    code;
    name = 'OTLPExporterError';
    data;
    constructor(message, code, data){
        super(message);
        this.data = data;
        this.code = code;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $3e4caea9b02a862b$var$isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, 'partialSuccess');
}
function $3e4caea9b02a862b$export$b6a88465884baecf() {
    return {
        handleResponse (response) {
            // Partial success MUST never be an empty object according the specification
            // see https://opentelemetry.io/docs/specs/otlp/#partial-success
            if (response == null || !$3e4caea9b02a862b$var$isPartialSuccessResponse(response) || response.partialSuccess == null || Object.keys(response.partialSuccess).length === 0) return;
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Received Partial Success response:', JSON.stringify(response.partialSuccess));
        }
    };
}



class $18e73005dd8bbe6d$var$OTLPExportDelegate {
    _transport;
    _serializer;
    _responseHandler;
    _promiseQueue;
    _timeout;
    _diagLogger;
    constructor(_transport, _serializer, _responseHandler, _promiseQueue, _timeout){
        this._transport = _transport;
        this._serializer = _serializer;
        this._responseHandler = _responseHandler;
        this._promiseQueue = _promiseQueue;
        this._timeout = _timeout;
        this._diagLogger = (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).createComponentLogger({
            namespace: 'OTLPExportDelegate'
        });
    }
    export(internalRepresentation, resultCallback) {
        this._diagLogger.debug('items to be sent', internalRepresentation);
        // don't do any work if too many exports are in progress.
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Concurrent export limit reached')
            });
            return;
        }
        const serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Nothing to send')
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then((response)=>{
            if (response.status === 'success') {
                if (response.data != null) try {
                    this._responseHandler.handleResponse(this._serializer.deserializeResponse(response.data));
                } catch (e) {
                    this._diagLogger.warn('Export succeeded but could not deserialize response - is the response specification compliant?', e, response.data);
                }
                // No matter the response, we can consider the export still successful.
                resultCallback({
                    code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).SUCCESS
                });
                return;
            } else if (response.status === 'failure' && response.error) {
                resultCallback({
                    code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                    error: response.error
                });
                return;
            } else if (response.status === 'retryable') resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $781829fe643e04c6$export$26c718c16cda30c6)('Export failed with retryable status')
            });
            else resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $781829fe643e04c6$export$26c718c16cda30c6)('Export failed with unknown error')
            });
        }, (reason)=>resultCallback({
                code: (0, $34c176c5ab8c4038$export$ee0fe4df4ef0f3a1).FAILED,
                error: reason
            })));
    }
    forceFlush() {
        return this._promiseQueue.awaitAll();
    }
    async shutdown() {
        this._diagLogger.debug('shutdown started');
        await this.forceFlush();
        this._transport.shutdown();
    }
}
function $18e73005dd8bbe6d$export$40ae898156a6d951(components, settings) {
    return new $18e73005dd8bbe6d$var$OTLPExportDelegate(components.transport, components.serializer, (0, $3e4caea9b02a862b$export$b6a88465884baecf)(), components.promiseHandler, settings.timeout);
}


function $7d0c02cecc294225$export$8874016870239da4(options, serializer, transport) {
    return (0, $18e73005dd8bbe6d$export$40ae898156a6d951)({
        transport: transport,
        serializer: serializer,
        promiseHandler: (0, $7975234183610ba3$export$1de3d1a6b8cb6545)(options)
    }, {
        timeout: options.timeoutMillis
    });
}


function $d7324b86b9a13b6b$export$f1ed08af29ca92a7(options, serializer) {
    return (0, $7d0c02cecc294225$export$8874016870239da4)(options, serializer, (0, $ac78d7cba247b951$export$2a8528aedd03b24e)({
        transport: (0, $cb09ba48eefe1474$export$8ab960d599ca0ecc)(options)
    }));
}
function $d7324b86b9a13b6b$export$5b68ba408d750db3(options, serializer) {
    return (0, $7d0c02cecc294225$export$8874016870239da4)(options, serializer, (0, $ac78d7cba247b951$export$2a8528aedd03b24e)({
        transport: (0, $e365c701f3b23db0$export$ef075750bfec2f31)({
            url: options.url,
            blobType: options.headers()['Content-Type']
        })
    }));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $21d798075bdc6ad7$export$c7dc25f7ba3fe11a(timeoutMillis) {
    if (Number.isFinite(timeoutMillis) && timeoutMillis > 0) return timeoutMillis;
    throw new Error(`Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '${timeoutMillis}')`);
}
function $21d798075bdc6ad7$export$c37a46ab59261386(headers) {
    if (headers == null) return undefined;
    return ()=>headers;
}
function $21d798075bdc6ad7$export$f0204f09cd0066b(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        timeoutMillis: $21d798075bdc6ad7$export$c7dc25f7ba3fe11a(userProvidedConfiguration.timeoutMillis ?? fallbackConfiguration.timeoutMillis ?? defaultConfiguration.timeoutMillis),
        concurrencyLimit: userProvidedConfiguration.concurrencyLimit ?? fallbackConfiguration.concurrencyLimit ?? defaultConfiguration.concurrencyLimit,
        compression: userProvidedConfiguration.compression ?? fallbackConfiguration.compression ?? defaultConfiguration.compression
    };
}
function $21d798075bdc6ad7$export$cd8c80b353c895f4() {
    return {
        timeoutMillis: 10000,
        concurrencyLimit: 30,
        compression: 'none'
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $9ee10f6ead5df449$export$4144cc9174bc6a0(partialHeaders) {
    return ()=>{
        const headers = {};
        Object.entries(partialHeaders?.() ?? {}).forEach(([key, value])=>{
            if (typeof value !== 'undefined') headers[key] = String(value);
            else (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Header "${key}" has invalid value (${value}) and will be ignored`);
        });
        return headers;
    };
}


function $7b3472f7b9490a7f$var$mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    const requiredHeaders = {
        ...defaultHeaders()
    };
    const headers = {};
    return ()=>{
        // add fallback ones first
        if (fallbackHeaders != null) Object.assign(headers, fallbackHeaders());
        // override with user-provided ones
        if (userProvidedHeaders != null) Object.assign(headers, userProvidedHeaders());
        // override required ones.
        return Object.assign(headers, requiredHeaders);
    };
}
function $7b3472f7b9490a7f$var$validateUserProvidedUrl(url) {
    if (url == null) return undefined;
    try {
        new URL(url);
        return url;
    } catch (e) {
        throw new Error(`Configuration: Could not parse user-provided export URL: '${url}'`);
    }
}
function $7b3472f7b9490a7f$export$dae543ef16d16f76(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        ...(0, $21d798075bdc6ad7$export$f0204f09cd0066b)(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration),
        headers: $7b3472f7b9490a7f$var$mergeHeaders((0, $9ee10f6ead5df449$export$4144cc9174bc6a0)(userProvidedConfiguration.headers), fallbackConfiguration.headers, defaultConfiguration.headers),
        url: $7b3472f7b9490a7f$var$validateUserProvidedUrl(userProvidedConfiguration.url) ?? fallbackConfiguration.url ?? defaultConfiguration.url,
        agentOptions: userProvidedConfiguration.agentOptions ?? fallbackConfiguration.agentOptions ?? defaultConfiguration.agentOptions
    };
}
function $7b3472f7b9490a7f$export$ed5dc921e0200ace(requiredHeaders, signalResourcePath) {
    return {
        ...(0, $21d798075bdc6ad7$export$cd8c80b353c895f4)(),
        headers: ()=>requiredHeaders,
        url: 'http://localhost:4318/' + signalResourcePath,
        agentOptions: {
            keepAlive: true
        }
    };
}



function $4308ed00514410df$export$816c85190fdd0ca8(config, signalResourcePath, requiredHeaders) {
    return (0, $7b3472f7b9490a7f$export$dae543ef16d16f76)({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: (0, $21d798075bdc6ad7$export$c37a46ab59261386)(config.headers),
        concurrencyLimit: config.concurrencyLimit
    }, {}, (0, $7b3472f7b9490a7f$export$ed5dc921e0200ace)(requiredHeaders, signalResourcePath));
}


function $4431ff953a4e960b$export$f0b482136e1f7b30(config, serializer, signalResourcePath, requiredHeaders) {
    const useXhr = !!config.headers || typeof navigator.sendBeacon !== 'function';
    const options = (0, $4308ed00514410df$export$816c85190fdd0ca8)(config, signalResourcePath, requiredHeaders);
    if (useXhr) return (0, $d7324b86b9a13b6b$export$f1ed08af29ca92a7)(options, serializer);
    else return (0, $d7324b86b9a13b6b$export$5b68ba408d750db3)(options, serializer);
}


class $392d64385d8e7a6b$export$f73dc942b4b27de3 extends (0, $d760faa28735d56a$export$a756c21bf453f1b5) {
    constructor(config = {}){
        super((0, $4431ff953a4e960b$export$f0b482136e1f7b30)(config, (0, $09e9215285e32b8e$export$dfba2b8376f2d3f5), 'v1/traces', {
            'Content-Type': 'application/json'
        }));
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $343ee5eade167bb1$export$85f6557964517f1a {
    _promise;
    _resolve;
    _reject;
    constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(val) {
        this._resolve(val);
    }
    reject(err) {
        this._reject(err);
    }
}


class $febbb558a26756d8$export$c1f52ab4952184cd {
    _callback;
    _that;
    _isCalled = false;
    _deferred = new (0, $343ee5eade167bb1$export$85f6557964517f1a)();
    constructor(_callback, _that){
        this._callback = _callback;
        this._that = _that;
    }
    get isCalled() {
        return this._isCalled;
    }
    get promise() {
        return this._deferred.promise;
    }
    call(...args) {
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve(this._callback.call(this._that, ...args)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1 || ($1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1 = {}));

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $10b6553ede829f91$export$c1cd528968868329(_) {
    return undefined;
}
function $10b6553ede829f91$export$9d8f36a7ac8db58c(_) {
    return undefined;
}
function $10b6553ede829f91$export$9d6c13e44580559c(_) {
    return undefined;
}
function $10b6553ede829f91$export$a18720db12f89f06(_) {
    return undefined;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $d3457759b0be0e45$export$cd67a16f6d11e5bd() {
    return (ex)=>{
        (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error($d3457759b0be0e45$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $d3457759b0be0e45$var$stringifyException(ex) {
    if (typeof ex === 'string') return ex;
    else return JSON.stringify($d3457759b0be0e45$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $d3457759b0be0e45$var$flattenException(ex) {
    const result = {};
    let current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach((propertyName)=>{
            if (result[propertyName]) return;
            const value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}


/** The global error handler delegate */ let $f91d2054c9c9eae4$var$delegateHandler = (0, $d3457759b0be0e45$export$cd67a16f6d11e5bd)();
function $f91d2054c9c9eae4$export$bdff946829732435(handler) {
    $f91d2054c9c9eae4$var$delegateHandler = handler;
}
function $f91d2054c9c9eae4$export$54c6946fc34b7cc2(ex) {
    try {
        $f91d2054c9c9eae4$var$delegateHandler(ex);
    } catch  {} // eslint-disable-line no-empty
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $471a7169b32a4714$var$SUPPRESS_TRACING_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $471a7169b32a4714$export$869298f9835abc68(context) {
    return context.setValue($471a7169b32a4714$var$SUPPRESS_TRACING_KEY, true);
}
function $471a7169b32a4714$export$a8cb26cef1019d30(context) {
    return context.deleteValue($471a7169b32a4714$var$SUPPRESS_TRACING_KEY);
}
function $471a7169b32a4714$export$7d5f2376f7cf513(context) {
    return context.getValue($471a7169b32a4714$var$SUPPRESS_TRACING_KEY) === true;
}


class $4169b44abe7f1185$export$54ea939f5d39e8a2 {
    _exporter;
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _isExporting = false;
    _finishedSpans = [];
    _timer;
    _shutdownOnce;
    _droppedSpansCount = 0;
    constructor(_exporter, config){
        this._exporter = _exporter;
        this._maxExportBatchSize = typeof config?.maxExportBatchSize === 'number' ? config.maxExportBatchSize : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_MAX_EXPORT_BATCH_SIZE') ?? 512;
        this._maxQueueSize = typeof config?.maxQueueSize === 'number' ? config.maxQueueSize : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_MAX_QUEUE_SIZE') ?? 2048;
        this._scheduledDelayMillis = typeof config?.scheduledDelayMillis === 'number' ? config.scheduledDelayMillis : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_SCHEDULE_DELAY') ?? 5000;
        this._exportTimeoutMillis = typeof config?.exportTimeoutMillis === 'number' ? config.exportTimeoutMillis : (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_BSP_EXPORT_TIMEOUT') ?? 30000;
        this._shutdownOnce = new (0, $febbb558a26756d8$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    forceFlush() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    }
    // does nothing.
    onStart(_span, _parentContext) {}
    onEnd(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $974e5505212bea35$export$bf9049ad2b0883ff).SAMPLED) === 0) return;
        this._addToBuffer(span);
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return Promise.resolve().then(()=>{
            return this.onShutdown();
        }).then(()=>{
            return this._flushAll();
        }).then(()=>{
            return this._exporter.shutdown();
        });
    }
    /** Add a span in the buffer. */ _addToBuffer(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('maxQueueSize reached, dropping spans');
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`);
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    }
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ _flushAll() {
        return new Promise((resolve, reject)=>{
            const promises = [];
            // calculate number of batches
            const count = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
            for(let i = 0, j = count; i < j; i++)promises.push(this._flushOneBatch());
            Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    _flushOneBatch() {
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            const timer = setTimeout(()=>{
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $471a7169b32a4714$export$869298f9835abc68)((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active()), ()=>{
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                let spans;
                if (this._finishedSpans.length <= this._maxExportBatchSize) {
                    spans = this._finishedSpans;
                    this._finishedSpans = [];
                } else spans = this._finishedSpans.splice(0, this._maxExportBatchSize);
                const doExport = ()=>this._exporter.export(spans, (result)=>{
                        clearTimeout(timer);
                        if (result.code === (0, $1c410abe0ad0a4e0$export$ee0fe4df4ef0f3a1).SUCCESS) resolve();
                        else reject(result.error ?? new Error('BatchSpanProcessor: span export failed'));
                    });
                let pendingResources = null;
                for(let i = 0, len = spans.length; i < len; i++){
                    const span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources ??= [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, (err)=>{
                    (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(err);
                    reject(err);
                });
            });
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const flush = ()=>{
            this._isExporting = true;
            this._flushOneBatch().finally(()=>{
                this._isExporting = false;
                if (this._finishedSpans.length > 0) {
                    this._clearTimer();
                    this._maybeStartTimer();
                }
            }).catch((e)=>{
                this._isExporting = false;
                (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
        // depending on runtime, this may be a 'number' or NodeJS.Timeout
        if (typeof this._timer !== 'number') this._timer.unref();
    }
    _clearTimer() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    }
}



class $09d39f20801a455d$export$237547059fd543f9 extends (0, $4169b44abe7f1185$export$54ea939f5d39e8a2) {
    _visibilityChangeListener;
    _pageHideListener;
    constructor(_exporter, config){
        super(_exporter, config);
        this.onInit(config);
    }
    onInit(config) {
        if (config?.disableAutoFlushOnDocumentHide !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = ()=>{
                if (document.visibilityState === 'hidden') this.forceFlush().catch((error)=>{
                    (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(error);
                });
            };
            this._pageHideListener = ()=>{
                this.forceFlush().catch((error)=>{
                    (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(error);
                });
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    }
    onShutdown() {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
        }
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ const $0ae6a14fd51bcf82$var$objectTag = '[object Object]';
const $0ae6a14fd51bcf82$var$nullTag = '[object Null]';
const $0ae6a14fd51bcf82$var$undefinedTag = '[object Undefined]';
const $0ae6a14fd51bcf82$var$funcProto = Function.prototype;
const $0ae6a14fd51bcf82$var$funcToString = $0ae6a14fd51bcf82$var$funcProto.toString;
const $0ae6a14fd51bcf82$var$objectCtorString = $0ae6a14fd51bcf82$var$funcToString.call(Object);
const $0ae6a14fd51bcf82$var$getPrototypeOf = Object.getPrototypeOf;
const $0ae6a14fd51bcf82$var$objectProto = Object.prototype;
const $0ae6a14fd51bcf82$var$hasOwnProperty = $0ae6a14fd51bcf82$var$objectProto.hasOwnProperty;
const $0ae6a14fd51bcf82$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
const $0ae6a14fd51bcf82$var$nativeObjectToString = $0ae6a14fd51bcf82$var$objectProto.toString;
function $0ae6a14fd51bcf82$export$53b83ca8eaab0383(value) {
    if (!$0ae6a14fd51bcf82$var$isObjectLike(value) || $0ae6a14fd51bcf82$var$baseGetTag(value) !== $0ae6a14fd51bcf82$var$objectTag) return false;
    const proto = $0ae6a14fd51bcf82$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = $0ae6a14fd51bcf82$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0ae6a14fd51bcf82$var$funcToString.call(Ctor) === $0ae6a14fd51bcf82$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0ae6a14fd51bcf82$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0ae6a14fd51bcf82$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $0ae6a14fd51bcf82$var$undefinedTag : $0ae6a14fd51bcf82$var$nullTag;
    return $0ae6a14fd51bcf82$var$symToStringTag && $0ae6a14fd51bcf82$var$symToStringTag in Object(value) ? $0ae6a14fd51bcf82$var$getRawTag(value) : $0ae6a14fd51bcf82$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0ae6a14fd51bcf82$var$getRawTag(value) {
    const isOwn = $0ae6a14fd51bcf82$var$hasOwnProperty.call(value, $0ae6a14fd51bcf82$var$symToStringTag), tag = value[$0ae6a14fd51bcf82$var$symToStringTag];
    let unmasked = false;
    try {
        value[$0ae6a14fd51bcf82$var$symToStringTag] = undefined;
        unmasked = true;
    } catch  {
    // silence
    }
    const result = $0ae6a14fd51bcf82$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0ae6a14fd51bcf82$var$symToStringTag] = tag;
        else delete value[$0ae6a14fd51bcf82$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $0ae6a14fd51bcf82$var$objectToString(value) {
    return $0ae6a14fd51bcf82$var$nativeObjectToString.call(value);
}


const $13d6a7eb020acf9f$var$MAX_LEVEL = 20;
function $13d6a7eb020acf9f$export$4950aa0f605343fb(...args) {
    let result = args.shift();
    const objects = new WeakMap();
    while(args.length > 0)result = $13d6a7eb020acf9f$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $13d6a7eb020acf9f$var$takeValue(value) {
    if ($13d6a7eb020acf9f$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $13d6a7eb020acf9f$var$mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > $13d6a7eb020acf9f$var$MAX_LEVEL) return undefined;
    level++;
    if ($13d6a7eb020acf9f$var$isPrimitive(one) || $13d6a7eb020acf9f$var$isPrimitive(two) || $13d6a7eb020acf9f$var$isFunction(two)) result = $13d6a7eb020acf9f$var$takeValue(two);
    else if ($13d6a7eb020acf9f$var$isArray(one)) {
        result = one.slice();
        if ($13d6a7eb020acf9f$var$isArray(two)) for(let i = 0, j = two.length; i < j; i++)result.push($13d6a7eb020acf9f$var$takeValue(two[i]));
        else if ($13d6a7eb020acf9f$var$isObject(two)) {
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                result[key] = $13d6a7eb020acf9f$var$takeValue(two[key]);
            }
        }
    } else if ($13d6a7eb020acf9f$var$isObject(one)) {
        if ($13d6a7eb020acf9f$var$isObject(two)) {
            if (!$13d6a7eb020acf9f$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                const twoValue = two[key];
                if ($13d6a7eb020acf9f$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if ($13d6a7eb020acf9f$var$wasObjectReferenced(one, key, objects) || $13d6a7eb020acf9f$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($13d6a7eb020acf9f$var$isObject(obj1) && $13d6a7eb020acf9f$var$isObject(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $13d6a7eb020acf9f$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $13d6a7eb020acf9f$var$wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for(let i = 0, j = arr.length; i < j; i++){
        const info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $13d6a7eb020acf9f$var$isArray(value) {
    return Array.isArray(value);
}
function $13d6a7eb020acf9f$var$isFunction(value) {
    return typeof value === 'function';
}
function $13d6a7eb020acf9f$var$isObject(value) {
    return !$13d6a7eb020acf9f$var$isPrimitive(value) && !$13d6a7eb020acf9f$var$isArray(value) && !$13d6a7eb020acf9f$var$isFunction(value) && typeof value === 'object';
}
function $13d6a7eb020acf9f$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' || value instanceof Date || value instanceof RegExp || value === null;
}
function $13d6a7eb020acf9f$var$shouldMerge(one, two) {
    if (!(0, $0ae6a14fd51bcf82$export$53b83ca8eaab0383)(one) || !(0, $0ae6a14fd51bcf82$export$53b83ca8eaab0383)(two)) return false;
    return true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $5b2a4f91df455610$export$a4ad2735b021c132 = '2.2.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ //----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/stable/attributes.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * ASP.NET Core exception middleware handling result.
 *
 * @example handled
 * @example unhandled
 */ const $d77970ee83c3563c$export$f82340eb6f7ee4fc = 'aspnetcore.diagnostics.exception.result';
const $d77970ee83c3563c$export$cda1f266e1fc5b3f = "aborted";
const $d77970ee83c3563c$export$f59ec205fdfe6400 = "handled";
const $d77970ee83c3563c$export$b427e935fd6651ab = "skipped";
const $d77970ee83c3563c$export$7a0c380cad26f867 = "unhandled";
const $d77970ee83c3563c$export$e15ee6ced4b4d793 = 'aspnetcore.diagnostics.handler.type';
const $d77970ee83c3563c$export$d6be6e9a073ccba5 = 'aspnetcore.rate_limiting.policy';
const $d77970ee83c3563c$export$df376702a339c094 = 'aspnetcore.rate_limiting.result';
const $d77970ee83c3563c$export$e160ee3fb23dd21e = "acquired";
const $d77970ee83c3563c$export$336cf096763833a3 = "endpoint_limiter";
const $d77970ee83c3563c$export$ee99d6c8d66ba053 = "global_limiter";
const $d77970ee83c3563c$export$d4525b0bcb1802a6 = "request_canceled";
const $d77970ee83c3563c$export$746fc3f900d45c45 = 'aspnetcore.request.is_unhandled';
const $d77970ee83c3563c$export$bcd5f0f8484c3bc0 = 'aspnetcore.routing.is_fallback';
const $d77970ee83c3563c$export$d181153b8bdfa0b6 = 'aspnetcore.routing.match_status';
const $d77970ee83c3563c$export$ca7f093befa342d4 = "failure";
const $d77970ee83c3563c$export$ae1a39d3a4050746 = "success";
const $d77970ee83c3563c$export$f25890d1e3848156 = 'aspnetcore.user.is_authenticated';
const $d77970ee83c3563c$export$d68d146ff79c04a8 = 'client.address';
const $d77970ee83c3563c$export$98967a53baad5eec = 'client.port';
const $d77970ee83c3563c$export$5285ee03db771e5b = 'code.column.number';
const $d77970ee83c3563c$export$ac9d6c9a41211595 = 'code.file.path';
const $d77970ee83c3563c$export$fd34f7e1f0c418fc = 'code.function.name';
const $d77970ee83c3563c$export$ccc16b040f2d3c68 = 'code.line.number';
const $d77970ee83c3563c$export$84cf154ace206984 = 'code.stacktrace';
const $d77970ee83c3563c$export$f3ebe872053c9886 = 'db.collection.name';
const $d77970ee83c3563c$export$354f27025f67a12d = 'db.namespace';
const $d77970ee83c3563c$export$899baaeb75956560 = 'db.operation.batch.size';
const $d77970ee83c3563c$export$32ff3b5ea8eeed5d = 'db.operation.name';
const $d77970ee83c3563c$export$ebef2908cb0508b2 = 'db.query.summary';
const $d77970ee83c3563c$export$dc45382793fd9c73 = 'db.query.text';
const $d77970ee83c3563c$export$5f1e82edb68082a5 = 'db.response.status_code';
const $d77970ee83c3563c$export$59730bfffb801deb = 'db.stored_procedure.name';
const $d77970ee83c3563c$export$e092ac179da1bacb = 'db.system.name';
const $d77970ee83c3563c$export$33a9d0e8e2693338 = "mariadb";
const $d77970ee83c3563c$export$e0e77e85ab698795 = "microsoft.sql_server";
const $d77970ee83c3563c$export$6b580327d217ab17 = "mysql";
const $d77970ee83c3563c$export$de5fcd2a0648ea59 = "postgresql";
const $d77970ee83c3563c$export$50d2ae8f0fe53654 = 'dotnet.gc.heap.generation';
const $d77970ee83c3563c$export$53c7cec226bbc008 = "gen0";
const $d77970ee83c3563c$export$16eba2d1cd3c6aae = "gen1";
const $d77970ee83c3563c$export$53cbcd4ebe9fed52 = "gen2";
const $d77970ee83c3563c$export$73025750a790bd80 = "loh";
const $d77970ee83c3563c$export$92f06dbb8b8e4efb = "poh";
const $d77970ee83c3563c$export$27bc5d0fa190eb39 = 'error.type';
const $d77970ee83c3563c$export$c00e2e224ae81dcc = "_OTHER";
const $d77970ee83c3563c$export$5afa65f3c67a6da5 = 'exception.escaped';
const $d77970ee83c3563c$export$ab4513c1b55519b5 = 'exception.message';
const $d77970ee83c3563c$export$9b74e4928364b671 = 'exception.stacktrace';
const $d77970ee83c3563c$export$85da07cb5d867763 = 'exception.type';
const $d77970ee83c3563c$export$6dc05c1a4ea7d452 = (key)=>`http.request.header.${key}`;
const $d77970ee83c3563c$export$c950c48d651d36f6 = 'http.request.method';
const $d77970ee83c3563c$export$475d0b6904c72522 = "_OTHER";
const $d77970ee83c3563c$export$1d0475e0429ecc7a = "CONNECT";
const $d77970ee83c3563c$export$f5009fc3b2e116f6 = "DELETE";
const $d77970ee83c3563c$export$b37eb57f1c0ae17e = "GET";
const $d77970ee83c3563c$export$cfad2d23aef0a595 = "HEAD";
const $d77970ee83c3563c$export$ffb5e83a22c8414 = "OPTIONS";
const $d77970ee83c3563c$export$c4e10ea4e2b3375 = "PATCH";
const $d77970ee83c3563c$export$ca259afc8ad50e83 = "POST";
const $d77970ee83c3563c$export$a8e9778ce76ecdaa = "PUT";
const $d77970ee83c3563c$export$81cc82dc1804c06e = "TRACE";
const $d77970ee83c3563c$export$b4706f4398125cd2 = 'http.request.method_original';
const $d77970ee83c3563c$export$44a2b6455db2b082 = 'http.request.resend_count';
const $d77970ee83c3563c$export$a3227fcde36256b7 = (key)=>`http.response.header.${key}`;
const $d77970ee83c3563c$export$4f9cc9c1e7b4e832 = 'http.response.status_code';
const $d77970ee83c3563c$export$ee724a749950397e = 'http.route';
const $d77970ee83c3563c$export$9633601338584456 = 'jvm.gc.action';
const $d77970ee83c3563c$export$81a9f72367df0211 = 'jvm.gc.name';
const $d77970ee83c3563c$export$27fb7cfe62c0cad7 = 'jvm.memory.pool.name';
const $d77970ee83c3563c$export$c9dfa04abbde6209 = 'jvm.memory.type';
const $d77970ee83c3563c$export$5eceb6c6d9c4a2b1 = "heap";
const $d77970ee83c3563c$export$fb42d239cc164326 = "non_heap";
const $d77970ee83c3563c$export$b9f4735680b4c618 = 'jvm.thread.daemon';
const $d77970ee83c3563c$export$49cfe86a143a90f4 = 'jvm.thread.state';
const $d77970ee83c3563c$export$4d1c8eb785b37946 = "blocked";
const $d77970ee83c3563c$export$438d3b92d604d3c1 = "new";
const $d77970ee83c3563c$export$efbf4822176b787e = "runnable";
const $d77970ee83c3563c$export$10d62496862243a3 = "terminated";
const $d77970ee83c3563c$export$54c3957659069067 = "timed_waiting";
const $d77970ee83c3563c$export$97de93f28bd98f0c = "waiting";
const $d77970ee83c3563c$export$122a3f3d92b58f2d = 'network.local.address';
const $d77970ee83c3563c$export$dd3d00f8681df0ce = 'network.local.port';
const $d77970ee83c3563c$export$28b7676252843fab = 'network.peer.address';
const $d77970ee83c3563c$export$9fb532b0fee2b1f1 = 'network.peer.port';
const $d77970ee83c3563c$export$dee59b686a2846ec = 'network.protocol.name';
const $d77970ee83c3563c$export$d98f8d975600c0d0 = 'network.protocol.version';
const $d77970ee83c3563c$export$7616c996937a34bc = 'network.transport';
const $d77970ee83c3563c$export$f4431576993bcf7a = "pipe";
const $d77970ee83c3563c$export$169e124b418d088f = "quic";
const $d77970ee83c3563c$export$26ef76391bdfab1b = "tcp";
const $d77970ee83c3563c$export$a1d89d523a38f571 = "udp";
const $d77970ee83c3563c$export$19b3a90274118dec = "unix";
const $d77970ee83c3563c$export$9ce893eda94da085 = 'network.type';
const $d77970ee83c3563c$export$1c0032dd042c0036 = "ipv4";
const $d77970ee83c3563c$export$2e20616f92e0c61 = "ipv6";
const $d77970ee83c3563c$export$c0272561abab91e2 = 'otel.scope.name';
const $d77970ee83c3563c$export$f34b883f266e7940 = 'otel.scope.version';
const $d77970ee83c3563c$export$1ce3678560a98f66 = 'otel.status_code';
const $d77970ee83c3563c$export$91e9746558fdb3eb = "ERROR";
const $d77970ee83c3563c$export$88d70046bd134963 = "OK";
const $d77970ee83c3563c$export$bb722bc34dbbae55 = 'otel.status_description';
const $d77970ee83c3563c$export$a5acaa0dbc823e02 = 'server.address';
const $d77970ee83c3563c$export$b7822882ad829476 = 'server.port';
const $d77970ee83c3563c$export$84187ab40ae4fa9c = 'service.name';
const $d77970ee83c3563c$export$262ef07bab967f36 = 'service.version';
const $d77970ee83c3563c$export$d52213f71e0d6fe9 = 'signalr.connection.status';
const $d77970ee83c3563c$export$1941a43dd05c1796 = "app_shutdown";
const $d77970ee83c3563c$export$339985f783caddd3 = "normal_closure";
const $d77970ee83c3563c$export$5dbce0c170853f5d = "timeout";
const $d77970ee83c3563c$export$344eec4d4360b8c9 = 'signalr.transport';
const $d77970ee83c3563c$export$c9ad321a279e5110 = "long_polling";
const $d77970ee83c3563c$export$ade38f22da951337 = "server_sent_events";
const $d77970ee83c3563c$export$cb9a023ecee30642 = "web_sockets";
const $d77970ee83c3563c$export$f0cc9f40fa472996 = 'telemetry.sdk.language';
const $d77970ee83c3563c$export$76253579e9fea8e3 = "cpp";
const $d77970ee83c3563c$export$4163d8f19c62acfe = "dotnet";
const $d77970ee83c3563c$export$d735f65160d35019 = "erlang";
const $d77970ee83c3563c$export$1dde175b7d1c8a44 = "go";
const $d77970ee83c3563c$export$73150af2f1f383fa = "java";
const $d77970ee83c3563c$export$1b3cb919ea0daa1c = "nodejs";
const $d77970ee83c3563c$export$1a3ac4d13e9292be = "php";
const $d77970ee83c3563c$export$5734868f06d7b5c8 = "python";
const $d77970ee83c3563c$export$b7bb3f8171ef2aa3 = "ruby";
const $d77970ee83c3563c$export$713f4fffa2875054 = "rust";
const $d77970ee83c3563c$export$8d08f2cb0d9fd722 = "swift";
const $d77970ee83c3563c$export$2f063992689fdf64 = "webjs";
const $d77970ee83c3563c$export$8f719441032e7a01 = 'telemetry.sdk.name';
const $d77970ee83c3563c$export$5fe5e8dd061ec635 = 'telemetry.sdk.version';
const $d77970ee83c3563c$export$f00e0b7bc579cfe4 = 'url.fragment';
const $d77970ee83c3563c$export$ef7da4fb774e8a84 = 'url.full';
const $d77970ee83c3563c$export$36f670b9709ab2f8 = 'url.path';
const $d77970ee83c3563c$export$55ce97b387061dd1 = 'url.query';
const $d77970ee83c3563c$export$d1d5ca1ca02801e6 = 'url.scheme';
const $d77970ee83c3563c$export$11d4f8ef7be26b3d = 'user_agent.original';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * The name of the runtime of this process.
 *
 * @example OpenJDK Runtime Environment
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 */ const $b03d57a2b73f253b$export$ad06ab84cf3d9d79 = 'process.runtime.name';


const $a43a32f76182233d$export$3c44663382dce232 = {
    [(0, $d77970ee83c3563c$export$8f719441032e7a01)]: 'opentelemetry',
    [(0, $b03d57a2b73f253b$export$ad06ab84cf3d9d79)]: 'browser',
    [(0, $d77970ee83c3563c$export$f0cc9f40fa472996)]: (0, $d77970ee83c3563c$export$2f063992689fdf64),
    [(0, $d77970ee83c3563c$export$5fe5e8dd061ec635)]: (0, $5b2a4f91df455610$export$a4ad2735b021c132)
};



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e583903ce4fde7b2$export$b8c2abd2a6cf7c10() {
    return 'unknown_service';
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4709fdbdf22bd726$export$ae936b9d47e5870e = (val)=>{
    return val !== null && typeof val === 'object' && typeof val.then === 'function';
};
function $4709fdbdf22bd726$export$f0954fd7d5368655(_) {
    return _;
}


class $f5d296ad825fd0d7$var$ResourceImpl {
    _rawAttributes;
    _asyncAttributesPending = false;
    _schemaUrl;
    _memoizedAttributes;
    static FromAttributeList(attributes, options) {
        const res = new $f5d296ad825fd0d7$var$ResourceImpl({}, options);
        res._rawAttributes = $f5d296ad825fd0d7$var$guardedRawAttributes(attributes);
        res._asyncAttributesPending = attributes.filter(([_, val])=>(0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(val)).length > 0;
        return res;
    }
    constructor(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ resource, options){
        const attributes = resource.attributes ?? {};
        this._rawAttributes = Object.entries(attributes).map(([k, v])=>{
            if ((0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v)) // side-effect
            this._asyncAttributesPending = true;
            return [
                k,
                v
            ];
        });
        this._rawAttributes = $f5d296ad825fd0d7$var$guardedRawAttributes(this._rawAttributes);
        this._schemaUrl = $f5d296ad825fd0d7$var$validateSchemaUrl(options?.schemaUrl);
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (!this.asyncAttributesPending) return;
        for(let i = 0; i < this._rawAttributes.length; i++){
            const [k, v] = this._rawAttributes[i];
            this._rawAttributes[i] = [
                k,
                (0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v) ? await v : v
            ];
        }
        this._asyncAttributesPending = false;
    }
    get attributes() {
        if (this.asyncAttributesPending) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error('Accessing resource attributes before async attributes settled');
        if (this._memoizedAttributes) return this._memoizedAttributes;
        const attrs = {};
        for (const [k, v] of this._rawAttributes){
            if ((0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v)) {
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug(`Unsettled resource attribute ${k} skipped`);
                continue;
            }
            if (v != null) attrs[k] ??= v;
        }
        // only memoize output if all attributes are settled
        if (!this._asyncAttributesPending) this._memoizedAttributes = attrs;
        return attrs;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    get schemaUrl() {
        return this._schemaUrl;
    }
    merge(resource) {
        if (resource == null) return this;
        // Order is important
        // Spec states incoming attributes override existing attributes
        const mergedSchemaUrl = $f5d296ad825fd0d7$var$mergeSchemaUrl(this, resource);
        const mergedOptions = mergedSchemaUrl ? {
            schemaUrl: mergedSchemaUrl
        } : undefined;
        return $f5d296ad825fd0d7$var$ResourceImpl.FromAttributeList([
            ...resource.getRawAttributes(),
            ...this.getRawAttributes()
        ], mergedOptions);
    }
}
function $f5d296ad825fd0d7$export$bb0fe4e7060febbf(attributes, options) {
    return $f5d296ad825fd0d7$var$ResourceImpl.FromAttributeList(Object.entries(attributes), options);
}
function $f5d296ad825fd0d7$export$4d462f2e58ee368a(detectedResource, options) {
    return new $f5d296ad825fd0d7$var$ResourceImpl(detectedResource, options);
}
function $f5d296ad825fd0d7$export$6ed870441802d126() {
    return $f5d296ad825fd0d7$export$bb0fe4e7060febbf({});
}
function $f5d296ad825fd0d7$export$522a862cad1b0abc() {
    return $f5d296ad825fd0d7$export$bb0fe4e7060febbf({
        [(0, $d77970ee83c3563c$export$84187ab40ae4fa9c)]: (0, $e583903ce4fde7b2$export$b8c2abd2a6cf7c10)(),
        [(0, $d77970ee83c3563c$export$f0cc9f40fa472996)]: (0, $a43a32f76182233d$export$3c44663382dce232)[0, $d77970ee83c3563c$export$f0cc9f40fa472996],
        [(0, $d77970ee83c3563c$export$8f719441032e7a01)]: (0, $a43a32f76182233d$export$3c44663382dce232)[0, $d77970ee83c3563c$export$8f719441032e7a01],
        [(0, $d77970ee83c3563c$export$5fe5e8dd061ec635)]: (0, $a43a32f76182233d$export$3c44663382dce232)[0, $d77970ee83c3563c$export$5fe5e8dd061ec635]
    });
}
function $f5d296ad825fd0d7$var$guardedRawAttributes(attributes) {
    return attributes.map(([k, v])=>{
        if ((0, $4709fdbdf22bd726$export$ae936b9d47e5870e)(v)) return [
            k,
            v.catch((err)=>{
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('promise rejection for resource attribute: %s - %s', k, err);
                return undefined;
            })
        ];
        return [
            k,
            v
        ];
    });
}
function $f5d296ad825fd0d7$var$validateSchemaUrl(schemaUrl) {
    if (typeof schemaUrl === 'string' || schemaUrl === undefined) return schemaUrl;
    (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Schema URL must be string or undefined, got %s. Schema URL will be ignored.', schemaUrl);
    return undefined;
}
function $f5d296ad825fd0d7$var$mergeSchemaUrl(old, updating) {
    const oldSchemaUrl = old?.schemaUrl;
    const updatingSchemaUrl = updating?.schemaUrl;
    const isOldEmpty = oldSchemaUrl === undefined || oldSchemaUrl === '';
    const isUpdatingEmpty = updatingSchemaUrl === undefined || updatingSchemaUrl === '';
    if (isOldEmpty) return updatingSchemaUrl;
    if (isUpdatingEmpty) return oldSchemaUrl;
    if (oldSchemaUrl === updatingSchemaUrl) return oldSchemaUrl;
    (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', oldSchemaUrl, updatingSchemaUrl);
    return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $ebedf3725a996547$export$b0663eba150d60c9(attributes) {
    const out = {};
    if (typeof attributes !== 'object' || attributes == null) return out;
    for(const key in attributes){
        if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
        if (!$ebedf3725a996547$export$d3dd8ead6a0318c3(key)) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            continue;
        }
        const val = attributes[key];
        if (!$ebedf3725a996547$export$1daad3d2aacf48c5(val)) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) out[key] = val.slice();
        else out[key] = val;
    }
    return out;
}
function $ebedf3725a996547$export$d3dd8ead6a0318c3(key) {
    return typeof key === 'string' && key !== '';
}
function $ebedf3725a996547$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $ebedf3725a996547$var$isHomogeneousAttributeValueArray(val);
    return $ebedf3725a996547$var$isValidPrimitiveAttributeValueType(typeof val);
}
function $ebedf3725a996547$var$isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element of arr){
        // null/undefined elements are allowed
        if (element == null) continue;
        const elementType = typeof element;
        if (elementType === type) continue;
        if (!type) {
            if ($ebedf3725a996547$var$isValidPrimitiveAttributeValueType(elementType)) {
                type = elementType;
                continue;
            }
            // encountered an invalid primitive
            return false;
        }
        return false;
    }
    return true;
}
function $ebedf3725a996547$var$isValidPrimitiveAttributeValueType(valType) {
    switch(valType){
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d7cd629efb5f51e$export$b22daef4119238cd = performance;


const $3b7d94c9e2749488$var$NANOSECOND_DIGITS = 9;
const $3b7d94c9e2749488$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $3b7d94c9e2749488$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $3b7d94c9e2749488$var$NANOSECOND_DIGITS_IN_MILLIS);
const $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS = Math.pow(10, $3b7d94c9e2749488$var$NANOSECOND_DIGITS);
function $3b7d94c9e2749488$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $3b7d94c9e2749488$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $3b7d94c9e2749488$export$e752b05e58096a2f() {
    let timeOrigin = (0, $1d7cd629efb5f51e$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== 'number') {
        const perf = (0, $1d7cd629efb5f51e$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $3b7d94c9e2749488$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $3b7d94c9e2749488$export$e7ec5c82995537b1($3b7d94c9e2749488$export$e752b05e58096a2f());
    const now = $3b7d94c9e2749488$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $1d7cd629efb5f51e$export$b22daef4119238cd).now());
    return $3b7d94c9e2749488$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $3b7d94c9e2749488$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($3b7d94c9e2749488$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $3b7d94c9e2749488$export$e752b05e58096a2f()) return $3b7d94c9e2749488$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $3b7d94c9e2749488$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $3b7d94c9e2749488$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $3b7d94c9e2749488$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $3b7d94c9e2749488$export$973c1c4fad6103e(time) {
    const precision = $3b7d94c9e2749488$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $3b7d94c9e2749488$export$2d91441ae30ebcfc(time) {
    return time[0] * $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS + time[1];
}
function $3b7d94c9e2749488$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $3b7d94c9e2749488$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $3b7d94c9e2749488$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $3b7d94c9e2749488$export$a5e58227c317ebb9(value) {
    return $3b7d94c9e2749488$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $3b7d94c9e2749488$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $3b7d94c9e2749488$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
const $1ecab79120c00c83$export$a0fff09a5370d06f = 'exception';


class $38fde56e89775176$export$7b15d0c2dba75760 {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    name;
    status = {
        code: (0, $873e79d0391b734f$export$1e28dd9b5d01db83).UNSET
    };
    endTime = [
        0,
        0
    ];
    _ended = false;
    _duration = [
        -1,
        -1
    ];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    /**
     * Constructs a new SpanImpl instance.
     */ constructor(opts){
        const now = Date.now();
        this._spanContext = opts.spanContext;
        this._performanceStartTime = (0, $1d7cd629efb5f51e$export$b22daef4119238cd).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $3b7d94c9e2749488$export$e752b05e58096a2f)());
        this._startTimeProvided = opts.startTime != null;
        this._spanLimits = opts.spanLimits;
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        this._spanProcessor = opts.spanProcessor;
        this.name = opts.name;
        this.parentSpanContext = opts.parentSpanContext;
        this.kind = opts.kind;
        this.links = opts.links || [];
        this.startTime = this._getTime(opts.startTime ?? now);
        this.resource = opts.resource;
        this.instrumentationScope = opts.scope;
        if (opts.attributes != null) this.setAttributes(opts.attributes);
        this._spanProcessor.onStart(this, opts.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!(0, $ebedf3725a996547$export$1daad3d2aacf48c5)(value)) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        const { attributeCountLimit: attributeCountLimit } = this._spanLimits;
        if (attributeCountLimit !== undefined && Object.keys(this.attributes).length >= attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    }
    setAttributes(attributes) {
        for (const [k, v] of Object.entries(attributes))this.setAttribute(k, v);
        return this;
    }
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ addEvent(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        const { eventCountLimit: eventCountLimit } = this._spanLimits;
        if (eventCountLimit === 0) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (eventCountLimit !== undefined && this.events.length >= eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).debug('Dropping extra events.');
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $3b7d94c9e2749488$export$a5e58227c317ebb9)(attributesOrStartTime)) {
            if (!(0, $3b7d94c9e2749488$export$a5e58227c317ebb9)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        const attributes = (0, $ebedf3725a996547$export$b0663eba150d60c9)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    }
    addLink(link) {
        this.links.push(link);
        return this;
    }
    addLinks(links) {
        this.links.push(...links);
        return this;
    }
    setStatus(status) {
        if (this._isSpanEnded()) return this;
        this.status = {
            ...status
        };
        // When using try-catch, the caught "error" is of type `any`. When then assigning `any` to `status.message`,
        // TypeScript will not error. While this can happen during use of any API, it is more common on Span#setStatus()
        // as it's likely used in a catch-block. Therefore, we validate if `status.message` is actually a string, null, or
        // undefined to avoid an incorrect type causing issues downstream.
        if (this.status.message != null && typeof status.message !== 'string') {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
            delete this.status.message;
        }
        return this;
    }
    updateName(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    }
    end(endTime) {
        if (this._isSpanEnded()) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = (0, $3b7d94c9e2749488$export$b783ad6617389e3e)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
        this._spanProcessor.onEnd(this);
    }
    _getTime(inp) {
        if (typeof inp === 'number' && inp <= (0, $1d7cd629efb5f51e$export$b22daef4119238cd).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $3b7d94c9e2749488$export$24b3f7dcd2848fa8)(inp + this._performanceOffset);
        if (typeof inp === 'number') return (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(inp);
        if (inp instanceof Date) return (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(inp.getTime());
        if ((0, $3b7d94c9e2749488$export$390c59432f173a9f)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(Date.now());
        const msDuration = (0, $1d7cd629efb5f51e$export$b22daef4119238cd).now() - this._performanceStartTime;
        return (0, $3b7d94c9e2749488$export$f07bb1dbc72184c3)(this.startTime, (0, $3b7d94c9e2749488$export$e7ec5c82995537b1)(msDuration));
    }
    isRecording() {
        return this._ended === false;
    }
    recordException(exception, time) {
        const attributes = {};
        if (typeof exception === 'string') attributes[0, $d77970ee83c3563c$export$ab4513c1b55519b5] = exception;
        else if (exception) {
            if (exception.code) attributes[0, $d77970ee83c3563c$export$85da07cb5d867763] = exception.code.toString();
            else if (exception.name) attributes[0, $d77970ee83c3563c$export$85da07cb5d867763] = exception.name;
            if (exception.message) attributes[0, $d77970ee83c3563c$export$ab4513c1b55519b5] = exception.message;
            if (exception.stack) attributes[0, $d77970ee83c3563c$export$9b74e4928364b671] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, $d77970ee83c3563c$export$85da07cb5d867763] || attributes[0, $d77970ee83c3563c$export$ab4513c1b55519b5]) this.addEvent((0, $1ecab79120c00c83$export$a0fff09a5370d06f), attributes, time);
        else (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Failed to record an exception ${exception}`);
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
        }
        return this._ended;
    }
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    }
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ _truncateToSize(value) {
        const limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map((val)=>typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        // Other types, no need to apply value length limit
        return value;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $9e1b4e663c9889e9$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($9e1b4e663c9889e9$export$94df7a7a96a92f7b || ($9e1b4e663c9889e9$export$94df7a7a96a92f7b = {}));


class $db3ff6a2c664450e$export$abc5f11618c4d6a3 {
    shouldSample() {
        return {
            decision: (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return 'AlwaysOffSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $f0144350595f9729$export$653f832afb4ffa27 {
    shouldSample() {
        return {
            decision: (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED
        };
    }
    toString() {
        return 'AlwaysOnSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



class $4c6db2f48508c435$export$2bc0b1b09c2e3b47 {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(config){
        this._root = config.root;
        if (!this._root) {
            (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        }
        this._remoteParentSampled = config.remoteParentSampled ?? new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        this._remoteParentNotSampled = config.remoteParentNotSampled ?? new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)();
        this._localParentSampled = config.localParentSampled ?? new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        this._localParentNotSampled = config.localParentNotSampled ?? new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)();
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const parentContext = (0, $a1569335aa614ed8$export$357889f174732d38).getSpanContext(context);
        if (!parentContext || !(0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $974e5505212bea35$export$bf9049ad2b0883ff).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $974e5505212bea35$export$bf9049ad2b0883ff).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

class $32a5444161ac9353$export$f1624f887f708bbf {
    _ratio;
    _upperBound;
    constructor(_ratio = 0){
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    shouldSample(context, traceId) {
        return {
            decision: (0, $a89fc3550e8ac673$export$29dd34cf1269f6da)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED : (0, $9e1b4e663c9889e9$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    }
    _accumulate(traceId) {
        let accumulation = 0;
        for(let i = 0; i < traceId.length / 8; i++){
            const pos = i * 8;
            const part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    }
}


var $9da0721ed781558b$var$TracesSamplerValues;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($9da0721ed781558b$var$TracesSamplerValues || ($9da0721ed781558b$var$TracesSamplerValues = {}));
const $9da0721ed781558b$var$DEFAULT_RATIO = 1;
function $9da0721ed781558b$export$d25a2c2f78a5e968() {
    return {
        sampler: $9da0721ed781558b$export$534308d7e73f0e71(),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? 128,
            linkCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_LINK_COUNT_LIMIT') ?? 128,
            eventCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_EVENT_COUNT_LIMIT') ?? 128,
            attributePerEventCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT') ?? 128,
            attributePerLinkCountLimit: (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT') ?? 128
        }
    };
}
function $9da0721ed781558b$export$534308d7e73f0e71() {
    const sampler = (0, $10b6553ede829f91$export$c1cd528968868329)('OTEL_TRACES_SAMPLER') ?? $9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOn;
    switch(sampler){
        case $9da0721ed781558b$var$TracesSamplerValues.AlwaysOn:
            return new (0, $f0144350595f9729$export$653f832afb4ffa27)();
        case $9da0721ed781558b$var$TracesSamplerValues.AlwaysOff:
            return new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)();
        case $9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $f0144350595f9729$export$653f832afb4ffa27)()
            });
        case $9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $db3ff6a2c664450e$export$abc5f11618c4d6a3)()
            });
        case $9da0721ed781558b$var$TracesSamplerValues.TraceIdRatio:
            return new (0, $32a5444161ac9353$export$f1624f887f708bbf)($9da0721ed781558b$var$getSamplerProbabilityFromEnv());
        case $9da0721ed781558b$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $32a5444161ac9353$export$f1624f887f708bbf)($9da0721ed781558b$var$getSamplerProbabilityFromEnv())
            });
        default:
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${$9da0721ed781558b$var$TracesSamplerValues.ParentBasedAlwaysOn}".`);
            return new (0, $4c6db2f48508c435$export$2bc0b1b09c2e3b47)({
                root: new (0, $f0144350595f9729$export$653f832afb4ffa27)()
            });
    }
}
function $9da0721ed781558b$var$getSamplerProbabilityFromEnv() {
    const probability = (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_TRACES_SAMPLER_ARG');
    if (probability == null) {
        (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${$9da0721ed781558b$var$DEFAULT_RATIO}.`);
        return $9da0721ed781558b$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${$9da0721ed781558b$var$DEFAULT_RATIO}.`);
        return $9da0721ed781558b$var$DEFAULT_RATIO;
    }
    return probability;
}



const $62df14f081748e93$export$6ad612be99f9ed48 = 128;
const $62df14f081748e93$export$d9446f3c1c12def1 = Infinity;
function $62df14f081748e93$export$7ec1ebcfa9d8bd6a(userConfig) {
    const perInstanceDefaults = {
        sampler: (0, $9da0721ed781558b$export$534308d7e73f0e71)()
    };
    const DEFAULT_CONFIG = (0, $9da0721ed781558b$export$d25a2c2f78a5e968)();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $62df14f081748e93$export$9f9fb435f8494555(userConfig) {
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = userConfig.spanLimits?.attributeCountLimit ?? userConfig.generalLimits?.attributeCountLimit ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? $62df14f081748e93$export$6ad612be99f9ed48;
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = userConfig.spanLimits?.attributeValueLengthLimit ?? userConfig.generalLimits?.attributeValueLengthLimit ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? (0, $10b6553ede829f91$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? $62df14f081748e93$export$d9446f3c1c12def1;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f32cfe3d924eea7$var$SPAN_ID_BYTES = 8;
const $2f32cfe3d924eea7$var$TRACE_ID_BYTES = 16;
class $2f32cfe3d924eea7$export$97307207ef48da75 {
    /**
     * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
     * characters corresponding to 128 bits.
     */ generateTraceId = $2f32cfe3d924eea7$var$getIdGenerator($2f32cfe3d924eea7$var$TRACE_ID_BYTES);
    /**
     * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
     * characters corresponding to 64 bits.
     */ generateSpanId = $2f32cfe3d924eea7$var$getIdGenerator($2f32cfe3d924eea7$var$SPAN_ID_BYTES);
}
const $2f32cfe3d924eea7$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $2f32cfe3d924eea7$var$getIdGenerator(bytes) {
    return function generateId() {
        for(let i = 0; i < bytes * 2; i++){
            $2f32cfe3d924eea7$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if ($2f32cfe3d924eea7$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $2f32cfe3d924eea7$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $2f32cfe3d924eea7$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}


class $16238f2d0abda630$export$c4b9363e2fc65361 {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    /**
     * Constructs a new Tracer instance.
     */ constructor(instrumentationScope, config, resource, spanProcessor){
        const localConfig = (0, $62df14f081748e93$export$7ec1ebcfa9d8bd6a)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $2f32cfe3d924eea7$export$97307207ef48da75)();
        this._resource = resource;
        this._spanProcessor = spanProcessor;
        this.instrumentationScope = instrumentationScope;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ startSpan(name, options = {}, context = $e8248f70bfae46d0$export$a078c61943f9dbbe.active()) {
        // remove span from context in case a root span is requested via options
        if (options.root) context = $a1569335aa614ed8$export$357889f174732d38.deleteSpan(context);
        const parentSpan = $a1569335aa614ed8$export$357889f174732d38.getSpan(context);
        if ((0, $471a7169b32a4714$export$7d5f2376f7cf513)(context)) {
            $83ffbea8f4ffb90a$export$c042e7c2f59bc046.debug('Instrumentation suppressed, returning Noop Span');
            const nonRecordingSpan = $a1569335aa614ed8$export$357889f174732d38.wrapSpanContext($9c9f5532a1cced84$export$8591e4c852b66703);
            return nonRecordingSpan;
        }
        const parentSpanContext = parentSpan?.spanContext();
        const spanId = this._idGenerator.generateSpanId();
        let validParentSpanContext;
        let traceId;
        let traceState;
        if (!parentSpanContext || !$a1569335aa614ed8$export$357889f174732d38.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            validParentSpanContext = parentSpanContext;
        }
        const spanKind = options.kind ?? $d03364baa5302116$export$4da4ea8145910e8b.INTERNAL;
        const links = (options.links ?? []).map((link)=>{
            return {
                context: link.context,
                attributes: (0, $ebedf3725a996547$export$b0663eba150d60c9)(link.attributes)
            };
        });
        const attributes = (0, $ebedf3725a996547$export$b0663eba150d60c9)(options.attributes);
        // make sampling decision
        const samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = samplingResult.traceState ?? traceState;
        const traceFlags = samplingResult.decision === $4be02e1161967f43$export$94df7a7a96a92f7b.RECORD_AND_SAMPLED ? $974e5505212bea35$export$bf9049ad2b0883ff.SAMPLED : $974e5505212bea35$export$bf9049ad2b0883ff.NONE;
        const spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $4be02e1161967f43$export$94df7a7a96a92f7b.NOT_RECORD) {
            $83ffbea8f4ffb90a$export$c042e7c2f59bc046.debug('Recording is off, propagating context in a non-recording span');
            const nonRecordingSpan = $a1569335aa614ed8$export$357889f174732d38.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        const initAttributes = (0, $ebedf3725a996547$export$b0663eba150d60c9)(Object.assign(attributes, samplingResult.attributes));
        const span = new (0, $38fde56e89775176$export$7b15d0c2dba75760)({
            resource: this._resource,
            scope: this.instrumentationScope,
            context: context,
            spanContext: spanContext,
            name: name,
            kind: spanKind,
            links: links,
            parentSpanContext: validParentSpanContext,
            attributes: initAttributes,
            startTime: options.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits
        });
        return span;
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx ?? $e8248f70bfae46d0$export$a078c61943f9dbbe.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = $a1569335aa614ed8$export$357889f174732d38.setSpan(parentContext, span);
        return $e8248f70bfae46d0$export$a078c61943f9dbbe.with(contextWithSpanSet, fn, undefined, span);
    }
    /** Returns the active {@link GeneralLimits}. */ getGeneralLimits() {
        return this._generalLimits;
    }
    /** Returns the active {@link SpanLimits}. */ getSpanLimits() {
        return this._spanLimits;
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $050933715781aed5$export$3012fe5a49154394 {
    _spanProcessors;
    constructor(_spanProcessors){
        this._spanProcessors = _spanProcessors;
    }
    forceFlush() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.forceFlush());
        return new Promise((resolve)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }).catch((error)=>{
                (0, $f91d2054c9c9eae4$export$54c6946fc34b7cc2)(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    }
    onStart(span, context) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onStart(span, context);
    }
    onEnd(span) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onEnd(span);
    }
    shutdown() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.shutdown());
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }, reject);
        });
    }
}



var $710ba7bf983224dc$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($710ba7bf983224dc$export$11a85395fcf5a7f0 || ($710ba7bf983224dc$export$11a85395fcf5a7f0 = {}));
class $710ba7bf983224dc$export$1f2f0f67f5ecff3b {
    _config;
    _tracers = new Map();
    _resource;
    _activeSpanProcessor;
    constructor(config = {}){
        const mergedConfig = (0, $13d6a7eb020acf9f$export$4950aa0f605343fb)({}, (0, $9da0721ed781558b$export$d25a2c2f78a5e968)(), (0, $62df14f081748e93$export$9f9fb435f8494555)(config));
        this._resource = mergedConfig.resource ?? (0, $f5d296ad825fd0d7$export$522a862cad1b0abc)();
        this._config = Object.assign({}, mergedConfig, {
            resource: this._resource
        });
        const spanProcessors = [];
        if (config.spanProcessors?.length) spanProcessors.push(...config.spanProcessors);
        this._activeSpanProcessor = new (0, $050933715781aed5$export$3012fe5a49154394)(spanProcessors);
    }
    getTracer(name, version, options) {
        const key = `${name}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $16238f2d0abda630$export$c4b9363e2fc65361)({
            name: name,
            version: version,
            schemaUrl: options?.schemaUrl
        }, this._config, this._resource, this._activeSpanProcessor));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    }
    forceFlush() {
        const timeout = this._config.forceFlushTimeoutMillis;
        const promises = this._activeSpanProcessor['_spanProcessors'].map((spanProcessor)=>{
            return new Promise((resolve)=>{
                let state;
                const timeoutInterval = setTimeout(()=>{
                    resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                    state = $710ba7bf983224dc$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(()=>{
                    clearTimeout(timeoutInterval);
                    if (state !== $710ba7bf983224dc$export$11a85395fcf5a7f0.timeout) {
                        state = $710ba7bf983224dc$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch((error)=>{
                    clearTimeout(timeoutInterval);
                    state = $710ba7bf983224dc$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then((results)=>{
                const errors = results.filter((result)=>result !== $710ba7bf983224dc$export$11a85395fcf5a7f0.resolved);
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch((error)=>reject([
                    error
                ]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $b63f1664080b1a3e$export$3dfe62dd209faf13 {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Keeps the reference to current context
     */ _currentContext = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc), target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * Returns the active context
     */ active() {
        return this._currentContext;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears the current context)
     */ disable() {
        this._currentContext = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $76b3906e377ff08a$export$4beb26f46770357f {
    _propagators;
    _fields;
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ constructor(config = {}){
        this._propagators = config.propagators ?? [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map((p)=>typeof p.fields === 'function' ? p.fields() : []).reduce((x, y)=>x.concat(y), [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ inject(context, carrier, setter) {
        for (const propagator of this._propagators)try {
            propagator.inject(context, carrier, setter);
        } catch (err) {
            (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
        }
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ extract(context, carrier, getter) {
        return this._propagators.reduce((ctx, propagator)=>{
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
            }
            return ctx;
        }, context);
    }
    fields() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fbacfa4ef56ce949$export$3043215ef908d54f = '=';
const $fbacfa4ef56ce949$export$393a3f9e6e76438 = ';';
const $fbacfa4ef56ce949$export$1ab471785c2cf557 = ',';
const $fbacfa4ef56ce949$export$a6199dd4fe419e69 = 'baggage';
const $fbacfa4ef56ce949$export$9a50757016085e99 = 180;
const $fbacfa4ef56ce949$export$c7d9e39bb295c1f = 4096;
const $fbacfa4ef56ce949$export$dd0527bee1f518e7 = 8192;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

function $689905a4a385e271$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce((hValue, current)=>{
        const value = `${hValue}${hValue !== '' ? (0, $fbacfa4ef56ce949$export$1ab471785c2cf557) : ''}${current}`;
        return value.length > (0, $fbacfa4ef56ce949$export$dd0527bee1f518e7) ? hValue : value;
    }, '');
}
function $689905a4a385e271$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(([key, value])=>{
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value.value)}`;
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $fbacfa4ef56ce949$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $689905a4a385e271$export$62659c450b08e504(entry) {
    const valueProps = entry.split((0, $fbacfa4ef56ce949$export$393a3f9e6e76438));
    if (valueProps.length <= 0) return;
    const keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    const separatorIndex = keyPairPart.indexOf((0, $fbacfa4ef56ce949$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    const key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    const value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    let metadata;
    if (valueProps.length > 0) metadata = (0, $6435a4ae4b78a9aa$export$c491cedc1b2b6e9e)(valueProps.join((0, $fbacfa4ef56ce949$export$393a3f9e6e76438)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $689905a4a385e271$export$1259660ed6830e21(value) {
    const result = {};
    if (typeof value === 'string' && value.length > 0) value.split((0, $fbacfa4ef56ce949$export$1ab471785c2cf557)).forEach((entry)=>{
        const keyPair = $689905a4a385e271$export$62659c450b08e504(entry);
        if (keyPair !== undefined && keyPair.value.length > 0) result[keyPair.key] = keyPair.value;
    });
    return result;
}


class $e8cd774804f15da5$export$604bcc7f2bff6bb {
    inject(context, carrier, setter) {
        const baggage = (0, $c76b4b4057b01033$export$3e49040daa9dba20).getBaggage(context);
        if (!baggage || (0, $471a7169b32a4714$export$7d5f2376f7cf513)(context)) return;
        const keyPairs = (0, $689905a4a385e271$export$ed4c06f0919b1951)(baggage).filter((pair)=>{
            return pair.length <= (0, $fbacfa4ef56ce949$export$c7d9e39bb295c1f);
        }).slice(0, (0, $fbacfa4ef56ce949$export$9a50757016085e99));
        const headerValue = (0, $689905a4a385e271$export$790fc82b2ff5bf87)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $fbacfa4ef56ce949$export$a6199dd4fe419e69), headerValue);
    }
    extract(context, carrier, getter) {
        const headerValue = getter.get(carrier, (0, $fbacfa4ef56ce949$export$a6199dd4fe419e69));
        const baggageString = Array.isArray(headerValue) ? headerValue.join((0, $fbacfa4ef56ce949$export$1ab471785c2cf557)) : headerValue;
        if (!baggageString) return context;
        const baggage = {};
        if (baggageString.length === 0) return context;
        const pairs = baggageString.split((0, $fbacfa4ef56ce949$export$1ab471785c2cf557));
        pairs.forEach((entry)=>{
            const keyPair = (0, $689905a4a385e271$export$62659c450b08e504)(entry);
            if (keyPair) {
                const baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $c76b4b4057b01033$export$3e49040daa9dba20).setBaggage(context, (0, $c76b4b4057b01033$export$3e49040daa9dba20).createBaggage(baggage));
    }
    fields() {
        return [
            (0, $fbacfa4ef56ce949$export$a6199dd4fe419e69)
        ];
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $d1957f4cd46ea820$var$VALID_KEY = `[a-z]${$d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $d1957f4cd46ea820$var$VALID_VENDOR_KEY = `[a-z0-9]${$d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$d1957f4cd46ea820$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $d1957f4cd46ea820$var$VALID_KEY_REGEX = new RegExp(`^(?:${$d1957f4cd46ea820$var$VALID_KEY}|${$d1957f4cd46ea820$var$VALID_VENDOR_KEY})$`);
const $d1957f4cd46ea820$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $d1957f4cd46ea820$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $d1957f4cd46ea820$export$469cc9c479301ba6(key) {
    return $d1957f4cd46ea820$var$VALID_KEY_REGEX.test(key);
}
function $d1957f4cd46ea820$export$b76e9316566cc26e(value) {
    return $d1957f4cd46ea820$var$VALID_VALUE_BASE_REGEX.test(value) && !$d1957f4cd46ea820$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $94923c0d7cbee9c3$var$MAX_TRACE_STATE_ITEMS = 32;
const $94923c0d7cbee9c3$var$MAX_TRACE_STATE_LEN = 512;
const $94923c0d7cbee9c3$var$LIST_MEMBERS_SEPARATOR = ',';
const $94923c0d7cbee9c3$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $94923c0d7cbee9c3$export$b0addedc390b67c2 {
    _internalState = new Map();
    constructor(rawTraceState){
        if (rawTraceState) this._parse(rawTraceState);
    }
    set(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        const traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys().reduce((agg, key)=>{
            agg.push(key + $94923c0d7cbee9c3$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, []).join($94923c0d7cbee9c3$var$LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > $94923c0d7cbee9c3$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($94923c0d7cbee9c3$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce((agg, part)=>{
            const listMember = part.trim(); // Optional Whitespace (OWS) handling
            const i = listMember.indexOf($94923c0d7cbee9c3$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if ((0, $d1957f4cd46ea820$export$469cc9c479301ba6)(key) && (0, $d1957f4cd46ea820$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $94923c0d7cbee9c3$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $94923c0d7cbee9c3$var$MAX_TRACE_STATE_ITEMS));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new $94923c0d7cbee9c3$export$b0addedc390b67c2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}


const $053891bfb7ff6443$export$830e05fa2746348 = 'traceparent';
const $053891bfb7ff6443$export$2b12ed38dcfae2ae = 'tracestate';
const $053891bfb7ff6443$var$VERSION = '00';
const $053891bfb7ff6443$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $053891bfb7ff6443$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $053891bfb7ff6443$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $053891bfb7ff6443$var$FLAGS_PART = '[\\da-f]{2}';
const $053891bfb7ff6443$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$053891bfb7ff6443$var$VERSION_PART})-(${$053891bfb7ff6443$var$TRACE_ID_PART})-(${$053891bfb7ff6443$var$PARENT_ID_PART})-(${$053891bfb7ff6443$var$FLAGS_PART})(-.*)?\\s?$`);
function $053891bfb7ff6443$export$f4d87f8901a93f5d(traceParent) {
    const match = $053891bfb7ff6443$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $053891bfb7ff6443$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $a1569335aa614ed8$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $471a7169b32a4714$export$7d5f2376f7cf513)(context) || !(0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(spanContext)) return;
        const traceParent = `${$053891bfb7ff6443$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $974e5505212bea35$export$bf9049ad2b0883ff).NONE).toString(16)}`;
        setter.set(carrier, $053891bfb7ff6443$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $053891bfb7ff6443$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $053891bfb7ff6443$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $053891bfb7ff6443$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $053891bfb7ff6443$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $94923c0d7cbee9c3$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $a1569335aa614ed8$export$357889f174732d38).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $053891bfb7ff6443$export$830e05fa2746348,
            $053891bfb7ff6443$export$2b12ed38dcfae2ae
        ];
    }
}


function $bebde9d422ce0bc5$var$setupContextManager(contextManager) {
    // null means 'do not register'
    if (contextManager === null) return;
    // undefined means 'register default'
    if (contextManager === undefined) {
        const defaultContextManager = new (0, $b63f1664080b1a3e$export$3dfe62dd209faf13)();
        defaultContextManager.enable();
        (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).setGlobalContextManager(contextManager);
}
function $bebde9d422ce0bc5$var$setupPropagator(propagator) {
    // null means 'do not register'
    if (propagator === null) return;
    // undefined means 'register default'
    if (propagator === undefined) {
        (0, $c76b4b4057b01033$export$3e49040daa9dba20).setGlobalPropagator(new (0, $76b3906e377ff08a$export$4beb26f46770357f)({
            propagators: [
                new (0, $053891bfb7ff6443$export$737c747d043a1f7b)(),
                new (0, $e8cd774804f15da5$export$604bcc7f2bff6bb)()
            ]
        }));
        return;
    }
    (0, $c76b4b4057b01033$export$3e49040daa9dba20).setGlobalPropagator(propagator);
}
class $bebde9d422ce0bc5$export$a785009afeee3453 extends (0, $710ba7bf983224dc$export$1f2f0f67f5ecff3b) {
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ constructor(config = {}){
        super(config);
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ register(config = {}) {
        (0, $a1569335aa614ed8$export$357889f174732d38).setGlobalTracerProvider(this);
        $bebde9d422ce0bc5$var$setupPropagator(config.propagator);
        $bebde9d422ce0bc5$var$setupContextManager(config.contextManager);
    }
}




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
const $a28b402d42900208$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


const $05013fa1f9162463$export$be5e405504011951 = Symbol.for('io.opentelemetry.js.api.logs');
const $05013fa1f9162463$export$fb1208122242c205 = (0, $a28b402d42900208$export$5c524ddf7208c00c);
function $05013fa1f9162463$export$bf9e00ce1090794f(requiredVersion, instance, fallback) {
    return (version)=>version === requiredVersion ? instance : fallback;
}
const $05013fa1f9162463$export$41e8763f7160bb4 = 1;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9673c718054f4a12$export$d16ba98760c74dd5 {
    emit(_logRecord) {}
}
const $9673c718054f4a12$export$f5681b99b7ff4eb3 = new $9673c718054f4a12$export$d16ba98760c74dd5();


class $7c1cd101c067953c$export$8d7f6fb42e615208 {
    getLogger(_name, _version, _options) {
        return new (0, $9673c718054f4a12$export$d16ba98760c74dd5)();
    }
}
const $7c1cd101c067953c$export$ade97358fd6ba8df = new $7c1cd101c067953c$export$8d7f6fb42e615208();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $fd304e339819fa77$export$ed6b4cba4dd55d4b {
    constructor(_provider, name, version, options){
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
     * Emit a log record. This method should only be used by log appenders.
     *
     * @param logRecord
     */ emit(logRecord) {
        this._getLogger().emit(logRecord);
    }
    /**
     * Try to get a logger from the proxy logger provider.
     * If the proxy logger provider has no delegate, return a noop logger.
     */ _getLogger() {
        if (this._delegate) return this._delegate;
        const logger = this._provider.getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return 0, $9673c718054f4a12$export$f5681b99b7ff4eb3;
        this._delegate = logger;
        return this._delegate;
    }
}


class $a3c7d36eae4f51f3$export$f72276fc3bc2aaa4 {
    getLogger(name, version, options) {
        var _a;
        return (_a = this.getDelegateLogger(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $fd304e339819fa77$export$ed6b4cba4dd55d4b)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : (0, $7c1cd101c067953c$export$ade97358fd6ba8df);
    }
    /**
     * Set the delegate logger provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateLogger(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getLogger(name, version, options);
    }
}


class $5df2ce5aaebec81d$export$f8e63508eb6a0fc1 {
    constructor(){
        this._proxyLoggerProvider = new (0, $a3c7d36eae4f51f3$export$f72276fc3bc2aaa4)();
    }
    static getInstance() {
        if (!this._instance) this._instance = new $5df2ce5aaebec81d$export$f8e63508eb6a0fc1();
        return this._instance;
    }
    setGlobalLoggerProvider(provider) {
        if ((0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951]) return this.getLoggerProvider();
        (0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951] = (0, $05013fa1f9162463$export$bf9e00ce1090794f)((0, $05013fa1f9162463$export$41e8763f7160bb4), provider, (0, $7c1cd101c067953c$export$ade97358fd6ba8df));
        this._proxyLoggerProvider.setDelegate(provider);
        return provider;
    }
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ getLoggerProvider() {
        var _a, _b;
        return (_b = (_a = (0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951]) === null || _a === void 0 ? void 0 : _a.call((0, $05013fa1f9162463$export$fb1208122242c205), (0, $05013fa1f9162463$export$41e8763f7160bb4))) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    }
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ getLogger(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    }
    /** Remove the global logger provider */ disable() {
        delete (0, $05013fa1f9162463$export$fb1208122242c205)[0, $05013fa1f9162463$export$be5e405504011951];
        this._proxyLoggerProvider = new (0, $a3c7d36eae4f51f3$export$f72276fc3bc2aaa4)();
    }
}


const $4c324fea8a388f6e$export$fa0831f497706bad = (0, $5df2ce5aaebec81d$export$f8e63508eb6a0fc1).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ function $5979010bab2f60f6$export$56a6415128a54b1(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(let i = 0, j = instrumentations.length; i < j; i++){
        const instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $5979010bab2f60f6$export$c7d87b302116dc69(instrumentations) {
    instrumentations.forEach((instrumentation)=>instrumentation.disable());
}


function $2c0724552941680d$export$fc0a1ca5231d826a(options) {
    const tracerProvider = options.tracerProvider || (0, $a1569335aa614ed8$export$357889f174732d38).getTracerProvider();
    const meterProvider = options.meterProvider || (0, $33f59e57c604672a$export$b0c5c2fac8144e54).getMeterProvider();
    const loggerProvider = options.loggerProvider || (0, $4c324fea8a388f6e$export$fa0831f497706bad).getLoggerProvider();
    const instrumentations = options.instrumentations?.flat() ?? [];
    (0, $5979010bab2f60f6$export$56a6415128a54b1)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return ()=>{
        (0, $5979010bab2f60f6$export$c7d87b302116dc69)(instrumentations);
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $f5e92f458368ef7c$exports = {};
'use strict';
function $f5e92f458368ef7c$var$isFunction(funktion) {
    return typeof funktion === 'function';
}
// Default to complaining loudly when things don't go according to plan.
var $f5e92f458368ef7c$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $f5e92f458368ef7c$var$defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
// Keep initialization idempotent.
function $f5e92f458368ef7c$var$shimmer(options) {
    if (options && options.logger) {
        if (!$f5e92f458368ef7c$var$isFunction(options.logger)) $f5e92f458368ef7c$var$logger("new logger isn't a function, not replacing");
        else $f5e92f458368ef7c$var$logger = options.logger;
    }
}
function $f5e92f458368ef7c$var$wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        $f5e92f458368ef7c$var$logger('no original function ' + name + ' to wrap');
        return;
    }
    if (!wrapper) {
        $f5e92f458368ef7c$var$logger('no wrapper function');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    }
    if (!$f5e92f458368ef7c$var$isFunction(nodule[name]) || !$f5e92f458368ef7c$var$isFunction(wrapper)) {
        $f5e92f458368ef7c$var$logger('original object and wrapper must be functions');
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    $f5e92f458368ef7c$var$defineProperty(wrapped, '__original', original);
    $f5e92f458368ef7c$var$defineProperty(wrapped, '__unwrap', function() {
        if (nodule[name] === wrapped) $f5e92f458368ef7c$var$defineProperty(nodule, name, original);
    });
    $f5e92f458368ef7c$var$defineProperty(wrapped, '__wrapped', true);
    $f5e92f458368ef7c$var$defineProperty(nodule, name, wrapped);
    return wrapped;
}
function $f5e92f458368ef7c$var$massWrap(nodules, names, wrapper) {
    if (!nodules) {
        $f5e92f458368ef7c$var$logger('must provide one or more modules to patch');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $f5e92f458368ef7c$var$logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $f5e92f458368ef7c$var$wrap(nodule, name, wrapper);
        });
    });
}
function $f5e92f458368ef7c$var$unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        $f5e92f458368ef7c$var$logger('no function to unwrap.');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) $f5e92f458368ef7c$var$logger('no original to unwrap to -- has ' + name + ' already been unwrapped?');
    else return nodule[name].__unwrap();
}
function $f5e92f458368ef7c$var$massUnwrap(nodules, names) {
    if (!nodules) {
        $f5e92f458368ef7c$var$logger('must provide one or more modules to patch');
        $f5e92f458368ef7c$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $f5e92f458368ef7c$var$logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $f5e92f458368ef7c$var$unwrap(nodule, name);
        });
    });
}
$f5e92f458368ef7c$var$shimmer.wrap = $f5e92f458368ef7c$var$wrap;
$f5e92f458368ef7c$var$shimmer.massWrap = $f5e92f458368ef7c$var$massWrap;
$f5e92f458368ef7c$var$shimmer.unwrap = $f5e92f458368ef7c$var$unwrap;
$f5e92f458368ef7c$var$shimmer.massUnwrap = $f5e92f458368ef7c$var$massUnwrap;
$f5e92f458368ef7c$exports = $f5e92f458368ef7c$var$shimmer;


class $b92650621f404eb3$export$74c31cfd4e541b89 {
    instrumentationName;
    instrumentationVersion;
    _config = {};
    _tracer;
    _meter;
    _logger;
    _diag;
    constructor(instrumentationName, instrumentationVersion, config){
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this.setConfig(config);
        this._diag = (0, $83ffbea8f4ffb90a$export$c042e7c2f59bc046).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, $a1569335aa614ed8$export$357889f174732d38).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, $33f59e57c604672a$export$b0c5c2fac8144e54).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, $4c324fea8a388f6e$export$fa0831f497706bad).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Api to wrap instrumented method */ _wrap = $f5e92f458368ef7c$exports.wrap;
    /* Api to unwrap instrumented methods */ _unwrap = $f5e92f458368ef7c$exports.unwrap;
    /* Api to mass wrap instrumented method */ _massWrap = $f5e92f458368ef7c$exports.massWrap;
    /* Api to mass unwrap instrumented methods */ _massUnwrap = $f5e92f458368ef7c$exports.massUnwrap;
    /* Returns meter */ get meter() {
        return this._meter;
    }
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns logger */ get logger() {
        return this._logger;
    }
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ setLoggerProvider(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    }
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ getModuleDefinitions() {
        const initResult = this.init() ?? [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    }
    /**
     * Sets the new metric instruments with the current Meter.
     */ _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */ getConfig() {
        return this._config;
    }
    /**
     * Sets InstrumentationConfig to this plugin
     * @param config
     */ setConfig(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = {
            enabled: true,
            ...config
        };
    }
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */ get tracer() {
        return this._tracer;
    }
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error(`Error running span customization hook due to exception in handler`, {
                triggerName: triggerName
            }, e);
        }
    }
}


class $be89eb9a2ed8d8a6$export$436b1c2bf7e9756b extends (0, $b92650621f404eb3$export$74c31cfd4e541b89) {
    constructor(instrumentationName, instrumentationVersion, config){
        super(instrumentationName, instrumentationVersion, config);
        if (this._config.enabled) this.enable();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ function $e5045196367e2654$export$fdff7e10f8ca069e(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
async function $e5045196367e2654$export$75852fe3c08f1502(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = await execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function $e5045196367e2654$export$ec0fd572751979bc(func) {
    return typeof func === 'function' && typeof func.__original === 'function' && typeof func.__unwrap === 'function' && func.__wrapped === true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
const $cf2085415f7cd9be$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a5b2d9a21101d5ac$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $a5b2d9a21101d5ac$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($a5b2d9a21101d5ac$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $07a8fc58179c2fd8$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($07a8fc58179c2fd8$export$74be52df2d6fd28c || ($07a8fc58179c2fd8$export$74be52df2d6fd28c = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */ /*#__NO_SIDE_EFFECTS__*/ function $af8983c0f76bcdfa$export$8796db7ca257d576(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    let res = {};
    const len = values.length;
    for(let lp = 0; lp < len; lp++){
        const val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
    }
    return res;
}


//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_AWS_LAMBDA_INVOKED_ARN = 'aws.lambda.invoked_arn';
const $6feacf3bb3931a8f$var$TMP_DB_SYSTEM = 'db.system';
const $6feacf3bb3931a8f$var$TMP_DB_CONNECTION_STRING = 'db.connection_string';
const $6feacf3bb3931a8f$var$TMP_DB_USER = 'db.user';
const $6feacf3bb3931a8f$var$TMP_DB_JDBC_DRIVER_CLASSNAME = 'db.jdbc.driver_classname';
const $6feacf3bb3931a8f$var$TMP_DB_NAME = 'db.name';
const $6feacf3bb3931a8f$var$TMP_DB_STATEMENT = 'db.statement';
const $6feacf3bb3931a8f$var$TMP_DB_OPERATION = 'db.operation';
const $6feacf3bb3931a8f$var$TMP_DB_MSSQL_INSTANCE_NAME = 'db.mssql.instance_name';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_KEYSPACE = 'db.cassandra.keyspace';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_PAGE_SIZE = 'db.cassandra.page_size';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = 'db.cassandra.consistency_level';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_TABLE = 'db.cassandra.table';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_IDEMPOTENCE = 'db.cassandra.idempotence';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = 'db.cassandra.speculative_execution_count';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_ID = 'db.cassandra.coordinator.id';
const $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_DC = 'db.cassandra.coordinator.dc';
const $6feacf3bb3931a8f$var$TMP_DB_HBASE_NAMESPACE = 'db.hbase.namespace';
const $6feacf3bb3931a8f$var$TMP_DB_REDIS_DATABASE_INDEX = 'db.redis.database_index';
const $6feacf3bb3931a8f$var$TMP_DB_MONGODB_COLLECTION = 'db.mongodb.collection';
const $6feacf3bb3931a8f$var$TMP_DB_SQL_TABLE = 'db.sql.table';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_TYPE = 'exception.type';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_MESSAGE = 'exception.message';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_STACKTRACE = 'exception.stacktrace';
const $6feacf3bb3931a8f$var$TMP_EXCEPTION_ESCAPED = 'exception.escaped';
const $6feacf3bb3931a8f$var$TMP_FAAS_TRIGGER = 'faas.trigger';
const $6feacf3bb3931a8f$var$TMP_FAAS_EXECUTION = 'faas.execution';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_COLLECTION = 'faas.document.collection';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_OPERATION = 'faas.document.operation';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_TIME = 'faas.document.time';
const $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_NAME = 'faas.document.name';
const $6feacf3bb3931a8f$var$TMP_FAAS_TIME = 'faas.time';
const $6feacf3bb3931a8f$var$TMP_FAAS_CRON = 'faas.cron';
const $6feacf3bb3931a8f$var$TMP_FAAS_COLDSTART = 'faas.coldstart';
const $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_NAME = 'faas.invoked_name';
const $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_PROVIDER = 'faas.invoked_provider';
const $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_REGION = 'faas.invoked_region';
const $6feacf3bb3931a8f$var$TMP_NET_TRANSPORT = 'net.transport';
const $6feacf3bb3931a8f$var$TMP_NET_PEER_IP = 'net.peer.ip';
const $6feacf3bb3931a8f$var$TMP_NET_PEER_PORT = 'net.peer.port';
const $6feacf3bb3931a8f$var$TMP_NET_PEER_NAME = 'net.peer.name';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_IP = 'net.host.ip';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_PORT = 'net.host.port';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_NAME = 'net.host.name';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_TYPE = 'net.host.connection.type';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_SUBTYPE = 'net.host.connection.subtype';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_NAME = 'net.host.carrier.name';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MCC = 'net.host.carrier.mcc';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MNC = 'net.host.carrier.mnc';
const $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_ICC = 'net.host.carrier.icc';
const $6feacf3bb3931a8f$var$TMP_PEER_SERVICE = 'peer.service';
const $6feacf3bb3931a8f$var$TMP_ENDUSER_ID = 'enduser.id';
const $6feacf3bb3931a8f$var$TMP_ENDUSER_ROLE = 'enduser.role';
const $6feacf3bb3931a8f$var$TMP_ENDUSER_SCOPE = 'enduser.scope';
const $6feacf3bb3931a8f$var$TMP_THREAD_ID = 'thread.id';
const $6feacf3bb3931a8f$var$TMP_THREAD_NAME = 'thread.name';
const $6feacf3bb3931a8f$var$TMP_CODE_FUNCTION = 'code.function';
const $6feacf3bb3931a8f$var$TMP_CODE_NAMESPACE = 'code.namespace';
const $6feacf3bb3931a8f$var$TMP_CODE_FILEPATH = 'code.filepath';
const $6feacf3bb3931a8f$var$TMP_CODE_LINENO = 'code.lineno';
const $6feacf3bb3931a8f$var$TMP_HTTP_METHOD = 'http.method';
const $6feacf3bb3931a8f$var$TMP_HTTP_URL = 'http.url';
const $6feacf3bb3931a8f$var$TMP_HTTP_TARGET = 'http.target';
const $6feacf3bb3931a8f$var$TMP_HTTP_HOST = 'http.host';
const $6feacf3bb3931a8f$var$TMP_HTTP_SCHEME = 'http.scheme';
const $6feacf3bb3931a8f$var$TMP_HTTP_STATUS_CODE = 'http.status_code';
const $6feacf3bb3931a8f$var$TMP_HTTP_FLAVOR = 'http.flavor';
const $6feacf3bb3931a8f$var$TMP_HTTP_USER_AGENT = 'http.user_agent';
const $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH = 'http.request_content_length';
const $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = 'http.request_content_length_uncompressed';
const $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH = 'http.response_content_length';
const $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = 'http.response_content_length_uncompressed';
const $6feacf3bb3931a8f$var$TMP_HTTP_SERVER_NAME = 'http.server_name';
const $6feacf3bb3931a8f$var$TMP_HTTP_ROUTE = 'http.route';
const $6feacf3bb3931a8f$var$TMP_HTTP_CLIENT_IP = 'http.client_ip';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_NAMES = 'aws.dynamodb.table_names';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = 'aws.dynamodb.consumed_capacity';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = 'aws.dynamodb.item_collection_metrics';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = 'aws.dynamodb.provisioned_read_capacity';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = 'aws.dynamodb.provisioned_write_capacity';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSISTENT_READ = 'aws.dynamodb.consistent_read';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROJECTION = 'aws.dynamodb.projection';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LIMIT = 'aws.dynamodb.limit';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = 'aws.dynamodb.attributes_to_get';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_INDEX_NAME = 'aws.dynamodb.index_name';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SELECT = 'aws.dynamodb.select';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = 'aws.dynamodb.global_secondary_indexes';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = 'aws.dynamodb.local_secondary_indexes';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = 'aws.dynamodb.exclusive_start_table';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_COUNT = 'aws.dynamodb.table_count';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCAN_FORWARD = 'aws.dynamodb.scan_forward';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SEGMENT = 'aws.dynamodb.segment';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = 'aws.dynamodb.total_segments';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_COUNT = 'aws.dynamodb.count';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCANNED_COUNT = 'aws.dynamodb.scanned_count';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = 'aws.dynamodb.attribute_definitions';
const $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = 'aws.dynamodb.global_secondary_index_updates';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_SYSTEM = 'messaging.system';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION = 'messaging.destination';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION_KIND = 'messaging.destination_kind';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_TEMP_DESTINATION = 'messaging.temp_destination';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL = 'messaging.protocol';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL_VERSION = 'messaging.protocol_version';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_URL = 'messaging.url';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_ID = 'messaging.message_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_CONVERSATION_ID = 'messaging.conversation_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = 'messaging.message_payload_size_bytes';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = 'messaging.message_payload_compressed_size_bytes';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_OPERATION = 'messaging.operation';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_CONSUMER_ID = 'messaging.consumer_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY = 'messaging.rabbitmq.routing_key';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY = 'messaging.kafka.message_key';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP = 'messaging.kafka.consumer_group';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CLIENT_ID = 'messaging.kafka.client_id';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_PARTITION = 'messaging.kafka.partition';
const $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_TOMBSTONE = 'messaging.kafka.tombstone';
const $6feacf3bb3931a8f$var$TMP_RPC_SYSTEM = 'rpc.system';
const $6feacf3bb3931a8f$var$TMP_RPC_SERVICE = 'rpc.service';
const $6feacf3bb3931a8f$var$TMP_RPC_METHOD = 'rpc.method';
const $6feacf3bb3931a8f$var$TMP_RPC_GRPC_STATUS_CODE = 'rpc.grpc.status_code';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_VERSION = 'rpc.jsonrpc.version';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_REQUEST_ID = 'rpc.jsonrpc.request_id';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_CODE = 'rpc.jsonrpc.error_code';
const $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_MESSAGE = 'rpc.jsonrpc.error_message';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_TYPE = 'message.type';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_ID = 'message.id';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_COMPRESSED_SIZE = 'message.compressed_size';
const $6feacf3bb3931a8f$var$TMP_MESSAGE_UNCOMPRESSED_SIZE = 'message.uncompressed_size';
const $6feacf3bb3931a8f$export$170bb395abfdb74 = $6feacf3bb3931a8f$var$TMP_AWS_LAMBDA_INVOKED_ARN;
const $6feacf3bb3931a8f$export$4d8f9683caa766fd = $6feacf3bb3931a8f$var$TMP_DB_SYSTEM;
const $6feacf3bb3931a8f$export$d367aaf68e61a0d5 = $6feacf3bb3931a8f$var$TMP_DB_CONNECTION_STRING;
const $6feacf3bb3931a8f$export$310240ea93b3fe22 = $6feacf3bb3931a8f$var$TMP_DB_USER;
const $6feacf3bb3931a8f$export$aa8b483f52799ba9 = $6feacf3bb3931a8f$var$TMP_DB_JDBC_DRIVER_CLASSNAME;
const $6feacf3bb3931a8f$export$d1ee0266d0ce708f = $6feacf3bb3931a8f$var$TMP_DB_NAME;
const $6feacf3bb3931a8f$export$ce244300665216c6 = $6feacf3bb3931a8f$var$TMP_DB_STATEMENT;
const $6feacf3bb3931a8f$export$dfb6a782675c717b = $6feacf3bb3931a8f$var$TMP_DB_OPERATION;
const $6feacf3bb3931a8f$export$ce5040faeb6d8f08 = $6feacf3bb3931a8f$var$TMP_DB_MSSQL_INSTANCE_NAME;
const $6feacf3bb3931a8f$export$e241e7101e6d4783 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_KEYSPACE;
const $6feacf3bb3931a8f$export$8823a63ac409681b = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_PAGE_SIZE;
const $6feacf3bb3931a8f$export$b838c3d1859a7260 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
const $6feacf3bb3931a8f$export$3f3068d83ae4cca5 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_TABLE;
const $6feacf3bb3931a8f$export$17334025dcb96205 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_IDEMPOTENCE;
const $6feacf3bb3931a8f$export$a63f22381e3297f2 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
const $6feacf3bb3931a8f$export$e06ccece5268ed3 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_ID;
const $6feacf3bb3931a8f$export$ab77f08d0cc7144 = $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_DC;
const $6feacf3bb3931a8f$export$f83bf50700108cdb = $6feacf3bb3931a8f$var$TMP_DB_HBASE_NAMESPACE;
const $6feacf3bb3931a8f$export$f9c9b189f60bce02 = $6feacf3bb3931a8f$var$TMP_DB_REDIS_DATABASE_INDEX;
const $6feacf3bb3931a8f$export$b73e684c351bf304 = $6feacf3bb3931a8f$var$TMP_DB_MONGODB_COLLECTION;
const $6feacf3bb3931a8f$export$5b02e077c84b0dc7 = $6feacf3bb3931a8f$var$TMP_DB_SQL_TABLE;
const $6feacf3bb3931a8f$export$ecc84ea0f5a24384 = $6feacf3bb3931a8f$var$TMP_EXCEPTION_TYPE;
const $6feacf3bb3931a8f$export$ff69507dfa9dcf0c = $6feacf3bb3931a8f$var$TMP_EXCEPTION_MESSAGE;
const $6feacf3bb3931a8f$export$d9432f0c350b687d = $6feacf3bb3931a8f$var$TMP_EXCEPTION_STACKTRACE;
const $6feacf3bb3931a8f$export$4d3c212dd7c75f9d = $6feacf3bb3931a8f$var$TMP_EXCEPTION_ESCAPED;
const $6feacf3bb3931a8f$export$7e853a3dbd95b3a2 = $6feacf3bb3931a8f$var$TMP_FAAS_TRIGGER;
const $6feacf3bb3931a8f$export$68a5b08142e33c1d = $6feacf3bb3931a8f$var$TMP_FAAS_EXECUTION;
const $6feacf3bb3931a8f$export$f4b6288b42b8d4f8 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_COLLECTION;
const $6feacf3bb3931a8f$export$7e6d28b35ab8e751 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_OPERATION;
const $6feacf3bb3931a8f$export$b36094664197ebd9 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_TIME;
const $6feacf3bb3931a8f$export$2401d669e1b7f304 = $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_NAME;
const $6feacf3bb3931a8f$export$4630b1edb758007c = $6feacf3bb3931a8f$var$TMP_FAAS_TIME;
const $6feacf3bb3931a8f$export$4358b4189d5aa75e = $6feacf3bb3931a8f$var$TMP_FAAS_CRON;
const $6feacf3bb3931a8f$export$18a88fa49bf141a8 = $6feacf3bb3931a8f$var$TMP_FAAS_COLDSTART;
const $6feacf3bb3931a8f$export$ba620de28d483834 = $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_NAME;
const $6feacf3bb3931a8f$export$1ac1158b40ce77df = $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_PROVIDER;
const $6feacf3bb3931a8f$export$e8b3f54186b03f93 = $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_REGION;
const $6feacf3bb3931a8f$export$958ce88767ff5cae = $6feacf3bb3931a8f$var$TMP_NET_TRANSPORT;
const $6feacf3bb3931a8f$export$5f5e19d7784bcab5 = $6feacf3bb3931a8f$var$TMP_NET_PEER_IP;
const $6feacf3bb3931a8f$export$83ab392b303d5cc4 = $6feacf3bb3931a8f$var$TMP_NET_PEER_PORT;
const $6feacf3bb3931a8f$export$869dc6e245da8a3c = $6feacf3bb3931a8f$var$TMP_NET_PEER_NAME;
const $6feacf3bb3931a8f$export$8363f5dd3626d1c7 = $6feacf3bb3931a8f$var$TMP_NET_HOST_IP;
const $6feacf3bb3931a8f$export$7c05177443136588 = $6feacf3bb3931a8f$var$TMP_NET_HOST_PORT;
const $6feacf3bb3931a8f$export$67ebd91e5927c9b6 = $6feacf3bb3931a8f$var$TMP_NET_HOST_NAME;
const $6feacf3bb3931a8f$export$b4399aff72c58221 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_TYPE;
const $6feacf3bb3931a8f$export$29124138bf62c161 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_SUBTYPE;
const $6feacf3bb3931a8f$export$a1a35234333f42fa = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_NAME;
const $6feacf3bb3931a8f$export$593e7f806b5bd9d0 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MCC;
const $6feacf3bb3931a8f$export$92c4882b0877ce0 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MNC;
const $6feacf3bb3931a8f$export$7158946157fdda52 = $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_ICC;
const $6feacf3bb3931a8f$export$706484bff197aa2f = $6feacf3bb3931a8f$var$TMP_PEER_SERVICE;
const $6feacf3bb3931a8f$export$37fdcbb3cc34507a = $6feacf3bb3931a8f$var$TMP_ENDUSER_ID;
const $6feacf3bb3931a8f$export$7486a34c0c780913 = $6feacf3bb3931a8f$var$TMP_ENDUSER_ROLE;
const $6feacf3bb3931a8f$export$c531f20a7a107be = $6feacf3bb3931a8f$var$TMP_ENDUSER_SCOPE;
const $6feacf3bb3931a8f$export$96304c684b1fe5bd = $6feacf3bb3931a8f$var$TMP_THREAD_ID;
const $6feacf3bb3931a8f$export$b1c76a722c30a73e = $6feacf3bb3931a8f$var$TMP_THREAD_NAME;
const $6feacf3bb3931a8f$export$f5b0a970f81eb82 = $6feacf3bb3931a8f$var$TMP_CODE_FUNCTION;
const $6feacf3bb3931a8f$export$ebd9bc6b684ae79f = $6feacf3bb3931a8f$var$TMP_CODE_NAMESPACE;
const $6feacf3bb3931a8f$export$f5c7dbf024e089b1 = $6feacf3bb3931a8f$var$TMP_CODE_FILEPATH;
const $6feacf3bb3931a8f$export$9bc82da636767e36 = $6feacf3bb3931a8f$var$TMP_CODE_LINENO;
const $6feacf3bb3931a8f$export$5ec7d06d671a3fbe = $6feacf3bb3931a8f$var$TMP_HTTP_METHOD;
const $6feacf3bb3931a8f$export$2f4ef7e39c2be395 = $6feacf3bb3931a8f$var$TMP_HTTP_URL;
const $6feacf3bb3931a8f$export$5284fc3356124326 = $6feacf3bb3931a8f$var$TMP_HTTP_TARGET;
const $6feacf3bb3931a8f$export$547e24d3f59a53ea = $6feacf3bb3931a8f$var$TMP_HTTP_HOST;
const $6feacf3bb3931a8f$export$a2928efa45f0acf4 = $6feacf3bb3931a8f$var$TMP_HTTP_SCHEME;
const $6feacf3bb3931a8f$export$d381c7525d715413 = $6feacf3bb3931a8f$var$TMP_HTTP_STATUS_CODE;
const $6feacf3bb3931a8f$export$1e443919b8f6a42e = $6feacf3bb3931a8f$var$TMP_HTTP_FLAVOR;
const $6feacf3bb3931a8f$export$7472b18f42d2d02f = $6feacf3bb3931a8f$var$TMP_HTTP_USER_AGENT;
const $6feacf3bb3931a8f$export$616f2909238995e9 = $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH;
const $6feacf3bb3931a8f$export$4352992cf528a286 = $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
const $6feacf3bb3931a8f$export$58d4fbfe35e08be0 = $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH;
const $6feacf3bb3931a8f$export$b9d3e41cd56c56cc = $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
const $6feacf3bb3931a8f$export$ae4c9cf5cd38f75e = $6feacf3bb3931a8f$var$TMP_HTTP_SERVER_NAME;
const $6feacf3bb3931a8f$export$391e30d1bcbfedd6 = $6feacf3bb3931a8f$var$TMP_HTTP_ROUTE;
const $6feacf3bb3931a8f$export$f21601c3f29048e9 = $6feacf3bb3931a8f$var$TMP_HTTP_CLIENT_IP;
const $6feacf3bb3931a8f$export$22c9c5cd37ccec8d = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_NAMES;
const $6feacf3bb3931a8f$export$636d932d69359471 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
const $6feacf3bb3931a8f$export$79414a2a1b36e0e4 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
const $6feacf3bb3931a8f$export$a17bc449a5f10183 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
const $6feacf3bb3931a8f$export$6d8e225848319009 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
const $6feacf3bb3931a8f$export$2daa7ca667f19522 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSISTENT_READ;
const $6feacf3bb3931a8f$export$d04f1e16b6682958 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROJECTION;
const $6feacf3bb3931a8f$export$9017e26d3dee82a7 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LIMIT;
const $6feacf3bb3931a8f$export$734476f2cddb4e = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
const $6feacf3bb3931a8f$export$6ffa6129be32f13f = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_INDEX_NAME;
const $6feacf3bb3931a8f$export$e439ba599235e943 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SELECT;
const $6feacf3bb3931a8f$export$691e052bf6ec1b50 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
const $6feacf3bb3931a8f$export$4a8114ba4973adf9 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
const $6feacf3bb3931a8f$export$3d3dcdb04b37b602 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
const $6feacf3bb3931a8f$export$a3ed03c10bfca049 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_COUNT;
const $6feacf3bb3931a8f$export$70f2263412a5d6f8 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCAN_FORWARD;
const $6feacf3bb3931a8f$export$cc291bca867c839c = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SEGMENT;
const $6feacf3bb3931a8f$export$2bd41520dd577767 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
const $6feacf3bb3931a8f$export$e3002f59defbb848 = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_COUNT;
const $6feacf3bb3931a8f$export$338ee58c976503fa = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCANNED_COUNT;
const $6feacf3bb3931a8f$export$9ef2d520d3111ebb = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
const $6feacf3bb3931a8f$export$50eb8413f579535b = $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
const $6feacf3bb3931a8f$export$e907440d5c8aa7ea = $6feacf3bb3931a8f$var$TMP_MESSAGING_SYSTEM;
const $6feacf3bb3931a8f$export$331bf1abb96af02c = $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION;
const $6feacf3bb3931a8f$export$ca3944a0a0fdb278 = $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION_KIND;
const $6feacf3bb3931a8f$export$b1f595d071164a5c = $6feacf3bb3931a8f$var$TMP_MESSAGING_TEMP_DESTINATION;
const $6feacf3bb3931a8f$export$734e634f7ff28b65 = $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL;
const $6feacf3bb3931a8f$export$62c96eec39d4f8fa = $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL_VERSION;
const $6feacf3bb3931a8f$export$8185788dec47d17c = $6feacf3bb3931a8f$var$TMP_MESSAGING_URL;
const $6feacf3bb3931a8f$export$6465ca78c6aedebd = $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_ID;
const $6feacf3bb3931a8f$export$9e29dbd41c4d02d5 = $6feacf3bb3931a8f$var$TMP_MESSAGING_CONVERSATION_ID;
const $6feacf3bb3931a8f$export$ded3a3185a1522d5 = $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
const $6feacf3bb3931a8f$export$c42edeca94088e4d = $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
const $6feacf3bb3931a8f$export$b0a29003262c7994 = $6feacf3bb3931a8f$var$TMP_MESSAGING_OPERATION;
const $6feacf3bb3931a8f$export$283c55d09fbdb92c = $6feacf3bb3931a8f$var$TMP_MESSAGING_CONSUMER_ID;
const $6feacf3bb3931a8f$export$78385ca43d0e8556 = $6feacf3bb3931a8f$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
const $6feacf3bb3931a8f$export$b6969aab3cf94e74 = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY;
const $6feacf3bb3931a8f$export$45eb738152aa5dd4 = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
const $6feacf3bb3931a8f$export$bc66f788b071fbad = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CLIENT_ID;
const $6feacf3bb3931a8f$export$ff4aad497ab5213e = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_PARTITION;
const $6feacf3bb3931a8f$export$256d25d7635b3a79 = $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_TOMBSTONE;
const $6feacf3bb3931a8f$export$8b1a1f43d7106aea = $6feacf3bb3931a8f$var$TMP_RPC_SYSTEM;
const $6feacf3bb3931a8f$export$7eb60929eaa797de = $6feacf3bb3931a8f$var$TMP_RPC_SERVICE;
const $6feacf3bb3931a8f$export$c6d175d5e9b8105b = $6feacf3bb3931a8f$var$TMP_RPC_METHOD;
const $6feacf3bb3931a8f$export$ccc8405c8a911fb7 = $6feacf3bb3931a8f$var$TMP_RPC_GRPC_STATUS_CODE;
const $6feacf3bb3931a8f$export$ce0f2ec42ba79570 = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_VERSION;
const $6feacf3bb3931a8f$export$2e981273bb2873ea = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_REQUEST_ID;
const $6feacf3bb3931a8f$export$214058615970c3e4 = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_CODE;
const $6feacf3bb3931a8f$export$2ad4f2a86baa9b1e = $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_MESSAGE;
const $6feacf3bb3931a8f$export$e6c57355a990f7ee = $6feacf3bb3931a8f$var$TMP_MESSAGE_TYPE;
const $6feacf3bb3931a8f$export$ba8e66ad5476d59f = $6feacf3bb3931a8f$var$TMP_MESSAGE_ID;
const $6feacf3bb3931a8f$export$16f3d59837418b1f = $6feacf3bb3931a8f$var$TMP_MESSAGE_COMPRESSED_SIZE;
const $6feacf3bb3931a8f$export$4b889081ab98b61 = $6feacf3bb3931a8f$var$TMP_MESSAGE_UNCOMPRESSED_SIZE;
const $6feacf3bb3931a8f$export$949e366c5c69d2e9 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_AWS_LAMBDA_INVOKED_ARN,
    $6feacf3bb3931a8f$var$TMP_DB_SYSTEM,
    $6feacf3bb3931a8f$var$TMP_DB_CONNECTION_STRING,
    $6feacf3bb3931a8f$var$TMP_DB_USER,
    $6feacf3bb3931a8f$var$TMP_DB_JDBC_DRIVER_CLASSNAME,
    $6feacf3bb3931a8f$var$TMP_DB_NAME,
    $6feacf3bb3931a8f$var$TMP_DB_STATEMENT,
    $6feacf3bb3931a8f$var$TMP_DB_OPERATION,
    $6feacf3bb3931a8f$var$TMP_DB_MSSQL_INSTANCE_NAME,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_KEYSPACE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_PAGE_SIZE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_TABLE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_IDEMPOTENCE,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_ID,
    $6feacf3bb3931a8f$var$TMP_DB_CASSANDRA_COORDINATOR_DC,
    $6feacf3bb3931a8f$var$TMP_DB_HBASE_NAMESPACE,
    $6feacf3bb3931a8f$var$TMP_DB_REDIS_DATABASE_INDEX,
    $6feacf3bb3931a8f$var$TMP_DB_MONGODB_COLLECTION,
    $6feacf3bb3931a8f$var$TMP_DB_SQL_TABLE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_TYPE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_MESSAGE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_STACKTRACE,
    $6feacf3bb3931a8f$var$TMP_EXCEPTION_ESCAPED,
    $6feacf3bb3931a8f$var$TMP_FAAS_TRIGGER,
    $6feacf3bb3931a8f$var$TMP_FAAS_EXECUTION,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_COLLECTION,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_OPERATION,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_TIME,
    $6feacf3bb3931a8f$var$TMP_FAAS_DOCUMENT_NAME,
    $6feacf3bb3931a8f$var$TMP_FAAS_TIME,
    $6feacf3bb3931a8f$var$TMP_FAAS_CRON,
    $6feacf3bb3931a8f$var$TMP_FAAS_COLDSTART,
    $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_NAME,
    $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_PROVIDER,
    $6feacf3bb3931a8f$var$TMP_FAAS_INVOKED_REGION,
    $6feacf3bb3931a8f$var$TMP_NET_TRANSPORT,
    $6feacf3bb3931a8f$var$TMP_NET_PEER_IP,
    $6feacf3bb3931a8f$var$TMP_NET_PEER_PORT,
    $6feacf3bb3931a8f$var$TMP_NET_PEER_NAME,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_IP,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_PORT,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_NAME,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_TYPE,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CONNECTION_SUBTYPE,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_NAME,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MCC,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_MNC,
    $6feacf3bb3931a8f$var$TMP_NET_HOST_CARRIER_ICC,
    $6feacf3bb3931a8f$var$TMP_PEER_SERVICE,
    $6feacf3bb3931a8f$var$TMP_ENDUSER_ID,
    $6feacf3bb3931a8f$var$TMP_ENDUSER_ROLE,
    $6feacf3bb3931a8f$var$TMP_ENDUSER_SCOPE,
    $6feacf3bb3931a8f$var$TMP_THREAD_ID,
    $6feacf3bb3931a8f$var$TMP_THREAD_NAME,
    $6feacf3bb3931a8f$var$TMP_CODE_FUNCTION,
    $6feacf3bb3931a8f$var$TMP_CODE_NAMESPACE,
    $6feacf3bb3931a8f$var$TMP_CODE_FILEPATH,
    $6feacf3bb3931a8f$var$TMP_CODE_LINENO,
    $6feacf3bb3931a8f$var$TMP_HTTP_METHOD,
    $6feacf3bb3931a8f$var$TMP_HTTP_URL,
    $6feacf3bb3931a8f$var$TMP_HTTP_TARGET,
    $6feacf3bb3931a8f$var$TMP_HTTP_HOST,
    $6feacf3bb3931a8f$var$TMP_HTTP_SCHEME,
    $6feacf3bb3931a8f$var$TMP_HTTP_STATUS_CODE,
    $6feacf3bb3931a8f$var$TMP_HTTP_FLAVOR,
    $6feacf3bb3931a8f$var$TMP_HTTP_USER_AGENT,
    $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH,
    $6feacf3bb3931a8f$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    $6feacf3bb3931a8f$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    $6feacf3bb3931a8f$var$TMP_HTTP_SERVER_NAME,
    $6feacf3bb3931a8f$var$TMP_HTTP_ROUTE,
    $6feacf3bb3931a8f$var$TMP_HTTP_CLIENT_IP,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_NAMES,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_CONSISTENT_READ,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_PROJECTION,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LIMIT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_INDEX_NAME,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SELECT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TABLE_COUNT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCAN_FORWARD,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SEGMENT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_COUNT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_SCANNED_COUNT,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    $6feacf3bb3931a8f$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_SYSTEM,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_DESTINATION_KIND,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_TEMP_DESTINATION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_PROTOCOL_VERSION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_URL,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_CONVERSATION_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_OPERATION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_CONSUMER_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_CLIENT_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_PARTITION,
    $6feacf3bb3931a8f$var$TMP_MESSAGING_KAFKA_TOMBSTONE,
    $6feacf3bb3931a8f$var$TMP_RPC_SYSTEM,
    $6feacf3bb3931a8f$var$TMP_RPC_SERVICE,
    $6feacf3bb3931a8f$var$TMP_RPC_METHOD,
    $6feacf3bb3931a8f$var$TMP_RPC_GRPC_STATUS_CODE,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_VERSION,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_REQUEST_ID,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_CODE,
    $6feacf3bb3931a8f$var$TMP_RPC_JSONRPC_ERROR_MESSAGE,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_TYPE,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_ID,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_COMPRESSED_SIZE,
    $6feacf3bb3931a8f$var$TMP_MESSAGE_UNCOMPRESSED_SIZE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbSystemValues enum definition
 *
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_OTHER_SQL = 'other_sql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MSSQL = 'mssql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MYSQL = 'mysql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ORACLE = 'oracle';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DB2 = 'db2';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POSTGRESQL = 'postgresql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDSHIFT = 'redshift';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HIVE = 'hive';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE = 'cloudscape';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HSQLDB = 'hsqldb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PROGRESS = 'progress';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MAXDB = 'maxdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HANADB = 'hanadb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INGRES = 'ingres';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIRSTSQL = 'firstsql';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_EDB = 'edb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CACHE = 'cache';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ADABAS = 'adabas';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIREBIRD = 'firebird';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DERBY = 'derby';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FILEMAKER = 'filemaker';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INFORMIX = 'informix';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INSTANTDB = 'instantdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INTERBASE = 'interbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MARIADB = 'mariadb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NETEZZA = 'netezza';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PERVASIVE = 'pervasive';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POINTBASE = 'pointbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SQLITE = 'sqlite';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SYBASE = 'sybase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_TERADATA = 'teradata';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_VERTICA = 'vertica';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_H2 = 'h2';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COLDFUSION = 'coldfusion';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CASSANDRA = 'cassandra';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HBASE = 'hbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MONGODB = 'mongodb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDIS = 'redis';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHBASE = 'couchbase';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHDB = 'couchdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COSMOSDB = 'cosmosdb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DYNAMODB = 'dynamodb';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NEO4J = 'neo4j';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_GEODE = 'geode';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH = 'elasticsearch';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MEMCACHED = 'memcached';
const $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COCKROACHDB = 'cockroachdb';
const $6feacf3bb3931a8f$export$a8dac6c506518069 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_OTHER_SQL;
const $6feacf3bb3931a8f$export$ea0447329a58abf0 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MSSQL;
const $6feacf3bb3931a8f$export$f10ddff4d378463e = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MYSQL;
const $6feacf3bb3931a8f$export$1187a6d6f356ed08 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ORACLE;
const $6feacf3bb3931a8f$export$c99652dcdf96b994 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DB2;
const $6feacf3bb3931a8f$export$fa83a16930a97d3b = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POSTGRESQL;
const $6feacf3bb3931a8f$export$502f4a0041906d71 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDSHIFT;
const $6feacf3bb3931a8f$export$9ca2599ef62580aa = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HIVE;
const $6feacf3bb3931a8f$export$910728553bdc4f2 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE;
const $6feacf3bb3931a8f$export$927252a026981dbc = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HSQLDB;
const $6feacf3bb3931a8f$export$1d4496dd2fb6e5bf = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PROGRESS;
const $6feacf3bb3931a8f$export$eeac513ec469c0cd = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MAXDB;
const $6feacf3bb3931a8f$export$accdcd0fb0e8e3f2 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HANADB;
const $6feacf3bb3931a8f$export$3dcc190bf239314c = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INGRES;
const $6feacf3bb3931a8f$export$ff4c8094bbcf5fa7 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIRSTSQL;
const $6feacf3bb3931a8f$export$3277e5141d071eb2 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_EDB;
const $6feacf3bb3931a8f$export$4a79cae41e08a0dd = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CACHE;
const $6feacf3bb3931a8f$export$cf3b85811d34c73b = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ADABAS;
const $6feacf3bb3931a8f$export$48eca9ca7c84a995 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIREBIRD;
const $6feacf3bb3931a8f$export$bc5d7654a3e6dc01 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DERBY;
const $6feacf3bb3931a8f$export$422940b84b884f99 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FILEMAKER;
const $6feacf3bb3931a8f$export$a49658a36841921 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INFORMIX;
const $6feacf3bb3931a8f$export$dd1bda064bc12f55 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INSTANTDB;
const $6feacf3bb3931a8f$export$3845f6f803a923b1 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INTERBASE;
const $6feacf3bb3931a8f$export$1b74fece6a0567e8 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MARIADB;
const $6feacf3bb3931a8f$export$8fc04abe03bce8d5 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NETEZZA;
const $6feacf3bb3931a8f$export$f9406b4f00b760b4 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PERVASIVE;
const $6feacf3bb3931a8f$export$5bc787da6daf8e9c = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POINTBASE;
const $6feacf3bb3931a8f$export$92e0362f5610565 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SQLITE;
const $6feacf3bb3931a8f$export$ec03fbd64421b165 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SYBASE;
const $6feacf3bb3931a8f$export$486b763280f7312f = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_TERADATA;
const $6feacf3bb3931a8f$export$424b3c529411045a = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_VERTICA;
const $6feacf3bb3931a8f$export$5b4c7807bd4e54d0 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_H2;
const $6feacf3bb3931a8f$export$998c3a6fdfbcf7df = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COLDFUSION;
const $6feacf3bb3931a8f$export$dc18027519a667a3 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CASSANDRA;
const $6feacf3bb3931a8f$export$a3cbb4bc103ae284 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HBASE;
const $6feacf3bb3931a8f$export$b1615e3bbcf0dea5 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MONGODB;
const $6feacf3bb3931a8f$export$e236e209844f1272 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDIS;
const $6feacf3bb3931a8f$export$a3861a07874f1889 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHBASE;
const $6feacf3bb3931a8f$export$f84afd1ccf7f622f = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHDB;
const $6feacf3bb3931a8f$export$408510df30ac38f0 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COSMOSDB;
const $6feacf3bb3931a8f$export$f704654eab77c7c7 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DYNAMODB;
const $6feacf3bb3931a8f$export$5eea4c4dfe97cf90 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NEO4J;
const $6feacf3bb3931a8f$export$f6740c7ce8d8a59 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_GEODE;
const $6feacf3bb3931a8f$export$25d0355c3ecc82d5 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH;
const $6feacf3bb3931a8f$export$3566ede46e0a8a41 = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MEMCACHED;
const $6feacf3bb3931a8f$export$2844c6dfa3d1660a = $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COCKROACHDB;
const $6feacf3bb3931a8f$export$53ce5c6571db6866 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_OTHER_SQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MSSQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MYSQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ORACLE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DB2,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POSTGRESQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDSHIFT,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HIVE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HSQLDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PROGRESS,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MAXDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HANADB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INGRES,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIRSTSQL,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_EDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CACHE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ADABAS,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FIREBIRD,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DERBY,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_FILEMAKER,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INFORMIX,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INSTANTDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_INTERBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MARIADB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NETEZZA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_PERVASIVE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_POINTBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SQLITE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_SYBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_TERADATA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_VERTICA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_H2,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COLDFUSION,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_CASSANDRA,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_HBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MONGODB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_REDIS,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHBASE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COUCHDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COSMOSDB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_DYNAMODB,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_NEO4J,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_GEODE,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_MEMCACHED,
    $6feacf3bb3931a8f$var$TMP_DBSYSTEMVALUES_COCKROACHDB
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbCassandraConsistencyLevelValues enum definition
 *
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = 'all';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = 'each_quorum';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = 'quorum';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = 'local_quorum';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = 'one';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = 'two';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = 'three';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = 'local_one';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = 'any';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = 'serial';
const $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = 'local_serial';
const $6feacf3bb3931a8f$export$8c965dbb4c30de17 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
const $6feacf3bb3931a8f$export$28269849572f223a = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
const $6feacf3bb3931a8f$export$c31be6925d18faf4 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
const $6feacf3bb3931a8f$export$dd2d046c43b425dc = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
const $6feacf3bb3931a8f$export$d567e6085f609657 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
const $6feacf3bb3931a8f$export$2638f2ef2b3637ea = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
const $6feacf3bb3931a8f$export$444dff27642c23a3 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
const $6feacf3bb3931a8f$export$be0e7a9b9b7460eb = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
const $6feacf3bb3931a8f$export$9cda430306f12b08 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
const $6feacf3bb3931a8f$export$79a04d8aacdacbe9 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
const $6feacf3bb3931a8f$export$42bf18043dacb777 = $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
const $6feacf3bb3931a8f$export$a6eeaa6fe6488373 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    $6feacf3bb3931a8f$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasTriggerValues enum definition
 *
 * Type of the trigger on which the function is executed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_DATASOURCE = 'datasource';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_HTTP = 'http';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_PUBSUB = 'pubsub';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_TIMER = 'timer';
const $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_OTHER = 'other';
const $6feacf3bb3931a8f$export$a116a6c98ad82a77 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_DATASOURCE;
const $6feacf3bb3931a8f$export$1b8130a1d4406030 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_HTTP;
const $6feacf3bb3931a8f$export$2c3c25968f77e7b3 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_PUBSUB;
const $6feacf3bb3931a8f$export$f1adafe5047573a = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_TIMER;
const $6feacf3bb3931a8f$export$2aa5343c84c7d0a6 = $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_OTHER;
const $6feacf3bb3931a8f$export$8bd13b593ef4858d = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_DATASOURCE,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_HTTP,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_PUBSUB,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_TIMER,
    $6feacf3bb3931a8f$var$TMP_FAASTRIGGERVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasDocumentOperationValues enum definition
 *
 * Describes the type of the operation that was performed on the data.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = 'insert';
const $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = 'edit';
const $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = 'delete';
const $6feacf3bb3931a8f$export$58594a32d0721c01 = $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
const $6feacf3bb3931a8f$export$fb5981e11be92c91 = $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
const $6feacf3bb3931a8f$export$8617289d67ca4e43 = $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
const $6feacf3bb3931a8f$export$d6463783e5bb27f9 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    $6feacf3bb3931a8f$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasInvokedProviderValues enum definition
 *
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS = 'aws';
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE = 'azure';
const $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP = 'gcp';
const $6feacf3bb3931a8f$export$a7a256059bf89bd1 = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
const $6feacf3bb3931a8f$export$8716f61e9f3c2aeb = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS;
const $6feacf3bb3931a8f$export$ec924dafe3d951e3 = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
const $6feacf3bb3931a8f$export$40370ddcd5c5f6d7 = $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP;
const $6feacf3bb3931a8f$export$668b545a1de0448 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    $6feacf3bb3931a8f$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetTransportValues enum definition
 *
 * Transport protocol used. See note below.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_TCP = 'ip_tcp';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_UDP = 'ip_udp';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP = 'ip';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_UNIX = 'unix';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_PIPE = 'pipe';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_INPROC = 'inproc';
const $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_OTHER = 'other';
const $6feacf3bb3931a8f$export$98ad64057f1fab9f = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_TCP;
const $6feacf3bb3931a8f$export$efc9b6ce6290a881 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_UDP;
const $6feacf3bb3931a8f$export$f3aeea475f2d61eb = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP;
const $6feacf3bb3931a8f$export$2ff43587ce3a6428 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_UNIX;
const $6feacf3bb3931a8f$export$8a59379768b7dcc2 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_PIPE;
const $6feacf3bb3931a8f$export$24d541ca01c48083 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_INPROC;
const $6feacf3bb3931a8f$export$61986d2ea3f68e4 = $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_OTHER;
const $6feacf3bb3931a8f$export$3818cf83a3542239 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_TCP,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP_UDP,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_IP,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_UNIX,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_PIPE,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_INPROC,
    $6feacf3bb3931a8f$var$TMP_NETTRANSPORTVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionTypeValues enum definition
 *
 * The internet connection type currently being used by the host.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = 'wifi';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = 'wired';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = 'cell';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = 'unavailable';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = 'unknown';
const $6feacf3bb3931a8f$export$9f02ba1730e68d64 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
const $6feacf3bb3931a8f$export$ff976cfa645183ea = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
const $6feacf3bb3931a8f$export$9dac5d5db0d7302d = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
const $6feacf3bb3931a8f$export$856320690b0a4ede = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
const $6feacf3bb3931a8f$export$b93b5033f8372e2b = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
const $6feacf3bb3931a8f$export$a5c9a789b3c34827 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionSubtypeValues enum definition
 *
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = 'gprs';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = 'edge';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = 'umts';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = 'cdma';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = 'evdo_0';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = 'evdo_a';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = 'cdma2000_1xrtt';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = 'hsdpa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = 'hsupa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = 'hspa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = 'iden';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = 'evdo_b';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = 'lte';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = 'ehrpd';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = 'hspap';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = 'gsm';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = 'td_scdma';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = 'iwlan';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = 'nr';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = 'nrnsa';
const $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = 'lte_ca';
const $6feacf3bb3931a8f$export$b3928d079bcf0650 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
const $6feacf3bb3931a8f$export$869e5d9e2d7d058f = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
const $6feacf3bb3931a8f$export$4fb8dba98d516457 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
const $6feacf3bb3931a8f$export$4c80eef388ebaccf = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
const $6feacf3bb3931a8f$export$fa867825f37e79db = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
const $6feacf3bb3931a8f$export$27a67e3163ce1ca1 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
const $6feacf3bb3931a8f$export$64eea596575c6ac7 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
const $6feacf3bb3931a8f$export$ac76a80a244a93c4 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
const $6feacf3bb3931a8f$export$1f6c75de7c7b16c8 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
const $6feacf3bb3931a8f$export$546b89c4781a174b = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
const $6feacf3bb3931a8f$export$76ada84046ded2cf = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
const $6feacf3bb3931a8f$export$cbc44b2ef04c23f2 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
const $6feacf3bb3931a8f$export$7df810136272d3ca = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
const $6feacf3bb3931a8f$export$6d0261a99bb34b75 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
const $6feacf3bb3931a8f$export$f5609166f18e0da4 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
const $6feacf3bb3931a8f$export$bb1d1d2dc1514ff9 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
const $6feacf3bb3931a8f$export$f39e3589dec1b486 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
const $6feacf3bb3931a8f$export$2ea90d5cadafeb66 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
const $6feacf3bb3931a8f$export$dacf20f714c7dfe3 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
const $6feacf3bb3931a8f$export$3057d75e98c27a82 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
const $6feacf3bb3931a8f$export$ac7da250598a79b7 = $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
const $6feacf3bb3931a8f$export$2f6476d8343c332 = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    $6feacf3bb3931a8f$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HttpFlavorValues enum definition
 *
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_0 = '1.0';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_1 = '1.1';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_2_0 = '2.0';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_SPDY = 'SPDY';
const $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_QUIC = 'QUIC';
const $6feacf3bb3931a8f$export$a5eaf604e08c3278 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_0;
const $6feacf3bb3931a8f$export$90c81a0909f2ae50 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_1;
const $6feacf3bb3931a8f$export$76fedb424c637ab1 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_2_0;
const $6feacf3bb3931a8f$export$64a9fa17294d693a = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_SPDY;
const $6feacf3bb3931a8f$export$71f9f90e022dd018 = $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_QUIC;
const $6feacf3bb3931a8f$export$98fa65d23b3ad768 = {
    HTTP_1_0: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: $6feacf3bb3931a8f$var$TMP_HTTPFLAVORVALUES_QUIC
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingDestinationKindValues enum definition
 *
 * The kind of message destination.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = 'queue';
const $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = 'topic';
const $6feacf3bb3931a8f$export$3c00656cec2b971b = $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
const $6feacf3bb3931a8f$export$5b3434288d57e9db = $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
const $6feacf3bb3931a8f$export$c97cf0959c06f2eb = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    $6feacf3bb3931a8f$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingOperationValues enum definition
 *
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE = 'receive';
const $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS = 'process';
const $6feacf3bb3931a8f$export$84220b734749f5b0 = $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
const $6feacf3bb3931a8f$export$e4e81e41cac54813 = $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS;
const $6feacf3bb3931a8f$export$4a89c511599cd2ec = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    $6feacf3bb3931a8f$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for RpcGrpcStatusCodeValues enum definition
 *
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
const $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
const $6feacf3bb3931a8f$export$949d8f2733439fe0 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OK;
const $6feacf3bb3931a8f$export$3ab4e217bae3a065 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
const $6feacf3bb3931a8f$export$82114f8ba92008f1 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
const $6feacf3bb3931a8f$export$4747f09ec996ed1a = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
const $6feacf3bb3931a8f$export$2f64e796efee7806 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
const $6feacf3bb3931a8f$export$c2b894d36cd1d993 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
const $6feacf3bb3931a8f$export$e675f9346907cdbf = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
const $6feacf3bb3931a8f$export$ee7173f54f1f7e52 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
const $6feacf3bb3931a8f$export$a2e4b937aa6d8799 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
const $6feacf3bb3931a8f$export$ef9ed8d6d4e5cd73 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
const $6feacf3bb3931a8f$export$5186c1c5a9145ea6 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
const $6feacf3bb3931a8f$export$e67583738364c597 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
const $6feacf3bb3931a8f$export$90f86b1e23bb678f = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
const $6feacf3bb3931a8f$export$133efbe81a3e3b7a = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
const $6feacf3bb3931a8f$export$8d87e3aaaab1d8c1 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
const $6feacf3bb3931a8f$export$2acca698ff2f1632 = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
const $6feacf3bb3931a8f$export$fc7c44549e950bf = $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
const $6feacf3bb3931a8f$export$759a06c32b696c70 = {
    OK: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: $6feacf3bb3931a8f$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessageTypeValues enum definition
 *
 * Whether this is a received or sent message.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_SENT = 'SENT';
const $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_RECEIVED = 'RECEIVED';
const $6feacf3bb3931a8f$export$10fb24096e4ea8a3 = $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_SENT;
const $6feacf3bb3931a8f$export$e520006d57a4745f = $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_RECEIVED;
const $6feacf3bb3931a8f$export$c83b17f5976c727c = /*#__PURE__*/ (0, $af8983c0f76bcdfa$export$8796db7ca257d576)([
    $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_SENT,
    $6feacf3bb3931a8f$var$TMP_MESSAGETYPEVALUES_RECEIVED
]);


// Used to normalize relative URLs
let $7aa841ad0014104b$var$urlNormalizingAnchor;
function $7aa841ad0014104b$var$getUrlNormalizingAnchor() {
    if (!$7aa841ad0014104b$var$urlNormalizingAnchor) $7aa841ad0014104b$var$urlNormalizingAnchor = document.createElement('a');
    return $7aa841ad0014104b$var$urlNormalizingAnchor;
}
function $7aa841ad0014104b$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $7aa841ad0014104b$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($7aa841ad0014104b$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $7aa841ad0014104b$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $7aa841ad0014104b$export$7e5e8f17966d37d1(span, (0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    const encodedLength = resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
    if (encodedLength !== undefined) span.setAttribute((0, $6feacf3bb3931a8f$export$58d4fbfe35e08be0), encodedLength);
    const decodedLength = resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
    // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
    if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $6feacf3bb3931a8f$export$b9d3e41cd56c56cc), decodedLength);
}
function $7aa841ad0014104b$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $7aa841ad0014104b$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $7aa841ad0014104b$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $7aa841ad0014104b$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $7aa841ad0014104b$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $7aa841ad0014104b$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $7aa841ad0014104b$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $7aa841ad0014104b$var$findMainRequest(sorted, corsPreFlightRequest[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $7aa841ad0014104b$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $7aa841ad0014104b$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $bd29e81cd70a2732$export$2d91441ae30ebcfc)((0, $bd29e81cd70a2732$export$5f4c8a8ba0e36226)(resource[(0, $07a8fc58179c2fd8$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $7aa841ad0014104b$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $7aa841ad0014104b$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $7aa841ad0014104b$export$6535eb414fa2c8b6(url) {
    const urlLike = $7aa841ad0014104b$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $7aa841ad0014104b$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $7aa841ad0014104b$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $7aa841ad0014104b$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $7aa841ad0014104b$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $7aa841ad0014104b$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $7aa841ad0014104b$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $7aa841ad0014104b$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $7aa841ad0014104b$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $7aa841ad0014104b$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $a5b2d9a21101d5ac$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $e240ff5b2bfa826f$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_ERROR_NAME"] = "http.error_name";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($e240ff5b2bfa826f$export$668754fb61dd076c || ($e240ff5b2bfa826f$export$668754fb61dd076c = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-xml-http-request
// These may be unified in the future.

const $34ff7089573fc4f7$var$DIAG_LOGGER = $83ffbea8f4ffb90a$export$c042e7c2f59bc046.createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-fetch/utils'
});
function $34ff7089573fc4f7$export$71d292fa56cdb7b9(...args) {
    if (args[0] instanceof URL || typeof args[0] === 'string') {
        const requestInit = args[1];
        if (!requestInit?.body) return Promise.resolve();
        if (requestInit.body instanceof ReadableStream) {
            const { body: body, length: length } = $34ff7089573fc4f7$var$_getBodyNonDestructively(requestInit.body);
            requestInit.body = body;
            return length;
        } else return Promise.resolve($34ff7089573fc4f7$export$e6a57dee760266dc(requestInit.body));
    } else {
        const info = args[0];
        if (!info?.body) return Promise.resolve();
        return info.clone().text().then((t)=>$34ff7089573fc4f7$var$getByteLength(t));
    }
}
function $34ff7089573fc4f7$var$_getBodyNonDestructively(body) {
    // can't read a ReadableStream without destroying it
    // but we CAN pipe it through and return a new ReadableStream
    // some (older) platforms don't expose the pipeThrough method and in that scenario, we're out of luck;
    //   there's no way to read the stream without consuming it.
    if (!body.pipeThrough) {
        $34ff7089573fc4f7$var$DIAG_LOGGER.warn('Platform has ReadableStream but not pipeThrough!');
        return {
            body: body,
            length: Promise.resolve(undefined)
        };
    }
    let length = 0;
    let resolveLength;
    const lengthPromise = new Promise((resolve)=>{
        resolveLength = resolve;
    });
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            const bytearray = await chunk;
            length += bytearray.byteLength;
            controller.enqueue(chunk);
        },
        flush () {
            resolveLength(length);
        }
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise
    };
}
function $34ff7089573fc4f7$var$isDocument(value) {
    return typeof Document !== 'undefined' && value instanceof Document;
}
function $34ff7089573fc4f7$export$e6a57dee760266dc(body) {
    if ($34ff7089573fc4f7$var$isDocument(body)) return new XMLSerializer().serializeToString(document).length;
    // XMLHttpRequestBodyInit expands to the following:
    if (typeof body === 'string') return $34ff7089573fc4f7$var$getByteLength(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $34ff7089573fc4f7$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $34ff7089573fc4f7$var$getByteLength(body.toString());
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) return body.byteLength;
    $34ff7089573fc4f7$var$DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
const $34ff7089573fc4f7$var$TEXT_ENCODER = new TextEncoder();
function $34ff7089573fc4f7$var$getByteLength(s) {
    return $34ff7089573fc4f7$var$TEXT_ENCODER.encode(s).byteLength;
}
function $34ff7089573fc4f7$var$getFormDataSize(formData) {
    let size = 0;
    for (const [key, value] of formData.entries()){
        size += key.length;
        if (value instanceof Blob) size += value.size;
        else size += value.length;
    }
    return size;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $7270322fd21e146f$export$a4ad2735b021c132 = '0.200.0';


// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
const $2ca417de41fd3f3d$var$OBSERVER_WAIT_TIME_MS = 300;
const $2ca417de41fd3f3d$var$isNode = false;
class $2ca417de41fd3f3d$export$f922a490458c98a8 extends (0, $be89eb9a2ed8d8a6$export$436b1c2bf7e9756b) {
    component = 'fetch';
    version = (0, $7270322fd21e146f$export$a4ad2735b021c132);
    moduleName = this.component;
    _usedResources = new WeakSet();
    _tasksCount = 0;
    constructor(config = {}){
        super('@opentelemetry/instrumentation-fetch', (0, $7270322fd21e146f$export$a4ad2735b021c132), config);
    }
    init() {}
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */ _addChildSpan(span, corsPreFlightRequest) {
        const childSpan = this.tracer.startSpan('CORS Preflight', {
            startTime: corsPreFlightRequest[$07a8fc58179c2fd8$export$74be52df2d6fd28c.FETCH_START]
        }, $a1569335aa614ed8$export$357889f174732d38.setSpan($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), span));
        $7aa841ad0014104b$export$e2385716cf129455(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents);
        childSpan.end(corsPreFlightRequest[$07a8fc58179c2fd8$export$74be52df2d6fd28c.RESPONSE_END]);
    }
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */ _addFinalSpanAttributes(span, response) {
        const parsedUrl = $7aa841ad0014104b$export$7a5253c0f62e0150(response.url);
        span.setAttribute((0, $6feacf3bb3931a8f$export$d381c7525d715413), response.status);
        if (response.statusText != null) span.setAttribute((0, $e240ff5b2bfa826f$export$668754fb61dd076c).HTTP_STATUS_TEXT, response.statusText);
        span.setAttribute((0, $6feacf3bb3931a8f$export$547e24d3f59a53ea), parsedUrl.host);
        span.setAttribute((0, $6feacf3bb3931a8f$export$a2928efa45f0acf4), parsedUrl.protocol.replace(':', ''));
        if (typeof navigator !== 'undefined') span.setAttribute((0, $6feacf3bb3931a8f$export$7472b18f42d2d02f), navigator.userAgent);
    }
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */ _addHeaders(options, spanUrl) {
        if (!$7aa841ad0014104b$export$c6501d7e56a5b40a(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            const headers = {};
            $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        if (options instanceof Request) $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Headers) $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Map) $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else {
            const headers = {};
            $c76b4b4057b01033$export$3e49040daa9dba20.inject($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    }
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ _clearResources() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    }
    /**
     * Creates a new span
     * @param url
     * @param options
     */ _createSpan(url, options = {}) {
        if ($a5b2d9a21101d5ac$export$172b5a1c42a6f83d(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        const method = (options.method || 'GET').toUpperCase();
        const spanName = `HTTP ${method}`;
        return this.tracer.startSpan(spanName, {
            kind: $d03364baa5302116$export$4da4ea8145910e8b.CLIENT,
            attributes: {
                [(0, $e240ff5b2bfa826f$export$668754fb61dd076c).COMPONENT]: this.moduleName,
                [(0, $6feacf3bb3931a8f$export$5ec7d06d671a3fbe)]: method,
                [(0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395)]: url
            }
        });
    }
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */ _findResourceAndAddNetworkEvents(span, resourcesObserver, endTime) {
        let resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType('resource');
        }
        const resource = $7aa841ad0014104b$export$cdcba7438a7553e8(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, 'fetch');
        if (resource.mainRequest) {
            const mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            const corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            $7aa841ad0014104b$export$e2385716cf129455(span, mainRequest, this.getConfig().ignoreNetworkEvents);
        }
    }
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */ _markResourceAsUsed(resource) {
        this._usedResources.add(resource);
    }
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */ _endSpan(span, spanData, response) {
        const endTime = $bd29e81cd70a2732$export$e7ec5c82995537b1(Date.now());
        const performanceEndTime = $bd29e81cd70a2732$export$24b3f7dcd2848fa8();
        this._addFinalSpanAttributes(span, response);
        setTimeout(()=>{
            spanData.observer?.disconnect();
            this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            this._tasksCount--;
            this._clearResources();
            span.end(endTime);
        }, $2ca417de41fd3f3d$var$OBSERVER_WAIT_TIME_MS);
    }
    /**
     * Patches the constructor of fetch
     */ _patchConstructor() {
        return (original)=>{
            const plugin = this;
            return function patchConstructor(...args) {
                const self = this;
                const url = $7aa841ad0014104b$export$7a5253c0f62e0150(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                const options = args[0] instanceof Request ? args[0] : args[1] || {};
                const createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                const spanData = plugin._prepareSpanData(url);
                if (plugin.getConfig().measureRequestSize) (0, $34ff7089573fc4f7$export$71d292fa56cdb7b9)(...args).then((length)=>{
                    if (!length) return;
                    createdSpan.setAttribute((0, $6feacf3bb3931a8f$export$4352992cf528a286), length);
                }).catch((error)=>{
                    plugin._diag.warn('getFetchBodyLength', error);
                });
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function onSuccess(span, resolve, response) {
                    try {
                        const resClone = response.clone();
                        const body = resClone.body;
                        if (body) {
                            const reader = body.getReader();
                            const read = ()=>{
                                reader.read().then(({ done: done })=>{
                                    if (done) endSpanOnSuccess(span, response);
                                    else read();
                                }, (error)=>{
                                    endSpanOnError(span, error);
                                });
                            };
                            read();
                        } else // some older browsers don't have .body implemented
                        endSpanOnSuccess(span, response);
                    } finally{
                        resolve(response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise((resolve, reject)=>{
                    return $e8248f70bfae46d0$export$a078c61943f9dbbe.with($a1569335aa614ed8$export$357889f174732d38.setSpan($e8248f70bfae46d0$export$a078c61943f9dbbe.active(), createdSpan), ()=>{
                        plugin._addHeaders(options, url);
                        // Important to execute "_callRequestHook" after "_addHeaders", allowing the consumer code to override the request headers.
                        plugin._callRequestHook(createdSpan, options);
                        plugin._tasksCount++;
                        // TypeScript complains about arrow function captured a this typed as globalThis
                        // ts(7041)
                        return original.apply(self, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    }
    _applyAttributesAfterFetch(span, request, result) {
        const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, request, result), (error)=>{
            if (!error) return;
            this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    }
    _callRequestHook(span, request) {
        const requestHook = this.getConfig().requestHook;
        if (requestHook) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>requestHook(span, request), (error)=>{
            if (!error) return;
            this._diag.error('requestHook', error);
        }, true);
    }
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */ _prepareSpanData(spanUrl) {
        const startTime = $bd29e81cd70a2732$export$24b3f7dcd2848fa8();
        const entries = [];
        if (typeof PerformanceObserver !== 'function') return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        const observer = new PerformanceObserver((list)=>{
            const perfObsEntries = list.getEntries();
            perfObsEntries.forEach((entry)=>{
                if (entry.initiatorType === 'fetch' && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                'resource'
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    }
    /**
     * implements enable function
     */ enable() {
        if ($2ca417de41fd3f3d$var$isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ((0, $e5045196367e2654$export$ec0fd572751979bc)(fetch)) {
            this._unwrap((0, $cf2085415f7cd9be$export$5c524ddf7208c00c), 'fetch');
            this._diag.debug('removing previous patch for constructor');
        }
        this._wrap((0, $cf2085415f7cd9be$export$5c524ddf7208c00c), 'fetch', this._patchConstructor());
    }
    /**
     * implements unpatch function
     */ disable() {
        if ($2ca417de41fd3f3d$var$isNode) return;
        this._unwrap((0, $cf2085415f7cd9be$export$5c524ddf7208c00c), 'fetch');
        this._usedResources = new WeakSet();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY = (0, $a50b1446b3c4bd0a$export$b8c322c5a7cfce78)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $2a3b8ba89960fe51$export$869298f9835abc68(context) {
    return context.setValue($2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY, true);
}
function $2a3b8ba89960fe51$export$a8cb26cef1019d30(context) {
    return context.deleteValue($2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY);
}
function $2a3b8ba89960fe51$export$7d5f2376f7cf513(context) {
    return context.getValue($2a3b8ba89960fe51$var$SUPPRESS_TRACING_KEY) === true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1615a6b145770120$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $1615a6b145770120$var$VALID_KEY = `[a-z]${$1615a6b145770120$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $1615a6b145770120$var$VALID_VENDOR_KEY = `[a-z0-9]${$1615a6b145770120$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$1615a6b145770120$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $1615a6b145770120$var$VALID_KEY_REGEX = new RegExp(`^(?:${$1615a6b145770120$var$VALID_KEY}|${$1615a6b145770120$var$VALID_VENDOR_KEY})$`);
const $1615a6b145770120$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $1615a6b145770120$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $1615a6b145770120$export$469cc9c479301ba6(key) {
    return $1615a6b145770120$var$VALID_KEY_REGEX.test(key);
}
function $1615a6b145770120$export$b76e9316566cc26e(value) {
    return $1615a6b145770120$var$VALID_VALUE_BASE_REGEX.test(value) && !$1615a6b145770120$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $9c2d70aad95d92da$var$MAX_TRACE_STATE_ITEMS = 32;
const $9c2d70aad95d92da$var$MAX_TRACE_STATE_LEN = 512;
const $9c2d70aad95d92da$var$LIST_MEMBERS_SEPARATOR = ',';
const $9c2d70aad95d92da$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $9c2d70aad95d92da$export$b0addedc390b67c2 {
    _internalState = new Map();
    constructor(rawTraceState){
        if (rawTraceState) this._parse(rawTraceState);
    }
    set(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        const traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys().reduce((agg, key)=>{
            agg.push(key + $9c2d70aad95d92da$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, []).join($9c2d70aad95d92da$var$LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > $9c2d70aad95d92da$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($9c2d70aad95d92da$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce((agg, part)=>{
            const listMember = part.trim(); // Optional Whitespace (OWS) handling
            const i = listMember.indexOf($9c2d70aad95d92da$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if ((0, $1615a6b145770120$export$469cc9c479301ba6)(key) && (0, $1615a6b145770120$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $9c2d70aad95d92da$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $9c2d70aad95d92da$var$MAX_TRACE_STATE_ITEMS));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new $9c2d70aad95d92da$export$b0addedc390b67c2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}


const $d133ac16ab96276c$export$830e05fa2746348 = 'traceparent';
const $d133ac16ab96276c$export$2b12ed38dcfae2ae = 'tracestate';
const $d133ac16ab96276c$var$VERSION = '00';
const $d133ac16ab96276c$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $d133ac16ab96276c$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $d133ac16ab96276c$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $d133ac16ab96276c$var$FLAGS_PART = '[\\da-f]{2}';
const $d133ac16ab96276c$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$d133ac16ab96276c$var$VERSION_PART})-(${$d133ac16ab96276c$var$TRACE_ID_PART})-(${$d133ac16ab96276c$var$PARENT_ID_PART})-(${$d133ac16ab96276c$var$FLAGS_PART})(-.*)?\\s?$`);
function $d133ac16ab96276c$export$f4d87f8901a93f5d(traceParent) {
    const match = $d133ac16ab96276c$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $d133ac16ab96276c$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $a1569335aa614ed8$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $2a3b8ba89960fe51$export$7d5f2376f7cf513)(context) || !(0, $a89fc3550e8ac673$export$e4373b9a2c09216c)(spanContext)) return;
        const traceParent = `${$d133ac16ab96276c$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $974e5505212bea35$export$bf9049ad2b0883ff).NONE).toString(16)}`;
        setter.set(carrier, $d133ac16ab96276c$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $d133ac16ab96276c$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $d133ac16ab96276c$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $d133ac16ab96276c$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $d133ac16ab96276c$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $9c2d70aad95d92da$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $a1569335aa614ed8$export$357889f174732d38).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $d133ac16ab96276c$export$830e05fa2746348,
            $d133ac16ab96276c$export$2b12ed38dcfae2ae
        ];
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e8d17355ab785685$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($e8d17355ab785685$export$74be52df2d6fd28c || ($e8d17355ab785685$export$74be52df2d6fd28c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1593213f4b74563$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $b1593213f4b74563$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($b1593213f4b74563$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.<key>` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.<key>`.
 */ const $2049f7584b342f39$export$237bc893b534cd8c = 'http.response_content_length';
const $2049f7584b342f39$export$651dae55eea4b228 = 'http.response_content_length_uncompressed';


// Used to normalize relative URLs
let $59ebb463b0007a01$var$urlNormalizingAnchor;
function $59ebb463b0007a01$var$getUrlNormalizingAnchor() {
    if (!$59ebb463b0007a01$var$urlNormalizingAnchor) $59ebb463b0007a01$var$urlNormalizingAnchor = document.createElement('a');
    return $59ebb463b0007a01$var$urlNormalizingAnchor;
}
function $59ebb463b0007a01$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $59ebb463b0007a01$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($59ebb463b0007a01$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $59ebb463b0007a01$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $59ebb463b0007a01$export$7e5e8f17966d37d1(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        // This block adds content-length-related span attributes using the
        // *old* HTTP semconv (v1.7.0).
        const encodedLength = resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
        if (encodedLength !== undefined) span.setAttribute((0, $2049f7584b342f39$export$237bc893b534cd8c), encodedLength);
        const decodedLength = resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
        // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
        if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $2049f7584b342f39$export$651dae55eea4b228), decodedLength);
    }
}
function $59ebb463b0007a01$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $59ebb463b0007a01$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $59ebb463b0007a01$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $59ebb463b0007a01$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $59ebb463b0007a01$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $59ebb463b0007a01$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $59ebb463b0007a01$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $59ebb463b0007a01$var$findMainRequest(sorted, corsPreFlightRequest[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $59ebb463b0007a01$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $59ebb463b0007a01$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $3b7d94c9e2749488$export$2d91441ae30ebcfc)((0, $3b7d94c9e2749488$export$5f4c8a8ba0e36226)(resource[(0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $59ebb463b0007a01$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $59ebb463b0007a01$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $59ebb463b0007a01$export$6535eb414fa2c8b6(url) {
    const urlLike = $59ebb463b0007a01$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $59ebb463b0007a01$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $59ebb463b0007a01$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $59ebb463b0007a01$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $59ebb463b0007a01$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $59ebb463b0007a01$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $59ebb463b0007a01$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $59ebb463b0007a01$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $59ebb463b0007a01$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $59ebb463b0007a01$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $b1593213f4b74563$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $20dfdf021ac74c82$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["DOCUMENT_LOAD"] = "documentLoad";
    AttributeNames["DOCUMENT_FETCH"] = "documentFetch";
    AttributeNames["RESOURCE_FETCH"] = "resourceFetch";
})($20dfdf021ac74c82$export$668754fb61dd076c || ($20dfdf021ac74c82$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $46e2973adff74f29$export$4a03ffab3315ee34 = '0.45.0';
const $46e2973adff74f29$export$b8b9d90f9e5bd72b = '@opentelemetry/instrumentation-document-load';



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d97c9a01d142b989$export$3fd36d65bf762270;
(function(EventNames) {
    EventNames["FIRST_PAINT"] = "firstPaint";
    EventNames["FIRST_CONTENTFUL_PAINT"] = "firstContentfulPaint";
})($d97c9a01d142b989$export$3fd36d65bf762270 || ($d97c9a01d142b989$export$3fd36d65bf762270 = {}));


const $ff864c8153add48a$export$1edb6265ef1ecc26 = ()=>{
    const entries = {};
    const performanceNavigationTiming = (0, $02b2267f7388e0c4$export$b22daef4119238cd).getEntriesByType?.('navigation')[0];
    if (performanceNavigationTiming) {
        const keys = Object.values((0, $e8d17355ab785685$export$74be52df2d6fd28c));
        keys.forEach((key)=>{
            if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(performanceNavigationTiming, key)) {
                const value = performanceNavigationTiming[key];
                if (typeof value === 'number') entries[key] = value;
            }
        });
    } else {
        // // fallback to previous version
        const perf = (0, $02b2267f7388e0c4$export$b22daef4119238cd);
        const performanceTiming = perf.timing;
        if (performanceTiming) {
            const keys = Object.values((0, $e8d17355ab785685$export$74be52df2d6fd28c));
            keys.forEach((key)=>{
                if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(performanceTiming, key)) {
                    const value = performanceTiming[key];
                    if (typeof value === 'number') entries[key] = value;
                }
            });
        }
    }
    return entries;
};
const $ff864c8153add48a$var$performancePaintNames = {
    'first-paint': (0, $d97c9a01d142b989$export$3fd36d65bf762270).FIRST_PAINT,
    'first-contentful-paint': (0, $d97c9a01d142b989$export$3fd36d65bf762270).FIRST_CONTENTFUL_PAINT
};
const $ff864c8153add48a$export$dbffc7a51b89acf6 = (span)=>{
    const performancePaintTiming = (0, $02b2267f7388e0c4$export$b22daef4119238cd).getEntriesByType?.('paint');
    if (performancePaintTiming) performancePaintTiming.forEach(({ name: name, startTime: startTime })=>{
        if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)($ff864c8153add48a$var$performancePaintNames, name)) span.addEvent($ff864c8153add48a$var$performancePaintNames[name], startTime);
    });
};


class $2d936f74e3529f90$export$381e8ef2e310d2c3 extends (0, $be89eb9a2ed8d8a6$export$436b1c2bf7e9756b) {
    component = 'document-load';
    version = '1';
    moduleName = this.component;
    constructor(config = {}){
        super((0, $46e2973adff74f29$export$b8b9d90f9e5bd72b), (0, $46e2973adff74f29$export$4a03ffab3315ee34), config);
    }
    init() {}
    /**
     * callback to be executed when page is loaded
     */ _onDocumentLoaded() {
        // Timeout is needed as load event doesn't have yet the performance metrics for loadEnd.
        // Support for event "loadend" is very limited and cannot be used
        window.setTimeout(()=>{
            this._collectPerformance();
        });
    }
    /**
     * Adds spans for all resources
     * @param rootSpan
     */ _addResourcesSpans(rootSpan) {
        const resources = (0, $02b2267f7388e0c4$export$b22daef4119238cd).getEntriesByType?.('resource');
        if (resources) resources.forEach((resource)=>{
            this._initResourceSpan(resource, rootSpan);
        });
    }
    /**
     * Collects information about performance and creates appropriate spans
     */ _collectPerformance() {
        const metaElement = Array.from(document.getElementsByTagName('meta')).find((e)=>e.getAttribute('name') === (0, $d133ac16ab96276c$export$830e05fa2746348));
        const entries = (0, $ff864c8153add48a$export$1edb6265ef1ecc26)();
        const traceparent = metaElement && metaElement.content || '';
        (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $c76b4b4057b01033$export$3e49040daa9dba20).extract((0, $a50b1446b3c4bd0a$export$78df28f9b2f9a7dc), {
            traceparent: traceparent
        }), ()=>{
            const rootSpan = this._startSpan((0, $20dfdf021ac74c82$export$668754fb61dd076c).DOCUMENT_LOAD, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, entries);
            if (!rootSpan) return;
            (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $a1569335aa614ed8$export$357889f174732d38).setSpan((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active(), rootSpan), ()=>{
                const fetchSpan = this._startSpan((0, $20dfdf021ac74c82$export$668754fb61dd076c).DOCUMENT_FETCH, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, entries);
                if (fetchSpan) {
                    fetchSpan.setAttribute((0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395), location.href);
                    (0, $e8248f70bfae46d0$export$a078c61943f9dbbe).with((0, $a1569335aa614ed8$export$357889f174732d38).setSpan((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active(), fetchSpan), ()=>{
                        if (!this.getConfig().ignoreNetworkEvents) (0, $59ebb463b0007a01$export$e2385716cf129455)(fetchSpan, entries);
                        this._addCustomAttributesOnSpan(fetchSpan, this.getConfig().applyCustomAttributesOnSpan?.documentFetch);
                        this._endSpan(fetchSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END, entries);
                    });
                }
            });
            rootSpan.setAttribute((0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395), location.href);
            rootSpan.setAttribute((0, $6feacf3bb3931a8f$export$7472b18f42d2d02f), navigator.userAgent);
            this._addResourcesSpans(rootSpan);
            if (!this.getConfig().ignoreNetworkEvents) {
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).UNLOAD_EVENT_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).UNLOAD_EVENT_END, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_INTERACTIVE, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_END, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).DOM_COMPLETE, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).LOAD_EVENT_START, entries);
                (0, $59ebb463b0007a01$export$7e5e8f17966d37d1)(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
            }
            if (!this.getConfig().ignorePerformancePaintEvents) (0, $ff864c8153add48a$export$dbffc7a51b89acf6)(rootSpan);
            this._addCustomAttributesOnSpan(rootSpan, this.getConfig().applyCustomAttributesOnSpan?.documentLoad);
            this._endSpan(rootSpan, (0, $e8d17355ab785685$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
        });
    }
    /**
     * Helper function for ending span
     * @param span
     * @param performanceName name of performance entry for time end
     * @param entries
     */ _endSpan(span, performanceName, entries) {
        // span can be undefined when entries are missing the certain performance - the span will not be created
        if (span) {
            if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(entries, performanceName)) span.end(entries[performanceName]);
            else // just end span
            span.end();
        }
    }
    /**
     * Creates and ends a span with network information about resource added as timed events
     * @param resource
     * @param parentSpan
     */ _initResourceSpan(resource, parentSpan) {
        const span = this._startSpan((0, $20dfdf021ac74c82$export$668754fb61dd076c).RESOURCE_FETCH, (0, $e8d17355ab785685$export$74be52df2d6fd28c).FETCH_START, resource, parentSpan);
        if (span) {
            span.setAttribute((0, $6feacf3bb3931a8f$export$2f4ef7e39c2be395), resource.name);
            if (!this.getConfig().ignoreNetworkEvents) (0, $59ebb463b0007a01$export$e2385716cf129455)(span, resource);
            this._addCustomAttributesOnResourceSpan(span, resource, this.getConfig().applyCustomAttributesOnSpan?.resourceFetch);
            this._endSpan(span, (0, $e8d17355ab785685$export$74be52df2d6fd28c).RESPONSE_END, resource);
        }
    }
    /**
     * Helper function for starting a span
     * @param spanName name of span
     * @param performanceName name of performance entry for time start
     * @param entries
     * @param parentSpan
     */ _startSpan(spanName, performanceName, entries, parentSpan) {
        if ((0, $59ebb463b0007a01$export$94df19ecb868bc1a)(entries, performanceName) && typeof entries[performanceName] === 'number') {
            const span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName]
            }, parentSpan ? (0, $a1569335aa614ed8$export$357889f174732d38).setSpan((0, $e8248f70bfae46d0$export$a078c61943f9dbbe).active(), parentSpan) : undefined);
            return span;
        }
        return undefined;
    }
    /**
     * executes callback {_onDocumentLoaded} when the page is loaded
     */ _waitForPageLoad() {
        if (window.document.readyState === 'complete') this._onDocumentLoaded();
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener('load', this._onDocumentLoaded);
        }
    }
    /**
     * adds custom attributes to root span if configured
     */ _addCustomAttributesOnSpan(span, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnSpan', error);
        }, true);
    }
    /**
     * adds custom attributes to span if configured
     */ _addCustomAttributesOnResourceSpan(span, resource, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $e5045196367e2654$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, resource), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnResourceSpan', error);
        }, true);
    }
    /**
     * implements enable function
     */ enable() {
        // remove previously attached load to avoid adding the same event twice
        // in case of multiple enable calling.
        window.removeEventListener('load', this._onDocumentLoaded);
        this._waitForPageLoad();
    }
    /**
     * implements disable function
     */ disable() {
        window.removeEventListener('load', this._onDocumentLoaded);
    }
}








var $7SHCs = parcelRequire("7SHCs");

var $hdMz2 = parcelRequire("hdMz2");

var $bWQ72 = parcelRequire("bWQ72");

var $kdMEA = parcelRequire("kdMEA");

var $2rYkD = parcelRequire("2rYkD");

var $3RB0m = parcelRequire("3RB0m");
const $f6050bdd136b78fe$var$TelemetryContextDefaultValues = {
    enabled: true,
    tracer: undefined,
    sendTrace: ()=>{},
    sendErrorTrace: ()=>{}
};
const $f6050bdd136b78fe$export$7b6b7bc4acb29126 = /*#__PURE__*/ (0, $bxRTa.createContext)($f6050bdd136b78fe$var$TelemetryContextDefaultValues);
function $f6050bdd136b78fe$export$a15d15518a3ec33d() {
    return (0, $bxRTa.useContext)($f6050bdd136b78fe$export$7b6b7bc4acb29126);
}
function $f6050bdd136b78fe$export$bb3ea6dd2428edb6({ enabled: enabled, children: children }) {
    const userId = (0, $hdMz2.useDirectlineStore)((state)=>state.userId);
    const conversationId = (0, $bWQ72.useActivityStore)((state)=>state.conversationId);
    const addressData = (0, $7SHCs.useRetorikStore)((state)=>state.addressData);
    const lastActivity = (0, $bWQ72.useActivityStore)((state)=>state.lastActivity);
    const botStreamingActivities = (0, $bWQ72.useActivityStore)((state)=>state.botStreamingActivities);
    const lastUserActivityRef = (0, $bxRTa.useRef)(null);
    const tracer = (0, $bxRTa.useMemo)(()=>{
        if (enabled && userId && conversationId) {
            const exporter = new (0, $392d64385d8e7a6b$export$f73dc942b4b27de3)({
                url: (0, $kdMEA.telemetryAddress),
                headers: {},
                concurrencyLimit: 1
            });
            let serviceNamespace = '';
            switch(addressData.prefix){
                case 'dev':
                    serviceNamespace = 'retorik-dev';
                    break;
                case 'staging':
                case 'preview':
                    serviceNamespace = 'retorik-preview';
                    break;
                case 'experimental':
                    serviceNamespace = 'retorik-experimental';
                    break;
                default:
                    serviceNamespace = 'retorik-prod';
                    break;
            }
            // Create resource with custom parameters used globally in uptrace
            const resource = (0, $f5d296ad825fd0d7$export$522a862cad1b0abc)().merge((0, $f5d296ad825fd0d7$export$bb0fe4e7060febbf)({
                [(0, $d77970ee83c3563c$export$84187ab40ae4fa9c)]: 'retorik-framework',
                ['davi.retorik.activity.conversation.id']: conversationId,
                ['service_namespace']: serviceNamespace,
                ['retorik_framework_version']: (0, $3RB0m.version),
                ['user_id']: userId
            }));
            const processor = new (0, $09d39f20801a455d$export$237547059fd543f9)(exporter);
            const provider = new (0, $bebde9d422ce0bc5$export$a785009afeee3453)({
                resource: resource,
                spanProcessors: [
                    processor
                ]
            });
            provider.register();
            // Add common attributes to each span for better tracing
            (0, $2c0724552941680d$export$fc0a1ca5231d826a)({
                instrumentations: [
                    new (0, $2ca417de41fd3f3d$export$f922a490458c98a8)(),
                    new (0, $2d936f74e3529f90$export$381e8ef2e310d2c3)()
                ]
            });
            return (0, $00524e035e1e9c07$export$2e2bcd8739ae039).trace.getTracer('retorik-framework');
        }
        return undefined;
    }, [
        enabled,
        userId,
        conversationId,
        addressData,
        (0, $3RB0m.version)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (lastActivity) lastActivity.from.role === 'user' ? handleUserActivity(lastActivity) : handleBotActivity(lastActivity);
    }, [
        lastActivity
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (lastUserActivityRef.current) {
            const temp = botStreamingActivities.get(lastUserActivityRef.current.id);
            temp?.length === 1 && handleBotActivity(temp[0]);
        }
    }, [
        botStreamingActivities
    ]);
    const handleUserActivity = (activity)=>{
        // Only handle message activites and event activities waiting for an answer, nothing for typing ones
        if (activity.type === 'message' || activity.type === 'event' && !(0, $kdMEA.nonResponseInducingEvents).find((eventName)=>activity.name?.toLowerCase().includes(eventName))) lastUserActivityRef.current = {
            id: activity.id,
            time: Date.now()
        };
    };
    const handleBotActivity = (activity)=>{
        // Do nothing for bring-up messages and non-streaming events
        if (lastUserActivityRef.current && (activity.type === 'message' || activity.name?.toLocaleLowerCase() === 'davi.streammessageactivity') && activity.label?.toLowerCase() !== 'davi.bringupmessage' && activity.replyToId === lastUserActivityRef.current.id) {
            sendTrace((0, $2rYkD.TraceType).message, {
                activityId: activity.id,
                userActivity: lastUserActivityRef.current
            });
            lastUserActivityRef.current = null;
        }
    };
    const sendTrace = (type, data)=>{
        if (tracer && type) {
            const parameters = data?.activityId ? {
                'davi.retorik.activity.id': data.activityId
            } : {};
            let startTime = 0;
            switch(type){
                case (0, $2rYkD.TraceType).message:
                    if (data?.userActivity) startTime = data?.userActivity.time;
                    break;
                case (0, $2rYkD.TraceType).utteranceStart:
                case (0, $2rYkD.TraceType).utteranceEnd:
                    parameters.text = data?.text;
                    break;
            }
            const span = tracer.startSpan(type, startTime ? {
                startTime: startTime
            } : undefined);
            span.setStatus({
                code: (0, $873e79d0391b734f$export$1e28dd9b5d01db83).OK
            });
            span.setAttributes(parameters);
            span.end();
        }
    };
    const sendErrorTrace = (error)=>{
        if (tracer) {
            const span = tracer.startSpan('Error');
            span.recordException(error);
            span.setStatus({
                code: (0, $873e79d0391b734f$export$1e28dd9b5d01db83).ERROR,
                message: `${error.message}`
            });
            span.end();
        }
    };
    const value = (0, $bxRTa.useMemo)(()=>({
            enabled: enabled,
            tracer: tracer,
            sendTrace: sendTrace,
            sendErrorTrace: sendErrorTrace
        }), [
        enabled,
        tracer
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)($f6050bdd136b78fe$export$7b6b7bc4acb29126.Provider, {
        value: value,
        children: children
    });
}



var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $hdMz2 = parcelRequire("hdMz2");

var $fzVhJ = parcelRequire("fzVhJ");
const $b4e3e24c87e40d50$var$ContextProvider = ({ skipLoader: skipLoader, mode: mode, viewsConfiguration: viewsConfiguration, configuration: configuration, customVoice: customVoice, addressData: addressData, agentSource: agentSource, ponyfillFactoryCredentials: ponyfillFactoryCredentials, children: children })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const supported = (0, $2eBYD.useLocaleStore)((state)=>state.supported);
    const defaultLocale = (0, $2eBYD.useLocaleStore)((state)=>state.defaultLocale);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const setLocale = (0, $2eBYD.useLocaleStore)((state)=>state.actions.setLocale);
    const setViewsConfiguration = (0, $9JLpC.useViewStore)((state)=>state.actions.setViewsConfiguration);
    const { setCustomVoice: setCustomVoice, setPonyfillFactoryCredentials: setPonyfillFactoryCredentials, setUseContinuousRecognition: setUseContinuousRecognition, setMuted: setMuted, setMode: setMode, setDisableSound: setDisableSound } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const { setAgentData: setAgentData, setConfiguration: setConfiguration, setAddressData: setAddressData, setSkipLoader: setSkipLoader, setSubtitlesInConfiguration: setSubtitlesInConfiguration } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const setPositionToSend = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.setPositionToSend);
    const setLocation = async (data)=>{
        const position = {
            searchForLocation: true,
            latitude: data.coords.latitude,
            longitude: data.coords.longitude
        };
        setPositionToSend({
            latitude: position.latitude,
            longitude: position.longitude
        });
        setConfiguration({
            ...configuration,
            position: position
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        // Set continous recognition state
        setUseContinuousRecognition(currentDeviceType, configuration?.speechRecognitionOptions);
    }, [
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setMode(mode);
    }, [
        mode
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setSkipLoader(!!skipLoader);
    }, [
        skipLoader
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setViewsConfiguration(viewsConfiguration);
    }, [
        viewsConfiguration,
        ...Object.values(viewsConfiguration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setConfiguration(configuration);
    }, [
        configuration,
        ...Object.values(configuration)
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration.position?.searchForLocation) // Position enabled
        {
            if (configuration.position.latitude === undefined && configuration.position.longitude === undefined) // Try to get the position of the device if no one has been given in the configuration
            navigator.geolocation?.getCurrentPosition(setLocation, (error)=>{
                switch(error.code){
                    case error.PERMISSION_DENIED:
                        console.warn('Geolocation : User denied the request for Geolocation.');
                        break;
                    case error.POSITION_UNAVAILABLE:
                        console.warn('Geolocation : Location information is unavailable.');
                        break;
                    case error.TIMEOUT:
                        console.warn('Geolocation : The request to get user location timed out.');
                        break;
                    default:
                        console.warn('Geolocation : An unknown error occurred.');
                        break;
                }
            }, {
                timeout: 3000
            });
        }
    }, [
        configuration.position
    ]);
    (0, $bxRTa.useEffect)(()=>{
        configuration.position?.latitude && configuration.position.longitude && setPositionToSend({
            latitude: configuration.position.latitude,
            longitude: configuration.position.longitude
        });
    }, [
        configuration.position?.latitude,
        configuration.position?.longitude
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (configuration.disableSound === true) {
            setMuted(true);
            setDisableSound(true);
        }
        if (configuration.disableSound === false) setDisableSound(false);
    }, [
        configuration.disableSound
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setSubtitlesInConfiguration(!!configuration.subtitles);
    }, [
        configuration.subtitles
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setCustomVoice(customVoice);
    }, [
        customVoice
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setAddressData(addressData);
    }, [
        addressData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setAgentData(agentSource);
    }, [
        agentSource
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setPonyfillFactoryCredentials(ponyfillFactoryCredentials);
    }, [
        ponyfillFactoryCredentials
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (supported.length) setLocale((0, $fzVhJ.checkLocale)({
            all: supported,
            default: defaultLocale
        }, configuration.locales));
    }, [
        supported,
        configuration
    ]);
    return locale && supported ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f6050bdd136b78fe$export$bb3ea6dd2428edb6), {
        enabled: !(configuration.enableTelemetry === false),
        children: children
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $b4e3e24c87e40d50$export$2e2bcd8739ae039 = $b4e3e24c87e40d50$var$ContextProvider;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $eo2R4 = parcelRequire("eo2R4");

var $bWQ72 = parcelRequire("bWQ72");

var $hdMz2 = parcelRequire("hdMz2");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");
async function $5feda0058508ab46$export$97c24bbbbbd7be8a(address) {
    const token = await fetch(address).then((res)=>{
        return res.json();
    }).catch((error)=>console.warn(`Retorik Framework > error fetching directline token : ${error}`));
    return token;
}



var $7c6BL = parcelRequire("7c6BL");
const $6a60c4ac572a9b7a$var$defaultUser = {
    name: 'default',
    id: `defaultId_${Date.now()}`,
    username: 'default',
    nom: 'defaultName',
    prenom: "\xe0 vous",
    email: '',
    token: '',
    referrer: '',
    ipaddress: ''
};
const $6a60c4ac572a9b7a$var$RetorikComposer = ({ addressData: addressData, userData: userData, externalEventHandler: externalEventHandler, children: children, isRetorikNews: isRetorikNews })=>{
    const directLine = (0, $hdMz2.useDirectlineStore)((state)=>state.directLine);
    const connectionStatus = (0, $hdMz2.useDirectlineStore)((state)=>state.directLineStatus);
    const [directLineCreationData, setDirectLineCreationData] = (0, $bxRTa.useState)();
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const supported = (0, $2eBYD.useLocaleStore)((state)=>state.supported);
    const setAppAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setAppAvailable);
    const { addCookie: addCookie, setAddRetorikNewsConversationIdInLocalStorage: setAddRetorikNewsConversationIdInLocalStorage, setRetrievingConversation: setRetrievingConversation } = (0, $bWQ72.useActivityStore)((state)=>state.actions);
    const { createDirectLine: createDirectLine, resetDirectlineStore: resetDirectlineStore } = (0, $hdMz2.useDirectlineStore)((state)=>state.actions);
    const [hasConversationCookie, setHasConversationCookie] = (0, $bxRTa.useState)(false);
    const processedUserData = (0, $bxRTa.useMemo)(()=>{
        if (userData) return userData;
        else {
            const userIdFromCookie = document.cookie.split('; ').find((row)=>row.startsWith('retorikUserIdCookie='))?.split('=')[1];
            if (userIdFromCookie) return {
                ...$6a60c4ac572a9b7a$var$defaultUser,
                username: userIdFromCookie,
                id: userIdFromCookie
            };
            else {
                const id = `defaultId_${Date.now()}`;
                addCookie(`retorikUserIdCookie=${id}`);
                return {
                    ...$6a60c4ac572a9b7a$var$defaultUser,
                    username: id,
                    id: id
                };
            }
        }
    }, [
        userData
    ]);
    const processDirectLine = async (directLineData)=>{
        (0, $5feda0058508ab46$export$97c24bbbbbd7be8a)(directLineData.tokenEndpoint).then((token)=>{
            let test = true;
            if (isRetorikNews) {
                const fullTenantName = (addressData.baseURI || `${addressData.prefix || ''}${addressData.tenant}`).replace(/;|,|\s/g, '');
                const newsConversationData = localStorage.getItem(`Retorik.News.Conversation.${fullTenantName}`);
                if (newsConversationData) {
                    const data = JSON.parse(newsConversationData);
                    if (data?.conversationId) // 604800000 = number of milliseconds in 7 days
                    {
                        if (!isNaN(data.startedAt) && data.startedAt + 604800000 > Date.now()) {
                            setDirectLineCreationData({
                                token: token,
                                domain: directLineData.address,
                                conversationId: data.conversationId
                            });
                            test = false;
                        }
                    }
                }
                test && setAddRetorikNewsConversationIdInLocalStorage(fullTenantName);
            } else if (configuration.enableConversationCookie !== false) {
                const conversationCookie = document.cookie.split('; ').find((row)=>row.startsWith('retorikConversationCookie='))?.split('=')[1];
                if (conversationCookie) {
                    const splitCookieData = conversationCookie.split('||');
                    if (splitCookieData.length === 2) {
                        const cookieConversationId = splitCookieData[0];
                        const cookieTenantName = splitCookieData[1];
                        const fullTenantName = (addressData.baseURI || `${addressData.prefix || ''}${addressData.tenant}`).replace(/;|,|\s/g, '');
                        if (cookieTenantName === fullTenantName) {
                            setDirectLineCreationData({
                                token: token,
                                domain: directLineData.address,
                                conversationId: cookieConversationId,
                                watermark: '0'
                            });
                            // Tell the activity store that we will retrieve several activities from an existing conversation, so that it displays only the last one
                            setRetrievingConversation(true);
                            setHasConversationCookie(true);
                            test = false;
                        }
                    }
                } else {
                    const fullTenantName = (addressData.baseURI || `${addressData.prefix || ''}${addressData.tenant}`).replace(/;|,|\s/g, '');
                    const maxAge = configuration.conversationCookieMaxAge || 3600;
                    addCookie(`retorikConversationCookie=<conversationId>||${fullTenantName}; max-age=${maxAge}`);
                }
            }
            test && setDirectLineCreationData({
                token: token,
                domain: directLineData.address
            });
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        if (directLineCreationData && locale && processedUserData) !directLine && createDirectLine({
            ...directLineCreationData,
            conversationStartProperties: {
                locale: locale
            },
            userId: processedUserData.id,
            externalActivityHandler: externalEventHandler
        });
    }, [
        locale,
        directLineCreationData,
        processedUserData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        addressData?.directline && processDirectLine(addressData.directline);
        return ()=>{
            console.log('Retorik Framework > disconnect and end directline');
            resetDirectlineStore();
        };
    }, [
        addressData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (locale && supported && agentData && connectionStatus === (0, $eo2R4.ConnectionStatus).Online && (isRetorikNews || loaderClosed)) setAppAvailable(true);
    }, [
        locale,
        supported,
        agentData,
        loaderClosed,
        connectionStatus
    ]);
    return directLine && agentData && processedUserData ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7c6BL.default), {
                isRetorikNews: isRetorikNews,
                hasConversationCookie: hasConversationCookie,
                userData: processedUserData
            }),
            children
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $6a60c4ac572a9b7a$export$2e2bcd8739ae039 = $6a60c4ac572a9b7a$var$RetorikComposer;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $bWQ72 = parcelRequire("bWQ72");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $9qyYE = parcelRequire("9qyYE");

var $2rYkD = parcelRequire("2rYkD");

var $VZzOq = parcelRequire("VZzOq");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");

var $gQoxd = parcelRequire("gQoxd");
const $a174d1df6657d370$var$springDuration = 1050;
const $a174d1df6657d370$var$VoiceInput = ({ className: className })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const lastRecognitionInterim = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const isWaitingForResponse = (0, $7SHCs.useRetorikStore)((state)=>state.isWaitingForResponse);
    const [remainingLastRecognitionInterim, setRemainingLastRecognitionInterim] = (0, $bxRTa.useState)(null);
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 1
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (lastRecognitionInterim) setRemainingLastRecognitionInterim(lastRecognitionInterim);
        else if (remainingLastRecognitionInterim) {
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $a174d1df6657d370$var$springDuration
                }
            });
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            animationTimerRef.current = setTimeout(()=>{
                api.set({
                    opacity: 1
                });
                setRemainingLastRecognitionInterim(null);
            }, $a174d1df6657d370$var$springDuration);
        }
    }, [
        lastRecognitionInterim
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: isWaitingForResponse ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $gQoxd.default), {
            classname: `rf-flex ${isMobile ? 'rf-justify-center' : 'rf-pl-8 rf-justify-start'} rf-py-3 rf-items-center`,
            subClassname: "rf-w-4 rf-h-4",
            size: (0, $2rYkD.AnimationSize).medium,
            useTextColor: true
        }) : remainingLastRecognitionInterim && (isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).p, {
            className: className,
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bTjo.animated).div, {
            className: "rf-w-full rf-py-3 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-shadow-black",
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }))
    });
};
var $a174d1df6657d370$export$2e2bcd8739ae039 = $a174d1df6657d370$var$VoiceInput;



var $dq6kU = parcelRequire("dq6kU");
const $515c6bb01607ffda$var$UserRequest = ()=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const mediumLandscape = (0, $9JLpC.useViewStore)((state)=>state.mediumLandscape);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (typeof configuration?.answerpanel === 'object') switch(mode){
                    case (0, $2rYkD.Mode).text:
                        if (configuration.answerpanel.landscape?.containerRowEndText) {
                            setGridRowStart(configuration.answerpanel.landscape.containerRowEndText);
                            setGridRowSpan(13 - configuration.answerpanel.landscape.containerRowEndText);
                        } else {
                            setGridRowStart(11);
                            setGridRowSpan(2);
                        }
                        break;
                    case (0, $2rYkD.Mode).vocal:
                        setGridRowStart(1);
                        if (configuration.answerpanel.landscape?.containerRowStart) setGridRowSpan(configuration.answerpanel.landscape.containerRowStart - 1);
                        else setGridRowSpan(3);
                        break;
                    default:
                        break;
                }
                else {
                    setGridRowStart(mode === (0, $2rYkD.Mode).text ? 11 : 1);
                    setGridRowSpan(mode === (0, $2rYkD.Mode).text ? 2 : 3);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne?.containerRowStart) {
                    setGridRowStart(1);
                    setGridRowSpan(configuration.answerpanel.borne.containerRowStart - 1);
                } else {
                    setGridRowStart(4);
                    setGridRowSpan(2);
                }
                break;
        }
    }, [
        mode,
        configuration.answerpanel,
        currentDeviceType
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-userRequest",
        className: `rf-relative rf-z-util rf-h-full rf-w-3/5 landscape-retorik:rf-w-[calc(80%-10rem)] landscape-retorik:rf-ml-1/5 rf-py-4 large-vertical:rf-py-5 rf-flex rf-flex-col rf-justify-self-center rf-justify-end landscape-retorik:rf-justify-self-start
        ${mode === (0, $2rYkD.Mode).text && 'landscape-retorik:rf-justify-start'}
        ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} large-vertical:rf-col-start-1 rf-col-span-full rf-text-size-auto rf-text-trueblack`,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: mode === (0, $2rYkD.Mode).text ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a174d1df6657d370$export$2e2bcd8739ae039), {})
    });
};
var $515c6bb01607ffda$export$2e2bcd8739ae039 = $515c6bb01607ffda$var$UserRequest;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $hvWkK = parcelRequire("hvWkK");

var $dq6kU = parcelRequire("dq6kU");
const $5377bf2433391660$var$UserRequest = ()=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const mediumLandscape = (0, $9JLpC.useViewStore)((state)=>state.mediumLandscape);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const [paddingTop, setPaddingTop] = (0, $bxRTa.useState)();
    const [paddingBottom, setPaddingBottom] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape?.containerRowEndText) {
                    setGridRowStart(configuration.answerpanel.landscape.containerRowEndText);
                    setGridRowSpan(13 - configuration.answerpanel.landscape.containerRowEndText);
                } else {
                    setGridRowStart(10);
                    setGridRowSpan(3);
                }
                setPaddingTop(currentHeight * 1 / 12 - 1.5 * remToPx);
                setPaddingBottom(remToPx);
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne?.containerRowStart) {
                    setGridRowStart(1);
                    setGridRowSpan(configuration.answerpanel.borne.containerRowStart - 1);
                } else {
                    setGridRowStart(4);
                    setGridRowSpan(2);
                }
                setPaddingTop(remToPx * 1.25);
                setPaddingBottom(remToPx * 1.25);
                break;
        }
    }, [
        configuration.answerpanel,
        currentDeviceType,
        currentHeight
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-userRequest",
        className: `rf-relative rf-z-[5] rf-h-full rf-w-3/5 landscape-retorik:rf-w-[calc(80%-10rem)] landscape-retorik:rf-ml-1/5 rf-flex rf-flex-col rf-justify-self-center rf-justify-end landscape-retorik:rf-justify-self-start landscape-retorik:rf-justify-start
        ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} large-vertical:rf-col-start-1 rf-col-span-full rf-text-size-auto rf-text-trueblack`,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom
        },
        children: mode === (0, $2rYkD.Mode).text ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hvWkK.default), {})
    });
};
var $5377bf2433391660$export$2e2bcd8739ae039 = $5377bf2433391660$var$UserRequest;



var $h0yA8 = parcelRequire("h0yA8");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $bWQ72 = parcelRequire("bWQ72");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $jz5ru = parcelRequire("jz5ru");

var $2nxul = parcelRequire("2nxul");
const $93405e9c3a3a1a91$var$BotResponse = ()=>{
    const speaking = (0, $giKuE.useSpeechStore)((state)=>state.speaking);
    const lastRecognitionInterim = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const currentOrLastPlayedActivity = (0, $giKuE.useSpeechStore)((state)=>state.currentOrLastPlayedActivity);
    const botMessageActivities = (0, $bWQ72.useActivityStore)((state)=>state.botMessageActivities);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const currentWidth = (0, $9JLpC.useViewStore)((state)=>state.currentWidth);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const mediumLandscape = (0, $9JLpC.useViewStore)((state)=>state.mediumLandscape);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const setListStatus = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setListStatus);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const botResponseClassname = (0, $bxRTa.useMemo)(()=>{
        let classname = 'rf-relative rf-w-full rf-h-full rf-z-util rf-overflow-y-scroll rf-scrollbar-thin';
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                {
                    // Special case for very small screens
                    const isSmall = currentHeight < 700 && currentWidth < 300;
                    classname += ' rf-col-start-1 rf-col-span-full';
                    setGridRowStart(isSmall ? 5 : 6);
                    if (displaySubtitles && speaking) setGridRowSpan(isSmall ? 6 : 5);
                    else setGridRowSpan(isSmall ? 7 : 6);
                    break;
                }
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                classname += ` ${mediumLandscape ? 'rf-col-start-3' : 'rf-col-start-4'} rf-col-span-full`;
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.landscape) {
                    const start = configuration.answerpanel.landscape.containerRowStart;
                    const end = configuration.answerpanel.landscape.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(4);
                        setGridRowSpan(9);
                    }
                } else {
                    setGridRowStart(4);
                    setGridRowSpan(9);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                classname += ' rf-col-start-1 rf-col-span-full';
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.borne) {
                    const start = configuration.answerpanel.borne.containerRowStart;
                    const end = configuration.answerpanel.borne.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(6);
                        setGridRowSpan(5);
                    }
                } else {
                    setGridRowStart(6);
                    setGridRowSpan(5);
                }
                break;
        }
        return classname;
    }, [
        currentDeviceType,
        displaySubtitles,
        speaking,
        configuration.answerpanel,
        currentWidth,
        currentHeight
    ]);
    /**
   * Check if the current activity is a streaming one without attachments.
   * If so, let's check if we already received the message at the end of the streaming asn if it contains attachments to be displayed
   */ const processedCurrentOrLastPlayedActivity = (0, $bxRTa.useMemo)(()=>{
        if (currentOrLastPlayedActivity?.name?.toLowerCase() === 'davi.streammessageactivity' && !currentOrLastPlayedActivity?.attachments?.length) {
            const relatedMessageActivityWithAttachments = botMessageActivities.find((activity)=>activity.value?.streamingCount && activity.replyToId === currentOrLastPlayedActivity.replyToId && activity.attachments?.length);
            if (relatedMessageActivityWithAttachments) return relatedMessageActivityWithAttachments;
        }
        return currentOrLastPlayedActivity;
    }, [
        currentOrLastPlayedActivity,
        botMessageActivities
    ]);
    const currentDisplay = (0, $bxRTa.useMemo)(()=>{
        if (processedCurrentOrLastPlayedActivity) {
            if (processedCurrentOrLastPlayedActivity.attachmentLayout) switch(processedCurrentOrLastPlayedActivity.attachmentLayout.toLowerCase()){
                case 'davilist':
                    return (0, $2rYkD.Displays).list;
                case 'carousel':
                case 'namedlist':
                    return processedCurrentOrLastPlayedActivity.attachments && processedCurrentOrLastPlayedActivity.attachments.length > 1 ? (0, $2rYkD.Displays).carousel : (0, $2rYkD.Displays).normal;
                case 'grid':
                    return (0, $2rYkD.Displays).grid;
            }
            // If we have no attachment layout but attachment(s), we use list display by default is there are several attachments
            if (processedCurrentOrLastPlayedActivity.attachments?.length) return processedCurrentOrLastPlayedActivity.attachments?.length > 1 ? (0, $2rYkD.Displays).list : (0, $2rYkD.Displays).normal;
        }
        return (0, $2rYkD.Displays).none;
    }, [
        processedCurrentOrLastPlayedActivity
    ]);
    return currentDisplay === (0, $2rYkD.Displays).none ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : currentDisplay === (0, $2rYkD.Displays).list ? lastRecognitionInterim === '' && !(listStatus === (0, $2rYkD.ListStatus).closed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jz5ru.default), {
        activity: processedCurrentOrLastPlayedActivity,
        onClose: ()=>setListStatus((0, $2rYkD.ListStatus).closed)
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-botResponse",
        className: botResponseClassname,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: processedCurrentOrLastPlayedActivity && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col landscape-retorik:rf-items-start vertical:rf-items-center rf-gap-2",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2nxul.default), {
                activity: processedCurrentOrLastPlayedActivity
            })
        })
    });
};
var $93405e9c3a3a1a91$export$2e2bcd8739ae039 = $93405e9c3a3a1a91$var$BotResponse;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $bWQ72 = parcelRequire("bWQ72");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $jz5ru = parcelRequire("jz5ru");

var $2nxul = parcelRequire("2nxul");
const $6fe7ed64ef75b076$var$BotResponse = ()=>{
    const speaking = (0, $giKuE.useSpeechStore)((state)=>state.speaking);
    const lastRecognitionInterim = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const currentOrLastPlayedActivity = (0, $giKuE.useSpeechStore)((state)=>state.currentOrLastPlayedActivity);
    const botMessageActivities = (0, $bWQ72.useActivityStore)((state)=>state.botMessageActivities);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const currentWidth = (0, $9JLpC.useViewStore)((state)=>state.currentWidth);
    const currentHeight = (0, $9JLpC.useViewStore)((state)=>state.currentHeight);
    const mediumLandscape = (0, $9JLpC.useViewStore)((state)=>state.mediumLandscape);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const setListStatus = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setListStatus);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const botResponseClassname = (0, $bxRTa.useMemo)(()=>{
        let classname = 'rf-relative rf-w-full rf-h-full rf-z-util rf-overflow-y-scroll rf-scrollbar-hidden';
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                {
                    // Special case for very small screens
                    const isSmall = currentHeight < 700 && currentWidth < 300;
                    classname += ' rf-col-start-1 rf-col-span-full';
                    setGridRowStart(isSmall ? 5 : 6);
                    if (displaySubtitles && speaking) setGridRowSpan(isSmall ? 6 : 5);
                    else setGridRowSpan(isSmall ? 7 : 6);
                    break;
                }
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                classname += ` ${mediumLandscape ? 'rf-col-start-3' : 'rf-col-start-4'} rf-col-span-full rf-py-6`;
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape) {
                    const start = configuration.answerpanel.landscape.containerRowStart;
                    const end = configuration.answerpanel.landscape.containerRowEnd;
                    if (start && start > 0 && start < 11) {
                        if (end && end < 11) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(11 - start);
                        }
                    } else if (end && end > 0 && end < 11) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(3);
                        setGridRowSpan(7);
                    }
                } else {
                    setGridRowStart(3);
                    setGridRowSpan(7);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                classname += ' rf-col-start-1 rf-col-span-full';
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.borne) {
                    const start = configuration.answerpanel.borne.containerRowStart;
                    const end = configuration.answerpanel.borne.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(6);
                        setGridRowSpan(5);
                    }
                } else {
                    setGridRowStart(6);
                    setGridRowSpan(5);
                }
                break;
        }
        return classname;
    }, [
        currentDeviceType,
        displaySubtitles,
        speaking,
        configuration.answerpanel,
        currentWidth,
        currentHeight
    ]);
    /**
   * Check if the current activity is a streaming one without attachments.
   * If so, let's check if we already received the message at the end of the streaming asn if it contains attachments to be displayed
   */ const processedCurrentOrLastPlayedActivity = (0, $bxRTa.useMemo)(()=>{
        if (currentOrLastPlayedActivity?.name?.toLowerCase() === 'davi.streammessageactivity' && !currentOrLastPlayedActivity?.attachments?.length) {
            const relatedMessageActivityWithAttachments = botMessageActivities.find((activity)=>activity.value?.streamingCount && activity.replyToId === currentOrLastPlayedActivity.replyToId && activity.attachments?.length);
            if (relatedMessageActivityWithAttachments) return relatedMessageActivityWithAttachments;
        }
        return currentOrLastPlayedActivity;
    }, [
        currentOrLastPlayedActivity,
        botMessageActivities
    ]);
    const currentDisplay = (0, $bxRTa.useMemo)(()=>{
        if (processedCurrentOrLastPlayedActivity) {
            if (processedCurrentOrLastPlayedActivity.attachmentLayout) switch(processedCurrentOrLastPlayedActivity.attachmentLayout.toLowerCase()){
                case 'davilist':
                    return (0, $2rYkD.Displays).list;
                case 'carousel':
                case 'namedlist':
                    return processedCurrentOrLastPlayedActivity.attachments && processedCurrentOrLastPlayedActivity.attachments.length > 1 ? (0, $2rYkD.Displays).carousel : (0, $2rYkD.Displays).normal;
                case 'grid':
                    return (0, $2rYkD.Displays).grid;
            }
            // If we have no attachment layout but attachment(s), we use list display by default is there are several attachments
            if (processedCurrentOrLastPlayedActivity.attachments?.length) return processedCurrentOrLastPlayedActivity.attachments?.length > 1 ? (0, $2rYkD.Displays).list : (0, $2rYkD.Displays).normal;
        }
        return (0, $2rYkD.Displays).none;
    }, [
        processedCurrentOrLastPlayedActivity
    ]);
    return currentDisplay === (0, $2rYkD.Displays).none ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : currentDisplay === (0, $2rYkD.Displays).list ? lastRecognitionInterim === '' && !(listStatus === (0, $2rYkD.ListStatus).closed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jz5ru.default), {
        activity: processedCurrentOrLastPlayedActivity,
        onClose: ()=>setListStatus((0, $2rYkD.ListStatus).closed)
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-botResponse",
        className: botResponseClassname,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: processedCurrentOrLastPlayedActivity && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col landscape-retorik:rf-justify-center landscape-retorik:rf-items-start vertical:rf-items-center rf-gap-2",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2nxul.default), {
                activity: processedCurrentOrLastPlayedActivity
            })
        })
    });
};
var $6fe7ed64ef75b076$export$2e2bcd8739ae039 = $6fe7ed64ef75b076$var$BotResponse;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");
parcelRequire("kMAJU");
var $lHTuW = parcelRequire("lHTuW");
const $6ebf4aa8111d9d5f$var$RetorikLogo = ()=>{
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    return isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-hidden large:rf-block rf-relative rf-z-[1] ltr:rf-col-start-1 rtl:rf-col-end-1 rf-col-span-full rf-row-start-12 rf-row-span-1 ltr:rf-self-end rtl:rf-self-start rf-justify-self-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
            className: "ltr:rf-ml-4 rtl:rf-mr-4 rf-mb-4 rf-h-14"
        })
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)("a", {
        href: "https://davi.ai",
        title: "Retorik by Davi",
        target: "_blank",
        rel: "noreferrer",
        className: "rf-hidden large:rf-block rf-relative rf-z-[1] rf-col-start-1 rf-col-span-full rf-row-start-12 rf-row-span-1 rf-self-end rf-justify-self-start",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
            className: "rf-ml-4 rf-mb-4 rf-h-14"
        })
    });
};
var $6ebf4aa8111d9d5f$export$2e2bcd8739ae039 = $6ebf4aa8111d9d5f$var$RetorikLogo;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $2eBYD = parcelRequire("2eBYD");

var $bWQ72 = parcelRequire("bWQ72");
const $7123c24c9dc0e392$var$useShowEmergency = ()=>{
    const lastBotActivity = (0, $bWQ72.useActivityStore)((state)=>state.lastBotActivity);
    if (lastBotActivity && lastBotActivity.type === 'event' && lastBotActivity.name === 'Hospitality.ShowEmergency') return true;
    return false;
};
var $7123c24c9dc0e392$export$2e2bcd8739ae039 = $7123c24c9dc0e392$var$useShowEmergency;



var $bWQ72 = parcelRequire("bWQ72");
const $649376ba64029917$var$useShowMap = ()=>{
    const lastActivity = (0, $bWQ72.useActivityStore)((state)=>state.lastActivity);
    if (lastActivity?.type === 'event' && lastActivity.name === 'Hospitality.ShowMap') return true;
    return false;
};
var $649376ba64029917$export$2e2bcd8739ae039 = $649376ba64029917$var$useShowMap;



var $2rYkD = parcelRequire("2rYkD");

const $2ddb2b8c38f184e3$var$HistoryList = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("b5pvk")));

const $2ddb2b8c38f184e3$var$LanguageChoice = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("5vqr0")));

const $2ddb2b8c38f184e3$var$AttachmentDetails = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("f4HPR")));

const $2ddb2b8c38f184e3$var$FullScreenImage = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("iFNHz")));

const $2ddb2b8c38f184e3$var$Weather = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("VHvle")));

const $2ddb2b8c38f184e3$var$CustomView = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("6JZzf")));

const $2ddb2b8c38f184e3$var$Emergency = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("6BMly")));
const $2ddb2b8c38f184e3$var$SubViews = ({ externalComponents: externalComponents })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const currentCustomView = (0, $4xGiN.useUtilsStore)((state)=>state.currentCustomView);
    const enabledFeatures = (0, $7SHCs.useRetorikStore)((state)=>state.enabledFeatures);
    const { setCurrentCustomView: setCurrentCustomView, setCurrentSubView: setCurrentSubView, setRetorikEvent: setRetorikEvent, unlockClickedButton: unlockClickedButton } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const showMap = (0, $649376ba64029917$export$2e2bcd8739ae039)();
    const showEmergency = (0, $7123c24c9dc0e392$export$2e2bcd8739ae039)();
    const [displayCustomComponent, setDisplayCustomComponent] = (0, $bxRTa.useState)(true);
    const [customView, setCustomView] = (0, $bxRTa.useState)(undefined);
    (0, $bxRTa.useEffect)(()=>{
        if (currentCustomView) {
            let label = '';
            if (currentCustomView.label && typeof currentCustomView.label === 'string') label = currentCustomView.label;
            else if (currentCustomView.label && typeof currentCustomView.label === 'object') label = currentCustomView.label[locale];
            if (label && currentCustomView.customDisplay && currentCustomView.icon) setCustomView({
                view: currentCustomView.customDisplay,
                title: label,
                icon: currentCustomView.icon
            });
            setCurrentSubView((0, $2rYkD.CurrentSubView).custom);
        }
    }, [
        currentCustomView
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (showMap && currentSubView !== (0, $2rYkD.CurrentSubView).custom) {
            if (externalComponents && externalComponents.length > 0) {
                const component = externalComponents?.find((e)=>e.name === 'mapDisplay');
                if (component && component.component) {
                    if (configuration.baseMenu || configuration.customMenu) {
                        let allMenus = [];
                        configuration.baseMenu && // Filter on 'icon' key to get only CustomMenu items
                        (allMenus = [
                            ...configuration.baseMenu
                        ].filter((m)=>Object.keys(m).includes('icon')));
                        if (configuration.customMenu && configuration.customMenu.length > 0) {
                            if (Array.isArray(configuration.customMenu[0])) {
                                const tempCustomMenu = configuration.customMenu;
                                tempCustomMenu.forEach((menu)=>{
                                    allMenus = [
                                        ...allMenus,
                                        ...menu
                                    ];
                                });
                            } else allMenus = [
                                ...allMenus,
                                ...configuration.customMenu
                            ];
                        }
                        const customMenuMap = allMenus.find((c)=>c.customDisplay && c.customDisplay === 'mapDisplay');
                        if (customMenuMap) {
                            if (customView && customView.view === customMenuMap.customDisplay) ;
                            else setCurrentCustomView(customMenuMap);
                            setRetorikEvent((0, $2rYkD.RetorikEvent).DetailViewOpen);
                            setCurrentSubView((0, $2rYkD.CurrentSubView).custom);
                            setDisplayCustomComponent(true);
                        }
                    }
                }
            }
        }
    }, [
        showMap
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (showEmergency) setCurrentSubView((0, $2rYkD.CurrentSubView).emergency);
    }, [
        showEmergency
    ]);
    (0, $bxRTa.useEffect)(()=>{
        unlockClickedButton();
        // Special processing for external / custom data
        setDisplayCustomComponent(currentSubView === (0, $2rYkD.CurrentSubView).custom);
        setRetorikEvent(currentSubView === (0, $2rYkD.CurrentSubView).none ? (0, $2rYkD.RetorikEvent).DetailViewClose : (0, $2rYkD.RetorikEvent).DetailViewOpen);
    }, [
        currentSubView
    ]);
    const processedSubView = (0, $bxRTa.useMemo)(()=>{
        switch(currentSubView){
            case (0, $2rYkD.CurrentSubView).none:
            case (0, $2rYkD.CurrentSubView).history:
            case (0, $2rYkD.CurrentSubView).languages:
            case (0, $2rYkD.CurrentSubView).custom:
                return currentSubView;
            case (0, $2rYkD.CurrentSubView).emergency:
                if (enabledFeatures.includes('emergency')) return (0, $2rYkD.CurrentSubView).emergency;
                else console.log('Retorik Framework > tried to switch to emergency while the feature is not activated in Retorik Studio');
                break;
            case (0, $2rYkD.CurrentSubView).weather:
                if (enabledFeatures.includes('weather')) return (0, $2rYkD.CurrentSubView).weather;
                else console.log('Retorik Framework > tried to switch to weather while the feature is not activated in Retorik Studio');
                break;
        }
        return (0, $2rYkD.CurrentSubView).none;
    }, [
        currentSubView,
        enabledFeatures
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $bxRTa.Suspense), {
        children: [
            processedSubView === (0, $2rYkD.CurrentSubView).history ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$HistoryList, {}) : processedSubView === (0, $2rYkD.CurrentSubView).languages ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$LanguageChoice, {}) : processedSubView === (0, $2rYkD.CurrentSubView).weather ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$Weather, {}) : processedSubView === (0, $2rYkD.CurrentSubView).emergency ? /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$Emergency, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$CustomView, {
                display: displayCustomComponent,
                externalComponents: externalComponents,
                customView: customView?.view,
                title: customView?.title,
                icon: customView?.icon,
                setDisplayCustomComponent: setDisplayCustomComponent
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$AttachmentDetails, {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)($2ddb2b8c38f184e3$var$FullScreenImage, {})
        ]
    });
};
var $2ddb2b8c38f184e3$export$2e2bcd8739ae039 = $2ddb2b8c38f184e3$var$SubViews;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $bWQ72 = parcelRequire("bWQ72");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");
/**
 * Check if the activity data need a display as list to be triggered
 * @param activity : RetorikActivity
 * @returns boolean
 */ const $af3086b4a2d8da64$export$7c55936a30618336 = (activity)=>{
    return !!(activity?.attachmentLayout?.toLowerCase() === 'davilist' || activity?.attachmentLayout?.toLowerCase() !== 'carousel' && activity?.attachmentLayout?.toLowerCase() !== 'grid' && activity?.attachmentLayout?.toLowerCase() !== 'namedlist' && activity?.attachments?.length && activity.attachments.length > 1);
};



var $6hEoY = parcelRequire("6hEoY");

var $2rYkD = parcelRequire("2rYkD");

var $jz5ru = parcelRequire("jz5ru");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $9qyYE = parcelRequire("9qyYE");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");

var $k4qlo = parcelRequire("k4qlo");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");
const $48dbcf3910a29a57$var$ConversationHeader = ({ agentName: agentName = "L\xe9a", companyName: companyName, companyNameLocalized: companyNameLocalized, subCompanyMessage: subCompanyMessage, subCompanyMessageLocalized: subCompanyMessageLocalized, imageUrl: imageUrl = '' })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.localeForRetorikStudioContent);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const [processedCompanyName, setProcessedCompanyName] = (0, $bxRTa.useState)();
    const [processedSubCompanyName, setProcessedSubCompanyName] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        const company = companyNameLocalized?.[locale] || companyName;
        const subCompany = subCompanyMessageLocalized?.[locale] || subCompanyMessage;
        if (company || subCompany) {
            setProcessedCompanyName(company);
            setProcessedSubCompanyName(subCompany);
        } else {
            setProcessedCompanyName('Davi');
            setProcessedSubCompanyName(`${agentName} ${translation.menu.answer}`);
        }
    }, [
        locale,
        companyName,
        companyNameLocalized,
        subCompanyMessage,
        subCompanyMessageLocalized
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-conversation-header",
        className: "rf-w-full rf-h-fit rf-grid rf-grid-cols-headerContainer rf-grid-rows-headerContainer rf-bg-truewhite rf-bg-opacity-80",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-col-start-1 rf-col-end-2 rf-row-start-1 rf-row-end-3 rf-flex rf-items-center rf-px-2 rf-py-2",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    src: imageUrl,
                    alt: "Agent",
                    className: "rf-w-full rf-max-h-20 rf-aspect-square rf-rounded-half rf-border-secondary rf-border-2 rf-bg-truewhite"
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-col-start-3 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-justify-center",
                children: [
                    processedCompanyName && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-font-bold rf-leading-4",
                        style: {
                            color: themeColors.companyName
                        },
                        children: processedCompanyName
                    }),
                    processedSubCompanyName && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-text-sm/4 rf-italic",
                        children: processedSubCompanyName
                    })
                ]
            })
        ]
    });
};
var $48dbcf3910a29a57$export$2e2bcd8739ae039 = $48dbcf3910a29a57$var$ConversationHeader;



var $hC8yR = parcelRequire("hC8yR");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $bWQ72 = parcelRequire("bWQ72");


var $aC3vq = parcelRequire("aC3vq");

var $2rYkD = parcelRequire("2rYkD");

var $2nxul = parcelRequire("2nxul");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2eBYD = parcelRequire("2eBYD");

var $2rYkD = parcelRequire("2rYkD");

var $3Gcj3 = parcelRequire("3Gcj3");
const $02ee0b23a8a78333$var$interval = 45;
const $02ee0b23a8a78333$var$splitRegex = new RegExp(/<[^<>]+>/g);
const $02ee0b23a8a78333$var$TextBubble = ({ from: from, id: id, text: text, htmlText: htmlText, showWaitingDots: showWaitingDots, isWaitingDots: isWaitingDots, triggerScroll: triggerScroll, onEnded: onEnded, canBeEnded: canBeEnded, isEnded: isEnded })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const [currentHtmlText, setCurrentHtmlText] = (0, $bxRTa.useState)('');
    const [ended, setEnded] = (0, $bxRTa.useState)(isEnded);
    const intervalRef = (0, $bxRTa.useRef)(null);
    const streamRef = (0, $bxRTa.useRef)([]);
    const streamIndexRef = (0, $bxRTa.useRef)(0);
    const canBeEndedRef = (0, $bxRTa.useRef)();
    (0, $bxRTa.useEffect)(()=>{
        setEnded(isEnded);
    }, [
        isEnded
    ]);
    (0, $bxRTa.useEffect)(()=>{
        canBeEndedRef.current = canBeEnded;
    }, [
        canBeEnded
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (htmlText) isEnded ? setEnded(true) : handleNewStreaming(htmlText);
        return ()=>{
            intervalRef.current && clearInterval(intervalRef.current);
        };
    }, [
        htmlText,
        ended
    ]);
    (0, $bxRTa.useEffect)(()=>{
        ended && endStreaming();
    }, [
        ended
    ]);
    const endStreaming = ()=>{
        setCurrentHtmlText(htmlText || '');
        onEnded?.();
        intervalRef.current && clearInterval(intervalRef.current);
    };
    const handleNewStreaming = (text)=>{
        streamRef.current = [];
        let test = false;
        while(test === false){
            const index = text.search($02ee0b23a8a78333$var$splitRegex);
            if (index === -1) {
                streamRef.current = [
                    ...streamRef.current,
                    ...Array.from(text)
                ];
                test = true;
            } else {
                const match = text.match($02ee0b23a8a78333$var$splitRegex);
                if (match?.length) {
                    const firstPart = index ? Array.from(text.slice(0, index)) : [];
                    streamRef.current = [
                        ...streamRef.current,
                        ...firstPart,
                        match[0]
                    ];
                    text = text.slice(firstPart.length + match[0].length);
                } else test = true;
            }
        }
        intervalRef.current = setInterval(()=>{
            if (streamIndexRef.current < streamRef.current.length) {
                const current = streamRef.current[streamIndexRef.current];
                setCurrentHtmlText((value)=>`${value}${current}`);
                streamIndexRef.current = streamIndexRef.current + 1;
                streamIndexRef.current % 20 === 0 && triggerScroll();
            } else canBeEndedRef.current && setEnded(true);
        }, $02ee0b23a8a78333$var$interval);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: from === (0, $2rYkD.TextFrom).user ? `retorik-userQuestion-${id}` : `retorik-botResponse-${id}`,
        dir: isRTL ? 'rtl' : 'ltr',
        className: `rf-w-fit ${from === (0, $2rYkD.TextFrom).user ? 'rf-min-h-fit' : 'rf-min-h-9 large-vertical:rf-min-h-10'} rf-px-4 rf-py-2 rf-max-w-[75%] landscape-retorik:rf-max-w-[calc((80%-10rem)*0.75)] large-vertical:rf-max-w-[45%] ${isMobile && 'rf-mx-4'} ${isRTL ? from === (0, $2rYkD.TextFrom).bot ? 'landscape-retorik:rf-mr-40 large-vertical:rf-mr-1/5 rf-self-end rf-text-textModePanelConversationBot rf-bg-textModePanelBackgroundBot rf-border rf-border-textModePanelBackgroundBot rf-rounded-tl-4' : 'landscape-retorik:rf-ml-1/5 large-vertical:rf-ml-1/5 rf-text-textModePanelConversationUser rf-bg-textModePanelBackgroundUser rf-border rf-border-textModePanelBackgroundUser rf-rounded-tr-4' : from === (0, $2rYkD.TextFrom).user ? 'landscape-retorik:rf-mr-40 large-vertical:rf-mr-1/5 rf-self-end rf-text-textModePanelConversationUser rf-bg-textModePanelBackgroundUser rf-border rf-border-textModePanelBackgroundUser rf-rounded-tl-4' : 'landscape-retorik:rf-ml-1/5 large-vertical:rf-ml-1/5 rf-text-textModePanelConversationBot rf-bg-textModePanelBackgroundBot rf-border rf-border-textModePanelBackgroundBot rf-rounded-tr-4'} rf-rounded-b-4 rf-animate-slideBottom rf-flex rf-flex-col rf-text-size-auto rf-shadow-[0_3px_6px_#00000029]`,
        children: isWaitingDots ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-w-8 rf-loader-bouncing-bot"
        }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
            children: [
                currentHtmlText ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: currentHtmlText
                    }
                }) : text ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    children: (0, $3Gcj3.getTextWithoutSpeechMarkdown)(text)
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
                showWaitingDots && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-font-bold rf-animate-blink",
                    children: "..."
                })
            ]
        })
    }, id);
};
var $02ee0b23a8a78333$export$2e2bcd8739ae039 = $02ee0b23a8a78333$var$TextBubble;


const $f776c70e79442292$var$DisplayStandard = ({ currentQuestionId: currentQuestionId, activities: activities, triggerScroll: triggerScroll, isWaitingForResponse: isWaitingForResponse })=>{
    const endedActivities = (0, $bWQ72.useActivityStore)((state)=>state.endedActivities);
    const watermark = (0, $bWQ72.useActivityStore)((state)=>state.watermark);
    const forceMobileView = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.forceMobileView);
    const [displayData, setDisplayData] = (0, $bxRTa.useState)([]);
    const [currentDisplayDataIndex, setCurrentDisplayDataIndex] = (0, $bxRTa.useState)(0);
    const [ended, setEnded] = (0, $bxRTa.useState)(!activities.length || endedActivities.includes(activities[activities.length - 1]?.id));
    const activitiesRef = (0, $bxRTa.useRef)([]);
    const displayDataRef = (0, $bxRTa.useRef)([]);
    (0, $bxRTa.useEffect)(()=>{
        setEnded(endedActivities.includes(activities[activities.length - 1]?.id));
        setDisplayData([]);
        setCurrentDisplayDataIndex(0);
    }, [
        currentQuestionId
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (isWaitingForResponse) {
            // Create temporary activity with the id of the next one to prevent re-renders, in order to display waiting dots
            const nextActivityId = `${currentQuestionId.slice(0, currentQuestionId.length - watermark.toString().length)}${watermark.toString()}`;
            const tempActivity = {
                id: nextActivityId,
                from: {
                    id: 'fake-bot-id',
                    role: 'bot'
                },
                type: 'message'
            };
            setDisplayData([
                {
                    activity: tempActivity,
                    type: (0, $2rYkD.DisplayDataTypes).text,
                    isWaitingDots: true,
                    canBeEnded: true,
                    isEnded: false
                }
            ]);
        }
    }, [
        isWaitingForResponse
    ]);
    (0, $bxRTa.useEffect)(()=>{
        activitiesRef.current = [
            ...activities
        ];
        if (activities.length) {
            let tempDisplayData = [];
            let currentFirstStreamingActivity;
            let streamingActivityHasAttachment = false;
            let streamingTexts = [];
            activities.forEach((activity, index)=>{
                let splitTextDataToAdd = [];
                // Check the attachments, special case if this is the message activity after streaming : show attachments if the first streaming activity didn't have any
                let attachments = [];
                if (activity.attachments?.length) {
                    if (activity.name?.toLowerCase() === 'davi.streammessageactivity') {
                        streamingActivityHasAttachment = true;
                        attachments = [
                            {
                                type: (0, $2rYkD.DisplayDataTypes).attachment,
                                activity: activity,
                                canBeEnded: true,
                                isEnded: true
                            }
                        ];
                    } else if (!(activity.value?.streamingCount && streamingActivityHasAttachment) && !(0, $af3086b4a2d8da64$export$7c55936a30618336)(activity)) attachments = [
                        {
                            type: (0, $2rYkD.DisplayDataTypes).attachment,
                            activity: activity,
                            canBeEnded: true,
                            isEnded: true
                        }
                    ];
                }
                // Deal with streaming activity first, then other activities except the complete streaming message
                if (activity.name?.toLowerCase() === 'davi.streammessageactivity') {
                    // Set this streaming activity as first one if there is none
                    !currentFirstStreamingActivity && (currentFirstStreamingActivity = activity);
                    if (activity.text) {
                        streamingTexts.push(activity.text);
                        // If this is the last activity or if the next one isn't a streaming one, let's put the data in the array of data to display
                        if (index === activities.length - 1 || activities[index + 1].name?.toLowerCase() !== 'davi.streammessageactivity') splitTextDataToAdd = [
                            {
                                type: (0, $2rYkD.DisplayDataTypes).text,
                                activity: {
                                    ...currentFirstStreamingActivity,
                                    htmlText: (0, $aC3vq.processMarkdownAndSpeechMarkdown)(streamingTexts.join(''), false).htmlText
                                },
                                canBeEnded: false,
                                isEnded: false
                            }
                        ];
                    }
                } else if (activity.value?.streamingCount) {
                    if (tempDisplayData.length) {
                        const lastStreamingIndex = tempDisplayData.findLastIndex((d)=>d.type === (0, $2rYkD.DisplayDataTypes).text);
                        if (lastStreamingIndex !== -1) {
                            // Set canBeEnded for the previous streaming
                            tempDisplayData[lastStreamingIndex].canBeEnded = true;
                            // Set previous streaming ended if this activity is ended in speech synthesis
                            tempDisplayData[lastStreamingIndex].isEnded = endedActivities.includes(activity.id);
                        }
                    }
                    // Reset streaming data if the message containing all streaming data is received
                    currentFirstStreamingActivity = undefined;
                    streamingActivityHasAttachment = false;
                    streamingTexts = [];
                } else {
                    let text = activity.htmlText;
                    if (!text && activity.text) text = (0, $aC3vq.processMarkdownAndSpeechMarkdown)(activity.text, false).htmlText;
                    if (text) {
                        activity.htmlText = text;
                        splitTextDataToAdd = [
                            {
                                type: (0, $2rYkD.DisplayDataTypes).text,
                                activity: activity,
                                canBeEnded: true,
                                isEnded: endedActivities.includes(activity.id)
                            }
                        ];
                    }
                }
                if (attachments.length || splitTextDataToAdd.length) {
                    if (activity.messageType === 'welcome') tempDisplayData = [
                        ...tempDisplayData,
                        ...attachments,
                        ...splitTextDataToAdd
                    ];
                    else tempDisplayData = [
                        ...tempDisplayData,
                        ...splitTextDataToAdd,
                        ...attachments
                    ];
                }
            });
            setDisplayData(tempDisplayData);
        }
    }, [
        currentQuestionId,
        activities.length,
        endedActivities
    ]);
    (0, $bxRTa.useEffect)(()=>{
        displayDataRef.current = [
            ...displayData
        ];
    }, [
        displayData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (displayData.length && currentDisplayDataIndex <= displayData.length && !ended) {
            if (currentDisplayDataIndex === displayData.length) setEnded(true);
            else if (displayData[currentDisplayDataIndex].type === (0, $2rYkD.DisplayDataTypes).attachment) {
                setCurrentDisplayDataIndex((current)=>current + 1);
                !ended && triggerScroll();
            }
        }
    }, [
        currentDisplayDataIndex,
        displayData,
        ended
    ]);
    const handleEnded = ()=>{
        setCurrentDisplayDataIndex((current)=>current + 1);
        !ended && triggerScroll();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: displayData.map((data, key)=>{
            if (key <= currentDisplayDataIndex || ended) {
                if (data.type === (0, $2rYkD.DisplayDataTypes).attachment) return data.activity.attachments?.length && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${forceMobileView ? 'rf-m-auto' : 'rf-w-full'} ${data.activity.attachments.filter((att)=>att.contentType.includes('card')).length === 1 && 'mobile:rf-px-4'} rf-flex rf-flex-col vertical:rf-items-center rf-gap-2`,
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2nxul.default), {
                        activity: data.activity,
                        triggerScroll: triggerScroll
                    })
                }, `${data.activity.id}-${key}`);
                else if (data.type === (0, $2rYkD.DisplayDataTypes).text) return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $02ee0b23a8a78333$export$2e2bcd8739ae039), {
                    from: (0, $2rYkD.TextFrom).bot,
                    id: data.activity.id,
                    htmlText: data.activity.htmlText,
                    triggerScroll: triggerScroll,
                    onEnded: handleEnded,
                    canBeEnded: data.canBeEnded,
                    isEnded: data.isEnded,
                    isWaitingDots: data.isWaitingDots
                }, `${data.activity.id}-${key}`);
            }
            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}, `${data.activity.id}-${key}`);
        })
    });
};
var $f776c70e79442292$export$2e2bcd8739ae039 = $f776c70e79442292$var$DisplayStandard;



var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");


var $9JLpC = parcelRequire("9JLpC");
const $94f2aceac6df6117$var$ConversationDisplay = ({ userQuestion: userQuestion, botResponses: botResponses, isMobile: isMobile, triggerScroll: triggerScroll, canBeStreaming: canBeStreaming })=>{
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const isWaitingForResponse = (0, $7SHCs.useRetorikStore)((state)=>state.isWaitingForResponse);
    return isLandscape ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: `retorik-botResponses-${userQuestion?.id}`,
                className: "rf-flex rf-flex-col rf-text-size-auto rf-gap-4 rf-scrollbar-hidden",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f776c70e79442292$export$2e2bcd8739ae039), {
                    currentQuestionId: userQuestion?.id || 'fake-question-id',
                    triggerScroll: triggerScroll,
                    activities: botResponses || [],
                    isWaitingForResponse: isWaitingForResponse
                })
            }),
            userQuestion?.text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $02ee0b23a8a78333$export$2e2bcd8739ae039), {
                from: (0, $2rYkD.TextFrom).user,
                id: userQuestion.id,
                text: userQuestion.text,
                triggerScroll: triggerScroll,
                isEnded: true
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            userQuestion?.text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $02ee0b23a8a78333$export$2e2bcd8739ae039), {
                from: (0, $2rYkD.TextFrom).user,
                id: userQuestion.id,
                text: userQuestion.text,
                triggerScroll: triggerScroll,
                isEnded: true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: `retorik-botResponses-${userQuestion?.id}`,
                className: "rf-flex rf-flex-col rf-text-size-auto rf-gap-4 rf-scrollbar-hidden",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $f776c70e79442292$export$2e2bcd8739ae039), {
                    currentQuestionId: userQuestion?.id || 'fake-question-id',
                    triggerScroll: triggerScroll,
                    activities: botResponses || [],
                    isWaitingForResponse: isWaitingForResponse && (!isMobile || isMobile && canBeStreaming)
                })
            })
        ]
    });
};
var $94f2aceac6df6117$export$2e2bcd8739ae039 = $94f2aceac6df6117$var$ConversationDisplay;


const $c2e3409b981f8d9b$var$ConversationPanelMobile = ({ activities: activities, itemsInConversation: itemsInConversation })=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const open = (0, $9qyYE.useWidgetStore)((state)=>state.open);
    const [opacityStyle, setOpacityStyle] = (0, $bxRTa.useState)('');
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $bxRTa.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $bxRTa.useState)('bottom');
    const retorikConversationRef = (0, $bxRTa.useRef)(null);
    const botStartRef = (0, $bxRTa.useRef)(null);
    const botEndRef = (0, $bxRTa.useRef)(null);
    const timerRef = (0, $bxRTa.useRef)(null);
    const handleScroll = ()=>{
        if (retorikConversationRef.current) {
            const current = retorikConversationRef.current;
            if (current.scrollHeight > current.offsetHeight) {
                setScrollButtonDisplay(true);
                setScrollButtonDirection(current.scrollTop > -10 ? 'top' : 'bottom');
            }
            const percentage = Math.ceil((current.scrollHeight - current.clientHeight) / Math.abs(current.scrollTop));
            setOpacityStyle(`linear-gradient(to top, black ${100 - Math.min(percentage, 15)}%, transparent 100%)`);
        }
    };
    /**
   * Scroll to the botEndRef HTML element at the bottom of the view
   */ const scrollHandler = (to)=>{
        switch(to){
            case 'top':
                setScrollButtonDirection('bottom');
                botStartRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
            case 'bottom':
                setScrollButtonDirection('top');
                botEndRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
                break;
        }
        handleScroll();
    };
    (0, $bxRTa.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            scrollHandler('bottom');
        }, 100);
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        itemsInConversation,
        retorikConversationRef?.current?.scrollHeight
    ]);
    (0, $bxRTa.useLayoutEffect)(()=>{
        if (retorikConversationRef?.current) isWidget && (0, $k4qlo.default)(null, retorikConversationRef, undefined, true);
    });
    (0, $bxRTa.useEffect)(()=>{
        if (listStatus === (0, $2rYkD.ListStatus).closed && botEndRef.current) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                scrollHandler('bottom');
            }, 100);
        }
    }, [
        listStatus
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-max-h-full rf-h-full rf-max-w-full rf-w-full rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-end-13 rf-self-start rf-overflow-hidden rf-justify-self-center rf-flex rf-flex-col",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $48dbcf3910a29a57$export$2e2bcd8739ae039), {
                agentName: agentData?.name,
                companyName: configuration?.companyName,
                companyNameLocalized: configuration?.companyNameLocalized,
                subCompanyMessage: configuration?.subCompanyMessage,
                subCompanyMessageLocalized: configuration?.subCompanyMessageLocalized,
                imageUrl: agentData?.portrait
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                id: "retorik-conversation",
                ref: retorikConversationRef,
                className: "rf-relative rf-h-full rf-max-h-full rf-overflow-y-scroll rf-overflow-x-hidden rf-scrollbar-thin rf-self-auto rf-mb-26 rf-justify-self-center rf-flex rf-flex-col-reverse rf-text-size-auto rf-text-trueblack rf-bg-truewhite rf-bg-opacity-80",
                style: {
                    WebkitMaskImage: currentDeviceType === (0, $2rYkD.DeviceType).mobile ? opacityStyle : undefined
                },
                onScroll: handleScroll,
                onWheel: handleScroll,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: botEndRef
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $hC8yR.default), {
                        direction: scrollButtonDirection,
                        display: scrollButtonDisplay && open,
                        scrollHandler: scrollHandler,
                        className: "rf-absolute rf-z-ui rf-bottom-8 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-h-max rf-w-full rf-py-4 rf-flex rf-flex-col rf-gap-3",
                        children: activities.map((activity, index)=>{
                            return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $94f2aceac6df6117$export$2e2bcd8739ae039), {
                                userQuestion: activity.question,
                                botResponses: activity.answers,
                                isMobile: true,
                                triggerScroll: ()=>scrollHandler('bottom'),
                                canBeStreaming: index === activities.length - 1
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        ref: botStartRef
                    })
                ]
            })
        ]
    });
};
var $c2e3409b981f8d9b$export$2e2bcd8739ae039 = $c2e3409b981f8d9b$var$ConversationPanelMobile;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

const $9b42b5f316fcc1ce$var$ConversationPanelLarge = ({ activities: activities, itemsInConversation: itemsInConversation })=>{
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const mediumLandscape = (0, $9JLpC.useViewStore)((state)=>state.mediumLandscape);
    const isLandscape = (0, $9JLpC.useViewStore)((state)=>state.isLandscape);
    const [userQuestion, setUserQuestion] = (0, $bxRTa.useState)(undefined);
    const [botResponses, setBotResponses] = (0, $bxRTa.useState)([]);
    const retorikConversationRef = (0, $bxRTa.useRef)(null);
    const botEndRef = (0, $bxRTa.useRef)(null);
    const timerRef = (0, $bxRTa.useRef)(null);
    const isLandscapeRef = (0, $bxRTa.useRef)(true);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const [opacityStyle, setOpacityStyle] = (0, $bxRTa.useState)('');
    (0, $bxRTa.useEffect)(()=>{
        setOpacityStyle(undefined);
    }, [
        activities?.length
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                isLandscapeRef.current = true;
                if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape) {
                    const start = configuration.answerpanel.landscape.containerRowStartText;
                    const end = configuration.answerpanel.landscape.containerRowEndText;
                    if (start && start > 0 && start < 11) {
                        if (end && end < 11) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(11 - start);
                        }
                    } else if (end && end > 0 && end < 11) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(1);
                        setGridRowSpan(configuration.useOldRemote ? 10 : 9);
                    }
                } else {
                    setGridRowStart(1);
                    setGridRowSpan(configuration.useOldRemote ? 10 : 9);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                isLandscapeRef.current = false;
                if (typeof configuration.answerpanel === 'object' && configuration.answerpanel.borne) {
                    const start = configuration.answerpanel.borne.containerRowStart;
                    const end = configuration.answerpanel.borne.containerRowEnd;
                    if (start && start > 0 && start < 13) {
                        if (end && end < 13) {
                            if (start < end) {
                                setGridRowStart(start);
                                setGridRowSpan(end - start);
                            }
                        } else {
                            setGridRowStart(start);
                            setGridRowSpan(13 - start);
                        }
                    } else if (end && end > 0 && end < 13) {
                        setGridRowStart(1);
                        setGridRowSpan(end - 1);
                    } else {
                        setGridRowStart(6);
                        setGridRowSpan(7);
                    }
                } else {
                    setGridRowStart(6);
                    setGridRowSpan(7);
                }
                break;
        }
    }, [
        currentDeviceType,
        configuration.answerpanel,
        configuration.useOldRemote
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (activities.length) {
            const lastActivity = activities[activities.length - 1];
            setUserQuestion(lastActivity.question);
            setBotResponses([
                ...lastActivity.answers
            ]);
        } else {
            setUserQuestion(undefined);
            setBotResponses([]);
        }
    }, [
        activities,
        itemsInConversation
    ]);
    const handleScroll = ()=>{
        botEndRef?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
        handleScrollOpacity(false);
    };
    const handleScrollOpacity = (triggeredByUser)=>{
        if (retorikConversationRef.current) {
            const current = retorikConversationRef.current;
            if (current.scrollHeight > current.clientHeight + 5) {
                let percentage = 0;
                if (current.scrollTop || !triggeredByUser) {
                    percentage = Math.ceil((current.scrollHeight - current.clientHeight - Math.abs(current.scrollTop)) * 100 / current.scrollHeight);
                    !isLandscapeRef.current && (percentage = Math.max(25 - percentage, 0));
                    setOpacityStyle(`linear-gradient(to top, black ${100 - Math.min(percentage, 15)}%, transparent 100%)`);
                }
            } else setOpacityStyle('linear-gradient(to top, black 100%, transparent 100%)');
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            handleScroll();
        }, 100);
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        itemsInConversation
    ]);
    return userQuestion || botResponses ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-conversation",
        ref: retorikConversationRef,
        className: `rf-relative rf-w-full rf-max-h-full rf-z-util landscape-retorik:rf-pb-2 ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} vertical:rf-col-start-1 rf-col-end-13 rf-self-start rf-overflow-y-scroll rf-overflow-x-visible rf-scrollbar-hidden vertical:rf-overflow-x-auto rf-justify-self-center rf-flex rf-flex-col landscape-retorik:rf-flex-col-reverse landscape-retorik:rf-self-end rf-gap-4 rf-text-size-auto rf-text-trueblack`,
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`,
            WebkitMaskImage: opacityStyle
        },
        onScroll: ()=>handleScrollOpacity(true),
        children: [
            isLandscape && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                ref: botEndRef
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $94f2aceac6df6117$export$2e2bcd8739ae039), {
                userQuestion: userQuestion,
                botResponses: botResponses,
                triggerScroll: handleScroll,
                canBeStreaming: true
            }),
            !isLandscape && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                ref: botEndRef
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $9b42b5f316fcc1ce$export$2e2bcd8739ae039 = $9b42b5f316fcc1ce$var$ConversationPanelLarge;


const $6c93a27d7818cb69$var$ConversationPanel = ()=>{
    const messageActivities = (0, $bWQ72.useActivityStore)((state)=>state.messageActivities);
    const streamingActivities = (0, $bWQ72.useActivityStore)((state)=>state.botStreamingActivities);
    const forceMobileView = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.forceMobileView);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const setListStatus = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setListStatus);
    const [listActivity, setListActivity] = (0, $bxRTa.useState)(undefined);
    const [itemsInConversation, setItemsInConversation] = (0, $bxRTa.useState)(0);
    const getActivitiesTextMode = (activities, streamingActivities)=>{
        // processedId contains the ids of the activities already processed (because useActivities gives duplicate activities with different state depending on if it's been spoken or not )
        const processedId = [];
        const history = [];
        let tempItemsInConversation = 0;
        activities.forEach((activity)=>{
            if (activity.id && !processedId.includes(activity.id)) {
                processedId.push(activity.id);
                // Check if this is a question or an answer (questions from the user don't have a replyToId field)
                if (activity.replyToId) {
                    const question = history.find((historyItem)=>historyItem.question.id === activity.replyToId);
                    if (question) {
                        if (!question.answers.length || !question.answers.find((item)=>item.id === activity.id)) {
                            question.answers.push(activity);
                            tempItemsInConversation++;
                        }
                    } else {
                        const newQuestion = (0, $6hEoY.createNewQuestionForTimestamp)(activity);
                        history.push({
                            question: newQuestion,
                            answers: [
                                activity
                            ]
                        });
                        tempItemsInConversation++;
                    }
                } else // If the activity has a value, it is a need for further informations that don't need to be displayed
                if (!activity.value) {
                    // Hack for Bringup Message to be displayed as bot message
                    if (activity.label === 'Davi.BringupMessage' && activity.text) {
                        const newQuestion = (0, $6hEoY.createNewQuestionForTimestamp)(activity);
                        history.push({
                            question: newQuestion,
                            answers: [
                                activity
                            ]
                        });
                        tempItemsInConversation++;
                    } else {
                        const streamingAnswers = streamingActivities.get(activity.id);
                        history.push({
                            question: activity,
                            answers: streamingAnswers || []
                        });
                        tempItemsInConversation += streamingAnswers?.length || 0;
                    }
                }
            }
        });
        setItemsInConversation(tempItemsInConversation);
        return history;
    };
    const activities = (0, $bxRTa.useMemo)(()=>{
        return getActivitiesTextMode(messageActivities, streamingActivities);
    }, [
        messageActivities,
        streamingActivities
    ]);
    /**
   * Check if there is an activity in need of List display in bot's answers.
   */ (0, $bxRTa.useEffect)(()=>{
        const answers = activities.length ? activities[activities.length - 1].answers : [];
        setListActivity(answers.find((activity)=>(0, $af3086b4a2d8da64$export$7c55936a30618336)(activity)));
    }, [
        itemsInConversation
    ]);
    (0, $bxRTa.useEffect)(()=>{
        listStatus === (0, $2rYkD.ListStatus).closed && setListActivity(undefined);
    }, [
        listStatus
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: listActivity && !(listStatus === (0, $2rYkD.ListStatus).closed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jz5ru.default), {
            activity: listActivity,
            onClose: ()=>setListStatus((0, $2rYkD.ListStatus).closed)
        }) : isMobile || forceMobileView ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c2e3409b981f8d9b$export$2e2bcd8739ae039), {
            activities: activities,
            itemsInConversation: itemsInConversation
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9b42b5f316fcc1ce$export$2e2bcd8739ae039), {
            activities: activities,
            itemsInConversation: itemsInConversation
        })
    });
};
var $6c93a27d7818cb69$export$2e2bcd8739ae039 = $6c93a27d7818cb69$var$ConversationPanel;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $d9kWL = parcelRequire("d9kWL");

var $4xGiN = parcelRequire("4xGiN");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("9cEaH");
var $9UTGN = parcelRequire("9UTGN");

var $iLzAK = parcelRequire("iLzAK");

var $ijq12 = parcelRequire("ijq12");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("9cEaH");
var $3o2AQ = parcelRequire("3o2AQ");
var $91jIt = parcelRequire("91jIt");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");

var $iqpLV = parcelRequire("iqpLV");
parcelRequire("dikAc");
var $9f9kU = parcelRequire("9f9kU");
var $jWbjz = parcelRequire("jWbjz");
const $8a85ad2f2c53ddfa$var$Mode = ()=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const disabledSpeechMode = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.disableSpeechMode);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const { setActiveRecognitionState: setActiveRecognitionState, setMode: setMode } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const setCanFocusSendBox = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setCanFocusSendBox);
    const [fromTextToVocal, setFromTextToVocal] = (0, $bxRTa.useState)(false);
    const toggleMode = (newMode)=>{
        setFromTextToVocal(true);
        if (newMode === (0, $2rYkD.Mode).text) {
            setCanFocusSendBox(true);
            setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
        }
        setMode(newMode);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: `rf-w-full rf-px-4 rf-grid rf-grid-cols-1 ${disabledSpeechMode ? 'rf-py-4' : 'rf-grid-rows-2'} rf-items-center`,
        children: [
            !disabledSpeechMode && /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-flex rf-justify-center",
                children: mode === (0, $2rYkD.Mode).text ? /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                    className: "rf-w-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border rf-border-menuBorder rf-rounded-half rf-shadow-[0_0_20px_1px_#A4A7AF80]",
                    onClick: ()=>toggleMode((0, $2rYkD.Mode).vocal),
                    "aria-label": "vocal mode",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
                        className: "rf-h-5 rf-w-5 tactile:rf-h-6 tactile:rf-w-6",
                        color: "#A4A7AF"
                    })
                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iqpLV.default), {
                    openMicrophone: fromTextToVocal
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-flex rf-justify-center rf-items-center",
                onClick: ()=>toggleMode((0, $2rYkD.Mode).text),
                "aria-label": "text mode",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
                    className: "rf-h-5 rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6",
                    color: mode === (0, $2rYkD.Mode).text ? themeColors.secondary : '#A4A7AF'
                })
            })
        ]
    });
};
var $8a85ad2f2c53ddfa$export$2e2bcd8739ae039 = $8a85ad2f2c53ddfa$var$Mode;


const $a9267bcac2d3faec$var$Remote = ()=>{
    const disableSound = (0, $giKuE.useSpeechStore)((state)=>state.disableSound);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-remote",
        className: "rf-relative rf-w-full rf-pt-3 rf-pb-4 rf-flex rf-flex-col rf-items-center rf-rounded-l-lg rf-shadow-[0_3px_6px_#606267]",
        style: {
            background: 'linear-gradient(#F8F8FC, #EDEEF3)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8a85ad2f2c53ddfa$export$2e2bcd8739ae039), {}),
            (!disableSound && mode === (0, $2rYkD.Mode).text || mode === (0, $2rYkD.Mode).vocal || isMobile) && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fl9nK.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-[90%] rf-mb-4 rf-border-b-2 rf-border-b-[#C4C5C8]"
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-gap-5 large-vertical:rf-gap-6",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $91jIt.default), {})
                    })
                ]
            }),
            configuration.languageChoiceBottom?.setUnderRemote && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3o2AQ.default), {})
        ]
    });
};
var $a9267bcac2d3faec$export$2e2bcd8739ae039 = $a9267bcac2d3faec$var$Remote;


const $963fb1bc599ff962$var$RemoteContainer = ({ hideMenu: hideMenu = false })=>{
    const top = (0, $d9kWL.default)();
    const menu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const dashboardOpened = (0, $4xGiN.useUtilsStore)((state)=>state.dashboardOpened);
    const isRTL = (0, $2eBYD.useLocaleStore)((state)=>state.isRTL);
    const { setCurrentSubView: setCurrentSubView, setDashboardOpened: setDashboardOpened, setClickedOnUI: setClickedOnUI } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    /**
   * On call :
   *  - close subview if one is opened and if the parameter is false / undefined
   *  - toggle dashboardOpened state
   * @param doNotCloseViews : boolean
   */ const toggleDashboard = (doNotCloseViews)=>{
        !doNotCloseViews && setCurrentSubView((0, $2rYkD.CurrentSubView).none);
        setDashboardOpened(!dashboardOpened);
    };
    const handleClick = (e)=>{
        setClickedOnUI((0, $2rYkD.UIPart).remote);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-absolute rf-z-ui rf-hidden large:rf-flex rf-flex-col rf-items-center rf-justify-start rf-w-24 rf-right-0 ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-text-trueblack`,
                style: {
                    top: top
                },
                onClick: (e)=>handleClick(e),
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $ijq12.default), {
                        dashboardVisible: false,
                        onClick: ()=>toggleDashboard()
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a9267bcac2d3faec$export$2e2bcd8739ae039), {})
                ]
            }),
            dashboardOpened && (menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iLzAK.default), {
                toggleDashboard: ()=>toggleDashboard(true)
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9UTGN.default), {
                toggleDashboard: ()=>toggleDashboard(true)
            }))
        ]
    });
};
var $963fb1bc599ff962$export$2e2bcd8739ae039 = $963fb1bc599ff962$var$RemoteContainer;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("hZeqH");
var $6Vbk7 = parcelRequire("6Vbk7");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");

var $dq6kU = parcelRequire("dq6kU");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");
parcelRequire("dikAc");
var $6Nt3V = parcelRequire("6Nt3V");
var $9f9kU = parcelRequire("9f9kU");
var $jWbjz = parcelRequire("jWbjz");
const $462dbc90634eb69d$var$ModeButton = ({ label: label, selected: selected, onClick: onClick })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    return /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
        className: "rf-grid rf-w-full rf-h-12 rf-pb-4 rf-justify-center rf-items-end",
        onClick: ()=>onClick((0, $2rYkD.Mode)[label]),
        "aria-label": label,
        children: label === 'vocal' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $jWbjz.default), {
            className: "rf-h-5",
            color: "#A4A7AF"
        }) : label === 'text' ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9f9kU.default), {
            className: "rf-h-4",
            color: selected ? themeColors.secondary : '#A4A7AF'
        }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6Nt3V.default), {
            className: "rf-h-[0.875rem]",
            color: selected ? themeColors.secondary : '#A4A7AF'
        })
    });
};
var $462dbc90634eb69d$export$2e2bcd8739ae039 = $462dbc90634eb69d$var$ModeButton;


parcelRequire("9cEaH");
var $iqpLV = parcelRequire("iqpLV");

const $b5cd57e79ee3959c$var$Mobile = ({ parametersOpened: parametersOpened, toggleParameters: toggleParameters })=>{
    const hideMenu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.hideMenu);
    const disabledSpeechMode = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.disableSpeechMode);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const appAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.appAvailable);
    const { setActiveRecognitionState: setActiveRecognitionState, setMode: setMode } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const setCanFocusSendBox = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setCanFocusSendBox);
    const [fromTextToVocal, setFromTextToVocal] = (0, $bxRTa.useState)(false);
    const toggleMode = (newMode)=>{
        // If the parameters are opened, no action
        if (!parametersOpened) {
            setFromTextToVocal(true);
            if (newMode === (0, $2rYkD.Mode).text) {
                setCanFocusSendBox(true);
                setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
            }
            setMode(newMode);
        }
    };
    const handleDashboardClick = ()=>{
        toggleParameters();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-framework-menu",
        className: "rf-w-full rf-h-fit rf-max-h-80 rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto",
        style: {
            background: 'linear-gradient(to right, #F8F8FC, #EDEEF3)'
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `rf-w-full rf-grid rf-flex-1 rf-h-full ${!disabledSpeechMode ? hideMenu ? 'rf-grid-cols-2' : 'rf-grid-cols-3' : hideMenu ? 'rf-grid-cols-1' : 'rf-grid-cols-2'} rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $462dbc90634eb69d$export$2e2bcd8739ae039), {
                        label: "text",
                        selected: parametersOpened ? false : mode === (0, $2rYkD.Mode).text,
                        onClick: toggleMode
                    }),
                    !disabledSpeechMode && (mode === (0, $2rYkD.Mode).vocal ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-py-2 rf-w-full rf-flex rf-justify-center",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iqpLV.default), {
                            openMicrophone: fromTextToVocal
                        })
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $462dbc90634eb69d$export$2e2bcd8739ae039), {
                        label: "vocal",
                        selected: false,
                        onClick: toggleMode
                    })),
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $462dbc90634eb69d$export$2e2bcd8739ae039), {
                        label: "dashboard",
                        selected: parametersOpened,
                        onClick: handleDashboardClick
                    })
                ]
            }),
            !parametersOpened && mode === (0, $2rYkD.Mode).text && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $dq6kU.default), {
                className: "rf-mx-4 rf-mt-2"
            }),
            appAvailable && !parametersOpened && mode === (0, $2rYkD.Mode).vocal && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a174d1df6657d370$export$2e2bcd8739ae039), {
                className: "rf-w-full rf-px-6 rf-py-2"
            })
        ]
    });
};
var $b5cd57e79ee3959c$export$2e2bcd8739ae039 = $b5cd57e79ee3959c$var$Mobile;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $eO5xw = parcelRequire("eO5xw");

var $k4qlo = parcelRequire("k4qlo");
parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");
var $9UTGN = parcelRequire("9UTGN");
var $91jIt = parcelRequire("91jIt");
var $lRvrG = parcelRequire("lRvrG");

var $3KYvq = parcelRequire("3KYvq");
const $cd5ef32a1d0fa8fd$var$ParametersAndDashboardContainer = ({ handleBack: handleBack, hideMenu: hideMenu = false })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const menu = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.menu);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const divRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        divRef?.current && isWidget && (0, $k4qlo.default)(null, divRef);
    }, [
        divRef.current
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-py-4 rf-bg-truewhite rf-overflow-y-hidden rf-pointer-events-auto",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                title: translation.menu.backconversation,
                className: "rf-px-4 rf-text-sm",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                ref: divRef,
                className: "rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: [
                            menu?.categories?.length ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3KYvq.default), {
                                toggleDashboard: handleBack
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9UTGN.default), {
                                toggleDashboard: handleBack
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
                        children: [
                            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                                className: "rf-py-4 rf-text-lightgray",
                                children: (0, $eO5xw.capitalizeFirstLetter)(translation.common.parameters, locale)
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $91jIt.default), {
                                handleBack: handleBack
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lRvrG.default), {
                        isMobile: true
                    })
                ]
            })
        ]
    });
};
var $cd5ef32a1d0fa8fd$export$2e2bcd8739ae039 = $cd5ef32a1d0fa8fd$var$ParametersAndDashboardContainer;


const $3f3d8b62c2ca95da$var$MobileContainer = ({ hideMenu: hideMenu })=>{
    const dashboardOpened = (0, $4xGiN.useUtilsStore)((state)=>state.dashboardOpened);
    const { setCurrentSubView: setCurrentSubView, setDashboardOpened: setDashboardOpened } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const toggleParameters = ()=>{
        setCurrentSubView((0, $2rYkD.CurrentSubView).none);
        setDashboardOpened(!dashboardOpened);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $6Vbk7.default), {
        className: "large:rf-hidden rf-p-0 rf-m-0 rf-flex rf-flex-col-reverse rf-pointer-events-none vertical:rf-row-start-0 vertical:rf-row-end-13",
        depth: (0, $2rYkD.Depth).ui,
        background: "transparent",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $b5cd57e79ee3959c$export$2e2bcd8739ae039), {
                parametersOpened: dashboardOpened,
                toggleParameters: toggleParameters
            }),
            dashboardOpened && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $cd5ef32a1d0fa8fd$export$2e2bcd8739ae039), {
                handleBack: toggleParameters,
                hideMenu: hideMenu
            })
        ]
    });
};
var $3f3d8b62c2ca95da$export$2e2bcd8739ae039 = $3f3d8b62c2ca95da$var$MobileContainer;


parcelRequire("9cEaH");
var $3o2AQ = parcelRequire("3o2AQ");
const $39b448c04b4eb972$var$MenuDisplayer = ({ hideMenu: hideMenu })=>{
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const displayControls = (0, $9JLpC.useViewStore)((state)=>state.displayControls);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    return !displayControls ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3f3d8b62c2ca95da$export$2e2bcd8739ae039), {
        hideMenu: !!hideMenu
    }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $963fb1bc599ff962$export$2e2bcd8739ae039), {
                hideMenu: !!hideMenu
            }),
            !configuration.languageChoiceBottom?.setUnderRemote && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3o2AQ.default), {})
        ]
    });
};
var $39b448c04b4eb972$export$2e2bcd8739ae039 = $39b448c04b4eb972$var$MenuDisplayer;



var $3i7uv = parcelRequire("3i7uv");

var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");
const $c8bd85879b11a2bb$var$ExtendIcon = ({ className: className, color: color, extended: extended })=>{
    if (extended) return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.018",
        height: "19.382",
        viewBox: "0 0 20.018 19.382",
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            id: "Groupe_841",
            "data-name": "Groupe 841",
            transform: "translate(3.415 3.891)",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                id: "PICTO",
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    id: "Groupe_845",
                    "data-name": "Groupe 845",
                    transform: "translate(0.003 -1)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_843",
                            "data-name": "Groupe 843",
                            transform: "translate(3.99 21.134) rotate(180)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15",
                                    "data-name": "Ligne 15",
                                    y2: "5.046",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16",
                                    "data-name": "Ligne 16",
                                    x1: "5.04",
                                    transform: "translate(0 12.077)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17",
                                    "data-name": "Ligne 17",
                                    x2: "0.004",
                                    y2: "8.475",
                                    transform: "translate(5.99 6.057) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_844",
                            "data-name": "Groupe 844",
                            transform: "translate(9.162 -7.493)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15-2",
                                    "data-name": "Ligne 15",
                                    y2: "5.002",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16-2",
                                    "data-name": "Ligne 16",
                                    x1: "5.067",
                                    transform: "translate(0 12.033)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17-2",
                                    "data-name": "Ligne 17",
                                    x1: "0.046",
                                    y2: "8.463",
                                    transform: "translate(5.984 6.024) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
    else // return (
    //   <svg
    //     xmlns='http://www.w3.org/2000/svg'
    //     className={className || 'rf-h-6 rf-w-6'}
    //     fill='none'
    //     viewBox='0 0 24 24'
    //     stroke={color || 'currentColor'}
    //     strokeWidth={2}
    //   >
    //     <path
    //       strokeLinecap='round'
    //       strokeLinejoin='round'
    //       d='M6 18L18 6M6 6l12 12'
    //     />
    //   </svg>
    // )
    return /*#__PURE__*/ (0, $fl9nK.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.018",
        height: "19.358",
        viewBox: "0 0 20.018 19.358",
        className: className || 'rf-h-6 rf-w-6',
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
            id: "Groupe_841",
            "data-name": "Groupe 841",
            transform: "translate(3.415 3.891)",
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("g", {
                id: "PICTO",
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                    id: "Groupe_845",
                    "data-name": "Groupe 845",
                    transform: "translate(0.003 -1)",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_843",
                            "data-name": "Groupe 843",
                            transform: "translate(-2 3)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15",
                                    "data-name": "Ligne 15",
                                    y2: "5.046",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16",
                                    "data-name": "Ligne 16",
                                    x1: "5.04",
                                    transform: "translate(0 12.077)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17",
                                    "data-name": "Ligne 17",
                                    x2: "0.004",
                                    y2: "8.475",
                                    transform: "translate(5.99 6.057) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsxs)("g", {
                            id: "Groupe_844",
                            "data-name": "Groupe 844",
                            transform: "translate(15.178 10.572) rotate(180)",
                            children: [
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_15-2",
                                    "data-name": "Ligne 15",
                                    y2: "5.002",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_16-2",
                                    "data-name": "Ligne 16",
                                    x1: "5.067",
                                    transform: "translate(0 12.033)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fl9nK.jsx)("line", {
                                    id: "Ligne_17-2",
                                    "data-name": "Ligne 17",
                                    x1: "0.046",
                                    y2: "8.463",
                                    transform: "translate(5.984 6.024) rotate(45)",
                                    fill: "none",
                                    stroke: color || 'currentColor',
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $c8bd85879b11a2bb$export$2e2bcd8739ae039 = $c8bd85879b11a2bb$var$ExtendIcon;


const $c7c960ecf27193cd$var$HomeView = ({ externalComponents: externalComponents })=>{
    const openWidget = (0, $9qyYE.useWidgetStore)((state)=>state.actions.openWidget);
    const currentLayout = (0, $7SHCs.useRetorikStore)((state)=>state.currentLayout);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const configurations = (0, $9JLpC.useViewStore)((state)=>state.configurations);
    const setDisplayControls = (0, $9JLpC.useViewStore)((state)=>state.actions.setDisplayControls);
    const setLayout = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setLayout);
    const displayData = (0, $bxRTa.useMemo)(()=>{
        return configurations.views.home;
    }, [
        configurations
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setDisplayControls(!configuration.hideControls);
    }, []);
    const extendButtonHandler = ()=>{
        setLayout((0, $2rYkD.ContainerParent).widget);
        openWidget();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            !!configuration.allowSwitchLayout && currentLayout !== (0, $2rYkD.ContainerParent).widget && (currentDeviceType === (0, $2rYkD.DeviceType).widgetLandscape || currentDeviceType === (0, $2rYkD.DeviceType).widgetBorne) && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                onClick: extendButtonHandler,
                "aria-label": "Minimize",
                className: "rf-absolute rf-z-exitwidget rf-flex rf-top-1 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg rf-right-10",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c8bd85879b11a2bb$export$2e2bcd8739ae039), {
                    className: "rf-h-4 rf-w-4",
                    color: "#000000",
                    extended: true
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $VZzOq.default), {
                config: displayData.background
            }),
            configuration?.logo && (!isMobile || isMobile && mode !== (0, $2rYkD.Mode).text) && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $h0yA8.default), {}),
            configuration?.answerpanel !== false && loaderClosed && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                children: [
                    !isMobile && (configuration.useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $515c6bb01607ffda$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5377bf2433391660$export$2e2bcd8739ae039), {})),
                    mode === (0, $2rYkD.Mode).vocal ? configuration.useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $93405e9c3a3a1a91$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6fe7ed64ef75b076$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6c93a27d7818cb69$export$2e2bcd8739ae039), {})
                ]
            }),
            configuration.useOldRemote ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $39b448c04b4eb972$export$2e2bcd8739ae039), {
                hideMenu: configuration?.hideMenu
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3i7uv.default), {
                hideMenu: configuration?.hideMenu
            }),
            loaderClosed && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $2ddb2b8c38f184e3$export$2e2bcd8739ae039), {
                externalComponents: externalComponents
            }),
            !configuration?.hideRetorikLogo && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6ebf4aa8111d9d5f$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c7c960ecf27193cd$export$2e2bcd8739ae039 = $c7c960ecf27193cd$var$HomeView;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

const $0dabfd02933d4a59$var$NewsContainer = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("b7yy4")));
const $0dabfd02933d4a59$var$NewsView = ({ hideMenu: hideMenu, isRetorikNews: isRetorikNews, handleEndedWithoutloop: handleEndedWithoutloop })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
        children: /*#__PURE__*/ (0, $fl9nK.jsx)($0dabfd02933d4a59$var$NewsContainer, {
            hideMenu: hideMenu,
            isRetorikNews: isRetorikNews,
            handleEndedWithoutloop: handleEndedWithoutloop
        })
    });
};
var $0dabfd02933d4a59$export$2e2bcd8739ae039 = $0dabfd02933d4a59$var$NewsView;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");

parcelRequire("9cEaH");
var $4kqtJ = parcelRequire("4kqtJ");
const $6289eff125003845$var$WarningBeforeNewsView = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const sendEvent = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendEvent);
    const [waiting, setWaiting] = (0, $bxRTa.useState)(true);
    const handleClick = (goHome)=>{
        sendEvent('Davi.CloseWindow', null, ()=>sendEvent('Davi.CloseWindowNewsSoundActivated', null));
        goHome ? setRoute((0, $2rYkD.Routes).Home) : setWaiting(false);
    };
    return waiting ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-relative rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-gap-4 rf-justify-center rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $4kqtJ.default), {
                title: translation.common.back,
                handleBack: ()=>handleClick(true),
                className: "rf-absolute rf-top-4 rf-left-4 rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-px-4 rf-text-center",
                children: translation.news.warningtext
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(false),
                children: translation.common.continue
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(true),
                children: translation.common.back
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0dabfd02933d4a59$export$2e2bcd8739ae039), {});
};
var $6289eff125003845$export$2e2bcd8739ae039 = $6289eff125003845$var$WarningBeforeNewsView;


const $8d8907b91df6feae$var$RetorikRouter = (props)=>{
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const setRoute = (0, $9JLpC.useViewStore)((state)=>state.actions.setRoute);
    const lastBotEvent = (0, $bWQ72.useActivityStore)((state)=>state.lastBotEventActivity);
    const setCurrentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setCurrentSubView);
    (0, $bxRTa.useEffect)(()=>{
        if (lastBotEvent) switch(lastBotEvent.name){
            case 'news.ShowFlashInfo':
                setRoute((0, $2rYkD.Routes).News);
                break;
            case 'weather.ShowWeather':
                setCurrentSubView((0, $2rYkD.CurrentSubView).weather);
                break;
            default:
                break;
        }
    }, [
        lastBotEvent
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            route === (0, $2rYkD.Routes).Home && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c7c960ecf27193cd$export$2e2bcd8739ae039), {
                ...props
            }),
            route === (0, $2rYkD.Routes).News && (mode === (0, $2rYkD.Mode).vocal || !!isUsedOnBorne ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0dabfd02933d4a59$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6289eff125003845$export$2e2bcd8739ae039), {}))
        ]
    });
};
var $8d8907b91df6feae$export$2e2bcd8739ae039 = $8d8907b91df6feae$var$RetorikRouter;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $clSD3 = parcelRequire("clSD3");

var $9JLpC = parcelRequire("9JLpC");

var $hdMz2 = parcelRequire("hdMz2");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $lOuaH = parcelRequire("lOuaH");

var $NMpBg = parcelRequire("NMpBg");

var $2rYkD = parcelRequire("2rYkD");

var $kdMEA = parcelRequire("kdMEA");

var $k4qlo = parcelRequire("k4qlo");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $4xGiN = parcelRequire("4xGiN");
const $a068197de55406c8$var$ModalFullscreen = ()=>{
    const content = (0, $4xGiN.useUtilsStore)((state)=>state.modalFullscreenContent);
    const handleClick = (event)=>{
        event?.stopPropagation();
    };
    return content ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: "rf-absolute rf-z-modal rf-h-full rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center",
        style: {
            background: 'rgba(18,18,18,0.7)'
        },
        onClick: (event)=>handleClick(event),
        children: content
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $a068197de55406c8$export$2e2bcd8739ae039 = $a068197de55406c8$var$ModalFullscreen;


const $44d007e76c69eba2$var$Container = ({ fullSize: fullSize, width: width, height: height, children: children, parent: parent })=>{
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const isTactile = (0, $9JLpC.useViewStore)((state)=>state.isTactile);
    const { setCurrentDeviceType: setCurrentDeviceType, setCurrentHeight: setCurrentHeight, setCurrentWidth: setCurrentWidth } = (0, $9JLpC.useViewStore)((state)=>state.actions);
    const doNotDetectDeviceFromUserAgent = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.doNotDetectDeviceFromUserAgent);
    const forceMobileView = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.forceMobileView);
    const setClickedOnUI = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setClickedOnUI);
    const setPaginationToSend = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.setPaginationToSend);
    const container = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(container);
    const [portrait, setPortrait] = (0, $bxRTa.useState)('');
    const [large, setLarge] = (0, $bxRTa.useState)('');
    const [mobile, setMobile] = (0, $bxRTa.useState)('');
    const [tablet, setTablet] = (0, $bxRTa.useState)('');
    // Call useCurrentPagination to update data sent to store. Do not remove
    const pagination = (0, $NMpBg.default)();
    const widthStyle = (0, $bxRTa.useMemo)(()=>{
        if (typeof width === 'number') return {
            width: `${width}px`
        };
        else if (typeof width === 'string') return {
            width: width === 'full' ? '100%' : width
        };
        return {};
    }, [
        width
    ]);
    const heightStyle = (0, $bxRTa.useMemo)(()=>{
        if (currentDeviceType === (0, $2rYkD.DeviceType).mobile) return {
            height: window.innerHeight,
            minHeight: window.innerHeight,
            maxHeight: window.innerHeight
        };
        else if (typeof height === 'number') return {
            height: `${height}px`
        };
        else if (typeof height === 'string') return height === 'full' ? {
            height: '100%',
            flexGrow: 1
        } : {
            height: height
        };
        return {};
    }, [
        height,
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setPaginationToSend(pagination);
    }, [
        pagination
    ]);
    const checkPortrait = (width, height)=>{
        return !!(width && height && width < height);
    };
    /**
   * On dimensions change :
   *  - check and set the classes in the main div that will allow us to use tailwind variants
   *  - set the main div dimensions in context
   */ (0, $bxRTa.useEffect)(()=>{
        if (forceMobileView) setCurrentDeviceType((0, $2rYkD.DeviceType).mobile);
        else if (dimensions?.width && dimensions?.height) {
            // If we don't want to use the userAgent to get the device type
            if (doNotDetectDeviceFromUserAgent) {
                const isPortrait = checkPortrait(dimensions.width, dimensions.height);
                if (isPortrait) {
                    if (dimensions.width > (0, $kdMEA.mobileBreakpoint)) setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widgetBorne : (0, $2rYkD.DeviceType).borne);
                    else setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).mobile);
                } else if (dimensions.height > (0, $kdMEA.mobileBreakpoint)) setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widgetLandscape : (0, $2rYkD.DeviceType).landscape);
                else setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).mobile);
            } else if (0, $clSD3.isMobile) setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).mobile);
            else {
                const isPortrait = checkPortrait(dimensions.width, dimensions.height);
                if (isPortrait) setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? dimensions.width > (0, $kdMEA.mobileBreakpoint) ? (0, $2rYkD.DeviceType).widgetBorne : (0, $2rYkD.DeviceType).widget : (0, $2rYkD.DeviceType).borne);
                else setCurrentDeviceType(parent === (0, $2rYkD.ContainerParent).widget ? (0, $2rYkD.DeviceType).widgetLandscape : (0, $2rYkD.DeviceType).landscape);
            }
        }
        dimensions?.height && setCurrentHeight(dimensions.height);
        dimensions?.width && setCurrentWidth(dimensions.width);
        setTablet(dimensions.height < (0, $kdMEA.mediumBreakpoint) && dimensions.width < (0, $kdMEA.mediumBreakpoint) ? 'rf-tablet' : '');
    }, [
        dimensions
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setPortrait('rf-portrait');
                setLarge('');
                setMobile('rf-mobile');
                setTablet('');
                break;
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                setPortrait('');
                setLarge('rf-large');
                setMobile('');
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                setPortrait('rf-portrait');
                setLarge('rf-large');
                setMobile('');
                break;
        }
    }, [
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        container?.current && (0, $kdMEA.widgetDisplays).includes(currentDeviceType) && (0, $k4qlo.default)(container.current);
    }, [
        container.current
    ]);
    const customColors = (0, $bxRTa.useMemo)(()=>{
        return themeColors ? {
            '--rf-color-primary': themeColors.primary,
            '--rf-color-secondary': themeColors.secondary,
            '--rf-color-black': themeColors.black,
            '--rf-color-whereToEatColor': themeColors.whereToEatColor,
            '--rf-color-whereToSleepColor': themeColors.whereToSleepColor,
            '--rf-color-tobeSeenColor': themeColors.tobeSeenColor,
            '--rf-color-tobeDoneColor': themeColors.tobeDoneColor,
            '--rf-color-localProductsColor': themeColors.localProductsColor,
            '--rf-color-servicesColor': themeColors.servicesColor,
            '--rf-color-cardFrameBackground': themeColors.card?.frame?.background,
            '--rf-color-cardFrameBorder': themeColors.card?.frame?.border,
            '--rf-color-cardFrameText': themeColors.card?.frame?.text,
            '--rf-color-cardButtonBackgroundDefault': themeColors.card?.button?.background?.default,
            '--rf-color-cardButtonBackgroundHover': themeColors.card?.button?.background?.hover,
            '--rf-color-cardButtonBorderDefault': themeColors.card?.button?.border?.default,
            '--rf-color-cardButtonBorderHover': themeColors.card?.button?.border?.hover,
            '--rf-color-cardButtonTextDefault': themeColors.card?.button?.text?.default,
            '--rf-color-cardButtonTextHover': themeColors.card?.button?.text?.hover,
            '--rf-color-cardButtonDiscoverBackgroundDefault': themeColors.card?.discoverButton?.background?.default,
            '--rf-color-cardButtonDiscoverBackgroundHover': themeColors.card?.discoverButton?.background?.hover,
            '--rf-color-cardButtonDiscoverBorderDefault': themeColors.card?.discoverButton?.border?.default,
            '--rf-color-cardButtonDiscoverBorderHover': themeColors.card?.discoverButton?.border?.hover,
            '--rf-color-cardButtonDiscoverTextDefault': themeColors.card?.discoverButton?.text?.default,
            '--rf-color-cardButtonDiscoverTextHover': themeColors.card?.discoverButton?.text?.hover,
            '--rf-color-textModePanelBackground': themeColors.textMode?.panel?.background,
            '--rf-color-textModePanelBorder': themeColors.textMode?.panel?.border,
            '--rf-color-textModePanelBackgroundUser': themeColors.textMode?.panel?.backgroundUser,
            '--rf-color-textModePanelBackgroundBot': themeColors.textMode?.panel?.backgroundBot,
            '--rf-color-textModePanelConversationUser': themeColors.textMode?.panel?.conversationUser,
            '--rf-color-textModePanelConversationBot': themeColors.textMode?.panel?.conversationBot,
            '--rf-color-vocalModeSubtitlesText': themeColors.vocalMode?.subtitles?.text,
            '--rf-color-vocalModeSubtitlesBackground': themeColors.vocalMode?.subtitles?.background,
            '--rf-color-formInputTextDefault': themeColors.formInput?.text?.default,
            '--rf-color-formInputTextHover': themeColors.formInput?.text?.hover,
            '--rf-color-formInputRadioCheckboxUncheckedBackground': themeColors.formInput?.inputRadioCheckbox?.unchecked?.background,
            '--rf-color-formInputRadioCheckboxUncheckedBorder': themeColors.formInput?.inputRadioCheckbox?.unchecked?.border,
            '--rf-color-formInputRadioCheckboxCheckedBackground': themeColors.formInput?.inputRadioCheckbox?.checked?.background,
            '--rf-color-formInputRadioCheckboxCheckedBorder': themeColors.formInput?.inputRadioCheckbox?.checked?.border,
            '--rf-color-formInputRadioCheckboxCheckedItem': themeColors.formInput?.inputRadioCheckbox?.checked?.item,
            '--rf-color-formInputButtonBackgroundDefault': themeColors.formInput?.inputButton?.background?.default,
            '--rf-color-formInputButtonBackgroundHover': themeColors.formInput?.inputButton?.background?.hover,
            '--rf-color-formInputButtonBorderDefault': themeColors.formInput?.inputButton?.border?.default,
            '--rf-color-formInputButtonBorderHover': themeColors.formInput?.inputButton?.border?.hover,
            '--rf-color-formInputButtonTextDefault': themeColors.formInput?.inputButton?.text?.default,
            '--rf-color-formInputButtonTextHover': themeColors.formInput?.inputButton?.text?.hover
        } : {};
    }, [
        themeColors
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        id: "retorik-container",
        ref: container,
        tabIndex: -1,
        className: `rf-relative ${fullSize ? 'rf-w-screen rf-h-screen' : 'rf-w-full rf-h-full'} rf-max-w-screen rf-max-h-screen rf-grid rf-grid-cols-8 rf-grid-rows-container rf-bg-transparent rf-text-trueblack rf-font-default ${portrait} ${large} ${mobile} ${tablet} ${isTactile && 'rf-tactile'} rf-overflow-hidden rf-animate-loaderFadeIn`,
        style: {
            ...widthStyle,
            ...heightStyle,
            ...customColors
        },
        onClick: ()=>setClickedOnUI((0, $2rYkD.UIPart).background),
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a068197de55406c8$export$2e2bcd8739ae039), {}),
            children
        ]
    });
};
var $44d007e76c69eba2$export$2e2bcd8739ae039 = $44d007e76c69eba2$var$Container;




var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $lo8xw = parcelRequire("lo8xw");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");
const $2f9f46fd962caacf$export$a2ce4fdd6972d6a7 = async (region, key)=>{
    const tokenRes = await fetch(`https://${region}.api.cognitive.microsoft.com/sts/v1.0/issueToken`, {
        method: 'POST',
        headers: {
            'Ocp-Apim-Subscription-Key': key
        }
    }).then((value)=>{
        return value.text();
    }).catch((error)=>{
        console.log('Error : ', error);
        return undefined;
    });
    return tokenRes;
};


const $57f41e573dafcd6e$export$4bf371fc4fa74a28 = (voices, locale, customVoice, agentData)=>{
    let voice = null;
    // Check if a custom voice is defined in the props
    if (customVoice) {
        if (customVoice.voice) {
            // Search voice with its full name (ex: AriaNeural, GuyNeural)
            const neuralVoice = new RegExp(customVoice.voice, 'iu');
            voice = voices.find(({ name: name })=>neuralVoice.test(name) || name === customVoice.voice);
        } else if (customVoice.gender) // Search voice depending on given gender and locale
        voice = voices.find(({ gender: gender, lang: lang })=>{
            return gender.toLowerCase() === customVoice?.gender?.toLowerCase() && lang === locale;
        });
    }
    // Get voice depending on locale and gender
    if (!voice) voice = voices.find(({ gender: gender, lang: lang })=>{
        return gender.toLowerCase() === (agentData?.gender?.toLowerCase() || 'female') && lang === locale;
    });
    // No voice found, fall back to US default voices : female => Aria / male => Guy
    if (!voice) {
        const genderedVoice = agentData?.gender?.toLowerCase() === 'female' ? 'AriaNeural' : 'GuyNeural';
        const neuralVoice = new RegExp(genderedVoice, 'iu');
        voice = voices.find(({ name: name })=>neuralVoice.test(name));
    }
    return voice;
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $bWQ72 = parcelRequire("bWQ72");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $4xGiN = parcelRequire("4xGiN");

var $7SHCs = parcelRequire("7SHCs");

var $hdMz2 = parcelRequire("hdMz2");


var $2rYkD = parcelRequire("2rYkD");


var $fb1tF = parcelRequire("fb1tF");

var $lo8xw = parcelRequire("lo8xw");
const $32267c4f7fbd2605$var$buildSSML = (activity, locale, speechMarkdownParser, sayAsWords)=>{
    let speech = activity.speak || activity.text;
    // Replace character not recognized in Microsoft TTS
    speech = speech.replaceAll("\u2019", "'");
    let textParsedAsSSML = '';
    try {
        if (sayAsWords?.length) {
            const wordsUsed = [];
            sayAsWords.forEach((tuple)=>{
                if (!wordsUsed.includes(tuple.text.toLocaleLowerCase(locale))) {
                    const regex = new RegExp(`\\b${tuple.text}\\b`, 'gi');
                    speech = speech.replaceAll(regex, `(${tuple.text})[ipa:"${tuple.ipa}"]`);
                    wordsUsed.push(tuple.text.toLocaleLowerCase(locale));
                }
            });
        }
        textParsedAsSSML = speechMarkdownParser.toSSML(speech);
    } catch (e) {
        console.warn('Retorik Framework > error in speechmarkdown parser : ', e);
    }
    return `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" xml:lang="${locale}">` + textParsedAsSSML + '</speak>';
};
const $32267c4f7fbd2605$var$createUtterance = ({ activity: activity, voice: voice, locale: locale, sayAsWords: sayAsWords })=>{
    // If there is no text to be read, create an empty utterance that will be put in the array of ended activities
    if (!voice || !activity.speak && !activity.text) return new (0, $lo8xw.SpeechSynthesisUtterance)('');
    return new (0, $lo8xw.SpeechSynthesisUtterance)($32267c4f7fbd2605$var$buildSSML(activity, locale, new (0, $fb1tF.SpeechMarkdown)({
        platform: 'microsoft-azure',
        includeSpeakTag: false,
        globalVoiceAndLang: {
            voice: voice.name,
            lang: voice.name.toLowerCase().includes('multilingual') ? locale : undefined
        }
    }), sayAsWords));
};
var $32267c4f7fbd2605$export$2e2bcd8739ae039 = $32267c4f7fbd2605$var$createUtterance;


/**
 * Check if there are some replacement codes for this language, to improve speech synthesis, and then create the utterance
 * @param {CreateUtteranceParams} params - data needed to create an utterance
 * @param {SayAs} sayAs - string that should be replaced by their ipa codes
 * @returns {SpeechSynthesisUtterance}
 */ const $2161e8fb47c6c1a6$export$f969af62bba9a48b = (params, sayAs)=>{
    let sayAsWords = [];
    if (sayAs) {
        sayAs.common?.length && (sayAsWords = [
            ...sayAs.common
        ]);
        sayAs.localized && sayAs.localized[params.locale]?.length && (sayAsWords = [
            ...sayAsWords,
            ...sayAs.localized[params.locale]
        ]);
    }
    return (0, $32267c4f7fbd2605$export$2e2bcd8739ae039)({
        ...params,
        sayAsWords: sayAsWords
    });
};



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $2eBYD = parcelRequire("2eBYD");

var $2rYkD = parcelRequire("2rYkD");

var $kdMEA = parcelRequire("kdMEA");
const $d1984bac2dac280a$export$52a3c04e084af2a0 = {
    onesecond: `${(0, $kdMEA.CDNAudioAddress)}/onesecond.mp3`,
    speechrecognition: `${(0, $kdMEA.CDNAudioAddress)}/blip.mp3`,
    microphoneopen: `${(0, $kdMEA.CDNAudioAddress)}/microphone-open.mp3`,
    microphoneclose: `${(0, $kdMEA.CDNAudioAddress)}/microphone-close.mp3`
};


class $75efbde667d94667$var$IndexedDbManager {
    constructor(){
        this.version = 1;
        this.storeName = 'speechSynthesisData';
        this.checkDB = async ()=>{
            return new Promise((resolve)=>{
                const request = indexedDB.open('retorik-framework-db', this.version);
                request.onsuccess = ()=>{
                    resolve(true);
                };
                request.onerror = ()=>{
                    resolve(false);
                };
                request.onupgradeneeded = ()=>{
                    const db = request.result;
                    // If the data object store doesn't exist, create it
                    if (!db.objectStoreNames.contains(this.storeName)) db.createObjectStore(this.storeName, {
                        keyPath: 'id'
                    });
                };
            });
        };
        this.addSpeechData = async (data)=>{
            return new Promise((resolve)=>{
                const request = indexedDB.open('retorik-framework-db', this.version);
                request.onsuccess = ()=>{
                    const db = request.result;
                    const tx = db.transaction(this.storeName, 'readwrite');
                    const store = tx.objectStore(this.storeName);
                    // Base 64 encode
                    data.id = window.btoa(encodeURI(data.id));
                    store.add(data);
                    resolve(true);
                };
                request.onerror = ()=>{
                    resolve(false);
                };
            });
        };
        this.getSpeechData = async (id)=>{
            return new Promise((resolve)=>{
                const request = indexedDB.open('retorik-framework-db', this.version);
                request.onsuccess = ()=>{
                    const db = request.result;
                    const tx = db.transaction(this.storeName, 'readonly');
                    const store = tx.objectStore(this.storeName);
                    // Base 64 encode
                    const data = store.get(window.btoa(encodeURI(id)));
                    data.onsuccess = ()=>{
                        resolve(data.result);
                    };
                };
                request.onerror = ()=>{
                    resolve(null);
                };
            });
        };
    }
}
var $75efbde667d94667$export$2e2bcd8739ae039 = $75efbde667d94667$var$IndexedDbManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $7SHCs = parcelRequire("7SHCs");

var $lOuaH = parcelRequire("lOuaH");

var $k4qlo = parcelRequire("k4qlo");
parcelRequire("kMAJU");
var $lHTuW = parcelRequire("lHTuW");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $9JLpC = parcelRequire("9JLpC");

var $giKuE = parcelRequire("giKuE");

var $2rYkD = parcelRequire("2rYkD");

var $6aH4h = parcelRequire("6aH4h");

var $iEJNQ = parcelRequire("iEJNQ");
const $a6f0e9ef461b31d5$var$springEnterDuration = 500;
const $a6f0e9ef461b31d5$var$springLeaveDuration = 1000;
const $a6f0e9ef461b31d5$var$LoaderCallToAction = ({ handleValidation: handleValidation })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.localeForRetorikStudioContent);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const loaderInformationTexts = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.loaderInformationTexts);
    const loaderInformationTextsLocalized = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.loaderInformationTextsLocalized);
    const hideRetorikLogo = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.hideRetorikLogo);
    const disabledSpeechMode = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.disableSpeechMode);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const characterLoaded = (0, $9JLpC.useViewStore)((state)=>state.characterLoaded);
    const setMode = (0, $giKuE.useSpeechStore)((state)=>state.actions.setMode);
    const container = (0, $bxRTa.useRef)(null);
    const [userValidation, setUserValidation] = (0, $bxRTa.useState)(false);
    const [hover, setHover] = (0, $bxRTa.useState)(false);
    const animationColor = {
        '--rf-color-loader-animation': themeColors.loader.animation
    };
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $a6f0e9ef461b31d5$var$springEnterDuration
            }
        });
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    const handleChange = (modeId)=>{
        setMode(modeId === 1 ? (0, $2rYkD.Mode).vocal : (0, $2rYkD.Mode).text);
    };
    (0, $bxRTa.useEffect)(()=>{
        if (userValidation && characterLoaded) {
            handleValidation();
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $a6f0e9ef461b31d5$var$springLeaveDuration
                }
            });
        }
    }, [
        userValidation,
        characterLoaded
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center rf-animate-loaderFadeIn",
        ref: container,
        style: {
            ...animationColor,
            ...spring
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-w-6 rf-h-6 rf-mb-16",
                        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {})
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                        className: "rf-text-center",
                        style: {
                            color: themeColors.loader.text
                        },
                        children: [
                            loaderInformationTexts?.vocal.top && loaderInformationTexts.text.top || loaderInformationTextsLocalized?.vocal?.top?.[locale] && loaderInformationTextsLocalized.text?.top?.[locale] ? /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                children: mode === (0, $2rYkD.Mode).vocal ? loaderInformationTextsLocalized?.vocal?.top?.[locale] || loaderInformationTexts?.vocal?.top : loaderInformationTextsLocalized?.text?.top?.[locale] || loaderInformationTexts?.text?.top
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                children: mode === (0, $2rYkD.Mode).vocal ? translation.loader.loader.optimal : translation.loader.loader.classic
                            }),
                            loaderInformationTexts?.vocal?.bottom && loaderInformationTexts.text?.bottom || loaderInformationTextsLocalized?.vocal?.bottom?.[locale] && loaderInformationTextsLocalized.text?.bottom?.[locale] ? /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $2rYkD.Mode).vocal ? loaderInformationTextsLocalized?.vocal?.bottom?.[locale] || loaderInformationTexts?.vocal?.bottom : loaderInformationTextsLocalized?.text?.bottom?.[locale] || loaderInformationTexts?.text?.bottom
                            }) : /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $2rYkD.Mode).vocal ? translation.loader.loader.vocal : translation.loader.loader.text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `rf-w-full rf-h-1/2 rf-flex rf-flex-col ${hideRetorikLogo ? 'rf-justify-start' : 'rf-justify-between'} rf-items-center`,
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                    className: "rf-flex rf-flex-col rf-items-center",
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6aH4h.default), {
                            texts: {
                                left: translation.loader.modes.vocal,
                                leftId: 1,
                                right: translation.loader.modes.text,
                                rightId: 2
                            },
                            colors: themeColors.loader.toggle,
                            defaultChecked: mode,
                            handleChange: handleChange,
                            showLeft: !disabledSpeechMode,
                            showRight: true
                        }),
                        userValidation ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                            className: "rf-font-bold rf-border-2 rf-rounded-lg rf-px-6 rf-py-3 rf-mt-8",
                            style: {
                                color: hover ? themeColors.loader.button.text.hover : themeColors.loader.button.text.default,
                                borderColor: hover ? themeColors.loader.button.border.hover : themeColors.loader.button.border.default,
                                background: hover ? themeColors.loader.button.background.hover : themeColors.loader.button.background.default
                            },
                            onClick: ()=>setUserValidation(true),
                            onMouseEnter: ()=>setHover(true),
                            onMouseLeave: ()=>setHover(false),
                            children: translation.loader.loaderValidation
                        })
                    ]
                })
            })
        ]
    });
};
var $a6f0e9ef461b31d5$export$2e2bcd8739ae039 = $a6f0e9ef461b31d5$var$LoaderCallToAction;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $5bTjo = parcelRequire("5bTjo");
var $hzlaD = parcelRequire("hzlaD");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $4xGiN = parcelRequire("4xGiN");

var $eO5xw = parcelRequire("eO5xw");
const $104fac0f2ca32b3a$var$springDuration = 500;
const $104fac0f2ca32b3a$var$finalMessageDisplayDuration = 2500;
const $104fac0f2ca32b3a$var$GdprWindow = ({ titleTextSize: titleTextSize })=>{
    const data = (0, $4xGiN.useUtilsStore)((state)=>state.GDPRWindowData);
    const { setGDPRDisplay: setGDPRDisplay, setGDPRUserConsent: setGDPRUserConsent } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.localeForRetorikStudioContent);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const [finalMessage, setFinalMessage] = (0, $bxRTa.useState)(null);
    const finalMessageTimerRef = (0, $bxRTa.useRef)();
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $104fac0f2ca32b3a$var$springDuration
            }
        });
        return ()=>{
            finalMessageTimerRef?.current && clearTimeout(finalMessageTimerRef.current);
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    const texts = (0, $bxRTa.useMemo)(()=>{
        return {
            title: data?.title?.[locale] || translation.GDPR.title,
            message: data?.message?.[locale] || translation.GDPR.message,
            link: data?.link?.[locale] || translation.GDPR.link,
            buttonAccept: data?.buttonAccept?.[locale] || translation.GDPR.buttonAccept,
            buttonRefuse: data?.buttonRefuse?.[locale] || translation.GDPR.buttonRefuse,
            messageAccepted: data?.messageAccepted?.[locale] || translation.GDPR.messageAccepted,
            messageRefused: data?.messageRefused?.[locale] || translation.GDPR.messageRefused
        };
    }, [
        translation,
        locale
    ]);
    const handleCheck = (value)=>{
        setGDPRUserConsent(value);
        setFinalMessage(value ? texts.messageAccepted : texts.messageRefused);
        finalMessageTimerRef.current = setTimeout(()=>{
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $104fac0f2ca32b3a$var$springDuration
                }
            });
        }, $104fac0f2ca32b3a$var$finalMessageDisplayDuration);
        animationTimerRef.current = setTimeout(()=>{
            setGDPRDisplay(false);
        }, $104fac0f2ca32b3a$var$springDuration + $104fac0f2ca32b3a$var$finalMessageDisplayDuration);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-gap-12 rf-justify-center rf-items-center rf-text-center",
        style: {
            ...spring
        },
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: `${isMobile ? 'rf-w-3/4' : 'rf-w-1/2'} ${titleTextSize}`,
                children: (0, $eO5xw.capitalizeFirstLetter)(texts.title, locale)
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${isMobile ? 'rf-w-3/4' : 'rf-w-1/2'} rf-flex rf-flex-col rf-items-center rf-gap-4`,
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0, $eO5xw.capitalizeFirstLetter)(texts.message, locale).replaceAll('\n', '<br>')
                        }
                    }),
                    data?.linkURL && /*#__PURE__*/ (0, $fl9nK.jsx)("a", {
                        href: data.linkURL,
                        target: "_blank",
                        rel: "noreferrer noopener",
                        style: {
                            color: themeColors.primary,
                            textDecoration: 'underline'
                        },
                        children: (0, $eO5xw.capitalizeFirstLetter)(texts.link, locale)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-h-16 rf-flex rf-flex-row rf-justify-center rf-gap-4",
                children: finalMessage ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: `${isMobile ? 'rf-w-3/4' : 'rf-w-1/2'} rf-animate-fadeIn`,
                    children: (0, $eO5xw.capitalizeFirstLetter)(finalMessage, locale)
                }) : /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                            className: "rf-h-fit rf-px-4 rf-py-2 rf-rounded-lg",
                            onClick: ()=>handleCheck(true),
                            style: {
                                color: themeColors.loader.toggle.text,
                                background: themeColors.loader.toggle.background,
                                borderColor: themeColors.loader.toggle.background
                            },
                            children: (0, $eO5xw.capitalizeFirstLetter)(texts.buttonAccept, locale)
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                            className: "rf-h-fit rf-px-4 rf-py-2 rf-rounded-lg",
                            onClick: ()=>handleCheck(false),
                            style: {
                                color: themeColors.loader.toggle.text,
                                background: themeColors.loader.toggle.background,
                                borderColor: themeColors.loader.toggle.background
                            },
                            children: (0, $eO5xw.capitalizeFirstLetter)(texts.buttonRefuse, locale)
                        })
                    ]
                })
            })
        ]
    });
};
var $104fac0f2ca32b3a$export$2e2bcd8739ae039 = $104fac0f2ca32b3a$var$GdprWindow;


const $7ac27256f2d61bf4$var$springEnterDuration = 500;
const $7ac27256f2d61bf4$var$springLeaveDuration = 1000;
const $7ac27256f2d61bf4$var$GdprAndLoader = ({ appAvailable: appAvailable, handleValidation: handleValidation })=>{
    const displayGDPR = (0, $4xGiN.useUtilsStore)((state)=>state.GDPRDisplay);
    const setGDPRDisplay = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setGDPRDisplay);
    const isUsedOnBorne = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.isUsedOnBorne);
    const skipLoader = (0, $7SHCs.useRetorikStore)((state)=>state.skipLoader);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const hideRetorikLogo = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.hideRetorikLogo);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const themeColors = (0, $9JLpC.useViewStore)((state)=>state.themeColors);
    const [textSize, setTextSize] = (0, $bxRTa.useState)('');
    const [titleTextSize, setTitleTextSize] = (0, $bxRTa.useState)();
    const container = (0, $bxRTa.useRef)(null);
    const dimensions = (0, $lOuaH.default)(container);
    const animationTimerRef = (0, $bxRTa.useRef)();
    const [spring, api] = (0, $hzlaD.useSpring)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $bxRTa.useEffect)(()=>{
        if (isUsedOnBorne || skipLoader) {
            setGDPRDisplay(false);
            handleValidation();
        }
    }, [
        isUsedOnBorne,
        skipLoader
    ]);
    (0, $bxRTa.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $7ac27256f2d61bf4$var$springEnterDuration
            }
        });
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        if (dimensions.width && dimensions.height && dimensions.width > 600) {
            if (dimensions.width < dimensions.height) {
                setTextSize('rf-text-lgcustom');
                setTitleTextSize('rf-text-3xl');
            } else {
                setTextSize('rf-text-basecustom');
                setTitleTextSize('rf-text-4xl');
            }
        } else {
            setTextSize('rf-text-sm');
            setTitleTextSize('rf-text-2xl');
        }
    }, [
        dimensions
    ]);
    const handleValidate = ()=>{
        handleValidation();
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $7ac27256f2d61bf4$var$springLeaveDuration
            }
        });
    };
    (0, $bxRTa.useEffect)(()=>{
        container?.current && isWidget && (0, $k4qlo.default)(container.current);
    }, [
        container?.current
    ]);
    return isUsedOnBorne || skipLoader ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}) : displayGDPR || !(appAvailable || loaderClosed) ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $5bTjo.animated).div, {
        id: "retorik-GDPR-and-loader",
        className: `rf-absolute rf-z-modal rf-top-0 rf-left-0 rf-h-full rf-w-full rf-font-default
        ${textSize}`,
        ref: container,
        style: {
            background: themeColors.loader.background,
            color: themeColors.loader.text,
            ...spring
        },
        children: [
            displayGDPR ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $104fac0f2ca32b3a$export$2e2bcd8739ae039), {
                titleTextSize: titleTextSize
            }) : !(appAvailable || loaderClosed) ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a6f0e9ef461b31d5$export$2e2bcd8739ae039), {
                handleValidation: handleValidate
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {}),
            !hideRetorikLogo && (isMobile ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
                className: "rf-absolute rf-bottom-10 rf-h-14"
            }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $lHTuW.default), {
                className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-14"
            }))
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $7ac27256f2d61bf4$export$2e2bcd8739ae039 = $7ac27256f2d61bf4$var$GdprAndLoader;


const $0673a82084862dad$var$DBManager = new (0, $75efbde667d94667$export$2e2bcd8739ae039)();
const $0673a82084862dad$var$tagsRemoverRegex = /<[^<>]+>/g;
const $0673a82084862dad$var$RetorikSpeech = ({ ponyfill: ponyfill, onEnd: onEnd, onError: onError, onStart: onStart, utterance: utterance, nextUtterance: nextUtterance, appAvailable: appAvailable })=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const enableSpeechCaching = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.enableSpeechCaching);
    const speechRecognitionOptions = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.speechRecognitionOptions);
    const useOldRemote = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.useOldRemote);
    const voice = (0, $giKuE.useSpeechStore)((state)=>state.voice);
    const muted = (0, $giKuE.useSpeechStore)((state)=>state.muted);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const { setBoundaryData: setBoundaryData, setVisemeData: setVisemeData, addViseme: addViseme } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const setLoaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setLoaderClosed);
    const boundaryRef = (0, $bxRTa.useRef)(null);
    const visemeRef = (0, $bxRTa.useRef)(null);
    const audioRef = (0, $bxRTa.useRef)(null);
    const speechRecognitionAudioRef = (0, $bxRTa.useRef)(null);
    const microphoneOpenAudioRef = (0, $bxRTa.useRef)(null);
    const microphoneCloseAudioRef = (0, $bxRTa.useRef)(null);
    const [DBReady, setDBReady] = (0, $bxRTa.useState)(false);
    const [playingBlob, setPlayingBlob] = (0, $bxRTa.useState)(false);
    const nextUtteranceDataRef = (0, $bxRTa.useRef)(null);
    const nextUtteranceTextRef = (0, $bxRTa.useRef)(null);
    const nextUtteranceBoundariesRef = (0, $bxRTa.useRef)([]);
    const nextUtteranceVisemesRef = (0, $bxRTa.useRef)([]);
    const emptyTextUtteranceRef = (0, $bxRTa.useRef)(null);
    (0, $bxRTa.useEffect)(()=>{
        $0673a82084862dad$var$DBManager.checkDB().then((result)=>setDBReady(result));
        return ()=>{
            stopCurrentPlaying();
            emptyTextUtteranceRef?.current && clearTimeout(emptyTextUtteranceRef.current);
        };
    }, []);
    const stopCurrentPlaying = ()=>{
        if (appAvailable || loaderClosed) {
            // Cancel synthesis if using synthesizer
            if (!playingBlob) ponyfill.speechSynthesis.cancel();
            resetNextUtteranceData();
            if (audioRef.current && !audioRef.current?.paused) {
                audioRef.current.pause();
                handleEnd();
            }
        }
    };
    const attachEvents = (tempUtterance, isMainUtterance)=>{
        tempUtterance.onerror = (event)=>{
            isMainUtterance ? handleError(event) : nextUtteranceDataRef.current = null;
        };
        tempUtterance.onsynthesiscompleted = ()=>{
            const endBoundary = {
                word: '',
                startTime: 0,
                endTime: 0,
                boundaryType: 'EndBoundary'
            };
            if (isMainUtterance) {
                const tempBoundaries = boundaryRef?.current || [];
                boundaryRef.current = [
                    ...tempBoundaries,
                    endBoundary
                ];
                setBoundaryData([
                    ...tempBoundaries,
                    endBoundary
                ]);
            } else nextUtteranceBoundariesRef.current = [
                ...nextUtteranceBoundariesRef.current,
                endBoundary
            ];
        };
        tempUtterance.onboundary = (event)=>{
            if (event.boundaryType !== 'Viseme') {
                const newBoundary = {
                    word: event.name,
                    startTime: event.elapsedTime,
                    endTime: event.elapsedTime + event.duration,
                    boundaryType: event.boundaryType
                };
                if (isMainUtterance) {
                    // Update the boundaryData state with the new data.
                    const tempBoundaries = boundaryRef?.current || [];
                    boundaryRef.current = [
                        ...tempBoundaries,
                        newBoundary
                    ];
                    setBoundaryData([
                        ...tempBoundaries,
                        newBoundary
                    ]);
                } else nextUtteranceBoundariesRef.current = [
                    ...nextUtteranceBoundariesRef.current,
                    newBoundary
                ];
            }
        };
        tempUtterance.onviseme = (event)=>{
            if (isMainUtterance) {
                // Update the boundaryData state with the new data.
                addViseme(event);
                const tempVisemes = visemeRef?.current || [];
                visemeRef.current = [
                    ...tempVisemes,
                    event
                ];
            } else nextUtteranceVisemesRef.current = [
                ...nextUtteranceVisemesRef.current,
                event
            ];
        };
        return tempUtterance;
    };
    const processNextData = (data)=>{
        nextUtteranceDataRef.current = data?.byteLength && nextUtteranceTextRef.current ? {
            text: nextUtteranceTextRef.current,
            data: {
                speechData: data,
                boundaries: nextUtteranceBoundariesRef.current,
                visemes: nextUtteranceVisemesRef.current
            }
        } : null;
        // Reset boundary / viseme data
        resetNextUtteranceData(true);
    };
    const resetNextUtteranceData = (keepArrayBufferData)=>{
        !keepArrayBufferData && (nextUtteranceDataRef.current = null);
        nextUtteranceTextRef.current = null;
        nextUtteranceBoundariesRef.current = [];
        nextUtteranceVisemesRef.current = [];
    };
    (0, $bxRTa.useEffect)(()=>{
        if (utterance) {
            if (utterance.text) {
                if (audioRef?.current) {
                    if (nextUtteranceDataRef.current?.text === utterance.text && nextUtteranceDataRef.current.data) {
                        boundaryRef.current = nextUtteranceDataRef.current.data.boundaries;
                        setBoundaryData(nextUtteranceDataRef.current.data.boundaries);
                        setVisemeData(nextUtteranceDataRef.current.data.visemes);
                        processData(nextUtteranceDataRef.current.data.speechData, true);
                    } else // Play utterance whether by asking for a speech synthesis, or by retrieving data from indexedDB
                    playUtterance(attachEvents(utterance, true));
                } else stopCurrentPlaying();
            } else handleEmptyTextUtterance();
        } else stopCurrentPlaying();
    }, [
        utterance
    ]);
    (0, $bxRTa.useEffect)(()=>{
        // If there are data in nextUtteranceTextRef, this means the previous synthesis data retrieval is not finished, so we don't begin a new one
        if (nextUtterance?.text && !nextUtteranceTextRef.current) {
            const tempUtterance = attachEvents(nextUtterance);
            nextUtteranceTextRef.current = nextUtterance.text;
            ponyfill.speechSynthesis.synthesizeAndGetArrayData(tempUtterance, processNextData);
        } else resetNextUtteranceData();
    }, [
        nextUtterance
    ]);
    const playUtterance = async (utt)=>{
        if (DBReady && enableSpeechCaching !== false && utt) {
            const dataFromIndexedDB = await $0673a82084862dad$var$DBManager.getSpeechData(`${locale}.${voice?.name}.${utt.text.replace($0673a82084862dad$var$tagsRemoverRegex, '')}`);
            if (dataFromIndexedDB) {
                boundaryRef.current = dataFromIndexedDB.boundaries;
                setBoundaryData(dataFromIndexedDB.boundaries);
                setVisemeData(dataFromIndexedDB.visemes || []);
                processData(dataFromIndexedDB.value, true);
            } else ponyfill.speechSynthesis.synthesizeAndGetArrayData(utt, processData);
        } else ponyfill.speechSynthesis.synthesizeAndGetArrayData(utt, processData);
    };
    const processData = (data, alreadyExistsInDB)=>{
        if (data?.byteLength) {
            const blob = new Blob([
                data
            ], {
                type: 'audio/mp3'
            });
            enableSpeechCaching !== false && !alreadyExistsInDB && DBReady && boundaryRef?.current && utterance && $0673a82084862dad$var$DBManager.addSpeechData({
                id: `${locale}.${voice?.name}.${utterance.text.replace($0673a82084862dad$var$tagsRemoverRegex, '')}`,
                value: data,
                boundaries: boundaryRef.current,
                visemes: visemeRef.current || []
            });
            const url = URL.createObjectURL(blob);
            if (audioRef?.current) {
                setPlayingBlob(true);
                audioRef.current.src = url;
                audioRef.current.play().catch((e)=>console.warn(e));
            }
        } else handleEmptyTextUtterance();
    };
    const resetData = ()=>{
        boundaryRef.current = [];
        visemeRef.current = [];
        setBoundaryData([]);
        setVisemeData([]);
        setPlayingBlob(false);
    };
    const handleStart = ()=>{
        if (appAvailable || loaderClosed) onStart?.();
    };
    const handleEnd = ()=>{
        if (appAvailable || loaderClosed) {
            onEnd?.();
            resetData();
        } else setLoaderClosed(true);
    };
    const handleError = (error)=>{
        console.log('Retorik Framework > speech synthesis error ', error);
        onError?.();
        resetData();
    };
    const handleEmptyTextUtterance = ()=>{
        handleStart();
        emptyTextUtteranceRef?.current && clearTimeout(emptyTextUtteranceRef.current);
        emptyTextUtteranceRef.current = setTimeout(()=>{
            handleEnd();
        }, 50);
    };
    /**
   * On call :
   *  - play 1 second muted sound to prime audio output
   *  - MANDATORY FOR SAFARI IN VOCAL MODE
   */ const primeRetorikSpeech = ()=>{
        if (audioRef.current) {
            audioRef.current.play().catch((e)=>console.warn(e));
            speechRecognitionAudioRef?.current && speechRecognitionAudioRef.current.play().catch((e)=>console.warn(e));
            // Send animation start event to secure animation not playing on safari if permissions are not sufficient
            window.dispatchEvent(new Event('retorikSpiritEnginePlay'));
        }
    };
    /**
   * Play sound on speech recognition activation if it isn't disabled in configuration
   */ (0, $bxRTa.useEffect)(()=>{
        if (useOldRemote) {
            if (!!speechRecognitionOptions?.enableActivationSound && activeRecognitionState === (0, $2rYkD.RecognitionState).Listening) speechRecognitionAudioRef?.current?.play().catch((e)=>console.warn(e));
        } else if (!!speechRecognitionOptions?.enableActivationSound) switch(activeRecognitionState){
            case (0, $2rYkD.RecognitionState).Listening:
                microphoneOpenAudioRef?.current?.play().catch((e)=>console.warn(e));
                break;
            case (0, $2rYkD.RecognitionState).Closing:
                microphoneCloseAudioRef?.current?.play().catch((e)=>console.warn(e));
                break;
            default:
                break;
        }
    }, [
        useOldRemote,
        activeRecognitionState,
        speechRecognitionOptions
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: audioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).onesecond,
                muted: appAvailable || loaderClosed ? muted : true,
                onPlay: handleStart,
                onEnded: handleEnd
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: speechRecognitionAudioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).speechrecognition,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: microphoneOpenAudioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).microphoneopen,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("audio", {
                ref: microphoneCloseAudioRef,
                src: (0, $d1984bac2dac280a$export$52a3c04e084af2a0).microphoneclose,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7ac27256f2d61bf4$export$2e2bcd8739ae039), {
                appAvailable: appAvailable,
                handleValidation: primeRetorikSpeech
            })
        ]
    });
};
var $0673a82084862dad$export$2e2bcd8739ae039 = $0673a82084862dad$var$RetorikSpeech;


const $12d972be73a3588e$var$SynthesisManager = ({ ponyfill: ponyfill, isRetorikNews: isRetorikNews })=>{
    const cancel = (0, $giKuE.useSpeechStore)((state)=>state.cancel);
    const streamingQueue = (0, $giKuE.useSpeechStore)((state)=>state.streamingQueue);
    const voice = (0, $giKuE.useSpeechStore)((state)=>state.voice);
    const customVoice = (0, $giKuE.useSpeechStore)((state)=>state.customVoice);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const externalTextToSpeech = (0, $giKuE.useSpeechStore)((state)=>state.externalTextToSpeech);
    const isMicrophoneAllowed = (0, $giKuE.useSpeechStore)((state)=>state.isMicrophoneAllowed);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const appAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.appAvailable);
    const preventExpectedInputHint = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.preventExpectedInputHint);
    const speechSynthesisOptions = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.speechSynthesisOptions);
    const checkReplacementLocale = (0, $2eBYD.useLocaleStore)((state)=>state.actions.checkReplacementLocale);
    const setRetorikNewsEnded = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setRetorikNewsEnded);
    const { setCurrentOrLastPlayedActivity: setCurrentOrLastPlayedActivity, resetCancelCurrentUtterance: resetCancelCurrentUtterance, setSpeaking: setSpeaking, setBoundaryData: setBoundaryData, removeFirstFromStreamingQueue: removeFirstFromStreamingQueue, killCurrentStreaming: killCurrentStreaming, askPermission: askPermission, toggleMicrophone: toggleMicrophone } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const addEndedActivity = (0, $bWQ72.useActivityStore)((state)=>state.actions.addEndedActivity);
    const dispatchMarkActivity = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.dispatchMarkActivity);
    const sendTrace = (0, $f6050bdd136b78fe$export$a15d15518a3ec33d)().sendTrace;
    const [utterance, setUtterance] = (0, $bxRTa.useState)(null);
    const [nextUtterance, setNextUtterance] = (0, $bxRTa.useState)(null);
    const isNewsViewRef = (0, $bxRTa.useRef)(!!isRetorikNews);
    const lastListTextPlayedRef = (0, $bxRTa.useRef)('');
    const streamingQueueRef = (0, $bxRTa.useRef)([]);
    const currentActivityRef = (0, $bxRTa.useRef)(null);
    /**
   * Check activity locale in case of voice change during the speech, to keep the language defined in activity
   * instead of switching languages between answers that are written in the same language
   * @param {string} activityLocale
   * @returns {SpeechSynthesisVoice | null}
   */ const getVoiceAfterCheckingActivityLocale = (activityLocale)=>{
        return activityLocale === locale ? voice : (0, $57f41e573dafcd6e$export$4bf371fc4fa74a28)(ponyfill.speechSynthesis.getVoices(), activityLocale, customVoice, agentData);
    };
    /**
   * Check if the activity is a list one, to prevent text re-reading on state update
   * @param {CreateUtteranceParams} params
   * @returns {SpeechSynthesisUtterance}
   */ const checkActivityAndCreateUtterance = (params)=>{
        if (params.activity.attachmentLayout && params.activity.attachmentLayout.toLowerCase() === 'davilist') {
            const textToSpeak = params.activity.speak || params.activity.text;
            if (textToSpeak) {
                if (textToSpeak === lastListTextPlayedRef.current) return (0, $2161e8fb47c6c1a6$export$f969af62bba9a48b)({
                    ...params,
                    voice: null
                }, speechSynthesisOptions?.sayAs);
                else lastListTextPlayedRef.current = textToSpeak;
            }
        }
        return (0, $2161e8fb47c6c1a6$export$f969af62bba9a48b)(params, speechSynthesisOptions?.sayAs);
    };
    const resetData = ()=>{
        // Set all activities currently in the queue as ended
        streamingQueueRef.current?.forEach((activity)=>{
            addEndedActivity(activity.id);
        });
        streamingQueueRef.current = [];
        killCurrentStreaming();
        currentActivityRef.current = null;
        setUtterance(null);
        setNextUtterance(null);
        resetCancelCurrentUtterance();
        setSpeaking(false);
        setBoundaryData([]);
    };
    const checkReplacementLocaleAndGetUtterance = (activity, checkReplacement = true)=>{
        const replacementLocale = checkReplacement ? checkReplacementLocale(activity.locale || locale) : locale;
        const params = {
            activity: activity,
            voice: getVoiceAfterCheckingActivityLocale(replacementLocale),
            locale: replacementLocale
        };
        return checkActivityAndCreateUtterance(params);
    };
    /**
   * Check if the microphone can be opened automatically
   */ const checkDictateState = ()=>{
        if (!preventExpectedInputHint && mode === (0, $2rYkD.Mode).vocal && activeRecognitionState === (0, $2rYkD.RecognitionState).Closed) {
            if (!isMicrophoneAllowed) askPermission();
            else toggleMicrophone(true);
        }
    };
    /**
   * On route change, reset all data and check if we are on the news view
   */ (0, $bxRTa.useEffect)(()=>{
        resetData();
        if (!isRetorikNews) isNewsViewRef.current = route === (0, $2rYkD.Routes).News;
    }, [
        route
    ]);
    /**
   * On cancel call, reset all data and kill current streaming
   */ (0, $bxRTa.useEffect)(()=>{
        cancel && resetData();
    }, [
        cancel
    ]);
    /**
   * Play external speech immediately but don't add it to the history
   */ (0, $bxRTa.useEffect)(()=>{
        if (externalTextToSpeech) {
            const activity = {
                speak: externalTextToSpeech,
                locale: locale
            };
            currentActivityRef.current = activity;
            setUtterance(checkReplacementLocaleAndGetUtterance(activity, false));
        }
    }, [
        externalTextToSpeech
    ]);
    const dispatchSpeechEvent = (start)=>{
        const speechEvent = start ? new Event('retorikSpeakStart') : new Event('retorikSpeakStop');
        document.dispatchEvent(speechEvent);
    };
    /**
   * Called when utterance's "start" event is fired
   */ const handleUtteranceStart = ()=>{
        sendTrace((0, $2rYkD.TraceType).utteranceStart, {
            activityId: currentActivityRef.current?.id,
            text: currentActivityRef.current?.speak || currentActivityRef.current?.text
        });
        setSpeaking(true);
        if (!isNewsViewRef.current && currentActivityRef?.current) {
            setCurrentOrLastPlayedActivity(currentActivityRef.current);
            currentActivityRef.current.id && dispatchMarkActivity(currentActivityRef.current.id, true);
        }
        dispatchSpeechEvent(true);
        // Set next utterance to prepare synthesis data in order to improve fluidity
        if (streamingQueueRef.current.length && !streamingQueueRef.current[0].value?.streamingCount) {
            const utt = checkReplacementLocaleAndGetUtterance(streamingQueueRef.current[0], false);
            setNextUtterance((current)=>utt.text === current?.text ? null : utt);
        } else setNextUtterance(null);
    };
    /**
   * Called when utterance's "end" event is fired
   */ const handleUtteranceEnd = ()=>{
        sendTrace((0, $2rYkD.TraceType).utteranceEnd, {
            activityId: currentActivityRef.current?.id
        });
        setSpeaking(false);
        dispatchSpeechEvent(false);
        if (isNewsViewRef.current) {
            setRetorikNewsEnded(true);
            currentActivityRef.current = null;
        } else handleEnded();
    };
    const handleEnded = ()=>{
        // Add played activity id to context's endedActivities
        if (currentActivityRef.current?.id) {
            addEndedActivity(currentActivityRef.current.id);
            dispatchMarkActivity(currentActivityRef.current.id, false);
        }
        if (streamingQueueRef.current?.length) {
            // Check if this is the message sent after streaming activities
            if (streamingQueueRef.current[0].value?.streamingCount) {
                addEndedActivity(streamingQueueRef.current[0].id);
                // If there is another activity after this message, play it. If not, let's check if the microphone should be opened
                if (streamingQueueRef.current?.length > 1) {
                    const utt = checkReplacementLocaleAndGetUtterance(streamingQueueRef.current[1]);
                    currentActivityRef.current = streamingQueueRef.current[1];
                    setUtterance(utt);
                    removeFirstFromStreamingQueue(true);
                } else {
                    streamingQueueRef.current[0].inputHint === 'expectingInput' && checkDictateState();
                    currentActivityRef.current = null;
                    setUtterance(null);
                    setNextUtterance(null);
                    removeFirstFromStreamingQueue();
                }
            } else {
                const utt = checkReplacementLocaleAndGetUtterance(streamingQueueRef.current[0]);
                currentActivityRef.current = streamingQueueRef.current[0];
                setUtterance(utt);
                removeFirstFromStreamingQueue();
            }
        } else {
            currentActivityRef.current?.inputHint === 'expectingInput' && checkDictateState();
            currentActivityRef.current = null;
            setUtterance(null);
            setNextUtterance(null);
        }
    };
    /**
   * Wait for app loading and voice selection to begin playing speech
   */ (0, $bxRTa.useEffect)(()=>{
        // Set ref from the state to use in events
        streamingQueueRef.current = streamingQueue;
        if (appAvailable && voice && streamingQueue.length && !currentActivityRef.current) handleEnded();
    }, [
        appAvailable,
        voice,
        streamingQueue
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0673a82084862dad$export$2e2bcd8739ae039), {
        ponyfill: ponyfill,
        appAvailable: appAvailable,
        utterance: utterance,
        nextUtterance: nextUtterance,
        onStart: handleUtteranceStart,
        onError: handleUtteranceEnd,
        onEnd: handleUtteranceEnd
    });
};
var $12d972be73a3588e$export$2e2bcd8739ae039 = $12d972be73a3588e$var$SynthesisManager;


const $33bbcb005e851f61$var$SynthesisPonyfillManager = ({ isRetorikNews: isRetorikNews })=>{
    const customVoice = (0, $giKuE.useSpeechStore)((state)=>state.customVoice);
    const ponyfillCredentials = (0, $giKuE.useSpeechStore)((state)=>state.ponyfillCredentials);
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const setVoice = (0, $giKuE.useSpeechStore)((state)=>state.actions.setVoice);
    const [ponyfillCreated, setPonyfillCreated] = (0, $bxRTa.useState)(false);
    const ponyfillRef = (0, $bxRTa.useRef)(undefined);
    const refreshTimerRef = (0, $bxRTa.useRef)(null);
    /**
   * Async function to retrieve a new token and assign it to the speechConfig inside ponyfill.speechSynthesis
   * @param {string} region
   * @param {string} key
   */ const refreshTokenInNineMinutes = async (region, key)=>{
        // A token is valid during 10 minutes, let's refresh it after 9 minutes
        refreshTimerRef.current = setTimeout(async ()=>{
            const token = await (0, $2f9f46fd962caacf$export$a2ce4fdd6972d6a7)(region, key);
            if (token && ponyfillRef.current?.speechSynthesis?.speechConfig) {
                ponyfillRef.current.speechSynthesis.speechConfig.authorizationToken = token;
                refreshTokenInNineMinutes(region, key);
            }
        }, 540000) // 9 minutes
        ;
    };
    /**
   * Fetch speech synthesis token and create the ponyfill containing all data
   * @param {string} region
   * @param {string} key
   */ const fetchTokenAndCreatePonyfill = async (region, key)=>{
        const token = await (0, $2f9f46fd962caacf$export$a2ce4fdd6972d6a7)(region, key);
        if (token) {
            ponyfillRef.current = (0, $lo8xw.createSpeechSynthesisPonyfill)({
                credentials: {
                    region: ponyfillCredentials?.region,
                    authorizationToken: token
                }
            });
            // Launch token refresh after ponyfill creation
            refreshTokenInNineMinutes(region, key);
            setPonyfillCreated(true);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillCredentials?.authorizationToken && ponyfillCredentials.region) {
            const data = {
                credentials: ponyfillCredentials
            };
            ponyfillRef.current = (0, $lo8xw.createSpeechSynthesisPonyfill)(data);
            setPonyfillCreated(true);
        } else if (ponyfillCredentials?.subscriptionKey && ponyfillCredentials.region) fetchTokenAndCreatePonyfill(ponyfillCredentials.region, ponyfillCredentials.subscriptionKey);
        else if (ponyfillCredentials?.speechSynthesisHostname) {
            // To use self-hosted voice containers, we need no 'region', and 'speechSynthesisHostname' and 'speechRecognitionHostname' must both be defined
            // As this ponyfill is for speech synthesis only, we put a mock 'speechRecognitionHostname' 
            const data = {
                credentials: {
                    // @ts-ignore
                    speechSynthesisHostname: new URL(ponyfillCredentials.speechSynthesisHostname),
                    speechRecognitionHostname: ponyfillCredentials.speechRecognitionHostname || 'mandatory_recognition_host_name',
                    subscriptionKey: ponyfillCredentials.subscriptionKey || 'mandatory_subscription_key'
                }
            };
            ponyfillRef.current = (0, $lo8xw.createSpeechSynthesisPonyfill)(data);
            setPonyfillCreated(true);
        }
    }, [
        ponyfillCredentials
    ]);
    const onVoicesChanged = ()=>{
        const voices = ponyfillRef.current?.speechSynthesis.getVoices();
        if (voices && Array.isArray(voices) && voices.length) setVoice((0, $57f41e573dafcd6e$export$4bf371fc4fa74a28)(voices, locale, customVoice, agentData));
    };
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillRef.current) {
            const voices = ponyfillRef.current.speechSynthesis.getVoices();
            if (voices && Array.isArray(voices) && voices.length) setVoice((0, $57f41e573dafcd6e$export$4bf371fc4fa74a28)(voices, locale, customVoice, agentData));
            else ponyfillRef.current.speechSynthesis.onvoiceschanged = onVoicesChanged;
        }
    }, [
        ponyfillCreated,
        customVoice,
        agentData,
        locale
    ]);
    (0, $bxRTa.useEffect)(()=>{
        return ()=>{
            refreshTimerRef.current && clearTimeout(refreshTimerRef.current);
        };
    }, []);
    return ponyfillCreated && ponyfillRef.current ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $12d972be73a3588e$export$2e2bcd8739ae039), {
        ponyfill: ponyfillRef.current,
        isRetorikNews: isRetorikNews
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $33bbcb005e851f61$export$2e2bcd8739ae039 = $33bbcb005e851f61$var$SynthesisPonyfillManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $lo8xw = parcelRequire("lo8xw");

var $2eBYD = parcelRequire("2eBYD");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $hdMz2 = parcelRequire("hdMz2");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");

var $eh4BG = parcelRequire("eh4BG");
const $929f3e20ef85e71e$var$timeoutDuration = 1000;
const $929f3e20ef85e71e$var$RecognitionManager = ()=>{
    const locale = (0, $2eBYD.useLocaleStore)((state)=>state.locale);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const appAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.appAvailable);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const delay = (0, $7SHCs.useRetorikStore)((state)=>state.submitDelayBeforeSendingMessage);
    const speechRecognitionOptions = (0, $7SHCs.useRetorikStore)((state)=>state.configuration.speechRecognitionOptions);
    const ponyfillCredentials = (0, $giKuE.useSpeechStore)((state)=>state.ponyfillCredentials);
    const useContinuousRecognition = (0, $giKuE.useSpeechStore)((state)=>state.useContinuousRecognition);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const lastRecognitionInterim = (0, $giKuE.useSpeechStore)((state)=>state.lastRecognitionInterim);
    const speechRecognitionDynamicGrammars = (0, $giKuE.useSpeechStore)((state)=>state.speechRecognitionDynamicGrammars);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const { setActiveRecognitionState: setActiveRecognitionState, setLastRecognitionInterim: setLastRecognitionInterim, toggleMicrophone: toggleMicrophone } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const sendMessage = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendMessage);
    const [ponyfill, setPonyfill] = (0, $bxRTa.useState)(null);
    const [recognitionAllowed, setRecognitionAllowed] = (0, $bxRTa.useState)(false);
    const [ponyfillReady, setPonyfillReady] = (0, $bxRTa.useState)(false);
    const activeModeRef = (0, $bxRTa.useRef)();
    const timerRef = (0, $bxRTa.useRef)(null);
    const localeRef = (0, $bxRTa.useRef)(undefined);
    const getCommonAndLocalizedWakeWords = (currentLocale, agentName)=>{
        let commonAndlocalizedWakeWords = [];
        if (speechRecognitionOptions?.wakeWords) {
            if (speechRecognitionOptions.wakeWords.common) commonAndlocalizedWakeWords = [
                ...speechRecognitionOptions.wakeWords.common
            ];
            if (speechRecognitionOptions.wakeWords.localized) {
                const localizedWakeWords = speechRecognitionOptions.wakeWords.localized[currentLocale] || [];
                localizedWakeWords.length && (commonAndlocalizedWakeWords = [
                    ...commonAndlocalizedWakeWords,
                    ...localizedWakeWords
                ]);
            }
        }
        // Add agent's name to wake words
        agentName && (commonAndlocalizedWakeWords = [
            ...commonAndlocalizedWakeWords,
            agentName
        ]);
        return commonAndlocalizedWakeWords;
    };
    const getCommonAndLocalizedGrammars = (currentLocale)=>{
        let commonAndlocalizedGrammars = [];
        if (speechRecognitionOptions?.grammars) {
            if (speechRecognitionOptions.grammars.common) commonAndlocalizedGrammars = [
                ...speechRecognitionOptions.grammars.common
            ];
            if (speechRecognitionOptions.grammars.localized) {
                const localizedGrammars = speechRecognitionOptions.grammars.localized[currentLocale] || [];
                localizedGrammars.length && (commonAndlocalizedGrammars = [
                    ...commonAndlocalizedGrammars,
                    ...localizedGrammars
                ]);
            }
        }
        return commonAndlocalizedGrammars;
    };
    const askPermission = ()=>{
        if (recognitionAllowed) ponyfill?.speechRecognition.start();
        else (0, $eh4BG.default)().then((permission)=>{
            setRecognitionAllowed(permission === (0, $2rYkD.PermissionStatus).allowed);
        }).catch(console.log);
    };
    (0, $bxRTa.useEffect)(()=>{
        // Clear data on component unmount
        return ()=>{
            timerRef?.current && clearTimeout(timerRef.current);
            ponyfill?.speechRecognition?.abort?.();
        };
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        recognitionAllowed && useContinuousRecognition && ponyfill?.speechRecognition.start();
    }, [
        recognitionAllowed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillCredentials && locale && agentData) {
            let currentPonyfill = ponyfill;
            if (locale !== localeRef.current) {
                localeRef.current = locale;
                // We create the ponyfill if it isn't created yet. We recreate a new one if we are using custom endpoints for speech recognition.
                if (!ponyfill || ponyfillCredentials?.speechRecognitionHostnamesRecord) {
                    // Check if we need to use a custom endpoint from speechRecognitionHostnamesRecord
                    const speechRecognitionHostname = ponyfillCredentials?.speechRecognitionHostnamesRecord ? ponyfillCredentials.speechRecognitionHostnamesRecord[locale] || Object.values(ponyfillCredentials.speechRecognitionHostnamesRecord)[0] : undefined;
                    const options = {
                        autoStart: false,
                        continuous: useContinuousRecognition,
                        interimResults: true,
                        grammarsList: getCommonAndLocalizedGrammars(locale),
                        lang: locale,
                        passive: useContinuousRecognition,
                        wakeWords: getCommonAndLocalizedWakeWords(locale),
                        debug: false,
                        timerBeforeSpeechEnd: speechRecognitionOptions?.timerBeforeSpeechEnd
                    };
                    const processedCredentials = {
                        credentials: speechRecognitionHostname ? {
                            region: undefined,
                            subscriptionKey: ponyfillCredentials.subscriptionKey || 'mandatory_subscription_key',
                            speechRecognitionHostname: speechRecognitionHostname,
                            speechSynthesisHostname: 'mandatory_synthesis_host_name'
                        } : {
                            region: ponyfillCredentials.region,
                            subscriptionKey: ponyfillCredentials.subscriptionKey,
                            authorizationToken: ponyfillCredentials.authorizationToken
                        }
                    };
                    // Abort current recognition before setting the new recognition ponyfill if there is a need to
                    currentPonyfill?.speechRecognition?.abort?.();
                    currentPonyfill = (0, $lo8xw.createSpeechRecognitionPonyfill)(processedCredentials, options);
                } else if (currentPonyfill) {
                    // Set wakeworkds
                    currentPonyfill.speechRecognition.wakeWords = getCommonAndLocalizedWakeWords(locale, agentData?.name);
                    // Set language
                    activeRecognitionState === (0, $2rYkD.RecognitionState).Listening ? currentPonyfill?.speechRecognition.changeLanguage(locale) : currentPonyfill.speechRecognition.lang = locale;
                }
            }
            if (currentPonyfill) {
                // Set grammar list
                const grammarList = new (0, $lo8xw.SpeechGrammarList)();
                grammarList.phrases = getCommonAndLocalizedGrammars(locale);
                if (speechRecognitionDynamicGrammars.length) speechRecognitionDynamicGrammars.forEach((grammar)=>{
                    !grammarList.phrases.includes(grammar) && grammarList.phrases.push(grammar);
                });
                if (agentData?.name) {
                    // Add raw name
                    !grammarList.phrases.includes(agentData.name) && grammarList.phrases.push(agentData.name);
                    // Add lower-cased name
                    !grammarList.phrases.includes(agentData.name.toLocaleLowerCase(locale)) && grammarList.phrases.push(agentData.name.toLocaleLowerCase(locale));
                }
                currentPonyfill.speechRecognition.grammars = grammarList;
                setPonyfill(currentPonyfill);
            }
        }
    }, [
        ponyfillCredentials,
        locale,
        speechRecognitionDynamicGrammars,
        agentData
    ]);
    /**
   * Abort recognition if we are not on the 'home' page
   */ (0, $bxRTa.useEffect)(()=>{
        route !== (0, $2rYkD.Routes).Home && setActiveRecognitionState((0, $2rYkD.RecognitionState).Closing);
    }, [
        route
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfill && appAvailable && loaderClosed) {
            if (ponyfill.speechRecognition) {
                ponyfill.speechRecognition.onstart = ()=>{
                    setActiveRecognitionState((0, $2rYkD.RecognitionState).Listening);
                };
                // onend callback is called only whithout using passive speech recognition
                ponyfill.speechRecognition.onend = ()=>{
                    setActiveRecognitionState((0, $2rYkD.RecognitionState).Closing);
                };
                ponyfill.speechRecognition.onabort = ()=>{
                    setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
                };
                ponyfill.speechRecognition.onwakeup = ()=>{
                    if (activeModeRef.current === (0, $2rYkD.RecognitionState).Closed) {
                        console.log('Retorik Framework > wake word found, trying to open microphone');
                        activeModeRef.current === (0, $2rYkD.RecognitionState).Closed && toggleMicrophone();
                    } else console.log('Retorik Framework > wake word found, but microphone not ready');
                };
                ponyfill.speechRecognition.onresult = (result)=>{
                    const lastMessage = result.length ? result[result.length - 1].transcript : null;
                    // Only get result in Active mode
                    if (lastMessage && activeModeRef.current === (0, $2rYkD.RecognitionState).Listening) setLastRecognitionInterim(lastMessage);
                };
                setPonyfillReady(true);
            }
        }
    }, [
        ponyfill,
        appAvailable,
        loaderClosed
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (ponyfillReady && mode === (0, $2rYkD.Mode).vocal) // Start passive recognition if not done yet
        useContinuousRecognition && !ponyfill?.speechRecognition.started && askPermission();
    }, [
        mode,
        ponyfillReady
    ]);
    const togglePassiveToActive = ()=>{
        if (ponyfill?.speechRecognition.started) ponyfill.speechRecognition.toggleContinuousPassiveToActive();
        else if (ponyfill) {
            ponyfill.speechRecognition.passive = false;
            ponyfill.speechRecognition.continuous = false;
            ponyfill.speechRecognition.start();
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        activeModeRef.current = activeRecognitionState;
        if (ponyfill?.speechRecognition && appAvailable && loaderClosed) {
            timerRef?.current && clearTimeout(timerRef.current);
            switch(activeRecognitionState){
                // Do nothing if we are in a transition state
                case (0, $2rYkD.RecognitionState).Initializing:
                    useContinuousRecognition ? togglePassiveToActive() : ponyfill.speechRecognition.start();
                    break;
                case (0, $2rYkD.RecognitionState).Listening:
                    break;
                case (0, $2rYkD.RecognitionState).Closing:
                    if (lastRecognitionInterim) {
                        if (!delay) timerRef.current = setTimeout(()=>{
                            sendMessage(lastRecognitionInterim);
                            setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
                        }, $929f3e20ef85e71e$var$timeoutDuration);
                    } else setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
                    break;
                case (0, $2rYkD.RecognitionState).ForceClosing:
                    setLastRecognitionInterim('');
                    // If an interim was processed, a 'end' event will be fired. If not, we must abort the current recognition
                    if (!lastRecognitionInterim) ponyfill.speechRecognition.started ? ponyfill.speechRecognition.abort?.() : setActiveRecognitionState((0, $2rYkD.RecognitionState).Closed);
                    break;
                case (0, $2rYkD.RecognitionState).Closed:
                    if (useContinuousRecognition && mode === (0, $2rYkD.Mode).vocal) timerRef.current = setTimeout(()=>{
                        ponyfill.speechRecognition.toggleContinuousActiveToPassive();
                    }, $929f3e20ef85e71e$var$timeoutDuration);
                    setLastRecognitionInterim('');
                    break;
            }
        }
    }, [
        activeRecognitionState
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $929f3e20ef85e71e$export$2e2bcd8739ae039 = $929f3e20ef85e71e$var$RecognitionManager;


const $93362ea804fbed50$var$SpeechManager = ({ isRetorikNews: isRetorikNews })=>{
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $33bbcb005e851f61$export$2e2bcd8739ae039), {
                isRetorikNews: isRetorikNews
            }),
            !isRetorikNews && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $929f3e20ef85e71e$export$2e2bcd8739ae039), {})
        ]
    });
};
var $93362ea804fbed50$export$2e2bcd8739ae039 = $93362ea804fbed50$var$SpeechManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $clSD3 = parcelRequire("clSD3");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $9qyYE = parcelRequire("9qyYE");

var $2rYkD = parcelRequire("2rYkD");
const $7b98e1e71501801c$var$FocusManager = ()=>{
    const isWidget = (0, $9JLpC.useViewStore)((state)=>state.isWidget);
    const open = (0, $9qyYE.useWidgetStore)((state)=>state.open);
    const muted = (0, $giKuE.useSpeechStore)((state)=>state.muted);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const { setMuted: setMuted, cancelCurrentUtterance: cancelCurrentUtterance, setActiveRecognitionState: setActiveRecognitionState } = (0, $giKuE.useSpeechStore)((state)=>state.actions);
    const focusedRef = (0, $bxRTa.useRef)(true);
    const oldMutedRef = (0, $bxRTa.useRef)(muted);
    const recognitionStateRef = (0, $bxRTa.useRef)(activeRecognitionState);
    (0, $bxRTa.useEffect)(()=>{
        focusedRef.current && (oldMutedRef.current = muted);
    }, [
        muted
    ]);
    (0, $bxRTa.useEffect)(()=>{
        recognitionStateRef.current = activeRecognitionState;
    }, [
        activeRecognitionState
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if ((0, $clSD3.isMobile) && isWidget) {
            if (open) {
                focusedRef.current = true;
                oldMutedRef.current === false && setMuted(false);
            } else {
                focusedRef.current = false;
                cancelCurrentUtterance();
                setMuted(true);
                recognitionStateRef.current === (0, $2rYkD.RecognitionState).Listening && setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
            }
        }
    }, [
        open,
        isWidget,
        (0, $clSD3.isMobile)
    ]);
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'visible') {
            focusedRef.current = true;
            oldMutedRef.current === false && setMuted(false);
        } else {
            focusedRef.current = false;
            cancelCurrentUtterance();
            setMuted(true);
            recognitionStateRef.current === (0, $2rYkD.RecognitionState).Listening && setActiveRecognitionState((0, $2rYkD.RecognitionState).ForceClosing);
        }
    };
    (0, $bxRTa.useEffect)(()=>{
        (0, $clSD3.isMobile) && document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        (0, $clSD3.isMobile)
    ]);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $7b98e1e71501801c$export$2e2bcd8739ae039 = $7b98e1e71501801c$var$FocusManager;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");

var $9JLpC = parcelRequire("9JLpC");

var $eyNRs = parcelRequire("eyNRs");
const $aebbface17e3c004$var$MobileLandscapePreventer = ()=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const isMobileLandscape = (0, $9JLpC.useViewStore)((state)=>state.isMobileLandscape);
    return isMobileLandscape ? /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-absolute rf-w-full rf-h-full rf-z-exitwidget rf-flex rf-flex-col rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-h-1/2 rf-flex rf-items-end rf-pb-4",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                    className: "rf-h-2/3",
                    src: (0, $eyNRs.rotatingPhoneFromVerticalToHorizontalPosition)
                })
            }),
            /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: "rf-h-1/2 rf-pt-4 rf-flex rf-flex-col rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-font-semibold rf-text-xl",
                        children: translation.mobileLandscapePreventer.firstline
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-font-bold rf-text-3xl",
                        children: translation.mobileLandscapePreventer.secondline
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $aebbface17e3c004$export$2e2bcd8739ae039 = $aebbface17e3c004$var$MobileLandscapePreventer;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $bxRTa = parcelRequire("bxRTa");
'use client';
const $d65cae6753790fc6$export$b16d9fb1a22de840 = (0, $bxRTa.createContext)(null);
const $d65cae6753790fc6$var$initialState = {
    didCatch: false,
    error: null
};
class $d65cae6753790fc6$export$e926676385687eaf extends (0, $bxRTa.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $d65cae6753790fc6$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($d65cae6753790fc6$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $d65cae6753790fc6$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($d65cae6753790fc6$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $bxRTa.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $bxRTa.createElement)($d65cae6753790fc6$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $d65cae6753790fc6$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $d65cae6753790fc6$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $d65cae6753790fc6$export$c052f6604b7d51fe() {
    const context = (0, $bxRTa.useContext)($d65cae6753790fc6$export$b16d9fb1a22de840);
    $d65cae6753790fc6$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $bxRTa.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $bxRTa.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $d65cae6753790fc6$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $bxRTa.forwardRef)((props, ref)=>(0, $bxRTa.createElement)($d65cae6753790fc6$export$e926676385687eaf, errorBoundaryProps, (0, $bxRTa.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $2eBYD = parcelRequire("2eBYD");
const $4f2286a4170005b4$var$ErrorFallback = ({ resetErrorBoundary: resetErrorBoundary })=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const handleReset = ()=>{
        resetErrorBoundary();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2",
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("p", {
                className: "rf-uppercase",
                children: translation.error.title
            }),
            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                onClick: handleReset,
                className: "rf-border rf-px-4",
                children: translation.error.button
            })
        ]
    });
};
var $4f2286a4170005b4$export$2e2bcd8739ae039 = $4f2286a4170005b4$var$ErrorFallback;


const $88f116d8e86f389c$var$ErrorCollector = ({ children: children })=>{
    const { sendErrorTrace: sendErrorTrace } = (0, $f6050bdd136b78fe$export$a15d15518a3ec33d)();
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $d65cae6753790fc6$export$e926676385687eaf), {
        FallbackComponent: (0, $4f2286a4170005b4$export$2e2bcd8739ae039),
        onError: sendErrorTrace,
        children: children
    });
};
var $88f116d8e86f389c$export$2e2bcd8739ae039 = $88f116d8e86f389c$var$ErrorCollector;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $giKuE = parcelRequire("giKuE");

var $7SHCs = parcelRequire("7SHCs");

var $4xGiN = parcelRequire("4xGiN");

var $9JLpC = parcelRequire("9JLpC");

var $hdMz2 = parcelRequire("hdMz2");

var $2rYkD = parcelRequire("2rYkD");
const $3a939308a60f9856$var$typingTimer = 2000;
const $3a939308a60f9856$var$SendTypingIndicator = ({ isRetorikNews: isRetorikNews })=>{
    const speaking = (0, $giKuE.useSpeechStore)((state)=>state.speaking);
    const streamingQueue = (0, $giKuE.useSpeechStore)((state)=>state.streamingQueue);
    const activeRecognitionState = (0, $giKuE.useSpeechStore)((state)=>state.activeRecognitionState);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const loaderClosed = (0, $7SHCs.useRetorikStore)((state)=>state.loaderClosed);
    const appAvailable = (0, $7SHCs.useRetorikStore)((state)=>state.appAvailable);
    const isWaitingForResponse = (0, $7SHCs.useRetorikStore)((state)=>state.isWaitingForResponse);
    const currentSubView = (0, $4xGiN.useUtilsStore)((state)=>state.currentSubView);
    const listStatus = (0, $4xGiN.useUtilsStore)((state)=>state.listStatus);
    const retorikEvent = (0, $4xGiN.useUtilsStore)((state)=>state.retorikEvent);
    const userIsTyping = (0, $4xGiN.useUtilsStore)((state)=>state.userIsTyping);
    const userIsSwiping = (0, $4xGiN.useUtilsStore)((state)=>state.userIsSwiping);
    const sendTyping = (0, $hdMz2.useDirectlineStore)((state)=>state.actions.sendTyping);
    const dataRef = (0, $bxRTa.useRef)(false);
    (0, $bxRTa.useEffect)(()=>{
        // Don't send typing activity when we are receiving streaming events
        const isReceivingStreamingData = !!streamingQueue.length && !!streamingQueue.find((activity)=>activity.name?.toLowerCase() === 'davi.streammessageactivity') && !streamingQueue.find((activity)=>activity.value?.streamingCount);
        dataRef.current = !isWaitingForResponse && // Don't send typing activity when we are receiving streaming events
        !isReceivingStreamingData && (!loaderClosed || activeRecognitionState !== (0, $2rYkD.RecognitionState).Closed || userIsTyping || userIsSwiping || speaking || currentSubView !== (0, $2rYkD.CurrentSubView).none || route === (0, $2rYkD.Routes).News || retorikEvent === (0, $2rYkD.RetorikEvent).DetailViewOpen || listStatus === (0, $2rYkD.ListStatus).opened);
    }, [
        appAvailable,
        loaderClosed,
        activeRecognitionState,
        userIsTyping,
        userIsSwiping,
        speaking,
        streamingQueue,
        currentSubView,
        route,
        retorikEvent,
        listStatus,
        isWaitingForResponse
    ]);
    const checkShouldSendTypingIndicator = ()=>{
        dataRef.current && !isRetorikNews && sendTyping();
    };
    (0, $bxRTa.useEffect)(()=>{
        const interval = setInterval(()=>{
            checkShouldSendTypingIndicator();
        }, $3a939308a60f9856$var$typingTimer);
        return ()=>{
            interval && clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $3a939308a60f9856$export$2e2bcd8739ae039 = $3a939308a60f9856$var$SendTypingIndicator;



var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $4xGiN = parcelRequire("4xGiN");

var $2rYkD = parcelRequire("2rYkD");

var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $7SHCs = parcelRequire("7SHCs");

var $giKuE = parcelRequire("giKuE");

var $9JLpC = parcelRequire("9JLpC");

var $2rYkD = parcelRequire("2rYkD");
const $1fdb6bf67360bb2c$var$Subtitle = ({ isSpeaking: isSpeaking, elapsedTime: elapsedTime })=>{
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const displaySubtitles = (0, $7SHCs.useRetorikStore)((state)=>state.displaySubtitles);
    const boundaryData = (0, $giKuE.useSpeechStore)((state)=>state.boundaryData);
    const configuration = (0, $7SHCs.useRetorikStore)((state)=>state.configuration);
    const currentDeviceType = (0, $9JLpC.useViewStore)((state)=>state.currentDeviceType);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    const [sentenceToDisplay, setSentenceToDisplay] = (0, $bxRTa.useState)('');
    const keepLastSentenceRef = (0, $bxRTa.useRef)(null);
    // Generate an array of sentences from boundaryData
    const sentences = (0, $bxRTa.useMemo)(()=>{
        // If no boundary data is available, return an empty array
        if (!boundaryData || boundaryData.length === 0) return [];
        // Prepare an array to store sentences and their durations
        const sentencesArray = [];
        let currentSentence = '';
        let currentStartTime = boundaryData[0].startTime / 10000;
        // Loop over each boundary data item
        for(let i = 0; i < boundaryData.length; i++){
            const boundary = boundaryData[i];
            // Prepare a string based on the word at the boundary
            let boundaryString = '';
            if ([
                '.',
                ',',
                '...'
            ].includes(boundary.word)) boundaryString = boundary.word;
            else if ([
                ':',
                ';',
                '!',
                '?'
            ].includes(boundary.word)) boundaryString = '\u00A0' + boundary.word;
            else boundaryString = i === 0 ? boundary.word : ' ' + boundary.word;
            // Construct a new sentence
            const newSentence = currentSentence + boundaryString;
            // If it's the last boundary of the current array or the end of the boundaries (type 'EndBoundary')
            if (i === boundaryData.length - 1 || boundary.boundaryType === 'EndBoundary') // If there is a sentence to push, add it to the array
            {
                if (newSentence.trim() !== '') sentencesArray.push({
                    sentence: newSentence,
                    startTime: currentStartTime
                });
            } else if (newSentence.length > 50) {
                // If the current word is a punctuation, add it even if it goes beyond 50 characters
                if (boundary.boundaryType === 'PunctuationBoundary') {
                    if (newSentence.trim() !== '') sentencesArray.push({
                        sentence: newSentence,
                        startTime: currentStartTime
                    });
                    currentStartTime = boundaryData[i + 1].startTime / 10000;
                    currentSentence = '';
                } else {
                    if (newSentence.trim() !== '') sentencesArray.push({
                        sentence: currentSentence,
                        startTime: currentStartTime
                    });
                    currentStartTime = boundary.startTime / 10000;
                    currentSentence = boundary.word;
                }
            } else // Continue the current sentence
            currentSentence = newSentence;
        }
        return sentencesArray;
    }, [
        boundaryData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $2rYkD.DeviceType).mobile:
            case (0, $2rYkD.DeviceType).widget:
                setGridRowStart(11);
                setGridRowSpan(1);
                break;
            case (0, $2rYkD.DeviceType).landscape:
            case (0, $2rYkD.DeviceType).widgetLandscape:
                if (configuration.subtitlesPosition?.landscape) {
                    const start = configuration.subtitlesPosition.landscape.containerRowStart || 9;
                    const end = configuration.subtitlesPosition.landscape.containerRowEnd || 13;
                    setGridRowStart(start);
                    setGridRowSpan(end - start);
                } else {
                    setGridRowStart(9);
                    setGridRowSpan(4);
                }
                break;
            case (0, $2rYkD.DeviceType).borne:
            case (0, $2rYkD.DeviceType).widgetBorne:
                if (configuration.subtitlesPosition?.borne) {
                    const start = configuration.subtitlesPosition.borne.containerRowStart || 11;
                    const end = configuration.subtitlesPosition.borne.containerRowEnd || 13;
                    setGridRowStart(start);
                    setGridRowSpan(end - start);
                } else if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne) {
                    if (configuration.answerpanel.borne.containerRowEnd && configuration.answerpanel.borne.containerRowEnd < 12) {
                        setGridRowStart(configuration.answerpanel.borne.containerRowEnd + 1);
                        setGridRowSpan(1);
                    } else {
                        setGridRowStart(11);
                        setGridRowSpan(2);
                    }
                } else {
                    setGridRowStart(11);
                    setGridRowSpan(2);
                }
                break;
        }
    }, [
        configuration.answerpanel,
        configuration.subtitlesPosition,
        currentDeviceType
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (elapsedTime) {
            for(let i = sentences.length - 1; i >= 0; i--)if (sentences[i].startTime < elapsedTime) {
                setSentenceToDisplay(sentences[i].sentence);
                break;
            }
        }
    }, [
        elapsedTime
    ]);
    (0, $bxRTa.useEffect)(()=>{
        keepLastSentenceRef.current && clearTimeout(keepLastSentenceRef.current);
        if (!isSpeaking && sentenceToDisplay && keepLastSentenceRef) keepLastSentenceRef.current = setTimeout(()=>{
            setSentenceToDisplay('');
        }, 1500);
        return ()=>{
            keepLastSentenceRef.current && clearTimeout(keepLastSentenceRef.current);
        };
    }, [
        isSpeaking
    ]);
    return mode === (0, $2rYkD.Mode).vocal && sentenceToDisplay && displaySubtitles ? /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        id: "retorik-framework-subtitles-container",
        className: "rf-relative rf-z-util rf-col-start-1 vertical:rf-col-span-full rf-col-span-4 rf-justify-self-center rf-self-center large-vertical:rf-self-start rf-overflow-y-auto rf-scrollbar-thin rf-w-1/2 vertical:rf-w-5/6 large-vertical:rf-w-3/5 rf-max-h-full rf-py-1 large:rf-py-4",
        style: {
            gridRow: `${gridRowStart} / span ${gridRowSpan}`
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            id: "retorik-framework-subtitles",
            className: "rf-relative rf-max-h-full rf-bg-vocalModeSubtitlesBackground rf-text-vocalModeSubtitlesText rf-justify-self-center rf-self-center rf-p-2 large:rf-p-4 rf-text-size-auto rf-text-center",
            children: sentenceToDisplay
        })
    }) : null;
};
var $1fdb6bf67360bb2c$export$2e2bcd8739ae039 = $1fdb6bf67360bb2c$var$Subtitle;



const $0f3dc49c00f92a8a$var$ThreeJsWrapper = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("eWorU")));

const $0f3dc49c00f92a8a$var$SpiritEngineWrapper = /*#__PURE__*/ (0, $bxRTa.lazy)(()=>(parcelRequire("hhGYP")));
const $0f3dc49c00f92a8a$var$intervalInMilliseconds = 100;
const $0f3dc49c00f92a8a$var$ChatbotAndSubtitlesContainer = ({ centered: centered, chatbotData: chatbotData, showSubtitles: showSubtitles, isNewsView: isNewsView, visible: visible })=>{
    const agentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const speaking = (0, $giKuE.useSpeechStore)((state)=>state.speaking);
    const boundaryData = (0, $giKuE.useSpeechStore)((state)=>state.boundaryData);
    const setClickedOnUI = (0, $4xGiN.useUtilsStore)((state)=>state.actions.setClickedOnUI);
    const [speechIntervals, setSpeechIntervals] = (0, $bxRTa.useState)([]);
    const [isSpeaking, setIsSpeaking] = (0, $bxRTa.useState)(false);
    const [elapsedTime, setElapsedTime] = (0, $bxRTa.useState)(0);
    const timerRef = (0, $bxRTa.useRef)(null);
    const [gridRowStart, setGridRowStart] = (0, $bxRTa.useState)();
    const [gridRowSpan, setGridRowSpan] = (0, $bxRTa.useState)();
    (0, $bxRTa.useEffect)(()=>{
        if (chatbotData?.containerRowStart && chatbotData.containerRowStart > 0 && chatbotData.containerRowStart < 13) {
            if (chatbotData.containerRowEnd && chatbotData.containerRowEnd < 13) {
                if (chatbotData.containerRowStart < chatbotData.containerRowEnd) {
                    setGridRowStart(chatbotData.containerRowStart);
                    setGridRowSpan(chatbotData.containerRowEnd - chatbotData.containerRowStart);
                }
            } else {
                setGridRowStart(chatbotData.containerRowStart);
                setGridRowSpan(13 - chatbotData.containerRowStart);
            }
        } else if (chatbotData?.containerRowEnd && chatbotData.containerRowEnd > 0 && chatbotData.containerRowEnd < 13) {
            setGridRowStart(1);
            setGridRowSpan(chatbotData.containerRowEnd - 1);
        } else {
            setGridRowStart(1);
            setGridRowSpan(12);
        }
    }, [
        chatbotData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (isNewsView) setIsSpeaking(speaking);
        else if (speaking && timerRef) {
            timerRef.current && clearInterval(timerRef.current);
            const now = Date.now();
            timerRef.current = setInterval(()=>{
                setElapsedTime(Date.now() - now);
            }, $0f3dc49c00f92a8a$var$intervalInMilliseconds);
        } else {
            timerRef?.current && clearInterval(timerRef.current);
            setElapsedTime(0);
        }
        return ()=>{
            timerRef?.current && clearInterval(timerRef.current);
        };
    }, [
        speaking
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (boundaryData.length > 0) {
            const tempArray = [];
            // While animations can't keep up, let's just synchronize the beginning and the end of speech
            const firstWord = boundaryData.find((boundary)=>boundary.boundaryType === 'WordBoundary');
            const lastWord = boundaryData.slice().reverse().find((boundary)=>boundary.boundaryType === 'WordBoundary');
            if (firstWord && lastWord) {
                tempArray.push(firstWord.startTime / 10000);
                tempArray.push(lastWord.endTime / 10000);
            }
            setSpeechIntervals(tempArray);
        } else setSpeechIntervals([]);
    }, [
        boundaryData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (elapsedTime && speechIntervals.length > 0) {
            let inside = false;
            for(let i = 0; i < speechIntervals.length; i++)if (speechIntervals[i] > elapsedTime) {
                inside = true;
                setIsSpeaking(!(i % 2 === 0));
                break;
            }
            !inside && setIsSpeaking(false);
        } else setIsSpeaking(false);
    }, [
        elapsedTime
    ]);
    const handleClick = (e)=>{
        setClickedOnUI((0, $2rYkD.UIPart).agent);
        e.stopPropagation();
        e.preventDefault();
    };
    return agentData ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                id: "retorik-animation-container",
                className: `rf-relative rf-z-agent rf-col-start-1 rf-col-end-9 ${!centered && 'landscape-retorik:-rf-translate-x-1/4'} rf-row-span-full rf-self-end rf-h-full`,
                style: {
                    visibility: visible ? 'visible' : 'hidden',
                    gridRow: `${gridRowStart} / span ${gridRowSpan}`
                },
                onClick: (e)=>handleClick(e),
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bxRTa.Suspense), {
                    children: agentData.useBodyEngineThree ? /*#__PURE__*/ (0, $fl9nK.jsx)($0f3dc49c00f92a8a$var$ThreeJsWrapper, {
                        agentData: agentData,
                        visible: visible,
                        height: chatbotData?.height,
                        size: chatbotData?.size,
                        cameraPreset: chatbotData?.cameraPreset
                    }) : /*#__PURE__*/ (0, $fl9nK.jsx)($0f3dc49c00f92a8a$var$SpiritEngineWrapper, {
                        agentData: agentData,
                        height: chatbotData?.height,
                        size: chatbotData?.size,
                        isSpeaking: isSpeaking
                    })
                })
            }),
            showSubtitles && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $1fdb6bf67360bb2c$export$2e2bcd8739ae039), {
                isSpeaking: isSpeaking,
                elapsedTime: elapsedTime
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $0f3dc49c00f92a8a$export$2e2bcd8739ae039 = $0f3dc49c00f92a8a$var$ChatbotAndSubtitlesContainer;


// Configure react-pdf worker
(0, $fP0xm.default).GlobalWorkerOptions.workerSrc = $1654af9fd29b2334$exports;
// Overload adaptive card rendering classes
(0, $9ef4e35797212449$export$6108075486421829)();
const $9d5ff8c24d218fb6$var$RetorikContainer = ({ config: config, viewsConfig: viewsConfig, chatbotData: chatbotData, chatbotDataWidget: chatbotDataWidget, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, addressData: addressData, userData: userData, skipLoader: skipLoader, defaultMode: defaultMode, customVoice: customVoice, externalEventHandler: externalEventHandler, externalComponents: externalComponents, width: width, height: height, colors: colors, parent: parent })=>{
    const currentLayout = (0, $7SHCs.useRetorikStore)((state)=>state.currentLayout);
    const mode = (0, $giKuE.useSpeechStore)((state)=>state.mode);
    const processedAgentData = (0, $7SHCs.useRetorikStore)((state)=>state.agentData);
    const displayAgentInNews = (0, $7SHCs.useRetorikStore)((state)=>state.displayAgentInNews);
    const displayAgent = (0, $4xGiN.useUtilsStore)((state)=>state.displayAgent);
    const route = (0, $9JLpC.useViewStore)((state)=>state.route);
    const isMobile = (0, $9JLpC.useViewStore)((state)=>state.isMobile);
    const visibility = (0, $9JLpC.useViewStore)((state)=>state.visibility);
    const setThemeColors = (0, $9JLpC.useViewStore)((state)=>state.actions.setThemeColors);
    const isNews = (0, $bxRTa.useMemo)(()=>{
        return parent === (0, $2rYkD.ContainerParent).news || route === (0, $2rYkD.Routes).News;
    }, [
        parent,
        route
    ]);
    const isAgentVisible = (0, $bxRTa.useMemo)(()=>{
        return displayAgent && !(isNews && !displayAgentInNews) && !(isMobile && mode === (0, $2rYkD.Mode).text) && visibility === 'visible';
    }, [
        mode,
        isMobile,
        displayAgent,
        displayAgentInNews,
        isNews,
        visibility
    ]);
    (0, $bxRTa.useEffect)(()=>{
        setThemeColors((0, $8h6ET.default)(colors));
    }, []);
    return config && viewsConfig && chatbotData && chatbotDataWidget && agentData && ponyfillFactoryCredentials ? /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $b4e3e24c87e40d50$export$2e2bcd8739ae039), {
        skipLoader: skipLoader,
        mode: defaultMode || (0, $2rYkD.Mode).vocal,
        viewsConfiguration: viewsConfig,
        configuration: config,
        addressData: addressData,
        agentSource: agentData,
        ponyfillFactoryCredentials: ponyfillFactoryCredentials,
        customVoice: customVoice,
        children: [
            !config.forceMobileView && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $aebbface17e3c004$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fl9nK.jsx)((0, $6a60c4ac572a9b7a$export$2e2bcd8739ae039), {
                addressData: addressData,
                userData: userData,
                externalEventHandler: externalEventHandler,
                isRetorikNews: parent === (0, $2rYkD.ContainerParent).news,
                children: /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $88f116d8e86f389c$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $93362ea804fbed50$export$2e2bcd8739ae039), {
                            isRetorikNews: parent === (0, $2rYkD.ContainerParent).news
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $7b98e1e71501801c$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $44d007e76c69eba2$export$2e2bcd8739ae039), {
                            fullSize: parent !== (0, $2rYkD.ContainerParent).widget && config.fullSize !== false,
                            width: width,
                            height: height,
                            parent: parent,
                            children: [
                                processedAgentData && /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0f3dc49c00f92a8a$export$2e2bcd8739ae039), {
                                    centered: chatbotData.fullWidthInDesktopMode && !isNews,
                                    chatbotData: currentLayout === (0, $2rYkD.ContainerParent).agent ? chatbotData : chatbotDataWidget,
                                    showSubtitles: !isNews,
                                    visible: isAgentVisible
                                }),
                                parent === (0, $2rYkD.ContainerParent).news ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $0dabfd02933d4a59$export$2e2bcd8739ae039), {
                                    hideMenu: true,
                                    isRetorikNews: true
                                }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $8d8907b91df6feae$export$2e2bcd8739ae039), {
                                    externalComponents: externalComponents
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3a939308a60f9856$export$2e2bcd8739ae039), {
                            isRetorikNews: parent === (0, $2rYkD.ContainerParent).news
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {});
};
var $9d5ff8c24d218fb6$export$2e2bcd8739ae039 = $9d5ff8c24d218fb6$var$RetorikContainer;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");

var $clSD3 = parcelRequire("clSD3");

var $iEJNQ = parcelRequire("iEJNQ");

var $2rYkD = parcelRequire("2rYkD");
const $a52955ed53ed59b6$var$Loader = ({ className: className, parent: parent, width: width, height: height, fullSize: fullSize })=>{
    const animationColor = {
        '--rf-color-loader-animation': '#00D7FF'
    };
    let widthStyle = {};
    let heightStyle = {};
    if (parent === (0, $2rYkD.ContainerParent).widget) {
        widthStyle = {
            width: '100%'
        };
        heightStyle = {
            height: height
        };
    }
    if (width === 'full') widthStyle = {
        width: '100%'
    };
    else if (typeof width === 'number') widthStyle = {
        width: `${width}px`
    };
    else if (typeof width === 'string') widthStyle = {
        width: width
    };
    if (height === 'full') heightStyle = {
        height: '100%',
        flexGrow: 1
    };
    else if (typeof height === 'number') heightStyle = {
        height: `${height}px`
    };
    else if (typeof height === 'string') heightStyle = {
        height: height
    };
    if (0, $clSD3.isMobile) heightStyle = {
        height: window.innerHeight,
        minHeight: window.innerHeight,
        maxHeight: window.innerHeight
    };
    return /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
        className: `${fullSize ? 'rf-w-screen rf-h-screen' : 'rf-w-full rf-h-full'} rf-max-w-screen rf-max-h-screen rf-bg-white ${className}`,
        style: {
            ...widthStyle,
            ...heightStyle
        },
        children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
            className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center",
            style: {
                background: 'rgba(18,18,18,0.7)',
                ...animationColor
            },
            children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                    className: "rf-w-6 rf-h-6 rf-mb-16",
                    children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $iEJNQ.default), {})
                })
            })
        })
    });
};
var $a52955ed53ed59b6$export$2e2bcd8739ae039 = $a52955ed53ed59b6$var$Loader;



var $kdMEA = parcelRequire("kdMEA");
const $a48ceaed86644192$var$processBaseURI = (baseURI)=>{
    if (baseURI?.length) {
        if (baseURI.indexOf(`${(0, $kdMEA.webchatTokenRetrievalAddress)}`) > -1) {
            console.warn('Retorik Framework > "/K2.ContentFields.WebChat/api/GetWebchatToken" endpoint for directline token retrieval is deprecated and will be removed in the next versions of Retorik Studio');
            baseURI = baseURI.replace(`${(0, $kdMEA.webchatTokenRetrievalAddress)}`, '');
        }
    }
    return baseURI;
};
var $a48ceaed86644192$export$2e2bcd8739ae039 = $a48ceaed86644192$var$processBaseURI;



var $kdMEA = parcelRequire("kdMEA");
const $2bd72e8e785aeb0f$var$processPrefix = (prefix)=>{
    switch(prefix){
        case 'dev':
            return 0, $kdMEA.studioRetorikDev;
        case 'staging':
        case 'preview':
            return 0, $kdMEA.studioRetorikStaging;
        case 'experimental':
            return 0, $kdMEA.studioRetorikExperimental;
        default:
            return 0, $kdMEA.studioRetorik;
    }
};
var $2bd72e8e785aeb0f$export$2e2bcd8739ae039 = $2bd72e8e785aeb0f$var$processPrefix;


/**
 * Get the base address from the incoming data.
 * The cases are :
 * - addressData.baseURI only : return this baseURI after removing the deprecated data
 * - addressData.baseURI + addressData.tenant : return the concatenation of this 2 values separated by '/'
 * - addressData.tenant only (with or without addressData.prefix) : process the prefix and return the processed data with the tenant
 * @param {AddressData} addressData
 * @returns {string}
 */ const $39912af9dc3f41d7$var$getBaseAddress = (addressData)=>{
    if (addressData.baseURI?.length) {
        if (addressData.tenant?.length) return `${addressData.baseURI}/${addressData.tenant}/`;
        else return (0, $a48ceaed86644192$export$2e2bcd8739ae039)(addressData.baseURI);
    } else {
        const tempBaseUri = (0, $2bd72e8e785aeb0f$export$2e2bcd8739ae039)(addressData.prefix);
        return `${tempBaseUri}/${addressData.tenant}/`;
    }
};
var $39912af9dc3f41d7$export$2e2bcd8739ae039 = $39912af9dc3f41d7$var$getBaseAddress;



var $D3wt5 = parcelRequire("D3wt5");
const $522017217b57aa4c$var$RetorikConfigHandler = ({ config: config, viewsConfig: viewsConfig, chatbotData: chatbotData, chatbotDataWidget: chatbotDataWidget, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, customVoice: customVoice, colors: colors, skipLoader: skipLoader, defaultMode: defaultMode, GDPR: GDPR, customScripts: customScripts, customCSS: customCSS, addressData: addressData, externalEventHandler: externalEventHandler, externalComponents: externalComponents, userData: userData, width: width, height: height, menuConfig: menuConfig, environmentPreset: environmentPreset, parent: parent })=>{
    const { fetchSupportedLanguages: fetchSupportedLanguages, setLanguageData: setLanguageData } = (0, $2eBYD.useLocaleStore)((state)=>state.actions);
    const setTheme = (0, $9JLpC.useViewStore)((state)=>state.actions.setTheme);
    const baseAddress = (0, $7SHCs.useRetorikStore)((state)=>state.baseAddress);
    const [fetchedConfig, setFetchedConfig] = (0, $bxRTa.useState)();
    const [mainConfig, setMainConfig] = (0, $bxRTa.useState)(undefined);
    const { setGDPRDisplay: setGDPRDisplay, setGDPRUserConsent: setGDPRUserConsent, setGDPRWindowData: setGDPRWindowData } = (0, $4xGiN.useUtilsStore)((state)=>state.actions);
    const { setBaseAddress: setBaseAddress, setDisableHistory: setDisableHistory, setEnvironmentPreset: setEnvironmentPreset, setCustomScripts: setCustomScripts, setCustomCSS: setCustomCSS, setEnabledFeatures: setEnabledFeatures } = (0, $7SHCs.useRetorikStore)((state)=>state.actions);
    const [isConfigUpdated, setIsConfigUpdated] = (0, $bxRTa.useState)(false);
    const fetchConfigurationFromRetorikStudio = async (baseAddress)=>{
        const fetchedConfig = await (0, $af55b6b5b4f24adb$export$2e2bcd8739ae039)({
            config: config,
            viewsConfig: viewsConfig,
            chatbotData: chatbotData,
            chatbotDataWidget: chatbotDataWidget,
            agentData: agentData,
            ponyfillFactoryCredentials: ponyfillFactoryCredentials,
            customVoice: customVoice,
            colors: colors,
            skipLoader: skipLoader,
            defaultMode: defaultMode,
            GDPR: GDPR,
            addressData: addressData,
            externalEventHandler: externalEventHandler,
            externalComponents: externalComponents,
            userData: userData,
            width: width,
            height: height,
            menuConfig: menuConfig
        }, baseAddress);
        console.log('Retorik Framework > configuration fetched from Retorik Studio');
        fetchedConfig && setFetchedConfig(fetchedConfig);
    };
    const checkGDPR = async (baseAddress)=>{
        const data = await (0, $6b7b10b90b820580$export$284b58786299e6c5)({
            configurationData: GDPR,
            baseAddress: baseAddress
        });
        // Set GDPR data in UtilsContext
        data.data && setGDPRWindowData(data.data);
        setGDPRDisplay(data.displayGDPR);
        typeof data.userConsent === 'boolean' && setGDPRUserConsent(data.userConsent);
    };
    /**
   * Process addressData to get the baseAddress and then :
   * - fetch configuration and save it
   * - get GDPR data and store them
   * - fetch available languages and store them
   * - set baseAddress in store
   */ (0, $bxRTa.useEffect)(()=>{
        if (addressData && (addressData.baseURI || addressData.tenant)) {
            const baseAddress = (0, $39912af9dc3f41d7$export$2e2bcd8739ae039)(addressData);
            fetchConfigurationFromRetorikStudio(baseAddress);
            checkGDPR(baseAddress);
            setBaseAddress(baseAddress);
        }
    }, [
        addressData
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (environmentPreset) setEnvironmentPreset(environmentPreset);
    }, [
        environmentPreset
    ]);
    (0, $bxRTa.useEffect)(()=>{
        if (fetchedConfig) {
            const { skipLoader: _skipLoader, defaultMode: _defaultMode, config: _config, viewsConfig: _viewsConfig, chatbotData: _chatbotData, chatbotDataWidget: _chatbotDataWidget, agentData: _agentData, addressData: _addressData, ponyfillFactoryCredentials: _ponyfillFactoryCredentials, customVoice: _customVoice, colors: _colors, defaultCulture: defaultCulture, supportedCultures: supportedCultures, disableHistory: disableHistory, customScripts: _customScripts, customCSS: _customCSS, features: features } = fetchedConfig;
            // Language
            if (defaultCulture && supportedCultures) {
                const { processedDefaultLanguage: processedDefaultLanguage, processedSupported: processedSupported } = (0, $D3wt5.processLanguageData)(defaultCulture, supportedCultures, true);
                processedDefaultLanguage && processedSupported && setLanguageData(processedDefaultLanguage, processedSupported);
            } else fetchSupportedLanguages(baseAddress);
            // Colors
            if (colors?.theme || _colors?.theme) {
                const tempTheme = colors?.theme || _colors?.theme;
                if (tempTheme === (0, $2rYkD.Theme).auto && window.matchMedia) {
                    // Use window.matchMedia to detect navigator's theme and set final theme instead of "auto"
                    const theme = window.matchMedia('(prefers-color-scheme:light)')?.matches ? (0, $2rYkD.Theme).light : (0, $2rYkD.Theme).dark;
                    setTheme(theme);
                    colors && (colors.theme = theme);
                    _colors && (_colors.theme = theme);
                } else setTheme(tempTheme === (0, $2rYkD.Theme).light ? (0, $2rYkD.Theme).light : (0, $2rYkD.Theme).dark);
            } else if (window.matchMedia) {
                const tempTheme = window.matchMedia('(prefers-color-scheme:light)')?.matches ? (0, $2rYkD.Theme).light : (0, $2rYkD.Theme).dark;
                setTheme(tempTheme);
                _colors && (_colors.theme = tempTheme);
            }
            const mergedMainConfig = {
                config: config !== undefined ? (0, $8h6ET.deepMerge)(config, _config) : _config,
                viewsConfig: viewsConfig !== undefined ? (0, $8h6ET.deepMerge)(viewsConfig, _viewsConfig) : _viewsConfig,
                chatbotData: chatbotData !== undefined ? {
                    ..._chatbotData,
                    ...chatbotData
                } : _chatbotData,
                chatbotDataWidget: chatbotDataWidget !== undefined ? {
                    ..._chatbotDataWidget,
                    ...chatbotDataWidget
                } : _chatbotDataWidget,
                agentData: agentData !== undefined ? typeof agentData === 'string' ? agentData : (0, $8h6ET.deepMerge)(agentData, _agentData) : _agentData,
                ponyfillFactoryCredentials: ponyfillFactoryCredentials !== undefined ? ponyfillFactoryCredentials : _ponyfillFactoryCredentials,
                customVoice: customVoice !== undefined ? {
                    ..._customVoice,
                    ...customVoice
                } : _customVoice,
                colors: colors !== undefined ? (0, $8h6ET.deepMerge)(colors, (0, $8h6ET.default)(_colors)) : (0, $8h6ET.default)(_colors),
                skipLoader: skipLoader !== undefined ? skipLoader : _skipLoader,
                defaultMode: defaultMode !== undefined ? defaultMode : _defaultMode,
                // Data not retrieved from Retorik Studio
                addressData: _addressData,
                userData: userData,
                externalEventHandler: externalEventHandler,
                externalComponents: externalComponents,
                width: width,
                height: height
            };
            // Prevent menus from being copied again after each modification of configuration
            if (mergedMainConfig.config) {
                mergedMainConfig.config.baseMenu = config?.baseMenu || menuConfig?.baseMenu;
                mergedMainConfig.config.customMenu = config?.customMenu || menuConfig?.customMenu;
                mergedMainConfig.config.subMenu = config?.subMenu || menuConfig?.subMenu;
                mergedMainConfig.config.menu = config?.menu || menuConfig?.menu || _config?.menu;
            }
            setDisableHistory(!!disableHistory);
            setCustomScripts(customScripts || _customScripts || []);
            setCustomCSS(customCSS || _customCSS || []);
            setEnabledFeatures(features || []);
            // Save this config and use it in the application
            setMainConfig(mergedMainConfig);
            setIsConfigUpdated(true);
        }
    }, [
        config,
        viewsConfig,
        chatbotData,
        chatbotDataWidget,
        agentData,
        ponyfillFactoryCredentials,
        customVoice,
        colors,
        skipLoader,
        defaultMode,
        GDPR,
        customScripts,
        addressData,
        externalEventHandler,
        externalComponents,
        userData,
        width,
        height,
        menuConfig,
        fetchedConfig
    ]);
    return mainConfig ? /*#__PURE__*/ (0, $fl9nK.jsx)((0, $9d5ff8c24d218fb6$export$2e2bcd8739ae039), {
        parent: parent,
        ...mainConfig
    }) : /*#__PURE__*/ (0, $fl9nK.jsx)((0, $a52955ed53ed59b6$export$2e2bcd8739ae039), {
        className: isConfigUpdated ? 'rf-animate-loaderFadeOut' : '',
        parent: parent,
        width: width,
        height: height,
        fullSize: !!(parent !== (0, $2rYkD.ContainerParent).widget && config?.fullSize !== false)
    });
};
var $522017217b57aa4c$export$2e2bcd8739ae039 = $522017217b57aa4c$var$RetorikConfigHandler;


const $da2880bb97fd9e98$var$RetorikAgent = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikAgent
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer
    // -------------------------
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bd43c48bdb8caf5f$export$2e2bcd8739ae039), {
        instanceId: props.instanceId,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3b22c72029a66628$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $522017217b57aa4c$export$2e2bcd8739ae039), {
                parent: (0, $2rYkD.ContainerParent).agent,
                ...props
            })
        })
    });
};
var $da2880bb97fd9e98$export$2e2bcd8739ae039 = $da2880bb97fd9e98$var$RetorikAgent;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


var $9P0Ec = parcelRequire("9P0Ec");


var $fl9nK = parcelRequire("fl9nK");

var $bxRTa = parcelRequire("bxRTa");

var $2rYkD = parcelRequire("2rYkD");

var $2eBYD = parcelRequire("2eBYD");

var $7SHCs = parcelRequire("7SHCs");

var $9qyYE = parcelRequire("9qyYE");
// Get style for widget's border (except colors)
const $fa75495d058a0be6$export$d6ad062ea094ff6f = (borderData)=>{
    if (!borderData || !borderData.color && borderData.thickness === undefined && borderData.rounded === undefined) return 'rf-border rf-rounded rf-border-gray';
    const borderThickness = borderData.thickness !== undefined && borderData.thickness !== 1 ? `rf-border-${borderData.thickness}` : 'rf-border';
    const borderRounded = borderData.rounded === false ? '' : 'rf-rounded-lg';
    return `${borderThickness} ${borderRounded}`;
};
// Get style for widget's button (except colors)
const $fa75495d058a0be6$export$5bc78eab59412c50 = (buttonData)=>{
    if (!buttonData || !buttonData.text && !buttonData.image && !buttonData.border && !buttonData.background && !buttonData.position) return 'rf-rounded-lg rf-font-bold';
    // Button border
    const borderStyle = buttonData.border?.rounded === false ? '' : 'rf-rounded-lg';
    // Button text
    const textStyle = buttonData.text?.bold && buttonData.text.bold === false ? '' : 'rf-font-bold';
    return `${borderStyle} ${textStyle}`;
};



var $7j7nS = parcelRequire("7j7nS");

var $04Syy = parcelRequire("04Syy");

const $5bf33bed4d01de5f$var$LayoutHandler = (props)=>{
    const translation = (0, $2eBYD.useLocaleStore)((state)=>state.currentTranslations);
    const currentLayout = (0, $7SHCs.useRetorikStore)((state)=>state.currentLayout);
    const displayChangeLayoutButton = (0, $7SHCs.useRetorikStore)((state)=>state.configuration).allowSwitchLayout;
    const open = (0, $9qyYE.useWidgetStore)((state)=>state.open);
    const loaded = (0, $9qyYE.useWidgetStore)((state)=>state.loaded);
    const widgetDisplayType = (0, $9qyYE.useWidgetStore)((state)=>state.widgetDisplayType);
    const { toggleDisplay: toggleDisplay, toggleWidget: toggleWidget } = (0, $9qyYE.useWidgetStore)((state)=>state.actions);
    const setLayout = (0, $7SHCs.useRetorikStore)((state)=>state.actions.setLayout);
    const [currentConfiguration, setCurrentConfiguration] = (0, $bxRTa.useState)(props.widgetConfig?.large);
    const [widgetButton, setWidgetButton] = (0, $bxRTa.useState)('');
    const [widgetBorder, setWidgetBorder] = (0, $bxRTa.useState)('');
    const [mobileWidth, setMobileWidth] = (0, $bxRTa.useState)(window.innerWidth < 600);
    const [frameStyle, setFrameStyle] = (0, $bxRTa.useState)({});
    const handleResize = ()=>{
        setMobileWidth(window.innerWidth < 600);
    };
    (0, $bxRTa.useEffect)(()=>{
        setWidgetButton((0, $fa75495d058a0be6$export$5bc78eab59412c50)(props.widgetConfig?.button));
        window.addEventListener('resize', handleResize);
        setLayout((0, $2rYkD.ContainerParent).widget);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    (0, $bxRTa.useEffect)(()=>{
        mobileWidth ? setFrameStyle({
            width: open ? '100%' : '0px',
            height: '100%'
        }) : setFrameStyle({
            top: currentConfiguration?.position?.top,
            bottom: currentConfiguration?.position?.bottom ? currentConfiguration?.position?.bottom : currentConfiguration?.position?.top || currentConfiguration?.position?.left || currentConfiguration?.position?.right ? undefined : '1rem',
            left: currentConfiguration?.position?.left,
            right: currentConfiguration?.position?.right ? currentConfiguration?.position?.right : currentConfiguration?.position?.top || currentConfiguration?.position?.bottom || currentConfiguration?.position?.left ? undefined : '1rem',
            borderColor: currentConfiguration?.border?.color || (0, $7j7nS.widgetDefault).rgb
        });
    }, [
        mobileWidth,
        currentConfiguration
    ]);
    (0, $bxRTa.useEffect)(()=>{
        switch(widgetDisplayType){
            case 'large':
                setCurrentConfiguration(props.widgetConfig?.large);
                setWidgetBorder((0, $fa75495d058a0be6$export$d6ad062ea094ff6f)(props.widgetConfig?.large?.border));
                break;
            case 'thumbnail':
                setCurrentConfiguration(props.widgetConfig?.thumbnail || props.widgetConfig?.large);
                setWidgetBorder((0, $fa75495d058a0be6$export$d6ad062ea094ff6f)(props.widgetConfig?.thumbnail?.border || props.widgetConfig?.large?.border));
                break;
            default:
                break;
        }
    }, [
        widgetDisplayType
    ]);
    const extendButtonHandler = ()=>{
        // if different display type available
        if (props.widgetConfig?.large && props.widgetConfig?.thumbnail) toggleDisplay();
        else setLayout((0, $2rYkD.ContainerParent).agent);
    };
    return /*#__PURE__*/ (0, $fl9nK.jsxs)((0, $fl9nK.Fragment), {
        children: [
            props.widgetConfig?.button?.display !== false && /*#__PURE__*/ (0, $fl9nK.jsxs)("button", {
                className: `rf-fixed rf-px-2 rf-flex rf-flex-row rf-items-center ${widgetButton}`,
                style: {
                    color: props.widgetConfig?.button?.text?.color || (0, $7j7nS.widgetDefault).rgb,
                    backgroundColor: props.widgetConfig?.button?.background?.color || 'transparent',
                    borderWidth: props.widgetConfig?.button?.border?.thickness !== undefined ? `${props.widgetConfig?.button?.border?.thickness}px` : '1px',
                    borderColor: props.widgetConfig?.button?.border?.color || (0, $7j7nS.widgetDefault).rgb,
                    top: props.widgetConfig?.button?.position?.top,
                    bottom: props.widgetConfig?.button?.position?.bottom ? props.widgetConfig?.button?.position?.bottom : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.left || props.widgetConfig?.button?.position?.right ? undefined : '1rem',
                    left: props.widgetConfig?.button?.position?.left,
                    right: props.widgetConfig?.button?.position?.right ? props.widgetConfig?.button?.position?.right : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.bottom || props.widgetConfig?.button?.position?.left ? undefined : '1rem'
                },
                onClick: toggleWidget,
                id: "retorik-widget-button",
                children: [
                    props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position !== 'right' && /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? '' : 'rf-my-1'}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || '2rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: "rf-py-2 rf-mx-2 rf-leading-4 rf-text-justify rf-whitespace-break-spaces",
                        style: {
                            overflowWrap: 'break-word',
                            maxWidth: props.widgetConfig?.button?.text?.maxWidth || 200
                        },
                        children: props.widgetConfig?.button?.text?.content || translation.common.needhelp
                    }),
                    props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position === 'right' && /*#__PURE__*/ (0, $fl9nK.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? '' : 'rf-my-1'}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || '2rem'
                        }
                    })
                ]
            }),
            loaded && /*#__PURE__*/ (0, $fl9nK.jsxs)("div", {
                className: `${currentLayout === (0, $2rYkD.ContainerParent).widget ? 'rf-fixed rf-pt-8 rf-height-fill-available rf-transition-all rf-overflow-hidden rf-max-w-[100vw]' : ''}`,
                style: currentLayout === (0, $2rYkD.ContainerParent).widget ? {
                    ...frameStyle,
                    width: open ? mobileWidth ? '100%' : currentConfiguration?.width || '400px' : '0px',
                    height: currentConfiguration?.height || (mobileWidth ? '100%' : '630px')
                } : {},
                "data-testid": "widget-wrapper",
                children: [
                    currentLayout === (0, $2rYkD.ContainerParent).widget && /*#__PURE__*/ (0, $fl9nK.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bxRTa))).Fragment, {
                        children: [
                            !!displayChangeLayoutButton && !mobileWidth && /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                onClick: extendButtonHandler,
                                "aria-label": "Extend",
                                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-8 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $c8bd85879b11a2bb$export$2e2bcd8739ae039), {
                                    className: "rf-h-4 rf-w-4",
                                    color: "#000000",
                                    extended: false
                                })
                            }),
                            /*#__PURE__*/ (0, $fl9nK.jsx)("button", {
                                onClick: toggleWidget,
                                "aria-label": "Close",
                                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-0 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $04Syy.default), {
                                    className: "rf-h-4 rf-w-4",
                                    color: "#000000"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fl9nK.jsx)("div", {
                        className: `${currentLayout === (0, $2rYkD.ContainerParent).widget ? `rf-relative rf-h-full rf-w-full rf-overflow-hidden ${!mobileWidth && widgetBorder}` : ''}`,
                        style: currentLayout === (0, $2rYkD.ContainerParent).widget ? {
                            borderColor: frameStyle.borderColor
                        } : {},
                        children: props.children
                    })
                ]
            })
        ]
    });
};
var $5bf33bed4d01de5f$export$2e2bcd8739ae039 = $5bf33bed4d01de5f$var$LayoutHandler;



var $2rYkD = parcelRequire("2rYkD");

window.Retorik = {
    ...window.Retorik,
    openWidget: $9P0Ec.openWidget,
    closeWidget: $9P0Ec.closeWidget,
    toggleWidget: $9P0Ec.toggleWidget,
    toggleDisplay: $9P0Ec.toggleDisplay
};
const $0ea8bb6e9c64ca4d$var$RetorikWidget = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au widget
    // Ce qui est commun avec RetorikAgent ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bd43c48bdb8caf5f$export$2e2bcd8739ae039), {
        instanceId: props.instanceId,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3b22c72029a66628$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $5bf33bed4d01de5f$export$2e2bcd8739ae039), {
                ...props,
                children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $522017217b57aa4c$export$2e2bcd8739ae039), {
                    ...props,
                    width: 'full',
                    height: 'full',
                    parent: (0, $2rYkD.ContainerParent).widget
                })
            })
        })
    });
};
var $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039 = $0ea8bb6e9c64ca4d$var$RetorikWidget;



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");




var $2rYkD = parcelRequire("2rYkD");
const $d0db728c13b4bca0$var$RetorikNews = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikNews
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    return /*#__PURE__*/ (0, $fl9nK.jsx)((0, $bd43c48bdb8caf5f$export$2e2bcd8739ae039), {
        instanceId: props.instanceId,
        children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $3b22c72029a66628$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $fl9nK.jsx)((0, $522017217b57aa4c$export$2e2bcd8739ae039), {
                parent: (0, $2rYkD.ContainerParent).news,
                ...props
            })
        })
    });
};
var $d0db728c13b4bca0$export$2e2bcd8739ae039 = $d0db728c13b4bca0$var$RetorikNews;




function $704c313ba3eba409$export$2e2bcd8739ae039(RetorikAgent, props, element) {
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $fl9nK.jsx)(RetorikAgent, {
        ...props
    }));
}
// WebComponent creation
class $704c313ba3eba409$var$RetorikAgentWebComponent extends HTMLElement {
    constructor(){
        super();
    }
    // Mehod called when the element is connected to the DOM
    connectedCallback() {
        const tenant = this.getAttribute('tenant');
        const prefix = this.getAttribute('prefix');
        const props = JSON.parse(this.getAttribute('props') || '{}');
        if (tenant) {
            const addressData = {
                tenant: tenant,
                prefix: prefix
            };
            this._renderAgent({
                ...props,
                addressData: addressData
            });
        }
    }
    // React component rendering
    _renderAgent(props) {
        const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(this);
        root.render(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $da2880bb97fd9e98$export$2e2bcd8739ae039), {
            ...props
        }));
    }
}
// WebComponent registering in window
window.customElements.define('retorik-agent', $704c313ba3eba409$var$RetorikAgentWebComponent);



var $fl9nK = parcelRequire("fl9nK");
parcelRequire("bxRTa");


function $e8dbe447b062a0b6$export$2e2bcd8739ae039(RetorikWidget, props, element) {
    const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $fl9nK.jsx)(RetorikWidget, {
        ...props
    }));
}
// WebComponent creation
class $e8dbe447b062a0b6$var$RetorikWidgetWebComponent extends HTMLElement {
    constructor(){
        super();
    }
    // Mehod called when the element is connected to the DOM
    connectedCallback() {
        const tenant = this.getAttribute('tenant');
        const prefix = this.getAttribute('prefix');
        const props = JSON.parse(this.getAttribute('props') || '{}');
        if (tenant) {
            const addressData = {
                tenant: tenant,
                prefix: prefix
            };
            this._renderWidget({
                ...props,
                addressData: addressData
            });
        }
    }
    // React component rendering
    _renderWidget(props) {
        const root = (0, $84b6f0871d6ab47a$export$882461b6382ed46c)(this);
        root.render(/*#__PURE__*/ (0, $fl9nK.jsx)((0, $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039), {
            ...props
        }));
    }
}
// WebComponent registering in window
window.customElements.define('retorik-widget', $e8dbe447b062a0b6$var$RetorikWidgetWebComponent);




var $itb2K = parcelRequire("itb2K");

var $7okOs = parcelRequire("7okOs");

var $D3wt5 = parcelRequire("D3wt5");


var $8h6ET = parcelRequire("8h6ET");

var $9P0Ec = parcelRequire("9P0Ec");
parcelRequire("f4klx");
var $lbJSZ = parcelRequire("lbJSZ");
var $f6Xnj = parcelRequire("f6Xnj");
var $ftSpM = parcelRequire("ftSpM");
var $h0xwd = parcelRequire("h0xwd");
var $5OuKI = parcelRequire("5OuKI");
var $cGvNv = parcelRequire("cGvNv");
var $fvifn = parcelRequire("fvifn");
var $dXqZ1 = parcelRequire("dXqZ1");
var $680es = parcelRequire("680es");
var $3grkP = parcelRequire("3grkP");
var $1gjkL = parcelRequire("1gjkL");
var $hqQWd = parcelRequire("hqQWd");
var $gxeI6 = parcelRequire("gxeI6");
var $517WC = parcelRequire("517WC");

var $dHUeX = parcelRequire("dHUeX");

var $2rYkD = parcelRequire("2rYkD");
const $7f785502bdb7babd$export$7a001476a013672 = ()=>{
    (0, $9P0Ec.resetLocaleStore)();
    (0, $9P0Ec.resetUtilsStore)();
    (0, $9P0Ec.resetRetorikStore)();
    (0, $9P0Ec.resetSpeechStore)();
    (0, $9P0Ec.resetActivityStore)();
    (0, $9P0Ec.resetDirectlineStore)();
    (0, $9P0Ec.resetAdaptiveCardStore)();
};
const $7f785502bdb7babd$export$b69254d879536cde = (0, $704c313ba3eba409$export$2e2bcd8739ae039).bind(null, (0, $da2880bb97fd9e98$export$2e2bcd8739ae039));
const $7f785502bdb7babd$var$renderWidget = (0, $e8dbe447b062a0b6$export$2e2bcd8739ae039).bind(null, (0, $0ea8bb6e9c64ca4d$export$2e2bcd8739ae039));
var $7f785502bdb7babd$export$2e2bcd8739ae039 = (0, $da2880bb97fd9e98$export$2e2bcd8739ae039);
window.Retorik = {
    ...window.Retorik,
    renderAgent: $7f785502bdb7babd$export$b69254d879536cde,
    renderWidget: $7f785502bdb7babd$var$renderWidget,
    addDetailedAttachmentTrigger: $9P0Ec.addDetailedAttachmentTrigger,
    addExternalActivityHandler: $9P0Ec.addExternalActivityHandler,
    cancelCurrentUtterance: $9P0Ec.cancelCurrentUtterance,
    changeAgent: (0, $9P0Ec.setAgentData),
    displaySubtitles: (0, $9P0Ec.setDisplaySubtitles),
    hideAgent: $9P0Ec.hideAgent,
    pauseConversation: $9P0Ec.pauseConversation,
    playExternalSynthesis: $9P0Ec.playExternalSynthesis,
    resumeConversation: $9P0Ec.resumeConversation,
    sendActivity: $9P0Ec.sendActivity,
    sendEvent: $9P0Ec.sendEvent,
    sendMessage: $9P0Ec.sendMessage,
    sendMessageToChatbot: $9P0Ec.sendMessageToChatbot,
    setExternalActivityHandlers: $9P0Ec.setExternalActivityHandlers,
    setLocale: $9P0Ec.setLocale,
    setModalFullscreenContent: $9P0Ec.setModalFullscreenContent,
    setMuted: $9P0Ec.setMuted,
    setVisibility: $9P0Ec.setVisibility,
    showAgent: $9P0Ec.showAgent,
    toggleMicrophone: $9P0Ec.toggleMicrophone,
    toggleSubtitles: $9P0Ec.toggleSubtitles,
    toggleVisibility: $9P0Ec.toggleVisibility
};


//# sourceMappingURL=index.js.map
